
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9db"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9db"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
};
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.2.0";

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber);
    var context = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, type, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, type, value) {
    "number" === type && $dca0ddb82b882518$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_427) {
            var $dca0ddb82b882518$var$element$jscomp$inline_428 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_427 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_428.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = $dca0ddb82b882518$var$isSupported$jscomp$inline_427;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $dca0ddb82b882518$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && null !== $dca0ddb82b882518$var$currentEntangledListeners) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(fiber);
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && $dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$66);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 42) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$69 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$69, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError
};
$dca0ddb82b882518$var$ContextOnlyDispatcher.useEffectEvent = $dca0ddb82b882518$var$throwInvalidHookError;
var $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnUpdate.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
var $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh
};
$dca0ddb82b882518$var$HooksDispatcherOnRerender.useEffectEvent = $dca0ddb82b882518$var$updateEvent;
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress));
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            nextProps = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, workInProgress = $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps));
        else if ($dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), $dca0ddb82b882518$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $dca0ddb82b882518$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $dca0ddb82b882518$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
            $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            workInProgress = $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $dca0ddb82b882518$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(nextPrimaryChildren.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $dca0ddb82b882518$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $dca0ddb82b882518$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $dca0ddb82b882518$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, suspenseContext);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, props[$dca0ddb82b882518$var$internalPropsKey] = current, $dca0ddb82b882518$var$setInitialProperties(props, renderLanes, current), $dca0ddb82b882518$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, props.value), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $dca0ddb82b882518$var$now(), current.sibling = null, renderLanes = $dca0ddb82b882518$var$suspenseStackCursor.current, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor), null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1));
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    for($dca0ddb82b882518$var$nextEffect = firstChild; null !== $dca0ddb82b882518$var$nextEffect;)if (firstChild = $dca0ddb82b882518$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $dca0ddb82b882518$var$nextEffect = root;
    else for(; null !== $dca0ddb82b882518$var$nextEffect;){
        firstChild = $dca0ddb82b882518$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $dca0ddb82b882518$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $dca0ddb82b882518$var$nextEffect = root;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = firstChild.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevProps;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$dca0ddb82b882518$var$internalHoistableMarker] || currentResource[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                        $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $dca0ddb82b882518$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                $dca0ddb82b882518$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $dca0ddb82b882518$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$tagCaches = null;
            hoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = hoistableRoot;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $dca0ddb82b882518$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && null !== fiber.memoizedState && $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$commitRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        };
        $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0;
        timeoutOffset = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($dca0ddb82b882518$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $dca0ddb82b882518$var$entangledRenderLanes = lanes;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
        $dca0ddb82b882518$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
            $dca0ddb82b882518$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            transitions = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $dca0ddb82b882518$var$executionContext = spawnedLane, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = transitions, $dca0ddb82b882518$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 1;
        $dca0ddb82b882518$var$flushMutationEffects();
        $dca0ddb82b882518$var$flushLayoutEffects();
        $dca0ddb82b882518$var$flushSpawnedWork();
    }
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $dca0ddb82b882518$var$selectionInformation, curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            remainingLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : $dca0ddb82b882518$var$nestedUpdateCount = 0;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) && $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$170, root$170 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL("" + actionProp);
}
function $dca0ddb82b882518$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $dca0ddb82b882518$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1577 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1577 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1577++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1578 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1577], $dca0ddb82b882518$var$domEventName$jscomp$inline_1579 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580 = $dca0ddb82b882518$var$eventName$jscomp$inline_1578[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1578.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1579, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1580);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $dca0ddb82b882518$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $dca0ddb82b882518$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $dca0ddb82b882518$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
    }
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $dca0ddb82b882518$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        $dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(as, "link", href), $dca0ddb82b882518$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$243 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $dca0ddb82b882518$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, pendingProps), styles$243 || $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), pendingProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $dca0ddb82b882518$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$249)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $acw62.version;
if ("19.2.0" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.0"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.2.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2348.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2348.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2348.inject($dca0ddb82b882518$var$internals$jscomp$inline_2347), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.2.0";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});

parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.2.0";

});



parcelRegister("hOzOt", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $kZO5c = parcelRequire("kZO5c");
function $cf82e2ef667d5788$var$emptyFunction() {}
function $cf82e2ef667d5788$var$emptyFunctionWithReset() {}
$cf82e2ef667d5788$var$emptyFunctionWithReset.resetWarningCache = $cf82e2ef667d5788$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $kZO5c) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $cf82e2ef667d5788$var$emptyFunctionWithReset,
        resetWarningCache: $cf82e2ef667d5788$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("kZO5c", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $f4905a8b274aa381$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $f4905a8b274aa381$var$ReactPropTypesSecret;

});


parcelRegister("gijsP", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $bdcd6ced2cdccd72$export$a7c73072b1a182ae, (v) => $bdcd6ced2cdccd72$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $bdcd6ced2cdccd72$export$9f27bc3417b4524d, (v) => $bdcd6ced2cdccd72$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $bdcd6ced2cdccd72$export$db77ccec0bb4ccac, (v) => $bdcd6ced2cdccd72$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35, (v) => $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $bdcd6ced2cdccd72$export$ffb0004e005737fa, (v) => $bdcd6ced2cdccd72$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $bdcd6ced2cdccd72$export$b624eff549462981, (v) => $bdcd6ced2cdccd72$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $bdcd6ced2cdccd72$export$7897aa7841a5380c, (v) => $bdcd6ced2cdccd72$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $bdcd6ced2cdccd72$export$602eac185826482c, (v) => $bdcd6ced2cdccd72$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $bdcd6ced2cdccd72$export$e2c29f18771995cb, (v) => $bdcd6ced2cdccd72$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $bdcd6ced2cdccd72$export$5f8d39834fd61797, (v) => $bdcd6ced2cdccd72$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $bdcd6ced2cdccd72$export$74bf444e3cd11ea5, (v) => $bdcd6ced2cdccd72$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $bdcd6ced2cdccd72$export$998bcd577473dd93, (v) => $bdcd6ced2cdccd72$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isContextConsumer", () => $bdcd6ced2cdccd72$export$b706b080d889d2c9, (v) => $bdcd6ced2cdccd72$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $bdcd6ced2cdccd72$export$5be5a87408f70ddc, (v) => $bdcd6ced2cdccd72$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d, (v) => $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $bdcd6ced2cdccd72$export$455c2e768291efa6, (v) => $bdcd6ced2cdccd72$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $bdcd6ced2cdccd72$export$9522e17588c12572, (v) => $bdcd6ced2cdccd72$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $bdcd6ced2cdccd72$export$2110ac352bb060b9, (v) => $bdcd6ced2cdccd72$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $bdcd6ced2cdccd72$export$56885ab8b9c456ab, (v) => $bdcd6ced2cdccd72$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $bdcd6ced2cdccd72$export$d927fcb6adf8f9de, (v) => $bdcd6ced2cdccd72$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $bdcd6ced2cdccd72$export$b82d16f27459e05a, (v) => $bdcd6ced2cdccd72$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $bdcd6ced2cdccd72$export$522c17b4f5e123e8, (v) => $bdcd6ced2cdccd72$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6, (v) => $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $bdcd6ced2cdccd72$export$3d6c20d97e46b957, (v) => $bdcd6ced2cdccd72$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $bdcd6ced2cdccd72$export$9b621391a187a31a, (v) => $bdcd6ced2cdccd72$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $bdcd6ced2cdccd72$export$f5bbd400c2f4426f, (v) => $bdcd6ced2cdccd72$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bdcd6ced2cdccd72$export$a7c73072b1a182ae;
var $bdcd6ced2cdccd72$export$9f27bc3417b4524d;
var $bdcd6ced2cdccd72$export$db77ccec0bb4ccac;
var $bdcd6ced2cdccd72$export$8392c0c9d3dcbd35;
var $bdcd6ced2cdccd72$export$ffb0004e005737fa;
var $bdcd6ced2cdccd72$export$b624eff549462981;
var $bdcd6ced2cdccd72$export$7897aa7841a5380c;
var $bdcd6ced2cdccd72$export$602eac185826482c;
var $bdcd6ced2cdccd72$export$e2c29f18771995cb;
var $bdcd6ced2cdccd72$export$5f8d39834fd61797;
var $bdcd6ced2cdccd72$export$74bf444e3cd11ea5;
var $bdcd6ced2cdccd72$export$998bcd577473dd93;
var $bdcd6ced2cdccd72$export$b706b080d889d2c9;
var $bdcd6ced2cdccd72$export$5be5a87408f70ddc;
var $bdcd6ced2cdccd72$export$45a5e7f76e0caa8d;
var $bdcd6ced2cdccd72$export$455c2e768291efa6;
var $bdcd6ced2cdccd72$export$9522e17588c12572;
var $bdcd6ced2cdccd72$export$2110ac352bb060b9;
var $bdcd6ced2cdccd72$export$56885ab8b9c456ab;
var $bdcd6ced2cdccd72$export$d927fcb6adf8f9de;
var $bdcd6ced2cdccd72$export$b82d16f27459e05a;
var $bdcd6ced2cdccd72$export$522c17b4f5e123e8;
var $bdcd6ced2cdccd72$export$1aabd8a0274ecfd6;
var $bdcd6ced2cdccd72$export$3d6c20d97e46b957;
var $bdcd6ced2cdccd72$export$9b621391a187a31a;
var $bdcd6ced2cdccd72$export$f5bbd400c2f4426f;
"use strict";
var $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $bdcd6ced2cdccd72$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $bdcd6ced2cdccd72$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $bdcd6ced2cdccd72$var$typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE:
                    case $bdcd6ced2cdccd72$var$REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE:
                            case $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE:
                                return object;
                            case $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
$bdcd6ced2cdccd72$export$a7c73072b1a182ae = $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE;
$bdcd6ced2cdccd72$export$9f27bc3417b4524d = $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE;
$bdcd6ced2cdccd72$export$db77ccec0bb4ccac = $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE;
$bdcd6ced2cdccd72$export$8392c0c9d3dcbd35 = $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE;
$bdcd6ced2cdccd72$export$ffb0004e005737fa = $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE;
$bdcd6ced2cdccd72$export$b624eff549462981 = $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE;
$bdcd6ced2cdccd72$export$7897aa7841a5380c = $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE;
$bdcd6ced2cdccd72$export$602eac185826482c = $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE;
$bdcd6ced2cdccd72$export$e2c29f18771995cb = $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE;
$bdcd6ced2cdccd72$export$5f8d39834fd61797 = $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE;
$bdcd6ced2cdccd72$export$74bf444e3cd11ea5 = $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE;
$bdcd6ced2cdccd72$export$998bcd577473dd93 = $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE;
$bdcd6ced2cdccd72$export$b706b080d889d2c9 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE;
};
$bdcd6ced2cdccd72$export$5be5a87408f70ddc = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE;
};
$bdcd6ced2cdccd72$export$45a5e7f76e0caa8d = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $bdcd6ced2cdccd72$var$REACT_ELEMENT_TYPE;
};
$bdcd6ced2cdccd72$export$455c2e768291efa6 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE;
};
$bdcd6ced2cdccd72$export$9522e17588c12572 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE;
};
$bdcd6ced2cdccd72$export$2110ac352bb060b9 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE;
};
$bdcd6ced2cdccd72$export$56885ab8b9c456ab = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE;
};
$bdcd6ced2cdccd72$export$d927fcb6adf8f9de = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_PORTAL_TYPE;
};
$bdcd6ced2cdccd72$export$b82d16f27459e05a = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE;
};
$bdcd6ced2cdccd72$export$522c17b4f5e123e8 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE;
};
$bdcd6ced2cdccd72$export$1aabd8a0274ecfd6 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE;
};
$bdcd6ced2cdccd72$export$3d6c20d97e46b957 = function(object) {
    return $bdcd6ced2cdccd72$var$typeOf(object) === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE;
};
$bdcd6ced2cdccd72$export$9b621391a187a31a = function(type) {
    return "string" === typeof type || "function" === typeof type || type === $bdcd6ced2cdccd72$var$REACT_FRAGMENT_TYPE || type === $bdcd6ced2cdccd72$var$REACT_PROFILER_TYPE || type === $bdcd6ced2cdccd72$var$REACT_STRICT_MODE_TYPE || type === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_TYPE || type === $bdcd6ced2cdccd72$var$REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === $bdcd6ced2cdccd72$var$REACT_LAZY_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_MEMO_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CONTEXT_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CONSUMER_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_FORWARD_REF_TYPE || type.$$typeof === $bdcd6ced2cdccd72$var$REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
$bdcd6ced2cdccd72$export$f5bbd400c2f4426f = $bdcd6ced2cdccd72$var$typeOf;

});

parcelRegister("dNL7g", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", () => $a0c46644c9629c37$export$2b8d127b894957b9, (v) => $a0c46644c9629c37$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $a0c46644c9629c37$export$cea3a54a6425200c, (v) => $a0c46644c9629c37$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $a0c46644c9629c37$export$a7c73072b1a182ae, (v) => $a0c46644c9629c37$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $a0c46644c9629c37$export$9f27bc3417b4524d, (v) => $a0c46644c9629c37$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $a0c46644c9629c37$export$db77ccec0bb4ccac, (v) => $a0c46644c9629c37$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $a0c46644c9629c37$export$8392c0c9d3dcbd35, (v) => $a0c46644c9629c37$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $a0c46644c9629c37$export$ffb0004e005737fa, (v) => $a0c46644c9629c37$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $a0c46644c9629c37$export$b624eff549462981, (v) => $a0c46644c9629c37$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $a0c46644c9629c37$export$7897aa7841a5380c, (v) => $a0c46644c9629c37$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $a0c46644c9629c37$export$602eac185826482c, (v) => $a0c46644c9629c37$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $a0c46644c9629c37$export$e2c29f18771995cb, (v) => $a0c46644c9629c37$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $a0c46644c9629c37$export$5f8d39834fd61797, (v) => $a0c46644c9629c37$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $a0c46644c9629c37$export$74bf444e3cd11ea5, (v) => $a0c46644c9629c37$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $a0c46644c9629c37$export$92387174baf9b227, (v) => $a0c46644c9629c37$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $a0c46644c9629c37$export$ec112efeb987d9c6, (v) => $a0c46644c9629c37$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $a0c46644c9629c37$export$b706b080d889d2c9, (v) => $a0c46644c9629c37$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $a0c46644c9629c37$export$5be5a87408f70ddc, (v) => $a0c46644c9629c37$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $a0c46644c9629c37$export$45a5e7f76e0caa8d, (v) => $a0c46644c9629c37$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $a0c46644c9629c37$export$455c2e768291efa6, (v) => $a0c46644c9629c37$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $a0c46644c9629c37$export$9522e17588c12572, (v) => $a0c46644c9629c37$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $a0c46644c9629c37$export$2110ac352bb060b9, (v) => $a0c46644c9629c37$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $a0c46644c9629c37$export$56885ab8b9c456ab, (v) => $a0c46644c9629c37$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $a0c46644c9629c37$export$d927fcb6adf8f9de, (v) => $a0c46644c9629c37$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $a0c46644c9629c37$export$b82d16f27459e05a, (v) => $a0c46644c9629c37$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $a0c46644c9629c37$export$522c17b4f5e123e8, (v) => $a0c46644c9629c37$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $a0c46644c9629c37$export$1aabd8a0274ecfd6, (v) => $a0c46644c9629c37$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $a0c46644c9629c37$export$9b621391a187a31a, (v) => $a0c46644c9629c37$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $a0c46644c9629c37$export$f5bbd400c2f4426f, (v) => $a0c46644c9629c37$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a0c46644c9629c37$export$2b8d127b894957b9;
var $a0c46644c9629c37$export$cea3a54a6425200c;
var $a0c46644c9629c37$export$a7c73072b1a182ae;
var $a0c46644c9629c37$export$9f27bc3417b4524d;
var $a0c46644c9629c37$export$db77ccec0bb4ccac;
var $a0c46644c9629c37$export$8392c0c9d3dcbd35;
var $a0c46644c9629c37$export$ffb0004e005737fa;
var $a0c46644c9629c37$export$b624eff549462981;
var $a0c46644c9629c37$export$7897aa7841a5380c;
var $a0c46644c9629c37$export$602eac185826482c;
var $a0c46644c9629c37$export$e2c29f18771995cb;
var $a0c46644c9629c37$export$5f8d39834fd61797;
var $a0c46644c9629c37$export$74bf444e3cd11ea5;
var $a0c46644c9629c37$export$92387174baf9b227;
var $a0c46644c9629c37$export$ec112efeb987d9c6;
var $a0c46644c9629c37$export$b706b080d889d2c9;
var $a0c46644c9629c37$export$5be5a87408f70ddc;
var $a0c46644c9629c37$export$45a5e7f76e0caa8d;
var $a0c46644c9629c37$export$455c2e768291efa6;
var $a0c46644c9629c37$export$9522e17588c12572;
var $a0c46644c9629c37$export$2110ac352bb060b9;
var $a0c46644c9629c37$export$56885ab8b9c456ab;
var $a0c46644c9629c37$export$d927fcb6adf8f9de;
var $a0c46644c9629c37$export$b82d16f27459e05a;
var $a0c46644c9629c37$export$522c17b4f5e123e8;
var $a0c46644c9629c37$export$1aabd8a0274ecfd6;
var $a0c46644c9629c37$export$9b621391a187a31a;
var $a0c46644c9629c37$export$f5bbd400c2f4426f;
'use strict';
var $a0c46644c9629c37$var$b = "function" === typeof Symbol && Symbol.for, $a0c46644c9629c37$var$c = $a0c46644c9629c37$var$b ? Symbol.for("react.element") : 60103, $a0c46644c9629c37$var$d = $a0c46644c9629c37$var$b ? Symbol.for("react.portal") : 60106, $a0c46644c9629c37$var$e = $a0c46644c9629c37$var$b ? Symbol.for("react.fragment") : 60107, $a0c46644c9629c37$var$f = $a0c46644c9629c37$var$b ? Symbol.for("react.strict_mode") : 60108, $a0c46644c9629c37$var$g = $a0c46644c9629c37$var$b ? Symbol.for("react.profiler") : 60114, $a0c46644c9629c37$var$h = $a0c46644c9629c37$var$b ? Symbol.for("react.provider") : 60109, $a0c46644c9629c37$var$k = $a0c46644c9629c37$var$b ? Symbol.for("react.context") : 60110, $a0c46644c9629c37$var$l = $a0c46644c9629c37$var$b ? Symbol.for("react.async_mode") : 60111, $a0c46644c9629c37$var$m = $a0c46644c9629c37$var$b ? Symbol.for("react.concurrent_mode") : 60111, $a0c46644c9629c37$var$n = $a0c46644c9629c37$var$b ? Symbol.for("react.forward_ref") : 60112, $a0c46644c9629c37$var$p = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense") : 60113, $a0c46644c9629c37$var$q = $a0c46644c9629c37$var$b ? Symbol.for("react.suspense_list") : 60120, $a0c46644c9629c37$var$r = $a0c46644c9629c37$var$b ? Symbol.for("react.memo") : 60115, $a0c46644c9629c37$var$t = $a0c46644c9629c37$var$b ? Symbol.for("react.lazy") : 60116, $a0c46644c9629c37$var$v = $a0c46644c9629c37$var$b ? Symbol.for("react.block") : 60121, $a0c46644c9629c37$var$w = $a0c46644c9629c37$var$b ? Symbol.for("react.fundamental") : 60117, $a0c46644c9629c37$var$x = $a0c46644c9629c37$var$b ? Symbol.for("react.responder") : 60118, $a0c46644c9629c37$var$y = $a0c46644c9629c37$var$b ? Symbol.for("react.scope") : 60119;
function $a0c46644c9629c37$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $a0c46644c9629c37$var$c:
                switch(a = a.type, a){
                    case $a0c46644c9629c37$var$l:
                    case $a0c46644c9629c37$var$m:
                    case $a0c46644c9629c37$var$e:
                    case $a0c46644c9629c37$var$g:
                    case $a0c46644c9629c37$var$f:
                    case $a0c46644c9629c37$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $a0c46644c9629c37$var$k:
                            case $a0c46644c9629c37$var$n:
                            case $a0c46644c9629c37$var$t:
                            case $a0c46644c9629c37$var$r:
                            case $a0c46644c9629c37$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $a0c46644c9629c37$var$d:
                return u;
        }
    }
}
function $a0c46644c9629c37$var$A(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$m;
}
$a0c46644c9629c37$export$2b8d127b894957b9 = $a0c46644c9629c37$var$l;
$a0c46644c9629c37$export$cea3a54a6425200c = $a0c46644c9629c37$var$m;
$a0c46644c9629c37$export$a7c73072b1a182ae = $a0c46644c9629c37$var$k;
$a0c46644c9629c37$export$9f27bc3417b4524d = $a0c46644c9629c37$var$h;
$a0c46644c9629c37$export$db77ccec0bb4ccac = $a0c46644c9629c37$var$c;
$a0c46644c9629c37$export$8392c0c9d3dcbd35 = $a0c46644c9629c37$var$n;
$a0c46644c9629c37$export$ffb0004e005737fa = $a0c46644c9629c37$var$e;
$a0c46644c9629c37$export$b624eff549462981 = $a0c46644c9629c37$var$t;
$a0c46644c9629c37$export$7897aa7841a5380c = $a0c46644c9629c37$var$r;
$a0c46644c9629c37$export$602eac185826482c = $a0c46644c9629c37$var$d;
$a0c46644c9629c37$export$e2c29f18771995cb = $a0c46644c9629c37$var$g;
$a0c46644c9629c37$export$5f8d39834fd61797 = $a0c46644c9629c37$var$f;
$a0c46644c9629c37$export$74bf444e3cd11ea5 = $a0c46644c9629c37$var$p;
$a0c46644c9629c37$export$92387174baf9b227 = function(a) {
    return $a0c46644c9629c37$var$A(a) || $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$l;
};
$a0c46644c9629c37$export$ec112efeb987d9c6 = $a0c46644c9629c37$var$A;
$a0c46644c9629c37$export$b706b080d889d2c9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$k;
};
$a0c46644c9629c37$export$5be5a87408f70ddc = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$h;
};
$a0c46644c9629c37$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $a0c46644c9629c37$var$c;
};
$a0c46644c9629c37$export$455c2e768291efa6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$n;
};
$a0c46644c9629c37$export$9522e17588c12572 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$e;
};
$a0c46644c9629c37$export$2110ac352bb060b9 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$t;
};
$a0c46644c9629c37$export$56885ab8b9c456ab = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$r;
};
$a0c46644c9629c37$export$d927fcb6adf8f9de = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$d;
};
$a0c46644c9629c37$export$b82d16f27459e05a = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$g;
};
$a0c46644c9629c37$export$522c17b4f5e123e8 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$f;
};
$a0c46644c9629c37$export$1aabd8a0274ecfd6 = function(a) {
    return $a0c46644c9629c37$var$z(a) === $a0c46644c9629c37$var$p;
};
$a0c46644c9629c37$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $a0c46644c9629c37$var$e || a === $a0c46644c9629c37$var$m || a === $a0c46644c9629c37$var$g || a === $a0c46644c9629c37$var$f || a === $a0c46644c9629c37$var$p || a === $a0c46644c9629c37$var$q || "object" === typeof a && null !== a && (a.$$typeof === $a0c46644c9629c37$var$t || a.$$typeof === $a0c46644c9629c37$var$r || a.$$typeof === $a0c46644c9629c37$var$h || a.$$typeof === $a0c46644c9629c37$var$k || a.$$typeof === $a0c46644c9629c37$var$n || a.$$typeof === $a0c46644c9629c37$var$w || a.$$typeof === $a0c46644c9629c37$var$x || a.$$typeof === $a0c46644c9629c37$var$y || a.$$typeof === $a0c46644c9629c37$var$v);
};
$a0c46644c9629c37$export$f5bbd400c2f4426f = $a0c46644c9629c37$var$z;

});

parcelRegister("8HV7i", function(module, exports) {

var $g3LWB = parcelRequire("g3LWB");

var $dxaB1 = parcelRequire("dxaB1");

var $clik2 = parcelRequire("clik2");

var $ffJvR = parcelRequire("ffJvR");

var $akdiQ = parcelRequire("akdiQ");

var $jqdgk = parcelRequire("jqdgk");

var $fj05i = parcelRequire("fj05i");
function $656ea513998a70a9$var$_regeneratorRuntime() {
    "use strict";
    var r = $dxaB1(), e = r.m($656ea513998a70a9$var$_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor;
    function n(r) {
        var e = "function" == typeof r && r.constructor;
        return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name));
    }
    var o = {
        "throw": 1,
        "return": 2,
        "break": 3,
        "continue": 3
    };
    function a(r) {
        var e, t;
        return function(n) {
            e || (e = {
                stop: function stop() {
                    return t(n.a, 2);
                },
                "catch": function _catch() {
                    return n.v;
                },
                abrupt: function abrupt(r, e) {
                    return t(n.a, o[r], e);
                },
                delegateYield: function delegateYield(r, o, a) {
                    return e.resultName = o, t(n.d, $fj05i(r), a);
                },
                finish: function finish(r) {
                    return t(n.f, r);
                }
            }, t = function t(r, _t, o) {
                n.p = e.prev, n.n = e.next;
                try {
                    return r(_t, o);
                } finally{
                    e.next = n.n;
                }
            }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n;
            try {
                return r.call(this, e);
            } finally{
                n.p = e.prev, n.n = e.next;
            }
        };
    }
    return (module.exports = $656ea513998a70a9$var$_regeneratorRuntime = function _regeneratorRuntime() {
        return {
            wrap: function wrap(e, t, n, o) {
                return r.w(a(e), t, n, o && o.reverse());
            },
            isGeneratorFunction: n,
            mark: r.m,
            awrap: function awrap(r, e) {
                return new $g3LWB(r, e);
            },
            AsyncIterator: $akdiQ,
            async: function async(r, e, t, o, u) {
                return (n(e) ? $ffJvR : $clik2)(a(r), e, t, o, u);
            },
            keys: $jqdgk,
            values: $fj05i
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $656ea513998a70a9$var$_regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("g3LWB", function(module, exports) {
function $bb121de08fcbfcd5$var$_OverloadYield(e, d) {
    this.v = e, this.k = d;
}
module.exports = $bb121de08fcbfcd5$var$_OverloadYield, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("dxaB1", function(module, exports) {

var $bvtjp = parcelRequire("bvtjp");
function $9da69396b6a55ef6$var$_regenerator() {
    /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag";
    function i(r, n, o, i) {
        var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype);
        return $bvtjp(u, "_invoke", function(r, n, o) {
            var i, c, u, f = 0, p = o || [], y = !1, G = {
                p: 0,
                n: 0,
                v: e,
                a: d,
                f: d.bind(e, 4),
                d: function d(t, r) {
                    return i = t, c = 0, u = e, G.n = r, a;
                }
            };
            function d(r, n) {
                for(c = r, u = n, t = 0; !y && f && !o && t < p.length; t++){
                    var o, i = p[t], d = G.p, l = i[2];
                    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
                }
                if (o || r > 1) return a;
                throw y = !0, n;
            }
            return function(o, p, l) {
                if (f > 1) throw TypeError("Generator is already running");
                for(y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;){
                    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
                    try {
                        if (f = 2, i) {
                            if (c || (o = "next"), t = i[o]) {
                                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                                if (!t.done) return t;
                                u = t.value, c < 2 && (c = 0);
                            } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
                            i = e;
                        } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
                    } catch (t) {
                        i = e, c = 1, u = t;
                    } finally{
                        f = 1;
                    }
                }
                return {
                    value: t,
                    done: y
                };
            };
        }(r, o, i), !0), u;
    }
    var a = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    t = Object.getPrototypeOf;
    var c = [][n] ? t(t([][n]())) : ($bvtjp(t = {}, n, function() {
        return this;
    }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
    function f(e) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, $bvtjp(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, $bvtjp(u, "constructor", GeneratorFunctionPrototype), $bvtjp(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", $bvtjp(GeneratorFunctionPrototype, o, "GeneratorFunction"), $bvtjp(u), $bvtjp(u, o, "Generator"), $bvtjp(u, n, function() {
        return this;
    }), $bvtjp(u, "toString", function() {
        return "[object Generator]";
    }), (module.exports = $9da69396b6a55ef6$var$_regenerator = function _regenerator() {
        return {
            w: i,
            m: f
        };
    }, module.exports.__esModule = true, module.exports["default"] = module.exports)();
}
module.exports = $9da69396b6a55ef6$var$_regenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("bvtjp", function(module, exports) {
function $860953b56aa6b685$var$_regeneratorDefine(e, r, n, t) {
    var i = Object.defineProperty;
    try {
        i({}, "", {});
    } catch (e) {
        i = 0;
    }
    module.exports = $860953b56aa6b685$var$_regeneratorDefine = function regeneratorDefine(e, r, n, t) {
        function o(r, n) {
            $860953b56aa6b685$var$_regeneratorDefine(e, r, function(e) {
                return this._invoke(r, n, e);
            });
        }
        r ? i ? i(e, r, {
            value: n,
            enumerable: !t,
            configurable: !t,
            writable: !t
        }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $860953b56aa6b685$var$_regeneratorDefine(e, r, n, t);
}
module.exports = $860953b56aa6b685$var$_regeneratorDefine, module.exports.__esModule = true, module.exports["default"] = module.exports;

});


parcelRegister("clik2", function(module, exports) {

var $ffJvR = parcelRequire("ffJvR");
function $8fc5a89a7b8dab85$var$_regeneratorAsync(n, e, r, t, o) {
    var a = $ffJvR(n, e, r, t, o);
    return a.next().then(function(n) {
        return n.done ? n.value : a.next();
    });
}
module.exports = $8fc5a89a7b8dab85$var$_regeneratorAsync, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("ffJvR", function(module, exports) {

var $dxaB1 = parcelRequire("dxaB1");

var $akdiQ = parcelRequire("akdiQ");
function $b1ab8fa4d5e48c1f$var$_regeneratorAsyncGen(r, e, t, o, n) {
    return new $akdiQ($dxaB1().w(r, e, t, o), n || Promise);
}
module.exports = $b1ab8fa4d5e48c1f$var$_regeneratorAsyncGen, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("akdiQ", function(module, exports) {

var $g3LWB = parcelRequire("g3LWB");

var $bvtjp = parcelRequire("bvtjp");
function $78461755ff54e6c7$var$AsyncIterator(t, e) {
    function n(r, o, i, f) {
        try {
            var c = t[r](o), u = c.value;
            return u instanceof $g3LWB ? e.resolve(u.v).then(function(t) {
                n("next", t, i, f);
            }, function(t) {
                n("throw", t, i, f);
            }) : e.resolve(u).then(function(t) {
                c.value = t, i(c);
            }, function(t) {
                return n("throw", t, i, f);
            });
        } catch (t) {
            f(t);
        }
    }
    var r;
    this.next || ($bvtjp($78461755ff54e6c7$var$AsyncIterator.prototype), $bvtjp($78461755ff54e6c7$var$AsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function() {
        return this;
    })), $bvtjp(this, "_invoke", function(t, o, i) {
        function f() {
            return new e(function(e, r) {
                n(t, i, e, r);
            });
        }
        return r = r ? r.then(f, f) : f();
    }, !0);
}
module.exports = $78461755ff54e6c7$var$AsyncIterator, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("jqdgk", function(module, exports) {
function $e23abba3e573ae7a$var$_regeneratorKeys(e) {
    var n = Object(e), r = [];
    for(var t in n)r.unshift(t);
    return function e() {
        for(; r.length;)if ((t = r.pop()) in n) return e.value = t, e.done = !1, e;
        return e.done = !0, e;
    };
}
module.exports = $e23abba3e573ae7a$var$_regeneratorKeys, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRegister("fj05i", function(module, exports) {

var $41YNz = parcelRequire("41YNz");
var $b248b2228601290d$var$_typeof = $41YNz.default;
function $b248b2228601290d$var$_regeneratorValues(e) {
    if (null != e) {
        var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0;
        if (t) return t.call(e);
        if ("function" == typeof e.next) return e;
        if (!isNaN(e.length)) return {
            next: function next() {
                return e && r >= e.length && (e = void 0), {
                    value: e && e[r++],
                    done: !e
                };
            }
        };
    }
    throw new TypeError($b248b2228601290d$var$_typeof(e) + " is not iterable");
}
module.exports = $b248b2228601290d$var$_regeneratorValues, module.exports.__esModule = true, module.exports["default"] = module.exports;

});
parcelRegister("41YNz", function(module, exports) {
function $2ef66ab8c52ac1c0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return module.exports = $2ef66ab8c52ac1c0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, module.exports.__esModule = true, module.exports["default"] = module.exports, $2ef66ab8c52ac1c0$var$_typeof(o);
}
module.exports = $2ef66ab8c52ac1c0$var$_typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

});



parcelRegister("R5nvG", function(module, exports) {
// Save global object in a variable
var __global__ = typeof globalThis !== 'undefined' && globalThis || typeof self !== 'undefined' && self || typeof $parcel$global !== 'undefined' && $parcel$global;
// Create an object that extends from __global__ without the fetch function
var __globalThis__ = function() {
    function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
    }
    F.prototype = __global__; // Needed for feature detection on whatwg-fetch's code
    return new F();
}();
// Wraps whatwg-fetch with a function scope to hijack the global object
// "globalThis" that's going to be patched
(function(globalThis1) {
    var irrelevant = function(exports1) {
        /* eslint-disable no-prototype-builtins */ var g = typeof globalThis1 !== 'undefined' && globalThis1 || typeof self !== 'undefined' && self || // eslint-disable-next-line no-undef
        typeof $parcel$global !== 'undefined' && $parcel$global || {};
        var support = {
            searchParams: 'URLSearchParams' in g,
            iterable: 'Symbol' in g && 'iterator' in Symbol,
            blob: 'FileReader' in g && 'Blob' in g && function() {
                try {
                    new Blob();
                    return true;
                } catch (e) {
                    return false;
                }
            }(),
            formData: 'FormData' in g,
            arrayBuffer: 'ArrayBuffer' in g
        };
        function isDataView(obj) {
            return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support.arrayBuffer) {
            var viewClasses = [
                '[object Int8Array]',
                '[object Uint8Array]',
                '[object Uint8ClampedArray]',
                '[object Int16Array]',
                '[object Uint16Array]',
                '[object Int32Array]',
                '[object Uint32Array]',
                '[object Float32Array]',
                '[object Float64Array]'
            ];
            var isArrayBufferView = ArrayBuffer.isView || function(obj) {
                return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
            };
        }
        function normalizeName(name) {
            if (typeof name !== 'string') name = String(name);
            if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') throw new TypeError('Invalid character in header field name: "' + name + '"');
            return name.toLowerCase();
        }
        function normalizeValue(value) {
            if (typeof value !== 'string') value = String(value);
            return value;
        }
        // Build a destructive iterator for the value list
        function iteratorFor(items) {
            var iterator = {
                next: function() {
                    var value = items.shift();
                    return {
                        done: value === undefined,
                        value: value
                    };
                }
            };
            if (support.iterable) iterator[Symbol.iterator] = function() {
                return iterator;
            };
            return iterator;
        }
        function Headers(headers) {
            this.map = {};
            if (headers instanceof Headers) headers.forEach(function(value, name) {
                this.append(name, value);
            }, this);
            else if (Array.isArray(headers)) headers.forEach(function(header) {
                if (header.length != 2) throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length);
                this.append(header[0], header[1]);
            }, this);
            else if (headers) Object.getOwnPropertyNames(headers).forEach(function(name) {
                this.append(name, headers[name]);
            }, this);
        }
        Headers.prototype.append = function(name, value) {
            name = normalizeName(name);
            value = normalizeValue(value);
            var oldValue = this.map[name];
            this.map[name] = oldValue ? oldValue + ', ' + value : value;
        };
        Headers.prototype['delete'] = function(name) {
            delete this.map[normalizeName(name)];
        };
        Headers.prototype.get = function(name) {
            name = normalizeName(name);
            return this.has(name) ? this.map[name] : null;
        };
        Headers.prototype.has = function(name) {
            return this.map.hasOwnProperty(normalizeName(name));
        };
        Headers.prototype.set = function(name, value) {
            this.map[normalizeName(name)] = normalizeValue(value);
        };
        Headers.prototype.forEach = function(callback, thisArg) {
            for(var name in this.map)if (this.map.hasOwnProperty(name)) callback.call(thisArg, this.map[name], name, this);
        };
        Headers.prototype.keys = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push(name);
            });
            return iteratorFor(items);
        };
        Headers.prototype.values = function() {
            var items = [];
            this.forEach(function(value) {
                items.push(value);
            });
            return iteratorFor(items);
        };
        Headers.prototype.entries = function() {
            var items = [];
            this.forEach(function(value, name) {
                items.push([
                    name,
                    value
                ]);
            });
            return iteratorFor(items);
        };
        if (support.iterable) Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
        function consumed(body) {
            if (body._noBody) return;
            if (body.bodyUsed) return Promise.reject(new TypeError('Already read'));
            body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
            return new Promise(function(resolve, reject) {
                reader.onload = function() {
                    resolve(reader.result);
                };
                reader.onerror = function() {
                    reject(reader.error);
                };
            });
        }
        function readBlobAsArrayBuffer(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            reader.readAsArrayBuffer(blob);
            return promise;
        }
        function readBlobAsText(blob) {
            var reader = new FileReader();
            var promise = fileReaderReady(reader);
            var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
            var encoding = match ? match[1] : 'utf-8';
            reader.readAsText(blob, encoding);
            return promise;
        }
        function readArrayBufferAsText(buf) {
            var view = new Uint8Array(buf);
            var chars = new Array(view.length);
            for(var i = 0; i < view.length; i++)chars[i] = String.fromCharCode(view[i]);
            return chars.join('');
        }
        function bufferClone(buf) {
            if (buf.slice) return buf.slice(0);
            else {
                var view = new Uint8Array(buf.byteLength);
                view.set(new Uint8Array(buf));
                return view.buffer;
            }
        }
        function Body() {
            this.bodyUsed = false;
            this._initBody = function(body) {
                /*
        fetch-mock wraps the Response object in an ES6 Proxy to
        provide useful test harness features such as flush. However, on
        ES5 browsers without fetch or Proxy support pollyfills must be used;
        the proxy-pollyfill is unable to proxy an attribute unless it exists
        on the object before the Proxy is created. This change ensures
        Response.bodyUsed exists on the instance, while maintaining the
        semantic of setting Request.bodyUsed in the constructor before
        _initBody is called.
      */ // eslint-disable-next-line no-self-assign
                this.bodyUsed = this.bodyUsed;
                this._bodyInit = body;
                if (!body) {
                    this._noBody = true;
                    this._bodyText = '';
                } else if (typeof body === 'string') this._bodyText = body;
                else if (support.blob && Blob.prototype.isPrototypeOf(body)) this._bodyBlob = body;
                else if (support.formData && FormData.prototype.isPrototypeOf(body)) this._bodyFormData = body;
                else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this._bodyText = body.toString();
                else if (support.arrayBuffer && support.blob && isDataView(body)) {
                    this._bodyArrayBuffer = bufferClone(body.buffer);
                    // IE 10-11 can't handle a DataView body.
                    this._bodyInit = new Blob([
                        this._bodyArrayBuffer
                    ]);
                } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) this._bodyArrayBuffer = bufferClone(body);
                else this._bodyText = body = Object.prototype.toString.call(body);
                if (!this.headers.get('content-type')) {
                    if (typeof body === 'string') this.headers.set('content-type', 'text/plain;charset=UTF-8');
                    else if (this._bodyBlob && this._bodyBlob.type) this.headers.set('content-type', this._bodyBlob.type);
                    else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
                }
            };
            if (support.blob) this.blob = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(new Blob([
                    this._bodyArrayBuffer
                ]));
                else if (this._bodyFormData) throw new Error('could not read FormData body as blob');
                else return Promise.resolve(new Blob([
                    this._bodyText
                ]));
            };
            this.arrayBuffer = function() {
                if (this._bodyArrayBuffer) {
                    var isConsumed = consumed(this);
                    if (isConsumed) return isConsumed;
                    else if (ArrayBuffer.isView(this._bodyArrayBuffer)) return Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset, this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength));
                    else return Promise.resolve(this._bodyArrayBuffer);
                } else if (support.blob) return this.blob().then(readBlobAsArrayBuffer);
                else throw new Error('could not read as ArrayBuffer');
            };
            this.text = function() {
                var rejected = consumed(this);
                if (rejected) return rejected;
                if (this._bodyBlob) return readBlobAsText(this._bodyBlob);
                else if (this._bodyArrayBuffer) return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
                else if (this._bodyFormData) throw new Error('could not read FormData body as text');
                else return Promise.resolve(this._bodyText);
            };
            if (support.formData) this.formData = function() {
                return this.text().then(decode);
            };
            this.json = function() {
                return this.text().then(JSON.parse);
            };
            return this;
        }
        // HTTP methods whose capitalization should be normalized
        var methods = [
            'CONNECT',
            'DELETE',
            'GET',
            'HEAD',
            'OPTIONS',
            'PATCH',
            'POST',
            'PUT',
            'TRACE'
        ];
        function normalizeMethod(method) {
            var upcased = method.toUpperCase();
            return methods.indexOf(upcased) > -1 ? upcased : method;
        }
        function Request(input, options) {
            if (!(this instanceof Request)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            options = options || {};
            var body = options.body;
            if (input instanceof Request) {
                if (input.bodyUsed) throw new TypeError('Already read');
                this.url = input.url;
                this.credentials = input.credentials;
                if (!options.headers) this.headers = new Headers(input.headers);
                this.method = input.method;
                this.mode = input.mode;
                this.signal = input.signal;
                if (!body && input._bodyInit != null) {
                    body = input._bodyInit;
                    input.bodyUsed = true;
                }
            } else this.url = String(input);
            this.credentials = options.credentials || this.credentials || 'same-origin';
            if (options.headers || !this.headers) this.headers = new Headers(options.headers);
            this.method = normalizeMethod(options.method || this.method || 'GET');
            this.mode = options.mode || this.mode || null;
            this.signal = options.signal || this.signal || function() {
                if ('AbortController' in g) {
                    var ctrl = new AbortController();
                    return ctrl.signal;
                }
            }();
            this.referrer = null;
            if ((this.method === 'GET' || this.method === 'HEAD') && body) throw new TypeError('Body not allowed for GET or HEAD requests');
            this._initBody(body);
            if (this.method === 'GET' || this.method === 'HEAD') {
                if (options.cache === 'no-store' || options.cache === 'no-cache') {
                    // Search for a '_' parameter in the query string
                    var reParamSearch = /([?&])_=[^&]*/;
                    if (reParamSearch.test(this.url)) // If it already exists then set the value with the current time
                    this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime());
                    else {
                        // Otherwise add a new '_' parameter to the end with the current time
                        var reQueryString = /\?/;
                        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime();
                    }
                }
            }
        }
        Request.prototype.clone = function() {
            return new Request(this, {
                body: this._bodyInit
            });
        };
        function decode(body) {
            var form = new FormData();
            body.trim().split('&').forEach(function(bytes) {
                if (bytes) {
                    var split = bytes.split('=');
                    var name = split.shift().replace(/\+/g, ' ');
                    var value = split.join('=').replace(/\+/g, ' ');
                    form.append(decodeURIComponent(name), decodeURIComponent(value));
                }
            });
            return form;
        }
        function parseHeaders(rawHeaders) {
            var headers = new Headers();
            // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
            // https://tools.ietf.org/html/rfc7230#section-3.2
            var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
            // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
            // https://github.com/github/fetch/issues/748
            // https://github.com/zloirock/core-js/issues/751
            preProcessedHeaders.split('\r').map(function(header) {
                return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header;
            }).forEach(function(line) {
                var parts = line.split(':');
                var key = parts.shift().trim();
                if (key) {
                    var value = parts.join(':').trim();
                    try {
                        headers.append(key, value);
                    } catch (error) {
                        console.warn('Response ' + error.message);
                    }
                }
            });
            return headers;
        }
        Body.call(Request.prototype);
        function Response(bodyInit, options) {
            if (!(this instanceof Response)) throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
            if (!options) options = {};
            this.type = 'default';
            this.status = options.status === undefined ? 200 : options.status;
            if (this.status < 200 || this.status > 599) throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
            this.ok = this.status >= 200 && this.status < 300;
            this.statusText = options.statusText === undefined ? '' : '' + options.statusText;
            this.headers = new Headers(options.headers);
            this.url = options.url || '';
            this._initBody(bodyInit);
        }
        Body.call(Response.prototype);
        Response.prototype.clone = function() {
            return new Response(this._bodyInit, {
                status: this.status,
                statusText: this.statusText,
                headers: new Headers(this.headers),
                url: this.url
            });
        };
        Response.error = function() {
            var response = new Response(null, {
                status: 200,
                statusText: ''
            });
            response.ok = false;
            response.status = 0;
            response.type = 'error';
            return response;
        };
        var redirectStatuses = [
            301,
            302,
            303,
            307,
            308
        ];
        Response.redirect = function(url, status) {
            if (redirectStatuses.indexOf(status) === -1) throw new RangeError('Invalid status code');
            return new Response(null, {
                status: status,
                headers: {
                    location: url
                }
            });
        };
        exports1.DOMException = g.DOMException;
        try {
            new exports1.DOMException();
        } catch (err) {
            exports1.DOMException = function(message, name) {
                this.message = message;
                this.name = name;
                var error = Error(message);
                this.stack = error.stack;
            };
            exports1.DOMException.prototype = Object.create(Error.prototype);
            exports1.DOMException.prototype.constructor = exports1.DOMException;
        }
        function fetch(input, init) {
            return new Promise(function(resolve, reject) {
                var request = new Request(input, init);
                if (request.signal && request.signal.aborted) return reject(new exports1.DOMException('Aborted', 'AbortError'));
                var xhr = new XMLHttpRequest();
                function abortXhr() {
                    xhr.abort();
                }
                xhr.onload = function() {
                    var options = {
                        statusText: xhr.statusText,
                        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
                    };
                    // This check if specifically for when a user fetches a file locally from the file system
                    // Only if the status is out of a normal range
                    if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) options.status = 200;
                    else options.status = xhr.status;
                    options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
                    var body = 'response' in xhr ? xhr.response : xhr.responseText;
                    setTimeout(function() {
                        resolve(new Response(body, options));
                    }, 0);
                };
                xhr.onerror = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request failed'));
                    }, 0);
                };
                xhr.ontimeout = function() {
                    setTimeout(function() {
                        reject(new TypeError('Network request timed out'));
                    }, 0);
                };
                xhr.onabort = function() {
                    setTimeout(function() {
                        reject(new exports1.DOMException('Aborted', 'AbortError'));
                    }, 0);
                };
                function fixUrl(url) {
                    try {
                        return url === '' && g.location.href ? g.location.href : url;
                    } catch (e) {
                        return url;
                    }
                }
                xhr.open(request.method, fixUrl(request.url), true);
                if (request.credentials === 'include') xhr.withCredentials = true;
                else if (request.credentials === 'omit') xhr.withCredentials = false;
                if ('responseType' in xhr) {
                    if (support.blob) xhr.responseType = 'blob';
                    else if (support.arrayBuffer) xhr.responseType = 'arraybuffer';
                }
                if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || g.Headers && init.headers instanceof g.Headers)) {
                    var names = [];
                    Object.getOwnPropertyNames(init.headers).forEach(function(name) {
                        names.push(normalizeName(name));
                        xhr.setRequestHeader(name, normalizeValue(init.headers[name]));
                    });
                    request.headers.forEach(function(value, name) {
                        if (names.indexOf(name) === -1) xhr.setRequestHeader(name, value);
                    });
                } else request.headers.forEach(function(value, name) {
                    xhr.setRequestHeader(name, value);
                });
                if (request.signal) {
                    request.signal.addEventListener('abort', abortXhr);
                    xhr.onreadystatechange = function() {
                        // DONE (success or failure)
                        if (xhr.readyState === 4) request.signal.removeEventListener('abort', abortXhr);
                    };
                }
                xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
            });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
            g.fetch = fetch;
            g.Headers = Headers;
            g.Request = Request;
            g.Response = Response;
        }
        exports1.Headers = Headers;
        exports1.Request = Request;
        exports1.Response = Response;
        exports1.fetch = fetch;
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
        return exports1;
    }({});
})(__globalThis__);
// This is a ponyfill, so...
__globalThis__.fetch.ponyfill = true;
delete __globalThis__.fetch.polyfill;
// Choose between native implementation (__global__) or custom implementation (__globalThis__)
var ctx = __global__.fetch ? __global__ : __globalThis__;
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
;
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
;
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
;
exports.Headers = ctx.Headers;
exports.Request = ctx.Request;
exports.Response = ctx.Response;
module.exports = exports;

});

parcelRegister("gd5R7", function(module, exports) {
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $bcd2671091eb623d$var$n;
function $bcd2671091eb623d$var$aa(a) {
    var b = 0;
    return function() {
        return b < a.length ? {
            done: !1,
            value: a[b++]
        } : {
            done: !0
        };
    };
}
var $bcd2671091eb623d$var$ba = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
};
function $bcd2671091eb623d$var$ca(a) {
    a = [
        "object" == typeof window && window,
        "object" == typeof self && self,
        "object" == typeof $parcel$global && $parcel$global,
        a
    ];
    for(var b = 0; b < a.length; ++b){
        var c = a[b];
        if (c && c.Math == Math) return c;
    }
    throw Error("Cannot find global object");
}
var $bcd2671091eb623d$var$r = $bcd2671091eb623d$var$ca(module.exports);
function $bcd2671091eb623d$var$t() {
    $bcd2671091eb623d$var$t = function() {};
    $bcd2671091eb623d$var$r.Symbol || ($bcd2671091eb623d$var$r.Symbol = $bcd2671091eb623d$var$da);
}
function $bcd2671091eb623d$var$ea(a, b) {
    this.a = a;
    $bcd2671091eb623d$var$ba(this, "description", {
        configurable: !0,
        writable: !0,
        value: b
    });
}
$bcd2671091eb623d$var$ea.prototype.toString = function() {
    return this.a;
};
var $bcd2671091eb623d$var$da = function() {
    function a(c) {
        if (this instanceof a) throw new TypeError("Symbol is not a constructor");
        return new $bcd2671091eb623d$var$ea("jscomp_symbol_" + (c || "") + "_" + b++, c);
    }
    var b = 0;
    return a;
}();
function $bcd2671091eb623d$var$u() {
    $bcd2671091eb623d$var$t();
    var a = $bcd2671091eb623d$var$r.Symbol.iterator;
    a || (a = $bcd2671091eb623d$var$r.Symbol.iterator = $bcd2671091eb623d$var$r.Symbol("Symbol.iterator"));
    "function" != typeof Array.prototype[a] && $bcd2671091eb623d$var$ba(Array.prototype, a, {
        configurable: !0,
        writable: !0,
        value: function() {
            return $bcd2671091eb623d$var$fa($bcd2671091eb623d$var$aa(this));
        }
    });
    $bcd2671091eb623d$var$u = function() {};
}
function $bcd2671091eb623d$var$fa(a) {
    $bcd2671091eb623d$var$u();
    a = {
        next: a
    };
    a[$bcd2671091eb623d$var$r.Symbol.iterator] = function() {
        return this;
    };
    return a;
}
function $bcd2671091eb623d$var$ha(a) {
    var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : {
        next: $bcd2671091eb623d$var$aa(a)
    };
}
var $bcd2671091eb623d$var$ia = "function" == typeof Object.create ? Object.create : function(a) {
    function b() {}
    b.prototype = a;
    return new b;
}, $bcd2671091eb623d$var$ja;
if ("function" == typeof Object.setPrototypeOf) $bcd2671091eb623d$var$ja = Object.setPrototypeOf;
else {
    var $bcd2671091eb623d$var$ka;
    a: {
        var $bcd2671091eb623d$var$la = {
            V: !0
        }, $bcd2671091eb623d$var$ma = {};
        try {
            $bcd2671091eb623d$var$ma.__proto__ = $bcd2671091eb623d$var$la;
            $bcd2671091eb623d$var$ka = $bcd2671091eb623d$var$ma.V;
            break a;
        } catch (a) {}
        $bcd2671091eb623d$var$ka = !1;
    }
    $bcd2671091eb623d$var$ja = $bcd2671091eb623d$var$ka ? function(a, b) {
        a.__proto__ = b;
        if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
        return a;
    } : null;
}
var $bcd2671091eb623d$var$na = $bcd2671091eb623d$var$ja;
function $bcd2671091eb623d$var$oa(a, b) {
    a.prototype = $bcd2671091eb623d$var$ia(b.prototype);
    a.prototype.constructor = a;
    if ($bcd2671091eb623d$var$na) $bcd2671091eb623d$var$na(a, b);
    else for(var c in b)if ("prototype" != c) {
        if (Object.defineProperties) {
            var d = Object.getOwnPropertyDescriptor(b, c);
            d && Object.defineProperty(a, c, d);
        } else a[c] = b[c];
    }
    a.O = b.prototype;
}
function $bcd2671091eb623d$var$pa(a, b) {
    $bcd2671091eb623d$var$u();
    a instanceof String && (a += "");
    var c = 0, d = {
        next: function() {
            if (c < a.length) {
                var f = c++;
                return {
                    value: b(f, a[f]),
                    done: !1
                };
            }
            d.next = function() {
                return {
                    done: !0,
                    value: void 0
                };
            };
            return d.next();
        }
    };
    d[Symbol.iterator] = function() {
        return d;
    };
    return d;
}
function $bcd2671091eb623d$var$v(a, b) {
    if (b) {
        var c = $bcd2671091eb623d$var$r;
        a = a.split(".");
        for(var d = 0; d < a.length - 1; d++){
            var f = a[d];
            f in c || (c[f] = {});
            c = c[f];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && $bcd2671091eb623d$var$ba(c, a, {
            configurable: !0,
            writable: !0,
            value: b
        });
    }
}
$bcd2671091eb623d$var$v("Array.prototype.keys", function(a) {
    return a ? a : function() {
        return $bcd2671091eb623d$var$pa(this, function(b) {
            return b;
        });
    };
});
$bcd2671091eb623d$var$v("Array.prototype.find", function(a) {
    return a ? a : function(b, c) {
        a: {
            var d = this;
            d instanceof String && (d = String(d));
            for(var f = d.length, g = 0; g < f; g++){
                var e = d[g];
                if (b.call(c, e, g, d)) {
                    b = e;
                    break a;
                }
            }
            b = void 0;
        }
        return b;
    };
});
$bcd2671091eb623d$var$v("Object.is", function(a) {
    return a ? a : function(b, c) {
        return b === c ? 0 !== b || 1 / b === 1 / c : b !== b && c !== c;
    };
});
$bcd2671091eb623d$var$v("Array.prototype.includes", function(a) {
    return a ? a : function(b, c) {
        var d = this;
        d instanceof String && (d = String(d));
        var f = d.length;
        c = c || 0;
        for(0 > c && (c = Math.max(c + f, 0)); c < f; c++){
            var g = d[c];
            if (g === b || Object.is(g, b)) return !0;
        }
        return !1;
    };
});
$bcd2671091eb623d$var$v("Promise", function(a) {
    function b(e) {
        this.b = 0;
        this.c = void 0;
        this.a = [];
        var h = this.f();
        try {
            e(h.resolve, h.reject);
        } catch (k) {
            h.reject(k);
        }
    }
    function c() {
        this.a = null;
    }
    function d(e) {
        return e instanceof b ? e : new b(function(h) {
            h(e);
        });
    }
    if (a) return a;
    c.prototype.b = function(e) {
        if (null == this.a) {
            this.a = [];
            var h = this;
            this.c(function() {
                h.g();
            });
        }
        this.a.push(e);
    };
    var f = $bcd2671091eb623d$var$r.setTimeout;
    c.prototype.c = function(e) {
        f(e, 0);
    };
    c.prototype.g = function() {
        for(; this.a && this.a.length;){
            var e = this.a;
            this.a = [];
            for(var h = 0; h < e.length; ++h){
                var k = e[h];
                e[h] = null;
                try {
                    k();
                } catch (l) {
                    this.f(l);
                }
            }
        }
        this.a = null;
    };
    c.prototype.f = function(e) {
        this.c(function() {
            throw e;
        });
    };
    b.prototype.f = function() {
        function e(l) {
            return function(m) {
                k || (k = !0, l.call(h, m));
            };
        }
        var h = this, k = !1;
        return {
            resolve: e(this.s),
            reject: e(this.g)
        };
    };
    b.prototype.s = function(e) {
        if (e === this) this.g(new TypeError("A Promise cannot resolve to itself"));
        else if (e instanceof b) this.v(e);
        else {
            a: switch(typeof e){
                case "object":
                    var h = null != e;
                    break a;
                case "function":
                    h = !0;
                    break a;
                default:
                    h = !1;
            }
            h ? this.m(e) : this.h(e);
        }
    };
    b.prototype.m = function(e) {
        var h = void 0;
        try {
            h = e.then;
        } catch (k) {
            this.g(k);
            return;
        }
        "function" == typeof h ? this.w(h, e) : this.h(e);
    };
    b.prototype.g = function(e) {
        this.i(2, e);
    };
    b.prototype.h = function(e) {
        this.i(1, e);
    };
    b.prototype.i = function(e, h) {
        if (0 != this.b) throw Error("Cannot settle(" + e + ", " + h + "): Promise already settled in state" + this.b);
        this.b = e;
        this.c = h;
        this.l();
    };
    b.prototype.l = function() {
        if (null != this.a) {
            for(var e = 0; e < this.a.length; ++e)g.b(this.a[e]);
            this.a = null;
        }
    };
    var g = new c;
    b.prototype.v = function(e) {
        var h = this.f();
        e.F(h.resolve, h.reject);
    };
    b.prototype.w = function(e, h) {
        var k = this.f();
        try {
            e.call(h, k.resolve, k.reject);
        } catch (l) {
            k.reject(l);
        }
    };
    b.prototype.then = function(e, h) {
        function k(q, w) {
            return "function" == typeof q ? function(A) {
                try {
                    l(q(A));
                } catch (L) {
                    m(L);
                }
            } : w;
        }
        var l, m, p = new b(function(q, w) {
            l = q;
            m = w;
        });
        this.F(k(e, l), k(h, m));
        return p;
    };
    b.prototype.catch = function(e) {
        return this.then(void 0, e);
    };
    b.prototype.F = function(e, h) {
        function k() {
            switch(l.b){
                case 1:
                    e(l.c);
                    break;
                case 2:
                    h(l.c);
                    break;
                default:
                    throw Error("Unexpected state: " + l.b);
            }
        }
        var l = this;
        null == this.a ? g.b(k) : this.a.push(k);
    };
    b.resolve = d;
    b.reject = function(e) {
        return new b(function(h, k) {
            k(e);
        });
    };
    b.race = function(e) {
        return new b(function(h, k) {
            for(var l = $bcd2671091eb623d$var$ha(e), m = l.next(); !m.done; m = l.next())d(m.value).F(h, k);
        });
    };
    b.all = function(e) {
        var h = $bcd2671091eb623d$var$ha(e), k = h.next();
        return k.done ? d([]) : new b(function(l, m) {
            function p(A) {
                return function(L) {
                    q[A] = L;
                    w--;
                    0 == w && l(q);
                };
            }
            var q = [], w = 0;
            do q.push(void 0), w++, d(k.value).F(p(q.length - 1), m), k = h.next();
            while (!k.done);
        });
    };
    return b;
});
var $bcd2671091eb623d$var$qa = $bcd2671091eb623d$var$qa || {}, $bcd2671091eb623d$var$x = module.exports || self;
function $bcd2671091eb623d$var$y(a, b) {
    a = a.split(".");
    b = b || $bcd2671091eb623d$var$x;
    for(var c = 0; c < a.length; c++)if (b = b[a[c]], null == b) return null;
    return b;
}
function $bcd2671091eb623d$var$ra() {}
function $bcd2671091eb623d$var$sa(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
var $bcd2671091eb623d$var$ta = "closure_uid_" + (1E9 * Math.random() >>> 0), $bcd2671091eb623d$var$ua = 0;
function $bcd2671091eb623d$var$va(a, b, c) {
    return a.call.apply(a.bind, arguments);
}
function $bcd2671091eb623d$var$wa(a, b, c) {
    if (!a) throw Error();
    if (2 < arguments.length) {
        var d = Array.prototype.slice.call(arguments, 2);
        return function() {
            var f = Array.prototype.slice.call(arguments);
            Array.prototype.unshift.apply(f, d);
            return a.apply(b, f);
        };
    }
    return function() {
        return a.apply(b, arguments);
    };
}
function $bcd2671091eb623d$var$z(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? $bcd2671091eb623d$var$z = $bcd2671091eb623d$var$va : $bcd2671091eb623d$var$z = $bcd2671091eb623d$var$wa;
    return $bcd2671091eb623d$var$z.apply(null, arguments);
}
function $bcd2671091eb623d$var$B(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.O = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
}
function $bcd2671091eb623d$var$xa(a) {
    this.a = a || {};
}
$bcd2671091eb623d$var$xa.prototype.get = function(a) {
    return this.a[a];
};
$bcd2671091eb623d$var$xa.prototype.G = function() {
    return Object.keys(this.a);
};
function $bcd2671091eb623d$var$C(a, b, c, d) {
    this.f = a;
    this.c = b;
    this.b = c;
    this.a = d;
}
$bcd2671091eb623d$var$C.prototype.getRequestMessage = function() {
    return this.f;
};
$bcd2671091eb623d$var$C.prototype.getMethodDescriptor = function() {
    return this.c;
};
$bcd2671091eb623d$var$C.prototype.getMetadata = function() {
    return this.b;
};
$bcd2671091eb623d$var$C.prototype.getCallOptions = function() {
    return this.a;
};
function $bcd2671091eb623d$var$D(a, b, c, d) {
    c = void 0 === c ? {} : c;
    this.c = a;
    this.a = c;
    this.b = b;
    this.f = void 0 === d ? null : d;
}
$bcd2671091eb623d$var$D.prototype.getResponseMessage = function() {
    return this.c;
};
$bcd2671091eb623d$var$D.prototype.getMetadata = function() {
    return this.a;
};
$bcd2671091eb623d$var$D.prototype.getMethodDescriptor = function() {
    return this.b;
};
$bcd2671091eb623d$var$D.prototype.getStatus = function() {
    return this.f;
};
function $bcd2671091eb623d$var$ya(a, b, c, d, f, g) {
    this.name = a;
    this.a = f;
    this.b = g;
}
function $bcd2671091eb623d$var$za(a, b, c) {
    c = void 0 === c ? {} : c;
    var d = void 0 === d ? new $bcd2671091eb623d$var$xa : d;
    return new $bcd2671091eb623d$var$C(b, a, c, d);
}
$bcd2671091eb623d$var$ya.prototype.getName = function() {
    return this.name;
};
$bcd2671091eb623d$var$ya.prototype.getName = $bcd2671091eb623d$var$ya.prototype.getName;
function $bcd2671091eb623d$var$Aa(a) {
    switch(a){
        case 200:
            return 0;
        case 400:
            return 3;
        case 401:
            return 16;
        case 403:
            return 7;
        case 404:
            return 5;
        case 409:
            return 10;
        case 412:
            return 9;
        case 429:
            return 8;
        case 499:
            return 1;
        case 500:
            return 2;
        case 501:
            return 12;
        case 503:
            return 14;
        case 504:
            return 4;
        default:
            return 2;
    }
}
function $bcd2671091eb623d$var$Ba(a) {
    switch(a){
        case 0:
            return "OK";
        case 1:
            return "CANCELLED";
        case 2:
            return "UNKNOWN";
        case 3:
            return "INVALID_ARGUMENT";
        case 4:
            return "DEADLINE_EXCEEDED";
        case 5:
            return "NOT_FOUND";
        case 6:
            return "ALREADY_EXISTS";
        case 7:
            return "PERMISSION_DENIED";
        case 16:
            return "UNAUTHENTICATED";
        case 8:
            return "RESOURCE_EXHAUSTED";
        case 9:
            return "FAILED_PRECONDITION";
        case 10:
            return "ABORTED";
        case 11:
            return "OUT_OF_RANGE";
        case 12:
            return "UNIMPLEMENTED";
        case 13:
            return "INTERNAL";
        case 14:
            return "UNAVAILABLE";
        case 15:
            return "DATA_LOSS";
        default:
            return "";
    }
}
function $bcd2671091eb623d$var$E(a, b, c) {
    c = void 0 === c ? {} : c;
    b = Error.call(this, b);
    this.message = b.message;
    "stack" in b && (this.stack = b.stack);
    this.code = a;
    this.metadata = c;
}
$bcd2671091eb623d$var$oa($bcd2671091eb623d$var$E, Error);
$bcd2671091eb623d$var$E.prototype.toString = function() {
    var a = "RpcError(" + ($bcd2671091eb623d$var$Ba(this.code) || String(this.code)) + ")";
    this.message && (a += ": " + this.message);
    return a;
};
$bcd2671091eb623d$var$E.prototype.name = "RpcError";
function $bcd2671091eb623d$var$Ca(a) {
    this.a = a;
}
$bcd2671091eb623d$var$Ca.prototype.on = function(a, b) {
    return "data" == a || "error" == a ? this : this.a.on(a, b);
};
$bcd2671091eb623d$var$Ca.prototype.removeListener = function(a, b) {
    return this.a.removeListener(a, b);
};
$bcd2671091eb623d$var$Ca.prototype.cancel = function() {
    this.a.cancel();
};
function $bcd2671091eb623d$var$Da(a) {
    switch(a){
        case 0:
            return "No Error";
        case 1:
            return "Access denied to content document";
        case 2:
            return "File not found";
        case 3:
            return "Firefox silently errored";
        case 4:
            return "Application custom error";
        case 5:
            return "An exception occurred";
        case 6:
            return "Http response at 400 or 500 level";
        case 7:
            return "Request was aborted";
        case 8:
            return "Request timed out";
        case 9:
            return "The resource is not available offline";
        default:
            return "Unrecognized error code";
    }
}
function $bcd2671091eb623d$var$F(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, $bcd2671091eb623d$var$F);
    else {
        var b = Error().stack;
        b && (this.stack = b);
    }
    a && (this.message = String(a));
}
$bcd2671091eb623d$var$B($bcd2671091eb623d$var$F, Error);
$bcd2671091eb623d$var$F.prototype.name = "CustomError";
function $bcd2671091eb623d$var$Ea(a, b) {
    a = a.split("%s");
    for(var c = "", d = a.length - 1, f = 0; f < d; f++)c += a[f] + (f < b.length ? b[f] : "%s");
    $bcd2671091eb623d$var$F.call(this, c + a[d]);
}
$bcd2671091eb623d$var$B($bcd2671091eb623d$var$Ea, $bcd2671091eb623d$var$F);
$bcd2671091eb623d$var$Ea.prototype.name = "AssertionError";
function $bcd2671091eb623d$var$Fa(a, b) {
    throw new $bcd2671091eb623d$var$Ea("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
}
function $bcd2671091eb623d$var$Ga() {
    this.l = null;
    this.i = [];
    this.m = 0;
    this.b = $bcd2671091eb623d$var$Ha;
    this.f = this.a = this.h = 0;
    this.c = null;
    this.g = 0;
}
function $bcd2671091eb623d$var$Ia(a, b) {
    function c(l) {
        l == $bcd2671091eb623d$var$Ja ? e.h = l : l == $bcd2671091eb623d$var$G ? e.h = l : $bcd2671091eb623d$var$Ka(e, h, k, "invalid frame byte");
        e.b = $bcd2671091eb623d$var$La;
        e.a = 0;
        e.f = 0;
    }
    function d(l) {
        e.f++;
        e.a = (e.a << 8) + l;
        4 == e.f && (e.b = $bcd2671091eb623d$var$Ma, e.g = 0, "undefined" !== typeof Uint8Array ? e.c = new Uint8Array(e.a) : e.c = Array(e.a), 0 == e.a && g());
    }
    function f(l) {
        e.c[e.g++] = l;
        e.g == e.a && g();
    }
    function g() {
        var l = {};
        l[e.h] = e.c;
        e.i.push(l);
        e.b = $bcd2671091eb623d$var$Ha;
    }
    var e = a, h, k = 0;
    for(b instanceof Uint8Array || b instanceof Array ? h = b : h = new Uint8Array(b); k < h.length;){
        switch(e.b){
            case $bcd2671091eb623d$var$Na:
                $bcd2671091eb623d$var$Ka(e, h, k, "stream already broken");
                break;
            case $bcd2671091eb623d$var$Ha:
                c(h[k]);
                break;
            case $bcd2671091eb623d$var$La:
                d(h[k]);
                break;
            case $bcd2671091eb623d$var$Ma:
                f(h[k]);
                break;
            default:
                throw Error("unexpected parser state: " + e.b);
        }
        e.m++;
        k++;
    }
    a = e.i;
    e.i = [];
    return 0 < a.length ? a : null;
}
var $bcd2671091eb623d$var$Ha = 0, $bcd2671091eb623d$var$La = 1, $bcd2671091eb623d$var$Ma = 2, $bcd2671091eb623d$var$Na = 3, $bcd2671091eb623d$var$Ja = 0, $bcd2671091eb623d$var$G = 128;
function $bcd2671091eb623d$var$Ka(a, b, c, d) {
    a.b = $bcd2671091eb623d$var$Na;
    a.l = "The stream is broken @" + a.m + "/" + c + ". Error: " + d + ". With input:\n" + b;
    throw Error(a.l);
}
var $bcd2671091eb623d$var$Oa = Array.prototype.indexOf ? function(a, b) {
    return Array.prototype.indexOf.call(a, b, void 0);
} : function(a, b) {
    if ("string" === typeof a) return "string" !== typeof b || 1 != b.length ? -1 : a.indexOf(b, 0);
    for(var c = 0; c < a.length; c++)if (c in a && a[c] === b) return c;
    return -1;
};
var $bcd2671091eb623d$var$Pa = String.prototype.trim ? function(a) {
    return a.trim();
} : function(a) {
    return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(a)[1];
};
function $bcd2671091eb623d$var$H(a, b) {
    return -1 != a.indexOf(b);
}
function $bcd2671091eb623d$var$Qa(a, b) {
    return a < b ? -1 : a > b ? 1 : 0;
}
var $bcd2671091eb623d$var$I;
a: {
    var $bcd2671091eb623d$var$Ra = $bcd2671091eb623d$var$x.navigator;
    if ($bcd2671091eb623d$var$Ra) {
        var $bcd2671091eb623d$var$Sa = $bcd2671091eb623d$var$Ra.userAgent;
        if ($bcd2671091eb623d$var$Sa) {
            $bcd2671091eb623d$var$I = $bcd2671091eb623d$var$Sa;
            break a;
        }
    }
    $bcd2671091eb623d$var$I = "";
}
function $bcd2671091eb623d$var$Ta(a, b) {
    for(var c in a)b.call(void 0, a[c], c, a);
}
function $bcd2671091eb623d$var$Ua(a, b) {
    var c = {}, d;
    for(d in a)c[d] = b.call(void 0, a[d], d, a);
    return c;
}
var $bcd2671091eb623d$var$Va = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $bcd2671091eb623d$var$Wa(a, b) {
    for(var c, d, f = 1; f < arguments.length; f++){
        d = arguments[f];
        for(c in d)a[c] = d[c];
        for(var g = 0; g < $bcd2671091eb623d$var$Va.length; g++)c = $bcd2671091eb623d$var$Va[g], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
function $bcd2671091eb623d$var$Xa(a) {
    var b = 1;
    a = a.split(":");
    for(var c = []; 0 < b && a.length;)c.push(a.shift()), b--;
    a.length && c.push(a.join(":"));
    return c;
}
function $bcd2671091eb623d$var$Ya(a) {
    $bcd2671091eb623d$var$Ya[" "](a);
    return a;
}
$bcd2671091eb623d$var$Ya[" "] = $bcd2671091eb623d$var$ra;
function $bcd2671091eb623d$var$Za(a) {
    var b = $bcd2671091eb623d$var$$a;
    return Object.prototype.hasOwnProperty.call(b, 9) ? b[9] : b[9] = a(9);
}
var $bcd2671091eb623d$var$ab = $bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "Opera"), $bcd2671091eb623d$var$bb = $bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "Trident") || $bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "MSIE"), $bcd2671091eb623d$var$cb = $bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "Edge"), $bcd2671091eb623d$var$db = $bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "Gecko") && !($bcd2671091eb623d$var$H($bcd2671091eb623d$var$I.toLowerCase(), "webkit") && !$bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "Edge")) && !($bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "Trident") || $bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "MSIE")) && !$bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "Edge"), $bcd2671091eb623d$var$eb = $bcd2671091eb623d$var$H($bcd2671091eb623d$var$I.toLowerCase(), "webkit") && !$bcd2671091eb623d$var$H($bcd2671091eb623d$var$I, "Edge"), $bcd2671091eb623d$var$fb;
a: {
    var $bcd2671091eb623d$var$gb = "", $bcd2671091eb623d$var$hb = function() {
        var a = $bcd2671091eb623d$var$I;
        if ($bcd2671091eb623d$var$db) return /rv:([^\);]+)(\)|;)/.exec(a);
        if ($bcd2671091eb623d$var$cb) return /Edge\/([\d\.]+)/.exec(a);
        if ($bcd2671091eb623d$var$bb) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
        if ($bcd2671091eb623d$var$eb) return /WebKit\/(\S+)/.exec(a);
        if ($bcd2671091eb623d$var$ab) return /(?:Version)[ \/]?(\S+)/.exec(a);
    }();
    $bcd2671091eb623d$var$hb && ($bcd2671091eb623d$var$gb = $bcd2671091eb623d$var$hb ? $bcd2671091eb623d$var$hb[1] : "");
    if ($bcd2671091eb623d$var$bb) {
        var $bcd2671091eb623d$var$ib, $bcd2671091eb623d$var$jb = $bcd2671091eb623d$var$x.document;
        $bcd2671091eb623d$var$ib = $bcd2671091eb623d$var$jb ? $bcd2671091eb623d$var$jb.documentMode : void 0;
        if (null != $bcd2671091eb623d$var$ib && $bcd2671091eb623d$var$ib > parseFloat($bcd2671091eb623d$var$gb)) {
            $bcd2671091eb623d$var$fb = String($bcd2671091eb623d$var$ib);
            break a;
        }
    }
    $bcd2671091eb623d$var$fb = $bcd2671091eb623d$var$gb;
}
var $bcd2671091eb623d$var$$a = {};
function $bcd2671091eb623d$var$kb() {
    return $bcd2671091eb623d$var$Za(function() {
        for(var a = 0, b = $bcd2671091eb623d$var$Pa(String($bcd2671091eb623d$var$fb)).split("."), c = $bcd2671091eb623d$var$Pa("9").split("."), d = Math.max(b.length, c.length), f = 0; 0 == a && f < d; f++){
            var g = b[f] || "", e = c[f] || "";
            do {
                g = /(\d*)(\D*)(.*)/.exec(g) || [
                    "",
                    "",
                    "",
                    ""
                ];
                e = /(\d*)(\D*)(.*)/.exec(e) || [
                    "",
                    "",
                    "",
                    ""
                ];
                if (0 == g[0].length && 0 == e[0].length) break;
                a = $bcd2671091eb623d$var$Qa(0 == g[1].length ? 0 : parseInt(g[1], 10), 0 == e[1].length ? 0 : parseInt(e[1], 10)) || $bcd2671091eb623d$var$Qa(0 == g[2].length, 0 == e[2].length) || $bcd2671091eb623d$var$Qa(g[2], e[2]);
                g = g[3];
                e = e[3];
            }while (0 == a);
        }
        return 0 <= a;
    });
}
function $bcd2671091eb623d$var$lb() {
    0 != $bcd2671091eb623d$var$mb && (Object.prototype.hasOwnProperty.call(this, $bcd2671091eb623d$var$ta) && this[$bcd2671091eb623d$var$ta] || (this[$bcd2671091eb623d$var$ta] = ++$bcd2671091eb623d$var$ua));
    this.K = this.K;
}
var $bcd2671091eb623d$var$mb = 0;
$bcd2671091eb623d$var$lb.prototype.K = !1;
var $bcd2671091eb623d$var$nb = Object.freeze || function(a) {
    return a;
};
function $bcd2671091eb623d$var$J(a, b) {
    this.type = a;
    this.a = this.target = b;
    this.defaultPrevented = !1;
}
$bcd2671091eb623d$var$J.prototype.b = function() {
    this.defaultPrevented = !0;
};
var $bcd2671091eb623d$var$ob = function() {
    if (!$bcd2671091eb623d$var$x.addEventListener || !Object.defineProperty) return !1;
    var a = !1, b = Object.defineProperty({}, "passive", {
        get: function() {
            a = !0;
        }
    });
    try {
        $bcd2671091eb623d$var$x.addEventListener("test", $bcd2671091eb623d$var$ra, b), $bcd2671091eb623d$var$x.removeEventListener("test", $bcd2671091eb623d$var$ra, b);
    } catch (c) {}
    return a;
}();
function $bcd2671091eb623d$var$K(a, b) {
    $bcd2671091eb623d$var$J.call(this, a ? a.type : "");
    this.relatedTarget = this.a = this.target = null;
    this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
    this.key = "";
    this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
    this.pointerId = 0;
    this.pointerType = "";
    this.c = null;
    if (a) {
        var c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.a = b;
        if (b = a.relatedTarget) {
            if ($bcd2671091eb623d$var$db) {
                a: {
                    try {
                        $bcd2671091eb623d$var$Ya(b.nodeName);
                        var f = !0;
                        break a;
                    } catch (g) {}
                    f = !1;
                }
                f || (b = null);
            }
        } else "mouseover" == c ? b = a.fromElement : "mouseout" == c && (b = a.toElement);
        this.relatedTarget = b;
        d ? (this.clientX = void 0 !== d.clientX ? d.clientX : d.pageX, this.clientY = void 0 !== d.clientY ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = "string" === typeof a.pointerType ? a.pointerType : $bcd2671091eb623d$var$pb[a.pointerType] || "";
        this.c = a;
        a.defaultPrevented && $bcd2671091eb623d$var$K.O.b.call(this);
    }
}
$bcd2671091eb623d$var$B($bcd2671091eb623d$var$K, $bcd2671091eb623d$var$J);
var $bcd2671091eb623d$var$pb = $bcd2671091eb623d$var$nb({
    2: "touch",
    3: "pen",
    4: "mouse"
});
$bcd2671091eb623d$var$K.prototype.b = function() {
    $bcd2671091eb623d$var$K.O.b.call(this);
    var a = this.c;
    a.preventDefault ? a.preventDefault() : a.returnValue = !1;
};
var $bcd2671091eb623d$var$M = "closure_listenable_" + (1E6 * Math.random() | 0);
var $bcd2671091eb623d$var$qb = 0;
function $bcd2671091eb623d$var$rb(a, b, c, d, f) {
    this.listener = a;
    this.proxy = null;
    this.src = b;
    this.type = c;
    this.capture = !!d;
    this.H = f;
    this.key = ++$bcd2671091eb623d$var$qb;
    this.A = this.D = !1;
}
function $bcd2671091eb623d$var$sb(a) {
    a.A = !0;
    a.listener = null;
    a.proxy = null;
    a.src = null;
    a.H = null;
}
function $bcd2671091eb623d$var$tb(a) {
    this.src = a;
    this.a = {};
    this.b = 0;
}
$bcd2671091eb623d$var$tb.prototype.add = function(a, b, c, d, f) {
    var g = a.toString();
    a = this.a[g];
    a || (a = this.a[g] = [], this.b++);
    var e = $bcd2671091eb623d$var$ub(a, b, d, f);
    -1 < e ? (b = a[e], c || (b.D = !1)) : (b = new $bcd2671091eb623d$var$rb(b, this.src, g, !!d, f), b.D = c, a.push(b));
    return b;
};
$bcd2671091eb623d$var$tb.prototype.remove = function(a, b, c, d) {
    a = a.toString();
    if (!(a in this.a)) return !1;
    var f = this.a[a];
    b = $bcd2671091eb623d$var$ub(f, b, c, d);
    return -1 < b ? ($bcd2671091eb623d$var$sb(f[b]), Array.prototype.splice.call(f, b, 1), 0 == f.length && (delete this.a[a], this.b--), !0) : !1;
};
function $bcd2671091eb623d$var$vb(a, b) {
    var c = b.type;
    if (c in a.a) {
        var d = a.a[c], f = $bcd2671091eb623d$var$Oa(d, b), g;
        (g = 0 <= f) && Array.prototype.splice.call(d, f, 1);
        g && ($bcd2671091eb623d$var$sb(b), 0 == a.a[c].length && (delete a.a[c], a.b--));
    }
}
function $bcd2671091eb623d$var$ub(a, b, c, d) {
    for(var f = 0; f < a.length; ++f){
        var g = a[f];
        if (!g.A && g.listener == b && g.capture == !!c && g.H == d) return f;
    }
    return -1;
}
var $bcd2671091eb623d$var$wb = "closure_lm_" + (1E6 * Math.random() | 0), $bcd2671091eb623d$var$xb = {}, $bcd2671091eb623d$var$yb = 0;
function $bcd2671091eb623d$var$zb(a, b, c, d, f) {
    if (d && d.once) $bcd2671091eb623d$var$Ab(a, b, c, d, f);
    else if (Array.isArray(b)) for(var g = 0; g < b.length; g++)$bcd2671091eb623d$var$zb(a, b[g], c, d, f);
    else c = $bcd2671091eb623d$var$Bb(c), a && a[$bcd2671091eb623d$var$M] ? a.f.add(String(b), c, !1, $bcd2671091eb623d$var$sa(d) ? !!d.capture : !!d, f) : $bcd2671091eb623d$var$Cb(a, b, c, !1, d, f);
}
function $bcd2671091eb623d$var$Cb(a, b, c, d, f, g) {
    if (!b) throw Error("Invalid event type");
    var e = $bcd2671091eb623d$var$sa(f) ? !!f.capture : !!f, h = $bcd2671091eb623d$var$Db(a);
    h || (a[$bcd2671091eb623d$var$wb] = h = new $bcd2671091eb623d$var$tb(a));
    c = h.add(b, c, d, e, g);
    if (!c.proxy) {
        d = $bcd2671091eb623d$var$Eb();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) $bcd2671091eb623d$var$ob || (f = e), void 0 === f && (f = !1), a.addEventListener(b.toString(), d, f);
        else if (a.attachEvent) a.attachEvent($bcd2671091eb623d$var$Fb(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        $bcd2671091eb623d$var$yb++;
    }
}
function $bcd2671091eb623d$var$Eb() {
    function a(c) {
        return b.call(a.src, a.listener, c);
    }
    var b = $bcd2671091eb623d$var$Gb;
    return a;
}
function $bcd2671091eb623d$var$Ab(a, b, c, d, f) {
    if (Array.isArray(b)) for(var g = 0; g < b.length; g++)$bcd2671091eb623d$var$Ab(a, b[g], c, d, f);
    else c = $bcd2671091eb623d$var$Bb(c), a && a[$bcd2671091eb623d$var$M] ? a.f.add(String(b), c, !0, $bcd2671091eb623d$var$sa(d) ? !!d.capture : !!d, f) : $bcd2671091eb623d$var$Cb(a, b, c, !0, d, f);
}
function $bcd2671091eb623d$var$Hb(a, b, c, d, f) {
    if (Array.isArray(b)) for(var g = 0; g < b.length; g++)$bcd2671091eb623d$var$Hb(a, b[g], c, d, f);
    else (d = $bcd2671091eb623d$var$sa(d) ? !!d.capture : !!d, c = $bcd2671091eb623d$var$Bb(c), a && a[$bcd2671091eb623d$var$M]) ? a.f.remove(String(b), c, d, f) : a && (a = $bcd2671091eb623d$var$Db(a)) && (b = a.a[b.toString()], a = -1, b && (a = $bcd2671091eb623d$var$ub(b, c, d, f)), (c = -1 < a ? b[a] : null) && $bcd2671091eb623d$var$Ib(c));
}
function $bcd2671091eb623d$var$Ib(a) {
    if ("number" !== typeof a && a && !a.A) {
        var b = a.src;
        if (b && b[$bcd2671091eb623d$var$M]) $bcd2671091eb623d$var$vb(b.f, a);
        else {
            var c = a.type, d = a.proxy;
            b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent($bcd2671091eb623d$var$Fb(c), d) : b.addListener && b.removeListener && b.removeListener(d);
            $bcd2671091eb623d$var$yb--;
            (c = $bcd2671091eb623d$var$Db(b)) ? ($bcd2671091eb623d$var$vb(c, a), 0 == c.b && (c.src = null, b[$bcd2671091eb623d$var$wb] = null)) : $bcd2671091eb623d$var$sb(a);
        }
    }
}
function $bcd2671091eb623d$var$Fb(a) {
    return a in $bcd2671091eb623d$var$xb ? $bcd2671091eb623d$var$xb[a] : $bcd2671091eb623d$var$xb[a] = "on" + a;
}
function $bcd2671091eb623d$var$Gb(a, b) {
    if (a.A) a = !0;
    else {
        b = new $bcd2671091eb623d$var$K(b, this);
        var c = a.listener, d = a.H || a.src;
        a.D && $bcd2671091eb623d$var$Ib(a);
        a = c.call(d, b);
    }
    return a;
}
function $bcd2671091eb623d$var$Db(a) {
    a = a[$bcd2671091eb623d$var$wb];
    return a instanceof $bcd2671091eb623d$var$tb ? a : null;
}
var $bcd2671091eb623d$var$Jb = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);
function $bcd2671091eb623d$var$Bb(a) {
    if ("function" === typeof a) return a;
    a[$bcd2671091eb623d$var$Jb] || (a[$bcd2671091eb623d$var$Jb] = function(b) {
        return a.handleEvent(b);
    });
    return a[$bcd2671091eb623d$var$Jb];
}
function $bcd2671091eb623d$var$N() {
    $bcd2671091eb623d$var$lb.call(this);
    this.f = new $bcd2671091eb623d$var$tb(this);
    this.U = this;
}
$bcd2671091eb623d$var$B($bcd2671091eb623d$var$N, $bcd2671091eb623d$var$lb);
$bcd2671091eb623d$var$N.prototype[$bcd2671091eb623d$var$M] = !0;
$bcd2671091eb623d$var$N.prototype.addEventListener = function(a, b, c, d) {
    $bcd2671091eb623d$var$zb(this, a, b, c, d);
};
$bcd2671091eb623d$var$N.prototype.removeEventListener = function(a, b, c, d) {
    $bcd2671091eb623d$var$Hb(this, a, b, c, d);
};
function $bcd2671091eb623d$var$O(a, b) {
    a = a.U;
    var c = b.type || b;
    if ("string" === typeof b) b = new $bcd2671091eb623d$var$J(b, a);
    else if (b instanceof $bcd2671091eb623d$var$J) b.target = b.target || a;
    else {
        var d = b;
        b = new $bcd2671091eb623d$var$J(c, a);
        $bcd2671091eb623d$var$Wa(b, d);
    }
    a = b.a = a;
    $bcd2671091eb623d$var$Kb(a, c, !0, b);
    $bcd2671091eb623d$var$Kb(a, c, !1, b);
}
function $bcd2671091eb623d$var$Kb(a, b, c, d) {
    if (b = a.f.a[String(b)]) {
        b = b.concat();
        for(var f = !0, g = 0; g < b.length; ++g){
            var e = b[g];
            if (e && !e.A && e.capture == c) {
                var h = e.listener, k = e.H || e.src;
                e.D && $bcd2671091eb623d$var$vb(a.f, e);
                f = !1 !== h.call(k, d) && f;
            }
        }
    }
}
var $bcd2671091eb623d$var$Lb = $bcd2671091eb623d$var$x;
function $bcd2671091eb623d$var$Mb(a, b, c) {
    if ("function" === typeof a) c && (a = $bcd2671091eb623d$var$z(a, c));
    else if (a && "function" == typeof a.handleEvent) a = $bcd2671091eb623d$var$z(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    return 2147483647 < Number(b) ? -1 : $bcd2671091eb623d$var$Lb.setTimeout(a, b || 0);
}
function $bcd2671091eb623d$var$Nb(a, b) {
    this.name = a;
    this.value = b;
}
$bcd2671091eb623d$var$Nb.prototype.toString = function() {
    return this.name;
};
var $bcd2671091eb623d$var$Ob = new $bcd2671091eb623d$var$Nb("OFF", Infinity), $bcd2671091eb623d$var$Pb = new $bcd2671091eb623d$var$Nb("SEVERE", 1E3), $bcd2671091eb623d$var$Qb = new $bcd2671091eb623d$var$Nb("CONFIG", 700), $bcd2671091eb623d$var$Rb = new $bcd2671091eb623d$var$Nb("FINE", 500);
function $bcd2671091eb623d$var$Tb() {
    this.clear();
}
var $bcd2671091eb623d$var$Ub;
$bcd2671091eb623d$var$Tb.prototype.clear = function() {};
function $bcd2671091eb623d$var$Vb(a, b, c) {
    this.reset(a || $bcd2671091eb623d$var$Ob, b, c, void 0, void 0);
}
$bcd2671091eb623d$var$Vb.prototype.reset = function() {};
function $bcd2671091eb623d$var$Wb(a, b) {
    this.a = null;
    this.f = [];
    this.b = (void 0 === b ? null : b) || null;
    this.c = [];
    this.g = {
        getName: function() {
            return a;
        }
    };
}
function $bcd2671091eb623d$var$Xb(a) {
    if (a.a) return a.a;
    if (a.b) return $bcd2671091eb623d$var$Xb(a.b);
    $bcd2671091eb623d$var$Fa("Root logger has no level set.");
    return $bcd2671091eb623d$var$Ob;
}
function $bcd2671091eb623d$var$Yb(a, b) {
    for(; a;)a.f.forEach(function(c) {
        c(b);
    }), a = a.b;
}
function $bcd2671091eb623d$var$Zb() {
    this.entries = {};
    var a = new $bcd2671091eb623d$var$Wb("");
    a.a = $bcd2671091eb623d$var$Qb;
    this.entries[""] = a;
}
var $bcd2671091eb623d$var$$b;
function $bcd2671091eb623d$var$ac(a, b, c) {
    var d = a.entries[b];
    if (d) return void 0 !== c && (d.a = c), d;
    d = $bcd2671091eb623d$var$ac(a, b.substr(0, b.lastIndexOf(".")));
    var f = new $bcd2671091eb623d$var$Wb(b, d);
    a.entries[b] = f;
    d.c.push(f);
    void 0 !== c && (f.a = c);
    return f;
}
function $bcd2671091eb623d$var$bc() {
    $bcd2671091eb623d$var$$b || ($bcd2671091eb623d$var$$b = new $bcd2671091eb623d$var$Zb);
    return $bcd2671091eb623d$var$$b;
}
function $bcd2671091eb623d$var$cc(a, b, c) {
    var d;
    if (d = a) {
        if (d = a && b) {
            d = b.value;
            var f = a ? $bcd2671091eb623d$var$Xb($bcd2671091eb623d$var$ac($bcd2671091eb623d$var$bc(), a.getName())) : $bcd2671091eb623d$var$Ob;
            d = d >= f.value;
        }
    }
    d && (b = b || $bcd2671091eb623d$var$Ob, d = $bcd2671091eb623d$var$ac($bcd2671091eb623d$var$bc(), a.getName()), "function" === typeof c && (c = c()), $bcd2671091eb623d$var$Ub || ($bcd2671091eb623d$var$Ub = new $bcd2671091eb623d$var$Tb), a = a.getName(), a = new $bcd2671091eb623d$var$Vb(b, c, a), $bcd2671091eb623d$var$Yb(d, a));
}
function $bcd2671091eb623d$var$P(a, b) {
    a && $bcd2671091eb623d$var$cc(a, $bcd2671091eb623d$var$Rb, b);
}
function $bcd2671091eb623d$var$dc() {}
$bcd2671091eb623d$var$dc.prototype.a = null;
function $bcd2671091eb623d$var$ec(a) {
    var b;
    (b = a.a) || (b = {}, $bcd2671091eb623d$var$fc(a) && (b[0] = !0, b[1] = !0), b = a.a = b);
    return b;
}
var $bcd2671091eb623d$var$gc;
function $bcd2671091eb623d$var$hc() {}
$bcd2671091eb623d$var$B($bcd2671091eb623d$var$hc, $bcd2671091eb623d$var$dc);
function $bcd2671091eb623d$var$ic(a) {
    return (a = $bcd2671091eb623d$var$fc(a)) ? new ActiveXObject(a) : new XMLHttpRequest;
}
function $bcd2671091eb623d$var$fc(a) {
    if (!a.b && "undefined" == typeof XMLHttpRequest && "undefined" != typeof ActiveXObject) {
        for(var b = [
            "MSXML2.XMLHTTP.6.0",
            "MSXML2.XMLHTTP.3.0",
            "MSXML2.XMLHTTP",
            "Microsoft.XMLHTTP"
        ], c = 0; c < b.length; c++){
            var d = b[c];
            try {
                return new ActiveXObject(d), a.b = d;
            } catch (f) {}
        }
        throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");
    }
    return a.b;
}
$bcd2671091eb623d$var$gc = new $bcd2671091eb623d$var$hc;
$bcd2671091eb623d$var$t();
$bcd2671091eb623d$var$u();
function $bcd2671091eb623d$var$jc(a, b) {
    this.b = a[$bcd2671091eb623d$var$x.Symbol.iterator]();
    this.c = b;
    this.f = 0;
}
$bcd2671091eb623d$var$jc.prototype[Symbol.iterator] = function() {
    return this;
};
$bcd2671091eb623d$var$jc.prototype.next = function() {
    var a = this.b.next();
    return {
        value: a.done ? void 0 : this.c.call(void 0, a.value, this.f++),
        done: a.done
    };
};
function $bcd2671091eb623d$var$kc(a, b) {
    return new $bcd2671091eb623d$var$jc(a, b);
}
$bcd2671091eb623d$var$t();
$bcd2671091eb623d$var$u();
$bcd2671091eb623d$var$t();
$bcd2671091eb623d$var$u();
var $bcd2671091eb623d$var$lc = "StopIteration" in $bcd2671091eb623d$var$x ? $bcd2671091eb623d$var$x.StopIteration : {
    message: "StopIteration",
    stack: ""
};
function $bcd2671091eb623d$var$Q() {}
$bcd2671091eb623d$var$Q.prototype.next = function() {
    return $bcd2671091eb623d$var$Q.prototype.a.call(this);
};
$bcd2671091eb623d$var$Q.prototype.a = function() {
    throw $bcd2671091eb623d$var$lc;
};
$bcd2671091eb623d$var$Q.prototype.u = function() {
    return this;
};
function $bcd2671091eb623d$var$mc(a) {
    if (a instanceof $bcd2671091eb623d$var$R || a instanceof $bcd2671091eb623d$var$S || a instanceof $bcd2671091eb623d$var$T) return a;
    if ("function" == typeof a.next) return new $bcd2671091eb623d$var$R(function() {
        return $bcd2671091eb623d$var$nc(a);
    });
    $bcd2671091eb623d$var$t();
    $bcd2671091eb623d$var$u();
    if ("function" == typeof a[Symbol.iterator]) return $bcd2671091eb623d$var$t(), $bcd2671091eb623d$var$u(), new $bcd2671091eb623d$var$R(function() {
        return a[Symbol.iterator]();
    });
    if ("function" == typeof a.u) return new $bcd2671091eb623d$var$R(function() {
        return $bcd2671091eb623d$var$nc(a.u());
    });
    throw Error("Not an iterator or iterable.");
}
function $bcd2671091eb623d$var$nc(a) {
    if (!(a instanceof $bcd2671091eb623d$var$Q)) return a;
    var b = !1;
    return {
        next: function() {
            for(var c; !b;)try {
                c = a.a();
                break;
            } catch (d) {
                if (d !== $bcd2671091eb623d$var$lc) throw d;
                b = !0;
            }
            return {
                value: c,
                done: b
            };
        }
    };
}
$bcd2671091eb623d$var$t();
$bcd2671091eb623d$var$u();
function $bcd2671091eb623d$var$R(a) {
    this.b = a;
}
$bcd2671091eb623d$var$R.prototype.u = function() {
    return new $bcd2671091eb623d$var$S(this.b());
};
$bcd2671091eb623d$var$R.prototype[Symbol.iterator] = function() {
    return new $bcd2671091eb623d$var$T(this.b());
};
$bcd2671091eb623d$var$R.prototype.c = function() {
    return new $bcd2671091eb623d$var$T(this.b());
};
$bcd2671091eb623d$var$t();
$bcd2671091eb623d$var$u();
function $bcd2671091eb623d$var$S(a) {
    this.b = a;
}
$bcd2671091eb623d$var$oa($bcd2671091eb623d$var$S, $bcd2671091eb623d$var$Q);
$bcd2671091eb623d$var$S.prototype.a = function() {
    var a = this.b.next();
    if (a.done) throw $bcd2671091eb623d$var$lc;
    return a.value;
};
$bcd2671091eb623d$var$S.prototype.next = function() {
    return $bcd2671091eb623d$var$S.prototype.a.call(this);
};
$bcd2671091eb623d$var$S.prototype[Symbol.iterator] = function() {
    return new $bcd2671091eb623d$var$T(this.b);
};
$bcd2671091eb623d$var$S.prototype.c = function() {
    return new $bcd2671091eb623d$var$T(this.b);
};
function $bcd2671091eb623d$var$T(a) {
    $bcd2671091eb623d$var$R.call(this, function() {
        return a;
    });
    this.f = a;
}
$bcd2671091eb623d$var$oa($bcd2671091eb623d$var$T, $bcd2671091eb623d$var$R);
$bcd2671091eb623d$var$T.prototype.next = function() {
    return this.f.next();
};
function $bcd2671091eb623d$var$oc(a, b) {
    this.o = {};
    this.j = [];
    this.B = this.size = 0;
    var c = arguments.length;
    if (1 < c) {
        if (c % 2) throw Error("Uneven number of arguments");
        for(var d = 0; d < c; d += 2)this.set(arguments[d], arguments[d + 1]);
    } else a && this.addAll(a);
}
$bcd2671091eb623d$var$n = $bcd2671091eb623d$var$oc.prototype;
$bcd2671091eb623d$var$n.G = function() {
    $bcd2671091eb623d$var$pc(this);
    return this.j.concat();
};
$bcd2671091eb623d$var$n.has = function(a) {
    return $bcd2671091eb623d$var$U(this.o, a);
};
$bcd2671091eb623d$var$n.clear = function() {
    this.o = {};
    this.B = this.size = this.j.length = 0;
};
$bcd2671091eb623d$var$n.remove = function(a) {
    return this.delete(a);
};
$bcd2671091eb623d$var$n.delete = function(a) {
    return $bcd2671091eb623d$var$U(this.o, a) ? (delete this.o[a], --this.size, this.B++, this.j.length > 2 * this.size && $bcd2671091eb623d$var$pc(this), !0) : !1;
};
function $bcd2671091eb623d$var$pc(a) {
    if (a.size != a.j.length) {
        for(var b = 0, c = 0; b < a.j.length;){
            var d = a.j[b];
            $bcd2671091eb623d$var$U(a.o, d) && (a.j[c++] = d);
            b++;
        }
        a.j.length = c;
    }
    if (a.size != a.j.length) {
        var f = {};
        for(c = b = 0; b < a.j.length;)d = a.j[b], $bcd2671091eb623d$var$U(f, d) || (a.j[c++] = d, f[d] = 1), b++;
        a.j.length = c;
    }
}
$bcd2671091eb623d$var$n.get = function(a, b) {
    return $bcd2671091eb623d$var$U(this.o, a) ? this.o[a] : b;
};
$bcd2671091eb623d$var$n.set = function(a, b) {
    $bcd2671091eb623d$var$U(this.o, a) || (this.size += 1, this.j.push(a), this.B++);
    this.o[a] = b;
};
$bcd2671091eb623d$var$n.addAll = function(a) {
    if (a instanceof $bcd2671091eb623d$var$oc) for(var b = a.G(), c = 0; c < b.length; c++)this.set(b[c], a.get(b[c]));
    else for(b in a)this.set(b, a[b]);
};
$bcd2671091eb623d$var$n.forEach = function(a, b) {
    for(var c = this.G(), d = 0; d < c.length; d++){
        var f = c[d], g = this.get(f);
        a.call(b, g, f, this);
    }
};
$bcd2671091eb623d$var$n.clone = function() {
    return new $bcd2671091eb623d$var$oc(this);
};
$bcd2671091eb623d$var$n.keys = function() {
    return $bcd2671091eb623d$var$mc(this.u(!0)).c();
};
$bcd2671091eb623d$var$n.values = function() {
    return $bcd2671091eb623d$var$mc(this.u(!1)).c();
};
$bcd2671091eb623d$var$n.entries = function() {
    var a = this;
    return $bcd2671091eb623d$var$kc(this.keys(), function(b) {
        return [
            b,
            a.get(b)
        ];
    });
};
$bcd2671091eb623d$var$n.u = function(a) {
    $bcd2671091eb623d$var$pc(this);
    var b = 0, c = this.B, d = this, f = new $bcd2671091eb623d$var$Q;
    f.a = function() {
        if (c != d.B) throw Error("The map has changed since the iterator was created");
        if (b >= d.j.length) throw $bcd2671091eb623d$var$lc;
        var g = d.j[b++];
        return a ? g : d.o[g];
    };
    f.next = f.a.bind(f);
    return f;
};
function $bcd2671091eb623d$var$U(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
}
var $bcd2671091eb623d$var$qc = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^\\/?#]*)@)?([^\\/?#]*?)(?::([0-9]+))?(?=[\\/?#]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;
function $bcd2671091eb623d$var$rc(a) {
    $bcd2671091eb623d$var$N.call(this);
    this.headers = new $bcd2671091eb623d$var$oc;
    this.C = a || null;
    this.c = !1;
    this.J = this.a = null;
    this.P = this.v = "";
    this.g = 0;
    this.l = "";
    this.i = this.N = this.s = this.L = !1;
    this.h = 0;
    this.w = null;
    this.m = $bcd2671091eb623d$var$sc;
    this.I = this.M = !1;
}
$bcd2671091eb623d$var$B($bcd2671091eb623d$var$rc, $bcd2671091eb623d$var$N);
var $bcd2671091eb623d$var$sc = "";
$bcd2671091eb623d$var$rc.prototype.b = $bcd2671091eb623d$var$ac($bcd2671091eb623d$var$bc(), "goog.net.XhrIo", void 0).g;
var $bcd2671091eb623d$var$tc = /^https?$/i, $bcd2671091eb623d$var$uc = [
    "POST",
    "PUT"
];
function $bcd2671091eb623d$var$vc(a, b, c) {
    if (a.a) throw Error("[goog.net.XhrIo] Object is active with another request=" + a.v + "; newUri=" + b);
    a.v = b;
    a.l = "";
    a.g = 0;
    a.P = "POST";
    a.L = !1;
    a.c = !0;
    a.a = a.C ? $bcd2671091eb623d$var$ic(a.C) : $bcd2671091eb623d$var$ic($bcd2671091eb623d$var$gc);
    a.J = a.C ? $bcd2671091eb623d$var$ec(a.C) : $bcd2671091eb623d$var$ec($bcd2671091eb623d$var$gc);
    a.a.onreadystatechange = $bcd2671091eb623d$var$z(a.R, a);
    try {
        $bcd2671091eb623d$var$P(a.b, $bcd2671091eb623d$var$V(a, "Opening Xhr")), a.N = !0, a.a.open("POST", String(b), !0), a.N = !1;
    } catch (g) {
        $bcd2671091eb623d$var$P(a.b, $bcd2671091eb623d$var$V(a, "Error opening Xhr: " + g.message));
        $bcd2671091eb623d$var$wc(a, g);
        return;
    }
    b = c || "";
    c = a.headers.clone();
    var d = c.G().find(function(g) {
        return "content-type" == g.toLowerCase();
    }), f = $bcd2671091eb623d$var$x.FormData && b instanceof $bcd2671091eb623d$var$x.FormData;
    !(0 <= $bcd2671091eb623d$var$Oa($bcd2671091eb623d$var$uc, "POST")) || d || f || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
    c.forEach(function(g, e) {
        this.a.setRequestHeader(e, g);
    }, a);
    a.m && (a.a.responseType = a.m);
    "withCredentials" in a.a && a.a.withCredentials !== a.M && (a.a.withCredentials = a.M);
    try {
        $bcd2671091eb623d$var$xc(a), 0 < a.h && (a.I = $bcd2671091eb623d$var$yc(a.a), $bcd2671091eb623d$var$P(a.b, $bcd2671091eb623d$var$V(a, "Will abort after " + a.h + "ms if incomplete, xhr2 " + a.I)), a.I ? (a.a.timeout = a.h, a.a.ontimeout = $bcd2671091eb623d$var$z(a.T, a)) : a.w = $bcd2671091eb623d$var$Mb(a.T, a.h, a)), $bcd2671091eb623d$var$P(a.b, $bcd2671091eb623d$var$V(a, "Sending request")), a.s = !0, a.a.send(b), a.s = !1;
    } catch (g) {
        $bcd2671091eb623d$var$P(a.b, $bcd2671091eb623d$var$V(a, "Send error: " + g.message)), $bcd2671091eb623d$var$wc(a, g);
    }
}
function $bcd2671091eb623d$var$yc(a) {
    return $bcd2671091eb623d$var$bb && $bcd2671091eb623d$var$kb() && "number" === typeof a.timeout && void 0 !== a.ontimeout;
}
$bcd2671091eb623d$var$n = $bcd2671091eb623d$var$rc.prototype;
$bcd2671091eb623d$var$n.T = function() {
    "undefined" != typeof $bcd2671091eb623d$var$qa && this.a && (this.l = "Timed out after " + this.h + "ms, aborting", this.g = 8, $bcd2671091eb623d$var$P(this.b, $bcd2671091eb623d$var$V(this, this.l)), $bcd2671091eb623d$var$O(this, "timeout"), this.abort(8));
};
function $bcd2671091eb623d$var$wc(a, b) {
    a.c = !1;
    a.a && (a.i = !0, a.a.abort(), a.i = !1);
    a.l = b;
    a.g = 5;
    $bcd2671091eb623d$var$zc(a);
    $bcd2671091eb623d$var$Ac(a);
}
function $bcd2671091eb623d$var$zc(a) {
    a.L || (a.L = !0, $bcd2671091eb623d$var$O(a, "complete"), $bcd2671091eb623d$var$O(a, "error"));
}
$bcd2671091eb623d$var$n.abort = function(a) {
    this.a && this.c && ($bcd2671091eb623d$var$P(this.b, $bcd2671091eb623d$var$V(this, "Aborting")), this.c = !1, this.i = !0, this.a.abort(), this.i = !1, this.g = a || 7, $bcd2671091eb623d$var$O(this, "complete"), $bcd2671091eb623d$var$O(this, "abort"), $bcd2671091eb623d$var$Ac(this));
};
$bcd2671091eb623d$var$n.R = function() {
    this.K || (this.N || this.s || this.i ? $bcd2671091eb623d$var$Bc(this) : this.W());
};
$bcd2671091eb623d$var$n.W = function() {
    $bcd2671091eb623d$var$Bc(this);
};
function $bcd2671091eb623d$var$Bc(a) {
    if (a.c && "undefined" != typeof $bcd2671091eb623d$var$qa) {
        if (a.J[1] && 4 == $bcd2671091eb623d$var$W(a) && 2 == a.getStatus()) $bcd2671091eb623d$var$P(a.b, $bcd2671091eb623d$var$V(a, "Local request error detected and ignored"));
        else if (a.s && 4 == $bcd2671091eb623d$var$W(a)) $bcd2671091eb623d$var$Mb(a.R, 0, a);
        else if ($bcd2671091eb623d$var$O(a, "readystatechange"), 4 == $bcd2671091eb623d$var$W(a)) {
            $bcd2671091eb623d$var$P(a.b, $bcd2671091eb623d$var$V(a, "Request complete"));
            a.c = !1;
            try {
                var b = a.getStatus();
                a: switch(b){
                    case 200:
                    case 201:
                    case 202:
                    case 204:
                    case 206:
                    case 304:
                    case 1223:
                        var c = !0;
                        break a;
                    default:
                        c = !1;
                }
                var d;
                if (!(d = c)) {
                    var f;
                    if (f = 0 === b) {
                        var g = String(a.v).match($bcd2671091eb623d$var$qc)[1] || null;
                        if (!g && $bcd2671091eb623d$var$x.self && $bcd2671091eb623d$var$x.self.location) {
                            var e = $bcd2671091eb623d$var$x.self.location.protocol;
                            g = e.substr(0, e.length - 1);
                        }
                        f = !$bcd2671091eb623d$var$tc.test(g ? g.toLowerCase() : "");
                    }
                    d = f;
                }
                if (d) $bcd2671091eb623d$var$O(a, "complete"), $bcd2671091eb623d$var$O(a, "success");
                else {
                    a.g = 6;
                    try {
                        var h = 2 < $bcd2671091eb623d$var$W(a) ? a.a.statusText : "";
                    } catch (k) {
                        $bcd2671091eb623d$var$P(a.b, "Can not get status: " + k.message), h = "";
                    }
                    a.l = h + " [" + a.getStatus() + "]";
                    $bcd2671091eb623d$var$zc(a);
                }
            } finally{
                $bcd2671091eb623d$var$Ac(a);
            }
        }
    }
}
function $bcd2671091eb623d$var$Ac(a) {
    if (a.a) {
        $bcd2671091eb623d$var$xc(a);
        var b = a.a, c = a.J[0] ? $bcd2671091eb623d$var$ra : null;
        a.a = null;
        a.J = null;
        $bcd2671091eb623d$var$O(a, "ready");
        try {
            b.onreadystatechange = c;
        } catch (d) {
            (a = a.b) && $bcd2671091eb623d$var$cc(a, $bcd2671091eb623d$var$Pb, "Problem encountered resetting onreadystatechange: " + d.message);
        }
    }
}
function $bcd2671091eb623d$var$xc(a) {
    a.a && a.I && (a.a.ontimeout = null);
    a.w && ($bcd2671091eb623d$var$Lb.clearTimeout(a.w), a.w = null);
}
function $bcd2671091eb623d$var$W(a) {
    return a.a ? a.a.readyState : 0;
}
$bcd2671091eb623d$var$n.getStatus = function() {
    try {
        return 2 < $bcd2671091eb623d$var$W(this) ? this.a.status : -1;
    } catch (a) {
        return -1;
    }
};
function $bcd2671091eb623d$var$Cc(a) {
    try {
        if (!a.a) return null;
        if ("response" in a.a) return a.a.response;
        switch(a.m){
            case $bcd2671091eb623d$var$sc:
            case "text":
                return a.a.responseText;
            case "arraybuffer":
                if ("mozResponseArrayBuffer" in a.a) return a.a.mozResponseArrayBuffer;
        }
        var b = a.b;
        b && $bcd2671091eb623d$var$cc(b, $bcd2671091eb623d$var$Pb, "Response type " + a.m + " is not supported on this browser");
        return null;
    } catch (c) {
        return $bcd2671091eb623d$var$P(a.b, "Can not get response: " + c.message), null;
    }
}
function $bcd2671091eb623d$var$Dc(a) {
    var b = {};
    a = (a.a && 4 == $bcd2671091eb623d$var$W(a) ? a.a.getAllResponseHeaders() || "" : "").split("\r\n");
    for(var c = 0; c < a.length; c++)if (!/^[\s\xa0]*$/.test(a[c])) {
        var d = $bcd2671091eb623d$var$Xa(a[c]), f = d[0];
        d = d[1];
        if ("string" === typeof d) {
            d = d.trim();
            var g = b[f] || [];
            b[f] = g;
            g.push(d);
        }
    }
    return $bcd2671091eb623d$var$Ua(b, function(e) {
        return e.join(", ");
    });
}
function $bcd2671091eb623d$var$V(a, b) {
    return b + " [" + a.P + " " + a.v + " " + a.getStatus() + "]";
}
var $bcd2671091eb623d$var$Ec = {}, $bcd2671091eb623d$var$Fc = null;
function $bcd2671091eb623d$var$Gc(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : $bcd2671091eb623d$var$H("=.", a[b - 1]) && (c = $bcd2671091eb623d$var$H("=.", a[b - 2]) ? c - 2 : c - 1);
    var d = new Uint8Array(c), f = 0;
    $bcd2671091eb623d$var$Hc(a, function(g) {
        d[f++] = g;
    });
    return d.subarray(0, f);
}
function $bcd2671091eb623d$var$Hc(a, b) {
    function c(k) {
        for(; d < a.length;){
            var l = a.charAt(d++), m = $bcd2671091eb623d$var$Fc[l];
            if (null != m) return m;
            if (!/^[\s\xa0]*$/.test(l)) throw Error("Unknown base64 encoding at char: " + l);
        }
        return k;
    }
    $bcd2671091eb623d$var$Ic();
    for(var d = 0;;){
        var f = c(-1), g = c(0), e = c(64), h = c(64);
        if (64 === h && -1 === f) break;
        b(f << 2 | g >> 4);
        64 != e && (b(g << 4 & 240 | e >> 2), 64 != h && b(e << 6 & 192 | h));
    }
}
function $bcd2671091eb623d$var$Ic() {
    if (!$bcd2671091eb623d$var$Fc) {
        $bcd2671091eb623d$var$Fc = {};
        for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
            "+/=",
            "+/",
            "-_=",
            "-_.",
            "-_"
        ], c = 0; 5 > c; c++){
            var d = a.concat(b[c].split(""));
            $bcd2671091eb623d$var$Ec[c] = d;
            for(var f = 0; f < d.length; f++){
                var g = d[f];
                void 0 === $bcd2671091eb623d$var$Fc[g] && ($bcd2671091eb623d$var$Fc[g] = f);
            }
        }
    }
}
var $bcd2671091eb623d$var$Jc = [
    "content-type",
    "grpc-status",
    "grpc-message"
];
function $bcd2671091eb623d$var$X(a) {
    this.a = a.Z;
    this.m = null;
    this.b = [];
    this.h = [];
    this.g = [];
    this.f = [];
    this.c = [];
    this.l = !1;
    this.i = 0;
    this.s = new $bcd2671091eb623d$var$Ga;
    var b = this;
    $bcd2671091eb623d$var$zb(this.a, "readystatechange", function() {
        var c = b.a;
        if (c = c.a ? c.a.getResponseHeader("Content-Type") : null) {
            c = c.toLowerCase();
            if (0 == c.lastIndexOf("application/grpc-web-text", 0)) {
                c = b.a;
                try {
                    var d = c.a ? c.a.responseText : "";
                } catch (k) {
                    $bcd2671091eb623d$var$P(c.b, "Can not get responseText: " + k.message), d = "";
                }
                c = d || "";
                d = c.length - c.length % 4;
                c = c.substr(b.i, d - b.i);
                if (0 == c.length) return;
                b.i = d;
                c = $bcd2671091eb623d$var$Gc(c);
            } else if (0 == c.lastIndexOf("application/grpc", 0)) c = new Uint8Array($bcd2671091eb623d$var$Cc(b.a));
            else {
                $bcd2671091eb623d$var$Y(b, new $bcd2671091eb623d$var$E(2, "Unknown Content-type received."));
                return;
            }
            d = null;
            try {
                d = $bcd2671091eb623d$var$Ia(b.s, c);
            } catch (k) {
                $bcd2671091eb623d$var$Y(b, new $bcd2671091eb623d$var$E(2, "Error in parsing response body"));
            }
            if (d) for(c = 0; c < d.length; c++){
                if ($bcd2671091eb623d$var$Ja in d[c]) {
                    var f = d[c][$bcd2671091eb623d$var$Ja];
                    if (f) {
                        var g = !1, e = void 0;
                        try {
                            e = b.m(f), g = !0;
                        } catch (k) {
                            $bcd2671091eb623d$var$Y(b, new $bcd2671091eb623d$var$E(13, "Error when deserializing response data; error: " + k + (", response: " + e)));
                        }
                        if (g) for(f = e, g = 0; g < b.b.length; g++)b.b[g](f);
                    }
                }
                if ($bcd2671091eb623d$var$G in d[c] && 0 < d[c][$bcd2671091eb623d$var$G].length) {
                    f = "";
                    for(g = 0; g < d[c][$bcd2671091eb623d$var$G].length; g++)f += String.fromCharCode(d[c][$bcd2671091eb623d$var$G][g]);
                    f = f.trim().split("\r\n");
                    g = {};
                    for(e = 0; e < f.length; e++){
                        var h = f[e].indexOf(":");
                        g[f[e].substring(0, h).trim()] = f[e].substring(h + 1).trim();
                    }
                    f = g;
                    g = 0;
                    e = "";
                    "grpc-status" in f && (g = Number(f["grpc-status"]), delete f["grpc-status"]);
                    "grpc-message" in f && (e = f["grpc-message"], delete f["grpc-message"]);
                    $bcd2671091eb623d$var$Y(b, new $bcd2671091eb623d$var$E(g, e, f));
                }
            }
        }
    });
    $bcd2671091eb623d$var$zb(this.a, "complete", function() {
        var c = b.a.g, d = 2, f = "", g = {};
        d = $bcd2671091eb623d$var$Dc(b.a);
        var e = {};
        for(h in d)d.hasOwnProperty(h) && (e[h.toLowerCase()] = d[h]);
        Object.keys(e).forEach(function(k) {
            $bcd2671091eb623d$var$Jc.includes(k) || (g[k] = e[k]);
        });
        $bcd2671091eb623d$var$Kc(b, g);
        var h = -1;
        if (0 != c) {
            switch(c){
                case 7:
                    d = 10;
                    break;
                case 8:
                    d = 4;
                    break;
                case 6:
                    h = b.a.getStatus();
                    d = $bcd2671091eb623d$var$Aa(h);
                    break;
                default:
                    d = 14;
            }
            10 == d && b.l || (f = $bcd2671091eb623d$var$Da(c), -1 != h && (f += ", http status code: " + h), $bcd2671091eb623d$var$Y(b, new $bcd2671091eb623d$var$E(d, f)));
        } else c = !1, "grpc-status" in e && (d = Number(e["grpc-status"]), "grpc-message" in e && (f = e["grpc-message"]), 0 != d && ($bcd2671091eb623d$var$Y(b, new $bcd2671091eb623d$var$E(d, f || "", e)), c = !0)), c || $bcd2671091eb623d$var$Lc(b);
    });
}
$bcd2671091eb623d$var$X.prototype.on = function(a, b) {
    "data" == a ? this.b.push(b) : "status" == a ? this.h.push(b) : "metadata" == a ? this.g.push(b) : "end" == a ? this.c.push(b) : "error" == a && this.f.push(b);
    return this;
};
function $bcd2671091eb623d$var$Mc(a, b) {
    b = a.indexOf(b);
    -1 < b && a.splice(b, 1);
}
$bcd2671091eb623d$var$X.prototype.removeListener = function(a, b) {
    "data" == a ? $bcd2671091eb623d$var$Mc(this.b, b) : "status" == a ? $bcd2671091eb623d$var$Mc(this.h, b) : "metadata" == a ? $bcd2671091eb623d$var$Mc(this.g, b) : "end" == a ? $bcd2671091eb623d$var$Mc(this.c, b) : "error" == a && $bcd2671091eb623d$var$Mc(this.f, b);
    return this;
};
$bcd2671091eb623d$var$X.prototype.cancel = function() {
    this.l = !0;
    this.a.abort();
};
function $bcd2671091eb623d$var$Y(a, b) {
    if (0 != b.code) for(var c = new $bcd2671091eb623d$var$E(b.code, decodeURIComponent(b.message || ""), b.metadata), d = 0; d < a.f.length; d++)a.f[d](c);
    b = {
        code: b.code,
        details: decodeURIComponent(b.message || ""),
        metadata: b.metadata
    };
    for(c = 0; c < a.h.length; c++)a.h[c](b);
}
function $bcd2671091eb623d$var$Kc(a, b) {
    for(var c = 0; c < a.g.length; c++)a.g[c](b);
}
function $bcd2671091eb623d$var$Lc(a) {
    for(var b = 0; b < a.c.length; b++)a.c[b]();
}
$bcd2671091eb623d$var$X.prototype.cancel = $bcd2671091eb623d$var$X.prototype.cancel;
$bcd2671091eb623d$var$X.prototype.removeListener = $bcd2671091eb623d$var$X.prototype.removeListener;
$bcd2671091eb623d$var$X.prototype.on = $bcd2671091eb623d$var$X.prototype.on;
function $bcd2671091eb623d$var$Nc(a) {
    var b = "";
    $bcd2671091eb623d$var$Ta(a, function(c, d) {
        b += d;
        b += ":";
        b += c;
        b += "\r\n";
    });
    return b;
}
function $bcd2671091eb623d$var$Z(a, b) {
    a = void 0 === a ? {} : a;
    this.a = a.format || $bcd2671091eb623d$var$y("format", a) || "text";
    this.g = a.aa || $bcd2671091eb623d$var$y("suppressCorsPreflight", a) || !1;
    this.f = a.withCredentials || $bcd2671091eb623d$var$y("withCredentials", a) || !1;
    this.b = a.$ || $bcd2671091eb623d$var$y("streamInterceptors", a) || [];
    this.h = a.ba || $bcd2671091eb623d$var$y("unaryInterceptors", a) || [];
    this.c = b || null;
}
$bcd2671091eb623d$var$Z.prototype.X = function(a, b, c, d, f) {
    var g = this, e = a.substr(0, a.length - d.name.length);
    a = $bcd2671091eb623d$var$Oc(function(h) {
        return $bcd2671091eb623d$var$Pc(g, h, e);
    }, this.b).call(this, $bcd2671091eb623d$var$za(d, b, c));
    $bcd2671091eb623d$var$Qc(a, f, !1);
    return new $bcd2671091eb623d$var$Ca(a);
};
$bcd2671091eb623d$var$Z.prototype.S = function(a, b, c, d) {
    var f = this, g = a.substr(0, a.length - d.name.length);
    return $bcd2671091eb623d$var$Oc(function(e) {
        return new Promise(function(h, k) {
            var l = $bcd2671091eb623d$var$Pc(f, e, g), m, p, q;
            $bcd2671091eb623d$var$Qc(l, function(w, A, L, Sb, Rc) {
                w ? k(w) : Rc ? q = A : L ? p = L : Sb ? m = Sb : (w = e.getMethodDescriptor(), A = m, A = void 0 === A ? {} : A, h(new $bcd2671091eb623d$var$D(q, w, A, void 0 === p ? null : p)));
            }, !0);
        });
    }, this.h).call(this, $bcd2671091eb623d$var$za(d, b, c)).then(function(e) {
        return e.getResponseMessage();
    });
};
$bcd2671091eb623d$var$Z.prototype.unaryCall = function(a, b, c, d) {
    return this.S(a, b, c, d);
};
$bcd2671091eb623d$var$Z.prototype.Y = function(a, b, c, d) {
    var f = this, g = a.substr(0, a.length - d.name.length);
    return $bcd2671091eb623d$var$Oc(function(e) {
        return $bcd2671091eb623d$var$Pc(f, e, g);
    }, this.b).call(this, $bcd2671091eb623d$var$za(d, b, c));
};
function $bcd2671091eb623d$var$Pc(a, b, c) {
    var d = b.getMethodDescriptor(), f = c + d.getName();
    c = a.c ? a.c : new $bcd2671091eb623d$var$rc;
    c.M = a.f;
    var g = new $bcd2671091eb623d$var$X({
        Z: c
    });
    g.m = d.b;
    var e = b.getMetadata();
    for(h in e)c.headers.set(h, e[h]);
    "text" == a.a ? (c.headers.set("Content-Type", "application/grpc-web-text"), c.headers.set("Accept", "application/grpc-web-text")) : c.headers.set("Content-Type", "application/grpc-web+proto");
    c.headers.set("X-User-Agent", "grpc-web-javascript/0.1");
    c.headers.set("X-Grpc-Web", "1");
    if (c.headers.has("deadline")) {
        var h = Number(c.headers.get("deadline"));
        h = Math.ceil(h - (new Date).getTime());
        c.headers.delete("deadline");
        Infinity === h && (h = 0);
        0 < h && (c.headers.set("grpc-timeout", h + "m"), c.h = Math.max(0, Math.max(1E3, Math.ceil(1.1 * h))));
    }
    if (a.g) {
        e = c.headers;
        h = {};
        for(var k = $bcd2671091eb623d$var$ha(e.keys()), l = k.next(); !l.done; l = k.next())l = l.value, h[l] = e.get(l);
        c.headers.clear();
        b: {
            for(m in h){
                var m = !1;
                break b;
            }
            m = !0;
        }
        if (!m) {
            if (h = $bcd2671091eb623d$var$Nc(h), "string" === typeof f) {
                if (m = encodeURIComponent("$httpHeaders"), h = null != h ? "=" + encodeURIComponent(String(h)) : "", m += h) h = f.indexOf("#"), 0 > h && (h = f.length), e = f.indexOf("?"), 0 > e || e > h ? (e = h, k = "") : k = f.substring(e + 1, h), f = [
                    f.substr(0, e),
                    k,
                    f.substr(h)
                ], h = f[1], f[1] = m ? h ? h + "&" + m : m : h, f = f[0] + (f[1] ? "?" + f[1] : "") + f[2];
            } else f.a("$httpHeaders", h);
        }
    }
    b = (0, d.a)(b.getRequestMessage());
    d = b.length;
    m = [
        0,
        0,
        0,
        0
    ];
    h = new Uint8Array(5 + d);
    for(e = 3; 0 <= e; e--)m[e] = d % 256, d >>>= 8;
    h.set(new Uint8Array(m), 1);
    h.set(b, 5);
    b = h;
    if ("text" == a.a) {
        a = b;
        var p;
        void 0 === p && (p = 0);
        $bcd2671091eb623d$var$Ic();
        p = $bcd2671091eb623d$var$Ec[p];
        b = Array(Math.floor(a.length / 3));
        d = p[64] || "";
        for(m = h = 0; h < a.length - 2; h += 3){
            l = a[h];
            var q = a[h + 1];
            k = a[h + 2];
            e = p[l >> 2];
            l = p[(l & 3) << 4 | q >> 4];
            q = p[(q & 15) << 2 | k >> 6];
            k = p[k & 63];
            b[m++] = e + l + q + k;
        }
        e = 0;
        k = d;
        switch(a.length - h){
            case 2:
                e = a[h + 1], k = p[(e & 15) << 2] || d;
            case 1:
                a = a[h], b[m] = p[a >> 2] + p[(a & 3) << 4 | e >> 4] + k + d;
        }
        b = b.join("");
    } else "binary" == a.a && (c.m = "arraybuffer");
    $bcd2671091eb623d$var$vc(c, f, b);
    return g;
}
function $bcd2671091eb623d$var$Qc(a, b, c) {
    var d = !1, f = null, g = !1;
    a.on("data", function(e) {
        d = !0;
        f = e;
    });
    a.on("error", function(e) {
        0 == e.code || g || (g = !0, b(e, null));
    });
    a.on("status", function(e) {
        0 == e.code || g ? c && b(null, null, e) : (g = !0, b({
            code: e.code,
            message: e.details,
            metadata: e.metadata
        }, null));
    });
    if (c) a.on("metadata", function(e) {
        b(null, null, null, e);
    });
    a.on("end", function() {
        g || (d ? c ? b(null, f, null, null, !0) : b(null, f) : b({
            code: 2,
            message: "Incomplete response"
        }));
        c && b(null, null);
    });
}
function $bcd2671091eb623d$var$Oc(a, b) {
    var c = a;
    b.forEach(function(d) {
        var f = c;
        c = function(g) {
            return d.intercept(g, f);
        };
    });
    return c;
}
$bcd2671091eb623d$var$Z.prototype.serverStreaming = $bcd2671091eb623d$var$Z.prototype.Y;
$bcd2671091eb623d$var$Z.prototype.unaryCall = $bcd2671091eb623d$var$Z.prototype.unaryCall;
$bcd2671091eb623d$var$Z.prototype.thenableCall = $bcd2671091eb623d$var$Z.prototype.S;
$bcd2671091eb623d$var$Z.prototype.rpcCall = $bcd2671091eb623d$var$Z.prototype.X;
module.exports.CallOptions = $bcd2671091eb623d$var$xa;
module.exports.MethodDescriptor = $bcd2671091eb623d$var$ya;
module.exports.GrpcWebClientBase = $bcd2671091eb623d$var$Z;
module.exports.RpcError = $bcd2671091eb623d$var$E;
module.exports.StatusCode = {
    OK: 0,
    CANCELLED: 1,
    UNKNOWN: 2,
    INVALID_ARGUMENT: 3,
    DEADLINE_EXCEEDED: 4,
    NOT_FOUND: 5,
    ALREADY_EXISTS: 6,
    PERMISSION_DENIED: 7,
    UNAUTHENTICATED: 16,
    RESOURCE_EXHAUSTED: 8,
    FAILED_PRECONDITION: 9,
    ABORTED: 10,
    OUT_OF_RANGE: 11,
    UNIMPLEMENTED: 12,
    INTERNAL: 13,
    UNAVAILABLE: 14,
    DATA_LOSS: 15
};
module.exports.MethodType = {
    UNARY: "unary",
    SERVER_STREAMING: "server_streaming",
    BIDI_STREAMING: "bidi_streaming"
};
$bcd2671091eb623d$var$Lb = "undefined" !== typeof globalThis && globalThis || self;

});

parcelRegister("ghA5X", function(module, exports) {
// source: insurance_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $bdaa3b9c627308ce$var$goog = $8M67s;
var $bdaa3b9c627308ce$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$bdaa3b9c627308ce$var$goog.object.extend(proto, $3QqPt);

var $gQESC = parcelRequire("gQESC");
$bdaa3b9c627308ce$var$goog.object.extend(proto, $gQESC);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.BulkUpdatePoliciesRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.BulkUpdatePoliciesResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CancelInsurancePolicyRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CancelInsurancePolicyResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreateAllInsuranceQuotesRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreateAllInsuranceQuotesRequest.VehicleType', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreateAllInsuranceQuotesResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreateInsurancePolicyRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreateInsuranceQuoteRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreateInsuranceQuoteRequest.VehicleType', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreateInsuranceQuoteResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreatePolicyChangeQuoteRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreatePolicyChangeQuoteResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreatePolicyChangeRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CreatePolicyChangeResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.CustomerIdentity', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.Driver', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.ExtendInsurancePolicyRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.ExtendInsurancePolicyResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetExternalPoliciesFromDsotRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetExternalPoliciesFromDsotResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsurancePoliciesResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsurancePolicyRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsurancePolicyResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsuranceQuoteRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsuranceQuoteResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsuranceStatusRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsuranceStatusResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsuredDriversRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetInsuredDriversResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetLatestQuoteGroupRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetLatestQuoteGroupResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetOwnInsurancePoliciesRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetUpdatedInsurancePolicyCardRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.GetUpdatedInsurancePolicyCardResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.ImportInsuranceDataRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.ImportInsuranceDataResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.InsurancePolicyCancelled', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.InsurancePolicyCreated', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.InsurancePolicyUpdated', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.InsuranceSplitLimits', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.IsQualifiedForLiberty', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.ModifyInsuranceDriversRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.ModifyInsuranceDriversResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.QualifyForLibertyInsuranceRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.QualifyForLibertyInsuranceResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.QuoteResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.RequestSource', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.SelectInsuranceQuoteRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.SelectInsuranceQuoteResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.UpsertInsurancePoliciesRequest', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.UpsertInsurancePoliciesResponse', null, $bdaa3b9c627308ce$var$global);
$bdaa3b9c627308ce$var$goog.exportSymbol('proto.insurance_service.UpsertOwnInsurancePoliciesRequest', null, $bdaa3b9c627308ce$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CustomerIdentity = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CustomerIdentity, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CustomerIdentity.displayName = 'proto.insurance_service.CustomerIdentity';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.UpsertOwnInsurancePoliciesRequest.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.UpsertOwnInsurancePoliciesRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.displayName = 'proto.insurance_service.UpsertOwnInsurancePoliciesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.UpsertInsurancePoliciesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.UpsertInsurancePoliciesRequest.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.UpsertInsurancePoliciesRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.UpsertInsurancePoliciesRequest.displayName = 'proto.insurance_service.UpsertInsurancePoliciesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.UpsertInsurancePoliciesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.UpsertInsurancePoliciesResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.UpsertInsurancePoliciesResponse.displayName = 'proto.insurance_service.UpsertInsurancePoliciesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreateInsuranceQuoteRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.CreateInsuranceQuoteRequest.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreateInsuranceQuoteRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreateInsuranceQuoteRequest.displayName = 'proto.insurance_service.CreateInsuranceQuoteRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreateInsuranceQuoteResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.CreateInsuranceQuoteResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreateInsuranceQuoteResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreateInsuranceQuoteResponse.displayName = 'proto.insurance_service.CreateInsuranceQuoteResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.CreateAllInsuranceQuotesRequest.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreateAllInsuranceQuotesRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreateAllInsuranceQuotesRequest.displayName = 'proto.insurance_service.CreateAllInsuranceQuotesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.CreateAllInsuranceQuotesResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreateAllInsuranceQuotesResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreateAllInsuranceQuotesResponse.displayName = 'proto.insurance_service.CreateAllInsuranceQuotesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.SelectInsuranceQuoteRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.SelectInsuranceQuoteRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.SelectInsuranceQuoteRequest.displayName = 'proto.insurance_service.SelectInsuranceQuoteRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.SelectInsuranceQuoteResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.SelectInsuranceQuoteResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.SelectInsuranceQuoteResponse.displayName = 'proto.insurance_service.SelectInsuranceQuoteResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsuranceQuoteRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsuranceQuoteRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsuranceQuoteRequest.displayName = 'proto.insurance_service.GetInsuranceQuoteRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsuranceQuoteResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.GetInsuranceQuoteResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsuranceQuoteResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsuranceQuoteResponse.displayName = 'proto.insurance_service.GetInsuranceQuoteResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreateInsurancePolicyRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreateInsurancePolicyRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreateInsurancePolicyRequest.displayName = 'proto.insurance_service.CreateInsurancePolicyRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetOwnInsurancePoliciesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetOwnInsurancePoliciesRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetOwnInsurancePoliciesRequest.displayName = 'proto.insurance_service.GetOwnInsurancePoliciesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsurancePoliciesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.GetInsurancePoliciesResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsurancePoliciesResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsurancePoliciesResponse.displayName = 'proto.insurance_service.GetInsurancePoliciesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsurancePolicyRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsurancePolicyRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsurancePolicyRequest.displayName = 'proto.insurance_service.GetInsurancePolicyRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsurancePolicyResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsurancePolicyResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsurancePolicyResponse.displayName = 'proto.insurance_service.GetInsurancePolicyResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.QuoteResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.QuoteResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.QuoteResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.QuoteResponse.displayName = 'proto.insurance_service.QuoteResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.InsuranceSplitLimits = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.InsuranceSplitLimits, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.InsuranceSplitLimits.displayName = 'proto.insurance_service.InsuranceSplitLimits';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.CreatePolicyChangeQuoteRequest.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreatePolicyChangeQuoteRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreatePolicyChangeQuoteRequest.displayName = 'proto.insurance_service.CreatePolicyChangeQuoteRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.CreatePolicyChangeQuoteResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreatePolicyChangeQuoteResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreatePolicyChangeQuoteResponse.displayName = 'proto.insurance_service.CreatePolicyChangeQuoteResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreatePolicyChangeRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreatePolicyChangeRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreatePolicyChangeRequest.displayName = 'proto.insurance_service.CreatePolicyChangeRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CreatePolicyChangeResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.CreatePolicyChangeResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CreatePolicyChangeResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CreatePolicyChangeResponse.displayName = 'proto.insurance_service.CreatePolicyChangeResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.QualifyForLibertyInsuranceRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.QualifyForLibertyInsuranceRequest.displayName = 'proto.insurance_service.QualifyForLibertyInsuranceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.QualifyForLibertyInsuranceResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.QualifyForLibertyInsuranceResponse.displayName = 'proto.insurance_service.QualifyForLibertyInsuranceResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsuredDriversRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsuredDriversRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsuredDriversRequest.displayName = 'proto.insurance_service.GetInsuredDriversRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsuredDriversResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.GetInsuredDriversResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsuredDriversResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsuredDriversResponse.displayName = 'proto.insurance_service.GetInsuredDriversResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CancelInsurancePolicyRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CancelInsurancePolicyRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CancelInsurancePolicyRequest.displayName = 'proto.insurance_service.CancelInsurancePolicyRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.CancelInsurancePolicyResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.CancelInsurancePolicyResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.CancelInsurancePolicyResponse.displayName = 'proto.insurance_service.CancelInsurancePolicyResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.ExtendInsurancePolicyRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.ExtendInsurancePolicyRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.ExtendInsurancePolicyRequest.displayName = 'proto.insurance_service.ExtendInsurancePolicyRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.ExtendInsurancePolicyResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.ExtendInsurancePolicyResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.ExtendInsurancePolicyResponse.displayName = 'proto.insurance_service.ExtendInsurancePolicyResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetUpdatedInsurancePolicyCardRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.displayName = 'proto.insurance_service.GetUpdatedInsurancePolicyCardRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetUpdatedInsurancePolicyCardResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.displayName = 'proto.insurance_service.GetUpdatedInsurancePolicyCardResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsuranceStatusRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsuranceStatusRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsuranceStatusRequest.displayName = 'proto.insurance_service.GetInsuranceStatusRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetInsuranceStatusResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetInsuranceStatusResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetInsuranceStatusResponse.displayName = 'proto.insurance_service.GetInsuranceStatusResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.BulkUpdatePoliciesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.BulkUpdatePoliciesRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.BulkUpdatePoliciesRequest.displayName = 'proto.insurance_service.BulkUpdatePoliciesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.BulkUpdatePoliciesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.BulkUpdatePoliciesResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.BulkUpdatePoliciesResponse.displayName = 'proto.insurance_service.BulkUpdatePoliciesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetExternalPoliciesFromDsotRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.displayName = 'proto.insurance_service.GetExternalPoliciesFromDsotRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetExternalPoliciesFromDsotResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetExternalPoliciesFromDsotResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetExternalPoliciesFromDsotResponse.displayName = 'proto.insurance_service.GetExternalPoliciesFromDsotResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.ImportInsuranceDataRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.ImportInsuranceDataRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.ImportInsuranceDataRequest.displayName = 'proto.insurance_service.ImportInsuranceDataRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.ImportInsuranceDataResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.ImportInsuranceDataResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.ImportInsuranceDataResponse.displayName = 'proto.insurance_service.ImportInsuranceDataResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.IsQualifiedForLiberty = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.IsQualifiedForLiberty, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.IsQualifiedForLiberty.displayName = 'proto.insurance_service.IsQualifiedForLiberty';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.InsurancePolicyCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.InsurancePolicyCreated.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.InsurancePolicyCreated, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.InsurancePolicyCreated.displayName = 'proto.insurance_service.InsurancePolicyCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.InsurancePolicyUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.InsurancePolicyUpdated, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.InsurancePolicyUpdated.displayName = 'proto.insurance_service.InsurancePolicyUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.InsurancePolicyCancelled = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.InsurancePolicyCancelled, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.InsurancePolicyCancelled.displayName = 'proto.insurance_service.InsurancePolicyCancelled';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetLatestQuoteGroupRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetLatestQuoteGroupRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetLatestQuoteGroupRequest.displayName = 'proto.insurance_service.GetLatestQuoteGroupRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.GetLatestQuoteGroupResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.GetLatestQuoteGroupResponse.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.GetLatestQuoteGroupResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.GetLatestQuoteGroupResponse.displayName = 'proto.insurance_service.GetLatestQuoteGroupResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.Driver = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.Driver, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.Driver.displayName = 'proto.insurance_service.Driver';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.ModifyInsuranceDriversRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.insurance_service.ModifyInsuranceDriversRequest.repeatedFields_, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.ModifyInsuranceDriversRequest, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.ModifyInsuranceDriversRequest.displayName = 'proto.insurance_service.ModifyInsuranceDriversRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance_service.ModifyInsuranceDriversResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdaa3b9c627308ce$var$goog.inherits(proto.insurance_service.ModifyInsuranceDriversResponse, $8M67s.Message);
if ($bdaa3b9c627308ce$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance_service.ModifyInsuranceDriversResponse.displayName = 'proto.insurance_service.ModifyInsuranceDriversResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CustomerIdentity.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CustomerIdentity.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CustomerIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CustomerIdentity.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CustomerIdentity}
 */ proto.insurance_service.CustomerIdentity.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CustomerIdentity;
    return proto.insurance_service.CustomerIdentity.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CustomerIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CustomerIdentity}
 */ proto.insurance_service.CustomerIdentity.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CustomerIdentity.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CustomerIdentity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CustomerIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CustomerIdentity.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.CustomerIdentity.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CustomerIdentity} returns this
 */ proto.insurance_service.CustomerIdentity.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.UpsertOwnInsurancePoliciesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            insurancePoliciesList: $8M67s.Message.toObjectList(msg.getInsurancePoliciesList(), $3QqPt.InsurancePolicy.toObject, includeInstance),
            requestSource: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest}
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.UpsertOwnInsurancePoliciesRequest;
    return proto.insurance_service.UpsertOwnInsurancePoliciesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest}
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.InsurancePolicy;
                reader.readMessage(value, $3QqPt.InsurancePolicy.deserializeBinaryFromReader);
                msg.addInsurancePolicies(value);
                break;
            case 2:
                var value = /** @type {!proto.insurance_service.RequestSource} */ reader.readEnum();
                msg.setRequestSource(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.UpsertOwnInsurancePoliciesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInsurancePoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.InsurancePolicy.serializeBinaryToWriter);
    f = message.getRequestSource();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * repeated domain.InsurancePolicy insurance_policies = 1;
 * @return {!Array<!proto.domain.InsurancePolicy>}
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.prototype.getInsurancePoliciesList = function() {
    return /** @type{!Array<!proto.domain.InsurancePolicy>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.InsurancePolicy, 1);
};
/**
 * @param {!Array<!proto.domain.InsurancePolicy>} value
 * @return {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} returns this
*/ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.prototype.setInsurancePoliciesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.InsurancePolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.InsurancePolicy}
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.prototype.addInsurancePolicies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.InsurancePolicy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} returns this
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.prototype.clearInsurancePoliciesList = function() {
    return this.setInsurancePoliciesList([]);
};
/**
 * optional RequestSource request_source = 2;
 * @return {!proto.insurance_service.RequestSource}
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.prototype.getRequestSource = function() {
    return /** @type {!proto.insurance_service.RequestSource} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.insurance_service.RequestSource} value
 * @return {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} returns this
 */ proto.insurance_service.UpsertOwnInsurancePoliciesRequest.prototype.setRequestSource = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.UpsertInsurancePoliciesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerIdentity: (f = msg.getCustomerIdentity()) && proto.insurance_service.CustomerIdentity.toObject(includeInstance, f),
            insurancePoliciesList: $8M67s.Message.toObjectList(msg.getInsurancePoliciesList(), $3QqPt.InsurancePolicy.toObject, includeInstance),
            requestSource: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.UpsertInsurancePoliciesRequest}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.UpsertInsurancePoliciesRequest;
    return proto.insurance_service.UpsertInsurancePoliciesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.UpsertInsurancePoliciesRequest}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.insurance_service.CustomerIdentity;
                reader.readMessage(value, proto.insurance_service.CustomerIdentity.deserializeBinaryFromReader);
                msg.setCustomerIdentity(value);
                break;
            case 2:
                var value = new $3QqPt.InsurancePolicy;
                reader.readMessage(value, $3QqPt.InsurancePolicy.deserializeBinaryFromReader);
                msg.addInsurancePolicies(value);
                break;
            case 3:
                var value = /** @type {!proto.insurance_service.RequestSource} */ reader.readEnum();
                msg.setRequestSource(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.UpsertInsurancePoliciesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerIdentity();
    if (f != null) writer.writeMessage(1, f, proto.insurance_service.CustomerIdentity.serializeBinaryToWriter);
    f = message.getInsurancePoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.InsurancePolicy.serializeBinaryToWriter);
    f = message.getRequestSource();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional CustomerIdentity customer_identity = 1;
 * @return {?proto.insurance_service.CustomerIdentity}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.getCustomerIdentity = function() {
    return /** @type{?proto.insurance_service.CustomerIdentity} */ $8M67s.Message.getWrapperField(this, proto.insurance_service.CustomerIdentity, 1);
};
/**
 * @param {?proto.insurance_service.CustomerIdentity|undefined} value
 * @return {!proto.insurance_service.UpsertInsurancePoliciesRequest} returns this
*/ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.setCustomerIdentity = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.insurance_service.UpsertInsurancePoliciesRequest} returns this
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.clearCustomerIdentity = function() {
    return this.setCustomerIdentity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.hasCustomerIdentity = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated domain.InsurancePolicy insurance_policies = 2;
 * @return {!Array<!proto.domain.InsurancePolicy>}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.getInsurancePoliciesList = function() {
    return /** @type{!Array<!proto.domain.InsurancePolicy>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.InsurancePolicy, 2);
};
/**
 * @param {!Array<!proto.domain.InsurancePolicy>} value
 * @return {!proto.insurance_service.UpsertInsurancePoliciesRequest} returns this
*/ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.setInsurancePoliciesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.InsurancePolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.InsurancePolicy}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.addInsurancePolicies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.InsurancePolicy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.UpsertInsurancePoliciesRequest} returns this
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.clearInsurancePoliciesList = function() {
    return this.setInsurancePoliciesList([]);
};
/**
 * optional RequestSource request_source = 3;
 * @return {!proto.insurance_service.RequestSource}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.getRequestSource = function() {
    return /** @type {!proto.insurance_service.RequestSource} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.insurance_service.RequestSource} value
 * @return {!proto.insurance_service.UpsertInsurancePoliciesRequest} returns this
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.setRequestSource = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string subscription_id = 4;
 * @return {string}
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.UpsertInsurancePoliciesRequest} returns this
 */ proto.insurance_service.UpsertInsurancePoliciesRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.UpsertInsurancePoliciesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.UpsertInsurancePoliciesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.UpsertInsurancePoliciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.UpsertInsurancePoliciesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.UpsertInsurancePoliciesResponse}
 */ proto.insurance_service.UpsertInsurancePoliciesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.UpsertInsurancePoliciesResponse;
    return proto.insurance_service.UpsertInsurancePoliciesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.UpsertInsurancePoliciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.UpsertInsurancePoliciesResponse}
 */ proto.insurance_service.UpsertInsurancePoliciesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.UpsertInsurancePoliciesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.UpsertInsurancePoliciesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.UpsertInsurancePoliciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.UpsertInsurancePoliciesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.CreateInsuranceQuoteRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreateInsuranceQuoteRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateInsuranceQuoteRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleType: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            deductible: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            limits: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            programName: $8M67s.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreateInsuranceQuoteRequest;
    return proto.insurance_service.CreateInsuranceQuoteRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {!proto.insurance_service.CreateInsuranceQuoteRequest.VehicleType} */ reader.readEnum();
                msg.setVehicleType(value);
                break;
            case 3:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeductible(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLimits(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreateInsuranceQuoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateInsuranceQuoteRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleType();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getDeductible();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getLimits();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getProgramName();
    if (f.length > 0) writer.writeString(6, f);
};
/**
 * @enum {number}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.VehicleType = {
    MODEL_3: 0,
    MODEL_Y: 1
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest} returns this
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional VehicleType vehicle_type = 2;
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest.VehicleType}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.getVehicleType = function() {
    return /** @type {!proto.insurance_service.CreateInsuranceQuoteRequest.VehicleType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.insurance_service.CreateInsuranceQuoteRequest.VehicleType} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest} returns this
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.setVehicleType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 3;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 3);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest} returns this
*/ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest} returns this
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional int32 deductible = 4;
 * @return {number}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.getDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest} returns this
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.setDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string limits = 5;
 * @return {string}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.getLimits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest} returns this
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.setLimits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string program_name = 6;
 * @return {string}
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.getProgramName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteRequest} returns this
 */ proto.insurance_service.CreateInsuranceQuoteRequest.prototype.setProgramName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.CreateInsuranceQuoteResponse.repeatedFields_ = [
    5
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreateInsuranceQuoteResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreateInsuranceQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateInsuranceQuoteResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            quoteId: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            mileageRate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            insuranceSplitLimits: (f = msg.getInsuranceSplitLimits()) && proto.insurance_service.InsuranceSplitLimits.toObject(includeInstance, f),
            deductible: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            limits: $8M67s.Message.getFieldWithDefault(msg, 8, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreateInsuranceQuoteResponse;
    return proto.insurance_service.CreateInsuranceQuoteResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreateInsuranceQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setQuoteId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMileageRate(value);
                break;
            case 5:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 6:
                var value = new proto.insurance_service.InsuranceSplitLimits;
                reader.readMessage(value, proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader);
                msg.setInsuranceSplitLimits(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeductible(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setLimits(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreateInsuranceQuoteResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreateInsuranceQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateInsuranceQuoteResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getQuoteId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMileageRate();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getInsuranceSplitLimits();
    if (f != null) writer.writeMessage(6, f, proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter);
    f = message.getDeductible();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getLimits();
    if (f.length > 0) writer.writeString(8, f);
};
/**
 * optional int32 quote_id = 1;
 * @return {number}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.getQuoteId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.setQuoteId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 daily_rate = 2;
 * @return {number}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 monthly_rate = 3;
 * @return {number}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 mileage_rate = 4;
 * @return {number}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.getMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.setMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 5;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 5);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
*/ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional InsuranceSplitLimits insurance_split_limits = 6;
 * @return {?proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.getInsuranceSplitLimits = function() {
    return /** @type{?proto.insurance_service.InsuranceSplitLimits} */ $8M67s.Message.getWrapperField(this, proto.insurance_service.InsuranceSplitLimits, 6);
};
/**
 * @param {?proto.insurance_service.InsuranceSplitLimits|undefined} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
*/ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.setInsuranceSplitLimits = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.clearInsuranceSplitLimits = function() {
    return this.setInsuranceSplitLimits(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.hasInsuranceSplitLimits = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional int32 deductible = 7;
 * @return {number}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.getDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.setDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string limits = 8;
 * @return {string}
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.getLimits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateInsuranceQuoteResponse} returns this
 */ proto.insurance_service.CreateInsuranceQuoteResponse.prototype.setLimits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreateAllInsuranceQuotesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleType: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            programName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreateAllInsuranceQuotesRequest;
    return proto.insurance_service.CreateAllInsuranceQuotesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {!proto.insurance_service.CreateAllInsuranceQuotesRequest.VehicleType} */ reader.readEnum();
                msg.setVehicleType(value);
                break;
            case 3:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreateAllInsuranceQuotesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleType();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getProgramName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * @enum {number}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.VehicleType = {
    MODEL_3: 0,
    MODEL_Y: 1
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest} returns this
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional VehicleType vehicle_type = 2;
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest.VehicleType}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.getVehicleType = function() {
    return /** @type {!proto.insurance_service.CreateAllInsuranceQuotesRequest.VehicleType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest.VehicleType} value
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest} returns this
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.setVehicleType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 3;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 3);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest} returns this
*/ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest} returns this
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional string program_name = 4;
 * @return {string}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.getProgramName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest} returns this
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.setProgramName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string subscription_id = 5;
 * @return {string}
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesRequest} returns this
 */ proto.insurance_service.CreateAllInsuranceQuotesRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreateAllInsuranceQuotesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            quoteresponseList: $8M67s.Message.toObjectList(msg.getQuoteresponseList(), proto.insurance_service.QuoteResponse.toObject, includeInstance),
            isQualified: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesResponse}
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreateAllInsuranceQuotesResponse;
    return proto.insurance_service.CreateAllInsuranceQuotesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesResponse}
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.insurance_service.QuoteResponse;
                reader.readMessage(value, proto.insurance_service.QuoteResponse.deserializeBinaryFromReader);
                msg.addQuoteresponse(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsQualified(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreateAllInsuranceQuotesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getQuoteresponseList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.insurance_service.QuoteResponse.serializeBinaryToWriter);
    f = message.getIsQualified();
    if (f) writer.writeBool(2, f);
};
/**
 * repeated QuoteResponse quoteResponse = 1;
 * @return {!Array<!proto.insurance_service.QuoteResponse>}
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.prototype.getQuoteresponseList = function() {
    return /** @type{!Array<!proto.insurance_service.QuoteResponse>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.insurance_service.QuoteResponse, 1);
};
/**
 * @param {!Array<!proto.insurance_service.QuoteResponse>} value
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesResponse} returns this
*/ proto.insurance_service.CreateAllInsuranceQuotesResponse.prototype.setQuoteresponseList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.insurance_service.QuoteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance_service.QuoteResponse}
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.prototype.addQuoteresponse = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.insurance_service.QuoteResponse, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesResponse} returns this
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.prototype.clearQuoteresponseList = function() {
    return this.setQuoteresponseList([]);
};
/**
 * optional bool is_qualified = 2;
 * @return {boolean}
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.prototype.getIsQualified = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance_service.CreateAllInsuranceQuotesResponse} returns this
 */ proto.insurance_service.CreateAllInsuranceQuotesResponse.prototype.setIsQualified = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.SelectInsuranceQuoteRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.SelectInsuranceQuoteRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.SelectInsuranceQuoteRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            quoteId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            deprecatedQuoteId: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.SelectInsuranceQuoteRequest}
 */ proto.insurance_service.SelectInsuranceQuoteRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.SelectInsuranceQuoteRequest;
    return proto.insurance_service.SelectInsuranceQuoteRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.SelectInsuranceQuoteRequest}
 */ proto.insurance_service.SelectInsuranceQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setQuoteId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedQuoteId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.SelectInsuranceQuoteRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.SelectInsuranceQuoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.SelectInsuranceQuoteRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getQuoteId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDeprecatedQuoteId();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.SelectInsuranceQuoteRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.SelectInsuranceQuoteRequest} returns this
 */ proto.insurance_service.SelectInsuranceQuoteRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string quote_id = 3;
 * @return {string}
 */ proto.insurance_service.SelectInsuranceQuoteRequest.prototype.getQuoteId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.SelectInsuranceQuoteRequest} returns this
 */ proto.insurance_service.SelectInsuranceQuoteRequest.prototype.setQuoteId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 deprecated_quote_id = 2;
 * @return {number}
 */ proto.insurance_service.SelectInsuranceQuoteRequest.prototype.getDeprecatedQuoteId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.SelectInsuranceQuoteRequest} returns this
 */ proto.insurance_service.SelectInsuranceQuoteRequest.prototype.setDeprecatedQuoteId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.SelectInsuranceQuoteResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.SelectInsuranceQuoteResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.SelectInsuranceQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.SelectInsuranceQuoteResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.SelectInsuranceQuoteResponse}
 */ proto.insurance_service.SelectInsuranceQuoteResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.SelectInsuranceQuoteResponse;
    return proto.insurance_service.SelectInsuranceQuoteResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.SelectInsuranceQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.SelectInsuranceQuoteResponse}
 */ proto.insurance_service.SelectInsuranceQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.SelectInsuranceQuoteResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.SelectInsuranceQuoteResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.SelectInsuranceQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.SelectInsuranceQuoteResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsuranceQuoteRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsuranceQuoteRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuranceQuoteRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsuranceQuoteRequest}
 */ proto.insurance_service.GetInsuranceQuoteRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsuranceQuoteRequest;
    return proto.insurance_service.GetInsuranceQuoteRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsuranceQuoteRequest}
 */ proto.insurance_service.GetInsuranceQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsuranceQuoteRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsuranceQuoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuranceQuoteRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.insurance_service.GetInsuranceQuoteRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceQuoteRequest} returns this
 */ proto.insurance_service.GetInsuranceQuoteRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.GetInsuranceQuoteRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceQuoteRequest} returns this
 */ proto.insurance_service.GetInsuranceQuoteRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.GetInsuranceQuoteResponse.repeatedFields_ = [
    5
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsuranceQuoteResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsuranceQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuranceQuoteResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            mileageRate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            insuranceSplitLimits: (f = msg.getInsuranceSplitLimits()) && proto.insurance_service.InsuranceSplitLimits.toObject(includeInstance, f),
            isQualified: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            deductible: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            limits: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            quoteId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            deprecatedQuoteId: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse}
 */ proto.insurance_service.GetInsuranceQuoteResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsuranceQuoteResponse;
    return proto.insurance_service.GetInsuranceQuoteResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsuranceQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse}
 */ proto.insurance_service.GetInsuranceQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMileageRate(value);
                break;
            case 5:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 6:
                var value = new proto.insurance_service.InsuranceSplitLimits;
                reader.readMessage(value, proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader);
                msg.setInsuranceSplitLimits(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsQualified(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeductible(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setLimits(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setQuoteId(value);
                break;
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedQuoteId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsuranceQuoteResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsuranceQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuranceQuoteResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMileageRate();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getInsuranceSplitLimits();
    if (f != null) writer.writeMessage(6, f, proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter);
    f = message.getIsQualified();
    if (f) writer.writeBool(7, f);
    f = message.getDeductible();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getLimits();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getQuoteId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getDeprecatedQuoteId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional int32 monthly_rate = 3;
 * @return {number}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 mileage_rate = 4;
 * @return {number}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 5;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 5);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
*/ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional InsuranceSplitLimits insurance_split_limits = 6;
 * @return {?proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getInsuranceSplitLimits = function() {
    return /** @type{?proto.insurance_service.InsuranceSplitLimits} */ $8M67s.Message.getWrapperField(this, proto.insurance_service.InsuranceSplitLimits, 6);
};
/**
 * @param {?proto.insurance_service.InsuranceSplitLimits|undefined} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
*/ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setInsuranceSplitLimits = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.clearInsuranceSplitLimits = function() {
    return this.setInsuranceSplitLimits(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.hasInsuranceSplitLimits = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional bool is_qualified = 7;
 * @return {boolean}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getIsQualified = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setIsQualified = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * optional int32 deductible = 8;
 * @return {number}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string limits = 9;
 * @return {string}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getLimits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setLimits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string quote_id = 10;
 * @return {string}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getQuoteId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setQuoteId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional int32 deprecated_quote_id = 1;
 * @return {number}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getDeprecatedQuoteId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setDeprecatedQuoteId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 daily_rate = 2;
 * @return {number}
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceQuoteResponse} returns this
 */ proto.insurance_service.GetInsuranceQuoteResponse.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreateInsurancePolicyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreateInsurancePolicyRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreateInsurancePolicyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateInsurancePolicyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            quoteId: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreateInsurancePolicyRequest}
 */ proto.insurance_service.CreateInsurancePolicyRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreateInsurancePolicyRequest;
    return proto.insurance_service.CreateInsurancePolicyRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreateInsurancePolicyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreateInsurancePolicyRequest}
 */ proto.insurance_service.CreateInsurancePolicyRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setQuoteId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreateInsurancePolicyRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreateInsurancePolicyRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreateInsurancePolicyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreateInsurancePolicyRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getQuoteId();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.CreateInsurancePolicyRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateInsurancePolicyRequest} returns this
 */ proto.insurance_service.CreateInsurancePolicyRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 quote_id = 2;
 * @return {number}
 */ proto.insurance_service.CreateInsurancePolicyRequest.prototype.getQuoteId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreateInsurancePolicyRequest} returns this
 */ proto.insurance_service.CreateInsurancePolicyRequest.prototype.setQuoteId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.insurance_service.CreateInsurancePolicyRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreateInsurancePolicyRequest} returns this
 */ proto.insurance_service.CreateInsurancePolicyRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetOwnInsurancePoliciesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetOwnInsurancePoliciesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetOwnInsurancePoliciesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetOwnInsurancePoliciesRequest}
 */ proto.insurance_service.GetOwnInsurancePoliciesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetOwnInsurancePoliciesRequest;
    return proto.insurance_service.GetOwnInsurancePoliciesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetOwnInsurancePoliciesRequest}
 */ proto.insurance_service.GetOwnInsurancePoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetOwnInsurancePoliciesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetOwnInsurancePoliciesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetOwnInsurancePoliciesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.GetInsurancePoliciesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsurancePoliciesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsurancePoliciesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsurancePoliciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsurancePoliciesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            insurancePoliciesList: $8M67s.Message.toObjectList(msg.getInsurancePoliciesList(), $3QqPt.InsurancePolicy.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsurancePoliciesResponse}
 */ proto.insurance_service.GetInsurancePoliciesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsurancePoliciesResponse;
    return proto.insurance_service.GetInsurancePoliciesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsurancePoliciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsurancePoliciesResponse}
 */ proto.insurance_service.GetInsurancePoliciesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.InsurancePolicy;
                reader.readMessage(value, $3QqPt.InsurancePolicy.deserializeBinaryFromReader);
                msg.addInsurancePolicies(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsurancePoliciesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsurancePoliciesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsurancePoliciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsurancePoliciesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInsurancePoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.InsurancePolicy.serializeBinaryToWriter);
};
/**
 * repeated domain.InsurancePolicy insurance_policies = 1;
 * @return {!Array<!proto.domain.InsurancePolicy>}
 */ proto.insurance_service.GetInsurancePoliciesResponse.prototype.getInsurancePoliciesList = function() {
    return /** @type{!Array<!proto.domain.InsurancePolicy>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.InsurancePolicy, 1);
};
/**
 * @param {!Array<!proto.domain.InsurancePolicy>} value
 * @return {!proto.insurance_service.GetInsurancePoliciesResponse} returns this
*/ proto.insurance_service.GetInsurancePoliciesResponse.prototype.setInsurancePoliciesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.InsurancePolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.InsurancePolicy}
 */ proto.insurance_service.GetInsurancePoliciesResponse.prototype.addInsurancePolicies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.InsurancePolicy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.GetInsurancePoliciesResponse} returns this
 */ proto.insurance_service.GetInsurancePoliciesResponse.prototype.clearInsurancePoliciesList = function() {
    return this.setInsurancePoliciesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsurancePolicyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsurancePolicyRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsurancePolicyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsurancePolicyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsurancePolicyRequest}
 */ proto.insurance_service.GetInsurancePolicyRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsurancePolicyRequest;
    return proto.insurance_service.GetInsurancePolicyRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsurancePolicyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsurancePolicyRequest}
 */ proto.insurance_service.GetInsurancePolicyRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsurancePolicyRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsurancePolicyRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsurancePolicyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsurancePolicyRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.insurance_service.GetInsurancePolicyRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsurancePolicyRequest} returns this
 */ proto.insurance_service.GetInsurancePolicyRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.GetInsurancePolicyRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsurancePolicyRequest} returns this
 */ proto.insurance_service.GetInsurancePolicyRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsurancePolicyResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsurancePolicyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsurancePolicyResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            policyNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            effectiveDate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            expirationDate: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            excessMileageRate: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            insuranceCardDocumentId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            insuranceSplitLimits: (f = msg.getInsuranceSplitLimits()) && proto.insurance_service.InsuranceSplitLimits.toObject(includeInstance, f),
            deductible: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            limits: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            policyId: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            deprecatedPolicyId: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsurancePolicyResponse}
 */ proto.insurance_service.GetInsurancePolicyResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsurancePolicyResponse;
    return proto.insurance_service.GetInsurancePolicyResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsurancePolicyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsurancePolicyResponse}
 */ proto.insurance_service.GetInsurancePolicyResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyNumber(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setEffectiveDate(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setExpirationDate(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setExcessMileageRate(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceCardDocumentId(value);
                break;
            case 10:
                var value = new proto.insurance_service.InsuranceSplitLimits;
                reader.readMessage(value, proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader);
                msg.setInsuranceSplitLimits(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeductible(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setLimits(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedPolicyId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsurancePolicyResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsurancePolicyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsurancePolicyResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getPolicyNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getEffectiveDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getExpirationDate();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getExcessMileageRate();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getInsuranceCardDocumentId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getInsuranceSplitLimits();
    if (f != null) writer.writeMessage(10, f, proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter);
    f = message.getDeductible();
    if (f !== 0) writer.writeInt32(11, f);
    f = message.getLimits();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getPolicyId();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getDeprecatedPolicyId();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string policy_number = 3;
 * @return {string}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getPolicyNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setPolicyNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 effective_date = 4;
 * @return {number}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getEffectiveDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setEffectiveDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 expiration_date = 5;
 * @return {number}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 daily_rate = 6;
 * @return {number}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 monthly_rate = 7;
 * @return {number}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 excess_mileage_rate = 8;
 * @return {number}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getExcessMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setExcessMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string insurance_card_document_id = 9;
 * @return {string}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getInsuranceCardDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setInsuranceCardDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional InsuranceSplitLimits insurance_split_limits = 10;
 * @return {?proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getInsuranceSplitLimits = function() {
    return /** @type{?proto.insurance_service.InsuranceSplitLimits} */ $8M67s.Message.getWrapperField(this, proto.insurance_service.InsuranceSplitLimits, 10);
};
/**
 * @param {?proto.insurance_service.InsuranceSplitLimits|undefined} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
*/ proto.insurance_service.GetInsurancePolicyResponse.prototype.setInsuranceSplitLimits = function(value) {
    return $8M67s.Message.setWrapperField(this, 10, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.clearInsuranceSplitLimits = function() {
    return this.setInsuranceSplitLimits(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.hasInsuranceSplitLimits = function() {
    return $8M67s.Message.getField(this, 10) != null;
};
/**
 * optional int32 deductible = 11;
 * @return {number}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional string limits = 12;
 * @return {string}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getLimits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setLimits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string policy_id = 13;
 * @return {string}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getPolicyId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setPolicyId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional int32 deprecated_policy_id = 2;
 * @return {number}
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.getDeprecatedPolicyId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsurancePolicyResponse} returns this
 */ proto.insurance_service.GetInsurancePolicyResponse.prototype.setDeprecatedPolicyId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.QuoteResponse.repeatedFields_ = [
    5
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.QuoteResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.QuoteResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.QuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.QuoteResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            mileageRate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            insuranceSplitLimits: (f = msg.getInsuranceSplitLimits()) && proto.insurance_service.InsuranceSplitLimits.toObject(includeInstance, f),
            deductible: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            limits: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            quoteId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            state: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            zip: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            vehicleMake: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            vehicleModel: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            vehicleVin: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            createdAt: $8M67s.Message.getFieldWithDefault(msg, 15, ""),
            deprecatedQuoteId: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.QuoteResponse}
 */ proto.insurance_service.QuoteResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.QuoteResponse;
    return proto.insurance_service.QuoteResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.QuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.QuoteResponse}
 */ proto.insurance_service.QuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMileageRate(value);
                break;
            case 5:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 6:
                var value = new proto.insurance_service.InsuranceSplitLimits;
                reader.readMessage(value, proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader);
                msg.setInsuranceSplitLimits(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeductible(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setLimits(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setQuoteId(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setState(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setZip(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleMake(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleModel(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleVin(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setCreatedAt(value);
                break;
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedQuoteId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.QuoteResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.QuoteResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.QuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.QuoteResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMileageRate();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getInsuranceSplitLimits();
    if (f != null) writer.writeMessage(6, f, proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter);
    f = message.getDeductible();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getLimits();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getQuoteId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getState();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getZip();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getVehicleMake();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getVehicleModel();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getVehicleVin();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getCreatedAt();
    if (f.length > 0) writer.writeString(15, f);
    f = message.getDeprecatedQuoteId();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * optional int32 daily_rate = 2;
 * @return {number}
 */ proto.insurance_service.QuoteResponse.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 monthly_rate = 3;
 * @return {number}
 */ proto.insurance_service.QuoteResponse.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 mileage_rate = 4;
 * @return {number}
 */ proto.insurance_service.QuoteResponse.prototype.getMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 5;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.QuoteResponse.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 5);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
*/ proto.insurance_service.QuoteResponse.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.QuoteResponse.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional InsuranceSplitLimits insurance_split_limits = 6;
 * @return {?proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.QuoteResponse.prototype.getInsuranceSplitLimits = function() {
    return /** @type{?proto.insurance_service.InsuranceSplitLimits} */ $8M67s.Message.getWrapperField(this, proto.insurance_service.InsuranceSplitLimits, 6);
};
/**
 * @param {?proto.insurance_service.InsuranceSplitLimits|undefined} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
*/ proto.insurance_service.QuoteResponse.prototype.setInsuranceSplitLimits = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.clearInsuranceSplitLimits = function() {
    return this.setInsuranceSplitLimits(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.insurance_service.QuoteResponse.prototype.hasInsuranceSplitLimits = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional int32 deductible = 7;
 * @return {number}
 */ proto.insurance_service.QuoteResponse.prototype.getDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string limits = 8;
 * @return {string}
 */ proto.insurance_service.QuoteResponse.prototype.getLimits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setLimits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string quote_id = 9;
 * @return {string}
 */ proto.insurance_service.QuoteResponse.prototype.getQuoteId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setQuoteId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string state = 10;
 * @return {string}
 */ proto.insurance_service.QuoteResponse.prototype.getState = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setState = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string zip = 11;
 * @return {string}
 */ proto.insurance_service.QuoteResponse.prototype.getZip = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setZip = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string vehicle_make = 12;
 * @return {string}
 */ proto.insurance_service.QuoteResponse.prototype.getVehicleMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setVehicleMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string vehicle_model = 13;
 * @return {string}
 */ proto.insurance_service.QuoteResponse.prototype.getVehicleModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setVehicleModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string vehicle_vin = 14;
 * @return {string}
 */ proto.insurance_service.QuoteResponse.prototype.getVehicleVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setVehicleVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional string created_at = 15;
 * @return {string}
 */ proto.insurance_service.QuoteResponse.prototype.getCreatedAt = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setCreatedAt = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
/**
 * optional int32 deprecated_quote_id = 1;
 * @return {number}
 */ proto.insurance_service.QuoteResponse.prototype.getDeprecatedQuoteId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.QuoteResponse} returns this
 */ proto.insurance_service.QuoteResponse.prototype.setDeprecatedQuoteId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.InsuranceSplitLimits.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.InsuranceSplitLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.InsuranceSplitLimits.toObject = function(includeInstance, msg) {
        var f, obj = {
            liabilityPerPerson: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            liabilityPerAccident: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            liabilityPropertyDamage: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            uninsuredPerPerson: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            uninsuredPerAccident: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            medicalPayments: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            comprehensiveDeductible: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            collisionDeductible: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            rentalReimbursement: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            rentalReimbursementMaxDays: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            towingAndLabor: $8M67s.Message.getFieldWithDefault(msg, 12, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.InsuranceSplitLimits.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.InsuranceSplitLimits;
    return proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.InsuranceSplitLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLiabilityPerPerson(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLiabilityPerAccident(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLiabilityPropertyDamage(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setUninsuredPerPerson(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setUninsuredPerAccident(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMedicalPayments(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setComprehensiveDeductible(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setCollisionDeductible(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRentalReimbursement(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRentalReimbursementMaxDays(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTowingAndLabor(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.InsuranceSplitLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLiabilityPerPerson();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getLiabilityPerAccident();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getLiabilityPropertyDamage();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getUninsuredPerPerson();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getUninsuredPerAccident();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getMedicalPayments();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getComprehensiveDeductible();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getCollisionDeductible();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getRentalReimbursement();
    if (f !== 0) writer.writeInt32(10, f);
    f = message.getRentalReimbursementMaxDays();
    if (f !== 0) writer.writeInt32(11, f);
    f = message.getTowingAndLabor();
    if (f !== 0) writer.writeInt32(12, f);
};
/**
 * optional int32 liability_per_person = 1;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getLiabilityPerPerson = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setLiabilityPerPerson = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 liability_per_accident = 2;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getLiabilityPerAccident = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setLiabilityPerAccident = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 liability_property_damage = 3;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getLiabilityPropertyDamage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setLiabilityPropertyDamage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 uninsured_per_person = 4;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getUninsuredPerPerson = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setUninsuredPerPerson = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 uninsured_per_accident = 5;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getUninsuredPerAccident = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setUninsuredPerAccident = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 medical_payments = 7;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getMedicalPayments = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setMedicalPayments = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 comprehensive_deductible = 8;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getComprehensiveDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setComprehensiveDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 collision_deductible = 9;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getCollisionDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setCollisionDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 rental_reimbursement = 10;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getRentalReimbursement = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setRentalReimbursement = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int32 rental_reimbursement_max_days = 11;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getRentalReimbursementMaxDays = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setRentalReimbursementMaxDays = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int32 towing_and_labor = 12;
 * @return {number}
 */ proto.insurance_service.InsuranceSplitLimits.prototype.getTowingAndLabor = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsuranceSplitLimits} returns this
 */ proto.insurance_service.InsuranceSplitLimits.prototype.setTowingAndLabor = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreatePolicyChangeQuoteRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreatePolicyChangeQuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteRequest}
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreatePolicyChangeQuoteRequest;
    return proto.insurance_service.CreatePolicyChangeQuoteRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreatePolicyChangeQuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteRequest}
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreatePolicyChangeQuoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreatePolicyChangeQuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 4;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteRequest} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 3;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 3);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteRequest} returns this
*/ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteRequest} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteRequest} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.repeatedFields_ = [
    5
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreatePolicyChangeQuoteResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreatePolicyChangeQuoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            mileageRate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            insuranceSplitLimits: (f = msg.getInsuranceSplitLimits()) && proto.insurance_service.InsuranceSplitLimits.toObject(includeInstance, f),
            deductible: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            limits: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            quoteId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            deprecatedQuoteId: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreatePolicyChangeQuoteResponse;
    return proto.insurance_service.CreatePolicyChangeQuoteResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreatePolicyChangeQuoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMileageRate(value);
                break;
            case 5:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 6:
                var value = new proto.insurance_service.InsuranceSplitLimits;
                reader.readMessage(value, proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader);
                msg.setInsuranceSplitLimits(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeductible(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setLimits(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setQuoteId(value);
                break;
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedQuoteId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreatePolicyChangeQuoteResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreatePolicyChangeQuoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMileageRate();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getInsuranceSplitLimits();
    if (f != null) writer.writeMessage(6, f, proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter);
    f = message.getDeductible();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getLimits();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getQuoteId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getDeprecatedQuoteId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional int32 monthly_rate = 3;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 mileage_rate = 4;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 5;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 5);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
*/ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional InsuranceSplitLimits insurance_split_limits = 6;
 * @return {?proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getInsuranceSplitLimits = function() {
    return /** @type{?proto.insurance_service.InsuranceSplitLimits} */ $8M67s.Message.getWrapperField(this, proto.insurance_service.InsuranceSplitLimits, 6);
};
/**
 * @param {?proto.insurance_service.InsuranceSplitLimits|undefined} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
*/ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setInsuranceSplitLimits = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.clearInsuranceSplitLimits = function() {
    return this.setInsuranceSplitLimits(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.hasInsuranceSplitLimits = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional int32 deductible = 7;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string limits = 8;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getLimits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setLimits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string quote_id = 9;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getQuoteId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setQuoteId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional int32 deprecated_quote_id = 1;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getDeprecatedQuoteId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setDeprecatedQuoteId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 daily_rate = 2;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeQuoteResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeQuoteResponse.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreatePolicyChangeRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreatePolicyChangeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreatePolicyChangeRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            quoteId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            deprecatedQuoteId: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreatePolicyChangeRequest}
 */ proto.insurance_service.CreatePolicyChangeRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreatePolicyChangeRequest;
    return proto.insurance_service.CreatePolicyChangeRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreatePolicyChangeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreatePolicyChangeRequest}
 */ proto.insurance_service.CreatePolicyChangeRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setQuoteId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedQuoteId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreatePolicyChangeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreatePolicyChangeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreatePolicyChangeRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getQuoteId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getDeprecatedQuoteId();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeRequest} returns this
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeRequest} returns this
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string quote_id = 4;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.getQuoteId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeRequest} returns this
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.setQuoteId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 deprecated_quote_id = 2;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.getDeprecatedQuoteId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeRequest} returns this
 */ proto.insurance_service.CreatePolicyChangeRequest.prototype.setDeprecatedQuoteId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.CreatePolicyChangeResponse.repeatedFields_ = [
    5
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CreatePolicyChangeResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CreatePolicyChangeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreatePolicyChangeResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            mileageRate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            insuranceSplitLimits: (f = msg.getInsuranceSplitLimits()) && proto.insurance_service.InsuranceSplitLimits.toObject(includeInstance, f),
            deductible: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            limits: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            quoteId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            deprecatedQuoteId: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CreatePolicyChangeResponse}
 */ proto.insurance_service.CreatePolicyChangeResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CreatePolicyChangeResponse;
    return proto.insurance_service.CreatePolicyChangeResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CreatePolicyChangeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CreatePolicyChangeResponse}
 */ proto.insurance_service.CreatePolicyChangeResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMileageRate(value);
                break;
            case 5:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 6:
                var value = new proto.insurance_service.InsuranceSplitLimits;
                reader.readMessage(value, proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader);
                msg.setInsuranceSplitLimits(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeductible(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setLimits(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setQuoteId(value);
                break;
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedQuoteId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CreatePolicyChangeResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CreatePolicyChangeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CreatePolicyChangeResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMileageRate();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getInsuranceSplitLimits();
    if (f != null) writer.writeMessage(6, f, proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter);
    f = message.getDeductible();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getLimits();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getQuoteId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getDeprecatedQuoteId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional int32 monthly_rate = 3;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 mileage_rate = 4;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.setMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 5;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 5);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
*/ proto.insurance_service.CreatePolicyChangeResponse.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional InsuranceSplitLimits insurance_split_limits = 6;
 * @return {?proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getInsuranceSplitLimits = function() {
    return /** @type{?proto.insurance_service.InsuranceSplitLimits} */ $8M67s.Message.getWrapperField(this, proto.insurance_service.InsuranceSplitLimits, 6);
};
/**
 * @param {?proto.insurance_service.InsuranceSplitLimits|undefined} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
*/ proto.insurance_service.CreatePolicyChangeResponse.prototype.setInsuranceSplitLimits = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.clearInsuranceSplitLimits = function() {
    return this.setInsuranceSplitLimits(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.hasInsuranceSplitLimits = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional int32 deductible = 7;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.setDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string limits = 8;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getLimits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.setLimits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string quote_id = 9;
 * @return {string}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getQuoteId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.setQuoteId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional int32 deprecated_quote_id = 1;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getDeprecatedQuoteId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.setDeprecatedQuoteId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 daily_rate = 2;
 * @return {number}
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CreatePolicyChangeResponse} returns this
 */ proto.insurance_service.CreatePolicyChangeResponse.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.QualifyForLibertyInsuranceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.QualifyForLibertyInsuranceRequest}
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.QualifyForLibertyInsuranceRequest;
    return proto.insurance_service.QualifyForLibertyInsuranceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.QualifyForLibertyInsuranceRequest}
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.QualifyForLibertyInsuranceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.QualifyForLibertyInsuranceRequest} returns this
 */ proto.insurance_service.QualifyForLibertyInsuranceRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.QualifyForLibertyInsuranceResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            isQualified: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.QualifyForLibertyInsuranceResponse}
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.QualifyForLibertyInsuranceResponse;
    return proto.insurance_service.QualifyForLibertyInsuranceResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.QualifyForLibertyInsuranceResponse}
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsQualified(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.QualifyForLibertyInsuranceResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getIsQualified();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool is_qualified = 1;
 * @return {boolean}
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse.prototype.getIsQualified = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance_service.QualifyForLibertyInsuranceResponse} returns this
 */ proto.insurance_service.QualifyForLibertyInsuranceResponse.prototype.setIsQualified = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsuredDriversRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsuredDriversRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsuredDriversRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuredDriversRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsuredDriversRequest}
 */ proto.insurance_service.GetInsuredDriversRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsuredDriversRequest;
    return proto.insurance_service.GetInsuredDriversRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsuredDriversRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsuredDriversRequest}
 */ proto.insurance_service.GetInsuredDriversRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsuredDriversRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsuredDriversRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsuredDriversRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuredDriversRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.insurance_service.GetInsuredDriversRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuredDriversRequest} returns this
 */ proto.insurance_service.GetInsuredDriversRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.GetInsuredDriversRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuredDriversRequest} returns this
 */ proto.insurance_service.GetInsuredDriversRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.GetInsuredDriversResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsuredDriversResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsuredDriversResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsuredDriversResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuredDriversResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            driversList: $8M67s.Message.toObjectList(msg.getDriversList(), $gQESC.Driver.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsuredDriversResponse}
 */ proto.insurance_service.GetInsuredDriversResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsuredDriversResponse;
    return proto.insurance_service.GetInsuredDriversResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsuredDriversResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsuredDriversResponse}
 */ proto.insurance_service.GetInsuredDriversResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $gQESC.Driver;
                reader.readMessage(value, $gQESC.Driver.deserializeBinaryFromReader);
                msg.addDrivers(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsuredDriversResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsuredDriversResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsuredDriversResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuredDriversResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $gQESC.Driver.serializeBinaryToWriter);
};
/**
 * repeated insurance.Driver drivers = 1;
 * @return {!Array<!proto.insurance.Driver>}
 */ proto.insurance_service.GetInsuredDriversResponse.prototype.getDriversList = function() {
    return /** @type{!Array<!proto.insurance.Driver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.Driver, 1);
};
/**
 * @param {!Array<!proto.insurance.Driver>} value
 * @return {!proto.insurance_service.GetInsuredDriversResponse} returns this
*/ proto.insurance_service.GetInsuredDriversResponse.prototype.setDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.insurance.Driver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.Driver}
 */ proto.insurance_service.GetInsuredDriversResponse.prototype.addDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.insurance.Driver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.GetInsuredDriversResponse} returns this
 */ proto.insurance_service.GetInsuredDriversResponse.prototype.clearDriversList = function() {
    return this.setDriversList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CancelInsurancePolicyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CancelInsurancePolicyRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CancelInsurancePolicyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            endDateMilli: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CancelInsurancePolicyRequest}
 */ proto.insurance_service.CancelInsurancePolicyRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CancelInsurancePolicyRequest;
    return proto.insurance_service.CancelInsurancePolicyRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CancelInsurancePolicyRequest}
 */ proto.insurance_service.CancelInsurancePolicyRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setEndDateMilli(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CancelInsurancePolicyRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CancelInsurancePolicyRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CancelInsurancePolicyRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getEndDateMilli();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.insurance_service.CancelInsurancePolicyRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CancelInsurancePolicyRequest} returns this
 */ proto.insurance_service.CancelInsurancePolicyRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.CancelInsurancePolicyRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.CancelInsurancePolicyRequest} returns this
 */ proto.insurance_service.CancelInsurancePolicyRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 end_date_milli = 2;
 * @return {number}
 */ proto.insurance_service.CancelInsurancePolicyRequest.prototype.getEndDateMilli = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.CancelInsurancePolicyRequest} returns this
 */ proto.insurance_service.CancelInsurancePolicyRequest.prototype.setEndDateMilli = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.CancelInsurancePolicyResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.CancelInsurancePolicyResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.CancelInsurancePolicyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CancelInsurancePolicyResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.CancelInsurancePolicyResponse}
 */ proto.insurance_service.CancelInsurancePolicyResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.CancelInsurancePolicyResponse;
    return proto.insurance_service.CancelInsurancePolicyResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.CancelInsurancePolicyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.CancelInsurancePolicyResponse}
 */ proto.insurance_service.CancelInsurancePolicyResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.CancelInsurancePolicyResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.CancelInsurancePolicyResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.CancelInsurancePolicyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.CancelInsurancePolicyResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.insurance_service.CancelInsurancePolicyResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance_service.CancelInsurancePolicyResponse} returns this
 */ proto.insurance_service.CancelInsurancePolicyResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.ExtendInsurancePolicyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.ExtendInsurancePolicyRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.ExtendInsurancePolicyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ExtendInsurancePolicyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.ExtendInsurancePolicyRequest}
 */ proto.insurance_service.ExtendInsurancePolicyRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.ExtendInsurancePolicyRequest;
    return proto.insurance_service.ExtendInsurancePolicyRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.ExtendInsurancePolicyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.ExtendInsurancePolicyRequest}
 */ proto.insurance_service.ExtendInsurancePolicyRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.ExtendInsurancePolicyRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.ExtendInsurancePolicyRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.ExtendInsurancePolicyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ExtendInsurancePolicyRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.ExtendInsurancePolicyRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyRequest} returns this
 */ proto.insurance_service.ExtendInsurancePolicyRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.ExtendInsurancePolicyResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.ExtendInsurancePolicyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ExtendInsurancePolicyResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            policyId: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            policyNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            effectiveDate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            expirationDate: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            excessMileageRate: $8M67s.Message.getFieldWithDefault(msg, 8, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.ExtendInsurancePolicyResponse;
    return proto.insurance_service.ExtendInsurancePolicyResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.ExtendInsurancePolicyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPolicyId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyNumber(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setEffectiveDate(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setExpirationDate(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setExcessMileageRate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.ExtendInsurancePolicyResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.ExtendInsurancePolicyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ExtendInsurancePolicyResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPolicyId();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getPolicyNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getEffectiveDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getExpirationDate();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getExcessMileageRate();
    if (f !== 0) writer.writeInt32(8, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse} returns this
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 policy_id = 2;
 * @return {number}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.getPolicyId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse} returns this
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.setPolicyId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string policy_number = 3;
 * @return {string}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.getPolicyNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse} returns this
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.setPolicyNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 effective_date = 4;
 * @return {number}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.getEffectiveDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse} returns this
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.setEffectiveDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 expiration_date = 5;
 * @return {number}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.getExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse} returns this
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.setExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 daily_rate = 6;
 * @return {number}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse} returns this
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 monthly_rate = 7;
 * @return {number}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse} returns this
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 excess_mileage_rate = 8;
 * @return {number}
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.getExcessMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.ExtendInsurancePolicyResponse} returns this
 */ proto.insurance_service.ExtendInsurancePolicyResponse.prototype.setExcessMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetUpdatedInsurancePolicyCardRequest;
    return proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest} returns this
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetUpdatedInsurancePolicyCardResponse}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetUpdatedInsurancePolicyCardResponse;
    return proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetUpdatedInsurancePolicyCardResponse}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string document_id = 1;
 * @return {string}
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.prototype.getDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetUpdatedInsurancePolicyCardResponse} returns this
 */ proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.prototype.setDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsuranceStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsuranceStatusRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsuranceStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuranceStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsuranceStatusRequest}
 */ proto.insurance_service.GetInsuranceStatusRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsuranceStatusRequest;
    return proto.insurance_service.GetInsuranceStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsuranceStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsuranceStatusRequest}
 */ proto.insurance_service.GetInsuranceStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsuranceStatusRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsuranceStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsuranceStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuranceStatusRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.GetInsuranceStatusRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceStatusRequest} returns this
 */ proto.insurance_service.GetInsuranceStatusRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.insurance_service.GetInsuranceStatusRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceStatusRequest} returns this
 */ proto.insurance_service.GetInsuranceStatusRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetInsuranceStatusResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetInsuranceStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuranceStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            policyId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            effectiveDate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            excessMileageRate: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            isQualified: $8M67s.Message.getBooleanFieldWithDefault(msg, 9, false),
            status: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            deprecatedPolicyId: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            expirationDate: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetInsuranceStatusResponse}
 */ proto.insurance_service.GetInsuranceStatusResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetInsuranceStatusResponse;
    return proto.insurance_service.GetInsuranceStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetInsuranceStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetInsuranceStatusResponse}
 */ proto.insurance_service.GetInsuranceStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setEffectiveDate(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setExcessMileageRate(value);
                break;
            case 9:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsQualified(value);
                break;
            case 10:
                var value = /** @type {!proto.insurance.PolicyStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedPolicyId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setExpirationDate(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetInsuranceStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetInsuranceStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetInsuranceStatusResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPolicyId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getEffectiveDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getExcessMileageRate();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getIsQualified();
    if (f) writer.writeBool(9, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(10, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getDeprecatedPolicyId();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getExpirationDate();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(6, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string policy_id = 3;
 * @return {string}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getPolicyId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setPolicyId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 effective_date = 4;
 * @return {number}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getEffectiveDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setEffectiveDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 monthly_rate = 7;
 * @return {number}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 excess_mileage_rate = 8;
 * @return {number}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getExcessMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setExcessMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional bool is_qualified = 9;
 * @return {boolean}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getIsQualified = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 9, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setIsQualified = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 9, value);
};
/**
 * optional insurance.PolicyStatus status = 10;
 * @return {!proto.insurance.PolicyStatus}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getStatus = function() {
    return /** @type {!proto.insurance.PolicyStatus} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {!proto.insurance.PolicyStatus} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 10, value);
};
/**
 * optional string subscription_id = 11;
 * @return {string}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional int32 deprecated_policy_id = 2;
 * @return {number}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getDeprecatedPolicyId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setDeprecatedPolicyId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int64 expiration_date = 5;
 * @return {number}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 daily_rate = 6;
 * @return {number}
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetInsuranceStatusResponse} returns this
 */ proto.insurance_service.GetInsuranceStatusResponse.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.BulkUpdatePoliciesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.BulkUpdatePoliciesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.BulkUpdatePoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.BulkUpdatePoliciesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            cutoffDateUnixMilli: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.BulkUpdatePoliciesRequest}
 */ proto.insurance_service.BulkUpdatePoliciesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.BulkUpdatePoliciesRequest;
    return proto.insurance_service.BulkUpdatePoliciesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.BulkUpdatePoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.BulkUpdatePoliciesRequest}
 */ proto.insurance_service.BulkUpdatePoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCutoffDateUnixMilli(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.BulkUpdatePoliciesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.BulkUpdatePoliciesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.BulkUpdatePoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.BulkUpdatePoliciesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCutoffDateUnixMilli();
    if (f !== 0) writer.writeInt64(1, f);
};
/**
 * optional int64 cutoff_date_unix_milli = 1;
 * @return {number}
 */ proto.insurance_service.BulkUpdatePoliciesRequest.prototype.getCutoffDateUnixMilli = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.BulkUpdatePoliciesRequest} returns this
 */ proto.insurance_service.BulkUpdatePoliciesRequest.prototype.setCutoffDateUnixMilli = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.BulkUpdatePoliciesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.BulkUpdatePoliciesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.BulkUpdatePoliciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.BulkUpdatePoliciesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.BulkUpdatePoliciesResponse}
 */ proto.insurance_service.BulkUpdatePoliciesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.BulkUpdatePoliciesResponse;
    return proto.insurance_service.BulkUpdatePoliciesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.BulkUpdatePoliciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.BulkUpdatePoliciesResponse}
 */ proto.insurance_service.BulkUpdatePoliciesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.BulkUpdatePoliciesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.BulkUpdatePoliciesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.BulkUpdatePoliciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.BulkUpdatePoliciesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetExternalPoliciesFromDsotRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetExternalPoliciesFromDsotRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            batchSize: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            wait: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetExternalPoliciesFromDsotRequest}
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetExternalPoliciesFromDsotRequest;
    return proto.insurance_service.GetExternalPoliciesFromDsotRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetExternalPoliciesFromDsotRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetExternalPoliciesFromDsotRequest}
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setBatchSize(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setWait(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetExternalPoliciesFromDsotRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetExternalPoliciesFromDsotRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getBatchSize();
    if (f !== 0) writer.writeUint32(1, f);
    f = message.getWait();
    if (f) writer.writeBool(2, f);
};
/**
 * optional uint32 batch_size = 1;
 * @return {number}
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.prototype.getBatchSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.GetExternalPoliciesFromDsotRequest} returns this
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.prototype.setBatchSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bool wait = 2;
 * @return {boolean}
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.prototype.getWait = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance_service.GetExternalPoliciesFromDsotRequest} returns this
 */ proto.insurance_service.GetExternalPoliciesFromDsotRequest.prototype.setWait = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetExternalPoliciesFromDsotResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetExternalPoliciesFromDsotResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetExternalPoliciesFromDsotResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetExternalPoliciesFromDsotResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetExternalPoliciesFromDsotResponse}
 */ proto.insurance_service.GetExternalPoliciesFromDsotResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetExternalPoliciesFromDsotResponse;
    return proto.insurance_service.GetExternalPoliciesFromDsotResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetExternalPoliciesFromDsotResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetExternalPoliciesFromDsotResponse}
 */ proto.insurance_service.GetExternalPoliciesFromDsotResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetExternalPoliciesFromDsotResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetExternalPoliciesFromDsotResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetExternalPoliciesFromDsotResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetExternalPoliciesFromDsotResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.ImportInsuranceDataRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.ImportInsuranceDataRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.ImportInsuranceDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ImportInsuranceDataRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.ImportInsuranceDataRequest}
 */ proto.insurance_service.ImportInsuranceDataRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.ImportInsuranceDataRequest;
    return proto.insurance_service.ImportInsuranceDataRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.ImportInsuranceDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.ImportInsuranceDataRequest}
 */ proto.insurance_service.ImportInsuranceDataRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.ImportInsuranceDataRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.ImportInsuranceDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.ImportInsuranceDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ImportInsuranceDataRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.ImportInsuranceDataResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.ImportInsuranceDataResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.ImportInsuranceDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ImportInsuranceDataResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.ImportInsuranceDataResponse}
 */ proto.insurance_service.ImportInsuranceDataResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.ImportInsuranceDataResponse;
    return proto.insurance_service.ImportInsuranceDataResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.ImportInsuranceDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.ImportInsuranceDataResponse}
 */ proto.insurance_service.ImportInsuranceDataResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.ImportInsuranceDataResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.ImportInsuranceDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.ImportInsuranceDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ImportInsuranceDataResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.IsQualifiedForLiberty.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.IsQualifiedForLiberty.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.IsQualifiedForLiberty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.IsQualifiedForLiberty.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            isQualified: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.IsQualifiedForLiberty}
 */ proto.insurance_service.IsQualifiedForLiberty.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.IsQualifiedForLiberty;
    return proto.insurance_service.IsQualifiedForLiberty.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.IsQualifiedForLiberty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.IsQualifiedForLiberty}
 */ proto.insurance_service.IsQualifiedForLiberty.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsQualified(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.IsQualifiedForLiberty.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.IsQualifiedForLiberty.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.IsQualifiedForLiberty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.IsQualifiedForLiberty.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getIsQualified();
    if (f) writer.writeBool(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.IsQualifiedForLiberty.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.IsQualifiedForLiberty} returns this
 */ proto.insurance_service.IsQualifiedForLiberty.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool is_qualified = 2;
 * @return {boolean}
 */ proto.insurance_service.IsQualifiedForLiberty.prototype.getIsQualified = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance_service.IsQualifiedForLiberty} returns this
 */ proto.insurance_service.IsQualifiedForLiberty.prototype.setIsQualified = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.InsurancePolicyCreated.repeatedFields_ = [
    11
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.InsurancePolicyCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.InsurancePolicyCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.InsurancePolicyCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            dailyRate: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            excessMileageRate: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            insuranceCardDocumentId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            insuranceSplitLimits: (f = msg.getInsuranceSplitLimits()) && proto.insurance_service.InsuranceSplitLimits.toObject(includeInstance, f),
            additionalDriversList: $8M67s.Message.toObjectList(msg.getAdditionalDriversList(), $gQESC.AdditionalDriver.toObject, includeInstance),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            deductible: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            limits: $8M67s.Message.getFieldWithDefault(msg, 17, ""),
            policyId: $8M67s.Message.getFieldWithDefault(msg, 18, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 19, ""),
            deprecatedPolicyId: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            deprecatedPolicyNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            deprecatedEffectiveDate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            deprecatedExpirationDate: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.InsurancePolicyCreated}
 */ proto.insurance_service.InsurancePolicyCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.InsurancePolicyCreated;
    return proto.insurance_service.InsurancePolicyCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.InsurancePolicyCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.InsurancePolicyCreated}
 */ proto.insurance_service.InsurancePolicyCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDailyRate(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setExcessMileageRate(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceCardDocumentId(value);
                break;
            case 10:
                var value = new proto.insurance_service.InsuranceSplitLimits;
                reader.readMessage(value, proto.insurance_service.InsuranceSplitLimits.deserializeBinaryFromReader);
                msg.setInsuranceSplitLimits(value);
                break;
            case 11:
                var value = new $gQESC.AdditionalDriver;
                reader.readMessage(value, $gQESC.AdditionalDriver.deserializeBinaryFromReader);
                msg.addAdditionalDrivers(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt32();
                msg.setYear(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeductible(value);
                break;
            case 17:
                var value = /** @type {string} */ reader.readString();
                msg.setLimits(value);
                break;
            case 18:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyId(value);
                break;
            case 19:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeprecatedPolicyId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDeprecatedPolicyNumber(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDeprecatedEffectiveDate(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDeprecatedExpirationDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.InsurancePolicyCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.InsurancePolicyCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.InsurancePolicyCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDailyRate();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getExcessMileageRate();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getInsuranceCardDocumentId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getInsuranceSplitLimits();
    if (f != null) writer.writeMessage(10, f, proto.insurance_service.InsuranceSplitLimits.serializeBinaryToWriter);
    f = message.getAdditionalDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(11, f, $gQESC.AdditionalDriver.serializeBinaryToWriter);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getYear();
    if (f !== 0) writer.writeInt32(15, f);
    f = message.getDeductible();
    if (f !== 0) writer.writeInt32(16, f);
    f = message.getLimits();
    if (f.length > 0) writer.writeString(17, f);
    f = message.getPolicyId();
    if (f.length > 0) writer.writeString(18, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(19, f);
    f = message.getDeprecatedPolicyId();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getDeprecatedPolicyNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDeprecatedEffectiveDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getDeprecatedExpirationDate();
    if (f !== 0) writer.writeInt64(5, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 daily_rate = 6;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getDailyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setDailyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 monthly_rate = 7;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 excess_mileage_rate = 8;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getExcessMileageRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setExcessMileageRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string insurance_card_document_id = 9;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getInsuranceCardDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setInsuranceCardDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional InsuranceSplitLimits insurance_split_limits = 10;
 * @return {?proto.insurance_service.InsuranceSplitLimits}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getInsuranceSplitLimits = function() {
    return /** @type{?proto.insurance_service.InsuranceSplitLimits} */ $8M67s.Message.getWrapperField(this, proto.insurance_service.InsuranceSplitLimits, 10);
};
/**
 * @param {?proto.insurance_service.InsuranceSplitLimits|undefined} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
*/ proto.insurance_service.InsurancePolicyCreated.prototype.setInsuranceSplitLimits = function(value) {
    return $8M67s.Message.setWrapperField(this, 10, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.clearInsuranceSplitLimits = function() {
    return this.setInsuranceSplitLimits(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.hasInsuranceSplitLimits = function() {
    return $8M67s.Message.getField(this, 10) != null;
};
/**
 * repeated insurance.AdditionalDriver additional_drivers = 11;
 * @return {!Array<!proto.insurance.AdditionalDriver>}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getAdditionalDriversList = function() {
    return /** @type{!Array<!proto.insurance.AdditionalDriver>} */ $8M67s.Message.getRepeatedWrapperField(this, $gQESC.AdditionalDriver, 11);
};
/**
 * @param {!Array<!proto.insurance.AdditionalDriver>} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
*/ proto.insurance_service.InsurancePolicyCreated.prototype.setAdditionalDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 11, value);
};
/**
 * @param {!proto.insurance.AdditionalDriver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.addAdditionalDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.insurance.AdditionalDriver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.clearAdditionalDriversList = function() {
    return this.setAdditionalDriversList([]);
};
/**
 * optional string vehicle_id = 12;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string make = 13;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string model = 14;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional int32 year = 15;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getYear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * optional int32 deductible = 16;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getDeductible = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setDeductible = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
/**
 * optional string limits = 17;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getLimits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 17, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setLimits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 17, value);
};
/**
 * optional string policy_id = 18;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getPolicyId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 18, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setPolicyId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 18, value);
};
/**
 * optional string subscription_id = 19;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 19, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 19, value);
};
/**
 * optional int32 deprecated_policy_id = 2;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getDeprecatedPolicyId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setDeprecatedPolicyId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string deprecated_policy_number = 3;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getDeprecatedPolicyNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setDeprecatedPolicyNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 deprecated_effective_date = 4;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getDeprecatedEffectiveDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setDeprecatedEffectiveDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 deprecated_expiration_date = 5;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCreated.prototype.getDeprecatedExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCreated} returns this
 */ proto.insurance_service.InsurancePolicyCreated.prototype.setDeprecatedExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.InsurancePolicyUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.InsurancePolicyUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.InsurancePolicyUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            newDailyRateCents: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            newMonthlyRateCents: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            oldDailyRateCents: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            oldMonthlyRateCents: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.InsurancePolicyUpdated}
 */ proto.insurance_service.InsurancePolicyUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.InsurancePolicyUpdated;
    return proto.insurance_service.InsurancePolicyUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.InsurancePolicyUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.InsurancePolicyUpdated}
 */ proto.insurance_service.InsurancePolicyUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setNewDailyRateCents(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setNewMonthlyRateCents(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOldDailyRateCents(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOldMonthlyRateCents(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.InsurancePolicyUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.InsurancePolicyUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.InsurancePolicyUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getNewDailyRateCents();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getNewMonthlyRateCents();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getOldDailyRateCents();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getOldMonthlyRateCents();
    if (f !== 0) writer.writeInt32(6, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyUpdated} returns this
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyUpdated} returns this
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 new_daily_rate_cents = 3;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.getNewDailyRateCents = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyUpdated} returns this
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.setNewDailyRateCents = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 new_monthly_rate_cents = 4;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.getNewMonthlyRateCents = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyUpdated} returns this
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.setNewMonthlyRateCents = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 old_daily_rate_cents = 5;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.getOldDailyRateCents = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyUpdated} returns this
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.setOldDailyRateCents = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 old_monthly_rate_cents = 6;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.getOldMonthlyRateCents = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyUpdated} returns this
 */ proto.insurance_service.InsurancePolicyUpdated.prototype.setOldMonthlyRateCents = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.InsurancePolicyCancelled.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.InsurancePolicyCancelled.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.InsurancePolicyCancelled} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.InsurancePolicyCancelled.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            endDate: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.InsurancePolicyCancelled}
 */ proto.insurance_service.InsurancePolicyCancelled.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.InsurancePolicyCancelled;
    return proto.insurance_service.InsurancePolicyCancelled.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.InsurancePolicyCancelled} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.InsurancePolicyCancelled}
 */ proto.insurance_service.InsurancePolicyCancelled.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setEndDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.InsurancePolicyCancelled.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.InsurancePolicyCancelled.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.InsurancePolicyCancelled} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.InsurancePolicyCancelled.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getEndDate();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCancelled.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCancelled} returns this
 */ proto.insurance_service.InsurancePolicyCancelled.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.insurance_service.InsurancePolicyCancelled.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.InsurancePolicyCancelled} returns this
 */ proto.insurance_service.InsurancePolicyCancelled.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 end_date = 3;
 * @return {number}
 */ proto.insurance_service.InsurancePolicyCancelled.prototype.getEndDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance_service.InsurancePolicyCancelled} returns this
 */ proto.insurance_service.InsurancePolicyCancelled.prototype.setEndDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetLatestQuoteGroupRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetLatestQuoteGroupRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetLatestQuoteGroupRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetLatestQuoteGroupRequest}
 */ proto.insurance_service.GetLatestQuoteGroupRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetLatestQuoteGroupRequest;
    return proto.insurance_service.GetLatestQuoteGroupRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetLatestQuoteGroupRequest}
 */ proto.insurance_service.GetLatestQuoteGroupRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetLatestQuoteGroupRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetLatestQuoteGroupRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetLatestQuoteGroupRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.insurance_service.GetLatestQuoteGroupRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.GetLatestQuoteGroupRequest} returns this
 */ proto.insurance_service.GetLatestQuoteGroupRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.GetLatestQuoteGroupResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.GetLatestQuoteGroupResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.GetLatestQuoteGroupResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.GetLatestQuoteGroupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetLatestQuoteGroupResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            latestquoteresponseList: $8M67s.Message.toObjectList(msg.getLatestquoteresponseList(), proto.insurance_service.QuoteResponse.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.GetLatestQuoteGroupResponse}
 */ proto.insurance_service.GetLatestQuoteGroupResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.GetLatestQuoteGroupResponse;
    return proto.insurance_service.GetLatestQuoteGroupResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.GetLatestQuoteGroupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.GetLatestQuoteGroupResponse}
 */ proto.insurance_service.GetLatestQuoteGroupResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.insurance_service.QuoteResponse;
                reader.readMessage(value, proto.insurance_service.QuoteResponse.deserializeBinaryFromReader);
                msg.addLatestquoteresponse(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.GetLatestQuoteGroupResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.GetLatestQuoteGroupResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.GetLatestQuoteGroupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.GetLatestQuoteGroupResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLatestquoteresponseList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.insurance_service.QuoteResponse.serializeBinaryToWriter);
};
/**
 * repeated QuoteResponse latestQuoteResponse = 1;
 * @return {!Array<!proto.insurance_service.QuoteResponse>}
 */ proto.insurance_service.GetLatestQuoteGroupResponse.prototype.getLatestquoteresponseList = function() {
    return /** @type{!Array<!proto.insurance_service.QuoteResponse>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.insurance_service.QuoteResponse, 1);
};
/**
 * @param {!Array<!proto.insurance_service.QuoteResponse>} value
 * @return {!proto.insurance_service.GetLatestQuoteGroupResponse} returns this
*/ proto.insurance_service.GetLatestQuoteGroupResponse.prototype.setLatestquoteresponseList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.insurance_service.QuoteResponse=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance_service.QuoteResponse}
 */ proto.insurance_service.GetLatestQuoteGroupResponse.prototype.addLatestquoteresponse = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.insurance_service.QuoteResponse, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.GetLatestQuoteGroupResponse} returns this
 */ proto.insurance_service.GetLatestQuoteGroupResponse.prototype.clearLatestquoteresponseList = function() {
    return this.setLatestquoteresponseList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.Driver.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.Driver.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.Driver} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.Driver.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            dob: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.Driver}
 */ proto.insurance_service.Driver.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.Driver;
    return proto.insurance_service.Driver.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.Driver} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.Driver}
 */ proto.insurance_service.Driver.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDob(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.Driver.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.Driver.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.Driver} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.Driver.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDob();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.insurance_service.Driver.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.Driver} returns this
 */ proto.insurance_service.Driver.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string first_name = 2;
 * @return {string}
 */ proto.insurance_service.Driver.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.Driver} returns this
 */ proto.insurance_service.Driver.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string last_name = 3;
 * @return {string}
 */ proto.insurance_service.Driver.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.Driver} returns this
 */ proto.insurance_service.Driver.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string dob = 4;
 * @return {string}
 */ proto.insurance_service.Driver.prototype.getDob = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.Driver} returns this
 */ proto.insurance_service.Driver.prototype.setDob = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.insurance_service.ModifyInsuranceDriversRequest.repeatedFields_ = [
    2,
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.ModifyInsuranceDriversRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ModifyInsuranceDriversRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            policyId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            addedDriversList: $8M67s.Message.toObjectList(msg.getAddedDriversList(), proto.insurance_service.Driver.toObject, includeInstance),
            removedDriverIdsList: (f = $8M67s.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
            customerId: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.ModifyInsuranceDriversRequest;
    return proto.insurance_service.ModifyInsuranceDriversRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyId(value);
                break;
            case 2:
                var value = new proto.insurance_service.Driver;
                reader.readMessage(value, proto.insurance_service.Driver.deserializeBinaryFromReader);
                msg.addAddedDrivers(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.addRemovedDriverIds(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.ModifyInsuranceDriversRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ModifyInsuranceDriversRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPolicyId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAddedDriversList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.insurance_service.Driver.serializeBinaryToWriter);
    f = message.getRemovedDriverIdsList();
    if (f.length > 0) writer.writeRepeatedString(3, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string policy_id = 1;
 * @return {string}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.getPolicyId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest} returns this
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.setPolicyId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated Driver added_drivers = 2;
 * @return {!Array<!proto.insurance_service.Driver>}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.getAddedDriversList = function() {
    return /** @type{!Array<!proto.insurance_service.Driver>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.insurance_service.Driver, 2);
};
/**
 * @param {!Array<!proto.insurance_service.Driver>} value
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest} returns this
*/ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.setAddedDriversList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.insurance_service.Driver=} opt_value
 * @param {number=} opt_index
 * @return {!proto.insurance_service.Driver}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.addAddedDrivers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.insurance_service.Driver, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest} returns this
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.clearAddedDriversList = function() {
    return this.setAddedDriversList([]);
};
/**
 * repeated string removed_driver_ids = 3;
 * @return {!Array<string>}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.getRemovedDriverIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 3);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest} returns this
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.setRemovedDriverIdsList = function(value) {
    return $8M67s.Message.setField(this, 3, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest} returns this
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.addRemovedDriverIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 3, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest} returns this
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.clearRemovedDriverIdsList = function() {
    return this.setRemovedDriverIdsList([]);
};
/**
 * optional string customer_id = 4;
 * @return {string}
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.ModifyInsuranceDriversRequest} returns this
 */ proto.insurance_service.ModifyInsuranceDriversRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance_service.ModifyInsuranceDriversResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance_service.ModifyInsuranceDriversResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance_service.ModifyInsuranceDriversResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ModifyInsuranceDriversResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            policyId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance_service.ModifyInsuranceDriversResponse}
 */ proto.insurance_service.ModifyInsuranceDriversResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance_service.ModifyInsuranceDriversResponse;
    return proto.insurance_service.ModifyInsuranceDriversResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance_service.ModifyInsuranceDriversResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance_service.ModifyInsuranceDriversResponse}
 */ proto.insurance_service.ModifyInsuranceDriversResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance_service.ModifyInsuranceDriversResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance_service.ModifyInsuranceDriversResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance_service.ModifyInsuranceDriversResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance_service.ModifyInsuranceDriversResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPolicyId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string policy_id = 1;
 * @return {string}
 */ proto.insurance_service.ModifyInsuranceDriversResponse.prototype.getPolicyId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance_service.ModifyInsuranceDriversResponse} returns this
 */ proto.insurance_service.ModifyInsuranceDriversResponse.prototype.setPolicyId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * @enum {number}
 */ proto.insurance_service.RequestSource = {
    CUSTOMER: 0,
    CUSTOMER_SUPPORT: 1
};
$bdaa3b9c627308ce$var$goog.object.extend(module.exports, proto.insurance_service);

});
parcelRegister("8M67s", function(module, exports) {
/*

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ var $01a60eaba94db1c4$var$aa = "function" == typeof Object.defineProperties ? Object.defineProperty : function(a, b, c) {
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
}, $01a60eaba94db1c4$var$e = "undefined" != typeof window && window === module.exports ? module.exports : "undefined" != typeof $parcel$global && null != $parcel$global ? $parcel$global : module.exports;
function $01a60eaba94db1c4$var$ba(a, b) {
    if (b) {
        var c = $01a60eaba94db1c4$var$e;
        a = a.split(".");
        for(var d = 0; d < a.length - 1; d++){
            var f = a[d];
            f in c || (c[f] = {});
            c = c[f];
        }
        a = a[a.length - 1];
        d = c[a];
        b = b(d);
        b != d && null != b && $01a60eaba94db1c4$var$aa(c, a, {
            configurable: !0,
            writable: !0,
            value: b
        });
    }
}
function $01a60eaba94db1c4$var$ca(a) {
    var b = 0;
    return function() {
        return b < a.length ? {
            done: !1,
            value: a[b++]
        } : {
            done: !0
        };
    };
}
function $01a60eaba94db1c4$var$da() {
    $01a60eaba94db1c4$var$da = function() {};
    $01a60eaba94db1c4$var$e.Symbol || ($01a60eaba94db1c4$var$e.Symbol = $01a60eaba94db1c4$var$ea);
}
function $01a60eaba94db1c4$var$fa(a, b) {
    this.a = a;
    $01a60eaba94db1c4$var$aa(this, "description", {
        configurable: !0,
        writable: !0,
        value: b
    });
}
$01a60eaba94db1c4$var$fa.prototype.toString = function() {
    return this.a;
};
var $01a60eaba94db1c4$var$ea = function() {
    function a(c) {
        if (this instanceof a) throw new TypeError("Symbol is not a constructor");
        return new $01a60eaba94db1c4$var$fa("jscomp_symbol_" + (c || "") + "_" + b++, c);
    }
    var b = 0;
    return a;
}();
function $01a60eaba94db1c4$var$ha() {
    $01a60eaba94db1c4$var$da();
    var a = $01a60eaba94db1c4$var$e.Symbol.iterator;
    a || (a = $01a60eaba94db1c4$var$e.Symbol.iterator = $01a60eaba94db1c4$var$e.Symbol("Symbol.iterator"));
    "function" != typeof Array.prototype[a] && $01a60eaba94db1c4$var$aa(Array.prototype, a, {
        configurable: !0,
        writable: !0,
        value: function() {
            return $01a60eaba94db1c4$var$ia($01a60eaba94db1c4$var$ca(this));
        }
    });
    $01a60eaba94db1c4$var$ha = function() {};
}
function $01a60eaba94db1c4$var$ia(a) {
    $01a60eaba94db1c4$var$ha();
    a = {
        next: a
    };
    a[$01a60eaba94db1c4$var$e.Symbol.iterator] = function() {
        return this;
    };
    return a;
}
function $01a60eaba94db1c4$var$ja(a, b) {
    $01a60eaba94db1c4$var$ha();
    a instanceof String && (a += "");
    var c = 0, d = {
        next: function() {
            if (c < a.length) {
                var f = c++;
                return {
                    value: b(f, a[f]),
                    done: !1
                };
            }
            d.next = function() {
                return {
                    done: !0,
                    value: void 0
                };
            };
            return d.next();
        }
    };
    d[Symbol.iterator] = function() {
        return d;
    };
    return d;
}
$01a60eaba94db1c4$var$ba("Array.prototype.entries", function(a) {
    return a ? a : function() {
        return $01a60eaba94db1c4$var$ja(this, function(b, c) {
            return [
                b,
                c
            ];
        });
    };
});
var $01a60eaba94db1c4$var$ka = module.exports || self;
function $01a60eaba94db1c4$var$g(a, b, c) {
    a = a.split(".");
    c = c || $01a60eaba94db1c4$var$ka;
    a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);
    for(var d; a.length && (d = a.shift());)a.length || void 0 === b ? c[d] && c[d] !== Object.prototype[d] ? c = c[d] : c = c[d] = {} : c[d] = b;
}
function $01a60eaba94db1c4$var$k(a) {
    var b = typeof a;
    if ("object" == b) {
        if (a) {
            if (a instanceof Array) return "array";
            if (a instanceof Object) return b;
            var c = Object.prototype.toString.call(a);
            if ("[object Window]" == c) return "object";
            if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
            if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
        } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";
    return b;
}
function $01a60eaba94db1c4$var$la(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
}
function $01a60eaba94db1c4$var$ma(a, b, c) {
    $01a60eaba94db1c4$var$g(a, b, c);
}
function $01a60eaba94db1c4$var$na(a, b) {
    function c() {}
    c.prototype = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
}
var $01a60eaba94db1c4$var$oa = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function $01a60eaba94db1c4$var$pa(a, b) {
    for(var c, d, f = 1; f < arguments.length; f++){
        d = arguments[f];
        for(c in d)a[c] = d[c];
        for(var h = 0; h < $01a60eaba94db1c4$var$oa.length; h++)c = $01a60eaba94db1c4$var$oa[h], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
    }
}
var $01a60eaba94db1c4$var$qa = Array.prototype.forEach ? function(a, b) {
    Array.prototype.forEach.call(a, b, void 0);
} : function(a, b) {
    for(var c = a.length, d = "string" === typeof a ? a.split("") : a, f = 0; f < c; f++)f in d && b.call(void 0, d[f], f, a);
}, $01a60eaba94db1c4$var$l = Array.prototype.map ? function(a, b) {
    return Array.prototype.map.call(a, b, void 0);
} : function(a, b) {
    for(var c = a.length, d = Array(c), f = "string" === typeof a ? a.split("") : a, h = 0; h < c; h++)h in f && (d[h] = b.call(void 0, f[h], h, a));
    return d;
};
function $01a60eaba94db1c4$var$ra(a, b, c) {
    return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c);
}
function $01a60eaba94db1c4$var$sa(a, b, c, d) {
    var f = "Assertion failed";
    if (c) {
        f += ": " + c;
        var h = d;
    } else a && (f += ": " + a, h = b);
    throw Error(f, h || []);
}
function $01a60eaba94db1c4$var$n(a, b, c) {
    for(var d = [], f = 2; f < arguments.length; ++f)d[f - 2] = arguments[f];
    a || $01a60eaba94db1c4$var$sa("", null, b, d);
    return a;
}
function $01a60eaba94db1c4$var$ta(a, b, c) {
    for(var d = [], f = 2; f < arguments.length; ++f)d[f - 2] = arguments[f];
    "string" !== typeof a && $01a60eaba94db1c4$var$sa("Expected string but got %s: %s.", [
        $01a60eaba94db1c4$var$k(a),
        a
    ], b, d);
}
function $01a60eaba94db1c4$var$ua(a, b, c) {
    for(var d = [], f = 2; f < arguments.length; ++f)d[f - 2] = arguments[f];
    Array.isArray(a) || $01a60eaba94db1c4$var$sa("Expected array but got %s: %s.", [
        $01a60eaba94db1c4$var$k(a),
        a
    ], b, d);
}
function $01a60eaba94db1c4$var$p(a, b) {
    for(var c = [], d = 1; d < arguments.length; ++d)c[d - 1] = arguments[d];
    throw Error("Failure" + (a ? ": " + a : ""), c);
}
function $01a60eaba94db1c4$var$q(a, b, c, d) {
    for(var f = [], h = 3; h < arguments.length; ++h)f[h - 3] = arguments[h];
    a instanceof b || $01a60eaba94db1c4$var$sa("Expected instanceof %s but got %s.", [
        $01a60eaba94db1c4$var$va(b),
        $01a60eaba94db1c4$var$va(a)
    ], c, f);
}
function $01a60eaba94db1c4$var$va(a) {
    return a instanceof Function ? a.displayName || a.name || "unknown type name" : a instanceof Object ? a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a) : null === a ? "null" : typeof a;
}
function $01a60eaba94db1c4$var$r(a, b) {
    this.c = a;
    this.b = b;
    this.a = {};
    this.arrClean = !0;
    if (0 < this.c.length) {
        for(a = 0; a < this.c.length; a++){
            b = this.c[a];
            var c = b[0];
            this.a[c.toString()] = new $01a60eaba94db1c4$var$wa(c, b[1]);
        }
        this.arrClean = !0;
    }
}
$01a60eaba94db1c4$var$g("jspb.Map", $01a60eaba94db1c4$var$r, void 0);
$01a60eaba94db1c4$var$r.prototype.g = function() {
    if (this.arrClean) {
        if (this.b) {
            var a = this.a, b;
            for(b in a)if (Object.prototype.hasOwnProperty.call(a, b)) {
                var c = a[b].a;
                c && c.g();
            }
        }
    } else {
        this.c.length = 0;
        a = $01a60eaba94db1c4$var$u(this);
        a.sort();
        for(b = 0; b < a.length; b++){
            var d = this.a[a[b]];
            (c = d.a) && c.g();
            this.c.push([
                d.key,
                d.value
            ]);
        }
        this.arrClean = !0;
    }
    return this.c;
};
$01a60eaba94db1c4$var$r.prototype.toArray = $01a60eaba94db1c4$var$r.prototype.g;
$01a60eaba94db1c4$var$r.prototype.Mc = function(a, b) {
    for(var c = this.g(), d = [], f = 0; f < c.length; f++){
        var h = this.a[c[f][0].toString()];
        $01a60eaba94db1c4$var$v(this, h);
        var m = h.a;
        m ? ($01a60eaba94db1c4$var$n(b), d.push([
            h.key,
            b(a, m)
        ])) : d.push([
            h.key,
            h.value
        ]);
    }
    return d;
};
$01a60eaba94db1c4$var$r.prototype.toObject = $01a60eaba94db1c4$var$r.prototype.Mc;
$01a60eaba94db1c4$var$r.fromObject = function(a, b, c) {
    b = new $01a60eaba94db1c4$var$r([], b);
    for(var d = 0; d < a.length; d++){
        var f = a[d][0], h = c(a[d][1]);
        b.set(f, h);
    }
    return b;
};
function $01a60eaba94db1c4$var$w(a) {
    this.a = 0;
    this.b = a;
}
$01a60eaba94db1c4$var$w.prototype.next = function() {
    return this.a < this.b.length ? {
        done: !1,
        value: this.b[this.a++]
    } : {
        done: !0,
        value: void 0
    };
};
"undefined" != typeof Symbol && ($01a60eaba94db1c4$var$w.prototype[Symbol.iterator] = function() {
    return this;
});
$01a60eaba94db1c4$var$r.prototype.Jb = function() {
    return $01a60eaba94db1c4$var$u(this).length;
};
$01a60eaba94db1c4$var$r.prototype.getLength = $01a60eaba94db1c4$var$r.prototype.Jb;
$01a60eaba94db1c4$var$r.prototype.clear = function() {
    this.a = {};
    this.arrClean = !1;
};
$01a60eaba94db1c4$var$r.prototype.clear = $01a60eaba94db1c4$var$r.prototype.clear;
$01a60eaba94db1c4$var$r.prototype.Cb = function(a) {
    a = a.toString();
    var b = this.a.hasOwnProperty(a);
    delete this.a[a];
    this.arrClean = !1;
    return b;
};
$01a60eaba94db1c4$var$r.prototype.del = $01a60eaba94db1c4$var$r.prototype.Cb;
$01a60eaba94db1c4$var$r.prototype.Eb = function() {
    var a = [], b = $01a60eaba94db1c4$var$u(this);
    b.sort();
    for(var c = 0; c < b.length; c++){
        var d = this.a[b[c]];
        a.push([
            d.key,
            d.value
        ]);
    }
    return a;
};
$01a60eaba94db1c4$var$r.prototype.getEntryList = $01a60eaba94db1c4$var$r.prototype.Eb;
$01a60eaba94db1c4$var$r.prototype.entries = function() {
    var a = [], b = $01a60eaba94db1c4$var$u(this);
    b.sort();
    for(var c = 0; c < b.length; c++){
        var d = this.a[b[c]];
        a.push([
            d.key,
            $01a60eaba94db1c4$var$v(this, d)
        ]);
    }
    return new $01a60eaba94db1c4$var$w(a);
};
$01a60eaba94db1c4$var$r.prototype.entries = $01a60eaba94db1c4$var$r.prototype.entries;
$01a60eaba94db1c4$var$r.prototype.keys = function() {
    var a = [], b = $01a60eaba94db1c4$var$u(this);
    b.sort();
    for(var c = 0; c < b.length; c++)a.push(this.a[b[c]].key);
    return new $01a60eaba94db1c4$var$w(a);
};
$01a60eaba94db1c4$var$r.prototype.keys = $01a60eaba94db1c4$var$r.prototype.keys;
$01a60eaba94db1c4$var$r.prototype.values = function() {
    var a = [], b = $01a60eaba94db1c4$var$u(this);
    b.sort();
    for(var c = 0; c < b.length; c++)a.push($01a60eaba94db1c4$var$v(this, this.a[b[c]]));
    return new $01a60eaba94db1c4$var$w(a);
};
$01a60eaba94db1c4$var$r.prototype.values = $01a60eaba94db1c4$var$r.prototype.values;
$01a60eaba94db1c4$var$r.prototype.forEach = function(a, b) {
    var c = $01a60eaba94db1c4$var$u(this);
    c.sort();
    for(var d = 0; d < c.length; d++){
        var f = this.a[c[d]];
        a.call(b, $01a60eaba94db1c4$var$v(this, f), f.key, this);
    }
};
$01a60eaba94db1c4$var$r.prototype.forEach = $01a60eaba94db1c4$var$r.prototype.forEach;
$01a60eaba94db1c4$var$r.prototype.set = function(a, b) {
    var c = new $01a60eaba94db1c4$var$wa(a);
    this.b ? (c.a = b, c.value = b.g()) : c.value = b;
    this.a[a.toString()] = c;
    this.arrClean = !1;
    return this;
};
$01a60eaba94db1c4$var$r.prototype.set = $01a60eaba94db1c4$var$r.prototype.set;
function $01a60eaba94db1c4$var$v(a, b) {
    return a.b ? (b.a || (b.a = new a.b(b.value)), b.a) : b.value;
}
$01a60eaba94db1c4$var$r.prototype.get = function(a) {
    if (a = this.a[a.toString()]) return $01a60eaba94db1c4$var$v(this, a);
};
$01a60eaba94db1c4$var$r.prototype.get = $01a60eaba94db1c4$var$r.prototype.get;
$01a60eaba94db1c4$var$r.prototype.has = function(a) {
    return a.toString() in this.a;
};
$01a60eaba94db1c4$var$r.prototype.has = $01a60eaba94db1c4$var$r.prototype.has;
$01a60eaba94db1c4$var$r.prototype.Jc = function(a, b, c, d, f) {
    var h = $01a60eaba94db1c4$var$u(this);
    h.sort();
    for(var m = 0; m < h.length; m++){
        var t = this.a[h[m]];
        b.Va(a);
        c.call(b, 1, t.key);
        this.b ? d.call(b, 2, $01a60eaba94db1c4$var$v(this, t), f) : d.call(b, 2, t.value);
        b.Ya();
    }
};
$01a60eaba94db1c4$var$r.prototype.serializeBinary = $01a60eaba94db1c4$var$r.prototype.Jc;
$01a60eaba94db1c4$var$r.deserializeBinary = function(a, b, c, d, f, h, m) {
    for(; b.oa() && !b.bb();){
        var t = b.c;
        1 == t ? h = c.call(b) : 2 == t && (a.b ? ($01a60eaba94db1c4$var$n(f), m || (m = new a.b), d.call(b, m, f)) : m = d.call(b));
    }
    $01a60eaba94db1c4$var$n(void 0 != h);
    $01a60eaba94db1c4$var$n(void 0 != m);
    a.set(h, m);
};
function $01a60eaba94db1c4$var$u(a) {
    a = a.a;
    var b = [], c;
    for(c in a)Object.prototype.hasOwnProperty.call(a, c) && b.push(c);
    return b;
}
function $01a60eaba94db1c4$var$wa(a, b) {
    this.key = a;
    this.value = b;
    this.a = void 0;
}
function $01a60eaba94db1c4$var$xa(a) {
    if (8192 >= a.length) return String.fromCharCode.apply(null, a);
    for(var b = "", c = 0; c < a.length; c += 8192)b += String.fromCharCode.apply(null, $01a60eaba94db1c4$var$ra(a, c, c + 8192));
    return b;
}
var $01a60eaba94db1c4$var$ya = {
    "\x00": "\\0",
    "\b": "\\b",
    "\f": "\\f",
    "\n": "\\n",
    "\r": "\\r",
    "\t": "\\t",
    "\x0B": "\\x0B",
    '"': '\\"',
    "\\": "\\\\",
    "<": "\\u003C"
}, $01a60eaba94db1c4$var$za = {
    "'": "\\'"
};
var $01a60eaba94db1c4$var$Aa = {}, $01a60eaba94db1c4$var$x = null;
function $01a60eaba94db1c4$var$Ba(a, b) {
    void 0 === b && (b = 0);
    $01a60eaba94db1c4$var$Ca();
    b = $01a60eaba94db1c4$var$Aa[b];
    for(var c = [], d = 0; d < a.length; d += 3){
        var f = a[d], h = d + 1 < a.length, m = h ? a[d + 1] : 0, t = d + 2 < a.length, B = t ? a[d + 2] : 0, M = f >> 2;
        f = (f & 3) << 4 | m >> 4;
        m = (m & 15) << 2 | B >> 6;
        B &= 63;
        t || (B = 64, h || (m = 64));
        c.push(b[M], b[f], b[m] || "", b[B] || "");
    }
    return c.join("");
}
function $01a60eaba94db1c4$var$Da(a) {
    var b = a.length, c = 3 * b / 4;
    c % 3 ? c = Math.floor(c) : -1 != "=.".indexOf(a[b - 1]) && (c = -1 != "=.".indexOf(a[b - 2]) ? c - 2 : c - 1);
    var d = new Uint8Array(c), f = 0;
    $01a60eaba94db1c4$var$Ea(a, function(h) {
        d[f++] = h;
    });
    return d.subarray(0, f);
}
function $01a60eaba94db1c4$var$Ea(a, b) {
    function c(B) {
        for(; d < a.length;){
            var M = a.charAt(d++), La = $01a60eaba94db1c4$var$x[M];
            if (null != La) return La;
            if (!/^[\s\xa0]*$/.test(M)) throw Error("Unknown base64 encoding at char: " + M);
        }
        return B;
    }
    $01a60eaba94db1c4$var$Ca();
    for(var d = 0;;){
        var f = c(-1), h = c(0), m = c(64), t = c(64);
        if (64 === t && -1 === f) break;
        b(f << 2 | h >> 4);
        64 != m && (b(h << 4 & 240 | m >> 2), 64 != t && b(m << 6 & 192 | t));
    }
}
function $01a60eaba94db1c4$var$Ca() {
    if (!$01a60eaba94db1c4$var$x) {
        $01a60eaba94db1c4$var$x = {};
        for(var a = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), b = [
            "+/=",
            "+/",
            "-_=",
            "-_.",
            "-_"
        ], c = 0; 5 > c; c++){
            var d = a.concat(b[c].split(""));
            $01a60eaba94db1c4$var$Aa[c] = d;
            for(var f = 0; f < d.length; f++){
                var h = d[f];
                void 0 === $01a60eaba94db1c4$var$x[h] && ($01a60eaba94db1c4$var$x[h] = f);
            }
        }
    }
}
$01a60eaba94db1c4$var$g("jspb.ConstBinaryMessage", function() {}, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryMessage", function() {}, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.FieldType", {
    yb: -1,
    ee: 1,
    FLOAT: 2,
    ke: 3,
    te: 4,
    je: 5,
    xb: 6,
    wb: 7,
    BOOL: 8,
    re: 9,
    ie: 10,
    le: 11,
    ce: 12,
    se: 13,
    ge: 14,
    me: 15,
    ne: 16,
    oe: 17,
    pe: 18,
    he: 30,
    ve: 31
}, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.WireType", {
    yb: -1,
    ue: 0,
    xb: 1,
    de: 2,
    qe: 3,
    fe: 4,
    wb: 5
}, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.FieldTypeToWireType", function(a) {
    switch(a){
        case 5:
        case 3:
        case 13:
        case 4:
        case 17:
        case 18:
        case 8:
        case 14:
        case 31:
            return 0;
        case 1:
        case 6:
        case 16:
        case 30:
            return 1;
        case 9:
        case 11:
        case 12:
            return 2;
        case 2:
        case 7:
        case 15:
            return 5;
        default:
            return -1;
    }
}, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.INVALID_FIELD_NUMBER", -1, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.FLOAT32_EPS", 1.401298464324817E-45, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.FLOAT32_MIN", 1.1754943508222875E-38, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.FLOAT32_MAX", 3.4028234663852886E38, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.FLOAT64_EPS", 4.9E-324, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.FLOAT64_MIN", 2.2250738585072014E-308, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.FLOAT64_MAX", 1.7976931348623157E308, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.TWO_TO_20", 1048576, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.TWO_TO_23", 8388608, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.TWO_TO_31", 2147483648, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.TWO_TO_32", 4294967296, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.TWO_TO_52", 4503599627370496, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.TWO_TO_63", 0x7fffffffffffffff, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.TWO_TO_64", 1.8446744073709552E19, void 0);
$01a60eaba94db1c4$var$g("jspb.BinaryConstants.ZERO_HASH", "\x00\x00\x00\x00\x00\x00\x00\x00", void 0);
var $01a60eaba94db1c4$var$y = 0, $01a60eaba94db1c4$var$z = 0;
$01a60eaba94db1c4$var$g("jspb.utils.getSplit64Low", function() {
    return $01a60eaba94db1c4$var$y;
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.getSplit64High", function() {
    return $01a60eaba94db1c4$var$z;
}, void 0);
function $01a60eaba94db1c4$var$Fa(a) {
    var b = a >>> 0;
    a = Math.floor((a - b) / 4294967296) >>> 0;
    $01a60eaba94db1c4$var$y = b;
    $01a60eaba94db1c4$var$z = a;
}
$01a60eaba94db1c4$var$g("jspb.utils.splitUint64", $01a60eaba94db1c4$var$Fa, void 0);
function $01a60eaba94db1c4$var$A(a) {
    var b = 0 > a;
    a = Math.abs(a);
    var c = a >>> 0;
    a = Math.floor((a - c) / 4294967296);
    a >>>= 0;
    b && (a = ~a >>> 0, c = (~c >>> 0) + 1, 4294967295 < c && (c = 0, a++, 4294967295 < a && (a = 0)));
    $01a60eaba94db1c4$var$y = c;
    $01a60eaba94db1c4$var$z = a;
}
$01a60eaba94db1c4$var$g("jspb.utils.splitInt64", $01a60eaba94db1c4$var$A, void 0);
function $01a60eaba94db1c4$var$Ga(a) {
    var b = 0 > a;
    a = 2 * Math.abs(a);
    $01a60eaba94db1c4$var$Fa(a);
    a = $01a60eaba94db1c4$var$y;
    var c = $01a60eaba94db1c4$var$z;
    b && (0 == a ? 0 == c ? c = a = 4294967295 : (c--, a = 4294967295) : a--);
    $01a60eaba94db1c4$var$y = a;
    $01a60eaba94db1c4$var$z = c;
}
$01a60eaba94db1c4$var$g("jspb.utils.splitZigzag64", $01a60eaba94db1c4$var$Ga, void 0);
function $01a60eaba94db1c4$var$Ha(a) {
    var b = 0 > a ? 1 : 0;
    a = b ? -a : a;
    if (0 === a) 0 < 1 / a ? $01a60eaba94db1c4$var$y = $01a60eaba94db1c4$var$z = 0 : ($01a60eaba94db1c4$var$z = 0, $01a60eaba94db1c4$var$y = 2147483648);
    else if (isNaN(a)) $01a60eaba94db1c4$var$z = 0, $01a60eaba94db1c4$var$y = 2147483647;
    else if (3.4028234663852886E38 < a) $01a60eaba94db1c4$var$z = 0, $01a60eaba94db1c4$var$y = (b << 31 | 2139095040) >>> 0;
    else if (1.1754943508222875E-38 > a) a = Math.round(a / Math.pow(2, -149)), $01a60eaba94db1c4$var$z = 0, $01a60eaba94db1c4$var$y = (b << 31 | a) >>> 0;
    else {
        var c = Math.floor(Math.log(a) / Math.LN2);
        a *= Math.pow(2, -c);
        a = Math.round(8388608 * a);
        16777216 <= a && ++c;
        $01a60eaba94db1c4$var$z = 0;
        $01a60eaba94db1c4$var$y = (b << 31 | c + 127 << 23 | a & 8388607) >>> 0;
    }
}
$01a60eaba94db1c4$var$g("jspb.utils.splitFloat32", $01a60eaba94db1c4$var$Ha, void 0);
function $01a60eaba94db1c4$var$Ia(a) {
    var b = 0 > a ? 1 : 0;
    a = b ? -a : a;
    if (0 === a) $01a60eaba94db1c4$var$z = 0 < 1 / a ? 0 : 2147483648, $01a60eaba94db1c4$var$y = 0;
    else if (isNaN(a)) $01a60eaba94db1c4$var$z = 2147483647, $01a60eaba94db1c4$var$y = 4294967295;
    else if (1.7976931348623157E308 < a) $01a60eaba94db1c4$var$z = (b << 31 | 2146435072) >>> 0, $01a60eaba94db1c4$var$y = 0;
    else if (2.2250738585072014E-308 > a) a /= Math.pow(2, -1074), $01a60eaba94db1c4$var$z = (b << 31 | a / 4294967296) >>> 0, $01a60eaba94db1c4$var$y = a >>> 0;
    else {
        var c = a, d = 0;
        if (2 <= c) for(; 2 <= c && 1023 > d;)d++, c /= 2;
        else for(; 1 > c && -1022 < d;)c *= 2, d--;
        a *= Math.pow(2, -d);
        $01a60eaba94db1c4$var$z = (b << 31 | d + 1023 << 20 | 1048576 * a & 1048575) >>> 0;
        $01a60eaba94db1c4$var$y = 4503599627370496 * a >>> 0;
    }
}
$01a60eaba94db1c4$var$g("jspb.utils.splitFloat64", $01a60eaba94db1c4$var$Ia, void 0);
function $01a60eaba94db1c4$var$C(a) {
    var b = a.charCodeAt(4), c = a.charCodeAt(5), d = a.charCodeAt(6), f = a.charCodeAt(7);
    $01a60eaba94db1c4$var$y = a.charCodeAt(0) + (a.charCodeAt(1) << 8) + (a.charCodeAt(2) << 16) + (a.charCodeAt(3) << 24) >>> 0;
    $01a60eaba94db1c4$var$z = b + (c << 8) + (d << 16) + (f << 24) >>> 0;
}
$01a60eaba94db1c4$var$g("jspb.utils.splitHash64", $01a60eaba94db1c4$var$C, void 0);
function $01a60eaba94db1c4$var$D(a, b) {
    return 4294967296 * b + (a >>> 0);
}
$01a60eaba94db1c4$var$g("jspb.utils.joinUint64", $01a60eaba94db1c4$var$D, void 0);
function $01a60eaba94db1c4$var$E(a, b) {
    var c = b & 2147483648;
    c && (a = ~a + 1 >>> 0, b = ~b >>> 0, 0 == a && (b = b + 1 >>> 0));
    a = $01a60eaba94db1c4$var$D(a, b);
    return c ? -a : a;
}
$01a60eaba94db1c4$var$g("jspb.utils.joinInt64", $01a60eaba94db1c4$var$E, void 0);
function $01a60eaba94db1c4$var$Ja(a, b, c) {
    var d = b >> 31;
    return c(a << 1 ^ d, (b << 1 | a >>> 31) ^ d);
}
$01a60eaba94db1c4$var$g("jspb.utils.toZigzag64", $01a60eaba94db1c4$var$Ja, void 0);
function $01a60eaba94db1c4$var$Ka(a, b) {
    return $01a60eaba94db1c4$var$Ma(a, b, $01a60eaba94db1c4$var$E);
}
$01a60eaba94db1c4$var$g("jspb.utils.joinZigzag64", $01a60eaba94db1c4$var$Ka, void 0);
function $01a60eaba94db1c4$var$Ma(a, b, c) {
    var d = -(a & 1);
    return c((a >>> 1 | b << 31) ^ d, b >>> 1 ^ d);
}
$01a60eaba94db1c4$var$g("jspb.utils.fromZigzag64", $01a60eaba94db1c4$var$Ma, void 0);
function $01a60eaba94db1c4$var$Na(a) {
    var b = 2 * (a >> 31) + 1, c = a >>> 23 & 255;
    a &= 8388607;
    return 255 == c ? a ? NaN : Infinity * b : 0 == c ? b * Math.pow(2, -149) * a : b * Math.pow(2, c - 150) * (a + Math.pow(2, 23));
}
$01a60eaba94db1c4$var$g("jspb.utils.joinFloat32", $01a60eaba94db1c4$var$Na, void 0);
function $01a60eaba94db1c4$var$Oa(a, b) {
    var c = 2 * (b >> 31) + 1, d = b >>> 20 & 2047;
    a = 4294967296 * (b & 1048575) + a;
    return 2047 == d ? a ? NaN : Infinity * c : 0 == d ? c * Math.pow(2, -1074) * a : c * Math.pow(2, d - 1075) * (a + 4503599627370496);
}
$01a60eaba94db1c4$var$g("jspb.utils.joinFloat64", $01a60eaba94db1c4$var$Oa, void 0);
function $01a60eaba94db1c4$var$Pa(a, b) {
    return String.fromCharCode(a >>> 0 & 255, a >>> 8 & 255, a >>> 16 & 255, a >>> 24 & 255, b >>> 0 & 255, b >>> 8 & 255, b >>> 16 & 255, b >>> 24 & 255);
}
$01a60eaba94db1c4$var$g("jspb.utils.joinHash64", $01a60eaba94db1c4$var$Pa, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.DIGITS", "0123456789abcdef".split(""), void 0);
function $01a60eaba94db1c4$var$F(a, b) {
    function c(f, h) {
        f = f ? String(f) : "";
        return h ? "0000000".slice(f.length) + f : f;
    }
    if (2097151 >= b) return "" + $01a60eaba94db1c4$var$D(a, b);
    var d = (a >>> 24 | b << 8) >>> 0 & 16777215;
    b = b >> 16 & 65535;
    a = (a & 16777215) + 6777216 * d + 6710656 * b;
    d += 8147497 * b;
    b *= 2;
    1E7 <= a && (d += Math.floor(a / 1E7), a %= 1E7);
    1E7 <= d && (b += Math.floor(d / 1E7), d %= 1E7);
    return c(b, 0) + c(d, b) + c(a, 1);
}
$01a60eaba94db1c4$var$g("jspb.utils.joinUnsignedDecimalString", $01a60eaba94db1c4$var$F, void 0);
function $01a60eaba94db1c4$var$G(a, b) {
    var c = b & 2147483648;
    c && (a = ~a + 1 >>> 0, b = ~b + (0 == a ? 1 : 0) >>> 0);
    a = $01a60eaba94db1c4$var$F(a, b);
    return c ? "-" + a : a;
}
$01a60eaba94db1c4$var$g("jspb.utils.joinSignedDecimalString", $01a60eaba94db1c4$var$G, void 0);
function $01a60eaba94db1c4$var$Qa(a, b) {
    $01a60eaba94db1c4$var$C(a);
    a = $01a60eaba94db1c4$var$y;
    var c = $01a60eaba94db1c4$var$z;
    return b ? $01a60eaba94db1c4$var$G(a, c) : $01a60eaba94db1c4$var$F(a, c);
}
$01a60eaba94db1c4$var$g("jspb.utils.hash64ToDecimalString", $01a60eaba94db1c4$var$Qa, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.hash64ArrayToDecimalStrings", function(a, b) {
    for(var c = Array(a.length), d = 0; d < a.length; d++)c[d] = $01a60eaba94db1c4$var$Qa(a[d], b);
    return c;
}, void 0);
function $01a60eaba94db1c4$var$H(a) {
    function b(m, t) {
        for(var B = 0; 8 > B && (1 !== m || 0 < t); B++)t = m * f[B] + t, f[B] = t & 255, t >>>= 8;
    }
    function c() {
        for(var m = 0; 8 > m; m++)f[m] = ~f[m] & 255;
    }
    $01a60eaba94db1c4$var$n(0 < a.length);
    var d = !1;
    "-" === a[0] && (d = !0, a = a.slice(1));
    for(var f = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ], h = 0; h < a.length; h++)b(10, a.charCodeAt(h) - 48);
    d && (c(), b(1, 1));
    return $01a60eaba94db1c4$var$xa(f);
}
$01a60eaba94db1c4$var$g("jspb.utils.decimalStringToHash64", $01a60eaba94db1c4$var$H, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.splitDecimalString", function(a) {
    $01a60eaba94db1c4$var$C($01a60eaba94db1c4$var$H(a));
}, void 0);
function $01a60eaba94db1c4$var$Ra(a) {
    return String.fromCharCode(10 > a ? 48 + a : 87 + a);
}
function $01a60eaba94db1c4$var$Sa(a) {
    return 97 <= a ? a - 97 + 10 : a - 48;
}
$01a60eaba94db1c4$var$g("jspb.utils.hash64ToHexString", function(a) {
    var b = Array(18);
    b[0] = "0";
    b[1] = "x";
    for(var c = 0; 8 > c; c++){
        var d = a.charCodeAt(7 - c);
        b[2 * c + 2] = $01a60eaba94db1c4$var$Ra(d >> 4);
        b[2 * c + 3] = $01a60eaba94db1c4$var$Ra(d & 15);
    }
    return b.join("");
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.hexStringToHash64", function(a) {
    a = a.toLowerCase();
    $01a60eaba94db1c4$var$n(18 == a.length);
    $01a60eaba94db1c4$var$n("0" == a[0]);
    $01a60eaba94db1c4$var$n("x" == a[1]);
    for(var b = "", c = 0; 8 > c; c++)b = String.fromCharCode(16 * $01a60eaba94db1c4$var$Sa(a.charCodeAt(2 * c + 2)) + $01a60eaba94db1c4$var$Sa(a.charCodeAt(2 * c + 3))) + b;
    return b;
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.hash64ToNumber", function(a, b) {
    $01a60eaba94db1c4$var$C(a);
    a = $01a60eaba94db1c4$var$y;
    var c = $01a60eaba94db1c4$var$z;
    return b ? $01a60eaba94db1c4$var$E(a, c) : $01a60eaba94db1c4$var$D(a, c);
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.numberToHash64", function(a) {
    $01a60eaba94db1c4$var$A(a);
    return $01a60eaba94db1c4$var$Pa($01a60eaba94db1c4$var$y, $01a60eaba94db1c4$var$z);
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.countVarints", function(a, b, c) {
    for(var d = 0, f = b; f < c; f++)d += a[f] >> 7;
    return c - b - d;
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.countVarintFields", function(a, b, c, d) {
    var f = 0;
    d *= 8;
    if (128 > d) for(; b < c && a[b++] == d;)for(f++;;){
        var h = a[b++];
        if (0 == (h & 128)) break;
    }
    else for(; b < c;){
        for(h = d; 128 < h;){
            if (a[b] != (h & 127 | 128)) return f;
            b++;
            h >>= 7;
        }
        if (a[b++] != h) break;
        for(f++; h = a[b++], 0 != (h & 128););
    }
    return f;
}, void 0);
function $01a60eaba94db1c4$var$Ta(a, b, c, d, f) {
    var h = 0;
    if (128 > d) for(; b < c && a[b++] == d;)h++, b += f;
    else for(; b < c;){
        for(var m = d; 128 < m;){
            if (a[b++] != (m & 127 | 128)) return h;
            m >>= 7;
        }
        if (a[b++] != m) break;
        h++;
        b += f;
    }
    return h;
}
$01a60eaba94db1c4$var$g("jspb.utils.countFixed32Fields", function(a, b, c, d) {
    return $01a60eaba94db1c4$var$Ta(a, b, c, 8 * d + 5, 4);
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.countFixed64Fields", function(a, b, c, d) {
    return $01a60eaba94db1c4$var$Ta(a, b, c, 8 * d + 1, 8);
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.countDelimitedFields", function(a, b, c, d) {
    var f = 0;
    for(d = 8 * d + 2; b < c;){
        for(var h = d; 128 < h;){
            if (a[b++] != (h & 127 | 128)) return f;
            h >>= 7;
        }
        if (a[b++] != h) break;
        f++;
        for(var m = 0, t = 1; h = a[b++], m += (h & 127) * t, t *= 128, 0 != (h & 128););
        b += m;
    }
    return f;
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.debugBytesToTextFormat", function(a) {
    var b = '"';
    if (a) {
        a = $01a60eaba94db1c4$var$Ua(a);
        for(var c = 0; c < a.length; c++)b += "\\x", 16 > a[c] && (b += "0"), b += a[c].toString(16);
    }
    return b + '"';
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.debugScalarToTextFormat", function(a) {
    if ("string" === typeof a) {
        a = String(a);
        for(var b = [
            '"'
        ], c = 0; c < a.length; c++){
            var d = a.charAt(c), f = d.charCodeAt(0), h = c + 1, m;
            if (!(m = $01a60eaba94db1c4$var$ya[d])) {
                if (!(31 < f && 127 > f)) {
                    if (f = d, f in $01a60eaba94db1c4$var$za) d = $01a60eaba94db1c4$var$za[f];
                    else if (f in $01a60eaba94db1c4$var$ya) d = $01a60eaba94db1c4$var$za[f] = $01a60eaba94db1c4$var$ya[f];
                    else {
                        m = f.charCodeAt(0);
                        if (31 < m && 127 > m) d = f;
                        else {
                            if (256 > m) {
                                if (d = "\\x", 16 > m || 256 < m) d += "0";
                            } else d = "\\u", 4096 > m && (d += "0");
                            d += m.toString(16).toUpperCase();
                        }
                        d = $01a60eaba94db1c4$var$za[f] = d;
                    }
                }
                m = d;
            }
            b[h] = m;
        }
        b.push('"');
        a = b.join("");
    } else a = a.toString();
    return a;
}, void 0);
$01a60eaba94db1c4$var$g("jspb.utils.stringToByteArray", function(a) {
    for(var b = new Uint8Array(a.length), c = 0; c < a.length; c++){
        var d = a.charCodeAt(c);
        if (255 < d) throw Error("Conversion error: string contains codepoint outside of byte range");
        b[c] = d;
    }
    return b;
}, void 0);
function $01a60eaba94db1c4$var$Ua(a) {
    if (a.constructor === Uint8Array) return a;
    if (a.constructor === ArrayBuffer) return new Uint8Array(a);
    if (a.constructor === Array) return new Uint8Array(a);
    if (a.constructor === String) return $01a60eaba94db1c4$var$Da(a);
    if (a instanceof Uint8Array) return new Uint8Array(a.buffer, a.byteOffset, a.byteLength);
    $01a60eaba94db1c4$var$p("Type not convertible to Uint8Array.");
    return new Uint8Array(0);
}
$01a60eaba94db1c4$var$g("jspb.utils.byteSourceToUint8Array", $01a60eaba94db1c4$var$Ua, void 0);
function $01a60eaba94db1c4$var$I(a, b, c) {
    this.b = null;
    this.a = this.c = this.h = 0;
    this.v = !1;
    a && this.H(a, b, c);
}
$01a60eaba94db1c4$var$g("jspb.BinaryDecoder", $01a60eaba94db1c4$var$I, void 0);
var $01a60eaba94db1c4$var$Va = [];
$01a60eaba94db1c4$var$I.getInstanceCacheLength = function() {
    return $01a60eaba94db1c4$var$Va.length;
};
function $01a60eaba94db1c4$var$Wa(a, b, c) {
    if ($01a60eaba94db1c4$var$Va.length) {
        var d = $01a60eaba94db1c4$var$Va.pop();
        a && d.H(a, b, c);
        return d;
    }
    return new $01a60eaba94db1c4$var$I(a, b, c);
}
$01a60eaba94db1c4$var$I.alloc = $01a60eaba94db1c4$var$Wa;
$01a60eaba94db1c4$var$I.prototype.Ca = function() {
    this.clear();
    100 > $01a60eaba94db1c4$var$Va.length && $01a60eaba94db1c4$var$Va.push(this);
};
$01a60eaba94db1c4$var$I.prototype.free = $01a60eaba94db1c4$var$I.prototype.Ca;
$01a60eaba94db1c4$var$I.prototype.clone = function() {
    return $01a60eaba94db1c4$var$Wa(this.b, this.h, this.c - this.h);
};
$01a60eaba94db1c4$var$I.prototype.clone = $01a60eaba94db1c4$var$I.prototype.clone;
$01a60eaba94db1c4$var$I.prototype.clear = function() {
    this.b = null;
    this.a = this.c = this.h = 0;
    this.v = !1;
};
$01a60eaba94db1c4$var$I.prototype.clear = $01a60eaba94db1c4$var$I.prototype.clear;
$01a60eaba94db1c4$var$I.prototype.Y = function() {
    return this.b;
};
$01a60eaba94db1c4$var$I.prototype.getBuffer = $01a60eaba94db1c4$var$I.prototype.Y;
$01a60eaba94db1c4$var$I.prototype.H = function(a, b, c) {
    this.b = $01a60eaba94db1c4$var$Ua(a);
    this.h = void 0 !== b ? b : 0;
    this.c = void 0 !== c ? this.h + c : this.b.length;
    this.a = this.h;
};
$01a60eaba94db1c4$var$I.prototype.setBlock = $01a60eaba94db1c4$var$I.prototype.H;
$01a60eaba94db1c4$var$I.prototype.Db = function() {
    return this.c;
};
$01a60eaba94db1c4$var$I.prototype.getEnd = $01a60eaba94db1c4$var$I.prototype.Db;
$01a60eaba94db1c4$var$I.prototype.setEnd = function(a) {
    this.c = a;
};
$01a60eaba94db1c4$var$I.prototype.setEnd = $01a60eaba94db1c4$var$I.prototype.setEnd;
$01a60eaba94db1c4$var$I.prototype.reset = function() {
    this.a = this.h;
};
$01a60eaba94db1c4$var$I.prototype.reset = $01a60eaba94db1c4$var$I.prototype.reset;
$01a60eaba94db1c4$var$I.prototype.B = function() {
    return this.a;
};
$01a60eaba94db1c4$var$I.prototype.getCursor = $01a60eaba94db1c4$var$I.prototype.B;
$01a60eaba94db1c4$var$I.prototype.Ma = function(a) {
    this.a = a;
};
$01a60eaba94db1c4$var$I.prototype.setCursor = $01a60eaba94db1c4$var$I.prototype.Ma;
$01a60eaba94db1c4$var$I.prototype.advance = function(a) {
    this.a += a;
    $01a60eaba94db1c4$var$n(this.a <= this.c);
};
$01a60eaba94db1c4$var$I.prototype.advance = $01a60eaba94db1c4$var$I.prototype.advance;
$01a60eaba94db1c4$var$I.prototype.ya = function() {
    return this.a == this.c;
};
$01a60eaba94db1c4$var$I.prototype.atEnd = $01a60eaba94db1c4$var$I.prototype.ya;
$01a60eaba94db1c4$var$I.prototype.Qb = function() {
    return this.a > this.c;
};
$01a60eaba94db1c4$var$I.prototype.pastEnd = $01a60eaba94db1c4$var$I.prototype.Qb;
$01a60eaba94db1c4$var$I.prototype.getError = function() {
    return this.v || 0 > this.a || this.a > this.c;
};
$01a60eaba94db1c4$var$I.prototype.getError = $01a60eaba94db1c4$var$I.prototype.getError;
$01a60eaba94db1c4$var$I.prototype.w = function(a) {
    for(var b = 128, c = 0, d = 0, f = 0; 4 > f && 128 <= b; f++)b = this.b[this.a++], c |= (b & 127) << 7 * f;
    128 <= b && (b = this.b[this.a++], c |= (b & 127) << 28, d |= (b & 127) >> 4);
    if (128 <= b) for(f = 0; 5 > f && 128 <= b; f++)b = this.b[this.a++], d |= (b & 127) << 7 * f + 3;
    if (128 > b) return a(c >>> 0, d >>> 0);
    $01a60eaba94db1c4$var$p("Failed to read varint, encoding is invalid.");
    this.v = !0;
};
$01a60eaba94db1c4$var$I.prototype.readSplitVarint64 = $01a60eaba94db1c4$var$I.prototype.w;
$01a60eaba94db1c4$var$I.prototype.ea = function(a) {
    return this.w(function(b, c) {
        return $01a60eaba94db1c4$var$Ma(b, c, a);
    });
};
$01a60eaba94db1c4$var$I.prototype.readSplitZigzagVarint64 = $01a60eaba94db1c4$var$I.prototype.ea;
$01a60eaba94db1c4$var$I.prototype.ta = function(a) {
    var b = this.b, c = this.a;
    this.a += 8;
    for(var d = 0, f = 0, h = c + 7; h >= c; h--)d = d << 8 | b[h], f = f << 8 | b[h + 4];
    return a(d, f);
};
$01a60eaba94db1c4$var$I.prototype.readSplitFixed64 = $01a60eaba94db1c4$var$I.prototype.ta;
$01a60eaba94db1c4$var$I.prototype.kb = function() {
    for(; this.b[this.a] & 128;)this.a++;
    this.a++;
};
$01a60eaba94db1c4$var$I.prototype.skipVarint = $01a60eaba94db1c4$var$I.prototype.kb;
$01a60eaba94db1c4$var$I.prototype.mb = function(a) {
    for(; 128 < a;)this.a--, a >>>= 7;
    this.a--;
};
$01a60eaba94db1c4$var$I.prototype.unskipVarint = $01a60eaba94db1c4$var$I.prototype.mb;
$01a60eaba94db1c4$var$I.prototype.o = function() {
    var a = this.b;
    var b = a[this.a];
    var c = b & 127;
    if (128 > b) return this.a += 1, $01a60eaba94db1c4$var$n(this.a <= this.c), c;
    b = a[this.a + 1];
    c |= (b & 127) << 7;
    if (128 > b) return this.a += 2, $01a60eaba94db1c4$var$n(this.a <= this.c), c;
    b = a[this.a + 2];
    c |= (b & 127) << 14;
    if (128 > b) return this.a += 3, $01a60eaba94db1c4$var$n(this.a <= this.c), c;
    b = a[this.a + 3];
    c |= (b & 127) << 21;
    if (128 > b) return this.a += 4, $01a60eaba94db1c4$var$n(this.a <= this.c), c;
    b = a[this.a + 4];
    c |= (b & 15) << 28;
    if (128 > b) return this.a += 5, $01a60eaba94db1c4$var$n(this.a <= this.c), c >>> 0;
    this.a += 5;
    128 <= a[this.a++] && 128 <= a[this.a++] && 128 <= a[this.a++] && 128 <= a[this.a++] && 128 <= a[this.a++] && $01a60eaba94db1c4$var$n(!1);
    $01a60eaba94db1c4$var$n(this.a <= this.c);
    return c;
};
$01a60eaba94db1c4$var$I.prototype.readUnsignedVarint32 = $01a60eaba94db1c4$var$I.prototype.o;
$01a60eaba94db1c4$var$I.prototype.da = function() {
    return ~~this.o();
};
$01a60eaba94db1c4$var$I.prototype.readSignedVarint32 = $01a60eaba94db1c4$var$I.prototype.da;
$01a60eaba94db1c4$var$I.prototype.O = function() {
    return this.o().toString();
};
$01a60eaba94db1c4$var$I.prototype.Ea = function() {
    return this.da().toString();
};
$01a60eaba94db1c4$var$I.prototype.readSignedVarint32String = $01a60eaba94db1c4$var$I.prototype.Ea;
$01a60eaba94db1c4$var$I.prototype.Ia = function() {
    var a = this.o();
    return a >>> 1 ^ -(a & 1);
};
$01a60eaba94db1c4$var$I.prototype.readZigzagVarint32 = $01a60eaba94db1c4$var$I.prototype.Ia;
$01a60eaba94db1c4$var$I.prototype.Ga = function() {
    return this.w($01a60eaba94db1c4$var$D);
};
$01a60eaba94db1c4$var$I.prototype.readUnsignedVarint64 = $01a60eaba94db1c4$var$I.prototype.Ga;
$01a60eaba94db1c4$var$I.prototype.Ha = function() {
    return this.w($01a60eaba94db1c4$var$F);
};
$01a60eaba94db1c4$var$I.prototype.readUnsignedVarint64String = $01a60eaba94db1c4$var$I.prototype.Ha;
$01a60eaba94db1c4$var$I.prototype.sa = function() {
    return this.w($01a60eaba94db1c4$var$E);
};
$01a60eaba94db1c4$var$I.prototype.readSignedVarint64 = $01a60eaba94db1c4$var$I.prototype.sa;
$01a60eaba94db1c4$var$I.prototype.Fa = function() {
    return this.w($01a60eaba94db1c4$var$G);
};
$01a60eaba94db1c4$var$I.prototype.readSignedVarint64String = $01a60eaba94db1c4$var$I.prototype.Fa;
$01a60eaba94db1c4$var$I.prototype.Ja = function() {
    return this.w($01a60eaba94db1c4$var$Ka);
};
$01a60eaba94db1c4$var$I.prototype.readZigzagVarint64 = $01a60eaba94db1c4$var$I.prototype.Ja;
$01a60eaba94db1c4$var$I.prototype.fb = function() {
    return this.ea($01a60eaba94db1c4$var$Pa);
};
$01a60eaba94db1c4$var$I.prototype.readZigzagVarintHash64 = $01a60eaba94db1c4$var$I.prototype.fb;
$01a60eaba94db1c4$var$I.prototype.Ka = function() {
    return this.ea($01a60eaba94db1c4$var$G);
};
$01a60eaba94db1c4$var$I.prototype.readZigzagVarint64String = $01a60eaba94db1c4$var$I.prototype.Ka;
$01a60eaba94db1c4$var$I.prototype.Gc = function() {
    var a = this.b[this.a];
    this.a += 1;
    $01a60eaba94db1c4$var$n(this.a <= this.c);
    return a;
};
$01a60eaba94db1c4$var$I.prototype.readUint8 = $01a60eaba94db1c4$var$I.prototype.Gc;
$01a60eaba94db1c4$var$I.prototype.Ec = function() {
    var a = this.b[this.a], b = this.b[this.a + 1];
    this.a += 2;
    $01a60eaba94db1c4$var$n(this.a <= this.c);
    return a << 0 | b << 8;
};
$01a60eaba94db1c4$var$I.prototype.readUint16 = $01a60eaba94db1c4$var$I.prototype.Ec;
$01a60eaba94db1c4$var$I.prototype.m = function() {
    var a = this.b[this.a], b = this.b[this.a + 1], c = this.b[this.a + 2], d = this.b[this.a + 3];
    this.a += 4;
    $01a60eaba94db1c4$var$n(this.a <= this.c);
    return (a << 0 | b << 8 | c << 16 | d << 24) >>> 0;
};
$01a60eaba94db1c4$var$I.prototype.readUint32 = $01a60eaba94db1c4$var$I.prototype.m;
$01a60eaba94db1c4$var$I.prototype.ga = function() {
    var a = this.m(), b = this.m();
    return $01a60eaba94db1c4$var$D(a, b);
};
$01a60eaba94db1c4$var$I.prototype.readUint64 = $01a60eaba94db1c4$var$I.prototype.ga;
$01a60eaba94db1c4$var$I.prototype.ha = function() {
    var a = this.m(), b = this.m();
    return $01a60eaba94db1c4$var$F(a, b);
};
$01a60eaba94db1c4$var$I.prototype.readUint64String = $01a60eaba94db1c4$var$I.prototype.ha;
$01a60eaba94db1c4$var$I.prototype.Xb = function() {
    var a = this.b[this.a];
    this.a += 1;
    $01a60eaba94db1c4$var$n(this.a <= this.c);
    return a << 24 >> 24;
};
$01a60eaba94db1c4$var$I.prototype.readInt8 = $01a60eaba94db1c4$var$I.prototype.Xb;
$01a60eaba94db1c4$var$I.prototype.Vb = function() {
    var a = this.b[this.a], b = this.b[this.a + 1];
    this.a += 2;
    $01a60eaba94db1c4$var$n(this.a <= this.c);
    return (a << 0 | b << 8) << 16 >> 16;
};
$01a60eaba94db1c4$var$I.prototype.readInt16 = $01a60eaba94db1c4$var$I.prototype.Vb;
$01a60eaba94db1c4$var$I.prototype.P = function() {
    var a = this.b[this.a], b = this.b[this.a + 1], c = this.b[this.a + 2], d = this.b[this.a + 3];
    this.a += 4;
    $01a60eaba94db1c4$var$n(this.a <= this.c);
    return a << 0 | b << 8 | c << 16 | d << 24;
};
$01a60eaba94db1c4$var$I.prototype.readInt32 = $01a60eaba94db1c4$var$I.prototype.P;
$01a60eaba94db1c4$var$I.prototype.ba = function() {
    var a = this.m(), b = this.m();
    return $01a60eaba94db1c4$var$E(a, b);
};
$01a60eaba94db1c4$var$I.prototype.readInt64 = $01a60eaba94db1c4$var$I.prototype.ba;
$01a60eaba94db1c4$var$I.prototype.ca = function() {
    var a = this.m(), b = this.m();
    return $01a60eaba94db1c4$var$G(a, b);
};
$01a60eaba94db1c4$var$I.prototype.readInt64String = $01a60eaba94db1c4$var$I.prototype.ca;
$01a60eaba94db1c4$var$I.prototype.aa = function() {
    var a = this.m();
    return $01a60eaba94db1c4$var$Na(a, 0);
};
$01a60eaba94db1c4$var$I.prototype.readFloat = $01a60eaba94db1c4$var$I.prototype.aa;
$01a60eaba94db1c4$var$I.prototype.Z = function() {
    var a = this.m(), b = this.m();
    return $01a60eaba94db1c4$var$Oa(a, b);
};
$01a60eaba94db1c4$var$I.prototype.readDouble = $01a60eaba94db1c4$var$I.prototype.Z;
$01a60eaba94db1c4$var$I.prototype.pa = function() {
    return !!this.b[this.a++];
};
$01a60eaba94db1c4$var$I.prototype.readBool = $01a60eaba94db1c4$var$I.prototype.pa;
$01a60eaba94db1c4$var$I.prototype.ra = function() {
    return this.da();
};
$01a60eaba94db1c4$var$I.prototype.readEnum = $01a60eaba94db1c4$var$I.prototype.ra;
$01a60eaba94db1c4$var$I.prototype.fa = function(a) {
    var b = this.b, c = this.a;
    a = c + a;
    for(var d = [], f = ""; c < a;){
        var h = b[c++];
        if (128 > h) d.push(h);
        else if (192 > h) continue;
        else if (224 > h) {
            var m = b[c++];
            d.push((h & 31) << 6 | m & 63);
        } else if (240 > h) {
            m = b[c++];
            var t = b[c++];
            d.push((h & 15) << 12 | (m & 63) << 6 | t & 63);
        } else if (248 > h) {
            m = b[c++];
            t = b[c++];
            var B = b[c++];
            h = (h & 7) << 18 | (m & 63) << 12 | (t & 63) << 6 | B & 63;
            h -= 65536;
            d.push((h >> 10 & 1023) + 55296, (h & 1023) + 56320);
        }
        8192 <= d.length && (f += String.fromCharCode.apply(null, d), d.length = 0);
    }
    f += $01a60eaba94db1c4$var$xa(d);
    this.a = c;
    return f;
};
$01a60eaba94db1c4$var$I.prototype.readString = $01a60eaba94db1c4$var$I.prototype.fa;
$01a60eaba94db1c4$var$I.prototype.Dc = function() {
    var a = this.o();
    return this.fa(a);
};
$01a60eaba94db1c4$var$I.prototype.readStringWithLength = $01a60eaba94db1c4$var$I.prototype.Dc;
$01a60eaba94db1c4$var$I.prototype.qa = function(a) {
    if (0 > a || this.a + a > this.b.length) return this.v = !0, $01a60eaba94db1c4$var$p("Invalid byte length!"), new Uint8Array(0);
    var b = this.b.subarray(this.a, this.a + a);
    this.a += a;
    $01a60eaba94db1c4$var$n(this.a <= this.c);
    return b;
};
$01a60eaba94db1c4$var$I.prototype.readBytes = $01a60eaba94db1c4$var$I.prototype.qa;
$01a60eaba94db1c4$var$I.prototype.ia = function() {
    return this.w($01a60eaba94db1c4$var$Pa);
};
$01a60eaba94db1c4$var$I.prototype.readVarintHash64 = $01a60eaba94db1c4$var$I.prototype.ia;
$01a60eaba94db1c4$var$I.prototype.$ = function() {
    var a = this.b, b = this.a, c = a[b], d = a[b + 1], f = a[b + 2], h = a[b + 3], m = a[b + 4], t = a[b + 5], B = a[b + 6];
    a = a[b + 7];
    this.a += 8;
    return String.fromCharCode(c, d, f, h, m, t, B, a);
};
$01a60eaba94db1c4$var$I.prototype.readFixedHash64 = $01a60eaba94db1c4$var$I.prototype.$;
function $01a60eaba94db1c4$var$J(a, b, c) {
    this.a = $01a60eaba94db1c4$var$Wa(a, b, c);
    this.O = this.a.B();
    this.b = this.c = -1;
    this.h = !1;
    this.v = null;
}
$01a60eaba94db1c4$var$g("jspb.BinaryReader", $01a60eaba94db1c4$var$J, void 0);
var $01a60eaba94db1c4$var$K = [];
$01a60eaba94db1c4$var$J.clearInstanceCache = function() {
    $01a60eaba94db1c4$var$K = [];
};
$01a60eaba94db1c4$var$J.getInstanceCacheLength = function() {
    return $01a60eaba94db1c4$var$K.length;
};
function $01a60eaba94db1c4$var$Xa(a, b, c) {
    if ($01a60eaba94db1c4$var$K.length) {
        var d = $01a60eaba94db1c4$var$K.pop();
        a && d.a.H(a, b, c);
        return d;
    }
    return new $01a60eaba94db1c4$var$J(a, b, c);
}
$01a60eaba94db1c4$var$J.alloc = $01a60eaba94db1c4$var$Xa;
$01a60eaba94db1c4$var$J.prototype.zb = $01a60eaba94db1c4$var$Xa;
$01a60eaba94db1c4$var$J.prototype.alloc = $01a60eaba94db1c4$var$J.prototype.zb;
$01a60eaba94db1c4$var$J.prototype.Ca = function() {
    this.a.clear();
    this.b = this.c = -1;
    this.h = !1;
    this.v = null;
    100 > $01a60eaba94db1c4$var$K.length && $01a60eaba94db1c4$var$K.push(this);
};
$01a60eaba94db1c4$var$J.prototype.free = $01a60eaba94db1c4$var$J.prototype.Ca;
$01a60eaba94db1c4$var$J.prototype.Fb = function() {
    return this.O;
};
$01a60eaba94db1c4$var$J.prototype.getFieldCursor = $01a60eaba94db1c4$var$J.prototype.Fb;
$01a60eaba94db1c4$var$J.prototype.B = function() {
    return this.a.B();
};
$01a60eaba94db1c4$var$J.prototype.getCursor = $01a60eaba94db1c4$var$J.prototype.B;
$01a60eaba94db1c4$var$J.prototype.Y = function() {
    return this.a.Y();
};
$01a60eaba94db1c4$var$J.prototype.getBuffer = $01a60eaba94db1c4$var$J.prototype.Y;
$01a60eaba94db1c4$var$J.prototype.Hb = function() {
    return this.c;
};
$01a60eaba94db1c4$var$J.prototype.getFieldNumber = $01a60eaba94db1c4$var$J.prototype.Hb;
$01a60eaba94db1c4$var$J.prototype.Lb = function() {
    return this.b;
};
$01a60eaba94db1c4$var$J.prototype.getWireType = $01a60eaba94db1c4$var$J.prototype.Lb;
$01a60eaba94db1c4$var$J.prototype.Mb = function() {
    return 2 == this.b;
};
$01a60eaba94db1c4$var$J.prototype.isDelimited = $01a60eaba94db1c4$var$J.prototype.Mb;
$01a60eaba94db1c4$var$J.prototype.bb = function() {
    return 4 == this.b;
};
$01a60eaba94db1c4$var$J.prototype.isEndGroup = $01a60eaba94db1c4$var$J.prototype.bb;
$01a60eaba94db1c4$var$J.prototype.getError = function() {
    return this.h || this.a.getError();
};
$01a60eaba94db1c4$var$J.prototype.getError = $01a60eaba94db1c4$var$J.prototype.getError;
$01a60eaba94db1c4$var$J.prototype.H = function(a, b, c) {
    this.a.H(a, b, c);
    this.b = this.c = -1;
};
$01a60eaba94db1c4$var$J.prototype.setBlock = $01a60eaba94db1c4$var$J.prototype.H;
$01a60eaba94db1c4$var$J.prototype.reset = function() {
    this.a.reset();
    this.b = this.c = -1;
};
$01a60eaba94db1c4$var$J.prototype.reset = $01a60eaba94db1c4$var$J.prototype.reset;
$01a60eaba94db1c4$var$J.prototype.advance = function(a) {
    this.a.advance(a);
};
$01a60eaba94db1c4$var$J.prototype.advance = $01a60eaba94db1c4$var$J.prototype.advance;
$01a60eaba94db1c4$var$J.prototype.oa = function() {
    if (this.a.ya()) return !1;
    if (this.getError()) return $01a60eaba94db1c4$var$p("Decoder hit an error"), !1;
    this.O = this.a.B();
    var a = this.a.o(), b = a >>> 3;
    a &= 7;
    if (0 != a && 5 != a && 1 != a && 2 != a && 3 != a && 4 != a) return $01a60eaba94db1c4$var$p("Invalid wire type: %s (at position %s)", a, this.O), this.h = !0, !1;
    this.c = b;
    this.b = a;
    return !0;
};
$01a60eaba94db1c4$var$J.prototype.nextField = $01a60eaba94db1c4$var$J.prototype.oa;
$01a60eaba94db1c4$var$J.prototype.Oa = function() {
    this.a.mb(this.c << 3 | this.b);
};
$01a60eaba94db1c4$var$J.prototype.unskipHeader = $01a60eaba94db1c4$var$J.prototype.Oa;
$01a60eaba94db1c4$var$J.prototype.Lc = function() {
    var a = this.c;
    for(this.Oa(); this.oa() && this.c == a;)this.C();
    this.a.ya() || this.Oa();
};
$01a60eaba94db1c4$var$J.prototype.skipMatchingFields = $01a60eaba94db1c4$var$J.prototype.Lc;
$01a60eaba94db1c4$var$J.prototype.lb = function() {
    0 != this.b ? ($01a60eaba94db1c4$var$p("Invalid wire type for skipVarintField"), this.C()) : this.a.kb();
};
$01a60eaba94db1c4$var$J.prototype.skipVarintField = $01a60eaba94db1c4$var$J.prototype.lb;
$01a60eaba94db1c4$var$J.prototype.gb = function() {
    if (2 != this.b) $01a60eaba94db1c4$var$p("Invalid wire type for skipDelimitedField"), this.C();
    else {
        var a = this.a.o();
        this.a.advance(a);
    }
};
$01a60eaba94db1c4$var$J.prototype.skipDelimitedField = $01a60eaba94db1c4$var$J.prototype.gb;
$01a60eaba94db1c4$var$J.prototype.hb = function() {
    5 != this.b ? ($01a60eaba94db1c4$var$p("Invalid wire type for skipFixed32Field"), this.C()) : this.a.advance(4);
};
$01a60eaba94db1c4$var$J.prototype.skipFixed32Field = $01a60eaba94db1c4$var$J.prototype.hb;
$01a60eaba94db1c4$var$J.prototype.ib = function() {
    1 != this.b ? ($01a60eaba94db1c4$var$p("Invalid wire type for skipFixed64Field"), this.C()) : this.a.advance(8);
};
$01a60eaba94db1c4$var$J.prototype.skipFixed64Field = $01a60eaba94db1c4$var$J.prototype.ib;
$01a60eaba94db1c4$var$J.prototype.jb = function() {
    var a = this.c;
    do {
        if (!this.oa()) {
            $01a60eaba94db1c4$var$p("Unmatched start-group tag: stream EOF");
            this.h = !0;
            break;
        }
        if (4 == this.b) {
            this.c != a && ($01a60eaba94db1c4$var$p("Unmatched end-group tag"), this.h = !0);
            break;
        }
        this.C();
    }while (1);
};
$01a60eaba94db1c4$var$J.prototype.skipGroup = $01a60eaba94db1c4$var$J.prototype.jb;
$01a60eaba94db1c4$var$J.prototype.C = function() {
    switch(this.b){
        case 0:
            this.lb();
            break;
        case 1:
            this.ib();
            break;
        case 2:
            this.gb();
            break;
        case 5:
            this.hb();
            break;
        case 3:
            this.jb();
            break;
        default:
            $01a60eaba94db1c4$var$p("Invalid wire encoding for field.");
    }
};
$01a60eaba94db1c4$var$J.prototype.skipField = $01a60eaba94db1c4$var$J.prototype.C;
$01a60eaba94db1c4$var$J.prototype.Hc = function(a, b) {
    null === this.v && (this.v = {});
    $01a60eaba94db1c4$var$n(!this.v[a]);
    this.v[a] = b;
};
$01a60eaba94db1c4$var$J.prototype.registerReadCallback = $01a60eaba94db1c4$var$J.prototype.Hc;
$01a60eaba94db1c4$var$J.prototype.Ic = function(a) {
    $01a60eaba94db1c4$var$n(null !== this.v);
    a = this.v[a];
    $01a60eaba94db1c4$var$n(a);
    return a(this);
};
$01a60eaba94db1c4$var$J.prototype.runReadCallback = $01a60eaba94db1c4$var$J.prototype.Ic;
$01a60eaba94db1c4$var$J.prototype.Yb = function(a, b) {
    $01a60eaba94db1c4$var$n(2 == this.b);
    var c = this.a.c, d = this.a.o();
    d = this.a.B() + d;
    this.a.setEnd(d);
    b(a, this);
    this.a.Ma(d);
    this.a.setEnd(c);
};
$01a60eaba94db1c4$var$J.prototype.readMessage = $01a60eaba94db1c4$var$J.prototype.Yb;
$01a60eaba94db1c4$var$J.prototype.Ub = function(a, b, c) {
    $01a60eaba94db1c4$var$n(3 == this.b);
    $01a60eaba94db1c4$var$n(this.c == a);
    c(b, this);
    this.h || 4 == this.b || ($01a60eaba94db1c4$var$p("Group submessage did not end with an END_GROUP tag"), this.h = !0);
};
$01a60eaba94db1c4$var$J.prototype.readGroup = $01a60eaba94db1c4$var$J.prototype.Ub;
$01a60eaba94db1c4$var$J.prototype.Gb = function() {
    $01a60eaba94db1c4$var$n(2 == this.b);
    var a = this.a.o(), b = this.a.B(), c = b + a;
    a = $01a60eaba94db1c4$var$Wa(this.a.Y(), b, a);
    this.a.Ma(c);
    return a;
};
$01a60eaba94db1c4$var$J.prototype.getFieldDecoder = $01a60eaba94db1c4$var$J.prototype.Gb;
$01a60eaba94db1c4$var$J.prototype.P = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.da();
};
$01a60eaba94db1c4$var$J.prototype.readInt32 = $01a60eaba94db1c4$var$J.prototype.P;
$01a60eaba94db1c4$var$J.prototype.Wb = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.Ea();
};
$01a60eaba94db1c4$var$J.prototype.readInt32String = $01a60eaba94db1c4$var$J.prototype.Wb;
$01a60eaba94db1c4$var$J.prototype.ba = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.sa();
};
$01a60eaba94db1c4$var$J.prototype.readInt64 = $01a60eaba94db1c4$var$J.prototype.ba;
$01a60eaba94db1c4$var$J.prototype.ca = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.Fa();
};
$01a60eaba94db1c4$var$J.prototype.readInt64String = $01a60eaba94db1c4$var$J.prototype.ca;
$01a60eaba94db1c4$var$J.prototype.m = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.o();
};
$01a60eaba94db1c4$var$J.prototype.readUint32 = $01a60eaba94db1c4$var$J.prototype.m;
$01a60eaba94db1c4$var$J.prototype.Fc = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.O();
};
$01a60eaba94db1c4$var$J.prototype.readUint32String = $01a60eaba94db1c4$var$J.prototype.Fc;
$01a60eaba94db1c4$var$J.prototype.ga = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.Ga();
};
$01a60eaba94db1c4$var$J.prototype.readUint64 = $01a60eaba94db1c4$var$J.prototype.ga;
$01a60eaba94db1c4$var$J.prototype.ha = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.Ha();
};
$01a60eaba94db1c4$var$J.prototype.readUint64String = $01a60eaba94db1c4$var$J.prototype.ha;
$01a60eaba94db1c4$var$J.prototype.zc = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.Ia();
};
$01a60eaba94db1c4$var$J.prototype.readSint32 = $01a60eaba94db1c4$var$J.prototype.zc;
$01a60eaba94db1c4$var$J.prototype.Ac = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.Ja();
};
$01a60eaba94db1c4$var$J.prototype.readSint64 = $01a60eaba94db1c4$var$J.prototype.Ac;
$01a60eaba94db1c4$var$J.prototype.Bc = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.Ka();
};
$01a60eaba94db1c4$var$J.prototype.readSint64String = $01a60eaba94db1c4$var$J.prototype.Bc;
$01a60eaba94db1c4$var$J.prototype.Rb = function() {
    $01a60eaba94db1c4$var$n(5 == this.b);
    return this.a.m();
};
$01a60eaba94db1c4$var$J.prototype.readFixed32 = $01a60eaba94db1c4$var$J.prototype.Rb;
$01a60eaba94db1c4$var$J.prototype.Sb = function() {
    $01a60eaba94db1c4$var$n(1 == this.b);
    return this.a.ga();
};
$01a60eaba94db1c4$var$J.prototype.readFixed64 = $01a60eaba94db1c4$var$J.prototype.Sb;
$01a60eaba94db1c4$var$J.prototype.Tb = function() {
    $01a60eaba94db1c4$var$n(1 == this.b);
    return this.a.ha();
};
$01a60eaba94db1c4$var$J.prototype.readFixed64String = $01a60eaba94db1c4$var$J.prototype.Tb;
$01a60eaba94db1c4$var$J.prototype.vc = function() {
    $01a60eaba94db1c4$var$n(5 == this.b);
    return this.a.P();
};
$01a60eaba94db1c4$var$J.prototype.readSfixed32 = $01a60eaba94db1c4$var$J.prototype.vc;
$01a60eaba94db1c4$var$J.prototype.wc = function() {
    $01a60eaba94db1c4$var$n(5 == this.b);
    return this.a.P().toString();
};
$01a60eaba94db1c4$var$J.prototype.readSfixed32String = $01a60eaba94db1c4$var$J.prototype.wc;
$01a60eaba94db1c4$var$J.prototype.xc = function() {
    $01a60eaba94db1c4$var$n(1 == this.b);
    return this.a.ba();
};
$01a60eaba94db1c4$var$J.prototype.readSfixed64 = $01a60eaba94db1c4$var$J.prototype.xc;
$01a60eaba94db1c4$var$J.prototype.yc = function() {
    $01a60eaba94db1c4$var$n(1 == this.b);
    return this.a.ca();
};
$01a60eaba94db1c4$var$J.prototype.readSfixed64String = $01a60eaba94db1c4$var$J.prototype.yc;
$01a60eaba94db1c4$var$J.prototype.aa = function() {
    $01a60eaba94db1c4$var$n(5 == this.b);
    return this.a.aa();
};
$01a60eaba94db1c4$var$J.prototype.readFloat = $01a60eaba94db1c4$var$J.prototype.aa;
$01a60eaba94db1c4$var$J.prototype.Z = function() {
    $01a60eaba94db1c4$var$n(1 == this.b);
    return this.a.Z();
};
$01a60eaba94db1c4$var$J.prototype.readDouble = $01a60eaba94db1c4$var$J.prototype.Z;
$01a60eaba94db1c4$var$J.prototype.pa = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return !!this.a.o();
};
$01a60eaba94db1c4$var$J.prototype.readBool = $01a60eaba94db1c4$var$J.prototype.pa;
$01a60eaba94db1c4$var$J.prototype.ra = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.sa();
};
$01a60eaba94db1c4$var$J.prototype.readEnum = $01a60eaba94db1c4$var$J.prototype.ra;
$01a60eaba94db1c4$var$J.prototype.fa = function() {
    $01a60eaba94db1c4$var$n(2 == this.b);
    var a = this.a.o();
    return this.a.fa(a);
};
$01a60eaba94db1c4$var$J.prototype.readString = $01a60eaba94db1c4$var$J.prototype.fa;
$01a60eaba94db1c4$var$J.prototype.qa = function() {
    $01a60eaba94db1c4$var$n(2 == this.b);
    var a = this.a.o();
    return this.a.qa(a);
};
$01a60eaba94db1c4$var$J.prototype.readBytes = $01a60eaba94db1c4$var$J.prototype.qa;
$01a60eaba94db1c4$var$J.prototype.ia = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.ia();
};
$01a60eaba94db1c4$var$J.prototype.readVarintHash64 = $01a60eaba94db1c4$var$J.prototype.ia;
$01a60eaba94db1c4$var$J.prototype.Cc = function() {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.fb();
};
$01a60eaba94db1c4$var$J.prototype.readSintHash64 = $01a60eaba94db1c4$var$J.prototype.Cc;
$01a60eaba94db1c4$var$J.prototype.w = function(a) {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.w(a);
};
$01a60eaba94db1c4$var$J.prototype.readSplitVarint64 = $01a60eaba94db1c4$var$J.prototype.w;
$01a60eaba94db1c4$var$J.prototype.ea = function(a) {
    $01a60eaba94db1c4$var$n(0 == this.b);
    return this.a.w(function(b, c) {
        return $01a60eaba94db1c4$var$Ma(b, c, a);
    });
};
$01a60eaba94db1c4$var$J.prototype.readSplitZigzagVarint64 = $01a60eaba94db1c4$var$J.prototype.ea;
$01a60eaba94db1c4$var$J.prototype.$ = function() {
    $01a60eaba94db1c4$var$n(1 == this.b);
    return this.a.$();
};
$01a60eaba94db1c4$var$J.prototype.readFixedHash64 = $01a60eaba94db1c4$var$J.prototype.$;
$01a60eaba94db1c4$var$J.prototype.ta = function(a) {
    $01a60eaba94db1c4$var$n(1 == this.b);
    return this.a.ta(a);
};
$01a60eaba94db1c4$var$J.prototype.readSplitFixed64 = $01a60eaba94db1c4$var$J.prototype.ta;
function $01a60eaba94db1c4$var$L(a, b) {
    $01a60eaba94db1c4$var$n(2 == a.b);
    var c = a.a.o();
    c = a.a.B() + c;
    for(var d = []; a.a.B() < c;)d.push(b.call(a.a));
    return d;
}
$01a60eaba94db1c4$var$J.prototype.gc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.da);
};
$01a60eaba94db1c4$var$J.prototype.readPackedInt32 = $01a60eaba94db1c4$var$J.prototype.gc;
$01a60eaba94db1c4$var$J.prototype.hc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.Ea);
};
$01a60eaba94db1c4$var$J.prototype.readPackedInt32String = $01a60eaba94db1c4$var$J.prototype.hc;
$01a60eaba94db1c4$var$J.prototype.ic = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.sa);
};
$01a60eaba94db1c4$var$J.prototype.readPackedInt64 = $01a60eaba94db1c4$var$J.prototype.ic;
$01a60eaba94db1c4$var$J.prototype.jc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.Fa);
};
$01a60eaba94db1c4$var$J.prototype.readPackedInt64String = $01a60eaba94db1c4$var$J.prototype.jc;
$01a60eaba94db1c4$var$J.prototype.qc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.o);
};
$01a60eaba94db1c4$var$J.prototype.readPackedUint32 = $01a60eaba94db1c4$var$J.prototype.qc;
$01a60eaba94db1c4$var$J.prototype.rc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.O);
};
$01a60eaba94db1c4$var$J.prototype.readPackedUint32String = $01a60eaba94db1c4$var$J.prototype.rc;
$01a60eaba94db1c4$var$J.prototype.sc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.Ga);
};
$01a60eaba94db1c4$var$J.prototype.readPackedUint64 = $01a60eaba94db1c4$var$J.prototype.sc;
$01a60eaba94db1c4$var$J.prototype.tc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.Ha);
};
$01a60eaba94db1c4$var$J.prototype.readPackedUint64String = $01a60eaba94db1c4$var$J.prototype.tc;
$01a60eaba94db1c4$var$J.prototype.nc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.Ia);
};
$01a60eaba94db1c4$var$J.prototype.readPackedSint32 = $01a60eaba94db1c4$var$J.prototype.nc;
$01a60eaba94db1c4$var$J.prototype.oc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.Ja);
};
$01a60eaba94db1c4$var$J.prototype.readPackedSint64 = $01a60eaba94db1c4$var$J.prototype.oc;
$01a60eaba94db1c4$var$J.prototype.pc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.Ka);
};
$01a60eaba94db1c4$var$J.prototype.readPackedSint64String = $01a60eaba94db1c4$var$J.prototype.pc;
$01a60eaba94db1c4$var$J.prototype.bc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.m);
};
$01a60eaba94db1c4$var$J.prototype.readPackedFixed32 = $01a60eaba94db1c4$var$J.prototype.bc;
$01a60eaba94db1c4$var$J.prototype.cc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.ga);
};
$01a60eaba94db1c4$var$J.prototype.readPackedFixed64 = $01a60eaba94db1c4$var$J.prototype.cc;
$01a60eaba94db1c4$var$J.prototype.dc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.ha);
};
$01a60eaba94db1c4$var$J.prototype.readPackedFixed64String = $01a60eaba94db1c4$var$J.prototype.dc;
$01a60eaba94db1c4$var$J.prototype.kc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.P);
};
$01a60eaba94db1c4$var$J.prototype.readPackedSfixed32 = $01a60eaba94db1c4$var$J.prototype.kc;
$01a60eaba94db1c4$var$J.prototype.lc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.ba);
};
$01a60eaba94db1c4$var$J.prototype.readPackedSfixed64 = $01a60eaba94db1c4$var$J.prototype.lc;
$01a60eaba94db1c4$var$J.prototype.mc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.ca);
};
$01a60eaba94db1c4$var$J.prototype.readPackedSfixed64String = $01a60eaba94db1c4$var$J.prototype.mc;
$01a60eaba94db1c4$var$J.prototype.fc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.aa);
};
$01a60eaba94db1c4$var$J.prototype.readPackedFloat = $01a60eaba94db1c4$var$J.prototype.fc;
$01a60eaba94db1c4$var$J.prototype.$b = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.Z);
};
$01a60eaba94db1c4$var$J.prototype.readPackedDouble = $01a60eaba94db1c4$var$J.prototype.$b;
$01a60eaba94db1c4$var$J.prototype.Zb = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.pa);
};
$01a60eaba94db1c4$var$J.prototype.readPackedBool = $01a60eaba94db1c4$var$J.prototype.Zb;
$01a60eaba94db1c4$var$J.prototype.ac = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.ra);
};
$01a60eaba94db1c4$var$J.prototype.readPackedEnum = $01a60eaba94db1c4$var$J.prototype.ac;
$01a60eaba94db1c4$var$J.prototype.uc = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.ia);
};
$01a60eaba94db1c4$var$J.prototype.readPackedVarintHash64 = $01a60eaba94db1c4$var$J.prototype.uc;
$01a60eaba94db1c4$var$J.prototype.ec = function() {
    return $01a60eaba94db1c4$var$L(this, this.a.$);
};
$01a60eaba94db1c4$var$J.prototype.readPackedFixedHash64 = $01a60eaba94db1c4$var$J.prototype.ec;
function $01a60eaba94db1c4$var$Ya(a, b, c, d, f) {
    this.ma = a;
    this.Ba = b;
    this.la = c;
    this.Na = d;
    this.na = f;
}
$01a60eaba94db1c4$var$g("jspb.ExtensionFieldInfo", $01a60eaba94db1c4$var$Ya, void 0);
function $01a60eaba94db1c4$var$Za(a, b, c, d, f, h) {
    this.Za = a;
    this.za = b;
    this.Aa = c;
    this.Wa = d;
    this.Ab = f;
    this.Nb = h;
}
$01a60eaba94db1c4$var$g("jspb.ExtensionFieldBinaryInfo", $01a60eaba94db1c4$var$Za, void 0);
$01a60eaba94db1c4$var$Ya.prototype.F = function() {
    return !!this.la;
};
$01a60eaba94db1c4$var$Ya.prototype.isMessageType = $01a60eaba94db1c4$var$Ya.prototype.F;
function $01a60eaba94db1c4$var$N() {}
$01a60eaba94db1c4$var$g("jspb.Message", $01a60eaba94db1c4$var$N, void 0);
$01a60eaba94db1c4$var$N.GENERATE_TO_OBJECT = !0;
$01a60eaba94db1c4$var$N.GENERATE_FROM_OBJECT = !0;
var $01a60eaba94db1c4$var$$a = "function" == typeof Uint8Array;
$01a60eaba94db1c4$var$N.prototype.Ib = function() {
    return this.b;
};
$01a60eaba94db1c4$var$N.prototype.getJsPbMessageId = $01a60eaba94db1c4$var$N.prototype.Ib;
$01a60eaba94db1c4$var$N.initialize = function(a, b, c, d, f, h) {
    a.f = null;
    b || (b = c ? [
        c
    ] : []);
    a.b = c ? String(c) : void 0;
    a.D = 0 === c ? -1 : 0;
    a.u = b;
    a: {
        c = a.u.length;
        b = -1;
        if (c && (b = c - 1, c = a.u[b], !(null === c || "object" != typeof c || Array.isArray(c) || $01a60eaba94db1c4$var$$a && c instanceof Uint8Array))) {
            a.G = b - a.D;
            a.i = c;
            break a;
        }
        -1 < d ? (a.G = Math.max(d, b + 1 - a.D), a.i = null) : a.G = Number.MAX_VALUE;
    }
    a.a = {};
    if (f) for(d = 0; d < f.length; d++)b = f[d], b < a.G ? (b += a.D, a.u[b] = a.u[b] || $01a60eaba94db1c4$var$ab) : ($01a60eaba94db1c4$var$bb(a), a.i[b] = a.i[b] || $01a60eaba94db1c4$var$ab);
    if (h && h.length) for(d = 0; d < h.length; d++)$01a60eaba94db1c4$var$cb(a, h[d]);
};
var $01a60eaba94db1c4$var$ab = Object.freeze ? Object.freeze([]) : [];
function $01a60eaba94db1c4$var$bb(a) {
    var b = a.G + a.D;
    a.u[b] || (a.i = a.u[b] = {});
}
function $01a60eaba94db1c4$var$db(a, b, c) {
    for(var d = [], f = 0; f < a.length; f++)d[f] = b.call(a[f], c, a[f]);
    return d;
}
$01a60eaba94db1c4$var$N.toObjectList = $01a60eaba94db1c4$var$db;
$01a60eaba94db1c4$var$N.toObjectExtension = function(a, b, c, d, f) {
    for(var h in c){
        var m = c[h], t = d.call(a, m);
        if (null != t) {
            for(var B in m.Ba)if (m.Ba.hasOwnProperty(B)) break;
            b[B] = m.Na ? m.na ? $01a60eaba94db1c4$var$db(t, m.Na, f) : m.Na(f, t) : t;
        }
    }
};
$01a60eaba94db1c4$var$N.serializeBinaryExtensions = function(a, b, c, d) {
    for(var f in c){
        var h = c[f], m = h.Za;
        if (!h.Aa) throw Error("Message extension present that was generated without binary serialization support");
        var t = d.call(a, m);
        if (null != t) {
            if (m.F()) {
                if (h.Wa) h.Aa.call(b, m.ma, t, h.Wa);
                else throw Error("Message extension present holding submessage without binary support enabled, and message is being serialized to binary format");
            } else h.Aa.call(b, m.ma, t);
        }
    }
};
$01a60eaba94db1c4$var$N.readBinaryExtension = function(a, b, c, d, f) {
    var h = c[b.c];
    if (h) {
        c = h.Za;
        if (!h.za) throw Error("Deserializing extension whose generated code does not support binary format");
        if (c.F()) {
            var m = new c.la;
            h.za.call(b, m, h.Ab);
        } else m = h.za.call(b);
        c.na && !h.Nb ? (b = d.call(a, c)) ? b.push(m) : f.call(a, c, [
            m
        ]) : f.call(a, c, m);
    } else b.C();
};
function $01a60eaba94db1c4$var$O(a, b) {
    if (b < a.G) {
        b += a.D;
        var c = a.u[b];
        return c === $01a60eaba94db1c4$var$ab ? a.u[b] = [] : c;
    }
    if (a.i) return c = a.i[b], c === $01a60eaba94db1c4$var$ab ? a.i[b] = [] : c;
}
$01a60eaba94db1c4$var$N.getField = $01a60eaba94db1c4$var$O;
$01a60eaba94db1c4$var$N.getRepeatedField = function(a, b) {
    return $01a60eaba94db1c4$var$O(a, b);
};
function $01a60eaba94db1c4$var$eb(a, b) {
    a = $01a60eaba94db1c4$var$O(a, b);
    return null == a ? a : +a;
}
$01a60eaba94db1c4$var$N.getOptionalFloatingPointField = $01a60eaba94db1c4$var$eb;
function $01a60eaba94db1c4$var$fb(a, b) {
    a = $01a60eaba94db1c4$var$O(a, b);
    return null == a ? a : !!a;
}
$01a60eaba94db1c4$var$N.getBooleanField = $01a60eaba94db1c4$var$fb;
$01a60eaba94db1c4$var$N.getRepeatedFloatingPointField = function(a, b) {
    var c = $01a60eaba94db1c4$var$O(a, b);
    a.a || (a.a = {});
    if (!a.a[b]) {
        for(var d = 0; d < c.length; d++)c[d] = +c[d];
        a.a[b] = !0;
    }
    return c;
};
$01a60eaba94db1c4$var$N.getRepeatedBooleanField = function(a, b) {
    var c = $01a60eaba94db1c4$var$O(a, b);
    a.a || (a.a = {});
    if (!a.a[b]) {
        for(var d = 0; d < c.length; d++)c[d] = !!c[d];
        a.a[b] = !0;
    }
    return c;
};
function $01a60eaba94db1c4$var$gb(a) {
    if (null == a || "string" === typeof a) return a;
    if ($01a60eaba94db1c4$var$$a && a instanceof Uint8Array) return $01a60eaba94db1c4$var$Ba(a);
    $01a60eaba94db1c4$var$p("Cannot coerce to b64 string: " + $01a60eaba94db1c4$var$k(a));
    return null;
}
$01a60eaba94db1c4$var$N.bytesAsB64 = $01a60eaba94db1c4$var$gb;
function $01a60eaba94db1c4$var$hb(a) {
    if (null == a || a instanceof Uint8Array) return a;
    if ("string" === typeof a) return $01a60eaba94db1c4$var$Da(a);
    $01a60eaba94db1c4$var$p("Cannot coerce to Uint8Array: " + $01a60eaba94db1c4$var$k(a));
    return null;
}
$01a60eaba94db1c4$var$N.bytesAsU8 = $01a60eaba94db1c4$var$hb;
$01a60eaba94db1c4$var$N.bytesListAsB64 = function(a) {
    $01a60eaba94db1c4$var$ib(a);
    return a.length && "string" !== typeof a[0] ? $01a60eaba94db1c4$var$l(a, $01a60eaba94db1c4$var$gb) : a;
};
$01a60eaba94db1c4$var$N.bytesListAsU8 = function(a) {
    $01a60eaba94db1c4$var$ib(a);
    return !a.length || a[0] instanceof Uint8Array ? a : $01a60eaba94db1c4$var$l(a, $01a60eaba94db1c4$var$hb);
};
function $01a60eaba94db1c4$var$ib(a) {
    if (a && 1 < a.length) {
        var b = $01a60eaba94db1c4$var$k(a[0]);
        $01a60eaba94db1c4$var$qa(a, function(c) {
            $01a60eaba94db1c4$var$k(c) != b && $01a60eaba94db1c4$var$p("Inconsistent type in JSPB repeated field array. Got " + $01a60eaba94db1c4$var$k(c) + " expected " + b);
        });
    }
}
function $01a60eaba94db1c4$var$jb(a, b, c) {
    a = $01a60eaba94db1c4$var$O(a, b);
    return null == a ? c : a;
}
$01a60eaba94db1c4$var$N.getFieldWithDefault = $01a60eaba94db1c4$var$jb;
$01a60eaba94db1c4$var$N.getBooleanFieldWithDefault = function(a, b, c) {
    a = $01a60eaba94db1c4$var$fb(a, b);
    return null == a ? c : a;
};
$01a60eaba94db1c4$var$N.getFloatingPointFieldWithDefault = function(a, b, c) {
    a = $01a60eaba94db1c4$var$eb(a, b);
    return null == a ? c : a;
};
$01a60eaba94db1c4$var$N.getFieldProto3 = $01a60eaba94db1c4$var$jb;
$01a60eaba94db1c4$var$N.getMapField = function(a, b, c, d) {
    a.f || (a.f = {});
    if (b in a.f) return a.f[b];
    var f = $01a60eaba94db1c4$var$O(a, b);
    if (!f) {
        if (c) return;
        f = [];
        $01a60eaba94db1c4$var$P(a, b, f);
    }
    return a.f[b] = new $01a60eaba94db1c4$var$r(f, d);
};
function $01a60eaba94db1c4$var$P(a, b, c) {
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N);
    b < a.G ? a.u[b + a.D] = c : ($01a60eaba94db1c4$var$bb(a), a.i[b] = c);
    return a;
}
$01a60eaba94db1c4$var$N.setField = $01a60eaba94db1c4$var$P;
$01a60eaba94db1c4$var$N.setProto3IntField = function(a, b, c) {
    return $01a60eaba94db1c4$var$Q(a, b, c, 0);
};
$01a60eaba94db1c4$var$N.setProto3FloatField = function(a, b, c) {
    return $01a60eaba94db1c4$var$Q(a, b, c, 0);
};
$01a60eaba94db1c4$var$N.setProto3BooleanField = function(a, b, c) {
    return $01a60eaba94db1c4$var$Q(a, b, c, !1);
};
$01a60eaba94db1c4$var$N.setProto3StringField = function(a, b, c) {
    return $01a60eaba94db1c4$var$Q(a, b, c, "");
};
$01a60eaba94db1c4$var$N.setProto3BytesField = function(a, b, c) {
    return $01a60eaba94db1c4$var$Q(a, b, c, "");
};
$01a60eaba94db1c4$var$N.setProto3EnumField = function(a, b, c) {
    return $01a60eaba94db1c4$var$Q(a, b, c, 0);
};
$01a60eaba94db1c4$var$N.setProto3StringIntField = function(a, b, c) {
    return $01a60eaba94db1c4$var$Q(a, b, c, "0");
};
function $01a60eaba94db1c4$var$Q(a, b, c, d) {
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N);
    c !== d ? $01a60eaba94db1c4$var$P(a, b, c) : b < a.G ? a.u[b + a.D] = null : ($01a60eaba94db1c4$var$bb(a), delete a.i[b]);
    return a;
}
$01a60eaba94db1c4$var$N.addToRepeatedField = function(a, b, c, d) {
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N);
    b = $01a60eaba94db1c4$var$O(a, b);
    void 0 != d ? b.splice(d, 0, c) : b.push(c);
    return a;
};
function $01a60eaba94db1c4$var$kb(a, b, c, d) {
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N);
    (c = $01a60eaba94db1c4$var$cb(a, c)) && c !== b && void 0 !== d && (a.f && c in a.f && (a.f[c] = void 0), $01a60eaba94db1c4$var$P(a, c, void 0));
    return $01a60eaba94db1c4$var$P(a, b, d);
}
$01a60eaba94db1c4$var$N.setOneofField = $01a60eaba94db1c4$var$kb;
function $01a60eaba94db1c4$var$cb(a, b) {
    for(var c, d, f = 0; f < b.length; f++){
        var h = b[f], m = $01a60eaba94db1c4$var$O(a, h);
        null != m && (c = h, d = m, $01a60eaba94db1c4$var$P(a, h, void 0));
    }
    return c ? ($01a60eaba94db1c4$var$P(a, c, d), c) : 0;
}
$01a60eaba94db1c4$var$N.computeOneofCase = $01a60eaba94db1c4$var$cb;
$01a60eaba94db1c4$var$N.getWrapperField = function(a, b, c, d) {
    a.f || (a.f = {});
    if (!a.f[c]) {
        var f = $01a60eaba94db1c4$var$O(a, c);
        if (d || f) a.f[c] = new b(f);
    }
    return a.f[c];
};
$01a60eaba94db1c4$var$N.getRepeatedWrapperField = function(a, b, c) {
    $01a60eaba94db1c4$var$lb(a, b, c);
    b = a.f[c];
    b == $01a60eaba94db1c4$var$ab && (b = a.f[c] = []);
    return b;
};
function $01a60eaba94db1c4$var$lb(a, b, c) {
    a.f || (a.f = {});
    if (!a.f[c]) {
        for(var d = $01a60eaba94db1c4$var$O(a, c), f = [], h = 0; h < d.length; h++)f[h] = new b(d[h]);
        a.f[c] = f;
    }
}
$01a60eaba94db1c4$var$N.setWrapperField = function(a, b, c) {
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N);
    a.f || (a.f = {});
    var d = c ? c.g() : c;
    a.f[b] = c;
    return $01a60eaba94db1c4$var$P(a, b, d);
};
$01a60eaba94db1c4$var$N.setOneofWrapperField = function(a, b, c, d) {
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N);
    a.f || (a.f = {});
    var f = d ? d.g() : d;
    a.f[b] = d;
    return $01a60eaba94db1c4$var$kb(a, b, c, f);
};
$01a60eaba94db1c4$var$N.setRepeatedWrapperField = function(a, b, c) {
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N);
    a.f || (a.f = {});
    c = c || [];
    for(var d = [], f = 0; f < c.length; f++)d[f] = c[f].g();
    a.f[b] = c;
    return $01a60eaba94db1c4$var$P(a, b, d);
};
$01a60eaba94db1c4$var$N.addToRepeatedWrapperField = function(a, b, c, d, f) {
    $01a60eaba94db1c4$var$lb(a, d, b);
    var h = a.f[b];
    h || (h = a.f[b] = []);
    c = c ? c : new d;
    a = $01a60eaba94db1c4$var$O(a, b);
    void 0 != f ? (h.splice(f, 0, c), a.splice(f, 0, c.g())) : (h.push(c), a.push(c.g()));
    return c;
};
$01a60eaba94db1c4$var$N.toMap = function(a, b, c, d) {
    for(var f = {}, h = 0; h < a.length; h++)f[b.call(a[h])] = c ? c.call(a[h], d, a[h]) : a[h];
    return f;
};
function $01a60eaba94db1c4$var$mb(a) {
    if (a.f) for(var b in a.f){
        var c = a.f[b];
        if (Array.isArray(c)) for(var d = 0; d < c.length; d++)c[d] && c[d].g();
        else c && c.g();
    }
}
$01a60eaba94db1c4$var$N.prototype.g = function() {
    $01a60eaba94db1c4$var$mb(this);
    return this.u;
};
$01a60eaba94db1c4$var$N.prototype.toArray = $01a60eaba94db1c4$var$N.prototype.g;
$01a60eaba94db1c4$var$N.prototype.toString = function() {
    $01a60eaba94db1c4$var$mb(this);
    return this.u.toString();
};
$01a60eaba94db1c4$var$N.prototype.getExtension = function(a) {
    if (this.i) {
        this.f || (this.f = {});
        var b = a.ma;
        if (a.na) {
            if (a.F()) return this.f[b] || (this.f[b] = $01a60eaba94db1c4$var$l(this.i[b] || [], function(c) {
                return new a.la(c);
            })), this.f[b];
        } else if (a.F()) return !this.f[b] && this.i[b] && (this.f[b] = new a.la(this.i[b])), this.f[b];
        return this.i[b];
    }
};
$01a60eaba94db1c4$var$N.prototype.getExtension = $01a60eaba94db1c4$var$N.prototype.getExtension;
$01a60eaba94db1c4$var$N.prototype.Kc = function(a, b) {
    this.f || (this.f = {});
    $01a60eaba94db1c4$var$bb(this);
    var c = a.ma;
    a.na ? (b = b || [], a.F() ? (this.f[c] = b, this.i[c] = $01a60eaba94db1c4$var$l(b, function(d) {
        return d.g();
    })) : this.i[c] = b) : a.F() ? (this.f[c] = b, this.i[c] = b ? b.g() : b) : this.i[c] = b;
    return this;
};
$01a60eaba94db1c4$var$N.prototype.setExtension = $01a60eaba94db1c4$var$N.prototype.Kc;
$01a60eaba94db1c4$var$N.difference = function(a, b) {
    if (!(a instanceof b.constructor)) throw Error("Messages have different types.");
    var c = a.g();
    b = b.g();
    var d = [], f = 0, h = c.length > b.length ? c.length : b.length;
    a.b && (d[0] = a.b, f = 1);
    for(; f < h; f++)$01a60eaba94db1c4$var$nb(c[f], b[f]) || (d[f] = b[f]);
    return new a.constructor(d);
};
$01a60eaba94db1c4$var$N.equals = function(a, b) {
    return a == b || !(!a || !b) && a instanceof b.constructor && $01a60eaba94db1c4$var$nb(a.g(), b.g());
};
function $01a60eaba94db1c4$var$ob(a, b) {
    a = a || {};
    b = b || {};
    var c = {}, d;
    for(d in a)c[d] = 0;
    for(d in b)c[d] = 0;
    for(d in c)if (!$01a60eaba94db1c4$var$nb(a[d], b[d])) return !1;
    return !0;
}
$01a60eaba94db1c4$var$N.compareExtensions = $01a60eaba94db1c4$var$ob;
function $01a60eaba94db1c4$var$nb(a, b) {
    if (a == b) return !0;
    if (!$01a60eaba94db1c4$var$la(a) || !$01a60eaba94db1c4$var$la(b)) return "number" === typeof a && isNaN(a) || "number" === typeof b && isNaN(b) ? String(a) == String(b) : !1;
    if (a.constructor != b.constructor) return !1;
    if ($01a60eaba94db1c4$var$$a && a.constructor === Uint8Array) {
        if (a.length != b.length) return !1;
        for(var c = 0; c < a.length; c++)if (a[c] != b[c]) return !1;
        return !0;
    }
    if (a.constructor === Array) {
        var d = void 0, f = void 0, h = Math.max(a.length, b.length);
        for(c = 0; c < h; c++){
            var m = a[c], t = b[c];
            m && m.constructor == Object && ($01a60eaba94db1c4$var$n(void 0 === d), $01a60eaba94db1c4$var$n(c === a.length - 1), d = m, m = void 0);
            t && t.constructor == Object && ($01a60eaba94db1c4$var$n(void 0 === f), $01a60eaba94db1c4$var$n(c === b.length - 1), f = t, t = void 0);
            if (!$01a60eaba94db1c4$var$nb(m, t)) return !1;
        }
        return d || f ? (d = d || {}, f = f || {}, $01a60eaba94db1c4$var$ob(d, f)) : !0;
    }
    if (a.constructor === Object) return $01a60eaba94db1c4$var$ob(a, b);
    throw Error("Invalid type in JSPB array");
}
$01a60eaba94db1c4$var$N.compareFields = $01a60eaba94db1c4$var$nb;
$01a60eaba94db1c4$var$N.prototype.Bb = function() {
    return $01a60eaba94db1c4$var$pb(this);
};
$01a60eaba94db1c4$var$N.prototype.cloneMessage = $01a60eaba94db1c4$var$N.prototype.Bb;
$01a60eaba94db1c4$var$N.prototype.clone = function() {
    return $01a60eaba94db1c4$var$pb(this);
};
$01a60eaba94db1c4$var$N.prototype.clone = $01a60eaba94db1c4$var$N.prototype.clone;
$01a60eaba94db1c4$var$N.clone = function(a) {
    return $01a60eaba94db1c4$var$pb(a);
};
function $01a60eaba94db1c4$var$pb(a) {
    return new a.constructor($01a60eaba94db1c4$var$qb(a.g()));
}
$01a60eaba94db1c4$var$N.copyInto = function(a, b) {
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N);
    $01a60eaba94db1c4$var$q(b, $01a60eaba94db1c4$var$N);
    $01a60eaba94db1c4$var$n(a.constructor == b.constructor, "Copy source and target message should have the same type.");
    a = $01a60eaba94db1c4$var$pb(a);
    for(var c = b.g(), d = a.g(), f = c.length = 0; f < d.length; f++)c[f] = d[f];
    b.f = a.f;
    b.i = a.i;
};
function $01a60eaba94db1c4$var$qb(a) {
    if (Array.isArray(a)) {
        for(var b = Array(a.length), c = 0; c < a.length; c++){
            var d = a[c];
            null != d && (b[c] = "object" == typeof d ? $01a60eaba94db1c4$var$qb($01a60eaba94db1c4$var$n(d)) : d);
        }
        return b;
    }
    if ($01a60eaba94db1c4$var$$a && a instanceof Uint8Array) return new Uint8Array(a);
    b = {};
    for(c in a)d = a[c], null != d && (b[c] = "object" == typeof d ? $01a60eaba94db1c4$var$qb($01a60eaba94db1c4$var$n(d)) : d);
    return b;
}
$01a60eaba94db1c4$var$N.registerMessageType = function(a, b) {
    b.we = a;
};
var $01a60eaba94db1c4$var$R = {
    dump: function(a) {
        $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N, "jspb.Message instance expected");
        $01a60eaba94db1c4$var$n(a.getExtension, "Only unobfuscated and unoptimized compilation modes supported.");
        return $01a60eaba94db1c4$var$R.X(a);
    }
};
$01a60eaba94db1c4$var$g("jspb.debug.dump", $01a60eaba94db1c4$var$R.dump, void 0);
$01a60eaba94db1c4$var$R.X = function(a) {
    var b = $01a60eaba94db1c4$var$k(a);
    if ("number" == b || "string" == b || "boolean" == b || "null" == b || "undefined" == b || "undefined" !== typeof Uint8Array && a instanceof Uint8Array) return a;
    if ("array" == b) return $01a60eaba94db1c4$var$ua(a), $01a60eaba94db1c4$var$l(a, $01a60eaba94db1c4$var$R.X);
    if (a instanceof $01a60eaba94db1c4$var$r) {
        var c = {};
        a = a.entries();
        for(var d = a.next(); !d.done; d = a.next())c[d.value[0]] = $01a60eaba94db1c4$var$R.X(d.value[1]);
        return c;
    }
    $01a60eaba94db1c4$var$q(a, $01a60eaba94db1c4$var$N, "Only messages expected: " + a);
    b = a.constructor;
    var f = {
        $name: b.name || b.displayName
    };
    for(t in b.prototype){
        var h = /^get([A-Z]\w*)/.exec(t);
        if (h && "getExtension" != t && "getJsPbMessageId" != t) {
            var m = "has" + h[1];
            if (!a[m] || a[m]()) m = a[t](), f[$01a60eaba94db1c4$var$R.$a(h[1])] = $01a60eaba94db1c4$var$R.X(m);
        }
    }
    if (a.extensionObject_) return f.$extensions = "Recursive dumping of extensions not supported in compiled code. Switch to uncompiled or dump extension object directly", f;
    for(d in b.extensions)if (/^\d+$/.test(d)) {
        m = b.extensions[d];
        var t = a.getExtension(m);
        h = void 0;
        m = m.Ba;
        var B = [], M = 0;
        for(h in m)B[M++] = h;
        h = B[0];
        null != t && (c || (c = f.$extensions = {}), c[$01a60eaba94db1c4$var$R.$a(h)] = $01a60eaba94db1c4$var$R.X(t));
    }
    return f;
};
$01a60eaba94db1c4$var$R.$a = function(a) {
    return a.replace(/^[A-Z]/, function(b) {
        return b.toLowerCase();
    });
};
function $01a60eaba94db1c4$var$S() {
    this.a = [];
}
$01a60eaba94db1c4$var$g("jspb.BinaryEncoder", $01a60eaba94db1c4$var$S, void 0);
$01a60eaba94db1c4$var$S.prototype.length = function() {
    return this.a.length;
};
$01a60eaba94db1c4$var$S.prototype.length = $01a60eaba94db1c4$var$S.prototype.length;
$01a60eaba94db1c4$var$S.prototype.end = function() {
    var a = this.a;
    this.a = [];
    return a;
};
$01a60eaba94db1c4$var$S.prototype.end = $01a60eaba94db1c4$var$S.prototype.end;
$01a60eaba94db1c4$var$S.prototype.l = function(a, b) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(b == Math.floor(b));
    $01a60eaba94db1c4$var$n(0 <= a && 4294967296 > a);
    for($01a60eaba94db1c4$var$n(0 <= b && 4294967296 > b); 0 < b || 127 < a;)this.a.push(a & 127 | 128), a = (a >>> 7 | b << 25) >>> 0, b >>>= 7;
    this.a.push(a);
};
$01a60eaba94db1c4$var$S.prototype.writeSplitVarint64 = $01a60eaba94db1c4$var$S.prototype.l;
$01a60eaba94db1c4$var$S.prototype.A = function(a, b) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(b == Math.floor(b));
    $01a60eaba94db1c4$var$n(0 <= a && 4294967296 > a);
    $01a60eaba94db1c4$var$n(0 <= b && 4294967296 > b);
    this.s(a);
    this.s(b);
};
$01a60eaba94db1c4$var$S.prototype.writeSplitFixed64 = $01a60eaba94db1c4$var$S.prototype.A;
$01a60eaba94db1c4$var$S.prototype.j = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    for($01a60eaba94db1c4$var$n(0 <= a && 4294967296 > a); 127 < a;)this.a.push(a & 127 | 128), a >>>= 7;
    this.a.push(a);
};
$01a60eaba94db1c4$var$S.prototype.writeUnsignedVarint32 = $01a60eaba94db1c4$var$S.prototype.j;
$01a60eaba94db1c4$var$S.prototype.M = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-2147483648 <= a && 2147483648 > a);
    if (0 <= a) this.j(a);
    else {
        for(var b = 0; 9 > b; b++)this.a.push(a & 127 | 128), a >>= 7;
        this.a.push(1);
    }
};
$01a60eaba94db1c4$var$S.prototype.writeSignedVarint32 = $01a60eaba94db1c4$var$S.prototype.M;
$01a60eaba94db1c4$var$S.prototype.va = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(0 <= a && 1.8446744073709552E19 > a);
    $01a60eaba94db1c4$var$A(a);
    this.l($01a60eaba94db1c4$var$y, $01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeUnsignedVarint64 = $01a60eaba94db1c4$var$S.prototype.va;
$01a60eaba94db1c4$var$S.prototype.ua = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-9223372036854776000 <= a && 0x7fffffffffffffff > a);
    $01a60eaba94db1c4$var$A(a);
    this.l($01a60eaba94db1c4$var$y, $01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeSignedVarint64 = $01a60eaba94db1c4$var$S.prototype.ua;
$01a60eaba94db1c4$var$S.prototype.wa = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-2147483648 <= a && 2147483648 > a);
    this.j((a << 1 ^ a >> 31) >>> 0);
};
$01a60eaba94db1c4$var$S.prototype.writeZigzagVarint32 = $01a60eaba94db1c4$var$S.prototype.wa;
$01a60eaba94db1c4$var$S.prototype.xa = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-9223372036854776000 <= a && 0x7fffffffffffffff > a);
    $01a60eaba94db1c4$var$Ga(a);
    this.l($01a60eaba94db1c4$var$y, $01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeZigzagVarint64 = $01a60eaba94db1c4$var$S.prototype.xa;
$01a60eaba94db1c4$var$S.prototype.Ta = function(a) {
    this.W($01a60eaba94db1c4$var$H(a));
};
$01a60eaba94db1c4$var$S.prototype.writeZigzagVarint64String = $01a60eaba94db1c4$var$S.prototype.Ta;
$01a60eaba94db1c4$var$S.prototype.W = function(a) {
    var b = this;
    $01a60eaba94db1c4$var$C(a);
    $01a60eaba94db1c4$var$Ja($01a60eaba94db1c4$var$y, $01a60eaba94db1c4$var$z, function(c, d) {
        b.l(c >>> 0, d >>> 0);
    });
};
$01a60eaba94db1c4$var$S.prototype.writeZigzagVarintHash64 = $01a60eaba94db1c4$var$S.prototype.W;
$01a60eaba94db1c4$var$S.prototype.be = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(0 <= a && 256 > a);
    this.a.push(a >>> 0 & 255);
};
$01a60eaba94db1c4$var$S.prototype.writeUint8 = $01a60eaba94db1c4$var$S.prototype.be;
$01a60eaba94db1c4$var$S.prototype.ae = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(0 <= a && 65536 > a);
    this.a.push(a >>> 0 & 255);
    this.a.push(a >>> 8 & 255);
};
$01a60eaba94db1c4$var$S.prototype.writeUint16 = $01a60eaba94db1c4$var$S.prototype.ae;
$01a60eaba94db1c4$var$S.prototype.s = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(0 <= a && 4294967296 > a);
    this.a.push(a >>> 0 & 255);
    this.a.push(a >>> 8 & 255);
    this.a.push(a >>> 16 & 255);
    this.a.push(a >>> 24 & 255);
};
$01a60eaba94db1c4$var$S.prototype.writeUint32 = $01a60eaba94db1c4$var$S.prototype.s;
$01a60eaba94db1c4$var$S.prototype.V = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(0 <= a && 1.8446744073709552E19 > a);
    $01a60eaba94db1c4$var$Fa(a);
    this.s($01a60eaba94db1c4$var$y);
    this.s($01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeUint64 = $01a60eaba94db1c4$var$S.prototype.V;
$01a60eaba94db1c4$var$S.prototype.Qc = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-128 <= a && 128 > a);
    this.a.push(a >>> 0 & 255);
};
$01a60eaba94db1c4$var$S.prototype.writeInt8 = $01a60eaba94db1c4$var$S.prototype.Qc;
$01a60eaba94db1c4$var$S.prototype.Pc = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-32768 <= a && 32768 > a);
    this.a.push(a >>> 0 & 255);
    this.a.push(a >>> 8 & 255);
};
$01a60eaba94db1c4$var$S.prototype.writeInt16 = $01a60eaba94db1c4$var$S.prototype.Pc;
$01a60eaba94db1c4$var$S.prototype.S = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-2147483648 <= a && 2147483648 > a);
    this.a.push(a >>> 0 & 255);
    this.a.push(a >>> 8 & 255);
    this.a.push(a >>> 16 & 255);
    this.a.push(a >>> 24 & 255);
};
$01a60eaba94db1c4$var$S.prototype.writeInt32 = $01a60eaba94db1c4$var$S.prototype.S;
$01a60eaba94db1c4$var$S.prototype.T = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-9223372036854776000 <= a && 0x7fffffffffffffff > a);
    $01a60eaba94db1c4$var$A(a);
    this.A($01a60eaba94db1c4$var$y, $01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeInt64 = $01a60eaba94db1c4$var$S.prototype.T;
$01a60eaba94db1c4$var$S.prototype.ka = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-9223372036854776000 <= +a && 0x7fffffffffffffff > +a);
    $01a60eaba94db1c4$var$C($01a60eaba94db1c4$var$H(a));
    this.A($01a60eaba94db1c4$var$y, $01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeInt64String = $01a60eaba94db1c4$var$S.prototype.ka;
$01a60eaba94db1c4$var$S.prototype.L = function(a) {
    $01a60eaba94db1c4$var$n(Infinity === a || -Infinity === a || isNaN(a) || -340282346638528860000000000000000000000 <= a && 3.4028234663852886E38 >= a);
    $01a60eaba94db1c4$var$Ha(a);
    this.s($01a60eaba94db1c4$var$y);
};
$01a60eaba94db1c4$var$S.prototype.writeFloat = $01a60eaba94db1c4$var$S.prototype.L;
$01a60eaba94db1c4$var$S.prototype.J = function(a) {
    $01a60eaba94db1c4$var$n(Infinity === a || -Infinity === a || isNaN(a) || -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000 <= a && 1.7976931348623157E308 >= a);
    $01a60eaba94db1c4$var$Ia(a);
    this.s($01a60eaba94db1c4$var$y);
    this.s($01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeDouble = $01a60eaba94db1c4$var$S.prototype.J;
$01a60eaba94db1c4$var$S.prototype.I = function(a) {
    $01a60eaba94db1c4$var$n("boolean" === typeof a || "number" === typeof a);
    this.a.push(a ? 1 : 0);
};
$01a60eaba94db1c4$var$S.prototype.writeBool = $01a60eaba94db1c4$var$S.prototype.I;
$01a60eaba94db1c4$var$S.prototype.R = function(a) {
    $01a60eaba94db1c4$var$n(a == Math.floor(a));
    $01a60eaba94db1c4$var$n(-2147483648 <= a && 2147483648 > a);
    this.M(a);
};
$01a60eaba94db1c4$var$S.prototype.writeEnum = $01a60eaba94db1c4$var$S.prototype.R;
$01a60eaba94db1c4$var$S.prototype.ja = function(a) {
    this.a.push.apply(this.a, a);
};
$01a60eaba94db1c4$var$S.prototype.writeBytes = $01a60eaba94db1c4$var$S.prototype.ja;
$01a60eaba94db1c4$var$S.prototype.N = function(a) {
    $01a60eaba94db1c4$var$C(a);
    this.l($01a60eaba94db1c4$var$y, $01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeVarintHash64 = $01a60eaba94db1c4$var$S.prototype.N;
$01a60eaba94db1c4$var$S.prototype.K = function(a) {
    $01a60eaba94db1c4$var$C(a);
    this.s($01a60eaba94db1c4$var$y);
    this.s($01a60eaba94db1c4$var$z);
};
$01a60eaba94db1c4$var$S.prototype.writeFixedHash64 = $01a60eaba94db1c4$var$S.prototype.K;
$01a60eaba94db1c4$var$S.prototype.U = function(a) {
    var b = this.a.length;
    $01a60eaba94db1c4$var$ta(a);
    for(var c = 0; c < a.length; c++){
        var d = a.charCodeAt(c);
        if (128 > d) this.a.push(d);
        else if (2048 > d) this.a.push(d >> 6 | 192), this.a.push(d & 63 | 128);
        else if (65536 > d) {
            if (55296 <= d && 56319 >= d && c + 1 < a.length) {
                var f = a.charCodeAt(c + 1);
                56320 <= f && 57343 >= f && (d = 1024 * (d - 55296) + f - 56320 + 65536, this.a.push(d >> 18 | 240), this.a.push(d >> 12 & 63 | 128), this.a.push(d >> 6 & 63 | 128), this.a.push(d & 63 | 128), c++);
            } else this.a.push(d >> 12 | 224), this.a.push(d >> 6 & 63 | 128), this.a.push(d & 63 | 128);
        }
    }
    return this.a.length - b;
};
$01a60eaba94db1c4$var$S.prototype.writeString = $01a60eaba94db1c4$var$S.prototype.U;
function $01a60eaba94db1c4$var$T(a, b) {
    this.lo = a;
    this.hi = b;
}
$01a60eaba94db1c4$var$g("jspb.arith.UInt64", $01a60eaba94db1c4$var$T, void 0);
$01a60eaba94db1c4$var$T.prototype.cmp = function(a) {
    return this.hi < a.hi || this.hi == a.hi && this.lo < a.lo ? -1 : this.hi == a.hi && this.lo == a.lo ? 0 : 1;
};
$01a60eaba94db1c4$var$T.prototype.cmp = $01a60eaba94db1c4$var$T.prototype.cmp;
$01a60eaba94db1c4$var$T.prototype.La = function() {
    return new $01a60eaba94db1c4$var$T((this.lo >>> 1 | (this.hi & 1) << 31) >>> 0, this.hi >>> 1 >>> 0);
};
$01a60eaba94db1c4$var$T.prototype.rightShift = $01a60eaba94db1c4$var$T.prototype.La;
$01a60eaba94db1c4$var$T.prototype.Da = function() {
    return new $01a60eaba94db1c4$var$T(this.lo << 1 >>> 0, (this.hi << 1 | this.lo >>> 31) >>> 0);
};
$01a60eaba94db1c4$var$T.prototype.leftShift = $01a60eaba94db1c4$var$T.prototype.Da;
$01a60eaba94db1c4$var$T.prototype.cb = function() {
    return !!(this.hi & 2147483648);
};
$01a60eaba94db1c4$var$T.prototype.msb = $01a60eaba94db1c4$var$T.prototype.cb;
$01a60eaba94db1c4$var$T.prototype.Ob = function() {
    return !!(this.lo & 1);
};
$01a60eaba94db1c4$var$T.prototype.lsb = $01a60eaba94db1c4$var$T.prototype.Ob;
$01a60eaba94db1c4$var$T.prototype.Ua = function() {
    return 0 == this.lo && 0 == this.hi;
};
$01a60eaba94db1c4$var$T.prototype.zero = $01a60eaba94db1c4$var$T.prototype.Ua;
$01a60eaba94db1c4$var$T.prototype.add = function(a) {
    return new $01a60eaba94db1c4$var$T((this.lo + a.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a.lo ? 1 : 0) >>> 0);
};
$01a60eaba94db1c4$var$T.prototype.add = $01a60eaba94db1c4$var$T.prototype.add;
$01a60eaba94db1c4$var$T.prototype.sub = function(a) {
    return new $01a60eaba94db1c4$var$T((this.lo - a.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a.hi & 4294967295) >>> 0) - (0 > this.lo - a.lo ? 1 : 0) >>> 0);
};
$01a60eaba94db1c4$var$T.prototype.sub = $01a60eaba94db1c4$var$T.prototype.sub;
function $01a60eaba94db1c4$var$rb(a, b) {
    var c = a & 65535;
    a >>>= 16;
    var d = b & 65535, f = b >>> 16;
    b = c * d + 65536 * (c * f & 65535) + 65536 * (a * d & 65535);
    for(c = a * f + (c * f >>> 16) + (a * d >>> 16); 4294967296 <= b;)b -= 4294967296, c += 1;
    return new $01a60eaba94db1c4$var$T(b >>> 0, c >>> 0);
}
$01a60eaba94db1c4$var$T.mul32x32 = $01a60eaba94db1c4$var$rb;
$01a60eaba94db1c4$var$T.prototype.eb = function(a) {
    var b = $01a60eaba94db1c4$var$rb(this.lo, a);
    a = $01a60eaba94db1c4$var$rb(this.hi, a);
    a.hi = a.lo;
    a.lo = 0;
    return b.add(a);
};
$01a60eaba94db1c4$var$T.prototype.mul = $01a60eaba94db1c4$var$T.prototype.eb;
$01a60eaba94db1c4$var$T.prototype.Xa = function(a) {
    if (0 == a) return [];
    var b = new $01a60eaba94db1c4$var$T(0, 0), c = new $01a60eaba94db1c4$var$T(this.lo, this.hi);
    a = new $01a60eaba94db1c4$var$T(a, 0);
    for(var d = new $01a60eaba94db1c4$var$T(1, 0); !a.cb();)a = a.Da(), d = d.Da();
    for(; !d.Ua();)0 >= a.cmp(c) && (b = b.add(d), c = c.sub(a)), a = a.La(), d = d.La();
    return [
        b,
        c
    ];
};
$01a60eaba94db1c4$var$T.prototype.div = $01a60eaba94db1c4$var$T.prototype.Xa;
$01a60eaba94db1c4$var$T.prototype.toString = function() {
    for(var a = "", b = this; !b.Ua();){
        b = b.Xa(10);
        var c = b[0];
        a = b[1].lo + a;
        b = c;
    }
    "" == a && (a = "0");
    return a;
};
$01a60eaba94db1c4$var$T.prototype.toString = $01a60eaba94db1c4$var$T.prototype.toString;
function $01a60eaba94db1c4$var$U(a) {
    for(var b = new $01a60eaba94db1c4$var$T(0, 0), c = new $01a60eaba94db1c4$var$T(0, 0), d = 0; d < a.length; d++){
        if ("0" > a[d] || "9" < a[d]) return null;
        c.lo = parseInt(a[d], 10);
        b = b.eb(10).add(c);
    }
    return b;
}
$01a60eaba94db1c4$var$T.fromString = $01a60eaba94db1c4$var$U;
$01a60eaba94db1c4$var$T.prototype.clone = function() {
    return new $01a60eaba94db1c4$var$T(this.lo, this.hi);
};
$01a60eaba94db1c4$var$T.prototype.clone = $01a60eaba94db1c4$var$T.prototype.clone;
function $01a60eaba94db1c4$var$V(a, b) {
    this.lo = a;
    this.hi = b;
}
$01a60eaba94db1c4$var$g("jspb.arith.Int64", $01a60eaba94db1c4$var$V, void 0);
$01a60eaba94db1c4$var$V.prototype.add = function(a) {
    return new $01a60eaba94db1c4$var$V((this.lo + a.lo & 4294967295) >>> 0 >>> 0, ((this.hi + a.hi & 4294967295) >>> 0) + (4294967296 <= this.lo + a.lo ? 1 : 0) >>> 0);
};
$01a60eaba94db1c4$var$V.prototype.add = $01a60eaba94db1c4$var$V.prototype.add;
$01a60eaba94db1c4$var$V.prototype.sub = function(a) {
    return new $01a60eaba94db1c4$var$V((this.lo - a.lo & 4294967295) >>> 0 >>> 0, ((this.hi - a.hi & 4294967295) >>> 0) - (0 > this.lo - a.lo ? 1 : 0) >>> 0);
};
$01a60eaba94db1c4$var$V.prototype.sub = $01a60eaba94db1c4$var$V.prototype.sub;
$01a60eaba94db1c4$var$V.prototype.clone = function() {
    return new $01a60eaba94db1c4$var$V(this.lo, this.hi);
};
$01a60eaba94db1c4$var$V.prototype.clone = $01a60eaba94db1c4$var$V.prototype.clone;
$01a60eaba94db1c4$var$V.prototype.toString = function() {
    var a = 0 != (this.hi & 2147483648), b = new $01a60eaba94db1c4$var$T(this.lo, this.hi);
    a && (b = new $01a60eaba94db1c4$var$T(0, 0).sub(b));
    return (a ? "-" : "") + b.toString();
};
$01a60eaba94db1c4$var$V.prototype.toString = $01a60eaba94db1c4$var$V.prototype.toString;
function $01a60eaba94db1c4$var$sb(a) {
    var b = 0 < a.length && "-" == a[0];
    b && (a = a.substring(1));
    a = $01a60eaba94db1c4$var$U(a);
    if (null === a) return null;
    b && (a = new $01a60eaba94db1c4$var$T(0, 0).sub(a));
    return new $01a60eaba94db1c4$var$V(a.lo, a.hi);
}
$01a60eaba94db1c4$var$V.fromString = $01a60eaba94db1c4$var$sb;
function $01a60eaba94db1c4$var$W() {
    this.c = [];
    this.b = 0;
    this.a = new $01a60eaba94db1c4$var$S;
    this.h = [];
}
$01a60eaba94db1c4$var$g("jspb.BinaryWriter", $01a60eaba94db1c4$var$W, void 0);
function $01a60eaba94db1c4$var$tb(a, b) {
    var c = a.a.end();
    a.c.push(c);
    a.c.push(b);
    a.b += c.length + b.length;
}
function $01a60eaba94db1c4$var$X(a, b) {
    $01a60eaba94db1c4$var$Y(a, b, 2);
    b = a.a.end();
    a.c.push(b);
    a.b += b.length;
    b.push(a.b);
    return b;
}
function $01a60eaba94db1c4$var$Z(a, b) {
    var c = b.pop();
    c = a.b + a.a.length() - c;
    for($01a60eaba94db1c4$var$n(0 <= c); 127 < c;)b.push(c & 127 | 128), c >>>= 7, a.b++;
    b.push(c);
    a.b++;
}
$01a60eaba94db1c4$var$W.prototype.pb = function(a, b, c) {
    $01a60eaba94db1c4$var$tb(this, a.subarray(b, c));
};
$01a60eaba94db1c4$var$W.prototype.writeSerializedMessage = $01a60eaba94db1c4$var$W.prototype.pb;
$01a60eaba94db1c4$var$W.prototype.Pb = function(a, b, c) {
    null != a && null != b && null != c && this.pb(a, b, c);
};
$01a60eaba94db1c4$var$W.prototype.maybeWriteSerializedMessage = $01a60eaba94db1c4$var$W.prototype.Pb;
$01a60eaba94db1c4$var$W.prototype.reset = function() {
    this.c = [];
    this.a.end();
    this.b = 0;
    this.h = [];
};
$01a60eaba94db1c4$var$W.prototype.reset = $01a60eaba94db1c4$var$W.prototype.reset;
$01a60eaba94db1c4$var$W.prototype.ab = function() {
    $01a60eaba94db1c4$var$n(0 == this.h.length);
    for(var a = new Uint8Array(this.b + this.a.length()), b = this.c, c = b.length, d = 0, f = 0; f < c; f++){
        var h = b[f];
        a.set(h, d);
        d += h.length;
    }
    b = this.a.end();
    a.set(b, d);
    d += b.length;
    $01a60eaba94db1c4$var$n(d == a.length);
    this.c = [
        a
    ];
    return a;
};
$01a60eaba94db1c4$var$W.prototype.getResultBuffer = $01a60eaba94db1c4$var$W.prototype.ab;
$01a60eaba94db1c4$var$W.prototype.Kb = function(a) {
    return $01a60eaba94db1c4$var$Ba(this.ab(), a);
};
$01a60eaba94db1c4$var$W.prototype.getResultBase64String = $01a60eaba94db1c4$var$W.prototype.Kb;
$01a60eaba94db1c4$var$W.prototype.Va = function(a) {
    this.h.push($01a60eaba94db1c4$var$X(this, a));
};
$01a60eaba94db1c4$var$W.prototype.beginSubMessage = $01a60eaba94db1c4$var$W.prototype.Va;
$01a60eaba94db1c4$var$W.prototype.Ya = function() {
    $01a60eaba94db1c4$var$n(0 <= this.h.length);
    $01a60eaba94db1c4$var$Z(this, this.h.pop());
};
$01a60eaba94db1c4$var$W.prototype.endSubMessage = $01a60eaba94db1c4$var$W.prototype.Ya;
function $01a60eaba94db1c4$var$Y(a, b, c) {
    $01a60eaba94db1c4$var$n(1 <= b && b == Math.floor(b));
    a.a.j(8 * b + c);
}
$01a60eaba94db1c4$var$W.prototype.Nc = function(a, b, c) {
    switch(a){
        case 1:
            this.J(b, c);
            break;
        case 2:
            this.L(b, c);
            break;
        case 3:
            this.T(b, c);
            break;
        case 4:
            this.V(b, c);
            break;
        case 5:
            this.S(b, c);
            break;
        case 6:
            this.Qa(b, c);
            break;
        case 7:
            this.Pa(b, c);
            break;
        case 8:
            this.I(b, c);
            break;
        case 9:
            this.U(b, c);
            break;
        case 10:
            $01a60eaba94db1c4$var$p("Group field type not supported in writeAny()");
            break;
        case 11:
            $01a60eaba94db1c4$var$p("Message field type not supported in writeAny()");
            break;
        case 12:
            this.ja(b, c);
            break;
        case 13:
            this.s(b, c);
            break;
        case 14:
            this.R(b, c);
            break;
        case 15:
            this.Ra(b, c);
            break;
        case 16:
            this.Sa(b, c);
            break;
        case 17:
            this.rb(b, c);
            break;
        case 18:
            this.sb(b, c);
            break;
        case 30:
            this.K(b, c);
            break;
        case 31:
            this.N(b, c);
            break;
        default:
            $01a60eaba94db1c4$var$p("Invalid field type in writeAny()");
    }
};
$01a60eaba94db1c4$var$W.prototype.writeAny = $01a60eaba94db1c4$var$W.prototype.Nc;
function $01a60eaba94db1c4$var$ub(a, b, c) {
    null != c && ($01a60eaba94db1c4$var$Y(a, b, 0), a.a.j(c));
}
function $01a60eaba94db1c4$var$vb(a, b, c) {
    null != c && ($01a60eaba94db1c4$var$Y(a, b, 0), a.a.M(c));
}
$01a60eaba94db1c4$var$W.prototype.S = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(-2147483648 <= b && 2147483648 > b), $01a60eaba94db1c4$var$vb(this, a, b));
};
$01a60eaba94db1c4$var$W.prototype.writeInt32 = $01a60eaba94db1c4$var$W.prototype.S;
$01a60eaba94db1c4$var$W.prototype.ob = function(a, b) {
    null != b && (b = parseInt(b, 10), $01a60eaba94db1c4$var$n(-2147483648 <= b && 2147483648 > b), $01a60eaba94db1c4$var$vb(this, a, b));
};
$01a60eaba94db1c4$var$W.prototype.writeInt32String = $01a60eaba94db1c4$var$W.prototype.ob;
$01a60eaba94db1c4$var$W.prototype.T = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(-9223372036854776000 <= b && 0x7fffffffffffffff > b), null != b && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.ua(b)));
};
$01a60eaba94db1c4$var$W.prototype.writeInt64 = $01a60eaba94db1c4$var$W.prototype.T;
$01a60eaba94db1c4$var$W.prototype.ka = function(a, b) {
    null != b && (b = $01a60eaba94db1c4$var$sb(b), $01a60eaba94db1c4$var$Y(this, a, 0), this.a.l(b.lo, b.hi));
};
$01a60eaba94db1c4$var$W.prototype.writeInt64String = $01a60eaba94db1c4$var$W.prototype.ka;
$01a60eaba94db1c4$var$W.prototype.s = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(0 <= b && 4294967296 > b), $01a60eaba94db1c4$var$ub(this, a, b));
};
$01a60eaba94db1c4$var$W.prototype.writeUint32 = $01a60eaba94db1c4$var$W.prototype.s;
$01a60eaba94db1c4$var$W.prototype.ub = function(a, b) {
    null != b && (b = parseInt(b, 10), $01a60eaba94db1c4$var$n(0 <= b && 4294967296 > b), $01a60eaba94db1c4$var$ub(this, a, b));
};
$01a60eaba94db1c4$var$W.prototype.writeUint32String = $01a60eaba94db1c4$var$W.prototype.ub;
$01a60eaba94db1c4$var$W.prototype.V = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(0 <= b && 1.8446744073709552E19 > b), null != b && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.va(b)));
};
$01a60eaba94db1c4$var$W.prototype.writeUint64 = $01a60eaba94db1c4$var$W.prototype.V;
$01a60eaba94db1c4$var$W.prototype.vb = function(a, b) {
    null != b && (b = $01a60eaba94db1c4$var$U(b), $01a60eaba94db1c4$var$Y(this, a, 0), this.a.l(b.lo, b.hi));
};
$01a60eaba94db1c4$var$W.prototype.writeUint64String = $01a60eaba94db1c4$var$W.prototype.vb;
$01a60eaba94db1c4$var$W.prototype.rb = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(-2147483648 <= b && 2147483648 > b), null != b && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.wa(b)));
};
$01a60eaba94db1c4$var$W.prototype.writeSint32 = $01a60eaba94db1c4$var$W.prototype.rb;
$01a60eaba94db1c4$var$W.prototype.sb = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(-9223372036854776000 <= b && 0x7fffffffffffffff > b), null != b && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.xa(b)));
};
$01a60eaba94db1c4$var$W.prototype.writeSint64 = $01a60eaba94db1c4$var$W.prototype.sb;
$01a60eaba94db1c4$var$W.prototype.$d = function(a, b) {
    null != b && null != b && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.W(b));
};
$01a60eaba94db1c4$var$W.prototype.writeSintHash64 = $01a60eaba94db1c4$var$W.prototype.$d;
$01a60eaba94db1c4$var$W.prototype.Zd = function(a, b) {
    null != b && null != b && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.Ta(b));
};
$01a60eaba94db1c4$var$W.prototype.writeSint64String = $01a60eaba94db1c4$var$W.prototype.Zd;
$01a60eaba94db1c4$var$W.prototype.Pa = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(0 <= b && 4294967296 > b), $01a60eaba94db1c4$var$Y(this, a, 5), this.a.s(b));
};
$01a60eaba94db1c4$var$W.prototype.writeFixed32 = $01a60eaba94db1c4$var$W.prototype.Pa;
$01a60eaba94db1c4$var$W.prototype.Qa = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(0 <= b && 1.8446744073709552E19 > b), $01a60eaba94db1c4$var$Y(this, a, 1), this.a.V(b));
};
$01a60eaba94db1c4$var$W.prototype.writeFixed64 = $01a60eaba94db1c4$var$W.prototype.Qa;
$01a60eaba94db1c4$var$W.prototype.nb = function(a, b) {
    null != b && (b = $01a60eaba94db1c4$var$U(b), $01a60eaba94db1c4$var$Y(this, a, 1), this.a.A(b.lo, b.hi));
};
$01a60eaba94db1c4$var$W.prototype.writeFixed64String = $01a60eaba94db1c4$var$W.prototype.nb;
$01a60eaba94db1c4$var$W.prototype.Ra = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(-2147483648 <= b && 2147483648 > b), $01a60eaba94db1c4$var$Y(this, a, 5), this.a.S(b));
};
$01a60eaba94db1c4$var$W.prototype.writeSfixed32 = $01a60eaba94db1c4$var$W.prototype.Ra;
$01a60eaba94db1c4$var$W.prototype.Sa = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(-9223372036854776000 <= b && 0x7fffffffffffffff > b), $01a60eaba94db1c4$var$Y(this, a, 1), this.a.T(b));
};
$01a60eaba94db1c4$var$W.prototype.writeSfixed64 = $01a60eaba94db1c4$var$W.prototype.Sa;
$01a60eaba94db1c4$var$W.prototype.qb = function(a, b) {
    null != b && (b = $01a60eaba94db1c4$var$sb(b), $01a60eaba94db1c4$var$Y(this, a, 1), this.a.A(b.lo, b.hi));
};
$01a60eaba94db1c4$var$W.prototype.writeSfixed64String = $01a60eaba94db1c4$var$W.prototype.qb;
$01a60eaba94db1c4$var$W.prototype.L = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$Y(this, a, 5), this.a.L(b));
};
$01a60eaba94db1c4$var$W.prototype.writeFloat = $01a60eaba94db1c4$var$W.prototype.L;
$01a60eaba94db1c4$var$W.prototype.J = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$Y(this, a, 1), this.a.J(b));
};
$01a60eaba94db1c4$var$W.prototype.writeDouble = $01a60eaba94db1c4$var$W.prototype.J;
$01a60eaba94db1c4$var$W.prototype.I = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n("boolean" === typeof b || "number" === typeof b), $01a60eaba94db1c4$var$Y(this, a, 0), this.a.I(b));
};
$01a60eaba94db1c4$var$W.prototype.writeBool = $01a60eaba94db1c4$var$W.prototype.I;
$01a60eaba94db1c4$var$W.prototype.R = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(-2147483648 <= b && 2147483648 > b), $01a60eaba94db1c4$var$Y(this, a, 0), this.a.M(b));
};
$01a60eaba94db1c4$var$W.prototype.writeEnum = $01a60eaba94db1c4$var$W.prototype.R;
$01a60eaba94db1c4$var$W.prototype.U = function(a, b) {
    null != b && (a = $01a60eaba94db1c4$var$X(this, a), this.a.U(b), $01a60eaba94db1c4$var$Z(this, a));
};
$01a60eaba94db1c4$var$W.prototype.writeString = $01a60eaba94db1c4$var$W.prototype.U;
$01a60eaba94db1c4$var$W.prototype.ja = function(a, b) {
    null != b && (b = $01a60eaba94db1c4$var$Ua(b), $01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(b.length), $01a60eaba94db1c4$var$tb(this, b));
};
$01a60eaba94db1c4$var$W.prototype.writeBytes = $01a60eaba94db1c4$var$W.prototype.ja;
$01a60eaba94db1c4$var$W.prototype.Rc = function(a, b, c) {
    null != b && (a = $01a60eaba94db1c4$var$X(this, a), c(b, this), $01a60eaba94db1c4$var$Z(this, a));
};
$01a60eaba94db1c4$var$W.prototype.writeMessage = $01a60eaba94db1c4$var$W.prototype.Rc;
$01a60eaba94db1c4$var$W.prototype.Sc = function(a, b, c) {
    null != b && ($01a60eaba94db1c4$var$Y(this, 1, 3), $01a60eaba94db1c4$var$Y(this, 2, 0), this.a.M(a), a = $01a60eaba94db1c4$var$X(this, 3), c(b, this), $01a60eaba94db1c4$var$Z(this, a), $01a60eaba94db1c4$var$Y(this, 1, 4));
};
$01a60eaba94db1c4$var$W.prototype.writeMessageSet = $01a60eaba94db1c4$var$W.prototype.Sc;
$01a60eaba94db1c4$var$W.prototype.Oc = function(a, b, c) {
    null != b && ($01a60eaba94db1c4$var$Y(this, a, 3), c(b, this), $01a60eaba94db1c4$var$Y(this, a, 4));
};
$01a60eaba94db1c4$var$W.prototype.writeGroup = $01a60eaba94db1c4$var$W.prototype.Oc;
$01a60eaba94db1c4$var$W.prototype.K = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(8 == b.length), $01a60eaba94db1c4$var$Y(this, a, 1), this.a.K(b));
};
$01a60eaba94db1c4$var$W.prototype.writeFixedHash64 = $01a60eaba94db1c4$var$W.prototype.K;
$01a60eaba94db1c4$var$W.prototype.N = function(a, b) {
    null != b && ($01a60eaba94db1c4$var$n(8 == b.length), $01a60eaba94db1c4$var$Y(this, a, 0), this.a.N(b));
};
$01a60eaba94db1c4$var$W.prototype.writeVarintHash64 = $01a60eaba94db1c4$var$W.prototype.N;
$01a60eaba94db1c4$var$W.prototype.A = function(a, b, c) {
    $01a60eaba94db1c4$var$Y(this, a, 1);
    this.a.A(b, c);
};
$01a60eaba94db1c4$var$W.prototype.writeSplitFixed64 = $01a60eaba94db1c4$var$W.prototype.A;
$01a60eaba94db1c4$var$W.prototype.l = function(a, b, c) {
    $01a60eaba94db1c4$var$Y(this, a, 0);
    this.a.l(b, c);
};
$01a60eaba94db1c4$var$W.prototype.writeSplitVarint64 = $01a60eaba94db1c4$var$W.prototype.l;
$01a60eaba94db1c4$var$W.prototype.tb = function(a, b, c) {
    $01a60eaba94db1c4$var$Y(this, a, 0);
    var d = this.a;
    $01a60eaba94db1c4$var$Ja(b, c, function(f, h) {
        d.l(f >>> 0, h >>> 0);
    });
};
$01a60eaba94db1c4$var$W.prototype.writeSplitZigzagVarint64 = $01a60eaba94db1c4$var$W.prototype.tb;
$01a60eaba94db1c4$var$W.prototype.Ed = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)$01a60eaba94db1c4$var$vb(this, a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedInt32 = $01a60eaba94db1c4$var$W.prototype.Ed;
$01a60eaba94db1c4$var$W.prototype.Fd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.ob(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedInt32String = $01a60eaba94db1c4$var$W.prototype.Fd;
$01a60eaba94db1c4$var$W.prototype.Gd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++){
        var d = b[c];
        null != d && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.ua(d));
    }
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedInt64 = $01a60eaba94db1c4$var$W.prototype.Gd;
$01a60eaba94db1c4$var$W.prototype.Qd = function(a, b, c, d) {
    if (null != b) for(var f = 0; f < b.length; f++)this.A(a, c(b[f]), d(b[f]));
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSplitFixed64 = $01a60eaba94db1c4$var$W.prototype.Qd;
$01a60eaba94db1c4$var$W.prototype.Rd = function(a, b, c, d) {
    if (null != b) for(var f = 0; f < b.length; f++)this.l(a, c(b[f]), d(b[f]));
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSplitVarint64 = $01a60eaba94db1c4$var$W.prototype.Rd;
$01a60eaba94db1c4$var$W.prototype.Sd = function(a, b, c, d) {
    if (null != b) for(var f = 0; f < b.length; f++)this.tb(a, c(b[f]), d(b[f]));
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSplitZigzagVarint64 = $01a60eaba94db1c4$var$W.prototype.Sd;
$01a60eaba94db1c4$var$W.prototype.Hd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.ka(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedInt64String = $01a60eaba94db1c4$var$W.prototype.Hd;
$01a60eaba94db1c4$var$W.prototype.Ud = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)$01a60eaba94db1c4$var$ub(this, a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedUint32 = $01a60eaba94db1c4$var$W.prototype.Ud;
$01a60eaba94db1c4$var$W.prototype.Vd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.ub(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedUint32String = $01a60eaba94db1c4$var$W.prototype.Vd;
$01a60eaba94db1c4$var$W.prototype.Wd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++){
        var d = b[c];
        null != d && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.va(d));
    }
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedUint64 = $01a60eaba94db1c4$var$W.prototype.Wd;
$01a60eaba94db1c4$var$W.prototype.Xd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.vb(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedUint64String = $01a60eaba94db1c4$var$W.prototype.Xd;
$01a60eaba94db1c4$var$W.prototype.Md = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++){
        var d = b[c];
        null != d && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.wa(d));
    }
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSint32 = $01a60eaba94db1c4$var$W.prototype.Md;
$01a60eaba94db1c4$var$W.prototype.Nd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++){
        var d = b[c];
        null != d && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.xa(d));
    }
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSint64 = $01a60eaba94db1c4$var$W.prototype.Nd;
$01a60eaba94db1c4$var$W.prototype.Od = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++){
        var d = b[c];
        null != d && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.Ta(d));
    }
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSint64String = $01a60eaba94db1c4$var$W.prototype.Od;
$01a60eaba94db1c4$var$W.prototype.Pd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++){
        var d = b[c];
        null != d && ($01a60eaba94db1c4$var$Y(this, a, 0), this.a.W(d));
    }
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSintHash64 = $01a60eaba94db1c4$var$W.prototype.Pd;
$01a60eaba94db1c4$var$W.prototype.yd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.Pa(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedFixed32 = $01a60eaba94db1c4$var$W.prototype.yd;
$01a60eaba94db1c4$var$W.prototype.zd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.Qa(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedFixed64 = $01a60eaba94db1c4$var$W.prototype.zd;
$01a60eaba94db1c4$var$W.prototype.Ad = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.nb(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedFixed64String = $01a60eaba94db1c4$var$W.prototype.Ad;
$01a60eaba94db1c4$var$W.prototype.Jd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.Ra(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSfixed32 = $01a60eaba94db1c4$var$W.prototype.Jd;
$01a60eaba94db1c4$var$W.prototype.Kd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.Sa(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSfixed64 = $01a60eaba94db1c4$var$W.prototype.Kd;
$01a60eaba94db1c4$var$W.prototype.Ld = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.qb(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedSfixed64String = $01a60eaba94db1c4$var$W.prototype.Ld;
$01a60eaba94db1c4$var$W.prototype.Cd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.L(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedFloat = $01a60eaba94db1c4$var$W.prototype.Cd;
$01a60eaba94db1c4$var$W.prototype.wd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.J(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedDouble = $01a60eaba94db1c4$var$W.prototype.wd;
$01a60eaba94db1c4$var$W.prototype.ud = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.I(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedBool = $01a60eaba94db1c4$var$W.prototype.ud;
$01a60eaba94db1c4$var$W.prototype.xd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.R(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedEnum = $01a60eaba94db1c4$var$W.prototype.xd;
$01a60eaba94db1c4$var$W.prototype.Td = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.U(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedString = $01a60eaba94db1c4$var$W.prototype.Td;
$01a60eaba94db1c4$var$W.prototype.vd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.ja(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedBytes = $01a60eaba94db1c4$var$W.prototype.vd;
$01a60eaba94db1c4$var$W.prototype.Id = function(a, b, c) {
    if (null != b) for(var d = 0; d < b.length; d++){
        var f = $01a60eaba94db1c4$var$X(this, a);
        c(b[d], this);
        $01a60eaba94db1c4$var$Z(this, f);
    }
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedMessage = $01a60eaba94db1c4$var$W.prototype.Id;
$01a60eaba94db1c4$var$W.prototype.Dd = function(a, b, c) {
    if (null != b) for(var d = 0; d < b.length; d++)$01a60eaba94db1c4$var$Y(this, a, 3), c(b[d], this), $01a60eaba94db1c4$var$Y(this, a, 4);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedGroup = $01a60eaba94db1c4$var$W.prototype.Dd;
$01a60eaba94db1c4$var$W.prototype.Bd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.K(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedFixedHash64 = $01a60eaba94db1c4$var$W.prototype.Bd;
$01a60eaba94db1c4$var$W.prototype.Yd = function(a, b) {
    if (null != b) for(var c = 0; c < b.length; c++)this.N(a, b[c]);
};
$01a60eaba94db1c4$var$W.prototype.writeRepeatedVarintHash64 = $01a60eaba94db1c4$var$W.prototype.Yd;
$01a60eaba94db1c4$var$W.prototype.ad = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.M(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedInt32 = $01a60eaba94db1c4$var$W.prototype.ad;
$01a60eaba94db1c4$var$W.prototype.bd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.M(parseInt(b[c], 10));
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedInt32String = $01a60eaba94db1c4$var$W.prototype.bd;
$01a60eaba94db1c4$var$W.prototype.cd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.ua(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedInt64 = $01a60eaba94db1c4$var$W.prototype.cd;
$01a60eaba94db1c4$var$W.prototype.md = function(a, b, c, d) {
    if (null != b) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var f = 0; f < b.length; f++)this.a.A(c(b[f]), d(b[f]));
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedSplitFixed64 = $01a60eaba94db1c4$var$W.prototype.md;
$01a60eaba94db1c4$var$W.prototype.nd = function(a, b, c, d) {
    if (null != b) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var f = 0; f < b.length; f++)this.a.l(c(b[f]), d(b[f]));
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedSplitVarint64 = $01a60eaba94db1c4$var$W.prototype.nd;
$01a60eaba94db1c4$var$W.prototype.od = function(a, b, c, d) {
    if (null != b) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var f = this.a, h = 0; h < b.length; h++)$01a60eaba94db1c4$var$Ja(c(b[h]), d(b[h]), function(m, t) {
            f.l(m >>> 0, t >>> 0);
        });
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedSplitZigzagVarint64 = $01a60eaba94db1c4$var$W.prototype.od;
$01a60eaba94db1c4$var$W.prototype.dd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++){
            var d = $01a60eaba94db1c4$var$sb(b[c]);
            this.a.l(d.lo, d.hi);
        }
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedInt64String = $01a60eaba94db1c4$var$W.prototype.dd;
$01a60eaba94db1c4$var$W.prototype.pd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.j(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedUint32 = $01a60eaba94db1c4$var$W.prototype.pd;
$01a60eaba94db1c4$var$W.prototype.qd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.j(parseInt(b[c], 10));
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedUint32String = $01a60eaba94db1c4$var$W.prototype.qd;
$01a60eaba94db1c4$var$W.prototype.rd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.va(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedUint64 = $01a60eaba94db1c4$var$W.prototype.rd;
$01a60eaba94db1c4$var$W.prototype.sd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++){
            var d = $01a60eaba94db1c4$var$U(b[c]);
            this.a.l(d.lo, d.hi);
        }
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedUint64String = $01a60eaba94db1c4$var$W.prototype.sd;
$01a60eaba94db1c4$var$W.prototype.hd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.wa(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedSint32 = $01a60eaba94db1c4$var$W.prototype.hd;
$01a60eaba94db1c4$var$W.prototype.jd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.xa(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedSint64 = $01a60eaba94db1c4$var$W.prototype.jd;
$01a60eaba94db1c4$var$W.prototype.kd = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.W($01a60eaba94db1c4$var$H(b[c]));
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedSint64String = $01a60eaba94db1c4$var$W.prototype.kd;
$01a60eaba94db1c4$var$W.prototype.ld = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.W(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedSintHash64 = $01a60eaba94db1c4$var$W.prototype.ld;
$01a60eaba94db1c4$var$W.prototype.Wc = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(4 * b.length), a = 0; a < b.length; a++)this.a.s(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedFixed32 = $01a60eaba94db1c4$var$W.prototype.Wc;
$01a60eaba94db1c4$var$W.prototype.Xc = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(8 * b.length), a = 0; a < b.length; a++)this.a.V(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedFixed64 = $01a60eaba94db1c4$var$W.prototype.Xc;
$01a60eaba94db1c4$var$W.prototype.Yc = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(8 * b.length), a = 0; a < b.length; a++){
        var c = $01a60eaba94db1c4$var$U(b[a]);
        this.a.A(c.lo, c.hi);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedFixed64String = $01a60eaba94db1c4$var$W.prototype.Yc;
$01a60eaba94db1c4$var$W.prototype.ed = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(4 * b.length), a = 0; a < b.length; a++)this.a.S(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedSfixed32 = $01a60eaba94db1c4$var$W.prototype.ed;
$01a60eaba94db1c4$var$W.prototype.fd = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(8 * b.length), a = 0; a < b.length; a++)this.a.T(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedSfixed64 = $01a60eaba94db1c4$var$W.prototype.fd;
$01a60eaba94db1c4$var$W.prototype.gd = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(8 * b.length), a = 0; a < b.length; a++)this.a.ka(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedSfixed64String = $01a60eaba94db1c4$var$W.prototype.gd;
$01a60eaba94db1c4$var$W.prototype.$c = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(4 * b.length), a = 0; a < b.length; a++)this.a.L(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedFloat = $01a60eaba94db1c4$var$W.prototype.$c;
$01a60eaba94db1c4$var$W.prototype.Uc = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(8 * b.length), a = 0; a < b.length; a++)this.a.J(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedDouble = $01a60eaba94db1c4$var$W.prototype.Uc;
$01a60eaba94db1c4$var$W.prototype.Tc = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(b.length), a = 0; a < b.length; a++)this.a.I(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedBool = $01a60eaba94db1c4$var$W.prototype.Tc;
$01a60eaba94db1c4$var$W.prototype.Vc = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.R(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedEnum = $01a60eaba94db1c4$var$W.prototype.Vc;
$01a60eaba94db1c4$var$W.prototype.Zc = function(a, b) {
    if (null != b && b.length) for($01a60eaba94db1c4$var$Y(this, a, 2), this.a.j(8 * b.length), a = 0; a < b.length; a++)this.a.K(b[a]);
};
$01a60eaba94db1c4$var$W.prototype.writePackedFixedHash64 = $01a60eaba94db1c4$var$W.prototype.Zc;
$01a60eaba94db1c4$var$W.prototype.td = function(a, b) {
    if (null != b && b.length) {
        a = $01a60eaba94db1c4$var$X(this, a);
        for(var c = 0; c < b.length; c++)this.a.N(b[c]);
        $01a60eaba94db1c4$var$Z(this, a);
    }
};
$01a60eaba94db1c4$var$W.prototype.writePackedVarintHash64 = $01a60eaba94db1c4$var$W.prototype.td;
module.exports.debug = $01a60eaba94db1c4$var$R, module.exports.Map = $01a60eaba94db1c4$var$r, module.exports.Message = $01a60eaba94db1c4$var$N, module.exports.BinaryReader = $01a60eaba94db1c4$var$J, module.exports.BinaryWriter = $01a60eaba94db1c4$var$W, module.exports.ExtensionFieldInfo = $01a60eaba94db1c4$var$Ya, module.exports.ExtensionFieldBinaryInfo = $01a60eaba94db1c4$var$Za, module.exports.exportSymbol = $01a60eaba94db1c4$var$ma, module.exports.inherits = $01a60eaba94db1c4$var$na, module.exports.object = {
    extend: $01a60eaba94db1c4$var$pa
}, module.exports.typeOf = $01a60eaba94db1c4$var$k;

});

parcelRegister("3QqPt", function(module, exports) {
// source: domain.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $2ccb0a253ca902ee$var$goog = $8M67s;
var $2ccb0a253ca902ee$var$global = Function('return this')();
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.ActivityState', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Address', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Address.AddressType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Appointment', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Appointment.Status', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Appointment.Type', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.AppointmentVehicle', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.AutonomyUser', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.AutonomyUser.UserType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Customer', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.CustomerActivity', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.CustomerErrorState', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.CustomerFailureState', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.CustomerInfo', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.CustomerState', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.DealerUser', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Dealership', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Dealership.Activity', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Dealership.ActivityState', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Dealership.ErrorState', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Dealership.State', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.DisqualificationReason', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Domain', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Gateway', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.GatewayToken', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Image', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.ImageType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.InsurancePolicy', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.InsurancePolicy.InsuranceStatus', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.LineItem', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.LineItem.LineItemType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Note', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.OdometerUpdate', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.OdometerUpdate.Type', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.PaymentMethod', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.PaymentMethod.PaymentType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Product', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Product.ProductType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.QualificationOrigin', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.QualificationTier', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Score', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Statement', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.StatementAction', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.StatementAction.ActionReason', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.StatementAction.ActionType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.StatementAction.UserType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.StatementStatus', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Subscription', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Subscription.Status', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Subscription.SubscriptionAction', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Subscription.SubscriptionAction.ActionReason', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Subscription.SubscriptionAction.ActionType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Subscription.SubscriptionAction.UserType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.TeamMember', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Transaction', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.Transaction.TransactionType', null, $2ccb0a253ca902ee$var$global);
$2ccb0a253ca902ee$var$goog.exportSymbol('proto.domain.VendorAccount', null, $2ccb0a253ca902ee$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Score = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.domain.Score.repeatedFields_, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Score, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Score.displayName = 'proto.domain.Score';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Address = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Address, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Address.displayName = 'proto.domain.Address';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Image = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Image, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Image.displayName = 'proto.domain.Image';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Customer = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.domain.Customer.repeatedFields_, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Customer, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Customer.displayName = 'proto.domain.Customer';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.CustomerInfo = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.domain.CustomerInfo.repeatedFields_, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.CustomerInfo, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.CustomerInfo.displayName = 'proto.domain.CustomerInfo';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Subscription = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.domain.Subscription.repeatedFields_, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Subscription, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Subscription.displayName = 'proto.domain.Subscription';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Subscription.SubscriptionAction = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Subscription.SubscriptionAction, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Subscription.SubscriptionAction.displayName = 'proto.domain.Subscription.SubscriptionAction';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.OdometerUpdate = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.OdometerUpdate, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.OdometerUpdate.displayName = 'proto.domain.OdometerUpdate';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.InsurancePolicy = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.domain.InsurancePolicy.repeatedFields_, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.InsurancePolicy, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.InsurancePolicy.displayName = 'proto.domain.InsurancePolicy';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.VendorAccount = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.VendorAccount, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.VendorAccount.displayName = 'proto.domain.VendorAccount';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Statement = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.domain.Statement.repeatedFields_, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Statement, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Statement.displayName = 'proto.domain.Statement';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.StatementAction = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.StatementAction, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.StatementAction.displayName = 'proto.domain.StatementAction';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.LineItem = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.LineItem, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.LineItem.displayName = 'proto.domain.LineItem';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Transaction = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Transaction, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Transaction.displayName = 'proto.domain.Transaction';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.PaymentMethod = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.PaymentMethod, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.PaymentMethod.displayName = 'proto.domain.PaymentMethod';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Note = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Note, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Note.displayName = 'proto.domain.Note';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Gateway = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Gateway, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Gateway.displayName = 'proto.domain.Gateway';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.GatewayToken = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.GatewayToken, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.GatewayToken.displayName = 'proto.domain.GatewayToken';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Product = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Product, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Product.displayName = 'proto.domain.Product';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Dealership = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Dealership, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Dealership.displayName = 'proto.domain.Dealership';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.TeamMember = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.TeamMember, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.TeamMember.displayName = 'proto.domain.TeamMember';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.DealerUser = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.domain.DealerUser.repeatedFields_, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.DealerUser, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.DealerUser.displayName = 'proto.domain.DealerUser';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.Appointment = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.Appointment, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.Appointment.displayName = 'proto.domain.Appointment';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.AutonomyUser = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.AutonomyUser, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.AutonomyUser.displayName = 'proto.domain.AutonomyUser';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.domain.AppointmentVehicle = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2ccb0a253ca902ee$var$goog.inherits(proto.domain.AppointmentVehicle, $8M67s.Message);
if ($2ccb0a253ca902ee$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.domain.AppointmentVehicle.displayName = 'proto.domain.AppointmentVehicle';
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.domain.Score.repeatedFields_ = [
    11
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Score.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Score.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Score} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Score.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            vendorName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            scoreName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            scoreValue: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            scoreNumeric: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
            sourceData: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            isPassing: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            vendorId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            isDisqualifiedScore: $8M67s.Message.getBooleanFieldWithDefault(msg, 10, false),
            disqualifiedReasonsList: (f = $8M67s.Message.getRepeatedField(msg, 11)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Score}
 */ proto.domain.Score.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Score;
    return proto.domain.Score.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Score} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Score}
 */ proto.domain.Score.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVendorName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setScoreName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setScoreValue(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readFloat();
                msg.setScoreNumeric(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceData(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsPassing(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setVendorId(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsDisqualifiedScore(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.addDisqualifiedReasons(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Score.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Score.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Score} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Score.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getVendorName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getScoreName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getScoreValue();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getScoreNumeric();
    if (f !== 0.0) writer.writeFloat(6, f);
    f = message.getSourceData();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getIsPassing();
    if (f) writer.writeBool(8, f);
    f = message.getVendorId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getIsDisqualifiedScore();
    if (f) writer.writeBool(10, f);
    f = message.getDisqualifiedReasonsList();
    if (f.length > 0) writer.writeRepeatedString(11, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.Score.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 timestamp = 2;
 * @return {number}
 */ proto.domain.Score.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string vendor_name = 3;
 * @return {string}
 */ proto.domain.Score.prototype.getVendorName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setVendorName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string score_name = 4;
 * @return {string}
 */ proto.domain.Score.prototype.getScoreName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setScoreName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string score_value = 5;
 * @return {string}
 */ proto.domain.Score.prototype.getScoreValue = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setScoreValue = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional float score_numeric = 6;
 * @return {number}
 */ proto.domain.Score.prototype.getScoreNumeric = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 6, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setScoreNumeric = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional string source_data = 7;
 * @return {string}
 */ proto.domain.Score.prototype.getSourceData = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setSourceData = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional bool is_passing = 8;
 * @return {boolean}
 */ proto.domain.Score.prototype.getIsPassing = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setIsPassing = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional string vendor_id = 9;
 * @return {string}
 */ proto.domain.Score.prototype.getVendorId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setVendorId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional bool is_disqualified_score = 10;
 * @return {boolean}
 */ proto.domain.Score.prototype.getIsDisqualifiedScore = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setIsDisqualifiedScore = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 10, value);
};
/**
 * repeated string disqualified_reasons = 11;
 * @return {!Array<string>}
 */ proto.domain.Score.prototype.getDisqualifiedReasonsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 11);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.setDisqualifiedReasonsList = function(value) {
    return $8M67s.Message.setField(this, 11, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.addDisqualifiedReasons = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 11, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Score} returns this
 */ proto.domain.Score.prototype.clearDisqualifiedReasonsList = function() {
    return this.setDisqualifiedReasonsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Address.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Address.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Address} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Address.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressType: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            street: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            street2: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            city: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            state: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            postal: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            id: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            deleted: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Address}
 */ proto.domain.Address.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Address;
    return proto.domain.Address.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Address} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Address}
 */ proto.domain.Address.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.Address.AddressType} */ reader.readEnum();
                msg.setAddressType(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setStreet(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setStreet2(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCity(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setState(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setPostal(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeleted(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Address.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Address.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Address} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Address.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressType();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getStreet();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStreet2();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCity();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getState();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getPostal();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getId();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getDeleted();
    if (f) writer.writeBool(8, f);
};
/**
 * @enum {number}
 */ proto.domain.Address.AddressType = {
    LICENSE: 0,
    PARKING: 1,
    CONTACT: 2,
    DATA_ENRICHMENT: 10
};
/**
 * optional AddressType address_type = 1;
 * @return {!proto.domain.Address.AddressType}
 */ proto.domain.Address.prototype.getAddressType = function() {
    return /** @type {!proto.domain.Address.AddressType} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.Address.AddressType} value
 * @return {!proto.domain.Address} returns this
 */ proto.domain.Address.prototype.setAddressType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string street = 2;
 * @return {string}
 */ proto.domain.Address.prototype.getStreet = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Address} returns this
 */ proto.domain.Address.prototype.setStreet = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string street2 = 3;
 * @return {string}
 */ proto.domain.Address.prototype.getStreet2 = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Address} returns this
 */ proto.domain.Address.prototype.setStreet2 = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string city = 4;
 * @return {string}
 */ proto.domain.Address.prototype.getCity = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Address} returns this
 */ proto.domain.Address.prototype.setCity = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string state = 5;
 * @return {string}
 */ proto.domain.Address.prototype.getState = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Address} returns this
 */ proto.domain.Address.prototype.setState = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string postal = 6;
 * @return {string}
 */ proto.domain.Address.prototype.getPostal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Address} returns this
 */ proto.domain.Address.prototype.setPostal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string id = 7;
 * @return {string}
 */ proto.domain.Address.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Address} returns this
 */ proto.domain.Address.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional bool deleted = 8;
 * @return {boolean}
 */ proto.domain.Address.prototype.getDeleted = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Address} returns this
 */ proto.domain.Address.prototype.setDeleted = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Image.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Image.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Image} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Image.toObject = function(includeInstance, msg) {
        var f, obj = {
            imageType: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            data: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            id: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            uri: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            presignedUri: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Image}
 */ proto.domain.Image.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Image;
    return proto.domain.Image.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Image} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Image}
 */ proto.domain.Image.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.ImageType} */ reader.readEnum();
                msg.setImageType(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setData(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setUri(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setPresignedUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Image.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Image.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Image} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Image.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getImageType();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getData();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getUri();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getPresignedUri();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional ImageType image_type = 1;
 * @return {!proto.domain.ImageType}
 */ proto.domain.Image.prototype.getImageType = function() {
    return /** @type {!proto.domain.ImageType} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.ImageType} value
 * @return {!proto.domain.Image} returns this
 */ proto.domain.Image.prototype.setImageType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string data = 2;
 * @return {string}
 */ proto.domain.Image.prototype.getData = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Image} returns this
 */ proto.domain.Image.prototype.setData = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string id = 3;
 * @return {string}
 */ proto.domain.Image.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Image} returns this
 */ proto.domain.Image.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string uri = 4;
 * @return {string}
 */ proto.domain.Image.prototype.getUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Image} returns this
 */ proto.domain.Image.prototype.setUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string presigned_uri = 5;
 * @return {string}
 */ proto.domain.Image.prototype.getPresignedUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Image} returns this
 */ proto.domain.Image.prototype.setPresignedUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.domain.Customer.repeatedFields_ = [
    9,
    10,
    11
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Customer.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Customer.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Customer.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerInfo: (f = msg.getCustomerInfo()) && proto.domain.CustomerInfo.toObject(includeInstance, f),
            state: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            failureState: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            activity: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            activityState: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            version: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            subscriptionsList: $8M67s.Message.toObjectList(msg.getSubscriptionsList(), proto.domain.Subscription.toObject, includeInstance),
            notesList: $8M67s.Message.toObjectList(msg.getNotesList(), proto.domain.Note.toObject, includeInstance),
            vendorAccountsList: $8M67s.Message.toObjectList(msg.getVendorAccountsList(), proto.domain.VendorAccount.toObject, includeInstance),
            lastSeen: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            errorState: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            clientId: $8M67s.Message.getFieldWithDefault(msg, 14, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Customer}
 */ proto.domain.Customer.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Customer;
    return proto.domain.Customer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Customer}
 */ proto.domain.Customer.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = new proto.domain.CustomerInfo;
                reader.readMessage(value, proto.domain.CustomerInfo.deserializeBinaryFromReader);
                msg.setCustomerInfo(value);
                break;
            case 4:
                var value = /** @type {!proto.domain.CustomerState} */ reader.readEnum();
                msg.setState(value);
                break;
            case 5:
                var value = /** @type {!proto.domain.CustomerFailureState} */ reader.readEnum();
                msg.setFailureState(value);
                break;
            case 6:
                var value = /** @type {!proto.domain.CustomerActivity} */ reader.readEnum();
                msg.setActivity(value);
                break;
            case 7:
                var value = /** @type {!proto.domain.ActivityState} */ reader.readEnum();
                msg.setActivityState(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 9:
                var value = new proto.domain.Subscription;
                reader.readMessage(value, proto.domain.Subscription.deserializeBinaryFromReader);
                msg.addSubscriptions(value);
                break;
            case 10:
                var value = new proto.domain.Note;
                reader.readMessage(value, proto.domain.Note.deserializeBinaryFromReader);
                msg.addNotes(value);
                break;
            case 11:
                var value = new proto.domain.VendorAccount;
                reader.readMessage(value, proto.domain.VendorAccount.deserializeBinaryFromReader);
                msg.addVendorAccounts(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLastSeen(value);
                break;
            case 13:
                var value = /** @type {!proto.domain.CustomerErrorState} */ reader.readEnum();
                msg.setErrorState(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setClientId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Customer.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Customer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Customer.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerInfo();
    if (f != null) writer.writeMessage(3, f, proto.domain.CustomerInfo.serializeBinaryToWriter);
    f = message.getState();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getFailureState();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getActivity();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getActivityState();
    if (f !== 0.0) writer.writeEnum(7, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getSubscriptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, proto.domain.Subscription.serializeBinaryToWriter);
    f = message.getNotesList();
    if (f.length > 0) writer.writeRepeatedMessage(10, f, proto.domain.Note.serializeBinaryToWriter);
    f = message.getVendorAccountsList();
    if (f.length > 0) writer.writeRepeatedMessage(11, f, proto.domain.VendorAccount.serializeBinaryToWriter);
    f = message.getLastSeen();
    if (f !== 0) writer.writeInt64(12, f);
    f = message.getErrorState();
    if (f !== 0.0) writer.writeEnum(13, f);
    f = message.getClientId();
    if (f.length > 0) writer.writeString(14, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.Customer.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account_number = 2;
 * @return {string}
 */ proto.domain.Customer.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional CustomerInfo customer_info = 3;
 * @return {?proto.domain.CustomerInfo}
 */ proto.domain.Customer.prototype.getCustomerInfo = function() {
    return /** @type{?proto.domain.CustomerInfo} */ $8M67s.Message.getWrapperField(this, proto.domain.CustomerInfo, 3);
};
/**
 * @param {?proto.domain.CustomerInfo|undefined} value
 * @return {!proto.domain.Customer} returns this
*/ proto.domain.Customer.prototype.setCustomerInfo = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.clearCustomerInfo = function() {
    return this.setCustomerInfo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.domain.Customer.prototype.hasCustomerInfo = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional CustomerState state = 4;
 * @return {!proto.domain.CustomerState}
 */ proto.domain.Customer.prototype.getState = function() {
    return /** @type {!proto.domain.CustomerState} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.domain.CustomerState} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional CustomerFailureState failure_state = 5;
 * @return {!proto.domain.CustomerFailureState}
 */ proto.domain.Customer.prototype.getFailureState = function() {
    return /** @type {!proto.domain.CustomerFailureState} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.domain.CustomerFailureState} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setFailureState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional CustomerActivity activity = 6;
 * @return {!proto.domain.CustomerActivity}
 */ proto.domain.Customer.prototype.getActivity = function() {
    return /** @type {!proto.domain.CustomerActivity} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.domain.CustomerActivity} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setActivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional ActivityState activity_state = 7;
 * @return {!proto.domain.ActivityState}
 */ proto.domain.Customer.prototype.getActivityState = function() {
    return /** @type {!proto.domain.ActivityState} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.domain.ActivityState} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setActivityState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional int64 version = 8;
 * @return {number}
 */ proto.domain.Customer.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * repeated Subscription subscriptions = 9;
 * @return {!Array<!proto.domain.Subscription>}
 */ proto.domain.Customer.prototype.getSubscriptionsList = function() {
    return /** @type{!Array<!proto.domain.Subscription>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Subscription, 9);
};
/**
 * @param {!Array<!proto.domain.Subscription>} value
 * @return {!proto.domain.Customer} returns this
*/ proto.domain.Customer.prototype.setSubscriptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.domain.Subscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Subscription}
 */ proto.domain.Customer.prototype.addSubscriptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.domain.Subscription, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.clearSubscriptionsList = function() {
    return this.setSubscriptionsList([]);
};
/**
 * repeated Note notes = 10;
 * @return {!Array<!proto.domain.Note>}
 */ proto.domain.Customer.prototype.getNotesList = function() {
    return /** @type{!Array<!proto.domain.Note>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Note, 10);
};
/**
 * @param {!Array<!proto.domain.Note>} value
 * @return {!proto.domain.Customer} returns this
*/ proto.domain.Customer.prototype.setNotesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 10, value);
};
/**
 * @param {!proto.domain.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Note}
 */ proto.domain.Customer.prototype.addNotes = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.domain.Note, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.clearNotesList = function() {
    return this.setNotesList([]);
};
/**
 * repeated VendorAccount vendor_accounts = 11;
 * @return {!Array<!proto.domain.VendorAccount>}
 */ proto.domain.Customer.prototype.getVendorAccountsList = function() {
    return /** @type{!Array<!proto.domain.VendorAccount>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.VendorAccount, 11);
};
/**
 * @param {!Array<!proto.domain.VendorAccount>} value
 * @return {!proto.domain.Customer} returns this
*/ proto.domain.Customer.prototype.setVendorAccountsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 11, value);
};
/**
 * @param {!proto.domain.VendorAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.VendorAccount}
 */ proto.domain.Customer.prototype.addVendorAccounts = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.domain.VendorAccount, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.clearVendorAccountsList = function() {
    return this.setVendorAccountsList([]);
};
/**
 * optional int64 last_seen = 12;
 * @return {number}
 */ proto.domain.Customer.prototype.getLastSeen = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setLastSeen = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional CustomerErrorState error_state = 13;
 * @return {!proto.domain.CustomerErrorState}
 */ proto.domain.Customer.prototype.getErrorState = function() {
    return /** @type {!proto.domain.CustomerErrorState} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {!proto.domain.CustomerErrorState} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setErrorState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 13, value);
};
/**
 * optional string client_id = 14;
 * @return {string}
 */ proto.domain.Customer.prototype.getClientId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Customer} returns this
 */ proto.domain.Customer.prototype.setClientId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.domain.CustomerInfo.repeatedFields_ = [
    6,
    9,
    10,
    12
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.CustomerInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.CustomerInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.CustomerInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.CustomerInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            firstName: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            language: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            addressesList: $8M67s.Message.toObjectList(msg.getAddressesList(), proto.domain.Address.toObject, includeInstance),
            licenseNumber: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            password: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            imagesList: $8M67s.Message.toObjectList(msg.getImagesList(), proto.domain.Image.toObject, includeInstance),
            scoresList: $8M67s.Message.toObjectList(msg.getScoresList(), proto.domain.Score.toObject, includeInstance),
            paymentGatewayId: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            insurancePoliciesList: $8M67s.Message.toObjectList(msg.getInsurancePoliciesList(), proto.domain.InsurancePolicy.toObject, includeInstance),
            licenseExpirationDate: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            dateOfBirth: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            qualificationTier: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            paymentMethodsRequired: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 17, ""),
            previousTier: $8M67s.Message.getFieldWithDefault(msg, 18, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.CustomerInfo}
 */ proto.domain.CustomerInfo.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.CustomerInfo;
    return proto.domain.CustomerInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.CustomerInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.CustomerInfo}
 */ proto.domain.CustomerInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 6:
                var value = new proto.domain.Address;
                reader.readMessage(value, proto.domain.Address.deserializeBinaryFromReader);
                msg.addAddresses(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setLicenseNumber(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setPassword(value);
                break;
            case 9:
                var value = new proto.domain.Image;
                reader.readMessage(value, proto.domain.Image.deserializeBinaryFromReader);
                msg.addImages(value);
                break;
            case 10:
                var value = new proto.domain.Score;
                reader.readMessage(value, proto.domain.Score.deserializeBinaryFromReader);
                msg.addScores(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentGatewayId(value);
                break;
            case 12:
                var value = new proto.domain.InsurancePolicy;
                reader.readMessage(value, proto.domain.InsurancePolicy.deserializeBinaryFromReader);
                msg.addInsurancePolicies(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLicenseExpirationDate(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDateOfBirth(value);
                break;
            case 15:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setQualificationTier(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPaymentMethodsRequired(value);
                break;
            case 17:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 18:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setPreviousTier(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.CustomerInfo.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.CustomerInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.CustomerInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.CustomerInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLanguage();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getAddressesList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, proto.domain.Address.serializeBinaryToWriter);
    f = message.getLicenseNumber();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getPassword();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getImagesList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, proto.domain.Image.serializeBinaryToWriter);
    f = message.getScoresList();
    if (f.length > 0) writer.writeRepeatedMessage(10, f, proto.domain.Score.serializeBinaryToWriter);
    f = message.getPaymentGatewayId();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getInsurancePoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(12, f, proto.domain.InsurancePolicy.serializeBinaryToWriter);
    f = message.getLicenseExpirationDate();
    if (f !== 0) writer.writeInt64(13, f);
    f = message.getDateOfBirth();
    if (f !== 0) writer.writeInt64(14, f);
    f = message.getQualificationTier();
    if (f !== 0.0) writer.writeEnum(15, f);
    f = message.getPaymentMethodsRequired();
    if (f !== 0) writer.writeInt32(16, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(17, f);
    f = message.getPreviousTier();
    if (f !== 0.0) writer.writeEnum(18, f);
};
/**
 * optional string first_name = 1;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string last_name = 2;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string language = 3;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getLanguage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setLanguage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string phone = 4;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string email = 5;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * repeated Address addresses = 6;
 * @return {!Array<!proto.domain.Address>}
 */ proto.domain.CustomerInfo.prototype.getAddressesList = function() {
    return /** @type{!Array<!proto.domain.Address>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Address, 6);
};
/**
 * @param {!Array<!proto.domain.Address>} value
 * @return {!proto.domain.CustomerInfo} returns this
*/ proto.domain.CustomerInfo.prototype.setAddressesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.domain.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Address}
 */ proto.domain.CustomerInfo.prototype.addAddresses = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.domain.Address, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.clearAddressesList = function() {
    return this.setAddressesList([]);
};
/**
 * optional string license_number = 7;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getLicenseNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setLicenseNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string password = 8;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getPassword = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setPassword = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * repeated Image images = 9;
 * @return {!Array<!proto.domain.Image>}
 */ proto.domain.CustomerInfo.prototype.getImagesList = function() {
    return /** @type{!Array<!proto.domain.Image>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Image, 9);
};
/**
 * @param {!Array<!proto.domain.Image>} value
 * @return {!proto.domain.CustomerInfo} returns this
*/ proto.domain.CustomerInfo.prototype.setImagesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.domain.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Image}
 */ proto.domain.CustomerInfo.prototype.addImages = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.domain.Image, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.clearImagesList = function() {
    return this.setImagesList([]);
};
/**
 * repeated Score scores = 10;
 * @return {!Array<!proto.domain.Score>}
 */ proto.domain.CustomerInfo.prototype.getScoresList = function() {
    return /** @type{!Array<!proto.domain.Score>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Score, 10);
};
/**
 * @param {!Array<!proto.domain.Score>} value
 * @return {!proto.domain.CustomerInfo} returns this
*/ proto.domain.CustomerInfo.prototype.setScoresList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 10, value);
};
/**
 * @param {!proto.domain.Score=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Score}
 */ proto.domain.CustomerInfo.prototype.addScores = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.domain.Score, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.clearScoresList = function() {
    return this.setScoresList([]);
};
/**
 * optional string payment_gateway_id = 11;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getPaymentGatewayId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setPaymentGatewayId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * repeated InsurancePolicy insurance_policies = 12;
 * @return {!Array<!proto.domain.InsurancePolicy>}
 */ proto.domain.CustomerInfo.prototype.getInsurancePoliciesList = function() {
    return /** @type{!Array<!proto.domain.InsurancePolicy>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.InsurancePolicy, 12);
};
/**
 * @param {!Array<!proto.domain.InsurancePolicy>} value
 * @return {!proto.domain.CustomerInfo} returns this
*/ proto.domain.CustomerInfo.prototype.setInsurancePoliciesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 12, value);
};
/**
 * @param {!proto.domain.InsurancePolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.InsurancePolicy}
 */ proto.domain.CustomerInfo.prototype.addInsurancePolicies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.domain.InsurancePolicy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.clearInsurancePoliciesList = function() {
    return this.setInsurancePoliciesList([]);
};
/**
 * optional int64 license_expiration_date = 13;
 * @return {number}
 */ proto.domain.CustomerInfo.prototype.getLicenseExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setLicenseExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
/**
 * optional int64 date_of_birth = 14;
 * @return {number}
 */ proto.domain.CustomerInfo.prototype.getDateOfBirth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setDateOfBirth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 14, value);
};
/**
 * optional QualificationTier qualification_tier = 15;
 * @return {!proto.domain.QualificationTier}
 */ proto.domain.CustomerInfo.prototype.getQualificationTier = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setQualificationTier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 15, value);
};
/**
 * optional int32 payment_methods_required = 16;
 * @return {number}
 */ proto.domain.CustomerInfo.prototype.getPaymentMethodsRequired = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setPaymentMethodsRequired = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
/**
 * optional string customer_id = 17;
 * @return {string}
 */ proto.domain.CustomerInfo.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 17, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 17, value);
};
/**
 * optional QualificationTier previous_tier = 18;
 * @return {!proto.domain.QualificationTier}
 */ proto.domain.CustomerInfo.prototype.getPreviousTier = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 18, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.domain.CustomerInfo} returns this
 */ proto.domain.CustomerInfo.prototype.setPreviousTier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 18, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.domain.Subscription.repeatedFields_ = [
    5,
    6,
    12,
    15
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Subscription.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Subscription.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Subscription.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            rate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            statementsList: $8M67s.Message.toObjectList(msg.getStatementsList(), proto.domain.Statement.toObject, includeInstance),
            paymentMethodsList: $8M67s.Message.toObjectList(msg.getPaymentMethodsList(), proto.domain.PaymentMethod.toObject, includeInstance),
            pickupDate: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            activationDate: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            addressId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            contractSignedDate: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            actionsList: $8M67s.Message.toObjectList(msg.getActionsList(), proto.domain.Subscription.SubscriptionAction.toObject, includeInstance),
            trackingId: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            odometerUpdatesList: $8M67s.Message.toObjectList(msg.getOdometerUpdatesList(), proto.domain.OdometerUpdate.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Subscription}
 */ proto.domain.Subscription.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Subscription;
    return proto.domain.Subscription.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Subscription}
 */ proto.domain.Subscription.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.Subscription.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRate(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 5:
                var value = new proto.domain.Statement;
                reader.readMessage(value, proto.domain.Statement.deserializeBinaryFromReader);
                msg.addStatements(value);
                break;
            case 6:
                var value = new proto.domain.PaymentMethod;
                reader.readMessage(value, proto.domain.PaymentMethod.deserializeBinaryFromReader);
                msg.addPaymentMethods(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPickupDate(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt64();
                msg.setActivationDate(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setAddressId(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt64();
                msg.setContractSignedDate(value);
                break;
            case 12:
                var value = new proto.domain.Subscription.SubscriptionAction;
                reader.readMessage(value, proto.domain.Subscription.SubscriptionAction.deserializeBinaryFromReader);
                msg.addActions(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingId(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 15:
                var value = new proto.domain.OdometerUpdate;
                reader.readMessage(value, proto.domain.OdometerUpdate.deserializeBinaryFromReader);
                msg.addOdometerUpdates(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Subscription.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Subscription.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Subscription.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getRate();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getStatementsList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, proto.domain.Statement.serializeBinaryToWriter);
    f = message.getPaymentMethodsList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, proto.domain.PaymentMethod.serializeBinaryToWriter);
    f = message.getPickupDate();
    if (f !== 0) writer.writeInt64(7, f);
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getActivationDate();
    if (f !== 0) writer.writeInt64(9, f);
    f = message.getAddressId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getContractSignedDate();
    if (f !== 0) writer.writeInt64(11, f);
    f = message.getActionsList();
    if (f.length > 0) writer.writeRepeatedMessage(12, f, proto.domain.Subscription.SubscriptionAction.serializeBinaryToWriter);
    f = message.getTrackingId();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getOdometerUpdatesList();
    if (f.length > 0) writer.writeRepeatedMessage(15, f, proto.domain.OdometerUpdate.serializeBinaryToWriter);
};
/**
 * @enum {number}
 */ proto.domain.Subscription.Status = {
    PENDING: 0,
    ACTIVE: 1,
    CLOSED: 2,
    RETURNING: 3
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Subscription.SubscriptionAction.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Subscription.SubscriptionAction.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Subscription.SubscriptionAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Subscription.SubscriptionAction.toObject = function(includeInstance, msg) {
        var f, obj = {
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            userId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            userEmail: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            userType: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            actionType: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            actionReason: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            notes: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Subscription.SubscriptionAction}
 */ proto.domain.Subscription.SubscriptionAction.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Subscription.SubscriptionAction;
    return proto.domain.Subscription.SubscriptionAction.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Subscription.SubscriptionAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Subscription.SubscriptionAction}
 */ proto.domain.Subscription.SubscriptionAction.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setUserEmail(value);
                break;
            case 4:
                var value = /** @type {!proto.domain.Subscription.SubscriptionAction.UserType} */ reader.readEnum();
                msg.setUserType(value);
                break;
            case 5:
                var value = /** @type {!proto.domain.Subscription.SubscriptionAction.ActionType} */ reader.readEnum();
                msg.setActionType(value);
                break;
            case 6:
                var value = /** @type {!proto.domain.Subscription.SubscriptionAction.ActionReason} */ reader.readEnum();
                msg.setActionReason(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setNotes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Subscription.SubscriptionAction.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Subscription.SubscriptionAction.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Subscription.SubscriptionAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Subscription.SubscriptionAction.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(1, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUserEmail();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getUserType();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getActionType();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getActionReason();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getNotes();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * @enum {number}
 */ proto.domain.Subscription.SubscriptionAction.UserType = {
    CUSTOMER: 0,
    DEALER: 1,
    AUTONOMY: 2
};
/**
 * @enum {number}
 */ proto.domain.Subscription.SubscriptionAction.ActionType = {
    CREATE: 0,
    UPDATE: 1,
    CANCEL: 2
};
/**
 * @enum {number}
 */ proto.domain.Subscription.SubscriptionAction.ActionReason = {
    DEALER_VEHICLE_NOT_AVAILABLE: 0,
    DEALER_VEHICLE_SELLING_PRICE_REJECTED: 1,
    DEALER_VEHICLE_SOLD: 2,
    CUSTOMER_VEHICLE_TOO_EXPENSIVE: 3,
    CUSTOMER_VEHICLE_DRIVE_NOT_AS_EXPECTED: 4,
    LINE_ITEM_ADDED: 5,
    TRANSACTION_ADDED: 6,
    STATEMENT_ADDED: 7,
    VEHICLE_PICKUP: 8,
    SUBSCRIPTION_ACTIVATED: 9,
    CONTRACT_SIGNED: 10,
    PAYMENT_METHOD_ADDED: 11,
    ANDROID_OS_UNSUPPORTED: 12,
    CUSTOMER_VEHICLE_DOES_NOT_WANT_VEHICLE: 13,
    ODOMETER_READING_UPDATE: 14
};
/**
 * optional int64 timestamp = 1;
 * @return {number}
 */ proto.domain.Subscription.SubscriptionAction.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Subscription.SubscriptionAction} returns this
 */ proto.domain.Subscription.SubscriptionAction.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string user_id = 2;
 * @return {string}
 */ proto.domain.Subscription.SubscriptionAction.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription.SubscriptionAction} returns this
 */ proto.domain.Subscription.SubscriptionAction.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string user_email = 3;
 * @return {string}
 */ proto.domain.Subscription.SubscriptionAction.prototype.getUserEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription.SubscriptionAction} returns this
 */ proto.domain.Subscription.SubscriptionAction.prototype.setUserEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional UserType user_type = 4;
 * @return {!proto.domain.Subscription.SubscriptionAction.UserType}
 */ proto.domain.Subscription.SubscriptionAction.prototype.getUserType = function() {
    return /** @type {!proto.domain.Subscription.SubscriptionAction.UserType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.domain.Subscription.SubscriptionAction.UserType} value
 * @return {!proto.domain.Subscription.SubscriptionAction} returns this
 */ proto.domain.Subscription.SubscriptionAction.prototype.setUserType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional ActionType action_type = 5;
 * @return {!proto.domain.Subscription.SubscriptionAction.ActionType}
 */ proto.domain.Subscription.SubscriptionAction.prototype.getActionType = function() {
    return /** @type {!proto.domain.Subscription.SubscriptionAction.ActionType} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.domain.Subscription.SubscriptionAction.ActionType} value
 * @return {!proto.domain.Subscription.SubscriptionAction} returns this
 */ proto.domain.Subscription.SubscriptionAction.prototype.setActionType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional ActionReason action_reason = 6;
 * @return {!proto.domain.Subscription.SubscriptionAction.ActionReason}
 */ proto.domain.Subscription.SubscriptionAction.prototype.getActionReason = function() {
    return /** @type {!proto.domain.Subscription.SubscriptionAction.ActionReason} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.domain.Subscription.SubscriptionAction.ActionReason} value
 * @return {!proto.domain.Subscription.SubscriptionAction} returns this
 */ proto.domain.Subscription.SubscriptionAction.prototype.setActionReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional string notes = 7;
 * @return {string}
 */ proto.domain.Subscription.SubscriptionAction.prototype.getNotes = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription.SubscriptionAction} returns this
 */ proto.domain.Subscription.SubscriptionAction.prototype.setNotes = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.Subscription.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Status status = 2;
 * @return {!proto.domain.Subscription.Status}
 */ proto.domain.Subscription.prototype.getStatus = function() {
    return /** @type {!proto.domain.Subscription.Status} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.Subscription.Status} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional int32 rate = 3;
 * @return {number}
 */ proto.domain.Subscription.prototype.getRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string vehicle_id = 4;
 * @return {string}
 */ proto.domain.Subscription.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * repeated Statement statements = 5;
 * @return {!Array<!proto.domain.Statement>}
 */ proto.domain.Subscription.prototype.getStatementsList = function() {
    return /** @type{!Array<!proto.domain.Statement>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Statement, 5);
};
/**
 * @param {!Array<!proto.domain.Statement>} value
 * @return {!proto.domain.Subscription} returns this
*/ proto.domain.Subscription.prototype.setStatementsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.domain.Statement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Statement}
 */ proto.domain.Subscription.prototype.addStatements = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.domain.Statement, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.clearStatementsList = function() {
    return this.setStatementsList([]);
};
/**
 * repeated PaymentMethod payment_methods = 6;
 * @return {!Array<!proto.domain.PaymentMethod>}
 */ proto.domain.Subscription.prototype.getPaymentMethodsList = function() {
    return /** @type{!Array<!proto.domain.PaymentMethod>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.PaymentMethod, 6);
};
/**
 * @param {!Array<!proto.domain.PaymentMethod>} value
 * @return {!proto.domain.Subscription} returns this
*/ proto.domain.Subscription.prototype.setPaymentMethodsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.domain.PaymentMethod=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.PaymentMethod}
 */ proto.domain.Subscription.prototype.addPaymentMethods = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.domain.PaymentMethod, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.clearPaymentMethodsList = function() {
    return this.setPaymentMethodsList([]);
};
/**
 * optional int64 pickup_date = 7;
 * @return {number}
 */ proto.domain.Subscription.prototype.getPickupDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setPickupDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string dealer_id = 8;
 * @return {string}
 */ proto.domain.Subscription.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional int64 activation_date = 9;
 * @return {number}
 */ proto.domain.Subscription.prototype.getActivationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setActivationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional string address_id = 10;
 * @return {string}
 */ proto.domain.Subscription.prototype.getAddressId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setAddressId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional int64 contract_signed_date = 11;
 * @return {number}
 */ proto.domain.Subscription.prototype.getContractSignedDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setContractSignedDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * repeated SubscriptionAction actions = 12;
 * @return {!Array<!proto.domain.Subscription.SubscriptionAction>}
 */ proto.domain.Subscription.prototype.getActionsList = function() {
    return /** @type{!Array<!proto.domain.Subscription.SubscriptionAction>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Subscription.SubscriptionAction, 12);
};
/**
 * @param {!Array<!proto.domain.Subscription.SubscriptionAction>} value
 * @return {!proto.domain.Subscription} returns this
*/ proto.domain.Subscription.prototype.setActionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 12, value);
};
/**
 * @param {!proto.domain.Subscription.SubscriptionAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Subscription.SubscriptionAction}
 */ proto.domain.Subscription.prototype.addActions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 12, opt_value, proto.domain.Subscription.SubscriptionAction, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.clearActionsList = function() {
    return this.setActionsList([]);
};
/**
 * optional string tracking_id = 13;
 * @return {string}
 */ proto.domain.Subscription.prototype.getTrackingId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setTrackingId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string customer_id = 14;
 * @return {string}
 */ proto.domain.Subscription.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * repeated OdometerUpdate odometer_updates = 15;
 * @return {!Array<!proto.domain.OdometerUpdate>}
 */ proto.domain.Subscription.prototype.getOdometerUpdatesList = function() {
    return /** @type{!Array<!proto.domain.OdometerUpdate>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.OdometerUpdate, 15);
};
/**
 * @param {!Array<!proto.domain.OdometerUpdate>} value
 * @return {!proto.domain.Subscription} returns this
*/ proto.domain.Subscription.prototype.setOdometerUpdatesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 15, value);
};
/**
 * @param {!proto.domain.OdometerUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.OdometerUpdate}
 */ proto.domain.Subscription.prototype.addOdometerUpdates = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.domain.OdometerUpdate, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Subscription} returns this
 */ proto.domain.Subscription.prototype.clearOdometerUpdatesList = function() {
    return this.setOdometerUpdatesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.OdometerUpdate.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.OdometerUpdate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.OdometerUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.OdometerUpdate.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            type: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            reading: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.OdometerUpdate}
 */ proto.domain.OdometerUpdate.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.OdometerUpdate;
    return proto.domain.OdometerUpdate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.OdometerUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.OdometerUpdate}
 */ proto.domain.OdometerUpdate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.OdometerUpdate.Type} */ reader.readEnum();
                msg.setType(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setReading(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.OdometerUpdate.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.OdometerUpdate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.OdometerUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.OdometerUpdate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getReading();
    if (f !== 0) writer.writeInt64(4, f);
};
/**
 * @enum {number}
 */ proto.domain.OdometerUpdate.Type = {
    TYPE_UNSPECIFIED: 0,
    TYPE_SUBSCRIPTION_START: 1,
    TYPE_SUBSCRIPTION_ACCRUAL: 2,
    TYPE_SUBSCRIPTION_END: 3
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.OdometerUpdate.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.OdometerUpdate} returns this
 */ proto.domain.OdometerUpdate.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 timestamp = 2;
 * @return {number}
 */ proto.domain.OdometerUpdate.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.OdometerUpdate} returns this
 */ proto.domain.OdometerUpdate.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional Type type = 3;
 * @return {!proto.domain.OdometerUpdate.Type}
 */ proto.domain.OdometerUpdate.prototype.getType = function() {
    return /** @type {!proto.domain.OdometerUpdate.Type} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.OdometerUpdate.Type} value
 * @return {!proto.domain.OdometerUpdate} returns this
 */ proto.domain.OdometerUpdate.prototype.setType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional int64 reading = 4;
 * @return {number}
 */ proto.domain.OdometerUpdate.prototype.getReading = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.OdometerUpdate} returns this
 */ proto.domain.OdometerUpdate.prototype.setReading = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.domain.InsurancePolicy.repeatedFields_ = [
    11
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.InsurancePolicy.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.InsurancePolicy.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.InsurancePolicy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.InsurancePolicy.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            providerName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            providerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            policyNumber: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            expirationDateString: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            expirationDate: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            effectiveDateString: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            effectiveDate: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            status: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            version: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            imagesList: $8M67s.Message.toObjectList(msg.getImagesList(), proto.domain.Image.toObject, includeInstance),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            premium: $8M67s.Message.getFieldWithDefault(msg, 13, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.InsurancePolicy}
 */ proto.domain.InsurancePolicy.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.InsurancePolicy;
    return proto.domain.InsurancePolicy.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.InsurancePolicy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.InsurancePolicy}
 */ proto.domain.InsurancePolicy.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setProviderName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setProviderId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyNumber(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setExpirationDateString(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt64();
                msg.setExpirationDate(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setEffectiveDateString(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setEffectiveDate(value);
                break;
            case 9:
                var value = /** @type {!proto.domain.InsurancePolicy.InsuranceStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 11:
                var value = new proto.domain.Image;
                reader.readMessage(value, proto.domain.Image.deserializeBinaryFromReader);
                msg.addImages(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPremium(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.InsurancePolicy.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.InsurancePolicy.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.InsurancePolicy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.InsurancePolicy.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getProviderName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getProviderId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getPolicyNumber();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getExpirationDateString();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getExpirationDate();
    if (f !== 0) writer.writeInt64(6, f);
    f = message.getEffectiveDateString();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getEffectiveDate();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(9, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(10, f);
    f = message.getImagesList();
    if (f.length > 0) writer.writeRepeatedMessage(11, f, proto.domain.Image.serializeBinaryToWriter);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getPremium();
    if (f !== 0) writer.writeInt64(13, f);
};
/**
 * @enum {number}
 */ proto.domain.InsurancePolicy.InsuranceStatus = {
    UNKNOWN: 0,
    VALID: 1,
    EXPIRED: 2
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.InsurancePolicy.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string provider_name = 2;
 * @return {string}
 */ proto.domain.InsurancePolicy.prototype.getProviderName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setProviderName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string provider_id = 3;
 * @return {string}
 */ proto.domain.InsurancePolicy.prototype.getProviderId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setProviderId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string policy_number = 4;
 * @return {string}
 */ proto.domain.InsurancePolicy.prototype.getPolicyNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setPolicyNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string expiration_date_string = 5;
 * @return {string}
 */ proto.domain.InsurancePolicy.prototype.getExpirationDateString = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setExpirationDateString = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int64 expiration_date = 6;
 * @return {number}
 */ proto.domain.InsurancePolicy.prototype.getExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional string effective_date_string = 7;
 * @return {string}
 */ proto.domain.InsurancePolicy.prototype.getEffectiveDateString = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setEffectiveDateString = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional int64 effective_date = 8;
 * @return {number}
 */ proto.domain.InsurancePolicy.prototype.getEffectiveDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setEffectiveDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional InsuranceStatus status = 9;
 * @return {!proto.domain.InsurancePolicy.InsuranceStatus}
 */ proto.domain.InsurancePolicy.prototype.getStatus = function() {
    return /** @type {!proto.domain.InsurancePolicy.InsuranceStatus} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {!proto.domain.InsurancePolicy.InsuranceStatus} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 9, value);
};
/**
 * optional int64 version = 10;
 * @return {number}
 */ proto.domain.InsurancePolicy.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * repeated Image images = 11;
 * @return {!Array<!proto.domain.Image>}
 */ proto.domain.InsurancePolicy.prototype.getImagesList = function() {
    return /** @type{!Array<!proto.domain.Image>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Image, 11);
};
/**
 * @param {!Array<!proto.domain.Image>} value
 * @return {!proto.domain.InsurancePolicy} returns this
*/ proto.domain.InsurancePolicy.prototype.setImagesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 11, value);
};
/**
 * @param {!proto.domain.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Image}
 */ proto.domain.InsurancePolicy.prototype.addImages = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.domain.Image, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.clearImagesList = function() {
    return this.setImagesList([]);
};
/**
 * optional string customer_id = 12;
 * @return {string}
 */ proto.domain.InsurancePolicy.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional int64 premium = 13;
 * @return {number}
 */ proto.domain.InsurancePolicy.prototype.getPremium = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.InsurancePolicy} returns this
 */ proto.domain.InsurancePolicy.prototype.setPremium = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.VendorAccount.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.VendorAccount.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.VendorAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.VendorAccount.toObject = function(includeInstance, msg) {
        var f, obj = {
            vendorName: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            accountId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            alternateAccountId: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.VendorAccount}
 */ proto.domain.VendorAccount.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.VendorAccount;
    return proto.domain.VendorAccount.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.VendorAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.VendorAccount}
 */ proto.domain.VendorAccount.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVendorName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setStatus(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAlternateAccountId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.VendorAccount.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.VendorAccount.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.VendorAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.VendorAccount.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVendorName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAccountId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStatus();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAlternateAccountId();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string vendor_name = 1;
 * @return {string}
 */ proto.domain.VendorAccount.prototype.getVendorName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.VendorAccount} returns this
 */ proto.domain.VendorAccount.prototype.setVendorName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account_id = 2;
 * @return {string}
 */ proto.domain.VendorAccount.prototype.getAccountId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.VendorAccount} returns this
 */ proto.domain.VendorAccount.prototype.setAccountId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string status = 3;
 * @return {string}
 */ proto.domain.VendorAccount.prototype.getStatus = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.VendorAccount} returns this
 */ proto.domain.VendorAccount.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string alternate_account_id = 4;
 * @return {string}
 */ proto.domain.VendorAccount.prototype.getAlternateAccountId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.VendorAccount} returns this
 */ proto.domain.VendorAccount.prototype.setAlternateAccountId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.domain.Statement.repeatedFields_ = [
    8,
    9,
    11
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Statement.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Statement.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Statement} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Statement.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            dueDate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            paymentDate: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), proto.domain.LineItem.toObject, includeInstance),
            transactionsList: $8M67s.Message.toObjectList(msg.getTransactionsList(), proto.domain.Transaction.toObject, includeInstance),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            actionsList: $8M67s.Message.toObjectList(msg.getActionsList(), proto.domain.StatementAction.toObject, includeInstance),
            preferredPaymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            orderId: $8M67s.Message.getFieldWithDefault(msg, 13, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Statement}
 */ proto.domain.Statement.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Statement;
    return proto.domain.Statement.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Statement} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Statement}
 */ proto.domain.Statement.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDueDate(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPaymentDate(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            case 7:
                var value = /** @type {!proto.domain.StatementStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 8:
                var value = new proto.domain.LineItem;
                reader.readMessage(value, proto.domain.LineItem.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            case 9:
                var value = new proto.domain.Transaction;
                reader.readMessage(value, proto.domain.Transaction.deserializeBinaryFromReader);
                msg.addTransactions(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 11:
                var value = new proto.domain.StatementAction;
                reader.readMessage(value, proto.domain.StatementAction.deserializeBinaryFromReader);
                msg.addActions(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setPreferredPaymentMethodId(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Statement.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Statement.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Statement} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Statement.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getDueDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getPaymentDate();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(7, f);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(8, f, proto.domain.LineItem.serializeBinaryToWriter);
    f = message.getTransactionsList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, proto.domain.Transaction.serializeBinaryToWriter);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getActionsList();
    if (f.length > 0) writer.writeRepeatedMessage(11, f, proto.domain.StatementAction.serializeBinaryToWriter);
    f = message.getPreferredPaymentMethodId();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getOrderId();
    if (f.length > 0) writer.writeString(13, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.Statement.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.domain.Statement.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 date = 3;
 * @return {number}
 */ proto.domain.Statement.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int64 due_date = 4;
 * @return {number}
 */ proto.domain.Statement.prototype.getDueDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setDueDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 payment_date = 5;
 * @return {number}
 */ proto.domain.Statement.prototype.getPaymentDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setPaymentDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string invoice_number = 6;
 * @return {string}
 */ proto.domain.Statement.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional StatementStatus status = 7;
 * @return {!proto.domain.StatementStatus}
 */ proto.domain.Statement.prototype.getStatus = function() {
    return /** @type {!proto.domain.StatementStatus} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.domain.StatementStatus} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 7, value);
};
/**
 * repeated LineItem line_items = 8;
 * @return {!Array<!proto.domain.LineItem>}
 */ proto.domain.Statement.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.domain.LineItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.LineItem, 8);
};
/**
 * @param {!Array<!proto.domain.LineItem>} value
 * @return {!proto.domain.Statement} returns this
*/ proto.domain.Statement.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.domain.LineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.LineItem}
 */ proto.domain.Statement.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.domain.LineItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
/**
 * repeated Transaction transactions = 9;
 * @return {!Array<!proto.domain.Transaction>}
 */ proto.domain.Statement.prototype.getTransactionsList = function() {
    return /** @type{!Array<!proto.domain.Transaction>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.Transaction, 9);
};
/**
 * @param {!Array<!proto.domain.Transaction>} value
 * @return {!proto.domain.Statement} returns this
*/ proto.domain.Statement.prototype.setTransactionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.domain.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Transaction}
 */ proto.domain.Statement.prototype.addTransactions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.domain.Transaction, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.clearTransactionsList = function() {
    return this.setTransactionsList([]);
};
/**
 * optional string order_number = 10;
 * @return {string}
 */ proto.domain.Statement.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * repeated StatementAction actions = 11;
 * @return {!Array<!proto.domain.StatementAction>}
 */ proto.domain.Statement.prototype.getActionsList = function() {
    return /** @type{!Array<!proto.domain.StatementAction>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.domain.StatementAction, 11);
};
/**
 * @param {!Array<!proto.domain.StatementAction>} value
 * @return {!proto.domain.Statement} returns this
*/ proto.domain.Statement.prototype.setActionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 11, value);
};
/**
 * @param {!proto.domain.StatementAction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.StatementAction}
 */ proto.domain.Statement.prototype.addActions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.domain.StatementAction, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.clearActionsList = function() {
    return this.setActionsList([]);
};
/**
 * optional string preferred_payment_method_id = 12;
 * @return {string}
 */ proto.domain.Statement.prototype.getPreferredPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setPreferredPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string order_id = 13;
 * @return {string}
 */ proto.domain.Statement.prototype.getOrderId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Statement} returns this
 */ proto.domain.Statement.prototype.setOrderId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.StatementAction.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.StatementAction.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.StatementAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.StatementAction.toObject = function(includeInstance, msg) {
        var f, obj = {
            date: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            userId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            userType: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            actionType: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            actionReason: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            notes: $8M67s.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.StatementAction}
 */ proto.domain.StatementAction.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.StatementAction;
    return proto.domain.StatementAction.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.StatementAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.StatementAction}
 */ proto.domain.StatementAction.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDate(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.StatementAction.UserType} */ reader.readEnum();
                msg.setUserType(value);
                break;
            case 4:
                var value = /** @type {!proto.domain.StatementAction.ActionType} */ reader.readEnum();
                msg.setActionType(value);
                break;
            case 5:
                var value = /** @type {!proto.domain.StatementAction.ActionReason} */ reader.readEnum();
                msg.setActionReason(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setNotes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.StatementAction.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.StatementAction.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.StatementAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.StatementAction.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUserType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getActionType();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getActionReason();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getNotes();
    if (f.length > 0) writer.writeString(6, f);
};
/**
 * @enum {number}
 */ proto.domain.StatementAction.UserType = {
    CUSTOMER: 0,
    DEALER: 1
};
/**
 * @enum {number}
 */ proto.domain.StatementAction.ActionType = {
    CREATE: 0,
    UPDATE: 1,
    CANCEL: 2
};
/**
 * @enum {number}
 */ proto.domain.StatementAction.ActionReason = {
    DEALER_VEHICLE_NOT_AVAILABLE: 0,
    DEALER_VEHICLE_SELLING_PRICE_REJECTED: 1,
    DEALER_VEHICLE_SOLD: 2,
    CUSTOMER_VEHICLE_TOO_EXPENSIVE: 3,
    CUSTOMER_VEHICLE_DRIVE_NOT_AS_EXPECTED: 4,
    LINE_ITEM_ADDED: 5,
    TRANSACTION_ADDED: 6,
    ACTIVATION: 7
};
/**
 * optional string date = 1;
 * @return {string}
 */ proto.domain.StatementAction.prototype.getDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.StatementAction} returns this
 */ proto.domain.StatementAction.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string user_id = 2;
 * @return {string}
 */ proto.domain.StatementAction.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.StatementAction} returns this
 */ proto.domain.StatementAction.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional UserType user_type = 3;
 * @return {!proto.domain.StatementAction.UserType}
 */ proto.domain.StatementAction.prototype.getUserType = function() {
    return /** @type {!proto.domain.StatementAction.UserType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.StatementAction.UserType} value
 * @return {!proto.domain.StatementAction} returns this
 */ proto.domain.StatementAction.prototype.setUserType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional ActionType action_type = 4;
 * @return {!proto.domain.StatementAction.ActionType}
 */ proto.domain.StatementAction.prototype.getActionType = function() {
    return /** @type {!proto.domain.StatementAction.ActionType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.domain.StatementAction.ActionType} value
 * @return {!proto.domain.StatementAction} returns this
 */ proto.domain.StatementAction.prototype.setActionType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional ActionReason action_reason = 5;
 * @return {!proto.domain.StatementAction.ActionReason}
 */ proto.domain.StatementAction.prototype.getActionReason = function() {
    return /** @type {!proto.domain.StatementAction.ActionReason} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.domain.StatementAction.ActionReason} value
 * @return {!proto.domain.StatementAction} returns this
 */ proto.domain.StatementAction.prototype.setActionReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional string notes = 6;
 * @return {string}
 */ proto.domain.StatementAction.prototype.getNotes = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.StatementAction} returns this
 */ proto.domain.StatementAction.prototype.setNotes = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.LineItem.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.LineItem.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.LineItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.LineItem.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            title: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            balance: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            currency: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            itemType: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            product: (f = msg.getProduct()) && proto.domain.Product.toObject(includeInstance, f),
            promotionId: $8M67s.Message.getFieldWithDefault(msg, 9, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.LineItem}
 */ proto.domain.LineItem.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.LineItem;
    return proto.domain.LineItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.LineItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.LineItem}
 */ proto.domain.LineItem.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTitle(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBalance(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setCurrency(value);
                break;
            case 7:
                var value = /** @type {!proto.domain.LineItem.LineItemType} */ reader.readEnum();
                msg.setItemType(value);
                break;
            case 8:
                var value = new proto.domain.Product;
                reader.readMessage(value, proto.domain.Product.deserializeBinaryFromReader);
                msg.setProduct(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setPromotionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.LineItem.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.LineItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.LineItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.LineItem.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getTitle();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getBalance();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getCurrency();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getItemType();
    if (f !== 0.0) writer.writeEnum(7, f);
    f = message.getProduct();
    if (f != null) writer.writeMessage(8, f, proto.domain.Product.serializeBinaryToWriter);
    f = message.getPromotionId();
    if (f.length > 0) writer.writeString(9, f);
};
/**
 * @enum {number}
 */ proto.domain.LineItem.LineItemType = {
    PRODUCT: 0,
    START_PAYMENT: 1,
    TAX: 2,
    PAST_DUE: 3
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.LineItem.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 date = 2;
 * @return {number}
 */ proto.domain.LineItem.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string title = 3;
 * @return {string}
 */ proto.domain.LineItem.prototype.getTitle = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.setTitle = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 amount = 4;
 * @return {number}
 */ proto.domain.LineItem.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 balance = 5;
 * @return {number}
 */ proto.domain.LineItem.prototype.getBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.setBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string currency = 6;
 * @return {string}
 */ proto.domain.LineItem.prototype.getCurrency = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.setCurrency = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional LineItemType item_type = 7;
 * @return {!proto.domain.LineItem.LineItemType}
 */ proto.domain.LineItem.prototype.getItemType = function() {
    return /** @type {!proto.domain.LineItem.LineItemType} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.domain.LineItem.LineItemType} value
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.setItemType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional Product product = 8;
 * @return {?proto.domain.Product}
 */ proto.domain.LineItem.prototype.getProduct = function() {
    return /** @type{?proto.domain.Product} */ $8M67s.Message.getWrapperField(this, proto.domain.Product, 8);
};
/**
 * @param {?proto.domain.Product|undefined} value
 * @return {!proto.domain.LineItem} returns this
*/ proto.domain.LineItem.prototype.setProduct = function(value) {
    return $8M67s.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.clearProduct = function() {
    return this.setProduct(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.domain.LineItem.prototype.hasProduct = function() {
    return $8M67s.Message.getField(this, 8) != null;
};
/**
 * optional string promotion_id = 9;
 * @return {string}
 */ proto.domain.LineItem.prototype.getPromotionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.LineItem} returns this
 */ proto.domain.LineItem.prototype.setPromotionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Transaction.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Transaction.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Transaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Transaction.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            title: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            currency: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            paymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            gatewayTransactionId: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            transactionType: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            paymentMethodName: $8M67s.Message.getFieldWithDefault(msg, 10, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Transaction}
 */ proto.domain.Transaction.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Transaction;
    return proto.domain.Transaction.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Transaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Transaction}
 */ proto.domain.Transaction.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTitle(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCurrency(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodId(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setGatewayTransactionId(value);
                break;
            case 9:
                var value = /** @type {!proto.domain.Transaction.TransactionType} */ reader.readEnum();
                msg.setTransactionType(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Transaction.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Transaction.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Transaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Transaction.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getTitle();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getCurrency();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getPaymentMethodId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getGatewayTransactionId();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getTransactionType();
    if (f !== 0.0) writer.writeEnum(9, f);
    f = message.getPaymentMethodName();
    if (f.length > 0) writer.writeString(10, f);
};
/**
 * @enum {number}
 */ proto.domain.Transaction.TransactionType = {
    CAPTURE: 0,
    AUTH: 1,
    AUTH_RELEASE: 2,
    FAILED_AFTER_SETTLEMENT: 3
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.Transaction.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 date = 2;
 * @return {number}
 */ proto.domain.Transaction.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string title = 3;
 * @return {string}
 */ proto.domain.Transaction.prototype.getTitle = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setTitle = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 amount = 4;
 * @return {number}
 */ proto.domain.Transaction.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string currency = 5;
 * @return {string}
 */ proto.domain.Transaction.prototype.getCurrency = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setCurrency = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string payment_method_id = 6;
 * @return {string}
 */ proto.domain.Transaction.prototype.getPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string subscription_id = 7;
 * @return {string}
 */ proto.domain.Transaction.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string gateway_transaction_id = 8;
 * @return {string}
 */ proto.domain.Transaction.prototype.getGatewayTransactionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setGatewayTransactionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional TransactionType transaction_type = 9;
 * @return {!proto.domain.Transaction.TransactionType}
 */ proto.domain.Transaction.prototype.getTransactionType = function() {
    return /** @type {!proto.domain.Transaction.TransactionType} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {!proto.domain.Transaction.TransactionType} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setTransactionType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 9, value);
};
/**
 * optional string payment_method_name = 10;
 * @return {string}
 */ proto.domain.Transaction.prototype.getPaymentMethodName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Transaction} returns this
 */ proto.domain.Transaction.prototype.setPaymentMethodName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.PaymentMethod.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.PaymentMethod.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.PaymentMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.PaymentMethod.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            paymentType: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            gatewayId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            token: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            primary: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            secondary: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            gatewayCustomerId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            last4: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            brandCode: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            oneTimeUse: $8M67s.Message.getBooleanFieldWithDefault(msg, 12, false),
            isDeleted: $8M67s.Message.getBooleanFieldWithDefault(msg, 13, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.PaymentMethod}
 */ proto.domain.PaymentMethod.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.PaymentMethod;
    return proto.domain.PaymentMethod.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.PaymentMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.PaymentMethod}
 */ proto.domain.PaymentMethod.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.PaymentMethod.PaymentType} */ reader.readEnum();
                msg.setPaymentType(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setGatewayId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setToken(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPrimary(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSecondary(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setGatewayCustomerId(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setLast4(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setBrandCode(value);
                break;
            case 12:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setOneTimeUse(value);
                break;
            case 13:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsDeleted(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.PaymentMethod.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.PaymentMethod.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.PaymentMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.PaymentMethod.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getPaymentType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getGatewayId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getToken();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getPrimary();
    if (f) writer.writeBool(7, f);
    f = message.getSecondary();
    if (f) writer.writeBool(8, f);
    f = message.getGatewayCustomerId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getLast4();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getBrandCode();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getOneTimeUse();
    if (f) writer.writeBool(12, f);
    f = message.getIsDeleted();
    if (f) writer.writeBool(13, f);
};
/**
 * @enum {number}
 */ proto.domain.PaymentMethod.PaymentType = {
    ACH: 0,
    CREDIT_CARD: 1,
    DEBIT_CARD: 2
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.PaymentMethod.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.domain.PaymentMethod.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional PaymentType payment_type = 3;
 * @return {!proto.domain.PaymentMethod.PaymentType}
 */ proto.domain.PaymentMethod.prototype.getPaymentType = function() {
    return /** @type {!proto.domain.PaymentMethod.PaymentType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.PaymentMethod.PaymentType} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setPaymentType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string gateway_id = 4;
 * @return {string}
 */ proto.domain.PaymentMethod.prototype.getGatewayId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setGatewayId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string subscription_id = 5;
 * @return {string}
 */ proto.domain.PaymentMethod.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string token = 6;
 * @return {string}
 */ proto.domain.PaymentMethod.prototype.getToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional bool primary = 7;
 * @return {boolean}
 */ proto.domain.PaymentMethod.prototype.getPrimary = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setPrimary = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * optional bool secondary = 8;
 * @return {boolean}
 */ proto.domain.PaymentMethod.prototype.getSecondary = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setSecondary = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional string gateway_customer_id = 9;
 * @return {string}
 */ proto.domain.PaymentMethod.prototype.getGatewayCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setGatewayCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string last4 = 10;
 * @return {string}
 */ proto.domain.PaymentMethod.prototype.getLast4 = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setLast4 = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string brand_code = 11;
 * @return {string}
 */ proto.domain.PaymentMethod.prototype.getBrandCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setBrandCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional bool one_time_use = 12;
 * @return {boolean}
 */ proto.domain.PaymentMethod.prototype.getOneTimeUse = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 12, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setOneTimeUse = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 12, value);
};
/**
 * optional bool is_deleted = 13;
 * @return {boolean}
 */ proto.domain.PaymentMethod.prototype.getIsDeleted = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 13, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.PaymentMethod} returns this
 */ proto.domain.PaymentMethod.prototype.setIsDeleted = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 13, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Note.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Note.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Note} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Note.toObject = function(includeInstance, msg) {
        var f, obj = {
            date: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            body: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            user: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Note}
 */ proto.domain.Note.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Note;
    return proto.domain.Note.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Note} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Note}
 */ proto.domain.Note.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setBody(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Note.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Note.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Note} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Note.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDate();
    if (f !== 0) writer.writeInt64(1, f);
    f = message.getBody();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUser();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional int64 date = 1;
 * @return {number}
 */ proto.domain.Note.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Note} returns this
 */ proto.domain.Note.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string body = 2;
 * @return {string}
 */ proto.domain.Note.prototype.getBody = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Note} returns this
 */ proto.domain.Note.prototype.setBody = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string user = 3;
 * @return {string}
 */ proto.domain.Note.prototype.getUser = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Note} returns this
 */ proto.domain.Note.prototype.setUser = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Gateway.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Gateway.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Gateway} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Gateway.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            url: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Gateway}
 */ proto.domain.Gateway.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Gateway;
    return proto.domain.Gateway.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Gateway} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Gateway}
 */ proto.domain.Gateway.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setUrl(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Gateway.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Gateway.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Gateway} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Gateway.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUrl();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.Gateway.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Gateway} returns this
 */ proto.domain.Gateway.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.domain.Gateway.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Gateway} returns this
 */ proto.domain.Gateway.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string url = 3;
 * @return {string}
 */ proto.domain.Gateway.prototype.getUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Gateway} returns this
 */ proto.domain.Gateway.prototype.setUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.GatewayToken.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.GatewayToken.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.GatewayToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.GatewayToken.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            gatewayId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            token: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.GatewayToken}
 */ proto.domain.GatewayToken.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.GatewayToken;
    return proto.domain.GatewayToken.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.GatewayToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.GatewayToken}
 */ proto.domain.GatewayToken.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setGatewayId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setToken(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.GatewayToken.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.GatewayToken.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.GatewayToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.GatewayToken.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getGatewayId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getToken();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.domain.GatewayToken.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.GatewayToken} returns this
 */ proto.domain.GatewayToken.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string gateway_id = 2;
 * @return {string}
 */ proto.domain.GatewayToken.prototype.getGatewayId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.GatewayToken} returns this
 */ proto.domain.GatewayToken.prototype.setGatewayId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string token = 3;
 * @return {string}
 */ proto.domain.GatewayToken.prototype.getToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.GatewayToken} returns this
 */ proto.domain.GatewayToken.prototype.setToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Product.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Product.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Product} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Product.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            currency: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            productType: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            recurring: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            addOn: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Product}
 */ proto.domain.Product.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Product;
    return proto.domain.Product.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Product} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Product}
 */ proto.domain.Product.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCurrency(value);
                break;
            case 6:
                var value = /** @type {!proto.domain.Product.ProductType} */ reader.readEnum();
                msg.setProductType(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRecurring(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setAddOn(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Product.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Product.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Product} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Product.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getCurrency();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getProductType();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getRecurring();
    if (f) writer.writeBool(7, f);
    f = message.getAddOn();
    if (f) writer.writeBool(8, f);
};
/**
 * @enum {number}
 */ proto.domain.Product.ProductType = {
    NOTYPE: 0,
    RENT: 1,
    DEPOSIT: 2,
    TITLE_REG_DOC: 3,
    COL_AND_LI: 4,
    COL_AND_LI_DEDUCT: 5,
    EXM: 6,
    EWT: 7,
    MILEAGE: 8,
    WAITLIST_DEPOSIT: 9,
    LATE: 10,
    TOLL: 11,
    CITATION: 12,
    ADMINISTRATIVE: 13,
    DELIVERY: 14,
    PICKUP: 15,
    REPOSESSION: 16,
    DISPOSITION: 17,
    FLIP: 18,
    NSF: 19,
    IMPOUND: 20,
    SUBSCRIPTION_PRORATION: 21,
    START_FEE: 22,
    RECURRING_MILEAGE: 23,
    ONE_TIME_MILEAGE: 24,
    WHEEL_AND_TIRE_PROTECTION: 25
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.Product.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Product} returns this
 */ proto.domain.Product.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.domain.Product.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Product} returns this
 */ proto.domain.Product.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string description = 3;
 * @return {string}
 */ proto.domain.Product.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Product} returns this
 */ proto.domain.Product.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 amount = 4;
 * @return {number}
 */ proto.domain.Product.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Product} returns this
 */ proto.domain.Product.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string currency = 5;
 * @return {string}
 */ proto.domain.Product.prototype.getCurrency = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Product} returns this
 */ proto.domain.Product.prototype.setCurrency = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional ProductType product_type = 6;
 * @return {!proto.domain.Product.ProductType}
 */ proto.domain.Product.prototype.getProductType = function() {
    return /** @type {!proto.domain.Product.ProductType} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.domain.Product.ProductType} value
 * @return {!proto.domain.Product} returns this
 */ proto.domain.Product.prototype.setProductType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional bool recurring = 7;
 * @return {boolean}
 */ proto.domain.Product.prototype.getRecurring = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Product} returns this
 */ proto.domain.Product.prototype.setRecurring = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * optional bool add_on = 8;
 * @return {boolean}
 */ proto.domain.Product.prototype.getAddOn = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Product} returns this
 */ proto.domain.Product.prototype.setAddOn = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Dealership.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Dealership.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Dealership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Dealership.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            street: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            street2: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            city: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            state: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            postal: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            latitude: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            longitude: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            vehicleCount: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            dealershipstate: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            dealershipactivity: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            dealershipactivitystate: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            dealershiperrorstate: $8M67s.Message.getFieldWithDefault(msg, 15, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Dealership}
 */ proto.domain.Dealership.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Dealership;
    return proto.domain.Dealership.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Dealership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Dealership}
 */ proto.domain.Dealership.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setStreet(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setStreet2(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCity(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setState(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setPostal(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setLatitude(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setLongitude(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleCount(value);
                break;
            case 12:
                var value = /** @type {!proto.domain.Dealership.State} */ reader.readEnum();
                msg.setDealershipstate(value);
                break;
            case 13:
                var value = /** @type {!proto.domain.Dealership.Activity} */ reader.readEnum();
                msg.setDealershipactivity(value);
                break;
            case 14:
                var value = /** @type {!proto.domain.Dealership.ActivityState} */ reader.readEnum();
                msg.setDealershipactivitystate(value);
                break;
            case 15:
                var value = /** @type {!proto.domain.Dealership.ErrorState} */ reader.readEnum();
                msg.setDealershiperrorstate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Dealership.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Dealership.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Dealership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Dealership.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStreet();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getStreet2();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCity();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getState();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getPostal();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getLatitude();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getLongitude();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getVehicleCount();
    if (f !== 0) writer.writeInt32(11, f);
    f = message.getDealershipstate();
    if (f !== 0.0) writer.writeEnum(12, f);
    f = message.getDealershipactivity();
    if (f !== 0.0) writer.writeEnum(13, f);
    f = message.getDealershipactivitystate();
    if (f !== 0.0) writer.writeEnum(14, f);
    f = message.getDealershiperrorstate();
    if (f !== 0.0) writer.writeEnum(15, f);
};
/**
 * @enum {number}
 */ proto.domain.Dealership.State = {
    INACTIVE: 0,
    INVITED: 1,
    ONBOARDING: 2
};
/**
 * @enum {number}
 */ proto.domain.Dealership.Activity = {
    INVITE_DEALER: 0,
    PHONE_NUMBER_ENTRY: 1,
    USER_INFO_ENTRY: 2,
    ROLE_SELECTION: 3,
    ACH_INFO_ENTRY: 4,
    TEAM_MEMBERS_INVITE: 5,
    FINISH_ONBOARDING: 6
};
/**
 * @enum {number}
 */ proto.domain.Dealership.ActivityState = {
    DEALER_INACTIVE: 0,
    INVITATION_SENT: 1,
    PHONE_NUMBER_ENTERED: 2,
    PHONE_NUMBER_VERIFIED: 3,
    ACCOUNT_CREATED: 4,
    USER_INFO_ENTERED: 5,
    ROLE_SELECTED: 6,
    ACH_INFO_SUBMITTED: 7,
    TEAM_MEMBERS_INVITED: 8,
    ONBOARDING_COMPLETED: 9
};
/**
 * @enum {number}
 */ proto.domain.Dealership.ErrorState = {
    DEALER_NULL: 0,
    INVITATION_FAILED: 1,
    PHONE_VERIFICATION_FAILED: 2,
    ACCOUNT_CREATION_FAILED: 3,
    USER_INFO_SUBMISSION_FAILED: 4,
    ROLE_SELECTION_FAILED: 5,
    ACH_INFO_SUBMISSION_FAILED: 6,
    INVITE_TEAM_MEMBERS_FAILED: 7,
    ONBOARDING_COMPLETION_FAILED: 8
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.Dealership.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.domain.Dealership.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string street = 3;
 * @return {string}
 */ proto.domain.Dealership.prototype.getStreet = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setStreet = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string street2 = 4;
 * @return {string}
 */ proto.domain.Dealership.prototype.getStreet2 = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setStreet2 = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string city = 5;
 * @return {string}
 */ proto.domain.Dealership.prototype.getCity = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setCity = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string state = 6;
 * @return {string}
 */ proto.domain.Dealership.prototype.getState = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setState = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string postal = 7;
 * @return {string}
 */ proto.domain.Dealership.prototype.getPostal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setPostal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string phone_number = 8;
 * @return {string}
 */ proto.domain.Dealership.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string latitude = 9;
 * @return {string}
 */ proto.domain.Dealership.prototype.getLatitude = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setLatitude = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string longitude = 10;
 * @return {string}
 */ proto.domain.Dealership.prototype.getLongitude = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setLongitude = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional int32 vehicle_count = 11;
 * @return {number}
 */ proto.domain.Dealership.prototype.getVehicleCount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setVehicleCount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional State dealershipState = 12;
 * @return {!proto.domain.Dealership.State}
 */ proto.domain.Dealership.prototype.getDealershipstate = function() {
    return /** @type {!proto.domain.Dealership.State} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {!proto.domain.Dealership.State} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setDealershipstate = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 12, value);
};
/**
 * optional Activity dealershipActivity = 13;
 * @return {!proto.domain.Dealership.Activity}
 */ proto.domain.Dealership.prototype.getDealershipactivity = function() {
    return /** @type {!proto.domain.Dealership.Activity} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {!proto.domain.Dealership.Activity} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setDealershipactivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 13, value);
};
/**
 * optional ActivityState dealershipActivityState = 14;
 * @return {!proto.domain.Dealership.ActivityState}
 */ proto.domain.Dealership.prototype.getDealershipactivitystate = function() {
    return /** @type {!proto.domain.Dealership.ActivityState} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {!proto.domain.Dealership.ActivityState} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setDealershipactivitystate = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 14, value);
};
/**
 * optional ErrorState dealershipErrorState = 15;
 * @return {!proto.domain.Dealership.ErrorState}
 */ proto.domain.Dealership.prototype.getDealershiperrorstate = function() {
    return /** @type {!proto.domain.Dealership.ErrorState} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {!proto.domain.Dealership.ErrorState} value
 * @return {!proto.domain.Dealership} returns this
 */ proto.domain.Dealership.prototype.setDealershiperrorstate = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 15, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.TeamMember.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.TeamMember.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.TeamMember} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.TeamMember.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            cellPhone: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.TeamMember}
 */ proto.domain.TeamMember.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.TeamMember;
    return proto.domain.TeamMember.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.TeamMember} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.TeamMember}
 */ proto.domain.TeamMember.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCellPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.TeamMember.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.TeamMember.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.TeamMember} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.TeamMember.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCellPhone();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.domain.TeamMember.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.TeamMember} returns this
 */ proto.domain.TeamMember.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string first_name = 2;
 * @return {string}
 */ proto.domain.TeamMember.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.TeamMember} returns this
 */ proto.domain.TeamMember.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string last_name = 3;
 * @return {string}
 */ proto.domain.TeamMember.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.TeamMember} returns this
 */ proto.domain.TeamMember.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string cell_phone = 4;
 * @return {string}
 */ proto.domain.TeamMember.prototype.getCellPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.TeamMember} returns this
 */ proto.domain.TeamMember.prototype.setCellPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.domain.DealerUser.repeatedFields_ = [
    6
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.DealerUser.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.DealerUser.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.DealerUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.DealerUser.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            cellPhone: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            workEmail: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            responsibilityList: (f = $8M67s.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
            nxcrInvitation: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            dealerAppInvitation: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            id: $8M67s.Message.getFieldWithDefault(msg, 9, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.DealerUser}
 */ proto.domain.DealerUser.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.DealerUser;
    return proto.domain.DealerUser.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.DealerUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.DealerUser}
 */ proto.domain.DealerUser.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCellPhone(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setWorkEmail(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.addResponsibility(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setNxcrInvitation(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDealerAppInvitation(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.DealerUser.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.DealerUser.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.DealerUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.DealerUser.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCellPhone();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getWorkEmail();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getResponsibilityList();
    if (f.length > 0) writer.writeRepeatedString(6, f);
    f = message.getNxcrInvitation();
    if (f) writer.writeBool(7, f);
    f = message.getDealerAppInvitation();
    if (f) writer.writeBool(8, f);
    f = message.getId();
    if (f.length > 0) writer.writeString(9, f);
};
/**
 * optional string dealership_id = 1;
 * @return {string}
 */ proto.domain.DealerUser.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string first_name = 2;
 * @return {string}
 */ proto.domain.DealerUser.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string last_name = 3;
 * @return {string}
 */ proto.domain.DealerUser.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string cell_phone = 4;
 * @return {string}
 */ proto.domain.DealerUser.prototype.getCellPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setCellPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string work_email = 5;
 * @return {string}
 */ proto.domain.DealerUser.prototype.getWorkEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setWorkEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * repeated string responsibility = 6;
 * @return {!Array<string>}
 */ proto.domain.DealerUser.prototype.getResponsibilityList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 6);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setResponsibilityList = function(value) {
    return $8M67s.Message.setField(this, 6, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.addResponsibility = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 6, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.clearResponsibilityList = function() {
    return this.setResponsibilityList([]);
};
/**
 * optional bool nxcr_invitation = 7;
 * @return {boolean}
 */ proto.domain.DealerUser.prototype.getNxcrInvitation = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setNxcrInvitation = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * optional bool dealer_app_invitation = 8;
 * @return {boolean}
 */ proto.domain.DealerUser.prototype.getDealerAppInvitation = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setDealerAppInvitation = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional string id = 9;
 * @return {string}
 */ proto.domain.DealerUser.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.DealerUser} returns this
 */ proto.domain.DealerUser.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.Appointment.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.Appointment.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.Appointment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Appointment.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            scheduledFor: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            stockNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            id: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            dealStatus: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            insuranceLinked: $8M67s.Message.getBooleanFieldWithDefault(msg, 6, false),
            licenseScanned: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            appointmentType: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            inspectionComplete: $8M67s.Message.getBooleanFieldWithDefault(msg, 12, false),
            contractSigned: $8M67s.Message.getBooleanFieldWithDefault(msg, 13, false),
            contractSubmitted: $8M67s.Message.getBooleanFieldWithDefault(msg, 14, false),
            subscriptionActivated: $8M67s.Message.getBooleanFieldWithDefault(msg, 15, false),
            received: $8M67s.Message.getFieldWithDefault(msg, 16, ""),
            updatedAt: $8M67s.Message.getFieldWithDefault(msg, 17, ""),
            pickupConfirmed: $8M67s.Message.getBooleanFieldWithDefault(msg, 18, false),
            paymentComplete: $8M67s.Message.getBooleanFieldWithDefault(msg, 19, false),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 20, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.Appointment}
 */ proto.domain.Appointment.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.Appointment;
    return proto.domain.Appointment.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.Appointment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.Appointment}
 */ proto.domain.Appointment.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setScheduledFor(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setStockNumber(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 5:
                var value = /** @type {!proto.domain.Appointment.Status} */ reader.readEnum();
                msg.setDealStatus(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setInsuranceLinked(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setLicenseScanned(value);
                break;
            case 8:
                var value = /** @type {!proto.domain.Appointment.Type} */ reader.readEnum();
                msg.setAppointmentType(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 12:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setInspectionComplete(value);
                break;
            case 13:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setContractSigned(value);
                break;
            case 14:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setContractSubmitted(value);
                break;
            case 15:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSubscriptionActivated(value);
                break;
            case 16:
                var value = /** @type {string} */ reader.readString();
                msg.setReceived(value);
                break;
            case 17:
                var value = /** @type {string} */ reader.readString();
                msg.setUpdatedAt(value);
                break;
            case 18:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPickupConfirmed(value);
                break;
            case 19:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPaymentComplete(value);
                break;
            case 20:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.Appointment.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.Appointment.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.Appointment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.Appointment.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getScheduledFor();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStockNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getDealStatus();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getInsuranceLinked();
    if (f) writer.writeBool(6, f);
    f = message.getLicenseScanned();
    if (f) writer.writeBool(7, f);
    f = message.getAppointmentType();
    if (f !== 0.0) writer.writeEnum(8, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getInspectionComplete();
    if (f) writer.writeBool(12, f);
    f = message.getContractSigned();
    if (f) writer.writeBool(13, f);
    f = message.getContractSubmitted();
    if (f) writer.writeBool(14, f);
    f = message.getSubscriptionActivated();
    if (f) writer.writeBool(15, f);
    f = message.getReceived();
    if (f.length > 0) writer.writeString(16, f);
    f = message.getUpdatedAt();
    if (f.length > 0) writer.writeString(17, f);
    f = message.getPickupConfirmed();
    if (f) writer.writeBool(18, f);
    f = message.getPaymentComplete();
    if (f) writer.writeBool(19, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(20, f);
};
/**
 * @enum {number}
 */ proto.domain.Appointment.Status = {
    ACTIVE: 0,
    IN_PROGRESS: 1,
    COMPLETED: 2,
    CANCELED: 3
};
/**
 * @enum {number}
 */ proto.domain.Appointment.Type = {
    PICKUP: 0,
    TRANSPORT_DELIVERY: 1,
    DIRECT_DELIVERY: 2,
    DROP_OFF: 3
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.domain.Appointment.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string scheduled_for = 2;
 * @return {string}
 */ proto.domain.Appointment.prototype.getScheduledFor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setScheduledFor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string stock_number = 3;
 * @return {string}
 */ proto.domain.Appointment.prototype.getStockNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setStockNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string id = 4;
 * @return {string}
 */ proto.domain.Appointment.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional Status deal_status = 5;
 * @return {!proto.domain.Appointment.Status}
 */ proto.domain.Appointment.prototype.getDealStatus = function() {
    return /** @type {!proto.domain.Appointment.Status} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.domain.Appointment.Status} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setDealStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional bool insurance_linked = 6;
 * @return {boolean}
 */ proto.domain.Appointment.prototype.getInsuranceLinked = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setInsuranceLinked = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 6, value);
};
/**
 * optional bool license_scanned = 7;
 * @return {boolean}
 */ proto.domain.Appointment.prototype.getLicenseScanned = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setLicenseScanned = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * optional Type appointment_type = 8;
 * @return {!proto.domain.Appointment.Type}
 */ proto.domain.Appointment.prototype.getAppointmentType = function() {
    return /** @type {!proto.domain.Appointment.Type} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {!proto.domain.Appointment.Type} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setAppointmentType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 8, value);
};
/**
 * optional string subscription_id = 9;
 * @return {string}
 */ proto.domain.Appointment.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string customer_id = 10;
 * @return {string}
 */ proto.domain.Appointment.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string vehicle_id = 11;
 * @return {string}
 */ proto.domain.Appointment.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional bool inspection_complete = 12;
 * @return {boolean}
 */ proto.domain.Appointment.prototype.getInspectionComplete = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 12, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setInspectionComplete = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 12, value);
};
/**
 * optional bool contract_signed = 13;
 * @return {boolean}
 */ proto.domain.Appointment.prototype.getContractSigned = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 13, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setContractSigned = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 13, value);
};
/**
 * optional bool contract_submitted = 14;
 * @return {boolean}
 */ proto.domain.Appointment.prototype.getContractSubmitted = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 14, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setContractSubmitted = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 14, value);
};
/**
 * optional bool subscription_activated = 15;
 * @return {boolean}
 */ proto.domain.Appointment.prototype.getSubscriptionActivated = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 15, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setSubscriptionActivated = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 15, value);
};
/**
 * optional string received = 16;
 * @return {string}
 */ proto.domain.Appointment.prototype.getReceived = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 16, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setReceived = function(value) {
    return $8M67s.Message.setProto3StringField(this, 16, value);
};
/**
 * optional string updated_at = 17;
 * @return {string}
 */ proto.domain.Appointment.prototype.getUpdatedAt = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 17, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setUpdatedAt = function(value) {
    return $8M67s.Message.setProto3StringField(this, 17, value);
};
/**
 * optional bool pickup_confirmed = 18;
 * @return {boolean}
 */ proto.domain.Appointment.prototype.getPickupConfirmed = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 18, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setPickupConfirmed = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 18, value);
};
/**
 * optional bool payment_complete = 19;
 * @return {boolean}
 */ proto.domain.Appointment.prototype.getPaymentComplete = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 19, false);
};
/**
 * @param {boolean} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setPaymentComplete = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 19, value);
};
/**
 * optional string account_number = 20;
 * @return {string}
 */ proto.domain.Appointment.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 20, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.Appointment} returns this
 */ proto.domain.Appointment.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 20, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.AutonomyUser.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.AutonomyUser.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.AutonomyUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.AutonomyUser.toObject = function(includeInstance, msg) {
        var f, obj = {
            userId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            userEmail: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            userType: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            userPhone: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.AutonomyUser}
 */ proto.domain.AutonomyUser.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.AutonomyUser;
    return proto.domain.AutonomyUser.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.AutonomyUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.AutonomyUser}
 */ proto.domain.AutonomyUser.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUserEmail(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.AutonomyUser.UserType} */ reader.readEnum();
                msg.setUserType(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setUserPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.AutonomyUser.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.AutonomyUser.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.AutonomyUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.AutonomyUser.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getUserEmail();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUserType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getUserPhone();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * @enum {number}
 */ proto.domain.AutonomyUser.UserType = {
    NEXUS: 0,
    CUSTOMER: 1,
    DEALER: 2,
    SYSTEM: 3,
    VENDOR: 4
};
/**
 * optional string user_id = 1;
 * @return {string}
 */ proto.domain.AutonomyUser.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AutonomyUser} returns this
 */ proto.domain.AutonomyUser.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string user_email = 2;
 * @return {string}
 */ proto.domain.AutonomyUser.prototype.getUserEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AutonomyUser} returns this
 */ proto.domain.AutonomyUser.prototype.setUserEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional UserType user_type = 3;
 * @return {!proto.domain.AutonomyUser.UserType}
 */ proto.domain.AutonomyUser.prototype.getUserType = function() {
    return /** @type {!proto.domain.AutonomyUser.UserType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.AutonomyUser.UserType} value
 * @return {!proto.domain.AutonomyUser} returns this
 */ proto.domain.AutonomyUser.prototype.setUserType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string user_phone = 4;
 * @return {string}
 */ proto.domain.AutonomyUser.prototype.getUserPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AutonomyUser} returns this
 */ proto.domain.AutonomyUser.prototype.setUserPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.domain.AppointmentVehicle.prototype.toObject = function(opt_includeInstance) {
        return proto.domain.AppointmentVehicle.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.domain.AppointmentVehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.AppointmentVehicle.toObject = function(includeInstance, msg) {
        var f, obj = {
            vin: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            transmission: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            bodyType: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            exteriorColor: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            interiorColor: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            drivetrain: $8M67s.Message.getFieldWithDefault(msg, 10, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.domain.AppointmentVehicle}
 */ proto.domain.AppointmentVehicle.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.domain.AppointmentVehicle;
    return proto.domain.AppointmentVehicle.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.domain.AppointmentVehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.domain.AppointmentVehicle}
 */ proto.domain.AppointmentVehicle.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setTransmission(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setBodyType(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setExteriorColor(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setInteriorColor(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setDrivetrain(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.domain.AppointmentVehicle.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.domain.AppointmentVehicle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.domain.AppointmentVehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.domain.AppointmentVehicle.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVin();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getTransmission();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getBodyType();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getExteriorColor();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getInteriorColor();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getDrivetrain();
    if (f.length > 0) writer.writeString(10, f);
};
/**
 * optional string vin = 1;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string make = 2;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string model = 3;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string year = 4;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string trim = 5;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string transmission = 6;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getTransmission = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setTransmission = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string body_type = 7;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getBodyType = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setBodyType = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string exterior_color = 8;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getExteriorColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setExteriorColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string interior_color = 9;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getInteriorColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setInteriorColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string drivetrain = 10;
 * @return {string}
 */ proto.domain.AppointmentVehicle.prototype.getDrivetrain = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.domain.AppointmentVehicle} returns this
 */ proto.domain.AppointmentVehicle.prototype.setDrivetrain = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * @enum {number}
 */ proto.domain.Domain = {
    SYSTEM: 0,
    VENDOR: 1,
    CUSTOMER: 2,
    SUBSCRIPTION: 3,
    FLEET: 4,
    INSURANCE: 5,
    DEALER: 6,
    NOTIFICATION: 7,
    RESERVATION: 8,
    PROGRAM: 9,
    PROMOTION: 10,
    APPOINTMENT: 11
};
/**
 * @enum {number}
 */ proto.domain.CustomerState = {
    ACCOUNT_PENDING: 0,
    ACCOUNT_CREATED: 1,
    PENDING_SECURITY_DEPOSIT: 2,
    SECURITY_DEPOSIT_COMPLETE: 3,
    PICKUP_SCHEDULED: 4,
    PENDING_PAYMENT_METHODS: 5,
    PENDING_INSURANCE: 6,
    PENDING_PICKUP: 7,
    PENDING_INSPECTION: 8,
    PENDING_SIGNATURE: 9,
    SUBSCRIPTION_ACTIVATION: 10
};
/**
 * @enum {number}
 */ proto.domain.CustomerErrorState = {
    NO_ERROR: 0,
    OTP_FAIL: 1,
    LICENSE_SCAN_FAILURE: 2,
    GARAGING_ADDRESS_FAILURE: 3,
    PAYMENT_ADDITION_FAILURE: 4,
    SECURITY_DEPOSIT_FAILURE: 5,
    PICKUP_DATE_UNAVAILABLE: 6,
    ADD_ONS_FAILURE: 7,
    INSURANCE_LINK_FAILURE: 8,
    INSURANCE_SELECTION_FAILURE: 9,
    QR_CODE_FAILURE: 10,
    INSPECTION_FAILURE: 11,
    PICKUP_REJECTION: 12,
    ACTIVATION_FAILURE: 13,
    VEHICLE_TRANSFER_FAILURE: 14,
    CONTRACT_FAILURE: 15
};
/**
 * @enum {number}
 */ proto.domain.CustomerFailureState = {
    NONE: 0,
    FRAUDULENT_PHONE: 1,
    FRAUDULENT_LICENSE: 2,
    FRAUDULENT_IDENTITY: 3,
    FRAUDULENT_EMAIL: 4,
    INELIGIBLE_USER: 5
};
/**
 * @enum {number}
 */ proto.domain.CustomerActivity = {
    PHONE_NUMBER_ENTRY: 0,
    OTP_ENTRY: 1,
    LICENSE_SCAN: 2,
    GARAGING_ADDRESS: 3,
    SELFIE_DEPRECATED: 4,
    EMAIL_ENTRY: 5,
    APPROVAL: 6,
    SECURITY_DEPOSIT: 7,
    SCHEDULE_PICKUP: 8,
    ADD_RECURRING_PAYMENT: 9,
    ADD_BACKUP_PAYMENT: 10,
    SELECT_ADD_ONS: 11,
    SELECT_INSURANCE: 12,
    GENERATE_QR_CODE: 13,
    CONDUCT_INSPECTION: 14,
    CONFIRM_PICKUP: 15,
    DIGITAL_SIGNATURE: 16,
    SUBMIT_CONTRACTS: 17
};
/**
 * @enum {number}
 */ proto.domain.ActivityState = {
    NEW: 0,
    PHONE_ENTERED: 1,
    OTP_SENT: 2,
    OTP_SUCCESS: 3,
    LICENSE_SCANNED: 4,
    GARAGING_ADDRESS_ADDED: 5,
    GARAGING_ADDRESS_CONFIRMED: 6,
    SELFIE_CAPTURED: 7,
    EMAIL_ENTERED: 8,
    EMAIL_VERIFIED: 9,
    ELIGIBLE_USER: 10,
    SECURITY_PAYMENT_METHOD_ADDED: 11,
    SECURITY_DEPOSIT_RECEIVED: 12,
    PENDING_PICKUP_DATE: 13,
    PICKUP_DATE_SELECTED: 14,
    PICKUP_DATE_CONFIRMED: 15,
    ACH_LINKED: 16,
    AUTOPAY_ENABLED: 17,
    BACKUP_PAYMENT_LINKED: 18,
    ADD_ONS_SELECTED: 19,
    ADD_ONS_CONFIRMED: 20,
    INSURANCE_SELECTED: 21,
    INSURANCE_LINKED: 22,
    QR_CODE_GENERATED: 23,
    INSPECTION_IN_PROGRESS: 24,
    INSPECTION_COMPLETE: 25,
    PICKUP_CONFIRMED: 26,
    CONTRACTS_SIGNED: 27,
    CONTRACTS_SUBMITTED: 28,
    START_PAYMENT_SUCCESS: 39,
    RECURRING_PAYMENT_SUCCESS: 30,
    SUBSCRIPTION_ACTIVATED: 31,
    VEHICLE_IN_FLEET: 32,
    SUBSCRIPTION_CANCELLED: 33,
    RESERVATION_CANCELLED: 34
};
/**
 * @enum {number}
 */ proto.domain.QualificationTier = {
    QUALIFICATION_PENDING: 0,
    DISQUALIFIED: 1,
    TIER_1: 2,
    TIER_2: 3,
    TIER_3: 4,
    THIN_FILE: 5,
    BORDERLINE_FICO: 6,
    NO_HIT: 7,
    LIQUIDITY_GENERIC: 8,
    ERROR: 10,
    NEEDS_REVIEW: 11,
    DISQUALIFIED_MANUAL: 12,
    TIER_1_MANUAL: 13,
    TIER_2_MANUAL: 14,
    TIER_3_MANUAL: 15
};
/**
 * @enum {number}
 */ proto.domain.DisqualificationReason = {
    IDENTITY: 0,
    FRAUD: 1,
    BACKGROUND: 2,
    FICO: 3,
    MVR: 4,
    LIQUIDITY: 5
};
/**
 * @enum {number}
 */ proto.domain.QualificationOrigin = {
    ORIGINAL: 0,
    VALIDATION: 1,
    OVERRIDE: 2
};
/**
 * @enum {number}
 */ proto.domain.ImageType = {
    LICENSE_FRONT: 0,
    LICENSE_BACK: 1,
    SELFIE: 2,
    INSURANCE_CARD: 3,
    VEHICLE_INSPECTION: 4
};
/**
 * @enum {number}
 */ proto.domain.StatementStatus = {
    PENDING: 0,
    DUE: 1,
    PAID: 2,
    OVERDUE: 3,
    CANCELLED: 4,
    FAILED: 5
};
$2ccb0a253ca902ee$var$goog.object.extend(module.exports, proto.domain);

});

parcelRegister("gQESC", function(module, exports) {
// source: insurance.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $c441369a25bd3944$var$goog = $8M67s;
var $c441369a25bd3944$var$global = Function('return this')();
$c441369a25bd3944$var$goog.exportSymbol('proto.insurance.AdditionalDriver', null, $c441369a25bd3944$var$global);
$c441369a25bd3944$var$goog.exportSymbol('proto.insurance.Claim', null, $c441369a25bd3944$var$global);
$c441369a25bd3944$var$goog.exportSymbol('proto.insurance.Driver', null, $c441369a25bd3944$var$global);
$c441369a25bd3944$var$goog.exportSymbol('proto.insurance.Policy', null, $c441369a25bd3944$var$global);
$c441369a25bd3944$var$goog.exportSymbol('proto.insurance.PolicyStatus', null, $c441369a25bd3944$var$global);
$c441369a25bd3944$var$goog.exportSymbol('proto.insurance.Quote', null, $c441369a25bd3944$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance.Quote = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$c441369a25bd3944$var$goog.inherits(proto.insurance.Quote, $8M67s.Message);
if ($c441369a25bd3944$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance.Quote.displayName = 'proto.insurance.Quote';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance.Policy = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$c441369a25bd3944$var$goog.inherits(proto.insurance.Policy, $8M67s.Message);
if ($c441369a25bd3944$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance.Policy.displayName = 'proto.insurance.Policy';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance.Claim = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$c441369a25bd3944$var$goog.inherits(proto.insurance.Claim, $8M67s.Message);
if ($c441369a25bd3944$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance.Claim.displayName = 'proto.insurance.Claim';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance.AdditionalDriver = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$c441369a25bd3944$var$goog.inherits(proto.insurance.AdditionalDriver, $8M67s.Message);
if ($c441369a25bd3944$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance.AdditionalDriver.displayName = 'proto.insurance.AdditionalDriver';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.insurance.Driver = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$c441369a25bd3944$var$goog.inherits(proto.insurance.Driver, $8M67s.Message);
if ($c441369a25bd3944$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.insurance.Driver.displayName = 'proto.insurance.Driver';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance.Quote.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance.Quote.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance.Quote} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.Quote.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance.Quote}
 */ proto.insurance.Quote.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance.Quote;
    return proto.insurance.Quote.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance.Quote} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance.Quote}
 */ proto.insurance.Quote.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance.Quote.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance.Quote.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance.Quote} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.Quote.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.insurance.Quote.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.Quote} returns this
 */ proto.insurance.Quote.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance.Policy.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance.Policy.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance.Policy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.Policy.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            policyurl: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance.Policy}
 */ proto.insurance.Policy.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance.Policy;
    return proto.insurance.Policy.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance.Policy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance.Policy}
 */ proto.insurance.Policy.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPolicyurl(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance.Policy.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance.Policy.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance.Policy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.Policy.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPolicyurl();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.insurance.Policy.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.Policy} returns this
 */ proto.insurance.Policy.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string policyUrl = 2;
 * @return {string}
 */ proto.insurance.Policy.prototype.getPolicyurl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.Policy} returns this
 */ proto.insurance.Policy.prototype.setPolicyurl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance.Claim.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance.Claim.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance.Claim} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.Claim.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance.Claim}
 */ proto.insurance.Claim.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance.Claim;
    return proto.insurance.Claim.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance.Claim} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance.Claim}
 */ proto.insurance.Claim.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance.Claim.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance.Claim.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance.Claim} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.Claim.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.insurance.Claim.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.Claim} returns this
 */ proto.insurance.Claim.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance.AdditionalDriver.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance.AdditionalDriver.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance.AdditionalDriver} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.AdditionalDriver.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            dateOfBirth: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            externalId: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance.AdditionalDriver.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance.AdditionalDriver;
    return proto.insurance.AdditionalDriver.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance.AdditionalDriver} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance.AdditionalDriver}
 */ proto.insurance.AdditionalDriver.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDateOfBirth(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setExternalId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance.AdditionalDriver.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance.AdditionalDriver.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance.AdditionalDriver} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.AdditionalDriver.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDateOfBirth();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getExternalId();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.insurance.AdditionalDriver.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.AdditionalDriver} returns this
 */ proto.insurance.AdditionalDriver.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string first_name = 2;
 * @return {string}
 */ proto.insurance.AdditionalDriver.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.AdditionalDriver} returns this
 */ proto.insurance.AdditionalDriver.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string last_name = 3;
 * @return {string}
 */ proto.insurance.AdditionalDriver.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.AdditionalDriver} returns this
 */ proto.insurance.AdditionalDriver.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string date_of_birth = 4;
 * @return {string}
 */ proto.insurance.AdditionalDriver.prototype.getDateOfBirth = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.AdditionalDriver} returns this
 */ proto.insurance.AdditionalDriver.prototype.setDateOfBirth = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 external_id = 5;
 * @return {number}
 */ proto.insurance.AdditionalDriver.prototype.getExternalId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance.AdditionalDriver} returns this
 */ proto.insurance.AdditionalDriver.prototype.setExternalId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.insurance.Driver.prototype.toObject = function(opt_includeInstance) {
        return proto.insurance.Driver.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.insurance.Driver} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.Driver.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            dateOfBirth: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            externalId: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            isprimary: $8M67s.Message.getBooleanFieldWithDefault(msg, 6, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.insurance.Driver}
 */ proto.insurance.Driver.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.insurance.Driver;
    return proto.insurance.Driver.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.insurance.Driver} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.insurance.Driver}
 */ proto.insurance.Driver.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDateOfBirth(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setExternalId(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsprimary(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.insurance.Driver.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.insurance.Driver.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.insurance.Driver} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.insurance.Driver.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDateOfBirth();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getExternalId();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getIsprimary();
    if (f) writer.writeBool(6, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.insurance.Driver.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.Driver} returns this
 */ proto.insurance.Driver.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string first_name = 2;
 * @return {string}
 */ proto.insurance.Driver.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.Driver} returns this
 */ proto.insurance.Driver.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string last_name = 3;
 * @return {string}
 */ proto.insurance.Driver.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.Driver} returns this
 */ proto.insurance.Driver.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string date_of_birth = 4;
 * @return {string}
 */ proto.insurance.Driver.prototype.getDateOfBirth = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.insurance.Driver} returns this
 */ proto.insurance.Driver.prototype.setDateOfBirth = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 external_id = 5;
 * @return {number}
 */ proto.insurance.Driver.prototype.getExternalId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.insurance.Driver} returns this
 */ proto.insurance.Driver.prototype.setExternalId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional bool isPrimary = 6;
 * @return {boolean}
 */ proto.insurance.Driver.prototype.getIsprimary = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.insurance.Driver} returns this
 */ proto.insurance.Driver.prototype.setIsprimary = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 6, value);
};
/**
 * @enum {number}
 */ proto.insurance.PolicyStatus = {
    NOT_BOUND: 0,
    BOUND: 1,
    CANCELLED: 2
};
$c441369a25bd3944$var$goog.object.extend(module.exports, proto.insurance);

});


parcelRegister("dsvHa", function(module, exports) {
// source: nexus_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $9cc679ea19110e37$var$goog = $8M67s;
var $9cc679ea19110e37$var$global = Function('return this')();

var $fcTGK = parcelRequire("fcTGK");
$9cc679ea19110e37$var$goog.object.extend(proto, $fcTGK);

var $7QrRI = parcelRequire("7QrRI");
$9cc679ea19110e37$var$goog.object.extend(proto, $7QrRI);

var $26u10 = parcelRequire("26u10");
$9cc679ea19110e37$var$goog.object.extend(proto, $26u10);

var $6EauF = parcelRequire("6EauF");
$9cc679ea19110e37$var$goog.object.extend(proto, $6EauF);

var $1oiLe = parcelRequire("1oiLe");
$9cc679ea19110e37$var$goog.object.extend(proto, $1oiLe);

var $dFFtz = parcelRequire("dFFtz");
$9cc679ea19110e37$var$goog.object.extend(proto, $dFFtz);

var $3QqPt = parcelRequire("3QqPt");
$9cc679ea19110e37$var$goog.object.extend(proto, $3QqPt);

var $3EyMN = parcelRequire("3EyMN");
$9cc679ea19110e37$var$goog.object.extend(proto, $3EyMN);

var $ghA5X = parcelRequire("ghA5X");
$9cc679ea19110e37$var$goog.object.extend(proto, $ghA5X);

var $9HeMJ = parcelRequire("9HeMJ");
$9cc679ea19110e37$var$goog.object.extend(proto, $9HeMJ);

var $aqwEO = parcelRequire("aqwEO");
$9cc679ea19110e37$var$goog.object.extend(proto, $aqwEO);

var $9c7Du = parcelRequire("9c7Du");
$9cc679ea19110e37$var$goog.object.extend(proto, $9c7Du);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.AddCustomerNoteRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.AddCustomerNoteResponse', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.AppointmentDay', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.ConvertToGalpinTeslaRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.ConvertToGalpinTeslaResponse', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.Customer', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetCustomerImagesRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetCustomerNotesRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetCustomerNotesResponse', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetCustomerNotesResponse.Note', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetCustomerRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetCustomerResponse', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetLatestCustodyRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetLatestCustodyRequest.CustodyType', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetLatestCustodyResponse', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetLatestCustodyResponse.CustodianCase', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetVehicleMapRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.GetVehicleMapResponse', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.ListAppointmentsRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.ListAppointmentsResponse', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.MapVehicle', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.NexusListProgramPricingRequest', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.Subscription', null, $9cc679ea19110e37$var$global);
$9cc679ea19110e37$var$goog.exportSymbol('proto.nexus_service.Vehicle', null, $9cc679ea19110e37$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.AddCustomerNoteRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.AddCustomerNoteRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.AddCustomerNoteRequest.displayName = 'proto.nexus_service.AddCustomerNoteRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.AddCustomerNoteResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.AddCustomerNoteResponse, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.AddCustomerNoteResponse.displayName = 'proto.nexus_service.AddCustomerNoteResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetCustomerNotesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetCustomerNotesRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetCustomerNotesRequest.displayName = 'proto.nexus_service.GetCustomerNotesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetCustomerNotesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.nexus_service.GetCustomerNotesResponse.repeatedFields_, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetCustomerNotesResponse, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetCustomerNotesResponse.displayName = 'proto.nexus_service.GetCustomerNotesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetCustomerNotesResponse.Note = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetCustomerNotesResponse.Note, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetCustomerNotesResponse.Note.displayName = 'proto.nexus_service.GetCustomerNotesResponse.Note';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.Customer = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.Customer, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.Customer.displayName = 'proto.nexus_service.Customer';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.Vehicle = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.Vehicle, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.Vehicle.displayName = 'proto.nexus_service.Vehicle';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.Subscription = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.Subscription, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.Subscription.displayName = 'proto.nexus_service.Subscription';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetCustomerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetCustomerRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetCustomerRequest.displayName = 'proto.nexus_service.GetCustomerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetCustomerResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetCustomerResponse, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetCustomerResponse.displayName = 'proto.nexus_service.GetCustomerResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetCustomerImagesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetCustomerImagesRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetCustomerImagesRequest.displayName = 'proto.nexus_service.GetCustomerImagesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetVehicleMapRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetVehicleMapRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetVehicleMapRequest.displayName = 'proto.nexus_service.GetVehicleMapRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetVehicleMapResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.nexus_service.GetVehicleMapResponse.repeatedFields_, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetVehicleMapResponse, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetVehicleMapResponse.displayName = 'proto.nexus_service.GetVehicleMapResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.MapVehicle = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.MapVehicle, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.MapVehicle.displayName = 'proto.nexus_service.MapVehicle';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetLatestCustodyRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetLatestCustodyRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetLatestCustodyRequest.displayName = 'proto.nexus_service.GetLatestCustodyRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.GetLatestCustodyResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.nexus_service.GetLatestCustodyResponse.oneofGroups_);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.GetLatestCustodyResponse, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.GetLatestCustodyResponse.displayName = 'proto.nexus_service.GetLatestCustodyResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.NexusListProgramPricingRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.NexusListProgramPricingRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.NexusListProgramPricingRequest.displayName = 'proto.nexus_service.NexusListProgramPricingRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.ConvertToGalpinTeslaRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.ConvertToGalpinTeslaRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.ConvertToGalpinTeslaRequest.displayName = 'proto.nexus_service.ConvertToGalpinTeslaRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.ConvertToGalpinTeslaResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.ConvertToGalpinTeslaResponse, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.ConvertToGalpinTeslaResponse.displayName = 'proto.nexus_service.ConvertToGalpinTeslaResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.ListAppointmentsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.ListAppointmentsRequest, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.ListAppointmentsRequest.displayName = 'proto.nexus_service.ListAppointmentsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.AppointmentDay = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.nexus_service.AppointmentDay.repeatedFields_, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.AppointmentDay, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.AppointmentDay.displayName = 'proto.nexus_service.AppointmentDay';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.nexus_service.ListAppointmentsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.nexus_service.ListAppointmentsResponse.repeatedFields_, null);
};
$9cc679ea19110e37$var$goog.inherits(proto.nexus_service.ListAppointmentsResponse, $8M67s.Message);
if ($9cc679ea19110e37$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.nexus_service.ListAppointmentsResponse.displayName = 'proto.nexus_service.ListAppointmentsResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.AddCustomerNoteRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.AddCustomerNoteRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.AddCustomerNoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.AddCustomerNoteRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            noteText: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.AddCustomerNoteRequest}
 */ proto.nexus_service.AddCustomerNoteRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.AddCustomerNoteRequest;
    return proto.nexus_service.AddCustomerNoteRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.AddCustomerNoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.AddCustomerNoteRequest}
 */ proto.nexus_service.AddCustomerNoteRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setNoteText(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.AddCustomerNoteRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.AddCustomerNoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.AddCustomerNoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.AddCustomerNoteRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getNoteText();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.nexus_service.AddCustomerNoteRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.AddCustomerNoteRequest} returns this
 */ proto.nexus_service.AddCustomerNoteRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string note_text = 2;
 * @return {string}
 */ proto.nexus_service.AddCustomerNoteRequest.prototype.getNoteText = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.AddCustomerNoteRequest} returns this
 */ proto.nexus_service.AddCustomerNoteRequest.prototype.setNoteText = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.AddCustomerNoteResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.AddCustomerNoteResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.AddCustomerNoteResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.AddCustomerNoteResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.AddCustomerNoteResponse}
 */ proto.nexus_service.AddCustomerNoteResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.AddCustomerNoteResponse;
    return proto.nexus_service.AddCustomerNoteResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.AddCustomerNoteResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.AddCustomerNoteResponse}
 */ proto.nexus_service.AddCustomerNoteResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.AddCustomerNoteResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.AddCustomerNoteResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.AddCustomerNoteResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.AddCustomerNoteResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetCustomerNotesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetCustomerNotesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetCustomerNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerNotesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetCustomerNotesRequest}
 */ proto.nexus_service.GetCustomerNotesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetCustomerNotesRequest;
    return proto.nexus_service.GetCustomerNotesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetCustomerNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetCustomerNotesRequest}
 */ proto.nexus_service.GetCustomerNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetCustomerNotesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetCustomerNotesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetCustomerNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerNotesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.nexus_service.GetCustomerNotesRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetCustomerNotesRequest} returns this
 */ proto.nexus_service.GetCustomerNotesRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.nexus_service.GetCustomerNotesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetCustomerNotesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetCustomerNotesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetCustomerNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerNotesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            notesList: $8M67s.Message.toObjectList(msg.getNotesList(), proto.nexus_service.GetCustomerNotesResponse.Note.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetCustomerNotesResponse}
 */ proto.nexus_service.GetCustomerNotesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetCustomerNotesResponse;
    return proto.nexus_service.GetCustomerNotesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetCustomerNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetCustomerNotesResponse}
 */ proto.nexus_service.GetCustomerNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.nexus_service.GetCustomerNotesResponse.Note;
                reader.readMessage(value, proto.nexus_service.GetCustomerNotesResponse.Note.deserializeBinaryFromReader);
                msg.addNotes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetCustomerNotesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetCustomerNotesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetCustomerNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerNotesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNotesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.nexus_service.GetCustomerNotesResponse.Note.serializeBinaryToWriter);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetCustomerNotesResponse.Note.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetCustomerNotesResponse.Note} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerNotesResponse.Note.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            id: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            authorEmail: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            noteText: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetCustomerNotesResponse.Note}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetCustomerNotesResponse.Note;
    return proto.nexus_service.GetCustomerNotesResponse.Note.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetCustomerNotesResponse.Note} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetCustomerNotesResponse.Note}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAuthorEmail(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setNoteText(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetCustomerNotesResponse.Note.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetCustomerNotesResponse.Note} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerNotesResponse.Note.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getAuthorEmail();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getNoteText();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetCustomerNotesResponse.Note} returns this
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string id = 2;
 * @return {string}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetCustomerNotesResponse.Note} returns this
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 timestamp = 3;
 * @return {number}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.GetCustomerNotesResponse.Note} returns this
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string author_email = 4;
 * @return {string}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.getAuthorEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetCustomerNotesResponse.Note} returns this
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.setAuthorEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string note_text = 5;
 * @return {string}
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.getNoteText = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetCustomerNotesResponse.Note} returns this
 */ proto.nexus_service.GetCustomerNotesResponse.Note.prototype.setNoteText = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * repeated Note notes = 1;
 * @return {!Array<!proto.nexus_service.GetCustomerNotesResponse.Note>}
 */ proto.nexus_service.GetCustomerNotesResponse.prototype.getNotesList = function() {
    return /** @type{!Array<!proto.nexus_service.GetCustomerNotesResponse.Note>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.nexus_service.GetCustomerNotesResponse.Note, 1);
};
/**
 * @param {!Array<!proto.nexus_service.GetCustomerNotesResponse.Note>} value
 * @return {!proto.nexus_service.GetCustomerNotesResponse} returns this
*/ proto.nexus_service.GetCustomerNotesResponse.prototype.setNotesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.nexus_service.GetCustomerNotesResponse.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nexus_service.GetCustomerNotesResponse.Note}
 */ proto.nexus_service.GetCustomerNotesResponse.prototype.addNotes = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nexus_service.GetCustomerNotesResponse.Note, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nexus_service.GetCustomerNotesResponse} returns this
 */ proto.nexus_service.GetCustomerNotesResponse.prototype.clearNotesList = function() {
    return this.setNotesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.Customer.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.Customer.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.Customer.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.Customer}
 */ proto.nexus_service.Customer.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.Customer;
    return proto.nexus_service.Customer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.Customer}
 */ proto.nexus_service.Customer.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.Customer.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.Customer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.Customer.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.nexus_service.Customer.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Customer} returns this
 */ proto.nexus_service.Customer.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.nexus_service.Customer.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Customer} returns this
 */ proto.nexus_service.Customer.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string account_number = 3;
 * @return {string}
 */ proto.nexus_service.Customer.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Customer} returns this
 */ proto.nexus_service.Customer.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.Vehicle.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.Vehicle.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.Vehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.Vehicle.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            color: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            odometerReading: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            odometerUpdatedAt: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            status: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            locationLat: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            locationLng: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            locationUpdatedAt: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            address: (f = msg.getAddress()) && $3QqPt.Address.toObject(includeInstance, f),
            trim: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            mediaUrl: $8M67s.Message.getFieldWithDefault(msg, 15, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.Vehicle}
 */ proto.nexus_service.Vehicle.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.Vehicle;
    return proto.nexus_service.Vehicle.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.Vehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.Vehicle}
 */ proto.nexus_service.Vehicle.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOdometerReading(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setOdometerUpdatedAt(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setStatus(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setLocationLat(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setLocationLng(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLocationUpdatedAt(value);
                break;
            case 13:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setAddress(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setMediaUrl(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.Vehicle.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.Vehicle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.Vehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.Vehicle.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getColor();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getOdometerReading();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getOdometerUpdatedAt();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getStatus();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getLocationLat();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getLocationLng();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getLocationUpdatedAt();
    if (f !== 0) writer.writeInt64(12, f);
    f = message.getAddress();
    if (f != null) writer.writeMessage(13, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getMediaUrl();
    if (f.length > 0) writer.writeString(15, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string make = 3;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string model = 4;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string year = 5;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string color = 6;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int32 odometer_reading = 7;
 * @return {number}
 */ proto.nexus_service.Vehicle.prototype.getOdometerReading = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setOdometerReading = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int64 odometer_updated_at = 8;
 * @return {number}
 */ proto.nexus_service.Vehicle.prototype.getOdometerUpdatedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setOdometerUpdatedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string status = 9;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getStatus = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string location_lat = 10;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getLocationLat = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setLocationLat = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string location_lng = 11;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getLocationLng = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setLocationLng = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional int64 location_updated_at = 12;
 * @return {number}
 */ proto.nexus_service.Vehicle.prototype.getLocationUpdatedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setLocationUpdatedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional domain.Address address = 13;
 * @return {?proto.domain.Address}
 */ proto.nexus_service.Vehicle.prototype.getAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 13);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.nexus_service.Vehicle} returns this
*/ proto.nexus_service.Vehicle.prototype.setAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 13, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.clearAddress = function() {
    return this.setAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.Vehicle.prototype.hasAddress = function() {
    return $8M67s.Message.getField(this, 13) != null;
};
/**
 * optional string trim = 14;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional string media_url = 15;
 * @return {string}
 */ proto.nexus_service.Vehicle.prototype.getMediaUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.Vehicle} returns this
 */ proto.nexus_service.Vehicle.prototype.setMediaUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.Subscription.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.Subscription.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.Subscription.toObject = function(includeInstance, msg) {
        var f, obj = {
            createdAt: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.Subscription}
 */ proto.nexus_service.Subscription.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.Subscription;
    return proto.nexus_service.Subscription.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.Subscription}
 */ proto.nexus_service.Subscription.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreatedAt(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.Subscription.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.Subscription.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.Subscription.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCreatedAt();
    if (f !== 0) writer.writeInt64(1, f);
};
/**
 * optional int64 created_at = 1;
 * @return {number}
 */ proto.nexus_service.Subscription.prototype.getCreatedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.Subscription} returns this
 */ proto.nexus_service.Subscription.prototype.setCreatedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetCustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetCustomerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetCustomerRequest}
 */ proto.nexus_service.GetCustomerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetCustomerRequest;
    return proto.nexus_service.GetCustomerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetCustomerRequest}
 */ proto.nexus_service.GetCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetCustomerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetCustomerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.nexus_service.GetCustomerRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetCustomerRequest} returns this
 */ proto.nexus_service.GetCustomerRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetCustomerResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetCustomerResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetCustomerResponse}
 */ proto.nexus_service.GetCustomerResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetCustomerResponse;
    return proto.nexus_service.GetCustomerResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetCustomerResponse}
 */ proto.nexus_service.GetCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetCustomerResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetCustomerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomer();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Customer.serializeBinaryToWriter);
};
/**
 * optional domain.Customer customer = 1;
 * @return {?proto.domain.Customer}
 */ proto.nexus_service.GetCustomerResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 1);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.nexus_service.GetCustomerResponse} returns this
*/ proto.nexus_service.GetCustomerResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.GetCustomerResponse} returns this
 */ proto.nexus_service.GetCustomerResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.GetCustomerResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetCustomerImagesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetCustomerImagesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetCustomerImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerImagesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetCustomerImagesRequest}
 */ proto.nexus_service.GetCustomerImagesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetCustomerImagesRequest;
    return proto.nexus_service.GetCustomerImagesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetCustomerImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetCustomerImagesRequest}
 */ proto.nexus_service.GetCustomerImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetCustomerImagesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetCustomerImagesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetCustomerImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetCustomerImagesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.nexus_service.GetCustomerImagesRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetCustomerImagesRequest} returns this
 */ proto.nexus_service.GetCustomerImagesRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetVehicleMapRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetVehicleMapRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetVehicleMapRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            status: (f = msg.getStatus()) && $9c7Du.ListParams.toObject(includeInstance, f),
            vehicleModel: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vehicleMake: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            vehicleVin: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            customerName: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            level: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            maxItems: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            geoReverseLookup: $8M67s.Message.getBooleanFieldWithDefault(msg, 10, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetVehicleMapRequest}
 */ proto.nexus_service.GetVehicleMapRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetVehicleMapRequest;
    return proto.nexus_service.GetVehicleMapRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetVehicleMapRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetVehicleMapRequest}
 */ proto.nexus_service.GetVehicleMapRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9c7Du.ListParams;
                reader.readMessage(value, $9c7Du.ListParams.deserializeBinaryFromReader);
                msg.setStatus(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleModel(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleMake(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleVin(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerName(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readUint32();
                msg.setLevel(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setMaxItems(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setGeoReverseLookup(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetVehicleMapRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetVehicleMapRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetVehicleMapRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStatus();
    if (f != null) writer.writeMessage(1, f, $9c7Du.ListParams.serializeBinaryToWriter);
    f = message.getVehicleModel();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVehicleMake();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getVehicleVin();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getCustomerName();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getLevel();
    if (f !== 0) writer.writeUint32(7, f);
    f = message.getMaxItems();
    if (f !== 0) writer.writeUint32(8, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getGeoReverseLookup();
    if (f) writer.writeBool(10, f);
};
/**
 * optional web.ListParams status = 1;
 * @return {?proto.web.ListParams}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getStatus = function() {
    return /** @type{?proto.web.ListParams} */ $8M67s.Message.getWrapperField(this, $9c7Du.ListParams, 1);
};
/**
 * @param {?proto.web.ListParams|undefined} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
*/ proto.nexus_service.GetVehicleMapRequest.prototype.setStatus = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.clearStatus = function() {
    return this.setStatus(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.hasStatus = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional string vehicle_model = 2;
 * @return {string}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getVehicleModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setVehicleModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vehicle_make = 3;
 * @return {string}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getVehicleMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setVehicleMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string vehicle_vin = 4;
 * @return {string}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getVehicleVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setVehicleVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string customer_id = 5;
 * @return {string}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string customer_name = 6;
 * @return {string}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getCustomerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setCustomerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional uint32 level = 7;
 * @return {number}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getLevel = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setLevel = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint32 max_items = 8;
 * @return {number}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getMaxItems = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setMaxItems = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string vehicle_id = 9;
 * @return {string}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional bool geo_reverse_lookup = 10;
 * @return {boolean}
 */ proto.nexus_service.GetVehicleMapRequest.prototype.getGeoReverseLookup = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.nexus_service.GetVehicleMapRequest} returns this
 */ proto.nexus_service.GetVehicleMapRequest.prototype.setGeoReverseLookup = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 10, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.nexus_service.GetVehicleMapResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetVehicleMapResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetVehicleMapResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetVehicleMapResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetVehicleMapResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehiclesList: $8M67s.Message.toObjectList(msg.getVehiclesList(), proto.nexus_service.MapVehicle.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetVehicleMapResponse}
 */ proto.nexus_service.GetVehicleMapResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetVehicleMapResponse;
    return proto.nexus_service.GetVehicleMapResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetVehicleMapResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetVehicleMapResponse}
 */ proto.nexus_service.GetVehicleMapResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.nexus_service.MapVehicle;
                reader.readMessage(value, proto.nexus_service.MapVehicle.deserializeBinaryFromReader);
                msg.addVehicles(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readUint32();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetVehicleMapResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetVehicleMapResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetVehicleMapResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetVehicleMapResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehiclesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.nexus_service.MapVehicle.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeUint32(2, f);
};
/**
 * repeated MapVehicle vehicles = 1;
 * @return {!Array<!proto.nexus_service.MapVehicle>}
 */ proto.nexus_service.GetVehicleMapResponse.prototype.getVehiclesList = function() {
    return /** @type{!Array<!proto.nexus_service.MapVehicle>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.nexus_service.MapVehicle, 1);
};
/**
 * @param {!Array<!proto.nexus_service.MapVehicle>} value
 * @return {!proto.nexus_service.GetVehicleMapResponse} returns this
*/ proto.nexus_service.GetVehicleMapResponse.prototype.setVehiclesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.nexus_service.MapVehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nexus_service.MapVehicle}
 */ proto.nexus_service.GetVehicleMapResponse.prototype.addVehicles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nexus_service.MapVehicle, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nexus_service.GetVehicleMapResponse} returns this
 */ proto.nexus_service.GetVehicleMapResponse.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
};
/**
 * optional uint32 total = 2;
 * @return {number}
 */ proto.nexus_service.GetVehicleMapResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.GetVehicleMapResponse} returns this
 */ proto.nexus_service.GetVehicleMapResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.MapVehicle.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.MapVehicle.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.MapVehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.MapVehicle.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && proto.nexus_service.Vehicle.toObject(includeInstance, f),
            customer: (f = msg.getCustomer()) && proto.nexus_service.Customer.toObject(includeInstance, f),
            subscription: (f = msg.getSubscription()) && proto.nexus_service.Subscription.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.MapVehicle}
 */ proto.nexus_service.MapVehicle.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.MapVehicle;
    return proto.nexus_service.MapVehicle.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.MapVehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.MapVehicle}
 */ proto.nexus_service.MapVehicle.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.nexus_service.Vehicle;
                reader.readMessage(value, proto.nexus_service.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            case 2:
                var value = new proto.nexus_service.Customer;
                reader.readMessage(value, proto.nexus_service.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            case 3:
                var value = new proto.nexus_service.Subscription;
                reader.readMessage(value, proto.nexus_service.Subscription.deserializeBinaryFromReader);
                msg.setSubscription(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.MapVehicle.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.MapVehicle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.MapVehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.MapVehicle.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, proto.nexus_service.Vehicle.serializeBinaryToWriter);
    f = message.getCustomer();
    if (f != null) writer.writeMessage(2, f, proto.nexus_service.Customer.serializeBinaryToWriter);
    f = message.getSubscription();
    if (f != null) writer.writeMessage(3, f, proto.nexus_service.Subscription.serializeBinaryToWriter);
};
/**
 * optional Vehicle vehicle = 1;
 * @return {?proto.nexus_service.Vehicle}
 */ proto.nexus_service.MapVehicle.prototype.getVehicle = function() {
    return /** @type{?proto.nexus_service.Vehicle} */ $8M67s.Message.getWrapperField(this, proto.nexus_service.Vehicle, 1);
};
/**
 * @param {?proto.nexus_service.Vehicle|undefined} value
 * @return {!proto.nexus_service.MapVehicle} returns this
*/ proto.nexus_service.MapVehicle.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.MapVehicle} returns this
 */ proto.nexus_service.MapVehicle.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.MapVehicle.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional Customer customer = 2;
 * @return {?proto.nexus_service.Customer}
 */ proto.nexus_service.MapVehicle.prototype.getCustomer = function() {
    return /** @type{?proto.nexus_service.Customer} */ $8M67s.Message.getWrapperField(this, proto.nexus_service.Customer, 2);
};
/**
 * @param {?proto.nexus_service.Customer|undefined} value
 * @return {!proto.nexus_service.MapVehicle} returns this
*/ proto.nexus_service.MapVehicle.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.MapVehicle} returns this
 */ proto.nexus_service.MapVehicle.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.MapVehicle.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional Subscription subscription = 3;
 * @return {?proto.nexus_service.Subscription}
 */ proto.nexus_service.MapVehicle.prototype.getSubscription = function() {
    return /** @type{?proto.nexus_service.Subscription} */ $8M67s.Message.getWrapperField(this, proto.nexus_service.Subscription, 3);
};
/**
 * @param {?proto.nexus_service.Subscription|undefined} value
 * @return {!proto.nexus_service.MapVehicle} returns this
*/ proto.nexus_service.MapVehicle.prototype.setSubscription = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.MapVehicle} returns this
 */ proto.nexus_service.MapVehicle.prototype.clearSubscription = function() {
    return this.setSubscription(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.MapVehicle.prototype.hasSubscription = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetLatestCustodyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetLatestCustodyRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetLatestCustodyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetLatestCustodyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            custodyType: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetLatestCustodyRequest}
 */ proto.nexus_service.GetLatestCustodyRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetLatestCustodyRequest;
    return proto.nexus_service.GetLatestCustodyRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetLatestCustodyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetLatestCustodyRequest}
 */ proto.nexus_service.GetLatestCustodyRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {!proto.nexus_service.GetLatestCustodyRequest.CustodyType} */ reader.readEnum();
                msg.setCustodyType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetLatestCustodyRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetLatestCustodyRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetLatestCustodyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetLatestCustodyRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustodyType();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * @enum {number}
 */ proto.nexus_service.GetLatestCustodyRequest.CustodyType = {
    DEALERSHIP: 0,
    CUSTOMER: 1,
    ANY: 2
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.nexus_service.GetLatestCustodyRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.GetLatestCustodyRequest} returns this
 */ proto.nexus_service.GetLatestCustodyRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional CustodyType custody_type = 2;
 * @return {!proto.nexus_service.GetLatestCustodyRequest.CustodyType}
 */ proto.nexus_service.GetLatestCustodyRequest.prototype.getCustodyType = function() {
    return /** @type {!proto.nexus_service.GetLatestCustodyRequest.CustodyType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.nexus_service.GetLatestCustodyRequest.CustodyType} value
 * @return {!proto.nexus_service.GetLatestCustodyRequest} returns this
 */ proto.nexus_service.GetLatestCustodyRequest.prototype.setCustodyType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.nexus_service.GetLatestCustodyResponse.oneofGroups_ = [
    [
        1,
        2
    ]
];
/**
 * @enum {number}
 */ proto.nexus_service.GetLatestCustodyResponse.CustodianCase = {
    CUSTODIAN_NOT_SET: 0,
    DEALERSHIP: 1,
    CUSTOMER: 2
};
/**
 * @return {proto.nexus_service.GetLatestCustodyResponse.CustodianCase}
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.getCustodianCase = function() {
    return /** @type {proto.nexus_service.GetLatestCustodyResponse.CustodianCase} */ $8M67s.Message.computeOneofCase(this, proto.nexus_service.GetLatestCustodyResponse.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.GetLatestCustodyResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.GetLatestCustodyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetLatestCustodyResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $1oiLe.Dealership.toObject(includeInstance, f),
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.GetLatestCustodyResponse}
 */ proto.nexus_service.GetLatestCustodyResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.GetLatestCustodyResponse;
    return proto.nexus_service.GetLatestCustodyResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.GetLatestCustodyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.GetLatestCustodyResponse}
 */ proto.nexus_service.GetLatestCustodyResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.Dealership;
                reader.readMessage(value, $1oiLe.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            case 2:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.GetLatestCustodyResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.GetLatestCustodyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.GetLatestCustodyResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $1oiLe.Dealership.serializeBinaryToWriter);
    f = message.getCustomer();
    if (f != null) writer.writeMessage(2, f, $3QqPt.Customer.serializeBinaryToWriter);
};
/**
 * optional dealer.Dealership dealership = 1;
 * @return {?proto.dealer.Dealership}
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.getDealership = function() {
    return /** @type{?proto.dealer.Dealership} */ $8M67s.Message.getWrapperField(this, $1oiLe.Dealership, 1);
};
/**
 * @param {?proto.dealer.Dealership|undefined} value
 * @return {!proto.nexus_service.GetLatestCustodyResponse} returns this
*/ proto.nexus_service.GetLatestCustodyResponse.prototype.setDealership = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 1, proto.nexus_service.GetLatestCustodyResponse.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.GetLatestCustodyResponse} returns this
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional domain.Customer customer = 2;
 * @return {?proto.domain.Customer}
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 2);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.nexus_service.GetLatestCustodyResponse} returns this
*/ proto.nexus_service.GetLatestCustodyResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 2, proto.nexus_service.GetLatestCustodyResponse.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.GetLatestCustodyResponse} returns this
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.GetLatestCustodyResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.NexusListProgramPricingRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.NexusListProgramPricingRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.NexusListProgramPricingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.NexusListProgramPricingRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            clientId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            listProgramPricingRequest: (f = msg.getListProgramPricingRequest()) && $26u10.ListProgramPricingRequest.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.NexusListProgramPricingRequest}
 */ proto.nexus_service.NexusListProgramPricingRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.NexusListProgramPricingRequest;
    return proto.nexus_service.NexusListProgramPricingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.NexusListProgramPricingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.NexusListProgramPricingRequest}
 */ proto.nexus_service.NexusListProgramPricingRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setClientId(value);
                break;
            case 2:
                var value = new $26u10.ListProgramPricingRequest;
                reader.readMessage(value, $26u10.ListProgramPricingRequest.deserializeBinaryFromReader);
                msg.setListProgramPricingRequest(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.NexusListProgramPricingRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.NexusListProgramPricingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.NexusListProgramPricingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.NexusListProgramPricingRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getClientId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getListProgramPricingRequest();
    if (f != null) writer.writeMessage(2, f, $26u10.ListProgramPricingRequest.serializeBinaryToWriter);
};
/**
 * optional string client_id = 1;
 * @return {string}
 */ proto.nexus_service.NexusListProgramPricingRequest.prototype.getClientId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.NexusListProgramPricingRequest} returns this
 */ proto.nexus_service.NexusListProgramPricingRequest.prototype.setClientId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional billing_service.ListProgramPricingRequest list_program_pricing_request = 2;
 * @return {?proto.billing_service.ListProgramPricingRequest}
 */ proto.nexus_service.NexusListProgramPricingRequest.prototype.getListProgramPricingRequest = function() {
    return /** @type{?proto.billing_service.ListProgramPricingRequest} */ $8M67s.Message.getWrapperField(this, $26u10.ListProgramPricingRequest, 2);
};
/**
 * @param {?proto.billing_service.ListProgramPricingRequest|undefined} value
 * @return {!proto.nexus_service.NexusListProgramPricingRequest} returns this
*/ proto.nexus_service.NexusListProgramPricingRequest.prototype.setListProgramPricingRequest = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.nexus_service.NexusListProgramPricingRequest} returns this
 */ proto.nexus_service.NexusListProgramPricingRequest.prototype.clearListProgramPricingRequest = function() {
    return this.setListProgramPricingRequest(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.nexus_service.NexusListProgramPricingRequest.prototype.hasListProgramPricingRequest = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.ConvertToGalpinTeslaRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.ConvertToGalpinTeslaRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.ConvertToGalpinTeslaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.ConvertToGalpinTeslaRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.ConvertToGalpinTeslaRequest}
 */ proto.nexus_service.ConvertToGalpinTeslaRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.ConvertToGalpinTeslaRequest;
    return proto.nexus_service.ConvertToGalpinTeslaRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.ConvertToGalpinTeslaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.ConvertToGalpinTeslaRequest}
 */ proto.nexus_service.ConvertToGalpinTeslaRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.ConvertToGalpinTeslaRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.ConvertToGalpinTeslaRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.ConvertToGalpinTeslaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.ConvertToGalpinTeslaRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string reservation_id = 1;
 * @return {string}
 */ proto.nexus_service.ConvertToGalpinTeslaRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.ConvertToGalpinTeslaRequest} returns this
 */ proto.nexus_service.ConvertToGalpinTeslaRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.ConvertToGalpinTeslaResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.ConvertToGalpinTeslaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            message: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.ConvertToGalpinTeslaResponse}
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.ConvertToGalpinTeslaResponse;
    return proto.nexus_service.ConvertToGalpinTeslaResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.ConvertToGalpinTeslaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.ConvertToGalpinTeslaResponse}
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.ConvertToGalpinTeslaResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.ConvertToGalpinTeslaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.nexus_service.ConvertToGalpinTeslaResponse} returns this
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string message = 2;
 * @return {string}
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.ConvertToGalpinTeslaResponse} returns this
 */ proto.nexus_service.ConvertToGalpinTeslaResponse.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.ListAppointmentsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.ListAppointmentsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.ListAppointmentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.ListAppointmentsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            daysOut: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.ListAppointmentsRequest}
 */ proto.nexus_service.ListAppointmentsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.ListAppointmentsRequest;
    return proto.nexus_service.ListAppointmentsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.ListAppointmentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.ListAppointmentsRequest}
 */ proto.nexus_service.ListAppointmentsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDaysOut(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.ListAppointmentsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.ListAppointmentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.ListAppointmentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.ListAppointmentsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDaysOut();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string dealership_id = 1;
 * @return {string}
 */ proto.nexus_service.ListAppointmentsRequest.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.ListAppointmentsRequest} returns this
 */ proto.nexus_service.ListAppointmentsRequest.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 days_out = 2;
 * @return {number}
 */ proto.nexus_service.ListAppointmentsRequest.prototype.getDaysOut = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.nexus_service.ListAppointmentsRequest} returns this
 */ proto.nexus_service.ListAppointmentsRequest.prototype.setDaysOut = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string account_number = 3;
 * @return {string}
 */ proto.nexus_service.ListAppointmentsRequest.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.ListAppointmentsRequest} returns this
 */ proto.nexus_service.ListAppointmentsRequest.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.nexus_service.AppointmentDay.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.AppointmentDay.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.AppointmentDay.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.AppointmentDay} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.AppointmentDay.toObject = function(includeInstance, msg) {
        var f, obj = {
            day: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            appointmentsList: $8M67s.Message.toObjectList(msg.getAppointmentsList(), $fcTGK.Appointment.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.AppointmentDay}
 */ proto.nexus_service.AppointmentDay.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.AppointmentDay;
    return proto.nexus_service.AppointmentDay.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.AppointmentDay} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.AppointmentDay}
 */ proto.nexus_service.AppointmentDay.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDay(value);
                break;
            case 2:
                var value = new $fcTGK.Appointment;
                reader.readMessage(value, $fcTGK.Appointment.deserializeBinaryFromReader);
                msg.addAppointments(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.AppointmentDay.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.AppointmentDay.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.AppointmentDay} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.AppointmentDay.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDay();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAppointmentsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $fcTGK.Appointment.serializeBinaryToWriter);
};
/**
 * optional string day = 1;
 * @return {string}
 */ proto.nexus_service.AppointmentDay.prototype.getDay = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.nexus_service.AppointmentDay} returns this
 */ proto.nexus_service.AppointmentDay.prototype.setDay = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated appointment.Appointment appointments = 2;
 * @return {!Array<!proto.appointment.Appointment>}
 */ proto.nexus_service.AppointmentDay.prototype.getAppointmentsList = function() {
    return /** @type{!Array<!proto.appointment.Appointment>} */ $8M67s.Message.getRepeatedWrapperField(this, $fcTGK.Appointment, 2);
};
/**
 * @param {!Array<!proto.appointment.Appointment>} value
 * @return {!proto.nexus_service.AppointmentDay} returns this
*/ proto.nexus_service.AppointmentDay.prototype.setAppointmentsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.appointment.Appointment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.appointment.Appointment}
 */ proto.nexus_service.AppointmentDay.prototype.addAppointments = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.appointment.Appointment, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nexus_service.AppointmentDay} returns this
 */ proto.nexus_service.AppointmentDay.prototype.clearAppointmentsList = function() {
    return this.setAppointmentsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.nexus_service.ListAppointmentsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.nexus_service.ListAppointmentsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.nexus_service.ListAppointmentsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.nexus_service.ListAppointmentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.ListAppointmentsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentDaysList: $8M67s.Message.toObjectList(msg.getAppointmentDaysList(), proto.nexus_service.AppointmentDay.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.nexus_service.ListAppointmentsResponse}
 */ proto.nexus_service.ListAppointmentsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.nexus_service.ListAppointmentsResponse;
    return proto.nexus_service.ListAppointmentsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.nexus_service.ListAppointmentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.nexus_service.ListAppointmentsResponse}
 */ proto.nexus_service.ListAppointmentsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.nexus_service.AppointmentDay;
                reader.readMessage(value, proto.nexus_service.AppointmentDay.deserializeBinaryFromReader);
                msg.addAppointmentDays(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.nexus_service.ListAppointmentsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.nexus_service.ListAppointmentsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.nexus_service.ListAppointmentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.nexus_service.ListAppointmentsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentDaysList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.nexus_service.AppointmentDay.serializeBinaryToWriter);
};
/**
 * repeated AppointmentDay appointment_days = 1;
 * @return {!Array<!proto.nexus_service.AppointmentDay>}
 */ proto.nexus_service.ListAppointmentsResponse.prototype.getAppointmentDaysList = function() {
    return /** @type{!Array<!proto.nexus_service.AppointmentDay>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.nexus_service.AppointmentDay, 1);
};
/**
 * @param {!Array<!proto.nexus_service.AppointmentDay>} value
 * @return {!proto.nexus_service.ListAppointmentsResponse} returns this
*/ proto.nexus_service.ListAppointmentsResponse.prototype.setAppointmentDaysList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.nexus_service.AppointmentDay=} opt_value
 * @param {number=} opt_index
 * @return {!proto.nexus_service.AppointmentDay}
 */ proto.nexus_service.ListAppointmentsResponse.prototype.addAppointmentDays = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.nexus_service.AppointmentDay, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.nexus_service.ListAppointmentsResponse} returns this
 */ proto.nexus_service.ListAppointmentsResponse.prototype.clearAppointmentDaysList = function() {
    return this.setAppointmentDaysList([]);
};
$9cc679ea19110e37$var$goog.object.extend(module.exports, proto.nexus_service);

});
parcelRegister("fcTGK", function(module, exports) {
// source: appointment.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $b1232c8ea2af4fd3$var$goog = $8M67s;
var $b1232c8ea2af4fd3$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$b1232c8ea2af4fd3$var$goog.object.extend(proto, $3QqPt);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.Appointment', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentCancelled', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentCheckoutStatus', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentCreated', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentKeyHandOff', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentPickupDate', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentStatus', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentStatusUpdated', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentType', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentTypeConfig', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentTypeUpdated', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentUpdated', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AppointmentVehicleUpdated', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.Availability', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AvailabilityCreated', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AvailableTime', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.AvailableTime.DayOfWeek', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.CustomerInfo', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.DealershipInfo', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.Note', null, $b1232c8ea2af4fd3$var$global);
$b1232c8ea2af4fd3$var$goog.exportSymbol('proto.appointment.VehicleInfo', null, $b1232c8ea2af4fd3$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.Availability = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.appointment.Availability.repeatedFields_, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.Availability, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.Availability.displayName = 'proto.appointment.Availability';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AvailableTime = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AvailableTime, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AvailableTime.displayName = 'proto.appointment.AvailableTime';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.Appointment = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.appointment.Appointment.repeatedFields_, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.Appointment, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.Appointment.displayName = 'proto.appointment.Appointment';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.DealershipInfo = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.DealershipInfo, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.DealershipInfo.displayName = 'proto.appointment.DealershipInfo';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.CustomerInfo = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.CustomerInfo, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.CustomerInfo.displayName = 'proto.appointment.CustomerInfo';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.VehicleInfo = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.VehicleInfo, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.VehicleInfo.displayName = 'proto.appointment.VehicleInfo';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.Note = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.Note, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.Note.displayName = 'proto.appointment.Note';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentTypeConfig = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentTypeConfig, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentTypeConfig.displayName = 'proto.appointment.AppointmentTypeConfig';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentCreated, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentCreated.displayName = 'proto.appointment.AppointmentCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentCancelled = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentCancelled, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentCancelled.displayName = 'proto.appointment.AppointmentCancelled';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentTypeUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentTypeUpdated, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentTypeUpdated.displayName = 'proto.appointment.AppointmentTypeUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentStatusUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentStatusUpdated, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentStatusUpdated.displayName = 'proto.appointment.AppointmentStatusUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentUpdated, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentUpdated.displayName = 'proto.appointment.AppointmentUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentVehicleUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentVehicleUpdated, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentVehicleUpdated.displayName = 'proto.appointment.AppointmentVehicleUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AvailabilityCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AvailabilityCreated, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AvailabilityCreated.displayName = 'proto.appointment.AvailabilityCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentCheckoutStatus = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentCheckoutStatus, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentCheckoutStatus.displayName = 'proto.appointment.AppointmentCheckoutStatus';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentKeyHandOff = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentKeyHandOff, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentKeyHandOff.displayName = 'proto.appointment.AppointmentKeyHandOff';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment.AppointmentPickupDate = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$b1232c8ea2af4fd3$var$goog.inherits(proto.appointment.AppointmentPickupDate, $8M67s.Message);
if ($b1232c8ea2af4fd3$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment.AppointmentPickupDate.displayName = 'proto.appointment.AppointmentPickupDate';
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.appointment.Availability.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.Availability.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.Availability.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.Availability} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.Availability.toObject = function(includeInstance, msg) {
        var f, obj = {
            slotsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            timezone: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.Availability}
 */ proto.appointment.Availability.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.Availability;
    return proto.appointment.Availability.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.Availability} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.Availability}
 */ proto.appointment.Availability.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedInt64() : [
                    reader.readInt64()
                ];
                for(var i = 0; i < values.length; i++)msg.addSlots(values[i]);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTimezone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.Availability.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.Availability.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.Availability} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.Availability.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSlotsList();
    if (f.length > 0) writer.writePackedInt64(1, f);
    f = message.getTimezone();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * repeated int64 slots = 1;
 * @return {!Array<number>}
 */ proto.appointment.Availability.prototype.getSlotsList = function() {
    return /** @type {!Array<number>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.appointment.Availability} returns this
 */ proto.appointment.Availability.prototype.setSlotsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.appointment.Availability} returns this
 */ proto.appointment.Availability.prototype.addSlots = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.appointment.Availability} returns this
 */ proto.appointment.Availability.prototype.clearSlotsList = function() {
    return this.setSlotsList([]);
};
/**
 * optional string timezone = 2;
 * @return {string}
 */ proto.appointment.Availability.prototype.getTimezone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.Availability} returns this
 */ proto.appointment.Availability.prototype.setTimezone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AvailableTime.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AvailableTime.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AvailableTime} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AvailableTime.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            dayOfWeek: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            startTime: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            endTime: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            timezone: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AvailableTime}
 */ proto.appointment.AvailableTime.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AvailableTime;
    return proto.appointment.AvailableTime.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AvailableTime} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AvailableTime}
 */ proto.appointment.AvailableTime.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 2:
                var value = /** @type {!proto.appointment.AvailableTime.DayOfWeek} */ reader.readEnum();
                msg.setDayOfWeek(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setStartTime(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setEndTime(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setTimezone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AvailableTime.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AvailableTime.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AvailableTime} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AvailableTime.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDayOfWeek();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getStartTime();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getEndTime();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getTimezone();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * @enum {number}
 */ proto.appointment.AvailableTime.DayOfWeek = {
    DAY_OF_WEEK_UNSPECIFIED: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    SUNDAY: 7
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.appointment.AvailableTime.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AvailableTime} returns this
 */ proto.appointment.AvailableTime.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional DayOfWeek day_of_week = 2;
 * @return {!proto.appointment.AvailableTime.DayOfWeek}
 */ proto.appointment.AvailableTime.prototype.getDayOfWeek = function() {
    return /** @type {!proto.appointment.AvailableTime.DayOfWeek} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.appointment.AvailableTime.DayOfWeek} value
 * @return {!proto.appointment.AvailableTime} returns this
 */ proto.appointment.AvailableTime.prototype.setDayOfWeek = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string start_time = 3;
 * @return {string}
 */ proto.appointment.AvailableTime.prototype.getStartTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AvailableTime} returns this
 */ proto.appointment.AvailableTime.prototype.setStartTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string end_time = 4;
 * @return {string}
 */ proto.appointment.AvailableTime.prototype.getEndTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AvailableTime} returns this
 */ proto.appointment.AvailableTime.prototype.setEndTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string timeZone = 5;
 * @return {string}
 */ proto.appointment.AvailableTime.prototype.getTimezone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AvailableTime} returns this
 */ proto.appointment.AvailableTime.prototype.setTimezone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.appointment.Appointment.repeatedFields_ = [
    9
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.Appointment.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.Appointment.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.Appointment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.Appointment.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            startTime: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            appointmentType: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            appointmentStatus: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            dealershipInfo: (f = msg.getDealershipInfo()) && proto.appointment.DealershipInfo.toObject(includeInstance, f),
            customerInfo: (f = msg.getCustomerInfo()) && proto.appointment.CustomerInfo.toObject(includeInstance, f),
            vehicleInfo: (f = msg.getVehicleInfo()) && proto.appointment.VehicleInfo.toObject(includeInstance, f),
            timeZone: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            notesList: $8M67s.Message.toObjectList(msg.getNotesList(), proto.appointment.Note.toObject, includeInstance),
            lastUpdate: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            version: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            duration: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            insuranceLinked: $8M67s.Message.getBooleanFieldWithDefault(msg, 13, false),
            licenseScanned: $8M67s.Message.getBooleanFieldWithDefault(msg, 14, false),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 15, ""),
            appointmentKeyHandOff: (f = msg.getAppointmentKeyHandOff()) && proto.appointment.AppointmentKeyHandOff.toObject(includeInstance, f),
            appointmentCheckoutStatus: (f = msg.getAppointmentCheckoutStatus()) && proto.appointment.AppointmentCheckoutStatus.toObject(includeInstance, f),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 18, ""),
            completedTime: $8M67s.Message.getFieldWithDefault(msg, 19, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.Appointment}
 */ proto.appointment.Appointment.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.Appointment;
    return proto.appointment.Appointment.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.Appointment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.Appointment}
 */ proto.appointment.Appointment.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setStartTime(value);
                break;
            case 3:
                var value = /** @type {!proto.appointment.AppointmentType} */ reader.readEnum();
                msg.setAppointmentType(value);
                break;
            case 4:
                var value = /** @type {!proto.appointment.AppointmentStatus} */ reader.readEnum();
                msg.setAppointmentStatus(value);
                break;
            case 5:
                var value = new proto.appointment.DealershipInfo;
                reader.readMessage(value, proto.appointment.DealershipInfo.deserializeBinaryFromReader);
                msg.setDealershipInfo(value);
                break;
            case 6:
                var value = new proto.appointment.CustomerInfo;
                reader.readMessage(value, proto.appointment.CustomerInfo.deserializeBinaryFromReader);
                msg.setCustomerInfo(value);
                break;
            case 7:
                var value = new proto.appointment.VehicleInfo;
                reader.readMessage(value, proto.appointment.VehicleInfo.deserializeBinaryFromReader);
                msg.setVehicleInfo(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setTimeZone(value);
                break;
            case 9:
                var value = new proto.appointment.Note;
                reader.readMessage(value, proto.appointment.Note.deserializeBinaryFromReader);
                msg.addNotes(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLastUpdate(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDuration(value);
                break;
            case 13:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setInsuranceLinked(value);
                break;
            case 14:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setLicenseScanned(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 16:
                var value = new proto.appointment.AppointmentKeyHandOff;
                reader.readMessage(value, proto.appointment.AppointmentKeyHandOff.deserializeBinaryFromReader);
                msg.setAppointmentKeyHandOff(value);
                break;
            case 17:
                var value = new proto.appointment.AppointmentCheckoutStatus;
                reader.readMessage(value, proto.appointment.AppointmentCheckoutStatus.deserializeBinaryFromReader);
                msg.setAppointmentCheckoutStatus(value);
                break;
            case 18:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 19:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCompletedTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.Appointment.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.Appointment.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.Appointment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.Appointment.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getStartTime();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getAppointmentType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getAppointmentStatus();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getDealershipInfo();
    if (f != null) writer.writeMessage(5, f, proto.appointment.DealershipInfo.serializeBinaryToWriter);
    f = message.getCustomerInfo();
    if (f != null) writer.writeMessage(6, f, proto.appointment.CustomerInfo.serializeBinaryToWriter);
    f = message.getVehicleInfo();
    if (f != null) writer.writeMessage(7, f, proto.appointment.VehicleInfo.serializeBinaryToWriter);
    f = message.getTimeZone();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getNotesList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, proto.appointment.Note.serializeBinaryToWriter);
    f = message.getLastUpdate();
    if (f !== 0) writer.writeInt64(10, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(11, f);
    f = message.getDuration();
    if (f !== 0) writer.writeInt32(12, f);
    f = message.getInsuranceLinked();
    if (f) writer.writeBool(13, f);
    f = message.getLicenseScanned();
    if (f) writer.writeBool(14, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(15, f);
    f = message.getAppointmentKeyHandOff();
    if (f != null) writer.writeMessage(16, f, proto.appointment.AppointmentKeyHandOff.serializeBinaryToWriter);
    f = message.getAppointmentCheckoutStatus();
    if (f != null) writer.writeMessage(17, f, proto.appointment.AppointmentCheckoutStatus.serializeBinaryToWriter);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(18, f);
    f = message.getCompletedTime();
    if (f !== 0) writer.writeInt64(19, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.appointment.Appointment.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 start_time = 2;
 * @return {number}
 */ proto.appointment.Appointment.prototype.getStartTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setStartTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional AppointmentType appointment_type = 3;
 * @return {!proto.appointment.AppointmentType}
 */ proto.appointment.Appointment.prototype.getAppointmentType = function() {
    return /** @type {!proto.appointment.AppointmentType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.appointment.AppointmentType} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setAppointmentType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional AppointmentStatus appointment_status = 4;
 * @return {!proto.appointment.AppointmentStatus}
 */ proto.appointment.Appointment.prototype.getAppointmentStatus = function() {
    return /** @type {!proto.appointment.AppointmentStatus} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.appointment.AppointmentStatus} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setAppointmentStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional DealershipInfo dealership_info = 5;
 * @return {?proto.appointment.DealershipInfo}
 */ proto.appointment.Appointment.prototype.getDealershipInfo = function() {
    return /** @type{?proto.appointment.DealershipInfo} */ $8M67s.Message.getWrapperField(this, proto.appointment.DealershipInfo, 5);
};
/**
 * @param {?proto.appointment.DealershipInfo|undefined} value
 * @return {!proto.appointment.Appointment} returns this
*/ proto.appointment.Appointment.prototype.setDealershipInfo = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.clearDealershipInfo = function() {
    return this.setDealershipInfo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.Appointment.prototype.hasDealershipInfo = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional CustomerInfo customer_info = 6;
 * @return {?proto.appointment.CustomerInfo}
 */ proto.appointment.Appointment.prototype.getCustomerInfo = function() {
    return /** @type{?proto.appointment.CustomerInfo} */ $8M67s.Message.getWrapperField(this, proto.appointment.CustomerInfo, 6);
};
/**
 * @param {?proto.appointment.CustomerInfo|undefined} value
 * @return {!proto.appointment.Appointment} returns this
*/ proto.appointment.Appointment.prototype.setCustomerInfo = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.clearCustomerInfo = function() {
    return this.setCustomerInfo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.Appointment.prototype.hasCustomerInfo = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional VehicleInfo vehicle_info = 7;
 * @return {?proto.appointment.VehicleInfo}
 */ proto.appointment.Appointment.prototype.getVehicleInfo = function() {
    return /** @type{?proto.appointment.VehicleInfo} */ $8M67s.Message.getWrapperField(this, proto.appointment.VehicleInfo, 7);
};
/**
 * @param {?proto.appointment.VehicleInfo|undefined} value
 * @return {!proto.appointment.Appointment} returns this
*/ proto.appointment.Appointment.prototype.setVehicleInfo = function(value) {
    return $8M67s.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.clearVehicleInfo = function() {
    return this.setVehicleInfo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.Appointment.prototype.hasVehicleInfo = function() {
    return $8M67s.Message.getField(this, 7) != null;
};
/**
 * optional string time_zone = 8;
 * @return {string}
 */ proto.appointment.Appointment.prototype.getTimeZone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setTimeZone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * repeated Note notes = 9;
 * @return {!Array<!proto.appointment.Note>}
 */ proto.appointment.Appointment.prototype.getNotesList = function() {
    return /** @type{!Array<!proto.appointment.Note>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.appointment.Note, 9);
};
/**
 * @param {!Array<!proto.appointment.Note>} value
 * @return {!proto.appointment.Appointment} returns this
*/ proto.appointment.Appointment.prototype.setNotesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.appointment.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.appointment.Note}
 */ proto.appointment.Appointment.prototype.addNotes = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.appointment.Note, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.clearNotesList = function() {
    return this.setNotesList([]);
};
/**
 * optional int64 last_update = 10;
 * @return {number}
 */ proto.appointment.Appointment.prototype.getLastUpdate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setLastUpdate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int64 version = 11;
 * @return {number}
 */ proto.appointment.Appointment.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int32 duration = 12;
 * @return {number}
 */ proto.appointment.Appointment.prototype.getDuration = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setDuration = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional bool insurance_linked = 13;
 * @return {boolean}
 */ proto.appointment.Appointment.prototype.getInsuranceLinked = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 13, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setInsuranceLinked = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 13, value);
};
/**
 * optional bool license_scanned = 14;
 * @return {boolean}
 */ proto.appointment.Appointment.prototype.getLicenseScanned = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 14, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setLicenseScanned = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 14, value);
};
/**
 * optional string subscription_id = 15;
 * @return {string}
 */ proto.appointment.Appointment.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
/**
 * optional AppointmentKeyHandOff appointment_key_hand_off = 16;
 * @return {?proto.appointment.AppointmentKeyHandOff}
 */ proto.appointment.Appointment.prototype.getAppointmentKeyHandOff = function() {
    return /** @type{?proto.appointment.AppointmentKeyHandOff} */ $8M67s.Message.getWrapperField(this, proto.appointment.AppointmentKeyHandOff, 16);
};
/**
 * @param {?proto.appointment.AppointmentKeyHandOff|undefined} value
 * @return {!proto.appointment.Appointment} returns this
*/ proto.appointment.Appointment.prototype.setAppointmentKeyHandOff = function(value) {
    return $8M67s.Message.setWrapperField(this, 16, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.clearAppointmentKeyHandOff = function() {
    return this.setAppointmentKeyHandOff(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.Appointment.prototype.hasAppointmentKeyHandOff = function() {
    return $8M67s.Message.getField(this, 16) != null;
};
/**
 * optional AppointmentCheckoutStatus appointment_checkout_status = 17;
 * @return {?proto.appointment.AppointmentCheckoutStatus}
 */ proto.appointment.Appointment.prototype.getAppointmentCheckoutStatus = function() {
    return /** @type{?proto.appointment.AppointmentCheckoutStatus} */ $8M67s.Message.getWrapperField(this, proto.appointment.AppointmentCheckoutStatus, 17);
};
/**
 * @param {?proto.appointment.AppointmentCheckoutStatus|undefined} value
 * @return {!proto.appointment.Appointment} returns this
*/ proto.appointment.Appointment.prototype.setAppointmentCheckoutStatus = function(value) {
    return $8M67s.Message.setWrapperField(this, 17, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.clearAppointmentCheckoutStatus = function() {
    return this.setAppointmentCheckoutStatus(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.Appointment.prototype.hasAppointmentCheckoutStatus = function() {
    return $8M67s.Message.getField(this, 17) != null;
};
/**
 * optional string reservation_id = 18;
 * @return {string}
 */ proto.appointment.Appointment.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 18, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 18, value);
};
/**
 * optional int64 completed_time = 19;
 * @return {number}
 */ proto.appointment.Appointment.prototype.getCompletedTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 19, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.Appointment} returns this
 */ proto.appointment.Appointment.prototype.setCompletedTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 19, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.DealershipInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.DealershipInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.DealershipInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.DealershipInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            assignee: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            assigneeId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            address: (f = msg.getAddress()) && $3QqPt.Address.toObject(includeInstance, f),
            timeZone: $8M67s.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.DealershipInfo}
 */ proto.appointment.DealershipInfo.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.DealershipInfo;
    return proto.appointment.DealershipInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.DealershipInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.DealershipInfo}
 */ proto.appointment.DealershipInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAssignee(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAssigneeId(value);
                break;
            case 5:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setAddress(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setTimeZone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.DealershipInfo.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.DealershipInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.DealershipInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.DealershipInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAssignee();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAssigneeId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getAddress();
    if (f != null) writer.writeMessage(5, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getTimeZone();
    if (f.length > 0) writer.writeString(6, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.appointment.DealershipInfo.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.DealershipInfo} returns this
 */ proto.appointment.DealershipInfo.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.appointment.DealershipInfo.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.DealershipInfo} returns this
 */ proto.appointment.DealershipInfo.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string assignee = 3;
 * @return {string}
 */ proto.appointment.DealershipInfo.prototype.getAssignee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.DealershipInfo} returns this
 */ proto.appointment.DealershipInfo.prototype.setAssignee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string assignee_id = 4;
 * @return {string}
 */ proto.appointment.DealershipInfo.prototype.getAssigneeId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.DealershipInfo} returns this
 */ proto.appointment.DealershipInfo.prototype.setAssigneeId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional domain.Address address = 5;
 * @return {?proto.domain.Address}
 */ proto.appointment.DealershipInfo.prototype.getAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 5);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.appointment.DealershipInfo} returns this
*/ proto.appointment.DealershipInfo.prototype.setAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.DealershipInfo} returns this
 */ proto.appointment.DealershipInfo.prototype.clearAddress = function() {
    return this.setAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.DealershipInfo.prototype.hasAddress = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional string time_zone = 6;
 * @return {string}
 */ proto.appointment.DealershipInfo.prototype.getTimeZone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.DealershipInfo} returns this
 */ proto.appointment.DealershipInfo.prototype.setTimeZone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.CustomerInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.CustomerInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.CustomerInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.CustomerInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fullName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            accountNum: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.CustomerInfo}
 */ proto.appointment.CustomerInfo.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.CustomerInfo;
    return proto.appointment.CustomerInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.CustomerInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.CustomerInfo}
 */ proto.appointment.CustomerInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFullName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNum(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.CustomerInfo.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.CustomerInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.CustomerInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.CustomerInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFullName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAccountNum();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.appointment.CustomerInfo.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.CustomerInfo} returns this
 */ proto.appointment.CustomerInfo.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string full_name = 2;
 * @return {string}
 */ proto.appointment.CustomerInfo.prototype.getFullName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.CustomerInfo} returns this
 */ proto.appointment.CustomerInfo.prototype.setFullName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string account_num = 3;
 * @return {string}
 */ proto.appointment.CustomerInfo.prototype.getAccountNum = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.CustomerInfo} returns this
 */ proto.appointment.CustomerInfo.prototype.setAccountNum = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string phone = 4;
 * @return {string}
 */ proto.appointment.CustomerInfo.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.CustomerInfo} returns this
 */ proto.appointment.CustomerInfo.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.VehicleInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.VehicleInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.VehicleInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.VehicleInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            color: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            drivetrain: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            odometer: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            wheelSize: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            interiorColor: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.VehicleInfo}
 */ proto.appointment.VehicleInfo.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.VehicleInfo;
    return proto.appointment.VehicleInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.VehicleInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.VehicleInfo}
 */ proto.appointment.VehicleInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setDrivetrain(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOdometer(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setWheelSize(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setInteriorColor(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.VehicleInfo.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.VehicleInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.VehicleInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.VehicleInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getColor();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getDrivetrain();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getOdometer();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getWheelSize();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getInteriorColor();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string make = 3;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string model = 4;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string year = 5;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string color = 6;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string drivetrain = 7;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getDrivetrain = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setDrivetrain = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional int32 odometer = 8;
 * @return {number}
 */ proto.appointment.VehicleInfo.prototype.getOdometer = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setOdometer = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string wheel_size = 9;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getWheelSize = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setWheelSize = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string interior_color = 10;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getInteriorColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setInteriorColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string trim = 11;
 * @return {string}
 */ proto.appointment.VehicleInfo.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.VehicleInfo} returns this
 */ proto.appointment.VehicleInfo.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.Note.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.Note.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.Note} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.Note.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            author: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            content: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.Note}
 */ proto.appointment.Note.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.Note;
    return proto.appointment.Note.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.Note} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.Note}
 */ proto.appointment.Note.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAuthor(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setContent(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.Note.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.Note.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.Note} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.Note.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getAuthor();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getContent();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.appointment.Note.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.Note} returns this
 */ proto.appointment.Note.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 created = 2;
 * @return {number}
 */ proto.appointment.Note.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.Note} returns this
 */ proto.appointment.Note.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string author = 3;
 * @return {string}
 */ proto.appointment.Note.prototype.getAuthor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.Note} returns this
 */ proto.appointment.Note.prototype.setAuthor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string content = 4;
 * @return {string}
 */ proto.appointment.Note.prototype.getContent = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.Note} returns this
 */ proto.appointment.Note.prototype.setContent = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentTypeConfig.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentTypeConfig.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentTypeConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentTypeConfig.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            type: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            durationMinutes: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            countPerSlot: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentTypeConfig}
 */ proto.appointment.AppointmentTypeConfig.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentTypeConfig;
    return proto.appointment.AppointmentTypeConfig.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentTypeConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentTypeConfig}
 */ proto.appointment.AppointmentTypeConfig.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.appointment.AppointmentType} */ reader.readEnum();
                msg.setType(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDurationMinutes(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setCountPerSlot(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentTypeConfig.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentTypeConfig.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentTypeConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentTypeConfig.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getType();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getDurationMinutes();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getCountPerSlot();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.appointment.AppointmentTypeConfig.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentTypeConfig} returns this
 */ proto.appointment.AppointmentTypeConfig.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional AppointmentType type = 2;
 * @return {!proto.appointment.AppointmentType}
 */ proto.appointment.AppointmentTypeConfig.prototype.getType = function() {
    return /** @type {!proto.appointment.AppointmentType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.appointment.AppointmentType} value
 * @return {!proto.appointment.AppointmentTypeConfig} returns this
 */ proto.appointment.AppointmentTypeConfig.prototype.setType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional int32 duration_minutes = 3;
 * @return {number}
 */ proto.appointment.AppointmentTypeConfig.prototype.getDurationMinutes = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.AppointmentTypeConfig} returns this
 */ proto.appointment.AppointmentTypeConfig.prototype.setDurationMinutes = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 count_per_slot = 4;
 * @return {number}
 */ proto.appointment.AppointmentTypeConfig.prototype.getCountPerSlot = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.AppointmentTypeConfig} returns this
 */ proto.appointment.AppointmentTypeConfig.prototype.setCountPerSlot = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointment: (f = msg.getAppointment()) && proto.appointment.Appointment.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentCreated}
 */ proto.appointment.AppointmentCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentCreated;
    return proto.appointment.AppointmentCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentCreated}
 */ proto.appointment.AppointmentCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.appointment.Appointment;
                reader.readMessage(value, proto.appointment.Appointment.deserializeBinaryFromReader);
                msg.setAppointment(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointment();
    if (f != null) writer.writeMessage(1, f, proto.appointment.Appointment.serializeBinaryToWriter);
};
/**
 * optional Appointment appointment = 1;
 * @return {?proto.appointment.Appointment}
 */ proto.appointment.AppointmentCreated.prototype.getAppointment = function() {
    return /** @type{?proto.appointment.Appointment} */ $8M67s.Message.getWrapperField(this, proto.appointment.Appointment, 1);
};
/**
 * @param {?proto.appointment.Appointment|undefined} value
 * @return {!proto.appointment.AppointmentCreated} returns this
*/ proto.appointment.AppointmentCreated.prototype.setAppointment = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.AppointmentCreated} returns this
 */ proto.appointment.AppointmentCreated.prototype.clearAppointment = function() {
    return this.setAppointment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.AppointmentCreated.prototype.hasAppointment = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentCancelled.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentCancelled.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentCancelled} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentCancelled.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentCancelled}
 */ proto.appointment.AppointmentCancelled.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentCancelled;
    return proto.appointment.AppointmentCancelled.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentCancelled} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentCancelled}
 */ proto.appointment.AppointmentCancelled.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentCancelled.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentCancelled.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentCancelled} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentCancelled.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.appointment.AppointmentCancelled.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentCancelled} returns this
 */ proto.appointment.AppointmentCancelled.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentTypeUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentTypeUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentTypeUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentTypeUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            type: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentTypeUpdated}
 */ proto.appointment.AppointmentTypeUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentTypeUpdated;
    return proto.appointment.AppointmentTypeUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentTypeUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentTypeUpdated}
 */ proto.appointment.AppointmentTypeUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 3:
                var value = /** @type {!proto.appointment.AppointmentType} */ reader.readEnum();
                msg.setType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentTypeUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentTypeUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentTypeUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentTypeUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getType();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment.AppointmentTypeUpdated.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentTypeUpdated} returns this
 */ proto.appointment.AppointmentTypeUpdated.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 date = 2;
 * @return {number}
 */ proto.appointment.AppointmentTypeUpdated.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.AppointmentTypeUpdated} returns this
 */ proto.appointment.AppointmentTypeUpdated.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional AppointmentType type = 3;
 * @return {!proto.appointment.AppointmentType}
 */ proto.appointment.AppointmentTypeUpdated.prototype.getType = function() {
    return /** @type {!proto.appointment.AppointmentType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.appointment.AppointmentType} value
 * @return {!proto.appointment.AppointmentTypeUpdated} returns this
 */ proto.appointment.AppointmentTypeUpdated.prototype.setType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentStatusUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentStatusUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentStatusUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentStatusUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            status: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentStatusUpdated}
 */ proto.appointment.AppointmentStatusUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentStatusUpdated;
    return proto.appointment.AppointmentStatusUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentStatusUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentStatusUpdated}
 */ proto.appointment.AppointmentStatusUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 3:
                var value = /** @type {!proto.appointment.AppointmentStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentStatusUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentStatusUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentStatusUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentStatusUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment.AppointmentStatusUpdated.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentStatusUpdated} returns this
 */ proto.appointment.AppointmentStatusUpdated.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 date = 2;
 * @return {number}
 */ proto.appointment.AppointmentStatusUpdated.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.AppointmentStatusUpdated} returns this
 */ proto.appointment.AppointmentStatusUpdated.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional AppointmentStatus status = 3;
 * @return {!proto.appointment.AppointmentStatus}
 */ proto.appointment.AppointmentStatusUpdated.prototype.getStatus = function() {
    return /** @type {!proto.appointment.AppointmentStatus} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.appointment.AppointmentStatus} value
 * @return {!proto.appointment.AppointmentStatusUpdated} returns this
 */ proto.appointment.AppointmentStatusUpdated.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            appointment: (f = msg.getAppointment()) && proto.appointment.Appointment.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentUpdated}
 */ proto.appointment.AppointmentUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentUpdated;
    return proto.appointment.AppointmentUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentUpdated}
 */ proto.appointment.AppointmentUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 3:
                var value = new proto.appointment.Appointment;
                reader.readMessage(value, proto.appointment.Appointment.deserializeBinaryFromReader);
                msg.setAppointment(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getAppointment();
    if (f != null) writer.writeMessage(3, f, proto.appointment.Appointment.serializeBinaryToWriter);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment.AppointmentUpdated.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentUpdated} returns this
 */ proto.appointment.AppointmentUpdated.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 date = 2;
 * @return {number}
 */ proto.appointment.AppointmentUpdated.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.AppointmentUpdated} returns this
 */ proto.appointment.AppointmentUpdated.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional Appointment appointment = 3;
 * @return {?proto.appointment.Appointment}
 */ proto.appointment.AppointmentUpdated.prototype.getAppointment = function() {
    return /** @type{?proto.appointment.Appointment} */ $8M67s.Message.getWrapperField(this, proto.appointment.Appointment, 3);
};
/**
 * @param {?proto.appointment.Appointment|undefined} value
 * @return {!proto.appointment.AppointmentUpdated} returns this
*/ proto.appointment.AppointmentUpdated.prototype.setAppointment = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.AppointmentUpdated} returns this
 */ proto.appointment.AppointmentUpdated.prototype.clearAppointment = function() {
    return this.setAppointment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.AppointmentUpdated.prototype.hasAppointment = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentVehicleUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentVehicleUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentVehicleUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentVehicleUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vehicleInfo: (f = msg.getVehicleInfo()) && proto.appointment.VehicleInfo.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentVehicleUpdated}
 */ proto.appointment.AppointmentVehicleUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentVehicleUpdated;
    return proto.appointment.AppointmentVehicleUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentVehicleUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentVehicleUpdated}
 */ proto.appointment.AppointmentVehicleUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = new proto.appointment.VehicleInfo;
                reader.readMessage(value, proto.appointment.VehicleInfo.deserializeBinaryFromReader);
                msg.setVehicleInfo(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentVehicleUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentVehicleUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentVehicleUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentVehicleUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVehicleInfo();
    if (f != null) writer.writeMessage(3, f, proto.appointment.VehicleInfo.serializeBinaryToWriter);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment.AppointmentVehicleUpdated.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentVehicleUpdated} returns this
 */ proto.appointment.AppointmentVehicleUpdated.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.appointment.AppointmentVehicleUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentVehicleUpdated} returns this
 */ proto.appointment.AppointmentVehicleUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional VehicleInfo vehicle_info = 3;
 * @return {?proto.appointment.VehicleInfo}
 */ proto.appointment.AppointmentVehicleUpdated.prototype.getVehicleInfo = function() {
    return /** @type{?proto.appointment.VehicleInfo} */ $8M67s.Message.getWrapperField(this, proto.appointment.VehicleInfo, 3);
};
/**
 * @param {?proto.appointment.VehicleInfo|undefined} value
 * @return {!proto.appointment.AppointmentVehicleUpdated} returns this
*/ proto.appointment.AppointmentVehicleUpdated.prototype.setVehicleInfo = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.AppointmentVehicleUpdated} returns this
 */ proto.appointment.AppointmentVehicleUpdated.prototype.clearVehicleInfo = function() {
    return this.setVehicleInfo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.AppointmentVehicleUpdated.prototype.hasVehicleInfo = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AvailabilityCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AvailabilityCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AvailabilityCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AvailabilityCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            availability: (f = msg.getAvailability()) && proto.appointment.Availability.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AvailabilityCreated}
 */ proto.appointment.AvailabilityCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AvailabilityCreated;
    return proto.appointment.AvailabilityCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AvailabilityCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AvailabilityCreated}
 */ proto.appointment.AvailabilityCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.appointment.Availability;
                reader.readMessage(value, proto.appointment.Availability.deserializeBinaryFromReader);
                msg.setAvailability(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AvailabilityCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AvailabilityCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AvailabilityCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AvailabilityCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAvailability();
    if (f != null) writer.writeMessage(1, f, proto.appointment.Availability.serializeBinaryToWriter);
};
/**
 * optional Availability availability = 1;
 * @return {?proto.appointment.Availability}
 */ proto.appointment.AvailabilityCreated.prototype.getAvailability = function() {
    return /** @type{?proto.appointment.Availability} */ $8M67s.Message.getWrapperField(this, proto.appointment.Availability, 1);
};
/**
 * @param {?proto.appointment.Availability|undefined} value
 * @return {!proto.appointment.AvailabilityCreated} returns this
*/ proto.appointment.AvailabilityCreated.prototype.setAvailability = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.AvailabilityCreated} returns this
 */ proto.appointment.AvailabilityCreated.prototype.clearAvailability = function() {
    return this.setAvailability(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.AvailabilityCreated.prototype.hasAvailability = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentCheckoutStatus.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentCheckoutStatus} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentCheckoutStatus.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            inspectionComplete: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false),
            contractSignedSubmitted: $8M67s.Message.getBooleanFieldWithDefault(msg, 3, false),
            subscriptionActivated: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false),
            insuranceLinked: $8M67s.Message.getBooleanFieldWithDefault(msg, 5, false),
            licenseScanned: $8M67s.Message.getBooleanFieldWithDefault(msg, 6, false),
            paymentComplete: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            keyHandOff: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            lastUpdate: $8M67s.Message.getFieldWithDefault(msg, 12, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentCheckoutStatus}
 */ proto.appointment.AppointmentCheckoutStatus.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentCheckoutStatus;
    return proto.appointment.AppointmentCheckoutStatus.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentCheckoutStatus} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentCheckoutStatus}
 */ proto.appointment.AppointmentCheckoutStatus.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setInspectionComplete(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setContractSignedSubmitted(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSubscriptionActivated(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setInsuranceLinked(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setLicenseScanned(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPaymentComplete(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setKeyHandOff(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLastUpdate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentCheckoutStatus.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentCheckoutStatus} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentCheckoutStatus.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getInspectionComplete();
    if (f) writer.writeBool(2, f);
    f = message.getContractSignedSubmitted();
    if (f) writer.writeBool(3, f);
    f = message.getSubscriptionActivated();
    if (f) writer.writeBool(4, f);
    f = message.getInsuranceLinked();
    if (f) writer.writeBool(5, f);
    f = message.getLicenseScanned();
    if (f) writer.writeBool(6, f);
    f = message.getPaymentComplete();
    if (f) writer.writeBool(7, f);
    f = message.getKeyHandOff();
    if (f) writer.writeBool(8, f);
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getLastUpdate();
    if (f !== 0) writer.writeInt64(12, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool inspection_complete = 2;
 * @return {boolean}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getInspectionComplete = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setInspectionComplete = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
/**
 * optional bool contract_signed_submitted = 3;
 * @return {boolean}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getContractSignedSubmitted = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setContractSignedSubmitted = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 3, value);
};
/**
 * optional bool subscription_activated = 4;
 * @return {boolean}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getSubscriptionActivated = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setSubscriptionActivated = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
/**
 * optional bool insurance_linked = 5;
 * @return {boolean}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getInsuranceLinked = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setInsuranceLinked = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 5, value);
};
/**
 * optional bool license_scanned = 6;
 * @return {boolean}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getLicenseScanned = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setLicenseScanned = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 6, value);
};
/**
 * optional bool payment_complete = 7;
 * @return {boolean}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getPaymentComplete = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setPaymentComplete = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * optional bool key_hand_off = 8;
 * @return {boolean}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getKeyHandOff = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setKeyHandOff = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional string appointment_id = 9;
 * @return {string}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string reservation_id = 10;
 * @return {string}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string customer_id = 11;
 * @return {string}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional int64 last_update = 12;
 * @return {number}
 */ proto.appointment.AppointmentCheckoutStatus.prototype.getLastUpdate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.AppointmentCheckoutStatus} returns this
 */ proto.appointment.AppointmentCheckoutStatus.prototype.setLastUpdate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentKeyHandOff.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentKeyHandOff.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentKeyHandOff} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentKeyHandOff.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            userId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            keyQuantity: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            vehicleRegistration: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false),
            ownersManual: $8M67s.Message.getBooleanFieldWithDefault(msg, 5, false),
            floorMats: $8M67s.Message.getBooleanFieldWithDefault(msg, 6, false),
            chargerCable: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            chargerAdapter: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            optAdapter: $8M67s.Message.getBooleanFieldWithDefault(msg, 9, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentKeyHandOff}
 */ proto.appointment.AppointmentKeyHandOff.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentKeyHandOff;
    return proto.appointment.AppointmentKeyHandOff.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentKeyHandOff} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentKeyHandOff}
 */ proto.appointment.AppointmentKeyHandOff.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setKeyQuantity(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setVehicleRegistration(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setOwnersManual(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setFloorMats(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setChargerCable(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setChargerAdapter(value);
                break;
            case 9:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setOptAdapter(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentKeyHandOff.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentKeyHandOff.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentKeyHandOff} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentKeyHandOff.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getKeyQuantity();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getVehicleRegistration();
    if (f) writer.writeBool(4, f);
    f = message.getOwnersManual();
    if (f) writer.writeBool(5, f);
    f = message.getFloorMats();
    if (f) writer.writeBool(6, f);
    f = message.getChargerCable();
    if (f) writer.writeBool(7, f);
    f = message.getChargerAdapter();
    if (f) writer.writeBool(8, f);
    f = message.getOptAdapter();
    if (f) writer.writeBool(9, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string user_id = 2;
 * @return {string}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 key_quantity = 3;
 * @return {number}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getKeyQuantity = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setKeyQuantity = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional bool vehicle_registration = 4;
 * @return {boolean}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getVehicleRegistration = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setVehicleRegistration = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
/**
 * optional bool owners_manual = 5;
 * @return {boolean}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getOwnersManual = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setOwnersManual = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 5, value);
};
/**
 * optional bool floor_mats = 6;
 * @return {boolean}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getFloorMats = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setFloorMats = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 6, value);
};
/**
 * optional bool charger_cable = 7;
 * @return {boolean}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getChargerCable = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setChargerCable = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * optional bool charger_adapter = 8;
 * @return {boolean}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getChargerAdapter = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setChargerAdapter = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional bool opt_adapter = 9;
 * @return {boolean}
 */ proto.appointment.AppointmentKeyHandOff.prototype.getOptAdapter = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 9, false);
};
/**
 * @param {boolean} value
 * @return {!proto.appointment.AppointmentKeyHandOff} returns this
 */ proto.appointment.AppointmentKeyHandOff.prototype.setOptAdapter = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment.AppointmentPickupDate.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment.AppointmentPickupDate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment.AppointmentPickupDate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentPickupDate.toObject = function(includeInstance, msg) {
        var f, obj = {
            startTime: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            dealershipInfo: (f = msg.getDealershipInfo()) && proto.appointment.DealershipInfo.toObject(includeInstance, f),
            timeZone: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment.AppointmentPickupDate}
 */ proto.appointment.AppointmentPickupDate.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment.AppointmentPickupDate;
    return proto.appointment.AppointmentPickupDate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment.AppointmentPickupDate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment.AppointmentPickupDate}
 */ proto.appointment.AppointmentPickupDate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setStartTime(value);
                break;
            case 2:
                var value = new proto.appointment.DealershipInfo;
                reader.readMessage(value, proto.appointment.DealershipInfo.deserializeBinaryFromReader);
                msg.setDealershipInfo(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTimeZone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment.AppointmentPickupDate.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment.AppointmentPickupDate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment.AppointmentPickupDate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment.AppointmentPickupDate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStartTime();
    if (f !== 0) writer.writeInt64(1, f);
    f = message.getDealershipInfo();
    if (f != null) writer.writeMessage(2, f, proto.appointment.DealershipInfo.serializeBinaryToWriter);
    f = message.getTimeZone();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional int64 start_time = 1;
 * @return {number}
 */ proto.appointment.AppointmentPickupDate.prototype.getStartTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment.AppointmentPickupDate} returns this
 */ proto.appointment.AppointmentPickupDate.prototype.setStartTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional DealershipInfo dealership_info = 2;
 * @return {?proto.appointment.DealershipInfo}
 */ proto.appointment.AppointmentPickupDate.prototype.getDealershipInfo = function() {
    return /** @type{?proto.appointment.DealershipInfo} */ $8M67s.Message.getWrapperField(this, proto.appointment.DealershipInfo, 2);
};
/**
 * @param {?proto.appointment.DealershipInfo|undefined} value
 * @return {!proto.appointment.AppointmentPickupDate} returns this
*/ proto.appointment.AppointmentPickupDate.prototype.setDealershipInfo = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment.AppointmentPickupDate} returns this
 */ proto.appointment.AppointmentPickupDate.prototype.clearDealershipInfo = function() {
    return this.setDealershipInfo(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment.AppointmentPickupDate.prototype.hasDealershipInfo = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional string time_zone = 3;
 * @return {string}
 */ proto.appointment.AppointmentPickupDate.prototype.getTimeZone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment.AppointmentPickupDate} returns this
 */ proto.appointment.AppointmentPickupDate.prototype.setTimeZone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * @enum {number}
 */ proto.appointment.AppointmentType = {
    PICKUP: 0,
    TRANSPORT: 1,
    DIRECT: 2,
    RETURN: 3,
    ANY: 4,
    PICKUP_SWAP: 5,
    TRANSPORT_SWAP: 6
};
/**
 * @enum {number}
 */ proto.appointment.AppointmentStatus = {
    SCHEDULED: 0,
    RESCHEDULED: 1,
    CANCELLED: 2,
    DONE: 3
};
$b1232c8ea2af4fd3$var$goog.object.extend(module.exports, proto.appointment);

});

parcelRegister("7QrRI", function(module, exports) {
// source: appointment_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $5b6301317dc38047$var$goog = $8M67s;
var $5b6301317dc38047$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$5b6301317dc38047$var$goog.object.extend(proto, $3QqPt);

var $fcTGK = parcelRequire("fcTGK");
$5b6301317dc38047$var$goog.object.extend(proto, $fcTGK);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.AppointmentKeyHandOffRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.AppointmentKeyHandOffResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.Area', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.Calendar', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.CancelAppointmentRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.CancelAppointmentResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.CreateAppointmentRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.CreateAppointmentResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.CreateAvailabilityRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.CreateAvailabilityResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.DeleteAvailabilityRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.DeleteAvailabilityResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAppointmentCheckoutStatusRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAppointmentCheckoutStatusResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAppointmentKeyHandOffRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAppointmentKeyHandOffResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAppointmentPickupDateRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAppointmentPickupDateResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAppointmentRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAppointmentResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAvailabilityRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAvailabilityResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAvailabilitySlotsRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetAvailabilitySlotsResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetPreAppointmentCheckoutStatusRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.GetPreAppointmentCheckoutStatusResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.ListAppointmentsRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.ListAppointmentsResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.ListCompletedAppointmentsRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.ListCompletedAppointmentsResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.Location', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.MigrateAppointmentDataRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.MigrateAppointmentDataResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.UpdateAppointmentRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.UpdateAppointmentResponse', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.UpdateAvailabilityRequest', null, $5b6301317dc38047$var$global);
$5b6301317dc38047$var$goog.exportSymbol('proto.appointment_service.UpdateAvailabilityResponse', null, $5b6301317dc38047$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.CreateAvailabilityRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.CreateAvailabilityRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.CreateAvailabilityRequest.displayName = 'proto.appointment_service.CreateAvailabilityRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.CreateAvailabilityResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.CreateAvailabilityResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.CreateAvailabilityResponse.displayName = 'proto.appointment_service.CreateAvailabilityResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.UpdateAvailabilityRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.UpdateAvailabilityRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.UpdateAvailabilityRequest.displayName = 'proto.appointment_service.UpdateAvailabilityRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.UpdateAvailabilityResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.UpdateAvailabilityResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.UpdateAvailabilityResponse.displayName = 'proto.appointment_service.UpdateAvailabilityResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.DeleteAvailabilityRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.DeleteAvailabilityRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.DeleteAvailabilityRequest.displayName = 'proto.appointment_service.DeleteAvailabilityRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.DeleteAvailabilityResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.DeleteAvailabilityResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.DeleteAvailabilityResponse.displayName = 'proto.appointment_service.DeleteAvailabilityResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAvailabilitySlotsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAvailabilitySlotsRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAvailabilitySlotsRequest.displayName = 'proto.appointment_service.GetAvailabilitySlotsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAvailabilitySlotsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.appointment_service.GetAvailabilitySlotsResponse.repeatedFields_, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAvailabilitySlotsResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAvailabilitySlotsResponse.displayName = 'proto.appointment_service.GetAvailabilitySlotsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAvailabilityRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAvailabilityRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAvailabilityRequest.displayName = 'proto.appointment_service.GetAvailabilityRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAvailabilityResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.appointment_service.GetAvailabilityResponse.repeatedFields_, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAvailabilityResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAvailabilityResponse.displayName = 'proto.appointment_service.GetAvailabilityResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.CreateAppointmentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.CreateAppointmentRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.CreateAppointmentRequest.displayName = 'proto.appointment_service.CreateAppointmentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.CreateAppointmentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.CreateAppointmentResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.CreateAppointmentResponse.displayName = 'proto.appointment_service.CreateAppointmentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAppointmentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAppointmentRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAppointmentRequest.displayName = 'proto.appointment_service.GetAppointmentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAppointmentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAppointmentResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAppointmentResponse.displayName = 'proto.appointment_service.GetAppointmentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.ListAppointmentsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.ListAppointmentsRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.ListAppointmentsRequest.displayName = 'proto.appointment_service.ListAppointmentsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.ListAppointmentsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.appointment_service.ListAppointmentsResponse.repeatedFields_, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.ListAppointmentsResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.ListAppointmentsResponse.displayName = 'proto.appointment_service.ListAppointmentsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.UpdateAppointmentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.UpdateAppointmentRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.UpdateAppointmentRequest.displayName = 'proto.appointment_service.UpdateAppointmentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.UpdateAppointmentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.UpdateAppointmentResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.UpdateAppointmentResponse.displayName = 'proto.appointment_service.UpdateAppointmentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.CancelAppointmentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.CancelAppointmentRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.CancelAppointmentRequest.displayName = 'proto.appointment_service.CancelAppointmentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.CancelAppointmentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.CancelAppointmentResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.CancelAppointmentResponse.displayName = 'proto.appointment_service.CancelAppointmentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.Area = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.Area, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.Area.displayName = 'proto.appointment_service.Area';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.Location = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.Location, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.Location.displayName = 'proto.appointment_service.Location';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.Calendar = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.appointment_service.Calendar.repeatedFields_, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.Calendar, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.Calendar.displayName = 'proto.appointment_service.Calendar';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAppointmentCheckoutStatusRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.displayName = 'proto.appointment_service.GetAppointmentCheckoutStatusRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAppointmentCheckoutStatusResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.displayName = 'proto.appointment_service.GetAppointmentCheckoutStatusResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.AppointmentKeyHandOffRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.AppointmentKeyHandOffRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.AppointmentKeyHandOffRequest.displayName = 'proto.appointment_service.AppointmentKeyHandOffRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.AppointmentKeyHandOffResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.AppointmentKeyHandOffResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.AppointmentKeyHandOffResponse.displayName = 'proto.appointment_service.AppointmentKeyHandOffResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAppointmentKeyHandOffRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAppointmentKeyHandOffRequest.displayName = 'proto.appointment_service.GetAppointmentKeyHandOffRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAppointmentKeyHandOffResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAppointmentKeyHandOffResponse.displayName = 'proto.appointment_service.GetAppointmentKeyHandOffResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAppointmentPickupDateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAppointmentPickupDateRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAppointmentPickupDateRequest.displayName = 'proto.appointment_service.GetAppointmentPickupDateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetAppointmentPickupDateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetAppointmentPickupDateResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetAppointmentPickupDateResponse.displayName = 'proto.appointment_service.GetAppointmentPickupDateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.ListCompletedAppointmentsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.ListCompletedAppointmentsRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.ListCompletedAppointmentsRequest.displayName = 'proto.appointment_service.ListCompletedAppointmentsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.ListCompletedAppointmentsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.appointment_service.ListCompletedAppointmentsResponse.repeatedFields_, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.ListCompletedAppointmentsResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.ListCompletedAppointmentsResponse.displayName = 'proto.appointment_service.ListCompletedAppointmentsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetPreAppointmentCheckoutStatusRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.displayName = 'proto.appointment_service.GetPreAppointmentCheckoutStatusRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.GetPreAppointmentCheckoutStatusResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.displayName = 'proto.appointment_service.GetPreAppointmentCheckoutStatusResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.MigrateAppointmentDataRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.MigrateAppointmentDataRequest, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.MigrateAppointmentDataRequest.displayName = 'proto.appointment_service.MigrateAppointmentDataRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.appointment_service.MigrateAppointmentDataResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$5b6301317dc38047$var$goog.inherits(proto.appointment_service.MigrateAppointmentDataResponse, $8M67s.Message);
if ($5b6301317dc38047$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.appointment_service.MigrateAppointmentDataResponse.displayName = 'proto.appointment_service.MigrateAppointmentDataResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.CreateAvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.CreateAvailabilityRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.CreateAvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CreateAvailabilityRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            availableTime: (f = msg.getAvailableTime()) && $fcTGK.AvailableTime.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.CreateAvailabilityRequest}
 */ proto.appointment_service.CreateAvailabilityRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.CreateAvailabilityRequest;
    return proto.appointment_service.CreateAvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.CreateAvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.CreateAvailabilityRequest}
 */ proto.appointment_service.CreateAvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.AvailableTime;
                reader.readMessage(value, $fcTGK.AvailableTime.deserializeBinaryFromReader);
                msg.setAvailableTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.CreateAvailabilityRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.CreateAvailabilityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.CreateAvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CreateAvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAvailableTime();
    if (f != null) writer.writeMessage(1, f, $fcTGK.AvailableTime.serializeBinaryToWriter);
};
/**
 * optional appointment.AvailableTime available_time = 1;
 * @return {?proto.appointment.AvailableTime}
 */ proto.appointment_service.CreateAvailabilityRequest.prototype.getAvailableTime = function() {
    return /** @type{?proto.appointment.AvailableTime} */ $8M67s.Message.getWrapperField(this, $fcTGK.AvailableTime, 1);
};
/**
 * @param {?proto.appointment.AvailableTime|undefined} value
 * @return {!proto.appointment_service.CreateAvailabilityRequest} returns this
*/ proto.appointment_service.CreateAvailabilityRequest.prototype.setAvailableTime = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.CreateAvailabilityRequest} returns this
 */ proto.appointment_service.CreateAvailabilityRequest.prototype.clearAvailableTime = function() {
    return this.setAvailableTime(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.CreateAvailabilityRequest.prototype.hasAvailableTime = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.CreateAvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.CreateAvailabilityResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.CreateAvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CreateAvailabilityResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            availableTime: (f = msg.getAvailableTime()) && $fcTGK.AvailableTime.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.CreateAvailabilityResponse}
 */ proto.appointment_service.CreateAvailabilityResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.CreateAvailabilityResponse;
    return proto.appointment_service.CreateAvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.CreateAvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.CreateAvailabilityResponse}
 */ proto.appointment_service.CreateAvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.AvailableTime;
                reader.readMessage(value, $fcTGK.AvailableTime.deserializeBinaryFromReader);
                msg.setAvailableTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.CreateAvailabilityResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.CreateAvailabilityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.CreateAvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CreateAvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAvailableTime();
    if (f != null) writer.writeMessage(1, f, $fcTGK.AvailableTime.serializeBinaryToWriter);
};
/**
 * optional appointment.AvailableTime available_time = 1;
 * @return {?proto.appointment.AvailableTime}
 */ proto.appointment_service.CreateAvailabilityResponse.prototype.getAvailableTime = function() {
    return /** @type{?proto.appointment.AvailableTime} */ $8M67s.Message.getWrapperField(this, $fcTGK.AvailableTime, 1);
};
/**
 * @param {?proto.appointment.AvailableTime|undefined} value
 * @return {!proto.appointment_service.CreateAvailabilityResponse} returns this
*/ proto.appointment_service.CreateAvailabilityResponse.prototype.setAvailableTime = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.CreateAvailabilityResponse} returns this
 */ proto.appointment_service.CreateAvailabilityResponse.prototype.clearAvailableTime = function() {
    return this.setAvailableTime(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.CreateAvailabilityResponse.prototype.hasAvailableTime = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.UpdateAvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.UpdateAvailabilityRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.UpdateAvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.UpdateAvailabilityRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.UpdateAvailabilityRequest}
 */ proto.appointment_service.UpdateAvailabilityRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.UpdateAvailabilityRequest;
    return proto.appointment_service.UpdateAvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.UpdateAvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.UpdateAvailabilityRequest}
 */ proto.appointment_service.UpdateAvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.UpdateAvailabilityRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.UpdateAvailabilityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.UpdateAvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.UpdateAvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.UpdateAvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.UpdateAvailabilityResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.UpdateAvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.UpdateAvailabilityResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.UpdateAvailabilityResponse}
 */ proto.appointment_service.UpdateAvailabilityResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.UpdateAvailabilityResponse;
    return proto.appointment_service.UpdateAvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.UpdateAvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.UpdateAvailabilityResponse}
 */ proto.appointment_service.UpdateAvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.UpdateAvailabilityResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.UpdateAvailabilityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.UpdateAvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.UpdateAvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.DeleteAvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.DeleteAvailabilityRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.DeleteAvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.DeleteAvailabilityRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.DeleteAvailabilityRequest}
 */ proto.appointment_service.DeleteAvailabilityRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.DeleteAvailabilityRequest;
    return proto.appointment_service.DeleteAvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.DeleteAvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.DeleteAvailabilityRequest}
 */ proto.appointment_service.DeleteAvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.DeleteAvailabilityRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.DeleteAvailabilityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.DeleteAvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.DeleteAvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.DeleteAvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.DeleteAvailabilityResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.DeleteAvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.DeleteAvailabilityResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.DeleteAvailabilityResponse}
 */ proto.appointment_service.DeleteAvailabilityResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.DeleteAvailabilityResponse;
    return proto.appointment_service.DeleteAvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.DeleteAvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.DeleteAvailabilityResponse}
 */ proto.appointment_service.DeleteAvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.DeleteAvailabilityResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.DeleteAvailabilityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.DeleteAvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.DeleteAvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAvailabilitySlotsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAvailabilitySlotsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAvailabilitySlotsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAvailabilitySlotsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            startTime: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            endTime: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAvailabilitySlotsRequest}
 */ proto.appointment_service.GetAvailabilitySlotsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAvailabilitySlotsRequest;
    return proto.appointment_service.GetAvailabilitySlotsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAvailabilitySlotsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAvailabilitySlotsRequest}
 */ proto.appointment_service.GetAvailabilitySlotsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setStartTime(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setEndTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAvailabilitySlotsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAvailabilitySlotsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAvailabilitySlotsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAvailabilitySlotsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getStartTime();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getEndTime();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.appointment_service.GetAvailabilitySlotsRequest.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.GetAvailabilitySlotsRequest} returns this
 */ proto.appointment_service.GetAvailabilitySlotsRequest.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 start_time = 2;
 * @return {number}
 */ proto.appointment_service.GetAvailabilitySlotsRequest.prototype.getStartTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.GetAvailabilitySlotsRequest} returns this
 */ proto.appointment_service.GetAvailabilitySlotsRequest.prototype.setStartTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int64 end_time = 3;
 * @return {number}
 */ proto.appointment_service.GetAvailabilitySlotsRequest.prototype.getEndTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.GetAvailabilitySlotsRequest} returns this
 */ proto.appointment_service.GetAvailabilitySlotsRequest.prototype.setEndTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.appointment_service.GetAvailabilitySlotsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAvailabilitySlotsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAvailabilitySlotsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAvailabilitySlotsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAvailabilitySlotsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            availabilityList: $8M67s.Message.toObjectList(msg.getAvailabilityList(), $fcTGK.Availability.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAvailabilitySlotsResponse}
 */ proto.appointment_service.GetAvailabilitySlotsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAvailabilitySlotsResponse;
    return proto.appointment_service.GetAvailabilitySlotsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAvailabilitySlotsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAvailabilitySlotsResponse}
 */ proto.appointment_service.GetAvailabilitySlotsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.Availability;
                reader.readMessage(value, $fcTGK.Availability.deserializeBinaryFromReader);
                msg.addAvailability(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAvailabilitySlotsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAvailabilitySlotsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAvailabilitySlotsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAvailabilitySlotsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAvailabilityList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $fcTGK.Availability.serializeBinaryToWriter);
};
/**
 * repeated appointment.Availability availability = 1;
 * @return {!Array<!proto.appointment.Availability>}
 */ proto.appointment_service.GetAvailabilitySlotsResponse.prototype.getAvailabilityList = function() {
    return /** @type{!Array<!proto.appointment.Availability>} */ $8M67s.Message.getRepeatedWrapperField(this, $fcTGK.Availability, 1);
};
/**
 * @param {!Array<!proto.appointment.Availability>} value
 * @return {!proto.appointment_service.GetAvailabilitySlotsResponse} returns this
*/ proto.appointment_service.GetAvailabilitySlotsResponse.prototype.setAvailabilityList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.appointment.Availability=} opt_value
 * @param {number=} opt_index
 * @return {!proto.appointment.Availability}
 */ proto.appointment_service.GetAvailabilitySlotsResponse.prototype.addAvailability = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.appointment.Availability, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.appointment_service.GetAvailabilitySlotsResponse} returns this
 */ proto.appointment_service.GetAvailabilitySlotsResponse.prototype.clearAvailabilityList = function() {
    return this.setAvailabilityList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAvailabilityRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAvailabilityRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAvailabilityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAvailabilityRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAvailabilityRequest}
 */ proto.appointment_service.GetAvailabilityRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAvailabilityRequest;
    return proto.appointment_service.GetAvailabilityRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAvailabilityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAvailabilityRequest}
 */ proto.appointment_service.GetAvailabilityRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAvailabilityRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAvailabilityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAvailabilityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAvailabilityRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.appointment_service.GetAvailabilityRequest.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.GetAvailabilityRequest} returns this
 */ proto.appointment_service.GetAvailabilityRequest.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.appointment_service.GetAvailabilityResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAvailabilityResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAvailabilityResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            availableTimesList: $8M67s.Message.toObjectList(msg.getAvailableTimesList(), $fcTGK.AvailableTime.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAvailabilityResponse}
 */ proto.appointment_service.GetAvailabilityResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAvailabilityResponse;
    return proto.appointment_service.GetAvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAvailabilityResponse}
 */ proto.appointment_service.GetAvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.AvailableTime;
                reader.readMessage(value, $fcTGK.AvailableTime.deserializeBinaryFromReader);
                msg.addAvailableTimes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAvailabilityResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAvailabilityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAvailableTimesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $fcTGK.AvailableTime.serializeBinaryToWriter);
};
/**
 * repeated appointment.AvailableTime available_times = 1;
 * @return {!Array<!proto.appointment.AvailableTime>}
 */ proto.appointment_service.GetAvailabilityResponse.prototype.getAvailableTimesList = function() {
    return /** @type{!Array<!proto.appointment.AvailableTime>} */ $8M67s.Message.getRepeatedWrapperField(this, $fcTGK.AvailableTime, 1);
};
/**
 * @param {!Array<!proto.appointment.AvailableTime>} value
 * @return {!proto.appointment_service.GetAvailabilityResponse} returns this
*/ proto.appointment_service.GetAvailabilityResponse.prototype.setAvailableTimesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.appointment.AvailableTime=} opt_value
 * @param {number=} opt_index
 * @return {!proto.appointment.AvailableTime}
 */ proto.appointment_service.GetAvailabilityResponse.prototype.addAvailableTimes = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.appointment.AvailableTime, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.appointment_service.GetAvailabilityResponse} returns this
 */ proto.appointment_service.GetAvailabilityResponse.prototype.clearAvailableTimesList = function() {
    return this.setAvailableTimesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.CreateAppointmentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.CreateAppointmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CreateAppointmentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            employeeId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            startTime: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            duration: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            appointmentType: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            timeZone: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            note: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            noteAuthor: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.CreateAppointmentRequest}
 */ proto.appointment_service.CreateAppointmentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.CreateAppointmentRequest;
    return proto.appointment_service.CreateAppointmentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.CreateAppointmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.CreateAppointmentRequest}
 */ proto.appointment_service.CreateAppointmentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEmployeeId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setStartTime(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDuration(value);
                break;
            case 6:
                var value = /** @type {!proto.appointment.AppointmentType} */ reader.readEnum();
                msg.setAppointmentType(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setTimeZone(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setNote(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setNoteAuthor(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.CreateAppointmentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.CreateAppointmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CreateAppointmentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getEmployeeId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getStartTime();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getDuration();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getAppointmentType();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getTimeZone();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getNote();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getNoteAuthor();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string employee_id = 2;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getEmployeeId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setEmployeeId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 start_time = 4;
 * @return {number}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getStartTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setStartTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 duration = 5;
 * @return {number}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getDuration = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setDuration = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional appointment.AppointmentType appointment_type = 6;
 * @return {!proto.appointment.AppointmentType}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getAppointmentType = function() {
    return /** @type {!proto.appointment.AppointmentType} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.appointment.AppointmentType} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setAppointmentType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional string time_zone = 7;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getTimeZone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setTimeZone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string note = 8;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getNote = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setNote = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string note_author = 9;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getNoteAuthor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setNoteAuthor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string reservation_id = 10;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string subscription_id = 11;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentRequest} returns this
 */ proto.appointment_service.CreateAppointmentRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.CreateAppointmentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.CreateAppointmentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.CreateAppointmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CreateAppointmentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            errorMessage: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.CreateAppointmentResponse}
 */ proto.appointment_service.CreateAppointmentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.CreateAppointmentResponse;
    return proto.appointment_service.CreateAppointmentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.CreateAppointmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.CreateAppointmentResponse}
 */ proto.appointment_service.CreateAppointmentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setErrorMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.CreateAppointmentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.CreateAppointmentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.CreateAppointmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CreateAppointmentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getErrorMessage();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentResponse.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentResponse} returns this
 */ proto.appointment_service.CreateAppointmentResponse.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string error_message = 2;
 * @return {string}
 */ proto.appointment_service.CreateAppointmentResponse.prototype.getErrorMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CreateAppointmentResponse} returns this
 */ proto.appointment_service.CreateAppointmentResponse.prototype.setErrorMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAppointmentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAppointmentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAppointmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAppointmentRequest}
 */ proto.appointment_service.GetAppointmentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAppointmentRequest;
    return proto.appointment_service.GetAppointmentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAppointmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAppointmentRequest}
 */ proto.appointment_service.GetAppointmentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAppointmentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAppointmentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAppointmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment_service.GetAppointmentRequest.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.GetAppointmentRequest} returns this
 */ proto.appointment_service.GetAppointmentRequest.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAppointmentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAppointmentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAppointmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointment: (f = msg.getAppointment()) && $fcTGK.Appointment.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAppointmentResponse}
 */ proto.appointment_service.GetAppointmentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAppointmentResponse;
    return proto.appointment_service.GetAppointmentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAppointmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAppointmentResponse}
 */ proto.appointment_service.GetAppointmentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.Appointment;
                reader.readMessage(value, $fcTGK.Appointment.deserializeBinaryFromReader);
                msg.setAppointment(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAppointmentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAppointmentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAppointmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointment();
    if (f != null) writer.writeMessage(1, f, $fcTGK.Appointment.serializeBinaryToWriter);
};
/**
 * optional appointment.Appointment appointment = 1;
 * @return {?proto.appointment.Appointment}
 */ proto.appointment_service.GetAppointmentResponse.prototype.getAppointment = function() {
    return /** @type{?proto.appointment.Appointment} */ $8M67s.Message.getWrapperField(this, $fcTGK.Appointment, 1);
};
/**
 * @param {?proto.appointment.Appointment|undefined} value
 * @return {!proto.appointment_service.GetAppointmentResponse} returns this
*/ proto.appointment_service.GetAppointmentResponse.prototype.setAppointment = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.GetAppointmentResponse} returns this
 */ proto.appointment_service.GetAppointmentResponse.prototype.clearAppointment = function() {
    return this.setAppointment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.GetAppointmentResponse.prototype.hasAppointment = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.ListAppointmentsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.ListAppointmentsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.ListAppointmentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.ListAppointmentsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            daysOut: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.ListAppointmentsRequest}
 */ proto.appointment_service.ListAppointmentsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.ListAppointmentsRequest;
    return proto.appointment_service.ListAppointmentsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.ListAppointmentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.ListAppointmentsRequest}
 */ proto.appointment_service.ListAppointmentsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDaysOut(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.ListAppointmentsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.ListAppointmentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.ListAppointmentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.ListAppointmentsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDaysOut();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.appointment_service.ListAppointmentsRequest.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.ListAppointmentsRequest} returns this
 */ proto.appointment_service.ListAppointmentsRequest.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 days_out = 2;
 * @return {number}
 */ proto.appointment_service.ListAppointmentsRequest.prototype.getDaysOut = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.ListAppointmentsRequest} returns this
 */ proto.appointment_service.ListAppointmentsRequest.prototype.setDaysOut = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.appointment_service.ListAppointmentsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.ListAppointmentsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.ListAppointmentsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.ListAppointmentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.ListAppointmentsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentsList: $8M67s.Message.toObjectList(msg.getAppointmentsList(), $fcTGK.Appointment.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.ListAppointmentsResponse}
 */ proto.appointment_service.ListAppointmentsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.ListAppointmentsResponse;
    return proto.appointment_service.ListAppointmentsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.ListAppointmentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.ListAppointmentsResponse}
 */ proto.appointment_service.ListAppointmentsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.Appointment;
                reader.readMessage(value, $fcTGK.Appointment.deserializeBinaryFromReader);
                msg.addAppointments(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.ListAppointmentsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.ListAppointmentsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.ListAppointmentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.ListAppointmentsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $fcTGK.Appointment.serializeBinaryToWriter);
};
/**
 * repeated appointment.Appointment appointments = 1;
 * @return {!Array<!proto.appointment.Appointment>}
 */ proto.appointment_service.ListAppointmentsResponse.prototype.getAppointmentsList = function() {
    return /** @type{!Array<!proto.appointment.Appointment>} */ $8M67s.Message.getRepeatedWrapperField(this, $fcTGK.Appointment, 1);
};
/**
 * @param {!Array<!proto.appointment.Appointment>} value
 * @return {!proto.appointment_service.ListAppointmentsResponse} returns this
*/ proto.appointment_service.ListAppointmentsResponse.prototype.setAppointmentsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.appointment.Appointment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.appointment.Appointment}
 */ proto.appointment_service.ListAppointmentsResponse.prototype.addAppointments = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.appointment.Appointment, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.appointment_service.ListAppointmentsResponse} returns this
 */ proto.appointment_service.ListAppointmentsResponse.prototype.clearAppointmentsList = function() {
    return this.setAppointmentsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.UpdateAppointmentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.UpdateAppointmentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.UpdateAppointmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.UpdateAppointmentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointment: (f = msg.getAppointment()) && $fcTGK.Appointment.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.UpdateAppointmentRequest}
 */ proto.appointment_service.UpdateAppointmentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.UpdateAppointmentRequest;
    return proto.appointment_service.UpdateAppointmentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.UpdateAppointmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.UpdateAppointmentRequest}
 */ proto.appointment_service.UpdateAppointmentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.Appointment;
                reader.readMessage(value, $fcTGK.Appointment.deserializeBinaryFromReader);
                msg.setAppointment(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.UpdateAppointmentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.UpdateAppointmentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.UpdateAppointmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.UpdateAppointmentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointment();
    if (f != null) writer.writeMessage(1, f, $fcTGK.Appointment.serializeBinaryToWriter);
};
/**
 * optional appointment.Appointment appointment = 1;
 * @return {?proto.appointment.Appointment}
 */ proto.appointment_service.UpdateAppointmentRequest.prototype.getAppointment = function() {
    return /** @type{?proto.appointment.Appointment} */ $8M67s.Message.getWrapperField(this, $fcTGK.Appointment, 1);
};
/**
 * @param {?proto.appointment.Appointment|undefined} value
 * @return {!proto.appointment_service.UpdateAppointmentRequest} returns this
*/ proto.appointment_service.UpdateAppointmentRequest.prototype.setAppointment = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.UpdateAppointmentRequest} returns this
 */ proto.appointment_service.UpdateAppointmentRequest.prototype.clearAppointment = function() {
    return this.setAppointment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.UpdateAppointmentRequest.prototype.hasAppointment = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.UpdateAppointmentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.UpdateAppointmentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.UpdateAppointmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.UpdateAppointmentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.UpdateAppointmentResponse}
 */ proto.appointment_service.UpdateAppointmentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.UpdateAppointmentResponse;
    return proto.appointment_service.UpdateAppointmentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.UpdateAppointmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.UpdateAppointmentResponse}
 */ proto.appointment_service.UpdateAppointmentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.UpdateAppointmentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.UpdateAppointmentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.UpdateAppointmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.UpdateAppointmentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment_service.UpdateAppointmentResponse.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.UpdateAppointmentResponse} returns this
 */ proto.appointment_service.UpdateAppointmentResponse.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.CancelAppointmentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.CancelAppointmentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.CancelAppointmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CancelAppointmentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.CancelAppointmentRequest}
 */ proto.appointment_service.CancelAppointmentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.CancelAppointmentRequest;
    return proto.appointment_service.CancelAppointmentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.CancelAppointmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.CancelAppointmentRequest}
 */ proto.appointment_service.CancelAppointmentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.CancelAppointmentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.CancelAppointmentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.CancelAppointmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CancelAppointmentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment_service.CancelAppointmentRequest.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.CancelAppointmentRequest} returns this
 */ proto.appointment_service.CancelAppointmentRequest.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.CancelAppointmentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.CancelAppointmentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.CancelAppointmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CancelAppointmentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.CancelAppointmentResponse}
 */ proto.appointment_service.CancelAppointmentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.CancelAppointmentResponse;
    return proto.appointment_service.CancelAppointmentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.CancelAppointmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.CancelAppointmentResponse}
 */ proto.appointment_service.CancelAppointmentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.CancelAppointmentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.CancelAppointmentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.CancelAppointmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.CancelAppointmentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.Area.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.Area.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.Area} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.Area.toObject = function(includeInstance, msg) {
        var f, obj = {
            zipCode: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            radius: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.Area}
 */ proto.appointment_service.Area.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.Area;
    return proto.appointment_service.Area.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.Area} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.Area}
 */ proto.appointment_service.Area.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setZipCode(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readFloat();
                msg.setRadius(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.Area.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.Area.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.Area} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.Area.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getZipCode();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getRadius();
    if (f !== 0.0) writer.writeFloat(2, f);
};
/**
 * optional int32 zip_code = 1;
 * @return {number}
 */ proto.appointment_service.Area.prototype.getZipCode = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.Area} returns this
 */ proto.appointment_service.Area.prototype.setZipCode = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional float radius = 2;
 * @return {number}
 */ proto.appointment_service.Area.prototype.getRadius = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 2, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.Area} returns this
 */ proto.appointment_service.Area.prototype.setRadius = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.Location.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.Location.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.Location.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = msg.getAddress()) && $3QqPt.Address.toObject(includeInstance, f),
            lat: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
            pb_long: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.Location}
 */ proto.appointment_service.Location.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.Location;
    return proto.appointment_service.Location.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.Location}
 */ proto.appointment_service.Location.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLat(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLong(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.Location.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.Location.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.Location.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddress();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getLat();
    if (f !== 0.0) writer.writeFloat(2, f);
    f = message.getLong();
    if (f !== 0.0) writer.writeFloat(3, f);
};
/**
 * optional domain.Address address = 1;
 * @return {?proto.domain.Address}
 */ proto.appointment_service.Location.prototype.getAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 1);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.appointment_service.Location} returns this
*/ proto.appointment_service.Location.prototype.setAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.Location} returns this
 */ proto.appointment_service.Location.prototype.clearAddress = function() {
    return this.setAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.Location.prototype.hasAddress = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional float lat = 2;
 * @return {number}
 */ proto.appointment_service.Location.prototype.getLat = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 2, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.Location} returns this
 */ proto.appointment_service.Location.prototype.setLat = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 2, value);
};
/**
 * optional float long = 3;
 * @return {number}
 */ proto.appointment_service.Location.prototype.getLong = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 3, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.appointment_service.Location} returns this
 */ proto.appointment_service.Location.prototype.setLong = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.appointment_service.Calendar.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.Calendar.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.Calendar.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.Calendar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.Calendar.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            availabilityList: $8M67s.Message.toObjectList(msg.getAvailabilityList(), $fcTGK.Availability.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.Calendar}
 */ proto.appointment_service.Calendar.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.Calendar;
    return proto.appointment_service.Calendar.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.Calendar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.Calendar}
 */ proto.appointment_service.Calendar.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = new $fcTGK.Availability;
                reader.readMessage(value, $fcTGK.Availability.deserializeBinaryFromReader);
                msg.addAvailability(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.Calendar.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.Calendar.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.Calendar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.Calendar.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAvailabilityList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $fcTGK.Availability.serializeBinaryToWriter);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.appointment_service.Calendar.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.Calendar} returns this
 */ proto.appointment_service.Calendar.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated appointment.Availability availability = 2;
 * @return {!Array<!proto.appointment.Availability>}
 */ proto.appointment_service.Calendar.prototype.getAvailabilityList = function() {
    return /** @type{!Array<!proto.appointment.Availability>} */ $8M67s.Message.getRepeatedWrapperField(this, $fcTGK.Availability, 2);
};
/**
 * @param {!Array<!proto.appointment.Availability>} value
 * @return {!proto.appointment_service.Calendar} returns this
*/ proto.appointment_service.Calendar.prototype.setAvailabilityList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.appointment.Availability=} opt_value
 * @param {number=} opt_index
 * @return {!proto.appointment.Availability}
 */ proto.appointment_service.Calendar.prototype.addAvailability = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.appointment.Availability, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.appointment_service.Calendar} returns this
 */ proto.appointment_service.Calendar.prototype.clearAvailabilityList = function() {
    return this.setAvailabilityList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAppointmentCheckoutStatusRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAppointmentCheckoutStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAppointmentCheckoutStatusRequest}
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAppointmentCheckoutStatusRequest;
    return proto.appointment_service.GetAppointmentCheckoutStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAppointmentCheckoutStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAppointmentCheckoutStatusRequest}
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAppointmentCheckoutStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAppointmentCheckoutStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.GetAppointmentCheckoutStatusRequest} returns this
 */ proto.appointment_service.GetAppointmentCheckoutStatusRequest.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAppointmentCheckoutStatusResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAppointmentCheckoutStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentCheckoutStatus: (f = msg.getAppointmentCheckoutStatus()) && $fcTGK.AppointmentCheckoutStatus.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAppointmentCheckoutStatusResponse}
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAppointmentCheckoutStatusResponse;
    return proto.appointment_service.GetAppointmentCheckoutStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAppointmentCheckoutStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAppointmentCheckoutStatusResponse}
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.AppointmentCheckoutStatus;
                reader.readMessage(value, $fcTGK.AppointmentCheckoutStatus.deserializeBinaryFromReader);
                msg.setAppointmentCheckoutStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAppointmentCheckoutStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAppointmentCheckoutStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentCheckoutStatus();
    if (f != null) writer.writeMessage(1, f, $fcTGK.AppointmentCheckoutStatus.serializeBinaryToWriter);
};
/**
 * optional appointment.AppointmentCheckoutStatus appointment_checkout_status = 1;
 * @return {?proto.appointment.AppointmentCheckoutStatus}
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.prototype.getAppointmentCheckoutStatus = function() {
    return /** @type{?proto.appointment.AppointmentCheckoutStatus} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentCheckoutStatus, 1);
};
/**
 * @param {?proto.appointment.AppointmentCheckoutStatus|undefined} value
 * @return {!proto.appointment_service.GetAppointmentCheckoutStatusResponse} returns this
*/ proto.appointment_service.GetAppointmentCheckoutStatusResponse.prototype.setAppointmentCheckoutStatus = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.GetAppointmentCheckoutStatusResponse} returns this
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.prototype.clearAppointmentCheckoutStatus = function() {
    return this.setAppointmentCheckoutStatus(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.GetAppointmentCheckoutStatusResponse.prototype.hasAppointmentCheckoutStatus = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.AppointmentKeyHandOffRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.AppointmentKeyHandOffRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.AppointmentKeyHandOffRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.AppointmentKeyHandOffRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentKeyHandOff: (f = msg.getAppointmentKeyHandOff()) && $fcTGK.AppointmentKeyHandOff.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.AppointmentKeyHandOffRequest}
 */ proto.appointment_service.AppointmentKeyHandOffRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.AppointmentKeyHandOffRequest;
    return proto.appointment_service.AppointmentKeyHandOffRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.AppointmentKeyHandOffRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.AppointmentKeyHandOffRequest}
 */ proto.appointment_service.AppointmentKeyHandOffRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.AppointmentKeyHandOff;
                reader.readMessage(value, $fcTGK.AppointmentKeyHandOff.deserializeBinaryFromReader);
                msg.setAppointmentKeyHandOff(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.AppointmentKeyHandOffRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.AppointmentKeyHandOffRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.AppointmentKeyHandOffRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.AppointmentKeyHandOffRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentKeyHandOff();
    if (f != null) writer.writeMessage(1, f, $fcTGK.AppointmentKeyHandOff.serializeBinaryToWriter);
};
/**
 * optional appointment.AppointmentKeyHandOff appointment_key_hand_off = 1;
 * @return {?proto.appointment.AppointmentKeyHandOff}
 */ proto.appointment_service.AppointmentKeyHandOffRequest.prototype.getAppointmentKeyHandOff = function() {
    return /** @type{?proto.appointment.AppointmentKeyHandOff} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentKeyHandOff, 1);
};
/**
 * @param {?proto.appointment.AppointmentKeyHandOff|undefined} value
 * @return {!proto.appointment_service.AppointmentKeyHandOffRequest} returns this
*/ proto.appointment_service.AppointmentKeyHandOffRequest.prototype.setAppointmentKeyHandOff = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.AppointmentKeyHandOffRequest} returns this
 */ proto.appointment_service.AppointmentKeyHandOffRequest.prototype.clearAppointmentKeyHandOff = function() {
    return this.setAppointmentKeyHandOff(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.AppointmentKeyHandOffRequest.prototype.hasAppointmentKeyHandOff = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.AppointmentKeyHandOffResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.AppointmentKeyHandOffResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.AppointmentKeyHandOffResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.AppointmentKeyHandOffResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.AppointmentKeyHandOffResponse}
 */ proto.appointment_service.AppointmentKeyHandOffResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.AppointmentKeyHandOffResponse;
    return proto.appointment_service.AppointmentKeyHandOffResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.AppointmentKeyHandOffResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.AppointmentKeyHandOffResponse}
 */ proto.appointment_service.AppointmentKeyHandOffResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.AppointmentKeyHandOffResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.AppointmentKeyHandOffResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.AppointmentKeyHandOffResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.AppointmentKeyHandOffResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment_service.AppointmentKeyHandOffResponse.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.AppointmentKeyHandOffResponse} returns this
 */ proto.appointment_service.AppointmentKeyHandOffResponse.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAppointmentKeyHandOffRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAppointmentKeyHandOffRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAppointmentKeyHandOffRequest}
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAppointmentKeyHandOffRequest;
    return proto.appointment_service.GetAppointmentKeyHandOffRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAppointmentKeyHandOffRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAppointmentKeyHandOffRequest}
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAppointmentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAppointmentKeyHandOffRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAppointmentKeyHandOffRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string appointment_id = 1;
 * @return {string}
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest.prototype.getAppointmentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.GetAppointmentKeyHandOffRequest} returns this
 */ proto.appointment_service.GetAppointmentKeyHandOffRequest.prototype.setAppointmentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAppointmentKeyHandOffResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAppointmentKeyHandOffResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentKeyHandOff: (f = msg.getAppointmentKeyHandOff()) && $fcTGK.AppointmentKeyHandOff.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAppointmentKeyHandOffResponse}
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAppointmentKeyHandOffResponse;
    return proto.appointment_service.GetAppointmentKeyHandOffResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAppointmentKeyHandOffResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAppointmentKeyHandOffResponse}
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.AppointmentKeyHandOff;
                reader.readMessage(value, $fcTGK.AppointmentKeyHandOff.deserializeBinaryFromReader);
                msg.setAppointmentKeyHandOff(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAppointmentKeyHandOffResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAppointmentKeyHandOffResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentKeyHandOff();
    if (f != null) writer.writeMessage(1, f, $fcTGK.AppointmentKeyHandOff.serializeBinaryToWriter);
};
/**
 * optional appointment.AppointmentKeyHandOff appointment_key_hand_off = 1;
 * @return {?proto.appointment.AppointmentKeyHandOff}
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.prototype.getAppointmentKeyHandOff = function() {
    return /** @type{?proto.appointment.AppointmentKeyHandOff} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentKeyHandOff, 1);
};
/**
 * @param {?proto.appointment.AppointmentKeyHandOff|undefined} value
 * @return {!proto.appointment_service.GetAppointmentKeyHandOffResponse} returns this
*/ proto.appointment_service.GetAppointmentKeyHandOffResponse.prototype.setAppointmentKeyHandOff = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.GetAppointmentKeyHandOffResponse} returns this
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.prototype.clearAppointmentKeyHandOff = function() {
    return this.setAppointmentKeyHandOff(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.GetAppointmentKeyHandOffResponse.prototype.hasAppointmentKeyHandOff = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAppointmentPickupDateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAppointmentPickupDateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAppointmentPickupDateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentPickupDateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAppointmentPickupDateRequest}
 */ proto.appointment_service.GetAppointmentPickupDateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAppointmentPickupDateRequest;
    return proto.appointment_service.GetAppointmentPickupDateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAppointmentPickupDateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAppointmentPickupDateRequest}
 */ proto.appointment_service.GetAppointmentPickupDateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAppointmentPickupDateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAppointmentPickupDateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAppointmentPickupDateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentPickupDateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.appointment_service.GetAppointmentPickupDateRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.GetAppointmentPickupDateRequest} returns this
 */ proto.appointment_service.GetAppointmentPickupDateRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetAppointmentPickupDateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetAppointmentPickupDateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetAppointmentPickupDateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentPickupDateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentPickupDate: (f = msg.getAppointmentPickupDate()) && $fcTGK.AppointmentPickupDate.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetAppointmentPickupDateResponse}
 */ proto.appointment_service.GetAppointmentPickupDateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetAppointmentPickupDateResponse;
    return proto.appointment_service.GetAppointmentPickupDateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetAppointmentPickupDateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetAppointmentPickupDateResponse}
 */ proto.appointment_service.GetAppointmentPickupDateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.AppointmentPickupDate;
                reader.readMessage(value, $fcTGK.AppointmentPickupDate.deserializeBinaryFromReader);
                msg.setAppointmentPickupDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetAppointmentPickupDateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetAppointmentPickupDateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetAppointmentPickupDateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetAppointmentPickupDateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentPickupDate();
    if (f != null) writer.writeMessage(1, f, $fcTGK.AppointmentPickupDate.serializeBinaryToWriter);
};
/**
 * optional appointment.AppointmentPickupDate appointment_pickup_date = 1;
 * @return {?proto.appointment.AppointmentPickupDate}
 */ proto.appointment_service.GetAppointmentPickupDateResponse.prototype.getAppointmentPickupDate = function() {
    return /** @type{?proto.appointment.AppointmentPickupDate} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentPickupDate, 1);
};
/**
 * @param {?proto.appointment.AppointmentPickupDate|undefined} value
 * @return {!proto.appointment_service.GetAppointmentPickupDateResponse} returns this
*/ proto.appointment_service.GetAppointmentPickupDateResponse.prototype.setAppointmentPickupDate = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.GetAppointmentPickupDateResponse} returns this
 */ proto.appointment_service.GetAppointmentPickupDateResponse.prototype.clearAppointmentPickupDate = function() {
    return this.setAppointmentPickupDate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.GetAppointmentPickupDateResponse.prototype.hasAppointmentPickupDate = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.ListCompletedAppointmentsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.ListCompletedAppointmentsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.ListCompletedAppointmentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.ListCompletedAppointmentsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            dealerUserId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.ListCompletedAppointmentsRequest}
 */ proto.appointment_service.ListCompletedAppointmentsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.ListCompletedAppointmentsRequest;
    return proto.appointment_service.ListCompletedAppointmentsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.ListCompletedAppointmentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.ListCompletedAppointmentsRequest}
 */ proto.appointment_service.ListCompletedAppointmentsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.ListCompletedAppointmentsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.ListCompletedAppointmentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.ListCompletedAppointmentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.ListCompletedAppointmentsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDealerUserId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.appointment_service.ListCompletedAppointmentsRequest.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.ListCompletedAppointmentsRequest} returns this
 */ proto.appointment_service.ListCompletedAppointmentsRequest.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string dealer_user_id = 2;
 * @return {string}
 */ proto.appointment_service.ListCompletedAppointmentsRequest.prototype.getDealerUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.ListCompletedAppointmentsRequest} returns this
 */ proto.appointment_service.ListCompletedAppointmentsRequest.prototype.setDealerUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.appointment_service.ListCompletedAppointmentsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.ListCompletedAppointmentsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.ListCompletedAppointmentsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.ListCompletedAppointmentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.ListCompletedAppointmentsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            appointmentsList: $8M67s.Message.toObjectList(msg.getAppointmentsList(), $fcTGK.Appointment.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.ListCompletedAppointmentsResponse}
 */ proto.appointment_service.ListCompletedAppointmentsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.ListCompletedAppointmentsResponse;
    return proto.appointment_service.ListCompletedAppointmentsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.ListCompletedAppointmentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.ListCompletedAppointmentsResponse}
 */ proto.appointment_service.ListCompletedAppointmentsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.Appointment;
                reader.readMessage(value, $fcTGK.Appointment.deserializeBinaryFromReader);
                msg.addAppointments(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.ListCompletedAppointmentsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.ListCompletedAppointmentsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.ListCompletedAppointmentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.ListCompletedAppointmentsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAppointmentsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $fcTGK.Appointment.serializeBinaryToWriter);
};
/**
 * repeated appointment.Appointment appointments = 1;
 * @return {!Array<!proto.appointment.Appointment>}
 */ proto.appointment_service.ListCompletedAppointmentsResponse.prototype.getAppointmentsList = function() {
    return /** @type{!Array<!proto.appointment.Appointment>} */ $8M67s.Message.getRepeatedWrapperField(this, $fcTGK.Appointment, 1);
};
/**
 * @param {!Array<!proto.appointment.Appointment>} value
 * @return {!proto.appointment_service.ListCompletedAppointmentsResponse} returns this
*/ proto.appointment_service.ListCompletedAppointmentsResponse.prototype.setAppointmentsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.appointment.Appointment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.appointment.Appointment}
 */ proto.appointment_service.ListCompletedAppointmentsResponse.prototype.addAppointments = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.appointment.Appointment, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.appointment_service.ListCompletedAppointmentsResponse} returns this
 */ proto.appointment_service.ListCompletedAppointmentsResponse.prototype.clearAppointmentsList = function() {
    return this.setAppointmentsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetPreAppointmentCheckoutStatusRequest;
    return proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest} returns this
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            preAppointmentCheckoutStatus: (f = msg.getPreAppointmentCheckoutStatus()) && $fcTGK.AppointmentCheckoutStatus.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.GetPreAppointmentCheckoutStatusResponse;
    return proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $fcTGK.AppointmentCheckoutStatus;
                reader.readMessage(value, $fcTGK.AppointmentCheckoutStatus.deserializeBinaryFromReader);
                msg.setPreAppointmentCheckoutStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPreAppointmentCheckoutStatus();
    if (f != null) writer.writeMessage(1, f, $fcTGK.AppointmentCheckoutStatus.serializeBinaryToWriter);
};
/**
 * optional appointment.AppointmentCheckoutStatus pre_appointment_checkout_status = 1;
 * @return {?proto.appointment.AppointmentCheckoutStatus}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.prototype.getPreAppointmentCheckoutStatus = function() {
    return /** @type{?proto.appointment.AppointmentCheckoutStatus} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentCheckoutStatus, 1);
};
/**
 * @param {?proto.appointment.AppointmentCheckoutStatus|undefined} value
 * @return {!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse} returns this
*/ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.prototype.setPreAppointmentCheckoutStatus = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse} returns this
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.prototype.clearPreAppointmentCheckoutStatus = function() {
    return this.setPreAppointmentCheckoutStatus(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.appointment_service.GetPreAppointmentCheckoutStatusResponse.prototype.hasPreAppointmentCheckoutStatus = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.MigrateAppointmentDataRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.MigrateAppointmentDataRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.MigrateAppointmentDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.MigrateAppointmentDataRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.MigrateAppointmentDataRequest}
 */ proto.appointment_service.MigrateAppointmentDataRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.MigrateAppointmentDataRequest;
    return proto.appointment_service.MigrateAppointmentDataRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.MigrateAppointmentDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.MigrateAppointmentDataRequest}
 */ proto.appointment_service.MigrateAppointmentDataRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.MigrateAppointmentDataRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.MigrateAppointmentDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.MigrateAppointmentDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.MigrateAppointmentDataRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.appointment_service.MigrateAppointmentDataResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.appointment_service.MigrateAppointmentDataResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.appointment_service.MigrateAppointmentDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.MigrateAppointmentDataResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.appointment_service.MigrateAppointmentDataResponse}
 */ proto.appointment_service.MigrateAppointmentDataResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.appointment_service.MigrateAppointmentDataResponse;
    return proto.appointment_service.MigrateAppointmentDataResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.appointment_service.MigrateAppointmentDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.appointment_service.MigrateAppointmentDataResponse}
 */ proto.appointment_service.MigrateAppointmentDataResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.appointment_service.MigrateAppointmentDataResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.appointment_service.MigrateAppointmentDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.appointment_service.MigrateAppointmentDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.appointment_service.MigrateAppointmentDataResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
$5b6301317dc38047$var$goog.object.extend(module.exports, proto.appointment_service);

});

parcelRegister("26u10", function(module, exports) {
// source: billing_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $18836cb648331d3c$var$goog = $8M67s;
var $18836cb648331d3c$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$18836cb648331d3c$var$goog.object.extend(proto, $3QqPt);

var $2k1Kk = parcelRequire("2k1Kk");
$18836cb648331d3c$var$goog.object.extend(proto, $2k1Kk);

var $9c7Du = parcelRequire("9c7Du");
$18836cb648331d3c$var$goog.object.extend(proto, $9c7Du);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ActivityType', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.AddMileageRecurringBillableItemRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.AddRecurringBillableItemsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.AddToOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.AddToOwnOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.BatchDateRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.BillPunitiveMileageRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ConfirmFinalBillRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ConvertOrderToInvoiceRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ConvertOrderToInvoiceResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ConvertOwnOrderToInvoiceRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ConvertSubscriptionOrdersByDateResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreateFeeInvoiceRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreateFeeInvoiceResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreateFinalBillRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreateOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreateOwnOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreatePromotionPartnerRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreatePromotionPartnerResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreatePromotionRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreatePromotionResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CreateReservationRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.CustomerAccountRow', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DatedProgramPricing', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DeactivateServicesRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DeactivateServicesResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DeleteOldDraftOrdersFromBillingRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DeleteOldDraftOrdersFromBillingResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DeleteOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DeleteOrderResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DeleteOwnOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DetailsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.DraftOrderUpdated', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportCustomerPromotionsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportCustomerPromotionsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportPartnerPromotionsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportPartnerPromotionsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportPromotionActivitiesRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportPromotionActivitiesResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportReferralCustomersRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportReferralCustomersResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportReferralPromotionsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportReferralPromotionsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportToWestlakeRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportToWestlakeResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportWestlakePaymentDetailsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportWestlakePaymentDetailsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ExportedReferralPromotion', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.FeeItem', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetAccountBalanceRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetAccountBalanceResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetBillingStatusRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetBillingStatusResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetDriveOffInvoiceRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetLatestDraftOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetMileageRecurringBillableItemRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetMileageRecurringBillableItemResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetOwnAccountBalanceRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetOwnBillingStatusRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetOwnDriveOffInvoiceRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetOwnLatestDraftOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetOwnMileageRecurringBillableItemRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetReservationRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetSubscriptionByIdRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.GetSubscriptionResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ImportDocumentDataRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ImportDocumentDataResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ImportRecurringMileagePackagesRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ImportRecurringMileagePackagesResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.Invoice', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.InvoiceFE', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.InvoiceReference', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.InvoiceStatus', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.InvoiceType', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.LineItem', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.LineItemFE', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.LineItemType', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListInvoicesResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListOwnInvoicesRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListOwnProgramReservationsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListOwnSubscriptionsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListProductsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListProgramPricingRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListProgramPricingResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListProgramsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListProgramsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListPromotionPartnersResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListPromotionsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListRecurringBillableItemsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListRecurringBillableItemsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListReservationsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ListSubscriptionsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.MileageRecurringBillableItem', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.OrderFE', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PayInvoiceRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PayInvoiceResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PaySubscriptionInvoiceByDateResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PricingOption', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ProductFE', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.Program', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ProgramColorOption', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.Promotion', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PromotionActivity', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PromotionConstraint', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PromotionConstraint.ConstraintDimension', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PromotionDetails', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PromotionPartner', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PromotionSource', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PromotionTarget', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PurchaseOneTimeMileageRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.PurchaseRecurringMileageRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.RecurringBillableItem', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.RedemptionRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.RedemptionResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ReferralCodeRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ReferralCodeResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.RemoveFromOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.RemoveFromOwnOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.RemoveMileageRecurringBillableItemRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.RemoveRecurringBillableItemsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.Reservation', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ReserveAndInfleetRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.ReserveAndInfleetResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.SeedReferralPromotionsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.SeedReferralPromotionsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageAllReservationsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageAllReservationsResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageCustomerRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageCustomerResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageDataRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageDataResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageReservationRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageReservationResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageWestlakeDataRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.StageWestlakeDataResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.Subscription', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.SyncReservationRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.SyncReservationResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.SyncTaxedProducts', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdateMileageRecurringBillableItemRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdateOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdateOwnOrderRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdatePromotionPartnerRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdatePromotionPartnerResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdatePromotionRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdatePromotionResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdateRecurringBillableItemsRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdateRecurringBillingDayRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdateRecurringBillingDayResponse', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.UpdateReservationRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.WestlakeStagingStatusRequest', null, $18836cb648331d3c$var$global);
$18836cb648331d3c$var$goog.exportSymbol('proto.billing_service.WestlakeStagingStatusResponse', null, $18836cb648331d3c$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.SyncReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.SyncReservationRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.SyncReservationRequest.displayName = 'proto.billing_service.SyncReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.SyncReservationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.SyncReservationResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.SyncReservationResponse.displayName = 'proto.billing_service.SyncReservationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.AddToOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.AddToOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.AddToOrderRequest.displayName = 'proto.billing_service.AddToOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.AddToOwnOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.AddToOwnOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.AddToOwnOrderRequest.displayName = 'proto.billing_service.AddToOwnOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreateOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.CreateOrderRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreateOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreateOrderRequest.displayName = 'proto.billing_service.CreateOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreateOwnOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.CreateOwnOrderRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreateOwnOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreateOwnOrderRequest.displayName = 'proto.billing_service.CreateOwnOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdateOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.UpdateOrderRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdateOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdateOrderRequest.displayName = 'proto.billing_service.UpdateOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdateOwnOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.UpdateOwnOrderRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdateOwnOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdateOwnOrderRequest.displayName = 'proto.billing_service.UpdateOwnOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ConvertOrderToInvoiceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ConvertOrderToInvoiceRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ConvertOrderToInvoiceRequest.displayName = 'proto.billing_service.ConvertOrderToInvoiceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ConvertOwnOrderToInvoiceRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.displayName = 'proto.billing_service.ConvertOwnOrderToInvoiceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PayInvoiceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PayInvoiceRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PayInvoiceRequest.displayName = 'proto.billing_service.PayInvoiceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PayInvoiceResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PayInvoiceResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PayInvoiceResponse.displayName = 'proto.billing_service.PayInvoiceResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetBillingStatusRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetBillingStatusRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetBillingStatusRequest.displayName = 'proto.billing_service.GetBillingStatusRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetOwnBillingStatusRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetOwnBillingStatusRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetOwnBillingStatusRequest.displayName = 'proto.billing_service.GetOwnBillingStatusRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetBillingStatusResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetBillingStatusResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetBillingStatusResponse.displayName = 'proto.billing_service.GetBillingStatusResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetDriveOffInvoiceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetDriveOffInvoiceRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetDriveOffInvoiceRequest.displayName = 'proto.billing_service.GetDriveOffInvoiceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetOwnDriveOffInvoiceRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetOwnDriveOffInvoiceRequest.displayName = 'proto.billing_service.GetOwnDriveOffInvoiceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.RemoveFromOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.RemoveFromOrderRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.RemoveFromOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.RemoveFromOrderRequest.displayName = 'proto.billing_service.RemoveFromOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.RemoveFromOwnOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.RemoveFromOwnOrderRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.RemoveFromOwnOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.RemoveFromOwnOrderRequest.displayName = 'proto.billing_service.RemoveFromOwnOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetOwnLatestDraftOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetOwnLatestDraftOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetOwnLatestDraftOrderRequest.displayName = 'proto.billing_service.GetOwnLatestDraftOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetLatestDraftOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetLatestDraftOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetLatestDraftOrderRequest.displayName = 'proto.billing_service.GetLatestDraftOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DeleteOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DeleteOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DeleteOrderRequest.displayName = 'proto.billing_service.DeleteOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DeleteOwnOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DeleteOwnOrderRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DeleteOwnOrderRequest.displayName = 'proto.billing_service.DeleteOwnOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DeleteOrderResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DeleteOrderResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DeleteOrderResponse.displayName = 'proto.billing_service.DeleteOrderResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ConvertOrderToInvoiceResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ConvertOrderToInvoiceResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ConvertOrderToInvoiceResponse.displayName = 'proto.billing_service.ConvertOrderToInvoiceResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreateFeeInvoiceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.CreateFeeInvoiceRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreateFeeInvoiceRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreateFeeInvoiceRequest.displayName = 'proto.billing_service.CreateFeeInvoiceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.FeeItem = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.FeeItem, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.FeeItem.displayName = 'proto.billing_service.FeeItem';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreateFeeInvoiceResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreateFeeInvoiceResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreateFeeInvoiceResponse.displayName = 'proto.billing_service.CreateFeeInvoiceResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreateFinalBillRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.CreateFinalBillRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreateFinalBillRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreateFinalBillRequest.displayName = 'proto.billing_service.CreateFinalBillRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ConfirmFinalBillRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ConfirmFinalBillRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ConfirmFinalBillRequest.displayName = 'proto.billing_service.ConfirmFinalBillRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.OrderFE = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.OrderFE.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.OrderFE, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.OrderFE.displayName = 'proto.billing_service.OrderFE';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetOwnAccountBalanceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetOwnAccountBalanceRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetOwnAccountBalanceRequest.displayName = 'proto.billing_service.GetOwnAccountBalanceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetAccountBalanceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetAccountBalanceRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetAccountBalanceRequest.displayName = 'proto.billing_service.GetAccountBalanceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetAccountBalanceResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetAccountBalanceResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetAccountBalanceResponse.displayName = 'proto.billing_service.GetAccountBalanceResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListOwnInvoicesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListOwnInvoicesRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListOwnInvoicesRequest.displayName = 'proto.billing_service.ListOwnInvoicesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListInvoicesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListInvoicesResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListInvoicesResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListInvoicesResponse.displayName = 'proto.billing_service.ListInvoicesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdateReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdateReservationRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdateReservationRequest.displayName = 'proto.billing_service.UpdateReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetReservationRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetReservationRequest.displayName = 'proto.billing_service.GetReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListOwnProgramReservationsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListOwnProgramReservationsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListOwnProgramReservationsRequest.displayName = 'proto.billing_service.ListOwnProgramReservationsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListReservationsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListReservationsResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListReservationsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListReservationsResponse.displayName = 'proto.billing_service.ListReservationsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreateReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreateReservationRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreateReservationRequest.displayName = 'proto.billing_service.CreateReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.InvoiceReference = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.InvoiceReference, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.InvoiceReference.displayName = 'proto.billing_service.InvoiceReference';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListProductsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListProductsResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListProductsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListProductsResponse.displayName = 'proto.billing_service.ListProductsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ProductFE = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ProductFE, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ProductFE.displayName = 'proto.billing_service.ProductFE';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ProgramColorOption = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ProgramColorOption, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ProgramColorOption.displayName = 'proto.billing_service.ProgramColorOption';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DatedProgramPricing = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.DatedProgramPricing.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DatedProgramPricing, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DatedProgramPricing.displayName = 'proto.billing_service.DatedProgramPricing';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PricingOption = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PricingOption, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PricingOption.displayName = 'proto.billing_service.PricingOption';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.Program = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.Program.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.Program, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.Program.displayName = 'proto.billing_service.Program';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListProgramsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListProgramsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListProgramsRequest.displayName = 'proto.billing_service.ListProgramsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListProgramsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListProgramsResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListProgramsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListProgramsResponse.displayName = 'proto.billing_service.ListProgramsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DetailsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DetailsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DetailsRequest.displayName = 'proto.billing_service.DetailsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PromotionConstraint = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PromotionConstraint, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PromotionConstraint.displayName = 'proto.billing_service.PromotionConstraint';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PromotionDetails = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PromotionDetails, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PromotionDetails.displayName = 'proto.billing_service.PromotionDetails';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.RedemptionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.RedemptionRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.RedemptionRequest.displayName = 'proto.billing_service.RedemptionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.RedemptionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.RedemptionResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.RedemptionResponse.displayName = 'proto.billing_service.RedemptionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ReferralCodeRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ReferralCodeRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ReferralCodeRequest.displayName = 'proto.billing_service.ReferralCodeRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetSubscriptionByIdRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetSubscriptionByIdRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetSubscriptionByIdRequest.displayName = 'proto.billing_service.GetSubscriptionByIdRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CustomerAccountRow = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CustomerAccountRow, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CustomerAccountRow.displayName = 'proto.billing_service.CustomerAccountRow';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetSubscriptionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetSubscriptionResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetSubscriptionResponse.displayName = 'proto.billing_service.GetSubscriptionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ReferralCodeResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ReferralCodeResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ReferralCodeResponse.displayName = 'proto.billing_service.ReferralCodeResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.SeedReferralPromotionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.SeedReferralPromotionsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.SeedReferralPromotionsRequest.displayName = 'proto.billing_service.SeedReferralPromotionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.SeedReferralPromotionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.SeedReferralPromotionsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.SeedReferralPromotionsResponse.displayName = 'proto.billing_service.SeedReferralPromotionsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportReferralPromotionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportReferralPromotionsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportReferralPromotionsRequest.displayName = 'proto.billing_service.ExportReferralPromotionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportedReferralPromotion = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportedReferralPromotion, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportedReferralPromotion.displayName = 'proto.billing_service.ExportedReferralPromotion';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportReferralPromotionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ExportReferralPromotionsResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportReferralPromotionsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportReferralPromotionsResponse.displayName = 'proto.billing_service.ExportReferralPromotionsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreatePromotionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.CreatePromotionRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreatePromotionRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreatePromotionRequest.displayName = 'proto.billing_service.CreatePromotionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreatePromotionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreatePromotionResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreatePromotionResponse.displayName = 'proto.billing_service.CreatePromotionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdatePromotionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.UpdatePromotionRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdatePromotionRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdatePromotionRequest.displayName = 'proto.billing_service.UpdatePromotionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdatePromotionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdatePromotionResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdatePromotionResponse.displayName = 'proto.billing_service.UpdatePromotionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListPromotionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListPromotionsResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListPromotionsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListPromotionsResponse.displayName = 'proto.billing_service.ListPromotionsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreatePromotionPartnerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreatePromotionPartnerRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreatePromotionPartnerRequest.displayName = 'proto.billing_service.CreatePromotionPartnerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.CreatePromotionPartnerResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.CreatePromotionPartnerResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.CreatePromotionPartnerResponse.displayName = 'proto.billing_service.CreatePromotionPartnerResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdatePromotionPartnerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdatePromotionPartnerRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdatePromotionPartnerRequest.displayName = 'proto.billing_service.UpdatePromotionPartnerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdatePromotionPartnerResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdatePromotionPartnerResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdatePromotionPartnerResponse.displayName = 'proto.billing_service.UpdatePromotionPartnerResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListPromotionPartnersResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListPromotionPartnersResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListPromotionPartnersResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListPromotionPartnersResponse.displayName = 'proto.billing_service.ListPromotionPartnersResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageWestlakeDataRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageWestlakeDataRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageWestlakeDataRequest.displayName = 'proto.billing_service.StageWestlakeDataRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageWestlakeDataResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageWestlakeDataResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageWestlakeDataResponse.displayName = 'proto.billing_service.StageWestlakeDataResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageCustomerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageCustomerRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageCustomerRequest.displayName = 'proto.billing_service.StageCustomerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageCustomerResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageCustomerResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageCustomerResponse.displayName = 'proto.billing_service.StageCustomerResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageReservationRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageReservationRequest.displayName = 'proto.billing_service.StageReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageReservationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageReservationResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageReservationResponse.displayName = 'proto.billing_service.StageReservationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageAllReservationsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageAllReservationsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageAllReservationsRequest.displayName = 'proto.billing_service.StageAllReservationsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageAllReservationsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageAllReservationsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageAllReservationsResponse.displayName = 'proto.billing_service.StageAllReservationsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageDataRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageDataRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageDataRequest.displayName = 'proto.billing_service.StageDataRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.StageDataResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.StageDataResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.StageDataResponse.displayName = 'proto.billing_service.StageDataResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportWestlakePaymentDetailsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportWestlakePaymentDetailsRequest.displayName = 'proto.billing_service.ExportWestlakePaymentDetailsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportWestlakePaymentDetailsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportWestlakePaymentDetailsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportWestlakePaymentDetailsResponse.displayName = 'proto.billing_service.ExportWestlakePaymentDetailsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportCustomerPromotionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportCustomerPromotionsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportCustomerPromotionsRequest.displayName = 'proto.billing_service.ExportCustomerPromotionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportCustomerPromotionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportCustomerPromotionsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportCustomerPromotionsResponse.displayName = 'proto.billing_service.ExportCustomerPromotionsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportPartnerPromotionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportPartnerPromotionsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportPartnerPromotionsRequest.displayName = 'proto.billing_service.ExportPartnerPromotionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportPartnerPromotionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportPartnerPromotionsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportPartnerPromotionsResponse.displayName = 'proto.billing_service.ExportPartnerPromotionsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportPromotionActivitiesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportPromotionActivitiesRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportPromotionActivitiesRequest.displayName = 'proto.billing_service.ExportPromotionActivitiesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportPromotionActivitiesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportPromotionActivitiesResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportPromotionActivitiesResponse.displayName = 'proto.billing_service.ExportPromotionActivitiesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportReferralCustomersRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportReferralCustomersRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportReferralCustomersRequest.displayName = 'proto.billing_service.ExportReferralCustomersRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportReferralCustomersResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportReferralCustomersResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportReferralCustomersResponse.displayName = 'proto.billing_service.ExportReferralCustomersResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.displayName = 'proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.displayName = 'proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ImportRecurringMileagePackagesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ImportRecurringMileagePackagesRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ImportRecurringMileagePackagesRequest.displayName = 'proto.billing_service.ImportRecurringMileagePackagesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ImportRecurringMileagePackagesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ImportRecurringMileagePackagesResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ImportRecurringMileagePackagesResponse.displayName = 'proto.billing_service.ImportRecurringMileagePackagesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DeleteOldDraftOrdersFromBillingRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.displayName = 'proto.billing_service.DeleteOldDraftOrdersFromBillingRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DeleteOldDraftOrdersFromBillingResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.displayName = 'proto.billing_service.DeleteOldDraftOrdersFromBillingResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportToWestlakeRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportToWestlakeRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportToWestlakeRequest.displayName = 'proto.billing_service.ExportToWestlakeRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ExportToWestlakeResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ExportToWestlakeResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ExportToWestlakeResponse.displayName = 'proto.billing_service.ExportToWestlakeResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.WestlakeStagingStatusRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.WestlakeStagingStatusRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.WestlakeStagingStatusRequest.displayName = 'proto.billing_service.WestlakeStagingStatusRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.WestlakeStagingStatusResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.WestlakeStagingStatusResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.WestlakeStagingStatusResponse.displayName = 'proto.billing_service.WestlakeStagingStatusResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DraftOrderUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DraftOrderUpdated, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DraftOrderUpdated.displayName = 'proto.billing_service.DraftOrderUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.Promotion = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.Promotion.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.Promotion, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.Promotion.displayName = 'proto.billing_service.Promotion';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PromotionPartner = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PromotionPartner, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PromotionPartner.displayName = 'proto.billing_service.PromotionPartner';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PromotionActivity = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.PromotionActivity.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PromotionActivity, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PromotionActivity.displayName = 'proto.billing_service.PromotionActivity';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.Reservation = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.Reservation, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.Reservation.displayName = 'proto.billing_service.Reservation';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.LineItemFE = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.LineItemFE, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.LineItemFE.displayName = 'proto.billing_service.LineItemFE';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.InvoiceFE = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.InvoiceFE.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.InvoiceFE, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.InvoiceFE.displayName = 'proto.billing_service.InvoiceFE';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.LineItem = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.LineItem, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.LineItem.displayName = 'proto.billing_service.LineItem';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.Invoice = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.Invoice.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.Invoice, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.Invoice.displayName = 'proto.billing_service.Invoice';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.MileageRecurringBillableItem = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.MileageRecurringBillableItem, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.MileageRecurringBillableItem.displayName = 'proto.billing_service.MileageRecurringBillableItem';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetMileageRecurringBillableItemRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetMileageRecurringBillableItemRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetMileageRecurringBillableItemRequest.displayName = 'proto.billing_service.GetMileageRecurringBillableItemRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetOwnMileageRecurringBillableItemRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.displayName = 'proto.billing_service.GetOwnMileageRecurringBillableItemRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetMileageRecurringBillableItemResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetMileageRecurringBillableItemResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetMileageRecurringBillableItemResponse.displayName = 'proto.billing_service.GetMileageRecurringBillableItemResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdateMileageRecurringBillableItemRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.displayName = 'proto.billing_service.UpdateMileageRecurringBillableItemRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.RemoveMileageRecurringBillableItemRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.displayName = 'proto.billing_service.RemoveMileageRecurringBillableItemRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.displayName = 'proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.AddMileageRecurringBillableItemRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.AddMileageRecurringBillableItemRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.AddMileageRecurringBillableItemRequest.displayName = 'proto.billing_service.AddMileageRecurringBillableItemRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdateRecurringBillingDayRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdateRecurringBillingDayRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdateRecurringBillingDayRequest.displayName = 'proto.billing_service.UpdateRecurringBillingDayRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdateRecurringBillingDayResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdateRecurringBillingDayResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdateRecurringBillingDayResponse.displayName = 'proto.billing_service.UpdateRecurringBillingDayResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.RecurringBillableItem = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.RecurringBillableItem, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.RecurringBillableItem.displayName = 'proto.billing_service.RecurringBillableItem';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListRecurringBillableItemsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListRecurringBillableItemsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListRecurringBillableItemsRequest.displayName = 'proto.billing_service.ListRecurringBillableItemsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListRecurringBillableItemsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListRecurringBillableItemsResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListRecurringBillableItemsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListRecurringBillableItemsResponse.displayName = 'proto.billing_service.ListRecurringBillableItemsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.AddRecurringBillableItemsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.AddRecurringBillableItemsRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.AddRecurringBillableItemsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.AddRecurringBillableItemsRequest.displayName = 'proto.billing_service.AddRecurringBillableItemsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.UpdateRecurringBillableItemsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.UpdateRecurringBillableItemsRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.UpdateRecurringBillableItemsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.UpdateRecurringBillableItemsRequest.displayName = 'proto.billing_service.UpdateRecurringBillableItemsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.RemoveRecurringBillableItemsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.RemoveRecurringBillableItemsRequest.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.RemoveRecurringBillableItemsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.RemoveRecurringBillableItemsRequest.displayName = 'proto.billing_service.RemoveRecurringBillableItemsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListOwnSubscriptionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListOwnSubscriptionsRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListOwnSubscriptionsRequest.displayName = 'proto.billing_service.ListOwnSubscriptionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListSubscriptionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListSubscriptionsResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListSubscriptionsResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListSubscriptionsResponse.displayName = 'proto.billing_service.ListSubscriptionsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.Subscription = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.Subscription, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.Subscription.displayName = 'proto.billing_service.Subscription';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.SyncTaxedProducts = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.SyncTaxedProducts, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.SyncTaxedProducts.displayName = 'proto.billing_service.SyncTaxedProducts';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PurchaseOneTimeMileageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PurchaseOneTimeMileageRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PurchaseOneTimeMileageRequest.displayName = 'proto.billing_service.PurchaseOneTimeMileageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PurchaseRecurringMileageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PurchaseRecurringMileageRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PurchaseRecurringMileageRequest.displayName = 'proto.billing_service.PurchaseRecurringMileageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.BillPunitiveMileageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.BillPunitiveMileageRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.BillPunitiveMileageRequest.displayName = 'proto.billing_service.BillPunitiveMileageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.BatchDateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.BatchDateRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.BatchDateRequest.displayName = 'proto.billing_service.BatchDateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.displayName = 'proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ConvertSubscriptionOrdersByDateResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ConvertSubscriptionOrdersByDateResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.displayName = 'proto.billing_service.ConvertSubscriptionOrdersByDateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.PaySubscriptionInvoiceByDateResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.PaySubscriptionInvoiceByDateResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.displayName = 'proto.billing_service.PaySubscriptionInvoiceByDateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListProgramPricingRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListProgramPricingRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListProgramPricingRequest.displayName = 'proto.billing_service.ListProgramPricingRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ListProgramPricingResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.billing_service.ListProgramPricingResponse.repeatedFields_, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ListProgramPricingResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ListProgramPricingResponse.displayName = 'proto.billing_service.ListProgramPricingResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ReserveAndInfleetRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ReserveAndInfleetRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ReserveAndInfleetRequest.displayName = 'proto.billing_service.ReserveAndInfleetRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ReserveAndInfleetResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ReserveAndInfleetResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ReserveAndInfleetResponse.displayName = 'proto.billing_service.ReserveAndInfleetResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DeactivateServicesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DeactivateServicesRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DeactivateServicesRequest.displayName = 'proto.billing_service.DeactivateServicesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.DeactivateServicesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.DeactivateServicesResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.DeactivateServicesResponse.displayName = 'proto.billing_service.DeactivateServicesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ImportDocumentDataRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ImportDocumentDataRequest, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ImportDocumentDataRequest.displayName = 'proto.billing_service.ImportDocumentDataRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.billing_service.ImportDocumentDataResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$18836cb648331d3c$var$goog.inherits(proto.billing_service.ImportDocumentDataResponse, $8M67s.Message);
if ($18836cb648331d3c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.billing_service.ImportDocumentDataResponse.displayName = 'proto.billing_service.ImportDocumentDataResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.SyncReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.SyncReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.SyncReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SyncReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.SyncReservationRequest}
 */ proto.billing_service.SyncReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.SyncReservationRequest;
    return proto.billing_service.SyncReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.SyncReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.SyncReservationRequest}
 */ proto.billing_service.SyncReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.SyncReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.SyncReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.SyncReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SyncReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.SyncReservationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.SyncReservationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.SyncReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SyncReservationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.SyncReservationResponse}
 */ proto.billing_service.SyncReservationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.SyncReservationResponse;
    return proto.billing_service.SyncReservationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.SyncReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.SyncReservationResponse}
 */ proto.billing_service.SyncReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.SyncReservationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.SyncReservationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.SyncReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SyncReservationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.AddToOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.AddToOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.AddToOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.AddToOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            productType: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            description: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            quantity: $8M67s.Message.getFieldWithDefault(msg, 9, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.AddToOrderRequest}
 */ proto.billing_service.AddToOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.AddToOrderRequest;
    return proto.billing_service.AddToOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.AddToOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.AddToOrderRequest}
 */ proto.billing_service.AddToOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 6:
                var value = /** @type {!proto.domain.Product.ProductType} */ reader.readEnum();
                msg.setProductType(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setQuantity(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.AddToOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.AddToOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.AddToOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.AddToOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getProductType();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getQuantity();
    if (f !== 0) writer.writeInt32(9, f);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.billing_service.AddToOrderRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddToOrderRequest} returns this
 */ proto.billing_service.AddToOrderRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string subscription_id = 4;
 * @return {string}
 */ proto.billing_service.AddToOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddToOrderRequest} returns this
 */ proto.billing_service.AddToOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string order_number = 5;
 * @return {string}
 */ proto.billing_service.AddToOrderRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddToOrderRequest} returns this
 */ proto.billing_service.AddToOrderRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional domain.Product.ProductType product_type = 6;
 * @return {!proto.domain.Product.ProductType}
 */ proto.billing_service.AddToOrderRequest.prototype.getProductType = function() {
    return /** @type {!proto.domain.Product.ProductType} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.domain.Product.ProductType} value
 * @return {!proto.billing_service.AddToOrderRequest} returns this
 */ proto.billing_service.AddToOrderRequest.prototype.setProductType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional string description = 7;
 * @return {string}
 */ proto.billing_service.AddToOrderRequest.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddToOrderRequest} returns this
 */ proto.billing_service.AddToOrderRequest.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional int32 amount = 8;
 * @return {number}
 */ proto.billing_service.AddToOrderRequest.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.AddToOrderRequest} returns this
 */ proto.billing_service.AddToOrderRequest.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 quantity = 9;
 * @return {number}
 */ proto.billing_service.AddToOrderRequest.prototype.getQuantity = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.AddToOrderRequest} returns this
 */ proto.billing_service.AddToOrderRequest.prototype.setQuantity = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.AddToOwnOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.AddToOwnOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.AddToOwnOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.AddToOwnOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            productType: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            description: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            quantity: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.AddToOwnOrderRequest}
 */ proto.billing_service.AddToOwnOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.AddToOwnOrderRequest;
    return proto.billing_service.AddToOwnOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.AddToOwnOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.AddToOwnOrderRequest}
 */ proto.billing_service.AddToOwnOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.Product.ProductType} */ reader.readEnum();
                msg.setProductType(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setQuantity(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.AddToOwnOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.AddToOwnOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.AddToOwnOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.AddToOwnOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getProductType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getQuantity();
    if (f !== 0) writer.writeInt32(6, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.AddToOwnOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddToOwnOrderRequest} returns this
 */ proto.billing_service.AddToOwnOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string order_number = 2;
 * @return {string}
 */ proto.billing_service.AddToOwnOrderRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddToOwnOrderRequest} returns this
 */ proto.billing_service.AddToOwnOrderRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional domain.Product.ProductType product_type = 3;
 * @return {!proto.domain.Product.ProductType}
 */ proto.billing_service.AddToOwnOrderRequest.prototype.getProductType = function() {
    return /** @type {!proto.domain.Product.ProductType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.Product.ProductType} value
 * @return {!proto.billing_service.AddToOwnOrderRequest} returns this
 */ proto.billing_service.AddToOwnOrderRequest.prototype.setProductType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string description = 4;
 * @return {string}
 */ proto.billing_service.AddToOwnOrderRequest.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddToOwnOrderRequest} returns this
 */ proto.billing_service.AddToOwnOrderRequest.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 amount = 5;
 * @return {number}
 */ proto.billing_service.AddToOwnOrderRequest.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.AddToOwnOrderRequest} returns this
 */ proto.billing_service.AddToOwnOrderRequest.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 quantity = 6;
 * @return {number}
 */ proto.billing_service.AddToOwnOrderRequest.prototype.getQuantity = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.AddToOwnOrderRequest} returns this
 */ proto.billing_service.AddToOwnOrderRequest.prototype.setQuantity = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.CreateOrderRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreateOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreateOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreateOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            itemsList: $8M67s.Message.toObjectList(msg.getItemsList(), $2k1Kk.OrderItem.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreateOrderRequest}
 */ proto.billing_service.CreateOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreateOrderRequest;
    return proto.billing_service.CreateOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreateOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreateOrderRequest}
 */ proto.billing_service.CreateOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new $2k1Kk.OrderItem;
                reader.readMessage(value, $2k1Kk.OrderItem.deserializeBinaryFromReader);
                msg.addItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreateOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreateOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreateOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, $2k1Kk.OrderItem.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.CreateOrderRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateOrderRequest} returns this
 */ proto.billing_service.CreateOrderRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.CreateOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateOrderRequest} returns this
 */ proto.billing_service.CreateOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated vendor_invoicing.OrderItem items = 3;
 * @return {!Array<!proto.vendor_invoicing.OrderItem>}
 */ proto.billing_service.CreateOrderRequest.prototype.getItemsList = function() {
    return /** @type{!Array<!proto.vendor_invoicing.OrderItem>} */ $8M67s.Message.getRepeatedWrapperField(this, $2k1Kk.OrderItem, 3);
};
/**
 * @param {!Array<!proto.vendor_invoicing.OrderItem>} value
 * @return {!proto.billing_service.CreateOrderRequest} returns this
*/ proto.billing_service.CreateOrderRequest.prototype.setItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.vendor_invoicing.OrderItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vendor_invoicing.OrderItem}
 */ proto.billing_service.CreateOrderRequest.prototype.addItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.vendor_invoicing.OrderItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.CreateOrderRequest} returns this
 */ proto.billing_service.CreateOrderRequest.prototype.clearItemsList = function() {
    return this.setItemsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.CreateOwnOrderRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreateOwnOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreateOwnOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreateOwnOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateOwnOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            itemsList: $8M67s.Message.toObjectList(msg.getItemsList(), $2k1Kk.OrderItem.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreateOwnOrderRequest}
 */ proto.billing_service.CreateOwnOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreateOwnOrderRequest;
    return proto.billing_service.CreateOwnOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreateOwnOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreateOwnOrderRequest}
 */ proto.billing_service.CreateOwnOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new $2k1Kk.OrderItem;
                reader.readMessage(value, $2k1Kk.OrderItem.deserializeBinaryFromReader);
                msg.addItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreateOwnOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreateOwnOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreateOwnOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateOwnOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, $2k1Kk.OrderItem.serializeBinaryToWriter);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.CreateOwnOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateOwnOrderRequest} returns this
 */ proto.billing_service.CreateOwnOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated vendor_invoicing.OrderItem items = 3;
 * @return {!Array<!proto.vendor_invoicing.OrderItem>}
 */ proto.billing_service.CreateOwnOrderRequest.prototype.getItemsList = function() {
    return /** @type{!Array<!proto.vendor_invoicing.OrderItem>} */ $8M67s.Message.getRepeatedWrapperField(this, $2k1Kk.OrderItem, 3);
};
/**
 * @param {!Array<!proto.vendor_invoicing.OrderItem>} value
 * @return {!proto.billing_service.CreateOwnOrderRequest} returns this
*/ proto.billing_service.CreateOwnOrderRequest.prototype.setItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.vendor_invoicing.OrderItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vendor_invoicing.OrderItem}
 */ proto.billing_service.CreateOwnOrderRequest.prototype.addItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.vendor_invoicing.OrderItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.CreateOwnOrderRequest} returns this
 */ proto.billing_service.CreateOwnOrderRequest.prototype.clearItemsList = function() {
    return this.setItemsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.UpdateOrderRequest.repeatedFields_ = [
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdateOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdateOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdateOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), proto.billing_service.LineItemFE.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdateOrderRequest}
 */ proto.billing_service.UpdateOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdateOrderRequest;
    return proto.billing_service.UpdateOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdateOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdateOrderRequest}
 */ proto.billing_service.UpdateOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 4:
                var value = new proto.billing_service.LineItemFE;
                reader.readMessage(value, proto.billing_service.LineItemFE.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdateOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdateOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdateOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.billing_service.LineItemFE.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.UpdateOrderRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateOrderRequest} returns this
 */ proto.billing_service.UpdateOrderRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.UpdateOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateOrderRequest} returns this
 */ proto.billing_service.UpdateOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string order_number = 3;
 * @return {string}
 */ proto.billing_service.UpdateOrderRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateOrderRequest} returns this
 */ proto.billing_service.UpdateOrderRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * repeated LineItemFE line_items = 4;
 * @return {!Array<!proto.billing_service.LineItemFE>}
 */ proto.billing_service.UpdateOrderRequest.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.billing_service.LineItemFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.LineItemFE, 4);
};
/**
 * @param {!Array<!proto.billing_service.LineItemFE>} value
 * @return {!proto.billing_service.UpdateOrderRequest} returns this
*/ proto.billing_service.UpdateOrderRequest.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.billing_service.LineItemFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.LineItemFE}
 */ proto.billing_service.UpdateOrderRequest.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.billing_service.LineItemFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.UpdateOrderRequest} returns this
 */ proto.billing_service.UpdateOrderRequest.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.UpdateOwnOrderRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdateOwnOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdateOwnOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateOwnOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), proto.billing_service.LineItemFE.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdateOwnOrderRequest}
 */ proto.billing_service.UpdateOwnOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdateOwnOrderRequest;
    return proto.billing_service.UpdateOwnOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdateOwnOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdateOwnOrderRequest}
 */ proto.billing_service.UpdateOwnOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 3:
                var value = new proto.billing_service.LineItemFE;
                reader.readMessage(value, proto.billing_service.LineItemFE.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdateOwnOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdateOwnOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateOwnOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.billing_service.LineItemFE.serializeBinaryToWriter);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateOwnOrderRequest} returns this
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string order_number = 2;
 * @return {string}
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateOwnOrderRequest} returns this
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated LineItemFE line_items = 3;
 * @return {!Array<!proto.billing_service.LineItemFE>}
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.billing_service.LineItemFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.LineItemFE, 3);
};
/**
 * @param {!Array<!proto.billing_service.LineItemFE>} value
 * @return {!proto.billing_service.UpdateOwnOrderRequest} returns this
*/ proto.billing_service.UpdateOwnOrderRequest.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.billing_service.LineItemFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.LineItemFE}
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.billing_service.LineItemFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.UpdateOwnOrderRequest} returns this
 */ proto.billing_service.UpdateOwnOrderRequest.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ConvertOrderToInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ConvertOrderToInvoiceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ConvertOrderToInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertOrderToInvoiceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ConvertOrderToInvoiceRequest}
 */ proto.billing_service.ConvertOrderToInvoiceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ConvertOrderToInvoiceRequest;
    return proto.billing_service.ConvertOrderToInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ConvertOrderToInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ConvertOrderToInvoiceRequest}
 */ proto.billing_service.ConvertOrderToInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ConvertOrderToInvoiceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ConvertOrderToInvoiceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ConvertOrderToInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertOrderToInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.ConvertOrderToInvoiceRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ConvertOrderToInvoiceRequest} returns this
 */ proto.billing_service.ConvertOrderToInvoiceRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.ConvertOrderToInvoiceRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ConvertOrderToInvoiceRequest} returns this
 */ proto.billing_service.ConvertOrderToInvoiceRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string order_number = 3;
 * @return {string}
 */ proto.billing_service.ConvertOrderToInvoiceRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ConvertOrderToInvoiceRequest} returns this
 */ proto.billing_service.ConvertOrderToInvoiceRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ConvertOwnOrderToInvoiceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ConvertOwnOrderToInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ConvertOwnOrderToInvoiceRequest}
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ConvertOwnOrderToInvoiceRequest;
    return proto.billing_service.ConvertOwnOrderToInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ConvertOwnOrderToInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ConvertOwnOrderToInvoiceRequest}
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ConvertOwnOrderToInvoiceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ConvertOwnOrderToInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ConvertOwnOrderToInvoiceRequest} returns this
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string order_number = 2;
 * @return {string}
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ConvertOwnOrderToInvoiceRequest} returns this
 */ proto.billing_service.ConvertOwnOrderToInvoiceRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PayInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PayInvoiceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PayInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PayInvoiceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            paymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PayInvoiceRequest}
 */ proto.billing_service.PayInvoiceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PayInvoiceRequest;
    return proto.billing_service.PayInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PayInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PayInvoiceRequest}
 */ proto.billing_service.PayInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PayInvoiceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PayInvoiceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PayInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PayInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPaymentMethodId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.PayInvoiceRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PayInvoiceRequest} returns this
 */ proto.billing_service.PayInvoiceRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string payment_method_id = 2;
 * @return {string}
 */ proto.billing_service.PayInvoiceRequest.prototype.getPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PayInvoiceRequest} returns this
 */ proto.billing_service.PayInvoiceRequest.prototype.setPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 amount = 3;
 * @return {number}
 */ proto.billing_service.PayInvoiceRequest.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PayInvoiceRequest} returns this
 */ proto.billing_service.PayInvoiceRequest.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string invoice_number = 4;
 * @return {string}
 */ proto.billing_service.PayInvoiceRequest.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PayInvoiceRequest} returns this
 */ proto.billing_service.PayInvoiceRequest.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PayInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PayInvoiceResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PayInvoiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PayInvoiceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            message: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PayInvoiceResponse}
 */ proto.billing_service.PayInvoiceResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PayInvoiceResponse;
    return proto.billing_service.PayInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PayInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PayInvoiceResponse}
 */ proto.billing_service.PayInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PayInvoiceResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PayInvoiceResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PayInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PayInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.billing_service.PayInvoiceResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.PayInvoiceResponse} returns this
 */ proto.billing_service.PayInvoiceResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string message = 2;
 * @return {string}
 */ proto.billing_service.PayInvoiceResponse.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PayInvoiceResponse} returns this
 */ proto.billing_service.PayInvoiceResponse.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetBillingStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetBillingStatusRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetBillingStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetBillingStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetBillingStatusRequest}
 */ proto.billing_service.GetBillingStatusRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetBillingStatusRequest;
    return proto.billing_service.GetBillingStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetBillingStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetBillingStatusRequest}
 */ proto.billing_service.GetBillingStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetBillingStatusRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetBillingStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetBillingStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetBillingStatusRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.GetBillingStatusRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetBillingStatusRequest} returns this
 */ proto.billing_service.GetBillingStatusRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetOwnBillingStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetOwnBillingStatusRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetOwnBillingStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnBillingStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetOwnBillingStatusRequest}
 */ proto.billing_service.GetOwnBillingStatusRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetOwnBillingStatusRequest;
    return proto.billing_service.GetOwnBillingStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetOwnBillingStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetOwnBillingStatusRequest}
 */ proto.billing_service.GetOwnBillingStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetOwnBillingStatusRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetOwnBillingStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetOwnBillingStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnBillingStatusRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.GetOwnBillingStatusRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetOwnBillingStatusRequest} returns this
 */ proto.billing_service.GetOwnBillingStatusRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetBillingStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetBillingStatusResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetBillingStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetBillingStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationFeePaid: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            signedContract: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false),
            driveOffPaid: $8M67s.Message.getBooleanFieldWithDefault(msg, 3, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetBillingStatusResponse}
 */ proto.billing_service.GetBillingStatusResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetBillingStatusResponse;
    return proto.billing_service.GetBillingStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetBillingStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetBillingStatusResponse}
 */ proto.billing_service.GetBillingStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setReservationFeePaid(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSignedContract(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDriveOffPaid(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetBillingStatusResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetBillingStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetBillingStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetBillingStatusResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationFeePaid();
    if (f) writer.writeBool(1, f);
    f = message.getSignedContract();
    if (f) writer.writeBool(2, f);
    f = message.getDriveOffPaid();
    if (f) writer.writeBool(3, f);
};
/**
 * optional bool reservation_fee_paid = 1;
 * @return {boolean}
 */ proto.billing_service.GetBillingStatusResponse.prototype.getReservationFeePaid = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.GetBillingStatusResponse} returns this
 */ proto.billing_service.GetBillingStatusResponse.prototype.setReservationFeePaid = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional bool signed_contract = 2;
 * @return {boolean}
 */ proto.billing_service.GetBillingStatusResponse.prototype.getSignedContract = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.GetBillingStatusResponse} returns this
 */ proto.billing_service.GetBillingStatusResponse.prototype.setSignedContract = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
/**
 * optional bool drive_off_paid = 3;
 * @return {boolean}
 */ proto.billing_service.GetBillingStatusResponse.prototype.getDriveOffPaid = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.GetBillingStatusResponse} returns this
 */ proto.billing_service.GetBillingStatusResponse.prototype.setDriveOffPaid = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetDriveOffInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetDriveOffInvoiceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetDriveOffInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetDriveOffInvoiceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetDriveOffInvoiceRequest}
 */ proto.billing_service.GetDriveOffInvoiceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetDriveOffInvoiceRequest;
    return proto.billing_service.GetDriveOffInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetDriveOffInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetDriveOffInvoiceRequest}
 */ proto.billing_service.GetDriveOffInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetDriveOffInvoiceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetDriveOffInvoiceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetDriveOffInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetDriveOffInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.GetDriveOffInvoiceRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetDriveOffInvoiceRequest} returns this
 */ proto.billing_service.GetDriveOffInvoiceRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetOwnDriveOffInvoiceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetOwnDriveOffInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetOwnDriveOffInvoiceRequest}
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetOwnDriveOffInvoiceRequest;
    return proto.billing_service.GetOwnDriveOffInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetOwnDriveOffInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetOwnDriveOffInvoiceRequest}
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetOwnDriveOffInvoiceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetOwnDriveOffInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetOwnDriveOffInvoiceRequest} returns this
 */ proto.billing_service.GetOwnDriveOffInvoiceRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.RemoveFromOrderRequest.repeatedFields_ = [
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.RemoveFromOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.RemoveFromOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.RemoveFromOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveFromOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lineItemIdsList: (f = $8M67s.Message.getRepeatedField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.RemoveFromOrderRequest}
 */ proto.billing_service.RemoveFromOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.RemoveFromOrderRequest;
    return proto.billing_service.RemoveFromOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.RemoveFromOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.RemoveFromOrderRequest}
 */ proto.billing_service.RemoveFromOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.addLineItemIds(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.RemoveFromOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.RemoveFromOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.RemoveFromOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveFromOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLineItemIdsList();
    if (f.length > 0) writer.writeRepeatedString(4, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.RemoveFromOrderRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveFromOrderRequest} returns this
 */ proto.billing_service.RemoveFromOrderRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.RemoveFromOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveFromOrderRequest} returns this
 */ proto.billing_service.RemoveFromOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string order_number = 3;
 * @return {string}
 */ proto.billing_service.RemoveFromOrderRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveFromOrderRequest} returns this
 */ proto.billing_service.RemoveFromOrderRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * repeated string line_item_ids = 4;
 * @return {!Array<string>}
 */ proto.billing_service.RemoveFromOrderRequest.prototype.getLineItemIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 4);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.billing_service.RemoveFromOrderRequest} returns this
 */ proto.billing_service.RemoveFromOrderRequest.prototype.setLineItemIdsList = function(value) {
    return $8M67s.Message.setField(this, 4, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing_service.RemoveFromOrderRequest} returns this
 */ proto.billing_service.RemoveFromOrderRequest.prototype.addLineItemIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 4, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.RemoveFromOrderRequest} returns this
 */ proto.billing_service.RemoveFromOrderRequest.prototype.clearLineItemIdsList = function() {
    return this.setLineItemIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.RemoveFromOwnOrderRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.RemoveFromOwnOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.RemoveFromOwnOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveFromOwnOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lineItemIdsList: (f = $8M67s.Message.getRepeatedField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.RemoveFromOwnOrderRequest}
 */ proto.billing_service.RemoveFromOwnOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.RemoveFromOwnOrderRequest;
    return proto.billing_service.RemoveFromOwnOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.RemoveFromOwnOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.RemoveFromOwnOrderRequest}
 */ proto.billing_service.RemoveFromOwnOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.addLineItemIds(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.RemoveFromOwnOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.RemoveFromOwnOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveFromOwnOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLineItemIdsList();
    if (f.length > 0) writer.writeRepeatedString(3, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveFromOwnOrderRequest} returns this
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string order_number = 2;
 * @return {string}
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveFromOwnOrderRequest} returns this
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated string line_item_ids = 3;
 * @return {!Array<string>}
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.getLineItemIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 3);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.billing_service.RemoveFromOwnOrderRequest} returns this
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.setLineItemIdsList = function(value) {
    return $8M67s.Message.setField(this, 3, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing_service.RemoveFromOwnOrderRequest} returns this
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.addLineItemIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 3, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.RemoveFromOwnOrderRequest} returns this
 */ proto.billing_service.RemoveFromOwnOrderRequest.prototype.clearLineItemIdsList = function() {
    return this.setLineItemIdsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetOwnLatestDraftOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetOwnLatestDraftOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetOwnLatestDraftOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnLatestDraftOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetOwnLatestDraftOrderRequest}
 */ proto.billing_service.GetOwnLatestDraftOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetOwnLatestDraftOrderRequest;
    return proto.billing_service.GetOwnLatestDraftOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetOwnLatestDraftOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetOwnLatestDraftOrderRequest}
 */ proto.billing_service.GetOwnLatestDraftOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetOwnLatestDraftOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetOwnLatestDraftOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetOwnLatestDraftOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnLatestDraftOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.GetOwnLatestDraftOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetOwnLatestDraftOrderRequest} returns this
 */ proto.billing_service.GetOwnLatestDraftOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetLatestDraftOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetLatestDraftOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetLatestDraftOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetLatestDraftOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetLatestDraftOrderRequest}
 */ proto.billing_service.GetLatestDraftOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetLatestDraftOrderRequest;
    return proto.billing_service.GetLatestDraftOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetLatestDraftOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetLatestDraftOrderRequest}
 */ proto.billing_service.GetLatestDraftOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetLatestDraftOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetLatestDraftOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetLatestDraftOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetLatestDraftOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.GetLatestDraftOrderRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetLatestDraftOrderRequest} returns this
 */ proto.billing_service.GetLatestDraftOrderRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.GetLatestDraftOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetLatestDraftOrderRequest} returns this
 */ proto.billing_service.GetLatestDraftOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DeleteOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DeleteOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DeleteOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DeleteOrderRequest}
 */ proto.billing_service.DeleteOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DeleteOrderRequest;
    return proto.billing_service.DeleteOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DeleteOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DeleteOrderRequest}
 */ proto.billing_service.DeleteOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DeleteOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DeleteOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DeleteOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string order_number = 1;
 * @return {string}
 */ proto.billing_service.DeleteOrderRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.DeleteOrderRequest} returns this
 */ proto.billing_service.DeleteOrderRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DeleteOwnOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DeleteOwnOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DeleteOwnOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOwnOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DeleteOwnOrderRequest}
 */ proto.billing_service.DeleteOwnOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DeleteOwnOrderRequest;
    return proto.billing_service.DeleteOwnOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DeleteOwnOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DeleteOwnOrderRequest}
 */ proto.billing_service.DeleteOwnOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DeleteOwnOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DeleteOwnOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DeleteOwnOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOwnOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string order_number = 1;
 * @return {string}
 */ proto.billing_service.DeleteOwnOrderRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.DeleteOwnOrderRequest} returns this
 */ proto.billing_service.DeleteOwnOrderRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DeleteOrderResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DeleteOrderResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DeleteOrderResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOrderResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DeleteOrderResponse}
 */ proto.billing_service.DeleteOrderResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DeleteOrderResponse;
    return proto.billing_service.DeleteOrderResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DeleteOrderResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DeleteOrderResponse}
 */ proto.billing_service.DeleteOrderResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DeleteOrderResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DeleteOrderResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DeleteOrderResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOrderResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ConvertOrderToInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ConvertOrderToInvoiceResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ConvertOrderToInvoiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertOrderToInvoiceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ConvertOrderToInvoiceResponse}
 */ proto.billing_service.ConvertOrderToInvoiceResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ConvertOrderToInvoiceResponse;
    return proto.billing_service.ConvertOrderToInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ConvertOrderToInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ConvertOrderToInvoiceResponse}
 */ proto.billing_service.ConvertOrderToInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ConvertOrderToInvoiceResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ConvertOrderToInvoiceResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ConvertOrderToInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertOrderToInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.CreateFeeInvoiceRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreateFeeInvoiceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreateFeeInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateFeeInvoiceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            itemsList: $8M67s.Message.toObjectList(msg.getItemsList(), proto.billing_service.FeeItem.toObject, includeInstance),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            autoPay: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreateFeeInvoiceRequest}
 */ proto.billing_service.CreateFeeInvoiceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreateFeeInvoiceRequest;
    return proto.billing_service.CreateFeeInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreateFeeInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreateFeeInvoiceRequest}
 */ proto.billing_service.CreateFeeInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new proto.billing_service.FeeItem;
                reader.readMessage(value, proto.billing_service.FeeItem.deserializeBinaryFromReader);
                msg.addItems(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setAutoPay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreateFeeInvoiceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreateFeeInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateFeeInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.billing_service.FeeItem.serializeBinaryToWriter);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAutoPay();
    if (f) writer.writeBool(4, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateFeeInvoiceRequest} returns this
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated FeeItem items = 2;
 * @return {!Array<!proto.billing_service.FeeItem>}
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.getItemsList = function() {
    return /** @type{!Array<!proto.billing_service.FeeItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.FeeItem, 2);
};
/**
 * @param {!Array<!proto.billing_service.FeeItem>} value
 * @return {!proto.billing_service.CreateFeeInvoiceRequest} returns this
*/ proto.billing_service.CreateFeeInvoiceRequest.prototype.setItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.billing_service.FeeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.FeeItem}
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.addItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.billing_service.FeeItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.CreateFeeInvoiceRequest} returns this
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.clearItemsList = function() {
    return this.setItemsList([]);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateFeeInvoiceRequest} returns this
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional bool auto_pay = 4;
 * @return {boolean}
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.getAutoPay = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.CreateFeeInvoiceRequest} returns this
 */ proto.billing_service.CreateFeeInvoiceRequest.prototype.setAutoPay = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.FeeItem.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.FeeItem.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.FeeItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.FeeItem.toObject = function(includeInstance, msg) {
        var f, obj = {
            amount: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            description: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            productType: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.FeeItem}
 */ proto.billing_service.FeeItem.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.FeeItem;
    return proto.billing_service.FeeItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.FeeItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.FeeItem}
 */ proto.billing_service.FeeItem.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.Product.ProductType} */ reader.readEnum();
                msg.setProductType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.FeeItem.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.FeeItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.FeeItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.FeeItem.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getProductType();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional int32 amount = 1;
 * @return {number}
 */ proto.billing_service.FeeItem.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.FeeItem} returns this
 */ proto.billing_service.FeeItem.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string description = 2;
 * @return {string}
 */ proto.billing_service.FeeItem.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.FeeItem} returns this
 */ proto.billing_service.FeeItem.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional domain.Product.ProductType product_type = 3;
 * @return {!proto.domain.Product.ProductType}
 */ proto.billing_service.FeeItem.prototype.getProductType = function() {
    return /** @type {!proto.domain.Product.ProductType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.Product.ProductType} value
 * @return {!proto.billing_service.FeeItem} returns this
 */ proto.billing_service.FeeItem.prototype.setProductType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreateFeeInvoiceResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreateFeeInvoiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateFeeInvoiceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            paymentSuccess: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false),
            paymentApplied: $8M67s.Message.getBooleanFieldWithDefault(msg, 3, false),
            message: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreateFeeInvoiceResponse}
 */ proto.billing_service.CreateFeeInvoiceResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreateFeeInvoiceResponse;
    return proto.billing_service.CreateFeeInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreateFeeInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreateFeeInvoiceResponse}
 */ proto.billing_service.CreateFeeInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPaymentSuccess(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPaymentApplied(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreateFeeInvoiceResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreateFeeInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateFeeInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPaymentSuccess();
    if (f) writer.writeBool(2, f);
    f = message.getPaymentApplied();
    if (f) writer.writeBool(3, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string invoice_number = 1;
 * @return {string}
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateFeeInvoiceResponse} returns this
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool payment_success = 2;
 * @return {boolean}
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.getPaymentSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.CreateFeeInvoiceResponse} returns this
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.setPaymentSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
/**
 * optional bool payment_applied = 3;
 * @return {boolean}
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.getPaymentApplied = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.CreateFeeInvoiceResponse} returns this
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.setPaymentApplied = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 3, value);
};
/**
 * optional string message = 4;
 * @return {string}
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateFeeInvoiceResponse} returns this
 */ proto.billing_service.CreateFeeInvoiceResponse.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.CreateFinalBillRequest.repeatedFields_ = [
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreateFinalBillRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreateFinalBillRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreateFinalBillRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateFinalBillRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            itemsList: $8M67s.Message.toObjectList(msg.getItemsList(), proto.billing_service.FeeItem.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreateFinalBillRequest}
 */ proto.billing_service.CreateFinalBillRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreateFinalBillRequest;
    return proto.billing_service.CreateFinalBillRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreateFinalBillRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreateFinalBillRequest}
 */ proto.billing_service.CreateFinalBillRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = new proto.billing_service.FeeItem;
                reader.readMessage(value, proto.billing_service.FeeItem.deserializeBinaryFromReader);
                msg.addItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreateFinalBillRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreateFinalBillRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreateFinalBillRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateFinalBillRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.billing_service.FeeItem.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.CreateFinalBillRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateFinalBillRequest} returns this
 */ proto.billing_service.CreateFinalBillRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.CreateFinalBillRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateFinalBillRequest} returns this
 */ proto.billing_service.CreateFinalBillRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated FeeItem items = 4;
 * @return {!Array<!proto.billing_service.FeeItem>}
 */ proto.billing_service.CreateFinalBillRequest.prototype.getItemsList = function() {
    return /** @type{!Array<!proto.billing_service.FeeItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.FeeItem, 4);
};
/**
 * @param {!Array<!proto.billing_service.FeeItem>} value
 * @return {!proto.billing_service.CreateFinalBillRequest} returns this
*/ proto.billing_service.CreateFinalBillRequest.prototype.setItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.billing_service.FeeItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.FeeItem}
 */ proto.billing_service.CreateFinalBillRequest.prototype.addItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.billing_service.FeeItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.CreateFinalBillRequest} returns this
 */ proto.billing_service.CreateFinalBillRequest.prototype.clearItemsList = function() {
    return this.setItemsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ConfirmFinalBillRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ConfirmFinalBillRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ConfirmFinalBillRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConfirmFinalBillRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ConfirmFinalBillRequest}
 */ proto.billing_service.ConfirmFinalBillRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ConfirmFinalBillRequest;
    return proto.billing_service.ConfirmFinalBillRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ConfirmFinalBillRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ConfirmFinalBillRequest}
 */ proto.billing_service.ConfirmFinalBillRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ConfirmFinalBillRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ConfirmFinalBillRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ConfirmFinalBillRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConfirmFinalBillRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.ConfirmFinalBillRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ConfirmFinalBillRequest} returns this
 */ proto.billing_service.ConfirmFinalBillRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.ConfirmFinalBillRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ConfirmFinalBillRequest} returns this
 */ proto.billing_service.ConfirmFinalBillRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.OrderFE.repeatedFields_ = [
    7
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.OrderFE.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.OrderFE.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.OrderFE} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.OrderFE.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            updated: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), proto.billing_service.LineItemFE.toObject, includeInstance),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 9, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.OrderFE}
 */ proto.billing_service.OrderFE.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.OrderFE;
    return proto.billing_service.OrderFE.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.OrderFE} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.OrderFE}
 */ proto.billing_service.OrderFE.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setUpdated(value);
                break;
            case 7:
                var value = new proto.billing_service.LineItemFE;
                reader.readMessage(value, proto.billing_service.LineItemFE.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.OrderFE.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.OrderFE.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.OrderFE} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.OrderFE.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getUpdated();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, proto.billing_service.LineItemFE.serializeBinaryToWriter);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(9, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.OrderFE.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.OrderFE} returns this
 */ proto.billing_service.OrderFE.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.billing_service.OrderFE.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.OrderFE} returns this
 */ proto.billing_service.OrderFE.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.billing_service.OrderFE.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.OrderFE} returns this
 */ proto.billing_service.OrderFE.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 created = 4;
 * @return {number}
 */ proto.billing_service.OrderFE.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.OrderFE} returns this
 */ proto.billing_service.OrderFE.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 updated = 5;
 * @return {number}
 */ proto.billing_service.OrderFE.prototype.getUpdated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.OrderFE} returns this
 */ proto.billing_service.OrderFE.prototype.setUpdated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * repeated LineItemFE line_items = 7;
 * @return {!Array<!proto.billing_service.LineItemFE>}
 */ proto.billing_service.OrderFE.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.billing_service.LineItemFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.LineItemFE, 7);
};
/**
 * @param {!Array<!proto.billing_service.LineItemFE>} value
 * @return {!proto.billing_service.OrderFE} returns this
*/ proto.billing_service.OrderFE.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.billing_service.LineItemFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.LineItemFE}
 */ proto.billing_service.OrderFE.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.billing_service.LineItemFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.OrderFE} returns this
 */ proto.billing_service.OrderFE.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
/**
 * optional string order_number = 8;
 * @return {string}
 */ proto.billing_service.OrderFE.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.OrderFE} returns this
 */ proto.billing_service.OrderFE.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string invoice_number = 9;
 * @return {string}
 */ proto.billing_service.OrderFE.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.OrderFE} returns this
 */ proto.billing_service.OrderFE.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetOwnAccountBalanceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetOwnAccountBalanceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetOwnAccountBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnAccountBalanceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetOwnAccountBalanceRequest}
 */ proto.billing_service.GetOwnAccountBalanceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetOwnAccountBalanceRequest;
    return proto.billing_service.GetOwnAccountBalanceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetOwnAccountBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetOwnAccountBalanceRequest}
 */ proto.billing_service.GetOwnAccountBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetOwnAccountBalanceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetOwnAccountBalanceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetOwnAccountBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnAccountBalanceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetAccountBalanceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetAccountBalanceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetAccountBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetAccountBalanceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetAccountBalanceRequest}
 */ proto.billing_service.GetAccountBalanceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetAccountBalanceRequest;
    return proto.billing_service.GetAccountBalanceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetAccountBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetAccountBalanceRequest}
 */ proto.billing_service.GetAccountBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetAccountBalanceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetAccountBalanceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetAccountBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetAccountBalanceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.GetAccountBalanceRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetAccountBalanceRequest} returns this
 */ proto.billing_service.GetAccountBalanceRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetAccountBalanceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetAccountBalanceResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetAccountBalanceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetAccountBalanceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            openBalance: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            pastDueBalance: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetAccountBalanceResponse}
 */ proto.billing_service.GetAccountBalanceResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetAccountBalanceResponse;
    return proto.billing_service.GetAccountBalanceResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetAccountBalanceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetAccountBalanceResponse}
 */ proto.billing_service.GetAccountBalanceResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOpenBalance(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPastDueBalance(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetAccountBalanceResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetAccountBalanceResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetAccountBalanceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetAccountBalanceResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOpenBalance();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getPastDueBalance();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.GetAccountBalanceResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetAccountBalanceResponse} returns this
 */ proto.billing_service.GetAccountBalanceResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 open_balance = 2;
 * @return {number}
 */ proto.billing_service.GetAccountBalanceResponse.prototype.getOpenBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.GetAccountBalanceResponse} returns this
 */ proto.billing_service.GetAccountBalanceResponse.prototype.setOpenBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 past_due_balance = 3;
 * @return {number}
 */ proto.billing_service.GetAccountBalanceResponse.prototype.getPastDueBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.GetAccountBalanceResponse} returns this
 */ proto.billing_service.GetAccountBalanceResponse.prototype.setPastDueBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListOwnInvoicesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListOwnInvoicesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListOwnInvoicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListOwnInvoicesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListOwnInvoicesRequest}
 */ proto.billing_service.ListOwnInvoicesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListOwnInvoicesRequest;
    return proto.billing_service.ListOwnInvoicesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListOwnInvoicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListOwnInvoicesRequest}
 */ proto.billing_service.ListOwnInvoicesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListOwnInvoicesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListOwnInvoicesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListOwnInvoicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListOwnInvoicesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_Id = 1;
 * @return {string}
 */ proto.billing_service.ListOwnInvoicesRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ListOwnInvoicesRequest} returns this
 */ proto.billing_service.ListOwnInvoicesRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListInvoicesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListInvoicesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListInvoicesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListInvoicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListInvoicesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            invoicesList: $8M67s.Message.toObjectList(msg.getInvoicesList(), proto.billing_service.InvoiceFE.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListInvoicesResponse}
 */ proto.billing_service.ListInvoicesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListInvoicesResponse;
    return proto.billing_service.ListInvoicesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListInvoicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListInvoicesResponse}
 */ proto.billing_service.ListInvoicesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.InvoiceFE;
                reader.readMessage(value, proto.billing_service.InvoiceFE.deserializeBinaryFromReader);
                msg.addInvoices(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListInvoicesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListInvoicesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListInvoicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListInvoicesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInvoicesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.InvoiceFE.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * repeated InvoiceFE invoices = 1;
 * @return {!Array<!proto.billing_service.InvoiceFE>}
 */ proto.billing_service.ListInvoicesResponse.prototype.getInvoicesList = function() {
    return /** @type{!Array<!proto.billing_service.InvoiceFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.InvoiceFE, 1);
};
/**
 * @param {!Array<!proto.billing_service.InvoiceFE>} value
 * @return {!proto.billing_service.ListInvoicesResponse} returns this
*/ proto.billing_service.ListInvoicesResponse.prototype.setInvoicesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.InvoiceFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.InvoiceFE}
 */ proto.billing_service.ListInvoicesResponse.prototype.addInvoices = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.InvoiceFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListInvoicesResponse} returns this
 */ proto.billing_service.ListInvoicesResponse.prototype.clearInvoicesList = function() {
    return this.setInvoicesList([]);
};
/**
 * optional int64 total = 2;
 * @return {number}
 */ proto.billing_service.ListInvoicesResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ListInvoicesResponse} returns this
 */ proto.billing_service.ListInvoicesResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdateReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdateReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdateReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            monthlyRent: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            color: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            secondaryColor: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            postal: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            trackingId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdateReservationRequest}
 */ proto.billing_service.UpdateReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdateReservationRequest;
    return proto.billing_service.UpdateReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdateReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdateReservationRequest}
 */ proto.billing_service.UpdateReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRent(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSecondaryColor(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setPostal(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingId(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdateReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdateReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdateReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMonthlyRent();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getColor();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getSecondaryColor();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getPostal();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getTrackingId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional string reservation_id = 1;
 * @return {string}
 */ proto.billing_service.UpdateReservationRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 deposit = 2;
 * @return {number}
 */ proto.billing_service.UpdateReservationRequest.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 start_fee = 3;
 * @return {number}
 */ proto.billing_service.UpdateReservationRequest.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 monthly_rent = 4;
 * @return {number}
 */ proto.billing_service.UpdateReservationRequest.prototype.getMonthlyRent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setMonthlyRent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string color = 5;
 * @return {string}
 */ proto.billing_service.UpdateReservationRequest.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string secondary_color = 6;
 * @return {string}
 */ proto.billing_service.UpdateReservationRequest.prototype.getSecondaryColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setSecondaryColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string make = 7;
 * @return {string}
 */ proto.billing_service.UpdateReservationRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string model = 8;
 * @return {string}
 */ proto.billing_service.UpdateReservationRequest.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string postal = 9;
 * @return {string}
 */ proto.billing_service.UpdateReservationRequest.prototype.getPostal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setPostal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string tracking_id = 10;
 * @return {string}
 */ proto.billing_service.UpdateReservationRequest.prototype.getTrackingId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setTrackingId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string program_id = 11;
 * @return {string}
 */ proto.billing_service.UpdateReservationRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateReservationRequest} returns this
 */ proto.billing_service.UpdateReservationRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetReservationRequest}
 */ proto.billing_service.GetReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetReservationRequest;
    return proto.billing_service.GetReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetReservationRequest}
 */ proto.billing_service.GetReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string reservation_id = 1;
 * @return {string}
 */ proto.billing_service.GetReservationRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetReservationRequest} returns this
 */ proto.billing_service.GetReservationRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListOwnProgramReservationsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListOwnProgramReservationsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListOwnProgramReservationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListOwnProgramReservationsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListOwnProgramReservationsRequest}
 */ proto.billing_service.ListOwnProgramReservationsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListOwnProgramReservationsRequest;
    return proto.billing_service.ListOwnProgramReservationsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListOwnProgramReservationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListOwnProgramReservationsRequest}
 */ proto.billing_service.ListOwnProgramReservationsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListOwnProgramReservationsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListOwnProgramReservationsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListOwnProgramReservationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListOwnProgramReservationsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListReservationsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListReservationsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListReservationsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListReservationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListReservationsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationsList: $8M67s.Message.toObjectList(msg.getReservationsList(), proto.billing_service.Reservation.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListReservationsResponse}
 */ proto.billing_service.ListReservationsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListReservationsResponse;
    return proto.billing_service.ListReservationsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListReservationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListReservationsResponse}
 */ proto.billing_service.ListReservationsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.Reservation;
                reader.readMessage(value, proto.billing_service.Reservation.deserializeBinaryFromReader);
                msg.addReservations(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListReservationsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListReservationsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListReservationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListReservationsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.Reservation.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * repeated Reservation reservations = 1;
 * @return {!Array<!proto.billing_service.Reservation>}
 */ proto.billing_service.ListReservationsResponse.prototype.getReservationsList = function() {
    return /** @type{!Array<!proto.billing_service.Reservation>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.Reservation, 1);
};
/**
 * @param {!Array<!proto.billing_service.Reservation>} value
 * @return {!proto.billing_service.ListReservationsResponse} returns this
*/ proto.billing_service.ListReservationsResponse.prototype.setReservationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.Reservation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.Reservation}
 */ proto.billing_service.ListReservationsResponse.prototype.addReservations = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.Reservation, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListReservationsResponse} returns this
 */ proto.billing_service.ListReservationsResponse.prototype.clearReservationsList = function() {
    return this.setReservationsList([]);
};
/**
 * optional int64 total = 2;
 * @return {number}
 */ proto.billing_service.ListReservationsResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ListReservationsResponse} returns this
 */ proto.billing_service.ListReservationsResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreateReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreateReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreateReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            programId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            monthlyRent: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            color: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            secondaryColor: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            postal: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 15, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 16, ""),
            trackingId: $8M67s.Message.getFieldWithDefault(msg, 17, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreateReservationRequest}
 */ proto.billing_service.CreateReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreateReservationRequest;
    return proto.billing_service.CreateReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreateReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreateReservationRequest}
 */ proto.billing_service.CreateReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReservationFee(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRent(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setSecondaryColor(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setPostal(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 16:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 17:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreateReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreateReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreateReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreateReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReservationFee();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getMonthlyRent();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getColor();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getSecondaryColor();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getPostal();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(15, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(16, f);
    f = message.getTrackingId();
    if (f.length > 0) writer.writeString(17, f);
};
/**
 * optional string program_id = 1;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 reservation_fee = 4;
 * @return {number}
 */ proto.billing_service.CreateReservationRequest.prototype.getReservationFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 deposit = 5;
 * @return {number}
 */ proto.billing_service.CreateReservationRequest.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 start_fee = 6;
 * @return {number}
 */ proto.billing_service.CreateReservationRequest.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 monthly_rent = 7;
 * @return {number}
 */ proto.billing_service.CreateReservationRequest.prototype.getMonthlyRent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setMonthlyRent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string color = 8;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string secondary_color = 9;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getSecondaryColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setSecondaryColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string make = 10;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string model = 11;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string postal = 12;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getPostal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setPostal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string first_name = 13;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string last_name = 14;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional string email = 15;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
/**
 * optional string phone = 16;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 16, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 16, value);
};
/**
 * optional string tracking_id = 17;
 * @return {string}
 */ proto.billing_service.CreateReservationRequest.prototype.getTrackingId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 17, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreateReservationRequest} returns this
 */ proto.billing_service.CreateReservationRequest.prototype.setTrackingId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 17, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.InvoiceReference.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.InvoiceReference.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.InvoiceReference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.InvoiceReference.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            invoiceId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            invoiceType: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.InvoiceReference}
 */ proto.billing_service.InvoiceReference.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.InvoiceReference;
    return proto.billing_service.InvoiceReference.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.InvoiceReference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.InvoiceReference}
 */ proto.billing_service.InvoiceReference.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceId(value);
                break;
            case 3:
                var value = /** @type {!proto.billing_service.InvoiceType} */ reader.readEnum();
                msg.setInvoiceType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.InvoiceReference.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.InvoiceReference.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.InvoiceReference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.InvoiceReference.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getInvoiceId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getInvoiceType();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.InvoiceReference.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.InvoiceReference} returns this
 */ proto.billing_service.InvoiceReference.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string invoice_id = 2;
 * @return {string}
 */ proto.billing_service.InvoiceReference.prototype.getInvoiceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.InvoiceReference} returns this
 */ proto.billing_service.InvoiceReference.prototype.setInvoiceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional InvoiceType invoice_type = 3;
 * @return {!proto.billing_service.InvoiceType}
 */ proto.billing_service.InvoiceReference.prototype.getInvoiceType = function() {
    return /** @type {!proto.billing_service.InvoiceType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.billing_service.InvoiceType} value
 * @return {!proto.billing_service.InvoiceReference} returns this
 */ proto.billing_service.InvoiceReference.prototype.setInvoiceType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListProductsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListProductsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListProductsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProductsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            productsList: $8M67s.Message.toObjectList(msg.getProductsList(), proto.billing_service.ProductFE.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListProductsResponse}
 */ proto.billing_service.ListProductsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListProductsResponse;
    return proto.billing_service.ListProductsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListProductsResponse}
 */ proto.billing_service.ListProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.ProductFE;
                reader.readMessage(value, proto.billing_service.ProductFE.deserializeBinaryFromReader);
                msg.addProducts(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListProductsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListProductsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProductsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProductsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.ProductFE.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * repeated ProductFE products = 1;
 * @return {!Array<!proto.billing_service.ProductFE>}
 */ proto.billing_service.ListProductsResponse.prototype.getProductsList = function() {
    return /** @type{!Array<!proto.billing_service.ProductFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.ProductFE, 1);
};
/**
 * @param {!Array<!proto.billing_service.ProductFE>} value
 * @return {!proto.billing_service.ListProductsResponse} returns this
*/ proto.billing_service.ListProductsResponse.prototype.setProductsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.ProductFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.ProductFE}
 */ proto.billing_service.ListProductsResponse.prototype.addProducts = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.ProductFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListProductsResponse} returns this
 */ proto.billing_service.ListProductsResponse.prototype.clearProductsList = function() {
    return this.setProductsList([]);
};
/**
 * optional int64 total = 2;
 * @return {number}
 */ proto.billing_service.ListProductsResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ListProductsResponse} returns this
 */ proto.billing_service.ListProductsResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ProductFE.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ProductFE.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ProductFE} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ProductFE.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            isRecurring: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ProductFE}
 */ proto.billing_service.ProductFE.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ProductFE;
    return proto.billing_service.ProductFE.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ProductFE} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ProductFE}
 */ proto.billing_service.ProductFE.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsRecurring(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ProductFE.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ProductFE.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ProductFE} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ProductFE.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getIsRecurring();
    if (f) writer.writeBool(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.ProductFE.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ProductFE} returns this
 */ proto.billing_service.ProductFE.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.billing_service.ProductFE.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ProductFE} returns this
 */ proto.billing_service.ProductFE.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string description = 3;
 * @return {string}
 */ proto.billing_service.ProductFE.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ProductFE} returns this
 */ proto.billing_service.ProductFE.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional bool is_recurring = 4;
 * @return {boolean}
 */ proto.billing_service.ProductFE.prototype.getIsRecurring = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ProductFE} returns this
 */ proto.billing_service.ProductFE.prototype.setIsRecurring = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ProgramColorOption.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ProgramColorOption.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ProgramColorOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ProgramColorOption.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ProgramColorOption}
 */ proto.billing_service.ProgramColorOption.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ProgramColorOption;
    return proto.billing_service.ProgramColorOption.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ProgramColorOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ProgramColorOption}
 */ proto.billing_service.ProgramColorOption.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ProgramColorOption.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ProgramColorOption.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ProgramColorOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ProgramColorOption.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.ProgramColorOption.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ProgramColorOption} returns this
 */ proto.billing_service.ProgramColorOption.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.billing_service.ProgramColorOption.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ProgramColorOption} returns this
 */ proto.billing_service.ProgramColorOption.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.DatedProgramPricing.repeatedFields_ = [
    5
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DatedProgramPricing.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DatedProgramPricing.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DatedProgramPricing} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DatedProgramPricing.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            fromDate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            toDate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            pricingOptionsList: $8M67s.Message.toObjectList(msg.getPricingOptionsList(), proto.billing_service.PricingOption.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DatedProgramPricing}
 */ proto.billing_service.DatedProgramPricing.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DatedProgramPricing;
    return proto.billing_service.DatedProgramPricing.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DatedProgramPricing} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DatedProgramPricing}
 */ proto.billing_service.DatedProgramPricing.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setFromDate(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setToDate(value);
                break;
            case 5:
                var value = new proto.billing_service.PricingOption;
                reader.readMessage(value, proto.billing_service.PricingOption.deserializeBinaryFromReader);
                msg.addPricingOptions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DatedProgramPricing.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DatedProgramPricing.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DatedProgramPricing} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DatedProgramPricing.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFromDate();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getToDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getPricingOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, proto.billing_service.PricingOption.serializeBinaryToWriter);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.DatedProgramPricing.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.DatedProgramPricing} returns this
 */ proto.billing_service.DatedProgramPricing.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string program_id = 2;
 * @return {string}
 */ proto.billing_service.DatedProgramPricing.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.DatedProgramPricing} returns this
 */ proto.billing_service.DatedProgramPricing.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 from_date = 3;
 * @return {number}
 */ proto.billing_service.DatedProgramPricing.prototype.getFromDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.DatedProgramPricing} returns this
 */ proto.billing_service.DatedProgramPricing.prototype.setFromDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int64 to_date = 4;
 * @return {number}
 */ proto.billing_service.DatedProgramPricing.prototype.getToDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.DatedProgramPricing} returns this
 */ proto.billing_service.DatedProgramPricing.prototype.setToDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * repeated PricingOption pricing_options = 5;
 * @return {!Array<!proto.billing_service.PricingOption>}
 */ proto.billing_service.DatedProgramPricing.prototype.getPricingOptionsList = function() {
    return /** @type{!Array<!proto.billing_service.PricingOption>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.PricingOption, 5);
};
/**
 * @param {!Array<!proto.billing_service.PricingOption>} value
 * @return {!proto.billing_service.DatedProgramPricing} returns this
*/ proto.billing_service.DatedProgramPricing.prototype.setPricingOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.billing_service.PricingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.PricingOption}
 */ proto.billing_service.DatedProgramPricing.prototype.addPricingOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.billing_service.PricingOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.DatedProgramPricing} returns this
 */ proto.billing_service.DatedProgramPricing.prototype.clearPricingOptionsList = function() {
    return this.setPricingOptionsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PricingOption.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PricingOption.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PricingOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PricingOption.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            monthlyRent: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PricingOption}
 */ proto.billing_service.PricingOption.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PricingOption;
    return proto.billing_service.PricingOption.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PricingOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PricingOption}
 */ proto.billing_service.PricingOption.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReservationFee(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRent(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPriceTermMonths(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PricingOption.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PricingOption.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PricingOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PricingOption.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReservationFee();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getMonthlyRent();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getPriceTermMonths();
    if (f !== 0) writer.writeInt32(6, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.PricingOption.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PricingOption} returns this
 */ proto.billing_service.PricingOption.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 reservation_fee = 2;
 * @return {number}
 */ proto.billing_service.PricingOption.prototype.getReservationFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PricingOption} returns this
 */ proto.billing_service.PricingOption.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 deposit = 3;
 * @return {number}
 */ proto.billing_service.PricingOption.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PricingOption} returns this
 */ proto.billing_service.PricingOption.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 start_fee = 4;
 * @return {number}
 */ proto.billing_service.PricingOption.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PricingOption} returns this
 */ proto.billing_service.PricingOption.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 monthly_rent = 5;
 * @return {number}
 */ proto.billing_service.PricingOption.prototype.getMonthlyRent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PricingOption} returns this
 */ proto.billing_service.PricingOption.prototype.setMonthlyRent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 price_term_months = 6;
 * @return {number}
 */ proto.billing_service.PricingOption.prototype.getPriceTermMonths = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PricingOption} returns this
 */ proto.billing_service.PricingOption.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.Program.repeatedFields_ = [
    6,
    7
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.Program.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.Program.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.Program} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Program.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            trimOptions: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            colorOptionsList: $8M67s.Message.toObjectList(msg.getColorOptionsList(), proto.billing_service.ProgramColorOption.toObject, includeInstance),
            pricingOptionsList: $8M67s.Message.toObjectList(msg.getPricingOptionsList(), proto.billing_service.DatedProgramPricing.toObject, includeInstance),
            make: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            active: $8M67s.Message.getBooleanFieldWithDefault(msg, 10, false),
            hidden: $8M67s.Message.getBooleanFieldWithDefault(msg, 11, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.Program}
 */ proto.billing_service.Program.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.Program;
    return proto.billing_service.Program.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.Program} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.Program}
 */ proto.billing_service.Program.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setTrimOptions(value);
                break;
            case 6:
                var value = new proto.billing_service.ProgramColorOption;
                reader.readMessage(value, proto.billing_service.ProgramColorOption.deserializeBinaryFromReader);
                msg.addColorOptions(value);
                break;
            case 7:
                var value = new proto.billing_service.DatedProgramPricing;
                reader.readMessage(value, proto.billing_service.DatedProgramPricing.deserializeBinaryFromReader);
                msg.addPricingOptions(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setActive(value);
                break;
            case 11:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setHidden(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.Program.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.Program.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.Program} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Program.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getTrimOptions();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getColorOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, proto.billing_service.ProgramColorOption.serializeBinaryToWriter);
    f = message.getPricingOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, proto.billing_service.DatedProgramPricing.serializeBinaryToWriter);
    f = message.getMake();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getActive();
    if (f) writer.writeBool(10, f);
    f = message.getHidden();
    if (f) writer.writeBool(11, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.Program.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.billing_service.Program.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string description = 3;
 * @return {string}
 */ proto.billing_service.Program.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 created = 4;
 * @return {number}
 */ proto.billing_service.Program.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string trim_options = 5;
 * @return {string}
 */ proto.billing_service.Program.prototype.getTrimOptions = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setTrimOptions = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * repeated ProgramColorOption color_options = 6;
 * @return {!Array<!proto.billing_service.ProgramColorOption>}
 */ proto.billing_service.Program.prototype.getColorOptionsList = function() {
    return /** @type{!Array<!proto.billing_service.ProgramColorOption>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.ProgramColorOption, 6);
};
/**
 * @param {!Array<!proto.billing_service.ProgramColorOption>} value
 * @return {!proto.billing_service.Program} returns this
*/ proto.billing_service.Program.prototype.setColorOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.billing_service.ProgramColorOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.ProgramColorOption}
 */ proto.billing_service.Program.prototype.addColorOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.billing_service.ProgramColorOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.clearColorOptionsList = function() {
    return this.setColorOptionsList([]);
};
/**
 * repeated DatedProgramPricing pricing_options = 7;
 * @return {!Array<!proto.billing_service.DatedProgramPricing>}
 */ proto.billing_service.Program.prototype.getPricingOptionsList = function() {
    return /** @type{!Array<!proto.billing_service.DatedProgramPricing>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.DatedProgramPricing, 7);
};
/**
 * @param {!Array<!proto.billing_service.DatedProgramPricing>} value
 * @return {!proto.billing_service.Program} returns this
*/ proto.billing_service.Program.prototype.setPricingOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.billing_service.DatedProgramPricing=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.DatedProgramPricing}
 */ proto.billing_service.Program.prototype.addPricingOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.billing_service.DatedProgramPricing, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.clearPricingOptionsList = function() {
    return this.setPricingOptionsList([]);
};
/**
 * optional string make = 8;
 * @return {string}
 */ proto.billing_service.Program.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string model = 9;
 * @return {string}
 */ proto.billing_service.Program.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional bool active = 10;
 * @return {boolean}
 */ proto.billing_service.Program.prototype.getActive = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setActive = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 10, value);
};
/**
 * optional bool hidden = 11;
 * @return {boolean}
 */ proto.billing_service.Program.prototype.getHidden = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 11, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.Program} returns this
 */ proto.billing_service.Program.prototype.setHidden = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListProgramsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListProgramsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListProgramsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProgramsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListProgramsRequest}
 */ proto.billing_service.ListProgramsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListProgramsRequest;
    return proto.billing_service.ListProgramsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListProgramsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListProgramsRequest}
 */ proto.billing_service.ListProgramsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListProgramsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListProgramsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListProgramsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProgramsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListProgramsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListProgramsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListProgramsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListProgramsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProgramsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            programsList: $8M67s.Message.toObjectList(msg.getProgramsList(), proto.billing_service.Program.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListProgramsResponse}
 */ proto.billing_service.ListProgramsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListProgramsResponse;
    return proto.billing_service.ListProgramsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListProgramsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListProgramsResponse}
 */ proto.billing_service.ListProgramsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.Program;
                reader.readMessage(value, proto.billing_service.Program.deserializeBinaryFromReader);
                msg.addPrograms(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListProgramsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListProgramsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListProgramsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProgramsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgramsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.Program.serializeBinaryToWriter);
};
/**
 * repeated Program programs = 1;
 * @return {!Array<!proto.billing_service.Program>}
 */ proto.billing_service.ListProgramsResponse.prototype.getProgramsList = function() {
    return /** @type{!Array<!proto.billing_service.Program>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.Program, 1);
};
/**
 * @param {!Array<!proto.billing_service.Program>} value
 * @return {!proto.billing_service.ListProgramsResponse} returns this
*/ proto.billing_service.ListProgramsResponse.prototype.setProgramsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.Program=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.Program}
 */ proto.billing_service.ListProgramsResponse.prototype.addPrograms = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.Program, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListProgramsResponse} returns this
 */ proto.billing_service.ListProgramsResponse.prototype.clearProgramsList = function() {
    return this.setProgramsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DetailsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DetailsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DetailsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DetailsRequest}
 */ proto.billing_service.DetailsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DetailsRequest;
    return proto.billing_service.DetailsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DetailsRequest}
 */ proto.billing_service.DetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DetailsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DetailsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string promo_code = 1;
 * @return {string}
 */ proto.billing_service.DetailsRequest.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.DetailsRequest} returns this
 */ proto.billing_service.DetailsRequest.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PromotionConstraint.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PromotionConstraint.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PromotionConstraint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PromotionConstraint.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            promotionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            constraintDimension: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            constraintProperty: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            constraintValue: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PromotionConstraint}
 */ proto.billing_service.PromotionConstraint.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PromotionConstraint;
    return proto.billing_service.PromotionConstraint.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PromotionConstraint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PromotionConstraint}
 */ proto.billing_service.PromotionConstraint.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPromotionId(value);
                break;
            case 3:
                var value = /** @type {!proto.billing_service.PromotionConstraint.ConstraintDimension} */ reader.readEnum();
                msg.setConstraintDimension(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setConstraintProperty(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setConstraintValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PromotionConstraint.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PromotionConstraint.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PromotionConstraint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PromotionConstraint.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPromotionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getConstraintDimension();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getConstraintProperty();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getConstraintValue();
    if (f !== 0) writer.writeInt64(5, f);
};
/**
 * @enum {number}
 */ proto.billing_service.PromotionConstraint.ConstraintDimension = {
    APPLICATION_COUNT: 0
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.PromotionConstraint.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionConstraint} returns this
 */ proto.billing_service.PromotionConstraint.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string promotion_id = 2;
 * @return {string}
 */ proto.billing_service.PromotionConstraint.prototype.getPromotionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionConstraint} returns this
 */ proto.billing_service.PromotionConstraint.prototype.setPromotionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional ConstraintDimension constraint_dimension = 3;
 * @return {!proto.billing_service.PromotionConstraint.ConstraintDimension}
 */ proto.billing_service.PromotionConstraint.prototype.getConstraintDimension = function() {
    return /** @type {!proto.billing_service.PromotionConstraint.ConstraintDimension} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.billing_service.PromotionConstraint.ConstraintDimension} value
 * @return {!proto.billing_service.PromotionConstraint} returns this
 */ proto.billing_service.PromotionConstraint.prototype.setConstraintDimension = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string constraint_property = 4;
 * @return {string}
 */ proto.billing_service.PromotionConstraint.prototype.getConstraintProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionConstraint} returns this
 */ proto.billing_service.PromotionConstraint.prototype.setConstraintProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 constraint_value = 5;
 * @return {number}
 */ proto.billing_service.PromotionConstraint.prototype.getConstraintValue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PromotionConstraint} returns this
 */ proto.billing_service.PromotionConstraint.prototype.setConstraintValue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PromotionDetails.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PromotionDetails.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PromotionDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PromotionDetails.toObject = function(includeInstance, msg) {
        var f, obj = {
            promotionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            rebateValue: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            rebatePercent: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            target: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            source: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            sourceName: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            sourceId: $8M67s.Message.getFieldWithDefault(msg, 8, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PromotionDetails}
 */ proto.billing_service.PromotionDetails.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PromotionDetails;
    return proto.billing_service.PromotionDetails.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PromotionDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PromotionDetails}
 */ proto.billing_service.PromotionDetails.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPromotionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setRebateValue(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRebatePercent(value);
                break;
            case 5:
                var value = /** @type {!proto.billing_service.PromotionTarget} */ reader.readEnum();
                msg.setTarget(value);
                break;
            case 6:
                var value = /** @type {!proto.billing_service.PromotionSource} */ reader.readEnum();
                msg.setSource(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceName(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PromotionDetails.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PromotionDetails.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PromotionDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PromotionDetails.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPromotionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getRebateValue();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getRebatePercent();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getTarget();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getSource();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getSourceName();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getSourceId();
    if (f.length > 0) writer.writeString(8, f);
};
/**
 * optional string promotion_id = 1;
 * @return {string}
 */ proto.billing_service.PromotionDetails.prototype.getPromotionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionDetails} returns this
 */ proto.billing_service.PromotionDetails.prototype.setPromotionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string promo_code = 2;
 * @return {string}
 */ proto.billing_service.PromotionDetails.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionDetails} returns this
 */ proto.billing_service.PromotionDetails.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 rebate_value = 3;
 * @return {number}
 */ proto.billing_service.PromotionDetails.prototype.getRebateValue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PromotionDetails} returns this
 */ proto.billing_service.PromotionDetails.prototype.setRebateValue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 rebate_percent = 4;
 * @return {number}
 */ proto.billing_service.PromotionDetails.prototype.getRebatePercent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PromotionDetails} returns this
 */ proto.billing_service.PromotionDetails.prototype.setRebatePercent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional PromotionTarget target = 5;
 * @return {!proto.billing_service.PromotionTarget}
 */ proto.billing_service.PromotionDetails.prototype.getTarget = function() {
    return /** @type {!proto.billing_service.PromotionTarget} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.billing_service.PromotionTarget} value
 * @return {!proto.billing_service.PromotionDetails} returns this
 */ proto.billing_service.PromotionDetails.prototype.setTarget = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional PromotionSource source = 6;
 * @return {!proto.billing_service.PromotionSource}
 */ proto.billing_service.PromotionDetails.prototype.getSource = function() {
    return /** @type {!proto.billing_service.PromotionSource} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.billing_service.PromotionSource} value
 * @return {!proto.billing_service.PromotionDetails} returns this
 */ proto.billing_service.PromotionDetails.prototype.setSource = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional string source_name = 7;
 * @return {string}
 */ proto.billing_service.PromotionDetails.prototype.getSourceName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionDetails} returns this
 */ proto.billing_service.PromotionDetails.prototype.setSourceName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string source_id = 8;
 * @return {string}
 */ proto.billing_service.PromotionDetails.prototype.getSourceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionDetails} returns this
 */ proto.billing_service.PromotionDetails.prototype.setSourceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.RedemptionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.RedemptionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.RedemptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RedemptionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.RedemptionRequest}
 */ proto.billing_service.RedemptionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.RedemptionRequest;
    return proto.billing_service.RedemptionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.RedemptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.RedemptionRequest}
 */ proto.billing_service.RedemptionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.RedemptionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.RedemptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.RedemptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RedemptionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string promo_code = 1;
 * @return {string}
 */ proto.billing_service.RedemptionRequest.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RedemptionRequest} returns this
 */ proto.billing_service.RedemptionRequest.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.RedemptionRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RedemptionRequest} returns this
 */ proto.billing_service.RedemptionRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.RedemptionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.RedemptionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.RedemptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RedemptionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.RedemptionResponse}
 */ proto.billing_service.RedemptionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.RedemptionResponse;
    return proto.billing_service.RedemptionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.RedemptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.RedemptionResponse}
 */ proto.billing_service.RedemptionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.RedemptionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.RedemptionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.RedemptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RedemptionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ReferralCodeRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ReferralCodeRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ReferralCodeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ReferralCodeRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ReferralCodeRequest}
 */ proto.billing_service.ReferralCodeRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ReferralCodeRequest;
    return proto.billing_service.ReferralCodeRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ReferralCodeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ReferralCodeRequest}
 */ proto.billing_service.ReferralCodeRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ReferralCodeRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ReferralCodeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ReferralCodeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ReferralCodeRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetSubscriptionByIdRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetSubscriptionByIdRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetSubscriptionByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetSubscriptionByIdRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetSubscriptionByIdRequest}
 */ proto.billing_service.GetSubscriptionByIdRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetSubscriptionByIdRequest;
    return proto.billing_service.GetSubscriptionByIdRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetSubscriptionByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetSubscriptionByIdRequest}
 */ proto.billing_service.GetSubscriptionByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetSubscriptionByIdRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetSubscriptionByIdRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetSubscriptionByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetSubscriptionByIdRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.GetSubscriptionByIdRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetSubscriptionByIdRequest} returns this
 */ proto.billing_service.GetSubscriptionByIdRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CustomerAccountRow.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CustomerAccountRow.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CustomerAccountRow} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CustomerAccountRow.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            subscriptionActive: $8M67s.Message.getBooleanFieldWithDefault(msg, 5, false),
            openBalance: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            pastDueBalance: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            daysPastDue: $8M67s.Message.getFieldWithDefault(msg, 8, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CustomerAccountRow}
 */ proto.billing_service.CustomerAccountRow.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CustomerAccountRow;
    return proto.billing_service.CustomerAccountRow.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CustomerAccountRow} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CustomerAccountRow}
 */ proto.billing_service.CustomerAccountRow.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSubscriptionActive(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOpenBalance(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPastDueBalance(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readUint32();
                msg.setDaysPastDue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CustomerAccountRow.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CustomerAccountRow.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CustomerAccountRow} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CustomerAccountRow.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getSubscriptionActive();
    if (f) writer.writeBool(5, f);
    f = message.getOpenBalance();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getPastDueBalance();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getDaysPastDue();
    if (f !== 0) writer.writeUint32(8, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.CustomerAccountRow.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CustomerAccountRow} returns this
 */ proto.billing_service.CustomerAccountRow.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account_number = 2;
 * @return {string}
 */ proto.billing_service.CustomerAccountRow.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CustomerAccountRow} returns this
 */ proto.billing_service.CustomerAccountRow.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string first_name = 3;
 * @return {string}
 */ proto.billing_service.CustomerAccountRow.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CustomerAccountRow} returns this
 */ proto.billing_service.CustomerAccountRow.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_name = 4;
 * @return {string}
 */ proto.billing_service.CustomerAccountRow.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CustomerAccountRow} returns this
 */ proto.billing_service.CustomerAccountRow.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional bool subscription_active = 5;
 * @return {boolean}
 */ proto.billing_service.CustomerAccountRow.prototype.getSubscriptionActive = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.CustomerAccountRow} returns this
 */ proto.billing_service.CustomerAccountRow.prototype.setSubscriptionActive = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 5, value);
};
/**
 * optional int32 open_balance = 6;
 * @return {number}
 */ proto.billing_service.CustomerAccountRow.prototype.getOpenBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CustomerAccountRow} returns this
 */ proto.billing_service.CustomerAccountRow.prototype.setOpenBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 past_due_balance = 7;
 * @return {number}
 */ proto.billing_service.CustomerAccountRow.prototype.getPastDueBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CustomerAccountRow} returns this
 */ proto.billing_service.CustomerAccountRow.prototype.setPastDueBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional uint32 days_past_due = 8;
 * @return {number}
 */ proto.billing_service.CustomerAccountRow.prototype.getDaysPastDue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CustomerAccountRow} returns this
 */ proto.billing_service.CustomerAccountRow.prototype.setDaysPastDue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetSubscriptionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetSubscriptionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetSubscriptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetSubscriptionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscription: (f = msg.getSubscription()) && proto.billing_service.Subscription.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetSubscriptionResponse}
 */ proto.billing_service.GetSubscriptionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetSubscriptionResponse;
    return proto.billing_service.GetSubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetSubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetSubscriptionResponse}
 */ proto.billing_service.GetSubscriptionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.Subscription;
                reader.readMessage(value, proto.billing_service.Subscription.deserializeBinaryFromReader);
                msg.setSubscription(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetSubscriptionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetSubscriptionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetSubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetSubscriptionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscription();
    if (f != null) writer.writeMessage(1, f, proto.billing_service.Subscription.serializeBinaryToWriter);
};
/**
 * optional Subscription subscription = 1;
 * @return {?proto.billing_service.Subscription}
 */ proto.billing_service.GetSubscriptionResponse.prototype.getSubscription = function() {
    return /** @type{?proto.billing_service.Subscription} */ $8M67s.Message.getWrapperField(this, proto.billing_service.Subscription, 1);
};
/**
 * @param {?proto.billing_service.Subscription|undefined} value
 * @return {!proto.billing_service.GetSubscriptionResponse} returns this
*/ proto.billing_service.GetSubscriptionResponse.prototype.setSubscription = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.billing_service.GetSubscriptionResponse} returns this
 */ proto.billing_service.GetSubscriptionResponse.prototype.clearSubscription = function() {
    return this.setSubscription(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.billing_service.GetSubscriptionResponse.prototype.hasSubscription = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ReferralCodeResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ReferralCodeResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ReferralCodeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ReferralCodeResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            referralCode: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ReferralCodeResponse}
 */ proto.billing_service.ReferralCodeResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ReferralCodeResponse;
    return proto.billing_service.ReferralCodeResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ReferralCodeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ReferralCodeResponse}
 */ proto.billing_service.ReferralCodeResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReferralCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ReferralCodeResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ReferralCodeResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ReferralCodeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ReferralCodeResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReferralCode();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string referral_code = 1;
 * @return {string}
 */ proto.billing_service.ReferralCodeResponse.prototype.getReferralCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ReferralCodeResponse} returns this
 */ proto.billing_service.ReferralCodeResponse.prototype.setReferralCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.SeedReferralPromotionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.SeedReferralPromotionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.SeedReferralPromotionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SeedReferralPromotionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.SeedReferralPromotionsRequest}
 */ proto.billing_service.SeedReferralPromotionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.SeedReferralPromotionsRequest;
    return proto.billing_service.SeedReferralPromotionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.SeedReferralPromotionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.SeedReferralPromotionsRequest}
 */ proto.billing_service.SeedReferralPromotionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.SeedReferralPromotionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.SeedReferralPromotionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.SeedReferralPromotionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SeedReferralPromotionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.SeedReferralPromotionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.SeedReferralPromotionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.SeedReferralPromotionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SeedReferralPromotionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.SeedReferralPromotionsResponse}
 */ proto.billing_service.SeedReferralPromotionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.SeedReferralPromotionsResponse;
    return proto.billing_service.SeedReferralPromotionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.SeedReferralPromotionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.SeedReferralPromotionsResponse}
 */ proto.billing_service.SeedReferralPromotionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.SeedReferralPromotionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.SeedReferralPromotionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.SeedReferralPromotionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SeedReferralPromotionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportReferralPromotionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportReferralPromotionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportReferralPromotionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportReferralPromotionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportReferralPromotionsRequest}
 */ proto.billing_service.ExportReferralPromotionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportReferralPromotionsRequest;
    return proto.billing_service.ExportReferralPromotionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportReferralPromotionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportReferralPromotionsRequest}
 */ proto.billing_service.ExportReferralPromotionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportReferralPromotionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportReferralPromotionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportReferralPromotionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportReferralPromotionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportedReferralPromotion.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportedReferralPromotion.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportedReferralPromotion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportedReferralPromotion.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            validFrom: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            validUntil: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            status: $8M67s.Message.getBooleanFieldWithDefault(msg, 10, false),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportedReferralPromotion}
 */ proto.billing_service.ExportedReferralPromotion.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportedReferralPromotion;
    return proto.billing_service.ExportedReferralPromotion.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportedReferralPromotion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportedReferralPromotion}
 */ proto.billing_service.ExportedReferralPromotion.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setValidFrom(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt64();
                msg.setValidUntil(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setStatus(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportedReferralPromotion.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportedReferralPromotion.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportedReferralPromotion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportedReferralPromotion.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getValidFrom();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getValidUntil();
    if (f !== 0) writer.writeInt64(9, f);
    f = message.getStatus();
    if (f) writer.writeBool(10, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string first_name = 3;
 * @return {string}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_name = 4;
 * @return {string}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string phone = 5;
 * @return {string}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string email = 6;
 * @return {string}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string promo_code = 7;
 * @return {string}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional int64 valid_from = 8;
 * @return {number}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getValidFrom = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setValidFrom = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int64 valid_until = 9;
 * @return {number}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getValidUntil = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setValidUntil = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional bool status = 10;
 * @return {boolean}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getStatus = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 10, value);
};
/**
 * optional string account_number = 11;
 * @return {string}
 */ proto.billing_service.ExportedReferralPromotion.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ExportedReferralPromotion} returns this
 */ proto.billing_service.ExportedReferralPromotion.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ExportReferralPromotionsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportReferralPromotionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportReferralPromotionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportReferralPromotionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportReferralPromotionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            promosList: $8M67s.Message.toObjectList(msg.getPromosList(), proto.billing_service.ExportedReferralPromotion.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportReferralPromotionsResponse}
 */ proto.billing_service.ExportReferralPromotionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportReferralPromotionsResponse;
    return proto.billing_service.ExportReferralPromotionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportReferralPromotionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportReferralPromotionsResponse}
 */ proto.billing_service.ExportReferralPromotionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.ExportedReferralPromotion;
                reader.readMessage(value, proto.billing_service.ExportedReferralPromotion.deserializeBinaryFromReader);
                msg.addPromos(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportReferralPromotionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportReferralPromotionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportReferralPromotionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportReferralPromotionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPromosList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.ExportedReferralPromotion.serializeBinaryToWriter);
};
/**
 * repeated ExportedReferralPromotion promos = 1;
 * @return {!Array<!proto.billing_service.ExportedReferralPromotion>}
 */ proto.billing_service.ExportReferralPromotionsResponse.prototype.getPromosList = function() {
    return /** @type{!Array<!proto.billing_service.ExportedReferralPromotion>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.ExportedReferralPromotion, 1);
};
/**
 * @param {!Array<!proto.billing_service.ExportedReferralPromotion>} value
 * @return {!proto.billing_service.ExportReferralPromotionsResponse} returns this
*/ proto.billing_service.ExportReferralPromotionsResponse.prototype.setPromosList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.ExportedReferralPromotion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.ExportedReferralPromotion}
 */ proto.billing_service.ExportReferralPromotionsResponse.prototype.addPromos = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.ExportedReferralPromotion, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ExportReferralPromotionsResponse} returns this
 */ proto.billing_service.ExportReferralPromotionsResponse.prototype.clearPromosList = function() {
    return this.setPromosList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.CreatePromotionRequest.repeatedFields_ = [
    10
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreatePromotionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreatePromotionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreatePromotionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreatePromotionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            rebateValue: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            rebatePercent: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            target: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            source: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            sourceId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            validFrom: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            validUntil: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            constraintsList: $8M67s.Message.toObjectList(msg.getConstraintsList(), proto.billing_service.PromotionConstraint.toObject, includeInstance),
            status: $8M67s.Message.getBooleanFieldWithDefault(msg, 11, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreatePromotionRequest}
 */ proto.billing_service.CreatePromotionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreatePromotionRequest;
    return proto.billing_service.CreatePromotionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreatePromotionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreatePromotionRequest}
 */ proto.billing_service.CreatePromotionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setRebateValue(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRebatePercent(value);
                break;
            case 4:
                var value = /** @type {!proto.billing_service.PromotionTarget} */ reader.readEnum();
                msg.setTarget(value);
                break;
            case 5:
                var value = /** @type {!proto.billing_service.PromotionSource} */ reader.readEnum();
                msg.setSource(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceId(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setValidFrom(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt64();
                msg.setValidUntil(value);
                break;
            case 10:
                var value = new proto.billing_service.PromotionConstraint;
                reader.readMessage(value, proto.billing_service.PromotionConstraint.deserializeBinaryFromReader);
                msg.addConstraints(value);
                break;
            case 11:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreatePromotionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreatePromotionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreatePromotionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreatePromotionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getRebateValue();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getRebatePercent();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getTarget();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getSource();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getSourceId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getValidFrom();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getValidUntil();
    if (f !== 0) writer.writeInt64(9, f);
    f = message.getConstraintsList();
    if (f.length > 0) writer.writeRepeatedMessage(10, f, proto.billing_service.PromotionConstraint.serializeBinaryToWriter);
    f = message.getStatus();
    if (f) writer.writeBool(11, f);
};
/**
 * optional string promo_code = 1;
 * @return {string}
 */ proto.billing_service.CreatePromotionRequest.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 rebate_value = 2;
 * @return {number}
 */ proto.billing_service.CreatePromotionRequest.prototype.getRebateValue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setRebateValue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 rebate_percent = 3;
 * @return {number}
 */ proto.billing_service.CreatePromotionRequest.prototype.getRebatePercent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setRebatePercent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional PromotionTarget target = 4;
 * @return {!proto.billing_service.PromotionTarget}
 */ proto.billing_service.CreatePromotionRequest.prototype.getTarget = function() {
    return /** @type {!proto.billing_service.PromotionTarget} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.billing_service.PromotionTarget} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setTarget = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional PromotionSource source = 5;
 * @return {!proto.billing_service.PromotionSource}
 */ proto.billing_service.CreatePromotionRequest.prototype.getSource = function() {
    return /** @type {!proto.billing_service.PromotionSource} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.billing_service.PromotionSource} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setSource = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional string source_id = 6;
 * @return {string}
 */ proto.billing_service.CreatePromotionRequest.prototype.getSourceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setSourceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int64 valid_from = 8;
 * @return {number}
 */ proto.billing_service.CreatePromotionRequest.prototype.getValidFrom = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setValidFrom = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int64 valid_until = 9;
 * @return {number}
 */ proto.billing_service.CreatePromotionRequest.prototype.getValidUntil = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setValidUntil = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * repeated PromotionConstraint constraints = 10;
 * @return {!Array<!proto.billing_service.PromotionConstraint>}
 */ proto.billing_service.CreatePromotionRequest.prototype.getConstraintsList = function() {
    return /** @type{!Array<!proto.billing_service.PromotionConstraint>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.PromotionConstraint, 10);
};
/**
 * @param {!Array<!proto.billing_service.PromotionConstraint>} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
*/ proto.billing_service.CreatePromotionRequest.prototype.setConstraintsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 10, value);
};
/**
 * @param {!proto.billing_service.PromotionConstraint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.PromotionConstraint}
 */ proto.billing_service.CreatePromotionRequest.prototype.addConstraints = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.billing_service.PromotionConstraint, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.clearConstraintsList = function() {
    return this.setConstraintsList([]);
};
/**
 * optional bool status = 11;
 * @return {boolean}
 */ proto.billing_service.CreatePromotionRequest.prototype.getStatus = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 11, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.CreatePromotionRequest} returns this
 */ proto.billing_service.CreatePromotionRequest.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreatePromotionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreatePromotionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreatePromotionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreatePromotionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            promotionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreatePromotionResponse}
 */ proto.billing_service.CreatePromotionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreatePromotionResponse;
    return proto.billing_service.CreatePromotionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreatePromotionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreatePromotionResponse}
 */ proto.billing_service.CreatePromotionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPromotionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreatePromotionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreatePromotionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreatePromotionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreatePromotionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPromotionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string promotion_id = 1;
 * @return {string}
 */ proto.billing_service.CreatePromotionResponse.prototype.getPromotionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreatePromotionResponse} returns this
 */ proto.billing_service.CreatePromotionResponse.prototype.setPromotionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.UpdatePromotionRequest.repeatedFields_ = [
    11
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdatePromotionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdatePromotionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdatePromotionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdatePromotionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            promotionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            rebateValue: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            rebatePercent: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            target: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            source: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            sourceId: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            validFrom: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            validUntil: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            status: $8M67s.Message.getBooleanFieldWithDefault(msg, 10, false),
            constraintsList: $8M67s.Message.toObjectList(msg.getConstraintsList(), proto.billing_service.PromotionConstraint.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdatePromotionRequest}
 */ proto.billing_service.UpdatePromotionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdatePromotionRequest;
    return proto.billing_service.UpdatePromotionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdatePromotionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdatePromotionRequest}
 */ proto.billing_service.UpdatePromotionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPromotionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setRebateValue(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRebatePercent(value);
                break;
            case 5:
                var value = /** @type {!proto.billing_service.PromotionTarget} */ reader.readEnum();
                msg.setTarget(value);
                break;
            case 6:
                var value = /** @type {!proto.billing_service.PromotionSource} */ reader.readEnum();
                msg.setSource(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceId(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setValidFrom(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt64();
                msg.setValidUntil(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setStatus(value);
                break;
            case 11:
                var value = new proto.billing_service.PromotionConstraint;
                reader.readMessage(value, proto.billing_service.PromotionConstraint.deserializeBinaryFromReader);
                msg.addConstraints(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdatePromotionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdatePromotionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdatePromotionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdatePromotionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPromotionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getRebateValue();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getRebatePercent();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getTarget();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getSource();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getSourceId();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getValidFrom();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getValidUntil();
    if (f !== 0) writer.writeInt64(9, f);
    f = message.getStatus();
    if (f) writer.writeBool(10, f);
    f = message.getConstraintsList();
    if (f.length > 0) writer.writeRepeatedMessage(11, f, proto.billing_service.PromotionConstraint.serializeBinaryToWriter);
};
/**
 * optional string promotion_id = 1;
 * @return {string}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getPromotionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setPromotionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string promo_code = 2;
 * @return {string}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 rebate_value = 3;
 * @return {number}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getRebateValue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setRebateValue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 rebate_percent = 4;
 * @return {number}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getRebatePercent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setRebatePercent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional PromotionTarget target = 5;
 * @return {!proto.billing_service.PromotionTarget}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getTarget = function() {
    return /** @type {!proto.billing_service.PromotionTarget} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.billing_service.PromotionTarget} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setTarget = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional PromotionSource source = 6;
 * @return {!proto.billing_service.PromotionSource}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getSource = function() {
    return /** @type {!proto.billing_service.PromotionSource} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.billing_service.PromotionSource} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setSource = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional string source_id = 7;
 * @return {string}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getSourceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setSourceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional int64 valid_from = 8;
 * @return {number}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getValidFrom = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setValidFrom = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int64 valid_until = 9;
 * @return {number}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getValidUntil = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setValidUntil = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional bool status = 10;
 * @return {boolean}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getStatus = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 10, value);
};
/**
 * repeated PromotionConstraint constraints = 11;
 * @return {!Array<!proto.billing_service.PromotionConstraint>}
 */ proto.billing_service.UpdatePromotionRequest.prototype.getConstraintsList = function() {
    return /** @type{!Array<!proto.billing_service.PromotionConstraint>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.PromotionConstraint, 11);
};
/**
 * @param {!Array<!proto.billing_service.PromotionConstraint>} value
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
*/ proto.billing_service.UpdatePromotionRequest.prototype.setConstraintsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 11, value);
};
/**
 * @param {!proto.billing_service.PromotionConstraint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.PromotionConstraint}
 */ proto.billing_service.UpdatePromotionRequest.prototype.addConstraints = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.billing_service.PromotionConstraint, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.UpdatePromotionRequest} returns this
 */ proto.billing_service.UpdatePromotionRequest.prototype.clearConstraintsList = function() {
    return this.setConstraintsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdatePromotionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdatePromotionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdatePromotionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdatePromotionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdatePromotionResponse}
 */ proto.billing_service.UpdatePromotionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdatePromotionResponse;
    return proto.billing_service.UpdatePromotionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdatePromotionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdatePromotionResponse}
 */ proto.billing_service.UpdatePromotionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdatePromotionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdatePromotionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdatePromotionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdatePromotionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListPromotionsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListPromotionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListPromotionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListPromotionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListPromotionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultsList: $8M67s.Message.toObjectList(msg.getResultsList(), proto.billing_service.Promotion.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListPromotionsResponse}
 */ proto.billing_service.ListPromotionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListPromotionsResponse;
    return proto.billing_service.ListPromotionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListPromotionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListPromotionsResponse}
 */ proto.billing_service.ListPromotionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.Promotion;
                reader.readMessage(value, proto.billing_service.Promotion.deserializeBinaryFromReader);
                msg.addResults(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListPromotionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListPromotionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListPromotionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListPromotionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.Promotion.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * repeated Promotion results = 1;
 * @return {!Array<!proto.billing_service.Promotion>}
 */ proto.billing_service.ListPromotionsResponse.prototype.getResultsList = function() {
    return /** @type{!Array<!proto.billing_service.Promotion>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.Promotion, 1);
};
/**
 * @param {!Array<!proto.billing_service.Promotion>} value
 * @return {!proto.billing_service.ListPromotionsResponse} returns this
*/ proto.billing_service.ListPromotionsResponse.prototype.setResultsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.Promotion=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.Promotion}
 */ proto.billing_service.ListPromotionsResponse.prototype.addResults = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.Promotion, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListPromotionsResponse} returns this
 */ proto.billing_service.ListPromotionsResponse.prototype.clearResultsList = function() {
    return this.setResultsList([]);
};
/**
 * optional int64 total = 2;
 * @return {number}
 */ proto.billing_service.ListPromotionsResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ListPromotionsResponse} returns this
 */ proto.billing_service.ListPromotionsResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreatePromotionPartnerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreatePromotionPartnerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreatePromotionPartnerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreatePromotionPartnerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreatePromotionPartnerRequest}
 */ proto.billing_service.CreatePromotionPartnerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreatePromotionPartnerRequest;
    return proto.billing_service.CreatePromotionPartnerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreatePromotionPartnerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreatePromotionPartnerRequest}
 */ proto.billing_service.CreatePromotionPartnerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreatePromotionPartnerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreatePromotionPartnerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreatePromotionPartnerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreatePromotionPartnerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getName();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.billing_service.CreatePromotionPartnerRequest.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreatePromotionPartnerRequest} returns this
 */ proto.billing_service.CreatePromotionPartnerRequest.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.CreatePromotionPartnerResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.CreatePromotionPartnerResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.CreatePromotionPartnerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreatePromotionPartnerResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.CreatePromotionPartnerResponse}
 */ proto.billing_service.CreatePromotionPartnerResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.CreatePromotionPartnerResponse;
    return proto.billing_service.CreatePromotionPartnerResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.CreatePromotionPartnerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.CreatePromotionPartnerResponse}
 */ proto.billing_service.CreatePromotionPartnerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.CreatePromotionPartnerResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.CreatePromotionPartnerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.CreatePromotionPartnerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.CreatePromotionPartnerResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.CreatePromotionPartnerResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.CreatePromotionPartnerResponse} returns this
 */ proto.billing_service.CreatePromotionPartnerResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdatePromotionPartnerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdatePromotionPartnerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdatePromotionPartnerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdatePromotionPartnerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdatePromotionPartnerRequest}
 */ proto.billing_service.UpdatePromotionPartnerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdatePromotionPartnerRequest;
    return proto.billing_service.UpdatePromotionPartnerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdatePromotionPartnerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdatePromotionPartnerRequest}
 */ proto.billing_service.UpdatePromotionPartnerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdatePromotionPartnerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdatePromotionPartnerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdatePromotionPartnerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdatePromotionPartnerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.UpdatePromotionPartnerRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdatePromotionPartnerRequest} returns this
 */ proto.billing_service.UpdatePromotionPartnerRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.billing_service.UpdatePromotionPartnerRequest.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdatePromotionPartnerRequest} returns this
 */ proto.billing_service.UpdatePromotionPartnerRequest.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdatePromotionPartnerResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdatePromotionPartnerResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdatePromotionPartnerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdatePromotionPartnerResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdatePromotionPartnerResponse}
 */ proto.billing_service.UpdatePromotionPartnerResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdatePromotionPartnerResponse;
    return proto.billing_service.UpdatePromotionPartnerResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdatePromotionPartnerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdatePromotionPartnerResponse}
 */ proto.billing_service.UpdatePromotionPartnerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdatePromotionPartnerResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdatePromotionPartnerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdatePromotionPartnerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdatePromotionPartnerResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListPromotionPartnersResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListPromotionPartnersResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListPromotionPartnersResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListPromotionPartnersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListPromotionPartnersResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultsList: $8M67s.Message.toObjectList(msg.getResultsList(), proto.billing_service.PromotionPartner.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListPromotionPartnersResponse}
 */ proto.billing_service.ListPromotionPartnersResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListPromotionPartnersResponse;
    return proto.billing_service.ListPromotionPartnersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListPromotionPartnersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListPromotionPartnersResponse}
 */ proto.billing_service.ListPromotionPartnersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.PromotionPartner;
                reader.readMessage(value, proto.billing_service.PromotionPartner.deserializeBinaryFromReader);
                msg.addResults(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListPromotionPartnersResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListPromotionPartnersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListPromotionPartnersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListPromotionPartnersResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.PromotionPartner.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * repeated PromotionPartner results = 1;
 * @return {!Array<!proto.billing_service.PromotionPartner>}
 */ proto.billing_service.ListPromotionPartnersResponse.prototype.getResultsList = function() {
    return /** @type{!Array<!proto.billing_service.PromotionPartner>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.PromotionPartner, 1);
};
/**
 * @param {!Array<!proto.billing_service.PromotionPartner>} value
 * @return {!proto.billing_service.ListPromotionPartnersResponse} returns this
*/ proto.billing_service.ListPromotionPartnersResponse.prototype.setResultsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.PromotionPartner=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.PromotionPartner}
 */ proto.billing_service.ListPromotionPartnersResponse.prototype.addResults = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.PromotionPartner, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListPromotionPartnersResponse} returns this
 */ proto.billing_service.ListPromotionPartnersResponse.prototype.clearResultsList = function() {
    return this.setResultsList([]);
};
/**
 * optional int64 total = 2;
 * @return {number}
 */ proto.billing_service.ListPromotionPartnersResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ListPromotionPartnersResponse} returns this
 */ proto.billing_service.ListPromotionPartnersResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageWestlakeDataRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageWestlakeDataRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageWestlakeDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageWestlakeDataRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            stageWestlakeExports: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageWestlakeDataRequest}
 */ proto.billing_service.StageWestlakeDataRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageWestlakeDataRequest;
    return proto.billing_service.StageWestlakeDataRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageWestlakeDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageWestlakeDataRequest}
 */ proto.billing_service.StageWestlakeDataRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setStageWestlakeExports(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageWestlakeDataRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageWestlakeDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageWestlakeDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageWestlakeDataRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStageWestlakeExports();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool stage_westlake_exports = 1;
 * @return {boolean}
 */ proto.billing_service.StageWestlakeDataRequest.prototype.getStageWestlakeExports = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.StageWestlakeDataRequest} returns this
 */ proto.billing_service.StageWestlakeDataRequest.prototype.setStageWestlakeExports = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageWestlakeDataResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageWestlakeDataResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageWestlakeDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageWestlakeDataResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageWestlakeDataResponse}
 */ proto.billing_service.StageWestlakeDataResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageWestlakeDataResponse;
    return proto.billing_service.StageWestlakeDataResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageWestlakeDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageWestlakeDataResponse}
 */ proto.billing_service.StageWestlakeDataResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageWestlakeDataResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageWestlakeDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageWestlakeDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageWestlakeDataResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageCustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageCustomerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageCustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageCustomerRequest}
 */ proto.billing_service.StageCustomerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageCustomerRequest;
    return proto.billing_service.StageCustomerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageCustomerRequest}
 */ proto.billing_service.StageCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageCustomerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageCustomerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageCustomerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.StageCustomerRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.StageCustomerRequest} returns this
 */ proto.billing_service.StageCustomerRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageCustomerResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageCustomerResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageCustomerResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageCustomerResponse}
 */ proto.billing_service.StageCustomerResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageCustomerResponse;
    return proto.billing_service.StageCustomerResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageCustomerResponse}
 */ proto.billing_service.StageCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageCustomerResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageCustomerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageCustomerResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageReservationRequest}
 */ proto.billing_service.StageReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageReservationRequest;
    return proto.billing_service.StageReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageReservationRequest}
 */ proto.billing_service.StageReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string reservation_id = 1;
 * @return {string}
 */ proto.billing_service.StageReservationRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.StageReservationRequest} returns this
 */ proto.billing_service.StageReservationRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageReservationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageReservationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageReservationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageReservationResponse}
 */ proto.billing_service.StageReservationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageReservationResponse;
    return proto.billing_service.StageReservationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageReservationResponse}
 */ proto.billing_service.StageReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageReservationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageReservationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageReservationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageAllReservationsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageAllReservationsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageAllReservationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageAllReservationsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageAllReservationsRequest}
 */ proto.billing_service.StageAllReservationsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageAllReservationsRequest;
    return proto.billing_service.StageAllReservationsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageAllReservationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageAllReservationsRequest}
 */ proto.billing_service.StageAllReservationsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageAllReservationsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageAllReservationsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageAllReservationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageAllReservationsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageAllReservationsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageAllReservationsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageAllReservationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageAllReservationsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageAllReservationsResponse}
 */ proto.billing_service.StageAllReservationsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageAllReservationsResponse;
    return proto.billing_service.StageAllReservationsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageAllReservationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageAllReservationsResponse}
 */ proto.billing_service.StageAllReservationsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageAllReservationsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageAllReservationsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageAllReservationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageAllReservationsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageDataRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageDataRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageDataRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageDataRequest}
 */ proto.billing_service.StageDataRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageDataRequest;
    return proto.billing_service.StageDataRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageDataRequest}
 */ proto.billing_service.StageDataRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageDataRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageDataRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.StageDataResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.StageDataResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.StageDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageDataResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.StageDataResponse}
 */ proto.billing_service.StageDataResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.StageDataResponse;
    return proto.billing_service.StageDataResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.StageDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.StageDataResponse}
 */ proto.billing_service.StageDataResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.StageDataResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.StageDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.StageDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.StageDataResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportWestlakePaymentDetailsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportWestlakePaymentDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            sendEmail: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportWestlakePaymentDetailsRequest}
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportWestlakePaymentDetailsRequest;
    return proto.billing_service.ExportWestlakePaymentDetailsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportWestlakePaymentDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportWestlakePaymentDetailsRequest}
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSendEmail(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportWestlakePaymentDetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportWestlakePaymentDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSendEmail();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool send_email = 1;
 * @return {boolean}
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest.prototype.getSendEmail = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ExportWestlakePaymentDetailsRequest} returns this
 */ proto.billing_service.ExportWestlakePaymentDetailsRequest.prototype.setSendEmail = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportWestlakePaymentDetailsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportWestlakePaymentDetailsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportWestlakePaymentDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportWestlakePaymentDetailsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportWestlakePaymentDetailsResponse}
 */ proto.billing_service.ExportWestlakePaymentDetailsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportWestlakePaymentDetailsResponse;
    return proto.billing_service.ExportWestlakePaymentDetailsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportWestlakePaymentDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportWestlakePaymentDetailsResponse}
 */ proto.billing_service.ExportWestlakePaymentDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportWestlakePaymentDetailsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportWestlakePaymentDetailsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportWestlakePaymentDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportWestlakePaymentDetailsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportCustomerPromotionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportCustomerPromotionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportCustomerPromotionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportCustomerPromotionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            sendEmail: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportCustomerPromotionsRequest}
 */ proto.billing_service.ExportCustomerPromotionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportCustomerPromotionsRequest;
    return proto.billing_service.ExportCustomerPromotionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportCustomerPromotionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportCustomerPromotionsRequest}
 */ proto.billing_service.ExportCustomerPromotionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSendEmail(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportCustomerPromotionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportCustomerPromotionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportCustomerPromotionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportCustomerPromotionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSendEmail();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool send_email = 1;
 * @return {boolean}
 */ proto.billing_service.ExportCustomerPromotionsRequest.prototype.getSendEmail = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ExportCustomerPromotionsRequest} returns this
 */ proto.billing_service.ExportCustomerPromotionsRequest.prototype.setSendEmail = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportCustomerPromotionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportCustomerPromotionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportCustomerPromotionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportCustomerPromotionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportCustomerPromotionsResponse}
 */ proto.billing_service.ExportCustomerPromotionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportCustomerPromotionsResponse;
    return proto.billing_service.ExportCustomerPromotionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportCustomerPromotionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportCustomerPromotionsResponse}
 */ proto.billing_service.ExportCustomerPromotionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportCustomerPromotionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportCustomerPromotionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportCustomerPromotionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportCustomerPromotionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportPartnerPromotionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportPartnerPromotionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportPartnerPromotionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportPartnerPromotionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            sendEmail: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportPartnerPromotionsRequest}
 */ proto.billing_service.ExportPartnerPromotionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportPartnerPromotionsRequest;
    return proto.billing_service.ExportPartnerPromotionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportPartnerPromotionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportPartnerPromotionsRequest}
 */ proto.billing_service.ExportPartnerPromotionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSendEmail(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportPartnerPromotionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportPartnerPromotionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportPartnerPromotionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportPartnerPromotionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSendEmail();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool send_email = 1;
 * @return {boolean}
 */ proto.billing_service.ExportPartnerPromotionsRequest.prototype.getSendEmail = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ExportPartnerPromotionsRequest} returns this
 */ proto.billing_service.ExportPartnerPromotionsRequest.prototype.setSendEmail = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportPartnerPromotionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportPartnerPromotionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportPartnerPromotionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportPartnerPromotionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportPartnerPromotionsResponse}
 */ proto.billing_service.ExportPartnerPromotionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportPartnerPromotionsResponse;
    return proto.billing_service.ExportPartnerPromotionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportPartnerPromotionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportPartnerPromotionsResponse}
 */ proto.billing_service.ExportPartnerPromotionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportPartnerPromotionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportPartnerPromotionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportPartnerPromotionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportPartnerPromotionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportPromotionActivitiesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportPromotionActivitiesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportPromotionActivitiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportPromotionActivitiesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            sendEmail: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportPromotionActivitiesRequest}
 */ proto.billing_service.ExportPromotionActivitiesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportPromotionActivitiesRequest;
    return proto.billing_service.ExportPromotionActivitiesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportPromotionActivitiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportPromotionActivitiesRequest}
 */ proto.billing_service.ExportPromotionActivitiesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSendEmail(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportPromotionActivitiesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportPromotionActivitiesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportPromotionActivitiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportPromotionActivitiesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSendEmail();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool send_email = 1;
 * @return {boolean}
 */ proto.billing_service.ExportPromotionActivitiesRequest.prototype.getSendEmail = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ExportPromotionActivitiesRequest} returns this
 */ proto.billing_service.ExportPromotionActivitiesRequest.prototype.setSendEmail = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportPromotionActivitiesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportPromotionActivitiesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportPromotionActivitiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportPromotionActivitiesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportPromotionActivitiesResponse}
 */ proto.billing_service.ExportPromotionActivitiesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportPromotionActivitiesResponse;
    return proto.billing_service.ExportPromotionActivitiesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportPromotionActivitiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportPromotionActivitiesResponse}
 */ proto.billing_service.ExportPromotionActivitiesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportPromotionActivitiesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportPromotionActivitiesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportPromotionActivitiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportPromotionActivitiesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportReferralCustomersRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportReferralCustomersRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportReferralCustomersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportReferralCustomersRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            sendEmail: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportReferralCustomersRequest}
 */ proto.billing_service.ExportReferralCustomersRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportReferralCustomersRequest;
    return proto.billing_service.ExportReferralCustomersRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportReferralCustomersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportReferralCustomersRequest}
 */ proto.billing_service.ExportReferralCustomersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSendEmail(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportReferralCustomersRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportReferralCustomersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportReferralCustomersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportReferralCustomersRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSendEmail();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool send_email = 1;
 * @return {boolean}
 */ proto.billing_service.ExportReferralCustomersRequest.prototype.getSendEmail = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ExportReferralCustomersRequest} returns this
 */ proto.billing_service.ExportReferralCustomersRequest.prototype.setSendEmail = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportReferralCustomersResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportReferralCustomersResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportReferralCustomersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportReferralCustomersResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportReferralCustomersResponse}
 */ proto.billing_service.ExportReferralCustomersResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportReferralCustomersResponse;
    return proto.billing_service.ExportReferralCustomersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportReferralCustomersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportReferralCustomersResponse}
 */ proto.billing_service.ExportReferralCustomersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportReferralCustomersResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportReferralCustomersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportReferralCustomersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportReferralCustomersResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest;
    return proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest} returns this
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse;
    return proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertSubscriptionToInternalBillingScheduleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ImportRecurringMileagePackagesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ImportRecurringMileagePackagesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ImportRecurringMileagePackagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ImportRecurringMileagePackagesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ImportRecurringMileagePackagesRequest}
 */ proto.billing_service.ImportRecurringMileagePackagesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ImportRecurringMileagePackagesRequest;
    return proto.billing_service.ImportRecurringMileagePackagesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ImportRecurringMileagePackagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ImportRecurringMileagePackagesRequest}
 */ proto.billing_service.ImportRecurringMileagePackagesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ImportRecurringMileagePackagesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ImportRecurringMileagePackagesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ImportRecurringMileagePackagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ImportRecurringMileagePackagesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ImportRecurringMileagePackagesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ImportRecurringMileagePackagesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ImportRecurringMileagePackagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ImportRecurringMileagePackagesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ImportRecurringMileagePackagesResponse}
 */ proto.billing_service.ImportRecurringMileagePackagesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ImportRecurringMileagePackagesResponse;
    return proto.billing_service.ImportRecurringMileagePackagesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ImportRecurringMileagePackagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ImportRecurringMileagePackagesResponse}
 */ proto.billing_service.ImportRecurringMileagePackagesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ImportRecurringMileagePackagesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ImportRecurringMileagePackagesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ImportRecurringMileagePackagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ImportRecurringMileagePackagesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DeleteOldDraftOrdersFromBillingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DeleteOldDraftOrdersFromBillingRequest}
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DeleteOldDraftOrdersFromBillingRequest;
    return proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DeleteOldDraftOrdersFromBillingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DeleteOldDraftOrdersFromBillingRequest}
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DeleteOldDraftOrdersFromBillingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DeleteOldDraftOrdersFromBillingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DeleteOldDraftOrdersFromBillingResponse}
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DeleteOldDraftOrdersFromBillingResponse;
    return proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DeleteOldDraftOrdersFromBillingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DeleteOldDraftOrdersFromBillingResponse}
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DeleteOldDraftOrdersFromBillingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeleteOldDraftOrdersFromBillingResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportToWestlakeRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportToWestlakeRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportToWestlakeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportToWestlakeRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            sftpToWestlake: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            sendEmail: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportToWestlakeRequest}
 */ proto.billing_service.ExportToWestlakeRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportToWestlakeRequest;
    return proto.billing_service.ExportToWestlakeRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportToWestlakeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportToWestlakeRequest}
 */ proto.billing_service.ExportToWestlakeRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSftpToWestlake(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSendEmail(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportToWestlakeRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportToWestlakeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportToWestlakeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportToWestlakeRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSftpToWestlake();
    if (f) writer.writeBool(1, f);
    f = message.getSendEmail();
    if (f) writer.writeBool(2, f);
};
/**
 * optional bool sftp_to_westlake = 1;
 * @return {boolean}
 */ proto.billing_service.ExportToWestlakeRequest.prototype.getSftpToWestlake = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ExportToWestlakeRequest} returns this
 */ proto.billing_service.ExportToWestlakeRequest.prototype.setSftpToWestlake = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional bool send_email = 2;
 * @return {boolean}
 */ proto.billing_service.ExportToWestlakeRequest.prototype.getSendEmail = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ExportToWestlakeRequest} returns this
 */ proto.billing_service.ExportToWestlakeRequest.prototype.setSendEmail = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ExportToWestlakeResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ExportToWestlakeResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ExportToWestlakeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportToWestlakeResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ExportToWestlakeResponse}
 */ proto.billing_service.ExportToWestlakeResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ExportToWestlakeResponse;
    return proto.billing_service.ExportToWestlakeResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ExportToWestlakeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ExportToWestlakeResponse}
 */ proto.billing_service.ExportToWestlakeResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ExportToWestlakeResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ExportToWestlakeResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ExportToWestlakeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ExportToWestlakeResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.WestlakeStagingStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.WestlakeStagingStatusRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.WestlakeStagingStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.WestlakeStagingStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.WestlakeStagingStatusRequest}
 */ proto.billing_service.WestlakeStagingStatusRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.WestlakeStagingStatusRequest;
    return proto.billing_service.WestlakeStagingStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.WestlakeStagingStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.WestlakeStagingStatusRequest}
 */ proto.billing_service.WestlakeStagingStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.WestlakeStagingStatusRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.WestlakeStagingStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.WestlakeStagingStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.WestlakeStagingStatusRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.WestlakeStagingStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.WestlakeStagingStatusResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.WestlakeStagingStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.WestlakeStagingStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            stagingWestlakeExports: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.WestlakeStagingStatusResponse}
 */ proto.billing_service.WestlakeStagingStatusResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.WestlakeStagingStatusResponse;
    return proto.billing_service.WestlakeStagingStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.WestlakeStagingStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.WestlakeStagingStatusResponse}
 */ proto.billing_service.WestlakeStagingStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setStagingWestlakeExports(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.WestlakeStagingStatusResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.WestlakeStagingStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.WestlakeStagingStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.WestlakeStagingStatusResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStagingWestlakeExports();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool staging_westlake_exports = 1;
 * @return {boolean}
 */ proto.billing_service.WestlakeStagingStatusResponse.prototype.getStagingWestlakeExports = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.WestlakeStagingStatusResponse} returns this
 */ proto.billing_service.WestlakeStagingStatusResponse.prototype.setStagingWestlakeExports = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DraftOrderUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DraftOrderUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DraftOrderUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DraftOrderUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            orderId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            orderSum: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DraftOrderUpdated}
 */ proto.billing_service.DraftOrderUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DraftOrderUpdated;
    return proto.billing_service.DraftOrderUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DraftOrderUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DraftOrderUpdated}
 */ proto.billing_service.DraftOrderUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setOrderSum(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DraftOrderUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DraftOrderUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DraftOrderUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DraftOrderUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getOrderId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getOrderSum();
    if (f !== 0) writer.writeInt64(4, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.DraftOrderUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.DraftOrderUpdated} returns this
 */ proto.billing_service.DraftOrderUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.DraftOrderUpdated.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.DraftOrderUpdated} returns this
 */ proto.billing_service.DraftOrderUpdated.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string order_id = 3;
 * @return {string}
 */ proto.billing_service.DraftOrderUpdated.prototype.getOrderId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.DraftOrderUpdated} returns this
 */ proto.billing_service.DraftOrderUpdated.prototype.setOrderId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 order_sum = 4;
 * @return {number}
 */ proto.billing_service.DraftOrderUpdated.prototype.getOrderSum = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.DraftOrderUpdated} returns this
 */ proto.billing_service.DraftOrderUpdated.prototype.setOrderSum = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.Promotion.repeatedFields_ = [
    11
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.Promotion.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.Promotion.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.Promotion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Promotion.toObject = function(includeInstance, msg) {
        var f, obj = {
            promotionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            version: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            rebateValue: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            rebatePercent: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            target: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            source: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            sourceId: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            sourceName: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            validFrom: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            validUntil: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            status: $8M67s.Message.getBooleanFieldWithDefault(msg, 10, false),
            constraintsList: $8M67s.Message.toObjectList(msg.getConstraintsList(), proto.billing_service.PromotionConstraint.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.Promotion}
 */ proto.billing_service.Promotion.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.Promotion;
    return proto.billing_service.Promotion.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.Promotion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.Promotion}
 */ proto.billing_service.Promotion.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPromotionId(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setRebateValue(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRebatePercent(value);
                break;
            case 5:
                var value = /** @type {!proto.billing_service.PromotionTarget} */ reader.readEnum();
                msg.setTarget(value);
                break;
            case 6:
                var value = /** @type {!proto.billing_service.PromotionSource} */ reader.readEnum();
                msg.setSource(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceId(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceName(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setValidFrom(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt64();
                msg.setValidUntil(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setStatus(value);
                break;
            case 11:
                var value = new proto.billing_service.PromotionConstraint;
                reader.readMessage(value, proto.billing_service.PromotionConstraint.deserializeBinaryFromReader);
                msg.addConstraints(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.Promotion.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.Promotion.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.Promotion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Promotion.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPromotionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(12, f);
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getRebateValue();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getRebatePercent();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getTarget();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getSource();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getSourceId();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getSourceName();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getValidFrom();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getValidUntil();
    if (f !== 0) writer.writeInt64(9, f);
    f = message.getStatus();
    if (f) writer.writeBool(10, f);
    f = message.getConstraintsList();
    if (f.length > 0) writer.writeRepeatedMessage(11, f, proto.billing_service.PromotionConstraint.serializeBinaryToWriter);
};
/**
 * optional string promotion_id = 1;
 * @return {string}
 */ proto.billing_service.Promotion.prototype.getPromotionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setPromotionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 version = 12;
 * @return {number}
 */ proto.billing_service.Promotion.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional string promo_code = 2;
 * @return {string}
 */ proto.billing_service.Promotion.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 rebate_value = 3;
 * @return {number}
 */ proto.billing_service.Promotion.prototype.getRebateValue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setRebateValue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 rebate_percent = 4;
 * @return {number}
 */ proto.billing_service.Promotion.prototype.getRebatePercent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setRebatePercent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional PromotionTarget target = 5;
 * @return {!proto.billing_service.PromotionTarget}
 */ proto.billing_service.Promotion.prototype.getTarget = function() {
    return /** @type {!proto.billing_service.PromotionTarget} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.billing_service.PromotionTarget} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setTarget = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional PromotionSource source = 6;
 * @return {!proto.billing_service.PromotionSource}
 */ proto.billing_service.Promotion.prototype.getSource = function() {
    return /** @type {!proto.billing_service.PromotionSource} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.billing_service.PromotionSource} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setSource = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional string source_id = 7;
 * @return {string}
 */ proto.billing_service.Promotion.prototype.getSourceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setSourceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string source_name = 13;
 * @return {string}
 */ proto.billing_service.Promotion.prototype.getSourceName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setSourceName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional int64 valid_from = 8;
 * @return {number}
 */ proto.billing_service.Promotion.prototype.getValidFrom = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setValidFrom = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int64 valid_until = 9;
 * @return {number}
 */ proto.billing_service.Promotion.prototype.getValidUntil = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setValidUntil = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional bool status = 10;
 * @return {boolean}
 */ proto.billing_service.Promotion.prototype.getStatus = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 10, value);
};
/**
 * repeated PromotionConstraint constraints = 11;
 * @return {!Array<!proto.billing_service.PromotionConstraint>}
 */ proto.billing_service.Promotion.prototype.getConstraintsList = function() {
    return /** @type{!Array<!proto.billing_service.PromotionConstraint>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.PromotionConstraint, 11);
};
/**
 * @param {!Array<!proto.billing_service.PromotionConstraint>} value
 * @return {!proto.billing_service.Promotion} returns this
*/ proto.billing_service.Promotion.prototype.setConstraintsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 11, value);
};
/**
 * @param {!proto.billing_service.PromotionConstraint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.PromotionConstraint}
 */ proto.billing_service.Promotion.prototype.addConstraints = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.billing_service.PromotionConstraint, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.Promotion} returns this
 */ proto.billing_service.Promotion.prototype.clearConstraintsList = function() {
    return this.setConstraintsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PromotionPartner.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PromotionPartner.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PromotionPartner} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PromotionPartner.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            version: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PromotionPartner}
 */ proto.billing_service.PromotionPartner.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PromotionPartner;
    return proto.billing_service.PromotionPartner.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PromotionPartner} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PromotionPartner}
 */ proto.billing_service.PromotionPartner.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PromotionPartner.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PromotionPartner.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PromotionPartner} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PromotionPartner.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.PromotionPartner.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionPartner} returns this
 */ proto.billing_service.PromotionPartner.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 version = 3;
 * @return {number}
 */ proto.billing_service.PromotionPartner.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PromotionPartner} returns this
 */ proto.billing_service.PromotionPartner.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.billing_service.PromotionPartner.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionPartner} returns this
 */ proto.billing_service.PromotionPartner.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.PromotionActivity.repeatedFields_ = [
    11,
    12
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PromotionActivity.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PromotionActivity.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PromotionActivity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PromotionActivity.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            type: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            promotionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            target: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            source: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            sourceId: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            statementId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            lineItemIdsList: (f = $8M67s.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
            transactionIdsList: (f = $8M67s.Message.getRepeatedField(msg, 12)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PromotionActivity}
 */ proto.billing_service.PromotionActivity.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PromotionActivity;
    return proto.billing_service.PromotionActivity.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PromotionActivity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PromotionActivity}
 */ proto.billing_service.PromotionActivity.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.billing_service.ActivityType} */ reader.readEnum();
                msg.setType(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPromotionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 6:
                var value = /** @type {!proto.billing_service.PromotionTarget} */ reader.readEnum();
                msg.setTarget(value);
                break;
            case 7:
                var value = /** @type {!proto.billing_service.PromotionSource} */ reader.readEnum();
                msg.setSource(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setSourceId(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setStatementId(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.addLineItemIds(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.addTransactionIds(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PromotionActivity.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PromotionActivity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PromotionActivity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PromotionActivity.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getType();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getPromotionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getTarget();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getSource();
    if (f !== 0.0) writer.writeEnum(7, f);
    f = message.getSourceId();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getStatementId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getLineItemIdsList();
    if (f.length > 0) writer.writeRepeatedString(11, f);
    f = message.getTransactionIdsList();
    if (f.length > 0) writer.writeRepeatedString(12, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.PromotionActivity.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional ActivityType type = 2;
 * @return {!proto.billing_service.ActivityType}
 */ proto.billing_service.PromotionActivity.prototype.getType = function() {
    return /** @type {!proto.billing_service.ActivityType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.billing_service.ActivityType} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string promotion_id = 3;
 * @return {string}
 */ proto.billing_service.PromotionActivity.prototype.getPromotionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setPromotionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string promo_code = 4;
 * @return {string}
 */ proto.billing_service.PromotionActivity.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string customer_id = 5;
 * @return {string}
 */ proto.billing_service.PromotionActivity.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional PromotionTarget target = 6;
 * @return {!proto.billing_service.PromotionTarget}
 */ proto.billing_service.PromotionActivity.prototype.getTarget = function() {
    return /** @type {!proto.billing_service.PromotionTarget} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.billing_service.PromotionTarget} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setTarget = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional PromotionSource source = 7;
 * @return {!proto.billing_service.PromotionSource}
 */ proto.billing_service.PromotionActivity.prototype.getSource = function() {
    return /** @type {!proto.billing_service.PromotionSource} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.billing_service.PromotionSource} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setSource = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional string source_id = 8;
 * @return {string}
 */ proto.billing_service.PromotionActivity.prototype.getSourceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setSourceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string subscription_id = 9;
 * @return {string}
 */ proto.billing_service.PromotionActivity.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string statement_id = 10;
 * @return {string}
 */ proto.billing_service.PromotionActivity.prototype.getStatementId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setStatementId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * repeated string line_item_ids = 11;
 * @return {!Array<string>}
 */ proto.billing_service.PromotionActivity.prototype.getLineItemIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 11);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setLineItemIdsList = function(value) {
    return $8M67s.Message.setField(this, 11, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.addLineItemIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 11, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.clearLineItemIdsList = function() {
    return this.setLineItemIdsList([]);
};
/**
 * repeated string transaction_ids = 12;
 * @return {!Array<string>}
 */ proto.billing_service.PromotionActivity.prototype.getTransactionIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 12);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.setTransactionIdsList = function(value) {
    return $8M67s.Message.setField(this, 12, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.addTransactionIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 12, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.PromotionActivity} returns this
 */ proto.billing_service.PromotionActivity.prototype.clearTransactionIdsList = function() {
    return this.setTransactionIdsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.Reservation.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.Reservation.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.Reservation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Reservation.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            updated: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            color: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            secondaryColor: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 15, ""),
            reservationNumber: $8M67s.Message.getFieldWithDefault(msg, 16, ""),
            postal: $8M67s.Message.getFieldWithDefault(msg, 17, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 18, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 19, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 20, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 21, ""),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 22, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 23, 0),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 24, 0),
            monthlyRent: $8M67s.Message.getFieldWithDefault(msg, 25, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.Reservation}
 */ proto.billing_service.Reservation.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.Reservation;
    return proto.billing_service.Reservation.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.Reservation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.Reservation}
 */ proto.billing_service.Reservation.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt64();
                msg.setUpdated(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setStatus(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setSecondaryColor(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 16:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationNumber(value);
                break;
            case 17:
                var value = /** @type {string} */ reader.readString();
                msg.setPostal(value);
                break;
            case 18:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 19:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 20:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 21:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 22:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReservationFee(value);
                break;
            case 23:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 24:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 25:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRent(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.Reservation.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.Reservation.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.Reservation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Reservation.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getUpdated();
    if (f !== 0) writer.writeInt64(9, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getStatus();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getColor();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getSecondaryColor();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(15, f);
    f = message.getReservationNumber();
    if (f.length > 0) writer.writeString(16, f);
    f = message.getPostal();
    if (f.length > 0) writer.writeString(17, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(18, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(19, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(20, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(21, f);
    f = message.getReservationFee();
    if (f !== 0) writer.writeInt32(22, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(23, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(24, f);
    f = message.getMonthlyRent();
    if (f !== 0) writer.writeInt32(25, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string program_id = 4;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 created = 8;
 * @return {number}
 */ proto.billing_service.Reservation.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int64 updated = 9;
 * @return {number}
 */ proto.billing_service.Reservation.prototype.getUpdated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setUpdated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional string vehicle_id = 10;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string status = 11;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getStatus = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string color = 12;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string secondary_color = 13;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getSecondaryColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setSecondaryColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string make = 14;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional string model = 15;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
/**
 * optional string reservation_number = 16;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getReservationNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 16, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setReservationNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 16, value);
};
/**
 * optional string postal = 17;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getPostal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 17, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setPostal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 17, value);
};
/**
 * optional string first_name = 18;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 18, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 18, value);
};
/**
 * optional string last_name = 19;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 19, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 19, value);
};
/**
 * optional string email = 20;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 20, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 20, value);
};
/**
 * optional string phone = 21;
 * @return {string}
 */ proto.billing_service.Reservation.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 21, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 21, value);
};
/**
 * optional int32 reservation_fee = 22;
 * @return {number}
 */ proto.billing_service.Reservation.prototype.getReservationFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 22, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 22, value);
};
/**
 * optional int32 deposit = 23;
 * @return {number}
 */ proto.billing_service.Reservation.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 23, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 23, value);
};
/**
 * optional int32 start_fee = 24;
 * @return {number}
 */ proto.billing_service.Reservation.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 24, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 24, value);
};
/**
 * optional int32 monthly_rent = 25;
 * @return {number}
 */ proto.billing_service.Reservation.prototype.getMonthlyRent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 25, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Reservation} returns this
 */ proto.billing_service.Reservation.prototype.setMonthlyRent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 25, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.LineItemFE.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.LineItemFE.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.LineItemFE} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.LineItemFE.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            productId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            balance: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            taxAmount: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            quantity: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            title: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            baseAmount: $8M67s.Message.getFieldWithDefault(msg, 12, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.LineItemFE}
 */ proto.billing_service.LineItemFE.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.LineItemFE;
    return proto.billing_service.LineItemFE.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.LineItemFE} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.LineItemFE}
 */ proto.billing_service.LineItemFE.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setProductId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBalance(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTaxAmount(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setQuantity(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setTitle(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBaseAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.LineItemFE.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.LineItemFE.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.LineItemFE} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.LineItemFE.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getProductId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getBalance();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getTaxAmount();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getQuantity();
    if (f !== 0) writer.writeInt32(10, f);
    f = message.getTitle();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getBaseAmount();
    if (f !== 0) writer.writeInt32(12, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.LineItemFE.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string product_id = 5;
 * @return {string}
 */ proto.billing_service.LineItemFE.prototype.getProductId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setProductId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string description = 6;
 * @return {string}
 */ proto.billing_service.LineItemFE.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int32 amount = 7;
 * @return {number}
 */ proto.billing_service.LineItemFE.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 balance = 8;
 * @return {number}
 */ proto.billing_service.LineItemFE.prototype.getBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 tax_amount = 9;
 * @return {number}
 */ proto.billing_service.LineItemFE.prototype.getTaxAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setTaxAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 quantity = 10;
 * @return {number}
 */ proto.billing_service.LineItemFE.prototype.getQuantity = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setQuantity = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional string title = 11;
 * @return {string}
 */ proto.billing_service.LineItemFE.prototype.getTitle = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setTitle = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional int32 base_amount = 12;
 * @return {number}
 */ proto.billing_service.LineItemFE.prototype.getBaseAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.LineItemFE} returns this
 */ proto.billing_service.LineItemFE.prototype.setBaseAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.InvoiceFE.repeatedFields_ = [
    7
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.InvoiceFE.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.InvoiceFE.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.InvoiceFE} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.InvoiceFE.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            documentNumber: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            dueDate: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), proto.billing_service.LineItemFE.toObject, includeInstance),
            amount: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            taxAmount: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            balance: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            status: $8M67s.Message.getFieldWithDefault(msg, 11, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.InvoiceFE}
 */ proto.billing_service.InvoiceFE.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.InvoiceFE;
    return proto.billing_service.InvoiceFE.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.InvoiceFE} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.InvoiceFE}
 */ proto.billing_service.InvoiceFE.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentNumber(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDueDate(value);
                break;
            case 7:
                var value = new proto.billing_service.LineItemFE;
                reader.readMessage(value, proto.billing_service.LineItemFE.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTaxAmount(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBalance(value);
                break;
            case 11:
                var value = /** @type {!proto.billing_service.InvoiceStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.InvoiceFE.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.InvoiceFE.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.InvoiceFE} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.InvoiceFE.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDocumentNumber();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getDueDate();
    if (f !== 0) writer.writeInt64(6, f);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, proto.billing_service.LineItemFE.serializeBinaryToWriter);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getTaxAmount();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getBalance();
    if (f !== 0) writer.writeInt32(10, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(11, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.InvoiceFE.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.billing_service.InvoiceFE.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string document_number = 4;
 * @return {string}
 */ proto.billing_service.InvoiceFE.prototype.getDocumentNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setDocumentNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 date = 5;
 * @return {number}
 */ proto.billing_service.InvoiceFE.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int64 due_date = 6;
 * @return {number}
 */ proto.billing_service.InvoiceFE.prototype.getDueDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setDueDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * repeated LineItemFE line_items = 7;
 * @return {!Array<!proto.billing_service.LineItemFE>}
 */ proto.billing_service.InvoiceFE.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.billing_service.LineItemFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.LineItemFE, 7);
};
/**
 * @param {!Array<!proto.billing_service.LineItemFE>} value
 * @return {!proto.billing_service.InvoiceFE} returns this
*/ proto.billing_service.InvoiceFE.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.billing_service.LineItemFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.LineItemFE}
 */ proto.billing_service.InvoiceFE.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.billing_service.LineItemFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
/**
 * optional int32 amount = 8;
 * @return {number}
 */ proto.billing_service.InvoiceFE.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 tax_amount = 9;
 * @return {number}
 */ proto.billing_service.InvoiceFE.prototype.getTaxAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setTaxAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 balance = 10;
 * @return {number}
 */ proto.billing_service.InvoiceFE.prototype.getBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional InvoiceStatus status = 11;
 * @return {!proto.billing_service.InvoiceStatus}
 */ proto.billing_service.InvoiceFE.prototype.getStatus = function() {
    return /** @type {!proto.billing_service.InvoiceStatus} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {!proto.billing_service.InvoiceStatus} value
 * @return {!proto.billing_service.InvoiceFE} returns this
 */ proto.billing_service.InvoiceFE.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.LineItem.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.LineItem.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.LineItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.LineItem.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            orderId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            invoiceId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            type: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            productId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            balance: $8M67s.Message.getFieldWithDefault(msg, 8, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.LineItem}
 */ proto.billing_service.LineItem.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.LineItem;
    return proto.billing_service.LineItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.LineItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.LineItem}
 */ proto.billing_service.LineItem.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceId(value);
                break;
            case 4:
                var value = /** @type {!proto.billing_service.LineItemType} */ reader.readEnum();
                msg.setType(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setProductId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBalance(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.LineItem.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.LineItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.LineItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.LineItem.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOrderId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getInvoiceId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getType();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getProductId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getBalance();
    if (f !== 0) writer.writeInt32(8, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.LineItem.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItem} returns this
 */ proto.billing_service.LineItem.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string order_id = 2;
 * @return {string}
 */ proto.billing_service.LineItem.prototype.getOrderId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItem} returns this
 */ proto.billing_service.LineItem.prototype.setOrderId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string invoice_id = 3;
 * @return {string}
 */ proto.billing_service.LineItem.prototype.getInvoiceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItem} returns this
 */ proto.billing_service.LineItem.prototype.setInvoiceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional LineItemType type = 4;
 * @return {!proto.billing_service.LineItemType}
 */ proto.billing_service.LineItem.prototype.getType = function() {
    return /** @type {!proto.billing_service.LineItemType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.billing_service.LineItemType} value
 * @return {!proto.billing_service.LineItem} returns this
 */ proto.billing_service.LineItem.prototype.setType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional string product_id = 5;
 * @return {string}
 */ proto.billing_service.LineItem.prototype.getProductId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItem} returns this
 */ proto.billing_service.LineItem.prototype.setProductId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string description = 6;
 * @return {string}
 */ proto.billing_service.LineItem.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.LineItem} returns this
 */ proto.billing_service.LineItem.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int32 amount = 7;
 * @return {number}
 */ proto.billing_service.LineItem.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.LineItem} returns this
 */ proto.billing_service.LineItem.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 balance = 8;
 * @return {number}
 */ proto.billing_service.LineItem.prototype.getBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.LineItem} returns this
 */ proto.billing_service.LineItem.prototype.setBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.Invoice.repeatedFields_ = [
    8
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.Invoice.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.Invoice.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.Invoice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Invoice.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            documentNumber: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            timeStamp: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            date: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            dueDate: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), proto.billing_service.LineItem.toObject, includeInstance),
            amount: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            balance: $8M67s.Message.getFieldWithDefault(msg, 10, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.Invoice}
 */ proto.billing_service.Invoice.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.Invoice;
    return proto.billing_service.Invoice.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.Invoice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.Invoice}
 */ proto.billing_service.Invoice.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentNumber(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimeStamp(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDueDate(value);
                break;
            case 8:
                var value = new proto.billing_service.LineItem;
                reader.readMessage(value, proto.billing_service.LineItem.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBalance(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.Invoice.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.Invoice.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.Invoice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Invoice.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDocumentNumber();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getTimeStamp();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(6, f);
    f = message.getDueDate();
    if (f !== 0) writer.writeInt64(7, f);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(8, f, proto.billing_service.LineItem.serializeBinaryToWriter);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getBalance();
    if (f !== 0) writer.writeInt32(10, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.Invoice.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.billing_service.Invoice.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.billing_service.Invoice.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string document_number = 4;
 * @return {string}
 */ proto.billing_service.Invoice.prototype.getDocumentNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setDocumentNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 time_stamp = 5;
 * @return {number}
 */ proto.billing_service.Invoice.prototype.getTimeStamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setTimeStamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int64 date = 6;
 * @return {number}
 */ proto.billing_service.Invoice.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int64 due_date = 7;
 * @return {number}
 */ proto.billing_service.Invoice.prototype.getDueDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setDueDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * repeated LineItem line_items = 8;
 * @return {!Array<!proto.billing_service.LineItem>}
 */ proto.billing_service.Invoice.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.billing_service.LineItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.LineItem, 8);
};
/**
 * @param {!Array<!proto.billing_service.LineItem>} value
 * @return {!proto.billing_service.Invoice} returns this
*/ proto.billing_service.Invoice.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.billing_service.LineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.LineItem}
 */ proto.billing_service.Invoice.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.billing_service.LineItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
/**
 * optional int32 amount = 9;
 * @return {number}
 */ proto.billing_service.Invoice.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 balance = 10;
 * @return {number}
 */ proto.billing_service.Invoice.prototype.getBalance = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Invoice} returns this
 */ proto.billing_service.Invoice.prototype.setBalance = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.MileageRecurringBillableItem.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.MileageRecurringBillableItem.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.MileageRecurringBillableItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.MileageRecurringBillableItem.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            productType: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            amount: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            miles: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            rate: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.MileageRecurringBillableItem}
 */ proto.billing_service.MileageRecurringBillableItem.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.MileageRecurringBillableItem;
    return proto.billing_service.MileageRecurringBillableItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.MileageRecurringBillableItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.MileageRecurringBillableItem}
 */ proto.billing_service.MileageRecurringBillableItem.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.Product.ProductType} */ reader.readEnum();
                msg.setProductType(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMiles(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.MileageRecurringBillableItem.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.MileageRecurringBillableItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.MileageRecurringBillableItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.MileageRecurringBillableItem.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getProductType();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMiles();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getRate();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional int32 id = 1;
 * @return {number}
 */ proto.billing_service.MileageRecurringBillableItem.prototype.getId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.MileageRecurringBillableItem} returns this
 */ proto.billing_service.MileageRecurringBillableItem.prototype.setId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional domain.Product.ProductType product_type = 2;
 * @return {!proto.domain.Product.ProductType}
 */ proto.billing_service.MileageRecurringBillableItem.prototype.getProductType = function() {
    return /** @type {!proto.domain.Product.ProductType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.Product.ProductType} value
 * @return {!proto.billing_service.MileageRecurringBillableItem} returns this
 */ proto.billing_service.MileageRecurringBillableItem.prototype.setProductType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional int32 amount = 3;
 * @return {number}
 */ proto.billing_service.MileageRecurringBillableItem.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.MileageRecurringBillableItem} returns this
 */ proto.billing_service.MileageRecurringBillableItem.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 miles = 4;
 * @return {number}
 */ proto.billing_service.MileageRecurringBillableItem.prototype.getMiles = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.MileageRecurringBillableItem} returns this
 */ proto.billing_service.MileageRecurringBillableItem.prototype.setMiles = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 rate = 5;
 * @return {number}
 */ proto.billing_service.MileageRecurringBillableItem.prototype.getRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.MileageRecurringBillableItem} returns this
 */ proto.billing_service.MileageRecurringBillableItem.prototype.setRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetMileageRecurringBillableItemRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetMileageRecurringBillableItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetMileageRecurringBillableItemRequest}
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetMileageRecurringBillableItemRequest;
    return proto.billing_service.GetMileageRecurringBillableItemRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetMileageRecurringBillableItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetMileageRecurringBillableItemRequest}
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetMileageRecurringBillableItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetMileageRecurringBillableItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.GetMileageRecurringBillableItemRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetOwnMileageRecurringBillableItemRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest}
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetOwnMileageRecurringBillableItemRequest;
    return proto.billing_service.GetOwnMileageRecurringBillableItemRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest}
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetOwnMileageRecurringBillableItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.GetOwnMileageRecurringBillableItemRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetMileageRecurringBillableItemResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetMileageRecurringBillableItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            mileageRecurringBillableItem: (f = msg.getMileageRecurringBillableItem()) && proto.billing_service.MileageRecurringBillableItem.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetMileageRecurringBillableItemResponse}
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetMileageRecurringBillableItemResponse;
    return proto.billing_service.GetMileageRecurringBillableItemResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetMileageRecurringBillableItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetMileageRecurringBillableItemResponse}
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.MileageRecurringBillableItem;
                reader.readMessage(value, proto.billing_service.MileageRecurringBillableItem.deserializeBinaryFromReader);
                msg.setMileageRecurringBillableItem(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetMileageRecurringBillableItemResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetMileageRecurringBillableItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMileageRecurringBillableItem();
    if (f != null) writer.writeMessage(1, f, proto.billing_service.MileageRecurringBillableItem.serializeBinaryToWriter);
};
/**
 * optional MileageRecurringBillableItem mileage_recurring_billable_item = 1;
 * @return {?proto.billing_service.MileageRecurringBillableItem}
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.prototype.getMileageRecurringBillableItem = function() {
    return /** @type{?proto.billing_service.MileageRecurringBillableItem} */ $8M67s.Message.getWrapperField(this, proto.billing_service.MileageRecurringBillableItem, 1);
};
/**
 * @param {?proto.billing_service.MileageRecurringBillableItem|undefined} value
 * @return {!proto.billing_service.GetMileageRecurringBillableItemResponse} returns this
*/ proto.billing_service.GetMileageRecurringBillableItemResponse.prototype.setMileageRecurringBillableItem = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.billing_service.GetMileageRecurringBillableItemResponse} returns this
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.prototype.clearMileageRecurringBillableItem = function() {
    return this.setMileageRecurringBillableItem(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.billing_service.GetMileageRecurringBillableItemResponse.prototype.hasMileageRecurringBillableItem = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdateMileageRecurringBillableItemRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            mileageRecurringBillableItem: (f = msg.getMileageRecurringBillableItem()) && proto.billing_service.MileageRecurringBillableItem.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdateMileageRecurringBillableItemRequest}
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdateMileageRecurringBillableItemRequest;
    return proto.billing_service.UpdateMileageRecurringBillableItemRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdateMileageRecurringBillableItemRequest}
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new proto.billing_service.MileageRecurringBillableItem;
                reader.readMessage(value, proto.billing_service.MileageRecurringBillableItem.deserializeBinaryFromReader);
                msg.setMileageRecurringBillableItem(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdateMileageRecurringBillableItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMileageRecurringBillableItem();
    if (f != null) writer.writeMessage(3, f, proto.billing_service.MileageRecurringBillableItem.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional MileageRecurringBillableItem mileage_recurring_billable_item = 3;
 * @return {?proto.billing_service.MileageRecurringBillableItem}
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.getMileageRecurringBillableItem = function() {
    return /** @type{?proto.billing_service.MileageRecurringBillableItem} */ $8M67s.Message.getWrapperField(this, proto.billing_service.MileageRecurringBillableItem, 3);
};
/**
 * @param {?proto.billing_service.MileageRecurringBillableItem|undefined} value
 * @return {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} returns this
*/ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.setMileageRecurringBillableItem = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.clearMileageRecurringBillableItem = function() {
    return this.setMileageRecurringBillableItem(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.billing_service.UpdateMileageRecurringBillableItemRequest.prototype.hasMileageRecurringBillableItem = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.RemoveMileageRecurringBillableItemRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            mileageRecurringBillableItemId: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.RemoveMileageRecurringBillableItemRequest}
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.RemoveMileageRecurringBillableItemRequest;
    return proto.billing_service.RemoveMileageRecurringBillableItemRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.RemoveMileageRecurringBillableItemRequest}
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMileageRecurringBillableItemId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.RemoveMileageRecurringBillableItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMileageRecurringBillableItemId();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 mileage_recurring_billable_item_id = 3;
 * @return {number}
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.prototype.getMileageRecurringBillableItemId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.RemoveMileageRecurringBillableItemRequest.prototype.setMileageRecurringBillableItemId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            mileageRecurringBillableItemId: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest}
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest;
    return proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest}
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMileageRecurringBillableItemId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getMileageRecurringBillableItemId();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 mileage_recurring_billable_item_id = 2;
 * @return {number}
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.prototype.getMileageRecurringBillableItemId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest.prototype.setMileageRecurringBillableItemId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.AddMileageRecurringBillableItemRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.AddMileageRecurringBillableItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            mileageRecurringBillableItem: (f = msg.getMileageRecurringBillableItem()) && proto.billing_service.MileageRecurringBillableItem.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.AddMileageRecurringBillableItemRequest}
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.AddMileageRecurringBillableItemRequest;
    return proto.billing_service.AddMileageRecurringBillableItemRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.AddMileageRecurringBillableItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.AddMileageRecurringBillableItemRequest}
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new proto.billing_service.MileageRecurringBillableItem;
                reader.readMessage(value, proto.billing_service.MileageRecurringBillableItem.deserializeBinaryFromReader);
                msg.setMileageRecurringBillableItem(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.AddMileageRecurringBillableItemRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.AddMileageRecurringBillableItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMileageRecurringBillableItem();
    if (f != null) writer.writeMessage(3, f, proto.billing_service.MileageRecurringBillableItem.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional MileageRecurringBillableItem mileage_recurring_billable_item = 3;
 * @return {?proto.billing_service.MileageRecurringBillableItem}
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.getMileageRecurringBillableItem = function() {
    return /** @type{?proto.billing_service.MileageRecurringBillableItem} */ $8M67s.Message.getWrapperField(this, proto.billing_service.MileageRecurringBillableItem, 3);
};
/**
 * @param {?proto.billing_service.MileageRecurringBillableItem|undefined} value
 * @return {!proto.billing_service.AddMileageRecurringBillableItemRequest} returns this
*/ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.setMileageRecurringBillableItem = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.billing_service.AddMileageRecurringBillableItemRequest} returns this
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.clearMileageRecurringBillableItem = function() {
    return this.setMileageRecurringBillableItem(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.billing_service.AddMileageRecurringBillableItemRequest.prototype.hasMileageRecurringBillableItem = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdateRecurringBillingDayRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdateRecurringBillingDayRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdateRecurringBillingDayRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateRecurringBillingDayRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            recurringBillableDay: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdateRecurringBillingDayRequest}
 */ proto.billing_service.UpdateRecurringBillingDayRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdateRecurringBillingDayRequest;
    return proto.billing_service.UpdateRecurringBillingDayRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdateRecurringBillingDayRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdateRecurringBillingDayRequest}
 */ proto.billing_service.UpdateRecurringBillingDayRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRecurringBillableDay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdateRecurringBillingDayRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdateRecurringBillingDayRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdateRecurringBillingDayRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateRecurringBillingDayRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getRecurringBillableDay();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.UpdateRecurringBillingDayRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateRecurringBillingDayRequest} returns this
 */ proto.billing_service.UpdateRecurringBillingDayRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 recurring_billable_day = 2;
 * @return {number}
 */ proto.billing_service.UpdateRecurringBillingDayRequest.prototype.getRecurringBillableDay = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdateRecurringBillingDayRequest} returns this
 */ proto.billing_service.UpdateRecurringBillingDayRequest.prototype.setRecurringBillableDay = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdateRecurringBillingDayResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdateRecurringBillingDayResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdateRecurringBillingDayResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateRecurringBillingDayResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            previousDueDate: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            nextDueDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdateRecurringBillingDayResponse}
 */ proto.billing_service.UpdateRecurringBillingDayResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdateRecurringBillingDayResponse;
    return proto.billing_service.UpdateRecurringBillingDayResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdateRecurringBillingDayResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdateRecurringBillingDayResponse}
 */ proto.billing_service.UpdateRecurringBillingDayResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPreviousDueDate(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setNextDueDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdateRecurringBillingDayResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdateRecurringBillingDayResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdateRecurringBillingDayResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateRecurringBillingDayResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPreviousDueDate();
    if (f !== 0) writer.writeInt64(1, f);
    f = message.getNextDueDate();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * optional int64 previous_due_date = 1;
 * @return {number}
 */ proto.billing_service.UpdateRecurringBillingDayResponse.prototype.getPreviousDueDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdateRecurringBillingDayResponse} returns this
 */ proto.billing_service.UpdateRecurringBillingDayResponse.prototype.setPreviousDueDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int64 next_due_date = 2;
 * @return {number}
 */ proto.billing_service.UpdateRecurringBillingDayResponse.prototype.getNextDueDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.UpdateRecurringBillingDayResponse} returns this
 */ proto.billing_service.UpdateRecurringBillingDayResponse.prototype.setNextDueDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.RecurringBillableItem.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.RecurringBillableItem.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.RecurringBillableItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RecurringBillableItem.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            productType: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            amount: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.RecurringBillableItem}
 */ proto.billing_service.RecurringBillableItem.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.RecurringBillableItem;
    return proto.billing_service.RecurringBillableItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.RecurringBillableItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.RecurringBillableItem}
 */ proto.billing_service.RecurringBillableItem.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.Product.ProductType} */ reader.readEnum();
                msg.setProductType(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.RecurringBillableItem.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.RecurringBillableItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.RecurringBillableItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RecurringBillableItem.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getProductType();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * optional int32 id = 1;
 * @return {number}
 */ proto.billing_service.RecurringBillableItem.prototype.getId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.RecurringBillableItem} returns this
 */ proto.billing_service.RecurringBillableItem.prototype.setId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional domain.Product.ProductType product_type = 2;
 * @return {!proto.domain.Product.ProductType}
 */ proto.billing_service.RecurringBillableItem.prototype.getProductType = function() {
    return /** @type {!proto.domain.Product.ProductType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.Product.ProductType} value
 * @return {!proto.billing_service.RecurringBillableItem} returns this
 */ proto.billing_service.RecurringBillableItem.prototype.setProductType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional int32 amount = 3;
 * @return {number}
 */ proto.billing_service.RecurringBillableItem.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.RecurringBillableItem} returns this
 */ proto.billing_service.RecurringBillableItem.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListRecurringBillableItemsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListRecurringBillableItemsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListRecurringBillableItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListRecurringBillableItemsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListRecurringBillableItemsRequest}
 */ proto.billing_service.ListRecurringBillableItemsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListRecurringBillableItemsRequest;
    return proto.billing_service.ListRecurringBillableItemsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListRecurringBillableItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListRecurringBillableItemsRequest}
 */ proto.billing_service.ListRecurringBillableItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListRecurringBillableItemsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListRecurringBillableItemsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListRecurringBillableItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListRecurringBillableItemsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.ListRecurringBillableItemsRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ListRecurringBillableItemsRequest} returns this
 */ proto.billing_service.ListRecurringBillableItemsRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.ListRecurringBillableItemsRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ListRecurringBillableItemsRequest} returns this
 */ proto.billing_service.ListRecurringBillableItemsRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListRecurringBillableItemsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListRecurringBillableItemsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListRecurringBillableItemsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListRecurringBillableItemsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListRecurringBillableItemsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            recurringBillableItemsList: $8M67s.Message.toObjectList(msg.getRecurringBillableItemsList(), proto.billing_service.RecurringBillableItem.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListRecurringBillableItemsResponse}
 */ proto.billing_service.ListRecurringBillableItemsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListRecurringBillableItemsResponse;
    return proto.billing_service.ListRecurringBillableItemsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListRecurringBillableItemsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListRecurringBillableItemsResponse}
 */ proto.billing_service.ListRecurringBillableItemsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.RecurringBillableItem;
                reader.readMessage(value, proto.billing_service.RecurringBillableItem.deserializeBinaryFromReader);
                msg.addRecurringBillableItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListRecurringBillableItemsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListRecurringBillableItemsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListRecurringBillableItemsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListRecurringBillableItemsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getRecurringBillableItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.RecurringBillableItem.serializeBinaryToWriter);
};
/**
 * repeated RecurringBillableItem recurring_billable_items = 1;
 * @return {!Array<!proto.billing_service.RecurringBillableItem>}
 */ proto.billing_service.ListRecurringBillableItemsResponse.prototype.getRecurringBillableItemsList = function() {
    return /** @type{!Array<!proto.billing_service.RecurringBillableItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.RecurringBillableItem, 1);
};
/**
 * @param {!Array<!proto.billing_service.RecurringBillableItem>} value
 * @return {!proto.billing_service.ListRecurringBillableItemsResponse} returns this
*/ proto.billing_service.ListRecurringBillableItemsResponse.prototype.setRecurringBillableItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.RecurringBillableItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.RecurringBillableItem}
 */ proto.billing_service.ListRecurringBillableItemsResponse.prototype.addRecurringBillableItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.RecurringBillableItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListRecurringBillableItemsResponse} returns this
 */ proto.billing_service.ListRecurringBillableItemsResponse.prototype.clearRecurringBillableItemsList = function() {
    return this.setRecurringBillableItemsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.AddRecurringBillableItemsRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.AddRecurringBillableItemsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.AddRecurringBillableItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.AddRecurringBillableItemsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            recurringBillableItemsList: $8M67s.Message.toObjectList(msg.getRecurringBillableItemsList(), proto.billing_service.RecurringBillableItem.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.AddRecurringBillableItemsRequest}
 */ proto.billing_service.AddRecurringBillableItemsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.AddRecurringBillableItemsRequest;
    return proto.billing_service.AddRecurringBillableItemsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.AddRecurringBillableItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.AddRecurringBillableItemsRequest}
 */ proto.billing_service.AddRecurringBillableItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new proto.billing_service.RecurringBillableItem;
                reader.readMessage(value, proto.billing_service.RecurringBillableItem.deserializeBinaryFromReader);
                msg.addRecurringBillableItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.AddRecurringBillableItemsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.AddRecurringBillableItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.AddRecurringBillableItemsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getRecurringBillableItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.billing_service.RecurringBillableItem.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddRecurringBillableItemsRequest} returns this
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.AddRecurringBillableItemsRequest} returns this
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated RecurringBillableItem recurring_billable_items = 3;
 * @return {!Array<!proto.billing_service.RecurringBillableItem>}
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.getRecurringBillableItemsList = function() {
    return /** @type{!Array<!proto.billing_service.RecurringBillableItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.RecurringBillableItem, 3);
};
/**
 * @param {!Array<!proto.billing_service.RecurringBillableItem>} value
 * @return {!proto.billing_service.AddRecurringBillableItemsRequest} returns this
*/ proto.billing_service.AddRecurringBillableItemsRequest.prototype.setRecurringBillableItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.billing_service.RecurringBillableItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.RecurringBillableItem}
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.addRecurringBillableItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.billing_service.RecurringBillableItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.AddRecurringBillableItemsRequest} returns this
 */ proto.billing_service.AddRecurringBillableItemsRequest.prototype.clearRecurringBillableItemsList = function() {
    return this.setRecurringBillableItemsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.UpdateRecurringBillableItemsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.UpdateRecurringBillableItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            recurringBillableItemsList: $8M67s.Message.toObjectList(msg.getRecurringBillableItemsList(), proto.billing_service.RecurringBillableItem.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.UpdateRecurringBillableItemsRequest}
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.UpdateRecurringBillableItemsRequest;
    return proto.billing_service.UpdateRecurringBillableItemsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.UpdateRecurringBillableItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.UpdateRecurringBillableItemsRequest}
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new proto.billing_service.RecurringBillableItem;
                reader.readMessage(value, proto.billing_service.RecurringBillableItem.deserializeBinaryFromReader);
                msg.addRecurringBillableItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.UpdateRecurringBillableItemsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.UpdateRecurringBillableItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getRecurringBillableItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.billing_service.RecurringBillableItem.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateRecurringBillableItemsRequest} returns this
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.UpdateRecurringBillableItemsRequest} returns this
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated RecurringBillableItem recurring_billable_items = 3;
 * @return {!Array<!proto.billing_service.RecurringBillableItem>}
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.getRecurringBillableItemsList = function() {
    return /** @type{!Array<!proto.billing_service.RecurringBillableItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.RecurringBillableItem, 3);
};
/**
 * @param {!Array<!proto.billing_service.RecurringBillableItem>} value
 * @return {!proto.billing_service.UpdateRecurringBillableItemsRequest} returns this
*/ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.setRecurringBillableItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.billing_service.RecurringBillableItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.RecurringBillableItem}
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.addRecurringBillableItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.billing_service.RecurringBillableItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.UpdateRecurringBillableItemsRequest} returns this
 */ proto.billing_service.UpdateRecurringBillableItemsRequest.prototype.clearRecurringBillableItemsList = function() {
    return this.setRecurringBillableItemsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.RemoveRecurringBillableItemsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.RemoveRecurringBillableItemsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            recurringBillableItemIdsList: (f = $8M67s.Message.getRepeatedField(msg, 3)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.RemoveRecurringBillableItemsRequest}
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.RemoveRecurringBillableItemsRequest;
    return proto.billing_service.RemoveRecurringBillableItemsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.RemoveRecurringBillableItemsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.RemoveRecurringBillableItemsRequest}
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var values = /** @type {!Array<number>} */ reader.isDelimited() ? reader.readPackedInt32() : [
                    reader.readInt32()
                ];
                for(var i = 0; i < values.length; i++)msg.addRecurringBillableItemIds(values[i]);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.RemoveRecurringBillableItemsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.RemoveRecurringBillableItemsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getRecurringBillableItemIdsList();
    if (f.length > 0) writer.writePackedInt32(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveRecurringBillableItemsRequest} returns this
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.RemoveRecurringBillableItemsRequest} returns this
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated int32 recurring_billable_item_ids = 3;
 * @return {!Array<number>}
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.getRecurringBillableItemIdsList = function() {
    return /** @type {!Array<number>} */ $8M67s.Message.getRepeatedField(this, 3);
};
/**
 * @param {!Array<number>} value
 * @return {!proto.billing_service.RemoveRecurringBillableItemsRequest} returns this
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.setRecurringBillableItemIdsList = function(value) {
    return $8M67s.Message.setField(this, 3, value || []);
};
/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.billing_service.RemoveRecurringBillableItemsRequest} returns this
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.addRecurringBillableItemIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 3, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.RemoveRecurringBillableItemsRequest} returns this
 */ proto.billing_service.RemoveRecurringBillableItemsRequest.prototype.clearRecurringBillableItemIdsList = function() {
    return this.setRecurringBillableItemIdsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListOwnSubscriptionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListOwnSubscriptionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListOwnSubscriptionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListOwnSubscriptionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListOwnSubscriptionsRequest}
 */ proto.billing_service.ListOwnSubscriptionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListOwnSubscriptionsRequest;
    return proto.billing_service.ListOwnSubscriptionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListOwnSubscriptionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListOwnSubscriptionsRequest}
 */ proto.billing_service.ListOwnSubscriptionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListOwnSubscriptionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListOwnSubscriptionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListOwnSubscriptionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListOwnSubscriptionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListSubscriptionsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListSubscriptionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListSubscriptionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListSubscriptionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListSubscriptionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionsList: $8M67s.Message.toObjectList(msg.getSubscriptionsList(), proto.billing_service.Subscription.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListSubscriptionsResponse}
 */ proto.billing_service.ListSubscriptionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListSubscriptionsResponse;
    return proto.billing_service.ListSubscriptionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListSubscriptionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListSubscriptionsResponse}
 */ proto.billing_service.ListSubscriptionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.Subscription;
                reader.readMessage(value, proto.billing_service.Subscription.deserializeBinaryFromReader);
                msg.addSubscriptions(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListSubscriptionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListSubscriptionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListSubscriptionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListSubscriptionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.Subscription.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * repeated Subscription subscriptions = 1;
 * @return {!Array<!proto.billing_service.Subscription>}
 */ proto.billing_service.ListSubscriptionsResponse.prototype.getSubscriptionsList = function() {
    return /** @type{!Array<!proto.billing_service.Subscription>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.Subscription, 1);
};
/**
 * @param {!Array<!proto.billing_service.Subscription>} value
 * @return {!proto.billing_service.ListSubscriptionsResponse} returns this
*/ proto.billing_service.ListSubscriptionsResponse.prototype.setSubscriptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.Subscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.Subscription}
 */ proto.billing_service.ListSubscriptionsResponse.prototype.addSubscriptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.Subscription, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListSubscriptionsResponse} returns this
 */ proto.billing_service.ListSubscriptionsResponse.prototype.clearSubscriptionsList = function() {
    return this.setSubscriptionsList([]);
};
/**
 * optional int64 total = 2;
 * @return {number}
 */ proto.billing_service.ListSubscriptionsResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ListSubscriptionsResponse} returns this
 */ proto.billing_service.ListSubscriptionsResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.Subscription.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.Subscription.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Subscription.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            pickupDate: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            createdAt: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            activationDate: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            vehicleAssignmentDate: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            startingOdometer: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            recurringBillingDay: $8M67s.Message.getFieldWithDefault(msg, 14, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.Subscription}
 */ proto.billing_service.Subscription.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.Subscription;
    return proto.billing_service.Subscription.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.Subscription}
 */ proto.billing_service.Subscription.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setStatus(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPickupDate(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreatedAt(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt64();
                msg.setActivationDate(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVehicleAssignmentDate(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartingOdometer(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRecurringBillingDay(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.Subscription.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.Subscription.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.Subscription.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getStatus();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getPickupDate();
    if (f !== 0) writer.writeInt64(9, f);
    f = message.getCreatedAt();
    if (f !== 0) writer.writeInt64(10, f);
    f = message.getActivationDate();
    if (f !== 0) writer.writeInt64(11, f);
    f = message.getVehicleAssignmentDate();
    if (f !== 0) writer.writeInt64(12, f);
    f = message.getStartingOdometer();
    if (f !== 0) writer.writeInt32(13, f);
    f = message.getRecurringBillingDay();
    if (f !== 0) writer.writeInt32(14, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.billing_service.Subscription.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.billing_service.Subscription.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vehicle_id = 6;
 * @return {string}
 */ proto.billing_service.Subscription.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string status = 8;
 * @return {string}
 */ proto.billing_service.Subscription.prototype.getStatus = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional int64 pickup_date = 9;
 * @return {number}
 */ proto.billing_service.Subscription.prototype.getPickupDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setPickupDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int64 created_at = 10;
 * @return {number}
 */ proto.billing_service.Subscription.prototype.getCreatedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setCreatedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int64 activation_date = 11;
 * @return {number}
 */ proto.billing_service.Subscription.prototype.getActivationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setActivationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int64 vehicle_assignment_date = 12;
 * @return {number}
 */ proto.billing_service.Subscription.prototype.getVehicleAssignmentDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setVehicleAssignmentDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional int32 starting_odometer = 13;
 * @return {number}
 */ proto.billing_service.Subscription.prototype.getStartingOdometer = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setStartingOdometer = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
/**
 * optional int32 recurring_billing_day = 14;
 * @return {number}
 */ proto.billing_service.Subscription.prototype.getRecurringBillingDay = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.Subscription} returns this
 */ proto.billing_service.Subscription.prototype.setRecurringBillingDay = function(value) {
    return $8M67s.Message.setProto3IntField(this, 14, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.SyncTaxedProducts.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.SyncTaxedProducts.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.SyncTaxedProducts} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SyncTaxedProducts.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.SyncTaxedProducts}
 */ proto.billing_service.SyncTaxedProducts.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.SyncTaxedProducts;
    return proto.billing_service.SyncTaxedProducts.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.SyncTaxedProducts} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.SyncTaxedProducts}
 */ proto.billing_service.SyncTaxedProducts.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.SyncTaxedProducts.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.SyncTaxedProducts.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.SyncTaxedProducts} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.SyncTaxedProducts.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PurchaseOneTimeMileageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PurchaseOneTimeMileageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PurchaseOneTimeMileageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PurchaseOneTimeMileageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            miles: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PurchaseOneTimeMileageRequest}
 */ proto.billing_service.PurchaseOneTimeMileageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PurchaseOneTimeMileageRequest;
    return proto.billing_service.PurchaseOneTimeMileageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PurchaseOneTimeMileageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PurchaseOneTimeMileageRequest}
 */ proto.billing_service.PurchaseOneTimeMileageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMiles(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PurchaseOneTimeMileageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PurchaseOneTimeMileageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PurchaseOneTimeMileageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PurchaseOneTimeMileageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getMiles();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.PurchaseOneTimeMileageRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PurchaseOneTimeMileageRequest} returns this
 */ proto.billing_service.PurchaseOneTimeMileageRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 amount = 2;
 * @return {number}
 */ proto.billing_service.PurchaseOneTimeMileageRequest.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PurchaseOneTimeMileageRequest} returns this
 */ proto.billing_service.PurchaseOneTimeMileageRequest.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 miles = 3;
 * @return {number}
 */ proto.billing_service.PurchaseOneTimeMileageRequest.prototype.getMiles = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PurchaseOneTimeMileageRequest} returns this
 */ proto.billing_service.PurchaseOneTimeMileageRequest.prototype.setMiles = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PurchaseRecurringMileageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PurchaseRecurringMileageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PurchaseRecurringMileageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            miles: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            rate: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PurchaseRecurringMileageRequest}
 */ proto.billing_service.PurchaseRecurringMileageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PurchaseRecurringMileageRequest;
    return proto.billing_service.PurchaseRecurringMileageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PurchaseRecurringMileageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PurchaseRecurringMileageRequest}
 */ proto.billing_service.PurchaseRecurringMileageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMiles(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PurchaseRecurringMileageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PurchaseRecurringMileageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PurchaseRecurringMileageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMiles();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getRate();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.PurchaseRecurringMileageRequest} returns this
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 amount = 3;
 * @return {number}
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PurchaseRecurringMileageRequest} returns this
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 miles = 4;
 * @return {number}
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.getMiles = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PurchaseRecurringMileageRequest} returns this
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.setMiles = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 rate = 5;
 * @return {number}
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.getRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.PurchaseRecurringMileageRequest} returns this
 */ proto.billing_service.PurchaseRecurringMileageRequest.prototype.setRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.BillPunitiveMileageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.BillPunitiveMileageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.BillPunitiveMileageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.BillPunitiveMileageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            miles: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.BillPunitiveMileageRequest}
 */ proto.billing_service.BillPunitiveMileageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.BillPunitiveMileageRequest;
    return proto.billing_service.BillPunitiveMileageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.BillPunitiveMileageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.BillPunitiveMileageRequest}
 */ proto.billing_service.BillPunitiveMileageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMiles(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.BillPunitiveMileageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.BillPunitiveMileageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.BillPunitiveMileageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.BillPunitiveMileageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getMiles();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.billing_service.BillPunitiveMileageRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.BillPunitiveMileageRequest} returns this
 */ proto.billing_service.BillPunitiveMileageRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 miles = 3;
 * @return {number}
 */ proto.billing_service.BillPunitiveMileageRequest.prototype.getMiles = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.BillPunitiveMileageRequest} returns this
 */ proto.billing_service.BillPunitiveMileageRequest.prototype.setMiles = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.BatchDateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.BatchDateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.BatchDateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.BatchDateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            date: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.BatchDateRequest}
 */ proto.billing_service.BatchDateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.BatchDateRequest;
    return proto.billing_service.BatchDateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.BatchDateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.BatchDateRequest}
 */ proto.billing_service.BatchDateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.BatchDateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.BatchDateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.BatchDateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.BatchDateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDate();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * optional int32 date = 1;
 * @return {number}
 */ proto.billing_service.BatchDateRequest.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.BatchDateRequest} returns this
 */ proto.billing_service.BatchDateRequest.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            accountNumbersList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse}
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse;
    return proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse}
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addAccountNumbers(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAccountNumbersList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string account_numbers = 1;
 * @return {!Array<string>}
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.prototype.getAccountNumbersList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse} returns this
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.prototype.setAccountNumbersList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse} returns this
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.prototype.addAccountNumbers = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse} returns this
 */ proto.billing_service.GetAccountsMissingSubscriptionInvoiceByDateResponse.prototype.clearAccountNumbersList = function() {
    return this.setAccountNumbersList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.repeatedFields_ = [
    1,
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ConvertSubscriptionOrdersByDateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            invoicesList: $8M67s.Message.toObjectList(msg.getInvoicesList(), proto.billing_service.InvoiceFE.toObject, includeInstance),
            failedAccountNumbersList: (f = $8M67s.Message.getRepeatedField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse}
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ConvertSubscriptionOrdersByDateResponse;
    return proto.billing_service.ConvertSubscriptionOrdersByDateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse}
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.InvoiceFE;
                reader.readMessage(value, proto.billing_service.InvoiceFE.deserializeBinaryFromReader);
                msg.addInvoices(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.addFailedAccountNumbers(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ConvertSubscriptionOrdersByDateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInvoicesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.InvoiceFE.serializeBinaryToWriter);
    f = message.getFailedAccountNumbersList();
    if (f.length > 0) writer.writeRepeatedString(2, f);
};
/**
 * repeated InvoiceFE invoices = 1;
 * @return {!Array<!proto.billing_service.InvoiceFE>}
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.getInvoicesList = function() {
    return /** @type{!Array<!proto.billing_service.InvoiceFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.InvoiceFE, 1);
};
/**
 * @param {!Array<!proto.billing_service.InvoiceFE>} value
 * @return {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse} returns this
*/ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.setInvoicesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.InvoiceFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.InvoiceFE}
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.addInvoices = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.InvoiceFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse} returns this
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.clearInvoicesList = function() {
    return this.setInvoicesList([]);
};
/**
 * repeated string failed_account_numbers = 2;
 * @return {!Array<string>}
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.getFailedAccountNumbersList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse} returns this
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.setFailedAccountNumbersList = function(value) {
    return $8M67s.Message.setField(this, 2, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse} returns this
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.addFailedAccountNumbers = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ConvertSubscriptionOrdersByDateResponse} returns this
 */ proto.billing_service.ConvertSubscriptionOrdersByDateResponse.prototype.clearFailedAccountNumbersList = function() {
    return this.setFailedAccountNumbersList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.repeatedFields_ = [
    1,
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.PaySubscriptionInvoiceByDateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.PaySubscriptionInvoiceByDateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            invoicesList: $8M67s.Message.toObjectList(msg.getInvoicesList(), proto.billing_service.InvoiceFE.toObject, includeInstance),
            failedAccountNumbersList: (f = $8M67s.Message.getRepeatedField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.PaySubscriptionInvoiceByDateResponse}
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.PaySubscriptionInvoiceByDateResponse;
    return proto.billing_service.PaySubscriptionInvoiceByDateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.PaySubscriptionInvoiceByDateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.PaySubscriptionInvoiceByDateResponse}
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.InvoiceFE;
                reader.readMessage(value, proto.billing_service.InvoiceFE.deserializeBinaryFromReader);
                msg.addInvoices(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.addFailedAccountNumbers(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.PaySubscriptionInvoiceByDateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.PaySubscriptionInvoiceByDateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInvoicesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.InvoiceFE.serializeBinaryToWriter);
    f = message.getFailedAccountNumbersList();
    if (f.length > 0) writer.writeRepeatedString(2, f);
};
/**
 * repeated InvoiceFE invoices = 1;
 * @return {!Array<!proto.billing_service.InvoiceFE>}
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.getInvoicesList = function() {
    return /** @type{!Array<!proto.billing_service.InvoiceFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.InvoiceFE, 1);
};
/**
 * @param {!Array<!proto.billing_service.InvoiceFE>} value
 * @return {!proto.billing_service.PaySubscriptionInvoiceByDateResponse} returns this
*/ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.setInvoicesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.InvoiceFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.InvoiceFE}
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.addInvoices = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.InvoiceFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.PaySubscriptionInvoiceByDateResponse} returns this
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.clearInvoicesList = function() {
    return this.setInvoicesList([]);
};
/**
 * repeated string failed_account_numbers = 2;
 * @return {!Array<string>}
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.getFailedAccountNumbersList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.billing_service.PaySubscriptionInvoiceByDateResponse} returns this
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.setFailedAccountNumbersList = function(value) {
    return $8M67s.Message.setField(this, 2, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.billing_service.PaySubscriptionInvoiceByDateResponse} returns this
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.addFailedAccountNumbers = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.PaySubscriptionInvoiceByDateResponse} returns this
 */ proto.billing_service.PaySubscriptionInvoiceByDateResponse.prototype.clearFailedAccountNumbersList = function() {
    return this.setFailedAccountNumbersList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListProgramPricingRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListProgramPricingRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListProgramPricingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProgramPricingRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            removehiddenprograms: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            removehiddenprices: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListProgramPricingRequest}
 */ proto.billing_service.ListProgramPricingRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListProgramPricingRequest;
    return proto.billing_service.ListProgramPricingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListProgramPricingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListProgramPricingRequest}
 */ proto.billing_service.ListProgramPricingRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRemovehiddenprograms(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRemovehiddenprices(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListProgramPricingRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListProgramPricingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListProgramPricingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProgramPricingRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getRemovehiddenprograms();
    if (f) writer.writeBool(1, f);
    f = message.getRemovehiddenprices();
    if (f) writer.writeBool(2, f);
};
/**
 * optional bool RemoveHiddenPrograms = 1;
 * @return {boolean}
 */ proto.billing_service.ListProgramPricingRequest.prototype.getRemovehiddenprograms = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ListProgramPricingRequest} returns this
 */ proto.billing_service.ListProgramPricingRequest.prototype.setRemovehiddenprograms = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional bool RemoveHiddenPrices = 2;
 * @return {boolean}
 */ proto.billing_service.ListProgramPricingRequest.prototype.getRemovehiddenprices = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.billing_service.ListProgramPricingRequest} returns this
 */ proto.billing_service.ListProgramPricingRequest.prototype.setRemovehiddenprices = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.billing_service.ListProgramPricingResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ListProgramPricingResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ListProgramPricingResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ListProgramPricingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProgramPricingResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            programsList: $8M67s.Message.toObjectList(msg.getProgramsList(), proto.billing_service.Program.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ListProgramPricingResponse}
 */ proto.billing_service.ListProgramPricingResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ListProgramPricingResponse;
    return proto.billing_service.ListProgramPricingResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ListProgramPricingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ListProgramPricingResponse}
 */ proto.billing_service.ListProgramPricingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.billing_service.Program;
                reader.readMessage(value, proto.billing_service.Program.deserializeBinaryFromReader);
                msg.addPrograms(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ListProgramPricingResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ListProgramPricingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ListProgramPricingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ListProgramPricingResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgramsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.billing_service.Program.serializeBinaryToWriter);
};
/**
 * repeated Program programs = 1;
 * @return {!Array<!proto.billing_service.Program>}
 */ proto.billing_service.ListProgramPricingResponse.prototype.getProgramsList = function() {
    return /** @type{!Array<!proto.billing_service.Program>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.billing_service.Program, 1);
};
/**
 * @param {!Array<!proto.billing_service.Program>} value
 * @return {!proto.billing_service.ListProgramPricingResponse} returns this
*/ proto.billing_service.ListProgramPricingResponse.prototype.setProgramsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.billing_service.Program=} opt_value
 * @param {number=} opt_index
 * @return {!proto.billing_service.Program}
 */ proto.billing_service.ListProgramPricingResponse.prototype.addPrograms = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.billing_service.Program, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.billing_service.ListProgramPricingResponse} returns this
 */ proto.billing_service.ListProgramPricingResponse.prototype.clearProgramsList = function() {
    return this.setProgramsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ReserveAndInfleetRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ReserveAndInfleetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ReserveAndInfleetRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            startFee: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            vehicleJson: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            postal: $8M67s.Message.getFieldWithDefault(msg, 9, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ReserveAndInfleetRequest}
 */ proto.billing_service.ReserveAndInfleetRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ReserveAndInfleetRequest;
    return proto.billing_service.ReserveAndInfleetRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ReserveAndInfleetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ReserveAndInfleetRequest}
 */ proto.billing_service.ReserveAndInfleetRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleJson(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setPostal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ReserveAndInfleetRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ReserveAndInfleetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ReserveAndInfleetRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getVehicleJson();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getPostal();
    if (f.length > 0) writer.writeString(9, f);
};
/**
 * optional int32 start_fee = 1;
 * @return {number}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 deposit = 2;
 * @return {number}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 monthly_rate = 3;
 * @return {number}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string first_name = 4;
 * @return {string}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string last_name = 5;
 * @return {string}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string phone = 6;
 * @return {string}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string email = 7;
 * @return {string}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string vehicle_json = 8;
 * @return {string}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getVehicleJson = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setVehicleJson = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string postal = 9;
 * @return {string}
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.getPostal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.billing_service.ReserveAndInfleetRequest} returns this
 */ proto.billing_service.ReserveAndInfleetRequest.prototype.setPostal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ReserveAndInfleetResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ReserveAndInfleetResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ReserveAndInfleetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ReserveAndInfleetResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ReserveAndInfleetResponse}
 */ proto.billing_service.ReserveAndInfleetResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ReserveAndInfleetResponse;
    return proto.billing_service.ReserveAndInfleetResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ReserveAndInfleetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ReserveAndInfleetResponse}
 */ proto.billing_service.ReserveAndInfleetResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ReserveAndInfleetResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ReserveAndInfleetResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ReserveAndInfleetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ReserveAndInfleetResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DeactivateServicesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DeactivateServicesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DeactivateServicesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeactivateServicesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DeactivateServicesRequest}
 */ proto.billing_service.DeactivateServicesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DeactivateServicesRequest;
    return proto.billing_service.DeactivateServicesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DeactivateServicesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DeactivateServicesRequest}
 */ proto.billing_service.DeactivateServicesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DeactivateServicesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DeactivateServicesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DeactivateServicesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeactivateServicesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.DeactivateServicesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.DeactivateServicesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.DeactivateServicesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeactivateServicesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.DeactivateServicesResponse}
 */ proto.billing_service.DeactivateServicesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.DeactivateServicesResponse;
    return proto.billing_service.DeactivateServicesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.DeactivateServicesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.DeactivateServicesResponse}
 */ proto.billing_service.DeactivateServicesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.DeactivateServicesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.DeactivateServicesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.DeactivateServicesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.DeactivateServicesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ImportDocumentDataRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ImportDocumentDataRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ImportDocumentDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ImportDocumentDataRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ImportDocumentDataRequest}
 */ proto.billing_service.ImportDocumentDataRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ImportDocumentDataRequest;
    return proto.billing_service.ImportDocumentDataRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ImportDocumentDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ImportDocumentDataRequest}
 */ proto.billing_service.ImportDocumentDataRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ImportDocumentDataRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ImportDocumentDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ImportDocumentDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ImportDocumentDataRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.billing_service.ImportDocumentDataResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.billing_service.ImportDocumentDataResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.billing_service.ImportDocumentDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ImportDocumentDataResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.billing_service.ImportDocumentDataResponse}
 */ proto.billing_service.ImportDocumentDataResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.billing_service.ImportDocumentDataResponse;
    return proto.billing_service.ImportDocumentDataResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.billing_service.ImportDocumentDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.billing_service.ImportDocumentDataResponse}
 */ proto.billing_service.ImportDocumentDataResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.billing_service.ImportDocumentDataResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.billing_service.ImportDocumentDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.billing_service.ImportDocumentDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.billing_service.ImportDocumentDataResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * @enum {number}
 */ proto.billing_service.PromotionSource = {
    PARTNER: 0,
    CUSTOMER: 1
};
/**
 * @enum {number}
 */ proto.billing_service.PromotionTarget = {
    START_PAYMENT: 0,
    FIRST_MONTH: 1
};
/**
 * @enum {number}
 */ proto.billing_service.ActivityType = {
    APPLIED_TO_ORDER: 0,
    REMOVED_FROM_ORDER: 1,
    CONVERTED: 2,
    ATTRIBUTED: 3
};
/**
 * @enum {number}
 */ proto.billing_service.InvoiceType = {
    RESERVATION: 0,
    SECURITY_DEPOSIT: 1,
    DRIVE_OFF: 2,
    MONTHLY: 3,
    ONE_TIME: 4
};
/**
 * @enum {number}
 */ proto.billing_service.InvoiceStatus = {
    ISSUED: 0,
    DUE: 1,
    PAID_IN_FULL: 2,
    PAID_PARTIAL: 3,
    PAST_DUE: 4,
    VOIDED: 5
};
/**
 * @enum {number}
 */ proto.billing_service.LineItemType = {
    RESERVATION_FEE: 0,
    SECURITY_DEPOSIT_TYPE: 1,
    START_PAYMENT_TYPE: 2,
    VEHICLE_RENT: 3,
    OPTION_RENT: 4,
    INSURANCE_PREMIUM: 5,
    ONE_TIME_CHARGE: 6,
    TAX: 7,
    DISCOUNT: 8,
    DELIVERY: 9,
    CITATION: 10
};
$18836cb648331d3c$var$goog.object.extend(module.exports, proto.billing_service);

});
parcelRegister("2k1Kk", function(module, exports) {
// source: vendor_invoicing.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $1b0ecdc6e9f856c1$var$goog = $8M67s;
var $1b0ecdc6e9f856c1$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$1b0ecdc6e9f856c1$var$goog.object.extend(proto, $3QqPt);
$1b0ecdc6e9f856c1$var$goog.exportSymbol('proto.vendor_invoicing.CancelOrderStatementRequest', null, $1b0ecdc6e9f856c1$var$global);
$1b0ecdc6e9f856c1$var$goog.exportSymbol('proto.vendor_invoicing.CancelOrderStatementResponse', null, $1b0ecdc6e9f856c1$var$global);
$1b0ecdc6e9f856c1$var$goog.exportSymbol('proto.vendor_invoicing.CreateMultiItemOrderRequest', null, $1b0ecdc6e9f856c1$var$global);
$1b0ecdc6e9f856c1$var$goog.exportSymbol('proto.vendor_invoicing.OrderItem', null, $1b0ecdc6e9f856c1$var$global);
$1b0ecdc6e9f856c1$var$goog.exportSymbol('proto.vendor_invoicing.OrderStatementCriteria', null, $1b0ecdc6e9f856c1$var$global);
$1b0ecdc6e9f856c1$var$goog.exportSymbol('proto.vendor_invoicing.RetrieveOrderStatementsRequest', null, $1b0ecdc6e9f856c1$var$global);
$1b0ecdc6e9f856c1$var$goog.exportSymbol('proto.vendor_invoicing.RetrieveOrderStatementsResponse', null, $1b0ecdc6e9f856c1$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vendor_invoicing.CancelOrderStatementRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$1b0ecdc6e9f856c1$var$goog.inherits(proto.vendor_invoicing.CancelOrderStatementRequest, $8M67s.Message);
if ($1b0ecdc6e9f856c1$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vendor_invoicing.CancelOrderStatementRequest.displayName = 'proto.vendor_invoicing.CancelOrderStatementRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vendor_invoicing.CancelOrderStatementResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$1b0ecdc6e9f856c1$var$goog.inherits(proto.vendor_invoicing.CancelOrderStatementResponse, $8M67s.Message);
if ($1b0ecdc6e9f856c1$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vendor_invoicing.CancelOrderStatementResponse.displayName = 'proto.vendor_invoicing.CancelOrderStatementResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vendor_invoicing.CreateMultiItemOrderRequest.repeatedFields_, null);
};
$1b0ecdc6e9f856c1$var$goog.inherits(proto.vendor_invoicing.CreateMultiItemOrderRequest, $8M67s.Message);
if ($1b0ecdc6e9f856c1$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vendor_invoicing.CreateMultiItemOrderRequest.displayName = 'proto.vendor_invoicing.CreateMultiItemOrderRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vendor_invoicing.OrderItem = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$1b0ecdc6e9f856c1$var$goog.inherits(proto.vendor_invoicing.OrderItem, $8M67s.Message);
if ($1b0ecdc6e9f856c1$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vendor_invoicing.OrderItem.displayName = 'proto.vendor_invoicing.OrderItem';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vendor_invoicing.RetrieveOrderStatementsRequest.repeatedFields_, null);
};
$1b0ecdc6e9f856c1$var$goog.inherits(proto.vendor_invoicing.RetrieveOrderStatementsRequest, $8M67s.Message);
if ($1b0ecdc6e9f856c1$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.displayName = 'proto.vendor_invoicing.RetrieveOrderStatementsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vendor_invoicing.OrderStatementCriteria = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$1b0ecdc6e9f856c1$var$goog.inherits(proto.vendor_invoicing.OrderStatementCriteria, $8M67s.Message);
if ($1b0ecdc6e9f856c1$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vendor_invoicing.OrderStatementCriteria.displayName = 'proto.vendor_invoicing.OrderStatementCriteria';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vendor_invoicing.RetrieveOrderStatementsResponse.repeatedFields_, null);
};
$1b0ecdc6e9f856c1$var$goog.inherits(proto.vendor_invoicing.RetrieveOrderStatementsResponse, $8M67s.Message);
if ($1b0ecdc6e9f856c1$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.displayName = 'proto.vendor_invoicing.RetrieveOrderStatementsResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vendor_invoicing.CancelOrderStatementRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vendor_invoicing.CancelOrderStatementRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendor_invoicing.CancelOrderStatementRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.CancelOrderStatementRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            orderNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendor_invoicing.CancelOrderStatementRequest}
 */ proto.vendor_invoicing.CancelOrderStatementRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vendor_invoicing.CancelOrderStatementRequest;
    return proto.vendor_invoicing.CancelOrderStatementRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendor_invoicing.CancelOrderStatementRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendor_invoicing.CancelOrderStatementRequest}
 */ proto.vendor_invoicing.CancelOrderStatementRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOrderNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vendor_invoicing.CancelOrderStatementRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vendor_invoicing.CancelOrderStatementRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendor_invoicing.CancelOrderStatementRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.CancelOrderStatementRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOrderNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.vendor_invoicing.CancelOrderStatementRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.CancelOrderStatementRequest} returns this
 */ proto.vendor_invoicing.CancelOrderStatementRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string order_number = 2;
 * @return {string}
 */ proto.vendor_invoicing.CancelOrderStatementRequest.prototype.getOrderNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.CancelOrderStatementRequest} returns this
 */ proto.vendor_invoicing.CancelOrderStatementRequest.prototype.setOrderNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string account_number = 3;
 * @return {string}
 */ proto.vendor_invoicing.CancelOrderStatementRequest.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.CancelOrderStatementRequest} returns this
 */ proto.vendor_invoicing.CancelOrderStatementRequest.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vendor_invoicing.CancelOrderStatementResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vendor_invoicing.CancelOrderStatementResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendor_invoicing.CancelOrderStatementResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.CancelOrderStatementResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            statementId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendor_invoicing.CancelOrderStatementResponse}
 */ proto.vendor_invoicing.CancelOrderStatementResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vendor_invoicing.CancelOrderStatementResponse;
    return proto.vendor_invoicing.CancelOrderStatementResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendor_invoicing.CancelOrderStatementResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendor_invoicing.CancelOrderStatementResponse}
 */ proto.vendor_invoicing.CancelOrderStatementResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setStatementId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vendor_invoicing.CancelOrderStatementResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vendor_invoicing.CancelOrderStatementResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendor_invoicing.CancelOrderStatementResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.CancelOrderStatementResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getStatementId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.vendor_invoicing.CancelOrderStatementResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vendor_invoicing.CancelOrderStatementResponse} returns this
 */ proto.vendor_invoicing.CancelOrderStatementResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string statement_id = 2;
 * @return {string}
 */ proto.vendor_invoicing.CancelOrderStatementResponse.prototype.getStatementId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.CancelOrderStatementResponse} returns this
 */ proto.vendor_invoicing.CancelOrderStatementResponse.prototype.setStatementId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string account_number = 3;
 * @return {string}
 */ proto.vendor_invoicing.CancelOrderStatementResponse.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.CancelOrderStatementResponse} returns this
 */ proto.vendor_invoicing.CancelOrderStatementResponse.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vendor_invoicing.CreateMultiItemOrderRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendor_invoicing.CreateMultiItemOrderRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            itemsList: $8M67s.Message.toObjectList(msg.getItemsList(), proto.vendor_invoicing.OrderItem.toObject, includeInstance),
            orderDate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            invoiceOrder: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendor_invoicing.CreateMultiItemOrderRequest}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vendor_invoicing.CreateMultiItemOrderRequest;
    return proto.vendor_invoicing.CreateMultiItemOrderRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendor_invoicing.CreateMultiItemOrderRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendor_invoicing.CreateMultiItemOrderRequest}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 2:
                var value = new proto.vendor_invoicing.OrderItem;
                reader.readMessage(value, proto.vendor_invoicing.OrderItem.deserializeBinaryFromReader);
                msg.addItems(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setOrderDate(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setInvoiceOrder(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vendor_invoicing.CreateMultiItemOrderRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendor_invoicing.CreateMultiItemOrderRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.vendor_invoicing.OrderItem.serializeBinaryToWriter);
    f = message.getOrderDate();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getInvoiceOrder();
    if (f) writer.writeBool(4, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string account_number = 1;
 * @return {string}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.CreateMultiItemOrderRequest} returns this
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated OrderItem items = 2;
 * @return {!Array<!proto.vendor_invoicing.OrderItem>}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.getItemsList = function() {
    return /** @type{!Array<!proto.vendor_invoicing.OrderItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vendor_invoicing.OrderItem, 2);
};
/**
 * @param {!Array<!proto.vendor_invoicing.OrderItem>} value
 * @return {!proto.vendor_invoicing.CreateMultiItemOrderRequest} returns this
*/ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.setItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.vendor_invoicing.OrderItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vendor_invoicing.OrderItem}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.addItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vendor_invoicing.OrderItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vendor_invoicing.CreateMultiItemOrderRequest} returns this
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.clearItemsList = function() {
    return this.setItemsList([]);
};
/**
 * optional int64 order_date = 3;
 * @return {number}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.getOrderDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vendor_invoicing.CreateMultiItemOrderRequest} returns this
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.setOrderDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional bool invoice_order = 4;
 * @return {boolean}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.getInvoiceOrder = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vendor_invoicing.CreateMultiItemOrderRequest} returns this
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.setInvoiceOrder = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
/**
 * optional string subscription_id = 5;
 * @return {string}
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.CreateMultiItemOrderRequest} returns this
 */ proto.vendor_invoicing.CreateMultiItemOrderRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vendor_invoicing.OrderItem.prototype.toObject = function(opt_includeInstance) {
        return proto.vendor_invoicing.OrderItem.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendor_invoicing.OrderItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.OrderItem.toObject = function(includeInstance, msg) {
        var f, obj = {
            amount: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            description: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            productType: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            quantity: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendor_invoicing.OrderItem}
 */ proto.vendor_invoicing.OrderItem.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vendor_invoicing.OrderItem;
    return proto.vendor_invoicing.OrderItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendor_invoicing.OrderItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendor_invoicing.OrderItem}
 */ proto.vendor_invoicing.OrderItem.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 4:
                var value = /** @type {!proto.domain.Product.ProductType} */ reader.readEnum();
                msg.setProductType(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setQuantity(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vendor_invoicing.OrderItem.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vendor_invoicing.OrderItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendor_invoicing.OrderItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.OrderItem.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getProductType();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getQuantity();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional int32 amount = 2;
 * @return {number}
 */ proto.vendor_invoicing.OrderItem.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vendor_invoicing.OrderItem} returns this
 */ proto.vendor_invoicing.OrderItem.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string description = 3;
 * @return {string}
 */ proto.vendor_invoicing.OrderItem.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.OrderItem} returns this
 */ proto.vendor_invoicing.OrderItem.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional domain.Product.ProductType product_type = 4;
 * @return {!proto.domain.Product.ProductType}
 */ proto.vendor_invoicing.OrderItem.prototype.getProductType = function() {
    return /** @type {!proto.domain.Product.ProductType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.domain.Product.ProductType} value
 * @return {!proto.vendor_invoicing.OrderItem} returns this
 */ proto.vendor_invoicing.OrderItem.prototype.setProductType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional int32 quantity = 5;
 * @return {number}
 */ proto.vendor_invoicing.OrderItem.prototype.getQuantity = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.vendor_invoicing.OrderItem} returns this
 */ proto.vendor_invoicing.OrderItem.prototype.setQuantity = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vendor_invoicing.RetrieveOrderStatementsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendor_invoicing.RetrieveOrderStatementsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            criteriaList: $8M67s.Message.toObjectList(msg.getCriteriaList(), proto.vendor_invoicing.OrderStatementCriteria.toObject, includeInstance),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsRequest}
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vendor_invoicing.RetrieveOrderStatementsRequest;
    return proto.vendor_invoicing.RetrieveOrderStatementsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendor_invoicing.RetrieveOrderStatementsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsRequest}
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 2:
                var value = new proto.vendor_invoicing.OrderStatementCriteria;
                reader.readMessage(value, proto.vendor_invoicing.OrderStatementCriteria.deserializeBinaryFromReader);
                msg.addCriteria(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vendor_invoicing.RetrieveOrderStatementsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendor_invoicing.RetrieveOrderStatementsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCriteriaList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.vendor_invoicing.OrderStatementCriteria.serializeBinaryToWriter);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string account_number = 1;
 * @return {string}
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsRequest} returns this
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated OrderStatementCriteria criteria = 2;
 * @return {!Array<!proto.vendor_invoicing.OrderStatementCriteria>}
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.getCriteriaList = function() {
    return /** @type{!Array<!proto.vendor_invoicing.OrderStatementCriteria>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vendor_invoicing.OrderStatementCriteria, 2);
};
/**
 * @param {!Array<!proto.vendor_invoicing.OrderStatementCriteria>} value
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsRequest} returns this
*/ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.setCriteriaList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.vendor_invoicing.OrderStatementCriteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vendor_invoicing.OrderStatementCriteria}
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.addCriteria = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vendor_invoicing.OrderStatementCriteria, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsRequest} returns this
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.clearCriteriaList = function() {
    return this.setCriteriaList([]);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsRequest} returns this
 */ proto.vendor_invoicing.RetrieveOrderStatementsRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vendor_invoicing.OrderStatementCriteria.prototype.toObject = function(opt_includeInstance) {
        return proto.vendor_invoicing.OrderStatementCriteria.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendor_invoicing.OrderStatementCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.OrderStatementCriteria.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            query: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendor_invoicing.OrderStatementCriteria}
 */ proto.vendor_invoicing.OrderStatementCriteria.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vendor_invoicing.OrderStatementCriteria;
    return proto.vendor_invoicing.OrderStatementCriteria.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendor_invoicing.OrderStatementCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendor_invoicing.OrderStatementCriteria}
 */ proto.vendor_invoicing.OrderStatementCriteria.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setQuery(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vendor_invoicing.OrderStatementCriteria.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vendor_invoicing.OrderStatementCriteria.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendor_invoicing.OrderStatementCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.OrderStatementCriteria.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getQuery();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.vendor_invoicing.OrderStatementCriteria.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.OrderStatementCriteria} returns this
 */ proto.vendor_invoicing.OrderStatementCriteria.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string query = 2;
 * @return {string}
 */ proto.vendor_invoicing.OrderStatementCriteria.prototype.getQuery = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vendor_invoicing.OrderStatementCriteria} returns this
 */ proto.vendor_invoicing.OrderStatementCriteria.prototype.setQuery = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vendor_invoicing.RetrieveOrderStatementsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vendor_invoicing.RetrieveOrderStatementsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            statementsList: $8M67s.Message.toObjectList(msg.getStatementsList(), $3QqPt.Statement.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsResponse}
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vendor_invoicing.RetrieveOrderStatementsResponse;
    return proto.vendor_invoicing.RetrieveOrderStatementsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vendor_invoicing.RetrieveOrderStatementsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsResponse}
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = new $3QqPt.Statement;
                reader.readMessage(value, $3QqPt.Statement.deserializeBinaryFromReader);
                msg.addStatements(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vendor_invoicing.RetrieveOrderStatementsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vendor_invoicing.RetrieveOrderStatementsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getStatementsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.Statement.serializeBinaryToWriter);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsResponse} returns this
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * repeated domain.Statement statements = 2;
 * @return {!Array<!proto.domain.Statement>}
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.prototype.getStatementsList = function() {
    return /** @type{!Array<!proto.domain.Statement>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Statement, 2);
};
/**
 * @param {!Array<!proto.domain.Statement>} value
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsResponse} returns this
*/ proto.vendor_invoicing.RetrieveOrderStatementsResponse.prototype.setStatementsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.Statement=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Statement}
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.prototype.addStatements = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.Statement, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vendor_invoicing.RetrieveOrderStatementsResponse} returns this
 */ proto.vendor_invoicing.RetrieveOrderStatementsResponse.prototype.clearStatementsList = function() {
    return this.setStatementsList([]);
};
$1b0ecdc6e9f856c1$var$goog.object.extend(module.exports, proto.vendor_invoicing);

});

parcelRegister("9c7Du", function(module, exports) {
// source: web.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $6b1b28663a0b3274$var$goog = $8M67s;
var $6b1b28663a0b3274$var$global = Function('return this')();
$6b1b28663a0b3274$var$goog.exportSymbol('proto.web.ListParams', null, $6b1b28663a0b3274$var$global);
$6b1b28663a0b3274$var$goog.exportSymbol('proto.web.Modifier', null, $6b1b28663a0b3274$var$global);
$6b1b28663a0b3274$var$goog.exportSymbol('proto.web.OrderParams', null, $6b1b28663a0b3274$var$global);
$6b1b28663a0b3274$var$goog.exportSymbol('proto.web.OrderParams.Direction', null, $6b1b28663a0b3274$var$global);
$6b1b28663a0b3274$var$goog.exportSymbol('proto.web.PaginationParams', null, $6b1b28663a0b3274$var$global);
$6b1b28663a0b3274$var$goog.exportSymbol('proto.web.QueryParams', null, $6b1b28663a0b3274$var$global);
$6b1b28663a0b3274$var$goog.exportSymbol('proto.web.SearchParams', null, $6b1b28663a0b3274$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.web.SearchParams = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.web.SearchParams.repeatedFields_, null);
};
$6b1b28663a0b3274$var$goog.inherits(proto.web.SearchParams, $8M67s.Message);
if ($6b1b28663a0b3274$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.web.SearchParams.displayName = 'proto.web.SearchParams';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.web.ListParams = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.web.ListParams.repeatedFields_, null);
};
$6b1b28663a0b3274$var$goog.inherits(proto.web.ListParams, $8M67s.Message);
if ($6b1b28663a0b3274$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.web.ListParams.displayName = 'proto.web.ListParams';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.web.QueryParams = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$6b1b28663a0b3274$var$goog.inherits(proto.web.QueryParams, $8M67s.Message);
if ($6b1b28663a0b3274$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.web.QueryParams.displayName = 'proto.web.QueryParams';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.web.OrderParams = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$6b1b28663a0b3274$var$goog.inherits(proto.web.OrderParams, $8M67s.Message);
if ($6b1b28663a0b3274$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.web.OrderParams.displayName = 'proto.web.OrderParams';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.web.PaginationParams = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$6b1b28663a0b3274$var$goog.inherits(proto.web.PaginationParams, $8M67s.Message);
if ($6b1b28663a0b3274$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.web.PaginationParams.displayName = 'proto.web.PaginationParams';
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.web.SearchParams.repeatedFields_ = [
    1,
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.web.SearchParams.prototype.toObject = function(opt_includeInstance) {
        return proto.web.SearchParams.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.web.SearchParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.SearchParams.toObject = function(includeInstance, msg) {
        var f, obj = {
            queryList: $8M67s.Message.toObjectList(msg.getQueryList(), proto.web.QueryParams.toObject, includeInstance),
            orderList: $8M67s.Message.toObjectList(msg.getOrderList(), proto.web.OrderParams.toObject, includeInstance),
            pagination: (f = msg.getPagination()) && proto.web.PaginationParams.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.web.SearchParams}
 */ proto.web.SearchParams.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.web.SearchParams;
    return proto.web.SearchParams.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.web.SearchParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.web.SearchParams}
 */ proto.web.SearchParams.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.web.QueryParams;
                reader.readMessage(value, proto.web.QueryParams.deserializeBinaryFromReader);
                msg.addQuery(value);
                break;
            case 2:
                var value = new proto.web.OrderParams;
                reader.readMessage(value, proto.web.OrderParams.deserializeBinaryFromReader);
                msg.addOrder(value);
                break;
            case 3:
                var value = new proto.web.PaginationParams;
                reader.readMessage(value, proto.web.PaginationParams.deserializeBinaryFromReader);
                msg.setPagination(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.web.SearchParams.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.web.SearchParams.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.web.SearchParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.SearchParams.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getQueryList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.web.QueryParams.serializeBinaryToWriter);
    f = message.getOrderList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.web.OrderParams.serializeBinaryToWriter);
    f = message.getPagination();
    if (f != null) writer.writeMessage(3, f, proto.web.PaginationParams.serializeBinaryToWriter);
};
/**
 * repeated QueryParams query = 1;
 * @return {!Array<!proto.web.QueryParams>}
 */ proto.web.SearchParams.prototype.getQueryList = function() {
    return /** @type{!Array<!proto.web.QueryParams>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.web.QueryParams, 1);
};
/**
 * @param {!Array<!proto.web.QueryParams>} value
 * @return {!proto.web.SearchParams} returns this
*/ proto.web.SearchParams.prototype.setQueryList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.web.QueryParams=} opt_value
 * @param {number=} opt_index
 * @return {!proto.web.QueryParams}
 */ proto.web.SearchParams.prototype.addQuery = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.web.QueryParams, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.web.SearchParams} returns this
 */ proto.web.SearchParams.prototype.clearQueryList = function() {
    return this.setQueryList([]);
};
/**
 * repeated OrderParams order = 2;
 * @return {!Array<!proto.web.OrderParams>}
 */ proto.web.SearchParams.prototype.getOrderList = function() {
    return /** @type{!Array<!proto.web.OrderParams>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.web.OrderParams, 2);
};
/**
 * @param {!Array<!proto.web.OrderParams>} value
 * @return {!proto.web.SearchParams} returns this
*/ proto.web.SearchParams.prototype.setOrderList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.web.OrderParams=} opt_value
 * @param {number=} opt_index
 * @return {!proto.web.OrderParams}
 */ proto.web.SearchParams.prototype.addOrder = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.web.OrderParams, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.web.SearchParams} returns this
 */ proto.web.SearchParams.prototype.clearOrderList = function() {
    return this.setOrderList([]);
};
/**
 * optional PaginationParams pagination = 3;
 * @return {?proto.web.PaginationParams}
 */ proto.web.SearchParams.prototype.getPagination = function() {
    return /** @type{?proto.web.PaginationParams} */ $8M67s.Message.getWrapperField(this, proto.web.PaginationParams, 3);
};
/**
 * @param {?proto.web.PaginationParams|undefined} value
 * @return {!proto.web.SearchParams} returns this
*/ proto.web.SearchParams.prototype.setPagination = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.web.SearchParams} returns this
 */ proto.web.SearchParams.prototype.clearPagination = function() {
    return this.setPagination(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.web.SearchParams.prototype.hasPagination = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.web.ListParams.repeatedFields_ = [
    1,
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.web.ListParams.prototype.toObject = function(opt_includeInstance) {
        return proto.web.ListParams.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.web.ListParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.ListParams.toObject = function(includeInstance, msg) {
        var f, obj = {
            queryList: $8M67s.Message.toObjectList(msg.getQueryList(), proto.web.QueryParams.toObject, includeInstance),
            orderList: $8M67s.Message.toObjectList(msg.getOrderList(), proto.web.OrderParams.toObject, includeInstance),
            pagination: (f = msg.getPagination()) && proto.web.PaginationParams.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.web.ListParams}
 */ proto.web.ListParams.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.web.ListParams;
    return proto.web.ListParams.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.web.ListParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.web.ListParams}
 */ proto.web.ListParams.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.web.QueryParams;
                reader.readMessage(value, proto.web.QueryParams.deserializeBinaryFromReader);
                msg.addQuery(value);
                break;
            case 2:
                var value = new proto.web.OrderParams;
                reader.readMessage(value, proto.web.OrderParams.deserializeBinaryFromReader);
                msg.addOrder(value);
                break;
            case 3:
                var value = new proto.web.PaginationParams;
                reader.readMessage(value, proto.web.PaginationParams.deserializeBinaryFromReader);
                msg.setPagination(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.web.ListParams.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.web.ListParams.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.web.ListParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.ListParams.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getQueryList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.web.QueryParams.serializeBinaryToWriter);
    f = message.getOrderList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.web.OrderParams.serializeBinaryToWriter);
    f = message.getPagination();
    if (f != null) writer.writeMessage(3, f, proto.web.PaginationParams.serializeBinaryToWriter);
};
/**
 * repeated QueryParams query = 1;
 * @return {!Array<!proto.web.QueryParams>}
 */ proto.web.ListParams.prototype.getQueryList = function() {
    return /** @type{!Array<!proto.web.QueryParams>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.web.QueryParams, 1);
};
/**
 * @param {!Array<!proto.web.QueryParams>} value
 * @return {!proto.web.ListParams} returns this
*/ proto.web.ListParams.prototype.setQueryList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.web.QueryParams=} opt_value
 * @param {number=} opt_index
 * @return {!proto.web.QueryParams}
 */ proto.web.ListParams.prototype.addQuery = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.web.QueryParams, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.web.ListParams} returns this
 */ proto.web.ListParams.prototype.clearQueryList = function() {
    return this.setQueryList([]);
};
/**
 * repeated OrderParams order = 2;
 * @return {!Array<!proto.web.OrderParams>}
 */ proto.web.ListParams.prototype.getOrderList = function() {
    return /** @type{!Array<!proto.web.OrderParams>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.web.OrderParams, 2);
};
/**
 * @param {!Array<!proto.web.OrderParams>} value
 * @return {!proto.web.ListParams} returns this
*/ proto.web.ListParams.prototype.setOrderList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.web.OrderParams=} opt_value
 * @param {number=} opt_index
 * @return {!proto.web.OrderParams}
 */ proto.web.ListParams.prototype.addOrder = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.web.OrderParams, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.web.ListParams} returns this
 */ proto.web.ListParams.prototype.clearOrderList = function() {
    return this.setOrderList([]);
};
/**
 * optional PaginationParams pagination = 3;
 * @return {?proto.web.PaginationParams}
 */ proto.web.ListParams.prototype.getPagination = function() {
    return /** @type{?proto.web.PaginationParams} */ $8M67s.Message.getWrapperField(this, proto.web.PaginationParams, 3);
};
/**
 * @param {?proto.web.PaginationParams|undefined} value
 * @return {!proto.web.ListParams} returns this
*/ proto.web.ListParams.prototype.setPagination = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.web.ListParams} returns this
 */ proto.web.ListParams.prototype.clearPagination = function() {
    return this.setPagination(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.web.ListParams.prototype.hasPagination = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.web.QueryParams.prototype.toObject = function(opt_includeInstance) {
        return proto.web.QueryParams.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.web.QueryParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.QueryParams.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            value: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            modifier: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.web.QueryParams}
 */ proto.web.QueryParams.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.web.QueryParams;
    return proto.web.QueryParams.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.web.QueryParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.web.QueryParams}
 */ proto.web.QueryParams.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValue(value);
                break;
            case 3:
                var value = /** @type {!proto.web.Modifier} */ reader.readEnum();
                msg.setModifier(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.web.QueryParams.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.web.QueryParams.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.web.QueryParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.QueryParams.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getValue();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getModifier();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.web.QueryParams.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.web.QueryParams} returns this
 */ proto.web.QueryParams.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string value = 2;
 * @return {string}
 */ proto.web.QueryParams.prototype.getValue = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.web.QueryParams} returns this
 */ proto.web.QueryParams.prototype.setValue = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Modifier modifier = 3;
 * @return {!proto.web.Modifier}
 */ proto.web.QueryParams.prototype.getModifier = function() {
    return /** @type {!proto.web.Modifier} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.web.Modifier} value
 * @return {!proto.web.QueryParams} returns this
 */ proto.web.QueryParams.prototype.setModifier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.web.OrderParams.prototype.toObject = function(opt_includeInstance) {
        return proto.web.OrderParams.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.web.OrderParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.OrderParams.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            direction: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.web.OrderParams}
 */ proto.web.OrderParams.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.web.OrderParams;
    return proto.web.OrderParams.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.web.OrderParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.web.OrderParams}
 */ proto.web.OrderParams.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {!proto.web.OrderParams.Direction} */ reader.readEnum();
                msg.setDirection(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.web.OrderParams.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.web.OrderParams.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.web.OrderParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.OrderParams.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDirection();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * @enum {number}
 */ proto.web.OrderParams.Direction = {
    ASC: 0,
    DESC: 1
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.web.OrderParams.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.web.OrderParams} returns this
 */ proto.web.OrderParams.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Direction direction = 2;
 * @return {!proto.web.OrderParams.Direction}
 */ proto.web.OrderParams.prototype.getDirection = function() {
    return /** @type {!proto.web.OrderParams.Direction} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.web.OrderParams.Direction} value
 * @return {!proto.web.OrderParams} returns this
 */ proto.web.OrderParams.prototype.setDirection = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.web.PaginationParams.prototype.toObject = function(opt_includeInstance) {
        return proto.web.PaginationParams.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.web.PaginationParams} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.PaginationParams.toObject = function(includeInstance, msg) {
        var f, obj = {
            limit: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            offset: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.web.PaginationParams}
 */ proto.web.PaginationParams.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.web.PaginationParams;
    return proto.web.PaginationParams.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.web.PaginationParams} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.web.PaginationParams}
 */ proto.web.PaginationParams.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLimit(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOffset(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.web.PaginationParams.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.web.PaginationParams.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.web.PaginationParams} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.web.PaginationParams.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLimit();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getOffset();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional int32 limit = 1;
 * @return {number}
 */ proto.web.PaginationParams.prototype.getLimit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.web.PaginationParams} returns this
 */ proto.web.PaginationParams.prototype.setLimit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 offset = 2;
 * @return {number}
 */ proto.web.PaginationParams.prototype.getOffset = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.web.PaginationParams} returns this
 */ proto.web.PaginationParams.prototype.setOffset = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * @enum {number}
 */ proto.web.Modifier = {
    GREATER_THAN: 0,
    LESS_THAN: 1,
    EQUAL_TO: 2,
    CONTAINS: 5,
    NOT_CONTAINS: 6,
    STARTS_WITH: 7,
    ENDS_WITH: 8,
    GREATER_THAN_EQUAL: 9,
    LESS_THAN_EQUAL: 10,
    NOT_EQUAL_TO: 11,
    IS_NULL: 12,
    NOT_NULL: 13
};
$6b1b28663a0b3274$var$goog.object.extend(module.exports, proto.web);

});


parcelRegister("6EauF", function(module, exports) {
// source: customer_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $4d6e9e4d0144e462$var$goog = $8M67s;
var $4d6e9e4d0144e462$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$4d6e9e4d0144e462$var$goog.object.extend(proto, $3QqPt);

var $9c7Du = parcelRequire("9c7Du");
$4d6e9e4d0144e462$var$goog.object.extend(proto, $9c7Du);

var $cyjZp = parcelRequire("cyjZp");
$4d6e9e4d0144e462$var$goog.object.extend(proto, $cyjZp);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Contract', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Contract.Status', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Payment', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Payment.Authorization', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Payment.Authorization.Status', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Payment.DriveOff', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Payment.DriveOff.Status', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Qualification', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Subscription', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ActivationState.Subscription.Status', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ChangeCustomerClientIdRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ChangeCustomerClientIdResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.Client', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ClientOSType', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.CreateCustomerRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.CreateCustomerResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.Customer', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.CustomerIdentity', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.CustomerProjectionMeta', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.DecryptCustomerDataRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.DecryptCustomerDataResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ExistsByPhoneRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ExistsByPhoneResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetAddressesRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetAddressesResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetAllCustomersByPhoneRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetAllCustomersByPhoneResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetAutoPayAuthorizationRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetAutoPayAuthorizationResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCQEScoresRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCQEScoresResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerBankInfoRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerBankInfoResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerByAccountNumberRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerByAccountNumberResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerByIDRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerByIDResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerByPhoneRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerByPhoneResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerQualificationRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetCustomerQualificationResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetImageUploadURIRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetImageUploadURIResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetImagesRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetImagesResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetInsurancePoliciesRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetInsurancePoliciesResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetNotesRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetOwnAddressesRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetSecurityDepositAmountRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetSecurityDepositAmountResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetSelfRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetSelfResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetStateRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.GetStateResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ImportDocumentDataRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ImportDocumentDataResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.InitProjectionsRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.InitProjectionsResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ListClientsRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ListClientsResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ListCustomersRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ListCustomersResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.OptIntoSMSRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.OptIntoSMSResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.OverrideQualificationRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.OverrideQualificationResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.QualificationRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.QualificationResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.QualificationState', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RecalculateCustomerScoresRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RecalculateCustomerScoresRequest.ScoreName', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RecalculateCustomerScoresResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RecalculateQualificationRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RecalculateQualificationRequest.ScoreName', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RecalculateQualificationResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RefreshAuthIDRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RefreshAuthIDResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RequestMfaRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RequestMfaRequest.EnrichmentStatus', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.RequestMfaResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ResetLoginAttemptsRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ResetLoginAttemptsResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ScrubCustomerInfoRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ScrubCustomerInfoResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SendDeepLinkRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SendDeepLinkRequest.MarketingMetaData', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SendDeepLinkResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SendOTPRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SendOTPResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SetActivityRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SetActivityResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SubmitLicenseInfoRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SubmitLicenseInfoResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SubmitLicensePhotosRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SubmitLicensePhotosResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SubmitSelfiePhotoRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SubmitSelfiePhotoResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SubscribeToActivationRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SyncCustomerNamesFromLicenseRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.SyncCustomerNamesFromLicenseResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.TrackCustomerInAppsFlyerRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.TrackCustomerInAppsFlyerResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpdateAutoPayAuthorizationRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpdateAutoPayAuthorizationResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpdateCustomerRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpdateCustomerResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpdateCustomerWithFakePhoneRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpdateCustomerWithFakePhoneResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpdateEmailRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpdateEmailResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpsertAddressesRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpsertAddressesResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpsertInsurancePoliciesRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpsertInsurancePoliciesResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.UpsertOwnAddressesRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ValidateClientRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ValidateClientResponse', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.ValidateClientResponse.ViabilityStatus', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.VerifyOTPRequest', null, $4d6e9e4d0144e462$var$global);
$4d6e9e4d0144e462$var$goog.exportSymbol('proto.customer_service.VerifyOTPResponse', null, $4d6e9e4d0144e462$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SyncCustomerNamesFromLicenseRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SyncCustomerNamesFromLicenseRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SyncCustomerNamesFromLicenseRequest.displayName = 'proto.customer_service.SyncCustomerNamesFromLicenseRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SyncCustomerNamesFromLicenseResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SyncCustomerNamesFromLicenseResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SyncCustomerNamesFromLicenseResponse.displayName = 'proto.customer_service.SyncCustomerNamesFromLicenseResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ResetLoginAttemptsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ResetLoginAttemptsRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ResetLoginAttemptsRequest.displayName = 'proto.customer_service.ResetLoginAttemptsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ResetLoginAttemptsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ResetLoginAttemptsResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ResetLoginAttemptsResponse.displayName = 'proto.customer_service.ResetLoginAttemptsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerBankInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerBankInfoRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerBankInfoRequest.displayName = 'proto.customer_service.GetCustomerBankInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerBankInfoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.GetCustomerBankInfoResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerBankInfoResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerBankInfoResponse.displayName = 'proto.customer_service.GetCustomerBankInfoResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SubscribeToActivationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SubscribeToActivationRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SubscribeToActivationRequest.displayName = 'proto.customer_service.SubscribeToActivationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ActivationState = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ActivationState, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ActivationState.displayName = 'proto.customer_service.ActivationState';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ActivationState.Qualification = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ActivationState.Qualification, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ActivationState.Qualification.displayName = 'proto.customer_service.ActivationState.Qualification';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ActivationState.Contract = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ActivationState.Contract, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ActivationState.Contract.displayName = 'proto.customer_service.ActivationState.Contract';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ActivationState.Payment = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ActivationState.Payment, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ActivationState.Payment.displayName = 'proto.customer_service.ActivationState.Payment';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ActivationState.Payment.DriveOff = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ActivationState.Payment.DriveOff, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ActivationState.Payment.DriveOff.displayName = 'proto.customer_service.ActivationState.Payment.DriveOff';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ActivationState.Payment.Authorization = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ActivationState.Payment.Authorization, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ActivationState.Payment.Authorization.displayName = 'proto.customer_service.ActivationState.Payment.Authorization';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ActivationState.Subscription = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ActivationState.Subscription, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ActivationState.Subscription.displayName = 'proto.customer_service.ActivationState.Subscription';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.QualificationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.QualificationRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.QualificationRequest.displayName = 'proto.customer_service.QualificationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.QualificationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.QualificationResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.QualificationResponse.displayName = 'proto.customer_service.QualificationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.CustomerIdentity = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.CustomerIdentity, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.CustomerIdentity.displayName = 'proto.customer_service.CustomerIdentity';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SetActivityRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SetActivityRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SetActivityRequest.displayName = 'proto.customer_service.SetActivityRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SetActivityResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SetActivityResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SetActivityResponse.displayName = 'proto.customer_service.SetActivityResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetSelfRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetSelfRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetSelfRequest.displayName = 'proto.customer_service.GetSelfRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetSelfResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetSelfResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetSelfResponse.displayName = 'proto.customer_service.GetSelfResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetStateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetStateRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetStateRequest.displayName = 'proto.customer_service.GetStateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetStateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetStateResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetStateResponse.displayName = 'proto.customer_service.GetStateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetOwnAddressesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetOwnAddressesRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetOwnAddressesRequest.displayName = 'proto.customer_service.GetOwnAddressesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetAddressesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetAddressesRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetAddressesRequest.displayName = 'proto.customer_service.GetAddressesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetAddressesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.GetAddressesResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetAddressesResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetAddressesResponse.displayName = 'proto.customer_service.GetAddressesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetInsurancePoliciesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetInsurancePoliciesRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetInsurancePoliciesRequest.displayName = 'proto.customer_service.GetInsurancePoliciesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetInsurancePoliciesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.GetInsurancePoliciesResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetInsurancePoliciesResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetInsurancePoliciesResponse.displayName = 'proto.customer_service.GetInsurancePoliciesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetImagesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetImagesRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetImagesRequest.displayName = 'proto.customer_service.GetImagesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetImagesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.GetImagesResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetImagesResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetImagesResponse.displayName = 'proto.customer_service.GetImagesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpdateEmailRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpdateEmailRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpdateEmailRequest.displayName = 'proto.customer_service.UpdateEmailRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpdateEmailResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpdateEmailResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpdateEmailResponse.displayName = 'proto.customer_service.UpdateEmailResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpsertInsurancePoliciesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.UpsertInsurancePoliciesRequest.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpsertInsurancePoliciesRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpsertInsurancePoliciesRequest.displayName = 'proto.customer_service.UpsertInsurancePoliciesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpsertInsurancePoliciesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpsertInsurancePoliciesResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpsertInsurancePoliciesResponse.displayName = 'proto.customer_service.UpsertInsurancePoliciesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpsertOwnAddressesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.UpsertOwnAddressesRequest.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpsertOwnAddressesRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpsertOwnAddressesRequest.displayName = 'proto.customer_service.UpsertOwnAddressesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpsertAddressesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.UpsertAddressesRequest.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpsertAddressesRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpsertAddressesRequest.displayName = 'proto.customer_service.UpsertAddressesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpsertAddressesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpsertAddressesResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpsertAddressesResponse.displayName = 'proto.customer_service.UpsertAddressesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ValidateClientRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ValidateClientRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ValidateClientRequest.displayName = 'proto.customer_service.ValidateClientRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ValidateClientResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ValidateClientResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ValidateClientResponse.displayName = 'proto.customer_service.ValidateClientResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SendOTPRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SendOTPRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SendOTPRequest.displayName = 'proto.customer_service.SendOTPRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SendOTPResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SendOTPResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SendOTPResponse.displayName = 'proto.customer_service.SendOTPResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.VerifyOTPRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.VerifyOTPRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.VerifyOTPRequest.displayName = 'proto.customer_service.VerifyOTPRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.VerifyOTPResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.VerifyOTPResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.VerifyOTPResponse.displayName = 'proto.customer_service.VerifyOTPResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SubmitLicenseInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SubmitLicenseInfoRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SubmitLicenseInfoRequest.displayName = 'proto.customer_service.SubmitLicenseInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SubmitLicenseInfoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SubmitLicenseInfoResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SubmitLicenseInfoResponse.displayName = 'proto.customer_service.SubmitLicenseInfoResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SubmitSelfiePhotoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SubmitSelfiePhotoRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SubmitSelfiePhotoRequest.displayName = 'proto.customer_service.SubmitSelfiePhotoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SubmitSelfiePhotoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SubmitSelfiePhotoResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SubmitSelfiePhotoResponse.displayName = 'proto.customer_service.SubmitSelfiePhotoResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SubmitLicensePhotosRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SubmitLicensePhotosRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SubmitLicensePhotosRequest.displayName = 'proto.customer_service.SubmitLicensePhotosRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SubmitLicensePhotosResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SubmitLicensePhotosResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SubmitLicensePhotosResponse.displayName = 'proto.customer_service.SubmitLicensePhotosResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetImageUploadURIRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetImageUploadURIRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetImageUploadURIRequest.displayName = 'proto.customer_service.GetImageUploadURIRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetImageUploadURIResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetImageUploadURIResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetImageUploadURIResponse.displayName = 'proto.customer_service.GetImageUploadURIResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.RequestMfaRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.RequestMfaRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.RequestMfaRequest.displayName = 'proto.customer_service.RequestMfaRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.RequestMfaResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.RequestMfaResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.RequestMfaResponse.displayName = 'proto.customer_service.RequestMfaResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.CustomerProjectionMeta = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.CustomerProjectionMeta.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.CustomerProjectionMeta, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.CustomerProjectionMeta.displayName = 'proto.customer_service.CustomerProjectionMeta';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ExistsByPhoneRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ExistsByPhoneRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ExistsByPhoneRequest.displayName = 'proto.customer_service.ExistsByPhoneRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ExistsByPhoneResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ExistsByPhoneResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ExistsByPhoneResponse.displayName = 'proto.customer_service.ExistsByPhoneResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.RecalculateQualificationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.RecalculateQualificationRequest.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.RecalculateQualificationRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.RecalculateQualificationRequest.displayName = 'proto.customer_service.RecalculateQualificationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.RecalculateQualificationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.RecalculateQualificationResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.RecalculateQualificationResponse.displayName = 'proto.customer_service.RecalculateQualificationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetSecurityDepositAmountRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetSecurityDepositAmountRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetSecurityDepositAmountRequest.displayName = 'proto.customer_service.GetSecurityDepositAmountRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetSecurityDepositAmountResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetSecurityDepositAmountResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetSecurityDepositAmountResponse.displayName = 'proto.customer_service.GetSecurityDepositAmountResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.OverrideQualificationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.OverrideQualificationRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.OverrideQualificationRequest.displayName = 'proto.customer_service.OverrideQualificationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.OverrideQualificationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.OverrideQualificationResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.OverrideQualificationResponse.displayName = 'proto.customer_service.OverrideQualificationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetNotesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetNotesRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetNotesRequest.displayName = 'proto.customer_service.GetNotesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.RecalculateCustomerScoresRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.RecalculateCustomerScoresRequest.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.RecalculateCustomerScoresRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.RecalculateCustomerScoresRequest.displayName = 'proto.customer_service.RecalculateCustomerScoresRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.RecalculateCustomerScoresResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.RecalculateCustomerScoresResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.RecalculateCustomerScoresResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.RecalculateCustomerScoresResponse.displayName = 'proto.customer_service.RecalculateCustomerScoresResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerQualificationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerQualificationRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerQualificationRequest.displayName = 'proto.customer_service.GetCustomerQualificationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerQualificationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerQualificationResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerQualificationResponse.displayName = 'proto.customer_service.GetCustomerQualificationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerByIDRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerByIDRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerByIDRequest.displayName = 'proto.customer_service.GetCustomerByIDRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerByIDResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerByIDResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerByIDResponse.displayName = 'proto.customer_service.GetCustomerByIDResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerByPhoneRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerByPhoneRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerByPhoneRequest.displayName = 'proto.customer_service.GetCustomerByPhoneRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerByPhoneResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerByPhoneResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerByPhoneResponse.displayName = 'proto.customer_service.GetCustomerByPhoneResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetAllCustomersByPhoneRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetAllCustomersByPhoneRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetAllCustomersByPhoneRequest.displayName = 'proto.customer_service.GetAllCustomersByPhoneRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetAllCustomersByPhoneResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.GetAllCustomersByPhoneResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetAllCustomersByPhoneResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetAllCustomersByPhoneResponse.displayName = 'proto.customer_service.GetAllCustomersByPhoneResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.displayName = 'proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.CreateCustomerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.CreateCustomerRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.CreateCustomerRequest.displayName = 'proto.customer_service.CreateCustomerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.CreateCustomerResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.CreateCustomerResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.CreateCustomerResponse.displayName = 'proto.customer_service.CreateCustomerResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpdateCustomerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpdateCustomerRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpdateCustomerRequest.displayName = 'proto.customer_service.UpdateCustomerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpdateCustomerResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpdateCustomerResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpdateCustomerResponse.displayName = 'proto.customer_service.UpdateCustomerResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpdateCustomerWithFakePhoneRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.displayName = 'proto.customer_service.UpdateCustomerWithFakePhoneRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpdateCustomerWithFakePhoneResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpdateCustomerWithFakePhoneResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpdateCustomerWithFakePhoneResponse.displayName = 'proto.customer_service.UpdateCustomerWithFakePhoneResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ScrubCustomerInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ScrubCustomerInfoRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ScrubCustomerInfoRequest.displayName = 'proto.customer_service.ScrubCustomerInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ScrubCustomerInfoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ScrubCustomerInfoResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ScrubCustomerInfoResponse.displayName = 'proto.customer_service.ScrubCustomerInfoResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.InitProjectionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.InitProjectionsRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.InitProjectionsRequest.displayName = 'proto.customer_service.InitProjectionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.InitProjectionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.InitProjectionsResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.InitProjectionsResponse.displayName = 'proto.customer_service.InitProjectionsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.RefreshAuthIDRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.RefreshAuthIDRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.RefreshAuthIDRequest.displayName = 'proto.customer_service.RefreshAuthIDRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.RefreshAuthIDResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.RefreshAuthIDResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.RefreshAuthIDResponse.displayName = 'proto.customer_service.RefreshAuthIDResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCQEScoresRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCQEScoresRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCQEScoresRequest.displayName = 'proto.customer_service.GetCQEScoresRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCQEScoresResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.GetCQEScoresResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCQEScoresResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCQEScoresResponse.displayName = 'proto.customer_service.GetCQEScoresResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SendDeepLinkRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SendDeepLinkRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SendDeepLinkRequest.displayName = 'proto.customer_service.SendDeepLinkRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SendDeepLinkRequest.MarketingMetaData, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.displayName = 'proto.customer_service.SendDeepLinkRequest.MarketingMetaData';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.SendDeepLinkResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.SendDeepLinkResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.SendDeepLinkResponse.displayName = 'proto.customer_service.SendDeepLinkResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.OptIntoSMSRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.OptIntoSMSRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.OptIntoSMSRequest.displayName = 'proto.customer_service.OptIntoSMSRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.OptIntoSMSResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.OptIntoSMSResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.OptIntoSMSResponse.displayName = 'proto.customer_service.OptIntoSMSResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.TrackCustomerInAppsFlyerRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.TrackCustomerInAppsFlyerRequest.displayName = 'proto.customer_service.TrackCustomerInAppsFlyerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.TrackCustomerInAppsFlyerResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.TrackCustomerInAppsFlyerResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.TrackCustomerInAppsFlyerResponse.displayName = 'proto.customer_service.TrackCustomerInAppsFlyerResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.Customer = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.Customer, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.Customer.displayName = 'proto.customer_service.Customer';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ListCustomersRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ListCustomersRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ListCustomersRequest.displayName = 'proto.customer_service.ListCustomersRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ListCustomersResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.ListCustomersResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ListCustomersResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ListCustomersResponse.displayName = 'proto.customer_service.ListCustomersResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.DecryptCustomerDataRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.DecryptCustomerDataRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.DecryptCustomerDataRequest.displayName = 'proto.customer_service.DecryptCustomerDataRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.DecryptCustomerDataResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.DecryptCustomerDataResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.DecryptCustomerDataResponse.displayName = 'proto.customer_service.DecryptCustomerDataResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerByAccountNumberRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerByAccountNumberRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerByAccountNumberRequest.displayName = 'proto.customer_service.GetCustomerByAccountNumberRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetCustomerByAccountNumberResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetCustomerByAccountNumberResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetCustomerByAccountNumberResponse.displayName = 'proto.customer_service.GetCustomerByAccountNumberResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ListClientsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ListClientsRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ListClientsRequest.displayName = 'proto.customer_service.ListClientsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ListClientsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_service.ListClientsResponse.repeatedFields_, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ListClientsResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ListClientsResponse.displayName = 'proto.customer_service.ListClientsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.Client = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.Client, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.Client.displayName = 'proto.customer_service.Client';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ChangeCustomerClientIdRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ChangeCustomerClientIdRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ChangeCustomerClientIdRequest.displayName = 'proto.customer_service.ChangeCustomerClientIdRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ChangeCustomerClientIdResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ChangeCustomerClientIdResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ChangeCustomerClientIdResponse.displayName = 'proto.customer_service.ChangeCustomerClientIdResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpdateAutoPayAuthorizationRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpdateAutoPayAuthorizationRequest.displayName = 'proto.customer_service.UpdateAutoPayAuthorizationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.UpdateAutoPayAuthorizationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.UpdateAutoPayAuthorizationResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.UpdateAutoPayAuthorizationResponse.displayName = 'proto.customer_service.UpdateAutoPayAuthorizationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetAutoPayAuthorizationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetAutoPayAuthorizationRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetAutoPayAuthorizationRequest.displayName = 'proto.customer_service.GetAutoPayAuthorizationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.GetAutoPayAuthorizationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.GetAutoPayAuthorizationResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.GetAutoPayAuthorizationResponse.displayName = 'proto.customer_service.GetAutoPayAuthorizationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ImportDocumentDataRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ImportDocumentDataRequest, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ImportDocumentDataRequest.displayName = 'proto.customer_service.ImportDocumentDataRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_service.ImportDocumentDataResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$4d6e9e4d0144e462$var$goog.inherits(proto.customer_service.ImportDocumentDataResponse, $8M67s.Message);
if ($4d6e9e4d0144e462$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_service.ImportDocumentDataResponse.displayName = 'proto.customer_service.ImportDocumentDataResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SyncCustomerNamesFromLicenseRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SyncCustomerNamesFromLicenseRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SyncCustomerNamesFromLicenseRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SyncCustomerNamesFromLicenseRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SyncCustomerNamesFromLicenseRequest}
 */ proto.customer_service.SyncCustomerNamesFromLicenseRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SyncCustomerNamesFromLicenseRequest;
    return proto.customer_service.SyncCustomerNamesFromLicenseRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SyncCustomerNamesFromLicenseRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SyncCustomerNamesFromLicenseRequest}
 */ proto.customer_service.SyncCustomerNamesFromLicenseRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SyncCustomerNamesFromLicenseRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SyncCustomerNamesFromLicenseRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SyncCustomerNamesFromLicenseRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SyncCustomerNamesFromLicenseRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SyncCustomerNamesFromLicenseResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SyncCustomerNamesFromLicenseResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SyncCustomerNamesFromLicenseResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SyncCustomerNamesFromLicenseResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SyncCustomerNamesFromLicenseResponse}
 */ proto.customer_service.SyncCustomerNamesFromLicenseResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SyncCustomerNamesFromLicenseResponse;
    return proto.customer_service.SyncCustomerNamesFromLicenseResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SyncCustomerNamesFromLicenseResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SyncCustomerNamesFromLicenseResponse}
 */ proto.customer_service.SyncCustomerNamesFromLicenseResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SyncCustomerNamesFromLicenseResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SyncCustomerNamesFromLicenseResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SyncCustomerNamesFromLicenseResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SyncCustomerNamesFromLicenseResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ResetLoginAttemptsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ResetLoginAttemptsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ResetLoginAttemptsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ResetLoginAttemptsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ResetLoginAttemptsRequest}
 */ proto.customer_service.ResetLoginAttemptsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ResetLoginAttemptsRequest;
    return proto.customer_service.ResetLoginAttemptsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ResetLoginAttemptsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ResetLoginAttemptsRequest}
 */ proto.customer_service.ResetLoginAttemptsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ResetLoginAttemptsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ResetLoginAttemptsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ResetLoginAttemptsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ResetLoginAttemptsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string phone_number = 1;
 * @return {string}
 */ proto.customer_service.ResetLoginAttemptsRequest.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ResetLoginAttemptsRequest} returns this
 */ proto.customer_service.ResetLoginAttemptsRequest.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.customer_service.ResetLoginAttemptsRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ResetLoginAttemptsRequest} returns this
 */ proto.customer_service.ResetLoginAttemptsRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string account_number = 3;
 * @return {string}
 */ proto.customer_service.ResetLoginAttemptsRequest.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ResetLoginAttemptsRequest} returns this
 */ proto.customer_service.ResetLoginAttemptsRequest.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ResetLoginAttemptsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ResetLoginAttemptsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ResetLoginAttemptsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ResetLoginAttemptsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ResetLoginAttemptsResponse}
 */ proto.customer_service.ResetLoginAttemptsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ResetLoginAttemptsResponse;
    return proto.customer_service.ResetLoginAttemptsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ResetLoginAttemptsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ResetLoginAttemptsResponse}
 */ proto.customer_service.ResetLoginAttemptsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ResetLoginAttemptsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ResetLoginAttemptsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ResetLoginAttemptsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ResetLoginAttemptsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerBankInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerBankInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerBankInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerBankInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerBankInfoRequest}
 */ proto.customer_service.GetCustomerBankInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerBankInfoRequest;
    return proto.customer_service.GetCustomerBankInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerBankInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerBankInfoRequest}
 */ proto.customer_service.GetCustomerBankInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerBankInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerBankInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerBankInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerBankInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetCustomerBankInfoRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetCustomerBankInfoRequest} returns this
 */ proto.customer_service.GetCustomerBankInfoRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.GetCustomerBankInfoResponse.repeatedFields_ = [
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerBankInfoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerBankInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerBankInfoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            routingNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            balanceCents: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            addressesList: $8M67s.Message.toObjectList(msg.getAddressesList(), $3QqPt.Address.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerBankInfoResponse}
 */ proto.customer_service.GetCustomerBankInfoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerBankInfoResponse;
    return proto.customer_service.GetCustomerBankInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerBankInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerBankInfoResponse}
 */ proto.customer_service.GetCustomerBankInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setRoutingNumber(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBalanceCents(value);
                break;
            case 4:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.addAddresses(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerBankInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerBankInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerBankInfoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getRoutingNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getBalanceCents();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getAddressesList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, $3QqPt.Address.serializeBinaryToWriter);
};
/**
 * optional string account_number = 1;
 * @return {string}
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetCustomerBankInfoResponse} returns this
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string routing_number = 2;
 * @return {string}
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.getRoutingNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetCustomerBankInfoResponse} returns this
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.setRoutingNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 balance_cents = 3;
 * @return {number}
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.getBalanceCents = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.GetCustomerBankInfoResponse} returns this
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.setBalanceCents = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * repeated domain.Address addresses = 4;
 * @return {!Array<!proto.domain.Address>}
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.getAddressesList = function() {
    return /** @type{!Array<!proto.domain.Address>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Address, 4);
};
/**
 * @param {!Array<!proto.domain.Address>} value
 * @return {!proto.customer_service.GetCustomerBankInfoResponse} returns this
*/ proto.customer_service.GetCustomerBankInfoResponse.prototype.setAddressesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.domain.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Address}
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.addAddresses = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.domain.Address, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.GetCustomerBankInfoResponse} returns this
 */ proto.customer_service.GetCustomerBankInfoResponse.prototype.clearAddressesList = function() {
    return this.setAddressesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SubscribeToActivationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SubscribeToActivationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SubscribeToActivationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubscribeToActivationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SubscribeToActivationRequest}
 */ proto.customer_service.SubscribeToActivationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SubscribeToActivationRequest;
    return proto.customer_service.SubscribeToActivationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SubscribeToActivationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SubscribeToActivationRequest}
 */ proto.customer_service.SubscribeToActivationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SubscribeToActivationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SubscribeToActivationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SubscribeToActivationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubscribeToActivationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ActivationState.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ActivationState.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ActivationState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            qualification: (f = msg.getQualification()) && proto.customer_service.ActivationState.Qualification.toObject(includeInstance, f),
            contract: (f = msg.getContract()) && proto.customer_service.ActivationState.Contract.toObject(includeInstance, f),
            payment: (f = msg.getPayment()) && proto.customer_service.ActivationState.Payment.toObject(includeInstance, f),
            subscription: (f = msg.getSubscription()) && proto.customer_service.ActivationState.Subscription.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ActivationState}
 */ proto.customer_service.ActivationState.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ActivationState;
    return proto.customer_service.ActivationState.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ActivationState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ActivationState}
 */ proto.customer_service.ActivationState.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new proto.customer_service.ActivationState.Qualification;
                reader.readMessage(value, proto.customer_service.ActivationState.Qualification.deserializeBinaryFromReader);
                msg.setQualification(value);
                break;
            case 3:
                var value = new proto.customer_service.ActivationState.Contract;
                reader.readMessage(value, proto.customer_service.ActivationState.Contract.deserializeBinaryFromReader);
                msg.setContract(value);
                break;
            case 4:
                var value = new proto.customer_service.ActivationState.Payment;
                reader.readMessage(value, proto.customer_service.ActivationState.Payment.deserializeBinaryFromReader);
                msg.setPayment(value);
                break;
            case 5:
                var value = new proto.customer_service.ActivationState.Subscription;
                reader.readMessage(value, proto.customer_service.ActivationState.Subscription.deserializeBinaryFromReader);
                msg.setSubscription(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ActivationState.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ActivationState.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ActivationState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getQualification();
    if (f != null) writer.writeMessage(2, f, proto.customer_service.ActivationState.Qualification.serializeBinaryToWriter);
    f = message.getContract();
    if (f != null) writer.writeMessage(3, f, proto.customer_service.ActivationState.Contract.serializeBinaryToWriter);
    f = message.getPayment();
    if (f != null) writer.writeMessage(4, f, proto.customer_service.ActivationState.Payment.serializeBinaryToWriter);
    f = message.getSubscription();
    if (f != null) writer.writeMessage(5, f, proto.customer_service.ActivationState.Subscription.serializeBinaryToWriter);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ActivationState.Qualification.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ActivationState.Qualification.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ActivationState.Qualification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Qualification.toObject = function(includeInstance, msg) {
        var f, obj = {
            tier: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ActivationState.Qualification}
 */ proto.customer_service.ActivationState.Qualification.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ActivationState.Qualification;
    return proto.customer_service.ActivationState.Qualification.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ActivationState.Qualification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ActivationState.Qualification}
 */ proto.customer_service.ActivationState.Qualification.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setTier(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ActivationState.Qualification.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ActivationState.Qualification.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ActivationState.Qualification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Qualification.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTier();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional domain.QualificationTier tier = 1;
 * @return {!proto.domain.QualificationTier}
 */ proto.customer_service.ActivationState.Qualification.prototype.getTier = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.customer_service.ActivationState.Qualification} returns this
 */ proto.customer_service.ActivationState.Qualification.prototype.setTier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ActivationState.Contract.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ActivationState.Contract.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ActivationState.Contract} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Contract.toObject = function(includeInstance, msg) {
        var f, obj = {
            status: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ActivationState.Contract}
 */ proto.customer_service.ActivationState.Contract.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ActivationState.Contract;
    return proto.customer_service.ActivationState.Contract.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ActivationState.Contract} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ActivationState.Contract}
 */ proto.customer_service.ActivationState.Contract.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.customer_service.ActivationState.Contract.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ActivationState.Contract.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ActivationState.Contract.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ActivationState.Contract} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Contract.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * @enum {number}
 */ proto.customer_service.ActivationState.Contract.Status = {
    PENDING_SIGNATURE: 0,
    SIGNED: 1
};
/**
 * optional Status status = 1;
 * @return {!proto.customer_service.ActivationState.Contract.Status}
 */ proto.customer_service.ActivationState.Contract.prototype.getStatus = function() {
    return /** @type {!proto.customer_service.ActivationState.Contract.Status} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.customer_service.ActivationState.Contract.Status} value
 * @return {!proto.customer_service.ActivationState.Contract} returns this
 */ proto.customer_service.ActivationState.Contract.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ActivationState.Payment.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ActivationState.Payment.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ActivationState.Payment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Payment.toObject = function(includeInstance, msg) {
        var f, obj = {
            driveOff: (f = msg.getDriveOff()) && proto.customer_service.ActivationState.Payment.DriveOff.toObject(includeInstance, f),
            authorization: (f = msg.getAuthorization()) && proto.customer_service.ActivationState.Payment.Authorization.toObject(includeInstance, f),
            paymentMethodsRequired: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ActivationState.Payment}
 */ proto.customer_service.ActivationState.Payment.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ActivationState.Payment;
    return proto.customer_service.ActivationState.Payment.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ActivationState.Payment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ActivationState.Payment}
 */ proto.customer_service.ActivationState.Payment.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_service.ActivationState.Payment.DriveOff;
                reader.readMessage(value, proto.customer_service.ActivationState.Payment.DriveOff.deserializeBinaryFromReader);
                msg.setDriveOff(value);
                break;
            case 2:
                var value = new proto.customer_service.ActivationState.Payment.Authorization;
                reader.readMessage(value, proto.customer_service.ActivationState.Payment.Authorization.deserializeBinaryFromReader);
                msg.setAuthorization(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPaymentMethodsRequired(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ActivationState.Payment.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ActivationState.Payment.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ActivationState.Payment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Payment.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDriveOff();
    if (f != null) writer.writeMessage(1, f, proto.customer_service.ActivationState.Payment.DriveOff.serializeBinaryToWriter);
    f = message.getAuthorization();
    if (f != null) writer.writeMessage(2, f, proto.customer_service.ActivationState.Payment.Authorization.serializeBinaryToWriter);
    f = message.getPaymentMethodsRequired();
    if (f !== 0) writer.writeInt32(3, f);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ActivationState.Payment.DriveOff.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ActivationState.Payment.DriveOff.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ActivationState.Payment.DriveOff} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Payment.DriveOff.toObject = function(includeInstance, msg) {
        var f, obj = {
            status: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ActivationState.Payment.DriveOff}
 */ proto.customer_service.ActivationState.Payment.DriveOff.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ActivationState.Payment.DriveOff;
    return proto.customer_service.ActivationState.Payment.DriveOff.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ActivationState.Payment.DriveOff} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ActivationState.Payment.DriveOff}
 */ proto.customer_service.ActivationState.Payment.DriveOff.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.customer_service.ActivationState.Payment.DriveOff.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ActivationState.Payment.DriveOff.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ActivationState.Payment.DriveOff.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ActivationState.Payment.DriveOff} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Payment.DriveOff.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * @enum {number}
 */ proto.customer_service.ActivationState.Payment.DriveOff.Status = {
    PENDING: 0,
    SUCCESS: 1,
    FAILURE: 2
};
/**
 * optional Status status = 1;
 * @return {!proto.customer_service.ActivationState.Payment.DriveOff.Status}
 */ proto.customer_service.ActivationState.Payment.DriveOff.prototype.getStatus = function() {
    return /** @type {!proto.customer_service.ActivationState.Payment.DriveOff.Status} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.customer_service.ActivationState.Payment.DriveOff.Status} value
 * @return {!proto.customer_service.ActivationState.Payment.DriveOff} returns this
 */ proto.customer_service.ActivationState.Payment.DriveOff.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ActivationState.Payment.Authorization.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ActivationState.Payment.Authorization.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ActivationState.Payment.Authorization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Payment.Authorization.toObject = function(includeInstance, msg) {
        var f, obj = {
            status: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ActivationState.Payment.Authorization}
 */ proto.customer_service.ActivationState.Payment.Authorization.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ActivationState.Payment.Authorization;
    return proto.customer_service.ActivationState.Payment.Authorization.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ActivationState.Payment.Authorization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ActivationState.Payment.Authorization}
 */ proto.customer_service.ActivationState.Payment.Authorization.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.customer_service.ActivationState.Payment.Authorization.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ActivationState.Payment.Authorization.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ActivationState.Payment.Authorization.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ActivationState.Payment.Authorization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Payment.Authorization.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * @enum {number}
 */ proto.customer_service.ActivationState.Payment.Authorization.Status = {
    PENDING: 0,
    SUCCESS: 1,
    FAILURE: 2
};
/**
 * optional Status status = 1;
 * @return {!proto.customer_service.ActivationState.Payment.Authorization.Status}
 */ proto.customer_service.ActivationState.Payment.Authorization.prototype.getStatus = function() {
    return /** @type {!proto.customer_service.ActivationState.Payment.Authorization.Status} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.customer_service.ActivationState.Payment.Authorization.Status} value
 * @return {!proto.customer_service.ActivationState.Payment.Authorization} returns this
 */ proto.customer_service.ActivationState.Payment.Authorization.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional DriveOff drive_off = 1;
 * @return {?proto.customer_service.ActivationState.Payment.DriveOff}
 */ proto.customer_service.ActivationState.Payment.prototype.getDriveOff = function() {
    return /** @type{?proto.customer_service.ActivationState.Payment.DriveOff} */ $8M67s.Message.getWrapperField(this, proto.customer_service.ActivationState.Payment.DriveOff, 1);
};
/**
 * @param {?proto.customer_service.ActivationState.Payment.DriveOff|undefined} value
 * @return {!proto.customer_service.ActivationState.Payment} returns this
*/ proto.customer_service.ActivationState.Payment.prototype.setDriveOff = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.ActivationState.Payment} returns this
 */ proto.customer_service.ActivationState.Payment.prototype.clearDriveOff = function() {
    return this.setDriveOff(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.ActivationState.Payment.prototype.hasDriveOff = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional Authorization authorization = 2;
 * @return {?proto.customer_service.ActivationState.Payment.Authorization}
 */ proto.customer_service.ActivationState.Payment.prototype.getAuthorization = function() {
    return /** @type{?proto.customer_service.ActivationState.Payment.Authorization} */ $8M67s.Message.getWrapperField(this, proto.customer_service.ActivationState.Payment.Authorization, 2);
};
/**
 * @param {?proto.customer_service.ActivationState.Payment.Authorization|undefined} value
 * @return {!proto.customer_service.ActivationState.Payment} returns this
*/ proto.customer_service.ActivationState.Payment.prototype.setAuthorization = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.ActivationState.Payment} returns this
 */ proto.customer_service.ActivationState.Payment.prototype.clearAuthorization = function() {
    return this.setAuthorization(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.ActivationState.Payment.prototype.hasAuthorization = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional int32 payment_methods_required = 3;
 * @return {number}
 */ proto.customer_service.ActivationState.Payment.prototype.getPaymentMethodsRequired = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.ActivationState.Payment} returns this
 */ proto.customer_service.ActivationState.Payment.prototype.setPaymentMethodsRequired = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ActivationState.Subscription.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ActivationState.Subscription.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ActivationState.Subscription} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Subscription.toObject = function(includeInstance, msg) {
        var f, obj = {
            status: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ActivationState.Subscription}
 */ proto.customer_service.ActivationState.Subscription.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ActivationState.Subscription;
    return proto.customer_service.ActivationState.Subscription.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ActivationState.Subscription} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ActivationState.Subscription}
 */ proto.customer_service.ActivationState.Subscription.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.customer_service.ActivationState.Subscription.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ActivationState.Subscription.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ActivationState.Subscription.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ActivationState.Subscription} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ActivationState.Subscription.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * @enum {number}
 */ proto.customer_service.ActivationState.Subscription.Status = {
    PENDING: 0,
    ACTIVATED: 1
};
/**
 * optional Status status = 1;
 * @return {!proto.customer_service.ActivationState.Subscription.Status}
 */ proto.customer_service.ActivationState.Subscription.prototype.getStatus = function() {
    return /** @type {!proto.customer_service.ActivationState.Subscription.Status} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.customer_service.ActivationState.Subscription.Status} value
 * @return {!proto.customer_service.ActivationState.Subscription} returns this
 */ proto.customer_service.ActivationState.Subscription.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.ActivationState.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ActivationState} returns this
 */ proto.customer_service.ActivationState.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Qualification qualification = 2;
 * @return {?proto.customer_service.ActivationState.Qualification}
 */ proto.customer_service.ActivationState.prototype.getQualification = function() {
    return /** @type{?proto.customer_service.ActivationState.Qualification} */ $8M67s.Message.getWrapperField(this, proto.customer_service.ActivationState.Qualification, 2);
};
/**
 * @param {?proto.customer_service.ActivationState.Qualification|undefined} value
 * @return {!proto.customer_service.ActivationState} returns this
*/ proto.customer_service.ActivationState.prototype.setQualification = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.ActivationState} returns this
 */ proto.customer_service.ActivationState.prototype.clearQualification = function() {
    return this.setQualification(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.ActivationState.prototype.hasQualification = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional Contract contract = 3;
 * @return {?proto.customer_service.ActivationState.Contract}
 */ proto.customer_service.ActivationState.prototype.getContract = function() {
    return /** @type{?proto.customer_service.ActivationState.Contract} */ $8M67s.Message.getWrapperField(this, proto.customer_service.ActivationState.Contract, 3);
};
/**
 * @param {?proto.customer_service.ActivationState.Contract|undefined} value
 * @return {!proto.customer_service.ActivationState} returns this
*/ proto.customer_service.ActivationState.prototype.setContract = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.ActivationState} returns this
 */ proto.customer_service.ActivationState.prototype.clearContract = function() {
    return this.setContract(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.ActivationState.prototype.hasContract = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional Payment payment = 4;
 * @return {?proto.customer_service.ActivationState.Payment}
 */ proto.customer_service.ActivationState.prototype.getPayment = function() {
    return /** @type{?proto.customer_service.ActivationState.Payment} */ $8M67s.Message.getWrapperField(this, proto.customer_service.ActivationState.Payment, 4);
};
/**
 * @param {?proto.customer_service.ActivationState.Payment|undefined} value
 * @return {!proto.customer_service.ActivationState} returns this
*/ proto.customer_service.ActivationState.prototype.setPayment = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.ActivationState} returns this
 */ proto.customer_service.ActivationState.prototype.clearPayment = function() {
    return this.setPayment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.ActivationState.prototype.hasPayment = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional Subscription subscription = 5;
 * @return {?proto.customer_service.ActivationState.Subscription}
 */ proto.customer_service.ActivationState.prototype.getSubscription = function() {
    return /** @type{?proto.customer_service.ActivationState.Subscription} */ $8M67s.Message.getWrapperField(this, proto.customer_service.ActivationState.Subscription, 5);
};
/**
 * @param {?proto.customer_service.ActivationState.Subscription|undefined} value
 * @return {!proto.customer_service.ActivationState} returns this
*/ proto.customer_service.ActivationState.prototype.setSubscription = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.ActivationState} returns this
 */ proto.customer_service.ActivationState.prototype.clearSubscription = function() {
    return this.setSubscription(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.ActivationState.prototype.hasSubscription = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.QualificationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.QualificationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.QualificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.QualificationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.QualificationRequest}
 */ proto.customer_service.QualificationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.QualificationRequest;
    return proto.customer_service.QualificationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.QualificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.QualificationRequest}
 */ proto.customer_service.QualificationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.QualificationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.QualificationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.QualificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.QualificationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.QualificationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.QualificationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.QualificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.QualificationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            qualificationTier: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.QualificationResponse}
 */ proto.customer_service.QualificationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.QualificationResponse;
    return proto.customer_service.QualificationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.QualificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.QualificationResponse}
 */ proto.customer_service.QualificationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setQualificationTier(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.QualificationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.QualificationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.QualificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.QualificationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getQualificationTier();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional domain.QualificationTier qualification_tier = 1;
 * @return {!proto.domain.QualificationTier}
 */ proto.customer_service.QualificationResponse.prototype.getQualificationTier = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.customer_service.QualificationResponse} returns this
 */ proto.customer_service.QualificationResponse.prototype.setQualificationTier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.CustomerIdentity.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.CustomerIdentity.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.CustomerIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.CustomerIdentity.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.CustomerIdentity}
 */ proto.customer_service.CustomerIdentity.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.CustomerIdentity;
    return proto.customer_service.CustomerIdentity.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.CustomerIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.CustomerIdentity}
 */ proto.customer_service.CustomerIdentity.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.CustomerIdentity.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.CustomerIdentity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.CustomerIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.CustomerIdentity.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.CustomerIdentity.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CustomerIdentity} returns this
 */ proto.customer_service.CustomerIdentity.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SetActivityRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SetActivityRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SetActivityRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SetActivityRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerActivity: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SetActivityRequest}
 */ proto.customer_service.SetActivityRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SetActivityRequest;
    return proto.customer_service.SetActivityRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SetActivityRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SetActivityRequest}
 */ proto.customer_service.SetActivityRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.CustomerActivity} */ reader.readEnum();
                msg.setCustomerActivity(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SetActivityRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SetActivityRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SetActivityRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SetActivityRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerActivity();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional domain.CustomerActivity customer_activity = 1;
 * @return {!proto.domain.CustomerActivity}
 */ proto.customer_service.SetActivityRequest.prototype.getCustomerActivity = function() {
    return /** @type {!proto.domain.CustomerActivity} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.CustomerActivity} value
 * @return {!proto.customer_service.SetActivityRequest} returns this
 */ proto.customer_service.SetActivityRequest.prototype.setCustomerActivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SetActivityResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SetActivityResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SetActivityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SetActivityResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SetActivityResponse}
 */ proto.customer_service.SetActivityResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SetActivityResponse;
    return proto.customer_service.SetActivityResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SetActivityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SetActivityResponse}
 */ proto.customer_service.SetActivityResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SetActivityResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SetActivityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SetActivityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SetActivityResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetSelfRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetSelfRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetSelfRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetSelfRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetSelfRequest}
 */ proto.customer_service.GetSelfRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetSelfRequest;
    return proto.customer_service.GetSelfRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetSelfRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetSelfRequest}
 */ proto.customer_service.GetSelfRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetSelfRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetSelfRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetSelfRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetSelfRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetSelfResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetSelfResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetSelfResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetSelfResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            language: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            licenseNumber: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            licenseExpirationDate: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            dateOfBirth: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            qualificationTier: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            paymentMethodsRequired: $8M67s.Message.getFieldWithDefault(msg, 13, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetSelfResponse}
 */ proto.customer_service.GetSelfResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetSelfResponse;
    return proto.customer_service.GetSelfResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetSelfResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetSelfResponse}
 */ proto.customer_service.GetSelfResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setLicenseNumber(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLicenseExpirationDate(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDateOfBirth(value);
                break;
            case 11:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setQualificationTier(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPaymentMethodsRequired(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetSelfResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetSelfResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetSelfResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetSelfResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getLanguage();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getLicenseNumber();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getLicenseExpirationDate();
    if (f !== 0) writer.writeInt64(9, f);
    f = message.getDateOfBirth();
    if (f !== 0) writer.writeInt64(10, f);
    f = message.getQualificationTier();
    if (f !== 0.0) writer.writeEnum(11, f);
    f = message.getPaymentMethodsRequired();
    if (f !== 0) writer.writeInt32(13, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetSelfResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account_number = 2;
 * @return {string}
 */ proto.customer_service.GetSelfResponse.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string first_name = 3;
 * @return {string}
 */ proto.customer_service.GetSelfResponse.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_name = 4;
 * @return {string}
 */ proto.customer_service.GetSelfResponse.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string language = 5;
 * @return {string}
 */ proto.customer_service.GetSelfResponse.prototype.getLanguage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setLanguage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string phone = 6;
 * @return {string}
 */ proto.customer_service.GetSelfResponse.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string email = 7;
 * @return {string}
 */ proto.customer_service.GetSelfResponse.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string license_number = 8;
 * @return {string}
 */ proto.customer_service.GetSelfResponse.prototype.getLicenseNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setLicenseNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional int64 license_expiration_date = 9;
 * @return {number}
 */ proto.customer_service.GetSelfResponse.prototype.getLicenseExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setLicenseExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int64 date_of_birth = 10;
 * @return {number}
 */ proto.customer_service.GetSelfResponse.prototype.getDateOfBirth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setDateOfBirth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional domain.QualificationTier qualification_tier = 11;
 * @return {!proto.domain.QualificationTier}
 */ proto.customer_service.GetSelfResponse.prototype.getQualificationTier = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setQualificationTier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 11, value);
};
/**
 * optional int32 payment_methods_required = 13;
 * @return {number}
 */ proto.customer_service.GetSelfResponse.prototype.getPaymentMethodsRequired = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.GetSelfResponse} returns this
 */ proto.customer_service.GetSelfResponse.prototype.setPaymentMethodsRequired = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetStateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetStateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetStateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetStateRequest}
 */ proto.customer_service.GetStateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetStateRequest;
    return proto.customer_service.GetStateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetStateRequest}
 */ proto.customer_service.GetStateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetStateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetStateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetStateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetStateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetStateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetStateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            state: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            activity: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            activityState: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            errorState: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            failureState: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetStateResponse}
 */ proto.customer_service.GetStateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetStateResponse;
    return proto.customer_service.GetStateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetStateResponse}
 */ proto.customer_service.GetStateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.CustomerState} */ reader.readEnum();
                msg.setState(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.CustomerActivity} */ reader.readEnum();
                msg.setActivity(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.ActivityState} */ reader.readEnum();
                msg.setActivityState(value);
                break;
            case 4:
                var value = /** @type {!proto.domain.CustomerErrorState} */ reader.readEnum();
                msg.setErrorState(value);
                break;
            case 5:
                var value = /** @type {!proto.domain.CustomerFailureState} */ reader.readEnum();
                msg.setFailureState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetStateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetStateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetStateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getState();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getActivity();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getActivityState();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getErrorState();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getFailureState();
    if (f !== 0.0) writer.writeEnum(5, f);
};
/**
 * optional domain.CustomerState state = 1;
 * @return {!proto.domain.CustomerState}
 */ proto.customer_service.GetStateResponse.prototype.getState = function() {
    return /** @type {!proto.domain.CustomerState} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.CustomerState} value
 * @return {!proto.customer_service.GetStateResponse} returns this
 */ proto.customer_service.GetStateResponse.prototype.setState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional domain.CustomerActivity activity = 2;
 * @return {!proto.domain.CustomerActivity}
 */ proto.customer_service.GetStateResponse.prototype.getActivity = function() {
    return /** @type {!proto.domain.CustomerActivity} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.CustomerActivity} value
 * @return {!proto.customer_service.GetStateResponse} returns this
 */ proto.customer_service.GetStateResponse.prototype.setActivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional domain.ActivityState activity_state = 3;
 * @return {!proto.domain.ActivityState}
 */ proto.customer_service.GetStateResponse.prototype.getActivityState = function() {
    return /** @type {!proto.domain.ActivityState} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.ActivityState} value
 * @return {!proto.customer_service.GetStateResponse} returns this
 */ proto.customer_service.GetStateResponse.prototype.setActivityState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional domain.CustomerErrorState error_state = 4;
 * @return {!proto.domain.CustomerErrorState}
 */ proto.customer_service.GetStateResponse.prototype.getErrorState = function() {
    return /** @type {!proto.domain.CustomerErrorState} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.domain.CustomerErrorState} value
 * @return {!proto.customer_service.GetStateResponse} returns this
 */ proto.customer_service.GetStateResponse.prototype.setErrorState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional domain.CustomerFailureState failure_state = 5;
 * @return {!proto.domain.CustomerFailureState}
 */ proto.customer_service.GetStateResponse.prototype.getFailureState = function() {
    return /** @type {!proto.domain.CustomerFailureState} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.domain.CustomerFailureState} value
 * @return {!proto.customer_service.GetStateResponse} returns this
 */ proto.customer_service.GetStateResponse.prototype.setFailureState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetOwnAddressesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetOwnAddressesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetOwnAddressesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetOwnAddressesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetOwnAddressesRequest}
 */ proto.customer_service.GetOwnAddressesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetOwnAddressesRequest;
    return proto.customer_service.GetOwnAddressesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetOwnAddressesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetOwnAddressesRequest}
 */ proto.customer_service.GetOwnAddressesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetOwnAddressesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetOwnAddressesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetOwnAddressesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetOwnAddressesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetAddressesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetAddressesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetAddressesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAddressesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetAddressesRequest}
 */ proto.customer_service.GetAddressesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetAddressesRequest;
    return proto.customer_service.GetAddressesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetAddressesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetAddressesRequest}
 */ proto.customer_service.GetAddressesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetAddressesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetAddressesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetAddressesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAddressesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetAddressesRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetAddressesRequest} returns this
 */ proto.customer_service.GetAddressesRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.GetAddressesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetAddressesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetAddressesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetAddressesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAddressesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressesList: $8M67s.Message.toObjectList(msg.getAddressesList(), $3QqPt.Address.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetAddressesResponse}
 */ proto.customer_service.GetAddressesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetAddressesResponse;
    return proto.customer_service.GetAddressesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetAddressesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetAddressesResponse}
 */ proto.customer_service.GetAddressesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.addAddresses(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetAddressesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetAddressesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetAddressesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAddressesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.Address.serializeBinaryToWriter);
};
/**
 * repeated domain.Address addresses = 1;
 * @return {!Array<!proto.domain.Address>}
 */ proto.customer_service.GetAddressesResponse.prototype.getAddressesList = function() {
    return /** @type{!Array<!proto.domain.Address>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Address, 1);
};
/**
 * @param {!Array<!proto.domain.Address>} value
 * @return {!proto.customer_service.GetAddressesResponse} returns this
*/ proto.customer_service.GetAddressesResponse.prototype.setAddressesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Address}
 */ proto.customer_service.GetAddressesResponse.prototype.addAddresses = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.Address, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.GetAddressesResponse} returns this
 */ proto.customer_service.GetAddressesResponse.prototype.clearAddressesList = function() {
    return this.setAddressesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetInsurancePoliciesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetInsurancePoliciesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetInsurancePoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetInsurancePoliciesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetInsurancePoliciesRequest}
 */ proto.customer_service.GetInsurancePoliciesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetInsurancePoliciesRequest;
    return proto.customer_service.GetInsurancePoliciesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetInsurancePoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetInsurancePoliciesRequest}
 */ proto.customer_service.GetInsurancePoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetInsurancePoliciesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetInsurancePoliciesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetInsurancePoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetInsurancePoliciesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.GetInsurancePoliciesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetInsurancePoliciesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetInsurancePoliciesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetInsurancePoliciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetInsurancePoliciesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            insurancePoliciesList: $8M67s.Message.toObjectList(msg.getInsurancePoliciesList(), $3QqPt.InsurancePolicy.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetInsurancePoliciesResponse}
 */ proto.customer_service.GetInsurancePoliciesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetInsurancePoliciesResponse;
    return proto.customer_service.GetInsurancePoliciesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetInsurancePoliciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetInsurancePoliciesResponse}
 */ proto.customer_service.GetInsurancePoliciesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.InsurancePolicy;
                reader.readMessage(value, $3QqPt.InsurancePolicy.deserializeBinaryFromReader);
                msg.addInsurancePolicies(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetInsurancePoliciesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetInsurancePoliciesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetInsurancePoliciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetInsurancePoliciesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInsurancePoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.InsurancePolicy.serializeBinaryToWriter);
};
/**
 * repeated domain.InsurancePolicy insurance_policies = 1;
 * @return {!Array<!proto.domain.InsurancePolicy>}
 */ proto.customer_service.GetInsurancePoliciesResponse.prototype.getInsurancePoliciesList = function() {
    return /** @type{!Array<!proto.domain.InsurancePolicy>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.InsurancePolicy, 1);
};
/**
 * @param {!Array<!proto.domain.InsurancePolicy>} value
 * @return {!proto.customer_service.GetInsurancePoliciesResponse} returns this
*/ proto.customer_service.GetInsurancePoliciesResponse.prototype.setInsurancePoliciesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.InsurancePolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.InsurancePolicy}
 */ proto.customer_service.GetInsurancePoliciesResponse.prototype.addInsurancePolicies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.InsurancePolicy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.GetInsurancePoliciesResponse} returns this
 */ proto.customer_service.GetInsurancePoliciesResponse.prototype.clearInsurancePoliciesList = function() {
    return this.setInsurancePoliciesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetImagesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetImagesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetImagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetImagesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetImagesRequest}
 */ proto.customer_service.GetImagesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetImagesRequest;
    return proto.customer_service.GetImagesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetImagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetImagesRequest}
 */ proto.customer_service.GetImagesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetImagesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetImagesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetImagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetImagesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.GetImagesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetImagesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetImagesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetImagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetImagesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            imagesList: $8M67s.Message.toObjectList(msg.getImagesList(), $3QqPt.Image.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetImagesResponse}
 */ proto.customer_service.GetImagesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetImagesResponse;
    return proto.customer_service.GetImagesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetImagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetImagesResponse}
 */ proto.customer_service.GetImagesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Image;
                reader.readMessage(value, $3QqPt.Image.deserializeBinaryFromReader);
                msg.addImages(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetImagesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetImagesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetImagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetImagesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getImagesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.Image.serializeBinaryToWriter);
};
/**
 * repeated domain.Image images = 1;
 * @return {!Array<!proto.domain.Image>}
 */ proto.customer_service.GetImagesResponse.prototype.getImagesList = function() {
    return /** @type{!Array<!proto.domain.Image>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Image, 1);
};
/**
 * @param {!Array<!proto.domain.Image>} value
 * @return {!proto.customer_service.GetImagesResponse} returns this
*/ proto.customer_service.GetImagesResponse.prototype.setImagesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Image}
 */ proto.customer_service.GetImagesResponse.prototype.addImages = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.Image, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.GetImagesResponse} returns this
 */ proto.customer_service.GetImagesResponse.prototype.clearImagesList = function() {
    return this.setImagesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpdateEmailRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpdateEmailRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpdateEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateEmailRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            email: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpdateEmailRequest}
 */ proto.customer_service.UpdateEmailRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpdateEmailRequest;
    return proto.customer_service.UpdateEmailRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpdateEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpdateEmailRequest}
 */ proto.customer_service.UpdateEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpdateEmailRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpdateEmailRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpdateEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateEmailRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getEmail();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string email = 1;
 * @return {string}
 */ proto.customer_service.UpdateEmailRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpdateEmailRequest} returns this
 */ proto.customer_service.UpdateEmailRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpdateEmailResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpdateEmailResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpdateEmailResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateEmailResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpdateEmailResponse}
 */ proto.customer_service.UpdateEmailResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpdateEmailResponse;
    return proto.customer_service.UpdateEmailResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpdateEmailResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpdateEmailResponse}
 */ proto.customer_service.UpdateEmailResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpdateEmailResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpdateEmailResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpdateEmailResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateEmailResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.UpsertInsurancePoliciesRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpsertInsurancePoliciesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpsertInsurancePoliciesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpsertInsurancePoliciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertInsurancePoliciesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            insurancePoliciesList: $8M67s.Message.toObjectList(msg.getInsurancePoliciesList(), $3QqPt.InsurancePolicy.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpsertInsurancePoliciesRequest}
 */ proto.customer_service.UpsertInsurancePoliciesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpsertInsurancePoliciesRequest;
    return proto.customer_service.UpsertInsurancePoliciesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpsertInsurancePoliciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpsertInsurancePoliciesRequest}
 */ proto.customer_service.UpsertInsurancePoliciesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.InsurancePolicy;
                reader.readMessage(value, $3QqPt.InsurancePolicy.deserializeBinaryFromReader);
                msg.addInsurancePolicies(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpsertInsurancePoliciesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpsertInsurancePoliciesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpsertInsurancePoliciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertInsurancePoliciesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInsurancePoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.InsurancePolicy.serializeBinaryToWriter);
};
/**
 * repeated domain.InsurancePolicy insurance_policies = 1;
 * @return {!Array<!proto.domain.InsurancePolicy>}
 */ proto.customer_service.UpsertInsurancePoliciesRequest.prototype.getInsurancePoliciesList = function() {
    return /** @type{!Array<!proto.domain.InsurancePolicy>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.InsurancePolicy, 1);
};
/**
 * @param {!Array<!proto.domain.InsurancePolicy>} value
 * @return {!proto.customer_service.UpsertInsurancePoliciesRequest} returns this
*/ proto.customer_service.UpsertInsurancePoliciesRequest.prototype.setInsurancePoliciesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.InsurancePolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.InsurancePolicy}
 */ proto.customer_service.UpsertInsurancePoliciesRequest.prototype.addInsurancePolicies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.InsurancePolicy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.UpsertInsurancePoliciesRequest} returns this
 */ proto.customer_service.UpsertInsurancePoliciesRequest.prototype.clearInsurancePoliciesList = function() {
    return this.setInsurancePoliciesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpsertInsurancePoliciesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpsertInsurancePoliciesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpsertInsurancePoliciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertInsurancePoliciesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpsertInsurancePoliciesResponse}
 */ proto.customer_service.UpsertInsurancePoliciesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpsertInsurancePoliciesResponse;
    return proto.customer_service.UpsertInsurancePoliciesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpsertInsurancePoliciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpsertInsurancePoliciesResponse}
 */ proto.customer_service.UpsertInsurancePoliciesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpsertInsurancePoliciesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpsertInsurancePoliciesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpsertInsurancePoliciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertInsurancePoliciesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.UpsertOwnAddressesRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpsertOwnAddressesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpsertOwnAddressesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpsertOwnAddressesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertOwnAddressesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressesList: $8M67s.Message.toObjectList(msg.getAddressesList(), $3QqPt.Address.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpsertOwnAddressesRequest}
 */ proto.customer_service.UpsertOwnAddressesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpsertOwnAddressesRequest;
    return proto.customer_service.UpsertOwnAddressesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpsertOwnAddressesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpsertOwnAddressesRequest}
 */ proto.customer_service.UpsertOwnAddressesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.addAddresses(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpsertOwnAddressesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpsertOwnAddressesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpsertOwnAddressesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertOwnAddressesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.Address.serializeBinaryToWriter);
};
/**
 * repeated domain.Address addresses = 1;
 * @return {!Array<!proto.domain.Address>}
 */ proto.customer_service.UpsertOwnAddressesRequest.prototype.getAddressesList = function() {
    return /** @type{!Array<!proto.domain.Address>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Address, 1);
};
/**
 * @param {!Array<!proto.domain.Address>} value
 * @return {!proto.customer_service.UpsertOwnAddressesRequest} returns this
*/ proto.customer_service.UpsertOwnAddressesRequest.prototype.setAddressesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Address}
 */ proto.customer_service.UpsertOwnAddressesRequest.prototype.addAddresses = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.Address, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.UpsertOwnAddressesRequest} returns this
 */ proto.customer_service.UpsertOwnAddressesRequest.prototype.clearAddressesList = function() {
    return this.setAddressesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.UpsertAddressesRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpsertAddressesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpsertAddressesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpsertAddressesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertAddressesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            addressesList: $8M67s.Message.toObjectList(msg.getAddressesList(), $3QqPt.Address.toObject, includeInstance),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpsertAddressesRequest}
 */ proto.customer_service.UpsertAddressesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpsertAddressesRequest;
    return proto.customer_service.UpsertAddressesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpsertAddressesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpsertAddressesRequest}
 */ proto.customer_service.UpsertAddressesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.addAddresses(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpsertAddressesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpsertAddressesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpsertAddressesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertAddressesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddressesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * repeated domain.Address addresses = 1;
 * @return {!Array<!proto.domain.Address>}
 */ proto.customer_service.UpsertAddressesRequest.prototype.getAddressesList = function() {
    return /** @type{!Array<!proto.domain.Address>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Address, 1);
};
/**
 * @param {!Array<!proto.domain.Address>} value
 * @return {!proto.customer_service.UpsertAddressesRequest} returns this
*/ proto.customer_service.UpsertAddressesRequest.prototype.setAddressesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Address}
 */ proto.customer_service.UpsertAddressesRequest.prototype.addAddresses = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.Address, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.UpsertAddressesRequest} returns this
 */ proto.customer_service.UpsertAddressesRequest.prototype.clearAddressesList = function() {
    return this.setAddressesList([]);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.customer_service.UpsertAddressesRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpsertAddressesRequest} returns this
 */ proto.customer_service.UpsertAddressesRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpsertAddressesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpsertAddressesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpsertAddressesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertAddressesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpsertAddressesResponse}
 */ proto.customer_service.UpsertAddressesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpsertAddressesResponse;
    return proto.customer_service.UpsertAddressesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpsertAddressesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpsertAddressesResponse}
 */ proto.customer_service.UpsertAddressesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpsertAddressesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpsertAddressesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpsertAddressesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpsertAddressesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ValidateClientRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ValidateClientRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ValidateClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ValidateClientRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            osType: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            osVersion: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            appVersion: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            appSignature: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ValidateClientRequest}
 */ proto.customer_service.ValidateClientRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ValidateClientRequest;
    return proto.customer_service.ValidateClientRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ValidateClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ValidateClientRequest}
 */ proto.customer_service.ValidateClientRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.customer_service.ClientOSType} */ reader.readEnum();
                msg.setOsType(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOsVersion(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAppVersion(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAppSignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ValidateClientRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ValidateClientRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ValidateClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ValidateClientRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getOsType();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getOsVersion();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAppVersion();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAppSignature();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional ClientOSType os_type = 1;
 * @return {!proto.customer_service.ClientOSType}
 */ proto.customer_service.ValidateClientRequest.prototype.getOsType = function() {
    return /** @type {!proto.customer_service.ClientOSType} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.customer_service.ClientOSType} value
 * @return {!proto.customer_service.ValidateClientRequest} returns this
 */ proto.customer_service.ValidateClientRequest.prototype.setOsType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string os_version = 2;
 * @return {string}
 */ proto.customer_service.ValidateClientRequest.prototype.getOsVersion = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ValidateClientRequest} returns this
 */ proto.customer_service.ValidateClientRequest.prototype.setOsVersion = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string app_version = 3;
 * @return {string}
 */ proto.customer_service.ValidateClientRequest.prototype.getAppVersion = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ValidateClientRequest} returns this
 */ proto.customer_service.ValidateClientRequest.prototype.setAppVersion = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string app_signature = 4;
 * @return {string}
 */ proto.customer_service.ValidateClientRequest.prototype.getAppSignature = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ValidateClientRequest} returns this
 */ proto.customer_service.ValidateClientRequest.prototype.setAppSignature = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ValidateClientResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ValidateClientResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ValidateClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ValidateClientResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            status: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            updateMessage: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            updateUrl: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ValidateClientResponse}
 */ proto.customer_service.ValidateClientResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ValidateClientResponse;
    return proto.customer_service.ValidateClientResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ValidateClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ValidateClientResponse}
 */ proto.customer_service.ValidateClientResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.customer_service.ValidateClientResponse.ViabilityStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUpdateMessage(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setUpdateUrl(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ValidateClientResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ValidateClientResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ValidateClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ValidateClientResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getUpdateMessage();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUpdateUrl();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * @enum {number}
 */ proto.customer_service.ValidateClientResponse.ViabilityStatus = {
    VALID: 0,
    UPDATE_AVAILABLE: 1,
    UPDATE_REQUIRED: 2,
    APP_RETIRED: 3
};
/**
 * optional ViabilityStatus status = 1;
 * @return {!proto.customer_service.ValidateClientResponse.ViabilityStatus}
 */ proto.customer_service.ValidateClientResponse.prototype.getStatus = function() {
    return /** @type {!proto.customer_service.ValidateClientResponse.ViabilityStatus} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.customer_service.ValidateClientResponse.ViabilityStatus} value
 * @return {!proto.customer_service.ValidateClientResponse} returns this
 */ proto.customer_service.ValidateClientResponse.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string update_message = 2;
 * @return {string}
 */ proto.customer_service.ValidateClientResponse.prototype.getUpdateMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ValidateClientResponse} returns this
 */ proto.customer_service.ValidateClientResponse.prototype.setUpdateMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string update_url = 3;
 * @return {string}
 */ proto.customer_service.ValidateClientResponse.prototype.getUpdateUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ValidateClientResponse} returns this
 */ proto.customer_service.ValidateClientResponse.prototype.setUpdateUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SendOTPRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SendOTPRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SendOTPRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendOTPRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SendOTPRequest}
 */ proto.customer_service.SendOTPRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SendOTPRequest;
    return proto.customer_service.SendOTPRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SendOTPRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SendOTPRequest}
 */ proto.customer_service.SendOTPRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SendOTPRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SendOTPRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SendOTPRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendOTPRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string phone_number = 1;
 * @return {string}
 */ proto.customer_service.SendOTPRequest.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendOTPRequest} returns this
 */ proto.customer_service.SendOTPRequest.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.customer_service.SendOTPRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendOTPRequest} returns this
 */ proto.customer_service.SendOTPRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SendOTPResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SendOTPResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SendOTPResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendOTPResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SendOTPResponse}
 */ proto.customer_service.SendOTPResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SendOTPResponse;
    return proto.customer_service.SendOTPResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SendOTPResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SendOTPResponse}
 */ proto.customer_service.SendOTPResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SendOTPResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SendOTPResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SendOTPResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendOTPResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.VerifyOTPRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.VerifyOTPRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.VerifyOTPRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.VerifyOTPRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            oneTimeCode: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.VerifyOTPRequest}
 */ proto.customer_service.VerifyOTPRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.VerifyOTPRequest;
    return proto.customer_service.VerifyOTPRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.VerifyOTPRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.VerifyOTPRequest}
 */ proto.customer_service.VerifyOTPRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setOneTimeCode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.VerifyOTPRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.VerifyOTPRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.VerifyOTPRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.VerifyOTPRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getOneTimeCode();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string one_time_code = 1;
 * @return {string}
 */ proto.customer_service.VerifyOTPRequest.prototype.getOneTimeCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.VerifyOTPRequest} returns this
 */ proto.customer_service.VerifyOTPRequest.prototype.setOneTimeCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string phone_number = 2;
 * @return {string}
 */ proto.customer_service.VerifyOTPRequest.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.VerifyOTPRequest} returns this
 */ proto.customer_service.VerifyOTPRequest.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vehicle_id = 3;
 * @return {string}
 */ proto.customer_service.VerifyOTPRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.VerifyOTPRequest} returns this
 */ proto.customer_service.VerifyOTPRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.VerifyOTPResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.VerifyOTPResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.VerifyOTPResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.VerifyOTPResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            token: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.VerifyOTPResponse}
 */ proto.customer_service.VerifyOTPResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.VerifyOTPResponse;
    return proto.customer_service.VerifyOTPResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.VerifyOTPResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.VerifyOTPResponse}
 */ proto.customer_service.VerifyOTPResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setToken(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.VerifyOTPResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.VerifyOTPResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.VerifyOTPResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.VerifyOTPResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getToken();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string token = 1;
 * @return {string}
 */ proto.customer_service.VerifyOTPResponse.prototype.getToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.VerifyOTPResponse} returns this
 */ proto.customer_service.VerifyOTPResponse.prototype.setToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SubmitLicenseInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SubmitLicenseInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitLicenseInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = msg.getAddress()) && $3QqPt.Address.toObject(includeInstance, f),
            licenseNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            licenseExpiration: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            dateOfBirth: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SubmitLicenseInfoRequest}
 */ proto.customer_service.SubmitLicenseInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SubmitLicenseInfoRequest;
    return proto.customer_service.SubmitLicenseInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SubmitLicenseInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SubmitLicenseInfoRequest}
 */ proto.customer_service.SubmitLicenseInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLicenseNumber(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLicenseExpiration(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDateOfBirth(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SubmitLicenseInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SubmitLicenseInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitLicenseInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddress();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getLicenseNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLicenseExpiration();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getDateOfBirth();
    if (f !== 0) writer.writeInt64(6, f);
};
/**
 * optional domain.Address address = 1;
 * @return {?proto.domain.Address}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.getAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 1);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.customer_service.SubmitLicenseInfoRequest} returns this
*/ proto.customer_service.SubmitLicenseInfoRequest.prototype.setAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.SubmitLicenseInfoRequest} returns this
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.clearAddress = function() {
    return this.setAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.hasAddress = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional string license_number = 2;
 * @return {string}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.getLicenseNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicenseInfoRequest} returns this
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.setLicenseNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 license_expiration = 3;
 * @return {number}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.getLicenseExpiration = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.SubmitLicenseInfoRequest} returns this
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.setLicenseExpiration = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string first_name = 4;
 * @return {string}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicenseInfoRequest} returns this
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string last_name = 5;
 * @return {string}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicenseInfoRequest} returns this
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int64 date_of_birth = 6;
 * @return {number}
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.getDateOfBirth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.SubmitLicenseInfoRequest} returns this
 */ proto.customer_service.SubmitLicenseInfoRequest.prototype.setDateOfBirth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SubmitLicenseInfoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SubmitLicenseInfoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SubmitLicenseInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitLicenseInfoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SubmitLicenseInfoResponse}
 */ proto.customer_service.SubmitLicenseInfoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SubmitLicenseInfoResponse;
    return proto.customer_service.SubmitLicenseInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SubmitLicenseInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SubmitLicenseInfoResponse}
 */ proto.customer_service.SubmitLicenseInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SubmitLicenseInfoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SubmitLicenseInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SubmitLicenseInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitLicenseInfoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SubmitSelfiePhotoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SubmitSelfiePhotoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SubmitSelfiePhotoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitSelfiePhotoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            selfie: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SubmitSelfiePhotoRequest}
 */ proto.customer_service.SubmitSelfiePhotoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SubmitSelfiePhotoRequest;
    return proto.customer_service.SubmitSelfiePhotoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SubmitSelfiePhotoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SubmitSelfiePhotoRequest}
 */ proto.customer_service.SubmitSelfiePhotoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSelfie(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SubmitSelfiePhotoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SubmitSelfiePhotoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SubmitSelfiePhotoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitSelfiePhotoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSelfie();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string selfie = 2;
 * @return {string}
 */ proto.customer_service.SubmitSelfiePhotoRequest.prototype.getSelfie = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitSelfiePhotoRequest} returns this
 */ proto.customer_service.SubmitSelfiePhotoRequest.prototype.setSelfie = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SubmitSelfiePhotoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SubmitSelfiePhotoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SubmitSelfiePhotoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitSelfiePhotoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SubmitSelfiePhotoResponse}
 */ proto.customer_service.SubmitSelfiePhotoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SubmitSelfiePhotoResponse;
    return proto.customer_service.SubmitSelfiePhotoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SubmitSelfiePhotoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SubmitSelfiePhotoResponse}
 */ proto.customer_service.SubmitSelfiePhotoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SubmitSelfiePhotoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SubmitSelfiePhotoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SubmitSelfiePhotoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitSelfiePhotoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SubmitLicensePhotosRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SubmitLicensePhotosRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SubmitLicensePhotosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitLicensePhotosRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            licenseFront: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            licenseBack: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            waitForResults: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SubmitLicensePhotosRequest}
 */ proto.customer_service.SubmitLicensePhotosRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SubmitLicensePhotosRequest;
    return proto.customer_service.SubmitLicensePhotosRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SubmitLicensePhotosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SubmitLicensePhotosRequest}
 */ proto.customer_service.SubmitLicensePhotosRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLicenseFront(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLicenseBack(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setWaitForResults(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SubmitLicensePhotosRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SubmitLicensePhotosRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SubmitLicensePhotosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitLicensePhotosRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLicenseFront();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLicenseBack();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getWaitForResults();
    if (f) writer.writeBool(4, f);
};
/**
 * optional string license_front = 2;
 * @return {string}
 */ proto.customer_service.SubmitLicensePhotosRequest.prototype.getLicenseFront = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicensePhotosRequest} returns this
 */ proto.customer_service.SubmitLicensePhotosRequest.prototype.setLicenseFront = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string license_back = 3;
 * @return {string}
 */ proto.customer_service.SubmitLicensePhotosRequest.prototype.getLicenseBack = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicensePhotosRequest} returns this
 */ proto.customer_service.SubmitLicensePhotosRequest.prototype.setLicenseBack = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional bool wait_for_results = 4;
 * @return {boolean}
 */ proto.customer_service.SubmitLicensePhotosRequest.prototype.getWaitForResults = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.customer_service.SubmitLicensePhotosRequest} returns this
 */ proto.customer_service.SubmitLicensePhotosRequest.prototype.setWaitForResults = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SubmitLicensePhotosResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SubmitLicensePhotosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitLicensePhotosResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            address: (f = msg.getAddress()) && $3QqPt.Address.toObject(includeInstance, f),
            licenseNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            expirationDate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            dateOfBirth: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            middleName: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SubmitLicensePhotosResponse}
 */ proto.customer_service.SubmitLicensePhotosResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SubmitLicensePhotosResponse;
    return proto.customer_service.SubmitLicensePhotosResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SubmitLicensePhotosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SubmitLicensePhotosResponse}
 */ proto.customer_service.SubmitLicensePhotosResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setAddress(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLicenseNumber(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setExpirationDate(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDateOfBirth(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setMiddleName(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SubmitLicensePhotosResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SubmitLicensePhotosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SubmitLicensePhotosResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAddress();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getLicenseNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getExpirationDate();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getDateOfBirth();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getMiddleName();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * optional domain.Address address = 1;
 * @return {?proto.domain.Address}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.getAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 1);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.customer_service.SubmitLicensePhotosResponse} returns this
*/ proto.customer_service.SubmitLicensePhotosResponse.prototype.setAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.SubmitLicensePhotosResponse} returns this
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.clearAddress = function() {
    return this.setAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.hasAddress = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional string license_number = 2;
 * @return {string}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.getLicenseNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicensePhotosResponse} returns this
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.setLicenseNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 expiration_date = 3;
 * @return {number}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.getExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.SubmitLicensePhotosResponse} returns this
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.setExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int64 date_of_birth = 4;
 * @return {number}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.getDateOfBirth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.SubmitLicensePhotosResponse} returns this
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.setDateOfBirth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string first_name = 5;
 * @return {string}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicensePhotosResponse} returns this
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string middle_name = 6;
 * @return {string}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.getMiddleName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicensePhotosResponse} returns this
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.setMiddleName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string last_name = 7;
 * @return {string}
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SubmitLicensePhotosResponse} returns this
 */ proto.customer_service.SubmitLicensePhotosResponse.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetImageUploadURIRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetImageUploadURIRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetImageUploadURIRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetImageUploadURIRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            imageType: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetImageUploadURIRequest}
 */ proto.customer_service.GetImageUploadURIRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetImageUploadURIRequest;
    return proto.customer_service.GetImageUploadURIRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetImageUploadURIRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetImageUploadURIRequest}
 */ proto.customer_service.GetImageUploadURIRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.ImageType} */ reader.readEnum();
                msg.setImageType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetImageUploadURIRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetImageUploadURIRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetImageUploadURIRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetImageUploadURIRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getImageType();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetImageUploadURIRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetImageUploadURIRequest} returns this
 */ proto.customer_service.GetImageUploadURIRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.ImageType image_type = 2;
 * @return {!proto.domain.ImageType}
 */ proto.customer_service.GetImageUploadURIRequest.prototype.getImageType = function() {
    return /** @type {!proto.domain.ImageType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.ImageType} value
 * @return {!proto.customer_service.GetImageUploadURIRequest} returns this
 */ proto.customer_service.GetImageUploadURIRequest.prototype.setImageType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetImageUploadURIResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetImageUploadURIResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetImageUploadURIResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetImageUploadURIResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            uri: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            imageType: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetImageUploadURIResponse}
 */ proto.customer_service.GetImageUploadURIResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetImageUploadURIResponse;
    return proto.customer_service.GetImageUploadURIResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetImageUploadURIResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetImageUploadURIResponse}
 */ proto.customer_service.GetImageUploadURIResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setUri(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.ImageType} */ reader.readEnum();
                msg.setImageType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetImageUploadURIResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetImageUploadURIResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetImageUploadURIResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetImageUploadURIResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUri();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getImageType();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * optional string uri = 1;
 * @return {string}
 */ proto.customer_service.GetImageUploadURIResponse.prototype.getUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetImageUploadURIResponse} returns this
 */ proto.customer_service.GetImageUploadURIResponse.prototype.setUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.ImageType image_type = 2;
 * @return {!proto.domain.ImageType}
 */ proto.customer_service.GetImageUploadURIResponse.prototype.getImageType = function() {
    return /** @type {!proto.domain.ImageType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.ImageType} value
 * @return {!proto.customer_service.GetImageUploadURIResponse} returns this
 */ proto.customer_service.GetImageUploadURIResponse.prototype.setImageType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.RequestMfaRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.RequestMfaRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.RequestMfaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RequestMfaRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            enrichmentStatus: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            forceWifi: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.RequestMfaRequest}
 */ proto.customer_service.RequestMfaRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.RequestMfaRequest;
    return proto.customer_service.RequestMfaRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.RequestMfaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.RequestMfaRequest}
 */ proto.customer_service.RequestMfaRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {!proto.customer_service.RequestMfaRequest.EnrichmentStatus} */ reader.readEnum();
                msg.setEnrichmentStatus(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setForceWifi(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.RequestMfaRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.RequestMfaRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.RequestMfaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RequestMfaRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getEnrichmentStatus();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getForceWifi();
    if (f) writer.writeBool(4, f);
};
/**
 * @enum {number}
 */ proto.customer_service.RequestMfaRequest.EnrichmentStatus = {
    NOT_APPLICABLE: 0,
    FAILURE: 1,
    SUCCESS: 2
};
/**
 * optional string phone_number = 1;
 * @return {string}
 */ proto.customer_service.RequestMfaRequest.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.RequestMfaRequest} returns this
 */ proto.customer_service.RequestMfaRequest.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.customer_service.RequestMfaRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.RequestMfaRequest} returns this
 */ proto.customer_service.RequestMfaRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional EnrichmentStatus enrichment_status = 3;
 * @return {!proto.customer_service.RequestMfaRequest.EnrichmentStatus}
 */ proto.customer_service.RequestMfaRequest.prototype.getEnrichmentStatus = function() {
    return /** @type {!proto.customer_service.RequestMfaRequest.EnrichmentStatus} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.customer_service.RequestMfaRequest.EnrichmentStatus} value
 * @return {!proto.customer_service.RequestMfaRequest} returns this
 */ proto.customer_service.RequestMfaRequest.prototype.setEnrichmentStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional bool force_wifi = 4;
 * @return {boolean}
 */ proto.customer_service.RequestMfaRequest.prototype.getForceWifi = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.customer_service.RequestMfaRequest} returns this
 */ proto.customer_service.RequestMfaRequest.prototype.setForceWifi = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.RequestMfaResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.RequestMfaResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.RequestMfaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RequestMfaResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            enrichmentUrl: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            authorizationToken: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.RequestMfaResponse}
 */ proto.customer_service.RequestMfaResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.RequestMfaResponse;
    return proto.customer_service.RequestMfaResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.RequestMfaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.RequestMfaResponse}
 */ proto.customer_service.RequestMfaResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setEnrichmentUrl(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAuthorizationToken(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.RequestMfaResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.RequestMfaResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.RequestMfaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RequestMfaResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getEnrichmentUrl();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAuthorizationToken();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string enrichment_url = 1;
 * @return {string}
 */ proto.customer_service.RequestMfaResponse.prototype.getEnrichmentUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.RequestMfaResponse} returns this
 */ proto.customer_service.RequestMfaResponse.prototype.setEnrichmentUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string authorization_token = 2;
 * @return {string}
 */ proto.customer_service.RequestMfaResponse.prototype.getAuthorizationToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.RequestMfaResponse} returns this
 */ proto.customer_service.RequestMfaResponse.prototype.setAuthorizationToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.CustomerProjectionMeta.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.CustomerProjectionMeta.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.CustomerProjectionMeta.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.CustomerProjectionMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.CustomerProjectionMeta.toObject = function(includeInstance, msg) {
        var f, obj = {
            authenticidtransactionid: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            imagesList: $8M67s.Message.toObjectList(msg.getImagesList(), $3QqPt.Image.toObject, includeInstance),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.CustomerProjectionMeta}
 */ proto.customer_service.CustomerProjectionMeta.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.CustomerProjectionMeta;
    return proto.customer_service.CustomerProjectionMeta.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.CustomerProjectionMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.CustomerProjectionMeta}
 */ proto.customer_service.CustomerProjectionMeta.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAuthenticidtransactionid(value);
                break;
            case 2:
                var value = new $3QqPt.Image;
                reader.readMessage(value, $3QqPt.Image.deserializeBinaryFromReader);
                msg.addImages(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.CustomerProjectionMeta.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.CustomerProjectionMeta.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.CustomerProjectionMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.CustomerProjectionMeta.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAuthenticidtransactionid();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getImagesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.Image.serializeBinaryToWriter);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string AuthenticIdTransactionId = 1;
 * @return {string}
 */ proto.customer_service.CustomerProjectionMeta.prototype.getAuthenticidtransactionid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CustomerProjectionMeta} returns this
 */ proto.customer_service.CustomerProjectionMeta.prototype.setAuthenticidtransactionid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated domain.Image images = 2;
 * @return {!Array<!proto.domain.Image>}
 */ proto.customer_service.CustomerProjectionMeta.prototype.getImagesList = function() {
    return /** @type{!Array<!proto.domain.Image>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Image, 2);
};
/**
 * @param {!Array<!proto.domain.Image>} value
 * @return {!proto.customer_service.CustomerProjectionMeta} returns this
*/ proto.customer_service.CustomerProjectionMeta.prototype.setImagesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Image}
 */ proto.customer_service.CustomerProjectionMeta.prototype.addImages = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.Image, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.CustomerProjectionMeta} returns this
 */ proto.customer_service.CustomerProjectionMeta.prototype.clearImagesList = function() {
    return this.setImagesList([]);
};
/**
 * optional string reservation_id = 3;
 * @return {string}
 */ proto.customer_service.CustomerProjectionMeta.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CustomerProjectionMeta} returns this
 */ proto.customer_service.CustomerProjectionMeta.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ExistsByPhoneRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ExistsByPhoneRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ExistsByPhoneRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ExistsByPhoneRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ExistsByPhoneRequest}
 */ proto.customer_service.ExistsByPhoneRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ExistsByPhoneRequest;
    return proto.customer_service.ExistsByPhoneRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ExistsByPhoneRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ExistsByPhoneRequest}
 */ proto.customer_service.ExistsByPhoneRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ExistsByPhoneRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ExistsByPhoneRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ExistsByPhoneRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ExistsByPhoneRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.customer_service.ExistsByPhoneRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ExistsByPhoneRequest} returns this
 */ proto.customer_service.ExistsByPhoneRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ExistsByPhoneResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ExistsByPhoneResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ExistsByPhoneResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ExistsByPhoneResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ExistsByPhoneResponse}
 */ proto.customer_service.ExistsByPhoneResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ExistsByPhoneResponse;
    return proto.customer_service.ExistsByPhoneResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ExistsByPhoneResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ExistsByPhoneResponse}
 */ proto.customer_service.ExistsByPhoneResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ExistsByPhoneResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ExistsByPhoneResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ExistsByPhoneResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ExistsByPhoneResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.RecalculateQualificationRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.RecalculateQualificationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.RecalculateQualificationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.RecalculateQualificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RecalculateQualificationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            scoreNamesList: (f = $8M67s.Message.getRepeatedField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.RecalculateQualificationRequest}
 */ proto.customer_service.RecalculateQualificationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.RecalculateQualificationRequest;
    return proto.customer_service.RecalculateQualificationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.RecalculateQualificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.RecalculateQualificationRequest}
 */ proto.customer_service.RecalculateQualificationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var values = /** @type {!Array<!proto.customer_service.RecalculateQualificationRequest.ScoreName>} */ reader.isDelimited() ? reader.readPackedEnum() : [
                    reader.readEnum()
                ];
                for(var i = 0; i < values.length; i++)msg.addScoreNames(values[i]);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.RecalculateQualificationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.RecalculateQualificationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.RecalculateQualificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RecalculateQualificationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getScoreNamesList();
    if (f.length > 0) writer.writePackedEnum(2, f);
};
/**
 * @enum {number}
 */ proto.customer_service.RecalculateQualificationRequest.ScoreName = {
    FICO: 0,
    MVR: 1,
    SELFIE: 2,
    BACKGROUND: 3
};
/**
 * repeated ScoreName score_names = 2;
 * @return {!Array<!proto.customer_service.RecalculateQualificationRequest.ScoreName>}
 */ proto.customer_service.RecalculateQualificationRequest.prototype.getScoreNamesList = function() {
    return /** @type {!Array<!proto.customer_service.RecalculateQualificationRequest.ScoreName>} */ $8M67s.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<!proto.customer_service.RecalculateQualificationRequest.ScoreName>} value
 * @return {!proto.customer_service.RecalculateQualificationRequest} returns this
 */ proto.customer_service.RecalculateQualificationRequest.prototype.setScoreNamesList = function(value) {
    return $8M67s.Message.setField(this, 2, value || []);
};
/**
 * @param {!proto.customer_service.RecalculateQualificationRequest.ScoreName} value
 * @param {number=} opt_index
 * @return {!proto.customer_service.RecalculateQualificationRequest} returns this
 */ proto.customer_service.RecalculateQualificationRequest.prototype.addScoreNames = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.RecalculateQualificationRequest} returns this
 */ proto.customer_service.RecalculateQualificationRequest.prototype.clearScoreNamesList = function() {
    return this.setScoreNamesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.RecalculateQualificationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.RecalculateQualificationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.RecalculateQualificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RecalculateQualificationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.RecalculateQualificationResponse}
 */ proto.customer_service.RecalculateQualificationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.RecalculateQualificationResponse;
    return proto.customer_service.RecalculateQualificationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.RecalculateQualificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.RecalculateQualificationResponse}
 */ proto.customer_service.RecalculateQualificationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.RecalculateQualificationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.RecalculateQualificationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.RecalculateQualificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RecalculateQualificationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetSecurityDepositAmountRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetSecurityDepositAmountRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetSecurityDepositAmountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetSecurityDepositAmountRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetSecurityDepositAmountRequest}
 */ proto.customer_service.GetSecurityDepositAmountRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetSecurityDepositAmountRequest;
    return proto.customer_service.GetSecurityDepositAmountRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetSecurityDepositAmountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetSecurityDepositAmountRequest}
 */ proto.customer_service.GetSecurityDepositAmountRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetSecurityDepositAmountRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetSecurityDepositAmountRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetSecurityDepositAmountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetSecurityDepositAmountRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetSecurityDepositAmountRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetSecurityDepositAmountRequest} returns this
 */ proto.customer_service.GetSecurityDepositAmountRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetSecurityDepositAmountResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetSecurityDepositAmountResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetSecurityDepositAmountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetSecurityDepositAmountResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            amount: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetSecurityDepositAmountResponse}
 */ proto.customer_service.GetSecurityDepositAmountResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetSecurityDepositAmountResponse;
    return proto.customer_service.GetSecurityDepositAmountResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetSecurityDepositAmountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetSecurityDepositAmountResponse}
 */ proto.customer_service.GetSecurityDepositAmountResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetSecurityDepositAmountResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetSecurityDepositAmountResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetSecurityDepositAmountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetSecurityDepositAmountResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * optional int32 amount = 1;
 * @return {number}
 */ proto.customer_service.GetSecurityDepositAmountResponse.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.GetSecurityDepositAmountResponse} returns this
 */ proto.customer_service.GetSecurityDepositAmountResponse.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.OverrideQualificationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.OverrideQualificationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.OverrideQualificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.OverrideQualificationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            tier: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            disqualifiedScoreId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.OverrideQualificationRequest}
 */ proto.customer_service.OverrideQualificationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.OverrideQualificationRequest;
    return proto.customer_service.OverrideQualificationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.OverrideQualificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.OverrideQualificationRequest}
 */ proto.customer_service.OverrideQualificationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setTier(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDisqualifiedScoreId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.OverrideQualificationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.OverrideQualificationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.OverrideQualificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.OverrideQualificationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTier();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getDisqualifiedScoreId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.OverrideQualificationRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.OverrideQualificationRequest} returns this
 */ proto.customer_service.OverrideQualificationRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.QualificationTier tier = 2;
 * @return {!proto.domain.QualificationTier}
 */ proto.customer_service.OverrideQualificationRequest.prototype.getTier = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.customer_service.OverrideQualificationRequest} returns this
 */ proto.customer_service.OverrideQualificationRequest.prototype.setTier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string disqualified_score_id = 3;
 * @return {string}
 */ proto.customer_service.OverrideQualificationRequest.prototype.getDisqualifiedScoreId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.OverrideQualificationRequest} returns this
 */ proto.customer_service.OverrideQualificationRequest.prototype.setDisqualifiedScoreId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.OverrideQualificationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.OverrideQualificationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.OverrideQualificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.OverrideQualificationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.OverrideQualificationResponse}
 */ proto.customer_service.OverrideQualificationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.OverrideQualificationResponse;
    return proto.customer_service.OverrideQualificationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.OverrideQualificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.OverrideQualificationResponse}
 */ proto.customer_service.OverrideQualificationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.OverrideQualificationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.OverrideQualificationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.OverrideQualificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.OverrideQualificationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetNotesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetNotesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetNotesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetNotesRequest}
 */ proto.customer_service.GetNotesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetNotesRequest;
    return proto.customer_service.GetNotesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetNotesRequest}
 */ proto.customer_service.GetNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetNotesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetNotesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetNotesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetNotesRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetNotesRequest} returns this
 */ proto.customer_service.GetNotesRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.RecalculateCustomerScoresRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.RecalculateCustomerScoresRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.RecalculateCustomerScoresRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RecalculateCustomerScoresRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            scoreNamesList: (f = $8M67s.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
            skipQualification: $8M67s.Message.getBooleanFieldWithDefault(msg, 3, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.RecalculateCustomerScoresRequest}
 */ proto.customer_service.RecalculateCustomerScoresRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.RecalculateCustomerScoresRequest;
    return proto.customer_service.RecalculateCustomerScoresRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.RecalculateCustomerScoresRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.RecalculateCustomerScoresRequest}
 */ proto.customer_service.RecalculateCustomerScoresRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var values = /** @type {!Array<!proto.customer_service.RecalculateCustomerScoresRequest.ScoreName>} */ reader.isDelimited() ? reader.readPackedEnum() : [
                    reader.readEnum()
                ];
                for(var i = 0; i < values.length; i++)msg.addScoreNames(values[i]);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSkipQualification(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.RecalculateCustomerScoresRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.RecalculateCustomerScoresRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RecalculateCustomerScoresRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getScoreNamesList();
    if (f.length > 0) writer.writePackedEnum(2, f);
    f = message.getSkipQualification();
    if (f) writer.writeBool(3, f);
};
/**
 * @enum {number}
 */ proto.customer_service.RecalculateCustomerScoresRequest.ScoreName = {
    SELFIE: 0,
    FICO: 1,
    MVR: 2,
    BACKGROUND: 3
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.RecalculateCustomerScoresRequest} returns this
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated ScoreName score_names = 2;
 * @return {!Array<!proto.customer_service.RecalculateCustomerScoresRequest.ScoreName>}
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.getScoreNamesList = function() {
    return /** @type {!Array<!proto.customer_service.RecalculateCustomerScoresRequest.ScoreName>} */ $8M67s.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<!proto.customer_service.RecalculateCustomerScoresRequest.ScoreName>} value
 * @return {!proto.customer_service.RecalculateCustomerScoresRequest} returns this
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.setScoreNamesList = function(value) {
    return $8M67s.Message.setField(this, 2, value || []);
};
/**
 * @param {!proto.customer_service.RecalculateCustomerScoresRequest.ScoreName} value
 * @param {number=} opt_index
 * @return {!proto.customer_service.RecalculateCustomerScoresRequest} returns this
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.addScoreNames = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.RecalculateCustomerScoresRequest} returns this
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.clearScoreNamesList = function() {
    return this.setScoreNamesList([]);
};
/**
 * optional bool skip_qualification = 3;
 * @return {boolean}
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.getSkipQualification = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.customer_service.RecalculateCustomerScoresRequest} returns this
 */ proto.customer_service.RecalculateCustomerScoresRequest.prototype.setSkipQualification = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.RecalculateCustomerScoresResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.RecalculateCustomerScoresResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.RecalculateCustomerScoresResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.RecalculateCustomerScoresResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RecalculateCustomerScoresResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            scoresList: $8M67s.Message.toObjectList(msg.getScoresList(), $3QqPt.Score.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.RecalculateCustomerScoresResponse}
 */ proto.customer_service.RecalculateCustomerScoresResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.RecalculateCustomerScoresResponse;
    return proto.customer_service.RecalculateCustomerScoresResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.RecalculateCustomerScoresResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.RecalculateCustomerScoresResponse}
 */ proto.customer_service.RecalculateCustomerScoresResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Score;
                reader.readMessage(value, $3QqPt.Score.deserializeBinaryFromReader);
                msg.addScores(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.RecalculateCustomerScoresResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.RecalculateCustomerScoresResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.RecalculateCustomerScoresResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RecalculateCustomerScoresResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getScoresList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.Score.serializeBinaryToWriter);
};
/**
 * repeated domain.Score scores = 1;
 * @return {!Array<!proto.domain.Score>}
 */ proto.customer_service.RecalculateCustomerScoresResponse.prototype.getScoresList = function() {
    return /** @type{!Array<!proto.domain.Score>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Score, 1);
};
/**
 * @param {!Array<!proto.domain.Score>} value
 * @return {!proto.customer_service.RecalculateCustomerScoresResponse} returns this
*/ proto.customer_service.RecalculateCustomerScoresResponse.prototype.setScoresList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.Score=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Score}
 */ proto.customer_service.RecalculateCustomerScoresResponse.prototype.addScores = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.Score, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.RecalculateCustomerScoresResponse} returns this
 */ proto.customer_service.RecalculateCustomerScoresResponse.prototype.clearScoresList = function() {
    return this.setScoresList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerQualificationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerQualificationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerQualificationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerQualificationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerQualificationRequest}
 */ proto.customer_service.GetCustomerQualificationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerQualificationRequest;
    return proto.customer_service.GetCustomerQualificationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerQualificationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerQualificationRequest}
 */ proto.customer_service.GetCustomerQualificationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerQualificationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerQualificationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerQualificationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerQualificationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetCustomerQualificationRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetCustomerQualificationRequest} returns this
 */ proto.customer_service.GetCustomerQualificationRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerQualificationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerQualificationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerQualificationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerQualificationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            state: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerQualificationResponse}
 */ proto.customer_service.GetCustomerQualificationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerQualificationResponse;
    return proto.customer_service.GetCustomerQualificationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerQualificationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerQualificationResponse}
 */ proto.customer_service.GetCustomerQualificationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.customer_service.QualificationState} */ reader.readEnum();
                msg.setState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerQualificationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerQualificationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerQualificationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerQualificationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getState();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional QualificationState state = 1;
 * @return {!proto.customer_service.QualificationState}
 */ proto.customer_service.GetCustomerQualificationResponse.prototype.getState = function() {
    return /** @type {!proto.customer_service.QualificationState} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.customer_service.QualificationState} value
 * @return {!proto.customer_service.GetCustomerQualificationResponse} returns this
 */ proto.customer_service.GetCustomerQualificationResponse.prototype.setState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerByIDRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerByIDRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerByIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByIDRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerByIDRequest}
 */ proto.customer_service.GetCustomerByIDRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerByIDRequest;
    return proto.customer_service.GetCustomerByIDRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerByIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerByIDRequest}
 */ proto.customer_service.GetCustomerByIDRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerByIDRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerByIDRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerByIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByIDRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetCustomerByIDRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetCustomerByIDRequest} returns this
 */ proto.customer_service.GetCustomerByIDRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerByIDResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerByIDResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerByIDResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByIDResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerByIDResponse}
 */ proto.customer_service.GetCustomerByIDResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerByIDResponse;
    return proto.customer_service.GetCustomerByIDResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerByIDResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerByIDResponse}
 */ proto.customer_service.GetCustomerByIDResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerByIDResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerByIDResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerByIDResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByIDResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomer();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Customer.serializeBinaryToWriter);
};
/**
 * optional domain.Customer customer = 1;
 * @return {?proto.domain.Customer}
 */ proto.customer_service.GetCustomerByIDResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 1);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.customer_service.GetCustomerByIDResponse} returns this
*/ proto.customer_service.GetCustomerByIDResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.GetCustomerByIDResponse} returns this
 */ proto.customer_service.GetCustomerByIDResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.GetCustomerByIDResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerByPhoneRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerByPhoneRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerByPhoneRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByPhoneRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerByPhoneRequest}
 */ proto.customer_service.GetCustomerByPhoneRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerByPhoneRequest;
    return proto.customer_service.GetCustomerByPhoneRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerByPhoneRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerByPhoneRequest}
 */ proto.customer_service.GetCustomerByPhoneRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerByPhoneRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerByPhoneRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerByPhoneRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByPhoneRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.customer_service.GetCustomerByPhoneRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetCustomerByPhoneRequest} returns this
 */ proto.customer_service.GetCustomerByPhoneRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerByPhoneResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerByPhoneResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerByPhoneResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByPhoneResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerByPhoneResponse}
 */ proto.customer_service.GetCustomerByPhoneResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerByPhoneResponse;
    return proto.customer_service.GetCustomerByPhoneResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerByPhoneResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerByPhoneResponse}
 */ proto.customer_service.GetCustomerByPhoneResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerByPhoneResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerByPhoneResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerByPhoneResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByPhoneResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomer();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Customer.serializeBinaryToWriter);
};
/**
 * optional domain.Customer customer = 1;
 * @return {?proto.domain.Customer}
 */ proto.customer_service.GetCustomerByPhoneResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 1);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.customer_service.GetCustomerByPhoneResponse} returns this
*/ proto.customer_service.GetCustomerByPhoneResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.GetCustomerByPhoneResponse} returns this
 */ proto.customer_service.GetCustomerByPhoneResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.GetCustomerByPhoneResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetAllCustomersByPhoneRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetAllCustomersByPhoneRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetAllCustomersByPhoneRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAllCustomersByPhoneRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetAllCustomersByPhoneRequest}
 */ proto.customer_service.GetAllCustomersByPhoneRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetAllCustomersByPhoneRequest;
    return proto.customer_service.GetAllCustomersByPhoneRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetAllCustomersByPhoneRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetAllCustomersByPhoneRequest}
 */ proto.customer_service.GetAllCustomersByPhoneRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetAllCustomersByPhoneRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetAllCustomersByPhoneRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetAllCustomersByPhoneRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAllCustomersByPhoneRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.customer_service.GetAllCustomersByPhoneRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetAllCustomersByPhoneRequest} returns this
 */ proto.customer_service.GetAllCustomersByPhoneRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.GetAllCustomersByPhoneResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetAllCustomersByPhoneResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetAllCustomersByPhoneResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAllCustomersByPhoneResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customersList: $8M67s.Message.toObjectList(msg.getCustomersList(), proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetAllCustomersByPhoneResponse;
    return proto.customer_service.GetAllCustomersByPhoneResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetAllCustomersByPhoneResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary;
                reader.readMessage(value, proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.deserializeBinaryFromReader);
                msg.addCustomers(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetAllCustomersByPhoneResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetAllCustomersByPhoneResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAllCustomersByPhoneResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomersList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.serializeBinaryToWriter);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            clientId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary;
    return proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setClientId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getClientId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary} returns this
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account_number = 2;
 * @return {string}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary} returns this
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string client_id = 3;
 * @return {string}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.prototype.getClientId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary} returns this
 */ proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary.prototype.setClientId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * repeated CustomerSummary customers = 1;
 * @return {!Array<!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary>}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.prototype.getCustomersList = function() {
    return /** @type{!Array<!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary, 1);
};
/**
 * @param {!Array<!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary>} value
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse} returns this
*/ proto.customer_service.GetAllCustomersByPhoneResponse.prototype.setCustomersList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary}
 */ proto.customer_service.GetAllCustomersByPhoneResponse.prototype.addCustomers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.customer_service.GetAllCustomersByPhoneResponse.CustomerSummary, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.GetAllCustomersByPhoneResponse} returns this
 */ proto.customer_service.GetAllCustomersByPhoneResponse.prototype.clearCustomersList = function() {
    return this.setCustomersList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.CreateCustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.CreateCustomerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.CreateCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.CreateCustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.CreateCustomerRequest}
 */ proto.customer_service.CreateCustomerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.CreateCustomerRequest;
    return proto.customer_service.CreateCustomerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.CreateCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.CreateCustomerRequest}
 */ proto.customer_service.CreateCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.CreateCustomerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.CreateCustomerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.CreateCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.CreateCustomerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.customer_service.CreateCustomerRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CreateCustomerRequest} returns this
 */ proto.customer_service.CreateCustomerRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string email = 2;
 * @return {string}
 */ proto.customer_service.CreateCustomerRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CreateCustomerRequest} returns this
 */ proto.customer_service.CreateCustomerRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string first_name = 3;
 * @return {string}
 */ proto.customer_service.CreateCustomerRequest.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CreateCustomerRequest} returns this
 */ proto.customer_service.CreateCustomerRequest.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_name = 4;
 * @return {string}
 */ proto.customer_service.CreateCustomerRequest.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CreateCustomerRequest} returns this
 */ proto.customer_service.CreateCustomerRequest.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.CreateCustomerResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.CreateCustomerResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.CreateCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.CreateCustomerResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.CreateCustomerResponse}
 */ proto.customer_service.CreateCustomerResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.CreateCustomerResponse;
    return proto.customer_service.CreateCustomerResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.CreateCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.CreateCustomerResponse}
 */ proto.customer_service.CreateCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.CreateCustomerResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.CreateCustomerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.CreateCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.CreateCustomerResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.customer_service.CreateCustomerResponse.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CreateCustomerResponse} returns this
 */ proto.customer_service.CreateCustomerResponse.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.customer_service.CreateCustomerResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CreateCustomerResponse} returns this
 */ proto.customer_service.CreateCustomerResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string account_number = 3;
 * @return {string}
 */ proto.customer_service.CreateCustomerResponse.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.CreateCustomerResponse} returns this
 */ proto.customer_service.CreateCustomerResponse.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpdateCustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpdateCustomerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpdateCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateCustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpdateCustomerRequest}
 */ proto.customer_service.UpdateCustomerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpdateCustomerRequest;
    return proto.customer_service.UpdateCustomerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpdateCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpdateCustomerRequest}
 */ proto.customer_service.UpdateCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpdateCustomerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpdateCustomerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpdateCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateCustomerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.UpdateCustomerRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpdateCustomerRequest} returns this
 */ proto.customer_service.UpdateCustomerRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string phone = 2;
 * @return {string}
 */ proto.customer_service.UpdateCustomerRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpdateCustomerRequest} returns this
 */ proto.customer_service.UpdateCustomerRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string email = 3;
 * @return {string}
 */ proto.customer_service.UpdateCustomerRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpdateCustomerRequest} returns this
 */ proto.customer_service.UpdateCustomerRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string first_name = 4;
 * @return {string}
 */ proto.customer_service.UpdateCustomerRequest.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpdateCustomerRequest} returns this
 */ proto.customer_service.UpdateCustomerRequest.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string last_name = 5;
 * @return {string}
 */ proto.customer_service.UpdateCustomerRequest.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpdateCustomerRequest} returns this
 */ proto.customer_service.UpdateCustomerRequest.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpdateCustomerResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpdateCustomerResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpdateCustomerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateCustomerResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpdateCustomerResponse}
 */ proto.customer_service.UpdateCustomerResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpdateCustomerResponse;
    return proto.customer_service.UpdateCustomerResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpdateCustomerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpdateCustomerResponse}
 */ proto.customer_service.UpdateCustomerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpdateCustomerResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpdateCustomerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpdateCustomerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateCustomerResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpdateCustomerWithFakePhoneRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpdateCustomerWithFakePhoneRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpdateCustomerWithFakePhoneRequest}
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpdateCustomerWithFakePhoneRequest;
    return proto.customer_service.UpdateCustomerWithFakePhoneRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpdateCustomerWithFakePhoneRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpdateCustomerWithFakePhoneRequest}
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpdateCustomerWithFakePhoneRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpdateCustomerWithFakePhoneRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpdateCustomerWithFakePhoneRequest} returns this
 */ proto.customer_service.UpdateCustomerWithFakePhoneRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpdateCustomerWithFakePhoneResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpdateCustomerWithFakePhoneResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpdateCustomerWithFakePhoneResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateCustomerWithFakePhoneResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpdateCustomerWithFakePhoneResponse}
 */ proto.customer_service.UpdateCustomerWithFakePhoneResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpdateCustomerWithFakePhoneResponse;
    return proto.customer_service.UpdateCustomerWithFakePhoneResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpdateCustomerWithFakePhoneResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpdateCustomerWithFakePhoneResponse}
 */ proto.customer_service.UpdateCustomerWithFakePhoneResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpdateCustomerWithFakePhoneResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpdateCustomerWithFakePhoneResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpdateCustomerWithFakePhoneResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateCustomerWithFakePhoneResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ScrubCustomerInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ScrubCustomerInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ScrubCustomerInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ScrubCustomerInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ScrubCustomerInfoRequest}
 */ proto.customer_service.ScrubCustomerInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ScrubCustomerInfoRequest;
    return proto.customer_service.ScrubCustomerInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ScrubCustomerInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ScrubCustomerInfoRequest}
 */ proto.customer_service.ScrubCustomerInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ScrubCustomerInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ScrubCustomerInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ScrubCustomerInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ScrubCustomerInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.ScrubCustomerInfoRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ScrubCustomerInfoRequest} returns this
 */ proto.customer_service.ScrubCustomerInfoRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ScrubCustomerInfoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ScrubCustomerInfoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ScrubCustomerInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ScrubCustomerInfoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ScrubCustomerInfoResponse}
 */ proto.customer_service.ScrubCustomerInfoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ScrubCustomerInfoResponse;
    return proto.customer_service.ScrubCustomerInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ScrubCustomerInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ScrubCustomerInfoResponse}
 */ proto.customer_service.ScrubCustomerInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ScrubCustomerInfoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ScrubCustomerInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ScrubCustomerInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ScrubCustomerInfoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.InitProjectionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.InitProjectionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.InitProjectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.InitProjectionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            batchSize: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            wait: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.InitProjectionsRequest}
 */ proto.customer_service.InitProjectionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.InitProjectionsRequest;
    return proto.customer_service.InitProjectionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.InitProjectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.InitProjectionsRequest}
 */ proto.customer_service.InitProjectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setBatchSize(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setWait(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.InitProjectionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.InitProjectionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.InitProjectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.InitProjectionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getBatchSize();
    if (f !== 0) writer.writeUint32(1, f);
    f = message.getWait();
    if (f) writer.writeBool(2, f);
};
/**
 * optional uint32 batch_size = 1;
 * @return {number}
 */ proto.customer_service.InitProjectionsRequest.prototype.getBatchSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.InitProjectionsRequest} returns this
 */ proto.customer_service.InitProjectionsRequest.prototype.setBatchSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bool wait = 2;
 * @return {boolean}
 */ proto.customer_service.InitProjectionsRequest.prototype.getWait = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.customer_service.InitProjectionsRequest} returns this
 */ proto.customer_service.InitProjectionsRequest.prototype.setWait = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.InitProjectionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.InitProjectionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.InitProjectionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.InitProjectionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.InitProjectionsResponse}
 */ proto.customer_service.InitProjectionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.InitProjectionsResponse;
    return proto.customer_service.InitProjectionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.InitProjectionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.InitProjectionsResponse}
 */ proto.customer_service.InitProjectionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.InitProjectionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.InitProjectionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.InitProjectionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.InitProjectionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.RefreshAuthIDRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.RefreshAuthIDRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.RefreshAuthIDRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RefreshAuthIDRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            decryptOnly: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            limit: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            startingCustomerId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.RefreshAuthIDRequest}
 */ proto.customer_service.RefreshAuthIDRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.RefreshAuthIDRequest;
    return proto.customer_service.RefreshAuthIDRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.RefreshAuthIDRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.RefreshAuthIDRequest}
 */ proto.customer_service.RefreshAuthIDRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDecryptOnly(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLimit(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setStartingCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.RefreshAuthIDRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.RefreshAuthIDRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.RefreshAuthIDRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RefreshAuthIDRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDecryptOnly();
    if (f) writer.writeBool(1, f);
    f = message.getLimit();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getStartingCustomerId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional bool decrypt_only = 1;
 * @return {boolean}
 */ proto.customer_service.RefreshAuthIDRequest.prototype.getDecryptOnly = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.customer_service.RefreshAuthIDRequest} returns this
 */ proto.customer_service.RefreshAuthIDRequest.prototype.setDecryptOnly = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional int32 limit = 2;
 * @return {number}
 */ proto.customer_service.RefreshAuthIDRequest.prototype.getLimit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.RefreshAuthIDRequest} returns this
 */ proto.customer_service.RefreshAuthIDRequest.prototype.setLimit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string starting_customer_id = 3;
 * @return {string}
 */ proto.customer_service.RefreshAuthIDRequest.prototype.getStartingCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.RefreshAuthIDRequest} returns this
 */ proto.customer_service.RefreshAuthIDRequest.prototype.setStartingCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.RefreshAuthIDResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.RefreshAuthIDResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.RefreshAuthIDResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RefreshAuthIDResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.RefreshAuthIDResponse}
 */ proto.customer_service.RefreshAuthIDResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.RefreshAuthIDResponse;
    return proto.customer_service.RefreshAuthIDResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.RefreshAuthIDResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.RefreshAuthIDResponse}
 */ proto.customer_service.RefreshAuthIDResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.RefreshAuthIDResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.RefreshAuthIDResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.RefreshAuthIDResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.RefreshAuthIDResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCQEScoresRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCQEScoresRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCQEScoresRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCQEScoresRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCQEScoresRequest}
 */ proto.customer_service.GetCQEScoresRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCQEScoresRequest;
    return proto.customer_service.GetCQEScoresRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCQEScoresRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCQEScoresRequest}
 */ proto.customer_service.GetCQEScoresRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCQEScoresRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCQEScoresRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCQEScoresRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCQEScoresRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetCQEScoresRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetCQEScoresRequest} returns this
 */ proto.customer_service.GetCQEScoresRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.GetCQEScoresResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCQEScoresResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCQEScoresResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCQEScoresResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCQEScoresResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            scoresList: $8M67s.Message.toObjectList(msg.getScoresList(), $3QqPt.Score.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCQEScoresResponse}
 */ proto.customer_service.GetCQEScoresResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCQEScoresResponse;
    return proto.customer_service.GetCQEScoresResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCQEScoresResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCQEScoresResponse}
 */ proto.customer_service.GetCQEScoresResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Score;
                reader.readMessage(value, $3QqPt.Score.deserializeBinaryFromReader);
                msg.addScores(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCQEScoresResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCQEScoresResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCQEScoresResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCQEScoresResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getScoresList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.Score.serializeBinaryToWriter);
};
/**
 * repeated domain.Score scores = 1;
 * @return {!Array<!proto.domain.Score>}
 */ proto.customer_service.GetCQEScoresResponse.prototype.getScoresList = function() {
    return /** @type{!Array<!proto.domain.Score>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Score, 1);
};
/**
 * @param {!Array<!proto.domain.Score>} value
 * @return {!proto.customer_service.GetCQEScoresResponse} returns this
*/ proto.customer_service.GetCQEScoresResponse.prototype.setScoresList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.Score=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Score}
 */ proto.customer_service.GetCQEScoresResponse.prototype.addScores = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.Score, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.GetCQEScoresResponse} returns this
 */ proto.customer_service.GetCQEScoresResponse.prototype.clearScoresList = function() {
    return this.setScoresList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SendDeepLinkRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SendDeepLinkRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SendDeepLinkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendDeepLinkRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            marketingData: (f = msg.getMarketingData()) && proto.customer_service.SendDeepLinkRequest.MarketingMetaData.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SendDeepLinkRequest}
 */ proto.customer_service.SendDeepLinkRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SendDeepLinkRequest;
    return proto.customer_service.SendDeepLinkRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SendDeepLinkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SendDeepLinkRequest}
 */ proto.customer_service.SendDeepLinkRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 5:
                var value = new proto.customer_service.SendDeepLinkRequest.MarketingMetaData;
                reader.readMessage(value, proto.customer_service.SendDeepLinkRequest.MarketingMetaData.deserializeBinaryFromReader);
                msg.setMarketingData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SendDeepLinkRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SendDeepLinkRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SendDeepLinkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendDeepLinkRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getMarketingData();
    if (f != null) writer.writeMessage(5, f, proto.customer_service.SendDeepLinkRequest.MarketingMetaData.serializeBinaryToWriter);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SendDeepLinkRequest.MarketingMetaData.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.toObject = function(includeInstance, msg) {
        var f, obj = {
            category: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            facebookId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            section: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            segmentAnonymousId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            appsflyerUserId: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SendDeepLinkRequest.MarketingMetaData;
    return proto.customer_service.SendDeepLinkRequest.MarketingMetaData.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCategory(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFacebookId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSection(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSegmentAnonymousId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setAppsflyerUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SendDeepLinkRequest.MarketingMetaData.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCategory();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFacebookId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSection();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getSegmentAnonymousId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getAppsflyerUserId();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string category = 1;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.getCategory = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData} returns this
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.setCategory = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string facebook_id = 2;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.getFacebookId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData} returns this
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.setFacebookId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string section = 3;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.getSection = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData} returns this
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.setSection = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string segment_anonymous_id = 4;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.getSegmentAnonymousId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData} returns this
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.setSegmentAnonymousId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string appsflyer_user_id = 5;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.getAppsflyerUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest.MarketingMetaData} returns this
 */ proto.customer_service.SendDeepLinkRequest.MarketingMetaData.prototype.setAppsflyerUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest} returns this
 */ proto.customer_service.SendDeepLinkRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string email = 2;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest} returns this
 */ proto.customer_service.SendDeepLinkRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string first_name = 3;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest} returns this
 */ proto.customer_service.SendDeepLinkRequest.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_name = 4;
 * @return {string}
 */ proto.customer_service.SendDeepLinkRequest.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.SendDeepLinkRequest} returns this
 */ proto.customer_service.SendDeepLinkRequest.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional MarketingMetaData marketing_data = 5;
 * @return {?proto.customer_service.SendDeepLinkRequest.MarketingMetaData}
 */ proto.customer_service.SendDeepLinkRequest.prototype.getMarketingData = function() {
    return /** @type{?proto.customer_service.SendDeepLinkRequest.MarketingMetaData} */ $8M67s.Message.getWrapperField(this, proto.customer_service.SendDeepLinkRequest.MarketingMetaData, 5);
};
/**
 * @param {?proto.customer_service.SendDeepLinkRequest.MarketingMetaData|undefined} value
 * @return {!proto.customer_service.SendDeepLinkRequest} returns this
*/ proto.customer_service.SendDeepLinkRequest.prototype.setMarketingData = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.SendDeepLinkRequest} returns this
 */ proto.customer_service.SendDeepLinkRequest.prototype.clearMarketingData = function() {
    return this.setMarketingData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.SendDeepLinkRequest.prototype.hasMarketingData = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.SendDeepLinkResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.SendDeepLinkResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.SendDeepLinkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendDeepLinkResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.SendDeepLinkResponse}
 */ proto.customer_service.SendDeepLinkResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.SendDeepLinkResponse;
    return proto.customer_service.SendDeepLinkResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.SendDeepLinkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.SendDeepLinkResponse}
 */ proto.customer_service.SendDeepLinkResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.SendDeepLinkResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.SendDeepLinkResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.SendDeepLinkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.SendDeepLinkResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.OptIntoSMSRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.OptIntoSMSRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.OptIntoSMSRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.OptIntoSMSRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.OptIntoSMSRequest}
 */ proto.customer_service.OptIntoSMSRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.OptIntoSMSRequest;
    return proto.customer_service.OptIntoSMSRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.OptIntoSMSRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.OptIntoSMSRequest}
 */ proto.customer_service.OptIntoSMSRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.OptIntoSMSRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.OptIntoSMSRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.OptIntoSMSRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.OptIntoSMSRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.customer_service.OptIntoSMSRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.OptIntoSMSRequest} returns this
 */ proto.customer_service.OptIntoSMSRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.OptIntoSMSResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.OptIntoSMSResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.OptIntoSMSResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.OptIntoSMSResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.OptIntoSMSResponse}
 */ proto.customer_service.OptIntoSMSResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.OptIntoSMSResponse;
    return proto.customer_service.OptIntoSMSResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.OptIntoSMSResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.OptIntoSMSResponse}
 */ proto.customer_service.OptIntoSMSResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.OptIntoSMSResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.OptIntoSMSResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.OptIntoSMSResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.OptIntoSMSResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.TrackCustomerInAppsFlyerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.TrackCustomerInAppsFlyerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            appsflyerUserId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.TrackCustomerInAppsFlyerRequest}
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.TrackCustomerInAppsFlyerRequest;
    return proto.customer_service.TrackCustomerInAppsFlyerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.TrackCustomerInAppsFlyerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.TrackCustomerInAppsFlyerRequest}
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAppsflyerUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.TrackCustomerInAppsFlyerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.TrackCustomerInAppsFlyerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAppsflyerUserId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.TrackCustomerInAppsFlyerRequest} returns this
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string appsflyer_user_id = 2;
 * @return {string}
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.prototype.getAppsflyerUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.TrackCustomerInAppsFlyerRequest} returns this
 */ proto.customer_service.TrackCustomerInAppsFlyerRequest.prototype.setAppsflyerUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.TrackCustomerInAppsFlyerResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.TrackCustomerInAppsFlyerResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.TrackCustomerInAppsFlyerResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.TrackCustomerInAppsFlyerResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.TrackCustomerInAppsFlyerResponse}
 */ proto.customer_service.TrackCustomerInAppsFlyerResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.TrackCustomerInAppsFlyerResponse;
    return proto.customer_service.TrackCustomerInAppsFlyerResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.TrackCustomerInAppsFlyerResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.TrackCustomerInAppsFlyerResponse}
 */ proto.customer_service.TrackCustomerInAppsFlyerResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.TrackCustomerInAppsFlyerResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.TrackCustomerInAppsFlyerResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.TrackCustomerInAppsFlyerResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.TrackCustomerInAppsFlyerResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.Customer.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.Customer.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.Customer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.Customer.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            cqeStatus: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            createdAt: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.Customer}
 */ proto.customer_service.Customer.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.Customer;
    return proto.customer_service.Customer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.Customer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.Customer}
 */ proto.customer_service.Customer.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 4:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setCqeStatus(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreatedAt(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.Customer.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.Customer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.Customer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.Customer.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCqeStatus();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getCreatedAt();
    if (f !== 0) writer.writeInt64(5, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.customer_service.Customer.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.Customer} returns this
 */ proto.customer_service.Customer.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_name = 2;
 * @return {string}
 */ proto.customer_service.Customer.prototype.getCustomerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.Customer} returns this
 */ proto.customer_service.Customer.prototype.setCustomerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string account_number = 3;
 * @return {string}
 */ proto.customer_service.Customer.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.Customer} returns this
 */ proto.customer_service.Customer.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional domain.QualificationTier cqe_status = 4;
 * @return {!proto.domain.QualificationTier}
 */ proto.customer_service.Customer.prototype.getCqeStatus = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.customer_service.Customer} returns this
 */ proto.customer_service.Customer.prototype.setCqeStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional int64 created_at = 5;
 * @return {number}
 */ proto.customer_service.Customer.prototype.getCreatedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.Customer} returns this
 */ proto.customer_service.Customer.prototype.setCreatedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ListCustomersRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ListCustomersRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ListCustomersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ListCustomersRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            searchParam: (f = msg.getSearchParam()) && $9c7Du.SearchParams.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ListCustomersRequest}
 */ proto.customer_service.ListCustomersRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ListCustomersRequest;
    return proto.customer_service.ListCustomersRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ListCustomersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ListCustomersRequest}
 */ proto.customer_service.ListCustomersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9c7Du.SearchParams;
                reader.readMessage(value, $9c7Du.SearchParams.deserializeBinaryFromReader);
                msg.setSearchParam(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ListCustomersRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ListCustomersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ListCustomersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ListCustomersRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSearchParam();
    if (f != null) writer.writeMessage(1, f, $9c7Du.SearchParams.serializeBinaryToWriter);
};
/**
 * optional web.SearchParams search_param = 1;
 * @return {?proto.web.SearchParams}
 */ proto.customer_service.ListCustomersRequest.prototype.getSearchParam = function() {
    return /** @type{?proto.web.SearchParams} */ $8M67s.Message.getWrapperField(this, $9c7Du.SearchParams, 1);
};
/**
 * @param {?proto.web.SearchParams|undefined} value
 * @return {!proto.customer_service.ListCustomersRequest} returns this
*/ proto.customer_service.ListCustomersRequest.prototype.setSearchParam = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.ListCustomersRequest} returns this
 */ proto.customer_service.ListCustomersRequest.prototype.clearSearchParam = function() {
    return this.setSearchParam(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.ListCustomersRequest.prototype.hasSearchParam = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.ListCustomersResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ListCustomersResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ListCustomersResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ListCustomersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ListCustomersResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dataList: $8M67s.Message.toObjectList(msg.getDataList(), proto.customer_service.Customer.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ListCustomersResponse}
 */ proto.customer_service.ListCustomersResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ListCustomersResponse;
    return proto.customer_service.ListCustomersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ListCustomersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ListCustomersResponse}
 */ proto.customer_service.ListCustomersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_service.Customer;
                reader.readMessage(value, proto.customer_service.Customer.deserializeBinaryFromReader);
                msg.addData(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ListCustomersResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ListCustomersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ListCustomersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ListCustomersResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDataList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.customer_service.Customer.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * repeated Customer data = 1;
 * @return {!Array<!proto.customer_service.Customer>}
 */ proto.customer_service.ListCustomersResponse.prototype.getDataList = function() {
    return /** @type{!Array<!proto.customer_service.Customer>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.customer_service.Customer, 1);
};
/**
 * @param {!Array<!proto.customer_service.Customer>} value
 * @return {!proto.customer_service.ListCustomersResponse} returns this
*/ proto.customer_service.ListCustomersResponse.prototype.setDataList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.customer_service.Customer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.customer_service.Customer}
 */ proto.customer_service.ListCustomersResponse.prototype.addData = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.customer_service.Customer, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.ListCustomersResponse} returns this
 */ proto.customer_service.ListCustomersResponse.prototype.clearDataList = function() {
    return this.setDataList([]);
};
/**
 * optional int32 total = 2;
 * @return {number}
 */ proto.customer_service.ListCustomersResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_service.ListCustomersResponse} returns this
 */ proto.customer_service.ListCustomersResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.DecryptCustomerDataRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.DecryptCustomerDataRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.DecryptCustomerDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.DecryptCustomerDataRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.DecryptCustomerDataRequest}
 */ proto.customer_service.DecryptCustomerDataRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.DecryptCustomerDataRequest;
    return proto.customer_service.DecryptCustomerDataRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.DecryptCustomerDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.DecryptCustomerDataRequest}
 */ proto.customer_service.DecryptCustomerDataRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.DecryptCustomerDataRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.DecryptCustomerDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.DecryptCustomerDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.DecryptCustomerDataRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.DecryptCustomerDataResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.DecryptCustomerDataResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.DecryptCustomerDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.DecryptCustomerDataResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.DecryptCustomerDataResponse}
 */ proto.customer_service.DecryptCustomerDataResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.DecryptCustomerDataResponse;
    return proto.customer_service.DecryptCustomerDataResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.DecryptCustomerDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.DecryptCustomerDataResponse}
 */ proto.customer_service.DecryptCustomerDataResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.DecryptCustomerDataResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.DecryptCustomerDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.DecryptCustomerDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.DecryptCustomerDataResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerByAccountNumberRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerByAccountNumberRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerByAccountNumberRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByAccountNumberRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerByAccountNumberRequest}
 */ proto.customer_service.GetCustomerByAccountNumberRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerByAccountNumberRequest;
    return proto.customer_service.GetCustomerByAccountNumberRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerByAccountNumberRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerByAccountNumberRequest}
 */ proto.customer_service.GetCustomerByAccountNumberRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerByAccountNumberRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerByAccountNumberRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerByAccountNumberRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByAccountNumberRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string account_number = 1;
 * @return {string}
 */ proto.customer_service.GetCustomerByAccountNumberRequest.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetCustomerByAccountNumberRequest} returns this
 */ proto.customer_service.GetCustomerByAccountNumberRequest.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetCustomerByAccountNumberResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetCustomerByAccountNumberResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetCustomerByAccountNumberResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByAccountNumberResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetCustomerByAccountNumberResponse}
 */ proto.customer_service.GetCustomerByAccountNumberResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetCustomerByAccountNumberResponse;
    return proto.customer_service.GetCustomerByAccountNumberResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetCustomerByAccountNumberResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetCustomerByAccountNumberResponse}
 */ proto.customer_service.GetCustomerByAccountNumberResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetCustomerByAccountNumberResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetCustomerByAccountNumberResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetCustomerByAccountNumberResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetCustomerByAccountNumberResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomer();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Customer.serializeBinaryToWriter);
};
/**
 * optional domain.Customer customer = 1;
 * @return {?proto.domain.Customer}
 */ proto.customer_service.GetCustomerByAccountNumberResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 1);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.customer_service.GetCustomerByAccountNumberResponse} returns this
*/ proto.customer_service.GetCustomerByAccountNumberResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.GetCustomerByAccountNumberResponse} returns this
 */ proto.customer_service.GetCustomerByAccountNumberResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.GetCustomerByAccountNumberResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ListClientsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ListClientsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ListClientsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ListClientsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ListClientsRequest}
 */ proto.customer_service.ListClientsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ListClientsRequest;
    return proto.customer_service.ListClientsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ListClientsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ListClientsRequest}
 */ proto.customer_service.ListClientsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ListClientsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ListClientsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ListClientsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ListClientsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_service.ListClientsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ListClientsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ListClientsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ListClientsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ListClientsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            clientsList: $8M67s.Message.toObjectList(msg.getClientsList(), proto.customer_service.Client.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ListClientsResponse}
 */ proto.customer_service.ListClientsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ListClientsResponse;
    return proto.customer_service.ListClientsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ListClientsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ListClientsResponse}
 */ proto.customer_service.ListClientsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_service.Client;
                reader.readMessage(value, proto.customer_service.Client.deserializeBinaryFromReader);
                msg.addClients(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ListClientsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ListClientsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ListClientsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ListClientsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getClientsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.customer_service.Client.serializeBinaryToWriter);
};
/**
 * repeated Client clients = 1;
 * @return {!Array<!proto.customer_service.Client>}
 */ proto.customer_service.ListClientsResponse.prototype.getClientsList = function() {
    return /** @type{!Array<!proto.customer_service.Client>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.customer_service.Client, 1);
};
/**
 * @param {!Array<!proto.customer_service.Client>} value
 * @return {!proto.customer_service.ListClientsResponse} returns this
*/ proto.customer_service.ListClientsResponse.prototype.setClientsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.customer_service.Client=} opt_value
 * @param {number=} opt_index
 * @return {!proto.customer_service.Client}
 */ proto.customer_service.ListClientsResponse.prototype.addClients = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.customer_service.Client, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_service.ListClientsResponse} returns this
 */ proto.customer_service.ListClientsResponse.prototype.clearClientsList = function() {
    return this.setClientsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.Client.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.Client.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.Client} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.Client.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.Client}
 */ proto.customer_service.Client.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.Client;
    return proto.customer_service.Client.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.Client} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.Client}
 */ proto.customer_service.Client.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.Client.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.Client.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.Client} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.Client.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.customer_service.Client.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.Client} returns this
 */ proto.customer_service.Client.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.customer_service.Client.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.Client} returns this
 */ proto.customer_service.Client.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ChangeCustomerClientIdRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ChangeCustomerClientIdRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ChangeCustomerClientIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ChangeCustomerClientIdRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            newClientId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ChangeCustomerClientIdRequest}
 */ proto.customer_service.ChangeCustomerClientIdRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ChangeCustomerClientIdRequest;
    return proto.customer_service.ChangeCustomerClientIdRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ChangeCustomerClientIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ChangeCustomerClientIdRequest}
 */ proto.customer_service.ChangeCustomerClientIdRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setNewClientId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ChangeCustomerClientIdRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ChangeCustomerClientIdRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ChangeCustomerClientIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ChangeCustomerClientIdRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getNewClientId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.ChangeCustomerClientIdRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ChangeCustomerClientIdRequest} returns this
 */ proto.customer_service.ChangeCustomerClientIdRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string new_client_id = 2;
 * @return {string}
 */ proto.customer_service.ChangeCustomerClientIdRequest.prototype.getNewClientId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.ChangeCustomerClientIdRequest} returns this
 */ proto.customer_service.ChangeCustomerClientIdRequest.prototype.setNewClientId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ChangeCustomerClientIdResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ChangeCustomerClientIdResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ChangeCustomerClientIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ChangeCustomerClientIdResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ChangeCustomerClientIdResponse}
 */ proto.customer_service.ChangeCustomerClientIdResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ChangeCustomerClientIdResponse;
    return proto.customer_service.ChangeCustomerClientIdResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ChangeCustomerClientIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ChangeCustomerClientIdResponse}
 */ proto.customer_service.ChangeCustomerClientIdResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ChangeCustomerClientIdResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ChangeCustomerClientIdResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ChangeCustomerClientIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ChangeCustomerClientIdResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpdateAutoPayAuthorizationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpdateAutoPayAuthorizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            autoPayAuthorization: (f = msg.getAutoPayAuthorization()) && $cyjZp.AutoPayAuthorization.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpdateAutoPayAuthorizationRequest}
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpdateAutoPayAuthorizationRequest;
    return proto.customer_service.UpdateAutoPayAuthorizationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpdateAutoPayAuthorizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpdateAutoPayAuthorizationRequest}
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new $cyjZp.AutoPayAuthorization;
                reader.readMessage(value, $cyjZp.AutoPayAuthorization.deserializeBinaryFromReader);
                msg.setAutoPayAuthorization(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpdateAutoPayAuthorizationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpdateAutoPayAuthorizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAutoPayAuthorization();
    if (f != null) writer.writeMessage(2, f, $cyjZp.AutoPayAuthorization.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.UpdateAutoPayAuthorizationRequest} returns this
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional document_service.AutoPayAuthorization auto_pay_authorization = 2;
 * @return {?proto.document_service.AutoPayAuthorization}
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.prototype.getAutoPayAuthorization = function() {
    return /** @type{?proto.document_service.AutoPayAuthorization} */ $8M67s.Message.getWrapperField(this, $cyjZp.AutoPayAuthorization, 2);
};
/**
 * @param {?proto.document_service.AutoPayAuthorization|undefined} value
 * @return {!proto.customer_service.UpdateAutoPayAuthorizationRequest} returns this
*/ proto.customer_service.UpdateAutoPayAuthorizationRequest.prototype.setAutoPayAuthorization = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.UpdateAutoPayAuthorizationRequest} returns this
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.prototype.clearAutoPayAuthorization = function() {
    return this.setAutoPayAuthorization(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.UpdateAutoPayAuthorizationRequest.prototype.hasAutoPayAuthorization = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.UpdateAutoPayAuthorizationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.UpdateAutoPayAuthorizationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.UpdateAutoPayAuthorizationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateAutoPayAuthorizationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.UpdateAutoPayAuthorizationResponse}
 */ proto.customer_service.UpdateAutoPayAuthorizationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.UpdateAutoPayAuthorizationResponse;
    return proto.customer_service.UpdateAutoPayAuthorizationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.UpdateAutoPayAuthorizationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.UpdateAutoPayAuthorizationResponse}
 */ proto.customer_service.UpdateAutoPayAuthorizationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.UpdateAutoPayAuthorizationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.UpdateAutoPayAuthorizationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.UpdateAutoPayAuthorizationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.UpdateAutoPayAuthorizationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetAutoPayAuthorizationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetAutoPayAuthorizationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetAutoPayAuthorizationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAutoPayAuthorizationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetAutoPayAuthorizationRequest}
 */ proto.customer_service.GetAutoPayAuthorizationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetAutoPayAuthorizationRequest;
    return proto.customer_service.GetAutoPayAuthorizationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetAutoPayAuthorizationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetAutoPayAuthorizationRequest}
 */ proto.customer_service.GetAutoPayAuthorizationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetAutoPayAuthorizationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetAutoPayAuthorizationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetAutoPayAuthorizationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAutoPayAuthorizationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_service.GetAutoPayAuthorizationRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_service.GetAutoPayAuthorizationRequest} returns this
 */ proto.customer_service.GetAutoPayAuthorizationRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.GetAutoPayAuthorizationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.GetAutoPayAuthorizationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.GetAutoPayAuthorizationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAutoPayAuthorizationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            autoPayAuthorization: (f = msg.getAutoPayAuthorization()) && $cyjZp.AutoPayAuthorization.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.GetAutoPayAuthorizationResponse}
 */ proto.customer_service.GetAutoPayAuthorizationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.GetAutoPayAuthorizationResponse;
    return proto.customer_service.GetAutoPayAuthorizationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.GetAutoPayAuthorizationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.GetAutoPayAuthorizationResponse}
 */ proto.customer_service.GetAutoPayAuthorizationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $cyjZp.AutoPayAuthorization;
                reader.readMessage(value, $cyjZp.AutoPayAuthorization.deserializeBinaryFromReader);
                msg.setAutoPayAuthorization(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.GetAutoPayAuthorizationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.GetAutoPayAuthorizationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.GetAutoPayAuthorizationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.GetAutoPayAuthorizationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAutoPayAuthorization();
    if (f != null) writer.writeMessage(1, f, $cyjZp.AutoPayAuthorization.serializeBinaryToWriter);
};
/**
 * optional document_service.AutoPayAuthorization auto_pay_authorization = 1;
 * @return {?proto.document_service.AutoPayAuthorization}
 */ proto.customer_service.GetAutoPayAuthorizationResponse.prototype.getAutoPayAuthorization = function() {
    return /** @type{?proto.document_service.AutoPayAuthorization} */ $8M67s.Message.getWrapperField(this, $cyjZp.AutoPayAuthorization, 1);
};
/**
 * @param {?proto.document_service.AutoPayAuthorization|undefined} value
 * @return {!proto.customer_service.GetAutoPayAuthorizationResponse} returns this
*/ proto.customer_service.GetAutoPayAuthorizationResponse.prototype.setAutoPayAuthorization = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_service.GetAutoPayAuthorizationResponse} returns this
 */ proto.customer_service.GetAutoPayAuthorizationResponse.prototype.clearAutoPayAuthorization = function() {
    return this.setAutoPayAuthorization(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_service.GetAutoPayAuthorizationResponse.prototype.hasAutoPayAuthorization = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ImportDocumentDataRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ImportDocumentDataRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ImportDocumentDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ImportDocumentDataRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ImportDocumentDataRequest}
 */ proto.customer_service.ImportDocumentDataRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ImportDocumentDataRequest;
    return proto.customer_service.ImportDocumentDataRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ImportDocumentDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ImportDocumentDataRequest}
 */ proto.customer_service.ImportDocumentDataRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ImportDocumentDataRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ImportDocumentDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ImportDocumentDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ImportDocumentDataRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_service.ImportDocumentDataResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_service.ImportDocumentDataResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_service.ImportDocumentDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ImportDocumentDataResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_service.ImportDocumentDataResponse}
 */ proto.customer_service.ImportDocumentDataResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_service.ImportDocumentDataResponse;
    return proto.customer_service.ImportDocumentDataResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_service.ImportDocumentDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_service.ImportDocumentDataResponse}
 */ proto.customer_service.ImportDocumentDataResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_service.ImportDocumentDataResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_service.ImportDocumentDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_service.ImportDocumentDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_service.ImportDocumentDataResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * @enum {number}
 */ proto.customer_service.ClientOSType = {
    UNDEFINED: 0,
    IOS: 1,
    ANDROID: 2,
    WEB: 3
};
/**
 * @enum {number}
 */ proto.customer_service.QualificationState = {
    NEEDS_REVIEW: 0,
    AUTO_APPROVED: 1,
    AUTO_REJECTED: 2
};
$4d6e9e4d0144e462$var$goog.object.extend(module.exports, proto.customer_service);

});
parcelRegister("cyjZp", function(module, exports) {
// source: document_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $92382a85b8f672d6$var$goog = $8M67s;
var $92382a85b8f672d6$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$92382a85b8f672d6$var$goog.object.extend(proto, $3QqPt);

var $gjhG2 = parcelRequire("gjhG2");
$92382a85b8f672d6$var$goog.object.extend(proto, $gjhG2);

var $hOsJC = parcelRequire("hOsJC");
$92382a85b8f672d6$var$goog.object.extend(proto, $hOsJC);

var $26u10 = parcelRequire("26u10");
$92382a85b8f672d6$var$goog.object.extend(proto, $26u10);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.Authorizations', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.AutoPayAuthorization', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.CustomerDocumentMeta', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GeneratePickupReceiptRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GeneratePickupReceiptResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetAllCustomerDocumentsRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetAllCustomerDocumentsResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetCustomerDocumentRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetCustomerDocumentResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetCustomerDocumentsRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetCustomerDocumentsResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetOwnDocumentRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetOwnDocumentResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetOwnDocumentsRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetOwnDocumentsResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetSubscriptionContractToSignRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetSubscriptionContractToSignResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetVehicleDocumentRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.GetVehicleDocumentResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.InitProjectionsRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.InitProjectionsResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.Inspection', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.InspectionPhoto', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.InspectionReport', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.Inspections', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.InsuranceCard', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.InsuranceCards', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.PickupReceipt', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.PopulateTemplateRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.PopulateTemplateResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.SendReceiptRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.SendReceiptResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.SignContractRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.SignContractResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.SubscriptionContract', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.TemplateType', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UnsignedCustomerContractResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UploadCustomerInspectionImageRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UploadCustomerInspectionImageResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UploadInsuranceCardRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UploadInsuranceCardResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UploadSingleCustomerInspectionImageRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UploadSingleCustomerInspectionImageResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UploadVehicleDocumentRequest', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.UploadVehicleDocumentResponse', null, $92382a85b8f672d6$var$global);
$92382a85b8f672d6$var$goog.exportSymbol('proto.document_service.VehicleDocumentMeta', null, $92382a85b8f672d6$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.PopulateTemplateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.PopulateTemplateRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.PopulateTemplateRequest.displayName = 'proto.document_service.PopulateTemplateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.PopulateTemplateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.PopulateTemplateResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.PopulateTemplateResponse.displayName = 'proto.document_service.PopulateTemplateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UploadInsuranceCardRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UploadInsuranceCardRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UploadInsuranceCardRequest.displayName = 'proto.document_service.UploadInsuranceCardRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UploadInsuranceCardResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UploadInsuranceCardResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UploadInsuranceCardResponse.displayName = 'proto.document_service.UploadInsuranceCardResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UploadSingleCustomerInspectionImageRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UploadSingleCustomerInspectionImageRequest.displayName = 'proto.document_service.UploadSingleCustomerInspectionImageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UploadCustomerInspectionImageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.document_service.UploadCustomerInspectionImageRequest.repeatedFields_, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UploadCustomerInspectionImageRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UploadCustomerInspectionImageRequest.displayName = 'proto.document_service.UploadCustomerInspectionImageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UploadSingleCustomerInspectionImageResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UploadSingleCustomerInspectionImageResponse.displayName = 'proto.document_service.UploadSingleCustomerInspectionImageResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UploadCustomerInspectionImageResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UploadCustomerInspectionImageResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UploadCustomerInspectionImageResponse.displayName = 'proto.document_service.UploadCustomerInspectionImageResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UploadVehicleDocumentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UploadVehicleDocumentRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UploadVehicleDocumentRequest.displayName = 'proto.document_service.UploadVehicleDocumentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UploadVehicleDocumentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UploadVehicleDocumentResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UploadVehicleDocumentResponse.displayName = 'proto.document_service.UploadVehicleDocumentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetVehicleDocumentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetVehicleDocumentRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetVehicleDocumentRequest.displayName = 'proto.document_service.GetVehicleDocumentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetVehicleDocumentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetVehicleDocumentResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetVehicleDocumentResponse.displayName = 'proto.document_service.GetVehicleDocumentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetSubscriptionContractToSignRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetSubscriptionContractToSignRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetSubscriptionContractToSignRequest.displayName = 'proto.document_service.GetSubscriptionContractToSignRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetSubscriptionContractToSignResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetSubscriptionContractToSignResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetSubscriptionContractToSignResponse.displayName = 'proto.document_service.GetSubscriptionContractToSignResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.CustomerDocumentMeta = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.CustomerDocumentMeta, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.CustomerDocumentMeta.displayName = 'proto.document_service.CustomerDocumentMeta';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.VehicleDocumentMeta = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.VehicleDocumentMeta, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.VehicleDocumentMeta.displayName = 'proto.document_service.VehicleDocumentMeta';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.SubscriptionContract = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.SubscriptionContract, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.SubscriptionContract.displayName = 'proto.document_service.SubscriptionContract';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.PickupReceipt = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.PickupReceipt, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.PickupReceipt.displayName = 'proto.document_service.PickupReceipt';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.AutoPayAuthorization = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.AutoPayAuthorization, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.AutoPayAuthorization.displayName = 'proto.document_service.AutoPayAuthorization';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.Authorizations = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.document_service.Authorizations.repeatedFields_, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.Authorizations, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.Authorizations.displayName = 'proto.document_service.Authorizations';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.InspectionPhoto = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.InspectionPhoto, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.InspectionPhoto.displayName = 'proto.document_service.InspectionPhoto';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.InspectionReport = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.InspectionReport, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.InspectionReport.displayName = 'proto.document_service.InspectionReport';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.Inspection = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.document_service.Inspection.repeatedFields_, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.Inspection, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.Inspection.displayName = 'proto.document_service.Inspection';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.Inspections = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.document_service.Inspections.repeatedFields_, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.Inspections, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.Inspections.displayName = 'proto.document_service.Inspections';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.InsuranceCard = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.InsuranceCard, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.InsuranceCard.displayName = 'proto.document_service.InsuranceCard';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.InsuranceCards = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.document_service.InsuranceCards.repeatedFields_, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.InsuranceCards, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.InsuranceCards.displayName = 'proto.document_service.InsuranceCards';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetOwnDocumentsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetOwnDocumentsRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetOwnDocumentsRequest.displayName = 'proto.document_service.GetOwnDocumentsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetOwnDocumentsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetOwnDocumentsResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetOwnDocumentsResponse.displayName = 'proto.document_service.GetOwnDocumentsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetOwnDocumentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetOwnDocumentRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetOwnDocumentRequest.displayName = 'proto.document_service.GetOwnDocumentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetOwnDocumentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetOwnDocumentResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetOwnDocumentResponse.displayName = 'proto.document_service.GetOwnDocumentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.SignContractRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.SignContractRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.SignContractRequest.displayName = 'proto.document_service.SignContractRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.SignContractResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.SignContractResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.SignContractResponse.displayName = 'proto.document_service.SignContractResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GeneratePickupReceiptRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GeneratePickupReceiptRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GeneratePickupReceiptRequest.displayName = 'proto.document_service.GeneratePickupReceiptRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GeneratePickupReceiptResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GeneratePickupReceiptResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GeneratePickupReceiptResponse.displayName = 'proto.document_service.GeneratePickupReceiptResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.UnsignedCustomerContractResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.UnsignedCustomerContractResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.UnsignedCustomerContractResponse.displayName = 'proto.document_service.UnsignedCustomerContractResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetAllCustomerDocumentsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetAllCustomerDocumentsRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetAllCustomerDocumentsRequest.displayName = 'proto.document_service.GetAllCustomerDocumentsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetAllCustomerDocumentsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.document_service.GetAllCustomerDocumentsResponse.repeatedFields_, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetAllCustomerDocumentsResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetAllCustomerDocumentsResponse.displayName = 'proto.document_service.GetAllCustomerDocumentsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetCustomerDocumentsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetCustomerDocumentsRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetCustomerDocumentsRequest.displayName = 'proto.document_service.GetCustomerDocumentsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetCustomerDocumentsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetCustomerDocumentsResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetCustomerDocumentsResponse.displayName = 'proto.document_service.GetCustomerDocumentsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetCustomerDocumentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetCustomerDocumentRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetCustomerDocumentRequest.displayName = 'proto.document_service.GetCustomerDocumentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.GetCustomerDocumentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.GetCustomerDocumentResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.GetCustomerDocumentResponse.displayName = 'proto.document_service.GetCustomerDocumentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.InitProjectionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.InitProjectionsRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.InitProjectionsRequest.displayName = 'proto.document_service.InitProjectionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.InitProjectionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.InitProjectionsResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.InitProjectionsResponse.displayName = 'proto.document_service.InitProjectionsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.SendReceiptRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.SendReceiptRequest, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.SendReceiptRequest.displayName = 'proto.document_service.SendReceiptRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.document_service.SendReceiptResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$92382a85b8f672d6$var$goog.inherits(proto.document_service.SendReceiptResponse, $8M67s.Message);
if ($92382a85b8f672d6$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.document_service.SendReceiptResponse.displayName = 'proto.document_service.SendReceiptResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.PopulateTemplateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.PopulateTemplateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.PopulateTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.PopulateTemplateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            templateId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            payload: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            templateType: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.PopulateTemplateRequest}
 */ proto.document_service.PopulateTemplateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.PopulateTemplateRequest;
    return proto.document_service.PopulateTemplateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.PopulateTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.PopulateTemplateRequest}
 */ proto.document_service.PopulateTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setTemplateId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPayload(value);
                break;
            case 3:
                var value = /** @type {!proto.document_service.TemplateType} */ reader.readEnum();
                msg.setTemplateType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.PopulateTemplateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.PopulateTemplateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.PopulateTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.PopulateTemplateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTemplateId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPayload();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getTemplateType();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional string template_id = 1;
 * @return {string}
 */ proto.document_service.PopulateTemplateRequest.prototype.getTemplateId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.PopulateTemplateRequest} returns this
 */ proto.document_service.PopulateTemplateRequest.prototype.setTemplateId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string payload = 2;
 * @return {string}
 */ proto.document_service.PopulateTemplateRequest.prototype.getPayload = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.PopulateTemplateRequest} returns this
 */ proto.document_service.PopulateTemplateRequest.prototype.setPayload = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional TemplateType template_type = 3;
 * @return {!proto.document_service.TemplateType}
 */ proto.document_service.PopulateTemplateRequest.prototype.getTemplateType = function() {
    return /** @type {!proto.document_service.TemplateType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.document_service.TemplateType} value
 * @return {!proto.document_service.PopulateTemplateRequest} returns this
 */ proto.document_service.PopulateTemplateRequest.prototype.setTemplateType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.PopulateTemplateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.PopulateTemplateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.PopulateTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.PopulateTemplateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            htmlContent: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.PopulateTemplateResponse}
 */ proto.document_service.PopulateTemplateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.PopulateTemplateResponse;
    return proto.document_service.PopulateTemplateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.PopulateTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.PopulateTemplateResponse}
 */ proto.document_service.PopulateTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setHtmlContent(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.PopulateTemplateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.PopulateTemplateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.PopulateTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.PopulateTemplateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getHtmlContent();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string html_content = 1;
 * @return {string}
 */ proto.document_service.PopulateTemplateResponse.prototype.getHtmlContent = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.PopulateTemplateResponse} returns this
 */ proto.document_service.PopulateTemplateResponse.prototype.setHtmlContent = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UploadInsuranceCardRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UploadInsuranceCardRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UploadInsuranceCardRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadInsuranceCardRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            insuranceCardBinary: msg.getInsuranceCardBinary_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UploadInsuranceCardRequest}
 */ proto.document_service.UploadInsuranceCardRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UploadInsuranceCardRequest;
    return proto.document_service.UploadInsuranceCardRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UploadInsuranceCardRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UploadInsuranceCardRequest}
 */ proto.document_service.UploadInsuranceCardRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setInsuranceCardBinary(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UploadInsuranceCardRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UploadInsuranceCardRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UploadInsuranceCardRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadInsuranceCardRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getInsuranceCardBinary_asU8();
    if (f.length > 0) writer.writeBytes(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.document_service.UploadInsuranceCardRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadInsuranceCardRequest} returns this
 */ proto.document_service.UploadInsuranceCardRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.document_service.UploadInsuranceCardRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadInsuranceCardRequest} returns this
 */ proto.document_service.UploadInsuranceCardRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional bytes insurance_card_binary = 3;
 * @return {!(string|Uint8Array)}
 */ proto.document_service.UploadInsuranceCardRequest.prototype.getInsuranceCardBinary = function() {
    return /** @type {!(string|Uint8Array)} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * optional bytes insurance_card_binary = 3;
 * This is a type-conversion wrapper around `getInsuranceCardBinary()`
 * @return {string}
 */ proto.document_service.UploadInsuranceCardRequest.prototype.getInsuranceCardBinary_asB64 = function() {
    return /** @type {string} */ $8M67s.Message.bytesAsB64(this.getInsuranceCardBinary());
};
/**
 * optional bytes insurance_card_binary = 3;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getInsuranceCardBinary()`
 * @return {!Uint8Array}
 */ proto.document_service.UploadInsuranceCardRequest.prototype.getInsuranceCardBinary_asU8 = function() {
    return /** @type {!Uint8Array} */ $8M67s.Message.bytesAsU8(this.getInsuranceCardBinary());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.document_service.UploadInsuranceCardRequest} returns this
 */ proto.document_service.UploadInsuranceCardRequest.prototype.setInsuranceCardBinary = function(value) {
    return $8M67s.Message.setProto3BytesField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UploadInsuranceCardResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UploadInsuranceCardResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UploadInsuranceCardResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadInsuranceCardResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UploadInsuranceCardResponse}
 */ proto.document_service.UploadInsuranceCardResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UploadInsuranceCardResponse;
    return proto.document_service.UploadInsuranceCardResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UploadInsuranceCardResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UploadInsuranceCardResponse}
 */ proto.document_service.UploadInsuranceCardResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UploadInsuranceCardResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UploadInsuranceCardResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UploadInsuranceCardResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadInsuranceCardResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string document_id = 1;
 * @return {string}
 */ proto.document_service.UploadInsuranceCardResponse.prototype.getDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadInsuranceCardResponse} returns this
 */ proto.document_service.UploadInsuranceCardResponse.prototype.setDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UploadSingleCustomerInspectionImageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UploadSingleCustomerInspectionImageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            indexnum: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            image: msg.getImage_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageRequest}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UploadSingleCustomerInspectionImageRequest;
    return proto.document_service.UploadSingleCustomerInspectionImageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UploadSingleCustomerInspectionImageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageRequest}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setIndexnum(value);
                break;
            case 5:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setImage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UploadSingleCustomerInspectionImageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UploadSingleCustomerInspectionImageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getIndexnum();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getImage_asU8();
    if (f.length > 0) writer.writeBytes(5, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string inspection_id = 3;
 * @return {string}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 indexNum = 4;
 * @return {number}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.getIndexnum = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.setIndexnum = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional bytes image = 5;
 * @return {!(string|Uint8Array)}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.getImage = function() {
    return /** @type {!(string|Uint8Array)} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * optional bytes image = 5;
 * This is a type-conversion wrapper around `getImage()`
 * @return {string}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.getImage_asB64 = function() {
    return /** @type {string} */ $8M67s.Message.bytesAsB64(this.getImage());
};
/**
 * optional bytes image = 5;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImage()`
 * @return {!Uint8Array}
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.getImage_asU8 = function() {
    return /** @type {!Uint8Array} */ $8M67s.Message.bytesAsU8(this.getImage());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadSingleCustomerInspectionImageRequest.prototype.setImage = function(value) {
    return $8M67s.Message.setProto3BytesField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.document_service.UploadCustomerInspectionImageRequest.repeatedFields_ = [
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UploadCustomerInspectionImageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UploadCustomerInspectionImageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadCustomerInspectionImageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            imagesList: msg.getImagesList_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UploadCustomerInspectionImageRequest}
 */ proto.document_service.UploadCustomerInspectionImageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UploadCustomerInspectionImageRequest;
    return proto.document_service.UploadCustomerInspectionImageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UploadCustomerInspectionImageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UploadCustomerInspectionImageRequest}
 */ proto.document_service.UploadCustomerInspectionImageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 4:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.addImages(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UploadCustomerInspectionImageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UploadCustomerInspectionImageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadCustomerInspectionImageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getImagesList_asU8();
    if (f.length > 0) writer.writeRepeatedBytes(4, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string inspection_id = 3;
 * @return {string}
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * repeated bytes images = 4;
 * @return {!(Array<!Uint8Array>|Array<string>)}
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.getImagesList = function() {
    return /** @type {!(Array<!Uint8Array>|Array<string>)} */ $8M67s.Message.getRepeatedField(this, 4);
};
/**
 * repeated bytes images = 4;
 * This is a type-conversion wrapper around `getImagesList()`
 * @return {!Array<string>}
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.getImagesList_asB64 = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.bytesListAsB64(this.getImagesList());
};
/**
 * repeated bytes images = 4;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getImagesList()`
 * @return {!Array<!Uint8Array>}
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.getImagesList_asU8 = function() {
    return /** @type {!Array<!Uint8Array>} */ $8M67s.Message.bytesListAsU8(this.getImagesList());
};
/**
 * @param {!(Array<!Uint8Array>|Array<string>)} value
 * @return {!proto.document_service.UploadCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.setImagesList = function(value) {
    return $8M67s.Message.setField(this, 4, value || []);
};
/**
 * @param {!(string|Uint8Array)} value
 * @param {number=} opt_index
 * @return {!proto.document_service.UploadCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.addImages = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 4, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.document_service.UploadCustomerInspectionImageRequest} returns this
 */ proto.document_service.UploadCustomerInspectionImageRequest.prototype.clearImagesList = function() {
    return this.setImagesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UploadSingleCustomerInspectionImageResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UploadSingleCustomerInspectionImageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageResponse}
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UploadSingleCustomerInspectionImageResponse;
    return proto.document_service.UploadSingleCustomerInspectionImageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UploadSingleCustomerInspectionImageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageResponse}
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UploadSingleCustomerInspectionImageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UploadSingleCustomerInspectionImageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadSingleCustomerInspectionImageResponse} returns this
 */ proto.document_service.UploadSingleCustomerInspectionImageResponse.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UploadCustomerInspectionImageResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UploadCustomerInspectionImageResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UploadCustomerInspectionImageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadCustomerInspectionImageResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UploadCustomerInspectionImageResponse}
 */ proto.document_service.UploadCustomerInspectionImageResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UploadCustomerInspectionImageResponse;
    return proto.document_service.UploadCustomerInspectionImageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UploadCustomerInspectionImageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UploadCustomerInspectionImageResponse}
 */ proto.document_service.UploadCustomerInspectionImageResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UploadCustomerInspectionImageResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UploadCustomerInspectionImageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UploadCustomerInspectionImageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadCustomerInspectionImageResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.document_service.UploadCustomerInspectionImageResponse.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadCustomerInspectionImageResponse} returns this
 */ proto.document_service.UploadCustomerInspectionImageResponse.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UploadVehicleDocumentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UploadVehicleDocumentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UploadVehicleDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadVehicleDocumentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vin: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            documentPayload: msg.getDocumentPayload_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UploadVehicleDocumentRequest}
 */ proto.document_service.UploadVehicleDocumentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UploadVehicleDocumentRequest;
    return proto.document_service.UploadVehicleDocumentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UploadVehicleDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UploadVehicleDocumentRequest}
 */ proto.document_service.UploadVehicleDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 2:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setDocumentPayload(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UploadVehicleDocumentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UploadVehicleDocumentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UploadVehicleDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadVehicleDocumentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVin();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDocumentPayload_asU8();
    if (f.length > 0) writer.writeBytes(2, f);
};
/**
 * optional string vin = 1;
 * @return {string}
 */ proto.document_service.UploadVehicleDocumentRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadVehicleDocumentRequest} returns this
 */ proto.document_service.UploadVehicleDocumentRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bytes document_payload = 2;
 * @return {!(string|Uint8Array)}
 */ proto.document_service.UploadVehicleDocumentRequest.prototype.getDocumentPayload = function() {
    return /** @type {!(string|Uint8Array)} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * optional bytes document_payload = 2;
 * This is a type-conversion wrapper around `getDocumentPayload()`
 * @return {string}
 */ proto.document_service.UploadVehicleDocumentRequest.prototype.getDocumentPayload_asB64 = function() {
    return /** @type {string} */ $8M67s.Message.bytesAsB64(this.getDocumentPayload());
};
/**
 * optional bytes document_payload = 2;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDocumentPayload()`
 * @return {!Uint8Array}
 */ proto.document_service.UploadVehicleDocumentRequest.prototype.getDocumentPayload_asU8 = function() {
    return /** @type {!Uint8Array} */ $8M67s.Message.bytesAsU8(this.getDocumentPayload());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.document_service.UploadVehicleDocumentRequest} returns this
 */ proto.document_service.UploadVehicleDocumentRequest.prototype.setDocumentPayload = function(value) {
    return $8M67s.Message.setProto3BytesField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UploadVehicleDocumentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UploadVehicleDocumentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UploadVehicleDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadVehicleDocumentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UploadVehicleDocumentResponse}
 */ proto.document_service.UploadVehicleDocumentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UploadVehicleDocumentResponse;
    return proto.document_service.UploadVehicleDocumentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UploadVehicleDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UploadVehicleDocumentResponse}
 */ proto.document_service.UploadVehicleDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UploadVehicleDocumentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UploadVehicleDocumentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UploadVehicleDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UploadVehicleDocumentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string document_id = 1;
 * @return {string}
 */ proto.document_service.UploadVehicleDocumentResponse.prototype.getDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.UploadVehicleDocumentResponse} returns this
 */ proto.document_service.UploadVehicleDocumentResponse.prototype.setDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetVehicleDocumentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetVehicleDocumentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetVehicleDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetVehicleDocumentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetVehicleDocumentRequest}
 */ proto.document_service.GetVehicleDocumentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetVehicleDocumentRequest;
    return proto.document_service.GetVehicleDocumentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetVehicleDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetVehicleDocumentRequest}
 */ proto.document_service.GetVehicleDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetVehicleDocumentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetVehicleDocumentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetVehicleDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetVehicleDocumentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string document_id = 1;
 * @return {string}
 */ proto.document_service.GetVehicleDocumentRequest.prototype.getDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetVehicleDocumentRequest} returns this
 */ proto.document_service.GetVehicleDocumentRequest.prototype.setDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetVehicleDocumentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetVehicleDocumentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetVehicleDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetVehicleDocumentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentPayload: msg.getDocumentPayload_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetVehicleDocumentResponse}
 */ proto.document_service.GetVehicleDocumentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetVehicleDocumentResponse;
    return proto.document_service.GetVehicleDocumentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetVehicleDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetVehicleDocumentResponse}
 */ proto.document_service.GetVehicleDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setDocumentPayload(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetVehicleDocumentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetVehicleDocumentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetVehicleDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetVehicleDocumentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentPayload_asU8();
    if (f.length > 0) writer.writeBytes(1, f);
};
/**
 * optional bytes document_payload = 1;
 * @return {!(string|Uint8Array)}
 */ proto.document_service.GetVehicleDocumentResponse.prototype.getDocumentPayload = function() {
    return /** @type {!(string|Uint8Array)} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes document_payload = 1;
 * This is a type-conversion wrapper around `getDocumentPayload()`
 * @return {string}
 */ proto.document_service.GetVehicleDocumentResponse.prototype.getDocumentPayload_asB64 = function() {
    return /** @type {string} */ $8M67s.Message.bytesAsB64(this.getDocumentPayload());
};
/**
 * optional bytes document_payload = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getDocumentPayload()`
 * @return {!Uint8Array}
 */ proto.document_service.GetVehicleDocumentResponse.prototype.getDocumentPayload_asU8 = function() {
    return /** @type {!Uint8Array} */ $8M67s.Message.bytesAsU8(this.getDocumentPayload());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.document_service.GetVehicleDocumentResponse} returns this
 */ proto.document_service.GetVehicleDocumentResponse.prototype.setDocumentPayload = function(value) {
    return $8M67s.Message.setProto3BytesField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetSubscriptionContractToSignRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetSubscriptionContractToSignRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetSubscriptionContractToSignRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerAccountNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerFirstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            customerLastName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            billingAddress: (f = msg.getBillingAddress()) && $3QqPt.Address.toObject(includeInstance, f),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            subscription: (f = msg.getSubscription()) && $3QqPt.Subscription.toObject(includeInstance, f),
            inspectionResults: (f = msg.getInspectionResults()) && $gjhG2.InspectionResults.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest}
 */ proto.document_service.GetSubscriptionContractToSignRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetSubscriptionContractToSignRequest;
    return proto.document_service.GetSubscriptionContractToSignRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetSubscriptionContractToSignRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest}
 */ proto.document_service.GetSubscriptionContractToSignRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerLastName(value);
                break;
            case 5:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setBillingAddress(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 7:
                var value = new $3QqPt.Subscription;
                reader.readMessage(value, $3QqPt.Subscription.deserializeBinaryFromReader);
                msg.setSubscription(value);
                break;
            case 8:
                var value = new $gjhG2.InspectionResults;
                reader.readMessage(value, $gjhG2.InspectionResults.deserializeBinaryFromReader);
                msg.setInspectionResults(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetSubscriptionContractToSignRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetSubscriptionContractToSignRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetSubscriptionContractToSignRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerAccountNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCustomerLastName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getBillingAddress();
    if (f != null) writer.writeMessage(5, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getSubscription();
    if (f != null) writer.writeMessage(7, f, $3QqPt.Subscription.serializeBinaryToWriter);
    f = message.getInspectionResults();
    if (f != null) writer.writeMessage(8, f, $gjhG2.InspectionResults.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_account_number = 2;
 * @return {string}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.getCustomerAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.setCustomerAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_first_name = 3;
 * @return {string}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.getCustomerFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.setCustomerFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string customer_last_name = 4;
 * @return {string}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.getCustomerLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.setCustomerLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional domain.Address billing_address = 5;
 * @return {?proto.domain.Address}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.getBillingAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 5);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
*/ proto.document_service.GetSubscriptionContractToSignRequest.prototype.setBillingAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.clearBillingAddress = function() {
    return this.setBillingAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.hasBillingAddress = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional string vehicle_id = 6;
 * @return {string}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional domain.Subscription subscription = 7;
 * @return {?proto.domain.Subscription}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.getSubscription = function() {
    return /** @type{?proto.domain.Subscription} */ $8M67s.Message.getWrapperField(this, $3QqPt.Subscription, 7);
};
/**
 * @param {?proto.domain.Subscription|undefined} value
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
*/ proto.document_service.GetSubscriptionContractToSignRequest.prototype.setSubscription = function(value) {
    return $8M67s.Message.setWrapperField(this, 7, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.clearSubscription = function() {
    return this.setSubscription(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.hasSubscription = function() {
    return $8M67s.Message.getField(this, 7) != null;
};
/**
 * optional inspection.InspectionResults inspection_results = 8;
 * @return {?proto.inspection.InspectionResults}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.getInspectionResults = function() {
    return /** @type{?proto.inspection.InspectionResults} */ $8M67s.Message.getWrapperField(this, $gjhG2.InspectionResults, 8);
};
/**
 * @param {?proto.inspection.InspectionResults|undefined} value
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
*/ proto.document_service.GetSubscriptionContractToSignRequest.prototype.setInspectionResults = function(value) {
    return $8M67s.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.GetSubscriptionContractToSignRequest} returns this
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.clearInspectionResults = function() {
    return this.setInspectionResults(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.GetSubscriptionContractToSignRequest.prototype.hasInspectionResults = function() {
    return $8M67s.Message.getField(this, 8) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetSubscriptionContractToSignResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetSubscriptionContractToSignResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetSubscriptionContractToSignResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetSubscriptionContractToSignResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            contractUri: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetSubscriptionContractToSignResponse}
 */ proto.document_service.GetSubscriptionContractToSignResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetSubscriptionContractToSignResponse;
    return proto.document_service.GetSubscriptionContractToSignResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetSubscriptionContractToSignResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetSubscriptionContractToSignResponse}
 */ proto.document_service.GetSubscriptionContractToSignResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setContractUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetSubscriptionContractToSignResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetSubscriptionContractToSignResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetSubscriptionContractToSignResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetSubscriptionContractToSignResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getContractUri();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string contract_uri = 1;
 * @return {string}
 */ proto.document_service.GetSubscriptionContractToSignResponse.prototype.getContractUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetSubscriptionContractToSignResponse} returns this
 */ proto.document_service.GetSubscriptionContractToSignResponse.prototype.setContractUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.CustomerDocumentMeta.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.CustomerDocumentMeta.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.CustomerDocumentMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.CustomerDocumentMeta.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentsByIdMap: (f = msg.getDocumentsByIdMap()) ? f.toObject(includeInstance, undefined) : [],
            contractsMap: (f = msg.getContractsMap()) ? f.toObject(includeInstance, proto.document_service.SubscriptionContract.toObject) : [],
            autoPayAuthorizationsMap: (f = msg.getAutoPayAuthorizationsMap()) ? f.toObject(includeInstance, proto.document_service.Authorizations.toObject) : [],
            insuranceCardsMap: (f = msg.getInsuranceCardsMap()) ? f.toObject(includeInstance, proto.document_service.InsuranceCard.toObject) : [],
            vehicleInspectionsMap: (f = msg.getVehicleInspectionsMap()) ? f.toObject(includeInstance, proto.document_service.Inspections.toObject) : [],
            pickupReceiptMap: (f = msg.getPickupReceiptMap()) ? f.toObject(includeInstance, proto.document_service.PickupReceipt.toObject) : [],
            customerId: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.CustomerDocumentMeta}
 */ proto.document_service.CustomerDocumentMeta.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.CustomerDocumentMeta;
    return proto.document_service.CustomerDocumentMeta.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.CustomerDocumentMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.CustomerDocumentMeta}
 */ proto.document_service.CustomerDocumentMeta.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = msg.getDocumentsByIdMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readString, null, "", "");
                });
                break;
            case 2:
                var value = msg.getContractsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.SubscriptionContract.deserializeBinaryFromReader, "", new proto.document_service.SubscriptionContract());
                });
                break;
            case 3:
                var value = msg.getAutoPayAuthorizationsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.Authorizations.deserializeBinaryFromReader, "", new proto.document_service.Authorizations());
                });
                break;
            case 4:
                var value = msg.getInsuranceCardsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.InsuranceCard.deserializeBinaryFromReader, "", new proto.document_service.InsuranceCard());
                });
                break;
            case 5:
                var value = msg.getVehicleInspectionsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.Inspections.deserializeBinaryFromReader, "", new proto.document_service.Inspections());
                });
                break;
            case 6:
                var value = msg.getPickupReceiptMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.PickupReceipt.deserializeBinaryFromReader, "", new proto.document_service.PickupReceipt());
                });
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.CustomerDocumentMeta.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.CustomerDocumentMeta.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.CustomerDocumentMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.CustomerDocumentMeta.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentsByIdMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(1, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeString);
    f = message.getContractsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(2, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.SubscriptionContract.serializeBinaryToWriter);
    f = message.getAutoPayAuthorizationsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(3, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.Authorizations.serializeBinaryToWriter);
    f = message.getInsuranceCardsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(4, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.InsuranceCard.serializeBinaryToWriter);
    f = message.getVehicleInspectionsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(5, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.Inspections.serializeBinaryToWriter);
    f = message.getPickupReceiptMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(6, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.PickupReceipt.serializeBinaryToWriter);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * map<string, string> documents_by_id = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */ proto.document_service.CustomerDocumentMeta.prototype.getDocumentsByIdMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,string>} */ $8M67s.Message.getMapField(this, 1, opt_noLazyCreate, null);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.CustomerDocumentMeta} returns this
 */ proto.document_service.CustomerDocumentMeta.prototype.clearDocumentsByIdMap = function() {
    this.getDocumentsByIdMap().clear();
    return this;
};
/**
 * map<string, SubscriptionContract> contracts = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.SubscriptionContract>}
 */ proto.document_service.CustomerDocumentMeta.prototype.getContractsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.SubscriptionContract>} */ $8M67s.Message.getMapField(this, 2, opt_noLazyCreate, proto.document_service.SubscriptionContract);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.CustomerDocumentMeta} returns this
 */ proto.document_service.CustomerDocumentMeta.prototype.clearContractsMap = function() {
    this.getContractsMap().clear();
    return this;
};
/**
 * map<string, Authorizations> auto_pay_authorizations = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.Authorizations>}
 */ proto.document_service.CustomerDocumentMeta.prototype.getAutoPayAuthorizationsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.Authorizations>} */ $8M67s.Message.getMapField(this, 3, opt_noLazyCreate, proto.document_service.Authorizations);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.CustomerDocumentMeta} returns this
 */ proto.document_service.CustomerDocumentMeta.prototype.clearAutoPayAuthorizationsMap = function() {
    this.getAutoPayAuthorizationsMap().clear();
    return this;
};
/**
 * map<string, InsuranceCard> insurance_cards = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.InsuranceCard>}
 */ proto.document_service.CustomerDocumentMeta.prototype.getInsuranceCardsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.InsuranceCard>} */ $8M67s.Message.getMapField(this, 4, opt_noLazyCreate, proto.document_service.InsuranceCard);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.CustomerDocumentMeta} returns this
 */ proto.document_service.CustomerDocumentMeta.prototype.clearInsuranceCardsMap = function() {
    this.getInsuranceCardsMap().clear();
    return this;
};
/**
 * map<string, Inspections> vehicle_inspections = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.Inspections>}
 */ proto.document_service.CustomerDocumentMeta.prototype.getVehicleInspectionsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.Inspections>} */ $8M67s.Message.getMapField(this, 5, opt_noLazyCreate, proto.document_service.Inspections);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.CustomerDocumentMeta} returns this
 */ proto.document_service.CustomerDocumentMeta.prototype.clearVehicleInspectionsMap = function() {
    this.getVehicleInspectionsMap().clear();
    return this;
};
/**
 * map<string, PickupReceipt> pickup_receipt = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.PickupReceipt>}
 */ proto.document_service.CustomerDocumentMeta.prototype.getPickupReceiptMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.PickupReceipt>} */ $8M67s.Message.getMapField(this, 6, opt_noLazyCreate, proto.document_service.PickupReceipt);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.CustomerDocumentMeta} returns this
 */ proto.document_service.CustomerDocumentMeta.prototype.clearPickupReceiptMap = function() {
    this.getPickupReceiptMap().clear();
    return this;
};
/**
 * optional string customer_id = 7;
 * @return {string}
 */ proto.document_service.CustomerDocumentMeta.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.CustomerDocumentMeta} returns this
 */ proto.document_service.CustomerDocumentMeta.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.VehicleDocumentMeta.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.VehicleDocumentMeta.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.VehicleDocumentMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.VehicleDocumentMeta.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentsByIdMap: (f = msg.getDocumentsByIdMap()) ? f.toObject(includeInstance, undefined) : [],
            inspectionsMap: (f = msg.getInspectionsMap()) ? f.toObject(includeInstance, proto.document_service.Inspection.toObject) : []
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.VehicleDocumentMeta}
 */ proto.document_service.VehicleDocumentMeta.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.VehicleDocumentMeta;
    return proto.document_service.VehicleDocumentMeta.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.VehicleDocumentMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.VehicleDocumentMeta}
 */ proto.document_service.VehicleDocumentMeta.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = msg.getDocumentsByIdMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readString, null, "", "");
                });
                break;
            case 2:
                var value = msg.getInspectionsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.Inspection.deserializeBinaryFromReader, "", new proto.document_service.Inspection());
                });
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.VehicleDocumentMeta.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.VehicleDocumentMeta.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.VehicleDocumentMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.VehicleDocumentMeta.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentsByIdMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(1, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeString);
    f = message.getInspectionsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(2, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.Inspection.serializeBinaryToWriter);
};
/**
 * map<string, string> documents_by_id = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */ proto.document_service.VehicleDocumentMeta.prototype.getDocumentsByIdMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,string>} */ $8M67s.Message.getMapField(this, 1, opt_noLazyCreate, null);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.VehicleDocumentMeta} returns this
 */ proto.document_service.VehicleDocumentMeta.prototype.clearDocumentsByIdMap = function() {
    this.getDocumentsByIdMap().clear();
    return this;
};
/**
 * map<string, Inspection> inspections = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.Inspection>}
 */ proto.document_service.VehicleDocumentMeta.prototype.getInspectionsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.Inspection>} */ $8M67s.Message.getMapField(this, 2, opt_noLazyCreate, proto.document_service.Inspection);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.VehicleDocumentMeta} returns this
 */ proto.document_service.VehicleDocumentMeta.prototype.clearInspectionsMap = function() {
    this.getInspectionsMap().clear();
    return this;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.SubscriptionContract.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.SubscriptionContract.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.SubscriptionContract} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SubscriptionContract.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.SubscriptionContract}
 */ proto.document_service.SubscriptionContract.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.SubscriptionContract;
    return proto.document_service.SubscriptionContract.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.SubscriptionContract} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.SubscriptionContract}
 */ proto.document_service.SubscriptionContract.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.SubscriptionContract.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.SubscriptionContract.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.SubscriptionContract} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SubscriptionContract.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.SubscriptionContract.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SubscriptionContract} returns this
 */ proto.document_service.SubscriptionContract.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.document_service.SubscriptionContract.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.SubscriptionContract} returns this
 */ proto.document_service.SubscriptionContract.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.document_service.SubscriptionContract.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SubscriptionContract} returns this
 */ proto.document_service.SubscriptionContract.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string document_uri = 4;
 * @return {string}
 */ proto.document_service.SubscriptionContract.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SubscriptionContract} returns this
 */ proto.document_service.SubscriptionContract.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.PickupReceipt.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.PickupReceipt.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.PickupReceipt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.PickupReceipt.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.PickupReceipt}
 */ proto.document_service.PickupReceipt.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.PickupReceipt;
    return proto.document_service.PickupReceipt.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.PickupReceipt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.PickupReceipt}
 */ proto.document_service.PickupReceipt.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.PickupReceipt.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.PickupReceipt.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.PickupReceipt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.PickupReceipt.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.PickupReceipt.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.PickupReceipt} returns this
 */ proto.document_service.PickupReceipt.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.document_service.PickupReceipt.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.PickupReceipt} returns this
 */ proto.document_service.PickupReceipt.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.document_service.PickupReceipt.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.PickupReceipt} returns this
 */ proto.document_service.PickupReceipt.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string document_uri = 4;
 * @return {string}
 */ proto.document_service.PickupReceipt.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.PickupReceipt} returns this
 */ proto.document_service.PickupReceipt.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.AutoPayAuthorization.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.AutoPayAuthorization.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.AutoPayAuthorization} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.AutoPayAuthorization.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.AutoPayAuthorization}
 */ proto.document_service.AutoPayAuthorization.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.AutoPayAuthorization;
    return proto.document_service.AutoPayAuthorization.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.AutoPayAuthorization} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.AutoPayAuthorization}
 */ proto.document_service.AutoPayAuthorization.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.AutoPayAuthorization.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.AutoPayAuthorization.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.AutoPayAuthorization} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.AutoPayAuthorization.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.AutoPayAuthorization.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.AutoPayAuthorization} returns this
 */ proto.document_service.AutoPayAuthorization.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.document_service.AutoPayAuthorization.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.AutoPayAuthorization} returns this
 */ proto.document_service.AutoPayAuthorization.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.document_service.AutoPayAuthorization.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.AutoPayAuthorization} returns this
 */ proto.document_service.AutoPayAuthorization.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string document_uri = 4;
 * @return {string}
 */ proto.document_service.AutoPayAuthorization.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.AutoPayAuthorization} returns this
 */ proto.document_service.AutoPayAuthorization.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.document_service.Authorizations.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.Authorizations.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.Authorizations.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.Authorizations} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.Authorizations.toObject = function(includeInstance, msg) {
        var f, obj = {
            authorizationsList: $8M67s.Message.toObjectList(msg.getAuthorizationsList(), proto.document_service.AutoPayAuthorization.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.Authorizations}
 */ proto.document_service.Authorizations.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.Authorizations;
    return proto.document_service.Authorizations.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.Authorizations} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.Authorizations}
 */ proto.document_service.Authorizations.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.document_service.AutoPayAuthorization;
                reader.readMessage(value, proto.document_service.AutoPayAuthorization.deserializeBinaryFromReader);
                msg.addAuthorizations(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.Authorizations.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.Authorizations.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.Authorizations} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.Authorizations.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAuthorizationsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.document_service.AutoPayAuthorization.serializeBinaryToWriter);
};
/**
 * repeated AutoPayAuthorization authorizations = 1;
 * @return {!Array<!proto.document_service.AutoPayAuthorization>}
 */ proto.document_service.Authorizations.prototype.getAuthorizationsList = function() {
    return /** @type{!Array<!proto.document_service.AutoPayAuthorization>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.document_service.AutoPayAuthorization, 1);
};
/**
 * @param {!Array<!proto.document_service.AutoPayAuthorization>} value
 * @return {!proto.document_service.Authorizations} returns this
*/ proto.document_service.Authorizations.prototype.setAuthorizationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.document_service.AutoPayAuthorization=} opt_value
 * @param {number=} opt_index
 * @return {!proto.document_service.AutoPayAuthorization}
 */ proto.document_service.Authorizations.prototype.addAuthorizations = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.document_service.AutoPayAuthorization, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.document_service.Authorizations} returns this
 */ proto.document_service.Authorizations.prototype.clearAuthorizationsList = function() {
    return this.setAuthorizationsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.InspectionPhoto.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.InspectionPhoto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.InspectionPhoto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InspectionPhoto.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            label: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.InspectionPhoto}
 */ proto.document_service.InspectionPhoto.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.InspectionPhoto;
    return proto.document_service.InspectionPhoto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.InspectionPhoto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.InspectionPhoto}
 */ proto.document_service.InspectionPhoto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLabel(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.InspectionPhoto.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.InspectionPhoto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.InspectionPhoto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InspectionPhoto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLabel();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.InspectionPhoto.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.InspectionPhoto} returns this
 */ proto.document_service.InspectionPhoto.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string label = 2;
 * @return {string}
 */ proto.document_service.InspectionPhoto.prototype.getLabel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.InspectionPhoto} returns this
 */ proto.document_service.InspectionPhoto.prototype.setLabel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string document_uri = 3;
 * @return {string}
 */ proto.document_service.InspectionPhoto.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.InspectionPhoto} returns this
 */ proto.document_service.InspectionPhoto.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.InspectionReport.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.InspectionReport.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.InspectionReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InspectionReport.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.InspectionReport}
 */ proto.document_service.InspectionReport.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.InspectionReport;
    return proto.document_service.InspectionReport.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.InspectionReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.InspectionReport}
 */ proto.document_service.InspectionReport.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.InspectionReport.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.InspectionReport.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.InspectionReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InspectionReport.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.InspectionReport.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.InspectionReport} returns this
 */ proto.document_service.InspectionReport.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string document_uri = 2;
 * @return {string}
 */ proto.document_service.InspectionReport.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.InspectionReport} returns this
 */ proto.document_service.InspectionReport.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.document_service.Inspection.repeatedFields_ = [
    5
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.Inspection.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.Inspection.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.Inspection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.Inspection.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            report: (f = msg.getReport()) && proto.document_service.InspectionReport.toObject(includeInstance, f),
            photosList: $8M67s.Message.toObjectList(msg.getPhotosList(), proto.document_service.InspectionPhoto.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.Inspection}
 */ proto.document_service.Inspection.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.Inspection;
    return proto.document_service.Inspection.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.Inspection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.Inspection}
 */ proto.document_service.Inspection.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 4:
                var value = new proto.document_service.InspectionReport;
                reader.readMessage(value, proto.document_service.InspectionReport.deserializeBinaryFromReader);
                msg.setReport(value);
                break;
            case 5:
                var value = new proto.document_service.InspectionPhoto;
                reader.readMessage(value, proto.document_service.InspectionPhoto.deserializeBinaryFromReader);
                msg.addPhotos(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.Inspection.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.Inspection.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.Inspection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.Inspection.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getReport();
    if (f != null) writer.writeMessage(4, f, proto.document_service.InspectionReport.serializeBinaryToWriter);
    f = message.getPhotosList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, proto.document_service.InspectionPhoto.serializeBinaryToWriter);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.Inspection.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.Inspection} returns this
 */ proto.document_service.Inspection.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.document_service.Inspection.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.Inspection} returns this
 */ proto.document_service.Inspection.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string vehicle_id = 3;
 * @return {string}
 */ proto.document_service.Inspection.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.Inspection} returns this
 */ proto.document_service.Inspection.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional InspectionReport report = 4;
 * @return {?proto.document_service.InspectionReport}
 */ proto.document_service.Inspection.prototype.getReport = function() {
    return /** @type{?proto.document_service.InspectionReport} */ $8M67s.Message.getWrapperField(this, proto.document_service.InspectionReport, 4);
};
/**
 * @param {?proto.document_service.InspectionReport|undefined} value
 * @return {!proto.document_service.Inspection} returns this
*/ proto.document_service.Inspection.prototype.setReport = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.Inspection} returns this
 */ proto.document_service.Inspection.prototype.clearReport = function() {
    return this.setReport(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.Inspection.prototype.hasReport = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * repeated InspectionPhoto photos = 5;
 * @return {!Array<!proto.document_service.InspectionPhoto>}
 */ proto.document_service.Inspection.prototype.getPhotosList = function() {
    return /** @type{!Array<!proto.document_service.InspectionPhoto>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.document_service.InspectionPhoto, 5);
};
/**
 * @param {!Array<!proto.document_service.InspectionPhoto>} value
 * @return {!proto.document_service.Inspection} returns this
*/ proto.document_service.Inspection.prototype.setPhotosList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.document_service.InspectionPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.document_service.InspectionPhoto}
 */ proto.document_service.Inspection.prototype.addPhotos = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.document_service.InspectionPhoto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.document_service.Inspection} returns this
 */ proto.document_service.Inspection.prototype.clearPhotosList = function() {
    return this.setPhotosList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.document_service.Inspections.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.Inspections.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.Inspections.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.Inspections} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.Inspections.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionsList: $8M67s.Message.toObjectList(msg.getInspectionsList(), proto.document_service.Inspection.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.Inspections}
 */ proto.document_service.Inspections.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.Inspections;
    return proto.document_service.Inspections.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.Inspections} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.Inspections}
 */ proto.document_service.Inspections.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.document_service.Inspection;
                reader.readMessage(value, proto.document_service.Inspection.deserializeBinaryFromReader);
                msg.addInspections(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.Inspections.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.Inspections.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.Inspections} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.Inspections.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.document_service.Inspection.serializeBinaryToWriter);
};
/**
 * repeated Inspection inspections = 1;
 * @return {!Array<!proto.document_service.Inspection>}
 */ proto.document_service.Inspections.prototype.getInspectionsList = function() {
    return /** @type{!Array<!proto.document_service.Inspection>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.document_service.Inspection, 1);
};
/**
 * @param {!Array<!proto.document_service.Inspection>} value
 * @return {!proto.document_service.Inspections} returns this
*/ proto.document_service.Inspections.prototype.setInspectionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.document_service.Inspection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.document_service.Inspection}
 */ proto.document_service.Inspections.prototype.addInspections = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.document_service.Inspection, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.document_service.Inspections} returns this
 */ proto.document_service.Inspections.prototype.clearInspectionsList = function() {
    return this.setInspectionsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.InsuranceCard.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.InsuranceCard.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.InsuranceCard} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InsuranceCard.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.InsuranceCard}
 */ proto.document_service.InsuranceCard.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.InsuranceCard;
    return proto.document_service.InsuranceCard.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.InsuranceCard} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.InsuranceCard}
 */ proto.document_service.InsuranceCard.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.InsuranceCard.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.InsuranceCard.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.InsuranceCard} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InsuranceCard.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.InsuranceCard.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.InsuranceCard} returns this
 */ proto.document_service.InsuranceCard.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.document_service.InsuranceCard.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.InsuranceCard} returns this
 */ proto.document_service.InsuranceCard.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.document_service.InsuranceCard.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.InsuranceCard} returns this
 */ proto.document_service.InsuranceCard.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string document_uri = 4;
 * @return {string}
 */ proto.document_service.InsuranceCard.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.InsuranceCard} returns this
 */ proto.document_service.InsuranceCard.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.document_service.InsuranceCards.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.InsuranceCards.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.InsuranceCards.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.InsuranceCards} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InsuranceCards.toObject = function(includeInstance, msg) {
        var f, obj = {
            insuranceCardsList: $8M67s.Message.toObjectList(msg.getInsuranceCardsList(), proto.document_service.InsuranceCard.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.InsuranceCards}
 */ proto.document_service.InsuranceCards.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.InsuranceCards;
    return proto.document_service.InsuranceCards.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.InsuranceCards} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.InsuranceCards}
 */ proto.document_service.InsuranceCards.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.document_service.InsuranceCard;
                reader.readMessage(value, proto.document_service.InsuranceCard.deserializeBinaryFromReader);
                msg.addInsuranceCards(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.InsuranceCards.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.InsuranceCards.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.InsuranceCards} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InsuranceCards.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInsuranceCardsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.document_service.InsuranceCard.serializeBinaryToWriter);
};
/**
 * repeated InsuranceCard insurance_cards = 1;
 * @return {!Array<!proto.document_service.InsuranceCard>}
 */ proto.document_service.InsuranceCards.prototype.getInsuranceCardsList = function() {
    return /** @type{!Array<!proto.document_service.InsuranceCard>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.document_service.InsuranceCard, 1);
};
/**
 * @param {!Array<!proto.document_service.InsuranceCard>} value
 * @return {!proto.document_service.InsuranceCards} returns this
*/ proto.document_service.InsuranceCards.prototype.setInsuranceCardsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.document_service.InsuranceCard=} opt_value
 * @param {number=} opt_index
 * @return {!proto.document_service.InsuranceCard}
 */ proto.document_service.InsuranceCards.prototype.addInsuranceCards = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.document_service.InsuranceCard, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.document_service.InsuranceCards} returns this
 */ proto.document_service.InsuranceCards.prototype.clearInsuranceCardsList = function() {
    return this.setInsuranceCardsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetOwnDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetOwnDocumentsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetOwnDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetOwnDocumentsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetOwnDocumentsRequest}
 */ proto.document_service.GetOwnDocumentsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetOwnDocumentsRequest;
    return proto.document_service.GetOwnDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetOwnDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetOwnDocumentsRequest}
 */ proto.document_service.GetOwnDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetOwnDocumentsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetOwnDocumentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetOwnDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetOwnDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetOwnDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetOwnDocumentsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetOwnDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetOwnDocumentsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            contractsMap: (f = msg.getContractsMap()) ? f.toObject(includeInstance, proto.document_service.SubscriptionContract.toObject) : [],
            autoPayAuthorizationsMap: (f = msg.getAutoPayAuthorizationsMap()) ? f.toObject(includeInstance, proto.document_service.Authorizations.toObject) : [],
            insuranceCardsMap: (f = msg.getInsuranceCardsMap()) ? f.toObject(includeInstance, proto.document_service.InsuranceCard.toObject) : [],
            pickupReceiptMap: (f = msg.getPickupReceiptMap()) ? f.toObject(includeInstance, proto.document_service.PickupReceipt.toObject) : []
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetOwnDocumentsResponse}
 */ proto.document_service.GetOwnDocumentsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetOwnDocumentsResponse;
    return proto.document_service.GetOwnDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetOwnDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetOwnDocumentsResponse}
 */ proto.document_service.GetOwnDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = msg.getContractsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.SubscriptionContract.deserializeBinaryFromReader, "", new proto.document_service.SubscriptionContract());
                });
                break;
            case 2:
                var value = msg.getAutoPayAuthorizationsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.Authorizations.deserializeBinaryFromReader, "", new proto.document_service.Authorizations());
                });
                break;
            case 3:
                var value = msg.getInsuranceCardsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.InsuranceCard.deserializeBinaryFromReader, "", new proto.document_service.InsuranceCard());
                });
                break;
            case 4:
                var value = msg.getPickupReceiptMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.PickupReceipt.deserializeBinaryFromReader, "", new proto.document_service.PickupReceipt());
                });
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetOwnDocumentsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetOwnDocumentsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetOwnDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetOwnDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getContractsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(1, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.SubscriptionContract.serializeBinaryToWriter);
    f = message.getAutoPayAuthorizationsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(2, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.Authorizations.serializeBinaryToWriter);
    f = message.getInsuranceCardsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(3, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.InsuranceCard.serializeBinaryToWriter);
    f = message.getPickupReceiptMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(4, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.PickupReceipt.serializeBinaryToWriter);
};
/**
 * map<string, SubscriptionContract> contracts = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.SubscriptionContract>}
 */ proto.document_service.GetOwnDocumentsResponse.prototype.getContractsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.SubscriptionContract>} */ $8M67s.Message.getMapField(this, 1, opt_noLazyCreate, proto.document_service.SubscriptionContract);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.GetOwnDocumentsResponse} returns this
 */ proto.document_service.GetOwnDocumentsResponse.prototype.clearContractsMap = function() {
    this.getContractsMap().clear();
    return this;
};
/**
 * map<string, Authorizations> auto_pay_authorizations = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.Authorizations>}
 */ proto.document_service.GetOwnDocumentsResponse.prototype.getAutoPayAuthorizationsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.Authorizations>} */ $8M67s.Message.getMapField(this, 2, opt_noLazyCreate, proto.document_service.Authorizations);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.GetOwnDocumentsResponse} returns this
 */ proto.document_service.GetOwnDocumentsResponse.prototype.clearAutoPayAuthorizationsMap = function() {
    this.getAutoPayAuthorizationsMap().clear();
    return this;
};
/**
 * map<string, InsuranceCard> insurance_cards = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.InsuranceCard>}
 */ proto.document_service.GetOwnDocumentsResponse.prototype.getInsuranceCardsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.InsuranceCard>} */ $8M67s.Message.getMapField(this, 3, opt_noLazyCreate, proto.document_service.InsuranceCard);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.GetOwnDocumentsResponse} returns this
 */ proto.document_service.GetOwnDocumentsResponse.prototype.clearInsuranceCardsMap = function() {
    this.getInsuranceCardsMap().clear();
    return this;
};
/**
 * map<string, PickupReceipt> pickup_receipt = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.PickupReceipt>}
 */ proto.document_service.GetOwnDocumentsResponse.prototype.getPickupReceiptMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.PickupReceipt>} */ $8M67s.Message.getMapField(this, 4, opt_noLazyCreate, proto.document_service.PickupReceipt);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.GetOwnDocumentsResponse} returns this
 */ proto.document_service.GetOwnDocumentsResponse.prototype.clearPickupReceiptMap = function() {
    this.getPickupReceiptMap().clear();
    return this;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetOwnDocumentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetOwnDocumentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetOwnDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetOwnDocumentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetOwnDocumentRequest}
 */ proto.document_service.GetOwnDocumentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetOwnDocumentRequest;
    return proto.document_service.GetOwnDocumentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetOwnDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetOwnDocumentRequest}
 */ proto.document_service.GetOwnDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetOwnDocumentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetOwnDocumentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetOwnDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetOwnDocumentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string document_id = 1;
 * @return {string}
 */ proto.document_service.GetOwnDocumentRequest.prototype.getDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetOwnDocumentRequest} returns this
 */ proto.document_service.GetOwnDocumentRequest.prototype.setDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetOwnDocumentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetOwnDocumentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetOwnDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetOwnDocumentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetOwnDocumentResponse}
 */ proto.document_service.GetOwnDocumentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetOwnDocumentResponse;
    return proto.document_service.GetOwnDocumentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetOwnDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetOwnDocumentResponse}
 */ proto.document_service.GetOwnDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetOwnDocumentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetOwnDocumentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetOwnDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetOwnDocumentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string document_uri = 1;
 * @return {string}
 */ proto.document_service.GetOwnDocumentResponse.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetOwnDocumentResponse} returns this
 */ proto.document_service.GetOwnDocumentResponse.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.SignContractRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.SignContractRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.SignContractRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SignContractRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            signatureImage: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            inspectionResults: (f = msg.getInspectionResults()) && $gjhG2.InspectionResults.toObject(includeInstance, f),
            customerIpAddress: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            contractProps: (f = msg.getContractProps()) && $hOsJC.ContractProperties.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.SignContractRequest}
 */ proto.document_service.SignContractRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.SignContractRequest;
    return proto.document_service.SignContractRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.SignContractRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.SignContractRequest}
 */ proto.document_service.SignContractRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSignatureImage(value);
                break;
            case 4:
                var value = new $gjhG2.InspectionResults;
                reader.readMessage(value, $gjhG2.InspectionResults.deserializeBinaryFromReader);
                msg.setInspectionResults(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerIpAddress(value);
                break;
            case 6:
                var value = new $hOsJC.ContractProperties;
                reader.readMessage(value, $hOsJC.ContractProperties.deserializeBinaryFromReader);
                msg.setContractProps(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.SignContractRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.SignContractRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.SignContractRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SignContractRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSignatureImage();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getInspectionResults();
    if (f != null) writer.writeMessage(4, f, $gjhG2.InspectionResults.serializeBinaryToWriter);
    f = message.getCustomerIpAddress();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getContractProps();
    if (f != null) writer.writeMessage(6, f, $hOsJC.ContractProperties.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.document_service.SignContractRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SignContractRequest} returns this
 */ proto.document_service.SignContractRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.document_service.SignContractRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SignContractRequest} returns this
 */ proto.document_service.SignContractRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string signature_image = 3;
 * @return {string}
 */ proto.document_service.SignContractRequest.prototype.getSignatureImage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SignContractRequest} returns this
 */ proto.document_service.SignContractRequest.prototype.setSignatureImage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional inspection.InspectionResults inspection_results = 4;
 * @return {?proto.inspection.InspectionResults}
 */ proto.document_service.SignContractRequest.prototype.getInspectionResults = function() {
    return /** @type{?proto.inspection.InspectionResults} */ $8M67s.Message.getWrapperField(this, $gjhG2.InspectionResults, 4);
};
/**
 * @param {?proto.inspection.InspectionResults|undefined} value
 * @return {!proto.document_service.SignContractRequest} returns this
*/ proto.document_service.SignContractRequest.prototype.setInspectionResults = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.SignContractRequest} returns this
 */ proto.document_service.SignContractRequest.prototype.clearInspectionResults = function() {
    return this.setInspectionResults(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.SignContractRequest.prototype.hasInspectionResults = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional string customer_ip_address = 5;
 * @return {string}
 */ proto.document_service.SignContractRequest.prototype.getCustomerIpAddress = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SignContractRequest} returns this
 */ proto.document_service.SignContractRequest.prototype.setCustomerIpAddress = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional subscription.ContractProperties contract_props = 6;
 * @return {?proto.subscription.ContractProperties}
 */ proto.document_service.SignContractRequest.prototype.getContractProps = function() {
    return /** @type{?proto.subscription.ContractProperties} */ $8M67s.Message.getWrapperField(this, $hOsJC.ContractProperties, 6);
};
/**
 * @param {?proto.subscription.ContractProperties|undefined} value
 * @return {!proto.document_service.SignContractRequest} returns this
*/ proto.document_service.SignContractRequest.prototype.setContractProps = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.SignContractRequest} returns this
 */ proto.document_service.SignContractRequest.prototype.clearContractProps = function() {
    return this.setContractProps(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.SignContractRequest.prototype.hasContractProps = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.SignContractResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.SignContractResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.SignContractResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SignContractResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            contractUri: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.SignContractResponse}
 */ proto.document_service.SignContractResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.SignContractResponse;
    return proto.document_service.SignContractResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.SignContractResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.SignContractResponse}
 */ proto.document_service.SignContractResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setContractUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.SignContractResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.SignContractResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.SignContractResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SignContractResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getContractUri();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.SignContractResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SignContractResponse} returns this
 */ proto.document_service.SignContractResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.document_service.SignContractResponse.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.SignContractResponse} returns this
 */ proto.document_service.SignContractResponse.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.document_service.SignContractResponse.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SignContractResponse} returns this
 */ proto.document_service.SignContractResponse.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string contract_uri = 4;
 * @return {string}
 */ proto.document_service.SignContractResponse.prototype.getContractUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SignContractResponse} returns this
 */ proto.document_service.SignContractResponse.prototype.setContractUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GeneratePickupReceiptRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GeneratePickupReceiptRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GeneratePickupReceiptRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            signatureImage: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            inspectionResults: (f = msg.getInspectionResults()) && $gjhG2.InspectionResults.toObject(includeInstance, f),
            insuranceexcessmileagefee: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            props: (f = msg.getProps()) && $hOsJC.VehiclePickupReceiptProperties.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GeneratePickupReceiptRequest}
 */ proto.document_service.GeneratePickupReceiptRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GeneratePickupReceiptRequest;
    return proto.document_service.GeneratePickupReceiptRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GeneratePickupReceiptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GeneratePickupReceiptRequest}
 */ proto.document_service.GeneratePickupReceiptRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSignatureImage(value);
                break;
            case 4:
                var value = new $gjhG2.InspectionResults;
                reader.readMessage(value, $gjhG2.InspectionResults.deserializeBinaryFromReader);
                msg.setInspectionResults(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceexcessmileagefee(value);
                break;
            case 6:
                var value = new $hOsJC.VehiclePickupReceiptProperties;
                reader.readMessage(value, $hOsJC.VehiclePickupReceiptProperties.deserializeBinaryFromReader);
                msg.setProps(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GeneratePickupReceiptRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GeneratePickupReceiptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GeneratePickupReceiptRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSignatureImage();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getInspectionResults();
    if (f != null) writer.writeMessage(4, f, $gjhG2.InspectionResults.serializeBinaryToWriter);
    f = message.getInsuranceexcessmileagefee();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getProps();
    if (f != null) writer.writeMessage(6, f, $hOsJC.VehiclePickupReceiptProperties.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GeneratePickupReceiptRequest} returns this
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GeneratePickupReceiptRequest} returns this
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string signature_image = 3;
 * @return {string}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.getSignatureImage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GeneratePickupReceiptRequest} returns this
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.setSignatureImage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional inspection.InspectionResults inspection_results = 4;
 * @return {?proto.inspection.InspectionResults}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.getInspectionResults = function() {
    return /** @type{?proto.inspection.InspectionResults} */ $8M67s.Message.getWrapperField(this, $gjhG2.InspectionResults, 4);
};
/**
 * @param {?proto.inspection.InspectionResults|undefined} value
 * @return {!proto.document_service.GeneratePickupReceiptRequest} returns this
*/ proto.document_service.GeneratePickupReceiptRequest.prototype.setInspectionResults = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.GeneratePickupReceiptRequest} returns this
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.clearInspectionResults = function() {
    return this.setInspectionResults(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.hasInspectionResults = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional string insuranceExcessMileageFee = 5;
 * @return {string}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.getInsuranceexcessmileagefee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GeneratePickupReceiptRequest} returns this
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.setInsuranceexcessmileagefee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional subscription.VehiclePickupReceiptProperties props = 6;
 * @return {?proto.subscription.VehiclePickupReceiptProperties}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.getProps = function() {
    return /** @type{?proto.subscription.VehiclePickupReceiptProperties} */ $8M67s.Message.getWrapperField(this, $hOsJC.VehiclePickupReceiptProperties, 6);
};
/**
 * @param {?proto.subscription.VehiclePickupReceiptProperties|undefined} value
 * @return {!proto.document_service.GeneratePickupReceiptRequest} returns this
*/ proto.document_service.GeneratePickupReceiptRequest.prototype.setProps = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.GeneratePickupReceiptRequest} returns this
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.clearProps = function() {
    return this.setProps(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.GeneratePickupReceiptRequest.prototype.hasProps = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GeneratePickupReceiptResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GeneratePickupReceiptResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GeneratePickupReceiptResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            receiptUri: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GeneratePickupReceiptResponse}
 */ proto.document_service.GeneratePickupReceiptResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GeneratePickupReceiptResponse;
    return proto.document_service.GeneratePickupReceiptResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GeneratePickupReceiptResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GeneratePickupReceiptResponse}
 */ proto.document_service.GeneratePickupReceiptResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setReceiptUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GeneratePickupReceiptResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GeneratePickupReceiptResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GeneratePickupReceiptResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getReceiptUri();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GeneratePickupReceiptResponse} returns this
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.GeneratePickupReceiptResponse} returns this
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GeneratePickupReceiptResponse} returns this
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string receipt_uri = 4;
 * @return {string}
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.getReceiptUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GeneratePickupReceiptResponse} returns this
 */ proto.document_service.GeneratePickupReceiptResponse.prototype.setReceiptUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.UnsignedCustomerContractResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.UnsignedCustomerContractResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.UnsignedCustomerContractResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UnsignedCustomerContractResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            pdfBytes: msg.getPdfBytes_asB64()
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.UnsignedCustomerContractResponse}
 */ proto.document_service.UnsignedCustomerContractResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.UnsignedCustomerContractResponse;
    return proto.document_service.UnsignedCustomerContractResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.UnsignedCustomerContractResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.UnsignedCustomerContractResponse}
 */ proto.document_service.UnsignedCustomerContractResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPdfBytes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.UnsignedCustomerContractResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.UnsignedCustomerContractResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.UnsignedCustomerContractResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.UnsignedCustomerContractResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPdfBytes_asU8();
    if (f.length > 0) writer.writeBytes(1, f);
};
/**
 * optional bytes pdf_bytes = 1;
 * @return {!(string|Uint8Array)}
 */ proto.document_service.UnsignedCustomerContractResponse.prototype.getPdfBytes = function() {
    return /** @type {!(string|Uint8Array)} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes pdf_bytes = 1;
 * This is a type-conversion wrapper around `getPdfBytes()`
 * @return {string}
 */ proto.document_service.UnsignedCustomerContractResponse.prototype.getPdfBytes_asB64 = function() {
    return /** @type {string} */ $8M67s.Message.bytesAsB64(this.getPdfBytes());
};
/**
 * optional bytes pdf_bytes = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPdfBytes()`
 * @return {!Uint8Array}
 */ proto.document_service.UnsignedCustomerContractResponse.prototype.getPdfBytes_asU8 = function() {
    return /** @type {!Uint8Array} */ $8M67s.Message.bytesAsU8(this.getPdfBytes());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.document_service.UnsignedCustomerContractResponse} returns this
 */ proto.document_service.UnsignedCustomerContractResponse.prototype.setPdfBytes = function(value) {
    return $8M67s.Message.setProto3BytesField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetAllCustomerDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetAllCustomerDocumentsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetAllCustomerDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetAllCustomerDocumentsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetAllCustomerDocumentsRequest}
 */ proto.document_service.GetAllCustomerDocumentsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetAllCustomerDocumentsRequest;
    return proto.document_service.GetAllCustomerDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetAllCustomerDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetAllCustomerDocumentsRequest}
 */ proto.document_service.GetAllCustomerDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetAllCustomerDocumentsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetAllCustomerDocumentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetAllCustomerDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetAllCustomerDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.document_service.GetAllCustomerDocumentsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetAllCustomerDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetAllCustomerDocumentsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetAllCustomerDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetAllCustomerDocumentsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerDocumentsList: $8M67s.Message.toObjectList(msg.getCustomerDocumentsList(), proto.document_service.CustomerDocumentMeta.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetAllCustomerDocumentsResponse}
 */ proto.document_service.GetAllCustomerDocumentsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetAllCustomerDocumentsResponse;
    return proto.document_service.GetAllCustomerDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetAllCustomerDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetAllCustomerDocumentsResponse}
 */ proto.document_service.GetAllCustomerDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.document_service.CustomerDocumentMeta;
                reader.readMessage(value, proto.document_service.CustomerDocumentMeta.deserializeBinaryFromReader);
                msg.addCustomerDocuments(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetAllCustomerDocumentsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetAllCustomerDocumentsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetAllCustomerDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetAllCustomerDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerDocumentsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.document_service.CustomerDocumentMeta.serializeBinaryToWriter);
};
/**
 * repeated CustomerDocumentMeta customer_documents = 1;
 * @return {!Array<!proto.document_service.CustomerDocumentMeta>}
 */ proto.document_service.GetAllCustomerDocumentsResponse.prototype.getCustomerDocumentsList = function() {
    return /** @type{!Array<!proto.document_service.CustomerDocumentMeta>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.document_service.CustomerDocumentMeta, 1);
};
/**
 * @param {!Array<!proto.document_service.CustomerDocumentMeta>} value
 * @return {!proto.document_service.GetAllCustomerDocumentsResponse} returns this
*/ proto.document_service.GetAllCustomerDocumentsResponse.prototype.setCustomerDocumentsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.document_service.CustomerDocumentMeta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.document_service.CustomerDocumentMeta}
 */ proto.document_service.GetAllCustomerDocumentsResponse.prototype.addCustomerDocuments = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.document_service.CustomerDocumentMeta, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.document_service.GetAllCustomerDocumentsResponse} returns this
 */ proto.document_service.GetAllCustomerDocumentsResponse.prototype.clearCustomerDocumentsList = function() {
    return this.setCustomerDocumentsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetCustomerDocumentsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetCustomerDocumentsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetCustomerDocumentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetCustomerDocumentsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerid: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetCustomerDocumentsRequest}
 */ proto.document_service.GetCustomerDocumentsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetCustomerDocumentsRequest;
    return proto.document_service.GetCustomerDocumentsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetCustomerDocumentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetCustomerDocumentsRequest}
 */ proto.document_service.GetCustomerDocumentsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerid(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetCustomerDocumentsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetCustomerDocumentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetCustomerDocumentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetCustomerDocumentsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerid();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customerId = 1;
 * @return {string}
 */ proto.document_service.GetCustomerDocumentsRequest.prototype.getCustomerid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetCustomerDocumentsRequest} returns this
 */ proto.document_service.GetCustomerDocumentsRequest.prototype.setCustomerid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetCustomerDocumentsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetCustomerDocumentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetCustomerDocumentsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            contractsMap: (f = msg.getContractsMap()) ? f.toObject(includeInstance, proto.document_service.SubscriptionContract.toObject) : [],
            autoPayAuthorizationsMap: (f = msg.getAutoPayAuthorizationsMap()) ? f.toObject(includeInstance, proto.document_service.Authorizations.toObject) : [],
            insuranceCardsMap: (f = msg.getInsuranceCardsMap()) ? f.toObject(includeInstance, proto.document_service.InsuranceCard.toObject) : [],
            pickupReceiptMap: (f = msg.getPickupReceiptMap()) ? f.toObject(includeInstance, proto.document_service.PickupReceipt.toObject) : []
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetCustomerDocumentsResponse}
 */ proto.document_service.GetCustomerDocumentsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetCustomerDocumentsResponse;
    return proto.document_service.GetCustomerDocumentsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetCustomerDocumentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetCustomerDocumentsResponse}
 */ proto.document_service.GetCustomerDocumentsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = msg.getContractsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.SubscriptionContract.deserializeBinaryFromReader, "", new proto.document_service.SubscriptionContract());
                });
                break;
            case 2:
                var value = msg.getAutoPayAuthorizationsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.Authorizations.deserializeBinaryFromReader, "", new proto.document_service.Authorizations());
                });
                break;
            case 3:
                var value = msg.getInsuranceCardsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.InsuranceCard.deserializeBinaryFromReader, "", new proto.document_service.InsuranceCard());
                });
                break;
            case 4:
                var value = msg.getPickupReceiptMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.document_service.PickupReceipt.deserializeBinaryFromReader, "", new proto.document_service.PickupReceipt());
                });
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetCustomerDocumentsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetCustomerDocumentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetCustomerDocumentsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getContractsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(1, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.SubscriptionContract.serializeBinaryToWriter);
    f = message.getAutoPayAuthorizationsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(2, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.Authorizations.serializeBinaryToWriter);
    f = message.getInsuranceCardsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(3, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.InsuranceCard.serializeBinaryToWriter);
    f = message.getPickupReceiptMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(4, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.document_service.PickupReceipt.serializeBinaryToWriter);
};
/**
 * map<string, SubscriptionContract> contracts = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.SubscriptionContract>}
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.getContractsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.SubscriptionContract>} */ $8M67s.Message.getMapField(this, 1, opt_noLazyCreate, proto.document_service.SubscriptionContract);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.GetCustomerDocumentsResponse} returns this
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.clearContractsMap = function() {
    this.getContractsMap().clear();
    return this;
};
/**
 * map<string, Authorizations> auto_pay_authorizations = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.Authorizations>}
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.getAutoPayAuthorizationsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.Authorizations>} */ $8M67s.Message.getMapField(this, 2, opt_noLazyCreate, proto.document_service.Authorizations);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.GetCustomerDocumentsResponse} returns this
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.clearAutoPayAuthorizationsMap = function() {
    this.getAutoPayAuthorizationsMap().clear();
    return this;
};
/**
 * map<string, InsuranceCard> insurance_cards = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.InsuranceCard>}
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.getInsuranceCardsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.InsuranceCard>} */ $8M67s.Message.getMapField(this, 3, opt_noLazyCreate, proto.document_service.InsuranceCard);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.GetCustomerDocumentsResponse} returns this
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.clearInsuranceCardsMap = function() {
    this.getInsuranceCardsMap().clear();
    return this;
};
/**
 * map<string, PickupReceipt> pickup_receipt = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.document_service.PickupReceipt>}
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.getPickupReceiptMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.document_service.PickupReceipt>} */ $8M67s.Message.getMapField(this, 4, opt_noLazyCreate, proto.document_service.PickupReceipt);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.document_service.GetCustomerDocumentsResponse} returns this
 */ proto.document_service.GetCustomerDocumentsResponse.prototype.clearPickupReceiptMap = function() {
    this.getPickupReceiptMap().clear();
    return this;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetCustomerDocumentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetCustomerDocumentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetCustomerDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetCustomerDocumentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerid: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            documentId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetCustomerDocumentRequest}
 */ proto.document_service.GetCustomerDocumentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetCustomerDocumentRequest;
    return proto.document_service.GetCustomerDocumentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetCustomerDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetCustomerDocumentRequest}
 */ proto.document_service.GetCustomerDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerid(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetCustomerDocumentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetCustomerDocumentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetCustomerDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetCustomerDocumentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerid();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDocumentId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customerId = 1;
 * @return {string}
 */ proto.document_service.GetCustomerDocumentRequest.prototype.getCustomerid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetCustomerDocumentRequest} returns this
 */ proto.document_service.GetCustomerDocumentRequest.prototype.setCustomerid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string document_id = 2;
 * @return {string}
 */ proto.document_service.GetCustomerDocumentRequest.prototype.getDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetCustomerDocumentRequest} returns this
 */ proto.document_service.GetCustomerDocumentRequest.prototype.setDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.GetCustomerDocumentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.GetCustomerDocumentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.GetCustomerDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetCustomerDocumentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.GetCustomerDocumentResponse}
 */ proto.document_service.GetCustomerDocumentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.GetCustomerDocumentResponse;
    return proto.document_service.GetCustomerDocumentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.GetCustomerDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.GetCustomerDocumentResponse}
 */ proto.document_service.GetCustomerDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.GetCustomerDocumentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.GetCustomerDocumentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.GetCustomerDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.GetCustomerDocumentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string document_uri = 1;
 * @return {string}
 */ proto.document_service.GetCustomerDocumentResponse.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.GetCustomerDocumentResponse} returns this
 */ proto.document_service.GetCustomerDocumentResponse.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.InitProjectionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.InitProjectionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.InitProjectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InitProjectionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            batchSize: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            wait: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.InitProjectionsRequest}
 */ proto.document_service.InitProjectionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.InitProjectionsRequest;
    return proto.document_service.InitProjectionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.InitProjectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.InitProjectionsRequest}
 */ proto.document_service.InitProjectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setBatchSize(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setWait(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.InitProjectionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.InitProjectionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.InitProjectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InitProjectionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getBatchSize();
    if (f !== 0) writer.writeUint32(1, f);
    f = message.getWait();
    if (f) writer.writeBool(2, f);
};
/**
 * optional uint32 batch_size = 1;
 * @return {number}
 */ proto.document_service.InitProjectionsRequest.prototype.getBatchSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.document_service.InitProjectionsRequest} returns this
 */ proto.document_service.InitProjectionsRequest.prototype.setBatchSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bool wait = 2;
 * @return {boolean}
 */ proto.document_service.InitProjectionsRequest.prototype.getWait = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.document_service.InitProjectionsRequest} returns this
 */ proto.document_service.InitProjectionsRequest.prototype.setWait = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.InitProjectionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.InitProjectionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.InitProjectionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InitProjectionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.InitProjectionsResponse}
 */ proto.document_service.InitProjectionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.InitProjectionsResponse;
    return proto.document_service.InitProjectionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.InitProjectionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.InitProjectionsResponse}
 */ proto.document_service.InitProjectionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.InitProjectionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.InitProjectionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.InitProjectionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.InitProjectionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.SendReceiptRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.SendReceiptRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.SendReceiptRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SendReceiptRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            order: (f = msg.getOrder()) && $26u10.OrderFE.toObject(includeInstance, f),
            invoice: (f = msg.getInvoice()) && $26u10.InvoiceFE.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.SendReceiptRequest}
 */ proto.document_service.SendReceiptRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.SendReceiptRequest;
    return proto.document_service.SendReceiptRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.SendReceiptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.SendReceiptRequest}
 */ proto.document_service.SendReceiptRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new $26u10.OrderFE;
                reader.readMessage(value, $26u10.OrderFE.deserializeBinaryFromReader);
                msg.setOrder(value);
                break;
            case 3:
                var value = new $26u10.InvoiceFE;
                reader.readMessage(value, $26u10.InvoiceFE.deserializeBinaryFromReader);
                msg.setInvoice(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.SendReceiptRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.SendReceiptRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.SendReceiptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SendReceiptRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOrder();
    if (f != null) writer.writeMessage(2, f, $26u10.OrderFE.serializeBinaryToWriter);
    f = message.getInvoice();
    if (f != null) writer.writeMessage(3, f, $26u10.InvoiceFE.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.document_service.SendReceiptRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.document_service.SendReceiptRequest} returns this
 */ proto.document_service.SendReceiptRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional billing_service.OrderFE order = 2;
 * @return {?proto.billing_service.OrderFE}
 */ proto.document_service.SendReceiptRequest.prototype.getOrder = function() {
    return /** @type{?proto.billing_service.OrderFE} */ $8M67s.Message.getWrapperField(this, $26u10.OrderFE, 2);
};
/**
 * @param {?proto.billing_service.OrderFE|undefined} value
 * @return {!proto.document_service.SendReceiptRequest} returns this
*/ proto.document_service.SendReceiptRequest.prototype.setOrder = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.SendReceiptRequest} returns this
 */ proto.document_service.SendReceiptRequest.prototype.clearOrder = function() {
    return this.setOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.SendReceiptRequest.prototype.hasOrder = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional billing_service.InvoiceFE invoice = 3;
 * @return {?proto.billing_service.InvoiceFE}
 */ proto.document_service.SendReceiptRequest.prototype.getInvoice = function() {
    return /** @type{?proto.billing_service.InvoiceFE} */ $8M67s.Message.getWrapperField(this, $26u10.InvoiceFE, 3);
};
/**
 * @param {?proto.billing_service.InvoiceFE|undefined} value
 * @return {!proto.document_service.SendReceiptRequest} returns this
*/ proto.document_service.SendReceiptRequest.prototype.setInvoice = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.document_service.SendReceiptRequest} returns this
 */ proto.document_service.SendReceiptRequest.prototype.clearInvoice = function() {
    return this.setInvoice(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.document_service.SendReceiptRequest.prototype.hasInvoice = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.document_service.SendReceiptResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.document_service.SendReceiptResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.document_service.SendReceiptResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SendReceiptResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.document_service.SendReceiptResponse}
 */ proto.document_service.SendReceiptResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.document_service.SendReceiptResponse;
    return proto.document_service.SendReceiptResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.document_service.SendReceiptResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.document_service.SendReceiptResponse}
 */ proto.document_service.SendReceiptResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.document_service.SendReceiptResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.document_service.SendReceiptResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.document_service.SendReceiptResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.document_service.SendReceiptResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * @enum {number}
 */ proto.document_service.TemplateType = {
    INVOICE: 0,
    RECEIPT: 1
};
$92382a85b8f672d6$var$goog.object.extend(module.exports, proto.document_service);

});
parcelRegister("gjhG2", function(module, exports) {
// source: inspection.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $bdfc2200c6930f2c$var$goog = $8M67s;
var $bdfc2200c6930f2c$var$global = Function('return this')();
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.BeginInspectionRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.BeginInspectionResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.CheckVehicleInspectionRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.CheckVehicleInspectionResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetCustomerSubmittedMileageRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetCustomerSubmittedMileageResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionNotesRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionNotesResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionPhotosRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionPhotosResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionResultsRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionResultsResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionStateRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionStateResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionStatusRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.GetInspectionStatusResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.Inspection', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.InspectionResults', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.InspectionStatus', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.InspectionType', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.Note', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.Photo', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.SMSDetails', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.StartInspectionCustomerRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.StartInspectionDealerRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.StartInspectionFleetRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.StartInspectionResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.SubmitCustomerMileageRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.SubmitCustomerMileageResponse', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.SubmitInspectionResultsRequest', null, $bdfc2200c6930f2c$var$global);
$bdfc2200c6930f2c$var$goog.exportSymbol('proto.inspection.SubmitInspectionResultsResponse', null, $bdfc2200c6930f2c$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionStateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionStateRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionStateRequest.displayName = 'proto.inspection.GetInspectionStateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionStateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionStateResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionStateResponse.displayName = 'proto.inspection.GetInspectionStateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.CheckVehicleInspectionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.CheckVehicleInspectionRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.CheckVehicleInspectionRequest.displayName = 'proto.inspection.CheckVehicleInspectionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.SubmitCustomerMileageResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.SubmitCustomerMileageResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.SubmitCustomerMileageResponse.displayName = 'proto.inspection.SubmitCustomerMileageResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.SubmitCustomerMileageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.SubmitCustomerMileageRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.SubmitCustomerMileageRequest.displayName = 'proto.inspection.SubmitCustomerMileageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetCustomerSubmittedMileageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetCustomerSubmittedMileageRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetCustomerSubmittedMileageRequest.displayName = 'proto.inspection.GetCustomerSubmittedMileageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetCustomerSubmittedMileageResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetCustomerSubmittedMileageResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetCustomerSubmittedMileageResponse.displayName = 'proto.inspection.GetCustomerSubmittedMileageResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.CheckVehicleInspectionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.CheckVehicleInspectionResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.CheckVehicleInspectionResponse.displayName = 'proto.inspection.CheckVehicleInspectionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.SubmitInspectionResultsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.inspection.SubmitInspectionResultsRequest.repeatedFields_, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.SubmitInspectionResultsRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.SubmitInspectionResultsRequest.displayName = 'proto.inspection.SubmitInspectionResultsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.SubmitInspectionResultsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.SubmitInspectionResultsResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.SubmitInspectionResultsResponse.displayName = 'proto.inspection.SubmitInspectionResultsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.BeginInspectionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.BeginInspectionRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.BeginInspectionRequest.displayName = 'proto.inspection.BeginInspectionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.SMSDetails = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.SMSDetails, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.SMSDetails.displayName = 'proto.inspection.SMSDetails';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.BeginInspectionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.BeginInspectionResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.BeginInspectionResponse.displayName = 'proto.inspection.BeginInspectionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.Photo = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.Photo, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.Photo.displayName = 'proto.inspection.Photo';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionResultsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionResultsRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionResultsRequest.displayName = 'proto.inspection.GetInspectionResultsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionResultsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionResultsResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionResultsResponse.displayName = 'proto.inspection.GetInspectionResultsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.InspectionResults = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.InspectionResults, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.InspectionResults.displayName = 'proto.inspection.InspectionResults';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.StartInspectionCustomerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.StartInspectionCustomerRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.StartInspectionCustomerRequest.displayName = 'proto.inspection.StartInspectionCustomerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.StartInspectionDealerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.StartInspectionDealerRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.StartInspectionDealerRequest.displayName = 'proto.inspection.StartInspectionDealerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.StartInspectionFleetRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.StartInspectionFleetRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.StartInspectionFleetRequest.displayName = 'proto.inspection.StartInspectionFleetRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.StartInspectionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.StartInspectionResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.StartInspectionResponse.displayName = 'proto.inspection.StartInspectionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionStatusRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionStatusRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionStatusRequest.displayName = 'proto.inspection.GetInspectionStatusRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionStatusResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionStatusResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionStatusResponse.displayName = 'proto.inspection.GetInspectionStatusResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.Inspection = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.Inspection, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.Inspection.displayName = 'proto.inspection.Inspection';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionPhotosRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionPhotosRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionPhotosRequest.displayName = 'proto.inspection.GetInspectionPhotosRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionPhotosResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.inspection.GetInspectionPhotosResponse.repeatedFields_, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionPhotosResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionPhotosResponse.displayName = 'proto.inspection.GetInspectionPhotosResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.Note = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.Note, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.Note.displayName = 'proto.inspection.Note';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionNotesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionNotesRequest, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionNotesRequest.displayName = 'proto.inspection.GetInspectionNotesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.inspection.GetInspectionNotesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.inspection.GetInspectionNotesResponse.repeatedFields_, null);
};
$bdfc2200c6930f2c$var$goog.inherits(proto.inspection.GetInspectionNotesResponse, $8M67s.Message);
if ($bdfc2200c6930f2c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.inspection.GetInspectionNotesResponse.displayName = 'proto.inspection.GetInspectionNotesResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionStateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionStateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionStateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionStateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionStateRequest}
 */ proto.inspection.GetInspectionStateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionStateRequest;
    return proto.inspection.GetInspectionStateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionStateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionStateRequest}
 */ proto.inspection.GetInspectionStateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionStateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionStateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionStateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionStateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.inspection.GetInspectionStateRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionStateRequest} returns this
 */ proto.inspection.GetInspectionStateRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionStateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionStateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionStateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionStateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionState: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionStateResponse}
 */ proto.inspection.GetInspectionStateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionStateResponse;
    return proto.inspection.GetInspectionStateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionStateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionStateResponse}
 */ proto.inspection.GetInspectionStateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionStateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionStateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionStateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionStateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionState();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string inspection_state = 1;
 * @return {string}
 */ proto.inspection.GetInspectionStateResponse.prototype.getInspectionState = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionStateResponse} returns this
 */ proto.inspection.GetInspectionStateResponse.prototype.setInspectionState = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.CheckVehicleInspectionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.CheckVehicleInspectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.CheckVehicleInspectionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vin: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.CheckVehicleInspectionRequest}
 */ proto.inspection.CheckVehicleInspectionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.CheckVehicleInspectionRequest;
    return proto.inspection.CheckVehicleInspectionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.CheckVehicleInspectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.CheckVehicleInspectionRequest}
 */ proto.inspection.CheckVehicleInspectionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.CheckVehicleInspectionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.CheckVehicleInspectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.CheckVehicleInspectionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVin();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string vin = 1;
 * @return {string}
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.CheckVehicleInspectionRequest} returns this
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.CheckVehicleInspectionRequest} returns this
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.CheckVehicleInspectionRequest} returns this
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string subscription_id = 4;
 * @return {string}
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.CheckVehicleInspectionRequest} returns this
 */ proto.inspection.CheckVehicleInspectionRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.SubmitCustomerMileageResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.SubmitCustomerMileageResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.SubmitCustomerMileageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SubmitCustomerMileageResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.SubmitCustomerMileageResponse}
 */ proto.inspection.SubmitCustomerMileageResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.SubmitCustomerMileageResponse;
    return proto.inspection.SubmitCustomerMileageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.SubmitCustomerMileageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.SubmitCustomerMileageResponse}
 */ proto.inspection.SubmitCustomerMileageResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.SubmitCustomerMileageResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.SubmitCustomerMileageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.SubmitCustomerMileageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SubmitCustomerMileageResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.inspection.SubmitCustomerMileageResponse.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SubmitCustomerMileageResponse} returns this
 */ proto.inspection.SubmitCustomerMileageResponse.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.SubmitCustomerMileageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.SubmitCustomerMileageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SubmitCustomerMileageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vin: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            mileage: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.SubmitCustomerMileageRequest}
 */ proto.inspection.SubmitCustomerMileageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.SubmitCustomerMileageRequest;
    return proto.inspection.SubmitCustomerMileageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.SubmitCustomerMileageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.SubmitCustomerMileageRequest}
 */ proto.inspection.SubmitCustomerMileageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setMileage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.SubmitCustomerMileageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.SubmitCustomerMileageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SubmitCustomerMileageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVin();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getMileage();
    if (f !== 0) writer.writeInt64(5, f);
};
/**
 * optional string vin = 1;
 * @return {string}
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SubmitCustomerMileageRequest} returns this
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SubmitCustomerMileageRequest} returns this
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SubmitCustomerMileageRequest} returns this
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string subscription_id = 4;
 * @return {string}
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SubmitCustomerMileageRequest} returns this
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 mileage = 5;
 * @return {number}
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.getMileage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.inspection.SubmitCustomerMileageRequest} returns this
 */ proto.inspection.SubmitCustomerMileageRequest.prototype.setMileage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetCustomerSubmittedMileageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetCustomerSubmittedMileageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetCustomerSubmittedMileageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetCustomerSubmittedMileageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetCustomerSubmittedMileageRequest}
 */ proto.inspection.GetCustomerSubmittedMileageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetCustomerSubmittedMileageRequest;
    return proto.inspection.GetCustomerSubmittedMileageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetCustomerSubmittedMileageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetCustomerSubmittedMileageRequest}
 */ proto.inspection.GetCustomerSubmittedMileageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetCustomerSubmittedMileageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetCustomerSubmittedMileageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetCustomerSubmittedMileageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetCustomerSubmittedMileageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.inspection.GetCustomerSubmittedMileageRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetCustomerSubmittedMileageRequest} returns this
 */ proto.inspection.GetCustomerSubmittedMileageRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetCustomerSubmittedMileageResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetCustomerSubmittedMileageResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetCustomerSubmittedMileageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetCustomerSubmittedMileageResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            odoReading: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetCustomerSubmittedMileageResponse}
 */ proto.inspection.GetCustomerSubmittedMileageResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetCustomerSubmittedMileageResponse;
    return proto.inspection.GetCustomerSubmittedMileageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetCustomerSubmittedMileageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetCustomerSubmittedMileageResponse}
 */ proto.inspection.GetCustomerSubmittedMileageResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setOdoReading(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetCustomerSubmittedMileageResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetCustomerSubmittedMileageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetCustomerSubmittedMileageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetCustomerSubmittedMileageResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getOdoReading();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string odo_reading = 1;
 * @return {string}
 */ proto.inspection.GetCustomerSubmittedMileageResponse.prototype.getOdoReading = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetCustomerSubmittedMileageResponse} returns this
 */ proto.inspection.GetCustomerSubmittedMileageResponse.prototype.setOdoReading = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.CheckVehicleInspectionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.CheckVehicleInspectionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.CheckVehicleInspectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.CheckVehicleInspectionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.CheckVehicleInspectionResponse}
 */ proto.inspection.CheckVehicleInspectionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.CheckVehicleInspectionResponse;
    return proto.inspection.CheckVehicleInspectionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.CheckVehicleInspectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.CheckVehicleInspectionResponse}
 */ proto.inspection.CheckVehicleInspectionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.CheckVehicleInspectionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.CheckVehicleInspectionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.CheckVehicleInspectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.CheckVehicleInspectionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.inspection.CheckVehicleInspectionResponse.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.CheckVehicleInspectionResponse} returns this
 */ proto.inspection.CheckVehicleInspectionResponse.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.inspection.SubmitInspectionResultsRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.SubmitInspectionResultsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.SubmitInspectionResultsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SubmitInspectionResultsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            resultsJson: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            photosList: $8M67s.Message.toObjectList(msg.getPhotosList(), proto.inspection.Photo.toObject, includeInstance),
            pdfUrl: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            inspectionStarted: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.SubmitInspectionResultsRequest}
 */ proto.inspection.SubmitInspectionResultsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.SubmitInspectionResultsRequest;
    return proto.inspection.SubmitInspectionResultsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.SubmitInspectionResultsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.SubmitInspectionResultsRequest}
 */ proto.inspection.SubmitInspectionResultsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setResultsJson(value);
                break;
            case 2:
                var value = new proto.inspection.Photo;
                reader.readMessage(value, proto.inspection.Photo.deserializeBinaryFromReader);
                msg.addPhotos(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPdfUrl(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setInspectionStarted(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.SubmitInspectionResultsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.SubmitInspectionResultsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SubmitInspectionResultsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResultsJson();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPhotosList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.inspection.Photo.serializeBinaryToWriter);
    f = message.getPdfUrl();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getInspectionStarted();
    if (f !== 0) writer.writeInt64(5, f);
};
/**
 * optional string results_json = 1;
 * @return {string}
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.getResultsJson = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SubmitInspectionResultsRequest} returns this
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.setResultsJson = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated Photo photos = 2;
 * @return {!Array<!proto.inspection.Photo>}
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.getPhotosList = function() {
    return /** @type{!Array<!proto.inspection.Photo>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.inspection.Photo, 2);
};
/**
 * @param {!Array<!proto.inspection.Photo>} value
 * @return {!proto.inspection.SubmitInspectionResultsRequest} returns this
*/ proto.inspection.SubmitInspectionResultsRequest.prototype.setPhotosList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.inspection.Photo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.inspection.Photo}
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.addPhotos = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.inspection.Photo, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.inspection.SubmitInspectionResultsRequest} returns this
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.clearPhotosList = function() {
    return this.setPhotosList([]);
};
/**
 * optional string pdf_url = 3;
 * @return {string}
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.getPdfUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SubmitInspectionResultsRequest} returns this
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.setPdfUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string vehicle_id = 4;
 * @return {string}
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SubmitInspectionResultsRequest} returns this
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 inspection_started = 5;
 * @return {number}
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.getInspectionStarted = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.inspection.SubmitInspectionResultsRequest} returns this
 */ proto.inspection.SubmitInspectionResultsRequest.prototype.setInspectionStarted = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.SubmitInspectionResultsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.SubmitInspectionResultsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.SubmitInspectionResultsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SubmitInspectionResultsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.SubmitInspectionResultsResponse}
 */ proto.inspection.SubmitInspectionResultsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.SubmitInspectionResultsResponse;
    return proto.inspection.SubmitInspectionResultsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.SubmitInspectionResultsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.SubmitInspectionResultsResponse}
 */ proto.inspection.SubmitInspectionResultsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.SubmitInspectionResultsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.SubmitInspectionResultsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.SubmitInspectionResultsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SubmitInspectionResultsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.BeginInspectionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.BeginInspectionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.BeginInspectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.BeginInspectionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vin: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            dealerUserId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            redirectUrl: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            inspectionType: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            smsDetails: (f = msg.getSmsDetails()) && proto.inspection.SMSDetails.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.BeginInspectionRequest}
 */ proto.inspection.BeginInspectionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.BeginInspectionRequest;
    return proto.inspection.BeginInspectionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.BeginInspectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.BeginInspectionRequest}
 */ proto.inspection.BeginInspectionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerUserId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setRedirectUrl(value);
                break;
            case 7:
                var value = /** @type {!proto.inspection.InspectionType} */ reader.readEnum();
                msg.setInspectionType(value);
                break;
            case 8:
                var value = new proto.inspection.SMSDetails;
                reader.readMessage(value, proto.inspection.SMSDetails.deserializeBinaryFromReader);
                msg.setSmsDetails(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.BeginInspectionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.BeginInspectionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.BeginInspectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.BeginInspectionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVin();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getDealerUserId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getRedirectUrl();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getInspectionType();
    if (f !== 0.0) writer.writeEnum(7, f);
    f = message.getSmsDetails();
    if (f != null) writer.writeMessage(8, f, proto.inspection.SMSDetails.serializeBinaryToWriter);
};
/**
 * optional string vin = 1;
 * @return {string}
 */ proto.inspection.BeginInspectionRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.BeginInspectionRequest} returns this
 */ proto.inspection.BeginInspectionRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.inspection.BeginInspectionRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.BeginInspectionRequest} returns this
 */ proto.inspection.BeginInspectionRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.inspection.BeginInspectionRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.BeginInspectionRequest} returns this
 */ proto.inspection.BeginInspectionRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string dealership_id = 4;
 * @return {string}
 */ proto.inspection.BeginInspectionRequest.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.BeginInspectionRequest} returns this
 */ proto.inspection.BeginInspectionRequest.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string dealer_user_id = 5;
 * @return {string}
 */ proto.inspection.BeginInspectionRequest.prototype.getDealerUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.BeginInspectionRequest} returns this
 */ proto.inspection.BeginInspectionRequest.prototype.setDealerUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string redirect_url = 6;
 * @return {string}
 */ proto.inspection.BeginInspectionRequest.prototype.getRedirectUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.BeginInspectionRequest} returns this
 */ proto.inspection.BeginInspectionRequest.prototype.setRedirectUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional InspectionType inspection_type = 7;
 * @return {!proto.inspection.InspectionType}
 */ proto.inspection.BeginInspectionRequest.prototype.getInspectionType = function() {
    return /** @type {!proto.inspection.InspectionType} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.inspection.InspectionType} value
 * @return {!proto.inspection.BeginInspectionRequest} returns this
 */ proto.inspection.BeginInspectionRequest.prototype.setInspectionType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional SMSDetails sms_details = 8;
 * @return {?proto.inspection.SMSDetails}
 */ proto.inspection.BeginInspectionRequest.prototype.getSmsDetails = function() {
    return /** @type{?proto.inspection.SMSDetails} */ $8M67s.Message.getWrapperField(this, proto.inspection.SMSDetails, 8);
};
/**
 * @param {?proto.inspection.SMSDetails|undefined} value
 * @return {!proto.inspection.BeginInspectionRequest} returns this
*/ proto.inspection.BeginInspectionRequest.prototype.setSmsDetails = function(value) {
    return $8M67s.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.inspection.BeginInspectionRequest} returns this
 */ proto.inspection.BeginInspectionRequest.prototype.clearSmsDetails = function() {
    return this.setSmsDetails(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.inspection.BeginInspectionRequest.prototype.hasSmsDetails = function() {
    return $8M67s.Message.getField(this, 8) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.SMSDetails.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.SMSDetails.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.SMSDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SMSDetails.toObject = function(includeInstance, msg) {
        var f, obj = {
            recipientPhone: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            recipientName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            senderPhone: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            senderName: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.SMSDetails}
 */ proto.inspection.SMSDetails.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.SMSDetails;
    return proto.inspection.SMSDetails.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.SMSDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.SMSDetails}
 */ proto.inspection.SMSDetails.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setRecipientPhone(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setRecipientName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSenderPhone(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSenderName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.SMSDetails.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.SMSDetails.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.SMSDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.SMSDetails.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getRecipientPhone();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getRecipientName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSenderPhone();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getSenderName();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string recipient_phone = 1;
 * @return {string}
 */ proto.inspection.SMSDetails.prototype.getRecipientPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SMSDetails} returns this
 */ proto.inspection.SMSDetails.prototype.setRecipientPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string recipient_name = 2;
 * @return {string}
 */ proto.inspection.SMSDetails.prototype.getRecipientName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SMSDetails} returns this
 */ proto.inspection.SMSDetails.prototype.setRecipientName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string sender_phone = 3;
 * @return {string}
 */ proto.inspection.SMSDetails.prototype.getSenderPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SMSDetails} returns this
 */ proto.inspection.SMSDetails.prototype.setSenderPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string sender_name = 4;
 * @return {string}
 */ proto.inspection.SMSDetails.prototype.getSenderName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.SMSDetails} returns this
 */ proto.inspection.SMSDetails.prototype.setSenderName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.BeginInspectionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.BeginInspectionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.BeginInspectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.BeginInspectionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            sessionKey: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            inspectionStarted: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.BeginInspectionResponse}
 */ proto.inspection.BeginInspectionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.BeginInspectionResponse;
    return proto.inspection.BeginInspectionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.BeginInspectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.BeginInspectionResponse}
 */ proto.inspection.BeginInspectionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSessionKey(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setInspectionStarted(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.BeginInspectionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.BeginInspectionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.BeginInspectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.BeginInspectionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSessionKey();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getInspectionStarted();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * optional string session_key = 1;
 * @return {string}
 */ proto.inspection.BeginInspectionResponse.prototype.getSessionKey = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.BeginInspectionResponse} returns this
 */ proto.inspection.BeginInspectionResponse.prototype.setSessionKey = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 inspection_started = 2;
 * @return {number}
 */ proto.inspection.BeginInspectionResponse.prototype.getInspectionStarted = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.inspection.BeginInspectionResponse} returns this
 */ proto.inspection.BeginInspectionResponse.prototype.setInspectionStarted = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.Photo.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.Photo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.Photo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.Photo.toObject = function(includeInstance, msg) {
        var f, obj = {
            label: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            url: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.Photo}
 */ proto.inspection.Photo.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.Photo;
    return proto.inspection.Photo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.Photo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.Photo}
 */ proto.inspection.Photo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setLabel(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUrl(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.Photo.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.Photo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.Photo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.Photo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLabel();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getUrl();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string label = 1;
 * @return {string}
 */ proto.inspection.Photo.prototype.getLabel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Photo} returns this
 */ proto.inspection.Photo.prototype.setLabel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string url = 2;
 * @return {string}
 */ proto.inspection.Photo.prototype.getUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Photo} returns this
 */ proto.inspection.Photo.prototype.setUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionResultsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionResultsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionResultsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionResultsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionResultsRequest}
 */ proto.inspection.GetInspectionResultsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionResultsRequest;
    return proto.inspection.GetInspectionResultsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionResultsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionResultsRequest}
 */ proto.inspection.GetInspectionResultsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionResultsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionResultsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionResultsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionResultsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.inspection.GetInspectionResultsRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionResultsRequest} returns this
 */ proto.inspection.GetInspectionResultsRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.inspection.GetInspectionResultsRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionResultsRequest} returns this
 */ proto.inspection.GetInspectionResultsRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.inspection.GetInspectionResultsRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionResultsRequest} returns this
 */ proto.inspection.GetInspectionResultsRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionResultsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionResultsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionResultsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionResultsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            results: (f = msg.getResults()) && proto.inspection.InspectionResults.toObject(includeInstance, f),
            inspectionJson: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionResultsResponse}
 */ proto.inspection.GetInspectionResultsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionResultsResponse;
    return proto.inspection.GetInspectionResultsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionResultsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionResultsResponse}
 */ proto.inspection.GetInspectionResultsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.inspection.InspectionResults;
                reader.readMessage(value, proto.inspection.InspectionResults.deserializeBinaryFromReader);
                msg.setResults(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionJson(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionResultsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionResultsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionResultsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionResultsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getResults();
    if (f != null) writer.writeMessage(1, f, proto.inspection.InspectionResults.serializeBinaryToWriter);
    f = message.getInspectionJson();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional InspectionResults results = 1;
 * @return {?proto.inspection.InspectionResults}
 */ proto.inspection.GetInspectionResultsResponse.prototype.getResults = function() {
    return /** @type{?proto.inspection.InspectionResults} */ $8M67s.Message.getWrapperField(this, proto.inspection.InspectionResults, 1);
};
/**
 * @param {?proto.inspection.InspectionResults|undefined} value
 * @return {!proto.inspection.GetInspectionResultsResponse} returns this
*/ proto.inspection.GetInspectionResultsResponse.prototype.setResults = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.inspection.GetInspectionResultsResponse} returns this
 */ proto.inspection.GetInspectionResultsResponse.prototype.clearResults = function() {
    return this.setResults(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.inspection.GetInspectionResultsResponse.prototype.hasResults = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional string inspection_json = 2;
 * @return {string}
 */ proto.inspection.GetInspectionResultsResponse.prototype.getInspectionJson = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionResultsResponse} returns this
 */ proto.inspection.GetInspectionResultsResponse.prototype.setInspectionJson = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.InspectionResults.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.InspectionResults.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.InspectionResults} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.InspectionResults.toObject = function(includeInstance, msg) {
        var f, obj = {
            odoReading: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            odoUnit: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            colour: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            signedCustomerId: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.InspectionResults}
 */ proto.inspection.InspectionResults.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.InspectionResults;
    return proto.inspection.InspectionResults.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.InspectionResults} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.InspectionResults}
 */ proto.inspection.InspectionResults.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setOdoReading(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOdoUnit(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setColour(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setSignedCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.InspectionResults.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.InspectionResults.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.InspectionResults} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.InspectionResults.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getOdoReading();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOdoUnit();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getColour();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getSignedCustomerId();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional string odo_reading = 1;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getOdoReading = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setOdoReading = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string odo_unit = 2;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getOdoUnit = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setOdoUnit = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vin = 3;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string year = 4;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string make = 5;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string model = 6;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string trim = 7;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string colour = 8;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getColour = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setColour = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string inspection_id = 9;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string vehicle_id = 10;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string signed_customer_id = 11;
 * @return {string}
 */ proto.inspection.InspectionResults.prototype.getSignedCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.InspectionResults} returns this
 */ proto.inspection.InspectionResults.prototype.setSignedCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.StartInspectionCustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.StartInspectionCustomerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.StartInspectionCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.StartInspectionCustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.StartInspectionCustomerRequest}
 */ proto.inspection.StartInspectionCustomerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.StartInspectionCustomerRequest;
    return proto.inspection.StartInspectionCustomerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.StartInspectionCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.StartInspectionCustomerRequest}
 */ proto.inspection.StartInspectionCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.StartInspectionCustomerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.StartInspectionCustomerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.StartInspectionCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.StartInspectionCustomerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.inspection.StartInspectionCustomerRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.StartInspectionCustomerRequest} returns this
 */ proto.inspection.StartInspectionCustomerRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.StartInspectionDealerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.StartInspectionDealerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.StartInspectionDealerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.StartInspectionDealerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.StartInspectionDealerRequest}
 */ proto.inspection.StartInspectionDealerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.StartInspectionDealerRequest;
    return proto.inspection.StartInspectionDealerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.StartInspectionDealerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.StartInspectionDealerRequest}
 */ proto.inspection.StartInspectionDealerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.StartInspectionDealerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.StartInspectionDealerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.StartInspectionDealerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.StartInspectionDealerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.inspection.StartInspectionDealerRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.StartInspectionDealerRequest} returns this
 */ proto.inspection.StartInspectionDealerRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.StartInspectionFleetRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.StartInspectionFleetRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.StartInspectionFleetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.StartInspectionFleetRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.StartInspectionFleetRequest}
 */ proto.inspection.StartInspectionFleetRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.StartInspectionFleetRequest;
    return proto.inspection.StartInspectionFleetRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.StartInspectionFleetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.StartInspectionFleetRequest}
 */ proto.inspection.StartInspectionFleetRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.StartInspectionFleetRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.StartInspectionFleetRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.StartInspectionFleetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.StartInspectionFleetRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.inspection.StartInspectionFleetRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.StartInspectionFleetRequest} returns this
 */ proto.inspection.StartInspectionFleetRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.inspection.StartInspectionFleetRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.StartInspectionFleetRequest} returns this
 */ proto.inspection.StartInspectionFleetRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.StartInspectionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.StartInspectionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.StartInspectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.StartInspectionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            inspectionKey: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.StartInspectionResponse}
 */ proto.inspection.StartInspectionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.StartInspectionResponse;
    return proto.inspection.StartInspectionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.StartInspectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.StartInspectionResponse}
 */ proto.inspection.StartInspectionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionKey(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.StartInspectionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.StartInspectionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.StartInspectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.StartInspectionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getInspectionKey();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.inspection.StartInspectionResponse.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.StartInspectionResponse} returns this
 */ proto.inspection.StartInspectionResponse.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string inspection_key = 2;
 * @return {string}
 */ proto.inspection.StartInspectionResponse.prototype.getInspectionKey = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.StartInspectionResponse} returns this
 */ proto.inspection.StartInspectionResponse.prototype.setInspectionKey = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionStatusRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionStatusRequest}
 */ proto.inspection.GetInspectionStatusRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionStatusRequest;
    return proto.inspection.GetInspectionStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionStatusRequest}
 */ proto.inspection.GetInspectionStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionStatusRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionStatusRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.inspection.GetInspectionStatusRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionStatusRequest} returns this
 */ proto.inspection.GetInspectionStatusRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionStatusResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            status: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionStatusResponse}
 */ proto.inspection.GetInspectionStatusResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionStatusResponse;
    return proto.inspection.GetInspectionStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionStatusResponse}
 */ proto.inspection.GetInspectionStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.inspection.InspectionStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionStatusResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionStatusResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional InspectionStatus status = 1;
 * @return {!proto.inspection.InspectionStatus}
 */ proto.inspection.GetInspectionStatusResponse.prototype.getStatus = function() {
    return /** @type {!proto.inspection.InspectionStatus} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.inspection.InspectionStatus} value
 * @return {!proto.inspection.GetInspectionStatusResponse} returns this
 */ proto.inspection.GetInspectionStatusResponse.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.Inspection.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.Inspection.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.Inspection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.Inspection.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastUpdate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            status: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.Inspection}
 */ proto.inspection.Inspection.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.Inspection;
    return proto.inspection.Inspection.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.Inspection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.Inspection}
 */ proto.inspection.Inspection.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLastUpdate(value);
                break;
            case 5:
                var value = /** @type {!proto.inspection.InspectionStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.Inspection.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.Inspection.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.Inspection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.Inspection.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastUpdate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(5, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.inspection.Inspection.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Inspection} returns this
 */ proto.inspection.Inspection.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.inspection.Inspection.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Inspection} returns this
 */ proto.inspection.Inspection.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vin = 3;
 * @return {string}
 */ proto.inspection.Inspection.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Inspection} returns this
 */ proto.inspection.Inspection.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 last_update = 4;
 * @return {number}
 */ proto.inspection.Inspection.prototype.getLastUpdate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.inspection.Inspection} returns this
 */ proto.inspection.Inspection.prototype.setLastUpdate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional InspectionStatus status = 5;
 * @return {!proto.inspection.InspectionStatus}
 */ proto.inspection.Inspection.prototype.getStatus = function() {
    return /** @type {!proto.inspection.InspectionStatus} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.inspection.InspectionStatus} value
 * @return {!proto.inspection.Inspection} returns this
 */ proto.inspection.Inspection.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionPhotosRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionPhotosRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionPhotosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionPhotosRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionPhotosRequest}
 */ proto.inspection.GetInspectionPhotosRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionPhotosRequest;
    return proto.inspection.GetInspectionPhotosRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionPhotosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionPhotosRequest}
 */ proto.inspection.GetInspectionPhotosRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionPhotosRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionPhotosRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionPhotosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionPhotosRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.inspection.GetInspectionPhotosRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionPhotosRequest} returns this
 */ proto.inspection.GetInspectionPhotosRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.inspection.GetInspectionPhotosRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionPhotosRequest} returns this
 */ proto.inspection.GetInspectionPhotosRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.inspection.GetInspectionPhotosResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionPhotosResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionPhotosResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionPhotosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionPhotosResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            photosList: $8M67s.Message.toObjectList(msg.getPhotosList(), proto.inspection.Photo.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionPhotosResponse}
 */ proto.inspection.GetInspectionPhotosResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionPhotosResponse;
    return proto.inspection.GetInspectionPhotosResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionPhotosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionPhotosResponse}
 */ proto.inspection.GetInspectionPhotosResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.inspection.Photo;
                reader.readMessage(value, proto.inspection.Photo.deserializeBinaryFromReader);
                msg.addPhotos(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionPhotosResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionPhotosResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionPhotosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionPhotosResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhotosList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.inspection.Photo.serializeBinaryToWriter);
};
/**
 * repeated Photo photos = 1;
 * @return {!Array<!proto.inspection.Photo>}
 */ proto.inspection.GetInspectionPhotosResponse.prototype.getPhotosList = function() {
    return /** @type{!Array<!proto.inspection.Photo>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.inspection.Photo, 1);
};
/**
 * @param {!Array<!proto.inspection.Photo>} value
 * @return {!proto.inspection.GetInspectionPhotosResponse} returns this
*/ proto.inspection.GetInspectionPhotosResponse.prototype.setPhotosList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.inspection.Photo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.inspection.Photo}
 */ proto.inspection.GetInspectionPhotosResponse.prototype.addPhotos = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.inspection.Photo, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.inspection.GetInspectionPhotosResponse} returns this
 */ proto.inspection.GetInspectionPhotosResponse.prototype.clearPhotosList = function() {
    return this.setPhotosList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.Note.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.Note.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.Note} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.Note.toObject = function(includeInstance, msg) {
        var f, obj = {
            user: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            title: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            type: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.Note}
 */ proto.inspection.Note.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.Note;
    return proto.inspection.Note.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.Note} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.Note}
 */ proto.inspection.Note.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setUser(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTitle(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setType(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setTimestamp(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.Note.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.Note.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.Note} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.Note.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUser();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTitle();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getType();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getTimestamp();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string user = 1;
 * @return {string}
 */ proto.inspection.Note.prototype.getUser = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Note} returns this
 */ proto.inspection.Note.prototype.setUser = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string title = 2;
 * @return {string}
 */ proto.inspection.Note.prototype.getTitle = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Note} returns this
 */ proto.inspection.Note.prototype.setTitle = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string description = 3;
 * @return {string}
 */ proto.inspection.Note.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Note} returns this
 */ proto.inspection.Note.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string type = 4;
 * @return {string}
 */ proto.inspection.Note.prototype.getType = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Note} returns this
 */ proto.inspection.Note.prototype.setType = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string timestamp = 5;
 * @return {string}
 */ proto.inspection.Note.prototype.getTimestamp = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.Note} returns this
 */ proto.inspection.Note.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionNotesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionNotesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionNotesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionNotesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionNotesRequest}
 */ proto.inspection.GetInspectionNotesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionNotesRequest;
    return proto.inspection.GetInspectionNotesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionNotesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionNotesRequest}
 */ proto.inspection.GetInspectionNotesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionNotesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionNotesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionNotesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionNotesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.inspection.GetInspectionNotesRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionNotesRequest} returns this
 */ proto.inspection.GetInspectionNotesRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.inspection.GetInspectionNotesRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.inspection.GetInspectionNotesRequest} returns this
 */ proto.inspection.GetInspectionNotesRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.inspection.GetInspectionNotesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.inspection.GetInspectionNotesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.inspection.GetInspectionNotesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.inspection.GetInspectionNotesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionNotesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            notesList: $8M67s.Message.toObjectList(msg.getNotesList(), proto.inspection.Note.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.inspection.GetInspectionNotesResponse}
 */ proto.inspection.GetInspectionNotesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.inspection.GetInspectionNotesResponse;
    return proto.inspection.GetInspectionNotesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.inspection.GetInspectionNotesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.inspection.GetInspectionNotesResponse}
 */ proto.inspection.GetInspectionNotesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.inspection.Note;
                reader.readMessage(value, proto.inspection.Note.deserializeBinaryFromReader);
                msg.addNotes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.inspection.GetInspectionNotesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.inspection.GetInspectionNotesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.inspection.GetInspectionNotesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.inspection.GetInspectionNotesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNotesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.inspection.Note.serializeBinaryToWriter);
};
/**
 * repeated Note notes = 1;
 * @return {!Array<!proto.inspection.Note>}
 */ proto.inspection.GetInspectionNotesResponse.prototype.getNotesList = function() {
    return /** @type{!Array<!proto.inspection.Note>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.inspection.Note, 1);
};
/**
 * @param {!Array<!proto.inspection.Note>} value
 * @return {!proto.inspection.GetInspectionNotesResponse} returns this
*/ proto.inspection.GetInspectionNotesResponse.prototype.setNotesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.inspection.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.inspection.Note}
 */ proto.inspection.GetInspectionNotesResponse.prototype.addNotes = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.inspection.Note, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.inspection.GetInspectionNotesResponse} returns this
 */ proto.inspection.GetInspectionNotesResponse.prototype.clearNotesList = function() {
    return this.setNotesList([]);
};
/**
 * @enum {number}
 */ proto.inspection.InspectionType = {
    INFLEETING: 0,
    RETURN: 1,
    PICKUP: 2
};
/**
 * @enum {number}
 */ proto.inspection.InspectionStatus = {
    INCOMPLETE: 0,
    COMPLETE: 1,
    ERROR: 2
};
$bdfc2200c6930f2c$var$goog.object.extend(module.exports, proto.inspection);

});

parcelRegister("hOsJC", function(module, exports) {
// source: subscription.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $cf7d654c329c7644$var$goog = $8M67s;
var $cf7d654c329c7644$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$cf7d654c329c7644$var$goog.object.extend(proto, $3QqPt);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ColorOption', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ColorOptionCreated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ContractProperties', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.PendingSubscriptionInitialized', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.PricingOption', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.PricingOptionCreated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ProcessDueStatements', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.Program', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ProgramCreated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ProgramPricingOptionsUpdated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.Reservation', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.Reservation.ProgramOptionsCase', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ReservationCancelled', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ReservationCreated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ReservationCreated.ProgramOptionsCase', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ReservationOptionsUpdated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ReservationOptionsUpdated.ProgramOptionsCase', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ReservationStatus', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.ReservationStatusUpdated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.StatementDue', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.SubscriptionAction', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.SubscriptionAction.ActionReason', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.SubscriptionAction.ActionType', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.SubscriptionAction.UserType', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.SubscriptionActivated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.SubscriptionStatus', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.SubscriptionUpdated', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.SubscriptionUpdated.Reason', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.TeslaModel3Options', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.TeslaModelYOptions', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.TrimOption', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.VehicleAssigned', null, $cf7d654c329c7644$var$global);
$cf7d654c329c7644$var$goog.exportSymbol('proto.subscription.VehiclePickupReceiptProperties', null, $cf7d654c329c7644$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.Reservation = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.subscription.Reservation.oneofGroups_);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.Reservation, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.Reservation.displayName = 'proto.subscription.Reservation';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.Program = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.subscription.Program.repeatedFields_, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.Program, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.Program.displayName = 'proto.subscription.Program';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.TrimOption = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.TrimOption, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.TrimOption.displayName = 'proto.subscription.TrimOption';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ColorOption = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ColorOption, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ColorOption.displayName = 'proto.subscription.ColorOption';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.PricingOption = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.PricingOption, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.PricingOption.displayName = 'proto.subscription.PricingOption';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.TeslaModel3Options = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.TeslaModel3Options, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.TeslaModel3Options.displayName = 'proto.subscription.TeslaModel3Options';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.TeslaModelYOptions = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.TeslaModelYOptions, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.TeslaModelYOptions.displayName = 'proto.subscription.TeslaModelYOptions';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ProgramCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ProgramCreated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ProgramCreated.displayName = 'proto.subscription.ProgramCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.PricingOptionCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.PricingOptionCreated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.PricingOptionCreated.displayName = 'proto.subscription.PricingOptionCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ColorOptionCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ColorOptionCreated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ColorOptionCreated.displayName = 'proto.subscription.ColorOptionCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ReservationCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.subscription.ReservationCreated.oneofGroups_);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ReservationCreated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ReservationCreated.displayName = 'proto.subscription.ReservationCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ReservationStatusUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ReservationStatusUpdated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ReservationStatusUpdated.displayName = 'proto.subscription.ReservationStatusUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.PendingSubscriptionInitialized = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.PendingSubscriptionInitialized, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.PendingSubscriptionInitialized.displayName = 'proto.subscription.PendingSubscriptionInitialized';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ReservationCancelled = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.subscription.ReservationCancelled.repeatedFields_, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ReservationCancelled, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ReservationCancelled.displayName = 'proto.subscription.ReservationCancelled';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.SubscriptionAction = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.SubscriptionAction, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.SubscriptionAction.displayName = 'proto.subscription.SubscriptionAction';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ReservationOptionsUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.subscription.ReservationOptionsUpdated.oneofGroups_);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ReservationOptionsUpdated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ReservationOptionsUpdated.displayName = 'proto.subscription.ReservationOptionsUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ProcessDueStatements = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ProcessDueStatements, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ProcessDueStatements.displayName = 'proto.subscription.ProcessDueStatements';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.StatementDue = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.StatementDue, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.StatementDue.displayName = 'proto.subscription.StatementDue';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.VehicleAssigned = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.VehicleAssigned, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.VehicleAssigned.displayName = 'proto.subscription.VehicleAssigned';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.SubscriptionActivated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.SubscriptionActivated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.SubscriptionActivated.displayName = 'proto.subscription.SubscriptionActivated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.SubscriptionUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.SubscriptionUpdated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.SubscriptionUpdated.displayName = 'proto.subscription.SubscriptionUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ProgramPricingOptionsUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.subscription.ProgramPricingOptionsUpdated.repeatedFields_, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ProgramPricingOptionsUpdated, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ProgramPricingOptionsUpdated.displayName = 'proto.subscription.ProgramPricingOptionsUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.ContractProperties = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.ContractProperties, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.ContractProperties.displayName = 'proto.subscription.ContractProperties';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription.VehiclePickupReceiptProperties = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$cf7d654c329c7644$var$goog.inherits(proto.subscription.VehiclePickupReceiptProperties, $8M67s.Message);
if ($cf7d654c329c7644$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription.VehiclePickupReceiptProperties.displayName = 'proto.subscription.VehiclePickupReceiptProperties';
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.subscription.Reservation.oneofGroups_ = [
    [
        9,
        11
    ]
];
/**
 * @enum {number}
 */ proto.subscription.Reservation.ProgramOptionsCase = {
    PROGRAM_OPTIONS_NOT_SET: 0,
    MODEL_3: 9,
    MODEL_Y: 11
};
/**
 * @return {proto.subscription.Reservation.ProgramOptionsCase}
 */ proto.subscription.Reservation.prototype.getProgramOptionsCase = function() {
    return /** @type {proto.subscription.Reservation.ProgramOptionsCase} */ $8M67s.Message.computeOneofCase(this, proto.subscription.Reservation.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.Reservation.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.Reservation.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.Reservation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.Reservation.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            version: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            reservationNumber: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            created: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            model3: (f = msg.getModel3()) && proto.subscription.TeslaModel3Options.toObject(includeInstance, f),
            modelY: (f = msg.getModelY()) && proto.subscription.TeslaModelYOptions.toObject(includeInstance, f),
            trackingId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            initialProgramId: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            initialPriceOptionId: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            zipCode: $8M67s.Message.getFieldWithDefault(msg, 14, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.Reservation}
 */ proto.subscription.Reservation.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.Reservation;
    return proto.subscription.Reservation.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.Reservation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.Reservation}
 */ proto.subscription.Reservation.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationNumber(value);
                break;
            case 7:
                var value = /** @type {!proto.subscription.ReservationStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 9:
                var value = new proto.subscription.TeslaModel3Options;
                reader.readMessage(value, proto.subscription.TeslaModel3Options.deserializeBinaryFromReader);
                msg.setModel3(value);
                break;
            case 11:
                var value = new proto.subscription.TeslaModelYOptions;
                reader.readMessage(value, proto.subscription.TeslaModelYOptions.deserializeBinaryFromReader);
                msg.setModelY(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingId(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setInitialProgramId(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setInitialPriceOptionId(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setZipCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.Reservation.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.Reservation.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.Reservation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.Reservation.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getReservationNumber();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(7, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getModel3();
    if (f != null) writer.writeMessage(9, f, proto.subscription.TeslaModel3Options.serializeBinaryToWriter);
    f = message.getModelY();
    if (f != null) writer.writeMessage(11, f, proto.subscription.TeslaModelYOptions.serializeBinaryToWriter);
    f = message.getTrackingId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getInitialProgramId();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getInitialPriceOptionId();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getZipCode();
    if (f.length > 0) writer.writeString(14, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 version = 2;
 * @return {number}
 */ proto.subscription.Reservation.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string program_id = 4;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string subscription_id = 5;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string reservation_number = 6;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getReservationNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setReservationNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional ReservationStatus status = 7;
 * @return {!proto.subscription.ReservationStatus}
 */ proto.subscription.Reservation.prototype.getStatus = function() {
    return /** @type {!proto.subscription.ReservationStatus} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.subscription.ReservationStatus} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional int64 created = 8;
 * @return {number}
 */ proto.subscription.Reservation.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional TeslaModel3Options model_3 = 9;
 * @return {?proto.subscription.TeslaModel3Options}
 */ proto.subscription.Reservation.prototype.getModel3 = function() {
    return /** @type{?proto.subscription.TeslaModel3Options} */ $8M67s.Message.getWrapperField(this, proto.subscription.TeslaModel3Options, 9);
};
/**
 * @param {?proto.subscription.TeslaModel3Options|undefined} value
 * @return {!proto.subscription.Reservation} returns this
*/ proto.subscription.Reservation.prototype.setModel3 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 9, proto.subscription.Reservation.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.clearModel3 = function() {
    return this.setModel3(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription.Reservation.prototype.hasModel3 = function() {
    return $8M67s.Message.getField(this, 9) != null;
};
/**
 * optional TeslaModelYOptions model_y = 11;
 * @return {?proto.subscription.TeslaModelYOptions}
 */ proto.subscription.Reservation.prototype.getModelY = function() {
    return /** @type{?proto.subscription.TeslaModelYOptions} */ $8M67s.Message.getWrapperField(this, proto.subscription.TeslaModelYOptions, 11);
};
/**
 * @param {?proto.subscription.TeslaModelYOptions|undefined} value
 * @return {!proto.subscription.Reservation} returns this
*/ proto.subscription.Reservation.prototype.setModelY = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 11, proto.subscription.Reservation.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.clearModelY = function() {
    return this.setModelY(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription.Reservation.prototype.hasModelY = function() {
    return $8M67s.Message.getField(this, 11) != null;
};
/**
 * optional string tracking_id = 10;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getTrackingId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setTrackingId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string initial_program_id = 12;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getInitialProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setInitialProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string initial_price_option_id = 13;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getInitialPriceOptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setInitialPriceOptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string zip_code = 14;
 * @return {string}
 */ proto.subscription.Reservation.prototype.getZipCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Reservation} returns this
 */ proto.subscription.Reservation.prototype.setZipCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.subscription.Program.repeatedFields_ = [
    6,
    7,
    8
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.Program.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.Program.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.Program} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.Program.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            version: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            name: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            trimOptionsList: $8M67s.Message.toObjectList(msg.getTrimOptionsList(), proto.subscription.TrimOption.toObject, includeInstance),
            colorOptionsList: $8M67s.Message.toObjectList(msg.getColorOptionsList(), proto.subscription.ColorOption.toObject, includeInstance),
            pricingOptionsList: $8M67s.Message.toObjectList(msg.getPricingOptionsList(), proto.subscription.PricingOption.toObject, includeInstance),
            make: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 10, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.Program}
 */ proto.subscription.Program.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.Program;
    return proto.subscription.Program.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.Program} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.Program}
 */ proto.subscription.Program.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 6:
                var value = new proto.subscription.TrimOption;
                reader.readMessage(value, proto.subscription.TrimOption.deserializeBinaryFromReader);
                msg.addTrimOptions(value);
                break;
            case 7:
                var value = new proto.subscription.ColorOption;
                reader.readMessage(value, proto.subscription.ColorOption.deserializeBinaryFromReader);
                msg.addColorOptions(value);
                break;
            case 8:
                var value = new proto.subscription.PricingOption;
                reader.readMessage(value, proto.subscription.PricingOption.deserializeBinaryFromReader);
                msg.addPricingOptions(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.Program.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.Program.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.Program} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.Program.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getTrimOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, proto.subscription.TrimOption.serializeBinaryToWriter);
    f = message.getColorOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, proto.subscription.ColorOption.serializeBinaryToWriter);
    f = message.getPricingOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(8, f, proto.subscription.PricingOption.serializeBinaryToWriter);
    f = message.getMake();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(10, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.Program.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 version = 2;
 * @return {number}
 */ proto.subscription.Program.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string name = 3;
 * @return {string}
 */ proto.subscription.Program.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string description = 4;
 * @return {string}
 */ proto.subscription.Program.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 created = 5;
 * @return {number}
 */ proto.subscription.Program.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * repeated TrimOption trim_options = 6;
 * @return {!Array<!proto.subscription.TrimOption>}
 */ proto.subscription.Program.prototype.getTrimOptionsList = function() {
    return /** @type{!Array<!proto.subscription.TrimOption>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.subscription.TrimOption, 6);
};
/**
 * @param {!Array<!proto.subscription.TrimOption>} value
 * @return {!proto.subscription.Program} returns this
*/ proto.subscription.Program.prototype.setTrimOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.subscription.TrimOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.subscription.TrimOption}
 */ proto.subscription.Program.prototype.addTrimOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.subscription.TrimOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.clearTrimOptionsList = function() {
    return this.setTrimOptionsList([]);
};
/**
 * repeated ColorOption color_options = 7;
 * @return {!Array<!proto.subscription.ColorOption>}
 */ proto.subscription.Program.prototype.getColorOptionsList = function() {
    return /** @type{!Array<!proto.subscription.ColorOption>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.subscription.ColorOption, 7);
};
/**
 * @param {!Array<!proto.subscription.ColorOption>} value
 * @return {!proto.subscription.Program} returns this
*/ proto.subscription.Program.prototype.setColorOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.subscription.ColorOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.subscription.ColorOption}
 */ proto.subscription.Program.prototype.addColorOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.subscription.ColorOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.clearColorOptionsList = function() {
    return this.setColorOptionsList([]);
};
/**
 * repeated PricingOption pricing_options = 8;
 * @return {!Array<!proto.subscription.PricingOption>}
 */ proto.subscription.Program.prototype.getPricingOptionsList = function() {
    return /** @type{!Array<!proto.subscription.PricingOption>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.subscription.PricingOption, 8);
};
/**
 * @param {!Array<!proto.subscription.PricingOption>} value
 * @return {!proto.subscription.Program} returns this
*/ proto.subscription.Program.prototype.setPricingOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.subscription.PricingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.subscription.PricingOption}
 */ proto.subscription.Program.prototype.addPricingOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.subscription.PricingOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.clearPricingOptionsList = function() {
    return this.setPricingOptionsList([]);
};
/**
 * optional string make = 9;
 * @return {string}
 */ proto.subscription.Program.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string model = 10;
 * @return {string}
 */ proto.subscription.Program.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.Program} returns this
 */ proto.subscription.Program.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.TrimOption.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.TrimOption.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.TrimOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.TrimOption.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.TrimOption}
 */ proto.subscription.TrimOption.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.TrimOption;
    return proto.subscription.TrimOption.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.TrimOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.TrimOption}
 */ proto.subscription.TrimOption.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationFee(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.TrimOption.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.TrimOption.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.TrimOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.TrimOption.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getReservationFee();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.TrimOption.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TrimOption} returns this
 */ proto.subscription.TrimOption.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.subscription.TrimOption.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TrimOption} returns this
 */ proto.subscription.TrimOption.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string reservation_fee = 3;
 * @return {string}
 */ proto.subscription.TrimOption.prototype.getReservationFee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TrimOption} returns this
 */ proto.subscription.TrimOption.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ColorOption.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ColorOption.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ColorOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ColorOption.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            colorName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            colorValue: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ColorOption}
 */ proto.subscription.ColorOption.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ColorOption;
    return proto.subscription.ColorOption.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ColorOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ColorOption}
 */ proto.subscription.ColorOption.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setColorName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setColorValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ColorOption.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ColorOption.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ColorOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ColorOption.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getColorName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getColorValue();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.ColorOption.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ColorOption} returns this
 */ proto.subscription.ColorOption.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string color_name = 2;
 * @return {string}
 */ proto.subscription.ColorOption.prototype.getColorName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ColorOption} returns this
 */ proto.subscription.ColorOption.prototype.setColorName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string color_value = 3;
 * @return {string}
 */ proto.subscription.ColorOption.prototype.getColorValue = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ColorOption} returns this
 */ proto.subscription.ColorOption.prototype.setColorValue = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.PricingOption.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.PricingOption.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.PricingOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.PricingOption.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            monthly: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.PricingOption}
 */ proto.subscription.PricingOption.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.PricingOption;
    return proto.subscription.PricingOption.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.PricingOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.PricingOption}
 */ proto.subscription.PricingOption.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthly(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReservationFee(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPriceTermMonths(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.PricingOption.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.PricingOption.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.PricingOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.PricingOption.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getMonthly();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getReservationFee();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getPriceTermMonths();
    if (f !== 0) writer.writeInt32(6, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.PricingOption.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.PricingOption} returns this
 */ proto.subscription.PricingOption.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 start_fee = 2;
 * @return {number}
 */ proto.subscription.PricingOption.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.PricingOption} returns this
 */ proto.subscription.PricingOption.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 monthly = 3;
 * @return {number}
 */ proto.subscription.PricingOption.prototype.getMonthly = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.PricingOption} returns this
 */ proto.subscription.PricingOption.prototype.setMonthly = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 deposit = 4;
 * @return {number}
 */ proto.subscription.PricingOption.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.PricingOption} returns this
 */ proto.subscription.PricingOption.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 reservation_fee = 5;
 * @return {number}
 */ proto.subscription.PricingOption.prototype.getReservationFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.PricingOption} returns this
 */ proto.subscription.PricingOption.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 price_term_months = 6;
 * @return {number}
 */ proto.subscription.PricingOption.prototype.getPriceTermMonths = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.PricingOption} returns this
 */ proto.subscription.PricingOption.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.TeslaModel3Options.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.TeslaModel3Options.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.TeslaModel3Options} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.TeslaModel3Options.toObject = function(includeInstance, msg) {
        var f, obj = {
            color: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            monthly: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            secondaryColor: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            make: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 9, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.TeslaModel3Options}
 */ proto.subscription.TeslaModel3Options.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.TeslaModel3Options;
    return proto.subscription.TeslaModel3Options.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.TeslaModel3Options} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.TeslaModel3Options}
 */ proto.subscription.TeslaModel3Options.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthly(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReservationFee(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSecondaryColor(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPriceTermMonths(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.TeslaModel3Options.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.TeslaModel3Options.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.TeslaModel3Options} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.TeslaModel3Options.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getColor();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getMonthly();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getReservationFee();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getSecondaryColor();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getPriceTermMonths();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(9, f);
};
/**
 * optional string color = 1;
 * @return {string}
 */ proto.subscription.TeslaModel3Options.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 monthly = 2;
 * @return {number}
 */ proto.subscription.TeslaModel3Options.prototype.getMonthly = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setMonthly = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 start_fee = 3;
 * @return {number}
 */ proto.subscription.TeslaModel3Options.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 deposit = 4;
 * @return {number}
 */ proto.subscription.TeslaModel3Options.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 reservation_fee = 5;
 * @return {number}
 */ proto.subscription.TeslaModel3Options.prototype.getReservationFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string secondary_color = 6;
 * @return {string}
 */ proto.subscription.TeslaModel3Options.prototype.getSecondaryColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setSecondaryColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int32 price_term_months = 7;
 * @return {number}
 */ proto.subscription.TeslaModel3Options.prototype.getPriceTermMonths = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string make = 8;
 * @return {string}
 */ proto.subscription.TeslaModel3Options.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string model = 9;
 * @return {string}
 */ proto.subscription.TeslaModel3Options.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TeslaModel3Options} returns this
 */ proto.subscription.TeslaModel3Options.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.TeslaModelYOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.TeslaModelYOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.TeslaModelYOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.TeslaModelYOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            color: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            monthly: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            secondaryColor: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            make: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 9, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.TeslaModelYOptions}
 */ proto.subscription.TeslaModelYOptions.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.TeslaModelYOptions;
    return proto.subscription.TeslaModelYOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.TeslaModelYOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.TeslaModelYOptions}
 */ proto.subscription.TeslaModelYOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthly(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReservationFee(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSecondaryColor(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPriceTermMonths(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.TeslaModelYOptions.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.TeslaModelYOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.TeslaModelYOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.TeslaModelYOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getColor();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getMonthly();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getReservationFee();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getSecondaryColor();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getPriceTermMonths();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(9, f);
};
/**
 * optional string color = 1;
 * @return {string}
 */ proto.subscription.TeslaModelYOptions.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 monthly = 2;
 * @return {number}
 */ proto.subscription.TeslaModelYOptions.prototype.getMonthly = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setMonthly = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 start_fee = 3;
 * @return {number}
 */ proto.subscription.TeslaModelYOptions.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 deposit = 4;
 * @return {number}
 */ proto.subscription.TeslaModelYOptions.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 reservation_fee = 5;
 * @return {number}
 */ proto.subscription.TeslaModelYOptions.prototype.getReservationFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string secondary_color = 6;
 * @return {string}
 */ proto.subscription.TeslaModelYOptions.prototype.getSecondaryColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setSecondaryColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int32 price_term_months = 7;
 * @return {number}
 */ proto.subscription.TeslaModelYOptions.prototype.getPriceTermMonths = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string make = 8;
 * @return {string}
 */ proto.subscription.TeslaModelYOptions.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string model = 9;
 * @return {string}
 */ proto.subscription.TeslaModelYOptions.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.TeslaModelYOptions} returns this
 */ proto.subscription.TeslaModelYOptions.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ProgramCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ProgramCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ProgramCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ProgramCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            name: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ProgramCreated}
 */ proto.subscription.ProgramCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ProgramCreated;
    return proto.subscription.ProgramCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ProgramCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ProgramCreated}
 */ proto.subscription.ProgramCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ProgramCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ProgramCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ProgramCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ProgramCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.ProgramCreated.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ProgramCreated} returns this
 */ proto.subscription.ProgramCreated.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 created = 2;
 * @return {number}
 */ proto.subscription.ProgramCreated.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.ProgramCreated} returns this
 */ proto.subscription.ProgramCreated.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string name = 3;
 * @return {string}
 */ proto.subscription.ProgramCreated.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ProgramCreated} returns this
 */ proto.subscription.ProgramCreated.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string description = 4;
 * @return {string}
 */ proto.subscription.ProgramCreated.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ProgramCreated} returns this
 */ proto.subscription.ProgramCreated.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.PricingOptionCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.PricingOptionCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.PricingOptionCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.PricingOptionCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            monthly: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.PricingOptionCreated}
 */ proto.subscription.PricingOptionCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.PricingOptionCreated;
    return proto.subscription.PricingOptionCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.PricingOptionCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.PricingOptionCreated}
 */ proto.subscription.PricingOptionCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthly(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.PricingOptionCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.PricingOptionCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.PricingOptionCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.PricingOptionCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getMonthly();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.PricingOptionCreated.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.PricingOptionCreated} returns this
 */ proto.subscription.PricingOptionCreated.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 start_fee = 2;
 * @return {number}
 */ proto.subscription.PricingOptionCreated.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.PricingOptionCreated} returns this
 */ proto.subscription.PricingOptionCreated.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 monthly = 3;
 * @return {number}
 */ proto.subscription.PricingOptionCreated.prototype.getMonthly = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.PricingOptionCreated} returns this
 */ proto.subscription.PricingOptionCreated.prototype.setMonthly = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 deposit = 4;
 * @return {number}
 */ proto.subscription.PricingOptionCreated.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.PricingOptionCreated} returns this
 */ proto.subscription.PricingOptionCreated.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ColorOptionCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ColorOptionCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ColorOptionCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ColorOptionCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            colorName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            colorValue: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ColorOptionCreated}
 */ proto.subscription.ColorOptionCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ColorOptionCreated;
    return proto.subscription.ColorOptionCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ColorOptionCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ColorOptionCreated}
 */ proto.subscription.ColorOptionCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setColorName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setColorValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ColorOptionCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ColorOptionCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ColorOptionCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ColorOptionCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getColorName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getColorValue();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.ColorOptionCreated.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ColorOptionCreated} returns this
 */ proto.subscription.ColorOptionCreated.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string color_name = 2;
 * @return {string}
 */ proto.subscription.ColorOptionCreated.prototype.getColorName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ColorOptionCreated} returns this
 */ proto.subscription.ColorOptionCreated.prototype.setColorName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string color_value = 3;
 * @return {string}
 */ proto.subscription.ColorOptionCreated.prototype.getColorValue = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ColorOptionCreated} returns this
 */ proto.subscription.ColorOptionCreated.prototype.setColorValue = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.subscription.ReservationCreated.oneofGroups_ = [
    [
        7,
        9
    ]
];
/**
 * @enum {number}
 */ proto.subscription.ReservationCreated.ProgramOptionsCase = {
    PROGRAM_OPTIONS_NOT_SET: 0,
    MODEL_3: 7,
    MODEL_Y: 9
};
/**
 * @return {proto.subscription.ReservationCreated.ProgramOptionsCase}
 */ proto.subscription.ReservationCreated.prototype.getProgramOptionsCase = function() {
    return /** @type {proto.subscription.ReservationCreated.ProgramOptionsCase} */ $8M67s.Message.computeOneofCase(this, proto.subscription.ReservationCreated.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ReservationCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ReservationCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ReservationCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ReservationCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            reservationNumber: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            model3: (f = msg.getModel3()) && proto.subscription.TeslaModel3Options.toObject(includeInstance, f),
            modelY: (f = msg.getModelY()) && proto.subscription.TeslaModelYOptions.toObject(includeInstance, f),
            trackingId: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            initialProgramId: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            initialPriceOptionId: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            zipCode: $8M67s.Message.getFieldWithDefault(msg, 12, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ReservationCreated}
 */ proto.subscription.ReservationCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ReservationCreated;
    return proto.subscription.ReservationCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ReservationCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ReservationCreated}
 */ proto.subscription.ReservationCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationNumber(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 7:
                var value = new proto.subscription.TeslaModel3Options;
                reader.readMessage(value, proto.subscription.TeslaModel3Options.deserializeBinaryFromReader);
                msg.setModel3(value);
                break;
            case 9:
                var value = new proto.subscription.TeslaModelYOptions;
                reader.readMessage(value, proto.subscription.TeslaModelYOptions.deserializeBinaryFromReader);
                msg.setModelY(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingId(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setInitialProgramId(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setInitialPriceOptionId(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setZipCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ReservationCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ReservationCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ReservationCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ReservationCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getReservationNumber();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(6, f);
    f = message.getModel3();
    if (f != null) writer.writeMessage(7, f, proto.subscription.TeslaModel3Options.serializeBinaryToWriter);
    f = message.getModelY();
    if (f != null) writer.writeMessage(9, f, proto.subscription.TeslaModelYOptions.serializeBinaryToWriter);
    f = message.getTrackingId();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getInitialProgramId();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getInitialPriceOptionId();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getZipCode();
    if (f.length > 0) writer.writeString(12, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string program_id = 3;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string subscription_id = 4;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string reservation_number = 5;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getReservationNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setReservationNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int64 created = 6;
 * @return {number}
 */ proto.subscription.ReservationCreated.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional TeslaModel3Options model_3 = 7;
 * @return {?proto.subscription.TeslaModel3Options}
 */ proto.subscription.ReservationCreated.prototype.getModel3 = function() {
    return /** @type{?proto.subscription.TeslaModel3Options} */ $8M67s.Message.getWrapperField(this, proto.subscription.TeslaModel3Options, 7);
};
/**
 * @param {?proto.subscription.TeslaModel3Options|undefined} value
 * @return {!proto.subscription.ReservationCreated} returns this
*/ proto.subscription.ReservationCreated.prototype.setModel3 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 7, proto.subscription.ReservationCreated.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.clearModel3 = function() {
    return this.setModel3(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription.ReservationCreated.prototype.hasModel3 = function() {
    return $8M67s.Message.getField(this, 7) != null;
};
/**
 * optional TeslaModelYOptions model_y = 9;
 * @return {?proto.subscription.TeslaModelYOptions}
 */ proto.subscription.ReservationCreated.prototype.getModelY = function() {
    return /** @type{?proto.subscription.TeslaModelYOptions} */ $8M67s.Message.getWrapperField(this, proto.subscription.TeslaModelYOptions, 9);
};
/**
 * @param {?proto.subscription.TeslaModelYOptions|undefined} value
 * @return {!proto.subscription.ReservationCreated} returns this
*/ proto.subscription.ReservationCreated.prototype.setModelY = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 9, proto.subscription.ReservationCreated.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.clearModelY = function() {
    return this.setModelY(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription.ReservationCreated.prototype.hasModelY = function() {
    return $8M67s.Message.getField(this, 9) != null;
};
/**
 * optional string tracking_id = 8;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getTrackingId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setTrackingId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string initial_program_id = 10;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getInitialProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setInitialProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string initial_price_option_id = 11;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getInitialPriceOptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setInitialPriceOptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string zip_code = 12;
 * @return {string}
 */ proto.subscription.ReservationCreated.prototype.getZipCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCreated} returns this
 */ proto.subscription.ReservationCreated.prototype.setZipCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ReservationStatusUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ReservationStatusUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ReservationStatusUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ReservationStatusUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            newStatus: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ReservationStatusUpdated}
 */ proto.subscription.ReservationStatusUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ReservationStatusUpdated;
    return proto.subscription.ReservationStatusUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ReservationStatusUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ReservationStatusUpdated}
 */ proto.subscription.ReservationStatusUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {!proto.subscription.ReservationStatus} */ reader.readEnum();
                msg.setNewStatus(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ReservationStatusUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ReservationStatusUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ReservationStatusUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ReservationStatusUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getNewStatus();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.ReservationStatusUpdated.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationStatusUpdated} returns this
 */ proto.subscription.ReservationStatusUpdated.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.subscription.ReservationStatusUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationStatusUpdated} returns this
 */ proto.subscription.ReservationStatusUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional ReservationStatus new_status = 3;
 * @return {!proto.subscription.ReservationStatus}
 */ proto.subscription.ReservationStatusUpdated.prototype.getNewStatus = function() {
    return /** @type {!proto.subscription.ReservationStatus} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.subscription.ReservationStatus} value
 * @return {!proto.subscription.ReservationStatusUpdated} returns this
 */ proto.subscription.ReservationStatusUpdated.prototype.setNewStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string subscription_id = 4;
 * @return {string}
 */ proto.subscription.ReservationStatusUpdated.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationStatusUpdated} returns this
 */ proto.subscription.ReservationStatusUpdated.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string vehicle_id = 5;
 * @return {string}
 */ proto.subscription.ReservationStatusUpdated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationStatusUpdated} returns this
 */ proto.subscription.ReservationStatusUpdated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.PendingSubscriptionInitialized.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.PendingSubscriptionInitialized.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.PendingSubscriptionInitialized} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.PendingSubscriptionInitialized.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.PendingSubscriptionInitialized}
 */ proto.subscription.PendingSubscriptionInitialized.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.PendingSubscriptionInitialized;
    return proto.subscription.PendingSubscriptionInitialized.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.PendingSubscriptionInitialized} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.PendingSubscriptionInitialized}
 */ proto.subscription.PendingSubscriptionInitialized.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.PendingSubscriptionInitialized.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.PendingSubscriptionInitialized.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.PendingSubscriptionInitialized} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.PendingSubscriptionInitialized.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.subscription.PendingSubscriptionInitialized.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.PendingSubscriptionInitialized} returns this
 */ proto.subscription.PendingSubscriptionInitialized.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.subscription.PendingSubscriptionInitialized.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.PendingSubscriptionInitialized} returns this
 */ proto.subscription.PendingSubscriptionInitialized.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.subscription.PendingSubscriptionInitialized.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.PendingSubscriptionInitialized} returns this
 */ proto.subscription.PendingSubscriptionInitialized.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.subscription.ReservationCancelled.repeatedFields_ = [
    8
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ReservationCancelled.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ReservationCancelled.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ReservationCancelled} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ReservationCancelled.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            user: (f = msg.getUser()) && $3QqPt.AutonomyUser.toObject(includeInstance, f),
            actionReason: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            transactionsList: $8M67s.Message.toObjectList(msg.getTransactionsList(), $3QqPt.Transaction.toObject, includeInstance),
            refundAmount: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            notes: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ReservationCancelled}
 */ proto.subscription.ReservationCancelled.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ReservationCancelled;
    return proto.subscription.ReservationCancelled.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ReservationCancelled} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ReservationCancelled}
 */ proto.subscription.ReservationCancelled.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = new $3QqPt.AutonomyUser;
                reader.readMessage(value, $3QqPt.AutonomyUser.deserializeBinaryFromReader);
                msg.setUser(value);
                break;
            case 5:
                var value = /** @type {!proto.subscription.SubscriptionAction.ActionReason} */ reader.readEnum();
                msg.setActionReason(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            case 8:
                var value = new $3QqPt.Transaction;
                reader.readMessage(value, $3QqPt.Transaction.deserializeBinaryFromReader);
                msg.addTransactions(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRefundAmount(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setNotes(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ReservationCancelled.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ReservationCancelled.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ReservationCancelled} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ReservationCancelled.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getUser();
    if (f != null) writer.writeMessage(4, f, $3QqPt.AutonomyUser.serializeBinaryToWriter);
    f = message.getActionReason();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getTransactionsList();
    if (f.length > 0) writer.writeRepeatedMessage(8, f, $3QqPt.Transaction.serializeBinaryToWriter);
    f = message.getRefundAmount();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getNotes();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional string reservation_id = 1;
 * @return {string}
 */ proto.subscription.ReservationCancelled.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.subscription.ReservationCancelled.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.subscription.ReservationCancelled.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional domain.AutonomyUser user = 4;
 * @return {?proto.domain.AutonomyUser}
 */ proto.subscription.ReservationCancelled.prototype.getUser = function() {
    return /** @type{?proto.domain.AutonomyUser} */ $8M67s.Message.getWrapperField(this, $3QqPt.AutonomyUser, 4);
};
/**
 * @param {?proto.domain.AutonomyUser|undefined} value
 * @return {!proto.subscription.ReservationCancelled} returns this
*/ proto.subscription.ReservationCancelled.prototype.setUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.clearUser = function() {
    return this.setUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription.ReservationCancelled.prototype.hasUser = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional SubscriptionAction.ActionReason action_reason = 5;
 * @return {!proto.subscription.SubscriptionAction.ActionReason}
 */ proto.subscription.ReservationCancelled.prototype.getActionReason = function() {
    return /** @type {!proto.subscription.SubscriptionAction.ActionReason} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.subscription.SubscriptionAction.ActionReason} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setActionReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional string account_number = 6;
 * @return {string}
 */ proto.subscription.ReservationCancelled.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string invoice_number = 7;
 * @return {string}
 */ proto.subscription.ReservationCancelled.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * repeated domain.Transaction transactions = 8;
 * @return {!Array<!proto.domain.Transaction>}
 */ proto.subscription.ReservationCancelled.prototype.getTransactionsList = function() {
    return /** @type{!Array<!proto.domain.Transaction>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Transaction, 8);
};
/**
 * @param {!Array<!proto.domain.Transaction>} value
 * @return {!proto.subscription.ReservationCancelled} returns this
*/ proto.subscription.ReservationCancelled.prototype.setTransactionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.domain.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Transaction}
 */ proto.subscription.ReservationCancelled.prototype.addTransactions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.domain.Transaction, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.clearTransactionsList = function() {
    return this.setTransactionsList([]);
};
/**
 * optional int32 refund_amount = 9;
 * @return {number}
 */ proto.subscription.ReservationCancelled.prototype.getRefundAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setRefundAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional string notes = 10;
 * @return {string}
 */ proto.subscription.ReservationCancelled.prototype.getNotes = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setNotes = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string vehicle_id = 11;
 * @return {string}
 */ proto.subscription.ReservationCancelled.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationCancelled} returns this
 */ proto.subscription.ReservationCancelled.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.SubscriptionAction.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.SubscriptionAction.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.SubscriptionAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.SubscriptionAction.toObject = function(includeInstance, msg) {
        var f, obj = {
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            userId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            userEmail: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            userType: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            actionType: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            actionReason: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            notes: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.SubscriptionAction}
 */ proto.subscription.SubscriptionAction.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.SubscriptionAction;
    return proto.subscription.SubscriptionAction.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.SubscriptionAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.SubscriptionAction}
 */ proto.subscription.SubscriptionAction.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setUserEmail(value);
                break;
            case 4:
                var value = /** @type {!proto.subscription.SubscriptionAction.UserType} */ reader.readEnum();
                msg.setUserType(value);
                break;
            case 5:
                var value = /** @type {!proto.subscription.SubscriptionAction.ActionType} */ reader.readEnum();
                msg.setActionType(value);
                break;
            case 6:
                var value = /** @type {!proto.subscription.SubscriptionAction.ActionReason} */ reader.readEnum();
                msg.setActionReason(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setNotes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.SubscriptionAction.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.SubscriptionAction.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.SubscriptionAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.SubscriptionAction.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(1, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUserEmail();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getUserType();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getActionType();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getActionReason();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getNotes();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * @enum {number}
 */ proto.subscription.SubscriptionAction.UserType = {
    CUSTOMER: 0,
    DEALER: 1
};
/**
 * @enum {number}
 */ proto.subscription.SubscriptionAction.ActionType = {
    CREATE: 0,
    UPDATE: 1,
    CANCEL: 2
};
/**
 * @enum {number}
 */ proto.subscription.SubscriptionAction.ActionReason = {
    DEALER_VEHICLE_NOT_AVAILABLE: 0,
    DEALER_VEHICLE_SELLING_PRICE_REJECTED: 1,
    DEALER_VEHICLE_SOLD: 2,
    CUSTOMER_VEHICLE_TOO_EXPENSIVE: 3,
    CUSTOMER_VEHICLE_DRIVE_NOT_AS_EXPECTED: 4,
    LINE_ITEM_ADDED: 5,
    TRANSACTION_ADDED: 6,
    STATEMENT_ADDED: 7,
    VEHICLE_PICKUP: 8,
    SUBSCRIPTION_ACTIVATED: 9,
    CONTRACT_SIGNED: 10,
    PAYMENT_METHOD_ADDED: 11,
    ANDROID_OS_UNSUPPORTED: 12,
    CUSTOMER_VEHICLE_DOES_NOT_WANT_VEHICLE: 13
};
/**
 * optional int64 timestamp = 1;
 * @return {number}
 */ proto.subscription.SubscriptionAction.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.SubscriptionAction} returns this
 */ proto.subscription.SubscriptionAction.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string user_id = 2;
 * @return {string}
 */ proto.subscription.SubscriptionAction.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.SubscriptionAction} returns this
 */ proto.subscription.SubscriptionAction.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string user_email = 3;
 * @return {string}
 */ proto.subscription.SubscriptionAction.prototype.getUserEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.SubscriptionAction} returns this
 */ proto.subscription.SubscriptionAction.prototype.setUserEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional UserType user_type = 4;
 * @return {!proto.subscription.SubscriptionAction.UserType}
 */ proto.subscription.SubscriptionAction.prototype.getUserType = function() {
    return /** @type {!proto.subscription.SubscriptionAction.UserType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.subscription.SubscriptionAction.UserType} value
 * @return {!proto.subscription.SubscriptionAction} returns this
 */ proto.subscription.SubscriptionAction.prototype.setUserType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional ActionType action_type = 5;
 * @return {!proto.subscription.SubscriptionAction.ActionType}
 */ proto.subscription.SubscriptionAction.prototype.getActionType = function() {
    return /** @type {!proto.subscription.SubscriptionAction.ActionType} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.subscription.SubscriptionAction.ActionType} value
 * @return {!proto.subscription.SubscriptionAction} returns this
 */ proto.subscription.SubscriptionAction.prototype.setActionType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional ActionReason action_reason = 6;
 * @return {!proto.subscription.SubscriptionAction.ActionReason}
 */ proto.subscription.SubscriptionAction.prototype.getActionReason = function() {
    return /** @type {!proto.subscription.SubscriptionAction.ActionReason} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.subscription.SubscriptionAction.ActionReason} value
 * @return {!proto.subscription.SubscriptionAction} returns this
 */ proto.subscription.SubscriptionAction.prototype.setActionReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional string notes = 7;
 * @return {string}
 */ proto.subscription.SubscriptionAction.prototype.getNotes = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.SubscriptionAction} returns this
 */ proto.subscription.SubscriptionAction.prototype.setNotes = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.subscription.ReservationOptionsUpdated.oneofGroups_ = [
    [
        4,
        6
    ]
];
/**
 * @enum {number}
 */ proto.subscription.ReservationOptionsUpdated.ProgramOptionsCase = {
    PROGRAM_OPTIONS_NOT_SET: 0,
    MODEL_3: 4,
    MODEL_Y: 6
};
/**
 * @return {proto.subscription.ReservationOptionsUpdated.ProgramOptionsCase}
 */ proto.subscription.ReservationOptionsUpdated.prototype.getProgramOptionsCase = function() {
    return /** @type {proto.subscription.ReservationOptionsUpdated.ProgramOptionsCase} */ $8M67s.Message.computeOneofCase(this, proto.subscription.ReservationOptionsUpdated.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ReservationOptionsUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ReservationOptionsUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ReservationOptionsUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ReservationOptionsUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            trackingId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            updated: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            model3: (f = msg.getModel3()) && proto.subscription.TeslaModel3Options.toObject(includeInstance, f),
            modelY: (f = msg.getModelY()) && proto.subscription.TeslaModelYOptions.toObject(includeInstance, f),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ReservationOptionsUpdated}
 */ proto.subscription.ReservationOptionsUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ReservationOptionsUpdated;
    return proto.subscription.ReservationOptionsUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ReservationOptionsUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ReservationOptionsUpdated}
 */ proto.subscription.ReservationOptionsUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setUpdated(value);
                break;
            case 4:
                var value = new proto.subscription.TeslaModel3Options;
                reader.readMessage(value, proto.subscription.TeslaModel3Options.deserializeBinaryFromReader);
                msg.setModel3(value);
                break;
            case 6:
                var value = new proto.subscription.TeslaModelYOptions;
                reader.readMessage(value, proto.subscription.TeslaModelYOptions.deserializeBinaryFromReader);
                msg.setModelY(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ReservationOptionsUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ReservationOptionsUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ReservationOptionsUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ReservationOptionsUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTrackingId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUpdated();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getModel3();
    if (f != null) writer.writeMessage(4, f, proto.subscription.TeslaModel3Options.serializeBinaryToWriter);
    f = message.getModelY();
    if (f != null) writer.writeMessage(6, f, proto.subscription.TeslaModelYOptions.serializeBinaryToWriter);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription.ReservationOptionsUpdated.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
 */ proto.subscription.ReservationOptionsUpdated.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string tracking_id = 2;
 * @return {string}
 */ proto.subscription.ReservationOptionsUpdated.prototype.getTrackingId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
 */ proto.subscription.ReservationOptionsUpdated.prototype.setTrackingId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 updated = 3;
 * @return {number}
 */ proto.subscription.ReservationOptionsUpdated.prototype.getUpdated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
 */ proto.subscription.ReservationOptionsUpdated.prototype.setUpdated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional TeslaModel3Options model_3 = 4;
 * @return {?proto.subscription.TeslaModel3Options}
 */ proto.subscription.ReservationOptionsUpdated.prototype.getModel3 = function() {
    return /** @type{?proto.subscription.TeslaModel3Options} */ $8M67s.Message.getWrapperField(this, proto.subscription.TeslaModel3Options, 4);
};
/**
 * @param {?proto.subscription.TeslaModel3Options|undefined} value
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
*/ proto.subscription.ReservationOptionsUpdated.prototype.setModel3 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 4, proto.subscription.ReservationOptionsUpdated.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
 */ proto.subscription.ReservationOptionsUpdated.prototype.clearModel3 = function() {
    return this.setModel3(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription.ReservationOptionsUpdated.prototype.hasModel3 = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional TeslaModelYOptions model_y = 6;
 * @return {?proto.subscription.TeslaModelYOptions}
 */ proto.subscription.ReservationOptionsUpdated.prototype.getModelY = function() {
    return /** @type{?proto.subscription.TeslaModelYOptions} */ $8M67s.Message.getWrapperField(this, proto.subscription.TeslaModelYOptions, 6);
};
/**
 * @param {?proto.subscription.TeslaModelYOptions|undefined} value
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
*/ proto.subscription.ReservationOptionsUpdated.prototype.setModelY = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 6, proto.subscription.ReservationOptionsUpdated.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
 */ proto.subscription.ReservationOptionsUpdated.prototype.clearModelY = function() {
    return this.setModelY(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription.ReservationOptionsUpdated.prototype.hasModelY = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional string customer_id = 5;
 * @return {string}
 */ proto.subscription.ReservationOptionsUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
 */ proto.subscription.ReservationOptionsUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string program_id = 7;
 * @return {string}
 */ proto.subscription.ReservationOptionsUpdated.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ReservationOptionsUpdated} returns this
 */ proto.subscription.ReservationOptionsUpdated.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ProcessDueStatements.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ProcessDueStatements.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ProcessDueStatements} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ProcessDueStatements.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ProcessDueStatements}
 */ proto.subscription.ProcessDueStatements.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ProcessDueStatements;
    return proto.subscription.ProcessDueStatements.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ProcessDueStatements} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ProcessDueStatements}
 */ proto.subscription.ProcessDueStatements.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ProcessDueStatements.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ProcessDueStatements.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ProcessDueStatements} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ProcessDueStatements.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.StatementDue.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.StatementDue.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.StatementDue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.StatementDue.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            statement: (f = msg.getStatement()) && $3QqPt.Statement.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.StatementDue}
 */ proto.subscription.StatementDue.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.StatementDue;
    return proto.subscription.StatementDue.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.StatementDue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.StatementDue}
 */ proto.subscription.StatementDue.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new $3QqPt.Statement;
                reader.readMessage(value, $3QqPt.Statement.deserializeBinaryFromReader);
                msg.setStatement(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.StatementDue.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.StatementDue.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.StatementDue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.StatementDue.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStatement();
    if (f != null) writer.writeMessage(3, f, $3QqPt.Statement.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription.StatementDue.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.StatementDue} returns this
 */ proto.subscription.StatementDue.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.subscription.StatementDue.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.StatementDue} returns this
 */ proto.subscription.StatementDue.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional domain.Statement statement = 3;
 * @return {?proto.domain.Statement}
 */ proto.subscription.StatementDue.prototype.getStatement = function() {
    return /** @type{?proto.domain.Statement} */ $8M67s.Message.getWrapperField(this, $3QqPt.Statement, 3);
};
/**
 * @param {?proto.domain.Statement|undefined} value
 * @return {!proto.subscription.StatementDue} returns this
*/ proto.subscription.StatementDue.prototype.setStatement = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription.StatementDue} returns this
 */ proto.subscription.StatementDue.prototype.clearStatement = function() {
    return this.setStatement(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription.StatementDue.prototype.hasStatement = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.VehicleAssigned.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.VehicleAssigned.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.VehicleAssigned} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.VehicleAssigned.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.VehicleAssigned}
 */ proto.subscription.VehicleAssigned.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.VehicleAssigned;
    return proto.subscription.VehicleAssigned.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.VehicleAssigned} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.VehicleAssigned}
 */ proto.subscription.VehicleAssigned.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.VehicleAssigned.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.VehicleAssigned.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.VehicleAssigned} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.VehicleAssigned.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.subscription.VehicleAssigned.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehicleAssigned} returns this
 */ proto.subscription.VehicleAssigned.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.subscription.VehicleAssigned.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehicleAssigned} returns this
 */ proto.subscription.VehicleAssigned.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.SubscriptionActivated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.SubscriptionActivated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.SubscriptionActivated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.SubscriptionActivated.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.SubscriptionActivated}
 */ proto.subscription.SubscriptionActivated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.SubscriptionActivated;
    return proto.subscription.SubscriptionActivated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.SubscriptionActivated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.SubscriptionActivated}
 */ proto.subscription.SubscriptionActivated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.SubscriptionActivated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.SubscriptionActivated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.SubscriptionActivated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.SubscriptionActivated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.subscription.SubscriptionActivated.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.SubscriptionActivated} returns this
 */ proto.subscription.SubscriptionActivated.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.subscription.SubscriptionActivated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.SubscriptionActivated} returns this
 */ proto.subscription.SubscriptionActivated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.subscription.SubscriptionActivated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.SubscriptionActivated} returns this
 */ proto.subscription.SubscriptionActivated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.SubscriptionUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.SubscriptionUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.SubscriptionUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.SubscriptionUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            reason: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.SubscriptionUpdated}
 */ proto.subscription.SubscriptionUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.SubscriptionUpdated;
    return proto.subscription.SubscriptionUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.SubscriptionUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.SubscriptionUpdated}
 */ proto.subscription.SubscriptionUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.Subscription.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 4:
                var value = /** @type {!proto.subscription.SubscriptionUpdated.Reason} */ reader.readEnum();
                msg.setReason(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.SubscriptionUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.SubscriptionUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.SubscriptionUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.SubscriptionUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getReason();
    if (f !== 0.0) writer.writeEnum(4, f);
};
/**
 * @enum {number}
 */ proto.subscription.SubscriptionUpdated.Reason = {
    UNKNOWN: 0,
    RETURNED: 1,
    SWAPPED: 2
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription.SubscriptionUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.SubscriptionUpdated} returns this
 */ proto.subscription.SubscriptionUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.subscription.SubscriptionUpdated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.SubscriptionUpdated} returns this
 */ proto.subscription.SubscriptionUpdated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional domain.Subscription.Status status = 3;
 * @return {!proto.domain.Subscription.Status}
 */ proto.subscription.SubscriptionUpdated.prototype.getStatus = function() {
    return /** @type {!proto.domain.Subscription.Status} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.Subscription.Status} value
 * @return {!proto.subscription.SubscriptionUpdated} returns this
 */ proto.subscription.SubscriptionUpdated.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional Reason reason = 4;
 * @return {!proto.subscription.SubscriptionUpdated.Reason}
 */ proto.subscription.SubscriptionUpdated.prototype.getReason = function() {
    return /** @type {!proto.subscription.SubscriptionUpdated.Reason} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.subscription.SubscriptionUpdated.Reason} value
 * @return {!proto.subscription.SubscriptionUpdated} returns this
 */ proto.subscription.SubscriptionUpdated.prototype.setReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.subscription.ProgramPricingOptionsUpdated.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ProgramPricingOptionsUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ProgramPricingOptionsUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ProgramPricingOptionsUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ProgramPricingOptionsUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            programId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            pricingOptionsList: $8M67s.Message.toObjectList(msg.getPricingOptionsList(), proto.subscription.PricingOption.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ProgramPricingOptionsUpdated}
 */ proto.subscription.ProgramPricingOptionsUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ProgramPricingOptionsUpdated;
    return proto.subscription.ProgramPricingOptionsUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ProgramPricingOptionsUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ProgramPricingOptionsUpdated}
 */ proto.subscription.ProgramPricingOptionsUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 2:
                var value = new proto.subscription.PricingOption;
                reader.readMessage(value, proto.subscription.PricingOption.deserializeBinaryFromReader);
                msg.addPricingOptions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ProgramPricingOptionsUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ProgramPricingOptionsUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ProgramPricingOptionsUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ProgramPricingOptionsUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPricingOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.subscription.PricingOption.serializeBinaryToWriter);
};
/**
 * optional string program_id = 1;
 * @return {string}
 */ proto.subscription.ProgramPricingOptionsUpdated.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ProgramPricingOptionsUpdated} returns this
 */ proto.subscription.ProgramPricingOptionsUpdated.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated PricingOption pricing_options = 2;
 * @return {!Array<!proto.subscription.PricingOption>}
 */ proto.subscription.ProgramPricingOptionsUpdated.prototype.getPricingOptionsList = function() {
    return /** @type{!Array<!proto.subscription.PricingOption>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.subscription.PricingOption, 2);
};
/**
 * @param {!Array<!proto.subscription.PricingOption>} value
 * @return {!proto.subscription.ProgramPricingOptionsUpdated} returns this
*/ proto.subscription.ProgramPricingOptionsUpdated.prototype.setPricingOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.subscription.PricingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.subscription.PricingOption}
 */ proto.subscription.ProgramPricingOptionsUpdated.prototype.addPricingOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.subscription.PricingOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.subscription.ProgramPricingOptionsUpdated} returns this
 */ proto.subscription.ProgramPricingOptionsUpdated.prototype.clearPricingOptionsList = function() {
    return this.setPricingOptionsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.ContractProperties.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.ContractProperties.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.ContractProperties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ContractProperties.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            odometer: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            paint: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            agreementDate: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            customerAccountNumber: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            customerName: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            billingAddress: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            subscriptionBaseMonthly: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            insuranceMonthly: $8M67s.Message.getFieldWithDefault(msg, 15, ""),
            insuranceMonthlyTax: $8M67s.Message.getFieldWithDefault(msg, 16, ""),
            subscriptionTax: $8M67s.Message.getFieldWithDefault(msg, 17, ""),
            subscriptionTotalMonthly: $8M67s.Message.getFieldWithDefault(msg, 18, ""),
            subscriptionTotalMonthlyTax: $8M67s.Message.getFieldWithDefault(msg, 19, ""),
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 20, ""),
            promoCodeAmount: $8M67s.Message.getFieldWithDefault(msg, 21, ""),
            billedMonthlyStartingOn: $8M67s.Message.getFieldWithDefault(msg, 22, ""),
            subscriptionExcessMileageRate: $8M67s.Message.getFieldWithDefault(msg, 23, ""),
            insuranceExcessMileageRate: $8M67s.Message.getFieldWithDefault(msg, 24, ""),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 25, ""),
            subscriptionRefundableDeposit: $8M67s.Message.getFieldWithDefault(msg, 26, ""),
            securityDepositPaidLastFourStatement: $8M67s.Message.getFieldWithDefault(msg, 27, ""),
            subscriptionStartPayment: $8M67s.Message.getFieldWithDefault(msg, 28, ""),
            subscriptionStartPaymentTax: $8M67s.Message.getFieldWithDefault(msg, 29, ""),
            driveOffSummary: $8M67s.Message.getFieldWithDefault(msg, 30, ""),
            driveOffTotalTax: $8M67s.Message.getFieldWithDefault(msg, 31, ""),
            subscriptionTotalDueToStart: $8M67s.Message.getFieldWithDefault(msg, 32, ""),
            firstMonthSubscriptionTax: $8M67s.Message.getFieldWithDefault(msg, 33, ""),
            firstMonthSubscriptionTotal: $8M67s.Message.getFieldWithDefault(msg, 34, ""),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 35, ""),
            wheelAndTireMonthly: $8M67s.Message.getFieldWithDefault(msg, 36, ""),
            wheelAndTireMonthlyTax: $8M67s.Message.getFieldWithDefault(msg, 37, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.ContractProperties}
 */ proto.subscription.ContractProperties.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.ContractProperties;
    return proto.subscription.ContractProperties.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.ContractProperties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.ContractProperties}
 */ proto.subscription.ContractProperties.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setOdometer(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setPaint(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setAgreementDate(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerAccountNumber(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerName(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setBillingAddress(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionBaseMonthly(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceMonthly(value);
                break;
            case 16:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceMonthlyTax(value);
                break;
            case 17:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionTax(value);
                break;
            case 18:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionTotalMonthly(value);
                break;
            case 19:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionTotalMonthlyTax(value);
                break;
            case 20:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 21:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCodeAmount(value);
                break;
            case 22:
                var value = /** @type {string} */ reader.readString();
                msg.setBilledMonthlyStartingOn(value);
                break;
            case 23:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionExcessMileageRate(value);
                break;
            case 24:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceExcessMileageRate(value);
                break;
            case 25:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationFee(value);
                break;
            case 26:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionRefundableDeposit(value);
                break;
            case 27:
                var value = /** @type {string} */ reader.readString();
                msg.setSecurityDepositPaidLastFourStatement(value);
                break;
            case 28:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionStartPayment(value);
                break;
            case 29:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionStartPaymentTax(value);
                break;
            case 30:
                var value = /** @type {string} */ reader.readString();
                msg.setDriveOffSummary(value);
                break;
            case 31:
                var value = /** @type {string} */ reader.readString();
                msg.setDriveOffTotalTax(value);
                break;
            case 32:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionTotalDueToStart(value);
                break;
            case 33:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstMonthSubscriptionTax(value);
                break;
            case 34:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstMonthSubscriptionTotal(value);
                break;
            case 35:
                var value = /** @type {string} */ reader.readString();
                msg.setPriceTermMonths(value);
                break;
            case 36:
                var value = /** @type {string} */ reader.readString();
                msg.setWheelAndTireMonthly(value);
                break;
            case 37:
                var value = /** @type {string} */ reader.readString();
                msg.setWheelAndTireMonthlyTax(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.ContractProperties.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.ContractProperties.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.ContractProperties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.ContractProperties.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getOdometer();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getPaint();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getAgreementDate();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getCustomerAccountNumber();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getCustomerName();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getBillingAddress();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getSubscriptionBaseMonthly();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getInsuranceMonthly();
    if (f.length > 0) writer.writeString(15, f);
    f = message.getInsuranceMonthlyTax();
    if (f.length > 0) writer.writeString(16, f);
    f = message.getSubscriptionTax();
    if (f.length > 0) writer.writeString(17, f);
    f = message.getSubscriptionTotalMonthly();
    if (f.length > 0) writer.writeString(18, f);
    f = message.getSubscriptionTotalMonthlyTax();
    if (f.length > 0) writer.writeString(19, f);
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(20, f);
    f = message.getPromoCodeAmount();
    if (f.length > 0) writer.writeString(21, f);
    f = message.getBilledMonthlyStartingOn();
    if (f.length > 0) writer.writeString(22, f);
    f = message.getSubscriptionExcessMileageRate();
    if (f.length > 0) writer.writeString(23, f);
    f = message.getInsuranceExcessMileageRate();
    if (f.length > 0) writer.writeString(24, f);
    f = message.getReservationFee();
    if (f.length > 0) writer.writeString(25, f);
    f = message.getSubscriptionRefundableDeposit();
    if (f.length > 0) writer.writeString(26, f);
    f = message.getSecurityDepositPaidLastFourStatement();
    if (f.length > 0) writer.writeString(27, f);
    f = message.getSubscriptionStartPayment();
    if (f.length > 0) writer.writeString(28, f);
    f = message.getSubscriptionStartPaymentTax();
    if (f.length > 0) writer.writeString(29, f);
    f = message.getDriveOffSummary();
    if (f.length > 0) writer.writeString(30, f);
    f = message.getDriveOffTotalTax();
    if (f.length > 0) writer.writeString(31, f);
    f = message.getSubscriptionTotalDueToStart();
    if (f.length > 0) writer.writeString(32, f);
    f = message.getFirstMonthSubscriptionTax();
    if (f.length > 0) writer.writeString(33, f);
    f = message.getFirstMonthSubscriptionTotal();
    if (f.length > 0) writer.writeString(34, f);
    f = message.getPriceTermMonths();
    if (f.length > 0) writer.writeString(35, f);
    f = message.getWheelAndTireMonthly();
    if (f.length > 0) writer.writeString(36, f);
    f = message.getWheelAndTireMonthlyTax();
    if (f.length > 0) writer.writeString(37, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vin = 3;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string odometer = 4;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getOdometer = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setOdometer = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string year = 5;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string model = 6;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string trim = 7;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string make = 8;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string paint = 9;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getPaint = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setPaint = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string agreement_date = 10;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getAgreementDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setAgreementDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string customer_account_number = 11;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getCustomerAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setCustomerAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string customer_name = 12;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getCustomerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setCustomerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string billing_address = 13;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getBillingAddress = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setBillingAddress = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string subscription_base_monthly = 14;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionBaseMonthly = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionBaseMonthly = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional string insurance_monthly = 15;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getInsuranceMonthly = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setInsuranceMonthly = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
/**
 * optional string insurance_monthly_tax = 16;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getInsuranceMonthlyTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 16, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setInsuranceMonthlyTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 16, value);
};
/**
 * optional string subscription_tax = 17;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 17, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 17, value);
};
/**
 * optional string subscription_total_monthly = 18;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionTotalMonthly = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 18, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionTotalMonthly = function(value) {
    return $8M67s.Message.setProto3StringField(this, 18, value);
};
/**
 * optional string subscription_total_monthly_tax = 19;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionTotalMonthlyTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 19, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionTotalMonthlyTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 19, value);
};
/**
 * optional string promo_code = 20;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 20, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 20, value);
};
/**
 * optional string promo_code_amount = 21;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getPromoCodeAmount = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 21, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setPromoCodeAmount = function(value) {
    return $8M67s.Message.setProto3StringField(this, 21, value);
};
/**
 * optional string billed_monthly_starting_on = 22;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getBilledMonthlyStartingOn = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 22, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setBilledMonthlyStartingOn = function(value) {
    return $8M67s.Message.setProto3StringField(this, 22, value);
};
/**
 * optional string subscription_excess_mileage_rate = 23;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionExcessMileageRate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 23, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionExcessMileageRate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 23, value);
};
/**
 * optional string insurance_excess_mileage_rate = 24;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getInsuranceExcessMileageRate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 24, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setInsuranceExcessMileageRate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 24, value);
};
/**
 * optional string reservation_fee = 25;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getReservationFee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 25, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 25, value);
};
/**
 * optional string subscription_refundable_deposit = 26;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionRefundableDeposit = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 26, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionRefundableDeposit = function(value) {
    return $8M67s.Message.setProto3StringField(this, 26, value);
};
/**
 * optional string security_deposit_paid_last_four_statement = 27;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSecurityDepositPaidLastFourStatement = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 27, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSecurityDepositPaidLastFourStatement = function(value) {
    return $8M67s.Message.setProto3StringField(this, 27, value);
};
/**
 * optional string subscription_start_payment = 28;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionStartPayment = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 28, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionStartPayment = function(value) {
    return $8M67s.Message.setProto3StringField(this, 28, value);
};
/**
 * optional string subscription_start_payment_tax = 29;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionStartPaymentTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 29, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionStartPaymentTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 29, value);
};
/**
 * optional string drive_off_summary = 30;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getDriveOffSummary = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 30, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setDriveOffSummary = function(value) {
    return $8M67s.Message.setProto3StringField(this, 30, value);
};
/**
 * optional string drive_off_total_tax = 31;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getDriveOffTotalTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 31, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setDriveOffTotalTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 31, value);
};
/**
 * optional string subscription_total_due_to_start = 32;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getSubscriptionTotalDueToStart = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 32, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setSubscriptionTotalDueToStart = function(value) {
    return $8M67s.Message.setProto3StringField(this, 32, value);
};
/**
 * optional string first_month_subscription_tax = 33;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getFirstMonthSubscriptionTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 33, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setFirstMonthSubscriptionTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 33, value);
};
/**
 * optional string first_month_subscription_total = 34;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getFirstMonthSubscriptionTotal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 34, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setFirstMonthSubscriptionTotal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 34, value);
};
/**
 * optional string price_term_months = 35;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getPriceTermMonths = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 35, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3StringField(this, 35, value);
};
/**
 * optional string wheel_and_tire_monthly = 36;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getWheelAndTireMonthly = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 36, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setWheelAndTireMonthly = function(value) {
    return $8M67s.Message.setProto3StringField(this, 36, value);
};
/**
 * optional string wheel_and_tire_monthly_tax = 37;
 * @return {string}
 */ proto.subscription.ContractProperties.prototype.getWheelAndTireMonthlyTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 37, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.ContractProperties} returns this
 */ proto.subscription.ContractProperties.prototype.setWheelAndTireMonthlyTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 37, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription.VehiclePickupReceiptProperties.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription.VehiclePickupReceiptProperties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.VehiclePickupReceiptProperties.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerName: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            billingAddress: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            autonomyId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            currentMileage: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            startDate: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            monthlyFee: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            nextMonthlyPayment: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 10, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription.VehiclePickupReceiptProperties}
 */ proto.subscription.VehiclePickupReceiptProperties.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription.VehiclePickupReceiptProperties;
    return proto.subscription.VehiclePickupReceiptProperties.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription.VehiclePickupReceiptProperties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription.VehiclePickupReceiptProperties}
 */ proto.subscription.VehiclePickupReceiptProperties.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setBillingAddress(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAutonomyId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCurrentMileage(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setStartDate(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setStartFee(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setMonthlyFee(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setNextMonthlyPayment(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setPriceTermMonths(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription.VehiclePickupReceiptProperties.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription.VehiclePickupReceiptProperties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription.VehiclePickupReceiptProperties.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getBillingAddress();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAutonomyId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCurrentMileage();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getStartDate();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getStartFee();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getMonthlyFee();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getNextMonthlyPayment();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getPriceTermMonths();
    if (f.length > 0) writer.writeString(10, f);
};
/**
 * optional string customer_name = 1;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getCustomerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setCustomerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string billing_address = 2;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getBillingAddress = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setBillingAddress = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vin = 3;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string autonomy_id = 4;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getAutonomyId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setAutonomyId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string current_mileage = 5;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getCurrentMileage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setCurrentMileage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string start_date = 6;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getStartDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setStartDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string start_fee = 7;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getStartFee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string monthly_fee = 8;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getMonthlyFee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setMonthlyFee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string next_monthly_payment = 9;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getNextMonthlyPayment = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setNextMonthlyPayment = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string price_term_months = 10;
 * @return {string}
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.getPriceTermMonths = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription.VehiclePickupReceiptProperties} returns this
 */ proto.subscription.VehiclePickupReceiptProperties.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * @enum {number}
 */ proto.subscription.SubscriptionStatus = {
    PENDING: 0,
    ACTIVE: 1,
    CLOSED: 2,
    RETURNING: 3
};
/**
 * @enum {number}
 */ proto.subscription.ReservationStatus = {
    CREATED: 0,
    PAID: 1,
    ASSIGNED_VEHICLE: 2,
    CONVERTED: 3,
    REFUND_REQUESTED: 4,
    REJECTED: 5,
    VEHICLE_UNASSIGNED: 6
};
$cf7d654c329c7644$var$goog.object.extend(module.exports, proto.subscription);

});



parcelRegister("1oiLe", function(module, exports) {
// source: dealer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $103695d54b6aba00$var$goog = $8M67s;
var $103695d54b6aba00$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$103695d54b6aba00$var$goog.object.extend(proto, $3QqPt);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.Calendar', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.ClosedDateWithReason', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.Date', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.Dealership', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.Dealership.Activity', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.DealershipCreated', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.DealershipUpdated', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.DealershipUser', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.DealershipUser.Activity', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.DealershipUserCreated', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.DealershipUserUpdated', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.GetAvailabilityResponse', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.GetClosedDatesResponse', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.GetHolidaysResponse', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.OpenDayOfWeek', null, $103695d54b6aba00$var$global);
$103695d54b6aba00$var$goog.exportSymbol('proto.dealer.OpenDayOfWeek.DayOfWeek', null, $103695d54b6aba00$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.Dealership = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.Dealership, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.Dealership.displayName = 'proto.dealer.Dealership';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.DealershipUser = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.dealer.DealershipUser.repeatedFields_, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.DealershipUser, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.DealershipUser.displayName = 'proto.dealer.DealershipUser';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.ClosedDateWithReason = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.ClosedDateWithReason, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.ClosedDateWithReason.displayName = 'proto.dealer.ClosedDateWithReason';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.OpenDayOfWeek = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.OpenDayOfWeek, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.OpenDayOfWeek.displayName = 'proto.dealer.OpenDayOfWeek';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.Calendar = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.dealer.Calendar.repeatedFields_, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.Calendar, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.Calendar.displayName = 'proto.dealer.Calendar';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.Date = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.Date, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.Date.displayName = 'proto.dealer.Date';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.GetClosedDatesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.dealer.GetClosedDatesResponse.repeatedFields_, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.GetClosedDatesResponse, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.GetClosedDatesResponse.displayName = 'proto.dealer.GetClosedDatesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.GetAvailabilityResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.dealer.GetAvailabilityResponse.repeatedFields_, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.GetAvailabilityResponse, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.GetAvailabilityResponse.displayName = 'proto.dealer.GetAvailabilityResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.GetHolidaysResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.GetHolidaysResponse, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.GetHolidaysResponse.displayName = 'proto.dealer.GetHolidaysResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.DealershipCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.DealershipCreated, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.DealershipCreated.displayName = 'proto.dealer.DealershipCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.DealershipUserCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.DealershipUserCreated, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.DealershipUserCreated.displayName = 'proto.dealer.DealershipUserCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.DealershipUserUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.DealershipUserUpdated, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.DealershipUserUpdated.displayName = 'proto.dealer.DealershipUserUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealer.DealershipUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$103695d54b6aba00$var$goog.inherits(proto.dealer.DealershipUpdated, $8M67s.Message);
if ($103695d54b6aba00$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealer.DealershipUpdated.displayName = 'proto.dealer.DealershipUpdated';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.Dealership.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.Dealership.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.Dealership} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.Dealership.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            address: (f = msg.getAddress()) && $3QqPt.Address.toObject(includeInstance, f),
            latitude: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            longitude: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            timeZone: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            version: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            activity: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            updatedTime: $8M67s.Message.getFieldWithDefault(msg, 10, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.Dealership}
 */ proto.dealer.Dealership.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.Dealership;
    return proto.dealer.Dealership.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.Dealership} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.Dealership}
 */ proto.dealer.Dealership.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            case 4:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setAddress(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLatitude(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setLongitude(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setTimeZone(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 9:
                var value = /** @type {!proto.dealer.Dealership.Activity} */ reader.readEnum();
                msg.setActivity(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt64();
                msg.setUpdatedTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.Dealership.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.Dealership.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.Dealership} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.Dealership.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getAddress();
    if (f != null) writer.writeMessage(4, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getLatitude();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getLongitude();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getTimeZone();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(8, f);
    f = message.getActivity();
    if (f !== 0.0) writer.writeEnum(9, f);
    f = message.getUpdatedTime();
    if (f !== 0) writer.writeInt64(10, f);
};
/**
 * @enum {number}
 */ proto.dealer.Dealership.Activity = {
    DEACTIVATED: 0,
    ACTIVATED: 1
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.dealer.Dealership.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.dealer.Dealership.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string phone_number = 3;
 * @return {string}
 */ proto.dealer.Dealership.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional domain.Address address = 4;
 * @return {?proto.domain.Address}
 */ proto.dealer.Dealership.prototype.getAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 4);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.dealer.Dealership} returns this
*/ proto.dealer.Dealership.prototype.setAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.clearAddress = function() {
    return this.setAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealer.Dealership.prototype.hasAddress = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional string latitude = 5;
 * @return {string}
 */ proto.dealer.Dealership.prototype.getLatitude = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setLatitude = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string longitude = 6;
 * @return {string}
 */ proto.dealer.Dealership.prototype.getLongitude = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setLongitude = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string time_zone = 7;
 * @return {string}
 */ proto.dealer.Dealership.prototype.getTimeZone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setTimeZone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional int64 version = 8;
 * @return {number}
 */ proto.dealer.Dealership.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional Activity activity = 9;
 * @return {!proto.dealer.Dealership.Activity}
 */ proto.dealer.Dealership.prototype.getActivity = function() {
    return /** @type {!proto.dealer.Dealership.Activity} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {!proto.dealer.Dealership.Activity} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setActivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 9, value);
};
/**
 * optional int64 updated_time = 10;
 * @return {number}
 */ proto.dealer.Dealership.prototype.getUpdatedTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.Dealership} returns this
 */ proto.dealer.Dealership.prototype.setUpdatedTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.dealer.DealershipUser.repeatedFields_ = [
    7,
    16
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.DealershipUser.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.DealershipUser.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.DealershipUser} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipUser.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            cellPhone: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            workEmail: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            responsibilityList: (f = $8M67s.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
            nxcrInvitation: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            dealerAppInvitation: $8M67s.Message.getBooleanFieldWithDefault(msg, 9, false),
            version: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            activity: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            termsOfService: $8M67s.Message.getBooleanFieldWithDefault(msg, 12, false),
            privacyPolicy: $8M67s.Message.getBooleanFieldWithDefault(msg, 13, false),
            eSignature: $8M67s.Message.getBooleanFieldWithDefault(msg, 14, false),
            updatedTime: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            vendorAccountsList: $8M67s.Message.toObjectList(msg.getVendorAccountsList(), $3QqPt.VendorAccount.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.DealershipUser}
 */ proto.dealer.DealershipUser.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.DealershipUser;
    return proto.dealer.DealershipUser.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.DealershipUser} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.DealershipUser}
 */ proto.dealer.DealershipUser.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCellPhone(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setWorkEmail(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.addResponsibility(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setNxcrInvitation(value);
                break;
            case 9:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDealerAppInvitation(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 11:
                var value = /** @type {!proto.dealer.DealershipUser.Activity} */ reader.readEnum();
                msg.setActivity(value);
                break;
            case 12:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTermsOfService(value);
                break;
            case 13:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPrivacyPolicy(value);
                break;
            case 14:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setESignature(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt64();
                msg.setUpdatedTime(value);
                break;
            case 16:
                var value = new $3QqPt.VendorAccount;
                reader.readMessage(value, $3QqPt.VendorAccount.deserializeBinaryFromReader);
                msg.addVendorAccounts(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.DealershipUser.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.DealershipUser.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.DealershipUser} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipUser.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCellPhone();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getWorkEmail();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getResponsibilityList();
    if (f.length > 0) writer.writeRepeatedString(7, f);
    f = message.getNxcrInvitation();
    if (f) writer.writeBool(8, f);
    f = message.getDealerAppInvitation();
    if (f) writer.writeBool(9, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(10, f);
    f = message.getActivity();
    if (f !== 0.0) writer.writeEnum(11, f);
    f = message.getTermsOfService();
    if (f) writer.writeBool(12, f);
    f = message.getPrivacyPolicy();
    if (f) writer.writeBool(13, f);
    f = message.getESignature();
    if (f) writer.writeBool(14, f);
    f = message.getUpdatedTime();
    if (f !== 0) writer.writeInt64(15, f);
    f = message.getVendorAccountsList();
    if (f.length > 0) writer.writeRepeatedMessage(16, f, $3QqPt.VendorAccount.serializeBinaryToWriter);
};
/**
 * @enum {number}
 */ proto.dealer.DealershipUser.Activity = {
    DEACTIVATED: 0,
    ACTIVATED: 1
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.dealer.DealershipUser.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string dealership_id = 2;
 * @return {string}
 */ proto.dealer.DealershipUser.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string first_name = 3;
 * @return {string}
 */ proto.dealer.DealershipUser.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_name = 4;
 * @return {string}
 */ proto.dealer.DealershipUser.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string cell_phone = 5;
 * @return {string}
 */ proto.dealer.DealershipUser.prototype.getCellPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setCellPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string work_email = 6;
 * @return {string}
 */ proto.dealer.DealershipUser.prototype.getWorkEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setWorkEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * repeated string responsibility = 7;
 * @return {!Array<string>}
 */ proto.dealer.DealershipUser.prototype.getResponsibilityList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 7);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setResponsibilityList = function(value) {
    return $8M67s.Message.setField(this, 7, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.addResponsibility = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 7, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.clearResponsibilityList = function() {
    return this.setResponsibilityList([]);
};
/**
 * optional bool nxcr_invitation = 8;
 * @return {boolean}
 */ proto.dealer.DealershipUser.prototype.getNxcrInvitation = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setNxcrInvitation = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional bool dealer_app_invitation = 9;
 * @return {boolean}
 */ proto.dealer.DealershipUser.prototype.getDealerAppInvitation = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 9, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setDealerAppInvitation = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 9, value);
};
/**
 * optional int64 version = 10;
 * @return {number}
 */ proto.dealer.DealershipUser.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional Activity activity = 11;
 * @return {!proto.dealer.DealershipUser.Activity}
 */ proto.dealer.DealershipUser.prototype.getActivity = function() {
    return /** @type {!proto.dealer.DealershipUser.Activity} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {!proto.dealer.DealershipUser.Activity} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setActivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 11, value);
};
/**
 * optional bool terms_of_service = 12;
 * @return {boolean}
 */ proto.dealer.DealershipUser.prototype.getTermsOfService = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 12, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setTermsOfService = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 12, value);
};
/**
 * optional bool privacy_policy = 13;
 * @return {boolean}
 */ proto.dealer.DealershipUser.prototype.getPrivacyPolicy = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 13, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setPrivacyPolicy = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 13, value);
};
/**
 * optional bool e_signature = 14;
 * @return {boolean}
 */ proto.dealer.DealershipUser.prototype.getESignature = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 14, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setESignature = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 14, value);
};
/**
 * optional int64 updated_time = 15;
 * @return {number}
 */ proto.dealer.DealershipUser.prototype.getUpdatedTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.setUpdatedTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * repeated domain.VendorAccount vendor_accounts = 16;
 * @return {!Array<!proto.domain.VendorAccount>}
 */ proto.dealer.DealershipUser.prototype.getVendorAccountsList = function() {
    return /** @type{!Array<!proto.domain.VendorAccount>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.VendorAccount, 16);
};
/**
 * @param {!Array<!proto.domain.VendorAccount>} value
 * @return {!proto.dealer.DealershipUser} returns this
*/ proto.dealer.DealershipUser.prototype.setVendorAccountsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 16, value);
};
/**
 * @param {!proto.domain.VendorAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.VendorAccount}
 */ proto.dealer.DealershipUser.prototype.addVendorAccounts = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.domain.VendorAccount, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dealer.DealershipUser} returns this
 */ proto.dealer.DealershipUser.prototype.clearVendorAccountsList = function() {
    return this.setVendorAccountsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.ClosedDateWithReason.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.ClosedDateWithReason.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.ClosedDateWithReason} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.ClosedDateWithReason.toObject = function(includeInstance, msg) {
        var f, obj = {
            date: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            reason: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.ClosedDateWithReason}
 */ proto.dealer.ClosedDateWithReason.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.ClosedDateWithReason;
    return proto.dealer.ClosedDateWithReason.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.ClosedDateWithReason} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.ClosedDateWithReason}
 */ proto.dealer.ClosedDateWithReason.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDate(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setReason(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.ClosedDateWithReason.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.ClosedDateWithReason.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.ClosedDateWithReason} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.ClosedDateWithReason.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReason();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string date = 1;
 * @return {string}
 */ proto.dealer.ClosedDateWithReason.prototype.getDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.ClosedDateWithReason} returns this
 */ proto.dealer.ClosedDateWithReason.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string reason = 2;
 * @return {string}
 */ proto.dealer.ClosedDateWithReason.prototype.getReason = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.ClosedDateWithReason} returns this
 */ proto.dealer.ClosedDateWithReason.prototype.setReason = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.OpenDayOfWeek.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.OpenDayOfWeek.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.OpenDayOfWeek} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.OpenDayOfWeek.toObject = function(includeInstance, msg) {
        var f, obj = {
            dayOfWeek: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            startTime: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            endTime: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            timezone: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.OpenDayOfWeek}
 */ proto.dealer.OpenDayOfWeek.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.OpenDayOfWeek;
    return proto.dealer.OpenDayOfWeek.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.OpenDayOfWeek} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.OpenDayOfWeek}
 */ proto.dealer.OpenDayOfWeek.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.dealer.OpenDayOfWeek.DayOfWeek} */ reader.readEnum();
                msg.setDayOfWeek(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setStartTime(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setEndTime(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTimezone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.OpenDayOfWeek.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.OpenDayOfWeek.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.OpenDayOfWeek} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.OpenDayOfWeek.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDayOfWeek();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getStartTime();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getEndTime();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getTimezone();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * @enum {number}
 */ proto.dealer.OpenDayOfWeek.DayOfWeek = {
    DAY_OF_WEEK_UNSPECIFIED: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6,
    SUNDAY: 7
};
/**
 * optional DayOfWeek day_of_week = 1;
 * @return {!proto.dealer.OpenDayOfWeek.DayOfWeek}
 */ proto.dealer.OpenDayOfWeek.prototype.getDayOfWeek = function() {
    return /** @type {!proto.dealer.OpenDayOfWeek.DayOfWeek} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.dealer.OpenDayOfWeek.DayOfWeek} value
 * @return {!proto.dealer.OpenDayOfWeek} returns this
 */ proto.dealer.OpenDayOfWeek.prototype.setDayOfWeek = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string start_time = 2;
 * @return {string}
 */ proto.dealer.OpenDayOfWeek.prototype.getStartTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.OpenDayOfWeek} returns this
 */ proto.dealer.OpenDayOfWeek.prototype.setStartTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string end_time = 3;
 * @return {string}
 */ proto.dealer.OpenDayOfWeek.prototype.getEndTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.OpenDayOfWeek} returns this
 */ proto.dealer.OpenDayOfWeek.prototype.setEndTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string timezone = 4;
 * @return {string}
 */ proto.dealer.OpenDayOfWeek.prototype.getTimezone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.OpenDayOfWeek} returns this
 */ proto.dealer.OpenDayOfWeek.prototype.setTimezone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.dealer.Calendar.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.Calendar.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.Calendar.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.Calendar} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.Calendar.toObject = function(includeInstance, msg) {
        var f, obj = {
            year: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            month: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            datesList: $8M67s.Message.toObjectList(msg.getDatesList(), proto.dealer.Date.toObject, includeInstance),
            timezone: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            dateformat: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.Calendar}
 */ proto.dealer.Calendar.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.Calendar;
    return proto.dealer.Calendar.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.Calendar} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.Calendar}
 */ proto.dealer.Calendar.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setYear(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonth(value);
                break;
            case 3:
                var value = new proto.dealer.Date;
                reader.readMessage(value, proto.dealer.Date.deserializeBinaryFromReader);
                msg.addDates(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTimezone(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setDateformat(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.Calendar.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.Calendar.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.Calendar} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.Calendar.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getYear();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getMonth();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getDatesList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.dealer.Date.serializeBinaryToWriter);
    f = message.getTimezone();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getDateformat();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional int32 year = 1;
 * @return {number}
 */ proto.dealer.Calendar.prototype.getYear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.Calendar} returns this
 */ proto.dealer.Calendar.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 month = 2;
 * @return {number}
 */ proto.dealer.Calendar.prototype.getMonth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.Calendar} returns this
 */ proto.dealer.Calendar.prototype.setMonth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * repeated Date dates = 3;
 * @return {!Array<!proto.dealer.Date>}
 */ proto.dealer.Calendar.prototype.getDatesList = function() {
    return /** @type{!Array<!proto.dealer.Date>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.dealer.Date, 3);
};
/**
 * @param {!Array<!proto.dealer.Date>} value
 * @return {!proto.dealer.Calendar} returns this
*/ proto.dealer.Calendar.prototype.setDatesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.dealer.Date=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dealer.Date}
 */ proto.dealer.Calendar.prototype.addDates = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.dealer.Date, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dealer.Calendar} returns this
 */ proto.dealer.Calendar.prototype.clearDatesList = function() {
    return this.setDatesList([]);
};
/**
 * optional string timeZone = 4;
 * @return {string}
 */ proto.dealer.Calendar.prototype.getTimezone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Calendar} returns this
 */ proto.dealer.Calendar.prototype.setTimezone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string dateFormat = 5;
 * @return {string}
 */ proto.dealer.Calendar.prototype.getDateformat = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Calendar} returns this
 */ proto.dealer.Calendar.prototype.setDateformat = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.Date.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.Date.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.Date} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.Date.toObject = function(includeInstance, msg) {
        var f, obj = {
            description: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            datetype: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            datestring: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            dow: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            month: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            day: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            year: $8M67s.Message.getFieldWithDefault(msg, 7, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.Date}
 */ proto.dealer.Date.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.Date;
    return proto.dealer.Date.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.Date} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.Date}
 */ proto.dealer.Date.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDatetype(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDatestring(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDow(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonth(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDay(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setYear(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.Date.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.Date.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.Date} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.Date.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDescription();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDatetype();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDatestring();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDow();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getMonth();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getDay();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getYear();
    if (f !== 0) writer.writeInt32(7, f);
};
/**
 * optional string description = 1;
 * @return {string}
 */ proto.dealer.Date.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Date} returns this
 */ proto.dealer.Date.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string dateType = 2;
 * @return {string}
 */ proto.dealer.Date.prototype.getDatetype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Date} returns this
 */ proto.dealer.Date.prototype.setDatetype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string dateString = 3;
 * @return {string}
 */ proto.dealer.Date.prototype.getDatestring = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.Date} returns this
 */ proto.dealer.Date.prototype.setDatestring = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 dow = 4;
 * @return {number}
 */ proto.dealer.Date.prototype.getDow = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.Date} returns this
 */ proto.dealer.Date.prototype.setDow = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 month = 5;
 * @return {number}
 */ proto.dealer.Date.prototype.getMonth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.Date} returns this
 */ proto.dealer.Date.prototype.setMonth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 day = 6;
 * @return {number}
 */ proto.dealer.Date.prototype.getDay = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.Date} returns this
 */ proto.dealer.Date.prototype.setDay = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 year = 7;
 * @return {number}
 */ proto.dealer.Date.prototype.getYear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.Date} returns this
 */ proto.dealer.Date.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.dealer.GetClosedDatesResponse.repeatedFields_ = [
    3,
    6
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.GetClosedDatesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.GetClosedDatesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.GetClosedDatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.GetClosedDatesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            closedDatesList: (f = $8M67s.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
            error: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            errorCode: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            closedDatesWithReasonsList: $8M67s.Message.toObjectList(msg.getClosedDatesWithReasonsList(), proto.dealer.ClosedDateWithReason.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.GetClosedDatesResponse}
 */ proto.dealer.GetClosedDatesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.GetClosedDatesResponse;
    return proto.dealer.GetClosedDatesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.GetClosedDatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.GetClosedDatesResponse}
 */ proto.dealer.GetClosedDatesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.addClosedDates(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setError(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setErrorCode(value);
                break;
            case 6:
                var value = new proto.dealer.ClosedDateWithReason;
                reader.readMessage(value, proto.dealer.ClosedDateWithReason.deserializeBinaryFromReader);
                msg.addClosedDatesWithReasons(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.GetClosedDatesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.GetClosedDatesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.GetClosedDatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.GetClosedDatesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getClosedDatesList();
    if (f.length > 0) writer.writeRepeatedString(3, f);
    f = message.getError();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getErrorCode();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getClosedDatesWithReasonsList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, proto.dealer.ClosedDateWithReason.serializeBinaryToWriter);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.dealer.GetClosedDatesResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
 */ proto.dealer.GetClosedDatesResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string dealership_id = 2;
 * @return {string}
 */ proto.dealer.GetClosedDatesResponse.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
 */ proto.dealer.GetClosedDatesResponse.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated string closed_dates = 3;
 * @return {!Array<string>}
 */ proto.dealer.GetClosedDatesResponse.prototype.getClosedDatesList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 3);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
 */ proto.dealer.GetClosedDatesResponse.prototype.setClosedDatesList = function(value) {
    return $8M67s.Message.setField(this, 3, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
 */ proto.dealer.GetClosedDatesResponse.prototype.addClosedDates = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 3, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
 */ proto.dealer.GetClosedDatesResponse.prototype.clearClosedDatesList = function() {
    return this.setClosedDatesList([]);
};
/**
 * optional string error = 4;
 * @return {string}
 */ proto.dealer.GetClosedDatesResponse.prototype.getError = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
 */ proto.dealer.GetClosedDatesResponse.prototype.setError = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 error_code = 5;
 * @return {number}
 */ proto.dealer.GetClosedDatesResponse.prototype.getErrorCode = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
 */ proto.dealer.GetClosedDatesResponse.prototype.setErrorCode = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * repeated ClosedDateWithReason closed_dates_with_reasons = 6;
 * @return {!Array<!proto.dealer.ClosedDateWithReason>}
 */ proto.dealer.GetClosedDatesResponse.prototype.getClosedDatesWithReasonsList = function() {
    return /** @type{!Array<!proto.dealer.ClosedDateWithReason>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.dealer.ClosedDateWithReason, 6);
};
/**
 * @param {!Array<!proto.dealer.ClosedDateWithReason>} value
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
*/ proto.dealer.GetClosedDatesResponse.prototype.setClosedDatesWithReasonsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.dealer.ClosedDateWithReason=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dealer.ClosedDateWithReason}
 */ proto.dealer.GetClosedDatesResponse.prototype.addClosedDatesWithReasons = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.dealer.ClosedDateWithReason, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dealer.GetClosedDatesResponse} returns this
 */ proto.dealer.GetClosedDatesResponse.prototype.clearClosedDatesWithReasonsList = function() {
    return this.setClosedDatesWithReasonsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.dealer.GetAvailabilityResponse.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.GetAvailabilityResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.GetAvailabilityResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.GetAvailabilityResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.GetAvailabilityResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            openDaysOfWeekList: $8M67s.Message.toObjectList(msg.getOpenDaysOfWeekList(), proto.dealer.OpenDayOfWeek.toObject, includeInstance),
            error: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            errorCode: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.GetAvailabilityResponse}
 */ proto.dealer.GetAvailabilityResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.GetAvailabilityResponse;
    return proto.dealer.GetAvailabilityResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.GetAvailabilityResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.GetAvailabilityResponse}
 */ proto.dealer.GetAvailabilityResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 3:
                var value = new proto.dealer.OpenDayOfWeek;
                reader.readMessage(value, proto.dealer.OpenDayOfWeek.deserializeBinaryFromReader);
                msg.addOpenDaysOfWeek(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setError(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setErrorCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.GetAvailabilityResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.GetAvailabilityResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.GetAvailabilityResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.GetAvailabilityResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getOpenDaysOfWeekList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.dealer.OpenDayOfWeek.serializeBinaryToWriter);
    f = message.getError();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getErrorCode();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.dealer.GetAvailabilityResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealer.GetAvailabilityResponse} returns this
 */ proto.dealer.GetAvailabilityResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string dealership_id = 2;
 * @return {string}
 */ proto.dealer.GetAvailabilityResponse.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.GetAvailabilityResponse} returns this
 */ proto.dealer.GetAvailabilityResponse.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated OpenDayOfWeek open_days_of_week = 3;
 * @return {!Array<!proto.dealer.OpenDayOfWeek>}
 */ proto.dealer.GetAvailabilityResponse.prototype.getOpenDaysOfWeekList = function() {
    return /** @type{!Array<!proto.dealer.OpenDayOfWeek>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.dealer.OpenDayOfWeek, 3);
};
/**
 * @param {!Array<!proto.dealer.OpenDayOfWeek>} value
 * @return {!proto.dealer.GetAvailabilityResponse} returns this
*/ proto.dealer.GetAvailabilityResponse.prototype.setOpenDaysOfWeekList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.dealer.OpenDayOfWeek=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dealer.OpenDayOfWeek}
 */ proto.dealer.GetAvailabilityResponse.prototype.addOpenDaysOfWeek = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.dealer.OpenDayOfWeek, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dealer.GetAvailabilityResponse} returns this
 */ proto.dealer.GetAvailabilityResponse.prototype.clearOpenDaysOfWeekList = function() {
    return this.setOpenDaysOfWeekList([]);
};
/**
 * optional string error = 4;
 * @return {string}
 */ proto.dealer.GetAvailabilityResponse.prototype.getError = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.GetAvailabilityResponse} returns this
 */ proto.dealer.GetAvailabilityResponse.prototype.setError = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 error_code = 5;
 * @return {number}
 */ proto.dealer.GetAvailabilityResponse.prototype.getErrorCode = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.GetAvailabilityResponse} returns this
 */ proto.dealer.GetAvailabilityResponse.prototype.setErrorCode = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.GetHolidaysResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.GetHolidaysResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.GetHolidaysResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.GetHolidaysResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            error: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            calendar: (f = msg.getCalendar()) && proto.dealer.Calendar.toObject(includeInstance, f),
            errorCode: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.GetHolidaysResponse}
 */ proto.dealer.GetHolidaysResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.GetHolidaysResponse;
    return proto.dealer.GetHolidaysResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.GetHolidaysResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.GetHolidaysResponse}
 */ proto.dealer.GetHolidaysResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setError(value);
                break;
            case 3:
                var value = new proto.dealer.Calendar;
                reader.readMessage(value, proto.dealer.Calendar.deserializeBinaryFromReader);
                msg.setCalendar(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setErrorCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.GetHolidaysResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.GetHolidaysResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.GetHolidaysResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.GetHolidaysResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getError();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCalendar();
    if (f != null) writer.writeMessage(3, f, proto.dealer.Calendar.serializeBinaryToWriter);
    f = message.getErrorCode();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.dealer.GetHolidaysResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealer.GetHolidaysResponse} returns this
 */ proto.dealer.GetHolidaysResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string error = 2;
 * @return {string}
 */ proto.dealer.GetHolidaysResponse.prototype.getError = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealer.GetHolidaysResponse} returns this
 */ proto.dealer.GetHolidaysResponse.prototype.setError = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Calendar calendar = 3;
 * @return {?proto.dealer.Calendar}
 */ proto.dealer.GetHolidaysResponse.prototype.getCalendar = function() {
    return /** @type{?proto.dealer.Calendar} */ $8M67s.Message.getWrapperField(this, proto.dealer.Calendar, 3);
};
/**
 * @param {?proto.dealer.Calendar|undefined} value
 * @return {!proto.dealer.GetHolidaysResponse} returns this
*/ proto.dealer.GetHolidaysResponse.prototype.setCalendar = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealer.GetHolidaysResponse} returns this
 */ proto.dealer.GetHolidaysResponse.prototype.clearCalendar = function() {
    return this.setCalendar(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealer.GetHolidaysResponse.prototype.hasCalendar = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional int32 error_code = 4;
 * @return {number}
 */ proto.dealer.GetHolidaysResponse.prototype.getErrorCode = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealer.GetHolidaysResponse} returns this
 */ proto.dealer.GetHolidaysResponse.prototype.setErrorCode = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.DealershipCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.DealershipCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.DealershipCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && proto.dealer.Dealership.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.DealershipCreated}
 */ proto.dealer.DealershipCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.DealershipCreated;
    return proto.dealer.DealershipCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.DealershipCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.DealershipCreated}
 */ proto.dealer.DealershipCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.dealer.Dealership;
                reader.readMessage(value, proto.dealer.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.DealershipCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.DealershipCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.DealershipCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, proto.dealer.Dealership.serializeBinaryToWriter);
};
/**
 * optional Dealership dealership = 1;
 * @return {?proto.dealer.Dealership}
 */ proto.dealer.DealershipCreated.prototype.getDealership = function() {
    return /** @type{?proto.dealer.Dealership} */ $8M67s.Message.getWrapperField(this, proto.dealer.Dealership, 1);
};
/**
 * @param {?proto.dealer.Dealership|undefined} value
 * @return {!proto.dealer.DealershipCreated} returns this
*/ proto.dealer.DealershipCreated.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealer.DealershipCreated} returns this
 */ proto.dealer.DealershipCreated.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealer.DealershipCreated.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.DealershipUserCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.DealershipUserCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.DealershipUserCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipUserCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            user: (f = msg.getUser()) && proto.dealer.DealershipUser.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.DealershipUserCreated}
 */ proto.dealer.DealershipUserCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.DealershipUserCreated;
    return proto.dealer.DealershipUserCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.DealershipUserCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.DealershipUserCreated}
 */ proto.dealer.DealershipUserCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.dealer.DealershipUser;
                reader.readMessage(value, proto.dealer.DealershipUser.deserializeBinaryFromReader);
                msg.setUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.DealershipUserCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.DealershipUserCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.DealershipUserCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipUserCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUser();
    if (f != null) writer.writeMessage(1, f, proto.dealer.DealershipUser.serializeBinaryToWriter);
};
/**
 * optional DealershipUser user = 1;
 * @return {?proto.dealer.DealershipUser}
 */ proto.dealer.DealershipUserCreated.prototype.getUser = function() {
    return /** @type{?proto.dealer.DealershipUser} */ $8M67s.Message.getWrapperField(this, proto.dealer.DealershipUser, 1);
};
/**
 * @param {?proto.dealer.DealershipUser|undefined} value
 * @return {!proto.dealer.DealershipUserCreated} returns this
*/ proto.dealer.DealershipUserCreated.prototype.setUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealer.DealershipUserCreated} returns this
 */ proto.dealer.DealershipUserCreated.prototype.clearUser = function() {
    return this.setUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealer.DealershipUserCreated.prototype.hasUser = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.DealershipUserUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.DealershipUserUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.DealershipUserUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipUserUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            user: (f = msg.getUser()) && proto.dealer.DealershipUser.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.DealershipUserUpdated}
 */ proto.dealer.DealershipUserUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.DealershipUserUpdated;
    return proto.dealer.DealershipUserUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.DealershipUserUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.DealershipUserUpdated}
 */ proto.dealer.DealershipUserUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.dealer.DealershipUser;
                reader.readMessage(value, proto.dealer.DealershipUser.deserializeBinaryFromReader);
                msg.setUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.DealershipUserUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.DealershipUserUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.DealershipUserUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipUserUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUser();
    if (f != null) writer.writeMessage(1, f, proto.dealer.DealershipUser.serializeBinaryToWriter);
};
/**
 * optional DealershipUser user = 1;
 * @return {?proto.dealer.DealershipUser}
 */ proto.dealer.DealershipUserUpdated.prototype.getUser = function() {
    return /** @type{?proto.dealer.DealershipUser} */ $8M67s.Message.getWrapperField(this, proto.dealer.DealershipUser, 1);
};
/**
 * @param {?proto.dealer.DealershipUser|undefined} value
 * @return {!proto.dealer.DealershipUserUpdated} returns this
*/ proto.dealer.DealershipUserUpdated.prototype.setUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealer.DealershipUserUpdated} returns this
 */ proto.dealer.DealershipUserUpdated.prototype.clearUser = function() {
    return this.setUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealer.DealershipUserUpdated.prototype.hasUser = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealer.DealershipUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.dealer.DealershipUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealer.DealershipUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && proto.dealer.Dealership.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealer.DealershipUpdated}
 */ proto.dealer.DealershipUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealer.DealershipUpdated;
    return proto.dealer.DealershipUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealer.DealershipUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealer.DealershipUpdated}
 */ proto.dealer.DealershipUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.dealer.Dealership;
                reader.readMessage(value, proto.dealer.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealer.DealershipUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealer.DealershipUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealer.DealershipUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealer.DealershipUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, proto.dealer.Dealership.serializeBinaryToWriter);
};
/**
 * optional Dealership dealership = 1;
 * @return {?proto.dealer.Dealership}
 */ proto.dealer.DealershipUpdated.prototype.getDealership = function() {
    return /** @type{?proto.dealer.Dealership} */ $8M67s.Message.getWrapperField(this, proto.dealer.Dealership, 1);
};
/**
 * @param {?proto.dealer.Dealership|undefined} value
 * @return {!proto.dealer.DealershipUpdated} returns this
*/ proto.dealer.DealershipUpdated.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealer.DealershipUpdated} returns this
 */ proto.dealer.DealershipUpdated.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealer.DealershipUpdated.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
$103695d54b6aba00$var$goog.object.extend(module.exports, proto.dealer);

});

parcelRegister("dFFtz", function(module, exports) {
// source: dealership_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $9f3f46f9bf15a2d9$var$goog = $8M67s;
var $9f3f46f9bf15a2d9$var$global = Function('return this')();

var $1oiLe = parcelRequire("1oiLe");
$9f3f46f9bf15a2d9$var$goog.object.extend(proto, $1oiLe);

var $3QqPt = parcelRequire("3QqPt");
$9f3f46f9bf15a2d9$var$goog.object.extend(proto, $3QqPt);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.CreateDealershipRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.CreateDealershipResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.CreateDealershipUserRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.CreateDealershipUserResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.DealershipUserSignaturesRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.DealershipUserSignaturesResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetDealerUserInfoRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetDealerUserInfoResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetDealershipInfoRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetDealershipInfoResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetDealershipUserByPhoneRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetDealershipUserByPhoneResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetFleetDealershipInfoRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetFleetDealershipInfoResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetSelfRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.GetSelfResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.ListDealershipsRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.ListDealershipsResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.MigrateDealershipDataRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.MigrateDealershipDataResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.UpdateDealershipRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.UpdateDealershipResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.UpdateDealershipUserRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.UpdateDealershipUserResponse', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.ViewTeamRequest', null, $9f3f46f9bf15a2d9$var$global);
$9f3f46f9bf15a2d9$var$goog.exportSymbol('proto.dealership_service.ViewTeamResponse', null, $9f3f46f9bf15a2d9$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.MigrateDealershipDataRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.MigrateDealershipDataRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.MigrateDealershipDataRequest.displayName = 'proto.dealership_service.MigrateDealershipDataRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.MigrateDealershipDataResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.MigrateDealershipDataResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.MigrateDealershipDataResponse.displayName = 'proto.dealership_service.MigrateDealershipDataResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.ListDealershipsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.ListDealershipsRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.ListDealershipsRequest.displayName = 'proto.dealership_service.ListDealershipsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.ListDealershipsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.dealership_service.ListDealershipsResponse.repeatedFields_, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.ListDealershipsResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.ListDealershipsResponse.displayName = 'proto.dealership_service.ListDealershipsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.CreateDealershipRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.CreateDealershipRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.CreateDealershipRequest.displayName = 'proto.dealership_service.CreateDealershipRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.CreateDealershipResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.CreateDealershipResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.CreateDealershipResponse.displayName = 'proto.dealership_service.CreateDealershipResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.CreateDealershipUserRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.CreateDealershipUserRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.CreateDealershipUserRequest.displayName = 'proto.dealership_service.CreateDealershipUserRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.CreateDealershipUserResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.CreateDealershipUserResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.CreateDealershipUserResponse.displayName = 'proto.dealership_service.CreateDealershipUserResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetFleetDealershipInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetFleetDealershipInfoRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetFleetDealershipInfoRequest.displayName = 'proto.dealership_service.GetFleetDealershipInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetFleetDealershipInfoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetFleetDealershipInfoResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetFleetDealershipInfoResponse.displayName = 'proto.dealership_service.GetFleetDealershipInfoResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetDealerUserInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetDealerUserInfoRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetDealerUserInfoRequest.displayName = 'proto.dealership_service.GetDealerUserInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetDealerUserInfoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetDealerUserInfoResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetDealerUserInfoResponse.displayName = 'proto.dealership_service.GetDealerUserInfoResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.ViewTeamRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.ViewTeamRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.ViewTeamRequest.displayName = 'proto.dealership_service.ViewTeamRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.ViewTeamResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.dealership_service.ViewTeamResponse.repeatedFields_, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.ViewTeamResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.ViewTeamResponse.displayName = 'proto.dealership_service.ViewTeamResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.UpdateDealershipUserRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.UpdateDealershipUserRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.UpdateDealershipUserRequest.displayName = 'proto.dealership_service.UpdateDealershipUserRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.UpdateDealershipUserResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.UpdateDealershipUserResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.UpdateDealershipUserResponse.displayName = 'proto.dealership_service.UpdateDealershipUserResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.DealershipUserSignaturesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.DealershipUserSignaturesRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.DealershipUserSignaturesRequest.displayName = 'proto.dealership_service.DealershipUserSignaturesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.DealershipUserSignaturesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.DealershipUserSignaturesResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.DealershipUserSignaturesResponse.displayName = 'proto.dealership_service.DealershipUserSignaturesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.UpdateDealershipRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.UpdateDealershipRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.UpdateDealershipRequest.displayName = 'proto.dealership_service.UpdateDealershipRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.UpdateDealershipResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.UpdateDealershipResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.UpdateDealershipResponse.displayName = 'proto.dealership_service.UpdateDealershipResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetSelfRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetSelfRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetSelfRequest.displayName = 'proto.dealership_service.GetSelfRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetSelfResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetSelfResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetSelfResponse.displayName = 'proto.dealership_service.GetSelfResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetDealershipUserByPhoneRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetDealershipUserByPhoneRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetDealershipUserByPhoneRequest.displayName = 'proto.dealership_service.GetDealershipUserByPhoneRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetDealershipUserByPhoneResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetDealershipUserByPhoneResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetDealershipUserByPhoneResponse.displayName = 'proto.dealership_service.GetDealershipUserByPhoneResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetDealershipInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetDealershipInfoRequest, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetDealershipInfoRequest.displayName = 'proto.dealership_service.GetDealershipInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.dealership_service.GetDealershipInfoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9f3f46f9bf15a2d9$var$goog.inherits(proto.dealership_service.GetDealershipInfoResponse, $8M67s.Message);
if ($9f3f46f9bf15a2d9$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.dealership_service.GetDealershipInfoResponse.displayName = 'proto.dealership_service.GetDealershipInfoResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.MigrateDealershipDataRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.MigrateDealershipDataRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.MigrateDealershipDataRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.MigrateDealershipDataRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.MigrateDealershipDataRequest}
 */ proto.dealership_service.MigrateDealershipDataRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.MigrateDealershipDataRequest;
    return proto.dealership_service.MigrateDealershipDataRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.MigrateDealershipDataRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.MigrateDealershipDataRequest}
 */ proto.dealership_service.MigrateDealershipDataRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.MigrateDealershipDataRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.MigrateDealershipDataRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.MigrateDealershipDataRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.MigrateDealershipDataRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.MigrateDealershipDataResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.MigrateDealershipDataResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.MigrateDealershipDataResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.MigrateDealershipDataResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.MigrateDealershipDataResponse}
 */ proto.dealership_service.MigrateDealershipDataResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.MigrateDealershipDataResponse;
    return proto.dealership_service.MigrateDealershipDataResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.MigrateDealershipDataResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.MigrateDealershipDataResponse}
 */ proto.dealership_service.MigrateDealershipDataResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.MigrateDealershipDataResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.MigrateDealershipDataResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.MigrateDealershipDataResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.MigrateDealershipDataResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.ListDealershipsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.ListDealershipsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.ListDealershipsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.ListDealershipsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.ListDealershipsRequest}
 */ proto.dealership_service.ListDealershipsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.ListDealershipsRequest;
    return proto.dealership_service.ListDealershipsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.ListDealershipsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.ListDealershipsRequest}
 */ proto.dealership_service.ListDealershipsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.ListDealershipsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.ListDealershipsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.ListDealershipsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.ListDealershipsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.dealership_service.ListDealershipsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.ListDealershipsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.ListDealershipsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.ListDealershipsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.ListDealershipsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealersList: $8M67s.Message.toObjectList(msg.getDealersList(), $1oiLe.Dealership.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.ListDealershipsResponse}
 */ proto.dealership_service.ListDealershipsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.ListDealershipsResponse;
    return proto.dealership_service.ListDealershipsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.ListDealershipsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.ListDealershipsResponse}
 */ proto.dealership_service.ListDealershipsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.Dealership;
                reader.readMessage(value, $1oiLe.Dealership.deserializeBinaryFromReader);
                msg.addDealers(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.ListDealershipsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.ListDealershipsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.ListDealershipsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.ListDealershipsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealersList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $1oiLe.Dealership.serializeBinaryToWriter);
};
/**
 * repeated dealer.Dealership dealers = 1;
 * @return {!Array<!proto.dealer.Dealership>}
 */ proto.dealership_service.ListDealershipsResponse.prototype.getDealersList = function() {
    return /** @type{!Array<!proto.dealer.Dealership>} */ $8M67s.Message.getRepeatedWrapperField(this, $1oiLe.Dealership, 1);
};
/**
 * @param {!Array<!proto.dealer.Dealership>} value
 * @return {!proto.dealership_service.ListDealershipsResponse} returns this
*/ proto.dealership_service.ListDealershipsResponse.prototype.setDealersList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.dealer.Dealership=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dealer.Dealership}
 */ proto.dealership_service.ListDealershipsResponse.prototype.addDealers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dealer.Dealership, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dealership_service.ListDealershipsResponse} returns this
 */ proto.dealership_service.ListDealershipsResponse.prototype.clearDealersList = function() {
    return this.setDealersList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.CreateDealershipRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.CreateDealershipRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.CreateDealershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.CreateDealershipRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $1oiLe.Dealership.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.CreateDealershipRequest}
 */ proto.dealership_service.CreateDealershipRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.CreateDealershipRequest;
    return proto.dealership_service.CreateDealershipRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.CreateDealershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.CreateDealershipRequest}
 */ proto.dealership_service.CreateDealershipRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.Dealership;
                reader.readMessage(value, $1oiLe.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.CreateDealershipRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.CreateDealershipRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.CreateDealershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.CreateDealershipRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $1oiLe.Dealership.serializeBinaryToWriter);
};
/**
 * optional dealer.Dealership dealership = 1;
 * @return {?proto.dealer.Dealership}
 */ proto.dealership_service.CreateDealershipRequest.prototype.getDealership = function() {
    return /** @type{?proto.dealer.Dealership} */ $8M67s.Message.getWrapperField(this, $1oiLe.Dealership, 1);
};
/**
 * @param {?proto.dealer.Dealership|undefined} value
 * @return {!proto.dealership_service.CreateDealershipRequest} returns this
*/ proto.dealership_service.CreateDealershipRequest.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.CreateDealershipRequest} returns this
 */ proto.dealership_service.CreateDealershipRequest.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.CreateDealershipRequest.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.CreateDealershipResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.CreateDealershipResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.CreateDealershipResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.CreateDealershipResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $1oiLe.Dealership.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.CreateDealershipResponse}
 */ proto.dealership_service.CreateDealershipResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.CreateDealershipResponse;
    return proto.dealership_service.CreateDealershipResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.CreateDealershipResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.CreateDealershipResponse}
 */ proto.dealership_service.CreateDealershipResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.Dealership;
                reader.readMessage(value, $1oiLe.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.CreateDealershipResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.CreateDealershipResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.CreateDealershipResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.CreateDealershipResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $1oiLe.Dealership.serializeBinaryToWriter);
};
/**
 * optional dealer.Dealership dealership = 1;
 * @return {?proto.dealer.Dealership}
 */ proto.dealership_service.CreateDealershipResponse.prototype.getDealership = function() {
    return /** @type{?proto.dealer.Dealership} */ $8M67s.Message.getWrapperField(this, $1oiLe.Dealership, 1);
};
/**
 * @param {?proto.dealer.Dealership|undefined} value
 * @return {!proto.dealership_service.CreateDealershipResponse} returns this
*/ proto.dealership_service.CreateDealershipResponse.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.CreateDealershipResponse} returns this
 */ proto.dealership_service.CreateDealershipResponse.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.CreateDealershipResponse.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.CreateDealershipUserRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.CreateDealershipUserRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.CreateDealershipUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.CreateDealershipUserRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipUser: (f = msg.getDealershipUser()) && $1oiLe.DealershipUser.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.CreateDealershipUserRequest}
 */ proto.dealership_service.CreateDealershipUserRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.CreateDealershipUserRequest;
    return proto.dealership_service.CreateDealershipUserRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.CreateDealershipUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.CreateDealershipUserRequest}
 */ proto.dealership_service.CreateDealershipUserRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.DealershipUser;
                reader.readMessage(value, $1oiLe.DealershipUser.deserializeBinaryFromReader);
                msg.setDealershipUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.CreateDealershipUserRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.CreateDealershipUserRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.CreateDealershipUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.CreateDealershipUserRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipUser();
    if (f != null) writer.writeMessage(1, f, $1oiLe.DealershipUser.serializeBinaryToWriter);
};
/**
 * optional dealer.DealershipUser dealership_user = 1;
 * @return {?proto.dealer.DealershipUser}
 */ proto.dealership_service.CreateDealershipUserRequest.prototype.getDealershipUser = function() {
    return /** @type{?proto.dealer.DealershipUser} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUser, 1);
};
/**
 * @param {?proto.dealer.DealershipUser|undefined} value
 * @return {!proto.dealership_service.CreateDealershipUserRequest} returns this
*/ proto.dealership_service.CreateDealershipUserRequest.prototype.setDealershipUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.CreateDealershipUserRequest} returns this
 */ proto.dealership_service.CreateDealershipUserRequest.prototype.clearDealershipUser = function() {
    return this.setDealershipUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.CreateDealershipUserRequest.prototype.hasDealershipUser = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.CreateDealershipUserResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.CreateDealershipUserResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.CreateDealershipUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.CreateDealershipUserResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipUser: (f = msg.getDealershipUser()) && $1oiLe.DealershipUser.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.CreateDealershipUserResponse}
 */ proto.dealership_service.CreateDealershipUserResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.CreateDealershipUserResponse;
    return proto.dealership_service.CreateDealershipUserResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.CreateDealershipUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.CreateDealershipUserResponse}
 */ proto.dealership_service.CreateDealershipUserResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.DealershipUser;
                reader.readMessage(value, $1oiLe.DealershipUser.deserializeBinaryFromReader);
                msg.setDealershipUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.CreateDealershipUserResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.CreateDealershipUserResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.CreateDealershipUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.CreateDealershipUserResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipUser();
    if (f != null) writer.writeMessage(1, f, $1oiLe.DealershipUser.serializeBinaryToWriter);
};
/**
 * optional dealer.DealershipUser dealership_user = 1;
 * @return {?proto.dealer.DealershipUser}
 */ proto.dealership_service.CreateDealershipUserResponse.prototype.getDealershipUser = function() {
    return /** @type{?proto.dealer.DealershipUser} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUser, 1);
};
/**
 * @param {?proto.dealer.DealershipUser|undefined} value
 * @return {!proto.dealership_service.CreateDealershipUserResponse} returns this
*/ proto.dealership_service.CreateDealershipUserResponse.prototype.setDealershipUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.CreateDealershipUserResponse} returns this
 */ proto.dealership_service.CreateDealershipUserResponse.prototype.clearDealershipUser = function() {
    return this.setDealershipUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.CreateDealershipUserResponse.prototype.hasDealershipUser = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetFleetDealershipInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetFleetDealershipInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetFleetDealershipInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetFleetDealershipInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetFleetDealershipInfoRequest}
 */ proto.dealership_service.GetFleetDealershipInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetFleetDealershipInfoRequest;
    return proto.dealership_service.GetFleetDealershipInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetFleetDealershipInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetFleetDealershipInfoRequest}
 */ proto.dealership_service.GetFleetDealershipInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetFleetDealershipInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetFleetDealershipInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetFleetDealershipInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetFleetDealershipInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.dealership_service.GetFleetDealershipInfoRequest.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.GetFleetDealershipInfoRequest} returns this
 */ proto.dealership_service.GetFleetDealershipInfoRequest.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetFleetDealershipInfoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetFleetDealershipInfoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetFleetDealershipInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetFleetDealershipInfoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $1oiLe.Dealership.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetFleetDealershipInfoResponse}
 */ proto.dealership_service.GetFleetDealershipInfoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetFleetDealershipInfoResponse;
    return proto.dealership_service.GetFleetDealershipInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetFleetDealershipInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetFleetDealershipInfoResponse}
 */ proto.dealership_service.GetFleetDealershipInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.Dealership;
                reader.readMessage(value, $1oiLe.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetFleetDealershipInfoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetFleetDealershipInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetFleetDealershipInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetFleetDealershipInfoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $1oiLe.Dealership.serializeBinaryToWriter);
};
/**
 * optional dealer.Dealership dealership = 1;
 * @return {?proto.dealer.Dealership}
 */ proto.dealership_service.GetFleetDealershipInfoResponse.prototype.getDealership = function() {
    return /** @type{?proto.dealer.Dealership} */ $8M67s.Message.getWrapperField(this, $1oiLe.Dealership, 1);
};
/**
 * @param {?proto.dealer.Dealership|undefined} value
 * @return {!proto.dealership_service.GetFleetDealershipInfoResponse} returns this
*/ proto.dealership_service.GetFleetDealershipInfoResponse.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.GetFleetDealershipInfoResponse} returns this
 */ proto.dealership_service.GetFleetDealershipInfoResponse.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.GetFleetDealershipInfoResponse.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetDealerUserInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetDealerUserInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetDealerUserInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealerUserInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerUserId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetDealerUserInfoRequest}
 */ proto.dealership_service.GetDealerUserInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetDealerUserInfoRequest;
    return proto.dealership_service.GetDealerUserInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetDealerUserInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetDealerUserInfoRequest}
 */ proto.dealership_service.GetDealerUserInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetDealerUserInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetDealerUserInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetDealerUserInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealerUserInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerUserId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealer_user_id = 1;
 * @return {string}
 */ proto.dealership_service.GetDealerUserInfoRequest.prototype.getDealerUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.GetDealerUserInfoRequest} returns this
 */ proto.dealership_service.GetDealerUserInfoRequest.prototype.setDealerUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetDealerUserInfoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetDealerUserInfoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetDealerUserInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealerUserInfoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerUser: (f = msg.getDealerUser()) && $1oiLe.DealershipUser.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetDealerUserInfoResponse}
 */ proto.dealership_service.GetDealerUserInfoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetDealerUserInfoResponse;
    return proto.dealership_service.GetDealerUserInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetDealerUserInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetDealerUserInfoResponse}
 */ proto.dealership_service.GetDealerUserInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.DealershipUser;
                reader.readMessage(value, $1oiLe.DealershipUser.deserializeBinaryFromReader);
                msg.setDealerUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetDealerUserInfoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetDealerUserInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetDealerUserInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealerUserInfoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerUser();
    if (f != null) writer.writeMessage(1, f, $1oiLe.DealershipUser.serializeBinaryToWriter);
};
/**
 * optional dealer.DealershipUser dealer_user = 1;
 * @return {?proto.dealer.DealershipUser}
 */ proto.dealership_service.GetDealerUserInfoResponse.prototype.getDealerUser = function() {
    return /** @type{?proto.dealer.DealershipUser} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUser, 1);
};
/**
 * @param {?proto.dealer.DealershipUser|undefined} value
 * @return {!proto.dealership_service.GetDealerUserInfoResponse} returns this
*/ proto.dealership_service.GetDealerUserInfoResponse.prototype.setDealerUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.GetDealerUserInfoResponse} returns this
 */ proto.dealership_service.GetDealerUserInfoResponse.prototype.clearDealerUser = function() {
    return this.setDealerUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.GetDealerUserInfoResponse.prototype.hasDealerUser = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.ViewTeamRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.ViewTeamRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.ViewTeamRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.ViewTeamRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.ViewTeamRequest}
 */ proto.dealership_service.ViewTeamRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.ViewTeamRequest;
    return proto.dealership_service.ViewTeamRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.ViewTeamRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.ViewTeamRequest}
 */ proto.dealership_service.ViewTeamRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.ViewTeamRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.ViewTeamRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.ViewTeamRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.ViewTeamRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealership_id = 1;
 * @return {string}
 */ proto.dealership_service.ViewTeamRequest.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.ViewTeamRequest} returns this
 */ proto.dealership_service.ViewTeamRequest.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.dealership_service.ViewTeamResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.ViewTeamResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.ViewTeamResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.ViewTeamResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.ViewTeamResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipTeamList: $8M67s.Message.toObjectList(msg.getDealershipTeamList(), $1oiLe.DealershipUser.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.ViewTeamResponse}
 */ proto.dealership_service.ViewTeamResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.ViewTeamResponse;
    return proto.dealership_service.ViewTeamResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.ViewTeamResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.ViewTeamResponse}
 */ proto.dealership_service.ViewTeamResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.DealershipUser;
                reader.readMessage(value, $1oiLe.DealershipUser.deserializeBinaryFromReader);
                msg.addDealershipTeam(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.ViewTeamResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.ViewTeamResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.ViewTeamResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.ViewTeamResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipTeamList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $1oiLe.DealershipUser.serializeBinaryToWriter);
};
/**
 * repeated dealer.DealershipUser dealership_team = 1;
 * @return {!Array<!proto.dealer.DealershipUser>}
 */ proto.dealership_service.ViewTeamResponse.prototype.getDealershipTeamList = function() {
    return /** @type{!Array<!proto.dealer.DealershipUser>} */ $8M67s.Message.getRepeatedWrapperField(this, $1oiLe.DealershipUser, 1);
};
/**
 * @param {!Array<!proto.dealer.DealershipUser>} value
 * @return {!proto.dealership_service.ViewTeamResponse} returns this
*/ proto.dealership_service.ViewTeamResponse.prototype.setDealershipTeamList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.dealer.DealershipUser=} opt_value
 * @param {number=} opt_index
 * @return {!proto.dealer.DealershipUser}
 */ proto.dealership_service.ViewTeamResponse.prototype.addDealershipTeam = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.dealer.DealershipUser, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.dealership_service.ViewTeamResponse} returns this
 */ proto.dealership_service.ViewTeamResponse.prototype.clearDealershipTeamList = function() {
    return this.setDealershipTeamList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.UpdateDealershipUserRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.UpdateDealershipUserRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.UpdateDealershipUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.UpdateDealershipUserRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipUser: (f = msg.getDealershipUser()) && $1oiLe.DealershipUser.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.UpdateDealershipUserRequest}
 */ proto.dealership_service.UpdateDealershipUserRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.UpdateDealershipUserRequest;
    return proto.dealership_service.UpdateDealershipUserRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.UpdateDealershipUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.UpdateDealershipUserRequest}
 */ proto.dealership_service.UpdateDealershipUserRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.DealershipUser;
                reader.readMessage(value, $1oiLe.DealershipUser.deserializeBinaryFromReader);
                msg.setDealershipUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.UpdateDealershipUserRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.UpdateDealershipUserRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.UpdateDealershipUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.UpdateDealershipUserRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipUser();
    if (f != null) writer.writeMessage(1, f, $1oiLe.DealershipUser.serializeBinaryToWriter);
};
/**
 * optional dealer.DealershipUser dealership_user = 1;
 * @return {?proto.dealer.DealershipUser}
 */ proto.dealership_service.UpdateDealershipUserRequest.prototype.getDealershipUser = function() {
    return /** @type{?proto.dealer.DealershipUser} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUser, 1);
};
/**
 * @param {?proto.dealer.DealershipUser|undefined} value
 * @return {!proto.dealership_service.UpdateDealershipUserRequest} returns this
*/ proto.dealership_service.UpdateDealershipUserRequest.prototype.setDealershipUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.UpdateDealershipUserRequest} returns this
 */ proto.dealership_service.UpdateDealershipUserRequest.prototype.clearDealershipUser = function() {
    return this.setDealershipUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.UpdateDealershipUserRequest.prototype.hasDealershipUser = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.UpdateDealershipUserResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.UpdateDealershipUserResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.UpdateDealershipUserResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.UpdateDealershipUserResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipUserId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.UpdateDealershipUserResponse}
 */ proto.dealership_service.UpdateDealershipUserResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.UpdateDealershipUserResponse;
    return proto.dealership_service.UpdateDealershipUserResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.UpdateDealershipUserResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.UpdateDealershipUserResponse}
 */ proto.dealership_service.UpdateDealershipUserResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.UpdateDealershipUserResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.UpdateDealershipUserResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.UpdateDealershipUserResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.UpdateDealershipUserResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipUserId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealership_user_id = 1;
 * @return {string}
 */ proto.dealership_service.UpdateDealershipUserResponse.prototype.getDealershipUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.UpdateDealershipUserResponse} returns this
 */ proto.dealership_service.UpdateDealershipUserResponse.prototype.setDealershipUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.DealershipUserSignaturesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.DealershipUserSignaturesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.DealershipUserSignaturesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerUserId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            tos: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false),
            privacyPolicy: $8M67s.Message.getBooleanFieldWithDefault(msg, 3, false),
            eSignature: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.DealershipUserSignaturesRequest}
 */ proto.dealership_service.DealershipUserSignaturesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.DealershipUserSignaturesRequest;
    return proto.dealership_service.DealershipUserSignaturesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.DealershipUserSignaturesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.DealershipUserSignaturesRequest}
 */ proto.dealership_service.DealershipUserSignaturesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerUserId(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTos(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPrivacyPolicy(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setESignature(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.DealershipUserSignaturesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.DealershipUserSignaturesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.DealershipUserSignaturesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerUserId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTos();
    if (f) writer.writeBool(2, f);
    f = message.getPrivacyPolicy();
    if (f) writer.writeBool(3, f);
    f = message.getESignature();
    if (f) writer.writeBool(4, f);
};
/**
 * optional string dealer_user_id = 1;
 * @return {string}
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.getDealerUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.DealershipUserSignaturesRequest} returns this
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.setDealerUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool tos = 2;
 * @return {boolean}
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.getTos = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealership_service.DealershipUserSignaturesRequest} returns this
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.setTos = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
/**
 * optional bool privacy_policy = 3;
 * @return {boolean}
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.getPrivacyPolicy = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealership_service.DealershipUserSignaturesRequest} returns this
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.setPrivacyPolicy = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 3, value);
};
/**
 * optional bool e_signature = 4;
 * @return {boolean}
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.getESignature = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealership_service.DealershipUserSignaturesRequest} returns this
 */ proto.dealership_service.DealershipUserSignaturesRequest.prototype.setESignature = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.DealershipUserSignaturesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.DealershipUserSignaturesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.DealershipUserSignaturesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.DealershipUserSignaturesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerUserId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.DealershipUserSignaturesResponse}
 */ proto.dealership_service.DealershipUserSignaturesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.DealershipUserSignaturesResponse;
    return proto.dealership_service.DealershipUserSignaturesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.DealershipUserSignaturesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.DealershipUserSignaturesResponse}
 */ proto.dealership_service.DealershipUserSignaturesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.DealershipUserSignaturesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.DealershipUserSignaturesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.DealershipUserSignaturesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.DealershipUserSignaturesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerUserId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealer_user_id = 1;
 * @return {string}
 */ proto.dealership_service.DealershipUserSignaturesResponse.prototype.getDealerUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.DealershipUserSignaturesResponse} returns this
 */ proto.dealership_service.DealershipUserSignaturesResponse.prototype.setDealerUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.UpdateDealershipRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.UpdateDealershipRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.UpdateDealershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.UpdateDealershipRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $1oiLe.Dealership.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.UpdateDealershipRequest}
 */ proto.dealership_service.UpdateDealershipRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.UpdateDealershipRequest;
    return proto.dealership_service.UpdateDealershipRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.UpdateDealershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.UpdateDealershipRequest}
 */ proto.dealership_service.UpdateDealershipRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.Dealership;
                reader.readMessage(value, $1oiLe.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.UpdateDealershipRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.UpdateDealershipRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.UpdateDealershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.UpdateDealershipRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $1oiLe.Dealership.serializeBinaryToWriter);
};
/**
 * optional dealer.Dealership dealership = 1;
 * @return {?proto.dealer.Dealership}
 */ proto.dealership_service.UpdateDealershipRequest.prototype.getDealership = function() {
    return /** @type{?proto.dealer.Dealership} */ $8M67s.Message.getWrapperField(this, $1oiLe.Dealership, 1);
};
/**
 * @param {?proto.dealer.Dealership|undefined} value
 * @return {!proto.dealership_service.UpdateDealershipRequest} returns this
*/ proto.dealership_service.UpdateDealershipRequest.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.UpdateDealershipRequest} returns this
 */ proto.dealership_service.UpdateDealershipRequest.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.UpdateDealershipRequest.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.UpdateDealershipResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.UpdateDealershipResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.UpdateDealershipResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.UpdateDealershipResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.UpdateDealershipResponse}
 */ proto.dealership_service.UpdateDealershipResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.UpdateDealershipResponse;
    return proto.dealership_service.UpdateDealershipResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.UpdateDealershipResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.UpdateDealershipResponse}
 */ proto.dealership_service.UpdateDealershipResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.UpdateDealershipResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.UpdateDealershipResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.UpdateDealershipResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.UpdateDealershipResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealership_id = 1;
 * @return {string}
 */ proto.dealership_service.UpdateDealershipResponse.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.UpdateDealershipResponse} returns this
 */ proto.dealership_service.UpdateDealershipResponse.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetSelfRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetSelfRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetSelfRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetSelfRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetSelfRequest}
 */ proto.dealership_service.GetSelfRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetSelfRequest;
    return proto.dealership_service.GetSelfRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetSelfRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetSelfRequest}
 */ proto.dealership_service.GetSelfRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetSelfRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetSelfRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetSelfRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetSelfRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetSelfResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetSelfResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetSelfResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetSelfResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            user: (f = msg.getUser()) && $1oiLe.DealershipUser.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetSelfResponse}
 */ proto.dealership_service.GetSelfResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetSelfResponse;
    return proto.dealership_service.GetSelfResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetSelfResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetSelfResponse}
 */ proto.dealership_service.GetSelfResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.DealershipUser;
                reader.readMessage(value, $1oiLe.DealershipUser.deserializeBinaryFromReader);
                msg.setUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetSelfResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetSelfResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetSelfResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetSelfResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUser();
    if (f != null) writer.writeMessage(1, f, $1oiLe.DealershipUser.serializeBinaryToWriter);
};
/**
 * optional dealer.DealershipUser user = 1;
 * @return {?proto.dealer.DealershipUser}
 */ proto.dealership_service.GetSelfResponse.prototype.getUser = function() {
    return /** @type{?proto.dealer.DealershipUser} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUser, 1);
};
/**
 * @param {?proto.dealer.DealershipUser|undefined} value
 * @return {!proto.dealership_service.GetSelfResponse} returns this
*/ proto.dealership_service.GetSelfResponse.prototype.setUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.GetSelfResponse} returns this
 */ proto.dealership_service.GetSelfResponse.prototype.clearUser = function() {
    return this.setUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.GetSelfResponse.prototype.hasUser = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetDealershipUserByPhoneRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetDealershipUserByPhoneRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetDealershipUserByPhoneRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealershipUserByPhoneRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetDealershipUserByPhoneRequest}
 */ proto.dealership_service.GetDealershipUserByPhoneRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetDealershipUserByPhoneRequest;
    return proto.dealership_service.GetDealershipUserByPhoneRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetDealershipUserByPhoneRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetDealershipUserByPhoneRequest}
 */ proto.dealership_service.GetDealershipUserByPhoneRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetDealershipUserByPhoneRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetDealershipUserByPhoneRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetDealershipUserByPhoneRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealershipUserByPhoneRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.dealership_service.GetDealershipUserByPhoneRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.GetDealershipUserByPhoneRequest} returns this
 */ proto.dealership_service.GetDealershipUserByPhoneRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetDealershipUserByPhoneResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetDealershipUserByPhoneResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            user: (f = msg.getUser()) && $1oiLe.DealershipUser.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetDealershipUserByPhoneResponse}
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetDealershipUserByPhoneResponse;
    return proto.dealership_service.GetDealershipUserByPhoneResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetDealershipUserByPhoneResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetDealershipUserByPhoneResponse}
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.DealershipUser;
                reader.readMessage(value, $1oiLe.DealershipUser.deserializeBinaryFromReader);
                msg.setUser(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetDealershipUserByPhoneResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetDealershipUserByPhoneResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUser();
    if (f != null) writer.writeMessage(1, f, $1oiLe.DealershipUser.serializeBinaryToWriter);
};
/**
 * optional dealer.DealershipUser user = 1;
 * @return {?proto.dealer.DealershipUser}
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.prototype.getUser = function() {
    return /** @type{?proto.dealer.DealershipUser} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUser, 1);
};
/**
 * @param {?proto.dealer.DealershipUser|undefined} value
 * @return {!proto.dealership_service.GetDealershipUserByPhoneResponse} returns this
*/ proto.dealership_service.GetDealershipUserByPhoneResponse.prototype.setUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.GetDealershipUserByPhoneResponse} returns this
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.prototype.clearUser = function() {
    return this.setUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.GetDealershipUserByPhoneResponse.prototype.hasUser = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetDealershipInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetDealershipInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetDealershipInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealershipInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetDealershipInfoRequest}
 */ proto.dealership_service.GetDealershipInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetDealershipInfoRequest;
    return proto.dealership_service.GetDealershipInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetDealershipInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetDealershipInfoRequest}
 */ proto.dealership_service.GetDealershipInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetDealershipInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetDealershipInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetDealershipInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealershipInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealership_id = 1;
 * @return {string}
 */ proto.dealership_service.GetDealershipInfoRequest.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.GetDealershipInfoRequest} returns this
 */ proto.dealership_service.GetDealershipInfoRequest.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.dealership_service.GetDealershipInfoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.dealership_service.GetDealershipInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealershipInfoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            error: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            dealership: (f = msg.getDealership()) && $3QqPt.Dealership.toObject(includeInstance, f),
            errorCode: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.dealership_service.GetDealershipInfoResponse}
 */ proto.dealership_service.GetDealershipInfoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.dealership_service.GetDealershipInfoResponse;
    return proto.dealership_service.GetDealershipInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.dealership_service.GetDealershipInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.dealership_service.GetDealershipInfoResponse}
 */ proto.dealership_service.GetDealershipInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setError(value);
                break;
            case 3:
                var value = new $3QqPt.Dealership;
                reader.readMessage(value, $3QqPt.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setErrorCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.dealership_service.GetDealershipInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.dealership_service.GetDealershipInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.dealership_service.GetDealershipInfoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getError();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDealership();
    if (f != null) writer.writeMessage(3, f, $3QqPt.Dealership.serializeBinaryToWriter);
    f = message.getErrorCode();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.dealership_service.GetDealershipInfoResponse} returns this
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string error = 2;
 * @return {string}
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.getError = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.dealership_service.GetDealershipInfoResponse} returns this
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.setError = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional domain.Dealership dealership = 3;
 * @return {?proto.domain.Dealership}
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.getDealership = function() {
    return /** @type{?proto.domain.Dealership} */ $8M67s.Message.getWrapperField(this, $3QqPt.Dealership, 3);
};
/**
 * @param {?proto.domain.Dealership|undefined} value
 * @return {!proto.dealership_service.GetDealershipInfoResponse} returns this
*/ proto.dealership_service.GetDealershipInfoResponse.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.dealership_service.GetDealershipInfoResponse} returns this
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional int32 error_code = 4;
 * @return {number}
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.getErrorCode = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.dealership_service.GetDealershipInfoResponse} returns this
 */ proto.dealership_service.GetDealershipInfoResponse.prototype.setErrorCode = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
$9f3f46f9bf15a2d9$var$goog.object.extend(module.exports, proto.dealership_service);

});

parcelRegister("3EyMN", function(module, exports) {
// source: fleet_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $2a9017512e0f7864$var$goog = $8M67s;
var $2a9017512e0f7864$var$global = Function('return this')();

var $9YICB = parcelRequire("9YICB");
$2a9017512e0f7864$var$goog.object.extend(proto, $9YICB);

var $3QqPt = parcelRequire("3QqPt");
$2a9017512e0f7864$var$goog.object.extend(proto, $3QqPt);

var $kpGLk = parcelRequire("kpGLk");
$2a9017512e0f7864$var$goog.object.extend(proto, $kpGLk);

var $gjhG2 = parcelRequire("gjhG2");
$2a9017512e0f7864$var$goog.object.extend(proto, $gjhG2);

var $1oiLe = parcelRequire("1oiLe");
$2a9017512e0f7864$var$goog.object.extend(proto, $1oiLe);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.AddInspectionPhotosRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.AddInspectionPhotosResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.AddVehicleRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.AddVehicleResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.AddVehiclesRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.AddVehiclesResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.AssignVehicleRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.AssignVehicleResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ConfirmVehicleRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ConfirmVehicleRequest.ColorName', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ConfirmVehicleRequest.ColorOptions', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ConfirmVehicleRequest.Type', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ConfirmVehicleRequest.VehicleModel', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ConfirmVehicleResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ConfirmVehicleResponse.ColorAssigned', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.CreateInspectionReportRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.CreateInspectionReportResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.DealershipCriteria', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.DeleteDocumentRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.DeleteDocumentResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.DeleteMilesPurchasedLogRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.DeleteMilesPurchasedLogResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.DeleteVehicleMediaRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.DeleteVehicleMediaResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetAvailableModelsRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetAvailableModelsResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetAvailableTrimsRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetAvailableTrimsResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetDealershipRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetDealershipResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetInspectionPhotosRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetInspectionPhotosResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetInspectionSignatureWriteURLRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetInspectionSignatureWriteURLResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetLatestCustodyRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetLatestCustodyRequest.CustodyType', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetLatestCustodyResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetLatestCustodyResponse.CustodianCase', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetMileageRatesRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetMileageRatesResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetOwnBuyItNowDetailsRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetOwnBuyItNowDetailsResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetPrePaidMileageRateRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetPrePaidMileageRateResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetPresignedWritePhotoURLRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetPresignedWritePhotoURLResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetSubscriptionMileagePurchasesRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetSubscriptionMileagePurchasesResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetSubscriptionMileageRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetSubscriptionMileageResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleByIdRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleByIdResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleByVinRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleByVinResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleInfleetingRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleInfleetingRequest.InfleetingRequestType', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleInfleetingResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleInspectionResultsRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleMediaRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleMediaResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.GetVehicleResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.HandleTelemetricEventResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.IngestVehiclesRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.IngestVehiclesResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.InitiateVehicleReturnRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.InitiateVehicleReturnResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.InspectionPhoto', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.InspectionReport', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListAllVehiclesRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListAllVehiclesResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListDealershipsRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListDealershipsResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListInspectionReportsQuery', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListInspectionReportsRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListInspectionReportsResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListInspectionReportsToken', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListModelsByMakeRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListModelsByMakeResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListOrdersRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListOrdersRequest.OrderState', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListOrdersResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListProfilesRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListProfilesResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListVehicleMakesRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListVehicleMakesResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListVehiclePickupsQuery', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListVehiclePickupsRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListVehiclePickupsResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListVehiclePickupsToken', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListVehiclesRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ListVehiclesResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.LogMilesPurchasedRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.LogMilesPurchasedResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.MatsStatus', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.MileageDrivenInMonth', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.MileagePurchase', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.NexusVehicle', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.NexusVehicle.Status', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.OrderCriteria', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.OrderCriteria.Direction', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.PhotoArea', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.PickupDetails', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.PrepaidExtraMileage', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.Priority', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.RecordMileageDrivenLogRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.RecordMileageDrivenLogResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ReturnAndPickupVehicleRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ReturnAndPickupVehicleResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ReturnDetails', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ReturnVehicleRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ReturnVehicleResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.Row', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.SignInspectionReportRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.SignInspectionReportResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.SignaturePhoto', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.StartVehicleInspectionRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.StartVehicleInspectionResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.StatusGroup', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.StatusGroup.GroupStatus', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.Table', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.TelemetricEvent', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UnassignVehicleRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UnassignVehicleResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateStateToInListingRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateStateToInListingResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateStateToInProcessRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateStateToInProcessResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateStateToSoldRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateStateToSoldResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateStateToTotalLossRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateStateToTotalLossResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateVehicleCustodyRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateVehicleCustodyResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateVehicleInfleetingRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateVehicleInfleetingResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateVehicleRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpdateVehicleResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpsertVehicleMediaRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.UpsertVehicleMediaResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ValidateVinRequest', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.ValidateVinResponse', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.Vehicle', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.VehicleCriteria', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.VehicleMedia', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.VehicleOrder', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.VehiclePickup', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.VehicleProperty', null, $2a9017512e0f7864$var$global);
$2a9017512e0f7864$var$goog.exportSymbol('proto.fleet_service.VehicleProperty.PropertyCase', null, $2a9017512e0f7864$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.Vehicle = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.Vehicle, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.Vehicle.displayName = 'proto.fleet_service.Vehicle';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.IngestVehiclesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.IngestVehiclesRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.IngestVehiclesRequest.displayName = 'proto.fleet_service.IngestVehiclesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.IngestVehiclesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.IngestVehiclesResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.IngestVehiclesResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.IngestVehiclesResponse.displayName = 'proto.fleet_service.IngestVehiclesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.Row = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.Row.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.Row, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.Row.displayName = 'proto.fleet_service.Row';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.Table = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.Table.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.Table, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.Table.displayName = 'proto.fleet_service.Table';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.InitiateVehicleReturnRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.InitiateVehicleReturnRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.InitiateVehicleReturnRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.InitiateVehicleReturnRequest.displayName = 'proto.fleet_service.InitiateVehicleReturnRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.InitiateVehicleReturnResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.InitiateVehicleReturnResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.InitiateVehicleReturnResponse.displayName = 'proto.fleet_service.InitiateVehicleReturnResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ReturnVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ReturnVehicleRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ReturnVehicleRequest.displayName = 'proto.fleet_service.ReturnVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ReturnVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ReturnVehicleResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ReturnVehicleResponse.displayName = 'proto.fleet_service.ReturnVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ReturnAndPickupVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ReturnAndPickupVehicleRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ReturnAndPickupVehicleRequest.displayName = 'proto.fleet_service.ReturnAndPickupVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ReturnAndPickupVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ReturnAndPickupVehicleResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ReturnAndPickupVehicleResponse.displayName = 'proto.fleet_service.ReturnAndPickupVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ReturnDetails = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ReturnDetails, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ReturnDetails.displayName = 'proto.fleet_service.ReturnDetails';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.PickupDetails = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.PickupDetails, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.PickupDetails.displayName = 'proto.fleet_service.PickupDetails';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.InspectionPhoto = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.InspectionPhoto, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.InspectionPhoto.displayName = 'proto.fleet_service.InspectionPhoto';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.SignaturePhoto = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.SignaturePhoto, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.SignaturePhoto.displayName = 'proto.fleet_service.SignaturePhoto';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.InspectionReport = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.InspectionReport, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.InspectionReport.displayName = 'proto.fleet_service.InspectionReport';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.CreateInspectionReportRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.CreateInspectionReportRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.CreateInspectionReportRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.CreateInspectionReportRequest.displayName = 'proto.fleet_service.CreateInspectionReportRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.CreateInspectionReportResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.CreateInspectionReportResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.CreateInspectionReportResponse.displayName = 'proto.fleet_service.CreateInspectionReportResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.SignInspectionReportRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.SignInspectionReportRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.SignInspectionReportRequest.displayName = 'proto.fleet_service.SignInspectionReportRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.SignInspectionReportResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.SignInspectionReportResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.SignInspectionReportResponse.displayName = 'proto.fleet_service.SignInspectionReportResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.AddInspectionPhotosRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.AddInspectionPhotosRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.AddInspectionPhotosRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.AddInspectionPhotosRequest.displayName = 'proto.fleet_service.AddInspectionPhotosRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.AddInspectionPhotosResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.AddInspectionPhotosResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.AddInspectionPhotosResponse.displayName = 'proto.fleet_service.AddInspectionPhotosResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetInspectionPhotosRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetInspectionPhotosRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetInspectionPhotosRequest.displayName = 'proto.fleet_service.GetInspectionPhotosRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetInspectionPhotosResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.GetInspectionPhotosResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetInspectionPhotosResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetInspectionPhotosResponse.displayName = 'proto.fleet_service.GetInspectionPhotosResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetPresignedWritePhotoURLRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetPresignedWritePhotoURLRequest.displayName = 'proto.fleet_service.GetPresignedWritePhotoURLRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetPresignedWritePhotoURLResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetPresignedWritePhotoURLResponse.displayName = 'proto.fleet_service.GetPresignedWritePhotoURLResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetInspectionSignatureWriteURLRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.displayName = 'proto.fleet_service.GetInspectionSignatureWriteURLRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetInspectionSignatureWriteURLResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.displayName = 'proto.fleet_service.GetInspectionSignatureWriteURLResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetSubscriptionMileageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetSubscriptionMileageRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetSubscriptionMileageRequest.displayName = 'proto.fleet_service.GetSubscriptionMileageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.MileageDrivenInMonth = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.MileageDrivenInMonth, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.MileageDrivenInMonth.displayName = 'proto.fleet_service.MileageDrivenInMonth';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.PrepaidExtraMileage = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.PrepaidExtraMileage, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.PrepaidExtraMileage.displayName = 'proto.fleet_service.PrepaidExtraMileage';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetSubscriptionMileageResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.GetSubscriptionMileageResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetSubscriptionMileageResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetSubscriptionMileageResponse.displayName = 'proto.fleet_service.GetSubscriptionMileageResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetSubscriptionMileagePurchasesRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.displayName = 'proto.fleet_service.GetSubscriptionMileagePurchasesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.MileagePurchase = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.MileagePurchase, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.MileagePurchase.displayName = 'proto.fleet_service.MileagePurchase';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.GetSubscriptionMileagePurchasesResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetSubscriptionMileagePurchasesResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.displayName = 'proto.fleet_service.GetSubscriptionMileagePurchasesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetPrePaidMileageRateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetPrePaidMileageRateRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetPrePaidMileageRateRequest.displayName = 'proto.fleet_service.GetPrePaidMileageRateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetPrePaidMileageRateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetPrePaidMileageRateResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetPrePaidMileageRateResponse.displayName = 'proto.fleet_service.GetPrePaidMileageRateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetMileageRatesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetMileageRatesRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetMileageRatesRequest.displayName = 'proto.fleet_service.GetMileageRatesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetMileageRatesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetMileageRatesResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetMileageRatesResponse.displayName = 'proto.fleet_service.GetMileageRatesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.StatusGroup = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.StatusGroup.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.StatusGroup, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.StatusGroup.displayName = 'proto.fleet_service.StatusGroup';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.AssignVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.AssignVehicleRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.AssignVehicleRequest.displayName = 'proto.fleet_service.AssignVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.AssignVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.AssignVehicleResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.AssignVehicleResponse.displayName = 'proto.fleet_service.AssignVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UnassignVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UnassignVehicleRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UnassignVehicleRequest.displayName = 'proto.fleet_service.UnassignVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UnassignVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UnassignVehicleResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UnassignVehicleResponse.displayName = 'proto.fleet_service.UnassignVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListOrdersRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListOrdersRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListOrdersRequest.displayName = 'proto.fleet_service.ListOrdersRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListOrdersResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListOrdersResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListOrdersResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListOrdersResponse.displayName = 'proto.fleet_service.ListOrdersResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.VehicleOrder = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.VehicleOrder, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.VehicleOrder.displayName = 'proto.fleet_service.VehicleOrder';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.AddVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.AddVehicleRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.AddVehicleRequest.displayName = 'proto.fleet_service.AddVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.AddVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.AddVehicleResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.AddVehicleResponse.displayName = 'proto.fleet_service.AddVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.AddVehiclesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.AddVehiclesRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.AddVehiclesRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.AddVehiclesRequest.displayName = 'proto.fleet_service.AddVehiclesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.AddVehiclesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.AddVehiclesResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.AddVehiclesResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.AddVehiclesResponse.displayName = 'proto.fleet_service.AddVehiclesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.VehicleCriteria = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.VehicleCriteria, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.VehicleCriteria.displayName = 'proto.fleet_service.VehicleCriteria';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListVehiclesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListVehiclesRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListVehiclesRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListVehiclesRequest.displayName = 'proto.fleet_service.ListVehiclesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListAllVehiclesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListAllVehiclesRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListAllVehiclesRequest.displayName = 'proto.fleet_service.ListAllVehiclesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListAllVehiclesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListAllVehiclesResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListAllVehiclesResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListAllVehiclesResponse.displayName = 'proto.fleet_service.ListAllVehiclesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListVehicleMakesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListVehicleMakesRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListVehicleMakesRequest.displayName = 'proto.fleet_service.ListVehicleMakesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListVehicleMakesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListVehicleMakesResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListVehicleMakesResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListVehicleMakesResponse.displayName = 'proto.fleet_service.ListVehicleMakesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListModelsByMakeRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListModelsByMakeRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListModelsByMakeRequest.displayName = 'proto.fleet_service.ListModelsByMakeRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListModelsByMakeResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListModelsByMakeResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListModelsByMakeResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListModelsByMakeResponse.displayName = 'proto.fleet_service.ListModelsByMakeResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.OrderCriteria = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.OrderCriteria, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.OrderCriteria.displayName = 'proto.fleet_service.OrderCriteria';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.NexusVehicle = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.NexusVehicle.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.NexusVehicle, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.NexusVehicle.displayName = 'proto.fleet_service.NexusVehicle';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListVehiclesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListVehiclesResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListVehiclesResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListVehiclesResponse.displayName = 'proto.fleet_service.ListVehiclesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetOwnBuyItNowDetailsRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.displayName = 'proto.fleet_service.GetOwnBuyItNowDetailsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetOwnBuyItNowDetailsResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.displayName = 'proto.fleet_service.GetOwnBuyItNowDetailsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleRequest.displayName = 'proto.fleet_service.GetVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleResponse.displayName = 'proto.fleet_service.GetVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleByIdRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleByIdRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleByIdRequest.displayName = 'proto.fleet_service.GetVehicleByIdRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleByIdResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleByIdResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleByIdResponse.displayName = 'proto.fleet_service.GetVehicleByIdResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleByVinRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleByVinRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleByVinRequest.displayName = 'proto.fleet_service.GetVehicleByVinRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleByVinResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleByVinResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleByVinResponse.displayName = 'proto.fleet_service.GetVehicleByVinResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.TelemetricEvent = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.TelemetricEvent, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.TelemetricEvent.displayName = 'proto.fleet_service.TelemetricEvent';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.HandleTelemetricEventResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.HandleTelemetricEventResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.HandleTelemetricEventResponse.displayName = 'proto.fleet_service.HandleTelemetricEventResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.DeleteDocumentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.DeleteDocumentRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.DeleteDocumentRequest.displayName = 'proto.fleet_service.DeleteDocumentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.DeleteDocumentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.DeleteDocumentResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.DeleteDocumentResponse.displayName = 'proto.fleet_service.DeleteDocumentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ConfirmVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ConfirmVehicleRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ConfirmVehicleRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ConfirmVehicleRequest.displayName = 'proto.fleet_service.ConfirmVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ConfirmVehicleRequest.ColorOptions, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.displayName = 'proto.fleet_service.ConfirmVehicleRequest.ColorOptions';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ConfirmVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ConfirmVehicleResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ConfirmVehicleResponse.displayName = 'proto.fleet_service.ConfirmVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListProfilesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListProfilesRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListProfilesRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListProfilesRequest.displayName = 'proto.fleet_service.ListProfilesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListProfilesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListProfilesResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListProfilesResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListProfilesResponse.displayName = 'proto.fleet_service.ListProfilesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.VehicleProperty = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.fleet_service.VehicleProperty.oneofGroups_);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.VehicleProperty, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.VehicleProperty.displayName = 'proto.fleet_service.VehicleProperty';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.UpdateVehicleRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateVehicleRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateVehicleRequest.displayName = 'proto.fleet_service.UpdateVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateVehicleResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateVehicleResponse.displayName = 'proto.fleet_service.UpdateVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListDealershipsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListDealershipsRequest.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListDealershipsRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListDealershipsRequest.displayName = 'proto.fleet_service.ListDealershipsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListDealershipsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListDealershipsResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListDealershipsResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListDealershipsResponse.displayName = 'proto.fleet_service.ListDealershipsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetDealershipRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetDealershipRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetDealershipRequest.displayName = 'proto.fleet_service.GetDealershipRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetDealershipResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetDealershipResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetDealershipResponse.displayName = 'proto.fleet_service.GetDealershipResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.DealershipCriteria = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.DealershipCriteria, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.DealershipCriteria.displayName = 'proto.fleet_service.DealershipCriteria';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.StartVehicleInspectionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.StartVehicleInspectionRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.StartVehicleInspectionRequest.displayName = 'proto.fleet_service.StartVehicleInspectionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.StartVehicleInspectionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.StartVehicleInspectionResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.StartVehicleInspectionResponse.displayName = 'proto.fleet_service.StartVehicleInspectionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleInspectionResultsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleInspectionResultsRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleInspectionResultsRequest.displayName = 'proto.fleet_service.GetVehicleInspectionResultsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetAvailableModelsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetAvailableModelsRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetAvailableModelsRequest.displayName = 'proto.fleet_service.GetAvailableModelsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetAvailableModelsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.GetAvailableModelsResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetAvailableModelsResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetAvailableModelsResponse.displayName = 'proto.fleet_service.GetAvailableModelsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetAvailableTrimsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetAvailableTrimsRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetAvailableTrimsRequest.displayName = 'proto.fleet_service.GetAvailableTrimsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetAvailableTrimsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.GetAvailableTrimsResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetAvailableTrimsResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetAvailableTrimsResponse.displayName = 'proto.fleet_service.GetAvailableTrimsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ValidateVinRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ValidateVinRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ValidateVinRequest.displayName = 'proto.fleet_service.ValidateVinRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ValidateVinResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ValidateVinResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ValidateVinResponse.displayName = 'proto.fleet_service.ValidateVinResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateVehicleCustodyRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateVehicleCustodyRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateVehicleCustodyRequest.displayName = 'proto.fleet_service.UpdateVehicleCustodyRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateVehicleCustodyResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateVehicleCustodyResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateVehicleCustodyResponse.displayName = 'proto.fleet_service.UpdateVehicleCustodyResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetLatestCustodyRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetLatestCustodyRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetLatestCustodyRequest.displayName = 'proto.fleet_service.GetLatestCustodyRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetLatestCustodyResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.fleet_service.GetLatestCustodyResponse.oneofGroups_);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetLatestCustodyResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetLatestCustodyResponse.displayName = 'proto.fleet_service.GetLatestCustodyResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleInfleetingRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleInfleetingRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleInfleetingRequest.displayName = 'proto.fleet_service.GetVehicleInfleetingRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleInfleetingResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.GetVehicleInfleetingResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleInfleetingResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleInfleetingResponse.displayName = 'proto.fleet_service.GetVehicleInfleetingResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateVehicleInfleetingRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateVehicleInfleetingRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateVehicleInfleetingRequest.displayName = 'proto.fleet_service.UpdateVehicleInfleetingRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateVehicleInfleetingResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateVehicleInfleetingResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateVehicleInfleetingResponse.displayName = 'proto.fleet_service.UpdateVehicleInfleetingResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.RecordMileageDrivenLogRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.RecordMileageDrivenLogRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.RecordMileageDrivenLogRequest.displayName = 'proto.fleet_service.RecordMileageDrivenLogRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.RecordMileageDrivenLogResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.RecordMileageDrivenLogResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.RecordMileageDrivenLogResponse.displayName = 'proto.fleet_service.RecordMileageDrivenLogResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.VehiclePickup = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.VehiclePickup, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.VehiclePickup.displayName = 'proto.fleet_service.VehiclePickup';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListVehiclePickupsQuery = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListVehiclePickupsQuery.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListVehiclePickupsQuery, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListVehiclePickupsQuery.displayName = 'proto.fleet_service.ListVehiclePickupsQuery';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListVehiclePickupsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListVehiclePickupsRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListVehiclePickupsRequest.displayName = 'proto.fleet_service.ListVehiclePickupsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListVehiclePickupsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListVehiclePickupsResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListVehiclePickupsResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListVehiclePickupsResponse.displayName = 'proto.fleet_service.ListVehiclePickupsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListVehiclePickupsToken = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListVehiclePickupsToken, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListVehiclePickupsToken.displayName = 'proto.fleet_service.ListVehiclePickupsToken';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListInspectionReportsQuery = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListInspectionReportsQuery, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListInspectionReportsQuery.displayName = 'proto.fleet_service.ListInspectionReportsQuery';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListInspectionReportsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListInspectionReportsRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListInspectionReportsRequest.displayName = 'proto.fleet_service.ListInspectionReportsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListInspectionReportsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.ListInspectionReportsResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListInspectionReportsResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListInspectionReportsResponse.displayName = 'proto.fleet_service.ListInspectionReportsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.ListInspectionReportsToken = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.ListInspectionReportsToken, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.ListInspectionReportsToken.displayName = 'proto.fleet_service.ListInspectionReportsToken';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateStateToInListingRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateStateToInListingRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateStateToInListingRequest.displayName = 'proto.fleet_service.UpdateStateToInListingRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateStateToInListingResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateStateToInListingResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateStateToInListingResponse.displayName = 'proto.fleet_service.UpdateStateToInListingResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateStateToInProcessRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateStateToInProcessRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateStateToInProcessRequest.displayName = 'proto.fleet_service.UpdateStateToInProcessRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateStateToInProcessResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateStateToInProcessResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateStateToInProcessResponse.displayName = 'proto.fleet_service.UpdateStateToInProcessResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateStateToSoldRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateStateToSoldRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateStateToSoldRequest.displayName = 'proto.fleet_service.UpdateStateToSoldRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateStateToSoldResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateStateToSoldResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateStateToSoldResponse.displayName = 'proto.fleet_service.UpdateStateToSoldResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateStateToTotalLossRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateStateToTotalLossRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateStateToTotalLossRequest.displayName = 'proto.fleet_service.UpdateStateToTotalLossRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpdateStateToTotalLossResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpdateStateToTotalLossResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpdateStateToTotalLossResponse.displayName = 'proto.fleet_service.UpdateStateToTotalLossResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.LogMilesPurchasedRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.LogMilesPurchasedRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.LogMilesPurchasedRequest.displayName = 'proto.fleet_service.LogMilesPurchasedRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.LogMilesPurchasedResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.LogMilesPurchasedResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.LogMilesPurchasedResponse.displayName = 'proto.fleet_service.LogMilesPurchasedResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.DeleteMilesPurchasedLogRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.DeleteMilesPurchasedLogRequest.displayName = 'proto.fleet_service.DeleteMilesPurchasedLogRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.DeleteMilesPurchasedLogResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.DeleteMilesPurchasedLogResponse.displayName = 'proto.fleet_service.DeleteMilesPurchasedLogResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleMediaRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleMediaRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleMediaRequest.displayName = 'proto.fleet_service.GetVehicleMediaRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.VehicleMedia = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.VehicleMedia, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.VehicleMedia.displayName = 'proto.fleet_service.VehicleMedia';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.GetVehicleMediaResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.fleet_service.GetVehicleMediaResponse.repeatedFields_, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.GetVehicleMediaResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.GetVehicleMediaResponse.displayName = 'proto.fleet_service.GetVehicleMediaResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpsertVehicleMediaRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpsertVehicleMediaRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpsertVehicleMediaRequest.displayName = 'proto.fleet_service.UpsertVehicleMediaRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.UpsertVehicleMediaResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.UpsertVehicleMediaResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.UpsertVehicleMediaResponse.displayName = 'proto.fleet_service.UpsertVehicleMediaResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.DeleteVehicleMediaRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.DeleteVehicleMediaRequest, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.DeleteVehicleMediaRequest.displayName = 'proto.fleet_service.DeleteVehicleMediaRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.fleet_service.DeleteVehicleMediaResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a9017512e0f7864$var$goog.inherits(proto.fleet_service.DeleteVehicleMediaResponse, $8M67s.Message);
if ($2a9017512e0f7864$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.fleet_service.DeleteVehicleMediaResponse.displayName = 'proto.fleet_service.DeleteVehicleMediaResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.Vehicle.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.Vehicle.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.Vehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.Vehicle.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            financier: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            interiorColor: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            exteriorColor: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            state: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            additionalDetails: $8M67s.Message.getFieldWithDefault(msg, 13, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.Vehicle}
 */ proto.fleet_service.Vehicle.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.Vehicle;
    return proto.fleet_service.Vehicle.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.Vehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.Vehicle}
 */ proto.fleet_service.Vehicle.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setFinancier(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setInteriorColor(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setExteriorColor(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setState(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setAdditionalDetails(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.Vehicle.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.Vehicle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.Vehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.Vehicle.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getFinancier();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getInteriorColor();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getExteriorColor();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getState();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getAdditionalDetails();
    if (f.length > 0) writer.writeString(13, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string make = 3;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string model = 4;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string year = 5;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string trim = 6;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string financier = 7;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getFinancier = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setFinancier = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string interior_color = 8;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getInteriorColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setInteriorColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string exterior_color = 9;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getExteriorColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setExteriorColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string state = 10;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getState = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setState = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string customer_id = 11;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string program_id = 12;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string additional_details = 13;
 * @return {string}
 */ proto.fleet_service.Vehicle.prototype.getAdditionalDetails = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Vehicle} returns this
 */ proto.fleet_service.Vehicle.prototype.setAdditionalDetails = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.IngestVehiclesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.IngestVehiclesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.IngestVehiclesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.IngestVehiclesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            table: (f = msg.getTable()) && proto.fleet_service.Table.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.IngestVehiclesRequest}
 */ proto.fleet_service.IngestVehiclesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.IngestVehiclesRequest;
    return proto.fleet_service.IngestVehiclesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.IngestVehiclesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.IngestVehiclesRequest}
 */ proto.fleet_service.IngestVehiclesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.Table;
                reader.readMessage(value, proto.fleet_service.Table.deserializeBinaryFromReader);
                msg.setTable(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.IngestVehiclesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.IngestVehiclesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.IngestVehiclesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.IngestVehiclesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTable();
    if (f != null) writer.writeMessage(1, f, proto.fleet_service.Table.serializeBinaryToWriter);
};
/**
 * optional Table table = 1;
 * @return {?proto.fleet_service.Table}
 */ proto.fleet_service.IngestVehiclesRequest.prototype.getTable = function() {
    return /** @type{?proto.fleet_service.Table} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.Table, 1);
};
/**
 * @param {?proto.fleet_service.Table|undefined} value
 * @return {!proto.fleet_service.IngestVehiclesRequest} returns this
*/ proto.fleet_service.IngestVehiclesRequest.prototype.setTable = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.IngestVehiclesRequest} returns this
 */ proto.fleet_service.IngestVehiclesRequest.prototype.clearTable = function() {
    return this.setTable(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.IngestVehiclesRequest.prototype.hasTable = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.IngestVehiclesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.IngestVehiclesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.IngestVehiclesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.IngestVehiclesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.IngestVehiclesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            successfulVinsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.IngestVehiclesResponse}
 */ proto.fleet_service.IngestVehiclesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.IngestVehiclesResponse;
    return proto.fleet_service.IngestVehiclesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.IngestVehiclesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.IngestVehiclesResponse}
 */ proto.fleet_service.IngestVehiclesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addSuccessfulVins(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.IngestVehiclesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.IngestVehiclesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.IngestVehiclesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.IngestVehiclesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccessfulVinsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string successful_vins = 1;
 * @return {!Array<string>}
 */ proto.fleet_service.IngestVehiclesResponse.prototype.getSuccessfulVinsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.IngestVehiclesResponse} returns this
 */ proto.fleet_service.IngestVehiclesResponse.prototype.setSuccessfulVinsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.IngestVehiclesResponse} returns this
 */ proto.fleet_service.IngestVehiclesResponse.prototype.addSuccessfulVins = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.IngestVehiclesResponse} returns this
 */ proto.fleet_service.IngestVehiclesResponse.prototype.clearSuccessfulVinsList = function() {
    return this.setSuccessfulVinsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.Row.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.Row.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.Row.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.Row} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.Row.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            valuesList: (f = $8M67s.Message.getRepeatedField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.Row}
 */ proto.fleet_service.Row.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.Row;
    return proto.fleet_service.Row.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.Row} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.Row}
 */ proto.fleet_service.Row.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.addValues(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.Row.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.Row.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.Row} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.Row.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getValuesList();
    if (f.length > 0) writer.writeRepeatedString(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.Row.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.Row} returns this
 */ proto.fleet_service.Row.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated string values = 2;
 * @return {!Array<string>}
 */ proto.fleet_service.Row.prototype.getValuesList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.Row} returns this
 */ proto.fleet_service.Row.prototype.setValuesList = function(value) {
    return $8M67s.Message.setField(this, 2, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.Row} returns this
 */ proto.fleet_service.Row.prototype.addValues = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.Row} returns this
 */ proto.fleet_service.Row.prototype.clearValuesList = function() {
    return this.setValuesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.Table.repeatedFields_ = [
    1,
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.Table.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.Table.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.Table} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.Table.toObject = function(includeInstance, msg) {
        var f, obj = {
            columnsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            rowsList: $8M67s.Message.toObjectList(msg.getRowsList(), proto.fleet_service.Row.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.Table}
 */ proto.fleet_service.Table.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.Table;
    return proto.fleet_service.Table.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.Table} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.Table}
 */ proto.fleet_service.Table.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addColumns(value);
                break;
            case 2:
                var value = new proto.fleet_service.Row;
                reader.readMessage(value, proto.fleet_service.Row.deserializeBinaryFromReader);
                msg.addRows(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.Table.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.Table.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.Table} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.Table.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getColumnsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
    f = message.getRowsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.fleet_service.Row.serializeBinaryToWriter);
};
/**
 * repeated string columns = 1;
 * @return {!Array<string>}
 */ proto.fleet_service.Table.prototype.getColumnsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.Table} returns this
 */ proto.fleet_service.Table.prototype.setColumnsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.Table} returns this
 */ proto.fleet_service.Table.prototype.addColumns = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.Table} returns this
 */ proto.fleet_service.Table.prototype.clearColumnsList = function() {
    return this.setColumnsList([]);
};
/**
 * repeated Row rows = 2;
 * @return {!Array<!proto.fleet_service.Row>}
 */ proto.fleet_service.Table.prototype.getRowsList = function() {
    return /** @type{!Array<!proto.fleet_service.Row>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.Row, 2);
};
/**
 * @param {!Array<!proto.fleet_service.Row>} value
 * @return {!proto.fleet_service.Table} returns this
*/ proto.fleet_service.Table.prototype.setRowsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.fleet_service.Row=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.Row}
 */ proto.fleet_service.Table.prototype.addRows = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet_service.Row, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.Table} returns this
 */ proto.fleet_service.Table.prototype.clearRowsList = function() {
    return this.setRowsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.InitiateVehicleReturnRequest.repeatedFields_ = [
    6,
    7
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.InitiateVehicleReturnRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.InitiateVehicleReturnRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.InitiateVehicleReturnRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            odometer: (f = msg.getOdometer()) && $9YICB.Odometer.toObject(includeInstance, f),
            location: (f = msg.getLocation()) && $9YICB.Location.toObject(includeInstance, f),
            imagesList: $8M67s.Message.toObjectList(msg.getImagesList(), $3QqPt.Image.toObject, includeInstance),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), $kpGLk.ReturnLineItem.toObject, includeInstance),
            miscellaneousMap: (f = msg.getMiscellaneousMap()) ? f.toObject(includeInstance, undefined) : [],
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            returnTime: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            missingAssetsAmount: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            initialDamagesAmount: $8M67s.Message.getFieldWithDefault(msg, 12, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest}
 */ proto.fleet_service.InitiateVehicleReturnRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.InitiateVehicleReturnRequest;
    return proto.fleet_service.InitiateVehicleReturnRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.InitiateVehicleReturnRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest}
 */ proto.fleet_service.InitiateVehicleReturnRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = new $9YICB.Odometer;
                reader.readMessage(value, $9YICB.Odometer.deserializeBinaryFromReader);
                msg.setOdometer(value);
                break;
            case 5:
                var value = new $9YICB.Location;
                reader.readMessage(value, $9YICB.Location.deserializeBinaryFromReader);
                msg.setLocation(value);
                break;
            case 6:
                var value = new $3QqPt.Image;
                reader.readMessage(value, $3QqPt.Image.deserializeBinaryFromReader);
                msg.addImages(value);
                break;
            case 7:
                var value = new $kpGLk.ReturnLineItem;
                reader.readMessage(value, $kpGLk.ReturnLineItem.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            case 8:
                var value = msg.getMiscellaneousMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readString, null, "", "");
                });
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setReturnTime(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMissingAssetsAmount(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInitialDamagesAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.InitiateVehicleReturnRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.InitiateVehicleReturnRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.InitiateVehicleReturnRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getOdometer();
    if (f != null) writer.writeMessage(4, f, $9YICB.Odometer.serializeBinaryToWriter);
    f = message.getLocation();
    if (f != null) writer.writeMessage(5, f, $9YICB.Location.serializeBinaryToWriter);
    f = message.getImagesList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, $3QqPt.Image.serializeBinaryToWriter);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, $kpGLk.ReturnLineItem.serializeBinaryToWriter);
    f = message.getMiscellaneousMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(8, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeString);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getReturnTime();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getMissingAssetsAmount();
    if (f !== 0) writer.writeInt32(11, f);
    f = message.getInitialDamagesAmount();
    if (f !== 0) writer.writeInt32(12, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional vehicle.Odometer odometer = 4;
 * @return {?proto.vehicle.Odometer}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getOdometer = function() {
    return /** @type{?proto.vehicle.Odometer} */ $8M67s.Message.getWrapperField(this, $9YICB.Odometer, 4);
};
/**
 * @param {?proto.vehicle.Odometer|undefined} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
*/ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setOdometer = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.clearOdometer = function() {
    return this.setOdometer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.hasOdometer = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional vehicle.Location location = 5;
 * @return {?proto.vehicle.Location}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getLocation = function() {
    return /** @type{?proto.vehicle.Location} */ $8M67s.Message.getWrapperField(this, $9YICB.Location, 5);
};
/**
 * @param {?proto.vehicle.Location|undefined} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
*/ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setLocation = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.clearLocation = function() {
    return this.setLocation(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.hasLocation = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * repeated domain.Image images = 6;
 * @return {!Array<!proto.domain.Image>}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getImagesList = function() {
    return /** @type{!Array<!proto.domain.Image>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Image, 6);
};
/**
 * @param {!Array<!proto.domain.Image>} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
*/ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setImagesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.domain.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Image}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.addImages = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.domain.Image, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.clearImagesList = function() {
    return this.setImagesList([]);
};
/**
 * repeated events.ReturnLineItem line_items = 7;
 * @return {!Array<!proto.events.ReturnLineItem>}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.events.ReturnLineItem>} */ $8M67s.Message.getRepeatedWrapperField(this, $kpGLk.ReturnLineItem, 7);
};
/**
 * @param {!Array<!proto.events.ReturnLineItem>} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
*/ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.events.ReturnLineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.events.ReturnLineItem}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.events.ReturnLineItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
/**
 * map<string, string> miscellaneous = 8;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getMiscellaneousMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,string>} */ $8M67s.Message.getMapField(this, 8, opt_noLazyCreate, null);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.clearMiscellaneousMap = function() {
    this.getMiscellaneousMap().clear();
    return this;
};
/**
 * optional string subscription_id = 9;
 * @return {string}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string return_time = 10;
 * @return {string}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getReturnTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setReturnTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional int32 missing_assets_amount = 11;
 * @return {number}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getMissingAssetsAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setMissingAssetsAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int32 initial_damages_amount = 12;
 * @return {number}
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.getInitialDamagesAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InitiateVehicleReturnRequest} returns this
 */ proto.fleet_service.InitiateVehicleReturnRequest.prototype.setInitialDamagesAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.InitiateVehicleReturnResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.InitiateVehicleReturnResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.InitiateVehicleReturnResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.InitiateVehicleReturnResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            initiated: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.InitiateVehicleReturnResponse}
 */ proto.fleet_service.InitiateVehicleReturnResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.InitiateVehicleReturnResponse;
    return proto.fleet_service.InitiateVehicleReturnResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.InitiateVehicleReturnResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.InitiateVehicleReturnResponse}
 */ proto.fleet_service.InitiateVehicleReturnResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setInitiated(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.InitiateVehicleReturnResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.InitiateVehicleReturnResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.InitiateVehicleReturnResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.InitiateVehicleReturnResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInitiated();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool initiated = 1;
 * @return {boolean}
 */ proto.fleet_service.InitiateVehicleReturnResponse.prototype.getInitiated = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InitiateVehicleReturnResponse} returns this
 */ proto.fleet_service.InitiateVehicleReturnResponse.prototype.setInitiated = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ReturnVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ReturnVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ReturnVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            returnDetails: (f = msg.getReturnDetails()) && proto.fleet_service.ReturnDetails.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ReturnVehicleRequest}
 */ proto.fleet_service.ReturnVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ReturnVehicleRequest;
    return proto.fleet_service.ReturnVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ReturnVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ReturnVehicleRequest}
 */ proto.fleet_service.ReturnVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = new proto.fleet_service.ReturnDetails;
                reader.readMessage(value, proto.fleet_service.ReturnDetails.deserializeBinaryFromReader);
                msg.setReturnDetails(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ReturnVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ReturnVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ReturnVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReturnDetails();
    if (f != null) writer.writeMessage(2, f, proto.fleet_service.ReturnDetails.serializeBinaryToWriter);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.fleet_service.ReturnVehicleRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ReturnVehicleRequest} returns this
 */ proto.fleet_service.ReturnVehicleRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional ReturnDetails return_details = 2;
 * @return {?proto.fleet_service.ReturnDetails}
 */ proto.fleet_service.ReturnVehicleRequest.prototype.getReturnDetails = function() {
    return /** @type{?proto.fleet_service.ReturnDetails} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.ReturnDetails, 2);
};
/**
 * @param {?proto.fleet_service.ReturnDetails|undefined} value
 * @return {!proto.fleet_service.ReturnVehicleRequest} returns this
*/ proto.fleet_service.ReturnVehicleRequest.prototype.setReturnDetails = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.ReturnVehicleRequest} returns this
 */ proto.fleet_service.ReturnVehicleRequest.prototype.clearReturnDetails = function() {
    return this.setReturnDetails(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.ReturnVehicleRequest.prototype.hasReturnDetails = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ReturnVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ReturnVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ReturnVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ReturnVehicleResponse}
 */ proto.fleet_service.ReturnVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ReturnVehicleResponse;
    return proto.fleet_service.ReturnVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ReturnVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ReturnVehicleResponse}
 */ proto.fleet_service.ReturnVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ReturnVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ReturnVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ReturnVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ReturnAndPickupVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ReturnAndPickupVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            returnDetails: (f = msg.getReturnDetails()) && proto.fleet_service.ReturnDetails.toObject(includeInstance, f),
            pickupDetails: (f = msg.getPickupDetails()) && proto.fleet_service.PickupDetails.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ReturnAndPickupVehicleRequest}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ReturnAndPickupVehicleRequest;
    return proto.fleet_service.ReturnAndPickupVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ReturnAndPickupVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ReturnAndPickupVehicleRequest}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = new proto.fleet_service.ReturnDetails;
                reader.readMessage(value, proto.fleet_service.ReturnDetails.deserializeBinaryFromReader);
                msg.setReturnDetails(value);
                break;
            case 3:
                var value = new proto.fleet_service.PickupDetails;
                reader.readMessage(value, proto.fleet_service.PickupDetails.deserializeBinaryFromReader);
                msg.setPickupDetails(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ReturnAndPickupVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ReturnAndPickupVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReturnDetails();
    if (f != null) writer.writeMessage(2, f, proto.fleet_service.ReturnDetails.serializeBinaryToWriter);
    f = message.getPickupDetails();
    if (f != null) writer.writeMessage(3, f, proto.fleet_service.PickupDetails.serializeBinaryToWriter);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ReturnAndPickupVehicleRequest} returns this
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional ReturnDetails return_details = 2;
 * @return {?proto.fleet_service.ReturnDetails}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.getReturnDetails = function() {
    return /** @type{?proto.fleet_service.ReturnDetails} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.ReturnDetails, 2);
};
/**
 * @param {?proto.fleet_service.ReturnDetails|undefined} value
 * @return {!proto.fleet_service.ReturnAndPickupVehicleRequest} returns this
*/ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.setReturnDetails = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.ReturnAndPickupVehicleRequest} returns this
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.clearReturnDetails = function() {
    return this.setReturnDetails(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.hasReturnDetails = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional PickupDetails pickup_details = 3;
 * @return {?proto.fleet_service.PickupDetails}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.getPickupDetails = function() {
    return /** @type{?proto.fleet_service.PickupDetails} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.PickupDetails, 3);
};
/**
 * @param {?proto.fleet_service.PickupDetails|undefined} value
 * @return {!proto.fleet_service.ReturnAndPickupVehicleRequest} returns this
*/ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.setPickupDetails = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.ReturnAndPickupVehicleRequest} returns this
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.clearPickupDetails = function() {
    return this.setPickupDetails(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.ReturnAndPickupVehicleRequest.prototype.hasPickupDetails = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ReturnAndPickupVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ReturnAndPickupVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ReturnAndPickupVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnAndPickupVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ReturnAndPickupVehicleResponse}
 */ proto.fleet_service.ReturnAndPickupVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ReturnAndPickupVehicleResponse;
    return proto.fleet_service.ReturnAndPickupVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ReturnAndPickupVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ReturnAndPickupVehicleResponse}
 */ proto.fleet_service.ReturnAndPickupVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ReturnAndPickupVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ReturnAndPickupVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ReturnAndPickupVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnAndPickupVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ReturnDetails.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ReturnDetails.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ReturnDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnDetails.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            odometer: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            time: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            inspectionReportId: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ReturnDetails}
 */ proto.fleet_service.ReturnDetails.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ReturnDetails;
    return proto.fleet_service.ReturnDetails.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ReturnDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ReturnDetails}
 */ proto.fleet_service.ReturnDetails.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOdometer(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTime(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInspectionReportId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ReturnDetails.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ReturnDetails.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ReturnDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ReturnDetails.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOdometer();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getTime();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getInspectionReportId();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.ReturnDetails.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ReturnDetails} returns this
 */ proto.fleet_service.ReturnDetails.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 odometer = 2;
 * @return {number}
 */ proto.fleet_service.ReturnDetails.prototype.getOdometer = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ReturnDetails} returns this
 */ proto.fleet_service.ReturnDetails.prototype.setOdometer = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string time = 3;
 * @return {string}
 */ proto.fleet_service.ReturnDetails.prototype.getTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ReturnDetails} returns this
 */ proto.fleet_service.ReturnDetails.prototype.setTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string inspection_id = 5;
 * @return {string}
 */ proto.fleet_service.ReturnDetails.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ReturnDetails} returns this
 */ proto.fleet_service.ReturnDetails.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 inspection_report_id = 4;
 * @return {number}
 */ proto.fleet_service.ReturnDetails.prototype.getInspectionReportId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ReturnDetails} returns this
 */ proto.fleet_service.ReturnDetails.prototype.setInspectionReportId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.PickupDetails.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.PickupDetails.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.PickupDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.PickupDetails.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            odometer: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            time: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            inspectionReportId: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.PickupDetails}
 */ proto.fleet_service.PickupDetails.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.PickupDetails;
    return proto.fleet_service.PickupDetails.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.PickupDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.PickupDetails}
 */ proto.fleet_service.PickupDetails.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOdometer(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTime(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInspectionReportId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.PickupDetails.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.PickupDetails.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.PickupDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.PickupDetails.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOdometer();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getTime();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getInspectionReportId();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.PickupDetails.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.PickupDetails} returns this
 */ proto.fleet_service.PickupDetails.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 odometer = 2;
 * @return {number}
 */ proto.fleet_service.PickupDetails.prototype.getOdometer = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.PickupDetails} returns this
 */ proto.fleet_service.PickupDetails.prototype.setOdometer = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string time = 3;
 * @return {string}
 */ proto.fleet_service.PickupDetails.prototype.getTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.PickupDetails} returns this
 */ proto.fleet_service.PickupDetails.prototype.setTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string inspection_id = 5;
 * @return {string}
 */ proto.fleet_service.PickupDetails.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.PickupDetails} returns this
 */ proto.fleet_service.PickupDetails.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 inspection_report_id = 4;
 * @return {number}
 */ proto.fleet_service.PickupDetails.prototype.getInspectionReportId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.PickupDetails} returns this
 */ proto.fleet_service.PickupDetails.prototype.setInspectionReportId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.InspectionPhoto.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.InspectionPhoto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.InspectionPhoto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.InspectionPhoto.toObject = function(includeInstance, msg) {
        var f, obj = {
            path: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            area: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            presignedUrl: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.InspectionPhoto}
 */ proto.fleet_service.InspectionPhoto.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.InspectionPhoto;
    return proto.fleet_service.InspectionPhoto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.InspectionPhoto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.InspectionPhoto}
 */ proto.fleet_service.InspectionPhoto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPath(value);
                break;
            case 2:
                var value = /** @type {!proto.fleet_service.PhotoArea} */ reader.readEnum();
                msg.setArea(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPresignedUrl(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.InspectionPhoto.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.InspectionPhoto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.InspectionPhoto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.InspectionPhoto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPath();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getArea();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getPresignedUrl();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string path = 1;
 * @return {string}
 */ proto.fleet_service.InspectionPhoto.prototype.getPath = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InspectionPhoto} returns this
 */ proto.fleet_service.InspectionPhoto.prototype.setPath = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional PhotoArea area = 2;
 * @return {!proto.fleet_service.PhotoArea}
 */ proto.fleet_service.InspectionPhoto.prototype.getArea = function() {
    return /** @type {!proto.fleet_service.PhotoArea} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.fleet_service.PhotoArea} value
 * @return {!proto.fleet_service.InspectionPhoto} returns this
 */ proto.fleet_service.InspectionPhoto.prototype.setArea = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string presigned_url = 3;
 * @return {string}
 */ proto.fleet_service.InspectionPhoto.prototype.getPresignedUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InspectionPhoto} returns this
 */ proto.fleet_service.InspectionPhoto.prototype.setPresignedUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.SignaturePhoto.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.SignaturePhoto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.SignaturePhoto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.SignaturePhoto.toObject = function(includeInstance, msg) {
        var f, obj = {
            path: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            presignedUrl: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.SignaturePhoto}
 */ proto.fleet_service.SignaturePhoto.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.SignaturePhoto;
    return proto.fleet_service.SignaturePhoto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.SignaturePhoto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.SignaturePhoto}
 */ proto.fleet_service.SignaturePhoto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPath(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPresignedUrl(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.SignaturePhoto.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.SignaturePhoto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.SignaturePhoto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.SignaturePhoto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPath();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPresignedUrl();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string path = 1;
 * @return {string}
 */ proto.fleet_service.SignaturePhoto.prototype.getPath = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.SignaturePhoto} returns this
 */ proto.fleet_service.SignaturePhoto.prototype.setPath = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string presigned_url = 2;
 * @return {string}
 */ proto.fleet_service.SignaturePhoto.prototype.getPresignedUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.SignaturePhoto} returns this
 */ proto.fleet_service.SignaturePhoto.prototype.setPresignedUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.InspectionReport.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.InspectionReport.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.InspectionReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.InspectionReport.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            dealerUserId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            keyCount: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            matsStatus: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            chargeLevel: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            chargingCable: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            plugAdapter120v: $8M67s.Message.getBooleanFieldWithDefault(msg, 9, false),
            plugAdapter240v: $8M67s.Message.getBooleanFieldWithDefault(msg, 10, false),
            saeChargingAdapter: $8M67s.Message.getBooleanFieldWithDefault(msg, 11, false),
            ccsChargingAdapter: $8M67s.Message.getBooleanFieldWithDefault(msg, 12, false),
            frontPlate: $8M67s.Message.getBooleanFieldWithDefault(msg, 13, false),
            rearPlate: $8M67s.Message.getBooleanFieldWithDefault(msg, 14, false),
            plateScrews: $8M67s.Message.getBooleanFieldWithDefault(msg, 15, false),
            frontPlateMount: $8M67s.Message.getBooleanFieldWithDefault(msg, 16, false),
            registrationInVehicle: $8M67s.Message.getBooleanFieldWithDefault(msg, 17, false),
            registrationExpired: $8M67s.Message.getBooleanFieldWithDefault(msg, 18, false),
            hovStickersInstalled: $8M67s.Message.getBooleanFieldWithDefault(msg, 19, false),
            tiresAndWheelsMatch: $8M67s.Message.getBooleanFieldWithDefault(msg, 20, false),
            treadDepthRightFront: $8M67s.Message.getFieldWithDefault(msg, 21, 0),
            treadDepthLeftFront: $8M67s.Message.getFieldWithDefault(msg, 22, 0),
            treadDepthRightRear: $8M67s.Message.getFieldWithDefault(msg, 23, 0),
            treadDepthLeftRear: $8M67s.Message.getFieldWithDefault(msg, 24, 0),
            personalItemsRemoved: $8M67s.Message.getBooleanFieldWithDefault(msg, 25, false),
            vehicleSystemReset: $8M67s.Message.getBooleanFieldWithDefault(msg, 26, false),
            signaturePhoto: (f = msg.getSignaturePhoto()) && proto.fleet_service.SignaturePhoto.toObject(includeInstance, f),
            signedCustomerId: $8M67s.Message.getFieldWithDefault(msg, 28, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.InspectionReport}
 */ proto.fleet_service.InspectionReport.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.InspectionReport;
    return proto.fleet_service.InspectionReport.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.InspectionReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.InspectionReport}
 */ proto.fleet_service.InspectionReport.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerUserId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setKeyCount(value);
                break;
            case 6:
                var value = /** @type {!proto.fleet_service.MatsStatus} */ reader.readEnum();
                msg.setMatsStatus(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setChargeLevel(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setChargingCable(value);
                break;
            case 9:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPlugAdapter120v(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPlugAdapter240v(value);
                break;
            case 11:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSaeChargingAdapter(value);
                break;
            case 12:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setCcsChargingAdapter(value);
                break;
            case 13:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setFrontPlate(value);
                break;
            case 14:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRearPlate(value);
                break;
            case 15:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPlateScrews(value);
                break;
            case 16:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setFrontPlateMount(value);
                break;
            case 17:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRegistrationInVehicle(value);
                break;
            case 18:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRegistrationExpired(value);
                break;
            case 19:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setHovStickersInstalled(value);
                break;
            case 20:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setTiresAndWheelsMatch(value);
                break;
            case 21:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTreadDepthRightFront(value);
                break;
            case 22:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTreadDepthLeftFront(value);
                break;
            case 23:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTreadDepthRightRear(value);
                break;
            case 24:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTreadDepthLeftRear(value);
                break;
            case 25:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPersonalItemsRemoved(value);
                break;
            case 26:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setVehicleSystemReset(value);
                break;
            case 27:
                var value = new proto.fleet_service.SignaturePhoto;
                reader.readMessage(value, proto.fleet_service.SignaturePhoto.deserializeBinaryFromReader);
                msg.setSignaturePhoto(value);
                break;
            case 28:
                var value = /** @type {string} */ reader.readString();
                msg.setSignedCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.InspectionReport.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.InspectionReport.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.InspectionReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.InspectionReport.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDealerUserId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getKeyCount();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getMatsStatus();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getChargeLevel();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getChargingCable();
    if (f) writer.writeBool(8, f);
    f = message.getPlugAdapter120v();
    if (f) writer.writeBool(9, f);
    f = message.getPlugAdapter240v();
    if (f) writer.writeBool(10, f);
    f = message.getSaeChargingAdapter();
    if (f) writer.writeBool(11, f);
    f = message.getCcsChargingAdapter();
    if (f) writer.writeBool(12, f);
    f = message.getFrontPlate();
    if (f) writer.writeBool(13, f);
    f = message.getRearPlate();
    if (f) writer.writeBool(14, f);
    f = message.getPlateScrews();
    if (f) writer.writeBool(15, f);
    f = message.getFrontPlateMount();
    if (f) writer.writeBool(16, f);
    f = message.getRegistrationInVehicle();
    if (f) writer.writeBool(17, f);
    f = message.getRegistrationExpired();
    if (f) writer.writeBool(18, f);
    f = message.getHovStickersInstalled();
    if (f) writer.writeBool(19, f);
    f = message.getTiresAndWheelsMatch();
    if (f) writer.writeBool(20, f);
    f = message.getTreadDepthRightFront();
    if (f !== 0) writer.writeInt32(21, f);
    f = message.getTreadDepthLeftFront();
    if (f !== 0) writer.writeInt32(22, f);
    f = message.getTreadDepthRightRear();
    if (f !== 0) writer.writeInt32(23, f);
    f = message.getTreadDepthLeftRear();
    if (f !== 0) writer.writeInt32(24, f);
    f = message.getPersonalItemsRemoved();
    if (f) writer.writeBool(25, f);
    f = message.getVehicleSystemReset();
    if (f) writer.writeBool(26, f);
    f = message.getSignaturePhoto();
    if (f != null) writer.writeMessage(27, f, proto.fleet_service.SignaturePhoto.serializeBinaryToWriter);
    f = message.getSignedCustomerId();
    if (f.length > 0) writer.writeString(28, f);
};
/**
 * optional int32 id = 1;
 * @return {number}
 */ proto.fleet_service.InspectionReport.prototype.getId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.fleet_service.InspectionReport.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string dealership_id = 3;
 * @return {string}
 */ proto.fleet_service.InspectionReport.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string dealer_user_id = 4;
 * @return {string}
 */ proto.fleet_service.InspectionReport.prototype.getDealerUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setDealerUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 key_count = 5;
 * @return {number}
 */ proto.fleet_service.InspectionReport.prototype.getKeyCount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setKeyCount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional MatsStatus mats_status = 6;
 * @return {!proto.fleet_service.MatsStatus}
 */ proto.fleet_service.InspectionReport.prototype.getMatsStatus = function() {
    return /** @type {!proto.fleet_service.MatsStatus} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.fleet_service.MatsStatus} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setMatsStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional int32 charge_level = 7;
 * @return {number}
 */ proto.fleet_service.InspectionReport.prototype.getChargeLevel = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setChargeLevel = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional bool charging_cable = 8;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getChargingCable = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setChargingCable = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional bool plug_adapter_120v = 9;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getPlugAdapter120v = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 9, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setPlugAdapter120v = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 9, value);
};
/**
 * optional bool plug_adapter_240v = 10;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getPlugAdapter240v = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setPlugAdapter240v = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 10, value);
};
/**
 * optional bool sae_charging_adapter = 11;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getSaeChargingAdapter = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 11, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setSaeChargingAdapter = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 11, value);
};
/**
 * optional bool ccs_charging_adapter = 12;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getCcsChargingAdapter = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 12, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setCcsChargingAdapter = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 12, value);
};
/**
 * optional bool front_plate = 13;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getFrontPlate = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 13, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setFrontPlate = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 13, value);
};
/**
 * optional bool rear_plate = 14;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getRearPlate = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 14, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setRearPlate = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 14, value);
};
/**
 * optional bool plate_screws = 15;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getPlateScrews = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 15, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setPlateScrews = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 15, value);
};
/**
 * optional bool front_plate_mount = 16;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getFrontPlateMount = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 16, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setFrontPlateMount = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 16, value);
};
/**
 * optional bool registration_in_vehicle = 17;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getRegistrationInVehicle = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 17, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setRegistrationInVehicle = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 17, value);
};
/**
 * optional bool registration_expired = 18;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getRegistrationExpired = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 18, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setRegistrationExpired = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 18, value);
};
/**
 * optional bool hov_stickers_installed = 19;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getHovStickersInstalled = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 19, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setHovStickersInstalled = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 19, value);
};
/**
 * optional bool tires_and_wheels_match = 20;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getTiresAndWheelsMatch = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 20, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setTiresAndWheelsMatch = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 20, value);
};
/**
 * optional int32 tread_depth_right_front = 21;
 * @return {number}
 */ proto.fleet_service.InspectionReport.prototype.getTreadDepthRightFront = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 21, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setTreadDepthRightFront = function(value) {
    return $8M67s.Message.setProto3IntField(this, 21, value);
};
/**
 * optional int32 tread_depth_left_front = 22;
 * @return {number}
 */ proto.fleet_service.InspectionReport.prototype.getTreadDepthLeftFront = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 22, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setTreadDepthLeftFront = function(value) {
    return $8M67s.Message.setProto3IntField(this, 22, value);
};
/**
 * optional int32 tread_depth_right_rear = 23;
 * @return {number}
 */ proto.fleet_service.InspectionReport.prototype.getTreadDepthRightRear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 23, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setTreadDepthRightRear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 23, value);
};
/**
 * optional int32 tread_depth_left_rear = 24;
 * @return {number}
 */ proto.fleet_service.InspectionReport.prototype.getTreadDepthLeftRear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 24, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setTreadDepthLeftRear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 24, value);
};
/**
 * optional bool personal_items_removed = 25;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getPersonalItemsRemoved = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 25, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setPersonalItemsRemoved = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 25, value);
};
/**
 * optional bool vehicle_system_reset = 26;
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.getVehicleSystemReset = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 26, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setVehicleSystemReset = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 26, value);
};
/**
 * optional SignaturePhoto signature_photo = 27;
 * @return {?proto.fleet_service.SignaturePhoto}
 */ proto.fleet_service.InspectionReport.prototype.getSignaturePhoto = function() {
    return /** @type{?proto.fleet_service.SignaturePhoto} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.SignaturePhoto, 27);
};
/**
 * @param {?proto.fleet_service.SignaturePhoto|undefined} value
 * @return {!proto.fleet_service.InspectionReport} returns this
*/ proto.fleet_service.InspectionReport.prototype.setSignaturePhoto = function(value) {
    return $8M67s.Message.setWrapperField(this, 27, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.clearSignaturePhoto = function() {
    return this.setSignaturePhoto(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.InspectionReport.prototype.hasSignaturePhoto = function() {
    return $8M67s.Message.getField(this, 27) != null;
};
/**
 * optional string signed_customer_id = 28;
 * @return {string}
 */ proto.fleet_service.InspectionReport.prototype.getSignedCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 28, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.InspectionReport} returns this
 */ proto.fleet_service.InspectionReport.prototype.setSignedCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 28, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.CreateInspectionReportRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.CreateInspectionReportRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.CreateInspectionReportRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.CreateInspectionReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.CreateInspectionReportRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            report: (f = msg.getReport()) && proto.fleet_service.InspectionReport.toObject(includeInstance, f),
            fleetPhotosList: $8M67s.Message.toObjectList(msg.getFleetPhotosList(), proto.fleet_service.InspectionPhoto.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.CreateInspectionReportRequest}
 */ proto.fleet_service.CreateInspectionReportRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.CreateInspectionReportRequest;
    return proto.fleet_service.CreateInspectionReportRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.CreateInspectionReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.CreateInspectionReportRequest}
 */ proto.fleet_service.CreateInspectionReportRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.InspectionReport;
                reader.readMessage(value, proto.fleet_service.InspectionReport.deserializeBinaryFromReader);
                msg.setReport(value);
                break;
            case 2:
                var value = new proto.fleet_service.InspectionPhoto;
                reader.readMessage(value, proto.fleet_service.InspectionPhoto.deserializeBinaryFromReader);
                msg.addFleetPhotos(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.CreateInspectionReportRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.CreateInspectionReportRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.CreateInspectionReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.CreateInspectionReportRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReport();
    if (f != null) writer.writeMessage(1, f, proto.fleet_service.InspectionReport.serializeBinaryToWriter);
    f = message.getFleetPhotosList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.fleet_service.InspectionPhoto.serializeBinaryToWriter);
};
/**
 * optional InspectionReport report = 1;
 * @return {?proto.fleet_service.InspectionReport}
 */ proto.fleet_service.CreateInspectionReportRequest.prototype.getReport = function() {
    return /** @type{?proto.fleet_service.InspectionReport} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.InspectionReport, 1);
};
/**
 * @param {?proto.fleet_service.InspectionReport|undefined} value
 * @return {!proto.fleet_service.CreateInspectionReportRequest} returns this
*/ proto.fleet_service.CreateInspectionReportRequest.prototype.setReport = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.CreateInspectionReportRequest} returns this
 */ proto.fleet_service.CreateInspectionReportRequest.prototype.clearReport = function() {
    return this.setReport(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.CreateInspectionReportRequest.prototype.hasReport = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated InspectionPhoto fleet_photos = 2;
 * @return {!Array<!proto.fleet_service.InspectionPhoto>}
 */ proto.fleet_service.CreateInspectionReportRequest.prototype.getFleetPhotosList = function() {
    return /** @type{!Array<!proto.fleet_service.InspectionPhoto>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.InspectionPhoto, 2);
};
/**
 * @param {!Array<!proto.fleet_service.InspectionPhoto>} value
 * @return {!proto.fleet_service.CreateInspectionReportRequest} returns this
*/ proto.fleet_service.CreateInspectionReportRequest.prototype.setFleetPhotosList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.fleet_service.InspectionPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.InspectionPhoto}
 */ proto.fleet_service.CreateInspectionReportRequest.prototype.addFleetPhotos = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet_service.InspectionPhoto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.CreateInspectionReportRequest} returns this
 */ proto.fleet_service.CreateInspectionReportRequest.prototype.clearFleetPhotosList = function() {
    return this.setFleetPhotosList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.CreateInspectionReportResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.CreateInspectionReportResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.CreateInspectionReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.CreateInspectionReportResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.CreateInspectionReportResponse}
 */ proto.fleet_service.CreateInspectionReportResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.CreateInspectionReportResponse;
    return proto.fleet_service.CreateInspectionReportResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.CreateInspectionReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.CreateInspectionReportResponse}
 */ proto.fleet_service.CreateInspectionReportResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.CreateInspectionReportResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.CreateInspectionReportResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.CreateInspectionReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.CreateInspectionReportResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * optional int32 id = 1;
 * @return {number}
 */ proto.fleet_service.CreateInspectionReportResponse.prototype.getId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.CreateInspectionReportResponse} returns this
 */ proto.fleet_service.CreateInspectionReportResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.SignInspectionReportRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.SignInspectionReportRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.SignInspectionReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.SignInspectionReportRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            signaturePhoto: (f = msg.getSignaturePhoto()) && proto.fleet_service.SignaturePhoto.toObject(includeInstance, f),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            inspectionReportId: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.SignInspectionReportRequest}
 */ proto.fleet_service.SignInspectionReportRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.SignInspectionReportRequest;
    return proto.fleet_service.SignInspectionReportRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.SignInspectionReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.SignInspectionReportRequest}
 */ proto.fleet_service.SignInspectionReportRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = new proto.fleet_service.SignaturePhoto;
                reader.readMessage(value, proto.fleet_service.SignaturePhoto.deserializeBinaryFromReader);
                msg.setSignaturePhoto(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInspectionReportId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.SignInspectionReportRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.SignInspectionReportRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.SignInspectionReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.SignInspectionReportRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSignaturePhoto();
    if (f != null) writer.writeMessage(3, f, proto.fleet_service.SignaturePhoto.serializeBinaryToWriter);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getInspectionReportId();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.fleet_service.SignInspectionReportRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.SignInspectionReportRequest} returns this
 */ proto.fleet_service.SignInspectionReportRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional SignaturePhoto signature_photo = 3;
 * @return {?proto.fleet_service.SignaturePhoto}
 */ proto.fleet_service.SignInspectionReportRequest.prototype.getSignaturePhoto = function() {
    return /** @type{?proto.fleet_service.SignaturePhoto} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.SignaturePhoto, 3);
};
/**
 * @param {?proto.fleet_service.SignaturePhoto|undefined} value
 * @return {!proto.fleet_service.SignInspectionReportRequest} returns this
*/ proto.fleet_service.SignInspectionReportRequest.prototype.setSignaturePhoto = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.SignInspectionReportRequest} returns this
 */ proto.fleet_service.SignInspectionReportRequest.prototype.clearSignaturePhoto = function() {
    return this.setSignaturePhoto(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.SignInspectionReportRequest.prototype.hasSignaturePhoto = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional string inspection_id = 4;
 * @return {string}
 */ proto.fleet_service.SignInspectionReportRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.SignInspectionReportRequest} returns this
 */ proto.fleet_service.SignInspectionReportRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 inspection_report_id = 1;
 * @return {number}
 */ proto.fleet_service.SignInspectionReportRequest.prototype.getInspectionReportId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.SignInspectionReportRequest} returns this
 */ proto.fleet_service.SignInspectionReportRequest.prototype.setInspectionReportId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.SignInspectionReportResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.SignInspectionReportResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.SignInspectionReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.SignInspectionReportResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.SignInspectionReportResponse}
 */ proto.fleet_service.SignInspectionReportResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.SignInspectionReportResponse;
    return proto.fleet_service.SignInspectionReportResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.SignInspectionReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.SignInspectionReportResponse}
 */ proto.fleet_service.SignInspectionReportResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.SignInspectionReportResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.SignInspectionReportResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.SignInspectionReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.SignInspectionReportResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.AddInspectionPhotosRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.AddInspectionPhotosRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.AddInspectionPhotosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddInspectionPhotosRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerPhotosList: $8M67s.Message.toObjectList(msg.getCustomerPhotosList(), proto.fleet_service.InspectionPhoto.toObject, includeInstance),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            inspectionReportId: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.AddInspectionPhotosRequest}
 */ proto.fleet_service.AddInspectionPhotosRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.AddInspectionPhotosRequest;
    return proto.fleet_service.AddInspectionPhotosRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.AddInspectionPhotosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.AddInspectionPhotosRequest}
 */ proto.fleet_service.AddInspectionPhotosRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = new proto.fleet_service.InspectionPhoto;
                reader.readMessage(value, proto.fleet_service.InspectionPhoto.deserializeBinaryFromReader);
                msg.addCustomerPhotos(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInspectionReportId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.AddInspectionPhotosRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.AddInspectionPhotosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddInspectionPhotosRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerPhotosList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.fleet_service.InspectionPhoto.serializeBinaryToWriter);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getInspectionReportId();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * repeated InspectionPhoto customer_photos = 2;
 * @return {!Array<!proto.fleet_service.InspectionPhoto>}
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.getCustomerPhotosList = function() {
    return /** @type{!Array<!proto.fleet_service.InspectionPhoto>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.InspectionPhoto, 2);
};
/**
 * @param {!Array<!proto.fleet_service.InspectionPhoto>} value
 * @return {!proto.fleet_service.AddInspectionPhotosRequest} returns this
*/ proto.fleet_service.AddInspectionPhotosRequest.prototype.setCustomerPhotosList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.fleet_service.InspectionPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.InspectionPhoto}
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.addCustomerPhotos = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet_service.InspectionPhoto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.AddInspectionPhotosRequest} returns this
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.clearCustomerPhotosList = function() {
    return this.setCustomerPhotosList([]);
};
/**
 * optional string inspection_id = 3;
 * @return {string}
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AddInspectionPhotosRequest} returns this
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 inspection_report_id = 1;
 * @return {number}
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.getInspectionReportId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.AddInspectionPhotosRequest} returns this
 */ proto.fleet_service.AddInspectionPhotosRequest.prototype.setInspectionReportId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.AddInspectionPhotosResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.AddInspectionPhotosResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.AddInspectionPhotosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddInspectionPhotosResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.AddInspectionPhotosResponse}
 */ proto.fleet_service.AddInspectionPhotosResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.AddInspectionPhotosResponse;
    return proto.fleet_service.AddInspectionPhotosResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.AddInspectionPhotosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.AddInspectionPhotosResponse}
 */ proto.fleet_service.AddInspectionPhotosResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.AddInspectionPhotosResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.AddInspectionPhotosResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.AddInspectionPhotosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddInspectionPhotosResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetInspectionPhotosRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetInspectionPhotosRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetInspectionPhotosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetInspectionPhotosRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionReportId: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetInspectionPhotosRequest}
 */ proto.fleet_service.GetInspectionPhotosRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetInspectionPhotosRequest;
    return proto.fleet_service.GetInspectionPhotosRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetInspectionPhotosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetInspectionPhotosRequest}
 */ proto.fleet_service.GetInspectionPhotosRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInspectionReportId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetInspectionPhotosRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetInspectionPhotosRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetInspectionPhotosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetInspectionPhotosRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionReportId();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * optional int32 inspection_report_id = 1;
 * @return {number}
 */ proto.fleet_service.GetInspectionPhotosRequest.prototype.getInspectionReportId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetInspectionPhotosRequest} returns this
 */ proto.fleet_service.GetInspectionPhotosRequest.prototype.setInspectionReportId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.GetInspectionPhotosResponse.repeatedFields_ = [
    1,
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetInspectionPhotosResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetInspectionPhotosResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetInspectionPhotosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetInspectionPhotosResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            fleetPhotosList: $8M67s.Message.toObjectList(msg.getFleetPhotosList(), proto.fleet_service.InspectionPhoto.toObject, includeInstance),
            customerPhotosList: $8M67s.Message.toObjectList(msg.getCustomerPhotosList(), proto.fleet_service.InspectionPhoto.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetInspectionPhotosResponse}
 */ proto.fleet_service.GetInspectionPhotosResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetInspectionPhotosResponse;
    return proto.fleet_service.GetInspectionPhotosResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetInspectionPhotosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetInspectionPhotosResponse}
 */ proto.fleet_service.GetInspectionPhotosResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.InspectionPhoto;
                reader.readMessage(value, proto.fleet_service.InspectionPhoto.deserializeBinaryFromReader);
                msg.addFleetPhotos(value);
                break;
            case 2:
                var value = new proto.fleet_service.InspectionPhoto;
                reader.readMessage(value, proto.fleet_service.InspectionPhoto.deserializeBinaryFromReader);
                msg.addCustomerPhotos(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetInspectionPhotosResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetInspectionPhotosResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetInspectionPhotosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetInspectionPhotosResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getFleetPhotosList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.InspectionPhoto.serializeBinaryToWriter);
    f = message.getCustomerPhotosList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.fleet_service.InspectionPhoto.serializeBinaryToWriter);
};
/**
 * repeated InspectionPhoto fleet_photos = 1;
 * @return {!Array<!proto.fleet_service.InspectionPhoto>}
 */ proto.fleet_service.GetInspectionPhotosResponse.prototype.getFleetPhotosList = function() {
    return /** @type{!Array<!proto.fleet_service.InspectionPhoto>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.InspectionPhoto, 1);
};
/**
 * @param {!Array<!proto.fleet_service.InspectionPhoto>} value
 * @return {!proto.fleet_service.GetInspectionPhotosResponse} returns this
*/ proto.fleet_service.GetInspectionPhotosResponse.prototype.setFleetPhotosList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.InspectionPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.InspectionPhoto}
 */ proto.fleet_service.GetInspectionPhotosResponse.prototype.addFleetPhotos = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.InspectionPhoto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.GetInspectionPhotosResponse} returns this
 */ proto.fleet_service.GetInspectionPhotosResponse.prototype.clearFleetPhotosList = function() {
    return this.setFleetPhotosList([]);
};
/**
 * repeated InspectionPhoto customer_photos = 2;
 * @return {!Array<!proto.fleet_service.InspectionPhoto>}
 */ proto.fleet_service.GetInspectionPhotosResponse.prototype.getCustomerPhotosList = function() {
    return /** @type{!Array<!proto.fleet_service.InspectionPhoto>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.InspectionPhoto, 2);
};
/**
 * @param {!Array<!proto.fleet_service.InspectionPhoto>} value
 * @return {!proto.fleet_service.GetInspectionPhotosResponse} returns this
*/ proto.fleet_service.GetInspectionPhotosResponse.prototype.setCustomerPhotosList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.fleet_service.InspectionPhoto=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.InspectionPhoto}
 */ proto.fleet_service.GetInspectionPhotosResponse.prototype.addCustomerPhotos = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet_service.InspectionPhoto, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.GetInspectionPhotosResponse} returns this
 */ proto.fleet_service.GetInspectionPhotosResponse.prototype.clearCustomerPhotosList = function() {
    return this.setCustomerPhotosList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetPresignedWritePhotoURLRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetPresignedWritePhotoURLRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            extension: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLRequest}
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetPresignedWritePhotoURLRequest;
    return proto.fleet_service.GetPresignedWritePhotoURLRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetPresignedWritePhotoURLRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLRequest}
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setExtension$(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetPresignedWritePhotoURLRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetPresignedWritePhotoURLRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getExtension$();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLRequest} returns this
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLRequest} returns this
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string name = 3;
 * @return {string}
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLRequest} returns this
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string extension = 4;
 * @return {string}
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.getExtension$ = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLRequest} returns this
 */ proto.fleet_service.GetPresignedWritePhotoURLRequest.prototype.setExtension$ = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetPresignedWritePhotoURLResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetPresignedWritePhotoURLResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            url: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            path: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLResponse}
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetPresignedWritePhotoURLResponse;
    return proto.fleet_service.GetPresignedWritePhotoURLResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetPresignedWritePhotoURLResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLResponse}
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setUrl(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPath(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetPresignedWritePhotoURLResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetPresignedWritePhotoURLResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUrl();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPath();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string url = 1;
 * @return {string}
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.prototype.getUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLResponse} returns this
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.prototype.setUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.prototype.getPath = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetPresignedWritePhotoURLResponse} returns this
 */ proto.fleet_service.GetPresignedWritePhotoURLResponse.prototype.setPath = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetInspectionSignatureWriteURLRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            extension: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            inspectionReportId: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLRequest}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetInspectionSignatureWriteURLRequest;
    return proto.fleet_service.GetInspectionSignatureWriteURLRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLRequest}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setExtension$(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInspectionReportId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetInspectionSignatureWriteURLRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getExtension$();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getInspectionReportId();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} returns this
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 3;
 * @return {string}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} returns this
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string extension = 4;
 * @return {string}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.getExtension$ = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} returns this
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.setExtension$ = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string inspection_id = 5;
 * @return {string}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} returns this
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 inspection_report_id = 2;
 * @return {number}
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.getInspectionReportId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} returns this
 */ proto.fleet_service.GetInspectionSignatureWriteURLRequest.prototype.setInspectionReportId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetInspectionSignatureWriteURLResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetInspectionSignatureWriteURLResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            url: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            path: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLResponse}
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetInspectionSignatureWriteURLResponse;
    return proto.fleet_service.GetInspectionSignatureWriteURLResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetInspectionSignatureWriteURLResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLResponse}
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setUrl(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPath(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetInspectionSignatureWriteURLResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetInspectionSignatureWriteURLResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUrl();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPath();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string url = 1;
 * @return {string}
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.prototype.getUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLResponse} returns this
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.prototype.setUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string path = 2;
 * @return {string}
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.prototype.getPath = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetInspectionSignatureWriteURLResponse} returns this
 */ proto.fleet_service.GetInspectionSignatureWriteURLResponse.prototype.setPath = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetSubscriptionMileageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetSubscriptionMileageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetSubscriptionMileageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetSubscriptionMileageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetSubscriptionMileageRequest}
 */ proto.fleet_service.GetSubscriptionMileageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetSubscriptionMileageRequest;
    return proto.fleet_service.GetSubscriptionMileageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetSubscriptionMileageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetSubscriptionMileageRequest}
 */ proto.fleet_service.GetSubscriptionMileageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetSubscriptionMileageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetSubscriptionMileageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetSubscriptionMileageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetSubscriptionMileageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.fleet_service.GetSubscriptionMileageRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetSubscriptionMileageRequest} returns this
 */ proto.fleet_service.GetSubscriptionMileageRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.MileageDrivenInMonth.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.MileageDrivenInMonth.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.MileageDrivenInMonth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.MileageDrivenInMonth.toObject = function(includeInstance, msg) {
        var f, obj = {
            date: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.MileageDrivenInMonth}
 */ proto.fleet_service.MileageDrivenInMonth.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.MileageDrivenInMonth;
    return proto.fleet_service.MileageDrivenInMonth.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.MileageDrivenInMonth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.MileageDrivenInMonth}
 */ proto.fleet_service.MileageDrivenInMonth.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDate(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.MileageDrivenInMonth.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.MileageDrivenInMonth.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.MileageDrivenInMonth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.MileageDrivenInMonth.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string date = 1;
 * @return {string}
 */ proto.fleet_service.MileageDrivenInMonth.prototype.getDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.MileageDrivenInMonth} returns this
 */ proto.fleet_service.MileageDrivenInMonth.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 amount = 2;
 * @return {number}
 */ proto.fleet_service.MileageDrivenInMonth.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.MileageDrivenInMonth} returns this
 */ proto.fleet_service.MileageDrivenInMonth.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.PrepaidExtraMileage.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.PrepaidExtraMileage.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.PrepaidExtraMileage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.PrepaidExtraMileage.toObject = function(includeInstance, msg) {
        var f, obj = {
            totalAmount: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            totalPrice: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.PrepaidExtraMileage}
 */ proto.fleet_service.PrepaidExtraMileage.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.PrepaidExtraMileage;
    return proto.fleet_service.PrepaidExtraMileage.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.PrepaidExtraMileage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.PrepaidExtraMileage}
 */ proto.fleet_service.PrepaidExtraMileage.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotalAmount(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotalPrice(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.PrepaidExtraMileage.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.PrepaidExtraMileage.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.PrepaidExtraMileage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.PrepaidExtraMileage.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTotalAmount();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getTotalPrice();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional int32 total_amount = 1;
 * @return {number}
 */ proto.fleet_service.PrepaidExtraMileage.prototype.getTotalAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.PrepaidExtraMileage} returns this
 */ proto.fleet_service.PrepaidExtraMileage.prototype.setTotalAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 total_price = 2;
 * @return {number}
 */ proto.fleet_service.PrepaidExtraMileage.prototype.getTotalPrice = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.PrepaidExtraMileage} returns this
 */ proto.fleet_service.PrepaidExtraMileage.prototype.setTotalPrice = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.GetSubscriptionMileageResponse.repeatedFields_ = [
    7
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetSubscriptionMileageResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetSubscriptionMileageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetSubscriptionMileageResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            totalAllotted: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            totalDriven: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            allottedPerMonth: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            drivenPerMonth: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            startingOdometer: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            lastOdometer: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            drivenByMonthList: $8M67s.Message.toObjectList(msg.getDrivenByMonthList(), proto.fleet_service.MileageDrivenInMonth.toObject, includeInstance),
            prepaidExtra: (f = msg.getPrepaidExtra()) && proto.fleet_service.PrepaidExtraMileage.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse}
 */ proto.fleet_service.GetSubscriptionMileageResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetSubscriptionMileageResponse;
    return proto.fleet_service.GetSubscriptionMileageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetSubscriptionMileageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse}
 */ proto.fleet_service.GetSubscriptionMileageResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotalAllotted(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotalDriven(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAllottedPerMonth(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDrivenPerMonth(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartingOdometer(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLastOdometer(value);
                break;
            case 7:
                var value = new proto.fleet_service.MileageDrivenInMonth;
                reader.readMessage(value, proto.fleet_service.MileageDrivenInMonth.deserializeBinaryFromReader);
                msg.addDrivenByMonth(value);
                break;
            case 8:
                var value = new proto.fleet_service.PrepaidExtraMileage;
                reader.readMessage(value, proto.fleet_service.PrepaidExtraMileage.deserializeBinaryFromReader);
                msg.setPrepaidExtra(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetSubscriptionMileageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetSubscriptionMileageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetSubscriptionMileageResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTotalAllotted();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getTotalDriven();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getAllottedPerMonth();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getDrivenPerMonth();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getStartingOdometer();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getLastOdometer();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getDrivenByMonthList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, proto.fleet_service.MileageDrivenInMonth.serializeBinaryToWriter);
    f = message.getPrepaidExtra();
    if (f != null) writer.writeMessage(8, f, proto.fleet_service.PrepaidExtraMileage.serializeBinaryToWriter);
};
/**
 * optional int32 total_allotted = 1;
 * @return {number}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.getTotalAllotted = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.setTotalAllotted = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 total_driven = 2;
 * @return {number}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.getTotalDriven = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.setTotalDriven = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 allotted_per_month = 3;
 * @return {number}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.getAllottedPerMonth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.setAllottedPerMonth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 driven_per_month = 4;
 * @return {number}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.getDrivenPerMonth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.setDrivenPerMonth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 starting_odometer = 5;
 * @return {number}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.getStartingOdometer = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.setStartingOdometer = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 last_odometer = 6;
 * @return {number}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.getLastOdometer = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.setLastOdometer = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * repeated MileageDrivenInMonth driven_by_month = 7;
 * @return {!Array<!proto.fleet_service.MileageDrivenInMonth>}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.getDrivenByMonthList = function() {
    return /** @type{!Array<!proto.fleet_service.MileageDrivenInMonth>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.MileageDrivenInMonth, 7);
};
/**
 * @param {!Array<!proto.fleet_service.MileageDrivenInMonth>} value
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
*/ proto.fleet_service.GetSubscriptionMileageResponse.prototype.setDrivenByMonthList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.fleet_service.MileageDrivenInMonth=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.MileageDrivenInMonth}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.addDrivenByMonth = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.fleet_service.MileageDrivenInMonth, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.clearDrivenByMonthList = function() {
    return this.setDrivenByMonthList([]);
};
/**
 * optional PrepaidExtraMileage prepaid_extra = 8;
 * @return {?proto.fleet_service.PrepaidExtraMileage}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.getPrepaidExtra = function() {
    return /** @type{?proto.fleet_service.PrepaidExtraMileage} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.PrepaidExtraMileage, 8);
};
/**
 * @param {?proto.fleet_service.PrepaidExtraMileage|undefined} value
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
*/ proto.fleet_service.GetSubscriptionMileageResponse.prototype.setPrepaidExtra = function(value) {
    return $8M67s.Message.setWrapperField(this, 8, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetSubscriptionMileageResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.clearPrepaidExtra = function() {
    return this.setPrepaidExtra(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetSubscriptionMileageResponse.prototype.hasPrepaidExtra = function() {
    return $8M67s.Message.getField(this, 8) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetSubscriptionMileagePurchasesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetSubscriptionMileagePurchasesRequest;
    return proto.fleet_service.GetSubscriptionMileagePurchasesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetSubscriptionMileagePurchasesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest} returns this
 */ proto.fleet_service.GetSubscriptionMileagePurchasesRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.MileagePurchase.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.MileagePurchase.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.MileagePurchase} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.MileagePurchase.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            amount: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            price: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            time: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            referenceId: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.MileagePurchase}
 */ proto.fleet_service.MileagePurchase.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.MileagePurchase;
    return proto.fleet_service.MileagePurchase.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.MileagePurchase} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.MileagePurchase}
 */ proto.fleet_service.MileagePurchase.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPrice(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTime(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setReferenceId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.MileagePurchase.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.MileagePurchase.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.MileagePurchase} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.MileagePurchase.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getPrice();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getTime();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getReferenceId();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional int32 id = 1;
 * @return {number}
 */ proto.fleet_service.MileagePurchase.prototype.getId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.MileagePurchase} returns this
 */ proto.fleet_service.MileagePurchase.prototype.setId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 amount = 2;
 * @return {number}
 */ proto.fleet_service.MileagePurchase.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.MileagePurchase} returns this
 */ proto.fleet_service.MileagePurchase.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 price = 3;
 * @return {number}
 */ proto.fleet_service.MileagePurchase.prototype.getPrice = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.MileagePurchase} returns this
 */ proto.fleet_service.MileagePurchase.prototype.setPrice = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int64 time = 4;
 * @return {number}
 */ proto.fleet_service.MileagePurchase.prototype.getTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.MileagePurchase} returns this
 */ proto.fleet_service.MileagePurchase.prototype.setTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string reference_id = 5;
 * @return {string}
 */ proto.fleet_service.MileagePurchase.prototype.getReferenceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.MileagePurchase} returns this
 */ proto.fleet_service.MileagePurchase.prototype.setReferenceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetSubscriptionMileagePurchasesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            purchasesList: $8M67s.Message.toObjectList(msg.getPurchasesList(), proto.fleet_service.MileagePurchase.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetSubscriptionMileagePurchasesResponse}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetSubscriptionMileagePurchasesResponse;
    return proto.fleet_service.GetSubscriptionMileagePurchasesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetSubscriptionMileagePurchasesResponse}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.MileagePurchase;
                reader.readMessage(value, proto.fleet_service.MileagePurchase.deserializeBinaryFromReader);
                msg.addPurchases(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetSubscriptionMileagePurchasesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPurchasesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.MileagePurchase.serializeBinaryToWriter);
};
/**
 * repeated MileagePurchase purchases = 1;
 * @return {!Array<!proto.fleet_service.MileagePurchase>}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.prototype.getPurchasesList = function() {
    return /** @type{!Array<!proto.fleet_service.MileagePurchase>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.MileagePurchase, 1);
};
/**
 * @param {!Array<!proto.fleet_service.MileagePurchase>} value
 * @return {!proto.fleet_service.GetSubscriptionMileagePurchasesResponse} returns this
*/ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.prototype.setPurchasesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.MileagePurchase=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.MileagePurchase}
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.prototype.addPurchases = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.MileagePurchase, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.GetSubscriptionMileagePurchasesResponse} returns this
 */ proto.fleet_service.GetSubscriptionMileagePurchasesResponse.prototype.clearPurchasesList = function() {
    return this.setPurchasesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetPrePaidMileageRateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetPrePaidMileageRateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetPrePaidMileageRateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetPrePaidMileageRateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetPrePaidMileageRateRequest}
 */ proto.fleet_service.GetPrePaidMileageRateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetPrePaidMileageRateRequest;
    return proto.fleet_service.GetPrePaidMileageRateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetPrePaidMileageRateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetPrePaidMileageRateRequest}
 */ proto.fleet_service.GetPrePaidMileageRateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetPrePaidMileageRateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetPrePaidMileageRateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetPrePaidMileageRateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetPrePaidMileageRateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.fleet_service.GetPrePaidMileageRateRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetPrePaidMileageRateRequest} returns this
 */ proto.fleet_service.GetPrePaidMileageRateRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetPrePaidMileageRateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetPrePaidMileageRateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetPrePaidMileageRateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetPrePaidMileageRateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            amountPerMile: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetPrePaidMileageRateResponse}
 */ proto.fleet_service.GetPrePaidMileageRateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetPrePaidMileageRateResponse;
    return proto.fleet_service.GetPrePaidMileageRateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetPrePaidMileageRateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetPrePaidMileageRateResponse}
 */ proto.fleet_service.GetPrePaidMileageRateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmountPerMile(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetPrePaidMileageRateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetPrePaidMileageRateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetPrePaidMileageRateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetPrePaidMileageRateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAmountPerMile();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * optional int32 amount_per_mile = 1;
 * @return {number}
 */ proto.fleet_service.GetPrePaidMileageRateResponse.prototype.getAmountPerMile = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetPrePaidMileageRateResponse} returns this
 */ proto.fleet_service.GetPrePaidMileageRateResponse.prototype.setAmountPerMile = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetMileageRatesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetMileageRatesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetMileageRatesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetMileageRatesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetMileageRatesRequest}
 */ proto.fleet_service.GetMileageRatesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetMileageRatesRequest;
    return proto.fleet_service.GetMileageRatesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetMileageRatesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetMileageRatesRequest}
 */ proto.fleet_service.GetMileageRatesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetMileageRatesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetMileageRatesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetMileageRatesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetMileageRatesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.fleet_service.GetMileageRatesRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetMileageRatesRequest} returns this
 */ proto.fleet_service.GetMileageRatesRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetMileageRatesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetMileageRatesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetMileageRatesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetMileageRatesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            prePaidRate: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            punitiveRate: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetMileageRatesResponse}
 */ proto.fleet_service.GetMileageRatesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetMileageRatesResponse;
    return proto.fleet_service.GetMileageRatesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetMileageRatesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetMileageRatesResponse}
 */ proto.fleet_service.GetMileageRatesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPrePaidRate(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPunitiveRate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetMileageRatesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetMileageRatesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetMileageRatesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetMileageRatesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPrePaidRate();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getPunitiveRate();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional int32 pre_paid_rate = 1;
 * @return {number}
 */ proto.fleet_service.GetMileageRatesResponse.prototype.getPrePaidRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetMileageRatesResponse} returns this
 */ proto.fleet_service.GetMileageRatesResponse.prototype.setPrePaidRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 punitive_rate = 2;
 * @return {number}
 */ proto.fleet_service.GetMileageRatesResponse.prototype.getPunitiveRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetMileageRatesResponse} returns this
 */ proto.fleet_service.GetMileageRatesResponse.prototype.setPunitiveRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.StatusGroup.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.StatusGroup.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.StatusGroup.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.StatusGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.StatusGroup.toObject = function(includeInstance, msg) {
        var f, obj = {
            status: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            count: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            vehiclesList: $8M67s.Message.toObjectList(msg.getVehiclesList(), $9YICB.Vehicle.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.StatusGroup}
 */ proto.fleet_service.StatusGroup.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.StatusGroup;
    return proto.fleet_service.StatusGroup.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.StatusGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.StatusGroup}
 */ proto.fleet_service.StatusGroup.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.fleet_service.StatusGroup.GroupStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setCount(value);
                break;
            case 3:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.addVehicles(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.StatusGroup.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.StatusGroup.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.StatusGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.StatusGroup.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getCount();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getVehiclesList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * @enum {number}
 */ proto.fleet_service.StatusGroup.GroupStatus = {
    GROUP_STATUS_UNSPECIFIED: 0,
    GROUP_STATUS_IN_PENDING: 1,
    GROUP_STATUS_READY: 2,
    GROUP_STATUS_SCHEDULED: 3,
    GROUP_STATUS_COMPLETED: 4,
    GROUP_STATUS_OUT_OF_SERVICE: 5
};
/**
 * optional GroupStatus status = 1;
 * @return {!proto.fleet_service.StatusGroup.GroupStatus}
 */ proto.fleet_service.StatusGroup.prototype.getStatus = function() {
    return /** @type {!proto.fleet_service.StatusGroup.GroupStatus} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.fleet_service.StatusGroup.GroupStatus} value
 * @return {!proto.fleet_service.StatusGroup} returns this
 */ proto.fleet_service.StatusGroup.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional int32 count = 2;
 * @return {number}
 */ proto.fleet_service.StatusGroup.prototype.getCount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.StatusGroup} returns this
 */ proto.fleet_service.StatusGroup.prototype.setCount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * repeated vehicle.Vehicle vehicles = 3;
 * @return {!Array<!proto.vehicle.Vehicle>}
 */ proto.fleet_service.StatusGroup.prototype.getVehiclesList = function() {
    return /** @type{!Array<!proto.vehicle.Vehicle>} */ $8M67s.Message.getRepeatedWrapperField(this, $9YICB.Vehicle, 3);
};
/**
 * @param {!Array<!proto.vehicle.Vehicle>} value
 * @return {!proto.fleet_service.StatusGroup} returns this
*/ proto.fleet_service.StatusGroup.prototype.setVehiclesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.vehicle.Vehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Vehicle}
 */ proto.fleet_service.StatusGroup.prototype.addVehicles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.vehicle.Vehicle, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.StatusGroup} returns this
 */ proto.fleet_service.StatusGroup.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.AssignVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.AssignVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.AssignVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AssignVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.AssignVehicleRequest}
 */ proto.fleet_service.AssignVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.AssignVehicleRequest;
    return proto.fleet_service.AssignVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.AssignVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.AssignVehicleRequest}
 */ proto.fleet_service.AssignVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.AssignVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.AssignVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.AssignVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AssignVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.AssignVehicleRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AssignVehicleRequest} returns this
 */ proto.fleet_service.AssignVehicleRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.fleet_service.AssignVehicleRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AssignVehicleRequest} returns this
 */ proto.fleet_service.AssignVehicleRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.AssignVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.AssignVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.AssignVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AssignVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.AssignVehicleResponse}
 */ proto.fleet_service.AssignVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.AssignVehicleResponse;
    return proto.fleet_service.AssignVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.AssignVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.AssignVehicleResponse}
 */ proto.fleet_service.AssignVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.AssignVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.AssignVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.AssignVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AssignVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UnassignVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UnassignVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UnassignVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UnassignVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UnassignVehicleRequest}
 */ proto.fleet_service.UnassignVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UnassignVehicleRequest;
    return proto.fleet_service.UnassignVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UnassignVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UnassignVehicleRequest}
 */ proto.fleet_service.UnassignVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UnassignVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UnassignVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UnassignVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UnassignVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.UnassignVehicleRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UnassignVehicleRequest} returns this
 */ proto.fleet_service.UnassignVehicleRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.fleet_service.UnassignVehicleRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UnassignVehicleRequest} returns this
 */ proto.fleet_service.UnassignVehicleRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UnassignVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UnassignVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UnassignVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UnassignVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UnassignVehicleResponse}
 */ proto.fleet_service.UnassignVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UnassignVehicleResponse;
    return proto.fleet_service.UnassignVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UnassignVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UnassignVehicleResponse}
 */ proto.fleet_service.UnassignVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UnassignVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UnassignVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UnassignVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UnassignVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListOrdersRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListOrdersRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListOrdersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListOrdersRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            startDate: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            endDate: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            pageNumber: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            pageSize: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            orderState: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListOrdersRequest}
 */ proto.fleet_service.ListOrdersRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListOrdersRequest;
    return proto.fleet_service.ListOrdersRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListOrdersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListOrdersRequest}
 */ proto.fleet_service.ListOrdersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setStartDate(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEndDate(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPageNumber(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPageSize(value);
                break;
            case 5:
                var value = /** @type {!proto.fleet_service.ListOrdersRequest.OrderState} */ reader.readEnum();
                msg.setOrderState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListOrdersRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListOrdersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListOrdersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListOrdersRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStartDate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getEndDate();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getPageNumber();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getPageSize();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getOrderState();
    if (f !== 0.0) writer.writeEnum(5, f);
};
/**
 * @enum {number}
 */ proto.fleet_service.ListOrdersRequest.OrderState = {
    ACCOUNT_CREATED: 0,
    PENDING: 1,
    QUALIFIED: 2,
    VEHICLE: 3,
    REJECTED: 4
};
/**
 * optional string start_date = 1;
 * @return {string}
 */ proto.fleet_service.ListOrdersRequest.prototype.getStartDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListOrdersRequest} returns this
 */ proto.fleet_service.ListOrdersRequest.prototype.setStartDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string end_date = 2;
 * @return {string}
 */ proto.fleet_service.ListOrdersRequest.prototype.getEndDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListOrdersRequest} returns this
 */ proto.fleet_service.ListOrdersRequest.prototype.setEndDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 page_number = 3;
 * @return {number}
 */ proto.fleet_service.ListOrdersRequest.prototype.getPageNumber = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListOrdersRequest} returns this
 */ proto.fleet_service.ListOrdersRequest.prototype.setPageNumber = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 page_size = 4;
 * @return {number}
 */ proto.fleet_service.ListOrdersRequest.prototype.getPageSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListOrdersRequest} returns this
 */ proto.fleet_service.ListOrdersRequest.prototype.setPageSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional OrderState order_state = 5;
 * @return {!proto.fleet_service.ListOrdersRequest.OrderState}
 */ proto.fleet_service.ListOrdersRequest.prototype.getOrderState = function() {
    return /** @type {!proto.fleet_service.ListOrdersRequest.OrderState} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.fleet_service.ListOrdersRequest.OrderState} value
 * @return {!proto.fleet_service.ListOrdersRequest} returns this
 */ proto.fleet_service.ListOrdersRequest.prototype.setOrderState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListOrdersResponse.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListOrdersResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListOrdersResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListOrdersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListOrdersResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            totalOrders: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicleOrdersList: $8M67s.Message.toObjectList(msg.getVehicleOrdersList(), proto.fleet_service.VehicleOrder.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListOrdersResponse}
 */ proto.fleet_service.ListOrdersResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListOrdersResponse;
    return proto.fleet_service.ListOrdersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListOrdersResponse}
 */ proto.fleet_service.ListOrdersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotalOrders(value);
                break;
            case 2:
                var value = new proto.fleet_service.VehicleOrder;
                reader.readMessage(value, proto.fleet_service.VehicleOrder.deserializeBinaryFromReader);
                msg.addVehicleOrders(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListOrdersResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListOrdersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListOrdersResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTotalOrders();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getVehicleOrdersList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.fleet_service.VehicleOrder.serializeBinaryToWriter);
};
/**
 * optional int32 total_orders = 1;
 * @return {number}
 */ proto.fleet_service.ListOrdersResponse.prototype.getTotalOrders = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListOrdersResponse} returns this
 */ proto.fleet_service.ListOrdersResponse.prototype.setTotalOrders = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * repeated VehicleOrder vehicle_orders = 2;
 * @return {!Array<!proto.fleet_service.VehicleOrder>}
 */ proto.fleet_service.ListOrdersResponse.prototype.getVehicleOrdersList = function() {
    return /** @type{!Array<!proto.fleet_service.VehicleOrder>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.VehicleOrder, 2);
};
/**
 * @param {!Array<!proto.fleet_service.VehicleOrder>} value
 * @return {!proto.fleet_service.ListOrdersResponse} returns this
*/ proto.fleet_service.ListOrdersResponse.prototype.setVehicleOrdersList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.fleet_service.VehicleOrder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.VehicleOrder}
 */ proto.fleet_service.ListOrdersResponse.prototype.addVehicleOrders = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet_service.VehicleOrder, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListOrdersResponse} returns this
 */ proto.fleet_service.ListOrdersResponse.prototype.clearVehicleOrdersList = function() {
    return this.setVehicleOrdersList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.VehicleOrder.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.VehicleOrder.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.VehicleOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehicleOrder.toObject = function(includeInstance, msg) {
        var f, obj = {
            pickupDate: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            depositPaidDate: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            subscriptionStatus: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            dealerName: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            customerName: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            customerAccountNumber: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            vehicleModelAndTrim: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            vehicleMiles: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            vehicleColor: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            dateListed: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            vehicleVin: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            securityDeposit: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            startPayment: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            monthlyPayment: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            reservationDeposit: $8M67s.Message.getFieldWithDefault(msg, 17, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.VehicleOrder}
 */ proto.fleet_service.VehicleOrder.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.VehicleOrder;
    return proto.fleet_service.VehicleOrder.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.VehicleOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.VehicleOrder}
 */ proto.fleet_service.VehicleOrder.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPickupDate(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDepositPaidDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionStatus(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerName(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerName(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerAccountNumber(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleModelAndTrim(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleMiles(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleColor(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setDateListed(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleVin(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readInt32();
                msg.setSecurityDeposit(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartPayment(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyPayment(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReservationDeposit(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.VehicleOrder.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.VehicleOrder.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.VehicleOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehicleOrder.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPickupDate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDepositPaidDate();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSubscriptionStatus();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getDealerName();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getCustomerName();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getCustomerAccountNumber();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getVehicleModelAndTrim();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getVehicleMiles();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getVehicleColor();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getDateListed();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getVehicleVin();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getSecurityDeposit();
    if (f !== 0) writer.writeInt32(14, f);
    f = message.getStartPayment();
    if (f !== 0) writer.writeInt32(15, f);
    f = message.getMonthlyPayment();
    if (f !== 0) writer.writeInt32(16, f);
    f = message.getReservationDeposit();
    if (f !== 0) writer.writeInt32(17, f);
};
/**
 * optional string pickup_date = 1;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getPickupDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setPickupDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string deposit_paid_date = 2;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getDepositPaidDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setDepositPaidDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string subscription_status = 3;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getSubscriptionStatus = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setSubscriptionStatus = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string dealer_id = 4;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string dealer_name = 5;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getDealerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setDealerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string customer_name = 6;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getCustomerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setCustomerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string customer_account_number = 7;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getCustomerAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setCustomerAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string subscription_id = 8;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string vehicle_model_and_trim = 9;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getVehicleModelAndTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setVehicleModelAndTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string vehicle_miles = 10;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getVehicleMiles = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setVehicleMiles = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string vehicle_color = 11;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getVehicleColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setVehicleColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string date_listed = 12;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getDateListed = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setDateListed = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string vehicle_vin = 13;
 * @return {string}
 */ proto.fleet_service.VehicleOrder.prototype.getVehicleVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setVehicleVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional int32 security_deposit = 14;
 * @return {number}
 */ proto.fleet_service.VehicleOrder.prototype.getSecurityDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setSecurityDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 14, value);
};
/**
 * optional int32 start_payment = 15;
 * @return {number}
 */ proto.fleet_service.VehicleOrder.prototype.getStartPayment = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setStartPayment = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * optional int32 monthly_payment = 16;
 * @return {number}
 */ proto.fleet_service.VehicleOrder.prototype.getMonthlyPayment = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setMonthlyPayment = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
/**
 * optional int32 reservation_deposit = 17;
 * @return {number}
 */ proto.fleet_service.VehicleOrder.prototype.getReservationDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 17, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.VehicleOrder} returns this
 */ proto.fleet_service.VehicleOrder.prototype.setReservationDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 17, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.AddVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.AddVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.AddVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleJson: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            financier: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.AddVehicleRequest}
 */ proto.fleet_service.AddVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.AddVehicleRequest;
    return proto.fleet_service.AddVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.AddVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.AddVehicleRequest}
 */ proto.fleet_service.AddVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleJson(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setFinancier(value);
                break;
            case 1:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.AddVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.AddVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.AddVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleJson();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getFinancier();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional string vehicle_json = 2;
 * @return {string}
 */ proto.fleet_service.AddVehicleRequest.prototype.getVehicleJson = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AddVehicleRequest} returns this
 */ proto.fleet_service.AddVehicleRequest.prototype.setVehicleJson = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string program_id = 3;
 * @return {string}
 */ proto.fleet_service.AddVehicleRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AddVehicleRequest} returns this
 */ proto.fleet_service.AddVehicleRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string financier = 4;
 * @return {string}
 */ proto.fleet_service.AddVehicleRequest.prototype.getFinancier = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AddVehicleRequest} returns this
 */ proto.fleet_service.AddVehicleRequest.prototype.setFinancier = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional vehicle.Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.fleet_service.AddVehicleRequest.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.fleet_service.AddVehicleRequest} returns this
*/ proto.fleet_service.AddVehicleRequest.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.AddVehicleRequest} returns this
 */ proto.fleet_service.AddVehicleRequest.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.AddVehicleRequest.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.AddVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.AddVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.AddVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            added: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.AddVehicleResponse}
 */ proto.fleet_service.AddVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.AddVehicleResponse;
    return proto.fleet_service.AddVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.AddVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.AddVehicleResponse}
 */ proto.fleet_service.AddVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setAdded(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.AddVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.AddVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.AddVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAdded();
    if (f) writer.writeBool(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional bool added = 1;
 * @return {boolean}
 */ proto.fleet_service.AddVehicleResponse.prototype.getAdded = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.AddVehicleResponse} returns this
 */ proto.fleet_service.AddVehicleResponse.prototype.setAdded = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.fleet_service.AddVehicleResponse.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AddVehicleResponse} returns this
 */ proto.fleet_service.AddVehicleResponse.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.AddVehiclesRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.AddVehiclesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.AddVehiclesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.AddVehiclesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddVehiclesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleJsonsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            programId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            financier: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.AddVehiclesRequest}
 */ proto.fleet_service.AddVehiclesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.AddVehiclesRequest;
    return proto.fleet_service.AddVehiclesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.AddVehiclesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.AddVehiclesRequest}
 */ proto.fleet_service.AddVehiclesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addVehicleJsons(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFinancier(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.AddVehiclesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.AddVehiclesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.AddVehiclesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddVehiclesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleJsonsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFinancier();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * repeated string vehicle_jsons = 1;
 * @return {!Array<string>}
 */ proto.fleet_service.AddVehiclesRequest.prototype.getVehicleJsonsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.AddVehiclesRequest} returns this
 */ proto.fleet_service.AddVehiclesRequest.prototype.setVehicleJsonsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.AddVehiclesRequest} returns this
 */ proto.fleet_service.AddVehiclesRequest.prototype.addVehicleJsons = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.AddVehiclesRequest} returns this
 */ proto.fleet_service.AddVehiclesRequest.prototype.clearVehicleJsonsList = function() {
    return this.setVehicleJsonsList([]);
};
/**
 * optional string program_id = 2;
 * @return {string}
 */ proto.fleet_service.AddVehiclesRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AddVehiclesRequest} returns this
 */ proto.fleet_service.AddVehiclesRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string financier = 3;
 * @return {string}
 */ proto.fleet_service.AddVehiclesRequest.prototype.getFinancier = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.AddVehiclesRequest} returns this
 */ proto.fleet_service.AddVehiclesRequest.prototype.setFinancier = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.AddVehiclesResponse.repeatedFields_ = [
    1,
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.AddVehiclesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.AddVehiclesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.AddVehiclesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddVehiclesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehiclesList: $8M67s.Message.toObjectList(msg.getVehiclesList(), proto.fleet_service.Vehicle.toObject, includeInstance),
            errorsList: (f = $8M67s.Message.getRepeatedField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.AddVehiclesResponse}
 */ proto.fleet_service.AddVehiclesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.AddVehiclesResponse;
    return proto.fleet_service.AddVehiclesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.AddVehiclesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.AddVehiclesResponse}
 */ proto.fleet_service.AddVehiclesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.Vehicle;
                reader.readMessage(value, proto.fleet_service.Vehicle.deserializeBinaryFromReader);
                msg.addVehicles(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.addErrors(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.AddVehiclesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.AddVehiclesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.AddVehiclesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.AddVehiclesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehiclesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.Vehicle.serializeBinaryToWriter);
    f = message.getErrorsList();
    if (f.length > 0) writer.writeRepeatedString(2, f);
};
/**
 * repeated Vehicle vehicles = 1;
 * @return {!Array<!proto.fleet_service.Vehicle>}
 */ proto.fleet_service.AddVehiclesResponse.prototype.getVehiclesList = function() {
    return /** @type{!Array<!proto.fleet_service.Vehicle>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.Vehicle, 1);
};
/**
 * @param {!Array<!proto.fleet_service.Vehicle>} value
 * @return {!proto.fleet_service.AddVehiclesResponse} returns this
*/ proto.fleet_service.AddVehiclesResponse.prototype.setVehiclesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.Vehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.Vehicle}
 */ proto.fleet_service.AddVehiclesResponse.prototype.addVehicles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.Vehicle, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.AddVehiclesResponse} returns this
 */ proto.fleet_service.AddVehiclesResponse.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
};
/**
 * repeated string errors = 2;
 * @return {!Array<string>}
 */ proto.fleet_service.AddVehiclesResponse.prototype.getErrorsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.AddVehiclesResponse} returns this
 */ proto.fleet_service.AddVehiclesResponse.prototype.setErrorsList = function(value) {
    return $8M67s.Message.setField(this, 2, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.AddVehiclesResponse} returns this
 */ proto.fleet_service.AddVehiclesResponse.prototype.addErrors = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.AddVehiclesResponse} returns this
 */ proto.fleet_service.AddVehiclesResponse.prototype.clearErrorsList = function() {
    return this.setErrorsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.VehicleCriteria.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.VehicleCriteria.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.VehicleCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehicleCriteria.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            query: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.VehicleCriteria}
 */ proto.fleet_service.VehicleCriteria.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.VehicleCriteria;
    return proto.fleet_service.VehicleCriteria.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.VehicleCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.VehicleCriteria}
 */ proto.fleet_service.VehicleCriteria.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setQuery(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.VehicleCriteria.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.VehicleCriteria.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.VehicleCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehicleCriteria.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getQuery();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.fleet_service.VehicleCriteria.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleCriteria} returns this
 */ proto.fleet_service.VehicleCriteria.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string query = 2;
 * @return {string}
 */ proto.fleet_service.VehicleCriteria.prototype.getQuery = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleCriteria} returns this
 */ proto.fleet_service.VehicleCriteria.prototype.setQuery = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListVehiclesRequest.repeatedFields_ = [
    1,
    6,
    8
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListVehiclesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListVehiclesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListVehiclesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            criteriaList: $8M67s.Message.toObjectList(msg.getCriteriaList(), proto.fleet_service.VehicleCriteria.toObject, includeInstance),
            page: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            resultsPerPage: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            order: (f = msg.getOrder()) && proto.fleet_service.OrderCriteria.toObject(includeInstance, f),
            trimPropertiesList: (f = $8M67s.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
            listByStatus: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            programIdsList: (f = $8M67s.Message.getRepeatedField(msg, 8)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListVehiclesRequest}
 */ proto.fleet_service.ListVehiclesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListVehiclesRequest;
    return proto.fleet_service.ListVehiclesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListVehiclesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListVehiclesRequest}
 */ proto.fleet_service.ListVehiclesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.VehicleCriteria;
                reader.readMessage(value, proto.fleet_service.VehicleCriteria.deserializeBinaryFromReader);
                msg.addCriteria(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPage(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setResultsPerPage(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 5:
                var value = new proto.fleet_service.OrderCriteria;
                reader.readMessage(value, proto.fleet_service.OrderCriteria.deserializeBinaryFromReader);
                msg.setOrder(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.addTrimProperties(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setListByStatus(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.addProgramIds(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListVehiclesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListVehiclesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListVehiclesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCriteriaList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.VehicleCriteria.serializeBinaryToWriter);
    f = message.getPage();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getResultsPerPage();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getOrder();
    if (f != null) writer.writeMessage(5, f, proto.fleet_service.OrderCriteria.serializeBinaryToWriter);
    f = message.getTrimPropertiesList();
    if (f.length > 0) writer.writeRepeatedString(6, f);
    f = message.getListByStatus();
    if (f) writer.writeBool(7, f);
    f = message.getProgramIdsList();
    if (f.length > 0) writer.writeRepeatedString(8, f);
};
/**
 * repeated VehicleCriteria criteria = 1;
 * @return {!Array<!proto.fleet_service.VehicleCriteria>}
 */ proto.fleet_service.ListVehiclesRequest.prototype.getCriteriaList = function() {
    return /** @type{!Array<!proto.fleet_service.VehicleCriteria>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.VehicleCriteria, 1);
};
/**
 * @param {!Array<!proto.fleet_service.VehicleCriteria>} value
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
*/ proto.fleet_service.ListVehiclesRequest.prototype.setCriteriaList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.VehicleCriteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.VehicleCriteria}
 */ proto.fleet_service.ListVehiclesRequest.prototype.addCriteria = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.VehicleCriteria, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.clearCriteriaList = function() {
    return this.setCriteriaList([]);
};
/**
 * optional int32 page = 2;
 * @return {number}
 */ proto.fleet_service.ListVehiclesRequest.prototype.getPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.setPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 results_per_page = 3;
 * @return {number}
 */ proto.fleet_service.ListVehiclesRequest.prototype.getResultsPerPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.setResultsPerPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string customer_id = 4;
 * @return {string}
 */ proto.fleet_service.ListVehiclesRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional OrderCriteria order = 5;
 * @return {?proto.fleet_service.OrderCriteria}
 */ proto.fleet_service.ListVehiclesRequest.prototype.getOrder = function() {
    return /** @type{?proto.fleet_service.OrderCriteria} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.OrderCriteria, 5);
};
/**
 * @param {?proto.fleet_service.OrderCriteria|undefined} value
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
*/ proto.fleet_service.ListVehiclesRequest.prototype.setOrder = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.clearOrder = function() {
    return this.setOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.ListVehiclesRequest.prototype.hasOrder = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * repeated string trim_properties = 6;
 * @return {!Array<string>}
 */ proto.fleet_service.ListVehiclesRequest.prototype.getTrimPropertiesList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 6);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.setTrimPropertiesList = function(value) {
    return $8M67s.Message.setField(this, 6, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.addTrimProperties = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 6, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.clearTrimPropertiesList = function() {
    return this.setTrimPropertiesList([]);
};
/**
 * optional bool list_by_status = 7;
 * @return {boolean}
 */ proto.fleet_service.ListVehiclesRequest.prototype.getListByStatus = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.setListByStatus = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * repeated string program_ids = 8;
 * @return {!Array<string>}
 */ proto.fleet_service.ListVehiclesRequest.prototype.getProgramIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 8);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.setProgramIdsList = function(value) {
    return $8M67s.Message.setField(this, 8, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.addProgramIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 8, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListVehiclesRequest} returns this
 */ proto.fleet_service.ListVehiclesRequest.prototype.clearProgramIdsList = function() {
    return this.setProgramIdsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListAllVehiclesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListAllVehiclesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListAllVehiclesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListAllVehiclesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListAllVehiclesRequest}
 */ proto.fleet_service.ListAllVehiclesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListAllVehiclesRequest;
    return proto.fleet_service.ListAllVehiclesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListAllVehiclesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListAllVehiclesRequest}
 */ proto.fleet_service.ListAllVehiclesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListAllVehiclesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListAllVehiclesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListAllVehiclesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListAllVehiclesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListAllVehiclesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListAllVehiclesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListAllVehiclesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListAllVehiclesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListAllVehiclesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehiclesList: $8M67s.Message.toObjectList(msg.getVehiclesList(), proto.fleet_service.Vehicle.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListAllVehiclesResponse}
 */ proto.fleet_service.ListAllVehiclesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListAllVehiclesResponse;
    return proto.fleet_service.ListAllVehiclesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListAllVehiclesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListAllVehiclesResponse}
 */ proto.fleet_service.ListAllVehiclesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.Vehicle;
                reader.readMessage(value, proto.fleet_service.Vehicle.deserializeBinaryFromReader);
                msg.addVehicles(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListAllVehiclesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListAllVehiclesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListAllVehiclesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListAllVehiclesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehiclesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.Vehicle.serializeBinaryToWriter);
};
/**
 * repeated Vehicle vehicles = 1;
 * @return {!Array<!proto.fleet_service.Vehicle>}
 */ proto.fleet_service.ListAllVehiclesResponse.prototype.getVehiclesList = function() {
    return /** @type{!Array<!proto.fleet_service.Vehicle>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.Vehicle, 1);
};
/**
 * @param {!Array<!proto.fleet_service.Vehicle>} value
 * @return {!proto.fleet_service.ListAllVehiclesResponse} returns this
*/ proto.fleet_service.ListAllVehiclesResponse.prototype.setVehiclesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.Vehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.Vehicle}
 */ proto.fleet_service.ListAllVehiclesResponse.prototype.addVehicles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.Vehicle, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListAllVehiclesResponse} returns this
 */ proto.fleet_service.ListAllVehiclesResponse.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListVehicleMakesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListVehicleMakesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListVehicleMakesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehicleMakesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListVehicleMakesRequest}
 */ proto.fleet_service.ListVehicleMakesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListVehicleMakesRequest;
    return proto.fleet_service.ListVehicleMakesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListVehicleMakesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListVehicleMakesRequest}
 */ proto.fleet_service.ListVehicleMakesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListVehicleMakesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListVehicleMakesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListVehicleMakesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehicleMakesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListVehicleMakesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListVehicleMakesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListVehicleMakesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListVehicleMakesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehicleMakesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            makesList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListVehicleMakesResponse}
 */ proto.fleet_service.ListVehicleMakesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListVehicleMakesResponse;
    return proto.fleet_service.ListVehicleMakesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListVehicleMakesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListVehicleMakesResponse}
 */ proto.fleet_service.ListVehicleMakesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addMakes(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListVehicleMakesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListVehicleMakesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListVehicleMakesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehicleMakesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMakesList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string makes = 1;
 * @return {!Array<string>}
 */ proto.fleet_service.ListVehicleMakesResponse.prototype.getMakesList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.ListVehicleMakesResponse} returns this
 */ proto.fleet_service.ListVehicleMakesResponse.prototype.setMakesList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.ListVehicleMakesResponse} returns this
 */ proto.fleet_service.ListVehicleMakesResponse.prototype.addMakes = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListVehicleMakesResponse} returns this
 */ proto.fleet_service.ListVehicleMakesResponse.prototype.clearMakesList = function() {
    return this.setMakesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListModelsByMakeRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListModelsByMakeRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListModelsByMakeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListModelsByMakeRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            make: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListModelsByMakeRequest}
 */ proto.fleet_service.ListModelsByMakeRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListModelsByMakeRequest;
    return proto.fleet_service.ListModelsByMakeRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListModelsByMakeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListModelsByMakeRequest}
 */ proto.fleet_service.ListModelsByMakeRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListModelsByMakeRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListModelsByMakeRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListModelsByMakeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListModelsByMakeRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMake();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string make = 1;
 * @return {string}
 */ proto.fleet_service.ListModelsByMakeRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListModelsByMakeRequest} returns this
 */ proto.fleet_service.ListModelsByMakeRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListModelsByMakeResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListModelsByMakeResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListModelsByMakeResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListModelsByMakeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListModelsByMakeResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            modelsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListModelsByMakeResponse}
 */ proto.fleet_service.ListModelsByMakeResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListModelsByMakeResponse;
    return proto.fleet_service.ListModelsByMakeResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListModelsByMakeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListModelsByMakeResponse}
 */ proto.fleet_service.ListModelsByMakeResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addModels(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListModelsByMakeResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListModelsByMakeResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListModelsByMakeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListModelsByMakeResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getModelsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string models = 1;
 * @return {!Array<string>}
 */ proto.fleet_service.ListModelsByMakeResponse.prototype.getModelsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.ListModelsByMakeResponse} returns this
 */ proto.fleet_service.ListModelsByMakeResponse.prototype.setModelsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.ListModelsByMakeResponse} returns this
 */ proto.fleet_service.ListModelsByMakeResponse.prototype.addModels = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListModelsByMakeResponse} returns this
 */ proto.fleet_service.ListModelsByMakeResponse.prototype.clearModelsList = function() {
    return this.setModelsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.OrderCriteria.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.OrderCriteria.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.OrderCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.OrderCriteria.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            direction: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.OrderCriteria}
 */ proto.fleet_service.OrderCriteria.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.OrderCriteria;
    return proto.fleet_service.OrderCriteria.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.OrderCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.OrderCriteria}
 */ proto.fleet_service.OrderCriteria.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {!proto.fleet_service.OrderCriteria.Direction} */ reader.readEnum();
                msg.setDirection(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.OrderCriteria.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.OrderCriteria.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.OrderCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.OrderCriteria.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDirection();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * @enum {number}
 */ proto.fleet_service.OrderCriteria.Direction = {
    ASC: 0,
    DESC: 1
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.fleet_service.OrderCriteria.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.OrderCriteria} returns this
 */ proto.fleet_service.OrderCriteria.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Direction direction = 2;
 * @return {!proto.fleet_service.OrderCriteria.Direction}
 */ proto.fleet_service.OrderCriteria.prototype.getDirection = function() {
    return /** @type {!proto.fleet_service.OrderCriteria.Direction} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.fleet_service.OrderCriteria.Direction} value
 * @return {!proto.fleet_service.OrderCriteria} returns this
 */ proto.fleet_service.OrderCriteria.prototype.setDirection = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.NexusVehicle.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.NexusVehicle.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.NexusVehicle.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.NexusVehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.NexusVehicle.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f),
            customersList: $8M67s.Message.toObjectList(msg.getCustomersList(), $3QqPt.Customer.toObject, includeInstance),
            monthsInService: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            purchasePrice: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            currentValue: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            status: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.NexusVehicle}
 */ proto.fleet_service.NexusVehicle.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.NexusVehicle;
    return proto.fleet_service.NexusVehicle.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.NexusVehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.NexusVehicle}
 */ proto.fleet_service.NexusVehicle.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            case 2:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.addCustomers(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthsInService(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPurchasePrice(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCurrentValue(value);
                break;
            case 6:
                var value = /** @type {!proto.fleet_service.NexusVehicle.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.NexusVehicle.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.NexusVehicle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.NexusVehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.NexusVehicle.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, $9YICB.Vehicle.serializeBinaryToWriter);
    f = message.getCustomersList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.Customer.serializeBinaryToWriter);
    f = message.getMonthsInService();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getPurchasePrice();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getCurrentValue();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(6, f);
};
/**
 * @enum {number}
 */ proto.fleet_service.NexusVehicle.Status = {
    INELIGIBLE: 0,
    ELIGIBLE: 1,
    ASSIGNED: 2,
    SUBSCRIBED: 3
};
/**
 * optional vehicle.Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.fleet_service.NexusVehicle.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.fleet_service.NexusVehicle} returns this
*/ proto.fleet_service.NexusVehicle.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.NexusVehicle} returns this
 */ proto.fleet_service.NexusVehicle.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.NexusVehicle.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated domain.Customer customers = 2;
 * @return {!Array<!proto.domain.Customer>}
 */ proto.fleet_service.NexusVehicle.prototype.getCustomersList = function() {
    return /** @type{!Array<!proto.domain.Customer>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Customer, 2);
};
/**
 * @param {!Array<!proto.domain.Customer>} value
 * @return {!proto.fleet_service.NexusVehicle} returns this
*/ proto.fleet_service.NexusVehicle.prototype.setCustomersList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.Customer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Customer}
 */ proto.fleet_service.NexusVehicle.prototype.addCustomers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.Customer, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.NexusVehicle} returns this
 */ proto.fleet_service.NexusVehicle.prototype.clearCustomersList = function() {
    return this.setCustomersList([]);
};
/**
 * optional int32 months_in_service = 3;
 * @return {number}
 */ proto.fleet_service.NexusVehicle.prototype.getMonthsInService = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.NexusVehicle} returns this
 */ proto.fleet_service.NexusVehicle.prototype.setMonthsInService = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int64 purchase_price = 4;
 * @return {number}
 */ proto.fleet_service.NexusVehicle.prototype.getPurchasePrice = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.NexusVehicle} returns this
 */ proto.fleet_service.NexusVehicle.prototype.setPurchasePrice = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 current_value = 5;
 * @return {number}
 */ proto.fleet_service.NexusVehicle.prototype.getCurrentValue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.NexusVehicle} returns this
 */ proto.fleet_service.NexusVehicle.prototype.setCurrentValue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional Status status = 6;
 * @return {!proto.fleet_service.NexusVehicle.Status}
 */ proto.fleet_service.NexusVehicle.prototype.getStatus = function() {
    return /** @type {!proto.fleet_service.NexusVehicle.Status} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.fleet_service.NexusVehicle.Status} value
 * @return {!proto.fleet_service.NexusVehicle} returns this
 */ proto.fleet_service.NexusVehicle.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListVehiclesResponse.repeatedFields_ = [
    2,
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListVehiclesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListVehiclesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListVehiclesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            total: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehiclesList: $8M67s.Message.toObjectList(msg.getVehiclesList(), proto.fleet_service.NexusVehicle.toObject, includeInstance),
            statusGroupsList: $8M67s.Message.toObjectList(msg.getStatusGroupsList(), proto.fleet_service.StatusGroup.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListVehiclesResponse}
 */ proto.fleet_service.ListVehiclesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListVehiclesResponse;
    return proto.fleet_service.ListVehiclesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListVehiclesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListVehiclesResponse}
 */ proto.fleet_service.ListVehiclesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotal(value);
                break;
            case 2:
                var value = new proto.fleet_service.NexusVehicle;
                reader.readMessage(value, proto.fleet_service.NexusVehicle.deserializeBinaryFromReader);
                msg.addVehicles(value);
                break;
            case 3:
                var value = new proto.fleet_service.StatusGroup;
                reader.readMessage(value, proto.fleet_service.StatusGroup.deserializeBinaryFromReader);
                msg.addStatusGroups(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListVehiclesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListVehiclesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListVehiclesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTotal();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getVehiclesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.fleet_service.NexusVehicle.serializeBinaryToWriter);
    f = message.getStatusGroupsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.fleet_service.StatusGroup.serializeBinaryToWriter);
};
/**
 * optional int32 total = 1;
 * @return {number}
 */ proto.fleet_service.ListVehiclesResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListVehiclesResponse} returns this
 */ proto.fleet_service.ListVehiclesResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * repeated NexusVehicle vehicles = 2;
 * @return {!Array<!proto.fleet_service.NexusVehicle>}
 */ proto.fleet_service.ListVehiclesResponse.prototype.getVehiclesList = function() {
    return /** @type{!Array<!proto.fleet_service.NexusVehicle>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.NexusVehicle, 2);
};
/**
 * @param {!Array<!proto.fleet_service.NexusVehicle>} value
 * @return {!proto.fleet_service.ListVehiclesResponse} returns this
*/ proto.fleet_service.ListVehiclesResponse.prototype.setVehiclesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.fleet_service.NexusVehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.NexusVehicle}
 */ proto.fleet_service.ListVehiclesResponse.prototype.addVehicles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet_service.NexusVehicle, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListVehiclesResponse} returns this
 */ proto.fleet_service.ListVehiclesResponse.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
};
/**
 * repeated StatusGroup status_groups = 3;
 * @return {!Array<!proto.fleet_service.StatusGroup>}
 */ proto.fleet_service.ListVehiclesResponse.prototype.getStatusGroupsList = function() {
    return /** @type{!Array<!proto.fleet_service.StatusGroup>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.StatusGroup, 3);
};
/**
 * @param {!Array<!proto.fleet_service.StatusGroup>} value
 * @return {!proto.fleet_service.ListVehiclesResponse} returns this
*/ proto.fleet_service.ListVehiclesResponse.prototype.setStatusGroupsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.fleet_service.StatusGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.StatusGroup}
 */ proto.fleet_service.ListVehiclesResponse.prototype.addStatusGroups = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.fleet_service.StatusGroup, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListVehiclesResponse} returns this
 */ proto.fleet_service.ListVehiclesResponse.prototype.clearStatusGroupsList = function() {
    return this.setStatusGroupsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetOwnBuyItNowDetailsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetOwnBuyItNowDetailsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsRequest}
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetOwnBuyItNowDetailsRequest;
    return proto.fleet_service.GetOwnBuyItNowDetailsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetOwnBuyItNowDetailsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsRequest}
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetOwnBuyItNowDetailsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetOwnBuyItNowDetailsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsRequest} returns this
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsRequest} returns this
 */ proto.fleet_service.GetOwnBuyItNowDetailsRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetOwnBuyItNowDetailsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetOwnBuyItNowDetailsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            manufacturerSuggestedRetailPrice: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            currentValue: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            buyItNowPrice: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsResponse}
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetOwnBuyItNowDetailsResponse;
    return proto.fleet_service.GetOwnBuyItNowDetailsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetOwnBuyItNowDetailsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsResponse}
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setManufacturerSuggestedRetailPrice(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setCurrentValue(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setBuyItNowPrice(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetOwnBuyItNowDetailsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetOwnBuyItNowDetailsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getManufacturerSuggestedRetailPrice();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getCurrentValue();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getBuyItNowPrice();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * optional int32 manufacturer_suggested_retail_price = 1;
 * @return {number}
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.prototype.getManufacturerSuggestedRetailPrice = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsResponse} returns this
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.prototype.setManufacturerSuggestedRetailPrice = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 current_value = 2;
 * @return {number}
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.prototype.getCurrentValue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsResponse} returns this
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.prototype.setCurrentValue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 buy_it_now_price = 3;
 * @return {number}
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.prototype.getBuyItNowPrice = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetOwnBuyItNowDetailsResponse} returns this
 */ proto.fleet_service.GetOwnBuyItNowDetailsResponse.prototype.setBuyItNowPrice = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            partialCustomer: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false),
            partialVehicle: $8M67s.Message.getBooleanFieldWithDefault(msg, 3, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleRequest}
 */ proto.fleet_service.GetVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleRequest;
    return proto.fleet_service.GetVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleRequest}
 */ proto.fleet_service.GetVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPartialCustomer(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPartialVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPartialCustomer();
    if (f) writer.writeBool(2, f);
    f = message.getPartialVehicle();
    if (f) writer.writeBool(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.GetVehicleRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetVehicleRequest} returns this
 */ proto.fleet_service.GetVehicleRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool partial_customer = 2;
 * @return {boolean}
 */ proto.fleet_service.GetVehicleRequest.prototype.getPartialCustomer = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.GetVehicleRequest} returns this
 */ proto.fleet_service.GetVehicleRequest.prototype.setPartialCustomer = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
/**
 * optional bool partial_vehicle = 3;
 * @return {boolean}
 */ proto.fleet_service.GetVehicleRequest.prototype.getPartialVehicle = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.GetVehicleRequest} returns this
 */ proto.fleet_service.GetVehicleRequest.prototype.setPartialVehicle = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f),
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleResponse}
 */ proto.fleet_service.GetVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleResponse;
    return proto.fleet_service.GetVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleResponse}
 */ proto.fleet_service.GetVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            case 2:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, $9YICB.Vehicle.serializeBinaryToWriter);
    f = message.getCustomer();
    if (f != null) writer.writeMessage(2, f, $3QqPt.Customer.serializeBinaryToWriter);
};
/**
 * optional vehicle.Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.fleet_service.GetVehicleResponse.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.fleet_service.GetVehicleResponse} returns this
*/ proto.fleet_service.GetVehicleResponse.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetVehicleResponse} returns this
 */ proto.fleet_service.GetVehicleResponse.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetVehicleResponse.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional domain.Customer customer = 2;
 * @return {?proto.domain.Customer}
 */ proto.fleet_service.GetVehicleResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 2);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.fleet_service.GetVehicleResponse} returns this
*/ proto.fleet_service.GetVehicleResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetVehicleResponse} returns this
 */ proto.fleet_service.GetVehicleResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetVehicleResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleByIdRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleByIdRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleByIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleByIdRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleByIdRequest}
 */ proto.fleet_service.GetVehicleByIdRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleByIdRequest;
    return proto.fleet_service.GetVehicleByIdRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleByIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleByIdRequest}
 */ proto.fleet_service.GetVehicleByIdRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleByIdRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleByIdRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleByIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleByIdRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.GetVehicleByIdRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetVehicleByIdRequest} returns this
 */ proto.fleet_service.GetVehicleByIdRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleByIdResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleByIdResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleByIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleByIdResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && proto.fleet_service.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleByIdResponse}
 */ proto.fleet_service.GetVehicleByIdResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleByIdResponse;
    return proto.fleet_service.GetVehicleByIdResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleByIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleByIdResponse}
 */ proto.fleet_service.GetVehicleByIdResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.Vehicle;
                reader.readMessage(value, proto.fleet_service.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleByIdResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleByIdResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleByIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleByIdResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, proto.fleet_service.Vehicle.serializeBinaryToWriter);
};
/**
 * optional Vehicle vehicle = 1;
 * @return {?proto.fleet_service.Vehicle}
 */ proto.fleet_service.GetVehicleByIdResponse.prototype.getVehicle = function() {
    return /** @type{?proto.fleet_service.Vehicle} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.Vehicle, 1);
};
/**
 * @param {?proto.fleet_service.Vehicle|undefined} value
 * @return {!proto.fleet_service.GetVehicleByIdResponse} returns this
*/ proto.fleet_service.GetVehicleByIdResponse.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetVehicleByIdResponse} returns this
 */ proto.fleet_service.GetVehicleByIdResponse.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetVehicleByIdResponse.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleByVinRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleByVinRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleByVinRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleByVinRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vin: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleByVinRequest}
 */ proto.fleet_service.GetVehicleByVinRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleByVinRequest;
    return proto.fleet_service.GetVehicleByVinRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleByVinRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleByVinRequest}
 */ proto.fleet_service.GetVehicleByVinRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleByVinRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleByVinRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleByVinRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleByVinRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVin();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string vin = 1;
 * @return {string}
 */ proto.fleet_service.GetVehicleByVinRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetVehicleByVinRequest} returns this
 */ proto.fleet_service.GetVehicleByVinRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleByVinResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleByVinResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleByVinResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleByVinResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && proto.fleet_service.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleByVinResponse}
 */ proto.fleet_service.GetVehicleByVinResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleByVinResponse;
    return proto.fleet_service.GetVehicleByVinResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleByVinResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleByVinResponse}
 */ proto.fleet_service.GetVehicleByVinResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.Vehicle;
                reader.readMessage(value, proto.fleet_service.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleByVinResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleByVinResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleByVinResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleByVinResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, proto.fleet_service.Vehicle.serializeBinaryToWriter);
};
/**
 * optional Vehicle vehicle = 1;
 * @return {?proto.fleet_service.Vehicle}
 */ proto.fleet_service.GetVehicleByVinResponse.prototype.getVehicle = function() {
    return /** @type{?proto.fleet_service.Vehicle} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.Vehicle, 1);
};
/**
 * @param {?proto.fleet_service.Vehicle|undefined} value
 * @return {!proto.fleet_service.GetVehicleByVinResponse} returns this
*/ proto.fleet_service.GetVehicleByVinResponse.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetVehicleByVinResponse} returns this
 */ proto.fleet_service.GetVehicleByVinResponse.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetVehicleByVinResponse.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.TelemetricEvent.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.TelemetricEvent.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.TelemetricEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.TelemetricEvent.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.TelemetricEvent}
 */ proto.fleet_service.TelemetricEvent.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.TelemetricEvent;
    return proto.fleet_service.TelemetricEvent.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.TelemetricEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.TelemetricEvent}
 */ proto.fleet_service.TelemetricEvent.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.TelemetricEvent.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.TelemetricEvent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.TelemetricEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.TelemetricEvent.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string Id = 1;
 * @return {string}
 */ proto.fleet_service.TelemetricEvent.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.TelemetricEvent} returns this
 */ proto.fleet_service.TelemetricEvent.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.HandleTelemetricEventResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.HandleTelemetricEventResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.HandleTelemetricEventResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.HandleTelemetricEventResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            eventprocessed: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.HandleTelemetricEventResponse}
 */ proto.fleet_service.HandleTelemetricEventResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.HandleTelemetricEventResponse;
    return proto.fleet_service.HandleTelemetricEventResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.HandleTelemetricEventResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.HandleTelemetricEventResponse}
 */ proto.fleet_service.HandleTelemetricEventResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setEventprocessed(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.HandleTelemetricEventResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.HandleTelemetricEventResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.HandleTelemetricEventResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.HandleTelemetricEventResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getEventprocessed();
    if (f) writer.writeBool(2, f);
};
/**
 * optional string Id = 1;
 * @return {string}
 */ proto.fleet_service.HandleTelemetricEventResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.HandleTelemetricEventResponse} returns this
 */ proto.fleet_service.HandleTelemetricEventResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool EventProcessed = 2;
 * @return {boolean}
 */ proto.fleet_service.HandleTelemetricEventResponse.prototype.getEventprocessed = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.HandleTelemetricEventResponse} returns this
 */ proto.fleet_service.HandleTelemetricEventResponse.prototype.setEventprocessed = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.DeleteDocumentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.DeleteDocumentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.DeleteDocumentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteDocumentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            documentId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            documentType: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.DeleteDocumentRequest}
 */ proto.fleet_service.DeleteDocumentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.DeleteDocumentRequest;
    return proto.fleet_service.DeleteDocumentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.DeleteDocumentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.DeleteDocumentRequest}
 */ proto.fleet_service.DeleteDocumentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.DeleteDocumentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.DeleteDocumentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.DeleteDocumentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteDocumentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDocumentId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDocumentType();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.DeleteDocumentRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.DeleteDocumentRequest} returns this
 */ proto.fleet_service.DeleteDocumentRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string document_id = 2;
 * @return {string}
 */ proto.fleet_service.DeleteDocumentRequest.prototype.getDocumentId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.DeleteDocumentRequest} returns this
 */ proto.fleet_service.DeleteDocumentRequest.prototype.setDocumentId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string document_type = 3;
 * @return {string}
 */ proto.fleet_service.DeleteDocumentRequest.prototype.getDocumentType = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.DeleteDocumentRequest} returns this
 */ proto.fleet_service.DeleteDocumentRequest.prototype.setDocumentType = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.DeleteDocumentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.DeleteDocumentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.DeleteDocumentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteDocumentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.DeleteDocumentResponse}
 */ proto.fleet_service.DeleteDocumentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.DeleteDocumentResponse;
    return proto.fleet_service.DeleteDocumentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.DeleteDocumentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.DeleteDocumentResponse}
 */ proto.fleet_service.DeleteDocumentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.DeleteDocumentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.DeleteDocumentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.DeleteDocumentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteDocumentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.fleet_service.DeleteDocumentResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.DeleteDocumentResponse} returns this
 */ proto.fleet_service.DeleteDocumentResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ConfirmVehicleRequest.repeatedFields_ = [
    7
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ConfirmVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ConfirmVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ConfirmVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            requestType: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            colorOptions: (f = msg.getColorOptions()) && proto.fleet_service.ConfirmVehicleRequest.ColorOptions.toObject(includeInstance, f),
            vehicleModel: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            year: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            vehiclePreferencesList: $8M67s.Message.toObjectList(msg.getVehiclePreferencesList(), $9YICB.Preference.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ConfirmVehicleRequest}
 */ proto.fleet_service.ConfirmVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ConfirmVehicleRequest;
    return proto.fleet_service.ConfirmVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ConfirmVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ConfirmVehicleRequest}
 */ proto.fleet_service.ConfirmVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {!proto.fleet_service.ConfirmVehicleRequest.Type} */ reader.readEnum();
                msg.setRequestType(value);
                break;
            case 4:
                var value = new proto.fleet_service.ConfirmVehicleRequest.ColorOptions;
                reader.readMessage(value, proto.fleet_service.ConfirmVehicleRequest.ColorOptions.deserializeBinaryFromReader);
                msg.setColorOptions(value);
                break;
            case 5:
                var value = /** @type {!proto.fleet_service.ConfirmVehicleRequest.VehicleModel} */ reader.readEnum();
                msg.setVehicleModel(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 7:
                var value = new $9YICB.Preference;
                reader.readMessage(value, $9YICB.Preference.deserializeBinaryFromReader);
                msg.addVehiclePreferences(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ConfirmVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ConfirmVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ConfirmVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getRequestType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getColorOptions();
    if (f != null) writer.writeMessage(4, f, proto.fleet_service.ConfirmVehicleRequest.ColorOptions.serializeBinaryToWriter);
    f = message.getVehicleModel();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getVehiclePreferencesList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, $9YICB.Preference.serializeBinaryToWriter);
};
/**
 * @enum {number}
 */ proto.fleet_service.ConfirmVehicleRequest.VehicleModel = {
    TESLA_MODEL_3: 0,
    TESLA_MODEL_Y: 1
};
/**
 * @enum {number}
 */ proto.fleet_service.ConfirmVehicleRequest.ColorName = {
    WHITE: 0,
    BLACK: 1,
    GRAY: 2,
    RED: 3,
    BLUE: 4,
    YELLOW: 5,
    ORANGE: 6,
    GREEN: 7,
    VIOLET: 8
};
/**
 * @enum {number}
 */ proto.fleet_service.ConfirmVehicleRequest.Type = {
    SUBSCRIPTION_ACTIVATION: 0,
    RESERVATION_ASSIGNMENT: 1
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ConfirmVehicleRequest.ColorOptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ConfirmVehicleRequest.ColorOptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            primaryColor: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            secondaryColor: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ConfirmVehicleRequest.ColorOptions}
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ConfirmVehicleRequest.ColorOptions;
    return proto.fleet_service.ConfirmVehicleRequest.ColorOptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ConfirmVehicleRequest.ColorOptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ConfirmVehicleRequest.ColorOptions}
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.fleet_service.ConfirmVehicleRequest.ColorName} */ reader.readEnum();
                msg.setPrimaryColor(value);
                break;
            case 2:
                var value = /** @type {!proto.fleet_service.ConfirmVehicleRequest.ColorName} */ reader.readEnum();
                msg.setSecondaryColor(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ConfirmVehicleRequest.ColorOptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ConfirmVehicleRequest.ColorOptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPrimaryColor();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getSecondaryColor();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * optional ColorName primary_color = 1;
 * @return {!proto.fleet_service.ConfirmVehicleRequest.ColorName}
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.prototype.getPrimaryColor = function() {
    return /** @type {!proto.fleet_service.ConfirmVehicleRequest.ColorName} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.fleet_service.ConfirmVehicleRequest.ColorName} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest.ColorOptions} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.prototype.setPrimaryColor = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional ColorName secondary_color = 2;
 * @return {!proto.fleet_service.ConfirmVehicleRequest.ColorName}
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.prototype.getSecondaryColor = function() {
    return /** @type {!proto.fleet_service.ConfirmVehicleRequest.ColorName} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.fleet_service.ConfirmVehicleRequest.ColorName} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest.ColorOptions} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.ColorOptions.prototype.setSecondaryColor = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Type request_type = 3;
 * @return {!proto.fleet_service.ConfirmVehicleRequest.Type}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.getRequestType = function() {
    return /** @type {!proto.fleet_service.ConfirmVehicleRequest.Type} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.fleet_service.ConfirmVehicleRequest.Type} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.setRequestType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional ColorOptions color_options = 4;
 * @return {?proto.fleet_service.ConfirmVehicleRequest.ColorOptions}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.getColorOptions = function() {
    return /** @type{?proto.fleet_service.ConfirmVehicleRequest.ColorOptions} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.ConfirmVehicleRequest.ColorOptions, 4);
};
/**
 * @param {?proto.fleet_service.ConfirmVehicleRequest.ColorOptions|undefined} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
*/ proto.fleet_service.ConfirmVehicleRequest.prototype.setColorOptions = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.clearColorOptions = function() {
    return this.setColorOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.hasColorOptions = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional VehicleModel vehicle_model = 5;
 * @return {!proto.fleet_service.ConfirmVehicleRequest.VehicleModel}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.getVehicleModel = function() {
    return /** @type {!proto.fleet_service.ConfirmVehicleRequest.VehicleModel} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.fleet_service.ConfirmVehicleRequest.VehicleModel} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.setVehicleModel = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional string year = 6;
 * @return {string}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * repeated vehicle.Preference vehicle_preferences = 7;
 * @return {!Array<!proto.vehicle.Preference>}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.getVehiclePreferencesList = function() {
    return /** @type{!Array<!proto.vehicle.Preference>} */ $8M67s.Message.getRepeatedWrapperField(this, $9YICB.Preference, 7);
};
/**
 * @param {!Array<!proto.vehicle.Preference>} value
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
*/ proto.fleet_service.ConfirmVehicleRequest.prototype.setVehiclePreferencesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.vehicle.Preference=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Preference}
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.addVehiclePreferences = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.vehicle.Preference, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ConfirmVehicleRequest} returns this
 */ proto.fleet_service.ConfirmVehicleRequest.prototype.clearVehiclePreferencesList = function() {
    return this.setVehiclePreferencesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ConfirmVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ConfirmVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ConfirmVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ConfirmVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            color: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            vin: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ConfirmVehicleResponse}
 */ proto.fleet_service.ConfirmVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ConfirmVehicleResponse;
    return proto.fleet_service.ConfirmVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ConfirmVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ConfirmVehicleResponse}
 */ proto.fleet_service.ConfirmVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {!proto.fleet_service.ConfirmVehicleResponse.ColorAssigned} */ reader.readEnum();
                msg.setColor(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ConfirmVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ConfirmVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ConfirmVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ConfirmVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getColor();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * @enum {number}
 */ proto.fleet_service.ConfirmVehicleResponse.ColorAssigned = {
    NO_COLOR_ASSIGNED: 0,
    PRIMARY_COLOR_ASSIGNED: 1,
    SECONDARY_COLOR_ASSIGNED: 2
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.fleet_service.ConfirmVehicleResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.ConfirmVehicleResponse} returns this
 */ proto.fleet_service.ConfirmVehicleResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional ColorAssigned color = 2;
 * @return {!proto.fleet_service.ConfirmVehicleResponse.ColorAssigned}
 */ proto.fleet_service.ConfirmVehicleResponse.prototype.getColor = function() {
    return /** @type {!proto.fleet_service.ConfirmVehicleResponse.ColorAssigned} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.fleet_service.ConfirmVehicleResponse.ColorAssigned} value
 * @return {!proto.fleet_service.ConfirmVehicleResponse} returns this
 */ proto.fleet_service.ConfirmVehicleResponse.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string vin = 3;
 * @return {string}
 */ proto.fleet_service.ConfirmVehicleResponse.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ConfirmVehicleResponse} returns this
 */ proto.fleet_service.ConfirmVehicleResponse.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListProfilesRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListProfilesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListProfilesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListProfilesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListProfilesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            criteriaList: $8M67s.Message.toObjectList(msg.getCriteriaList(), proto.fleet_service.VehicleCriteria.toObject, includeInstance),
            page: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            resultsPerPage: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListProfilesRequest}
 */ proto.fleet_service.ListProfilesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListProfilesRequest;
    return proto.fleet_service.ListProfilesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListProfilesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListProfilesRequest}
 */ proto.fleet_service.ListProfilesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.VehicleCriteria;
                reader.readMessage(value, proto.fleet_service.VehicleCriteria.deserializeBinaryFromReader);
                msg.addCriteria(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPage(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setResultsPerPage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListProfilesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListProfilesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListProfilesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListProfilesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCriteriaList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.VehicleCriteria.serializeBinaryToWriter);
    f = message.getPage();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getResultsPerPage();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * repeated VehicleCriteria criteria = 1;
 * @return {!Array<!proto.fleet_service.VehicleCriteria>}
 */ proto.fleet_service.ListProfilesRequest.prototype.getCriteriaList = function() {
    return /** @type{!Array<!proto.fleet_service.VehicleCriteria>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.VehicleCriteria, 1);
};
/**
 * @param {!Array<!proto.fleet_service.VehicleCriteria>} value
 * @return {!proto.fleet_service.ListProfilesRequest} returns this
*/ proto.fleet_service.ListProfilesRequest.prototype.setCriteriaList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.VehicleCriteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.VehicleCriteria}
 */ proto.fleet_service.ListProfilesRequest.prototype.addCriteria = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.VehicleCriteria, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListProfilesRequest} returns this
 */ proto.fleet_service.ListProfilesRequest.prototype.clearCriteriaList = function() {
    return this.setCriteriaList([]);
};
/**
 * optional int32 page = 2;
 * @return {number}
 */ proto.fleet_service.ListProfilesRequest.prototype.getPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListProfilesRequest} returns this
 */ proto.fleet_service.ListProfilesRequest.prototype.setPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 results_per_page = 3;
 * @return {number}
 */ proto.fleet_service.ListProfilesRequest.prototype.getResultsPerPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListProfilesRequest} returns this
 */ proto.fleet_service.ListProfilesRequest.prototype.setResultsPerPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListProfilesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListProfilesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListProfilesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListProfilesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListProfilesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            profilesList: $8M67s.Message.toObjectList(msg.getProfilesList(), $9YICB.Profile.toObject, includeInstance),
            page: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            total: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListProfilesResponse}
 */ proto.fleet_service.ListProfilesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListProfilesResponse;
    return proto.fleet_service.ListProfilesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListProfilesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListProfilesResponse}
 */ proto.fleet_service.ListProfilesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Profile;
                reader.readMessage(value, $9YICB.Profile.deserializeBinaryFromReader);
                msg.addProfiles(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPage(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListProfilesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListProfilesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListProfilesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListProfilesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProfilesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $9YICB.Profile.serializeBinaryToWriter);
    f = message.getPage();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getTotal();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * repeated vehicle.Profile profiles = 1;
 * @return {!Array<!proto.vehicle.Profile>}
 */ proto.fleet_service.ListProfilesResponse.prototype.getProfilesList = function() {
    return /** @type{!Array<!proto.vehicle.Profile>} */ $8M67s.Message.getRepeatedWrapperField(this, $9YICB.Profile, 1);
};
/**
 * @param {!Array<!proto.vehicle.Profile>} value
 * @return {!proto.fleet_service.ListProfilesResponse} returns this
*/ proto.fleet_service.ListProfilesResponse.prototype.setProfilesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.vehicle.Profile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Profile}
 */ proto.fleet_service.ListProfilesResponse.prototype.addProfiles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vehicle.Profile, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListProfilesResponse} returns this
 */ proto.fleet_service.ListProfilesResponse.prototype.clearProfilesList = function() {
    return this.setProfilesList([]);
};
/**
 * optional int32 page = 2;
 * @return {number}
 */ proto.fleet_service.ListProfilesResponse.prototype.getPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListProfilesResponse} returns this
 */ proto.fleet_service.ListProfilesResponse.prototype.setPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 total = 3;
 * @return {number}
 */ proto.fleet_service.ListProfilesResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListProfilesResponse} returns this
 */ proto.fleet_service.ListProfilesResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.fleet_service.VehicleProperty.oneofGroups_ = [
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7
    ]
];
/**
 * @enum {number}
 */ proto.fleet_service.VehicleProperty.PropertyCase = {
    PROPERTY_NOT_SET: 0,
    NEW_VEHICLE_STATE: 1,
    NEW_ACTIVITY_FAILURE: 2,
    NEW_ACTIVITY: 3,
    NEW_ACTIVITY_STATE: 4,
    VEHICLE_PROPERTY: 5,
    EXTERIOR_COLOR: 6,
    INTERIOR_COLOR: 7
};
/**
 * @return {proto.fleet_service.VehicleProperty.PropertyCase}
 */ proto.fleet_service.VehicleProperty.prototype.getPropertyCase = function() {
    return /** @type {proto.fleet_service.VehicleProperty.PropertyCase} */ $8M67s.Message.computeOneofCase(this, proto.fleet_service.VehicleProperty.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.VehicleProperty.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.VehicleProperty.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.VehicleProperty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehicleProperty.toObject = function(includeInstance, msg) {
        var f, obj = {
            newVehicleState: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            newActivityFailure: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            newActivity: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            newActivityState: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            vehicleProperty: (f = msg.getVehicleProperty()) && $9YICB.Property.toObject(includeInstance, f),
            exteriorColor: (f = msg.getExteriorColor()) && $9YICB.Color.toObject(includeInstance, f),
            interiorColor: (f = msg.getInteriorColor()) && $9YICB.Color.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.VehicleProperty}
 */ proto.fleet_service.VehicleProperty.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.VehicleProperty;
    return proto.fleet_service.VehicleProperty.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.VehicleProperty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.VehicleProperty}
 */ proto.fleet_service.VehicleProperty.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.vehicle.State} */ reader.readEnum();
                msg.setNewVehicleState(value);
                break;
            case 2:
                var value = /** @type {!proto.vehicle.ActivityFailure} */ reader.readEnum();
                msg.setNewActivityFailure(value);
                break;
            case 3:
                var value = /** @type {!proto.vehicle.Activity} */ reader.readEnum();
                msg.setNewActivity(value);
                break;
            case 4:
                var value = /** @type {!proto.vehicle.ActivityState} */ reader.readEnum();
                msg.setNewActivityState(value);
                break;
            case 5:
                var value = new $9YICB.Property;
                reader.readMessage(value, $9YICB.Property.deserializeBinaryFromReader);
                msg.setVehicleProperty(value);
                break;
            case 6:
                var value = new $9YICB.Color;
                reader.readMessage(value, $9YICB.Color.deserializeBinaryFromReader);
                msg.setExteriorColor(value);
                break;
            case 7:
                var value = new $9YICB.Color;
                reader.readMessage(value, $9YICB.Color.deserializeBinaryFromReader);
                msg.setInteriorColor(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.VehicleProperty.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.VehicleProperty.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.VehicleProperty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehicleProperty.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {!proto.vehicle.State} */ $8M67s.Message.getField(message, 1);
    if (f != null) writer.writeEnum(1, f);
    f = /** @type {!proto.vehicle.ActivityFailure} */ $8M67s.Message.getField(message, 2);
    if (f != null) writer.writeEnum(2, f);
    f = /** @type {!proto.vehicle.Activity} */ $8M67s.Message.getField(message, 3);
    if (f != null) writer.writeEnum(3, f);
    f = /** @type {!proto.vehicle.ActivityState} */ $8M67s.Message.getField(message, 4);
    if (f != null) writer.writeEnum(4, f);
    f = message.getVehicleProperty();
    if (f != null) writer.writeMessage(5, f, $9YICB.Property.serializeBinaryToWriter);
    f = message.getExteriorColor();
    if (f != null) writer.writeMessage(6, f, $9YICB.Color.serializeBinaryToWriter);
    f = message.getInteriorColor();
    if (f != null) writer.writeMessage(7, f, $9YICB.Color.serializeBinaryToWriter);
};
/**
 * optional vehicle.State new_vehicle_state = 1;
 * @return {!proto.vehicle.State}
 */ proto.fleet_service.VehicleProperty.prototype.getNewVehicleState = function() {
    return /** @type {!proto.vehicle.State} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.vehicle.State} value
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.setNewVehicleState = function(value) {
    return $8M67s.Message.setOneofField(this, 1, proto.fleet_service.VehicleProperty.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.clearNewVehicleState = function() {
    return $8M67s.Message.setOneofField(this, 1, proto.fleet_service.VehicleProperty.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.VehicleProperty.prototype.hasNewVehicleState = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional vehicle.ActivityFailure new_activity_failure = 2;
 * @return {!proto.vehicle.ActivityFailure}
 */ proto.fleet_service.VehicleProperty.prototype.getNewActivityFailure = function() {
    return /** @type {!proto.vehicle.ActivityFailure} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.vehicle.ActivityFailure} value
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.setNewActivityFailure = function(value) {
    return $8M67s.Message.setOneofField(this, 2, proto.fleet_service.VehicleProperty.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.clearNewActivityFailure = function() {
    return $8M67s.Message.setOneofField(this, 2, proto.fleet_service.VehicleProperty.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.VehicleProperty.prototype.hasNewActivityFailure = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional vehicle.Activity new_activity = 3;
 * @return {!proto.vehicle.Activity}
 */ proto.fleet_service.VehicleProperty.prototype.getNewActivity = function() {
    return /** @type {!proto.vehicle.Activity} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.vehicle.Activity} value
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.setNewActivity = function(value) {
    return $8M67s.Message.setOneofField(this, 3, proto.fleet_service.VehicleProperty.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.clearNewActivity = function() {
    return $8M67s.Message.setOneofField(this, 3, proto.fleet_service.VehicleProperty.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.VehicleProperty.prototype.hasNewActivity = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional vehicle.ActivityState new_activity_state = 4;
 * @return {!proto.vehicle.ActivityState}
 */ proto.fleet_service.VehicleProperty.prototype.getNewActivityState = function() {
    return /** @type {!proto.vehicle.ActivityState} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.vehicle.ActivityState} value
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.setNewActivityState = function(value) {
    return $8M67s.Message.setOneofField(this, 4, proto.fleet_service.VehicleProperty.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.clearNewActivityState = function() {
    return $8M67s.Message.setOneofField(this, 4, proto.fleet_service.VehicleProperty.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.VehicleProperty.prototype.hasNewActivityState = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional vehicle.Property vehicle_property = 5;
 * @return {?proto.vehicle.Property}
 */ proto.fleet_service.VehicleProperty.prototype.getVehicleProperty = function() {
    return /** @type{?proto.vehicle.Property} */ $8M67s.Message.getWrapperField(this, $9YICB.Property, 5);
};
/**
 * @param {?proto.vehicle.Property|undefined} value
 * @return {!proto.fleet_service.VehicleProperty} returns this
*/ proto.fleet_service.VehicleProperty.prototype.setVehicleProperty = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 5, proto.fleet_service.VehicleProperty.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.clearVehicleProperty = function() {
    return this.setVehicleProperty(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.VehicleProperty.prototype.hasVehicleProperty = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional vehicle.Color exterior_color = 6;
 * @return {?proto.vehicle.Color}
 */ proto.fleet_service.VehicleProperty.prototype.getExteriorColor = function() {
    return /** @type{?proto.vehicle.Color} */ $8M67s.Message.getWrapperField(this, $9YICB.Color, 6);
};
/**
 * @param {?proto.vehicle.Color|undefined} value
 * @return {!proto.fleet_service.VehicleProperty} returns this
*/ proto.fleet_service.VehicleProperty.prototype.setExteriorColor = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 6, proto.fleet_service.VehicleProperty.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.clearExteriorColor = function() {
    return this.setExteriorColor(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.VehicleProperty.prototype.hasExteriorColor = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional vehicle.Color interior_color = 7;
 * @return {?proto.vehicle.Color}
 */ proto.fleet_service.VehicleProperty.prototype.getInteriorColor = function() {
    return /** @type{?proto.vehicle.Color} */ $8M67s.Message.getWrapperField(this, $9YICB.Color, 7);
};
/**
 * @param {?proto.vehicle.Color|undefined} value
 * @return {!proto.fleet_service.VehicleProperty} returns this
*/ proto.fleet_service.VehicleProperty.prototype.setInteriorColor = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 7, proto.fleet_service.VehicleProperty.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.VehicleProperty} returns this
 */ proto.fleet_service.VehicleProperty.prototype.clearInteriorColor = function() {
    return this.setInteriorColor(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.VehicleProperty.prototype.hasInteriorColor = function() {
    return $8M67s.Message.getField(this, 7) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.UpdateVehicleRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f),
            propertiesList: $8M67s.Message.toObjectList(msg.getPropertiesList(), proto.fleet_service.VehicleProperty.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateVehicleRequest}
 */ proto.fleet_service.UpdateVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateVehicleRequest;
    return proto.fleet_service.UpdateVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateVehicleRequest}
 */ proto.fleet_service.UpdateVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 3:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            case 2:
                var value = new proto.fleet_service.VehicleProperty;
                reader.readMessage(value, proto.fleet_service.VehicleProperty.deserializeBinaryFromReader);
                msg.addProperties(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicle();
    if (f != null) writer.writeMessage(3, f, $9YICB.Vehicle.serializeBinaryToWriter);
    f = message.getPropertiesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.fleet_service.VehicleProperty.serializeBinaryToWriter);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.UpdateVehicleRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpdateVehicleRequest} returns this
 */ proto.fleet_service.UpdateVehicleRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional vehicle.Vehicle vehicle = 3;
 * @return {?proto.vehicle.Vehicle}
 */ proto.fleet_service.UpdateVehicleRequest.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 3);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.fleet_service.UpdateVehicleRequest} returns this
*/ proto.fleet_service.UpdateVehicleRequest.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.UpdateVehicleRequest} returns this
 */ proto.fleet_service.UpdateVehicleRequest.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.UpdateVehicleRequest.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * repeated VehicleProperty properties = 2;
 * @return {!Array<!proto.fleet_service.VehicleProperty>}
 */ proto.fleet_service.UpdateVehicleRequest.prototype.getPropertiesList = function() {
    return /** @type{!Array<!proto.fleet_service.VehicleProperty>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.VehicleProperty, 2);
};
/**
 * @param {!Array<!proto.fleet_service.VehicleProperty>} value
 * @return {!proto.fleet_service.UpdateVehicleRequest} returns this
*/ proto.fleet_service.UpdateVehicleRequest.prototype.setPropertiesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.fleet_service.VehicleProperty=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.VehicleProperty}
 */ proto.fleet_service.UpdateVehicleRequest.prototype.addProperties = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.fleet_service.VehicleProperty, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.UpdateVehicleRequest} returns this
 */ proto.fleet_service.UpdateVehicleRequest.prototype.clearPropertiesList = function() {
    return this.setPropertiesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateVehicleResponse}
 */ proto.fleet_service.UpdateVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateVehicleResponse;
    return proto.fleet_service.UpdateVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateVehicleResponse}
 */ proto.fleet_service.UpdateVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.fleet_service.UpdateVehicleResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.UpdateVehicleResponse} returns this
 */ proto.fleet_service.UpdateVehicleResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListDealershipsRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListDealershipsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListDealershipsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListDealershipsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListDealershipsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            criteriaList: $8M67s.Message.toObjectList(msg.getCriteriaList(), proto.fleet_service.DealershipCriteria.toObject, includeInstance),
            page: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            resultsPerPage: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListDealershipsRequest}
 */ proto.fleet_service.ListDealershipsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListDealershipsRequest;
    return proto.fleet_service.ListDealershipsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListDealershipsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListDealershipsRequest}
 */ proto.fleet_service.ListDealershipsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.DealershipCriteria;
                reader.readMessage(value, proto.fleet_service.DealershipCriteria.deserializeBinaryFromReader);
                msg.addCriteria(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPage(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setResultsPerPage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListDealershipsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListDealershipsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListDealershipsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListDealershipsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCriteriaList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.DealershipCriteria.serializeBinaryToWriter);
    f = message.getPage();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getResultsPerPage();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * repeated DealershipCriteria criteria = 1;
 * @return {!Array<!proto.fleet_service.DealershipCriteria>}
 */ proto.fleet_service.ListDealershipsRequest.prototype.getCriteriaList = function() {
    return /** @type{!Array<!proto.fleet_service.DealershipCriteria>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.DealershipCriteria, 1);
};
/**
 * @param {!Array<!proto.fleet_service.DealershipCriteria>} value
 * @return {!proto.fleet_service.ListDealershipsRequest} returns this
*/ proto.fleet_service.ListDealershipsRequest.prototype.setCriteriaList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.DealershipCriteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.DealershipCriteria}
 */ proto.fleet_service.ListDealershipsRequest.prototype.addCriteria = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.DealershipCriteria, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListDealershipsRequest} returns this
 */ proto.fleet_service.ListDealershipsRequest.prototype.clearCriteriaList = function() {
    return this.setCriteriaList([]);
};
/**
 * optional int32 page = 2;
 * @return {number}
 */ proto.fleet_service.ListDealershipsRequest.prototype.getPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListDealershipsRequest} returns this
 */ proto.fleet_service.ListDealershipsRequest.prototype.setPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 results_per_page = 3;
 * @return {number}
 */ proto.fleet_service.ListDealershipsRequest.prototype.getResultsPerPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListDealershipsRequest} returns this
 */ proto.fleet_service.ListDealershipsRequest.prototype.setResultsPerPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListDealershipsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListDealershipsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListDealershipsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListDealershipsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListDealershipsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipsList: $8M67s.Message.toObjectList(msg.getDealershipsList(), $3QqPt.Dealership.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListDealershipsResponse}
 */ proto.fleet_service.ListDealershipsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListDealershipsResponse;
    return proto.fleet_service.ListDealershipsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListDealershipsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListDealershipsResponse}
 */ proto.fleet_service.ListDealershipsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Dealership;
                reader.readMessage(value, $3QqPt.Dealership.deserializeBinaryFromReader);
                msg.addDealerships(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListDealershipsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListDealershipsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListDealershipsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListDealershipsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.Dealership.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * repeated domain.Dealership dealerships = 1;
 * @return {!Array<!proto.domain.Dealership>}
 */ proto.fleet_service.ListDealershipsResponse.prototype.getDealershipsList = function() {
    return /** @type{!Array<!proto.domain.Dealership>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Dealership, 1);
};
/**
 * @param {!Array<!proto.domain.Dealership>} value
 * @return {!proto.fleet_service.ListDealershipsResponse} returns this
*/ proto.fleet_service.ListDealershipsResponse.prototype.setDealershipsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.Dealership=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Dealership}
 */ proto.fleet_service.ListDealershipsResponse.prototype.addDealerships = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.Dealership, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListDealershipsResponse} returns this
 */ proto.fleet_service.ListDealershipsResponse.prototype.clearDealershipsList = function() {
    return this.setDealershipsList([]);
};
/**
 * optional int32 total = 2;
 * @return {number}
 */ proto.fleet_service.ListDealershipsResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListDealershipsResponse} returns this
 */ proto.fleet_service.ListDealershipsResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetDealershipRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetDealershipRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetDealershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetDealershipRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetDealershipRequest}
 */ proto.fleet_service.GetDealershipRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetDealershipRequest;
    return proto.fleet_service.GetDealershipRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetDealershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetDealershipRequest}
 */ proto.fleet_service.GetDealershipRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetDealershipRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetDealershipRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetDealershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetDealershipRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.GetDealershipRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetDealershipRequest} returns this
 */ proto.fleet_service.GetDealershipRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetDealershipResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetDealershipResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetDealershipResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetDealershipResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $3QqPt.Dealership.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetDealershipResponse}
 */ proto.fleet_service.GetDealershipResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetDealershipResponse;
    return proto.fleet_service.GetDealershipResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetDealershipResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetDealershipResponse}
 */ proto.fleet_service.GetDealershipResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Dealership;
                reader.readMessage(value, $3QqPt.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetDealershipResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetDealershipResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetDealershipResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetDealershipResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Dealership.serializeBinaryToWriter);
};
/**
 * optional domain.Dealership dealership = 1;
 * @return {?proto.domain.Dealership}
 */ proto.fleet_service.GetDealershipResponse.prototype.getDealership = function() {
    return /** @type{?proto.domain.Dealership} */ $8M67s.Message.getWrapperField(this, $3QqPt.Dealership, 1);
};
/**
 * @param {?proto.domain.Dealership|undefined} value
 * @return {!proto.fleet_service.GetDealershipResponse} returns this
*/ proto.fleet_service.GetDealershipResponse.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetDealershipResponse} returns this
 */ proto.fleet_service.GetDealershipResponse.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetDealershipResponse.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.DealershipCriteria.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.DealershipCriteria.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.DealershipCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DealershipCriteria.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            query: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.DealershipCriteria}
 */ proto.fleet_service.DealershipCriteria.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.DealershipCriteria;
    return proto.fleet_service.DealershipCriteria.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.DealershipCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.DealershipCriteria}
 */ proto.fleet_service.DealershipCriteria.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setQuery(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.DealershipCriteria.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.DealershipCriteria.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.DealershipCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DealershipCriteria.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getQuery();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.fleet_service.DealershipCriteria.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.DealershipCriteria} returns this
 */ proto.fleet_service.DealershipCriteria.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string query = 2;
 * @return {string}
 */ proto.fleet_service.DealershipCriteria.prototype.getQuery = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.DealershipCriteria} returns this
 */ proto.fleet_service.DealershipCriteria.prototype.setQuery = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.StartVehicleInspectionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.StartVehicleInspectionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.StartVehicleInspectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.StartVehicleInspectionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.StartVehicleInspectionRequest}
 */ proto.fleet_service.StartVehicleInspectionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.StartVehicleInspectionRequest;
    return proto.fleet_service.StartVehicleInspectionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.StartVehicleInspectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.StartVehicleInspectionRequest}
 */ proto.fleet_service.StartVehicleInspectionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.StartVehicleInspectionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.StartVehicleInspectionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.StartVehicleInspectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.StartVehicleInspectionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.StartVehicleInspectionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.StartVehicleInspectionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.StartVehicleInspectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.StartVehicleInspectionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            sessionKey: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.StartVehicleInspectionResponse}
 */ proto.fleet_service.StartVehicleInspectionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.StartVehicleInspectionResponse;
    return proto.fleet_service.StartVehicleInspectionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.StartVehicleInspectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.StartVehicleInspectionResponse}
 */ proto.fleet_service.StartVehicleInspectionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSessionKey(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.StartVehicleInspectionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.StartVehicleInspectionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.StartVehicleInspectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.StartVehicleInspectionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSessionKey();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string session_key = 1;
 * @return {string}
 */ proto.fleet_service.StartVehicleInspectionResponse.prototype.getSessionKey = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.StartVehicleInspectionResponse} returns this
 */ proto.fleet_service.StartVehicleInspectionResponse.prototype.setSessionKey = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleInspectionResultsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleInspectionResultsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            jwt: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            request: (f = msg.getRequest()) && $gjhG2.GetInspectionResultsRequest.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleInspectionResultsRequest}
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleInspectionResultsRequest;
    return proto.fleet_service.GetVehicleInspectionResultsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleInspectionResultsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleInspectionResultsRequest}
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setJwt(value);
                break;
            case 2:
                var value = new $gjhG2.GetInspectionResultsRequest;
                reader.readMessage(value, $gjhG2.GetInspectionResultsRequest.deserializeBinaryFromReader);
                msg.setRequest(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleInspectionResultsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleInspectionResultsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getJwt();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getRequest();
    if (f != null) writer.writeMessage(2, f, $gjhG2.GetInspectionResultsRequest.serializeBinaryToWriter);
};
/**
 * optional string jwt = 1;
 * @return {string}
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.prototype.getJwt = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetVehicleInspectionResultsRequest} returns this
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.prototype.setJwt = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional inspection.GetInspectionResultsRequest request = 2;
 * @return {?proto.inspection.GetInspectionResultsRequest}
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.prototype.getRequest = function() {
    return /** @type{?proto.inspection.GetInspectionResultsRequest} */ $8M67s.Message.getWrapperField(this, $gjhG2.GetInspectionResultsRequest, 2);
};
/**
 * @param {?proto.inspection.GetInspectionResultsRequest|undefined} value
 * @return {!proto.fleet_service.GetVehicleInspectionResultsRequest} returns this
*/ proto.fleet_service.GetVehicleInspectionResultsRequest.prototype.setRequest = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetVehicleInspectionResultsRequest} returns this
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.prototype.clearRequest = function() {
    return this.setRequest(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetVehicleInspectionResultsRequest.prototype.hasRequest = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetAvailableModelsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetAvailableModelsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetAvailableModelsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetAvailableModelsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            make: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetAvailableModelsRequest}
 */ proto.fleet_service.GetAvailableModelsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetAvailableModelsRequest;
    return proto.fleet_service.GetAvailableModelsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetAvailableModelsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetAvailableModelsRequest}
 */ proto.fleet_service.GetAvailableModelsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetAvailableModelsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetAvailableModelsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetAvailableModelsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetAvailableModelsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMake();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string make = 1;
 * @return {string}
 */ proto.fleet_service.GetAvailableModelsRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetAvailableModelsRequest} returns this
 */ proto.fleet_service.GetAvailableModelsRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.GetAvailableModelsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetAvailableModelsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetAvailableModelsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetAvailableModelsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetAvailableModelsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            modelsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetAvailableModelsResponse}
 */ proto.fleet_service.GetAvailableModelsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetAvailableModelsResponse;
    return proto.fleet_service.GetAvailableModelsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetAvailableModelsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetAvailableModelsResponse}
 */ proto.fleet_service.GetAvailableModelsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addModels(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetAvailableModelsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetAvailableModelsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetAvailableModelsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetAvailableModelsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getModelsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string models = 1;
 * @return {!Array<string>}
 */ proto.fleet_service.GetAvailableModelsResponse.prototype.getModelsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.GetAvailableModelsResponse} returns this
 */ proto.fleet_service.GetAvailableModelsResponse.prototype.setModelsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.GetAvailableModelsResponse} returns this
 */ proto.fleet_service.GetAvailableModelsResponse.prototype.addModels = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.GetAvailableModelsResponse} returns this
 */ proto.fleet_service.GetAvailableModelsResponse.prototype.clearModelsList = function() {
    return this.setModelsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetAvailableTrimsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetAvailableTrimsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetAvailableTrimsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetAvailableTrimsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            make: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetAvailableTrimsRequest}
 */ proto.fleet_service.GetAvailableTrimsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetAvailableTrimsRequest;
    return proto.fleet_service.GetAvailableTrimsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetAvailableTrimsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetAvailableTrimsRequest}
 */ proto.fleet_service.GetAvailableTrimsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetAvailableTrimsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetAvailableTrimsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetAvailableTrimsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetAvailableTrimsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMake();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string make = 1;
 * @return {string}
 */ proto.fleet_service.GetAvailableTrimsRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetAvailableTrimsRequest} returns this
 */ proto.fleet_service.GetAvailableTrimsRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string model = 2;
 * @return {string}
 */ proto.fleet_service.GetAvailableTrimsRequest.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetAvailableTrimsRequest} returns this
 */ proto.fleet_service.GetAvailableTrimsRequest.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.GetAvailableTrimsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetAvailableTrimsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetAvailableTrimsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetAvailableTrimsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetAvailableTrimsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            trimsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetAvailableTrimsResponse}
 */ proto.fleet_service.GetAvailableTrimsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetAvailableTrimsResponse;
    return proto.fleet_service.GetAvailableTrimsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetAvailableTrimsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetAvailableTrimsResponse}
 */ proto.fleet_service.GetAvailableTrimsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addTrims(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetAvailableTrimsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetAvailableTrimsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetAvailableTrimsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetAvailableTrimsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTrimsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string trims = 1;
 * @return {!Array<string>}
 */ proto.fleet_service.GetAvailableTrimsResponse.prototype.getTrimsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.GetAvailableTrimsResponse} returns this
 */ proto.fleet_service.GetAvailableTrimsResponse.prototype.setTrimsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.GetAvailableTrimsResponse} returns this
 */ proto.fleet_service.GetAvailableTrimsResponse.prototype.addTrims = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.GetAvailableTrimsResponse} returns this
 */ proto.fleet_service.GetAvailableTrimsResponse.prototype.clearTrimsList = function() {
    return this.setTrimsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ValidateVinRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ValidateVinRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ValidateVinRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ValidateVinRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vin: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ValidateVinRequest}
 */ proto.fleet_service.ValidateVinRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ValidateVinRequest;
    return proto.fleet_service.ValidateVinRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ValidateVinRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ValidateVinRequest}
 */ proto.fleet_service.ValidateVinRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ValidateVinRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ValidateVinRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ValidateVinRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ValidateVinRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVin();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string vin = 1;
 * @return {string}
 */ proto.fleet_service.ValidateVinRequest.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinRequest} returns this
 */ proto.fleet_service.ValidateVinRequest.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string dealership_id = 2;
 * @return {string}
 */ proto.fleet_service.ValidateVinRequest.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinRequest} returns this
 */ proto.fleet_service.ValidateVinRequest.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ValidateVinResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ValidateVinResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ValidateVinResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ValidateVinResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            color: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ValidateVinResponse}
 */ proto.fleet_service.ValidateVinResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ValidateVinResponse;
    return proto.fleet_service.ValidateVinResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ValidateVinResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ValidateVinResponse}
 */ proto.fleet_service.ValidateVinResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ValidateVinResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ValidateVinResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ValidateVinResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ValidateVinResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getColor();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.ValidateVinResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinResponse} returns this
 */ proto.fleet_service.ValidateVinResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.fleet_service.ValidateVinResponse.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinResponse} returns this
 */ proto.fleet_service.ValidateVinResponse.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string make = 3;
 * @return {string}
 */ proto.fleet_service.ValidateVinResponse.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinResponse} returns this
 */ proto.fleet_service.ValidateVinResponse.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string model = 4;
 * @return {string}
 */ proto.fleet_service.ValidateVinResponse.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinResponse} returns this
 */ proto.fleet_service.ValidateVinResponse.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string color = 5;
 * @return {string}
 */ proto.fleet_service.ValidateVinResponse.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinResponse} returns this
 */ proto.fleet_service.ValidateVinResponse.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string trim = 6;
 * @return {string}
 */ proto.fleet_service.ValidateVinResponse.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinResponse} returns this
 */ proto.fleet_service.ValidateVinResponse.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string year = 7;
 * @return {string}
 */ proto.fleet_service.ValidateVinResponse.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ValidateVinResponse} returns this
 */ proto.fleet_service.ValidateVinResponse.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateVehicleCustodyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateVehicleCustodyRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateVehicleCustodyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleCustodyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateVehicleCustodyRequest}
 */ proto.fleet_service.UpdateVehicleCustodyRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateVehicleCustodyRequest;
    return proto.fleet_service.UpdateVehicleCustodyRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateVehicleCustodyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateVehicleCustodyRequest}
 */ proto.fleet_service.UpdateVehicleCustodyRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateVehicleCustodyRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateVehicleCustodyRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateVehicleCustodyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleCustodyRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.UpdateVehicleCustodyRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpdateVehicleCustodyRequest} returns this
 */ proto.fleet_service.UpdateVehicleCustodyRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string dealership_id = 2;
 * @return {string}
 */ proto.fleet_service.UpdateVehicleCustodyRequest.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpdateVehicleCustodyRequest} returns this
 */ proto.fleet_service.UpdateVehicleCustodyRequest.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.fleet_service.UpdateVehicleCustodyRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpdateVehicleCustodyRequest} returns this
 */ proto.fleet_service.UpdateVehicleCustodyRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateVehicleCustodyResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateVehicleCustodyResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateVehicleCustodyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleCustodyResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateVehicleCustodyResponse}
 */ proto.fleet_service.UpdateVehicleCustodyResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateVehicleCustodyResponse;
    return proto.fleet_service.UpdateVehicleCustodyResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateVehicleCustodyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateVehicleCustodyResponse}
 */ proto.fleet_service.UpdateVehicleCustodyResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateVehicleCustodyResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateVehicleCustodyResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateVehicleCustodyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleCustodyResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetLatestCustodyRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetLatestCustodyRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetLatestCustodyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetLatestCustodyRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            custodyType: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetLatestCustodyRequest}
 */ proto.fleet_service.GetLatestCustodyRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetLatestCustodyRequest;
    return proto.fleet_service.GetLatestCustodyRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetLatestCustodyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetLatestCustodyRequest}
 */ proto.fleet_service.GetLatestCustodyRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {!proto.fleet_service.GetLatestCustodyRequest.CustodyType} */ reader.readEnum();
                msg.setCustodyType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetLatestCustodyRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetLatestCustodyRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetLatestCustodyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetLatestCustodyRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustodyType();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * @enum {number}
 */ proto.fleet_service.GetLatestCustodyRequest.CustodyType = {
    DEALERSHIP: 0,
    CUSTOMER: 1,
    ANY: 2
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.GetLatestCustodyRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetLatestCustodyRequest} returns this
 */ proto.fleet_service.GetLatestCustodyRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional CustodyType custody_type = 2;
 * @return {!proto.fleet_service.GetLatestCustodyRequest.CustodyType}
 */ proto.fleet_service.GetLatestCustodyRequest.prototype.getCustodyType = function() {
    return /** @type {!proto.fleet_service.GetLatestCustodyRequest.CustodyType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.fleet_service.GetLatestCustodyRequest.CustodyType} value
 * @return {!proto.fleet_service.GetLatestCustodyRequest} returns this
 */ proto.fleet_service.GetLatestCustodyRequest.prototype.setCustodyType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.fleet_service.GetLatestCustodyResponse.oneofGroups_ = [
    [
        1,
        2
    ]
];
/**
 * @enum {number}
 */ proto.fleet_service.GetLatestCustodyResponse.CustodianCase = {
    CUSTODIAN_NOT_SET: 0,
    DEALERSHIP: 1,
    CUSTOMER: 2
};
/**
 * @return {proto.fleet_service.GetLatestCustodyResponse.CustodianCase}
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.getCustodianCase = function() {
    return /** @type {proto.fleet_service.GetLatestCustodyResponse.CustodianCase} */ $8M67s.Message.computeOneofCase(this, proto.fleet_service.GetLatestCustodyResponse.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetLatestCustodyResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetLatestCustodyResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetLatestCustodyResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $1oiLe.Dealership.toObject(includeInstance, f),
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetLatestCustodyResponse}
 */ proto.fleet_service.GetLatestCustodyResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetLatestCustodyResponse;
    return proto.fleet_service.GetLatestCustodyResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetLatestCustodyResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetLatestCustodyResponse}
 */ proto.fleet_service.GetLatestCustodyResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $1oiLe.Dealership;
                reader.readMessage(value, $1oiLe.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            case 2:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetLatestCustodyResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetLatestCustodyResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetLatestCustodyResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $1oiLe.Dealership.serializeBinaryToWriter);
    f = message.getCustomer();
    if (f != null) writer.writeMessage(2, f, $3QqPt.Customer.serializeBinaryToWriter);
};
/**
 * optional dealer.Dealership dealership = 1;
 * @return {?proto.dealer.Dealership}
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.getDealership = function() {
    return /** @type{?proto.dealer.Dealership} */ $8M67s.Message.getWrapperField(this, $1oiLe.Dealership, 1);
};
/**
 * @param {?proto.dealer.Dealership|undefined} value
 * @return {!proto.fleet_service.GetLatestCustodyResponse} returns this
*/ proto.fleet_service.GetLatestCustodyResponse.prototype.setDealership = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 1, proto.fleet_service.GetLatestCustodyResponse.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetLatestCustodyResponse} returns this
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional domain.Customer customer = 2;
 * @return {?proto.domain.Customer}
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 2);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.fleet_service.GetLatestCustodyResponse} returns this
*/ proto.fleet_service.GetLatestCustodyResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 2, proto.fleet_service.GetLatestCustodyResponse.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.GetLatestCustodyResponse} returns this
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.GetLatestCustodyResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleInfleetingRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleInfleetingRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleInfleetingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleInfleetingRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            infleetingRequestType: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleInfleetingRequest}
 */ proto.fleet_service.GetVehicleInfleetingRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleInfleetingRequest;
    return proto.fleet_service.GetVehicleInfleetingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleInfleetingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleInfleetingRequest}
 */ proto.fleet_service.GetVehicleInfleetingRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.fleet_service.GetVehicleInfleetingRequest.InfleetingRequestType} */ reader.readEnum();
                msg.setInfleetingRequestType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleInfleetingRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleInfleetingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleInfleetingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleInfleetingRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getInfleetingRequestType();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * @enum {number}
 */ proto.fleet_service.GetVehicleInfleetingRequest.InfleetingRequestType = {
    LATEST: 0,
    ALL: 1
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.GetVehicleInfleetingRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetVehicleInfleetingRequest} returns this
 */ proto.fleet_service.GetVehicleInfleetingRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional InfleetingRequestType infleeting_request_type = 2;
 * @return {!proto.fleet_service.GetVehicleInfleetingRequest.InfleetingRequestType}
 */ proto.fleet_service.GetVehicleInfleetingRequest.prototype.getInfleetingRequestType = function() {
    return /** @type {!proto.fleet_service.GetVehicleInfleetingRequest.InfleetingRequestType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.fleet_service.GetVehicleInfleetingRequest.InfleetingRequestType} value
 * @return {!proto.fleet_service.GetVehicleInfleetingRequest} returns this
 */ proto.fleet_service.GetVehicleInfleetingRequest.prototype.setInfleetingRequestType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.GetVehicleInfleetingResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleInfleetingResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleInfleetingResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleInfleetingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleInfleetingResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            infleetingsList: $8M67s.Message.toObjectList(msg.getInfleetingsList(), $9YICB.Infleeting.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleInfleetingResponse}
 */ proto.fleet_service.GetVehicleInfleetingResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleInfleetingResponse;
    return proto.fleet_service.GetVehicleInfleetingResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleInfleetingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleInfleetingResponse}
 */ proto.fleet_service.GetVehicleInfleetingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Infleeting;
                reader.readMessage(value, $9YICB.Infleeting.deserializeBinaryFromReader);
                msg.addInfleetings(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleInfleetingResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleInfleetingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleInfleetingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleInfleetingResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInfleetingsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $9YICB.Infleeting.serializeBinaryToWriter);
};
/**
 * repeated vehicle.Infleeting infleetings = 1;
 * @return {!Array<!proto.vehicle.Infleeting>}
 */ proto.fleet_service.GetVehicleInfleetingResponse.prototype.getInfleetingsList = function() {
    return /** @type{!Array<!proto.vehicle.Infleeting>} */ $8M67s.Message.getRepeatedWrapperField(this, $9YICB.Infleeting, 1);
};
/**
 * @param {!Array<!proto.vehicle.Infleeting>} value
 * @return {!proto.fleet_service.GetVehicleInfleetingResponse} returns this
*/ proto.fleet_service.GetVehicleInfleetingResponse.prototype.setInfleetingsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.vehicle.Infleeting=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Infleeting}
 */ proto.fleet_service.GetVehicleInfleetingResponse.prototype.addInfleetings = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vehicle.Infleeting, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.GetVehicleInfleetingResponse} returns this
 */ proto.fleet_service.GetVehicleInfleetingResponse.prototype.clearInfleetingsList = function() {
    return this.setInfleetingsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateVehicleInfleetingRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateVehicleInfleetingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            infleeting: (f = msg.getInfleeting()) && $9YICB.Infleeting.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateVehicleInfleetingRequest}
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateVehicleInfleetingRequest;
    return proto.fleet_service.UpdateVehicleInfleetingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateVehicleInfleetingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateVehicleInfleetingRequest}
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Infleeting;
                reader.readMessage(value, $9YICB.Infleeting.deserializeBinaryFromReader);
                msg.setInfleeting(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateVehicleInfleetingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateVehicleInfleetingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInfleeting();
    if (f != null) writer.writeMessage(1, f, $9YICB.Infleeting.serializeBinaryToWriter);
};
/**
 * optional vehicle.Infleeting infleeting = 1;
 * @return {?proto.vehicle.Infleeting}
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.prototype.getInfleeting = function() {
    return /** @type{?proto.vehicle.Infleeting} */ $8M67s.Message.getWrapperField(this, $9YICB.Infleeting, 1);
};
/**
 * @param {?proto.vehicle.Infleeting|undefined} value
 * @return {!proto.fleet_service.UpdateVehicleInfleetingRequest} returns this
*/ proto.fleet_service.UpdateVehicleInfleetingRequest.prototype.setInfleeting = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.UpdateVehicleInfleetingRequest} returns this
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.prototype.clearInfleeting = function() {
    return this.setInfleeting(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.UpdateVehicleInfleetingRequest.prototype.hasInfleeting = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateVehicleInfleetingResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateVehicleInfleetingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            infleeting: (f = msg.getInfleeting()) && $9YICB.Infleeting.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateVehicleInfleetingResponse}
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateVehicleInfleetingResponse;
    return proto.fleet_service.UpdateVehicleInfleetingResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateVehicleInfleetingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateVehicleInfleetingResponse}
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Infleeting;
                reader.readMessage(value, $9YICB.Infleeting.deserializeBinaryFromReader);
                msg.setInfleeting(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateVehicleInfleetingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateVehicleInfleetingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInfleeting();
    if (f != null) writer.writeMessage(1, f, $9YICB.Infleeting.serializeBinaryToWriter);
};
/**
 * optional vehicle.Infleeting infleeting = 1;
 * @return {?proto.vehicle.Infleeting}
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.prototype.getInfleeting = function() {
    return /** @type{?proto.vehicle.Infleeting} */ $8M67s.Message.getWrapperField(this, $9YICB.Infleeting, 1);
};
/**
 * @param {?proto.vehicle.Infleeting|undefined} value
 * @return {!proto.fleet_service.UpdateVehicleInfleetingResponse} returns this
*/ proto.fleet_service.UpdateVehicleInfleetingResponse.prototype.setInfleeting = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.UpdateVehicleInfleetingResponse} returns this
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.prototype.clearInfleeting = function() {
    return this.setInfleeting(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.UpdateVehicleInfleetingResponse.prototype.hasInfleeting = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.RecordMileageDrivenLogRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.RecordMileageDrivenLogRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.RecordMileageDrivenLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.RecordMileageDrivenLogRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            time: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.RecordMileageDrivenLogRequest}
 */ proto.fleet_service.RecordMileageDrivenLogRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.RecordMileageDrivenLogRequest;
    return proto.fleet_service.RecordMileageDrivenLogRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.RecordMileageDrivenLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.RecordMileageDrivenLogRequest}
 */ proto.fleet_service.RecordMileageDrivenLogRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.RecordMileageDrivenLogRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.RecordMileageDrivenLogRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.RecordMileageDrivenLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.RecordMileageDrivenLogRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTime();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.fleet_service.RecordMileageDrivenLogRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.RecordMileageDrivenLogRequest} returns this
 */ proto.fleet_service.RecordMileageDrivenLogRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string time = 2;
 * @return {string}
 */ proto.fleet_service.RecordMileageDrivenLogRequest.prototype.getTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.RecordMileageDrivenLogRequest} returns this
 */ proto.fleet_service.RecordMileageDrivenLogRequest.prototype.setTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.RecordMileageDrivenLogResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.RecordMileageDrivenLogResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.RecordMileageDrivenLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.RecordMileageDrivenLogResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.RecordMileageDrivenLogResponse}
 */ proto.fleet_service.RecordMileageDrivenLogResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.RecordMileageDrivenLogResponse;
    return proto.fleet_service.RecordMileageDrivenLogResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.RecordMileageDrivenLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.RecordMileageDrivenLogResponse}
 */ proto.fleet_service.RecordMileageDrivenLogResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.RecordMileageDrivenLogResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.RecordMileageDrivenLogResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.RecordMileageDrivenLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.RecordMileageDrivenLogResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.VehiclePickup.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.VehiclePickup.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.VehiclePickup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehiclePickup.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            odometer: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            time: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.VehiclePickup}
 */ proto.fleet_service.VehiclePickup.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.VehiclePickup;
    return proto.fleet_service.VehiclePickup.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.VehiclePickup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.VehiclePickup}
 */ proto.fleet_service.VehiclePickup.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOdometer(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.VehiclePickup.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.VehiclePickup.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.VehiclePickup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehiclePickup.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getOdometer();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getTime();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.VehiclePickup.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehiclePickup} returns this
 */ proto.fleet_service.VehiclePickup.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.fleet_service.VehiclePickup.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehiclePickup} returns this
 */ proto.fleet_service.VehiclePickup.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 odometer = 3;
 * @return {number}
 */ proto.fleet_service.VehiclePickup.prototype.getOdometer = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.VehiclePickup} returns this
 */ proto.fleet_service.VehiclePickup.prototype.setOdometer = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string time = 4;
 * @return {string}
 */ proto.fleet_service.VehiclePickup.prototype.getTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehiclePickup} returns this
 */ proto.fleet_service.VehiclePickup.prototype.setTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListVehiclePickupsQuery.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListVehiclePickupsQuery.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListVehiclePickupsQuery.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListVehiclePickupsQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclePickupsQuery.toObject = function(includeInstance, msg) {
        var f, obj = {
            excludeReturned: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            subscriptionIdsList: (f = $8M67s.Message.getRepeatedField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListVehiclePickupsQuery}
 */ proto.fleet_service.ListVehiclePickupsQuery.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListVehiclePickupsQuery;
    return proto.fleet_service.ListVehiclePickupsQuery.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListVehiclePickupsQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListVehiclePickupsQuery}
 */ proto.fleet_service.ListVehiclePickupsQuery.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setExcludeReturned(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.addSubscriptionIds(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListVehiclePickupsQuery.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListVehiclePickupsQuery.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListVehiclePickupsQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclePickupsQuery.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getExcludeReturned();
    if (f) writer.writeBool(1, f);
    f = message.getSubscriptionIdsList();
    if (f.length > 0) writer.writeRepeatedString(2, f);
};
/**
 * optional bool exclude_returned = 1;
 * @return {boolean}
 */ proto.fleet_service.ListVehiclePickupsQuery.prototype.getExcludeReturned = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.ListVehiclePickupsQuery} returns this
 */ proto.fleet_service.ListVehiclePickupsQuery.prototype.setExcludeReturned = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * repeated string subscription_ids = 2;
 * @return {!Array<string>}
 */ proto.fleet_service.ListVehiclePickupsQuery.prototype.getSubscriptionIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.fleet_service.ListVehiclePickupsQuery} returns this
 */ proto.fleet_service.ListVehiclePickupsQuery.prototype.setSubscriptionIdsList = function(value) {
    return $8M67s.Message.setField(this, 2, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.ListVehiclePickupsQuery} returns this
 */ proto.fleet_service.ListVehiclePickupsQuery.prototype.addSubscriptionIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListVehiclePickupsQuery} returns this
 */ proto.fleet_service.ListVehiclePickupsQuery.prototype.clearSubscriptionIdsList = function() {
    return this.setSubscriptionIdsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListVehiclePickupsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListVehiclePickupsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclePickupsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            pageSize: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            pageToken: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            query: (f = msg.getQuery()) && proto.fleet_service.ListVehiclePickupsQuery.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListVehiclePickupsRequest}
 */ proto.fleet_service.ListVehiclePickupsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListVehiclePickupsRequest;
    return proto.fleet_service.ListVehiclePickupsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListVehiclePickupsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListVehiclePickupsRequest}
 */ proto.fleet_service.ListVehiclePickupsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPageSize(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPageToken(value);
                break;
            case 3:
                var value = new proto.fleet_service.ListVehiclePickupsQuery;
                reader.readMessage(value, proto.fleet_service.ListVehiclePickupsQuery.deserializeBinaryFromReader);
                msg.setQuery(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListVehiclePickupsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListVehiclePickupsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclePickupsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPageSize();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getPageToken();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getQuery();
    if (f != null) writer.writeMessage(3, f, proto.fleet_service.ListVehiclePickupsQuery.serializeBinaryToWriter);
};
/**
 * optional int32 page_size = 1;
 * @return {number}
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.getPageSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListVehiclePickupsRequest} returns this
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.setPageSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string page_token = 2;
 * @return {string}
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.getPageToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListVehiclePickupsRequest} returns this
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.setPageToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional ListVehiclePickupsQuery query = 3;
 * @return {?proto.fleet_service.ListVehiclePickupsQuery}
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.getQuery = function() {
    return /** @type{?proto.fleet_service.ListVehiclePickupsQuery} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.ListVehiclePickupsQuery, 3);
};
/**
 * @param {?proto.fleet_service.ListVehiclePickupsQuery|undefined} value
 * @return {!proto.fleet_service.ListVehiclePickupsRequest} returns this
*/ proto.fleet_service.ListVehiclePickupsRequest.prototype.setQuery = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.ListVehiclePickupsRequest} returns this
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.clearQuery = function() {
    return this.setQuery(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.ListVehiclePickupsRequest.prototype.hasQuery = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListVehiclePickupsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListVehiclePickupsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListVehiclePickupsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListVehiclePickupsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclePickupsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            pickupsList: $8M67s.Message.toObjectList(msg.getPickupsList(), proto.fleet_service.VehiclePickup.toObject, includeInstance),
            nextPageToken: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListVehiclePickupsResponse}
 */ proto.fleet_service.ListVehiclePickupsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListVehiclePickupsResponse;
    return proto.fleet_service.ListVehiclePickupsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListVehiclePickupsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListVehiclePickupsResponse}
 */ proto.fleet_service.ListVehiclePickupsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.VehiclePickup;
                reader.readMessage(value, proto.fleet_service.VehiclePickup.deserializeBinaryFromReader);
                msg.addPickups(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setNextPageToken(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListVehiclePickupsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListVehiclePickupsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListVehiclePickupsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclePickupsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPickupsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.VehiclePickup.serializeBinaryToWriter);
    f = message.getNextPageToken();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * repeated VehiclePickup pickups = 1;
 * @return {!Array<!proto.fleet_service.VehiclePickup>}
 */ proto.fleet_service.ListVehiclePickupsResponse.prototype.getPickupsList = function() {
    return /** @type{!Array<!proto.fleet_service.VehiclePickup>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.VehiclePickup, 1);
};
/**
 * @param {!Array<!proto.fleet_service.VehiclePickup>} value
 * @return {!proto.fleet_service.ListVehiclePickupsResponse} returns this
*/ proto.fleet_service.ListVehiclePickupsResponse.prototype.setPickupsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.VehiclePickup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.VehiclePickup}
 */ proto.fleet_service.ListVehiclePickupsResponse.prototype.addPickups = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.VehiclePickup, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListVehiclePickupsResponse} returns this
 */ proto.fleet_service.ListVehiclePickupsResponse.prototype.clearPickupsList = function() {
    return this.setPickupsList([]);
};
/**
 * optional string next_page_token = 2;
 * @return {string}
 */ proto.fleet_service.ListVehiclePickupsResponse.prototype.getNextPageToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListVehiclePickupsResponse} returns this
 */ proto.fleet_service.ListVehiclePickupsResponse.prototype.setNextPageToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListVehiclePickupsToken.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListVehiclePickupsToken.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListVehiclePickupsToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclePickupsToken.toObject = function(includeInstance, msg) {
        var f, obj = {
            lastTime: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            lastPickupId: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListVehiclePickupsToken}
 */ proto.fleet_service.ListVehiclePickupsToken.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListVehiclePickupsToken;
    return proto.fleet_service.ListVehiclePickupsToken.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListVehiclePickupsToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListVehiclePickupsToken}
 */ proto.fleet_service.ListVehiclePickupsToken.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setLastTime(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLastPickupId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListVehiclePickupsToken.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListVehiclePickupsToken.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListVehiclePickupsToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListVehiclePickupsToken.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLastTime();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLastPickupId();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string last_time = 1;
 * @return {string}
 */ proto.fleet_service.ListVehiclePickupsToken.prototype.getLastTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListVehiclePickupsToken} returns this
 */ proto.fleet_service.ListVehiclePickupsToken.prototype.setLastTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 last_pickup_id = 2;
 * @return {number}
 */ proto.fleet_service.ListVehiclePickupsToken.prototype.getLastPickupId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListVehiclePickupsToken} returns this
 */ proto.fleet_service.ListVehiclePickupsToken.prototype.setLastPickupId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListInspectionReportsQuery.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListInspectionReportsQuery.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListInspectionReportsQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListInspectionReportsQuery.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            createdAfter: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListInspectionReportsQuery}
 */ proto.fleet_service.ListInspectionReportsQuery.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListInspectionReportsQuery;
    return proto.fleet_service.ListInspectionReportsQuery.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListInspectionReportsQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListInspectionReportsQuery}
 */ proto.fleet_service.ListInspectionReportsQuery.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreatedAfter(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListInspectionReportsQuery.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListInspectionReportsQuery.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListInspectionReportsQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListInspectionReportsQuery.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreatedAfter();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.ListInspectionReportsQuery.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListInspectionReportsQuery} returns this
 */ proto.fleet_service.ListInspectionReportsQuery.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 created_after = 2;
 * @return {number}
 */ proto.fleet_service.ListInspectionReportsQuery.prototype.getCreatedAfter = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListInspectionReportsQuery} returns this
 */ proto.fleet_service.ListInspectionReportsQuery.prototype.setCreatedAfter = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListInspectionReportsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListInspectionReportsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListInspectionReportsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            pageSize: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            pageToken: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            query: (f = msg.getQuery()) && proto.fleet_service.ListInspectionReportsQuery.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListInspectionReportsRequest}
 */ proto.fleet_service.ListInspectionReportsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListInspectionReportsRequest;
    return proto.fleet_service.ListInspectionReportsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListInspectionReportsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListInspectionReportsRequest}
 */ proto.fleet_service.ListInspectionReportsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPageSize(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPageToken(value);
                break;
            case 3:
                var value = new proto.fleet_service.ListInspectionReportsQuery;
                reader.readMessage(value, proto.fleet_service.ListInspectionReportsQuery.deserializeBinaryFromReader);
                msg.setQuery(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListInspectionReportsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListInspectionReportsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListInspectionReportsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPageSize();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getPageToken();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getQuery();
    if (f != null) writer.writeMessage(3, f, proto.fleet_service.ListInspectionReportsQuery.serializeBinaryToWriter);
};
/**
 * optional int32 page_size = 1;
 * @return {number}
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.getPageSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListInspectionReportsRequest} returns this
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.setPageSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string page_token = 2;
 * @return {string}
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.getPageToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListInspectionReportsRequest} returns this
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.setPageToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional ListInspectionReportsQuery query = 3;
 * @return {?proto.fleet_service.ListInspectionReportsQuery}
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.getQuery = function() {
    return /** @type{?proto.fleet_service.ListInspectionReportsQuery} */ $8M67s.Message.getWrapperField(this, proto.fleet_service.ListInspectionReportsQuery, 3);
};
/**
 * @param {?proto.fleet_service.ListInspectionReportsQuery|undefined} value
 * @return {!proto.fleet_service.ListInspectionReportsRequest} returns this
*/ proto.fleet_service.ListInspectionReportsRequest.prototype.setQuery = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.fleet_service.ListInspectionReportsRequest} returns this
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.clearQuery = function() {
    return this.setQuery(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.fleet_service.ListInspectionReportsRequest.prototype.hasQuery = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.ListInspectionReportsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListInspectionReportsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListInspectionReportsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListInspectionReportsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListInspectionReportsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            reportsList: $8M67s.Message.toObjectList(msg.getReportsList(), proto.fleet_service.InspectionReport.toObject, includeInstance),
            nextPageToken: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListInspectionReportsResponse}
 */ proto.fleet_service.ListInspectionReportsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListInspectionReportsResponse;
    return proto.fleet_service.ListInspectionReportsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListInspectionReportsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListInspectionReportsResponse}
 */ proto.fleet_service.ListInspectionReportsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.InspectionReport;
                reader.readMessage(value, proto.fleet_service.InspectionReport.deserializeBinaryFromReader);
                msg.addReports(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setNextPageToken(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListInspectionReportsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListInspectionReportsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListInspectionReportsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListInspectionReportsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReportsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.InspectionReport.serializeBinaryToWriter);
    f = message.getNextPageToken();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * repeated InspectionReport reports = 1;
 * @return {!Array<!proto.fleet_service.InspectionReport>}
 */ proto.fleet_service.ListInspectionReportsResponse.prototype.getReportsList = function() {
    return /** @type{!Array<!proto.fleet_service.InspectionReport>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.InspectionReport, 1);
};
/**
 * @param {!Array<!proto.fleet_service.InspectionReport>} value
 * @return {!proto.fleet_service.ListInspectionReportsResponse} returns this
*/ proto.fleet_service.ListInspectionReportsResponse.prototype.setReportsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.InspectionReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.InspectionReport}
 */ proto.fleet_service.ListInspectionReportsResponse.prototype.addReports = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.InspectionReport, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.ListInspectionReportsResponse} returns this
 */ proto.fleet_service.ListInspectionReportsResponse.prototype.clearReportsList = function() {
    return this.setReportsList([]);
};
/**
 * optional string next_page_token = 2;
 * @return {string}
 */ proto.fleet_service.ListInspectionReportsResponse.prototype.getNextPageToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListInspectionReportsResponse} returns this
 */ proto.fleet_service.ListInspectionReportsResponse.prototype.setNextPageToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.ListInspectionReportsToken.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.ListInspectionReportsToken.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.ListInspectionReportsToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListInspectionReportsToken.toObject = function(includeInstance, msg) {
        var f, obj = {
            lastCreatedAt: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            lastReportId: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.ListInspectionReportsToken}
 */ proto.fleet_service.ListInspectionReportsToken.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.ListInspectionReportsToken;
    return proto.fleet_service.ListInspectionReportsToken.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.ListInspectionReportsToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.ListInspectionReportsToken}
 */ proto.fleet_service.ListInspectionReportsToken.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setLastCreatedAt(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLastReportId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.ListInspectionReportsToken.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.ListInspectionReportsToken.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.ListInspectionReportsToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.ListInspectionReportsToken.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLastCreatedAt();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLastReportId();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string last_created_at = 1;
 * @return {string}
 */ proto.fleet_service.ListInspectionReportsToken.prototype.getLastCreatedAt = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.ListInspectionReportsToken} returns this
 */ proto.fleet_service.ListInspectionReportsToken.prototype.setLastCreatedAt = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 last_report_id = 2;
 * @return {number}
 */ proto.fleet_service.ListInspectionReportsToken.prototype.getLastReportId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.ListInspectionReportsToken} returns this
 */ proto.fleet_service.ListInspectionReportsToken.prototype.setLastReportId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateStateToInListingRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateStateToInListingRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateStateToInListingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToInListingRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateStateToInListingRequest}
 */ proto.fleet_service.UpdateStateToInListingRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateStateToInListingRequest;
    return proto.fleet_service.UpdateStateToInListingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateStateToInListingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateStateToInListingRequest}
 */ proto.fleet_service.UpdateStateToInListingRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateStateToInListingRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateStateToInListingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateStateToInListingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToInListingRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.UpdateStateToInListingRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpdateStateToInListingRequest} returns this
 */ proto.fleet_service.UpdateStateToInListingRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateStateToInListingResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateStateToInListingResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateStateToInListingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToInListingResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateStateToInListingResponse}
 */ proto.fleet_service.UpdateStateToInListingResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateStateToInListingResponse;
    return proto.fleet_service.UpdateStateToInListingResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateStateToInListingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateStateToInListingResponse}
 */ proto.fleet_service.UpdateStateToInListingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateStateToInListingResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateStateToInListingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateStateToInListingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToInListingResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateStateToInProcessRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateStateToInProcessRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateStateToInProcessRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToInProcessRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateStateToInProcessRequest}
 */ proto.fleet_service.UpdateStateToInProcessRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateStateToInProcessRequest;
    return proto.fleet_service.UpdateStateToInProcessRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateStateToInProcessRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateStateToInProcessRequest}
 */ proto.fleet_service.UpdateStateToInProcessRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateStateToInProcessRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateStateToInProcessRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateStateToInProcessRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToInProcessRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.UpdateStateToInProcessRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpdateStateToInProcessRequest} returns this
 */ proto.fleet_service.UpdateStateToInProcessRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateStateToInProcessResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateStateToInProcessResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateStateToInProcessResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToInProcessResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateStateToInProcessResponse}
 */ proto.fleet_service.UpdateStateToInProcessResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateStateToInProcessResponse;
    return proto.fleet_service.UpdateStateToInProcessResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateStateToInProcessResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateStateToInProcessResponse}
 */ proto.fleet_service.UpdateStateToInProcessResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateStateToInProcessResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateStateToInProcessResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateStateToInProcessResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToInProcessResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateStateToSoldRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateStateToSoldRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateStateToSoldRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToSoldRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateStateToSoldRequest}
 */ proto.fleet_service.UpdateStateToSoldRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateStateToSoldRequest;
    return proto.fleet_service.UpdateStateToSoldRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateStateToSoldRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateStateToSoldRequest}
 */ proto.fleet_service.UpdateStateToSoldRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateStateToSoldRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateStateToSoldRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateStateToSoldRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToSoldRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.UpdateStateToSoldRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpdateStateToSoldRequest} returns this
 */ proto.fleet_service.UpdateStateToSoldRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateStateToSoldResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateStateToSoldResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateStateToSoldResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToSoldResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateStateToSoldResponse}
 */ proto.fleet_service.UpdateStateToSoldResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateStateToSoldResponse;
    return proto.fleet_service.UpdateStateToSoldResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateStateToSoldResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateStateToSoldResponse}
 */ proto.fleet_service.UpdateStateToSoldResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateStateToSoldResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateStateToSoldResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateStateToSoldResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToSoldResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateStateToTotalLossRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateStateToTotalLossRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateStateToTotalLossRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToTotalLossRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateStateToTotalLossRequest}
 */ proto.fleet_service.UpdateStateToTotalLossRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateStateToTotalLossRequest;
    return proto.fleet_service.UpdateStateToTotalLossRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateStateToTotalLossRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateStateToTotalLossRequest}
 */ proto.fleet_service.UpdateStateToTotalLossRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateStateToTotalLossRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateStateToTotalLossRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateStateToTotalLossRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToTotalLossRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.UpdateStateToTotalLossRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpdateStateToTotalLossRequest} returns this
 */ proto.fleet_service.UpdateStateToTotalLossRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpdateStateToTotalLossResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpdateStateToTotalLossResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpdateStateToTotalLossResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToTotalLossResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpdateStateToTotalLossResponse}
 */ proto.fleet_service.UpdateStateToTotalLossResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpdateStateToTotalLossResponse;
    return proto.fleet_service.UpdateStateToTotalLossResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpdateStateToTotalLossResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpdateStateToTotalLossResponse}
 */ proto.fleet_service.UpdateStateToTotalLossResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpdateStateToTotalLossResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpdateStateToTotalLossResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpdateStateToTotalLossResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpdateStateToTotalLossResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.LogMilesPurchasedRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.LogMilesPurchasedRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.LogMilesPurchasedRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            price: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            time: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            referenceId: $8M67s.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.LogMilesPurchasedRequest}
 */ proto.fleet_service.LogMilesPurchasedRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.LogMilesPurchasedRequest;
    return proto.fleet_service.LogMilesPurchasedRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.LogMilesPurchasedRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.LogMilesPurchasedRequest}
 */ proto.fleet_service.LogMilesPurchasedRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPrice(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTime(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setReferenceId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.LogMilesPurchasedRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.LogMilesPurchasedRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.LogMilesPurchasedRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getPrice();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getTime();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getReferenceId();
    if (f.length > 0) writer.writeString(6, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.LogMilesPurchasedRequest} returns this
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.LogMilesPurchasedRequest} returns this
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 amount = 3;
 * @return {number}
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.LogMilesPurchasedRequest} returns this
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 price = 4;
 * @return {number}
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.getPrice = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.LogMilesPurchasedRequest} returns this
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.setPrice = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 time = 5;
 * @return {number}
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.getTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.LogMilesPurchasedRequest} returns this
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.setTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string reference_id = 6;
 * @return {string}
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.getReferenceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.LogMilesPurchasedRequest} returns this
 */ proto.fleet_service.LogMilesPurchasedRequest.prototype.setReferenceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.LogMilesPurchasedResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.LogMilesPurchasedResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.LogMilesPurchasedResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.LogMilesPurchasedResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.LogMilesPurchasedResponse}
 */ proto.fleet_service.LogMilesPurchasedResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.LogMilesPurchasedResponse;
    return proto.fleet_service.LogMilesPurchasedResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.LogMilesPurchasedResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.LogMilesPurchasedResponse}
 */ proto.fleet_service.LogMilesPurchasedResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.LogMilesPurchasedResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.LogMilesPurchasedResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.LogMilesPurchasedResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.LogMilesPurchasedResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.fleet_service.LogMilesPurchasedResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.LogMilesPurchasedResponse} returns this
 */ proto.fleet_service.LogMilesPurchasedResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.DeleteMilesPurchasedLogRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.DeleteMilesPurchasedLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.DeleteMilesPurchasedLogRequest}
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.DeleteMilesPurchasedLogRequest;
    return proto.fleet_service.DeleteMilesPurchasedLogRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.DeleteMilesPurchasedLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.DeleteMilesPurchasedLogRequest}
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.DeleteMilesPurchasedLogRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.DeleteMilesPurchasedLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f !== 0) writer.writeInt32(1, f);
};
/**
 * optional int32 id = 1;
 * @return {number}
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest.prototype.getId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.DeleteMilesPurchasedLogRequest} returns this
 */ proto.fleet_service.DeleteMilesPurchasedLogRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.DeleteMilesPurchasedLogResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.DeleteMilesPurchasedLogResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.DeleteMilesPurchasedLogResponse}
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.DeleteMilesPurchasedLogResponse;
    return proto.fleet_service.DeleteMilesPurchasedLogResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.DeleteMilesPurchasedLogResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.DeleteMilesPurchasedLogResponse}
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.DeleteMilesPurchasedLogResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.DeleteMilesPurchasedLogResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.DeleteMilesPurchasedLogResponse} returns this
 */ proto.fleet_service.DeleteMilesPurchasedLogResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleMediaRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleMediaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleMediaRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            make: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleMediaRequest}
 */ proto.fleet_service.GetVehicleMediaRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleMediaRequest;
    return proto.fleet_service.GetVehicleMediaRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleMediaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleMediaRequest}
 */ proto.fleet_service.GetVehicleMediaRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setYear(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleMediaRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleMediaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleMediaRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMake();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getYear();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional string make = 1;
 * @return {string}
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetVehicleMediaRequest} returns this
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string model = 2;
 * @return {string}
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetVehicleMediaRequest} returns this
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string trim = 3;
 * @return {string}
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.GetVehicleMediaRequest} returns this
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 year = 4;
 * @return {number}
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.getYear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.GetVehicleMediaRequest} returns this
 */ proto.fleet_service.GetVehicleMediaRequest.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.VehicleMedia.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.VehicleMedia.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.VehicleMedia} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehicleMedia.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            clientId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            data: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            createdAt: $8M67s.Message.getFieldWithDefault(msg, 8, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.VehicleMedia}
 */ proto.fleet_service.VehicleMedia.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.VehicleMedia;
    return proto.fleet_service.VehicleMedia.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.VehicleMedia} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.VehicleMedia}
 */ proto.fleet_service.VehicleMedia.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setClientId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setYear(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setData(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setCreatedAt(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.VehicleMedia.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.VehicleMedia.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.VehicleMedia} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.VehicleMedia.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getClientId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getYear();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getData();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getCreatedAt();
    if (f.length > 0) writer.writeString(8, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.VehicleMedia.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleMedia} returns this
 */ proto.fleet_service.VehicleMedia.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string client_id = 2;
 * @return {string}
 */ proto.fleet_service.VehicleMedia.prototype.getClientId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleMedia} returns this
 */ proto.fleet_service.VehicleMedia.prototype.setClientId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string make = 3;
 * @return {string}
 */ proto.fleet_service.VehicleMedia.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleMedia} returns this
 */ proto.fleet_service.VehicleMedia.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string model = 4;
 * @return {string}
 */ proto.fleet_service.VehicleMedia.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleMedia} returns this
 */ proto.fleet_service.VehicleMedia.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string trim = 5;
 * @return {string}
 */ proto.fleet_service.VehicleMedia.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleMedia} returns this
 */ proto.fleet_service.VehicleMedia.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 year = 6;
 * @return {number}
 */ proto.fleet_service.VehicleMedia.prototype.getYear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.VehicleMedia} returns this
 */ proto.fleet_service.VehicleMedia.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional string data = 7;
 * @return {string}
 */ proto.fleet_service.VehicleMedia.prototype.getData = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleMedia} returns this
 */ proto.fleet_service.VehicleMedia.prototype.setData = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string created_at = 8;
 * @return {string}
 */ proto.fleet_service.VehicleMedia.prototype.getCreatedAt = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.VehicleMedia} returns this
 */ proto.fleet_service.VehicleMedia.prototype.setCreatedAt = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.fleet_service.GetVehicleMediaResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.GetVehicleMediaResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.GetVehicleMediaResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.GetVehicleMediaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleMediaResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            mediaList: $8M67s.Message.toObjectList(msg.getMediaList(), proto.fleet_service.VehicleMedia.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.GetVehicleMediaResponse}
 */ proto.fleet_service.GetVehicleMediaResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.GetVehicleMediaResponse;
    return proto.fleet_service.GetVehicleMediaResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.GetVehicleMediaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.GetVehicleMediaResponse}
 */ proto.fleet_service.GetVehicleMediaResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.fleet_service.VehicleMedia;
                reader.readMessage(value, proto.fleet_service.VehicleMedia.deserializeBinaryFromReader);
                msg.addMedia(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.GetVehicleMediaResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.GetVehicleMediaResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.GetVehicleMediaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.GetVehicleMediaResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMediaList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.fleet_service.VehicleMedia.serializeBinaryToWriter);
};
/**
 * repeated VehicleMedia media = 1;
 * @return {!Array<!proto.fleet_service.VehicleMedia>}
 */ proto.fleet_service.GetVehicleMediaResponse.prototype.getMediaList = function() {
    return /** @type{!Array<!proto.fleet_service.VehicleMedia>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.fleet_service.VehicleMedia, 1);
};
/**
 * @param {!Array<!proto.fleet_service.VehicleMedia>} value
 * @return {!proto.fleet_service.GetVehicleMediaResponse} returns this
*/ proto.fleet_service.GetVehicleMediaResponse.prototype.setMediaList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.fleet_service.VehicleMedia=} opt_value
 * @param {number=} opt_index
 * @return {!proto.fleet_service.VehicleMedia}
 */ proto.fleet_service.GetVehicleMediaResponse.prototype.addMedia = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.fleet_service.VehicleMedia, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.fleet_service.GetVehicleMediaResponse} returns this
 */ proto.fleet_service.GetVehicleMediaResponse.prototype.clearMediaList = function() {
    return this.setMediaList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpsertVehicleMediaRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpsertVehicleMediaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpsertVehicleMediaRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            data: $8M67s.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpsertVehicleMediaRequest}
 */ proto.fleet_service.UpsertVehicleMediaRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpsertVehicleMediaRequest;
    return proto.fleet_service.UpsertVehicleMediaRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpsertVehicleMediaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpsertVehicleMediaRequest}
 */ proto.fleet_service.UpsertVehicleMediaRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setYear(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpsertVehicleMediaRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpsertVehicleMediaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpsertVehicleMediaRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getYear();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getData();
    if (f.length > 0) writer.writeString(6, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpsertVehicleMediaRequest} returns this
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string make = 2;
 * @return {string}
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpsertVehicleMediaRequest} returns this
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string model = 3;
 * @return {string}
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpsertVehicleMediaRequest} returns this
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string trim = 4;
 * @return {string}
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpsertVehicleMediaRequest} returns this
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 year = 5;
 * @return {number}
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.getYear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.fleet_service.UpsertVehicleMediaRequest} returns this
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string data = 6;
 * @return {string}
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.getData = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpsertVehicleMediaRequest} returns this
 */ proto.fleet_service.UpsertVehicleMediaRequest.prototype.setData = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.UpsertVehicleMediaResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.UpsertVehicleMediaResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.UpsertVehicleMediaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpsertVehicleMediaResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.UpsertVehicleMediaResponse}
 */ proto.fleet_service.UpsertVehicleMediaResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.UpsertVehicleMediaResponse;
    return proto.fleet_service.UpsertVehicleMediaResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.UpsertVehicleMediaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.UpsertVehicleMediaResponse}
 */ proto.fleet_service.UpsertVehicleMediaResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.UpsertVehicleMediaResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.UpsertVehicleMediaResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.UpsertVehicleMediaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.UpsertVehicleMediaResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.UpsertVehicleMediaResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.UpsertVehicleMediaResponse} returns this
 */ proto.fleet_service.UpsertVehicleMediaResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.DeleteVehicleMediaRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.DeleteVehicleMediaRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.DeleteVehicleMediaRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteVehicleMediaRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.DeleteVehicleMediaRequest}
 */ proto.fleet_service.DeleteVehicleMediaRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.DeleteVehicleMediaRequest;
    return proto.fleet_service.DeleteVehicleMediaRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.DeleteVehicleMediaRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.DeleteVehicleMediaRequest}
 */ proto.fleet_service.DeleteVehicleMediaRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.DeleteVehicleMediaRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.DeleteVehicleMediaRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.DeleteVehicleMediaRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteVehicleMediaRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.fleet_service.DeleteVehicleMediaRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.fleet_service.DeleteVehicleMediaRequest} returns this
 */ proto.fleet_service.DeleteVehicleMediaRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.fleet_service.DeleteVehicleMediaResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.fleet_service.DeleteVehicleMediaResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.fleet_service.DeleteVehicleMediaResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteVehicleMediaResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.fleet_service.DeleteVehicleMediaResponse}
 */ proto.fleet_service.DeleteVehicleMediaResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.fleet_service.DeleteVehicleMediaResponse;
    return proto.fleet_service.DeleteVehicleMediaResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.fleet_service.DeleteVehicleMediaResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.fleet_service.DeleteVehicleMediaResponse}
 */ proto.fleet_service.DeleteVehicleMediaResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.fleet_service.DeleteVehicleMediaResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.fleet_service.DeleteVehicleMediaResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.fleet_service.DeleteVehicleMediaResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.fleet_service.DeleteVehicleMediaResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.fleet_service.DeleteVehicleMediaResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.fleet_service.DeleteVehicleMediaResponse} returns this
 */ proto.fleet_service.DeleteVehicleMediaResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * @enum {number}
 */ proto.fleet_service.MatsStatus = {
    MATS_STATUS_UNSPECIFIED: 0,
    MATS_STATUS_ALL: 1,
    MATS_STATUS_MISSING_FRONT: 2,
    MATS_STATUS_MISSING_REAR: 3,
    MATS_STATUS_NONE: 4
};
/**
 * @enum {number}
 */ proto.fleet_service.PhotoArea = {
    PHOTO_AREA_UNSPECIFIED: 0,
    PHOTO_AREA_HERO_SHOT: 1,
    PHOTO_AREA_BACK_PLATE: 2,
    PHOTO_AREA_ODOMETER: 3,
    PHOTO_AREA_OTHER: 4
};
/**
 * @enum {number}
 */ proto.fleet_service.Priority = {
    PRIMARY: 0,
    SECONDARY: 1
};
$2a9017512e0f7864$var$goog.object.extend(module.exports, proto.fleet_service);

});
parcelRegister("9YICB", function(module, exports) {
// source: vehicle.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $743c5491af46e344$var$goog = $8M67s;
var $743c5491af46e344$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$743c5491af46e344$var$goog.object.extend(proto, $3QqPt);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Activity', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.ActivityFailure', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.ActivityState', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Annotation', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.BuyersGuide', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Color', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Color.Name', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.ColorCode', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.ColorCode.Type', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Coordinates', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.CustodianType', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Custody', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Custody.CustodianCase', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Document', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Document.TypeCase', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Infleeting', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Infleeting.InfleetingStatus', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.InfleetingVehicle', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Ingestion', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Ingestion.ChangeType', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Inspection', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.InspectionPhoto', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Location', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.LocationUpdate', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.LocationUpdated', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Maintenance', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Media', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Media.Angle', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Media.Category', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Model', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Odometer', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Odometer.ReadingType', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Odometer.Units', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.OdometerUpdate', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.OdometerUpdate.Units', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Preference', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Preference.Color', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Priority', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Profile', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Property', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.PropertyUpdated', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.PropertyUpdated.UpdatedPropertyCase', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.PurchaseOrder', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Reg262', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Reg51', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Reg553', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Registration', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.State', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Title', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.UsedVehicleHistoryDisclosure', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Valuation', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Valuation.ValuationType', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Vehicle', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.VehicleDeleted', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.VehicleDeleted.Reason', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.VehicleInfleetingUpdated', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.VehiclePreferencesNotAvailable', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.VehicleTagType', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.VehicleTermsOfService', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.VehicleUpdated', null, $743c5491af46e344$var$global);
$743c5491af46e344$var$goog.exportSymbol('proto.vehicle.Warranty', null, $743c5491af46e344$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Custody = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.vehicle.Custody.oneofGroups_);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Custody, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Custody.displayName = 'proto.vehicle.Custody';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Media = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Media, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Media.displayName = 'proto.vehicle.Media';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Valuation = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Valuation, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Valuation.displayName = 'proto.vehicle.Valuation';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Color = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle.Color.repeatedFields_, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Color, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Color.displayName = 'proto.vehicle.Color';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.ColorCode = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.ColorCode, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.ColorCode.displayName = 'proto.vehicle.ColorCode';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Profile = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle.Profile.repeatedFields_, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Profile, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Profile.displayName = 'proto.vehicle.Profile';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Property = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Property, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Property.displayName = 'proto.vehicle.Property';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Vehicle = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle.Vehicle.repeatedFields_, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Vehicle, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Vehicle.displayName = 'proto.vehicle.Vehicle';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Coordinates = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Coordinates, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Coordinates.displayName = 'proto.vehicle.Coordinates';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Location = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Location, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Location.displayName = 'proto.vehicle.Location';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Odometer = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Odometer, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Odometer.displayName = 'proto.vehicle.Odometer';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Annotation = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Annotation, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Annotation.displayName = 'proto.vehicle.Annotation';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Inspection = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Inspection, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Inspection.displayName = 'proto.vehicle.Inspection';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.InspectionPhoto = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.InspectionPhoto, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.InspectionPhoto.displayName = 'proto.vehicle.InspectionPhoto';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Registration = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Registration, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Registration.displayName = 'proto.vehicle.Registration';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Title = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Title, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Title.displayName = 'proto.vehicle.Title';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Warranty = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Warranty, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Warranty.displayName = 'proto.vehicle.Warranty';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Maintenance = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Maintenance, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Maintenance.displayName = 'proto.vehicle.Maintenance';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Reg262 = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Reg262, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Reg262.displayName = 'proto.vehicle.Reg262';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.PurchaseOrder = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.PurchaseOrder, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.PurchaseOrder.displayName = 'proto.vehicle.PurchaseOrder';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Reg51 = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Reg51, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Reg51.displayName = 'proto.vehicle.Reg51';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Reg553 = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Reg553, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Reg553.displayName = 'proto.vehicle.Reg553';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.BuyersGuide = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.BuyersGuide, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.BuyersGuide.displayName = 'proto.vehicle.BuyersGuide';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.UsedVehicleHistoryDisclosure = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.UsedVehicleHistoryDisclosure, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.UsedVehicleHistoryDisclosure.displayName = 'proto.vehicle.UsedVehicleHistoryDisclosure';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.VehicleTermsOfService = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.VehicleTermsOfService, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.VehicleTermsOfService.displayName = 'proto.vehicle.VehicleTermsOfService';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.VehicleUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle.VehicleUpdated.repeatedFields_, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.VehicleUpdated, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.VehicleUpdated.displayName = 'proto.vehicle.VehicleUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.PropertyUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.vehicle.PropertyUpdated.oneofGroups_);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.PropertyUpdated, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.PropertyUpdated.displayName = 'proto.vehicle.PropertyUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.VehicleDeleted = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.VehicleDeleted, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.VehicleDeleted.displayName = 'proto.vehicle.VehicleDeleted';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Ingestion = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle.Ingestion.repeatedFields_, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Ingestion, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Ingestion.displayName = 'proto.vehicle.Ingestion';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.LocationUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.LocationUpdated, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.LocationUpdated.displayName = 'proto.vehicle.LocationUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.LocationUpdate = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.LocationUpdate, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.LocationUpdate.displayName = 'proto.vehicle.LocationUpdate';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.OdometerUpdate = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.OdometerUpdate, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.OdometerUpdate.displayName = 'proto.vehicle.OdometerUpdate';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.VehiclePreferencesNotAvailable = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle.VehiclePreferencesNotAvailable.repeatedFields_, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.VehiclePreferencesNotAvailable, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.VehiclePreferencesNotAvailable.displayName = 'proto.vehicle.VehiclePreferencesNotAvailable';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Preference = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Preference, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Preference.displayName = 'proto.vehicle.Preference';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Infleeting = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle.Infleeting.repeatedFields_, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Infleeting, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Infleeting.displayName = 'proto.vehicle.Infleeting';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.VehicleInfleetingUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.VehicleInfleetingUpdated, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.VehicleInfleetingUpdated.displayName = 'proto.vehicle.VehicleInfleetingUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.InfleetingVehicle = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.InfleetingVehicle, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.InfleetingVehicle.displayName = 'proto.vehicle.InfleetingVehicle';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle.Document = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.vehicle.Document.oneofGroups_);
};
$743c5491af46e344$var$goog.inherits(proto.vehicle.Document, $8M67s.Message);
if ($743c5491af46e344$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle.Document.displayName = 'proto.vehicle.Document';
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.vehicle.Custody.oneofGroups_ = [
    [
        1,
        2,
        5,
        6
    ]
];
/**
 * @enum {number}
 */ proto.vehicle.Custody.CustodianCase = {
    CUSTODIAN_NOT_SET: 0,
    DEALERSHIP: 1,
    CUSTOMER: 2,
    DEALERSHIP_ID: 5,
    CUSTOMER_ID: 6
};
/**
 * @return {proto.vehicle.Custody.CustodianCase}
 */ proto.vehicle.Custody.prototype.getCustodianCase = function() {
    return /** @type {proto.vehicle.Custody.CustodianCase} */ $8M67s.Message.computeOneofCase(this, proto.vehicle.Custody.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Custody.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Custody.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Custody} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Custody.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $3QqPt.Dealership.toObject(includeInstance, f),
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f),
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            stock: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Custody}
 */ proto.vehicle.Custody.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Custody;
    return proto.vehicle.Custody.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Custody} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Custody}
 */ proto.vehicle.Custody.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Dealership;
                reader.readMessage(value, $3QqPt.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            case 2:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setStock(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Custody.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Custody.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Custody} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Custody.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Dealership.serializeBinaryToWriter);
    f = message.getCustomer();
    if (f != null) writer.writeMessage(2, f, $3QqPt.Customer.serializeBinaryToWriter);
    f = /** @type {string} */ $8M67s.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = /** @type {string} */ $8M67s.Message.getField(message, 6);
    if (f != null) writer.writeString(6, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getStock();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional domain.Dealership dealership = 1;
 * @return {?proto.domain.Dealership}
 */ proto.vehicle.Custody.prototype.getDealership = function() {
    return /** @type{?proto.domain.Dealership} */ $8M67s.Message.getWrapperField(this, $3QqPt.Dealership, 1);
};
/**
 * @param {?proto.domain.Dealership|undefined} value
 * @return {!proto.vehicle.Custody} returns this
*/ proto.vehicle.Custody.prototype.setDealership = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 1, proto.vehicle.Custody.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Custody} returns this
 */ proto.vehicle.Custody.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Custody.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional domain.Customer customer = 2;
 * @return {?proto.domain.Customer}
 */ proto.vehicle.Custody.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 2);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.vehicle.Custody} returns this
*/ proto.vehicle.Custody.prototype.setCustomer = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 2, proto.vehicle.Custody.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Custody} returns this
 */ proto.vehicle.Custody.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Custody.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional string dealership_id = 5;
 * @return {string}
 */ proto.vehicle.Custody.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Custody} returns this
 */ proto.vehicle.Custody.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setOneofField(this, 5, proto.vehicle.Custody.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.vehicle.Custody} returns this
 */ proto.vehicle.Custody.prototype.clearDealershipId = function() {
    return $8M67s.Message.setOneofField(this, 5, proto.vehicle.Custody.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Custody.prototype.hasDealershipId = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional string customer_id = 6;
 * @return {string}
 */ proto.vehicle.Custody.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Custody} returns this
 */ proto.vehicle.Custody.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setOneofField(this, 6, proto.vehicle.Custody.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.vehicle.Custody} returns this
 */ proto.vehicle.Custody.prototype.clearCustomerId = function() {
    return $8M67s.Message.setOneofField(this, 6, proto.vehicle.Custody.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Custody.prototype.hasCustomerId = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional int64 date = 3;
 * @return {number}
 */ proto.vehicle.Custody.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Custody} returns this
 */ proto.vehicle.Custody.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string stock = 4;
 * @return {string}
 */ proto.vehicle.Custody.prototype.getStock = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Custody} returns this
 */ proto.vehicle.Custody.prototype.setStock = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Media.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Media.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Media} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Media.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            category: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            mediaType: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            data: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            source: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            color: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            simpleColor: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            angle: $8M67s.Message.getFieldWithDefault(msg, 8, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Media}
 */ proto.vehicle.Media.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Media;
    return proto.vehicle.Media.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Media} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Media}
 */ proto.vehicle.Media.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.vehicle.Media.Category} */ reader.readEnum();
                msg.setCategory(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMediaType(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setData(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setSource(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setSimpleColor(value);
                break;
            case 8:
                var value = /** @type {!proto.vehicle.Media.Angle} */ reader.readEnum();
                msg.setAngle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Media.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Media.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Media} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Media.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCategory();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getMediaType();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getData();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getSource();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getColor();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getSimpleColor();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getAngle();
    if (f !== 0.0) writer.writeEnum(8, f);
};
/**
 * @enum {number}
 */ proto.vehicle.Media.Category = {
    PICKUP: 0,
    DROPOFF: 1,
    STOCK: 3,
    FEED: 4,
    LISTING: 5
};
/**
 * @enum {number}
 */ proto.vehicle.Media.Angle = {
    THREE_QUARTER: 0,
    SIDE: 1
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Media.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Media} returns this
 */ proto.vehicle.Media.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Category category = 2;
 * @return {!proto.vehicle.Media.Category}
 */ proto.vehicle.Media.prototype.getCategory = function() {
    return /** @type {!proto.vehicle.Media.Category} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.vehicle.Media.Category} value
 * @return {!proto.vehicle.Media} returns this
 */ proto.vehicle.Media.prototype.setCategory = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string media_type = 3;
 * @return {string}
 */ proto.vehicle.Media.prototype.getMediaType = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Media} returns this
 */ proto.vehicle.Media.prototype.setMediaType = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string data = 4;
 * @return {string}
 */ proto.vehicle.Media.prototype.getData = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Media} returns this
 */ proto.vehicle.Media.prototype.setData = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string source = 5;
 * @return {string}
 */ proto.vehicle.Media.prototype.getSource = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Media} returns this
 */ proto.vehicle.Media.prototype.setSource = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string color = 6;
 * @return {string}
 */ proto.vehicle.Media.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Media} returns this
 */ proto.vehicle.Media.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string simple_color = 7;
 * @return {string}
 */ proto.vehicle.Media.prototype.getSimpleColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Media} returns this
 */ proto.vehicle.Media.prototype.setSimpleColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional Angle angle = 8;
 * @return {!proto.vehicle.Media.Angle}
 */ proto.vehicle.Media.prototype.getAngle = function() {
    return /** @type {!proto.vehicle.Media.Angle} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {!proto.vehicle.Media.Angle} value
 * @return {!proto.vehicle.Media} returns this
 */ proto.vehicle.Media.prototype.setAngle = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 8, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Valuation.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Valuation.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Valuation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Valuation.toObject = function(includeInstance, msg) {
        var f, obj = {
            amount: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            term: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            units: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            projectedDate: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            source: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            valuationType: $8M67s.Message.getFieldWithDefault(msg, 8, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Valuation}
 */ proto.vehicle.Valuation.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Valuation;
    return proto.vehicle.Valuation.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Valuation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Valuation}
 */ proto.vehicle.Valuation.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setAmount(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTerm(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setUnits(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setProjectedDate(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSource(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 8:
                var value = /** @type {!proto.vehicle.Valuation.ValuationType} */ reader.readEnum();
                msg.setValuationType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Valuation.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Valuation.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Valuation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Valuation.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAmount();
    if (f !== 0) writer.writeInt64(1, f);
    f = message.getTerm();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUnits();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getProjectedDate();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getSource();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getValuationType();
    if (f !== 0.0) writer.writeEnum(8, f);
};
/**
 * @enum {number}
 */ proto.vehicle.Valuation.ValuationType = {
    RETAIL: 0,
    FMV: 1,
    OFFER: 2,
    SPECIAL_PRICE: 3,
    SELLING_PRICE: 4,
    RECENT_AVERAGE_RETAIL: 5,
    RECENT_AVERAGE_LISTING_PRICE: 6,
    RECENT_AVERAGE_COST: 7,
    RECENT_AVERAGE_PROFIT: 8,
    RECENT_AVERAGE_DAYS_TO_TURN: 9,
    AVERAGE_CUSTOMER_AGE: 10,
    CUSTOMER_GENDER_AS_PERCENT_MALE: 11,
    GO_PRICE: 12,
    HSV_DEALER_COST: 13,
    AUCTION_VALUE: 14,
    FORECASTED_GO_PRICE: 15,
    FORECASTED_HSV_DEALER_COST: 16,
    FORECASTED_AUCTION: 17,
    TOTAL_PIN_FIN_INCOME: 18,
    FRONT_END_GROSS_PROFIT: 19
};
/**
 * optional int64 amount = 1;
 * @return {number}
 */ proto.vehicle.Valuation.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Valuation} returns this
 */ proto.vehicle.Valuation.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string term = 2;
 * @return {string}
 */ proto.vehicle.Valuation.prototype.getTerm = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Valuation} returns this
 */ proto.vehicle.Valuation.prototype.setTerm = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string units = 3;
 * @return {string}
 */ proto.vehicle.Valuation.prototype.getUnits = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Valuation} returns this
 */ proto.vehicle.Valuation.prototype.setUnits = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 date = 4;
 * @return {number}
 */ proto.vehicle.Valuation.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Valuation} returns this
 */ proto.vehicle.Valuation.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 projected_date = 5;
 * @return {number}
 */ proto.vehicle.Valuation.prototype.getProjectedDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Valuation} returns this
 */ proto.vehicle.Valuation.prototype.setProjectedDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string source = 6;
 * @return {string}
 */ proto.vehicle.Valuation.prototype.getSource = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Valuation} returns this
 */ proto.vehicle.Valuation.prototype.setSource = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string description = 7;
 * @return {string}
 */ proto.vehicle.Valuation.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Valuation} returns this
 */ proto.vehicle.Valuation.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional ValuationType valuation_type = 8;
 * @return {!proto.vehicle.Valuation.ValuationType}
 */ proto.vehicle.Valuation.prototype.getValuationType = function() {
    return /** @type {!proto.vehicle.Valuation.ValuationType} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {!proto.vehicle.Valuation.ValuationType} value
 * @return {!proto.vehicle.Valuation} returns this
 */ proto.vehicle.Valuation.prototype.setValuationType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 8, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle.Color.repeatedFields_ = [
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Color.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Color.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Color} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Color.toObject = function(includeInstance, msg) {
        var f, obj = {
            description: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            title: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            colorCodeList: $8M67s.Message.toObjectList(msg.getColorCodeList(), proto.vehicle.ColorCode.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Color}
 */ proto.vehicle.Color.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Color;
    return proto.vehicle.Color.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Color} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Color}
 */ proto.vehicle.Color.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTitle(value);
                break;
            case 3:
                var value = /** @type {!proto.vehicle.Color.Name} */ reader.readEnum();
                msg.setName(value);
                break;
            case 4:
                var value = new proto.vehicle.ColorCode;
                reader.readMessage(value, proto.vehicle.ColorCode.deserializeBinaryFromReader);
                msg.addColorCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Color.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Color.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Color} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Color.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDescription();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTitle();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getName();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getColorCodeList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.vehicle.ColorCode.serializeBinaryToWriter);
};
/**
 * @enum {number}
 */ proto.vehicle.Color.Name = {
    WHITE: 0,
    BLACK: 1,
    GRAY: 2,
    RED: 3,
    BLUE: 4,
    YELLOW: 5,
    ORANGE: 6,
    GREEN: 7,
    VIOLET: 8
};
/**
 * optional string description = 1;
 * @return {string}
 */ proto.vehicle.Color.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Color} returns this
 */ proto.vehicle.Color.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string title = 2;
 * @return {string}
 */ proto.vehicle.Color.prototype.getTitle = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Color} returns this
 */ proto.vehicle.Color.prototype.setTitle = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Name name = 3;
 * @return {!proto.vehicle.Color.Name}
 */ proto.vehicle.Color.prototype.getName = function() {
    return /** @type {!proto.vehicle.Color.Name} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.vehicle.Color.Name} value
 * @return {!proto.vehicle.Color} returns this
 */ proto.vehicle.Color.prototype.setName = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * repeated ColorCode color_code = 4;
 * @return {!Array<!proto.vehicle.ColorCode>}
 */ proto.vehicle.Color.prototype.getColorCodeList = function() {
    return /** @type{!Array<!proto.vehicle.ColorCode>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.ColorCode, 4);
};
/**
 * @param {!Array<!proto.vehicle.ColorCode>} value
 * @return {!proto.vehicle.Color} returns this
*/ proto.vehicle.Color.prototype.setColorCodeList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.vehicle.ColorCode=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.ColorCode}
 */ proto.vehicle.Color.prototype.addColorCode = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.vehicle.ColorCode, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Color} returns this
 */ proto.vehicle.Color.prototype.clearColorCodeList = function() {
    return this.setColorCodeList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.ColorCode.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.ColorCode.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.ColorCode} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.ColorCode.toObject = function(includeInstance, msg) {
        var f, obj = {
            code: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            type: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.ColorCode}
 */ proto.vehicle.ColorCode.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.ColorCode;
    return proto.vehicle.ColorCode.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.ColorCode} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.ColorCode}
 */ proto.vehicle.ColorCode.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.ColorCode.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.ColorCode.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.ColorCode} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.ColorCode.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCode();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getType();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * @enum {number}
 */ proto.vehicle.ColorCode.Type = {
    MANUFACTURER: 0,
    HEX: 1,
    RGB: 2
};
/**
 * optional string code = 1;
 * @return {string}
 */ proto.vehicle.ColorCode.prototype.getCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.ColorCode} returns this
 */ proto.vehicle.ColorCode.prototype.setCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string type = 2;
 * @return {string}
 */ proto.vehicle.ColorCode.prototype.getType = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.ColorCode} returns this
 */ proto.vehicle.ColorCode.prototype.setType = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle.Profile.repeatedFields_ = [
    2,
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Profile.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Profile.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Profile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Profile.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            propertiesList: $8M67s.Message.toObjectList(msg.getPropertiesList(), proto.vehicle.Property.toObject, includeInstance),
            mediaListList: $8M67s.Message.toObjectList(msg.getMediaListList(), proto.vehicle.Media.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Profile}
 */ proto.vehicle.Profile.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Profile;
    return proto.vehicle.Profile.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Profile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Profile}
 */ proto.vehicle.Profile.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = new proto.vehicle.Property;
                reader.readMessage(value, proto.vehicle.Property.deserializeBinaryFromReader);
                msg.addProperties(value);
                break;
            case 3:
                var value = new proto.vehicle.Media;
                reader.readMessage(value, proto.vehicle.Media.deserializeBinaryFromReader);
                msg.addMediaList(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Profile.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Profile.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Profile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Profile.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPropertiesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.vehicle.Property.serializeBinaryToWriter);
    f = message.getMediaListList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.vehicle.Media.serializeBinaryToWriter);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Profile.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Profile} returns this
 */ proto.vehicle.Profile.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated Property properties = 2;
 * @return {!Array<!proto.vehicle.Property>}
 */ proto.vehicle.Profile.prototype.getPropertiesList = function() {
    return /** @type{!Array<!proto.vehicle.Property>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Property, 2);
};
/**
 * @param {!Array<!proto.vehicle.Property>} value
 * @return {!proto.vehicle.Profile} returns this
*/ proto.vehicle.Profile.prototype.setPropertiesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.vehicle.Property=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Property}
 */ proto.vehicle.Profile.prototype.addProperties = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vehicle.Property, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Profile} returns this
 */ proto.vehicle.Profile.prototype.clearPropertiesList = function() {
    return this.setPropertiesList([]);
};
/**
 * repeated Media media_list = 3;
 * @return {!Array<!proto.vehicle.Media>}
 */ proto.vehicle.Profile.prototype.getMediaListList = function() {
    return /** @type{!Array<!proto.vehicle.Media>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Media, 3);
};
/**
 * @param {!Array<!proto.vehicle.Media>} value
 * @return {!proto.vehicle.Profile} returns this
*/ proto.vehicle.Profile.prototype.setMediaListList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.vehicle.Media=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Media}
 */ proto.vehicle.Profile.prototype.addMediaList = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.vehicle.Media, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Profile} returns this
 */ proto.vehicle.Profile.prototype.clearMediaListList = function() {
    return this.setMediaListList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Property.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Property.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Property} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Property.toObject = function(includeInstance, msg) {
        var f, obj = {
            propertyName: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            propertyString: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            propertyInt: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Property}
 */ proto.vehicle.Property.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Property;
    return proto.vehicle.Property.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Property} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Property}
 */ proto.vehicle.Property.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPropertyName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPropertyString(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPropertyInt(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Property.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Property.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Property} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Property.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPropertyName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPropertyString();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getPropertyInt();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string property_name = 1;
 * @return {string}
 */ proto.vehicle.Property.prototype.getPropertyName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Property} returns this
 */ proto.vehicle.Property.prototype.setPropertyName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string property_string = 2;
 * @return {string}
 */ proto.vehicle.Property.prototype.getPropertyString = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Property} returns this
 */ proto.vehicle.Property.prototype.setPropertyString = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 property_int = 3;
 * @return {number}
 */ proto.vehicle.Property.prototype.getPropertyInt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Property} returns this
 */ proto.vehicle.Property.prototype.setPropertyInt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle.Vehicle.repeatedFields_ = [
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    29,
    30,
    31,
    32,
    33,
    44,
    45
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Vehicle.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Vehicle.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Vehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Vehicle.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            drivetrain: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            transmission: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            bodyType: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            engine: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            optionalEquipment: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            manufactureDate: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            profilesList: $8M67s.Message.toObjectList(msg.getProfilesList(), proto.vehicle.Profile.toObject, includeInstance),
            exteriorColorsList: $8M67s.Message.toObjectList(msg.getExteriorColorsList(), proto.vehicle.Color.toObject, includeInstance),
            interiorColorsList: $8M67s.Message.toObjectList(msg.getInteriorColorsList(), proto.vehicle.Color.toObject, includeInstance),
            custodiesList: $8M67s.Message.toObjectList(msg.getCustodiesList(), proto.vehicle.Custody.toObject, includeInstance),
            locationsList: $8M67s.Message.toObjectList(msg.getLocationsList(), proto.vehicle.Location.toObject, includeInstance),
            valuationsList: $8M67s.Message.toObjectList(msg.getValuationsList(), proto.vehicle.Valuation.toObject, includeInstance),
            odometersList: $8M67s.Message.toObjectList(msg.getOdometersList(), proto.vehicle.Odometer.toObject, includeInstance),
            mediaListList: $8M67s.Message.toObjectList(msg.getMediaListList(), proto.vehicle.Media.toObject, includeInstance),
            annotationsList: $8M67s.Message.toObjectList(msg.getAnnotationsList(), proto.vehicle.Annotation.toObject, includeInstance),
            defaultLineItemsList: $8M67s.Message.toObjectList(msg.getDefaultLineItemsList(), $3QqPt.LineItem.toObject, includeInstance),
            dynamicLineItemsList: $8M67s.Message.toObjectList(msg.getDynamicLineItemsList(), $3QqPt.LineItem.toObject, includeInstance),
            state: $8M67s.Message.getFieldWithDefault(msg, 24, 0),
            activityFailure: $8M67s.Message.getFieldWithDefault(msg, 25, 0),
            activity: $8M67s.Message.getFieldWithDefault(msg, 26, 0),
            activityState: $8M67s.Message.getFieldWithDefault(msg, 27, 0),
            version: $8M67s.Message.getFieldWithDefault(msg, 28, 0),
            inspectionsList: $8M67s.Message.toObjectList(msg.getInspectionsList(), proto.vehicle.Inspection.toObject, includeInstance),
            registrationsList: $8M67s.Message.toObjectList(msg.getRegistrationsList(), proto.vehicle.Registration.toObject, includeInstance),
            titlesList: $8M67s.Message.toObjectList(msg.getTitlesList(), proto.vehicle.Title.toObject, includeInstance),
            warrantiesList: $8M67s.Message.toObjectList(msg.getWarrantiesList(), proto.vehicle.Warranty.toObject, includeInstance),
            maintenancesList: $8M67s.Message.toObjectList(msg.getMaintenancesList(), proto.vehicle.Maintenance.toObject, includeInstance),
            reg262: (f = msg.getReg262()) && proto.vehicle.Reg262.toObject(includeInstance, f),
            purchaseOrder: (f = msg.getPurchaseOrder()) && proto.vehicle.PurchaseOrder.toObject(includeInstance, f),
            reg51: (f = msg.getReg51()) && proto.vehicle.Reg51.toObject(includeInstance, f),
            reg553: (f = msg.getReg553()) && proto.vehicle.Reg553.toObject(includeInstance, f),
            buyersGuide: (f = msg.getBuyersGuide()) && proto.vehicle.BuyersGuide.toObject(includeInstance, f),
            usedVehicleHistoryDisclosure: (f = msg.getUsedVehicleHistoryDisclosure()) && proto.vehicle.UsedVehicleHistoryDisclosure.toObject(includeInstance, f),
            inServiceDate: $8M67s.Message.getFieldWithDefault(msg, 40, 0),
            tos: (f = msg.getTos()) && proto.vehicle.VehicleTermsOfService.toObject(includeInstance, f),
            listingDate: $8M67s.Message.getFieldWithDefault(msg, 42, 0),
            wheelSize: $8M67s.Message.getFieldWithDefault(msg, 43, ""),
            genericPropertiesList: $8M67s.Message.toObjectList(msg.getGenericPropertiesList(), proto.vehicle.Property.toObject, includeInstance),
            infleetingsList: $8M67s.Message.toObjectList(msg.getInfleetingsList(), proto.vehicle.Infleeting.toObject, includeInstance),
            financier: $8M67s.Message.getFieldWithDefault(msg, 46, ""),
            deleted: $8M67s.Message.getBooleanFieldWithDefault(msg, 99, false),
            programId: $8M67s.Message.getFieldWithDefault(msg, 100, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Vehicle}
 */ proto.vehicle.Vehicle.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Vehicle;
    return proto.vehicle.Vehicle.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Vehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Vehicle}
 */ proto.vehicle.Vehicle.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setDrivetrain(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setTransmission(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setBodyType(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setEngine(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setOptionalEquipment(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt64();
                msg.setManufactureDate(value);
                break;
            case 13:
                var value = new proto.vehicle.Profile;
                reader.readMessage(value, proto.vehicle.Profile.deserializeBinaryFromReader);
                msg.addProfiles(value);
                break;
            case 14:
                var value = new proto.vehicle.Color;
                reader.readMessage(value, proto.vehicle.Color.deserializeBinaryFromReader);
                msg.addExteriorColors(value);
                break;
            case 15:
                var value = new proto.vehicle.Color;
                reader.readMessage(value, proto.vehicle.Color.deserializeBinaryFromReader);
                msg.addInteriorColors(value);
                break;
            case 16:
                var value = new proto.vehicle.Custody;
                reader.readMessage(value, proto.vehicle.Custody.deserializeBinaryFromReader);
                msg.addCustodies(value);
                break;
            case 17:
                var value = new proto.vehicle.Location;
                reader.readMessage(value, proto.vehicle.Location.deserializeBinaryFromReader);
                msg.addLocations(value);
                break;
            case 18:
                var value = new proto.vehicle.Valuation;
                reader.readMessage(value, proto.vehicle.Valuation.deserializeBinaryFromReader);
                msg.addValuations(value);
                break;
            case 19:
                var value = new proto.vehicle.Odometer;
                reader.readMessage(value, proto.vehicle.Odometer.deserializeBinaryFromReader);
                msg.addOdometers(value);
                break;
            case 20:
                var value = new proto.vehicle.Media;
                reader.readMessage(value, proto.vehicle.Media.deserializeBinaryFromReader);
                msg.addMediaList(value);
                break;
            case 21:
                var value = new proto.vehicle.Annotation;
                reader.readMessage(value, proto.vehicle.Annotation.deserializeBinaryFromReader);
                msg.addAnnotations(value);
                break;
            case 22:
                var value = new $3QqPt.LineItem;
                reader.readMessage(value, $3QqPt.LineItem.deserializeBinaryFromReader);
                msg.addDefaultLineItems(value);
                break;
            case 23:
                var value = new $3QqPt.LineItem;
                reader.readMessage(value, $3QqPt.LineItem.deserializeBinaryFromReader);
                msg.addDynamicLineItems(value);
                break;
            case 24:
                var value = /** @type {!proto.vehicle.State} */ reader.readEnum();
                msg.setState(value);
                break;
            case 25:
                var value = /** @type {!proto.vehicle.ActivityFailure} */ reader.readEnum();
                msg.setActivityFailure(value);
                break;
            case 26:
                var value = /** @type {!proto.vehicle.Activity} */ reader.readEnum();
                msg.setActivity(value);
                break;
            case 27:
                var value = /** @type {!proto.vehicle.ActivityState} */ reader.readEnum();
                msg.setActivityState(value);
                break;
            case 28:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 29:
                var value = new proto.vehicle.Inspection;
                reader.readMessage(value, proto.vehicle.Inspection.deserializeBinaryFromReader);
                msg.addInspections(value);
                break;
            case 30:
                var value = new proto.vehicle.Registration;
                reader.readMessage(value, proto.vehicle.Registration.deserializeBinaryFromReader);
                msg.addRegistrations(value);
                break;
            case 31:
                var value = new proto.vehicle.Title;
                reader.readMessage(value, proto.vehicle.Title.deserializeBinaryFromReader);
                msg.addTitles(value);
                break;
            case 32:
                var value = new proto.vehicle.Warranty;
                reader.readMessage(value, proto.vehicle.Warranty.deserializeBinaryFromReader);
                msg.addWarranties(value);
                break;
            case 33:
                var value = new proto.vehicle.Maintenance;
                reader.readMessage(value, proto.vehicle.Maintenance.deserializeBinaryFromReader);
                msg.addMaintenances(value);
                break;
            case 34:
                var value = new proto.vehicle.Reg262;
                reader.readMessage(value, proto.vehicle.Reg262.deserializeBinaryFromReader);
                msg.setReg262(value);
                break;
            case 35:
                var value = new proto.vehicle.PurchaseOrder;
                reader.readMessage(value, proto.vehicle.PurchaseOrder.deserializeBinaryFromReader);
                msg.setPurchaseOrder(value);
                break;
            case 36:
                var value = new proto.vehicle.Reg51;
                reader.readMessage(value, proto.vehicle.Reg51.deserializeBinaryFromReader);
                msg.setReg51(value);
                break;
            case 37:
                var value = new proto.vehicle.Reg553;
                reader.readMessage(value, proto.vehicle.Reg553.deserializeBinaryFromReader);
                msg.setReg553(value);
                break;
            case 38:
                var value = new proto.vehicle.BuyersGuide;
                reader.readMessage(value, proto.vehicle.BuyersGuide.deserializeBinaryFromReader);
                msg.setBuyersGuide(value);
                break;
            case 39:
                var value = new proto.vehicle.UsedVehicleHistoryDisclosure;
                reader.readMessage(value, proto.vehicle.UsedVehicleHistoryDisclosure.deserializeBinaryFromReader);
                msg.setUsedVehicleHistoryDisclosure(value);
                break;
            case 40:
                var value = /** @type {number} */ reader.readInt64();
                msg.setInServiceDate(value);
                break;
            case 41:
                var value = new proto.vehicle.VehicleTermsOfService;
                reader.readMessage(value, proto.vehicle.VehicleTermsOfService.deserializeBinaryFromReader);
                msg.setTos(value);
                break;
            case 42:
                var value = /** @type {number} */ reader.readInt64();
                msg.setListingDate(value);
                break;
            case 43:
                var value = /** @type {string} */ reader.readString();
                msg.setWheelSize(value);
                break;
            case 44:
                var value = new proto.vehicle.Property;
                reader.readMessage(value, proto.vehicle.Property.deserializeBinaryFromReader);
                msg.addGenericProperties(value);
                break;
            case 45:
                var value = new proto.vehicle.Infleeting;
                reader.readMessage(value, proto.vehicle.Infleeting.deserializeBinaryFromReader);
                msg.addInfleetings(value);
                break;
            case 46:
                var value = /** @type {string} */ reader.readString();
                msg.setFinancier(value);
                break;
            case 99:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setDeleted(value);
                break;
            case 100:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Vehicle.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Vehicle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Vehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Vehicle.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getDrivetrain();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getTransmission();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getBodyType();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getEngine();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getOptionalEquipment();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getManufactureDate();
    if (f !== 0) writer.writeInt64(12, f);
    f = message.getProfilesList();
    if (f.length > 0) writer.writeRepeatedMessage(13, f, proto.vehicle.Profile.serializeBinaryToWriter);
    f = message.getExteriorColorsList();
    if (f.length > 0) writer.writeRepeatedMessage(14, f, proto.vehicle.Color.serializeBinaryToWriter);
    f = message.getInteriorColorsList();
    if (f.length > 0) writer.writeRepeatedMessage(15, f, proto.vehicle.Color.serializeBinaryToWriter);
    f = message.getCustodiesList();
    if (f.length > 0) writer.writeRepeatedMessage(16, f, proto.vehicle.Custody.serializeBinaryToWriter);
    f = message.getLocationsList();
    if (f.length > 0) writer.writeRepeatedMessage(17, f, proto.vehicle.Location.serializeBinaryToWriter);
    f = message.getValuationsList();
    if (f.length > 0) writer.writeRepeatedMessage(18, f, proto.vehicle.Valuation.serializeBinaryToWriter);
    f = message.getOdometersList();
    if (f.length > 0) writer.writeRepeatedMessage(19, f, proto.vehicle.Odometer.serializeBinaryToWriter);
    f = message.getMediaListList();
    if (f.length > 0) writer.writeRepeatedMessage(20, f, proto.vehicle.Media.serializeBinaryToWriter);
    f = message.getAnnotationsList();
    if (f.length > 0) writer.writeRepeatedMessage(21, f, proto.vehicle.Annotation.serializeBinaryToWriter);
    f = message.getDefaultLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(22, f, $3QqPt.LineItem.serializeBinaryToWriter);
    f = message.getDynamicLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(23, f, $3QqPt.LineItem.serializeBinaryToWriter);
    f = message.getState();
    if (f !== 0.0) writer.writeEnum(24, f);
    f = message.getActivityFailure();
    if (f !== 0.0) writer.writeEnum(25, f);
    f = message.getActivity();
    if (f !== 0.0) writer.writeEnum(26, f);
    f = message.getActivityState();
    if (f !== 0.0) writer.writeEnum(27, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(28, f);
    f = message.getInspectionsList();
    if (f.length > 0) writer.writeRepeatedMessage(29, f, proto.vehicle.Inspection.serializeBinaryToWriter);
    f = message.getRegistrationsList();
    if (f.length > 0) writer.writeRepeatedMessage(30, f, proto.vehicle.Registration.serializeBinaryToWriter);
    f = message.getTitlesList();
    if (f.length > 0) writer.writeRepeatedMessage(31, f, proto.vehicle.Title.serializeBinaryToWriter);
    f = message.getWarrantiesList();
    if (f.length > 0) writer.writeRepeatedMessage(32, f, proto.vehicle.Warranty.serializeBinaryToWriter);
    f = message.getMaintenancesList();
    if (f.length > 0) writer.writeRepeatedMessage(33, f, proto.vehicle.Maintenance.serializeBinaryToWriter);
    f = message.getReg262();
    if (f != null) writer.writeMessage(34, f, proto.vehicle.Reg262.serializeBinaryToWriter);
    f = message.getPurchaseOrder();
    if (f != null) writer.writeMessage(35, f, proto.vehicle.PurchaseOrder.serializeBinaryToWriter);
    f = message.getReg51();
    if (f != null) writer.writeMessage(36, f, proto.vehicle.Reg51.serializeBinaryToWriter);
    f = message.getReg553();
    if (f != null) writer.writeMessage(37, f, proto.vehicle.Reg553.serializeBinaryToWriter);
    f = message.getBuyersGuide();
    if (f != null) writer.writeMessage(38, f, proto.vehicle.BuyersGuide.serializeBinaryToWriter);
    f = message.getUsedVehicleHistoryDisclosure();
    if (f != null) writer.writeMessage(39, f, proto.vehicle.UsedVehicleHistoryDisclosure.serializeBinaryToWriter);
    f = message.getInServiceDate();
    if (f !== 0) writer.writeInt64(40, f);
    f = message.getTos();
    if (f != null) writer.writeMessage(41, f, proto.vehicle.VehicleTermsOfService.serializeBinaryToWriter);
    f = message.getListingDate();
    if (f !== 0) writer.writeInt64(42, f);
    f = message.getWheelSize();
    if (f.length > 0) writer.writeString(43, f);
    f = message.getGenericPropertiesList();
    if (f.length > 0) writer.writeRepeatedMessage(44, f, proto.vehicle.Property.serializeBinaryToWriter);
    f = message.getInfleetingsList();
    if (f.length > 0) writer.writeRepeatedMessage(45, f, proto.vehicle.Infleeting.serializeBinaryToWriter);
    f = message.getFinancier();
    if (f.length > 0) writer.writeString(46, f);
    f = message.getDeleted();
    if (f) writer.writeBool(99, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(100, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string make = 3;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string model = 4;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string year = 5;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string trim = 6;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string drivetrain = 7;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getDrivetrain = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setDrivetrain = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string transmission = 8;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getTransmission = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setTransmission = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string body_type = 9;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getBodyType = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setBodyType = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string engine = 10;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getEngine = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setEngine = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string optional_equipment = 11;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getOptionalEquipment = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setOptionalEquipment = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional int64 manufacture_date = 12;
 * @return {number}
 */ proto.vehicle.Vehicle.prototype.getManufactureDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setManufactureDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * repeated Profile profiles = 13;
 * @return {!Array<!proto.vehicle.Profile>}
 */ proto.vehicle.Vehicle.prototype.getProfilesList = function() {
    return /** @type{!Array<!proto.vehicle.Profile>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Profile, 13);
};
/**
 * @param {!Array<!proto.vehicle.Profile>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setProfilesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 13, value);
};
/**
 * @param {!proto.vehicle.Profile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Profile}
 */ proto.vehicle.Vehicle.prototype.addProfiles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 13, opt_value, proto.vehicle.Profile, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearProfilesList = function() {
    return this.setProfilesList([]);
};
/**
 * repeated Color exterior_colors = 14;
 * @return {!Array<!proto.vehicle.Color>}
 */ proto.vehicle.Vehicle.prototype.getExteriorColorsList = function() {
    return /** @type{!Array<!proto.vehicle.Color>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Color, 14);
};
/**
 * @param {!Array<!proto.vehicle.Color>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setExteriorColorsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 14, value);
};
/**
 * @param {!proto.vehicle.Color=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Color}
 */ proto.vehicle.Vehicle.prototype.addExteriorColors = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.vehicle.Color, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearExteriorColorsList = function() {
    return this.setExteriorColorsList([]);
};
/**
 * repeated Color interior_colors = 15;
 * @return {!Array<!proto.vehicle.Color>}
 */ proto.vehicle.Vehicle.prototype.getInteriorColorsList = function() {
    return /** @type{!Array<!proto.vehicle.Color>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Color, 15);
};
/**
 * @param {!Array<!proto.vehicle.Color>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setInteriorColorsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 15, value);
};
/**
 * @param {!proto.vehicle.Color=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Color}
 */ proto.vehicle.Vehicle.prototype.addInteriorColors = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.vehicle.Color, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearInteriorColorsList = function() {
    return this.setInteriorColorsList([]);
};
/**
 * repeated Custody custodies = 16;
 * @return {!Array<!proto.vehicle.Custody>}
 */ proto.vehicle.Vehicle.prototype.getCustodiesList = function() {
    return /** @type{!Array<!proto.vehicle.Custody>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Custody, 16);
};
/**
 * @param {!Array<!proto.vehicle.Custody>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setCustodiesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 16, value);
};
/**
 * @param {!proto.vehicle.Custody=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Custody}
 */ proto.vehicle.Vehicle.prototype.addCustodies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 16, opt_value, proto.vehicle.Custody, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearCustodiesList = function() {
    return this.setCustodiesList([]);
};
/**
 * repeated Location locations = 17;
 * @return {!Array<!proto.vehicle.Location>}
 */ proto.vehicle.Vehicle.prototype.getLocationsList = function() {
    return /** @type{!Array<!proto.vehicle.Location>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Location, 17);
};
/**
 * @param {!Array<!proto.vehicle.Location>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setLocationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 17, value);
};
/**
 * @param {!proto.vehicle.Location=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Location}
 */ proto.vehicle.Vehicle.prototype.addLocations = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 17, opt_value, proto.vehicle.Location, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearLocationsList = function() {
    return this.setLocationsList([]);
};
/**
 * repeated Valuation valuations = 18;
 * @return {!Array<!proto.vehicle.Valuation>}
 */ proto.vehicle.Vehicle.prototype.getValuationsList = function() {
    return /** @type{!Array<!proto.vehicle.Valuation>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Valuation, 18);
};
/**
 * @param {!Array<!proto.vehicle.Valuation>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setValuationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 18, value);
};
/**
 * @param {!proto.vehicle.Valuation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Valuation}
 */ proto.vehicle.Vehicle.prototype.addValuations = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 18, opt_value, proto.vehicle.Valuation, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearValuationsList = function() {
    return this.setValuationsList([]);
};
/**
 * repeated Odometer odometers = 19;
 * @return {!Array<!proto.vehicle.Odometer>}
 */ proto.vehicle.Vehicle.prototype.getOdometersList = function() {
    return /** @type{!Array<!proto.vehicle.Odometer>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Odometer, 19);
};
/**
 * @param {!Array<!proto.vehicle.Odometer>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setOdometersList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 19, value);
};
/**
 * @param {!proto.vehicle.Odometer=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Odometer}
 */ proto.vehicle.Vehicle.prototype.addOdometers = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 19, opt_value, proto.vehicle.Odometer, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearOdometersList = function() {
    return this.setOdometersList([]);
};
/**
 * repeated Media media_list = 20;
 * @return {!Array<!proto.vehicle.Media>}
 */ proto.vehicle.Vehicle.prototype.getMediaListList = function() {
    return /** @type{!Array<!proto.vehicle.Media>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Media, 20);
};
/**
 * @param {!Array<!proto.vehicle.Media>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setMediaListList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 20, value);
};
/**
 * @param {!proto.vehicle.Media=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Media}
 */ proto.vehicle.Vehicle.prototype.addMediaList = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 20, opt_value, proto.vehicle.Media, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearMediaListList = function() {
    return this.setMediaListList([]);
};
/**
 * repeated Annotation annotations = 21;
 * @return {!Array<!proto.vehicle.Annotation>}
 */ proto.vehicle.Vehicle.prototype.getAnnotationsList = function() {
    return /** @type{!Array<!proto.vehicle.Annotation>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Annotation, 21);
};
/**
 * @param {!Array<!proto.vehicle.Annotation>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setAnnotationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 21, value);
};
/**
 * @param {!proto.vehicle.Annotation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Annotation}
 */ proto.vehicle.Vehicle.prototype.addAnnotations = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.vehicle.Annotation, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearAnnotationsList = function() {
    return this.setAnnotationsList([]);
};
/**
 * repeated domain.LineItem default_line_items = 22;
 * @return {!Array<!proto.domain.LineItem>}
 */ proto.vehicle.Vehicle.prototype.getDefaultLineItemsList = function() {
    return /** @type{!Array<!proto.domain.LineItem>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.LineItem, 22);
};
/**
 * @param {!Array<!proto.domain.LineItem>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setDefaultLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 22, value);
};
/**
 * @param {!proto.domain.LineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.LineItem}
 */ proto.vehicle.Vehicle.prototype.addDefaultLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 22, opt_value, proto.domain.LineItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearDefaultLineItemsList = function() {
    return this.setDefaultLineItemsList([]);
};
/**
 * repeated domain.LineItem dynamic_line_items = 23;
 * @return {!Array<!proto.domain.LineItem>}
 */ proto.vehicle.Vehicle.prototype.getDynamicLineItemsList = function() {
    return /** @type{!Array<!proto.domain.LineItem>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.LineItem, 23);
};
/**
 * @param {!Array<!proto.domain.LineItem>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setDynamicLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 23, value);
};
/**
 * @param {!proto.domain.LineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.LineItem}
 */ proto.vehicle.Vehicle.prototype.addDynamicLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 23, opt_value, proto.domain.LineItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearDynamicLineItemsList = function() {
    return this.setDynamicLineItemsList([]);
};
/**
 * optional State state = 24;
 * @return {!proto.vehicle.State}
 */ proto.vehicle.Vehicle.prototype.getState = function() {
    return /** @type {!proto.vehicle.State} */ $8M67s.Message.getFieldWithDefault(this, 24, 0);
};
/**
 * @param {!proto.vehicle.State} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 24, value);
};
/**
 * optional ActivityFailure activity_failure = 25;
 * @return {!proto.vehicle.ActivityFailure}
 */ proto.vehicle.Vehicle.prototype.getActivityFailure = function() {
    return /** @type {!proto.vehicle.ActivityFailure} */ $8M67s.Message.getFieldWithDefault(this, 25, 0);
};
/**
 * @param {!proto.vehicle.ActivityFailure} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setActivityFailure = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 25, value);
};
/**
 * optional Activity activity = 26;
 * @return {!proto.vehicle.Activity}
 */ proto.vehicle.Vehicle.prototype.getActivity = function() {
    return /** @type {!proto.vehicle.Activity} */ $8M67s.Message.getFieldWithDefault(this, 26, 0);
};
/**
 * @param {!proto.vehicle.Activity} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setActivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 26, value);
};
/**
 * optional ActivityState activity_state = 27;
 * @return {!proto.vehicle.ActivityState}
 */ proto.vehicle.Vehicle.prototype.getActivityState = function() {
    return /** @type {!proto.vehicle.ActivityState} */ $8M67s.Message.getFieldWithDefault(this, 27, 0);
};
/**
 * @param {!proto.vehicle.ActivityState} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setActivityState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 27, value);
};
/**
 * optional int64 version = 28;
 * @return {number}
 */ proto.vehicle.Vehicle.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 28, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 28, value);
};
/**
 * repeated Inspection inspections = 29;
 * @return {!Array<!proto.vehicle.Inspection>}
 */ proto.vehicle.Vehicle.prototype.getInspectionsList = function() {
    return /** @type{!Array<!proto.vehicle.Inspection>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Inspection, 29);
};
/**
 * @param {!Array<!proto.vehicle.Inspection>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setInspectionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 29, value);
};
/**
 * @param {!proto.vehicle.Inspection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Inspection}
 */ proto.vehicle.Vehicle.prototype.addInspections = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 29, opt_value, proto.vehicle.Inspection, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearInspectionsList = function() {
    return this.setInspectionsList([]);
};
/**
 * repeated Registration registrations = 30;
 * @return {!Array<!proto.vehicle.Registration>}
 */ proto.vehicle.Vehicle.prototype.getRegistrationsList = function() {
    return /** @type{!Array<!proto.vehicle.Registration>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Registration, 30);
};
/**
 * @param {!Array<!proto.vehicle.Registration>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setRegistrationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 30, value);
};
/**
 * @param {!proto.vehicle.Registration=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Registration}
 */ proto.vehicle.Vehicle.prototype.addRegistrations = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 30, opt_value, proto.vehicle.Registration, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearRegistrationsList = function() {
    return this.setRegistrationsList([]);
};
/**
 * repeated Title titles = 31;
 * @return {!Array<!proto.vehicle.Title>}
 */ proto.vehicle.Vehicle.prototype.getTitlesList = function() {
    return /** @type{!Array<!proto.vehicle.Title>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Title, 31);
};
/**
 * @param {!Array<!proto.vehicle.Title>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setTitlesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 31, value);
};
/**
 * @param {!proto.vehicle.Title=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Title}
 */ proto.vehicle.Vehicle.prototype.addTitles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 31, opt_value, proto.vehicle.Title, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearTitlesList = function() {
    return this.setTitlesList([]);
};
/**
 * repeated Warranty warranties = 32;
 * @return {!Array<!proto.vehicle.Warranty>}
 */ proto.vehicle.Vehicle.prototype.getWarrantiesList = function() {
    return /** @type{!Array<!proto.vehicle.Warranty>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Warranty, 32);
};
/**
 * @param {!Array<!proto.vehicle.Warranty>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setWarrantiesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 32, value);
};
/**
 * @param {!proto.vehicle.Warranty=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Warranty}
 */ proto.vehicle.Vehicle.prototype.addWarranties = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 32, opt_value, proto.vehicle.Warranty, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearWarrantiesList = function() {
    return this.setWarrantiesList([]);
};
/**
 * repeated Maintenance maintenances = 33;
 * @return {!Array<!proto.vehicle.Maintenance>}
 */ proto.vehicle.Vehicle.prototype.getMaintenancesList = function() {
    return /** @type{!Array<!proto.vehicle.Maintenance>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Maintenance, 33);
};
/**
 * @param {!Array<!proto.vehicle.Maintenance>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setMaintenancesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 33, value);
};
/**
 * @param {!proto.vehicle.Maintenance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Maintenance}
 */ proto.vehicle.Vehicle.prototype.addMaintenances = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 33, opt_value, proto.vehicle.Maintenance, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearMaintenancesList = function() {
    return this.setMaintenancesList([]);
};
/**
 * optional Reg262 reg262 = 34;
 * @return {?proto.vehicle.Reg262}
 */ proto.vehicle.Vehicle.prototype.getReg262 = function() {
    return /** @type{?proto.vehicle.Reg262} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Reg262, 34);
};
/**
 * @param {?proto.vehicle.Reg262|undefined} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setReg262 = function(value) {
    return $8M67s.Message.setWrapperField(this, 34, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearReg262 = function() {
    return this.setReg262(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Vehicle.prototype.hasReg262 = function() {
    return $8M67s.Message.getField(this, 34) != null;
};
/**
 * optional PurchaseOrder purchase_order = 35;
 * @return {?proto.vehicle.PurchaseOrder}
 */ proto.vehicle.Vehicle.prototype.getPurchaseOrder = function() {
    return /** @type{?proto.vehicle.PurchaseOrder} */ $8M67s.Message.getWrapperField(this, proto.vehicle.PurchaseOrder, 35);
};
/**
 * @param {?proto.vehicle.PurchaseOrder|undefined} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setPurchaseOrder = function(value) {
    return $8M67s.Message.setWrapperField(this, 35, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearPurchaseOrder = function() {
    return this.setPurchaseOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Vehicle.prototype.hasPurchaseOrder = function() {
    return $8M67s.Message.getField(this, 35) != null;
};
/**
 * optional Reg51 reg51 = 36;
 * @return {?proto.vehicle.Reg51}
 */ proto.vehicle.Vehicle.prototype.getReg51 = function() {
    return /** @type{?proto.vehicle.Reg51} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Reg51, 36);
};
/**
 * @param {?proto.vehicle.Reg51|undefined} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setReg51 = function(value) {
    return $8M67s.Message.setWrapperField(this, 36, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearReg51 = function() {
    return this.setReg51(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Vehicle.prototype.hasReg51 = function() {
    return $8M67s.Message.getField(this, 36) != null;
};
/**
 * optional Reg553 reg553 = 37;
 * @return {?proto.vehicle.Reg553}
 */ proto.vehicle.Vehicle.prototype.getReg553 = function() {
    return /** @type{?proto.vehicle.Reg553} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Reg553, 37);
};
/**
 * @param {?proto.vehicle.Reg553|undefined} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setReg553 = function(value) {
    return $8M67s.Message.setWrapperField(this, 37, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearReg553 = function() {
    return this.setReg553(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Vehicle.prototype.hasReg553 = function() {
    return $8M67s.Message.getField(this, 37) != null;
};
/**
 * optional BuyersGuide buyers_guide = 38;
 * @return {?proto.vehicle.BuyersGuide}
 */ proto.vehicle.Vehicle.prototype.getBuyersGuide = function() {
    return /** @type{?proto.vehicle.BuyersGuide} */ $8M67s.Message.getWrapperField(this, proto.vehicle.BuyersGuide, 38);
};
/**
 * @param {?proto.vehicle.BuyersGuide|undefined} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setBuyersGuide = function(value) {
    return $8M67s.Message.setWrapperField(this, 38, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearBuyersGuide = function() {
    return this.setBuyersGuide(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Vehicle.prototype.hasBuyersGuide = function() {
    return $8M67s.Message.getField(this, 38) != null;
};
/**
 * optional UsedVehicleHistoryDisclosure used_vehicle_history_disclosure = 39;
 * @return {?proto.vehicle.UsedVehicleHistoryDisclosure}
 */ proto.vehicle.Vehicle.prototype.getUsedVehicleHistoryDisclosure = function() {
    return /** @type{?proto.vehicle.UsedVehicleHistoryDisclosure} */ $8M67s.Message.getWrapperField(this, proto.vehicle.UsedVehicleHistoryDisclosure, 39);
};
/**
 * @param {?proto.vehicle.UsedVehicleHistoryDisclosure|undefined} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setUsedVehicleHistoryDisclosure = function(value) {
    return $8M67s.Message.setWrapperField(this, 39, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearUsedVehicleHistoryDisclosure = function() {
    return this.setUsedVehicleHistoryDisclosure(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Vehicle.prototype.hasUsedVehicleHistoryDisclosure = function() {
    return $8M67s.Message.getField(this, 39) != null;
};
/**
 * optional int64 in_service_date = 40;
 * @return {number}
 */ proto.vehicle.Vehicle.prototype.getInServiceDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 40, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setInServiceDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 40, value);
};
/**
 * optional VehicleTermsOfService tos = 41;
 * @return {?proto.vehicle.VehicleTermsOfService}
 */ proto.vehicle.Vehicle.prototype.getTos = function() {
    return /** @type{?proto.vehicle.VehicleTermsOfService} */ $8M67s.Message.getWrapperField(this, proto.vehicle.VehicleTermsOfService, 41);
};
/**
 * @param {?proto.vehicle.VehicleTermsOfService|undefined} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setTos = function(value) {
    return $8M67s.Message.setWrapperField(this, 41, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearTos = function() {
    return this.setTos(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Vehicle.prototype.hasTos = function() {
    return $8M67s.Message.getField(this, 41) != null;
};
/**
 * optional int64 listing_date = 42;
 * @return {number}
 */ proto.vehicle.Vehicle.prototype.getListingDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 42, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setListingDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 42, value);
};
/**
 * optional string wheel_size = 43;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getWheelSize = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 43, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setWheelSize = function(value) {
    return $8M67s.Message.setProto3StringField(this, 43, value);
};
/**
 * repeated Property generic_properties = 44;
 * @return {!Array<!proto.vehicle.Property>}
 */ proto.vehicle.Vehicle.prototype.getGenericPropertiesList = function() {
    return /** @type{!Array<!proto.vehicle.Property>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Property, 44);
};
/**
 * @param {!Array<!proto.vehicle.Property>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setGenericPropertiesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 44, value);
};
/**
 * @param {!proto.vehicle.Property=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Property}
 */ proto.vehicle.Vehicle.prototype.addGenericProperties = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 44, opt_value, proto.vehicle.Property, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearGenericPropertiesList = function() {
    return this.setGenericPropertiesList([]);
};
/**
 * repeated Infleeting infleetings = 45;
 * @return {!Array<!proto.vehicle.Infleeting>}
 */ proto.vehicle.Vehicle.prototype.getInfleetingsList = function() {
    return /** @type{!Array<!proto.vehicle.Infleeting>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Infleeting, 45);
};
/**
 * @param {!Array<!proto.vehicle.Infleeting>} value
 * @return {!proto.vehicle.Vehicle} returns this
*/ proto.vehicle.Vehicle.prototype.setInfleetingsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 45, value);
};
/**
 * @param {!proto.vehicle.Infleeting=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Infleeting}
 */ proto.vehicle.Vehicle.prototype.addInfleetings = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 45, opt_value, proto.vehicle.Infleeting, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.clearInfleetingsList = function() {
    return this.setInfleetingsList([]);
};
/**
 * optional string financier = 46;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getFinancier = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 46, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setFinancier = function(value) {
    return $8M67s.Message.setProto3StringField(this, 46, value);
};
/**
 * optional bool deleted = 99;
 * @return {boolean}
 */ proto.vehicle.Vehicle.prototype.getDeleted = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 99, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setDeleted = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 99, value);
};
/**
 * optional string program_id = 100;
 * @return {string}
 */ proto.vehicle.Vehicle.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 100, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Vehicle} returns this
 */ proto.vehicle.Vehicle.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 100, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Coordinates.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Coordinates.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Coordinates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Coordinates.toObject = function(includeInstance, msg) {
        var f, obj = {
            latitude: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            longitude: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Coordinates}
 */ proto.vehicle.Coordinates.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Coordinates;
    return proto.vehicle.Coordinates.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Coordinates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Coordinates}
 */ proto.vehicle.Coordinates.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setLatitude(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLongitude(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Coordinates.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Coordinates.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Coordinates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Coordinates.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLatitude();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLongitude();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string latitude = 1;
 * @return {string}
 */ proto.vehicle.Coordinates.prototype.getLatitude = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Coordinates} returns this
 */ proto.vehicle.Coordinates.prototype.setLatitude = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string longitude = 2;
 * @return {string}
 */ proto.vehicle.Coordinates.prototype.getLongitude = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Coordinates} returns this
 */ proto.vehicle.Coordinates.prototype.setLongitude = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Location.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Location.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Location.toObject = function(includeInstance, msg) {
        var f, obj = {
            coordinates: (f = msg.getCoordinates()) && proto.vehicle.Coordinates.toObject(includeInstance, f),
            date: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Location}
 */ proto.vehicle.Location.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Location;
    return proto.vehicle.Location.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Location}
 */ proto.vehicle.Location.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.vehicle.Coordinates;
                reader.readMessage(value, proto.vehicle.Coordinates.deserializeBinaryFromReader);
                msg.setCoordinates(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Location.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Location.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Location.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCoordinates();
    if (f != null) writer.writeMessage(1, f, proto.vehicle.Coordinates.serializeBinaryToWriter);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * optional Coordinates coordinates = 1;
 * @return {?proto.vehicle.Coordinates}
 */ proto.vehicle.Location.prototype.getCoordinates = function() {
    return /** @type{?proto.vehicle.Coordinates} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Coordinates, 1);
};
/**
 * @param {?proto.vehicle.Coordinates|undefined} value
 * @return {!proto.vehicle.Location} returns this
*/ proto.vehicle.Location.prototype.setCoordinates = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Location} returns this
 */ proto.vehicle.Location.prototype.clearCoordinates = function() {
    return this.setCoordinates(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Location.prototype.hasCoordinates = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional int64 date = 2;
 * @return {number}
 */ proto.vehicle.Location.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Location} returns this
 */ proto.vehicle.Location.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Odometer.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Odometer.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Odometer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Odometer.toObject = function(includeInstance, msg) {
        var f, obj = {
            reading: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            units: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            readingType: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            date: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Odometer}
 */ proto.vehicle.Odometer.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Odometer;
    return proto.vehicle.Odometer.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Odometer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Odometer}
 */ proto.vehicle.Odometer.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReading(value);
                break;
            case 2:
                var value = /** @type {!proto.vehicle.Odometer.Units} */ reader.readEnum();
                msg.setUnits(value);
                break;
            case 3:
                var value = /** @type {!proto.vehicle.Odometer.ReadingType} */ reader.readEnum();
                msg.setReadingType(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Odometer.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Odometer.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Odometer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Odometer.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReading();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getUnits();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getReadingType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(4, f);
};
/**
 * @enum {number}
 */ proto.vehicle.Odometer.Units = {
    MILES: 0,
    KILOMETERS: 1
};
/**
 * @enum {number}
 */ proto.vehicle.Odometer.ReadingType = {
    ADVERTISED: 0,
    PICKUP: 1,
    DROPOFF: 2,
    IN_USE: 3
};
/**
 * optional int32 reading = 1;
 * @return {number}
 */ proto.vehicle.Odometer.prototype.getReading = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Odometer} returns this
 */ proto.vehicle.Odometer.prototype.setReading = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional Units units = 2;
 * @return {!proto.vehicle.Odometer.Units}
 */ proto.vehicle.Odometer.prototype.getUnits = function() {
    return /** @type {!proto.vehicle.Odometer.Units} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.vehicle.Odometer.Units} value
 * @return {!proto.vehicle.Odometer} returns this
 */ proto.vehicle.Odometer.prototype.setUnits = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional ReadingType reading_type = 3;
 * @return {!proto.vehicle.Odometer.ReadingType}
 */ proto.vehicle.Odometer.prototype.getReadingType = function() {
    return /** @type {!proto.vehicle.Odometer.ReadingType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.vehicle.Odometer.ReadingType} value
 * @return {!proto.vehicle.Odometer} returns this
 */ proto.vehicle.Odometer.prototype.setReadingType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional int64 date = 4;
 * @return {number}
 */ proto.vehicle.Odometer.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Odometer} returns this
 */ proto.vehicle.Odometer.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Annotation.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Annotation.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Annotation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Annotation.toObject = function(includeInstance, msg) {
        var f, obj = {
            notes: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            userId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            date: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Annotation}
 */ proto.vehicle.Annotation.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Annotation;
    return proto.vehicle.Annotation.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Annotation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Annotation}
 */ proto.vehicle.Annotation.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setNotes(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Annotation.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Annotation.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Annotation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Annotation.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNotes();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDate();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string notes = 1;
 * @return {string}
 */ proto.vehicle.Annotation.prototype.getNotes = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Annotation} returns this
 */ proto.vehicle.Annotation.prototype.setNotes = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string user_id = 2;
 * @return {string}
 */ proto.vehicle.Annotation.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Annotation} returns this
 */ proto.vehicle.Annotation.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 date = 3;
 * @return {number}
 */ proto.vehicle.Annotation.prototype.getDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Annotation} returns this
 */ proto.vehicle.Annotation.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Inspection.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Inspection.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Inspection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Inspection.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            report: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            generatedReport: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Inspection}
 */ proto.vehicle.Inspection.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Inspection;
    return proto.vehicle.Inspection.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Inspection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Inspection}
 */ proto.vehicle.Inspection.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setReport(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setGeneratedReport(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Inspection.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Inspection.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Inspection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Inspection.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getReport();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getGeneratedReport();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Inspection.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Inspection} returns this
 */ proto.vehicle.Inspection.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.vehicle.Inspection.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Inspection} returns this
 */ proto.vehicle.Inspection.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.Inspection.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Inspection} returns this
 */ proto.vehicle.Inspection.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string report = 4;
 * @return {string}
 */ proto.vehicle.Inspection.prototype.getReport = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Inspection} returns this
 */ proto.vehicle.Inspection.prototype.setReport = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string generated_report = 5;
 * @return {string}
 */ proto.vehicle.Inspection.prototype.getGeneratedReport = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Inspection} returns this
 */ proto.vehicle.Inspection.prototype.setGeneratedReport = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.InspectionPhoto.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.InspectionPhoto.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.InspectionPhoto} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.InspectionPhoto.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.InspectionPhoto}
 */ proto.vehicle.InspectionPhoto.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.InspectionPhoto;
    return proto.vehicle.InspectionPhoto.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.InspectionPhoto} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.InspectionPhoto}
 */ proto.vehicle.InspectionPhoto.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.InspectionPhoto.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.InspectionPhoto.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.InspectionPhoto} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.InspectionPhoto.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string inspection_id = 1;
 * @return {string}
 */ proto.vehicle.InspectionPhoto.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.InspectionPhoto} returns this
 */ proto.vehicle.InspectionPhoto.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.vehicle.InspectionPhoto.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.InspectionPhoto} returns this
 */ proto.vehicle.InspectionPhoto.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string file_name = 3;
 * @return {string}
 */ proto.vehicle.InspectionPhoto.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.InspectionPhoto} returns this
 */ proto.vehicle.InspectionPhoto.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Registration.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Registration.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Registration} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Registration.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            expiration: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            licensePlate: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Registration}
 */ proto.vehicle.Registration.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Registration;
    return proto.vehicle.Registration.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Registration} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Registration}
 */ proto.vehicle.Registration.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setExpiration(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLicensePlate(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Registration.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Registration.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Registration} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Registration.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getExpiration();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getLicensePlate();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Registration.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Registration} returns this
 */ proto.vehicle.Registration.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 created = 2;
 * @return {number}
 */ proto.vehicle.Registration.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Registration} returns this
 */ proto.vehicle.Registration.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int64 expiration = 3;
 * @return {number}
 */ proto.vehicle.Registration.prototype.getExpiration = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Registration} returns this
 */ proto.vehicle.Registration.prototype.setExpiration = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string license_plate = 4;
 * @return {string}
 */ proto.vehicle.Registration.prototype.getLicensePlate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Registration} returns this
 */ proto.vehicle.Registration.prototype.setLicensePlate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string file_name = 5;
 * @return {string}
 */ proto.vehicle.Registration.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Registration} returns this
 */ proto.vehicle.Registration.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Title.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Title.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Title} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Title.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Title}
 */ proto.vehicle.Title.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Title;
    return proto.vehicle.Title.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Title} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Title}
 */ proto.vehicle.Title.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Title.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Title.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Title} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Title.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Title.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Title} returns this
 */ proto.vehicle.Title.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.Title.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Title} returns this
 */ proto.vehicle.Title.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.Title.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Title} returns this
 */ proto.vehicle.Title.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Warranty.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Warranty.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Warranty} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Warranty.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            expiration: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Warranty}
 */ proto.vehicle.Warranty.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Warranty;
    return proto.vehicle.Warranty.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Warranty} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Warranty}
 */ proto.vehicle.Warranty.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setExpiration(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Warranty.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Warranty.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Warranty} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Warranty.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getExpiration();
    if (f !== 0) writer.writeInt64(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Warranty.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Warranty} returns this
 */ proto.vehicle.Warranty.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.Warranty.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Warranty} returns this
 */ proto.vehicle.Warranty.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.Warranty.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Warranty} returns this
 */ proto.vehicle.Warranty.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int64 expiration = 4;
 * @return {number}
 */ proto.vehicle.Warranty.prototype.getExpiration = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Warranty} returns this
 */ proto.vehicle.Warranty.prototype.setExpiration = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Maintenance.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Maintenance.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Maintenance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Maintenance.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            description: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Maintenance}
 */ proto.vehicle.Maintenance.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Maintenance;
    return proto.vehicle.Maintenance.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Maintenance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Maintenance}
 */ proto.vehicle.Maintenance.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Maintenance.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Maintenance.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Maintenance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Maintenance.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Maintenance.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Maintenance} returns this
 */ proto.vehicle.Maintenance.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.Maintenance.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Maintenance} returns this
 */ proto.vehicle.Maintenance.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.Maintenance.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Maintenance} returns this
 */ proto.vehicle.Maintenance.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string description = 4;
 * @return {string}
 */ proto.vehicle.Maintenance.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Maintenance} returns this
 */ proto.vehicle.Maintenance.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Reg262.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Reg262.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Reg262} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Reg262.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Reg262}
 */ proto.vehicle.Reg262.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Reg262;
    return proto.vehicle.Reg262.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Reg262} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Reg262}
 */ proto.vehicle.Reg262.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Reg262.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Reg262.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Reg262} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Reg262.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Reg262.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Reg262} returns this
 */ proto.vehicle.Reg262.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.Reg262.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Reg262} returns this
 */ proto.vehicle.Reg262.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.Reg262.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Reg262} returns this
 */ proto.vehicle.Reg262.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.PurchaseOrder.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.PurchaseOrder.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.PurchaseOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.PurchaseOrder.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            purchasePrice: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.PurchaseOrder}
 */ proto.vehicle.PurchaseOrder.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.PurchaseOrder;
    return proto.vehicle.PurchaseOrder.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.PurchaseOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.PurchaseOrder}
 */ proto.vehicle.PurchaseOrder.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPurchasePrice(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.PurchaseOrder.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.PurchaseOrder.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.PurchaseOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.PurchaseOrder.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getPurchasePrice();
    if (f !== 0) writer.writeInt64(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.PurchaseOrder.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.PurchaseOrder} returns this
 */ proto.vehicle.PurchaseOrder.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.PurchaseOrder.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.PurchaseOrder} returns this
 */ proto.vehicle.PurchaseOrder.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.PurchaseOrder.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.PurchaseOrder} returns this
 */ proto.vehicle.PurchaseOrder.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int64 purchase_price = 4;
 * @return {number}
 */ proto.vehicle.PurchaseOrder.prototype.getPurchasePrice = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.PurchaseOrder} returns this
 */ proto.vehicle.PurchaseOrder.prototype.setPurchasePrice = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Reg51.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Reg51.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Reg51} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Reg51.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Reg51}
 */ proto.vehicle.Reg51.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Reg51;
    return proto.vehicle.Reg51.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Reg51} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Reg51}
 */ proto.vehicle.Reg51.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Reg51.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Reg51.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Reg51} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Reg51.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Reg51.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Reg51} returns this
 */ proto.vehicle.Reg51.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.Reg51.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Reg51} returns this
 */ proto.vehicle.Reg51.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.Reg51.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Reg51} returns this
 */ proto.vehicle.Reg51.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Reg553.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Reg553.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Reg553} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Reg553.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Reg553}
 */ proto.vehicle.Reg553.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Reg553;
    return proto.vehicle.Reg553.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Reg553} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Reg553}
 */ proto.vehicle.Reg553.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Reg553.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Reg553.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Reg553} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Reg553.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Reg553.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Reg553} returns this
 */ proto.vehicle.Reg553.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.Reg553.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Reg553} returns this
 */ proto.vehicle.Reg553.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.Reg553.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Reg553} returns this
 */ proto.vehicle.Reg553.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.BuyersGuide.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.BuyersGuide.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.BuyersGuide} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.BuyersGuide.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.BuyersGuide}
 */ proto.vehicle.BuyersGuide.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.BuyersGuide;
    return proto.vehicle.BuyersGuide.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.BuyersGuide} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.BuyersGuide}
 */ proto.vehicle.BuyersGuide.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.BuyersGuide.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.BuyersGuide.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.BuyersGuide} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.BuyersGuide.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.BuyersGuide.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.BuyersGuide} returns this
 */ proto.vehicle.BuyersGuide.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.BuyersGuide.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.BuyersGuide} returns this
 */ proto.vehicle.BuyersGuide.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.BuyersGuide.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.BuyersGuide} returns this
 */ proto.vehicle.BuyersGuide.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.UsedVehicleHistoryDisclosure.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.UsedVehicleHistoryDisclosure.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.UsedVehicleHistoryDisclosure} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.UsedVehicleHistoryDisclosure.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fileName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.UsedVehicleHistoryDisclosure}
 */ proto.vehicle.UsedVehicleHistoryDisclosure.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.UsedVehicleHistoryDisclosure;
    return proto.vehicle.UsedVehicleHistoryDisclosure.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.UsedVehicleHistoryDisclosure} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.UsedVehicleHistoryDisclosure}
 */ proto.vehicle.UsedVehicleHistoryDisclosure.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFileName(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.UsedVehicleHistoryDisclosure.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.UsedVehicleHistoryDisclosure.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.UsedVehicleHistoryDisclosure} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.UsedVehicleHistoryDisclosure.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFileName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.UsedVehicleHistoryDisclosure.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.UsedVehicleHistoryDisclosure} returns this
 */ proto.vehicle.UsedVehicleHistoryDisclosure.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string file_name = 2;
 * @return {string}
 */ proto.vehicle.UsedVehicleHistoryDisclosure.prototype.getFileName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.UsedVehicleHistoryDisclosure} returns this
 */ proto.vehicle.UsedVehicleHistoryDisclosure.prototype.setFileName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 created = 3;
 * @return {number}
 */ proto.vehicle.UsedVehicleHistoryDisclosure.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.UsedVehicleHistoryDisclosure} returns this
 */ proto.vehicle.UsedVehicleHistoryDisclosure.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.VehicleTermsOfService.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.VehicleTermsOfService.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.VehicleTermsOfService} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehicleTermsOfService.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            userId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.VehicleTermsOfService}
 */ proto.vehicle.VehicleTermsOfService.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.VehicleTermsOfService;
    return proto.vehicle.VehicleTermsOfService.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.VehicleTermsOfService} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.VehicleTermsOfService}
 */ proto.vehicle.VehicleTermsOfService.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.VehicleTermsOfService.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.VehicleTermsOfService.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.VehicleTermsOfService} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehicleTermsOfService.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.VehicleTermsOfService.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.VehicleTermsOfService} returns this
 */ proto.vehicle.VehicleTermsOfService.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string user_id = 2;
 * @return {string}
 */ proto.vehicle.VehicleTermsOfService.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.VehicleTermsOfService} returns this
 */ proto.vehicle.VehicleTermsOfService.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 timestamp = 3;
 * @return {number}
 */ proto.vehicle.VehicleTermsOfService.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.VehicleTermsOfService} returns this
 */ proto.vehicle.VehicleTermsOfService.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle.VehicleUpdated.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.VehicleUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.VehicleUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.VehicleUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehicleUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && proto.vehicle.Vehicle.toObject(includeInstance, f),
            propertiesList: $8M67s.Message.toObjectList(msg.getPropertiesList(), proto.vehicle.PropertyUpdated.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.VehicleUpdated}
 */ proto.vehicle.VehicleUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.VehicleUpdated;
    return proto.vehicle.VehicleUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.VehicleUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.VehicleUpdated}
 */ proto.vehicle.VehicleUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.vehicle.Vehicle;
                reader.readMessage(value, proto.vehicle.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            case 2:
                var value = new proto.vehicle.PropertyUpdated;
                reader.readMessage(value, proto.vehicle.PropertyUpdated.deserializeBinaryFromReader);
                msg.addProperties(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.VehicleUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.VehicleUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.VehicleUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehicleUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, proto.vehicle.Vehicle.serializeBinaryToWriter);
    f = message.getPropertiesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.vehicle.PropertyUpdated.serializeBinaryToWriter);
};
/**
 * optional Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.vehicle.VehicleUpdated.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.vehicle.VehicleUpdated} returns this
*/ proto.vehicle.VehicleUpdated.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.VehicleUpdated} returns this
 */ proto.vehicle.VehicleUpdated.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.VehicleUpdated.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated PropertyUpdated properties = 2;
 * @return {!Array<!proto.vehicle.PropertyUpdated>}
 */ proto.vehicle.VehicleUpdated.prototype.getPropertiesList = function() {
    return /** @type{!Array<!proto.vehicle.PropertyUpdated>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.PropertyUpdated, 2);
};
/**
 * @param {!Array<!proto.vehicle.PropertyUpdated>} value
 * @return {!proto.vehicle.VehicleUpdated} returns this
*/ proto.vehicle.VehicleUpdated.prototype.setPropertiesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.vehicle.PropertyUpdated=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.PropertyUpdated}
 */ proto.vehicle.VehicleUpdated.prototype.addProperties = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vehicle.PropertyUpdated, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.VehicleUpdated} returns this
 */ proto.vehicle.VehicleUpdated.prototype.clearPropertiesList = function() {
    return this.setPropertiesList([]);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.vehicle.PropertyUpdated.oneofGroups_ = [
    [
        2,
        3,
        4,
        5,
        6,
        7
    ]
];
/**
 * @enum {number}
 */ proto.vehicle.PropertyUpdated.UpdatedPropertyCase = {
    UPDATED_PROPERTY_NOT_SET: 0,
    GENERIC_PROPERTY: 2,
    VIN: 3,
    CUSTODY: 4,
    WHEEL_SIZE: 5,
    EXTERIOR_COLOR: 6,
    INTERIOR_COLOR: 7
};
/**
 * @return {proto.vehicle.PropertyUpdated.UpdatedPropertyCase}
 */ proto.vehicle.PropertyUpdated.prototype.getUpdatedPropertyCase = function() {
    return /** @type {proto.vehicle.PropertyUpdated.UpdatedPropertyCase} */ $8M67s.Message.computeOneofCase(this, proto.vehicle.PropertyUpdated.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.PropertyUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.PropertyUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.PropertyUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.PropertyUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            genericProperty: (f = msg.getGenericProperty()) && proto.vehicle.Property.toObject(includeInstance, f),
            vin: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            custody: (f = msg.getCustody()) && proto.vehicle.Custody.toObject(includeInstance, f),
            wheelSize: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            exteriorColor: (f = msg.getExteriorColor()) && proto.vehicle.Color.toObject(includeInstance, f),
            interiorColor: (f = msg.getInteriorColor()) && proto.vehicle.Color.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.PropertyUpdated}
 */ proto.vehicle.PropertyUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.PropertyUpdated;
    return proto.vehicle.PropertyUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.PropertyUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.PropertyUpdated}
 */ proto.vehicle.PropertyUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = new proto.vehicle.Property;
                reader.readMessage(value, proto.vehicle.Property.deserializeBinaryFromReader);
                msg.setGenericProperty(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 4:
                var value = new proto.vehicle.Custody;
                reader.readMessage(value, proto.vehicle.Custody.deserializeBinaryFromReader);
                msg.setCustody(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setWheelSize(value);
                break;
            case 6:
                var value = new proto.vehicle.Color;
                reader.readMessage(value, proto.vehicle.Color.deserializeBinaryFromReader);
                msg.setExteriorColor(value);
                break;
            case 7:
                var value = new proto.vehicle.Color;
                reader.readMessage(value, proto.vehicle.Color.deserializeBinaryFromReader);
                msg.setInteriorColor(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.PropertyUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.PropertyUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.PropertyUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.PropertyUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getGenericProperty();
    if (f != null) writer.writeMessage(2, f, proto.vehicle.Property.serializeBinaryToWriter);
    f = /** @type {string} */ $8M67s.Message.getField(message, 3);
    if (f != null) writer.writeString(3, f);
    f = message.getCustody();
    if (f != null) writer.writeMessage(4, f, proto.vehicle.Custody.serializeBinaryToWriter);
    f = /** @type {string} */ $8M67s.Message.getField(message, 5);
    if (f != null) writer.writeString(5, f);
    f = message.getExteriorColor();
    if (f != null) writer.writeMessage(6, f, proto.vehicle.Color.serializeBinaryToWriter);
    f = message.getInteriorColor();
    if (f != null) writer.writeMessage(7, f, proto.vehicle.Color.serializeBinaryToWriter);
};
/**
 * optional Property generic_property = 2;
 * @return {?proto.vehicle.Property}
 */ proto.vehicle.PropertyUpdated.prototype.getGenericProperty = function() {
    return /** @type{?proto.vehicle.Property} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Property, 2);
};
/**
 * @param {?proto.vehicle.Property|undefined} value
 * @return {!proto.vehicle.PropertyUpdated} returns this
*/ proto.vehicle.PropertyUpdated.prototype.setGenericProperty = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 2, proto.vehicle.PropertyUpdated.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.PropertyUpdated} returns this
 */ proto.vehicle.PropertyUpdated.prototype.clearGenericProperty = function() {
    return this.setGenericProperty(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.PropertyUpdated.prototype.hasGenericProperty = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional string vin = 3;
 * @return {string}
 */ proto.vehicle.PropertyUpdated.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.PropertyUpdated} returns this
 */ proto.vehicle.PropertyUpdated.prototype.setVin = function(value) {
    return $8M67s.Message.setOneofField(this, 3, proto.vehicle.PropertyUpdated.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.vehicle.PropertyUpdated} returns this
 */ proto.vehicle.PropertyUpdated.prototype.clearVin = function() {
    return $8M67s.Message.setOneofField(this, 3, proto.vehicle.PropertyUpdated.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.PropertyUpdated.prototype.hasVin = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional Custody custody = 4;
 * @return {?proto.vehicle.Custody}
 */ proto.vehicle.PropertyUpdated.prototype.getCustody = function() {
    return /** @type{?proto.vehicle.Custody} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Custody, 4);
};
/**
 * @param {?proto.vehicle.Custody|undefined} value
 * @return {!proto.vehicle.PropertyUpdated} returns this
*/ proto.vehicle.PropertyUpdated.prototype.setCustody = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 4, proto.vehicle.PropertyUpdated.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.PropertyUpdated} returns this
 */ proto.vehicle.PropertyUpdated.prototype.clearCustody = function() {
    return this.setCustody(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.PropertyUpdated.prototype.hasCustody = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional string wheel_size = 5;
 * @return {string}
 */ proto.vehicle.PropertyUpdated.prototype.getWheelSize = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.PropertyUpdated} returns this
 */ proto.vehicle.PropertyUpdated.prototype.setWheelSize = function(value) {
    return $8M67s.Message.setOneofField(this, 5, proto.vehicle.PropertyUpdated.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.vehicle.PropertyUpdated} returns this
 */ proto.vehicle.PropertyUpdated.prototype.clearWheelSize = function() {
    return $8M67s.Message.setOneofField(this, 5, proto.vehicle.PropertyUpdated.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.PropertyUpdated.prototype.hasWheelSize = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional Color exterior_color = 6;
 * @return {?proto.vehicle.Color}
 */ proto.vehicle.PropertyUpdated.prototype.getExteriorColor = function() {
    return /** @type{?proto.vehicle.Color} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Color, 6);
};
/**
 * @param {?proto.vehicle.Color|undefined} value
 * @return {!proto.vehicle.PropertyUpdated} returns this
*/ proto.vehicle.PropertyUpdated.prototype.setExteriorColor = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 6, proto.vehicle.PropertyUpdated.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.PropertyUpdated} returns this
 */ proto.vehicle.PropertyUpdated.prototype.clearExteriorColor = function() {
    return this.setExteriorColor(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.PropertyUpdated.prototype.hasExteriorColor = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional Color interior_color = 7;
 * @return {?proto.vehicle.Color}
 */ proto.vehicle.PropertyUpdated.prototype.getInteriorColor = function() {
    return /** @type{?proto.vehicle.Color} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Color, 7);
};
/**
 * @param {?proto.vehicle.Color|undefined} value
 * @return {!proto.vehicle.PropertyUpdated} returns this
*/ proto.vehicle.PropertyUpdated.prototype.setInteriorColor = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 7, proto.vehicle.PropertyUpdated.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.PropertyUpdated} returns this
 */ proto.vehicle.PropertyUpdated.prototype.clearInteriorColor = function() {
    return this.setInteriorColor(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.PropertyUpdated.prototype.hasInteriorColor = function() {
    return $8M67s.Message.getField(this, 7) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.VehicleDeleted.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.VehicleDeleted.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.VehicleDeleted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehicleDeleted.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            reason: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.VehicleDeleted}
 */ proto.vehicle.VehicleDeleted.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.VehicleDeleted;
    return proto.vehicle.VehicleDeleted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.VehicleDeleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.VehicleDeleted}
 */ proto.vehicle.VehicleDeleted.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 3:
                var value = /** @type {!proto.vehicle.VehicleDeleted.Reason} */ reader.readEnum();
                msg.setReason(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.VehicleDeleted.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.VehicleDeleted.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.VehicleDeleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehicleDeleted.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getReason();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * @enum {number}
 */ proto.vehicle.VehicleDeleted.Reason = {
    SOLD: 0,
    DUPLICATE: 1
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.VehicleDeleted.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.VehicleDeleted} returns this
 */ proto.vehicle.VehicleDeleted.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vin = 2;
 * @return {string}
 */ proto.vehicle.VehicleDeleted.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.VehicleDeleted} returns this
 */ proto.vehicle.VehicleDeleted.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Reason reason = 3;
 * @return {!proto.vehicle.VehicleDeleted.Reason}
 */ proto.vehicle.VehicleDeleted.prototype.getReason = function() {
    return /** @type {!proto.vehicle.VehicleDeleted.Reason} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.vehicle.VehicleDeleted.Reason} value
 * @return {!proto.vehicle.VehicleDeleted} returns this
 */ proto.vehicle.VehicleDeleted.prototype.setReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle.Ingestion.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Ingestion.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Ingestion.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Ingestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Ingestion.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && proto.vehicle.Vehicle.toObject(includeInstance, f),
            changeType: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            vehiclesList: $8M67s.Message.toObjectList(msg.getVehiclesList(), proto.vehicle.Vehicle.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Ingestion}
 */ proto.vehicle.Ingestion.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Ingestion;
    return proto.vehicle.Ingestion.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Ingestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Ingestion}
 */ proto.vehicle.Ingestion.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.vehicle.Vehicle;
                reader.readMessage(value, proto.vehicle.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            case 2:
                var value = /** @type {!proto.vehicle.Ingestion.ChangeType} */ reader.readEnum();
                msg.setChangeType(value);
                break;
            case 3:
                var value = new proto.vehicle.Vehicle;
                reader.readMessage(value, proto.vehicle.Vehicle.deserializeBinaryFromReader);
                msg.addVehicles(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Ingestion.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Ingestion.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Ingestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Ingestion.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, proto.vehicle.Vehicle.serializeBinaryToWriter);
    f = message.getChangeType();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getVehiclesList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.vehicle.Vehicle.serializeBinaryToWriter);
};
/**
 * @enum {number}
 */ proto.vehicle.Ingestion.ChangeType = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
/**
 * optional Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.vehicle.Ingestion.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.vehicle.Ingestion} returns this
*/ proto.vehicle.Ingestion.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Ingestion} returns this
 */ proto.vehicle.Ingestion.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Ingestion.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional ChangeType change_type = 2;
 * @return {!proto.vehicle.Ingestion.ChangeType}
 */ proto.vehicle.Ingestion.prototype.getChangeType = function() {
    return /** @type {!proto.vehicle.Ingestion.ChangeType} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.vehicle.Ingestion.ChangeType} value
 * @return {!proto.vehicle.Ingestion} returns this
 */ proto.vehicle.Ingestion.prototype.setChangeType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * repeated Vehicle vehicles = 3;
 * @return {!Array<!proto.vehicle.Vehicle>}
 */ proto.vehicle.Ingestion.prototype.getVehiclesList = function() {
    return /** @type{!Array<!proto.vehicle.Vehicle>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Vehicle, 3);
};
/**
 * @param {!Array<!proto.vehicle.Vehicle>} value
 * @return {!proto.vehicle.Ingestion} returns this
*/ proto.vehicle.Ingestion.prototype.setVehiclesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.vehicle.Vehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Vehicle}
 */ proto.vehicle.Ingestion.prototype.addVehicles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.vehicle.Vehicle, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Ingestion} returns this
 */ proto.vehicle.Ingestion.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.LocationUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.LocationUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.LocationUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.LocationUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            location: (f = msg.getLocation()) && proto.vehicle.Location.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.LocationUpdated}
 */ proto.vehicle.LocationUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.LocationUpdated;
    return proto.vehicle.LocationUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.LocationUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.LocationUpdated}
 */ proto.vehicle.LocationUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = new proto.vehicle.Location;
                reader.readMessage(value, proto.vehicle.Location.deserializeBinaryFromReader);
                msg.setLocation(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.LocationUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.LocationUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.LocationUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.LocationUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLocation();
    if (f != null) writer.writeMessage(2, f, proto.vehicle.Location.serializeBinaryToWriter);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.vehicle.LocationUpdated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.LocationUpdated} returns this
 */ proto.vehicle.LocationUpdated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Location location = 2;
 * @return {?proto.vehicle.Location}
 */ proto.vehicle.LocationUpdated.prototype.getLocation = function() {
    return /** @type{?proto.vehicle.Location} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Location, 2);
};
/**
 * @param {?proto.vehicle.Location|undefined} value
 * @return {!proto.vehicle.LocationUpdated} returns this
*/ proto.vehicle.LocationUpdated.prototype.setLocation = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.LocationUpdated} returns this
 */ proto.vehicle.LocationUpdated.prototype.clearLocation = function() {
    return this.setLocation(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.LocationUpdated.prototype.hasLocation = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.LocationUpdate.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.LocationUpdate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.LocationUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.LocationUpdate.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            location: (f = msg.getLocation()) && proto.vehicle.Location.toObject(includeInstance, f),
            custodianId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            custodianType: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.LocationUpdate}
 */ proto.vehicle.LocationUpdate.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.LocationUpdate;
    return proto.vehicle.LocationUpdate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.LocationUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.LocationUpdate}
 */ proto.vehicle.LocationUpdate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = new proto.vehicle.Location;
                reader.readMessage(value, proto.vehicle.Location.deserializeBinaryFromReader);
                msg.setLocation(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustodianId(value);
                break;
            case 4:
                var value = /** @type {!proto.vehicle.CustodianType} */ reader.readEnum();
                msg.setCustodianType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.LocationUpdate.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.LocationUpdate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.LocationUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.LocationUpdate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLocation();
    if (f != null) writer.writeMessage(2, f, proto.vehicle.Location.serializeBinaryToWriter);
    f = message.getCustodianId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCustodianType();
    if (f !== 0.0) writer.writeEnum(4, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.vehicle.LocationUpdate.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.LocationUpdate} returns this
 */ proto.vehicle.LocationUpdate.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Location location = 2;
 * @return {?proto.vehicle.Location}
 */ proto.vehicle.LocationUpdate.prototype.getLocation = function() {
    return /** @type{?proto.vehicle.Location} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Location, 2);
};
/**
 * @param {?proto.vehicle.Location|undefined} value
 * @return {!proto.vehicle.LocationUpdate} returns this
*/ proto.vehicle.LocationUpdate.prototype.setLocation = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.LocationUpdate} returns this
 */ proto.vehicle.LocationUpdate.prototype.clearLocation = function() {
    return this.setLocation(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.LocationUpdate.prototype.hasLocation = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional string custodian_id = 3;
 * @return {string}
 */ proto.vehicle.LocationUpdate.prototype.getCustodianId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.LocationUpdate} returns this
 */ proto.vehicle.LocationUpdate.prototype.setCustodianId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional CustodianType custodian_type = 4;
 * @return {!proto.vehicle.CustodianType}
 */ proto.vehicle.LocationUpdate.prototype.getCustodianType = function() {
    return /** @type {!proto.vehicle.CustodianType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.vehicle.CustodianType} value
 * @return {!proto.vehicle.LocationUpdate} returns this
 */ proto.vehicle.LocationUpdate.prototype.setCustodianType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.OdometerUpdate.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.OdometerUpdate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.OdometerUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.OdometerUpdate.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            reading: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            units: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            custodianId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            custodianType: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.OdometerUpdate}
 */ proto.vehicle.OdometerUpdate.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.OdometerUpdate;
    return proto.vehicle.OdometerUpdate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.OdometerUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.OdometerUpdate}
 */ proto.vehicle.OdometerUpdate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReading(value);
                break;
            case 3:
                var value = /** @type {!proto.vehicle.OdometerUpdate.Units} */ reader.readEnum();
                msg.setUnits(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCustodianId(value);
                break;
            case 5:
                var value = /** @type {!proto.vehicle.CustodianType} */ reader.readEnum();
                msg.setCustodianType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.OdometerUpdate.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.OdometerUpdate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.OdometerUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.OdometerUpdate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReading();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getUnits();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getCustodianId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCustodianType();
    if (f !== 0.0) writer.writeEnum(5, f);
};
/**
 * @enum {number}
 */ proto.vehicle.OdometerUpdate.Units = {
    MILES: 0,
    KILOMETERS: 1
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.vehicle.OdometerUpdate.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.OdometerUpdate} returns this
 */ proto.vehicle.OdometerUpdate.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 reading = 2;
 * @return {number}
 */ proto.vehicle.OdometerUpdate.prototype.getReading = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.OdometerUpdate} returns this
 */ proto.vehicle.OdometerUpdate.prototype.setReading = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional Units units = 3;
 * @return {!proto.vehicle.OdometerUpdate.Units}
 */ proto.vehicle.OdometerUpdate.prototype.getUnits = function() {
    return /** @type {!proto.vehicle.OdometerUpdate.Units} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.vehicle.OdometerUpdate.Units} value
 * @return {!proto.vehicle.OdometerUpdate} returns this
 */ proto.vehicle.OdometerUpdate.prototype.setUnits = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string custodian_id = 4;
 * @return {string}
 */ proto.vehicle.OdometerUpdate.prototype.getCustodianId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.OdometerUpdate} returns this
 */ proto.vehicle.OdometerUpdate.prototype.setCustodianId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional CustodianType custodian_type = 5;
 * @return {!proto.vehicle.CustodianType}
 */ proto.vehicle.OdometerUpdate.prototype.getCustodianType = function() {
    return /** @type {!proto.vehicle.CustodianType} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.vehicle.CustodianType} value
 * @return {!proto.vehicle.OdometerUpdate} returns this
 */ proto.vehicle.OdometerUpdate.prototype.setCustodianType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle.VehiclePreferencesNotAvailable.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.VehiclePreferencesNotAvailable.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.VehiclePreferencesNotAvailable.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.VehiclePreferencesNotAvailable} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehiclePreferencesNotAvailable.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            preferencesList: $8M67s.Message.toObjectList(msg.getPreferencesList(), proto.vehicle.Preference.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.VehiclePreferencesNotAvailable}
 */ proto.vehicle.VehiclePreferencesNotAvailable.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.VehiclePreferencesNotAvailable;
    return proto.vehicle.VehiclePreferencesNotAvailable.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.VehiclePreferencesNotAvailable} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.VehiclePreferencesNotAvailable}
 */ proto.vehicle.VehiclePreferencesNotAvailable.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new proto.vehicle.Preference;
                reader.readMessage(value, proto.vehicle.Preference.deserializeBinaryFromReader);
                msg.addPreferences(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.VehiclePreferencesNotAvailable.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.VehiclePreferencesNotAvailable.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.VehiclePreferencesNotAvailable} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehiclePreferencesNotAvailable.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPreferencesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.vehicle.Preference.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.vehicle.VehiclePreferencesNotAvailable.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.VehiclePreferencesNotAvailable} returns this
 */ proto.vehicle.VehiclePreferencesNotAvailable.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated Preference preferences = 2;
 * @return {!Array<!proto.vehicle.Preference>}
 */ proto.vehicle.VehiclePreferencesNotAvailable.prototype.getPreferencesList = function() {
    return /** @type{!Array<!proto.vehicle.Preference>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle.Preference, 2);
};
/**
 * @param {!Array<!proto.vehicle.Preference>} value
 * @return {!proto.vehicle.VehiclePreferencesNotAvailable} returns this
*/ proto.vehicle.VehiclePreferencesNotAvailable.prototype.setPreferencesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.vehicle.Preference=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Preference}
 */ proto.vehicle.VehiclePreferencesNotAvailable.prototype.addPreferences = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vehicle.Preference, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.VehiclePreferencesNotAvailable} returns this
 */ proto.vehicle.VehiclePreferencesNotAvailable.prototype.clearPreferencesList = function() {
    return this.setPreferencesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Preference.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Preference.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Preference} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Preference.toObject = function(includeInstance, msg) {
        var f, obj = {
            priority: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicleModel: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            preferredColor: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            year: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Preference}
 */ proto.vehicle.Preference.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Preference;
    return proto.vehicle.Preference.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Preference} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Preference}
 */ proto.vehicle.Preference.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.vehicle.Priority} */ reader.readEnum();
                msg.setPriority(value);
                break;
            case 2:
                var value = /** @type {!proto.vehicle.Model} */ reader.readEnum();
                msg.setVehicleModel(value);
                break;
            case 3:
                var value = /** @type {!proto.vehicle.Preference.Color} */ reader.readEnum();
                msg.setPreferredColor(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Preference.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Preference.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Preference} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Preference.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPriority();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getVehicleModel();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getPreferredColor();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * @enum {number}
 */ proto.vehicle.Preference.Color = {
    WHITE: 0,
    BLACK: 1,
    GRAY: 2,
    RED: 3,
    BLUE: 4,
    YELLOW: 5,
    ORANGE: 6,
    GREEN: 7,
    VIOLET: 8
};
/**
 * optional Priority priority = 1;
 * @return {!proto.vehicle.Priority}
 */ proto.vehicle.Preference.prototype.getPriority = function() {
    return /** @type {!proto.vehicle.Priority} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.vehicle.Priority} value
 * @return {!proto.vehicle.Preference} returns this
 */ proto.vehicle.Preference.prototype.setPriority = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional Model vehicle_model = 2;
 * @return {!proto.vehicle.Model}
 */ proto.vehicle.Preference.prototype.getVehicleModel = function() {
    return /** @type {!proto.vehicle.Model} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.vehicle.Model} value
 * @return {!proto.vehicle.Preference} returns this
 */ proto.vehicle.Preference.prototype.setVehicleModel = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional Color preferred_color = 3;
 * @return {!proto.vehicle.Preference.Color}
 */ proto.vehicle.Preference.prototype.getPreferredColor = function() {
    return /** @type {!proto.vehicle.Preference.Color} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.vehicle.Preference.Color} value
 * @return {!proto.vehicle.Preference} returns this
 */ proto.vehicle.Preference.prototype.setPreferredColor = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string year = 4;
 * @return {string}
 */ proto.vehicle.Preference.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Preference} returns this
 */ proto.vehicle.Preference.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle.Infleeting.repeatedFields_ = [
    13
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Infleeting.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Infleeting.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Infleeting} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Infleeting.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            userId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            startDate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            completionDate: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            step: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            infleetingStatus: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            registration: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            keyCards: $8M67s.Message.getBooleanFieldWithDefault(msg, 9, false),
            charger: $8M67s.Message.getBooleanFieldWithDefault(msg, 10, false),
            mats: $8M67s.Message.getBooleanFieldWithDefault(msg, 11, false),
            plateMounting: $8M67s.Message.getBooleanFieldWithDefault(msg, 12, false),
            adaptersList: (f = $8M67s.Message.getRepeatedField(msg, 13)) == null ? undefined : f,
            tagType: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            tagPictureUri: $8M67s.Message.getFieldWithDefault(msg, 15, ""),
            visibleDamages: $8M67s.Message.getBooleanFieldWithDefault(msg, 16, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Infleeting}
 */ proto.vehicle.Infleeting.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Infleeting;
    return proto.vehicle.Infleeting.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Infleeting} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Infleeting}
 */ proto.vehicle.Infleeting.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setStartDate(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCompletionDate(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStep(value);
                break;
            case 7:
                var value = /** @type {!proto.vehicle.Infleeting.InfleetingStatus} */ reader.readEnum();
                msg.setInfleetingStatus(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRegistration(value);
                break;
            case 9:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setKeyCards(value);
                break;
            case 10:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setCharger(value);
                break;
            case 11:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setMats(value);
                break;
            case 12:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setPlateMounting(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.addAdapters(value);
                break;
            case 14:
                var value = /** @type {!proto.vehicle.VehicleTagType} */ reader.readEnum();
                msg.setTagType(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setTagPictureUri(value);
                break;
            case 16:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setVisibleDamages(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Infleeting.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Infleeting.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Infleeting} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Infleeting.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getStartDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getCompletionDate();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getStep();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getInfleetingStatus();
    if (f !== 0.0) writer.writeEnum(7, f);
    f = message.getRegistration();
    if (f) writer.writeBool(8, f);
    f = message.getKeyCards();
    if (f) writer.writeBool(9, f);
    f = message.getCharger();
    if (f) writer.writeBool(10, f);
    f = message.getMats();
    if (f) writer.writeBool(11, f);
    f = message.getPlateMounting();
    if (f) writer.writeBool(12, f);
    f = message.getAdaptersList();
    if (f.length > 0) writer.writeRepeatedString(13, f);
    f = message.getTagType();
    if (f !== 0.0) writer.writeEnum(14, f);
    f = message.getTagPictureUri();
    if (f.length > 0) writer.writeString(15, f);
    f = message.getVisibleDamages();
    if (f) writer.writeBool(16, f);
};
/**
 * @enum {number}
 */ proto.vehicle.Infleeting.InfleetingStatus = {
    IN_WORK: 0,
    COMPLETE: 1
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle.Infleeting.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.vehicle.Infleeting.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string user_id = 3;
 * @return {string}
 */ proto.vehicle.Infleeting.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 start_date = 4;
 * @return {number}
 */ proto.vehicle.Infleeting.prototype.getStartDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setStartDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 completion_date = 5;
 * @return {number}
 */ proto.vehicle.Infleeting.prototype.getCompletionDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setCompletionDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 step = 6;
 * @return {number}
 */ proto.vehicle.Infleeting.prototype.getStep = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setStep = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional InfleetingStatus infleeting_status = 7;
 * @return {!proto.vehicle.Infleeting.InfleetingStatus}
 */ proto.vehicle.Infleeting.prototype.getInfleetingStatus = function() {
    return /** @type {!proto.vehicle.Infleeting.InfleetingStatus} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {!proto.vehicle.Infleeting.InfleetingStatus} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setInfleetingStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 7, value);
};
/**
 * optional bool registration = 8;
 * @return {boolean}
 */ proto.vehicle.Infleeting.prototype.getRegistration = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setRegistration = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * optional bool key_cards = 9;
 * @return {boolean}
 */ proto.vehicle.Infleeting.prototype.getKeyCards = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 9, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setKeyCards = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 9, value);
};
/**
 * optional bool charger = 10;
 * @return {boolean}
 */ proto.vehicle.Infleeting.prototype.getCharger = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 10, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setCharger = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 10, value);
};
/**
 * optional bool mats = 11;
 * @return {boolean}
 */ proto.vehicle.Infleeting.prototype.getMats = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 11, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setMats = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 11, value);
};
/**
 * optional bool plate_mounting = 12;
 * @return {boolean}
 */ proto.vehicle.Infleeting.prototype.getPlateMounting = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 12, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setPlateMounting = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 12, value);
};
/**
 * repeated string adapters = 13;
 * @return {!Array<string>}
 */ proto.vehicle.Infleeting.prototype.getAdaptersList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 13);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setAdaptersList = function(value) {
    return $8M67s.Message.setField(this, 13, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.addAdapters = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 13, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.clearAdaptersList = function() {
    return this.setAdaptersList([]);
};
/**
 * optional VehicleTagType tag_type = 14;
 * @return {!proto.vehicle.VehicleTagType}
 */ proto.vehicle.Infleeting.prototype.getTagType = function() {
    return /** @type {!proto.vehicle.VehicleTagType} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {!proto.vehicle.VehicleTagType} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setTagType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 14, value);
};
/**
 * optional string tag_picture_uri = 15;
 * @return {string}
 */ proto.vehicle.Infleeting.prototype.getTagPictureUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setTagPictureUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
/**
 * optional bool visible_damages = 16;
 * @return {boolean}
 */ proto.vehicle.Infleeting.prototype.getVisibleDamages = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 16, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle.Infleeting} returns this
 */ proto.vehicle.Infleeting.prototype.setVisibleDamages = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 16, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.VehicleInfleetingUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.VehicleInfleetingUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.VehicleInfleetingUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehicleInfleetingUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            infleeting: (f = msg.getInfleeting()) && proto.vehicle.Infleeting.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.VehicleInfleetingUpdated}
 */ proto.vehicle.VehicleInfleetingUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.VehicleInfleetingUpdated;
    return proto.vehicle.VehicleInfleetingUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.VehicleInfleetingUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.VehicleInfleetingUpdated}
 */ proto.vehicle.VehicleInfleetingUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = new proto.vehicle.Infleeting;
                reader.readMessage(value, proto.vehicle.Infleeting.deserializeBinaryFromReader);
                msg.setInfleeting(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.VehicleInfleetingUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.VehicleInfleetingUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.VehicleInfleetingUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.VehicleInfleetingUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getInfleeting();
    if (f != null) writer.writeMessage(2, f, proto.vehicle.Infleeting.serializeBinaryToWriter);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.vehicle.VehicleInfleetingUpdated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.VehicleInfleetingUpdated} returns this
 */ proto.vehicle.VehicleInfleetingUpdated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Infleeting infleeting = 2;
 * @return {?proto.vehicle.Infleeting}
 */ proto.vehicle.VehicleInfleetingUpdated.prototype.getInfleeting = function() {
    return /** @type{?proto.vehicle.Infleeting} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Infleeting, 2);
};
/**
 * @param {?proto.vehicle.Infleeting|undefined} value
 * @return {!proto.vehicle.VehicleInfleetingUpdated} returns this
*/ proto.vehicle.VehicleInfleetingUpdated.prototype.setInfleeting = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.VehicleInfleetingUpdated} returns this
 */ proto.vehicle.VehicleInfleetingUpdated.prototype.clearInfleeting = function() {
    return this.setInfleeting(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.VehicleInfleetingUpdated.prototype.hasInfleeting = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.InfleetingVehicle.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.InfleetingVehicle.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.InfleetingVehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.InfleetingVehicle.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && proto.vehicle.Vehicle.toObject(includeInstance, f),
            status: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.InfleetingVehicle}
 */ proto.vehicle.InfleetingVehicle.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.InfleetingVehicle;
    return proto.vehicle.InfleetingVehicle.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.InfleetingVehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.InfleetingVehicle}
 */ proto.vehicle.InfleetingVehicle.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.vehicle.Vehicle;
                reader.readMessage(value, proto.vehicle.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.InfleetingVehicle.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.InfleetingVehicle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.InfleetingVehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.InfleetingVehicle.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, proto.vehicle.Vehicle.serializeBinaryToWriter);
    f = message.getStatus();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.vehicle.InfleetingVehicle.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.vehicle.InfleetingVehicle} returns this
*/ proto.vehicle.InfleetingVehicle.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.InfleetingVehicle} returns this
 */ proto.vehicle.InfleetingVehicle.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.InfleetingVehicle.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional string status = 2;
 * @return {string}
 */ proto.vehicle.InfleetingVehicle.prototype.getStatus = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle.InfleetingVehicle} returns this
 */ proto.vehicle.InfleetingVehicle.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.vehicle.Document.oneofGroups_ = [
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]
];
/**
 * @enum {number}
 */ proto.vehicle.Document.TypeCase = {
    TYPE_NOT_SET: 0,
    REG262: 1,
    PURCHASE_ORDER: 2,
    REG51: 3,
    REG553: 4,
    BUYERS_GUIDE: 5,
    USED_VEHICLE_HISTORY_DISCLOSURE: 6,
    TOS: 7,
    INSPECTIONS: 8,
    REGISTRATIONS: 9,
    TITLES: 10,
    WARRANTIES: 11,
    MAINTENANCES: 12
};
/**
 * @return {proto.vehicle.Document.TypeCase}
 */ proto.vehicle.Document.prototype.getTypeCase = function() {
    return /** @type {proto.vehicle.Document.TypeCase} */ $8M67s.Message.computeOneofCase(this, proto.vehicle.Document.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle.Document.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle.Document.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle.Document} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Document.toObject = function(includeInstance, msg) {
        var f, obj = {
            reg262: (f = msg.getReg262()) && proto.vehicle.Reg262.toObject(includeInstance, f),
            purchaseOrder: (f = msg.getPurchaseOrder()) && proto.vehicle.PurchaseOrder.toObject(includeInstance, f),
            reg51: (f = msg.getReg51()) && proto.vehicle.Reg51.toObject(includeInstance, f),
            reg553: (f = msg.getReg553()) && proto.vehicle.Reg553.toObject(includeInstance, f),
            buyersGuide: (f = msg.getBuyersGuide()) && proto.vehicle.BuyersGuide.toObject(includeInstance, f),
            usedVehicleHistoryDisclosure: (f = msg.getUsedVehicleHistoryDisclosure()) && proto.vehicle.UsedVehicleHistoryDisclosure.toObject(includeInstance, f),
            tos: (f = msg.getTos()) && proto.vehicle.VehicleTermsOfService.toObject(includeInstance, f),
            inspections: (f = msg.getInspections()) && proto.vehicle.Inspection.toObject(includeInstance, f),
            registrations: (f = msg.getRegistrations()) && proto.vehicle.Registration.toObject(includeInstance, f),
            titles: (f = msg.getTitles()) && proto.vehicle.Title.toObject(includeInstance, f),
            warranties: (f = msg.getWarranties()) && proto.vehicle.Warranty.toObject(includeInstance, f),
            maintenances: (f = msg.getMaintenances()) && proto.vehicle.Maintenance.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle.Document}
 */ proto.vehicle.Document.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle.Document;
    return proto.vehicle.Document.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle.Document} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle.Document}
 */ proto.vehicle.Document.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.vehicle.Reg262;
                reader.readMessage(value, proto.vehicle.Reg262.deserializeBinaryFromReader);
                msg.setReg262(value);
                break;
            case 2:
                var value = new proto.vehicle.PurchaseOrder;
                reader.readMessage(value, proto.vehicle.PurchaseOrder.deserializeBinaryFromReader);
                msg.setPurchaseOrder(value);
                break;
            case 3:
                var value = new proto.vehicle.Reg51;
                reader.readMessage(value, proto.vehicle.Reg51.deserializeBinaryFromReader);
                msg.setReg51(value);
                break;
            case 4:
                var value = new proto.vehicle.Reg553;
                reader.readMessage(value, proto.vehicle.Reg553.deserializeBinaryFromReader);
                msg.setReg553(value);
                break;
            case 5:
                var value = new proto.vehicle.BuyersGuide;
                reader.readMessage(value, proto.vehicle.BuyersGuide.deserializeBinaryFromReader);
                msg.setBuyersGuide(value);
                break;
            case 6:
                var value = new proto.vehicle.UsedVehicleHistoryDisclosure;
                reader.readMessage(value, proto.vehicle.UsedVehicleHistoryDisclosure.deserializeBinaryFromReader);
                msg.setUsedVehicleHistoryDisclosure(value);
                break;
            case 7:
                var value = new proto.vehicle.VehicleTermsOfService;
                reader.readMessage(value, proto.vehicle.VehicleTermsOfService.deserializeBinaryFromReader);
                msg.setTos(value);
                break;
            case 8:
                var value = new proto.vehicle.Inspection;
                reader.readMessage(value, proto.vehicle.Inspection.deserializeBinaryFromReader);
                msg.setInspections(value);
                break;
            case 9:
                var value = new proto.vehicle.Registration;
                reader.readMessage(value, proto.vehicle.Registration.deserializeBinaryFromReader);
                msg.setRegistrations(value);
                break;
            case 10:
                var value = new proto.vehicle.Title;
                reader.readMessage(value, proto.vehicle.Title.deserializeBinaryFromReader);
                msg.setTitles(value);
                break;
            case 11:
                var value = new proto.vehicle.Warranty;
                reader.readMessage(value, proto.vehicle.Warranty.deserializeBinaryFromReader);
                msg.setWarranties(value);
                break;
            case 12:
                var value = new proto.vehicle.Maintenance;
                reader.readMessage(value, proto.vehicle.Maintenance.deserializeBinaryFromReader);
                msg.setMaintenances(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle.Document.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle.Document.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle.Document} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle.Document.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReg262();
    if (f != null) writer.writeMessage(1, f, proto.vehicle.Reg262.serializeBinaryToWriter);
    f = message.getPurchaseOrder();
    if (f != null) writer.writeMessage(2, f, proto.vehicle.PurchaseOrder.serializeBinaryToWriter);
    f = message.getReg51();
    if (f != null) writer.writeMessage(3, f, proto.vehicle.Reg51.serializeBinaryToWriter);
    f = message.getReg553();
    if (f != null) writer.writeMessage(4, f, proto.vehicle.Reg553.serializeBinaryToWriter);
    f = message.getBuyersGuide();
    if (f != null) writer.writeMessage(5, f, proto.vehicle.BuyersGuide.serializeBinaryToWriter);
    f = message.getUsedVehicleHistoryDisclosure();
    if (f != null) writer.writeMessage(6, f, proto.vehicle.UsedVehicleHistoryDisclosure.serializeBinaryToWriter);
    f = message.getTos();
    if (f != null) writer.writeMessage(7, f, proto.vehicle.VehicleTermsOfService.serializeBinaryToWriter);
    f = message.getInspections();
    if (f != null) writer.writeMessage(8, f, proto.vehicle.Inspection.serializeBinaryToWriter);
    f = message.getRegistrations();
    if (f != null) writer.writeMessage(9, f, proto.vehicle.Registration.serializeBinaryToWriter);
    f = message.getTitles();
    if (f != null) writer.writeMessage(10, f, proto.vehicle.Title.serializeBinaryToWriter);
    f = message.getWarranties();
    if (f != null) writer.writeMessage(11, f, proto.vehicle.Warranty.serializeBinaryToWriter);
    f = message.getMaintenances();
    if (f != null) writer.writeMessage(12, f, proto.vehicle.Maintenance.serializeBinaryToWriter);
};
/**
 * optional Reg262 reg262 = 1;
 * @return {?proto.vehicle.Reg262}
 */ proto.vehicle.Document.prototype.getReg262 = function() {
    return /** @type{?proto.vehicle.Reg262} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Reg262, 1);
};
/**
 * @param {?proto.vehicle.Reg262|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setReg262 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 1, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearReg262 = function() {
    return this.setReg262(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasReg262 = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional PurchaseOrder purchase_order = 2;
 * @return {?proto.vehicle.PurchaseOrder}
 */ proto.vehicle.Document.prototype.getPurchaseOrder = function() {
    return /** @type{?proto.vehicle.PurchaseOrder} */ $8M67s.Message.getWrapperField(this, proto.vehicle.PurchaseOrder, 2);
};
/**
 * @param {?proto.vehicle.PurchaseOrder|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setPurchaseOrder = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 2, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearPurchaseOrder = function() {
    return this.setPurchaseOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasPurchaseOrder = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional Reg51 reg51 = 3;
 * @return {?proto.vehicle.Reg51}
 */ proto.vehicle.Document.prototype.getReg51 = function() {
    return /** @type{?proto.vehicle.Reg51} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Reg51, 3);
};
/**
 * @param {?proto.vehicle.Reg51|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setReg51 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 3, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearReg51 = function() {
    return this.setReg51(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasReg51 = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional Reg553 reg553 = 4;
 * @return {?proto.vehicle.Reg553}
 */ proto.vehicle.Document.prototype.getReg553 = function() {
    return /** @type{?proto.vehicle.Reg553} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Reg553, 4);
};
/**
 * @param {?proto.vehicle.Reg553|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setReg553 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 4, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearReg553 = function() {
    return this.setReg553(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasReg553 = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional BuyersGuide buyers_guide = 5;
 * @return {?proto.vehicle.BuyersGuide}
 */ proto.vehicle.Document.prototype.getBuyersGuide = function() {
    return /** @type{?proto.vehicle.BuyersGuide} */ $8M67s.Message.getWrapperField(this, proto.vehicle.BuyersGuide, 5);
};
/**
 * @param {?proto.vehicle.BuyersGuide|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setBuyersGuide = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 5, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearBuyersGuide = function() {
    return this.setBuyersGuide(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasBuyersGuide = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional UsedVehicleHistoryDisclosure used_vehicle_history_disclosure = 6;
 * @return {?proto.vehicle.UsedVehicleHistoryDisclosure}
 */ proto.vehicle.Document.prototype.getUsedVehicleHistoryDisclosure = function() {
    return /** @type{?proto.vehicle.UsedVehicleHistoryDisclosure} */ $8M67s.Message.getWrapperField(this, proto.vehicle.UsedVehicleHistoryDisclosure, 6);
};
/**
 * @param {?proto.vehicle.UsedVehicleHistoryDisclosure|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setUsedVehicleHistoryDisclosure = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 6, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearUsedVehicleHistoryDisclosure = function() {
    return this.setUsedVehicleHistoryDisclosure(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasUsedVehicleHistoryDisclosure = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional VehicleTermsOfService tos = 7;
 * @return {?proto.vehicle.VehicleTermsOfService}
 */ proto.vehicle.Document.prototype.getTos = function() {
    return /** @type{?proto.vehicle.VehicleTermsOfService} */ $8M67s.Message.getWrapperField(this, proto.vehicle.VehicleTermsOfService, 7);
};
/**
 * @param {?proto.vehicle.VehicleTermsOfService|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setTos = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 7, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearTos = function() {
    return this.setTos(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasTos = function() {
    return $8M67s.Message.getField(this, 7) != null;
};
/**
 * optional Inspection inspections = 8;
 * @return {?proto.vehicle.Inspection}
 */ proto.vehicle.Document.prototype.getInspections = function() {
    return /** @type{?proto.vehicle.Inspection} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Inspection, 8);
};
/**
 * @param {?proto.vehicle.Inspection|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setInspections = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 8, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearInspections = function() {
    return this.setInspections(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasInspections = function() {
    return $8M67s.Message.getField(this, 8) != null;
};
/**
 * optional Registration registrations = 9;
 * @return {?proto.vehicle.Registration}
 */ proto.vehicle.Document.prototype.getRegistrations = function() {
    return /** @type{?proto.vehicle.Registration} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Registration, 9);
};
/**
 * @param {?proto.vehicle.Registration|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setRegistrations = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 9, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearRegistrations = function() {
    return this.setRegistrations(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasRegistrations = function() {
    return $8M67s.Message.getField(this, 9) != null;
};
/**
 * optional Title titles = 10;
 * @return {?proto.vehicle.Title}
 */ proto.vehicle.Document.prototype.getTitles = function() {
    return /** @type{?proto.vehicle.Title} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Title, 10);
};
/**
 * @param {?proto.vehicle.Title|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setTitles = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 10, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearTitles = function() {
    return this.setTitles(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasTitles = function() {
    return $8M67s.Message.getField(this, 10) != null;
};
/**
 * optional Warranty warranties = 11;
 * @return {?proto.vehicle.Warranty}
 */ proto.vehicle.Document.prototype.getWarranties = function() {
    return /** @type{?proto.vehicle.Warranty} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Warranty, 11);
};
/**
 * @param {?proto.vehicle.Warranty|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setWarranties = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 11, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearWarranties = function() {
    return this.setWarranties(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasWarranties = function() {
    return $8M67s.Message.getField(this, 11) != null;
};
/**
 * optional Maintenance maintenances = 12;
 * @return {?proto.vehicle.Maintenance}
 */ proto.vehicle.Document.prototype.getMaintenances = function() {
    return /** @type{?proto.vehicle.Maintenance} */ $8M67s.Message.getWrapperField(this, proto.vehicle.Maintenance, 12);
};
/**
 * @param {?proto.vehicle.Maintenance|undefined} value
 * @return {!proto.vehicle.Document} returns this
*/ proto.vehicle.Document.prototype.setMaintenances = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 12, proto.vehicle.Document.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle.Document} returns this
 */ proto.vehicle.Document.prototype.clearMaintenances = function() {
    return this.setMaintenances(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle.Document.prototype.hasMaintenances = function() {
    return $8M67s.Message.getField(this, 12) != null;
};
/**
 * @enum {number}
 */ proto.vehicle.CustodianType = {
    CUSTODIAN_TYPE_UNSPECIFIED: 0,
    CUSTODIAN_TYPE_UNKNOWN: 1,
    CUSTODIAN_TYPE_OEM: 2,
    CUSTODIAN_TYPE_DEALER: 3,
    CUSTODIAN_TYPE_CUSTOMER: 4
};
/**
 * @enum {number}
 */ proto.vehicle.State = {
    IN_PROCESS: 0,
    IN_LISTING: 1,
    IN_ORDER: 2,
    ON_SUBSCRIPTION: 3,
    CHARGE_OFF_SKIP: 4,
    PENDING_RETURN: 5,
    RETURN_SCHEDULED: 6,
    RETURN_CANCELED: 7,
    OFF_SUBSCRIPTION: 8,
    VEHICLE_RECYCLED: 9,
    VEHICLE_SOLD: 10,
    REPO_ELIGIBLE: 11,
    OUT_FOR_REPO: 12,
    CHARGE_OFF_ELIGIBLE: 13,
    SOLD: 14,
    REPO: 15,
    RETURNED: 16,
    OUT_OF_SERVICE: 17,
    TOTAL_LOSS: 18
};
/**
 * @enum {number}
 */ proto.vehicle.ActivityFailure = {
    NONE: 0,
    UNAVAILABLE: 1,
    REJECT_SELLING_PRICE: 2,
    NOT_QUALIFIED: 3,
    INSPECTION_FAILURE: 4,
    CONTRACT_FAILURE: 5,
    VEHICLE_TRANSFER_FAILURE: 6,
    UPLOAD_FAILURE: 7,
    CUSTOM_INSURANCE_FAILURE: 8,
    TELEMATICS_FAILURE: 9,
    REGISTRATION_UPDATE_FAILURE: 10,
    UNWIND_FAILURE: 11,
    RETURN_NOT_SCHEDULED: 12,
    UNWIND_INELIGIBLE: 13,
    NO_LONGER_ELIGIBLE: 14,
    FRAUDULENT_PHONE: 15,
    RETURN_DATE_NOT_CONFIRMED: 16,
    RECYCLE_INELIGIBLE: 17,
    RETURN_CANCEL_FAILED: 18,
    FINAL_INSPECTION_FAILED: 19,
    ADDITIONAL_MILAGE_CHARGE_FAILED: 20,
    FINAL_BILL_ERROR: 21,
    UNABLE_TO_SUBMIT_TO_AUCTION: 22,
    REPAIRS_DENIED: 23,
    RECONDITIONING_CANCELED: 24,
    BUYER_DOCUMENT_FAILED: 25,
    PAYMENT_FAILED: 26
};
/**
 * @enum {number}
 */ proto.vehicle.Activity = {
    AVAILABILITY_CHECK: 0
};
/**
 * @enum {number}
 */ proto.vehicle.ActivityState = {
    AVAILABLE: 0,
    AGREED_SELLING_PRICE: 1,
    QUALIFIED: 2,
    REPRICE: 3,
    INSPECTION_IN_PROGRESS: 4,
    INSPECTION_COMPLETE: 5,
    CONTRACTS_SIGNED: 6,
    VEHICLE_IN_FLEET: 7,
    UPLOAD_REGISTRATION: 8,
    UPLOAD_TITLE: 9,
    INPUT_REGISTRATION_EXPIRATION: 10,
    ADD_INSURANCE: 11,
    VERIFY_CUSTOM_INSURANCE: 12,
    EMAIL_ENTERED: 13,
    ELIGIBLE_USER: 14,
    ACTIVATE_TELEMATICS: 15,
    VIEW_LOCATION: 16,
    MONTH_ADDED: 17,
    YEAR_ADDED: 18,
    REGISTRATION_PENDING: 19,
    REGISTRATION_RECEIVED: 20,
    REGISTRATION_NOT_REGISTERED: 21,
    SUBSCRIPTION_UNWOUND: 22,
    UNWIND_ELIGIBLE: 23,
    REPO_PENDING: 24,
    RETURN_DATE_SELECTED: 25,
    RETURN_DATE_CONFIRMED: 26,
    ELIGIBLE_FOR_FLEET: 27,
    RESCHEDULE_RETURN: 28,
    RECYCLE_ELIGIBLE: 29,
    RETURN_CANCEL_REQUESTED: 30,
    RETURN_CANCEL_CONFIRMED: 31,
    PENDING_FINAL_INSPECTION: 32,
    FINAL_INSPECTION_COMPLETE: 33,
    EXCESS_WEAR_CHARGE_SUBMITTED: 34,
    ENDING_MILAGE_SUBMITTED: 35,
    FINAL_BILL_SENT: 36,
    FINAL_BILL_PAID: 37,
    SUBMIT_TO_AUCTION: 38,
    VENDOR_ASSIGNED: 39,
    RECONDITIONING_IN_PROGRESS: 40,
    REPAIRS_APPROVED: 41,
    REPAIRS_COMPLETE: 42,
    RELOCATION_NEEDED: 43,
    RELOCATION_NOT_NEEDED: 44,
    IN_APP: 45,
    SUBMITTED_TO_AUCTION: 46,
    AUCTION_LISTED: 47,
    BUYER_CONFIRMED: 48,
    BUYER_DOCUMENTS_RECEIVED: 49,
    PAYMENT_PROCESSING: 50,
    PAYMENT_RECEIVED: 51
};
/**
 * @enum {number}
 */ proto.vehicle.Model = {
    TESLA_MODEL_3: 0,
    TESLA_MODEL_Y: 1
};
/**
 * @enum {number}
 */ proto.vehicle.Priority = {
    PRIMARY: 0,
    SECONDARY: 1
};
/**
 * @enum {number}
 */ proto.vehicle.VehicleTagType = {
    TEMP: 0,
    PERMANENT: 1
};
$743c5491af46e344$var$goog.object.extend(module.exports, proto.vehicle);

});

parcelRegister("kpGLk", function(module, exports) {
// source: events.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $edc7502dbc65dfc8$var$goog = $8M67s;
var $edc7502dbc65dfc8$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $3QqPt);

var $c17Fn = parcelRequire("c17Fn");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $c17Fn);

var $6EauF = parcelRequire("6EauF");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $6EauF);

var $9YICB = parcelRequire("9YICB");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $9YICB);

var $02GYf = parcelRequire("02GYf");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $02GYf);

var $hOsJC = parcelRequire("hOsJC");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $hOsJC);

var $26u10 = parcelRequire("26u10");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $26u10);

var $gjhG2 = parcelRequire("gjhG2");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $gjhG2);

var $fcTGK = parcelRequire("fcTGK");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $fcTGK);

var $3DbSe = parcelRequire("3DbSe");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $3DbSe);

var $1oiLe = parcelRequire("1oiLe");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $1oiLe);

var $ghA5X = parcelRequire("ghA5X");
$edc7502dbc65dfc8$var$goog.object.extend(proto, $ghA5X);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.ActivityStateUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.AuthStatus', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CancelPaymentTransaction', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CollisionReceived', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerActivityUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerCreated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerDataEnriched', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerDeleted', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerFailureStateUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerInfoUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerInsuranceUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerInsuranceUpdated.ChangeType', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerInsuranceUpdated.RequestSource', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerQualified', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerScoreDisqualified', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerScored', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.CustomerStateUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.DocumentAdded', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.DocumentAdded.DoctypeCase', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.DocumentDeleted', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.DocumentDeleted.DoctypeCase', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.Domain', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.Event', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.Event.PayloadCase', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.EventCategory', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.ExtendInsurancePolicies', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.InvoiceCancelled', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.InvoiceReady', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.InvoiceToBePaid', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.MilesPurchased', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.Notification', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.OdometerSet', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.OdometerUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.OfferReason', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.OfferResponse', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.OfferSubmitted', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.PaymentActivity', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.PaymentActivityType', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.PaymentRefunded', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.PaymentStatus', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.PickupDateSet', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.PickupPayment', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.PrepickupAuth', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.ReloadDomain', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.ReturnLineItem', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.SmsReceived', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.StatementActivity', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.StatementActivity.ActivityType', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.SubscriptionCancelled', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.SubscriptionContractAdded', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.SubscriptionVehicleChange', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.SubscriptionVehicleReturned', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.SyncDealerships', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.SyncIngestion', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.TransferVehicle', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.TripReceived', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleActivityFailureUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleActivityStateUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleActivityUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleChangeDetails', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleCreated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleInspectionCompleted', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleInspectionPhotoUrl', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleInspectionStarted', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehiclePickup', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehiclePrePickup', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleStateUpdated', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleStateUpdated.Reason', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VehicleTosAccepted', null, $edc7502dbc65dfc8$var$global);
$edc7502dbc65dfc8$var$goog.exportSymbol('proto.events.VendorAccountUpdated', null, $edc7502dbc65dfc8$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.Event = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.events.Event.oneofGroups_);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.Event, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.Event.displayName = 'proto.events.Event';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.PaymentRefunded = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.PaymentRefunded, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.PaymentRefunded.displayName = 'proto.events.PaymentRefunded';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.InvoiceCancelled = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.InvoiceCancelled, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.InvoiceCancelled.displayName = 'proto.events.InvoiceCancelled';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.SubscriptionCancelled = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.events.SubscriptionCancelled.repeatedFields_, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.SubscriptionCancelled, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.SubscriptionCancelled.displayName = 'proto.events.SubscriptionCancelled';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.TripReceived = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.TripReceived, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.TripReceived.displayName = 'proto.events.TripReceived';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CollisionReceived = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CollisionReceived, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CollisionReceived.displayName = 'proto.events.CollisionReceived';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.Notification = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.Notification, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.Notification.displayName = 'proto.events.Notification';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerCreated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerCreated.displayName = 'proto.events.CustomerCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerInfoUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.events.CustomerInfoUpdated.repeatedFields_, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerInfoUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerInfoUpdated.displayName = 'proto.events.CustomerInfoUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerInsuranceUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerInsuranceUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerInsuranceUpdated.displayName = 'proto.events.CustomerInsuranceUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerStateUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerStateUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerStateUpdated.displayName = 'proto.events.CustomerStateUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerFailureStateUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerFailureStateUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerFailureStateUpdated.displayName = 'proto.events.CustomerFailureStateUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerActivityUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerActivityUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerActivityUpdated.displayName = 'proto.events.CustomerActivityUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.ActivityStateUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.ActivityStateUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.ActivityStateUpdated.displayName = 'proto.events.ActivityStateUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VendorAccountUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VendorAccountUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VendorAccountUpdated.displayName = 'proto.events.VendorAccountUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerDeleted = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerDeleted, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerDeleted.displayName = 'proto.events.CustomerDeleted';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.PickupDateSet = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.PickupDateSet, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.PickupDateSet.displayName = 'proto.events.PickupDateSet';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehiclePrePickup = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehiclePrePickup, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehiclePrePickup.displayName = 'proto.events.VehiclePrePickup';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehiclePickup = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehiclePickup, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehiclePickup.displayName = 'proto.events.VehiclePickup';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.PrepickupAuth = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.PrepickupAuth, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.PrepickupAuth.displayName = 'proto.events.PrepickupAuth';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.PickupPayment = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.PickupPayment, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.PickupPayment.displayName = 'proto.events.PickupPayment';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleCreated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleCreated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleCreated.displayName = 'proto.events.VehicleCreated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.TransferVehicle = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.TransferVehicle, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.TransferVehicle.displayName = 'proto.events.TransferVehicle';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.InvoiceReady = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.InvoiceReady, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.InvoiceReady.displayName = 'proto.events.InvoiceReady';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.OdometerUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.OdometerUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.OdometerUpdated.displayName = 'proto.events.OdometerUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.OdometerSet = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.OdometerSet, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.OdometerSet.displayName = 'proto.events.OdometerSet';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.StatementActivity = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.StatementActivity, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.StatementActivity.displayName = 'proto.events.StatementActivity';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.PaymentActivity = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.PaymentActivity, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.PaymentActivity.displayName = 'proto.events.PaymentActivity';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleStateUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.events.VehicleStateUpdated.repeatedFields_, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleStateUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleStateUpdated.displayName = 'proto.events.VehicleStateUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.ReturnLineItem = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.ReturnLineItem, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.ReturnLineItem.displayName = 'proto.events.ReturnLineItem';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleActivityUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleActivityUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleActivityUpdated.displayName = 'proto.events.VehicleActivityUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleActivityStateUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleActivityStateUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleActivityStateUpdated.displayName = 'proto.events.VehicleActivityStateUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleActivityFailureUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleActivityFailureUpdated, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleActivityFailureUpdated.displayName = 'proto.events.VehicleActivityFailureUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.InvoiceToBePaid = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.InvoiceToBePaid, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.InvoiceToBePaid.displayName = 'proto.events.InvoiceToBePaid';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.SyncDealerships = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.SyncDealerships, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.SyncDealerships.displayName = 'proto.events.SyncDealerships';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.DocumentAdded = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.events.DocumentAdded.oneofGroups_);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.DocumentAdded, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.DocumentAdded.displayName = 'proto.events.DocumentAdded';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.DocumentDeleted = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.events.DocumentDeleted.oneofGroups_);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.DocumentDeleted, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.DocumentDeleted.displayName = 'proto.events.DocumentDeleted';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.OfferSubmitted = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.OfferSubmitted, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.OfferSubmitted.displayName = 'proto.events.OfferSubmitted';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.SubscriptionContractAdded = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.SubscriptionContractAdded, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.SubscriptionContractAdded.displayName = 'proto.events.SubscriptionContractAdded';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleInspectionStarted = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleInspectionStarted, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleInspectionStarted.displayName = 'proto.events.VehicleInspectionStarted';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleInspectionPhotoUrl = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleInspectionPhotoUrl, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleInspectionPhotoUrl.displayName = 'proto.events.VehicleInspectionPhotoUrl';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleInspectionCompleted = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.events.VehicleInspectionCompleted.repeatedFields_, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleInspectionCompleted, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleInspectionCompleted.displayName = 'proto.events.VehicleInspectionCompleted';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.OfferResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.OfferResponse, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.OfferResponse.displayName = 'proto.events.OfferResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleTosAccepted = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleTosAccepted, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleTosAccepted.displayName = 'proto.events.VehicleTosAccepted';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.ReloadDomain = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.ReloadDomain, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.ReloadDomain.displayName = 'proto.events.ReloadDomain';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CancelPaymentTransaction = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.events.CancelPaymentTransaction.repeatedFields_, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CancelPaymentTransaction, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CancelPaymentTransaction.displayName = 'proto.events.CancelPaymentTransaction';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.SmsReceived = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.SmsReceived, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.SmsReceived.displayName = 'proto.events.SmsReceived';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerScored = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerScored, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerScored.displayName = 'proto.events.CustomerScored';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerQualified = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerQualified, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerQualified.displayName = 'proto.events.CustomerQualified';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerScoreDisqualified = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerScoreDisqualified, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerScoreDisqualified.displayName = 'proto.events.CustomerScoreDisqualified';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.CustomerDataEnriched = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.CustomerDataEnriched, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.CustomerDataEnriched.displayName = 'proto.events.CustomerDataEnriched';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.SyncIngestion = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.SyncIngestion, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.SyncIngestion.displayName = 'proto.events.SyncIngestion';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.ExtendInsurancePolicies = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.ExtendInsurancePolicies, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.ExtendInsurancePolicies.displayName = 'proto.events.ExtendInsurancePolicies';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.MilesPurchased = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.MilesPurchased, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.MilesPurchased.displayName = 'proto.events.MilesPurchased';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.VehicleChangeDetails = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.VehicleChangeDetails, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.VehicleChangeDetails.displayName = 'proto.events.VehicleChangeDetails';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.SubscriptionVehicleChange = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.SubscriptionVehicleChange, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.SubscriptionVehicleChange.displayName = 'proto.events.SubscriptionVehicleChange';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.events.SubscriptionVehicleReturned = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$edc7502dbc65dfc8$var$goog.inherits(proto.events.SubscriptionVehicleReturned, $8M67s.Message);
if ($edc7502dbc65dfc8$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.events.SubscriptionVehicleReturned.displayName = 'proto.events.SubscriptionVehicleReturned';
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.events.Event.oneofGroups_ = [
    [
        9,
        10,
        11,
        12,
        13,
        14,
        15,
        16,
        17,
        18,
        19,
        20,
        21,
        22,
        23,
        24,
        25,
        26,
        27,
        28,
        29,
        30,
        31,
        32,
        33,
        34,
        35,
        36,
        37,
        38,
        39,
        40,
        41,
        42,
        43,
        44,
        45,
        46,
        47,
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,
        58,
        59,
        60,
        61,
        62,
        63,
        64,
        65,
        66,
        67,
        68,
        69,
        70,
        71,
        72,
        73,
        74,
        75,
        76,
        77,
        78,
        79,
        80,
        81,
        82,
        83,
        84,
        85,
        86,
        87,
        88,
        89,
        90,
        91,
        92,
        93,
        94,
        100,
        101,
        102,
        103,
        104,
        105,
        106,
        107,
        108,
        109,
        110,
        111,
        112,
        113,
        114,
        115
    ]
];
/**
 * @enum {number}
 */ proto.events.Event.PayloadCase = {
    PAYLOAD_NOT_SET: 0,
    CUSTOMER_CREATED: 9,
    CUSTOMER_INFO_UPDATED: 10,
    CUSTOMER_STATE_UPDATED: 11,
    CUSTOMER_FAILURE_STATE_UPDATED: 12,
    CUSTOMER_ACTIVITY_UPDATED: 13,
    ACTIVITY_STATE_UPDATED: 14,
    VENDOR_ACCOUNT_UPDATED: 15,
    CUSTOMER_DELETED: 16,
    PICKUP_DATE_SET: 17,
    VEHICLE_PREPICKUP: 18,
    VEHICLE_PICKUP: 19,
    PREPICKUP_AUTH: 20,
    PICKUP_PAYMENT: 21,
    TRANSFER_VEHICLE: 22,
    VEHICLE_CREATED: 23,
    TRIP_RECEIVED: 24,
    COLLISION_RECEIVED: 25,
    NOTIFICATION: 26,
    INVOICE_READY: 27,
    ODOMETER_UPDATED: 28,
    ODOMETER_SET: 29,
    STATEMENT_ACTIVITY: 30,
    PAYMENT_ACTIVITY: 31,
    VEHICLE_STATE_UPDATED: 32,
    VEHICLE_ACTIVITY_UPDATED: 33,
    VEHICLE_ACTIVITY_STATE_UPDATED: 34,
    VEHICLE_ACTIVITY_FAILURE_UPDATED: 35,
    CUSTOMER_INSURANCE_UPDATED: 36,
    SYNC_DEALERSHIPS: 37,
    INVOICE_TO_BE_PAID: 38,
    DOCUMENT_ADDED: 39,
    DOCUMENT_DELETED: 40,
    OFFER_SUBMITTED: 41,
    SUBSCRIPTION_CONTRACT_ADDED: 42,
    VEHICLE_INSPECTION_COMPLETED: 43,
    VEHICLE_INSPECTION_STARTED: 44,
    OFFER_RESPONSE: 45,
    VEHICLE_TOS_ACCEPTED: 46,
    SUBSCRIPTION_CANCELLED: 47,
    INVOICE_CANCELLED: 48,
    RELOAD_DOMAIN: 49,
    CANCEL_PAYMENT_TRANSACTION: 50,
    SMS_RECEIVED: 51,
    CUSTOMER_SCORED: 52,
    CUSTOMER_QUALIFIED: 53,
    CUSTOMER_SCORE_DISQUALIFIED: 54,
    PAYMENT_REFUNDED: 55,
    CUSTOMER_DATA_ENRICHED: 56,
    RESERVATION_CREATED: 57,
    RESERVATION_STATUS_UPDATED: 58,
    PROGRAM_CREATED: 59,
    COLOR_OPTION_CREATED: 60,
    PRICING_OPTION_CREATED: 61,
    PENDING_SUBSCRIPTION_INITIALIZED: 62,
    RESERVATION_CANCELLED: 63,
    SYNC_INGESTION: 64,
    VEHICLE_INGESTION: 65,
    VEHICLE_UPDATED: 66,
    VEHICLE_DELETED: 67,
    PROCESS_DUE_STATEMENTS: 68,
    STATEMENT_DUE: 69,
    SUBSCRIPTION_ACTIVATED: 70,
    CUSTOMER_PHONE_UPDATED: 71,
    PROMOTION_CREATED: 72,
    PROMOTION_UPDATED: 73,
    PROMOTION_ACTIVITY: 74,
    DRAFT_ORDER_UPDATED: 75,
    RESERVATION_OPTIONS_UPDATED: 76,
    PROMOTION_PARTNER_CREATED: 77,
    PROMOTION_PARTNER_UPDATED: 78,
    LOCATION_UPDATED: 79,
    SUBSCRIPTION_UPDATED: 80,
    ODOMETER_UPDATE: 81,
    LOCATION_UPDATE: 82,
    APPOINTMENT_CREATED: 83,
    APPOINTMENT_TYPE_UPDATED: 84,
    APPOINTMENT_STATUS_UPDATED: 85,
    APPOINTMENT_VEHICLE_UPDATED: 86,
    AVAILABILITY_CREATED: 87,
    APPOINTMENT_CANCELLED: 88,
    PROGRAM_PRICING_OPTIONS_UPDATED: 89,
    APPOINTMENT_UPDATED: 90,
    VEHICLE_PREFERENCES_NOT_AVAILABLE: 91,
    SEND_NOTIFICATIONS: 92,
    NOTIFICATIONS_RECEIVED: 93,
    NOTIFICATION_STATUS_UPDATED: 94,
    DEALERSHIP_CREATED: 100,
    DEALERSHIP_USER_CREATED: 101,
    CUSTOMER_BANK_VERIFIED: 102,
    IS_QUALIFIED_FOR_LIBERTY: 103,
    INSURANCE_POLICY_CREATED: 104,
    DEALERSHIP_USER_UPDATED: 105,
    DEALERSHIP_UPDATED: 106,
    PHONE_NUMBER_ENTERED: 107,
    LICENSE_INFO_SUBMITTED: 108,
    VEHICLE_INFLEETING_UPDATED: 109,
    EXTEND_INSURANCE_POLICIES: 110,
    INSURANCE_POLICY_UPDATED: 111,
    MILES_PURCHASED: 112,
    INSURANCE_POLICY_CANCELLED: 113,
    SUBSCRIPTION_VEHICLE_CHANGE: 114,
    SUBSCRIPTION_VEHICLE_RETURNED: 115
};
/**
 * @return {proto.events.Event.PayloadCase}
 */ proto.events.Event.prototype.getPayloadCase = function() {
    return /** @type {proto.events.Event.PayloadCase} */ $8M67s.Message.computeOneofCase(this, proto.events.Event.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.Event.prototype.toObject = function(opt_includeInstance) {
        return proto.events.Event.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.Event} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.Event.toObject = function(includeInstance, msg) {
        var f, obj = {
            category: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            domain: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            domainId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            traceId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            version: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            modelVersion: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            customerCreated: (f = msg.getCustomerCreated()) && proto.events.CustomerCreated.toObject(includeInstance, f),
            customerInfoUpdated: (f = msg.getCustomerInfoUpdated()) && proto.events.CustomerInfoUpdated.toObject(includeInstance, f),
            customerStateUpdated: (f = msg.getCustomerStateUpdated()) && proto.events.CustomerStateUpdated.toObject(includeInstance, f),
            customerFailureStateUpdated: (f = msg.getCustomerFailureStateUpdated()) && proto.events.CustomerFailureStateUpdated.toObject(includeInstance, f),
            customerActivityUpdated: (f = msg.getCustomerActivityUpdated()) && proto.events.CustomerActivityUpdated.toObject(includeInstance, f),
            activityStateUpdated: (f = msg.getActivityStateUpdated()) && proto.events.ActivityStateUpdated.toObject(includeInstance, f),
            vendorAccountUpdated: (f = msg.getVendorAccountUpdated()) && proto.events.VendorAccountUpdated.toObject(includeInstance, f),
            customerDeleted: (f = msg.getCustomerDeleted()) && proto.events.CustomerDeleted.toObject(includeInstance, f),
            pickupDateSet: (f = msg.getPickupDateSet()) && proto.events.PickupDateSet.toObject(includeInstance, f),
            vehiclePrepickup: (f = msg.getVehiclePrepickup()) && proto.events.VehiclePrePickup.toObject(includeInstance, f),
            vehiclePickup: (f = msg.getVehiclePickup()) && proto.events.VehiclePickup.toObject(includeInstance, f),
            prepickupAuth: (f = msg.getPrepickupAuth()) && proto.events.PrepickupAuth.toObject(includeInstance, f),
            pickupPayment: (f = msg.getPickupPayment()) && proto.events.PickupPayment.toObject(includeInstance, f),
            transferVehicle: (f = msg.getTransferVehicle()) && proto.events.TransferVehicle.toObject(includeInstance, f),
            vehicleCreated: (f = msg.getVehicleCreated()) && proto.events.VehicleCreated.toObject(includeInstance, f),
            tripReceived: (f = msg.getTripReceived()) && proto.events.TripReceived.toObject(includeInstance, f),
            collisionReceived: (f = msg.getCollisionReceived()) && proto.events.CollisionReceived.toObject(includeInstance, f),
            notification: (f = msg.getNotification()) && proto.events.Notification.toObject(includeInstance, f),
            invoiceReady: (f = msg.getInvoiceReady()) && proto.events.InvoiceReady.toObject(includeInstance, f),
            odometerUpdated: (f = msg.getOdometerUpdated()) && proto.events.OdometerUpdated.toObject(includeInstance, f),
            odometerSet: (f = msg.getOdometerSet()) && proto.events.OdometerSet.toObject(includeInstance, f),
            statementActivity: (f = msg.getStatementActivity()) && proto.events.StatementActivity.toObject(includeInstance, f),
            paymentActivity: (f = msg.getPaymentActivity()) && proto.events.PaymentActivity.toObject(includeInstance, f),
            vehicleStateUpdated: (f = msg.getVehicleStateUpdated()) && proto.events.VehicleStateUpdated.toObject(includeInstance, f),
            vehicleActivityUpdated: (f = msg.getVehicleActivityUpdated()) && proto.events.VehicleActivityUpdated.toObject(includeInstance, f),
            vehicleActivityStateUpdated: (f = msg.getVehicleActivityStateUpdated()) && proto.events.VehicleActivityStateUpdated.toObject(includeInstance, f),
            vehicleActivityFailureUpdated: (f = msg.getVehicleActivityFailureUpdated()) && proto.events.VehicleActivityFailureUpdated.toObject(includeInstance, f),
            customerInsuranceUpdated: (f = msg.getCustomerInsuranceUpdated()) && proto.events.CustomerInsuranceUpdated.toObject(includeInstance, f),
            syncDealerships: (f = msg.getSyncDealerships()) && proto.events.SyncDealerships.toObject(includeInstance, f),
            invoiceToBePaid: (f = msg.getInvoiceToBePaid()) && proto.events.InvoiceToBePaid.toObject(includeInstance, f),
            documentAdded: (f = msg.getDocumentAdded()) && proto.events.DocumentAdded.toObject(includeInstance, f),
            documentDeleted: (f = msg.getDocumentDeleted()) && proto.events.DocumentDeleted.toObject(includeInstance, f),
            offerSubmitted: (f = msg.getOfferSubmitted()) && proto.events.OfferSubmitted.toObject(includeInstance, f),
            subscriptionContractAdded: (f = msg.getSubscriptionContractAdded()) && proto.events.SubscriptionContractAdded.toObject(includeInstance, f),
            vehicleInspectionCompleted: (f = msg.getVehicleInspectionCompleted()) && proto.events.VehicleInspectionCompleted.toObject(includeInstance, f),
            vehicleInspectionStarted: (f = msg.getVehicleInspectionStarted()) && proto.events.VehicleInspectionStarted.toObject(includeInstance, f),
            offerResponse: (f = msg.getOfferResponse()) && proto.events.OfferResponse.toObject(includeInstance, f),
            vehicleTosAccepted: (f = msg.getVehicleTosAccepted()) && proto.events.VehicleTosAccepted.toObject(includeInstance, f),
            subscriptionCancelled: (f = msg.getSubscriptionCancelled()) && proto.events.SubscriptionCancelled.toObject(includeInstance, f),
            invoiceCancelled: (f = msg.getInvoiceCancelled()) && proto.events.InvoiceCancelled.toObject(includeInstance, f),
            reloadDomain: (f = msg.getReloadDomain()) && proto.events.ReloadDomain.toObject(includeInstance, f),
            cancelPaymentTransaction: (f = msg.getCancelPaymentTransaction()) && proto.events.CancelPaymentTransaction.toObject(includeInstance, f),
            smsReceived: (f = msg.getSmsReceived()) && proto.events.SmsReceived.toObject(includeInstance, f),
            customerScored: (f = msg.getCustomerScored()) && proto.events.CustomerScored.toObject(includeInstance, f),
            customerQualified: (f = msg.getCustomerQualified()) && proto.events.CustomerQualified.toObject(includeInstance, f),
            customerScoreDisqualified: (f = msg.getCustomerScoreDisqualified()) && proto.events.CustomerScoreDisqualified.toObject(includeInstance, f),
            paymentRefunded: (f = msg.getPaymentRefunded()) && proto.events.PaymentRefunded.toObject(includeInstance, f),
            customerDataEnriched: (f = msg.getCustomerDataEnriched()) && proto.events.CustomerDataEnriched.toObject(includeInstance, f),
            reservationCreated: (f = msg.getReservationCreated()) && $hOsJC.ReservationCreated.toObject(includeInstance, f),
            reservationStatusUpdated: (f = msg.getReservationStatusUpdated()) && $hOsJC.ReservationStatusUpdated.toObject(includeInstance, f),
            programCreated: (f = msg.getProgramCreated()) && $hOsJC.ProgramCreated.toObject(includeInstance, f),
            colorOptionCreated: (f = msg.getColorOptionCreated()) && $hOsJC.ColorOptionCreated.toObject(includeInstance, f),
            pricingOptionCreated: (f = msg.getPricingOptionCreated()) && $hOsJC.PricingOptionCreated.toObject(includeInstance, f),
            pendingSubscriptionInitialized: (f = msg.getPendingSubscriptionInitialized()) && $hOsJC.PendingSubscriptionInitialized.toObject(includeInstance, f),
            reservationCancelled: (f = msg.getReservationCancelled()) && $hOsJC.ReservationCancelled.toObject(includeInstance, f),
            syncIngestion: (f = msg.getSyncIngestion()) && proto.events.SyncIngestion.toObject(includeInstance, f),
            vehicleIngestion: (f = msg.getVehicleIngestion()) && $9YICB.Ingestion.toObject(includeInstance, f),
            vehicleUpdated: (f = msg.getVehicleUpdated()) && $9YICB.VehicleUpdated.toObject(includeInstance, f),
            vehicleDeleted: (f = msg.getVehicleDeleted()) && $9YICB.VehicleDeleted.toObject(includeInstance, f),
            processDueStatements: (f = msg.getProcessDueStatements()) && $hOsJC.ProcessDueStatements.toObject(includeInstance, f),
            statementDue: (f = msg.getStatementDue()) && $hOsJC.StatementDue.toObject(includeInstance, f),
            subscriptionActivated: (f = msg.getSubscriptionActivated()) && $hOsJC.SubscriptionActivated.toObject(includeInstance, f),
            customerPhoneUpdated: (f = msg.getCustomerPhoneUpdated()) && $c17Fn.CustomerPhoneUpdated.toObject(includeInstance, f),
            promotionCreated: (f = msg.getPromotionCreated()) && $26u10.Promotion.toObject(includeInstance, f),
            promotionUpdated: (f = msg.getPromotionUpdated()) && $26u10.Promotion.toObject(includeInstance, f),
            promotionActivity: (f = msg.getPromotionActivity()) && $26u10.PromotionActivity.toObject(includeInstance, f),
            draftOrderUpdated: (f = msg.getDraftOrderUpdated()) && $26u10.DraftOrderUpdated.toObject(includeInstance, f),
            reservationOptionsUpdated: (f = msg.getReservationOptionsUpdated()) && $hOsJC.ReservationOptionsUpdated.toObject(includeInstance, f),
            promotionPartnerCreated: (f = msg.getPromotionPartnerCreated()) && $26u10.PromotionPartner.toObject(includeInstance, f),
            promotionPartnerUpdated: (f = msg.getPromotionPartnerUpdated()) && $26u10.PromotionPartner.toObject(includeInstance, f),
            locationUpdated: (f = msg.getLocationUpdated()) && $9YICB.LocationUpdated.toObject(includeInstance, f),
            subscriptionUpdated: (f = msg.getSubscriptionUpdated()) && $hOsJC.SubscriptionUpdated.toObject(includeInstance, f),
            odometerUpdate: (f = msg.getOdometerUpdate()) && $9YICB.OdometerUpdate.toObject(includeInstance, f),
            locationUpdate: (f = msg.getLocationUpdate()) && $9YICB.LocationUpdate.toObject(includeInstance, f),
            appointmentCreated: (f = msg.getAppointmentCreated()) && $fcTGK.AppointmentCreated.toObject(includeInstance, f),
            appointmentTypeUpdated: (f = msg.getAppointmentTypeUpdated()) && $fcTGK.AppointmentTypeUpdated.toObject(includeInstance, f),
            appointmentStatusUpdated: (f = msg.getAppointmentStatusUpdated()) && $fcTGK.AppointmentStatusUpdated.toObject(includeInstance, f),
            appointmentVehicleUpdated: (f = msg.getAppointmentVehicleUpdated()) && $fcTGK.AppointmentVehicleUpdated.toObject(includeInstance, f),
            availabilityCreated: (f = msg.getAvailabilityCreated()) && $fcTGK.AvailabilityCreated.toObject(includeInstance, f),
            appointmentCancelled: (f = msg.getAppointmentCancelled()) && $fcTGK.AppointmentCancelled.toObject(includeInstance, f),
            programPricingOptionsUpdated: (f = msg.getProgramPricingOptionsUpdated()) && $hOsJC.ProgramPricingOptionsUpdated.toObject(includeInstance, f),
            appointmentUpdated: (f = msg.getAppointmentUpdated()) && $fcTGK.AppointmentUpdated.toObject(includeInstance, f),
            vehiclePreferencesNotAvailable: (f = msg.getVehiclePreferencesNotAvailable()) && $9YICB.VehiclePreferencesNotAvailable.toObject(includeInstance, f),
            sendNotifications: (f = msg.getSendNotifications()) && $3DbSe.SendNotifications.toObject(includeInstance, f),
            notificationsReceived: (f = msg.getNotificationsReceived()) && $3DbSe.NotificationReceived.toObject(includeInstance, f),
            notificationStatusUpdated: (f = msg.getNotificationStatusUpdated()) && $3DbSe.NotificationStatusUpdated.toObject(includeInstance, f),
            dealershipCreated: (f = msg.getDealershipCreated()) && $1oiLe.DealershipCreated.toObject(includeInstance, f),
            dealershipUserCreated: (f = msg.getDealershipUserCreated()) && $1oiLe.DealershipUserCreated.toObject(includeInstance, f),
            customerBankVerified: (f = msg.getCustomerBankVerified()) && $c17Fn.CustomerBankAccountVerified.toObject(includeInstance, f),
            isQualifiedForLiberty: (f = msg.getIsQualifiedForLiberty()) && $ghA5X.IsQualifiedForLiberty.toObject(includeInstance, f),
            insurancePolicyCreated: (f = msg.getInsurancePolicyCreated()) && $ghA5X.InsurancePolicyCreated.toObject(includeInstance, f),
            dealershipUserUpdated: (f = msg.getDealershipUserUpdated()) && $1oiLe.DealershipUserUpdated.toObject(includeInstance, f),
            dealershipUpdated: (f = msg.getDealershipUpdated()) && $1oiLe.DealershipUpdated.toObject(includeInstance, f),
            phoneNumberEntered: (f = msg.getPhoneNumberEntered()) && $c17Fn.PhoneNumberEntered.toObject(includeInstance, f),
            licenseInfoSubmitted: (f = msg.getLicenseInfoSubmitted()) && $c17Fn.LicenseInfoSubmitted.toObject(includeInstance, f),
            vehicleInfleetingUpdated: (f = msg.getVehicleInfleetingUpdated()) && $9YICB.VehicleInfleetingUpdated.toObject(includeInstance, f),
            extendInsurancePolicies: (f = msg.getExtendInsurancePolicies()) && proto.events.ExtendInsurancePolicies.toObject(includeInstance, f),
            insurancePolicyUpdated: (f = msg.getInsurancePolicyUpdated()) && $ghA5X.InsurancePolicyUpdated.toObject(includeInstance, f),
            milesPurchased: (f = msg.getMilesPurchased()) && proto.events.MilesPurchased.toObject(includeInstance, f),
            insurancePolicyCancelled: (f = msg.getInsurancePolicyCancelled()) && $ghA5X.InsurancePolicyCancelled.toObject(includeInstance, f),
            subscriptionVehicleChange: (f = msg.getSubscriptionVehicleChange()) && proto.events.SubscriptionVehicleChange.toObject(includeInstance, f),
            subscriptionVehicleReturned: (f = msg.getSubscriptionVehicleReturned()) && proto.events.SubscriptionVehicleReturned.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.Event}
 */ proto.events.Event.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.Event;
    return proto.events.Event.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.Event} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.Event}
 */ proto.events.Event.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.events.EventCategory} */ reader.readEnum();
                msg.setCategory(value);
                break;
            case 2:
                var value = /** @type {!proto.events.Domain} */ reader.readEnum();
                msg.setDomain(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDomainId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setTraceId(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setModelVersion(value);
                break;
            case 9:
                var value = new proto.events.CustomerCreated;
                reader.readMessage(value, proto.events.CustomerCreated.deserializeBinaryFromReader);
                msg.setCustomerCreated(value);
                break;
            case 10:
                var value = new proto.events.CustomerInfoUpdated;
                reader.readMessage(value, proto.events.CustomerInfoUpdated.deserializeBinaryFromReader);
                msg.setCustomerInfoUpdated(value);
                break;
            case 11:
                var value = new proto.events.CustomerStateUpdated;
                reader.readMessage(value, proto.events.CustomerStateUpdated.deserializeBinaryFromReader);
                msg.setCustomerStateUpdated(value);
                break;
            case 12:
                var value = new proto.events.CustomerFailureStateUpdated;
                reader.readMessage(value, proto.events.CustomerFailureStateUpdated.deserializeBinaryFromReader);
                msg.setCustomerFailureStateUpdated(value);
                break;
            case 13:
                var value = new proto.events.CustomerActivityUpdated;
                reader.readMessage(value, proto.events.CustomerActivityUpdated.deserializeBinaryFromReader);
                msg.setCustomerActivityUpdated(value);
                break;
            case 14:
                var value = new proto.events.ActivityStateUpdated;
                reader.readMessage(value, proto.events.ActivityStateUpdated.deserializeBinaryFromReader);
                msg.setActivityStateUpdated(value);
                break;
            case 15:
                var value = new proto.events.VendorAccountUpdated;
                reader.readMessage(value, proto.events.VendorAccountUpdated.deserializeBinaryFromReader);
                msg.setVendorAccountUpdated(value);
                break;
            case 16:
                var value = new proto.events.CustomerDeleted;
                reader.readMessage(value, proto.events.CustomerDeleted.deserializeBinaryFromReader);
                msg.setCustomerDeleted(value);
                break;
            case 17:
                var value = new proto.events.PickupDateSet;
                reader.readMessage(value, proto.events.PickupDateSet.deserializeBinaryFromReader);
                msg.setPickupDateSet(value);
                break;
            case 18:
                var value = new proto.events.VehiclePrePickup;
                reader.readMessage(value, proto.events.VehiclePrePickup.deserializeBinaryFromReader);
                msg.setVehiclePrepickup(value);
                break;
            case 19:
                var value = new proto.events.VehiclePickup;
                reader.readMessage(value, proto.events.VehiclePickup.deserializeBinaryFromReader);
                msg.setVehiclePickup(value);
                break;
            case 20:
                var value = new proto.events.PrepickupAuth;
                reader.readMessage(value, proto.events.PrepickupAuth.deserializeBinaryFromReader);
                msg.setPrepickupAuth(value);
                break;
            case 21:
                var value = new proto.events.PickupPayment;
                reader.readMessage(value, proto.events.PickupPayment.deserializeBinaryFromReader);
                msg.setPickupPayment(value);
                break;
            case 22:
                var value = new proto.events.TransferVehicle;
                reader.readMessage(value, proto.events.TransferVehicle.deserializeBinaryFromReader);
                msg.setTransferVehicle(value);
                break;
            case 23:
                var value = new proto.events.VehicleCreated;
                reader.readMessage(value, proto.events.VehicleCreated.deserializeBinaryFromReader);
                msg.setVehicleCreated(value);
                break;
            case 24:
                var value = new proto.events.TripReceived;
                reader.readMessage(value, proto.events.TripReceived.deserializeBinaryFromReader);
                msg.setTripReceived(value);
                break;
            case 25:
                var value = new proto.events.CollisionReceived;
                reader.readMessage(value, proto.events.CollisionReceived.deserializeBinaryFromReader);
                msg.setCollisionReceived(value);
                break;
            case 26:
                var value = new proto.events.Notification;
                reader.readMessage(value, proto.events.Notification.deserializeBinaryFromReader);
                msg.setNotification(value);
                break;
            case 27:
                var value = new proto.events.InvoiceReady;
                reader.readMessage(value, proto.events.InvoiceReady.deserializeBinaryFromReader);
                msg.setInvoiceReady(value);
                break;
            case 28:
                var value = new proto.events.OdometerUpdated;
                reader.readMessage(value, proto.events.OdometerUpdated.deserializeBinaryFromReader);
                msg.setOdometerUpdated(value);
                break;
            case 29:
                var value = new proto.events.OdometerSet;
                reader.readMessage(value, proto.events.OdometerSet.deserializeBinaryFromReader);
                msg.setOdometerSet(value);
                break;
            case 30:
                var value = new proto.events.StatementActivity;
                reader.readMessage(value, proto.events.StatementActivity.deserializeBinaryFromReader);
                msg.setStatementActivity(value);
                break;
            case 31:
                var value = new proto.events.PaymentActivity;
                reader.readMessage(value, proto.events.PaymentActivity.deserializeBinaryFromReader);
                msg.setPaymentActivity(value);
                break;
            case 32:
                var value = new proto.events.VehicleStateUpdated;
                reader.readMessage(value, proto.events.VehicleStateUpdated.deserializeBinaryFromReader);
                msg.setVehicleStateUpdated(value);
                break;
            case 33:
                var value = new proto.events.VehicleActivityUpdated;
                reader.readMessage(value, proto.events.VehicleActivityUpdated.deserializeBinaryFromReader);
                msg.setVehicleActivityUpdated(value);
                break;
            case 34:
                var value = new proto.events.VehicleActivityStateUpdated;
                reader.readMessage(value, proto.events.VehicleActivityStateUpdated.deserializeBinaryFromReader);
                msg.setVehicleActivityStateUpdated(value);
                break;
            case 35:
                var value = new proto.events.VehicleActivityFailureUpdated;
                reader.readMessage(value, proto.events.VehicleActivityFailureUpdated.deserializeBinaryFromReader);
                msg.setVehicleActivityFailureUpdated(value);
                break;
            case 36:
                var value = new proto.events.CustomerInsuranceUpdated;
                reader.readMessage(value, proto.events.CustomerInsuranceUpdated.deserializeBinaryFromReader);
                msg.setCustomerInsuranceUpdated(value);
                break;
            case 37:
                var value = new proto.events.SyncDealerships;
                reader.readMessage(value, proto.events.SyncDealerships.deserializeBinaryFromReader);
                msg.setSyncDealerships(value);
                break;
            case 38:
                var value = new proto.events.InvoiceToBePaid;
                reader.readMessage(value, proto.events.InvoiceToBePaid.deserializeBinaryFromReader);
                msg.setInvoiceToBePaid(value);
                break;
            case 39:
                var value = new proto.events.DocumentAdded;
                reader.readMessage(value, proto.events.DocumentAdded.deserializeBinaryFromReader);
                msg.setDocumentAdded(value);
                break;
            case 40:
                var value = new proto.events.DocumentDeleted;
                reader.readMessage(value, proto.events.DocumentDeleted.deserializeBinaryFromReader);
                msg.setDocumentDeleted(value);
                break;
            case 41:
                var value = new proto.events.OfferSubmitted;
                reader.readMessage(value, proto.events.OfferSubmitted.deserializeBinaryFromReader);
                msg.setOfferSubmitted(value);
                break;
            case 42:
                var value = new proto.events.SubscriptionContractAdded;
                reader.readMessage(value, proto.events.SubscriptionContractAdded.deserializeBinaryFromReader);
                msg.setSubscriptionContractAdded(value);
                break;
            case 43:
                var value = new proto.events.VehicleInspectionCompleted;
                reader.readMessage(value, proto.events.VehicleInspectionCompleted.deserializeBinaryFromReader);
                msg.setVehicleInspectionCompleted(value);
                break;
            case 44:
                var value = new proto.events.VehicleInspectionStarted;
                reader.readMessage(value, proto.events.VehicleInspectionStarted.deserializeBinaryFromReader);
                msg.setVehicleInspectionStarted(value);
                break;
            case 45:
                var value = new proto.events.OfferResponse;
                reader.readMessage(value, proto.events.OfferResponse.deserializeBinaryFromReader);
                msg.setOfferResponse(value);
                break;
            case 46:
                var value = new proto.events.VehicleTosAccepted;
                reader.readMessage(value, proto.events.VehicleTosAccepted.deserializeBinaryFromReader);
                msg.setVehicleTosAccepted(value);
                break;
            case 47:
                var value = new proto.events.SubscriptionCancelled;
                reader.readMessage(value, proto.events.SubscriptionCancelled.deserializeBinaryFromReader);
                msg.setSubscriptionCancelled(value);
                break;
            case 48:
                var value = new proto.events.InvoiceCancelled;
                reader.readMessage(value, proto.events.InvoiceCancelled.deserializeBinaryFromReader);
                msg.setInvoiceCancelled(value);
                break;
            case 49:
                var value = new proto.events.ReloadDomain;
                reader.readMessage(value, proto.events.ReloadDomain.deserializeBinaryFromReader);
                msg.setReloadDomain(value);
                break;
            case 50:
                var value = new proto.events.CancelPaymentTransaction;
                reader.readMessage(value, proto.events.CancelPaymentTransaction.deserializeBinaryFromReader);
                msg.setCancelPaymentTransaction(value);
                break;
            case 51:
                var value = new proto.events.SmsReceived;
                reader.readMessage(value, proto.events.SmsReceived.deserializeBinaryFromReader);
                msg.setSmsReceived(value);
                break;
            case 52:
                var value = new proto.events.CustomerScored;
                reader.readMessage(value, proto.events.CustomerScored.deserializeBinaryFromReader);
                msg.setCustomerScored(value);
                break;
            case 53:
                var value = new proto.events.CustomerQualified;
                reader.readMessage(value, proto.events.CustomerQualified.deserializeBinaryFromReader);
                msg.setCustomerQualified(value);
                break;
            case 54:
                var value = new proto.events.CustomerScoreDisqualified;
                reader.readMessage(value, proto.events.CustomerScoreDisqualified.deserializeBinaryFromReader);
                msg.setCustomerScoreDisqualified(value);
                break;
            case 55:
                var value = new proto.events.PaymentRefunded;
                reader.readMessage(value, proto.events.PaymentRefunded.deserializeBinaryFromReader);
                msg.setPaymentRefunded(value);
                break;
            case 56:
                var value = new proto.events.CustomerDataEnriched;
                reader.readMessage(value, proto.events.CustomerDataEnriched.deserializeBinaryFromReader);
                msg.setCustomerDataEnriched(value);
                break;
            case 57:
                var value = new $hOsJC.ReservationCreated;
                reader.readMessage(value, $hOsJC.ReservationCreated.deserializeBinaryFromReader);
                msg.setReservationCreated(value);
                break;
            case 58:
                var value = new $hOsJC.ReservationStatusUpdated;
                reader.readMessage(value, $hOsJC.ReservationStatusUpdated.deserializeBinaryFromReader);
                msg.setReservationStatusUpdated(value);
                break;
            case 59:
                var value = new $hOsJC.ProgramCreated;
                reader.readMessage(value, $hOsJC.ProgramCreated.deserializeBinaryFromReader);
                msg.setProgramCreated(value);
                break;
            case 60:
                var value = new $hOsJC.ColorOptionCreated;
                reader.readMessage(value, $hOsJC.ColorOptionCreated.deserializeBinaryFromReader);
                msg.setColorOptionCreated(value);
                break;
            case 61:
                var value = new $hOsJC.PricingOptionCreated;
                reader.readMessage(value, $hOsJC.PricingOptionCreated.deserializeBinaryFromReader);
                msg.setPricingOptionCreated(value);
                break;
            case 62:
                var value = new $hOsJC.PendingSubscriptionInitialized;
                reader.readMessage(value, $hOsJC.PendingSubscriptionInitialized.deserializeBinaryFromReader);
                msg.setPendingSubscriptionInitialized(value);
                break;
            case 63:
                var value = new $hOsJC.ReservationCancelled;
                reader.readMessage(value, $hOsJC.ReservationCancelled.deserializeBinaryFromReader);
                msg.setReservationCancelled(value);
                break;
            case 64:
                var value = new proto.events.SyncIngestion;
                reader.readMessage(value, proto.events.SyncIngestion.deserializeBinaryFromReader);
                msg.setSyncIngestion(value);
                break;
            case 65:
                var value = new $9YICB.Ingestion;
                reader.readMessage(value, $9YICB.Ingestion.deserializeBinaryFromReader);
                msg.setVehicleIngestion(value);
                break;
            case 66:
                var value = new $9YICB.VehicleUpdated;
                reader.readMessage(value, $9YICB.VehicleUpdated.deserializeBinaryFromReader);
                msg.setVehicleUpdated(value);
                break;
            case 67:
                var value = new $9YICB.VehicleDeleted;
                reader.readMessage(value, $9YICB.VehicleDeleted.deserializeBinaryFromReader);
                msg.setVehicleDeleted(value);
                break;
            case 68:
                var value = new $hOsJC.ProcessDueStatements;
                reader.readMessage(value, $hOsJC.ProcessDueStatements.deserializeBinaryFromReader);
                msg.setProcessDueStatements(value);
                break;
            case 69:
                var value = new $hOsJC.StatementDue;
                reader.readMessage(value, $hOsJC.StatementDue.deserializeBinaryFromReader);
                msg.setStatementDue(value);
                break;
            case 70:
                var value = new $hOsJC.SubscriptionActivated;
                reader.readMessage(value, $hOsJC.SubscriptionActivated.deserializeBinaryFromReader);
                msg.setSubscriptionActivated(value);
                break;
            case 71:
                var value = new $c17Fn.CustomerPhoneUpdated;
                reader.readMessage(value, $c17Fn.CustomerPhoneUpdated.deserializeBinaryFromReader);
                msg.setCustomerPhoneUpdated(value);
                break;
            case 72:
                var value = new $26u10.Promotion;
                reader.readMessage(value, $26u10.Promotion.deserializeBinaryFromReader);
                msg.setPromotionCreated(value);
                break;
            case 73:
                var value = new $26u10.Promotion;
                reader.readMessage(value, $26u10.Promotion.deserializeBinaryFromReader);
                msg.setPromotionUpdated(value);
                break;
            case 74:
                var value = new $26u10.PromotionActivity;
                reader.readMessage(value, $26u10.PromotionActivity.deserializeBinaryFromReader);
                msg.setPromotionActivity(value);
                break;
            case 75:
                var value = new $26u10.DraftOrderUpdated;
                reader.readMessage(value, $26u10.DraftOrderUpdated.deserializeBinaryFromReader);
                msg.setDraftOrderUpdated(value);
                break;
            case 76:
                var value = new $hOsJC.ReservationOptionsUpdated;
                reader.readMessage(value, $hOsJC.ReservationOptionsUpdated.deserializeBinaryFromReader);
                msg.setReservationOptionsUpdated(value);
                break;
            case 77:
                var value = new $26u10.PromotionPartner;
                reader.readMessage(value, $26u10.PromotionPartner.deserializeBinaryFromReader);
                msg.setPromotionPartnerCreated(value);
                break;
            case 78:
                var value = new $26u10.PromotionPartner;
                reader.readMessage(value, $26u10.PromotionPartner.deserializeBinaryFromReader);
                msg.setPromotionPartnerUpdated(value);
                break;
            case 79:
                var value = new $9YICB.LocationUpdated;
                reader.readMessage(value, $9YICB.LocationUpdated.deserializeBinaryFromReader);
                msg.setLocationUpdated(value);
                break;
            case 80:
                var value = new $hOsJC.SubscriptionUpdated;
                reader.readMessage(value, $hOsJC.SubscriptionUpdated.deserializeBinaryFromReader);
                msg.setSubscriptionUpdated(value);
                break;
            case 81:
                var value = new $9YICB.OdometerUpdate;
                reader.readMessage(value, $9YICB.OdometerUpdate.deserializeBinaryFromReader);
                msg.setOdometerUpdate(value);
                break;
            case 82:
                var value = new $9YICB.LocationUpdate;
                reader.readMessage(value, $9YICB.LocationUpdate.deserializeBinaryFromReader);
                msg.setLocationUpdate(value);
                break;
            case 83:
                var value = new $fcTGK.AppointmentCreated;
                reader.readMessage(value, $fcTGK.AppointmentCreated.deserializeBinaryFromReader);
                msg.setAppointmentCreated(value);
                break;
            case 84:
                var value = new $fcTGK.AppointmentTypeUpdated;
                reader.readMessage(value, $fcTGK.AppointmentTypeUpdated.deserializeBinaryFromReader);
                msg.setAppointmentTypeUpdated(value);
                break;
            case 85:
                var value = new $fcTGK.AppointmentStatusUpdated;
                reader.readMessage(value, $fcTGK.AppointmentStatusUpdated.deserializeBinaryFromReader);
                msg.setAppointmentStatusUpdated(value);
                break;
            case 86:
                var value = new $fcTGK.AppointmentVehicleUpdated;
                reader.readMessage(value, $fcTGK.AppointmentVehicleUpdated.deserializeBinaryFromReader);
                msg.setAppointmentVehicleUpdated(value);
                break;
            case 87:
                var value = new $fcTGK.AvailabilityCreated;
                reader.readMessage(value, $fcTGK.AvailabilityCreated.deserializeBinaryFromReader);
                msg.setAvailabilityCreated(value);
                break;
            case 88:
                var value = new $fcTGK.AppointmentCancelled;
                reader.readMessage(value, $fcTGK.AppointmentCancelled.deserializeBinaryFromReader);
                msg.setAppointmentCancelled(value);
                break;
            case 89:
                var value = new $hOsJC.ProgramPricingOptionsUpdated;
                reader.readMessage(value, $hOsJC.ProgramPricingOptionsUpdated.deserializeBinaryFromReader);
                msg.setProgramPricingOptionsUpdated(value);
                break;
            case 90:
                var value = new $fcTGK.AppointmentUpdated;
                reader.readMessage(value, $fcTGK.AppointmentUpdated.deserializeBinaryFromReader);
                msg.setAppointmentUpdated(value);
                break;
            case 91:
                var value = new $9YICB.VehiclePreferencesNotAvailable;
                reader.readMessage(value, $9YICB.VehiclePreferencesNotAvailable.deserializeBinaryFromReader);
                msg.setVehiclePreferencesNotAvailable(value);
                break;
            case 92:
                var value = new $3DbSe.SendNotifications;
                reader.readMessage(value, $3DbSe.SendNotifications.deserializeBinaryFromReader);
                msg.setSendNotifications(value);
                break;
            case 93:
                var value = new $3DbSe.NotificationReceived;
                reader.readMessage(value, $3DbSe.NotificationReceived.deserializeBinaryFromReader);
                msg.setNotificationsReceived(value);
                break;
            case 94:
                var value = new $3DbSe.NotificationStatusUpdated;
                reader.readMessage(value, $3DbSe.NotificationStatusUpdated.deserializeBinaryFromReader);
                msg.setNotificationStatusUpdated(value);
                break;
            case 100:
                var value = new $1oiLe.DealershipCreated;
                reader.readMessage(value, $1oiLe.DealershipCreated.deserializeBinaryFromReader);
                msg.setDealershipCreated(value);
                break;
            case 101:
                var value = new $1oiLe.DealershipUserCreated;
                reader.readMessage(value, $1oiLe.DealershipUserCreated.deserializeBinaryFromReader);
                msg.setDealershipUserCreated(value);
                break;
            case 102:
                var value = new $c17Fn.CustomerBankAccountVerified;
                reader.readMessage(value, $c17Fn.CustomerBankAccountVerified.deserializeBinaryFromReader);
                msg.setCustomerBankVerified(value);
                break;
            case 103:
                var value = new $ghA5X.IsQualifiedForLiberty;
                reader.readMessage(value, $ghA5X.IsQualifiedForLiberty.deserializeBinaryFromReader);
                msg.setIsQualifiedForLiberty(value);
                break;
            case 104:
                var value = new $ghA5X.InsurancePolicyCreated;
                reader.readMessage(value, $ghA5X.InsurancePolicyCreated.deserializeBinaryFromReader);
                msg.setInsurancePolicyCreated(value);
                break;
            case 105:
                var value = new $1oiLe.DealershipUserUpdated;
                reader.readMessage(value, $1oiLe.DealershipUserUpdated.deserializeBinaryFromReader);
                msg.setDealershipUserUpdated(value);
                break;
            case 106:
                var value = new $1oiLe.DealershipUpdated;
                reader.readMessage(value, $1oiLe.DealershipUpdated.deserializeBinaryFromReader);
                msg.setDealershipUpdated(value);
                break;
            case 107:
                var value = new $c17Fn.PhoneNumberEntered;
                reader.readMessage(value, $c17Fn.PhoneNumberEntered.deserializeBinaryFromReader);
                msg.setPhoneNumberEntered(value);
                break;
            case 108:
                var value = new $c17Fn.LicenseInfoSubmitted;
                reader.readMessage(value, $c17Fn.LicenseInfoSubmitted.deserializeBinaryFromReader);
                msg.setLicenseInfoSubmitted(value);
                break;
            case 109:
                var value = new $9YICB.VehicleInfleetingUpdated;
                reader.readMessage(value, $9YICB.VehicleInfleetingUpdated.deserializeBinaryFromReader);
                msg.setVehicleInfleetingUpdated(value);
                break;
            case 110:
                var value = new proto.events.ExtendInsurancePolicies;
                reader.readMessage(value, proto.events.ExtendInsurancePolicies.deserializeBinaryFromReader);
                msg.setExtendInsurancePolicies(value);
                break;
            case 111:
                var value = new $ghA5X.InsurancePolicyUpdated;
                reader.readMessage(value, $ghA5X.InsurancePolicyUpdated.deserializeBinaryFromReader);
                msg.setInsurancePolicyUpdated(value);
                break;
            case 112:
                var value = new proto.events.MilesPurchased;
                reader.readMessage(value, proto.events.MilesPurchased.deserializeBinaryFromReader);
                msg.setMilesPurchased(value);
                break;
            case 113:
                var value = new $ghA5X.InsurancePolicyCancelled;
                reader.readMessage(value, $ghA5X.InsurancePolicyCancelled.deserializeBinaryFromReader);
                msg.setInsurancePolicyCancelled(value);
                break;
            case 114:
                var value = new proto.events.SubscriptionVehicleChange;
                reader.readMessage(value, proto.events.SubscriptionVehicleChange.deserializeBinaryFromReader);
                msg.setSubscriptionVehicleChange(value);
                break;
            case 115:
                var value = new proto.events.SubscriptionVehicleReturned;
                reader.readMessage(value, proto.events.SubscriptionVehicleReturned.deserializeBinaryFromReader);
                msg.setSubscriptionVehicleReturned(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.Event.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.Event.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.Event} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.Event.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCategory();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getDomain();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getDomainId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getTraceId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(7, f);
    f = message.getModelVersion();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getCustomerCreated();
    if (f != null) writer.writeMessage(9, f, proto.events.CustomerCreated.serializeBinaryToWriter);
    f = message.getCustomerInfoUpdated();
    if (f != null) writer.writeMessage(10, f, proto.events.CustomerInfoUpdated.serializeBinaryToWriter);
    f = message.getCustomerStateUpdated();
    if (f != null) writer.writeMessage(11, f, proto.events.CustomerStateUpdated.serializeBinaryToWriter);
    f = message.getCustomerFailureStateUpdated();
    if (f != null) writer.writeMessage(12, f, proto.events.CustomerFailureStateUpdated.serializeBinaryToWriter);
    f = message.getCustomerActivityUpdated();
    if (f != null) writer.writeMessage(13, f, proto.events.CustomerActivityUpdated.serializeBinaryToWriter);
    f = message.getActivityStateUpdated();
    if (f != null) writer.writeMessage(14, f, proto.events.ActivityStateUpdated.serializeBinaryToWriter);
    f = message.getVendorAccountUpdated();
    if (f != null) writer.writeMessage(15, f, proto.events.VendorAccountUpdated.serializeBinaryToWriter);
    f = message.getCustomerDeleted();
    if (f != null) writer.writeMessage(16, f, proto.events.CustomerDeleted.serializeBinaryToWriter);
    f = message.getPickupDateSet();
    if (f != null) writer.writeMessage(17, f, proto.events.PickupDateSet.serializeBinaryToWriter);
    f = message.getVehiclePrepickup();
    if (f != null) writer.writeMessage(18, f, proto.events.VehiclePrePickup.serializeBinaryToWriter);
    f = message.getVehiclePickup();
    if (f != null) writer.writeMessage(19, f, proto.events.VehiclePickup.serializeBinaryToWriter);
    f = message.getPrepickupAuth();
    if (f != null) writer.writeMessage(20, f, proto.events.PrepickupAuth.serializeBinaryToWriter);
    f = message.getPickupPayment();
    if (f != null) writer.writeMessage(21, f, proto.events.PickupPayment.serializeBinaryToWriter);
    f = message.getTransferVehicle();
    if (f != null) writer.writeMessage(22, f, proto.events.TransferVehicle.serializeBinaryToWriter);
    f = message.getVehicleCreated();
    if (f != null) writer.writeMessage(23, f, proto.events.VehicleCreated.serializeBinaryToWriter);
    f = message.getTripReceived();
    if (f != null) writer.writeMessage(24, f, proto.events.TripReceived.serializeBinaryToWriter);
    f = message.getCollisionReceived();
    if (f != null) writer.writeMessage(25, f, proto.events.CollisionReceived.serializeBinaryToWriter);
    f = message.getNotification();
    if (f != null) writer.writeMessage(26, f, proto.events.Notification.serializeBinaryToWriter);
    f = message.getInvoiceReady();
    if (f != null) writer.writeMessage(27, f, proto.events.InvoiceReady.serializeBinaryToWriter);
    f = message.getOdometerUpdated();
    if (f != null) writer.writeMessage(28, f, proto.events.OdometerUpdated.serializeBinaryToWriter);
    f = message.getOdometerSet();
    if (f != null) writer.writeMessage(29, f, proto.events.OdometerSet.serializeBinaryToWriter);
    f = message.getStatementActivity();
    if (f != null) writer.writeMessage(30, f, proto.events.StatementActivity.serializeBinaryToWriter);
    f = message.getPaymentActivity();
    if (f != null) writer.writeMessage(31, f, proto.events.PaymentActivity.serializeBinaryToWriter);
    f = message.getVehicleStateUpdated();
    if (f != null) writer.writeMessage(32, f, proto.events.VehicleStateUpdated.serializeBinaryToWriter);
    f = message.getVehicleActivityUpdated();
    if (f != null) writer.writeMessage(33, f, proto.events.VehicleActivityUpdated.serializeBinaryToWriter);
    f = message.getVehicleActivityStateUpdated();
    if (f != null) writer.writeMessage(34, f, proto.events.VehicleActivityStateUpdated.serializeBinaryToWriter);
    f = message.getVehicleActivityFailureUpdated();
    if (f != null) writer.writeMessage(35, f, proto.events.VehicleActivityFailureUpdated.serializeBinaryToWriter);
    f = message.getCustomerInsuranceUpdated();
    if (f != null) writer.writeMessage(36, f, proto.events.CustomerInsuranceUpdated.serializeBinaryToWriter);
    f = message.getSyncDealerships();
    if (f != null) writer.writeMessage(37, f, proto.events.SyncDealerships.serializeBinaryToWriter);
    f = message.getInvoiceToBePaid();
    if (f != null) writer.writeMessage(38, f, proto.events.InvoiceToBePaid.serializeBinaryToWriter);
    f = message.getDocumentAdded();
    if (f != null) writer.writeMessage(39, f, proto.events.DocumentAdded.serializeBinaryToWriter);
    f = message.getDocumentDeleted();
    if (f != null) writer.writeMessage(40, f, proto.events.DocumentDeleted.serializeBinaryToWriter);
    f = message.getOfferSubmitted();
    if (f != null) writer.writeMessage(41, f, proto.events.OfferSubmitted.serializeBinaryToWriter);
    f = message.getSubscriptionContractAdded();
    if (f != null) writer.writeMessage(42, f, proto.events.SubscriptionContractAdded.serializeBinaryToWriter);
    f = message.getVehicleInspectionCompleted();
    if (f != null) writer.writeMessage(43, f, proto.events.VehicleInspectionCompleted.serializeBinaryToWriter);
    f = message.getVehicleInspectionStarted();
    if (f != null) writer.writeMessage(44, f, proto.events.VehicleInspectionStarted.serializeBinaryToWriter);
    f = message.getOfferResponse();
    if (f != null) writer.writeMessage(45, f, proto.events.OfferResponse.serializeBinaryToWriter);
    f = message.getVehicleTosAccepted();
    if (f != null) writer.writeMessage(46, f, proto.events.VehicleTosAccepted.serializeBinaryToWriter);
    f = message.getSubscriptionCancelled();
    if (f != null) writer.writeMessage(47, f, proto.events.SubscriptionCancelled.serializeBinaryToWriter);
    f = message.getInvoiceCancelled();
    if (f != null) writer.writeMessage(48, f, proto.events.InvoiceCancelled.serializeBinaryToWriter);
    f = message.getReloadDomain();
    if (f != null) writer.writeMessage(49, f, proto.events.ReloadDomain.serializeBinaryToWriter);
    f = message.getCancelPaymentTransaction();
    if (f != null) writer.writeMessage(50, f, proto.events.CancelPaymentTransaction.serializeBinaryToWriter);
    f = message.getSmsReceived();
    if (f != null) writer.writeMessage(51, f, proto.events.SmsReceived.serializeBinaryToWriter);
    f = message.getCustomerScored();
    if (f != null) writer.writeMessage(52, f, proto.events.CustomerScored.serializeBinaryToWriter);
    f = message.getCustomerQualified();
    if (f != null) writer.writeMessage(53, f, proto.events.CustomerQualified.serializeBinaryToWriter);
    f = message.getCustomerScoreDisqualified();
    if (f != null) writer.writeMessage(54, f, proto.events.CustomerScoreDisqualified.serializeBinaryToWriter);
    f = message.getPaymentRefunded();
    if (f != null) writer.writeMessage(55, f, proto.events.PaymentRefunded.serializeBinaryToWriter);
    f = message.getCustomerDataEnriched();
    if (f != null) writer.writeMessage(56, f, proto.events.CustomerDataEnriched.serializeBinaryToWriter);
    f = message.getReservationCreated();
    if (f != null) writer.writeMessage(57, f, $hOsJC.ReservationCreated.serializeBinaryToWriter);
    f = message.getReservationStatusUpdated();
    if (f != null) writer.writeMessage(58, f, $hOsJC.ReservationStatusUpdated.serializeBinaryToWriter);
    f = message.getProgramCreated();
    if (f != null) writer.writeMessage(59, f, $hOsJC.ProgramCreated.serializeBinaryToWriter);
    f = message.getColorOptionCreated();
    if (f != null) writer.writeMessage(60, f, $hOsJC.ColorOptionCreated.serializeBinaryToWriter);
    f = message.getPricingOptionCreated();
    if (f != null) writer.writeMessage(61, f, $hOsJC.PricingOptionCreated.serializeBinaryToWriter);
    f = message.getPendingSubscriptionInitialized();
    if (f != null) writer.writeMessage(62, f, $hOsJC.PendingSubscriptionInitialized.serializeBinaryToWriter);
    f = message.getReservationCancelled();
    if (f != null) writer.writeMessage(63, f, $hOsJC.ReservationCancelled.serializeBinaryToWriter);
    f = message.getSyncIngestion();
    if (f != null) writer.writeMessage(64, f, proto.events.SyncIngestion.serializeBinaryToWriter);
    f = message.getVehicleIngestion();
    if (f != null) writer.writeMessage(65, f, $9YICB.Ingestion.serializeBinaryToWriter);
    f = message.getVehicleUpdated();
    if (f != null) writer.writeMessage(66, f, $9YICB.VehicleUpdated.serializeBinaryToWriter);
    f = message.getVehicleDeleted();
    if (f != null) writer.writeMessage(67, f, $9YICB.VehicleDeleted.serializeBinaryToWriter);
    f = message.getProcessDueStatements();
    if (f != null) writer.writeMessage(68, f, $hOsJC.ProcessDueStatements.serializeBinaryToWriter);
    f = message.getStatementDue();
    if (f != null) writer.writeMessage(69, f, $hOsJC.StatementDue.serializeBinaryToWriter);
    f = message.getSubscriptionActivated();
    if (f != null) writer.writeMessage(70, f, $hOsJC.SubscriptionActivated.serializeBinaryToWriter);
    f = message.getCustomerPhoneUpdated();
    if (f != null) writer.writeMessage(71, f, $c17Fn.CustomerPhoneUpdated.serializeBinaryToWriter);
    f = message.getPromotionCreated();
    if (f != null) writer.writeMessage(72, f, $26u10.Promotion.serializeBinaryToWriter);
    f = message.getPromotionUpdated();
    if (f != null) writer.writeMessage(73, f, $26u10.Promotion.serializeBinaryToWriter);
    f = message.getPromotionActivity();
    if (f != null) writer.writeMessage(74, f, $26u10.PromotionActivity.serializeBinaryToWriter);
    f = message.getDraftOrderUpdated();
    if (f != null) writer.writeMessage(75, f, $26u10.DraftOrderUpdated.serializeBinaryToWriter);
    f = message.getReservationOptionsUpdated();
    if (f != null) writer.writeMessage(76, f, $hOsJC.ReservationOptionsUpdated.serializeBinaryToWriter);
    f = message.getPromotionPartnerCreated();
    if (f != null) writer.writeMessage(77, f, $26u10.PromotionPartner.serializeBinaryToWriter);
    f = message.getPromotionPartnerUpdated();
    if (f != null) writer.writeMessage(78, f, $26u10.PromotionPartner.serializeBinaryToWriter);
    f = message.getLocationUpdated();
    if (f != null) writer.writeMessage(79, f, $9YICB.LocationUpdated.serializeBinaryToWriter);
    f = message.getSubscriptionUpdated();
    if (f != null) writer.writeMessage(80, f, $hOsJC.SubscriptionUpdated.serializeBinaryToWriter);
    f = message.getOdometerUpdate();
    if (f != null) writer.writeMessage(81, f, $9YICB.OdometerUpdate.serializeBinaryToWriter);
    f = message.getLocationUpdate();
    if (f != null) writer.writeMessage(82, f, $9YICB.LocationUpdate.serializeBinaryToWriter);
    f = message.getAppointmentCreated();
    if (f != null) writer.writeMessage(83, f, $fcTGK.AppointmentCreated.serializeBinaryToWriter);
    f = message.getAppointmentTypeUpdated();
    if (f != null) writer.writeMessage(84, f, $fcTGK.AppointmentTypeUpdated.serializeBinaryToWriter);
    f = message.getAppointmentStatusUpdated();
    if (f != null) writer.writeMessage(85, f, $fcTGK.AppointmentStatusUpdated.serializeBinaryToWriter);
    f = message.getAppointmentVehicleUpdated();
    if (f != null) writer.writeMessage(86, f, $fcTGK.AppointmentVehicleUpdated.serializeBinaryToWriter);
    f = message.getAvailabilityCreated();
    if (f != null) writer.writeMessage(87, f, $fcTGK.AvailabilityCreated.serializeBinaryToWriter);
    f = message.getAppointmentCancelled();
    if (f != null) writer.writeMessage(88, f, $fcTGK.AppointmentCancelled.serializeBinaryToWriter);
    f = message.getProgramPricingOptionsUpdated();
    if (f != null) writer.writeMessage(89, f, $hOsJC.ProgramPricingOptionsUpdated.serializeBinaryToWriter);
    f = message.getAppointmentUpdated();
    if (f != null) writer.writeMessage(90, f, $fcTGK.AppointmentUpdated.serializeBinaryToWriter);
    f = message.getVehiclePreferencesNotAvailable();
    if (f != null) writer.writeMessage(91, f, $9YICB.VehiclePreferencesNotAvailable.serializeBinaryToWriter);
    f = message.getSendNotifications();
    if (f != null) writer.writeMessage(92, f, $3DbSe.SendNotifications.serializeBinaryToWriter);
    f = message.getNotificationsReceived();
    if (f != null) writer.writeMessage(93, f, $3DbSe.NotificationReceived.serializeBinaryToWriter);
    f = message.getNotificationStatusUpdated();
    if (f != null) writer.writeMessage(94, f, $3DbSe.NotificationStatusUpdated.serializeBinaryToWriter);
    f = message.getDealershipCreated();
    if (f != null) writer.writeMessage(100, f, $1oiLe.DealershipCreated.serializeBinaryToWriter);
    f = message.getDealershipUserCreated();
    if (f != null) writer.writeMessage(101, f, $1oiLe.DealershipUserCreated.serializeBinaryToWriter);
    f = message.getCustomerBankVerified();
    if (f != null) writer.writeMessage(102, f, $c17Fn.CustomerBankAccountVerified.serializeBinaryToWriter);
    f = message.getIsQualifiedForLiberty();
    if (f != null) writer.writeMessage(103, f, $ghA5X.IsQualifiedForLiberty.serializeBinaryToWriter);
    f = message.getInsurancePolicyCreated();
    if (f != null) writer.writeMessage(104, f, $ghA5X.InsurancePolicyCreated.serializeBinaryToWriter);
    f = message.getDealershipUserUpdated();
    if (f != null) writer.writeMessage(105, f, $1oiLe.DealershipUserUpdated.serializeBinaryToWriter);
    f = message.getDealershipUpdated();
    if (f != null) writer.writeMessage(106, f, $1oiLe.DealershipUpdated.serializeBinaryToWriter);
    f = message.getPhoneNumberEntered();
    if (f != null) writer.writeMessage(107, f, $c17Fn.PhoneNumberEntered.serializeBinaryToWriter);
    f = message.getLicenseInfoSubmitted();
    if (f != null) writer.writeMessage(108, f, $c17Fn.LicenseInfoSubmitted.serializeBinaryToWriter);
    f = message.getVehicleInfleetingUpdated();
    if (f != null) writer.writeMessage(109, f, $9YICB.VehicleInfleetingUpdated.serializeBinaryToWriter);
    f = message.getExtendInsurancePolicies();
    if (f != null) writer.writeMessage(110, f, proto.events.ExtendInsurancePolicies.serializeBinaryToWriter);
    f = message.getInsurancePolicyUpdated();
    if (f != null) writer.writeMessage(111, f, $ghA5X.InsurancePolicyUpdated.serializeBinaryToWriter);
    f = message.getMilesPurchased();
    if (f != null) writer.writeMessage(112, f, proto.events.MilesPurchased.serializeBinaryToWriter);
    f = message.getInsurancePolicyCancelled();
    if (f != null) writer.writeMessage(113, f, $ghA5X.InsurancePolicyCancelled.serializeBinaryToWriter);
    f = message.getSubscriptionVehicleChange();
    if (f != null) writer.writeMessage(114, f, proto.events.SubscriptionVehicleChange.serializeBinaryToWriter);
    f = message.getSubscriptionVehicleReturned();
    if (f != null) writer.writeMessage(115, f, proto.events.SubscriptionVehicleReturned.serializeBinaryToWriter);
};
/**
 * optional EventCategory category = 1;
 * @return {!proto.events.EventCategory}
 */ proto.events.Event.prototype.getCategory = function() {
    return /** @type {!proto.events.EventCategory} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.events.EventCategory} value
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.setCategory = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional Domain domain = 2;
 * @return {!proto.events.Domain}
 */ proto.events.Event.prototype.getDomain = function() {
    return /** @type {!proto.events.Domain} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.events.Domain} value
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.setDomain = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string domain_id = 3;
 * @return {string}
 */ proto.events.Event.prototype.getDomainId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.setDomainId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string name = 4;
 * @return {string}
 */ proto.events.Event.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 timestamp = 5;
 * @return {number}
 */ proto.events.Event.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string trace_id = 6;
 * @return {string}
 */ proto.events.Event.prototype.getTraceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.setTraceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int64 version = 7;
 * @return {number}
 */ proto.events.Event.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 model_version = 8;
 * @return {number}
 */ proto.events.Event.prototype.getModelVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.setModelVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional CustomerCreated customer_created = 9;
 * @return {?proto.events.CustomerCreated}
 */ proto.events.Event.prototype.getCustomerCreated = function() {
    return /** @type{?proto.events.CustomerCreated} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerCreated, 9);
};
/**
 * @param {?proto.events.CustomerCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 9, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerCreated = function() {
    return this.setCustomerCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerCreated = function() {
    return $8M67s.Message.getField(this, 9) != null;
};
/**
 * optional CustomerInfoUpdated customer_info_updated = 10;
 * @return {?proto.events.CustomerInfoUpdated}
 */ proto.events.Event.prototype.getCustomerInfoUpdated = function() {
    return /** @type{?proto.events.CustomerInfoUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerInfoUpdated, 10);
};
/**
 * @param {?proto.events.CustomerInfoUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerInfoUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 10, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerInfoUpdated = function() {
    return this.setCustomerInfoUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerInfoUpdated = function() {
    return $8M67s.Message.getField(this, 10) != null;
};
/**
 * optional CustomerStateUpdated customer_state_updated = 11;
 * @return {?proto.events.CustomerStateUpdated}
 */ proto.events.Event.prototype.getCustomerStateUpdated = function() {
    return /** @type{?proto.events.CustomerStateUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerStateUpdated, 11);
};
/**
 * @param {?proto.events.CustomerStateUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerStateUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 11, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerStateUpdated = function() {
    return this.setCustomerStateUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerStateUpdated = function() {
    return $8M67s.Message.getField(this, 11) != null;
};
/**
 * optional CustomerFailureStateUpdated customer_failure_state_updated = 12;
 * @return {?proto.events.CustomerFailureStateUpdated}
 */ proto.events.Event.prototype.getCustomerFailureStateUpdated = function() {
    return /** @type{?proto.events.CustomerFailureStateUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerFailureStateUpdated, 12);
};
/**
 * @param {?proto.events.CustomerFailureStateUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerFailureStateUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 12, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerFailureStateUpdated = function() {
    return this.setCustomerFailureStateUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerFailureStateUpdated = function() {
    return $8M67s.Message.getField(this, 12) != null;
};
/**
 * optional CustomerActivityUpdated customer_activity_updated = 13;
 * @return {?proto.events.CustomerActivityUpdated}
 */ proto.events.Event.prototype.getCustomerActivityUpdated = function() {
    return /** @type{?proto.events.CustomerActivityUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerActivityUpdated, 13);
};
/**
 * @param {?proto.events.CustomerActivityUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerActivityUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 13, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerActivityUpdated = function() {
    return this.setCustomerActivityUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerActivityUpdated = function() {
    return $8M67s.Message.getField(this, 13) != null;
};
/**
 * optional ActivityStateUpdated activity_state_updated = 14;
 * @return {?proto.events.ActivityStateUpdated}
 */ proto.events.Event.prototype.getActivityStateUpdated = function() {
    return /** @type{?proto.events.ActivityStateUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.ActivityStateUpdated, 14);
};
/**
 * @param {?proto.events.ActivityStateUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setActivityStateUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 14, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearActivityStateUpdated = function() {
    return this.setActivityStateUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasActivityStateUpdated = function() {
    return $8M67s.Message.getField(this, 14) != null;
};
/**
 * optional VendorAccountUpdated vendor_account_updated = 15;
 * @return {?proto.events.VendorAccountUpdated}
 */ proto.events.Event.prototype.getVendorAccountUpdated = function() {
    return /** @type{?proto.events.VendorAccountUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.VendorAccountUpdated, 15);
};
/**
 * @param {?proto.events.VendorAccountUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVendorAccountUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 15, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVendorAccountUpdated = function() {
    return this.setVendorAccountUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVendorAccountUpdated = function() {
    return $8M67s.Message.getField(this, 15) != null;
};
/**
 * optional CustomerDeleted customer_deleted = 16;
 * @return {?proto.events.CustomerDeleted}
 */ proto.events.Event.prototype.getCustomerDeleted = function() {
    return /** @type{?proto.events.CustomerDeleted} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerDeleted, 16);
};
/**
 * @param {?proto.events.CustomerDeleted|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerDeleted = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 16, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerDeleted = function() {
    return this.setCustomerDeleted(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerDeleted = function() {
    return $8M67s.Message.getField(this, 16) != null;
};
/**
 * optional PickupDateSet pickup_date_set = 17;
 * @return {?proto.events.PickupDateSet}
 */ proto.events.Event.prototype.getPickupDateSet = function() {
    return /** @type{?proto.events.PickupDateSet} */ $8M67s.Message.getWrapperField(this, proto.events.PickupDateSet, 17);
};
/**
 * @param {?proto.events.PickupDateSet|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPickupDateSet = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 17, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPickupDateSet = function() {
    return this.setPickupDateSet(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPickupDateSet = function() {
    return $8M67s.Message.getField(this, 17) != null;
};
/**
 * optional VehiclePrePickup vehicle_prepickup = 18;
 * @return {?proto.events.VehiclePrePickup}
 */ proto.events.Event.prototype.getVehiclePrepickup = function() {
    return /** @type{?proto.events.VehiclePrePickup} */ $8M67s.Message.getWrapperField(this, proto.events.VehiclePrePickup, 18);
};
/**
 * @param {?proto.events.VehiclePrePickup|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehiclePrepickup = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 18, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehiclePrepickup = function() {
    return this.setVehiclePrepickup(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehiclePrepickup = function() {
    return $8M67s.Message.getField(this, 18) != null;
};
/**
 * optional VehiclePickup vehicle_pickup = 19;
 * @return {?proto.events.VehiclePickup}
 */ proto.events.Event.prototype.getVehiclePickup = function() {
    return /** @type{?proto.events.VehiclePickup} */ $8M67s.Message.getWrapperField(this, proto.events.VehiclePickup, 19);
};
/**
 * @param {?proto.events.VehiclePickup|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehiclePickup = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 19, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehiclePickup = function() {
    return this.setVehiclePickup(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehiclePickup = function() {
    return $8M67s.Message.getField(this, 19) != null;
};
/**
 * optional PrepickupAuth prepickup_auth = 20;
 * @return {?proto.events.PrepickupAuth}
 */ proto.events.Event.prototype.getPrepickupAuth = function() {
    return /** @type{?proto.events.PrepickupAuth} */ $8M67s.Message.getWrapperField(this, proto.events.PrepickupAuth, 20);
};
/**
 * @param {?proto.events.PrepickupAuth|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPrepickupAuth = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 20, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPrepickupAuth = function() {
    return this.setPrepickupAuth(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPrepickupAuth = function() {
    return $8M67s.Message.getField(this, 20) != null;
};
/**
 * optional PickupPayment pickup_payment = 21;
 * @return {?proto.events.PickupPayment}
 */ proto.events.Event.prototype.getPickupPayment = function() {
    return /** @type{?proto.events.PickupPayment} */ $8M67s.Message.getWrapperField(this, proto.events.PickupPayment, 21);
};
/**
 * @param {?proto.events.PickupPayment|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPickupPayment = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 21, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPickupPayment = function() {
    return this.setPickupPayment(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPickupPayment = function() {
    return $8M67s.Message.getField(this, 21) != null;
};
/**
 * optional TransferVehicle transfer_vehicle = 22;
 * @return {?proto.events.TransferVehicle}
 */ proto.events.Event.prototype.getTransferVehicle = function() {
    return /** @type{?proto.events.TransferVehicle} */ $8M67s.Message.getWrapperField(this, proto.events.TransferVehicle, 22);
};
/**
 * @param {?proto.events.TransferVehicle|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setTransferVehicle = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 22, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearTransferVehicle = function() {
    return this.setTransferVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasTransferVehicle = function() {
    return $8M67s.Message.getField(this, 22) != null;
};
/**
 * optional VehicleCreated vehicle_created = 23;
 * @return {?proto.events.VehicleCreated}
 */ proto.events.Event.prototype.getVehicleCreated = function() {
    return /** @type{?proto.events.VehicleCreated} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleCreated, 23);
};
/**
 * @param {?proto.events.VehicleCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 23, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleCreated = function() {
    return this.setVehicleCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleCreated = function() {
    return $8M67s.Message.getField(this, 23) != null;
};
/**
 * optional TripReceived trip_received = 24;
 * @return {?proto.events.TripReceived}
 */ proto.events.Event.prototype.getTripReceived = function() {
    return /** @type{?proto.events.TripReceived} */ $8M67s.Message.getWrapperField(this, proto.events.TripReceived, 24);
};
/**
 * @param {?proto.events.TripReceived|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setTripReceived = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 24, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearTripReceived = function() {
    return this.setTripReceived(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasTripReceived = function() {
    return $8M67s.Message.getField(this, 24) != null;
};
/**
 * optional CollisionReceived collision_received = 25;
 * @return {?proto.events.CollisionReceived}
 */ proto.events.Event.prototype.getCollisionReceived = function() {
    return /** @type{?proto.events.CollisionReceived} */ $8M67s.Message.getWrapperField(this, proto.events.CollisionReceived, 25);
};
/**
 * @param {?proto.events.CollisionReceived|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCollisionReceived = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 25, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCollisionReceived = function() {
    return this.setCollisionReceived(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCollisionReceived = function() {
    return $8M67s.Message.getField(this, 25) != null;
};
/**
 * optional Notification notification = 26;
 * @return {?proto.events.Notification}
 */ proto.events.Event.prototype.getNotification = function() {
    return /** @type{?proto.events.Notification} */ $8M67s.Message.getWrapperField(this, proto.events.Notification, 26);
};
/**
 * @param {?proto.events.Notification|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setNotification = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 26, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearNotification = function() {
    return this.setNotification(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasNotification = function() {
    return $8M67s.Message.getField(this, 26) != null;
};
/**
 * optional InvoiceReady invoice_ready = 27;
 * @return {?proto.events.InvoiceReady}
 */ proto.events.Event.prototype.getInvoiceReady = function() {
    return /** @type{?proto.events.InvoiceReady} */ $8M67s.Message.getWrapperField(this, proto.events.InvoiceReady, 27);
};
/**
 * @param {?proto.events.InvoiceReady|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setInvoiceReady = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 27, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearInvoiceReady = function() {
    return this.setInvoiceReady(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasInvoiceReady = function() {
    return $8M67s.Message.getField(this, 27) != null;
};
/**
 * optional OdometerUpdated odometer_updated = 28;
 * @return {?proto.events.OdometerUpdated}
 */ proto.events.Event.prototype.getOdometerUpdated = function() {
    return /** @type{?proto.events.OdometerUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.OdometerUpdated, 28);
};
/**
 * @param {?proto.events.OdometerUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setOdometerUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 28, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearOdometerUpdated = function() {
    return this.setOdometerUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasOdometerUpdated = function() {
    return $8M67s.Message.getField(this, 28) != null;
};
/**
 * optional OdometerSet odometer_set = 29;
 * @return {?proto.events.OdometerSet}
 */ proto.events.Event.prototype.getOdometerSet = function() {
    return /** @type{?proto.events.OdometerSet} */ $8M67s.Message.getWrapperField(this, proto.events.OdometerSet, 29);
};
/**
 * @param {?proto.events.OdometerSet|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setOdometerSet = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 29, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearOdometerSet = function() {
    return this.setOdometerSet(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasOdometerSet = function() {
    return $8M67s.Message.getField(this, 29) != null;
};
/**
 * optional StatementActivity statement_activity = 30;
 * @return {?proto.events.StatementActivity}
 */ proto.events.Event.prototype.getStatementActivity = function() {
    return /** @type{?proto.events.StatementActivity} */ $8M67s.Message.getWrapperField(this, proto.events.StatementActivity, 30);
};
/**
 * @param {?proto.events.StatementActivity|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setStatementActivity = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 30, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearStatementActivity = function() {
    return this.setStatementActivity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasStatementActivity = function() {
    return $8M67s.Message.getField(this, 30) != null;
};
/**
 * optional PaymentActivity payment_activity = 31;
 * @return {?proto.events.PaymentActivity}
 */ proto.events.Event.prototype.getPaymentActivity = function() {
    return /** @type{?proto.events.PaymentActivity} */ $8M67s.Message.getWrapperField(this, proto.events.PaymentActivity, 31);
};
/**
 * @param {?proto.events.PaymentActivity|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPaymentActivity = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 31, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPaymentActivity = function() {
    return this.setPaymentActivity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPaymentActivity = function() {
    return $8M67s.Message.getField(this, 31) != null;
};
/**
 * optional VehicleStateUpdated vehicle_state_updated = 32;
 * @return {?proto.events.VehicleStateUpdated}
 */ proto.events.Event.prototype.getVehicleStateUpdated = function() {
    return /** @type{?proto.events.VehicleStateUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleStateUpdated, 32);
};
/**
 * @param {?proto.events.VehicleStateUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleStateUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 32, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleStateUpdated = function() {
    return this.setVehicleStateUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleStateUpdated = function() {
    return $8M67s.Message.getField(this, 32) != null;
};
/**
 * optional VehicleActivityUpdated vehicle_activity_updated = 33;
 * @return {?proto.events.VehicleActivityUpdated}
 */ proto.events.Event.prototype.getVehicleActivityUpdated = function() {
    return /** @type{?proto.events.VehicleActivityUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleActivityUpdated, 33);
};
/**
 * @param {?proto.events.VehicleActivityUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleActivityUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 33, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleActivityUpdated = function() {
    return this.setVehicleActivityUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleActivityUpdated = function() {
    return $8M67s.Message.getField(this, 33) != null;
};
/**
 * optional VehicleActivityStateUpdated vehicle_activity_state_updated = 34;
 * @return {?proto.events.VehicleActivityStateUpdated}
 */ proto.events.Event.prototype.getVehicleActivityStateUpdated = function() {
    return /** @type{?proto.events.VehicleActivityStateUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleActivityStateUpdated, 34);
};
/**
 * @param {?proto.events.VehicleActivityStateUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleActivityStateUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 34, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleActivityStateUpdated = function() {
    return this.setVehicleActivityStateUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleActivityStateUpdated = function() {
    return $8M67s.Message.getField(this, 34) != null;
};
/**
 * optional VehicleActivityFailureUpdated vehicle_activity_failure_updated = 35;
 * @return {?proto.events.VehicleActivityFailureUpdated}
 */ proto.events.Event.prototype.getVehicleActivityFailureUpdated = function() {
    return /** @type{?proto.events.VehicleActivityFailureUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleActivityFailureUpdated, 35);
};
/**
 * @param {?proto.events.VehicleActivityFailureUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleActivityFailureUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 35, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleActivityFailureUpdated = function() {
    return this.setVehicleActivityFailureUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleActivityFailureUpdated = function() {
    return $8M67s.Message.getField(this, 35) != null;
};
/**
 * optional CustomerInsuranceUpdated customer_insurance_updated = 36;
 * @return {?proto.events.CustomerInsuranceUpdated}
 */ proto.events.Event.prototype.getCustomerInsuranceUpdated = function() {
    return /** @type{?proto.events.CustomerInsuranceUpdated} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerInsuranceUpdated, 36);
};
/**
 * @param {?proto.events.CustomerInsuranceUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerInsuranceUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 36, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerInsuranceUpdated = function() {
    return this.setCustomerInsuranceUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerInsuranceUpdated = function() {
    return $8M67s.Message.getField(this, 36) != null;
};
/**
 * optional SyncDealerships sync_dealerships = 37;
 * @return {?proto.events.SyncDealerships}
 */ proto.events.Event.prototype.getSyncDealerships = function() {
    return /** @type{?proto.events.SyncDealerships} */ $8M67s.Message.getWrapperField(this, proto.events.SyncDealerships, 37);
};
/**
 * @param {?proto.events.SyncDealerships|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSyncDealerships = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 37, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSyncDealerships = function() {
    return this.setSyncDealerships(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSyncDealerships = function() {
    return $8M67s.Message.getField(this, 37) != null;
};
/**
 * optional InvoiceToBePaid invoice_to_be_paid = 38;
 * @return {?proto.events.InvoiceToBePaid}
 */ proto.events.Event.prototype.getInvoiceToBePaid = function() {
    return /** @type{?proto.events.InvoiceToBePaid} */ $8M67s.Message.getWrapperField(this, proto.events.InvoiceToBePaid, 38);
};
/**
 * @param {?proto.events.InvoiceToBePaid|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setInvoiceToBePaid = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 38, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearInvoiceToBePaid = function() {
    return this.setInvoiceToBePaid(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasInvoiceToBePaid = function() {
    return $8M67s.Message.getField(this, 38) != null;
};
/**
 * optional DocumentAdded document_added = 39;
 * @return {?proto.events.DocumentAdded}
 */ proto.events.Event.prototype.getDocumentAdded = function() {
    return /** @type{?proto.events.DocumentAdded} */ $8M67s.Message.getWrapperField(this, proto.events.DocumentAdded, 39);
};
/**
 * @param {?proto.events.DocumentAdded|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setDocumentAdded = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 39, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearDocumentAdded = function() {
    return this.setDocumentAdded(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasDocumentAdded = function() {
    return $8M67s.Message.getField(this, 39) != null;
};
/**
 * optional DocumentDeleted document_deleted = 40;
 * @return {?proto.events.DocumentDeleted}
 */ proto.events.Event.prototype.getDocumentDeleted = function() {
    return /** @type{?proto.events.DocumentDeleted} */ $8M67s.Message.getWrapperField(this, proto.events.DocumentDeleted, 40);
};
/**
 * @param {?proto.events.DocumentDeleted|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setDocumentDeleted = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 40, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearDocumentDeleted = function() {
    return this.setDocumentDeleted(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasDocumentDeleted = function() {
    return $8M67s.Message.getField(this, 40) != null;
};
/**
 * optional OfferSubmitted offer_submitted = 41;
 * @return {?proto.events.OfferSubmitted}
 */ proto.events.Event.prototype.getOfferSubmitted = function() {
    return /** @type{?proto.events.OfferSubmitted} */ $8M67s.Message.getWrapperField(this, proto.events.OfferSubmitted, 41);
};
/**
 * @param {?proto.events.OfferSubmitted|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setOfferSubmitted = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 41, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearOfferSubmitted = function() {
    return this.setOfferSubmitted(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasOfferSubmitted = function() {
    return $8M67s.Message.getField(this, 41) != null;
};
/**
 * optional SubscriptionContractAdded subscription_contract_added = 42;
 * @return {?proto.events.SubscriptionContractAdded}
 */ proto.events.Event.prototype.getSubscriptionContractAdded = function() {
    return /** @type{?proto.events.SubscriptionContractAdded} */ $8M67s.Message.getWrapperField(this, proto.events.SubscriptionContractAdded, 42);
};
/**
 * @param {?proto.events.SubscriptionContractAdded|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSubscriptionContractAdded = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 42, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSubscriptionContractAdded = function() {
    return this.setSubscriptionContractAdded(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSubscriptionContractAdded = function() {
    return $8M67s.Message.getField(this, 42) != null;
};
/**
 * optional VehicleInspectionCompleted vehicle_inspection_completed = 43;
 * @return {?proto.events.VehicleInspectionCompleted}
 */ proto.events.Event.prototype.getVehicleInspectionCompleted = function() {
    return /** @type{?proto.events.VehicleInspectionCompleted} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleInspectionCompleted, 43);
};
/**
 * @param {?proto.events.VehicleInspectionCompleted|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleInspectionCompleted = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 43, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleInspectionCompleted = function() {
    return this.setVehicleInspectionCompleted(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleInspectionCompleted = function() {
    return $8M67s.Message.getField(this, 43) != null;
};
/**
 * optional VehicleInspectionStarted vehicle_inspection_started = 44;
 * @return {?proto.events.VehicleInspectionStarted}
 */ proto.events.Event.prototype.getVehicleInspectionStarted = function() {
    return /** @type{?proto.events.VehicleInspectionStarted} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleInspectionStarted, 44);
};
/**
 * @param {?proto.events.VehicleInspectionStarted|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleInspectionStarted = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 44, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleInspectionStarted = function() {
    return this.setVehicleInspectionStarted(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleInspectionStarted = function() {
    return $8M67s.Message.getField(this, 44) != null;
};
/**
 * optional OfferResponse offer_response = 45;
 * @return {?proto.events.OfferResponse}
 */ proto.events.Event.prototype.getOfferResponse = function() {
    return /** @type{?proto.events.OfferResponse} */ $8M67s.Message.getWrapperField(this, proto.events.OfferResponse, 45);
};
/**
 * @param {?proto.events.OfferResponse|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setOfferResponse = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 45, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearOfferResponse = function() {
    return this.setOfferResponse(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasOfferResponse = function() {
    return $8M67s.Message.getField(this, 45) != null;
};
/**
 * optional VehicleTosAccepted vehicle_tos_accepted = 46;
 * @return {?proto.events.VehicleTosAccepted}
 */ proto.events.Event.prototype.getVehicleTosAccepted = function() {
    return /** @type{?proto.events.VehicleTosAccepted} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleTosAccepted, 46);
};
/**
 * @param {?proto.events.VehicleTosAccepted|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleTosAccepted = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 46, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleTosAccepted = function() {
    return this.setVehicleTosAccepted(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleTosAccepted = function() {
    return $8M67s.Message.getField(this, 46) != null;
};
/**
 * optional SubscriptionCancelled subscription_cancelled = 47;
 * @return {?proto.events.SubscriptionCancelled}
 */ proto.events.Event.prototype.getSubscriptionCancelled = function() {
    return /** @type{?proto.events.SubscriptionCancelled} */ $8M67s.Message.getWrapperField(this, proto.events.SubscriptionCancelled, 47);
};
/**
 * @param {?proto.events.SubscriptionCancelled|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSubscriptionCancelled = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 47, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSubscriptionCancelled = function() {
    return this.setSubscriptionCancelled(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSubscriptionCancelled = function() {
    return $8M67s.Message.getField(this, 47) != null;
};
/**
 * optional InvoiceCancelled invoice_cancelled = 48;
 * @return {?proto.events.InvoiceCancelled}
 */ proto.events.Event.prototype.getInvoiceCancelled = function() {
    return /** @type{?proto.events.InvoiceCancelled} */ $8M67s.Message.getWrapperField(this, proto.events.InvoiceCancelled, 48);
};
/**
 * @param {?proto.events.InvoiceCancelled|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setInvoiceCancelled = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 48, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearInvoiceCancelled = function() {
    return this.setInvoiceCancelled(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasInvoiceCancelled = function() {
    return $8M67s.Message.getField(this, 48) != null;
};
/**
 * optional ReloadDomain reload_domain = 49;
 * @return {?proto.events.ReloadDomain}
 */ proto.events.Event.prototype.getReloadDomain = function() {
    return /** @type{?proto.events.ReloadDomain} */ $8M67s.Message.getWrapperField(this, proto.events.ReloadDomain, 49);
};
/**
 * @param {?proto.events.ReloadDomain|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setReloadDomain = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 49, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearReloadDomain = function() {
    return this.setReloadDomain(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasReloadDomain = function() {
    return $8M67s.Message.getField(this, 49) != null;
};
/**
 * optional CancelPaymentTransaction cancel_payment_transaction = 50;
 * @return {?proto.events.CancelPaymentTransaction}
 */ proto.events.Event.prototype.getCancelPaymentTransaction = function() {
    return /** @type{?proto.events.CancelPaymentTransaction} */ $8M67s.Message.getWrapperField(this, proto.events.CancelPaymentTransaction, 50);
};
/**
 * @param {?proto.events.CancelPaymentTransaction|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCancelPaymentTransaction = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 50, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCancelPaymentTransaction = function() {
    return this.setCancelPaymentTransaction(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCancelPaymentTransaction = function() {
    return $8M67s.Message.getField(this, 50) != null;
};
/**
 * optional SmsReceived sms_received = 51;
 * @return {?proto.events.SmsReceived}
 */ proto.events.Event.prototype.getSmsReceived = function() {
    return /** @type{?proto.events.SmsReceived} */ $8M67s.Message.getWrapperField(this, proto.events.SmsReceived, 51);
};
/**
 * @param {?proto.events.SmsReceived|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSmsReceived = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 51, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSmsReceived = function() {
    return this.setSmsReceived(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSmsReceived = function() {
    return $8M67s.Message.getField(this, 51) != null;
};
/**
 * optional CustomerScored customer_scored = 52;
 * @return {?proto.events.CustomerScored}
 */ proto.events.Event.prototype.getCustomerScored = function() {
    return /** @type{?proto.events.CustomerScored} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerScored, 52);
};
/**
 * @param {?proto.events.CustomerScored|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerScored = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 52, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerScored = function() {
    return this.setCustomerScored(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerScored = function() {
    return $8M67s.Message.getField(this, 52) != null;
};
/**
 * optional CustomerQualified customer_qualified = 53;
 * @return {?proto.events.CustomerQualified}
 */ proto.events.Event.prototype.getCustomerQualified = function() {
    return /** @type{?proto.events.CustomerQualified} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerQualified, 53);
};
/**
 * @param {?proto.events.CustomerQualified|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerQualified = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 53, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerQualified = function() {
    return this.setCustomerQualified(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerQualified = function() {
    return $8M67s.Message.getField(this, 53) != null;
};
/**
 * optional CustomerScoreDisqualified customer_score_disqualified = 54;
 * @return {?proto.events.CustomerScoreDisqualified}
 */ proto.events.Event.prototype.getCustomerScoreDisqualified = function() {
    return /** @type{?proto.events.CustomerScoreDisqualified} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerScoreDisqualified, 54);
};
/**
 * @param {?proto.events.CustomerScoreDisqualified|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerScoreDisqualified = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 54, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerScoreDisqualified = function() {
    return this.setCustomerScoreDisqualified(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerScoreDisqualified = function() {
    return $8M67s.Message.getField(this, 54) != null;
};
/**
 * optional PaymentRefunded payment_refunded = 55;
 * @return {?proto.events.PaymentRefunded}
 */ proto.events.Event.prototype.getPaymentRefunded = function() {
    return /** @type{?proto.events.PaymentRefunded} */ $8M67s.Message.getWrapperField(this, proto.events.PaymentRefunded, 55);
};
/**
 * @param {?proto.events.PaymentRefunded|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPaymentRefunded = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 55, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPaymentRefunded = function() {
    return this.setPaymentRefunded(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPaymentRefunded = function() {
    return $8M67s.Message.getField(this, 55) != null;
};
/**
 * optional CustomerDataEnriched customer_data_enriched = 56;
 * @return {?proto.events.CustomerDataEnriched}
 */ proto.events.Event.prototype.getCustomerDataEnriched = function() {
    return /** @type{?proto.events.CustomerDataEnriched} */ $8M67s.Message.getWrapperField(this, proto.events.CustomerDataEnriched, 56);
};
/**
 * @param {?proto.events.CustomerDataEnriched|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerDataEnriched = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 56, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerDataEnriched = function() {
    return this.setCustomerDataEnriched(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerDataEnriched = function() {
    return $8M67s.Message.getField(this, 56) != null;
};
/**
 * optional subscription.ReservationCreated reservation_created = 57;
 * @return {?proto.subscription.ReservationCreated}
 */ proto.events.Event.prototype.getReservationCreated = function() {
    return /** @type{?proto.subscription.ReservationCreated} */ $8M67s.Message.getWrapperField(this, $hOsJC.ReservationCreated, 57);
};
/**
 * @param {?proto.subscription.ReservationCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setReservationCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 57, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearReservationCreated = function() {
    return this.setReservationCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasReservationCreated = function() {
    return $8M67s.Message.getField(this, 57) != null;
};
/**
 * optional subscription.ReservationStatusUpdated reservation_status_updated = 58;
 * @return {?proto.subscription.ReservationStatusUpdated}
 */ proto.events.Event.prototype.getReservationStatusUpdated = function() {
    return /** @type{?proto.subscription.ReservationStatusUpdated} */ $8M67s.Message.getWrapperField(this, $hOsJC.ReservationStatusUpdated, 58);
};
/**
 * @param {?proto.subscription.ReservationStatusUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setReservationStatusUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 58, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearReservationStatusUpdated = function() {
    return this.setReservationStatusUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasReservationStatusUpdated = function() {
    return $8M67s.Message.getField(this, 58) != null;
};
/**
 * optional subscription.ProgramCreated program_created = 59;
 * @return {?proto.subscription.ProgramCreated}
 */ proto.events.Event.prototype.getProgramCreated = function() {
    return /** @type{?proto.subscription.ProgramCreated} */ $8M67s.Message.getWrapperField(this, $hOsJC.ProgramCreated, 59);
};
/**
 * @param {?proto.subscription.ProgramCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setProgramCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 59, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearProgramCreated = function() {
    return this.setProgramCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasProgramCreated = function() {
    return $8M67s.Message.getField(this, 59) != null;
};
/**
 * optional subscription.ColorOptionCreated color_option_created = 60;
 * @return {?proto.subscription.ColorOptionCreated}
 */ proto.events.Event.prototype.getColorOptionCreated = function() {
    return /** @type{?proto.subscription.ColorOptionCreated} */ $8M67s.Message.getWrapperField(this, $hOsJC.ColorOptionCreated, 60);
};
/**
 * @param {?proto.subscription.ColorOptionCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setColorOptionCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 60, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearColorOptionCreated = function() {
    return this.setColorOptionCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasColorOptionCreated = function() {
    return $8M67s.Message.getField(this, 60) != null;
};
/**
 * optional subscription.PricingOptionCreated pricing_option_created = 61;
 * @return {?proto.subscription.PricingOptionCreated}
 */ proto.events.Event.prototype.getPricingOptionCreated = function() {
    return /** @type{?proto.subscription.PricingOptionCreated} */ $8M67s.Message.getWrapperField(this, $hOsJC.PricingOptionCreated, 61);
};
/**
 * @param {?proto.subscription.PricingOptionCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPricingOptionCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 61, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPricingOptionCreated = function() {
    return this.setPricingOptionCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPricingOptionCreated = function() {
    return $8M67s.Message.getField(this, 61) != null;
};
/**
 * optional subscription.PendingSubscriptionInitialized pending_subscription_initialized = 62;
 * @return {?proto.subscription.PendingSubscriptionInitialized}
 */ proto.events.Event.prototype.getPendingSubscriptionInitialized = function() {
    return /** @type{?proto.subscription.PendingSubscriptionInitialized} */ $8M67s.Message.getWrapperField(this, $hOsJC.PendingSubscriptionInitialized, 62);
};
/**
 * @param {?proto.subscription.PendingSubscriptionInitialized|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPendingSubscriptionInitialized = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 62, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPendingSubscriptionInitialized = function() {
    return this.setPendingSubscriptionInitialized(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPendingSubscriptionInitialized = function() {
    return $8M67s.Message.getField(this, 62) != null;
};
/**
 * optional subscription.ReservationCancelled reservation_cancelled = 63;
 * @return {?proto.subscription.ReservationCancelled}
 */ proto.events.Event.prototype.getReservationCancelled = function() {
    return /** @type{?proto.subscription.ReservationCancelled} */ $8M67s.Message.getWrapperField(this, $hOsJC.ReservationCancelled, 63);
};
/**
 * @param {?proto.subscription.ReservationCancelled|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setReservationCancelled = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 63, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearReservationCancelled = function() {
    return this.setReservationCancelled(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasReservationCancelled = function() {
    return $8M67s.Message.getField(this, 63) != null;
};
/**
 * optional SyncIngestion sync_ingestion = 64;
 * @return {?proto.events.SyncIngestion}
 */ proto.events.Event.prototype.getSyncIngestion = function() {
    return /** @type{?proto.events.SyncIngestion} */ $8M67s.Message.getWrapperField(this, proto.events.SyncIngestion, 64);
};
/**
 * @param {?proto.events.SyncIngestion|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSyncIngestion = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 64, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSyncIngestion = function() {
    return this.setSyncIngestion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSyncIngestion = function() {
    return $8M67s.Message.getField(this, 64) != null;
};
/**
 * optional vehicle.Ingestion vehicle_ingestion = 65;
 * @return {?proto.vehicle.Ingestion}
 */ proto.events.Event.prototype.getVehicleIngestion = function() {
    return /** @type{?proto.vehicle.Ingestion} */ $8M67s.Message.getWrapperField(this, $9YICB.Ingestion, 65);
};
/**
 * @param {?proto.vehicle.Ingestion|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleIngestion = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 65, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleIngestion = function() {
    return this.setVehicleIngestion(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleIngestion = function() {
    return $8M67s.Message.getField(this, 65) != null;
};
/**
 * optional vehicle.VehicleUpdated vehicle_updated = 66;
 * @return {?proto.vehicle.VehicleUpdated}
 */ proto.events.Event.prototype.getVehicleUpdated = function() {
    return /** @type{?proto.vehicle.VehicleUpdated} */ $8M67s.Message.getWrapperField(this, $9YICB.VehicleUpdated, 66);
};
/**
 * @param {?proto.vehicle.VehicleUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 66, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleUpdated = function() {
    return this.setVehicleUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleUpdated = function() {
    return $8M67s.Message.getField(this, 66) != null;
};
/**
 * optional vehicle.VehicleDeleted vehicle_deleted = 67;
 * @return {?proto.vehicle.VehicleDeleted}
 */ proto.events.Event.prototype.getVehicleDeleted = function() {
    return /** @type{?proto.vehicle.VehicleDeleted} */ $8M67s.Message.getWrapperField(this, $9YICB.VehicleDeleted, 67);
};
/**
 * @param {?proto.vehicle.VehicleDeleted|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleDeleted = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 67, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleDeleted = function() {
    return this.setVehicleDeleted(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleDeleted = function() {
    return $8M67s.Message.getField(this, 67) != null;
};
/**
 * optional subscription.ProcessDueStatements process_due_statements = 68;
 * @return {?proto.subscription.ProcessDueStatements}
 */ proto.events.Event.prototype.getProcessDueStatements = function() {
    return /** @type{?proto.subscription.ProcessDueStatements} */ $8M67s.Message.getWrapperField(this, $hOsJC.ProcessDueStatements, 68);
};
/**
 * @param {?proto.subscription.ProcessDueStatements|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setProcessDueStatements = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 68, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearProcessDueStatements = function() {
    return this.setProcessDueStatements(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasProcessDueStatements = function() {
    return $8M67s.Message.getField(this, 68) != null;
};
/**
 * optional subscription.StatementDue statement_due = 69;
 * @return {?proto.subscription.StatementDue}
 */ proto.events.Event.prototype.getStatementDue = function() {
    return /** @type{?proto.subscription.StatementDue} */ $8M67s.Message.getWrapperField(this, $hOsJC.StatementDue, 69);
};
/**
 * @param {?proto.subscription.StatementDue|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setStatementDue = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 69, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearStatementDue = function() {
    return this.setStatementDue(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasStatementDue = function() {
    return $8M67s.Message.getField(this, 69) != null;
};
/**
 * optional subscription.SubscriptionActivated subscription_activated = 70;
 * @return {?proto.subscription.SubscriptionActivated}
 */ proto.events.Event.prototype.getSubscriptionActivated = function() {
    return /** @type{?proto.subscription.SubscriptionActivated} */ $8M67s.Message.getWrapperField(this, $hOsJC.SubscriptionActivated, 70);
};
/**
 * @param {?proto.subscription.SubscriptionActivated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSubscriptionActivated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 70, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSubscriptionActivated = function() {
    return this.setSubscriptionActivated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSubscriptionActivated = function() {
    return $8M67s.Message.getField(this, 70) != null;
};
/**
 * optional customer.CustomerPhoneUpdated customer_phone_updated = 71;
 * @return {?proto.customer.CustomerPhoneUpdated}
 */ proto.events.Event.prototype.getCustomerPhoneUpdated = function() {
    return /** @type{?proto.customer.CustomerPhoneUpdated} */ $8M67s.Message.getWrapperField(this, $c17Fn.CustomerPhoneUpdated, 71);
};
/**
 * @param {?proto.customer.CustomerPhoneUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerPhoneUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 71, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerPhoneUpdated = function() {
    return this.setCustomerPhoneUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerPhoneUpdated = function() {
    return $8M67s.Message.getField(this, 71) != null;
};
/**
 * optional billing_service.Promotion promotion_created = 72;
 * @return {?proto.billing_service.Promotion}
 */ proto.events.Event.prototype.getPromotionCreated = function() {
    return /** @type{?proto.billing_service.Promotion} */ $8M67s.Message.getWrapperField(this, $26u10.Promotion, 72);
};
/**
 * @param {?proto.billing_service.Promotion|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPromotionCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 72, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPromotionCreated = function() {
    return this.setPromotionCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPromotionCreated = function() {
    return $8M67s.Message.getField(this, 72) != null;
};
/**
 * optional billing_service.Promotion promotion_updated = 73;
 * @return {?proto.billing_service.Promotion}
 */ proto.events.Event.prototype.getPromotionUpdated = function() {
    return /** @type{?proto.billing_service.Promotion} */ $8M67s.Message.getWrapperField(this, $26u10.Promotion, 73);
};
/**
 * @param {?proto.billing_service.Promotion|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPromotionUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 73, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPromotionUpdated = function() {
    return this.setPromotionUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPromotionUpdated = function() {
    return $8M67s.Message.getField(this, 73) != null;
};
/**
 * optional billing_service.PromotionActivity promotion_activity = 74;
 * @return {?proto.billing_service.PromotionActivity}
 */ proto.events.Event.prototype.getPromotionActivity = function() {
    return /** @type{?proto.billing_service.PromotionActivity} */ $8M67s.Message.getWrapperField(this, $26u10.PromotionActivity, 74);
};
/**
 * @param {?proto.billing_service.PromotionActivity|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPromotionActivity = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 74, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPromotionActivity = function() {
    return this.setPromotionActivity(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPromotionActivity = function() {
    return $8M67s.Message.getField(this, 74) != null;
};
/**
 * optional billing_service.DraftOrderUpdated draft_order_updated = 75;
 * @return {?proto.billing_service.DraftOrderUpdated}
 */ proto.events.Event.prototype.getDraftOrderUpdated = function() {
    return /** @type{?proto.billing_service.DraftOrderUpdated} */ $8M67s.Message.getWrapperField(this, $26u10.DraftOrderUpdated, 75);
};
/**
 * @param {?proto.billing_service.DraftOrderUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setDraftOrderUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 75, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearDraftOrderUpdated = function() {
    return this.setDraftOrderUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasDraftOrderUpdated = function() {
    return $8M67s.Message.getField(this, 75) != null;
};
/**
 * optional subscription.ReservationOptionsUpdated reservation_options_updated = 76;
 * @return {?proto.subscription.ReservationOptionsUpdated}
 */ proto.events.Event.prototype.getReservationOptionsUpdated = function() {
    return /** @type{?proto.subscription.ReservationOptionsUpdated} */ $8M67s.Message.getWrapperField(this, $hOsJC.ReservationOptionsUpdated, 76);
};
/**
 * @param {?proto.subscription.ReservationOptionsUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setReservationOptionsUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 76, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearReservationOptionsUpdated = function() {
    return this.setReservationOptionsUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasReservationOptionsUpdated = function() {
    return $8M67s.Message.getField(this, 76) != null;
};
/**
 * optional billing_service.PromotionPartner promotion_partner_created = 77;
 * @return {?proto.billing_service.PromotionPartner}
 */ proto.events.Event.prototype.getPromotionPartnerCreated = function() {
    return /** @type{?proto.billing_service.PromotionPartner} */ $8M67s.Message.getWrapperField(this, $26u10.PromotionPartner, 77);
};
/**
 * @param {?proto.billing_service.PromotionPartner|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPromotionPartnerCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 77, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPromotionPartnerCreated = function() {
    return this.setPromotionPartnerCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPromotionPartnerCreated = function() {
    return $8M67s.Message.getField(this, 77) != null;
};
/**
 * optional billing_service.PromotionPartner promotion_partner_updated = 78;
 * @return {?proto.billing_service.PromotionPartner}
 */ proto.events.Event.prototype.getPromotionPartnerUpdated = function() {
    return /** @type{?proto.billing_service.PromotionPartner} */ $8M67s.Message.getWrapperField(this, $26u10.PromotionPartner, 78);
};
/**
 * @param {?proto.billing_service.PromotionPartner|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPromotionPartnerUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 78, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPromotionPartnerUpdated = function() {
    return this.setPromotionPartnerUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPromotionPartnerUpdated = function() {
    return $8M67s.Message.getField(this, 78) != null;
};
/**
 * optional vehicle.LocationUpdated location_updated = 79;
 * @return {?proto.vehicle.LocationUpdated}
 */ proto.events.Event.prototype.getLocationUpdated = function() {
    return /** @type{?proto.vehicle.LocationUpdated} */ $8M67s.Message.getWrapperField(this, $9YICB.LocationUpdated, 79);
};
/**
 * @param {?proto.vehicle.LocationUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setLocationUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 79, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearLocationUpdated = function() {
    return this.setLocationUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasLocationUpdated = function() {
    return $8M67s.Message.getField(this, 79) != null;
};
/**
 * optional subscription.SubscriptionUpdated subscription_updated = 80;
 * @return {?proto.subscription.SubscriptionUpdated}
 */ proto.events.Event.prototype.getSubscriptionUpdated = function() {
    return /** @type{?proto.subscription.SubscriptionUpdated} */ $8M67s.Message.getWrapperField(this, $hOsJC.SubscriptionUpdated, 80);
};
/**
 * @param {?proto.subscription.SubscriptionUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSubscriptionUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 80, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSubscriptionUpdated = function() {
    return this.setSubscriptionUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSubscriptionUpdated = function() {
    return $8M67s.Message.getField(this, 80) != null;
};
/**
 * optional vehicle.OdometerUpdate odometer_update = 81;
 * @return {?proto.vehicle.OdometerUpdate}
 */ proto.events.Event.prototype.getOdometerUpdate = function() {
    return /** @type{?proto.vehicle.OdometerUpdate} */ $8M67s.Message.getWrapperField(this, $9YICB.OdometerUpdate, 81);
};
/**
 * @param {?proto.vehicle.OdometerUpdate|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setOdometerUpdate = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 81, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearOdometerUpdate = function() {
    return this.setOdometerUpdate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasOdometerUpdate = function() {
    return $8M67s.Message.getField(this, 81) != null;
};
/**
 * optional vehicle.LocationUpdate location_update = 82;
 * @return {?proto.vehicle.LocationUpdate}
 */ proto.events.Event.prototype.getLocationUpdate = function() {
    return /** @type{?proto.vehicle.LocationUpdate} */ $8M67s.Message.getWrapperField(this, $9YICB.LocationUpdate, 82);
};
/**
 * @param {?proto.vehicle.LocationUpdate|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setLocationUpdate = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 82, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearLocationUpdate = function() {
    return this.setLocationUpdate(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasLocationUpdate = function() {
    return $8M67s.Message.getField(this, 82) != null;
};
/**
 * optional appointment.AppointmentCreated appointment_created = 83;
 * @return {?proto.appointment.AppointmentCreated}
 */ proto.events.Event.prototype.getAppointmentCreated = function() {
    return /** @type{?proto.appointment.AppointmentCreated} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentCreated, 83);
};
/**
 * @param {?proto.appointment.AppointmentCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setAppointmentCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 83, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearAppointmentCreated = function() {
    return this.setAppointmentCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasAppointmentCreated = function() {
    return $8M67s.Message.getField(this, 83) != null;
};
/**
 * optional appointment.AppointmentTypeUpdated appointment_type_updated = 84;
 * @return {?proto.appointment.AppointmentTypeUpdated}
 */ proto.events.Event.prototype.getAppointmentTypeUpdated = function() {
    return /** @type{?proto.appointment.AppointmentTypeUpdated} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentTypeUpdated, 84);
};
/**
 * @param {?proto.appointment.AppointmentTypeUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setAppointmentTypeUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 84, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearAppointmentTypeUpdated = function() {
    return this.setAppointmentTypeUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasAppointmentTypeUpdated = function() {
    return $8M67s.Message.getField(this, 84) != null;
};
/**
 * optional appointment.AppointmentStatusUpdated appointment_status_updated = 85;
 * @return {?proto.appointment.AppointmentStatusUpdated}
 */ proto.events.Event.prototype.getAppointmentStatusUpdated = function() {
    return /** @type{?proto.appointment.AppointmentStatusUpdated} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentStatusUpdated, 85);
};
/**
 * @param {?proto.appointment.AppointmentStatusUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setAppointmentStatusUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 85, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearAppointmentStatusUpdated = function() {
    return this.setAppointmentStatusUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasAppointmentStatusUpdated = function() {
    return $8M67s.Message.getField(this, 85) != null;
};
/**
 * optional appointment.AppointmentVehicleUpdated appointment_vehicle_updated = 86;
 * @return {?proto.appointment.AppointmentVehicleUpdated}
 */ proto.events.Event.prototype.getAppointmentVehicleUpdated = function() {
    return /** @type{?proto.appointment.AppointmentVehicleUpdated} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentVehicleUpdated, 86);
};
/**
 * @param {?proto.appointment.AppointmentVehicleUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setAppointmentVehicleUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 86, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearAppointmentVehicleUpdated = function() {
    return this.setAppointmentVehicleUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasAppointmentVehicleUpdated = function() {
    return $8M67s.Message.getField(this, 86) != null;
};
/**
 * optional appointment.AvailabilityCreated availability_created = 87;
 * @return {?proto.appointment.AvailabilityCreated}
 */ proto.events.Event.prototype.getAvailabilityCreated = function() {
    return /** @type{?proto.appointment.AvailabilityCreated} */ $8M67s.Message.getWrapperField(this, $fcTGK.AvailabilityCreated, 87);
};
/**
 * @param {?proto.appointment.AvailabilityCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setAvailabilityCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 87, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearAvailabilityCreated = function() {
    return this.setAvailabilityCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasAvailabilityCreated = function() {
    return $8M67s.Message.getField(this, 87) != null;
};
/**
 * optional appointment.AppointmentCancelled appointment_cancelled = 88;
 * @return {?proto.appointment.AppointmentCancelled}
 */ proto.events.Event.prototype.getAppointmentCancelled = function() {
    return /** @type{?proto.appointment.AppointmentCancelled} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentCancelled, 88);
};
/**
 * @param {?proto.appointment.AppointmentCancelled|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setAppointmentCancelled = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 88, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearAppointmentCancelled = function() {
    return this.setAppointmentCancelled(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasAppointmentCancelled = function() {
    return $8M67s.Message.getField(this, 88) != null;
};
/**
 * optional subscription.ProgramPricingOptionsUpdated program_pricing_options_updated = 89;
 * @return {?proto.subscription.ProgramPricingOptionsUpdated}
 */ proto.events.Event.prototype.getProgramPricingOptionsUpdated = function() {
    return /** @type{?proto.subscription.ProgramPricingOptionsUpdated} */ $8M67s.Message.getWrapperField(this, $hOsJC.ProgramPricingOptionsUpdated, 89);
};
/**
 * @param {?proto.subscription.ProgramPricingOptionsUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setProgramPricingOptionsUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 89, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearProgramPricingOptionsUpdated = function() {
    return this.setProgramPricingOptionsUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasProgramPricingOptionsUpdated = function() {
    return $8M67s.Message.getField(this, 89) != null;
};
/**
 * optional appointment.AppointmentUpdated appointment_updated = 90;
 * @return {?proto.appointment.AppointmentUpdated}
 */ proto.events.Event.prototype.getAppointmentUpdated = function() {
    return /** @type{?proto.appointment.AppointmentUpdated} */ $8M67s.Message.getWrapperField(this, $fcTGK.AppointmentUpdated, 90);
};
/**
 * @param {?proto.appointment.AppointmentUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setAppointmentUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 90, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearAppointmentUpdated = function() {
    return this.setAppointmentUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasAppointmentUpdated = function() {
    return $8M67s.Message.getField(this, 90) != null;
};
/**
 * optional vehicle.VehiclePreferencesNotAvailable vehicle_preferences_not_available = 91;
 * @return {?proto.vehicle.VehiclePreferencesNotAvailable}
 */ proto.events.Event.prototype.getVehiclePreferencesNotAvailable = function() {
    return /** @type{?proto.vehicle.VehiclePreferencesNotAvailable} */ $8M67s.Message.getWrapperField(this, $9YICB.VehiclePreferencesNotAvailable, 91);
};
/**
 * @param {?proto.vehicle.VehiclePreferencesNotAvailable|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehiclePreferencesNotAvailable = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 91, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehiclePreferencesNotAvailable = function() {
    return this.setVehiclePreferencesNotAvailable(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehiclePreferencesNotAvailable = function() {
    return $8M67s.Message.getField(this, 91) != null;
};
/**
 * optional notifications.SendNotifications send_notifications = 92;
 * @return {?proto.notifications.SendNotifications}
 */ proto.events.Event.prototype.getSendNotifications = function() {
    return /** @type{?proto.notifications.SendNotifications} */ $8M67s.Message.getWrapperField(this, $3DbSe.SendNotifications, 92);
};
/**
 * @param {?proto.notifications.SendNotifications|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSendNotifications = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 92, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSendNotifications = function() {
    return this.setSendNotifications(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSendNotifications = function() {
    return $8M67s.Message.getField(this, 92) != null;
};
/**
 * optional notifications.NotificationReceived notifications_received = 93;
 * @return {?proto.notifications.NotificationReceived}
 */ proto.events.Event.prototype.getNotificationsReceived = function() {
    return /** @type{?proto.notifications.NotificationReceived} */ $8M67s.Message.getWrapperField(this, $3DbSe.NotificationReceived, 93);
};
/**
 * @param {?proto.notifications.NotificationReceived|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setNotificationsReceived = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 93, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearNotificationsReceived = function() {
    return this.setNotificationsReceived(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasNotificationsReceived = function() {
    return $8M67s.Message.getField(this, 93) != null;
};
/**
 * optional notifications.NotificationStatusUpdated notification_status_updated = 94;
 * @return {?proto.notifications.NotificationStatusUpdated}
 */ proto.events.Event.prototype.getNotificationStatusUpdated = function() {
    return /** @type{?proto.notifications.NotificationStatusUpdated} */ $8M67s.Message.getWrapperField(this, $3DbSe.NotificationStatusUpdated, 94);
};
/**
 * @param {?proto.notifications.NotificationStatusUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setNotificationStatusUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 94, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearNotificationStatusUpdated = function() {
    return this.setNotificationStatusUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasNotificationStatusUpdated = function() {
    return $8M67s.Message.getField(this, 94) != null;
};
/**
 * optional dealer.DealershipCreated dealership_created = 100;
 * @return {?proto.dealer.DealershipCreated}
 */ proto.events.Event.prototype.getDealershipCreated = function() {
    return /** @type{?proto.dealer.DealershipCreated} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipCreated, 100);
};
/**
 * @param {?proto.dealer.DealershipCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setDealershipCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 100, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearDealershipCreated = function() {
    return this.setDealershipCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasDealershipCreated = function() {
    return $8M67s.Message.getField(this, 100) != null;
};
/**
 * optional dealer.DealershipUserCreated dealership_user_created = 101;
 * @return {?proto.dealer.DealershipUserCreated}
 */ proto.events.Event.prototype.getDealershipUserCreated = function() {
    return /** @type{?proto.dealer.DealershipUserCreated} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUserCreated, 101);
};
/**
 * @param {?proto.dealer.DealershipUserCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setDealershipUserCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 101, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearDealershipUserCreated = function() {
    return this.setDealershipUserCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasDealershipUserCreated = function() {
    return $8M67s.Message.getField(this, 101) != null;
};
/**
 * optional customer.CustomerBankAccountVerified customer_bank_verified = 102;
 * @return {?proto.customer.CustomerBankAccountVerified}
 */ proto.events.Event.prototype.getCustomerBankVerified = function() {
    return /** @type{?proto.customer.CustomerBankAccountVerified} */ $8M67s.Message.getWrapperField(this, $c17Fn.CustomerBankAccountVerified, 102);
};
/**
 * @param {?proto.customer.CustomerBankAccountVerified|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setCustomerBankVerified = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 102, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearCustomerBankVerified = function() {
    return this.setCustomerBankVerified(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasCustomerBankVerified = function() {
    return $8M67s.Message.getField(this, 102) != null;
};
/**
 * optional insurance_service.IsQualifiedForLiberty is_qualified_for_liberty = 103;
 * @return {?proto.insurance_service.IsQualifiedForLiberty}
 */ proto.events.Event.prototype.getIsQualifiedForLiberty = function() {
    return /** @type{?proto.insurance_service.IsQualifiedForLiberty} */ $8M67s.Message.getWrapperField(this, $ghA5X.IsQualifiedForLiberty, 103);
};
/**
 * @param {?proto.insurance_service.IsQualifiedForLiberty|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setIsQualifiedForLiberty = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 103, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearIsQualifiedForLiberty = function() {
    return this.setIsQualifiedForLiberty(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasIsQualifiedForLiberty = function() {
    return $8M67s.Message.getField(this, 103) != null;
};
/**
 * optional insurance_service.InsurancePolicyCreated insurance_policy_created = 104;
 * @return {?proto.insurance_service.InsurancePolicyCreated}
 */ proto.events.Event.prototype.getInsurancePolicyCreated = function() {
    return /** @type{?proto.insurance_service.InsurancePolicyCreated} */ $8M67s.Message.getWrapperField(this, $ghA5X.InsurancePolicyCreated, 104);
};
/**
 * @param {?proto.insurance_service.InsurancePolicyCreated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setInsurancePolicyCreated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 104, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearInsurancePolicyCreated = function() {
    return this.setInsurancePolicyCreated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasInsurancePolicyCreated = function() {
    return $8M67s.Message.getField(this, 104) != null;
};
/**
 * optional dealer.DealershipUserUpdated dealership_user_updated = 105;
 * @return {?proto.dealer.DealershipUserUpdated}
 */ proto.events.Event.prototype.getDealershipUserUpdated = function() {
    return /** @type{?proto.dealer.DealershipUserUpdated} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUserUpdated, 105);
};
/**
 * @param {?proto.dealer.DealershipUserUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setDealershipUserUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 105, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearDealershipUserUpdated = function() {
    return this.setDealershipUserUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasDealershipUserUpdated = function() {
    return $8M67s.Message.getField(this, 105) != null;
};
/**
 * optional dealer.DealershipUpdated dealership_updated = 106;
 * @return {?proto.dealer.DealershipUpdated}
 */ proto.events.Event.prototype.getDealershipUpdated = function() {
    return /** @type{?proto.dealer.DealershipUpdated} */ $8M67s.Message.getWrapperField(this, $1oiLe.DealershipUpdated, 106);
};
/**
 * @param {?proto.dealer.DealershipUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setDealershipUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 106, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearDealershipUpdated = function() {
    return this.setDealershipUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasDealershipUpdated = function() {
    return $8M67s.Message.getField(this, 106) != null;
};
/**
 * optional customer.PhoneNumberEntered phone_number_entered = 107;
 * @return {?proto.customer.PhoneNumberEntered}
 */ proto.events.Event.prototype.getPhoneNumberEntered = function() {
    return /** @type{?proto.customer.PhoneNumberEntered} */ $8M67s.Message.getWrapperField(this, $c17Fn.PhoneNumberEntered, 107);
};
/**
 * @param {?proto.customer.PhoneNumberEntered|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setPhoneNumberEntered = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 107, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearPhoneNumberEntered = function() {
    return this.setPhoneNumberEntered(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasPhoneNumberEntered = function() {
    return $8M67s.Message.getField(this, 107) != null;
};
/**
 * optional customer.LicenseInfoSubmitted license_info_submitted = 108;
 * @return {?proto.customer.LicenseInfoSubmitted}
 */ proto.events.Event.prototype.getLicenseInfoSubmitted = function() {
    return /** @type{?proto.customer.LicenseInfoSubmitted} */ $8M67s.Message.getWrapperField(this, $c17Fn.LicenseInfoSubmitted, 108);
};
/**
 * @param {?proto.customer.LicenseInfoSubmitted|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setLicenseInfoSubmitted = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 108, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearLicenseInfoSubmitted = function() {
    return this.setLicenseInfoSubmitted(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasLicenseInfoSubmitted = function() {
    return $8M67s.Message.getField(this, 108) != null;
};
/**
 * optional vehicle.VehicleInfleetingUpdated vehicle_infleeting_updated = 109;
 * @return {?proto.vehicle.VehicleInfleetingUpdated}
 */ proto.events.Event.prototype.getVehicleInfleetingUpdated = function() {
    return /** @type{?proto.vehicle.VehicleInfleetingUpdated} */ $8M67s.Message.getWrapperField(this, $9YICB.VehicleInfleetingUpdated, 109);
};
/**
 * @param {?proto.vehicle.VehicleInfleetingUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setVehicleInfleetingUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 109, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearVehicleInfleetingUpdated = function() {
    return this.setVehicleInfleetingUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasVehicleInfleetingUpdated = function() {
    return $8M67s.Message.getField(this, 109) != null;
};
/**
 * optional ExtendInsurancePolicies extend_insurance_policies = 110;
 * @return {?proto.events.ExtendInsurancePolicies}
 */ proto.events.Event.prototype.getExtendInsurancePolicies = function() {
    return /** @type{?proto.events.ExtendInsurancePolicies} */ $8M67s.Message.getWrapperField(this, proto.events.ExtendInsurancePolicies, 110);
};
/**
 * @param {?proto.events.ExtendInsurancePolicies|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setExtendInsurancePolicies = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 110, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearExtendInsurancePolicies = function() {
    return this.setExtendInsurancePolicies(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasExtendInsurancePolicies = function() {
    return $8M67s.Message.getField(this, 110) != null;
};
/**
 * optional insurance_service.InsurancePolicyUpdated insurance_policy_updated = 111;
 * @return {?proto.insurance_service.InsurancePolicyUpdated}
 */ proto.events.Event.prototype.getInsurancePolicyUpdated = function() {
    return /** @type{?proto.insurance_service.InsurancePolicyUpdated} */ $8M67s.Message.getWrapperField(this, $ghA5X.InsurancePolicyUpdated, 111);
};
/**
 * @param {?proto.insurance_service.InsurancePolicyUpdated|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setInsurancePolicyUpdated = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 111, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearInsurancePolicyUpdated = function() {
    return this.setInsurancePolicyUpdated(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasInsurancePolicyUpdated = function() {
    return $8M67s.Message.getField(this, 111) != null;
};
/**
 * optional MilesPurchased miles_purchased = 112;
 * @return {?proto.events.MilesPurchased}
 */ proto.events.Event.prototype.getMilesPurchased = function() {
    return /** @type{?proto.events.MilesPurchased} */ $8M67s.Message.getWrapperField(this, proto.events.MilesPurchased, 112);
};
/**
 * @param {?proto.events.MilesPurchased|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setMilesPurchased = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 112, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearMilesPurchased = function() {
    return this.setMilesPurchased(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasMilesPurchased = function() {
    return $8M67s.Message.getField(this, 112) != null;
};
/**
 * optional insurance_service.InsurancePolicyCancelled insurance_policy_cancelled = 113;
 * @return {?proto.insurance_service.InsurancePolicyCancelled}
 */ proto.events.Event.prototype.getInsurancePolicyCancelled = function() {
    return /** @type{?proto.insurance_service.InsurancePolicyCancelled} */ $8M67s.Message.getWrapperField(this, $ghA5X.InsurancePolicyCancelled, 113);
};
/**
 * @param {?proto.insurance_service.InsurancePolicyCancelled|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setInsurancePolicyCancelled = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 113, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearInsurancePolicyCancelled = function() {
    return this.setInsurancePolicyCancelled(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasInsurancePolicyCancelled = function() {
    return $8M67s.Message.getField(this, 113) != null;
};
/**
 * optional SubscriptionVehicleChange subscription_vehicle_change = 114;
 * @return {?proto.events.SubscriptionVehicleChange}
 */ proto.events.Event.prototype.getSubscriptionVehicleChange = function() {
    return /** @type{?proto.events.SubscriptionVehicleChange} */ $8M67s.Message.getWrapperField(this, proto.events.SubscriptionVehicleChange, 114);
};
/**
 * @param {?proto.events.SubscriptionVehicleChange|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSubscriptionVehicleChange = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 114, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSubscriptionVehicleChange = function() {
    return this.setSubscriptionVehicleChange(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSubscriptionVehicleChange = function() {
    return $8M67s.Message.getField(this, 114) != null;
};
/**
 * optional SubscriptionVehicleReturned subscription_vehicle_returned = 115;
 * @return {?proto.events.SubscriptionVehicleReturned}
 */ proto.events.Event.prototype.getSubscriptionVehicleReturned = function() {
    return /** @type{?proto.events.SubscriptionVehicleReturned} */ $8M67s.Message.getWrapperField(this, proto.events.SubscriptionVehicleReturned, 115);
};
/**
 * @param {?proto.events.SubscriptionVehicleReturned|undefined} value
 * @return {!proto.events.Event} returns this
*/ proto.events.Event.prototype.setSubscriptionVehicleReturned = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 115, proto.events.Event.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.Event} returns this
 */ proto.events.Event.prototype.clearSubscriptionVehicleReturned = function() {
    return this.setSubscriptionVehicleReturned(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.Event.prototype.hasSubscriptionVehicleReturned = function() {
    return $8M67s.Message.getField(this, 115) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.PaymentRefunded.prototype.toObject = function(opt_includeInstance) {
        return proto.events.PaymentRefunded.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PaymentRefunded} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PaymentRefunded.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            reason: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PaymentRefunded}
 */ proto.events.PaymentRefunded.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.PaymentRefunded;
    return proto.events.PaymentRefunded.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PaymentRefunded} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PaymentRefunded}
 */ proto.events.PaymentRefunded.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 6:
                var value = /** @type {!proto.domain.Subscription.SubscriptionAction.ActionReason} */ reader.readEnum();
                msg.setReason(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.PaymentRefunded.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.PaymentRefunded.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PaymentRefunded} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PaymentRefunded.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getReason();
    if (f !== 0.0) writer.writeEnum(6, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.PaymentRefunded.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentRefunded} returns this
 */ proto.events.PaymentRefunded.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account_number = 2;
 * @return {string}
 */ proto.events.PaymentRefunded.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentRefunded} returns this
 */ proto.events.PaymentRefunded.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string invoice_number = 3;
 * @return {string}
 */ proto.events.PaymentRefunded.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentRefunded} returns this
 */ proto.events.PaymentRefunded.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string description = 4;
 * @return {string}
 */ proto.events.PaymentRefunded.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentRefunded} returns this
 */ proto.events.PaymentRefunded.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 amount = 5;
 * @return {number}
 */ proto.events.PaymentRefunded.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.PaymentRefunded} returns this
 */ proto.events.PaymentRefunded.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional domain.Subscription.SubscriptionAction.ActionReason reason = 6;
 * @return {!proto.domain.Subscription.SubscriptionAction.ActionReason}
 */ proto.events.PaymentRefunded.prototype.getReason = function() {
    return /** @type {!proto.domain.Subscription.SubscriptionAction.ActionReason} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.domain.Subscription.SubscriptionAction.ActionReason} value
 * @return {!proto.events.PaymentRefunded} returns this
 */ proto.events.PaymentRefunded.prototype.setReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.InvoiceCancelled.prototype.toObject = function(opt_includeInstance) {
        return proto.events.InvoiceCancelled.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.InvoiceCancelled} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.InvoiceCancelled.toObject = function(includeInstance, msg) {
        var f, obj = {
            invoiceId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.InvoiceCancelled}
 */ proto.events.InvoiceCancelled.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.InvoiceCancelled;
    return proto.events.InvoiceCancelled.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.InvoiceCancelled} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.InvoiceCancelled}
 */ proto.events.InvoiceCancelled.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.InvoiceCancelled.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.InvoiceCancelled.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.InvoiceCancelled} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.InvoiceCancelled.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInvoiceId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string invoice_id = 1;
 * @return {string}
 */ proto.events.InvoiceCancelled.prototype.getInvoiceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.InvoiceCancelled} returns this
 */ proto.events.InvoiceCancelled.prototype.setInvoiceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.events.SubscriptionCancelled.repeatedFields_ = [
    7
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.SubscriptionCancelled.prototype.toObject = function(opt_includeInstance) {
        return proto.events.SubscriptionCancelled.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.SubscriptionCancelled} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SubscriptionCancelled.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            userId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            userEmail: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            actionReason: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            notes: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            transactionsList: $8M67s.Message.toObjectList(msg.getTransactionsList(), $3QqPt.Transaction.toObject, includeInstance),
            refundAmount: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 10, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.SubscriptionCancelled}
 */ proto.events.SubscriptionCancelled.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.SubscriptionCancelled;
    return proto.events.SubscriptionCancelled.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.SubscriptionCancelled} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.SubscriptionCancelled}
 */ proto.events.SubscriptionCancelled.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setUserEmail(value);
                break;
            case 5:
                var value = /** @type {!proto.domain.Subscription.SubscriptionAction.ActionReason} */ reader.readEnum();
                msg.setActionReason(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setNotes(value);
                break;
            case 7:
                var value = new $3QqPt.Transaction;
                reader.readMessage(value, $3QqPt.Transaction.deserializeBinaryFromReader);
                msg.addTransactions(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRefundAmount(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.SubscriptionCancelled.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.SubscriptionCancelled.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.SubscriptionCancelled} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SubscriptionCancelled.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getUserEmail();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getActionReason();
    if (f !== 0.0) writer.writeEnum(5, f);
    f = message.getNotes();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getTransactionsList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, $3QqPt.Transaction.serializeBinaryToWriter);
    f = message.getRefundAmount();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(10, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.events.SubscriptionCancelled.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.events.SubscriptionCancelled.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string user_id = 3;
 * @return {string}
 */ proto.events.SubscriptionCancelled.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string user_email = 4;
 * @return {string}
 */ proto.events.SubscriptionCancelled.prototype.getUserEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setUserEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional domain.Subscription.SubscriptionAction.ActionReason action_reason = 5;
 * @return {!proto.domain.Subscription.SubscriptionAction.ActionReason}
 */ proto.events.SubscriptionCancelled.prototype.getActionReason = function() {
    return /** @type {!proto.domain.Subscription.SubscriptionAction.ActionReason} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.domain.Subscription.SubscriptionAction.ActionReason} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setActionReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * optional string notes = 6;
 * @return {string}
 */ proto.events.SubscriptionCancelled.prototype.getNotes = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setNotes = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * repeated domain.Transaction transactions = 7;
 * @return {!Array<!proto.domain.Transaction>}
 */ proto.events.SubscriptionCancelled.prototype.getTransactionsList = function() {
    return /** @type{!Array<!proto.domain.Transaction>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Transaction, 7);
};
/**
 * @param {!Array<!proto.domain.Transaction>} value
 * @return {!proto.events.SubscriptionCancelled} returns this
*/ proto.events.SubscriptionCancelled.prototype.setTransactionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.domain.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Transaction}
 */ proto.events.SubscriptionCancelled.prototype.addTransactions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.domain.Transaction, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.clearTransactionsList = function() {
    return this.setTransactionsList([]);
};
/**
 * optional int32 refund_amount = 8;
 * @return {number}
 */ proto.events.SubscriptionCancelled.prototype.getRefundAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setRefundAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional string account_number = 9;
 * @return {string}
 */ proto.events.SubscriptionCancelled.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string invoice_number = 10;
 * @return {string}
 */ proto.events.SubscriptionCancelled.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionCancelled} returns this
 */ proto.events.SubscriptionCancelled.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.TripReceived.prototype.toObject = function(opt_includeInstance) {
        return proto.events.TripReceived.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.TripReceived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.TripReceived.toObject = function(includeInstance, msg) {
        var f, obj = {
            trip: (f = msg.getTrip()) && $02GYf.TripReceived.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.TripReceived}
 */ proto.events.TripReceived.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.TripReceived;
    return proto.events.TripReceived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.TripReceived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.TripReceived}
 */ proto.events.TripReceived.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $02GYf.TripReceived;
                reader.readMessage(value, $02GYf.TripReceived.deserializeBinaryFromReader);
                msg.setTrip(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.TripReceived.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.TripReceived.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.TripReceived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.TripReceived.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTrip();
    if (f != null) writer.writeMessage(1, f, $02GYf.TripReceived.serializeBinaryToWriter);
};
/**
 * optional telemetric.TripReceived trip = 1;
 * @return {?proto.telemetric.TripReceived}
 */ proto.events.TripReceived.prototype.getTrip = function() {
    return /** @type{?proto.telemetric.TripReceived} */ $8M67s.Message.getWrapperField(this, $02GYf.TripReceived, 1);
};
/**
 * @param {?proto.telemetric.TripReceived|undefined} value
 * @return {!proto.events.TripReceived} returns this
*/ proto.events.TripReceived.prototype.setTrip = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.TripReceived} returns this
 */ proto.events.TripReceived.prototype.clearTrip = function() {
    return this.setTrip(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.TripReceived.prototype.hasTrip = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CollisionReceived.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CollisionReceived.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CollisionReceived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CollisionReceived.toObject = function(includeInstance, msg) {
        var f, obj = {
            collision: (f = msg.getCollision()) && $02GYf.CollisionReceived.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CollisionReceived}
 */ proto.events.CollisionReceived.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CollisionReceived;
    return proto.events.CollisionReceived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CollisionReceived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CollisionReceived}
 */ proto.events.CollisionReceived.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = new $02GYf.CollisionReceived;
                reader.readMessage(value, $02GYf.CollisionReceived.deserializeBinaryFromReader);
                msg.setCollision(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CollisionReceived.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CollisionReceived.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CollisionReceived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CollisionReceived.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCollision();
    if (f != null) writer.writeMessage(2, f, $02GYf.CollisionReceived.serializeBinaryToWriter);
};
/**
 * optional telemetric.CollisionReceived collision = 2;
 * @return {?proto.telemetric.CollisionReceived}
 */ proto.events.CollisionReceived.prototype.getCollision = function() {
    return /** @type{?proto.telemetric.CollisionReceived} */ $8M67s.Message.getWrapperField(this, $02GYf.CollisionReceived, 2);
};
/**
 * @param {?proto.telemetric.CollisionReceived|undefined} value
 * @return {!proto.events.CollisionReceived} returns this
*/ proto.events.CollisionReceived.prototype.setCollision = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.CollisionReceived} returns this
 */ proto.events.CollisionReceived.prototype.clearCollision = function() {
    return this.setCollision(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.CollisionReceived.prototype.hasCollision = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.Notification.prototype.toObject = function(opt_includeInstance) {
        return proto.events.Notification.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.Notification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.Notification.toObject = function(includeInstance, msg) {
        var f, obj = {
            data: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.Notification}
 */ proto.events.Notification.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.Notification;
    return proto.events.Notification.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.Notification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.Notification}
 */ proto.events.Notification.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.Notification.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.Notification.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.Notification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.Notification.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getData();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string data = 1;
 * @return {string}
 */ proto.events.Notification.prototype.getData = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.Notification} returns this
 */ proto.events.Notification.prototype.setData = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerCreated}
 */ proto.events.CustomerCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerCreated;
    return proto.events.CustomerCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerCreated}
 */ proto.events.CustomerCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.events.CustomerCreated.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerCreated} returns this
 */ proto.events.CustomerCreated.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.events.CustomerCreated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerCreated} returns this
 */ proto.events.CustomerCreated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.events.CustomerCreated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerCreated} returns this
 */ proto.events.CustomerCreated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.events.CustomerInfoUpdated.repeatedFields_ = [
    9,
    10,
    11
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerInfoUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerInfoUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerInfoUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerInfoUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            language: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            licenseNumber: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            isPartial: $8M67s.Message.getBooleanFieldWithDefault(msg, 8, false),
            scoresList: $8M67s.Message.toObjectList(msg.getScoresList(), $3QqPt.Score.toObject, includeInstance),
            addressesList: $8M67s.Message.toObjectList(msg.getAddressesList(), $3QqPt.Address.toObject, includeInstance),
            imagesList: $8M67s.Message.toObjectList(msg.getImagesList(), $3QqPt.Image.toObject, includeInstance),
            qualificationTier: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            paymentMethodsRequired: $8M67s.Message.getFieldWithDefault(msg, 13, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerInfoUpdated}
 */ proto.events.CustomerInfoUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerInfoUpdated;
    return proto.events.CustomerInfoUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerInfoUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerInfoUpdated}
 */ proto.events.CustomerInfoUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setLicenseNumber(value);
                break;
            case 8:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsPartial(value);
                break;
            case 9:
                var value = new $3QqPt.Score;
                reader.readMessage(value, $3QqPt.Score.deserializeBinaryFromReader);
                msg.addScores(value);
                break;
            case 10:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.addAddresses(value);
                break;
            case 11:
                var value = new $3QqPt.Image;
                reader.readMessage(value, $3QqPt.Image.deserializeBinaryFromReader);
                msg.addImages(value);
                break;
            case 12:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setQualificationTier(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPaymentMethodsRequired(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerInfoUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerInfoUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerInfoUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerInfoUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getLanguage();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getLicenseNumber();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getIsPartial();
    if (f) writer.writeBool(8, f);
    f = message.getScoresList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, $3QqPt.Score.serializeBinaryToWriter);
    f = message.getAddressesList();
    if (f.length > 0) writer.writeRepeatedMessage(10, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getImagesList();
    if (f.length > 0) writer.writeRepeatedMessage(11, f, $3QqPt.Image.serializeBinaryToWriter);
    f = message.getQualificationTier();
    if (f !== 0.0) writer.writeEnum(12, f);
    f = message.getPaymentMethodsRequired();
    if (f !== 0) writer.writeInt32(13, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.CustomerInfoUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string phone = 2;
 * @return {string}
 */ proto.events.CustomerInfoUpdated.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string first_name = 3;
 * @return {string}
 */ proto.events.CustomerInfoUpdated.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_name = 4;
 * @return {string}
 */ proto.events.CustomerInfoUpdated.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string language = 5;
 * @return {string}
 */ proto.events.CustomerInfoUpdated.prototype.getLanguage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setLanguage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string email = 6;
 * @return {string}
 */ proto.events.CustomerInfoUpdated.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string license_number = 7;
 * @return {string}
 */ proto.events.CustomerInfoUpdated.prototype.getLicenseNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setLicenseNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional bool is_partial = 8;
 * @return {boolean}
 */ proto.events.CustomerInfoUpdated.prototype.getIsPartial = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 8, false);
};
/**
 * @param {boolean} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setIsPartial = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 8, value);
};
/**
 * repeated domain.Score scores = 9;
 * @return {!Array<!proto.domain.Score>}
 */ proto.events.CustomerInfoUpdated.prototype.getScoresList = function() {
    return /** @type{!Array<!proto.domain.Score>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Score, 9);
};
/**
 * @param {!Array<!proto.domain.Score>} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
*/ proto.events.CustomerInfoUpdated.prototype.setScoresList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.domain.Score=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Score}
 */ proto.events.CustomerInfoUpdated.prototype.addScores = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.domain.Score, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.clearScoresList = function() {
    return this.setScoresList([]);
};
/**
 * repeated domain.Address addresses = 10;
 * @return {!Array<!proto.domain.Address>}
 */ proto.events.CustomerInfoUpdated.prototype.getAddressesList = function() {
    return /** @type{!Array<!proto.domain.Address>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Address, 10);
};
/**
 * @param {!Array<!proto.domain.Address>} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
*/ proto.events.CustomerInfoUpdated.prototype.setAddressesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 10, value);
};
/**
 * @param {!proto.domain.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Address}
 */ proto.events.CustomerInfoUpdated.prototype.addAddresses = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.domain.Address, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.clearAddressesList = function() {
    return this.setAddressesList([]);
};
/**
 * repeated domain.Image images = 11;
 * @return {!Array<!proto.domain.Image>}
 */ proto.events.CustomerInfoUpdated.prototype.getImagesList = function() {
    return /** @type{!Array<!proto.domain.Image>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Image, 11);
};
/**
 * @param {!Array<!proto.domain.Image>} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
*/ proto.events.CustomerInfoUpdated.prototype.setImagesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 11, value);
};
/**
 * @param {!proto.domain.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Image}
 */ proto.events.CustomerInfoUpdated.prototype.addImages = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.domain.Image, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.clearImagesList = function() {
    return this.setImagesList([]);
};
/**
 * optional domain.QualificationTier qualification_tier = 12;
 * @return {!proto.domain.QualificationTier}
 */ proto.events.CustomerInfoUpdated.prototype.getQualificationTier = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setQualificationTier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 12, value);
};
/**
 * optional int32 payment_methods_required = 13;
 * @return {number}
 */ proto.events.CustomerInfoUpdated.prototype.getPaymentMethodsRequired = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.CustomerInfoUpdated} returns this
 */ proto.events.CustomerInfoUpdated.prototype.setPaymentMethodsRequired = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerInsuranceUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerInsuranceUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerInsuranceUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerInsuranceUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            requestSource: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            insurancePolicy: (f = msg.getInsurancePolicy()) && $3QqPt.InsurancePolicy.toObject(includeInstance, f),
            changeType: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerInsuranceUpdated}
 */ proto.events.CustomerInsuranceUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerInsuranceUpdated;
    return proto.events.CustomerInsuranceUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerInsuranceUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerInsuranceUpdated}
 */ proto.events.CustomerInsuranceUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {!proto.events.CustomerInsuranceUpdated.RequestSource} */ reader.readEnum();
                msg.setRequestSource(value);
                break;
            case 3:
                var value = new $3QqPt.InsurancePolicy;
                reader.readMessage(value, $3QqPt.InsurancePolicy.deserializeBinaryFromReader);
                msg.setInsurancePolicy(value);
                break;
            case 4:
                var value = /** @type {!proto.events.CustomerInsuranceUpdated.ChangeType} */ reader.readEnum();
                msg.setChangeType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerInsuranceUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerInsuranceUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerInsuranceUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerInsuranceUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getRequestSource();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getInsurancePolicy();
    if (f != null) writer.writeMessage(3, f, $3QqPt.InsurancePolicy.serializeBinaryToWriter);
    f = message.getChangeType();
    if (f !== 0.0) writer.writeEnum(4, f);
};
/**
 * @enum {number}
 */ proto.events.CustomerInsuranceUpdated.RequestSource = {
    CUSTOMER: 0,
    CUSTOMER_SUPPORT: 1
};
/**
 * @enum {number}
 */ proto.events.CustomerInsuranceUpdated.ChangeType = {
    CREATE: 0,
    UPDATE: 1,
    DELETE: 2
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.CustomerInsuranceUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerInsuranceUpdated} returns this
 */ proto.events.CustomerInsuranceUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional RequestSource request_source = 2;
 * @return {!proto.events.CustomerInsuranceUpdated.RequestSource}
 */ proto.events.CustomerInsuranceUpdated.prototype.getRequestSource = function() {
    return /** @type {!proto.events.CustomerInsuranceUpdated.RequestSource} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.events.CustomerInsuranceUpdated.RequestSource} value
 * @return {!proto.events.CustomerInsuranceUpdated} returns this
 */ proto.events.CustomerInsuranceUpdated.prototype.setRequestSource = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional domain.InsurancePolicy insurance_policy = 3;
 * @return {?proto.domain.InsurancePolicy}
 */ proto.events.CustomerInsuranceUpdated.prototype.getInsurancePolicy = function() {
    return /** @type{?proto.domain.InsurancePolicy} */ $8M67s.Message.getWrapperField(this, $3QqPt.InsurancePolicy, 3);
};
/**
 * @param {?proto.domain.InsurancePolicy|undefined} value
 * @return {!proto.events.CustomerInsuranceUpdated} returns this
*/ proto.events.CustomerInsuranceUpdated.prototype.setInsurancePolicy = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.CustomerInsuranceUpdated} returns this
 */ proto.events.CustomerInsuranceUpdated.prototype.clearInsurancePolicy = function() {
    return this.setInsurancePolicy(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.CustomerInsuranceUpdated.prototype.hasInsurancePolicy = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional ChangeType change_type = 4;
 * @return {!proto.events.CustomerInsuranceUpdated.ChangeType}
 */ proto.events.CustomerInsuranceUpdated.prototype.getChangeType = function() {
    return /** @type {!proto.events.CustomerInsuranceUpdated.ChangeType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.events.CustomerInsuranceUpdated.ChangeType} value
 * @return {!proto.events.CustomerInsuranceUpdated} returns this
 */ proto.events.CustomerInsuranceUpdated.prototype.setChangeType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerStateUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerStateUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerStateUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerStateUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            newState: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerStateUpdated}
 */ proto.events.CustomerStateUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerStateUpdated;
    return proto.events.CustomerStateUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerStateUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerStateUpdated}
 */ proto.events.CustomerStateUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.CustomerState} */ reader.readEnum();
                msg.setNewState(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerStateUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerStateUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerStateUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerStateUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNewState();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional domain.CustomerState new_state = 1;
 * @return {!proto.domain.CustomerState}
 */ proto.events.CustomerStateUpdated.prototype.getNewState = function() {
    return /** @type {!proto.domain.CustomerState} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.CustomerState} value
 * @return {!proto.events.CustomerStateUpdated} returns this
 */ proto.events.CustomerStateUpdated.prototype.setNewState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.events.CustomerStateUpdated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerStateUpdated} returns this
 */ proto.events.CustomerStateUpdated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerFailureStateUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerFailureStateUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerFailureStateUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerFailureStateUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            newState: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerFailureStateUpdated}
 */ proto.events.CustomerFailureStateUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerFailureStateUpdated;
    return proto.events.CustomerFailureStateUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerFailureStateUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerFailureStateUpdated}
 */ proto.events.CustomerFailureStateUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.CustomerFailureState} */ reader.readEnum();
                msg.setNewState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerFailureStateUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerFailureStateUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerFailureStateUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerFailureStateUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNewState();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional domain.CustomerFailureState new_state = 1;
 * @return {!proto.domain.CustomerFailureState}
 */ proto.events.CustomerFailureStateUpdated.prototype.getNewState = function() {
    return /** @type {!proto.domain.CustomerFailureState} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.CustomerFailureState} value
 * @return {!proto.events.CustomerFailureStateUpdated} returns this
 */ proto.events.CustomerFailureStateUpdated.prototype.setNewState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerActivityUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerActivityUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerActivityUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerActivityUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            newActivity: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerActivityUpdated}
 */ proto.events.CustomerActivityUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerActivityUpdated;
    return proto.events.CustomerActivityUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerActivityUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerActivityUpdated}
 */ proto.events.CustomerActivityUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.CustomerActivity} */ reader.readEnum();
                msg.setNewActivity(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerActivityUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerActivityUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerActivityUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerActivityUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNewActivity();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional domain.CustomerActivity new_activity = 1;
 * @return {!proto.domain.CustomerActivity}
 */ proto.events.CustomerActivityUpdated.prototype.getNewActivity = function() {
    return /** @type {!proto.domain.CustomerActivity} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.CustomerActivity} value
 * @return {!proto.events.CustomerActivityUpdated} returns this
 */ proto.events.CustomerActivityUpdated.prototype.setNewActivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.ActivityStateUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.ActivityStateUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.ActivityStateUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.ActivityStateUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            newState: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.ActivityStateUpdated}
 */ proto.events.ActivityStateUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.ActivityStateUpdated;
    return proto.events.ActivityStateUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.ActivityStateUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.ActivityStateUpdated}
 */ proto.events.ActivityStateUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.ActivityState} */ reader.readEnum();
                msg.setNewState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.ActivityStateUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.ActivityStateUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.ActivityStateUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.ActivityStateUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNewState();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional domain.ActivityState new_state = 1;
 * @return {!proto.domain.ActivityState}
 */ proto.events.ActivityStateUpdated.prototype.getNewState = function() {
    return /** @type {!proto.domain.ActivityState} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.ActivityState} value
 * @return {!proto.events.ActivityStateUpdated} returns this
 */ proto.events.ActivityStateUpdated.prototype.setNewState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VendorAccountUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VendorAccountUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VendorAccountUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VendorAccountUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vendorName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            accountId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VendorAccountUpdated}
 */ proto.events.VendorAccountUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VendorAccountUpdated;
    return proto.events.VendorAccountUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VendorAccountUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VendorAccountUpdated}
 */ proto.events.VendorAccountUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVendorName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VendorAccountUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VendorAccountUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VendorAccountUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VendorAccountUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVendorName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getAccountId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.VendorAccountUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VendorAccountUpdated} returns this
 */ proto.events.VendorAccountUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vendor_name = 2;
 * @return {string}
 */ proto.events.VendorAccountUpdated.prototype.getVendorName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VendorAccountUpdated} returns this
 */ proto.events.VendorAccountUpdated.prototype.setVendorName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string account_id = 3;
 * @return {string}
 */ proto.events.VendorAccountUpdated.prototype.getAccountId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VendorAccountUpdated} returns this
 */ proto.events.VendorAccountUpdated.prototype.setAccountId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerDeleted.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerDeleted.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerDeleted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerDeleted.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerDeleted}
 */ proto.events.CustomerDeleted.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerDeleted;
    return proto.events.CustomerDeleted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerDeleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerDeleted}
 */ proto.events.CustomerDeleted.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerDeleted.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerDeleted.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerDeleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerDeleted.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.CustomerDeleted.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerDeleted} returns this
 */ proto.events.CustomerDeleted.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.PickupDateSet.prototype.toObject = function(opt_includeInstance) {
        return proto.events.PickupDateSet.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PickupDateSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PickupDateSet.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            pickupDate: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PickupDateSet}
 */ proto.events.PickupDateSet.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.PickupDateSet;
    return proto.events.PickupDateSet.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PickupDateSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PickupDateSet}
 */ proto.events.PickupDateSet.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPickupDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.PickupDateSet.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.PickupDateSet.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PickupDateSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PickupDateSet.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getPickupDate();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.PickupDateSet.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PickupDateSet} returns this
 */ proto.events.PickupDateSet.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.events.PickupDateSet.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PickupDateSet} returns this
 */ proto.events.PickupDateSet.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 pickup_date = 3;
 * @return {number}
 */ proto.events.PickupDateSet.prototype.getPickupDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.PickupDateSet} returns this
 */ proto.events.PickupDateSet.prototype.setPickupDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehiclePrePickup.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehiclePrePickup.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehiclePrePickup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehiclePrePickup.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehiclePrePickup}
 */ proto.events.VehiclePrePickup.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehiclePrePickup;
    return proto.events.VehiclePrePickup.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehiclePrePickup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehiclePrePickup}
 */ proto.events.VehiclePrePickup.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehiclePrePickup.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehiclePrePickup.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehiclePrePickup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehiclePrePickup.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.VehiclePrePickup.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehiclePrePickup} returns this
 */ proto.events.VehiclePrePickup.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehiclePickup.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehiclePickup.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehiclePickup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehiclePickup.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehiclePickup}
 */ proto.events.VehiclePickup.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehiclePickup;
    return proto.events.VehiclePickup.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehiclePickup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehiclePickup}
 */ proto.events.VehiclePickup.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehiclePickup.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehiclePickup.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehiclePickup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehiclePickup.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.VehiclePickup.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehiclePickup} returns this
 */ proto.events.VehiclePickup.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.PrepickupAuth.prototype.toObject = function(opt_includeInstance) {
        return proto.events.PrepickupAuth.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PrepickupAuth} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PrepickupAuth.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            paymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PrepickupAuth}
 */ proto.events.PrepickupAuth.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.PrepickupAuth;
    return proto.events.PrepickupAuth.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PrepickupAuth} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PrepickupAuth}
 */ proto.events.PrepickupAuth.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodId(value);
                break;
            case 3:
                var value = /** @type {!proto.events.AuthStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.PrepickupAuth.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.PrepickupAuth.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PrepickupAuth} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PrepickupAuth.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPaymentMethodId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.PrepickupAuth.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PrepickupAuth} returns this
 */ proto.events.PrepickupAuth.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string payment_method_id = 2;
 * @return {string}
 */ proto.events.PrepickupAuth.prototype.getPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PrepickupAuth} returns this
 */ proto.events.PrepickupAuth.prototype.setPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional AuthStatus status = 3;
 * @return {!proto.events.AuthStatus}
 */ proto.events.PrepickupAuth.prototype.getStatus = function() {
    return /** @type {!proto.events.AuthStatus} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.events.AuthStatus} value
 * @return {!proto.events.PrepickupAuth} returns this
 */ proto.events.PrepickupAuth.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.PickupPayment.prototype.toObject = function(opt_includeInstance) {
        return proto.events.PickupPayment.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PickupPayment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PickupPayment.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            paymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PickupPayment}
 */ proto.events.PickupPayment.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.PickupPayment;
    return proto.events.PickupPayment.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PickupPayment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PickupPayment}
 */ proto.events.PickupPayment.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodId(value);
                break;
            case 3:
                var value = /** @type {!proto.events.PaymentStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.PickupPayment.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.PickupPayment.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PickupPayment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PickupPayment.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPaymentMethodId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.PickupPayment.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PickupPayment} returns this
 */ proto.events.PickupPayment.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string payment_method_id = 2;
 * @return {string}
 */ proto.events.PickupPayment.prototype.getPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PickupPayment} returns this
 */ proto.events.PickupPayment.prototype.setPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional PaymentStatus status = 3;
 * @return {!proto.events.PaymentStatus}
 */ proto.events.PickupPayment.prototype.getStatus = function() {
    return /** @type {!proto.events.PaymentStatus} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.events.PaymentStatus} value
 * @return {!proto.events.PickupPayment} returns this
 */ proto.events.PickupPayment.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleCreated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleCreated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleCreated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleCreated.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleCreated}
 */ proto.events.VehicleCreated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleCreated;
    return proto.events.VehicleCreated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleCreated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleCreated}
 */ proto.events.VehicleCreated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleCreated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleCreated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleCreated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleCreated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional vehicle.Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.events.VehicleCreated.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.events.VehicleCreated} returns this
*/ proto.events.VehicleCreated.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.VehicleCreated} returns this
 */ proto.events.VehicleCreated.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.VehicleCreated.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.TransferVehicle.prototype.toObject = function(opt_includeInstance) {
        return proto.events.TransferVehicle.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.TransferVehicle} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.TransferVehicle.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.TransferVehicle}
 */ proto.events.TransferVehicle.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.TransferVehicle;
    return proto.events.TransferVehicle.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.TransferVehicle} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.TransferVehicle}
 */ proto.events.TransferVehicle.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.TransferVehicle.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.TransferVehicle.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.TransferVehicle} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.TransferVehicle.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional vehicle.Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.events.TransferVehicle.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.events.TransferVehicle} returns this
*/ proto.events.TransferVehicle.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.TransferVehicle} returns this
 */ proto.events.TransferVehicle.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.TransferVehicle.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.InvoiceReady.prototype.toObject = function(opt_includeInstance) {
        return proto.events.InvoiceReady.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.InvoiceReady} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.InvoiceReady.toObject = function(includeInstance, msg) {
        var f, obj = {
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            statement: (f = msg.getStatement()) && $3QqPt.Statement.toObject(includeInstance, f),
            recurring: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.InvoiceReady}
 */ proto.events.InvoiceReady.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.InvoiceReady;
    return proto.events.InvoiceReady.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.InvoiceReady} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.InvoiceReady}
 */ proto.events.InvoiceReady.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = new $3QqPt.Statement;
                reader.readMessage(value, $3QqPt.Statement.deserializeBinaryFromReader);
                msg.setStatement(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setRecurring(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.InvoiceReady.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.InvoiceReady.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.InvoiceReady} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.InvoiceReady.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStatement();
    if (f != null) writer.writeMessage(3, f, $3QqPt.Statement.serializeBinaryToWriter);
    f = message.getRecurring();
    if (f) writer.writeBool(4, f);
};
/**
 * optional string account_number = 1;
 * @return {string}
 */ proto.events.InvoiceReady.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.InvoiceReady} returns this
 */ proto.events.InvoiceReady.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.events.InvoiceReady.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.InvoiceReady} returns this
 */ proto.events.InvoiceReady.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional domain.Statement statement = 3;
 * @return {?proto.domain.Statement}
 */ proto.events.InvoiceReady.prototype.getStatement = function() {
    return /** @type{?proto.domain.Statement} */ $8M67s.Message.getWrapperField(this, $3QqPt.Statement, 3);
};
/**
 * @param {?proto.domain.Statement|undefined} value
 * @return {!proto.events.InvoiceReady} returns this
*/ proto.events.InvoiceReady.prototype.setStatement = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.InvoiceReady} returns this
 */ proto.events.InvoiceReady.prototype.clearStatement = function() {
    return this.setStatement(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.InvoiceReady.prototype.hasStatement = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional bool recurring = 4;
 * @return {boolean}
 */ proto.events.InvoiceReady.prototype.getRecurring = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.events.InvoiceReady} returns this
 */ proto.events.InvoiceReady.prototype.setRecurring = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.OdometerUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.OdometerUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.OdometerUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.OdometerUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            value: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.OdometerUpdated}
 */ proto.events.OdometerUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.OdometerUpdated;
    return proto.events.OdometerUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.OdometerUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.OdometerUpdated}
 */ proto.events.OdometerUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readFloat();
                msg.setValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.OdometerUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.OdometerUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.OdometerUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.OdometerUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getValue();
    if (f !== 0.0) writer.writeFloat(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.events.OdometerUpdated.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.OdometerUpdated} returns this
 */ proto.events.OdometerUpdated.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional float value = 2;
 * @return {number}
 */ proto.events.OdometerUpdated.prototype.getValue = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 2, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.events.OdometerUpdated} returns this
 */ proto.events.OdometerUpdated.prototype.setValue = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.OdometerSet.prototype.toObject = function(opt_includeInstance) {
        return proto.events.OdometerSet.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.OdometerSet} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.OdometerSet.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            value: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.OdometerSet}
 */ proto.events.OdometerSet.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.OdometerSet;
    return proto.events.OdometerSet.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.OdometerSet} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.OdometerSet}
 */ proto.events.OdometerSet.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readFloat();
                msg.setValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.OdometerSet.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.OdometerSet.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.OdometerSet} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.OdometerSet.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getValue();
    if (f !== 0.0) writer.writeFloat(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.events.OdometerSet.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.OdometerSet} returns this
 */ proto.events.OdometerSet.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional float value = 2;
 * @return {number}
 */ proto.events.OdometerSet.prototype.getValue = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 2, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.events.OdometerSet} returns this
 */ proto.events.OdometerSet.prototype.setValue = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.StatementActivity.prototype.toObject = function(opt_includeInstance) {
        return proto.events.StatementActivity.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.StatementActivity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.StatementActivity.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            statementId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            statementDueDate: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            daysPastDue: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            activityType: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.StatementActivity}
 */ proto.events.StatementActivity.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.StatementActivity;
    return proto.events.StatementActivity.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.StatementActivity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.StatementActivity}
 */ proto.events.StatementActivity.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setStatementId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setStatementDueDate(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDaysPastDue(value);
                break;
            case 6:
                var value = /** @type {!proto.events.StatementActivity.ActivityType} */ reader.readEnum();
                msg.setActivityType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.StatementActivity.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.StatementActivity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.StatementActivity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.StatementActivity.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStatementId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getStatementDueDate();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getDaysPastDue();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getActivityType();
    if (f !== 0.0) writer.writeEnum(6, f);
};
/**
 * @enum {number}
 */ proto.events.StatementActivity.ActivityType = {
    LINE_ITEM_ADDED: 0,
    STATEMENT_CANCELLED: 1
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.StatementActivity.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.StatementActivity} returns this
 */ proto.events.StatementActivity.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.events.StatementActivity.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.StatementActivity} returns this
 */ proto.events.StatementActivity.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string statement_id = 3;
 * @return {string}
 */ proto.events.StatementActivity.prototype.getStatementId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.StatementActivity} returns this
 */ proto.events.StatementActivity.prototype.setStatementId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 statement_due_date = 4;
 * @return {number}
 */ proto.events.StatementActivity.prototype.getStatementDueDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.StatementActivity} returns this
 */ proto.events.StatementActivity.prototype.setStatementDueDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 days_past_due = 5;
 * @return {number}
 */ proto.events.StatementActivity.prototype.getDaysPastDue = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.StatementActivity} returns this
 */ proto.events.StatementActivity.prototype.setDaysPastDue = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional ActivityType activity_type = 6;
 * @return {!proto.events.StatementActivity.ActivityType}
 */ proto.events.StatementActivity.prototype.getActivityType = function() {
    return /** @type {!proto.events.StatementActivity.ActivityType} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.events.StatementActivity.ActivityType} value
 * @return {!proto.events.StatementActivity} returns this
 */ proto.events.StatementActivity.prototype.setActivityType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.PaymentActivity.prototype.toObject = function(opt_includeInstance) {
        return proto.events.PaymentActivity.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.PaymentActivity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PaymentActivity.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            statementId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            transactionId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            paymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            succeeded: $8M67s.Message.getBooleanFieldWithDefault(msg, 7, false),
            last4: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            activityType: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            achReturnCode: $8M67s.Message.getFieldWithDefault(msg, 14, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.PaymentActivity}
 */ proto.events.PaymentActivity.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.PaymentActivity;
    return proto.events.PaymentActivity.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.PaymentActivity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.PaymentActivity}
 */ proto.events.PaymentActivity.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setStatementId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTransactionId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodId(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 7:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSucceeded(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setLast4(value);
                break;
            case 9:
                var value = /** @type {!proto.events.PaymentActivityType} */ reader.readEnum();
                msg.setActivityType(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setAchReturnCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.PaymentActivity.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.PaymentActivity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.PaymentActivity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.PaymentActivity.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getStatementId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getTransactionId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getPaymentMethodId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getSucceeded();
    if (f) writer.writeBool(7, f);
    f = message.getLast4();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getActivityType();
    if (f !== 0.0) writer.writeEnum(9, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getAchReturnCode();
    if (f.length > 0) writer.writeString(14, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string statement_id = 3;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getStatementId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setStatementId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string transaction_id = 4;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getTransactionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setTransactionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string payment_method_id = 5;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 amount = 6;
 * @return {number}
 */ proto.events.PaymentActivity.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional bool succeeded = 7;
 * @return {boolean}
 */ proto.events.PaymentActivity.prototype.getSucceeded = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 7, false);
};
/**
 * @param {boolean} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setSucceeded = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 7, value);
};
/**
 * optional string last4 = 8;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getLast4 = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setLast4 = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional PaymentActivityType activity_type = 9;
 * @return {!proto.events.PaymentActivityType}
 */ proto.events.PaymentActivity.prototype.getActivityType = function() {
    return /** @type {!proto.events.PaymentActivityType} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {!proto.events.PaymentActivityType} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setActivityType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 9, value);
};
/**
 * optional string account_number = 10;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string description = 11;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string reservation_id = 12;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string invoice_number = 13;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string ach_return_code = 14;
 * @return {string}
 */ proto.events.PaymentActivity.prototype.getAchReturnCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.events.PaymentActivity} returns this
 */ proto.events.PaymentActivity.prototype.setAchReturnCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.events.VehicleStateUpdated.repeatedFields_ = [
    9
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleStateUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleStateUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleStateUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleStateUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            state: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vehicleVin: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            reason: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            user: (f = msg.getUser()) && $3QqPt.AutonomyUser.toObject(includeInstance, f),
            notes: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
            newCustomerId: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), proto.events.ReturnLineItem.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleStateUpdated}
 */ proto.events.VehicleStateUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleStateUpdated;
    return proto.events.VehicleStateUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleStateUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleStateUpdated}
 */ proto.events.VehicleStateUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.vehicle.State} */ reader.readEnum();
                msg.setState(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleVin(value);
                break;
            case 4:
                var value = /** @type {!proto.events.VehicleStateUpdated.Reason} */ reader.readEnum();
                msg.setReason(value);
                break;
            case 5:
                var value = new $3QqPt.AutonomyUser;
                reader.readMessage(value, $3QqPt.AutonomyUser.deserializeBinaryFromReader);
                msg.setUser(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setNotes(value);
                break;
            case 7:
                var value = msg.getMetadataMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readString, null, "", "");
                });
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setNewCustomerId(value);
                break;
            case 9:
                var value = new proto.events.ReturnLineItem;
                reader.readMessage(value, proto.events.ReturnLineItem.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleStateUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleStateUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleStateUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleStateUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getState();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVehicleVin();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getReason();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getUser();
    if (f != null) writer.writeMessage(5, f, $3QqPt.AutonomyUser.serializeBinaryToWriter);
    f = message.getNotes();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getMetadataMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(7, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeString);
    f = message.getNewCustomerId();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, proto.events.ReturnLineItem.serializeBinaryToWriter);
};
/**
 * @enum {number}
 */ proto.events.VehicleStateUpdated.Reason = {
    REASON_UNSPECIFIED: 0,
    REASON_ASSIGNMENT: 1,
    REASON_RETURN: 3,
    REASON_TRANSFER: 4,
    REASON_REPO: 5,
    REASON_COLLISION: 6,
    REASON_UNASSIGNMENT: 7,
    REASON_DELISTING: 8,
    REASON_ACTIVATION: 9,
    REASON_LISTING: 10
};
/**
 * optional vehicle.State state = 1;
 * @return {!proto.vehicle.State}
 */ proto.events.VehicleStateUpdated.prototype.getState = function() {
    return /** @type {!proto.vehicle.State} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.vehicle.State} value
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.setState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.events.VehicleStateUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vehicle_vin = 3;
 * @return {string}
 */ proto.events.VehicleStateUpdated.prototype.getVehicleVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.setVehicleVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional Reason reason = 4;
 * @return {!proto.events.VehicleStateUpdated.Reason}
 */ proto.events.VehicleStateUpdated.prototype.getReason = function() {
    return /** @type {!proto.events.VehicleStateUpdated.Reason} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.events.VehicleStateUpdated.Reason} value
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.setReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional domain.AutonomyUser user = 5;
 * @return {?proto.domain.AutonomyUser}
 */ proto.events.VehicleStateUpdated.prototype.getUser = function() {
    return /** @type{?proto.domain.AutonomyUser} */ $8M67s.Message.getWrapperField(this, $3QqPt.AutonomyUser, 5);
};
/**
 * @param {?proto.domain.AutonomyUser|undefined} value
 * @return {!proto.events.VehicleStateUpdated} returns this
*/ proto.events.VehicleStateUpdated.prototype.setUser = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.clearUser = function() {
    return this.setUser(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.VehicleStateUpdated.prototype.hasUser = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional string notes = 6;
 * @return {string}
 */ proto.events.VehicleStateUpdated.prototype.getNotes = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.setNotes = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * map<string, string> metadata = 7;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */ proto.events.VehicleStateUpdated.prototype.getMetadataMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,string>} */ $8M67s.Message.getMapField(this, 7, opt_noLazyCreate, null);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.clearMetadataMap = function() {
    this.getMetadataMap().clear();
    return this;
};
/**
 * optional string new_customer_id = 8;
 * @return {string}
 */ proto.events.VehicleStateUpdated.prototype.getNewCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.setNewCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * repeated ReturnLineItem line_items = 9;
 * @return {!Array<!proto.events.ReturnLineItem>}
 */ proto.events.VehicleStateUpdated.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.events.ReturnLineItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.events.ReturnLineItem, 9);
};
/**
 * @param {!Array<!proto.events.ReturnLineItem>} value
 * @return {!proto.events.VehicleStateUpdated} returns this
*/ proto.events.VehicleStateUpdated.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.events.ReturnLineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.events.ReturnLineItem}
 */ proto.events.VehicleStateUpdated.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.events.ReturnLineItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.events.VehicleStateUpdated} returns this
 */ proto.events.VehicleStateUpdated.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.ReturnLineItem.prototype.toObject = function(opt_includeInstance) {
        return proto.events.ReturnLineItem.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.ReturnLineItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.ReturnLineItem.toObject = function(includeInstance, msg) {
        var f, obj = {
            title: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.ReturnLineItem}
 */ proto.events.ReturnLineItem.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.ReturnLineItem;
    return proto.events.ReturnLineItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.ReturnLineItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.ReturnLineItem}
 */ proto.events.ReturnLineItem.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setTitle(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.ReturnLineItem.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.ReturnLineItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.ReturnLineItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.ReturnLineItem.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTitle();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string title = 1;
 * @return {string}
 */ proto.events.ReturnLineItem.prototype.getTitle = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.ReturnLineItem} returns this
 */ proto.events.ReturnLineItem.prototype.setTitle = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 amount = 2;
 * @return {number}
 */ proto.events.ReturnLineItem.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.ReturnLineItem} returns this
 */ proto.events.ReturnLineItem.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleActivityUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleActivityUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleActivityUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleActivityUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            activity: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleActivityUpdated}
 */ proto.events.VehicleActivityUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleActivityUpdated;
    return proto.events.VehicleActivityUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleActivityUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleActivityUpdated}
 */ proto.events.VehicleActivityUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.vehicle.Activity} */ reader.readEnum();
                msg.setActivity(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleActivityUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleActivityUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleActivityUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleActivityUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getActivity();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional vehicle.Activity activity = 1;
 * @return {!proto.vehicle.Activity}
 */ proto.events.VehicleActivityUpdated.prototype.getActivity = function() {
    return /** @type {!proto.vehicle.Activity} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.vehicle.Activity} value
 * @return {!proto.events.VehicleActivityUpdated} returns this
 */ proto.events.VehicleActivityUpdated.prototype.setActivity = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleActivityStateUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleActivityStateUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleActivityStateUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleActivityStateUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            activityState: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleActivityStateUpdated}
 */ proto.events.VehicleActivityStateUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleActivityStateUpdated;
    return proto.events.VehicleActivityStateUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleActivityStateUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleActivityStateUpdated}
 */ proto.events.VehicleActivityStateUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.vehicle.ActivityState} */ reader.readEnum();
                msg.setActivityState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleActivityStateUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleActivityStateUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleActivityStateUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleActivityStateUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getActivityState();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional vehicle.ActivityState activity_state = 1;
 * @return {!proto.vehicle.ActivityState}
 */ proto.events.VehicleActivityStateUpdated.prototype.getActivityState = function() {
    return /** @type {!proto.vehicle.ActivityState} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.vehicle.ActivityState} value
 * @return {!proto.events.VehicleActivityStateUpdated} returns this
 */ proto.events.VehicleActivityStateUpdated.prototype.setActivityState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleActivityFailureUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleActivityFailureUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleActivityFailureUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleActivityFailureUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            activityFailure: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleActivityFailureUpdated}
 */ proto.events.VehicleActivityFailureUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleActivityFailureUpdated;
    return proto.events.VehicleActivityFailureUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleActivityFailureUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleActivityFailureUpdated}
 */ proto.events.VehicleActivityFailureUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.vehicle.ActivityFailure} */ reader.readEnum();
                msg.setActivityFailure(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleActivityFailureUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleActivityFailureUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleActivityFailureUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleActivityFailureUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getActivityFailure();
    if (f !== 0.0) writer.writeEnum(1, f);
};
/**
 * optional vehicle.ActivityFailure activity_failure = 1;
 * @return {!proto.vehicle.ActivityFailure}
 */ proto.events.VehicleActivityFailureUpdated.prototype.getActivityFailure = function() {
    return /** @type {!proto.vehicle.ActivityFailure} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.vehicle.ActivityFailure} value
 * @return {!proto.events.VehicleActivityFailureUpdated} returns this
 */ proto.events.VehicleActivityFailureUpdated.prototype.setActivityFailure = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.InvoiceToBePaid.prototype.toObject = function(opt_includeInstance) {
        return proto.events.InvoiceToBePaid.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.InvoiceToBePaid} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.InvoiceToBePaid.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.InvoiceToBePaid}
 */ proto.events.InvoiceToBePaid.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.InvoiceToBePaid;
    return proto.events.InvoiceToBePaid.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.InvoiceToBePaid} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.InvoiceToBePaid}
 */ proto.events.InvoiceToBePaid.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.InvoiceToBePaid.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.InvoiceToBePaid.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.InvoiceToBePaid} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.InvoiceToBePaid.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.InvoiceToBePaid.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.InvoiceToBePaid} returns this
 */ proto.events.InvoiceToBePaid.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.events.InvoiceToBePaid.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.InvoiceToBePaid} returns this
 */ proto.events.InvoiceToBePaid.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.SyncDealerships.prototype.toObject = function(opt_includeInstance) {
        return proto.events.SyncDealerships.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.SyncDealerships} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SyncDealerships.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.SyncDealerships}
 */ proto.events.SyncDealerships.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.SyncDealerships;
    return proto.events.SyncDealerships.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.SyncDealerships} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.SyncDealerships}
 */ proto.events.SyncDealerships.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.SyncDealerships.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.SyncDealerships.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.SyncDealerships} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SyncDealerships.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.events.DocumentAdded.oneofGroups_ = [
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ]
];
/**
 * @enum {number}
 */ proto.events.DocumentAdded.DoctypeCase = {
    DOCTYPE_NOT_SET: 0,
    INSPECTION: 1,
    REGISTRATION: 2,
    WARRANTY: 3,
    TITLE: 4,
    MAINTENANCE: 5,
    REG262: 6,
    REG51: 7,
    REG553: 8,
    PURCHASE_ORDER: 9,
    USED_VEHICLE_HISTORY_DISCLOSURE: 10,
    BUYERS_GUIDE: 11
};
/**
 * @return {proto.events.DocumentAdded.DoctypeCase}
 */ proto.events.DocumentAdded.prototype.getDoctypeCase = function() {
    return /** @type {proto.events.DocumentAdded.DoctypeCase} */ $8M67s.Message.computeOneofCase(this, proto.events.DocumentAdded.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.DocumentAdded.prototype.toObject = function(opt_includeInstance) {
        return proto.events.DocumentAdded.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.DocumentAdded} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.DocumentAdded.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspection: (f = msg.getInspection()) && $9YICB.Inspection.toObject(includeInstance, f),
            registration: (f = msg.getRegistration()) && $9YICB.Registration.toObject(includeInstance, f),
            warranty: (f = msg.getWarranty()) && $9YICB.Warranty.toObject(includeInstance, f),
            title: (f = msg.getTitle()) && $9YICB.Title.toObject(includeInstance, f),
            maintenance: (f = msg.getMaintenance()) && $9YICB.Maintenance.toObject(includeInstance, f),
            reg262: (f = msg.getReg262()) && $9YICB.Reg262.toObject(includeInstance, f),
            reg51: (f = msg.getReg51()) && $9YICB.Reg51.toObject(includeInstance, f),
            reg553: (f = msg.getReg553()) && $9YICB.Reg553.toObject(includeInstance, f),
            purchaseOrder: (f = msg.getPurchaseOrder()) && $9YICB.PurchaseOrder.toObject(includeInstance, f),
            usedVehicleHistoryDisclosure: (f = msg.getUsedVehicleHistoryDisclosure()) && $9YICB.UsedVehicleHistoryDisclosure.toObject(includeInstance, f),
            buyersGuide: (f = msg.getBuyersGuide()) && $9YICB.BuyersGuide.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.DocumentAdded}
 */ proto.events.DocumentAdded.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.DocumentAdded;
    return proto.events.DocumentAdded.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.DocumentAdded} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.DocumentAdded}
 */ proto.events.DocumentAdded.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Inspection;
                reader.readMessage(value, $9YICB.Inspection.deserializeBinaryFromReader);
                msg.setInspection(value);
                break;
            case 2:
                var value = new $9YICB.Registration;
                reader.readMessage(value, $9YICB.Registration.deserializeBinaryFromReader);
                msg.setRegistration(value);
                break;
            case 3:
                var value = new $9YICB.Warranty;
                reader.readMessage(value, $9YICB.Warranty.deserializeBinaryFromReader);
                msg.setWarranty(value);
                break;
            case 4:
                var value = new $9YICB.Title;
                reader.readMessage(value, $9YICB.Title.deserializeBinaryFromReader);
                msg.setTitle(value);
                break;
            case 5:
                var value = new $9YICB.Maintenance;
                reader.readMessage(value, $9YICB.Maintenance.deserializeBinaryFromReader);
                msg.setMaintenance(value);
                break;
            case 6:
                var value = new $9YICB.Reg262;
                reader.readMessage(value, $9YICB.Reg262.deserializeBinaryFromReader);
                msg.setReg262(value);
                break;
            case 7:
                var value = new $9YICB.Reg51;
                reader.readMessage(value, $9YICB.Reg51.deserializeBinaryFromReader);
                msg.setReg51(value);
                break;
            case 8:
                var value = new $9YICB.Reg553;
                reader.readMessage(value, $9YICB.Reg553.deserializeBinaryFromReader);
                msg.setReg553(value);
                break;
            case 9:
                var value = new $9YICB.PurchaseOrder;
                reader.readMessage(value, $9YICB.PurchaseOrder.deserializeBinaryFromReader);
                msg.setPurchaseOrder(value);
                break;
            case 10:
                var value = new $9YICB.UsedVehicleHistoryDisclosure;
                reader.readMessage(value, $9YICB.UsedVehicleHistoryDisclosure.deserializeBinaryFromReader);
                msg.setUsedVehicleHistoryDisclosure(value);
                break;
            case 11:
                var value = new $9YICB.BuyersGuide;
                reader.readMessage(value, $9YICB.BuyersGuide.deserializeBinaryFromReader);
                msg.setBuyersGuide(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.DocumentAdded.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.DocumentAdded.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.DocumentAdded} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.DocumentAdded.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspection();
    if (f != null) writer.writeMessage(1, f, $9YICB.Inspection.serializeBinaryToWriter);
    f = message.getRegistration();
    if (f != null) writer.writeMessage(2, f, $9YICB.Registration.serializeBinaryToWriter);
    f = message.getWarranty();
    if (f != null) writer.writeMessage(3, f, $9YICB.Warranty.serializeBinaryToWriter);
    f = message.getTitle();
    if (f != null) writer.writeMessage(4, f, $9YICB.Title.serializeBinaryToWriter);
    f = message.getMaintenance();
    if (f != null) writer.writeMessage(5, f, $9YICB.Maintenance.serializeBinaryToWriter);
    f = message.getReg262();
    if (f != null) writer.writeMessage(6, f, $9YICB.Reg262.serializeBinaryToWriter);
    f = message.getReg51();
    if (f != null) writer.writeMessage(7, f, $9YICB.Reg51.serializeBinaryToWriter);
    f = message.getReg553();
    if (f != null) writer.writeMessage(8, f, $9YICB.Reg553.serializeBinaryToWriter);
    f = message.getPurchaseOrder();
    if (f != null) writer.writeMessage(9, f, $9YICB.PurchaseOrder.serializeBinaryToWriter);
    f = message.getUsedVehicleHistoryDisclosure();
    if (f != null) writer.writeMessage(10, f, $9YICB.UsedVehicleHistoryDisclosure.serializeBinaryToWriter);
    f = message.getBuyersGuide();
    if (f != null) writer.writeMessage(11, f, $9YICB.BuyersGuide.serializeBinaryToWriter);
};
/**
 * optional vehicle.Inspection inspection = 1;
 * @return {?proto.vehicle.Inspection}
 */ proto.events.DocumentAdded.prototype.getInspection = function() {
    return /** @type{?proto.vehicle.Inspection} */ $8M67s.Message.getWrapperField(this, $9YICB.Inspection, 1);
};
/**
 * @param {?proto.vehicle.Inspection|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setInspection = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 1, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearInspection = function() {
    return this.setInspection(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasInspection = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional vehicle.Registration registration = 2;
 * @return {?proto.vehicle.Registration}
 */ proto.events.DocumentAdded.prototype.getRegistration = function() {
    return /** @type{?proto.vehicle.Registration} */ $8M67s.Message.getWrapperField(this, $9YICB.Registration, 2);
};
/**
 * @param {?proto.vehicle.Registration|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setRegistration = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 2, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearRegistration = function() {
    return this.setRegistration(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasRegistration = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional vehicle.Warranty warranty = 3;
 * @return {?proto.vehicle.Warranty}
 */ proto.events.DocumentAdded.prototype.getWarranty = function() {
    return /** @type{?proto.vehicle.Warranty} */ $8M67s.Message.getWrapperField(this, $9YICB.Warranty, 3);
};
/**
 * @param {?proto.vehicle.Warranty|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setWarranty = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 3, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearWarranty = function() {
    return this.setWarranty(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasWarranty = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional vehicle.Title title = 4;
 * @return {?proto.vehicle.Title}
 */ proto.events.DocumentAdded.prototype.getTitle = function() {
    return /** @type{?proto.vehicle.Title} */ $8M67s.Message.getWrapperField(this, $9YICB.Title, 4);
};
/**
 * @param {?proto.vehicle.Title|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setTitle = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 4, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearTitle = function() {
    return this.setTitle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasTitle = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional vehicle.Maintenance maintenance = 5;
 * @return {?proto.vehicle.Maintenance}
 */ proto.events.DocumentAdded.prototype.getMaintenance = function() {
    return /** @type{?proto.vehicle.Maintenance} */ $8M67s.Message.getWrapperField(this, $9YICB.Maintenance, 5);
};
/**
 * @param {?proto.vehicle.Maintenance|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setMaintenance = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 5, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearMaintenance = function() {
    return this.setMaintenance(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasMaintenance = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional vehicle.Reg262 reg262 = 6;
 * @return {?proto.vehicle.Reg262}
 */ proto.events.DocumentAdded.prototype.getReg262 = function() {
    return /** @type{?proto.vehicle.Reg262} */ $8M67s.Message.getWrapperField(this, $9YICB.Reg262, 6);
};
/**
 * @param {?proto.vehicle.Reg262|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setReg262 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 6, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearReg262 = function() {
    return this.setReg262(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasReg262 = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional vehicle.Reg51 reg51 = 7;
 * @return {?proto.vehicle.Reg51}
 */ proto.events.DocumentAdded.prototype.getReg51 = function() {
    return /** @type{?proto.vehicle.Reg51} */ $8M67s.Message.getWrapperField(this, $9YICB.Reg51, 7);
};
/**
 * @param {?proto.vehicle.Reg51|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setReg51 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 7, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearReg51 = function() {
    return this.setReg51(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasReg51 = function() {
    return $8M67s.Message.getField(this, 7) != null;
};
/**
 * optional vehicle.Reg553 reg553 = 8;
 * @return {?proto.vehicle.Reg553}
 */ proto.events.DocumentAdded.prototype.getReg553 = function() {
    return /** @type{?proto.vehicle.Reg553} */ $8M67s.Message.getWrapperField(this, $9YICB.Reg553, 8);
};
/**
 * @param {?proto.vehicle.Reg553|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setReg553 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 8, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearReg553 = function() {
    return this.setReg553(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasReg553 = function() {
    return $8M67s.Message.getField(this, 8) != null;
};
/**
 * optional vehicle.PurchaseOrder purchase_order = 9;
 * @return {?proto.vehicle.PurchaseOrder}
 */ proto.events.DocumentAdded.prototype.getPurchaseOrder = function() {
    return /** @type{?proto.vehicle.PurchaseOrder} */ $8M67s.Message.getWrapperField(this, $9YICB.PurchaseOrder, 9);
};
/**
 * @param {?proto.vehicle.PurchaseOrder|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setPurchaseOrder = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 9, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearPurchaseOrder = function() {
    return this.setPurchaseOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasPurchaseOrder = function() {
    return $8M67s.Message.getField(this, 9) != null;
};
/**
 * optional vehicle.UsedVehicleHistoryDisclosure used_vehicle_history_disclosure = 10;
 * @return {?proto.vehicle.UsedVehicleHistoryDisclosure}
 */ proto.events.DocumentAdded.prototype.getUsedVehicleHistoryDisclosure = function() {
    return /** @type{?proto.vehicle.UsedVehicleHistoryDisclosure} */ $8M67s.Message.getWrapperField(this, $9YICB.UsedVehicleHistoryDisclosure, 10);
};
/**
 * @param {?proto.vehicle.UsedVehicleHistoryDisclosure|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setUsedVehicleHistoryDisclosure = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 10, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearUsedVehicleHistoryDisclosure = function() {
    return this.setUsedVehicleHistoryDisclosure(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasUsedVehicleHistoryDisclosure = function() {
    return $8M67s.Message.getField(this, 10) != null;
};
/**
 * optional vehicle.BuyersGuide buyers_guide = 11;
 * @return {?proto.vehicle.BuyersGuide}
 */ proto.events.DocumentAdded.prototype.getBuyersGuide = function() {
    return /** @type{?proto.vehicle.BuyersGuide} */ $8M67s.Message.getWrapperField(this, $9YICB.BuyersGuide, 11);
};
/**
 * @param {?proto.vehicle.BuyersGuide|undefined} value
 * @return {!proto.events.DocumentAdded} returns this
*/ proto.events.DocumentAdded.prototype.setBuyersGuide = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 11, proto.events.DocumentAdded.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentAdded} returns this
 */ proto.events.DocumentAdded.prototype.clearBuyersGuide = function() {
    return this.setBuyersGuide(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentAdded.prototype.hasBuyersGuide = function() {
    return $8M67s.Message.getField(this, 11) != null;
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.events.DocumentDeleted.oneofGroups_ = [
    [
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ]
];
/**
 * @enum {number}
 */ proto.events.DocumentDeleted.DoctypeCase = {
    DOCTYPE_NOT_SET: 0,
    INSPECTION: 1,
    REGISTRATION: 2,
    WARRANTY: 3,
    TITLE: 4,
    MAINTENANCE: 5,
    REG262: 6,
    REG51: 7,
    REG553: 8,
    PURCHASE_ORDER: 9,
    USED_VEHICLE_HISTORY_DISCLOSURE: 10,
    BUYERS_GUIDE: 11
};
/**
 * @return {proto.events.DocumentDeleted.DoctypeCase}
 */ proto.events.DocumentDeleted.prototype.getDoctypeCase = function() {
    return /** @type {proto.events.DocumentDeleted.DoctypeCase} */ $8M67s.Message.computeOneofCase(this, proto.events.DocumentDeleted.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.DocumentDeleted.prototype.toObject = function(opt_includeInstance) {
        return proto.events.DocumentDeleted.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.DocumentDeleted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.DocumentDeleted.toObject = function(includeInstance, msg) {
        var f, obj = {
            inspection: (f = msg.getInspection()) && $9YICB.Inspection.toObject(includeInstance, f),
            registration: (f = msg.getRegistration()) && $9YICB.Registration.toObject(includeInstance, f),
            warranty: (f = msg.getWarranty()) && $9YICB.Warranty.toObject(includeInstance, f),
            title: (f = msg.getTitle()) && $9YICB.Title.toObject(includeInstance, f),
            maintenance: (f = msg.getMaintenance()) && $9YICB.Maintenance.toObject(includeInstance, f),
            reg262: (f = msg.getReg262()) && $9YICB.Reg262.toObject(includeInstance, f),
            reg51: (f = msg.getReg51()) && $9YICB.Reg51.toObject(includeInstance, f),
            reg553: (f = msg.getReg553()) && $9YICB.Reg553.toObject(includeInstance, f),
            purchaseOrder: (f = msg.getPurchaseOrder()) && $9YICB.PurchaseOrder.toObject(includeInstance, f),
            usedVehicleHistoryDisclosure: (f = msg.getUsedVehicleHistoryDisclosure()) && $9YICB.UsedVehicleHistoryDisclosure.toObject(includeInstance, f),
            buyersGuide: (f = msg.getBuyersGuide()) && $9YICB.BuyersGuide.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.DocumentDeleted}
 */ proto.events.DocumentDeleted.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.DocumentDeleted;
    return proto.events.DocumentDeleted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.DocumentDeleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.DocumentDeleted}
 */ proto.events.DocumentDeleted.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Inspection;
                reader.readMessage(value, $9YICB.Inspection.deserializeBinaryFromReader);
                msg.setInspection(value);
                break;
            case 2:
                var value = new $9YICB.Registration;
                reader.readMessage(value, $9YICB.Registration.deserializeBinaryFromReader);
                msg.setRegistration(value);
                break;
            case 3:
                var value = new $9YICB.Warranty;
                reader.readMessage(value, $9YICB.Warranty.deserializeBinaryFromReader);
                msg.setWarranty(value);
                break;
            case 4:
                var value = new $9YICB.Title;
                reader.readMessage(value, $9YICB.Title.deserializeBinaryFromReader);
                msg.setTitle(value);
                break;
            case 5:
                var value = new $9YICB.Maintenance;
                reader.readMessage(value, $9YICB.Maintenance.deserializeBinaryFromReader);
                msg.setMaintenance(value);
                break;
            case 6:
                var value = new $9YICB.Reg262;
                reader.readMessage(value, $9YICB.Reg262.deserializeBinaryFromReader);
                msg.setReg262(value);
                break;
            case 7:
                var value = new $9YICB.Reg51;
                reader.readMessage(value, $9YICB.Reg51.deserializeBinaryFromReader);
                msg.setReg51(value);
                break;
            case 8:
                var value = new $9YICB.Reg553;
                reader.readMessage(value, $9YICB.Reg553.deserializeBinaryFromReader);
                msg.setReg553(value);
                break;
            case 9:
                var value = new $9YICB.PurchaseOrder;
                reader.readMessage(value, $9YICB.PurchaseOrder.deserializeBinaryFromReader);
                msg.setPurchaseOrder(value);
                break;
            case 10:
                var value = new $9YICB.UsedVehicleHistoryDisclosure;
                reader.readMessage(value, $9YICB.UsedVehicleHistoryDisclosure.deserializeBinaryFromReader);
                msg.setUsedVehicleHistoryDisclosure(value);
                break;
            case 11:
                var value = new $9YICB.BuyersGuide;
                reader.readMessage(value, $9YICB.BuyersGuide.deserializeBinaryFromReader);
                msg.setBuyersGuide(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.DocumentDeleted.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.DocumentDeleted.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.DocumentDeleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.DocumentDeleted.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInspection();
    if (f != null) writer.writeMessage(1, f, $9YICB.Inspection.serializeBinaryToWriter);
    f = message.getRegistration();
    if (f != null) writer.writeMessage(2, f, $9YICB.Registration.serializeBinaryToWriter);
    f = message.getWarranty();
    if (f != null) writer.writeMessage(3, f, $9YICB.Warranty.serializeBinaryToWriter);
    f = message.getTitle();
    if (f != null) writer.writeMessage(4, f, $9YICB.Title.serializeBinaryToWriter);
    f = message.getMaintenance();
    if (f != null) writer.writeMessage(5, f, $9YICB.Maintenance.serializeBinaryToWriter);
    f = message.getReg262();
    if (f != null) writer.writeMessage(6, f, $9YICB.Reg262.serializeBinaryToWriter);
    f = message.getReg51();
    if (f != null) writer.writeMessage(7, f, $9YICB.Reg51.serializeBinaryToWriter);
    f = message.getReg553();
    if (f != null) writer.writeMessage(8, f, $9YICB.Reg553.serializeBinaryToWriter);
    f = message.getPurchaseOrder();
    if (f != null) writer.writeMessage(9, f, $9YICB.PurchaseOrder.serializeBinaryToWriter);
    f = message.getUsedVehicleHistoryDisclosure();
    if (f != null) writer.writeMessage(10, f, $9YICB.UsedVehicleHistoryDisclosure.serializeBinaryToWriter);
    f = message.getBuyersGuide();
    if (f != null) writer.writeMessage(11, f, $9YICB.BuyersGuide.serializeBinaryToWriter);
};
/**
 * optional vehicle.Inspection inspection = 1;
 * @return {?proto.vehicle.Inspection}
 */ proto.events.DocumentDeleted.prototype.getInspection = function() {
    return /** @type{?proto.vehicle.Inspection} */ $8M67s.Message.getWrapperField(this, $9YICB.Inspection, 1);
};
/**
 * @param {?proto.vehicle.Inspection|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setInspection = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 1, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearInspection = function() {
    return this.setInspection(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasInspection = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional vehicle.Registration registration = 2;
 * @return {?proto.vehicle.Registration}
 */ proto.events.DocumentDeleted.prototype.getRegistration = function() {
    return /** @type{?proto.vehicle.Registration} */ $8M67s.Message.getWrapperField(this, $9YICB.Registration, 2);
};
/**
 * @param {?proto.vehicle.Registration|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setRegistration = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 2, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearRegistration = function() {
    return this.setRegistration(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasRegistration = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional vehicle.Warranty warranty = 3;
 * @return {?proto.vehicle.Warranty}
 */ proto.events.DocumentDeleted.prototype.getWarranty = function() {
    return /** @type{?proto.vehicle.Warranty} */ $8M67s.Message.getWrapperField(this, $9YICB.Warranty, 3);
};
/**
 * @param {?proto.vehicle.Warranty|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setWarranty = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 3, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearWarranty = function() {
    return this.setWarranty(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasWarranty = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional vehicle.Title title = 4;
 * @return {?proto.vehicle.Title}
 */ proto.events.DocumentDeleted.prototype.getTitle = function() {
    return /** @type{?proto.vehicle.Title} */ $8M67s.Message.getWrapperField(this, $9YICB.Title, 4);
};
/**
 * @param {?proto.vehicle.Title|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setTitle = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 4, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearTitle = function() {
    return this.setTitle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasTitle = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional vehicle.Maintenance maintenance = 5;
 * @return {?proto.vehicle.Maintenance}
 */ proto.events.DocumentDeleted.prototype.getMaintenance = function() {
    return /** @type{?proto.vehicle.Maintenance} */ $8M67s.Message.getWrapperField(this, $9YICB.Maintenance, 5);
};
/**
 * @param {?proto.vehicle.Maintenance|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setMaintenance = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 5, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearMaintenance = function() {
    return this.setMaintenance(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasMaintenance = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional vehicle.Reg262 reg262 = 6;
 * @return {?proto.vehicle.Reg262}
 */ proto.events.DocumentDeleted.prototype.getReg262 = function() {
    return /** @type{?proto.vehicle.Reg262} */ $8M67s.Message.getWrapperField(this, $9YICB.Reg262, 6);
};
/**
 * @param {?proto.vehicle.Reg262|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setReg262 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 6, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearReg262 = function() {
    return this.setReg262(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasReg262 = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
/**
 * optional vehicle.Reg51 reg51 = 7;
 * @return {?proto.vehicle.Reg51}
 */ proto.events.DocumentDeleted.prototype.getReg51 = function() {
    return /** @type{?proto.vehicle.Reg51} */ $8M67s.Message.getWrapperField(this, $9YICB.Reg51, 7);
};
/**
 * @param {?proto.vehicle.Reg51|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setReg51 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 7, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearReg51 = function() {
    return this.setReg51(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasReg51 = function() {
    return $8M67s.Message.getField(this, 7) != null;
};
/**
 * optional vehicle.Reg553 reg553 = 8;
 * @return {?proto.vehicle.Reg553}
 */ proto.events.DocumentDeleted.prototype.getReg553 = function() {
    return /** @type{?proto.vehicle.Reg553} */ $8M67s.Message.getWrapperField(this, $9YICB.Reg553, 8);
};
/**
 * @param {?proto.vehicle.Reg553|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setReg553 = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 8, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearReg553 = function() {
    return this.setReg553(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasReg553 = function() {
    return $8M67s.Message.getField(this, 8) != null;
};
/**
 * optional vehicle.PurchaseOrder purchase_order = 9;
 * @return {?proto.vehicle.PurchaseOrder}
 */ proto.events.DocumentDeleted.prototype.getPurchaseOrder = function() {
    return /** @type{?proto.vehicle.PurchaseOrder} */ $8M67s.Message.getWrapperField(this, $9YICB.PurchaseOrder, 9);
};
/**
 * @param {?proto.vehicle.PurchaseOrder|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setPurchaseOrder = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 9, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearPurchaseOrder = function() {
    return this.setPurchaseOrder(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasPurchaseOrder = function() {
    return $8M67s.Message.getField(this, 9) != null;
};
/**
 * optional vehicle.UsedVehicleHistoryDisclosure used_vehicle_history_disclosure = 10;
 * @return {?proto.vehicle.UsedVehicleHistoryDisclosure}
 */ proto.events.DocumentDeleted.prototype.getUsedVehicleHistoryDisclosure = function() {
    return /** @type{?proto.vehicle.UsedVehicleHistoryDisclosure} */ $8M67s.Message.getWrapperField(this, $9YICB.UsedVehicleHistoryDisclosure, 10);
};
/**
 * @param {?proto.vehicle.UsedVehicleHistoryDisclosure|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setUsedVehicleHistoryDisclosure = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 10, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearUsedVehicleHistoryDisclosure = function() {
    return this.setUsedVehicleHistoryDisclosure(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasUsedVehicleHistoryDisclosure = function() {
    return $8M67s.Message.getField(this, 10) != null;
};
/**
 * optional vehicle.BuyersGuide buyers_guide = 11;
 * @return {?proto.vehicle.BuyersGuide}
 */ proto.events.DocumentDeleted.prototype.getBuyersGuide = function() {
    return /** @type{?proto.vehicle.BuyersGuide} */ $8M67s.Message.getWrapperField(this, $9YICB.BuyersGuide, 11);
};
/**
 * @param {?proto.vehicle.BuyersGuide|undefined} value
 * @return {!proto.events.DocumentDeleted} returns this
*/ proto.events.DocumentDeleted.prototype.setBuyersGuide = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 11, proto.events.DocumentDeleted.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.DocumentDeleted} returns this
 */ proto.events.DocumentDeleted.prototype.clearBuyersGuide = function() {
    return this.setBuyersGuide(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.DocumentDeleted.prototype.hasBuyersGuide = function() {
    return $8M67s.Message.getField(this, 11) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.OfferSubmitted.prototype.toObject = function(opt_includeInstance) {
        return proto.events.OfferSubmitted.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.OfferSubmitted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.OfferSubmitted.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.OfferSubmitted}
 */ proto.events.OfferSubmitted.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.OfferSubmitted;
    return proto.events.OfferSubmitted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.OfferSubmitted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.OfferSubmitted}
 */ proto.events.OfferSubmitted.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.OfferSubmitted.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.OfferSubmitted.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.OfferSubmitted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.OfferSubmitted.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.events.OfferSubmitted.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.OfferSubmitted} returns this
 */ proto.events.OfferSubmitted.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.events.OfferSubmitted.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.OfferSubmitted} returns this
 */ proto.events.OfferSubmitted.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 4;
 * @return {string}
 */ proto.events.OfferSubmitted.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.OfferSubmitted} returns this
 */ proto.events.OfferSubmitted.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int32 amount = 5;
 * @return {number}
 */ proto.events.OfferSubmitted.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.OfferSubmitted} returns this
 */ proto.events.OfferSubmitted.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.SubscriptionContractAdded.prototype.toObject = function(opt_includeInstance) {
        return proto.events.SubscriptionContractAdded.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.SubscriptionContractAdded} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SubscriptionContractAdded.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            contractUri: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            contractStartMileage: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.SubscriptionContractAdded}
 */ proto.events.SubscriptionContractAdded.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.SubscriptionContractAdded;
    return proto.events.SubscriptionContractAdded.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.SubscriptionContractAdded} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.SubscriptionContractAdded}
 */ proto.events.SubscriptionContractAdded.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setContractUri(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setContractStartMileage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.SubscriptionContractAdded.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.SubscriptionContractAdded.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.SubscriptionContractAdded} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SubscriptionContractAdded.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getContractUri();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getContractStartMileage();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.SubscriptionContractAdded.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionContractAdded} returns this
 */ proto.events.SubscriptionContractAdded.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.events.SubscriptionContractAdded.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionContractAdded} returns this
 */ proto.events.SubscriptionContractAdded.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string contract_uri = 3;
 * @return {string}
 */ proto.events.SubscriptionContractAdded.prototype.getContractUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionContractAdded} returns this
 */ proto.events.SubscriptionContractAdded.prototype.setContractUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 contract_start_mileage = 4;
 * @return {number}
 */ proto.events.SubscriptionContractAdded.prototype.getContractStartMileage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.SubscriptionContractAdded} returns this
 */ proto.events.SubscriptionContractAdded.prototype.setContractStartMileage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleInspectionStarted.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleInspectionStarted.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleInspectionStarted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleInspectionStarted.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            inspectionStarted: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            vin: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleInspectionStarted}
 */ proto.events.VehicleInspectionStarted.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleInspectionStarted;
    return proto.events.VehicleInspectionStarted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleInspectionStarted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleInspectionStarted}
 */ proto.events.VehicleInspectionStarted.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setInspectionStarted(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleInspectionStarted.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleInspectionStarted.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleInspectionStarted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleInspectionStarted.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getInspectionStarted();
    if (f !== 0) writer.writeInt64(3, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.VehicleInspectionStarted.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionStarted} returns this
 */ proto.events.VehicleInspectionStarted.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.events.VehicleInspectionStarted.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionStarted} returns this
 */ proto.events.VehicleInspectionStarted.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 inspection_started = 3;
 * @return {number}
 */ proto.events.VehicleInspectionStarted.prototype.getInspectionStarted = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.VehicleInspectionStarted} returns this
 */ proto.events.VehicleInspectionStarted.prototype.setInspectionStarted = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string vin = 4;
 * @return {string}
 */ proto.events.VehicleInspectionStarted.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionStarted} returns this
 */ proto.events.VehicleInspectionStarted.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleInspectionPhotoUrl.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleInspectionPhotoUrl.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleInspectionPhotoUrl} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleInspectionPhotoUrl.toObject = function(includeInstance, msg) {
        var f, obj = {
            url: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            label: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleInspectionPhotoUrl}
 */ proto.events.VehicleInspectionPhotoUrl.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleInspectionPhotoUrl;
    return proto.events.VehicleInspectionPhotoUrl.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleInspectionPhotoUrl} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleInspectionPhotoUrl}
 */ proto.events.VehicleInspectionPhotoUrl.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setUrl(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLabel(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleInspectionPhotoUrl.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleInspectionPhotoUrl.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleInspectionPhotoUrl} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleInspectionPhotoUrl.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUrl();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLabel();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string url = 1;
 * @return {string}
 */ proto.events.VehicleInspectionPhotoUrl.prototype.getUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionPhotoUrl} returns this
 */ proto.events.VehicleInspectionPhotoUrl.prototype.setUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string label = 2;
 * @return {string}
 */ proto.events.VehicleInspectionPhotoUrl.prototype.getLabel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionPhotoUrl} returns this
 */ proto.events.VehicleInspectionPhotoUrl.prototype.setLabel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.events.VehicleInspectionCompleted.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleInspectionCompleted.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleInspectionCompleted.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleInspectionCompleted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleInspectionCompleted.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            photoUrlsList: $8M67s.Message.toObjectList(msg.getPhotoUrlsList(), proto.events.VehicleInspectionPhotoUrl.toObject, includeInstance),
            reportPdfUrl: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            rawReport: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            inspectionId: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            results: (f = msg.getResults()) && $gjhG2.InspectionResults.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleInspectionCompleted}
 */ proto.events.VehicleInspectionCompleted.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleInspectionCompleted;
    return proto.events.VehicleInspectionCompleted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleInspectionCompleted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleInspectionCompleted}
 */ proto.events.VehicleInspectionCompleted.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = new proto.events.VehicleInspectionPhotoUrl;
                reader.readMessage(value, proto.events.VehicleInspectionPhotoUrl.deserializeBinaryFromReader);
                msg.addPhotoUrls(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setReportPdfUrl(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setRawReport(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setInspectionId(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 10:
                var value = new $gjhG2.InspectionResults;
                reader.readMessage(value, $gjhG2.InspectionResults.deserializeBinaryFromReader);
                msg.setResults(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleInspectionCompleted.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleInspectionCompleted.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleInspectionCompleted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleInspectionCompleted.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getPhotoUrlsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.events.VehicleInspectionPhotoUrl.serializeBinaryToWriter);
    f = message.getReportPdfUrl();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getRawReport();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getInspectionId();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getResults();
    if (f != null) writer.writeMessage(10, f, $gjhG2.InspectionResults.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.VehicleInspectionCompleted.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.events.VehicleInspectionCompleted.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated VehicleInspectionPhotoUrl photo_urls = 3;
 * @return {!Array<!proto.events.VehicleInspectionPhotoUrl>}
 */ proto.events.VehicleInspectionCompleted.prototype.getPhotoUrlsList = function() {
    return /** @type{!Array<!proto.events.VehicleInspectionPhotoUrl>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.events.VehicleInspectionPhotoUrl, 3);
};
/**
 * @param {!Array<!proto.events.VehicleInspectionPhotoUrl>} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
*/ proto.events.VehicleInspectionCompleted.prototype.setPhotoUrlsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.events.VehicleInspectionPhotoUrl=} opt_value
 * @param {number=} opt_index
 * @return {!proto.events.VehicleInspectionPhotoUrl}
 */ proto.events.VehicleInspectionCompleted.prototype.addPhotoUrls = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.events.VehicleInspectionPhotoUrl, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.clearPhotoUrlsList = function() {
    return this.setPhotoUrlsList([]);
};
/**
 * optional string report_pdf_url = 4;
 * @return {string}
 */ proto.events.VehicleInspectionCompleted.prototype.getReportPdfUrl = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.setReportPdfUrl = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string raw_report = 5;
 * @return {string}
 */ proto.events.VehicleInspectionCompleted.prototype.getRawReport = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.setRawReport = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string subscription_id = 6;
 * @return {string}
 */ proto.events.VehicleInspectionCompleted.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string dealer_id = 7;
 * @return {string}
 */ proto.events.VehicleInspectionCompleted.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string inspection_id = 8;
 * @return {string}
 */ proto.events.VehicleInspectionCompleted.prototype.getInspectionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.setInspectionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string vin = 9;
 * @return {string}
 */ proto.events.VehicleInspectionCompleted.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional inspection.InspectionResults results = 10;
 * @return {?proto.inspection.InspectionResults}
 */ proto.events.VehicleInspectionCompleted.prototype.getResults = function() {
    return /** @type{?proto.inspection.InspectionResults} */ $8M67s.Message.getWrapperField(this, $gjhG2.InspectionResults, 10);
};
/**
 * @param {?proto.inspection.InspectionResults|undefined} value
 * @return {!proto.events.VehicleInspectionCompleted} returns this
*/ proto.events.VehicleInspectionCompleted.prototype.setResults = function(value) {
    return $8M67s.Message.setWrapperField(this, 10, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.VehicleInspectionCompleted} returns this
 */ proto.events.VehicleInspectionCompleted.prototype.clearResults = function() {
    return this.setResults(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.VehicleInspectionCompleted.prototype.hasResults = function() {
    return $8M67s.Message.getField(this, 10) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.OfferResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.events.OfferResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.OfferResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.OfferResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            response: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false),
            reason: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.OfferResponse}
 */ proto.events.OfferResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.OfferResponse;
    return proto.events.OfferResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.OfferResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.OfferResponse}
 */ proto.events.OfferResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setResponse(value);
                break;
            case 5:
                var value = /** @type {!proto.events.OfferReason} */ reader.readEnum();
                msg.setReason(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.OfferResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.OfferResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.OfferResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.OfferResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getResponse();
    if (f) writer.writeBool(4, f);
    f = message.getReason();
    if (f !== 0.0) writer.writeEnum(5, f);
};
/**
 * optional string dealer_id = 1;
 * @return {string}
 */ proto.events.OfferResponse.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.OfferResponse} returns this
 */ proto.events.OfferResponse.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.events.OfferResponse.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.OfferResponse} returns this
 */ proto.events.OfferResponse.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_id = 3;
 * @return {string}
 */ proto.events.OfferResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.OfferResponse} returns this
 */ proto.events.OfferResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional bool response = 4;
 * @return {boolean}
 */ proto.events.OfferResponse.prototype.getResponse = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.events.OfferResponse} returns this
 */ proto.events.OfferResponse.prototype.setResponse = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 4, value);
};
/**
 * optional OfferReason reason = 5;
 * @return {!proto.events.OfferReason}
 */ proto.events.OfferResponse.prototype.getReason = function() {
    return /** @type {!proto.events.OfferReason} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.events.OfferReason} value
 * @return {!proto.events.OfferResponse} returns this
 */ proto.events.OfferResponse.prototype.setReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleTosAccepted.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleTosAccepted.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleTosAccepted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleTosAccepted.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            userId: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleTosAccepted}
 */ proto.events.VehicleTosAccepted.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleTosAccepted;
    return proto.events.VehicleTosAccepted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleTosAccepted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleTosAccepted}
 */ proto.events.VehicleTosAccepted.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setUserId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleTosAccepted.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleTosAccepted.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleTosAccepted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleTosAccepted.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getUserId();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.events.VehicleTosAccepted.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleTosAccepted} returns this
 */ proto.events.VehicleTosAccepted.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 timestamp = 2;
 * @return {number}
 */ proto.events.VehicleTosAccepted.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.VehicleTosAccepted} returns this
 */ proto.events.VehicleTosAccepted.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string dealer_id = 3;
 * @return {string}
 */ proto.events.VehicleTosAccepted.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleTosAccepted} returns this
 */ proto.events.VehicleTosAccepted.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string user_id = 4;
 * @return {string}
 */ proto.events.VehicleTosAccepted.prototype.getUserId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleTosAccepted} returns this
 */ proto.events.VehicleTosAccepted.prototype.setUserId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.ReloadDomain.prototype.toObject = function(opt_includeInstance) {
        return proto.events.ReloadDomain.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.ReloadDomain} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.ReloadDomain.toObject = function(includeInstance, msg) {
        var f, obj = {
            domain: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            domainId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.ReloadDomain}
 */ proto.events.ReloadDomain.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.ReloadDomain;
    return proto.events.ReloadDomain.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.ReloadDomain} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.ReloadDomain}
 */ proto.events.ReloadDomain.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.events.Domain} */ reader.readEnum();
                msg.setDomain(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDomainId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.ReloadDomain.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.ReloadDomain.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.ReloadDomain} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.ReloadDomain.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDomain();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getDomainId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional Domain domain = 1;
 * @return {!proto.events.Domain}
 */ proto.events.ReloadDomain.prototype.getDomain = function() {
    return /** @type {!proto.events.Domain} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.events.Domain} value
 * @return {!proto.events.ReloadDomain} returns this
 */ proto.events.ReloadDomain.prototype.setDomain = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string domain_id = 2;
 * @return {string}
 */ proto.events.ReloadDomain.prototype.getDomainId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.ReloadDomain} returns this
 */ proto.events.ReloadDomain.prototype.setDomainId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.events.CancelPaymentTransaction.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CancelPaymentTransaction.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CancelPaymentTransaction.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CancelPaymentTransaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CancelPaymentTransaction.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            transactionsList: $8M67s.Message.toObjectList(msg.getTransactionsList(), $3QqPt.Transaction.toObject, includeInstance),
            refundAmount: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 6, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CancelPaymentTransaction}
 */ proto.events.CancelPaymentTransaction.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CancelPaymentTransaction;
    return proto.events.CancelPaymentTransaction.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CancelPaymentTransaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CancelPaymentTransaction}
 */ proto.events.CancelPaymentTransaction.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new $3QqPt.Transaction;
                reader.readMessage(value, $3QqPt.Transaction.deserializeBinaryFromReader);
                msg.addTransactions(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRefundAmount(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CancelPaymentTransaction.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CancelPaymentTransaction.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CancelPaymentTransaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CancelPaymentTransaction.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTransactionsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.Transaction.serializeBinaryToWriter);
    f = message.getRefundAmount();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(6, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.CancelPaymentTransaction.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CancelPaymentTransaction} returns this
 */ proto.events.CancelPaymentTransaction.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated domain.Transaction transactions = 2;
 * @return {!Array<!proto.domain.Transaction>}
 */ proto.events.CancelPaymentTransaction.prototype.getTransactionsList = function() {
    return /** @type{!Array<!proto.domain.Transaction>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Transaction, 2);
};
/**
 * @param {!Array<!proto.domain.Transaction>} value
 * @return {!proto.events.CancelPaymentTransaction} returns this
*/ proto.events.CancelPaymentTransaction.prototype.setTransactionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Transaction}
 */ proto.events.CancelPaymentTransaction.prototype.addTransactions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.Transaction, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.events.CancelPaymentTransaction} returns this
 */ proto.events.CancelPaymentTransaction.prototype.clearTransactionsList = function() {
    return this.setTransactionsList([]);
};
/**
 * optional int32 refund_amount = 3;
 * @return {number}
 */ proto.events.CancelPaymentTransaction.prototype.getRefundAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.CancelPaymentTransaction} returns this
 */ proto.events.CancelPaymentTransaction.prototype.setRefundAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string account_number = 4;
 * @return {string}
 */ proto.events.CancelPaymentTransaction.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CancelPaymentTransaction} returns this
 */ proto.events.CancelPaymentTransaction.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string invoice_number = 5;
 * @return {string}
 */ proto.events.CancelPaymentTransaction.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CancelPaymentTransaction} returns this
 */ proto.events.CancelPaymentTransaction.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string subscription_id = 6;
 * @return {string}
 */ proto.events.CancelPaymentTransaction.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CancelPaymentTransaction} returns this
 */ proto.events.CancelPaymentTransaction.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.SmsReceived.prototype.toObject = function(opt_includeInstance) {
        return proto.events.SmsReceived.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.SmsReceived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SmsReceived.toObject = function(includeInstance, msg) {
        var f, obj = {
            senderDomain: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            senderDomainId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            senderPhone: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            message: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.SmsReceived}
 */ proto.events.SmsReceived.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.SmsReceived;
    return proto.events.SmsReceived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.SmsReceived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.SmsReceived}
 */ proto.events.SmsReceived.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.events.Domain} */ reader.readEnum();
                msg.setSenderDomain(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSenderDomainId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSenderPhone(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.SmsReceived.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.SmsReceived.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.SmsReceived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SmsReceived.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSenderDomain();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getSenderDomainId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSenderPhone();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional Domain sender_domain = 1;
 * @return {!proto.events.Domain}
 */ proto.events.SmsReceived.prototype.getSenderDomain = function() {
    return /** @type {!proto.events.Domain} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.events.Domain} value
 * @return {!proto.events.SmsReceived} returns this
 */ proto.events.SmsReceived.prototype.setSenderDomain = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string sender_domain_id = 2;
 * @return {string}
 */ proto.events.SmsReceived.prototype.getSenderDomainId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SmsReceived} returns this
 */ proto.events.SmsReceived.prototype.setSenderDomainId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string sender_phone = 3;
 * @return {string}
 */ proto.events.SmsReceived.prototype.getSenderPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SmsReceived} returns this
 */ proto.events.SmsReceived.prototype.setSenderPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string message = 4;
 * @return {string}
 */ proto.events.SmsReceived.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SmsReceived} returns this
 */ proto.events.SmsReceived.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerScored.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerScored.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerScored} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerScored.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            score: (f = msg.getScore()) && $3QqPt.Score.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerScored}
 */ proto.events.CustomerScored.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerScored;
    return proto.events.CustomerScored.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerScored} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerScored}
 */ proto.events.CustomerScored.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new $3QqPt.Score;
                reader.readMessage(value, $3QqPt.Score.deserializeBinaryFromReader);
                msg.setScore(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerScored.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerScored.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerScored} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerScored.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getScore();
    if (f != null) writer.writeMessage(2, f, $3QqPt.Score.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.CustomerScored.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerScored} returns this
 */ proto.events.CustomerScored.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.Score score = 2;
 * @return {?proto.domain.Score}
 */ proto.events.CustomerScored.prototype.getScore = function() {
    return /** @type{?proto.domain.Score} */ $8M67s.Message.getWrapperField(this, $3QqPt.Score, 2);
};
/**
 * @param {?proto.domain.Score|undefined} value
 * @return {!proto.events.CustomerScored} returns this
*/ proto.events.CustomerScored.prototype.setScore = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.CustomerScored} returns this
 */ proto.events.CustomerScored.prototype.clearScore = function() {
    return this.setScore(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.CustomerScored.prototype.hasScore = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerQualified.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerQualified.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerQualified} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerQualified.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            tier: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            score: (f = msg.getScore()) && $3QqPt.Score.toObject(includeInstance, f),
            origin: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            state: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerQualified}
 */ proto.events.CustomerQualified.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerQualified;
    return proto.events.CustomerQualified.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerQualified} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerQualified}
 */ proto.events.CustomerQualified.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.QualificationTier} */ reader.readEnum();
                msg.setTier(value);
                break;
            case 3:
                var value = new $3QqPt.Score;
                reader.readMessage(value, $3QqPt.Score.deserializeBinaryFromReader);
                msg.setScore(value);
                break;
            case 4:
                var value = /** @type {!proto.domain.QualificationOrigin} */ reader.readEnum();
                msg.setOrigin(value);
                break;
            case 5:
                var value = /** @type {!proto.customer_service.QualificationState} */ reader.readEnum();
                msg.setState(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerQualified.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerQualified.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerQualified} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerQualified.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTier();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getScore();
    if (f != null) writer.writeMessage(3, f, $3QqPt.Score.serializeBinaryToWriter);
    f = message.getOrigin();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getState();
    if (f !== 0.0) writer.writeEnum(5, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.CustomerQualified.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerQualified} returns this
 */ proto.events.CustomerQualified.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.QualificationTier tier = 2;
 * @return {!proto.domain.QualificationTier}
 */ proto.events.CustomerQualified.prototype.getTier = function() {
    return /** @type {!proto.domain.QualificationTier} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.QualificationTier} value
 * @return {!proto.events.CustomerQualified} returns this
 */ proto.events.CustomerQualified.prototype.setTier = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional domain.Score score = 3;
 * @return {?proto.domain.Score}
 */ proto.events.CustomerQualified.prototype.getScore = function() {
    return /** @type{?proto.domain.Score} */ $8M67s.Message.getWrapperField(this, $3QqPt.Score, 3);
};
/**
 * @param {?proto.domain.Score|undefined} value
 * @return {!proto.events.CustomerQualified} returns this
*/ proto.events.CustomerQualified.prototype.setScore = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.CustomerQualified} returns this
 */ proto.events.CustomerQualified.prototype.clearScore = function() {
    return this.setScore(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.CustomerQualified.prototype.hasScore = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional domain.QualificationOrigin origin = 4;
 * @return {!proto.domain.QualificationOrigin}
 */ proto.events.CustomerQualified.prototype.getOrigin = function() {
    return /** @type {!proto.domain.QualificationOrigin} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.domain.QualificationOrigin} value
 * @return {!proto.events.CustomerQualified} returns this
 */ proto.events.CustomerQualified.prototype.setOrigin = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional customer_service.QualificationState state = 5;
 * @return {!proto.customer_service.QualificationState}
 */ proto.events.CustomerQualified.prototype.getState = function() {
    return /** @type {!proto.customer_service.QualificationState} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.customer_service.QualificationState} value
 * @return {!proto.events.CustomerQualified} returns this
 */ proto.events.CustomerQualified.prototype.setState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerScoreDisqualified.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerScoreDisqualified.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerScoreDisqualified} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerScoreDisqualified.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            reason: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            score: (f = msg.getScore()) && $3QqPt.Score.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerScoreDisqualified}
 */ proto.events.CustomerScoreDisqualified.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerScoreDisqualified;
    return proto.events.CustomerScoreDisqualified.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerScoreDisqualified} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerScoreDisqualified}
 */ proto.events.CustomerScoreDisqualified.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.DisqualificationReason} */ reader.readEnum();
                msg.setReason(value);
                break;
            case 3:
                var value = new $3QqPt.Score;
                reader.readMessage(value, $3QqPt.Score.deserializeBinaryFromReader);
                msg.setScore(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerScoreDisqualified.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerScoreDisqualified.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerScoreDisqualified} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerScoreDisqualified.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReason();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getScore();
    if (f != null) writer.writeMessage(3, f, $3QqPt.Score.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.CustomerScoreDisqualified.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerScoreDisqualified} returns this
 */ proto.events.CustomerScoreDisqualified.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.DisqualificationReason reason = 2;
 * @return {!proto.domain.DisqualificationReason}
 */ proto.events.CustomerScoreDisqualified.prototype.getReason = function() {
    return /** @type {!proto.domain.DisqualificationReason} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.DisqualificationReason} value
 * @return {!proto.events.CustomerScoreDisqualified} returns this
 */ proto.events.CustomerScoreDisqualified.prototype.setReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional domain.Score score = 3;
 * @return {?proto.domain.Score}
 */ proto.events.CustomerScoreDisqualified.prototype.getScore = function() {
    return /** @type{?proto.domain.Score} */ $8M67s.Message.getWrapperField(this, $3QqPt.Score, 3);
};
/**
 * @param {?proto.domain.Score|undefined} value
 * @return {!proto.events.CustomerScoreDisqualified} returns this
*/ proto.events.CustomerScoreDisqualified.prototype.setScore = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.CustomerScoreDisqualified} returns this
 */ proto.events.CustomerScoreDisqualified.prototype.clearScore = function() {
    return this.setScore(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.CustomerScoreDisqualified.prototype.hasScore = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.CustomerDataEnriched.prototype.toObject = function(opt_includeInstance) {
        return proto.events.CustomerDataEnriched.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.CustomerDataEnriched} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerDataEnriched.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            address: (f = msg.getAddress()) && $3QqPt.Address.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.CustomerDataEnriched}
 */ proto.events.CustomerDataEnriched.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.CustomerDataEnriched;
    return proto.events.CustomerDataEnriched.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.CustomerDataEnriched} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.CustomerDataEnriched}
 */ proto.events.CustomerDataEnriched.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 6:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.CustomerDataEnriched.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.CustomerDataEnriched.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.CustomerDataEnriched} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.CustomerDataEnriched.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getAddress();
    if (f != null) writer.writeMessage(6, f, $3QqPt.Address.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.events.CustomerDataEnriched.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerDataEnriched} returns this
 */ proto.events.CustomerDataEnriched.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string first_name = 2;
 * @return {string}
 */ proto.events.CustomerDataEnriched.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerDataEnriched} returns this
 */ proto.events.CustomerDataEnriched.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string last_name = 3;
 * @return {string}
 */ proto.events.CustomerDataEnriched.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerDataEnriched} returns this
 */ proto.events.CustomerDataEnriched.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string email = 4;
 * @return {string}
 */ proto.events.CustomerDataEnriched.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerDataEnriched} returns this
 */ proto.events.CustomerDataEnriched.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string phone = 5;
 * @return {string}
 */ proto.events.CustomerDataEnriched.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.events.CustomerDataEnriched} returns this
 */ proto.events.CustomerDataEnriched.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional domain.Address address = 6;
 * @return {?proto.domain.Address}
 */ proto.events.CustomerDataEnriched.prototype.getAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 6);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.events.CustomerDataEnriched} returns this
*/ proto.events.CustomerDataEnriched.prototype.setAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.CustomerDataEnriched} returns this
 */ proto.events.CustomerDataEnriched.prototype.clearAddress = function() {
    return this.setAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.CustomerDataEnriched.prototype.hasAddress = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.SyncIngestion.prototype.toObject = function(opt_includeInstance) {
        return proto.events.SyncIngestion.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.SyncIngestion} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SyncIngestion.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.SyncIngestion}
 */ proto.events.SyncIngestion.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.SyncIngestion;
    return proto.events.SyncIngestion.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.SyncIngestion} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.SyncIngestion}
 */ proto.events.SyncIngestion.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.SyncIngestion.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.SyncIngestion.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.SyncIngestion} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SyncIngestion.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.ExtendInsurancePolicies.prototype.toObject = function(opt_includeInstance) {
        return proto.events.ExtendInsurancePolicies.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.ExtendInsurancePolicies} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.ExtendInsurancePolicies.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.ExtendInsurancePolicies}
 */ proto.events.ExtendInsurancePolicies.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.ExtendInsurancePolicies;
    return proto.events.ExtendInsurancePolicies.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.ExtendInsurancePolicies} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.ExtendInsurancePolicies}
 */ proto.events.ExtendInsurancePolicies.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.ExtendInsurancePolicies.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.ExtendInsurancePolicies.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.ExtendInsurancePolicies} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.ExtendInsurancePolicies.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.MilesPurchased.prototype.toObject = function(opt_includeInstance) {
        return proto.events.MilesPurchased.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.MilesPurchased} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.MilesPurchased.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            miles: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            purchaseAmount: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.MilesPurchased}
 */ proto.events.MilesPurchased.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.MilesPurchased;
    return proto.events.MilesPurchased.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.MilesPurchased} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.MilesPurchased}
 */ proto.events.MilesPurchased.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMiles(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPurchaseAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.MilesPurchased.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.MilesPurchased.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.MilesPurchased} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.MilesPurchased.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getMiles();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getPurchaseAmount();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.events.MilesPurchased.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.MilesPurchased} returns this
 */ proto.events.MilesPurchased.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 miles = 2;
 * @return {number}
 */ proto.events.MilesPurchased.prototype.getMiles = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.MilesPurchased} returns this
 */ proto.events.MilesPurchased.prototype.setMiles = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string vehicle_id = 3;
 * @return {string}
 */ proto.events.MilesPurchased.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.events.MilesPurchased} returns this
 */ proto.events.MilesPurchased.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 purchase_amount = 4;
 * @return {number}
 */ proto.events.MilesPurchased.prototype.getPurchaseAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.MilesPurchased} returns this
 */ proto.events.MilesPurchased.prototype.setPurchaseAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.VehicleChangeDetails.prototype.toObject = function(opt_includeInstance) {
        return proto.events.VehicleChangeDetails.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.VehicleChangeDetails} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleChangeDetails.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            odometer: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.VehicleChangeDetails}
 */ proto.events.VehicleChangeDetails.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.VehicleChangeDetails;
    return proto.events.VehicleChangeDetails.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.VehicleChangeDetails} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.VehicleChangeDetails}
 */ proto.events.VehicleChangeDetails.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOdometer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.VehicleChangeDetails.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.VehicleChangeDetails.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.VehicleChangeDetails} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.VehicleChangeDetails.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOdometer();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.events.VehicleChangeDetails.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.VehicleChangeDetails} returns this
 */ proto.events.VehicleChangeDetails.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 odometer = 2;
 * @return {number}
 */ proto.events.VehicleChangeDetails.prototype.getOdometer = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.VehicleChangeDetails} returns this
 */ proto.events.VehicleChangeDetails.prototype.setOdometer = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.SubscriptionVehicleChange.prototype.toObject = function(opt_includeInstance) {
        return proto.events.SubscriptionVehicleChange.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.SubscriptionVehicleChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SubscriptionVehicleChange.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            pb_return: (f = msg.getReturn()) && proto.events.VehicleChangeDetails.toObject(includeInstance, f),
            pickup: (f = msg.getPickup()) && proto.events.VehicleChangeDetails.toObject(includeInstance, f),
            timeOfChange: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.SubscriptionVehicleChange}
 */ proto.events.SubscriptionVehicleChange.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.SubscriptionVehicleChange;
    return proto.events.SubscriptionVehicleChange.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.SubscriptionVehicleChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.SubscriptionVehicleChange}
 */ proto.events.SubscriptionVehicleChange.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = new proto.events.VehicleChangeDetails;
                reader.readMessage(value, proto.events.VehicleChangeDetails.deserializeBinaryFromReader);
                msg.setReturn(value);
                break;
            case 3:
                var value = new proto.events.VehicleChangeDetails;
                reader.readMessage(value, proto.events.VehicleChangeDetails.deserializeBinaryFromReader);
                msg.setPickup(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTimeOfChange(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.SubscriptionVehicleChange.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.SubscriptionVehicleChange.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.SubscriptionVehicleChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SubscriptionVehicleChange.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReturn();
    if (f != null) writer.writeMessage(2, f, proto.events.VehicleChangeDetails.serializeBinaryToWriter);
    f = message.getPickup();
    if (f != null) writer.writeMessage(3, f, proto.events.VehicleChangeDetails.serializeBinaryToWriter);
    f = message.getTimeOfChange();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.events.SubscriptionVehicleChange.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionVehicleChange} returns this
 */ proto.events.SubscriptionVehicleChange.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional VehicleChangeDetails return = 2;
 * @return {?proto.events.VehicleChangeDetails}
 */ proto.events.SubscriptionVehicleChange.prototype.getReturn = function() {
    return /** @type{?proto.events.VehicleChangeDetails} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleChangeDetails, 2);
};
/**
 * @param {?proto.events.VehicleChangeDetails|undefined} value
 * @return {!proto.events.SubscriptionVehicleChange} returns this
*/ proto.events.SubscriptionVehicleChange.prototype.setReturn = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.SubscriptionVehicleChange} returns this
 */ proto.events.SubscriptionVehicleChange.prototype.clearReturn = function() {
    return this.setReturn(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.SubscriptionVehicleChange.prototype.hasReturn = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional VehicleChangeDetails pickup = 3;
 * @return {?proto.events.VehicleChangeDetails}
 */ proto.events.SubscriptionVehicleChange.prototype.getPickup = function() {
    return /** @type{?proto.events.VehicleChangeDetails} */ $8M67s.Message.getWrapperField(this, proto.events.VehicleChangeDetails, 3);
};
/**
 * @param {?proto.events.VehicleChangeDetails|undefined} value
 * @return {!proto.events.SubscriptionVehicleChange} returns this
*/ proto.events.SubscriptionVehicleChange.prototype.setPickup = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.events.SubscriptionVehicleChange} returns this
 */ proto.events.SubscriptionVehicleChange.prototype.clearPickup = function() {
    return this.setPickup(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.events.SubscriptionVehicleChange.prototype.hasPickup = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional string time_of_change = 4;
 * @return {string}
 */ proto.events.SubscriptionVehicleChange.prototype.getTimeOfChange = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionVehicleChange} returns this
 */ proto.events.SubscriptionVehicleChange.prototype.setTimeOfChange = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.events.SubscriptionVehicleReturned.prototype.toObject = function(opt_includeInstance) {
        return proto.events.SubscriptionVehicleReturned.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.events.SubscriptionVehicleReturned} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SubscriptionVehicleReturned.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            excessMileageAmount: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            missingAssetsAmount: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            initialDamagesAmount: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.events.SubscriptionVehicleReturned}
 */ proto.events.SubscriptionVehicleReturned.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.events.SubscriptionVehicleReturned;
    return proto.events.SubscriptionVehicleReturned.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.events.SubscriptionVehicleReturned} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.events.SubscriptionVehicleReturned}
 */ proto.events.SubscriptionVehicleReturned.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setExcessMileageAmount(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMissingAssetsAmount(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInitialDamagesAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.events.SubscriptionVehicleReturned.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.events.SubscriptionVehicleReturned.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.events.SubscriptionVehicleReturned} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.events.SubscriptionVehicleReturned.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getExcessMileageAmount();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMissingAssetsAmount();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getInitialDamagesAmount();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.events.SubscriptionVehicleReturned.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionVehicleReturned} returns this
 */ proto.events.SubscriptionVehicleReturned.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.events.SubscriptionVehicleReturned.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.events.SubscriptionVehicleReturned} returns this
 */ proto.events.SubscriptionVehicleReturned.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 excess_mileage_amount = 3;
 * @return {number}
 */ proto.events.SubscriptionVehicleReturned.prototype.getExcessMileageAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.SubscriptionVehicleReturned} returns this
 */ proto.events.SubscriptionVehicleReturned.prototype.setExcessMileageAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 missing_assets_amount = 4;
 * @return {number}
 */ proto.events.SubscriptionVehicleReturned.prototype.getMissingAssetsAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.SubscriptionVehicleReturned} returns this
 */ proto.events.SubscriptionVehicleReturned.prototype.setMissingAssetsAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 initial_damages_amount = 5;
 * @return {number}
 */ proto.events.SubscriptionVehicleReturned.prototype.getInitialDamagesAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.events.SubscriptionVehicleReturned} returns this
 */ proto.events.SubscriptionVehicleReturned.prototype.setInitialDamagesAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * @enum {number}
 */ proto.events.EventCategory = {
    COMMAND_ACCEPTED: 0,
    EFFECT: 1
};
/**
 * @enum {number}
 */ proto.events.Domain = {
    SYSTEM: 0,
    VENDOR: 1,
    CUSTOMER: 2,
    SUBSCRIPTION: 3,
    FLEET: 4,
    INSURANCE: 5,
    DEALER: 6,
    NOTIFICATION: 7,
    RESERVATION: 8,
    PROGRAM: 9,
    PROMOTION: 10,
    APPOINTMENT: 11,
    DEALER_USER: 12,
    TELEMATICS: 13
};
/**
 * @enum {number}
 */ proto.events.AuthStatus = {
    AUTH_SUCCESS: 0,
    AUTH_FAILED: 1,
    AUTH_ERROR: 2
};
/**
 * @enum {number}
 */ proto.events.PaymentStatus = {
    PAYMENT_SUCCESS: 0,
    PAYMENT_FAILED: 1,
    PAYMENT_ERROR: 2
};
/**
 * @enum {number}
 */ proto.events.PaymentActivityType = {
    SECURITY_DEPOSIT_PAYMENT_TYPE: 0,
    START_PAYMENT_TYPE: 1,
    SUBSCRIPTION_PAYMENT_TYPE: 2,
    SECURITY_DEPOSIT_REFUNDED: 3,
    SECURITY_DEPOSIT_REFUND_UNSUCCESSFUL: 4,
    AUTHORIZATION_VOIDED: 5,
    WAITLIST_DEPOSIT_REFUNDED: 6,
    WAITLIST_DEPOSIT_PAYMENT_TYPE: 7,
    ADD_PAYMENT_METHOD_PAYMENT_TYPE: 8,
    AUTHORIZATION_PAYMENT_TYPE: 9,
    CHARGE_DISPUTE_OPENED: 10,
    CHARGE_DISPUTE_LOST: 11,
    CHARGE_DISPUTE_WON: 12,
    TRANSACTION_SETTLEMENT_DECLINED: 13,
    AUTHORIZATION_NOT_REQUIRED: 14,
    TRANSACTION_SETTLED: 15,
    SYSTEM_RESERVED_BLACK_HOLE: 100
};
/**
 * @enum {number}
 */ proto.events.OfferReason = {
    VEHICLE_AVAILABLE: 0,
    VEHICLE_UNAVAILABLE: 1,
    PRICE_ACCEPTED: 2,
    PRICE_REJECTED: 3
};
$edc7502dbc65dfc8$var$goog.object.extend(module.exports, proto.events);

});
parcelRegister("c17Fn", function(module, exports) {
// source: customer.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $8bfb86688e86f790$var$goog = $8M67s;
var $8bfb86688e86f790$var$global = Function('return this')();
$8bfb86688e86f790$var$goog.exportSymbol('proto.customer.CustomerBankAccountVerified', null, $8bfb86688e86f790$var$global);
$8bfb86688e86f790$var$goog.exportSymbol('proto.customer.CustomerPhoneUpdated', null, $8bfb86688e86f790$var$global);
$8bfb86688e86f790$var$goog.exportSymbol('proto.customer.LicenseInfoSubmitted', null, $8bfb86688e86f790$var$global);
$8bfb86688e86f790$var$goog.exportSymbol('proto.customer.PhoneNumberEntered', null, $8bfb86688e86f790$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer.CustomerPhoneUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8bfb86688e86f790$var$goog.inherits(proto.customer.CustomerPhoneUpdated, $8M67s.Message);
if ($8bfb86688e86f790$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer.CustomerPhoneUpdated.displayName = 'proto.customer.CustomerPhoneUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer.CustomerBankAccountVerified = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8bfb86688e86f790$var$goog.inherits(proto.customer.CustomerBankAccountVerified, $8M67s.Message);
if ($8bfb86688e86f790$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer.CustomerBankAccountVerified.displayName = 'proto.customer.CustomerBankAccountVerified';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer.PhoneNumberEntered = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8bfb86688e86f790$var$goog.inherits(proto.customer.PhoneNumberEntered, $8M67s.Message);
if ($8bfb86688e86f790$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer.PhoneNumberEntered.displayName = 'proto.customer.PhoneNumberEntered';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer.LicenseInfoSubmitted = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$8bfb86688e86f790$var$goog.inherits(proto.customer.LicenseInfoSubmitted, $8M67s.Message);
if ($8bfb86688e86f790$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer.LicenseInfoSubmitted.displayName = 'proto.customer.LicenseInfoSubmitted';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer.CustomerPhoneUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.customer.CustomerPhoneUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer.CustomerPhoneUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer.CustomerPhoneUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            oldPhone: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            newPhone: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer.CustomerPhoneUpdated}
 */ proto.customer.CustomerPhoneUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer.CustomerPhoneUpdated;
    return proto.customer.CustomerPhoneUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer.CustomerPhoneUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer.CustomerPhoneUpdated}
 */ proto.customer.CustomerPhoneUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOldPhone(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setNewPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer.CustomerPhoneUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer.CustomerPhoneUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer.CustomerPhoneUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer.CustomerPhoneUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOldPhone();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getNewPhone();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer.CustomerPhoneUpdated.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.CustomerPhoneUpdated} returns this
 */ proto.customer.CustomerPhoneUpdated.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string old_phone = 2;
 * @return {string}
 */ proto.customer.CustomerPhoneUpdated.prototype.getOldPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.CustomerPhoneUpdated} returns this
 */ proto.customer.CustomerPhoneUpdated.prototype.setOldPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string new_phone = 3;
 * @return {string}
 */ proto.customer.CustomerPhoneUpdated.prototype.getNewPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.CustomerPhoneUpdated} returns this
 */ proto.customer.CustomerPhoneUpdated.prototype.setNewPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer.CustomerBankAccountVerified.prototype.toObject = function(opt_includeInstance) {
        return proto.customer.CustomerBankAccountVerified.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer.CustomerBankAccountVerified} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer.CustomerBankAccountVerified.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer.CustomerBankAccountVerified}
 */ proto.customer.CustomerBankAccountVerified.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer.CustomerBankAccountVerified;
    return proto.customer.CustomerBankAccountVerified.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer.CustomerBankAccountVerified} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer.CustomerBankAccountVerified}
 */ proto.customer.CustomerBankAccountVerified.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer.CustomerBankAccountVerified.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer.CustomerBankAccountVerified.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer.CustomerBankAccountVerified} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer.CustomerBankAccountVerified.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer.CustomerBankAccountVerified.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.CustomerBankAccountVerified} returns this
 */ proto.customer.CustomerBankAccountVerified.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer.PhoneNumberEntered.prototype.toObject = function(opt_includeInstance) {
        return proto.customer.PhoneNumberEntered.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer.PhoneNumberEntered} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer.PhoneNumberEntered.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            category: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            fbp: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            section: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            segmentAnonymousId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            accountType: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer.PhoneNumberEntered}
 */ proto.customer.PhoneNumberEntered.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer.PhoneNumberEntered;
    return proto.customer.PhoneNumberEntered.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer.PhoneNumberEntered} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer.PhoneNumberEntered}
 */ proto.customer.PhoneNumberEntered.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCategory(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFbp(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setSection(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSegmentAnonymousId(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer.PhoneNumberEntered.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer.PhoneNumberEntered.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer.PhoneNumberEntered} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer.PhoneNumberEntered.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCategory();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFbp();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getSection();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getSegmentAnonymousId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getAccountType();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer.PhoneNumberEntered.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.PhoneNumberEntered} returns this
 */ proto.customer.PhoneNumberEntered.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string category = 2;
 * @return {string}
 */ proto.customer.PhoneNumberEntered.prototype.getCategory = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.PhoneNumberEntered} returns this
 */ proto.customer.PhoneNumberEntered.prototype.setCategory = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string fbp = 3;
 * @return {string}
 */ proto.customer.PhoneNumberEntered.prototype.getFbp = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.PhoneNumberEntered} returns this
 */ proto.customer.PhoneNumberEntered.prototype.setFbp = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string phone = 4;
 * @return {string}
 */ proto.customer.PhoneNumberEntered.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.PhoneNumberEntered} returns this
 */ proto.customer.PhoneNumberEntered.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string section = 5;
 * @return {string}
 */ proto.customer.PhoneNumberEntered.prototype.getSection = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.PhoneNumberEntered} returns this
 */ proto.customer.PhoneNumberEntered.prototype.setSection = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string segment_anonymous_id = 6;
 * @return {string}
 */ proto.customer.PhoneNumberEntered.prototype.getSegmentAnonymousId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.PhoneNumberEntered} returns this
 */ proto.customer.PhoneNumberEntered.prototype.setSegmentAnonymousId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string account_type = 7;
 * @return {string}
 */ proto.customer.PhoneNumberEntered.prototype.getAccountType = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.PhoneNumberEntered} returns this
 */ proto.customer.PhoneNumberEntered.prototype.setAccountType = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer.LicenseInfoSubmitted.prototype.toObject = function(opt_includeInstance) {
        return proto.customer.LicenseInfoSubmitted.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer.LicenseInfoSubmitted} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer.LicenseInfoSubmitted.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            licenseNumber: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer.LicenseInfoSubmitted}
 */ proto.customer.LicenseInfoSubmitted.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer.LicenseInfoSubmitted;
    return proto.customer.LicenseInfoSubmitted.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer.LicenseInfoSubmitted} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer.LicenseInfoSubmitted}
 */ proto.customer.LicenseInfoSubmitted.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLicenseNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer.LicenseInfoSubmitted.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer.LicenseInfoSubmitted.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer.LicenseInfoSubmitted} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer.LicenseInfoSubmitted.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLicenseNumber();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer.LicenseInfoSubmitted.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.LicenseInfoSubmitted} returns this
 */ proto.customer.LicenseInfoSubmitted.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string license_number = 2;
 * @return {string}
 */ proto.customer.LicenseInfoSubmitted.prototype.getLicenseNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer.LicenseInfoSubmitted} returns this
 */ proto.customer.LicenseInfoSubmitted.prototype.setLicenseNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
$8bfb86688e86f790$var$goog.object.extend(module.exports, proto.customer);

});

parcelRegister("02GYf", function(module, exports) {
// source: telemetric.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $0081851a503594c0$var$goog = $8M67s;
var $0081851a503594c0$var$global = Function('return this')();
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.CollisionEvent', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.CollisionReceived', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.DailyDrivingBehavior', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.DrivingBehavior', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.EventRating', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.Location', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.RoutePosition', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.TripEvent', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.TripReceived', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.VehicleScore', null, $0081851a503594c0$var$global);
$0081851a503594c0$var$goog.exportSymbol('proto.telemetric.VehicleScore.Vehicles', null, $0081851a503594c0$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.TripReceived = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telemetric.TripReceived.repeatedFields_, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.TripReceived, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.TripReceived.displayName = 'proto.telemetric.TripReceived';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.CollisionReceived = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telemetric.CollisionReceived.repeatedFields_, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.CollisionReceived, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.CollisionReceived.displayName = 'proto.telemetric.CollisionReceived';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.CollisionEvent = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.CollisionEvent, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.CollisionEvent.displayName = 'proto.telemetric.CollisionEvent';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.RoutePosition = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.RoutePosition, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.RoutePosition.displayName = 'proto.telemetric.RoutePosition';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.Location = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.Location, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.Location.displayName = 'proto.telemetric.Location';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.TripEvent = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.TripEvent, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.TripEvent.displayName = 'proto.telemetric.TripEvent';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.DailyDrivingBehavior = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.DailyDrivingBehavior, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.DailyDrivingBehavior.displayName = 'proto.telemetric.DailyDrivingBehavior';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.DrivingBehavior = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.DrivingBehavior, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.DrivingBehavior.displayName = 'proto.telemetric.DrivingBehavior';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.VehicleScore = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.VehicleScore, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.VehicleScore.displayName = 'proto.telemetric.VehicleScore';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.VehicleScore.Vehicles = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.VehicleScore.Vehicles, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.VehicleScore.Vehicles.displayName = 'proto.telemetric.VehicleScore.Vehicles';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telemetric.EventRating = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$0081851a503594c0$var$goog.inherits(proto.telemetric.EventRating, $8M67s.Message);
if ($0081851a503594c0$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telemetric.EventRating.displayName = 'proto.telemetric.EventRating';
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telemetric.TripReceived.repeatedFields_ = [
    21
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.TripReceived.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.TripReceived.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.TripReceived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.TripReceived.toObject = function(includeInstance, msg) {
        var f, obj = {
            driverid: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleid: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            tripid: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            starttime: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            endtime: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            tripmaxspeed: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
            tripduration: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
            distance: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
            sessionid: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            trackingid: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            insuranceperiod: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            usermode: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            drivetype: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            vehicletype: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            hardbrakerating: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            hardturnrating: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            rapidaccelerationrating: $8M67s.Message.getFieldWithDefault(msg, 17, 0),
            phoneuserating: $8M67s.Message.getFieldWithDefault(msg, 18, 0),
            overspeedingrating: $8M67s.Message.getFieldWithDefault(msg, 19, 0),
            drivingscore: $8M67s.Message.getFieldWithDefault(msg, 20, 0),
            tripeventsList: $8M67s.Message.toObjectList(msg.getTripeventsList(), proto.telemetric.TripEvent.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.TripReceived}
 */ proto.telemetric.TripReceived.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.TripReceived;
    return proto.telemetric.TripReceived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.TripReceived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.TripReceived}
 */ proto.telemetric.TripReceived.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDriverid(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleid(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTripid(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setStarttime(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setEndtime(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTripmaxspeed(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTripduration(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readFloat();
                msg.setDistance(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setSessionid(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingid(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt64();
                msg.setInsuranceperiod(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setUsermode(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setDrivetype(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicletype(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt32();
                msg.setHardbrakerating(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setHardturnrating(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRapidaccelerationrating(value);
                break;
            case 18:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPhoneuserating(value);
                break;
            case 19:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOverspeedingrating(value);
                break;
            case 20:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDrivingscore(value);
                break;
            case 21:
                var value = new proto.telemetric.TripEvent;
                reader.readMessage(value, proto.telemetric.TripEvent.deserializeBinaryFromReader);
                msg.addTripevents(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.TripReceived.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.TripReceived.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.TripReceived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.TripReceived.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDriverid();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleid();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getTripid();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getStarttime();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getEndtime();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getTripmaxspeed();
    if (f !== 0.0) writer.writeFloat(6, f);
    f = message.getTripduration();
    if (f !== 0.0) writer.writeFloat(7, f);
    f = message.getDistance();
    if (f !== 0.0) writer.writeFloat(8, f);
    f = message.getSessionid();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getTrackingid();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getInsuranceperiod();
    if (f !== 0) writer.writeInt64(11, f);
    f = message.getUsermode();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getDrivetype();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getVehicletype();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getHardbrakerating();
    if (f !== 0) writer.writeInt32(15, f);
    f = message.getHardturnrating();
    if (f !== 0) writer.writeInt32(16, f);
    f = message.getRapidaccelerationrating();
    if (f !== 0) writer.writeInt32(17, f);
    f = message.getPhoneuserating();
    if (f !== 0) writer.writeInt32(18, f);
    f = message.getOverspeedingrating();
    if (f !== 0) writer.writeInt32(19, f);
    f = message.getDrivingscore();
    if (f !== 0) writer.writeInt32(20, f);
    f = message.getTripeventsList();
    if (f.length > 0) writer.writeRepeatedMessage(21, f, proto.telemetric.TripEvent.serializeBinaryToWriter);
};
/**
 * optional string DriverId = 1;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getDriverid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setDriverid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string VehicleId = 2;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getVehicleid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setVehicleid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string TripId = 3;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getTripid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setTripid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string StartTime = 4;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getStarttime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setStarttime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string EndTime = 5;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getEndtime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setEndtime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional float TripMaxSpeed = 6;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getTripmaxspeed = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 6, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setTripmaxspeed = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional float TripDuration = 7;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getTripduration = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 7, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setTripduration = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional float Distance = 8;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getDistance = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 8, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setDistance = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional string SessionId = 9;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getSessionid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setSessionid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string TrackingId = 10;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getTrackingid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setTrackingid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional int64 InsurancePeriod = 11;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getInsuranceperiod = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setInsuranceperiod = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional string UserMode = 12;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getUsermode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setUsermode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string DriveType = 13;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getDrivetype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setDrivetype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string VehicleType = 14;
 * @return {string}
 */ proto.telemetric.TripReceived.prototype.getVehicletype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setVehicletype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional int32 HardBrakeRating = 15;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getHardbrakerating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setHardbrakerating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * optional int32 HardTurnRating = 16;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getHardturnrating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setHardturnrating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
/**
 * optional int32 RapidAccelerationRating = 17;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getRapidaccelerationrating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 17, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setRapidaccelerationrating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 17, value);
};
/**
 * optional int32 PhoneUseRating = 18;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getPhoneuserating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 18, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setPhoneuserating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 18, value);
};
/**
 * optional int32 OverspeedingRating = 19;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getOverspeedingrating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 19, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setOverspeedingrating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 19, value);
};
/**
 * optional int32 DrivingScore = 20;
 * @return {number}
 */ proto.telemetric.TripReceived.prototype.getDrivingscore = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 20, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.setDrivingscore = function(value) {
    return $8M67s.Message.setProto3IntField(this, 20, value);
};
/**
 * repeated TripEvent TripEvents = 21;
 * @return {!Array<!proto.telemetric.TripEvent>}
 */ proto.telemetric.TripReceived.prototype.getTripeventsList = function() {
    return /** @type{!Array<!proto.telemetric.TripEvent>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.telemetric.TripEvent, 21);
};
/**
 * @param {!Array<!proto.telemetric.TripEvent>} value
 * @return {!proto.telemetric.TripReceived} returns this
*/ proto.telemetric.TripReceived.prototype.setTripeventsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 21, value);
};
/**
 * @param {!proto.telemetric.TripEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telemetric.TripEvent}
 */ proto.telemetric.TripReceived.prototype.addTripevents = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.telemetric.TripEvent, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telemetric.TripReceived} returns this
 */ proto.telemetric.TripReceived.prototype.clearTripeventsList = function() {
    return this.setTripeventsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telemetric.CollisionReceived.repeatedFields_ = [
    26
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.CollisionReceived.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.CollisionReceived.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.CollisionReceived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.CollisionReceived.toObject = function(includeInstance, msg) {
        var f, obj = {
            driverid: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleid: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            collisionid: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            time: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            roadtype: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            roadspeedlimit: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            currentspeed: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
            gforce: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
            headingdegrees: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
            brakedistance: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
            decelerationratemilesperhourpersecond: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
            airbagdeployed: $8M67s.Message.getBooleanFieldWithDefault(msg, 12, false),
            confidencenumber: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            confidence: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            tripmaxspeedkmph: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
            durationseconds: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
            distance: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
            sessionid: $8M67s.Message.getFieldWithDefault(msg, 18, ""),
            trackingid: $8M67s.Message.getFieldWithDefault(msg, 19, ""),
            insuranceperiod: $8M67s.Message.getFieldWithDefault(msg, 20, 0),
            usermode: $8M67s.Message.getFieldWithDefault(msg, 21, ""),
            drivetype: $8M67s.Message.getFieldWithDefault(msg, 22, ""),
            message: $8M67s.Message.getFieldWithDefault(msg, 23, ""),
            latitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
            longitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
            collisioneventsList: $8M67s.Message.toObjectList(msg.getCollisioneventsList(), proto.telemetric.CollisionEvent.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.CollisionReceived}
 */ proto.telemetric.CollisionReceived.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.CollisionReceived;
    return proto.telemetric.CollisionReceived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.CollisionReceived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.CollisionReceived}
 */ proto.telemetric.CollisionReceived.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDriverid(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleid(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCollisionid(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTime(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setRoadtype(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRoadspeedlimit(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readFloat();
                msg.setCurrentspeed(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readFloat();
                msg.setGforce(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readFloat();
                msg.setHeadingdegrees(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readFloat();
                msg.setBrakedistance(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readFloat();
                msg.setDecelerationratemilesperhourpersecond(value);
                break;
            case 12:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setAirbagdeployed(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt32();
                msg.setConfidencenumber(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setConfidence(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTripmaxspeedkmph(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readFloat();
                msg.setDurationseconds(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readFloat();
                msg.setDistance(value);
                break;
            case 18:
                var value = /** @type {string} */ reader.readString();
                msg.setSessionid(value);
                break;
            case 19:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingid(value);
                break;
            case 20:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInsuranceperiod(value);
                break;
            case 21:
                var value = /** @type {string} */ reader.readString();
                msg.setUsermode(value);
                break;
            case 22:
                var value = /** @type {string} */ reader.readString();
                msg.setDrivetype(value);
                break;
            case 23:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            case 24:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitude(value);
                break;
            case 25:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitude(value);
                break;
            case 26:
                var value = new proto.telemetric.CollisionEvent;
                reader.readMessage(value, proto.telemetric.CollisionEvent.deserializeBinaryFromReader);
                msg.addCollisionevents(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.CollisionReceived.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.CollisionReceived.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.CollisionReceived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.CollisionReceived.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDriverid();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleid();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCollisionid();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getTime();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getRoadtype();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getRoadspeedlimit();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getCurrentspeed();
    if (f !== 0.0) writer.writeFloat(7, f);
    f = message.getGforce();
    if (f !== 0.0) writer.writeFloat(8, f);
    f = message.getHeadingdegrees();
    if (f !== 0.0) writer.writeFloat(9, f);
    f = message.getBrakedistance();
    if (f !== 0.0) writer.writeFloat(10, f);
    f = message.getDecelerationratemilesperhourpersecond();
    if (f !== 0.0) writer.writeFloat(11, f);
    f = message.getAirbagdeployed();
    if (f) writer.writeBool(12, f);
    f = message.getConfidencenumber();
    if (f !== 0) writer.writeInt32(13, f);
    f = message.getConfidence();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getTripmaxspeedkmph();
    if (f !== 0.0) writer.writeFloat(15, f);
    f = message.getDurationseconds();
    if (f !== 0.0) writer.writeFloat(16, f);
    f = message.getDistance();
    if (f !== 0.0) writer.writeFloat(17, f);
    f = message.getSessionid();
    if (f.length > 0) writer.writeString(18, f);
    f = message.getTrackingid();
    if (f.length > 0) writer.writeString(19, f);
    f = message.getInsuranceperiod();
    if (f !== 0) writer.writeInt32(20, f);
    f = message.getUsermode();
    if (f.length > 0) writer.writeString(21, f);
    f = message.getDrivetype();
    if (f.length > 0) writer.writeString(22, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(23, f);
    f = message.getLatitude();
    if (f !== 0.0) writer.writeFloat(24, f);
    f = message.getLongitude();
    if (f !== 0.0) writer.writeFloat(25, f);
    f = message.getCollisioneventsList();
    if (f.length > 0) writer.writeRepeatedMessage(26, f, proto.telemetric.CollisionEvent.serializeBinaryToWriter);
};
/**
 * optional string DriverId = 1;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getDriverid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setDriverid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string VehicleId = 2;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getVehicleid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setVehicleid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string CollisionId = 3;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getCollisionid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setCollisionid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string Time = 4;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string RoadType = 5;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getRoadtype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setRoadtype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 RoadSpeedLimit = 6;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getRoadspeedlimit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setRoadspeedlimit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional float CurrentSpeed = 7;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getCurrentspeed = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 7, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setCurrentspeed = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional float Gforce = 8;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getGforce = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 8, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setGforce = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional float HeadingDegrees = 9;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getHeadingdegrees = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 9, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setHeadingdegrees = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 9, value);
};
/**
 * optional float BrakeDistance = 10;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getBrakedistance = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 10, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setBrakedistance = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 10, value);
};
/**
 * optional float DecelerationRateMilesPerHourPerSecond = 11;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getDecelerationratemilesperhourpersecond = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 11, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setDecelerationratemilesperhourpersecond = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 11, value);
};
/**
 * optional bool AirbagDeployed = 12;
 * @return {boolean}
 */ proto.telemetric.CollisionReceived.prototype.getAirbagdeployed = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 12, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setAirbagdeployed = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 12, value);
};
/**
 * optional int32 ConfidenceNumber = 13;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getConfidencenumber = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setConfidencenumber = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
/**
 * optional string Confidence = 14;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getConfidence = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setConfidence = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional float TripMaxSpeedKmph = 15;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getTripmaxspeedkmph = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 15, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setTripmaxspeedkmph = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 15, value);
};
/**
 * optional float DurationSeconds = 16;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getDurationseconds = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 16, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setDurationseconds = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 16, value);
};
/**
 * optional float Distance = 17;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getDistance = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 17, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setDistance = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 17, value);
};
/**
 * optional string SessionId = 18;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getSessionid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 18, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setSessionid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 18, value);
};
/**
 * optional string TrackingId = 19;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getTrackingid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 19, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setTrackingid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 19, value);
};
/**
 * optional int32 InsurancePeriod = 20;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getInsuranceperiod = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 20, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setInsuranceperiod = function(value) {
    return $8M67s.Message.setProto3IntField(this, 20, value);
};
/**
 * optional string UserMode = 21;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getUsermode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 21, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setUsermode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 21, value);
};
/**
 * optional string DriveType = 22;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getDrivetype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 22, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setDrivetype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 22, value);
};
/**
 * optional string Message = 23;
 * @return {string}
 */ proto.telemetric.CollisionReceived.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 23, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 23, value);
};
/**
 * optional float Latitude = 24;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getLatitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 24, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setLatitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 24, value);
};
/**
 * optional float Longitude = 25;
 * @return {number}
 */ proto.telemetric.CollisionReceived.prototype.getLongitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 25, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.setLongitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 25, value);
};
/**
 * repeated CollisionEvent CollisionEvents = 26;
 * @return {!Array<!proto.telemetric.CollisionEvent>}
 */ proto.telemetric.CollisionReceived.prototype.getCollisioneventsList = function() {
    return /** @type{!Array<!proto.telemetric.CollisionEvent>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.telemetric.CollisionEvent, 26);
};
/**
 * @param {!Array<!proto.telemetric.CollisionEvent>} value
 * @return {!proto.telemetric.CollisionReceived} returns this
*/ proto.telemetric.CollisionReceived.prototype.setCollisioneventsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 26, value);
};
/**
 * @param {!proto.telemetric.CollisionEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telemetric.CollisionEvent}
 */ proto.telemetric.CollisionReceived.prototype.addCollisionevents = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.telemetric.CollisionEvent, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telemetric.CollisionReceived} returns this
 */ proto.telemetric.CollisionReceived.prototype.clearCollisioneventsList = function() {
    return this.setCollisioneventsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.CollisionEvent.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.CollisionEvent.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.CollisionEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.CollisionEvent.toObject = function(includeInstance, msg) {
        var f, obj = {
            eventtype: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            eventtypename: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            latitudeend: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
            longitudeend: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
            longitudestart: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
            latitudestart: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
            averagedriverspeedmph: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
            maxdriverspeedmph: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
            endtime: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            postedspeedlimitmph: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
            starttime: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.CollisionEvent}
 */ proto.telemetric.CollisionEvent.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.CollisionEvent;
    return proto.telemetric.CollisionEvent.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.CollisionEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.CollisionEvent}
 */ proto.telemetric.CollisionEvent.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEventtype(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEventtypename(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitudeend(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitudeend(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitudestart(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitudestart(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readFloat();
                msg.setAveragedriverspeedmph(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readFloat();
                msg.setMaxdriverspeedmph(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setEndtime(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readFloat();
                msg.setPostedspeedlimitmph(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setStarttime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.CollisionEvent.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.CollisionEvent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.CollisionEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.CollisionEvent.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getEventtype();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getEventtypename();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLatitudeend();
    if (f !== 0.0) writer.writeFloat(3, f);
    f = message.getLongitudeend();
    if (f !== 0.0) writer.writeFloat(4, f);
    f = message.getLongitudestart();
    if (f !== 0.0) writer.writeFloat(5, f);
    f = message.getLatitudestart();
    if (f !== 0.0) writer.writeFloat(6, f);
    f = message.getAveragedriverspeedmph();
    if (f !== 0.0) writer.writeFloat(7, f);
    f = message.getMaxdriverspeedmph();
    if (f !== 0.0) writer.writeFloat(8, f);
    f = message.getEndtime();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getPostedspeedlimitmph();
    if (f !== 0.0) writer.writeFloat(10, f);
    f = message.getStarttime();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional int32 EventType = 1;
 * @return {number}
 */ proto.telemetric.CollisionEvent.prototype.getEventtype = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setEventtype = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string EventTypeName = 2;
 * @return {string}
 */ proto.telemetric.CollisionEvent.prototype.getEventtypename = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setEventtypename = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional float LatitudeEnd = 3;
 * @return {number}
 */ proto.telemetric.CollisionEvent.prototype.getLatitudeend = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 3, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setLatitudeend = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 3, value);
};
/**
 * optional float LongitudeEnd = 4;
 * @return {number}
 */ proto.telemetric.CollisionEvent.prototype.getLongitudeend = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 4, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setLongitudeend = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 4, value);
};
/**
 * optional float LongitudeStart = 5;
 * @return {number}
 */ proto.telemetric.CollisionEvent.prototype.getLongitudestart = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 5, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setLongitudestart = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 5, value);
};
/**
 * optional float LatitudeStart = 6;
 * @return {number}
 */ proto.telemetric.CollisionEvent.prototype.getLatitudestart = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 6, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setLatitudestart = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional float AverageDriverSpeedMph = 7;
 * @return {number}
 */ proto.telemetric.CollisionEvent.prototype.getAveragedriverspeedmph = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 7, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setAveragedriverspeedmph = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional float MaxDriverSpeedMph = 8;
 * @return {number}
 */ proto.telemetric.CollisionEvent.prototype.getMaxdriverspeedmph = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 8, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setMaxdriverspeedmph = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional string EndTime = 9;
 * @return {string}
 */ proto.telemetric.CollisionEvent.prototype.getEndtime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setEndtime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional float PostedSpeedLimitMph = 10;
 * @return {number}
 */ proto.telemetric.CollisionEvent.prototype.getPostedspeedlimitmph = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 10, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setPostedspeedlimitmph = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 10, value);
};
/**
 * optional string StartTime = 11;
 * @return {string}
 */ proto.telemetric.CollisionEvent.prototype.getStarttime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.CollisionEvent} returns this
 */ proto.telemetric.CollisionEvent.prototype.setStarttime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.RoutePosition.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.RoutePosition.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.RoutePosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.RoutePosition.toObject = function(includeInstance, msg) {
        var f, obj = {
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            location: (f = msg.getLocation()) && proto.telemetric.Location.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.RoutePosition}
 */ proto.telemetric.RoutePosition.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.RoutePosition;
    return proto.telemetric.RoutePosition.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.RoutePosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.RoutePosition}
 */ proto.telemetric.RoutePosition.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setTimestamp(value);
                break;
            case 2:
                var value = new proto.telemetric.Location;
                reader.readMessage(value, proto.telemetric.Location.deserializeBinaryFromReader);
                msg.setLocation(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.RoutePosition.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.RoutePosition.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.RoutePosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.RoutePosition.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTimestamp();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLocation();
    if (f != null) writer.writeMessage(2, f, proto.telemetric.Location.serializeBinaryToWriter);
};
/**
 * optional string timestamp = 1;
 * @return {string}
 */ proto.telemetric.RoutePosition.prototype.getTimestamp = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.RoutePosition} returns this
 */ proto.telemetric.RoutePosition.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Location location = 2;
 * @return {?proto.telemetric.Location}
 */ proto.telemetric.RoutePosition.prototype.getLocation = function() {
    return /** @type{?proto.telemetric.Location} */ $8M67s.Message.getWrapperField(this, proto.telemetric.Location, 2);
};
/**
 * @param {?proto.telemetric.Location|undefined} value
 * @return {!proto.telemetric.RoutePosition} returns this
*/ proto.telemetric.RoutePosition.prototype.setLocation = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telemetric.RoutePosition} returns this
 */ proto.telemetric.RoutePosition.prototype.clearLocation = function() {
    return this.setLocation(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telemetric.RoutePosition.prototype.hasLocation = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.Location.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.Location.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.Location.toObject = function(includeInstance, msg) {
        var f, obj = {
            latitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
            longitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
            physicalAddress: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.Location}
 */ proto.telemetric.Location.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.Location;
    return proto.telemetric.Location.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.Location}
 */ proto.telemetric.Location.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitude(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitude(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setPhysicalAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.Location.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.Location.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.Location.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLatitude();
    if (f !== 0.0) writer.writeFloat(1, f);
    f = message.getLongitude();
    if (f !== 0.0) writer.writeFloat(2, f);
    f = message.getPhysicalAddress();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional float latitude = 1;
 * @return {number}
 */ proto.telemetric.Location.prototype.getLatitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 1, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.Location} returns this
 */ proto.telemetric.Location.prototype.setLatitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 1, value);
};
/**
 * optional float longitude = 2;
 * @return {number}
 */ proto.telemetric.Location.prototype.getLongitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 2, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.Location} returns this
 */ proto.telemetric.Location.prototype.setLongitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 2, value);
};
/**
 * optional string physical_address = 3;
 * @return {string}
 */ proto.telemetric.Location.prototype.getPhysicalAddress = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.Location} returns this
 */ proto.telemetric.Location.prototype.setPhysicalAddress = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.TripEvent.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.TripEvent.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.TripEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.TripEvent.toObject = function(includeInstance, msg) {
        var f, obj = {
            eventtype: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            eventtypename: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            latitudestart: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
            longitudestart: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
            latitudeend: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
            longitudeend: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
            averagedriverspeed: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
            maxdriverspeed: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
            postedspeedlimit: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
            starttime: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            endtime: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.TripEvent}
 */ proto.telemetric.TripEvent.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.TripEvent;
    return proto.telemetric.TripEvent.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.TripEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.TripEvent}
 */ proto.telemetric.TripEvent.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEventtype(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEventtypename(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitudestart(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitudestart(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitudeend(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitudeend(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readFloat();
                msg.setAveragedriverspeed(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readFloat();
                msg.setMaxdriverspeed(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readFloat();
                msg.setPostedspeedlimit(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setStarttime(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setEndtime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.TripEvent.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.TripEvent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.TripEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.TripEvent.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getEventtype();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getEventtypename();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLatitudestart();
    if (f !== 0.0) writer.writeFloat(3, f);
    f = message.getLongitudestart();
    if (f !== 0.0) writer.writeFloat(4, f);
    f = message.getLatitudeend();
    if (f !== 0.0) writer.writeFloat(5, f);
    f = message.getLongitudeend();
    if (f !== 0.0) writer.writeFloat(6, f);
    f = message.getAveragedriverspeed();
    if (f !== 0.0) writer.writeFloat(7, f);
    f = message.getMaxdriverspeed();
    if (f !== 0.0) writer.writeFloat(8, f);
    f = message.getPostedspeedlimit();
    if (f !== 0.0) writer.writeFloat(9, f);
    f = message.getStarttime();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getEndtime();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional int32 EventType = 1;
 * @return {number}
 */ proto.telemetric.TripEvent.prototype.getEventtype = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setEventtype = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string EventTypeName = 2;
 * @return {string}
 */ proto.telemetric.TripEvent.prototype.getEventtypename = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setEventtypename = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional float LatitudeStart = 3;
 * @return {number}
 */ proto.telemetric.TripEvent.prototype.getLatitudestart = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 3, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setLatitudestart = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 3, value);
};
/**
 * optional float LongitudeStart = 4;
 * @return {number}
 */ proto.telemetric.TripEvent.prototype.getLongitudestart = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 4, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setLongitudestart = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 4, value);
};
/**
 * optional float LatitudeEnd = 5;
 * @return {number}
 */ proto.telemetric.TripEvent.prototype.getLatitudeend = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 5, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setLatitudeend = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 5, value);
};
/**
 * optional float LongitudeEnd = 6;
 * @return {number}
 */ proto.telemetric.TripEvent.prototype.getLongitudeend = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 6, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setLongitudeend = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional float AverageDriverSpeed = 7;
 * @return {number}
 */ proto.telemetric.TripEvent.prototype.getAveragedriverspeed = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 7, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setAveragedriverspeed = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional float MaxDriverSpeed = 8;
 * @return {number}
 */ proto.telemetric.TripEvent.prototype.getMaxdriverspeed = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 8, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setMaxdriverspeed = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional float PostedSpeedLimit = 9;
 * @return {number}
 */ proto.telemetric.TripEvent.prototype.getPostedspeedlimit = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 9, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setPostedspeedlimit = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 9, value);
};
/**
 * optional string StartTime = 10;
 * @return {string}
 */ proto.telemetric.TripEvent.prototype.getStarttime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setStarttime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string EndTime = 11;
 * @return {string}
 */ proto.telemetric.TripEvent.prototype.getEndtime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.TripEvent} returns this
 */ proto.telemetric.TripEvent.prototype.setEndtime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.DailyDrivingBehavior.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.DailyDrivingBehavior.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.DailyDrivingBehavior} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.DailyDrivingBehavior.toObject = function(includeInstance, msg) {
        var f, obj = {
            date: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            score: (f = msg.getScore()) && proto.telemetric.VehicleScore.toObject(includeInstance, f),
            eventRating: (f = msg.getEventRating()) && proto.telemetric.EventRating.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.DailyDrivingBehavior}
 */ proto.telemetric.DailyDrivingBehavior.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.DailyDrivingBehavior;
    return proto.telemetric.DailyDrivingBehavior.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.DailyDrivingBehavior} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.DailyDrivingBehavior}
 */ proto.telemetric.DailyDrivingBehavior.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDate(value);
                break;
            case 2:
                var value = new proto.telemetric.VehicleScore;
                reader.readMessage(value, proto.telemetric.VehicleScore.deserializeBinaryFromReader);
                msg.setScore(value);
                break;
            case 3:
                var value = new proto.telemetric.EventRating;
                reader.readMessage(value, proto.telemetric.EventRating.deserializeBinaryFromReader);
                msg.setEventRating(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.DailyDrivingBehavior.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.DailyDrivingBehavior.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.DailyDrivingBehavior} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.DailyDrivingBehavior.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getScore();
    if (f != null) writer.writeMessage(2, f, proto.telemetric.VehicleScore.serializeBinaryToWriter);
    f = message.getEventRating();
    if (f != null) writer.writeMessage(3, f, proto.telemetric.EventRating.serializeBinaryToWriter);
};
/**
 * optional string date = 1;
 * @return {string}
 */ proto.telemetric.DailyDrivingBehavior.prototype.getDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telemetric.DailyDrivingBehavior} returns this
 */ proto.telemetric.DailyDrivingBehavior.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional VehicleScore score = 2;
 * @return {?proto.telemetric.VehicleScore}
 */ proto.telemetric.DailyDrivingBehavior.prototype.getScore = function() {
    return /** @type{?proto.telemetric.VehicleScore} */ $8M67s.Message.getWrapperField(this, proto.telemetric.VehicleScore, 2);
};
/**
 * @param {?proto.telemetric.VehicleScore|undefined} value
 * @return {!proto.telemetric.DailyDrivingBehavior} returns this
*/ proto.telemetric.DailyDrivingBehavior.prototype.setScore = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telemetric.DailyDrivingBehavior} returns this
 */ proto.telemetric.DailyDrivingBehavior.prototype.clearScore = function() {
    return this.setScore(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telemetric.DailyDrivingBehavior.prototype.hasScore = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional EventRating event_rating = 3;
 * @return {?proto.telemetric.EventRating}
 */ proto.telemetric.DailyDrivingBehavior.prototype.getEventRating = function() {
    return /** @type{?proto.telemetric.EventRating} */ $8M67s.Message.getWrapperField(this, proto.telemetric.EventRating, 3);
};
/**
 * @param {?proto.telemetric.EventRating|undefined} value
 * @return {!proto.telemetric.DailyDrivingBehavior} returns this
*/ proto.telemetric.DailyDrivingBehavior.prototype.setEventRating = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telemetric.DailyDrivingBehavior} returns this
 */ proto.telemetric.DailyDrivingBehavior.prototype.clearEventRating = function() {
    return this.setEventRating(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telemetric.DailyDrivingBehavior.prototype.hasEventRating = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.DrivingBehavior.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.DrivingBehavior.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.DrivingBehavior} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.DrivingBehavior.toObject = function(includeInstance, msg) {
        var f, obj = {
            score: (f = msg.getScore()) && proto.telemetric.VehicleScore.toObject(includeInstance, f),
            eventRating: (f = msg.getEventRating()) && proto.telemetric.EventRating.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.DrivingBehavior}
 */ proto.telemetric.DrivingBehavior.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.DrivingBehavior;
    return proto.telemetric.DrivingBehavior.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.DrivingBehavior} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.DrivingBehavior}
 */ proto.telemetric.DrivingBehavior.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.telemetric.VehicleScore;
                reader.readMessage(value, proto.telemetric.VehicleScore.deserializeBinaryFromReader);
                msg.setScore(value);
                break;
            case 2:
                var value = new proto.telemetric.EventRating;
                reader.readMessage(value, proto.telemetric.EventRating.deserializeBinaryFromReader);
                msg.setEventRating(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.DrivingBehavior.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.DrivingBehavior.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.DrivingBehavior} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.DrivingBehavior.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getScore();
    if (f != null) writer.writeMessage(1, f, proto.telemetric.VehicleScore.serializeBinaryToWriter);
    f = message.getEventRating();
    if (f != null) writer.writeMessage(2, f, proto.telemetric.EventRating.serializeBinaryToWriter);
};
/**
 * optional VehicleScore score = 1;
 * @return {?proto.telemetric.VehicleScore}
 */ proto.telemetric.DrivingBehavior.prototype.getScore = function() {
    return /** @type{?proto.telemetric.VehicleScore} */ $8M67s.Message.getWrapperField(this, proto.telemetric.VehicleScore, 1);
};
/**
 * @param {?proto.telemetric.VehicleScore|undefined} value
 * @return {!proto.telemetric.DrivingBehavior} returns this
*/ proto.telemetric.DrivingBehavior.prototype.setScore = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telemetric.DrivingBehavior} returns this
 */ proto.telemetric.DrivingBehavior.prototype.clearScore = function() {
    return this.setScore(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telemetric.DrivingBehavior.prototype.hasScore = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional EventRating event_rating = 2;
 * @return {?proto.telemetric.EventRating}
 */ proto.telemetric.DrivingBehavior.prototype.getEventRating = function() {
    return /** @type{?proto.telemetric.EventRating} */ $8M67s.Message.getWrapperField(this, proto.telemetric.EventRating, 2);
};
/**
 * @param {?proto.telemetric.EventRating|undefined} value
 * @return {!proto.telemetric.DrivingBehavior} returns this
*/ proto.telemetric.DrivingBehavior.prototype.setEventRating = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telemetric.DrivingBehavior} returns this
 */ proto.telemetric.DrivingBehavior.prototype.clearEventRating = function() {
    return this.setEventRating(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telemetric.DrivingBehavior.prototype.hasEventRating = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.VehicleScore.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.VehicleScore.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.VehicleScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.VehicleScore.toObject = function(includeInstance, msg) {
        var f, obj = {
            zendriveScore: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicles: (f = msg.getVehicles()) && proto.telemetric.VehicleScore.Vehicles.toObject(includeInstance, f),
            unknownVehicleScore: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.VehicleScore}
 */ proto.telemetric.VehicleScore.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.VehicleScore;
    return proto.telemetric.VehicleScore.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.VehicleScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.VehicleScore}
 */ proto.telemetric.VehicleScore.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setZendriveScore(value);
                break;
            case 2:
                var value = new proto.telemetric.VehicleScore.Vehicles;
                reader.readMessage(value, proto.telemetric.VehicleScore.Vehicles.deserializeBinaryFromReader);
                msg.setVehicles(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setUnknownVehicleScore(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.VehicleScore.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.VehicleScore.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.VehicleScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.VehicleScore.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getZendriveScore();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getVehicles();
    if (f != null) writer.writeMessage(2, f, proto.telemetric.VehicleScore.Vehicles.serializeBinaryToWriter);
    f = message.getUnknownVehicleScore();
    if (f !== 0) writer.writeInt32(3, f);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.VehicleScore.Vehicles.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.VehicleScore.Vehicles.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.VehicleScore.Vehicles} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.VehicleScore.Vehicles.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId1: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicleId2: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.VehicleScore.Vehicles}
 */ proto.telemetric.VehicleScore.Vehicles.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.VehicleScore.Vehicles;
    return proto.telemetric.VehicleScore.Vehicles.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.VehicleScore.Vehicles} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.VehicleScore.Vehicles}
 */ proto.telemetric.VehicleScore.Vehicles.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleId1(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleId2(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.VehicleScore.Vehicles.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.VehicleScore.Vehicles.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.VehicleScore.Vehicles} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.VehicleScore.Vehicles.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId1();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getVehicleId2();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional int32 vehicle_id_1 = 1;
 * @return {number}
 */ proto.telemetric.VehicleScore.Vehicles.prototype.getVehicleId1 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.VehicleScore.Vehicles} returns this
 */ proto.telemetric.VehicleScore.Vehicles.prototype.setVehicleId1 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 vehicle_id_2 = 2;
 * @return {number}
 */ proto.telemetric.VehicleScore.Vehicles.prototype.getVehicleId2 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.VehicleScore.Vehicles} returns this
 */ proto.telemetric.VehicleScore.Vehicles.prototype.setVehicleId2 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 zendrive_score = 1;
 * @return {number}
 */ proto.telemetric.VehicleScore.prototype.getZendriveScore = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.VehicleScore} returns this
 */ proto.telemetric.VehicleScore.prototype.setZendriveScore = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional Vehicles vehicles = 2;
 * @return {?proto.telemetric.VehicleScore.Vehicles}
 */ proto.telemetric.VehicleScore.prototype.getVehicles = function() {
    return /** @type{?proto.telemetric.VehicleScore.Vehicles} */ $8M67s.Message.getWrapperField(this, proto.telemetric.VehicleScore.Vehicles, 2);
};
/**
 * @param {?proto.telemetric.VehicleScore.Vehicles|undefined} value
 * @return {!proto.telemetric.VehicleScore} returns this
*/ proto.telemetric.VehicleScore.prototype.setVehicles = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telemetric.VehicleScore} returns this
 */ proto.telemetric.VehicleScore.prototype.clearVehicles = function() {
    return this.setVehicles(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telemetric.VehicleScore.prototype.hasVehicles = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional int32 unknown_vehicle_score = 3;
 * @return {number}
 */ proto.telemetric.VehicleScore.prototype.getUnknownVehicleScore = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.VehicleScore} returns this
 */ proto.telemetric.VehicleScore.prototype.setUnknownVehicleScore = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telemetric.EventRating.prototype.toObject = function(opt_includeInstance) {
        return proto.telemetric.EventRating.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telemetric.EventRating} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.EventRating.toObject = function(includeInstance, msg) {
        var f, obj = {
            hardBrakeRating: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            hardTurnRating: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            rapidAccelerationRating: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            phoneUseRating: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            overspeedingRating: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telemetric.EventRating}
 */ proto.telemetric.EventRating.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telemetric.EventRating;
    return proto.telemetric.EventRating.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telemetric.EventRating} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telemetric.EventRating}
 */ proto.telemetric.EventRating.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setHardBrakeRating(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setHardTurnRating(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRapidAccelerationRating(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPhoneUseRating(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOverspeedingRating(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telemetric.EventRating.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telemetric.EventRating.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telemetric.EventRating} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telemetric.EventRating.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getHardBrakeRating();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getHardTurnRating();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getRapidAccelerationRating();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getPhoneUseRating();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getOverspeedingRating();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional int32 hard_brake_rating = 1;
 * @return {number}
 */ proto.telemetric.EventRating.prototype.getHardBrakeRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.EventRating} returns this
 */ proto.telemetric.EventRating.prototype.setHardBrakeRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 hard_turn_rating = 2;
 * @return {number}
 */ proto.telemetric.EventRating.prototype.getHardTurnRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.EventRating} returns this
 */ proto.telemetric.EventRating.prototype.setHardTurnRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 rapid_acceleration_rating = 3;
 * @return {number}
 */ proto.telemetric.EventRating.prototype.getRapidAccelerationRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.EventRating} returns this
 */ proto.telemetric.EventRating.prototype.setRapidAccelerationRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 phone_use_rating = 4;
 * @return {number}
 */ proto.telemetric.EventRating.prototype.getPhoneUseRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.EventRating} returns this
 */ proto.telemetric.EventRating.prototype.setPhoneUseRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 overspeeding_rating = 5;
 * @return {number}
 */ proto.telemetric.EventRating.prototype.getOverspeedingRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.telemetric.EventRating} returns this
 */ proto.telemetric.EventRating.prototype.setOverspeedingRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
$0081851a503594c0$var$goog.object.extend(module.exports, proto.telemetric);

});

parcelRegister("3DbSe", function(module, exports) {
// source: notifications.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $2a4e397979157a14$var$goog = $8M67s;
var $2a4e397979157a14$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$2a4e397979157a14$var$goog.object.extend(proto, $3QqPt);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.Attribute', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.Content', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.ContentType', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.DeliveryMethod', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.Encoding', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.Notification', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.NotificationReceived', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.NotificationStatusUpdated', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.Recipient', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.SendNotifications', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.Status', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.Time', null, $2a4e397979157a14$var$global);
$2a4e397979157a14$var$goog.exportSymbol('proto.notifications.VendorData', null, $2a4e397979157a14$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.SendNotifications = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.notifications.SendNotifications.repeatedFields_, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.SendNotifications, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.SendNotifications.displayName = 'proto.notifications.SendNotifications';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.NotificationReceived = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.NotificationReceived, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.NotificationReceived.displayName = 'proto.notifications.NotificationReceived';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.NotificationStatusUpdated = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.notifications.NotificationStatusUpdated.repeatedFields_, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.NotificationStatusUpdated, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.NotificationStatusUpdated.displayName = 'proto.notifications.NotificationStatusUpdated';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.Notification = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.notifications.Notification.repeatedFields_, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.Notification, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.Notification.displayName = 'proto.notifications.Notification';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.Time = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.Time, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.Time.displayName = 'proto.notifications.Time';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.Recipient = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.notifications.Recipient.repeatedFields_, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.Recipient, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.Recipient.displayName = 'proto.notifications.Recipient';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.Content = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.Content, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.Content.displayName = 'proto.notifications.Content';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.Attribute = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.Attribute, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.Attribute.displayName = 'proto.notifications.Attribute';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notifications.VendorData = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$2a4e397979157a14$var$goog.inherits(proto.notifications.VendorData, $8M67s.Message);
if ($2a4e397979157a14$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notifications.VendorData.displayName = 'proto.notifications.VendorData';
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.notifications.SendNotifications.repeatedFields_ = [
    3
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.SendNotifications.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.SendNotifications.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.SendNotifications} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.SendNotifications.toObject = function(includeInstance, msg) {
        var f, obj = {
            domain: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            requestToken: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            notificationsList: $8M67s.Message.toObjectList(msg.getNotificationsList(), proto.notifications.Notification.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.SendNotifications}
 */ proto.notifications.SendNotifications.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.SendNotifications;
    return proto.notifications.SendNotifications.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.SendNotifications} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.SendNotifications}
 */ proto.notifications.SendNotifications.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.domain.Domain} */ reader.readEnum();
                msg.setDomain(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setRequestToken(value);
                break;
            case 3:
                var value = new proto.notifications.Notification;
                reader.readMessage(value, proto.notifications.Notification.deserializeBinaryFromReader);
                msg.addNotifications(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.SendNotifications.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.SendNotifications.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.SendNotifications} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.SendNotifications.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDomain();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getRequestToken();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getNotificationsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.notifications.Notification.serializeBinaryToWriter);
};
/**
 * optional domain.Domain domain = 1;
 * @return {!proto.domain.Domain}
 */ proto.notifications.SendNotifications.prototype.getDomain = function() {
    return /** @type {!proto.domain.Domain} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.domain.Domain} value
 * @return {!proto.notifications.SendNotifications} returns this
 */ proto.notifications.SendNotifications.prototype.setDomain = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string request_token = 2;
 * @return {string}
 */ proto.notifications.SendNotifications.prototype.getRequestToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.SendNotifications} returns this
 */ proto.notifications.SendNotifications.prototype.setRequestToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated Notification notifications = 3;
 * @return {!Array<!proto.notifications.Notification>}
 */ proto.notifications.SendNotifications.prototype.getNotificationsList = function() {
    return /** @type{!Array<!proto.notifications.Notification>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.notifications.Notification, 3);
};
/**
 * @param {!Array<!proto.notifications.Notification>} value
 * @return {!proto.notifications.SendNotifications} returns this
*/ proto.notifications.SendNotifications.prototype.setNotificationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.notifications.Notification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notifications.Notification}
 */ proto.notifications.SendNotifications.prototype.addNotifications = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.notifications.Notification, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notifications.SendNotifications} returns this
 */ proto.notifications.SendNotifications.prototype.clearNotificationsList = function() {
    return this.setNotificationsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.NotificationReceived.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.NotificationReceived.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.NotificationReceived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.NotificationReceived.toObject = function(includeInstance, msg) {
        var f, obj = {
            requestToken: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            domain: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            sender: (f = msg.getSender()) && $3QqPt.AutonomyUser.toObject(includeInstance, f),
            notification: (f = msg.getNotification()) && proto.notifications.Notification.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.NotificationReceived}
 */ proto.notifications.NotificationReceived.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.NotificationReceived;
    return proto.notifications.NotificationReceived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.NotificationReceived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.NotificationReceived}
 */ proto.notifications.NotificationReceived.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setRequestToken(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.Domain} */ reader.readEnum();
                msg.setDomain(value);
                break;
            case 3:
                var value = new $3QqPt.AutonomyUser;
                reader.readMessage(value, $3QqPt.AutonomyUser.deserializeBinaryFromReader);
                msg.setSender(value);
                break;
            case 4:
                var value = new proto.notifications.Notification;
                reader.readMessage(value, proto.notifications.Notification.deserializeBinaryFromReader);
                msg.setNotification(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.NotificationReceived.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.NotificationReceived.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.NotificationReceived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.NotificationReceived.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getRequestToken();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDomain();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getSender();
    if (f != null) writer.writeMessage(3, f, $3QqPt.AutonomyUser.serializeBinaryToWriter);
    f = message.getNotification();
    if (f != null) writer.writeMessage(4, f, proto.notifications.Notification.serializeBinaryToWriter);
};
/**
 * optional string request_token = 1;
 * @return {string}
 */ proto.notifications.NotificationReceived.prototype.getRequestToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.NotificationReceived} returns this
 */ proto.notifications.NotificationReceived.prototype.setRequestToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.Domain domain = 2;
 * @return {!proto.domain.Domain}
 */ proto.notifications.NotificationReceived.prototype.getDomain = function() {
    return /** @type {!proto.domain.Domain} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.Domain} value
 * @return {!proto.notifications.NotificationReceived} returns this
 */ proto.notifications.NotificationReceived.prototype.setDomain = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional domain.AutonomyUser sender = 3;
 * @return {?proto.domain.AutonomyUser}
 */ proto.notifications.NotificationReceived.prototype.getSender = function() {
    return /** @type{?proto.domain.AutonomyUser} */ $8M67s.Message.getWrapperField(this, $3QqPt.AutonomyUser, 3);
};
/**
 * @param {?proto.domain.AutonomyUser|undefined} value
 * @return {!proto.notifications.NotificationReceived} returns this
*/ proto.notifications.NotificationReceived.prototype.setSender = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.notifications.NotificationReceived} returns this
 */ proto.notifications.NotificationReceived.prototype.clearSender = function() {
    return this.setSender(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.notifications.NotificationReceived.prototype.hasSender = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional Notification notification = 4;
 * @return {?proto.notifications.Notification}
 */ proto.notifications.NotificationReceived.prototype.getNotification = function() {
    return /** @type{?proto.notifications.Notification} */ $8M67s.Message.getWrapperField(this, proto.notifications.Notification, 4);
};
/**
 * @param {?proto.notifications.Notification|undefined} value
 * @return {!proto.notifications.NotificationReceived} returns this
*/ proto.notifications.NotificationReceived.prototype.setNotification = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.notifications.NotificationReceived} returns this
 */ proto.notifications.NotificationReceived.prototype.clearNotification = function() {
    return this.setNotification(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.notifications.NotificationReceived.prototype.hasNotification = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.notifications.NotificationStatusUpdated.repeatedFields_ = [
    5
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.NotificationStatusUpdated.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.NotificationStatusUpdated.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.NotificationStatusUpdated} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.NotificationStatusUpdated.toObject = function(includeInstance, msg) {
        var f, obj = {
            notificationId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            domain: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            requestToken: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            vendorDataList: $8M67s.Message.toObjectList(msg.getVendorDataList(), proto.notifications.VendorData.toObject, includeInstance),
            deliveryMethod: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.NotificationStatusUpdated}
 */ proto.notifications.NotificationStatusUpdated.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.NotificationStatusUpdated;
    return proto.notifications.NotificationStatusUpdated.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.NotificationStatusUpdated} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.NotificationStatusUpdated}
 */ proto.notifications.NotificationStatusUpdated.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setNotificationId(value);
                break;
            case 2:
                var value = /** @type {!proto.domain.Domain} */ reader.readEnum();
                msg.setDomain(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setRequestToken(value);
                break;
            case 4:
                var value = /** @type {!proto.notifications.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 5:
                var value = new proto.notifications.VendorData;
                reader.readMessage(value, proto.notifications.VendorData.deserializeBinaryFromReader);
                msg.addVendorData(value);
                break;
            case 6:
                var value = /** @type {!proto.notifications.DeliveryMethod} */ reader.readEnum();
                msg.setDeliveryMethod(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.NotificationStatusUpdated.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.NotificationStatusUpdated.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.NotificationStatusUpdated} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.NotificationStatusUpdated.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNotificationId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDomain();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getRequestToken();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getVendorDataList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, proto.notifications.VendorData.serializeBinaryToWriter);
    f = message.getDeliveryMethod();
    if (f !== 0.0) writer.writeEnum(6, f);
};
/**
 * optional string notification_id = 1;
 * @return {string}
 */ proto.notifications.NotificationStatusUpdated.prototype.getNotificationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.NotificationStatusUpdated} returns this
 */ proto.notifications.NotificationStatusUpdated.prototype.setNotificationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.Domain domain = 2;
 * @return {!proto.domain.Domain}
 */ proto.notifications.NotificationStatusUpdated.prototype.getDomain = function() {
    return /** @type {!proto.domain.Domain} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.domain.Domain} value
 * @return {!proto.notifications.NotificationStatusUpdated} returns this
 */ proto.notifications.NotificationStatusUpdated.prototype.setDomain = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional string request_token = 3;
 * @return {string}
 */ proto.notifications.NotificationStatusUpdated.prototype.getRequestToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.NotificationStatusUpdated} returns this
 */ proto.notifications.NotificationStatusUpdated.prototype.setRequestToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional Status status = 4;
 * @return {!proto.notifications.Status}
 */ proto.notifications.NotificationStatusUpdated.prototype.getStatus = function() {
    return /** @type {!proto.notifications.Status} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.notifications.Status} value
 * @return {!proto.notifications.NotificationStatusUpdated} returns this
 */ proto.notifications.NotificationStatusUpdated.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * repeated VendorData vendor_data = 5;
 * @return {!Array<!proto.notifications.VendorData>}
 */ proto.notifications.NotificationStatusUpdated.prototype.getVendorDataList = function() {
    return /** @type{!Array<!proto.notifications.VendorData>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.notifications.VendorData, 5);
};
/**
 * @param {!Array<!proto.notifications.VendorData>} value
 * @return {!proto.notifications.NotificationStatusUpdated} returns this
*/ proto.notifications.NotificationStatusUpdated.prototype.setVendorDataList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.notifications.VendorData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notifications.VendorData}
 */ proto.notifications.NotificationStatusUpdated.prototype.addVendorData = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.notifications.VendorData, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notifications.NotificationStatusUpdated} returns this
 */ proto.notifications.NotificationStatusUpdated.prototype.clearVendorDataList = function() {
    return this.setVendorDataList([]);
};
/**
 * optional DeliveryMethod delivery_method = 6;
 * @return {!proto.notifications.DeliveryMethod}
 */ proto.notifications.NotificationStatusUpdated.prototype.getDeliveryMethod = function() {
    return /** @type {!proto.notifications.DeliveryMethod} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.notifications.DeliveryMethod} value
 * @return {!proto.notifications.NotificationStatusUpdated} returns this
 */ proto.notifications.NotificationStatusUpdated.prototype.setDeliveryMethod = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.notifications.Notification.repeatedFields_ = [
    3,
    4,
    5,
    8,
    9
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.Notification.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.Notification.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.Notification} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Notification.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            sender: (f = msg.getSender()) && $3QqPt.AutonomyUser.toObject(includeInstance, f),
            recipientsList: $8M67s.Message.toObjectList(msg.getRecipientsList(), proto.notifications.Recipient.toObject, includeInstance),
            contentList: $8M67s.Message.toObjectList(msg.getContentList(), proto.notifications.Content.toObject, includeInstance),
            scheduledForTimesList: $8M67s.Message.toObjectList(msg.getScheduledForTimesList(), proto.notifications.Time.toObject, includeInstance),
            status: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            readAt: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            vendorDataList: $8M67s.Message.toObjectList(msg.getVendorDataList(), proto.notifications.VendorData.toObject, includeInstance),
            attributesList: $8M67s.Message.toObjectList(msg.getAttributesList(), proto.notifications.Attribute.toObject, includeInstance),
            createdAt: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            sentAt: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            deletedAt: $8M67s.Message.getFieldWithDefault(msg, 12, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.Notification}
 */ proto.notifications.Notification.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.Notification;
    return proto.notifications.Notification.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.Notification} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.Notification}
 */ proto.notifications.Notification.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = new $3QqPt.AutonomyUser;
                reader.readMessage(value, $3QqPt.AutonomyUser.deserializeBinaryFromReader);
                msg.setSender(value);
                break;
            case 3:
                var value = new proto.notifications.Recipient;
                reader.readMessage(value, proto.notifications.Recipient.deserializeBinaryFromReader);
                msg.addRecipients(value);
                break;
            case 4:
                var value = new proto.notifications.Content;
                reader.readMessage(value, proto.notifications.Content.deserializeBinaryFromReader);
                msg.addContent(value);
                break;
            case 5:
                var value = new proto.notifications.Time;
                reader.readMessage(value, proto.notifications.Time.deserializeBinaryFromReader);
                msg.addScheduledForTimes(value);
                break;
            case 6:
                var value = /** @type {!proto.notifications.Status} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt64();
                msg.setReadAt(value);
                break;
            case 8:
                var value = new proto.notifications.VendorData;
                reader.readMessage(value, proto.notifications.VendorData.deserializeBinaryFromReader);
                msg.addVendorData(value);
                break;
            case 9:
                var value = new proto.notifications.Attribute;
                reader.readMessage(value, proto.notifications.Attribute.deserializeBinaryFromReader);
                msg.addAttributes(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreatedAt(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt64();
                msg.setSentAt(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDeletedAt(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.Notification.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.Notification.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.Notification} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Notification.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSender();
    if (f != null) writer.writeMessage(2, f, $3QqPt.AutonomyUser.serializeBinaryToWriter);
    f = message.getRecipientsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.notifications.Recipient.serializeBinaryToWriter);
    f = message.getContentList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.notifications.Content.serializeBinaryToWriter);
    f = message.getScheduledForTimesList();
    if (f.length > 0) writer.writeRepeatedMessage(5, f, proto.notifications.Time.serializeBinaryToWriter);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(6, f);
    f = message.getReadAt();
    if (f !== 0) writer.writeInt64(7, f);
    f = message.getVendorDataList();
    if (f.length > 0) writer.writeRepeatedMessage(8, f, proto.notifications.VendorData.serializeBinaryToWriter);
    f = message.getAttributesList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, proto.notifications.Attribute.serializeBinaryToWriter);
    f = message.getCreatedAt();
    if (f !== 0) writer.writeInt64(10, f);
    f = message.getSentAt();
    if (f !== 0) writer.writeInt64(11, f);
    f = message.getDeletedAt();
    if (f !== 0) writer.writeInt64(12, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.notifications.Notification.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.AutonomyUser sender = 2;
 * @return {?proto.domain.AutonomyUser}
 */ proto.notifications.Notification.prototype.getSender = function() {
    return /** @type{?proto.domain.AutonomyUser} */ $8M67s.Message.getWrapperField(this, $3QqPt.AutonomyUser, 2);
};
/**
 * @param {?proto.domain.AutonomyUser|undefined} value
 * @return {!proto.notifications.Notification} returns this
*/ proto.notifications.Notification.prototype.setSender = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.clearSender = function() {
    return this.setSender(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.notifications.Notification.prototype.hasSender = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * repeated Recipient recipients = 3;
 * @return {!Array<!proto.notifications.Recipient>}
 */ proto.notifications.Notification.prototype.getRecipientsList = function() {
    return /** @type{!Array<!proto.notifications.Recipient>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.notifications.Recipient, 3);
};
/**
 * @param {!Array<!proto.notifications.Recipient>} value
 * @return {!proto.notifications.Notification} returns this
*/ proto.notifications.Notification.prototype.setRecipientsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.notifications.Recipient=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notifications.Recipient}
 */ proto.notifications.Notification.prototype.addRecipients = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.notifications.Recipient, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.clearRecipientsList = function() {
    return this.setRecipientsList([]);
};
/**
 * repeated Content content = 4;
 * @return {!Array<!proto.notifications.Content>}
 */ proto.notifications.Notification.prototype.getContentList = function() {
    return /** @type{!Array<!proto.notifications.Content>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.notifications.Content, 4);
};
/**
 * @param {!Array<!proto.notifications.Content>} value
 * @return {!proto.notifications.Notification} returns this
*/ proto.notifications.Notification.prototype.setContentList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.notifications.Content=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notifications.Content}
 */ proto.notifications.Notification.prototype.addContent = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.notifications.Content, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.clearContentList = function() {
    return this.setContentList([]);
};
/**
 * repeated Time scheduled_for_times = 5;
 * @return {!Array<!proto.notifications.Time>}
 */ proto.notifications.Notification.prototype.getScheduledForTimesList = function() {
    return /** @type{!Array<!proto.notifications.Time>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.notifications.Time, 5);
};
/**
 * @param {!Array<!proto.notifications.Time>} value
 * @return {!proto.notifications.Notification} returns this
*/ proto.notifications.Notification.prototype.setScheduledForTimesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 5, value);
};
/**
 * @param {!proto.notifications.Time=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notifications.Time}
 */ proto.notifications.Notification.prototype.addScheduledForTimes = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.notifications.Time, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.clearScheduledForTimesList = function() {
    return this.setScheduledForTimesList([]);
};
/**
 * optional Status status = 6;
 * @return {!proto.notifications.Status}
 */ proto.notifications.Notification.prototype.getStatus = function() {
    return /** @type {!proto.notifications.Status} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.notifications.Status} value
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
/**
 * optional int64 read_at = 7;
 * @return {number}
 */ proto.notifications.Notification.prototype.getReadAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.setReadAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * repeated VendorData vendor_data = 8;
 * @return {!Array<!proto.notifications.VendorData>}
 */ proto.notifications.Notification.prototype.getVendorDataList = function() {
    return /** @type{!Array<!proto.notifications.VendorData>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.notifications.VendorData, 8);
};
/**
 * @param {!Array<!proto.notifications.VendorData>} value
 * @return {!proto.notifications.Notification} returns this
*/ proto.notifications.Notification.prototype.setVendorDataList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.notifications.VendorData=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notifications.VendorData}
 */ proto.notifications.Notification.prototype.addVendorData = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.notifications.VendorData, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.clearVendorDataList = function() {
    return this.setVendorDataList([]);
};
/**
 * repeated Attribute attributes = 9;
 * @return {!Array<!proto.notifications.Attribute>}
 */ proto.notifications.Notification.prototype.getAttributesList = function() {
    return /** @type{!Array<!proto.notifications.Attribute>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.notifications.Attribute, 9);
};
/**
 * @param {!Array<!proto.notifications.Attribute>} value
 * @return {!proto.notifications.Notification} returns this
*/ proto.notifications.Notification.prototype.setAttributesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.notifications.Attribute=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notifications.Attribute}
 */ proto.notifications.Notification.prototype.addAttributes = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.notifications.Attribute, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.clearAttributesList = function() {
    return this.setAttributesList([]);
};
/**
 * optional int64 created_at = 10;
 * @return {number}
 */ proto.notifications.Notification.prototype.getCreatedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.setCreatedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int64 sent_at = 11;
 * @return {number}
 */ proto.notifications.Notification.prototype.getSentAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.setSentAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int64 deleted_at = 12;
 * @return {number}
 */ proto.notifications.Notification.prototype.getDeletedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.notifications.Notification} returns this
 */ proto.notifications.Notification.prototype.setDeletedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.Time.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.Time.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.Time} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Time.toObject = function(includeInstance, msg) {
        var f, obj = {
            epochMilli: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            timezone: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.Time}
 */ proto.notifications.Time.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.Time;
    return proto.notifications.Time.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.Time} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.Time}
 */ proto.notifications.Time.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setEpochMilli(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTimezone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.Time.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.Time.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.Time} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Time.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getEpochMilli();
    if (f !== 0) writer.writeInt64(1, f);
    f = message.getTimezone();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional int64 epoch_milli = 1;
 * @return {number}
 */ proto.notifications.Time.prototype.getEpochMilli = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.notifications.Time} returns this
 */ proto.notifications.Time.prototype.setEpochMilli = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string timezone = 2;
 * @return {string}
 */ proto.notifications.Time.prototype.getTimezone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.Time} returns this
 */ proto.notifications.Time.prototype.setTimezone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.notifications.Recipient.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.Recipient.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.Recipient.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.Recipient} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Recipient.toObject = function(includeInstance, msg) {
        var f, obj = {
            userData: (f = msg.getUserData()) && $3QqPt.AutonomyUser.toObject(includeInstance, f),
            deliveryMethodsList: (f = $8M67s.Message.getRepeatedField(msg, 2)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.Recipient}
 */ proto.notifications.Recipient.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.Recipient;
    return proto.notifications.Recipient.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.Recipient} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.Recipient}
 */ proto.notifications.Recipient.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.AutonomyUser;
                reader.readMessage(value, $3QqPt.AutonomyUser.deserializeBinaryFromReader);
                msg.setUserData(value);
                break;
            case 2:
                var values = /** @type {!Array<!proto.notifications.DeliveryMethod>} */ reader.isDelimited() ? reader.readPackedEnum() : [
                    reader.readEnum()
                ];
                for(var i = 0; i < values.length; i++)msg.addDeliveryMethods(values[i]);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.Recipient.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.Recipient.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.Recipient} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Recipient.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getUserData();
    if (f != null) writer.writeMessage(1, f, $3QqPt.AutonomyUser.serializeBinaryToWriter);
    f = message.getDeliveryMethodsList();
    if (f.length > 0) writer.writePackedEnum(2, f);
};
/**
 * optional domain.AutonomyUser user_data = 1;
 * @return {?proto.domain.AutonomyUser}
 */ proto.notifications.Recipient.prototype.getUserData = function() {
    return /** @type{?proto.domain.AutonomyUser} */ $8M67s.Message.getWrapperField(this, $3QqPt.AutonomyUser, 1);
};
/**
 * @param {?proto.domain.AutonomyUser|undefined} value
 * @return {!proto.notifications.Recipient} returns this
*/ proto.notifications.Recipient.prototype.setUserData = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.notifications.Recipient} returns this
 */ proto.notifications.Recipient.prototype.clearUserData = function() {
    return this.setUserData(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.notifications.Recipient.prototype.hasUserData = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated DeliveryMethod delivery_methods = 2;
 * @return {!Array<!proto.notifications.DeliveryMethod>}
 */ proto.notifications.Recipient.prototype.getDeliveryMethodsList = function() {
    return /** @type {!Array<!proto.notifications.DeliveryMethod>} */ $8M67s.Message.getRepeatedField(this, 2);
};
/**
 * @param {!Array<!proto.notifications.DeliveryMethod>} value
 * @return {!proto.notifications.Recipient} returns this
 */ proto.notifications.Recipient.prototype.setDeliveryMethodsList = function(value) {
    return $8M67s.Message.setField(this, 2, value || []);
};
/**
 * @param {!proto.notifications.DeliveryMethod} value
 * @param {number=} opt_index
 * @return {!proto.notifications.Recipient} returns this
 */ proto.notifications.Recipient.prototype.addDeliveryMethods = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 2, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notifications.Recipient} returns this
 */ proto.notifications.Recipient.prototype.clearDeliveryMethodsList = function() {
    return this.setDeliveryMethodsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.Content.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.Content.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.Content} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Content.toObject = function(includeInstance, msg) {
        var f, obj = {
            type: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            data: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            encoding: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.Content}
 */ proto.notifications.Content.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.Content;
    return proto.notifications.Content.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.Content} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.Content}
 */ proto.notifications.Content.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.notifications.ContentType} */ reader.readEnum();
                msg.setType(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setData(value);
                break;
            case 3:
                var value = /** @type {!proto.notifications.Encoding} */ reader.readEnum();
                msg.setEncoding(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.Content.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.Content.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.Content} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Content.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getType();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getData();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getEncoding();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * optional ContentType type = 1;
 * @return {!proto.notifications.ContentType}
 */ proto.notifications.Content.prototype.getType = function() {
    return /** @type {!proto.notifications.ContentType} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.notifications.ContentType} value
 * @return {!proto.notifications.Content} returns this
 */ proto.notifications.Content.prototype.setType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string data = 2;
 * @return {string}
 */ proto.notifications.Content.prototype.getData = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.Content} returns this
 */ proto.notifications.Content.prototype.setData = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional Encoding encoding = 3;
 * @return {!proto.notifications.Encoding}
 */ proto.notifications.Content.prototype.getEncoding = function() {
    return /** @type {!proto.notifications.Encoding} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.notifications.Encoding} value
 * @return {!proto.notifications.Content} returns this
 */ proto.notifications.Content.prototype.setEncoding = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.Attribute.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.Attribute.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.Attribute} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Attribute.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            value: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.Attribute}
 */ proto.notifications.Attribute.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.Attribute;
    return proto.notifications.Attribute.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.Attribute} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.Attribute}
 */ proto.notifications.Attribute.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.Attribute.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.Attribute.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.Attribute} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.Attribute.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getValue();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.notifications.Attribute.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.Attribute} returns this
 */ proto.notifications.Attribute.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string value = 2;
 * @return {string}
 */ proto.notifications.Attribute.prototype.getValue = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.Attribute} returns this
 */ proto.notifications.Attribute.prototype.setValue = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notifications.VendorData.prototype.toObject = function(opt_includeInstance) {
        return proto.notifications.VendorData.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notifications.VendorData} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.VendorData.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            data: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notifications.VendorData}
 */ proto.notifications.VendorData.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notifications.VendorData;
    return proto.notifications.VendorData.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notifications.VendorData} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notifications.VendorData}
 */ proto.notifications.VendorData.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setData(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notifications.VendorData.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notifications.VendorData.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notifications.VendorData} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notifications.VendorData.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getData();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.notifications.VendorData.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.VendorData} returns this
 */ proto.notifications.VendorData.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string data = 2;
 * @return {string}
 */ proto.notifications.VendorData.prototype.getData = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.notifications.VendorData} returns this
 */ proto.notifications.VendorData.prototype.setData = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * @enum {number}
 */ proto.notifications.Status = {
    SCHEDULED: 0,
    SENT: 1,
    DELIVERED: 2
};
/**
 * @enum {number}
 */ proto.notifications.DeliveryMethod = {
    SMS: 0,
    EMAIL: 1,
    IN_APP: 2
};
/**
 * @enum {number}
 */ proto.notifications.ContentType = {
    SUBJECT: 0,
    BODY: 1
};
/**
 * @enum {number}
 */ proto.notifications.Encoding = {
    PLAIN_TEXT: 0,
    JSON_STRING: 1,
    BASE_64: 2,
    BINARY: 3
};
$2a4e397979157a14$var$goog.object.extend(module.exports, proto.notifications);

});



parcelRegister("9HeMJ", function(module, exports) {
// source: subscription_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $70f39930bf7ec61a$var$goog = $8M67s;
var $70f39930bf7ec61a$var$global = Function('return this')();

var $hOsJC = parcelRequire("hOsJC");
$70f39930bf7ec61a$var$goog.object.extend(proto, $hOsJC);

var $3QqPt = parcelRequire("3QqPt");
$70f39930bf7ec61a$var$goog.object.extend(proto, $3QqPt);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.ActivateRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.ActivateResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.AddVehicleAssignmentRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.AddVehicleAssignmentResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.AdminActivateRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.CancelReservationRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.CancelReservationResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.ContractResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.CreateWebReservationRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.CreateWebReservationResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.DatedPricingOption', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.FindCustomerByPhoneRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.FindCustomerByPhoneResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetActiveOrLatestSubscriptionRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetContractRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetOwnContractRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetOwnPickupReceiptRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetPickupReceiptRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetProgramRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetProgramResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetReservationRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetReservationResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetSubscriptionRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.GetSubscriptionResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.ListProgramsRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.ListProgramsResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.ListReservationsRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.ListReservationsResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.PickupReceiptResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.PreviewOwnContractRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.PreviewOwnPickupReceiptRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.RemoveVehicleAssignmentRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.RemoveVehicleAssignmentResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.ReservationListItem', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.SetReservationProgramRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.SetReservationProgramResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.SignContractRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.SignContractResponse', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.UpdateReservationRequest', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.UpdateReservationRequest.ProgramOptionsCase', null, $70f39930bf7ec61a$var$global);
$70f39930bf7ec61a$var$goog.exportSymbol('proto.subscription_service.UpdateReservationResponse', null, $70f39930bf7ec61a$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.PreviewOwnContractRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.PreviewOwnContractRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.PreviewOwnContractRequest.displayName = 'proto.subscription_service.PreviewOwnContractRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetOwnContractRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetOwnContractRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetOwnContractRequest.displayName = 'proto.subscription_service.GetOwnContractRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetContractRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetContractRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetContractRequest.displayName = 'proto.subscription_service.GetContractRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.ContractResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.ContractResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.ContractResponse.displayName = 'proto.subscription_service.ContractResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.SignContractRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.SignContractRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.SignContractRequest.displayName = 'proto.subscription_service.SignContractRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.SignContractResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.SignContractResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.SignContractResponse.displayName = 'proto.subscription_service.SignContractResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.PreviewOwnPickupReceiptRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.PreviewOwnPickupReceiptRequest.displayName = 'proto.subscription_service.PreviewOwnPickupReceiptRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetOwnPickupReceiptRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetOwnPickupReceiptRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetOwnPickupReceiptRequest.displayName = 'proto.subscription_service.GetOwnPickupReceiptRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetPickupReceiptRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetPickupReceiptRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetPickupReceiptRequest.displayName = 'proto.subscription_service.GetPickupReceiptRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.PickupReceiptResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.PickupReceiptResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.PickupReceiptResponse.displayName = 'proto.subscription_service.PickupReceiptResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.AdminActivateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.AdminActivateRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.AdminActivateRequest.displayName = 'proto.subscription_service.AdminActivateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.ActivateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.ActivateRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.ActivateRequest.displayName = 'proto.subscription_service.ActivateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.ActivateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.ActivateResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.ActivateResponse.displayName = 'proto.subscription_service.ActivateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.CancelReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.CancelReservationRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.CancelReservationRequest.displayName = 'proto.subscription_service.CancelReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.CancelReservationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.CancelReservationResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.CancelReservationResponse.displayName = 'proto.subscription_service.CancelReservationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.CreateWebReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.CreateWebReservationRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.CreateWebReservationRequest.displayName = 'proto.subscription_service.CreateWebReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.CreateWebReservationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.CreateWebReservationResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.CreateWebReservationResponse.displayName = 'proto.subscription_service.CreateWebReservationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.ListReservationsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.ListReservationsRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.ListReservationsRequest.displayName = 'proto.subscription_service.ListReservationsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.ReservationListItem = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.ReservationListItem, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.ReservationListItem.displayName = 'proto.subscription_service.ReservationListItem';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.ListReservationsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.subscription_service.ListReservationsResponse.repeatedFields_, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.ListReservationsResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.ListReservationsResponse.displayName = 'proto.subscription_service.ListReservationsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetReservationRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetReservationRequest.displayName = 'proto.subscription_service.GetReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetReservationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetReservationResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetReservationResponse.displayName = 'proto.subscription_service.GetReservationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.ListProgramsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.ListProgramsRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.ListProgramsRequest.displayName = 'proto.subscription_service.ListProgramsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.ListProgramsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.subscription_service.ListProgramsResponse.repeatedFields_, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.ListProgramsResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.ListProgramsResponse.displayName = 'proto.subscription_service.ListProgramsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.UpdateReservationRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.subscription_service.UpdateReservationRequest.oneofGroups_);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.UpdateReservationRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.UpdateReservationRequest.displayName = 'proto.subscription_service.UpdateReservationRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.UpdateReservationResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.UpdateReservationResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.UpdateReservationResponse.displayName = 'proto.subscription_service.UpdateReservationResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.FindCustomerByPhoneRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.FindCustomerByPhoneRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.FindCustomerByPhoneRequest.displayName = 'proto.subscription_service.FindCustomerByPhoneRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.FindCustomerByPhoneResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.FindCustomerByPhoneResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.FindCustomerByPhoneResponse.displayName = 'proto.subscription_service.FindCustomerByPhoneResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.SetReservationProgramRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.SetReservationProgramRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.SetReservationProgramRequest.displayName = 'proto.subscription_service.SetReservationProgramRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.SetReservationProgramResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.SetReservationProgramResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.SetReservationProgramResponse.displayName = 'proto.subscription_service.SetReservationProgramResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.DatedPricingOption = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.subscription_service.DatedPricingOption.repeatedFields_, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.DatedPricingOption, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.DatedPricingOption.displayName = 'proto.subscription_service.DatedPricingOption';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetProgramRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetProgramRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetProgramRequest.displayName = 'proto.subscription_service.GetProgramRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetProgramResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetProgramResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetProgramResponse.displayName = 'proto.subscription_service.GetProgramResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetSubscriptionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetSubscriptionRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetSubscriptionRequest.displayName = 'proto.subscription_service.GetSubscriptionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetSubscriptionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetSubscriptionResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetSubscriptionResponse.displayName = 'proto.subscription_service.GetSubscriptionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.GetActiveOrLatestSubscriptionRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.displayName = 'proto.subscription_service.GetActiveOrLatestSubscriptionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.AddVehicleAssignmentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.AddVehicleAssignmentRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.AddVehicleAssignmentRequest.displayName = 'proto.subscription_service.AddVehicleAssignmentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.AddVehicleAssignmentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.AddVehicleAssignmentResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.AddVehicleAssignmentResponse.displayName = 'proto.subscription_service.AddVehicleAssignmentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.RemoveVehicleAssignmentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.RemoveVehicleAssignmentRequest, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.RemoveVehicleAssignmentRequest.displayName = 'proto.subscription_service.RemoveVehicleAssignmentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.subscription_service.RemoveVehicleAssignmentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$70f39930bf7ec61a$var$goog.inherits(proto.subscription_service.RemoveVehicleAssignmentResponse, $8M67s.Message);
if ($70f39930bf7ec61a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.subscription_service.RemoveVehicleAssignmentResponse.displayName = 'proto.subscription_service.RemoveVehicleAssignmentResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.PreviewOwnContractRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.PreviewOwnContractRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.PreviewOwnContractRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.PreviewOwnContractRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.PreviewOwnContractRequest}
 */ proto.subscription_service.PreviewOwnContractRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.PreviewOwnContractRequest;
    return proto.subscription_service.PreviewOwnContractRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.PreviewOwnContractRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.PreviewOwnContractRequest}
 */ proto.subscription_service.PreviewOwnContractRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.PreviewOwnContractRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.PreviewOwnContractRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.PreviewOwnContractRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.PreviewOwnContractRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.subscription_service.PreviewOwnContractRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.PreviewOwnContractRequest} returns this
 */ proto.subscription_service.PreviewOwnContractRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetOwnContractRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetOwnContractRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetOwnContractRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetOwnContractRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetOwnContractRequest}
 */ proto.subscription_service.GetOwnContractRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetOwnContractRequest;
    return proto.subscription_service.GetOwnContractRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetOwnContractRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetOwnContractRequest}
 */ proto.subscription_service.GetOwnContractRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetOwnContractRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetOwnContractRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetOwnContractRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetOwnContractRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetContractRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetContractRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetContractRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetContractRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetContractRequest}
 */ proto.subscription_service.GetContractRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetContractRequest;
    return proto.subscription_service.GetContractRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetContractRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetContractRequest}
 */ proto.subscription_service.GetContractRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetContractRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetContractRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetContractRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetContractRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription_service.GetContractRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetContractRequest} returns this
 */ proto.subscription_service.GetContractRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.ContractResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.ContractResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.ContractResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ContractResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            properties: (f = msg.getProperties()) && $hOsJC.ContractProperties.toObject(includeInstance, f),
            signature: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            signedAt: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            contractUri: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            createdAt: $8M67s.Message.getFieldWithDefault(msg, 7, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.ContractResponse}
 */ proto.subscription_service.ContractResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.ContractResponse;
    return proto.subscription_service.ContractResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.ContractResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.ContractResponse}
 */ proto.subscription_service.ContractResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = new $hOsJC.ContractProperties;
                reader.readMessage(value, $hOsJC.ContractProperties.deserializeBinaryFromReader);
                msg.setProperties(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setSignature(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setSignedAt(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setContractUri(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreatedAt(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.ContractResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.ContractResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.ContractResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ContractResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getProperties();
    if (f != null) writer.writeMessage(3, f, $hOsJC.ContractProperties.serializeBinaryToWriter);
    f = message.getSignature();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getSignedAt();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getContractUri();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getCreatedAt();
    if (f !== 0) writer.writeInt64(7, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription_service.ContractResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ContractResponse} returns this
 */ proto.subscription_service.ContractResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.subscription_service.ContractResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ContractResponse} returns this
 */ proto.subscription_service.ContractResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional subscription.ContractProperties properties = 3;
 * @return {?proto.subscription.ContractProperties}
 */ proto.subscription_service.ContractResponse.prototype.getProperties = function() {
    return /** @type{?proto.subscription.ContractProperties} */ $8M67s.Message.getWrapperField(this, $hOsJC.ContractProperties, 3);
};
/**
 * @param {?proto.subscription.ContractProperties|undefined} value
 * @return {!proto.subscription_service.ContractResponse} returns this
*/ proto.subscription_service.ContractResponse.prototype.setProperties = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.ContractResponse} returns this
 */ proto.subscription_service.ContractResponse.prototype.clearProperties = function() {
    return this.setProperties(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.ContractResponse.prototype.hasProperties = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional string signature = 4;
 * @return {string}
 */ proto.subscription_service.ContractResponse.prototype.getSignature = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ContractResponse} returns this
 */ proto.subscription_service.ContractResponse.prototype.setSignature = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional int64 signed_at = 5;
 * @return {number}
 */ proto.subscription_service.ContractResponse.prototype.getSignedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.ContractResponse} returns this
 */ proto.subscription_service.ContractResponse.prototype.setSignedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional string contract_uri = 6;
 * @return {string}
 */ proto.subscription_service.ContractResponse.prototype.getContractUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ContractResponse} returns this
 */ proto.subscription_service.ContractResponse.prototype.setContractUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int64 created_at = 7;
 * @return {number}
 */ proto.subscription_service.ContractResponse.prototype.getCreatedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.ContractResponse} returns this
 */ proto.subscription_service.ContractResponse.prototype.setCreatedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.SignContractRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.SignContractRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.SignContractRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.SignContractRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            signatureImage: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.SignContractRequest}
 */ proto.subscription_service.SignContractRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.SignContractRequest;
    return proto.subscription_service.SignContractRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.SignContractRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.SignContractRequest}
 */ proto.subscription_service.SignContractRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSignatureImage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.SignContractRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.SignContractRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.SignContractRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.SignContractRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSignatureImage();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.subscription_service.SignContractRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.SignContractRequest} returns this
 */ proto.subscription_service.SignContractRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string signature_image = 2;
 * @return {string}
 */ proto.subscription_service.SignContractRequest.prototype.getSignatureImage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.SignContractRequest} returns this
 */ proto.subscription_service.SignContractRequest.prototype.setSignatureImage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.SignContractResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.SignContractResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.SignContractResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.SignContractResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.SignContractResponse}
 */ proto.subscription_service.SignContractResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.SignContractResponse;
    return proto.subscription_service.SignContractResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.SignContractResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.SignContractResponse}
 */ proto.subscription_service.SignContractResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.SignContractResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.SignContractResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.SignContractResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.SignContractResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.PreviewOwnPickupReceiptRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.PreviewOwnPickupReceiptRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.PreviewOwnPickupReceiptRequest}
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.PreviewOwnPickupReceiptRequest;
    return proto.subscription_service.PreviewOwnPickupReceiptRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.PreviewOwnPickupReceiptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.PreviewOwnPickupReceiptRequest}
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.PreviewOwnPickupReceiptRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.PreviewOwnPickupReceiptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.PreviewOwnPickupReceiptRequest} returns this
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.PreviewOwnPickupReceiptRequest} returns this
 */ proto.subscription_service.PreviewOwnPickupReceiptRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetOwnPickupReceiptRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetOwnPickupReceiptRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetOwnPickupReceiptRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetOwnPickupReceiptRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetOwnPickupReceiptRequest}
 */ proto.subscription_service.GetOwnPickupReceiptRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetOwnPickupReceiptRequest;
    return proto.subscription_service.GetOwnPickupReceiptRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetOwnPickupReceiptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetOwnPickupReceiptRequest}
 */ proto.subscription_service.GetOwnPickupReceiptRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetOwnPickupReceiptRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetOwnPickupReceiptRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetOwnPickupReceiptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetOwnPickupReceiptRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.subscription_service.GetOwnPickupReceiptRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetOwnPickupReceiptRequest} returns this
 */ proto.subscription_service.GetOwnPickupReceiptRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.subscription_service.GetOwnPickupReceiptRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetOwnPickupReceiptRequest} returns this
 */ proto.subscription_service.GetOwnPickupReceiptRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetPickupReceiptRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetPickupReceiptRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetPickupReceiptRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetPickupReceiptRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetPickupReceiptRequest}
 */ proto.subscription_service.GetPickupReceiptRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetPickupReceiptRequest;
    return proto.subscription_service.GetPickupReceiptRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetPickupReceiptRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetPickupReceiptRequest}
 */ proto.subscription_service.GetPickupReceiptRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetPickupReceiptRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetPickupReceiptRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetPickupReceiptRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetPickupReceiptRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription_service.GetPickupReceiptRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetPickupReceiptRequest} returns this
 */ proto.subscription_service.GetPickupReceiptRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.subscription_service.GetPickupReceiptRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetPickupReceiptRequest} returns this
 */ proto.subscription_service.GetPickupReceiptRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.subscription_service.GetPickupReceiptRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetPickupReceiptRequest} returns this
 */ proto.subscription_service.GetPickupReceiptRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.PickupReceiptResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.PickupReceiptResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.PickupReceiptResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.PickupReceiptResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            receipt: (f = msg.getReceipt()) && $hOsJC.VehiclePickupReceiptProperties.toObject(includeInstance, f),
            receiptUri: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            id: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            createdAt: $8M67s.Message.getFieldWithDefault(msg, 7, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.PickupReceiptResponse}
 */ proto.subscription_service.PickupReceiptResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.PickupReceiptResponse;
    return proto.subscription_service.PickupReceiptResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.PickupReceiptResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.PickupReceiptResponse}
 */ proto.subscription_service.PickupReceiptResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = new $hOsJC.VehiclePickupReceiptProperties;
                reader.readMessage(value, $hOsJC.VehiclePickupReceiptProperties.deserializeBinaryFromReader);
                msg.setReceipt(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setReceiptUri(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreatedAt(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.PickupReceiptResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.PickupReceiptResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.PickupReceiptResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.PickupReceiptResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getReceipt();
    if (f != null) writer.writeMessage(3, f, $hOsJC.VehiclePickupReceiptProperties.serializeBinaryToWriter);
    f = message.getReceiptUri();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getCreatedAt();
    if (f !== 0) writer.writeInt64(7, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription_service.PickupReceiptResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.PickupReceiptResponse} returns this
 */ proto.subscription_service.PickupReceiptResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.subscription_service.PickupReceiptResponse.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.PickupReceiptResponse} returns this
 */ proto.subscription_service.PickupReceiptResponse.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional subscription.VehiclePickupReceiptProperties receipt = 3;
 * @return {?proto.subscription.VehiclePickupReceiptProperties}
 */ proto.subscription_service.PickupReceiptResponse.prototype.getReceipt = function() {
    return /** @type{?proto.subscription.VehiclePickupReceiptProperties} */ $8M67s.Message.getWrapperField(this, $hOsJC.VehiclePickupReceiptProperties, 3);
};
/**
 * @param {?proto.subscription.VehiclePickupReceiptProperties|undefined} value
 * @return {!proto.subscription_service.PickupReceiptResponse} returns this
*/ proto.subscription_service.PickupReceiptResponse.prototype.setReceipt = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.PickupReceiptResponse} returns this
 */ proto.subscription_service.PickupReceiptResponse.prototype.clearReceipt = function() {
    return this.setReceipt(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.PickupReceiptResponse.prototype.hasReceipt = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional string receipt_uri = 4;
 * @return {string}
 */ proto.subscription_service.PickupReceiptResponse.prototype.getReceiptUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.PickupReceiptResponse} returns this
 */ proto.subscription_service.PickupReceiptResponse.prototype.setReceiptUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string id = 5;
 * @return {string}
 */ proto.subscription_service.PickupReceiptResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.PickupReceiptResponse} returns this
 */ proto.subscription_service.PickupReceiptResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string subscription_id = 6;
 * @return {string}
 */ proto.subscription_service.PickupReceiptResponse.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.PickupReceiptResponse} returns this
 */ proto.subscription_service.PickupReceiptResponse.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional int64 created_at = 7;
 * @return {number}
 */ proto.subscription_service.PickupReceiptResponse.prototype.getCreatedAt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.PickupReceiptResponse} returns this
 */ proto.subscription_service.PickupReceiptResponse.prototype.setCreatedAt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.AdminActivateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.AdminActivateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.AdminActivateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.AdminActivateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.AdminActivateRequest}
 */ proto.subscription_service.AdminActivateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.AdminActivateRequest;
    return proto.subscription_service.AdminActivateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.AdminActivateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.AdminActivateRequest}
 */ proto.subscription_service.AdminActivateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.AdminActivateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.AdminActivateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.AdminActivateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.AdminActivateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription_service.AdminActivateRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.AdminActivateRequest} returns this
 */ proto.subscription_service.AdminActivateRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.subscription_service.AdminActivateRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.AdminActivateRequest} returns this
 */ proto.subscription_service.AdminActivateRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.ActivateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.ActivateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.ActivateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ActivateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.ActivateRequest}
 */ proto.subscription_service.ActivateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.ActivateRequest;
    return proto.subscription_service.ActivateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.ActivateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.ActivateRequest}
 */ proto.subscription_service.ActivateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.ActivateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.ActivateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.ActivateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ActivateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.subscription_service.ActivateRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ActivateRequest} returns this
 */ proto.subscription_service.ActivateRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.ActivateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.ActivateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.ActivateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ActivateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.ActivateResponse}
 */ proto.subscription_service.ActivateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.ActivateResponse;
    return proto.subscription_service.ActivateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.ActivateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.ActivateResponse}
 */ proto.subscription_service.ActivateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.ActivateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.ActivateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.ActivateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ActivateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.CancelReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.CancelReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.CancelReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.CancelReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            customerReason: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            userType: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            actionReason: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.CancelReservationRequest}
 */ proto.subscription_service.CancelReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.CancelReservationRequest;
    return proto.subscription_service.CancelReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.CancelReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.CancelReservationRequest}
 */ proto.subscription_service.CancelReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerReason(value);
                break;
            case 4:
                var value = /** @type {!proto.domain.Subscription.SubscriptionAction.UserType} */ reader.readEnum();
                msg.setUserType(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 6:
                var value = /** @type {!proto.subscription.SubscriptionAction.ActionReason} */ reader.readEnum();
                msg.setActionReason(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.CancelReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.CancelReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.CancelReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.CancelReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCustomerReason();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getUserType();
    if (f !== 0.0) writer.writeEnum(4, f);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getActionReason();
    if (f !== 0.0) writer.writeEnum(6, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.subscription_service.CancelReservationRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CancelReservationRequest} returns this
 */ proto.subscription_service.CancelReservationRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.subscription_service.CancelReservationRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CancelReservationRequest} returns this
 */ proto.subscription_service.CancelReservationRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string customer_reason = 3;
 * @return {string}
 */ proto.subscription_service.CancelReservationRequest.prototype.getCustomerReason = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CancelReservationRequest} returns this
 */ proto.subscription_service.CancelReservationRequest.prototype.setCustomerReason = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional domain.Subscription.SubscriptionAction.UserType user_type = 4;
 * @return {!proto.domain.Subscription.SubscriptionAction.UserType}
 */ proto.subscription_service.CancelReservationRequest.prototype.getUserType = function() {
    return /** @type {!proto.domain.Subscription.SubscriptionAction.UserType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.domain.Subscription.SubscriptionAction.UserType} value
 * @return {!proto.subscription_service.CancelReservationRequest} returns this
 */ proto.subscription_service.CancelReservationRequest.prototype.setUserType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
/**
 * optional string reservation_id = 5;
 * @return {string}
 */ proto.subscription_service.CancelReservationRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CancelReservationRequest} returns this
 */ proto.subscription_service.CancelReservationRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional subscription.SubscriptionAction.ActionReason action_reason = 6;
 * @return {!proto.subscription.SubscriptionAction.ActionReason}
 */ proto.subscription_service.CancelReservationRequest.prototype.getActionReason = function() {
    return /** @type {!proto.subscription.SubscriptionAction.ActionReason} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {!proto.subscription.SubscriptionAction.ActionReason} value
 * @return {!proto.subscription_service.CancelReservationRequest} returns this
 */ proto.subscription_service.CancelReservationRequest.prototype.setActionReason = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.CancelReservationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.CancelReservationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.CancelReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.CancelReservationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.CancelReservationResponse}
 */ proto.subscription_service.CancelReservationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.CancelReservationResponse;
    return proto.subscription_service.CancelReservationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.CancelReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.CancelReservationResponse}
 */ proto.subscription_service.CancelReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.CancelReservationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.CancelReservationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.CancelReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.CancelReservationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string reservation_id = 1;
 * @return {string}
 */ proto.subscription_service.CancelReservationResponse.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CancelReservationResponse} returns this
 */ proto.subscription_service.CancelReservationResponse.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.subscription_service.CancelReservationResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CancelReservationResponse} returns this
 */ proto.subscription_service.CancelReservationResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.CreateWebReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.CreateWebReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.CreateWebReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            programId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            monthlyRate: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            cardholderName: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            cardNumber: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            cardExpiration: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            cardValidation: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            billingPostal: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            trackingId: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 14, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.CreateWebReservationRequest}
 */ proto.subscription_service.CreateWebReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.CreateWebReservationRequest;
    return proto.subscription_service.CreateWebReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.CreateWebReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.CreateWebReservationRequest}
 */ proto.subscription_service.CreateWebReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyRate(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setCardholderName(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setCardNumber(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setCardExpiration(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setCardValidation(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setBillingPostal(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingId(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPriceTermMonths(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.CreateWebReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.CreateWebReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.CreateWebReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getMonthlyRate();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getCardholderName();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getCardNumber();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getCardExpiration();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getCardValidation();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getBillingPostal();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getTrackingId();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getPriceTermMonths();
    if (f !== 0) writer.writeInt32(14, f);
};
/**
 * optional string program_id = 1;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 start_fee = 2;
 * @return {number}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 monthly_rate = 3;
 * @return {number}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getMonthlyRate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setMonthlyRate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string first_name = 4;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string last_name = 5;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string phone = 6;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string email = 7;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string cardholder_name = 8;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getCardholderName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setCardholderName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string card_number = 9;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getCardNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setCardNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string card_expiration = 10;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getCardExpiration = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setCardExpiration = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string card_validation = 11;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getCardValidation = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setCardValidation = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string billing_postal = 12;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getBillingPostal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setBillingPostal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string tracking_id = 13;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getTrackingId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setTrackingId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional int32 price_term_months = 14;
 * @return {number}
 */ proto.subscription_service.CreateWebReservationRequest.prototype.getPriceTermMonths = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.CreateWebReservationRequest} returns this
 */ proto.subscription_service.CreateWebReservationRequest.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3IntField(this, 14, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.CreateWebReservationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.CreateWebReservationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.CreateWebReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.CreateWebReservationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            reservationNumber: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.CreateWebReservationResponse}
 */ proto.subscription_service.CreateWebReservationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.CreateWebReservationResponse;
    return proto.subscription_service.CreateWebReservationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.CreateWebReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.CreateWebReservationResponse}
 */ proto.subscription_service.CreateWebReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.CreateWebReservationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.CreateWebReservationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.CreateWebReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.CreateWebReservationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getReservationNumber();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationResponse.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationResponse} returns this
 */ proto.subscription_service.CreateWebReservationResponse.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string reservation_id = 2;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationResponse.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationResponse} returns this
 */ proto.subscription_service.CreateWebReservationResponse.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string reservation_number = 3;
 * @return {string}
 */ proto.subscription_service.CreateWebReservationResponse.prototype.getReservationNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.CreateWebReservationResponse} returns this
 */ proto.subscription_service.CreateWebReservationResponse.prototype.setReservationNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.ListReservationsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.ListReservationsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.ListReservationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ListReservationsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            programId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            pageState: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            pageSize: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            query: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            clientId: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.ListReservationsRequest}
 */ proto.subscription_service.ListReservationsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.ListReservationsRequest;
    return proto.subscription_service.ListReservationsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.ListReservationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.ListReservationsRequest}
 */ proto.subscription_service.ListReservationsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPageState(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPageSize(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setQuery(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setClientId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.ListReservationsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.ListReservationsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.ListReservationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ListReservationsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPageState();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getPageSize();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getQuery();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getClientId();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string program_id = 1;
 * @return {string}
 */ proto.subscription_service.ListReservationsRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ListReservationsRequest} returns this
 */ proto.subscription_service.ListReservationsRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string page_state = 2;
 * @return {string}
 */ proto.subscription_service.ListReservationsRequest.prototype.getPageState = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ListReservationsRequest} returns this
 */ proto.subscription_service.ListReservationsRequest.prototype.setPageState = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 page_size = 3;
 * @return {number}
 */ proto.subscription_service.ListReservationsRequest.prototype.getPageSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.ListReservationsRequest} returns this
 */ proto.subscription_service.ListReservationsRequest.prototype.setPageSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string query = 4;
 * @return {string}
 */ proto.subscription_service.ListReservationsRequest.prototype.getQuery = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ListReservationsRequest} returns this
 */ proto.subscription_service.ListReservationsRequest.prototype.setQuery = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string client_id = 5;
 * @return {string}
 */ proto.subscription_service.ListReservationsRequest.prototype.getClientId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ListReservationsRequest} returns this
 */ proto.subscription_service.ListReservationsRequest.prototype.setClientId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.ReservationListItem.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.ReservationListItem.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.ReservationListItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ReservationListItem.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservation: (f = msg.getReservation()) && $hOsJC.Reservation.toObject(includeInstance, f),
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            waitlistStart: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            color: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            status: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            postal: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 14, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.ReservationListItem}
 */ proto.subscription_service.ReservationListItem.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.ReservationListItem;
    return proto.subscription_service.ReservationListItem.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.ReservationListItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.ReservationListItem}
 */ proto.subscription_service.ReservationListItem.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $hOsJC.Reservation;
                reader.readMessage(value, $hOsJC.Reservation.deserializeBinaryFromReader);
                msg.setReservation(value);
                break;
            case 2:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setWaitlistStart(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setColor(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setStatus(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setPostal(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.ReservationListItem.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.ReservationListItem.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.ReservationListItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ReservationListItem.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservation();
    if (f != null) writer.writeMessage(1, f, $hOsJC.Reservation.serializeBinaryToWriter);
    f = message.getCustomer();
    if (f != null) writer.writeMessage(2, f, $3QqPt.Customer.serializeBinaryToWriter);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getWaitlistStart();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getColor();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getStatus();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getPostal();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(14, f);
};
/**
 * optional subscription.Reservation reservation = 1;
 * @return {?proto.subscription.Reservation}
 */ proto.subscription_service.ReservationListItem.prototype.getReservation = function() {
    return /** @type{?proto.subscription.Reservation} */ $8M67s.Message.getWrapperField(this, $hOsJC.Reservation, 1);
};
/**
 * @param {?proto.subscription.Reservation|undefined} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
*/ proto.subscription_service.ReservationListItem.prototype.setReservation = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.clearReservation = function() {
    return this.setReservation(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.ReservationListItem.prototype.hasReservation = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional domain.Customer customer = 2;
 * @return {?proto.domain.Customer}
 */ proto.subscription_service.ReservationListItem.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 2);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
*/ proto.subscription_service.ReservationListItem.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.ReservationListItem.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional string reservation_id = 3;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string customer_id = 4;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string first_name = 5;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string last_name = 6;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string account_number = 7;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string waitlist_start = 8;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getWaitlistStart = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setWaitlistStart = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string vin = 9;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string model = 10;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string color = 11;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string status = 12;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getStatus = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string postal = 13;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getPostal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setPostal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string make = 14;
 * @return {string}
 */ proto.subscription_service.ReservationListItem.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ReservationListItem} returns this
 */ proto.subscription_service.ReservationListItem.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.subscription_service.ListReservationsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.ListReservationsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.ListReservationsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.ListReservationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ListReservationsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationsList: $8M67s.Message.toObjectList(msg.getReservationsList(), proto.subscription_service.ReservationListItem.toObject, includeInstance),
            pageState: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            total: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.ListReservationsResponse}
 */ proto.subscription_service.ListReservationsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.ListReservationsResponse;
    return proto.subscription_service.ListReservationsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.ListReservationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.ListReservationsResponse}
 */ proto.subscription_service.ListReservationsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.subscription_service.ReservationListItem;
                reader.readMessage(value, proto.subscription_service.ReservationListItem.deserializeBinaryFromReader);
                msg.addReservations(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPageState(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.ListReservationsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.ListReservationsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.ListReservationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ListReservationsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.subscription_service.ReservationListItem.serializeBinaryToWriter);
    f = message.getPageState();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getTotal();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * repeated ReservationListItem reservations = 1;
 * @return {!Array<!proto.subscription_service.ReservationListItem>}
 */ proto.subscription_service.ListReservationsResponse.prototype.getReservationsList = function() {
    return /** @type{!Array<!proto.subscription_service.ReservationListItem>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.subscription_service.ReservationListItem, 1);
};
/**
 * @param {!Array<!proto.subscription_service.ReservationListItem>} value
 * @return {!proto.subscription_service.ListReservationsResponse} returns this
*/ proto.subscription_service.ListReservationsResponse.prototype.setReservationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.subscription_service.ReservationListItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.subscription_service.ReservationListItem}
 */ proto.subscription_service.ListReservationsResponse.prototype.addReservations = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.subscription_service.ReservationListItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.subscription_service.ListReservationsResponse} returns this
 */ proto.subscription_service.ListReservationsResponse.prototype.clearReservationsList = function() {
    return this.setReservationsList([]);
};
/**
 * optional string page_state = 2;
 * @return {string}
 */ proto.subscription_service.ListReservationsResponse.prototype.getPageState = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.ListReservationsResponse} returns this
 */ proto.subscription_service.ListReservationsResponse.prototype.setPageState = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 total = 3;
 * @return {number}
 */ proto.subscription_service.ListReservationsResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.ListReservationsResponse} returns this
 */ proto.subscription_service.ListReservationsResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetReservationRequest}
 */ proto.subscription_service.GetReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetReservationRequest;
    return proto.subscription_service.GetReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetReservationRequest}
 */ proto.subscription_service.GetReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription_service.GetReservationRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetReservationRequest} returns this
 */ proto.subscription_service.GetReservationRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetReservationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetReservationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetReservationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservation: (f = msg.getReservation()) && $hOsJC.Reservation.toObject(includeInstance, f),
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f),
            program: (f = msg.getProgram()) && $hOsJC.Program.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetReservationResponse}
 */ proto.subscription_service.GetReservationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetReservationResponse;
    return proto.subscription_service.GetReservationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetReservationResponse}
 */ proto.subscription_service.GetReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $hOsJC.Reservation;
                reader.readMessage(value, $hOsJC.Reservation.deserializeBinaryFromReader);
                msg.setReservation(value);
                break;
            case 2:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            case 3:
                var value = new $hOsJC.Program;
                reader.readMessage(value, $hOsJC.Program.deserializeBinaryFromReader);
                msg.setProgram(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetReservationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetReservationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetReservationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservation();
    if (f != null) writer.writeMessage(1, f, $hOsJC.Reservation.serializeBinaryToWriter);
    f = message.getCustomer();
    if (f != null) writer.writeMessage(2, f, $3QqPt.Customer.serializeBinaryToWriter);
    f = message.getProgram();
    if (f != null) writer.writeMessage(3, f, $hOsJC.Program.serializeBinaryToWriter);
};
/**
 * optional subscription.Reservation reservation = 1;
 * @return {?proto.subscription.Reservation}
 */ proto.subscription_service.GetReservationResponse.prototype.getReservation = function() {
    return /** @type{?proto.subscription.Reservation} */ $8M67s.Message.getWrapperField(this, $hOsJC.Reservation, 1);
};
/**
 * @param {?proto.subscription.Reservation|undefined} value
 * @return {!proto.subscription_service.GetReservationResponse} returns this
*/ proto.subscription_service.GetReservationResponse.prototype.setReservation = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.GetReservationResponse} returns this
 */ proto.subscription_service.GetReservationResponse.prototype.clearReservation = function() {
    return this.setReservation(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.GetReservationResponse.prototype.hasReservation = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional domain.Customer customer = 2;
 * @return {?proto.domain.Customer}
 */ proto.subscription_service.GetReservationResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 2);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.subscription_service.GetReservationResponse} returns this
*/ proto.subscription_service.GetReservationResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.GetReservationResponse} returns this
 */ proto.subscription_service.GetReservationResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.GetReservationResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional subscription.Program program = 3;
 * @return {?proto.subscription.Program}
 */ proto.subscription_service.GetReservationResponse.prototype.getProgram = function() {
    return /** @type{?proto.subscription.Program} */ $8M67s.Message.getWrapperField(this, $hOsJC.Program, 3);
};
/**
 * @param {?proto.subscription.Program|undefined} value
 * @return {!proto.subscription_service.GetReservationResponse} returns this
*/ proto.subscription_service.GetReservationResponse.prototype.setProgram = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.GetReservationResponse} returns this
 */ proto.subscription_service.GetReservationResponse.prototype.clearProgram = function() {
    return this.setProgram(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.GetReservationResponse.prototype.hasProgram = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.ListProgramsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.ListProgramsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.ListProgramsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ListProgramsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.ListProgramsRequest}
 */ proto.subscription_service.ListProgramsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.ListProgramsRequest;
    return proto.subscription_service.ListProgramsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.ListProgramsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.ListProgramsRequest}
 */ proto.subscription_service.ListProgramsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.ListProgramsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.ListProgramsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.ListProgramsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ListProgramsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.subscription_service.ListProgramsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.ListProgramsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.ListProgramsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.ListProgramsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ListProgramsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            programsList: $8M67s.Message.toObjectList(msg.getProgramsList(), $hOsJC.Program.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.ListProgramsResponse}
 */ proto.subscription_service.ListProgramsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.ListProgramsResponse;
    return proto.subscription_service.ListProgramsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.ListProgramsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.ListProgramsResponse}
 */ proto.subscription_service.ListProgramsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $hOsJC.Program;
                reader.readMessage(value, $hOsJC.Program.deserializeBinaryFromReader);
                msg.addPrograms(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.ListProgramsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.ListProgramsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.ListProgramsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.ListProgramsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgramsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $hOsJC.Program.serializeBinaryToWriter);
};
/**
 * repeated subscription.Program programs = 1;
 * @return {!Array<!proto.subscription.Program>}
 */ proto.subscription_service.ListProgramsResponse.prototype.getProgramsList = function() {
    return /** @type{!Array<!proto.subscription.Program>} */ $8M67s.Message.getRepeatedWrapperField(this, $hOsJC.Program, 1);
};
/**
 * @param {!Array<!proto.subscription.Program>} value
 * @return {!proto.subscription_service.ListProgramsResponse} returns this
*/ proto.subscription_service.ListProgramsResponse.prototype.setProgramsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.subscription.Program=} opt_value
 * @param {number=} opt_index
 * @return {!proto.subscription.Program}
 */ proto.subscription_service.ListProgramsResponse.prototype.addPrograms = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.subscription.Program, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.subscription_service.ListProgramsResponse} returns this
 */ proto.subscription_service.ListProgramsResponse.prototype.clearProgramsList = function() {
    return this.setProgramsList([]);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.subscription_service.UpdateReservationRequest.oneofGroups_ = [
    [
        2,
        3
    ]
];
/**
 * @enum {number}
 */ proto.subscription_service.UpdateReservationRequest.ProgramOptionsCase = {
    PROGRAM_OPTIONS_NOT_SET: 0,
    MODEL3_OPTIONS: 2,
    MODEL_Y_OPTIONS: 3
};
/**
 * @return {proto.subscription_service.UpdateReservationRequest.ProgramOptionsCase}
 */ proto.subscription_service.UpdateReservationRequest.prototype.getProgramOptionsCase = function() {
    return /** @type {proto.subscription_service.UpdateReservationRequest.ProgramOptionsCase} */ $8M67s.Message.computeOneofCase(this, proto.subscription_service.UpdateReservationRequest.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.UpdateReservationRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.UpdateReservationRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.UpdateReservationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.UpdateReservationRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            model3Options: (f = msg.getModel3Options()) && $hOsJC.TeslaModel3Options.toObject(includeInstance, f),
            modelYOptions: (f = msg.getModelYOptions()) && $hOsJC.TeslaModelYOptions.toObject(includeInstance, f),
            status: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            programId: $8M67s.Message.getFieldWithDefault(msg, 12, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.UpdateReservationRequest}
 */ proto.subscription_service.UpdateReservationRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.UpdateReservationRequest;
    return proto.subscription_service.UpdateReservationRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.UpdateReservationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.UpdateReservationRequest}
 */ proto.subscription_service.UpdateReservationRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 2:
                var value = new $hOsJC.TeslaModel3Options;
                reader.readMessage(value, $hOsJC.TeslaModel3Options.deserializeBinaryFromReader);
                msg.setModel3Options(value);
                break;
            case 3:
                var value = new $hOsJC.TeslaModelYOptions;
                reader.readMessage(value, $hOsJC.TeslaModelYOptions.deserializeBinaryFromReader);
                msg.setModelYOptions(value);
                break;
            case 11:
                var value = /** @type {!proto.subscription.ReservationStatus} */ reader.readEnum();
                msg.setStatus(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.UpdateReservationRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.UpdateReservationRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.UpdateReservationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.UpdateReservationRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getModel3Options();
    if (f != null) writer.writeMessage(2, f, $hOsJC.TeslaModel3Options.serializeBinaryToWriter);
    f = message.getModelYOptions();
    if (f != null) writer.writeMessage(3, f, $hOsJC.TeslaModelYOptions.serializeBinaryToWriter);
    f = message.getStatus();
    if (f !== 0.0) writer.writeEnum(11, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(12, f);
};
/**
 * optional string reservation_id = 1;
 * @return {string}
 */ proto.subscription_service.UpdateReservationRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.UpdateReservationRequest} returns this
 */ proto.subscription_service.UpdateReservationRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional subscription.TeslaModel3Options model3_options = 2;
 * @return {?proto.subscription.TeslaModel3Options}
 */ proto.subscription_service.UpdateReservationRequest.prototype.getModel3Options = function() {
    return /** @type{?proto.subscription.TeslaModel3Options} */ $8M67s.Message.getWrapperField(this, $hOsJC.TeslaModel3Options, 2);
};
/**
 * @param {?proto.subscription.TeslaModel3Options|undefined} value
 * @return {!proto.subscription_service.UpdateReservationRequest} returns this
*/ proto.subscription_service.UpdateReservationRequest.prototype.setModel3Options = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 2, proto.subscription_service.UpdateReservationRequest.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.UpdateReservationRequest} returns this
 */ proto.subscription_service.UpdateReservationRequest.prototype.clearModel3Options = function() {
    return this.setModel3Options(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.UpdateReservationRequest.prototype.hasModel3Options = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional subscription.TeslaModelYOptions model_y_options = 3;
 * @return {?proto.subscription.TeslaModelYOptions}
 */ proto.subscription_service.UpdateReservationRequest.prototype.getModelYOptions = function() {
    return /** @type{?proto.subscription.TeslaModelYOptions} */ $8M67s.Message.getWrapperField(this, $hOsJC.TeslaModelYOptions, 3);
};
/**
 * @param {?proto.subscription.TeslaModelYOptions|undefined} value
 * @return {!proto.subscription_service.UpdateReservationRequest} returns this
*/ proto.subscription_service.UpdateReservationRequest.prototype.setModelYOptions = function(value) {
    return $8M67s.Message.setOneofWrapperField(this, 3, proto.subscription_service.UpdateReservationRequest.oneofGroups_[0], value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.UpdateReservationRequest} returns this
 */ proto.subscription_service.UpdateReservationRequest.prototype.clearModelYOptions = function() {
    return this.setModelYOptions(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.UpdateReservationRequest.prototype.hasModelYOptions = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional subscription.ReservationStatus status = 11;
 * @return {!proto.subscription.ReservationStatus}
 */ proto.subscription_service.UpdateReservationRequest.prototype.getStatus = function() {
    return /** @type {!proto.subscription.ReservationStatus} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {!proto.subscription.ReservationStatus} value
 * @return {!proto.subscription_service.UpdateReservationRequest} returns this
 */ proto.subscription_service.UpdateReservationRequest.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 11, value);
};
/**
 * optional string program_id = 12;
 * @return {string}
 */ proto.subscription_service.UpdateReservationRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.UpdateReservationRequest} returns this
 */ proto.subscription_service.UpdateReservationRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.UpdateReservationResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.UpdateReservationResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.UpdateReservationResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.UpdateReservationResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.UpdateReservationResponse}
 */ proto.subscription_service.UpdateReservationResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.UpdateReservationResponse;
    return proto.subscription_service.UpdateReservationResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.UpdateReservationResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.UpdateReservationResponse}
 */ proto.subscription_service.UpdateReservationResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.UpdateReservationResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.UpdateReservationResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.UpdateReservationResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.UpdateReservationResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.FindCustomerByPhoneRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.FindCustomerByPhoneRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.FindCustomerByPhoneRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.FindCustomerByPhoneRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phone: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.FindCustomerByPhoneRequest}
 */ proto.subscription_service.FindCustomerByPhoneRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.FindCustomerByPhoneRequest;
    return proto.subscription_service.FindCustomerByPhoneRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.FindCustomerByPhoneRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.FindCustomerByPhoneRequest}
 */ proto.subscription_service.FindCustomerByPhoneRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.FindCustomerByPhoneRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.FindCustomerByPhoneRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.FindCustomerByPhoneRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.FindCustomerByPhoneRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhone();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string phone = 1;
 * @return {string}
 */ proto.subscription_service.FindCustomerByPhoneRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.FindCustomerByPhoneRequest} returns this
 */ proto.subscription_service.FindCustomerByPhoneRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.FindCustomerByPhoneResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.FindCustomerByPhoneResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.FindCustomerByPhoneResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.FindCustomerByPhoneResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customer: (f = msg.getCustomer()) && $3QqPt.Customer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.FindCustomerByPhoneResponse}
 */ proto.subscription_service.FindCustomerByPhoneResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.FindCustomerByPhoneResponse;
    return proto.subscription_service.FindCustomerByPhoneResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.FindCustomerByPhoneResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.FindCustomerByPhoneResponse}
 */ proto.subscription_service.FindCustomerByPhoneResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Customer;
                reader.readMessage(value, $3QqPt.Customer.deserializeBinaryFromReader);
                msg.setCustomer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.FindCustomerByPhoneResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.FindCustomerByPhoneResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.FindCustomerByPhoneResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.FindCustomerByPhoneResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomer();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Customer.serializeBinaryToWriter);
};
/**
 * optional domain.Customer customer = 1;
 * @return {?proto.domain.Customer}
 */ proto.subscription_service.FindCustomerByPhoneResponse.prototype.getCustomer = function() {
    return /** @type{?proto.domain.Customer} */ $8M67s.Message.getWrapperField(this, $3QqPt.Customer, 1);
};
/**
 * @param {?proto.domain.Customer|undefined} value
 * @return {!proto.subscription_service.FindCustomerByPhoneResponse} returns this
*/ proto.subscription_service.FindCustomerByPhoneResponse.prototype.setCustomer = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.FindCustomerByPhoneResponse} returns this
 */ proto.subscription_service.FindCustomerByPhoneResponse.prototype.clearCustomer = function() {
    return this.setCustomer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.FindCustomerByPhoneResponse.prototype.hasCustomer = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.SetReservationProgramRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.SetReservationProgramRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.SetReservationProgramRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.SetReservationProgramRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            programId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            monthly: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.SetReservationProgramRequest}
 */ proto.subscription_service.SetReservationProgramRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.SetReservationProgramRequest;
    return proto.subscription_service.SetReservationProgramRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.SetReservationProgramRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.SetReservationProgramRequest}
 */ proto.subscription_service.SetReservationProgramRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthly(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartFee(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPriceTermMonths(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.SetReservationProgramRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.SetReservationProgramRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.SetReservationProgramRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.SetReservationProgramRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getMonthly();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getStartFee();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getPriceTermMonths();
    if (f !== 0) writer.writeInt32(6, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription_service.SetReservationProgramRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.SetReservationProgramRequest} returns this
 */ proto.subscription_service.SetReservationProgramRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string reservation_id = 2;
 * @return {string}
 */ proto.subscription_service.SetReservationProgramRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.SetReservationProgramRequest} returns this
 */ proto.subscription_service.SetReservationProgramRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string program_id = 3;
 * @return {string}
 */ proto.subscription_service.SetReservationProgramRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.SetReservationProgramRequest} returns this
 */ proto.subscription_service.SetReservationProgramRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int32 monthly = 4;
 * @return {number}
 */ proto.subscription_service.SetReservationProgramRequest.prototype.getMonthly = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.SetReservationProgramRequest} returns this
 */ proto.subscription_service.SetReservationProgramRequest.prototype.setMonthly = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 start_fee = 5;
 * @return {number}
 */ proto.subscription_service.SetReservationProgramRequest.prototype.getStartFee = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.SetReservationProgramRequest} returns this
 */ proto.subscription_service.SetReservationProgramRequest.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 price_term_months = 6;
 * @return {number}
 */ proto.subscription_service.SetReservationProgramRequest.prototype.getPriceTermMonths = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.SetReservationProgramRequest} returns this
 */ proto.subscription_service.SetReservationProgramRequest.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.SetReservationProgramResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.SetReservationProgramResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.SetReservationProgramResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.SetReservationProgramResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.SetReservationProgramResponse}
 */ proto.subscription_service.SetReservationProgramResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.SetReservationProgramResponse;
    return proto.subscription_service.SetReservationProgramResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.SetReservationProgramResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.SetReservationProgramResponse}
 */ proto.subscription_service.SetReservationProgramResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.SetReservationProgramResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.SetReservationProgramResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.SetReservationProgramResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.SetReservationProgramResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.subscription_service.DatedPricingOption.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.DatedPricingOption.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.DatedPricingOption.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.DatedPricingOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.DatedPricingOption.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            pricingOptionsList: $8M67s.Message.toObjectList(msg.getPricingOptionsList(), $hOsJC.PricingOption.toObject, includeInstance),
            fromDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            toDate: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.DatedPricingOption}
 */ proto.subscription_service.DatedPricingOption.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.DatedPricingOption;
    return proto.subscription_service.DatedPricingOption.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.DatedPricingOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.DatedPricingOption}
 */ proto.subscription_service.DatedPricingOption.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 1:
                var value = new $hOsJC.PricingOption;
                reader.readMessage(value, $hOsJC.PricingOption.deserializeBinaryFromReader);
                msg.addPricingOptions(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setFromDate(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setToDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.DatedPricingOption.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.DatedPricingOption.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.DatedPricingOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.DatedPricingOption.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getPricingOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $hOsJC.PricingOption.serializeBinaryToWriter);
    f = message.getFromDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getToDate();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string id = 4;
 * @return {string}
 */ proto.subscription_service.DatedPricingOption.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.DatedPricingOption} returns this
 */ proto.subscription_service.DatedPricingOption.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * repeated subscription.PricingOption pricing_options = 1;
 * @return {!Array<!proto.subscription.PricingOption>}
 */ proto.subscription_service.DatedPricingOption.prototype.getPricingOptionsList = function() {
    return /** @type{!Array<!proto.subscription.PricingOption>} */ $8M67s.Message.getRepeatedWrapperField(this, $hOsJC.PricingOption, 1);
};
/**
 * @param {!Array<!proto.subscription.PricingOption>} value
 * @return {!proto.subscription_service.DatedPricingOption} returns this
*/ proto.subscription_service.DatedPricingOption.prototype.setPricingOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.subscription.PricingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.subscription.PricingOption}
 */ proto.subscription_service.DatedPricingOption.prototype.addPricingOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.subscription.PricingOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.subscription_service.DatedPricingOption} returns this
 */ proto.subscription_service.DatedPricingOption.prototype.clearPricingOptionsList = function() {
    return this.setPricingOptionsList([]);
};
/**
 * optional int64 from_date = 2;
 * @return {number}
 */ proto.subscription_service.DatedPricingOption.prototype.getFromDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.DatedPricingOption} returns this
 */ proto.subscription_service.DatedPricingOption.prototype.setFromDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int64 to_date = 3;
 * @return {number}
 */ proto.subscription_service.DatedPricingOption.prototype.getToDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.subscription_service.DatedPricingOption} returns this
 */ proto.subscription_service.DatedPricingOption.prototype.setToDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetProgramRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetProgramRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetProgramRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetProgramRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetProgramRequest}
 */ proto.subscription_service.GetProgramRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetProgramRequest;
    return proto.subscription_service.GetProgramRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetProgramRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetProgramRequest}
 */ proto.subscription_service.GetProgramRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetProgramRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetProgramRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetProgramRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetProgramRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.subscription_service.GetProgramRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetProgramRequest} returns this
 */ proto.subscription_service.GetProgramRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetProgramResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetProgramResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetProgramResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetProgramResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            program: (f = msg.getProgram()) && $hOsJC.Program.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetProgramResponse}
 */ proto.subscription_service.GetProgramResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetProgramResponse;
    return proto.subscription_service.GetProgramResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetProgramResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetProgramResponse}
 */ proto.subscription_service.GetProgramResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $hOsJC.Program;
                reader.readMessage(value, $hOsJC.Program.deserializeBinaryFromReader);
                msg.setProgram(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetProgramResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetProgramResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetProgramResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetProgramResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgram();
    if (f != null) writer.writeMessage(1, f, $hOsJC.Program.serializeBinaryToWriter);
};
/**
 * optional subscription.Program program = 1;
 * @return {?proto.subscription.Program}
 */ proto.subscription_service.GetProgramResponse.prototype.getProgram = function() {
    return /** @type{?proto.subscription.Program} */ $8M67s.Message.getWrapperField(this, $hOsJC.Program, 1);
};
/**
 * @param {?proto.subscription.Program|undefined} value
 * @return {!proto.subscription_service.GetProgramResponse} returns this
*/ proto.subscription_service.GetProgramResponse.prototype.setProgram = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.GetProgramResponse} returns this
 */ proto.subscription_service.GetProgramResponse.prototype.clearProgram = function() {
    return this.setProgram(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.GetProgramResponse.prototype.hasProgram = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetSubscriptionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetSubscriptionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetSubscriptionRequest}
 */ proto.subscription_service.GetSubscriptionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetSubscriptionRequest;
    return proto.subscription_service.GetSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetSubscriptionRequest}
 */ proto.subscription_service.GetSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetSubscriptionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription_service.GetSubscriptionRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetSubscriptionRequest} returns this
 */ proto.subscription_service.GetSubscriptionRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.subscription_service.GetSubscriptionRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetSubscriptionRequest} returns this
 */ proto.subscription_service.GetSubscriptionRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetSubscriptionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetSubscriptionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetSubscriptionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetSubscriptionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscription: (f = msg.getSubscription()) && $3QqPt.Subscription.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetSubscriptionResponse}
 */ proto.subscription_service.GetSubscriptionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetSubscriptionResponse;
    return proto.subscription_service.GetSubscriptionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetSubscriptionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetSubscriptionResponse}
 */ proto.subscription_service.GetSubscriptionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Subscription;
                reader.readMessage(value, $3QqPt.Subscription.deserializeBinaryFromReader);
                msg.setSubscription(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetSubscriptionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetSubscriptionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetSubscriptionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetSubscriptionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscription();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Subscription.serializeBinaryToWriter);
};
/**
 * optional domain.Subscription subscription = 1;
 * @return {?proto.domain.Subscription}
 */ proto.subscription_service.GetSubscriptionResponse.prototype.getSubscription = function() {
    return /** @type{?proto.domain.Subscription} */ $8M67s.Message.getWrapperField(this, $3QqPt.Subscription, 1);
};
/**
 * @param {?proto.domain.Subscription|undefined} value
 * @return {!proto.subscription_service.GetSubscriptionResponse} returns this
*/ proto.subscription_service.GetSubscriptionResponse.prototype.setSubscription = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.subscription_service.GetSubscriptionResponse} returns this
 */ proto.subscription_service.GetSubscriptionResponse.prototype.clearSubscription = function() {
    return this.setSubscription(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.subscription_service.GetSubscriptionResponse.prototype.hasSubscription = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.GetActiveOrLatestSubscriptionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest}
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.GetActiveOrLatestSubscriptionRequest;
    return proto.subscription_service.GetActiveOrLatestSubscriptionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest}
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.GetActiveOrLatestSubscriptionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest} returns this
 */ proto.subscription_service.GetActiveOrLatestSubscriptionRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.AddVehicleAssignmentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.AddVehicleAssignmentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.AddVehicleAssignmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.AddVehicleAssignmentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.AddVehicleAssignmentRequest}
 */ proto.subscription_service.AddVehicleAssignmentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.AddVehicleAssignmentRequest;
    return proto.subscription_service.AddVehicleAssignmentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.AddVehicleAssignmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.AddVehicleAssignmentRequest}
 */ proto.subscription_service.AddVehicleAssignmentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.AddVehicleAssignmentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.AddVehicleAssignmentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.AddVehicleAssignmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.AddVehicleAssignmentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.subscription_service.AddVehicleAssignmentRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.AddVehicleAssignmentRequest} returns this
 */ proto.subscription_service.AddVehicleAssignmentRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.subscription_service.AddVehicleAssignmentRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.AddVehicleAssignmentRequest} returns this
 */ proto.subscription_service.AddVehicleAssignmentRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.AddVehicleAssignmentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.AddVehicleAssignmentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.AddVehicleAssignmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.AddVehicleAssignmentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.AddVehicleAssignmentResponse}
 */ proto.subscription_service.AddVehicleAssignmentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.AddVehicleAssignmentResponse;
    return proto.subscription_service.AddVehicleAssignmentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.AddVehicleAssignmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.AddVehicleAssignmentResponse}
 */ proto.subscription_service.AddVehicleAssignmentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.AddVehicleAssignmentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.AddVehicleAssignmentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.AddVehicleAssignmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.AddVehicleAssignmentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.RemoveVehicleAssignmentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.RemoveVehicleAssignmentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.RemoveVehicleAssignmentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.RemoveVehicleAssignmentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.RemoveVehicleAssignmentRequest}
 */ proto.subscription_service.RemoveVehicleAssignmentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.RemoveVehicleAssignmentRequest;
    return proto.subscription_service.RemoveVehicleAssignmentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.RemoveVehicleAssignmentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.RemoveVehicleAssignmentRequest}
 */ proto.subscription_service.RemoveVehicleAssignmentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.RemoveVehicleAssignmentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.RemoveVehicleAssignmentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.RemoveVehicleAssignmentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.RemoveVehicleAssignmentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.subscription_service.RemoveVehicleAssignmentRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.subscription_service.RemoveVehicleAssignmentRequest} returns this
 */ proto.subscription_service.RemoveVehicleAssignmentRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.subscription_service.RemoveVehicleAssignmentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.subscription_service.RemoveVehicleAssignmentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.subscription_service.RemoveVehicleAssignmentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.RemoveVehicleAssignmentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.subscription_service.RemoveVehicleAssignmentResponse}
 */ proto.subscription_service.RemoveVehicleAssignmentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.subscription_service.RemoveVehicleAssignmentResponse;
    return proto.subscription_service.RemoveVehicleAssignmentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.subscription_service.RemoveVehicleAssignmentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.subscription_service.RemoveVehicleAssignmentResponse}
 */ proto.subscription_service.RemoveVehicleAssignmentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.subscription_service.RemoveVehicleAssignmentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.subscription_service.RemoveVehicleAssignmentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.subscription_service.RemoveVehicleAssignmentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.subscription_service.RemoveVehicleAssignmentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
$70f39930bf7ec61a$var$goog.object.extend(module.exports, proto.subscription_service);

});

parcelRegister("aqwEO", function(module, exports) {
// source: telematics_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $7975aa205a78f630$var$goog = $8M67s;
var $7975aa205a78f630$var$global = Function('return this')();

var $9YICB = parcelRequire("9YICB");
$7975aa205a78f630$var$goog.object.extend(proto, $9YICB);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.ClusterState', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.CollisionEvent', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.CollisionReceived', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.CommandVehicleRequest', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.CommandVehicleResponse', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.DailyDrivingBehavior', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.DrivingBehavior', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.EventRating', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.GetTelematicsRequest', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.GetTelematicsResponse', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.Instance', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.Location', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.Param', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.RoutePosition', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.StreamTelematicsRequest', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.Telematics', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.Telematics.ConnectionState', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.TripEvent', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.TripReceived', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.VehicleCommand', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.VehicleCommand.CommandCase', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.VehicleScore', null, $7975aa205a78f630$var$global);
$7975aa205a78f630$var$goog.exportSymbol('proto.telematics_service.VehicleScore.Vehicles', null, $7975aa205a78f630$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.GetTelematicsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telematics_service.GetTelematicsRequest.repeatedFields_, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.GetTelematicsRequest, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.GetTelematicsRequest.displayName = 'proto.telematics_service.GetTelematicsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.Param = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.Param, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.Param.displayName = 'proto.telematics_service.Param';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.GetTelematicsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telematics_service.GetTelematicsResponse.repeatedFields_, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.GetTelematicsResponse, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.GetTelematicsResponse.displayName = 'proto.telematics_service.GetTelematicsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.StreamTelematicsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telematics_service.StreamTelematicsRequest.repeatedFields_, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.StreamTelematicsRequest, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.StreamTelematicsRequest.displayName = 'proto.telematics_service.StreamTelematicsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.CommandVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telematics_service.CommandVehicleRequest.repeatedFields_, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.CommandVehicleRequest, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.CommandVehicleRequest.displayName = 'proto.telematics_service.CommandVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.VehicleCommand = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, proto.telematics_service.VehicleCommand.oneofGroups_);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.VehicleCommand, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.VehicleCommand.displayName = 'proto.telematics_service.VehicleCommand';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.CommandVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.CommandVehicleResponse, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.CommandVehicleResponse.displayName = 'proto.telematics_service.CommandVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.TripReceived = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telematics_service.TripReceived.repeatedFields_, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.TripReceived, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.TripReceived.displayName = 'proto.telematics_service.TripReceived';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.CollisionReceived = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telematics_service.CollisionReceived.repeatedFields_, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.CollisionReceived, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.CollisionReceived.displayName = 'proto.telematics_service.CollisionReceived';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.CollisionEvent = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.CollisionEvent, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.CollisionEvent.displayName = 'proto.telematics_service.CollisionEvent';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.Telematics = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.Telematics, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.Telematics.displayName = 'proto.telematics_service.Telematics';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.ClusterState = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.telematics_service.ClusterState.repeatedFields_, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.ClusterState, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.ClusterState.displayName = 'proto.telematics_service.ClusterState';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.Instance = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.Instance, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.Instance.displayName = 'proto.telematics_service.Instance';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.RoutePosition = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.RoutePosition, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.RoutePosition.displayName = 'proto.telematics_service.RoutePosition';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.Location = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.Location, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.Location.displayName = 'proto.telematics_service.Location';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.TripEvent = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.TripEvent, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.TripEvent.displayName = 'proto.telematics_service.TripEvent';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.DailyDrivingBehavior = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.DailyDrivingBehavior, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.DailyDrivingBehavior.displayName = 'proto.telematics_service.DailyDrivingBehavior';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.DrivingBehavior = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.DrivingBehavior, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.DrivingBehavior.displayName = 'proto.telematics_service.DrivingBehavior';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.VehicleScore = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.VehicleScore, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.VehicleScore.displayName = 'proto.telematics_service.VehicleScore';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.VehicleScore.Vehicles = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.VehicleScore.Vehicles, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.VehicleScore.Vehicles.displayName = 'proto.telematics_service.VehicleScore.Vehicles';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.telematics_service.EventRating = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$7975aa205a78f630$var$goog.inherits(proto.telematics_service.EventRating, $8M67s.Message);
if ($7975aa205a78f630$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.telematics_service.EventRating.displayName = 'proto.telematics_service.EventRating';
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telematics_service.GetTelematicsRequest.repeatedFields_ = [
    1,
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.GetTelematicsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.GetTelematicsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.GetTelematicsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.GetTelematicsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleIdsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            paramsList: $8M67s.Message.toObjectList(msg.getParamsList(), proto.telematics_service.Param.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.GetTelematicsRequest}
 */ proto.telematics_service.GetTelematicsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.GetTelematicsRequest;
    return proto.telematics_service.GetTelematicsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.GetTelematicsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.GetTelematicsRequest}
 */ proto.telematics_service.GetTelematicsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addVehicleIds(value);
                break;
            case 2:
                var value = new proto.telematics_service.Param;
                reader.readMessage(value, proto.telematics_service.Param.deserializeBinaryFromReader);
                msg.addParams(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.GetTelematicsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.GetTelematicsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.GetTelematicsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.GetTelematicsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleIdsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
    f = message.getParamsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.telematics_service.Param.serializeBinaryToWriter);
};
/**
 * repeated string vehicle_ids = 1;
 * @return {!Array<string>}
 */ proto.telematics_service.GetTelematicsRequest.prototype.getVehicleIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.telematics_service.GetTelematicsRequest} returns this
 */ proto.telematics_service.GetTelematicsRequest.prototype.setVehicleIdsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.telematics_service.GetTelematicsRequest} returns this
 */ proto.telematics_service.GetTelematicsRequest.prototype.addVehicleIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telematics_service.GetTelematicsRequest} returns this
 */ proto.telematics_service.GetTelematicsRequest.prototype.clearVehicleIdsList = function() {
    return this.setVehicleIdsList([]);
};
/**
 * repeated Param params = 2;
 * @return {!Array<!proto.telematics_service.Param>}
 */ proto.telematics_service.GetTelematicsRequest.prototype.getParamsList = function() {
    return /** @type{!Array<!proto.telematics_service.Param>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.telematics_service.Param, 2);
};
/**
 * @param {!Array<!proto.telematics_service.Param>} value
 * @return {!proto.telematics_service.GetTelematicsRequest} returns this
*/ proto.telematics_service.GetTelematicsRequest.prototype.setParamsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.telematics_service.Param=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telematics_service.Param}
 */ proto.telematics_service.GetTelematicsRequest.prototype.addParams = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.telematics_service.Param, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telematics_service.GetTelematicsRequest} returns this
 */ proto.telematics_service.GetTelematicsRequest.prototype.clearParamsList = function() {
    return this.setParamsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.Param.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.Param.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.Param} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.Param.toObject = function(includeInstance, msg) {
        var f, obj = {
            key: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            value: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.Param}
 */ proto.telematics_service.Param.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.Param;
    return proto.telematics_service.Param.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.Param} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.Param}
 */ proto.telematics_service.Param.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setKey(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setValue(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.Param.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.Param.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.Param} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.Param.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getKey();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getValue();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string key = 1;
 * @return {string}
 */ proto.telematics_service.Param.prototype.getKey = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Param} returns this
 */ proto.telematics_service.Param.prototype.setKey = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string value = 2;
 * @return {string}
 */ proto.telematics_service.Param.prototype.getValue = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Param} returns this
 */ proto.telematics_service.Param.prototype.setValue = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telematics_service.GetTelematicsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.GetTelematicsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.GetTelematicsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.GetTelematicsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.GetTelematicsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            telematicsList: $8M67s.Message.toObjectList(msg.getTelematicsList(), proto.telematics_service.Telematics.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.GetTelematicsResponse}
 */ proto.telematics_service.GetTelematicsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.GetTelematicsResponse;
    return proto.telematics_service.GetTelematicsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.GetTelematicsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.GetTelematicsResponse}
 */ proto.telematics_service.GetTelematicsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.telematics_service.Telematics;
                reader.readMessage(value, proto.telematics_service.Telematics.deserializeBinaryFromReader);
                msg.addTelematics(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.GetTelematicsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.GetTelematicsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.GetTelematicsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.GetTelematicsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTelematicsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.telematics_service.Telematics.serializeBinaryToWriter);
};
/**
 * repeated Telematics telematics = 1;
 * @return {!Array<!proto.telematics_service.Telematics>}
 */ proto.telematics_service.GetTelematicsResponse.prototype.getTelematicsList = function() {
    return /** @type{!Array<!proto.telematics_service.Telematics>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.telematics_service.Telematics, 1);
};
/**
 * @param {!Array<!proto.telematics_service.Telematics>} value
 * @return {!proto.telematics_service.GetTelematicsResponse} returns this
*/ proto.telematics_service.GetTelematicsResponse.prototype.setTelematicsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.telematics_service.Telematics=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telematics_service.Telematics}
 */ proto.telematics_service.GetTelematicsResponse.prototype.addTelematics = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.telematics_service.Telematics, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telematics_service.GetTelematicsResponse} returns this
 */ proto.telematics_service.GetTelematicsResponse.prototype.clearTelematicsList = function() {
    return this.setTelematicsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telematics_service.StreamTelematicsRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.StreamTelematicsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.StreamTelematicsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.StreamTelematicsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.StreamTelematicsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleIdsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.StreamTelematicsRequest}
 */ proto.telematics_service.StreamTelematicsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.StreamTelematicsRequest;
    return proto.telematics_service.StreamTelematicsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.StreamTelematicsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.StreamTelematicsRequest}
 */ proto.telematics_service.StreamTelematicsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addVehicleIds(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.StreamTelematicsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.StreamTelematicsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.StreamTelematicsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.StreamTelematicsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleIdsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string vehicle_ids = 1;
 * @return {!Array<string>}
 */ proto.telematics_service.StreamTelematicsRequest.prototype.getVehicleIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.telematics_service.StreamTelematicsRequest} returns this
 */ proto.telematics_service.StreamTelematicsRequest.prototype.setVehicleIdsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.telematics_service.StreamTelematicsRequest} returns this
 */ proto.telematics_service.StreamTelematicsRequest.prototype.addVehicleIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telematics_service.StreamTelematicsRequest} returns this
 */ proto.telematics_service.StreamTelematicsRequest.prototype.clearVehicleIdsList = function() {
    return this.setVehicleIdsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telematics_service.CommandVehicleRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.CommandVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.CommandVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.CommandVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.CommandVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            commandsList: $8M67s.Message.toObjectList(msg.getCommandsList(), proto.telematics_service.VehicleCommand.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.CommandVehicleRequest}
 */ proto.telematics_service.CommandVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.CommandVehicleRequest;
    return proto.telematics_service.CommandVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.CommandVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.CommandVehicleRequest}
 */ proto.telematics_service.CommandVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 2:
                var value = new proto.telematics_service.VehicleCommand;
                reader.readMessage(value, proto.telematics_service.VehicleCommand.deserializeBinaryFromReader);
                msg.addCommands(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.CommandVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.CommandVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.CommandVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.CommandVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCommandsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.telematics_service.VehicleCommand.serializeBinaryToWriter);
};
/**
 * optional string vehicle_id = 1;
 * @return {string}
 */ proto.telematics_service.CommandVehicleRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CommandVehicleRequest} returns this
 */ proto.telematics_service.CommandVehicleRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated VehicleCommand commands = 2;
 * @return {!Array<!proto.telematics_service.VehicleCommand>}
 */ proto.telematics_service.CommandVehicleRequest.prototype.getCommandsList = function() {
    return /** @type{!Array<!proto.telematics_service.VehicleCommand>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.telematics_service.VehicleCommand, 2);
};
/**
 * @param {!Array<!proto.telematics_service.VehicleCommand>} value
 * @return {!proto.telematics_service.CommandVehicleRequest} returns this
*/ proto.telematics_service.CommandVehicleRequest.prototype.setCommandsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.telematics_service.VehicleCommand=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telematics_service.VehicleCommand}
 */ proto.telematics_service.CommandVehicleRequest.prototype.addCommands = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.telematics_service.VehicleCommand, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telematics_service.CommandVehicleRequest} returns this
 */ proto.telematics_service.CommandVehicleRequest.prototype.clearCommandsList = function() {
    return this.setCommandsList([]);
};
/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */ proto.telematics_service.VehicleCommand.oneofGroups_ = [
    [
        2,
        3,
        4,
        5,
        6
    ]
];
/**
 * @enum {number}
 */ proto.telematics_service.VehicleCommand.CommandCase = {
    COMMAND_NOT_SET: 0,
    HEAD_LIGHTS_ON: 2,
    HEAD_LIGHTS_OFF: 3,
    HONK_HORN: 4,
    UNLOCK_DOORS: 5,
    LOCK_DOORS: 6
};
/**
 * @return {proto.telematics_service.VehicleCommand.CommandCase}
 */ proto.telematics_service.VehicleCommand.prototype.getCommandCase = function() {
    return /** @type {proto.telematics_service.VehicleCommand.CommandCase} */ $8M67s.Message.computeOneofCase(this, proto.telematics_service.VehicleCommand.oneofGroups_[0]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.VehicleCommand.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.VehicleCommand.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.VehicleCommand} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.VehicleCommand.toObject = function(includeInstance, msg) {
        var f, obj = {
            headLightsOn: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false),
            headLightsOff: $8M67s.Message.getBooleanFieldWithDefault(msg, 3, false),
            honkHorn: $8M67s.Message.getBooleanFieldWithDefault(msg, 4, false),
            unlockDoors: $8M67s.Message.getBooleanFieldWithDefault(msg, 5, false),
            lockDoors: $8M67s.Message.getBooleanFieldWithDefault(msg, 6, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.VehicleCommand}
 */ proto.telematics_service.VehicleCommand.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.VehicleCommand;
    return proto.telematics_service.VehicleCommand.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.VehicleCommand} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.VehicleCommand}
 */ proto.telematics_service.VehicleCommand.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setHeadLightsOn(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setHeadLightsOff(value);
                break;
            case 4:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setHonkHorn(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setUnlockDoors(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setLockDoors(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.VehicleCommand.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.VehicleCommand.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.VehicleCommand} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.VehicleCommand.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = /** @type {boolean} */ $8M67s.Message.getField(message, 2);
    if (f != null) writer.writeBool(2, f);
    f = /** @type {boolean} */ $8M67s.Message.getField(message, 3);
    if (f != null) writer.writeBool(3, f);
    f = /** @type {boolean} */ $8M67s.Message.getField(message, 4);
    if (f != null) writer.writeBool(4, f);
    f = /** @type {boolean} */ $8M67s.Message.getField(message, 5);
    if (f != null) writer.writeBool(5, f);
    f = /** @type {boolean} */ $8M67s.Message.getField(message, 6);
    if (f != null) writer.writeBool(6, f);
};
/**
 * optional bool head_lights_on = 2;
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.getHeadLightsOn = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.setHeadLightsOn = function(value) {
    return $8M67s.Message.setOneofField(this, 2, proto.telematics_service.VehicleCommand.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.clearHeadLightsOn = function() {
    return $8M67s.Message.setOneofField(this, 2, proto.telematics_service.VehicleCommand.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.hasHeadLightsOn = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional bool head_lights_off = 3;
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.getHeadLightsOff = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.setHeadLightsOff = function(value) {
    return $8M67s.Message.setOneofField(this, 3, proto.telematics_service.VehicleCommand.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.clearHeadLightsOff = function() {
    return $8M67s.Message.setOneofField(this, 3, proto.telematics_service.VehicleCommand.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.hasHeadLightsOff = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional bool honk_horn = 4;
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.getHonkHorn = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 4, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.setHonkHorn = function(value) {
    return $8M67s.Message.setOneofField(this, 4, proto.telematics_service.VehicleCommand.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.clearHonkHorn = function() {
    return $8M67s.Message.setOneofField(this, 4, proto.telematics_service.VehicleCommand.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.hasHonkHorn = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional bool unlock_doors = 5;
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.getUnlockDoors = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.setUnlockDoors = function(value) {
    return $8M67s.Message.setOneofField(this, 5, proto.telematics_service.VehicleCommand.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.clearUnlockDoors = function() {
    return $8M67s.Message.setOneofField(this, 5, proto.telematics_service.VehicleCommand.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.hasUnlockDoors = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * optional bool lock_doors = 6;
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.getLockDoors = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.setLockDoors = function(value) {
    return $8M67s.Message.setOneofField(this, 6, proto.telematics_service.VehicleCommand.oneofGroups_[0], value);
};
/**
 * Clears the field making it undefined.
 * @return {!proto.telematics_service.VehicleCommand} returns this
 */ proto.telematics_service.VehicleCommand.prototype.clearLockDoors = function() {
    return $8M67s.Message.setOneofField(this, 6, proto.telematics_service.VehicleCommand.oneofGroups_[0], undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.VehicleCommand.prototype.hasLockDoors = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.CommandVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.CommandVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.CommandVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.CommandVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            msg: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.CommandVehicleResponse}
 */ proto.telematics_service.CommandVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.CommandVehicleResponse;
    return proto.telematics_service.CommandVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.CommandVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.CommandVehicleResponse}
 */ proto.telematics_service.CommandVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMsg(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.CommandVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.CommandVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.CommandVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.CommandVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMsg();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string msg = 1;
 * @return {string}
 */ proto.telematics_service.CommandVehicleResponse.prototype.getMsg = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CommandVehicleResponse} returns this
 */ proto.telematics_service.CommandVehicleResponse.prototype.setMsg = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telematics_service.TripReceived.repeatedFields_ = [
    21
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.TripReceived.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.TripReceived.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.TripReceived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.TripReceived.toObject = function(includeInstance, msg) {
        var f, obj = {
            driverid: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleid: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            tripid: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            starttime: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            endtime: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            tripmaxspeed: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
            tripduration: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
            distance: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
            sessionid: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            trackingid: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            insuranceperiod: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            usermode: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            drivetype: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            vehicletype: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            hardbrakerating: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            hardturnrating: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            rapidaccelerationrating: $8M67s.Message.getFieldWithDefault(msg, 17, 0),
            phoneuserating: $8M67s.Message.getFieldWithDefault(msg, 18, 0),
            overspeedingrating: $8M67s.Message.getFieldWithDefault(msg, 19, 0),
            drivingscore: $8M67s.Message.getFieldWithDefault(msg, 20, 0),
            tripeventsList: $8M67s.Message.toObjectList(msg.getTripeventsList(), proto.telematics_service.TripEvent.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.TripReceived}
 */ proto.telematics_service.TripReceived.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.TripReceived;
    return proto.telematics_service.TripReceived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.TripReceived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.TripReceived}
 */ proto.telematics_service.TripReceived.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDriverid(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleid(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setTripid(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setStarttime(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setEndtime(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTripmaxspeed(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTripduration(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readFloat();
                msg.setDistance(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setSessionid(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingid(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt64();
                msg.setInsuranceperiod(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setUsermode(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setDrivetype(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicletype(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt32();
                msg.setHardbrakerating(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setHardturnrating(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRapidaccelerationrating(value);
                break;
            case 18:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPhoneuserating(value);
                break;
            case 19:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOverspeedingrating(value);
                break;
            case 20:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDrivingscore(value);
                break;
            case 21:
                var value = new proto.telematics_service.TripEvent;
                reader.readMessage(value, proto.telematics_service.TripEvent.deserializeBinaryFromReader);
                msg.addTripevents(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.TripReceived.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.TripReceived.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.TripReceived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.TripReceived.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDriverid();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleid();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getTripid();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getStarttime();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getEndtime();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getTripmaxspeed();
    if (f !== 0.0) writer.writeFloat(6, f);
    f = message.getTripduration();
    if (f !== 0.0) writer.writeFloat(7, f);
    f = message.getDistance();
    if (f !== 0.0) writer.writeFloat(8, f);
    f = message.getSessionid();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getTrackingid();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getInsuranceperiod();
    if (f !== 0) writer.writeInt64(11, f);
    f = message.getUsermode();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getDrivetype();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getVehicletype();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getHardbrakerating();
    if (f !== 0) writer.writeInt32(15, f);
    f = message.getHardturnrating();
    if (f !== 0) writer.writeInt32(16, f);
    f = message.getRapidaccelerationrating();
    if (f !== 0) writer.writeInt32(17, f);
    f = message.getPhoneuserating();
    if (f !== 0) writer.writeInt32(18, f);
    f = message.getOverspeedingrating();
    if (f !== 0) writer.writeInt32(19, f);
    f = message.getDrivingscore();
    if (f !== 0) writer.writeInt32(20, f);
    f = message.getTripeventsList();
    if (f.length > 0) writer.writeRepeatedMessage(21, f, proto.telematics_service.TripEvent.serializeBinaryToWriter);
};
/**
 * optional string DriverId = 1;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getDriverid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setDriverid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string VehicleId = 2;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getVehicleid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setVehicleid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string TripId = 3;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getTripid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setTripid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string StartTime = 4;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getStarttime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setStarttime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string EndTime = 5;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getEndtime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setEndtime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional float TripMaxSpeed = 6;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getTripmaxspeed = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 6, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setTripmaxspeed = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional float TripDuration = 7;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getTripduration = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 7, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setTripduration = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional float Distance = 8;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getDistance = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 8, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setDistance = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional string SessionId = 9;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getSessionid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setSessionid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string TrackingId = 10;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getTrackingid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setTrackingid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional int64 InsurancePeriod = 11;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getInsuranceperiod = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setInsuranceperiod = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional string UserMode = 12;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getUsermode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setUsermode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string DriveType = 13;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getDrivetype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setDrivetype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string VehicleType = 14;
 * @return {string}
 */ proto.telematics_service.TripReceived.prototype.getVehicletype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setVehicletype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional int32 HardBrakeRating = 15;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getHardbrakerating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setHardbrakerating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * optional int32 HardTurnRating = 16;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getHardturnrating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setHardturnrating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
/**
 * optional int32 RapidAccelerationRating = 17;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getRapidaccelerationrating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 17, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setRapidaccelerationrating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 17, value);
};
/**
 * optional int32 PhoneUseRating = 18;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getPhoneuserating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 18, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setPhoneuserating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 18, value);
};
/**
 * optional int32 OverspeedingRating = 19;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getOverspeedingrating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 19, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setOverspeedingrating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 19, value);
};
/**
 * optional int32 DrivingScore = 20;
 * @return {number}
 */ proto.telematics_service.TripReceived.prototype.getDrivingscore = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 20, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.setDrivingscore = function(value) {
    return $8M67s.Message.setProto3IntField(this, 20, value);
};
/**
 * repeated TripEvent TripEvents = 21;
 * @return {!Array<!proto.telematics_service.TripEvent>}
 */ proto.telematics_service.TripReceived.prototype.getTripeventsList = function() {
    return /** @type{!Array<!proto.telematics_service.TripEvent>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.telematics_service.TripEvent, 21);
};
/**
 * @param {!Array<!proto.telematics_service.TripEvent>} value
 * @return {!proto.telematics_service.TripReceived} returns this
*/ proto.telematics_service.TripReceived.prototype.setTripeventsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 21, value);
};
/**
 * @param {!proto.telematics_service.TripEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telematics_service.TripEvent}
 */ proto.telematics_service.TripReceived.prototype.addTripevents = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 21, opt_value, proto.telematics_service.TripEvent, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telematics_service.TripReceived} returns this
 */ proto.telematics_service.TripReceived.prototype.clearTripeventsList = function() {
    return this.setTripeventsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telematics_service.CollisionReceived.repeatedFields_ = [
    26
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.CollisionReceived.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.CollisionReceived.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.CollisionReceived} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.CollisionReceived.toObject = function(includeInstance, msg) {
        var f, obj = {
            driverid: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleid: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            collisionid: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            time: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            roadtype: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            roadspeedlimit: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            currentspeed: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
            gforce: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
            headingdegrees: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
            brakedistance: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
            decelerationratemilesperhourpersecond: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 11, 0.0),
            airbagdeployed: $8M67s.Message.getBooleanFieldWithDefault(msg, 12, false),
            confidencenumber: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            confidence: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            tripmaxspeedkmph: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 15, 0.0),
            durationseconds: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 16, 0.0),
            distance: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 17, 0.0),
            sessionid: $8M67s.Message.getFieldWithDefault(msg, 18, ""),
            trackingid: $8M67s.Message.getFieldWithDefault(msg, 19, ""),
            insuranceperiod: $8M67s.Message.getFieldWithDefault(msg, 20, 0),
            usermode: $8M67s.Message.getFieldWithDefault(msg, 21, ""),
            drivetype: $8M67s.Message.getFieldWithDefault(msg, 22, ""),
            message: $8M67s.Message.getFieldWithDefault(msg, 23, ""),
            latitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 24, 0.0),
            longitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 25, 0.0),
            collisioneventsList: $8M67s.Message.toObjectList(msg.getCollisioneventsList(), proto.telematics_service.CollisionEvent.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.CollisionReceived}
 */ proto.telematics_service.CollisionReceived.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.CollisionReceived;
    return proto.telematics_service.CollisionReceived.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.CollisionReceived} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.CollisionReceived}
 */ proto.telematics_service.CollisionReceived.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDriverid(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleid(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCollisionid(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setTime(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setRoadtype(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRoadspeedlimit(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readFloat();
                msg.setCurrentspeed(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readFloat();
                msg.setGforce(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readFloat();
                msg.setHeadingdegrees(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readFloat();
                msg.setBrakedistance(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readFloat();
                msg.setDecelerationratemilesperhourpersecond(value);
                break;
            case 12:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setAirbagdeployed(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt32();
                msg.setConfidencenumber(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setConfidence(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTripmaxspeedkmph(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readFloat();
                msg.setDurationseconds(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readFloat();
                msg.setDistance(value);
                break;
            case 18:
                var value = /** @type {string} */ reader.readString();
                msg.setSessionid(value);
                break;
            case 19:
                var value = /** @type {string} */ reader.readString();
                msg.setTrackingid(value);
                break;
            case 20:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInsuranceperiod(value);
                break;
            case 21:
                var value = /** @type {string} */ reader.readString();
                msg.setUsermode(value);
                break;
            case 22:
                var value = /** @type {string} */ reader.readString();
                msg.setDrivetype(value);
                break;
            case 23:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            case 24:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitude(value);
                break;
            case 25:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitude(value);
                break;
            case 26:
                var value = new proto.telematics_service.CollisionEvent;
                reader.readMessage(value, proto.telematics_service.CollisionEvent.deserializeBinaryFromReader);
                msg.addCollisionevents(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.CollisionReceived.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.CollisionReceived.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.CollisionReceived} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.CollisionReceived.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDriverid();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleid();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getCollisionid();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getTime();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getRoadtype();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getRoadspeedlimit();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getCurrentspeed();
    if (f !== 0.0) writer.writeFloat(7, f);
    f = message.getGforce();
    if (f !== 0.0) writer.writeFloat(8, f);
    f = message.getHeadingdegrees();
    if (f !== 0.0) writer.writeFloat(9, f);
    f = message.getBrakedistance();
    if (f !== 0.0) writer.writeFloat(10, f);
    f = message.getDecelerationratemilesperhourpersecond();
    if (f !== 0.0) writer.writeFloat(11, f);
    f = message.getAirbagdeployed();
    if (f) writer.writeBool(12, f);
    f = message.getConfidencenumber();
    if (f !== 0) writer.writeInt32(13, f);
    f = message.getConfidence();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getTripmaxspeedkmph();
    if (f !== 0.0) writer.writeFloat(15, f);
    f = message.getDurationseconds();
    if (f !== 0.0) writer.writeFloat(16, f);
    f = message.getDistance();
    if (f !== 0.0) writer.writeFloat(17, f);
    f = message.getSessionid();
    if (f.length > 0) writer.writeString(18, f);
    f = message.getTrackingid();
    if (f.length > 0) writer.writeString(19, f);
    f = message.getInsuranceperiod();
    if (f !== 0) writer.writeInt32(20, f);
    f = message.getUsermode();
    if (f.length > 0) writer.writeString(21, f);
    f = message.getDrivetype();
    if (f.length > 0) writer.writeString(22, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(23, f);
    f = message.getLatitude();
    if (f !== 0.0) writer.writeFloat(24, f);
    f = message.getLongitude();
    if (f !== 0.0) writer.writeFloat(25, f);
    f = message.getCollisioneventsList();
    if (f.length > 0) writer.writeRepeatedMessage(26, f, proto.telematics_service.CollisionEvent.serializeBinaryToWriter);
};
/**
 * optional string DriverId = 1;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getDriverid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setDriverid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string VehicleId = 2;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getVehicleid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setVehicleid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string CollisionId = 3;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getCollisionid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setCollisionid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string Time = 4;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getTime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setTime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string RoadType = 5;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getRoadtype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setRoadtype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 RoadSpeedLimit = 6;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getRoadspeedlimit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setRoadspeedlimit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional float CurrentSpeed = 7;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getCurrentspeed = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 7, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setCurrentspeed = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional float Gforce = 8;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getGforce = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 8, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setGforce = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional float HeadingDegrees = 9;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getHeadingdegrees = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 9, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setHeadingdegrees = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 9, value);
};
/**
 * optional float BrakeDistance = 10;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getBrakedistance = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 10, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setBrakedistance = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 10, value);
};
/**
 * optional float DecelerationRateMilesPerHourPerSecond = 11;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getDecelerationratemilesperhourpersecond = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 11, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setDecelerationratemilesperhourpersecond = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 11, value);
};
/**
 * optional bool AirbagDeployed = 12;
 * @return {boolean}
 */ proto.telematics_service.CollisionReceived.prototype.getAirbagdeployed = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 12, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setAirbagdeployed = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 12, value);
};
/**
 * optional int32 ConfidenceNumber = 13;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getConfidencenumber = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setConfidencenumber = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
/**
 * optional string Confidence = 14;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getConfidence = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setConfidence = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional float TripMaxSpeedKmph = 15;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getTripmaxspeedkmph = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 15, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setTripmaxspeedkmph = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 15, value);
};
/**
 * optional float DurationSeconds = 16;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getDurationseconds = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 16, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setDurationseconds = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 16, value);
};
/**
 * optional float Distance = 17;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getDistance = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 17, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setDistance = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 17, value);
};
/**
 * optional string SessionId = 18;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getSessionid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 18, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setSessionid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 18, value);
};
/**
 * optional string TrackingId = 19;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getTrackingid = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 19, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setTrackingid = function(value) {
    return $8M67s.Message.setProto3StringField(this, 19, value);
};
/**
 * optional int32 InsurancePeriod = 20;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getInsuranceperiod = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 20, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setInsuranceperiod = function(value) {
    return $8M67s.Message.setProto3IntField(this, 20, value);
};
/**
 * optional string UserMode = 21;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getUsermode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 21, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setUsermode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 21, value);
};
/**
 * optional string DriveType = 22;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getDrivetype = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 22, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setDrivetype = function(value) {
    return $8M67s.Message.setProto3StringField(this, 22, value);
};
/**
 * optional string Message = 23;
 * @return {string}
 */ proto.telematics_service.CollisionReceived.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 23, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 23, value);
};
/**
 * optional float Latitude = 24;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getLatitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 24, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setLatitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 24, value);
};
/**
 * optional float Longitude = 25;
 * @return {number}
 */ proto.telematics_service.CollisionReceived.prototype.getLongitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 25, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.setLongitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 25, value);
};
/**
 * repeated CollisionEvent CollisionEvents = 26;
 * @return {!Array<!proto.telematics_service.CollisionEvent>}
 */ proto.telematics_service.CollisionReceived.prototype.getCollisioneventsList = function() {
    return /** @type{!Array<!proto.telematics_service.CollisionEvent>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.telematics_service.CollisionEvent, 26);
};
/**
 * @param {!Array<!proto.telematics_service.CollisionEvent>} value
 * @return {!proto.telematics_service.CollisionReceived} returns this
*/ proto.telematics_service.CollisionReceived.prototype.setCollisioneventsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 26, value);
};
/**
 * @param {!proto.telematics_service.CollisionEvent=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telematics_service.CollisionEvent}
 */ proto.telematics_service.CollisionReceived.prototype.addCollisionevents = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 26, opt_value, proto.telematics_service.CollisionEvent, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telematics_service.CollisionReceived} returns this
 */ proto.telematics_service.CollisionReceived.prototype.clearCollisioneventsList = function() {
    return this.setCollisioneventsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.CollisionEvent.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.CollisionEvent.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.CollisionEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.CollisionEvent.toObject = function(includeInstance, msg) {
        var f, obj = {
            eventtype: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            eventtypename: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            latitudeend: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
            longitudeend: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
            longitudestart: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
            latitudestart: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
            averagedriverspeedmph: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
            maxdriverspeedmph: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
            endtime: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            postedspeedlimitmph: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 10, 0.0),
            starttime: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.CollisionEvent}
 */ proto.telematics_service.CollisionEvent.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.CollisionEvent;
    return proto.telematics_service.CollisionEvent.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.CollisionEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.CollisionEvent}
 */ proto.telematics_service.CollisionEvent.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEventtype(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEventtypename(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitudeend(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitudeend(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitudestart(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitudestart(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readFloat();
                msg.setAveragedriverspeedmph(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readFloat();
                msg.setMaxdriverspeedmph(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setEndtime(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readFloat();
                msg.setPostedspeedlimitmph(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setStarttime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.CollisionEvent.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.CollisionEvent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.CollisionEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.CollisionEvent.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getEventtype();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getEventtypename();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLatitudeend();
    if (f !== 0.0) writer.writeFloat(3, f);
    f = message.getLongitudeend();
    if (f !== 0.0) writer.writeFloat(4, f);
    f = message.getLongitudestart();
    if (f !== 0.0) writer.writeFloat(5, f);
    f = message.getLatitudestart();
    if (f !== 0.0) writer.writeFloat(6, f);
    f = message.getAveragedriverspeedmph();
    if (f !== 0.0) writer.writeFloat(7, f);
    f = message.getMaxdriverspeedmph();
    if (f !== 0.0) writer.writeFloat(8, f);
    f = message.getEndtime();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getPostedspeedlimitmph();
    if (f !== 0.0) writer.writeFloat(10, f);
    f = message.getStarttime();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional int32 EventType = 1;
 * @return {number}
 */ proto.telematics_service.CollisionEvent.prototype.getEventtype = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setEventtype = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string EventTypeName = 2;
 * @return {string}
 */ proto.telematics_service.CollisionEvent.prototype.getEventtypename = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setEventtypename = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional float LatitudeEnd = 3;
 * @return {number}
 */ proto.telematics_service.CollisionEvent.prototype.getLatitudeend = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 3, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setLatitudeend = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 3, value);
};
/**
 * optional float LongitudeEnd = 4;
 * @return {number}
 */ proto.telematics_service.CollisionEvent.prototype.getLongitudeend = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 4, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setLongitudeend = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 4, value);
};
/**
 * optional float LongitudeStart = 5;
 * @return {number}
 */ proto.telematics_service.CollisionEvent.prototype.getLongitudestart = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 5, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setLongitudestart = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 5, value);
};
/**
 * optional float LatitudeStart = 6;
 * @return {number}
 */ proto.telematics_service.CollisionEvent.prototype.getLatitudestart = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 6, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setLatitudestart = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional float AverageDriverSpeedMph = 7;
 * @return {number}
 */ proto.telematics_service.CollisionEvent.prototype.getAveragedriverspeedmph = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 7, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setAveragedriverspeedmph = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional float MaxDriverSpeedMph = 8;
 * @return {number}
 */ proto.telematics_service.CollisionEvent.prototype.getMaxdriverspeedmph = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 8, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setMaxdriverspeedmph = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional string EndTime = 9;
 * @return {string}
 */ proto.telematics_service.CollisionEvent.prototype.getEndtime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setEndtime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional float PostedSpeedLimitMph = 10;
 * @return {number}
 */ proto.telematics_service.CollisionEvent.prototype.getPostedspeedlimitmph = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 10, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setPostedspeedlimitmph = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 10, value);
};
/**
 * optional string StartTime = 11;
 * @return {string}
 */ proto.telematics_service.CollisionEvent.prototype.getStarttime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.CollisionEvent} returns this
 */ proto.telematics_service.CollisionEvent.prototype.setStarttime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.Telematics.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.Telematics.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.Telematics} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.Telematics.toObject = function(includeInstance, msg) {
        var f, obj = {
            internalId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            externalId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            location: (f = msg.getLocation()) && proto.telematics_service.Location.toObject(includeInstance, f),
            odometer: (f = msg.getOdometer()) && $9YICB.Odometer.toObject(includeInstance, f),
            metadataMap: (f = msg.getMetadataMap()) ? f.toObject(includeInstance, undefined) : [],
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            make: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            lastConnectionTime: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            oemId: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            currentConnectionAttempts: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            connectionState: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            custodianId: $8M67s.Message.getFieldWithDefault(msg, 15, ""),
            custodianType: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            chargeState: $8M67s.Message.getFieldWithDefault(msg, 17, 0),
            locked: $8M67s.Message.getBooleanFieldWithDefault(msg, 18, false),
            fdWindow: $8M67s.Message.getFieldWithDefault(msg, 19, 0),
            fpWindow: $8M67s.Message.getFieldWithDefault(msg, 20, 0),
            dashcamState: $8M67s.Message.getFieldWithDefault(msg, 21, ""),
            batteryLevel: $8M67s.Message.getFieldWithDefault(msg, 22, 0),
            batteryRange: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 23, 0.0),
            rdWindow: $8M67s.Message.getFieldWithDefault(msg, 24, 0),
            rpWindow: $8M67s.Message.getFieldWithDefault(msg, 25, 0),
            sentryMode: $8M67s.Message.getBooleanFieldWithDefault(msg, 26, false),
            tpmsPressureFl: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 27, 0.0),
            tpmsPressureFr: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 28, 0.0),
            tpmsPressureRl: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 29, 0.0),
            tpmsPressureRr: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 30, 0.0),
            payload: $8M67s.Message.getFieldWithDefault(msg, 31, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.Telematics}
 */ proto.telematics_service.Telematics.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.Telematics;
    return proto.telematics_service.Telematics.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.Telematics} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.Telematics}
 */ proto.telematics_service.Telematics.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInternalId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setExternalId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 4:
                var value = new proto.telematics_service.Location;
                reader.readMessage(value, proto.telematics_service.Location.deserializeBinaryFromReader);
                msg.setLocation(value);
                break;
            case 5:
                var value = new $9YICB.Odometer;
                reader.readMessage(value, $9YICB.Odometer.deserializeBinaryFromReader);
                msg.setOdometer(value);
                break;
            case 6:
                var value = msg.getMetadataMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readString, null, "", "");
                });
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt64();
                msg.setTimestamp(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setYear(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLastConnectionTime(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setOemId(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCurrentConnectionAttempts(value);
                break;
            case 14:
                var value = /** @type {!proto.telematics_service.Telematics.ConnectionState} */ reader.readEnum();
                msg.setConnectionState(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setCustodianId(value);
                break;
            case 16:
                var value = /** @type {!proto.vehicle.CustodianType} */ reader.readEnum();
                msg.setCustodianType(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readInt64();
                msg.setChargeState(value);
                break;
            case 18:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setLocked(value);
                break;
            case 19:
                var value = /** @type {number} */ reader.readInt64();
                msg.setFdWindow(value);
                break;
            case 20:
                var value = /** @type {number} */ reader.readInt64();
                msg.setFpWindow(value);
                break;
            case 21:
                var value = /** @type {string} */ reader.readString();
                msg.setDashcamState(value);
                break;
            case 22:
                var value = /** @type {number} */ reader.readInt64();
                msg.setBatteryLevel(value);
                break;
            case 23:
                var value = /** @type {number} */ reader.readFloat();
                msg.setBatteryRange(value);
                break;
            case 24:
                var value = /** @type {number} */ reader.readInt64();
                msg.setRdWindow(value);
                break;
            case 25:
                var value = /** @type {number} */ reader.readInt64();
                msg.setRpWindow(value);
                break;
            case 26:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSentryMode(value);
                break;
            case 27:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTpmsPressureFl(value);
                break;
            case 28:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTpmsPressureFr(value);
                break;
            case 29:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTpmsPressureRl(value);
                break;
            case 30:
                var value = /** @type {number} */ reader.readFloat();
                msg.setTpmsPressureRr(value);
                break;
            case 31:
                var value = /** @type {string} */ reader.readString();
                msg.setPayload(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.Telematics.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.Telematics.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.Telematics} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.Telematics.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInternalId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getExternalId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLocation();
    if (f != null) writer.writeMessage(4, f, proto.telematics_service.Location.serializeBinaryToWriter);
    f = message.getOdometer();
    if (f != null) writer.writeMessage(5, f, $9YICB.Odometer.serializeBinaryToWriter);
    f = message.getMetadataMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(6, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeString);
    f = message.getTimestamp();
    if (f !== 0) writer.writeInt64(7, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getYear();
    if (f !== 0) writer.writeInt32(10, f);
    f = message.getLastConnectionTime();
    if (f !== 0) writer.writeInt64(11, f);
    f = message.getOemId();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getCurrentConnectionAttempts();
    if (f !== 0) writer.writeInt64(13, f);
    f = message.getConnectionState();
    if (f !== 0.0) writer.writeEnum(14, f);
    f = message.getCustodianId();
    if (f.length > 0) writer.writeString(15, f);
    f = message.getCustodianType();
    if (f !== 0.0) writer.writeEnum(16, f);
    f = message.getChargeState();
    if (f !== 0) writer.writeInt64(17, f);
    f = message.getLocked();
    if (f) writer.writeBool(18, f);
    f = message.getFdWindow();
    if (f !== 0) writer.writeInt64(19, f);
    f = message.getFpWindow();
    if (f !== 0) writer.writeInt64(20, f);
    f = message.getDashcamState();
    if (f.length > 0) writer.writeString(21, f);
    f = message.getBatteryLevel();
    if (f !== 0) writer.writeInt64(22, f);
    f = message.getBatteryRange();
    if (f !== 0.0) writer.writeFloat(23, f);
    f = message.getRdWindow();
    if (f !== 0) writer.writeInt64(24, f);
    f = message.getRpWindow();
    if (f !== 0) writer.writeInt64(25, f);
    f = message.getSentryMode();
    if (f) writer.writeBool(26, f);
    f = message.getTpmsPressureFl();
    if (f !== 0.0) writer.writeFloat(27, f);
    f = message.getTpmsPressureFr();
    if (f !== 0.0) writer.writeFloat(28, f);
    f = message.getTpmsPressureRl();
    if (f !== 0.0) writer.writeFloat(29, f);
    f = message.getTpmsPressureRr();
    if (f !== 0.0) writer.writeFloat(30, f);
    f = message.getPayload();
    if (f.length > 0) writer.writeString(31, f);
};
/**
 * @enum {number}
 */ proto.telematics_service.Telematics.ConnectionState = {
    CONNECTION_STATE_UNSPECIFIED: 0,
    CONNECTION_STATE_UNKNOWN: 1,
    CONNECTION_STATE_OFFLINE: 2,
    CONNECTION_STATE_ASLEEP: 3,
    CONNECTION_STATE_ONLINE: 4
};
/**
 * optional string internal_id = 1;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getInternalId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setInternalId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string external_id = 2;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getExternalId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setExternalId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vin = 3;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional Location location = 4;
 * @return {?proto.telematics_service.Location}
 */ proto.telematics_service.Telematics.prototype.getLocation = function() {
    return /** @type{?proto.telematics_service.Location} */ $8M67s.Message.getWrapperField(this, proto.telematics_service.Location, 4);
};
/**
 * @param {?proto.telematics_service.Location|undefined} value
 * @return {!proto.telematics_service.Telematics} returns this
*/ proto.telematics_service.Telematics.prototype.setLocation = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.clearLocation = function() {
    return this.setLocation(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.Telematics.prototype.hasLocation = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * optional vehicle.Odometer odometer = 5;
 * @return {?proto.vehicle.Odometer}
 */ proto.telematics_service.Telematics.prototype.getOdometer = function() {
    return /** @type{?proto.vehicle.Odometer} */ $8M67s.Message.getWrapperField(this, $9YICB.Odometer, 5);
};
/**
 * @param {?proto.vehicle.Odometer|undefined} value
 * @return {!proto.telematics_service.Telematics} returns this
*/ proto.telematics_service.Telematics.prototype.setOdometer = function(value) {
    return $8M67s.Message.setWrapperField(this, 5, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.clearOdometer = function() {
    return this.setOdometer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.Telematics.prototype.hasOdometer = function() {
    return $8M67s.Message.getField(this, 5) != null;
};
/**
 * map<string, string> metadata = 6;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */ proto.telematics_service.Telematics.prototype.getMetadataMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,string>} */ $8M67s.Message.getMapField(this, 6, opt_noLazyCreate, null);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.clearMetadataMap = function() {
    this.getMetadataMap().clear();
    return this;
};
/**
 * optional int64 timestamp = 7;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getTimestamp = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional string make = 8;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string model = 9;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional int32 year = 10;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getYear = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int64 last_connection_time = 11;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getLastConnectionTime = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setLastConnectionTime = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional string oem_id = 12;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getOemId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setOemId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional int64 current_connection_attempts = 13;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getCurrentConnectionAttempts = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setCurrentConnectionAttempts = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
/**
 * optional ConnectionState connection_state = 14;
 * @return {!proto.telematics_service.Telematics.ConnectionState}
 */ proto.telematics_service.Telematics.prototype.getConnectionState = function() {
    return /** @type {!proto.telematics_service.Telematics.ConnectionState} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {!proto.telematics_service.Telematics.ConnectionState} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setConnectionState = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 14, value);
};
/**
 * optional string custodian_id = 15;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getCustodianId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setCustodianId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
/**
 * optional vehicle.CustodianType custodian_type = 16;
 * @return {!proto.vehicle.CustodianType}
 */ proto.telematics_service.Telematics.prototype.getCustodianType = function() {
    return /** @type {!proto.vehicle.CustodianType} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {!proto.vehicle.CustodianType} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setCustodianType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 16, value);
};
/**
 * optional int64 charge_state = 17;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getChargeState = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 17, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setChargeState = function(value) {
    return $8M67s.Message.setProto3IntField(this, 17, value);
};
/**
 * optional bool locked = 18;
 * @return {boolean}
 */ proto.telematics_service.Telematics.prototype.getLocked = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 18, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setLocked = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 18, value);
};
/**
 * optional int64 fd_window = 19;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getFdWindow = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 19, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setFdWindow = function(value) {
    return $8M67s.Message.setProto3IntField(this, 19, value);
};
/**
 * optional int64 fp_window = 20;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getFpWindow = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 20, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setFpWindow = function(value) {
    return $8M67s.Message.setProto3IntField(this, 20, value);
};
/**
 * optional string dashcam_state = 21;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getDashcamState = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 21, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setDashcamState = function(value) {
    return $8M67s.Message.setProto3StringField(this, 21, value);
};
/**
 * optional int64 battery_level = 22;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getBatteryLevel = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 22, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setBatteryLevel = function(value) {
    return $8M67s.Message.setProto3IntField(this, 22, value);
};
/**
 * optional float battery_range = 23;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getBatteryRange = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 23, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setBatteryRange = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 23, value);
};
/**
 * optional int64 rd_window = 24;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getRdWindow = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 24, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setRdWindow = function(value) {
    return $8M67s.Message.setProto3IntField(this, 24, value);
};
/**
 * optional int64 rp_window = 25;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getRpWindow = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 25, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setRpWindow = function(value) {
    return $8M67s.Message.setProto3IntField(this, 25, value);
};
/**
 * optional bool sentry_mode = 26;
 * @return {boolean}
 */ proto.telematics_service.Telematics.prototype.getSentryMode = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 26, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setSentryMode = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 26, value);
};
/**
 * optional float tpms_pressure_fl = 27;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getTpmsPressureFl = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 27, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setTpmsPressureFl = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 27, value);
};
/**
 * optional float tpms_pressure_fr = 28;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getTpmsPressureFr = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 28, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setTpmsPressureFr = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 28, value);
};
/**
 * optional float tpms_pressure_rl = 29;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getTpmsPressureRl = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 29, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setTpmsPressureRl = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 29, value);
};
/**
 * optional float tpms_pressure_rr = 30;
 * @return {number}
 */ proto.telematics_service.Telematics.prototype.getTpmsPressureRr = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 30, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setTpmsPressureRr = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 30, value);
};
/**
 * optional string payload = 31;
 * @return {string}
 */ proto.telematics_service.Telematics.prototype.getPayload = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 31, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Telematics} returns this
 */ proto.telematics_service.Telematics.prototype.setPayload = function(value) {
    return $8M67s.Message.setProto3StringField(this, 31, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.telematics_service.ClusterState.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.ClusterState.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.ClusterState.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.ClusterState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.ClusterState.toObject = function(includeInstance, msg) {
        var f, obj = {
            instancesList: $8M67s.Message.toObjectList(msg.getInstancesList(), proto.telematics_service.Instance.toObject, includeInstance),
            leaderId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            groupName: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            vehicleCount: $8M67s.Message.getFieldWithDefault(msg, 6, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.ClusterState}
 */ proto.telematics_service.ClusterState.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.ClusterState;
    return proto.telematics_service.ClusterState.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.ClusterState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.ClusterState}
 */ proto.telematics_service.ClusterState.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.telematics_service.Instance;
                reader.readMessage(value, proto.telematics_service.Instance.deserializeBinaryFromReader);
                msg.addInstances(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setLeaderId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setGroupName(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVehicleCount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.ClusterState.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.ClusterState.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.ClusterState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.ClusterState.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInstancesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.telematics_service.Instance.serializeBinaryToWriter);
    f = message.getLeaderId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getGroupName();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getVehicleCount();
    if (f !== 0) writer.writeInt64(6, f);
};
/**
 * repeated Instance instances = 1;
 * @return {!Array<!proto.telematics_service.Instance>}
 */ proto.telematics_service.ClusterState.prototype.getInstancesList = function() {
    return /** @type{!Array<!proto.telematics_service.Instance>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.telematics_service.Instance, 1);
};
/**
 * @param {!Array<!proto.telematics_service.Instance>} value
 * @return {!proto.telematics_service.ClusterState} returns this
*/ proto.telematics_service.ClusterState.prototype.setInstancesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.telematics_service.Instance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.telematics_service.Instance}
 */ proto.telematics_service.ClusterState.prototype.addInstances = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.telematics_service.Instance, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.telematics_service.ClusterState} returns this
 */ proto.telematics_service.ClusterState.prototype.clearInstancesList = function() {
    return this.setInstancesList([]);
};
/**
 * optional string leader_id = 2;
 * @return {string}
 */ proto.telematics_service.ClusterState.prototype.getLeaderId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.ClusterState} returns this
 */ proto.telematics_service.ClusterState.prototype.setLeaderId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string group_name = 5;
 * @return {string}
 */ proto.telematics_service.ClusterState.prototype.getGroupName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.ClusterState} returns this
 */ proto.telematics_service.ClusterState.prototype.setGroupName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int64 vehicle_count = 6;
 * @return {number}
 */ proto.telematics_service.ClusterState.prototype.getVehicleCount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.ClusterState} returns this
 */ proto.telematics_service.ClusterState.prototype.setVehicleCount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.Instance.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.Instance.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.Instance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.Instance.toObject = function(includeInstance, msg) {
        var f, obj = {
            instanceName: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            isLeader: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false),
            vehiclesTrackingMap: (f = msg.getVehiclesTrackingMap()) ? f.toObject(includeInstance, undefined) : [],
            lastCheckin: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            trackingMapMap: (f = msg.getTrackingMapMap()) ? f.toObject(includeInstance, proto.telematics_service.Telematics.toObject) : []
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.Instance}
 */ proto.telematics_service.Instance.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.Instance;
    return proto.telematics_service.Instance.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.Instance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.Instance}
 */ proto.telematics_service.Instance.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setInstanceName(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsLeader(value);
                break;
            case 3:
                var value = msg.getVehiclesTrackingMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readString, null, "", "");
                });
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLastCheckin(value);
                break;
            case 5:
                var value = msg.getTrackingMapMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.telematics_service.Telematics.deserializeBinaryFromReader, "", new proto.telematics_service.Telematics());
                });
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.Instance.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.Instance.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.Instance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.Instance.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getInstanceName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getIsLeader();
    if (f) writer.writeBool(2, f);
    f = message.getVehiclesTrackingMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(3, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeString);
    f = message.getLastCheckin();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getTrackingMapMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(5, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.telematics_service.Telematics.serializeBinaryToWriter);
};
/**
 * optional string instance_name = 1;
 * @return {string}
 */ proto.telematics_service.Instance.prototype.getInstanceName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Instance} returns this
 */ proto.telematics_service.Instance.prototype.setInstanceName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool is_leader = 2;
 * @return {boolean}
 */ proto.telematics_service.Instance.prototype.getIsLeader = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.telematics_service.Instance} returns this
 */ proto.telematics_service.Instance.prototype.setIsLeader = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
/**
 * map<string, string> vehicles_tracking = 3;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */ proto.telematics_service.Instance.prototype.getVehiclesTrackingMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,string>} */ $8M67s.Message.getMapField(this, 3, opt_noLazyCreate, null);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.telematics_service.Instance} returns this
 */ proto.telematics_service.Instance.prototype.clearVehiclesTrackingMap = function() {
    this.getVehiclesTrackingMap().clear();
    return this;
};
/**
 * optional int64 last_checkin = 4;
 * @return {number}
 */ proto.telematics_service.Instance.prototype.getLastCheckin = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Instance} returns this
 */ proto.telematics_service.Instance.prototype.setLastCheckin = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * map<string, Telematics> tracking_map = 5;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.telematics_service.Telematics>}
 */ proto.telematics_service.Instance.prototype.getTrackingMapMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.telematics_service.Telematics>} */ $8M67s.Message.getMapField(this, 5, opt_noLazyCreate, proto.telematics_service.Telematics);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.telematics_service.Instance} returns this
 */ proto.telematics_service.Instance.prototype.clearTrackingMapMap = function() {
    this.getTrackingMapMap().clear();
    return this;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.RoutePosition.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.RoutePosition.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.RoutePosition} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.RoutePosition.toObject = function(includeInstance, msg) {
        var f, obj = {
            timestamp: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            location: (f = msg.getLocation()) && proto.telematics_service.Location.toObject(includeInstance, f),
            odometer: (f = msg.getOdometer()) && $9YICB.Odometer.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.RoutePosition}
 */ proto.telematics_service.RoutePosition.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.RoutePosition;
    return proto.telematics_service.RoutePosition.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.RoutePosition} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.RoutePosition}
 */ proto.telematics_service.RoutePosition.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setTimestamp(value);
                break;
            case 2:
                var value = new proto.telematics_service.Location;
                reader.readMessage(value, proto.telematics_service.Location.deserializeBinaryFromReader);
                msg.setLocation(value);
                break;
            case 3:
                var value = new $9YICB.Odometer;
                reader.readMessage(value, $9YICB.Odometer.deserializeBinaryFromReader);
                msg.setOdometer(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.RoutePosition.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.RoutePosition.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.RoutePosition} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.RoutePosition.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTimestamp();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getLocation();
    if (f != null) writer.writeMessage(2, f, proto.telematics_service.Location.serializeBinaryToWriter);
    f = message.getOdometer();
    if (f != null) writer.writeMessage(3, f, $9YICB.Odometer.serializeBinaryToWriter);
};
/**
 * optional string timestamp = 1;
 * @return {string}
 */ proto.telematics_service.RoutePosition.prototype.getTimestamp = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.RoutePosition} returns this
 */ proto.telematics_service.RoutePosition.prototype.setTimestamp = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Location location = 2;
 * @return {?proto.telematics_service.Location}
 */ proto.telematics_service.RoutePosition.prototype.getLocation = function() {
    return /** @type{?proto.telematics_service.Location} */ $8M67s.Message.getWrapperField(this, proto.telematics_service.Location, 2);
};
/**
 * @param {?proto.telematics_service.Location|undefined} value
 * @return {!proto.telematics_service.RoutePosition} returns this
*/ proto.telematics_service.RoutePosition.prototype.setLocation = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.RoutePosition} returns this
 */ proto.telematics_service.RoutePosition.prototype.clearLocation = function() {
    return this.setLocation(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.RoutePosition.prototype.hasLocation = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional vehicle.Odometer odometer = 3;
 * @return {?proto.vehicle.Odometer}
 */ proto.telematics_service.RoutePosition.prototype.getOdometer = function() {
    return /** @type{?proto.vehicle.Odometer} */ $8M67s.Message.getWrapperField(this, $9YICB.Odometer, 3);
};
/**
 * @param {?proto.vehicle.Odometer|undefined} value
 * @return {!proto.telematics_service.RoutePosition} returns this
*/ proto.telematics_service.RoutePosition.prototype.setOdometer = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.RoutePosition} returns this
 */ proto.telematics_service.RoutePosition.prototype.clearOdometer = function() {
    return this.setOdometer(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.RoutePosition.prototype.hasOdometer = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.Location.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.Location.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.Location} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.Location.toObject = function(includeInstance, msg) {
        var f, obj = {
            latitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
            longitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
            altitude: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
            physicalAddress: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.Location}
 */ proto.telematics_service.Location.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.Location;
    return proto.telematics_service.Location.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.Location} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.Location}
 */ proto.telematics_service.Location.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitude(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitude(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readFloat();
                msg.setAltitude(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setPhysicalAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.Location.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.Location.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.Location} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.Location.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLatitude();
    if (f !== 0.0) writer.writeFloat(1, f);
    f = message.getLongitude();
    if (f !== 0.0) writer.writeFloat(2, f);
    f = message.getAltitude();
    if (f !== 0.0) writer.writeFloat(3, f);
    f = message.getPhysicalAddress();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional float latitude = 1;
 * @return {number}
 */ proto.telematics_service.Location.prototype.getLatitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 1, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Location} returns this
 */ proto.telematics_service.Location.prototype.setLatitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 1, value);
};
/**
 * optional float longitude = 2;
 * @return {number}
 */ proto.telematics_service.Location.prototype.getLongitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 2, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Location} returns this
 */ proto.telematics_service.Location.prototype.setLongitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 2, value);
};
/**
 * optional float altitude = 3;
 * @return {number}
 */ proto.telematics_service.Location.prototype.getAltitude = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 3, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.Location} returns this
 */ proto.telematics_service.Location.prototype.setAltitude = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 3, value);
};
/**
 * optional string physical_address = 5;
 * @return {string}
 */ proto.telematics_service.Location.prototype.getPhysicalAddress = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.Location} returns this
 */ proto.telematics_service.Location.prototype.setPhysicalAddress = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.TripEvent.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.TripEvent.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.TripEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.TripEvent.toObject = function(includeInstance, msg) {
        var f, obj = {
            eventtype: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            eventtypename: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            latitudestart: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
            longitudestart: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
            latitudeend: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
            longitudeend: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
            averagedriverspeed: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
            maxdriverspeed: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0),
            postedspeedlimit: $8M67s.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
            starttime: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            endtime: $8M67s.Message.getFieldWithDefault(msg, 11, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.TripEvent}
 */ proto.telematics_service.TripEvent.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.TripEvent;
    return proto.telematics_service.TripEvent.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.TripEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.TripEvent}
 */ proto.telematics_service.TripEvent.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEventtype(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEventtypename(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitudestart(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitudestart(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLatitudeend(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readFloat();
                msg.setLongitudeend(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readFloat();
                msg.setAveragedriverspeed(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readFloat();
                msg.setMaxdriverspeed(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readFloat();
                msg.setPostedspeedlimit(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setStarttime(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setEndtime(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.TripEvent.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.TripEvent.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.TripEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.TripEvent.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getEventtype();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getEventtypename();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLatitudestart();
    if (f !== 0.0) writer.writeFloat(3, f);
    f = message.getLongitudestart();
    if (f !== 0.0) writer.writeFloat(4, f);
    f = message.getLatitudeend();
    if (f !== 0.0) writer.writeFloat(5, f);
    f = message.getLongitudeend();
    if (f !== 0.0) writer.writeFloat(6, f);
    f = message.getAveragedriverspeed();
    if (f !== 0.0) writer.writeFloat(7, f);
    f = message.getMaxdriverspeed();
    if (f !== 0.0) writer.writeFloat(8, f);
    f = message.getPostedspeedlimit();
    if (f !== 0.0) writer.writeFloat(9, f);
    f = message.getStarttime();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getEndtime();
    if (f.length > 0) writer.writeString(11, f);
};
/**
 * optional int32 EventType = 1;
 * @return {number}
 */ proto.telematics_service.TripEvent.prototype.getEventtype = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setEventtype = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string EventTypeName = 2;
 * @return {string}
 */ proto.telematics_service.TripEvent.prototype.getEventtypename = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setEventtypename = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional float LatitudeStart = 3;
 * @return {number}
 */ proto.telematics_service.TripEvent.prototype.getLatitudestart = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 3, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setLatitudestart = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 3, value);
};
/**
 * optional float LongitudeStart = 4;
 * @return {number}
 */ proto.telematics_service.TripEvent.prototype.getLongitudestart = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 4, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setLongitudestart = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 4, value);
};
/**
 * optional float LatitudeEnd = 5;
 * @return {number}
 */ proto.telematics_service.TripEvent.prototype.getLatitudeend = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 5, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setLatitudeend = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 5, value);
};
/**
 * optional float LongitudeEnd = 6;
 * @return {number}
 */ proto.telematics_service.TripEvent.prototype.getLongitudeend = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 6, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setLongitudeend = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 6, value);
};
/**
 * optional float AverageDriverSpeed = 7;
 * @return {number}
 */ proto.telematics_service.TripEvent.prototype.getAveragedriverspeed = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 7, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setAveragedriverspeed = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 7, value);
};
/**
 * optional float MaxDriverSpeed = 8;
 * @return {number}
 */ proto.telematics_service.TripEvent.prototype.getMaxdriverspeed = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 8, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setMaxdriverspeed = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 8, value);
};
/**
 * optional float PostedSpeedLimit = 9;
 * @return {number}
 */ proto.telematics_service.TripEvent.prototype.getPostedspeedlimit = function() {
    return /** @type {number} */ $8M67s.Message.getFloatingPointFieldWithDefault(this, 9, 0.0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setPostedspeedlimit = function(value) {
    return $8M67s.Message.setProto3FloatField(this, 9, value);
};
/**
 * optional string StartTime = 10;
 * @return {string}
 */ proto.telematics_service.TripEvent.prototype.getStarttime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setStarttime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string EndTime = 11;
 * @return {string}
 */ proto.telematics_service.TripEvent.prototype.getEndtime = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.TripEvent} returns this
 */ proto.telematics_service.TripEvent.prototype.setEndtime = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.DailyDrivingBehavior.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.DailyDrivingBehavior.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.DailyDrivingBehavior} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.DailyDrivingBehavior.toObject = function(includeInstance, msg) {
        var f, obj = {
            date: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            score: (f = msg.getScore()) && proto.telematics_service.VehicleScore.toObject(includeInstance, f),
            eventRating: (f = msg.getEventRating()) && proto.telematics_service.EventRating.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.DailyDrivingBehavior}
 */ proto.telematics_service.DailyDrivingBehavior.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.DailyDrivingBehavior;
    return proto.telematics_service.DailyDrivingBehavior.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.DailyDrivingBehavior} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.DailyDrivingBehavior}
 */ proto.telematics_service.DailyDrivingBehavior.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDate(value);
                break;
            case 2:
                var value = new proto.telematics_service.VehicleScore;
                reader.readMessage(value, proto.telematics_service.VehicleScore.deserializeBinaryFromReader);
                msg.setScore(value);
                break;
            case 3:
                var value = new proto.telematics_service.EventRating;
                reader.readMessage(value, proto.telematics_service.EventRating.deserializeBinaryFromReader);
                msg.setEventRating(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.DailyDrivingBehavior.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.DailyDrivingBehavior.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.DailyDrivingBehavior} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.DailyDrivingBehavior.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getScore();
    if (f != null) writer.writeMessage(2, f, proto.telematics_service.VehicleScore.serializeBinaryToWriter);
    f = message.getEventRating();
    if (f != null) writer.writeMessage(3, f, proto.telematics_service.EventRating.serializeBinaryToWriter);
};
/**
 * optional string date = 1;
 * @return {string}
 */ proto.telematics_service.DailyDrivingBehavior.prototype.getDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.telematics_service.DailyDrivingBehavior} returns this
 */ proto.telematics_service.DailyDrivingBehavior.prototype.setDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional VehicleScore score = 2;
 * @return {?proto.telematics_service.VehicleScore}
 */ proto.telematics_service.DailyDrivingBehavior.prototype.getScore = function() {
    return /** @type{?proto.telematics_service.VehicleScore} */ $8M67s.Message.getWrapperField(this, proto.telematics_service.VehicleScore, 2);
};
/**
 * @param {?proto.telematics_service.VehicleScore|undefined} value
 * @return {!proto.telematics_service.DailyDrivingBehavior} returns this
*/ proto.telematics_service.DailyDrivingBehavior.prototype.setScore = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.DailyDrivingBehavior} returns this
 */ proto.telematics_service.DailyDrivingBehavior.prototype.clearScore = function() {
    return this.setScore(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.DailyDrivingBehavior.prototype.hasScore = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional EventRating event_rating = 3;
 * @return {?proto.telematics_service.EventRating}
 */ proto.telematics_service.DailyDrivingBehavior.prototype.getEventRating = function() {
    return /** @type{?proto.telematics_service.EventRating} */ $8M67s.Message.getWrapperField(this, proto.telematics_service.EventRating, 3);
};
/**
 * @param {?proto.telematics_service.EventRating|undefined} value
 * @return {!proto.telematics_service.DailyDrivingBehavior} returns this
*/ proto.telematics_service.DailyDrivingBehavior.prototype.setEventRating = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.DailyDrivingBehavior} returns this
 */ proto.telematics_service.DailyDrivingBehavior.prototype.clearEventRating = function() {
    return this.setEventRating(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.DailyDrivingBehavior.prototype.hasEventRating = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.DrivingBehavior.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.DrivingBehavior.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.DrivingBehavior} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.DrivingBehavior.toObject = function(includeInstance, msg) {
        var f, obj = {
            score: (f = msg.getScore()) && proto.telematics_service.VehicleScore.toObject(includeInstance, f),
            eventRating: (f = msg.getEventRating()) && proto.telematics_service.EventRating.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.DrivingBehavior}
 */ proto.telematics_service.DrivingBehavior.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.DrivingBehavior;
    return proto.telematics_service.DrivingBehavior.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.DrivingBehavior} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.DrivingBehavior}
 */ proto.telematics_service.DrivingBehavior.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.telematics_service.VehicleScore;
                reader.readMessage(value, proto.telematics_service.VehicleScore.deserializeBinaryFromReader);
                msg.setScore(value);
                break;
            case 2:
                var value = new proto.telematics_service.EventRating;
                reader.readMessage(value, proto.telematics_service.EventRating.deserializeBinaryFromReader);
                msg.setEventRating(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.DrivingBehavior.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.DrivingBehavior.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.DrivingBehavior} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.DrivingBehavior.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getScore();
    if (f != null) writer.writeMessage(1, f, proto.telematics_service.VehicleScore.serializeBinaryToWriter);
    f = message.getEventRating();
    if (f != null) writer.writeMessage(2, f, proto.telematics_service.EventRating.serializeBinaryToWriter);
};
/**
 * optional VehicleScore score = 1;
 * @return {?proto.telematics_service.VehicleScore}
 */ proto.telematics_service.DrivingBehavior.prototype.getScore = function() {
    return /** @type{?proto.telematics_service.VehicleScore} */ $8M67s.Message.getWrapperField(this, proto.telematics_service.VehicleScore, 1);
};
/**
 * @param {?proto.telematics_service.VehicleScore|undefined} value
 * @return {!proto.telematics_service.DrivingBehavior} returns this
*/ proto.telematics_service.DrivingBehavior.prototype.setScore = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.DrivingBehavior} returns this
 */ proto.telematics_service.DrivingBehavior.prototype.clearScore = function() {
    return this.setScore(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.DrivingBehavior.prototype.hasScore = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional EventRating event_rating = 2;
 * @return {?proto.telematics_service.EventRating}
 */ proto.telematics_service.DrivingBehavior.prototype.getEventRating = function() {
    return /** @type{?proto.telematics_service.EventRating} */ $8M67s.Message.getWrapperField(this, proto.telematics_service.EventRating, 2);
};
/**
 * @param {?proto.telematics_service.EventRating|undefined} value
 * @return {!proto.telematics_service.DrivingBehavior} returns this
*/ proto.telematics_service.DrivingBehavior.prototype.setEventRating = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.DrivingBehavior} returns this
 */ proto.telematics_service.DrivingBehavior.prototype.clearEventRating = function() {
    return this.setEventRating(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.DrivingBehavior.prototype.hasEventRating = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.VehicleScore.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.VehicleScore.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.VehicleScore} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.VehicleScore.toObject = function(includeInstance, msg) {
        var f, obj = {
            zendriveScore: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicles: (f = msg.getVehicles()) && proto.telematics_service.VehicleScore.Vehicles.toObject(includeInstance, f),
            unknownVehicleScore: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.VehicleScore}
 */ proto.telematics_service.VehicleScore.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.VehicleScore;
    return proto.telematics_service.VehicleScore.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.VehicleScore} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.VehicleScore}
 */ proto.telematics_service.VehicleScore.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setZendriveScore(value);
                break;
            case 2:
                var value = new proto.telematics_service.VehicleScore.Vehicles;
                reader.readMessage(value, proto.telematics_service.VehicleScore.Vehicles.deserializeBinaryFromReader);
                msg.setVehicles(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setUnknownVehicleScore(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.VehicleScore.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.VehicleScore.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.VehicleScore} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.VehicleScore.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getZendriveScore();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getVehicles();
    if (f != null) writer.writeMessage(2, f, proto.telematics_service.VehicleScore.Vehicles.serializeBinaryToWriter);
    f = message.getUnknownVehicleScore();
    if (f !== 0) writer.writeInt32(3, f);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.VehicleScore.Vehicles.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.VehicleScore.Vehicles.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.VehicleScore.Vehicles} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.VehicleScore.Vehicles.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicleId1: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicleId2: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.VehicleScore.Vehicles}
 */ proto.telematics_service.VehicleScore.Vehicles.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.VehicleScore.Vehicles;
    return proto.telematics_service.VehicleScore.Vehicles.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.VehicleScore.Vehicles} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.VehicleScore.Vehicles}
 */ proto.telematics_service.VehicleScore.Vehicles.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleId1(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleId2(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.VehicleScore.Vehicles.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.VehicleScore.Vehicles.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.VehicleScore.Vehicles} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.VehicleScore.Vehicles.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicleId1();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getVehicleId2();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * optional int32 vehicle_id_1 = 1;
 * @return {number}
 */ proto.telematics_service.VehicleScore.Vehicles.prototype.getVehicleId1 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.VehicleScore.Vehicles} returns this
 */ proto.telematics_service.VehicleScore.Vehicles.prototype.setVehicleId1 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 vehicle_id_2 = 2;
 * @return {number}
 */ proto.telematics_service.VehicleScore.Vehicles.prototype.getVehicleId2 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.VehicleScore.Vehicles} returns this
 */ proto.telematics_service.VehicleScore.Vehicles.prototype.setVehicleId2 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 zendrive_score = 1;
 * @return {number}
 */ proto.telematics_service.VehicleScore.prototype.getZendriveScore = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.VehicleScore} returns this
 */ proto.telematics_service.VehicleScore.prototype.setZendriveScore = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional Vehicles vehicles = 2;
 * @return {?proto.telematics_service.VehicleScore.Vehicles}
 */ proto.telematics_service.VehicleScore.prototype.getVehicles = function() {
    return /** @type{?proto.telematics_service.VehicleScore.Vehicles} */ $8M67s.Message.getWrapperField(this, proto.telematics_service.VehicleScore.Vehicles, 2);
};
/**
 * @param {?proto.telematics_service.VehicleScore.Vehicles|undefined} value
 * @return {!proto.telematics_service.VehicleScore} returns this
*/ proto.telematics_service.VehicleScore.prototype.setVehicles = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.telematics_service.VehicleScore} returns this
 */ proto.telematics_service.VehicleScore.prototype.clearVehicles = function() {
    return this.setVehicles(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.telematics_service.VehicleScore.prototype.hasVehicles = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional int32 unknown_vehicle_score = 3;
 * @return {number}
 */ proto.telematics_service.VehicleScore.prototype.getUnknownVehicleScore = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.VehicleScore} returns this
 */ proto.telematics_service.VehicleScore.prototype.setUnknownVehicleScore = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.telematics_service.EventRating.prototype.toObject = function(opt_includeInstance) {
        return proto.telematics_service.EventRating.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.telematics_service.EventRating} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.EventRating.toObject = function(includeInstance, msg) {
        var f, obj = {
            hardBrakeRating: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            hardTurnRating: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            rapidAccelerationRating: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            phoneUseRating: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            overspeedingRating: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.telematics_service.EventRating}
 */ proto.telematics_service.EventRating.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.telematics_service.EventRating;
    return proto.telematics_service.EventRating.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.telematics_service.EventRating} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.telematics_service.EventRating}
 */ proto.telematics_service.EventRating.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setHardBrakeRating(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setHardTurnRating(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRapidAccelerationRating(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPhoneUseRating(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setOverspeedingRating(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.telematics_service.EventRating.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.telematics_service.EventRating.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.telematics_service.EventRating} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.telematics_service.EventRating.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getHardBrakeRating();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getHardTurnRating();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getRapidAccelerationRating();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getPhoneUseRating();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getOverspeedingRating();
    if (f !== 0) writer.writeInt32(5, f);
};
/**
 * optional int32 hard_brake_rating = 1;
 * @return {number}
 */ proto.telematics_service.EventRating.prototype.getHardBrakeRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.EventRating} returns this
 */ proto.telematics_service.EventRating.prototype.setHardBrakeRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 hard_turn_rating = 2;
 * @return {number}
 */ proto.telematics_service.EventRating.prototype.getHardTurnRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.EventRating} returns this
 */ proto.telematics_service.EventRating.prototype.setHardTurnRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 rapid_acceleration_rating = 3;
 * @return {number}
 */ proto.telematics_service.EventRating.prototype.getRapidAccelerationRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.EventRating} returns this
 */ proto.telematics_service.EventRating.prototype.setRapidAccelerationRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 phone_use_rating = 4;
 * @return {number}
 */ proto.telematics_service.EventRating.prototype.getPhoneUseRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.EventRating} returns this
 */ proto.telematics_service.EventRating.prototype.setPhoneUseRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 overspeeding_rating = 5;
 * @return {number}
 */ proto.telematics_service.EventRating.prototype.getOverspeedingRating = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.telematics_service.EventRating} returns this
 */ proto.telematics_service.EventRating.prototype.setOverspeedingRating = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
$7975aa205a78f630$var$goog.object.extend(module.exports, proto.telematics_service);

});


parcelRegister("f1q41", function(module, exports) {
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ (function() {
    /** Used as a safe reference for `undefined` in pre-ES5 environments. */ var undefined;
    /** Used as the semantic version number. */ var VERSION = '4.18.1';
    /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
    /** Error message constants. */ var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.', FUNC_ERROR_TEXT = 'Expected a function', INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`', INVALID_TEMPL_IMPORTS_ERROR_TEXT = 'Invalid `imports` option passed into `_.template`';
    /** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
    /** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
    /** Used as the internal argument placeholder. */ var PLACEHOLDER = '__lodash_placeholder__';
    /** Used to compose bitmasks for cloning. */ var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
    /** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
    /** Used to compose bitmasks for function metadata. */ var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
    /** Used as default options for `_.truncate`. */ var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = '...';
    /** Used to detect hot functions by number of calls within a span of milliseconds. */ var HOT_COUNT = 800, HOT_SPAN = 16;
    /** Used to indicate the type of lazy iteratees. */ var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
    /** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 1.7976931348623157e+308, NAN = 0 / 0;
    /** Used as references for the maximum length and index of an array. */ var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    /** Used to associate wrap methods with their bit flags. */ var wrapFlags = [
        [
            'ary',
            WRAP_ARY_FLAG
        ],
        [
            'bind',
            WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            WRAP_FLIP_FLAG
        ],
        [
            'partial',
            WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            WRAP_REARG_FLAG
        ]
    ];
    /** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', asyncTag = '[object AsyncFunction]', boolTag = '[object Boolean]', dateTag = '[object Date]', domExcTag = '[object DOMException]', errorTag = '[object Error]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', mapTag = '[object Map]', numberTag = '[object Number]', nullTag = '[object Null]', objectTag = '[object Object]', promiseTag = '[object Promise]', proxyTag = '[object Proxy]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]', undefinedTag = '[object Undefined]', weakMapTag = '[object WeakMap]', weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
    /** Used to match empty string literals in compiled template source. */ var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    /** Used to match HTML entities and HTML characters. */ var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    /** Used to match template delimiters. */ var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
    /** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
    /** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
    /** Used to match a single whitespace character. */ var reWhitespace = /\s/;
    /** Used to match wrap detail comments. */ var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
    /** Used to match words composed of alphanumeric characters. */ var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */ var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    /** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
    /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */ var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    /** Used to match `RegExp` flags from their coerced string values. */ var reFlags = /\w*$/;
    /** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    /** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
    /** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
    /** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
    /** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
    /** Used to match Latin Unicode letters (excluding mathematical operators). */ var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    /** Used to ensure capturing order of template delimiters. */ var reNoMatch = /($^)/;
    /** Used to match unescaped characters in compiled string literals. */ var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    /** Used to compose unicode character classes. */ var rsAstralRange = '\\ud800-\\udfff', rsComboMarksRange = '\\u0300-\\u036f', reComboHalfMarksRange = '\\ufe20-\\ufe2f', rsComboSymbolsRange = '\\u20d0-\\u20ff', rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = '\\u2700-\\u27bf', rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', rsPunctuationRange = '\\u2000-\\u206f', rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', rsVarRange = '\\ufe0e\\ufe0f', rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    /** Used to compose unicode capture groups. */ var rsApos = "['\u2019]", rsAstral = '[' + rsAstralRange + ']', rsBreak = '[' + rsBreakRange + ']', rsCombo = '[' + rsComboRange + ']', rsDigits = '\\d+', rsDingbat = '[' + rsDingbatRange + ']', rsLower = '[' + rsLowerRange + ']', rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']', rsFitz = '\\ud83c[\\udffb-\\udfff]', rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')', rsNonAstral = '[^' + rsAstralRange + ']', rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', rsUpper = '[' + rsUpperRange + ']', rsZWJ = '\\u200d';
    /** Used to compose unicode regexes. */ var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')', rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')', rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?', rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?', reOptMod = rsModifier + '?', rsOptVar = '[' + rsVarRange + ']?', rsOptJoin = '(?:' + rsZWJ + '(?:' + [
        rsNonAstral,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsOptVar + reOptMod + ')*', rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = '(?:' + [
        rsDingbat,
        rsRegional,
        rsSurrPair
    ].join('|') + ')' + rsSeq, rsSymbol = '(?:' + [
        rsNonAstral + rsCombo + '?',
        rsCombo,
        rsRegional,
        rsSurrPair,
        rsAstral
    ].join('|') + ')';
    /** Used to match apostrophes. */ var reApos = RegExp(rsApos, 'g');
    /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */ var reComboMark = RegExp(rsCombo, 'g');
    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    /** Used to match complex or compound words. */ var reUnicodeWord = RegExp([
        rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [
            rsBreak,
            rsUpper,
            '$'
        ].join('|') + ')',
        rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [
            rsBreak,
            rsUpper + rsMiscLower,
            '$'
        ].join('|') + ')',
        rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
        rsUpper + '+' + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
    ].join('|'), 'g');
    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    /** Used to detect strings that need a more robust regexp to match words. */ var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    /** Used to assign default `context` object properties. */ var contextProps = [
        'Array',
        'Buffer',
        'DataView',
        'Date',
        'Error',
        'Float32Array',
        'Float64Array',
        'Function',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Map',
        'Math',
        'Object',
        'Promise',
        'RegExp',
        'Set',
        'String',
        'Symbol',
        'TypeError',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'WeakMap',
        '_',
        'clearTimeout',
        'isFinite',
        'parseInt',
        'setTimeout'
    ];
    /** Used to make template sourceURLs easier to identify. */ var templateCounter = -1;
    /** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    /** Used to identify `toStringTag` values supported by `_.clone`. */ var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    /** Used to map Latin Unicode letters to basic Latin letters. */ var deburredLetters = {
        // Latin-1 Supplement block.
        '\xc0': 'A',
        '\xc1': 'A',
        '\xc2': 'A',
        '\xc3': 'A',
        '\xc4': 'A',
        '\xc5': 'A',
        '\xe0': 'a',
        '\xe1': 'a',
        '\xe2': 'a',
        '\xe3': 'a',
        '\xe4': 'a',
        '\xe5': 'a',
        '\xc7': 'C',
        '\xe7': 'c',
        '\xd0': 'D',
        '\xf0': 'd',
        '\xc8': 'E',
        '\xc9': 'E',
        '\xca': 'E',
        '\xcb': 'E',
        '\xe8': 'e',
        '\xe9': 'e',
        '\xea': 'e',
        '\xeb': 'e',
        '\xcc': 'I',
        '\xcd': 'I',
        '\xce': 'I',
        '\xcf': 'I',
        '\xec': 'i',
        '\xed': 'i',
        '\xee': 'i',
        '\xef': 'i',
        '\xd1': 'N',
        '\xf1': 'n',
        '\xd2': 'O',
        '\xd3': 'O',
        '\xd4': 'O',
        '\xd5': 'O',
        '\xd6': 'O',
        '\xd8': 'O',
        '\xf2': 'o',
        '\xf3': 'o',
        '\xf4': 'o',
        '\xf5': 'o',
        '\xf6': 'o',
        '\xf8': 'o',
        '\xd9': 'U',
        '\xda': 'U',
        '\xdb': 'U',
        '\xdc': 'U',
        '\xf9': 'u',
        '\xfa': 'u',
        '\xfb': 'u',
        '\xfc': 'u',
        '\xdd': 'Y',
        '\xfd': 'y',
        '\xff': 'y',
        '\xc6': 'Ae',
        '\xe6': 'ae',
        '\xde': 'Th',
        '\xfe': 'th',
        '\xdf': 'ss',
        // Latin Extended-A block.
        '\u0100': 'A',
        '\u0102': 'A',
        '\u0104': 'A',
        '\u0101': 'a',
        '\u0103': 'a',
        '\u0105': 'a',
        '\u0106': 'C',
        '\u0108': 'C',
        '\u010a': 'C',
        '\u010c': 'C',
        '\u0107': 'c',
        '\u0109': 'c',
        '\u010b': 'c',
        '\u010d': 'c',
        '\u010e': 'D',
        '\u0110': 'D',
        '\u010f': 'd',
        '\u0111': 'd',
        '\u0112': 'E',
        '\u0114': 'E',
        '\u0116': 'E',
        '\u0118': 'E',
        '\u011a': 'E',
        '\u0113': 'e',
        '\u0115': 'e',
        '\u0117': 'e',
        '\u0119': 'e',
        '\u011b': 'e',
        '\u011c': 'G',
        '\u011e': 'G',
        '\u0120': 'G',
        '\u0122': 'G',
        '\u011d': 'g',
        '\u011f': 'g',
        '\u0121': 'g',
        '\u0123': 'g',
        '\u0124': 'H',
        '\u0126': 'H',
        '\u0125': 'h',
        '\u0127': 'h',
        '\u0128': 'I',
        '\u012a': 'I',
        '\u012c': 'I',
        '\u012e': 'I',
        '\u0130': 'I',
        '\u0129': 'i',
        '\u012b': 'i',
        '\u012d': 'i',
        '\u012f': 'i',
        '\u0131': 'i',
        '\u0134': 'J',
        '\u0135': 'j',
        '\u0136': 'K',
        '\u0137': 'k',
        '\u0138': 'k',
        '\u0139': 'L',
        '\u013b': 'L',
        '\u013d': 'L',
        '\u013f': 'L',
        '\u0141': 'L',
        '\u013a': 'l',
        '\u013c': 'l',
        '\u013e': 'l',
        '\u0140': 'l',
        '\u0142': 'l',
        '\u0143': 'N',
        '\u0145': 'N',
        '\u0147': 'N',
        '\u014a': 'N',
        '\u0144': 'n',
        '\u0146': 'n',
        '\u0148': 'n',
        '\u014b': 'n',
        '\u014c': 'O',
        '\u014e': 'O',
        '\u0150': 'O',
        '\u014d': 'o',
        '\u014f': 'o',
        '\u0151': 'o',
        '\u0154': 'R',
        '\u0156': 'R',
        '\u0158': 'R',
        '\u0155': 'r',
        '\u0157': 'r',
        '\u0159': 'r',
        '\u015a': 'S',
        '\u015c': 'S',
        '\u015e': 'S',
        '\u0160': 'S',
        '\u015b': 's',
        '\u015d': 's',
        '\u015f': 's',
        '\u0161': 's',
        '\u0162': 'T',
        '\u0164': 'T',
        '\u0166': 'T',
        '\u0163': 't',
        '\u0165': 't',
        '\u0167': 't',
        '\u0168': 'U',
        '\u016a': 'U',
        '\u016c': 'U',
        '\u016e': 'U',
        '\u0170': 'U',
        '\u0172': 'U',
        '\u0169': 'u',
        '\u016b': 'u',
        '\u016d': 'u',
        '\u016f': 'u',
        '\u0171': 'u',
        '\u0173': 'u',
        '\u0174': 'W',
        '\u0175': 'w',
        '\u0176': 'Y',
        '\u0177': 'y',
        '\u0178': 'Y',
        '\u0179': 'Z',
        '\u017b': 'Z',
        '\u017d': 'Z',
        '\u017a': 'z',
        '\u017c': 'z',
        '\u017e': 'z',
        '\u0132': 'IJ',
        '\u0133': 'ij',
        '\u0152': 'Oe',
        '\u0153': 'oe',
        '\u0149': "'n",
        '\u017f': 's'
    };
    /** Used to map characters to HTML entities. */ var htmlEscapes = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    /** Used to map HTML entities to characters. */ var htmlUnescapes = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#39;': "'"
    };
    /** Used to escape characters for inclusion in compiled string literals. */ var stringEscapes = {
        '\\': '\\',
        "'": "'",
        '\n': 'n',
        '\r': 'r',
        '\u2028': 'u2028',
        '\u2029': 'u2029'
    };
    /** Built-in method references without a dependency on `root`. */ var freeParseFloat = parseFloat, freeParseInt = parseInt;
    /** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
    /** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    /** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
    /** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
    /** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
    /** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
    /** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
    /** Used to access faster Node.js helpers. */ var nodeUtil = function() {
        try {
            // Use `util.types` for Node.js 10+.
            var types = freeModule && freeModule.require && freeModule.require('util').types;
            if (types) return types;
            // Legacy `process.binding('util')` for Node.js < 10.
            return freeProcess && freeProcess.binding && freeProcess.binding('util');
        } catch (e) {}
    }();
    /* Node.js helper references. */ var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    /*--------------------------------------------------------------------------*/ /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */ function apply(func, thisArg, args) {
        switch(args.length){
            case 0:
                return func.call(thisArg);
            case 1:
                return func.call(thisArg, args[0]);
            case 2:
                return func.call(thisArg, args[0], args[1]);
            case 3:
                return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
    }
    /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */ function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            var value = array[index];
            setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
    }
    /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (iteratee(array[index], index, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */ function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while(length--){
            if (iteratee(array[length], length, array) === false) break;
        }
        return array;
    }
    /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */ function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (!predicate(array[index], index, array)) return false;
        }
        return true;
    }
    /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */ function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (predicate(value, index, array)) result[resIndex++] = value;
        }
        return result;
    }
    /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
    }
    /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */ function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (comparator(value, array[index])) return true;
        }
        return false;
    }
    /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */ function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while(++index < length)result[index] = iteratee(array[index], index, array);
        return result;
    }
    /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */ function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while(++index < length)array[offset + index] = values[index];
        return array;
    }
    /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[++index];
        while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */ function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) accumulator = array[--length];
        while(length--)accumulator = iteratee(accumulator, array[length], length, array);
        return accumulator;
    }
    /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */ function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while(++index < length){
            if (predicate(array[index], index, array)) return true;
        }
        return false;
    }
    /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ var asciiSize = baseProperty('length');
    /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function asciiToArray(string) {
        return string.split('');
    }
    /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function asciiWords(string) {
        return string.match(reAsciiWord) || [];
    }
    /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */ function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection) {
            if (predicate(value, key, collection)) {
                result = key;
                return false;
            }
        });
        return result;
    }
    /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while(fromRight ? index-- : ++index < length){
            if (predicate(array[index], index, array)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }
    /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (comparator(array[index], value)) return index;
        }
        return -1;
    }
    /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */ function baseIsNaN(value) {
        return value !== value;
    }
    /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */ function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
    }
    /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */ function baseProperty(key) {
        return function(object) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */ function basePropertyOf(object) {
        return function(key) {
            return object == null ? undefined : object[key];
        };
    }
    /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */ function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection) {
            accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
        });
        return accumulator;
    }
    /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */ function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while(length--)array[length] = array[length].value;
        return array;
    }
    /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */ function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */ function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while(++index < n)result[index] = iteratee(index);
        return result;
    }
    /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */ function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
            return [
                key,
                object[key]
            ];
        });
    }
    /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */ function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }
    /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */ function baseUnary(func) {
        return function(value) {
            return func(value);
        };
    }
    /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */ function baseValues(object, props) {
        return arrayMap(props, function(key) {
            return object[key];
        });
    }
    /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */ function cacheHas(cache, key) {
        return cache.has(key);
    }
    /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */ function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */ function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */ function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */ var deburrLetter = basePropertyOf(deburredLetters);
    /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ var escapeHtmlChar = basePropertyOf(htmlEscapes);
    /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */ function escapeStringChar(chr) {
        return '\\' + stringEscapes[chr];
    }
    /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */ function getValue(object, key) {
        return object == null ? undefined : object[key];
    }
    /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */ function hasUnicode(string) {
        return reHasUnicode.test(string);
    }
    /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */ function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
    }
    /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */ function iteratorToArray(iterator) {
        var data, result = [];
        while(!(data = iterator.next()).done)result.push(data.value);
        return result;
    }
    /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */ function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
            result[++index] = [
                key,
                value
            ];
        });
        return result;
    }
    /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function(arg) {
            return func(transform(arg));
        };
    }
    /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */ function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === PLACEHOLDER) {
                array[index] = PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */ function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = value;
        });
        return result;
    }
    /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */ function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
            result[++index] = [
                value,
                value
            ];
        });
        return result;
    }
    /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while(++index < length){
            if (array[index] === value) return index;
        }
        return -1;
    }
    /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */ function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while(index--){
            if (array[index] === value) return index;
        }
        return index;
    }
    /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */ function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }
    /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }
    /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */ function trimmedEndIndex(string) {
        var index = string.length;
        while(index-- && reWhitespace.test(string.charAt(index)));
        return index;
    }
    /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */ var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
    /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */ function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while(reUnicode.test(string))++result;
        return result;
    }
    /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */ function unicodeToArray(string) {
        return string.match(reUnicode) || [];
    }
    /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */ function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
    }
    /*--------------------------------------------------------------------------*/ /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */ var runInContext = function runInContext(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        /** Built-in constructor references. */ var Array1 = context.Array, Date = context.Date, Error = context.Error, Function1 = context.Function, Math = context.Math, Object1 = context.Object, RegExp1 = context.RegExp, String = context.String, TypeError = context.TypeError;
        /** Used for built-in method references. */ var arrayProto = Array1.prototype, funcProto = Function1.prototype, objectProto = Object1.prototype;
        /** Used to detect overreaching core-js shims. */ var coreJsData = context['__core-js_shared__'];
        /** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
        /** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
        /** Used to generate unique IDs. */ var idCounter = 0;
        /** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
            var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
            return uid ? 'Symbol(src)_1.' + uid : '';
        }();
        /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */ var nativeObjectToString = objectProto.toString;
        /** Used to infer the `Object` constructor. */ var objectCtorString = funcToString.call(Object1);
        /** Used to restore the original `_` reference in `_.noConflict`. */ var oldDash = root._;
        /** Used to detect if a method is native. */ var reIsNative = RegExp1('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
        /** Built-in value references. */ var Buffer = moduleExports ? context.Buffer : undefined, Symbol = context.Symbol, Uint8Array = context.Uint8Array, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined, getPrototype = overArg(Object1.getPrototypeOf, Object1), objectCreate = Object1.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined, symIterator = Symbol ? Symbol.iterator : undefined, symToStringTag = Symbol ? Symbol.toStringTag : undefined;
        var defineProperty = function() {
            try {
                var func = getNative(Object1, 'defineProperty');
                func({}, '', {});
                return func;
            } catch (e) {}
        }();
        /** Mocked built-ins. */ var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date && Date.now !== root.Date.now && Date.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        /* Built-in method references for those with the same name as other `lodash` methods. */ var nativeCeil = Math.ceil, nativeFloor = Math.floor, nativeGetSymbols = Object1.getOwnPropertySymbols, nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object1.keys, Object1), nativeMax = Math.max, nativeMin = Math.min, nativeNow = Date.now, nativeParseInt = context.parseInt, nativeRandom = Math.random, nativeReverse = arrayProto.reverse;
        /* Built-in method references that are verified to be native. */ var DataView = getNative(context, 'DataView'), Map = getNative(context, 'Map'), Promise = getNative(context, 'Promise'), Set = getNative(context, 'Set'), WeakMap = getNative(context, 'WeakMap'), nativeCreate = getNative(Object1, 'create');
        /** Used to store function metadata. */ var metaMap = WeakMap && new WeakMap;
        /** Used to lookup unminified function names. */ var realNames = {};
        /** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        /** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */ function lodash(value) {
            if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
                if (value instanceof LodashWrapper) return value;
                if (hasOwnProperty.call(value, '__wrapped__')) return wrapperClone(value);
            }
            return new LodashWrapper(value);
        }
        /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */ var baseCreate = function() {
            function object() {}
            return function(proto) {
                if (!isObject(proto)) return {};
                if (objectCreate) return objectCreate(proto);
                object.prototype = proto;
                var result = new object;
                object.prototype = undefined;
                return result;
            };
        }();
        /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */ function baseLodash() {
        // No operation performed.
        }
        /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */ function LodashWrapper(value, chainAll) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__chain__ = !!chainAll;
            this.__index__ = 0;
            this.__values__ = undefined;
        }
        /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * **Security:** See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md)
     * — `_.template` is insecure and will be removed in v5.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */ lodash.templateSettings = {
            /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'escape': reEscape,
            /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'evaluate': reEvaluate,
            /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */ 'interpolate': reInterpolate,
            /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */ 'variable': '',
            /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */ 'imports': {
                /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */ '_': lodash
            }
        };
        // Ensure wrappers are instances of `baseLodash`.
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */ function LazyWrapper(value) {
            this.__wrapped__ = value;
            this.__actions__ = [];
            this.__dir__ = 1;
            this.__filtered__ = false;
            this.__iteratees__ = [];
            this.__takeCount__ = MAX_ARRAY_LENGTH;
            this.__views__ = [];
        }
        /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */ function lazyClone() {
            var result = new LazyWrapper(this.__wrapped__);
            result.__actions__ = copyArray(this.__actions__);
            result.__dir__ = this.__dir__;
            result.__filtered__ = this.__filtered__;
            result.__iteratees__ = copyArray(this.__iteratees__);
            result.__takeCount__ = this.__takeCount__;
            result.__views__ = copyArray(this.__views__);
            return result;
        }
        /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */ function lazyReverse() {
            if (this.__filtered__) {
                var result = new LazyWrapper(this);
                result.__dir__ = -1;
                result.__filtered__ = true;
            } else {
                result = this.clone();
                result.__dir__ *= -1;
            }
            return result;
        }
        /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */ function lazyValue() {
            var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
            if (!isArr || !isRight && arrLength == length && takeCount == length) return baseWrapperValue(array, this.__actions__);
            var result = [];
            outer: while(length-- && resIndex < takeCount){
                index += dir;
                var iterIndex = -1, value = array[index];
                while(++iterIndex < iterLength){
                    var data = iteratees[iterIndex], iteratee = data.iteratee, type = data.type, computed = iteratee(value);
                    if (type == LAZY_MAP_FLAG) value = computed;
                    else if (!computed) {
                        if (type == LAZY_FILTER_FLAG) continue outer;
                        else break outer;
                    }
                }
                result[resIndex++] = value;
            }
            return result;
        }
        // Ensure `LazyWrapper` is an instance of `baseLodash`.
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        /*------------------------------------------------------------------------*/ /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Hash(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */ function hashClear() {
            this.__data__ = nativeCreate ? nativeCreate(null) : {};
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function hashDelete(key) {
            var result = this.has(key) && delete this.__data__[key];
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function hashGet(key) {
            var data = this.__data__;
            if (nativeCreate) {
                var result = data[key];
                return result === HASH_UNDEFINED ? undefined : result;
            }
            return hasOwnProperty.call(data, key) ? data[key] : undefined;
        }
        /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function hashHas(key) {
            var data = this.__data__;
            return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
        }
        /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */ function hashSet(key, value) {
            var data = this.__data__;
            this.size += this.has(key) ? 0 : 1;
            data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
            return this;
        }
        // Add methods to `Hash`.
        Hash.prototype.clear = hashClear;
        Hash.prototype['delete'] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function ListCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */ function listCacheClear() {
            this.__data__ = [];
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function listCacheDelete(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) return false;
            var lastIndex = data.length - 1;
            if (index == lastIndex) data.pop();
            else splice.call(data, index, 1);
            --this.size;
            return true;
        }
        /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function listCacheGet(key) {
            var data = this.__data__, index = assocIndexOf(data, key);
            return index < 0 ? undefined : data[index][1];
        }
        /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function listCacheHas(key) {
            return assocIndexOf(this.__data__, key) > -1;
        }
        /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */ function listCacheSet(key, value) {
            var data = this.__data__, index = assocIndexOf(data, key);
            if (index < 0) {
                ++this.size;
                data.push([
                    key,
                    value
                ]);
            } else data[index][1] = value;
            return this;
        }
        // Add methods to `ListCache`.
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype['delete'] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function MapCache(entries) {
            var index = -1, length = entries == null ? 0 : entries.length;
            this.clear();
            while(++index < length){
                var entry = entries[index];
                this.set(entry[0], entry[1]);
            }
        }
        /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */ function mapCacheClear() {
            this.size = 0;
            this.__data__ = {
                'hash': new Hash,
                'map': new (Map || ListCache),
                'string': new Hash
            };
        }
        /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function mapCacheDelete(key) {
            var result = getMapData(this, key)['delete'](key);
            this.size -= result ? 1 : 0;
            return result;
        }
        /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function mapCacheGet(key) {
            return getMapData(this, key).get(key);
        }
        /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function mapCacheHas(key) {
            return getMapData(this, key).has(key);
        }
        /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */ function mapCacheSet(key, value) {
            var data = getMapData(this, key), size = data.size;
            data.set(key, value);
            this.size += data.size == size ? 0 : 1;
            return this;
        }
        // Add methods to `MapCache`.
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype['delete'] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        /*------------------------------------------------------------------------*/ /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */ function SetCache(values) {
            var index = -1, length = values == null ? 0 : values.length;
            this.__data__ = new MapCache;
            while(++index < length)this.add(values[index]);
        }
        /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */ function setCacheAdd(value) {
            this.__data__.set(value, HASH_UNDEFINED);
            return this;
        }
        /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     */ function setCacheHas(value) {
            return this.__data__.has(value);
        }
        // Add methods to `SetCache`.
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        /*------------------------------------------------------------------------*/ /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */ function Stack(entries) {
            var data = this.__data__ = new ListCache(entries);
            this.size = data.size;
        }
        /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */ function stackClear() {
            this.__data__ = new ListCache;
            this.size = 0;
        }
        /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */ function stackDelete(key) {
            var data = this.__data__, result = data['delete'](key);
            this.size = data.size;
            return result;
        }
        /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */ function stackGet(key) {
            return this.__data__.get(key);
        }
        /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */ function stackHas(key) {
            return this.__data__.has(key);
        }
        /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */ function stackSet(key, value) {
            var data = this.__data__;
            if (data instanceof ListCache) {
                var pairs = data.__data__;
                if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
                    pairs.push([
                        key,
                        value
                    ]);
                    this.size = ++data.size;
                    return this;
                }
                data = this.__data__ = new MapCache(pairs);
            }
            data.set(key, value);
            this.size = data.size;
            return this;
        }
        // Add methods to `Stack`.
        Stack.prototype.clear = stackClear;
        Stack.prototype['delete'] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */ function arrayLikeKeys(value, inherited) {
            var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
            for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
            isIndex(key, length)))) result.push(key);
            return result;
        }
        /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */ function arraySample(array) {
            var length = array.length;
            return length ? array[baseRandom(0, length - 1)] : undefined;
        }
        /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function arraySampleSize(array, n) {
            return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function arrayShuffle(array) {
            return shuffleSelf(copyArray(array));
        }
        /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignMergeValue(object, key, value) {
            if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function assignValue(object, key, value) {
            var objValue = object[key];
            if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) baseAssignValue(object, key, value);
        }
        /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */ function assocIndexOf(array, key) {
            var length = array.length;
            while(length--){
                if (eq(array[length][0], key)) return length;
            }
            return -1;
        }
        /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */ function baseAggregator(collection, setter, iteratee, accumulator) {
            baseEach(collection, function(value, key, collection) {
                setter(accumulator, value, iteratee(value), collection);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssign(object, source) {
            return object && copyObject(source, keys(source), object);
        }
        /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */ function baseAssignIn(object, source) {
            return object && copyObject(source, keysIn(source), object);
        }
        /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */ function baseAssignValue(object, key, value) {
            if (key == '__proto__' && defineProperty) defineProperty(object, key, {
                'configurable': true,
                'enumerable': true,
                'value': value,
                'writable': true
            });
            else object[key] = value;
        }
        /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */ function baseAt(object, paths) {
            var index = -1, length = paths.length, result = Array1(length), skip = object == null;
            while(++index < length)result[index] = skip ? undefined : get(object, paths[index]);
            return result;
        }
        /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */ function baseClamp(number, lower, upper) {
            if (number === number) {
                if (upper !== undefined) number = number <= upper ? number : upper;
                if (lower !== undefined) number = number >= lower ? number : lower;
            }
            return number;
        }
        /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */ function baseClone(value, bitmask, customizer, key, object, stack) {
            var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
            if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
            if (result !== undefined) return result;
            if (!isObject(value)) return value;
            var isArr = isArray(value);
            if (isArr) {
                result = initCloneArray(value);
                if (!isDeep) return copyArray(value, result);
            } else {
                var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
                if (isBuffer(value)) return cloneBuffer(value, isDeep);
                if (tag == objectTag || tag == argsTag || isFunc && !object) {
                    result = isFlat || isFunc ? {} : initCloneObject(value);
                    if (!isDeep) return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
                } else {
                    if (!cloneableTags[tag]) return object ? value : {};
                    result = initCloneByTag(value, tag, isDeep);
                }
            }
            // Check for circular references and return its corresponding clone.
            stack || (stack = new Stack);
            var stacked = stack.get(value);
            if (stacked) return stacked;
            stack.set(value, result);
            if (isSet(value)) value.forEach(function(subValue) {
                result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
            else if (isMap(value)) value.forEach(function(subValue, key) {
                result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
            var props = isArr ? undefined : keysFunc(value);
            arrayEach(props || value, function(subValue, key) {
                if (props) {
                    key = subValue;
                    subValue = value[key];
                }
                // Recursively populate clone (susceptible to call stack limits).
                assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
            });
            return result;
        }
        /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */ function baseConforms(source) {
            var props = keys(source);
            return function(object) {
                return baseConformsTo(object, source, props);
            };
        }
        /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */ function baseConformsTo(object, source, props) {
            var length = props.length;
            if (object == null) return !length;
            object = Object1(object);
            while(length--){
                var key = props[length], predicate = source[key], value = object[key];
                if (value === undefined && !(key in object) || !predicate(value)) return false;
            }
            return true;
        }
        /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ function baseDelay(func, wait, args) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return setTimeout(function() {
                func.apply(undefined, args);
            }, wait);
        }
        /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */ function baseDifference(array, values, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, isCommon = true, length = array.length, result = [], valuesLength = values.length;
            if (!length) return result;
            if (iteratee) values = arrayMap(values, baseUnary(iteratee));
            if (comparator) {
                includes = arrayIncludesWith;
                isCommon = false;
            } else if (values.length >= LARGE_ARRAY_SIZE) {
                includes = cacheHas;
                isCommon = false;
                values = new SetCache(values);
            }
            outer: while(++index < length){
                var value = array[index], computed = iteratee == null ? value : iteratee(value);
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var valuesIndex = valuesLength;
                    while(valuesIndex--){
                        if (values[valuesIndex] === computed) continue outer;
                    }
                    result.push(value);
                } else if (!includes(values, computed, comparator)) result.push(value);
            }
            return result;
        }
        /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEach = createBaseEach(baseForOwn);
        /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */ var baseEachRight = createBaseEach(baseForOwnRight, true);
        /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */ function baseEvery(collection, predicate) {
            var result = true;
            baseEach(collection, function(value, index, collection) {
                result = !!predicate(value, index, collection);
                return result;
            });
            return result;
        }
        /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */ function baseExtremum(array, iteratee, comparator) {
            var index = -1, length = array.length;
            while(++index < length){
                var value = array[index], current = iteratee(value);
                if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) var computed = current, result = value;
            }
            return result;
        }
        /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */ function baseFill(array, value, start, end) {
            var length = array.length;
            start = toInteger(start);
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end === undefined || end > length ? length : toInteger(end);
            if (end < 0) end += length;
            end = start > end ? 0 : toLength(end);
            while(start < end)array[start++] = value;
            return array;
        }
        /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */ function baseFilter(collection, predicate) {
            var result = [];
            baseEach(collection, function(value, index, collection) {
                if (predicate(value, index, collection)) result.push(value);
            });
            return result;
        }
        /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */ function baseFlatten(array, depth, predicate, isStrict, result) {
            var index = -1, length = array.length;
            predicate || (predicate = isFlattenable);
            result || (result = []);
            while(++index < length){
                var value = array[index];
                if (depth > 0 && predicate(value)) {
                    if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
                    baseFlatten(value, depth - 1, predicate, isStrict, result);
                    else arrayPush(result, value);
                } else if (!isStrict) result[result.length] = value;
            }
            return result;
        }
        /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseFor = createBaseFor();
        /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */ var baseForRight = createBaseFor(true);
        /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwn(object, iteratee) {
            return object && baseFor(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */ function baseForOwnRight(object, iteratee) {
            return object && baseForRight(object, iteratee, keys);
        }
        /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */ function baseFunctions(object, props) {
            return arrayFilter(props, function(key) {
                return isFunction(object[key]);
            });
        }
        /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */ function baseGet(object, path) {
            path = castPath(path, object);
            var index = 0, length = path.length;
            while(object != null && index < length)object = object[toKey(path[index++])];
            return index && index == length ? object : undefined;
        }
        /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
            var result = keysFunc(object);
            return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
        }
        /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ function baseGetTag(value) {
            if (value == null) return value === undefined ? undefinedTag : nullTag;
            return symToStringTag && symToStringTag in Object1(value) ? getRawTag(value) : objectToString(value);
        }
        /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */ function baseGt(value, other) {
            return value > other;
        }
        /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHas(object, key) {
            return object != null && hasOwnProperty.call(object, key);
        }
        /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */ function baseHasIn(object, key) {
            return object != null && key in Object1(object);
        }
        /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */ function baseInRange(number, start, end) {
            return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */ function baseIntersection(arrays, iteratee, comparator) {
            var includes = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array1(othLength), maxLength = Infinity, result = [];
            while(othIndex--){
                var array = arrays[othIndex];
                if (othIndex && iteratee) array = arrayMap(array, baseUnary(iteratee));
                maxLength = nativeMin(array.length, maxLength);
                caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
            }
            array = arrays[0];
            var index = -1, seen = caches[0];
            outer: while(++index < length && result.length < maxLength){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
                    othIndex = othLength;
                    while(--othIndex){
                        var cache = caches[othIndex];
                        if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
                    }
                    if (seen) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */ function baseInverter(object, setter, iteratee, accumulator) {
            baseForOwn(object, function(value, key, object) {
                setter(accumulator, iteratee(value), key, object);
            });
            return accumulator;
        }
        /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */ function baseInvoke(object, path, args) {
            path = castPath(path, object);
            object = parent(object, path);
            var func = object == null ? object : object[toKey(last(path))];
            return func == null ? undefined : apply(func, object, args);
        }
        /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */ function baseIsArguments(value) {
            return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */ function baseIsArrayBuffer(value) {
            return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */ function baseIsDate(value) {
            return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */ function baseIsEqual(value, other, bitmask, customizer, stack) {
            if (value === other) return true;
            if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
            return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
            var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
            objTag = objTag == argsTag ? objectTag : objTag;
            othTag = othTag == argsTag ? objectTag : othTag;
            var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
            if (isSameTag && isBuffer(object)) {
                if (!isBuffer(other)) return false;
                objIsArr = true;
                objIsObj = false;
            }
            if (isSameTag && !objIsObj) {
                stack || (stack = new Stack);
                return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
            }
            if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
                var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
                if (objIsWrapped || othIsWrapped) {
                    var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
                    stack || (stack = new Stack);
                    return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
                }
            }
            if (!isSameTag) return false;
            stack || (stack = new Stack);
            return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */ function baseIsMap(value) {
            return isObjectLike(value) && getTag(value) == mapTag;
        }
        /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */ function baseIsMatch(object, source, matchData, customizer) {
            var index = matchData.length, length = index, noCustomizer = !customizer;
            if (object == null) return !length;
            object = Object1(object);
            while(index--){
                var data = matchData[index];
                if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
            }
            while(++index < length){
                data = matchData[index];
                var key = data[0], objValue = object[key], srcValue = data[1];
                if (noCustomizer && data[2]) {
                    if (objValue === undefined && !(key in object)) return false;
                } else {
                    var stack = new Stack;
                    if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
                    if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
                }
            }
            return true;
        }
        /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */ function baseIsNative(value) {
            if (!isObject(value) || isMasked(value)) return false;
            var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
            return pattern.test(toSource(value));
        }
        /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */ function baseIsRegExp(value) {
            return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */ function baseIsSet(value) {
            return isObjectLike(value) && getTag(value) == setTag;
        }
        /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */ function baseIsTypedArray(value) {
            return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */ function baseIteratee(value) {
            // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
            // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
            if (typeof value == 'function') return value;
            if (value == null) return identity;
            if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
            return property(value);
        }
        /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeys(object) {
            if (!isPrototype(object)) return nativeKeys(object);
            var result = [];
            for(var key in Object1(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function baseKeysIn(object) {
            if (!isObject(object)) return nativeKeysIn(object);
            var isProto = isPrototype(object), result = [];
            for(var key in object)if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) result.push(key);
            return result;
        }
        /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */ function baseLt(value, other) {
            return value < other;
        }
        /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */ function baseMap(collection, iteratee) {
            var index = -1, result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value, key, collection) {
                result[++index] = iteratee(value, key, collection);
            });
            return result;
        }
        /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatches(source) {
            var matchData = getMatchData(source);
            if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
            return function(object) {
                return object === source || baseIsMatch(object, source, matchData);
            };
        }
        /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function baseMatchesProperty(path, srcValue) {
            if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
            return function(object) {
                var objValue = get(object, path);
                return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
            };
        }
        /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMerge(object, source, srcIndex, customizer, stack) {
            if (object === source) return;
            baseFor(source, function(srcValue, key) {
                stack || (stack = new Stack);
                if (isObject(srcValue)) baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
                else {
                    var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
                    if (newValue === undefined) newValue = srcValue;
                    assignMergeValue(object, key, newValue);
                }
            }, keysIn);
        }
        /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */ function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
            var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
            if (stacked) {
                assignMergeValue(object, key, stacked);
                return;
            }
            var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
            var isCommon = newValue === undefined;
            if (isCommon) {
                var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
                newValue = srcValue;
                if (isArr || isBuff || isTyped) {
                    if (isArray(objValue)) newValue = objValue;
                    else if (isArrayLikeObject(objValue)) newValue = copyArray(objValue);
                    else if (isBuff) {
                        isCommon = false;
                        newValue = cloneBuffer(srcValue, true);
                    } else if (isTyped) {
                        isCommon = false;
                        newValue = cloneTypedArray(srcValue, true);
                    } else newValue = [];
                } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
                    newValue = objValue;
                    if (isArguments(objValue)) newValue = toPlainObject(objValue);
                    else if (!isObject(objValue) || isFunction(objValue)) newValue = initCloneObject(srcValue);
                } else isCommon = false;
            }
            if (isCommon) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, newValue);
                mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
                stack['delete'](srcValue);
            }
            assignMergeValue(object, key, newValue);
        }
        /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */ function baseNth(array, n) {
            var length = array.length;
            if (!length) return;
            n += n < 0 ? length : 0;
            return isIndex(n, length) ? array[n] : undefined;
        }
        /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */ function baseOrderBy(collection, iteratees, orders) {
            if (iteratees.length) iteratees = arrayMap(iteratees, function(iteratee) {
                if (isArray(iteratee)) return function(value) {
                    return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
                };
                return iteratee;
            });
            else iteratees = [
                identity
            ];
            var index = -1;
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            var result = baseMap(collection, function(value, key, collection) {
                var criteria = arrayMap(iteratees, function(iteratee) {
                    return iteratee(value);
                });
                return {
                    'criteria': criteria,
                    'index': ++index,
                    'value': value
                };
            });
            return baseSortBy(result, function(object, other) {
                return compareMultiple(object, other, orders);
            });
        }
        /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */ function basePick(object, paths) {
            return basePickBy(object, paths, function(value, path) {
                return hasIn(object, path);
            });
        }
        /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */ function basePickBy(object, paths, predicate) {
            var index = -1, length = paths.length, result = {};
            while(++index < length){
                var path = paths[index], value = baseGet(object, path);
                if (predicate(value, path)) baseSet(result, castPath(path, object), value);
            }
            return result;
        }
        /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */ function basePropertyDeep(path) {
            return function(object) {
                return baseGet(object, path);
            };
        }
        /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */ function basePullAll(array, values, iteratee, comparator) {
            var indexOf = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values.length, seen = array;
            if (array === values) values = copyArray(values);
            if (iteratee) seen = arrayMap(array, baseUnary(iteratee));
            while(++index < length){
                var fromIndex = 0, value = values[index], computed = iteratee ? iteratee(value) : value;
                while((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1){
                    if (seen !== array) splice.call(seen, fromIndex, 1);
                    splice.call(array, fromIndex, 1);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */ function basePullAt(array, indexes) {
            var length = array ? indexes.length : 0, lastIndex = length - 1;
            while(length--){
                var index = indexes[length];
                if (length == lastIndex || index !== previous) {
                    var previous = index;
                    if (isIndex(index)) splice.call(array, index, 1);
                    else baseUnset(array, index);
                }
            }
            return array;
        }
        /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */ function baseRandom(lower, upper) {
            return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */ function baseRange(start, end, step, fromRight) {
            var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result = Array1(length);
            while(length--){
                result[fromRight ? length : ++index] = start;
                start += step;
            }
            return result;
        }
        /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */ function baseRepeat(string, n) {
            var result = '';
            if (!string || n < 1 || n > MAX_SAFE_INTEGER) return result;
            // Leverage the exponentiation by squaring algorithm for a faster repeat.
            // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
            do {
                if (n % 2) result += string;
                n = nativeFloor(n / 2);
                if (n) string += string;
            }while (n);
            return result;
        }
        /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */ function baseRest(func, start) {
            return setToString(overRest(func, start, identity), func + '');
        }
        /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */ function baseSample(collection) {
            return arraySample(values(collection));
        }
        /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */ function baseSampleSize(collection, n) {
            var array = values(collection);
            return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseSet(object, path, value, customizer) {
            if (!isObject(object)) return object;
            path = castPath(path, object);
            var index = -1, length = path.length, lastIndex = length - 1, nested = object;
            while(nested != null && ++index < length){
                var key = toKey(path[index]), newValue = value;
                if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
                if (index != lastIndex) {
                    var objValue = nested[key];
                    newValue = customizer ? customizer(objValue, key, nested) : undefined;
                    if (newValue === undefined) newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
                }
                assignValue(nested, key, newValue);
                nested = nested[key];
            }
            return object;
        }
        /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var baseSetData = !metaMap ? identity : function(func, data) {
            metaMap.set(func, data);
            return func;
        };
        /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var baseSetToString = !defineProperty ? identity : function(func, string) {
            return defineProperty(func, 'toString', {
                'configurable': true,
                'enumerable': false,
                'value': constant(string),
                'writable': true
            });
        };
        /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */ function baseShuffle(collection) {
            return shuffleSelf(values(collection));
        }
        /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function baseSlice(array, start, end) {
            var index = -1, length = array.length;
            if (start < 0) start = -start > length ? 0 : length + start;
            end = end > length ? length : end;
            if (end < 0) end += length;
            length = start > end ? 0 : end - start >>> 0;
            start >>>= 0;
            var result = Array1(length);
            while(++index < length)result[index] = array[index + start];
            return result;
        }
        /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */ function baseSome(collection, predicate) {
            var result;
            baseEach(collection, function(value, index, collection) {
                result = predicate(value, index, collection);
                return !result;
            });
            return !!result;
        }
        /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndex(array, value, retHighest) {
            var low = 0, high = array == null ? low : array.length;
            if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
                while(low < high){
                    var mid = low + high >>> 1, computed = array[mid];
                    if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) low = mid + 1;
                    else high = mid;
                }
                return high;
            }
            return baseSortedIndexBy(array, value, identity, retHighest);
        }
        /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */ function baseSortedIndexBy(array, value, iteratee, retHighest) {
            var low = 0, high = array == null ? 0 : array.length;
            if (high === 0) return 0;
            value = iteratee(value);
            var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined;
            while(low < high){
                var mid = nativeFloor((low + high) / 2), computed = iteratee(array[mid]), othIsDefined = computed !== undefined, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
                if (valIsNaN) var setLow = retHighest || othIsReflexive;
                else if (valIsUndefined) setLow = othIsReflexive && (retHighest || othIsDefined);
                else if (valIsNull) setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
                else if (valIsSymbol) setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
                else if (othIsNull || othIsSymbol) setLow = false;
                else setLow = retHighest ? computed <= value : computed < value;
                if (setLow) low = mid + 1;
                else high = mid;
            }
            return nativeMin(high, MAX_ARRAY_INDEX);
        }
        /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseSortedUniq(array, iteratee) {
            var index = -1, length = array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                if (!index || !eq(computed, seen)) {
                    var seen = computed;
                    result[resIndex++] = value === 0 ? 0 : value;
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */ function baseToNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            return +value;
        }
        /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */ function baseToString(value) {
            // Exit early for strings to avoid a performance hit in some environments.
            if (typeof value == 'string') return value;
            if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
            return arrayMap(value, baseToString) + '';
            if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */ function baseUniq(array, iteratee, comparator) {
            var index = -1, includes = arrayIncludes, length = array.length, isCommon = true, result = [], seen = result;
            if (comparator) {
                isCommon = false;
                includes = arrayIncludesWith;
            } else if (length >= LARGE_ARRAY_SIZE) {
                var set = iteratee ? null : createSet(array);
                if (set) return setToArray(set);
                isCommon = false;
                includes = cacheHas;
                seen = new SetCache;
            } else seen = iteratee ? [] : result;
            outer: while(++index < length){
                var value = array[index], computed = iteratee ? iteratee(value) : value;
                value = comparator || value !== 0 ? value : 0;
                if (isCommon && computed === computed) {
                    var seenIndex = seen.length;
                    while(seenIndex--){
                        if (seen[seenIndex] === computed) continue outer;
                    }
                    if (iteratee) seen.push(computed);
                    result.push(value);
                } else if (!includes(seen, computed, comparator)) {
                    if (seen !== result) seen.push(computed);
                    result.push(value);
                }
            }
            return result;
        }
        /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */ function baseUnset(object, path) {
            path = castPath(path, object);
            // Prevent prototype pollution:
            // https://github.com/lodash/lodash/security/advisories/GHSA-xxjr-mmjv-4gpg
            // https://github.com/lodash/lodash/security/advisories/GHSA-f23m-r3pf-42rh
            var index = -1, length = path.length;
            if (!length) return true;
            while(++index < length){
                var key = toKey(path[index]);
                // Always block "__proto__" anywhere in the path if it's not expected
                if (key === '__proto__' && !hasOwnProperty.call(object, '__proto__')) return false;
                // Block constructor/prototype as non-terminal traversal keys to prevent
                // escaping the object graph into built-in constructors and prototypes.
                if ((key === 'constructor' || key === 'prototype') && index < length - 1) return false;
            }
            var obj = parent(object, path);
            return obj == null || delete obj[toKey(last(path))];
        }
        /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */ function baseUpdate(object, path, updater, customizer) {
            return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */ function baseWhile(array, predicate, isDrop, fromRight) {
            var length = array.length, index = fromRight ? length : -1;
            while((fromRight ? index-- : ++index < length) && predicate(array[index], index, array));
            return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */ function baseWrapperValue(value, actions) {
            var result = value;
            if (result instanceof LazyWrapper) result = result.value();
            return arrayReduce(actions, function(result, action) {
                return action.func.apply(action.thisArg, arrayPush([
                    result
                ], action.args));
            }, result);
        }
        /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */ function baseXor(arrays, iteratee, comparator) {
            var length = arrays.length;
            if (length < 2) return length ? baseUniq(arrays[0]) : [];
            var index = -1, result = Array1(length);
            while(++index < length){
                var array = arrays[index], othIndex = -1;
                while(++othIndex < length)if (othIndex != index) result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
            return baseUniq(baseFlatten(result, 1), iteratee, comparator);
        }
        /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */ function baseZipObject(props, values, assignFunc) {
            var index = -1, length = props.length, valsLength = values.length, result = {};
            while(++index < length){
                var value = index < valsLength ? values[index] : undefined;
                assignFunc(result, props[index], value);
            }
            return result;
        }
        /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */ function castArrayLikeObject(value) {
            return isArrayLikeObject(value) ? value : [];
        }
        /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */ function castFunction(value) {
            return typeof value == 'function' ? value : identity;
        }
        /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */ function castPath(value, object) {
            if (isArray(value)) return value;
            return isKey(value, object) ? [
                value
            ] : stringToPath(toString(value));
        }
        /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ var castRest = baseRest;
        /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */ function castSlice(array, start, end) {
            var length = array.length;
            end = end === undefined ? length : end;
            return !start && end >= length ? array : baseSlice(array, start, end);
        }
        /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */ var clearTimeout = ctxClearTimeout || function(id) {
            return root.clearTimeout(id);
        };
        /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */ function cloneBuffer(buffer, isDeep) {
            if (isDeep) return buffer.slice();
            var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
            buffer.copy(result);
            return result;
        }
        /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */ function cloneArrayBuffer(arrayBuffer) {
            var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
            new Uint8Array(result).set(new Uint8Array(arrayBuffer));
            return result;
        }
        /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */ function cloneDataView(dataView, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
            return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */ function cloneRegExp(regexp) {
            var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
            result.lastIndex = regexp.lastIndex;
            return result;
        }
        /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */ function cloneSymbol(symbol) {
            return symbolValueOf ? Object1(symbolValueOf.call(symbol)) : {};
        }
        /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */ function cloneTypedArray(typedArray, isDeep) {
            var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
            return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */ function compareAscending(value, other) {
            if (value !== other) {
                var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
                var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
                if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
                if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
            }
            return 0;
        }
        /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */ function compareMultiple(object, other, orders) {
            var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
            while(++index < length){
                var result = compareAscending(objCriteria[index], othCriteria[index]);
                if (result) {
                    if (index >= ordersLength) return result;
                    var order = orders[index];
                    return result * (order == 'desc' ? -1 : 1);
                }
            }
            // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
            // that causes it, under certain circumstances, to provide the same value for
            // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
            // for more details.
            //
            // This also ensures a stable sort in V8 and other engines.
            // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
            return object.index - other.index;
        }
        /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgs(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(leftLength + rangeLength), isUncurried = !isCurried;
            while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
            while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
            while(rangeLength--)result[leftIndex++] = args[argsIndex++];
            return result;
        }
        /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */ function composeArgsRight(args, partials, holders, isCurried) {
            var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result = Array1(rangeLength + rightLength), isUncurried = !isCurried;
            while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
            var offset = argsIndex;
            while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
            while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
            return result;
        }
        /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */ function copyArray(source, array) {
            var index = -1, length = source.length;
            array || (array = Array1(length));
            while(++index < length)array[index] = source[index];
            return array;
        }
        /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */ function copyObject(source, props, object, customizer) {
            var isNew = !object;
            object || (object = {});
            var index = -1, length = props.length;
            while(++index < length){
                var key = props[index];
                var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
                if (newValue === undefined) newValue = source[key];
                if (isNew) baseAssignValue(object, key, newValue);
                else assignValue(object, key, newValue);
            }
            return object;
        }
        /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbols(source, object) {
            return copyObject(source, getSymbols(source), object);
        }
        /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */ function copySymbolsIn(source, object) {
            return copyObject(source, getSymbolsIn(source), object);
        }
        /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */ function createAggregator(setter, initializer) {
            return function(collection, iteratee) {
                var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
                return func(collection, setter, getIteratee(iteratee, 2), accumulator);
            };
        }
        /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */ function createAssigner(assigner) {
            return baseRest(function(object, sources) {
                var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
                customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
                if (guard && isIterateeCall(sources[0], sources[1], guard)) {
                    customizer = length < 3 ? undefined : customizer;
                    length = 1;
                }
                object = Object1(object);
                while(++index < length){
                    var source = sources[index];
                    if (source) assigner(object, source, index, customizer);
                }
                return object;
            });
        }
        /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseEach(eachFunc, fromRight) {
            return function(collection, iteratee) {
                if (collection == null) return collection;
                if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
                var length = collection.length, index = fromRight ? length : -1, iterable = Object1(collection);
                while(fromRight ? index-- : ++index < length){
                    if (iteratee(iterable[index], index, iterable) === false) break;
                }
                return collection;
            };
        }
        /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */ function createBaseFor(fromRight) {
            return function(object, iteratee, keysFunc) {
                var index = -1, iterable = Object1(object), props = keysFunc(object), length = props.length;
                while(length--){
                    var key = props[fromRight ? length : ++index];
                    if (iteratee(iterable[key], key, iterable) === false) break;
                }
                return object;
            };
        }
        /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createBind(func, bitmask, thisArg) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return fn.apply(isBind ? thisArg : this, arguments);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */ function createCaseFirst(methodName) {
            return function(string) {
                string = toString(string);
                var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
                var chr = strSymbols ? strSymbols[0] : string.charAt(0);
                var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
                return chr[methodName]() + trailing;
            };
        }
        /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */ function createCompounder(callback) {
            return function(string) {
                return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
            };
        }
        /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */ function createCtor(Ctor) {
            return function() {
                // Use a `switch` statement to work with class constructors. See
                // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
                // for more details.
                var args = arguments;
                switch(args.length){
                    case 0:
                        return new Ctor;
                    case 1:
                        return new Ctor(args[0]);
                    case 2:
                        return new Ctor(args[0], args[1]);
                    case 3:
                        return new Ctor(args[0], args[1], args[2]);
                    case 4:
                        return new Ctor(args[0], args[1], args[2], args[3]);
                    case 5:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                    case 6:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                    case 7:
                        return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
                }
                var thisBinding = baseCreate(Ctor.prototype), result = Ctor.apply(thisBinding, args);
                // Mimic the constructor's `return` behavior.
                // See https://es5.github.io/#x13.2.2 for more details.
                return isObject(result) ? result : thisBinding;
            };
        }
        /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createCurry(func, bitmask, arity) {
            var Ctor = createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length, placeholder = getHolder(wrapper);
                while(index--)args[index] = arguments[index];
                var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
                length -= holders.length;
                if (length < arity) return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
                var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                return apply(fn, this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */ function createFind(findIndexFunc) {
            return function(collection, predicate, fromIndex) {
                var iterable = Object1(collection);
                if (!isArrayLike(collection)) {
                    var iteratee = getIteratee(predicate, 3);
                    collection = keys(collection);
                    predicate = function(key) {
                        return iteratee(iterable[key], key, iterable);
                    };
                }
                var index = findIndexFunc(collection, predicate, fromIndex);
                return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
            };
        }
        /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */ function createFlow(fromRight) {
            return flatRest(function(funcs) {
                var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
                if (fromRight) funcs.reverse();
                while(index--){
                    var func = funcs[index];
                    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                    if (prereq && !wrapper && getFuncName(func) == 'wrapper') var wrapper = new LodashWrapper([], true);
                }
                index = wrapper ? index : length;
                while(++index < length){
                    func = funcs[index];
                    var funcName = getFuncName(func), data = funcName == 'wrapper' ? getData(func) : undefined;
                    if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
                    else wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
                }
                return function() {
                    var args = arguments, value = args[0];
                    if (wrapper && args.length == 1 && isArray(value)) return wrapper.plant(value).value();
                    var index = 0, result = length ? funcs[index].apply(this, args) : value;
                    while(++index < length)result = funcs[index].call(this, result);
                    return result;
                };
            });
        }
        /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
            var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : createCtor(func);
            function wrapper() {
                var length = arguments.length, args = Array1(length), index = length;
                while(index--)args[index] = arguments[index];
                if (isCurried) var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
                if (partials) args = composeArgs(args, partials, holders, isCurried);
                if (partialsRight) args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
                length -= holdersCount;
                if (isCurried && length < arity) {
                    var newHolders = replaceHolders(args, placeholder);
                    return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
                }
                var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
                length = args.length;
                if (argPos) args = reorder(args, argPos);
                else if (isFlip && length > 1) args.reverse();
                if (isAry && ary < length) args.length = ary;
                if (this && this !== root && this instanceof wrapper) fn = Ctor || createCtor(fn);
                return fn.apply(thisBinding, args);
            }
            return wrapper;
        }
        /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */ function createInverter(setter, toIteratee) {
            return function(object, iteratee) {
                return baseInverter(object, setter, toIteratee(iteratee), {});
            };
        }
        /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */ function createMathOperation(operator, defaultValue) {
            return function(value, other) {
                var result;
                if (value === undefined && other === undefined) return defaultValue;
                if (value !== undefined) result = value;
                if (other !== undefined) {
                    if (result === undefined) return other;
                    if (typeof value == 'string' || typeof other == 'string') {
                        value = baseToString(value);
                        other = baseToString(other);
                    } else {
                        value = baseToNumber(value);
                        other = baseToNumber(other);
                    }
                    result = operator(value, other);
                }
                return result;
            };
        }
        /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */ function createOver(arrayFunc) {
            return flatRest(function(iteratees) {
                iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
                return baseRest(function(args) {
                    var thisArg = this;
                    return arrayFunc(iteratees, function(iteratee) {
                        return apply(iteratee, thisArg, args);
                    });
                });
            });
        }
        /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */ function createPadding(length, chars) {
            chars = chars === undefined ? ' ' : baseToString(chars);
            var charsLength = chars.length;
            if (charsLength < 2) return charsLength ? baseRepeat(chars, length) : chars;
            var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
            return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
        }
        /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */ function createPartial(func, bitmask, thisArg, partials) {
            var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
            function wrapper() {
                var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array1(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
                while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
                while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
                return apply(fn, isBind ? thisArg : this, args);
            }
            return wrapper;
        }
        /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */ function createRange(fromRight) {
            return function(start, end, step) {
                if (step && typeof step != 'number' && isIterateeCall(start, end, step)) end = step = undefined;
                // Ensure the sign of `-0` is preserved.
                start = toFinite(start);
                if (end === undefined) {
                    end = start;
                    start = 0;
                } else end = toFinite(end);
                step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
                return baseRange(start, end, step, fromRight);
            };
        }
        /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */ function createRelationalOperation(operator) {
            return function(value, other) {
                if (!(typeof value == 'string' && typeof other == 'string')) {
                    value = toNumber(value);
                    other = toNumber(other);
                }
                return operator(value, other);
            };
        }
        /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
            var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
            bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
            bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
            if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
            var newData = [
                func,
                bitmask,
                thisArg,
                newPartials,
                newHolders,
                newPartialsRight,
                newHoldersRight,
                argPos,
                ary,
                arity
            ];
            var result = wrapFunc.apply(undefined, newData);
            if (isLaziable(func)) setData(result, newData);
            result.placeholder = placeholder;
            return setWrapToString(result, func, bitmask);
        }
        /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */ function createRound(methodName) {
            var func = Math[methodName];
            return function(number, precision) {
                number = toNumber(number);
                precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
                if (precision && nativeIsFinite(number)) {
                    // Shift with exponential notation to avoid floating-point issues.
                    // See [MDN](https://mdn.io/round#Examples) for more details.
                    var pair = (toString(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
                    pair = (toString(value) + 'e').split('e');
                    return +(pair[0] + 'e' + (+pair[1] - precision));
                }
                return func(number);
            };
        }
        /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */ var createSet = !(Set && 1 / setToArray(new Set([
            ,
            -0
        ]))[1] == INFINITY) ? noop : function(values) {
            return new Set(values);
        };
        /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */ function createToPairs(keysFunc) {
            return function(object) {
                var tag = getTag(object);
                if (tag == mapTag) return mapToArray(object);
                if (tag == setTag) return setToPairs(object);
                return baseToPairs(object, keysFunc(object));
            };
        }
        /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */ function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
            var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
            if (!isBindKey && typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var length = partials ? partials.length : 0;
            if (!length) {
                bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
                partials = holders = undefined;
            }
            ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
            arity = arity === undefined ? arity : toInteger(arity);
            length -= holders ? holders.length : 0;
            if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
                var partialsRight = partials, holdersRight = holders;
                partials = holders = undefined;
            }
            var data = isBindKey ? undefined : getData(func);
            var newData = [
                func,
                bitmask,
                thisArg,
                partials,
                holders,
                partialsRight,
                holdersRight,
                argPos,
                ary,
                arity
            ];
            if (data) mergeData(newData, data);
            func = newData[0];
            bitmask = newData[1];
            thisArg = newData[2];
            partials = newData[3];
            holders = newData[4];
            arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
            if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
            if (!bitmask || bitmask == WRAP_BIND_FLAG) var result = createBind(func, bitmask, thisArg);
            else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) result = createCurry(func, bitmask, arity);
            else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) result = createPartial(func, bitmask, thisArg, partials);
            else result = createHybrid.apply(undefined, newData);
            var setter = data ? baseSetData : setData;
            return setWrapToString(setter(result, newData), func, bitmask);
        }
        /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsAssignIn(objValue, srcValue, key, object) {
            if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) return srcValue;
            return objValue;
        }
        /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */ function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
            if (isObject(objValue) && isObject(srcValue)) {
                // Recursively merge objects and arrays (susceptible to call stack limits).
                stack.set(srcValue, objValue);
                baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
                stack['delete'](srcValue);
            }
            return objValue;
        }
        /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */ function customOmitClone(value) {
            return isPlainObject(value) ? undefined : value;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
            if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
            // Check that cyclic values are equal.
            var arrStacked = stack.get(array);
            var othStacked = stack.get(other);
            if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
            var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
            stack.set(array, other);
            stack.set(other, array);
            // Ignore non-index properties.
            while(++index < arrLength){
                var arrValue = array[index], othValue = other[index];
                if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
                if (compared !== undefined) {
                    if (compared) continue;
                    result = false;
                    break;
                }
                // Recursively compare arrays (susceptible to call stack limits).
                if (seen) {
                    if (!arraySome(other, function(othValue, othIndex) {
                        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
                    })) {
                        result = false;
                        break;
                    }
                } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    result = false;
                    break;
                }
            }
            stack['delete'](array);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
            switch(tag){
                case dataViewTag:
                    if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
                    object = object.buffer;
                    other = other.buffer;
                case arrayBufferTag:
                    if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
                    return true;
                case boolTag:
                case dateTag:
                case numberTag:
                    // Coerce booleans to `1` or `0` and dates to milliseconds.
                    // Invalid dates are coerced to `NaN`.
                    return eq(+object, +other);
                case errorTag:
                    return object.name == other.name && object.message == other.message;
                case regexpTag:
                case stringTag:
                    // Coerce regexes to strings and treat strings, primitives and objects,
                    // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
                    // for more details.
                    return object == other + '';
                case mapTag:
                    var convert = mapToArray;
                case setTag:
                    var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
                    convert || (convert = setToArray);
                    if (object.size != other.size && !isPartial) return false;
                    // Assume cyclic values are equal.
                    var stacked = stack.get(object);
                    if (stacked) return stacked == other;
                    bitmask |= COMPARE_UNORDERED_FLAG;
                    // Recursively compare objects (susceptible to call stack limits).
                    stack.set(object, other);
                    var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
                    stack['delete'](object);
                    return result;
                case symbolTag:
                    if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
            return false;
        }
        /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
            if (objLength != othLength && !isPartial) return false;
            var index = objLength;
            while(index--){
                var key = objProps[index];
                if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
            }
            // Check that cyclic values are equal.
            var objStacked = stack.get(object);
            var othStacked = stack.get(other);
            if (objStacked && othStacked) return objStacked == other && othStacked == object;
            var result = true;
            stack.set(object, other);
            stack.set(other, object);
            var skipCtor = isPartial;
            while(++index < objLength){
                key = objProps[index];
                var objValue = object[key], othValue = other[key];
                if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
                // Recursively compare objects (susceptible to call stack limits).
                if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
                    result = false;
                    break;
                }
                skipCtor || (skipCtor = key == 'constructor');
            }
            if (result && !skipCtor) {
                var objCtor = object.constructor, othCtor = other.constructor;
                // Non `Object` object instances with different constructors are not equal.
                if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
            }
            stack['delete'](object);
            stack['delete'](other);
            return result;
        }
        /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */ function flatRest(func) {
            return setToString(overRest(func, undefined, flatten), func + '');
        }
        /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeys(object) {
            return baseGetAllKeys(object, keys, getSymbols);
        }
        /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */ function getAllKeysIn(object) {
            return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */ var getData = !metaMap ? noop : function(func) {
            return metaMap.get(func);
        };
        /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */ function getFuncName(func) {
            var result = func.name + '', array = realNames[result], length = hasOwnProperty.call(realNames, result) ? array.length : 0;
            while(length--){
                var data = array[length], otherFunc = data.func;
                if (otherFunc == null || otherFunc == func) return data.name;
            }
            return result;
        }
        /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */ function getHolder(func) {
            var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
            return object.placeholder;
        }
        /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */ function getIteratee() {
            var result = lodash.iteratee || iteratee;
            result = result === iteratee ? baseIteratee : result;
            return arguments.length ? result(arguments[0], arguments[1]) : result;
        }
        /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */ function getMapData(map, key) {
            var data = map.__data__;
            return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
        }
        /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */ function getMatchData(object) {
            var result = keys(object), length = result.length;
            while(length--){
                var key = result[length], value = object[key];
                result[length] = [
                    key,
                    value,
                    isStrictComparable(value)
                ];
            }
            return result;
        }
        /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */ function getNative(object, key) {
            var value = getValue(object, key);
            return baseIsNative(value) ? value : undefined;
        }
        /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */ function getRawTag(value) {
            var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
            try {
                value[symToStringTag] = undefined;
                var unmasked = true;
            } catch (e) {}
            var result = nativeObjectToString.call(value);
            if (unmasked) {
                if (isOwn) value[symToStringTag] = tag;
                else delete value[symToStringTag];
            }
            return result;
        }
        /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
            if (object == null) return [];
            object = Object1(object);
            return arrayFilter(nativeGetSymbols(object), function(symbol) {
                return propertyIsEnumerable.call(object, symbol);
            });
        };
        /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */ var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
            var result = [];
            while(object){
                arrayPush(result, getSymbols(object));
                object = getPrototype(object);
            }
            return result;
        };
        /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */ var getTag = baseGetTag;
        // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
            var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
            if (ctorString) switch(ctorString){
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
            return result;
        };
        /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */ function getView(start, end, transforms) {
            var index = -1, length = transforms.length;
            while(++index < length){
                var data = transforms[index], size = data.size;
                switch(data.type){
                    case 'drop':
                        start += size;
                        break;
                    case 'dropRight':
                        end -= size;
                        break;
                    case 'take':
                        end = nativeMin(end, start + size);
                        break;
                    case 'takeRight':
                        start = nativeMax(start, end - size);
                        break;
                }
            }
            return {
                'start': start,
                'end': end
            };
        }
        /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */ function getWrapDetails(source) {
            var match = source.match(reWrapDetails);
            return match ? match[1].split(reSplitDetails) : [];
        }
        /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */ function hasPath(object, path, hasFunc) {
            path = castPath(path, object);
            var index = -1, length = path.length, result = false;
            while(++index < length){
                var key = toKey(path[index]);
                if (!(result = object != null && hasFunc(object, key))) break;
                object = object[key];
            }
            if (result || ++index != length) return result;
            length = object == null ? 0 : object.length;
            return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */ function initCloneArray(array) {
            var length = array.length, result = new array.constructor(length);
            // Add properties assigned by `RegExp#exec`.
            if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
                result.index = array.index;
                result.input = array.input;
            }
            return result;
        }
        /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneObject(object) {
            return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */ function initCloneByTag(object, tag, isDeep) {
            var Ctor = object.constructor;
            switch(tag){
                case arrayBufferTag:
                    return cloneArrayBuffer(object);
                case boolTag:
                case dateTag:
                    return new Ctor(+object);
                case dataViewTag:
                    return cloneDataView(object, isDeep);
                case float32Tag:
                case float64Tag:
                case int8Tag:
                case int16Tag:
                case int32Tag:
                case uint8Tag:
                case uint8ClampedTag:
                case uint16Tag:
                case uint32Tag:
                    return cloneTypedArray(object, isDeep);
                case mapTag:
                    return new Ctor;
                case numberTag:
                case stringTag:
                    return new Ctor(object);
                case regexpTag:
                    return cloneRegExp(object);
                case setTag:
                    return new Ctor;
                case symbolTag:
                    return cloneSymbol(object);
            }
        }
        /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */ function insertWrapDetails(source, details) {
            var length = details.length;
            if (!length) return source;
            var lastIndex = length - 1;
            details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
            details = details.join(length > 2 ? ', ' : ' ');
            return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
        }
        /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */ function isFlattenable(value) {
            return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */ function isIndex(value, length) {
            var type = typeof value;
            length = length == null ? MAX_SAFE_INTEGER : length;
            return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
        }
        /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */ function isIterateeCall(value, index, object) {
            if (!isObject(object)) return false;
            var type = typeof index;
            if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) return eq(object[index], value);
            return false;
        }
        /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */ function isKey(value, object) {
            if (isArray(value)) return false;
            var type = typeof value;
            if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
            return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object1(object);
        }
        /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */ function isKeyable(value) {
            var type = typeof value;
            return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
        }
        /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */ function isLaziable(func) {
            var funcName = getFuncName(func), other = lodash[funcName];
            if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) return false;
            if (func === other) return true;
            var data = getData(other);
            return !!data && func === data[0];
        }
        /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */ function isMasked(func) {
            return !!maskSrcKey && maskSrcKey in func;
        }
        /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */ var isMaskable = coreJsData ? isFunction : stubFalse;
        /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */ function isPrototype(value) {
            var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
            return value === proto;
        }
        /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */ function isStrictComparable(value) {
            return value === value && !isObject(value);
        }
        /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */ function matchesStrictComparable(key, srcValue) {
            return function(object) {
                if (object == null) return false;
                return object[key] === srcValue && (srcValue !== undefined || key in Object1(object));
            };
        }
        /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */ function memoizeCapped(func) {
            var result = memoize(func, function(key) {
                if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
                return key;
            });
            var cache = result.cache;
            return result;
        }
        /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */ function mergeData(data, source) {
            var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
            var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
            // Exit early if metadata can't be merged.
            if (!(isCommon || isCombo)) return data;
            // Use source `thisArg` if available.
            if (srcBitmask & WRAP_BIND_FLAG) {
                data[2] = source[2];
                // Set when currying a bound function.
                newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
            }
            // Compose partial arguments.
            var value = source[3];
            if (value) {
                var partials = data[3];
                data[3] = partials ? composeArgs(partials, value, source[4]) : value;
                data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
            }
            // Compose partial right arguments.
            value = source[5];
            if (value) {
                partials = data[5];
                data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
                data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
            }
            // Use source `argPos` if available.
            value = source[7];
            if (value) data[7] = value;
            // Use source `ary` if it's smaller.
            if (srcBitmask & WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
            // Use source `arity` if one is not provided.
            if (data[9] == null) data[9] = source[9];
            // Use source `func` and merge bitmasks.
            data[0] = source[0];
            data[1] = newBitmask;
            return data;
        }
        /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */ function nativeKeysIn(object) {
            var result = [];
            if (object != null) for(var key in Object1(object))result.push(key);
            return result;
        }
        /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */ function objectToString(value) {
            return nativeObjectToString.call(value);
        }
        /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */ function overRest(func, start, transform) {
            start = nativeMax(start === undefined ? func.length - 1 : start, 0);
            return function() {
                var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array1(length);
                while(++index < length)array[index] = args[start + index];
                index = -1;
                var otherArgs = Array1(start + 1);
                while(++index < start)otherArgs[index] = args[index];
                otherArgs[start] = transform(array);
                return apply(func, this, otherArgs);
            };
        }
        /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */ function parent(object, path) {
            return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */ function reorder(array, indexes) {
            var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
            while(length--){
                var index = indexes[length];
                array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
            }
            return array;
        }
        /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */ function safeGet(object, key) {
            if (key === 'constructor' && typeof object[key] === 'function') return;
            if (key == '__proto__') return;
            return object[key];
        }
        /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */ var setData = shortOut(baseSetData);
        /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */ var setTimeout = ctxSetTimeout || function(func, wait) {
            return root.setTimeout(func, wait);
        };
        /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */ var setToString = shortOut(baseSetToString);
        /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */ function setWrapToString(wrapper, reference, bitmask) {
            var source = reference + '';
            return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */ function shortOut(func) {
            var count = 0, lastCalled = 0;
            return function() {
                var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
                lastCalled = stamp;
                if (remaining > 0) {
                    if (++count >= HOT_COUNT) return arguments[0];
                } else count = 0;
                return func.apply(undefined, arguments);
            };
        }
        /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */ function shuffleSelf(array, size) {
            var index = -1, length = array.length, lastIndex = length - 1;
            size = size === undefined ? length : size;
            while(++index < size){
                var rand = baseRandom(index, lastIndex), value = array[rand];
                array[rand] = array[index];
                array[index] = value;
            }
            array.length = size;
            return array;
        }
        /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */ var stringToPath = memoizeCapped(function(string) {
            var result = [];
            if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
            string.replace(rePropName, function(match, number, quote, subString) {
                result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
            });
            return result;
        });
        /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */ function toKey(value) {
            if (typeof value == 'string' || isSymbol(value)) return value;
            var result = value + '';
            return result == '0' && 1 / value == -INFINITY ? '-0' : result;
        }
        /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */ function toSource(func) {
            if (func != null) {
                try {
                    return funcToString.call(func);
                } catch (e) {}
                try {
                    return func + '';
                } catch (e) {}
            }
            return '';
        }
        /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */ function updateWrapDetails(details, bitmask) {
            arrayEach(wrapFlags, function(pair) {
                var value = '_.' + pair[0];
                if (bitmask & pair[1] && !arrayIncludes(details, value)) details.push(value);
            });
            return details.sort();
        }
        /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */ function wrapperClone(wrapper) {
            if (wrapper instanceof LazyWrapper) return wrapper.clone();
            var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
            result.__actions__ = copyArray(wrapper.__actions__);
            result.__index__ = wrapper.__index__;
            result.__values__ = wrapper.__values__;
            return result;
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */ function chunk(array, size, guard) {
            if (guard ? isIterateeCall(array, size, guard) : size === undefined) size = 1;
            else size = nativeMax(toInteger(size), 0);
            var length = array == null ? 0 : array.length;
            if (!length || size < 1) return [];
            var index = 0, resIndex = 0, result = Array1(nativeCeil(length / size));
            while(index < length)result[resIndex++] = baseSlice(array, index, index += size);
            return result;
        }
        /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `-0`, `0n`, `""`, `undefined`, and `NaN` are falsy.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */ function compact(array) {
            var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
            while(++index < length){
                var value = array[index];
                if (value) result[resIndex++] = value;
            }
            return result;
        }
        /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */ function concat() {
            var length = arguments.length;
            if (!length) return [];
            var args = Array1(length - 1), array = arguments[0], index = length;
            while(index--)args[index - 1] = arguments[index];
            return arrayPush(isArray(array) ? copyArray(array) : [
                array
            ], baseFlatten(args, 1));
        }
        /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */ var difference = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var differenceBy = baseRest(function(array, values) {
            var iteratee = last(values);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */ var differenceWith = baseRest(function(array, values) {
            var comparator = last(values);
            if (isArrayLikeObject(comparator)) comparator = undefined;
            return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
        });
        /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function drop(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */ function dropRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */ function dropWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */ function fill(array, value, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
                start = 0;
                end = length;
            }
            return baseFill(array, value, start, end);
        }
        /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */ function findIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */ function findLastIndex(array, predicate, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length - 1;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */ function flatten(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, 1) : [];
        }
        /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */ function flattenDeep(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseFlatten(array, INFINITY) : [];
        }
        /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */ function flattenDepth(array, depth) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(array, depth);
        }
        /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */ function fromPairs(pairs) {
            var index = -1, length = pairs == null ? 0 : pairs.length, result = {};
            while(++index < length){
                var pair = pairs[index];
                baseAssignValue(result, pair[0], pair[1]);
            }
            return result;
        }
        /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */ function head(array) {
            return array && array.length ? array[0] : undefined;
        }
        /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */ function indexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = fromIndex == null ? 0 : toInteger(fromIndex);
            if (index < 0) index = nativeMax(length + index, 0);
            return baseIndexOf(array, value, index);
        }
        /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */ function initial(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 0, -1) : [];
        }
        /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */ var intersection = baseRest(function(arrays) {
            var mapped = arrayMap(arrays, castArrayLikeObject);
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */ var intersectionBy = baseRest(function(arrays) {
            var iteratee = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            if (iteratee === last(mapped)) iteratee = undefined;
            else mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
        });
        /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */ var intersectionWith = baseRest(function(arrays) {
            var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            if (comparator) mapped.pop();
            return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
        });
        /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */ function join(array, separator) {
            return array == null ? '' : nativeJoin.call(array, separator);
        }
        /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */ function last(array) {
            var length = array == null ? 0 : array.length;
            return length ? array[length - 1] : undefined;
        }
        /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */ function lastIndexOf(array, value, fromIndex) {
            var length = array == null ? 0 : array.length;
            if (!length) return -1;
            var index = length;
            if (fromIndex !== undefined) {
                index = toInteger(fromIndex);
                index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
            }
            return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */ function nth(array, n) {
            return array && array.length ? baseNth(array, toInteger(n)) : undefined;
        }
        /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */ var pull = baseRest(pullAll);
        /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */ function pullAll(array, values) {
            return array && array.length && values && values.length ? basePullAll(array, values) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */ function pullAllBy(array, values, iteratee) {
            return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
        }
        /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */ function pullAllWith(array, values, comparator) {
            return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
        }
        /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */ var pullAt = flatRest(function(array, indexes) {
            var length = array == null ? 0 : array.length, result = baseAt(array, indexes);
            basePullAt(array, arrayMap(indexes, function(index) {
                return isIndex(index, length) ? +index : index;
            }).sort(compareAscending));
            return result;
        });
        /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */ function remove(array, predicate) {
            var result = [];
            if (!(array && array.length)) return result;
            var index = -1, indexes = [], length = array.length;
            predicate = getIteratee(predicate, 3);
            while(++index < length){
                var value = array[index];
                if (predicate(value, index, array)) {
                    result.push(value);
                    indexes.push(index);
                }
            }
            basePullAt(array, indexes);
            return result;
        }
        /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function reverse(array) {
            return array == null ? array : nativeReverse.call(array);
        }
        /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */ function slice(array, start, end) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
                start = 0;
                end = length;
            } else {
                start = start == null ? 0 : toInteger(start);
                end = end === undefined ? length : toInteger(end);
            }
            return baseSlice(array, start, end);
        }
        /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */ function sortedIndex(array, value) {
            return baseSortedIndex(array, value);
        }
        /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */ function sortedIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
        }
        /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */ function sortedIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value);
                if (index < length && eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */ function sortedLastIndex(array, value) {
            return baseSortedIndex(array, value, true);
        }
        /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */ function sortedLastIndexBy(array, value, iteratee) {
            return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
        }
        /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */ function sortedLastIndexOf(array, value) {
            var length = array == null ? 0 : array.length;
            if (length) {
                var index = baseSortedIndex(array, value, true) - 1;
                if (eq(array[index], value)) return index;
            }
            return -1;
        }
        /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */ function sortedUniq(array) {
            return array && array.length ? baseSortedUniq(array) : [];
        }
        /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */ function sortedUniqBy(array, iteratee) {
            return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */ function tail(array) {
            var length = array == null ? 0 : array.length;
            return length ? baseSlice(array, 1, length) : [];
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */ function take(array, n, guard) {
            if (!(array && array.length)) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */ function takeRight(array, n, guard) {
            var length = array == null ? 0 : array.length;
            if (!length) return [];
            n = guard || n === undefined ? 1 : toInteger(n);
            n = length - n;
            return baseSlice(array, n < 0 ? 0 : n, length);
        }
        /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */ function takeRightWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */ function takeWhile(array, predicate) {
            return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */ var union = baseRest(function(arrays) {
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ var unionBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var unionWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
        });
        /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */ function uniq(array) {
            return array && array.length ? baseUniq(array) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */ function uniqBy(array, iteratee) {
            return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
        }
        /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */ function uniqWith(array, comparator) {
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return array && array.length ? baseUniq(array, undefined, comparator) : [];
        }
        /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */ function unzip(array) {
            if (!(array && array.length)) return [];
            var length = 0;
            array = arrayFilter(array, function(group) {
                if (isArrayLikeObject(group)) {
                    length = nativeMax(group.length, length);
                    return true;
                }
            });
            return baseTimes(length, function(index) {
                return arrayMap(array, baseProperty(index));
            });
        }
        /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */ function unzipWith(array, iteratee) {
            if (!(array && array.length)) return [];
            var result = unzip(array);
            if (iteratee == null) return result;
            return arrayMap(result, function(group) {
                return apply(iteratee, undefined, group);
            });
        }
        /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */ var without = baseRest(function(array, values) {
            return isArrayLikeObject(array) ? baseDifference(array, values) : [];
        });
        /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */ var xor = baseRest(function(arrays) {
            return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */ var xorBy = baseRest(function(arrays) {
            var iteratee = last(arrays);
            if (isArrayLikeObject(iteratee)) iteratee = undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
        });
        /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */ var xorWith = baseRest(function(arrays) {
            var comparator = last(arrays);
            comparator = typeof comparator == 'function' ? comparator : undefined;
            return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
        });
        /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */ var zip = baseRest(unzip);
        /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */ function zipObject(props, values) {
            return baseZipObject(props || [], values || [], assignValue);
        }
        /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */ function zipObjectDeep(props, values) {
            return baseZipObject(props || [], values || [], baseSet);
        }
        /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */ var zipWith = baseRest(function(arrays) {
            var length = arrays.length, iteratee = length > 1 ? arrays[length - 1] : undefined;
            iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
            return unzipWith(arrays, iteratee);
        });
        /*------------------------------------------------------------------------*/ /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */ function chain(value) {
            var result = lodash(value);
            result.__chain__ = true;
            return result;
        }
        /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */ function tap(value, interceptor) {
            interceptor(value);
            return value;
        }
        /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */ function thru(value, interceptor) {
            return interceptor(value);
        }
        /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */ var wrapperAt = flatRest(function(paths) {
            var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
                return baseAt(object, paths);
            };
            if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) return this.thru(interceptor);
            value = value.slice(start, +start + (length ? 1 : 0));
            value.__actions__.push({
                'func': thru,
                'args': [
                    interceptor
                ],
                'thisArg': undefined
            });
            return new LodashWrapper(value, this.__chain__).thru(function(array) {
                if (length && !array.length) array.push(undefined);
                return array;
            });
        });
        /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */ function wrapperChain() {
            return chain(this);
        }
        /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */ function wrapperCommit() {
            return new LodashWrapper(this.value(), this.__chain__);
        }
        /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */ function wrapperNext() {
            if (this.__values__ === undefined) this.__values__ = toArray(this.value());
            var done = this.__index__ >= this.__values__.length, value = done ? undefined : this.__values__[this.__index__++];
            return {
                'done': done,
                'value': value
            };
        }
        /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */ function wrapperToIterator() {
            return this;
        }
        /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */ function wrapperPlant(value) {
            var result, parent = this;
            while(parent instanceof baseLodash){
                var clone = wrapperClone(parent);
                clone.__index__ = 0;
                clone.__values__ = undefined;
                if (result) previous.__wrapped__ = clone;
                else result = clone;
                var previous = clone;
                parent = parent.__wrapped__;
            }
            previous.__wrapped__ = value;
            return result;
        }
        /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */ function wrapperReverse() {
            var value = this.__wrapped__;
            if (value instanceof LazyWrapper) {
                var wrapped = value;
                if (this.__actions__.length) wrapped = new LazyWrapper(this);
                wrapped = wrapped.reverse();
                wrapped.__actions__.push({
                    'func': thru,
                    'args': [
                        reverse
                    ],
                    'thisArg': undefined
                });
                return new LodashWrapper(wrapped, this.__chain__);
            }
            return this.thru(reverse);
        }
        /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */ function wrapperValue() {
            return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        /*------------------------------------------------------------------------*/ /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */ var countBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) ++result[key];
            else baseAssignValue(result, key, 1);
        });
        /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */ function every(collection, predicate, guard) {
            var func = isArray(collection) ? arrayEvery : baseEvery;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */ function filter(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */ var find = createFind(findIndex);
        /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */ var findLast = createFind(findLastIndex);
        /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMap(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), 1);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */ function flatMapDeep(collection, iteratee) {
            return baseFlatten(map(collection, iteratee), INFINITY);
        }
        /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */ function flatMapDepth(collection, iteratee, depth) {
            depth = depth === undefined ? 1 : toInteger(depth);
            return baseFlatten(map(collection, iteratee), depth);
        }
        /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forEach(collection, iteratee) {
            var func = isArray(collection) ? arrayEach : baseEach;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */ function forEachRight(collection, iteratee) {
            var func = isArray(collection) ? arrayEachRight : baseEachRight;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */ var groupBy = createAggregator(function(result, value, key) {
            if (hasOwnProperty.call(result, key)) result[key].push(value);
            else baseAssignValue(result, key, [
                value
            ]);
        });
        /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */ function includes(collection, value, fromIndex, guard) {
            collection = isArrayLike(collection) ? collection : values(collection);
            fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
            var length = collection.length;
            if (fromIndex < 0) fromIndex = nativeMax(length + fromIndex, 0);
            return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */ var invokeMap = baseRest(function(collection, path, args) {
            var index = -1, isFunc = typeof path == 'function', result = isArrayLike(collection) ? Array1(collection.length) : [];
            baseEach(collection, function(value) {
                result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
            });
            return result;
        });
        /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */ var keyBy = createAggregator(function(result, value, key) {
            baseAssignValue(result, key, value);
        });
        /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */ function map(collection, iteratee) {
            var func = isArray(collection) ? arrayMap : baseMap;
            return func(collection, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */ function orderBy(collection, iteratees, orders, guard) {
            if (collection == null) return [];
            if (!isArray(iteratees)) iteratees = iteratees == null ? [] : [
                iteratees
            ];
            orders = guard ? undefined : orders;
            if (!isArray(orders)) orders = orders == null ? [] : [
                orders
            ];
            return baseOrderBy(collection, iteratees, orders);
        }
        /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */ var partition = createAggregator(function(result, value, key) {
            result[key ? 0 : 1].push(value);
        }, function() {
            return [
                [],
                []
            ];
        });
        /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */ function reduce(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
        }
        /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */ function reduceRight(collection, iteratee, accumulator) {
            var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
            return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
        }
        /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */ function reject(collection, predicate) {
            var func = isArray(collection) ? arrayFilter : baseFilter;
            return func(collection, negate(getIteratee(predicate, 3)));
        }
        /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */ function sample(collection) {
            var func = isArray(collection) ? arraySample : baseSample;
            return func(collection);
        }
        /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */ function sampleSize(collection, n, guard) {
            if (guard ? isIterateeCall(collection, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            var func = isArray(collection) ? arraySampleSize : baseSampleSize;
            return func(collection, n);
        }
        /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */ function shuffle(collection) {
            var func = isArray(collection) ? arrayShuffle : baseShuffle;
            return func(collection);
        }
        /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */ function size(collection) {
            if (collection == null) return 0;
            if (isArrayLike(collection)) return isString(collection) ? stringSize(collection) : collection.length;
            var tag = getTag(collection);
            if (tag == mapTag || tag == setTag) return collection.size;
            return baseKeys(collection).length;
        }
        /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */ function some(collection, predicate, guard) {
            var func = isArray(collection) ? arraySome : baseSome;
            if (guard && isIterateeCall(collection, predicate, guard)) predicate = undefined;
            return func(collection, getIteratee(predicate, 3));
        }
        /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */ var sortBy = baseRest(function(collection, iteratees) {
            if (collection == null) return [];
            var length = iteratees.length;
            if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) iteratees = [];
            else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
                iteratees[0]
            ];
            return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        /*------------------------------------------------------------------------*/ /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */ var now = ctxNow || function() {
            return root.Date.now();
        };
        /*------------------------------------------------------------------------*/ /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */ function after(n, func) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n < 1) return func.apply(this, arguments);
            };
        }
        /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */ function ary(func, n, guard) {
            n = guard ? undefined : n;
            n = func && n == null ? func.length : n;
            return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
        }
        /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */ function before(n, func) {
            var result;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            n = toInteger(n);
            return function() {
                if (--n > 0) result = func.apply(this, arguments);
                if (n <= 1) func = undefined;
                return result;
            };
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */ var bind = baseRest(function(func, thisArg, partials) {
            var bitmask = WRAP_BIND_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bind));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(func, bitmask, thisArg, partials, holders);
        });
        /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */ var bindKey = baseRest(function(object, key, partials) {
            var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
            if (partials.length) {
                var holders = replaceHolders(partials, getHolder(bindKey));
                bitmask |= WRAP_PARTIAL_FLAG;
            }
            return createWrap(key, bitmask, object, partials, holders);
        });
        /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */ function curry(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curry.placeholder;
            return result;
        }
        /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */ function curryRight(func, arity, guard) {
            arity = guard ? undefined : arity;
            var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
            result.placeholder = curryRight.placeholder;
            return result;
        }
        /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */ function debounce(func, wait, options) {
            var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            wait = toNumber(wait) || 0;
            if (isObject(options)) {
                leading = !!options.leading;
                maxing = 'maxWait' in options;
                maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            function invokeFunc(time) {
                var args = lastArgs, thisArg = lastThis;
                lastArgs = lastThis = undefined;
                lastInvokeTime = time;
                result = func.apply(thisArg, args);
                return result;
            }
            function leadingEdge(time) {
                // Reset any `maxWait` timer.
                lastInvokeTime = time;
                // Start the timer for the trailing edge.
                timerId = setTimeout(timerExpired, wait);
                // Invoke the leading edge.
                return leading ? invokeFunc(time) : result;
            }
            function remainingWait(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
                return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
            }
            function shouldInvoke(time) {
                var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
                // Either this is the first call, activity has stopped and we're at the
                // trailing edge, the system time has gone backwards and we're treating
                // it as the trailing edge, or we've hit the `maxWait` limit.
                return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
            }
            function timerExpired() {
                var time = now();
                if (shouldInvoke(time)) return trailingEdge(time);
                // Restart the timer.
                timerId = setTimeout(timerExpired, remainingWait(time));
            }
            function trailingEdge(time) {
                timerId = undefined;
                // Only invoke if we have `lastArgs` which means `func` has been
                // debounced at least once.
                if (trailing && lastArgs) return invokeFunc(time);
                lastArgs = lastThis = undefined;
                return result;
            }
            function cancel() {
                if (timerId !== undefined) clearTimeout(timerId);
                lastInvokeTime = 0;
                lastArgs = lastCallTime = lastThis = timerId = undefined;
            }
            function flush() {
                return timerId === undefined ? result : trailingEdge(now());
            }
            function debounced() {
                var time = now(), isInvoking = shouldInvoke(time);
                lastArgs = arguments;
                lastThis = this;
                lastCallTime = time;
                if (isInvoking) {
                    if (timerId === undefined) return leadingEdge(lastCallTime);
                    if (maxing) {
                        // Handle invocations in a tight loop.
                        clearTimeout(timerId);
                        timerId = setTimeout(timerExpired, wait);
                        return invokeFunc(lastCallTime);
                    }
                }
                if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
                return result;
            }
            debounced.cancel = cancel;
            debounced.flush = flush;
            return debounced;
        }
        /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */ var defer = baseRest(function(func, args) {
            return baseDelay(func, 1, args);
        });
        /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */ var delay = baseRest(function(func, wait, args) {
            return baseDelay(func, toNumber(wait) || 0, args);
        });
        /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */ function flip(func) {
            return createWrap(func, WRAP_FLIP_FLAG);
        }
        /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */ function memoize(func, resolver) {
            if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            var memoized = function() {
                var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
                if (cache.has(key)) return cache.get(key);
                var result = func.apply(this, args);
                memoized.cache = cache.set(key, result) || cache;
                return result;
            };
            memoized.cache = new (memoize.Cache || MapCache);
            return memoized;
        }
        // Expose `MapCache`.
        memoize.Cache = MapCache;
        /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */ function negate(predicate) {
            if (typeof predicate != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            return function() {
                var args = arguments;
                switch(args.length){
                    case 0:
                        return !predicate.call(this);
                    case 1:
                        return !predicate.call(this, args[0]);
                    case 2:
                        return !predicate.call(this, args[0], args[1]);
                    case 3:
                        return !predicate.call(this, args[0], args[1], args[2]);
                }
                return !predicate.apply(this, args);
            };
        }
        /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */ function once(func) {
            return before(2, func);
        }
        /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */ var overArgs = castRest(function(func, transforms) {
            transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
            var funcsLength = transforms.length;
            return baseRest(function(args) {
                var index = -1, length = nativeMin(args.length, funcsLength);
                while(++index < length)args[index] = transforms[index].call(this, args[index]);
                return apply(func, this, args);
            });
        });
        /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */ var partial = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partial));
            return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
        });
        /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */ var partialRight = baseRest(function(func, partials) {
            var holders = replaceHolders(partials, getHolder(partialRight));
            return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
        });
        /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */ var rearg = flatRest(function(func, indexes) {
            return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
        });
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */ function rest(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start === undefined ? start : toInteger(start);
            return baseRest(func, start);
        }
        /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */ function spread(func, start) {
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            start = start == null ? 0 : nativeMax(toInteger(start), 0);
            return baseRest(function(args) {
                var array = args[start], otherArgs = castSlice(args, 0, start);
                if (array) arrayPush(otherArgs, array);
                return apply(func, this, otherArgs);
            });
        }
        /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */ function throttle(func, wait, options) {
            var leading = true, trailing = true;
            if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
            if (isObject(options)) {
                leading = 'leading' in options ? !!options.leading : leading;
                trailing = 'trailing' in options ? !!options.trailing : trailing;
            }
            return debounce(func, wait, {
                'leading': leading,
                'maxWait': wait,
                'trailing': trailing
            });
        }
        /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */ function unary(func) {
            return ary(func, 1);
        }
        /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */ function wrap(value, wrapper) {
            return partial(castFunction(wrapper), value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */ function castArray() {
            if (!arguments.length) return [];
            var value = arguments[0];
            return isArray(value) ? value : [
                value
            ];
        }
        /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */ function clone(value) {
            return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */ function cloneWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */ function cloneDeep(value) {
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */ function cloneDeepWith(value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */ function conformsTo(object, source) {
            return source == null || baseConformsTo(object, source, keys(source));
        }
        /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */ function eq(value, other) {
            return value === other || value !== value && other !== other;
        }
        /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */ var gt = createRelationalOperation(baseGt);
        /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */ var gte = createRelationalOperation(function(value, other) {
            return value >= other;
        });
        /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */ var isArguments = baseIsArguments(function() {
            return arguments;
        }()) ? baseIsArguments : function(value) {
            return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
        };
        /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */ var isArray = Array1.isArray;
        /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */ var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */ function isArrayLike(value) {
            return value != null && isLength(value.length) && !isFunction(value);
        }
        /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */ function isArrayLikeObject(value) {
            return isObjectLike(value) && isArrayLike(value);
        }
        /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */ function isBoolean(value) {
            return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */ var isBuffer = nativeIsBuffer || stubFalse;
        /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */ var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */ function isElement(value) {
            return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */ function isEmpty(value) {
            if (value == null) return true;
            if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) return !value.length;
            var tag = getTag(value);
            if (tag == mapTag || tag == setTag) return !value.size;
            if (isPrototype(value)) return !baseKeys(value).length;
            for(var key in value){
                if (hasOwnProperty.call(value, key)) return false;
            }
            return true;
        }
        /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */ function isEqual(value, other) {
            return baseIsEqual(value, other);
        }
        /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */ function isEqualWith(value, other, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            var result = customizer ? customizer(value, other) : undefined;
            return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
        }
        /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */ function isError(value) {
            if (!isObjectLike(value)) return false;
            var tag = baseGetTag(value);
            return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
        }
        /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */ function isFinite(value) {
            return typeof value == 'number' && nativeIsFinite(value);
        }
        /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */ function isFunction(value) {
            if (!isObject(value)) return false;
            // The use of `Object#toString` avoids issues with the `typeof` operator
            // in Safari 9 which returns 'object' for typed arrays and other constructors.
            var tag = baseGetTag(value);
            return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */ function isInteger(value) {
            return typeof value == 'number' && value == toInteger(value);
        }
        /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */ function isLength(value) {
            return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */ function isObject(value) {
            var type = typeof value;
            return value != null && (type == 'object' || type == 'function');
        }
        /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */ function isObjectLike(value) {
            return value != null && typeof value == 'object';
        }
        /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */ var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */ function isMatch(object, source) {
            return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */ function isMatchWith(object, source, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */ function isNaN(value) {
            // An `NaN` primitive is the only value that is not equal to itself.
            // Perform the `toStringTag` check first to avoid errors with some
            // ActiveX objects in IE.
            return isNumber(value) && value != +value;
        }
        /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */ function isNative(value) {
            if (isMaskable(value)) throw new Error(CORE_ERROR_TEXT);
            return baseIsNative(value);
        }
        /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */ function isNull(value) {
            return value === null;
        }
        /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */ function isNil(value) {
            return value == null;
        }
        /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */ function isNumber(value) {
            return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */ function isPlainObject(value) {
            if (!isObjectLike(value) || baseGetTag(value) != objectTag) return false;
            var proto = getPrototype(value);
            if (proto === null) return true;
            var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
            return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */ var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */ function isSafeInteger(value) {
            return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */ var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */ function isString(value) {
            return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */ function isSymbol(value) {
            return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */ function isUndefined(value) {
            return value === undefined;
        }
        /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */ function isWeakMap(value) {
            return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */ function isWeakSet(value) {
            return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */ var lt = createRelationalOperation(baseLt);
        /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */ var lte = createRelationalOperation(function(value, other) {
            return value <= other;
        });
        /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */ function toArray(value) {
            if (!value) return [];
            if (isArrayLike(value)) return isString(value) ? stringToArray(value) : copyArray(value);
            if (symIterator && value[symIterator]) return iteratorToArray(value[symIterator]());
            var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
            return func(value);
        }
        /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */ function toFinite(value) {
            if (!value) return value === 0 ? value : 0;
            value = toNumber(value);
            if (value === INFINITY || value === -INFINITY) {
                var sign = value < 0 ? -1 : 1;
                return sign * MAX_INTEGER;
            }
            return value === value ? value : 0;
        }
        /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */ function toInteger(value) {
            var result = toFinite(value), remainder = result % 1;
            return result === result ? remainder ? result - remainder : result : 0;
        }
        /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */ function toLength(value) {
            return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */ function toNumber(value) {
            if (typeof value == 'number') return value;
            if (isSymbol(value)) return NAN;
            if (isObject(value)) {
                var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
                value = isObject(other) ? other + '' : other;
            }
            if (typeof value != 'string') return value === 0 ? value : +value;
            value = baseTrim(value);
            var isBinary = reIsBinary.test(value);
            return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */ function toPlainObject(value) {
            return copyObject(value, keysIn(value));
        }
        /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */ function toSafeInteger(value) {
            return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */ function toString(value) {
            return value == null ? '' : baseToString(value);
        }
        /*------------------------------------------------------------------------*/ /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */ var assign = createAssigner(function(object, source) {
            if (isPrototype(source) || isArrayLike(source)) {
                copyObject(source, keys(source), object);
                return;
            }
            for(var key in source)if (hasOwnProperty.call(source, key)) assignValue(object, key, source[key]);
        });
        /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */ var assignIn = createAssigner(function(object, source) {
            copyObject(source, keysIn(source), object);
        });
        /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keysIn(source), object, customizer);
        });
        /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
            copyObject(source, keys(source), object, customizer);
        });
        /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */ var at = flatRest(baseAt);
        /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */ function create(prototype, properties) {
            var result = baseCreate(prototype);
            return properties == null ? result : baseAssign(result, properties);
        }
        /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */ var defaults = baseRest(function(object, sources) {
            object = Object1(object);
            var index = -1;
            var length = sources.length;
            var guard = length > 2 ? sources[2] : undefined;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) length = 1;
            while(++index < length){
                var source = sources[index];
                var props = keysIn(source);
                var propsIndex = -1;
                var propsLength = props.length;
                while(++propsIndex < propsLength){
                    var key = props[propsIndex];
                    var value = object[key];
                    if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) object[key] = source[key];
                }
            }
            return object;
        });
        /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */ var defaultsDeep = baseRest(function(args) {
            args.push(undefined, customDefaultsMerge);
            return apply(mergeWith, undefined, args);
        });
        /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */ function findKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */ function findLastKey(object, predicate) {
            return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */ function forIn(object, iteratee) {
            return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */ function forInRight(object, iteratee) {
            return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
        }
        /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */ function forOwn(object, iteratee) {
            return object && baseForOwn(object, getIteratee(iteratee, 3));
        }
        /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */ function forOwnRight(object, iteratee) {
            return object && baseForOwnRight(object, getIteratee(iteratee, 3));
        }
        /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */ function functions(object) {
            return object == null ? [] : baseFunctions(object, keys(object));
        }
        /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */ function functionsIn(object) {
            return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */ function get(object, path, defaultValue) {
            var result = object == null ? undefined : baseGet(object, path);
            return result === undefined ? defaultValue : result;
        }
        /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */ function has(object, path) {
            return object != null && hasPath(object, path, baseHas);
        }
        /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */ function hasIn(object, path) {
            return object != null && hasPath(object, path, baseHasIn);
        }
        /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */ var invert = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            result[value] = key;
        }, constant(identity));
        /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */ var invertBy = createInverter(function(result, value, key) {
            if (value != null && typeof value.toString != 'function') value = nativeObjectToString.call(value);
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }, getIteratee);
        /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */ var invoke = baseRest(baseInvoke);
        /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */ function keys(object) {
            return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */ function keysIn(object) {
            return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */ function mapKeys(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, iteratee(value, key, object), value);
            });
            return result;
        }
        /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */ function mapValues(object, iteratee) {
            var result = {};
            iteratee = getIteratee(iteratee, 3);
            baseForOwn(object, function(value, key, object) {
                baseAssignValue(result, key, iteratee(value, key, object));
            });
            return result;
        }
        /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */ var merge = createAssigner(function(object, source, srcIndex) {
            baseMerge(object, source, srcIndex);
        });
        /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */ var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
            baseMerge(object, source, srcIndex, customizer);
        });
        /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */ var omit = flatRest(function(object, paths) {
            var result = {};
            if (object == null) return result;
            var isDeep = false;
            paths = arrayMap(paths, function(path) {
                path = castPath(path, object);
                isDeep || (isDeep = path.length > 1);
                return path;
            });
            copyObject(object, getAllKeysIn(object), result);
            if (isDeep) result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
            var length = paths.length;
            while(length--)baseUnset(result, paths[length]);
            return result;
        });
        /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */ function omitBy(object, predicate) {
            return pickBy(object, negate(getIteratee(predicate)));
        }
        /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */ var pick = flatRest(function(object, paths) {
            return object == null ? {} : basePick(object, paths);
        });
        /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */ function pickBy(object, predicate) {
            if (object == null) return {};
            var props = arrayMap(getAllKeysIn(object), function(prop) {
                return [
                    prop
                ];
            });
            predicate = getIteratee(predicate);
            return basePickBy(object, props, function(value, path) {
                return predicate(value, path[0]);
            });
        }
        /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */ function result(object, path, defaultValue) {
            path = castPath(path, object);
            var index = -1, length = path.length;
            // Ensure the loop is entered when path is empty.
            if (!length) {
                length = 1;
                object = undefined;
            }
            while(++index < length){
                var value = object == null ? undefined : object[toKey(path[index])];
                if (value === undefined) {
                    index = length;
                    value = defaultValue;
                }
                object = isFunction(value) ? value.call(object) : value;
            }
            return object;
        }
        /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */ function set(object, path, value) {
            return object == null ? object : baseSet(object, path, value);
        }
        /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */ function setWith(object, path, value, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseSet(object, path, value, customizer);
        }
        /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */ var toPairs = createToPairs(keys);
        /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */ var toPairsIn = createToPairs(keysIn);
        /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */ function transform(object, iteratee, accumulator) {
            var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
            iteratee = getIteratee(iteratee, 4);
            if (accumulator == null) {
                var Ctor = object && object.constructor;
                if (isArrLike) accumulator = isArr ? new Ctor : [];
                else if (isObject(object)) accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
                else accumulator = {};
            }
            (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
                return iteratee(accumulator, value, index, object);
            });
            return accumulator;
        }
        /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */ function unset(object, path) {
            return object == null ? true : baseUnset(object, path);
        }
        /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */ function update(object, path, updater) {
            return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */ function updateWith(object, path, updater, customizer) {
            customizer = typeof customizer == 'function' ? customizer : undefined;
            return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */ function values(object) {
            return object == null ? [] : baseValues(object, keys(object));
        }
        /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */ function valuesIn(object) {
            return object == null ? [] : baseValues(object, keysIn(object));
        }
        /*------------------------------------------------------------------------*/ /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */ function clamp(number, lower, upper) {
            if (upper === undefined) {
                upper = lower;
                lower = undefined;
            }
            if (upper !== undefined) {
                upper = toNumber(upper);
                upper = upper === upper ? upper : 0;
            }
            if (lower !== undefined) {
                lower = toNumber(lower);
                lower = lower === lower ? lower : 0;
            }
            return baseClamp(toNumber(number), lower, upper);
        }
        /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */ function inRange(number, start, end) {
            start = toFinite(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = toFinite(end);
            number = toNumber(number);
            return baseInRange(number, start, end);
        }
        /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * **Note:** If `lower` is greater than `upper`, the values are swapped.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * // when lower is greater than upper the values are swapped
     * _.random(5, 0);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(-5);
     * // => an integer between -5 and 0
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */ function random(lower, upper, floating) {
            if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) upper = floating = undefined;
            if (floating === undefined) {
                if (typeof upper == 'boolean') {
                    floating = upper;
                    upper = undefined;
                } else if (typeof lower == 'boolean') {
                    floating = lower;
                    lower = undefined;
                }
            }
            if (lower === undefined && upper === undefined) {
                lower = 0;
                upper = 1;
            } else {
                lower = toFinite(lower);
                if (upper === undefined) {
                    upper = lower;
                    lower = 0;
                } else upper = toFinite(upper);
            }
            if (lower > upper) {
                var temp = lower;
                lower = upper;
                upper = temp;
            }
            if (floating || lower % 1 || upper % 1) {
                var rand = nativeRandom();
                return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
            }
            return baseRandom(lower, upper);
        }
        /*------------------------------------------------------------------------*/ /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */ var camelCase = createCompounder(function(result, word, index) {
            word = word.toLowerCase();
            return result + (index ? capitalize(word) : word);
        });
        /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */ function capitalize(string) {
            return upperFirst(toString(string).toLowerCase());
        }
        /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */ function deburr(string) {
            string = toString(string);
            return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
        }
        /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */ function endsWith(string, target, position) {
            string = toString(string);
            target = baseToString(target);
            var length = string.length;
            position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
            var end = position;
            position -= target.length;
            return position >= 0 && string.slice(position, end) == target;
        }
        /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */ function escape(string) {
            string = toString(string);
            return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */ function escapeRegExp(string) {
            string = toString(string);
            return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
        }
        /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */ var kebabCase = createCompounder(function(result, word, index) {
            return result + (index ? '-' : '') + word.toLowerCase();
        });
        /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */ var lowerCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toLowerCase();
        });
        /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */ var lowerFirst = createCaseFirst('toLowerCase');
        /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */ function pad(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            if (!length || strLength >= length) return string;
            var mid = (length - strLength) / 2;
            return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */ function padEnd(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */ function padStart(string, length, chars) {
            string = toString(string);
            length = toInteger(length);
            var strLength = length ? stringSize(string) : 0;
            return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */ function parseInt1(string, radix, guard) {
            if (guard || radix == null) radix = 0;
            else if (radix) radix = +radix;
            return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
        }
        /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */ function repeat(string, n, guard) {
            if (guard ? isIterateeCall(string, n, guard) : n === undefined) n = 1;
            else n = toInteger(n);
            return baseRepeat(toString(string), n);
        }
        /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */ function replace() {
            var args = arguments, string = toString(args[0]);
            return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */ var snakeCase = createCompounder(function(result, word, index) {
            return result + (index ? '_' : '') + word.toLowerCase();
        });
        /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */ function split(string, separator, limit) {
            if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) separator = limit = undefined;
            limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
            if (!limit) return [];
            string = toString(string);
            if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
                separator = baseToString(separator);
                if (!separator && hasUnicode(string)) return castSlice(stringToArray(string), 0, limit);
            }
            return string.split(separator, limit);
        }
        /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */ var startCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + upperFirst(word);
        });
        /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */ function startsWith(string, target, position) {
            string = toString(string);
            position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
            target = baseToString(target);
            return string.slice(position, position + target.length) == target;
        }
        /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Security:** `_.template` is insecure and should not be used. It will be
     * removed in Lodash v5. Avoid untrusted input. See
     * [threat model](https://github.com/lodash/lodash/blob/main/threat-model.md).
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */ function template(string, options, guard) {
            // Based on John Resig's `tmpl` implementation
            // (http://ejohn.org/blog/javascript-micro-templating/)
            // and Laura Doktorova's doT.js (https://github.com/olado/doT).
            var settings = lodash.templateSettings;
            if (guard && isIterateeCall(string, options, guard)) options = undefined;
            string = toString(string);
            options = assignWith({}, options, settings, customDefaultsAssignIn);
            var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
            arrayEach(importsKeys, function(key) {
                if (reForbiddenIdentifierChars.test(key)) throw new Error(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            });
            var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
            // Compile the regexp to match each delimiter.
            var reDelimiters = RegExp1((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
            // Use a sourceURL for easier debugging.
            // The sourceURL gets injected into the source that's eval-ed, so be careful
            // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
            // and escape the comment, thus injecting code that gets evaled.
            var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
            string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
                interpolateValue || (interpolateValue = esTemplateValue);
                // Escape characters that can't be included in string literals.
                source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
                // Replace delimiters with snippets.
                if (escapeValue) {
                    isEscaping = true;
                    source += "' +\n__e(" + escapeValue + ") +\n'";
                }
                if (evaluateValue) {
                    isEvaluating = true;
                    source += "';\n" + evaluateValue + ";\n__p += '";
                }
                if (interpolateValue) source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
                index = offset + match.length;
                // The JS engine embedded in Adobe products needs `match` returned in
                // order to produce the correct `offset` value.
                return match;
            });
            source += "';\n";
            // If `variable` is not specified wrap a with-statement around the generated
            // code to add the data object to the top of the scope chain.
            var variable = hasOwnProperty.call(options, 'variable') && options.variable;
            if (!variable) source = 'with (obj) {\n' + source + '\n}\n';
            else if (reForbiddenIdentifierChars.test(variable)) throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
            // Cleanup code by stripping empty strings.
            source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
            // Frame code as the function body.
            source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
            var result = attempt(function() {
                return Function1(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
            });
            // Provide the compiled function's source by its `toString` method or
            // the `source` property as a convenience for inlining compiled templates.
            result.source = source;
            if (isError(result)) throw result;
            return result;
        }
        /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */ function toLower(value) {
            return toString(value).toLowerCase();
        }
        /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */ function toUpper(value) {
            return toString(value).toUpperCase();
        }
        /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */ function trim(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return baseTrim(string);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
            return castSlice(strSymbols, start, end).join('');
        }
        /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */ function trimEnd(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.slice(0, trimmedEndIndex(string) + 1);
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
            return castSlice(strSymbols, 0, end).join('');
        }
        /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */ function trimStart(string, chars, guard) {
            string = toString(string);
            if (string && (guard || chars === undefined)) return string.replace(reTrimStart, '');
            if (!string || !(chars = baseToString(chars))) return string;
            var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
            return castSlice(strSymbols, start).join('');
        }
        /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */ function truncate(string, options) {
            var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
            if (isObject(options)) {
                var separator = 'separator' in options ? options.separator : separator;
                length = 'length' in options ? toInteger(options.length) : length;
                omission = 'omission' in options ? baseToString(options.omission) : omission;
            }
            string = toString(string);
            var strLength = string.length;
            if (hasUnicode(string)) {
                var strSymbols = stringToArray(string);
                strLength = strSymbols.length;
            }
            if (length >= strLength) return string;
            var end = length - stringSize(omission);
            if (end < 1) return omission;
            var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
            if (separator === undefined) return result + omission;
            if (strSymbols) end += result.length - end;
            if (isRegExp(separator)) {
                if (string.slice(end).search(separator)) {
                    var match, substring = result;
                    if (!separator.global) separator = RegExp1(separator.source, toString(reFlags.exec(separator)) + 'g');
                    separator.lastIndex = 0;
                    while(match = separator.exec(substring))var newEnd = match.index;
                    result = result.slice(0, newEnd === undefined ? end : newEnd);
                }
            } else if (string.indexOf(baseToString(separator), end) != end) {
                var index = result.lastIndexOf(separator);
                if (index > -1) result = result.slice(0, index);
            }
            return result + omission;
        }
        /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */ function unescape(string) {
            string = toString(string);
            return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */ var upperCase = createCompounder(function(result, word, index) {
            return result + (index ? ' ' : '') + word.toUpperCase();
        });
        /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */ var upperFirst = createCaseFirst('toUpperCase');
        /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */ function words(string, pattern, guard) {
            string = toString(string);
            pattern = guard ? undefined : pattern;
            if (pattern === undefined) return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
            return string.match(pattern) || [];
        }
        /*------------------------------------------------------------------------*/ /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */ var attempt = baseRest(function(func, args) {
            try {
                return apply(func, undefined, args);
            } catch (e) {
                return isError(e) ? e : new Error(e);
            }
        });
        /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */ var bindAll = flatRest(function(object, methodNames) {
            arrayEach(methodNames, function(key) {
                key = toKey(key);
                baseAssignValue(object, key, bind(object[key], object));
            });
            return object;
        });
        /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */ function cond(pairs) {
            var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
            pairs = !length ? [] : arrayMap(pairs, function(pair) {
                if (typeof pair[1] != 'function') throw new TypeError(FUNC_ERROR_TEXT);
                return [
                    toIteratee(pair[0]),
                    pair[1]
                ];
            });
            return baseRest(function(args) {
                var index = -1;
                while(++index < length){
                    var pair = pairs[index];
                    if (apply(pair[0], this, args)) return apply(pair[1], this, args);
                }
            });
        }
        /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */ function conforms(source) {
            return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */ function constant(value) {
            return function() {
                return value;
            };
        }
        /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */ function defaultTo(value, defaultValue) {
            return value == null || value !== value ? defaultValue : value;
        }
        /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */ var flow = createFlow();
        /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */ var flowRight = createFlow(true);
        /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */ function identity(value) {
            return value;
        }
        /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */ function iteratee(func) {
            return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matches(source) {
            return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */ function matchesProperty(path, srcValue) {
            return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */ var method = baseRest(function(path, args) {
            return function(object) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */ var methodOf = baseRest(function(object, args) {
            return function(path) {
                return baseInvoke(object, path, args);
            };
        });
        /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */ function mixin(object, source, options) {
            var props = keys(source), methodNames = baseFunctions(source, props);
            if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
                options = source;
                source = object;
                object = this;
                methodNames = baseFunctions(source, keys(source));
            }
            var chain = !(isObject(options) && 'chain' in options) || !!options.chain, isFunc = isFunction(object);
            arrayEach(methodNames, function(methodName) {
                var func = source[methodName];
                object[methodName] = func;
                if (isFunc) object.prototype[methodName] = function() {
                    var chainAll = this.__chain__;
                    if (chain || chainAll) {
                        var result = object(this.__wrapped__), actions = result.__actions__ = copyArray(this.__actions__);
                        actions.push({
                            'func': func,
                            'args': arguments,
                            'thisArg': object
                        });
                        result.__chain__ = chainAll;
                        return result;
                    }
                    return func.apply(object, arrayPush([
                        this.value()
                    ], arguments));
                };
            });
            return object;
        }
        /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */ function noConflict() {
            if (root._ === this) root._ = oldDash;
            return this;
        }
        /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */ function noop() {
        // No operation performed.
        }
        /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */ function nthArg(n) {
            n = toInteger(n);
            return baseRest(function(args) {
                return baseNth(args, n);
            });
        }
        /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */ var over = createOver(arrayMap);
        /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */ var overEvery = createOver(arrayEvery);
        /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */ var overSome = createOver(arraySome);
        /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */ function property(path) {
            return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */ function propertyOf(object) {
            return function(path) {
                return object == null ? undefined : baseGet(object, path);
            };
        }
        /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */ var range = createRange();
        /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */ var rangeRight = createRange(true);
        /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */ function stubArray() {
            return [];
        }
        /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */ function stubFalse() {
            return false;
        }
        /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */ function stubObject() {
            return {};
        }
        /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */ function stubString() {
            return '';
        }
        /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */ function stubTrue() {
            return true;
        }
        /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */ function times(n, iteratee) {
            n = toInteger(n);
            if (n < 1 || n > MAX_SAFE_INTEGER) return [];
            var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
            iteratee = getIteratee(iteratee);
            n -= MAX_ARRAY_LENGTH;
            var result = baseTimes(length, iteratee);
            while(++index < n)iteratee(index);
            return result;
        }
        /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */ function toPath(value) {
            if (isArray(value)) return arrayMap(value, toKey);
            return isSymbol(value) ? [
                value
            ] : copyArray(stringToPath(toString(value)));
        }
        /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */ function uniqueId(prefix) {
            var id = ++idCounter;
            return toString(prefix) + id;
        }
        /*------------------------------------------------------------------------*/ /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */ var add = createMathOperation(function(augend, addend) {
            return augend + addend;
        }, 0);
        /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */ var ceil = createRound('ceil');
        /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */ var divide = createMathOperation(function(dividend, divisor) {
            return dividend / divisor;
        }, 1);
        /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */ var floor = createRound('floor');
        /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */ function max(array) {
            return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
        }
        /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */ function maxBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
        }
        /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */ function mean(array) {
            return baseMean(array, identity);
        }
        /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */ function meanBy(array, iteratee) {
            return baseMean(array, getIteratee(iteratee, 2));
        }
        /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */ function min(array) {
            return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
        }
        /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */ function minBy(array, iteratee) {
            return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
        }
        /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */ var multiply = createMathOperation(function(multiplier, multiplicand) {
            return multiplier * multiplicand;
        }, 1);
        /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */ var round = createRound('round');
        /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */ var subtract = createMathOperation(function(minuend, subtrahend) {
            return minuend - subtrahend;
        }, 0);
        /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */ function sum(array) {
            return array && array.length ? baseSum(array, identity) : 0;
        }
        /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */ function sumBy(array, iteratee) {
            return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
        }
        /*------------------------------------------------------------------------*/ // Add methods that return wrapped values in chain sequences.
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        // Add aliases.
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        // Add methods to `lodash.prototype`.
        mixin(lodash, lodash);
        /*------------------------------------------------------------------------*/ // Add methods that return unwrapped values in chain sequences.
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt1;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        // Add aliases.
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
            var source = {};
            baseForOwn(lodash, function(func, methodName) {
                if (!hasOwnProperty.call(lodash.prototype, methodName)) source[methodName] = func;
            });
            return source;
        }(), {
            'chain': false
        });
        /*------------------------------------------------------------------------*/ /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */ lodash.VERSION = VERSION;
        // Assign default placeholders.
        arrayEach([
            'bind',
            'bindKey',
            'curry',
            'curryRight',
            'partial',
            'partialRight'
        ], function(methodName) {
            lodash[methodName].placeholder = lodash;
        });
        // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
        arrayEach([
            'drop',
            'take'
        ], function(methodName, index) {
            LazyWrapper.prototype[methodName] = function(n) {
                n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
                var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
                if (result.__filtered__) result.__takeCount__ = nativeMin(n, result.__takeCount__);
                else result.__views__.push({
                    'size': nativeMin(n, MAX_ARRAY_LENGTH),
                    'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
                });
                return result;
            };
            LazyWrapper.prototype[methodName + 'Right'] = function(n) {
                return this.reverse()[methodName](n).reverse();
            };
        });
        // Add `LazyWrapper` methods that accept an `iteratee` value.
        arrayEach([
            'filter',
            'map',
            'takeWhile'
        ], function(methodName, index) {
            var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
            LazyWrapper.prototype[methodName] = function(iteratee) {
                var result = this.clone();
                result.__iteratees__.push({
                    'iteratee': getIteratee(iteratee, 3),
                    'type': type
                });
                result.__filtered__ = result.__filtered__ || isFilter;
                return result;
            };
        });
        // Add `LazyWrapper` methods for `_.head` and `_.last`.
        arrayEach([
            'head',
            'last'
        ], function(methodName, index) {
            var takeName = 'take' + (index ? 'Right' : '');
            LazyWrapper.prototype[methodName] = function() {
                return this[takeName](1).value()[0];
            };
        });
        // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
        arrayEach([
            'initial',
            'tail'
        ], function(methodName, index) {
            var dropName = 'drop' + (index ? '' : 'Right');
            LazyWrapper.prototype[methodName] = function() {
                return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
            };
        });
        LazyWrapper.prototype.compact = function() {
            return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
            return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
            return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
            if (typeof path == 'function') return new LazyWrapper(this);
            return this.map(function(value) {
                return baseInvoke(value, path, args);
            });
        });
        LazyWrapper.prototype.reject = function(predicate) {
            return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
            start = toInteger(start);
            var result = this;
            if (result.__filtered__ && (start > 0 || end < 0)) return new LazyWrapper(result);
            if (start < 0) result = result.takeRight(-start);
            else if (start) result = result.drop(start);
            if (end !== undefined) {
                end = toInteger(end);
                result = end < 0 ? result.dropRight(-end) : result.take(end - start);
            }
            return result;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
            return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
            return this.take(MAX_ARRAY_LENGTH);
        };
        // Add `LazyWrapper` methods to `lodash.prototype`.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
            if (!lodashFunc) return;
            lodash.prototype[methodName] = function() {
                var value = this.__wrapped__, args = isTaker ? [
                    1
                ] : arguments, isLazy = value instanceof LazyWrapper, iteratee = args[0], useLazy = isLazy || isArray(value);
                var interceptor = function(value) {
                    var result = lodashFunc.apply(lodash, arrayPush([
                        value
                    ], args));
                    return isTaker && chainAll ? result[0] : result;
                };
                if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) // Avoid lazy use if the iteratee has a "length" value other than `1`.
                isLazy = useLazy = false;
                var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
                if (!retUnwrapped && useLazy) {
                    value = onlyLazy ? value : new LazyWrapper(this);
                    var result = func.apply(value, args);
                    result.__actions__.push({
                        'func': thru,
                        'args': [
                            interceptor
                        ],
                        'thisArg': undefined
                    });
                    return new LodashWrapper(result, chainAll);
                }
                if (isUnwrapped && onlyLazy) return func.apply(this, args);
                result = this.thru(interceptor);
                return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
            };
        });
        // Add `Array` methods to `lodash.prototype`.
        arrayEach([
            'pop',
            'push',
            'shift',
            'sort',
            'splice',
            'unshift'
        ], function(methodName) {
            var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru', retUnwrapped = /^(?:pop|shift)$/.test(methodName);
            lodash.prototype[methodName] = function() {
                var args = arguments;
                if (retUnwrapped && !this.__chain__) {
                    var value = this.value();
                    return func.apply(isArray(value) ? value : [], args);
                }
                return this[chainName](function(value) {
                    return func.apply(isArray(value) ? value : [], args);
                });
            };
        });
        // Map minified method names to their real names.
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
            var lodashFunc = lodash[methodName];
            if (lodashFunc) {
                var key = lodashFunc.name + '';
                if (!hasOwnProperty.call(realNames, key)) realNames[key] = [];
                realNames[key].push({
                    'name': methodName,
                    'func': lodashFunc
                });
            }
        });
        realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [
            {
                'name': 'wrapper',
                'func': undefined
            }
        ];
        // Add methods to `LazyWrapper`.
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        // Add chain sequence methods to the `lodash` wrapper.
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        // Add lazy aliases.
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) lodash.prototype[symIterator] = wrapperToIterator;
        return lodash;
    };
    /*--------------------------------------------------------------------------*/ // Export lodash.
    var _ = runInContext();
    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
        // Expose Lodash on the global object to prevent errors when Lodash is
        // loaded by a script tag in the presence of an AMD loader.
        // See http://requirejs.org/docs/errors.html#mismatch for more details.
        // Use `_.noConflict` to remove Lodash from the global object.
        root._ = _;
        // Define as an anonymous module so, through path mapping, it can be
        // referenced as the "underscore" module.
        define(function() {
            return _;
        });
    } else if (freeModule) {
        // Export for Node.js.
        (freeModule.exports = _)._ = _;
        // Export for CommonJS support.
        freeExports._ = _;
    } else // Export to the global object.
    root._ = _;
}).call(this);

});

parcelRegister("ekuMq", function(module, exports) {
// source: gateway_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $a6eacf3d80b7077c$var$goog = $8M67s;
var $a6eacf3d80b7077c$var$global = Function('return this')();

var $7QrRI = parcelRequire("7QrRI");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $7QrRI);

var $26u10 = parcelRequire("26u10");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $26u10);

var $an37o = parcelRequire("an37o");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $an37o);

var $k1gxg = parcelRequire("k1gxg");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $k1gxg);

var $6EauF = parcelRequire("6EauF");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $6EauF);

var $g1LOb = parcelRequire("g1LOb");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $g1LOb);

var $dFFtz = parcelRequire("dFFtz");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $dFFtz);

var $cyjZp = parcelRequire("cyjZp");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $cyjZp);

var $3QqPt = parcelRequire("3QqPt");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $3QqPt);

var $3EyMN = parcelRequire("3EyMN");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $3EyMN);

var $gjhG2 = parcelRequire("gjhG2");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $gjhG2);

var $ghA5X = parcelRequire("ghA5X");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $ghA5X);

var $dsvHa = parcelRequire("dsvHa");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $dsvHa);

var $eAp0I = parcelRequire("eAp0I");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $eAp0I);

var $8ilIL = parcelRequire("8ilIL");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $8ilIL);

var $cIR06 = parcelRequire("cIR06");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $cIR06);

var $9HeMJ = parcelRequire("9HeMJ");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $9HeMJ);

var $9YICB = parcelRequire("9YICB");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $9YICB);

var $2Yrcc = parcelRequire("2Yrcc");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $2Yrcc);

var $9c7Du = parcelRequire("9c7Du");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $9c7Du);

var $aqwEO = parcelRequire("aqwEO");
$a6eacf3d80b7077c$var$goog.object.extend(proto, $aqwEO);

});
parcelRegister("an37o", function(module, exports) {
// source: communication_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $78ce7899548d9a7a$var$goog = $8M67s;
var $78ce7899548d9a7a$var$global = Function('return this')();
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.CommunicationMethod', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.CommunicationType', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.OptOut', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.OptOutRequest', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.OptOutResponse', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.SendPushBatchRequest', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.SendPushBatchResponse', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.SendPushRequest', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.SendPushResponse', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.UpsertCustomerDeviceRequest', null, $78ce7899548d9a7a$var$global);
$78ce7899548d9a7a$var$goog.exportSymbol('proto.communication_service.UpsertCustomerDeviceResponse', null, $78ce7899548d9a7a$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.SendPushRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.SendPushRequest, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.SendPushRequest.displayName = 'proto.communication_service.SendPushRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.SendPushResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.SendPushResponse, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.SendPushResponse.displayName = 'proto.communication_service.SendPushResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.SendPushBatchRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.communication_service.SendPushBatchRequest.repeatedFields_, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.SendPushBatchRequest, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.SendPushBatchRequest.displayName = 'proto.communication_service.SendPushBatchRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.SendPushBatchResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.SendPushBatchResponse, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.SendPushBatchResponse.displayName = 'proto.communication_service.SendPushBatchResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.OptOut = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.OptOut, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.OptOut.displayName = 'proto.communication_service.OptOut';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.OptOutRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.communication_service.OptOutRequest.repeatedFields_, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.OptOutRequest, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.OptOutRequest.displayName = 'proto.communication_service.OptOutRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.OptOutResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.OptOutResponse, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.OptOutResponse.displayName = 'proto.communication_service.OptOutResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.UpsertCustomerDeviceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.communication_service.UpsertCustomerDeviceRequest.repeatedFields_, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.UpsertCustomerDeviceRequest, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.UpsertCustomerDeviceRequest.displayName = 'proto.communication_service.UpsertCustomerDeviceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.communication_service.UpsertCustomerDeviceResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$78ce7899548d9a7a$var$goog.inherits(proto.communication_service.UpsertCustomerDeviceResponse, $8M67s.Message);
if ($78ce7899548d9a7a$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.communication_service.UpsertCustomerDeviceResponse.displayName = 'proto.communication_service.UpsertCustomerDeviceResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.SendPushRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.SendPushRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.SendPushRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.SendPushRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subject: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            message: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            communicationType: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.SendPushRequest}
 */ proto.communication_service.SendPushRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.SendPushRequest;
    return proto.communication_service.SendPushRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.SendPushRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.SendPushRequest}
 */ proto.communication_service.SendPushRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubject(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            case 4:
                var value = /** @type {!proto.communication_service.CommunicationType} */ reader.readEnum();
                msg.setCommunicationType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.SendPushRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.SendPushRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.SendPushRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.SendPushRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubject();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCommunicationType();
    if (f !== 0.0) writer.writeEnum(4, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.communication_service.SendPushRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.SendPushRequest} returns this
 */ proto.communication_service.SendPushRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subject = 2;
 * @return {string}
 */ proto.communication_service.SendPushRequest.prototype.getSubject = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.SendPushRequest} returns this
 */ proto.communication_service.SendPushRequest.prototype.setSubject = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string message = 3;
 * @return {string}
 */ proto.communication_service.SendPushRequest.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.SendPushRequest} returns this
 */ proto.communication_service.SendPushRequest.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional CommunicationType communication_type = 4;
 * @return {!proto.communication_service.CommunicationType}
 */ proto.communication_service.SendPushRequest.prototype.getCommunicationType = function() {
    return /** @type {!proto.communication_service.CommunicationType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.communication_service.CommunicationType} value
 * @return {!proto.communication_service.SendPushRequest} returns this
 */ proto.communication_service.SendPushRequest.prototype.setCommunicationType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.SendPushResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.SendPushResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.SendPushResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.SendPushResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.SendPushResponse}
 */ proto.communication_service.SendPushResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.SendPushResponse;
    return proto.communication_service.SendPushResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.SendPushResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.SendPushResponse}
 */ proto.communication_service.SendPushResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.SendPushResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.SendPushResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.SendPushResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.SendPushResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.communication_service.SendPushResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.communication_service.SendPushResponse} returns this
 */ proto.communication_service.SendPushResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.communication_service.SendPushBatchRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.SendPushBatchRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.SendPushBatchRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.SendPushBatchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.SendPushBatchRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerIdsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            subject: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            message: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            communicationType: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.SendPushBatchRequest}
 */ proto.communication_service.SendPushBatchRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.SendPushBatchRequest;
    return proto.communication_service.SendPushBatchRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.SendPushBatchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.SendPushBatchRequest}
 */ proto.communication_service.SendPushBatchRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addCustomerIds(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubject(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            case 4:
                var value = /** @type {!proto.communication_service.CommunicationType} */ reader.readEnum();
                msg.setCommunicationType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.SendPushBatchRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.SendPushBatchRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.SendPushBatchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.SendPushBatchRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerIdsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
    f = message.getSubject();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getCommunicationType();
    if (f !== 0.0) writer.writeEnum(4, f);
};
/**
 * repeated string customer_ids = 1;
 * @return {!Array<string>}
 */ proto.communication_service.SendPushBatchRequest.prototype.getCustomerIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.communication_service.SendPushBatchRequest} returns this
 */ proto.communication_service.SendPushBatchRequest.prototype.setCustomerIdsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.communication_service.SendPushBatchRequest} returns this
 */ proto.communication_service.SendPushBatchRequest.prototype.addCustomerIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.communication_service.SendPushBatchRequest} returns this
 */ proto.communication_service.SendPushBatchRequest.prototype.clearCustomerIdsList = function() {
    return this.setCustomerIdsList([]);
};
/**
 * optional string subject = 2;
 * @return {string}
 */ proto.communication_service.SendPushBatchRequest.prototype.getSubject = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.SendPushBatchRequest} returns this
 */ proto.communication_service.SendPushBatchRequest.prototype.setSubject = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string message = 3;
 * @return {string}
 */ proto.communication_service.SendPushBatchRequest.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.SendPushBatchRequest} returns this
 */ proto.communication_service.SendPushBatchRequest.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional CommunicationType communication_type = 4;
 * @return {!proto.communication_service.CommunicationType}
 */ proto.communication_service.SendPushBatchRequest.prototype.getCommunicationType = function() {
    return /** @type {!proto.communication_service.CommunicationType} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {!proto.communication_service.CommunicationType} value
 * @return {!proto.communication_service.SendPushBatchRequest} returns this
 */ proto.communication_service.SendPushBatchRequest.prototype.setCommunicationType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.SendPushBatchResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.SendPushBatchResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.SendPushBatchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.SendPushBatchResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.SendPushBatchResponse}
 */ proto.communication_service.SendPushBatchResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.SendPushBatchResponse;
    return proto.communication_service.SendPushBatchResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.SendPushBatchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.SendPushBatchResponse}
 */ proto.communication_service.SendPushBatchResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.SendPushBatchResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.SendPushBatchResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.SendPushBatchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.SendPushBatchResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.OptOut.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.OptOut.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.OptOut} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.OptOut.toObject = function(includeInstance, msg) {
        var f, obj = {
            communicationType: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            communicationMethod: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            optOut: $8M67s.Message.getBooleanFieldWithDefault(msg, 3, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.OptOut}
 */ proto.communication_service.OptOut.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.OptOut;
    return proto.communication_service.OptOut.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.OptOut} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.OptOut}
 */ proto.communication_service.OptOut.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.communication_service.CommunicationType} */ reader.readEnum();
                msg.setCommunicationType(value);
                break;
            case 2:
                var value = /** @type {!proto.communication_service.CommunicationMethod} */ reader.readEnum();
                msg.setCommunicationMethod(value);
                break;
            case 3:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setOptOut(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.OptOut.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.OptOut.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.OptOut} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.OptOut.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCommunicationType();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getCommunicationMethod();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getOptOut();
    if (f) writer.writeBool(3, f);
};
/**
 * optional CommunicationType communication_type = 1;
 * @return {!proto.communication_service.CommunicationType}
 */ proto.communication_service.OptOut.prototype.getCommunicationType = function() {
    return /** @type {!proto.communication_service.CommunicationType} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.communication_service.CommunicationType} value
 * @return {!proto.communication_service.OptOut} returns this
 */ proto.communication_service.OptOut.prototype.setCommunicationType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional CommunicationMethod communication_method = 2;
 * @return {!proto.communication_service.CommunicationMethod}
 */ proto.communication_service.OptOut.prototype.getCommunicationMethod = function() {
    return /** @type {!proto.communication_service.CommunicationMethod} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.communication_service.CommunicationMethod} value
 * @return {!proto.communication_service.OptOut} returns this
 */ proto.communication_service.OptOut.prototype.setCommunicationMethod = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional bool opt_out = 3;
 * @return {boolean}
 */ proto.communication_service.OptOut.prototype.getOptOut = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 3, false);
};
/**
 * @param {boolean} value
 * @return {!proto.communication_service.OptOut} returns this
 */ proto.communication_service.OptOut.prototype.setOptOut = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.communication_service.OptOutRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.OptOutRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.OptOutRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.OptOutRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.OptOutRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            optOutsList: $8M67s.Message.toObjectList(msg.getOptOutsList(), proto.communication_service.OptOut.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.OptOutRequest}
 */ proto.communication_service.OptOutRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.OptOutRequest;
    return proto.communication_service.OptOutRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.OptOutRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.OptOutRequest}
 */ proto.communication_service.OptOutRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new proto.communication_service.OptOut;
                reader.readMessage(value, proto.communication_service.OptOut.deserializeBinaryFromReader);
                msg.addOptOuts(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.OptOutRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.OptOutRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.OptOutRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.OptOutRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOptOutsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.communication_service.OptOut.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.communication_service.OptOutRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.OptOutRequest} returns this
 */ proto.communication_service.OptOutRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated OptOut opt_outs = 2;
 * @return {!Array<!proto.communication_service.OptOut>}
 */ proto.communication_service.OptOutRequest.prototype.getOptOutsList = function() {
    return /** @type{!Array<!proto.communication_service.OptOut>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.communication_service.OptOut, 2);
};
/**
 * @param {!Array<!proto.communication_service.OptOut>} value
 * @return {!proto.communication_service.OptOutRequest} returns this
*/ proto.communication_service.OptOutRequest.prototype.setOptOutsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.communication_service.OptOut=} opt_value
 * @param {number=} opt_index
 * @return {!proto.communication_service.OptOut}
 */ proto.communication_service.OptOutRequest.prototype.addOptOuts = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.communication_service.OptOut, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.communication_service.OptOutRequest} returns this
 */ proto.communication_service.OptOutRequest.prototype.clearOptOutsList = function() {
    return this.setOptOutsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.OptOutResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.OptOutResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.OptOutResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.OptOutResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.OptOutResponse}
 */ proto.communication_service.OptOutResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.OptOutResponse;
    return proto.communication_service.OptOutResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.OptOutResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.OptOutResponse}
 */ proto.communication_service.OptOutResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.OptOutResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.OptOutResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.OptOutResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.OptOutResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.communication_service.UpsertCustomerDeviceRequest.repeatedFields_ = [
    10
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.UpsertCustomerDeviceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.UpsertCustomerDeviceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.UpsertCustomerDeviceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            deviceId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            deviceModel: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            deviceBrand: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            deviceFamily: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            osFamily: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            osMajorVersion: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            osMinorVersion: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            appVersion: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            optOutsList: $8M67s.Message.toObjectList(msg.getOptOutsList(), proto.communication_service.OptOut.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest}
 */ proto.communication_service.UpsertCustomerDeviceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.UpsertCustomerDeviceRequest;
    return proto.communication_service.UpsertCustomerDeviceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.UpsertCustomerDeviceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest}
 */ proto.communication_service.UpsertCustomerDeviceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDeviceId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDeviceModel(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDeviceBrand(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setDeviceFamily(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setOsFamily(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setOsMajorVersion(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setOsMinorVersion(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setAppVersion(value);
                break;
            case 10:
                var value = new proto.communication_service.OptOut;
                reader.readMessage(value, proto.communication_service.OptOut.deserializeBinaryFromReader);
                msg.addOptOuts(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.UpsertCustomerDeviceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.UpsertCustomerDeviceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.UpsertCustomerDeviceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDeviceId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDeviceModel();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDeviceBrand();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getDeviceFamily();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getOsFamily();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getOsMajorVersion();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getOsMinorVersion();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getAppVersion();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getOptOutsList();
    if (f.length > 0) writer.writeRepeatedMessage(10, f, proto.communication_service.OptOut.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string device_id = 2;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getDeviceId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setDeviceId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string device_model = 3;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getDeviceModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setDeviceModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string device_brand = 4;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getDeviceBrand = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setDeviceBrand = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string device_family = 5;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getDeviceFamily = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setDeviceFamily = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string os_family = 6;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getOsFamily = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setOsFamily = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string os_major_version = 7;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getOsMajorVersion = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setOsMajorVersion = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string os_minor_version = 8;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getOsMinorVersion = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setOsMinorVersion = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string app_version = 9;
 * @return {string}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getAppVersion = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setAppVersion = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * repeated OptOut opt_outs = 10;
 * @return {!Array<!proto.communication_service.OptOut>}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.getOptOutsList = function() {
    return /** @type{!Array<!proto.communication_service.OptOut>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.communication_service.OptOut, 10);
};
/**
 * @param {!Array<!proto.communication_service.OptOut>} value
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
*/ proto.communication_service.UpsertCustomerDeviceRequest.prototype.setOptOutsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 10, value);
};
/**
 * @param {!proto.communication_service.OptOut=} opt_value
 * @param {number=} opt_index
 * @return {!proto.communication_service.OptOut}
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.addOptOuts = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.communication_service.OptOut, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.communication_service.UpsertCustomerDeviceRequest} returns this
 */ proto.communication_service.UpsertCustomerDeviceRequest.prototype.clearOptOutsList = function() {
    return this.setOptOutsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.communication_service.UpsertCustomerDeviceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.communication_service.UpsertCustomerDeviceResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.communication_service.UpsertCustomerDeviceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.UpsertCustomerDeviceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.communication_service.UpsertCustomerDeviceResponse}
 */ proto.communication_service.UpsertCustomerDeviceResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.communication_service.UpsertCustomerDeviceResponse;
    return proto.communication_service.UpsertCustomerDeviceResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.communication_service.UpsertCustomerDeviceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.communication_service.UpsertCustomerDeviceResponse}
 */ proto.communication_service.UpsertCustomerDeviceResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.communication_service.UpsertCustomerDeviceResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.communication_service.UpsertCustomerDeviceResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.communication_service.UpsertCustomerDeviceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.communication_service.UpsertCustomerDeviceResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * @enum {number}
 */ proto.communication_service.CommunicationType = {
    SYSTEM: 0,
    COMMUNICATION: 1,
    MARKETING: 2
};
/**
 * @enum {number}
 */ proto.communication_service.CommunicationMethod = {
    PUSH: 0,
    EMAIL: 1,
    TEXT: 2
};
$78ce7899548d9a7a$var$goog.object.extend(module.exports, proto.communication_service);

});

parcelRegister("k1gxg", function(module, exports) {
// source: contract_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $e930ba3d5946d461$var$goog = $8M67s;
var $e930ba3d5946d461$var$global = Function('return this')();
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.AddTemplateRequest', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.AddTemplateResponse', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.ContractProperties', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.ContractType', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.CustomerContractMeta', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.GetCustomerContractsRequest', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.GetCustomerContractsResponse', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.LegalCopy', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.PickupReceipt', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.PreviewCustomerContractResponse', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.SignContractRequest', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.SignContractResponse', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.SubscriptionContract', null, $e930ba3d5946d461$var$global);
$e930ba3d5946d461$var$goog.exportSymbol('proto.contract_service.SubscriptionLegalCopy', null, $e930ba3d5946d461$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.SignContractRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.SignContractRequest, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.SignContractRequest.displayName = 'proto.contract_service.SignContractRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.ContractProperties = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.ContractProperties, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.ContractProperties.displayName = 'proto.contract_service.ContractProperties';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.SignContractResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.SignContractResponse, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.SignContractResponse.displayName = 'proto.contract_service.SignContractResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.AddTemplateRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.AddTemplateRequest, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.AddTemplateRequest.displayName = 'proto.contract_service.AddTemplateRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.LegalCopy = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.LegalCopy, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.LegalCopy.displayName = 'proto.contract_service.LegalCopy';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.SubscriptionLegalCopy = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.contract_service.SubscriptionLegalCopy.repeatedFields_, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.SubscriptionLegalCopy, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.SubscriptionLegalCopy.displayName = 'proto.contract_service.SubscriptionLegalCopy';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.AddTemplateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.AddTemplateResponse, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.AddTemplateResponse.displayName = 'proto.contract_service.AddTemplateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.SubscriptionContract = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.SubscriptionContract, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.SubscriptionContract.displayName = 'proto.contract_service.SubscriptionContract';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.PickupReceipt = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.PickupReceipt, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.PickupReceipt.displayName = 'proto.contract_service.PickupReceipt';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.GetCustomerContractsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.GetCustomerContractsRequest, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.GetCustomerContractsRequest.displayName = 'proto.contract_service.GetCustomerContractsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.GetCustomerContractsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.contract_service.GetCustomerContractsResponse.repeatedFields_, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.GetCustomerContractsResponse, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.GetCustomerContractsResponse.displayName = 'proto.contract_service.GetCustomerContractsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.CustomerContractMeta = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.CustomerContractMeta, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.CustomerContractMeta.displayName = 'proto.contract_service.CustomerContractMeta';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.contract_service.PreviewCustomerContractResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$e930ba3d5946d461$var$goog.inherits(proto.contract_service.PreviewCustomerContractResponse, $8M67s.Message);
if ($e930ba3d5946d461$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.contract_service.PreviewCustomerContractResponse.displayName = 'proto.contract_service.PreviewCustomerContractResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.SignContractRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.SignContractRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.SignContractRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.SignContractRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            contractType: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            contractVersion: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            createdBeforeUnix: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            contractProperties: (f = msg.getContractProperties()) && proto.contract_service.ContractProperties.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.SignContractRequest}
 */ proto.contract_service.SignContractRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.SignContractRequest;
    return proto.contract_service.SignContractRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.SignContractRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.SignContractRequest}
 */ proto.contract_service.SignContractRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {!proto.contract_service.ContractType} */ reader.readEnum();
                msg.setContractType(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setContractVersion(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreatedBeforeUnix(value);
                break;
            case 6:
                var value = new proto.contract_service.ContractProperties;
                reader.readMessage(value, proto.contract_service.ContractProperties.deserializeBinaryFromReader);
                msg.setContractProperties(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.SignContractRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.SignContractRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.SignContractRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.SignContractRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getContractType();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getContractVersion();
    if (f !== 0) writer.writeInt64(4, f);
    f = message.getCreatedBeforeUnix();
    if (f !== 0) writer.writeInt64(5, f);
    f = message.getContractProperties();
    if (f != null) writer.writeMessage(6, f, proto.contract_service.ContractProperties.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.contract_service.SignContractRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SignContractRequest} returns this
 */ proto.contract_service.SignContractRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.contract_service.SignContractRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SignContractRequest} returns this
 */ proto.contract_service.SignContractRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional ContractType contract_type = 3;
 * @return {!proto.contract_service.ContractType}
 */ proto.contract_service.SignContractRequest.prototype.getContractType = function() {
    return /** @type {!proto.contract_service.ContractType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.contract_service.ContractType} value
 * @return {!proto.contract_service.SignContractRequest} returns this
 */ proto.contract_service.SignContractRequest.prototype.setContractType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional int64 contract_version = 4;
 * @return {number}
 */ proto.contract_service.SignContractRequest.prototype.getContractVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.contract_service.SignContractRequest} returns this
 */ proto.contract_service.SignContractRequest.prototype.setContractVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int64 created_before_unix = 5;
 * @return {number}
 */ proto.contract_service.SignContractRequest.prototype.getCreatedBeforeUnix = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.contract_service.SignContractRequest} returns this
 */ proto.contract_service.SignContractRequest.prototype.setCreatedBeforeUnix = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional ContractProperties contract_properties = 6;
 * @return {?proto.contract_service.ContractProperties}
 */ proto.contract_service.SignContractRequest.prototype.getContractProperties = function() {
    return /** @type{?proto.contract_service.ContractProperties} */ $8M67s.Message.getWrapperField(this, proto.contract_service.ContractProperties, 6);
};
/**
 * @param {?proto.contract_service.ContractProperties|undefined} value
 * @return {!proto.contract_service.SignContractRequest} returns this
*/ proto.contract_service.SignContractRequest.prototype.setContractProperties = function(value) {
    return $8M67s.Message.setWrapperField(this, 6, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.contract_service.SignContractRequest} returns this
 */ proto.contract_service.SignContractRequest.prototype.clearContractProperties = function() {
    return this.setContractProperties(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.contract_service.SignContractRequest.prototype.hasContractProperties = function() {
    return $8M67s.Message.getField(this, 6) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.ContractProperties.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.ContractProperties.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.ContractProperties} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.ContractProperties.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vin: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            odometer: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            year: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            trim: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            make: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            paint: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            agreementDate: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            customerAccountNumber: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            customerName: $8M67s.Message.getFieldWithDefault(msg, 12, ""),
            billingAddress: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            subscriptionBaseMonthly: $8M67s.Message.getFieldWithDefault(msg, 14, ""),
            insuranceMonthly: $8M67s.Message.getFieldWithDefault(msg, 15, ""),
            insuranceMonthlyTax: $8M67s.Message.getFieldWithDefault(msg, 16, ""),
            subscriptionTax: $8M67s.Message.getFieldWithDefault(msg, 17, ""),
            subscriptionTotalMonthly: $8M67s.Message.getFieldWithDefault(msg, 18, ""),
            subscriptionTotalMonthlyTax: $8M67s.Message.getFieldWithDefault(msg, 19, ""),
            promoCode: $8M67s.Message.getFieldWithDefault(msg, 20, ""),
            promoCodeAmount: $8M67s.Message.getFieldWithDefault(msg, 21, ""),
            billedMonthlyStartingOn: $8M67s.Message.getFieldWithDefault(msg, 22, ""),
            subscriptionExcessMileageRate: $8M67s.Message.getFieldWithDefault(msg, 23, ""),
            insuranceExcessMileageRate: $8M67s.Message.getFieldWithDefault(msg, 24, ""),
            reservationFee: $8M67s.Message.getFieldWithDefault(msg, 25, ""),
            subscriptionRefundableDeposit: $8M67s.Message.getFieldWithDefault(msg, 26, ""),
            securityDepositPaidLastFourStatement: $8M67s.Message.getFieldWithDefault(msg, 27, ""),
            subscriptionStartPayment: $8M67s.Message.getFieldWithDefault(msg, 28, ""),
            subscriptionStartPaymentTax: $8M67s.Message.getFieldWithDefault(msg, 29, ""),
            driveOffSummary: $8M67s.Message.getFieldWithDefault(msg, 30, ""),
            driveOffTotalTax: $8M67s.Message.getFieldWithDefault(msg, 31, ""),
            subscriptionTotalDueToStart: $8M67s.Message.getFieldWithDefault(msg, 32, ""),
            firstMonthSubscriptionTax: $8M67s.Message.getFieldWithDefault(msg, 33, ""),
            firstMonthSubscriptionTotal: $8M67s.Message.getFieldWithDefault(msg, 34, ""),
            priceTermMonths: $8M67s.Message.getFieldWithDefault(msg, 35, ""),
            signatureImage: $8M67s.Message.getFieldWithDefault(msg, 36, ""),
            autonomyId: $8M67s.Message.getFieldWithDefault(msg, 37, ""),
            currentMileage: $8M67s.Message.getFieldWithDefault(msg, 38, ""),
            startDate: $8M67s.Message.getFieldWithDefault(msg, 39, ""),
            startFee: $8M67s.Message.getFieldWithDefault(msg, 40, ""),
            monthlyFee: $8M67s.Message.getFieldWithDefault(msg, 41, ""),
            nextMonthlyPayment: $8M67s.Message.getFieldWithDefault(msg, 42, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.ContractProperties}
 */ proto.contract_service.ContractProperties.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.ContractProperties;
    return proto.contract_service.ContractProperties.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.ContractProperties} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.ContractProperties}
 */ proto.contract_service.ContractProperties.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVin(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setOdometer(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setYear(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setTrim(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setPaint(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setAgreementDate(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerAccountNumber(value);
                break;
            case 12:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerName(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setBillingAddress(value);
                break;
            case 14:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionBaseMonthly(value);
                break;
            case 15:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceMonthly(value);
                break;
            case 16:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceMonthlyTax(value);
                break;
            case 17:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionTax(value);
                break;
            case 18:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionTotalMonthly(value);
                break;
            case 19:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionTotalMonthlyTax(value);
                break;
            case 20:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCode(value);
                break;
            case 21:
                var value = /** @type {string} */ reader.readString();
                msg.setPromoCodeAmount(value);
                break;
            case 22:
                var value = /** @type {string} */ reader.readString();
                msg.setBilledMonthlyStartingOn(value);
                break;
            case 23:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionExcessMileageRate(value);
                break;
            case 24:
                var value = /** @type {string} */ reader.readString();
                msg.setInsuranceExcessMileageRate(value);
                break;
            case 25:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationFee(value);
                break;
            case 26:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionRefundableDeposit(value);
                break;
            case 27:
                var value = /** @type {string} */ reader.readString();
                msg.setSecurityDepositPaidLastFourStatement(value);
                break;
            case 28:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionStartPayment(value);
                break;
            case 29:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionStartPaymentTax(value);
                break;
            case 30:
                var value = /** @type {string} */ reader.readString();
                msg.setDriveOffSummary(value);
                break;
            case 31:
                var value = /** @type {string} */ reader.readString();
                msg.setDriveOffTotalTax(value);
                break;
            case 32:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionTotalDueToStart(value);
                break;
            case 33:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstMonthSubscriptionTax(value);
                break;
            case 34:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstMonthSubscriptionTotal(value);
                break;
            case 35:
                var value = /** @type {string} */ reader.readString();
                msg.setPriceTermMonths(value);
                break;
            case 36:
                var value = /** @type {string} */ reader.readString();
                msg.setSignatureImage(value);
                break;
            case 37:
                var value = /** @type {string} */ reader.readString();
                msg.setAutonomyId(value);
                break;
            case 38:
                var value = /** @type {string} */ reader.readString();
                msg.setCurrentMileage(value);
                break;
            case 39:
                var value = /** @type {string} */ reader.readString();
                msg.setStartDate(value);
                break;
            case 40:
                var value = /** @type {string} */ reader.readString();
                msg.setStartFee(value);
                break;
            case 41:
                var value = /** @type {string} */ reader.readString();
                msg.setMonthlyFee(value);
                break;
            case 42:
                var value = /** @type {string} */ reader.readString();
                msg.setNextMonthlyPayment(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.ContractProperties.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.ContractProperties.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.ContractProperties} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.ContractProperties.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVin();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getOdometer();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getYear();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getTrim();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getMake();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getPaint();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getAgreementDate();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getCustomerAccountNumber();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getCustomerName();
    if (f.length > 0) writer.writeString(12, f);
    f = message.getBillingAddress();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getSubscriptionBaseMonthly();
    if (f.length > 0) writer.writeString(14, f);
    f = message.getInsuranceMonthly();
    if (f.length > 0) writer.writeString(15, f);
    f = message.getInsuranceMonthlyTax();
    if (f.length > 0) writer.writeString(16, f);
    f = message.getSubscriptionTax();
    if (f.length > 0) writer.writeString(17, f);
    f = message.getSubscriptionTotalMonthly();
    if (f.length > 0) writer.writeString(18, f);
    f = message.getSubscriptionTotalMonthlyTax();
    if (f.length > 0) writer.writeString(19, f);
    f = message.getPromoCode();
    if (f.length > 0) writer.writeString(20, f);
    f = message.getPromoCodeAmount();
    if (f.length > 0) writer.writeString(21, f);
    f = message.getBilledMonthlyStartingOn();
    if (f.length > 0) writer.writeString(22, f);
    f = message.getSubscriptionExcessMileageRate();
    if (f.length > 0) writer.writeString(23, f);
    f = message.getInsuranceExcessMileageRate();
    if (f.length > 0) writer.writeString(24, f);
    f = message.getReservationFee();
    if (f.length > 0) writer.writeString(25, f);
    f = message.getSubscriptionRefundableDeposit();
    if (f.length > 0) writer.writeString(26, f);
    f = message.getSecurityDepositPaidLastFourStatement();
    if (f.length > 0) writer.writeString(27, f);
    f = message.getSubscriptionStartPayment();
    if (f.length > 0) writer.writeString(28, f);
    f = message.getSubscriptionStartPaymentTax();
    if (f.length > 0) writer.writeString(29, f);
    f = message.getDriveOffSummary();
    if (f.length > 0) writer.writeString(30, f);
    f = message.getDriveOffTotalTax();
    if (f.length > 0) writer.writeString(31, f);
    f = message.getSubscriptionTotalDueToStart();
    if (f.length > 0) writer.writeString(32, f);
    f = message.getFirstMonthSubscriptionTax();
    if (f.length > 0) writer.writeString(33, f);
    f = message.getFirstMonthSubscriptionTotal();
    if (f.length > 0) writer.writeString(34, f);
    f = message.getPriceTermMonths();
    if (f.length > 0) writer.writeString(35, f);
    f = message.getSignatureImage();
    if (f.length > 0) writer.writeString(36, f);
    f = message.getAutonomyId();
    if (f.length > 0) writer.writeString(37, f);
    f = message.getCurrentMileage();
    if (f.length > 0) writer.writeString(38, f);
    f = message.getStartDate();
    if (f.length > 0) writer.writeString(39, f);
    f = message.getStartFee();
    if (f.length > 0) writer.writeString(40, f);
    f = message.getMonthlyFee();
    if (f.length > 0) writer.writeString(41, f);
    f = message.getNextMonthlyPayment();
    if (f.length > 0) writer.writeString(42, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vin = 3;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string odometer = 4;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getOdometer = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setOdometer = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string year = 5;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getYear = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setYear = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string model = 6;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string trim = 7;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string make = 8;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string paint = 9;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getPaint = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setPaint = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string agreement_date = 10;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getAgreementDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setAgreementDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string customer_account_number = 11;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getCustomerAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setCustomerAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional string customer_name = 12;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getCustomerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 12, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setCustomerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 12, value);
};
/**
 * optional string billing_address = 13;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getBillingAddress = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setBillingAddress = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional string subscription_base_monthly = 14;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionBaseMonthly = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 14, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionBaseMonthly = function(value) {
    return $8M67s.Message.setProto3StringField(this, 14, value);
};
/**
 * optional string insurance_monthly = 15;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getInsuranceMonthly = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 15, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setInsuranceMonthly = function(value) {
    return $8M67s.Message.setProto3StringField(this, 15, value);
};
/**
 * optional string insurance_monthly_tax = 16;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getInsuranceMonthlyTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 16, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setInsuranceMonthlyTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 16, value);
};
/**
 * optional string subscription_tax = 17;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 17, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 17, value);
};
/**
 * optional string subscription_total_monthly = 18;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionTotalMonthly = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 18, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionTotalMonthly = function(value) {
    return $8M67s.Message.setProto3StringField(this, 18, value);
};
/**
 * optional string subscription_total_monthly_tax = 19;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionTotalMonthlyTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 19, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionTotalMonthlyTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 19, value);
};
/**
 * optional string promo_code = 20;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getPromoCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 20, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setPromoCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 20, value);
};
/**
 * optional string promo_code_amount = 21;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getPromoCodeAmount = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 21, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setPromoCodeAmount = function(value) {
    return $8M67s.Message.setProto3StringField(this, 21, value);
};
/**
 * optional string billed_monthly_starting_on = 22;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getBilledMonthlyStartingOn = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 22, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setBilledMonthlyStartingOn = function(value) {
    return $8M67s.Message.setProto3StringField(this, 22, value);
};
/**
 * optional string subscription_excess_mileage_rate = 23;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionExcessMileageRate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 23, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionExcessMileageRate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 23, value);
};
/**
 * optional string insurance_excess_mileage_rate = 24;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getInsuranceExcessMileageRate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 24, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setInsuranceExcessMileageRate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 24, value);
};
/**
 * optional string reservation_fee = 25;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getReservationFee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 25, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setReservationFee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 25, value);
};
/**
 * optional string subscription_refundable_deposit = 26;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionRefundableDeposit = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 26, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionRefundableDeposit = function(value) {
    return $8M67s.Message.setProto3StringField(this, 26, value);
};
/**
 * optional string security_deposit_paid_last_four_statement = 27;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSecurityDepositPaidLastFourStatement = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 27, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSecurityDepositPaidLastFourStatement = function(value) {
    return $8M67s.Message.setProto3StringField(this, 27, value);
};
/**
 * optional string subscription_start_payment = 28;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionStartPayment = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 28, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionStartPayment = function(value) {
    return $8M67s.Message.setProto3StringField(this, 28, value);
};
/**
 * optional string subscription_start_payment_tax = 29;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionStartPaymentTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 29, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionStartPaymentTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 29, value);
};
/**
 * optional string drive_off_summary = 30;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getDriveOffSummary = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 30, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setDriveOffSummary = function(value) {
    return $8M67s.Message.setProto3StringField(this, 30, value);
};
/**
 * optional string drive_off_total_tax = 31;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getDriveOffTotalTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 31, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setDriveOffTotalTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 31, value);
};
/**
 * optional string subscription_total_due_to_start = 32;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSubscriptionTotalDueToStart = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 32, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSubscriptionTotalDueToStart = function(value) {
    return $8M67s.Message.setProto3StringField(this, 32, value);
};
/**
 * optional string first_month_subscription_tax = 33;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getFirstMonthSubscriptionTax = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 33, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setFirstMonthSubscriptionTax = function(value) {
    return $8M67s.Message.setProto3StringField(this, 33, value);
};
/**
 * optional string first_month_subscription_total = 34;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getFirstMonthSubscriptionTotal = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 34, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setFirstMonthSubscriptionTotal = function(value) {
    return $8M67s.Message.setProto3StringField(this, 34, value);
};
/**
 * optional string price_term_months = 35;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getPriceTermMonths = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 35, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setPriceTermMonths = function(value) {
    return $8M67s.Message.setProto3StringField(this, 35, value);
};
/**
 * optional string signature_image = 36;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getSignatureImage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 36, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setSignatureImage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 36, value);
};
/**
 * optional string autonomy_id = 37;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getAutonomyId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 37, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setAutonomyId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 37, value);
};
/**
 * optional string current_mileage = 38;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getCurrentMileage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 38, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setCurrentMileage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 38, value);
};
/**
 * optional string start_date = 39;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getStartDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 39, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setStartDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 39, value);
};
/**
 * optional string start_fee = 40;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getStartFee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 40, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setStartFee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 40, value);
};
/**
 * optional string monthly_fee = 41;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getMonthlyFee = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 41, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setMonthlyFee = function(value) {
    return $8M67s.Message.setProto3StringField(this, 41, value);
};
/**
 * optional string next_monthly_payment = 42;
 * @return {string}
 */ proto.contract_service.ContractProperties.prototype.getNextMonthlyPayment = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 42, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.ContractProperties} returns this
 */ proto.contract_service.ContractProperties.prototype.setNextMonthlyPayment = function(value) {
    return $8M67s.Message.setProto3StringField(this, 42, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.SignContractResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.SignContractResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.SignContractResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.SignContractResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            version: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.SignContractResponse}
 */ proto.contract_service.SignContractResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.SignContractResponse;
    return proto.contract_service.SignContractResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.SignContractResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.SignContractResponse}
 */ proto.contract_service.SignContractResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.SignContractResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.SignContractResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.SignContractResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.SignContractResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.contract_service.SignContractResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SignContractResponse} returns this
 */ proto.contract_service.SignContractResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.contract_service.SignContractResponse.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.contract_service.SignContractResponse} returns this
 */ proto.contract_service.SignContractResponse.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.contract_service.SignContractResponse.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SignContractResponse} returns this
 */ proto.contract_service.SignContractResponse.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional int64 version = 4;
 * @return {number}
 */ proto.contract_service.SignContractResponse.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.contract_service.SignContractResponse} returns this
 */ proto.contract_service.SignContractResponse.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.AddTemplateRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.AddTemplateRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.AddTemplateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.AddTemplateRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            contractType: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            template: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            legalCopy: (f = msg.getLegalCopy()) && proto.contract_service.LegalCopy.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.AddTemplateRequest}
 */ proto.contract_service.AddTemplateRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.AddTemplateRequest;
    return proto.contract_service.AddTemplateRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.AddTemplateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.AddTemplateRequest}
 */ proto.contract_service.AddTemplateRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.contract_service.ContractType} */ reader.readEnum();
                msg.setContractType(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTemplate(value);
                break;
            case 3:
                var value = new proto.contract_service.LegalCopy;
                reader.readMessage(value, proto.contract_service.LegalCopy.deserializeBinaryFromReader);
                msg.setLegalCopy(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.AddTemplateRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.AddTemplateRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.AddTemplateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.AddTemplateRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getContractType();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getTemplate();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLegalCopy();
    if (f != null) writer.writeMessage(3, f, proto.contract_service.LegalCopy.serializeBinaryToWriter);
};
/**
 * optional ContractType contract_type = 1;
 * @return {!proto.contract_service.ContractType}
 */ proto.contract_service.AddTemplateRequest.prototype.getContractType = function() {
    return /** @type {!proto.contract_service.ContractType} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.contract_service.ContractType} value
 * @return {!proto.contract_service.AddTemplateRequest} returns this
 */ proto.contract_service.AddTemplateRequest.prototype.setContractType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string template = 2;
 * @return {string}
 */ proto.contract_service.AddTemplateRequest.prototype.getTemplate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.AddTemplateRequest} returns this
 */ proto.contract_service.AddTemplateRequest.prototype.setTemplate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional LegalCopy legal_copy = 3;
 * @return {?proto.contract_service.LegalCopy}
 */ proto.contract_service.AddTemplateRequest.prototype.getLegalCopy = function() {
    return /** @type{?proto.contract_service.LegalCopy} */ $8M67s.Message.getWrapperField(this, proto.contract_service.LegalCopy, 3);
};
/**
 * @param {?proto.contract_service.LegalCopy|undefined} value
 * @return {!proto.contract_service.AddTemplateRequest} returns this
*/ proto.contract_service.AddTemplateRequest.prototype.setLegalCopy = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.contract_service.AddTemplateRequest} returns this
 */ proto.contract_service.AddTemplateRequest.prototype.clearLegalCopy = function() {
    return this.setLegalCopy(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.contract_service.AddTemplateRequest.prototype.hasLegalCopy = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.LegalCopy.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.LegalCopy.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.LegalCopy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.LegalCopy.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionLegalCopy: (f = msg.getSubscriptionLegalCopy()) && proto.contract_service.SubscriptionLegalCopy.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.LegalCopy}
 */ proto.contract_service.LegalCopy.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.LegalCopy;
    return proto.contract_service.LegalCopy.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.LegalCopy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.LegalCopy}
 */ proto.contract_service.LegalCopy.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.contract_service.SubscriptionLegalCopy;
                reader.readMessage(value, proto.contract_service.SubscriptionLegalCopy.deserializeBinaryFromReader);
                msg.setSubscriptionLegalCopy(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.LegalCopy.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.LegalCopy.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.LegalCopy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.LegalCopy.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionLegalCopy();
    if (f != null) writer.writeMessage(1, f, proto.contract_service.SubscriptionLegalCopy.serializeBinaryToWriter);
};
/**
 * optional SubscriptionLegalCopy subscription_legal_copy = 1;
 * @return {?proto.contract_service.SubscriptionLegalCopy}
 */ proto.contract_service.LegalCopy.prototype.getSubscriptionLegalCopy = function() {
    return /** @type{?proto.contract_service.SubscriptionLegalCopy} */ $8M67s.Message.getWrapperField(this, proto.contract_service.SubscriptionLegalCopy, 1);
};
/**
 * @param {?proto.contract_service.SubscriptionLegalCopy|undefined} value
 * @return {!proto.contract_service.LegalCopy} returns this
*/ proto.contract_service.LegalCopy.prototype.setSubscriptionLegalCopy = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.contract_service.LegalCopy} returns this
 */ proto.contract_service.LegalCopy.prototype.clearSubscriptionLegalCopy = function() {
    return this.setSubscriptionLegalCopy(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.contract_service.LegalCopy.prototype.hasSubscriptionLegalCopy = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.contract_service.SubscriptionLegalCopy.repeatedFields_ = [
    1,
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.SubscriptionLegalCopy.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.SubscriptionLegalCopy.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.SubscriptionLegalCopy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.SubscriptionLegalCopy.toObject = function(includeInstance, msg) {
        var f, obj = {
            paragraphsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            excessMileageDisclaimerNoInsurance: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            excessMileageDisclaimerWithInsurance: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            bulletPointsList: (f = $8M67s.Message.getRepeatedField(msg, 4)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.SubscriptionLegalCopy}
 */ proto.contract_service.SubscriptionLegalCopy.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.SubscriptionLegalCopy;
    return proto.contract_service.SubscriptionLegalCopy.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.SubscriptionLegalCopy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.SubscriptionLegalCopy}
 */ proto.contract_service.SubscriptionLegalCopy.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addParagraphs(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setExcessMileageDisclaimerNoInsurance(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setExcessMileageDisclaimerWithInsurance(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.addBulletPoints(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.SubscriptionLegalCopy.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.SubscriptionLegalCopy.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.SubscriptionLegalCopy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.SubscriptionLegalCopy.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getParagraphsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
    f = message.getExcessMileageDisclaimerNoInsurance();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getExcessMileageDisclaimerWithInsurance();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getBulletPointsList();
    if (f.length > 0) writer.writeRepeatedString(4, f);
};
/**
 * repeated string paragraphs = 1;
 * @return {!Array<string>}
 */ proto.contract_service.SubscriptionLegalCopy.prototype.getParagraphsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.contract_service.SubscriptionLegalCopy} returns this
 */ proto.contract_service.SubscriptionLegalCopy.prototype.setParagraphsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.contract_service.SubscriptionLegalCopy} returns this
 */ proto.contract_service.SubscriptionLegalCopy.prototype.addParagraphs = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.contract_service.SubscriptionLegalCopy} returns this
 */ proto.contract_service.SubscriptionLegalCopy.prototype.clearParagraphsList = function() {
    return this.setParagraphsList([]);
};
/**
 * optional string excess_mileage_disclaimer_no_insurance = 2;
 * @return {string}
 */ proto.contract_service.SubscriptionLegalCopy.prototype.getExcessMileageDisclaimerNoInsurance = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SubscriptionLegalCopy} returns this
 */ proto.contract_service.SubscriptionLegalCopy.prototype.setExcessMileageDisclaimerNoInsurance = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string excess_mileage_disclaimer_with_insurance = 3;
 * @return {string}
 */ proto.contract_service.SubscriptionLegalCopy.prototype.getExcessMileageDisclaimerWithInsurance = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SubscriptionLegalCopy} returns this
 */ proto.contract_service.SubscriptionLegalCopy.prototype.setExcessMileageDisclaimerWithInsurance = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * repeated string bullet_points = 4;
 * @return {!Array<string>}
 */ proto.contract_service.SubscriptionLegalCopy.prototype.getBulletPointsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 4);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.contract_service.SubscriptionLegalCopy} returns this
 */ proto.contract_service.SubscriptionLegalCopy.prototype.setBulletPointsList = function(value) {
    return $8M67s.Message.setField(this, 4, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.contract_service.SubscriptionLegalCopy} returns this
 */ proto.contract_service.SubscriptionLegalCopy.prototype.addBulletPoints = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 4, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.contract_service.SubscriptionLegalCopy} returns this
 */ proto.contract_service.SubscriptionLegalCopy.prototype.clearBulletPointsList = function() {
    return this.setBulletPointsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.AddTemplateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.AddTemplateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.AddTemplateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.AddTemplateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            template: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            version: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.AddTemplateResponse}
 */ proto.contract_service.AddTemplateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.AddTemplateResponse;
    return proto.contract_service.AddTemplateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.AddTemplateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.AddTemplateResponse}
 */ proto.contract_service.AddTemplateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setTemplate(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.AddTemplateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.AddTemplateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.AddTemplateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.AddTemplateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTemplate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(2, f);
};
/**
 * optional string template = 1;
 * @return {string}
 */ proto.contract_service.AddTemplateResponse.prototype.getTemplate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.AddTemplateResponse} returns this
 */ proto.contract_service.AddTemplateResponse.prototype.setTemplate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 version = 2;
 * @return {number}
 */ proto.contract_service.AddTemplateResponse.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.contract_service.AddTemplateResponse} returns this
 */ proto.contract_service.AddTemplateResponse.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.SubscriptionContract.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.SubscriptionContract.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.SubscriptionContract} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.SubscriptionContract.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.SubscriptionContract}
 */ proto.contract_service.SubscriptionContract.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.SubscriptionContract;
    return proto.contract_service.SubscriptionContract.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.SubscriptionContract} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.SubscriptionContract}
 */ proto.contract_service.SubscriptionContract.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.SubscriptionContract.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.SubscriptionContract.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.SubscriptionContract} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.SubscriptionContract.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.contract_service.SubscriptionContract.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SubscriptionContract} returns this
 */ proto.contract_service.SubscriptionContract.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.contract_service.SubscriptionContract.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.contract_service.SubscriptionContract} returns this
 */ proto.contract_service.SubscriptionContract.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.contract_service.SubscriptionContract.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SubscriptionContract} returns this
 */ proto.contract_service.SubscriptionContract.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string document_uri = 4;
 * @return {string}
 */ proto.contract_service.SubscriptionContract.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.SubscriptionContract} returns this
 */ proto.contract_service.SubscriptionContract.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.PickupReceipt.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.PickupReceipt.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.PickupReceipt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.PickupReceipt.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            creationDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            documentUri: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.PickupReceipt}
 */ proto.contract_service.PickupReceipt.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.PickupReceipt;
    return proto.contract_service.PickupReceipt.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.PickupReceipt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.PickupReceipt}
 */ proto.contract_service.PickupReceipt.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreationDate(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDocumentUri(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.PickupReceipt.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.PickupReceipt.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.PickupReceipt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.PickupReceipt.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreationDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDocumentUri();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.contract_service.PickupReceipt.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.PickupReceipt} returns this
 */ proto.contract_service.PickupReceipt.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 creation_date = 2;
 * @return {number}
 */ proto.contract_service.PickupReceipt.prototype.getCreationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.contract_service.PickupReceipt} returns this
 */ proto.contract_service.PickupReceipt.prototype.setCreationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string subscription_id = 3;
 * @return {string}
 */ proto.contract_service.PickupReceipt.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.PickupReceipt} returns this
 */ proto.contract_service.PickupReceipt.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string document_uri = 4;
 * @return {string}
 */ proto.contract_service.PickupReceipt.prototype.getDocumentUri = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.PickupReceipt} returns this
 */ proto.contract_service.PickupReceipt.prototype.setDocumentUri = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.GetCustomerContractsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.GetCustomerContractsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.GetCustomerContractsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.GetCustomerContractsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.GetCustomerContractsRequest}
 */ proto.contract_service.GetCustomerContractsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.GetCustomerContractsRequest;
    return proto.contract_service.GetCustomerContractsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.GetCustomerContractsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.GetCustomerContractsRequest}
 */ proto.contract_service.GetCustomerContractsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.GetCustomerContractsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.GetCustomerContractsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.GetCustomerContractsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.GetCustomerContractsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.contract_service.GetCustomerContractsRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.GetCustomerContractsRequest} returns this
 */ proto.contract_service.GetCustomerContractsRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.contract_service.GetCustomerContractsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.GetCustomerContractsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.GetCustomerContractsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.GetCustomerContractsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.GetCustomerContractsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerContractsList: $8M67s.Message.toObjectList(msg.getCustomerContractsList(), proto.contract_service.CustomerContractMeta.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.GetCustomerContractsResponse}
 */ proto.contract_service.GetCustomerContractsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.GetCustomerContractsResponse;
    return proto.contract_service.GetCustomerContractsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.GetCustomerContractsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.GetCustomerContractsResponse}
 */ proto.contract_service.GetCustomerContractsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.contract_service.CustomerContractMeta;
                reader.readMessage(value, proto.contract_service.CustomerContractMeta.deserializeBinaryFromReader);
                msg.addCustomerContracts(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.GetCustomerContractsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.GetCustomerContractsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.GetCustomerContractsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.GetCustomerContractsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerContractsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.contract_service.CustomerContractMeta.serializeBinaryToWriter);
};
/**
 * repeated CustomerContractMeta customer_contracts = 1;
 * @return {!Array<!proto.contract_service.CustomerContractMeta>}
 */ proto.contract_service.GetCustomerContractsResponse.prototype.getCustomerContractsList = function() {
    return /** @type{!Array<!proto.contract_service.CustomerContractMeta>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.contract_service.CustomerContractMeta, 1);
};
/**
 * @param {!Array<!proto.contract_service.CustomerContractMeta>} value
 * @return {!proto.contract_service.GetCustomerContractsResponse} returns this
*/ proto.contract_service.GetCustomerContractsResponse.prototype.setCustomerContractsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.contract_service.CustomerContractMeta=} opt_value
 * @param {number=} opt_index
 * @return {!proto.contract_service.CustomerContractMeta}
 */ proto.contract_service.GetCustomerContractsResponse.prototype.addCustomerContracts = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.contract_service.CustomerContractMeta, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.contract_service.GetCustomerContractsResponse} returns this
 */ proto.contract_service.GetCustomerContractsResponse.prototype.clearCustomerContractsList = function() {
    return this.setCustomerContractsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.CustomerContractMeta.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.CustomerContractMeta.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.CustomerContractMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.CustomerContractMeta.toObject = function(includeInstance, msg) {
        var f, obj = {
            documentsByIdMap: (f = msg.getDocumentsByIdMap()) ? f.toObject(includeInstance, undefined) : [],
            contractsMap: (f = msg.getContractsMap()) ? f.toObject(includeInstance, proto.contract_service.SubscriptionContract.toObject) : [],
            pickupReceiptMap: (f = msg.getPickupReceiptMap()) ? f.toObject(includeInstance, proto.contract_service.PickupReceipt.toObject) : [],
            customerId: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.CustomerContractMeta}
 */ proto.contract_service.CustomerContractMeta.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.CustomerContractMeta;
    return proto.contract_service.CustomerContractMeta.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.CustomerContractMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.CustomerContractMeta}
 */ proto.contract_service.CustomerContractMeta.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = msg.getDocumentsByIdMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readString, null, "", "");
                });
                break;
            case 2:
                var value = msg.getContractsMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.contract_service.SubscriptionContract.deserializeBinaryFromReader, "", new proto.contract_service.SubscriptionContract());
                });
                break;
            case 4:
                var value = msg.getPickupReceiptMap();
                reader.readMessage(value, function(message, reader) {
                    $8M67s.Map.deserializeBinary(message, reader, $8M67s.BinaryReader.prototype.readString, $8M67s.BinaryReader.prototype.readMessage, proto.contract_service.PickupReceipt.deserializeBinaryFromReader, "", new proto.contract_service.PickupReceipt());
                });
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.CustomerContractMeta.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.CustomerContractMeta.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.CustomerContractMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.CustomerContractMeta.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDocumentsByIdMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(1, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeString);
    f = message.getContractsMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(2, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.contract_service.SubscriptionContract.serializeBinaryToWriter);
    f = message.getPickupReceiptMap(true);
    if (f && f.getLength() > 0) f.serializeBinary(4, writer, $8M67s.BinaryWriter.prototype.writeString, $8M67s.BinaryWriter.prototype.writeMessage, proto.contract_service.PickupReceipt.serializeBinaryToWriter);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * map<string, string> documents_by_id = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */ proto.contract_service.CustomerContractMeta.prototype.getDocumentsByIdMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,string>} */ $8M67s.Message.getMapField(this, 1, opt_noLazyCreate, null);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.contract_service.CustomerContractMeta} returns this
 */ proto.contract_service.CustomerContractMeta.prototype.clearDocumentsByIdMap = function() {
    this.getDocumentsByIdMap().clear();
    return this;
};
/**
 * map<string, SubscriptionContract> contracts = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.contract_service.SubscriptionContract>}
 */ proto.contract_service.CustomerContractMeta.prototype.getContractsMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.contract_service.SubscriptionContract>} */ $8M67s.Message.getMapField(this, 2, opt_noLazyCreate, proto.contract_service.SubscriptionContract);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.contract_service.CustomerContractMeta} returns this
 */ proto.contract_service.CustomerContractMeta.prototype.clearContractsMap = function() {
    this.getContractsMap().clear();
    return this;
};
/**
 * map<string, PickupReceipt> pickup_receipt = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.contract_service.PickupReceipt>}
 */ proto.contract_service.CustomerContractMeta.prototype.getPickupReceiptMap = function(opt_noLazyCreate) {
    return /** @type {!jspb.Map<string,!proto.contract_service.PickupReceipt>} */ $8M67s.Message.getMapField(this, 4, opt_noLazyCreate, proto.contract_service.PickupReceipt);
};
/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.contract_service.CustomerContractMeta} returns this
 */ proto.contract_service.CustomerContractMeta.prototype.clearPickupReceiptMap = function() {
    this.getPickupReceiptMap().clear();
    return this;
};
/**
 * optional string customer_id = 5;
 * @return {string}
 */ proto.contract_service.CustomerContractMeta.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.contract_service.CustomerContractMeta} returns this
 */ proto.contract_service.CustomerContractMeta.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.contract_service.PreviewCustomerContractResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.contract_service.PreviewCustomerContractResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.PreviewCustomerContractResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            pdfBytes: msg.getPdfBytes_asB64(),
            legalCopy: (f = msg.getLegalCopy()) && proto.contract_service.LegalCopy.toObject(includeInstance, f),
            version: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.contract_service.PreviewCustomerContractResponse}
 */ proto.contract_service.PreviewCustomerContractResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.contract_service.PreviewCustomerContractResponse;
    return proto.contract_service.PreviewCustomerContractResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.contract_service.PreviewCustomerContractResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.contract_service.PreviewCustomerContractResponse}
 */ proto.contract_service.PreviewCustomerContractResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!Uint8Array} */ reader.readBytes();
                msg.setPdfBytes(value);
                break;
            case 2:
                var value = new proto.contract_service.LegalCopy;
                reader.readMessage(value, proto.contract_service.LegalCopy.deserializeBinaryFromReader);
                msg.setLegalCopy(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setVersion(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.contract_service.PreviewCustomerContractResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.contract_service.PreviewCustomerContractResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.contract_service.PreviewCustomerContractResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPdfBytes_asU8();
    if (f.length > 0) writer.writeBytes(1, f);
    f = message.getLegalCopy();
    if (f != null) writer.writeMessage(2, f, proto.contract_service.LegalCopy.serializeBinaryToWriter);
    f = message.getVersion();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional bytes pdf_bytes = 1;
 * @return {!(string|Uint8Array)}
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.getPdfBytes = function() {
    return /** @type {!(string|Uint8Array)} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * optional bytes pdf_bytes = 1;
 * This is a type-conversion wrapper around `getPdfBytes()`
 * @return {string}
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.getPdfBytes_asB64 = function() {
    return /** @type {string} */ $8M67s.Message.bytesAsB64(this.getPdfBytes());
};
/**
 * optional bytes pdf_bytes = 1;
 * Note that Uint8Array is not supported on all browsers.
 * @see http://caniuse.com/Uint8Array
 * This is a type-conversion wrapper around `getPdfBytes()`
 * @return {!Uint8Array}
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.getPdfBytes_asU8 = function() {
    return /** @type {!Uint8Array} */ $8M67s.Message.bytesAsU8(this.getPdfBytes());
};
/**
 * @param {!(string|Uint8Array)} value
 * @return {!proto.contract_service.PreviewCustomerContractResponse} returns this
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.setPdfBytes = function(value) {
    return $8M67s.Message.setProto3BytesField(this, 1, value);
};
/**
 * optional LegalCopy legal_copy = 2;
 * @return {?proto.contract_service.LegalCopy}
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.getLegalCopy = function() {
    return /** @type{?proto.contract_service.LegalCopy} */ $8M67s.Message.getWrapperField(this, proto.contract_service.LegalCopy, 2);
};
/**
 * @param {?proto.contract_service.LegalCopy|undefined} value
 * @return {!proto.contract_service.PreviewCustomerContractResponse} returns this
*/ proto.contract_service.PreviewCustomerContractResponse.prototype.setLegalCopy = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.contract_service.PreviewCustomerContractResponse} returns this
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.clearLegalCopy = function() {
    return this.setLegalCopy(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.hasLegalCopy = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional int64 version = 3;
 * @return {number}
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.getVersion = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.contract_service.PreviewCustomerContractResponse} returns this
 */ proto.contract_service.PreviewCustomerContractResponse.prototype.setVersion = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * @enum {number}
 */ proto.contract_service.ContractType = {
    SUBSCRIPTION_CONTRACT: 0,
    PICKUP_RECEIPT: 1
};
$e930ba3d5946d461$var$goog.object.extend(module.exports, proto.contract_service);

});

parcelRegister("g1LOb", function(module, exports) {
// source: customer_support_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $bab1d31cc935585c$var$goog = $8M67s;
var $bab1d31cc935585c$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$bab1d31cc935585c$var$goog.object.extend(proto, $3QqPt);

var $9YICB = parcelRequire("9YICB");
$bab1d31cc935585c$var$goog.object.extend(proto, $9YICB);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.CustomerIdentity', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.CustomerInfo', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.CustomerInsuranceInfo', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.CustomerSubscriptions', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.CustomerVehicles', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.DateString', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.GetDealershipInfoRequest', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.GetDealershipInfoResponse', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.GetPermissionsRequest', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.Permissions', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.UpdateCustomerGarageAddressRequest', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.UpdateCustomerGarageAddressResponse', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.UpdateCustomerInfoRequest', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.UpdateCustomerInfoResponse', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.UpdateCustomerInsuranceInfoRequest', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.WipeTwilioFactorsRequest', null, $bab1d31cc935585c$var$global);
$bab1d31cc935585c$var$goog.exportSymbol('proto.customer_support_service.WipeTwilioFactorsResponse', null, $bab1d31cc935585c$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.GetPermissionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.GetPermissionsRequest, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.GetPermissionsRequest.displayName = 'proto.customer_support_service.GetPermissionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.Permissions = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_support_service.Permissions.repeatedFields_, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.Permissions, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.Permissions.displayName = 'proto.customer_support_service.Permissions';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.DateString = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.DateString, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.DateString.displayName = 'proto.customer_support_service.DateString';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.CustomerIdentity = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.CustomerIdentity, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.CustomerIdentity.displayName = 'proto.customer_support_service.CustomerIdentity';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.CustomerInfo = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_support_service.CustomerInfo.repeatedFields_, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.CustomerInfo, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.CustomerInfo.displayName = 'proto.customer_support_service.CustomerInfo';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.UpdateCustomerInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.UpdateCustomerInfoRequest, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.UpdateCustomerInfoRequest.displayName = 'proto.customer_support_service.UpdateCustomerInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.UpdateCustomerInfoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.UpdateCustomerInfoResponse, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.UpdateCustomerInfoResponse.displayName = 'proto.customer_support_service.UpdateCustomerInfoResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.UpdateCustomerGarageAddressRequest, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.displayName = 'proto.customer_support_service.UpdateCustomerGarageAddressRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.UpdateCustomerGarageAddressResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.UpdateCustomerGarageAddressResponse, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.UpdateCustomerGarageAddressResponse.displayName = 'proto.customer_support_service.UpdateCustomerGarageAddressResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.CustomerInsuranceInfo = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_support_service.CustomerInsuranceInfo.repeatedFields_, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.CustomerInsuranceInfo, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.CustomerInsuranceInfo.displayName = 'proto.customer_support_service.CustomerInsuranceInfo';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.repeatedFields_, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.UpdateCustomerInsuranceInfoRequest, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.displayName = 'proto.customer_support_service.UpdateCustomerInsuranceInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.CustomerSubscriptions = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_support_service.CustomerSubscriptions.repeatedFields_, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.CustomerSubscriptions, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.CustomerSubscriptions.displayName = 'proto.customer_support_service.CustomerSubscriptions';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.CustomerVehicles = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.customer_support_service.CustomerVehicles.repeatedFields_, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.CustomerVehicles, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.CustomerVehicles.displayName = 'proto.customer_support_service.CustomerVehicles';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.WipeTwilioFactorsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.WipeTwilioFactorsRequest, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.WipeTwilioFactorsRequest.displayName = 'proto.customer_support_service.WipeTwilioFactorsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.WipeTwilioFactorsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.WipeTwilioFactorsResponse, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.WipeTwilioFactorsResponse.displayName = 'proto.customer_support_service.WipeTwilioFactorsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.GetDealershipInfoRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.GetDealershipInfoRequest, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.GetDealershipInfoRequest.displayName = 'proto.customer_support_service.GetDealershipInfoRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.customer_support_service.GetDealershipInfoResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$bab1d31cc935585c$var$goog.inherits(proto.customer_support_service.GetDealershipInfoResponse, $8M67s.Message);
if ($bab1d31cc935585c$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.customer_support_service.GetDealershipInfoResponse.displayName = 'proto.customer_support_service.GetDealershipInfoResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.GetPermissionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.GetPermissionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.GetPermissionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.GetPermissionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.GetPermissionsRequest}
 */ proto.customer_support_service.GetPermissionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.GetPermissionsRequest;
    return proto.customer_support_service.GetPermissionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.GetPermissionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.GetPermissionsRequest}
 */ proto.customer_support_service.GetPermissionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.GetPermissionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.GetPermissionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.GetPermissionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.GetPermissionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_support_service.Permissions.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.Permissions.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.Permissions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.Permissions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.Permissions.toObject = function(includeInstance, msg) {
        var f, obj = {
            accessibleMethodsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.Permissions}
 */ proto.customer_support_service.Permissions.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.Permissions;
    return proto.customer_support_service.Permissions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.Permissions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.Permissions}
 */ proto.customer_support_service.Permissions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addAccessibleMethods(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.Permissions.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.Permissions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.Permissions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.Permissions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getAccessibleMethodsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string accessible_methods = 1;
 * @return {!Array<string>}
 */ proto.customer_support_service.Permissions.prototype.getAccessibleMethodsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.customer_support_service.Permissions} returns this
 */ proto.customer_support_service.Permissions.prototype.setAccessibleMethodsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.customer_support_service.Permissions} returns this
 */ proto.customer_support_service.Permissions.prototype.addAccessibleMethods = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_support_service.Permissions} returns this
 */ proto.customer_support_service.Permissions.prototype.clearAccessibleMethodsList = function() {
    return this.setAccessibleMethodsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.DateString.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.DateString.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.DateString} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.DateString.toObject = function(includeInstance, msg) {
        var f, obj = {
            yyyyMmDd: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.DateString}
 */ proto.customer_support_service.DateString.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.DateString;
    return proto.customer_support_service.DateString.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.DateString} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.DateString}
 */ proto.customer_support_service.DateString.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setYyyyMmDd(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.DateString.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.DateString.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.DateString} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.DateString.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getYyyyMmDd();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string yyyy_mm_dd = 1;
 * @return {string}
 */ proto.customer_support_service.DateString.prototype.getYyyyMmDd = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.DateString} returns this
 */ proto.customer_support_service.DateString.prototype.setYyyyMmDd = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.CustomerIdentity.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.CustomerIdentity.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.CustomerIdentity} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerIdentity.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.CustomerIdentity}
 */ proto.customer_support_service.CustomerIdentity.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.CustomerIdentity;
    return proto.customer_support_service.CustomerIdentity.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.CustomerIdentity} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.CustomerIdentity}
 */ proto.customer_support_service.CustomerIdentity.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.CustomerIdentity.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.CustomerIdentity.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.CustomerIdentity} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerIdentity.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_support_service.CustomerIdentity.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.CustomerIdentity} returns this
 */ proto.customer_support_service.CustomerIdentity.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_support_service.CustomerInfo.repeatedFields_ = [
    8,
    9
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.CustomerInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.CustomerInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.CustomerInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            accountNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            firstName: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lastName: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            language: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            phone: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            addressesList: $8M67s.Message.toObjectList(msg.getAddressesList(), $3QqPt.Address.toObject, includeInstance),
            imagesList: $8M67s.Message.toObjectList(msg.getImagesList(), $3QqPt.Image.toObject, includeInstance),
            licenseExpirationDate: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            dateOfBirth: $8M67s.Message.getFieldWithDefault(msg, 11, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.CustomerInfo}
 */ proto.customer_support_service.CustomerInfo.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.CustomerInfo;
    return proto.customer_support_service.CustomerInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.CustomerInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.CustomerInfo}
 */ proto.customer_support_service.CustomerInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFirstName(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLastName(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLanguage(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 8:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.addAddresses(value);
                break;
            case 9:
                var value = new $3QqPt.Image;
                reader.readMessage(value, $3QqPt.Image.deserializeBinaryFromReader);
                msg.addImages(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLicenseExpirationDate(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDateOfBirth(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.CustomerInfo.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.CustomerInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.CustomerInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAccountNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFirstName();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLastName();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getLanguage();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getAddressesList();
    if (f.length > 0) writer.writeRepeatedMessage(8, f, $3QqPt.Address.serializeBinaryToWriter);
    f = message.getImagesList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, $3QqPt.Image.serializeBinaryToWriter);
    f = message.getLicenseExpirationDate();
    if (f !== 0) writer.writeInt64(10, f);
    f = message.getDateOfBirth();
    if (f !== 0) writer.writeInt64(11, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.customer_support_service.CustomerInfo.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string account_number = 2;
 * @return {string}
 */ proto.customer_support_service.CustomerInfo.prototype.getAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string first_name = 3;
 * @return {string}
 */ proto.customer_support_service.CustomerInfo.prototype.getFirstName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setFirstName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string last_name = 4;
 * @return {string}
 */ proto.customer_support_service.CustomerInfo.prototype.getLastName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setLastName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string language = 5;
 * @return {string}
 */ proto.customer_support_service.CustomerInfo.prototype.getLanguage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setLanguage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string phone = 6;
 * @return {string}
 */ proto.customer_support_service.CustomerInfo.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string email = 7;
 * @return {string}
 */ proto.customer_support_service.CustomerInfo.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * repeated domain.Address addresses = 8;
 * @return {!Array<!proto.domain.Address>}
 */ proto.customer_support_service.CustomerInfo.prototype.getAddressesList = function() {
    return /** @type{!Array<!proto.domain.Address>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Address, 8);
};
/**
 * @param {!Array<!proto.domain.Address>} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
*/ proto.customer_support_service.CustomerInfo.prototype.setAddressesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.domain.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Address}
 */ proto.customer_support_service.CustomerInfo.prototype.addAddresses = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.domain.Address, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.clearAddressesList = function() {
    return this.setAddressesList([]);
};
/**
 * repeated domain.Image images = 9;
 * @return {!Array<!proto.domain.Image>}
 */ proto.customer_support_service.CustomerInfo.prototype.getImagesList = function() {
    return /** @type{!Array<!proto.domain.Image>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Image, 9);
};
/**
 * @param {!Array<!proto.domain.Image>} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
*/ proto.customer_support_service.CustomerInfo.prototype.setImagesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.domain.Image=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Image}
 */ proto.customer_support_service.CustomerInfo.prototype.addImages = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.domain.Image, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.clearImagesList = function() {
    return this.setImagesList([]);
};
/**
 * optional int64 license_expiration_date = 10;
 * @return {number}
 */ proto.customer_support_service.CustomerInfo.prototype.getLicenseExpirationDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setLicenseExpirationDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int64 date_of_birth = 11;
 * @return {number}
 */ proto.customer_support_service.CustomerInfo.prototype.getDateOfBirth = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_support_service.CustomerInfo} returns this
 */ proto.customer_support_service.CustomerInfo.prototype.setDateOfBirth = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.UpdateCustomerInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.UpdateCustomerInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: (f = msg.getId()) && proto.customer_support_service.CustomerIdentity.toObject(includeInstance, f),
            phone: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            serviceAddress: (f = msg.getServiceAddress()) && $3QqPt.Address.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.UpdateCustomerInfoRequest}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.UpdateCustomerInfoRequest;
    return proto.customer_support_service.UpdateCustomerInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.UpdateCustomerInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.UpdateCustomerInfoRequest}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_support_service.CustomerIdentity;
                reader.readMessage(value, proto.customer_support_service.CustomerIdentity.deserializeBinaryFromReader);
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 4:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setServiceAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.UpdateCustomerInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.UpdateCustomerInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f != null) writer.writeMessage(1, f, proto.customer_support_service.CustomerIdentity.serializeBinaryToWriter);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getServiceAddress();
    if (f != null) writer.writeMessage(4, f, $3QqPt.Address.serializeBinaryToWriter);
};
/**
 * optional CustomerIdentity id = 1;
 * @return {?proto.customer_support_service.CustomerIdentity}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.getId = function() {
    return /** @type{?proto.customer_support_service.CustomerIdentity} */ $8M67s.Message.getWrapperField(this, proto.customer_support_service.CustomerIdentity, 1);
};
/**
 * @param {?proto.customer_support_service.CustomerIdentity|undefined} value
 * @return {!proto.customer_support_service.UpdateCustomerInfoRequest} returns this
*/ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.setId = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.UpdateCustomerInfoRequest} returns this
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.clearId = function() {
    return this.setId(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.hasId = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional string phone = 2;
 * @return {string}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.UpdateCustomerInfoRequest} returns this
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string email = 3;
 * @return {string}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.UpdateCustomerInfoRequest} returns this
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional domain.Address service_address = 4;
 * @return {?proto.domain.Address}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.getServiceAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 4);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.customer_support_service.UpdateCustomerInfoRequest} returns this
*/ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.setServiceAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.UpdateCustomerInfoRequest} returns this
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.clearServiceAddress = function() {
    return this.setServiceAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.UpdateCustomerInfoRequest.prototype.hasServiceAddress = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.UpdateCustomerInfoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.UpdateCustomerInfoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.UpdateCustomerInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerInfoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.UpdateCustomerInfoResponse}
 */ proto.customer_support_service.UpdateCustomerInfoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.UpdateCustomerInfoResponse;
    return proto.customer_support_service.UpdateCustomerInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.UpdateCustomerInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.UpdateCustomerInfoResponse}
 */ proto.customer_support_service.UpdateCustomerInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.UpdateCustomerInfoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.UpdateCustomerInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.UpdateCustomerInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerInfoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.UpdateCustomerGarageAddressRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            garageAddress: (f = msg.getGarageAddress()) && $3QqPt.Address.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.UpdateCustomerGarageAddressRequest}
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.UpdateCustomerGarageAddressRequest;
    return proto.customer_support_service.UpdateCustomerGarageAddressRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.UpdateCustomerGarageAddressRequest}
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new $3QqPt.Address;
                reader.readMessage(value, $3QqPt.Address.deserializeBinaryFromReader);
                msg.setGarageAddress(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.UpdateCustomerGarageAddressRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getGarageAddress();
    if (f != null) writer.writeMessage(2, f, $3QqPt.Address.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} returns this
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional domain.Address garage_address = 2;
 * @return {?proto.domain.Address}
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.prototype.getGarageAddress = function() {
    return /** @type{?proto.domain.Address} */ $8M67s.Message.getWrapperField(this, $3QqPt.Address, 2);
};
/**
 * @param {?proto.domain.Address|undefined} value
 * @return {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} returns this
*/ proto.customer_support_service.UpdateCustomerGarageAddressRequest.prototype.setGarageAddress = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} returns this
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.prototype.clearGarageAddress = function() {
    return this.setGarageAddress(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.UpdateCustomerGarageAddressRequest.prototype.hasGarageAddress = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.UpdateCustomerGarageAddressResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.UpdateCustomerGarageAddressResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.UpdateCustomerGarageAddressResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerGarageAddressResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.UpdateCustomerGarageAddressResponse}
 */ proto.customer_support_service.UpdateCustomerGarageAddressResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.UpdateCustomerGarageAddressResponse;
    return proto.customer_support_service.UpdateCustomerGarageAddressResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.UpdateCustomerGarageAddressResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.UpdateCustomerGarageAddressResponse}
 */ proto.customer_support_service.UpdateCustomerGarageAddressResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.UpdateCustomerGarageAddressResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.UpdateCustomerGarageAddressResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.UpdateCustomerGarageAddressResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerGarageAddressResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_support_service.CustomerInsuranceInfo.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.CustomerInsuranceInfo.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.CustomerInsuranceInfo.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.CustomerInsuranceInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerInsuranceInfo.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: (f = msg.getId()) && proto.customer_support_service.CustomerIdentity.toObject(includeInstance, f),
            insurancePoliciesList: $8M67s.Message.toObjectList(msg.getInsurancePoliciesList(), $3QqPt.InsurancePolicy.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.CustomerInsuranceInfo}
 */ proto.customer_support_service.CustomerInsuranceInfo.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.CustomerInsuranceInfo;
    return proto.customer_support_service.CustomerInsuranceInfo.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.CustomerInsuranceInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.CustomerInsuranceInfo}
 */ proto.customer_support_service.CustomerInsuranceInfo.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_support_service.CustomerIdentity;
                reader.readMessage(value, proto.customer_support_service.CustomerIdentity.deserializeBinaryFromReader);
                msg.setId(value);
                break;
            case 2:
                var value = new $3QqPt.InsurancePolicy;
                reader.readMessage(value, $3QqPt.InsurancePolicy.deserializeBinaryFromReader);
                msg.addInsurancePolicies(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.CustomerInsuranceInfo.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.CustomerInsuranceInfo.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.CustomerInsuranceInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerInsuranceInfo.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f != null) writer.writeMessage(1, f, proto.customer_support_service.CustomerIdentity.serializeBinaryToWriter);
    f = message.getInsurancePoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.InsurancePolicy.serializeBinaryToWriter);
};
/**
 * optional CustomerIdentity id = 1;
 * @return {?proto.customer_support_service.CustomerIdentity}
 */ proto.customer_support_service.CustomerInsuranceInfo.prototype.getId = function() {
    return /** @type{?proto.customer_support_service.CustomerIdentity} */ $8M67s.Message.getWrapperField(this, proto.customer_support_service.CustomerIdentity, 1);
};
/**
 * @param {?proto.customer_support_service.CustomerIdentity|undefined} value
 * @return {!proto.customer_support_service.CustomerInsuranceInfo} returns this
*/ proto.customer_support_service.CustomerInsuranceInfo.prototype.setId = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.CustomerInsuranceInfo} returns this
 */ proto.customer_support_service.CustomerInsuranceInfo.prototype.clearId = function() {
    return this.setId(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.CustomerInsuranceInfo.prototype.hasId = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated domain.InsurancePolicy insurance_policies = 2;
 * @return {!Array<!proto.domain.InsurancePolicy>}
 */ proto.customer_support_service.CustomerInsuranceInfo.prototype.getInsurancePoliciesList = function() {
    return /** @type{!Array<!proto.domain.InsurancePolicy>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.InsurancePolicy, 2);
};
/**
 * @param {!Array<!proto.domain.InsurancePolicy>} value
 * @return {!proto.customer_support_service.CustomerInsuranceInfo} returns this
*/ proto.customer_support_service.CustomerInsuranceInfo.prototype.setInsurancePoliciesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.InsurancePolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.InsurancePolicy}
 */ proto.customer_support_service.CustomerInsuranceInfo.prototype.addInsurancePolicies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.InsurancePolicy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_support_service.CustomerInsuranceInfo} returns this
 */ proto.customer_support_service.CustomerInsuranceInfo.prototype.clearInsurancePoliciesList = function() {
    return this.setInsurancePoliciesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: (f = msg.getId()) && proto.customer_support_service.CustomerIdentity.toObject(includeInstance, f),
            insurancePoliciesList: $8M67s.Message.toObjectList(msg.getInsurancePoliciesList(), $3QqPt.InsurancePolicy.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest}
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.UpdateCustomerInsuranceInfoRequest;
    return proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest}
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_support_service.CustomerIdentity;
                reader.readMessage(value, proto.customer_support_service.CustomerIdentity.deserializeBinaryFromReader);
                msg.setId(value);
                break;
            case 2:
                var value = new $3QqPt.InsurancePolicy;
                reader.readMessage(value, $3QqPt.InsurancePolicy.deserializeBinaryFromReader);
                msg.addInsurancePolicies(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f != null) writer.writeMessage(1, f, proto.customer_support_service.CustomerIdentity.serializeBinaryToWriter);
    f = message.getInsurancePoliciesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.InsurancePolicy.serializeBinaryToWriter);
};
/**
 * optional CustomerIdentity id = 1;
 * @return {?proto.customer_support_service.CustomerIdentity}
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.getId = function() {
    return /** @type{?proto.customer_support_service.CustomerIdentity} */ $8M67s.Message.getWrapperField(this, proto.customer_support_service.CustomerIdentity, 1);
};
/**
 * @param {?proto.customer_support_service.CustomerIdentity|undefined} value
 * @return {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} returns this
*/ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.setId = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} returns this
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.clearId = function() {
    return this.setId(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.hasId = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated domain.InsurancePolicy insurance_policies = 2;
 * @return {!Array<!proto.domain.InsurancePolicy>}
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.getInsurancePoliciesList = function() {
    return /** @type{!Array<!proto.domain.InsurancePolicy>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.InsurancePolicy, 2);
};
/**
 * @param {!Array<!proto.domain.InsurancePolicy>} value
 * @return {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} returns this
*/ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.setInsurancePoliciesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.InsurancePolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.InsurancePolicy}
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.addInsurancePolicies = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.InsurancePolicy, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} returns this
 */ proto.customer_support_service.UpdateCustomerInsuranceInfoRequest.prototype.clearInsurancePoliciesList = function() {
    return this.setInsurancePoliciesList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_support_service.CustomerSubscriptions.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.CustomerSubscriptions.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.CustomerSubscriptions.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.CustomerSubscriptions} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerSubscriptions.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: (f = msg.getId()) && proto.customer_support_service.CustomerIdentity.toObject(includeInstance, f),
            subscriptionsList: $8M67s.Message.toObjectList(msg.getSubscriptionsList(), $3QqPt.Subscription.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.CustomerSubscriptions}
 */ proto.customer_support_service.CustomerSubscriptions.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.CustomerSubscriptions;
    return proto.customer_support_service.CustomerSubscriptions.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.CustomerSubscriptions} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.CustomerSubscriptions}
 */ proto.customer_support_service.CustomerSubscriptions.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_support_service.CustomerIdentity;
                reader.readMessage(value, proto.customer_support_service.CustomerIdentity.deserializeBinaryFromReader);
                msg.setId(value);
                break;
            case 2:
                var value = new $3QqPt.Subscription;
                reader.readMessage(value, $3QqPt.Subscription.deserializeBinaryFromReader);
                msg.addSubscriptions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.CustomerSubscriptions.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.CustomerSubscriptions.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.CustomerSubscriptions} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerSubscriptions.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f != null) writer.writeMessage(1, f, proto.customer_support_service.CustomerIdentity.serializeBinaryToWriter);
    f = message.getSubscriptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.Subscription.serializeBinaryToWriter);
};
/**
 * optional CustomerIdentity id = 1;
 * @return {?proto.customer_support_service.CustomerIdentity}
 */ proto.customer_support_service.CustomerSubscriptions.prototype.getId = function() {
    return /** @type{?proto.customer_support_service.CustomerIdentity} */ $8M67s.Message.getWrapperField(this, proto.customer_support_service.CustomerIdentity, 1);
};
/**
 * @param {?proto.customer_support_service.CustomerIdentity|undefined} value
 * @return {!proto.customer_support_service.CustomerSubscriptions} returns this
*/ proto.customer_support_service.CustomerSubscriptions.prototype.setId = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.CustomerSubscriptions} returns this
 */ proto.customer_support_service.CustomerSubscriptions.prototype.clearId = function() {
    return this.setId(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.CustomerSubscriptions.prototype.hasId = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated domain.Subscription subscriptions = 2;
 * @return {!Array<!proto.domain.Subscription>}
 */ proto.customer_support_service.CustomerSubscriptions.prototype.getSubscriptionsList = function() {
    return /** @type{!Array<!proto.domain.Subscription>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Subscription, 2);
};
/**
 * @param {!Array<!proto.domain.Subscription>} value
 * @return {!proto.customer_support_service.CustomerSubscriptions} returns this
*/ proto.customer_support_service.CustomerSubscriptions.prototype.setSubscriptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.Subscription=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Subscription}
 */ proto.customer_support_service.CustomerSubscriptions.prototype.addSubscriptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.Subscription, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_support_service.CustomerSubscriptions} returns this
 */ proto.customer_support_service.CustomerSubscriptions.prototype.clearSubscriptionsList = function() {
    return this.setSubscriptionsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.customer_support_service.CustomerVehicles.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.CustomerVehicles.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.CustomerVehicles.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.CustomerVehicles} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerVehicles.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: (f = msg.getId()) && proto.customer_support_service.CustomerIdentity.toObject(includeInstance, f),
            vehiclesList: $8M67s.Message.toObjectList(msg.getVehiclesList(), $9YICB.Vehicle.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.CustomerVehicles}
 */ proto.customer_support_service.CustomerVehicles.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.CustomerVehicles;
    return proto.customer_support_service.CustomerVehicles.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.CustomerVehicles} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.CustomerVehicles}
 */ proto.customer_support_service.CustomerVehicles.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_support_service.CustomerIdentity;
                reader.readMessage(value, proto.customer_support_service.CustomerIdentity.deserializeBinaryFromReader);
                msg.setId(value);
                break;
            case 2:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.addVehicles(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.CustomerVehicles.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.CustomerVehicles.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.CustomerVehicles} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.CustomerVehicles.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f != null) writer.writeMessage(1, f, proto.customer_support_service.CustomerIdentity.serializeBinaryToWriter);
    f = message.getVehiclesList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional CustomerIdentity id = 1;
 * @return {?proto.customer_support_service.CustomerIdentity}
 */ proto.customer_support_service.CustomerVehicles.prototype.getId = function() {
    return /** @type{?proto.customer_support_service.CustomerIdentity} */ $8M67s.Message.getWrapperField(this, proto.customer_support_service.CustomerIdentity, 1);
};
/**
 * @param {?proto.customer_support_service.CustomerIdentity|undefined} value
 * @return {!proto.customer_support_service.CustomerVehicles} returns this
*/ proto.customer_support_service.CustomerVehicles.prototype.setId = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.CustomerVehicles} returns this
 */ proto.customer_support_service.CustomerVehicles.prototype.clearId = function() {
    return this.setId(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.CustomerVehicles.prototype.hasId = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * repeated vehicle.Vehicle vehicles = 2;
 * @return {!Array<!proto.vehicle.Vehicle>}
 */ proto.customer_support_service.CustomerVehicles.prototype.getVehiclesList = function() {
    return /** @type{!Array<!proto.vehicle.Vehicle>} */ $8M67s.Message.getRepeatedWrapperField(this, $9YICB.Vehicle, 2);
};
/**
 * @param {!Array<!proto.vehicle.Vehicle>} value
 * @return {!proto.customer_support_service.CustomerVehicles} returns this
*/ proto.customer_support_service.CustomerVehicles.prototype.setVehiclesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.vehicle.Vehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Vehicle}
 */ proto.customer_support_service.CustomerVehicles.prototype.addVehicles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vehicle.Vehicle, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.customer_support_service.CustomerVehicles} returns this
 */ proto.customer_support_service.CustomerVehicles.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.WipeTwilioFactorsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.WipeTwilioFactorsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.WipeTwilioFactorsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.WipeTwilioFactorsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: (f = msg.getId()) && proto.customer_support_service.CustomerIdentity.toObject(includeInstance, f),
            isSandbox: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.WipeTwilioFactorsRequest}
 */ proto.customer_support_service.WipeTwilioFactorsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.WipeTwilioFactorsRequest;
    return proto.customer_support_service.WipeTwilioFactorsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.WipeTwilioFactorsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.WipeTwilioFactorsRequest}
 */ proto.customer_support_service.WipeTwilioFactorsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.customer_support_service.CustomerIdentity;
                reader.readMessage(value, proto.customer_support_service.CustomerIdentity.deserializeBinaryFromReader);
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsSandbox(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.WipeTwilioFactorsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.WipeTwilioFactorsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.WipeTwilioFactorsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.WipeTwilioFactorsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f != null) writer.writeMessage(1, f, proto.customer_support_service.CustomerIdentity.serializeBinaryToWriter);
    f = message.getIsSandbox();
    if (f) writer.writeBool(2, f);
};
/**
 * optional CustomerIdentity id = 1;
 * @return {?proto.customer_support_service.CustomerIdentity}
 */ proto.customer_support_service.WipeTwilioFactorsRequest.prototype.getId = function() {
    return /** @type{?proto.customer_support_service.CustomerIdentity} */ $8M67s.Message.getWrapperField(this, proto.customer_support_service.CustomerIdentity, 1);
};
/**
 * @param {?proto.customer_support_service.CustomerIdentity|undefined} value
 * @return {!proto.customer_support_service.WipeTwilioFactorsRequest} returns this
*/ proto.customer_support_service.WipeTwilioFactorsRequest.prototype.setId = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.WipeTwilioFactorsRequest} returns this
 */ proto.customer_support_service.WipeTwilioFactorsRequest.prototype.clearId = function() {
    return this.setId(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.WipeTwilioFactorsRequest.prototype.hasId = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional bool is_sandbox = 2;
 * @return {boolean}
 */ proto.customer_support_service.WipeTwilioFactorsRequest.prototype.getIsSandbox = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.customer_support_service.WipeTwilioFactorsRequest} returns this
 */ proto.customer_support_service.WipeTwilioFactorsRequest.prototype.setIsSandbox = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.WipeTwilioFactorsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.WipeTwilioFactorsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.WipeTwilioFactorsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.WipeTwilioFactorsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.WipeTwilioFactorsResponse}
 */ proto.customer_support_service.WipeTwilioFactorsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.WipeTwilioFactorsResponse;
    return proto.customer_support_service.WipeTwilioFactorsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.WipeTwilioFactorsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.WipeTwilioFactorsResponse}
 */ proto.customer_support_service.WipeTwilioFactorsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.WipeTwilioFactorsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.WipeTwilioFactorsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.WipeTwilioFactorsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.WipeTwilioFactorsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.GetDealershipInfoRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.GetDealershipInfoRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.GetDealershipInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.GetDealershipInfoRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.GetDealershipInfoRequest}
 */ proto.customer_support_service.GetDealershipInfoRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.GetDealershipInfoRequest;
    return proto.customer_support_service.GetDealershipInfoRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.GetDealershipInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.GetDealershipInfoRequest}
 */ proto.customer_support_service.GetDealershipInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setDealershipId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.GetDealershipInfoRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.GetDealershipInfoRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.GetDealershipInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.GetDealershipInfoRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string dealership_id = 1;
 * @return {string}
 */ proto.customer_support_service.GetDealershipInfoRequest.prototype.getDealershipId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.GetDealershipInfoRequest} returns this
 */ proto.customer_support_service.GetDealershipInfoRequest.prototype.setDealershipId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.customer_support_service.GetDealershipInfoResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.customer_support_service.GetDealershipInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.GetDealershipInfoResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            error: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            dealership: (f = msg.getDealership()) && $3QqPt.Dealership.toObject(includeInstance, f),
            errorCode: $8M67s.Message.getFieldWithDefault(msg, 4, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.customer_support_service.GetDealershipInfoResponse}
 */ proto.customer_support_service.GetDealershipInfoResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.customer_support_service.GetDealershipInfoResponse;
    return proto.customer_support_service.GetDealershipInfoResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.customer_support_service.GetDealershipInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.customer_support_service.GetDealershipInfoResponse}
 */ proto.customer_support_service.GetDealershipInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setError(value);
                break;
            case 3:
                var value = new $3QqPt.Dealership;
                reader.readMessage(value, $3QqPt.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setErrorCode(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.customer_support_service.GetDealershipInfoResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.customer_support_service.GetDealershipInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.customer_support_service.GetDealershipInfoResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getError();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDealership();
    if (f != null) writer.writeMessage(3, f, $3QqPt.Dealership.serializeBinaryToWriter);
    f = message.getErrorCode();
    if (f !== 0) writer.writeInt32(4, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.customer_support_service.GetDealershipInfoResponse} returns this
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string error = 2;
 * @return {string}
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.getError = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.customer_support_service.GetDealershipInfoResponse} returns this
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.setError = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional domain.Dealership dealership = 3;
 * @return {?proto.domain.Dealership}
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.getDealership = function() {
    return /** @type{?proto.domain.Dealership} */ $8M67s.Message.getWrapperField(this, $3QqPt.Dealership, 3);
};
/**
 * @param {?proto.domain.Dealership|undefined} value
 * @return {!proto.customer_support_service.GetDealershipInfoResponse} returns this
*/ proto.customer_support_service.GetDealershipInfoResponse.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 3, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.customer_support_service.GetDealershipInfoResponse} returns this
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 3) != null;
};
/**
 * optional int32 error_code = 4;
 * @return {number}
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.getErrorCode = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.customer_support_service.GetDealershipInfoResponse} returns this
 */ proto.customer_support_service.GetDealershipInfoResponse.prototype.setErrorCode = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
$bab1d31cc935585c$var$goog.object.extend(module.exports, proto.customer_support_service);

});

parcelRegister("eAp0I", function(module, exports) {
// source: notification_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $a9e7d4098ba69953$var$goog = $8M67s;
var $a9e7d4098ba69953$var$global = Function('return this')();

var $3DbSe = parcelRequire("3DbSe");
$a9e7d4098ba69953$var$goog.object.extend(proto, $3DbSe);

var $9c7Du = parcelRequire("9c7Du");
$a9e7d4098ba69953$var$goog.object.extend(proto, $9c7Du);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.CustomerMeta', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.DealerUserMeta', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.GetNotificationsRequest', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.GetNotificationsResponse', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.InitProjectionsRequest', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.InitProjectionsResponse', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.NotificationStatusUpdate', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.NotificationStatusUpdate.Update', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.SendDeepLinkRequest', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.SendDeepLinkRequest.DeepLinkType', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.SendDeepLinkRequest.SourceType', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.SendDeepLinkResponse', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.SendMessageRequest', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.SendMessageResponse', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.SendOTPRequest', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.SendOtpResponse', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.UpdateNotificationStatusRequest', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.UpdateNotificationStatusResponse', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.VerifyOTPRequest', null, $a9e7d4098ba69953$var$global);
$a9e7d4098ba69953$var$goog.exportSymbol('proto.notification_service.VerifyOtpResponse', null, $a9e7d4098ba69953$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.UpdateNotificationStatusRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.notification_service.UpdateNotificationStatusRequest.repeatedFields_, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.UpdateNotificationStatusRequest, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.UpdateNotificationStatusRequest.displayName = 'proto.notification_service.UpdateNotificationStatusRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.UpdateNotificationStatusResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.UpdateNotificationStatusResponse, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.UpdateNotificationStatusResponse.displayName = 'proto.notification_service.UpdateNotificationStatusResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.NotificationStatusUpdate = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.NotificationStatusUpdate, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.NotificationStatusUpdate.displayName = 'proto.notification_service.NotificationStatusUpdate';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.GetNotificationsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.notification_service.GetNotificationsRequest.repeatedFields_, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.GetNotificationsRequest, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.GetNotificationsRequest.displayName = 'proto.notification_service.GetNotificationsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.GetNotificationsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.notification_service.GetNotificationsResponse.repeatedFields_, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.GetNotificationsResponse, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.GetNotificationsResponse.displayName = 'proto.notification_service.GetNotificationsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.SendDeepLinkRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.SendDeepLinkRequest, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.SendDeepLinkRequest.displayName = 'proto.notification_service.SendDeepLinkRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.SendDeepLinkResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.SendDeepLinkResponse, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.SendDeepLinkResponse.displayName = 'proto.notification_service.SendDeepLinkResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.DealerUserMeta = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.DealerUserMeta, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.DealerUserMeta.displayName = 'proto.notification_service.DealerUserMeta';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.CustomerMeta = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.CustomerMeta, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.CustomerMeta.displayName = 'proto.notification_service.CustomerMeta';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.SendOTPRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.SendOTPRequest, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.SendOTPRequest.displayName = 'proto.notification_service.SendOTPRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.SendOtpResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.SendOtpResponse, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.SendOtpResponse.displayName = 'proto.notification_service.SendOtpResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.VerifyOTPRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.VerifyOTPRequest, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.VerifyOTPRequest.displayName = 'proto.notification_service.VerifyOTPRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.VerifyOtpResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.VerifyOtpResponse, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.VerifyOtpResponse.displayName = 'proto.notification_service.VerifyOtpResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.SendMessageRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.SendMessageRequest, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.SendMessageRequest.displayName = 'proto.notification_service.SendMessageRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.SendMessageResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.SendMessageResponse, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.SendMessageResponse.displayName = 'proto.notification_service.SendMessageResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.InitProjectionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.InitProjectionsRequest, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.InitProjectionsRequest.displayName = 'proto.notification_service.InitProjectionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.notification_service.InitProjectionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$a9e7d4098ba69953$var$goog.inherits(proto.notification_service.InitProjectionsResponse, $8M67s.Message);
if ($a9e7d4098ba69953$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.notification_service.InitProjectionsResponse.displayName = 'proto.notification_service.InitProjectionsResponse';
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.notification_service.UpdateNotificationStatusRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.UpdateNotificationStatusRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.UpdateNotificationStatusRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.UpdateNotificationStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.UpdateNotificationStatusRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            notificationStatusUpdatesList: $8M67s.Message.toObjectList(msg.getNotificationStatusUpdatesList(), proto.notification_service.NotificationStatusUpdate.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.UpdateNotificationStatusRequest}
 */ proto.notification_service.UpdateNotificationStatusRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.UpdateNotificationStatusRequest;
    return proto.notification_service.UpdateNotificationStatusRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.UpdateNotificationStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.UpdateNotificationStatusRequest}
 */ proto.notification_service.UpdateNotificationStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.notification_service.NotificationStatusUpdate;
                reader.readMessage(value, proto.notification_service.NotificationStatusUpdate.deserializeBinaryFromReader);
                msg.addNotificationStatusUpdates(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.UpdateNotificationStatusRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.UpdateNotificationStatusRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.UpdateNotificationStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.UpdateNotificationStatusRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNotificationStatusUpdatesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.notification_service.NotificationStatusUpdate.serializeBinaryToWriter);
};
/**
 * repeated NotificationStatusUpdate notification_status_updates = 1;
 * @return {!Array<!proto.notification_service.NotificationStatusUpdate>}
 */ proto.notification_service.UpdateNotificationStatusRequest.prototype.getNotificationStatusUpdatesList = function() {
    return /** @type{!Array<!proto.notification_service.NotificationStatusUpdate>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.notification_service.NotificationStatusUpdate, 1);
};
/**
 * @param {!Array<!proto.notification_service.NotificationStatusUpdate>} value
 * @return {!proto.notification_service.UpdateNotificationStatusRequest} returns this
*/ proto.notification_service.UpdateNotificationStatusRequest.prototype.setNotificationStatusUpdatesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.notification_service.NotificationStatusUpdate=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notification_service.NotificationStatusUpdate}
 */ proto.notification_service.UpdateNotificationStatusRequest.prototype.addNotificationStatusUpdates = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.notification_service.NotificationStatusUpdate, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notification_service.UpdateNotificationStatusRequest} returns this
 */ proto.notification_service.UpdateNotificationStatusRequest.prototype.clearNotificationStatusUpdatesList = function() {
    return this.setNotificationStatusUpdatesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.UpdateNotificationStatusResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.UpdateNotificationStatusResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.UpdateNotificationStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.UpdateNotificationStatusResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.UpdateNotificationStatusResponse}
 */ proto.notification_service.UpdateNotificationStatusResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.UpdateNotificationStatusResponse;
    return proto.notification_service.UpdateNotificationStatusResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.UpdateNotificationStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.UpdateNotificationStatusResponse}
 */ proto.notification_service.UpdateNotificationStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.UpdateNotificationStatusResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.UpdateNotificationStatusResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.UpdateNotificationStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.UpdateNotificationStatusResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.NotificationStatusUpdate.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.NotificationStatusUpdate.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.NotificationStatusUpdate} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.NotificationStatusUpdate.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            update: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.NotificationStatusUpdate}
 */ proto.notification_service.NotificationStatusUpdate.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.NotificationStatusUpdate;
    return proto.notification_service.NotificationStatusUpdate.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.NotificationStatusUpdate} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.NotificationStatusUpdate}
 */ proto.notification_service.NotificationStatusUpdate.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {!proto.notification_service.NotificationStatusUpdate.Update} */ reader.readEnum();
                msg.setUpdate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.NotificationStatusUpdate.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.NotificationStatusUpdate.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.NotificationStatusUpdate} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.NotificationStatusUpdate.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getUpdate();
    if (f !== 0.0) writer.writeEnum(2, f);
};
/**
 * @enum {number}
 */ proto.notification_service.NotificationStatusUpdate.Update = {
    READ: 0,
    DELETE: 1
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.notification_service.NotificationStatusUpdate.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notification_service.NotificationStatusUpdate} returns this
 */ proto.notification_service.NotificationStatusUpdate.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional Update update = 2;
 * @return {!proto.notification_service.NotificationStatusUpdate.Update}
 */ proto.notification_service.NotificationStatusUpdate.prototype.getUpdate = function() {
    return /** @type {!proto.notification_service.NotificationStatusUpdate.Update} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.notification_service.NotificationStatusUpdate.Update} value
 * @return {!proto.notification_service.NotificationStatusUpdate} returns this
 */ proto.notification_service.NotificationStatusUpdate.prototype.setUpdate = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.notification_service.GetNotificationsRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.GetNotificationsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.GetNotificationsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.GetNotificationsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.GetNotificationsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            idsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
            listParams: (f = msg.getListParams()) && $9c7Du.ListParams.toObject(includeInstance, f),
            fromDate: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.GetNotificationsRequest}
 */ proto.notification_service.GetNotificationsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.GetNotificationsRequest;
    return proto.notification_service.GetNotificationsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.GetNotificationsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.GetNotificationsRequest}
 */ proto.notification_service.GetNotificationsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addIds(value);
                break;
            case 2:
                var value = new $9c7Du.ListParams;
                reader.readMessage(value, $9c7Du.ListParams.deserializeBinaryFromReader);
                msg.setListParams(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setFromDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.GetNotificationsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.GetNotificationsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.GetNotificationsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.GetNotificationsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getIdsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
    f = message.getListParams();
    if (f != null) writer.writeMessage(2, f, $9c7Du.ListParams.serializeBinaryToWriter);
    f = message.getFromDate();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */ proto.notification_service.GetNotificationsRequest.prototype.getIdsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.notification_service.GetNotificationsRequest} returns this
 */ proto.notification_service.GetNotificationsRequest.prototype.setIdsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.notification_service.GetNotificationsRequest} returns this
 */ proto.notification_service.GetNotificationsRequest.prototype.addIds = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notification_service.GetNotificationsRequest} returns this
 */ proto.notification_service.GetNotificationsRequest.prototype.clearIdsList = function() {
    return this.setIdsList([]);
};
/**
 * optional web.ListParams list_params = 2;
 * @return {?proto.web.ListParams}
 */ proto.notification_service.GetNotificationsRequest.prototype.getListParams = function() {
    return /** @type{?proto.web.ListParams} */ $8M67s.Message.getWrapperField(this, $9c7Du.ListParams, 2);
};
/**
 * @param {?proto.web.ListParams|undefined} value
 * @return {!proto.notification_service.GetNotificationsRequest} returns this
*/ proto.notification_service.GetNotificationsRequest.prototype.setListParams = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.notification_service.GetNotificationsRequest} returns this
 */ proto.notification_service.GetNotificationsRequest.prototype.clearListParams = function() {
    return this.setListParams(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.notification_service.GetNotificationsRequest.prototype.hasListParams = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * optional int64 from_date = 3;
 * @return {number}
 */ proto.notification_service.GetNotificationsRequest.prototype.getFromDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.notification_service.GetNotificationsRequest} returns this
 */ proto.notification_service.GetNotificationsRequest.prototype.setFromDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.notification_service.GetNotificationsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.GetNotificationsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.GetNotificationsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.GetNotificationsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.GetNotificationsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            notificationsList: $8M67s.Message.toObjectList(msg.getNotificationsList(), $3DbSe.Notification.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.GetNotificationsResponse}
 */ proto.notification_service.GetNotificationsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.GetNotificationsResponse;
    return proto.notification_service.GetNotificationsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.GetNotificationsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.GetNotificationsResponse}
 */ proto.notification_service.GetNotificationsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3DbSe.Notification;
                reader.readMessage(value, $3DbSe.Notification.deserializeBinaryFromReader);
                msg.addNotifications(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.GetNotificationsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.GetNotificationsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.GetNotificationsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.GetNotificationsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getNotificationsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3DbSe.Notification.serializeBinaryToWriter);
};
/**
 * repeated notifications.Notification notifications = 1;
 * @return {!Array<!proto.notifications.Notification>}
 */ proto.notification_service.GetNotificationsResponse.prototype.getNotificationsList = function() {
    return /** @type{!Array<!proto.notifications.Notification>} */ $8M67s.Message.getRepeatedWrapperField(this, $3DbSe.Notification, 1);
};
/**
 * @param {!Array<!proto.notifications.Notification>} value
 * @return {!proto.notification_service.GetNotificationsResponse} returns this
*/ proto.notification_service.GetNotificationsResponse.prototype.setNotificationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.notifications.Notification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.notifications.Notification}
 */ proto.notification_service.GetNotificationsResponse.prototype.addNotifications = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.notifications.Notification, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.notification_service.GetNotificationsResponse} returns this
 */ proto.notification_service.GetNotificationsResponse.prototype.clearNotificationsList = function() {
    return this.setNotificationsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.SendDeepLinkRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.SendDeepLinkRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.SendDeepLinkRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendDeepLinkRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            type: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            phone: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            sourceType: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.SendDeepLinkRequest}
 */ proto.notification_service.SendDeepLinkRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.SendDeepLinkRequest;
    return proto.notification_service.SendDeepLinkRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.SendDeepLinkRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.SendDeepLinkRequest}
 */ proto.notification_service.SendDeepLinkRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.notification_service.SendDeepLinkRequest.DeepLinkType} */ reader.readEnum();
                msg.setType(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPhone(value);
                break;
            case 3:
                var value = /** @type {!proto.notification_service.SendDeepLinkRequest.SourceType} */ reader.readEnum();
                msg.setSourceType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.SendDeepLinkRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.SendDeepLinkRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.SendDeepLinkRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendDeepLinkRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getType();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getPhone();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getSourceType();
    if (f !== 0.0) writer.writeEnum(3, f);
};
/**
 * @enum {number}
 */ proto.notification_service.SendDeepLinkRequest.DeepLinkType = {
    INSTALL: 0,
    LOGIN: 1
};
/**
 * @enum {number}
 */ proto.notification_service.SendDeepLinkRequest.SourceType = {
    DEFAULT: 0,
    CARS_COM: 1,
    AUTOTRADER: 2,
    PERKSATWORK: 3,
    JDPOWER: 4,
    NADAGUIDE: 5,
    TRUECAR: 6
};
/**
 * optional DeepLinkType type = 1;
 * @return {!proto.notification_service.SendDeepLinkRequest.DeepLinkType}
 */ proto.notification_service.SendDeepLinkRequest.prototype.getType = function() {
    return /** @type {!proto.notification_service.SendDeepLinkRequest.DeepLinkType} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.notification_service.SendDeepLinkRequest.DeepLinkType} value
 * @return {!proto.notification_service.SendDeepLinkRequest} returns this
 */ proto.notification_service.SendDeepLinkRequest.prototype.setType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional string phone = 2;
 * @return {string}
 */ proto.notification_service.SendDeepLinkRequest.prototype.getPhone = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.notification_service.SendDeepLinkRequest} returns this
 */ proto.notification_service.SendDeepLinkRequest.prototype.setPhone = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional SourceType source_type = 3;
 * @return {!proto.notification_service.SendDeepLinkRequest.SourceType}
 */ proto.notification_service.SendDeepLinkRequest.prototype.getSourceType = function() {
    return /** @type {!proto.notification_service.SendDeepLinkRequest.SourceType} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.notification_service.SendDeepLinkRequest.SourceType} value
 * @return {!proto.notification_service.SendDeepLinkRequest} returns this
 */ proto.notification_service.SendDeepLinkRequest.prototype.setSourceType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.SendDeepLinkResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.SendDeepLinkResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.SendDeepLinkResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendDeepLinkResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.SendDeepLinkResponse}
 */ proto.notification_service.SendDeepLinkResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.SendDeepLinkResponse;
    return proto.notification_service.SendDeepLinkResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.SendDeepLinkResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.SendDeepLinkResponse}
 */ proto.notification_service.SendDeepLinkResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.SendDeepLinkResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.SendDeepLinkResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.SendDeepLinkResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendDeepLinkResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.DealerUserMeta.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.DealerUserMeta.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.DealerUserMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.DealerUserMeta.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.DealerUserMeta}
 */ proto.notification_service.DealerUserMeta.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.DealerUserMeta;
    return proto.notification_service.DealerUserMeta.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.DealerUserMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.DealerUserMeta}
 */ proto.notification_service.DealerUserMeta.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.DealerUserMeta.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.DealerUserMeta.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.DealerUserMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.DealerUserMeta.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.CustomerMeta.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.CustomerMeta.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.CustomerMeta} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.CustomerMeta.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.CustomerMeta}
 */ proto.notification_service.CustomerMeta.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.CustomerMeta;
    return proto.notification_service.CustomerMeta.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.CustomerMeta} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.CustomerMeta}
 */ proto.notification_service.CustomerMeta.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.CustomerMeta.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.CustomerMeta.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.CustomerMeta} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.CustomerMeta.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.SendOTPRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.SendOTPRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.SendOTPRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendOTPRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.SendOTPRequest}
 */ proto.notification_service.SendOTPRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.SendOTPRequest;
    return proto.notification_service.SendOTPRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.SendOTPRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.SendOTPRequest}
 */ proto.notification_service.SendOTPRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.SendOTPRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.SendOTPRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.SendOTPRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendOTPRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string phone_number = 1;
 * @return {string}
 */ proto.notification_service.SendOTPRequest.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notification_service.SendOTPRequest} returns this
 */ proto.notification_service.SendOTPRequest.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.SendOtpResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.SendOtpResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.SendOtpResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendOtpResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.SendOtpResponse}
 */ proto.notification_service.SendOtpResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.SendOtpResponse;
    return proto.notification_service.SendOtpResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.SendOtpResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.SendOtpResponse}
 */ proto.notification_service.SendOtpResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.SendOtpResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.SendOtpResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.SendOtpResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendOtpResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.VerifyOTPRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.VerifyOTPRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.VerifyOTPRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.VerifyOTPRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            code: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.VerifyOTPRequest}
 */ proto.notification_service.VerifyOTPRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.VerifyOTPRequest;
    return proto.notification_service.VerifyOTPRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.VerifyOTPRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.VerifyOTPRequest}
 */ proto.notification_service.VerifyOTPRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.VerifyOTPRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.VerifyOTPRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.VerifyOTPRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.VerifyOTPRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCode();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string code = 1;
 * @return {string}
 */ proto.notification_service.VerifyOTPRequest.prototype.getCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notification_service.VerifyOTPRequest} returns this
 */ proto.notification_service.VerifyOTPRequest.prototype.setCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string phone_number = 2;
 * @return {string}
 */ proto.notification_service.VerifyOTPRequest.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.notification_service.VerifyOTPRequest} returns this
 */ proto.notification_service.VerifyOTPRequest.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.VerifyOtpResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.VerifyOtpResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.VerifyOtpResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.VerifyOtpResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.VerifyOtpResponse}
 */ proto.notification_service.VerifyOtpResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.VerifyOtpResponse;
    return proto.notification_service.VerifyOtpResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.VerifyOtpResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.VerifyOtpResponse}
 */ proto.notification_service.VerifyOtpResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.VerifyOtpResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.VerifyOtpResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.VerifyOtpResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.VerifyOtpResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.SendMessageRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.SendMessageRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.SendMessageRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendMessageRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            code: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            phoneNumber: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            message: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.SendMessageRequest}
 */ proto.notification_service.SendMessageRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.SendMessageRequest;
    return proto.notification_service.SendMessageRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.SendMessageRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.SendMessageRequest}
 */ proto.notification_service.SendMessageRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCode(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPhoneNumber(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.SendMessageRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.SendMessageRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.SendMessageRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendMessageRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCode();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPhoneNumber();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string code = 1;
 * @return {string}
 */ proto.notification_service.SendMessageRequest.prototype.getCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.notification_service.SendMessageRequest} returns this
 */ proto.notification_service.SendMessageRequest.prototype.setCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string phone_number = 2;
 * @return {string}
 */ proto.notification_service.SendMessageRequest.prototype.getPhoneNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.notification_service.SendMessageRequest} returns this
 */ proto.notification_service.SendMessageRequest.prototype.setPhoneNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string message = 3;
 * @return {string}
 */ proto.notification_service.SendMessageRequest.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.notification_service.SendMessageRequest} returns this
 */ proto.notification_service.SendMessageRequest.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.SendMessageResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.SendMessageResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.SendMessageResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendMessageResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.SendMessageResponse}
 */ proto.notification_service.SendMessageResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.SendMessageResponse;
    return proto.notification_service.SendMessageResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.SendMessageResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.SendMessageResponse}
 */ proto.notification_service.SendMessageResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.SendMessageResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.SendMessageResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.SendMessageResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.SendMessageResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.InitProjectionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.InitProjectionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.InitProjectionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.InitProjectionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            batchSize: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            wait: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.InitProjectionsRequest}
 */ proto.notification_service.InitProjectionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.InitProjectionsRequest;
    return proto.notification_service.InitProjectionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.InitProjectionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.InitProjectionsRequest}
 */ proto.notification_service.InitProjectionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readUint32();
                msg.setBatchSize(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setWait(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.InitProjectionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.InitProjectionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.InitProjectionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.InitProjectionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getBatchSize();
    if (f !== 0) writer.writeUint32(1, f);
    f = message.getWait();
    if (f) writer.writeBool(2, f);
};
/**
 * optional uint32 batch_size = 1;
 * @return {number}
 */ proto.notification_service.InitProjectionsRequest.prototype.getBatchSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.notification_service.InitProjectionsRequest} returns this
 */ proto.notification_service.InitProjectionsRequest.prototype.setBatchSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional bool wait = 2;
 * @return {boolean}
 */ proto.notification_service.InitProjectionsRequest.prototype.getWait = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.notification_service.InitProjectionsRequest} returns this
 */ proto.notification_service.InitProjectionsRequest.prototype.setWait = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.notification_service.InitProjectionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.notification_service.InitProjectionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.notification_service.InitProjectionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.InitProjectionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.notification_service.InitProjectionsResponse}
 */ proto.notification_service.InitProjectionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.notification_service.InitProjectionsResponse;
    return proto.notification_service.InitProjectionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.notification_service.InitProjectionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.notification_service.InitProjectionsResponse}
 */ proto.notification_service.InitProjectionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.notification_service.InitProjectionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.notification_service.InitProjectionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.notification_service.InitProjectionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.notification_service.InitProjectionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
$a9e7d4098ba69953$var$goog.object.extend(module.exports, proto.notification_service);

});

parcelRegister("8ilIL", function(module, exports) {
// source: payment_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $60a0da88a463b149$var$goog = $8M67s;
var $60a0da88a463b149$var$global = Function('return this')();
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.CreateMerchantAccountRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.CreateVendorSetupIntentRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.CreateVendorSetupIntentResponse', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.GetCustomerRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.GetOwnPrimaryPaymentMethodRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.GetPrimaryPaymentMethodRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.GetPrimaryPaymentMethodResponse', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.ListOwnPaymentsRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.ListPaymentsRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.ListPaymentsResponse', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.MerchantAccount', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.PayByTokenRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.PayByTokenResponse', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.PaymentFE', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.PaymentsVendorToken', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.PaymentsVendorTokenRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.RefundInvoiceRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.RefundInvoiceResponse', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.ScheduledPickupRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.ScheduledPickupResponse', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.SetOwnPrimaryPaymentMethodRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.SetPrimaryPaymentMethodRequest', null, $60a0da88a463b149$var$global);
$60a0da88a463b149$var$goog.exportSymbol('proto.payment_service.SetPrimaryPaymentMethodResponse', null, $60a0da88a463b149$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.GetOwnPrimaryPaymentMethodRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.GetOwnPrimaryPaymentMethodRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.GetOwnPrimaryPaymentMethodRequest.displayName = 'proto.payment_service.GetOwnPrimaryPaymentMethodRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.GetPrimaryPaymentMethodRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.GetPrimaryPaymentMethodRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.GetPrimaryPaymentMethodRequest.displayName = 'proto.payment_service.GetPrimaryPaymentMethodRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.GetPrimaryPaymentMethodResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.GetPrimaryPaymentMethodResponse, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.GetPrimaryPaymentMethodResponse.displayName = 'proto.payment_service.GetPrimaryPaymentMethodResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.SetOwnPrimaryPaymentMethodRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.displayName = 'proto.payment_service.SetOwnPrimaryPaymentMethodRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.SetPrimaryPaymentMethodRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.SetPrimaryPaymentMethodRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.SetPrimaryPaymentMethodRequest.displayName = 'proto.payment_service.SetPrimaryPaymentMethodRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.SetPrimaryPaymentMethodResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.SetPrimaryPaymentMethodResponse, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.SetPrimaryPaymentMethodResponse.displayName = 'proto.payment_service.SetPrimaryPaymentMethodResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.RefundInvoiceRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.RefundInvoiceRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.RefundInvoiceRequest.displayName = 'proto.payment_service.RefundInvoiceRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.RefundInvoiceResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.RefundInvoiceResponse, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.RefundInvoiceResponse.displayName = 'proto.payment_service.RefundInvoiceResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.CreateMerchantAccountRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.CreateMerchantAccountRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.CreateMerchantAccountRequest.displayName = 'proto.payment_service.CreateMerchantAccountRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.MerchantAccount = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.MerchantAccount, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.MerchantAccount.displayName = 'proto.payment_service.MerchantAccount';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.ScheduledPickupRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.ScheduledPickupRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.ScheduledPickupRequest.displayName = 'proto.payment_service.ScheduledPickupRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.ScheduledPickupResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.ScheduledPickupResponse, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.ScheduledPickupResponse.displayName = 'proto.payment_service.ScheduledPickupResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.GetCustomerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.GetCustomerRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.GetCustomerRequest.displayName = 'proto.payment_service.GetCustomerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.PayByTokenRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.payment_service.PayByTokenRequest.repeatedFields_, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.PayByTokenRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.PayByTokenRequest.displayName = 'proto.payment_service.PayByTokenRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.PayByTokenResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.PayByTokenResponse, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.PayByTokenResponse.displayName = 'proto.payment_service.PayByTokenResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.PaymentsVendorTokenRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.PaymentsVendorTokenRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.PaymentsVendorTokenRequest.displayName = 'proto.payment_service.PaymentsVendorTokenRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.PaymentsVendorToken = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.PaymentsVendorToken, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.PaymentsVendorToken.displayName = 'proto.payment_service.PaymentsVendorToken';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.ListOwnPaymentsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.ListOwnPaymentsRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.ListOwnPaymentsRequest.displayName = 'proto.payment_service.ListOwnPaymentsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.ListPaymentsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.ListPaymentsRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.ListPaymentsRequest.displayName = 'proto.payment_service.ListPaymentsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.ListPaymentsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.payment_service.ListPaymentsResponse.repeatedFields_, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.ListPaymentsResponse, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.ListPaymentsResponse.displayName = 'proto.payment_service.ListPaymentsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.PaymentFE = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.PaymentFE, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.PaymentFE.displayName = 'proto.payment_service.PaymentFE';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.CreateVendorSetupIntentRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.CreateVendorSetupIntentRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.CreateVendorSetupIntentRequest.displayName = 'proto.payment_service.CreateVendorSetupIntentRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.CreateVendorSetupIntentResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.CreateVendorSetupIntentResponse, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.CreateVendorSetupIntentResponse.displayName = 'proto.payment_service.CreateVendorSetupIntentResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.displayName = 'proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$60a0da88a463b149$var$goog.inherits(proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse, $8M67s.Message);
if ($60a0da88a463b149$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.displayName = 'proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.GetOwnPrimaryPaymentMethodRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.GetOwnPrimaryPaymentMethodRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.GetOwnPrimaryPaymentMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.GetOwnPrimaryPaymentMethodRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.GetOwnPrimaryPaymentMethodRequest}
 */ proto.payment_service.GetOwnPrimaryPaymentMethodRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.GetOwnPrimaryPaymentMethodRequest;
    return proto.payment_service.GetOwnPrimaryPaymentMethodRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.GetOwnPrimaryPaymentMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.GetOwnPrimaryPaymentMethodRequest}
 */ proto.payment_service.GetOwnPrimaryPaymentMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.GetOwnPrimaryPaymentMethodRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.GetOwnPrimaryPaymentMethodRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.GetOwnPrimaryPaymentMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.GetOwnPrimaryPaymentMethodRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.GetPrimaryPaymentMethodRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.GetPrimaryPaymentMethodRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.GetPrimaryPaymentMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.GetPrimaryPaymentMethodRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.GetPrimaryPaymentMethodRequest}
 */ proto.payment_service.GetPrimaryPaymentMethodRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.GetPrimaryPaymentMethodRequest;
    return proto.payment_service.GetPrimaryPaymentMethodRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.GetPrimaryPaymentMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.GetPrimaryPaymentMethodRequest}
 */ proto.payment_service.GetPrimaryPaymentMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.GetPrimaryPaymentMethodRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.GetPrimaryPaymentMethodRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.GetPrimaryPaymentMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.GetPrimaryPaymentMethodRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.payment_service.GetPrimaryPaymentMethodRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.GetPrimaryPaymentMethodRequest} returns this
 */ proto.payment_service.GetPrimaryPaymentMethodRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.GetPrimaryPaymentMethodResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.GetPrimaryPaymentMethodResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.GetPrimaryPaymentMethodResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.GetPrimaryPaymentMethodResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            paymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.GetPrimaryPaymentMethodResponse}
 */ proto.payment_service.GetPrimaryPaymentMethodResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.GetPrimaryPaymentMethodResponse;
    return proto.payment_service.GetPrimaryPaymentMethodResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.GetPrimaryPaymentMethodResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.GetPrimaryPaymentMethodResponse}
 */ proto.payment_service.GetPrimaryPaymentMethodResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.GetPrimaryPaymentMethodResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.GetPrimaryPaymentMethodResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.GetPrimaryPaymentMethodResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.GetPrimaryPaymentMethodResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPaymentMethodId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string payment_method_id = 1;
 * @return {string}
 */ proto.payment_service.GetPrimaryPaymentMethodResponse.prototype.getPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.GetPrimaryPaymentMethodResponse} returns this
 */ proto.payment_service.GetPrimaryPaymentMethodResponse.prototype.setPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.SetOwnPrimaryPaymentMethodRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            paymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest}
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.SetOwnPrimaryPaymentMethodRequest;
    return proto.payment_service.SetOwnPrimaryPaymentMethodRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest}
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.SetOwnPrimaryPaymentMethodRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPaymentMethodId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string payment_method_id = 1;
 * @return {string}
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.prototype.getPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest} returns this
 */ proto.payment_service.SetOwnPrimaryPaymentMethodRequest.prototype.setPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.SetPrimaryPaymentMethodRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.SetPrimaryPaymentMethodRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            paymentMethodId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.SetPrimaryPaymentMethodRequest}
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.SetPrimaryPaymentMethodRequest;
    return proto.payment_service.SetPrimaryPaymentMethodRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.SetPrimaryPaymentMethodRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.SetPrimaryPaymentMethodRequest}
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.SetPrimaryPaymentMethodRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.SetPrimaryPaymentMethodRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getPaymentMethodId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.SetPrimaryPaymentMethodRequest} returns this
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string payment_method_id = 2;
 * @return {string}
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.prototype.getPaymentMethodId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.SetPrimaryPaymentMethodRequest} returns this
 */ proto.payment_service.SetPrimaryPaymentMethodRequest.prototype.setPaymentMethodId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.SetPrimaryPaymentMethodResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.SetPrimaryPaymentMethodResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.SetPrimaryPaymentMethodResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.SetPrimaryPaymentMethodResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.SetPrimaryPaymentMethodResponse}
 */ proto.payment_service.SetPrimaryPaymentMethodResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.SetPrimaryPaymentMethodResponse;
    return proto.payment_service.SetPrimaryPaymentMethodResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.SetPrimaryPaymentMethodResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.SetPrimaryPaymentMethodResponse}
 */ proto.payment_service.SetPrimaryPaymentMethodResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.SetPrimaryPaymentMethodResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.SetPrimaryPaymentMethodResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.SetPrimaryPaymentMethodResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.SetPrimaryPaymentMethodResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.RefundInvoiceRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.RefundInvoiceRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.RefundInvoiceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.RefundInvoiceRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            invoiceNumber: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.RefundInvoiceRequest}
 */ proto.payment_service.RefundInvoiceRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.RefundInvoiceRequest;
    return proto.payment_service.RefundInvoiceRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.RefundInvoiceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.RefundInvoiceRequest}
 */ proto.payment_service.RefundInvoiceRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setInvoiceNumber(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.RefundInvoiceRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.RefundInvoiceRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.RefundInvoiceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.RefundInvoiceRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getInvoiceNumber();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string subscription_id = 1;
 * @return {string}
 */ proto.payment_service.RefundInvoiceRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.RefundInvoiceRequest} returns this
 */ proto.payment_service.RefundInvoiceRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string invoice_number = 2;
 * @return {string}
 */ proto.payment_service.RefundInvoiceRequest.prototype.getInvoiceNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.RefundInvoiceRequest} returns this
 */ proto.payment_service.RefundInvoiceRequest.prototype.setInvoiceNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.RefundInvoiceResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.RefundInvoiceResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.RefundInvoiceResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.RefundInvoiceResponse.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.RefundInvoiceResponse}
 */ proto.payment_service.RefundInvoiceResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.RefundInvoiceResponse;
    return proto.payment_service.RefundInvoiceResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.RefundInvoiceResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.RefundInvoiceResponse}
 */ proto.payment_service.RefundInvoiceResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.RefundInvoiceResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.RefundInvoiceResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.RefundInvoiceResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.RefundInvoiceResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.CreateMerchantAccountRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.CreateMerchantAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateMerchantAccountRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            externalId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            country: $8M67s.Message.getFieldWithDefault(msg, 5, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.CreateMerchantAccountRequest}
 */ proto.payment_service.CreateMerchantAccountRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.CreateMerchantAccountRequest;
    return proto.payment_service.CreateMerchantAccountRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.CreateMerchantAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.CreateMerchantAccountRequest}
 */ proto.payment_service.CreateMerchantAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setExternalId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setCountry(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.CreateMerchantAccountRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.CreateMerchantAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateMerchantAccountRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getExternalId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getCountry();
    if (f.length > 0) writer.writeString(5, f);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.CreateMerchantAccountRequest} returns this
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string description = 2;
 * @return {string}
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.CreateMerchantAccountRequest} returns this
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string email = 3;
 * @return {string}
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.CreateMerchantAccountRequest} returns this
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string external_id = 4;
 * @return {string}
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.getExternalId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.CreateMerchantAccountRequest} returns this
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.setExternalId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string country = 5;
 * @return {string}
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.getCountry = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.CreateMerchantAccountRequest} returns this
 */ proto.payment_service.CreateMerchantAccountRequest.prototype.setCountry = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.MerchantAccount.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.MerchantAccount.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.MerchantAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.MerchantAccount.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            description: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            email: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            externalId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            accountId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            country: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.MerchantAccount}
 */ proto.payment_service.MerchantAccount.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.MerchantAccount;
    return proto.payment_service.MerchantAccount.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.MerchantAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.MerchantAccount}
 */ proto.payment_service.MerchantAccount.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setDescription(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setEmail(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setExternalId(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setAccountId(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setCountry(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.MerchantAccount.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.MerchantAccount.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.MerchantAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.MerchantAccount.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getDescription();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getEmail();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getExternalId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getAccountId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getCountry();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * optional int32 id = 1;
 * @return {number}
 */ proto.payment_service.MerchantAccount.prototype.getId = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.payment_service.MerchantAccount} returns this
 */ proto.payment_service.MerchantAccount.prototype.setId = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.payment_service.MerchantAccount.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.MerchantAccount} returns this
 */ proto.payment_service.MerchantAccount.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string description = 3;
 * @return {string}
 */ proto.payment_service.MerchantAccount.prototype.getDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.MerchantAccount} returns this
 */ proto.payment_service.MerchantAccount.prototype.setDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string email = 4;
 * @return {string}
 */ proto.payment_service.MerchantAccount.prototype.getEmail = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.MerchantAccount} returns this
 */ proto.payment_service.MerchantAccount.prototype.setEmail = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string external_id = 5;
 * @return {string}
 */ proto.payment_service.MerchantAccount.prototype.getExternalId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.MerchantAccount} returns this
 */ proto.payment_service.MerchantAccount.prototype.setExternalId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string account_id = 6;
 * @return {string}
 */ proto.payment_service.MerchantAccount.prototype.getAccountId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.MerchantAccount} returns this
 */ proto.payment_service.MerchantAccount.prototype.setAccountId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string country = 7;
 * @return {string}
 */ proto.payment_service.MerchantAccount.prototype.getCountry = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.MerchantAccount} returns this
 */ proto.payment_service.MerchantAccount.prototype.setCountry = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.ScheduledPickupRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.ScheduledPickupRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.ScheduledPickupRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ScheduledPickupRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            scheduleDate: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.ScheduledPickupRequest}
 */ proto.payment_service.ScheduledPickupRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.ScheduledPickupRequest;
    return proto.payment_service.ScheduledPickupRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.ScheduledPickupRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.ScheduledPickupRequest}
 */ proto.payment_service.ScheduledPickupRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt64();
                msg.setScheduleDate(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.ScheduledPickupRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.ScheduledPickupRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.ScheduledPickupRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ScheduledPickupRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getScheduleDate();
    if (f !== 0) writer.writeInt64(3, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.payment_service.ScheduledPickupRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.ScheduledPickupRequest} returns this
 */ proto.payment_service.ScheduledPickupRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string subscription_id = 2;
 * @return {string}
 */ proto.payment_service.ScheduledPickupRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.ScheduledPickupRequest} returns this
 */ proto.payment_service.ScheduledPickupRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int64 schedule_date = 3;
 * @return {number}
 */ proto.payment_service.ScheduledPickupRequest.prototype.getScheduleDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.payment_service.ScheduledPickupRequest} returns this
 */ proto.payment_service.ScheduledPickupRequest.prototype.setScheduleDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.ScheduledPickupResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.ScheduledPickupResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.ScheduledPickupResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ScheduledPickupResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.ScheduledPickupResponse}
 */ proto.payment_service.ScheduledPickupResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.ScheduledPickupResponse;
    return proto.payment_service.ScheduledPickupResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.ScheduledPickupResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.ScheduledPickupResponse}
 */ proto.payment_service.ScheduledPickupResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.ScheduledPickupResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.ScheduledPickupResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.ScheduledPickupResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ScheduledPickupResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.payment_service.ScheduledPickupResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.payment_service.ScheduledPickupResponse} returns this
 */ proto.payment_service.ScheduledPickupResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.GetCustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.GetCustomerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.GetCustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.GetCustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.GetCustomerRequest}
 */ proto.payment_service.GetCustomerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.GetCustomerRequest;
    return proto.payment_service.GetCustomerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.GetCustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.GetCustomerRequest}
 */ proto.payment_service.GetCustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.GetCustomerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.GetCustomerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.GetCustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.GetCustomerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.payment_service.GetCustomerRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.GetCustomerRequest} returns this
 */ proto.payment_service.GetCustomerRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.payment_service.PayByTokenRequest.repeatedFields_ = [
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.PayByTokenRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.PayByTokenRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.PayByTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PayByTokenRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            token: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            amount: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            invoiceNumbersList: (f = $8M67s.Message.getRepeatedField(msg, 4)) == null ? undefined : f,
            isDriveOff: $8M67s.Message.getBooleanFieldWithDefault(msg, 5, false),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 7, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.PayByTokenRequest}
 */ proto.payment_service.PayByTokenRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.PayByTokenRequest;
    return proto.payment_service.PayByTokenRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.PayByTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.PayByTokenRequest}
 */ proto.payment_service.PayByTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setToken(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.addInvoiceNumbers(value);
                break;
            case 5:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsDriveOff(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.PayByTokenRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.PayByTokenRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.PayByTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PayByTokenRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getToken();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getInvoiceNumbersList();
    if (f.length > 0) writer.writeRepeatedString(4, f);
    f = message.getIsDriveOff();
    if (f) writer.writeBool(5, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(7, f);
};
/**
 * optional string token = 1;
 * @return {string}
 */ proto.payment_service.PayByTokenRequest.prototype.getToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PayByTokenRequest} returns this
 */ proto.payment_service.PayByTokenRequest.prototype.setToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 amount = 3;
 * @return {number}
 */ proto.payment_service.PayByTokenRequest.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.payment_service.PayByTokenRequest} returns this
 */ proto.payment_service.PayByTokenRequest.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * repeated string invoice_numbers = 4;
 * @return {!Array<string>}
 */ proto.payment_service.PayByTokenRequest.prototype.getInvoiceNumbersList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 4);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.payment_service.PayByTokenRequest} returns this
 */ proto.payment_service.PayByTokenRequest.prototype.setInvoiceNumbersList = function(value) {
    return $8M67s.Message.setField(this, 4, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.payment_service.PayByTokenRequest} returns this
 */ proto.payment_service.PayByTokenRequest.prototype.addInvoiceNumbers = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 4, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.payment_service.PayByTokenRequest} returns this
 */ proto.payment_service.PayByTokenRequest.prototype.clearInvoiceNumbersList = function() {
    return this.setInvoiceNumbersList([]);
};
/**
 * optional bool is_drive_off = 5;
 * @return {boolean}
 */ proto.payment_service.PayByTokenRequest.prototype.getIsDriveOff = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 5, false);
};
/**
 * @param {boolean} value
 * @return {!proto.payment_service.PayByTokenRequest} returns this
 */ proto.payment_service.PayByTokenRequest.prototype.setIsDriveOff = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 5, value);
};
/**
 * optional string subscription_id = 6;
 * @return {string}
 */ proto.payment_service.PayByTokenRequest.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PayByTokenRequest} returns this
 */ proto.payment_service.PayByTokenRequest.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string reservation_id = 7;
 * @return {string}
 */ proto.payment_service.PayByTokenRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PayByTokenRequest} returns this
 */ proto.payment_service.PayByTokenRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.PayByTokenResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.PayByTokenResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.PayByTokenResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PayByTokenResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            message: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.PayByTokenResponse}
 */ proto.payment_service.PayByTokenResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.PayByTokenResponse;
    return proto.payment_service.PayByTokenResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.PayByTokenResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.PayByTokenResponse}
 */ proto.payment_service.PayByTokenResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.PayByTokenResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.PayByTokenResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.PayByTokenResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PayByTokenResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getMessage();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.payment_service.PayByTokenResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.payment_service.PayByTokenResponse} returns this
 */ proto.payment_service.PayByTokenResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional string message = 2;
 * @return {string}
 */ proto.payment_service.PayByTokenResponse.prototype.getMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PayByTokenResponse} returns this
 */ proto.payment_service.PayByTokenResponse.prototype.setMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.PaymentsVendorTokenRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.PaymentsVendorTokenRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.PaymentsVendorTokenRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PaymentsVendorTokenRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.PaymentsVendorTokenRequest}
 */ proto.payment_service.PaymentsVendorTokenRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.PaymentsVendorTokenRequest;
    return proto.payment_service.PaymentsVendorTokenRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.PaymentsVendorTokenRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.PaymentsVendorTokenRequest}
 */ proto.payment_service.PaymentsVendorTokenRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.PaymentsVendorTokenRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.PaymentsVendorTokenRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.PaymentsVendorTokenRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PaymentsVendorTokenRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.PaymentsVendorToken.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.PaymentsVendorToken.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.PaymentsVendorToken} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PaymentsVendorToken.toObject = function(includeInstance, msg) {
        var f, obj = {
            token: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vendor: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.PaymentsVendorToken}
 */ proto.payment_service.PaymentsVendorToken.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.PaymentsVendorToken;
    return proto.payment_service.PaymentsVendorToken.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.PaymentsVendorToken} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.PaymentsVendorToken}
 */ proto.payment_service.PaymentsVendorToken.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setToken(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVendor(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.PaymentsVendorToken.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.PaymentsVendorToken.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.PaymentsVendorToken} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PaymentsVendorToken.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getToken();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVendor();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string token = 1;
 * @return {string}
 */ proto.payment_service.PaymentsVendorToken.prototype.getToken = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PaymentsVendorToken} returns this
 */ proto.payment_service.PaymentsVendorToken.prototype.setToken = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vendor = 2;
 * @return {string}
 */ proto.payment_service.PaymentsVendorToken.prototype.getVendor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PaymentsVendorToken} returns this
 */ proto.payment_service.PaymentsVendorToken.prototype.setVendor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.ListOwnPaymentsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.ListOwnPaymentsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.ListOwnPaymentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ListOwnPaymentsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.ListOwnPaymentsRequest}
 */ proto.payment_service.ListOwnPaymentsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.ListOwnPaymentsRequest;
    return proto.payment_service.ListOwnPaymentsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.ListOwnPaymentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.ListOwnPaymentsRequest}
 */ proto.payment_service.ListOwnPaymentsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.ListOwnPaymentsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.ListOwnPaymentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.ListOwnPaymentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ListOwnPaymentsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.ListPaymentsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.ListPaymentsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.ListPaymentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ListPaymentsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.ListPaymentsRequest}
 */ proto.payment_service.ListPaymentsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.ListPaymentsRequest;
    return proto.payment_service.ListPaymentsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.ListPaymentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.ListPaymentsRequest}
 */ proto.payment_service.ListPaymentsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.ListPaymentsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.ListPaymentsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.ListPaymentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ListPaymentsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.payment_service.ListPaymentsRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.ListPaymentsRequest} returns this
 */ proto.payment_service.ListPaymentsRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.payment_service.ListPaymentsResponse.repeatedFields_ = [
    7
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.ListPaymentsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.ListPaymentsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.ListPaymentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ListPaymentsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            paymentsList: $8M67s.Message.toObjectList(msg.getPaymentsList(), proto.payment_service.PaymentFE.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.ListPaymentsResponse}
 */ proto.payment_service.ListPaymentsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.ListPaymentsResponse;
    return proto.payment_service.ListPaymentsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.ListPaymentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.ListPaymentsResponse}
 */ proto.payment_service.ListPaymentsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 7:
                var value = new proto.payment_service.PaymentFE;
                reader.readMessage(value, proto.payment_service.PaymentFE.deserializeBinaryFromReader);
                msg.addPayments(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.ListPaymentsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.ListPaymentsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.ListPaymentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.ListPaymentsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPaymentsList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, proto.payment_service.PaymentFE.serializeBinaryToWriter);
};
/**
 * repeated PaymentFE payments = 7;
 * @return {!Array<!proto.payment_service.PaymentFE>}
 */ proto.payment_service.ListPaymentsResponse.prototype.getPaymentsList = function() {
    return /** @type{!Array<!proto.payment_service.PaymentFE>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.payment_service.PaymentFE, 7);
};
/**
 * @param {!Array<!proto.payment_service.PaymentFE>} value
 * @return {!proto.payment_service.ListPaymentsResponse} returns this
*/ proto.payment_service.ListPaymentsResponse.prototype.setPaymentsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.payment_service.PaymentFE=} opt_value
 * @param {number=} opt_index
 * @return {!proto.payment_service.PaymentFE}
 */ proto.payment_service.ListPaymentsResponse.prototype.addPayments = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.payment_service.PaymentFE, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.payment_service.ListPaymentsResponse} returns this
 */ proto.payment_service.ListPaymentsResponse.prototype.clearPaymentsList = function() {
    return this.setPaymentsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.PaymentFE.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.PaymentFE.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.PaymentFE} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PaymentFE.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            created: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            amount: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            last4: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            paymentMethodDescription: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            isExpired: $8M67s.Message.getBooleanFieldWithDefault(msg, 6, false),
            status: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            errorCode: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            errorMessage: $8M67s.Message.getFieldWithDefault(msg, 9, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.PaymentFE}
 */ proto.payment_service.PaymentFE.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.PaymentFE;
    return proto.payment_service.PaymentFE.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.PaymentFE} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.PaymentFE}
 */ proto.payment_service.PaymentFE.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setCreated(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setLast4(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setPaymentMethodDescription(value);
                break;
            case 6:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setIsExpired(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setStatus(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setErrorCode(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setErrorMessage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.PaymentFE.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.PaymentFE.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.PaymentFE} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.PaymentFE.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCreated();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getLast4();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getPaymentMethodDescription();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getIsExpired();
    if (f) writer.writeBool(6, f);
    f = message.getStatus();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getErrorCode();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getErrorMessage();
    if (f.length > 0) writer.writeString(9, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.payment_service.PaymentFE.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int64 created = 2;
 * @return {number}
 */ proto.payment_service.PaymentFE.prototype.getCreated = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setCreated = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 amount = 3;
 * @return {number}
 */ proto.payment_service.PaymentFE.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string last4 = 4;
 * @return {string}
 */ proto.payment_service.PaymentFE.prototype.getLast4 = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setLast4 = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string payment_method_description = 5;
 * @return {string}
 */ proto.payment_service.PaymentFE.prototype.getPaymentMethodDescription = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setPaymentMethodDescription = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional bool is_expired = 6;
 * @return {boolean}
 */ proto.payment_service.PaymentFE.prototype.getIsExpired = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 6, false);
};
/**
 * @param {boolean} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setIsExpired = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 6, value);
};
/**
 * optional string status = 7;
 * @return {string}
 */ proto.payment_service.PaymentFE.prototype.getStatus = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setStatus = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string error_code = 8;
 * @return {string}
 */ proto.payment_service.PaymentFE.prototype.getErrorCode = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setErrorCode = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string error_message = 9;
 * @return {string}
 */ proto.payment_service.PaymentFE.prototype.getErrorMessage = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.PaymentFE} returns this
 */ proto.payment_service.PaymentFE.prototype.setErrorMessage = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.CreateVendorSetupIntentRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.CreateVendorSetupIntentRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.CreateVendorSetupIntentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateVendorSetupIntentRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.CreateVendorSetupIntentRequest}
 */ proto.payment_service.CreateVendorSetupIntentRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.CreateVendorSetupIntentRequest;
    return proto.payment_service.CreateVendorSetupIntentRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.CreateVendorSetupIntentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.CreateVendorSetupIntentRequest}
 */ proto.payment_service.CreateVendorSetupIntentRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.CreateVendorSetupIntentRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.CreateVendorSetupIntentRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.CreateVendorSetupIntentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateVendorSetupIntentRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.CreateVendorSetupIntentResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.CreateVendorSetupIntentResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.CreateVendorSetupIntentResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateVendorSetupIntentResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            setupIntent: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.CreateVendorSetupIntentResponse}
 */ proto.payment_service.CreateVendorSetupIntentResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.CreateVendorSetupIntentResponse;
    return proto.payment_service.CreateVendorSetupIntentResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.CreateVendorSetupIntentResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.CreateVendorSetupIntentResponse}
 */ proto.payment_service.CreateVendorSetupIntentResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSetupIntent(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.CreateVendorSetupIntentResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.CreateVendorSetupIntentResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.CreateVendorSetupIntentResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateVendorSetupIntentResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSetupIntent();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string setup_intent = 1;
 * @return {string}
 */ proto.payment_service.CreateVendorSetupIntentResponse.prototype.getSetupIntent = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.CreateVendorSetupIntentResponse} returns this
 */ proto.payment_service.CreateVendorSetupIntentResponse.prototype.setSetupIntent = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest;
    return proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            clientSecret: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerSessionClientSecret: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse;
    return proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setClientSecret(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerSessionClientSecret(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getClientSecret();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerSessionClientSecret();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string client_secret = 1;
 * @return {string}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.prototype.getClientSecret = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse} returns this
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.prototype.setClientSecret = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_session_client_secret = 2;
 * @return {string}
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.prototype.getCustomerSessionClientSecret = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse} returns this
 */ proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse.prototype.setCustomerSessionClientSecret = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
$60a0da88a463b149$var$goog.object.extend(module.exports, proto.payment_service);

});

parcelRegister("cIR06", function(module, exports) {
// source: spre.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $9432b4eba6c55581$var$goog = $8M67s;
var $9432b4eba6c55581$var$global = Function('return this')();

var $3QqPt = parcelRequire("3QqPt");
$9432b4eba6c55581$var$goog.object.extend(proto, $3QqPt);

var $9YICB = parcelRequire("9YICB");
$9432b4eba6c55581$var$goog.object.extend(proto, $9YICB);

var $hOsJC = parcelRequire("hOsJC");
$9432b4eba6c55581$var$goog.object.extend(proto, $hOsJC);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Algorithm', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Band', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.CalculateCustomerVehiclePricingRequest', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.CalculateCustomerVehiclePricingResponse', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.CalculateVehiclePricingRequest', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.CalculateVehiclePricingResponse', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Calculation', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.CreateIdResponse', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.CreateResponse', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.CustomerRequest', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.ExecuteFunctionRequest', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Expense', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Expense.Category', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Expense.Type', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.HypotheticalRequest', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.HypotheticalResponse', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Item', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.ItemResponse', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.ItemTypeQuery', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.ListProductsRequest', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.ListProductsResponse', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.ListProgramPricingOptionsRequest', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.ListProgramPricingOptionsResponse', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Lut', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Price', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Profile', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Quote', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.QuoteRequest', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.Report', null, $9432b4eba6c55581$var$global);
$9432b4eba6c55581$var$goog.exportSymbol('proto.spre.VariableMap', null, $9432b4eba6c55581$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.ItemTypeQuery = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.ItemTypeQuery, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.ItemTypeQuery.displayName = 'proto.spre.ItemTypeQuery';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.ItemResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.spre.ItemResponse.repeatedFields_, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.ItemResponse, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.ItemResponse.displayName = 'proto.spre.ItemResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Item = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Item, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Item.displayName = 'proto.spre.Item';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.CustomerRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.CustomerRequest, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.CustomerRequest.displayName = 'proto.spre.CustomerRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.QuoteRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.QuoteRequest, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.QuoteRequest.displayName = 'proto.spre.QuoteRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.CreateIdResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.CreateIdResponse, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.CreateIdResponse.displayName = 'proto.spre.CreateIdResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.CreateResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.CreateResponse, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.CreateResponse.displayName = 'proto.spre.CreateResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.ExecuteFunctionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.ExecuteFunctionRequest, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.ExecuteFunctionRequest.displayName = 'proto.spre.ExecuteFunctionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.VariableMap = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.VariableMap, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.VariableMap.displayName = 'proto.spre.VariableMap';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Calculation = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.spre.Calculation.repeatedFields_, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Calculation, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Calculation.displayName = 'proto.spre.Calculation';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Report = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.spre.Report.repeatedFields_, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Report, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Report.displayName = 'proto.spre.Report';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Expense = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Expense, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Expense.displayName = 'proto.spre.Expense';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Profile = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Profile, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Profile.displayName = 'proto.spre.Profile';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Quote = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.spre.Quote.repeatedFields_, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Quote, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Quote.displayName = 'proto.spre.Quote';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Algorithm = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Algorithm, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Algorithm.displayName = 'proto.spre.Algorithm';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Lut = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.spre.Lut.repeatedFields_, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Lut, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Lut.displayName = 'proto.spre.Lut';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Band = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Band, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Band.displayName = 'proto.spre.Band';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.HypotheticalRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.HypotheticalRequest, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.HypotheticalRequest.displayName = 'proto.spre.HypotheticalRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.HypotheticalResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.HypotheticalResponse, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.HypotheticalResponse.displayName = 'proto.spre.HypotheticalResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.Price = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.Price, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.Price.displayName = 'proto.spre.Price';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.ListProductsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.spre.ListProductsResponse.repeatedFields_, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.ListProductsResponse, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.ListProductsResponse.displayName = 'proto.spre.ListProductsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.ListProductsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.ListProductsRequest, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.ListProductsRequest.displayName = 'proto.spre.ListProductsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.CalculateVehiclePricingRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.CalculateVehiclePricingRequest, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.CalculateVehiclePricingRequest.displayName = 'proto.spre.CalculateVehiclePricingRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.CalculateVehiclePricingResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.CalculateVehiclePricingResponse, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.CalculateVehiclePricingResponse.displayName = 'proto.spre.CalculateVehiclePricingResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.CalculateCustomerVehiclePricingRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.CalculateCustomerVehiclePricingRequest, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.CalculateCustomerVehiclePricingRequest.displayName = 'proto.spre.CalculateCustomerVehiclePricingRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.CalculateCustomerVehiclePricingResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.CalculateCustomerVehiclePricingResponse, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.CalculateCustomerVehiclePricingResponse.displayName = 'proto.spre.CalculateCustomerVehiclePricingResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.ListProgramPricingOptionsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.ListProgramPricingOptionsRequest, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.ListProgramPricingOptionsRequest.displayName = 'proto.spre.ListProgramPricingOptionsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.spre.ListProgramPricingOptionsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.spre.ListProgramPricingOptionsResponse.repeatedFields_, null);
};
$9432b4eba6c55581$var$goog.inherits(proto.spre.ListProgramPricingOptionsResponse, $8M67s.Message);
if ($9432b4eba6c55581$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.spre.ListProgramPricingOptionsResponse.displayName = 'proto.spre.ListProgramPricingOptionsResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.ItemTypeQuery.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.ItemTypeQuery.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.ItemTypeQuery} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ItemTypeQuery.toObject = function(includeInstance, msg) {
        var f, obj = {
            type: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.ItemTypeQuery}
 */ proto.spre.ItemTypeQuery.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.ItemTypeQuery;
    return proto.spre.ItemTypeQuery.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.ItemTypeQuery} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.ItemTypeQuery}
 */ proto.spre.ItemTypeQuery.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setType(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.ItemTypeQuery.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.ItemTypeQuery.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.ItemTypeQuery} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ItemTypeQuery.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getType();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string type = 1;
 * @return {string}
 */ proto.spre.ItemTypeQuery.prototype.getType = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.ItemTypeQuery} returns this
 */ proto.spre.ItemTypeQuery.prototype.setType = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.spre.ItemResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.ItemResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.ItemResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.ItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ItemResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            itemsList: $8M67s.Message.toObjectList(msg.getItemsList(), proto.spre.Item.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.ItemResponse}
 */ proto.spre.ItemResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.ItemResponse;
    return proto.spre.ItemResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.ItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.ItemResponse}
 */ proto.spre.ItemResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.spre.Item;
                reader.readMessage(value, proto.spre.Item.deserializeBinaryFromReader);
                msg.addItems(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.ItemResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.ItemResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.ItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ItemResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.spre.Item.serializeBinaryToWriter);
};
/**
 * repeated Item items = 1;
 * @return {!Array<!proto.spre.Item>}
 */ proto.spre.ItemResponse.prototype.getItemsList = function() {
    return /** @type{!Array<!proto.spre.Item>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.spre.Item, 1);
};
/**
 * @param {!Array<!proto.spre.Item>} value
 * @return {!proto.spre.ItemResponse} returns this
*/ proto.spre.ItemResponse.prototype.setItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.spre.Item=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spre.Item}
 */ proto.spre.ItemResponse.prototype.addItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.spre.Item, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.ItemResponse} returns this
 */ proto.spre.ItemResponse.prototype.clearItemsList = function() {
    return this.setItemsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Item.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Item.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Item} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Item.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Item}
 */ proto.spre.Item.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Item;
    return proto.spre.Item.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Item} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Item}
 */ proto.spre.Item.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Item.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Item.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Item} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Item.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.spre.Item.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Item} returns this
 */ proto.spre.Item.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.CustomerRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.CustomerRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.CustomerRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CustomerRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.CustomerRequest}
 */ proto.spre.CustomerRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.CustomerRequest;
    return proto.spre.CustomerRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.CustomerRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.CustomerRequest}
 */ proto.spre.CustomerRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.CustomerRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.CustomerRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.CustomerRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CustomerRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.spre.CustomerRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.CustomerRequest} returns this
 */ proto.spre.CustomerRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.QuoteRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.QuoteRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.QuoteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.QuoteRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            pricingOption: (f = msg.getPricingOption()) && $hOsJC.PricingOption.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.QuoteRequest}
 */ proto.spre.QuoteRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.QuoteRequest;
    return proto.spre.QuoteRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.QuoteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.QuoteRequest}
 */ proto.spre.QuoteRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            case 4:
                var value = new $hOsJC.PricingOption;
                reader.readMessage(value, $hOsJC.PricingOption.deserializeBinaryFromReader);
                msg.setPricingOption(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.QuoteRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.QuoteRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.QuoteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.QuoteRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getPricingOption();
    if (f != null) writer.writeMessage(4, f, $hOsJC.PricingOption.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.spre.QuoteRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.QuoteRequest} returns this
 */ proto.spre.QuoteRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.spre.QuoteRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.QuoteRequest} returns this
 */ proto.spre.QuoteRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string reservation_id = 3;
 * @return {string}
 */ proto.spre.QuoteRequest.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.QuoteRequest} returns this
 */ proto.spre.QuoteRequest.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional subscription.PricingOption pricing_option = 4;
 * @return {?proto.subscription.PricingOption}
 */ proto.spre.QuoteRequest.prototype.getPricingOption = function() {
    return /** @type{?proto.subscription.PricingOption} */ $8M67s.Message.getWrapperField(this, $hOsJC.PricingOption, 4);
};
/**
 * @param {?proto.subscription.PricingOption|undefined} value
 * @return {!proto.spre.QuoteRequest} returns this
*/ proto.spre.QuoteRequest.prototype.setPricingOption = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spre.QuoteRequest} returns this
 */ proto.spre.QuoteRequest.prototype.clearPricingOption = function() {
    return this.setPricingOption(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.spre.QuoteRequest.prototype.hasPricingOption = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.CreateIdResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.CreateIdResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.CreateIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CreateIdResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 2, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.CreateIdResponse}
 */ proto.spre.CreateIdResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.CreateIdResponse;
    return proto.spre.CreateIdResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.CreateIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.CreateIdResponse}
 */ proto.spre.CreateIdResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.CreateIdResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.CreateIdResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.CreateIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CreateIdResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getSuccess();
    if (f) writer.writeBool(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.spre.CreateIdResponse.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.CreateIdResponse} returns this
 */ proto.spre.CreateIdResponse.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional bool success = 2;
 * @return {boolean}
 */ proto.spre.CreateIdResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 2, false);
};
/**
 * @param {boolean} value
 * @return {!proto.spre.CreateIdResponse} returns this
 */ proto.spre.CreateIdResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.CreateResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.CreateResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.CreateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CreateResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.CreateResponse}
 */ proto.spre.CreateResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.CreateResponse;
    return proto.spre.CreateResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.CreateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.CreateResponse}
 */ proto.spre.CreateResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.CreateResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.CreateResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.CreateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CreateResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.spre.CreateResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.spre.CreateResponse} returns this
 */ proto.spre.CreateResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.ExecuteFunctionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.ExecuteFunctionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.ExecuteFunctionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ExecuteFunctionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            calculationId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            target: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            lutId: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.ExecuteFunctionRequest}
 */ proto.spre.ExecuteFunctionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.ExecuteFunctionRequest;
    return proto.spre.ExecuteFunctionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.ExecuteFunctionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.ExecuteFunctionRequest}
 */ proto.spre.ExecuteFunctionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCalculationId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setTarget(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setLutId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.ExecuteFunctionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.ExecuteFunctionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.ExecuteFunctionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ExecuteFunctionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCalculationId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getTarget();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getLutId();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional string calculation_id = 1;
 * @return {string}
 */ proto.spre.ExecuteFunctionRequest.prototype.getCalculationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.ExecuteFunctionRequest} returns this
 */ proto.spre.ExecuteFunctionRequest.prototype.setCalculationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string target = 2;
 * @return {string}
 */ proto.spre.ExecuteFunctionRequest.prototype.getTarget = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.ExecuteFunctionRequest} returns this
 */ proto.spre.ExecuteFunctionRequest.prototype.setTarget = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string lut_id = 3;
 * @return {string}
 */ proto.spre.ExecuteFunctionRequest.prototype.getLutId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.ExecuteFunctionRequest} returns this
 */ proto.spre.ExecuteFunctionRequest.prototype.setLutId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.VariableMap.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.VariableMap.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.VariableMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.VariableMap.toObject = function(includeInstance, msg) {
        var f, obj = {
            name: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            column: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.VariableMap}
 */ proto.spre.VariableMap.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.VariableMap;
    return proto.spre.VariableMap.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.VariableMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.VariableMap}
 */ proto.spre.VariableMap.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setColumn(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.VariableMap.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.VariableMap.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.VariableMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.VariableMap.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getName();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getColumn();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string name = 1;
 * @return {string}
 */ proto.spre.VariableMap.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.VariableMap} returns this
 */ proto.spre.VariableMap.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string column = 2;
 * @return {string}
 */ proto.spre.VariableMap.prototype.getColumn = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.VariableMap} returns this
 */ proto.spre.VariableMap.prototype.setColumn = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.spre.Calculation.repeatedFields_ = [
    3,
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Calculation.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Calculation.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Calculation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Calculation.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            operation: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            inputsList: $8M67s.Message.toObjectList(msg.getInputsList(), proto.spre.VariableMap.toObject, includeInstance),
            outputsList: $8M67s.Message.toObjectList(msg.getOutputsList(), proto.spre.VariableMap.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Calculation}
 */ proto.spre.Calculation.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Calculation;
    return proto.spre.Calculation.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Calculation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Calculation}
 */ proto.spre.Calculation.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setOperation(value);
                break;
            case 3:
                var value = new proto.spre.VariableMap;
                reader.readMessage(value, proto.spre.VariableMap.deserializeBinaryFromReader);
                msg.addInputs(value);
                break;
            case 4:
                var value = new proto.spre.VariableMap;
                reader.readMessage(value, proto.spre.VariableMap.deserializeBinaryFromReader);
                msg.addOutputs(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Calculation.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Calculation.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Calculation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Calculation.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getOperation();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getInputsList();
    if (f.length > 0) writer.writeRepeatedMessage(3, f, proto.spre.VariableMap.serializeBinaryToWriter);
    f = message.getOutputsList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.spre.VariableMap.serializeBinaryToWriter);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.spre.Calculation.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Calculation} returns this
 */ proto.spre.Calculation.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string operation = 2;
 * @return {string}
 */ proto.spre.Calculation.prototype.getOperation = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Calculation} returns this
 */ proto.spre.Calculation.prototype.setOperation = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * repeated VariableMap inputs = 3;
 * @return {!Array<!proto.spre.VariableMap>}
 */ proto.spre.Calculation.prototype.getInputsList = function() {
    return /** @type{!Array<!proto.spre.VariableMap>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.spre.VariableMap, 3);
};
/**
 * @param {!Array<!proto.spre.VariableMap>} value
 * @return {!proto.spre.Calculation} returns this
*/ proto.spre.Calculation.prototype.setInputsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 3, value);
};
/**
 * @param {!proto.spre.VariableMap=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spre.VariableMap}
 */ proto.spre.Calculation.prototype.addInputs = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.spre.VariableMap, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.Calculation} returns this
 */ proto.spre.Calculation.prototype.clearInputsList = function() {
    return this.setInputsList([]);
};
/**
 * repeated VariableMap outputs = 4;
 * @return {!Array<!proto.spre.VariableMap>}
 */ proto.spre.Calculation.prototype.getOutputsList = function() {
    return /** @type{!Array<!proto.spre.VariableMap>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.spre.VariableMap, 4);
};
/**
 * @param {!Array<!proto.spre.VariableMap>} value
 * @return {!proto.spre.Calculation} returns this
*/ proto.spre.Calculation.prototype.setOutputsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.spre.VariableMap=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spre.VariableMap}
 */ proto.spre.Calculation.prototype.addOutputs = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.spre.VariableMap, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.Calculation} returns this
 */ proto.spre.Calculation.prototype.clearOutputsList = function() {
    return this.setOutputsList([]);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.spre.Report.repeatedFields_ = [
    4
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Report.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Report.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Report} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Report.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            fico: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            income: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            expensesList: $8M67s.Message.toObjectList(msg.getExpensesList(), proto.spre.Expense.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Report}
 */ proto.spre.Report.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Report;
    return proto.spre.Report.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Report} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Report}
 */ proto.spre.Report.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setFico(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setIncome(value);
                break;
            case 4:
                var value = new proto.spre.Expense;
                reader.readMessage(value, proto.spre.Expense.deserializeBinaryFromReader);
                msg.addExpenses(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Report.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Report.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Report} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Report.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getFico();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getIncome();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getExpensesList();
    if (f.length > 0) writer.writeRepeatedMessage(4, f, proto.spre.Expense.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.spre.Report.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Report} returns this
 */ proto.spre.Report.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 fico = 2;
 * @return {number}
 */ proto.spre.Report.prototype.getFico = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Report} returns this
 */ proto.spre.Report.prototype.setFico = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 income = 3;
 * @return {number}
 */ proto.spre.Report.prototype.getIncome = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Report} returns this
 */ proto.spre.Report.prototype.setIncome = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * repeated Expense expenses = 4;
 * @return {!Array<!proto.spre.Expense>}
 */ proto.spre.Report.prototype.getExpensesList = function() {
    return /** @type{!Array<!proto.spre.Expense>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.spre.Expense, 4);
};
/**
 * @param {!Array<!proto.spre.Expense>} value
 * @return {!proto.spre.Report} returns this
*/ proto.spre.Report.prototype.setExpensesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 4, value);
};
/**
 * @param {!proto.spre.Expense=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spre.Expense}
 */ proto.spre.Report.prototype.addExpenses = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.spre.Expense, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.Report} returns this
 */ proto.spre.Report.prototype.clearExpensesList = function() {
    return this.setExpensesList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Expense.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Expense.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Expense} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Expense.toObject = function(includeInstance, msg) {
        var f, obj = {
            category: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            type: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            amount: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Expense}
 */ proto.spre.Expense.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Expense;
    return proto.spre.Expense.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Expense} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Expense}
 */ proto.spre.Expense.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {!proto.spre.Expense.Category} */ reader.readEnum();
                msg.setCategory(value);
                break;
            case 2:
                var value = /** @type {!proto.spre.Expense.Type} */ reader.readEnum();
                msg.setType(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAmount(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Expense.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Expense.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Expense} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Expense.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCategory();
    if (f !== 0.0) writer.writeEnum(1, f);
    f = message.getType();
    if (f !== 0.0) writer.writeEnum(2, f);
    f = message.getAmount();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * @enum {number}
 */ proto.spre.Expense.Category = {
    NOCATEGORY: 0,
    MORTGAGE: 1,
    RENT: 2,
    STUDENT_LOAN: 3,
    AUTO_LOAN: 4,
    AUTO_LEASE: 5,
    AUTO_INS: 6,
    CREDIT_CARD_MIN: 7
};
/**
 * @enum {number}
 */ proto.spre.Expense.Type = {
    NOTYPE: 0,
    FIXED: 1,
    VARIABLE: 2
};
/**
 * optional Category category = 1;
 * @return {!proto.spre.Expense.Category}
 */ proto.spre.Expense.prototype.getCategory = function() {
    return /** @type {!proto.spre.Expense.Category} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {!proto.spre.Expense.Category} value
 * @return {!proto.spre.Expense} returns this
 */ proto.spre.Expense.prototype.setCategory = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 1, value);
};
/**
 * optional Type type = 2;
 * @return {!proto.spre.Expense.Type}
 */ proto.spre.Expense.prototype.getType = function() {
    return /** @type {!proto.spre.Expense.Type} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {!proto.spre.Expense.Type} value
 * @return {!proto.spre.Expense} returns this
 */ proto.spre.Expense.prototype.setType = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 2, value);
};
/**
 * optional int32 amount = 3;
 * @return {number}
 */ proto.spre.Expense.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Expense} returns this
 */ proto.spre.Expense.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Profile.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Profile.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Profile} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Profile.toObject = function(includeInstance, msg) {
        var f, obj = {
            totalExpenses: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            netIncome: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            dti: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            maxPtiPct: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            maxPtiPmt: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            maxDtiPct: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            maxDtiPmt: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            incDtiPmt: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            maxPmt: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            vehicleBronze: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            vehicleSilver: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            vehicleGold: $8M67s.Message.getFieldWithDefault(msg, 12, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Profile}
 */ proto.spre.Profile.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Profile;
    return proto.spre.Profile.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Profile} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Profile}
 */ proto.spre.Profile.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotalExpenses(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setNetIncome(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDti(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxPtiPct(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxPtiPmt(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxDtiPct(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxDtiPmt(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setIncDtiPmt(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxPmt(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleBronze(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleSilver(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleGold(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Profile.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Profile.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Profile} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Profile.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTotalExpenses();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getNetIncome();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getDti();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getMaxPtiPct();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getMaxPtiPmt();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getMaxDtiPct();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getMaxDtiPmt();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getIncDtiPmt();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getMaxPmt();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getVehicleBronze();
    if (f !== 0) writer.writeInt32(10, f);
    f = message.getVehicleSilver();
    if (f !== 0) writer.writeInt32(11, f);
    f = message.getVehicleGold();
    if (f !== 0) writer.writeInt32(12, f);
};
/**
 * optional int32 total_expenses = 1;
 * @return {number}
 */ proto.spre.Profile.prototype.getTotalExpenses = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setTotalExpenses = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int32 net_income = 2;
 * @return {number}
 */ proto.spre.Profile.prototype.getNetIncome = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setNetIncome = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 dti = 3;
 * @return {number}
 */ proto.spre.Profile.prototype.getDti = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setDti = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 max_pti_pct = 4;
 * @return {number}
 */ proto.spre.Profile.prototype.getMaxPtiPct = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setMaxPtiPct = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 max_pti_pmt = 5;
 * @return {number}
 */ proto.spre.Profile.prototype.getMaxPtiPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setMaxPtiPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 max_dti_pct = 6;
 * @return {number}
 */ proto.spre.Profile.prototype.getMaxDtiPct = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setMaxDtiPct = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 max_dti_pmt = 7;
 * @return {number}
 */ proto.spre.Profile.prototype.getMaxDtiPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setMaxDtiPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 inc_dti_pmt = 8;
 * @return {number}
 */ proto.spre.Profile.prototype.getIncDtiPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setIncDtiPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 max_pmt = 9;
 * @return {number}
 */ proto.spre.Profile.prototype.getMaxPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setMaxPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 vehicle_bronze = 10;
 * @return {number}
 */ proto.spre.Profile.prototype.getVehicleBronze = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setVehicleBronze = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int32 vehicle_silver = 11;
 * @return {number}
 */ proto.spre.Profile.prototype.getVehicleSilver = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setVehicleSilver = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int32 vehicle_gold = 12;
 * @return {number}
 */ proto.spre.Profile.prototype.getVehicleGold = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Profile} returns this
 */ proto.spre.Profile.prototype.setVehicleGold = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.spre.Quote.repeatedFields_ = [
    6,
    7,
    8,
    9
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Quote.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Quote.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Quote} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Quote.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            lutId: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            startupList: $8M67s.Message.toObjectList(msg.getStartupList(), $3QqPt.Product.toObject, includeInstance),
            monthlyList: $8M67s.Message.toObjectList(msg.getMonthlyList(), $3QqPt.Product.toObject, includeInstance),
            lineItemsList: $8M67s.Message.toObjectList(msg.getLineItemsList(), $3QqPt.LineItem.toObject, includeInstance),
            valuationsList: $8M67s.Message.toObjectList(msg.getValuationsList(), $9YICB.Valuation.toObject, includeInstance),
            reservationId: $8M67s.Message.getFieldWithDefault(msg, 10, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Quote}
 */ proto.spre.Quote.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Quote;
    return proto.spre.Quote.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Quote} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Quote}
 */ proto.spre.Quote.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setLutId(value);
                break;
            case 6:
                var value = new $3QqPt.Product;
                reader.readMessage(value, $3QqPt.Product.deserializeBinaryFromReader);
                msg.addStartup(value);
                break;
            case 7:
                var value = new $3QqPt.Product;
                reader.readMessage(value, $3QqPt.Product.deserializeBinaryFromReader);
                msg.addMonthly(value);
                break;
            case 8:
                var value = new $3QqPt.LineItem;
                reader.readMessage(value, $3QqPt.LineItem.deserializeBinaryFromReader);
                msg.addLineItems(value);
                break;
            case 9:
                var value = new $9YICB.Valuation;
                reader.readMessage(value, $9YICB.Valuation.deserializeBinaryFromReader);
                msg.addValuations(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setReservationId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Quote.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Quote.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Quote} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Quote.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getLutId();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getStartupList();
    if (f.length > 0) writer.writeRepeatedMessage(6, f, $3QqPt.Product.serializeBinaryToWriter);
    f = message.getMonthlyList();
    if (f.length > 0) writer.writeRepeatedMessage(7, f, $3QqPt.Product.serializeBinaryToWriter);
    f = message.getLineItemsList();
    if (f.length > 0) writer.writeRepeatedMessage(8, f, $3QqPt.LineItem.serializeBinaryToWriter);
    f = message.getValuationsList();
    if (f.length > 0) writer.writeRepeatedMessage(9, f, $9YICB.Valuation.serializeBinaryToWriter);
    f = message.getReservationId();
    if (f.length > 0) writer.writeString(10, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.spre.Quote.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.spre.Quote.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string vehicle_id = 3;
 * @return {string}
 */ proto.spre.Quote.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional string dealer_id = 4;
 * @return {string}
 */ proto.spre.Quote.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string lut_id = 5;
 * @return {string}
 */ proto.spre.Quote.prototype.getLutId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.setLutId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * repeated domain.Product startup = 6;
 * @return {!Array<!proto.domain.Product>}
 */ proto.spre.Quote.prototype.getStartupList = function() {
    return /** @type{!Array<!proto.domain.Product>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Product, 6);
};
/**
 * @param {!Array<!proto.domain.Product>} value
 * @return {!proto.spre.Quote} returns this
*/ proto.spre.Quote.prototype.setStartupList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 6, value);
};
/**
 * @param {!proto.domain.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Product}
 */ proto.spre.Quote.prototype.addStartup = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.domain.Product, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.clearStartupList = function() {
    return this.setStartupList([]);
};
/**
 * repeated domain.Product monthly = 7;
 * @return {!Array<!proto.domain.Product>}
 */ proto.spre.Quote.prototype.getMonthlyList = function() {
    return /** @type{!Array<!proto.domain.Product>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Product, 7);
};
/**
 * @param {!Array<!proto.domain.Product>} value
 * @return {!proto.spre.Quote} returns this
*/ proto.spre.Quote.prototype.setMonthlyList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 7, value);
};
/**
 * @param {!proto.domain.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Product}
 */ proto.spre.Quote.prototype.addMonthly = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.domain.Product, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.clearMonthlyList = function() {
    return this.setMonthlyList([]);
};
/**
 * repeated domain.LineItem line_items = 8;
 * @return {!Array<!proto.domain.LineItem>}
 */ proto.spre.Quote.prototype.getLineItemsList = function() {
    return /** @type{!Array<!proto.domain.LineItem>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.LineItem, 8);
};
/**
 * @param {!Array<!proto.domain.LineItem>} value
 * @return {!proto.spre.Quote} returns this
*/ proto.spre.Quote.prototype.setLineItemsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 8, value);
};
/**
 * @param {!proto.domain.LineItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.LineItem}
 */ proto.spre.Quote.prototype.addLineItems = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.domain.LineItem, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.clearLineItemsList = function() {
    return this.setLineItemsList([]);
};
/**
 * repeated vehicle.Valuation valuations = 9;
 * @return {!Array<!proto.vehicle.Valuation>}
 */ proto.spre.Quote.prototype.getValuationsList = function() {
    return /** @type{!Array<!proto.vehicle.Valuation>} */ $8M67s.Message.getRepeatedWrapperField(this, $9YICB.Valuation, 9);
};
/**
 * @param {!Array<!proto.vehicle.Valuation>} value
 * @return {!proto.spre.Quote} returns this
*/ proto.spre.Quote.prototype.setValuationsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 9, value);
};
/**
 * @param {!proto.vehicle.Valuation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Valuation}
 */ proto.spre.Quote.prototype.addValuations = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.vehicle.Valuation, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.clearValuationsList = function() {
    return this.setValuationsList([]);
};
/**
 * optional string reservation_id = 10;
 * @return {string}
 */ proto.spre.Quote.prototype.getReservationId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Quote} returns this
 */ proto.spre.Quote.prototype.setReservationId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Algorithm.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Algorithm.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Algorithm} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Algorithm.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            name: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            formula: $8M67s.Message.getFieldWithDefault(msg, 3, ""),
            lut: (f = msg.getLut()) && proto.spre.Lut.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Algorithm}
 */ proto.spre.Algorithm.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Algorithm;
    return proto.spre.Algorithm.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Algorithm} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Algorithm}
 */ proto.spre.Algorithm.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setName(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setFormula(value);
                break;
            case 4:
                var value = new proto.spre.Lut;
                reader.readMessage(value, proto.spre.Lut.deserializeBinaryFromReader);
                msg.setLut(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Algorithm.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Algorithm.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Algorithm} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Algorithm.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getName();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFormula();
    if (f.length > 0) writer.writeString(3, f);
    f = message.getLut();
    if (f != null) writer.writeMessage(4, f, proto.spre.Lut.serializeBinaryToWriter);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.spre.Algorithm.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Algorithm} returns this
 */ proto.spre.Algorithm.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string name = 2;
 * @return {string}
 */ proto.spre.Algorithm.prototype.getName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Algorithm} returns this
 */ proto.spre.Algorithm.prototype.setName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional string formula = 3;
 * @return {string}
 */ proto.spre.Algorithm.prototype.getFormula = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Algorithm} returns this
 */ proto.spre.Algorithm.prototype.setFormula = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * optional Lut lut = 4;
 * @return {?proto.spre.Lut}
 */ proto.spre.Algorithm.prototype.getLut = function() {
    return /** @type{?proto.spre.Lut} */ $8M67s.Message.getWrapperField(this, proto.spre.Lut, 4);
};
/**
 * @param {?proto.spre.Lut|undefined} value
 * @return {!proto.spre.Algorithm} returns this
*/ proto.spre.Algorithm.prototype.setLut = function(value) {
    return $8M67s.Message.setWrapperField(this, 4, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spre.Algorithm} returns this
 */ proto.spre.Algorithm.prototype.clearLut = function() {
    return this.setLut(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.spre.Algorithm.prototype.hasLut = function() {
    return $8M67s.Message.getField(this, 4) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.spre.Lut.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Lut.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Lut.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Lut} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Lut.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            bandsList: $8M67s.Message.toObjectList(msg.getBandsList(), proto.spre.Band.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Lut}
 */ proto.spre.Lut.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Lut;
    return proto.spre.Lut.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Lut} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Lut}
 */ proto.spre.Lut.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = new proto.spre.Band;
                reader.readMessage(value, proto.spre.Band.deserializeBinaryFromReader);
                msg.addBands(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Lut.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Lut.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Lut} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Lut.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getBandsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.spre.Band.serializeBinaryToWriter);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.spre.Lut.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Lut} returns this
 */ proto.spre.Lut.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * repeated Band bands = 2;
 * @return {!Array<!proto.spre.Band>}
 */ proto.spre.Lut.prototype.getBandsList = function() {
    return /** @type{!Array<!proto.spre.Band>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.spre.Band, 2);
};
/**
 * @param {!Array<!proto.spre.Band>} value
 * @return {!proto.spre.Lut} returns this
*/ proto.spre.Lut.prototype.setBandsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.spre.Band=} opt_value
 * @param {number=} opt_index
 * @return {!proto.spre.Band}
 */ proto.spre.Lut.prototype.addBands = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.spre.Band, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.Lut} returns this
 */ proto.spre.Lut.prototype.clearBandsList = function() {
    return this.setBandsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Band.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Band.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Band} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Band.toObject = function(includeInstance, msg) {
        var f, obj = {
            fico: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            ficoBand: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            ficoMin: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            ficoMax: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            riskBand: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            pti: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            dti: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            start15k: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            start20k: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            start25k: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            start30k: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            inscAndLiSm: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            inscAndLiMd: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            inscAndLiLg: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            tax: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            pOverFmvSm: $8M67s.Message.getFieldWithDefault(msg, 17, 0),
            pOverFmvMd: $8M67s.Message.getFieldWithDefault(msg, 18, 0),
            pOverFmvLg: $8M67s.Message.getFieldWithDefault(msg, 19, 0),
            loan36: $8M67s.Message.getFieldWithDefault(msg, 20, 0),
            loan48: $8M67s.Message.getFieldWithDefault(msg, 21, 0),
            loan60: $8M67s.Message.getFieldWithDefault(msg, 22, 0),
            loan72: $8M67s.Message.getFieldWithDefault(msg, 23, 0),
            lse24: $8M67s.Message.getFieldWithDefault(msg, 24, 0),
            lse36: $8M67s.Message.getFieldWithDefault(msg, 25, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Band}
 */ proto.spre.Band.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Band;
    return proto.spre.Band.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Band} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Band}
 */ proto.spre.Band.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setFico(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setFicoBand(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setFicoMin(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setFicoMax(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setRiskBand(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPti(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDti(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStart15k(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStart20k(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStart25k(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStart30k(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInscAndLiSm(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInscAndLiMd(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt32();
                msg.setInscAndLiLg(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTax(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPOverFmvSm(value);
                break;
            case 18:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPOverFmvMd(value);
                break;
            case 19:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPOverFmvLg(value);
                break;
            case 20:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLoan36(value);
                break;
            case 21:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLoan48(value);
                break;
            case 22:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLoan60(value);
                break;
            case 23:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLoan72(value);
                break;
            case 24:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLse24(value);
                break;
            case 25:
                var value = /** @type {number} */ reader.readInt32();
                msg.setLse36(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Band.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Band.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Band} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Band.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getFico();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getFicoBand();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getFicoMin();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getFicoMax();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getRiskBand();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getPti();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getDti();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getStart15k();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getStart20k();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getStart25k();
    if (f !== 0) writer.writeInt32(10, f);
    f = message.getStart30k();
    if (f !== 0) writer.writeInt32(11, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(12, f);
    f = message.getInscAndLiSm();
    if (f !== 0) writer.writeInt32(13, f);
    f = message.getInscAndLiMd();
    if (f !== 0) writer.writeInt32(14, f);
    f = message.getInscAndLiLg();
    if (f !== 0) writer.writeInt32(15, f);
    f = message.getTax();
    if (f !== 0) writer.writeInt32(16, f);
    f = message.getPOverFmvSm();
    if (f !== 0) writer.writeInt32(17, f);
    f = message.getPOverFmvMd();
    if (f !== 0) writer.writeInt32(18, f);
    f = message.getPOverFmvLg();
    if (f !== 0) writer.writeInt32(19, f);
    f = message.getLoan36();
    if (f !== 0) writer.writeInt32(20, f);
    f = message.getLoan48();
    if (f !== 0) writer.writeInt32(21, f);
    f = message.getLoan60();
    if (f !== 0) writer.writeInt32(22, f);
    f = message.getLoan72();
    if (f !== 0) writer.writeInt32(23, f);
    f = message.getLse24();
    if (f !== 0) writer.writeInt32(24, f);
    f = message.getLse36();
    if (f !== 0) writer.writeInt32(25, f);
};
/**
 * optional int32 fico = 1;
 * @return {number}
 */ proto.spre.Band.prototype.getFico = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setFico = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional string fico_band = 2;
 * @return {string}
 */ proto.spre.Band.prototype.getFicoBand = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setFicoBand = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 fico_min = 3;
 * @return {number}
 */ proto.spre.Band.prototype.getFicoMin = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setFicoMin = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 fico_max = 4;
 * @return {number}
 */ proto.spre.Band.prototype.getFicoMax = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setFicoMax = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional string risk_band = 5;
 * @return {string}
 */ proto.spre.Band.prototype.getRiskBand = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setRiskBand = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional int32 pti = 6;
 * @return {number}
 */ proto.spre.Band.prototype.getPti = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setPti = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 dti = 7;
 * @return {number}
 */ proto.spre.Band.prototype.getDti = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setDti = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 start15k = 8;
 * @return {number}
 */ proto.spre.Band.prototype.getStart15k = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setStart15k = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 start20k = 9;
 * @return {number}
 */ proto.spre.Band.prototype.getStart20k = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setStart20k = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 start25k = 10;
 * @return {number}
 */ proto.spre.Band.prototype.getStart25k = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setStart25k = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int32 start30k = 11;
 * @return {number}
 */ proto.spre.Band.prototype.getStart30k = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setStart30k = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int32 deposit = 12;
 * @return {number}
 */ proto.spre.Band.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional int32 insc_and_li_sm = 13;
 * @return {number}
 */ proto.spre.Band.prototype.getInscAndLiSm = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setInscAndLiSm = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
/**
 * optional int32 insc_and_li_md = 14;
 * @return {number}
 */ proto.spre.Band.prototype.getInscAndLiMd = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setInscAndLiMd = function(value) {
    return $8M67s.Message.setProto3IntField(this, 14, value);
};
/**
 * optional int32 insc_and_li_lg = 15;
 * @return {number}
 */ proto.spre.Band.prototype.getInscAndLiLg = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setInscAndLiLg = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * optional int32 tax = 16;
 * @return {number}
 */ proto.spre.Band.prototype.getTax = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setTax = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
/**
 * optional int32 p_over_fmv_sm = 17;
 * @return {number}
 */ proto.spre.Band.prototype.getPOverFmvSm = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 17, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setPOverFmvSm = function(value) {
    return $8M67s.Message.setProto3IntField(this, 17, value);
};
/**
 * optional int32 p_over_fmv_md = 18;
 * @return {number}
 */ proto.spre.Band.prototype.getPOverFmvMd = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 18, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setPOverFmvMd = function(value) {
    return $8M67s.Message.setProto3IntField(this, 18, value);
};
/**
 * optional int32 p_over_fmv_lg = 19;
 * @return {number}
 */ proto.spre.Band.prototype.getPOverFmvLg = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 19, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setPOverFmvLg = function(value) {
    return $8M67s.Message.setProto3IntField(this, 19, value);
};
/**
 * optional int32 loan36 = 20;
 * @return {number}
 */ proto.spre.Band.prototype.getLoan36 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 20, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setLoan36 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 20, value);
};
/**
 * optional int32 loan48 = 21;
 * @return {number}
 */ proto.spre.Band.prototype.getLoan48 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 21, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setLoan48 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 21, value);
};
/**
 * optional int32 loan60 = 22;
 * @return {number}
 */ proto.spre.Band.prototype.getLoan60 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 22, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setLoan60 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 22, value);
};
/**
 * optional int32 loan72 = 23;
 * @return {number}
 */ proto.spre.Band.prototype.getLoan72 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 23, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setLoan72 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 23, value);
};
/**
 * optional int32 lse24 = 24;
 * @return {number}
 */ proto.spre.Band.prototype.getLse24 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 24, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setLse24 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 24, value);
};
/**
 * optional int32 lse36 = 25;
 * @return {number}
 */ proto.spre.Band.prototype.getLse36 = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 25, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Band} returns this
 */ proto.spre.Band.prototype.setLse36 = function(value) {
    return $8M67s.Message.setProto3IntField(this, 25, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.HypotheticalRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.HypotheticalRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.HypotheticalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.HypotheticalRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            lutId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            minRent: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            minIns: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            colAndLi: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            exm: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            ewt: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            colAndLiDeduct: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            fico: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            grossAnnualIncome: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            mortgage: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            rent: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            studentLoan: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            autoLoan: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            autoLease: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            autoIns: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            creditCardMin: $8M67s.Message.getFieldWithDefault(msg, 16, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.HypotheticalRequest}
 */ proto.spre.HypotheticalRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.HypotheticalRequest;
    return proto.spre.HypotheticalRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.HypotheticalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.HypotheticalRequest}
 */ proto.spre.HypotheticalRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setLutId(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMinRent(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMinIns(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setColAndLi(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setExm(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setEwt(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setColAndLiDeduct(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setFico(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setGrossAnnualIncome(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMortgage(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt32();
                msg.setRent(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStudentLoan(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAutoLoan(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAutoLease(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt32();
                msg.setAutoIns(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setCreditCardMin(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.HypotheticalRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.HypotheticalRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.HypotheticalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.HypotheticalRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLutId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getMinRent();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getMinIns();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getColAndLi();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getExm();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getEwt();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getColAndLiDeduct();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getFico();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getGrossAnnualIncome();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getMortgage();
    if (f !== 0) writer.writeInt32(10, f);
    f = message.getRent();
    if (f !== 0) writer.writeInt32(11, f);
    f = message.getStudentLoan();
    if (f !== 0) writer.writeInt32(12, f);
    f = message.getAutoLoan();
    if (f !== 0) writer.writeInt32(13, f);
    f = message.getAutoLease();
    if (f !== 0) writer.writeInt32(14, f);
    f = message.getAutoIns();
    if (f !== 0) writer.writeInt32(15, f);
    f = message.getCreditCardMin();
    if (f !== 0) writer.writeInt32(16, f);
};
/**
 * optional string lut_id = 1;
 * @return {string}
 */ proto.spre.HypotheticalRequest.prototype.getLutId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setLutId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional int32 min_rent = 2;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getMinRent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setMinRent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 min_ins = 3;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getMinIns = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setMinIns = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 col_and_li = 4;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getColAndLi = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setColAndLi = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 exm = 5;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getExm = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setExm = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 ewt = 6;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getEwt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setEwt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 col_and_li_deduct = 7;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getColAndLiDeduct = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setColAndLiDeduct = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 fico = 8;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getFico = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setFico = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 gross_annual_income = 9;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getGrossAnnualIncome = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setGrossAnnualIncome = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 mortgage = 10;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getMortgage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setMortgage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int32 rent = 11;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getRent = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setRent = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int32 student_loan = 12;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getStudentLoan = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setStudentLoan = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional int32 auto_loan = 13;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getAutoLoan = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setAutoLoan = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
/**
 * optional int32 auto_lease = 14;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getAutoLease = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setAutoLease = function(value) {
    return $8M67s.Message.setProto3IntField(this, 14, value);
};
/**
 * optional int32 auto_ins = 15;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getAutoIns = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setAutoIns = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * optional int32 credit_card_min = 16;
 * @return {number}
 */ proto.spre.HypotheticalRequest.prototype.getCreditCardMin = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalRequest} returns this
 */ proto.spre.HypotheticalRequest.prototype.setCreditCardMin = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.HypotheticalResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.HypotheticalResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.HypotheticalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.HypotheticalResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            ficoBand: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            riskBand: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            grossIncome: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            totalExpenses: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            dti: $8M67s.Message.getFieldWithDefault(msg, 5, 0),
            netIncome: $8M67s.Message.getFieldWithDefault(msg, 6, 0),
            maxDtiPct: $8M67s.Message.getFieldWithDefault(msg, 7, 0),
            maxDtiPmt: $8M67s.Message.getFieldWithDefault(msg, 8, 0),
            incDtiPmt: $8M67s.Message.getFieldWithDefault(msg, 9, 0),
            maxPtiPct: $8M67s.Message.getFieldWithDefault(msg, 10, 0),
            maxPtiPmt: $8M67s.Message.getFieldWithDefault(msg, 11, 0),
            minSubAvail: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            maxPmt: $8M67s.Message.getFieldWithDefault(msg, 13, 0),
            subscription: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            deposit: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            startPmt: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            tax: $8M67s.Message.getFieldWithDefault(msg, 17, 0),
            driveOff: $8M67s.Message.getFieldWithDefault(msg, 18, 0),
            vehicleBronze: $8M67s.Message.getFieldWithDefault(msg, 19, 0),
            vehicleSilver: $8M67s.Message.getFieldWithDefault(msg, 20, 0),
            vehicleGold: $8M67s.Message.getFieldWithDefault(msg, 21, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.HypotheticalResponse}
 */ proto.spre.HypotheticalResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.HypotheticalResponse;
    return proto.spre.HypotheticalResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.HypotheticalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.HypotheticalResponse}
 */ proto.spre.HypotheticalResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setFicoBand(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setRiskBand(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setGrossIncome(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotalExpenses(value);
                break;
            case 5:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDti(value);
                break;
            case 6:
                var value = /** @type {number} */ reader.readInt32();
                msg.setNetIncome(value);
                break;
            case 7:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxDtiPct(value);
                break;
            case 8:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxDtiPmt(value);
                break;
            case 9:
                var value = /** @type {number} */ reader.readInt32();
                msg.setIncDtiPmt(value);
                break;
            case 10:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxPtiPct(value);
                break;
            case 11:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxPtiPmt(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMinSubAvail(value);
                break;
            case 13:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMaxPmt(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readInt32();
                msg.setSubscription(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDeposit(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartPmt(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTax(value);
                break;
            case 18:
                var value = /** @type {number} */ reader.readInt32();
                msg.setDriveOff(value);
                break;
            case 19:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleBronze(value);
                break;
            case 20:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleSilver(value);
                break;
            case 21:
                var value = /** @type {number} */ reader.readInt32();
                msg.setVehicleGold(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.HypotheticalResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.HypotheticalResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.HypotheticalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.HypotheticalResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getFicoBand();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getRiskBand();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getGrossIncome();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getTotalExpenses();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getDti();
    if (f !== 0) writer.writeInt32(5, f);
    f = message.getNetIncome();
    if (f !== 0) writer.writeInt32(6, f);
    f = message.getMaxDtiPct();
    if (f !== 0) writer.writeInt32(7, f);
    f = message.getMaxDtiPmt();
    if (f !== 0) writer.writeInt32(8, f);
    f = message.getIncDtiPmt();
    if (f !== 0) writer.writeInt32(9, f);
    f = message.getMaxPtiPct();
    if (f !== 0) writer.writeInt32(10, f);
    f = message.getMaxPtiPmt();
    if (f !== 0) writer.writeInt32(11, f);
    f = message.getMinSubAvail();
    if (f !== 0) writer.writeInt32(12, f);
    f = message.getMaxPmt();
    if (f !== 0) writer.writeInt32(13, f);
    f = message.getSubscription();
    if (f !== 0) writer.writeInt32(14, f);
    f = message.getDeposit();
    if (f !== 0) writer.writeInt32(15, f);
    f = message.getStartPmt();
    if (f !== 0) writer.writeInt32(16, f);
    f = message.getTax();
    if (f !== 0) writer.writeInt32(17, f);
    f = message.getDriveOff();
    if (f !== 0) writer.writeInt32(18, f);
    f = message.getVehicleBronze();
    if (f !== 0) writer.writeInt32(19, f);
    f = message.getVehicleSilver();
    if (f !== 0) writer.writeInt32(20, f);
    f = message.getVehicleGold();
    if (f !== 0) writer.writeInt32(21, f);
};
/**
 * optional string fico_band = 1;
 * @return {string}
 */ proto.spre.HypotheticalResponse.prototype.getFicoBand = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setFicoBand = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string risk_band = 2;
 * @return {string}
 */ proto.spre.HypotheticalResponse.prototype.getRiskBand = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setRiskBand = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 gross_income = 3;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getGrossIncome = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setGrossIncome = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 total_expenses = 4;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getTotalExpenses = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setTotalExpenses = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional int32 dti = 5;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getDti = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setDti = function(value) {
    return $8M67s.Message.setProto3IntField(this, 5, value);
};
/**
 * optional int32 net_income = 6;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getNetIncome = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 6, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setNetIncome = function(value) {
    return $8M67s.Message.setProto3IntField(this, 6, value);
};
/**
 * optional int32 max_dti_pct = 7;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getMaxDtiPct = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 7, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setMaxDtiPct = function(value) {
    return $8M67s.Message.setProto3IntField(this, 7, value);
};
/**
 * optional int32 max_dti_pmt = 8;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getMaxDtiPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 8, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setMaxDtiPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 8, value);
};
/**
 * optional int32 inc_dti_pmt = 9;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getIncDtiPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 9, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setIncDtiPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 9, value);
};
/**
 * optional int32 max_pti_pct = 10;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getMaxPtiPct = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 10, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setMaxPtiPct = function(value) {
    return $8M67s.Message.setProto3IntField(this, 10, value);
};
/**
 * optional int32 max_pti_pmt = 11;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getMaxPtiPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 11, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setMaxPtiPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 11, value);
};
/**
 * optional int32 min_sub_avail = 12;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getMinSubAvail = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setMinSubAvail = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional int32 max_pmt = 13;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getMaxPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 13, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setMaxPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 13, value);
};
/**
 * optional int32 subscription = 14;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getSubscription = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setSubscription = function(value) {
    return $8M67s.Message.setProto3IntField(this, 14, value);
};
/**
 * optional int32 deposit = 15;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * optional int32 start_pmt = 16;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getStartPmt = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setStartPmt = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
/**
 * optional int32 tax = 17;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getTax = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 17, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setTax = function(value) {
    return $8M67s.Message.setProto3IntField(this, 17, value);
};
/**
 * optional int32 drive_off = 18;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getDriveOff = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 18, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setDriveOff = function(value) {
    return $8M67s.Message.setProto3IntField(this, 18, value);
};
/**
 * optional int32 vehicle_bronze = 19;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getVehicleBronze = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 19, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setVehicleBronze = function(value) {
    return $8M67s.Message.setProto3IntField(this, 19, value);
};
/**
 * optional int32 vehicle_silver = 20;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getVehicleSilver = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 20, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setVehicleSilver = function(value) {
    return $8M67s.Message.setProto3IntField(this, 20, value);
};
/**
 * optional int32 vehicle_gold = 21;
 * @return {number}
 */ proto.spre.HypotheticalResponse.prototype.getVehicleGold = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 21, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.HypotheticalResponse} returns this
 */ proto.spre.HypotheticalResponse.prototype.setVehicleGold = function(value) {
    return $8M67s.Message.setProto3IntField(this, 21, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.Price.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.Price.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.Price} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Price.toObject = function(includeInstance, msg) {
        var f, obj = {
            product: (f = msg.getProduct()) && $3QqPt.Product.toObject(includeInstance, f),
            amount: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            currency: $8M67s.Message.getFieldWithDefault(msg, 3, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.Price}
 */ proto.spre.Price.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.Price;
    return proto.spre.Price.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.Price} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.Price}
 */ proto.spre.Price.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Product;
                reader.readMessage(value, $3QqPt.Product.deserializeBinaryFromReader);
                msg.setProduct(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setAmount(value);
                break;
            case 3:
                var value = /** @type {string} */ reader.readString();
                msg.setCurrency(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.Price.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.Price.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.Price} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.Price.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProduct();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Product.serializeBinaryToWriter);
    f = message.getAmount();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getCurrency();
    if (f.length > 0) writer.writeString(3, f);
};
/**
 * optional domain.Product product = 1;
 * @return {?proto.domain.Product}
 */ proto.spre.Price.prototype.getProduct = function() {
    return /** @type{?proto.domain.Product} */ $8M67s.Message.getWrapperField(this, $3QqPt.Product, 1);
};
/**
 * @param {?proto.domain.Product|undefined} value
 * @return {!proto.spre.Price} returns this
*/ proto.spre.Price.prototype.setProduct = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spre.Price} returns this
 */ proto.spre.Price.prototype.clearProduct = function() {
    return this.setProduct(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.spre.Price.prototype.hasProduct = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
/**
 * optional int64 amount = 2;
 * @return {number}
 */ proto.spre.Price.prototype.getAmount = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.Price} returns this
 */ proto.spre.Price.prototype.setAmount = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional string currency = 3;
 * @return {string}
 */ proto.spre.Price.prototype.getCurrency = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 3, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.Price} returns this
 */ proto.spre.Price.prototype.setCurrency = function(value) {
    return $8M67s.Message.setProto3StringField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.spre.ListProductsResponse.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.ListProductsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.ListProductsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.ListProductsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ListProductsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            productsList: $8M67s.Message.toObjectList(msg.getProductsList(), $3QqPt.Product.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.ListProductsResponse}
 */ proto.spre.ListProductsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.ListProductsResponse;
    return proto.spre.ListProductsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.ListProductsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.ListProductsResponse}
 */ proto.spre.ListProductsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = new $3QqPt.Product;
                reader.readMessage(value, $3QqPt.Product.deserializeBinaryFromReader);
                msg.addProducts(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.ListProductsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.ListProductsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.ListProductsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ListProductsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getProductsList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, $3QqPt.Product.serializeBinaryToWriter);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.spre.ListProductsResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.spre.ListProductsResponse} returns this
 */ proto.spre.ListProductsResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * repeated domain.Product products = 2;
 * @return {!Array<!proto.domain.Product>}
 */ proto.spre.ListProductsResponse.prototype.getProductsList = function() {
    return /** @type{!Array<!proto.domain.Product>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Product, 2);
};
/**
 * @param {!Array<!proto.domain.Product>} value
 * @return {!proto.spre.ListProductsResponse} returns this
*/ proto.spre.ListProductsResponse.prototype.setProductsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.domain.Product=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Product}
 */ proto.spre.ListProductsResponse.prototype.addProducts = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.domain.Product, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.ListProductsResponse} returns this
 */ proto.spre.ListProductsResponse.prototype.clearProductsList = function() {
    return this.setProductsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.ListProductsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.ListProductsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.ListProductsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ListProductsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            limit: $8M67s.Message.getFieldWithDefault(msg, 1, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.ListProductsRequest}
 */ proto.spre.ListProductsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.ListProductsRequest;
    return proto.spre.ListProductsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.ListProductsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.ListProductsRequest}
 */ proto.spre.ListProductsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setLimit(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.ListProductsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.ListProductsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.ListProductsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ListProductsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getLimit();
    if (f !== 0) writer.writeInt64(1, f);
};
/**
 * optional int64 limit = 1;
 * @return {number}
 */ proto.spre.ListProductsRequest.prototype.getLimit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.spre.ListProductsRequest} returns this
 */ proto.spre.ListProductsRequest.prototype.setLimit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.CalculateVehiclePricingRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.CalculateVehiclePricingRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.CalculateVehiclePricingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CalculateVehiclePricingRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.CalculateVehiclePricingRequest}
 */ proto.spre.CalculateVehiclePricingRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.CalculateVehiclePricingRequest;
    return proto.spre.CalculateVehiclePricingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.CalculateVehiclePricingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.CalculateVehiclePricingRequest}
 */ proto.spre.CalculateVehiclePricingRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.CalculateVehiclePricingRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.CalculateVehiclePricingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.CalculateVehiclePricingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CalculateVehiclePricingRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional vehicle.Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.spre.CalculateVehiclePricingRequest.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.spre.CalculateVehiclePricingRequest} returns this
*/ proto.spre.CalculateVehiclePricingRequest.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spre.CalculateVehiclePricingRequest} returns this
 */ proto.spre.CalculateVehiclePricingRequest.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.spre.CalculateVehiclePricingRequest.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.CalculateVehiclePricingResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.CalculateVehiclePricingResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.CalculateVehiclePricingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CalculateVehiclePricingResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.CalculateVehiclePricingResponse}
 */ proto.spre.CalculateVehiclePricingResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.CalculateVehiclePricingResponse;
    return proto.spre.CalculateVehiclePricingResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.CalculateVehiclePricingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.CalculateVehiclePricingResponse}
 */ proto.spre.CalculateVehiclePricingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.CalculateVehiclePricingResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.CalculateVehiclePricingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.CalculateVehiclePricingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CalculateVehiclePricingResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getVehicle();
    if (f != null) writer.writeMessage(2, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.spre.CalculateVehiclePricingResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.spre.CalculateVehiclePricingResponse} returns this
 */ proto.spre.CalculateVehiclePricingResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional vehicle.Vehicle vehicle = 2;
 * @return {?proto.vehicle.Vehicle}
 */ proto.spre.CalculateVehiclePricingResponse.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 2);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.spre.CalculateVehiclePricingResponse} returns this
*/ proto.spre.CalculateVehiclePricingResponse.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spre.CalculateVehiclePricingResponse} returns this
 */ proto.spre.CalculateVehiclePricingResponse.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.spre.CalculateVehiclePricingResponse.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.CalculateCustomerVehiclePricingRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.CalculateCustomerVehiclePricingRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.CalculateCustomerVehiclePricingRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CalculateCustomerVehiclePricingRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.CalculateCustomerVehiclePricingRequest}
 */ proto.spre.CalculateCustomerVehiclePricingRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.CalculateCustomerVehiclePricingRequest;
    return proto.spre.CalculateCustomerVehiclePricingRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.CalculateCustomerVehiclePricingRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.CalculateCustomerVehiclePricingRequest}
 */ proto.spre.CalculateCustomerVehiclePricingRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.CalculateCustomerVehiclePricingRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.CalculateCustomerVehiclePricingRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.CalculateCustomerVehiclePricingRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CalculateCustomerVehiclePricingRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicle();
    if (f != null) writer.writeMessage(2, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.spre.CalculateCustomerVehiclePricingRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.CalculateCustomerVehiclePricingRequest} returns this
 */ proto.spre.CalculateCustomerVehiclePricingRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional vehicle.Vehicle vehicle = 2;
 * @return {?proto.vehicle.Vehicle}
 */ proto.spre.CalculateCustomerVehiclePricingRequest.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 2);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.spre.CalculateCustomerVehiclePricingRequest} returns this
*/ proto.spre.CalculateCustomerVehiclePricingRequest.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spre.CalculateCustomerVehiclePricingRequest} returns this
 */ proto.spre.CalculateCustomerVehiclePricingRequest.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.spre.CalculateCustomerVehiclePricingRequest.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.CalculateCustomerVehiclePricingResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.CalculateCustomerVehiclePricingResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.CalculateCustomerVehiclePricingResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CalculateCustomerVehiclePricingResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.CalculateCustomerVehiclePricingResponse}
 */ proto.spre.CalculateCustomerVehiclePricingResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.CalculateCustomerVehiclePricingResponse;
    return proto.spre.CalculateCustomerVehiclePricingResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.CalculateCustomerVehiclePricingResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.CalculateCustomerVehiclePricingResponse}
 */ proto.spre.CalculateCustomerVehiclePricingResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.CalculateCustomerVehiclePricingResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.CalculateCustomerVehiclePricingResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.CalculateCustomerVehiclePricingResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.CalculateCustomerVehiclePricingResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getVehicle();
    if (f != null) writer.writeMessage(2, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.spre.CalculateCustomerVehiclePricingResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.spre.CalculateCustomerVehiclePricingResponse} returns this
 */ proto.spre.CalculateCustomerVehiclePricingResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional vehicle.Vehicle vehicle = 2;
 * @return {?proto.vehicle.Vehicle}
 */ proto.spre.CalculateCustomerVehiclePricingResponse.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 2);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.spre.CalculateCustomerVehiclePricingResponse} returns this
*/ proto.spre.CalculateCustomerVehiclePricingResponse.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.spre.CalculateCustomerVehiclePricingResponse} returns this
 */ proto.spre.CalculateCustomerVehiclePricingResponse.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.spre.CalculateCustomerVehiclePricingResponse.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.ListProgramPricingOptionsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.ListProgramPricingOptionsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.ListProgramPricingOptionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ListProgramPricingOptionsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            programId: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.ListProgramPricingOptionsRequest}
 */ proto.spre.ListProgramPricingOptionsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.ListProgramPricingOptionsRequest;
    return proto.spre.ListProgramPricingOptionsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.ListProgramPricingOptionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.ListProgramPricingOptionsRequest}
 */ proto.spre.ListProgramPricingOptionsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProgramId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.ListProgramPricingOptionsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.ListProgramPricingOptionsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.ListProgramPricingOptionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ListProgramPricingOptionsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProgramId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string program_id = 1;
 * @return {string}
 */ proto.spre.ListProgramPricingOptionsRequest.prototype.getProgramId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.spre.ListProgramPricingOptionsRequest} returns this
 */ proto.spre.ListProgramPricingOptionsRequest.prototype.setProgramId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.spre.ListProgramPricingOptionsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.spre.ListProgramPricingOptionsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.spre.ListProgramPricingOptionsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spre.ListProgramPricingOptionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ListProgramPricingOptionsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            pricingOptionsList: $8M67s.Message.toObjectList(msg.getPricingOptionsList(), $hOsJC.PricingOption.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spre.ListProgramPricingOptionsResponse}
 */ proto.spre.ListProgramPricingOptionsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.spre.ListProgramPricingOptionsResponse;
    return proto.spre.ListProgramPricingOptionsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spre.ListProgramPricingOptionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spre.ListProgramPricingOptionsResponse}
 */ proto.spre.ListProgramPricingOptionsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $hOsJC.PricingOption;
                reader.readMessage(value, $hOsJC.PricingOption.deserializeBinaryFromReader);
                msg.addPricingOptions(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.spre.ListProgramPricingOptionsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.spre.ListProgramPricingOptionsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spre.ListProgramPricingOptionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.spre.ListProgramPricingOptionsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPricingOptionsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $hOsJC.PricingOption.serializeBinaryToWriter);
};
/**
 * repeated subscription.PricingOption pricing_options = 1;
 * @return {!Array<!proto.subscription.PricingOption>}
 */ proto.spre.ListProgramPricingOptionsResponse.prototype.getPricingOptionsList = function() {
    return /** @type{!Array<!proto.subscription.PricingOption>} */ $8M67s.Message.getRepeatedWrapperField(this, $hOsJC.PricingOption, 1);
};
/**
 * @param {!Array<!proto.subscription.PricingOption>} value
 * @return {!proto.spre.ListProgramPricingOptionsResponse} returns this
*/ proto.spre.ListProgramPricingOptionsResponse.prototype.setPricingOptionsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.subscription.PricingOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.subscription.PricingOption}
 */ proto.spre.ListProgramPricingOptionsResponse.prototype.addPricingOptions = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.subscription.PricingOption, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.spre.ListProgramPricingOptionsResponse} returns this
 */ proto.spre.ListProgramPricingOptionsResponse.prototype.clearPricingOptionsList = function() {
    return this.setPricingOptionsList([]);
};
$9432b4eba6c55581$var$goog.object.extend(module.exports, proto.spre);

});

parcelRegister("2Yrcc", function(module, exports) {
// source: vehicle_listing_service.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */ // GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */ // @ts-nocheck

var $8M67s = parcelRequire("8M67s");
var $22a647dbcf55e4ac$var$goog = $8M67s;
var $22a647dbcf55e4ac$var$global = Function('return this')();

var $9YICB = parcelRequire("9YICB");
$22a647dbcf55e4ac$var$goog.object.extend(proto, $9YICB);

var $3QqPt = parcelRequire("3QqPt");
$22a647dbcf55e4ac$var$goog.object.extend(proto, $3QqPt);

var $gjhG2 = parcelRequire("gjhG2");
$22a647dbcf55e4ac$var$goog.object.extend(proto, $gjhG2);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ConfirmVehicleRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ConfirmVehicleResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.DealershipCriteria', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.GetAvailableModelsRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.GetAvailableModelsResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.GetAvailableTrimsRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.GetAvailableTrimsResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.GetDealershipRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.GetDealershipResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.GetVehicleInspectionResultsRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.GetVehicleRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ListDealershipsRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ListDealershipsResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ListOrdersRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ListOrdersResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ListProfilesRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ListProfilesResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ListVehiclesRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.ListVehiclesResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.OrderStatus', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.StartVehicleInspectionRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.StartVehicleInspectionResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.UpdateVehicleRequest', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.UpdateVehicleResponse', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.VehicleCriteria', null, $22a647dbcf55e4ac$var$global);
$22a647dbcf55e4ac$var$goog.exportSymbol('proto.vehicle_listing_service.VehicleOrder', null, $22a647dbcf55e4ac$var$global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ListOrdersRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ListOrdersRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ListOrdersRequest.displayName = 'proto.vehicle_listing_service.ListOrdersRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ListOrdersResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.ListOrdersResponse.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ListOrdersResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ListOrdersResponse.displayName = 'proto.vehicle_listing_service.ListOrdersResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.VehicleOrder = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.VehicleOrder, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.VehicleOrder.displayName = 'proto.vehicle_listing_service.VehicleOrder';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ConfirmVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ConfirmVehicleRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ConfirmVehicleRequest.displayName = 'proto.vehicle_listing_service.ConfirmVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ConfirmVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ConfirmVehicleResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ConfirmVehicleResponse.displayName = 'proto.vehicle_listing_service.ConfirmVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.GetVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.GetVehicleRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.GetVehicleRequest.displayName = 'proto.vehicle_listing_service.GetVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ListProfilesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.ListProfilesRequest.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ListProfilesRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ListProfilesRequest.displayName = 'proto.vehicle_listing_service.ListProfilesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ListProfilesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.ListProfilesResponse.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ListProfilesResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ListProfilesResponse.displayName = 'proto.vehicle_listing_service.ListProfilesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ListVehiclesRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.ListVehiclesRequest.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ListVehiclesRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ListVehiclesRequest.displayName = 'proto.vehicle_listing_service.ListVehiclesRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.VehicleCriteria = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.VehicleCriteria, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.VehicleCriteria.displayName = 'proto.vehicle_listing_service.VehicleCriteria';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ListVehiclesResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.ListVehiclesResponse.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ListVehiclesResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ListVehiclesResponse.displayName = 'proto.vehicle_listing_service.ListVehiclesResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.UpdateVehicleRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.UpdateVehicleRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.UpdateVehicleRequest.displayName = 'proto.vehicle_listing_service.UpdateVehicleRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.UpdateVehicleResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.UpdateVehicleResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.UpdateVehicleResponse.displayName = 'proto.vehicle_listing_service.UpdateVehicleResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ListDealershipsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.ListDealershipsRequest.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ListDealershipsRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ListDealershipsRequest.displayName = 'proto.vehicle_listing_service.ListDealershipsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.ListDealershipsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.ListDealershipsResponse.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.ListDealershipsResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.ListDealershipsResponse.displayName = 'proto.vehicle_listing_service.ListDealershipsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.GetDealershipRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.GetDealershipRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.GetDealershipRequest.displayName = 'proto.vehicle_listing_service.GetDealershipRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.GetDealershipResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.GetDealershipResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.GetDealershipResponse.displayName = 'proto.vehicle_listing_service.GetDealershipResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.DealershipCriteria = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.DealershipCriteria, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.DealershipCriteria.displayName = 'proto.vehicle_listing_service.DealershipCriteria';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.StartVehicleInspectionRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.StartVehicleInspectionRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.StartVehicleInspectionRequest.displayName = 'proto.vehicle_listing_service.StartVehicleInspectionRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.StartVehicleInspectionResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.StartVehicleInspectionResponse.displayName = 'proto.vehicle_listing_service.StartVehicleInspectionResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.GetVehicleInspectionResultsRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.displayName = 'proto.vehicle_listing_service.GetVehicleInspectionResultsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.GetAvailableModelsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.GetAvailableModelsRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.GetAvailableModelsRequest.displayName = 'proto.vehicle_listing_service.GetAvailableModelsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.GetAvailableModelsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.GetAvailableModelsResponse.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.GetAvailableModelsResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.GetAvailableModelsResponse.displayName = 'proto.vehicle_listing_service.GetAvailableModelsResponse';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, null, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.GetAvailableTrimsRequest, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.GetAvailableTrimsRequest.displayName = 'proto.vehicle_listing_service.GetAvailableTrimsRequest';
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse = function(opt_data) {
    $8M67s.Message.initialize(this, opt_data, 0, -1, proto.vehicle_listing_service.GetAvailableTrimsResponse.repeatedFields_, null);
};
$22a647dbcf55e4ac$var$goog.inherits(proto.vehicle_listing_service.GetAvailableTrimsResponse, $8M67s.Message);
if ($22a647dbcf55e4ac$var$goog.DEBUG && !COMPILED) /**
   * @public
   * @override
   */ proto.vehicle_listing_service.GetAvailableTrimsResponse.displayName = 'proto.vehicle_listing_service.GetAvailableTrimsResponse';
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ListOrdersRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ListOrdersRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListOrdersRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            startDate: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            endDate: $8M67s.Message.getFieldWithDefault(msg, 2, ""),
            pageNumber: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            pageSize: $8M67s.Message.getFieldWithDefault(msg, 4, 0),
            orderStatus: $8M67s.Message.getFieldWithDefault(msg, 5, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ListOrdersRequest}
 */ proto.vehicle_listing_service.ListOrdersRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ListOrdersRequest;
    return proto.vehicle_listing_service.ListOrdersRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ListOrdersRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ListOrdersRequest}
 */ proto.vehicle_listing_service.ListOrdersRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setStartDate(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setEndDate(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPageNumber(value);
                break;
            case 4:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPageSize(value);
                break;
            case 5:
                var value = /** @type {!proto.vehicle_listing_service.OrderStatus} */ reader.readEnum();
                msg.setOrderStatus(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ListOrdersRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ListOrdersRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListOrdersRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getStartDate();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getEndDate();
    if (f.length > 0) writer.writeString(2, f);
    f = message.getPageNumber();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getPageSize();
    if (f !== 0) writer.writeInt32(4, f);
    f = message.getOrderStatus();
    if (f !== 0.0) writer.writeEnum(5, f);
};
/**
 * optional string start_date = 1;
 * @return {string}
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.getStartDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.ListOrdersRequest} returns this
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.setStartDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string end_date = 2;
 * @return {string}
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.getEndDate = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.ListOrdersRequest} returns this
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.setEndDate = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * optional int32 page_number = 3;
 * @return {number}
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.getPageNumber = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListOrdersRequest} returns this
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.setPageNumber = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional int32 page_size = 4;
 * @return {number}
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.getPageSize = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 4, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListOrdersRequest} returns this
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.setPageSize = function(value) {
    return $8M67s.Message.setProto3IntField(this, 4, value);
};
/**
 * optional OrderStatus order_status = 5;
 * @return {!proto.vehicle_listing_service.OrderStatus}
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.getOrderStatus = function() {
    return /** @type {!proto.vehicle_listing_service.OrderStatus} */ $8M67s.Message.getFieldWithDefault(this, 5, 0);
};
/**
 * @param {!proto.vehicle_listing_service.OrderStatus} value
 * @return {!proto.vehicle_listing_service.ListOrdersRequest} returns this
 */ proto.vehicle_listing_service.ListOrdersRequest.prototype.setOrderStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 5, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.ListOrdersResponse.repeatedFields_ = [
    2
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ListOrdersResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ListOrdersResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ListOrdersResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListOrdersResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            totalOrders: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            vehicleOrdersList: $8M67s.Message.toObjectList(msg.getVehicleOrdersList(), proto.vehicle_listing_service.VehicleOrder.toObject, includeInstance)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ListOrdersResponse}
 */ proto.vehicle_listing_service.ListOrdersResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ListOrdersResponse;
    return proto.vehicle_listing_service.ListOrdersResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ListOrdersResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ListOrdersResponse}
 */ proto.vehicle_listing_service.ListOrdersResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotalOrders(value);
                break;
            case 2:
                var value = new proto.vehicle_listing_service.VehicleOrder;
                reader.readMessage(value, proto.vehicle_listing_service.VehicleOrder.deserializeBinaryFromReader);
                msg.addVehicleOrders(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ListOrdersResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ListOrdersResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ListOrdersResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListOrdersResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTotalOrders();
    if (f !== 0) writer.writeInt32(1, f);
    f = message.getVehicleOrdersList();
    if (f.length > 0) writer.writeRepeatedMessage(2, f, proto.vehicle_listing_service.VehicleOrder.serializeBinaryToWriter);
};
/**
 * optional int32 total_orders = 1;
 * @return {number}
 */ proto.vehicle_listing_service.ListOrdersResponse.prototype.getTotalOrders = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListOrdersResponse} returns this
 */ proto.vehicle_listing_service.ListOrdersResponse.prototype.setTotalOrders = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * repeated VehicleOrder vehicle_orders = 2;
 * @return {!Array<!proto.vehicle_listing_service.VehicleOrder>}
 */ proto.vehicle_listing_service.ListOrdersResponse.prototype.getVehicleOrdersList = function() {
    return /** @type{!Array<!proto.vehicle_listing_service.VehicleOrder>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle_listing_service.VehicleOrder, 2);
};
/**
 * @param {!Array<!proto.vehicle_listing_service.VehicleOrder>} value
 * @return {!proto.vehicle_listing_service.ListOrdersResponse} returns this
*/ proto.vehicle_listing_service.ListOrdersResponse.prototype.setVehicleOrdersList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 2, value);
};
/**
 * @param {!proto.vehicle_listing_service.VehicleOrder=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle_listing_service.VehicleOrder}
 */ proto.vehicle_listing_service.ListOrdersResponse.prototype.addVehicleOrders = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.vehicle_listing_service.VehicleOrder, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.ListOrdersResponse} returns this
 */ proto.vehicle_listing_service.ListOrdersResponse.prototype.clearVehicleOrdersList = function() {
    return this.setVehicleOrdersList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.VehicleOrder.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.VehicleOrder} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.VehicleOrder.toObject = function(includeInstance, msg) {
        var f, obj = {
            pickupDate: $8M67s.Message.getFieldWithDefault(msg, 1, 0),
            depositPaidDate: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            subscriptionStatus: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            dealerId: $8M67s.Message.getFieldWithDefault(msg, 4, ""),
            dealerName: $8M67s.Message.getFieldWithDefault(msg, 5, ""),
            customerName: $8M67s.Message.getFieldWithDefault(msg, 6, ""),
            customerAccountNumber: $8M67s.Message.getFieldWithDefault(msg, 7, ""),
            subscriptionId: $8M67s.Message.getFieldWithDefault(msg, 8, ""),
            vehicleModelAndTrim: $8M67s.Message.getFieldWithDefault(msg, 9, ""),
            vehicleMiles: $8M67s.Message.getFieldWithDefault(msg, 10, ""),
            vehicleColor: $8M67s.Message.getFieldWithDefault(msg, 11, ""),
            dateListed: $8M67s.Message.getFieldWithDefault(msg, 12, 0),
            vehicleVin: $8M67s.Message.getFieldWithDefault(msg, 13, ""),
            securityDeposit: $8M67s.Message.getFieldWithDefault(msg, 14, 0),
            startPayment: $8M67s.Message.getFieldWithDefault(msg, 15, 0),
            monthlyPayment: $8M67s.Message.getFieldWithDefault(msg, 16, 0),
            reservationDeposit: $8M67s.Message.getFieldWithDefault(msg, 17, 0),
            orderStatus: $8M67s.Message.getFieldWithDefault(msg, 18, 0),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 19, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.VehicleOrder}
 */ proto.vehicle_listing_service.VehicleOrder.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.VehicleOrder;
    return proto.vehicle_listing_service.VehicleOrder.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.VehicleOrder} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.VehicleOrder}
 */ proto.vehicle_listing_service.VehicleOrder.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {number} */ reader.readInt64();
                msg.setPickupDate(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDepositPaidDate(value);
                break;
            case 3:
                var value = /** @type {!proto.domain.Subscription.Status} */ reader.readEnum();
                msg.setSubscriptionStatus(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerId(value);
                break;
            case 5:
                var value = /** @type {string} */ reader.readString();
                msg.setDealerName(value);
                break;
            case 6:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerName(value);
                break;
            case 7:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerAccountNumber(value);
                break;
            case 8:
                var value = /** @type {string} */ reader.readString();
                msg.setSubscriptionId(value);
                break;
            case 9:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleModelAndTrim(value);
                break;
            case 10:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleMiles(value);
                break;
            case 11:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleColor(value);
                break;
            case 12:
                var value = /** @type {number} */ reader.readInt64();
                msg.setDateListed(value);
                break;
            case 13:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleVin(value);
                break;
            case 14:
                var value = /** @type {number} */ reader.readInt32();
                msg.setSecurityDeposit(value);
                break;
            case 15:
                var value = /** @type {number} */ reader.readInt32();
                msg.setStartPayment(value);
                break;
            case 16:
                var value = /** @type {number} */ reader.readInt32();
                msg.setMonthlyPayment(value);
                break;
            case 17:
                var value = /** @type {number} */ reader.readInt32();
                msg.setReservationDeposit(value);
                break;
            case 18:
                var value = /** @type {!proto.vehicle_listing_service.OrderStatus} */ reader.readEnum();
                msg.setOrderStatus(value);
                break;
            case 19:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.VehicleOrder.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.VehicleOrder} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.VehicleOrder.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getPickupDate();
    if (f !== 0) writer.writeInt64(1, f);
    f = message.getDepositPaidDate();
    if (f !== 0) writer.writeInt64(2, f);
    f = message.getSubscriptionStatus();
    if (f !== 0.0) writer.writeEnum(3, f);
    f = message.getDealerId();
    if (f.length > 0) writer.writeString(4, f);
    f = message.getDealerName();
    if (f.length > 0) writer.writeString(5, f);
    f = message.getCustomerName();
    if (f.length > 0) writer.writeString(6, f);
    f = message.getCustomerAccountNumber();
    if (f.length > 0) writer.writeString(7, f);
    f = message.getSubscriptionId();
    if (f.length > 0) writer.writeString(8, f);
    f = message.getVehicleModelAndTrim();
    if (f.length > 0) writer.writeString(9, f);
    f = message.getVehicleMiles();
    if (f.length > 0) writer.writeString(10, f);
    f = message.getVehicleColor();
    if (f.length > 0) writer.writeString(11, f);
    f = message.getDateListed();
    if (f !== 0) writer.writeInt64(12, f);
    f = message.getVehicleVin();
    if (f.length > 0) writer.writeString(13, f);
    f = message.getSecurityDeposit();
    if (f !== 0) writer.writeInt32(14, f);
    f = message.getStartPayment();
    if (f !== 0) writer.writeInt32(15, f);
    f = message.getMonthlyPayment();
    if (f !== 0) writer.writeInt32(16, f);
    f = message.getReservationDeposit();
    if (f !== 0) writer.writeInt32(17, f);
    f = message.getOrderStatus();
    if (f !== 0.0) writer.writeEnum(18, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(19, f);
};
/**
 * optional int64 pickup_date = 1;
 * @return {number}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getPickupDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 1, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setPickupDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 1, value);
};
/**
 * optional int64 deposit_paid_date = 2;
 * @return {number}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getDepositPaidDate = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setDepositPaidDate = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional domain.Subscription.Status subscription_status = 3;
 * @return {!proto.domain.Subscription.Status}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getSubscriptionStatus = function() {
    return /** @type {!proto.domain.Subscription.Status} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {!proto.domain.Subscription.Status} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setSubscriptionStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 3, value);
};
/**
 * optional string dealer_id = 4;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getDealerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setDealerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
/**
 * optional string dealer_name = 5;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getDealerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 5, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setDealerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 5, value);
};
/**
 * optional string customer_name = 6;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getCustomerName = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 6, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setCustomerName = function(value) {
    return $8M67s.Message.setProto3StringField(this, 6, value);
};
/**
 * optional string customer_account_number = 7;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getCustomerAccountNumber = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 7, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setCustomerAccountNumber = function(value) {
    return $8M67s.Message.setProto3StringField(this, 7, value);
};
/**
 * optional string subscription_id = 8;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getSubscriptionId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 8, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setSubscriptionId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 8, value);
};
/**
 * optional string vehicle_model_and_trim = 9;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getVehicleModelAndTrim = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 9, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setVehicleModelAndTrim = function(value) {
    return $8M67s.Message.setProto3StringField(this, 9, value);
};
/**
 * optional string vehicle_miles = 10;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getVehicleMiles = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 10, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setVehicleMiles = function(value) {
    return $8M67s.Message.setProto3StringField(this, 10, value);
};
/**
 * optional string vehicle_color = 11;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getVehicleColor = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 11, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setVehicleColor = function(value) {
    return $8M67s.Message.setProto3StringField(this, 11, value);
};
/**
 * optional int64 date_listed = 12;
 * @return {number}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getDateListed = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 12, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setDateListed = function(value) {
    return $8M67s.Message.setProto3IntField(this, 12, value);
};
/**
 * optional string vehicle_vin = 13;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getVehicleVin = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 13, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setVehicleVin = function(value) {
    return $8M67s.Message.setProto3StringField(this, 13, value);
};
/**
 * optional int32 security_deposit = 14;
 * @return {number}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getSecurityDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 14, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setSecurityDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 14, value);
};
/**
 * optional int32 start_payment = 15;
 * @return {number}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getStartPayment = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 15, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setStartPayment = function(value) {
    return $8M67s.Message.setProto3IntField(this, 15, value);
};
/**
 * optional int32 monthly_payment = 16;
 * @return {number}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getMonthlyPayment = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 16, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setMonthlyPayment = function(value) {
    return $8M67s.Message.setProto3IntField(this, 16, value);
};
/**
 * optional int32 reservation_deposit = 17;
 * @return {number}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getReservationDeposit = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 17, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setReservationDeposit = function(value) {
    return $8M67s.Message.setProto3IntField(this, 17, value);
};
/**
 * optional OrderStatus order_status = 18;
 * @return {!proto.vehicle_listing_service.OrderStatus}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getOrderStatus = function() {
    return /** @type {!proto.vehicle_listing_service.OrderStatus} */ $8M67s.Message.getFieldWithDefault(this, 18, 0);
};
/**
 * @param {!proto.vehicle_listing_service.OrderStatus} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setOrderStatus = function(value) {
    return $8M67s.Message.setProto3EnumField(this, 18, value);
};
/**
 * optional string customer_id = 19;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleOrder.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 19, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleOrder} returns this
 */ proto.vehicle_listing_service.VehicleOrder.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 19, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ConfirmVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ConfirmVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            customerId: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            vehicleId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ConfirmVehicleRequest}
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ConfirmVehicleRequest;
    return proto.vehicle_listing_service.ConfirmVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ConfirmVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ConfirmVehicleRequest}
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setVehicleId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ConfirmVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ConfirmVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getVehicleId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string customer_id = 1;
 * @return {string}
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.ConfirmVehicleRequest} returns this
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string vehicle_id = 2;
 * @return {string}
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.prototype.getVehicleId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.ConfirmVehicleRequest} returns this
 */ proto.vehicle_listing_service.ConfirmVehicleRequest.prototype.setVehicleId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ConfirmVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ConfirmVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ConfirmVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ConfirmVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ConfirmVehicleResponse}
 */ proto.vehicle_listing_service.ConfirmVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ConfirmVehicleResponse;
    return proto.vehicle_listing_service.ConfirmVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ConfirmVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ConfirmVehicleResponse}
 */ proto.vehicle_listing_service.ConfirmVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ConfirmVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ConfirmVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ConfirmVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ConfirmVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.vehicle_listing_service.ConfirmVehicleResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle_listing_service.ConfirmVehicleResponse} returns this
 */ proto.vehicle_listing_service.ConfirmVehicleResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.GetVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.GetVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.GetVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.GetVehicleRequest}
 */ proto.vehicle_listing_service.GetVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.GetVehicleRequest;
    return proto.vehicle_listing_service.GetVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.GetVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.GetVehicleRequest}
 */ proto.vehicle_listing_service.GetVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.GetVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.GetVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.GetVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle_listing_service.GetVehicleRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.GetVehicleRequest} returns this
 */ proto.vehicle_listing_service.GetVehicleRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string customer_id = 2;
 * @return {string}
 */ proto.vehicle_listing_service.GetVehicleRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.GetVehicleRequest} returns this
 */ proto.vehicle_listing_service.GetVehicleRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.ListProfilesRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ListProfilesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ListProfilesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListProfilesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            criteriaList: $8M67s.Message.toObjectList(msg.getCriteriaList(), proto.vehicle_listing_service.VehicleCriteria.toObject, includeInstance),
            page: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            resultsPerPage: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ListProfilesRequest}
 */ proto.vehicle_listing_service.ListProfilesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ListProfilesRequest;
    return proto.vehicle_listing_service.ListProfilesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ListProfilesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ListProfilesRequest}
 */ proto.vehicle_listing_service.ListProfilesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.vehicle_listing_service.VehicleCriteria;
                reader.readMessage(value, proto.vehicle_listing_service.VehicleCriteria.deserializeBinaryFromReader);
                msg.addCriteria(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPage(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setResultsPerPage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ListProfilesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ListProfilesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListProfilesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCriteriaList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.vehicle_listing_service.VehicleCriteria.serializeBinaryToWriter);
    f = message.getPage();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getResultsPerPage();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * repeated VehicleCriteria criteria = 1;
 * @return {!Array<!proto.vehicle_listing_service.VehicleCriteria>}
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.getCriteriaList = function() {
    return /** @type{!Array<!proto.vehicle_listing_service.VehicleCriteria>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle_listing_service.VehicleCriteria, 1);
};
/**
 * @param {!Array<!proto.vehicle_listing_service.VehicleCriteria>} value
 * @return {!proto.vehicle_listing_service.ListProfilesRequest} returns this
*/ proto.vehicle_listing_service.ListProfilesRequest.prototype.setCriteriaList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.vehicle_listing_service.VehicleCriteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle_listing_service.VehicleCriteria}
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.addCriteria = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vehicle_listing_service.VehicleCriteria, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.ListProfilesRequest} returns this
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.clearCriteriaList = function() {
    return this.setCriteriaList([]);
};
/**
 * optional int32 page = 2;
 * @return {number}
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.getPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListProfilesRequest} returns this
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.setPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 results_per_page = 3;
 * @return {number}
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.getResultsPerPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListProfilesRequest} returns this
 */ proto.vehicle_listing_service.ListProfilesRequest.prototype.setResultsPerPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.ListProfilesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ListProfilesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ListProfilesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListProfilesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            profilesList: $8M67s.Message.toObjectList(msg.getProfilesList(), $9YICB.Profile.toObject, includeInstance),
            page: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            total: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ListProfilesResponse}
 */ proto.vehicle_listing_service.ListProfilesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ListProfilesResponse;
    return proto.vehicle_listing_service.ListProfilesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ListProfilesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ListProfilesResponse}
 */ proto.vehicle_listing_service.ListProfilesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Profile;
                reader.readMessage(value, $9YICB.Profile.deserializeBinaryFromReader);
                msg.addProfiles(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPage(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ListProfilesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ListProfilesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListProfilesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProfilesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $9YICB.Profile.serializeBinaryToWriter);
    f = message.getPage();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getTotal();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * repeated vehicle.Profile profiles = 1;
 * @return {!Array<!proto.vehicle.Profile>}
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.getProfilesList = function() {
    return /** @type{!Array<!proto.vehicle.Profile>} */ $8M67s.Message.getRepeatedWrapperField(this, $9YICB.Profile, 1);
};
/**
 * @param {!Array<!proto.vehicle.Profile>} value
 * @return {!proto.vehicle_listing_service.ListProfilesResponse} returns this
*/ proto.vehicle_listing_service.ListProfilesResponse.prototype.setProfilesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.vehicle.Profile=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Profile}
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.addProfiles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vehicle.Profile, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.ListProfilesResponse} returns this
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.clearProfilesList = function() {
    return this.setProfilesList([]);
};
/**
 * optional int32 page = 2;
 * @return {number}
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.getPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListProfilesResponse} returns this
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.setPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 total = 3;
 * @return {number}
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListProfilesResponse} returns this
 */ proto.vehicle_listing_service.ListProfilesResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.ListVehiclesRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ListVehiclesRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ListVehiclesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListVehiclesRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            criteriaList: $8M67s.Message.toObjectList(msg.getCriteriaList(), proto.vehicle_listing_service.VehicleCriteria.toObject, includeInstance),
            page: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            resultsPerPage: $8M67s.Message.getFieldWithDefault(msg, 3, 0),
            customerId: $8M67s.Message.getFieldWithDefault(msg, 4, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ListVehiclesRequest}
 */ proto.vehicle_listing_service.ListVehiclesRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ListVehiclesRequest;
    return proto.vehicle_listing_service.ListVehiclesRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ListVehiclesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ListVehiclesRequest}
 */ proto.vehicle_listing_service.ListVehiclesRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.vehicle_listing_service.VehicleCriteria;
                reader.readMessage(value, proto.vehicle_listing_service.VehicleCriteria.deserializeBinaryFromReader);
                msg.addCriteria(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPage(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setResultsPerPage(value);
                break;
            case 4:
                var value = /** @type {string} */ reader.readString();
                msg.setCustomerId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ListVehiclesRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ListVehiclesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListVehiclesRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCriteriaList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.vehicle_listing_service.VehicleCriteria.serializeBinaryToWriter);
    f = message.getPage();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getResultsPerPage();
    if (f !== 0) writer.writeInt32(3, f);
    f = message.getCustomerId();
    if (f.length > 0) writer.writeString(4, f);
};
/**
 * repeated VehicleCriteria criteria = 1;
 * @return {!Array<!proto.vehicle_listing_service.VehicleCriteria>}
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.getCriteriaList = function() {
    return /** @type{!Array<!proto.vehicle_listing_service.VehicleCriteria>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle_listing_service.VehicleCriteria, 1);
};
/**
 * @param {!Array<!proto.vehicle_listing_service.VehicleCriteria>} value
 * @return {!proto.vehicle_listing_service.ListVehiclesRequest} returns this
*/ proto.vehicle_listing_service.ListVehiclesRequest.prototype.setCriteriaList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.vehicle_listing_service.VehicleCriteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle_listing_service.VehicleCriteria}
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.addCriteria = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vehicle_listing_service.VehicleCriteria, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.ListVehiclesRequest} returns this
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.clearCriteriaList = function() {
    return this.setCriteriaList([]);
};
/**
 * optional int32 page = 2;
 * @return {number}
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.getPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListVehiclesRequest} returns this
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.setPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 results_per_page = 3;
 * @return {number}
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.getResultsPerPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListVehiclesRequest} returns this
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.setResultsPerPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * optional string customer_id = 4;
 * @return {string}
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.getCustomerId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 4, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.ListVehiclesRequest} returns this
 */ proto.vehicle_listing_service.ListVehiclesRequest.prototype.setCustomerId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 4, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.VehicleCriteria.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.VehicleCriteria.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.VehicleCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.VehicleCriteria.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            query: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.VehicleCriteria}
 */ proto.vehicle_listing_service.VehicleCriteria.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.VehicleCriteria;
    return proto.vehicle_listing_service.VehicleCriteria.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.VehicleCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.VehicleCriteria}
 */ proto.vehicle_listing_service.VehicleCriteria.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setQuery(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.VehicleCriteria.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.VehicleCriteria.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.VehicleCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.VehicleCriteria.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getQuery();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleCriteria.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleCriteria} returns this
 */ proto.vehicle_listing_service.VehicleCriteria.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string query = 2;
 * @return {string}
 */ proto.vehicle_listing_service.VehicleCriteria.prototype.getQuery = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.VehicleCriteria} returns this
 */ proto.vehicle_listing_service.VehicleCriteria.prototype.setQuery = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.ListVehiclesResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ListVehiclesResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ListVehiclesResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ListVehiclesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListVehiclesResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehiclesList: $8M67s.Message.toObjectList(msg.getVehiclesList(), $9YICB.Vehicle.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ListVehiclesResponse}
 */ proto.vehicle_listing_service.ListVehiclesResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ListVehiclesResponse;
    return proto.vehicle_listing_service.ListVehiclesResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ListVehiclesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ListVehiclesResponse}
 */ proto.vehicle_listing_service.ListVehiclesResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.addVehicles(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ListVehiclesResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ListVehiclesResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ListVehiclesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListVehiclesResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehiclesList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $9YICB.Vehicle.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * repeated vehicle.Vehicle vehicles = 1;
 * @return {!Array<!proto.vehicle.Vehicle>}
 */ proto.vehicle_listing_service.ListVehiclesResponse.prototype.getVehiclesList = function() {
    return /** @type{!Array<!proto.vehicle.Vehicle>} */ $8M67s.Message.getRepeatedWrapperField(this, $9YICB.Vehicle, 1);
};
/**
 * @param {!Array<!proto.vehicle.Vehicle>} value
 * @return {!proto.vehicle_listing_service.ListVehiclesResponse} returns this
*/ proto.vehicle_listing_service.ListVehiclesResponse.prototype.setVehiclesList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.vehicle.Vehicle=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle.Vehicle}
 */ proto.vehicle_listing_service.ListVehiclesResponse.prototype.addVehicles = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vehicle.Vehicle, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.ListVehiclesResponse} returns this
 */ proto.vehicle_listing_service.ListVehiclesResponse.prototype.clearVehiclesList = function() {
    return this.setVehiclesList([]);
};
/**
 * optional int32 total = 2;
 * @return {number}
 */ proto.vehicle_listing_service.ListVehiclesResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListVehiclesResponse} returns this
 */ proto.vehicle_listing_service.ListVehiclesResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.UpdateVehicleRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.UpdateVehicleRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.UpdateVehicleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.UpdateVehicleRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.UpdateVehicleRequest}
 */ proto.vehicle_listing_service.UpdateVehicleRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.UpdateVehicleRequest;
    return proto.vehicle_listing_service.UpdateVehicleRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.UpdateVehicleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.UpdateVehicleRequest}
 */ proto.vehicle_listing_service.UpdateVehicleRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.UpdateVehicleRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.UpdateVehicleRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.UpdateVehicleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.UpdateVehicleRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getVehicle();
    if (f != null) writer.writeMessage(1, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional vehicle.Vehicle vehicle = 1;
 * @return {?proto.vehicle.Vehicle}
 */ proto.vehicle_listing_service.UpdateVehicleRequest.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 1);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.vehicle_listing_service.UpdateVehicleRequest} returns this
*/ proto.vehicle_listing_service.UpdateVehicleRequest.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_listing_service.UpdateVehicleRequest} returns this
 */ proto.vehicle_listing_service.UpdateVehicleRequest.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle_listing_service.UpdateVehicleRequest.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.UpdateVehicleResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.UpdateVehicleResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.UpdateVehicleResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.UpdateVehicleResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            success: $8M67s.Message.getBooleanFieldWithDefault(msg, 1, false),
            vehicle: (f = msg.getVehicle()) && $9YICB.Vehicle.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.UpdateVehicleResponse}
 */ proto.vehicle_listing_service.UpdateVehicleResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.UpdateVehicleResponse;
    return proto.vehicle_listing_service.UpdateVehicleResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.UpdateVehicleResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.UpdateVehicleResponse}
 */ proto.vehicle_listing_service.UpdateVehicleResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {boolean} */ reader.readBool();
                msg.setSuccess(value);
                break;
            case 2:
                var value = new $9YICB.Vehicle;
                reader.readMessage(value, $9YICB.Vehicle.deserializeBinaryFromReader);
                msg.setVehicle(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.UpdateVehicleResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.UpdateVehicleResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.UpdateVehicleResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.UpdateVehicleResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSuccess();
    if (f) writer.writeBool(1, f);
    f = message.getVehicle();
    if (f != null) writer.writeMessage(2, f, $9YICB.Vehicle.serializeBinaryToWriter);
};
/**
 * optional bool success = 1;
 * @return {boolean}
 */ proto.vehicle_listing_service.UpdateVehicleResponse.prototype.getSuccess = function() {
    return /** @type {boolean} */ $8M67s.Message.getBooleanFieldWithDefault(this, 1, false);
};
/**
 * @param {boolean} value
 * @return {!proto.vehicle_listing_service.UpdateVehicleResponse} returns this
 */ proto.vehicle_listing_service.UpdateVehicleResponse.prototype.setSuccess = function(value) {
    return $8M67s.Message.setProto3BooleanField(this, 1, value);
};
/**
 * optional vehicle.Vehicle vehicle = 2;
 * @return {?proto.vehicle.Vehicle}
 */ proto.vehicle_listing_service.UpdateVehicleResponse.prototype.getVehicle = function() {
    return /** @type{?proto.vehicle.Vehicle} */ $8M67s.Message.getWrapperField(this, $9YICB.Vehicle, 2);
};
/**
 * @param {?proto.vehicle.Vehicle|undefined} value
 * @return {!proto.vehicle_listing_service.UpdateVehicleResponse} returns this
*/ proto.vehicle_listing_service.UpdateVehicleResponse.prototype.setVehicle = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_listing_service.UpdateVehicleResponse} returns this
 */ proto.vehicle_listing_service.UpdateVehicleResponse.prototype.clearVehicle = function() {
    return this.setVehicle(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle_listing_service.UpdateVehicleResponse.prototype.hasVehicle = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.ListDealershipsRequest.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ListDealershipsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ListDealershipsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListDealershipsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            criteriaList: $8M67s.Message.toObjectList(msg.getCriteriaList(), proto.vehicle_listing_service.DealershipCriteria.toObject, includeInstance),
            page: $8M67s.Message.getFieldWithDefault(msg, 2, 0),
            resultsPerPage: $8M67s.Message.getFieldWithDefault(msg, 3, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ListDealershipsRequest}
 */ proto.vehicle_listing_service.ListDealershipsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ListDealershipsRequest;
    return proto.vehicle_listing_service.ListDealershipsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ListDealershipsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ListDealershipsRequest}
 */ proto.vehicle_listing_service.ListDealershipsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new proto.vehicle_listing_service.DealershipCriteria;
                reader.readMessage(value, proto.vehicle_listing_service.DealershipCriteria.deserializeBinaryFromReader);
                msg.addCriteria(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setPage(value);
                break;
            case 3:
                var value = /** @type {number} */ reader.readInt32();
                msg.setResultsPerPage(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ListDealershipsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ListDealershipsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListDealershipsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getCriteriaList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, proto.vehicle_listing_service.DealershipCriteria.serializeBinaryToWriter);
    f = message.getPage();
    if (f !== 0) writer.writeInt32(2, f);
    f = message.getResultsPerPage();
    if (f !== 0) writer.writeInt32(3, f);
};
/**
 * repeated DealershipCriteria criteria = 1;
 * @return {!Array<!proto.vehicle_listing_service.DealershipCriteria>}
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.getCriteriaList = function() {
    return /** @type{!Array<!proto.vehicle_listing_service.DealershipCriteria>} */ $8M67s.Message.getRepeatedWrapperField(this, proto.vehicle_listing_service.DealershipCriteria, 1);
};
/**
 * @param {!Array<!proto.vehicle_listing_service.DealershipCriteria>} value
 * @return {!proto.vehicle_listing_service.ListDealershipsRequest} returns this
*/ proto.vehicle_listing_service.ListDealershipsRequest.prototype.setCriteriaList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.vehicle_listing_service.DealershipCriteria=} opt_value
 * @param {number=} opt_index
 * @return {!proto.vehicle_listing_service.DealershipCriteria}
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.addCriteria = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.vehicle_listing_service.DealershipCriteria, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.ListDealershipsRequest} returns this
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.clearCriteriaList = function() {
    return this.setCriteriaList([]);
};
/**
 * optional int32 page = 2;
 * @return {number}
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.getPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListDealershipsRequest} returns this
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.setPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
/**
 * optional int32 results_per_page = 3;
 * @return {number}
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.getResultsPerPage = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 3, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListDealershipsRequest} returns this
 */ proto.vehicle_listing_service.ListDealershipsRequest.prototype.setResultsPerPage = function(value) {
    return $8M67s.Message.setProto3IntField(this, 3, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.ListDealershipsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.ListDealershipsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.ListDealershipsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.ListDealershipsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListDealershipsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealershipsList: $8M67s.Message.toObjectList(msg.getDealershipsList(), $3QqPt.Dealership.toObject, includeInstance),
            total: $8M67s.Message.getFieldWithDefault(msg, 2, 0)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.ListDealershipsResponse}
 */ proto.vehicle_listing_service.ListDealershipsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.ListDealershipsResponse;
    return proto.vehicle_listing_service.ListDealershipsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.ListDealershipsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.ListDealershipsResponse}
 */ proto.vehicle_listing_service.ListDealershipsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Dealership;
                reader.readMessage(value, $3QqPt.Dealership.deserializeBinaryFromReader);
                msg.addDealerships(value);
                break;
            case 2:
                var value = /** @type {number} */ reader.readInt32();
                msg.setTotal(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.ListDealershipsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.ListDealershipsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.ListDealershipsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.ListDealershipsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealershipsList();
    if (f.length > 0) writer.writeRepeatedMessage(1, f, $3QqPt.Dealership.serializeBinaryToWriter);
    f = message.getTotal();
    if (f !== 0) writer.writeInt32(2, f);
};
/**
 * repeated domain.Dealership dealerships = 1;
 * @return {!Array<!proto.domain.Dealership>}
 */ proto.vehicle_listing_service.ListDealershipsResponse.prototype.getDealershipsList = function() {
    return /** @type{!Array<!proto.domain.Dealership>} */ $8M67s.Message.getRepeatedWrapperField(this, $3QqPt.Dealership, 1);
};
/**
 * @param {!Array<!proto.domain.Dealership>} value
 * @return {!proto.vehicle_listing_service.ListDealershipsResponse} returns this
*/ proto.vehicle_listing_service.ListDealershipsResponse.prototype.setDealershipsList = function(value) {
    return $8M67s.Message.setRepeatedWrapperField(this, 1, value);
};
/**
 * @param {!proto.domain.Dealership=} opt_value
 * @param {number=} opt_index
 * @return {!proto.domain.Dealership}
 */ proto.vehicle_listing_service.ListDealershipsResponse.prototype.addDealerships = function(opt_value, opt_index) {
    return $8M67s.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.domain.Dealership, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.ListDealershipsResponse} returns this
 */ proto.vehicle_listing_service.ListDealershipsResponse.prototype.clearDealershipsList = function() {
    return this.setDealershipsList([]);
};
/**
 * optional int32 total = 2;
 * @return {number}
 */ proto.vehicle_listing_service.ListDealershipsResponse.prototype.getTotal = function() {
    return /** @type {number} */ $8M67s.Message.getFieldWithDefault(this, 2, 0);
};
/**
 * @param {number} value
 * @return {!proto.vehicle_listing_service.ListDealershipsResponse} returns this
 */ proto.vehicle_listing_service.ListDealershipsResponse.prototype.setTotal = function(value) {
    return $8M67s.Message.setProto3IntField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.GetDealershipRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.GetDealershipRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.GetDealershipRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetDealershipRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            id: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.GetDealershipRequest}
 */ proto.vehicle_listing_service.GetDealershipRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.GetDealershipRequest;
    return proto.vehicle_listing_service.GetDealershipRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.GetDealershipRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.GetDealershipRequest}
 */ proto.vehicle_listing_service.GetDealershipRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setId(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.GetDealershipRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.GetDealershipRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.GetDealershipRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetDealershipRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getId();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string id = 1;
 * @return {string}
 */ proto.vehicle_listing_service.GetDealershipRequest.prototype.getId = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.GetDealershipRequest} returns this
 */ proto.vehicle_listing_service.GetDealershipRequest.prototype.setId = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.GetDealershipResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.GetDealershipResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.GetDealershipResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetDealershipResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            dealership: (f = msg.getDealership()) && $3QqPt.Dealership.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.GetDealershipResponse}
 */ proto.vehicle_listing_service.GetDealershipResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.GetDealershipResponse;
    return proto.vehicle_listing_service.GetDealershipResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.GetDealershipResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.GetDealershipResponse}
 */ proto.vehicle_listing_service.GetDealershipResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = new $3QqPt.Dealership;
                reader.readMessage(value, $3QqPt.Dealership.deserializeBinaryFromReader);
                msg.setDealership(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.GetDealershipResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.GetDealershipResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.GetDealershipResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetDealershipResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getDealership();
    if (f != null) writer.writeMessage(1, f, $3QqPt.Dealership.serializeBinaryToWriter);
};
/**
 * optional domain.Dealership dealership = 1;
 * @return {?proto.domain.Dealership}
 */ proto.vehicle_listing_service.GetDealershipResponse.prototype.getDealership = function() {
    return /** @type{?proto.domain.Dealership} */ $8M67s.Message.getWrapperField(this, $3QqPt.Dealership, 1);
};
/**
 * @param {?proto.domain.Dealership|undefined} value
 * @return {!proto.vehicle_listing_service.GetDealershipResponse} returns this
*/ proto.vehicle_listing_service.GetDealershipResponse.prototype.setDealership = function(value) {
    return $8M67s.Message.setWrapperField(this, 1, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_listing_service.GetDealershipResponse} returns this
 */ proto.vehicle_listing_service.GetDealershipResponse.prototype.clearDealership = function() {
    return this.setDealership(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle_listing_service.GetDealershipResponse.prototype.hasDealership = function() {
    return $8M67s.Message.getField(this, 1) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.DealershipCriteria.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.DealershipCriteria.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.DealershipCriteria} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.DealershipCriteria.toObject = function(includeInstance, msg) {
        var f, obj = {
            property: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            query: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.DealershipCriteria}
 */ proto.vehicle_listing_service.DealershipCriteria.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.DealershipCriteria;
    return proto.vehicle_listing_service.DealershipCriteria.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.DealershipCriteria} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.DealershipCriteria}
 */ proto.vehicle_listing_service.DealershipCriteria.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setProperty(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setQuery(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.DealershipCriteria.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.DealershipCriteria.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.DealershipCriteria} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.DealershipCriteria.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getProperty();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getQuery();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string property = 1;
 * @return {string}
 */ proto.vehicle_listing_service.DealershipCriteria.prototype.getProperty = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.DealershipCriteria} returns this
 */ proto.vehicle_listing_service.DealershipCriteria.prototype.setProperty = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string query = 2;
 * @return {string}
 */ proto.vehicle_listing_service.DealershipCriteria.prototype.getQuery = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.DealershipCriteria} returns this
 */ proto.vehicle_listing_service.DealershipCriteria.prototype.setQuery = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.StartVehicleInspectionRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.StartVehicleInspectionRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.StartVehicleInspectionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.StartVehicleInspectionRequest.toObject = function(includeInstance, msg) {
        var f, obj = {};
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.StartVehicleInspectionRequest}
 */ proto.vehicle_listing_service.StartVehicleInspectionRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.StartVehicleInspectionRequest;
    return proto.vehicle_listing_service.StartVehicleInspectionRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.StartVehicleInspectionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.StartVehicleInspectionRequest}
 */ proto.vehicle_listing_service.StartVehicleInspectionRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        field;
        reader.skipField();
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.StartVehicleInspectionRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.StartVehicleInspectionRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.StartVehicleInspectionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.StartVehicleInspectionRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.StartVehicleInspectionResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.StartVehicleInspectionResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            sessionKey: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.StartVehicleInspectionResponse}
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.StartVehicleInspectionResponse;
    return proto.vehicle_listing_service.StartVehicleInspectionResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.StartVehicleInspectionResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.StartVehicleInspectionResponse}
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setSessionKey(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.StartVehicleInspectionResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.StartVehicleInspectionResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getSessionKey();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string session_key = 1;
 * @return {string}
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse.prototype.getSessionKey = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.StartVehicleInspectionResponse} returns this
 */ proto.vehicle_listing_service.StartVehicleInspectionResponse.prototype.setSessionKey = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.GetVehicleInspectionResultsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            jwt: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            request: (f = msg.getRequest()) && $gjhG2.GetInspectionResultsRequest.toObject(includeInstance, f)
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.GetVehicleInspectionResultsRequest}
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.GetVehicleInspectionResultsRequest;
    return proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.GetVehicleInspectionResultsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.GetVehicleInspectionResultsRequest}
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setJwt(value);
                break;
            case 2:
                var value = new $gjhG2.GetInspectionResultsRequest;
                reader.readMessage(value, $gjhG2.GetInspectionResultsRequest.deserializeBinaryFromReader);
                msg.setRequest(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.GetVehicleInspectionResultsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getJwt();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getRequest();
    if (f != null) writer.writeMessage(2, f, $gjhG2.GetInspectionResultsRequest.serializeBinaryToWriter);
};
/**
 * optional string jwt = 1;
 * @return {string}
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.prototype.getJwt = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.GetVehicleInspectionResultsRequest} returns this
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.prototype.setJwt = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional inspection.GetInspectionResultsRequest request = 2;
 * @return {?proto.inspection.GetInspectionResultsRequest}
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.prototype.getRequest = function() {
    return /** @type{?proto.inspection.GetInspectionResultsRequest} */ $8M67s.Message.getWrapperField(this, $gjhG2.GetInspectionResultsRequest, 2);
};
/**
 * @param {?proto.inspection.GetInspectionResultsRequest|undefined} value
 * @return {!proto.vehicle_listing_service.GetVehicleInspectionResultsRequest} returns this
*/ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.prototype.setRequest = function(value) {
    return $8M67s.Message.setWrapperField(this, 2, value);
};
/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_listing_service.GetVehicleInspectionResultsRequest} returns this
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.prototype.clearRequest = function() {
    return this.setRequest(undefined);
};
/**
 * Returns whether this field is set.
 * @return {boolean}
 */ proto.vehicle_listing_service.GetVehicleInspectionResultsRequest.prototype.hasRequest = function() {
    return $8M67s.Message.getField(this, 2) != null;
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.GetAvailableModelsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.GetAvailableModelsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.GetAvailableModelsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetAvailableModelsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            make: $8M67s.Message.getFieldWithDefault(msg, 1, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.GetAvailableModelsRequest}
 */ proto.vehicle_listing_service.GetAvailableModelsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.GetAvailableModelsRequest;
    return proto.vehicle_listing_service.GetAvailableModelsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.GetAvailableModelsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.GetAvailableModelsRequest}
 */ proto.vehicle_listing_service.GetAvailableModelsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.GetAvailableModelsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.GetAvailableModelsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.GetAvailableModelsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetAvailableModelsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMake();
    if (f.length > 0) writer.writeString(1, f);
};
/**
 * optional string make = 1;
 * @return {string}
 */ proto.vehicle_listing_service.GetAvailableModelsRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.GetAvailableModelsRequest} returns this
 */ proto.vehicle_listing_service.GetAvailableModelsRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.GetAvailableModelsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.GetAvailableModelsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            modelsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.GetAvailableModelsResponse}
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.GetAvailableModelsResponse;
    return proto.vehicle_listing_service.GetAvailableModelsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.GetAvailableModelsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.GetAvailableModelsResponse}
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addModels(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.GetAvailableModelsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.GetAvailableModelsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getModelsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string models = 1;
 * @return {!Array<string>}
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.prototype.getModelsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.vehicle_listing_service.GetAvailableModelsResponse} returns this
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.prototype.setModelsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vehicle_listing_service.GetAvailableModelsResponse} returns this
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.prototype.addModels = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.GetAvailableModelsResponse} returns this
 */ proto.vehicle_listing_service.GetAvailableModelsResponse.prototype.clearModelsList = function() {
    return this.setModelsList([]);
};
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.GetAvailableTrimsRequest.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.GetAvailableTrimsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.toObject = function(includeInstance, msg) {
        var f, obj = {
            make: $8M67s.Message.getFieldWithDefault(msg, 1, ""),
            model: $8M67s.Message.getFieldWithDefault(msg, 2, "")
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsRequest}
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.GetAvailableTrimsRequest;
    return proto.vehicle_listing_service.GetAvailableTrimsRequest.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.GetAvailableTrimsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsRequest}
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.setMake(value);
                break;
            case 2:
                var value = /** @type {string} */ reader.readString();
                msg.setModel(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.GetAvailableTrimsRequest.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.GetAvailableTrimsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getMake();
    if (f.length > 0) writer.writeString(1, f);
    f = message.getModel();
    if (f.length > 0) writer.writeString(2, f);
};
/**
 * optional string make = 1;
 * @return {string}
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.prototype.getMake = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 1, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsRequest} returns this
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.prototype.setMake = function(value) {
    return $8M67s.Message.setProto3StringField(this, 1, value);
};
/**
 * optional string model = 2;
 * @return {string}
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.prototype.getModel = function() {
    return /** @type {string} */ $8M67s.Message.getFieldWithDefault(this, 2, "");
};
/**
 * @param {string} value
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsRequest} returns this
 */ proto.vehicle_listing_service.GetAvailableTrimsRequest.prototype.setModel = function(value) {
    return $8M67s.Message.setProto3StringField(this, 2, value);
};
/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.repeatedFields_ = [
    1
];
if ($8M67s.Message.GENERATE_TO_OBJECT) {
    /**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.prototype.toObject = function(opt_includeInstance) {
        return proto.vehicle_listing_service.GetAvailableTrimsResponse.toObject(opt_includeInstance, this);
    };
    /**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_listing_service.GetAvailableTrimsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.toObject = function(includeInstance, msg) {
        var f, obj = {
            trimsList: (f = $8M67s.Message.getRepeatedField(msg, 1)) == null ? undefined : f
        };
        if (includeInstance) obj.$jspbMessageInstance = msg;
        return obj;
    };
}
/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsResponse}
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.deserializeBinary = function(bytes) {
    var reader = new $8M67s.BinaryReader(bytes);
    var msg = new proto.vehicle_listing_service.GetAvailableTrimsResponse;
    return proto.vehicle_listing_service.GetAvailableTrimsResponse.deserializeBinaryFromReader(msg, reader);
};
/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_listing_service.GetAvailableTrimsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsResponse}
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.deserializeBinaryFromReader = function(msg, reader) {
    while(reader.nextField()){
        if (reader.isEndGroup()) break;
        var field = reader.getFieldNumber();
        switch(field){
            case 1:
                var value = /** @type {string} */ reader.readString();
                msg.addTrims(value);
                break;
            default:
                reader.skipField();
                break;
        }
    }
    return msg;
};
/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.prototype.serializeBinary = function() {
    var writer = new $8M67s.BinaryWriter();
    proto.vehicle_listing_service.GetAvailableTrimsResponse.serializeBinaryToWriter(this, writer);
    return writer.getResultBuffer();
};
/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_listing_service.GetAvailableTrimsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.serializeBinaryToWriter = function(message, writer) {
    var f = undefined;
    f = message.getTrimsList();
    if (f.length > 0) writer.writeRepeatedString(1, f);
};
/**
 * repeated string trims = 1;
 * @return {!Array<string>}
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.prototype.getTrimsList = function() {
    return /** @type {!Array<string>} */ $8M67s.Message.getRepeatedField(this, 1);
};
/**
 * @param {!Array<string>} value
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsResponse} returns this
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.prototype.setTrimsList = function(value) {
    return $8M67s.Message.setField(this, 1, value || []);
};
/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsResponse} returns this
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.prototype.addTrims = function(value, opt_index) {
    return $8M67s.Message.addToRepeatedField(this, 1, value, opt_index);
};
/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vehicle_listing_service.GetAvailableTrimsResponse} returns this
 */ proto.vehicle_listing_service.GetAvailableTrimsResponse.prototype.clearTrimsList = function() {
    return this.setTrimsList([]);
};
/**
 * @enum {number}
 */ proto.vehicle_listing_service.OrderStatus = {
    ACCOUNT_CREATED: 0,
    PENDING: 1,
    QUALIFIED: 2,
    VEHICLE: 3,
    REJECTED: 4,
    TESLA_WAITLIST: 5,
    VEHICLE_SELECTED: 6,
    DEPOSIT_PAID: 7,
    PICKUP_SCHEDULED: 8,
    CANCELLED: 9
};
$22a647dbcf55e4ac$var$goog.object.extend(module.exports, proto.vehicle_listing_service);

});


parcelRegister("hkKGc", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $c9e8838827ce4c4a$export$306c0aa65ff9ec16, (v) => $c9e8838827ce4c4a$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c9e8838827ce4c4a$export$306c0aa65ff9ec16;
"use strict";

var $acw62 = parcelRequire("acw62");
function $c9e8838827ce4c4a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c9e8838827ce4c4a$var$objectIs = "function" === typeof Object.is ? Object.is : $c9e8838827ce4c4a$var$is, $c9e8838827ce4c4a$var$useState = $acw62.useState, $c9e8838827ce4c4a$var$useEffect = $acw62.useEffect, $c9e8838827ce4c4a$var$useLayoutEffect = $acw62.useLayoutEffect, $c9e8838827ce4c4a$var$useDebugValue = $acw62.useDebugValue;
function $c9e8838827ce4c4a$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $c9e8838827ce4c4a$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $c9e8838827ce4c4a$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $c9e8838827ce4c4a$var$useEffect(function() {
        $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $c9e8838827ce4c4a$var$useDebugValue(value);
    return value;
}
function $c9e8838827ce4c4a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c9e8838827ce4c4a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c9e8838827ce4c4a$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $c9e8838827ce4c4a$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $c9e8838827ce4c4a$var$useSyncExternalStore$1 : $c9e8838827ce4c4a$var$useSyncExternalStore$2;
$c9e8838827ce4c4a$export$306c0aa65ff9ec16 = void 0 !== $acw62.useSyncExternalStore ? $acw62.useSyncExternalStore : $c9e8838827ce4c4a$var$shim;

});

parcelRegister("i5mAx", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d2aa372f85a97975$export$bf730a2d8bf68b42, (v) => $d2aa372f85a97975$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d2aa372f85a97975$export$bf730a2d8bf68b42;
"use strict";

var $acw62 = parcelRequire("acw62");

var $hfliI = parcelRequire("hfliI");
function $d2aa372f85a97975$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $d2aa372f85a97975$var$objectIs = "function" === typeof Object.is ? Object.is : $d2aa372f85a97975$var$is, $d2aa372f85a97975$var$useSyncExternalStore = $hfliI.useSyncExternalStore, $d2aa372f85a97975$var$useRef = $acw62.useRef, $d2aa372f85a97975$var$useEffect = $acw62.useEffect, $d2aa372f85a97975$var$useMemo = $acw62.useMemo, $d2aa372f85a97975$var$useDebugValue = $acw62.useDebugValue;
$d2aa372f85a97975$export$bf730a2d8bf68b42 = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = $d2aa372f85a97975$var$useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = $d2aa372f85a97975$var$useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if ($d2aa372f85a97975$var$objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = $d2aa372f85a97975$var$useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    $d2aa372f85a97975$var$useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    $d2aa372f85a97975$var$useDebugValue(value);
    return value;
};

});
parcelRegister("hfliI", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hkKGc"));

});


parcelRegister("2hToY", function(module, exports) {
module.exports = import("f7clq").then(()=>parcelRequire('f2WZf'));

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


parcelRequire("acw62");
var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


/**
 * react-router v7.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");
var $84c11e79798ea0cb$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/development/chunk-EPOLDU6W.mjs"
});
var $84c11e79798ea0cb$var$__typeError = (msg)=>{
    throw TypeError(msg);
};
var $84c11e79798ea0cb$var$__accessCheck = (obj, member, msg)=>member.has(obj) || $84c11e79798ea0cb$var$__typeError("Cannot " + msg);
var $84c11e79798ea0cb$var$__privateGet = (obj, member, getter)=>($84c11e79798ea0cb$var$__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var $84c11e79798ea0cb$var$__privateAdd = (obj, member, value)=>member.has(obj) ? $84c11e79798ea0cb$var$__typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
// lib/router/history.ts
var $84c11e79798ea0cb$export$e19cd5f9376f8cee = /* @__PURE__ */ ((Action2)=>{
    Action2["Pop"] = "POP";
    Action2["Push"] = "PUSH";
    Action2["Replace"] = "REPLACE";
    return Action2;
})($84c11e79798ea0cb$export$e19cd5f9376f8cee || {});
var $84c11e79798ea0cb$var$PopStateEventType = "popstate";
function $84c11e79798ea0cb$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index2)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index2 === 0 ? "default" : void 0));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP" /* Pop */ ;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key) {
        let location = $84c11e79798ea0cb$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $84c11e79798ea0cb$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref2(to) {
        return typeof to === "string" ? to : $84c11e79798ea0cb$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref2,
        createURL (to) {
            return new URL(createHref2(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $84c11e79798ea0cb$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH" /* Push */ ;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE" /* Replace */ ;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP" /* Pop */ ;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
function $84c11e79798ea0cb$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window2, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window2.location;
        return $84c11e79798ea0cb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window2, to) {
        return typeof to === "string" ? to : $84c11e79798ea0cb$export$fe53371bee54353d(to);
    }
    return $84c11e79798ea0cb$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
function $84c11e79798ea0cb$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window2, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $84c11e79798ea0cb$export$8ccf933b0513f8d0(window2.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $84c11e79798ea0cb$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window2, to) {
        let base = window2.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window2.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $84c11e79798ea0cb$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $84c11e79798ea0cb$var$warning(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $84c11e79798ea0cb$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $84c11e79798ea0cb$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $84c11e79798ea0cb$var$warning(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $84c11e79798ea0cb$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
function $84c11e79798ea0cb$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
function $84c11e79798ea0cb$var$createLocation(current, to, state = null, key) {
    let location = {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $84c11e79798ea0cb$export$8ccf933b0513f8d0(to) : to,
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $84c11e79798ea0cb$var$createKey()
    };
    return location;
}
function $84c11e79798ea0cb$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
function $84c11e79798ea0cb$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $84c11e79798ea0cb$var$getUrlBasedHistory(getLocation, createHref2, validateLocation, options = {}) {
    let { window: window2 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window2.history;
    let action = "POP" /* Pop */ ;
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = "POP" /* Pop */ ;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH" /* Push */ ;
        let location = $84c11e79798ea0cb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $84c11e79798ea0cb$var$getHistoryState(location, index);
        let url = history.createHref(location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window2.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace2(to, state) {
        action = "REPLACE" /* Replace */ ;
        let location = $84c11e79798ea0cb$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $84c11e79798ea0cb$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $84c11e79798ea0cb$var$createBrowserURLImpl(to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window2, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window2.addEventListener($84c11e79798ea0cb$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window2.removeEventListener($84c11e79798ea0cb$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref2(window2, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace2,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $84c11e79798ea0cb$var$createBrowserURLImpl(to, isAbsolute = false) {
    let base = "http://localhost";
    if (typeof window !== "undefined") base = window.location.origin !== "null" ? window.location.origin : window.location.href;
    $84c11e79798ea0cb$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $84c11e79798ea0cb$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && href.startsWith("//")) href = base + href;
    return new URL(href, base);
}
// lib/router/utils.ts
function $84c11e79798ea0cb$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
var $84c11e79798ea0cb$var$_map;
var $84c11e79798ea0cb$export$b8d3e69d4b3eff04 = class {
    /**
   * Create a new `RouterContextProvider` instance
   * @param init An optional initial context map to populate the provider with
   */ constructor(init){
        $84c11e79798ea0cb$var$__privateAdd(this, $84c11e79798ea0cb$var$_map, /* @__PURE__ */ new Map());
        if (init) for (let [context, value] of init)this.set(context, value);
    }
    /**
   * Access a value from the context. If no value has been set for the context,
   * it will return the context's `defaultValue` if provided, or throw an error
   * if no `defaultValue` was set.
   * @param context The context to get the value for
   * @returns The value for the context, or the context's `defaultValue` if no
   * value was set
   */ get(context) {
        if ($84c11e79798ea0cb$var$__privateGet(this, $84c11e79798ea0cb$var$_map).has(context)) return $84c11e79798ea0cb$var$__privateGet(this, $84c11e79798ea0cb$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
   * Set a value for the context. If the context already has a value set, this
   * will overwrite it.
   *
   * @param context The context to set the value for
   * @param value The value to set for the context
   * @returns {void}
   */ set(context, value) {
        $84c11e79798ea0cb$var$__privateGet(this, $84c11e79798ea0cb$var$_map).set(context, value);
    }
};
$84c11e79798ea0cb$var$_map = new WeakMap();
var $84c11e79798ea0cb$var$unsupportedLazyRouteObjectKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $84c11e79798ea0cb$var$isUnsupportedLazyRouteObjectKey(key) {
    return $84c11e79798ea0cb$var$unsupportedLazyRouteObjectKeys.has(key);
}
var $84c11e79798ea0cb$var$unsupportedLazyRouteFunctionKeys = /* @__PURE__ */ new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function $84c11e79798ea0cb$var$isUnsupportedLazyRouteFunctionKey(key) {
    return $84c11e79798ea0cb$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $84c11e79798ea0cb$var$isIndexRoute(route) {
    return route.index === true;
}
function $84c11e79798ea0cb$export$87cb1a9238dc3fba(routes, mapRouteProperties2, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $84c11e79798ea0cb$export$f5708dca728d7177(route.index !== true || !route.children, `Cannot specify children on an index route`);
        $84c11e79798ea0cb$export$f5708dca728d7177(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($84c11e79798ea0cb$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $84c11e79798ea0cb$var$mergeRouteUpdates(indexRoute, mapRouteProperties2(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $84c11e79798ea0cb$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties2(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $84c11e79798ea0cb$export$87cb1a9238dc3fba(route.children, mapRouteProperties2, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $84c11e79798ea0cb$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
function $84c11e79798ea0cb$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $84c11e79798ea0cb$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $84c11e79798ea0cb$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $84c11e79798ea0cb$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $84c11e79798ea0cb$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $84c11e79798ea0cb$var$flattenRoutes(routes);
    $84c11e79798ea0cb$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        let decoded = $84c11e79798ea0cb$var$decodePath(pathname);
        matches = $84c11e79798ea0cb$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $84c11e79798ea0cb$var$convertRouteMatchToUiMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $84c11e79798ea0cb$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            $84c11e79798ea0cb$export$f5708dca728d7177(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $84c11e79798ea0cb$var$joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            $84c11e79798ea0cb$export$f5708dca728d7177(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $84c11e79798ea0cb$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $84c11e79798ea0cb$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $84c11e79798ea0cb$var$explodeOptionalSegments(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $84c11e79798ea0cb$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $84c11e79798ea0cb$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $84c11e79798ea0cb$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $84c11e79798ea0cb$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
var $84c11e79798ea0cb$var$paramRe = /^:[\w-]+$/;
var $84c11e79798ea0cb$var$dynamicSegmentValue = 3;
var $84c11e79798ea0cb$var$indexRouteValue = 2;
var $84c11e79798ea0cb$var$emptySegmentValue = 1;
var $84c11e79798ea0cb$var$staticSegmentValue = 10;
var $84c11e79798ea0cb$var$splatPenalty = -2;
var $84c11e79798ea0cb$var$isSplat = (s)=>s === "*";
function $84c11e79798ea0cb$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($84c11e79798ea0cb$var$isSplat)) initialScore += $84c11e79798ea0cb$var$splatPenalty;
    if (index) initialScore += $84c11e79798ea0cb$var$indexRouteValue;
    return segments.filter((s)=>!$84c11e79798ea0cb$var$isSplat(s)).reduce((score, segment)=>score + ($84c11e79798ea0cb$var$paramRe.test(segment) ? $84c11e79798ea0cb$var$dynamicSegmentValue : segment === "" ? $84c11e79798ea0cb$var$emptySegmentValue : $84c11e79798ea0cb$var$staticSegmentValue), initialScore);
}
function $84c11e79798ea0cb$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $84c11e79798ea0cb$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $84c11e79798ea0cb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $84c11e79798ea0cb$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $84c11e79798ea0cb$var$joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $84c11e79798ea0cb$var$normalizePathname($84c11e79798ea0cb$var$joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $84c11e79798ea0cb$var$joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
function $84c11e79798ea0cb$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $84c11e79798ea0cb$var$warning(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify2 = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        if (isLastSegment && segment === "*") {
            const star = "*";
            return stringify2(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            $84c11e79798ea0cb$export$f5708dca728d7177(optional === "?" || param != null, `Missing ":${key}" param`);
            return encodeURIComponent(stringify2(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
function $84c11e79798ea0cb$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $84c11e79798ea0cb$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo2, { paramName: paramName, isOptional: isOptional }, index)=>{
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo2[paramName] = void 0;
        else memo2[paramName] = (value || "").replace(/%2F/g, "/");
        return memo2;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $84c11e79798ea0cb$var$compilePath(path, caseSensitive = false, end = true) {
    $84c11e79798ea0cb$var$warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? void 0 : "i");
    return [
        matcher,
        params
    ];
}
function $84c11e79798ea0cb$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $84c11e79798ea0cb$var$warning(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $84c11e79798ea0cb$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $84c11e79798ea0cb$var$prependBasename({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $84c11e79798ea0cb$var$joinPaths([
        basename,
        pathname
    ]);
}
var $84c11e79798ea0cb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $84c11e79798ea0cb$var$isAbsoluteUrl = (url)=>$84c11e79798ea0cb$var$ABSOLUTE_URL_REGEX.test(url);
function $84c11e79798ea0cb$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $84c11e79798ea0cb$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($84c11e79798ea0cb$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $84c11e79798ea0cb$var$warning(false, `Pathnames cannot have embedded double slashes - normalizing ${oldPathname} -> ${toPathname}`);
            }
            if (toPathname.startsWith("/")) pathname = $84c11e79798ea0cb$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $84c11e79798ea0cb$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $84c11e79798ea0cb$var$normalizeSearch(search),
        hash: $84c11e79798ea0cb$var$normalizeHash(hash)
    };
}
function $84c11e79798ea0cb$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $84c11e79798ea0cb$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $84c11e79798ea0cb$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $84c11e79798ea0cb$var$getResolveToMatches(matches) {
    let pathMatches = $84c11e79798ea0cb$var$getPathContributingMatches(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $84c11e79798ea0cb$var$resolveTo(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = $84c11e79798ea0cb$export$8ccf933b0513f8d0(toArg);
    else {
        to = {
            ...toArg
        };
        $84c11e79798ea0cb$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("?"), $84c11e79798ea0cb$var$getInvalidPathError("?", "pathname", "search", to));
        $84c11e79798ea0cb$export$f5708dca728d7177(!to.pathname || !to.pathname.includes("#"), $84c11e79798ea0cb$var$getInvalidPathError("#", "pathname", "hash", to));
        $84c11e79798ea0cb$export$f5708dca728d7177(!to.search || !to.search.includes("#"), $84c11e79798ea0cb$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $84c11e79798ea0cb$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var $84c11e79798ea0cb$var$joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
var $84c11e79798ea0cb$var$normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
var $84c11e79798ea0cb$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
var $84c11e79798ea0cb$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $84c11e79798ea0cb$var$DataWithResponseInit = class {
    constructor(data2, init){
        this.type = "DataWithResponseInit";
        this.data = data2;
        this.init = init || null;
    }
};
function $84c11e79798ea0cb$export$4051a07651545597(data2, init) {
    return new $84c11e79798ea0cb$var$DataWithResponseInit(data2, typeof init === "number" ? {
        status: init
    } : init);
}
var $84c11e79798ea0cb$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
var $84c11e79798ea0cb$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $84c11e79798ea0cb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
var $84c11e79798ea0cb$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $84c11e79798ea0cb$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var $84c11e79798ea0cb$export$f2680fa305b734ca = class {
    constructor(status, statusText, data2, internal = false){
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data2 instanceof Error) {
            this.data = data2.toString();
            this.error = data2;
        } else this.data = data2;
    }
};
function $84c11e79798ea0cb$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $84c11e79798ea0cb$var$getRoutePattern(matches) {
    return matches.map((m)=>m.route.path).filter(Boolean).join("/").replace(/\/\/*/g, "/") || "/";
}
var $84c11e79798ea0cb$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $84c11e79798ea0cb$var$parseToInfo(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !$84c11e79798ea0cb$var$ABSOLUTE_URL_REGEX.test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($84c11e79798ea0cb$var$isBrowser) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
        let path = $84c11e79798ea0cb$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        $84c11e79798ea0cb$var$warning(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}
// lib/router/instrumentation.ts
var $84c11e79798ea0cb$var$UninstrumentedSymbol = Symbol("Uninstrumented");
function $84c11e79798ea0cb$var$getRouteInstrumentationUpdates(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                let keys = Object.keys(aggregated);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let instrumented = $84c11e79798ea0cb$var$wrapImpl(aggregated.lazy, route.lazy, ()=>void 0);
        if (instrumented) updates.lazy = instrumented;
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        [
            "middleware",
            "loader",
            "action"
        ].forEach((key)=>{
            let lazyFn = lazyObject[key];
            let instrumentations = aggregated[`lazy.${key}`];
            if (typeof lazyFn === "function" && instrumentations.length > 0) {
                let instrumented = $84c11e79798ea0cb$var$wrapImpl(instrumentations, lazyFn, ()=>void 0);
                if (instrumented) updates.lazy = Object.assign(updates.lazy || {}, {
                    [key]: instrumented
                });
            }
        });
    }
    [
        "loader",
        "action"
    ].forEach((key)=>{
        let handler = route[key];
        if (typeof handler === "function" && aggregated[key].length > 0) {
            let original = handler[$84c11e79798ea0cb$var$UninstrumentedSymbol] ?? handler;
            let instrumented = $84c11e79798ea0cb$var$wrapImpl(aggregated[key], original, (...args)=>$84c11e79798ea0cb$var$getHandlerInfo(args[0]));
            if (instrumented) {
                if (key === "loader" && original.hydrate === true) instrumented.hydrate = true;
                instrumented[$84c11e79798ea0cb$var$UninstrumentedSymbol] = original;
                updates[key] = instrumented;
            }
        }
    });
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = middleware[$84c11e79798ea0cb$var$UninstrumentedSymbol] ?? middleware;
        let instrumented = $84c11e79798ea0cb$var$wrapImpl(aggregated.middleware, original, (...args)=>$84c11e79798ea0cb$var$getHandlerInfo(args[0]));
        if (instrumented) {
            instrumented[$84c11e79798ea0cb$var$UninstrumentedSymbol] = original;
            return instrumented;
        }
        return middleware;
    });
    return updates;
}
function $84c11e79798ea0cb$var$instrumentClientSideRouter(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = router.navigate[$84c11e79798ea0cb$var$UninstrumentedSymbol] ?? router.navigate;
        let instrumentedNavigate = $84c11e79798ea0cb$var$wrapImpl(aggregated.navigate, navigate, (...args)=>{
            let [to, opts] = args;
            return {
                to: typeof to === "number" || typeof to === "string" ? to : to ? $84c11e79798ea0cb$export$fe53371bee54353d(to) : ".",
                ...$84c11e79798ea0cb$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedNavigate) {
            instrumentedNavigate[$84c11e79798ea0cb$var$UninstrumentedSymbol] = navigate;
            router.navigate = instrumentedNavigate;
        }
    }
    if (aggregated.fetch.length > 0) {
        let fetch2 = router.fetch[$84c11e79798ea0cb$var$UninstrumentedSymbol] ?? router.fetch;
        let instrumentedFetch = $84c11e79798ea0cb$var$wrapImpl(aggregated.fetch, fetch2, (...args)=>{
            let [key, , href, opts] = args;
            return {
                href: href ?? ".",
                fetcherKey: key,
                ...$84c11e79798ea0cb$var$getRouterInfo(router, opts ?? {})
            };
        });
        if (instrumentedFetch) {
            instrumentedFetch[$84c11e79798ea0cb$var$UninstrumentedSymbol] = fetch2;
            router.fetch = instrumentedFetch;
        }
    }
    return router;
}
function $84c11e79798ea0cb$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                let keys = Object.keys(i);
                for (let key of keys)if (i[key]) aggregated[key].push(i[key]);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = $84c11e79798ea0cb$var$wrapImpl(aggregated.request, handler, (...args)=>{
        let [request, context] = args;
        return {
            request: $84c11e79798ea0cb$var$getReadonlyRequest(request),
            context: context != null ? $84c11e79798ea0cb$var$getReadonlyContext(context) : context
        };
    });
    return instrumentedHandler;
}
function $84c11e79798ea0cb$var$wrapImpl(impls, handler, getInfo) {
    if (impls.length === 0) return null;
    return async (...args)=>{
        let result = await $84c11e79798ea0cb$var$recurseRight(impls, getInfo(...args), ()=>handler(...args), impls.length - 1);
        if (result.type === "error") throw result.value;
        return result.value;
    };
}
async function $84c11e79798ea0cb$var$recurseRight(impls, info, handler, index) {
    let impl = impls[index];
    let result;
    if (!impl) try {
        let value = await handler();
        result = {
            type: "success",
            value: value
        };
    } catch (e) {
        result = {
            type: "error",
            value: e
        };
    }
    else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $84c11e79798ea0cb$var$recurseRight(impls, info, handler, index - 1);
            result = await handlerPromise;
            $84c11e79798ea0cb$export$f5708dca728d7177(result, "Expected a result");
            if (result.type === "error" && result.value instanceof Error) return {
                status: "error",
                error: result.value
            };
            return {
                status: "success",
                error: void 0
            };
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (result) return result;
    return {
        type: "error",
        value: new Error("No result assigned in instrumentation chain.")
    };
}
function $84c11e79798ea0cb$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params, unstable_pattern: unstable_pattern } = args;
    return {
        request: $84c11e79798ea0cb$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        unstable_pattern: unstable_pattern,
        context: $84c11e79798ea0cb$var$getReadonlyContext(context)
    };
}
function $84c11e79798ea0cb$var$getRouterInfo(router, opts) {
    return {
        currentUrl: $84c11e79798ea0cb$export$fe53371bee54353d(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $84c11e79798ea0cb$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $84c11e79798ea0cb$var$getReadonlyContext(context) {
    if ($84c11e79798ea0cb$var$isPlainObject(context)) {
        let frozen = {
            ...context
        };
        Object.freeze(frozen);
        return frozen;
    } else return {
        get: (ctx)=>context.get(ctx)
    };
}
var $84c11e79798ea0cb$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $84c11e79798ea0cb$var$isPlainObject(thing) {
    if (thing === null || typeof thing !== "object") return false;
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $84c11e79798ea0cb$var$objectProtoNames;
}
// lib/router/router.ts
var $84c11e79798ea0cb$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $84c11e79798ea0cb$var$validMutationMethods = new Set($84c11e79798ea0cb$var$validMutationMethodsArr);
var $84c11e79798ea0cb$var$validRequestMethodsArr = [
    "GET",
    ...$84c11e79798ea0cb$var$validMutationMethodsArr
];
var $84c11e79798ea0cb$var$validRequestMethods = new Set($84c11e79798ea0cb$var$validRequestMethodsArr);
var $84c11e79798ea0cb$var$redirectStatusCodes = /* @__PURE__ */ new Set([
    301,
    302,
    303,
    307,
    308
]);
var $84c11e79798ea0cb$var$redirectPreserveMethodStatusCodes = /* @__PURE__ */ new Set([
    307,
    308
]);
var $84c11e79798ea0cb$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $84c11e79798ea0cb$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $84c11e79798ea0cb$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $84c11e79798ea0cb$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
var $84c11e79798ea0cb$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $84c11e79798ea0cb$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $84c11e79798ea0cb$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser3 = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    $84c11e79798ea0cb$export$f5708dca728d7177(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties2 = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties || $84c11e79798ea0cb$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (init.unstable_instrumentations) {
        let instrumentations = init.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$84c11e79798ea0cb$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let manifest = {};
    let dataRoutes = $84c11e79798ea0cb$export$87cb1a9238dc3fba(init.routes, mapRouteProperties2, void 0, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataStrategyImpl = init.dataStrategy || $84c11e79798ea0cb$var$defaultDataStrategyWithMiddleware;
    let future = {
        ...init.future
    };
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let savedScrollPositions2 = null;
    let getScrollRestorationKey2 = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $84c11e79798ea0cb$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $84c11e79798ea0cb$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $84c11e79798ea0cb$var$getShortCircuitMatches(dataRoutes);
        initialized = true;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) initialized = false;
        else if (!initialMatches.some((m)=>$84c11e79798ea0cb$var$routeHasLoaderOrMiddleware(m.route))) initialized = true;
        else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                initialized = initialMatches.slice(0, idx + 1).every((m)=>!$84c11e79798ea0cb$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
            } else initialized = initialMatches.every((m)=>!$84c11e79798ea0cb$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $84c11e79798ea0cb$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP" /* Pop */ ;
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            $84c11e79798ea0cb$var$warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $84c11e79798ea0cb$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser3) {
            $84c11e79798ea0cb$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$84c11e79798ea0cb$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP" /* Pop */ , state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $84c11e79798ea0cb$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $84c11e79798ea0cb$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $84c11e79798ea0cb$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $84c11e79798ea0cb$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = void 0;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP" /* Pop */ ) ;
        else if (pendingAction === "PUSH" /* Push */ ) init.history.push(location, location.state);
        else if (pendingAction === "REPLACE" /* Replace */ ) init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" /* Pop */ ) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = /* @__PURE__ */ new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: // matches, errors, fetchers go through as-is
            actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $84c11e79798ea0cb$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP" /* Pop */ ;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $84c11e79798ea0cb$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let normalizedPath = $84c11e79798ea0cb$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative);
        let { path: path, submission: submission, error: error } = $84c11e79798ea0cb$var$normalizeNavigateOptions(false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $84c11e79798ea0cb$var$createLocation(state.location, path, opts && opts.state);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH" /* Push */ ;
        if (userReplace === true) historyAction = "REPLACE" /* Replace */ ;
        else if (userReplace === false) ;
        else if (submission != null && $84c11e79798ea0cb$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE" /* Replace */ ;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $84c11e79798ea0cb$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.unstable_defaultShouldRevalidate
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $84c11e79798ea0cb$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $84c11e79798ea0cb$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $84c11e79798ea0cb$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $84c11e79798ea0cb$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        pendingNavigationController = new AbortController();
        let request = $84c11e79798ea0cb$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new $84c11e79798ea0cb$export$b8d3e69d4b3eff04();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $84c11e79798ea0cb$var$findNearestBoundary(matches).route.id,
            {
                type: "error" /* error */ ,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $84c11e79798ea0cb$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($84c11e79798ea0cb$var$isErrorResult(result) && $84c11e79798ea0cb$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $84c11e79798ea0cb$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $84c11e79798ea0cb$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$84c11e79798ea0cb$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors
        });
    }
    async function handleAction(request, location, submission, matches, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        let navigation = $84c11e79798ea0cb$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $84c11e79798ea0cb$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error" /* error */ ,
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $84c11e79798ea0cb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error" /* error */ ,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error" /* error */ ,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $84c11e79798ea0cb$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error" /* error */ ,
            error: $84c11e79798ea0cb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let dsMatches = $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties2, scopedContext);
            let results = await callDataStrategy(request, dsMatches, scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($84c11e79798ea0cb$var$isRedirectResult(result)) {
            let replace2;
            if (opts && opts.replace != null) replace2 = opts.replace;
            else {
                let location2 = $84c11e79798ea0cb$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace2 = location2 === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        if ($84c11e79798ea0cb$var$isErrorResult(result)) {
            let boundaryMatch = $84c11e79798ea0cb$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH" /* Push */ ;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace2, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $84c11e79798ea0cb$var$getLoadingNavigation(location, submission);
        let activeSubmission = submission || fetcherSubmission || $84c11e79798ea0cb$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches2, route: route } = $84c11e79798ea0cb$var$getShortCircuitMatches(dataRoutes);
                    return {
                        matches: matches2,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $84c11e79798ea0cb$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $84c11e79798ea0cb$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties2, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let updatedFetchers2 = markFetchRedirectsDone();
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $84c11e79798ea0cb$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$84c11e79798ea0cb$var$getActionDataForCommit(pendingActionResult),
                ...updatedFetchers2 ? {
                    fetchers: new Map(state.fetchers)
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect2 = $84c11e79798ea0cb$var$findRedirect(loaderResults);
        if (redirect2) {
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        redirect2 = $84c11e79798ea0cb$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            await startRedirectNavigation(request, redirect2.result, true, {
                replace: replace2
            });
            return {
                shortCircuited: true
            };
        }
        let { loaderData: loaderData, errors: errors } = $84c11e79798ea0cb$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$84c11e79798ea0cb$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $84c11e79798ea0cb$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    async function fetch2(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $84c11e79798ea0cb$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = $84c11e79798ea0cb$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $84c11e79798ea0cb$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $84c11e79798ea0cb$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new $84c11e79798ea0cb$export$b8d3e69d4b3eff04();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $84c11e79798ea0cb$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.unstable_defaultShouldRevalidate);
            return;
        }
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        await handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $84c11e79798ea0cb$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $84c11e79798ea0cb$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $84c11e79798ea0cb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $84c11e79798ea0cb$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            let error = $84c11e79798ea0cb$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, requestMatches, match, hydrationRouteProperties2, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match2 of fetchMatches)if (actionResults[match2.route.id]) {
                actionResult = actionResults[match2.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($84c11e79798ea0cb$var$isRedirectResult(actionResult) || $84c11e79798ea0cb$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $84c11e79798ea0cb$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($84c11e79798ea0cb$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $84c11e79798ea0cb$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $84c11e79798ea0cb$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($84c11e79798ea0cb$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $84c11e79798ea0cb$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $84c11e79798ea0cb$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $84c11e79798ea0cb$export$f5708dca728d7177(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $84c11e79798ea0cb$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $84c11e79798ea0cb$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties2, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties2, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher2 = state.fetchers.get(staleKey);
            let revalidatingFetcher = $84c11e79798ea0cb$var$getLoadingFetcher(void 0, existingFetcher2 ? existingFetcher2.data : void 0);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, scopedContext);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        if (state.fetchers.has(key)) {
            let doneFetcher = $84c11e79798ea0cb$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        let redirect2 = $84c11e79798ea0cb$var$findRedirect(loaderResults);
        if (redirect2) return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect2 = $84c11e79798ea0cb$var$findRedirect(fetcherResults);
        if (redirect2) {
            fetchRedirectIds.add(redirect2.key);
            return startRedirectNavigation(revalidationRequest, redirect2.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let { loaderData: loaderData, errors: errors } = $84c11e79798ea0cb$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults);
        abortStaleFetchLoads(loadId);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $84c11e79798ea0cb$export$f5708dca728d7177(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $84c11e79798ea0cb$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $84c11e79798ea0cb$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $84c11e79798ea0cb$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $84c11e79798ea0cb$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else matches = discoverResult.matches;
        }
        let match = $84c11e79798ea0cb$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let dsMatches = $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, matches, match, hydrationRouteProperties2, scopedContext);
        let results = await callDataStrategy(fetchRequest, dsMatches, scopedContext, key);
        let result = results[match.route.id];
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $84c11e79798ea0cb$var$getDoneFetcher(void 0));
            return;
        }
        if ($84c11e79798ea0cb$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $84c11e79798ea0cb$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($84c11e79798ea0cb$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $84c11e79798ea0cb$var$getDoneFetcher(result.data));
    }
    async function startRedirectNavigation(request, redirect2, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace2 } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect2.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect2.response.headers.get("Location");
        $84c11e79798ea0cb$export$f5708dca728d7177(location, "Expected a Location header on the redirect Response");
        location = $84c11e79798ea0cb$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $84c11e79798ea0cb$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser3) {
            let isDocumentReload = false;
            if (redirect2.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ($84c11e79798ea0cb$var$isAbsoluteUrl(location)) {
                const url = $84c11e79798ea0cb$var$createBrowserURLImpl(location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $84c11e79798ea0cb$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace2) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace2 === true || redirect2.response.headers.has("X-Remix-Replace") ? "REPLACE" /* Replace */  : "PUSH" /* Push */ ;
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $84c11e79798ea0cb$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($84c11e79798ea0cb$var$redirectPreserveMethodStatusCodes.has(redirect2.response.status) && activeSubmission && $84c11e79798ea0cb$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else {
            let overrideNavigation = $84c11e79798ea0cb$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectNavigationType, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
            });
        }
    }
    async function callDataStrategy(request, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $84c11e79798ea0cb$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error" /* error */ ,
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$84c11e79798ea0cb$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error" /* error */ ) break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error" /* error */ ,
                result: new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($84c11e79798ea0cb$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect" /* redirect */ ,
                response: $84c11e79798ea0cb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $84c11e79798ea0cb$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let results = await callDataStrategy(f.request, f.matches, scopedContext, f.key);
                let result = results[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error" /* error */ ,
                    error: $84c11e79798ea0cb$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $84c11e79798ea0cb$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $84c11e79798ea0cb$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $84c11e79798ea0cb$var$getDoneFetcher(null));
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $84c11e79798ea0cb$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $84c11e79798ea0cb$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $84c11e79798ea0cb$export$f5708dca728d7177(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $84c11e79798ea0cb$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $84c11e79798ea0cb$export$386d57f03f0b2883;
        $84c11e79798ea0cb$export$f5708dca728d7177(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) $84c11e79798ea0cb$var$warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $84c11e79798ea0cb$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $84c11e79798ea0cb$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions2 = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey2 = getKey || null;
        if (!initialScrollRestored && state.navigation === $84c11e79798ea0cb$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions2 = null;
            getScrollPosition = null;
            getScrollRestorationKey2 = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey2) {
            let key = getScrollRestorationKey2(location, matches.map((m)=>$84c11e79798ea0cb$var$convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions2 && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions2[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions2) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions2[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) {
                let fogMatches = $84c11e79798ea0cb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                let partialMatches = $84c11e79798ea0cb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $84c11e79798ea0cb$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties2, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $84c11e79798ea0cb$export$2708184779ceb39d(routesToUse, pathname, basename);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = $84c11e79798ea0cb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                    let matchedDeeper = newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length));
                    if (!matchedDeeper) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = $84c11e79798ea0cb$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $84c11e79798ea0cb$export$87cb1a9238dc3fba(newRoutes, mapRouteProperties2, void 0, manifest);
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $84c11e79798ea0cb$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, unstable_allowElementMutations);
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch2,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.unstable_instrumentations) router = $84c11e79798ea0cb$var$instrumentClientSideRouter(router, init.unstable_instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
function $84c11e79798ea0cb$export$3336b097a6fbc59a(routes, opts) {
    $84c11e79798ea0cb$export$f5708dca728d7177(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties || $84c11e79798ea0cb$var$defaultMapRouteProperties;
    let mapRouteProperties2 = _mapRouteProperties;
    if (opts?.unstable_instrumentations) {
        let instrumentations = opts.unstable_instrumentations;
        mapRouteProperties2 = (route)=>{
            return {
                ..._mapRouteProperties(route),
                ...$84c11e79798ea0cb$var$getRouteInstrumentationUpdates(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = $84c11e79798ea0cb$export$87cb1a9238dc3fba(routes, mapRouteProperties2, void 0, manifest);
    async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $84c11e79798ea0cb$var$createLocation("", $84c11e79798ea0cb$export$fe53371bee54353d(url), null, "default");
        let matches = $84c11e79798ea0cb$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $84c11e79798ea0cb$export$b8d3e69d4b3eff04();
        if (!$84c11e79798ea0cb$var$isValidMethod(method) && method !== "HEAD") {
            let error = $84c11e79798ea0cb$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $84c11e79798ea0cb$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $84c11e79798ea0cb$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $84c11e79798ea0cb$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {}
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            $84c11e79798ea0cb$export$f5708dca728d7177(requestContext instanceof $84c11e79798ea0cb$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $84c11e79798ea0cb$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
                let renderedStaticContext;
                let response = await $84c11e79798ea0cb$var$runServerMiddlewarePipeline({
                    request: request,
                    unstable_pattern: $84c11e79798ea0cb$var$getRoutePattern(matches),
                    matches: matches,
                    params: matches[0].params,
                    // If we're calling middleware then it must be enabled so we can cast
                    // this to the proper type knowing it's not an `AppLoadContext`
                    context: requestContext
                }, async ()=>{
                    let res = await generateMiddlewareResponse(async (revalidationRequest, opts2 = {})=>{
                        let result2 = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts2 ? opts2.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result2)) return result2;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result2
                        };
                        return renderedStaticContext;
                    });
                    return res;
                }, async (error, routeId)=>{
                    if ($84c11e79798ea0cb$export$6e80290866a84dd4(error)) return error;
                    if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(error)) try {
                        error = new $84c11e79798ea0cb$export$f2680fa305b734ca(error.status, error.statusText, await $84c11e79798ea0cb$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($84c11e79798ea0cb$export$e0163cfdf7bc9cfa(error)) error = $84c11e79798ea0cb$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $84c11e79798ea0cb$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $84c11e79798ea0cb$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let boundaryRouteId = skipLoaderErrorBubbling ? routeId : $84c11e79798ea0cb$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id;
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [boundaryRouteId]: error
                            },
                            statusCode: $84c11e79798ea0cb$export$972111febbeef05b(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {}
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                $84c11e79798ea0cb$export$f5708dca728d7177($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result
        };
    }
    async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse } = {}) {
        let url = new URL(request.url);
        let method = request.method;
        let location = $84c11e79798ea0cb$var$createLocation("", $84c11e79798ea0cb$export$fe53371bee54353d(url), null, "default");
        let matches = $84c11e79798ea0cb$export$2708184779ceb39d(dataRoutes, location, basename);
        requestContext = requestContext != null ? requestContext : new $84c11e79798ea0cb$export$b8d3e69d4b3eff04();
        if (!$84c11e79798ea0cb$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $84c11e79798ea0cb$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $84c11e79798ea0cb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $84c11e79798ea0cb$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $84c11e79798ea0cb$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $84c11e79798ea0cb$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            $84c11e79798ea0cb$export$f5708dca728d7177(requestContext instanceof $84c11e79798ea0cb$export$b8d3e69d4b3eff04, "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $84c11e79798ea0cb$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2);
            let response = await $84c11e79798ea0cb$var$runServerMiddlewarePipeline({
                request: request,
                unstable_pattern: $84c11e79798ea0cb$var$getRoutePattern(matches),
                matches: matches,
                params: matches[0].params,
                // If we're calling middleware then it must be enabled so we can cast
                // this to the proper type knowing it's not an `AppLoadContext`
                context: requestContext
            }, async ()=>{
                let res = await generateMiddlewareResponse(async (innerRequest)=>{
                    let result2 = await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false);
                    let processed = handleQueryResult(result2);
                    return $84c11e79798ea0cb$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
                return res;
            }, (error)=>{
                if ($84c11e79798ea0cb$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($84c11e79798ea0cb$var$dataWithResponseInitToResponse(error));
                if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
            return response;
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false);
        return handleQueryResult(result);
        function handleQueryResult(result2) {
            if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result2)) return result2;
            let error = result2.errors ? Object.values(result2.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result2.actionData) return Object.values(result2.actionData)[0];
            if (result2.loaderData) return Object.values(result2.loaderData)[0];
            return void 0;
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        $84c11e79798ea0cb$export$f5708dca728d7177(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($84c11e79798ea0cb$export$cbae47800eb95bc3(request.method)) {
                let result2 = await submit(request, matches, routeMatch || $84c11e79798ea0cb$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
                return result2;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($84c11e79798ea0cb$var$isDataStrategyResult(e) && $84c11e79798ea0cb$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error" /* error */ ) throw e.result;
                return e.result;
            }
            if ($84c11e79798ea0cb$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $84c11e79798ea0cb$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error" /* error */ ,
                error: error
            };
        } else {
            let dsMatches = $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, actionMatch, [], requestContext);
            let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $84c11e79798ea0cb$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($84c11e79798ea0cb$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($84c11e79798ea0cb$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($84c11e79798ea0cb$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $84c11e79798ea0cb$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: $84c11e79798ea0cb$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($84c11e79798ea0cb$var$isErrorResult(result)) {
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $84c11e79798ea0cb$var$findNearestBoundary(matches, actionMatch.route.id);
            let handlerContext2 = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                boundaryMatch.route.id,
                result
            ]);
            return {
                ...handlerContext2,
                statusCode: $84c11e79798ea0cb$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: {
                    ...result.headers ? {
                        [actionMatch.route.id]: result.headers
                    } : {}
                }
            };
        }
        let handlerContext = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad);
        return {
            ...handlerContext,
            actionData: {
                [actionMatch.route.id]: result.data
            },
            // action status codes take precedence over loader status codes
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $84c11e79798ea0cb$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $84c11e79798ea0cb$var$isErrorResult(pendingActionResult[1]) ? // Up to but not including the boundary
            matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = $84c11e79798ea0cb$var$getRoutePattern(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $84c11e79798ea0cb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, false);
                return $84c11e79798ea0cb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $84c11e79798ea0cb$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $84c11e79798ea0cb$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        let handlerContext = $84c11e79798ea0cb$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling);
        return {
            ...handlerContext,
            matches: matches
        };
    }
    async function callDataStrategy(request, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $84c11e79798ea0cb$var$callDataStrategyImpl(dataStrategy || $84c11e79798ea0cb$var$defaultDataStrategy, request, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($84c11e79798ea0cb$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $84c11e79798ea0cb$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($84c11e79798ea0cb$export$e0163cfdf7bc9cfa(result.result)) throw $84c11e79798ea0cb$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $84c11e79798ea0cb$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
function $84c11e79798ea0cb$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: $84c11e79798ea0cb$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $84c11e79798ea0cb$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(`${method}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $84c11e79798ea0cb$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $84c11e79798ea0cb$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = $84c11e79798ea0cb$var$resolveTo(to ? to : ".", $84c11e79798ea0cb$var$getResolveToMatches(contextualMatches), $84c11e79798ea0cb$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $84c11e79798ea0cb$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = $84c11e79798ea0cb$var$prependBasename({
        basename: basename,
        pathname: path.pathname
    });
    return $84c11e79798ea0cb$export$fe53371bee54353d(path);
}
function $84c11e79798ea0cb$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$84c11e79798ea0cb$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$84c11e79798ea0cb$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $84c11e79798ea0cb$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $84c11e79798ea0cb$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = rawFormMethod.toUpperCase();
    let formAction = $84c11e79798ea0cb$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$84c11e79798ea0cb$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}
`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$84c11e79798ea0cb$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $84c11e79798ea0cb$export$f5708dca728d7177(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $84c11e79798ea0cb$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $84c11e79798ea0cb$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $84c11e79798ea0cb$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $84c11e79798ea0cb$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($84c11e79798ea0cb$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = $84c11e79798ea0cb$export$8ccf933b0513f8d0(path);
    if (isFetcher && parsedPath.search && $84c11e79798ea0cb$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: $84c11e79798ea0cb$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
function $84c11e79798ea0cb$var$getMatchesToLoad(request, scopedContext, mapRouteProperties2, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $84c11e79798ea0cb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $84c11e79798ea0cb$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = $84c11e79798ea0cb$var$getRoutePattern(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$84c11e79798ea0cb$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) forceShouldLoad = $84c11e79798ea0cb$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        else if ($84c11e79798ea0cb$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $84c11e79798ea0cb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($84c11e79798ea0cb$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        let shouldLoad = $84c11e79798ea0cb$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        return $84c11e79798ea0cb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key)) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = $84c11e79798ea0cb$export$2708184779ceb39d(routesToUse, f.path, basename);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $84c11e79798ea0cb$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $84c11e79798ea0cb$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($84c11e79798ea0cb$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, fetchRequest, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $84c11e79798ea0cb$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $84c11e79798ea0cb$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    if (route.lazy) return true;
    if (!$84c11e79798ea0cb$var$routeHasLoaderOrMiddleware(route)) return false;
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return false;
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    return !hasData && !hasError;
}
function $84c11e79798ea0cb$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $84c11e79798ea0cb$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $84c11e79798ea0cb$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $84c11e79798ea0cb$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties2, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $84c11e79798ea0cb$export$f5708dca728d7177(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute2)=>$84c11e79798ea0cb$var$isSameRoute(newRoute, existingRoute2));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = $84c11e79798ea0cb$export$87cb1a9238dc3fba(uniqueChildren, mapRouteProperties2, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = $84c11e79798ea0cb$export$87cb1a9238dc3fba([
            newRoute
        ], mapRouteProperties2, [], // Doesn't matter for mutated routes since they already have an id
        {}, // Don't touch the manifest here since we're updating in place
        true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
}
function $84c11e79798ea0cb$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children.every((aChild, i)=>existingRoute.children?.some((bChild)=>$84c11e79798ea0cb$var$isSameRoute(aChild, bChild)));
}
var $84c11e79798ea0cb$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $84c11e79798ea0cb$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties2 })=>{
    let routeToUpdate = manifest[route.id];
    $84c11e79798ea0cb$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $84c11e79798ea0cb$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $84c11e79798ea0cb$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = $84c11e79798ea0cb$var$isUnsupportedLazyRouteObjectKey(key);
        let staticRouteValue = routeToUpdate[key];
        let isStaticallyDefined = staticRouteValue !== void 0 && key !== "hasErrorBoundary";
        if (isUnsupported) {
            $84c11e79798ea0cb$var$warning(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) $84c11e79798ea0cb$var$warning(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties2(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $84c11e79798ea0cb$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
function $84c11e79798ea0cb$var$loadLazyRoute(route, type, manifest, mapRouteProperties2, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    $84c11e79798ea0cb$export$f5708dca728d7177(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $84c11e79798ea0cb$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise2 = (async ()=>{
            $84c11e79798ea0cb$export$f5708dca728d7177(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = $84c11e79798ea0cb$var$isUnsupportedLazyRouteFunctionKey(lazyRouteProperty);
                let staticRouteValue = routeToUpdate[lazyRouteProperty];
                let isStaticallyDefined = staticRouteValue !== void 0 && // This property isn't static since it should always be updated based
                // on the route updates
                lazyRouteProperty !== "hasErrorBoundary";
                if (isUnsupported) $84c11e79798ea0cb$var$warning(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) $84c11e79798ea0cb$var$warning(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                // To keep things framework agnostic, we use the provided `mapRouteProperties`
                // function to set the framework-aware properties (`element`/`hasErrorBoundary`)
                // since the logic will differ between frameworks.
                ...mapRouteProperties2(routeToUpdate),
                lazy: void 0
            });
        })();
        $84c11e79798ea0cb$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise2);
        lazyRoutePromise2.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise2,
            lazyHandlerPromise: lazyRoutePromise2
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $84c11e79798ea0cb$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $84c11e79798ea0cb$var$isNonNullable(value) {
    return value !== void 0;
}
function $84c11e79798ea0cb$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties2) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return void 0;
        return $84c11e79798ea0cb$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties2
        });
    }).filter($84c11e79798ea0cb$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $84c11e79798ea0cb$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    results.forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $84c11e79798ea0cb$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $84c11e79798ea0cb$var$defaultDataStrategy(args);
    return $84c11e79798ea0cb$var$runClientMiddlewarePipeline(args, ()=>$84c11e79798ea0cb$var$defaultDataStrategy(args));
}
function $84c11e79798ea0cb$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $84c11e79798ea0cb$var$runMiddlewarePipeline(args, handler, processResult, $84c11e79798ea0cb$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $84c11e79798ea0cb$export$e0163cfdf7bc9cfa(result) ? $84c11e79798ea0cb$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $84c11e79798ea0cb$var$runClientMiddlewarePipeline(args, handler) {
    return $84c11e79798ea0cb$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($84c11e79798ea0cb$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $84c11e79798ea0cb$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Promise.resolve(Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        }));
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(// Throwing route
            Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), // or the shallowest route that needs to load data
            Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let boundaryRouteId = $84c11e79798ea0cb$var$findNearestBoundary(matches, matches[maxBoundaryIdx].route.id).route.id;
            return Promise.resolve({
                [boundaryRouteId]: {
                    type: "error",
                    result: error
                }
            });
        }
    }
}
async function $84c11e79798ea0cb$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, request: request, params: params, context: context, unstable_pattern: unstable_pattern } = args;
    let tuples = matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []);
    let result = await $84c11e79798ea0cb$var$callRouteMiddleware({
        request: request,
        params: params,
        context: context,
        unstable_pattern: unstable_pattern
    }, tuples, handler, processResult, isResult, errorHandler);
    return result;
}
async function $84c11e79798ea0cb$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) {
        let result = await handler();
        return result;
    }
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            let result = await $84c11e79798ea0cb$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1);
            nextResult = {
                value: result
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        let response = await errorHandler(error, routeId, nextResult);
        return response;
    }
}
function $84c11e79798ea0cb$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $84c11e79798ea0cb$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties2
    });
    let lazyRoutePromises = $84c11e79798ea0cb$var$loadLazyRoute(match.route, $84c11e79798ea0cb$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties2, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $84c11e79798ea0cb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, unstable_pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $84c11e79798ea0cb$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $84c11e79798ea0cb$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $84c11e79798ea0cb$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $84c11e79798ea0cb$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$84c11e79798ea0cb$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($84c11e79798ea0cb$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $84c11e79798ea0cb$var$callLoaderOrAction({
                request: request,
                unstable_pattern: unstable_pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data" /* data */ ,
                result: void 0
            });
        }
    };
}
function $84c11e79798ea0cb$var$getTargetedDataStrategyMatches(mapRouteProperties2, manifest, request, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $84c11e79798ea0cb$var$getDataStrategyMatchLazyPromises(mapRouteProperties2, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $84c11e79798ea0cb$var$getDataStrategyMatch(mapRouteProperties2, manifest, request, $84c11e79798ea0cb$var$getRoutePattern(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $84c11e79798ea0cb$var$callDataStrategyImpl(dataStrategyImpl, request, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        unstable_pattern: $84c11e79798ea0cb$var$getRoutePattern(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $84c11e79798ea0cb$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch (e) {}
    return results;
}
async function $84c11e79798ea0cb$var$callLoaderOrAction({ request: request, unstable_pattern: unstable_pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $84c11e79798ea0cb$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                unstable_pattern: unstable_pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    // Ensure all lazy route promises are resolved before continuing
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler2 = isAction ? match.route.action : match.route.loader;
                if (handler2) [result] = await Promise.all([
                    runHandler(handler2),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $84c11e79798ea0cb$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data" /* data */ ,
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $84c11e79798ea0cb$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error" /* error */ ,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $84c11e79798ea0cb$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $84c11e79798ea0cb$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result)) {
        let data2;
        try {
            data2 = await $84c11e79798ea0cb$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error" /* error */ ,
                error: e
            };
        }
        if (type === "error" /* error */ ) return {
            type: "error" /* error */ ,
            error: new $84c11e79798ea0cb$export$f2680fa305b734ca(result.status, result.statusText, data2),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data" /* data */ ,
            data: data2,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error" /* error */ ) {
        if ($84c11e79798ea0cb$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error" /* error */ ,
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error" /* error */ ,
                error: $84c11e79798ea0cb$var$dataWithResponseInitToErrorResponse(result),
                statusCode: $84c11e79798ea0cb$export$972111febbeef05b(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error" /* error */ ,
            error: result,
            statusCode: $84c11e79798ea0cb$export$972111febbeef05b(result) ? result.status : void 0
        };
    }
    if ($84c11e79798ea0cb$export$e0163cfdf7bc9cfa(result)) return {
        type: "data" /* data */ ,
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data" /* data */ ,
        data: result
    };
}
function $84c11e79798ea0cb$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    $84c11e79798ea0cb$export$f5708dca728d7177(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$84c11e79798ea0cb$var$isAbsoluteUrl(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $84c11e79798ea0cb$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
function $84c11e79798ea0cb$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($84c11e79798ea0cb$var$isAbsoluteUrl(location)) {
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $84c11e79798ea0cb$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $84c11e79798ea0cb$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($84c11e79798ea0cb$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $84c11e79798ea0cb$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $84c11e79798ea0cb$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $84c11e79798ea0cb$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $84c11e79798ea0cb$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $84c11e79798ea0cb$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $84c11e79798ea0cb$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $84c11e79798ea0cb$export$f5708dca728d7177(!$84c11e79798ea0cb$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($84c11e79798ea0cb$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $84c11e79798ea0cb$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $84c11e79798ea0cb$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = $84c11e79798ea0cb$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $84c11e79798ea0cb$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults) {
    let { loaderData: loaderData, errors: errors } = $84c11e79798ea0cb$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        $84c11e79798ea0cb$export$f5708dca728d7177(result, "Did not find corresponding fetcher result");
        if ($84c11e79798ea0cb$var$isErrorResult(result)) {
            let boundaryMatch = $84c11e79798ea0cb$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            state.fetchers.delete(key);
        } else if ($84c11e79798ea0cb$var$isRedirectResult(result)) $84c11e79798ea0cb$export$f5708dca728d7177(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $84c11e79798ea0cb$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $84c11e79798ea0cb$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $84c11e79798ea0cb$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $84c11e79798ea0cb$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $84c11e79798ea0cb$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $84c11e79798ea0cb$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $84c11e79798ea0cb$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $84c11e79798ea0cb$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new $84c11e79798ea0cb$export$f2680fa305b734ca(status || 500, statusText, new Error(errorMessage), true);
}
function $84c11e79798ea0cb$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($84c11e79798ea0cb$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $84c11e79798ea0cb$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $84c11e79798ea0cb$export$8ccf933b0513f8d0(path) : path;
    return $84c11e79798ea0cb$export$fe53371bee54353d({
        ...parsedPath,
        hash: ""
    });
}
function $84c11e79798ea0cb$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $84c11e79798ea0cb$var$dataWithResponseInitToResponse(data2) {
    return Response.json(data2.data, data2.init ?? void 0);
}
function $84c11e79798ea0cb$var$dataWithResponseInitToErrorResponse(data2) {
    return new $84c11e79798ea0cb$export$f2680fa305b734ca(data2.init?.status ?? 500, data2.init?.statusText ?? "Internal Server Error", data2.data);
}
function $84c11e79798ea0cb$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $84c11e79798ea0cb$var$isDataStrategyResult(value));
}
function $84c11e79798ea0cb$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" /* data */  || result.type === "error" /* error */ );
}
function $84c11e79798ea0cb$var$isRedirectDataStrategyResult(result) {
    return $84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result.result) && $84c11e79798ea0cb$var$redirectStatusCodes.has(result.result.status);
}
function $84c11e79798ea0cb$var$isErrorResult(result) {
    return result.type === "error" /* error */ ;
}
function $84c11e79798ea0cb$var$isRedirectResult(result) {
    return (result && result.type) === "redirect" /* redirect */ ;
}
function $84c11e79798ea0cb$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $84c11e79798ea0cb$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $84c11e79798ea0cb$export$794b2760043cf8cd(statusCode) {
    return $84c11e79798ea0cb$var$redirectStatusCodes.has(statusCode);
}
function $84c11e79798ea0cb$export$6e80290866a84dd4(result) {
    return $84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result) && $84c11e79798ea0cb$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $84c11e79798ea0cb$var$isValidMethod(method) {
    return $84c11e79798ea0cb$var$validRequestMethods.has(method.toUpperCase());
}
function $84c11e79798ea0cb$export$cbae47800eb95bc3(method) {
    return $84c11e79798ea0cb$var$validMutationMethods.has(method.toUpperCase());
}
function $84c11e79798ea0cb$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $84c11e79798ea0cb$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $84c11e79798ea0cb$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $84c11e79798ea0cb$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = $84c11e79798ea0cb$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $84c11e79798ea0cb$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $84c11e79798ea0cb$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0
        };
        return navigation;
    }
}
function $84c11e79798ea0cb$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $84c11e79798ea0cb$var$getLoadingFetcher(submission, data2) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data2
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: void 0,
            formAction: void 0,
            formEncType: void 0,
            formData: void 0,
            json: void 0,
            text: void 0,
            data: data2
        };
        return fetcher;
    }
}
function $84c11e79798ea0cb$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
    return fetcher;
}
function $84c11e79798ea0cb$var$getDoneFetcher(data2) {
    let fetcher = {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data2
    };
    return fetcher;
}
function $84c11e79798ea0cb$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($84c11e79798ea0cb$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {}
}
function $84c11e79798ea0cb$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($84c11e79798ea0cb$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $84c11e79798ea0cb$var$warning(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $84c11e79798ea0cb$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
var $84c11e79798ea0cb$export$2eeee58951ff3c1c = $acw62.createContext(null);
$84c11e79798ea0cb$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $84c11e79798ea0cb$export$315e3ffb01f217 = $acw62.createContext(null);
$84c11e79798ea0cb$export$315e3ffb01f217.displayName = "DataRouterState";
var $84c11e79798ea0cb$export$717f757c655223f1 = $acw62.createContext(false);
function $84c11e79798ea0cb$var$useIsRSCRouterContext() {
    return $acw62.useContext($84c11e79798ea0cb$export$717f757c655223f1);
}
var $84c11e79798ea0cb$export$3681f408decb40d1 = $acw62.createContext({
    isTransitioning: false
});
$84c11e79798ea0cb$export$3681f408decb40d1.displayName = "ViewTransition";
var $84c11e79798ea0cb$export$cb3f1df1bef00a39 = $acw62.createContext(/* @__PURE__ */ new Map());
$84c11e79798ea0cb$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $84c11e79798ea0cb$var$AwaitContext = $acw62.createContext(null);
$84c11e79798ea0cb$var$AwaitContext.displayName = "Await";
var $84c11e79798ea0cb$export$2666c20e15407622 = (props)=>$acw62.createElement($84c11e79798ea0cb$var$AwaitContext.Provider, props);
var $84c11e79798ea0cb$export$3044ab7fdabeaee6 = $acw62.createContext(null);
$84c11e79798ea0cb$export$3044ab7fdabeaee6.displayName = "Navigation";
var $84c11e79798ea0cb$export$e6a44b110a0c44d3 = $acw62.createContext(null);
$84c11e79798ea0cb$export$e6a44b110a0c44d3.displayName = "Location";
var $84c11e79798ea0cb$export$aac280ed165a4397 = $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$84c11e79798ea0cb$export$aac280ed165a4397.displayName = "Route";
var $84c11e79798ea0cb$var$RouteErrorContext = $acw62.createContext(null);
$84c11e79798ea0cb$var$RouteErrorContext.displayName = "RouteError";
var $84c11e79798ea0cb$export$945fecf35a8ef089 = true;
// lib/errors.ts
var $84c11e79798ea0cb$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $84c11e79798ea0cb$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $84c11e79798ea0cb$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $84c11e79798ea0cb$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$84c11e79798ea0cb$var$ERROR_DIGEST_BASE}:${$84c11e79798ea0cb$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $84c11e79798ea0cb$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$84c11e79798ea0cb$var$ERROR_DIGEST_BASE}:${$84c11e79798ea0cb$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new $84c11e79798ea0cb$export$f2680fa305b734ca(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}
// lib/hooks.tsx
function $84c11e79798ea0cb$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    $84c11e79798ea0cb$export$f5708dca728d7177($84c11e79798ea0cb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let { hash: hash, pathname: pathname, search: search } = $84c11e79798ea0cb$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : $84c11e79798ea0cb$var$joinPaths([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
function $84c11e79798ea0cb$export$9c954a9d03d32f4a() {
    return $acw62.useContext($84c11e79798ea0cb$export$e6a44b110a0c44d3) != null;
}
function $84c11e79798ea0cb$export$45d76561a5302f2b() {
    $84c11e79798ea0cb$export$f5708dca728d7177($84c11e79798ea0cb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useLocation() may be used only in the context of a <Router> component.`);
    return $acw62.useContext($84c11e79798ea0cb$export$e6a44b110a0c44d3).location;
}
function $84c11e79798ea0cb$export$1b3f31771c5d07c() {
    return $acw62.useContext($84c11e79798ea0cb$export$e6a44b110a0c44d3).navigationType;
}
function $84c11e79798ea0cb$export$6c330e8992e8a295(pattern) {
    $84c11e79798ea0cb$export$f5708dca728d7177($84c11e79798ea0cb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $84c11e79798ea0cb$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>$84c11e79798ea0cb$export$81336c211d5ff295(pattern, $84c11e79798ea0cb$var$decodePath(pathname)), [
        pathname,
        pattern
    ]);
}
var $84c11e79798ea0cb$var$navigateEffectWarning = `You should call navigate() in a React.useEffect(), not when your component is first rendered.`;
function $84c11e79798ea0cb$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6).static;
    if (!isStatic) $acw62.useLayoutEffect(cb);
}
function $84c11e79798ea0cb$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    return isDataRoute ? $84c11e79798ea0cb$var$useNavigateStable() : $84c11e79798ea0cb$var$useNavigateUnstable();
}
function $84c11e79798ea0cb$var$useNavigateUnstable() {
    $84c11e79798ea0cb$export$f5708dca728d7177($84c11e79798ea0cb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $acw62.useContext($84c11e79798ea0cb$export$2eeee58951ff3c1c);
    let { basename: basename, navigator: navigator } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let { matches: matches } = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    let { pathname: locationPathname } = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($84c11e79798ea0cb$var$getResolveToMatches(matches));
    let activeRef = $acw62.useRef(false);
    $84c11e79798ea0cb$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback((to, options = {})=>{
        $84c11e79798ea0cb$var$warning(activeRef.current, $84c11e79798ea0cb$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = $84c11e79798ea0cb$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : $84c11e79798ea0cb$var$joinPaths([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var $84c11e79798ea0cb$var$OutletContext = $acw62.createContext(null);
function $84c11e79798ea0cb$export$4138103a3ae699cc() {
    return $acw62.useContext($84c11e79798ea0cb$var$OutletContext);
}
function $84c11e79798ea0cb$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397).outlet;
    return $acw62.useMemo(()=>outlet && /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
function $84c11e79798ea0cb$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
function $84c11e79798ea0cb$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    let { pathname: locationPathname } = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify($84c11e79798ea0cb$var$getResolveToMatches(matches));
    return $acw62.useMemo(()=>$84c11e79798ea0cb$var$resolveTo(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
function $84c11e79798ea0cb$export$5d3fca4a98652595(routes, locationArg) {
    return $84c11e79798ea0cb$var$useRoutesImpl(routes, locationArg);
}
function $84c11e79798ea0cb$var$useRoutesImpl(routes, locationArg, dataRouterState, onError, future) {
    $84c11e79798ea0cb$export$f5708dca728d7177($84c11e79798ea0cb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let { matches: parentMatches } = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    if ($84c11e79798ea0cb$export$945fecf35a8ef089) {
        let parentPath = parentRoute && parentRoute.path || "";
        $84c11e79798ea0cb$var$warningOnce(parentPathname, !parentRoute || parentPath.endsWith("*") || parentPath.endsWith("*?"), `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${parentPathname}" (under <Route path="${parentPath}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${parentPath}"> to <Route path="${parentPath === "/" ? "*" : `${parentPath}/*`}">.`);
    }
    let locationFromContext = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? $84c11e79798ea0cb$export$8ccf933b0513f8d0(locationArg) : locationArg;
        $84c11e79798ea0cb$export$f5708dca728d7177(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = $84c11e79798ea0cb$export$2708184779ceb39d(routes, {
        pathname: remainingPathname
    });
    if ($84c11e79798ea0cb$export$945fecf35a8ef089) {
        $84c11e79798ea0cb$var$warning(parentRoute || matches != null, `No routes matched location "${location.pathname}${location.search}${location.hash}" `);
        $84c11e79798ea0cb$var$warning(matches == null || matches[matches.length - 1].route.element !== void 0 || matches[matches.length - 1].route.Component !== void 0 || matches[matches.length - 1].route.lazy !== void 0, `Matched leaf route at location "${location.pathname}${location.search}${location.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`);
    }
    let renderedMatches = $84c11e79798ea0cb$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: $84c11e79798ea0cb$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes.
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : $84c11e79798ea0cb$var$joinPaths([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
                // `new URL()` internally and we need to prevent it from treating
                // them as separators
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, onError, future);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$e6a44b110a0c44d3.Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                ...location
            },
            navigationType: "POP" /* Pop */ 
        }
    }, renderedMatches);
    return renderedMatches;
}
function $84c11e79798ea0cb$var$DefaultErrorComponent() {
    let error = $84c11e79798ea0cb$export$ed527bf60f6e05f2();
    let message = $84c11e79798ea0cb$export$972111febbeef05b(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    if ($84c11e79798ea0cb$export$945fecf35a8ef089) {
        console.error("Error handled by React Router default ErrorBoundary:", error);
        devInfo = /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("p", null, "\uD83D\uDCBF Hey developer \uD83D\uDC4B"), /* @__PURE__ */ $acw62.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ $acw62.createElement("code", {
            style: codeStyles
        }, "errorElement"), " prop on your route."));
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var $84c11e79798ea0cb$var$defaultErrorElement = /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$DefaultErrorComponent, null);
var $84c11e79798ea0cb$var$RenderErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = $84c11e79798ea0cb$export$2b5950305b3e7eaf(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$aac280ed165a4397.Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$RouteErrorContext.Provider, {
            value: error,
            children: this.props.component
        })) : this.props.children;
        if (this.context) return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
};
$84c11e79798ea0cb$var$RenderErrorBoundary.contextType = $84c11e79798ea0cb$export$717f757c655223f1;
var $84c11e79798ea0cb$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $84c11e79798ea0cb$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect2 = $84c11e79798ea0cb$export$30db792b333fd2ee(error.digest);
        if (redirect2) {
            let existingRedirect = $84c11e79798ea0cb$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = $84c11e79798ea0cb$var$parseToInfo(redirect2.location, basename);
            if ($84c11e79798ea0cb$var$isBrowser && !$84c11e79798ea0cb$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect2.reloadDocument) window.location.href = parsed.absoluteURL || parsed.to;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect2.replace
                        }));
                    $84c11e79798ea0cb$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $acw62.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${parsed.absoluteURL || parsed.to}`
            });
        }
    }
    return children;
}
function $84c11e79798ea0cb$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $acw62.useContext($84c11e79798ea0cb$export$2eeee58951ff3c1c);
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$aac280ed165a4397.Provider, {
        value: routeContext
    }, children);
}
function $84c11e79798ea0cb$var$_renderMatches(matches, parentMatches = [], dataRouterState = null, onErrorHandler = null, future = null) {
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        $84c11e79798ea0cb$export$f5708dca728d7177(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors2 } = dataRouterState;
            let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors2 || errors2[match.route.id] === void 0);
            if (match.route.lazy || needsToRunLoader) {
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            unstable_pattern: $84c11e79798ea0cb$var$getRoutePattern(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $84c11e79798ea0cb$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $84c11e79798ea0cb$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches2 = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches2,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches2,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $84c11e79798ea0cb$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $84c11e79798ea0cb$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($84c11e79798ea0cb$export$2eeee58951ff3c1c);
    $84c11e79798ea0cb$export$f5708dca728d7177(ctx, $84c11e79798ea0cb$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $84c11e79798ea0cb$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($84c11e79798ea0cb$export$315e3ffb01f217);
    $84c11e79798ea0cb$export$f5708dca728d7177(state, $84c11e79798ea0cb$var$getDataRouterConsoleError(hookName));
    return state;
}
function $84c11e79798ea0cb$var$useRouteContext(hookName) {
    let route = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    $84c11e79798ea0cb$export$f5708dca728d7177(route, $84c11e79798ea0cb$var$getDataRouterConsoleError(hookName));
    return route;
}
function $84c11e79798ea0cb$var$useCurrentRouteId(hookName) {
    let route = $84c11e79798ea0cb$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    $84c11e79798ea0cb$export$f5708dca728d7177(thisRoute.route.id, `${hookName} can only be used on routes that contain a unique "id"`);
    return thisRoute.route.id;
}
function $84c11e79798ea0cb$var$useRouteId() {
    return $84c11e79798ea0cb$var$useCurrentRouteId("useRouteId" /* UseRouteId */ );
}
function $84c11e79798ea0cb$export$d0fd4b7106de2769() {
    let state = $84c11e79798ea0cb$var$useDataRouterState("useNavigation" /* UseNavigation */ );
    return state.navigation;
}
function $84c11e79798ea0cb$export$600dc272ed516c15() {
    let dataRouterContext = $84c11e79798ea0cb$var$useDataRouterContext("useRevalidator" /* UseRevalidator */ );
    let state = $84c11e79798ea0cb$var$useDataRouterState("useRevalidator" /* UseRevalidator */ );
    let revalidate = $acw62.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $acw62.useMemo(()=>({
            revalidate: revalidate,
            state: state.revalidation
        }), [
        revalidate,
        state.revalidation
    ]);
}
function $84c11e79798ea0cb$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $84c11e79798ea0cb$var$useDataRouterState("useMatches" /* UseMatches */ );
    return $acw62.useMemo(()=>matches.map((m)=>$84c11e79798ea0cb$var$convertRouteMatchToUiMatch(m, loaderData)), [
        matches,
        loaderData
    ]);
}
function $84c11e79798ea0cb$export$1448a5050d252c4d() {
    let state = $84c11e79798ea0cb$var$useDataRouterState("useLoaderData" /* UseLoaderData */ );
    let routeId = $84c11e79798ea0cb$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.loaderData[routeId];
}
function $84c11e79798ea0cb$export$fd5d37484eab868d(routeId) {
    let state = $84c11e79798ea0cb$var$useDataRouterState("useRouteLoaderData" /* UseRouteLoaderData */ );
    return state.loaderData[routeId];
}
function $84c11e79798ea0cb$export$fdc00f3f26066d5e() {
    let state = $84c11e79798ea0cb$var$useDataRouterState("useActionData" /* UseActionData */ );
    let routeId = $84c11e79798ea0cb$var$useCurrentRouteId("useLoaderData" /* UseLoaderData */ );
    return state.actionData ? state.actionData[routeId] : void 0;
}
function $84c11e79798ea0cb$export$ed527bf60f6e05f2() {
    let error = $acw62.useContext($84c11e79798ea0cb$var$RouteErrorContext);
    let state = $84c11e79798ea0cb$var$useDataRouterState("useRouteError" /* UseRouteError */ );
    let routeId = $84c11e79798ea0cb$var$useCurrentRouteId("useRouteError" /* UseRouteError */ );
    if (error !== void 0) return error;
    return state.errors?.[routeId];
}
function $84c11e79798ea0cb$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($84c11e79798ea0cb$var$AwaitContext);
    return value?._data;
}
function $84c11e79798ea0cb$export$17f53340677d5831() {
    let value = $acw62.useContext($84c11e79798ea0cb$var$AwaitContext);
    return value?._error;
}
var $84c11e79798ea0cb$var$blockerId = 0;
function $84c11e79798ea0cb$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $84c11e79798ea0cb$var$useDataRouterContext("useBlocker" /* UseBlocker */ );
    let state = $84c11e79798ea0cb$var$useDataRouterState("useBlocker" /* UseBlocker */ );
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: $84c11e79798ea0cb$export$b69e3301ce081aa3(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: $84c11e79798ea0cb$export$b69e3301ce081aa3(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $acw62.useEffect(()=>{
        let key = String(++$84c11e79798ea0cb$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : $84c11e79798ea0cb$export$386d57f03f0b2883;
}
function $84c11e79798ea0cb$var$useNavigateStable() {
    let { router: router } = $84c11e79798ea0cb$var$useDataRouterContext("useNavigate" /* UseNavigateStable */ );
    let id = $84c11e79798ea0cb$var$useCurrentRouteId("useNavigate" /* UseNavigateStable */ );
    let activeRef = $acw62.useRef(false);
    $84c11e79798ea0cb$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(async (to, options = {})=>{
        $84c11e79798ea0cb$var$warning(activeRef.current, $84c11e79798ea0cb$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
    return navigate;
}
var $84c11e79798ea0cb$var$alreadyWarned = {};
function $84c11e79798ea0cb$var$warningOnce(key, cond, message) {
    if (!cond && !$84c11e79798ea0cb$var$alreadyWarned[key]) {
        $84c11e79798ea0cb$var$alreadyWarned[key] = true;
        $84c11e79798ea0cb$var$warning(false, message);
    }
}
function $84c11e79798ea0cb$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $84c11e79798ea0cb$var$useCurrentRouteId("useRoute" /* UseRoute */ );
    const id = args[0] ?? currentRouteId;
    const state = $84c11e79798ea0cb$var$useDataRouterState("useRoute" /* UseRoute */ );
    const route = state.matches.find(({ route: route2 })=>route2.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: state.actionData?.[id]
    };
}
// lib/server-runtime/warnings.ts
var $84c11e79798ea0cb$var$alreadyWarned2 = {};
function $84c11e79798ea0cb$export$5b28268982f175ba(condition, message) {
    if (!condition && !$84c11e79798ea0cb$var$alreadyWarned2[message]) {
        $84c11e79798ea0cb$var$alreadyWarned2[message] = true;
        console.warn(message);
    }
}
// lib/components.tsx
var $84c11e79798ea0cb$var$USE_OPTIMISTIC = "useOptimistic";
var $84c11e79798ea0cb$var$useOptimisticImpl = $acw62[$84c11e79798ea0cb$var$USE_OPTIMISTIC];
var $84c11e79798ea0cb$var$stableUseOptimisticSetter = ()=>void 0;
function $84c11e79798ea0cb$var$useOptimisticSafe(val) {
    if ($84c11e79798ea0cb$var$useOptimisticImpl) return $84c11e79798ea0cb$var$useOptimisticImpl(val);
    else return [
        val,
        $84c11e79798ea0cb$var$stableUseOptimisticSetter
    ];
}
function $84c11e79798ea0cb$export$9269a41d8c4635e(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.hasErrorBoundary || route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) {
        if ($84c11e79798ea0cb$export$945fecf35a8ef089) {
            if (route.element) $84c11e79798ea0cb$var$warning(false, "You should not include both `Component` and `element` on your route - `Component` will be used.");
        }
        Object.assign(updates, {
            element: $acw62.createElement(route.Component),
            Component: void 0
        });
    }
    if (route.HydrateFallback) {
        if ($84c11e79798ea0cb$export$945fecf35a8ef089) {
            if (route.hydrateFallbackElement) $84c11e79798ea0cb$var$warning(false, "You should not include both `HydrateFallback` and `hydrateFallbackElement` on your route - `HydrateFallback` will be used.");
        }
        Object.assign(updates, {
            hydrateFallbackElement: $acw62.createElement(route.HydrateFallback),
            HydrateFallback: void 0
        });
    }
    if (route.ErrorBoundary) {
        if ($84c11e79798ea0cb$export$945fecf35a8ef089) {
            if (route.errorElement) $84c11e79798ea0cb$var$warning(false, "You should not include both `ErrorBoundary` and `errorElement` on your route - `ErrorBoundary` will be used.");
        }
        Object.assign(updates, {
            errorElement: $acw62.createElement(route.ErrorBoundary),
            ErrorBoundary: void 0
        });
    }
    return updates;
}
var $84c11e79798ea0cb$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
function $84c11e79798ea0cb$export$f30f7e456d254e83(routes, opts) {
    return $84c11e79798ea0cb$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $84c11e79798ea0cb$export$2b76ad033c6e6d08({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        hydrationRouteProperties: $84c11e79798ea0cb$export$e2fd2c03906469db,
        mapRouteProperties: $84c11e79798ea0cb$export$9269a41d8c4635e,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
var $84c11e79798ea0cb$var$Deferred = class {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
function $84c11e79798ea0cb$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, unstable_useTransitions: unstable_useTransitions }) {
    let unstable_rsc = $84c11e79798ea0cb$var$useIsRSCRouterContext();
    unstable_useTransitions = unstable_rsc || unstable_useTransitions;
    let [_state, setStateImpl] = $acw62.useState(router.state);
    let [state, setOptimisticState] = $84c11e79798ea0cb$var$useOptimisticSafe(_state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(/* @__PURE__ */ new Map());
    let setState = $acw62.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                unstable_pattern: $84c11e79798ea0cb$var$getRoutePattern(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        $84c11e79798ea0cb$export$5b28268982f175ba(flushSync === false || reactDomFlushSyncImpl != null, 'You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from "react-router/dom"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.');
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        $84c11e79798ea0cb$export$5b28268982f175ba(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (unstable_useTransitions === false) setStateImpl(newState);
            else $acw62.startTransition(()=>{
                if (unstable_useTransitions === true) setOptimisticState((s)=>$84c11e79798ea0cb$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        unstable_useTransitions,
        setOptimisticState,
        onError
    ]);
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $84c11e79798ea0cb$var$Deferred());
    }, [
        vtContext
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition2 = router.window.document.startViewTransition(async ()=>{
                if (unstable_useTransitions === false) setStateImpl(newState);
                else $acw62.startTransition(()=>{
                    if (unstable_useTransitions === true) setOptimisticState((s)=>$84c11e79798ea0cb$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition2.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition2);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        unstable_useTransitions,
        setOptimisticState
    ]);
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state2, opts)=>router.navigate(to, {
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state2, opts)=>router.navigate(to, {
                    replace: true,
                    state: state2,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$cb3f1df1bef00a39.Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$3681f408decb40d1.Provider, {
        value: vtContext
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        unstable_useTransitions: unstable_useTransitions
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state,
        onError: onError
    })))))), null);
}
function $84c11e79798ea0cb$var$getOptimisticRouterState(currentState, newState) {
    return {
        // Don't surface "current location specific" stuff mid-navigation
        // (historyAction, location, matches, loaderData, errors, initialized,
        // restoreScroll, preventScrollReset, blockers, etc.)
        ...currentState,
        // Only surface "pending/in-flight stuff"
        // (navigation, revalidation, actionData, fetchers, )
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
var $84c11e79798ea0cb$var$MemoizedDataRoutes = $acw62.memo($84c11e79798ea0cb$var$DataRoutes);
function $84c11e79798ea0cb$var$DataRoutes({ routes: routes, future: future, state: state, onError: onError }) {
    return $84c11e79798ea0cb$var$useRoutesImpl(routes, void 0, state, onError, future);
}
function $84c11e79798ea0cb$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, unstable_useTransitions: unstable_useTransitions }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $84c11e79798ea0cb$export$2b76ad033c6e6d08({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $84c11e79798ea0cb$export$444b3ab0cb9aec40({ to: to, replace: replace2, state: state, relative: relative }) {
    $84c11e79798ea0cb$export$f5708dca728d7177($84c11e79798ea0cb$export$9c954a9d03d32f4a(), // TODO: This error is probably because they somehow have 2 versions of
    // the router loaded. We can help them understand how to avoid that.
    `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    $84c11e79798ea0cb$var$warning(!isStatic, `<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.`);
    let { matches: matches } = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    let { pathname: locationPathname } = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let navigate = $84c11e79798ea0cb$export$9770f232ac06a008();
    let path = $84c11e79798ea0cb$var$resolveTo(to, $84c11e79798ea0cb$var$getResolveToMatches(matches), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace2,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace2,
        state
    ]);
    return null;
}
function $84c11e79798ea0cb$export$910ae8079b2c2852(props) {
    return $84c11e79798ea0cb$export$a3be3530d8e40d0b(props.context);
}
function $84c11e79798ea0cb$export$e7b0ac011bb776c6(props) {
    $84c11e79798ea0cb$export$f5708dca728d7177(false, `A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.`);
}
function $84c11e79798ea0cb$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP" /* Pop */ , navigator: navigator, static: staticProp = false, unstable_useTransitions: unstable_useTransitions }) {
    $84c11e79798ea0cb$export$f5708dca728d7177(!$84c11e79798ea0cb$export$9c954a9d03d32f4a(), `You cannot render a <Router> inside another <Router>. You should never have more than one in your app.`);
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            unstable_useTransitions: unstable_useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        unstable_useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = $84c11e79798ea0cb$export$8ccf933b0513f8d0(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = $84c11e79798ea0cb$export$b69e3301ce081aa3(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    $84c11e79798ea0cb$var$warning(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$3044ab7fdabeaee6.Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$e6a44b110a0c44d3.Provider, {
        children: children,
        value: locationContext
    }));
}
function $84c11e79798ea0cb$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return $84c11e79798ea0cb$export$5d3fca4a98652595($84c11e79798ea0cb$export$16da398f5434bdec(children), location);
}
function $84c11e79798ea0cb$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $acw62.useContext($84c11e79798ea0cb$export$2eeee58951ff3c1c);
    let dataRouterStateContext = $acw62.useContext($84c11e79798ea0cb$export$315e3ffb01f217);
    let onError = $acw62.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            unstable_pattern: $84c11e79798ea0cb$var$getRoutePattern(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$ResolveAwait, null, children));
}
var $84c11e79798ea0cb$var$AwaitErrorBoundary = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0 /* pending */ ;
        if (!(resolve instanceof Promise)) {
            status = 1 /* success */ ;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2 /* error */ ;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 /* error */  : "_data" in promise ? 1 /* success */  : 0 /* pending */ ;
        } else {
            status = 0 /* pending */ ;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data2)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data2
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 /* error */  && !errorElement) throw promise._error;
        if (status === 2 /* error */ ) return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1 /* success */ ) return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
};
function $84c11e79798ea0cb$var$ResolveAwait({ children: children }) {
    let data2 = $84c11e79798ea0cb$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data2) : children;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, toRender);
}
function $84c11e79798ea0cb$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!$acw62.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            routes.push.apply(routes, $84c11e79798ea0cb$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        $84c11e79798ea0cb$export$f5708dca728d7177(element.type === $84c11e79798ea0cb$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        $84c11e79798ea0cb$export$f5708dca728d7177(!element.props.index || !element.props.children, "An index route cannot have child routes.");
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            middleware: element.props.middleware,
            loader: element.props.loader,
            action: element.props.action,
            hydrateFallbackElement: element.props.hydrateFallbackElement,
            HydrateFallback: element.props.HydrateFallback,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.hasErrorBoundary === true || element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $84c11e79798ea0cb$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
var $84c11e79798ea0cb$export$9b5b6d122dea0c88 = $84c11e79798ea0cb$export$16da398f5434bdec;
function $84c11e79798ea0cb$export$daf73786167a7f72(matches) {
    return $84c11e79798ea0cb$var$_renderMatches(matches);
}
function $84c11e79798ea0cb$var$useRouteComponentProps() {
    return {
        params: $84c11e79798ea0cb$export$99eaa27ddbbb95ef(),
        loaderData: $84c11e79798ea0cb$export$1448a5050d252c4d(),
        actionData: $84c11e79798ea0cb$export$fdc00f3f26066d5e(),
        matches: $84c11e79798ea0cb$export$2378eb7f5ff86053()
    };
}
function $84c11e79798ea0cb$export$6c4f3826290c37af({ children: children }) {
    const props = $84c11e79798ea0cb$var$useRouteComponentProps();
    return $acw62.cloneElement(children, props);
}
function $84c11e79798ea0cb$export$1a5de91a5c3255e0(Component4) {
    return function WithComponentProps2() {
        const props = $84c11e79798ea0cb$var$useRouteComponentProps();
        return $acw62.createElement(Component4, props);
    };
}
function $84c11e79798ea0cb$var$useHydrateFallbackProps() {
    return {
        params: $84c11e79798ea0cb$export$99eaa27ddbbb95ef(),
        loaderData: $84c11e79798ea0cb$export$1448a5050d252c4d(),
        actionData: $84c11e79798ea0cb$export$fdc00f3f26066d5e()
    };
}
function $84c11e79798ea0cb$export$f8cff34f39c1932a({ children: children }) {
    const props = $84c11e79798ea0cb$var$useHydrateFallbackProps();
    return $acw62.cloneElement(children, props);
}
function $84c11e79798ea0cb$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps2() {
        const props = $84c11e79798ea0cb$var$useHydrateFallbackProps();
        return $acw62.createElement(HydrateFallback, props);
    };
}
function $84c11e79798ea0cb$var$useErrorBoundaryProps() {
    return {
        params: $84c11e79798ea0cb$export$99eaa27ddbbb95ef(),
        loaderData: $84c11e79798ea0cb$export$1448a5050d252c4d(),
        actionData: $84c11e79798ea0cb$export$fdc00f3f26066d5e(),
        error: $84c11e79798ea0cb$export$ed527bf60f6e05f2()
    };
}
function $84c11e79798ea0cb$export$e5afde5c4b6d747b({ children: children }) {
    const props = $84c11e79798ea0cb$var$useErrorBoundaryProps();
    return $acw62.cloneElement(children, props);
}
function $84c11e79798ea0cb$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps2() {
        const props = $84c11e79798ea0cb$var$useErrorBoundaryProps();
        return $acw62.createElement(ErrorBoundary, props);
    };
}
// lib/dom/dom.ts
var $84c11e79798ea0cb$var$defaultMethod = "get";
var $84c11e79798ea0cb$var$defaultEncType = "application/x-www-form-urlencoded";
function $84c11e79798ea0cb$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $84c11e79798ea0cb$var$isButtonElement(object) {
    return $84c11e79798ea0cb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $84c11e79798ea0cb$var$isFormElement(object) {
    return $84c11e79798ea0cb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $84c11e79798ea0cb$var$isInputElement(object) {
    return $84c11e79798ea0cb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $84c11e79798ea0cb$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $84c11e79798ea0cb$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$84c11e79798ea0cb$var$isModifiedEvent(event);
}
function $84c11e79798ea0cb$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo2, key)=>{
        let value = init[key];
        return memo2.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $84c11e79798ea0cb$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $84c11e79798ea0cb$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $84c11e79798ea0cb$var$_formDataSupportsSubmitter = null;
function $84c11e79798ea0cb$var$isFormDataSubmitterSupported() {
    if ($84c11e79798ea0cb$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $84c11e79798ea0cb$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $84c11e79798ea0cb$var$_formDataSupportsSubmitter = true;
    }
    return $84c11e79798ea0cb$var$_formDataSupportsSubmitter;
}
var $84c11e79798ea0cb$var$supportedFormEncTypes = /* @__PURE__ */ new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $84c11e79798ea0cb$var$getFormEncType(encType) {
    if (encType != null && !$84c11e79798ea0cb$var$supportedFormEncTypes.has(encType)) {
        $84c11e79798ea0cb$var$warning(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$84c11e79798ea0cb$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $84c11e79798ea0cb$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($84c11e79798ea0cb$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? $84c11e79798ea0cb$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("method") || $84c11e79798ea0cb$var$defaultMethod;
        encType = $84c11e79798ea0cb$var$getFormEncType(target.getAttribute("enctype")) || $84c11e79798ea0cb$var$defaultEncType;
        formData = new FormData(target);
    } else if ($84c11e79798ea0cb$var$isButtonElement(target) || $84c11e79798ea0cb$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? $84c11e79798ea0cb$export$b69e3301ce081aa3(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $84c11e79798ea0cb$var$defaultMethod;
        encType = $84c11e79798ea0cb$var$getFormEncType(target.getAttribute("formenctype")) || $84c11e79798ea0cb$var$getFormEncType(form.getAttribute("enctype")) || $84c11e79798ea0cb$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$84c11e79798ea0cb$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($84c11e79798ea0cb$var$isHtmlElement(target)) throw new Error(`Cannot submit element that is not <form>, <button>, or <input type="submit|image">`);
    else {
        method = $84c11e79798ea0cb$var$defaultMethod;
        action = null;
        encType = $84c11e79798ea0cb$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
// vendor/turbo-stream-v2/utils.ts
var $84c11e79798ea0cb$var$HOLE = -1;
var $84c11e79798ea0cb$var$NAN = -2;
var $84c11e79798ea0cb$var$NEGATIVE_INFINITY = -3;
var $84c11e79798ea0cb$var$NEGATIVE_ZERO = -4;
var $84c11e79798ea0cb$var$NULL = -5;
var $84c11e79798ea0cb$var$POSITIVE_INFINITY = -6;
var $84c11e79798ea0cb$var$UNDEFINED = -7;
var $84c11e79798ea0cb$var$TYPE_BIGINT = "B";
var $84c11e79798ea0cb$var$TYPE_DATE = "D";
var $84c11e79798ea0cb$var$TYPE_ERROR = "E";
var $84c11e79798ea0cb$var$TYPE_MAP = "M";
var $84c11e79798ea0cb$var$TYPE_NULL_OBJECT = "N";
var $84c11e79798ea0cb$var$TYPE_PROMISE = "P";
var $84c11e79798ea0cb$var$TYPE_REGEXP = "R";
var $84c11e79798ea0cb$var$TYPE_SET = "S";
var $84c11e79798ea0cb$var$TYPE_SYMBOL = "Y";
var $84c11e79798ea0cb$var$TYPE_URL = "U";
var $84c11e79798ea0cb$var$TYPE_PREVIOUS_RESOLVED = "Z";
var $84c11e79798ea0cb$var$Deferred2 = class {
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $84c11e79798ea0cb$var$createLineSplittingTransform() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}
// vendor/turbo-stream-v2/flatten.ts
function $84c11e79798ea0cb$var$flatten(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return $84c11e79798ea0cb$var$UNDEFINED;
    if (input === null) return $84c11e79798ea0cb$var$NULL;
    if (Number.isNaN(input)) return $84c11e79798ea0cb$var$NAN;
    if (input === Number.POSITIVE_INFINITY) return $84c11e79798ea0cb$var$POSITIVE_INFINITY;
    if (input === Number.NEGATIVE_INFINITY) return $84c11e79798ea0cb$var$NEGATIVE_INFINITY;
    if (input === 0 && 1 / input < 0) return $84c11e79798ea0cb$var$NEGATIVE_ZERO;
    const index = this.index++;
    indices.set(input, index);
    $84c11e79798ea0cb$var$stringify.call(this, input, index);
    return index;
}
function $84c11e79798ea0cb$var$stringify(input, index) {
    const { deferred: deferred, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    const stack = [
        [
            input,
            index
        ]
    ];
    while(stack.length > 0){
        const [input2, index2] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${$84c11e79798ea0cb$var$flatten.call(this, k)}":${$84c11e79798ea0cb$var$flatten.call(this, obj[k])}`).join(",");
        let error = null;
        switch(typeof input2){
            case "boolean":
            case "number":
            case "string":
                str[index2] = JSON.stringify(input2);
                break;
            case "bigint":
                str[index2] = `["${$84c11e79798ea0cb$var$TYPE_BIGINT}","${input2}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input2);
                    if (!keyFor) error = new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index2] = `["${$84c11e79798ea0cb$var$TYPE_SYMBOL}",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input2) {
                        str[index2] = `${$84c11e79798ea0cb$var$NULL}`;
                        break;
                    }
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$84c11e79798ea0cb$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input2.length; i++)result += (i ? "," : "") + (i in input2 ? $84c11e79798ea0cb$var$flatten.call(this, input2[i]) : $84c11e79798ea0cb$var$HOLE);
                            str[index2] = `${result}]`;
                        } else if (input2 instanceof Date) {
                            const dateTime = input2.getTime();
                            str[index2] = `["${$84c11e79798ea0cb$var$TYPE_DATE}",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input2 instanceof URL) str[index2] = `["${$84c11e79798ea0cb$var$TYPE_URL}",${JSON.stringify(input2.href)}]`;
                        else if (input2 instanceof RegExp) str[index2] = `["${$84c11e79798ea0cb$var$TYPE_REGEXP}",${JSON.stringify(input2.source)},${JSON.stringify(input2.flags)}]`;
                        else if (input2 instanceof Set) {
                            if (input2.size > 0) str[index2] = `["${$84c11e79798ea0cb$var$TYPE_SET}",${[
                                ...input2
                            ].map((val)=>$84c11e79798ea0cb$var$flatten.call(this, val)).join(",")}]`;
                            else str[index2] = `["${$84c11e79798ea0cb$var$TYPE_SET}"]`;
                        } else if (input2 instanceof Map) {
                            if (input2.size > 0) str[index2] = `["${$84c11e79798ea0cb$var$TYPE_MAP}",${[
                                ...input2
                            ].flatMap(([k, v])=>[
                                    $84c11e79798ea0cb$var$flatten.call(this, k),
                                    $84c11e79798ea0cb$var$flatten.call(this, v)
                                ]).join(",")}]`;
                            else str[index2] = `["${$84c11e79798ea0cb$var$TYPE_MAP}"]`;
                        } else if (input2 instanceof Promise) {
                            str[index2] = `["${$84c11e79798ea0cb$var$TYPE_PROMISE}",${index2}]`;
                            deferred[index2] = input2;
                        } else if (input2 instanceof Error) {
                            str[index2] = `["${$84c11e79798ea0cb$var$TYPE_ERROR}",${JSON.stringify(input2.message)}`;
                            if (input2.name !== "Error") str[index2] += `,${JSON.stringify(input2.name)}`;
                            str[index2] += "]";
                        } else if (Object.getPrototypeOf(input2) === null) str[index2] = `["${$84c11e79798ea0cb$var$TYPE_NULL_OBJECT}",{${partsForObj(input2)}}]`;
                        else if ($84c11e79798ea0cb$var$isPlainObject2(input2)) str[index2] = `{${partsForObj(input2)}}`;
                        else error = new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input2);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input2);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index2] += `,${rest.map((v)=>$84c11e79798ea0cb$var$flatten.call(this, v)).join(",")}`;
                            str[index2] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input2);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index2] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index2] += `,${rest.map((v)=>$84c11e79798ea0cb$var$flatten.call(this, v)).join(",")}`;
                    str[index2] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
var $84c11e79798ea0cb$var$objectProtoNames2 = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $84c11e79798ea0cb$var$isPlainObject2(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $84c11e79798ea0cb$var$objectProtoNames2;
}
// vendor/turbo-stream-v2/unflatten.ts
var $84c11e79798ea0cb$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $84c11e79798ea0cb$var$unflatten(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $84c11e79798ea0cb$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $84c11e79798ea0cb$var$hydrate.call(this, startIndex);
}
function $84c11e79798ea0cb$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index2, set] = stack.pop();
        switch(index2){
            case $84c11e79798ea0cb$var$UNDEFINED:
                set(void 0);
                continue;
            case $84c11e79798ea0cb$var$NULL:
                set(null);
                continue;
            case $84c11e79798ea0cb$var$NAN:
                set(NaN);
                continue;
            case $84c11e79798ea0cb$var$POSITIVE_INFINITY:
                set(Infinity);
                continue;
            case $84c11e79798ea0cb$var$NEGATIVE_INFINITY:
                set(-Infinity);
                continue;
            case $84c11e79798ea0cb$var$NEGATIVE_ZERO:
                set(-0);
                continue;
        }
        if (hydrated[index2]) {
            set(hydrated[index2]);
            continue;
        }
        const value = values[index2];
        if (!value || typeof value !== "object") {
            hydrated[index2] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case $84c11e79798ea0cb$var$TYPE_DATE:
                        set(hydrated[index2] = new Date(b));
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_URL:
                        set(hydrated[index2] = new URL(b));
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_BIGINT:
                        set(hydrated[index2] = BigInt(b));
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_REGEXP:
                        set(hydrated[index2] = new RegExp(b, c));
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_SYMBOL:
                        set(hydrated[index2] = Symbol.for(b));
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_SET:
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index2] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_MAP:
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index2] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_NULL_OBJECT:
                        const obj = /* @__PURE__ */ Object.create(null);
                        hydrated[index2] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_PROMISE:
                        if (hydrated[b]) set(hydrated[index2] = hydrated[b]);
                        else {
                            const d = new $84c11e79798ea0cb$var$Deferred2();
                            deferred[b] = d;
                            set(hydrated[index2] = d.promise);
                        }
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_ERROR:
                        const [, message, errorType] = value;
                        let error = errorType && $84c11e79798ea0cb$var$globalObj && $84c11e79798ea0cb$var$globalObj[errorType] ? new $84c11e79798ea0cb$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index2] = error;
                        set(error);
                        continue;
                    case $84c11e79798ea0cb$var$TYPE_PREVIOUS_RESOLVED:
                        set(hydrated[index2] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v2)=>{
                                        r[i] = v2;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result2 = plugin(value[0], ...r);
                                    if (result2) {
                                        set(hydrated[index2] = result2.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index2] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== $84c11e79798ea0cb$var$HOLE) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index2] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}
// vendor/turbo-stream-v2/turbo-stream.ts
async function $84c11e79798ea0cb$var$decode(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new $84c11e79798ea0cb$var$Deferred2();
    const reader = readable.pipeThrough($84c11e79798ea0cb$var$createLineSplittingTransform()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $84c11e79798ea0cb$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $84c11e79798ea0cb$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $84c11e79798ea0cb$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch (reason) {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: $84c11e79798ea0cb$var$unflatten.call(this, line)
    };
}
async function $84c11e79798ea0cb$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case $84c11e79798ea0cb$var$TYPE_PROMISE:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $84c11e79798ea0cb$var$unflatten.call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case $84c11e79798ea0cb$var$TYPE_ERROR:
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch (reason) {
                        throw new SyntaxError();
                    }
                    const value = $84c11e79798ea0cb$var$unflatten.call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $84c11e79798ea0cb$export$c564cdbbe6da493(input, options) {
    const { plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    const readable = new ReadableStream({
        async start (controller) {
            const id = $84c11e79798ea0cb$var$flatten.call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}
`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]
`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(// biome-ignore lint/suspicious/noAssignInExpressions: <explanation>
                        encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            const id2 = $84c11e79798ea0cb$var$flatten.call(encoder, resolved);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$84c11e79798ea0cb$var$TYPE_PROMISE}${deferredId}:[["${$84c11e79798ea0cb$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$84c11e79798ea0cb$var$TYPE_PROMISE}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$84c11e79798ea0cb$var$TYPE_PROMISE}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }, (reason)=>{
                            if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = new Error("An unknown error occurred");
                            const id2 = $84c11e79798ea0cb$var$flatten.call(encoder, reason);
                            if (Array.isArray(id2)) {
                                controller.enqueue(textEncoder.encode(`${$84c11e79798ea0cb$var$TYPE_ERROR}${deferredId}:[["${$84c11e79798ea0cb$var$TYPE_PREVIOUS_RESOLVED}",${id2[0]}]]
`));
                                encoder.index++;
                                lastSentIndex++;
                            } else if (id2 < 0) controller.enqueue(textEncoder.encode(`${$84c11e79798ea0cb$var$TYPE_ERROR}${deferredId}:${id2}
`));
                            else {
                                const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                controller.enqueue(textEncoder.encode(`${$84c11e79798ea0cb$var$TYPE_ERROR}${deferredId}:[${values}]
`));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            controller.close();
        }
    });
    return readable;
}
// lib/dom/ssr/data.ts
async function $84c11e79798ea0cb$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}
// lib/dom/ssr/markup.ts
var $84c11e79798ea0cb$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $84c11e79798ea0cb$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $84c11e79798ea0cb$export$4cf11838cdc2a8a8(html) {
    return html.replace($84c11e79798ea0cb$var$ESCAPE_REGEX, (match)=>$84c11e79798ea0cb$var$ESCAPE_LOOKUP[match]);
}
// lib/dom/ssr/invariant.ts
function $84c11e79798ea0cb$var$invariant2(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
// lib/dom/ssr/single-fetch.tsx
var $84c11e79798ea0cb$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $84c11e79798ea0cb$var$SingleFetchNoResultError = class extends Error {
};
var $84c11e79798ea0cb$export$ae9272e641ead836 = 202;
var $84c11e79798ea0cb$export$e35ccdcde387134d = /* @__PURE__ */ new Set([
    100,
    101,
    204,
    205
]);
function $84c11e79798ea0cb$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${$84c11e79798ea0cb$export$4cf11838cdc2a8a8(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, scriptTag, /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $84c11e79798ea0cb$export$77d7799427e365da(getRouter, manifest, routeModules, ssr, basename, trailingSlashAware) {
    let dataStrategy = $84c11e79798ea0cb$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        $84c11e79798ea0cb$var$invariant2(manifestRoute, "Route not found in manifest");
        let routeModule = routeModules[match.route.id];
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader,
            hasShouldRevalidate: Boolean(routeModule?.shouldRevalidate)
        };
    }, $84c11e79798ea0cb$var$fetchAndDecodeViaTurboStream, ssr, basename, trailingSlashAware);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $84c11e79798ea0cb$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $84c11e79798ea0cb$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $84c11e79798ea0cb$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware);
        if (fetcherKey) return $84c11e79798ea0cb$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware);
        return $84c11e79798ea0cb$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut);
    };
}
async function $84c11e79798ea0cb$var$singleFetchActionStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    $84c11e79798ea0cb$var$invariant2(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        let result2 = await handler(async ()=>{
            let { data: data2, status: status } = await fetchAndDecode(args, basename, trailingSlashAware, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $84c11e79798ea0cb$var$unwrapSingleFetchResult(data2, actionMatch.route.id);
        });
        return result2;
    });
    if ($84c11e79798ea0cb$export$3f1eb41d9a6a6a27(result.result) || $84c11e79798ea0cb$export$972111febbeef05b(result.result) || $84c11e79798ea0cb$export$e0163cfdf7bc9cfa(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: $84c11e79798ea0cb$export$4051a07651545597(result.result, actionStatus)
        }
    };
}
async function $84c11e79798ea0cb$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode, basename, trailingSlashAware) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map((m)=>m.resolve(async (handler)=>{
            try {
                let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
                let routeId = m.route.id;
                let result = hasClientLoader ? await handler(async ()=>{
                    let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                        routeId
                    ]);
                    return $84c11e79798ea0cb$var$unwrapSingleFetchResult(data2, routeId);
                }) : await handler();
                results[m.route.id] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[m.route.id] = {
                    type: "error",
                    result: e
                };
            }
        })));
    return results;
}
async function $84c11e79798ea0cb$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, basename, trailingSlashAware, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$84c11e79798ea0cb$var$createDeferred2());
    let singleFetchDfd = $84c11e79798ea0cb$var$createDeferred2();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader, hasShouldRevalidate: hasShouldRevalidate } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            let shouldCall = m.shouldCallHandler(defaultShouldRevalidate);
            if (!shouldCall) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && // This is a revalidation,
                hasLoader && // for a route with a server loader,
                hasShouldRevalidate === true);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    let result = await handler(async ()=>{
                        let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                            routeId
                        ]);
                        return $84c11e79798ea0cb$var$unwrapSingleFetchResult(data2, routeId);
                    });
                    results[routeId] = {
                        type: "data",
                        result: result
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                let result = await handler(async ()=>{
                    let data2 = await singleFetchDfd.promise;
                    return $84c11e79798ea0cb$var$unwrapSingleFetchResult(data2, routeId);
                });
                results[routeId] = {
                    type: "data",
                    result: result
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    let isInitialLoad = !router.state.initialized && router.state.navigation.state === "idle";
    if ((isInitialLoad || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data2 = await fetchAndDecode(args, basename, trailingSlashAware, targetRoutes);
            singleFetchDfd.resolve(data2.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $84c11e79798ea0cb$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $84c11e79798ea0cb$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $84c11e79798ea0cb$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch (e) {}
}
async function $84c11e79798ea0cb$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode, basename, trailingSlashAware) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    $84c11e79798ea0cb$var$invariant2(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data2 } = await fetchAndDecode(args, basename, trailingSlashAware, [
                routeId
            ]);
            return $84c11e79798ea0cb$var$unwrapSingleFetchResult(data2, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $84c11e79798ea0cb$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $84c11e79798ea0cb$export$7b977381851b2c(reqUrl, basename, trailingSlashAware, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (trailingSlashAware) {
        if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
        else url.pathname = `${url.pathname}.${extension}`;
    } else {
        if (url.pathname === "/") url.pathname = `_root.${extension}`;
        else if (basename && $84c11e79798ea0cb$export$b69e3301ce081aa3(url.pathname, basename) === "/") url.pathname = `${basename.replace(/\/$/, "")}/_root.${extension}`;
        else url.pathname = `${url.pathname.replace(/\/$/, "")}.${extension}`;
    }
    return url;
}
async function $84c11e79798ea0cb$var$fetchAndDecodeViaTurboStream(args, basename, trailingSlashAware, targetRoutes) {
    let { request: request } = args;
    let url = $84c11e79798ea0cb$export$7b977381851b2c(request.url, basename, trailingSlashAware, "data");
    if (request.method === "GET") {
        url = $84c11e79798ea0cb$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await $84c11e79798ea0cb$export$a30aa2a0fce6c468(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new $84c11e79798ea0cb$export$f2680fa305b734ca(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: $84c11e79798ea0cb$export$ae9272e641ead836,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($84c11e79798ea0cb$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    $84c11e79798ea0cb$var$invariant2(res.body, "No response body to decode");
    try {
        let decoded = await $84c11e79798ea0cb$export$4023ad4ecd4126a2(res.body, window);
        let data2;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($84c11e79798ea0cb$export$60644022b8b46aaa in typed) data2 = {
                redirect: typed[$84c11e79798ea0cb$export$60644022b8b46aaa]
            };
            else data2 = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            $84c11e79798ea0cb$var$invariant2(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data2 = {
                redirect: typed
            };
            else data2 = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data2
        };
    } catch (e) {
        throw new Error("Unable to decode turbo-stream response");
    }
}
function $84c11e79798ea0cb$export$4023ad4ecd4126a2(body, global) {
    return $84c11e79798ea0cb$var$decode(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data2, status, statusText] = rest;
                    return {
                        value: new $84c11e79798ea0cb$export$f2680fa305b734ca(status, statusText, data2)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$84c11e79798ea0cb$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $84c11e79798ea0cb$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace2, status: status } = result.redirect;
        throw $84c11e79798ea0cb$export$89e12c5b50f7529d(location, {
            status: status,
            headers: {
                // Three R's of redirecting (lol Veep)
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace2 ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $84c11e79798ea0cb$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $84c11e79798ea0cb$var$createDeferred2() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch (e) {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch (e) {}
        };
    });
    return {
        promise: promise,
        resolve: //@ts-ignore
        resolve,
        reject: //@ts-ignore
        reject
    };
}
// lib/dom/ssr/routeModules.ts
async function $84c11e79798ea0cb$var$loadRouteModule(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && // @ts-expect-error
        $84c11e79798ea0cb$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}
// lib/dom/ssr/links.ts
function $84c11e79798ea0cb$var$getKeyedLinksForMatches(matches, routeModules, manifest) {
    let descriptors = matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2);
    let preloads = $84c11e79798ea0cb$var$getModuleLinkHrefs(matches, manifest);
    return $84c11e79798ea0cb$var$dedupeLinkDescriptors(descriptors, preloads);
}
function $84c11e79798ea0cb$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $84c11e79798ea0cb$var$prefetchRouteCss(route) {
    if (!route.css) return;
    let descriptors = $84c11e79798ea0cb$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($84c11e79798ea0cb$var$prefetchStyleLink));
}
async function $84c11e79798ea0cb$var$prefetchStyleLinks(route, routeModule) {
    if (!route.css && !routeModule.links || !$84c11e79798ea0cb$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$84c11e79798ea0cb$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$84c11e79798ea0cb$var$isPageLinkDescriptor(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($84c11e79798ea0cb$var$prefetchStyleLink));
}
async function $84c11e79798ea0cb$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $84c11e79798ea0cb$var$isPageLinkDescriptor(object) {
    return object != null && typeof object.page === "string";
}
function $84c11e79798ea0cb$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $84c11e79798ea0cb$var$getKeyedPrefetchLinks(matches, manifest, routeModules) {
    let links = await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await $84c11e79798ea0cb$var$loadRouteModule(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }));
    return $84c11e79798ea0cb$var$dedupeLinkDescriptors(links.flat(1).filter($84c11e79798ea0cb$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $84c11e79798ea0cb$var$getNewMatchesForLinks(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return(// param change, /users/123 -> /users/456
        currentMatches[index].pathname !== match.pathname || // splat param changed, which is not present in match.path
        // e.g. /files/images/avatar.jpg -> files/finances.xls
        currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"]);
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $84c11e79798ea0cb$var$getModuleLinkHrefs(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $84c11e79798ea0cb$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $84c11e79798ea0cb$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $84c11e79798ea0cb$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $84c11e79798ea0cb$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        let alreadyModulePreload = preloads && !$84c11e79798ea0cb$var$isPageLinkDescriptor(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href);
        if (alreadyModulePreload) return deduped;
        let key = JSON.stringify($84c11e79798ea0cb$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $84c11e79798ea0cb$var$_isPreloadSupported;
function $84c11e79798ea0cb$var$isPreloadSupported() {
    if ($84c11e79798ea0cb$var$_isPreloadSupported !== void 0) return $84c11e79798ea0cb$var$_isPreloadSupported;
    let el = document.createElement("link");
    $84c11e79798ea0cb$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $84c11e79798ea0cb$var$_isPreloadSupported;
}
function $84c11e79798ea0cb$var$RemixRootDefaultHydrateFallback() {
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$BoundaryShell, {
        title: "Loading...",
        renderScripts: true
    }, $84c11e79798ea0cb$export$945fecf35a8ef089 ? /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
              console.log(
                "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this " +
                "when your app is loading JS modules and/or running \`clientLoader\` " +
                "functions. Check out https://reactrouter.com/start/framework/route-module#hydratefallback " +
                "for more information."
              );
            `
        }
    }) : null);
}
// lib/dom/ssr/routes.tsx
function $84c11e79798ea0cb$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $84c11e79798ea0cb$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component4 = $84c11e79798ea0cb$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? $84c11e79798ea0cb$var$RemixRootDefaultHydrateFallback : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$RemixRootDefaultErrorBoundary, {
            error: $84c11e79798ea0cb$export$ed527bf60f6e05f2()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component4 ? {
            element: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(Component4, null))
        } : {
            Component: Component4
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $acw62.createElement(routeModule.Layout, null, /* @__PURE__ */ $acw62.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component4,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $84c11e79798ea0cb$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $84c11e79798ea0cb$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        $84c11e79798ea0cb$var$invariant2(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$84c11e79798ea0cb$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            // For SPA Mode, all routes are lazy except root.  However we tell the
            // router root is also lazy here too since we don't need a full
            // implementation - we just need a `lazy` prop to tell the RR rendering
            // where to stop which is always at the root route in SPA mode
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            // For partial hydration rendering, we need to indicate when the route
            // has a loader/clientLoader, but it won't ever be called during the static
            // render, so just give it a no-op function so we can render down to the
            // proper fallback
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $84c11e79798ea0cb$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $84c11e79798ea0cb$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $84c11e79798ea0cb$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $84c11e79798ea0cb$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $84c11e79798ea0cb$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new $84c11e79798ea0cb$export$f2680fa305b734ca(400, "Bad Request", new Error(msg), true);
    }
}
function $84c11e79798ea0cb$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new $84c11e79798ea0cb$export$f2680fa305b734ca(405, "Method Not Allowed", new Error(msg), true);
}
function $84c11e79798ea0cb$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $84c11e79798ea0cb$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            $84c11e79798ea0cb$var$invariant2(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $84c11e79798ea0cb$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route2) {
            if (route2.clientActionModule) prefetchModule(route2.clientActionModule);
            if (route2.clientLoaderModule) prefetchModule(route2.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? $84c11e79798ea0cb$var$prefetchStyleLinks(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$84c11e79798ea0cb$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $84c11e79798ea0cb$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                try {
                    let result = await prefetchStylesAndCallHandler(async ()=>{
                        $84c11e79798ea0cb$var$invariant2(routeModule, "No `routeModule` available for critical-route loader");
                        if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                        return routeModule.clientLoader({
                            request: request,
                            params: params,
                            context: context,
                            unstable_pattern: unstable_pattern,
                            async serverLoader () {
                                $84c11e79798ea0cb$var$preventInvalidServerHandlerCall("loader", route);
                                if (isHydrationRequest) {
                                    if (hasInitialData) return initialData;
                                    if (hasInitialError) throw initialError;
                                }
                                return fetchServerLoader(singleFetch);
                            }
                        });
                    });
                    return result;
                } finally{
                    isHydrationRequest = false;
                }
            };
            dataRoute.loader.hydrate = $84c11e79798ea0cb$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, unstable_pattern: unstable_pattern }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    $84c11e79798ea0cb$var$invariant2(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $84c11e79798ea0cb$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        unstable_pattern: unstable_pattern,
                        async serverAction () {
                            $84c11e79798ea0cb$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $84c11e79798ea0cb$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $84c11e79798ea0cb$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    $84c11e79798ea0cb$var$invariant2(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $84c11e79798ea0cb$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    $84c11e79798ea0cb$var$invariant2(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $84c11e79798ea0cb$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    $84c11e79798ea0cb$var$invariant2(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $84c11e79798ea0cb$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                // No need to wrap these in layout since the root route is never
                // loaded via route.lazy()
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $84c11e79798ea0cb$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $84c11e79798ea0cb$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $84c11e79798ea0cb$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? $84c11e79798ea0cb$var$compilePath(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $84c11e79798ea0cb$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $84c11e79798ea0cb$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = $84c11e79798ea0cb$var$loadRouteModule(route, routeModules);
    let prefetchRouteCssPromise = $84c11e79798ea0cb$var$prefetchRouteCss(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        $84c11e79798ea0cb$var$prefetchStyleLinks(route, routeModule)
    ]);
    return {
        Component: $84c11e79798ea0cb$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $84c11e79798ea0cb$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    let isEmptyObject = typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0;
    if (!isEmptyObject) return routeModule.default;
}
function $84c11e79798ea0cb$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}
// lib/dom/ssr/fog-of-war.ts
var $84c11e79798ea0cb$var$nextPaths = /* @__PURE__ */ new Set();
var $84c11e79798ea0cb$var$discoveredPathsMaxSize = 1e3;
var $84c11e79798ea0cb$var$discoveredPaths = /* @__PURE__ */ new Set();
var $84c11e79798ea0cb$var$URL_LIMIT = 7680;
function $84c11e79798ea0cb$var$isFogOfWarEnabled(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $84c11e79798ea0cb$var$getPartialManifest({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = $84c11e79798ea0cb$export$2708184779ceb39d(router.routes, path, router.basename);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $84c11e79798ea0cb$export$72ab377a1030deb9(manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$84c11e79798ea0cb$var$isFogOfWarEnabled(routeDiscovery, ssr)) return void 0;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($84c11e79798ea0cb$var$discoveredPaths.has(path)) return;
        await $84c11e79798ea0cb$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : path, manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $84c11e79798ea0cb$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $acw62.useEffect(()=>{
        if (!$84c11e79798ea0cb$var$isFogOfWarEnabled(routeDiscovery, ssr) || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$84c11e79798ea0cb$var$discoveredPaths.has(pathname)) $84c11e79798ea0cb$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($84c11e79798ea0cb$var$nextPaths.keys()).filter((path)=>{
                if ($84c11e79798ea0cb$var$discoveredPaths.has(path)) {
                    $84c11e79798ea0cb$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $84c11e79798ea0cb$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $84c11e79798ea0cb$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $84c11e79798ea0cb$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    if (basename == null) return manifestPath;
    return `${basename}${manifestPath}`.replace(/\/+/g, "/");
}
var $84c11e79798ea0cb$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
async function $84c11e79798ea0cb$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($84c11e79798ea0cb$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > $84c11e79798ea0cb$var$URL_LIMIT) {
        $84c11e79798ea0cb$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        else if (res.status === 204 && res.headers.has("X-Remix-Reload-Document")) {
            if (!errorReloadPath) {
                console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                return;
            }
            try {
                if (sessionStorage.getItem($84c11e79798ea0cb$var$MANIFEST_VERSION_STORAGE_KEY) === manifest.version) {
                    console.error("Unable to discover routes due to manifest version mismatch.");
                    return;
                }
                sessionStorage.setItem($84c11e79798ea0cb$var$MANIFEST_VERSION_STORAGE_KEY, manifest.version);
            } catch  {}
            window.location.href = errorReloadPath;
            console.warn("Detected manifest version mismatch, reloading...");
            await new Promise(()=>{});
        } else if (res.status >= 400) throw new Error(await res.text());
        try {
            sessionStorage.removeItem($84c11e79798ea0cb$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$84c11e79798ea0cb$var$addToFifoQueue(p, $84c11e79798ea0cb$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, $84c11e79798ea0cb$export$af76e85f27ba0229(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $84c11e79798ea0cb$var$addToFifoQueue(path, queue) {
    if (queue.size >= $84c11e79798ea0cb$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        queue.delete(first);
    }
    queue.add(path);
}
function $84c11e79798ea0cb$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
// lib/dom/ssr/components.tsx
function $84c11e79798ea0cb$var$useDataRouterContext2() {
    let context = $acw62.useContext($84c11e79798ea0cb$export$2eeee58951ff3c1c);
    $84c11e79798ea0cb$var$invariant2(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $84c11e79798ea0cb$var$useDataRouterStateContext() {
    let context = $acw62.useContext($84c11e79798ea0cb$export$315e3ffb01f217);
    $84c11e79798ea0cb$var$invariant2(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $84c11e79798ea0cb$export$208d6a3bc3aa62bd = $acw62.createContext(void 0);
$84c11e79798ea0cb$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $84c11e79798ea0cb$var$useFrameworkContext() {
    let context = $acw62.useContext($84c11e79798ea0cb$export$208d6a3bc3aa62bd);
    $84c11e79798ea0cb$var$invariant2(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $84c11e79798ea0cb$var$usePrefetchBehavior(prefetch, theirElementProps) {
    let frameworkContext = $acw62.useContext($84c11e79798ea0cb$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $acw62.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $acw62.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: 0.5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $acw62.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $84c11e79798ea0cb$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $84c11e79798ea0cb$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $84c11e79798ea0cb$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $84c11e79798ea0cb$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $84c11e79798ea0cb$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $84c11e79798ea0cb$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $84c11e79798ea0cb$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$84c11e79798ea0cb$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $84c11e79798ea0cb$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
function $84c11e79798ea0cb$export$b2e089eb3692b073({ nonce: nonce }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss } = $84c11e79798ea0cb$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches } = $84c11e79798ea0cb$var$useDataRouterStateContext();
    let matches = $84c11e79798ea0cb$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $acw62.useMemo(()=>$84c11e79798ea0cb$var$getKeyedLinksForMatches(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $acw62.createElement("style", {
        [$84c11e79798ea0cb$export$7e4ed4715c00dab0]: "",
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $acw62.createElement("link", {
        [$84c11e79798ea0cb$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce
    }) : null, keyedLinks.map(({ key: key, link: link })=>$84c11e79798ea0cb$var$isPageLinkDescriptor(link) ? /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link
        }) : /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: nonce,
            ...link
        })));
}
function $84c11e79798ea0cb$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let { router: router } = $84c11e79798ea0cb$var$useDataRouterContext2();
    let matches = $acw62.useMemo(()=>$84c11e79798ea0cb$export$2708184779ceb39d(router.routes, page, router.basename), [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $84c11e79798ea0cb$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $84c11e79798ea0cb$var$useFrameworkContext();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $acw62.useState([]);
    $acw62.useEffect(()=>{
        let interrupted = false;
        $84c11e79798ea0cb$var$getKeyedPrefetchLinks(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $84c11e79798ea0cb$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let { future: future, manifest: manifest, routeModules: routeModules } = $84c11e79798ea0cb$var$useFrameworkContext();
    let { basename: basename } = $84c11e79798ea0cb$var$useDataRouterContext2();
    let { loaderData: loaderData, matches: matches } = $84c11e79798ea0cb$var$useDataRouterStateContext();
    let newMatchesForData = $acw62.useMemo(()=>$84c11e79798ea0cb$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $acw62.useMemo(()=>$84c11e79798ea0cb$var$getNewMatchesForLinks(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $acw62.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = $84c11e79798ea0cb$export$7b977381851b2c(page, basename, future.unstable_trailingSlashAwareDataRequests, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        basename,
        future.unstable_trailingSlashAwareDataRequests,
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $acw62.useMemo(()=>$84c11e79798ea0cb$var$getModuleLinkHrefs(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $84c11e79798ea0cb$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>// these don't spread `linkProps` because they are full link descriptors
        // already with their own props
        /* @__PURE__ */ $acw62.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link
        })));
}
function $84c11e79798ea0cb$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $84c11e79798ea0cb$var$useFrameworkContext();
    let { errors: errors, matches: routerMatches, loaderData: loaderData } = $84c11e79798ea0cb$var$useDataRouterStateContext();
    let location = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let _matches = $84c11e79798ea0cb$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data2 = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            data: data2,
            loaderData: data2,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            data: data2,
            loaderData: data2,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://remix.run/route/meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$84c11e79798ea0cb$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $acw62.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $acw62.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            metaProps.charSet ?? (metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $acw62.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $acw62.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: $84c11e79798ea0cb$export$4cf11838cdc2a8a8(json)
                }
            });
        } catch (err) {
            return null;
        }
        return /* @__PURE__ */ $acw62.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $84c11e79798ea0cb$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
var $84c11e79798ea0cb$var$isHydrated = false;
function $84c11e79798ea0cb$export$3be068dde909e563() {
    $84c11e79798ea0cb$var$isHydrated = true;
}
function $84c11e79798ea0cb$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr } = $84c11e79798ea0cb$var$useFrameworkContext();
    let { router: router, static: isStatic, staticContext: staticContext } = $84c11e79798ea0cb$var$useDataRouterContext2();
    let { matches: routerMatches } = $84c11e79798ea0cb$var$useDataRouterStateContext();
    let isRSCRouterContext = $84c11e79798ea0cb$var$useIsRSCRouterContext();
    let enableFogOfWar = $84c11e79798ea0cb$var$isFogOfWarEnabled(routeDiscovery, ssr);
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $84c11e79798ea0cb$var$getActiveMatches(routerMatches, null, isSpaMode);
    $acw62.useEffect(()=>{
        $84c11e79798ea0cb$export$3be068dde909e563();
    }, []);
    let initialScripts = $acw62.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let streamScript = "window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());";
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};${streamScript}` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            $84c11e79798ea0cb$var$invariant2(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            let chunkImportsSnippet = chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n");
            let mergedChunksSnippet = `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`;
            return [
                chunkImportsSnippet,
                mergedChunksSnippet
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? // Inline a minimal manifest with the SSR matches
        `window.__reactRouterManifest = ${JSON.stringify($84c11e79798ea0cb$var$getPartialManifest(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $acw62.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $84c11e79798ea0cb$var$isHydrated || isRSCRouterContext ? [] : $84c11e79798ea0cb$var$dedupe(manifest.entry.imports.concat($84c11e79798ea0cb$var$getModuleLinkHrefs(matches, manifest, {
        includeHydrateFallback: true
    })));
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    $84c11e79798ea0cb$export$5b28268982f175ba(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $84c11e79798ea0cb$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $acw62.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $acw62.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $acw62.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            suppressHydrationWarning: true
        })), initialScripts);
}
function $84c11e79798ea0cb$var$dedupe(array) {
    return [
        ...new Set(array)
    ];
}
function $84c11e79798ea0cb$var$mergeRefs(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}
// lib/dom/ssr/errorBoundaries.tsx
var $84c11e79798ea0cb$export$32e57f52df4b6e34 = class extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$RemixRootDefaultErrorBoundary, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
};
function $84c11e79798ea0cb$var$RemixRootDefaultErrorBoundary({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $acw62.createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ($84c11e79798ea0cb$export$972111febbeef05b(error)) return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$BoundaryShell, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), $84c11e79798ea0cb$export$945fecf35a8ef089 ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$BoundaryShell, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $acw62.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $acw62.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $84c11e79798ea0cb$var$BoundaryShell({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = $84c11e79798ea0cb$var$useFrameworkContext();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $acw62.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $acw62.createElement("head", null, /* @__PURE__ */ $acw62.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $acw62.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $acw62.createElement("title", null, title)), /* @__PURE__ */ $acw62.createElement("body", null, /* @__PURE__ */ $acw62.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$ff0bf87698939488, null) : null)));
}
var $84c11e79798ea0cb$var$isBrowser2 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($84c11e79798ea0cb$var$isBrowser2) window.__reactRouterVersion = "7.12.0";
} catch (e) {}
function $84c11e79798ea0cb$export$1f3f55432a00e06d(routes, opts) {
    return $84c11e79798ea0cb$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $84c11e79798ea0cb$export$719fc203c4e16dee({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $84c11e79798ea0cb$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $84c11e79798ea0cb$export$9269a41d8c4635e,
        hydrationRouteProperties: $84c11e79798ea0cb$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $84c11e79798ea0cb$export$1ba7ed8a3a7b3765(routes, opts) {
    return $84c11e79798ea0cb$export$baddd0131ee8c05b({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: $84c11e79798ea0cb$export$b71fdd3798280242({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $84c11e79798ea0cb$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: $84c11e79798ea0cb$export$9269a41d8c4635e,
        hydrationRouteProperties: $84c11e79798ea0cb$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        unstable_instrumentations: opts?.unstable_instrumentations
    }).initialize();
}
function $84c11e79798ea0cb$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $84c11e79798ea0cb$var$deserializeErrors(state.errors)
    };
    return state;
}
function $84c11e79798ea0cb$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new $84c11e79798ea0cb$export$f2680fa305b734ca(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
function $84c11e79798ea0cb$export$9ba4e89fdfa1fc54({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $84c11e79798ea0cb$export$719fc203c4e16dee({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $84c11e79798ea0cb$export$7221d69dcfc8e36b({ basename: basename, children: children, unstable_useTransitions: unstable_useTransitions, window: window2 }) {
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = $84c11e79798ea0cb$export$b71fdd3798280242({
        window: window2,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
function $84c11e79798ea0cb$export$de73885c9336221c({ basename: basename, children: children, history: history, unstable_useTransitions: unstable_useTransitions }) {
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let setState = $acw62.useCallback((newState)=>{
        if (unstable_useTransitions === false) setStateImpl(newState);
        else $acw62.startTransition(()=>setStateImpl(newState));
    }, [
        unstable_useTransitions
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        unstable_useTransitions: unstable_useTransitions
    });
}
$84c11e79798ea0cb$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
var $84c11e79798ea0cb$var$ABSOLUTE_URL_REGEX2 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var $84c11e79798ea0cb$export$a6c7ac8248d6e38a = $acw62.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace2, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let isAbsolute = typeof to === "string" && $84c11e79798ea0cb$var$ABSOLUTE_URL_REGEX2.test(to);
    let parsed = $84c11e79798ea0cb$var$parseToInfo(to, basename);
    to = parsed.to;
    let href = $84c11e79798ea0cb$export$b66bb29c5006f12f(to, {
        relative: relative
    });
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = $84c11e79798ea0cb$var$usePrefetchBehavior(prefetch, rest);
    let internalOnClick = $84c11e79798ea0cb$export$67621102c14d847(to, {
        replace: replace2,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate,
        unstable_useTransitions: unstable_useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let link = // eslint-disable-next-line jsx-a11y/anchor-has-content
    /* @__PURE__ */ $acw62.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: parsed.absoluteURL || href,
        onClick: parsed.isExternal || reloadDocument ? onClick : handleClick,
        ref: $84c11e79798ea0cb$var$mergeRefs(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, link, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$60dcec93e67386bd, {
        page: href
    })) : link;
});
$84c11e79798ea0cb$export$a6c7ac8248d6e38a.displayName = "Link";
var $84c11e79798ea0cb$export$b0d92dbee9b5b60d = $acw62.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = $84c11e79798ea0cb$export$e75d2a2d1b3c245b(to, {
        relative: rest.relative
    });
    let location = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let routerState = $acw62.useContext($84c11e79798ea0cb$export$315e3ffb01f217);
    let { navigator: navigator, basename: basename } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $84c11e79798ea0cb$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = $84c11e79798ea0cb$export$b69e3301ce081aa3(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$84c11e79798ea0cb$export$b0d92dbee9b5b60d.displayName = "NavLink";
var $84c11e79798ea0cb$export$a7fed597f4b8afd8 = $acw62.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace2, state: state, method: method = $84c11e79798ea0cb$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { unstable_useTransitions: unstable_useTransitions } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let submit = $84c11e79798ea0cb$export$47c85c6e3a081d3();
    let formAction = $84c11e79798ea0cb$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && $84c11e79798ea0cb$var$ABSOLUTE_URL_REGEX2.test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace2,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
            });
        if (unstable_useTransitions && navigate !== false) $acw62.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $acw62.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$84c11e79798ea0cb$export$a7fed597f4b8afd8.displayName = "Form";
function $84c11e79798ea0cb$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $acw62.useContext($84c11e79798ea0cb$export$208d6a3bc3aa62bd);
    let { basename: basename } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let location = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let matches = $84c11e79798ea0cb$export$2378eb7f5ff86053();
    $84c11e79798ea0cb$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $acw62.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $84c11e79798ea0cb$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, // Nah, we only need this the first time for the SSR render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey2, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let positions = JSON.parse(sessionStorage.getItem(storageKey2) || "{}");
            let storedY = positions[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey2);
        }
    }).toString();
    return /* @__PURE__ */ $acw62.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${$84c11e79798ea0cb$export$4cf11838cdc2a8a8(JSON.stringify(storageKey || $84c11e79798ea0cb$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${$84c11e79798ea0cb$export$4cf11838cdc2a8a8(JSON.stringify(ssrKey))})`
        }
    });
}
$84c11e79798ea0cb$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $84c11e79798ea0cb$var$getDataRouterConsoleError2(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $84c11e79798ea0cb$var$useDataRouterContext3(hookName) {
    let ctx = $acw62.useContext($84c11e79798ea0cb$export$2eeee58951ff3c1c);
    $84c11e79798ea0cb$export$f5708dca728d7177(ctx, $84c11e79798ea0cb$var$getDataRouterConsoleError2(hookName));
    return ctx;
}
function $84c11e79798ea0cb$var$useDataRouterState2(hookName) {
    let state = $acw62.useContext($84c11e79798ea0cb$export$315e3ffb01f217);
    $84c11e79798ea0cb$export$f5708dca728d7177(state, $84c11e79798ea0cb$var$getDataRouterConsoleError2(hookName));
    return state;
}
function $84c11e79798ea0cb$export$67621102c14d847(to, { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate, unstable_useTransitions: unstable_useTransitions } = {}) {
    let navigate = $84c11e79798ea0cb$export$9770f232ac06a008();
    let location = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let path = $84c11e79798ea0cb$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($84c11e79798ea0cb$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            let replace2 = replaceProp !== void 0 ? replaceProp : $84c11e79798ea0cb$export$fe53371bee54353d(location) === $84c11e79798ea0cb$export$fe53371bee54353d(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace2,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    unstable_defaultShouldRevalidate: unstable_defaultShouldRevalidate
                });
            if (unstable_useTransitions) $acw62.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        unstable_defaultShouldRevalidate,
        unstable_useTransitions
    ]);
}
function $84c11e79798ea0cb$export$f1a78c17382fe22a(defaultInit) {
    $84c11e79798ea0cb$var$warning(typeof URLSearchParams !== "undefined", `You cannot use the \`useSearchParams\` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.`);
    let defaultSearchParamsRef = $acw62.useRef($84c11e79798ea0cb$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $84c11e79798ea0cb$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = $84c11e79798ea0cb$export$9770f232ac06a008();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $84c11e79798ea0cb$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
var $84c11e79798ea0cb$var$fetcherId = 0;
var $84c11e79798ea0cb$var$getUniqueFetcherId = ()=>`__${String(++$84c11e79798ea0cb$var$fetcherId)}__`;
function $84c11e79798ea0cb$export$47c85c6e3a081d3() {
    let { router: router } = $84c11e79798ea0cb$var$useDataRouterContext3("useSubmit" /* UseSubmit */ );
    let { basename: basename } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let currentRouteId = $84c11e79798ea0cb$var$useRouteId();
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $acw62.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $84c11e79798ea0cb$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $84c11e79798ea0cb$var$getUniqueFetcherId();
            await routerFetch(key, currentRouteId, options.action || action, {
                unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else await routerNavigate(options.action || action, {
            unstable_defaultShouldRevalidate: options.unstable_defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
function $84c11e79798ea0cb$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let routeContext = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    $84c11e79798ea0cb$export$f5708dca728d7177(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...$84c11e79798ea0cb$export$e75d2a2d1b3c245b(action ? action : ".", {
            relative: relative
        })
    };
    let location = $84c11e79798ea0cb$export$45d76561a5302f2b();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : $84c11e79798ea0cb$var$joinPaths([
        basename,
        path.pathname
    ]);
    return $84c11e79798ea0cb$export$fe53371bee54353d(path);
}
function $84c11e79798ea0cb$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = $84c11e79798ea0cb$var$useDataRouterContext3("useFetcher" /* UseFetcher */ );
    let state = $84c11e79798ea0cb$var$useDataRouterState2("useFetcher" /* UseFetcher */ );
    let fetcherData = $acw62.useContext($84c11e79798ea0cb$export$cb3f1df1bef00a39);
    let route = $acw62.useContext($84c11e79798ea0cb$export$aac280ed165a4397);
    let routeId = route.matches[route.matches.length - 1]?.route.id;
    $84c11e79798ea0cb$export$f5708dca728d7177(fetcherData, `useFetcher must be used inside a FetchersContext`);
    $84c11e79798ea0cb$export$f5708dca728d7177(route, `useFetcher must be used inside a RouteContext`);
    $84c11e79798ea0cb$export$f5708dca728d7177(routeId != null, `useFetcher can only be used on routes that contain a unique "id"`);
    let defaultKey = $acw62.useId();
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $acw62.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $acw62.useCallback(async (href, opts)=>{
        $84c11e79798ea0cb$export$f5708dca728d7177(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $84c11e79798ea0cb$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $acw62.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm2 = $acw62.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm2.displayName = "fetcher.Form";
        return FetcherForm2;
    }, [
        fetcherKey
    ]);
    let fetcher = state.fetchers.get(fetcherKey) || $84c11e79798ea0cb$export$52eace9c284d3585;
    let data2 = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data2
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data2
    ]);
    return fetcherWithComponents;
}
function $84c11e79798ea0cb$export$fa996778a3a31087() {
    let state = $84c11e79798ea0cb$var$useDataRouterState2("useFetchers" /* UseFetchers */ );
    return Array.from(state.fetchers.entries()).map(([key, fetcher])=>({
            ...fetcher,
            key: key
        }));
}
var $84c11e79798ea0cb$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $84c11e79798ea0cb$var$savedScrollPositions = {};
function $84c11e79798ea0cb$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: $84c11e79798ea0cb$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
function $84c11e79798ea0cb$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = $84c11e79798ea0cb$var$useDataRouterContext3("useScrollRestoration" /* UseScrollRestoration */ );
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $84c11e79798ea0cb$var$useDataRouterState2("useScrollRestoration" /* UseScrollRestoration */ );
    let { basename: basename } = $acw62.useContext($84c11e79798ea0cb$export$3044ab7fdabeaee6);
    let location = $84c11e79798ea0cb$export$45d76561a5302f2b();
    let matches = $84c11e79798ea0cb$export$2378eb7f5ff86053();
    let navigation = $84c11e79798ea0cb$export$d0fd4b7106de2769();
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $84c11e79798ea0cb$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $84c11e79798ea0cb$var$getScrollRestorationKey(location, matches, basename, getKey);
            $84c11e79798ea0cb$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $84c11e79798ea0cb$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($84c11e79798ea0cb$var$savedScrollPositions));
        } catch (error) {
            $84c11e79798ea0cb$var$warning(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $84c11e79798ea0cb$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $84c11e79798ea0cb$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $acw62.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($84c11e79798ea0cb$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location2, matches2)=>$84c11e79798ea0cb$var$getScrollRestorationKey(location2, matches2, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $acw62.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                $84c11e79798ea0cb$var$warning(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
function $84c11e79798ea0cb$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $84c11e79798ea0cb$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $84c11e79798ea0cb$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = $84c11e79798ea0cb$export$b273b3273281a049(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
function $84c11e79798ea0cb$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $acw62.useContext($84c11e79798ea0cb$export$3681f408decb40d1);
    $84c11e79798ea0cb$export$f5708dca728d7177(vtContext != null, "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = $84c11e79798ea0cb$var$useDataRouterContext3("useViewTransitionState" /* useViewTransitionState */ );
    let path = $84c11e79798ea0cb$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = $84c11e79798ea0cb$export$b69e3301ce081aa3(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = $84c11e79798ea0cb$export$b69e3301ce081aa3(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return $84c11e79798ea0cb$export$81336c211d5ff295(path.pathname, nextPath) != null || $84c11e79798ea0cb$export$81336c211d5ff295(path.pathname, currentPath) != null;
}
function $84c11e79798ea0cb$export$cac06da4d76d935b({ basename: basename, children: children, location: locationProp = "/" }) {
    if (typeof locationProp === "string") locationProp = $84c11e79798ea0cb$export$8ccf933b0513f8d0(locationProp);
    let action = "POP" /* Pop */ ;
    let location = {
        pathname: locationProp.pathname || "/",
        search: locationProp.search || "",
        hash: locationProp.hash || "",
        state: locationProp.state != null ? locationProp.state : null,
        key: locationProp.key || "default"
    };
    let staticNavigator = $84c11e79798ea0cb$var$getStatelessNavigator();
    return /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: location,
        navigationType: action,
        navigator: staticNavigator,
        static: true,
        unstable_useTransitions: false
    });
}
function $84c11e79798ea0cb$export$3d80f15952491985({ context: context, router: router, hydrate: hydrate2 = true, nonce: nonce }) {
    $84c11e79798ea0cb$export$f5708dca728d7177(router && context, "You must provide `router` and `context` to <StaticRouterProvider>");
    let dataRouterContext = {
        router: router,
        navigator: $84c11e79798ea0cb$var$getStatelessNavigator(),
        static: true,
        staticContext: context,
        basename: context.basename || "/"
    };
    let fetchersContext = /* @__PURE__ */ new Map();
    let hydrateScript = "";
    if (hydrate2 !== false) {
        let data2 = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $84c11e79798ea0cb$var$serializeErrors(context.errors)
        };
        let json = $84c11e79798ea0cb$export$4cf11838cdc2a8a8(JSON.stringify(JSON.stringify(data2)));
        hydrateScript = `window.__staticRouterHydrationData = JSON.parse(${json});`;
    }
    let { state: state } = dataRouterContext.router;
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$2eeee58951ff3c1c.Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$315e3ffb01f217.Provider, {
        value: state
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$cb3f1df1bef00a39.Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$3681f408decb40d1.Provider, {
        value: {
            isTransitioning: false
        }
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$export$55185c17a0fcbe46, {
        basename: dataRouterContext.basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: dataRouterContext.navigator,
        static: dataRouterContext.static,
        unstable_useTransitions: false
    }, /* @__PURE__ */ $acw62.createElement($84c11e79798ea0cb$var$DataRoutes2, {
        routes: router.routes,
        future: router.future,
        state: state
    })))))), hydrateScript ? /* @__PURE__ */ $acw62.createElement("script", {
        suppressHydrationWarning: true,
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: hydrateScript
        }
    }) : null);
}
function $84c11e79798ea0cb$var$DataRoutes2({ routes: routes, future: future, state: state }) {
    return $84c11e79798ea0cb$var$useRoutesImpl(routes, void 0, state, void 0, future);
}
function $84c11e79798ea0cb$var$serializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ($84c11e79798ea0cb$export$972111febbeef05b(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) serialized[key] = {
            message: val.message,
            __type: "Error",
            // If this is a subclass (i.e., ReferenceError), send up the type so we
            // can re-create the same type during hydration.
            ...val.name !== "Error" ? {
                __subType: val.name
            } : {}
        };
        else serialized[key] = val;
    }
    return serialized;
}
function $84c11e79798ea0cb$var$getStatelessNavigator() {
    return {
        createHref: $84c11e79798ea0cb$var$createHref,
        encodeLocation: $84c11e79798ea0cb$var$encodeLocation,
        push (to) {
            throw new Error(`You cannot use navigator.push() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)})\` somewhere in your app.`);
        },
        replace (to) {
            throw new Error(`You cannot use navigator.replace() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${JSON.stringify(to)}, { replace: true })\` somewhere in your app.`);
        },
        go (delta) {
            throw new Error(`You cannot use navigator.go() on the server because it is a stateless environment. This error was probably triggered when you did a \`navigate(${delta})\` somewhere in your app.`);
        },
        back () {
            throw new Error(`You cannot use navigator.back() on the server because it is a stateless environment.`);
        },
        forward () {
            throw new Error(`You cannot use navigator.forward() on the server because it is a stateless environment.`);
        }
    };
}
function $84c11e79798ea0cb$export$69163f0b72ec60d9(routes, opts) {
    return $84c11e79798ea0cb$export$3336b097a6fbc59a(routes, {
        ...opts,
        mapRouteProperties: $84c11e79798ea0cb$export$9269a41d8c4635e
    });
}
function $84c11e79798ea0cb$export$3dd6171c30258b6f(routes, context, opts = {}) {
    let manifest = {};
    let dataRoutes = $84c11e79798ea0cb$export$87cb1a9238dc3fba(routes, $84c11e79798ea0cb$export$9269a41d8c4635e, void 0, manifest);
    let matches = context.matches.map((match)=>{
        let route = manifest[match.route.id] || match.route;
        return {
            ...match,
            route: route
        };
    });
    let msg = (method)=>`You cannot use router.${method}() on the server because it is a stateless environment`;
    return {
        get basename () {
            return context.basename;
        },
        get future () {
            return {
                v8_middleware: false,
                ...opts?.future
            };
        },
        get state () {
            return {
                historyAction: "POP" /* Pop */ ,
                location: context.location,
                matches: matches,
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: context.errors,
                initialized: true,
                navigation: $84c11e79798ea0cb$export$ed3e14b2f9e105d0,
                restoreScrollPosition: null,
                preventScrollReset: false,
                revalidation: "idle",
                fetchers: /* @__PURE__ */ new Map(),
                blockers: /* @__PURE__ */ new Map()
            };
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return void 0;
        },
        initialize () {
            throw msg("initialize");
        },
        subscribe () {
            throw msg("subscribe");
        },
        enableScrollRestoration () {
            throw msg("enableScrollRestoration");
        },
        navigate () {
            throw msg("navigate");
        },
        fetch () {
            throw msg("fetch");
        },
        revalidate () {
            throw msg("revalidate");
        },
        createHref: $84c11e79798ea0cb$var$createHref,
        encodeLocation: $84c11e79798ea0cb$var$encodeLocation,
        getFetcher () {
            return $84c11e79798ea0cb$export$52eace9c284d3585;
        },
        deleteFetcher () {
            throw msg("deleteFetcher");
        },
        resetFetcher () {
            throw msg("resetFetcher");
        },
        dispose () {
            throw msg("dispose");
        },
        getBlocker () {
            return $84c11e79798ea0cb$export$386d57f03f0b2883;
        },
        deleteBlocker () {
            throw msg("deleteBlocker");
        },
        patchRoutes () {
            throw msg("patchRoutes");
        },
        _internalFetchControllers: /* @__PURE__ */ new Map(),
        _internalSetRoutes () {
            throw msg("_internalSetRoutes");
        },
        _internalSetStateDoNotUseOrYouWillBreakYourApp () {
            throw msg("_internalSetStateDoNotUseOrYouWillBreakYourApp");
        }
    };
}
function $84c11e79798ea0cb$var$createHref(to) {
    return typeof to === "string" ? to : $84c11e79798ea0cb$export$fe53371bee54353d(to);
}
function $84c11e79798ea0cb$var$encodeLocation(to) {
    let href = typeof to === "string" ? to : $84c11e79798ea0cb$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    let encoded = $84c11e79798ea0cb$var$ABSOLUTE_URL_REGEX3.test(href) ? new URL(href) : new URL(href, "http://localhost");
    return {
        pathname: encoded.pathname,
        search: encoded.search,
        hash: encoded.hash
    };
}
var $84c11e79798ea0cb$var$ABSOLUTE_URL_REGEX3 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;



var $acw62 = parcelRequire("acw62");

parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $0d72ae83f7641f56$exports = {};
'use strict';

$0d72ae83f7641f56$exports = (parcelRequire("gijsP"));


function $2985df77ba145d35$export$53b83ca8eaab0383(item) {
    if (typeof item !== 'object' || item === null) return false;
    const prototype = Object.getPrototypeOf(item);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in item) && !(Symbol.iterator in item);
}
function $2985df77ba145d35$var$deepClone(source) {
    if (/*#__PURE__*/ $acw62.isValidElement(source) || (0, $0d72ae83f7641f56$exports.isValidElementType)(source) || !$2985df77ba145d35$export$53b83ca8eaab0383(source)) return source;
    const output = {};
    Object.keys(source).forEach((key)=>{
        output[key] = $2985df77ba145d35$var$deepClone(source[key]);
    });
    return output;
}
function $2985df77ba145d35$export$2e2bcd8739ae039(target, source, options = {
    clone: true
}) {
    const output = options.clone ? {
        ...target
    } : target;
    if ($2985df77ba145d35$export$53b83ca8eaab0383(target) && $2985df77ba145d35$export$53b83ca8eaab0383(source)) Object.keys(source).forEach((key)=>{
        if (/*#__PURE__*/ $acw62.isValidElement(source[key]) || (0, $0d72ae83f7641f56$exports.isValidElementType)(source[key])) output[key] = source[key];
        else if ($2985df77ba145d35$export$53b83ca8eaab0383(source[key]) && // Avoid prototype pollution
        Object.prototype.hasOwnProperty.call(target, key) && $2985df77ba145d35$export$53b83ca8eaab0383(target[key])) // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = $2985df77ba145d35$export$2e2bcd8739ae039(target[key], source[key], options);
        else if (options.clone) output[key] = $2985df77ba145d35$export$53b83ca8eaab0383(source[key]) ? $2985df77ba145d35$var$deepClone(source[key]) : source[key];
        else output[key] = source[key];
    });
    return output;
}






function $e5a728ecb1a1c3c0$var$merge(acc, item) {
    if (!item) return acc;
    return (0, $2985df77ba145d35$export$2e2bcd8739ae039)(acc, item, {
        clone: false // No need to clone deep, it's way faster.
    });
}
var $e5a728ecb1a1c3c0$export$2e2bcd8739ae039 = $e5a728ecb1a1c3c0$var$merge;



function $91bc4077911678f2$export$456f6c1142f990db(theme, css) {
    if (!theme.containerQueries) return css;
    const sorted = Object.keys(css).filter((key)=>key.startsWith('@container')).sort((a, b)=>{
        const regex = /min-width:\s*([0-9.]+)/;
        return +(a.match(regex)?.[1] || 0) - +(b.match(regex)?.[1] || 0);
    });
    if (!sorted.length) return css;
    return sorted.reduce((acc, key)=>{
        const value = css[key];
        delete acc[key];
        acc[key] = value;
        return acc;
    }, {
        ...css
    });
}
function $91bc4077911678f2$export$77c7c3e357f440e7(breakpointKeys, value) {
    return value === '@' || value.startsWith('@') && (breakpointKeys.some((key)=>value.startsWith(`@${key}`)) || !!value.match(/^@\d/));
}
function $91bc4077911678f2$export$10a9745dfa00d15(theme, shorthand) {
    const matches = shorthand.match(/^@([^/]+)?\/?(.+)?$/);
    if (!matches) return null;
    const [, containerQuery, containerName] = matches;
    const value = Number.isNaN(+containerQuery) ? containerQuery || 0 : +containerQuery;
    return theme.containerQueries(containerName).up(value);
}
function $91bc4077911678f2$export$2e2bcd8739ae039(themeInput) {
    const toContainerQuery = (mediaQuery, name)=>mediaQuery.replace('@media', name ? `@container ${name}` : '@container');
    function attachCq(node, name) {
        node.up = (...args)=>toContainerQuery(themeInput.breakpoints.up(...args), name);
        node.down = (...args)=>toContainerQuery(themeInput.breakpoints.down(...args), name);
        node.between = (...args)=>toContainerQuery(themeInput.breakpoints.between(...args), name);
        node.only = (...args)=>toContainerQuery(themeInput.breakpoints.only(...args), name);
        node.not = (...args)=>{
            const result = toContainerQuery(themeInput.breakpoints.not(...args), name);
            if (result.includes('not all and')) // `@container` does not work with `not all and`, so need to invert the logic
            return result.replace('not all and ', '').replace('min-width:', 'width<').replace('max-width:', 'width>').replace('and', 'or');
            return result;
        };
    }
    const node = {};
    const containerQueries = (name)=>{
        attachCq(node, name);
        return node;
    };
    attachCq(containerQueries);
    return {
        ...themeInput,
        containerQueries: containerQueries
    };
}


const $5d96decff5ccffcb$export$68c286be0e7e55b7 = {
    xs: 0,
    // phone
    sm: 600,
    // tablet
    md: 900,
    // small laptop
    lg: 1200,
    // desktop
    xl: 1536 // large screen
};
const $5d96decff5ccffcb$var$defaultBreakpoints = {
    // Sorted ASC by size. That's important.
    // It can't be configured as it's used statically for propTypes.
    keys: [
        'xs',
        'sm',
        'md',
        'lg',
        'xl'
    ],
    up: (key)=>`@media (min-width:${$5d96decff5ccffcb$export$68c286be0e7e55b7[key]}px)`
};
const $5d96decff5ccffcb$var$defaultContainerQueries = {
    containerQueries: (containerName)=>({
            up: (key)=>{
                let result = typeof key === 'number' ? key : $5d96decff5ccffcb$export$68c286be0e7e55b7[key] || key;
                if (typeof result === 'number') result = `${result}px`;
                return containerName ? `@container ${containerName} (min-width:${result})` : `@container (min-width:${result})`;
            }
        })
};
function $5d96decff5ccffcb$export$88347efdb2e19abd(props, propValue, styleFromPropValue) {
    const theme = props.theme || {};
    if (Array.isArray(propValue)) {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return propValue.reduce((acc, item, index)=>{
            acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
            return acc;
        }, {});
    }
    if (typeof propValue === 'object') {
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        return Object.keys(propValue).reduce((acc, breakpoint)=>{
            if ((0, $91bc4077911678f2$export$77c7c3e357f440e7)(themeBreakpoints.keys, breakpoint)) {
                const containerKey = (0, $91bc4077911678f2$export$10a9745dfa00d15)(theme.containerQueries ? theme : $5d96decff5ccffcb$var$defaultContainerQueries, breakpoint);
                if (containerKey) acc[containerKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else if (Object.keys(themeBreakpoints.values || $5d96decff5ccffcb$export$68c286be0e7e55b7).includes(breakpoint)) {
                const mediaKey = themeBreakpoints.up(breakpoint);
                acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
            } else {
                const cssKey = breakpoint;
                acc[cssKey] = propValue[cssKey];
            }
            return acc;
        }, {});
    }
    const output = styleFromPropValue(propValue);
    return output;
}
function $5d96decff5ccffcb$var$breakpoints(styleFunction) {
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const newStyleFunction = (props)=>{
        const theme = props.theme || {};
        const base = styleFunction(props);
        const themeBreakpoints = theme.breakpoints || $5d96decff5ccffcb$var$defaultBreakpoints;
        const extended = themeBreakpoints.keys.reduce((acc, key)=>{
            if (props[key]) {
                acc = acc || {};
                acc[themeBreakpoints.up(key)] = styleFunction({
                    theme: theme,
                    ...props[key]
                });
            }
            return acc;
        }, null);
        return (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(base, extended);
    };
    newStyleFunction.propTypes = {};
    newStyleFunction.filterProps = [
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        ...styleFunction.filterProps
    ];
    return newStyleFunction;
}
function $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput = {}) {
    const breakpointsInOrder = breakpointsInput.keys?.reduce((acc, key)=>{
        const breakpointStyleKey = breakpointsInput.up(key);
        acc[breakpointStyleKey] = {};
        return acc;
    }, {});
    return breakpointsInOrder || {};
}
function $5d96decff5ccffcb$export$8922c90b6e020726(breakpointKeys, style) {
    return breakpointKeys.reduce((acc, key)=>{
        const breakpointOutput = acc[key];
        const isBreakpointUnused = !breakpointOutput || Object.keys(breakpointOutput).length === 0;
        if (isBreakpointUnused) delete acc[key];
        return acc;
    }, style);
}
function $5d96decff5ccffcb$export$b89a003a1e05c0ee(breakpointsInput, ...styles) {
    const emptyBreakpoints = $5d96decff5ccffcb$export$1f2600516e91381f(breakpointsInput);
    const mergedOutput = [
        emptyBreakpoints,
        ...styles
    ].reduce((prev, next)=>(0, $2985df77ba145d35$export$2e2bcd8739ae039)(prev, next), {});
    return $5d96decff5ccffcb$export$8922c90b6e020726(Object.keys(emptyBreakpoints), mergedOutput);
}
function $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints) {
    // fixed value
    if (typeof breakpointValues !== 'object') return {};
    const base = {};
    const breakpointsKeys = Object.keys(themeBreakpoints);
    if (Array.isArray(breakpointValues)) breakpointsKeys.forEach((breakpoint, i)=>{
        if (i < breakpointValues.length) base[breakpoint] = true;
    });
    else breakpointsKeys.forEach((breakpoint)=>{
        if (breakpointValues[breakpoint] != null) base[breakpoint] = true;
    });
    return base;
}
function $5d96decff5ccffcb$export$980e6a259d807490({ values: breakpointValues, breakpoints: themeBreakpoints, base: customBase }) {
    const base = customBase || $5d96decff5ccffcb$export$ead4e80eca2ebb85(breakpointValues, themeBreakpoints);
    const keys = Object.keys(base);
    if (keys.length === 0) return breakpointValues;
    let previous;
    return keys.reduce((acc, breakpoint, i)=>{
        if (Array.isArray(breakpointValues)) {
            acc[breakpoint] = breakpointValues[i] != null ? breakpointValues[i] : breakpointValues[previous];
            previous = i;
        } else if (typeof breakpointValues === 'object') {
            acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
            previous = breakpoint;
        } else acc[breakpoint] = breakpointValues;
        return acc;
    }, {});
}
var $5d96decff5ccffcb$export$2e2bcd8739ae039 = $5d96decff5ccffcb$var$breakpoints;


/**
 * WARNING: Don't import this directly. It's imported by the code generated by
 * `@mui/interal-babel-plugin-minify-errors`. Make sure to always use string literals in `Error`
 * constructors to ensure the plugin works as expected. Supported patterns include:
 *   throw new Error('My message');
 *   throw new Error(`My message: ${foo}`);
 *   throw new Error(`My message: ${foo}` + 'another string');
 *   ...
 * @param {number} code
 */ function $90895d1859655b11$export$2e2bcd8739ae039(code, ...args) {
    const url = new URL(`https://mui.com/production-error/?code=${code}`);
    args.forEach((arg)=>url.searchParams.append('args[]', arg));
    return `Minified MUI error #${code}; visit ${url} for the full message.`;
}


function $c0a836f2f53d8f74$export$2e2bcd8739ae039(string) {
    if (typeof string !== 'string') throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(7));
    return string.charAt(0).toUpperCase() + string.slice(1);
}




function $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(obj, path, checkVars = true) {
    if (!path || typeof path !== 'string') return null;
    // Check if CSS variables are used
    if (obj && obj.vars && checkVars) {
        const val = `vars.${path}`.split('.').reduce((acc, item)=>acc && acc[item] ? acc[item] : null, obj);
        if (val != null) return val;
    }
    return path.split('.').reduce((acc, item)=>{
        if (acc && acc[item] != null) return acc[item];
        return null;
    }, obj);
}
function $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
    let value;
    if (typeof themeMapping === 'function') value = themeMapping(propValueFinal);
    else if (Array.isArray(themeMapping)) value = themeMapping[propValueFinal] || userValue;
    else value = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(themeMapping, propValueFinal) || userValue;
    if (transform) value = transform(value, userValue, themeMapping);
    return value;
}
function $d50fcf9a3ec00b94$var$style(options) {
    const { prop: prop, cssProperty: cssProperty = options.prop, themeKey: themeKey, transform: transform } = options;
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        if (props[prop] == null) return null;
        const propValue = props[prop];
        const theme = props.theme;
        const themeMapping = $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8(theme, themeKey) || {};
        const styleFromPropValue = (propValueFinal)=>{
            let value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = $d50fcf9a3ec00b94$export$741ad47189a64aa0(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
    };
    fn.propTypes = {};
    fn.filterProps = [
        prop
    ];
    return fn;
}
var $d50fcf9a3ec00b94$export$2e2bcd8739ae039 = $d50fcf9a3ec00b94$var$style;



function $c9a3e017c1fe4096$export$2e2bcd8739ae039(fn) {
    const cache = {};
    return (arg)=>{
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


const $555e14aafbcd0190$var$properties = {
    m: 'margin',
    p: 'padding'
};
const $555e14aafbcd0190$var$directions = {
    t: 'Top',
    r: 'Right',
    b: 'Bottom',
    l: 'Left',
    x: [
        'Left',
        'Right'
    ],
    y: [
        'Top',
        'Bottom'
    ]
};
const $555e14aafbcd0190$var$aliases = {
    marginX: 'mx',
    marginY: 'my',
    paddingX: 'px',
    paddingY: 'py'
};
// memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec
const $555e14aafbcd0190$var$getCssProperties = (0, $c9a3e017c1fe4096$export$2e2bcd8739ae039)((prop)=>{
    // It's not a shorthand notation.
    if (prop.length > 2) {
        if ($555e14aafbcd0190$var$aliases[prop]) prop = $555e14aafbcd0190$var$aliases[prop];
        else return [
            prop
        ];
    }
    const [a, b] = prop.split('');
    const property = $555e14aafbcd0190$var$properties[a];
    const direction = $555e14aafbcd0190$var$directions[b] || '';
    return Array.isArray(direction) ? direction.map((dir)=>property + dir) : [
        property + direction
    ];
});
const $555e14aafbcd0190$export$aab52a0dde05ad8a = [
    'm',
    'mt',
    'mr',
    'mb',
    'ml',
    'mx',
    'my',
    'margin',
    'marginTop',
    'marginRight',
    'marginBottom',
    'marginLeft',
    'marginX',
    'marginY',
    'marginInline',
    'marginInlineStart',
    'marginInlineEnd',
    'marginBlock',
    'marginBlockStart',
    'marginBlockEnd'
];
const $555e14aafbcd0190$export$f8397d44f03ab6ad = [
    'p',
    'pt',
    'pr',
    'pb',
    'pl',
    'px',
    'py',
    'padding',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'paddingX',
    'paddingY',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd'
];
const $555e14aafbcd0190$var$spacingKeys = [
    ...$555e14aafbcd0190$export$aab52a0dde05ad8a,
    ...$555e14aafbcd0190$export$f8397d44f03ab6ad
];
function $555e14aafbcd0190$export$cb5ee237cce814a2(theme, themeKey, defaultValue, propName) {
    const themeSpacing = (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, themeKey, true) ?? defaultValue;
    if (typeof themeSpacing === 'number' || typeof themeSpacing === 'string') return (val)=>{
        if (typeof val === 'string') return val;
        if (typeof themeSpacing === 'string') {
            if (themeSpacing.startsWith('var(') && val === 0) return 0;
            if (themeSpacing.startsWith('var(') && val === 1) return themeSpacing;
            return `calc(${val} * ${themeSpacing})`;
        }
        return themeSpacing * val;
    };
    if (Array.isArray(themeSpacing)) return (val)=>{
        if (typeof val === 'string') return val;
        const abs = Math.abs(val);
        const transformed = themeSpacing[abs];
        if (val >= 0) return transformed;
        if (typeof transformed === 'number') return -transformed;
        if (typeof transformed === 'string' && transformed.startsWith('var(')) return `calc(-1 * ${transformed})`;
        return `-${transformed}`;
    };
    if (typeof themeSpacing === 'function') return themeSpacing;
    return ()=>undefined;
}
function $555e14aafbcd0190$export$1def6f833384e3d1(theme) {
    return $555e14aafbcd0190$export$cb5ee237cce814a2(theme, 'spacing', 8, 'spacing');
}
function $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue) {
    if (typeof propValue === 'string' || propValue == null) return propValue;
    return transformer(propValue);
}
function $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer) {
    return (propValue)=>cssProperties.reduce((acc, cssProperty)=>{
            acc[cssProperty] = $555e14aafbcd0190$export$bf7199a9ebcb84a9(transformer, propValue);
            return acc;
        }, {});
}
function $555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (!keys.includes(prop)) return null;
    const cssProperties = $555e14aafbcd0190$var$getCssProperties(prop);
    const styleFromPropValue = $555e14aafbcd0190$export$1dc0036b298ea8d1(cssProperties, transformer);
    const propValue = props[prop];
    return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, propValue, styleFromPropValue);
}
function $555e14aafbcd0190$var$style(props, keys) {
    const transformer = $555e14aafbcd0190$export$1def6f833384e3d1(props.theme);
    return Object.keys(props).map((prop)=>$555e14aafbcd0190$var$resolveCssProperty(props, keys, prop, transformer)).reduce((0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039), {});
}
function $555e14aafbcd0190$export$7ede87f9b603dd3c(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$aab52a0dde05ad8a);
}
$555e14aafbcd0190$export$7ede87f9b603dd3c.propTypes = {};
$555e14aafbcd0190$export$7ede87f9b603dd3c.filterProps = $555e14aafbcd0190$export$aab52a0dde05ad8a;
function $555e14aafbcd0190$export$6f98e8eaf0be1996(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$export$f8397d44f03ab6ad);
}
$555e14aafbcd0190$export$6f98e8eaf0be1996.propTypes = {};
$555e14aafbcd0190$export$6f98e8eaf0be1996.filterProps = $555e14aafbcd0190$export$f8397d44f03ab6ad;
function $555e14aafbcd0190$var$spacing(props) {
    return $555e14aafbcd0190$var$style(props, $555e14aafbcd0190$var$spacingKeys);
}
$555e14aafbcd0190$var$spacing.propTypes = {};
$555e14aafbcd0190$var$spacing.filterProps = $555e14aafbcd0190$var$spacingKeys;
var $555e14aafbcd0190$export$2e2bcd8739ae039 = $555e14aafbcd0190$var$spacing;





function $ce5a4af256600fcc$var$compose(...styles) {
    const handlers = styles.reduce((acc, style)=>{
        style.filterProps.forEach((prop)=>{
            acc[prop] = style;
        });
        return acc;
    }, {});
    // false positive
    // eslint-disable-next-line react/function-component-definition
    const fn = (props)=>{
        return Object.keys(props).reduce((acc, prop)=>{
            if (handlers[prop]) return (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(acc, handlers[prop](props));
            return acc;
        }, {});
    };
    fn.propTypes = {};
    fn.filterProps = styles.reduce((acc, style)=>acc.concat(style.filterProps), []);
    return fn;
}
var $ce5a4af256600fcc$export$2e2bcd8739ae039 = $ce5a4af256600fcc$var$compose;




function $c2b4d2c425fe2f29$export$34e2febe53ae29cc(value) {
    if (typeof value !== 'number') return value;
    return `${value}px solid`;
}
function $c2b4d2c425fe2f29$var$createBorderStyle(prop, transform) {
    return (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
        prop: prop,
        themeKey: 'borders',
        transform: transform
    });
}
const $c2b4d2c425fe2f29$export$1edee58a52776cd9 = $c2b4d2c425fe2f29$var$createBorderStyle('border', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$f9a7b6bd24892946 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTop', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$5abca33e6be905d2 = $c2b4d2c425fe2f29$var$createBorderStyle('borderRight', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e2ce9f12a980a822 = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottom', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$47658cca1a909427 = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeft', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$e7fb0694ba2404fc = $c2b4d2c425fe2f29$var$createBorderStyle('borderColor');
const $c2b4d2c425fe2f29$export$126a92c968acdb85 = $c2b4d2c425fe2f29$var$createBorderStyle('borderTopColor');
const $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e = $c2b4d2c425fe2f29$var$createBorderStyle('borderRightColor');
const $c2b4d2c425fe2f29$export$340b0327727f6d1a = $c2b4d2c425fe2f29$var$createBorderStyle('borderBottomColor');
const $c2b4d2c425fe2f29$export$60beef91a985b4bf = $c2b4d2c425fe2f29$var$createBorderStyle('borderLeftColor');
const $c2b4d2c425fe2f29$export$f9258c55612cbed7 = $c2b4d2c425fe2f29$var$createBorderStyle('outline', $c2b4d2c425fe2f29$export$34e2febe53ae29cc);
const $c2b4d2c425fe2f29$export$621fe586efeb64b9 = $c2b4d2c425fe2f29$var$createBorderStyle('outlineColor');
const $c2b4d2c425fe2f29$export$7a57f79000377ca2 = (props)=>{
    if (props.borderRadius !== undefined && props.borderRadius !== null) {
        const transformer = (0, $555e14aafbcd0190$export$cb5ee237cce814a2)(props.theme, 'shape.borderRadius', 4, 'borderRadius');
        const styleFromPropValue = (propValue)=>({
                borderRadius: (0, $555e14aafbcd0190$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.borderRadius, styleFromPropValue);
    }
    return null;
};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.propTypes = {};
$c2b4d2c425fe2f29$export$7a57f79000377ca2.filterProps = [
    'borderRadius'
];
const $c2b4d2c425fe2f29$var$borders = (0, $ce5a4af256600fcc$export$2e2bcd8739ae039)($c2b4d2c425fe2f29$export$1edee58a52776cd9, $c2b4d2c425fe2f29$export$f9a7b6bd24892946, $c2b4d2c425fe2f29$export$5abca33e6be905d2, $c2b4d2c425fe2f29$export$e2ce9f12a980a822, $c2b4d2c425fe2f29$export$47658cca1a909427, $c2b4d2c425fe2f29$export$e7fb0694ba2404fc, $c2b4d2c425fe2f29$export$126a92c968acdb85, $c2b4d2c425fe2f29$export$85cc51cb8fbb8c0e, $c2b4d2c425fe2f29$export$340b0327727f6d1a, $c2b4d2c425fe2f29$export$60beef91a985b4bf, $c2b4d2c425fe2f29$export$7a57f79000377ca2, $c2b4d2c425fe2f29$export$f9258c55612cbed7, $c2b4d2c425fe2f29$export$621fe586efeb64b9);
var $c2b4d2c425fe2f29$export$2e2bcd8739ae039 = $c2b4d2c425fe2f29$var$borders;







const $b007bd6739310ca0$export$5df9adcb0db95e1e = (props)=>{
    if (props.gap !== undefined && props.gap !== null) {
        const transformer = (0, $555e14aafbcd0190$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'gap');
        const styleFromPropValue = (propValue)=>({
                gap: (0, $555e14aafbcd0190$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.gap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$5df9adcb0db95e1e.propTypes = {};
$b007bd6739310ca0$export$5df9adcb0db95e1e.filterProps = [
    'gap'
];
const $b007bd6739310ca0$export$ec60d70ff941a580 = (props)=>{
    if (props.columnGap !== undefined && props.columnGap !== null) {
        const transformer = (0, $555e14aafbcd0190$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'columnGap');
        const styleFromPropValue = (propValue)=>({
                columnGap: (0, $555e14aafbcd0190$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.columnGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$ec60d70ff941a580.propTypes = {};
$b007bd6739310ca0$export$ec60d70ff941a580.filterProps = [
    'columnGap'
];
const $b007bd6739310ca0$export$8a833ffa5f5dbeda = (props)=>{
    if (props.rowGap !== undefined && props.rowGap !== null) {
        const transformer = (0, $555e14aafbcd0190$export$cb5ee237cce814a2)(props.theme, 'spacing', 8, 'rowGap');
        const styleFromPropValue = (propValue)=>({
                rowGap: (0, $555e14aafbcd0190$export$bf7199a9ebcb84a9)(transformer, propValue)
            });
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.rowGap, styleFromPropValue);
    }
    return null;
};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.propTypes = {};
$b007bd6739310ca0$export$8a833ffa5f5dbeda.filterProps = [
    'rowGap'
];
const $b007bd6739310ca0$export$baf44164ca3a34e8 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridColumn'
});
const $b007bd6739310ca0$export$8f7213a1cd01e832 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridRow'
});
const $b007bd6739310ca0$export$b0e0abbc49ba668 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridAutoFlow'
});
const $b007bd6739310ca0$export$bcd8b929d4b4142 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridAutoColumns'
});
const $b007bd6739310ca0$export$e5039a674e14c828 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridAutoRows'
});
const $b007bd6739310ca0$export$42bd9088661ffb03 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridTemplateColumns'
});
const $b007bd6739310ca0$export$920682ae05b999bc = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridTemplateRows'
});
const $b007bd6739310ca0$export$1b88fbdd482fd33a = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridTemplateAreas'
});
const $b007bd6739310ca0$export$bdb486e40d52d26f = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'gridArea'
});
const $b007bd6739310ca0$var$grid = (0, $ce5a4af256600fcc$export$2e2bcd8739ae039)($b007bd6739310ca0$export$5df9adcb0db95e1e, $b007bd6739310ca0$export$ec60d70ff941a580, $b007bd6739310ca0$export$8a833ffa5f5dbeda, $b007bd6739310ca0$export$baf44164ca3a34e8, $b007bd6739310ca0$export$8f7213a1cd01e832, $b007bd6739310ca0$export$b0e0abbc49ba668, $b007bd6739310ca0$export$bcd8b929d4b4142, $b007bd6739310ca0$export$e5039a674e14c828, $b007bd6739310ca0$export$42bd9088661ffb03, $b007bd6739310ca0$export$920682ae05b999bc, $b007bd6739310ca0$export$1b88fbdd482fd33a, $b007bd6739310ca0$export$bdb486e40d52d26f);
var $b007bd6739310ca0$export$2e2bcd8739ae039 = $b007bd6739310ca0$var$grid;




function $b08badac1d124df3$export$dbaffd4420ea0ac6(value, userValue) {
    if (userValue === 'grey') return userValue;
    return value;
}
const $b08badac1d124df3$export$35e9368ef982300f = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'color',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$2506f56c10355b33 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'bgcolor',
    cssProperty: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$export$8c5a050822fd698c = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'backgroundColor',
    themeKey: 'palette',
    transform: $b08badac1d124df3$export$dbaffd4420ea0ac6
});
const $b08badac1d124df3$var$palette = (0, $ce5a4af256600fcc$export$2e2bcd8739ae039)($b08badac1d124df3$export$35e9368ef982300f, $b08badac1d124df3$export$2506f56c10355b33, $b08badac1d124df3$export$8c5a050822fd698c);
var $b08badac1d124df3$export$2e2bcd8739ae039 = $b08badac1d124df3$var$palette;





function $60c239303eb89b20$export$8afece71750ec241(value) {
    return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}
const $60c239303eb89b20$export$7e3df82ee760448c = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$488fda99655ff65a = (props)=>{
    if (props.maxWidth !== undefined && props.maxWidth !== null) {
        const styleFromPropValue = (propValue)=>{
            const breakpoint = props.theme?.breakpoints?.values?.[propValue] || (0, $5d96decff5ccffcb$export$68c286be0e7e55b7)[propValue];
            if (!breakpoint) return {
                maxWidth: $60c239303eb89b20$export$8afece71750ec241(propValue)
            };
            if (props.theme?.breakpoints?.unit !== 'px') return {
                maxWidth: `${breakpoint}${props.theme.breakpoints.unit}`
            };
            return {
                maxWidth: breakpoint
            };
        };
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, props.maxWidth, styleFromPropValue);
    }
    return null;
};
$60c239303eb89b20$export$488fda99655ff65a.filterProps = [
    'maxWidth'
];
const $60c239303eb89b20$export$ee148fbbe8357dd2 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'minWidth',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ac607276a8fe9f0a = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$dc0d8bd0b94f8570 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'maxHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$a43cf604e12f3b17 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'minHeight',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$ffed9f14fb65e276 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'width',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$905076ed6620e671 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'size',
    cssProperty: 'height',
    transform: $60c239303eb89b20$export$8afece71750ec241
});
const $60c239303eb89b20$export$6ccc93f785106a58 = (0, $d50fcf9a3ec00b94$export$2e2bcd8739ae039)({
    prop: 'boxSizing'
});
const $60c239303eb89b20$var$sizing = (0, $ce5a4af256600fcc$export$2e2bcd8739ae039)($60c239303eb89b20$export$7e3df82ee760448c, $60c239303eb89b20$export$488fda99655ff65a, $60c239303eb89b20$export$ee148fbbe8357dd2, $60c239303eb89b20$export$ac607276a8fe9f0a, $60c239303eb89b20$export$dc0d8bd0b94f8570, $60c239303eb89b20$export$a43cf604e12f3b17, $60c239303eb89b20$export$6ccc93f785106a58);
var $60c239303eb89b20$export$2e2bcd8739ae039 = $60c239303eb89b20$var$sizing;


const $f27f6a6c429b3415$var$defaultSxConfig = {
    // borders
    border: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderTop: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderRight: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderBottom: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderLeft: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    borderColor: {
        themeKey: 'palette'
    },
    borderTopColor: {
        themeKey: 'palette'
    },
    borderRightColor: {
        themeKey: 'palette'
    },
    borderBottomColor: {
        themeKey: 'palette'
    },
    borderLeftColor: {
        themeKey: 'palette'
    },
    outline: {
        themeKey: 'borders',
        transform: (0, $c2b4d2c425fe2f29$export$34e2febe53ae29cc)
    },
    outlineColor: {
        themeKey: 'palette'
    },
    borderRadius: {
        themeKey: 'shape.borderRadius',
        style: (0, $c2b4d2c425fe2f29$export$7a57f79000377ca2)
    },
    // palette
    color: {
        themeKey: 'palette',
        transform: (0, $b08badac1d124df3$export$dbaffd4420ea0ac6)
    },
    bgcolor: {
        themeKey: 'palette',
        cssProperty: 'backgroundColor',
        transform: (0, $b08badac1d124df3$export$dbaffd4420ea0ac6)
    },
    backgroundColor: {
        themeKey: 'palette',
        transform: (0, $b08badac1d124df3$export$dbaffd4420ea0ac6)
    },
    // spacing
    p: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    pt: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    pr: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    pb: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    pl: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    px: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    py: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    padding: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingTop: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingRight: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingBottom: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingLeft: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingX: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingY: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingInline: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingInlineStart: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingInlineEnd: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingBlock: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingBlockStart: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    paddingBlockEnd: {
        style: (0, $555e14aafbcd0190$export$6f98e8eaf0be1996)
    },
    m: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    mt: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    mr: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    mb: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    ml: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    mx: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    my: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    margin: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginTop: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginRight: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginBottom: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginLeft: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginX: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginY: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginInline: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginInlineStart: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginInlineEnd: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginBlock: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginBlockStart: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    marginBlockEnd: {
        style: (0, $555e14aafbcd0190$export$7ede87f9b603dd3c)
    },
    // display
    displayPrint: {
        cssProperty: false,
        transform: (value)=>({
                '@media print': {
                    display: value
                }
            })
    },
    display: {},
    overflow: {},
    textOverflow: {},
    visibility: {},
    whiteSpace: {},
    // flexbox
    flexBasis: {},
    flexDirection: {},
    flexWrap: {},
    justifyContent: {},
    alignItems: {},
    alignContent: {},
    order: {},
    flex: {},
    flexGrow: {},
    flexShrink: {},
    alignSelf: {},
    justifyItems: {},
    justifySelf: {},
    // grid
    gap: {
        style: (0, $b007bd6739310ca0$export$5df9adcb0db95e1e)
    },
    rowGap: {
        style: (0, $b007bd6739310ca0$export$8a833ffa5f5dbeda)
    },
    columnGap: {
        style: (0, $b007bd6739310ca0$export$ec60d70ff941a580)
    },
    gridColumn: {},
    gridRow: {},
    gridAutoFlow: {},
    gridAutoColumns: {},
    gridAutoRows: {},
    gridTemplateColumns: {},
    gridTemplateRows: {},
    gridTemplateAreas: {},
    gridArea: {},
    // positions
    position: {},
    zIndex: {
        themeKey: 'zIndex'
    },
    top: {},
    right: {},
    bottom: {},
    left: {},
    // shadows
    boxShadow: {
        themeKey: 'shadows'
    },
    // sizing
    width: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    maxWidth: {
        style: (0, $60c239303eb89b20$export$488fda99655ff65a)
    },
    minWidth: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    height: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    maxHeight: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    minHeight: {
        transform: (0, $60c239303eb89b20$export$8afece71750ec241)
    },
    boxSizing: {},
    // typography
    font: {
        themeKey: 'font'
    },
    fontFamily: {
        themeKey: 'typography'
    },
    fontSize: {
        themeKey: 'typography'
    },
    fontStyle: {
        themeKey: 'typography'
    },
    fontWeight: {
        themeKey: 'typography'
    },
    letterSpacing: {},
    textTransform: {},
    lineHeight: {},
    textAlign: {},
    typography: {
        cssProperty: false,
        themeKey: 'typography'
    }
};
var $f27f6a6c429b3415$export$2e2bcd8739ae039 = $f27f6a6c429b3415$var$defaultSxConfig;


const $c85eb76b78f8a14c$var$splitProps = (props)=>{
    const result = {
        systemProps: {},
        otherProps: {}
    };
    const config = props?.theme?.unstable_sxConfig ?? (0, $f27f6a6c429b3415$export$2e2bcd8739ae039);
    Object.keys(props).forEach((prop)=>{
        if (config[prop]) result.systemProps[prop] = props[prop];
        else result.otherProps[prop] = props[prop];
    });
    return result;
};
function $c85eb76b78f8a14c$export$2e2bcd8739ae039(props) {
    const { sx: inSx, ...other } = props;
    const { systemProps: systemProps, otherProps: otherProps } = $c85eb76b78f8a14c$var$splitProps(other);
    let finalSx;
    if (Array.isArray(inSx)) finalSx = [
        systemProps,
        ...inSx
    ];
    else if (typeof inSx === 'function') finalSx = (...args)=>{
        const result = inSx(...args);
        if (!(0, $2985df77ba145d35$export$53b83ca8eaab0383)(result)) return systemProps;
        return {
            ...systemProps,
            ...result
        };
    };
    else finalSx = {
        ...systemProps,
        ...inSx
    };
    return {
        ...otherProps,
        sx: finalSx
    };
}


parcelRequire("acw62");

// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
const $7c7a04bfefec7c88$export$ebf128a87553cecf = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl'
];
const $7c7a04bfefec7c88$var$sortBreakpointsValues = (values)=>{
    const breakpointsAsArray = Object.keys(values).map((key)=>({
            key: key,
            val: values[key]
        })) || [];
    // Sort in ascending order
    breakpointsAsArray.sort((breakpoint1, breakpoint2)=>breakpoint1.val - breakpoint2.val);
    return breakpointsAsArray.reduce((acc, obj)=>{
        return {
            ...acc,
            [obj.key]: obj.val
        };
    }, {});
};
function $7c7a04bfefec7c88$export$2e2bcd8739ae039(breakpoints) {
    const { values: // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    }, unit: unit = 'px', step: step = 5, ...other } = breakpoints;
    const sortedValues = $7c7a04bfefec7c88$var$sortBreakpointsValues(values);
    const keys = Object.keys(sortedValues);
    function up(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}${unit})`;
    }
    function down(key) {
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (max-width:${value - step / 100}${unit})`;
    }
    function between(start, end) {
        const endIndex = keys.indexOf(end);
        return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
    }
    function only(key) {
        if (keys.indexOf(key) + 1 < keys.length) return between(key, keys[keys.indexOf(key) + 1]);
        return up(key);
    }
    function not(key) {
        // handle first and last key separately, for better readability
        const keyIndex = keys.indexOf(key);
        if (keyIndex === 0) return up(keys[1]);
        if (keyIndex === keys.length - 1) return down(keys[keyIndex]);
        return between(key, keys[keys.indexOf(key) + 1]).replace('@media', '@media not all and');
    }
    return {
        keys: keys,
        values: sortedValues,
        up: up,
        down: down,
        between: between,
        only: only,
        not: not,
        unit: unit,
        ...other
    };
}



const $8aecb04a157fa644$var$shape = {
    borderRadius: 4
};
var $8aecb04a157fa644$export$2e2bcd8739ae039 = $8aecb04a157fa644$var$shape;



function $1f392ba2ebd18096$export$2e2bcd8739ae039(spacingInput = 8, // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
// Smaller components, such as icons, can align to a 4dp grid.
// https://m2.material.io/design/layout/understanding-layout.html
transform = (0, $555e14aafbcd0190$export$1def6f833384e3d1)({
    spacing: spacingInput
})) {
    // Already transformed.
    if (spacingInput.mui) return spacingInput;
    const spacing = (...argsInput)=>{
        const args = argsInput.length === 0 ? [
            1
        ] : argsInput;
        return args.map((argument)=>{
            const output = transform(argument);
            return typeof output === 'number' ? `${output}px` : output;
        }).join(' ');
    };
    spacing.mui = true;
    return spacing;
}








function $6b750d631801d296$var$objectsHaveSameKeys(...objects) {
    const allKeys = objects.reduce((keys, object)=>keys.concat(Object.keys(object)), []);
    const union = new Set(allKeys);
    return objects.every((object)=>union.size === Object.keys(object).length);
}
function $6b750d631801d296$var$callIfFn(maybeFn, arg) {
    return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}
function $6b750d631801d296$export$7d53d8bf2911e013() {
    function getThemeValue(prop, val, theme, config) {
        const props = {
            [prop]: val,
            theme: theme
        };
        const options = config[prop];
        if (!options) return {
            [prop]: val
        };
        const { cssProperty: cssProperty = prop, themeKey: themeKey, transform: transform, style: style } = options;
        if (val == null) return null;
        // TODO v6: remove, see https://github.com/mui/material-ui/pull/38123
        if (themeKey === 'typography' && val === 'inherit') return {
            [prop]: val
        };
        const themeMapping = (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, themeKey) || {};
        if (style) return style(props);
        const styleFromPropValue = (propValueFinal)=>{
            let value = (0, $d50fcf9a3ec00b94$export$741ad47189a64aa0)(themeMapping, transform, propValueFinal);
            if (propValueFinal === value && typeof propValueFinal === 'string') // Haven't found value
            value = (0, $d50fcf9a3ec00b94$export$741ad47189a64aa0)(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : (0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(propValueFinal)}`, propValueFinal);
            if (cssProperty === false) return value;
            return {
                [cssProperty]: value
            };
        };
        return (0, $5d96decff5ccffcb$export$88347efdb2e19abd)(props, val, styleFromPropValue);
    }
    function styleFunctionSx(props) {
        const { sx: sx, theme: theme = {}, nested: nested } = props || {};
        if (!sx) return null; // Emotion & styled-components will neglect null
        const config = theme.unstable_sxConfig ?? (0, $f27f6a6c429b3415$export$2e2bcd8739ae039);
        /*
     * Receive `sxInput` as object or callback
     * and then recursively check keys & values to create media query object styles.
     * (the result will be used in `styled`)
     */ function traverse(sxInput) {
            let sxObject = sxInput;
            if (typeof sxInput === 'function') sxObject = sxInput(theme);
            else if (typeof sxInput !== 'object') // value
            return sxInput;
            if (!sxObject) return null;
            const emptyBreakpoints = (0, $5d96decff5ccffcb$export$1f2600516e91381f)(theme.breakpoints);
            const breakpointsKeys = Object.keys(emptyBreakpoints);
            let css = emptyBreakpoints;
            Object.keys(sxObject).forEach((styleKey)=>{
                const value = $6b750d631801d296$var$callIfFn(sxObject[styleKey], theme);
                if (value !== null && value !== undefined) {
                    if (typeof value === 'object') {
                        if (config[styleKey]) css = (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                        else {
                            const breakpointsValues = (0, $5d96decff5ccffcb$export$88347efdb2e19abd)({
                                theme: theme
                            }, value, (x)=>({
                                    [styleKey]: x
                                }));
                            if ($6b750d631801d296$var$objectsHaveSameKeys(breakpointsValues, value)) css[styleKey] = styleFunctionSx({
                                sx: value,
                                theme: theme,
                                nested: true
                            });
                            else css = (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(css, breakpointsValues);
                        }
                    } else css = (0, $e5a728ecb1a1c3c0$export$2e2bcd8739ae039)(css, getThemeValue(styleKey, value, theme, config));
                }
            });
            if (!nested && theme.modularCssLayers) return {
                '@layer sx': (0, $91bc4077911678f2$export$456f6c1142f990db)(theme, (0, $5d96decff5ccffcb$export$8922c90b6e020726)(breakpointsKeys, css))
            };
            return (0, $91bc4077911678f2$export$456f6c1142f990db)(theme, (0, $5d96decff5ccffcb$export$8922c90b6e020726)(breakpointsKeys, css));
        }
        return Array.isArray(sx) ? sx.map(traverse) : traverse(sx);
    }
    return styleFunctionSx;
}
const $6b750d631801d296$var$styleFunctionSx = $6b750d631801d296$export$7d53d8bf2911e013();
$6b750d631801d296$var$styleFunctionSx.filterProps = [
    'sx'
];
var $6b750d631801d296$export$2e2bcd8739ae039 = $6b750d631801d296$var$styleFunctionSx;



/**
 * A universal utility to style components with multiple color modes. Always use it from the theme object.
 * It works with:
 *  - [Basic theme](https://mui.com/material-ui/customization/dark-mode/)
 *  - [CSS theme variables](https://mui.com/material-ui/customization/css-theme-variables/overview/)
 *  - Zero-runtime engine
 *
 * Tips: Use an array over object spread and place `theme.applyStyles()` last.
 *
 * With the styled function:
 * ✅ [{ background: '#e5e5e5' }, theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * With the sx prop:
 * ✅ [{ background: '#e5e5e5' }, theme => theme.applyStyles('dark', { background: '#1c1c1c' })]
 * 🚫 { background: '#e5e5e5', ...theme => theme.applyStyles('dark', { background: '#1c1c1c' })}
 *
 * @example
 * 1. using with `styled`:
 * ```jsx
 *   const Component = styled('div')(({ theme }) => [
 *     { background: '#e5e5e5' },
 *     theme.applyStyles('dark', {
 *       background: '#1c1c1c',
 *       color: '#fff',
 *     }),
 *   ]);
 * ```
 *
 * @example
 * 2. using with `sx` prop:
 * ```jsx
 *   <Box sx={[
 *     { background: '#e5e5e5' },
 *     theme => theme.applyStyles('dark', {
 *        background: '#1c1c1c',
 *        color: '#fff',
 *      }),
 *     ]}
 *   />
 * ```
 *
 * @example
 * 3. theming a component:
 * ```jsx
 *   extendTheme({
 *     components: {
 *       MuiButton: {
 *         styleOverrides: {
 *           root: ({ theme }) => [
 *             { background: '#e5e5e5' },
 *             theme.applyStyles('dark', {
 *               background: '#1c1c1c',
 *               color: '#fff',
 *             }),
 *           ],
 *         },
 *       }
 *     }
 *   })
 *```
 */ function $21efa8802134c535$export$2e2bcd8739ae039(key, styles) {
    // @ts-expect-error this is 'any' type
    const theme = this;
    if (theme.vars) {
        if (!theme.colorSchemes?.[key] || typeof theme.getColorSchemeSelector !== 'function') return {};
        // If CssVarsProvider is used as a provider, returns '*:where({selector}) &'
        let selector = theme.getColorSchemeSelector(key);
        if (selector === '&') return styles;
        if (selector.includes('data-') || selector.includes('.')) // '*' is required as a workaround for Emotion issue (https://github.com/emotion-js/emotion/issues/2836)
        selector = `*:where(${selector.replace(/\s*&$/, '')}) &`;
        return {
            [selector]: styles
        };
    }
    if (theme.palette.mode === key) return styles;
    return {};
}


function $4a66cd95e497efc7$var$createTheme(options = {}, ...args) {
    const { breakpoints: breakpointsInput = {}, palette: paletteInput = {}, spacing: spacingInput, shape: shapeInput = {}, ...other } = options;
    const breakpoints = (0, $7c7a04bfefec7c88$export$2e2bcd8739ae039)(breakpointsInput);
    const spacing = (0, $1f392ba2ebd18096$export$2e2bcd8739ae039)(spacingInput);
    let muiTheme = (0, $2985df77ba145d35$export$2e2bcd8739ae039)({
        breakpoints: breakpoints,
        direction: 'ltr',
        components: {},
        // Inject component definitions.
        palette: {
            mode: 'light',
            ...paletteInput
        },
        spacing: spacing,
        shape: {
            ...(0, $8aecb04a157fa644$export$2e2bcd8739ae039),
            ...shapeInput
        }
    }, other);
    muiTheme = (0, $91bc4077911678f2$export$2e2bcd8739ae039)(muiTheme);
    muiTheme.applyStyles = (0, $21efa8802134c535$export$2e2bcd8739ae039);
    muiTheme = args.reduce((acc, argument)=>(0, $2985df77ba145d35$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    muiTheme.unstable_sxConfig = {
        ...(0, $f27f6a6c429b3415$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6b750d631801d296$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    return muiTheme;
}
var $4a66cd95e497efc7$export$2e2bcd8739ae039 = $4a66cd95e497efc7$var$createTheme;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $e19976245606d3d7$var$isDevelopment = false;
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ function $e19976245606d3d7$var$sheetForTag(tag) {
    if (tag.sheet) return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) return document.styleSheets[i];
    } // this function should always return with a value
    // TS can't understand it though so we make it stop complaining here
    return undefined;
}
function $e19976245606d3d7$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $e19976245606d3d7$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? !$e19976245606d3d7$var$isDevelopment : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($e19976245606d3d7$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        if (this.isSpeedy) {
            var sheet = $e19976245606d3d7$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        this.tags.forEach(function(tag) {
            var _tag$parentNode;
            return (_tag$parentNode = tag.parentNode) == null ? void 0 : _tag$parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


/**
 * @param {number}
 * @return {number}
 */ var $5e4f012072913cb4$export$2335f513bbd82c6d = Math.abs;
var $5e4f012072913cb4$export$6788812c4e6611e6 = String.fromCharCode;
var $5e4f012072913cb4$export$e6e34fd1f2686227 = Object.assign;
function $5e4f012072913cb4$export$d6af199866bfb566(value, length) {
    return $5e4f012072913cb4$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 0)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 1)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 2)) << 2 ^ $5e4f012072913cb4$export$a9db5e087081082d(value, 3) : 0;
}
function $5e4f012072913cb4$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $5e4f012072913cb4$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $5e4f012072913cb4$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $5e4f012072913cb4$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $5e4f012072913cb4$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $5e4f012072913cb4$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $5e4f012072913cb4$export$36776f635604f274(value) {
    return value.length;
}
function $5e4f012072913cb4$export$f9084667e487ed46(value) {
    return value.length;
}
function $5e4f012072913cb4$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $5e4f012072913cb4$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}


var $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = 1;
var $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1;
var $f4f4fca9115ed8bd$export$f24224f1c91d8156 = 0;
var $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0;
var $f4f4fca9115ed8bd$export$c0306caf338ac095 = 0;
var $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '';
function $f4f4fca9115ed8bd$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c,
        column: $f4f4fca9115ed8bd$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $f4f4fca9115ed8bd$export$784d13d8ee351f07(root, props) {
    return (0, $5e4f012072913cb4$export$e6e34fd1f2686227)($f4f4fca9115ed8bd$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7() {
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$232faf9add678146() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 > 0 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, --$f4f4fca9115ed8bd$export$5880b8b5730aff45) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3--, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c--;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() {
    $f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$5880b8b5730aff45 < $f4f4fca9115ed8bd$export$f24224f1c91d8156 ? (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45++) : 0;
    if ($f4f4fca9115ed8bd$export$4e0c71f277ca26b3++, $f4f4fca9115ed8bd$export$c0306caf338ac095 === 10) $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c++;
    return $f4f4fca9115ed8bd$export$c0306caf338ac095;
}
function $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() {
    return (0, $5e4f012072913cb4$export$a9db5e087081082d)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}
function $f4f4fca9115ed8bd$export$e88cb2efb12ae807() {
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$58adb3bec8346d0f(begin, end) {
    return (0, $5e4f012072913cb4$export$2f35ab04d2335697)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6, begin, end);
}
function $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $f4f4fca9115ed8bd$export$2de70f21292aac9e(value) {
    return $f4f4fca9115ed8bd$export$53f1d5ea8de3d7c = $f4f4fca9115ed8bd$export$4e0c71f277ca26b3 = 1, $f4f4fca9115ed8bd$export$f24224f1c91d8156 = (0, $5e4f012072913cb4$export$36776f635604f274)($f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = value), $f4f4fca9115ed8bd$export$5880b8b5730aff45 = 0, [];
}
function $f4f4fca9115ed8bd$export$45918ac1574455b1(value) {
    return $f4f4fca9115ed8bd$export$30a86d91af8ff6e6 = '', value;
}
function $f4f4fca9115ed8bd$export$410ac95b9ec204b8(type) {
    return (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)($f4f4fca9115ed8bd$export$58adb3bec8346d0f($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1, $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff(value) {
    return $f4f4fca9115ed8bd$export$45918ac1574455b1($f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1($f4f4fca9115ed8bd$export$2de70f21292aac9e(value)));
}
function $f4f4fca9115ed8bd$export$7af1228ff777d175(type) {
    while($f4f4fca9115ed8bd$export$c0306caf338ac095 = $f4f4fca9115ed8bd$export$4d3fb11e950abb9e())if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 33) $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    else break;
    return $f4f4fca9115ed8bd$export$9e1725a4cfeada27(type) > 2 || $f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $f4f4fca9115ed8bd$export$5f8c09e3ae6f64e1(children) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$c0306caf338ac095)){
        case 0:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$c2ab62c7bf24634($f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)($f4f4fca9115ed8bd$export$410ac95b9ec204b8($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
            break;
        default:
            (0, $5e4f012072913cb4$export$10d8903dec122b9d)((0, $5e4f012072913cb4$export$6788812c4e6611e6)($f4f4fca9115ed8bd$export$c0306caf338ac095), children);
    }
    return children;
}
function $f4f4fca9115ed8bd$export$955ba06d119e085e(index, count) {
    while(--count && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($f4f4fca9115ed8bd$export$c0306caf338ac095 < 48 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 102 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 57 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 65 || $f4f4fca9115ed8bd$export$c0306caf338ac095 > 70 && $f4f4fca9115ed8bd$export$c0306caf338ac095 < 97) break;
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$e88cb2efb12ae807() + (count < 6 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() == 32 && $f4f4fca9115ed8bd$export$48cfd1e771a65c4f() == 32));
}
function $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())switch($f4f4fca9115ed8bd$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12($f4f4fca9115ed8bd$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $f4f4fca9115ed8bd$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
            break;
    }
    return $f4f4fca9115ed8bd$export$5880b8b5730aff45;
}
function $f4f4fca9115ed8bd$export$4254d4e2b3745c4c(type, index) {
    while($f4f4fca9115ed8bd$export$48cfd1e771a65c4f())// //
    if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 57) break;
    else if (type + $f4f4fca9115ed8bd$export$c0306caf338ac095 === 84 && $f4f4fca9115ed8bd$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45 - 1) + '*' + (0, $5e4f012072913cb4$export$6788812c4e6611e6)(type === 47 ? type : $f4f4fca9115ed8bd$export$48cfd1e771a65c4f());
}
function $f4f4fca9115ed8bd$export$c2ab62c7bf24634(index) {
    while(!$f4f4fca9115ed8bd$export$9e1725a4cfeada27($f4f4fca9115ed8bd$export$4d3fb11e950abb9e()))$f4f4fca9115ed8bd$export$48cfd1e771a65c4f();
    return $f4f4fca9115ed8bd$export$58adb3bec8346d0f(index, $f4f4fca9115ed8bd$export$5880b8b5730aff45);
}

var $e853ac0080e24cb4$export$71ad59f2e432cfe8 = '-ms-';
var $e853ac0080e24cb4$export$2c0f367103c8d01c = '-moz-';
var $e853ac0080e24cb4$export$39dfd62a25e0fe93 = '-webkit-';
var $e853ac0080e24cb4$export$a29989082612d0d9 = 'comm';
var $e853ac0080e24cb4$export$aa3a2e812ca8570d = 'rule';
var $e853ac0080e24cb4$export$527d108ccf083c2b = 'decl';
var $e853ac0080e24cb4$export$d3d35020fa5b54f0 = '@page';
var $e853ac0080e24cb4$export$500415a86c544f73 = '@media';
var $e853ac0080e24cb4$export$a763edbf796b780a = '@import';
var $e853ac0080e24cb4$export$2790aeb8b4e5c826 = '@charset';
var $e853ac0080e24cb4$export$1cc683e23b84b133 = '@viewport';
var $e853ac0080e24cb4$export$9447a5efea57e862 = '@supports';
var $e853ac0080e24cb4$export$ef011b4e114b1fba = '@document';
var $e853ac0080e24cb4$export$6aad947bda0f3f46 = '@namespace';
var $e853ac0080e24cb4$export$b44a8529a35fcb60 = '@keyframes';
var $e853ac0080e24cb4$export$2c16de31893252e6 = '@font-face';
var $e853ac0080e24cb4$export$3d846dd52e150c6f = '@counter-style';
var $e853ac0080e24cb4$export$22314bfbb57653fe = '@font-feature-values';
var $e853ac0080e24cb4$export$d773506282b3cfe6 = '@layer';




function $36ea00327b41abe1$export$ef7acd7185315e22(value) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($36ea00327b41abe1$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), 0, [
        0
    ], value));
}
function $36ea00327b41abe1$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)()){
        // (
        case 40:
            if (previous != 108 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, length - 1) == 58) {
                if ((0, $5e4f012072913cb4$export$f8e21b1e77979a08)(characters += (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $f4f4fca9115ed8bd$export$7af1228ff777d175)(previous);
            break;
        // \
        case 92:
            characters += (0, $f4f4fca9115ed8bd$export$955ba06d119e085e)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)()){
                case 42:
                case 47:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$4a34f930e789283c((0, $f4f4fca9115ed8bd$export$4254d4e2b3745c4c)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)(), (0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $5e4f012072913cb4$export$36776f635604f274)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, /\f/g, '');
                    if (property > 0 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) - length) (0, $5e4f012072913cb4$export$10d8903dec122b9d)(property > 32 ? $36ea00327b41abe1$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $36ea00327b41abe1$export$f8483753829ec8f3((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $5e4f012072913cb4$export$10d8903dec122b9d)(reference = $36ea00327b41abe1$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $36ea00327b41abe1$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $5e4f012072913cb4$export$a9db5e087081082d)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $36ea00327b41abe1$export$98e6a39c04603d36(value, reference, reference, rule && (0, $5e4f012072913cb4$export$10d8903dec122b9d)($36ea00327b41abe1$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $36ea00327b41abe1$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $5e4f012072913cb4$export$36776f635604f274)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $f4f4fca9115ed8bd$export$232faf9add678146)() == 125) continue;
            }
            switch(characters += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $5e4f012072913cb4$export$36776f635604f274)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 45) characters += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)((0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
                    atrule = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(), offset = length = (0, $5e4f012072913cb4$export$36776f635604f274)(type = characters += (0, $f4f4fca9115ed8bd$export$c2ab62c7bf24634)((0, $f4f4fca9115ed8bd$export$e88cb2efb12ae807)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $5e4f012072913cb4$export$36776f635604f274)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $36ea00327b41abe1$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $5e4f012072913cb4$export$f9084667e487ed46)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, post + 1, post = (0, $5e4f012072913cb4$export$2335f513bbd82c6d)(j = points[i])), z = value; x < size; ++x)if (z = (0, $5e4f012072913cb4$export$87c2784dc9fc4ab)(j > 0 ? rule[x] + ' ' + y : (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, offset === 0 ? (0, $e853ac0080e24cb4$export$aa3a2e812ca8570d) : type, props, children, length);
}
function $36ea00327b41abe1$export$4a34f930e789283c(value, root, parent) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$a29989082612d0d9), (0, $5e4f012072913cb4$export$6788812c4e6611e6)((0, $f4f4fca9115ed8bd$export$eba6f6f03b0a92e7)()), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 2, -2), 0);
}
function $36ea00327b41abe1$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $f4f4fca9115ed8bd$export$35059013cd4a06db)(value, root, parent, (0, $e853ac0080e24cb4$export$527d108ccf083c2b), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 0, length), (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length + 1, -1), length);
}






function $8f2522f8594faa86$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $8f2522f8594faa86$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$d773506282b3cfe6:
            if (element.children.length) break;
        case 0, $e853ac0080e24cb4$export$a763edbf796b780a:
        case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
            return element.return = element.return || element.value;
        case 0, $e853ac0080e24cb4$export$a29989082612d0d9:
            return '';
        case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
            return element.return = element.value + '{' + $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.value = element.props.join(',');
    }
    return (0, $5e4f012072913cb4$export$36776f635604f274)(children = $8f2522f8594faa86$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}




function $be3fa667258f7944$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // tab-size
        case 4789:
            return (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') + (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/) ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // justify-self
        case 4200:
            if (!(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /flex-|baseline/)) return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-column-align' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-end/);
            })) return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value + (children = children[length].value), 'span') ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'grid-row-span:' + (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(children, 'span') ? (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) : +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(children, /\d+/) - +(0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /\d+/)) + ';';
            return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $5e4f012072913cb4$export$4659b591c19bdf3d)(element.props, /grid-\w+-start/);
            }) ? value : (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch') ? $be3fa667258f7944$export$82e9f45cca5ba907((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + ':' + b + f + (c ? (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 6) === 121) return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}


function $b9a8452e0aabfcf6$export$5a7767152ae0305f(collection) {
    var length = (0, $5e4f012072913cb4$export$f9084667e487ed46)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $b9a8452e0aabfcf6$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $b9a8452e0aabfcf6$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element.return = (0, $be3fa667258f7944$export$82e9f45cca5ba907)(element.value, element.length, children);
                return;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $b9a8452e0aabfcf6$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
            element.props = element.props.map(function(value) {
                return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)((0, $f4f4fca9115ed8bd$export$660b2ee2d4fb4eff)(value), function(value, index, children) {
                    switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 0)){
                        // \f
                        case 12:
                            return (0, $5e4f012072913cb4$export$2f35ab04d2335697)(value, 1, (0, $5e4f012072913cb4$export$36776f635604f274)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $5e4f012072913cb4$export$2f35ab04d2335697)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) > 1 ? '' : value;
                                case index = (0, $5e4f012072913cb4$export$f9084667e487ed46)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}


var $d68ffb0773f38e18$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $6bb1e54ce1bc6efa$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $fc182b1f84212d3f$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)) break;
        (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)();
    }
    return (0, $f4f4fca9115ed8bd$export$58adb3bec8346d0f)(begin, (0, $f4f4fca9115ed8bd$export$5880b8b5730aff45));
};
var $fc182b1f84212d3f$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $f4f4fca9115ed8bd$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $fc182b1f84212d3f$var$identifierWithPointTracking((0, $f4f4fca9115ed8bd$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $f4f4fca9115ed8bd$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $f4f4fca9115ed8bd$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $5e4f012072913cb4$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $f4f4fca9115ed8bd$export$48cfd1e771a65c4f)());
    return parsed;
};
var $fc182b1f84212d3f$var$getRules = function getRules(value, points) {
    return (0, $f4f4fca9115ed8bd$export$45918ac1574455b1)($fc182b1f84212d3f$var$toRules((0, $f4f4fca9115ed8bd$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $fc182b1f84212d3f$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $fc182b1f84212d3f$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value;
    var parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$fc182b1f84212d3f$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $fc182b1f84212d3f$var$fixedElements.set(element, true);
    var points = [];
    var rules = $fc182b1f84212d3f$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $fc182b1f84212d3f$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $fc182b1f84212d3f$var$prefix(value, length) {
    switch((0, $5e4f012072913cb4$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-' + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $5e4f012072913cb4$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, 'stretch') ? $fc182b1f84212d3f$var$prefix((0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, (0, $5e4f012072913cb4$export$36776f635604f274)(value) - 3 - (~(0, $5e4f012072913cb4$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + ((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $5e4f012072913cb4$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + value + (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $fc182b1f84212d3f$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $e853ac0080e24cb4$export$527d108ccf083c2b:
                element["return"] = $fc182b1f84212d3f$var$prefix(element.value, element.length);
                break;
            case 0, $e853ac0080e24cb4$export$b44a8529a35fcb60:
                return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                    (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                        value: (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $e853ac0080e24cb4$export$aa3a2e812ca8570d:
                if (element.length) return (0, $5e4f012072913cb4$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $5e4f012072913cb4$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)([
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $e853ac0080e24cb4$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $f4f4fca9115ed8bd$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $5e4f012072913cb4$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $e853ac0080e24cb4$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $fc182b1f84212d3f$var$defaultStylisPlugins = [
    $fc182b1f84212d3f$var$prefixer
];
var $fc182b1f84212d3f$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $fc182b1f84212d3f$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $fc182b1f84212d3f$var$compat,
        $fc182b1f84212d3f$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $8f2522f8594faa86$export$fac44ee5b035f737),
        (0, $b9a8452e0aabfcf6$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $b9a8452e0aabfcf6$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $8f2522f8594faa86$export$dfdc1655ccc5b9cb)((0, $36ea00327b41abe1$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $e19976245606d3d7$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};


function $618a8e53233cd9fa$export$2e2bcd8739ae039() {
    return $618a8e53233cd9fa$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $618a8e53233cd9fa$export$2e2bcd8739ae039.apply(null, arguments);
}



var $72623ab6bcb0a33b$exports = {};
'use strict';
var $1c4952809f3474ad$exports = {};
'use strict';

$1c4952809f3474ad$exports = (parcelRequire("dNL7g"));


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $72623ab6bcb0a33b$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $72623ab6bcb0a33b$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $72623ab6bcb0a33b$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $72623ab6bcb0a33b$var$TYPE_STATICS = {};
$72623ab6bcb0a33b$var$TYPE_STATICS[$1c4952809f3474ad$exports.ForwardRef] = $72623ab6bcb0a33b$var$FORWARD_REF_STATICS;
$72623ab6bcb0a33b$var$TYPE_STATICS[$1c4952809f3474ad$exports.Memo] = $72623ab6bcb0a33b$var$MEMO_STATICS;
function $72623ab6bcb0a33b$var$getStatics(component) {
    // React v16.11 and below
    if ($1c4952809f3474ad$exports.isMemo(component)) return $72623ab6bcb0a33b$var$MEMO_STATICS;
     // React v16.12 and above
    return $72623ab6bcb0a33b$var$TYPE_STATICS[component['$$typeof']] || $72623ab6bcb0a33b$var$REACT_STATICS;
}
var $72623ab6bcb0a33b$var$defineProperty = Object.defineProperty;
var $72623ab6bcb0a33b$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $72623ab6bcb0a33b$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $72623ab6bcb0a33b$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $72623ab6bcb0a33b$var$getPrototypeOf = Object.getPrototypeOf;
var $72623ab6bcb0a33b$var$objectPrototype = Object.prototype;
function $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($72623ab6bcb0a33b$var$objectPrototype) {
            var inheritedComponent = $72623ab6bcb0a33b$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $72623ab6bcb0a33b$var$objectPrototype) $72623ab6bcb0a33b$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $72623ab6bcb0a33b$var$getOwnPropertyNames(sourceComponent);
        if ($72623ab6bcb0a33b$var$getOwnPropertySymbols) keys = keys.concat($72623ab6bcb0a33b$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $72623ab6bcb0a33b$var$getStatics(targetComponent);
        var sourceStatics = $72623ab6bcb0a33b$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$72623ab6bcb0a33b$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $72623ab6bcb0a33b$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $72623ab6bcb0a33b$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$72623ab6bcb0a33b$exports = $72623ab6bcb0a33b$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $f1be2661c8fac766$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(targetComponent, sourceComponent);
};


var $1f6791d0a193b918$var$isBrowser = true;
function $1f6791d0a193b918$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else if (className) rawClassName += className + " ";
    });
    return rawClassName;
}
var $1f6791d0a193b918$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $1f6791d0a193b918$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $1f6791d0a193b918$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $1f6791d0a193b918$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $3629985b3ecf741f$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $936be3b045ab836e$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $62578605b07c8dad$var$isDevelopment = false;
var $62578605b07c8dad$var$hyphenateRegex = /[A-Z]|^ms/g;
var $62578605b07c8dad$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $62578605b07c8dad$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $62578605b07c8dad$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $62578605b07c8dad$var$processStyleName = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(styleName) {
    return $62578605b07c8dad$var$isCustomProperty(styleName) ? styleName : styleName.replace($62578605b07c8dad$var$hyphenateRegex, '-$&').toLowerCase();
});
var $62578605b07c8dad$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($62578605b07c8dad$var$animationRegex, function(match, p1, p2) {
                $62578605b07c8dad$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $62578605b07c8dad$var$cursor
                };
                return p1;
            });
    }
    if ((0, $936be3b045ab836e$export$2e2bcd8739ae039)[key] !== 1 && !$62578605b07c8dad$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $62578605b07c8dad$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $62578605b07c8dad$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $62578605b07c8dad$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $62578605b07c8dad$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $62578605b07c8dad$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $62578605b07c8dad$var$cursor;
                var result = interpolation(mergedProps);
                $62578605b07c8dad$var$cursor = previousCursor;
                return $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $62578605b07c8dad$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($62578605b07c8dad$var$isProcessableValue(asString)) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $62578605b07c8dad$var$isDevelopment) throw new Error($62578605b07c8dad$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($62578605b07c8dad$var$isProcessableValue(value[_i])) string += $62578605b07c8dad$var$processStyleName(key) + ":" + $62578605b07c8dad$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $62578605b07c8dad$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $62578605b07c8dad$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $62578605b07c8dad$var$cursor;
function $62578605b07c8dad$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $62578605b07c8dad$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $62578605b07c8dad$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $62578605b07c8dad$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $62578605b07c8dad$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $3629985b3ecf741f$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $62578605b07c8dad$var$cursor
    };
}



var $acw62 = parcelRequire("acw62");
var $19b532704a3a90e7$var$syncFallback = function syncFallback(create) {
    return create();
};
var $19b532704a3a90e7$var$useInsertionEffect = $acw62.useInsertionEffect ? $acw62.useInsertionEffect : false;
var $19b532704a3a90e7$export$db21c7ffa21794e7 = $19b532704a3a90e7$var$useInsertionEffect || $19b532704a3a90e7$var$syncFallback;
var $19b532704a3a90e7$export$811a713a7276cb9d = $19b532704a3a90e7$var$useInsertionEffect || $acw62.useLayoutEffect;


var $4eee05ec22b53782$export$23f2a1d2818174ef = false;
var $4eee05ec22b53782$var$EmotionCacheContext = /* #__PURE__ */ $acw62.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $4eee05ec22b53782$export$e7094788287c5e9b = $4eee05ec22b53782$var$EmotionCacheContext.Provider;
var $4eee05ec22b53782$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $acw62.useContext)($4eee05ec22b53782$var$EmotionCacheContext);
};
var $4eee05ec22b53782$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return /*#__PURE__*/ (0, $acw62.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $acw62.useContext)($4eee05ec22b53782$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
var $4eee05ec22b53782$export$971d5caa766a69d7 = /* #__PURE__ */ $acw62.createContext({});
var $4eee05ec22b53782$export$3b14a55fb2447963 = function useTheme() {
    return $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
};
var $4eee05ec22b53782$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $4eee05ec22b53782$var$createCacheWithTheme = /* #__PURE__ */ (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $d68ffb0773f38e18$export$2e2bcd8739ae039)(function(theme) {
        return $4eee05ec22b53782$var$getTheme(outerTheme, theme);
    });
});
var $4eee05ec22b53782$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $4eee05ec22b53782$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $acw62.createElement($4eee05ec22b53782$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $4eee05ec22b53782$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var WithTheme = /*#__PURE__*/ $acw62.forwardRef(function render(props, ref) {
        var theme = $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7);
        return /*#__PURE__*/ $acw62.createElement(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    });
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $f1be2661c8fac766$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $4eee05ec22b53782$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $4eee05ec22b53782$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $4eee05ec22b53782$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var _key in props)if ($4eee05ec22b53782$export$dda1d9f60106f0e9.call(props, _key)) newProps[_key] = props[_key];
    newProps[$4eee05ec22b53782$var$typePropName] = type; // Runtime labeling is an opt-in feature because:
    return newProps;
};
var $4eee05ec22b53782$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $4eee05ec22b53782$var$Emotion = /* #__PURE__ */ $4eee05ec22b53782$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$4eee05ec22b53782$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(registeredStyles, undefined, $acw62.useContext($4eee05ec22b53782$export$971d5caa766a69d7));
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var _key2 in props)if ($4eee05ec22b53782$export$dda1d9f60106f0e9.call(props, _key2) && _key2 !== 'css' && _key2 !== $4eee05ec22b53782$var$typePropName && !$4eee05ec22b53782$export$23f2a1d2818174ef) newProps[_key2] = props[_key2];
    newProps.className = className;
    if (ref) newProps.ref = ref;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($4eee05ec22b53782$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $acw62.createElement(WrappedComponent, newProps));
});
var $4eee05ec22b53782$export$a9c23c6ac3fc3eca = $4eee05ec22b53782$var$Emotion;



var $acw62 = parcelRequire("acw62");








var $63d46a01db878c10$export$c8a8987d4410bf2d = function jsx(type, props) {
    // eslint-disable-next-line prefer-rest-params
    var args = arguments;
    if (props == null || !(0, $4eee05ec22b53782$export$dda1d9f60106f0e9).call(props, 'css')) return $acw62.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $4eee05ec22b53782$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $4eee05ec22b53782$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
    return $acw62.createElement.apply(null, createElementArgArray);
};
(function(_jsx) {
    var JSX;
    JSX || (JSX = _jsx.JSX || (_jsx.JSX = {}));
})($63d46a01db878c10$export$c8a8987d4410bf2d || ($63d46a01db878c10$export$c8a8987d4410bf2d = {}));
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $63d46a01db878c10$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)([
        styles
    ], undefined, $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7)));
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $acw62.useRef();
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false;
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $19b532704a3a90e7$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $63d46a01db878c10$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $62578605b07c8dad$export$6321afa313b251b5)(args);
}
function $63d46a01db878c10$export$d25ddfdf17c3ad3e() {
    var insertable = $63d46a01db878c10$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name;
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
}
var $63d46a01db878c10$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $63d46a01db878c10$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $63d46a01db878c10$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $63d46a01db878c10$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        if (hasRendered && (0, $4eee05ec22b53782$export$23f2a1d2818174ef)) throw new Error('css can only be used during render');
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        if (hasRendered && (0, $4eee05ec22b53782$export$23f2a1d2818174ef)) throw new Error('cx can only be used during render');
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $63d46a01db878c10$var$merge(cache.registered, css, $63d46a01db878c10$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($63d46a01db878c10$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});


'use client';
function $bba4444e1ea571ca$var$isObjectEmpty(obj) {
    return Object.keys(obj).length === 0;
}
function $bba4444e1ea571ca$var$useTheme(defaultTheme = null) {
    const contextTheme = $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7));
    return !contextTheme || $bba4444e1ea571ca$var$isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}
var $bba4444e1ea571ca$export$2e2bcd8739ae039 = $bba4444e1ea571ca$var$useTheme;


'use client';
const $ac16d208682bdb3f$export$35e57303dbd8a66 = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
function $ac16d208682bdb3f$var$useTheme(defaultTheme = $ac16d208682bdb3f$export$35e57303dbd8a66) {
    return (0, $bba4444e1ea571ca$export$2e2bcd8739ae039)(defaultTheme);
}
var $ac16d208682bdb3f$export$2e2bcd8739ae039 = $ac16d208682bdb3f$var$useTheme;





function $0f5b14b581d98cb8$var$clamp(val, min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER) {
    return Math.max(min, Math.min(val, max));
}
var $0f5b14b581d98cb8$export$2e2bcd8739ae039 = $0f5b14b581d98cb8$var$clamp;


/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */ function $7ebe803ced17df29$var$clampWrapper(value, min = 0, max = 1) {
    return (0, $0f5b14b581d98cb8$export$2e2bcd8739ae039)(value, min, max);
}
function $7ebe803ced17df29$export$5a544e13ad4e1fa5(color) {
    color = color.slice(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) colors = colors.map((n)=>n + n);
    return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index)=>{
        return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
    }).join(', ')})` : '';
}
function $7ebe803ced17df29$var$intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
function $7ebe803ced17df29$export$677b39864803984e(color) {
    // Idempotent
    if (color.type) return color;
    if (color.charAt(0) === '#') return $7ebe803ced17df29$export$677b39864803984e($7ebe803ced17df29$export$5a544e13ad4e1fa5(color));
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (![
        'rgb',
        'rgba',
        'hsl',
        'hsla',
        'color'
    ].includes(type)) throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(9, color));
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') values[3] = values[3].slice(1);
        if (![
            'srgb',
            'display-p3',
            'a98-rgb',
            'prophoto-rgb',
            'rec-2020'
        ].includes(colorSpace)) throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(10, colorSpace));
    } else values = values.split(',');
    values = values.map((value)=>parseFloat(value));
    return {
        type: type,
        values: values,
        colorSpace: colorSpace
    };
}
const $7ebe803ced17df29$export$1b91fc959f7ee5a7 = (color)=>{
    const decomposedColor = $7ebe803ced17df29$export$677b39864803984e(color);
    return decomposedColor.values.slice(0, 3).map((val, idx)=>decomposedColor.type.includes('hsl') && idx !== 0 ? `${val}%` : val).join(' ');
};
const $7ebe803ced17df29$export$427365fc3db6fc5e = (color, warning)=>{
    try {
        return $7ebe803ced17df29$export$1b91fc959f7ee5a7(color);
    } catch (error) {
        return color;
    }
};
function $7ebe803ced17df29$export$211a73f2b8c10ce4(color) {
    const { type: type, colorSpace: colorSpace } = color;
    let { values: values } = color;
    if (type.includes('rgb')) // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i)=>i < 3 ? parseInt(n, 10) : n);
    else if (type.includes('hsl')) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.includes('color')) values = `${colorSpace} ${values.join(' ')}`;
    else values = `${values.join(', ')}`;
    return `${type}(${values})`;
}
function $7ebe803ced17df29$export$34d09c4a771c46ef(color) {
    // Idempotent
    if (color.startsWith('#')) return color;
    const { values: values } = $7ebe803ced17df29$export$677b39864803984e(color);
    return `#${values.map((n, i)=>$7ebe803ced17df29$var$intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
function $7ebe803ced17df29$export$29fb7152bd3f781a(color) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    const { values: values } = color;
    const h = values[0];
    const s = values[1] / 100;
    const l = values[2] / 100;
    const a = s * Math.min(l, 1 - l);
    const f = (n, k = (n + h / 30) % 12)=>l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    let type = 'rgb';
    const rgb = [
        Math.round(f(0) * 255),
        Math.round(f(8) * 255),
        Math.round(f(4) * 255)
    ];
    if (color.type === 'hsla') {
        type += 'a';
        rgb.push(values[3]);
    }
    return $7ebe803ced17df29$export$211a73f2b8c10ce4({
        type: type,
        values: rgb
    });
}
function $7ebe803ced17df29$export$c852d90bf7403b62(color) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    let rgb = color.type === 'hsl' || color.type === 'hsla' ? $7ebe803ced17df29$export$677b39864803984e($7ebe803ced17df29$export$29fb7152bd3f781a(color)).values : color.values;
    rgb = rgb.map((val)=>{
        if (color.type !== 'color') val /= 255; // normalized
        return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
    });
    // Truncate at 3 digits
    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
function $7ebe803ced17df29$export$d061e26956a60b0a(foreground, background) {
    const lumA = $7ebe803ced17df29$export$c852d90bf7403b62(foreground);
    const lumB = $7ebe803ced17df29$export$c852d90bf7403b62(background);
    return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
function $7ebe803ced17df29$export$58f0f39f63f3cf42(color, value) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    value = $7ebe803ced17df29$var$clampWrapper(value);
    if (color.type === 'rgb' || color.type === 'hsl') color.type += 'a';
    if (color.type === 'color') color.values[3] = `/${value}`;
    else color.values[3] = value;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$34109543fc7f43f8(color, value, warning) {
    try {
        return $7ebe803ced17df29$export$58f0f39f63f3cf42(color, value);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$4b073707ff63303(color, coefficient) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    coefficient = $7ebe803ced17df29$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] *= 1 - coefficient;
    else if (color.type.includes('rgb') || color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] *= 1 - coefficient;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$eaaef2dca3e9e512(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$4b073707ff63303(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient) {
    color = $7ebe803ced17df29$export$677b39864803984e(color);
    coefficient = $7ebe803ced17df29$var$clampWrapper(coefficient);
    if (color.type.includes('hsl')) color.values[2] += (100 - color.values[2]) * coefficient;
    else if (color.type.includes('rgb')) for(let i = 0; i < 3; i += 1)color.values[i] += (255 - color.values[i]) * coefficient;
    else if (color.type.includes('color')) for(let i = 0; i < 3; i += 1)color.values[i] += (1 - color.values[i]) * coefficient;
    return $7ebe803ced17df29$export$211a73f2b8c10ce4(color);
}
function $7ebe803ced17df29$export$aeeda94ef1d01275(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$e665714f76e581fd(color, coefficient = 0.15) {
    return $7ebe803ced17df29$export$c852d90bf7403b62(color) > 0.5 ? $7ebe803ced17df29$export$4b073707ff63303(color, coefficient) : $7ebe803ced17df29$export$c0816ed86df316af(color, coefficient);
}
function $7ebe803ced17df29$export$11bb74ba10c85505(color, coefficient, warning) {
    try {
        return $7ebe803ced17df29$export$e665714f76e581fd(color, coefficient);
    } catch (error) {
        return color;
    }
}
function $7ebe803ced17df29$export$fdb28526eb2966c3(background, overlay, opacity, gamma = 1.0) {
    const blendChannel = (b, o)=>Math.round((b ** (1 / gamma) * (1 - opacity) + o ** (1 / gamma) * opacity) ** gamma);
    const backgroundColor = $7ebe803ced17df29$export$677b39864803984e(background);
    const overlayColor = $7ebe803ced17df29$export$677b39864803984e(overlay);
    const rgb = [
        blendChannel(backgroundColor.values[0], overlayColor.values[0]),
        blendChannel(backgroundColor.values[1], overlayColor.values[1]),
        blendChannel(backgroundColor.values[2], overlayColor.values[2])
    ];
    return $7ebe803ced17df29$export$211a73f2b8c10ce4({
        type: 'rgb',
        values: rgb
    });
}


const $d37ba043b695a86b$var$common = {
    black: '#000',
    white: '#fff'
};
var $d37ba043b695a86b$export$2e2bcd8739ae039 = $d37ba043b695a86b$var$common;


const $f6d26248a242c674$var$grey = {
    50: '#fafafa',
    100: '#f5f5f5',
    200: '#eeeeee',
    300: '#e0e0e0',
    400: '#bdbdbd',
    500: '#9e9e9e',
    600: '#757575',
    700: '#616161',
    800: '#424242',
    900: '#212121',
    A100: '#f5f5f5',
    A200: '#eeeeee',
    A400: '#bdbdbd',
    A700: '#616161'
};
var $f6d26248a242c674$export$2e2bcd8739ae039 = $f6d26248a242c674$var$grey;


const $e9a31dd7cc73b986$var$purple = {
    50: '#f3e5f5',
    100: '#e1bee7',
    200: '#ce93d8',
    300: '#ba68c8',
    400: '#ab47bc',
    500: '#9c27b0',
    600: '#8e24aa',
    700: '#7b1fa2',
    800: '#6a1b9a',
    900: '#4a148c',
    A100: '#ea80fc',
    A200: '#e040fb',
    A400: '#d500f9',
    A700: '#aa00ff'
};
var $e9a31dd7cc73b986$export$2e2bcd8739ae039 = $e9a31dd7cc73b986$var$purple;


const $54cad5d9f2acbb0d$var$red = {
    50: '#ffebee',
    100: '#ffcdd2',
    200: '#ef9a9a',
    300: '#e57373',
    400: '#ef5350',
    500: '#f44336',
    600: '#e53935',
    700: '#d32f2f',
    800: '#c62828',
    900: '#b71c1c',
    A100: '#ff8a80',
    A200: '#ff5252',
    A400: '#ff1744',
    A700: '#d50000'
};
var $54cad5d9f2acbb0d$export$2e2bcd8739ae039 = $54cad5d9f2acbb0d$var$red;


const $228fc37206d3e0db$var$orange = {
    50: '#fff3e0',
    100: '#ffe0b2',
    200: '#ffcc80',
    300: '#ffb74d',
    400: '#ffa726',
    500: '#ff9800',
    600: '#fb8c00',
    700: '#f57c00',
    800: '#ef6c00',
    900: '#e65100',
    A100: '#ffd180',
    A200: '#ffab40',
    A400: '#ff9100',
    A700: '#ff6d00'
};
var $228fc37206d3e0db$export$2e2bcd8739ae039 = $228fc37206d3e0db$var$orange;


const $cc48e8508d197286$var$blue = {
    50: '#e3f2fd',
    100: '#bbdefb',
    200: '#90caf9',
    300: '#64b5f6',
    400: '#42a5f5',
    500: '#2196f3',
    600: '#1e88e5',
    700: '#1976d2',
    800: '#1565c0',
    900: '#0d47a1',
    A100: '#82b1ff',
    A200: '#448aff',
    A400: '#2979ff',
    A700: '#2962ff'
};
var $cc48e8508d197286$export$2e2bcd8739ae039 = $cc48e8508d197286$var$blue;


const $29fdcd59f703e693$var$lightBlue = {
    50: '#e1f5fe',
    100: '#b3e5fc',
    200: '#81d4fa',
    300: '#4fc3f7',
    400: '#29b6f6',
    500: '#03a9f4',
    600: '#039be5',
    700: '#0288d1',
    800: '#0277bd',
    900: '#01579b',
    A100: '#80d8ff',
    A200: '#40c4ff',
    A400: '#00b0ff',
    A700: '#0091ea'
};
var $29fdcd59f703e693$export$2e2bcd8739ae039 = $29fdcd59f703e693$var$lightBlue;


const $506551f203a25923$var$green = {
    50: '#e8f5e9',
    100: '#c8e6c9',
    200: '#a5d6a7',
    300: '#81c784',
    400: '#66bb6a',
    500: '#4caf50',
    600: '#43a047',
    700: '#388e3c',
    800: '#2e7d32',
    900: '#1b5e20',
    A100: '#b9f6ca',
    A200: '#69f0ae',
    A400: '#00e676',
    A700: '#00c853'
};
var $506551f203a25923$export$2e2bcd8739ae039 = $506551f203a25923$var$green;


function $5763e0c539a251df$var$getLight() {
    return {
        // The colors used to style the text.
        text: {
            // The most important text.
            primary: 'rgba(0, 0, 0, 0.87)',
            // Secondary text.
            secondary: 'rgba(0, 0, 0, 0.6)',
            // Disabled text have even lower visual prominence.
            disabled: 'rgba(0, 0, 0, 0.38)'
        },
        // The color used to divide different elements.
        divider: 'rgba(0, 0, 0, 0.12)',
        // The background colors used to style the surfaces.
        // Consistency between these values is important.
        background: {
            paper: (0, $d37ba043b695a86b$export$2e2bcd8739ae039).white,
            default: (0, $d37ba043b695a86b$export$2e2bcd8739ae039).white
        },
        // The colors used to style the action elements.
        action: {
            // The color of an active action like an icon button.
            active: 'rgba(0, 0, 0, 0.54)',
            // The color of an hovered action.
            hover: 'rgba(0, 0, 0, 0.04)',
            hoverOpacity: 0.04,
            // The color of a selected action.
            selected: 'rgba(0, 0, 0, 0.08)',
            selectedOpacity: 0.08,
            // The color of a disabled action.
            disabled: 'rgba(0, 0, 0, 0.26)',
            // The background color of a disabled action.
            disabledBackground: 'rgba(0, 0, 0, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(0, 0, 0, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.12
        }
    };
}
const $5763e0c539a251df$export$a43af521ac8c3202 = $5763e0c539a251df$var$getLight();
function $5763e0c539a251df$var$getDark() {
    return {
        text: {
            primary: (0, $d37ba043b695a86b$export$2e2bcd8739ae039).white,
            secondary: 'rgba(255, 255, 255, 0.7)',
            disabled: 'rgba(255, 255, 255, 0.5)',
            icon: 'rgba(255, 255, 255, 0.5)'
        },
        divider: 'rgba(255, 255, 255, 0.12)',
        background: {
            paper: '#121212',
            default: '#121212'
        },
        action: {
            active: (0, $d37ba043b695a86b$export$2e2bcd8739ae039).white,
            hover: 'rgba(255, 255, 255, 0.08)',
            hoverOpacity: 0.08,
            selected: 'rgba(255, 255, 255, 0.16)',
            selectedOpacity: 0.16,
            disabled: 'rgba(255, 255, 255, 0.3)',
            disabledBackground: 'rgba(255, 255, 255, 0.12)',
            disabledOpacity: 0.38,
            focus: 'rgba(255, 255, 255, 0.12)',
            focusOpacity: 0.12,
            activatedOpacity: 0.24
        }
    };
}
const $5763e0c539a251df$export$55ce6f3a06c59543 = $5763e0c539a251df$var$getDark();
function $5763e0c539a251df$var$addLightOrDark(intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = (0, $7ebe803ced17df29$export$c0816ed86df316af)(intent.main, tonalOffsetLight);
        else if (direction === 'dark') intent.dark = (0, $7ebe803ced17df29$export$4b073707ff63303)(intent.main, tonalOffsetDark);
    }
}
function $5763e0c539a251df$var$mixLightOrDark(colorSpace, intent, direction, shade, tonalOffset) {
    const tonalOffsetLight = tonalOffset.light || tonalOffset;
    const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;
    if (!intent[direction]) {
        if (intent.hasOwnProperty(shade)) intent[direction] = intent[shade];
        else if (direction === 'light') intent.light = `color-mix(in ${colorSpace}, ${intent.main}, #fff ${(tonalOffsetLight * 100).toFixed(0)}%)`;
        else if (direction === 'dark') intent.dark = `color-mix(in ${colorSpace}, ${intent.main}, #000 ${(tonalOffsetDark * 100).toFixed(0)}%)`;
    }
}
function $5763e0c539a251df$var$getDefaultPrimary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[200],
        light: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[50],
        dark: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[700],
        light: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[400],
        dark: (0, $cc48e8508d197286$export$2e2bcd8739ae039)[800]
    };
}
function $5763e0c539a251df$var$getDefaultSecondary(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[200],
        light: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[50],
        dark: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[400]
    };
    return {
        main: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[500],
        light: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[300],
        dark: (0, $e9a31dd7cc73b986$export$2e2bcd8739ae039)[700]
    };
}
function $5763e0c539a251df$var$getDefaultError(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[500],
        light: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[300],
        dark: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[700],
        light: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[400],
        dark: (0, $54cad5d9f2acbb0d$export$2e2bcd8739ae039)[800]
    };
}
function $5763e0c539a251df$var$getDefaultInfo(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[400],
        light: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[300],
        dark: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[700],
        light: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[500],
        dark: (0, $29fdcd59f703e693$export$2e2bcd8739ae039)[900]
    };
}
function $5763e0c539a251df$var$getDefaultSuccess(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $506551f203a25923$export$2e2bcd8739ae039)[400],
        light: (0, $506551f203a25923$export$2e2bcd8739ae039)[300],
        dark: (0, $506551f203a25923$export$2e2bcd8739ae039)[700]
    };
    return {
        main: (0, $506551f203a25923$export$2e2bcd8739ae039)[800],
        light: (0, $506551f203a25923$export$2e2bcd8739ae039)[500],
        dark: (0, $506551f203a25923$export$2e2bcd8739ae039)[900]
    };
}
function $5763e0c539a251df$var$getDefaultWarning(mode = 'light') {
    if (mode === 'dark') return {
        main: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[400],
        light: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[300],
        dark: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[700]
    };
    return {
        main: '#ed6c02',
        // closest to orange[800] that pass 3:1.
        light: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[500],
        dark: (0, $228fc37206d3e0db$export$2e2bcd8739ae039)[900]
    };
}
function $5763e0c539a251df$export$b6e2ca4581a735cb(background) {
    return `oklch(from ${background} var(--__l) 0 h / var(--__a))`;
}
function $5763e0c539a251df$export$2e2bcd8739ae039(palette) {
    const { mode: mode = 'light', contrastThreshold: contrastThreshold = 3, tonalOffset: tonalOffset = 0.2, colorSpace: colorSpace, ...other } = palette;
    const primary = palette.primary || $5763e0c539a251df$var$getDefaultPrimary(mode);
    const secondary = palette.secondary || $5763e0c539a251df$var$getDefaultSecondary(mode);
    const error = palette.error || $5763e0c539a251df$var$getDefaultError(mode);
    const info = palette.info || $5763e0c539a251df$var$getDefaultInfo(mode);
    const success = palette.success || $5763e0c539a251df$var$getDefaultSuccess(mode);
    const warning = palette.warning || $5763e0c539a251df$var$getDefaultWarning(mode);
    // Use the same logic as
    // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
    // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
    function getContrastText(background) {
        if (colorSpace) return $5763e0c539a251df$export$b6e2ca4581a735cb(background);
        const contrastText = (0, $7ebe803ced17df29$export$d061e26956a60b0a)(background, $5763e0c539a251df$export$55ce6f3a06c59543.text.primary) >= contrastThreshold ? $5763e0c539a251df$export$55ce6f3a06c59543.text.primary : $5763e0c539a251df$export$a43af521ac8c3202.text.primary;
        return contrastText;
    }
    const augmentColor = ({ color: color, name: name, mainShade: mainShade = 500, lightShade: lightShade = 300, darkShade: darkShade = 700 })=>{
        color = {
            ...color
        };
        if (!color.main && color[mainShade]) color.main = color[mainShade];
        if (!color.hasOwnProperty('main')) throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(11, name ? ` (${name})` : '', mainShade));
        if (typeof color.main !== 'string') throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
        if (colorSpace) {
            $5763e0c539a251df$var$mixLightOrDark(colorSpace, color, 'light', lightShade, tonalOffset);
            $5763e0c539a251df$var$mixLightOrDark(colorSpace, color, 'dark', darkShade, tonalOffset);
        } else {
            $5763e0c539a251df$var$addLightOrDark(color, 'light', lightShade, tonalOffset);
            $5763e0c539a251df$var$addLightOrDark(color, 'dark', darkShade, tonalOffset);
        }
        if (!color.contrastText) color.contrastText = getContrastText(color.main);
        return color;
    };
    let modeHydrated;
    if (mode === 'light') modeHydrated = $5763e0c539a251df$var$getLight();
    else if (mode === 'dark') modeHydrated = $5763e0c539a251df$var$getDark();
    const paletteOutput = (0, $2985df77ba145d35$export$2e2bcd8739ae039)({
        // A collection of common colors.
        common: {
            ...(0, $d37ba043b695a86b$export$2e2bcd8739ae039)
        },
        mode: // prevent mutable object.
        // The palette mode, can be light or dark.
        mode,
        // The colors used to represent primary interface elements for a user.
        primary: augmentColor({
            color: primary,
            name: 'primary'
        }),
        // The colors used to represent secondary interface elements for a user.
        secondary: augmentColor({
            color: secondary,
            name: 'secondary',
            mainShade: 'A400',
            lightShade: 'A200',
            darkShade: 'A700'
        }),
        // The colors used to represent interface elements that the user should be made aware of.
        error: augmentColor({
            color: error,
            name: 'error'
        }),
        // The colors used to represent potentially dangerous actions or important messages.
        warning: augmentColor({
            color: warning,
            name: 'warning'
        }),
        // The colors used to present information to the user that is neutral and not necessarily important.
        info: augmentColor({
            color: info,
            name: 'info'
        }),
        // The colors used to indicate the successful completion of an action that user triggered.
        success: augmentColor({
            color: success,
            name: 'success'
        }),
        grey: // The grey colors.
        $f6d26248a242c674$export$2e2bcd8739ae039,
        contrastThreshold: // Used by `getContrastText()` to maximize the contrast between
        // the background and the text.
        contrastThreshold,
        getContrastText: // Takes a background color and returns the text color that maximizes the contrast.
        getContrastText,
        augmentColor: // Generate a rich color object.
        augmentColor,
        tonalOffset: // Used by the functions below to shift a color's luminance by approximately
        // two indexes within its tonal palette.
        // E.g., shift from Red 500 to Red 300 or Red 700.
        tonalOffset,
        // The light and dark mode object.
        ...modeHydrated
    }, other);
    return paletteOutput;
}




/**
 * The benefit of this function is to help developers get CSS var from theme without specifying the whole variable
 * and they does not need to remember the prefix (defined once).
 */ function $b82d0f0117f79ef3$export$2e2bcd8739ae039(prefix = '') {
    function appendVar(...vars) {
        if (!vars.length) return '';
        const value = vars[0];
        if (typeof value === 'string' && !value.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/)) return `, var(--${prefix ? `${prefix}-` : ''}${value}${appendVar(...vars.slice(1))})`;
        return `, ${value}`;
    }
    // AdditionalVars makes `getCssVar` less strict, so it can be use like this `getCssVar('non-mui-variable')` without type error.
    const getCssVar = (field, ...fallbacks)=>{
        return `var(--${prefix ? `${prefix}-` : ''}${field}${appendVar(...fallbacks)})`;
    };
    return getCssVar;
}



/* eslint-disable import/prefer-default-export */ function $2856c28c5d84ba80$export$858538ff6c0d421d(selector) {
    return function getColorSchemeSelector(colorScheme) {
        if (selector === 'media') return `@media (prefers-color-scheme: ${colorScheme})`;
        if (selector) {
            if (selector.startsWith('data-') && !selector.includes('%s')) return `[${selector}="${colorScheme}"] &`;
            if (selector === 'class') return `.${colorScheme} &`;
            if (selector === 'data') return `[data-${colorScheme}] &`;
            return `${selector.replace('%s', colorScheme)} &`;
        }
        return '&';
    };
}


/**
 * This function create an object from keys, value and then assign to target
 *
 * @param {Object} obj : the target object to be assigned
 * @param {string[]} keys
 * @param {string | number} value
 *
 * @example
 * const source = {}
 * assignNestedKeys(source, ['palette', 'primary'], 'var(--palette-primary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)' } }
 *
 * @example
 * const source = { palette: { primary: 'var(--palette-primary)' } }
 * assignNestedKeys(source, ['palette', 'secondary'], 'var(--palette-secondary)')
 * console.log(source) // { palette: { primary: 'var(--palette-primary)', secondary: 'var(--palette-secondary)' } }
 */ const $2b8c5837678016ea$export$b7855adbea215c1a = (obj, keys, value, arrayKeys = [])=>{
    let temp = obj;
    keys.forEach((k, index)=>{
        if (index === keys.length - 1) {
            if (Array.isArray(temp)) temp[Number(k)] = value;
            else if (temp && typeof temp === 'object') temp[k] = value;
        } else if (temp && typeof temp === 'object') {
            if (!temp[k]) temp[k] = arrayKeys.includes(k) ? [] : {};
            temp = temp[k];
        }
    });
};
const $2b8c5837678016ea$export$65957d378dc9a0b3 = (obj, callback, shouldSkipPaths)=>{
    function recurse(object, parentKeys = [], arrayKeys = []) {
        Object.entries(object).forEach(([key, value])=>{
            if (!shouldSkipPaths || shouldSkipPaths && !shouldSkipPaths([
                ...parentKeys,
                key
            ])) {
                if (value !== undefined && value !== null) {
                    if (typeof value === 'object' && Object.keys(value).length > 0) recurse(value, [
                        ...parentKeys,
                        key
                    ], Array.isArray(value) ? [
                        ...arrayKeys,
                        key
                    ] : arrayKeys);
                    else callback([
                        ...parentKeys,
                        key
                    ], value, arrayKeys);
                }
            }
        });
    }
    recurse(obj);
};
const $2b8c5837678016ea$var$getCssValue = (keys, value)=>{
    if (typeof value === 'number') {
        if ([
            'lineHeight',
            'fontWeight',
            'opacity',
            'zIndex'
        ].some((prop)=>keys.includes(prop))) // CSS property that are unitless
        return value;
        const lastKey = keys[keys.length - 1];
        if (lastKey.toLowerCase().includes('opacity')) // opacity values are unitless
        return value;
        return `${value}px`;
    }
    return value;
};
function $2b8c5837678016ea$export$2e2bcd8739ae039(theme, options) {
    const { prefix: prefix, shouldSkipGeneratingVar: shouldSkipGeneratingVar } = options || {};
    const css = {};
    const vars = {};
    const varsWithDefaults = {};
    $2b8c5837678016ea$export$65957d378dc9a0b3(theme, (keys, value, arrayKeys)=>{
        if (typeof value === 'string' || typeof value === 'number') {
            if (!shouldSkipGeneratingVar || !shouldSkipGeneratingVar(keys, value)) {
                // only create css & var if `shouldSkipGeneratingVar` return false
                const cssVar = `--${prefix ? `${prefix}-` : ''}${keys.join('-')}`;
                const resolvedValue = $2b8c5837678016ea$var$getCssValue(keys, value);
                Object.assign(css, {
                    [cssVar]: resolvedValue
                });
                $2b8c5837678016ea$export$b7855adbea215c1a(vars, keys, `var(${cssVar})`, arrayKeys);
                $2b8c5837678016ea$export$b7855adbea215c1a(varsWithDefaults, keys, `var(${cssVar}, ${resolvedValue})`, arrayKeys);
            }
        }
    }, (keys)=>keys[0] === 'vars' // skip 'vars/*' paths
    );
    return {
        css: css,
        vars: vars,
        varsWithDefaults: varsWithDefaults
    };
}


function $508fc6c60afa1bca$var$prepareCssVars(theme, parserConfig = {}) {
    const { getSelector: getSelector = defaultGetSelector, disableCssColorScheme: disableCssColorScheme, colorSchemeSelector: selector, enableContrastVars: enableContrastVars } = parserConfig;
    // @ts-ignore - ignore components do not exist
    const { colorSchemes: colorSchemes = {}, components: components, defaultColorScheme: defaultColorScheme = 'light', ...otherTheme } = theme;
    const { vars: rootVars, css: rootCss, varsWithDefaults: rootVarsWithDefaults } = (0, $2b8c5837678016ea$export$2e2bcd8739ae039)(otherTheme, parserConfig);
    let themeVars = rootVarsWithDefaults;
    const colorSchemesMap = {};
    const { [defaultColorScheme]: defaultScheme, ...otherColorSchemes } = colorSchemes;
    Object.entries(otherColorSchemes || {}).forEach(([key, scheme])=>{
        const { vars: vars, css: css, varsWithDefaults: varsWithDefaults } = (0, $2b8c5837678016ea$export$2e2bcd8739ae039)(scheme, parserConfig);
        themeVars = (0, $2985df77ba145d35$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[key] = {
            css: css,
            vars: vars
        };
    });
    if (defaultScheme) {
        // default color scheme vars should be merged last to set as default
        const { css: css, vars: vars, varsWithDefaults: varsWithDefaults } = (0, $2b8c5837678016ea$export$2e2bcd8739ae039)(defaultScheme, parserConfig);
        themeVars = (0, $2985df77ba145d35$export$2e2bcd8739ae039)(themeVars, varsWithDefaults);
        colorSchemesMap[defaultColorScheme] = {
            css: css,
            vars: vars
        };
    }
    function defaultGetSelector(colorScheme, cssObject) {
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-joy-color-scheme' -> '[data-joy-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (colorScheme) {
            if (rule === 'media') {
                if (theme.defaultColorScheme === colorScheme) return ':root';
                const mode = colorSchemes[colorScheme]?.palette?.mode || colorScheme;
                return {
                    [`@media (prefers-color-scheme: ${mode})`]: {
                        ':root': cssObject
                    }
                };
            }
            if (rule) {
                if (theme.defaultColorScheme === colorScheme) return `:root, ${rule.replace('%s', String(colorScheme))}`;
                return rule.replace('%s', String(colorScheme));
            }
        }
        return ':root';
    }
    const generateThemeVars = ()=>{
        let vars = {
            ...rootVars
        };
        Object.entries(colorSchemesMap).forEach(([, { vars: schemeVars }])=>{
            vars = (0, $2985df77ba145d35$export$2e2bcd8739ae039)(vars, schemeVars);
        });
        return vars;
    };
    const generateStyleSheets = ()=>{
        const stylesheets = [];
        const colorScheme = theme.defaultColorScheme || 'light';
        function insertStyleSheet(key, css) {
            if (Object.keys(css).length) stylesheets.push(typeof key === 'string' ? {
                [key]: {
                    ...css
                }
            } : key);
        }
        insertStyleSheet(getSelector(undefined, {
            ...rootCss
        }), rootCss);
        const { [colorScheme]: defaultSchemeVal, ...other } = colorSchemesMap;
        if (defaultSchemeVal) {
            // default color scheme has to come before other color schemes
            const { css: css } = defaultSchemeVal;
            const cssColorSheme = colorSchemes[colorScheme]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(colorScheme, {
                ...finalCss
            }), finalCss);
        }
        Object.entries(other).forEach(([key, { css: css }])=>{
            const cssColorSheme = colorSchemes[key]?.palette?.mode;
            const finalCss = !disableCssColorScheme && cssColorSheme ? {
                colorScheme: cssColorSheme,
                ...css
            } : {
                ...css
            };
            insertStyleSheet(getSelector(key, {
                ...finalCss
            }), finalCss);
        });
        if (enableContrastVars) stylesheets.push({
            ':root': {
                // use double underscore to indicate that these are private variables
                '--__l-threshold': '0.7',
                '--__l': 'clamp(0, (l / var(--__l-threshold) - 1) * -infinity, 1)',
                '--__a': 'clamp(0.87, (l / var(--__l-threshold) - 1) * -infinity, 1)' // 0.87 is the default alpha value for black text.
            }
        });
        return stylesheets;
    };
    return {
        vars: themeVars,
        generateThemeVars: generateThemeVars,
        generateStyleSheets: generateStyleSheets
    };
}
var $508fc6c60afa1bca$export$2e2bcd8739ae039 = $508fc6c60afa1bca$var$prepareCssVars;

function $66ad9cf01c4526b5$export$2e2bcd8739ae039(typography) {
    const vars = {};
    const entries = Object.entries(typography);
    entries.forEach((entry)=>{
        const [key, value] = entry;
        if (typeof value === 'object') vars[key] = `${value.fontStyle ? `${value.fontStyle} ` : ''}${value.fontVariant ? `${value.fontVariant} ` : ''}${value.fontWeight ? `${value.fontWeight} ` : ''}${value.fontStretch ? `${value.fontStretch} ` : ''}${value.fontSize || ''}${value.lineHeight ? `/${value.lineHeight} ` : ''}${value.fontFamily || ''}`;
    });
    return vars;
}










function $359d1cd3c99dce0c$export$2e2bcd8739ae039(breakpoints, mixins) {
    return {
        toolbar: {
            minHeight: 56,
            [breakpoints.up('xs')]: {
                '@media (orientation: landscape)': {
                    minHeight: 48
                }
            },
            [breakpoints.up('sm')]: {
                minHeight: 64
            }
        },
        ...mixins
    };
}




function $807f5ad944800d5b$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $807f5ad944800d5b$var$caseAllCaps = {
    textTransform: 'uppercase'
};
const $807f5ad944800d5b$var$defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
function $807f5ad944800d5b$export$2e2bcd8739ae039(palette, typography) {
    const { fontFamily: fontFamily = $807f5ad944800d5b$var$defaultFontFamily, fontSize: // The default font size of the Material Specification.
    fontSize = 14, fontWeightLight: // px
    fontWeightLight = 300, fontWeightRegular: fontWeightRegular = 400, fontWeightMedium: fontWeightMedium = 500, fontWeightBold: fontWeightBold = 700, htmlFontSize: // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16, allVariants: // Apply the CSS properties to all the variants.
    allVariants, pxToRem: pxToRem2, ...other } = typeof typography === 'function' ? typography(palette) : typography;
    const coef = fontSize / 14;
    const pxToRem = pxToRem2 || ((size)=>`${size / htmlFontSize * coef}rem`);
    const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing)=>({
            fontFamily: fontFamily,
            fontWeight: fontWeight,
            fontSize: pxToRem(size),
            lineHeight: // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
            lineHeight,
            // The letter spacing was designed for the Roboto font-family. Using the same letter-spacing
            // across font-families can cause issues with the kerning.
            ...fontFamily === $807f5ad944800d5b$var$defaultFontFamily ? {
                letterSpacing: `${$807f5ad944800d5b$var$round(letterSpacing / size)}em`
            } : {},
            ...casing,
            ...allVariants
        });
    const variants = {
        h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
        h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
        h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
        h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
        h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
        h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
        subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
        subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
        body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
        body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
        button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, $807f5ad944800d5b$var$caseAllCaps),
        caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
        overline: buildVariant(fontWeightRegular, 12, 2.66, 1, $807f5ad944800d5b$var$caseAllCaps),
        // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
        inherit: {
            fontFamily: 'inherit',
            fontWeight: 'inherit',
            fontSize: 'inherit',
            lineHeight: 'inherit',
            letterSpacing: 'inherit'
        }
    };
    return (0, $2985df77ba145d35$export$2e2bcd8739ae039)({
        htmlFontSize: htmlFontSize,
        pxToRem: pxToRem,
        fontFamily: fontFamily,
        fontSize: fontSize,
        fontWeightLight: fontWeightLight,
        fontWeightRegular: fontWeightRegular,
        fontWeightMedium: fontWeightMedium,
        fontWeightBold: fontWeightBold,
        ...variants
    }, other, {
        clone: false // No need to clone deep
    });
}


const $5e676e189e322653$var$shadowKeyUmbraOpacity = 0.2;
const $5e676e189e322653$var$shadowKeyPenumbraOpacity = 0.14;
const $5e676e189e322653$var$shadowAmbientShadowOpacity = 0.12;
function $5e676e189e322653$var$createShadow(...px) {
    return [
        `${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${$5e676e189e322653$var$shadowKeyUmbraOpacity})`,
        `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${$5e676e189e322653$var$shadowKeyPenumbraOpacity})`,
        `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${$5e676e189e322653$var$shadowAmbientShadowOpacity})`
    ].join(',');
}
// Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
const $5e676e189e322653$var$shadows = [
    'none',
    $5e676e189e322653$var$createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
    $5e676e189e322653$var$createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
    $5e676e189e322653$var$createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
    $5e676e189e322653$var$createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
    $5e676e189e322653$var$createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
    $5e676e189e322653$var$createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
    $5e676e189e322653$var$createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
    $5e676e189e322653$var$createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
    $5e676e189e322653$var$createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
    $5e676e189e322653$var$createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
    $5e676e189e322653$var$createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
    $5e676e189e322653$var$createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
    $5e676e189e322653$var$createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
    $5e676e189e322653$var$createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
    $5e676e189e322653$var$createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
    $5e676e189e322653$var$createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
    $5e676e189e322653$var$createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
    $5e676e189e322653$var$createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
    $5e676e189e322653$var$createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
    $5e676e189e322653$var$createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
    $5e676e189e322653$var$createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
    $5e676e189e322653$var$createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
    $5e676e189e322653$var$createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
    $5e676e189e322653$var$createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)
];
var $5e676e189e322653$export$2e2bcd8739ae039 = $5e676e189e322653$var$shadows;


// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const $b3dcd50dcf07bac9$export$24c5ac7c37452e7d = {
    // This is the most common easing curve.
    easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
    // Objects enter the screen at full velocity from off-screen and
    // slowly decelerate to a resting point.
    easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
    // Objects leave the screen at full velocity. They do not decelerate when off-screen.
    easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
    // The sharp curve is used by objects that may return to the screen at any time.
    sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
};
const $b3dcd50dcf07bac9$export$1f34108aa9eb96ab = {
    shortest: 150,
    shorter: 200,
    short: 250,
    // most basic recommended timing
    standard: 300,
    // this is to be used in complex animations
    complex: 375,
    // recommended when something is entering screen
    enteringScreen: 225,
    // recommended when something is leaving screen
    leavingScreen: 195
};
function $b3dcd50dcf07bac9$var$formatMs(milliseconds) {
    return `${Math.round(milliseconds)}ms`;
}
function $b3dcd50dcf07bac9$var$getAutoHeightDuration(height) {
    if (!height) return 0;
    const constant = height / 36;
    // https://www.desmos.com/calculator/vbrp3ggqet
    return Math.min(Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10), 3000);
}
function $b3dcd50dcf07bac9$export$2e2bcd8739ae039(inputTransitions) {
    const mergedEasing = {
        ...$b3dcd50dcf07bac9$export$24c5ac7c37452e7d,
        ...inputTransitions.easing
    };
    const mergedDuration = {
        ...$b3dcd50dcf07bac9$export$1f34108aa9eb96ab,
        ...inputTransitions.duration
    };
    const create = (props = [
        'all'
    ], options = {})=>{
        const { duration: durationOption = mergedDuration.standard, easing: easingOption = mergedEasing.easeInOut, delay: delay = 0, ...other } = options;
        return (Array.isArray(props) ? props : [
            props
        ]).map((animatedProp)=>`${animatedProp} ${typeof durationOption === 'string' ? durationOption : $b3dcd50dcf07bac9$var$formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : $b3dcd50dcf07bac9$var$formatMs(delay)}`).join(',');
    };
    return {
        getAutoHeightDuration: $b3dcd50dcf07bac9$var$getAutoHeightDuration,
        create: create,
        ...inputTransitions,
        easing: mergedEasing,
        duration: mergedDuration
    };
}


// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const $6899f6a23f8dea0a$var$zIndex = {
    mobileStepper: 1000,
    fab: 1050,
    speedDial: 1050,
    appBar: 1100,
    drawer: 1200,
    modal: 1300,
    snackbar: 1400,
    tooltip: 1500
};
var $6899f6a23f8dea0a$export$2e2bcd8739ae039 = $6899f6a23f8dea0a$var$zIndex;


/* eslint-disable import/prefer-default-export */ 
function $158c2acb0a4a3031$var$isSerializable(val) {
    return (0, $2985df77ba145d35$export$53b83ca8eaab0383)(val) || typeof val === 'undefined' || typeof val === 'string' || typeof val === 'boolean' || typeof val === 'number' || Array.isArray(val);
}
function $158c2acb0a4a3031$export$32c2afa5f91892aa(baseTheme = {}) {
    const serializableTheme = {
        ...baseTheme
    };
    function serializeTheme(object) {
        const array = Object.entries(object);
        // eslint-disable-next-line no-plusplus
        for(let index = 0; index < array.length; index++){
            const [key, value] = array[index];
            if (!$158c2acb0a4a3031$var$isSerializable(value) || key.startsWith('unstable_')) delete object[key];
            else if ((0, $2985df77ba145d35$export$53b83ca8eaab0383)(value)) {
                object[key] = {
                    ...value
                };
                serializeTheme(object[key]);
            }
        }
    }
    serializeTheme(serializableTheme);
    return `import { unstable_createBreakpoints as createBreakpoints, createTransitions } from '@mui/material/styles';

const theme = ${JSON.stringify(serializableTheme, null, 2)};

theme.breakpoints = createBreakpoints(theme.breakpoints || {});
theme.transitions = createTransitions(theme.transitions || {});

export default theme;`;
}


function $ccb5a5a44382729b$var$coefficientToPercentage(coefficient) {
    if (typeof coefficient === 'number') return `${(coefficient * 100).toFixed(0)}%`;
    return `calc((${coefficient}) * 100%)`;
}
// This can be removed when moved to `color-mix()` entirely.
const $ccb5a5a44382729b$var$parseAddition = (str)=>{
    if (!Number.isNaN(+str)) return +str;
    const numbers = str.match(/\d*\.?\d+/g);
    if (!numbers) return 0;
    let sum = 0;
    for(let i = 0; i < numbers.length; i += 1)sum += +numbers[i];
    return sum;
};
function $ccb5a5a44382729b$var$attachColorManipulators(theme) {
    Object.assign(theme, {
        alpha (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `oklch(from ${color} l c h / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            if (obj.vars) // To preserve the behavior of the CSS theme variables
            // In the future, this could be replaced by `color-mix` (when https://caniuse.com/?search=color-mix reaches 95%).
            return `rgba(${color.replace(/var\(--([^,\s)]+)(?:,[^)]+)?\)+/g, 'var(--$1Channel)')} / ${typeof coefficient === 'string' ? `calc(${coefficient})` : coefficient})`;
            return (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(color, $ccb5a5a44382729b$var$parseAddition(coefficient));
        },
        lighten (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #fff ${$ccb5a5a44382729b$var$coefficientToPercentage(coefficient)})`;
            return (0, $7ebe803ced17df29$export$c0816ed86df316af)(color, coefficient);
        },
        darken (color, coefficient) {
            const obj = this || theme;
            if (obj.colorSpace) return `color-mix(in ${obj.colorSpace}, ${color}, #000 ${$ccb5a5a44382729b$var$coefficientToPercentage(coefficient)})`;
            return (0, $7ebe803ced17df29$export$4b073707ff63303)(color, coefficient);
        }
    });
}
function $ccb5a5a44382729b$var$createThemeNoVars(options = {}, ...args) {
    const { breakpoints: breakpointsInput, mixins: mixinsInput = {}, spacing: spacingInput, palette: paletteInput = {}, transitions: transitionsInput = {}, typography: typographyInput = {}, shape: shapeInput, colorSpace: colorSpace, ...other } = options;
    if (options.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
    // `generateThemeVars` is the closest identifier for checking that the `options` is a result of `createTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
    options.generateThemeVars === undefined) throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(20));
    const palette = (0, $5763e0c539a251df$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    const systemTheme = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)(options);
    let muiTheme = (0, $2985df77ba145d35$export$2e2bcd8739ae039)(systemTheme, {
        mixins: (0, $359d1cd3c99dce0c$export$2e2bcd8739ae039)(systemTheme.breakpoints, mixinsInput),
        palette: palette,
        // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
        shadows: (0, $5e676e189e322653$export$2e2bcd8739ae039).slice(),
        typography: (0, $807f5ad944800d5b$export$2e2bcd8739ae039)(palette, typographyInput),
        transitions: (0, $b3dcd50dcf07bac9$export$2e2bcd8739ae039)(transitionsInput),
        zIndex: {
            ...(0, $6899f6a23f8dea0a$export$2e2bcd8739ae039)
        }
    });
    muiTheme = (0, $2985df77ba145d35$export$2e2bcd8739ae039)(muiTheme, other);
    muiTheme = args.reduce((acc, argument)=>(0, $2985df77ba145d35$export$2e2bcd8739ae039)(acc, argument), muiTheme);
    var component;
    muiTheme.unstable_sxConfig = {
        ...(0, $f27f6a6c429b3415$export$2e2bcd8739ae039),
        ...other?.unstable_sxConfig
    };
    muiTheme.unstable_sx = function sx(props) {
        return (0, $6b750d631801d296$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    muiTheme.toRuntimeSource = (0, $158c2acb0a4a3031$export$32c2afa5f91892aa); // for Pigment CSS integration
    $ccb5a5a44382729b$var$attachColorManipulators(muiTheme);
    return muiTheme;
}
var $ccb5a5a44382729b$export$2e2bcd8739ae039 = $ccb5a5a44382729b$var$createThemeNoVars;



// Inspired by https://github.com/material-components/material-components-ios/blob/bca36107405594d5b7b16265a5b0ed698f85a5ee/components/Elevation/src/UIColor%2BMaterialElevation.m#L61
function $399a169bab06dc0f$export$2e2bcd8739ae039(elevation) {
    let alphaValue;
    if (elevation < 1) alphaValue = 5.11916 * elevation ** 2;
    else alphaValue = 4.5 * Math.log(elevation + 1) + 2;
    return Math.round(alphaValue * 10) / 1000;
}


const $baf1ba368e53b158$var$defaultDarkOverlays = [
    ...Array(25)
].map((_, index)=>{
    if (index === 0) return 'none';
    const overlay = (0, $399a169bab06dc0f$export$2e2bcd8739ae039)(index);
    return `linear-gradient(rgba(255 255 255 / ${overlay}), rgba(255 255 255 / ${overlay}))`;
});
function $baf1ba368e53b158$export$c85e0347fceb69ba(mode) {
    return {
        inputPlaceholder: mode === 'dark' ? 0.5 : 0.42,
        inputUnderline: mode === 'dark' ? 0.7 : 0.42,
        switchTrackDisabled: mode === 'dark' ? 0.2 : 0.12,
        switchTrack: mode === 'dark' ? 0.3 : 0.38
    };
}
function $baf1ba368e53b158$export$dd191566510330d3(mode) {
    return mode === 'dark' ? $baf1ba368e53b158$var$defaultDarkOverlays : [];
}
function $baf1ba368e53b158$export$2e2bcd8739ae039(options) {
    const { palette: paletteInput = {
        mode: 'light'
    }, opacity: // need to cast to avoid module augmentation test
    opacity, overlays: overlays, colorSpace: colorSpace, ...other } = options;
    // need to cast because `colorSpace` is considered internal at the moment.
    const palette = (0, $5763e0c539a251df$export$2e2bcd8739ae039)({
        ...paletteInput,
        colorSpace: colorSpace
    });
    return {
        palette: palette,
        opacity: {
            ...$baf1ba368e53b158$export$c85e0347fceb69ba(palette.mode),
            ...opacity
        },
        overlays: overlays || $baf1ba368e53b158$export$dd191566510330d3(palette.mode),
        ...other
    };
}


function $367a4b35286320ec$export$2e2bcd8739ae039(keys) {
    return !!keys[0].match(/(cssVarPrefix|colorSchemeSelector|modularCssLayers|rootSelector|typography|mixins|breakpoints|direction|transitions)/) || !!keys[0].match(/sxConfig$/) || // ends with sxConfig
    keys[0] === 'palette' && !!keys[1]?.match(/(mode|contrastThreshold|tonalOffset)/);
}


/**
 * @internal These variables should not appear in the :root stylesheet when the `defaultColorScheme="dark"`
 */ const $eeb996f5fdb0285b$var$excludeVariablesFromRoot = (cssVarPrefix)=>[
        ...[
            ...Array(25)
        ].map((_, index)=>`--${cssVarPrefix ? `${cssVarPrefix}-` : ''}overlays-${index}`),
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkBg`,
        `--${cssVarPrefix ? `${cssVarPrefix}-` : ''}palette-AppBar-darkColor`
    ];
var $eeb996f5fdb0285b$export$2e2bcd8739ae039 = $eeb996f5fdb0285b$var$excludeVariablesFromRoot;


var $4027f8c8ae6e8b1d$export$2e2bcd8739ae039 = (theme)=>(colorScheme, css)=>{
        const root = theme.rootSelector || ':root';
        const selector = theme.colorSchemeSelector;
        let rule = selector;
        if (selector === 'class') rule = '.%s';
        if (selector === 'data') rule = '[data-%s]';
        if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
        rule = `[${selector}="%s"]`;
        if (theme.defaultColorScheme === colorScheme) {
            if (colorScheme === 'dark') {
                const excludedVariables = {};
                (0, $eeb996f5fdb0285b$export$2e2bcd8739ae039)(theme.cssVarPrefix).forEach((cssVar)=>{
                    excludedVariables[cssVar] = css[cssVar];
                    delete css[cssVar];
                });
                if (rule === 'media') return {
                    [root]: css,
                    [`@media (prefers-color-scheme: dark)`]: {
                        [root]: excludedVariables
                    }
                };
                if (rule) return {
                    [rule.replace('%s', colorScheme)]: excludedVariables,
                    [`${root}, ${rule.replace('%s', colorScheme)}`]: css
                };
                return {
                    [root]: {
                        ...css,
                        ...excludedVariables
                    }
                };
            }
            if (rule && rule !== 'media') return `${root}, ${rule.replace('%s', String(colorScheme))}`;
        } else if (colorScheme) {
            if (rule === 'media') return {
                [`@media (prefers-color-scheme: ${String(colorScheme)})`]: {
                    [root]: css
                }
            };
            if (rule) return rule.replace('%s', String(colorScheme));
        }
        return root;
    };




function $a8fc49caae8a6210$var$assignNode(obj, keys) {
    keys.forEach((k)=>{
        if (!obj[k]) obj[k] = {};
    });
}
function $a8fc49caae8a6210$var$setColor(obj, key, defaultValue) {
    if (!obj[key] && defaultValue) obj[key] = defaultValue;
}
function $a8fc49caae8a6210$var$toRgb(color) {
    if (typeof color !== 'string' || !color.startsWith('hsl')) return color;
    return (0, $7ebe803ced17df29$export$29fb7152bd3f781a)(color);
}
function $a8fc49caae8a6210$var$setColorChannel(obj, key) {
    if (!(`${key}Channel` in obj)) // custom channel token is not provided, generate one.
    // if channel token can't be generated, show a warning.
    obj[`${key}Channel`] = (0, $7ebe803ced17df29$export$427365fc3db6fc5e)($a8fc49caae8a6210$var$toRgb(obj[key]), `MUI: Can't create \`palette.${key}Channel\` because \`palette.${key}\` is not one of these formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color().` + '\n' + `To suppress this warning, you need to explicitly provide the \`palette.${key}Channel\` as a string (in rgb format, for example "12 12 12") or undefined if you want to remove the channel token.`);
}
function $a8fc49caae8a6210$var$getSpacingVal(spacingInput) {
    if (typeof spacingInput === 'number') return `${spacingInput}px`;
    if (typeof spacingInput === 'string' || typeof spacingInput === 'function' || Array.isArray(spacingInput)) return spacingInput;
    return '8px';
}
const $a8fc49caae8a6210$var$silent = (fn)=>{
    try {
        return fn();
    } catch (error) {
    // ignore error
    }
    return undefined;
};
const $a8fc49caae8a6210$export$65418b4d9082cc44 = (cssVarPrefix = 'mui')=>(0, $b82d0f0117f79ef3$export$2e2bcd8739ae039)(cssVarPrefix);
function $a8fc49caae8a6210$var$attachColorScheme(colorSpace, colorSchemes, scheme, restTheme, colorScheme) {
    if (!scheme) return undefined;
    scheme = scheme === true ? {} : scheme;
    const mode = colorScheme === 'dark' ? 'dark' : 'light';
    if (!restTheme) {
        colorSchemes[colorScheme] = (0, $baf1ba368e53b158$export$2e2bcd8739ae039)({
            ...scheme,
            palette: {
                mode: mode,
                ...scheme?.palette
            },
            colorSpace: colorSpace
        });
        return undefined;
    }
    const { palette: palette, ...muiTheme } = (0, $ccb5a5a44382729b$export$2e2bcd8739ae039)({
        ...restTheme,
        palette: {
            mode: mode,
            ...scheme?.palette
        },
        colorSpace: colorSpace
    });
    colorSchemes[colorScheme] = {
        ...scheme,
        palette: palette,
        opacity: {
            ...(0, $baf1ba368e53b158$export$c85e0347fceb69ba)(mode),
            ...scheme?.opacity
        },
        overlays: scheme?.overlays || (0, $baf1ba368e53b158$export$dd191566510330d3)(mode)
    };
    return muiTheme;
}
function $a8fc49caae8a6210$export$2e2bcd8739ae039(options = {}, ...args) {
    const { colorSchemes: colorSchemesInput = {
        light: true
    }, defaultColorScheme: defaultColorSchemeInput, disableCssColorScheme: disableCssColorScheme = false, cssVarPrefix: cssVarPrefix = 'mui', nativeColor: nativeColor = false, shouldSkipGeneratingVar: shouldSkipGeneratingVar = (0, $367a4b35286320ec$export$2e2bcd8739ae039), colorSchemeSelector: selector = colorSchemesInput.light && colorSchemesInput.dark ? 'media' : undefined, rootSelector: rootSelector = ':root', ...input } = options;
    const firstColorScheme = Object.keys(colorSchemesInput)[0];
    const defaultColorScheme = defaultColorSchemeInput || (colorSchemesInput.light && firstColorScheme !== 'light' ? 'light' : firstColorScheme);
    const getCssVar = $a8fc49caae8a6210$export$65418b4d9082cc44(cssVarPrefix);
    const { [defaultColorScheme]: defaultSchemeInput, light: builtInLight, dark: builtInDark, ...customColorSchemes } = colorSchemesInput;
    const colorSchemes = {
        ...customColorSchemes
    };
    let defaultScheme = defaultSchemeInput;
    // For built-in light and dark color schemes, ensure that the value is valid if they are the default color scheme.
    if (defaultColorScheme === 'dark' && !('dark' in colorSchemesInput) || defaultColorScheme === 'light' && !('light' in colorSchemesInput)) defaultScheme = true;
    if (!defaultScheme) throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(21, defaultColorScheme));
    // The reason to use `oklch` is that it is the most perceptually uniform color space and widely supported.
    let colorSpace;
    if (nativeColor) colorSpace = 'oklch';
    // Create the palette for the default color scheme, either `light`, `dark`, or custom color scheme.
    const muiTheme = $a8fc49caae8a6210$var$attachColorScheme(colorSpace, colorSchemes, defaultScheme, input, defaultColorScheme);
    if (builtInLight && !colorSchemes.light) $a8fc49caae8a6210$var$attachColorScheme(colorSpace, colorSchemes, builtInLight, undefined, 'light');
    if (builtInDark && !colorSchemes.dark) $a8fc49caae8a6210$var$attachColorScheme(colorSpace, colorSchemes, builtInDark, undefined, 'dark');
    let theme = {
        defaultColorScheme: defaultColorScheme,
        ...muiTheme,
        cssVarPrefix: cssVarPrefix,
        colorSchemeSelector: selector,
        rootSelector: rootSelector,
        getCssVar: getCssVar,
        colorSchemes: colorSchemes,
        font: {
            ...(0, $66ad9cf01c4526b5$export$2e2bcd8739ae039)(muiTheme.typography),
            ...muiTheme.font
        },
        spacing: $a8fc49caae8a6210$var$getSpacingVal(input.spacing)
    };
    Object.keys(theme.colorSchemes).forEach((key)=>{
        const palette = theme.colorSchemes[key].palette;
        const setCssVarColor = (cssVar)=>{
            const tokens = cssVar.split('-');
            const color = tokens[1];
            const colorToken = tokens[2];
            return getCssVar(cssVar, palette[color][colorToken]);
        };
        // attach black & white channels to common node
        if (palette.mode === 'light') {
            $a8fc49caae8a6210$var$setColor(palette.common, 'background', '#fff');
            $a8fc49caae8a6210$var$setColor(palette.common, 'onBackground', '#000');
        }
        if (palette.mode === 'dark') {
            $a8fc49caae8a6210$var$setColor(palette.common, 'background', '#000');
            $a8fc49caae8a6210$var$setColor(palette.common, 'onBackground', '#fff');
        }
        function colorMix(method, color, coefficient) {
            if (colorSpace) {
                let mixer;
                if (method === (0, $7ebe803ced17df29$export$34109543fc7f43f8)) mixer = `transparent ${((1 - coefficient) * 100).toFixed(0)}%`;
                if (method === (0, $7ebe803ced17df29$export$eaaef2dca3e9e512)) mixer = `#000 ${(coefficient * 100).toFixed(0)}%`;
                if (method === (0, $7ebe803ced17df29$export$aeeda94ef1d01275)) mixer = `#fff ${(coefficient * 100).toFixed(0)}%`;
                return `color-mix(in ${colorSpace}, ${color}, ${mixer})`;
            }
            return method(color, coefficient);
        }
        // assign component variables
        $a8fc49caae8a6210$var$assignNode(palette, [
            'Alert',
            'AppBar',
            'Avatar',
            'Button',
            'Chip',
            'FilledInput',
            'LinearProgress',
            'Skeleton',
            'Slider',
            'SnackbarContent',
            'SpeedDialAction',
            'StepConnector',
            'StepContent',
            'Switch',
            'TableCell',
            'Tooltip'
        ]);
        if (palette.mode === 'light') {
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.error.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.info.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.success.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.warning.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.error.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.info.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.success.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.warning.main)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.error.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.info.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.success.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.warning.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-100'));
            $a8fc49caae8a6210$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-A100'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'bg', 'rgba(0, 0, 0, 0.06)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(0, 0, 0, 0.09)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(0, 0, 0, 0.12)');
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.warning.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $7ebe803ced17df29$export$34109543fc7f43f8), palette.text.primary, 0.11) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.11)`);
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'successTrack', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.warning.main, 0.62));
            const snackbarContentBackground = colorSpace ? colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.background.default, 0.6825) // use `0.6825` instead of `0.8` to match the contrast ratio of JS implementation
             : (0, $7ebe803ced17df29$export$11bb74ba10c85505)(palette.background.default, 0.8);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'color', $a8fc49caae8a6210$var$silent(()=>colorSpace ? (0, $5763e0c539a251df$export$55ce6f3a06c59543).text.primary : palette.getContrastText(snackbarContentBackground)));
            $a8fc49caae8a6210$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $7ebe803ced17df29$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $a8fc49caae8a6210$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-400'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-common-white'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-100'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.primary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.secondary.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.error.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.info.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.success.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.warning.main, 0.62));
            $a8fc49caae8a6210$var$setColor(palette.TableCell, 'border', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), colorMix((0, $7ebe803ced17df29$export$34109543fc7f43f8), palette.divider, 1), 0.88));
            $a8fc49caae8a6210$var$setColor(palette.Tooltip, 'bg', colorMix((0, $7ebe803ced17df29$export$34109543fc7f43f8), palette.grey[700], 0.92));
        }
        if (palette.mode === 'dark') {
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.error.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.info.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.success.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningColor', colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.warning.light, 0.6));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledBg', setCssVarColor('palette-error-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledBg', setCssVarColor('palette-info-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledBg', setCssVarColor('palette-success-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledBg', setCssVarColor('palette-warning-dark'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.error.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.info.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.success.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningFilledColor', $a8fc49caae8a6210$var$silent(()=>palette.getContrastText(palette.warning.dark)));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorStandardBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.error.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoStandardBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.info.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successStandardBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.success.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningStandardBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.warning.light, 0.9));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'errorIconColor', setCssVarColor('palette-error-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'infoIconColor', setCssVarColor('palette-info-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'successIconColor', setCssVarColor('palette-success-main'));
            $a8fc49caae8a6210$var$setColor(palette.Alert, 'warningIconColor', setCssVarColor('palette-warning-main'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'defaultBg', setCssVarColor('palette-grey-900'));
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'darkBg', setCssVarColor('palette-background-paper')); // specific for dark mode
            $a8fc49caae8a6210$var$setColor(palette.AppBar, 'darkColor', setCssVarColor('palette-text-primary')); // specific for dark mode
            $a8fc49caae8a6210$var$setColor(palette.Avatar, 'defaultBg', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedBg', setCssVarColor('palette-grey-800'));
            $a8fc49caae8a6210$var$setColor(palette.Button, 'inheritContainedHoverBg', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultBorder', setCssVarColor('palette-grey-700'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultAvatarColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Chip, 'defaultIconColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'bg', 'rgba(255, 255, 255, 0.09)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'hoverBg', 'rgba(255, 255, 255, 0.13)');
            $a8fc49caae8a6210$var$setColor(palette.FilledInput, 'disabledBg', 'rgba(255, 255, 255, 0.12)');
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'primaryBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.primary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'secondaryBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.secondary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'errorBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.error.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'infoBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.info.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'successBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.success.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.LinearProgress, 'warningBg', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.warning.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Skeleton, 'bg', colorSpace ? colorMix((0, $7ebe803ced17df29$export$34109543fc7f43f8), palette.text.primary, 0.13) : `rgba(${setCssVarColor('palette-text-primaryChannel')} / 0.13)`);
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'primaryTrack', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.primary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'secondaryTrack', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.secondary.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'errorTrack', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.error.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'infoTrack', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.info.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'successTrack', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.success.main, 0.5));
            $a8fc49caae8a6210$var$setColor(palette.Slider, 'warningTrack', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.warning.main, 0.5));
            const snackbarContentBackground = colorSpace ? colorMix((0, $7ebe803ced17df29$export$aeeda94ef1d01275), palette.background.default, 0.985) // use `0.985` instead of `0.98` to match the contrast ratio of JS implementation
             : (0, $7ebe803ced17df29$export$11bb74ba10c85505)(palette.background.default, 0.98);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'bg', snackbarContentBackground);
            $a8fc49caae8a6210$var$setColor(palette.SnackbarContent, 'color', $a8fc49caae8a6210$var$silent(()=>colorSpace ? (0, $5763e0c539a251df$export$a43af521ac8c3202).text.primary : palette.getContrastText(snackbarContentBackground)));
            $a8fc49caae8a6210$var$setColor(palette.SpeedDialAction, 'fabHoverBg', (0, $7ebe803ced17df29$export$11bb74ba10c85505)(palette.background.paper, 0.15));
            $a8fc49caae8a6210$var$setColor(palette.StepConnector, 'border', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.StepContent, 'border', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultColor', setCssVarColor('palette-grey-300'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'defaultDisabledColor', setCssVarColor('palette-grey-600'));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'primaryDisabledColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.primary.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'secondaryDisabledColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.secondary.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'errorDisabledColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.error.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'infoDisabledColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.info.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'successDisabledColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.success.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.Switch, 'warningDisabledColor', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), palette.warning.main, 0.55));
            $a8fc49caae8a6210$var$setColor(palette.TableCell, 'border', colorMix((0, $7ebe803ced17df29$export$eaaef2dca3e9e512), colorMix((0, $7ebe803ced17df29$export$34109543fc7f43f8), palette.divider, 1), 0.68));
            $a8fc49caae8a6210$var$setColor(palette.Tooltip, 'bg', colorMix((0, $7ebe803ced17df29$export$34109543fc7f43f8), palette.grey[700], 0.92));
        }
        // MUI X - DataGrid needs this token.
        $a8fc49caae8a6210$var$setColorChannel(palette.background, 'default');
        // added for consistency with the `background.default` token
        $a8fc49caae8a6210$var$setColorChannel(palette.background, 'paper');
        $a8fc49caae8a6210$var$setColorChannel(palette.common, 'background');
        $a8fc49caae8a6210$var$setColorChannel(palette.common, 'onBackground');
        $a8fc49caae8a6210$var$setColorChannel(palette, 'divider');
        Object.keys(palette).forEach((color)=>{
            const colors = palette[color];
            // The default palettes (primary, secondary, error, info, success, and warning) errors are handled by the above `createTheme(...)`.
            if (color !== 'tonalOffset' && colors && typeof colors === 'object') {
                // Silent the error for custom palettes.
                if (colors.main) $a8fc49caae8a6210$var$setColor(palette[color], 'mainChannel', (0, $7ebe803ced17df29$export$427365fc3db6fc5e)($a8fc49caae8a6210$var$toRgb(colors.main)));
                if (colors.light) $a8fc49caae8a6210$var$setColor(palette[color], 'lightChannel', (0, $7ebe803ced17df29$export$427365fc3db6fc5e)($a8fc49caae8a6210$var$toRgb(colors.light)));
                if (colors.dark) $a8fc49caae8a6210$var$setColor(palette[color], 'darkChannel', (0, $7ebe803ced17df29$export$427365fc3db6fc5e)($a8fc49caae8a6210$var$toRgb(colors.dark)));
                if (colors.contrastText) $a8fc49caae8a6210$var$setColor(palette[color], 'contrastTextChannel', (0, $7ebe803ced17df29$export$427365fc3db6fc5e)($a8fc49caae8a6210$var$toRgb(colors.contrastText)));
                if (color === 'text') {
                    // Text colors: text.primary, text.secondary
                    $a8fc49caae8a6210$var$setColorChannel(palette[color], 'primary');
                    $a8fc49caae8a6210$var$setColorChannel(palette[color], 'secondary');
                }
                if (color === 'action') {
                    // Action colors: action.active, action.selected
                    if (colors.active) $a8fc49caae8a6210$var$setColorChannel(palette[color], 'active');
                    if (colors.selected) $a8fc49caae8a6210$var$setColorChannel(palette[color], 'selected');
                }
            }
        });
    });
    theme = args.reduce((acc, argument)=>(0, $2985df77ba145d35$export$2e2bcd8739ae039)(acc, argument), theme);
    const parserConfig = {
        prefix: cssVarPrefix,
        disableCssColorScheme: disableCssColorScheme,
        shouldSkipGeneratingVar: shouldSkipGeneratingVar,
        getSelector: (0, $4027f8c8ae6e8b1d$export$2e2bcd8739ae039)(theme),
        enableContrastVars: nativeColor
    };
    const { vars: vars, generateThemeVars: generateThemeVars, generateStyleSheets: generateStyleSheets } = (0, $508fc6c60afa1bca$export$2e2bcd8739ae039)(theme, parserConfig);
    theme.vars = vars;
    Object.entries(theme.colorSchemes[theme.defaultColorScheme]).forEach(([key, value])=>{
        theme[key] = value;
    });
    theme.generateThemeVars = generateThemeVars;
    theme.generateStyleSheets = generateStyleSheets;
    theme.generateSpacing = function generateSpacing() {
        return (0, $1f392ba2ebd18096$export$2e2bcd8739ae039)(input.spacing, (0, $555e14aafbcd0190$export$1def6f833384e3d1)(this));
    };
    theme.getColorSchemeSelector = (0, $2856c28c5d84ba80$export$858538ff6c0d421d)(selector);
    theme.spacing = theme.generateSpacing();
    theme.shouldSkipGeneratingVar = shouldSkipGeneratingVar;
    theme.unstable_sxConfig = {
        ...(0, $f27f6a6c429b3415$export$2e2bcd8739ae039),
        ...input?.unstable_sxConfig
    };
    theme.unstable_sx = function sx(props) {
        return (0, $6b750d631801d296$export$2e2bcd8739ae039)({
            sx: props,
            theme: this
        });
    };
    theme.toRuntimeSource = (0, $158c2acb0a4a3031$export$32c2afa5f91892aa); // for Pigment CSS integration
    return theme;
}



// eslint-disable-next-line consistent-return
function $1c8355eadf532640$var$attachColorScheme(theme, scheme, colorScheme) {
    if (!theme.colorSchemes) return undefined;
    if (colorScheme) theme.colorSchemes[scheme] = {
        ...colorScheme !== true && colorScheme,
        palette: (0, $5763e0c539a251df$export$2e2bcd8739ae039)({
            ...colorScheme === true ? {} : colorScheme.palette,
            mode: scheme
        }) // cast type to skip module augmentation test
    };
}
function $1c8355eadf532640$export$2e2bcd8739ae039(options = {}, // cast type to skip module augmentation test
...args) {
    const { palette: palette, cssVariables: cssVariables = false, colorSchemes: initialColorSchemes = !palette ? {
        light: true
    } : undefined, defaultColorScheme: initialDefaultColorScheme = palette?.mode, ...other } = options;
    const defaultColorSchemeInput = initialDefaultColorScheme || 'light';
    const defaultScheme = initialColorSchemes?.[defaultColorSchemeInput];
    const colorSchemesInput = {
        ...initialColorSchemes,
        ...palette ? {
            [defaultColorSchemeInput]: {
                ...typeof defaultScheme !== 'boolean' && defaultScheme,
                palette: palette
            }
        } : undefined
    };
    if (cssVariables === false) {
        if (!('colorSchemes' in options)) // Behaves exactly as v5
        return (0, $ccb5a5a44382729b$export$2e2bcd8739ae039)(options, ...args);
        let paletteOptions = palette;
        if (!('palette' in options)) {
            if (colorSchemesInput[defaultColorSchemeInput]) {
                if (colorSchemesInput[defaultColorSchemeInput] !== true) paletteOptions = colorSchemesInput[defaultColorSchemeInput].palette;
                else if (defaultColorSchemeInput === 'dark') // @ts-ignore to prevent the module augmentation test from failing
                paletteOptions = {
                    mode: 'dark'
                };
            }
        }
        const theme = (0, $ccb5a5a44382729b$export$2e2bcd8739ae039)({
            ...options,
            palette: paletteOptions
        }, ...args);
        theme.defaultColorScheme = defaultColorSchemeInput;
        theme.colorSchemes = colorSchemesInput;
        if (theme.palette.mode === 'light') {
            theme.colorSchemes.light = {
                ...colorSchemesInput.light !== true && colorSchemesInput.light,
                palette: theme.palette
            };
            $1c8355eadf532640$var$attachColorScheme(theme, 'dark', colorSchemesInput.dark);
        }
        if (theme.palette.mode === 'dark') {
            theme.colorSchemes.dark = {
                ...colorSchemesInput.dark !== true && colorSchemesInput.dark,
                palette: theme.palette
            };
            $1c8355eadf532640$var$attachColorScheme(theme, 'light', colorSchemesInput.light);
        }
        return theme;
    }
    if (!palette && !('light' in colorSchemesInput) && defaultColorSchemeInput === 'light') colorSchemesInput.light = true;
    return (0, $a8fc49caae8a6210$export$2e2bcd8739ae039)({
        ...other,
        colorSchemes: colorSchemesInput,
        defaultColorScheme: defaultColorSchemeInput,
        ...typeof cssVariables !== 'boolean' && cssVariables
    }, ...args);
}


'use client';
const $a477e5500cafdc51$var$defaultTheme = (0, $1c8355eadf532640$export$2e2bcd8739ae039)();
var $a477e5500cafdc51$export$2e2bcd8739ae039 = $a477e5500cafdc51$var$defaultTheme;


var $8b4c3f6e5c407120$export$2e2bcd8739ae039 = '$$material';


'use client';
function $81976569638fc3b7$export$2e2bcd8739ae039() {
    const theme = (0, $ac16d208682bdb3f$export$2e2bcd8739ae039)((0, $a477e5500cafdc51$export$2e2bcd8739ae039));
    return theme[0, $8b4c3f6e5c407120$export$2e2bcd8739ae039] || theme;
}


parcelRequire("acw62");

parcelRequire("acw62");

parcelRequire("acw62");



'use client';
function $afce2778e79e00d1$var$isEmpty(obj) {
    return obj === undefined || obj === null || Object.keys(obj).length === 0;
}
function $afce2778e79e00d1$export$2e2bcd8739ae039(props) {
    const { styles: styles, defaultTheme: defaultTheme = {} } = props;
    const globalStyles = typeof styles === 'function' ? (themeInput)=>styles($afce2778e79e00d1$var$isEmpty(themeInput) ? defaultTheme : themeInput) : styles;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63d46a01db878c10$export$98f03c5d19621d70), {
        styles: globalStyles
    });
}

/**
 * @mui/styled-engine v7.3.3
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 





var $acw62 = parcelRequire("acw62");

// eslint-disable-next-line no-undef
var $bcd4e42ca4163639$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $bcd4e42ca4163639$export$2e2bcd8739ae039 = /* #__PURE__ */ (0, $6bb1e54ce1bc6efa$export$2e2bcd8739ae039)(function(prop) {
    return $bcd4e42ca4163639$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});


var $60e97af874e8cdaa$var$isDevelopment = false;
var $60e97af874e8cdaa$var$testOmitPropsOnStringTag = (0, $bcd4e42ca4163639$export$2e2bcd8739ae039);
var $60e97af874e8cdaa$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme';
};
var $60e97af874e8cdaa$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $60e97af874e8cdaa$var$testOmitPropsOnStringTag : $60e97af874e8cdaa$var$testOmitPropsOnComponent;
};
var $60e97af874e8cdaa$var$composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
    var shouldForwardProp;
    if (options) {
        var optionsShouldForwardProp = options.shouldForwardProp;
        shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
        } : optionsShouldForwardProp;
    }
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    return shouldForwardProp;
};
var $60e97af874e8cdaa$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $1f6791d0a193b918$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $19b532704a3a90e7$export$db21c7ffa21794e7)(function() {
        return (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $60e97af874e8cdaa$export$2e2bcd8739ae039 = function createStyled(tag, options) {
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    var identifierName;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
    }
    var shouldForwardProp = $60e97af874e8cdaa$var$composeShouldForwardProps(tag, options, isReal);
    var defaultShouldForwardProp = shouldForwardProp || $60e97af874e8cdaa$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        // eslint-disable-next-line prefer-rest-params
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) // eslint-disable-next-line prefer-spread
        styles.push.apply(styles, args);
        else {
            var templateStringsArr = args[0];
            styles.push(templateStringsArr[0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], templateStringsArr[i]);
        }
        var Styled = (0, $4eee05ec22b53782$export$efccba1c4a2ef57b)(function(props, cache, ref) {
            var FinalTag = shouldUseAs && props.as || baseTag;
            var className = '';
            var classInterpolations = [];
            var mergedProps = props;
            if (props.theme == null) {
                mergedProps = {};
                for(var key in props)mergedProps[key] = props[key];
                mergedProps.theme = $acw62.useContext((0, $4eee05ec22b53782$export$971d5caa766a69d7));
            }
            if (typeof props.className === 'string') className = (0, $1f6791d0a193b918$export$95d99596f328fd52)(cache.registered, classInterpolations, props.className);
            else if (props.className != null) className = props.className + " ";
            var serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(styles.concat(classInterpolations), cache.registered, mergedProps);
            className += cache.key + "-" + serialized.name;
            if (targetClassName !== undefined) className += " " + targetClassName;
            var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $60e97af874e8cdaa$var$getDefaultShouldForwardProp(FinalTag) : defaultShouldForwardProp;
            var newProps = {};
            for(var _key in props){
                if (shouldUseAs && _key === 'as') continue;
                if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
            }
            newProps.className = className;
            if (ref) newProps.ref = ref;
            return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($60e97af874e8cdaa$var$Insertion, {
                cache: cache,
                serialized: serialized,
                isStringTag: typeof FinalTag === 'string'
            }), /*#__PURE__*/ $acw62.createElement(FinalTag, newProps));
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                if (targetClassName === undefined && $60e97af874e8cdaa$var$isDevelopment) return 'NO_COMPONENT_SELECTOR';
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            var newStyled = createStyled(nextTag, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, options, nextOptions, {
                shouldForwardProp: $60e97af874e8cdaa$var$composeShouldForwardProps(Styled, nextOptions, true)
            }));
            return newStyled.apply(void 0, styles);
        };
        return Styled;
    };
};







parcelRequire("acw62");

var $12ab803fa905d303$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// bind it to avoid mutating the original function
var $12ab803fa905d303$export$2e2bcd8739ae039 = (0, $60e97af874e8cdaa$export$2e2bcd8739ae039).bind(null);
$12ab803fa905d303$var$tags.forEach(function(tagName) {
    $12ab803fa905d303$export$2e2bcd8739ae039[tagName] = $12ab803fa905d303$export$2e2bcd8739ae039(tagName);
});






'use client';
function $678bd0f6619332de$export$2e2bcd8739ae039(tag, options) {
    const stylesFactory = (0, $12ab803fa905d303$export$2e2bcd8739ae039)(tag, options);
    var styles, style;
    return stylesFactory;
}
function $678bd0f6619332de$export$592c7226e4cb0171(tag, processor) {
    // Emotion attaches all the styles as `__emotion_styles`.
    // Ref: https://github.com/emotion-js/emotion/blob/16d971d0da229596d6bcc39d282ba9753c9ee7cf/packages/styled/src/base.js#L186
    if (Array.isArray(tag.__emotion_styles)) tag.__emotion_styles = processor(tag.__emotion_styles);
}
// Emotion only accepts an array, but we want to avoid allocations
const $678bd0f6619332de$var$wrapper = [];
function $678bd0f6619332de$export$13a2d3ef13012b32(styles) {
    $678bd0f6619332de$var$wrapper[0] = styles;
    return (0, $62578605b07c8dad$export$6321afa313b251b5)($678bd0f6619332de$var$wrapper);
}




'use client';
function $6942d6ec85232a9d$var$wrapGlobalLayer(styles) {
    const serialized = (0, $678bd0f6619332de$export$13a2d3ef13012b32)(styles);
    if (styles !== serialized && serialized.styles) {
        if (!serialized.styles.match(/^@layer\s+[^{]*$/)) // If the styles are not already wrapped in a layer, wrap them in a global layer.
        serialized.styles = `@layer global{${serialized.styles}}`;
        return serialized;
    }
    return styles;
}
function $6942d6ec85232a9d$var$GlobalStyles({ styles: styles, themeId: themeId, defaultTheme: defaultTheme = {} }) {
    const upperTheme = (0, $ac16d208682bdb3f$export$2e2bcd8739ae039)(defaultTheme);
    const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
    let globalStyles = typeof styles === 'function' ? styles(resolvedTheme) : styles;
    if (resolvedTheme.modularCssLayers) {
        if (Array.isArray(globalStyles)) globalStyles = globalStyles.map((styleArg)=>{
            if (typeof styleArg === 'function') return $6942d6ec85232a9d$var$wrapGlobalLayer(styleArg(resolvedTheme));
            return $6942d6ec85232a9d$var$wrapGlobalLayer(styleArg);
        });
        else globalStyles = $6942d6ec85232a9d$var$wrapGlobalLayer(globalStyles);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afce2778e79e00d1$export$2e2bcd8739ae039), {
        styles: globalStyles
    });
}
var $6942d6ec85232a9d$export$2e2bcd8739ae039 = $6942d6ec85232a9d$var$GlobalStyles;





'use client';
function $7daa246831c829f7$var$GlobalStyles(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6942d6ec85232a9d$export$2e2bcd8739ae039), {
        ...props,
        defaultTheme: (0, $a477e5500cafdc51$export$2e2bcd8739ae039),
        themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039)
    });
}
var $7daa246831c829f7$export$2e2bcd8739ae039 = $7daa246831c829f7$var$GlobalStyles;








function $ae078d4716220a63$var$getFunctionComponentName(Component, fallback = '') {
    return Component.displayName || Component.name || fallback;
}
function $ae078d4716220a63$var$getWrappedName(outerType, innerType, wrapperName) {
    const functionName = $ae078d4716220a63$var$getFunctionComponentName(innerType);
    return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
function $ae078d4716220a63$export$2e2bcd8739ae039(Component) {
    if (Component == null) return undefined;
    if (typeof Component === 'string') return Component;
    if (typeof Component === 'function') return $ae078d4716220a63$var$getFunctionComponentName(Component, 'Component');
    // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`
    if (typeof Component === 'object') switch(Component.$$typeof){
        case 0, $0d72ae83f7641f56$exports.ForwardRef:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.render, 'ForwardRef');
        case 0, $0d72ae83f7641f56$exports.Memo:
            return $ae078d4716220a63$var$getWrappedName(Component, Component.type, 'memo');
        default:
            return undefined;
    }
    return undefined;
}





function $7c4e0616915ca3a0$export$2e2bcd8739ae039(input) {
    const { variants: variants, ...style } = input;
    const result = {
        variants: variants,
        style: (0, $678bd0f6619332de$export$13a2d3ef13012b32)(style),
        isProcessed: true
    };
    // Not supported on styled-components
    if (result.style === style) return result;
    if (variants) variants.forEach((variant)=>{
        if (typeof variant.style !== 'function') variant.style = (0, $678bd0f6619332de$export$13a2d3ef13012b32)(variant.style);
    });
    return result;
}


const $9a7e913a82f46e5c$export$35e57303dbd8a66 = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
function $9a7e913a82f46e5c$export$3ba67b570e26eea0(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
function $9a7e913a82f46e5c$var$shallowLayer(serialized, layerName) {
    if (layerName && serialized && typeof serialized === 'object' && serialized.styles && !serialized.styles.startsWith('@layer') // only add the layer if it is not already there.
    ) serialized.styles = `@layer ${layerName}{${String(serialized.styles)}}`;
    return serialized;
}
function $9a7e913a82f46e5c$var$defaultOverridesResolver(slot) {
    if (!slot) return null;
    return (_props, styles)=>styles[slot];
}
function $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme) {
    props.theme = $9a7e913a82f46e5c$var$isObjectEmpty(props.theme) ? defaultTheme : props.theme[themeId] || props.theme;
}
function $9a7e913a82f46e5c$var$processStyle(props, style, layerName) {
    /*
   * Style types:
   *  - null/undefined
   *  - string
   *  - CSS style object: { [cssKey]: [cssValue], variants }
   *  - Processed style object: { style, variants, isProcessed: true }
   *  - Array of any of the above
   */ const resolvedStyle = typeof style === 'function' ? style(props) : style;
    if (Array.isArray(resolvedStyle)) return resolvedStyle.flatMap((subStyle)=>$9a7e913a82f46e5c$var$processStyle(props, subStyle, layerName));
    if (Array.isArray(resolvedStyle?.variants)) {
        let rootStyle;
        if (resolvedStyle.isProcessed) rootStyle = layerName ? $9a7e913a82f46e5c$var$shallowLayer(resolvedStyle.style, layerName) : resolvedStyle.style;
        else {
            const { variants: variants, ...otherStyles } = resolvedStyle;
            rootStyle = layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $678bd0f6619332de$export$13a2d3ef13012b32)(otherStyles), layerName) : otherStyles;
        }
        return $9a7e913a82f46e5c$var$processStyleVariants(props, resolvedStyle.variants, [
            rootStyle
        ], layerName);
    }
    if (resolvedStyle?.isProcessed) return layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $678bd0f6619332de$export$13a2d3ef13012b32)(resolvedStyle.style), layerName) : resolvedStyle.style;
    return layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $678bd0f6619332de$export$13a2d3ef13012b32)(resolvedStyle), layerName) : resolvedStyle;
}
function $9a7e913a82f46e5c$var$processStyleVariants(props, variants, results = [], layerName) {
    let mergedState; // We might not need it, initialized lazily
    variantLoop: for(let i = 0; i < variants.length; i += 1){
        const variant = variants[i];
        if (typeof variant.props === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            if (!variant.props(mergedState)) continue;
        } else for(const key in variant.props){
            if (props[key] !== variant.props[key] && props.ownerState?.[key] !== variant.props[key]) continue variantLoop;
        }
        if (typeof variant.style === 'function') {
            mergedState ??= {
                ...props,
                ...props.ownerState,
                ownerState: props.ownerState
            };
            results.push(layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $678bd0f6619332de$export$13a2d3ef13012b32)(variant.style(mergedState)), layerName) : variant.style(mergedState));
        } else results.push(layerName ? $9a7e913a82f46e5c$var$shallowLayer((0, $678bd0f6619332de$export$13a2d3ef13012b32)(variant.style), layerName) : variant.style);
    }
    return results;
}
function $9a7e913a82f46e5c$export$2e2bcd8739ae039(input = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme = $9a7e913a82f46e5c$export$35e57303dbd8a66, rootShouldForwardProp: rootShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0, slotShouldForwardProp: slotShouldForwardProp = $9a7e913a82f46e5c$export$3ba67b570e26eea0 } = input;
    function styleAttachTheme(props) {
        $9a7e913a82f46e5c$var$attachTheme(props, themeId, defaultTheme);
    }
    const styled = (tag, inputOptions = {})=>{
        // If `tag` is already a styled component, filter out the `sx` style function
        // to prevent unnecessary styles generated by the composite components.
        (0, $678bd0f6619332de$export$592c7226e4cb0171)(tag, (styles)=>styles.filter((style)=>style !== (0, $6b750d631801d296$export$2e2bcd8739ae039)));
        const { name: componentName, slot: componentSlot, skipVariantsResolver: inputSkipVariantsResolver, skipSx: inputSkipSx, overridesResolver: // TODO v6: remove `lowercaseFirstLetter()` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        overridesResolver = $9a7e913a82f46e5c$var$defaultOverridesResolver($9a7e913a82f46e5c$var$lowercaseFirstLetter(componentSlot)), ...options } = inputOptions;
        const layerName = componentName && componentName.startsWith('Mui') || !!componentSlot ? 'components' : 'custom';
        // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.
        const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        componentSlot && componentSlot !== 'Root' && componentSlot !== 'root' || false;
        const skipSx = inputSkipSx || false;
        let shouldForwardPropOption = $9a7e913a82f46e5c$export$3ba67b570e26eea0;
        // TODO v6: remove `Root` in the next major release
        // For more details: https://github.com/mui/material-ui/pull/37908
        if (componentSlot === 'Root' || componentSlot === 'root') shouldForwardPropOption = rootShouldForwardProp;
        else if (componentSlot) // any other slot specified
        shouldForwardPropOption = slotShouldForwardProp;
        else if ($9a7e913a82f46e5c$var$isStringTag(tag)) // for string (html) tag, preserve the behavior in emotion & styled-components.
        shouldForwardPropOption = undefined;
        const defaultStyledResolver = (0, $678bd0f6619332de$export$2e2bcd8739ae039)(tag, {
            shouldForwardProp: shouldForwardPropOption,
            label: $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot),
            ...options
        });
        const transformStyle = (style)=>{
            // - On the server Emotion doesn't use React.forwardRef for creating components, so the created
            //   component stays as a function. This condition makes sure that we do not interpolate functions
            //   which are basically components used as a selectors.
            // - `style` could be a styled component from a babel plugin for component selectors, This condition
            //   makes sure that we do not interpolate them.
            if (style.__emotion_real === style) return style;
            if (typeof style === 'function') return function styleFunctionProcessor(props) {
                return $9a7e913a82f46e5c$var$processStyle(props, style, props.theme.modularCssLayers ? layerName : undefined);
            };
            if ((0, $2985df77ba145d35$export$53b83ca8eaab0383)(style)) {
                const serialized = (0, $7c4e0616915ca3a0$export$2e2bcd8739ae039)(style);
                return function styleObjectProcessor(props) {
                    if (!serialized.variants) return props.theme.modularCssLayers ? $9a7e913a82f46e5c$var$shallowLayer(serialized.style, layerName) : serialized.style;
                    return $9a7e913a82f46e5c$var$processStyle(props, serialized, props.theme.modularCssLayers ? layerName : undefined);
                };
            }
            return style;
        };
        const muiStyledResolver = (...expressionsInput)=>{
            const expressionsHead = [];
            const expressionsBody = expressionsInput.map(transformStyle);
            const expressionsTail = [];
            // Preprocess `props` to set the scoped theme value.
            // This must run before any other expression.
            expressionsHead.push(styleAttachTheme);
            if (componentName && overridesResolver) expressionsTail.push(function styleThemeOverrides(props) {
                const theme = props.theme;
                const styleOverrides = theme.components?.[componentName]?.styleOverrides;
                if (!styleOverrides) return null;
                const resolvedStyleOverrides = {};
                // TODO: v7 remove iteration and use `resolveStyleArg(styleOverrides[slot])` directly
                // eslint-disable-next-line guard-for-in
                for(const slotKey in styleOverrides)resolvedStyleOverrides[slotKey] = $9a7e913a82f46e5c$var$processStyle(props, styleOverrides[slotKey], props.theme.modularCssLayers ? 'theme' : undefined);
                return overridesResolver(props, resolvedStyleOverrides);
            });
            if (componentName && !skipVariantsResolver) expressionsTail.push(function styleThemeVariants(props) {
                const theme = props.theme;
                const themeVariants = theme?.components?.[componentName]?.variants;
                if (!themeVariants) return null;
                return $9a7e913a82f46e5c$var$processStyleVariants(props, themeVariants, [], props.theme.modularCssLayers ? 'theme' : undefined);
            });
            if (!skipSx) expressionsTail.push((0, $6b750d631801d296$export$2e2bcd8739ae039));
            // This function can be called as a tagged template, so the first argument would contain
            // CSS `string[]` values.
            if (Array.isArray(expressionsBody[0])) {
                const inputStrings = expressionsBody.shift();
                // We need to add placeholders in the tagged template for the custom functions we have
                // possibly added (attachTheme, overrides, variants, and sx).
                const placeholdersHead = new Array(expressionsHead.length).fill('');
                const placeholdersTail = new Array(expressionsTail.length).fill('');
                let outputStrings;
                outputStrings = [
                    ...placeholdersHead,
                    ...inputStrings,
                    ...placeholdersTail
                ];
                outputStrings.raw = [
                    ...placeholdersHead,
                    ...inputStrings.raw,
                    ...placeholdersTail
                ];
                // The only case where we put something before `attachTheme`
                expressionsHead.unshift(outputStrings);
            }
            const expressions = [
                ...expressionsHead,
                ...expressionsBody,
                ...expressionsTail
            ];
            const Component = defaultStyledResolver(...expressions);
            if (tag.muiName) Component.muiName = tag.muiName;
            return Component;
        };
        if (defaultStyledResolver.withConfig) muiStyledResolver.withConfig = defaultStyledResolver.withConfig;
        return muiStyledResolver;
    };
    return styled;
}
function $9a7e913a82f46e5c$var$generateDisplayName(componentName, componentSlot, tag) {
    if (componentName) return `${componentName}${(0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(componentSlot || '')}`;
    return `Styled(${(0, $ae078d4716220a63$export$2e2bcd8739ae039)(tag)})`;
}
function $9a7e913a82f46e5c$var$generateStyledLabel(componentName, componentSlot) {
    let label;
    return label;
}
function $9a7e913a82f46e5c$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
// https://github.com/emotion-js/emotion/blob/26ded6109fcd8ca9875cc2ce4564fee678a3f3c5/packages/styled/src/utils.js#L40
function $9a7e913a82f46e5c$var$isStringTag(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96;
}
function $9a7e913a82f46e5c$var$lowercaseFirstLetter(string) {
    if (!string) return string;
    return string.charAt(0).toLowerCase() + string.slice(1);
}




// copied from @mui/system/createStyled
function $7109435727661db9$var$slotShouldForwardProp(prop) {
    return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
var $7109435727661db9$export$2e2bcd8739ae039 = $7109435727661db9$var$slotShouldForwardProp;


const $7f9f996b464e1691$var$rootShouldForwardProp = (prop)=>(0, $7109435727661db9$export$2e2bcd8739ae039)(prop) && prop !== 'classes';
var $7f9f996b464e1691$export$2e2bcd8739ae039 = $7f9f996b464e1691$var$rootShouldForwardProp;



'use client';
const $13f99d5fb06222df$var$styled = (0, $9a7e913a82f46e5c$export$2e2bcd8739ae039)({
    themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039),
    defaultTheme: $a477e5500cafdc51$export$2e2bcd8739ae039,
    rootShouldForwardProp: $7f9f996b464e1691$export$2e2bcd8739ae039
});
var $13f99d5fb06222df$export$2e2bcd8739ae039 = $13f99d5fb06222df$var$styled;


function $76e91e24afb64923$export$db53682eef82cc11(styles) {
    return function GlobalStylesWrapper(props) {
        return(/*#__PURE__*/ // Pigment CSS `globalCss` support callback with theme inside an object but `GlobalStyles` support theme as a callback value.
        (0, $7b02d682eb115277$exports.jsx)((0, $7daa246831c829f7$export$2e2bcd8739ae039), {
            styles: typeof styles === 'function' ? (theme)=>styles({
                    theme: theme,
                    ...props
                }) : styles
        }));
    };
}
function $76e91e24afb64923$export$7e7f5719ff4debb1() {
    return 0, $c85eb76b78f8a14c$export$2e2bcd8739ae039;
}


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $f2ccb2ae3c8742b7$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $f2ccb2ae3c8742b7$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $f2ccb2ae3c8742b7$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $f2ccb2ae3c8742b7$export$2e2bcd8739ae039 = $f2ccb2ae3c8742b7$export$4f5d2d50c9deca37;


function $367acbd429e20ec9$export$2e2bcd8739ae039(defaultProps, props, mergeClassNameAndStyle = false) {
    const output = {
        ...props
    };
    for(const key in defaultProps)if (Object.prototype.hasOwnProperty.call(defaultProps, key)) {
        const propName = key;
        if (propName === 'components' || propName === 'slots') output[propName] = {
            ...defaultProps[propName],
            ...output[propName]
        };
        else if (propName === 'componentsProps' || propName === 'slotProps') {
            const defaultSlotProps = defaultProps[propName];
            const slotProps = props[propName];
            if (!slotProps) output[propName] = defaultSlotProps || {};
            else if (!defaultSlotProps) output[propName] = slotProps;
            else {
                output[propName] = {
                    ...slotProps
                };
                for(const slotKey in defaultSlotProps)if (Object.prototype.hasOwnProperty.call(defaultSlotProps, slotKey)) {
                    const slotPropName = slotKey;
                    output[propName][slotPropName] = $367acbd429e20ec9$export$2e2bcd8739ae039(defaultSlotProps[slotPropName], slotProps[slotPropName], mergeClassNameAndStyle);
                }
            }
        } else if (propName === 'className' && mergeClassNameAndStyle && props.className) output.className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(defaultProps?.className, props?.className);
        else if (propName === 'style' && mergeClassNameAndStyle && props.style) output.style = {
            ...defaultProps?.style,
            ...props?.style
        };
        else if (output[propName] === undefined) output[propName] = defaultProps[propName];
    }
    return output;
}



'use client';
const $7d98f590ab80e73c$var$PropsContext = /*#__PURE__*/ $acw62.createContext(undefined);
function $7d98f590ab80e73c$var$DefaultPropsProvider({ value: value, children: children }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7d98f590ab80e73c$var$PropsContext.Provider, {
        value: value,
        children: children
    });
}
function $7d98f590ab80e73c$var$getThemeProps(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name]) return props;
    const config = theme.components[name];
    if (config.defaultProps) // compatible with v5 signature
    return (0, $367acbd429e20ec9$export$2e2bcd8739ae039)(config.defaultProps, props, theme.components.mergeClassNameAndStyle);
    if (!config.styleOverrides && !config.variants) // v6 signature, no property 'defaultProps'
    return (0, $367acbd429e20ec9$export$2e2bcd8739ae039)(config, props, theme.components.mergeClassNameAndStyle);
    return props;
}
function $7d98f590ab80e73c$export$2440da353cedad43({ props: props, name: name }) {
    const ctx = $acw62.useContext($7d98f590ab80e73c$var$PropsContext);
    return $7d98f590ab80e73c$var$getThemeProps({
        props: props,
        name: name,
        theme: {
            components: ctx
        }
    });
}
var $7d98f590ab80e73c$export$2e2bcd8739ae039 = $7d98f590ab80e73c$var$DefaultPropsProvider;



'use client';
function $1bc4906ad0338fb8$var$DefaultPropsProvider(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d98f590ab80e73c$export$2e2bcd8739ae039), {
        ...props
    });
}
var $1bc4906ad0338fb8$export$2e2bcd8739ae039 = $1bc4906ad0338fb8$var$DefaultPropsProvider;
function $1bc4906ad0338fb8$export$2440da353cedad43(params) {
    return (0, $7d98f590ab80e73c$export$2440da353cedad43)(params);
}



'use client';
const $888b8a9d3c5d3650$var$isDynamicSupport = typeof (0, $76e91e24afb64923$export$db53682eef82cc11)({}) === 'function';
const $888b8a9d3c5d3650$export$c0bb0b647f701bb5 = (theme, enableColorScheme)=>({
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box',
        // Fix font resize problem in iOS
        WebkitTextSizeAdjust: '100%',
        // When used under CssVarsProvider, colorScheme should not be applied dynamically because it will generate the stylesheet twice for server-rendered applications.
        ...enableColorScheme && !theme.vars && {
            colorScheme: theme.palette.mode
        }
    });
const $888b8a9d3c5d3650$export$32180ef41b15b513 = (theme)=>({
        color: (theme.vars || theme).palette.text.primary,
        ...theme.typography.body1,
        backgroundColor: (theme.vars || theme).palette.background.default,
        '@media print': {
            // Save printer ink.
            backgroundColor: (theme.vars || theme).palette.common.white
        }
    });
const $888b8a9d3c5d3650$export$9dd6ff9ea0189349 = (theme, enableColorScheme = false)=>{
    const colorSchemeStyles = {};
    if (enableColorScheme && theme.colorSchemes && typeof theme.getColorSchemeSelector === 'function') Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        colorSchemeStyles[selector] = {
            ':root': {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        colorSchemeStyles[selector.replace(/\s*&/, '')] = {
            colorScheme: scheme.palette?.mode
        };
    });
    let defaultStyles = {
        html: $888b8a9d3c5d3650$export$c0bb0b647f701bb5(theme, enableColorScheme),
        '*, *::before, *::after': {
            boxSizing: 'inherit'
        },
        'strong, b': {
            fontWeight: theme.typography.fontWeightBold
        },
        body: {
            margin: 0,
            // Remove the margin in all browsers.
            ...$888b8a9d3c5d3650$export$32180ef41b15b513(theme),
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            '&::backdrop': {
                backgroundColor: (theme.vars || theme).palette.background.default
            }
        },
        ...colorSchemeStyles
    };
    const themeOverrides = theme.components?.MuiCssBaseline?.styleOverrides;
    if (themeOverrides) defaultStyles = [
        defaultStyles,
        themeOverrides
    ];
    return defaultStyles;
};
// `ecs` stands for enableColorScheme. This is internal logic to make it work with Pigment CSS, so shorter is better.
const $888b8a9d3c5d3650$var$SELECTOR = 'mui-ecs';
const $888b8a9d3c5d3650$var$staticStyles = (theme)=>{
    const result = $888b8a9d3c5d3650$export$9dd6ff9ea0189349(theme, false);
    const baseStyles = Array.isArray(result) ? result[0] : result;
    if (!theme.vars && baseStyles) baseStyles.html[`:root:has(${$888b8a9d3c5d3650$var$SELECTOR})`] = {
        colorScheme: theme.palette.mode
    };
    if (theme.colorSchemes) Object.entries(theme.colorSchemes).forEach(([key, scheme])=>{
        const selector = theme.getColorSchemeSelector(key);
        if (selector.startsWith('@')) // for @media (prefers-color-scheme), we need to target :root
        baseStyles[selector] = {
            [`:root:not(:has(.${$888b8a9d3c5d3650$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
        else // else, it's likely that the selector already target an element with a class or data attribute
        baseStyles[selector.replace(/\s*&/, '')] = {
            [`&:not(:has(.${$888b8a9d3c5d3650$var$SELECTOR}))`]: {
                colorScheme: scheme.palette?.mode
            }
        };
    });
    return result;
};
const $888b8a9d3c5d3650$var$GlobalStyles = (0, $76e91e24afb64923$export$db53682eef82cc11)($888b8a9d3c5d3650$var$isDynamicSupport ? ({ theme: theme, enableColorScheme: enableColorScheme })=>$888b8a9d3c5d3650$export$9dd6ff9ea0189349(theme, enableColorScheme) : ({ theme: theme })=>$888b8a9d3c5d3650$var$staticStyles(theme));
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */ function $888b8a9d3c5d3650$var$CssBaseline(inProps) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCssBaseline'
    });
    const { children: children, enableColorScheme: enableColorScheme = false } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            $888b8a9d3c5d3650$var$isDynamicSupport && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($888b8a9d3c5d3650$var$GlobalStyles, {
                enableColorScheme: enableColorScheme
            }),
            !$888b8a9d3c5d3650$var$isDynamicSupport && !enableColorScheme && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: $888b8a9d3c5d3650$var$SELECTOR,
                style: {
                    display: 'none'
                }
            }),
            children
        ]
    });
}
var $888b8a9d3c5d3650$export$2e2bcd8739ae039 = $888b8a9d3c5d3650$var$CssBaseline;



var $acw62 = parcelRequire("acw62");
parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
'use client';
const $fd1f5abca3e37f57$var$ThemeContext = /*#__PURE__*/ $acw62.createContext(null);
var $fd1f5abca3e37f57$export$2e2bcd8739ae039 = $fd1f5abca3e37f57$var$ThemeContext;



var $acw62 = parcelRequire("acw62");

function $022fb1085af75a08$export$2e2bcd8739ae039() {
    const theme = $acw62.useContext((0, $fd1f5abca3e37f57$export$2e2bcd8739ae039));
    return theme;
}


const $c91932685c2e3b45$var$hasSymbol = typeof Symbol === 'function' && Symbol.for;
var $c91932685c2e3b45$export$2e2bcd8739ae039 = $c91932685c2e3b45$var$hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';



function $9a2b73dc6dc04e22$var$mergeOuterLocalTheme(outerTheme, localTheme) {
    if (typeof localTheme === 'function') {
        const mergedTheme = localTheme(outerTheme);
        return mergedTheme;
    }
    return {
        ...outerTheme,
        ...localTheme
    };
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */ function $9a2b73dc6dc04e22$var$ThemeProvider(props) {
    const { children: children, theme: localTheme } = props;
    const outerTheme = (0, $022fb1085af75a08$export$2e2bcd8739ae039)();
    const theme = $acw62.useMemo(()=>{
        const output = outerTheme === null ? {
            ...localTheme
        } : $9a2b73dc6dc04e22$var$mergeOuterLocalTheme(outerTheme, localTheme);
        if (output != null) output[0, $c91932685c2e3b45$export$2e2bcd8739ae039] = outerTheme !== null;
        return output;
    }, [
        localTheme,
        outerTheme
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd1f5abca3e37f57$export$2e2bcd8739ae039).Provider, {
        value: theme,
        children: children
    });
}
var $9a2b73dc6dc04e22$export$2e2bcd8739ae039 = $9a2b73dc6dc04e22$var$ThemeProvider;






var $acw62 = parcelRequire("acw62");


'use client';
const $3bcebab40d8ce666$var$RtlContext = /*#__PURE__*/ $acw62.createContext();
function $3bcebab40d8ce666$var$RtlProvider({ value: value, ...props }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3bcebab40d8ce666$var$RtlContext.Provider, {
        value: value ?? true,
        ...props
    });
}
const $3bcebab40d8ce666$export$b2dd014b6c321cb = ()=>{
    const value = $acw62.useContext($3bcebab40d8ce666$var$RtlContext);
    return value ?? false;
};
var $3bcebab40d8ce666$export$2e2bcd8739ae039 = $3bcebab40d8ce666$var$RtlProvider;



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * A version of `React.useLayoutEffect` that does not show a warning when server-side rendering.
 * This is useful for effects that are only needed for client-side rendering but not for SSR.
 *
 * Before you use this hook, make sure to read https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85
 * and confirm it doesn't apply to your use-case.
 */ const $aab859a020ad749e$var$useEnhancedEffect = typeof window !== 'undefined' ? $acw62.useLayoutEffect : $acw62.useEffect;
var $aab859a020ad749e$export$2e2bcd8739ae039 = $aab859a020ad749e$var$useEnhancedEffect;



var $acw62 = parcelRequire("acw62");
'use client';
let $7a3a319e7e555608$var$globalId = 0;
// TODO React 17: Remove `useGlobalId` once React 17 support is removed
function $7a3a319e7e555608$var$useGlobalId(idOverride) {
    const [defaultId, setDefaultId] = $acw62.useState(idOverride);
    const id = idOverride || defaultId;
    $acw62.useEffect(()=>{
        if (defaultId == null) {
            // Fallback to this default id when possible.
            // Use the incrementing value for client-side rendering only.
            // We can't use it server-side.
            // If you want to use random values please consider the Birthday Problem: https://en.wikipedia.org/wiki/Birthday_problem
            $7a3a319e7e555608$var$globalId += 1;
            setDefaultId(`mui-${$7a3a319e7e555608$var$globalId}`);
        }
    }, [
        defaultId
    ]);
    return id;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $7a3a319e7e555608$var$safeReact = {
    ...$acw62
};
const $7a3a319e7e555608$var$maybeReactUseId = $7a3a319e7e555608$var$safeReact.useId;
function $7a3a319e7e555608$export$2e2bcd8739ae039(idOverride) {
    // React.useId() is only available from React 17.0.0.
    if ($7a3a319e7e555608$var$maybeReactUseId !== undefined) {
        const reactId = $7a3a319e7e555608$var$maybeReactUseId();
        return idOverride ?? reactId;
    }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/rules-of-hooks -- `React.useId` is invariant at runtime.
    return $7a3a319e7e555608$var$useGlobalId(idOverride);
}





function $34de227aaca64f99$export$2e2bcd8739ae039(theme) {
    const upperTheme = (0, $bba4444e1ea571ca$export$2e2bcd8739ae039)();
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)() || '';
    const { modularCssLayers: modularCssLayers } = theme;
    let layerOrder = 'mui.global, mui.components, mui.theme, mui.custom, mui.sx';
    if (!modularCssLayers || upperTheme !== null) // skip this hook if upper theme exists.
    layerOrder = '';
    else if (typeof modularCssLayers === 'string') layerOrder = modularCssLayers.replace(/mui(?!\.)/g, layerOrder);
    else layerOrder = `@layer ${layerOrder};`;
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const head = document.querySelector('head');
        if (!head) return;
        const firstChild = head.firstChild;
        if (layerOrder) {
            // Only insert if first child doesn't have data-mui-layer-order attribute
            if (firstChild && firstChild.hasAttribute?.('data-mui-layer-order') && firstChild.getAttribute('data-mui-layer-order') === id) return;
            const styleElement = document.createElement('style');
            styleElement.setAttribute('data-mui-layer-order', id);
            styleElement.textContent = layerOrder;
            head.prepend(styleElement);
        } else head.querySelector(`style[data-mui-layer-order="${id}"]`)?.remove();
    }, [
        layerOrder,
        id
    ]);
    if (!layerOrder) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6942d6ec85232a9d$export$2e2bcd8739ae039), {
        styles: layerOrder
    });
}



'use client';
const $50ef44b883b4d7f9$var$EMPTY_THEME = {};
function $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme, isPrivate = false) {
    return $acw62.useMemo(()=>{
        const resolvedTheme = themeId ? upperTheme[themeId] || upperTheme : upperTheme;
        if (typeof localTheme === 'function') {
            const mergedTheme = localTheme(resolvedTheme);
            const result = themeId ? {
                ...upperTheme,
                [themeId]: mergedTheme
            } : mergedTheme;
            // must return a function for the private theme to NOT merge with the upper theme.
            // see the test case "use provided theme from a callback" in ThemeProvider.test.js
            if (isPrivate) return ()=>result;
            return result;
        }
        return themeId ? {
            ...upperTheme,
            [themeId]: localTheme
        } : {
            ...upperTheme,
            ...localTheme
        };
    }, [
        themeId,
        upperTheme,
        localTheme,
        isPrivate
    ]);
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 *
 * <ThemeProvider theme={theme}> // existing use case
 * <ThemeProvider theme={{ id: theme }}> // theme scoping
 */ function $50ef44b883b4d7f9$var$ThemeProvider(props) {
    const { children: children, theme: localTheme, themeId: themeId } = props;
    const upperTheme = (0, $bba4444e1ea571ca$export$2e2bcd8739ae039)($50ef44b883b4d7f9$var$EMPTY_THEME);
    const upperPrivateTheme = (0, $022fb1085af75a08$export$2e2bcd8739ae039)() || $50ef44b883b4d7f9$var$EMPTY_THEME;
    const engineTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperTheme, localTheme);
    const privateTheme = $50ef44b883b4d7f9$var$useThemeScoping(themeId, upperPrivateTheme, localTheme, true);
    const rtlValue = (themeId ? engineTheme[themeId] : engineTheme).direction === 'rtl';
    const layerOrder = (0, $34de227aaca64f99$export$2e2bcd8739ae039)(engineTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a2b73dc6dc04e22$export$2e2bcd8739ae039), {
        theme: privateTheme,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4eee05ec22b53782$export$971d5caa766a69d7).Provider, {
            value: engineTheme,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3bcebab40d8ce666$export$2e2bcd8739ae039), {
                value: rtlValue,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7d98f590ab80e73c$export$2e2bcd8739ae039), {
                    value: themeId ? engineTheme[themeId].components : engineTheme.components,
                    children: [
                        layerOrder,
                        children
                    ]
                })
            })
        })
    });
}
var $50ef44b883b4d7f9$export$2e2bcd8739ae039 = $50ef44b883b4d7f9$var$ThemeProvider;




'use client';
function $05516f934f879d28$export$2e2bcd8739ae039({ theme: themeInput, ...props }) {
    const scopedTheme = (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039) in themeInput ? themeInput[0, $8b4c3f6e5c407120$export$2e2bcd8739ae039] : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50ef44b883b4d7f9$export$2e2bcd8739ae039), {
        ...props,
        themeId: scopedTheme ? (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039) : undefined,
        theme: scopedTheme || themeInput
    });
}


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





/**
 * Split this component for RSC import
 */ parcelRequire("acw62");

const $1507b440b55b1cf7$export$ff0fa3047d11164c = 'mode';
const $1507b440b55b1cf7$export$665054ea9d94dab9 = 'color-scheme';
const $1507b440b55b1cf7$export$14ebe5b26ee7fb38 = 'data-color-scheme';
function $1507b440b55b1cf7$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = 'light', defaultDarkColorScheme: defaultDarkColorScheme = 'dark', modeStorageKey: modeStorageKey = $1507b440b55b1cf7$export$ff0fa3047d11164c, colorSchemeStorageKey: colorSchemeStorageKey = $1507b440b55b1cf7$export$665054ea9d94dab9, attribute: initialAttribute = $1507b440b55b1cf7$export$14ebe5b26ee7fb38, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = options || {};
    let setter = '';
    let attribute = initialAttribute;
    if (initialAttribute === 'class') attribute = '.%s';
    if (initialAttribute === 'data') attribute = '[data-%s]';
    if (attribute.startsWith('.')) {
        const selector = attribute.substring(1);
        setter += `${colorSchemeNode}.classList.remove('${selector}'.replace('%s', light), '${selector}'.replace('%s', dark));
      ${colorSchemeNode}.classList.add('${selector}'.replace('%s', colorScheme));`;
    }
    const matches = attribute.match(/\[([^[\]]+)\]/); // case [data-color-scheme='%s'] or [data-color-scheme]
    if (matches) {
        const [attr, value] = matches[1].split('=');
        if (!value) setter += `${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', light));
      ${colorSchemeNode}.removeAttribute('${attr}'.replace('%s', dark));`;
        setter += `
      ${colorSchemeNode}.setAttribute('${attr}'.replace('%s', colorScheme), ${value ? `${value}.replace('%s', colorScheme)` : '""'});`;
    } else setter += `${colorSchemeNode}.setAttribute('${attribute}', colorScheme);`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("script", {
        suppressHydrationWarning: true,
        nonce: typeof window === 'undefined' ? nonce : '',
        dangerouslySetInnerHTML: {
            __html: `(function() {
try {
  let colorScheme = '';
  const mode = localStorage.getItem('${modeStorageKey}') || '${defaultMode}';
  const dark = localStorage.getItem('${colorSchemeStorageKey}-dark') || '${defaultDarkColorScheme}';
  const light = localStorage.getItem('${colorSchemeStorageKey}-light') || '${defaultLightColorScheme}';
  if (mode === 'system') {
    // handle system mode
    const mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = dark
    } else {
      colorScheme = light
    }
  }
  if (mode === 'light') {
    colorScheme = light;
  }
  if (mode === 'dark') {
    colorScheme = dark;
  }
  if (colorScheme) {
    ${setter}
  }
} catch(e){}})();`
        }
    }, "mui-color-scheme-init");
}



var $acw62 = parcelRequire("acw62");

function $3b1fb882896a7778$var$noop() {}
const $3b1fb882896a7778$var$localStorageManager = ({ key: key, storageWindow: storageWindow })=>{
    if (!storageWindow && typeof window !== 'undefined') storageWindow = window;
    return {
        get (defaultValue) {
            if (typeof window === 'undefined') return undefined;
            if (!storageWindow) return defaultValue;
            let value;
            try {
                value = storageWindow.localStorage.getItem(key);
            } catch  {
            // Unsupported
            }
            return value || defaultValue;
        },
        set: (value)=>{
            if (storageWindow) try {
                storageWindow.localStorage.setItem(key, value);
            } catch  {
            // Unsupported
            }
        },
        subscribe: (handler)=>{
            if (!storageWindow) return $3b1fb882896a7778$var$noop;
            const listener = (event)=>{
                const value = event.newValue;
                if (event.key === key) handler(value);
            };
            storageWindow.addEventListener('storage', listener);
            return ()=>{
                storageWindow.removeEventListener('storage', listener);
            };
        }
    };
};
var $3b1fb882896a7778$export$2e2bcd8739ae039 = $3b1fb882896a7778$var$localStorageManager;


'use client';
function $d8b25f9d3c9e642d$var$noop() {}
function $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(mode) {
    if (typeof window !== 'undefined' && typeof window.matchMedia === 'function' && mode === 'system') {
        const mql = window.matchMedia('(prefers-color-scheme: dark)');
        if (mql.matches) return 'dark';
        return 'light';
    }
    return undefined;
}
function $d8b25f9d3c9e642d$var$processState(state, callback) {
    if (state.mode === 'light' || state.mode === 'system' && state.systemMode === 'light') return callback('light');
    if (state.mode === 'dark' || state.mode === 'system' && state.systemMode === 'dark') return callback('dark');
    return undefined;
}
function $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state) {
    return $d8b25f9d3c9e642d$var$processState(state, (mode)=>{
        if (mode === 'light') return state.lightColorScheme;
        if (mode === 'dark') return state.darkColorScheme;
        return undefined;
    });
}
function $d8b25f9d3c9e642d$export$2e2bcd8739ae039(options) {
    const { defaultMode: defaultMode = 'light', defaultLightColorScheme: defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme, supportedColorSchemes: supportedColorSchemes = [], modeStorageKey: modeStorageKey = (0, $1507b440b55b1cf7$export$ff0fa3047d11164c), colorSchemeStorageKey: colorSchemeStorageKey = (0, $1507b440b55b1cf7$export$665054ea9d94dab9), storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, storageManager: storageManager = (0, $3b1fb882896a7778$export$2e2bcd8739ae039), noSsr: noSsr = false } = options;
    const joinedColorSchemes = supportedColorSchemes.join(',');
    const isMultiSchemes = supportedColorSchemes.length > 1;
    const modeStorage = $acw62.useMemo(()=>storageManager?.({
            key: modeStorageKey,
            storageWindow: storageWindow
        }), [
        storageManager,
        modeStorageKey,
        storageWindow
    ]);
    const lightStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-light`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const darkStorage = $acw62.useMemo(()=>storageManager?.({
            key: `${colorSchemeStorageKey}-dark`,
            storageWindow: storageWindow
        }), [
        storageManager,
        colorSchemeStorageKey,
        storageWindow
    ]);
    const [state, setState] = $acw62.useState(()=>{
        const initialMode = modeStorage?.get(defaultMode) || defaultMode;
        const lightColorScheme = lightStorage?.get(defaultLightColorScheme) || defaultLightColorScheme;
        const darkColorScheme = darkStorage?.get(defaultDarkColorScheme) || defaultDarkColorScheme;
        return {
            mode: initialMode,
            systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(initialMode),
            lightColorScheme: lightColorScheme,
            darkColorScheme: darkColorScheme
        };
    });
    const [isClient, setIsClient] = $acw62.useState(noSsr || !isMultiSchemes);
    $acw62.useEffect(()=>{
        setIsClient(true); // to rerender the component after hydration
    }, []);
    const colorScheme = $d8b25f9d3c9e642d$export$3caa7590cc1987bd(state);
    const setMode = $acw62.useCallback((mode)=>{
        setState((currentState)=>{
            if (mode === currentState.mode) // do nothing if mode does not change
            return currentState;
            const newMode = mode ?? defaultMode;
            modeStorage?.set(newMode);
            return {
                ...currentState,
                mode: newMode,
                systemMode: $d8b25f9d3c9e642d$export$ab3d447356dfa3e5(newMode)
            };
        });
    }, [
        modeStorage,
        defaultMode
    ]);
    const setColorScheme = $acw62.useCallback((value)=>{
        if (!value) setState((currentState)=>{
            lightStorage?.set(defaultLightColorScheme);
            darkStorage?.set(defaultDarkColorScheme);
            return {
                ...currentState,
                lightColorScheme: defaultLightColorScheme,
                darkColorScheme: defaultDarkColorScheme
            };
        });
        else if (typeof value === 'string') {
            if (value && !joinedColorSchemes.includes(value)) console.error(`\`${value}\` does not exist in \`theme.colorSchemes\`.`);
            else setState((currentState)=>{
                const newState = {
                    ...currentState
                };
                $d8b25f9d3c9e642d$var$processState(currentState, (mode)=>{
                    if (mode === 'light') {
                        lightStorage?.set(value);
                        newState.lightColorScheme = value;
                    }
                    if (mode === 'dark') {
                        darkStorage?.set(value);
                        newState.darkColorScheme = value;
                    }
                });
                return newState;
            });
        } else setState((currentState)=>{
            const newState = {
                ...currentState
            };
            const newLightColorScheme = value.light === null ? defaultLightColorScheme : value.light;
            const newDarkColorScheme = value.dark === null ? defaultDarkColorScheme : value.dark;
            if (newLightColorScheme) {
                if (!joinedColorSchemes.includes(newLightColorScheme)) console.error(`\`${newLightColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.lightColorScheme = newLightColorScheme;
                    lightStorage?.set(newLightColorScheme);
                }
            }
            if (newDarkColorScheme) {
                if (!joinedColorSchemes.includes(newDarkColorScheme)) console.error(`\`${newDarkColorScheme}\` does not exist in \`theme.colorSchemes\`.`);
                else {
                    newState.darkColorScheme = newDarkColorScheme;
                    darkStorage?.set(newDarkColorScheme);
                }
            }
            return newState;
        });
    }, [
        joinedColorSchemes,
        lightStorage,
        darkStorage,
        defaultLightColorScheme,
        defaultDarkColorScheme
    ]);
    const handleMediaQuery = $acw62.useCallback((event)=>{
        if (state.mode === 'system') setState((currentState)=>{
            const systemMode = event?.matches ? 'dark' : 'light';
            // Early exit, nothing changed.
            if (currentState.systemMode === systemMode) return currentState;
            return {
                ...currentState,
                systemMode: systemMode
            };
        });
    }, [
        state.mode
    ]);
    // Ref hack to avoid adding handleMediaQuery as a dep
    const mediaListener = $acw62.useRef(handleMediaQuery);
    mediaListener.current = handleMediaQuery;
    $acw62.useEffect(()=>{
        if (typeof window.matchMedia !== 'function' || !isMultiSchemes) return undefined;
        const handler = (...args)=>mediaListener.current(...args);
        // Always listen to System preference
        const media = window.matchMedia('(prefers-color-scheme: dark)');
        // Intentionally use deprecated listener methods to support iOS & old browsers
        media.addListener(handler);
        handler(media);
        return ()=>{
            media.removeListener(handler);
        };
    }, [
        isMultiSchemes
    ]);
    // Handle when localStorage has changed
    $acw62.useEffect(()=>{
        if (isMultiSchemes) {
            const unsubscribeMode = modeStorage?.subscribe((value)=>{
                if (!value || [
                    'light',
                    'dark',
                    'system'
                ].includes(value)) setMode(value || defaultMode);
            }) || $d8b25f9d3c9e642d$var$noop;
            const unsubscribeLight = lightStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    light: value
                });
            }) || $d8b25f9d3c9e642d$var$noop;
            const unsubscribeDark = darkStorage?.subscribe((value)=>{
                if (!value || joinedColorSchemes.match(value)) setColorScheme({
                    dark: value
                });
            }) || $d8b25f9d3c9e642d$var$noop;
            return ()=>{
                unsubscribeMode();
                unsubscribeLight();
                unsubscribeDark();
            };
        }
        return undefined;
    }, [
        setColorScheme,
        setMode,
        joinedColorSchemes,
        defaultMode,
        storageWindow,
        isMultiSchemes,
        modeStorage,
        lightStorage,
        darkStorage
    ]);
    return {
        ...state,
        mode: isClient ? state.mode : undefined,
        systemMode: isClient ? state.systemMode : undefined,
        colorScheme: isClient ? colorScheme : undefined,
        setMode: setMode,
        setColorScheme: setColorScheme
    };
}



'use client';
const $8dfeca3d89da820b$export$c09f426c4535c3ec = '*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}';
function $8dfeca3d89da820b$export$2e2bcd8739ae039(options) {
    const { themeId: themeId, /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */ theme: defaultTheme = {}, modeStorageKey: defaultModeStorageKey = (0, $1507b440b55b1cf7$export$ff0fa3047d11164c), colorSchemeStorageKey: defaultColorSchemeStorageKey = (0, $1507b440b55b1cf7$export$665054ea9d94dab9), disableTransitionOnChange: designSystemTransitionOnChange = false, defaultColorScheme: defaultColorScheme, resolveTheme: resolveTheme } = options;
    const defaultContext = {
        allColorSchemes: [],
        colorScheme: undefined,
        darkColorScheme: undefined,
        lightColorScheme: undefined,
        mode: undefined,
        setColorScheme: ()=>{},
        setMode: ()=>{},
        systemMode: undefined
    };
    const ColorSchemeContext = /*#__PURE__*/ $acw62.createContext(undefined);
    const useColorScheme = ()=>$acw62.useContext(ColorSchemeContext) || defaultContext;
    const defaultColorSchemes = {};
    const defaultComponents = {};
    function CssVarsProvider(props) {
        const { children: children, theme: themeProp, modeStorageKey: modeStorageKey = defaultModeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = defaultColorSchemeStorageKey, disableTransitionOnChange: disableTransitionOnChange = designSystemTransitionOnChange, storageManager: storageManager, storageWindow: storageWindow = typeof window === 'undefined' ? undefined : window, documentNode: documentNode = typeof document === 'undefined' ? undefined : document, colorSchemeNode: colorSchemeNode = typeof document === 'undefined' ? undefined : document.documentElement, disableNestedContext: disableNestedContext = false, disableStyleSheetGeneration: disableStyleSheetGeneration = false, defaultMode: initialMode = 'system', forceThemeRerender: forceThemeRerender = false, noSsr: noSsr } = props;
        const hasMounted = $acw62.useRef(false);
        const upperTheme = (0, $022fb1085af75a08$export$2e2bcd8739ae039)();
        const ctx = $acw62.useContext(ColorSchemeContext);
        const nested = !!ctx && !disableNestedContext;
        const initialTheme = $acw62.useMemo(()=>{
            if (themeProp) return themeProp;
            return typeof defaultTheme === 'function' ? defaultTheme() : defaultTheme;
        }, [
            themeProp
        ]);
        const scopedTheme = initialTheme[themeId];
        const restThemeProp = scopedTheme || initialTheme;
        const { colorSchemes: colorSchemes = defaultColorSchemes, components: components = defaultComponents, cssVarPrefix: cssVarPrefix } = restThemeProp;
        const joinedColorSchemes = Object.keys(colorSchemes).filter((k)=>!!colorSchemes[k]).join(',');
        const allColorSchemes = $acw62.useMemo(()=>joinedColorSchemes.split(','), [
            joinedColorSchemes
        ]);
        const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
        const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
        const defaultMode = colorSchemes[defaultLightColorScheme] && colorSchemes[defaultDarkColorScheme] ? initialMode : colorSchemes[restThemeProp.defaultColorScheme]?.palette?.mode || restThemeProp.palette?.mode;
        // 1. Get the data about the `mode`, `colorScheme`, and setter functions.
        const { mode: stateMode, setMode: setMode, systemMode: systemMode, lightColorScheme: lightColorScheme, darkColorScheme: darkColorScheme, colorScheme: stateColorScheme, setColorScheme: setColorScheme } = (0, $d8b25f9d3c9e642d$export$2e2bcd8739ae039)({
            supportedColorSchemes: allColorSchemes,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: modeStorageKey,
            colorSchemeStorageKey: colorSchemeStorageKey,
            defaultMode: defaultMode,
            storageManager: storageManager,
            storageWindow: storageWindow,
            noSsr: noSsr
        });
        let mode = stateMode;
        let colorScheme = stateColorScheme;
        if (nested) {
            mode = ctx.mode;
            colorScheme = ctx.colorScheme;
        }
        // `colorScheme` is undefined on the server and hydration phase
        let calculatedColorScheme = colorScheme || restThemeProp.defaultColorScheme;
        if (restThemeProp.vars && !forceThemeRerender) calculatedColorScheme = restThemeProp.defaultColorScheme;
        const memoTheme = $acw62.useMemo(()=>{
            // 2. get the `vars` object that refers to the CSS custom properties
            const themeVars = restThemeProp.generateThemeVars?.() || restThemeProp.vars;
            // 3. Start composing the theme object
            const theme = {
                ...restThemeProp,
                components: components,
                colorSchemes: colorSchemes,
                cssVarPrefix: cssVarPrefix,
                vars: themeVars
            };
            if (typeof theme.generateSpacing === 'function') theme.spacing = theme.generateSpacing();
            // 4. Resolve the color scheme and merge it to the theme
            if (calculatedColorScheme) {
                const scheme = colorSchemes[calculatedColorScheme];
                if (scheme && typeof scheme === 'object') // 4.1 Merge the selected color scheme to the theme
                Object.keys(scheme).forEach((schemeKey)=>{
                    if (scheme[schemeKey] && typeof scheme[schemeKey] === 'object') // shallow merge the 1st level structure of the theme.
                    theme[schemeKey] = {
                        ...theme[schemeKey],
                        ...scheme[schemeKey]
                    };
                    else theme[schemeKey] = scheme[schemeKey];
                });
            }
            return resolveTheme ? resolveTheme(theme) : theme;
        }, [
            restThemeProp,
            calculatedColorScheme,
            components,
            colorSchemes,
            cssVarPrefix
        ]);
        // 5. Declaring effects
        // 5.1 Updates the selector value to use the current color scheme which tells CSS to use the proper stylesheet.
        const colorSchemeSelector = restThemeProp.colorSchemeSelector;
        (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
            if (colorScheme && colorSchemeNode && colorSchemeSelector && colorSchemeSelector !== 'media') {
                const selector = colorSchemeSelector;
                let rule = colorSchemeSelector;
                if (selector === 'class') rule = `.%s`;
                if (selector === 'data') rule = `[data-%s]`;
                if (selector?.startsWith('data-') && !selector.includes('%s')) // 'data-mui-color-scheme' -> '[data-mui-color-scheme="%s"]'
                rule = `[${selector}="%s"]`;
                if (rule.startsWith('.')) {
                    colorSchemeNode.classList.remove(...allColorSchemes.map((scheme)=>rule.substring(1).replace('%s', scheme)));
                    colorSchemeNode.classList.add(rule.substring(1).replace('%s', colorScheme));
                } else {
                    const matches = rule.replace('%s', colorScheme).match(/\[([^\]]+)\]/);
                    if (matches) {
                        const [attr, value] = matches[1].split('=');
                        if (!value) // for attributes like `data-theme-dark`, `data-theme-light`
                        // remove all the existing data attributes before setting the new one
                        allColorSchemes.forEach((scheme)=>{
                            colorSchemeNode.removeAttribute(attr.replace(colorScheme, scheme));
                        });
                        colorSchemeNode.setAttribute(attr, value ? value.replace(/"|'/g, '') : '');
                    } else colorSchemeNode.setAttribute(rule, colorScheme);
                }
            }
        }, [
            colorScheme,
            colorSchemeSelector,
            colorSchemeNode,
            allColorSchemes
        ]);
        // 5.2 Remove the CSS transition when color scheme changes to create instant experience.
        // credit: https://github.com/pacocoursey/next-themes/blob/b5c2bad50de2d61ad7b52a9c5cdc801a78507d7a/index.tsx#L313
        $acw62.useEffect(()=>{
            let timer;
            if (disableTransitionOnChange && hasMounted.current && documentNode) {
                const css = documentNode.createElement('style');
                css.appendChild(documentNode.createTextNode($8dfeca3d89da820b$export$c09f426c4535c3ec));
                documentNode.head.appendChild(css);
                // Force browser repaint
                (()=>window.getComputedStyle(documentNode.body))();
                timer = setTimeout(()=>{
                    documentNode.head.removeChild(css);
                }, 1);
            }
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            colorScheme,
            disableTransitionOnChange,
            documentNode
        ]);
        $acw62.useEffect(()=>{
            hasMounted.current = true;
            return ()=>{
                hasMounted.current = false;
            };
        }, []);
        const contextValue = $acw62.useMemo(()=>({
                allColorSchemes: allColorSchemes,
                colorScheme: colorScheme,
                darkColorScheme: darkColorScheme,
                lightColorScheme: lightColorScheme,
                mode: mode,
                setColorScheme: setColorScheme,
                setMode: setMode,
                systemMode: systemMode
            }), [
            allColorSchemes,
            colorScheme,
            darkColorScheme,
            lightColorScheme,
            mode,
            setColorScheme,
            setMode,
            systemMode,
            memoTheme.colorSchemeSelector
        ]);
        let shouldGenerateStyleSheet = true;
        if (disableStyleSheetGeneration || restThemeProp.cssVariables === false || nested && upperTheme?.cssVarPrefix === cssVarPrefix) shouldGenerateStyleSheet = false;
        const element = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $50ef44b883b4d7f9$export$2e2bcd8739ae039), {
                    themeId: scopedTheme ? themeId : undefined,
                    theme: memoTheme,
                    children: children
                }),
                shouldGenerateStyleSheet && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $afce2778e79e00d1$export$2e2bcd8739ae039), {
                    styles: memoTheme.generateStyleSheets?.() || []
                })
            ]
        });
        if (nested) return element;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColorSchemeContext.Provider, {
            value: contextValue,
            children: element
        });
    }
    const defaultLightColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.light;
    const defaultDarkColorScheme = typeof defaultColorScheme === 'string' ? defaultColorScheme : defaultColorScheme.dark;
    const getInitColorSchemeScript = (params)=>(0, $1507b440b55b1cf7$export$2e2bcd8739ae039)({
            colorSchemeStorageKey: defaultColorSchemeStorageKey,
            defaultLightColorScheme: defaultLightColorScheme,
            defaultDarkColorScheme: defaultDarkColorScheme,
            modeStorageKey: defaultModeStorageKey,
            ...params
        });
    return {
        CssVarsProvider: CssVarsProvider,
        useColorScheme: useColorScheme,
        getInitColorSchemeScript: getInitColorSchemeScript
    };
}





parcelRequire("acw62");



const $d5eac692ed332b1c$export$f84bd70098573c5c = {
    attribute: 'data-mui-color-scheme',
    colorSchemeStorageKey: 'mui-color-scheme',
    defaultLightColorScheme: 'light',
    defaultDarkColorScheme: 'dark',
    modeStorageKey: 'mui-mode'
};
/**
 *
 * Demos:
 *
 * - [InitColorSchemeScript](https://mui.com/material-ui/react-init-color-scheme-script/)
 *
 * API:
 *
 * - [InitColorSchemeScript API](https://mui.com/material-ui/api/init-color-scheme-script/)
 */ function $d5eac692ed332b1c$var$InitColorSchemeScript(props) {
    const { defaultMode: defaultMode = 'system', defaultLightColorScheme: defaultLightColorScheme = $d5eac692ed332b1c$export$f84bd70098573c5c.defaultLightColorScheme, defaultDarkColorScheme: defaultDarkColorScheme = $d5eac692ed332b1c$export$f84bd70098573c5c.defaultDarkColorScheme, modeStorageKey: modeStorageKey = $d5eac692ed332b1c$export$f84bd70098573c5c.modeStorageKey, colorSchemeStorageKey: colorSchemeStorageKey = $d5eac692ed332b1c$export$f84bd70098573c5c.colorSchemeStorageKey, attribute: initialAttribute = $d5eac692ed332b1c$export$f84bd70098573c5c.attribute, colorSchemeNode: colorSchemeNode = 'document.documentElement', nonce: nonce } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1507b440b55b1cf7$export$2e2bcd8739ae039), {
        defaultMode: defaultMode,
        defaultLightColorScheme: defaultLightColorScheme,
        defaultDarkColorScheme: defaultDarkColorScheme,
        modeStorageKey: modeStorageKey,
        colorSchemeStorageKey: colorSchemeStorageKey,
        attribute: initialAttribute,
        colorSchemeNode: colorSchemeNode,
        nonce: nonce
    });
}
var $d5eac692ed332b1c$export$2e2bcd8739ae039 = $d5eac692ed332b1c$var$InitColorSchemeScript;



'use client';
const { CssVarsProvider: $cfa43f235c6b12b8$var$InternalCssVarsProvider, useColorScheme: $cfa43f235c6b12b8$export$6343629ee1b29116, getInitColorSchemeScript: $cfa43f235c6b12b8$var$deprecatedGetInitColorSchemeScript } = (0, $8dfeca3d89da820b$export$2e2bcd8739ae039)({
    themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039),
    // @ts-ignore ignore module augmentation tests
    theme: ()=>(0, $1c8355eadf532640$export$2e2bcd8739ae039)({
            cssVariables: true
        }),
    colorSchemeStorageKey: (0, $d5eac692ed332b1c$export$f84bd70098573c5c).colorSchemeStorageKey,
    modeStorageKey: (0, $d5eac692ed332b1c$export$f84bd70098573c5c).modeStorageKey,
    defaultColorScheme: {
        light: (0, $d5eac692ed332b1c$export$f84bd70098573c5c).defaultLightColorScheme,
        dark: (0, $d5eac692ed332b1c$export$f84bd70098573c5c).defaultDarkColorScheme
    },
    resolveTheme: (theme)=>{
        const newTheme = {
            ...theme,
            typography: (0, $807f5ad944800d5b$export$2e2bcd8739ae039)(theme.palette, theme.typography)
        };
        newTheme.unstable_sx = function sx(props) {
            return (0, $6b750d631801d296$export$2e2bcd8739ae039)({
                sx: props,
                theme: this
            });
        };
        return newTheme;
    }
});
let $cfa43f235c6b12b8$var$warnedOnce = false;
// TODO: remove in v7
// eslint-disable-next-line @typescript-eslint/naming-convention
function $cfa43f235c6b12b8$export$99adf6d9ed169a14(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cfa43f235c6b12b8$var$InternalCssVarsProvider, {
        ...props
    });
}
let $cfa43f235c6b12b8$var$warnedInitScriptOnce = false;
// TODO: remove in v7
const $cfa43f235c6b12b8$export$f9a57b4a2abf8ed = (params)=>{
    if (!$cfa43f235c6b12b8$var$warnedInitScriptOnce) {
        console.warn([
            'MUI: The getInitColorSchemeScript function has been deprecated.',
            '',
            "You should use `import InitColorSchemeScript from '@mui/material/InitColorSchemeScript'`",
            'and replace the function call with `<InitColorSchemeScript />` instead.'
        ].join('\n'));
        $cfa43f235c6b12b8$var$warnedInitScriptOnce = true;
    }
    return $cfa43f235c6b12b8$var$deprecatedGetInitColorSchemeScript(params);
};
const $cfa43f235c6b12b8$export$50ec01b133c61652 = $cfa43f235c6b12b8$var$InternalCssVarsProvider;




'use client';
function $cc8cea264685552f$export$2e2bcd8739ae039({ theme: theme, ...props }) {
    const noVarsTheme = $acw62.useMemo(()=>{
        if (typeof theme === 'function') return theme;
        const muiTheme = (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039) in theme ? theme[0, $8b4c3f6e5c407120$export$2e2bcd8739ae039] : theme;
        if (!('colorSchemes' in muiTheme)) {
            if (!('vars' in muiTheme)) // For non-CSS variables themes, set `vars` to null to prevent theme inheritance from the upper theme.
            // The example use case is the docs demo that uses ThemeProvider to customize the theme while the upper theme is using CSS variables.
            return {
                ...theme,
                vars: null
            };
            return theme;
        }
        return null;
    }, [
        theme
    ]);
    if (noVarsTheme) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05516f934f879d28$export$2e2bcd8739ae039), {
        theme: noVarsTheme,
        ...props
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cfa43f235c6b12b8$export$50ec01b133c61652), {
        theme: theme,
        ...props
    });
}





var $acw62 = parcelRequire("acw62");
function $36d0e3de07f3b68c$var$e(e) {
    function t(e, t) {
        Error.captureStackTrace && Error.captureStackTrace(this, this.constructor), this.message = e, this.code = t;
    }
    return t.prototype = new Error, t.prototype.name = e, t.prototype.constructor = t, t;
}
const $36d0e3de07f3b68c$var$t = $36d0e3de07f3b68c$var$e("LaunchDarklyUnexpectedResponseError"), $36d0e3de07f3b68c$var$n = $36d0e3de07f3b68c$var$e("LaunchDarklyInvalidEnvironmentIdError"), $36d0e3de07f3b68c$var$r = $36d0e3de07f3b68c$var$e("LaunchDarklyInvalidUserError"), $36d0e3de07f3b68c$var$o = $36d0e3de07f3b68c$var$e("LaunchDarklyInvalidEventKeyError"), $36d0e3de07f3b68c$var$i = $36d0e3de07f3b68c$var$e("LaunchDarklyInvalidArgumentError"), $36d0e3de07f3b68c$var$a = $36d0e3de07f3b68c$var$e("LaunchDarklyFlagFetchError");
for(var $36d0e3de07f3b68c$var$s = {
    LDUnexpectedResponseError: $36d0e3de07f3b68c$var$t,
    LDInvalidEnvironmentIdError: $36d0e3de07f3b68c$var$n,
    LDInvalidUserError: $36d0e3de07f3b68c$var$r,
    LDInvalidEventKeyError: $36d0e3de07f3b68c$var$o,
    LDInvalidArgumentError: $36d0e3de07f3b68c$var$i,
    LDInvalidDataError: $36d0e3de07f3b68c$var$e("LaunchDarklyInvalidDataError"),
    LDFlagFetchError: $36d0e3de07f3b68c$var$a,
    LDTimeoutError: $36d0e3de07f3b68c$var$e("LaunchDarklyTimeoutError"),
    isHttpErrorRecoverable: function(e) {
        return !(e >= 400 && e < 500) || 400 === e || 408 === e || 429 === e;
    }
}, $36d0e3de07f3b68c$var$c = function(e) {
    var t = $36d0e3de07f3b68c$var$m(e), n = t[0], r = t[1];
    return 3 * (n + r) / 4 - r;
}, $36d0e3de07f3b68c$var$u = function(e) {
    var t, n, r = $36d0e3de07f3b68c$var$m(e), o = r[0], i = r[1], a = new $36d0e3de07f3b68c$var$g(function(e, t, n) {
        return 3 * (t + n) / 4 - n;
    }(0, o, i)), s = 0, c = i > 0 ? o - 4 : o;
    for(n = 0; n < c; n += 4)t = $36d0e3de07f3b68c$var$f[e.charCodeAt(n)] << 18 | $36d0e3de07f3b68c$var$f[e.charCodeAt(n + 1)] << 12 | $36d0e3de07f3b68c$var$f[e.charCodeAt(n + 2)] << 6 | $36d0e3de07f3b68c$var$f[e.charCodeAt(n + 3)], a[s++] = t >> 16 & 255, a[s++] = t >> 8 & 255, a[s++] = 255 & t;
    2 === i && (t = $36d0e3de07f3b68c$var$f[e.charCodeAt(n)] << 2 | $36d0e3de07f3b68c$var$f[e.charCodeAt(n + 1)] >> 4, a[s++] = 255 & t);
    1 === i && (t = $36d0e3de07f3b68c$var$f[e.charCodeAt(n)] << 10 | $36d0e3de07f3b68c$var$f[e.charCodeAt(n + 1)] << 4 | $36d0e3de07f3b68c$var$f[e.charCodeAt(n + 2)] >> 2, a[s++] = t >> 8 & 255, a[s++] = 255 & t);
    return a;
}, $36d0e3de07f3b68c$var$l = function(e) {
    for(var t, n = e.length, r = n % 3, o = [], i = 16383, a = 0, s = n - r; a < s; a += i)o.push($36d0e3de07f3b68c$var$y(e, a, a + i > s ? s : a + i));
    1 === r ? (t = e[n - 1], o.push($36d0e3de07f3b68c$var$d[t >> 2] + $36d0e3de07f3b68c$var$d[t << 4 & 63] + "==")) : 2 === r && (t = (e[n - 2] << 8) + e[n - 1], o.push($36d0e3de07f3b68c$var$d[t >> 10] + $36d0e3de07f3b68c$var$d[t >> 4 & 63] + $36d0e3de07f3b68c$var$d[t << 2 & 63] + "="));
    return o.join("");
}, $36d0e3de07f3b68c$var$d = [], $36d0e3de07f3b68c$var$f = [], $36d0e3de07f3b68c$var$g = "undefined" != typeof Uint8Array ? Uint8Array : Array, $36d0e3de07f3b68c$var$v = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", $36d0e3de07f3b68c$var$p = 0; $36d0e3de07f3b68c$var$p < 64; ++$36d0e3de07f3b68c$var$p)$36d0e3de07f3b68c$var$d[$36d0e3de07f3b68c$var$p] = $36d0e3de07f3b68c$var$v[$36d0e3de07f3b68c$var$p], $36d0e3de07f3b68c$var$f[$36d0e3de07f3b68c$var$v.charCodeAt($36d0e3de07f3b68c$var$p)] = $36d0e3de07f3b68c$var$p;
function $36d0e3de07f3b68c$var$m(e) {
    var t = e.length;
    if (t % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    var n = e.indexOf("=");
    return -1 === n && (n = t), [
        n,
        n === t ? 0 : 4 - n % 4
    ];
}
function $36d0e3de07f3b68c$var$h(e) {
    return $36d0e3de07f3b68c$var$d[e >> 18 & 63] + $36d0e3de07f3b68c$var$d[e >> 12 & 63] + $36d0e3de07f3b68c$var$d[e >> 6 & 63] + $36d0e3de07f3b68c$var$d[63 & e];
}
function $36d0e3de07f3b68c$var$y(e, t, n) {
    for(var r, o = [], i = t; i < n; i += 3)r = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (255 & e[i + 2]), o.push($36d0e3de07f3b68c$var$h(r));
    return o.join("");
}
$36d0e3de07f3b68c$var$f["-".charCodeAt(0)] = 62, $36d0e3de07f3b68c$var$f["_".charCodeAt(0)] = 63;
var $36d0e3de07f3b68c$var$w = {
    byteLength: $36d0e3de07f3b68c$var$c,
    toByteArray: $36d0e3de07f3b68c$var$u,
    fromByteArray: $36d0e3de07f3b68c$var$l
}, $36d0e3de07f3b68c$var$b = Array.isArray, $36d0e3de07f3b68c$var$k = Object.keys, $36d0e3de07f3b68c$var$E = Object.prototype.hasOwnProperty, $36d0e3de07f3b68c$var$D = function e(t, n) {
    if (t === n) return !0;
    if (t && n && "object" == typeof t && "object" == typeof n) {
        var r, o, i, a = $36d0e3de07f3b68c$var$b(t), s = $36d0e3de07f3b68c$var$b(n);
        if (a && s) {
            if ((o = t.length) != n.length) return !1;
            for(r = o; 0 !== r--;)if (!e(t[r], n[r])) return !1;
            return !0;
        }
        if (a != s) return !1;
        var c = t instanceof Date, u = n instanceof Date;
        if (c != u) return !1;
        if (c && u) return t.getTime() == n.getTime();
        var l = t instanceof RegExp, d = n instanceof RegExp;
        if (l != d) return !1;
        if (l && d) return t.toString() == n.toString();
        var f = $36d0e3de07f3b68c$var$k(t);
        if ((o = f.length) !== $36d0e3de07f3b68c$var$k(n).length) return !1;
        for(r = o; 0 !== r--;)if (!$36d0e3de07f3b68c$var$E.call(n, f[r])) return !1;
        for(r = o; 0 !== r--;)if (!e(t[i = f[r]], n[i])) return !1;
        return !0;
    }
    return t != t && n != n;
};
const $36d0e3de07f3b68c$var$x = [
    "key",
    "ip",
    "country",
    "email",
    "firstName",
    "lastName",
    "avatar",
    "name"
];
function $36d0e3de07f3b68c$var$O(e) {
    const t = unescape(encodeURIComponent(e));
    return $36d0e3de07f3b68c$var$w.fromByteArray(function(e) {
        const t = [];
        for(let n = 0; n < e.length; n++)t.push(e.charCodeAt(n));
        return t;
    }(t));
}
function $36d0e3de07f3b68c$var$C(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
var $36d0e3de07f3b68c$var$P, $36d0e3de07f3b68c$var$S = {
    appendUrlPath: function(e, t) {
        return (e.endsWith("/") ? e.substring(0, e.length - 1) : e) + (t.startsWith("/") ? "" : "/") + t;
    },
    base64URLEncode: function(e) {
        return $36d0e3de07f3b68c$var$O(e).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
    },
    btoa: $36d0e3de07f3b68c$var$O,
    clone: function(e) {
        return JSON.parse(JSON.stringify(e));
    },
    deepEquals: function(e, t) {
        return $36d0e3de07f3b68c$var$D(e, t);
    },
    extend: function(...e) {
        return e.reduce((e, t)=>({
                ...e,
                ...t
            }), {});
    },
    getLDUserAgentString: function(e) {
        const t = e.version || "?";
        return e.userAgent + "/" + t;
    },
    objectHasOwnProperty: $36d0e3de07f3b68c$var$C,
    onNextTick: function(e) {
        setTimeout(e, 0);
    },
    sanitizeContext: function(e) {
        if (!e) return e;
        let t;
        return null !== e.kind && void 0 !== e.kind || $36d0e3de07f3b68c$var$x.forEach((n)=>{
            const r = e[n];
            void 0 !== r && "string" != typeof r && (t = t || {
                ...e
            }, t[n] = String(r));
        }), t || e;
    },
    transformValuesToVersionedValues: function(e) {
        const t = {};
        for(const n in e)$36d0e3de07f3b68c$var$C(e, n) && (t[n] = {
            value: e[n],
            version: 0
        });
        return t;
    },
    transformVersionedValuesToValues: function(e) {
        const t = {};
        for(const n in e)$36d0e3de07f3b68c$var$C(e, n) && (t[n] = e[n].value);
        return t;
    },
    wrapPromiseCallback: function(e, t) {
        const n = e.then((e)=>(t && setTimeout(()=>{
                t(null, e);
            }, 0), e), (e)=>{
            if (!t) return Promise.reject(e);
            setTimeout(()=>{
                t(e, null);
            }, 0);
        });
        return t ? void 0 : n;
    },
    once: function(e) {
        let t, n = !1;
        return function(...r) {
            return n || (n = !0, t = e.apply(this, r)), t;
        };
    }
}, $36d0e3de07f3b68c$var$I = new Uint8Array(16);
function $36d0e3de07f3b68c$var$T() {
    if (!$36d0e3de07f3b68c$var$P && !($36d0e3de07f3b68c$var$P = "undefined" != typeof crypto && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || "undefined" != typeof msCrypto && "function" == typeof msCrypto.getRandomValues && msCrypto.getRandomValues.bind(msCrypto))) throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return $36d0e3de07f3b68c$var$P($36d0e3de07f3b68c$var$I);
}
var $36d0e3de07f3b68c$var$F = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function $36d0e3de07f3b68c$var$L(e) {
    return "string" == typeof e && $36d0e3de07f3b68c$var$F.test(e);
}
for(var $36d0e3de07f3b68c$var$U, $36d0e3de07f3b68c$var$A, $36d0e3de07f3b68c$var$j = [], $36d0e3de07f3b68c$var$R = 0; $36d0e3de07f3b68c$var$R < 256; ++$36d0e3de07f3b68c$var$R)$36d0e3de07f3b68c$var$j.push(($36d0e3de07f3b68c$var$R + 256).toString(16).substr(1));
function $36d0e3de07f3b68c$var$N(e) {
    var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 0, n = ($36d0e3de07f3b68c$var$j[e[t + 0]] + $36d0e3de07f3b68c$var$j[e[t + 1]] + $36d0e3de07f3b68c$var$j[e[t + 2]] + $36d0e3de07f3b68c$var$j[e[t + 3]] + "-" + $36d0e3de07f3b68c$var$j[e[t + 4]] + $36d0e3de07f3b68c$var$j[e[t + 5]] + "-" + $36d0e3de07f3b68c$var$j[e[t + 6]] + $36d0e3de07f3b68c$var$j[e[t + 7]] + "-" + $36d0e3de07f3b68c$var$j[e[t + 8]] + $36d0e3de07f3b68c$var$j[e[t + 9]] + "-" + $36d0e3de07f3b68c$var$j[e[t + 10]] + $36d0e3de07f3b68c$var$j[e[t + 11]] + $36d0e3de07f3b68c$var$j[e[t + 12]] + $36d0e3de07f3b68c$var$j[e[t + 13]] + $36d0e3de07f3b68c$var$j[e[t + 14]] + $36d0e3de07f3b68c$var$j[e[t + 15]]).toLowerCase();
    if (!$36d0e3de07f3b68c$var$L(n)) throw TypeError("Stringified UUID is invalid");
    return n;
}
var $36d0e3de07f3b68c$var$$ = 0, $36d0e3de07f3b68c$var$V = 0;
function $36d0e3de07f3b68c$var$H(e) {
    if (!$36d0e3de07f3b68c$var$L(e)) throw TypeError("Invalid UUID");
    var t, n = new Uint8Array(16);
    return n[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, n[1] = t >>> 16 & 255, n[2] = t >>> 8 & 255, n[3] = 255 & t, n[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, n[5] = 255 & t, n[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, n[7] = 255 & t, n[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, n[9] = 255 & t, n[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, n[11] = t / 4294967296 & 255, n[12] = t >>> 24 & 255, n[13] = t >>> 16 & 255, n[14] = t >>> 8 & 255, n[15] = 255 & t, n;
}
function $36d0e3de07f3b68c$var$M(e, t, n) {
    function r(e, r, o, i) {
        if ("string" == typeof e && (e = function(e) {
            e = unescape(encodeURIComponent(e));
            for(var t = [], n = 0; n < e.length; ++n)t.push(e.charCodeAt(n));
            return t;
        }(e)), "string" == typeof r && (r = $36d0e3de07f3b68c$var$H(r)), 16 !== r.length) throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
        var a = new Uint8Array(16 + e.length);
        if (a.set(r), a.set(e, r.length), (a = n(a))[6] = 15 & a[6] | t, a[8] = 63 & a[8] | 128, o) {
            i = i || 0;
            for(var s = 0; s < 16; ++s)o[i + s] = a[s];
            return o;
        }
        return $36d0e3de07f3b68c$var$N(a);
    }
    try {
        r.name = e;
    } catch (e) {}
    return r.DNS = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", r.URL = "6ba7b811-9dad-11d1-80b4-00c04fd430c8", r;
}
function $36d0e3de07f3b68c$var$q(e) {
    return 14 + (e + 64 >>> 9 << 4) + 1;
}
function $36d0e3de07f3b68c$var$z(e, t) {
    var n = (65535 & e) + (65535 & t);
    return (e >> 16) + (t >> 16) + (n >> 16) << 16 | 65535 & n;
}
function $36d0e3de07f3b68c$var$K(e, t, n, r, o, i) {
    var a, s;
    return $36d0e3de07f3b68c$var$z((a = $36d0e3de07f3b68c$var$z($36d0e3de07f3b68c$var$z(t, e), $36d0e3de07f3b68c$var$z(r, i))) << (s = o) | a >>> 32 - s, n);
}
function $36d0e3de07f3b68c$var$_(e, t, n, r, o, i, a) {
    return $36d0e3de07f3b68c$var$K(t & n | ~t & r, e, t, o, i, a);
}
function $36d0e3de07f3b68c$var$J(e, t, n, r, o, i, a) {
    return $36d0e3de07f3b68c$var$K(t & r | n & ~r, e, t, o, i, a);
}
function $36d0e3de07f3b68c$var$B(e, t, n, r, o, i, a) {
    return $36d0e3de07f3b68c$var$K(t ^ n ^ r, e, t, o, i, a);
}
function $36d0e3de07f3b68c$var$W(e, t, n, r, o, i, a) {
    return $36d0e3de07f3b68c$var$K(n ^ (t | ~r), e, t, o, i, a);
}
var $36d0e3de07f3b68c$var$G = $36d0e3de07f3b68c$var$M("v3", 48, function(e) {
    if ("string" == typeof e) {
        var t = unescape(encodeURIComponent(e));
        e = new Uint8Array(t.length);
        for(var n = 0; n < t.length; ++n)e[n] = t.charCodeAt(n);
    }
    return function(e) {
        for(var t = [], n = 32 * e.length, r = "0123456789abcdef", o = 0; o < n; o += 8){
            var i = e[o >> 5] >>> o % 32 & 255, a = parseInt(r.charAt(i >>> 4 & 15) + r.charAt(15 & i), 16);
            t.push(a);
        }
        return t;
    }(function(e, t) {
        e[t >> 5] |= 128 << t % 32, e[$36d0e3de07f3b68c$var$q(t) - 1] = t;
        for(var n = 1732584193, r = -271733879, o = -1732584194, i = 271733878, a = 0; a < e.length; a += 16){
            var s = n, c = r, u = o, l = i;
            n = $36d0e3de07f3b68c$var$_(n, r, o, i, e[a], 7, -680876936), i = $36d0e3de07f3b68c$var$_(i, n, r, o, e[a + 1], 12, -389564586), o = $36d0e3de07f3b68c$var$_(o, i, n, r, e[a + 2], 17, 606105819), r = $36d0e3de07f3b68c$var$_(r, o, i, n, e[a + 3], 22, -1044525330), n = $36d0e3de07f3b68c$var$_(n, r, o, i, e[a + 4], 7, -176418897), i = $36d0e3de07f3b68c$var$_(i, n, r, o, e[a + 5], 12, 1200080426), o = $36d0e3de07f3b68c$var$_(o, i, n, r, e[a + 6], 17, -1473231341), r = $36d0e3de07f3b68c$var$_(r, o, i, n, e[a + 7], 22, -45705983), n = $36d0e3de07f3b68c$var$_(n, r, o, i, e[a + 8], 7, 1770035416), i = $36d0e3de07f3b68c$var$_(i, n, r, o, e[a + 9], 12, -1958414417), o = $36d0e3de07f3b68c$var$_(o, i, n, r, e[a + 10], 17, -42063), r = $36d0e3de07f3b68c$var$_(r, o, i, n, e[a + 11], 22, -1990404162), n = $36d0e3de07f3b68c$var$_(n, r, o, i, e[a + 12], 7, 1804603682), i = $36d0e3de07f3b68c$var$_(i, n, r, o, e[a + 13], 12, -40341101), o = $36d0e3de07f3b68c$var$_(o, i, n, r, e[a + 14], 17, -1502002290), n = $36d0e3de07f3b68c$var$J(n, r = $36d0e3de07f3b68c$var$_(r, o, i, n, e[a + 15], 22, 1236535329), o, i, e[a + 1], 5, -165796510), i = $36d0e3de07f3b68c$var$J(i, n, r, o, e[a + 6], 9, -1069501632), o = $36d0e3de07f3b68c$var$J(o, i, n, r, e[a + 11], 14, 643717713), r = $36d0e3de07f3b68c$var$J(r, o, i, n, e[a], 20, -373897302), n = $36d0e3de07f3b68c$var$J(n, r, o, i, e[a + 5], 5, -701558691), i = $36d0e3de07f3b68c$var$J(i, n, r, o, e[a + 10], 9, 38016083), o = $36d0e3de07f3b68c$var$J(o, i, n, r, e[a + 15], 14, -660478335), r = $36d0e3de07f3b68c$var$J(r, o, i, n, e[a + 4], 20, -405537848), n = $36d0e3de07f3b68c$var$J(n, r, o, i, e[a + 9], 5, 568446438), i = $36d0e3de07f3b68c$var$J(i, n, r, o, e[a + 14], 9, -1019803690), o = $36d0e3de07f3b68c$var$J(o, i, n, r, e[a + 3], 14, -187363961), r = $36d0e3de07f3b68c$var$J(r, o, i, n, e[a + 8], 20, 1163531501), n = $36d0e3de07f3b68c$var$J(n, r, o, i, e[a + 13], 5, -1444681467), i = $36d0e3de07f3b68c$var$J(i, n, r, o, e[a + 2], 9, -51403784), o = $36d0e3de07f3b68c$var$J(o, i, n, r, e[a + 7], 14, 1735328473), n = $36d0e3de07f3b68c$var$B(n, r = $36d0e3de07f3b68c$var$J(r, o, i, n, e[a + 12], 20, -1926607734), o, i, e[a + 5], 4, -378558), i = $36d0e3de07f3b68c$var$B(i, n, r, o, e[a + 8], 11, -2022574463), o = $36d0e3de07f3b68c$var$B(o, i, n, r, e[a + 11], 16, 1839030562), r = $36d0e3de07f3b68c$var$B(r, o, i, n, e[a + 14], 23, -35309556), n = $36d0e3de07f3b68c$var$B(n, r, o, i, e[a + 1], 4, -1530992060), i = $36d0e3de07f3b68c$var$B(i, n, r, o, e[a + 4], 11, 1272893353), o = $36d0e3de07f3b68c$var$B(o, i, n, r, e[a + 7], 16, -155497632), r = $36d0e3de07f3b68c$var$B(r, o, i, n, e[a + 10], 23, -1094730640), n = $36d0e3de07f3b68c$var$B(n, r, o, i, e[a + 13], 4, 681279174), i = $36d0e3de07f3b68c$var$B(i, n, r, o, e[a], 11, -358537222), o = $36d0e3de07f3b68c$var$B(o, i, n, r, e[a + 3], 16, -722521979), r = $36d0e3de07f3b68c$var$B(r, o, i, n, e[a + 6], 23, 76029189), n = $36d0e3de07f3b68c$var$B(n, r, o, i, e[a + 9], 4, -640364487), i = $36d0e3de07f3b68c$var$B(i, n, r, o, e[a + 12], 11, -421815835), o = $36d0e3de07f3b68c$var$B(o, i, n, r, e[a + 15], 16, 530742520), n = $36d0e3de07f3b68c$var$W(n, r = $36d0e3de07f3b68c$var$B(r, o, i, n, e[a + 2], 23, -995338651), o, i, e[a], 6, -198630844), i = $36d0e3de07f3b68c$var$W(i, n, r, o, e[a + 7], 10, 1126891415), o = $36d0e3de07f3b68c$var$W(o, i, n, r, e[a + 14], 15, -1416354905), r = $36d0e3de07f3b68c$var$W(r, o, i, n, e[a + 5], 21, -57434055), n = $36d0e3de07f3b68c$var$W(n, r, o, i, e[a + 12], 6, 1700485571), i = $36d0e3de07f3b68c$var$W(i, n, r, o, e[a + 3], 10, -1894986606), o = $36d0e3de07f3b68c$var$W(o, i, n, r, e[a + 10], 15, -1051523), r = $36d0e3de07f3b68c$var$W(r, o, i, n, e[a + 1], 21, -2054922799), n = $36d0e3de07f3b68c$var$W(n, r, o, i, e[a + 8], 6, 1873313359), i = $36d0e3de07f3b68c$var$W(i, n, r, o, e[a + 15], 10, -30611744), o = $36d0e3de07f3b68c$var$W(o, i, n, r, e[a + 6], 15, -1560198380), r = $36d0e3de07f3b68c$var$W(r, o, i, n, e[a + 13], 21, 1309151649), n = $36d0e3de07f3b68c$var$W(n, r, o, i, e[a + 4], 6, -145523070), i = $36d0e3de07f3b68c$var$W(i, n, r, o, e[a + 11], 10, -1120210379), o = $36d0e3de07f3b68c$var$W(o, i, n, r, e[a + 2], 15, 718787259), r = $36d0e3de07f3b68c$var$W(r, o, i, n, e[a + 9], 21, -343485551), n = $36d0e3de07f3b68c$var$z(n, s), r = $36d0e3de07f3b68c$var$z(r, c), o = $36d0e3de07f3b68c$var$z(o, u), i = $36d0e3de07f3b68c$var$z(i, l);
        }
        return [
            n,
            r,
            o,
            i
        ];
    }(function(e) {
        if (0 === e.length) return [];
        for(var t = 8 * e.length, n = new Uint32Array($36d0e3de07f3b68c$var$q(t)), r = 0; r < t; r += 8)n[r >> 5] |= (255 & e[r / 8]) << r % 32;
        return n;
    }(e), 8 * e.length));
}), $36d0e3de07f3b68c$var$X = $36d0e3de07f3b68c$var$G;
function $36d0e3de07f3b68c$var$Q(e, t, n, r) {
    switch(e){
        case 0:
            return t & n ^ ~t & r;
        case 1:
        case 3:
            return t ^ n ^ r;
        case 2:
            return t & n ^ t & r ^ n & r;
    }
}
function $36d0e3de07f3b68c$var$Y(e, t) {
    return e << t | e >>> 32 - t;
}
var $36d0e3de07f3b68c$var$Z = $36d0e3de07f3b68c$var$M("v5", 80, function(e) {
    var t = [
        1518500249,
        1859775393,
        2400959708,
        3395469782
    ], n = [
        1732584193,
        4023233417,
        2562383102,
        271733878,
        3285377520
    ];
    if ("string" == typeof e) {
        var r = unescape(encodeURIComponent(e));
        e = [];
        for(var o = 0; o < r.length; ++o)e.push(r.charCodeAt(o));
    } else Array.isArray(e) || (e = Array.prototype.slice.call(e));
    e.push(128);
    for(var i = e.length / 4 + 2, a = Math.ceil(i / 16), s = new Array(a), c = 0; c < a; ++c){
        for(var u = new Uint32Array(16), l = 0; l < 16; ++l)u[l] = e[64 * c + 4 * l] << 24 | e[64 * c + 4 * l + 1] << 16 | e[64 * c + 4 * l + 2] << 8 | e[64 * c + 4 * l + 3];
        s[c] = u;
    }
    s[a - 1][14] = 8 * (e.length - 1) / Math.pow(2, 32), s[a - 1][14] = Math.floor(s[a - 1][14]), s[a - 1][15] = 8 * (e.length - 1) & 4294967295;
    for(var d = 0; d < a; ++d){
        for(var f = new Uint32Array(80), g = 0; g < 16; ++g)f[g] = s[d][g];
        for(var v = 16; v < 80; ++v)f[v] = $36d0e3de07f3b68c$var$Y(f[v - 3] ^ f[v - 8] ^ f[v - 14] ^ f[v - 16], 1);
        for(var p = n[0], m = n[1], h = n[2], y = n[3], w = n[4], b = 0; b < 80; ++b){
            var k = Math.floor(b / 20), E = $36d0e3de07f3b68c$var$Y(p, 5) + $36d0e3de07f3b68c$var$Q(k, m, h, y) + w + t[k] + f[b] >>> 0;
            w = y, y = h, h = $36d0e3de07f3b68c$var$Y(m, 30) >>> 0, m = p, p = E;
        }
        n[0] = n[0] + p >>> 0, n[1] = n[1] + m >>> 0, n[2] = n[2] + h >>> 0, n[3] = n[3] + y >>> 0, n[4] = n[4] + w >>> 0;
    }
    return [
        n[0] >> 24 & 255,
        n[0] >> 16 & 255,
        n[0] >> 8 & 255,
        255 & n[0],
        n[1] >> 24 & 255,
        n[1] >> 16 & 255,
        n[1] >> 8 & 255,
        255 & n[1],
        n[2] >> 24 & 255,
        n[2] >> 16 & 255,
        n[2] >> 8 & 255,
        255 & n[2],
        n[3] >> 24 & 255,
        n[3] >> 16 & 255,
        n[3] >> 8 & 255,
        255 & n[3],
        n[4] >> 24 & 255,
        n[4] >> 16 & 255,
        n[4] >> 8 & 255,
        255 & n[4]
    ];
}), $36d0e3de07f3b68c$var$ee = $36d0e3de07f3b68c$var$Z;
var $36d0e3de07f3b68c$var$te = Object.freeze({
    __proto__: null,
    v1: function(e, t, n) {
        var r = t && n || 0, o = t || new Array(16), i = (e = e || {}).node || $36d0e3de07f3b68c$var$U, a = void 0 !== e.clockseq ? e.clockseq : $36d0e3de07f3b68c$var$A;
        if (null == i || null == a) {
            var s = e.random || (e.rng || $36d0e3de07f3b68c$var$T)();
            null == i && (i = $36d0e3de07f3b68c$var$U = [
                1 | s[0],
                s[1],
                s[2],
                s[3],
                s[4],
                s[5]
            ]), null == a && (a = $36d0e3de07f3b68c$var$A = 16383 & (s[6] << 8 | s[7]));
        }
        var c = void 0 !== e.msecs ? e.msecs : Date.now(), u = void 0 !== e.nsecs ? e.nsecs : $36d0e3de07f3b68c$var$V + 1, l = c - $36d0e3de07f3b68c$var$$ + (u - $36d0e3de07f3b68c$var$V) / 1e4;
        if (l < 0 && void 0 === e.clockseq && (a = a + 1 & 16383), (l < 0 || c > $36d0e3de07f3b68c$var$$) && void 0 === e.nsecs && (u = 0), u >= 1e4) throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
        $36d0e3de07f3b68c$var$$ = c, $36d0e3de07f3b68c$var$V = u, $36d0e3de07f3b68c$var$A = a;
        var d = (1e4 * (268435455 & (c += 122192928e5)) + u) % 4294967296;
        o[r++] = d >>> 24 & 255, o[r++] = d >>> 16 & 255, o[r++] = d >>> 8 & 255, o[r++] = 255 & d;
        var f = c / 4294967296 * 1e4 & 268435455;
        o[r++] = f >>> 8 & 255, o[r++] = 255 & f, o[r++] = f >>> 24 & 15 | 16, o[r++] = f >>> 16 & 255, o[r++] = a >>> 8 | 128, o[r++] = 255 & a;
        for(var g = 0; g < 6; ++g)o[r + g] = i[g];
        return t || $36d0e3de07f3b68c$var$N(o);
    },
    v3: $36d0e3de07f3b68c$var$X,
    v4: function(e, t, n) {
        var r = (e = e || {}).random || (e.rng || $36d0e3de07f3b68c$var$T)();
        if (r[6] = 15 & r[6] | 64, r[8] = 63 & r[8] | 128, t) {
            n = n || 0;
            for(var o = 0; o < 16; ++o)t[n + o] = r[o];
            return t;
        }
        return $36d0e3de07f3b68c$var$N(r);
    },
    v5: $36d0e3de07f3b68c$var$ee,
    NIL: "00000000-0000-0000-0000-000000000000",
    version: function(e) {
        if (!$36d0e3de07f3b68c$var$L(e)) throw TypeError("Invalid UUID");
        return parseInt(e.substr(14, 1), 16);
    },
    validate: $36d0e3de07f3b68c$var$L,
    stringify: $36d0e3de07f3b68c$var$N,
    parse: $36d0e3de07f3b68c$var$H
});
const $36d0e3de07f3b68c$var$ne = [
    "debug",
    "info",
    "warn",
    "error",
    "none"
];
var $36d0e3de07f3b68c$var$re = {
    commonBasicLogger: function(e, t) {
        if (e && e.destination && "function" != typeof e.destination) throw new Error("destination for basicLogger was set to a non-function");
        function n(e) {
            return function(t) {
                console && console[e] && console[e].call(console, t);
            };
        }
        const r = e && e.destination ? [
            e.destination,
            e.destination,
            e.destination,
            e.destination
        ] : [
            n("log"),
            n("info"),
            n("warn"),
            n("error")
        ], o = !(!e || !e.destination), i = e && void 0 !== e.prefix && null !== e.prefix ? e.prefix : "[LaunchDarkly] ";
        let a = 1;
        if (e && e.level) for(let t = 0; t < $36d0e3de07f3b68c$var$ne.length; t++)$36d0e3de07f3b68c$var$ne[t] === e.level && (a = t);
        function s(e, n, a) {
            if (a.length < 1) return;
            let s;
            const c = o ? n + ": " + i : i;
            if (1 !== a.length && t) {
                const e = [
                    ...a
                ];
                e[0] = c + e[0], s = t(...e);
            } else s = c + a[0];
            try {
                r[e](s);
            } catch (e) {
                console && console.log && console.log("[LaunchDarkly] Configured logger's " + n + " method threw an exception: " + e);
            }
        }
        const c = {};
        for(let e = 0; e < $36d0e3de07f3b68c$var$ne.length; e++){
            const t = $36d0e3de07f3b68c$var$ne[e];
            if ("none" !== t) {
                if (e < a) c[t] = ()=>{};
                else {
                    const n = e;
                    c[t] = function() {
                        s(n, t, arguments);
                    };
                }
            }
        }
        return c;
    },
    validateLogger: function(e) {
        $36d0e3de07f3b68c$var$ne.forEach((t)=>{
            if ("none" !== t && (!e[t] || "function" != typeof e[t])) throw new Error("Provided logger instance must support logger." + t + "(...) method");
        });
    }
};
function $36d0e3de07f3b68c$var$oe(e) {
    return e && e.message ? e.message : "string" == typeof e || e instanceof String ? e : JSON.stringify(e);
}
const $36d0e3de07f3b68c$var$ie = " Please see https://docs.launchdarkly.com/sdk/client-side/javascript#initialize-the-client for instructions on SDK initialization.";
var $36d0e3de07f3b68c$var$ae = {
    bootstrapInvalid: function() {
        return "LaunchDarkly bootstrap data is not available because the back end could not read the flags.";
    },
    bootstrapOldFormat: function() {
        return "LaunchDarkly client was initialized with bootstrap data that did not include flag metadata. Events may not be sent correctly." + $36d0e3de07f3b68c$var$ie;
    },
    clientInitialized: function() {
        return "LaunchDarkly client initialized";
    },
    clientNotReady: function() {
        return "LaunchDarkly client is not ready";
    },
    debugEnqueueingEvent: function(e) {
        return 'enqueueing "' + e + '" event';
    },
    debugPostingDiagnosticEvent: function(e) {
        return "sending diagnostic event (" + e.kind + ")";
    },
    debugPostingEvents: function(e) {
        return "sending " + e + " events";
    },
    debugStreamDelete: function(e) {
        return 'received streaming deletion for flag "' + e + '"';
    },
    debugStreamDeleteIgnored: function(e) {
        return 'received streaming deletion for flag "' + e + '" but ignored due to version check';
    },
    debugStreamPatch: function(e) {
        return 'received streaming update for flag "' + e + '"';
    },
    debugStreamPatchIgnored: function(e) {
        return 'received streaming update for flag "' + e + '" but ignored due to version check';
    },
    debugStreamPing: function() {
        return "received ping message from stream";
    },
    debugPolling: function(e) {
        return "polling for feature flags at " + e;
    },
    debugStreamPut: function() {
        return "received streaming update for all flags";
    },
    deprecated: function(e, t) {
        return t ? '"' + e + '" is deprecated, please use "' + t + '"' : '"' + e + '" is deprecated';
    },
    environmentNotFound: function() {
        return "Environment not found. Double check that you specified a valid environment/client-side ID." + $36d0e3de07f3b68c$var$ie;
    },
    environmentNotSpecified: function() {
        return "No environment/client-side ID was specified." + $36d0e3de07f3b68c$var$ie;
    },
    errorFetchingFlags: function(e) {
        return "Error fetching flag settings: " + $36d0e3de07f3b68c$var$oe(e);
    },
    eventCapacityExceeded: function() {
        return "Exceeded event queue capacity. Increase capacity to avoid dropping events.";
    },
    eventWithoutContext: function() {
        return "Be sure to call `identify` in the LaunchDarkly client: https://docs.launchdarkly.com/sdk/features/identify#javascript";
    },
    httpErrorMessage: function(e, t, n) {
        return "Received error " + e + (401 === e ? " (invalid SDK key)" : "") + " for " + t + " - " + ($36d0e3de07f3b68c$var$s.isHttpErrorRecoverable(e) ? n : "giving up permanently");
    },
    httpUnavailable: function() {
        return "Cannot make HTTP requests in this environment." + $36d0e3de07f3b68c$var$ie;
    },
    identifyDisabled: function() {
        return "identify() has no effect here; it must be called on the main client instance";
    },
    inspectorMethodError: (e, t)=>`an inspector: "${t}" of type: "${e}" generated an exception`,
    invalidContentType: function(e) {
        return 'Expected application/json content type but got "' + e + '"';
    },
    invalidData: function() {
        return "Invalid data received from LaunchDarkly; connection may have been interrupted";
    },
    invalidInspector: (e, t)=>`an inspector: "${t}" of an invalid type (${e}) was configured`,
    invalidKey: function() {
        return "Event key must be a string";
    },
    invalidMetricValue: (e)=>`The track function was called with a non-numeric "metricValue" (${e}), only numeric metric values are supported.`,
    invalidContext: function() {
        return "Invalid context specified." + $36d0e3de07f3b68c$var$ie;
    },
    invalidTagValue: (e)=>`Config option "${e}" must only contain letters, numbers, ., _ or -.`,
    localStorageUnavailable: function(e) {
        return "local storage is unavailable: " + $36d0e3de07f3b68c$var$oe(e);
    },
    networkError: (e)=>"network error" + (e ? " (" + e + ")" : ""),
    optionBelowMinimum: (e, t, n)=>'Config option "' + e + '" was set to ' + t + ", changing to minimum value of " + n,
    streamClosing: function() {
        return "Closing stream connection";
    },
    streamConnecting: function(e) {
        return "Opening stream connection to " + e;
    },
    streamError: function(e, t) {
        return "Error on stream connection: " + $36d0e3de07f3b68c$var$oe(e) + ", will continue retrying after " + t + " milliseconds.";
    },
    tagValueTooLong: (e)=>`Value of "${e}" was longer than 64 characters and was discarded.`,
    unknownCustomEventKey: function(e) {
        return 'Custom event "' + e + '" does not exist';
    },
    unknownOption: (e)=>'Ignoring unknown config option "' + e + '"',
    contextNotSpecified: function() {
        return "No context specified." + $36d0e3de07f3b68c$var$ie;
    },
    unrecoverableStreamError: (e)=>`Error on stream connection ${$36d0e3de07f3b68c$var$oe(e)}, giving up permanently`,
    wrongOptionType: (e, t, n)=>'Config option "' + e + '" should be of type ' + t + ", got " + n + ", using default value",
    wrongOptionTypeBoolean: (e, t)=>'Config option "' + e + '" should be a boolean, got ' + t + ", converting to boolean"
};
const { validateLogger: $36d0e3de07f3b68c$var$se } = $36d0e3de07f3b68c$var$re, $36d0e3de07f3b68c$var$ce = {
    baseUrl: {
        default: "https://app.launchdarkly.com"
    },
    streamUrl: {
        default: "https://clientstream.launchdarkly.com"
    },
    eventsUrl: {
        default: "https://events.launchdarkly.com"
    },
    sendEvents: {
        default: !0
    },
    streaming: {
        type: "boolean"
    },
    sendLDHeaders: {
        default: !0
    },
    requestHeaderTransform: {
        type: "function"
    },
    sendEventsOnlyForVariation: {
        default: !1
    },
    useReport: {
        default: !1
    },
    evaluationReasons: {
        default: !1
    },
    eventCapacity: {
        default: 100,
        minimum: 1
    },
    flushInterval: {
        default: 2e3,
        minimum: 2e3
    },
    samplingInterval: {
        default: 0,
        minimum: 0
    },
    streamReconnectDelay: {
        default: 1e3,
        minimum: 0
    },
    allAttributesPrivate: {
        default: !1
    },
    privateAttributes: {
        default: []
    },
    bootstrap: {
        type: "string|object"
    },
    diagnosticRecordingInterval: {
        default: 9e5,
        minimum: 2e3
    },
    diagnosticOptOut: {
        default: !1
    },
    wrapperName: {
        type: "string"
    },
    wrapperVersion: {
        type: "string"
    },
    stateProvider: {
        type: "object"
    },
    application: {
        validator: function(e, t, n) {
            const r = {};
            t.id && (r.id = $36d0e3de07f3b68c$var$de(`${e}.id`, t.id, n));
            t.version && (r.version = $36d0e3de07f3b68c$var$de(`${e}.version`, t.version, n));
            return r;
        }
    },
    inspectors: {
        default: []
    },
    hooks: {
        default: []
    },
    plugins: {
        default: []
    }
}, $36d0e3de07f3b68c$var$ue = /^(\w|\.|-)+$/;
function $36d0e3de07f3b68c$var$le(e) {
    return e && e.replace(/\/+$/, "");
}
function $36d0e3de07f3b68c$var$de(e, t, n) {
    if ("string" == typeof t && t.match($36d0e3de07f3b68c$var$ue)) {
        if (!(t.length > 64)) return t;
        n.warn($36d0e3de07f3b68c$var$ae.tagValueTooLong(e));
    } else n.warn($36d0e3de07f3b68c$var$ae.invalidTagValue(e));
}
var $36d0e3de07f3b68c$var$fe = {
    baseOptionDefs: $36d0e3de07f3b68c$var$ce,
    validate: function(e, t, n, r) {
        const o = $36d0e3de07f3b68c$var$S.extend({
            logger: {
                default: r
            }
        }, $36d0e3de07f3b68c$var$ce, n), i = {};
        function a(e) {
            $36d0e3de07f3b68c$var$S.onNextTick(()=>{
                t && t.maybeReportError(new $36d0e3de07f3b68c$var$s.LDInvalidArgumentError(e));
            });
        }
        let c = $36d0e3de07f3b68c$var$S.extend({}, e || {});
        return function(e) {
            const t = e;
            Object.keys(i).forEach((e)=>{
                if (void 0 !== t[e]) {
                    const n = i[e];
                    r && r.warn($36d0e3de07f3b68c$var$ae.deprecated(e, n)), n && (void 0 === t[n] && (t[n] = t[e]), delete t[e]);
                }
            });
        }(c), c = function(e) {
            const t = $36d0e3de07f3b68c$var$S.extend({}, e);
            return Object.keys(o).forEach((e)=>{
                void 0 !== t[e] && null !== t[e] || (t[e] = o[e] && o[e].default);
            }), t;
        }(c), c = function(e) {
            const t = $36d0e3de07f3b68c$var$S.extend({}, e), n = (e)=>{
                if (null === e) return "any";
                if (void 0 === e) return;
                if (Array.isArray(e)) return "array";
                const t = typeof e;
                return "boolean" === t || "string" === t || "number" === t || "function" === t ? t : "object";
            };
            return Object.keys(e).forEach((i)=>{
                const s = e[i];
                if (null != s) {
                    const c = o[i];
                    if (void 0 === c) a($36d0e3de07f3b68c$var$ae.unknownOption(i));
                    else {
                        const o = c.type || n(c.default), u = c.validator;
                        if (u) {
                            const n = u(i, e[i], r);
                            void 0 !== n ? t[i] = n : delete t[i];
                        } else if ("any" !== o) {
                            const e = o.split("|"), r = n(s);
                            e.indexOf(r) < 0 ? "boolean" === o ? (t[i] = !!s, a($36d0e3de07f3b68c$var$ae.wrongOptionTypeBoolean(i, r))) : (a($36d0e3de07f3b68c$var$ae.wrongOptionType(i, o, r)), t[i] = c.default) : "number" === r && void 0 !== c.minimum && s < c.minimum && (a($36d0e3de07f3b68c$var$ae.optionBelowMinimum(i, s, c.minimum)), t[i] = c.minimum);
                        }
                    }
                }
            }), t.baseUrl = $36d0e3de07f3b68c$var$le(t.baseUrl), t.streamUrl = $36d0e3de07f3b68c$var$le(t.streamUrl), t.eventsUrl = $36d0e3de07f3b68c$var$le(t.eventsUrl), t;
        }(c), $36d0e3de07f3b68c$var$se(c.logger), c;
    },
    getTags: function(e) {
        const t = {};
        return e && (e.application && void 0 !== e.application.id && null !== e.application.id && (t["application-id"] = [
            e.application.id
        ]), e.application && void 0 !== e.application.version && null !== e.application.id && (t["application-version"] = [
            e.application.version
        ])), t;
    }
};
const { getLDUserAgentString: $36d0e3de07f3b68c$var$ge } = $36d0e3de07f3b68c$var$S;
var $36d0e3de07f3b68c$var$ve = {
    getLDHeaders: function(e, t) {
        if (t && !t.sendLDHeaders) return {};
        const n = {};
        n[e.userAgentHeaderName || "User-Agent"] = $36d0e3de07f3b68c$var$ge(e), t && t.wrapperName && (n["X-LaunchDarkly-Wrapper"] = t.wrapperVersion ? t.wrapperName + "/" + t.wrapperVersion : t.wrapperName);
        const r = $36d0e3de07f3b68c$var$fe.getTags(t), o = Object.keys(r);
        return o.length && (n["x-launchdarkly-tags"] = o.sort().map((e)=>Array.isArray(r[e]) ? r[e].sort().map((t)=>`${e}/${t}`) : [
                `${e}/${r[e]}`
            ]).reduce((e, t)=>e.concat(t), []).join(" ")), n;
    },
    transformHeaders: function(e, t) {
        return t && t.requestHeaderTransform ? t.requestHeaderTransform({
            ...e
        }) : e;
    }
};
const { v1: $36d0e3de07f3b68c$var$pe } = $36d0e3de07f3b68c$var$te, { getLDHeaders: $36d0e3de07f3b68c$var$me, transformHeaders: $36d0e3de07f3b68c$var$he } = $36d0e3de07f3b68c$var$ve;
var $36d0e3de07f3b68c$var$ye = function(e, t, n) {
    const r = $36d0e3de07f3b68c$var$S.extend({
        "Content-Type": "application/json"
    }, $36d0e3de07f3b68c$var$me(e, n)), o = {};
    return o.sendEvents = (t, o, i)=>{
        if (!e.httpRequest) return Promise.resolve();
        const a = JSON.stringify(t), c = i ? null : $36d0e3de07f3b68c$var$pe();
        return (function t(u) {
            const l = i ? r : $36d0e3de07f3b68c$var$S.extend({}, r, {
                "X-LaunchDarkly-Event-Schema": "4",
                "X-LaunchDarkly-Payload-ID": c
            });
            return e.httpRequest("POST", o, $36d0e3de07f3b68c$var$he(l, n), a).promise.then((e)=>{
                if (e) return e.status >= 400 && $36d0e3de07f3b68c$var$s.isHttpErrorRecoverable(e.status) && u ? t(!1) : function(e) {
                    const t = {
                        status: e.status
                    }, n = e.header("date");
                    if (n) {
                        const e = Date.parse(n);
                        e && (t.serverTime = e);
                    }
                    return t;
                }(e);
            }).catch(()=>u ? t(!1) : Promise.reject());
        })(!0).catch(()=>{});
    }, o;
};
var $36d0e3de07f3b68c$var$we = function e(t, n = []) {
    if (null === t || "object" != typeof t) return JSON.stringify(t);
    if (n.includes(t)) throw new Error("Cycle detected");
    if (Array.isArray(t)) return `[${t.map((r)=>e(r, [
            ...n,
            t
        ])).map((e)=>void 0 === e ? "null" : e).join(",")}]`;
    return `{${Object.keys(t).sort().map((r)=>{
        const o = e(t[r], [
            ...n,
            t
        ]);
        if (void 0 !== o) return `${JSON.stringify(r)}:${o}`;
    }).filter((e)=>void 0 !== e).join(",")}}`;
};
const { commonBasicLogger: $36d0e3de07f3b68c$var$be } = $36d0e3de07f3b68c$var$re;
function $36d0e3de07f3b68c$var$ke(e) {
    return "string" == typeof e && "kind" !== e && e.match(/^(\w|\.|-)+$/);
}
function $36d0e3de07f3b68c$var$Ee(e) {
    return e.includes("%") || e.includes(":") ? e.replace(/%/g, "%25").replace(/:/g, "%3A") : e;
}
var $36d0e3de07f3b68c$var$De = {
    checkContext: function(e, t) {
        if (e) {
            if (t && (void 0 === e.kind || null === e.kind)) return void 0 !== e.key && null !== e.key;
            const n = e.key, r = void 0 === e.kind ? "user" : e.kind, o = $36d0e3de07f3b68c$var$ke(r), i = "multi" === r || null != n && "" !== n;
            if ("multi" === r) {
                const t = Object.keys(e).filter((e)=>"kind" !== e);
                return i && t.every((e)=>$36d0e3de07f3b68c$var$ke(e)) && t.every((t)=>{
                    const n = e[t].key;
                    return null != n && "" !== n;
                });
            }
            return i && o;
        }
        return !1;
    },
    getContextKeys: function(e, t = $36d0e3de07f3b68c$var$be()) {
        if (!e) return;
        const n = {}, { kind: r, key: o } = e;
        switch(r){
            case void 0:
                n.user = `${o}`;
                break;
            case "multi":
                Object.entries(e).filter(([e])=>"kind" !== e).forEach(([e, t])=>{
                    t && t.key && (n[e] = t.key);
                });
                break;
            case null:
                t.warn(`null is not a valid context kind: ${e}`);
                break;
            case "":
                t.warn(`'' is not a valid context kind: ${e}`);
                break;
            default:
                n[r] = `${o}`;
        }
        return n;
    },
    getContextKinds: function(e) {
        return e ? null === e.kind || void 0 === e.kind ? [
            "user"
        ] : "multi" !== e.kind ? [
            e.kind
        ] : Object.keys(e).filter((e)=>"kind" !== e) : [];
    },
    getCanonicalKey: function(e) {
        if (e) {
            if ((void 0 === e.kind || null === e.kind || "user" === e.kind) && e.key) return e.key;
            if ("multi" !== e.kind && e.key) return `${e.kind}:${$36d0e3de07f3b68c$var$Ee(e.key)}`;
            if ("multi" === e.kind) return Object.keys(e).sort().filter((e)=>"kind" !== e).map((t)=>`${t}:${$36d0e3de07f3b68c$var$Ee(e[t].key)}`).join(":");
        }
    }
};
const { getContextKinds: $36d0e3de07f3b68c$var$xe } = $36d0e3de07f3b68c$var$De;
var $36d0e3de07f3b68c$var$Oe = function() {
    const e = {};
    let t = 0, n = 0, r = {}, o = {};
    return e.summarizeEvent = (e)=>{
        if ("feature" === e.kind) {
            const i = e.key + ":" + (null !== e.variation && void 0 !== e.variation ? e.variation : "") + ":" + (null !== e.version && void 0 !== e.version ? e.version : ""), a = r[i];
            let s = o[e.key];
            s || (s = new Set, o[e.key] = s), (function(e) {
                return e.context ? $36d0e3de07f3b68c$var$xe(e.context) : e.contextKeys ? Object.keys(e.contextKeys) : [];
            })(e).forEach((e)=>s.add(e)), a ? a.count = a.count + 1 : r[i] = {
                count: 1,
                key: e.key,
                version: e.version,
                variation: e.variation,
                value: e.value,
                default: e.default
            }, (0 === t || e.creationDate < t) && (t = e.creationDate), e.creationDate > n && (n = e.creationDate);
        }
    }, e.getSummary = ()=>{
        const e = {};
        let i = !0;
        for (const t of Object.values(r)){
            let n = e[t.key];
            n || (n = {
                default: t.default,
                counters: [],
                contextKinds: [
                    ...o[t.key]
                ]
            }, e[t.key] = n);
            const r = {
                value: t.value,
                count: t.count
            };
            void 0 !== t.variation && null !== t.variation && (r.variation = t.variation), void 0 !== t.version && null !== t.version ? r.version = t.version : r.unknown = !0, n.counters.push(r), i = !1;
        }
        return i ? null : {
            startDate: t,
            endDate: n,
            features: e,
            kind: "summary"
        };
    }, e.clearSummary = ()=>{
        t = 0, n = 0, r = {}, o = {};
    }, e;
};
var $36d0e3de07f3b68c$var$Ce = function(e) {
    let t = {}, n = {};
    return {
        summarizeEvent: function(e) {
            if ("feature" === e.kind) {
                const r = $36d0e3de07f3b68c$var$we(e.context);
                if (!r) return;
                let o = t[r];
                o || (t[r] = $36d0e3de07f3b68c$var$Oe(), o = t[r], n[r] = e.context), o.summarizeEvent(e);
            }
        },
        getSummaries: function() {
            const r = t, o = n;
            return t = {}, n = {}, Object.entries(r).map(([t, n])=>{
                const r = n.getSummary();
                return r.context = e.filter(o[t]), r;
            });
        }
    };
};
function $36d0e3de07f3b68c$var$Pe(e) {
    return e.replace(/~/g, "~0").replace(/\//g, "~1");
}
function $36d0e3de07f3b68c$var$Se(e) {
    return (e.startsWith("/") ? e.substring(1) : e).split("/").map((e)=>e.indexOf("~") >= 0 ? e.replace(/~1/g, "/").replace(/~0/g, "~") : e);
}
function $36d0e3de07f3b68c$var$Ie(e) {
    return !e.startsWith("/");
}
function $36d0e3de07f3b68c$var$Te(e, t) {
    const n = $36d0e3de07f3b68c$var$Ie(e), r = $36d0e3de07f3b68c$var$Ie(t);
    if (n && r) return e === t;
    if (n) {
        const n = $36d0e3de07f3b68c$var$Se(t);
        return 1 === n.length && e === n[0];
    }
    if (r) {
        const n = $36d0e3de07f3b68c$var$Se(e);
        return 1 === n.length && t === n[0];
    }
    return e === t;
}
function $36d0e3de07f3b68c$var$Fe(e) {
    return `/${$36d0e3de07f3b68c$var$Pe(e)}`;
}
var $36d0e3de07f3b68c$var$Le = {
    cloneExcluding: function(e, t) {
        const n = [], r = {}, o = [];
        for(n.push(...Object.keys(e).map((t)=>({
                key: t,
                ptr: $36d0e3de07f3b68c$var$Fe(t),
                source: e,
                parent: r,
                visited: [
                    e
                ]
            }))); n.length;){
            const e = n.pop();
            if (t.some((t)=>$36d0e3de07f3b68c$var$Te(t, e.ptr))) o.push(e.ptr);
            else {
                const t = e.source[e.key];
                if (null === t) e.parent[e.key] = t;
                else if (Array.isArray(t)) e.parent[e.key] = [
                    ...t
                ];
                else if ("object" == typeof t) {
                    if (e.visited.includes(t)) continue;
                    e.parent[e.key] = {}, n.push(...Object.keys(t).map((n)=>{
                        var r, o;
                        return {
                            key: n,
                            ptr: (r = e.ptr, o = $36d0e3de07f3b68c$var$Pe(n), `${r}/${o}`),
                            source: t,
                            parent: e.parent[e.key],
                            visited: [
                                ...e.visited,
                                t
                            ]
                        };
                    }));
                } else e.parent[e.key] = t;
            }
        }
        return {
            cloned: r,
            excluded: o.sort()
        };
    },
    compare: $36d0e3de07f3b68c$var$Te,
    literalToReference: $36d0e3de07f3b68c$var$Fe
};
var $36d0e3de07f3b68c$var$Ue = function(e) {
    const t = {}, n = e.allAttributesPrivate, r = e.privateAttributes || [], o = [
        "key",
        "kind",
        "_meta",
        "anonymous"
    ], i = [
        "name",
        "ip",
        "firstName",
        "lastName",
        "email",
        "avatar",
        "country"
    ], a = (e, t)=>{
        if ("object" != typeof e || null === e || Array.isArray(e)) return;
        const { cloned: i, excluded: a } = $36d0e3de07f3b68c$var$Le.cloneExcluding(e, ((e, t)=>(n || t && e.anonymous ? Object.keys(e) : [
                ...r,
                ...e._meta && e._meta.privateAttributes || []
            ]).filter((e)=>!o.some((t)=>$36d0e3de07f3b68c$var$Le.compare(e, t))))(e, t));
        return i.key = String(i.key), a.length && (i._meta || (i._meta = {}), i._meta.redactedAttributes = a), i._meta && (delete i._meta.privateAttributes, 0 === Object.keys(i._meta).length && delete i._meta), void 0 !== i.anonymous && (i.anonymous = !!i.anonymous), i;
    };
    return t.filter = (e, t = !1)=>void 0 === e.kind || null === e.kind ? a(((e)=>{
            const t = {
                ...e.custom || {},
                kind: "user",
                key: e.key
            };
            void 0 !== e.anonymous && (t.anonymous = !!e.anonymous);
            for (const n of i)delete t[n], void 0 !== e[n] && null !== e[n] && (t[n] = String(e[n]));
            return void 0 !== e.privateAttributeNames && null !== e.privateAttributeNames && (t._meta = t._meta || {}, t._meta.privateAttributes = e.privateAttributeNames.map((e)=>e.startsWith("/") ? $36d0e3de07f3b68c$var$Le.literalToReference(e) : e)), t;
        })(e), t) : "multi" === e.kind ? ((e, t)=>{
            const n = {
                kind: e.kind
            }, r = Object.keys(e);
            for (const o of r)if ("kind" !== o) {
                const r = a(e[o], t);
                r && (n[o] = r);
            }
            return n;
        })(e, t) : a(e, t), t;
};
const { getContextKeys: $36d0e3de07f3b68c$var$Ae } = $36d0e3de07f3b68c$var$De;
var $36d0e3de07f3b68c$var$je = function(e, t, n, r = null, o = null, i = null) {
    const a = {}, c = i || $36d0e3de07f3b68c$var$ye(e, n, t), u = $36d0e3de07f3b68c$var$S.appendUrlPath(t.eventsUrl, "/events/bulk/" + n), l = $36d0e3de07f3b68c$var$Ue(t), d = $36d0e3de07f3b68c$var$Ce(l), f = t.samplingInterval, g = t.eventCapacity, v = t.flushInterval, p = t.logger;
    let m, h = [], y = 0, w = !1, b = !1;
    function k() {
        return 0 === f || 0 === Math.floor(Math.random() * f);
    }
    function E(e) {
        const t = $36d0e3de07f3b68c$var$S.extend({}, e);
        return "identify" === e.kind || "feature" === e.kind || "custom" === e.kind ? t.context = l.filter(e.context) : (t.contextKeys = $36d0e3de07f3b68c$var$Ae(e.context, p), delete t.context), "feature" === e.kind && (delete t.trackEvents, delete t.debugEventsUntilDate), t;
    }
    function D(e) {
        h.length < g ? (h.push(e), b = !1) : (b || (b = !0, p.warn($36d0e3de07f3b68c$var$ae.eventCapacityExceeded())), r && r.incrementDroppedEvents());
    }
    return a.enqueue = function(e) {
        if (w) return;
        let t = !1, n = !1;
        var r;
        if (d.summarizeEvent(e), "feature" === e.kind ? k() && (t = !!e.trackEvents, n = !!(r = e).debugEventsUntilDate && r.debugEventsUntilDate > y && r.debugEventsUntilDate > (new Date).getTime()) : t = k(), t && D(E(e)), n) {
            const t = $36d0e3de07f3b68c$var$S.extend({}, e, {
                kind: "debug"
            });
            t.context = l.filter(t.context), delete t.trackEvents, delete t.debugEventsUntilDate, D(t);
        }
    }, a.flush = async function() {
        if (w) return Promise.resolve();
        const e = h;
        return d.getSummaries().forEach((t)=>{
            Object.keys(t.features).length && e.push(t);
        }), r && r.setEventsInLastBatch(e.length), 0 === e.length ? Promise.resolve() : (h = [], p.debug($36d0e3de07f3b68c$var$ae.debugPostingEvents(e.length)), c.sendEvents(e, u).then((e)=>{
            e && (e.serverTime && (y = e.serverTime), $36d0e3de07f3b68c$var$s.isHttpErrorRecoverable(e.status) || (w = !0), e.status >= 400 && $36d0e3de07f3b68c$var$S.onNextTick(()=>{
                o.maybeReportError(new $36d0e3de07f3b68c$var$s.LDUnexpectedResponseError($36d0e3de07f3b68c$var$ae.httpErrorMessage(e.status, "event posting", "some events were dropped")));
            }));
        }));
    }, a.start = function() {
        const e = ()=>{
            a.flush(), m = setTimeout(e, v);
        };
        m = setTimeout(e, v);
    }, a.stop = function() {
        clearTimeout(m);
    }, a;
};
var $36d0e3de07f3b68c$var$Re = function(e) {
    const t = {}, n = {};
    return t.on = function(e, t, r) {
        n[e] = n[e] || [], n[e] = n[e].concat({
            handler: t,
            context: r
        });
    }, t.off = function(e, t, r) {
        if (n[e]) for(let o = 0; o < n[e].length; o++)n[e][o].handler === t && n[e][o].context === r && (n[e] = n[e].slice(0, o).concat(n[e].slice(o + 1)));
    }, t.emit = function(e) {
        if (!n[e]) return;
        const t = n[e].slice(0);
        for(let e = 0; e < t.length; e++)t[e].handler.apply(t[e].context, Array.prototype.slice.call(arguments, 1));
    }, t.getEvents = function() {
        return Object.keys(n);
    }, t.getEventListenerCount = function(e) {
        return n[e] ? n[e].length : 0;
    }, t.maybeReportError = function(t) {
        t && (n["error"] ? this.emit("error", t) : (e || console).error(t.message));
    }, t;
};
const $36d0e3de07f3b68c$var$Ne = "ready", $36d0e3de07f3b68c$var$$e = "initialized", $36d0e3de07f3b68c$var$Ve = "failed";
var $36d0e3de07f3b68c$var$He = function(e) {
    let t = !1, n = !1, r = null, o = null;
    const i = new Promise((t)=>{
        const n = ()=>{
            e.off($36d0e3de07f3b68c$var$Ne, n), t();
        };
        e.on($36d0e3de07f3b68c$var$Ne, n);
    }).catch(()=>{});
    return {
        getInitializationPromise: ()=>o || (t ? Promise.resolve() : n ? Promise.reject(r) : (o = new Promise((t, n)=>{
                const r = ()=>{
                    e.off($36d0e3de07f3b68c$var$$e, r), t();
                }, o = (t)=>{
                    e.off($36d0e3de07f3b68c$var$Ve, o), n(t);
                };
                e.on($36d0e3de07f3b68c$var$$e, r), e.on($36d0e3de07f3b68c$var$Ve, o);
            }), o)),
        getReadyPromise: ()=>i,
        signalSuccess: ()=>{
            t || n || (t = !0, e.emit($36d0e3de07f3b68c$var$$e), e.emit($36d0e3de07f3b68c$var$Ne));
        },
        signalFailure: (o)=>{
            t || n || (n = !0, r = o, e.emit($36d0e3de07f3b68c$var$Ve, o), e.emit($36d0e3de07f3b68c$var$Ne)), e.maybeReportError(o);
        }
    };
};
var $36d0e3de07f3b68c$var$Me = function(e, t, n, r) {
    const o = {};
    function i() {
        let e = "";
        const o = r.getContext();
        return o && (e = n || $36d0e3de07f3b68c$var$S.btoa(JSON.stringify(o))), "ld:" + t + ":" + e;
    }
    return o.loadFlags = ()=>e.get(i()).then((e)=>{
            if (null == e) return null;
            try {
                let t = JSON.parse(e);
                if (t) {
                    const e = t.$schema;
                    void 0 === e || e < 1 ? t = $36d0e3de07f3b68c$var$S.transformValuesToVersionedValues(t) : delete t.$schema;
                }
                return t;
            } catch (e) {
                return o.clearFlags().then(()=>null);
            }
        }), o.saveFlags = (t)=>{
        const n = $36d0e3de07f3b68c$var$S.extend({}, t, {
            $schema: 1
        });
        return e.set(i(), JSON.stringify(n));
    }, o.clearFlags = ()=>e.clear(i()), o;
};
var $36d0e3de07f3b68c$var$qe = function(e, t) {
    const n = {};
    let r = !1;
    const o = (e)=>{
        r || (r = !0, t.warn($36d0e3de07f3b68c$var$ae.localStorageUnavailable(e)));
    };
    return n.isEnabled = ()=>!!e, n.get = (t)=>new Promise((n)=>{
            e ? e.get(t).then(n).catch((e)=>{
                o(e), n(void 0);
            }) : n(void 0);
        }), n.set = (t, n)=>new Promise((r)=>{
            e ? e.set(t, n).then(()=>r(!0)).catch((e)=>{
                o(e), r(!1);
            }) : r(!1);
        }), n.clear = (t)=>new Promise((n)=>{
            e ? e.clear(t).then(()=>n(!0)).catch((e)=>{
                o(e), n(!1);
            }) : n(!1);
        }), n;
};
const { appendUrlPath: $36d0e3de07f3b68c$var$ze, base64URLEncode: $36d0e3de07f3b68c$var$Ke, objectHasOwnProperty: $36d0e3de07f3b68c$var$_e } = $36d0e3de07f3b68c$var$S, { getLDHeaders: $36d0e3de07f3b68c$var$Je, transformHeaders: $36d0e3de07f3b68c$var$Be } = $36d0e3de07f3b68c$var$ve, { isHttpErrorRecoverable: $36d0e3de07f3b68c$var$We } = $36d0e3de07f3b68c$var$s;
var $36d0e3de07f3b68c$var$Ge = function(e, t, n, r) {
    const o = t.streamUrl, i = t.logger, a = {}, s = $36d0e3de07f3b68c$var$ze(o, "/eval/" + n), c = t.useReport, u = t.evaluationReasons, l = t.streamReconnectDelay, d = $36d0e3de07f3b68c$var$Je(e, t);
    let f, g = !1, v = null, p = null, m = null, h = null, y = null, w = 0;
    function b() {
        const e = (t = function() {
            const e = l * Math.pow(2, w);
            return e > 3e4 ? 3e4 : e;
        }(), t - Math.trunc(.5 * Math.random() * t));
        var t;
        return w += 1, e;
    }
    function k(e) {
        if (e.status && "number" == typeof e.status && !$36d0e3de07f3b68c$var$We(e.status)) return x(), i.error($36d0e3de07f3b68c$var$ae.unrecoverableStreamError(e)), void (p && (clearTimeout(p), p = null));
        const t = b();
        g || (i.warn($36d0e3de07f3b68c$var$ae.streamError(e, t)), g = !0), O(!1), x(), E(t);
    }
    function E(e) {
        p || (e ? p = setTimeout(D, e) : D());
    }
    function D() {
        let r;
        p = null;
        let a = "";
        const l = {
            headers: d,
            readTimeoutMillis: 3e5
        };
        if (e.eventSourceFactory) {
            null != h && (a = "h=" + h), c ? e.eventSourceAllowsReport ? (r = s, l.method = "REPORT", l.headers["Content-Type"] = "application/json", l.body = JSON.stringify(m)) : (r = $36d0e3de07f3b68c$var$ze(o, "/ping/" + n), a = "") : r = s + "/" + $36d0e3de07f3b68c$var$Ke(JSON.stringify(m)), l.headers = $36d0e3de07f3b68c$var$Be(l.headers, t), u && (a = a + (a ? "&" : "") + "withReasons=true"), r = r + (a ? "?" : "") + a, x(), i.info($36d0e3de07f3b68c$var$ae.streamConnecting(r)), f = (new Date).getTime(), v = e.eventSourceFactory(r, l);
            for(const e in y)$36d0e3de07f3b68c$var$_e(y, e) && v.addEventListener(e, y[e]);
            v.onerror = k, v.onopen = ()=>{
                w = 0;
            };
        }
    }
    function x() {
        v && (i.info($36d0e3de07f3b68c$var$ae.streamClosing()), v.close(), v = null);
    }
    function O(e) {
        f && r && r.recordStreamInit(f, !e, (new Date).getTime() - f), f = null;
    }
    return a.connect = function(e, t, n) {
        m = e, h = t, y = {};
        for(const e in n || {})y[e] = function(t) {
            g = !1, O(!0), n[e] && n[e](t);
        };
        E();
    }, a.disconnect = function() {
        clearTimeout(p), p = null, x();
    }, a.isConnected = function() {
        return !!(v && e.eventSourceIsActive && e.eventSourceIsActive(v));
    }, a;
};
var $36d0e3de07f3b68c$var$Xe = function(e) {
    let t, n, r, o;
    const i = {
        addPromise: (i, a)=>{
            t = i, n && n(), n = a, i.then((n)=>{
                t === i && (r(n), e && e());
            }, (n)=>{
                t === i && (o(n), e && e());
            });
        }
    };
    return i.resultPromise = new Promise((e, t)=>{
        r = e, o = t;
    }), i;
};
const { transformHeaders: $36d0e3de07f3b68c$var$Qe, getLDHeaders: $36d0e3de07f3b68c$var$Ye } = $36d0e3de07f3b68c$var$ve, $36d0e3de07f3b68c$var$Ze = "application/json";
var $36d0e3de07f3b68c$var$et = function(e, t, n) {
    const r = t.baseUrl, o = t.useReport, i = t.evaluationReasons, a = t.logger, c = {}, u = {};
    function l(n, r) {
        if (!e.httpRequest) return new Promise((e, t)=>{
            t(new $36d0e3de07f3b68c$var$s.LDFlagFetchError($36d0e3de07f3b68c$var$ae.httpUnavailable()));
        });
        const o = r ? "REPORT" : "GET", i = $36d0e3de07f3b68c$var$Ye(e, t);
        r && (i["Content-Type"] = $36d0e3de07f3b68c$var$Ze);
        let a = u[n];
        a || (a = $36d0e3de07f3b68c$var$Xe(()=>{
            delete u[n];
        }), u[n] = a);
        const c = e.httpRequest(o, n, $36d0e3de07f3b68c$var$Qe(i, t), r), l = c.promise.then((e)=>{
            if (200 === e.status) {
                if (e.header("content-type") && e.header("content-type").substring(0, 16) === $36d0e3de07f3b68c$var$Ze) return JSON.parse(e.body);
                {
                    const t = $36d0e3de07f3b68c$var$ae.invalidContentType(e.header("content-type") || "");
                    return Promise.reject(new $36d0e3de07f3b68c$var$s.LDFlagFetchError(t));
                }
            }
            return Promise.reject(function(e) {
                return 404 === e.status ? new $36d0e3de07f3b68c$var$s.LDInvalidEnvironmentIdError($36d0e3de07f3b68c$var$ae.environmentNotFound()) : new $36d0e3de07f3b68c$var$s.LDFlagFetchError($36d0e3de07f3b68c$var$ae.errorFetchingFlags(e.statusText || String(e.status)));
            }(e));
        }, (e)=>Promise.reject(new $36d0e3de07f3b68c$var$s.LDFlagFetchError($36d0e3de07f3b68c$var$ae.networkError(e))));
        return a.addPromise(l, ()=>{
            c.cancel && c.cancel();
        }), a.resultPromise;
    }
    return c.fetchJSON = function(e) {
        return l($36d0e3de07f3b68c$var$S.appendUrlPath(r, e), null);
    }, c.fetchFlagSettings = function(e, t) {
        let s, c, u, d = "";
        return o ? (c = [
            r,
            "/sdk/evalx/",
            n,
            "/context"
        ].join(""), u = JSON.stringify(e)) : (s = $36d0e3de07f3b68c$var$S.base64URLEncode(JSON.stringify(e)), c = [
            r,
            "/sdk/evalx/",
            n,
            "/contexts/",
            s
        ].join("")), t && (d = "h=" + t), i && (d = d + (d ? "&" : "") + "withReasons=true"), c = c + (d ? "?" : "") + d, a.debug($36d0e3de07f3b68c$var$ae.debugPolling(c)), l(c, u);
    }, c;
};
var $36d0e3de07f3b68c$var$tt = function(e, t) {
    const n = {};
    let r;
    return n.setContext = function(e) {
        r = $36d0e3de07f3b68c$var$S.sanitizeContext(e), r && t && t($36d0e3de07f3b68c$var$S.clone(r));
    }, n.getContext = function() {
        return r ? $36d0e3de07f3b68c$var$S.clone(r) : null;
    }, e && n.setContext(e), n;
};
const { v1: $36d0e3de07f3b68c$var$nt } = $36d0e3de07f3b68c$var$te, { getContextKinds: $36d0e3de07f3b68c$var$rt } = $36d0e3de07f3b68c$var$De;
var $36d0e3de07f3b68c$var$ot = function(e) {
    function t(e) {
        return null == e || "user" === e ? "ld:$anonUserId" : `ld:$contextKey:${e}`;
    }
    function n(n, r) {
        return null !== r.key && void 0 !== r.key ? (r.key = r.key.toString(), Promise.resolve(r)) : r.anonymous ? (function(n) {
            return e.get(t(n));
        })(n).then((o)=>{
            if (o) return r.key = o, r;
            {
                const o = $36d0e3de07f3b68c$var$nt();
                return r.key = o, (function(n, r) {
                    return e.set(t(r), n);
                })(o, n).then(()=>r);
            }
        }) : Promise.reject(new $36d0e3de07f3b68c$var$s.LDInvalidUserError($36d0e3de07f3b68c$var$ae.invalidContext()));
    }
    this.processContext = (e)=>{
        if (!e) return Promise.reject(new $36d0e3de07f3b68c$var$s.LDInvalidUserError($36d0e3de07f3b68c$var$ae.contextNotSpecified()));
        const t = $36d0e3de07f3b68c$var$S.clone(e);
        if ("multi" === e.kind) {
            const e = $36d0e3de07f3b68c$var$rt(t);
            return Promise.all(e.map((e)=>n(e, t[e]))).then(()=>t);
        }
        return n(e.kind, t);
    };
};
const { v1: $36d0e3de07f3b68c$var$it } = $36d0e3de07f3b68c$var$te, { baseOptionDefs: $36d0e3de07f3b68c$var$at } = $36d0e3de07f3b68c$var$fe, { appendUrlPath: $36d0e3de07f3b68c$var$st } = $36d0e3de07f3b68c$var$S;
var $36d0e3de07f3b68c$var$ct = {
    DiagnosticId: function(e) {
        const t = {
            diagnosticId: $36d0e3de07f3b68c$var$it()
        };
        return e && (t.sdkKeySuffix = e.length > 6 ? e.substring(e.length - 6) : e), t;
    },
    DiagnosticsAccumulator: function(e) {
        let t, n, r, o;
        function i(e) {
            t = e, n = 0, r = 0, o = [];
        }
        return i(e), {
            getProps: ()=>({
                    dataSinceDate: t,
                    droppedEvents: n,
                    eventsInLastBatch: r,
                    streamInits: o
                }),
            setProps: (e)=>{
                t = e.dataSinceDate, n = e.droppedEvents || 0, r = e.eventsInLastBatch || 0, o = e.streamInits || [];
            },
            incrementDroppedEvents: ()=>{
                n++;
            },
            setEventsInLastBatch: (e)=>{
                r = e;
            },
            recordStreamInit: (e, t, n)=>{
                const r = {
                    timestamp: e,
                    failed: t,
                    durationMillis: n
                };
                o.push(r);
            },
            reset: i
        };
    },
    DiagnosticsManager: function(e, t, n, r, o, i, a) {
        const s = !!e.diagnosticUseCombinedEvent, c = "ld:" + o + ":$diagnostics", u = $36d0e3de07f3b68c$var$st(i.eventsUrl, "/events/diagnostic/" + o), l = i.diagnosticRecordingInterval, d = n;
        let f, g, v = !!i.streaming;
        const p = {};
        function m() {
            return {
                sdk: w(),
                configuration: b(),
                platform: e.diagnosticPlatformData
            };
        }
        function h(e) {
            i.logger && i.logger.debug($36d0e3de07f3b68c$var$ae.debugPostingDiagnosticEvent(e)), r.sendEvents(e, u, !0).then(()=>{}).catch(()=>{});
        }
        function y() {
            h(function() {
                const e = (new Date).getTime();
                let t = {
                    kind: s ? "diagnostic-combined" : "diagnostic",
                    id: a,
                    creationDate: e,
                    ...d.getProps()
                };
                return s && (t = {
                    ...t,
                    ...m()
                }), d.reset(e), t;
            }()), g = setTimeout(y, l), f = (new Date).getTime(), s && function() {
                if (t.isEnabled()) {
                    const e = {
                        ...d.getProps()
                    };
                    t.set(c, JSON.stringify(e));
                }
            }();
        }
        function w() {
            const t = {
                ...e.diagnosticSdkData
            };
            return i.wrapperName && (t.wrapperName = i.wrapperName), i.wrapperVersion && (t.wrapperVersion = i.wrapperVersion), t;
        }
        function b() {
            return {
                customBaseURI: i.baseUrl !== $36d0e3de07f3b68c$var$at.baseUrl.default,
                customStreamURI: i.streamUrl !== $36d0e3de07f3b68c$var$at.streamUrl.default,
                customEventsURI: i.eventsUrl !== $36d0e3de07f3b68c$var$at.eventsUrl.default,
                eventsCapacity: i.eventCapacity,
                eventsFlushIntervalMillis: i.flushInterval,
                reconnectTimeMillis: i.streamReconnectDelay,
                streamingDisabled: !v,
                allAttributesPrivate: !!i.allAttributesPrivate,
                diagnosticRecordingIntervalMillis: i.diagnosticRecordingInterval,
                usingSecureMode: !!i.hash,
                bootstrapMode: !!i.bootstrap,
                fetchGoalsDisabled: !i.fetchGoals,
                sendEventsOnlyForVariation: !!i.sendEventsOnlyForVariation
            };
        }
        return p.start = ()=>{
            s ? function(e) {
                if (!t.isEnabled()) return e(!1);
                t.get(c).then((t)=>{
                    if (t) try {
                        const e = JSON.parse(t);
                        d.setProps(e), f = e.dataSinceDate;
                    } catch (e) {}
                    e(!0);
                }).catch(()=>{
                    e(!1);
                });
            }((e)=>{
                if (e) {
                    const e = (f || 0) + l, t = (new Date).getTime();
                    t >= e ? y() : g = setTimeout(y, e - t);
                } else 0 === Math.floor(4 * Math.random()) ? y() : g = setTimeout(y, l);
            }) : (h({
                kind: "diagnostic-init",
                id: a,
                creationDate: d.getProps().dataSinceDate,
                ...m()
            }), g = setTimeout(y, l));
        }, p.stop = ()=>{
            g && clearTimeout(g);
        }, p.setStreaming = (e)=>{
            v = e;
        }, p;
    }
};
var $36d0e3de07f3b68c$var$ut = function(e, t) {
    let n = !1;
    const r = {
        type: e.type,
        name: e.name,
        synchronous: e.synchronous,
        method: (...o)=>{
            try {
                e.method(...o);
            } catch  {
                n || (n = !0, t.warn($36d0e3de07f3b68c$var$ae.inspectorMethodError(r.type, r.name)));
            }
        }
    };
    return r;
};
const { onNextTick: $36d0e3de07f3b68c$var$lt } = $36d0e3de07f3b68c$var$S, $36d0e3de07f3b68c$var$dt = {
    flagUsed: "flag-used",
    flagDetailsChanged: "flag-details-changed",
    flagDetailChanged: "flag-detail-changed",
    clientIdentityChanged: "client-identity-changed"
};
Object.freeze($36d0e3de07f3b68c$var$dt);
var $36d0e3de07f3b68c$var$ft = {
    InspectorTypes: $36d0e3de07f3b68c$var$dt,
    InspectorManager: function(e, t) {
        const n = {}, r = {
            [$36d0e3de07f3b68c$var$dt.flagUsed]: [],
            [$36d0e3de07f3b68c$var$dt.flagDetailsChanged]: [],
            [$36d0e3de07f3b68c$var$dt.flagDetailChanged]: [],
            [$36d0e3de07f3b68c$var$dt.clientIdentityChanged]: []
        }, o = {
            [$36d0e3de07f3b68c$var$dt.flagUsed]: [],
            [$36d0e3de07f3b68c$var$dt.flagDetailsChanged]: [],
            [$36d0e3de07f3b68c$var$dt.flagDetailChanged]: [],
            [$36d0e3de07f3b68c$var$dt.clientIdentityChanged]: []
        }, i = e && e.map((e)=>$36d0e3de07f3b68c$var$ut(e, t));
        return i && i.forEach((e)=>{
            Object.prototype.hasOwnProperty.call(r, e.type) && !e.synchronous ? r[e.type].push(e) : Object.prototype.hasOwnProperty.call(o, e.type) && e.synchronous ? o[e.type].push(e) : t.warn($36d0e3de07f3b68c$var$ae.invalidInspector(e.type, e.name));
        }), n.hasListeners = (e)=>r[e] && r[e].length || o[e] && o[e].length, n.onFlagUsed = (e, t, n)=>{
            const i = $36d0e3de07f3b68c$var$dt.flagUsed;
            o[i].length && o[i].forEach((r)=>r.method(e, t, n)), r[i].length && $36d0e3de07f3b68c$var$lt(()=>{
                r[i].forEach((r)=>r.method(e, t, n));
            });
        }, n.onFlags = (e)=>{
            const t = $36d0e3de07f3b68c$var$dt.flagDetailsChanged;
            o[t].length && o[t].forEach((t)=>t.method(e)), r[t].length && $36d0e3de07f3b68c$var$lt(()=>{
                r[t].forEach((t)=>t.method(e));
            });
        }, n.onFlagChanged = (e, t)=>{
            const n = $36d0e3de07f3b68c$var$dt.flagDetailChanged;
            o[n].length && o[n].forEach((n)=>n.method(e, t)), r[n].length && $36d0e3de07f3b68c$var$lt(()=>{
                r[n].forEach((n)=>n.method(e, t));
            });
        }, n.onIdentityChanged = (e)=>{
            const t = $36d0e3de07f3b68c$var$dt.clientIdentityChanged;
            o[t].length && o[t].forEach((t)=>t.method(e)), r[t].length && $36d0e3de07f3b68c$var$lt(()=>{
                r[t].forEach((t)=>t.method(e));
            });
        }, n;
    }
};
const { LDTimeoutError: $36d0e3de07f3b68c$var$gt } = $36d0e3de07f3b68c$var$s;
var $36d0e3de07f3b68c$var$vt = function(e, t) {
    return new Promise((n, r)=>{
        setTimeout(()=>{
            r(new $36d0e3de07f3b68c$var$gt(`${t} timed out after ${e} seconds.`));
        }, 1e3 * e);
    });
};
const $36d0e3de07f3b68c$var$pt = "unknown hook";
function $36d0e3de07f3b68c$var$mt(e, t, n, r, o) {
    try {
        return r();
    } catch (r) {
        return e?.error(`An error was encountered in "${t}" of the "${n}" hook: ${r}`), o;
    }
}
function $36d0e3de07f3b68c$var$ht(e, t) {
    try {
        return t.getMetadata().name || $36d0e3de07f3b68c$var$pt;
    } catch  {
        return e.error("Exception thrown getting metadata for hook. Unable to get hook name."), $36d0e3de07f3b68c$var$pt;
    }
}
var $36d0e3de07f3b68c$var$yt = function(e, t) {
    const n = t ? [
        ...t
    ] : [];
    return {
        withEvaluation: function(t, r, o, i) {
            if (0 === n.length) return i();
            const a = [
                ...n
            ], s = {
                flagKey: t,
                context: r,
                defaultValue: o
            }, c = function(e, t, n) {
                return t.map((t)=>$36d0e3de07f3b68c$var$mt(e, "beforeEvaluation", $36d0e3de07f3b68c$var$ht(e, t), ()=>t?.beforeEvaluation?.(n, {}) ?? {}, {}));
            }(e, a, s), u = i();
            return function(e, t, n, r, o) {
                for(let i = t.length - 1; i >= 0; i -= 1){
                    const a = t[i], s = r[i];
                    $36d0e3de07f3b68c$var$mt(e, "afterEvaluation", $36d0e3de07f3b68c$var$ht(e, a), ()=>a?.afterEvaluation?.(n, s, o) ?? {}, {});
                }
            }(e, a, s, c, u), u;
        },
        identify: function(t, r) {
            const o = [
                ...n
            ], i = {
                context: t,
                timeout: r
            }, a = function(e, t, n) {
                return t.map((t)=>$36d0e3de07f3b68c$var$mt(e, "beforeIdentify", $36d0e3de07f3b68c$var$ht(e, t), ()=>t?.beforeIdentify?.(n, {}) ?? {}, {}));
            }(e, o, i);
            return (t)=>{
                !function(e, t, n, r, o) {
                    for(let i = t.length - 1; i >= 0; i -= 1){
                        const a = t[i], s = r[i];
                        $36d0e3de07f3b68c$var$mt(e, "afterIdentify", $36d0e3de07f3b68c$var$ht(e, a), ()=>a?.afterIdentify?.(n, s, o) ?? {}, {});
                    }
                }(e, o, i, a, t);
            };
        },
        addHook: function(e) {
            n.push(e);
        },
        afterTrack: function(t) {
            if (0 === n.length) return;
            const r = [
                ...n
            ];
            !function(e, t, n) {
                for(let r = t.length - 1; r >= 0; r -= 1){
                    const o = t[r];
                    $36d0e3de07f3b68c$var$mt(e, "afterTrack", $36d0e3de07f3b68c$var$ht(e, o), ()=>o?.afterTrack?.(n), void 0);
                }
            }(e, r, t);
        }
    };
};
var $36d0e3de07f3b68c$var$wt = function() {
    let e, t = {};
    function n(n) {
        return e && $36d0e3de07f3b68c$var$S.objectHasOwnProperty(e, n) && e[n] ? e[n] : t && $36d0e3de07f3b68c$var$S.objectHasOwnProperty(t, n) && t[n] && !t[n].deleted ? t[n] : null;
    }
    return {
        clearAllOverrides: function() {
            if (!e) return {};
            const t = {
                ...e
            };
            return e = void 0, t;
        },
        get: n,
        getFlagOverrides: function() {
            return e || {};
        },
        getFlags: function() {
            return t;
        },
        getFlagsWithOverrides: function() {
            const r = {};
            for(const e in t){
                const t = n(e);
                t && (r[e] = t);
            }
            if (e) for(const t in e){
                const e = n(t);
                e && (r[t] = e);
            }
            return r;
        },
        removeOverride: function(t) {
            e && e[t] && (delete e[t], 0 === Object.keys(e).length && (e = void 0));
        },
        setFlags: function(e) {
            t = {
                ...e
            };
        },
        setOverride: function(t, n) {
            e || (e = {}), e[t] = {
                value: n
            };
        }
    };
};
const $36d0e3de07f3b68c$var$bt = "unknown plugin";
function $36d0e3de07f3b68c$var$kt(e, t) {
    try {
        return t.getMetadata().name || $36d0e3de07f3b68c$var$bt;
    } catch (t) {
        return e.error("Exception thrown getting metadata for plugin. Unable to get plugin name."), $36d0e3de07f3b68c$var$bt;
    }
}
var $36d0e3de07f3b68c$var$Et = {
    getPluginHooks: function(e, t, n) {
        const r = [];
        return n.forEach((n)=>{
            try {
                const o = n.getHooks?.(t);
                void 0 === o ? e.error(`Plugin ${$36d0e3de07f3b68c$var$kt(e, n)} returned undefined from getHooks.`) : o && o.length > 0 && r.push(...o);
            } catch (t) {
                e.error(`Exception thrown getting hooks for plugin ${$36d0e3de07f3b68c$var$kt(e, n)}. Unable to get hooks.`);
            }
        }), r;
    },
    registerPlugins: function(e, t, n, r) {
        r.forEach((r)=>{
            try {
                r.register(n, t);
            } catch (t) {
                e.error(`Exception thrown registering plugin ${$36d0e3de07f3b68c$var$kt(e, r)}.`);
            }
        });
    },
    registerPluginsForDebugOverride: function(e, t, n) {
        n.forEach((n)=>{
            try {
                n.registerDebug?.(t);
            } catch (t) {
                e.error(`Exception thrown registering debug override with plugin ${$36d0e3de07f3b68c$var$kt(e, n)}.`);
            }
        });
    },
    createPluginEnvironment: function(e, t, n) {
        const r = {};
        e.userAgent && (r.name = e.userAgent), e.version && (r.version = e.version), n.wrapperName && (r.wrapperName = n.wrapperName), n.wrapperVersion && (r.wrapperVersion = n.wrapperVersion);
        const o = {};
        n.application && (n.application.name && (o.name = n.application.name), n.application.version && (o.version = n.application.version));
        const i = {
            sdk: r,
            clientSideId: t
        };
        return Object.keys(o).length > 0 && (i.application = o), i;
    }
};
const { commonBasicLogger: $36d0e3de07f3b68c$var$Dt } = $36d0e3de07f3b68c$var$re, { checkContext: $36d0e3de07f3b68c$var$xt, getContextKeys: $36d0e3de07f3b68c$var$Ot } = $36d0e3de07f3b68c$var$De, { InspectorTypes: $36d0e3de07f3b68c$var$Ct, InspectorManager: $36d0e3de07f3b68c$var$Pt } = $36d0e3de07f3b68c$var$ft, { getPluginHooks: $36d0e3de07f3b68c$var$St, registerPlugins: $36d0e3de07f3b68c$var$It, registerPluginsForDebugOverride: $36d0e3de07f3b68c$var$Tt, createPluginEnvironment: $36d0e3de07f3b68c$var$Ft } = $36d0e3de07f3b68c$var$Et, $36d0e3de07f3b68c$var$Lt = "change", $36d0e3de07f3b68c$var$Ut = "internal-change";
var $36d0e3de07f3b68c$var$At = {
    initialize: function(e, t, n, r, o) {
        const i = function() {
            if (n && n.logger) return n.logger;
            return o && o.logger && o.logger.default || $36d0e3de07f3b68c$var$Dt("warn");
        }(), a = $36d0e3de07f3b68c$var$Re(i), c = $36d0e3de07f3b68c$var$He(a), u = $36d0e3de07f3b68c$var$fe.validate(n, a, o, i), l = $36d0e3de07f3b68c$var$Pt(u.inspectors, i), d = u.sendEvents;
        let f = e, g = u.hash;
        const v = [
            ...u.plugins
        ], p = $36d0e3de07f3b68c$var$Ft(r, e, u), m = $36d0e3de07f3b68c$var$St(i, p, v), h = $36d0e3de07f3b68c$var$yt(i, [
            ...u.hooks,
            ...m
        ]), y = $36d0e3de07f3b68c$var$qe(r.localStorage, i), w = $36d0e3de07f3b68c$var$ye(r, f, u), b = u.sendEvents && !u.diagnosticOptOut, k = b ? $36d0e3de07f3b68c$var$ct.DiagnosticId(f) : null, E = b ? $36d0e3de07f3b68c$var$ct.DiagnosticsAccumulator((new Date).getTime()) : null, D = b ? $36d0e3de07f3b68c$var$ct.DiagnosticsManager(r, y, E, w, f, u, k) : null, x = $36d0e3de07f3b68c$var$Ge(r, u, f, E), O = u.eventProcessor || $36d0e3de07f3b68c$var$je(r, u, f, E, a, w), C = $36d0e3de07f3b68c$var$et(r, u, f), P = $36d0e3de07f3b68c$var$wt();
        let I, T, F, L = u.streaming, U = !1, A = !1, j = !0;
        const R = u.stateProvider, N = $36d0e3de07f3b68c$var$tt(null, function(e) {
            (function(e) {
                if (R) return;
                e && H({
                    kind: "identify",
                    context: e,
                    creationDate: (new Date).getTime()
                });
            })(e), l.hasListeners($36d0e3de07f3b68c$var$Ct.clientIdentityChanged) && l.onIdentityChanged(N.getContext());
        }), $ = new $36d0e3de07f3b68c$var$ot(y), V = y.isEnabled() ? $36d0e3de07f3b68c$var$Me(y, f, g, N) : null;
        function H(e) {
            f && (R && R.enqueueEvent && R.enqueueEvent(e) || (e.context ? (j = !1, !d || A || r.isDoNotTrack() || (i.debug($36d0e3de07f3b68c$var$ae.debugEnqueueingEvent(e.kind)), O.enqueue(e))) : j && (i.warn($36d0e3de07f3b68c$var$ae.eventWithoutContext()), j = !1)));
        }
        function M(e, t) {
            l.hasListeners($36d0e3de07f3b68c$var$Ct.flagDetailChanged) && l.onFlagChanged(e.key, J(t));
        }
        function q() {
            l.hasListeners($36d0e3de07f3b68c$var$Ct.flagDetailsChanged) && l.onFlags(Object.entries(P.getFlagsWithOverrides()).map(([e, t])=>({
                    key: e,
                    detail: J(t)
                })).reduce((e, t)=>(e[t.key] = t.detail, e), {}));
        }
        function z(e, t, n, r) {
            const o = N.getContext(), i = new Date, a = {
                kind: "feature",
                key: e,
                context: o,
                value: t ? t.value : null,
                variation: t ? t.variationIndex : null,
                default: n,
                creationDate: i.getTime()
            }, s = P.getFlags()[e];
            s && (a.version = s.flagVersion ? s.flagVersion : s.version, a.trackEvents = s.trackEvents, a.debugEventsUntilDate = s.debugEventsUntilDate), (r || s && s.trackReason) && t && (a.reason = t.reason), H(a);
        }
        function K(e) {
            return $36d0e3de07f3b68c$var$xt(e, !1) ? Promise.resolve(e) : Promise.reject(new $36d0e3de07f3b68c$var$s.LDInvalidUserError($36d0e3de07f3b68c$var$ae.invalidContext()));
        }
        function _(e, t, n, r, o, i) {
            let a;
            const s = P.get(e);
            return s ? (a = J(s), null !== s.value && void 0 !== s.value || (a.value = t)) : a = {
                value: t,
                variationIndex: null,
                reason: {
                    kind: "ERROR",
                    errorKind: "FLAG_NOT_FOUND"
                }
            }, n && (o || s?.prerequisites?.forEach((e)=>{
                _(e, void 0, n, !1, !1, !1);
            }), z(e, a, t, r)), !o && i && function(e, t) {
                l.hasListeners($36d0e3de07f3b68c$var$Ct.flagUsed) && l.onFlagUsed(e, t, N.getContext());
            }(e, a), a;
        }
        function J(e) {
            return {
                value: e.value,
                variationIndex: void 0 === e.variation ? null : e.variation,
                reason: e.reason || null
            };
        }
        function B() {
            if (T = !0, !N.getContext()) return;
            const e = (e)=>{
                try {
                    return JSON.parse(e);
                } catch (e) {
                    return void a.maybeReportError(new $36d0e3de07f3b68c$var$s.LDInvalidDataError($36d0e3de07f3b68c$var$ae.invalidData()));
                }
            };
            x.connect(N.getContext(), g, {
                ping: function() {
                    i.debug($36d0e3de07f3b68c$var$ae.debugStreamPing());
                    const e = N.getContext();
                    C.fetchFlagSettings(e, g).then((t)=>{
                        $36d0e3de07f3b68c$var$S.deepEquals(e, N.getContext()) && G(t || {});
                    }).catch((e)=>{
                        a.maybeReportError(new $36d0e3de07f3b68c$var$s.LDFlagFetchError($36d0e3de07f3b68c$var$ae.errorFetchingFlags(e)));
                    });
                },
                put: function(t) {
                    const n = e(t.data);
                    n && (i.debug($36d0e3de07f3b68c$var$ae.debugStreamPut()), G(n));
                },
                patch: function(t) {
                    const n = e(t.data);
                    if (!n) return;
                    const r = P.getFlags(), o = r[n.key];
                    if (!o || !o.version || !n.version || o.version < n.version) {
                        i.debug($36d0e3de07f3b68c$var$ae.debugStreamPatch(n.key));
                        const e = {}, t = $36d0e3de07f3b68c$var$S.extend({}, n);
                        delete t.key, r[n.key] = t, P.setFlags(r);
                        const a = J(t);
                        e[n.key] = o ? {
                            previous: o.value,
                            current: a
                        } : {
                            current: a
                        }, M(n, t), X(e);
                    } else i.debug($36d0e3de07f3b68c$var$ae.debugStreamPatchIgnored(n.key));
                },
                delete: function(t) {
                    const n = e(t.data);
                    if (!n) return;
                    const r = P.getFlags();
                    if (!r[n.key] || r[n.key].version < n.version) {
                        i.debug($36d0e3de07f3b68c$var$ae.debugStreamDelete(n.key));
                        const e = {};
                        r[n.key] && !r[n.key].deleted && (e[n.key] = {
                            previous: r[n.key].value
                        }), r[n.key] = {
                            version: n.version,
                            deleted: !0
                        }, P.setFlags(r), M(n, r[n.key]), X(e);
                    } else i.debug($36d0e3de07f3b68c$var$ae.debugStreamDeleteIgnored(n.key));
                }
            });
        }
        function W() {
            T && (x.disconnect(), T = !1);
        }
        function G(e) {
            const t = {};
            if (!e) return Promise.resolve();
            const n = P.getFlags();
            for(const r in n)$36d0e3de07f3b68c$var$S.objectHasOwnProperty(n, r) && n[r] && (e[r] && !$36d0e3de07f3b68c$var$S.deepEquals(e[r].value, n[r].value) ? t[r] = {
                previous: n[r].value,
                current: J(e[r])
            } : e[r] && !e[r].deleted || (t[r] = {
                previous: n[r].value
            }));
            for(const r in e)$36d0e3de07f3b68c$var$S.objectHasOwnProperty(e, r) && e[r] && (!n[r] || n[r].deleted) && (t[r] = {
                current: J(e[r])
            });
            return P.setFlags({
                ...e
            }), q(), X(t).catch(()=>{});
        }
        function X(e) {
            const t = Object.keys(e);
            if (t.length > 0) {
                const n = {};
                t.forEach((t)=>{
                    const r = e[t].current, o = r ? r.value : void 0, i = e[t].previous;
                    a.emit($36d0e3de07f3b68c$var$Lt + ":" + t, o, i), n[t] = r ? {
                        current: o,
                        previous: i
                    } : {
                        previous: i
                    };
                }), a.emit($36d0e3de07f3b68c$var$Lt, n), a.emit($36d0e3de07f3b68c$var$Ut, P.getFlagsWithOverrides()), u.sendEventsOnlyForVariation || R || t.forEach((t)=>{
                    z(t, e[t].current);
                });
            }
            return I && V ? V.saveFlags(P.getFlags()) : Promise.resolve();
        }
        function Q() {
            const e = L || F && void 0 === L;
            e && !T ? B() : !e && T && W(), D && D.setStreaming(e);
        }
        function Y(e) {
            return e === $36d0e3de07f3b68c$var$Lt || e.substr(0, 7) === $36d0e3de07f3b68c$var$Lt + ":";
        }
        if ("string" == typeof u.bootstrap && "LOCALSTORAGE" === u.bootstrap.toUpperCase() && (V ? I = !0 : i.warn($36d0e3de07f3b68c$var$ae.localStorageUnavailable())), "object" == typeof u.bootstrap && P.setFlags(function(e) {
            const t = Object.keys(e), n = "$flagsState", r = "$valid", o = e[n];
            !o && t.length && i.warn($36d0e3de07f3b68c$var$ae.bootstrapOldFormat()), !1 === e[r] && i.warn($36d0e3de07f3b68c$var$ae.bootstrapInvalid());
            const a = {};
            return t.forEach((t)=>{
                if (t !== n && t !== r) {
                    let n = {
                        value: e[t]
                    };
                    o && o[t] ? n = $36d0e3de07f3b68c$var$S.extend(n, o[t]) : n.version = 0, a[t] = n;
                }
            }), a;
        }(u.bootstrap)), R) {
            const e = R.getInitialState();
            e ? Z(e) : R.on("init", Z), R.on("update", function(e) {
                e.context && N.setContext(e.context);
                e.flags && G(e.flags);
            });
        } else (function() {
            if (!e) return Promise.reject(new $36d0e3de07f3b68c$var$s.LDInvalidEnvironmentIdError($36d0e3de07f3b68c$var$ae.environmentNotSpecified()));
            let n;
            return $.processContext(t).then(K).then((e)=>(n = $36d0e3de07f3b68c$var$S.once(h.identify(e, void 0)), e)).then((e)=>(n?.({
                    status: "completed"
                }), N.setContext(e), "object" == typeof u.bootstrap ? ee() : I ? V.loadFlags().then((e)=>null == e ? (P.setFlags({}), C.fetchFlagSettings(N.getContext(), g).then((e)=>G(e || {})).then(ee).catch((e)=>{
                        te(new $36d0e3de07f3b68c$var$s.LDFlagFetchError($36d0e3de07f3b68c$var$ae.errorFetchingFlags(e)));
                    })) : (P.setFlags(e), $36d0e3de07f3b68c$var$S.onNextTick(ee), C.fetchFlagSettings(N.getContext(), g).then((e)=>G(e)).catch((e)=>a.maybeReportError(e)))) : C.fetchFlagSettings(N.getContext(), g).then((e)=>{
                    P.setFlags(e || {}), q(), ee();
                }).catch((e)=>{
                    P.setFlags({}), te(e);
                }))).catch((e)=>{
                throw n?.({
                    status: "error"
                }), e;
            });
        })().catch(te);
        function Z(e) {
            f = e.environment, N.setContext(e.context), P.setFlags({
                ...e.flags
            }), $36d0e3de07f3b68c$var$S.onNextTick(ee);
        }
        function ee() {
            i.info($36d0e3de07f3b68c$var$ae.clientInitialized()), U = !0, Q(), c.signalSuccess();
        }
        function te(e) {
            c.signalFailure(e);
        }
        const ne = {
            waitForInitialization: function(e) {
                if (null != e) {
                    if ("number" == typeof e) return function(e) {
                        e > 5 && i.warn("The waitForInitialization function was called with a timeout greater than 5 seconds. We recommend a timeout of 5 seconds or less.");
                        const t = c.getInitializationPromise(), n = $36d0e3de07f3b68c$var$vt(e, "waitForInitialization");
                        return Promise.race([
                            n,
                            t
                        ]).catch((e)=>{
                            throw e instanceof $36d0e3de07f3b68c$var$s.LDTimeoutError && i.error(`waitForInitialization error: ${e}`), e;
                        });
                    }(e);
                    i.warn("The waitForInitialization method was provided with a non-numeric timeout.");
                }
                return i.warn("The waitForInitialization function was called without a timeout specified. In a future version a default timeout will be applied."), c.getInitializationPromise();
            },
            waitUntilReady: ()=>c.getReadyPromise(),
            identify: function(e, t, n) {
                if (A) return $36d0e3de07f3b68c$var$S.wrapPromiseCallback(Promise.resolve({}), n);
                if (R) return i.warn($36d0e3de07f3b68c$var$ae.identifyDisabled()), $36d0e3de07f3b68c$var$S.wrapPromiseCallback(Promise.resolve($36d0e3de07f3b68c$var$S.transformVersionedValuesToValues(P.getFlagsWithOverrides())), n);
                let r;
                const o = I && V ? V.clearFlags() : Promise.resolve();
                return $36d0e3de07f3b68c$var$S.wrapPromiseCallback(o.then(()=>$.processContext(e)).then(K).then((e)=>(r = $36d0e3de07f3b68c$var$S.once(h.identify(e, void 0)), e)).then((e)=>C.fetchFlagSettings(e, t).then((n)=>{
                        const r = $36d0e3de07f3b68c$var$S.transformVersionedValuesToValues(n);
                        return N.setContext(e), g = t, n ? G(n).then(()=>r) : r;
                    })).then((e)=>(r?.({
                        status: "completed"
                    }), T && B(), e)).catch((e)=>(r?.({
                        status: "error"
                    }), a.maybeReportError(e), Promise.reject(e))), n);
            },
            getContext: function() {
                return N.getContext();
            },
            variation: function(e, t) {
                const { value: n } = h.withEvaluation(e, N.getContext(), t, ()=>_(e, t, !0, !1, !1, !0));
                return n;
            },
            variationDetail: function(e, t) {
                return h.withEvaluation(e, N.getContext(), t, ()=>_(e, t, !0, !0, !1, !0));
            },
            track: function(e, t, n) {
                if ("string" != typeof e) return void a.maybeReportError(new $36d0e3de07f3b68c$var$s.LDInvalidEventKeyError($36d0e3de07f3b68c$var$ae.unknownCustomEventKey(e)));
                void 0 !== n && "number" != typeof n && i.warn($36d0e3de07f3b68c$var$ae.invalidMetricValue(typeof n)), r.customEventFilter && !r.customEventFilter(e) && i.warn($36d0e3de07f3b68c$var$ae.unknownCustomEventKey(e));
                const o = N.getContext(), c = {
                    kind: "custom",
                    key: e,
                    context: o,
                    url: r.getCurrentUrl(),
                    creationDate: (new Date).getTime()
                };
                o && o.anonymous && (c.contextKind = o.anonymous ? "anonymousUser" : "user"), null != t && (c.data = t), null != n && (c.metricValue = n), H(c), h.afterTrack({
                    context: o,
                    key: e,
                    data: t,
                    metricValue: n
                });
            },
            on: function(e, t, n) {
                Y(e) ? (F = !0, U && Q(), a.on(e, t, n)) : a.on(...arguments);
            },
            off: function(e) {
                if (a.off(...arguments), Y(e)) {
                    let e = !1;
                    a.getEvents().forEach((t)=>{
                        Y(t) && a.getEventListenerCount(t) > 0 && (e = !0);
                    }), e || (F = !1, T && void 0 === L && W());
                }
            },
            setStreaming: function(e) {
                const t = null === e ? void 0 : e;
                t !== L && (L = t, Q());
            },
            flush: function(e) {
                return $36d0e3de07f3b68c$var$S.wrapPromiseCallback(d ? O.flush() : Promise.resolve(), e);
            },
            allFlags: function() {
                const e = {}, t = P.getFlagsWithOverrides();
                if (!t) return e;
                for(const n in t)e[n] = _(n, null, !u.sendEventsOnlyForVariation, !1, !0, !1).value;
                return e;
            },
            close: function(e) {
                if (A) return $36d0e3de07f3b68c$var$S.wrapPromiseCallback(Promise.resolve(), e);
                const t = ()=>{
                    A = !0, P.setFlags({});
                }, n = Promise.resolve().then(()=>{
                    if (W(), D && D.stop(), d) return O.stop(), O.flush();
                }).then(t).catch(t);
                return $36d0e3de07f3b68c$var$S.wrapPromiseCallback(n, e);
            },
            addHook: function(e) {
                h.addHook(e);
            }
        };
        $36d0e3de07f3b68c$var$It(i, p, ne, v);
        const re = {
            setOverride: function(e, t) {
                const n = {}, r = P.get(e), o = r ? r.value : null;
                if (o === t) return void i.debug(`setOverride: No change needed for ${e}, value already ${t}`);
                P.setOverride(e, t);
                const a = P.get(e), s = J(a);
                n[e] = {
                    previous: o,
                    current: s
                }, M({
                    key: e
                }, a), X(n);
            },
            removeOverride: function(e) {
                const t = P.getFlagOverrides();
                if (!t[e]) return;
                const n = {}, r = t[e], o = P.getFlags()[e];
                n[e] = {
                    previous: r.value,
                    current: o ? J(o) : void 0
                }, P.removeOverride(e), M({
                    key: e
                }, o), X(n);
            },
            clearAllOverrides: function() {
                const e = P.getFlagOverrides();
                if (0 === Object.keys(e).length) return;
                const t = {}, n = P.getFlags();
                Object.keys(e).forEach((r)=>{
                    const o = e[r], i = n[r];
                    t[r] = {
                        previous: o.value,
                        current: i ? J(i) : void 0
                    };
                }), P.clearAllOverrides(), Object.keys(t).length > 0 && X(t);
            },
            getAllOverrides: function() {
                const e = P.getFlagOverrides();
                if (!e) return {};
                const t = {};
                return Object.keys(e).forEach((n)=>{
                    const r = e[n];
                    r && (t[n] = r.value);
                }), t;
            }
        };
        return $36d0e3de07f3b68c$var$Tt(i, re, v), {
            client: ne,
            options: u,
            emitter: a,
            ident: N,
            logger: i,
            requestor: C,
            start: function() {
                d && (D && D.start(), O.start());
            },
            enqueueEvent: H,
            getFlagsInternal: function() {
                return P.getFlagsWithOverrides();
            },
            getEnvironmentId: ()=>f,
            internalChangeEventName: $36d0e3de07f3b68c$var$Ut
        };
    },
    commonBasicLogger: $36d0e3de07f3b68c$var$Dt,
    errors: $36d0e3de07f3b68c$var$s,
    messages: $36d0e3de07f3b68c$var$ae,
    utils: $36d0e3de07f3b68c$var$S,
    getContextKeys: $36d0e3de07f3b68c$var$Ot
}, $36d0e3de07f3b68c$var$jt = $36d0e3de07f3b68c$var$At.initialize, $36d0e3de07f3b68c$var$Rt = $36d0e3de07f3b68c$var$At.errors, $36d0e3de07f3b68c$var$Nt = $36d0e3de07f3b68c$var$At.messages;
function $36d0e3de07f3b68c$var$$t(e, t, n) {
    return (t = function(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var r = n.call(e, t || "default");
                if ("object" != typeof r) return r;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return ("string" === t ? String : Number)(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = n, e;
}
function $36d0e3de07f3b68c$var$Vt(e, t) {
    var n = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function(t) {
            return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
    }
    return n;
}
function $36d0e3de07f3b68c$var$Ht(e) {
    for(var t = 1; t < arguments.length; t++){
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? $36d0e3de07f3b68c$var$Vt(Object(n), !0).forEach(function(t) {
            $36d0e3de07f3b68c$var$$t(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $36d0e3de07f3b68c$var$Vt(Object(n)).forEach(function(t) {
            Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
    }
    return e;
}
var $36d0e3de07f3b68c$var$Mt = $36d0e3de07f3b68c$var$At.commonBasicLogger;
var $36d0e3de07f3b68c$var$qt = function(e) {
    return $36d0e3de07f3b68c$var$Mt($36d0e3de07f3b68c$var$Ht({
        destination: console.log
    }, e));
};
var $36d0e3de07f3b68c$var$zt = {
    promise: Promise.resolve({
        status: 200,
        header: function() {
            return null;
        },
        body: null
    })
};
function $36d0e3de07f3b68c$var$Kt(e, t, n, r, o) {
    if (o && !function() {
        var e = window.navigator && window.navigator.userAgent;
        if (e) {
            var t = e.match(/Chrom(e|ium)\/([0-9]+)\./);
            if (t) return parseInt(t[2], 10) < 73;
        }
        return !0;
    }()) return $36d0e3de07f3b68c$var$zt;
    var i = new window.XMLHttpRequest;
    for(var a in i.open(e, t, !o), n || {})Object.prototype.hasOwnProperty.call(n, a) && i.setRequestHeader(a, n[a]);
    if (o) {
        try {
            i.send(r);
        } catch (e) {}
        return $36d0e3de07f3b68c$var$zt;
    }
    var s, c = new Promise(function(e, t) {
        i.addEventListener("load", function() {
            s || e({
                status: i.status,
                header: function(e) {
                    return i.getResponseHeader(e);
                },
                body: i.responseText
            });
        }), i.addEventListener("error", function() {
            s || t(new Error);
        }), i.send(r);
    });
    return {
        promise: c,
        cancel: function() {
            s = !0, i.abort();
        }
    };
}
var $36d0e3de07f3b68c$var$_t = (e)=>{
    if ("string" != typeof e) throw new TypeError("Expected a string");
    return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
};
function $36d0e3de07f3b68c$var$Jt(e, t, n, r) {
    var o, i, a = (("substring" === e.kind || "regex" === e.kind) && r.includes("/") ? t : t.replace(r, "")).replace(n, "");
    switch(e.kind){
        case "exact":
            i = t, o = new RegExp("^" + $36d0e3de07f3b68c$var$_t(e.url) + "/?$");
            break;
        case "canonical":
            i = a, o = new RegExp("^" + $36d0e3de07f3b68c$var$_t(e.url) + "/?$");
            break;
        case "substring":
            i = a, o = new RegExp(".*" + $36d0e3de07f3b68c$var$_t(e.substring) + ".*$");
            break;
        case "regex":
            i = a, o = new RegExp(e.pattern);
            break;
        default:
            return !1;
    }
    return o.test(i);
}
function $36d0e3de07f3b68c$var$Bt(e, t) {
    for(var n = {}, r = null, o = [], i = 0; i < e.length; i++)for(var a = e[i], s = a.urls || [], c = 0; c < s.length; c++)if ($36d0e3de07f3b68c$var$Jt(s[c], window.location.href, window.location.search, window.location.hash)) {
        "pageview" === a.kind ? t("pageview", a) : (o.push(a), t("click_pageview", a));
        break;
    }
    return o.length > 0 && (r = function(e) {
        for(var n = function(e, t) {
            for(var n = [], r = 0; r < t.length; r++)for(var o = e.target, i = t[r], a = i.selector, s = document.querySelectorAll(a); o && s.length > 0;){
                for(var c = 0; c < s.length; c++)o === s[c] && n.push(i);
                o = o.parentNode;
            }
            return n;
        }(e, o), r = 0; r < n.length; r++)t("click", n[r]);
    }, document.addEventListener("click", r)), n.dispose = function() {
        document.removeEventListener("click", r);
    }, n;
}
function $36d0e3de07f3b68c$var$Wt(e, t) {
    var n, r;
    function o() {
        r && r.dispose(), n && n.length && (r = $36d0e3de07f3b68c$var$Bt(n, i));
    }
    function i(t, n) {
        var r = e.ident.getContext(), o = {
            kind: t,
            key: n.key,
            data: null,
            url: window.location.href,
            creationDate: (new Date).getTime(),
            context: r
        };
        return "click" === t && (o.selector = n.selector), e.enqueueEvent(o);
    }
    return e.requestor.fetchJSON("/sdk/goals/" + e.getEnvironmentId()).then(function(e) {
        e && e.length > 0 && (r = $36d0e3de07f3b68c$var$Bt(n = e, i), function(e, t) {
            var n, r = window.location.href;
            function o() {
                (n = window.location.href) !== r && (r = n, t());
            }
            !function e(t, n) {
                t(), setTimeout(function() {
                    e(t, n);
                }, n);
            }(o, e), window.history && window.history.pushState ? window.addEventListener("popstate", o) : window.addEventListener("hashchange", o);
        }(300, o)), t();
    }).catch(function(n) {
        e.emitter.maybeReportError(new $36d0e3de07f3b68c$var$Rt.LDUnexpectedResponseError((n && n.message, n.message))), t();
    }), {};
}
var $36d0e3de07f3b68c$var$Gt = "goalsReady", $36d0e3de07f3b68c$var$Xt = {
    fetchGoals: {
        default: !0
    },
    hash: {
        type: "string"
    },
    eventProcessor: {
        type: "object"
    },
    eventUrlTransformer: {
        type: "function"
    },
    disableSyncEventPost: {
        default: !1
    }
};
function $36d0e3de07f3b68c$export$2a47f398eeff8b01(e, t) {
    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}, r = function(e) {
        var t, n = {
            userAgentHeaderName: "X-LaunchDarkly-User-Agent",
            synchronousFlush: !1
        };
        if (window.XMLHttpRequest) {
            var r = e && e.disableSyncEventPost;
            n.httpRequest = function(e, t, o, i) {
                var a = n.synchronousFlush & !r;
                return n.synchronousFlush = !1, $36d0e3de07f3b68c$var$Kt(e, t, o, i, a);
            };
        }
        n.httpAllowsPost = function() {
            return void 0 === t && (t = !!window.XMLHttpRequest && "withCredentials" in new window.XMLHttpRequest), t;
        }, n.httpFallbackPing = function(e) {
            (new window.Image).src = e;
        };
        var o, i = e && e.eventUrlTransformer;
        n.getCurrentUrl = function() {
            return i ? i(window.location.href) : window.location.href;
        }, n.isDoNotTrack = function() {
            var e;
            return 1 === (e = window.navigator && void 0 !== window.navigator.doNotTrack ? window.navigator.doNotTrack : window.navigator && void 0 !== window.navigator.msDoNotTrack ? window.navigator.msDoNotTrack : window.doNotTrack) || !0 === e || "1" === e || "yes" === e;
        };
        try {
            window.localStorage && (n.localStorage = {
                get: function(e) {
                    return new Promise(function(t) {
                        t(window.localStorage.getItem(e));
                    });
                },
                set: function(e, t) {
                    return new Promise(function(n) {
                        window.localStorage.setItem(e, t), n();
                    });
                },
                clear: function(e) {
                    return new Promise(function(t) {
                        window.localStorage.removeItem(e), t();
                    });
                }
            });
        } catch (e) {
            n.localStorage = null;
        }
        if (e && e.useReport && "function" == typeof window.EventSourcePolyfill && window.EventSourcePolyfill.supportedOptions && window.EventSourcePolyfill.supportedOptions.method ? (n.eventSourceAllowsReport = !0, o = window.EventSourcePolyfill) : (n.eventSourceAllowsReport = !1, o = window.EventSource), window.EventSource) {
            var a = 3e5;
            n.eventSourceFactory = function(e, t) {
                var n = $36d0e3de07f3b68c$var$Ht($36d0e3de07f3b68c$var$Ht({}, {
                    heartbeatTimeout: a,
                    silentTimeout: a,
                    skipDefaultHeaders: !0
                }), t);
                return new o(e, n);
            }, n.eventSourceIsActive = function(e) {
                return e.readyState === window.EventSource.OPEN || e.readyState === window.EventSource.CONNECTING;
            };
        }
        return n.userAgent = "JSClient", n.version = "3.9.0", n.diagnosticSdkData = {
            name: "js-client-sdk",
            version: "3.9.0"
        }, n.diagnosticPlatformData = {
            name: "JS"
        }, n.diagnosticUseCombinedEvent = !0, n;
    }(n), o = $36d0e3de07f3b68c$var$jt(e, t, n, r, $36d0e3de07f3b68c$var$Xt), i = o.client, a = o.options, s = o.emitter, c = new Promise(function(e) {
        var t = s.on($36d0e3de07f3b68c$var$Gt, function() {
            s.off($36d0e3de07f3b68c$var$Gt, t), e();
        });
    });
    i.waitUntilGoalsReady = function() {
        return c;
    }, a.fetchGoals ? $36d0e3de07f3b68c$var$Wt(o, function() {
        return s.emit($36d0e3de07f3b68c$var$Gt);
    }) : s.emit($36d0e3de07f3b68c$var$Gt), "complete" !== document.readyState ? window.addEventListener("load", o.start) : o.start();
    var u = function() {
        r.synchronousFlush = !0, i.flush().catch(function() {}), r.synchronousFlush = !1;
    };
    return document.addEventListener("visibilitychange", function() {
        "hidden" === document.visibilityState && u();
    }), window.addEventListener("pagehide", u), i;
}
var $36d0e3de07f3b68c$export$b66aba0a73c7dec6 = $36d0e3de07f3b68c$var$qt, $36d0e3de07f3b68c$export$297abbbd7d012370 = void 0, $36d0e3de07f3b68c$export$83d89fbfd8236492 = "3.9.0";
var $36d0e3de07f3b68c$export$2e2bcd8739ae039 = {
    initialize: function(e, t) {
        var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
        return console && console.warn && console.warn($36d0e3de07f3b68c$var$Nt.deprecated("default export", "named LDClient export")), $36d0e3de07f3b68c$export$2a47f398eeff8b01(e, t, n);
    },
    version: $36d0e3de07f3b68c$export$83d89fbfd8236492
};


var $76cfcb23d8197d02$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $76cfcb23d8197d02$var$INFINITY = 1 / 0;
/** `Object#toString` result references. */ var $76cfcb23d8197d02$var$symbolTag = '[object Symbol]';
/** Used to match words composed of alphanumeric characters. */ var $76cfcb23d8197d02$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $76cfcb23d8197d02$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $76cfcb23d8197d02$var$rsAstralRange = '\\ud800-\\udfff', $76cfcb23d8197d02$var$rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23', $76cfcb23d8197d02$var$rsComboSymbolsRange = '\\u20d0-\\u20f0', $76cfcb23d8197d02$var$rsDingbatRange = '\\u2700-\\u27bf', $76cfcb23d8197d02$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $76cfcb23d8197d02$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $76cfcb23d8197d02$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $76cfcb23d8197d02$var$rsPunctuationRange = '\\u2000-\\u206f', $76cfcb23d8197d02$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $76cfcb23d8197d02$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $76cfcb23d8197d02$var$rsVarRange = '\\ufe0e\\ufe0f', $76cfcb23d8197d02$var$rsBreakRange = $76cfcb23d8197d02$var$rsMathOpRange + $76cfcb23d8197d02$var$rsNonCharRange + $76cfcb23d8197d02$var$rsPunctuationRange + $76cfcb23d8197d02$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $76cfcb23d8197d02$var$rsApos = "['\u2019]", $76cfcb23d8197d02$var$rsAstral = '[' + $76cfcb23d8197d02$var$rsAstralRange + ']', $76cfcb23d8197d02$var$rsBreak = '[' + $76cfcb23d8197d02$var$rsBreakRange + ']', $76cfcb23d8197d02$var$rsCombo = '[' + $76cfcb23d8197d02$var$rsComboMarksRange + $76cfcb23d8197d02$var$rsComboSymbolsRange + ']', $76cfcb23d8197d02$var$rsDigits = '\\d+', $76cfcb23d8197d02$var$rsDingbat = '[' + $76cfcb23d8197d02$var$rsDingbatRange + ']', $76cfcb23d8197d02$var$rsLower = '[' + $76cfcb23d8197d02$var$rsLowerRange + ']', $76cfcb23d8197d02$var$rsMisc = '[^' + $76cfcb23d8197d02$var$rsAstralRange + $76cfcb23d8197d02$var$rsBreakRange + $76cfcb23d8197d02$var$rsDigits + $76cfcb23d8197d02$var$rsDingbatRange + $76cfcb23d8197d02$var$rsLowerRange + $76cfcb23d8197d02$var$rsUpperRange + ']', $76cfcb23d8197d02$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $76cfcb23d8197d02$var$rsModifier = '(?:' + $76cfcb23d8197d02$var$rsCombo + '|' + $76cfcb23d8197d02$var$rsFitz + ')', $76cfcb23d8197d02$var$rsNonAstral = '[^' + $76cfcb23d8197d02$var$rsAstralRange + ']', $76cfcb23d8197d02$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $76cfcb23d8197d02$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $76cfcb23d8197d02$var$rsUpper = '[' + $76cfcb23d8197d02$var$rsUpperRange + ']', $76cfcb23d8197d02$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $76cfcb23d8197d02$var$rsLowerMisc = '(?:' + $76cfcb23d8197d02$var$rsLower + '|' + $76cfcb23d8197d02$var$rsMisc + ')', $76cfcb23d8197d02$var$rsUpperMisc = '(?:' + $76cfcb23d8197d02$var$rsUpper + '|' + $76cfcb23d8197d02$var$rsMisc + ')', $76cfcb23d8197d02$var$rsOptLowerContr = '(?:' + $76cfcb23d8197d02$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $76cfcb23d8197d02$var$rsOptUpperContr = '(?:' + $76cfcb23d8197d02$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $76cfcb23d8197d02$var$reOptMod = $76cfcb23d8197d02$var$rsModifier + '?', $76cfcb23d8197d02$var$rsOptVar = '[' + $76cfcb23d8197d02$var$rsVarRange + ']?', $76cfcb23d8197d02$var$rsOptJoin = '(?:' + $76cfcb23d8197d02$var$rsZWJ + '(?:' + [
    $76cfcb23d8197d02$var$rsNonAstral,
    $76cfcb23d8197d02$var$rsRegional,
    $76cfcb23d8197d02$var$rsSurrPair
].join('|') + ')' + $76cfcb23d8197d02$var$rsOptVar + $76cfcb23d8197d02$var$reOptMod + ')*', $76cfcb23d8197d02$var$rsSeq = $76cfcb23d8197d02$var$rsOptVar + $76cfcb23d8197d02$var$reOptMod + $76cfcb23d8197d02$var$rsOptJoin, $76cfcb23d8197d02$var$rsEmoji = '(?:' + [
    $76cfcb23d8197d02$var$rsDingbat,
    $76cfcb23d8197d02$var$rsRegional,
    $76cfcb23d8197d02$var$rsSurrPair
].join('|') + ')' + $76cfcb23d8197d02$var$rsSeq, $76cfcb23d8197d02$var$rsSymbol = '(?:' + [
    $76cfcb23d8197d02$var$rsNonAstral + $76cfcb23d8197d02$var$rsCombo + '?',
    $76cfcb23d8197d02$var$rsCombo,
    $76cfcb23d8197d02$var$rsRegional,
    $76cfcb23d8197d02$var$rsSurrPair,
    $76cfcb23d8197d02$var$rsAstral
].join('|') + ')';
/** Used to match apostrophes. */ var $76cfcb23d8197d02$var$reApos = RegExp($76cfcb23d8197d02$var$rsApos, 'g');
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $76cfcb23d8197d02$var$reComboMark = RegExp($76cfcb23d8197d02$var$rsCombo, 'g');
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $76cfcb23d8197d02$var$reUnicode = RegExp($76cfcb23d8197d02$var$rsFitz + '(?=' + $76cfcb23d8197d02$var$rsFitz + ')|' + $76cfcb23d8197d02$var$rsSymbol + $76cfcb23d8197d02$var$rsSeq, 'g');
/** Used to match complex or compound words. */ var $76cfcb23d8197d02$var$reUnicodeWord = RegExp([
    $76cfcb23d8197d02$var$rsUpper + '?' + $76cfcb23d8197d02$var$rsLower + '+' + $76cfcb23d8197d02$var$rsOptLowerContr + '(?=' + [
        $76cfcb23d8197d02$var$rsBreak,
        $76cfcb23d8197d02$var$rsUpper,
        '$'
    ].join('|') + ')',
    $76cfcb23d8197d02$var$rsUpperMisc + '+' + $76cfcb23d8197d02$var$rsOptUpperContr + '(?=' + [
        $76cfcb23d8197d02$var$rsBreak,
        $76cfcb23d8197d02$var$rsUpper + $76cfcb23d8197d02$var$rsLowerMisc,
        '$'
    ].join('|') + ')',
    $76cfcb23d8197d02$var$rsUpper + '?' + $76cfcb23d8197d02$var$rsLowerMisc + '+' + $76cfcb23d8197d02$var$rsOptLowerContr,
    $76cfcb23d8197d02$var$rsUpper + '+' + $76cfcb23d8197d02$var$rsOptUpperContr,
    $76cfcb23d8197d02$var$rsDigits,
    $76cfcb23d8197d02$var$rsEmoji
].join('|'), 'g');
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $76cfcb23d8197d02$var$reHasUnicode = RegExp('[' + $76cfcb23d8197d02$var$rsZWJ + $76cfcb23d8197d02$var$rsAstralRange + $76cfcb23d8197d02$var$rsComboMarksRange + $76cfcb23d8197d02$var$rsComboSymbolsRange + $76cfcb23d8197d02$var$rsVarRange + ']');
/** Used to detect strings that need a more robust regexp to match words. */ var $76cfcb23d8197d02$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/** Used to map Latin Unicode letters to basic Latin letters. */ var $76cfcb23d8197d02$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 'ss'
};
/** Detect free variable `global` from Node.js. */ var $76cfcb23d8197d02$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $76cfcb23d8197d02$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $76cfcb23d8197d02$var$root = $76cfcb23d8197d02$var$freeGlobal || $76cfcb23d8197d02$var$freeSelf || Function('return this')();
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $76cfcb23d8197d02$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array ? array.length : 0;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $76cfcb23d8197d02$var$asciiToArray(string) {
    return string.split('');
}
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $76cfcb23d8197d02$var$asciiWords(string) {
    return string.match($76cfcb23d8197d02$var$reAsciiWord) || [];
}
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $76cfcb23d8197d02$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $76cfcb23d8197d02$var$deburrLetter = $76cfcb23d8197d02$var$basePropertyOf($76cfcb23d8197d02$var$deburredLetters);
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $76cfcb23d8197d02$var$hasUnicode(string) {
    return $76cfcb23d8197d02$var$reHasUnicode.test(string);
}
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $76cfcb23d8197d02$var$hasUnicodeWord(string) {
    return $76cfcb23d8197d02$var$reHasUnicodeWord.test(string);
}
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $76cfcb23d8197d02$var$stringToArray(string) {
    return $76cfcb23d8197d02$var$hasUnicode(string) ? $76cfcb23d8197d02$var$unicodeToArray(string) : $76cfcb23d8197d02$var$asciiToArray(string);
}
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $76cfcb23d8197d02$var$unicodeToArray(string) {
    return string.match($76cfcb23d8197d02$var$reUnicode) || [];
}
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $76cfcb23d8197d02$var$unicodeWords(string) {
    return string.match($76cfcb23d8197d02$var$reUnicodeWord) || [];
}
/** Used for built-in method references. */ var $76cfcb23d8197d02$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $76cfcb23d8197d02$var$objectToString = $76cfcb23d8197d02$var$objectProto.toString;
/** Built-in value references. */ var $76cfcb23d8197d02$var$Symbol = $76cfcb23d8197d02$var$root.Symbol;
/** Used to convert symbols to primitives and strings. */ var $76cfcb23d8197d02$var$symbolProto = $76cfcb23d8197d02$var$Symbol ? $76cfcb23d8197d02$var$Symbol.prototype : undefined, $76cfcb23d8197d02$var$symbolToString = $76cfcb23d8197d02$var$symbolProto ? $76cfcb23d8197d02$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $76cfcb23d8197d02$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $76cfcb23d8197d02$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($76cfcb23d8197d02$var$isSymbol(value)) return $76cfcb23d8197d02$var$symbolToString ? $76cfcb23d8197d02$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$76cfcb23d8197d02$var$INFINITY ? '-0' : result;
}
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $76cfcb23d8197d02$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $76cfcb23d8197d02$var$baseSlice(array, start, end);
}
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $76cfcb23d8197d02$var$createCaseFirst(methodName) {
    return function(string) {
        string = $76cfcb23d8197d02$var$toString(string);
        var strSymbols = $76cfcb23d8197d02$var$hasUnicode(string) ? $76cfcb23d8197d02$var$stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $76cfcb23d8197d02$var$castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $76cfcb23d8197d02$var$createCompounder(callback) {
    return function(string) {
        return $76cfcb23d8197d02$var$arrayReduce($76cfcb23d8197d02$var$words($76cfcb23d8197d02$var$deburr(string).replace($76cfcb23d8197d02$var$reApos, '')), callback, '');
    };
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $76cfcb23d8197d02$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $76cfcb23d8197d02$var$isSymbol(value) {
    return typeof value == 'symbol' || $76cfcb23d8197d02$var$isObjectLike(value) && $76cfcb23d8197d02$var$objectToString.call(value) == $76cfcb23d8197d02$var$symbolTag;
}
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $76cfcb23d8197d02$var$toString(value) {
    return value == null ? '' : $76cfcb23d8197d02$var$baseToString(value);
}
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $76cfcb23d8197d02$var$camelCase = $76cfcb23d8197d02$var$createCompounder(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $76cfcb23d8197d02$var$capitalize(word) : word);
});
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $76cfcb23d8197d02$var$capitalize(string) {
    return $76cfcb23d8197d02$var$upperFirst($76cfcb23d8197d02$var$toString(string).toLowerCase());
}
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $76cfcb23d8197d02$var$deburr(string) {
    string = $76cfcb23d8197d02$var$toString(string);
    return string && string.replace($76cfcb23d8197d02$var$reLatin, $76cfcb23d8197d02$var$deburrLetter).replace($76cfcb23d8197d02$var$reComboMark, '');
}
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $76cfcb23d8197d02$var$upperFirst = $76cfcb23d8197d02$var$createCaseFirst('toUpperCase');
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $76cfcb23d8197d02$var$words(string, pattern, guard) {
    string = $76cfcb23d8197d02$var$toString(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $76cfcb23d8197d02$var$hasUnicodeWord(string) ? $76cfcb23d8197d02$var$unicodeWords(string) : $76cfcb23d8197d02$var$asciiWords(string);
    return string.match(pattern) || [];
}
$76cfcb23d8197d02$exports = $76cfcb23d8197d02$var$camelCase;



const $47ddd57e03687cb6$export$ce8c0145cc79f29d = ()=>(0, $acw62.createContext)({
        flags: {},
        flagKeyMap: {},
        ldClient: void 0
    }), $47ddd57e03687cb6$var$u = $47ddd57e03687cb6$export$ce8c0145cc79f29d(), { Provider: $47ddd57e03687cb6$var$f, Consumer: $47ddd57e03687cb6$var$d } = $47ddd57e03687cb6$var$u, $47ddd57e03687cb6$export$24786f8731f5ec69 = {
    useCamelCaseFlagKeys: !0,
    sendEventsOnFlagRead: !0,
    reactContext: $47ddd57e03687cb6$var$u
}, $47ddd57e03687cb6$var$h = (e)=>{
    var t;
    return null != (t = e.context) ? t : e.user;
}, $47ddd57e03687cb6$export$286850650ff1d8c0 = (e)=>{
    const t = {};
    for(const r in e)0 !== r.indexOf("$") && (t[(0, (/*@__PURE__*/$parcel$interopDefault($76cfcb23d8197d02$exports)))(r)] = e[r]);
    return t;
}, $47ddd57e03687cb6$var$O = (e, t)=>{
    const r = {};
    for(const n in e)t && void 0 === t[n] || (r[n] = e[n].current);
    return r;
}, $47ddd57e03687cb6$var$b = (e, t)=>{
    const r = e.allFlags();
    return t ? Object.keys(t).reduce((e, n)=>(e[n] = Object.prototype.hasOwnProperty.call(r, n) ? r[n] : t[n], e), {}) : r;
};
function $47ddd57e03687cb6$var$m(e, t, r = $47ddd57e03687cb6$export$24786f8731f5ec69, n) {
    const o = function(e, t) {
        if (void 0 === t) return e;
        return Object.keys(t).reduce((t, r)=>($47ddd57e03687cb6$var$v(e, r) && (t[r] = e[r]), t), {});
    }(t, n), { useCamelCaseFlagKeys: a = !0 } = r, [i, s = {}] = a ? function(e) {
        const t = {}, r = {};
        for(const n in e){
            if (0 === n.indexOf("$")) continue;
            const o = (0, (/*@__PURE__*/$parcel$interopDefault($76cfcb23d8197d02$exports)))(n);
            t[o] = e[n], r[o] = n;
        }
        return [
            t,
            r
        ];
    }(o) : [
        o
    ];
    return {
        flags: r.sendEventsOnFlagRead ? $47ddd57e03687cb6$var$C(e, i, s, a) : i,
        flagKeyMap: s
    };
}
function $47ddd57e03687cb6$var$v(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}
function $47ddd57e03687cb6$var$C(e, t, r, n) {
    return new Proxy(t, {
        get (t, o, a) {
            const i = Reflect.get(t, o, a), s = n && $47ddd57e03687cb6$var$v(r, o) || $47ddd57e03687cb6$var$v(t, o);
            if ("symbol" == typeof o || !s) return i;
            if (void 0 === i) return;
            const l = n ? r[o] : o;
            return e.variation(l, i);
        }
    });
}
$47ddd57e03687cb6$export$286850650ff1d8c0.camelCaseKeys = $47ddd57e03687cb6$export$286850650ff1d8c0;
const $47ddd57e03687cb6$var$x = {
    wrapperName: "react-client-sdk",
    wrapperVersion: "3.9.0",
    sendEventsOnlyForVariation: !0
};
var $47ddd57e03687cb6$var$j = Object.defineProperty, $47ddd57e03687cb6$var$w = Object.defineProperties, $47ddd57e03687cb6$var$P = Object.getOwnPropertyDescriptors, $47ddd57e03687cb6$var$F = Object.getOwnPropertySymbols, $47ddd57e03687cb6$var$E = Object.prototype.hasOwnProperty, $47ddd57e03687cb6$var$S = Object.prototype.propertyIsEnumerable, $47ddd57e03687cb6$var$k = (e, t, r)=>t in e ? $47ddd57e03687cb6$var$j(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $47ddd57e03687cb6$var$D = (e, t)=>{
    for(var r in t || (t = {}))$47ddd57e03687cb6$var$E.call(t, r) && $47ddd57e03687cb6$var$k(e, r, t[r]);
    if ($47ddd57e03687cb6$var$F) for (var r of $47ddd57e03687cb6$var$F(t))$47ddd57e03687cb6$var$S.call(t, r) && $47ddd57e03687cb6$var$k(e, r, t[r]);
    return e;
}, $47ddd57e03687cb6$var$I = (e, t)=>$47ddd57e03687cb6$var$w(e, $47ddd57e03687cb6$var$P(t)), $47ddd57e03687cb6$var$K = (e, t, r)=>new Promise((n, o)=>{
        var a = (e)=>{
            try {
                s(r.next(e));
            } catch (e) {
                o(e);
            }
        }, i = (e)=>{
            try {
                s(r.throw(e));
            } catch (e) {
                o(e);
            }
        }, s = (e)=>e.done ? n(e.value) : Promise.resolve(e.value).then(a, i);
        s((r = r.apply(e, t)).next());
    });
class $47ddd57e03687cb6$export$c13ec8f38dc946a8 extends (0, $acw62.Component) {
    constructor(e){
        super(e), this.getReactOptions = ()=>$47ddd57e03687cb6$var$D($47ddd57e03687cb6$var$D({}, $47ddd57e03687cb6$export$24786f8731f5ec69), this.props.reactOptions), this.subscribeToChanges = (e)=>{
            const { flags: t } = this.props;
            e.on("change", (r)=>{
                const n = this.getReactOptions(), o = $47ddd57e03687cb6$var$O(r, t);
                Object.keys(o).length > 0 && this.setState((r)=>{
                    const a = $47ddd57e03687cb6$var$D($47ddd57e03687cb6$var$D({}, r.unproxiedFlags), o);
                    return $47ddd57e03687cb6$var$D($47ddd57e03687cb6$var$I($47ddd57e03687cb6$var$D({}, r), {
                        unproxiedFlags: a
                    }), $47ddd57e03687cb6$var$m(e, a, n, t));
                });
            });
        }, this.onFailed = (e, t)=>{
            this.setState((e)=>$47ddd57e03687cb6$var$I($47ddd57e03687cb6$var$D({}, e), {
                    error: t
                }));
        }, this.onReady = (e, t, r)=>{
            const n = $47ddd57e03687cb6$var$b(e, r);
            this.setState((o)=>$47ddd57e03687cb6$var$D($47ddd57e03687cb6$var$I($47ddd57e03687cb6$var$D({}, o), {
                    unproxiedFlags: n
                }), $47ddd57e03687cb6$var$m(e, n, t, r)));
        }, this.prepareLDClient = ()=>$47ddd57e03687cb6$var$K(this, null, function*() {
                var e;
                const { clientSideID: t, flags: r, options: n } = this.props;
                let o = yield this.props.ldClient;
                const a = this.getReactOptions();
                let i, l = this.state.unproxiedFlags;
                if (o) l = $47ddd57e03687cb6$var$b(o, r);
                else {
                    const c = null != (e = $47ddd57e03687cb6$var$h(this.props)) ? e : {
                        anonymous: !0,
                        kind: "user"
                    };
                    o = (0, $36d0e3de07f3b68c$export$2a47f398eeff8b01)(t, c, $47ddd57e03687cb6$var$D($47ddd57e03687cb6$var$D({}, $47ddd57e03687cb6$var$x), n));
                    try {
                        yield o.waitForInitialization(this.props.timeout), l = $47ddd57e03687cb6$var$b(o, r);
                    } catch (e) {
                        i = e, (null == i ? void 0 : i.name.toLowerCase().includes("timeout")) && (o.on("failed", this.onFailed), o.on("ready", ()=>{
                            this.onReady(o, a, r);
                        }));
                    }
                }
                this.setState((e)=>$47ddd57e03687cb6$var$I($47ddd57e03687cb6$var$D($47ddd57e03687cb6$var$I($47ddd57e03687cb6$var$D({}, e), {
                        unproxiedFlags: l
                    }), $47ddd57e03687cb6$var$m(o, l, a, r)), {
                        ldClient: o,
                        error: i
                    })), this.subscribeToChanges(o);
            });
        const { options: t } = e;
        if (this.state = {
            flags: {},
            unproxiedFlags: {},
            flagKeyMap: {}
        }, t) {
            const { bootstrap: e } = t;
            if (e && "localStorage" !== e) {
                const { useCamelCaseFlagKeys: t } = this.getReactOptions();
                this.state = {
                    flags: t ? $47ddd57e03687cb6$export$286850650ff1d8c0(e) : e,
                    unproxiedFlags: e,
                    flagKeyMap: {}
                };
            }
        }
    }
    componentDidMount() {
        return $47ddd57e03687cb6$var$K(this, null, function*() {
            const { deferInitialization: e } = this.props;
            e && !$47ddd57e03687cb6$var$h(this.props) || (yield this.prepareLDClient());
        });
    }
    componentDidUpdate(e) {
        return $47ddd57e03687cb6$var$K(this, null, function*() {
            const { deferInitialization: t } = this.props, r = !$47ddd57e03687cb6$var$h(e) && $47ddd57e03687cb6$var$h(this.props);
            t && r && (yield this.prepareLDClient());
        });
    }
    render() {
        const { flags: e, flagKeyMap: r, ldClient: n, error: o } = this.state, { reactContext: a } = this.getReactOptions();
        return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(a.Provider, {
            value: {
                flags: e,
                flagKeyMap: r,
                ldClient: n,
                error: o
            }
        }, this.props.children);
    }
}
var $47ddd57e03687cb6$var$M = Object.defineProperty, $47ddd57e03687cb6$var$L = Object.defineProperties, $47ddd57e03687cb6$var$z = Object.getOwnPropertyDescriptors, $47ddd57e03687cb6$var$T = Object.getOwnPropertySymbols, $47ddd57e03687cb6$var$V = Object.prototype.hasOwnProperty, $47ddd57e03687cb6$var$$ = Object.prototype.propertyIsEnumerable, $47ddd57e03687cb6$var$N = (e, t, r)=>t in e ? $47ddd57e03687cb6$var$M(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $47ddd57e03687cb6$var$U = (e, t)=>{
    for(var r in t || (t = {}))$47ddd57e03687cb6$var$V.call(t, r) && $47ddd57e03687cb6$var$N(e, r, t[r]);
    if ($47ddd57e03687cb6$var$T) for (var r of $47ddd57e03687cb6$var$T(t))$47ddd57e03687cb6$var$$.call(t, r) && $47ddd57e03687cb6$var$N(e, r, t[r]);
    return e;
};
function $47ddd57e03687cb6$export$39143e8ef25ed6fd(t) {
    return function(r) {
        const { reactOptions: n } = t, o = $47ddd57e03687cb6$var$U($47ddd57e03687cb6$var$U({}, $47ddd57e03687cb6$export$24786f8731f5ec69), n), a = (i = $47ddd57e03687cb6$var$U({}, t), $47ddd57e03687cb6$var$L(i, $47ddd57e03687cb6$var$z({
            reactOptions: o
        })));
        var i;
        function s(t) {
            return $acw62.createElement($47ddd57e03687cb6$export$c13ec8f38dc946a8, $47ddd57e03687cb6$var$U({}, a), $acw62.createElement(r, $47ddd57e03687cb6$var$U({}, t)));
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($72623ab6bcb0a33b$exports)))(s, r), s;
    };
}
var $47ddd57e03687cb6$var$A = Object.defineProperty, $47ddd57e03687cb6$var$B = Object.defineProperties, $47ddd57e03687cb6$var$G = Object.getOwnPropertyDescriptors, $47ddd57e03687cb6$var$H = Object.getOwnPropertySymbols, $47ddd57e03687cb6$var$J = Object.prototype.hasOwnProperty, $47ddd57e03687cb6$var$Q = Object.prototype.propertyIsEnumerable, $47ddd57e03687cb6$var$W = (e, t, r)=>t in e ? $47ddd57e03687cb6$var$A(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $47ddd57e03687cb6$var$X = (e, t)=>{
    for(var r in t || (t = {}))$47ddd57e03687cb6$var$J.call(t, r) && $47ddd57e03687cb6$var$W(e, r, t[r]);
    if ($47ddd57e03687cb6$var$H) for (var r of $47ddd57e03687cb6$var$H(t))$47ddd57e03687cb6$var$Q.call(t, r) && $47ddd57e03687cb6$var$W(e, r, t[r]);
    return e;
}, $47ddd57e03687cb6$var$Y = (e, t)=>$47ddd57e03687cb6$var$B(e, $47ddd57e03687cb6$var$G(t));
function $47ddd57e03687cb6$export$22bf485402efd36e(e) {
    var r, n, i;
    return r = this, n = null, i = function*() {
        var r, n;
        const { clientSideID: i, flags: l, options: c, reactOptions: p } = e, u = $47ddd57e03687cb6$var$X($47ddd57e03687cb6$var$X({}, $47ddd57e03687cb6$export$24786f8731f5ec69), p), f = null != (r = $47ddd57e03687cb6$var$h(e)) ? r : {
            anonymous: !0,
            kind: "user"
        };
        let d, g = {};
        const v = null != (n = yield e.ldClient) ? n : (0, $36d0e3de07f3b68c$export$2a47f398eeff8b01)(i, f, $47ddd57e03687cb6$var$X($47ddd57e03687cb6$var$X({}, $47ddd57e03687cb6$var$x), c));
        try {
            yield v.waitForInitialization(e.timeout), g = $47ddd57e03687cb6$var$b(v, l);
        } catch (e) {
            d = e;
        }
        const C = (null == c ? void 0 : c.bootstrap) && "localStorage" !== c.bootstrap ? c.bootstrap : g;
        return ({ children: e })=>{
            const [r, n] = (0, $acw62.useState)(()=>$47ddd57e03687cb6$var$Y($47ddd57e03687cb6$var$X({
                    unproxiedFlags: C
                }, $47ddd57e03687cb6$var$m(v, C, u, l)), {
                    ldClient: v,
                    error: d
                }));
            (0, $acw62.useEffect)(()=>{
                function e(e) {
                    const t = $47ddd57e03687cb6$var$O(e, l);
                    Object.keys(t).length > 0 && n((e)=>{
                        const r = $47ddd57e03687cb6$var$X($47ddd57e03687cb6$var$X({}, e.unproxiedFlags), t);
                        return $47ddd57e03687cb6$var$X($47ddd57e03687cb6$var$Y($47ddd57e03687cb6$var$X({}, e), {
                            unproxiedFlags: r
                        }), $47ddd57e03687cb6$var$m(v, r, u, l));
                    });
                }
                function t() {
                    const e = $47ddd57e03687cb6$var$b(v, l);
                    n((t)=>$47ddd57e03687cb6$var$X($47ddd57e03687cb6$var$Y($47ddd57e03687cb6$var$X({}, t), {
                            unproxiedFlags: e
                        }), $47ddd57e03687cb6$var$m(v, e, u, l)));
                }
                function r(e) {
                    n((t)=>$47ddd57e03687cb6$var$Y($47ddd57e03687cb6$var$X({}, t), {
                            error: e
                        }));
                }
                return v.on("change", e), (null == d ? void 0 : d.name.toLowerCase().includes("timeout")) && (v.on("failed", r), v.on("ready", t)), function() {
                    v.off("change", e), v.off("failed", r), v.off("ready", t);
                };
            }, []);
            const i = r, { unproxiedFlags: s } = i, c = ((e, t)=>{
                var r = {};
                for(var n in e)$47ddd57e03687cb6$var$J.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
                if (null != e && $47ddd57e03687cb6$var$H) for (var n of $47ddd57e03687cb6$var$H(e))t.indexOf(n) < 0 && $47ddd57e03687cb6$var$Q.call(e, n) && (r[n] = e[n]);
                return r;
            })(i, [
                "unproxiedFlags"
            ]), { reactContext: p } = u;
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(p.Provider, {
                value: c
            }, e);
        };
    }, new Promise((e, t)=>{
        var o = (e)=>{
            try {
                s(i.next(e));
            } catch (e) {
                t(e);
            }
        }, a = (e)=>{
            try {
                s(i.throw(e));
            } catch (e) {
                t(e);
            }
        }, s = (t)=>t.done ? e(t.value) : Promise.resolve(t.value).then(o, a);
        s((i = i.apply(r, n)).next());
    });
}
var $47ddd57e03687cb6$var$_ = Object.defineProperty, $47ddd57e03687cb6$var$ee = Object.getOwnPropertySymbols, $47ddd57e03687cb6$var$te = Object.prototype.hasOwnProperty, $47ddd57e03687cb6$var$re = Object.prototype.propertyIsEnumerable, $47ddd57e03687cb6$var$ne = (e, t, r)=>t in e ? $47ddd57e03687cb6$var$_(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: r
    }) : e[t] = r, $47ddd57e03687cb6$var$oe = (e, t)=>{
    for(var r in t || (t = {}))$47ddd57e03687cb6$var$te.call(t, r) && $47ddd57e03687cb6$var$ne(e, r, t[r]);
    if ($47ddd57e03687cb6$var$ee) for (var r of $47ddd57e03687cb6$var$ee(t))$47ddd57e03687cb6$var$re.call(t, r) && $47ddd57e03687cb6$var$ne(e, r, t[r]);
    return e;
};
function $47ddd57e03687cb6$export$881d030e8b53e212(t = {
    clientOnly: !1
}) {
    return function(r) {
        var n;
        const o = null != (n = t.reactContext) ? n : $47ddd57e03687cb6$export$24786f8731f5ec69.reactContext;
        return (n)=>$acw62.createElement(o.Consumer, null, ({ flags: o, ldClient: a })=>t.clientOnly ? $acw62.createElement(r, $47ddd57e03687cb6$var$oe({
                    ldClient: a
                }, n)) : $acw62.createElement(r, $47ddd57e03687cb6$var$oe({
                    flags: o,
                    ldClient: a
                }, n)));
    };
}
const $47ddd57e03687cb6$export$2879604e6aec4ab = (e)=>{
    const { flags: t } = (0, $acw62.useContext)(null != e ? e : $47ddd57e03687cb6$export$24786f8731f5ec69.reactContext);
    return t;
}, $47ddd57e03687cb6$export$7e29760eb21080eb = (e)=>{
    const { ldClient: t } = (0, $acw62.useContext)(null != e ? e : $47ddd57e03687cb6$export$24786f8731f5ec69.reactContext);
    return t;
};
function $47ddd57e03687cb6$export$95ba6b0917914a5e(e) {
    const { error: t } = (0, $acw62.useContext)(null != e ? e : $47ddd57e03687cb6$export$24786f8731f5ec69.reactContext);
    return t;
}


var $798e894a39525bfd$exports = {};
$parcel$export($798e894a39525bfd$exports, "BooleanParam", () => $edbc22aa0be45f44$export$3117e3aa90640455);
$parcel$export($798e894a39525bfd$exports, "createEnumParam", () => $edbc22aa0be45f44$export$54e6d6dcaa879431);
$parcel$export($798e894a39525bfd$exports, "JsonParam", () => $edbc22aa0be45f44$export$4c7eaae15e9a9af5);
$parcel$export($798e894a39525bfd$exports, "NumberParam", () => $edbc22aa0be45f44$export$618b01d7ec7ac09d);
$parcel$export($798e894a39525bfd$exports, "StringParam", () => $edbc22aa0be45f44$export$cc4e5467ec2866fa);
$parcel$export($798e894a39525bfd$exports, "transformSearchStringJsonSafe", () => $c1c13b455d7842dc$export$62f639b96e7f6421);
$parcel$export($798e894a39525bfd$exports, "withDefault", () => $87c38218c747143a$export$36faa878fcded3d7);

$parcel$export($798e894a39525bfd$exports, "QueryParamProvider", () => $25251e27701bd9d9$export$64222bfa440b0c2);
$parcel$export($798e894a39525bfd$exports, "useQueryParams", () => $9963aa6f9102c92d$export$b37ee0d76c6d2fbc);
function $87c38218c747143a$export$36faa878fcded3d7(param, defaultValue, includeNull = true) {
    const decodeWithDefault = (...args)=>{
        const decodedValue = param.decode(...args);
        if (decodedValue === void 0) return defaultValue;
        if (includeNull) {
            if (decodedValue === null) return defaultValue;
            else return decodedValue;
        }
        return decodedValue;
    };
    return {
        ...param,
        default: defaultValue,
        decode: decodeWithDefault
    };
}
var $87c38218c747143a$export$2e2bcd8739ae039 = $87c38218c747143a$export$36faa878fcded3d7;


function $b3ce04ddf6d7f19b$var$getEncodedValue(input, allowEmptyString) {
    if (input == null) return input;
    if (input.length === 0 && (!allowEmptyString || allowEmptyString && input !== "")) return null;
    const str = input instanceof Array ? input[0] : input;
    if (str == null) return str;
    if (!allowEmptyString && str === "") return null;
    return str;
}
function $b3ce04ddf6d7f19b$var$getEncodedValueArray(input) {
    if (input == null) return input;
    return input instanceof Array ? input : input === "" ? [] : [
        input
    ];
}
function $b3ce04ddf6d7f19b$export$1f6496565fa978d9(date) {
    if (date == null) return date;
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`;
}
function $b3ce04ddf6d7f19b$export$26f796a90b2e5c7c(input) {
    const dateString = $b3ce04ddf6d7f19b$var$getEncodedValue(input);
    if (dateString == null) return dateString;
    const parts = dateString.split("-");
    if (parts[1] != null) parts[1] -= 1;
    else {
        parts[1] = 0;
        parts[2] = 1;
    }
    const decoded = new Date(...parts);
    if (isNaN(decoded.getTime())) return null;
    return decoded;
}
function $b3ce04ddf6d7f19b$export$9bf71b8e0dd729c0(date) {
    if (date == null) return date;
    return date.toISOString();
}
function $b3ce04ddf6d7f19b$export$4611288935f7bd58(input) {
    const dateString = $b3ce04ddf6d7f19b$var$getEncodedValue(input);
    if (dateString == null) return dateString;
    const decoded = new Date(dateString);
    if (isNaN(decoded.getTime())) return null;
    return decoded;
}
function $b3ce04ddf6d7f19b$export$1b0ad99313e5e2c6(bool) {
    if (bool == null) return bool;
    return bool ? "1" : "0";
}
function $b3ce04ddf6d7f19b$export$7e6b1898d6f2947e(input) {
    const boolStr = $b3ce04ddf6d7f19b$var$getEncodedValue(input);
    if (boolStr == null) return boolStr;
    if (boolStr === "1") return true;
    else if (boolStr === "0") return false;
    return null;
}
function $b3ce04ddf6d7f19b$export$ed41c27e89606957(num) {
    if (num == null) return num;
    return String(num);
}
function $b3ce04ddf6d7f19b$export$874d75d651b25595(input) {
    const numStr = $b3ce04ddf6d7f19b$var$getEncodedValue(input);
    if (numStr == null) return numStr;
    if (numStr === "") return null;
    const result = +numStr;
    return result;
}
function $b3ce04ddf6d7f19b$export$8146d2e653b87d6a(str) {
    if (str == null) return str;
    return String(str);
}
function $b3ce04ddf6d7f19b$export$a0fb664af7d0cc44(input) {
    const str = $b3ce04ddf6d7f19b$var$getEncodedValue(input, true);
    if (str == null) return str;
    return String(str);
}
function $b3ce04ddf6d7f19b$export$7dd779fcbafd51fd(input, enumValues) {
    const str = $b3ce04ddf6d7f19b$export$a0fb664af7d0cc44(input);
    if (str == null) return str;
    return enumValues.includes(str) ? str : void 0;
}
function $b3ce04ddf6d7f19b$export$a648efa4ca4156e0(input, enumValues) {
    const arr = $b3ce04ddf6d7f19b$export$81879b02e9646afe(input);
    if (arr == null) return arr;
    if (!arr.length) return void 0;
    return arr.every((str)=>str != null && enumValues.includes(str)) ? arr : void 0;
}
function $b3ce04ddf6d7f19b$export$3b407212e10790da(input, enumValues, entrySeparator = "_") {
    if (input != null && Array.isArray(input) && !input.length) return void 0;
    const arr = $b3ce04ddf6d7f19b$export$8ba6fb21700f6061(input, entrySeparator);
    return $b3ce04ddf6d7f19b$export$a648efa4ca4156e0(arr, enumValues);
}
function $b3ce04ddf6d7f19b$export$a865279d3b7b5f70(any) {
    if (any == null) return any;
    return JSON.stringify(any);
}
function $b3ce04ddf6d7f19b$export$cd9ded616c0cfb91(input) {
    const jsonStr = $b3ce04ddf6d7f19b$var$getEncodedValue(input);
    if (jsonStr == null) return jsonStr;
    let result = null;
    try {
        result = JSON.parse(jsonStr);
    } catch (e) {}
    return result;
}
function $b3ce04ddf6d7f19b$export$5953f05715bb15e3(array) {
    if (array == null) return array;
    return array;
}
function $b3ce04ddf6d7f19b$export$81879b02e9646afe(input) {
    const arr = $b3ce04ddf6d7f19b$var$getEncodedValueArray(input);
    if (arr == null) return arr;
    return arr;
}
function $b3ce04ddf6d7f19b$export$5f4cea45fa96beab(array) {
    if (array == null) return array;
    return array.map(String);
}
function $b3ce04ddf6d7f19b$export$77393dbf77646190(input) {
    const arr = $b3ce04ddf6d7f19b$export$81879b02e9646afe(input);
    if (arr == null) return arr;
    return arr.map((d)=>d === "" || d == null ? null : +d);
}
function $b3ce04ddf6d7f19b$export$eb244bdf28ee09ff(array, entrySeparator = "_") {
    if (array == null) return array;
    return array.join(entrySeparator);
}
function $b3ce04ddf6d7f19b$export$8ba6fb21700f6061(input, entrySeparator = "_") {
    const arrayStr = $b3ce04ddf6d7f19b$var$getEncodedValue(input, true);
    if (arrayStr == null) return arrayStr;
    if (arrayStr === "") return [];
    return arrayStr.split(entrySeparator);
}
const $b3ce04ddf6d7f19b$export$778c4de8ad8b83d9 = $b3ce04ddf6d7f19b$export$eb244bdf28ee09ff;
function $b3ce04ddf6d7f19b$export$14336aab2e53912b(arrayStr, entrySeparator = "_") {
    const decoded = $b3ce04ddf6d7f19b$export$8ba6fb21700f6061(arrayStr, entrySeparator);
    if (decoded == null) return decoded;
    return decoded.map((d)=>d === "" || d == null ? null : +d);
}
function $b3ce04ddf6d7f19b$export$c57605e441fcb142(obj, keyValSeparator = "-", entrySeparator = "_") {
    if (obj == null) return obj;
    if (!Object.keys(obj).length) return "";
    return Object.keys(obj).map((key)=>`${key}${keyValSeparator}${obj[key]}`).join(entrySeparator);
}
function $b3ce04ddf6d7f19b$export$57868717af36a6c(input, keyValSeparator = "-", entrySeparator = "_") {
    const objStr = $b3ce04ddf6d7f19b$var$getEncodedValue(input, true);
    if (objStr == null) return objStr;
    if (objStr === "") return {};
    const obj = {};
    const keyValSeparatorRegExp = new RegExp(`${keyValSeparator}(.*)`);
    objStr.split(entrySeparator).forEach((entryStr)=>{
        const [key, value] = entryStr.split(keyValSeparatorRegExp);
        obj[key] = value;
    });
    return obj;
}
const $b3ce04ddf6d7f19b$export$1d793c5f2822542d = $b3ce04ddf6d7f19b$export$c57605e441fcb142;
function $b3ce04ddf6d7f19b$export$b06b2fb0b0c2e67(input, keyValSeparator = "-", entrySeparator = "_") {
    const decoded = $b3ce04ddf6d7f19b$export$57868717af36a6c(input, keyValSeparator, entrySeparator);
    if (decoded == null) return decoded;
    const decodedNumberObj = {};
    for (const key of Object.keys(decoded))decodedNumberObj[key] = $b3ce04ddf6d7f19b$export$874d75d651b25595(decoded[key]);
    return decodedNumberObj;
}



const $edbc22aa0be45f44$export$cc4e5467ec2866fa = {
    encode: $b3ce04ddf6d7f19b$export$8146d2e653b87d6a,
    decode: $b3ce04ddf6d7f19b$export$a0fb664af7d0cc44
};
const $edbc22aa0be45f44$export$54e6d6dcaa879431 = (enumValues)=>({
        encode: $b3ce04ddf6d7f19b$export$8146d2e653b87d6a,
        decode: (input)=>$b3ce04ddf6d7f19b$export$7dd779fcbafd51fd(input, enumValues)
    });
const $edbc22aa0be45f44$export$145c5c0af2294393 = (enumValues)=>({
        encode: (text)=>$b3ce04ddf6d7f19b$export$5953f05715bb15e3(text == null || Array.isArray(text) ? text : [
                text
            ]),
        decode: (input)=>$b3ce04ddf6d7f19b$export$a648efa4ca4156e0(input, enumValues)
    });
const $edbc22aa0be45f44$export$64e36efb3b68eb06 = (enumValues, entrySeparator = "_")=>({
        encode: (text)=>$b3ce04ddf6d7f19b$export$eb244bdf28ee09ff(text == null || Array.isArray(text) ? text : [
                text
            ], entrySeparator),
        decode: (input)=>$b3ce04ddf6d7f19b$export$3b407212e10790da(input, enumValues, entrySeparator)
    });
const $edbc22aa0be45f44$export$618b01d7ec7ac09d = {
    encode: $b3ce04ddf6d7f19b$export$ed41c27e89606957,
    decode: $b3ce04ddf6d7f19b$export$874d75d651b25595
};
const $edbc22aa0be45f44$export$c8fb36dadbc00625 = {
    encode: $b3ce04ddf6d7f19b$export$c57605e441fcb142,
    decode: $b3ce04ddf6d7f19b$export$57868717af36a6c
};
const $edbc22aa0be45f44$export$9d0544e81e01aced = {
    encode: $b3ce04ddf6d7f19b$export$5953f05715bb15e3,
    decode: $b3ce04ddf6d7f19b$export$81879b02e9646afe
};
const $edbc22aa0be45f44$export$e28e4676bad837d1 = {
    encode: $b3ce04ddf6d7f19b$export$5f4cea45fa96beab,
    decode: $b3ce04ddf6d7f19b$export$77393dbf77646190
};
const $edbc22aa0be45f44$export$4c7eaae15e9a9af5 = {
    encode: $b3ce04ddf6d7f19b$export$a865279d3b7b5f70,
    decode: $b3ce04ddf6d7f19b$export$cd9ded616c0cfb91
};
const $edbc22aa0be45f44$export$969cf60553ed8597 = {
    encode: $b3ce04ddf6d7f19b$export$1f6496565fa978d9,
    decode: $b3ce04ddf6d7f19b$export$26f796a90b2e5c7c,
    equals: (valueA, valueB)=>{
        if (valueA === valueB) return true;
        if (valueA == null || valueB == null) return valueA === valueB;
        return valueA.getFullYear() === valueB.getFullYear() && valueA.getMonth() === valueB.getMonth() && valueA.getDate() === valueB.getDate();
    }
};
const $edbc22aa0be45f44$export$51b32f8baed4ecf9 = {
    encode: $b3ce04ddf6d7f19b$export$9bf71b8e0dd729c0,
    decode: $b3ce04ddf6d7f19b$export$4611288935f7bd58,
    equals: (valueA, valueB)=>{
        if (valueA === valueB) return true;
        if (valueA == null || valueB == null) return valueA === valueB;
        return valueA.valueOf() === valueB.valueOf();
    }
};
const $edbc22aa0be45f44$export$3117e3aa90640455 = {
    encode: $b3ce04ddf6d7f19b$export$1b0ad99313e5e2c6,
    decode: $b3ce04ddf6d7f19b$export$7e6b1898d6f2947e
};
const $edbc22aa0be45f44$export$db845d497684641f = {
    encode: $b3ce04ddf6d7f19b$export$1d793c5f2822542d,
    decode: $b3ce04ddf6d7f19b$export$b06b2fb0b0c2e67
};
const $edbc22aa0be45f44$export$98404c17996d1897 = {
    encode: $b3ce04ddf6d7f19b$export$eb244bdf28ee09ff,
    decode: $b3ce04ddf6d7f19b$export$8ba6fb21700f6061
};
const $edbc22aa0be45f44$export$80f4dec81c832610 = {
    encode: $b3ce04ddf6d7f19b$export$778c4de8ad8b83d9,
    decode: $b3ce04ddf6d7f19b$export$14336aab2e53912b
};


function $3f23ef6aa3514b27$export$b0e71db9c1dc37c3(encodedParams) {
    const params = new URLSearchParams();
    const entries = Object.entries(encodedParams);
    for (const [key, value] of entries){
        if (value === void 0) continue;
        if (value === null) continue;
        if (Array.isArray(value)) for (const item of value)params.append(key, item != null ? item : "");
        else params.append(key, value);
    }
    return params.toString();
}



const $c1c13b455d7842dc$var$JSON_SAFE_CHARS = `{}[],":`.split("").map((d)=>[
        d,
        encodeURIComponent(d)
    ]);
function $c1c13b455d7842dc$var$getHrefFromLocation(location, search) {
    let href = search;
    if (location.href) try {
        const url = new URL(location.href);
        href = `${url.origin}${url.pathname}${search}`;
    } catch (e) {
        href = "";
    }
    return href;
}
function $c1c13b455d7842dc$export$62f639b96e7f6421(searchString) {
    let str = searchString;
    for (let [char, code] of $c1c13b455d7842dc$var$JSON_SAFE_CHARS)str = str.replace(new RegExp("\\" + code, "g"), char);
    return str;
}
function $c1c13b455d7842dc$export$735c4579e2cd6507(encodedQuery, location, objectToSearchStringFn = (0, $3f23ef6aa3514b27$export$b0e71db9c1dc37c3)) {
    let encodedSearchString = objectToSearchStringFn(encodedQuery);
    const search = encodedSearchString.length ? `?${encodedSearchString}` : "";
    const newLocation = {
        ...location,
        key: `${Date.now()}`,
        href: $c1c13b455d7842dc$var$getHrefFromLocation(location, search),
        search: search,
        query: encodedQuery
    };
    return newLocation;
}
function $c1c13b455d7842dc$export$ec01f784fd9166fb(encodedQueryReplacements, location, objectToSearchStringFn = (0, $3f23ef6aa3514b27$export$b0e71db9c1dc37c3), searchStringToObjectFn = (0, $121bff6d13a97dff$export$3692e2d4bb392c5b)) {
    const currQuery = searchStringToObjectFn(location.search);
    const newQuery = {
        ...currQuery,
        ...encodedQueryReplacements
    };
    return $c1c13b455d7842dc$export$735c4579e2cd6507(newQuery, location, objectToSearchStringFn);
}


function $c57ae42e518e0de7$export$8c0ce924e434923b(paramConfigMap, query) {
    const encodedQuery = {};
    const paramNames = Object.keys(query);
    for (const paramName of paramNames){
        const decodedValue = query[paramName];
        if (!paramConfigMap[paramName]) encodedQuery[paramName] = decodedValue == null ? decodedValue : String(decodedValue);
        else encodedQuery[paramName] = paramConfigMap[paramName].encode(query[paramName]);
    }
    return encodedQuery;
}
var $c57ae42e518e0de7$export$2e2bcd8739ae039 = $c57ae42e518e0de7$export$8c0ce924e434923b;


function $4b969cedef8901d9$export$6025d61c37f75253(paramConfigMap, encodedQuery) {
    const decodedQuery = {};
    const paramNames = Object.keys(paramConfigMap);
    for (const encodedKey of Object.keys(encodedQuery))if (paramConfigMap[encodedKey] == null) paramNames.push(encodedKey);
    for (const paramName of paramNames){
        const encodedValue = encodedQuery[paramName];
        if (!paramConfigMap[paramName]) {
            console.warn(`Passing through parameter ${paramName} during decoding since it was not configured.`);
            decodedQuery[paramName] = encodedValue;
        } else decodedQuery[paramName] = paramConfigMap[paramName].decode(encodedValue);
    }
    return decodedQuery;
}


function $121bff6d13a97dff$export$3692e2d4bb392c5b(searchString) {
    const params = new URLSearchParams(searchString);
    const parsed = {};
    for (let [key, value] of params)if (Object.prototype.hasOwnProperty.call(parsed, key)) {
        if (Array.isArray(parsed[key])) parsed[key].push(value);
        else parsed[key] = [
            parsed[key],
            value
        ];
    } else parsed[key] = value;
    return parsed;
}





var $f5001d18c2e12e66$exports = {};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

class $0825790a9cd16361$export$23edf466d4341f84 {
    constructor(){
        this.paramsMap = /* @__PURE__ */ new Map();
        this.registeredParams = /* @__PURE__ */ new Map();
    }
    set(param, stringifiedValue, decodedValue, decode) {
        this.paramsMap.set(param, {
            stringified: stringifiedValue,
            decoded: decodedValue,
            decode: decode
        });
    }
    has(param, stringifiedValue, decode) {
        if (!this.paramsMap.has(param)) return false;
        const cachedParam = this.paramsMap.get(param);
        if (!cachedParam) return false;
        return cachedParam.stringified === stringifiedValue && (decode == null || cachedParam.decode === decode);
    }
    get(param) {
        var _a;
        if (this.paramsMap.has(param)) return (_a = this.paramsMap.get(param)) == null ? void 0 : _a.decoded;
        return void 0;
    }
    registerParams(paramNames) {
        for (const param of paramNames){
            const currValue = this.registeredParams.get(param) || 0;
            this.registeredParams.set(param, currValue + 1);
        }
    }
    unregisterParams(paramNames) {
        for (const param of paramNames){
            const value = (this.registeredParams.get(param) || 0) - 1;
            if (value <= 0) {
                this.registeredParams.delete(param);
                if (this.paramsMap.has(param)) this.paramsMap.delete(param);
            } else this.registeredParams.set(param, value);
        }
    }
    clear() {
        this.paramsMap.clear();
        this.registeredParams.clear();
    }
}
const $0825790a9cd16361$export$1eab7ffc45b39ec0 = new $0825790a9cd16361$export$23edf466d4341f84();



function $3f77c4f46480d722$export$9bcd7a69a977fc5a(paramConfigMapWithInherit, options) {
    var _a, _b, _c;
    const paramConfigMap = {};
    let hasInherit = false;
    const hookKeys = Object.keys(paramConfigMapWithInherit);
    let paramKeys = hookKeys;
    const includeKnownParams = options.includeKnownParams || options.includeKnownParams !== false && hookKeys.length === 0;
    if (includeKnownParams) {
        const knownKeys = Object.keys((_a = options.params) != null ? _a : {});
        paramKeys.push(...knownKeys);
    }
    for (const key of paramKeys){
        const param = paramConfigMapWithInherit[key];
        if (param != null && typeof param === "object") {
            paramConfigMap[key] = param;
            continue;
        }
        hasInherit = true;
        paramConfigMap[key] = (_c = (_b = options.params) == null ? void 0 : _b[key]) != null ? _c : (0, $edbc22aa0be45f44$export$cc4e5467ec2866fa);
    }
    if (!hasInherit) return paramConfigMapWithInherit;
    return paramConfigMap;
}
function $3f77c4f46480d722$export$d1419dfe7609108a(baseParamConfigMap, paramKeys, inheritedParams, defaultParam) {
    var _a;
    if (!inheritedParams || !paramKeys.length) return baseParamConfigMap;
    let paramConfigMap = {
        ...baseParamConfigMap
    };
    let hasInherit = false;
    for (const paramKey of paramKeys)if (!Object.prototype.hasOwnProperty.call(paramConfigMap, paramKey)) {
        paramConfigMap[paramKey] = (_a = inheritedParams[paramKey]) != null ? _a : defaultParam;
        hasInherit = true;
    }
    if (!hasInherit) return baseParamConfigMap;
    return paramConfigMap;
}


const $23980ae42c94a043$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $23980ae42c94a043$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $23980ae42c94a043$export$2e2bcd8739ae039(objA, objB, equalMap) {
    var _a, _b;
    if ($23980ae42c94a043$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        const isEqual = (_b = (_a = equalMap == null ? void 0 : equalMap[keysA[i]]) == null ? void 0 : _a.equals) != null ? _b : $23980ae42c94a043$var$is;
        if (!$23980ae42c94a043$var$hasOwnProperty.call(objB, keysA[i]) || !isEqual(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}


function $01d6f59b8bcf6f11$export$fa8e6c4aa23a0571(parsedParams, paramConfigMap, decodedParamCache) {
    const decodedValues = {};
    const paramNames = Object.keys(paramConfigMap);
    for (const paramName of paramNames){
        const paramConfig = paramConfigMap[paramName];
        const encodedValue = parsedParams[paramName];
        let decodedValue;
        if (decodedParamCache.has(paramName, encodedValue, paramConfig.decode)) decodedValue = decodedParamCache.get(paramName);
        else {
            decodedValue = paramConfig.decode(encodedValue);
            if (paramConfig.equals && decodedParamCache.has(paramName, encodedValue)) {
                const oldDecodedValue = decodedParamCache.get(paramName);
                if (paramConfig.equals(decodedValue, oldDecodedValue)) decodedValue = oldDecodedValue;
            }
            if (decodedValue !== void 0) decodedParamCache.set(paramName, encodedValue, decodedValue, paramConfig.decode);
        }
        if (decodedValue === void 0 && paramConfig.default !== void 0) decodedValue = paramConfig.default;
        decodedValues[paramName] = decodedValue;
    }
    return decodedValues;
}
function $01d6f59b8bcf6f11$export$9e1f95e6ce6dc2d9() {
    let prevDecodedValues;
    function stableGetLatest(parsedParams, paramConfigMap, decodedParamCache) {
        const decodedValues = $01d6f59b8bcf6f11$export$fa8e6c4aa23a0571(parsedParams, paramConfigMap, decodedParamCache);
        if (prevDecodedValues != null && (0, $23980ae42c94a043$export$2e2bcd8739ae039)(prevDecodedValues, decodedValues)) return prevDecodedValues;
        prevDecodedValues = decodedValues;
        return decodedValues;
    }
    return stableGetLatest;
}



function $8c061bd163885363$export$801ca9fcc0e24796(paramConfigMap) {
    let urlNameMapParts;
    for(const paramName in paramConfigMap)if (paramConfigMap[paramName].urlName) {
        const urlName = paramConfigMap[paramName].urlName;
        const part = `${urlName}\0${paramName}`;
        if (!urlNameMapParts) urlNameMapParts = [
            part
        ];
        else urlNameMapParts.push(part);
    }
    return urlNameMapParts ? urlNameMapParts.join("\n") : void 0;
}
function $8c061bd163885363$export$864607719751562e(urlNameMapStr) {
    if (!urlNameMapStr) return void 0;
    return Object.fromEntries(urlNameMapStr.split("\n").map((part)=>part.split("\0")));
}
function $8c061bd163885363$export$a75d6ab7cfc5ac50(encodedValues, paramConfigMap) {
    var _a;
    let newEncodedValues = {};
    for(const paramName in encodedValues)if (((_a = paramConfigMap[paramName]) == null ? void 0 : _a.urlName) != null) newEncodedValues[paramConfigMap[paramName].urlName] = encodedValues[paramName];
    else newEncodedValues[paramName] = encodedValues[paramName];
    return newEncodedValues;
}


let $da4002bb37eb7f5f$var$cachedSearchString;
let $da4002bb37eb7f5f$var$cachedUrlNameMapString;
let $da4002bb37eb7f5f$var$cachedSearchStringToObjectFn;
let $da4002bb37eb7f5f$var$cachedParsedQuery = {};
const $da4002bb37eb7f5f$export$26a31ec93c44cc89 = (searchStringToObject, searchString, urlNameMapStr)=>{
    if ($da4002bb37eb7f5f$var$cachedSearchString === searchString && $da4002bb37eb7f5f$var$cachedSearchStringToObjectFn === searchStringToObject && $da4002bb37eb7f5f$var$cachedUrlNameMapString === urlNameMapStr) return $da4002bb37eb7f5f$var$cachedParsedQuery;
    $da4002bb37eb7f5f$var$cachedSearchString = searchString;
    $da4002bb37eb7f5f$var$cachedSearchStringToObjectFn = searchStringToObject;
    const newParsedQuery = searchStringToObject(searchString != null ? searchString : "");
    $da4002bb37eb7f5f$var$cachedUrlNameMapString = urlNameMapStr;
    const urlNameMap = (0, $8c061bd163885363$export$864607719751562e)(urlNameMapStr);
    for (let [key, value] of Object.entries(newParsedQuery)){
        if (urlNameMap == null ? void 0 : urlNameMap[key]) {
            delete newParsedQuery[key];
            key = urlNameMap[key];
            newParsedQuery[key] = value;
        }
        const oldValue = $da4002bb37eb7f5f$var$cachedParsedQuery[key];
        if ((0, $23980ae42c94a043$export$2e2bcd8739ae039)(value, oldValue)) newParsedQuery[key] = oldValue;
    }
    $da4002bb37eb7f5f$var$cachedParsedQuery = newParsedQuery;
    return newParsedQuery;
};



const $b9539d52ff76315f$export$ba43bf67f3d48107 = {
    searchStringToObject: $121bff6d13a97dff$export$3692e2d4bb392c5b,
    objectToSearchString: $3f23ef6aa3514b27$export$b0e71db9c1dc37c3,
    updateType: "pushIn",
    includeKnownParams: void 0,
    includeAllParams: false,
    removeDefaultsFromUrl: false,
    enableBatching: false,
    skipUpdateWhenNoChange: true
};
function $b9539d52ff76315f$export$235b7fc70b9fc359(parentOptions, currOptions) {
    if (currOptions == null) currOptions = {};
    const merged = {
        ...parentOptions,
        ...currOptions
    };
    if (currOptions.params && parentOptions.params) merged.params = {
        ...parentOptions.params,
        ...currOptions.params
    };
    return merged;
}



var $acw62 = parcelRequire("acw62");

const $25251e27701bd9d9$var$providerlessContextValue = {
    adapter: {},
    options: (0, $b9539d52ff76315f$export$ba43bf67f3d48107)
};
const $25251e27701bd9d9$export$99ec8971fa59e598 = $acw62.createContext($25251e27701bd9d9$var$providerlessContextValue);
function $25251e27701bd9d9$export$e55055a19b1b0665() {
    const value = $acw62.useContext($25251e27701bd9d9$export$99ec8971fa59e598);
    if (value === void 0 || value === $25251e27701bd9d9$var$providerlessContextValue) throw new Error("useQueryParams must be used within a QueryParamProvider");
    return value;
}
function $25251e27701bd9d9$var$QueryParamProviderInner({ children: children, adapter: adapter, options: options }) {
    const { adapter: parentAdapter, options: parentOptions } = $acw62.useContext($25251e27701bd9d9$export$99ec8971fa59e598);
    const value = $acw62.useMemo(()=>{
        return {
            adapter: adapter != null ? adapter : parentAdapter,
            options: (0, $b9539d52ff76315f$export$235b7fc70b9fc359)(parentOptions, options)
        };
    }, [
        adapter,
        options,
        parentAdapter,
        parentOptions
    ]);
    return /* @__PURE__ */ $acw62.createElement($25251e27701bd9d9$export$99ec8971fa59e598.Provider, {
        value: value
    }, children);
}
function $25251e27701bd9d9$export$64222bfa440b0c2({ children: children, adapter: adapter, options: options }) {
    const Adapter = adapter;
    return Adapter ? /* @__PURE__ */ $acw62.createElement(Adapter, null, (adapter2)=>/* @__PURE__ */ $acw62.createElement($25251e27701bd9d9$var$QueryParamProviderInner, {
            adapter: adapter2,
            options: options
        }, children)) : /* @__PURE__ */ $acw62.createElement($25251e27701bd9d9$var$QueryParamProviderInner, {
        options: options
    }, children);
}
var $25251e27701bd9d9$export$2e2bcd8739ae039 = $25251e27701bd9d9$export$64222bfa440b0c2;







function $59cb217f156857e8$export$fb44f956c73b9d70(encodedValues, paramConfigMap) {
    var _a;
    for(const paramName in encodedValues)if (((_a = paramConfigMap[paramName]) == null ? void 0 : _a.default) !== void 0 && encodedValues[paramName] !== void 0) {
        const encodedDefault = paramConfigMap[paramName].encode(paramConfigMap[paramName].default);
        if (encodedDefault === encodedValues[paramName]) encodedValues[paramName] = void 0;
    }
}



function $64acea2e07137292$export$9ecca02838ba14da({ changes: changes, updateType: updateType, currentSearchString: currentSearchString, paramConfigMap: baseParamConfigMap, options: options }) {
    const { searchStringToObject: searchStringToObject, objectToSearchString: objectToSearchString } = options;
    if (updateType == null) updateType = options.updateType;
    let encodedChanges;
    const parsedParams = (0, $da4002bb37eb7f5f$export$26a31ec93c44cc89)(searchStringToObject, currentSearchString);
    const paramConfigMap = (0, $3f77c4f46480d722$export$d1419dfe7609108a)(baseParamConfigMap, Object.keys(changes), options.params);
    let changesToUse;
    if (typeof changes === "function") {
        const latestValues = (0, $01d6f59b8bcf6f11$export$fa8e6c4aa23a0571)(parsedParams, paramConfigMap, (0, $0825790a9cd16361$export$1eab7ffc45b39ec0));
        changesToUse = changes(latestValues);
    } else changesToUse = changes;
    encodedChanges = (0, $c57ae42e518e0de7$export$8c0ce924e434923b)(paramConfigMap, changesToUse);
    if (options.removeDefaultsFromUrl) (0, $59cb217f156857e8$export$fb44f956c73b9d70)(encodedChanges, paramConfigMap);
    encodedChanges = (0, $8c061bd163885363$export$a75d6ab7cfc5ac50)(encodedChanges, paramConfigMap);
    let newSearchString;
    if (updateType === "push" || updateType === "replace") newSearchString = objectToSearchString(encodedChanges);
    else newSearchString = objectToSearchString({
        ...parsedParams,
        ...encodedChanges
    });
    if ((newSearchString == null ? void 0 : newSearchString.length) && newSearchString[0] !== "?") newSearchString = `?${newSearchString}`;
    return newSearchString != null ? newSearchString : "";
}
function $64acea2e07137292$export$762bdf38e87c280d({ searchString: searchString, adapter: adapter, navigate: navigate, updateType: updateType }) {
    const currentLocation = adapter.location;
    const newLocation = {
        ...currentLocation,
        search: searchString
    };
    if (navigate) {
        if (typeof updateType === "string" && updateType.startsWith("replace")) adapter.replace(newLocation);
        else adapter.push(newLocation);
    }
}
const $64acea2e07137292$var$immediateTask = (task)=>task();
const $64acea2e07137292$var$timeoutTask = (task)=>setTimeout(()=>task(), 0);
const $64acea2e07137292$var$updateQueue = [];
function $64acea2e07137292$export$3f9c9dc8b61499e9(args, { immediate: immediate } = {}) {
    $64acea2e07137292$var$updateQueue.push(args);
    let scheduleTask = immediate ? $64acea2e07137292$var$immediateTask : $64acea2e07137292$var$timeoutTask;
    if ($64acea2e07137292$var$updateQueue.length === 1) scheduleTask(()=>{
        const updates = $64acea2e07137292$var$updateQueue.slice();
        $64acea2e07137292$var$updateQueue.length = 0;
        const initialSearchString = updates[0].currentSearchString;
        let searchString;
        for(let i = 0; i < updates.length; ++i){
            const modifiedUpdate = i === 0 ? updates[i] : {
                ...updates[i],
                currentSearchString: searchString
            };
            searchString = $64acea2e07137292$export$9ecca02838ba14da(modifiedUpdate);
        }
        if (args.options.skipUpdateWhenNoChange && searchString === initialSearchString) return;
        $64acea2e07137292$export$762bdf38e87c280d({
            searchString: searchString != null ? searchString : "",
            adapter: updates[updates.length - 1].adapter,
            navigate: true,
            updateType: updates[updates.length - 1].updateType
        });
    });
}



function $9963aa6f9102c92d$export$b37ee0d76c6d2fbc(arg1, arg2) {
    const { adapter: adapter, options: contextOptions } = (0, $25251e27701bd9d9$export$e55055a19b1b0665)();
    const [stableGetLatest] = (0, $acw62.useState)((0, $01d6f59b8bcf6f11$export$9e1f95e6ce6dc2d9));
    const { paramConfigMap: paramConfigMapWithInherit, options: options } = $9963aa6f9102c92d$var$parseArguments(arg1, arg2);
    const mergedOptions = (0, $acw62.useMemo)(()=>{
        return (0, $b9539d52ff76315f$export$235b7fc70b9fc359)(contextOptions, options);
    }, [
        contextOptions,
        options
    ]);
    let paramConfigMap = (0, $3f77c4f46480d722$export$9bcd7a69a977fc5a)(paramConfigMapWithInherit, mergedOptions);
    const parsedParams = (0, $da4002bb37eb7f5f$export$26a31ec93c44cc89)(mergedOptions.searchStringToObject, adapter.location.search, (0, $8c061bd163885363$export$801ca9fcc0e24796)(paramConfigMap));
    if (mergedOptions.includeAllParams) paramConfigMap = (0, $3f77c4f46480d722$export$d1419dfe7609108a)(paramConfigMap, Object.keys(parsedParams), mergedOptions.params, (0, $edbc22aa0be45f44$export$cc4e5467ec2866fa));
    const decodedValues = stableGetLatest(parsedParams, paramConfigMap, (0, $0825790a9cd16361$export$1eab7ffc45b39ec0));
    const paramKeyString = Object.keys(paramConfigMap).join("\0");
    (0, $acw62.useEffect)(()=>{
        const paramNames = paramKeyString.split("\0");
        (0, $0825790a9cd16361$export$1eab7ffc45b39ec0).registerParams(paramNames);
        return ()=>{
            (0, $0825790a9cd16361$export$1eab7ffc45b39ec0).unregisterParams(paramNames);
        };
    }, [
        paramKeyString
    ]);
    const callbackDependencies = {
        adapter: adapter,
        paramConfigMap: paramConfigMap,
        options: mergedOptions
    };
    const callbackDependenciesRef = (0, $acw62.useRef)(callbackDependencies);
    if (callbackDependenciesRef.current == null) callbackDependenciesRef.current = callbackDependencies;
    (0, $acw62.useEffect)(()=>{
        callbackDependenciesRef.current.adapter = adapter;
        callbackDependenciesRef.current.paramConfigMap = paramConfigMap;
        callbackDependenciesRef.current.options = mergedOptions;
    }, [
        adapter,
        paramConfigMap,
        mergedOptions
    ]);
    const [setQuery] = (0, $acw62.useState)(()=>{
        const setQuery2 = (changes, updateType)=>{
            const { adapter: adapter2, paramConfigMap: paramConfigMap2, options: options2 } = callbackDependenciesRef.current;
            if (updateType == null) updateType = options2.updateType;
            (0, $64acea2e07137292$export$3f9c9dc8b61499e9)({
                changes: changes,
                updateType: updateType,
                currentSearchString: adapter2.location.search,
                paramConfigMap: paramConfigMap2,
                options: options2,
                adapter: adapter2
            }, {
                immediate: !options2.enableBatching
            });
        };
        return setQuery2;
    });
    return [
        decodedValues,
        setQuery
    ];
}
var $9963aa6f9102c92d$export$2e2bcd8739ae039 = $9963aa6f9102c92d$export$b37ee0d76c6d2fbc;
function $9963aa6f9102c92d$var$parseArguments(arg1, arg2) {
    let paramConfigMap;
    let options;
    if (arg1 === void 0) {
        paramConfigMap = {};
        options = arg2;
    } else if (Array.isArray(arg1)) {
        paramConfigMap = Object.fromEntries(arg1.map((key)=>[
                key,
                "inherit"
            ]));
        options = arg2;
    } else {
        paramConfigMap = arg1;
        options = arg2;
    }
    return {
        paramConfigMap: paramConfigMap,
        options: options
    };
}


const $d3cad286061bc5f2$export$ae316f0eeb712a36 = (name, paramConfig, options)=>{
    const paramConfigMap = (0, $acw62.useMemo)(()=>({
            [name]: paramConfig != null ? paramConfig : "inherit"
        }), [
        name,
        paramConfig
    ]);
    const [query, setQuery] = (0, $9963aa6f9102c92d$export$2e2bcd8739ae039)(paramConfigMap, options);
    const decodedValue = query[name];
    const setValue = (0, $acw62.useCallback)((newValue, updateType)=>{
        if (typeof newValue === "function") return setQuery((latestValues)=>{
            const newValueFromLatest = newValue(latestValues[name]);
            return {
                [name]: newValueFromLatest
            };
        }, updateType);
        return setQuery({
            [name]: newValue
        }, updateType);
    }, [
        name,
        setQuery
    ]);
    return [
        decodedValue,
        setValue
    ];
};




var $acw62 = parcelRequire("acw62");

function $fbb5dd1c29eaaa8f$export$df3b50a3c9f89f16(paramConfigMap, WrappedComponent) {
    const Component = (props)=>{
        const [query, setQuery] = (0, $9963aa6f9102c92d$export$2e2bcd8739ae039)(paramConfigMap);
        return /* @__PURE__ */ $acw62.createElement(WrappedComponent, {
            query: query,
            setQuery: setQuery,
            ...props
        });
    };
    Component.displayName = `withQueryParams(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
    return Component;
}
var $fbb5dd1c29eaaa8f$export$2e2bcd8739ae039 = $fbb5dd1c29eaaa8f$export$df3b50a3c9f89f16;
function $fbb5dd1c29eaaa8f$export$e4569c0647c2953a(paramConfigMap, mapToProps, WrappedComponent) {
    const Component = (props)=>{
        const [query, setQuery] = (0, $9963aa6f9102c92d$export$2e2bcd8739ae039)(paramConfigMap);
        const propsToAdd = mapToProps(query, setQuery, props);
        return /* @__PURE__ */ $acw62.createElement(WrappedComponent, {
            ...propsToAdd,
            ...props
        });
    };
    Component.displayName = `withQueryParams(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
    return Component;
}



const $55a9b2c8f4bb59a8$export$a2c2391d088d03ad = ({ config: config, children: children })=>{
    const [query, setQuery] = (0, $9963aa6f9102c92d$export$2e2bcd8739ae039)(config);
    return children({
        query: query,
        setQuery: setQuery
    });
};
var $55a9b2c8f4bb59a8$export$2e2bcd8739ae039 = $55a9b2c8f4bb59a8$export$a2c2391d088d03ad;



$parcel$exportWildcard($798e894a39525bfd$exports, $f5001d18c2e12e66$exports);


// src/queryClient.ts
// src/utils.ts
// src/timeoutManager.ts
var $b7f1384d98eac5cd$export$d235812f9125bf47 = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var $b7f1384d98eac5cd$export$6336d90323f0ab52 = class {
    // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
    // type at app boot; and if we leave that type, then any new timer provider
    // would need to support ReturnType<typeof setTimeout>, which is infeasible.
    //
    // We settle for type safety for the TimeoutProvider type, and accept that
    // this class is unsafe internally to allow for extension.
    #provider = $b7f1384d98eac5cd$export$d235812f9125bf47;
    #providerCalled = false;
    setTimeoutProvider(provider) {
        this.#provider = provider;
    }
    setTimeout(callback, delay) {
        return this.#provider.setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        this.#provider.clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return this.#provider.setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        this.#provider.clearInterval(intervalId);
    }
};
var $b7f1384d98eac5cd$export$94a2700736e69372 = new $b7f1384d98eac5cd$export$6336d90323f0ab52();
function $b7f1384d98eac5cd$export$5086591e51e32a18(callback) {
    setTimeout(callback, 0);
}


var $938ae10f13d49bdc$export$6acf61af03e62db = typeof window === "undefined" || "Deno" in globalThis;
function $938ae10f13d49bdc$export$8793edee2d425525() {}
function $938ae10f13d49bdc$export$7f095f455ad5af3f(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function $938ae10f13d49bdc$export$e539f754e934e270(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function $938ae10f13d49bdc$export$811b83d62bcf47f0(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function $938ae10f13d49bdc$export$cb3145f011bda3ac(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function $938ae10f13d49bdc$export$8c88ee6f2357230d(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function $938ae10f13d49bdc$export$c5d1efe363797780(filters, query) {
    const { type: type = "all", exact: exact, fetchStatus: fetchStatus, predicate: predicate, queryKey: queryKey, stale: stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== $938ae10f13d49bdc$export$cc90ca97bc0d73fd(queryKey, query.options)) return false;
        } else if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function $938ae10f13d49bdc$export$a1ea5fb559f63ae3(filters, mutation) {
    const { exact: exact, status: status, predicate: predicate, mutationKey: mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if ($938ae10f13d49bdc$export$1e87d19d4aab5805(mutation.options.mutationKey) !== $938ae10f13d49bdc$export$1e87d19d4aab5805(mutationKey)) return false;
        } else if (!$938ae10f13d49bdc$export$2f07189bb9fa26a7(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function $938ae10f13d49bdc$export$cc90ca97bc0d73fd(queryKey, options) {
    const hashFn = options?.queryKeyHashFn || $938ae10f13d49bdc$export$1e87d19d4aab5805;
    return hashFn(queryKey);
}
function $938ae10f13d49bdc$export$1e87d19d4aab5805(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>$938ae10f13d49bdc$export$53b83ca8eaab0383(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function $938ae10f13d49bdc$export$2f07189bb9fa26a7(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>$938ae10f13d49bdc$export$2f07189bb9fa26a7(a[key], b[key]));
    return false;
}
var $938ae10f13d49bdc$var$hasOwn = Object.prototype.hasOwnProperty;
function $938ae10f13d49bdc$export$77a71fc411098696(a, b) {
    if (a === b) return a;
    const array = $938ae10f13d49bdc$export$7a8558113332b71e(a) && $938ae10f13d49bdc$export$7a8558113332b71e(b);
    if (!array && !($938ae10f13d49bdc$export$53b83ca8eaab0383(a) && $938ae10f13d49bdc$export$53b83ca8eaab0383(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : $938ae10f13d49bdc$var$hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = $938ae10f13d49bdc$export$77a71fc411098696(aItem, bItem);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function $938ae10f13d49bdc$export$3e67810a3f0e9f1c(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function $938ae10f13d49bdc$export$7a8558113332b71e(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function $938ae10f13d49bdc$export$53b83ca8eaab0383(o) {
    if (!$938ae10f13d49bdc$var$hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!$938ae10f13d49bdc$var$hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function $938ae10f13d49bdc$var$hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function $938ae10f13d49bdc$export$e772c8ff12451969(timeout) {
    return new Promise((resolve)=>{
        (0, $b7f1384d98eac5cd$export$94a2700736e69372).setTimeout(resolve, timeout);
    });
}
function $938ae10f13d49bdc$export$17619bac5b909b23(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return $938ae10f13d49bdc$export$77a71fc411098696(prevData, data);
    }
    return data;
}
function $938ae10f13d49bdc$export$f537417e7e421eac(previousData) {
    return previousData;
}
function $938ae10f13d49bdc$export$ccce65a22a26f2bc(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function $938ae10f13d49bdc$export$8c6246b73dd61f4a(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var $938ae10f13d49bdc$export$1aa5a89531b7670d = Symbol();
function $938ae10f13d49bdc$export$c71c44209368a3bc(options, fetchOptions) {
    if (!options.queryFn && fetchOptions?.initialPromise) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === $938ae10f13d49bdc$export$1aa5a89531b7670d) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function $938ae10f13d49bdc$export$2072f68e6c3507cf(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}


// src/queryCache.ts

// src/query.ts

// src/notifyManager.ts

var $e2307e33fb454067$export$7c76da44185e6090 = (0, $b7f1384d98eac5cd$export$5086591e51e32a18);
function $e2307e33fb454067$export$316a8efd03cd1458() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = $e2307e33fb454067$export$7c76da44185e6090;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule: schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var $e2307e33fb454067$export$520687f44db6e1ab = $e2307e33fb454067$export$316a8efd03cd1458();


// src/retryer.ts
// src/focusManager.ts
// src/subscribable.ts
var $f28bf069faa02086$export$d26086b469ecdbcc = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};



var $3f1a0485b2ecb725$export$86f1af424b2ca4de = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #focused;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onFocus)=>{
            if (!(0, $938ae10f13d49bdc$export$6acf61af03e62db) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        });
    }
    setFocused(focused) {
        const changed = this.#focused !== focused;
        if (changed) {
            this.#focused = focused;
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        if (typeof this.#focused === "boolean") return this.#focused;
        return globalThis.document?.visibilityState !== "hidden";
    }
};
var $3f1a0485b2ecb725$export$6bf54661be5b02cf = new $3f1a0485b2ecb725$export$86f1af424b2ca4de();


// src/onlineManager.ts


var $0d08006668a80e57$export$58774fb55d5ff7fc = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #online = true;
    #cleanup;
    #setup;
    constructor(){
        super();
        this.#setup = (onOnline)=>{
            if (!(0, $938ae10f13d49bdc$export$6acf61af03e62db) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        };
    }
    onSubscribe() {
        if (!this.#cleanup) this.setEventListener(this.#setup);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) {
            this.#cleanup?.();
            this.#cleanup = void 0;
        }
    }
    setEventListener(setup) {
        this.#setup = setup;
        this.#cleanup?.();
        this.#cleanup = setup(this.setOnline.bind(this));
    }
    setOnline(online) {
        const changed = this.#online !== online;
        if (changed) {
            this.#online = online;
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return this.#online;
    }
};
var $0d08006668a80e57$export$b113e788b2dd3fdc = new $0d08006668a80e57$export$58774fb55d5ff7fc();


// src/thenable.ts

function $f6114de20f9a4572$export$d54630db02a12b72() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value: value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason: reason
        });
        reject(reason);
    };
    return thenable;
}
function $f6114de20f9a4572$export$216296c47a9d1275(promise) {
    let data;
    promise.then((result)=>{
        data = result;
        return result;
    }, (0, $938ae10f13d49bdc$export$8793edee2d425525))?.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    if (data !== void 0) return {
        data: data
    };
    return void 0;
}



function $af92dbbbb3fbc9c5$var$defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function $af92dbbbb3fbc9c5$export$61b92f63f30245cf(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline() : true;
}
var $af92dbbbb3fbc9c5$export$a8430ed4188f35a9 = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options?.revert;
        this.silent = options?.silent;
    }
};
function $af92dbbbb3fbc9c5$export$986cc6445c1d323(value) {
    return value instanceof $af92dbbbb3fbc9c5$export$a8430ed4188f35a9;
}
function $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        if (!isResolved()) {
            const error = new $af92dbbbb3fbc9c5$export$a8430ed4188f35a9(cancelOptions);
            reject(error);
            config.onCancel?.(error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).isFocused() && (config.networkMode === "always" || (0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline()) && config.canRun();
    const canStart = ()=>$af92dbbbb3fbc9c5$export$61b92f63f30245cf(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn?.();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            config.onPause?.();
        }).then(()=>{
            continueFn = void 0;
            if (!isResolved()) config.onContinue?.();
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            if (isResolved()) return;
            const retry = config.retry ?? ((0, $938ae10f13d49bdc$export$6acf61af03e62db) ? 0 : 3);
            const retryDelay = config.retryDelay ?? $af92dbbbb3fbc9c5$var$defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            config.onFail?.(failureCount, error);
            (0, $938ae10f13d49bdc$export$e772c8ff12451969)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel: cancel,
        continue: ()=>{
            continueFn?.();
            return thenable;
        },
        cancelRetry: cancelRetry,
        continueRetry: continueRetry,
        canStart: canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}


// src/removable.ts


var $e24fc843f912068a$export$e09608847fcc8c59 = class {
    #gcTimeout;
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, $938ae10f13d49bdc$export$e539f754e934e270)(this.gcTime)) this.#gcTimeout = (0, $b7f1384d98eac5cd$export$94a2700736e69372).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime);
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, $938ae10f13d49bdc$export$6acf61af03e62db) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if (this.#gcTimeout) {
            (0, $b7f1384d98eac5cd$export$94a2700736e69372).clearTimeout(this.#gcTimeout);
            this.#gcTimeout = void 0;
        }
    }
};


var $bbb5e4108fb61687$export$62297b13309008b2 = class extends (0, $e24fc843f912068a$export$e09608847fcc8c59) {
    #initialState;
    #revertState;
    #cache;
    #client;
    #retryer;
    #defaultOptions;
    #abortSignalConsumed;
    constructor(config){
        super();
        this.#abortSignalConsumed = false;
        this.#defaultOptions = config.defaultOptions;
        this.setOptions(config.options);
        this.observers = [];
        this.#client = config.client;
        this.#cache = this.#client.getQueryCache();
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        this.#initialState = $bbb5e4108fb61687$var$getDefaultState(this.options);
        this.state = config.state ?? this.#initialState;
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        return this.#retryer?.promise;
    }
    setOptions(options) {
        this.options = {
            ...this.#defaultOptions,
            ...options
        };
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = $bbb5e4108fb61687$var$getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setData(defaultState.data, {
                    updatedAt: defaultState.dataUpdatedAt,
                    manual: true
                });
                this.#initialState = defaultState;
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") this.#cache.remove(this);
    }
    setData(newData, options) {
        const data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(this.state.data, newData, this.options);
        this.#dispatch({
            data: data,
            type: "success",
            dataUpdatedAt: options?.updatedAt,
            manual: options?.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        this.#dispatch({
            type: "setState",
            state: state,
            setStateOptions: setStateOptions
        });
    }
    cancel(options) {
        const promise = this.#retryer?.promise;
        this.#retryer?.cancel(options);
        return promise ? promise.then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState(this.#initialState);
    }
    isActive() {
        return this.observers.some((observer)=>(0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, $938ae10f13d49bdc$export$1aa5a89531b7670d) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, $938ae10f13d49bdc$export$811b83d62bcf47f0)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    onOnline() {
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer?.refetch({
            cancelRefetch: false
        });
        this.#retryer?.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            this.#cache.notify({
                type: "observerAdded",
                query: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if (this.#retryer) {
                    if (this.#abortSignalConsumed) this.#retryer.cancel({
                        revert: true
                    });
                    else this.#retryer.cancelRetry();
                }
                this.scheduleGc();
            }
            this.#cache.notify({
                type: "observerRemoved",
                query: this,
                observer: observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) this.#dispatch({
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        this.#retryer?.status() !== "rejected") {
            if (this.state.data !== void 0 && fetchOptions?.cancelRefetch) this.cancel({
                silent: true
            });
            else if (this.#retryer) {
                this.#retryer.continueRetry();
                return this.#retryer.promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    this.#abortSignalConsumed = true;
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, $938ae10f13d49bdc$export$c71c44209368a3bc)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: this.#client,
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            this.#abortSignalConsumed = false;
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions: fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: this.#client,
                state: this.state,
                fetchFn: fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        this.options.behavior?.onFetch(context, this);
        this.#revertState = this.state;
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== context.fetchOptions?.meta) this.#dispatch({
            type: "fetch",
            meta: context.fetchOptions?.meta
        });
        this.#retryer = (0, $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85)({
            initialPromise: fetchOptions?.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, $af92dbbbb3fbc9c5$export$a8430ed4188f35a9) && error.revert) this.setState({
                    ...this.#revertState,
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: ()=>{
                this.#dispatch({
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        });
        try {
            const data = await this.#retryer.start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            this.#cache.config.onSuccess?.(data, this);
            this.#cache.config.onSettled?.(data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, $af92dbbbb3fbc9c5$export$a8430ed4188f35a9)) {
                if (error.silent) return this.#retryer.promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            this.#dispatch({
                type: "error",
                error: error
            });
            this.#cache.config.onError?.(error, this);
            this.#cache.config.onSettled?.(this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        fetchFailureCount: action.failureCount,
                        fetchFailureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        fetchStatus: "paused"
                    };
                case "continue":
                    return {
                        ...state,
                        fetchStatus: "fetching"
                    };
                case "fetch":
                    return {
                        ...state,
                        ...$bbb5e4108fb61687$export$f3df9013f2b58bce(state.data, this.options),
                        fetchMeta: action.meta ?? null
                    };
                case "success":
                    const newState = {
                        ...state,
                        data: action.data,
                        dataUpdateCount: state.dataUpdateCount + 1,
                        dataUpdatedAt: action.dataUpdatedAt ?? Date.now(),
                        error: null,
                        isInvalidated: false,
                        status: "success",
                        ...!action.manual && {
                            fetchStatus: "idle",
                            fetchFailureCount: 0,
                            fetchFailureReason: null
                        }
                    };
                    this.#revertState = action.manual ? newState : void 0;
                    return newState;
                case "error":
                    const error = action.error;
                    return {
                        ...state,
                        error: error,
                        errorUpdateCount: state.errorUpdateCount + 1,
                        errorUpdatedAt: Date.now(),
                        fetchFailureCount: state.fetchFailureCount + 1,
                        fetchFailureReason: error,
                        fetchStatus: "idle",
                        status: "error"
                    };
                case "invalidate":
                    return {
                        ...state,
                        isInvalidated: true
                    };
                case "setState":
                    return {
                        ...state,
                        ...action.state
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.observers.forEach((observer)=>{
                observer.onQueryUpdate();
            });
            this.#cache.notify({
                query: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $bbb5e4108fb61687$export$f3df9013f2b58bce(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, $af92dbbbb3fbc9c5$export$61b92f63f30245cf)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function $bbb5e4108fb61687$var$getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data: data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}




var $74dfca891c706a66$export$5dde0cd941da8468 = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#queries = /* @__PURE__ */ new Map();
    }
    #queries;
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, $938ae10f13d49bdc$export$cc90ca97bc0d73fd)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, $bbb5e4108fb61687$export$62297b13309008b2)({
                client: client,
                queryKey: queryKey,
                queryHash: queryHash,
                options: client.defaultQueryOptions(options),
                state: state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!this.#queries.has(query.queryHash)) {
            this.#queries.set(query.queryHash, query);
            this.notify({
                type: "added",
                query: query
            });
        }
    }
    remove(query) {
        const queryInMap = this.#queries.get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) this.#queries.delete(query.queryHash);
            this.notify({
                type: "removed",
                query: query
            });
        }
    }
    clear() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return this.#queries.get(queryHash);
    }
    getAll() {
        return [
            ...this.#queries.values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, $938ae10f13d49bdc$export$c5d1efe363797780)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, $938ae10f13d49bdc$export$c5d1efe363797780)(filters, query)) : queries;
    }
    notify(event) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};


// src/mutationCache.ts

// src/mutation.ts



var $524c502dbe70a85f$export$17b8b19c814bcf56 = class extends (0, $e24fc843f912068a$export$e09608847fcc8c59) {
    #client;
    #observers;
    #mutationCache;
    #retryer;
    constructor(config){
        super();
        this.#client = config.client;
        this.mutationId = config.mutationId;
        this.#mutationCache = config.mutationCache;
        this.#observers = [];
        this.state = config.state || $524c502dbe70a85f$export$a1659b54bac3252a();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!this.#observers.includes(observer)) {
            this.#observers.push(observer);
            this.clearGcTimeout();
            this.#mutationCache.notify({
                type: "observerAdded",
                mutation: this,
                observer: observer
            });
        }
    }
    removeObserver(observer) {
        this.#observers = this.#observers.filter((x)=>x !== observer);
        this.scheduleGc();
        this.#mutationCache.notify({
            type: "observerRemoved",
            mutation: this,
            observer: observer
        });
    }
    optionalRemove() {
        if (!this.#observers.length) {
            if (this.state.status === "pending") this.scheduleGc();
            else this.#mutationCache.remove(this);
        }
    }
    continue() {
        return this.#retryer?.continue() ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        const onContinue = ()=>{
            this.#dispatch({
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: this.#client,
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        this.#retryer = (0, $af92dbbbb3fbc9c5$export$2cbd00fe8a2c8d85)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                this.#dispatch({
                    type: "failed",
                    failureCount: failureCount,
                    error: error
                });
            },
            onPause: ()=>{
                this.#dispatch({
                    type: "pause"
                });
            },
            onContinue: onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>this.#mutationCache.canRun(this)
        });
        const restored = this.state.status === "pending";
        const isPaused = !this.#retryer.canStart();
        try {
            if (restored) onContinue();
            else {
                this.#dispatch({
                    type: "pending",
                    variables: variables,
                    isPaused: isPaused
                });
                await this.#mutationCache.config.onMutate?.(variables, this, mutationFnContext);
                const context = await this.options.onMutate?.(variables, mutationFnContext);
                if (context !== this.state.context) this.#dispatch({
                    type: "pending",
                    context: context,
                    variables: variables,
                    isPaused: isPaused
                });
            }
            const data = await this.#retryer.start();
            await this.#mutationCache.config.onSuccess?.(data, variables, this.state.context, this, mutationFnContext);
            await this.options.onSuccess?.(data, variables, this.state.context, mutationFnContext);
            await this.#mutationCache.config.onSettled?.(data, null, this.state.variables, this.state.context, this, mutationFnContext);
            await this.options.onSettled?.(data, null, variables, this.state.context, mutationFnContext);
            this.#dispatch({
                type: "success",
                data: data
            });
            return data;
        } catch (error) {
            try {
                await this.#mutationCache.config.onError?.(error, variables, this.state.context, this, mutationFnContext);
                await this.options.onError?.(error, variables, this.state.context, mutationFnContext);
                await this.#mutationCache.config.onSettled?.(void 0, error, this.state.variables, this.state.context, this, mutationFnContext);
                await this.options.onSettled?.(void 0, error, variables, this.state.context, mutationFnContext);
                throw error;
            } finally{
                this.#dispatch({
                    type: "error",
                    error: error
                });
            }
        } finally{
            this.#mutationCache.runNext(this);
        }
    }
    #dispatch(action) {
        const reducer = (state)=>{
            switch(action.type){
                case "failed":
                    return {
                        ...state,
                        failureCount: action.failureCount,
                        failureReason: action.error
                    };
                case "pause":
                    return {
                        ...state,
                        isPaused: true
                    };
                case "continue":
                    return {
                        ...state,
                        isPaused: false
                    };
                case "pending":
                    return {
                        ...state,
                        context: action.context,
                        data: void 0,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        isPaused: action.isPaused,
                        status: "pending",
                        variables: action.variables,
                        submittedAt: Date.now()
                    };
                case "success":
                    return {
                        ...state,
                        data: action.data,
                        failureCount: 0,
                        failureReason: null,
                        error: null,
                        status: "success",
                        isPaused: false
                    };
                case "error":
                    return {
                        ...state,
                        data: void 0,
                        error: action.error,
                        failureCount: state.failureCount + 1,
                        failureReason: action.error,
                        isPaused: false,
                        status: "error"
                    };
            }
        };
        this.state = reducer(this.state);
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#observers.forEach((observer)=>{
                observer.onMutationUpdate(action);
            });
            this.#mutationCache.notify({
                mutation: this,
                type: "updated",
                action: action
            });
        });
    }
};
function $524c502dbe70a85f$export$a1659b54bac3252a() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}




var $217efee59d834f2b$export$1fcfd9a244434844 = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(config = {}){
        super();
        this.config = config;
        this.#mutations = /* @__PURE__ */ new Set();
        this.#scopes = /* @__PURE__ */ new Map();
        this.#mutationId = 0;
    }
    #mutations;
    #scopes;
    #mutationId;
    build(client, options, state) {
        const mutation = new (0, $524c502dbe70a85f$export$17b8b19c814bcf56)({
            client: client,
            mutationCache: this,
            mutationId: ++this.#mutationId,
            options: client.defaultMutationOptions(options),
            state: state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        this.#mutations.add(mutation);
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = this.#scopes.get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else this.#scopes.set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation: mutation
        });
    }
    remove(mutation) {
        if (this.#mutations.delete(mutation)) {
            const scope = $217efee59d834f2b$var$scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = this.#scopes.get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) this.#scopes.delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation: mutation
        });
    }
    canRun(mutation) {
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = this.#scopes.get(scope);
            const firstPendingMutation = mutationsWithSameScope?.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        const scope = $217efee59d834f2b$var$scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = this.#scopes.get(scope)?.find((m)=>m !== mutation && m.state.isPaused);
            return foundMutation?.continue() ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#mutations.forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation: mutation
                });
            });
            this.#mutations.clear();
            this.#scopes.clear();
        });
    }
    getAll() {
        return Array.from(this.#mutations);
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, $938ae10f13d49bdc$export$a1ea5fb559f63ae3)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, $938ae10f13d49bdc$export$a1ea5fb559f63ae3)(filters, mutation));
    }
    notify(event) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, $938ae10f13d49bdc$export$8793edee2d425525)))));
    }
};
function $217efee59d834f2b$var$scopeFor(mutation) {
    return mutation.options.scope?.id;
}





// src/infiniteQueryBehavior.ts

function $5e3ed657d3a894dc$export$84470d1367601e8d(pages) {
    return {
        onFetch: (context, query)=>{
            const options = context.options;
            const direction = context.fetchOptions?.meta?.fetchMore?.direction;
            const oldPages = context.state.data?.pages || [];
            const oldPageParams = context.state.data?.pageParams || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, $938ae10f13d49bdc$export$c71c44209368a3bc)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages: maxPages } = context.options;
                    const addTo = previous ? (0, $938ae10f13d49bdc$export$8c6246b73dd61f4a) : (0, $938ae10f13d49bdc$export$ccce65a22a26f2bc);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? $5e3ed657d3a894dc$var$getPreviousPageParam : $5e3ed657d3a894dc$var$getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : $5e3ed657d3a894dc$var$getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                return context.options.persister?.(fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function $5e3ed657d3a894dc$var$getNextPageParam(options, { pages: pages, pageParams: pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function $5e3ed657d3a894dc$var$getPreviousPageParam(options, { pages: pages, pageParams: pageParams }) {
    return pages.length > 0 ? options.getPreviousPageParam?.(pages[0], pages, pageParams[0], pageParams) : void 0;
}
function $5e3ed657d3a894dc$export$b9c88add8b8b5e6a(options, data) {
    if (!data) return false;
    return $5e3ed657d3a894dc$var$getNextPageParam(options, data) != null;
}
function $5e3ed657d3a894dc$export$db1663b730a8e6e4(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return $5e3ed657d3a894dc$var$getPreviousPageParam(options, data) != null;
}


var $83ccb5f70678ce73$export$405d0624ed55a03f = class {
    #queryCache;
    #mutationCache;
    #defaultOptions;
    #queryDefaults;
    #mutationDefaults;
    #mountCount;
    #unsubscribeFocus;
    #unsubscribeOnline;
    constructor(config = {}){
        this.#queryCache = config.queryCache || new (0, $74dfca891c706a66$export$5dde0cd941da8468)();
        this.#mutationCache = config.mutationCache || new (0, $217efee59d834f2b$export$1fcfd9a244434844)();
        this.#defaultOptions = config.defaultOptions || {};
        this.#queryDefaults = /* @__PURE__ */ new Map();
        this.#mutationDefaults = /* @__PURE__ */ new Map();
        this.#mountCount = 0;
    }
    mount() {
        this.#mountCount++;
        if (this.#mountCount !== 1) return;
        this.#unsubscribeFocus = (0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                this.#queryCache.onFocus();
            }
        });
        this.#unsubscribeOnline = (0, $0d08006668a80e57$export$b113e788b2dd3fdc).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                this.#queryCache.onOnline();
            }
        });
    }
    unmount() {
        this.#mountCount--;
        if (this.#mountCount !== 0) return;
        this.#unsubscribeFocus?.();
        this.#unsubscribeFocus = void 0;
        this.#unsubscribeOnline?.();
        this.#unsubscribeOnline = void 0;
    }
    isFetching(filters) {
        return this.#queryCache.findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return this.#mutationCache.findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = this.#queryCache.build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return this.#queryCache.findAll(filters).map(({ queryKey: queryKey, state: state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey: queryKey
        });
        const query = this.#queryCache.get(defaultedOptions.queryHash);
        const prevData = query?.state.data;
        const data = (0, $938ae10f13d49bdc$export$7f095f455ad5af3f)(updater, prevData);
        if (data === void 0) return void 0;
        return this.#queryCache.build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map(({ queryKey: queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        const options = this.defaultQueryOptions({
            queryKey: queryKey
        });
        return this.#queryCache.get(options.queryHash)?.state;
    }
    removeQueries(filters) {
        const queryCache = this.#queryCache;
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = this.#queryCache;
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    invalidateQueries(filters, options = {}) {
        return (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            this.#queryCache.findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if (filters?.refetchType === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: filters?.refetchType ?? filters?.type ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>this.#queryCache.findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = this.#queryCache.build(this, defaultedOptions);
        return query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, $5e3ed657d3a894dc$export$84470d1367601e8d)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, $938ae10f13d49bdc$export$8793edee2d425525)).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, $5e3ed657d3a894dc$export$84470d1367601e8d)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, $0d08006668a80e57$export$b113e788b2dd3fdc).isOnline()) return this.#mutationCache.resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return this.#queryCache;
    }
    getMutationCache() {
        return this.#mutationCache;
    }
    getDefaultOptions() {
        return this.#defaultOptions;
    }
    setDefaultOptions(options) {
        this.#defaultOptions = options;
    }
    setQueryDefaults(queryKey, options) {
        this.#queryDefaults.set((0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(queryKey), {
            queryKey: queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...this.#queryDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $938ae10f13d49bdc$export$2f07189bb9fa26a7)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        this.#mutationDefaults.set((0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(mutationKey), {
            mutationKey: mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...this.#mutationDefaults.values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, $938ae10f13d49bdc$export$2f07189bb9fa26a7)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...this.#defaultOptions.queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, $938ae10f13d49bdc$export$cc90ca97bc0d73fd)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, $938ae10f13d49bdc$export$1aa5a89531b7670d)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options?._defaulted) return options;
        return {
            ...this.#defaultOptions.mutations,
            ...options?.mutationKey && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        this.#queryCache.clear();
        this.#mutationCache.clear();
    }
};


var $acw62 = parcelRequire("acw62");

"use client";
var $c780594f51309d36$export$da112d31b0149f31 = $acw62.createContext(void 0);
var $c780594f51309d36$export$22e77b9572c4fded = (queryClient)=>{
    const client = $acw62.useContext($c780594f51309d36$export$da112d31b0149f31);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var $c780594f51309d36$export$45604f0cc8ae667b = ({ client: client, children: children })=>{
    $acw62.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($c780594f51309d36$export$da112d31b0149f31.Provider, {
        value: client,
        children: children
    });
};




"use client";
var $797b6392ad7a8820$export$fd1469cb3147d866 = function() {
    return null;
};
var $797b6392ad7a8820$export$6d64409a8b475869 = function() {
    return null;
};



parcelRequire("acw62");

/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $4051039ece381ef4$var$asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function $4051039ece381ef4$export$2e2bcd8739ae039(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                $4051039ece381ef4$var$asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}


function $1167ce760980f343$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}


function $c029ce1ef065e371$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}


function $5a337bca9556bfe7$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}


function $76af8a05551d5f25$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $5a337bca9556bfe7$export$2e2bcd8739ae039)(r, a) : void 0;
    }
}


function $530b88ff20858fe6$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $adaabbc18727b3e6$export$2e2bcd8739ae039(r, e) {
    return (0, $1167ce760980f343$export$2e2bcd8739ae039)(r) || (0, $c029ce1ef065e371$export$2e2bcd8739ae039)(r, e) || (0, $76af8a05551d5f25$export$2e2bcd8739ae039)(r, e) || (0, $530b88ff20858fe6$export$2e2bcd8739ae039)();
}


var $c6598bdb60f83fe0$exports = {};
// TODO(Babel 8): Remove this file.

var $c6598bdb60f83fe0$var$runtime = (parcelRequire("8HV7i"))();
$c6598bdb60f83fe0$exports = $c6598bdb60f83fe0$var$runtime;
// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
    regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
} catch (accidentalStrictMode) {
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $c6598bdb60f83fe0$var$runtime;
    else Function("r", "regeneratorRuntime = r")($c6598bdb60f83fe0$var$runtime);
}



var $acw62 = parcelRequire("acw62");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $23b7d84f5e759bd1$export$c96dcb52978c0932;
(function(IdxStatus) {
    IdxStatus["SUCCESS"] = "SUCCESS";
    IdxStatus["PENDING"] = "PENDING";
    IdxStatus["FAILURE"] = "FAILURE";
    IdxStatus["TERMINAL"] = "TERMINAL";
    IdxStatus["CANCELED"] = "CANCELED";
})($23b7d84f5e759bd1$export$c96dcb52978c0932 || ($23b7d84f5e759bd1$export$c96dcb52978c0932 = {}));
var $23b7d84f5e759bd1$export$b420a84de7aa04bd;
(function(AuthenticatorKey) {
    AuthenticatorKey["OKTA_PASSWORD"] = "okta_password";
    AuthenticatorKey["OKTA_EMAIL"] = "okta_email";
    AuthenticatorKey["PHONE_NUMBER"] = "phone_number";
    AuthenticatorKey["GOOGLE_AUTHENTICATOR"] = "google_otp";
    AuthenticatorKey["SECURITY_QUESTION"] = "security_question";
    AuthenticatorKey["OKTA_VERIFY"] = "okta_verify";
    AuthenticatorKey["WEBAUTHN"] = "webauthn";
})($23b7d84f5e759bd1$export$b420a84de7aa04bd || ($23b7d84f5e759bd1$export$b420a84de7aa04bd = {}));
var $23b7d84f5e759bd1$export$451922195d9391fb;
(function(IdxFeature) {
    IdxFeature["PASSWORD_RECOVERY"] = "recover-password";
    IdxFeature["REGISTRATION"] = "enroll-profile";
    IdxFeature["SOCIAL_IDP"] = "redirect-idp";
    IdxFeature["ACCOUNT_UNLOCK"] = "unlock-account";
})($23b7d84f5e759bd1$export$451922195d9391fb || ($23b7d84f5e759bd1$export$451922195d9391fb = {}));
function $23b7d84f5e759bd1$export$361ab32a8474b3c4(obj) {
    return obj && (obj.key || obj.id);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $5502e384469ea433$export$1207c686809a84c1() {
    if (typeof window !== 'undefined') return window.console;
    else if (typeof console !== 'undefined') return console;
    else return undefined;
}
function $5502e384469ea433$export$bbe488cec1edd401() {
    var nativeConsole = $5502e384469ea433$export$1207c686809a84c1();
    if (nativeConsole && nativeConsole.log) return nativeConsole;
    return {
        log: function() {},
        warn: function() {},
        group: function() {},
        groupEnd: function() {}
    };
}
function $5502e384469ea433$export$c106dd0671a0fc2d(text) {
    $5502e384469ea433$export$bbe488cec1edd401().warn('[okta-auth-sdk] WARN: ' + text);
}
function $5502e384469ea433$export$b680e6b2c82f8c2f(text) {
    $5502e384469ea433$export$bbe488cec1edd401().warn('[okta-auth-sdk] DEPRECATION: ' + text);
}
function $5502e384469ea433$export$1f4f33396f74ac7(text, fn) {
    return function() {
        $5502e384469ea433$export$b680e6b2c82f8c2f(text);
        return fn.apply(null, arguments);
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $12f7cf89ebb788f9$export$2385a24977818dd0(fn, ctx) {
    var additionalArgs = Array.prototype.slice.call(arguments, 2);
    return function() {
        var args = Array.prototype.slice.call(arguments);
        args = additionalArgs.concat(args);
        return fn.apply(ctx, args);
    };
}
function $12f7cf89ebb788f9$export$8b58be045bf06082() {
    var obj1 = arguments[0];
    var objArray = [].slice.call(arguments, 1);
    objArray.forEach(function(obj) {
        for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop) && obj[prop] !== undefined) obj1[prop] = obj[prop];
    });
    return obj1;
}
function $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2(obj) {
    var cleaned = {};
    for(var prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        var value = obj[prop];
        if (value !== null && value !== undefined) cleaned[prop] = value;
    }
    return cleaned;
}
function $12f7cf89ebb788f9$export$9cd59f9826255e47(obj) {
    if (obj) {
        var str = JSON.stringify(obj);
        if (str) return JSON.parse(str);
    }
    return obj;
}
function $12f7cf89ebb788f9$export$30a06c8d3562193f(obj, ...props) {
    var newobj = {};
    for(var p in obj)if (Object.prototype.hasOwnProperty.call(obj, p) && props.indexOf(p) == -1) newobj[p] = obj[p];
    return $12f7cf89ebb788f9$export$9cd59f9826255e47(newobj);
}
function $12f7cf89ebb788f9$export$71aa6c912b956294(collection, searchParams) {
    var c = collection.length;
    while(c--){
        var item = collection[c];
        var found = true;
        for(var prop in searchParams){
            if (!Object.prototype.hasOwnProperty.call(searchParams, prop)) continue;
            if (item[prop] !== searchParams[prop]) {
                found = false;
                break;
            }
        }
        if (found) return item;
    }
}
function $12f7cf89ebb788f9$export$67e8a86e59c99895(obj, linkName, altName) {
    if (!obj || !obj._links) return;
    var link = $12f7cf89ebb788f9$export$9cd59f9826255e47(obj._links[linkName]);
    if (link && link.name && altName) {
        if (link.name === altName) return link;
    } else return link;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ class $8255b78460174178$export$2e2bcd8739ae039 extends Error {
    constructor(message){
        super(message);
        Object.setPrototypeOf(this, new.target.prototype);
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $307f2ba6550d7c99$export$844ec244b1367d54(obj) {
    return Object.prototype.toString.call(obj) === '[object String]';
}
function $307f2ba6550d7c99$export$a6cdc56e425d0d0a(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
function $307f2ba6550d7c99$export$7e4aa119212bc614(obj) {
    return Object.prototype.toString.call(obj) === '[object Number]';
}
function $307f2ba6550d7c99$export$f6e2535fb5126e54(fn) {
    return !!fn && ({}).toString.call(fn) === '[object Function]';
}
function $307f2ba6550d7c99$export$4369c812aac99591(obj) {
    return obj && obj.finally && typeof obj.finally === 'function';
}


class $d28aec32d9343bab$export$2e2bcd8739ae039 extends (0, $8255b78460174178$export$2e2bcd8739ae039) {
    constructor(scheme, parameters, resp){
        var _a;
        super((_a = parameters.error) !== null && _a !== void 0 ? _a : $d28aec32d9343bab$export$2e2bcd8739ae039.UNKNOWN_ERROR);
        this.name = 'WWWAuthError';
        this.resp = null;
        this.scheme = scheme;
        this.parameters = parameters;
        if (resp) this.resp = resp;
    }
    get error() {
        return this.parameters.error;
    }
    get errorCode() {
        return this.error;
    }
    get error_description() {
        return this.parameters.error_description;
    }
    get errorDescription() {
        return this.error_description;
    }
    get errorSummary() {
        return this.errorDescription;
    }
    get realm() {
        return this.parameters.realm;
    }
    static parseHeader(header) {
        var _a;
        if (!header) return null;
        const regex = /(?:,|, )?([a-zA-Z0-9!#$%&'*+\-.^_`|~]+)=(?:"([a-zA-Z0-9!#$%&'*+\-.,^_`|~ /:]+)"|([a-zA-Z0-9!#$%&'*+\-.^_`|~/:]+))/g;
        const firstSpace = header.indexOf(' ');
        const scheme = header.slice(0, firstSpace);
        const remaining = header.slice(firstSpace + 1);
        const params = {};
        let match;
        while((match = regex.exec(remaining)) !== null)params[match[1]] = (_a = match[2]) !== null && _a !== void 0 ? _a : match[3];
        return new $d28aec32d9343bab$export$2e2bcd8739ae039(scheme, params);
    }
    static getWWWAuthenticateHeader(headers = {}) {
        var _a;
        if ((0, $307f2ba6550d7c99$export$f6e2535fb5126e54)(headers === null || headers === void 0 ? void 0 : headers.get)) return headers.get('WWW-Authenticate');
        return (_a = headers['www-authenticate']) !== null && _a !== void 0 ? _a : headers['WWW-Authenticate'];
    }
}
$d28aec32d9343bab$export$2e2bcd8739ae039.UNKNOWN_ERROR = 'UNKNOWN_WWW_AUTH_ERROR';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $d7af732897cdd522$export$b3fc7ea1bf63bc2b(str) {
    var parts = str.match(/\d+/g), isoTime = Date.UTC(parts[0], parts[1] - 1, parts[2], parts[3], parts[4], parts[5]), isoDate = new Date(isoTime);
    return isoDate.toUTCString();
}
function $d7af732897cdd522$export$e3d3ee93624b0deb(length) {
    var randomCharset = 'abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var random = '';
    for(var c = 0, cl = randomCharset.length; c < length; ++c)random += randomCharset[Math.floor(Math.random() * cl)];
    return random;
}
function $d7af732897cdd522$export$1391212d75b2ee65(ms) {
    return new Promise(function(resolve) {
        setTimeout(resolve, ms);
    });
}
function $d7af732897cdd522$export$5f7ca8c53ac3b054(str, delim) {
    const parts = str.split(delim);
    return [
        parts[0],
        parts.splice(1, parts.length).join(delim)
    ];
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $83e7c3a0ba92185e$export$a1cbf2de32a9fd1(url) {
    return /^[a-z][a-z0-9+.-]*:/i.test(url);
}
function $83e7c3a0ba92185e$export$7895c48e9c019048(url = '', baseUrl) {
    if ($83e7c3a0ba92185e$export$a1cbf2de32a9fd1(url)) return url;
    baseUrl = $83e7c3a0ba92185e$export$b6d465111d914331(baseUrl);
    return url[0] === '/' ? `${baseUrl}${url}` : `${baseUrl}/${url}`;
}
function $83e7c3a0ba92185e$export$4ebdca5513a016fe(url = '', baseUrl) {
    if ($83e7c3a0ba92185e$export$a1cbf2de32a9fd1(url)) url = url.substring(baseUrl.length);
    return url[0] === '/' ? url : `/${url}`;
}
function $83e7c3a0ba92185e$export$249cc09c933c4d7a(obj) {
    var str = [];
    if (obj !== null) {
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key) && obj[key] !== undefined && obj[key] !== null) str.push(key + '=' + encodeURIComponent(obj[key]));
    }
    if (str.length) return '?' + str.join('&');
    else return '';
}
function $83e7c3a0ba92185e$export$b6d465111d914331(path) {
    if (!path) return;
    var trimmed = path.replace(/^\s+|\s+$/gm, '');
    trimmed = trimmed.replace(/\/+$/, '');
    return trimmed;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $9789dcf8e8374992$export$2e2bcd8739ae039 extends (0, $8255b78460174178$export$2e2bcd8739ae039) {
    constructor(msg, xhr){
        super(msg);
        this.name = 'AuthSdkError';
        this.errorCode = 'INTERNAL';
        this.errorSummary = msg;
        this.errorLink = 'INTERNAL';
        this.errorId = 'INTERNAL';
        this.errorCauses = [];
        if (xhr) this.xhr = xhr;
    }
}


function $28694eacc5911f05$export$9ccd2716e53a229b() {
    return (0, $d7af732897cdd522$export$e3d3ee93624b0deb)(64);
}
function $28694eacc5911f05$export$3ff59198e2333fc6() {
    return (0, $d7af732897cdd522$export$e3d3ee93624b0deb)(64);
}
function $28694eacc5911f05$var$getIssuer(sdk, options = {}) {
    const issuer = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.issuer) || sdk.options.issuer;
    return issuer;
}
function $28694eacc5911f05$export$11243677e2baf764(sdk, options = {}) {
    const issuer = $28694eacc5911f05$var$getIssuer(sdk, options);
    const baseUrl = issuer.indexOf('/oauth2') > 0 ? issuer : issuer + '/oauth2';
    return baseUrl;
}
function $28694eacc5911f05$export$bf8eda7d9615a5f0(sdk, options = {}) {
    const issuer = $28694eacc5911f05$var$getIssuer(sdk, options);
    const domain = issuer.split('/oauth2')[0];
    return domain;
}
function $28694eacc5911f05$export$1a398a8b679ebb76(sdk, options) {
    if (arguments.length > 2) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('As of version 3.0, "getOAuthUrls" takes only a single set of options');
    options = options || {};
    var authorizeUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.authorizeUrl) || sdk.options.authorizeUrl;
    var issuer = $28694eacc5911f05$var$getIssuer(sdk, options);
    var userinfoUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.userinfoUrl) || sdk.options.userinfoUrl;
    var tokenUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.tokenUrl) || sdk.options.tokenUrl;
    var logoutUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.logoutUrl) || sdk.options.logoutUrl;
    var revokeUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.revokeUrl) || sdk.options.revokeUrl;
    var baseUrl = $28694eacc5911f05$export$11243677e2baf764(sdk, options);
    authorizeUrl = authorizeUrl || baseUrl + '/v1/authorize';
    userinfoUrl = userinfoUrl || baseUrl + '/v1/userinfo';
    tokenUrl = tokenUrl || baseUrl + '/v1/token';
    revokeUrl = revokeUrl || baseUrl + '/v1/revoke';
    logoutUrl = logoutUrl || baseUrl + '/v1/logout';
    return {
        issuer: issuer,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        tokenUrl: tokenUrl,
        revokeUrl: revokeUrl,
        logoutUrl: logoutUrl
    };
}


function $487672a81f8ed323$export$6fd737cbc709c406(sdk, tokenParams) {
    const issuer = sdk.options.issuer;
    const urls = (0, $28694eacc5911f05$export$1a398a8b679ebb76)(sdk, tokenParams);
    const oauthMeta = {
        issuer: issuer,
        urls: urls,
        clientId: tokenParams.clientId,
        redirectUri: tokenParams.redirectUri,
        responseType: tokenParams.responseType,
        responseMode: tokenParams.responseMode,
        scopes: tokenParams.scopes,
        state: tokenParams.state,
        nonce: tokenParams.nonce,
        ignoreSignature: tokenParams.ignoreSignature,
        acrValues: tokenParams.acrValues,
        extraParams: tokenParams.extraParams
    };
    if (tokenParams.pkce === false) return oauthMeta;
    const pkceMeta = Object.assign(Object.assign({}, oauthMeta), {
        codeVerifier: tokenParams.codeVerifier,
        codeChallengeMethod: tokenParams.codeChallengeMethod,
        codeChallenge: tokenParams.codeChallenge
    });
    return pkceMeta;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


var $2119f0a66eb38a81$exports = {};

$parcel$export($2119f0a66eb38a81$exports, "STATE_TOKEN_KEY_NAME", () => $2119f0a66eb38a81$export$511e8ed0baecd62c);
$parcel$export($2119f0a66eb38a81$exports, "DEFAULT_POLLING_DELAY", () => $2119f0a66eb38a81$export$626063bdcc4f0775);
$parcel$export($2119f0a66eb38a81$exports, "IOS_MAX_RETRY_COUNT", () => $2119f0a66eb38a81$export$5f5ecd9ae1a04492);
$parcel$export($2119f0a66eb38a81$exports, "DEFAULT_MAX_CLOCK_SKEW", () => $2119f0a66eb38a81$export$a842e30d5ade6c4c);
$parcel$export($2119f0a66eb38a81$exports, "DEFAULT_CACHE_DURATION", () => $2119f0a66eb38a81$export$adfe1f91858943cf);
$parcel$export($2119f0a66eb38a81$exports, "TOKEN_STORAGE_NAME", () => $2119f0a66eb38a81$export$45d1f6fc12799d40);
$parcel$export($2119f0a66eb38a81$exports, "CACHE_STORAGE_NAME", () => $2119f0a66eb38a81$export$e9f2fad0ae10585a);
$parcel$export($2119f0a66eb38a81$exports, "PKCE_STORAGE_NAME", () => $2119f0a66eb38a81$export$48d827fe136140e7);
$parcel$export($2119f0a66eb38a81$exports, "TRANSACTION_STORAGE_NAME", () => $2119f0a66eb38a81$export$8cc5d1fc2dba148d);
$parcel$export($2119f0a66eb38a81$exports, "SHARED_TRANSACTION_STORAGE_NAME", () => $2119f0a66eb38a81$export$b9b27de9edfa5b8);
$parcel$export($2119f0a66eb38a81$exports, "ORIGINAL_URI_STORAGE_NAME", () => $2119f0a66eb38a81$export$ad9943119a111be1);
$parcel$export($2119f0a66eb38a81$exports, "IDX_RESPONSE_STORAGE_NAME", () => $2119f0a66eb38a81$export$48bfce2bad4674d4);
$parcel$export($2119f0a66eb38a81$exports, "ACCESS_TOKEN_STORAGE_KEY", () => $2119f0a66eb38a81$export$c1b1ca3f8a992ce2);
$parcel$export($2119f0a66eb38a81$exports, "ID_TOKEN_STORAGE_KEY", () => $2119f0a66eb38a81$export$b81e057a42e83180);
$parcel$export($2119f0a66eb38a81$exports, "REFRESH_TOKEN_STORAGE_KEY", () => $2119f0a66eb38a81$export$b04ebc518c9597f0);
$parcel$export($2119f0a66eb38a81$exports, "REFERRER_PATH_STORAGE_KEY", () => $2119f0a66eb38a81$export$dc0f85461823eff2);
$parcel$export($2119f0a66eb38a81$exports, "MIN_VERIFIER_LENGTH", () => $2119f0a66eb38a81$export$3429266d17ae1515);
$parcel$export($2119f0a66eb38a81$exports, "MAX_VERIFIER_LENGTH", () => $2119f0a66eb38a81$export$65dcf38d91740c9a);
$parcel$export($2119f0a66eb38a81$exports, "DEFAULT_CODE_CHALLENGE_METHOD", () => $2119f0a66eb38a81$export$ed9a92f7e3f906d8);
$parcel$export($2119f0a66eb38a81$exports, "IDX_API_VERSION", () => $2119f0a66eb38a81$export$3e8b495e17a161fe);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $2119f0a66eb38a81$export$511e8ed0baecd62c = 'oktaStateToken';
const $2119f0a66eb38a81$export$626063bdcc4f0775 = 500;
const $2119f0a66eb38a81$export$5f5ecd9ae1a04492 = 3;
const $2119f0a66eb38a81$export$a842e30d5ade6c4c = 300;
const $2119f0a66eb38a81$export$adfe1f91858943cf = 86400;
const $2119f0a66eb38a81$export$45d1f6fc12799d40 = 'okta-token-storage';
const $2119f0a66eb38a81$export$e9f2fad0ae10585a = 'okta-cache-storage';
const $2119f0a66eb38a81$export$48d827fe136140e7 = 'okta-pkce-storage';
const $2119f0a66eb38a81$export$8cc5d1fc2dba148d = 'okta-transaction-storage';
const $2119f0a66eb38a81$export$b9b27de9edfa5b8 = 'okta-shared-transaction-storage';
const $2119f0a66eb38a81$export$ad9943119a111be1 = 'okta-original-uri-storage';
const $2119f0a66eb38a81$export$48bfce2bad4674d4 = 'okta-idx-response-storage';
const $2119f0a66eb38a81$export$c1b1ca3f8a992ce2 = 'accessToken';
const $2119f0a66eb38a81$export$b81e057a42e83180 = 'idToken';
const $2119f0a66eb38a81$export$b04ebc518c9597f0 = 'refreshToken';
const $2119f0a66eb38a81$export$dc0f85461823eff2 = 'referrerPath';
const $2119f0a66eb38a81$export$3429266d17ae1515 = 43;
const $2119f0a66eb38a81$export$65dcf38d91740c9a = 128;
const $2119f0a66eb38a81$export$ed9a92f7e3f906d8 = 'S256';
const $2119f0a66eb38a81$export$3e8b495e17a161fe = '1.0.0';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $b7e782aa925a4626$export$2e2bcd8739ae039 extends (0, $8255b78460174178$export$2e2bcd8739ae039) {
    constructor(err, xhr, meta){
        const message = err.errorSummary;
        super(message);
        this.name = 'AuthApiError';
        this.errorSummary = err.errorSummary;
        this.errorCode = err.errorCode;
        this.errorLink = err.errorLink;
        this.errorId = err.errorId;
        this.errorCauses = err.errorCauses;
        if (xhr) this.xhr = xhr;
        if (meta) this.meta = meta;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $b17ce0de6fad00bb$export$2e2bcd8739ae039 extends (0, $8255b78460174178$export$2e2bcd8739ae039) {
    constructor(errorCode, summary, resp){
        super(summary);
        this.resp = null;
        this.name = 'OAuthError';
        this.errorCode = errorCode;
        this.errorSummary = summary;
        this.error = errorCode;
        this.error_description = summary;
        if (resp) this.resp = resp;
    }
}



var $cbeaafbff16be8ee$exports = {};

$parcel$export($cbeaafbff16be8ee$exports, "isBrowser", () => $cbeaafbff16be8ee$export$4e09c449d6c407f7);
$parcel$export($cbeaafbff16be8ee$exports, "isIE11OrLess", () => $cbeaafbff16be8ee$export$302f5f2c80ff991d);
$parcel$export($cbeaafbff16be8ee$exports, "getUserAgent", () => $cbeaafbff16be8ee$export$7935961ef7719cb0);
$parcel$export($cbeaafbff16be8ee$exports, "isFingerprintSupported", () => $cbeaafbff16be8ee$export$cfef6ce26ae59877);
$parcel$export($cbeaafbff16be8ee$exports, "isPopupPostMessageSupported", () => $cbeaafbff16be8ee$export$11913a9ce5f0afc7);
$parcel$export($cbeaafbff16be8ee$exports, "isTokenVerifySupported", () => $cbeaafbff16be8ee$export$9d89ee721af2fd32);
$parcel$export($cbeaafbff16be8ee$exports, "hasTextEncoder", () => $cbeaafbff16be8ee$export$930ee512796875bb);
$parcel$export($cbeaafbff16be8ee$exports, "isPKCESupported", () => $cbeaafbff16be8ee$export$29eda5462b5ce78d);
$parcel$export($cbeaafbff16be8ee$exports, "isHTTPS", () => $cbeaafbff16be8ee$export$ab537f3fcabe7053);
$parcel$export($cbeaafbff16be8ee$exports, "isLocalhost", () => $cbeaafbff16be8ee$export$ec8a6426516240fc);
$parcel$export($cbeaafbff16be8ee$exports, "isDPoPSupported", () => $cbeaafbff16be8ee$export$ed5ee78d39fe76d7);
$parcel$export($cbeaafbff16be8ee$exports, "isIOS", () => $cbeaafbff16be8ee$export$fedb369cb70207f1);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $a8d4082f60e792f5$export$1406ac7a6dfd7b7a = function(str) {
    return atob(str);
};
const $a8d4082f60e792f5$export$a32219e24f8d1e2 = function(str) {
    return btoa(str);
};
const $a8d4082f60e792f5$export$96ce270682c18269 = typeof crypto === 'undefined' ? null : crypto;


const $cbeaafbff16be8ee$var$isWindowsPhone = /windows phone|iemobile|wpdesktop/i;
function $cbeaafbff16be8ee$export$4e09c449d6c407f7() {
    return typeof document !== 'undefined' && typeof window !== 'undefined';
}
function $cbeaafbff16be8ee$export$302f5f2c80ff991d() {
    if (!$cbeaafbff16be8ee$export$4e09c449d6c407f7()) return false;
    const documentMode = document.documentMode;
    return !!documentMode && documentMode <= 11;
}
function $cbeaafbff16be8ee$export$7935961ef7719cb0() {
    return navigator.userAgent;
}
function $cbeaafbff16be8ee$export$cfef6ce26ae59877() {
    const agent = $cbeaafbff16be8ee$export$7935961ef7719cb0();
    return agent && !$cbeaafbff16be8ee$var$isWindowsPhone.test(agent);
}
function $cbeaafbff16be8ee$export$11913a9ce5f0afc7() {
    if (!$cbeaafbff16be8ee$export$4e09c449d6c407f7()) return false;
    const documentMode = document.documentMode;
    var isIE8or9 = documentMode && documentMode < 10;
    if (typeof window.postMessage !== 'undefined' && !isIE8or9) return true;
    return false;
}
function $cbeaafbff16be8ee$var$isWebCryptoSubtleSupported() {
    return typeof (0, $a8d4082f60e792f5$export$96ce270682c18269) !== 'undefined' && (0, $a8d4082f60e792f5$export$96ce270682c18269) !== null && typeof (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle !== 'undefined' && typeof Uint8Array !== 'undefined';
}
function $cbeaafbff16be8ee$export$9d89ee721af2fd32() {
    return $cbeaafbff16be8ee$var$isWebCryptoSubtleSupported();
}
function $cbeaafbff16be8ee$export$930ee512796875bb() {
    return typeof TextEncoder !== 'undefined';
}
function $cbeaafbff16be8ee$export$29eda5462b5ce78d() {
    return $cbeaafbff16be8ee$export$9d89ee721af2fd32() && $cbeaafbff16be8ee$export$930ee512796875bb();
}
function $cbeaafbff16be8ee$export$ab537f3fcabe7053() {
    if (!$cbeaafbff16be8ee$export$4e09c449d6c407f7()) return false;
    return window.location.protocol === 'https:';
}
function $cbeaafbff16be8ee$export$ec8a6426516240fc() {
    return $cbeaafbff16be8ee$export$4e09c449d6c407f7() && window.location.hostname === 'localhost';
}
function $cbeaafbff16be8ee$export$ed5ee78d39fe76d7() {
    return !$cbeaafbff16be8ee$export$302f5f2c80ff991d() && typeof window.indexedDB !== 'undefined' && $cbeaafbff16be8ee$export$930ee512796875bb() && $cbeaafbff16be8ee$var$isWebCryptoSubtleSupported();
}
function $cbeaafbff16be8ee$export$fedb369cb70207f1() {
    return $cbeaafbff16be8ee$export$4e09c449d6c407f7() && typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}


let $b8f53662f6ac3919$var$dateDocumentBecameVisible = 0;
let $b8f53662f6ac3919$var$trackDateDocumentBecameVisible;
if ((0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)()) {
    $b8f53662f6ac3919$var$dateDocumentBecameVisible = Date.now();
    $b8f53662f6ac3919$var$trackDateDocumentBecameVisible = ()=>{
        if (!document.hidden) $b8f53662f6ac3919$var$dateDocumentBecameVisible = Date.now();
    };
    document.addEventListener('visibilitychange', $b8f53662f6ac3919$var$trackDateDocumentBecameVisible);
}
const $b8f53662f6ac3919$var$formatError = (sdk, error)=>{
    var _a;
    if (error instanceof Error) return new (0, $b7e782aa925a4626$export$2e2bcd8739ae039)({
        errorSummary: error.message
    });
    let resp = error;
    let err;
    let serverErr = {};
    if (resp.responseText && (0, $307f2ba6550d7c99$export$844ec244b1367d54)(resp.responseText)) try {
        serverErr = JSON.parse(resp.responseText);
    } catch (e) {
        serverErr = {
            errorSummary: 'Unknown error'
        };
    }
    if (resp.status >= 500) serverErr.errorSummary = 'Unknown error';
    if (sdk.options.transformErrorXHR) resp = sdk.options.transformErrorXHR((0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(resp));
    const wwwAuthHeader = (_a = (0, $d28aec32d9343bab$export$2e2bcd8739ae039).getWWWAuthenticateHeader(resp === null || resp === void 0 ? void 0 : resp.headers)) !== null && _a !== void 0 ? _a : '';
    if (serverErr.error && serverErr.error_description) err = new (0, $b17ce0de6fad00bb$export$2e2bcd8739ae039)(serverErr.error, serverErr.error_description, resp);
    else err = new (0, $b7e782aa925a4626$export$2e2bcd8739ae039)(serverErr, resp, {
        wwwAuthHeader: wwwAuthHeader
    });
    if (wwwAuthHeader && (resp === null || resp === void 0 ? void 0 : resp.status) >= 400 && (resp === null || resp === void 0 ? void 0 : resp.status) < 500) {
        const wwwAuthErr = (0, $d28aec32d9343bab$export$2e2bcd8739ae039).parseHeader(wwwAuthHeader);
        if (resp.status === 403 && (wwwAuthErr === null || wwwAuthErr === void 0 ? void 0 : wwwAuthErr.error) === 'insufficient_authentication_context') {
            const { max_age: max_age, acr_values: acr_values } = wwwAuthErr.parameters;
            err = new (0, $b7e782aa925a4626$export$2e2bcd8739ae039)({
                errorSummary: wwwAuthErr.error,
                errorCauses: [
                    {
                        errorSummary: wwwAuthErr.errorDescription
                    }
                ]
            }, resp, Object.assign({
                max_age: +max_age
            }, acr_values && {
                acr_values: acr_values
            }));
        } else if ((wwwAuthErr === null || wwwAuthErr === void 0 ? void 0 : wwwAuthErr.scheme) === 'DPoP') err = wwwAuthErr;
    }
    return err;
};
function $b8f53662f6ac3919$export$46f383001bf60e04(sdk, options) {
    var _a;
    options = options || {};
    if (sdk.options.httpRequestInterceptors) for (const interceptor of sdk.options.httpRequestInterceptors)interceptor(options);
    var url = options.url, method = options.method, args = options.args, saveAuthnState = options.saveAuthnState, accessToken = options.accessToken, withCredentials = options.withCredentials === true, storageUtil = sdk.options.storageUtil, storage = storageUtil.storage, httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies), pollingIntent = options.pollingIntent, pollDelay = (_a = sdk.options.pollDelay) !== null && _a !== void 0 ? _a : 0;
    if (options.cacheResponse) {
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[url];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) return Promise.resolve(cachedResponse.response);
    }
    var oktaUserAgentHeader = sdk._oktaUserAgent.getHttpHeader();
    var headers = Object.assign({
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }, oktaUserAgentHeader);
    Object.assign(headers, sdk.options.headers, options.headers);
    headers = (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)(headers);
    if (accessToken && (0, $307f2ba6550d7c99$export$844ec244b1367d54)(accessToken)) headers['Authorization'] = 'Bearer ' + accessToken;
    var ajaxOptions = {
        headers: headers,
        data: args || undefined,
        withCredentials: withCredentials
    };
    var err, res, promise;
    if (pollingIntent && (0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)() && pollDelay > 0) {
        let waitForVisibleAndAwakenDocument;
        let waitForAwakenDocument;
        let recursiveFetch;
        let retryCount = 0;
        waitForAwakenDocument = ()=>{
            const timeSinceDocumentIsVisible = Date.now() - $b8f53662f6ac3919$var$dateDocumentBecameVisible;
            if (timeSinceDocumentIsVisible < pollDelay) return new Promise((resolve)=>setTimeout(()=>{
                    if (!document.hidden) resolve();
                    else resolve(waitForVisibleAndAwakenDocument());
                }, pollDelay - timeSinceDocumentIsVisible));
            else return Promise.resolve();
        };
        waitForVisibleAndAwakenDocument = ()=>{
            if (document.hidden) {
                let pageVisibilityHandler;
                return new Promise((resolve)=>{
                    pageVisibilityHandler = ()=>{
                        if (!document.hidden) {
                            document.removeEventListener('visibilitychange', pageVisibilityHandler);
                            resolve(waitForAwakenDocument());
                        }
                    };
                    document.addEventListener('visibilitychange', pageVisibilityHandler);
                });
            } else return waitForAwakenDocument();
        };
        const retryableFetch = ()=>{
            return sdk.options.httpRequestClient(method, url, ajaxOptions).catch((err)=>{
                const isNetworkError = (err === null || err === void 0 ? void 0 : err.message) === 'Load failed';
                if (isNetworkError && retryCount < (0, $2119f0a66eb38a81$export$5f5ecd9ae1a04492)) {
                    retryCount++;
                    return recursiveFetch();
                }
                throw err;
            });
        };
        recursiveFetch = ()=>{
            return waitForVisibleAndAwakenDocument().then(retryableFetch);
        };
        promise = recursiveFetch();
    } else promise = sdk.options.httpRequestClient(method, url, ajaxOptions);
    return promise.then(function(resp) {
        res = resp.responseText;
        if (res && (0, $307f2ba6550d7c99$export$844ec244b1367d54)(res)) {
            res = JSON.parse(res);
            if (res && typeof res === 'object' && !res.headers) {
                if (Array.isArray(res)) res.forEach((item)=>{
                    item.headers = resp.headers;
                });
                else res.headers = resp.headers;
            }
        }
        if (saveAuthnState) {
            if (!res.stateToken) storage.delete((0, $2119f0a66eb38a81$export$511e8ed0baecd62c));
        }
        if (res && res.stateToken && res.expiresAt) storage.set((0, $2119f0a66eb38a81$export$511e8ed0baecd62c), res.stateToken, res.expiresAt, sdk.options.cookies);
        if (res && options.cacheResponse) httpCache.updateStorage(url, {
            expiresAt: Math.floor(Date.now() / 1000) + (0, $2119f0a66eb38a81$export$adfe1f91858943cf),
            response: res
        });
        return res;
    }).catch(function(resp) {
        err = $b8f53662f6ac3919$var$formatError(sdk, resp);
        if (err.errorCode === 'E0000011') storage.delete((0, $2119f0a66eb38a81$export$511e8ed0baecd62c));
        throw err;
    });
}
function $b8f53662f6ac3919$export$3988ae62b71be9a3(sdk, url, options) {
    url = (0, $83e7c3a0ba92185e$export$a1cbf2de32a9fd1)(url) ? url : sdk.getIssuerOrigin() + url;
    var getOptions = {
        url: url,
        method: 'GET'
    };
    Object.assign(getOptions, options);
    return $b8f53662f6ac3919$export$46f383001bf60e04(sdk, getOptions);
}
function $b8f53662f6ac3919$export$299ba2dee77727e9(sdk, url, args, options) {
    url = (0, $83e7c3a0ba92185e$export$a1cbf2de32a9fd1)(url) ? url : sdk.getIssuerOrigin() + url;
    var postOptions = {
        url: url,
        method: 'POST',
        args: args,
        saveAuthnState: true
    };
    Object.assign(postOptions, options);
    return $b8f53662f6ac3919$export$46f383001bf60e04(sdk, postOptions);
}


var $bb3d51bfa22856f3$exports = {};
function $bb3d51bfa22856f3$var$E() {
// Keep this empty so it's easier to inherit from
// (via https://github.com/lipsmack from https://github.com/scottcorgan/tiny-emitter/issues/3)
}
$bb3d51bfa22856f3$var$E.prototype = {
    on: function(name, callback, ctx) {
        var e = this.e || (this.e = {});
        (e[name] || (e[name] = [])).push({
            fn: callback,
            ctx: ctx
        });
        return this;
    },
    once: function(name, callback, ctx) {
        var self = this;
        function listener() {
            self.off(name, listener);
            callback.apply(ctx, arguments);
        }
        listener._ = callback;
        return this.on(name, listener, ctx);
    },
    emit: function(name) {
        var data = [].slice.call(arguments, 1);
        var evtArr = ((this.e || (this.e = {}))[name] || []).slice();
        var i = 0;
        var len = evtArr.length;
        for(i; i < len; i++)evtArr[i].fn.apply(evtArr[i].ctx, data);
        return this;
    },
    off: function(name, callback) {
        var e = this.e || (this.e = {});
        var evts = e[name];
        var liveEvents = [];
        if (evts && callback) {
            for(var i = 0, len = evts.length; i < len; i++)if (evts[i].fn !== callback && evts[i].fn._ !== callback) liveEvents.push(evts[i]);
        }
        // Remove event from queue to prevent memory leak
        // Suggested by https://github.com/lazd
        // Ref: https://github.com/scottcorgan/tiny-emitter/commit/c6ebfaa9bc973b33d110a84a307742b7cf94c953#commitcomment-5024910
        liveEvents.length ? e[name] = liveEvents : delete e[name];
        return this;
    }
};
$bb3d51bfa22856f3$exports = $bb3d51bfa22856f3$var$E;


/*! js-cookie v3.0.5 | MIT */ /* eslint-disable no-var */ function $fb2bda4b905adee7$var$assign(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)target[key] = source[key];
    }
    return target;
}
/* eslint-enable no-var */ /* eslint-disable no-var */ var $fb2bda4b905adee7$var$defaultConverter = {
    read: function(value) {
        if (value[0] === '"') value = value.slice(1, -1);
        return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
    },
    write: function(value) {
        return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
    }
};
/* eslint-enable no-var */ /* eslint-disable no-var */ function $fb2bda4b905adee7$var$init(converter, defaultAttributes) {
    function set(name, value, attributes) {
        if (typeof document === 'undefined') return;
        attributes = $fb2bda4b905adee7$var$assign({}, defaultAttributes, attributes);
        if (typeof attributes.expires === 'number') attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
        if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
        name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
        var stringifiedAttributes = '';
        for(var attributeName in attributes){
            if (!attributes[attributeName]) continue;
            stringifiedAttributes += '; ' + attributeName;
            if (attributes[attributeName] === true) continue;
            // Considers RFC 6265 section 5.2:
            // ...
            // 3.  If the remaining unparsed-attributes contains a %x3B (";")
            //     character:
            // Consume the characters of the unparsed-attributes up to,
            // not including, the first %x3B (";") character.
            // ...
            stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
        }
        return document.cookie = name + '=' + converter.write(value, name) + stringifiedAttributes;
    }
    function get(name) {
        if (typeof document === 'undefined' || arguments.length && !name) return;
        // To prevent the for loop in the first place assign an empty array
        // in case there are no cookies at all.
        var cookies = document.cookie ? document.cookie.split('; ') : [];
        var jar = {};
        for(var i = 0; i < cookies.length; i++){
            var parts = cookies[i].split('=');
            var value = parts.slice(1).join('=');
            try {
                var found = decodeURIComponent(parts[0]);
                jar[found] = converter.read(value, found);
                if (name === found) break;
            } catch (e) {}
        }
        return name ? jar[name] : jar;
    }
    return Object.create({
        set: set,
        get: get,
        remove: function(name, attributes) {
            set(name, '', $fb2bda4b905adee7$var$assign({}, attributes, {
                expires: -1
            }));
        },
        withAttributes: function(attributes) {
            return $fb2bda4b905adee7$var$init(this.converter, $fb2bda4b905adee7$var$assign({}, this.attributes, attributes));
        },
        withConverter: function(converter) {
            return $fb2bda4b905adee7$var$init($fb2bda4b905adee7$var$assign({}, this.converter, converter), this.attributes);
        }
    }, {
        attributes: {
            value: Object.freeze(defaultAttributes)
        },
        converter: {
            value: Object.freeze(converter)
        }
    });
}
var $fb2bda4b905adee7$export$2e2bcd8739ae039 = $fb2bda4b905adee7$var$init($fb2bda4b905adee7$var$defaultConverter, {
    path: '/'
});


parcelRequire("R5nvG");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $1728265dc3c1bbda$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["ACCESS"] = "accessToken";
    TokenKind["ID"] = "idToken";
    TokenKind["REFRESH"] = "refreshToken";
})($1728265dc3c1bbda$export$8b9d26ab11394711 || ($1728265dc3c1bbda$export$8b9d26ab11394711 = {}));
function $1728265dc3c1bbda$export$7c699a821ea811bc(obj) {
    if (obj && (obj.accessToken || obj.idToken || obj.refreshToken) && Array.isArray(obj.scopes)) return true;
    return false;
}
function $1728265dc3c1bbda$export$3a59e0981c18db3c(obj) {
    return obj && obj.accessToken;
}
function $1728265dc3c1bbda$export$e183da9b0d22b235(obj) {
    return obj && obj.idToken;
}
function $1728265dc3c1bbda$export$178a2c036dbf8815(obj) {
    return obj && obj.refreshToken;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ function $ca95e6f9e1ec9f80$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
typeof SuppressedError === "function" && SuppressedError;


async function $c6cd386983d9ca48$export$88d345acadfc62dd(authClient, options = {}) {
    const tokenParams = await authClient.token.prepareTokenParams(options);
    const pkceMeta = (0, $487672a81f8ed323$export$6fd737cbc709c406)(authClient, tokenParams);
    let { flow: flow = 'default', withCredentials: withCredentials = true, activationToken: activationToken, recoveryToken: recoveryToken, maxAge: maxAge, acrValues: acrValues } = Object.assign(Object.assign({}, authClient.options), options);
    const meta = Object.assign(Object.assign({}, pkceMeta), {
        flow: flow,
        withCredentials: withCredentials,
        activationToken: activationToken,
        recoveryToken: recoveryToken,
        maxAge: maxAge,
        acrValues: acrValues
    });
    return meta;
}
function $c6cd386983d9ca48$export$ca280d73913750db(authClient, options) {
    const savedMeta = $c6cd386983d9ca48$export$ee78659ae5675f26(authClient, options);
    if (savedMeta === null || savedMeta === void 0 ? void 0 : savedMeta.interactionHandle) return true;
    return false;
}
function $c6cd386983d9ca48$export$ee78659ae5675f26(authClient, options) {
    options = (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    let savedMeta;
    try {
        savedMeta = authClient.transactionManager.load(options);
    } catch (e) {}
    if (!savedMeta) return;
    if ($c6cd386983d9ca48$export$e14be23af70c5fd(savedMeta, options)) return savedMeta;
    (0, $5502e384469ea433$export$c106dd0671a0fc2d)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
}
async function $c6cd386983d9ca48$export$701cc743c44cf8ae(authClient, options) {
    options = (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)(options);
    options = Object.assign(Object.assign({}, authClient.options), options);
    const validExistingMeta = $c6cd386983d9ca48$export$ee78659ae5675f26(authClient, options);
    if (validExistingMeta) return validExistingMeta;
    return $c6cd386983d9ca48$export$88d345acadfc62dd(authClient, options);
}
function $c6cd386983d9ca48$export$dc27696b235944d6(authClient, meta) {
    authClient.transactionManager.save(meta, {
        muteWarning: true
    });
}
function $c6cd386983d9ca48$export$750593bdfc027325(authClient) {
    authClient.transactionManager.clear();
}
function $c6cd386983d9ca48$export$e14be23af70c5fd(meta, options = {}) {
    const keys = [
        'issuer',
        'clientId',
        'redirectUri',
        'state',
        'codeChallenge',
        'codeChallengeMethod',
        'activationToken',
        'recoveryToken'
    ];
    if ($c6cd386983d9ca48$export$1b2885e9c397dca2(meta, options, keys) === false) return false;
    const { flow: flow } = options;
    if ($c6cd386983d9ca48$export$d422e962aa11e537(meta, flow) === false) return false;
    return true;
}
function $c6cd386983d9ca48$export$d422e962aa11e537(meta, flow) {
    const shouldValidateFlow = flow && flow !== 'default' && flow !== 'proceed';
    if (shouldValidateFlow) {
        if (flow !== meta.flow) return false;
    }
    return true;
}
function $c6cd386983d9ca48$export$1b2885e9c397dca2(meta, options, keys) {
    const mismatch = keys.some((key)=>{
        const value = options[key];
        if (value && value !== meta[key]) return true;
    });
    return !mismatch;
}








parcelRequire("R5nvG");


function $2027d28688355efb$var$getResponse(meta) {
    return {
        meta: meta,
        interactionHandle: meta.interactionHandle,
        state: meta.state
    };
}
async function $2027d28688355efb$export$20814a0f9b60f8cf(authClient, options = {}) {
    options = (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)(options);
    let meta = (0, $c6cd386983d9ca48$export$ee78659ae5675f26)(authClient, options);
    if (meta === null || meta === void 0 ? void 0 : meta.interactionHandle) return $2027d28688355efb$var$getResponse(meta);
    meta = await (0, $c6cd386983d9ca48$export$88d345acadfc62dd)(authClient, Object.assign(Object.assign({}, meta), options));
    const baseUrl = (0, $28694eacc5911f05$export$11243677e2baf764)(authClient);
    let { clientId: clientId, redirectUri: redirectUri, state: state, scopes: scopes, withCredentials: withCredentials, codeChallenge: codeChallenge, codeChallengeMethod: codeChallengeMethod, activationToken: activationToken, recoveryToken: recoveryToken, maxAge: maxAge, acrValues: acrValues, nonce: nonce } = meta;
    const clientSecret = options.clientSecret || authClient.options.clientSecret;
    withCredentials = withCredentials !== null && withCredentials !== void 0 ? withCredentials : true;
    const url = `${baseUrl}/v1/interact`;
    const params = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        client_id: clientId,
        scope: scopes.join(' '),
        redirect_uri: redirectUri,
        code_challenge: codeChallenge,
        code_challenge_method: codeChallengeMethod,
        state: state
    }, activationToken && {
        activation_token: activationToken
    }), recoveryToken && {
        recovery_token: recoveryToken
    }), clientSecret && {
        client_secret: clientSecret
    }), maxAge && {
        max_age: maxAge
    }), acrValues && {
        acr_values: acrValues
    }), nonce && {
        nonce: nonce
    });
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    const resp = await (0, $b8f53662f6ac3919$export$46f383001bf60e04)(authClient, {
        method: 'POST',
        url: url,
        headers: headers,
        withCredentials: withCredentials,
        args: params
    });
    const interactionHandle = resp.interaction_handle;
    const newMeta = Object.assign(Object.assign({}, meta), {
        interactionHandle: interactionHandle,
        withCredentials: withCredentials,
        state: state,
        scopes: scopes,
        recoveryToken: recoveryToken,
        activationToken: activationToken
    });
    (0, $c6cd386983d9ca48$export$dc27696b235944d6)(authClient, newMeta);
    return $2027d28688355efb$var$getResponse(newMeta);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




parcelRequire("R5nvG");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $f0a5b12f75550181$var$isFieldMutable = function isFieldMutable(field) {
    return field.mutable !== false;
};
const $f0a5b12f75550181$var$divideSingleActionParamsByMutability = function divideSingleActionParamsByMutability(action) {
    var _a, _b;
    const defaultParamsForAction = {};
    const neededParamsForAction = [];
    const immutableParamsForAction = {};
    if (!action.value) {
        neededParamsForAction.push(action);
        return {
            defaultParamsForAction: defaultParamsForAction,
            neededParamsForAction: neededParamsForAction,
            immutableParamsForAction: immutableParamsForAction
        };
    }
    for (let field of action.value)if ($f0a5b12f75550181$var$isFieldMutable(field)) {
        neededParamsForAction.push(field);
        if ((_a = field.value) !== null && _a !== void 0 ? _a : false) defaultParamsForAction[field.name] = field.value;
    } else immutableParamsForAction[field.name] = (_b = field.value) !== null && _b !== void 0 ? _b : '';
    return {
        defaultParamsForAction: defaultParamsForAction,
        neededParamsForAction: neededParamsForAction,
        immutableParamsForAction: immutableParamsForAction
    };
};
const $f0a5b12f75550181$export$4c3d503ea1c11b10 = function divideActionParamsByMutability(actionList) {
    actionList = Array.isArray(actionList) ? actionList : [
        actionList
    ];
    const neededParams = [];
    const defaultParams = {};
    const immutableParams = {};
    for (let action of actionList){
        const { defaultParamsForAction: defaultParamsForAction, neededParamsForAction: neededParamsForAction, immutableParamsForAction: immutableParamsForAction } = $f0a5b12f75550181$var$divideSingleActionParamsByMutability(action);
        neededParams.push(neededParamsForAction);
        defaultParams[action.name] = defaultParamsForAction;
        immutableParams[action.name] = immutableParamsForAction;
    }
    return {
        defaultParams: defaultParams,
        neededParams: neededParams,
        immutableParams: immutableParams
    };
};


const $e06342644768b7f6$var$generateDirectFetch = function generateDirectFetch(authClient, { actionDefinition: actionDefinition, defaultParamsForAction: defaultParamsForAction = {}, immutableParamsForAction: immutableParamsForAction = {}, toPersist: toPersist = {} }) {
    const target = actionDefinition.href;
    return async function(params = {}) {
        var _a, _b;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': actionDefinition.accepts || 'application/ion+json'
        };
        const body = JSON.stringify(Object.assign(Object.assign(Object.assign({}, defaultParamsForAction), params), immutableParamsForAction));
        try {
            const options = {
                url: target,
                method: actionDefinition.method,
                headers: headers,
                args: body,
                withCredentials: (_a = toPersist === null || toPersist === void 0 ? void 0 : toPersist.withCredentials) !== null && _a !== void 0 ? _a : true
            };
            const isPolling = actionDefinition.name === 'poll' || ((_b = actionDefinition.name) === null || _b === void 0 ? void 0 : _b.endsWith('-poll'));
            if (isPolling) options.pollingIntent = true;
            const response = await (0, $b8f53662f6ac3919$export$46f383001bf60e04)(authClient, options);
            return authClient.idx.makeIdxResponse(Object.assign({}, response), toPersist, true);
        } catch (err) {
            if (!(err instanceof (0, $b7e782aa925a4626$export$2e2bcd8739ae039)) || !(err === null || err === void 0 ? void 0 : err.xhr)) throw err;
            const response = err.xhr;
            const payload = response.responseJSON || JSON.parse(response.responseText);
            const wwwAuthHeader = response.headers['WWW-Authenticate'] || response.headers['www-authenticate'];
            const idxResponse = authClient.idx.makeIdxResponse(Object.assign({}, payload), toPersist, false);
            if (response.status === 401 && wwwAuthHeader === 'Oktadevicejwt realm="Okta Device"') idxResponse.stepUp = true;
            return idxResponse;
        }
    };
};
const $e06342644768b7f6$export$2e2bcd8739ae039 = function generateIdxAction(authClient, actionDefinition, toPersist) {
    const generator = $e06342644768b7f6$var$generateDirectFetch;
    const { defaultParams: defaultParams, neededParams: neededParams, immutableParams: immutableParams } = (0, $f0a5b12f75550181$export$4c3d503ea1c11b10)(actionDefinition);
    const action = generator(authClient, {
        actionDefinition: actionDefinition,
        defaultParamsForAction: defaultParams[actionDefinition.name],
        immutableParamsForAction: immutableParams[actionDefinition.name],
        toPersist: toPersist
    });
    action.neededParams = neededParams;
    return action;
};


const $690980e12ff31d55$export$4238c1f37c3119f5 = function generateRemediationFunctions(authClient, remediationValue, toPersist = {}) {
    return remediationValue.reduce((obj, remediation)=>Object.assign(Object.assign({}, obj), {
            [remediation.name]: (0, $e06342644768b7f6$export$2e2bcd8739ae039)(authClient, remediation, toPersist)
        }), {});
};



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $efdef85212a629b7$var$jsonpathRegex = /\$?(?<step>\w+)|(?:\[(?<index>\d+)\])/g;
function $efdef85212a629b7$export$2562421ccea4d9dd({ path: path, json: json }) {
    var _a, _b, _c;
    const steps = [];
    let match;
    while((match = $efdef85212a629b7$var$jsonpathRegex.exec(path)) !== null){
        const step = (_b = (_a = match === null || match === void 0 ? void 0 : match.groups) === null || _a === void 0 ? void 0 : _a.step) !== null && _b !== void 0 ? _b : (_c = match === null || match === void 0 ? void 0 : match.groups) === null || _c === void 0 ? void 0 : _c.index;
        if (step) steps.push(step);
    }
    if (steps.length < 1) return undefined;
    const lastStep = steps.pop();
    let curr = json;
    for (const step of steps)if (Object.prototype.hasOwnProperty.call(curr, step)) {
        if (typeof curr[step] !== 'object') return undefined;
        curr = curr[step];
    }
    return curr[lastStep];
}




const $801348e3f3b6224b$var$SKIP_FIELDS = {
    'remediation': true,
    'context': true
};
const $801348e3f3b6224b$export$5737e7831fcbdfb8 = function parseNonRemediations(authClient, idxResponse, toPersist = {}) {
    const actions = {};
    const context = {};
    Object.keys(idxResponse).filter((field)=>!$801348e3f3b6224b$var$SKIP_FIELDS[field]).forEach((field)=>{
        const fieldIsObject = typeof idxResponse[field] === 'object' && !!idxResponse[field];
        if (!fieldIsObject) {
            context[field] = idxResponse[field];
            return;
        }
        if (idxResponse[field].rel) {
            actions[idxResponse[field].name] = (0, $e06342644768b7f6$export$2e2bcd8739ae039)(authClient, idxResponse[field], toPersist);
            return;
        }
        const _a = idxResponse[field], { value: fieldValue, type: type } = _a, info = (0, $ca95e6f9e1ec9f80$export$3c9a16f847548506)(_a, [
            "value",
            "type"
        ]);
        context[field] = Object.assign({
            type: type
        }, info);
        if (type !== 'object') {
            context[field].value = fieldValue;
            return;
        }
        context[field].value = {};
        Object.entries(fieldValue).forEach(([subField, value])=>{
            if (value.rel) actions[`${field}-${subField.name || subField}`] = (0, $e06342644768b7f6$export$2e2bcd8739ae039)(authClient, value, toPersist);
            else context[field].value[subField] = value;
        });
    });
    return {
        context: context,
        actions: actions
    };
};
const $801348e3f3b6224b$var$expandRelatesTo = (idxResponse, value)=>{
    Object.keys(value).forEach((k)=>{
        if (k === 'relatesTo') {
            const query = Array.isArray(value[k]) ? value[k][0] : value[k];
            if (typeof query === 'string') {
                const result = (0, $efdef85212a629b7$export$2562421ccea4d9dd)({
                    path: query,
                    json: idxResponse
                });
                if (result) {
                    value[k] = result;
                    return;
                } else throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)(`Cannot resolve relatesTo: ${query}`);
            }
        }
        if (Array.isArray(value[k])) value[k].forEach((innerValue)=>$801348e3f3b6224b$var$expandRelatesTo(idxResponse, innerValue));
    });
};
const $801348e3f3b6224b$var$convertRemediationAction = (authClient, remediation, toPersist)=>{
    if (remediation.rel) {
        const remediationActions = (0, $690980e12ff31d55$export$4238c1f37c3119f5)(authClient, [
            remediation
        ], toPersist);
        const actionFn = remediationActions[remediation.name];
        return Object.assign(Object.assign({}, remediation), {
            action: actionFn
        });
    }
    return remediation;
};
const $801348e3f3b6224b$export$7da4ffbe52143665 = function parseIdxResponse(authClient, idxResponse, toPersist = {}) {
    var _a;
    const remediationData = ((_a = idxResponse.remediation) === null || _a === void 0 ? void 0 : _a.value) || [];
    remediationData.forEach((remediation)=>{
        var _a;
        if (remediation.name === 'launch-authenticator' && ((_a = remediation === null || remediation === void 0 ? void 0 : remediation.relatesTo) === null || _a === void 0 ? void 0 : _a[0]) === 'authenticatorChallenge' && !(idxResponse === null || idxResponse === void 0 ? void 0 : idxResponse.authenticatorChallenge)) {
            delete remediation.relatesTo;
            return;
        }
        return $801348e3f3b6224b$var$expandRelatesTo(idxResponse, remediation);
    });
    const remediations = remediationData.map((remediation)=>$801348e3f3b6224b$var$convertRemediationAction(authClient, remediation, toPersist));
    const { context: context, actions: actions } = $801348e3f3b6224b$export$5737e7831fcbdfb8(authClient, idxResponse, toPersist);
    return {
        remediations: remediations,
        context: context,
        actions: actions
    };
};


function $d8b56a8f95a03e63$export$67f6ec95030789e9(authClient, idxResponse, toPersist, requestDidSucceed) {
    var _a, _b, _c;
    const rawIdxResponse = idxResponse;
    const { remediations: remediations, context: context, actions: actions } = (0, $801348e3f3b6224b$export$7da4ffbe52143665)(authClient, idxResponse, toPersist);
    const neededToProceed = [
        ...remediations
    ];
    const proceed = async function(remediationChoice, paramsFromUser = {}) {
        const remediationChoiceObject = remediations.find((remediation)=>remediation.name === remediationChoice);
        if (!remediationChoiceObject) return Promise.reject(`Unknown remediation choice: [${remediationChoice}]`);
        const actionFn = remediationChoiceObject.action;
        if (typeof actionFn !== 'function') return Promise.reject(`Current remediation cannot make form submit action: [${remediationChoice}]`);
        return remediationChoiceObject.action(paramsFromUser);
    };
    const findCode = (item)=>item.name === 'interaction_code';
    const interactionCode = (_c = (_b = (_a = rawIdxResponse.successWithInteractionCode) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.find(findCode)) === null || _c === void 0 ? void 0 : _c.value;
    return {
        proceed: proceed,
        neededToProceed: neededToProceed,
        actions: actions,
        context: context,
        rawIdxState: rawIdxResponse,
        interactionCode: interactionCode,
        toPersist: toPersist,
        requestDidSucceed: requestDidSucceed
    };
}


var $d675c72be7ba7960$export$2e2bcd8739ae039 = {
    makeIdxState: $d8b56a8f95a03e63$export$67f6ec95030789e9
};


const $40b25ced63ff9c03$export$7ba1824e1085df61 = function parsersForVersion(version) {
    switch(version){
        case '1.0.0':
            return 0, $d675c72be7ba7960$export$2e2bcd8739ae039;
        case undefined:
        case null:
            throw new Error('Api version is required');
        default:
            throw new Error(`Unknown api version: ${version}.  Use an exact semver version.`);
    }
};
function $40b25ced63ff9c03$export$dab03d97af55f77c(version) {
    if (!version) throw new Error('version is required');
    const cleanVersion = (version !== null && version !== void 0 ? version : '').replace(/[^0-9a-zA-Z._-]/, '');
    if (cleanVersion !== version || !version) throw new Error('invalid version supplied - version is required and uses semver syntax');
    $40b25ced63ff9c03$export$7ba1824e1085df61(version);
}
function $40b25ced63ff9c03$export$67f6ec95030789e9(authClient, rawIdxResponse, toPersist, requestDidSucceed) {
    var _a;
    const version = (_a = rawIdxResponse === null || rawIdxResponse === void 0 ? void 0 : rawIdxResponse.version) !== null && _a !== void 0 ? _a : (0, $2119f0a66eb38a81$export$3e8b495e17a161fe);
    $40b25ced63ff9c03$export$dab03d97af55f77c(version);
    const { makeIdxState: makeIdxState } = $40b25ced63ff9c03$export$7ba1824e1085df61(version);
    return makeIdxState(authClient, rawIdxResponse, toPersist, requestDidSucceed);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $b09480b83b84af67$export$e440ed50f1b21dd3(obj) {
    return obj && obj.version;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $00075bbb69b7d8b4$export$4fe744aeb810d543(obj) {
    return obj instanceof (0, $b7e782aa925a4626$export$2e2bcd8739ae039);
}
function $00075bbb69b7d8b4$export$65ac14d4981b453f(obj) {
    return obj instanceof (0, $b17ce0de6fad00bb$export$2e2bcd8739ae039);
}
function $00075bbb69b7d8b4$export$380e188e91bd13a1(obj) {
    return obj instanceof (0, $d28aec32d9343bab$export$2e2bcd8739ae039);
}







parcelRequire("R5nvG");


async function $21d92a1cc115c86c$export$3b41a86e379f8f15(authClient, options = {}) {
    var _a;
    let rawIdxResponse;
    let requestDidSucceed;
    const savedIdxResponse = authClient.transactionManager.loadIdxResponse(options);
    if (savedIdxResponse) {
        rawIdxResponse = savedIdxResponse.rawIdxResponse;
        requestDidSucceed = savedIdxResponse.requestDidSucceed;
    }
    if (!rawIdxResponse) {
        const version = options.version || (0, $2119f0a66eb38a81$export$3e8b495e17a161fe);
        const domain = (0, $28694eacc5911f05$export$bf8eda7d9615a5f0)(authClient);
        const { interactionHandle: interactionHandle, stateHandle: stateHandle } = options;
        const withCredentials = (_a = options.withCredentials) !== null && _a !== void 0 ? _a : true;
        try {
            requestDidSucceed = true;
            (0, $40b25ced63ff9c03$export$dab03d97af55f77c)(version);
            const url = `${domain}/idp/idx/introspect`;
            const body = stateHandle ? {
                stateToken: stateHandle
            } : {
                interactionHandle: interactionHandle
            };
            const headers = {
                'Content-Type': `application/ion+json; okta-version=${version}`,
                Accept: `application/ion+json; okta-version=${version}`
            };
            rawIdxResponse = await (0, $b8f53662f6ac3919$export$46f383001bf60e04)(authClient, {
                method: 'POST',
                url: url,
                headers: headers,
                withCredentials: withCredentials,
                args: body
            });
        } catch (err) {
            if ((0, $00075bbb69b7d8b4$export$4fe744aeb810d543)(err) && err.xhr && (0, $b09480b83b84af67$export$e440ed50f1b21dd3)(err.xhr.responseJSON)) {
                rawIdxResponse = err.xhr.responseJSON;
                requestDidSucceed = false;
            } else throw err;
        }
    }
    const { withCredentials: withCredentials } = options;
    return (0, $40b25ced63ff9c03$export$67f6ec95030789e9)(authClient, rawIdxResponse, {
        withCredentials: withCredentials
    }, requestDidSucceed);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $f063e89c0fabde24$export$b6327bf2935d9246(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.map((r)=>r.name);
}
function $f063e89c0fabde24$export$fa24fba53a75381b(idxRemediation) {
    var _a;
    return (_a = idxRemediation.value) === null || _a === void 0 ? void 0 : _a.reduce((required, cur)=>{
        if (cur.required) required.push(cur.name);
        return required;
    }, []);
}
function $f063e89c0fabde24$export$348afa8c9ff47183(str) {
    return str.charAt(0).toUpperCase() + str.substring(1);
}
function $f063e89c0fabde24$export$2c4be893a02ba700(remediation) {
    return remediation.value.find(({ name: name })=>name === 'authenticator');
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $c0eaea62dde87e17$export$a524de6c5d3a7a61(incoming) {
    let authenticator;
    if ((0, $23b7d84f5e759bd1$export$361ab32a8474b3c4)(incoming)) authenticator = incoming;
    else if (typeof incoming === 'string') authenticator = {
        key: incoming
    };
    else throw new Error('Invalid format for authenticator');
    return authenticator;
}
function $c0eaea62dde87e17$export$36b7fa650feebb56(auth1, auth2) {
    if (!auth1 || !auth2) return false;
    if (auth1.id && auth2.id) return auth1.id === auth2.id;
    if (auth1.key && auth2.key) return auth1.key === auth2.key;
    return false;
}
function $c0eaea62dde87e17$export$fafdedfcbb7d2691(authenticators, options) {
    let option;
    for (let authenticator of authenticators){
        option = options.find(({ relatesTo: relatesTo })=>relatesTo.key && relatesTo.key === authenticator.key);
        if (option) break;
    }
    return option;
}


class $27bc8f98a25df821$export$8ab7a5763733596 {
    constructor(remediation, values = {}, options = {}){
        this.values = Object.assign({}, values);
        this.options = Object.assign({}, options);
        this.formatAuthenticators();
        this.remediation = remediation;
    }
    formatAuthenticators() {
        this.values.authenticators = this.values.authenticators || [];
        this.values.authenticators = this.values.authenticators.map((authenticator)=>{
            return (0, $c0eaea62dde87e17$export$a524de6c5d3a7a61)(authenticator);
        });
        if (this.values.authenticator) {
            const authenticator = (0, $c0eaea62dde87e17$export$a524de6c5d3a7a61)(this.values.authenticator);
            const hasAuthenticatorInList = this.values.authenticators.some((existing)=>{
                return (0, $c0eaea62dde87e17$export$36b7fa650feebb56)(authenticator, existing);
            });
            if (!hasAuthenticatorInList) this.values.authenticators.push(authenticator);
        }
        this.values.authenticatorsData = this.values.authenticators.reduce((acc, authenticator)=>{
            if (typeof authenticator === 'object' && Object.keys(authenticator).length > 1) acc.push(authenticator);
            return acc;
        }, this.values.authenticatorsData || []);
    }
    getName() {
        return this.remediation.name;
    }
    canRemediate(context) {
        const required = (0, $f063e89c0fabde24$export$fa24fba53a75381b)(this.remediation);
        const needed = required.find((key)=>!this.hasData(key));
        if (needed) return false;
        return true;
    }
    getData(key) {
        if (!key) {
            let allValues = (0, $f063e89c0fabde24$export$b6327bf2935d9246)(this.remediation);
            let res = allValues.reduce((data, key)=>{
                data[key] = this.getData(key);
                return data;
            }, {});
            return res;
        }
        if (typeof this[`map${(0, $f063e89c0fabde24$export$348afa8c9ff47183)(key)}`] === 'function') {
            const val = this[`map${(0, $f063e89c0fabde24$export$348afa8c9ff47183)(key)}`](this.remediation.value.find(({ name: name })=>name === key));
            if (val) return val;
        }
        if (this.map && this.map[key]) {
            const entry = this.map[key];
            for(let i = 0; i < entry.length; i++){
                let val = this.values[entry[i]];
                if (val) return val;
            }
        }
        return this.values[key];
    }
    hasData(key) {
        return !!this.getData(key);
    }
    getNextStep(_authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const authenticator = this.getAuthenticator();
        const type = authenticator === null || authenticator === void 0 ? void 0 : authenticator.type;
        return Object.assign(Object.assign({
            name: name,
            inputs: inputs
        }, type && {
            type: type
        }), authenticator && {
            authenticator: authenticator
        });
    }
    getInputs() {
        const inputs = [];
        const inputsFromRemediation = this.remediation.value || [];
        inputsFromRemediation.forEach((inputFromRemediation)=>{
            let input;
            let { name: name, type: type, visible: visible, messages: messages } = inputFromRemediation;
            if (visible === false) return;
            if (typeof this[`getInput${(0, $f063e89c0fabde24$export$348afa8c9ff47183)(name)}`] === 'function') input = this[`getInput${(0, $f063e89c0fabde24$export$348afa8c9ff47183)(name)}`](inputFromRemediation);
            else if (type !== 'object') {
                let alias;
                const aliases = (this.map ? this.map[name] : null) || [];
                if (aliases.length === 1) alias = aliases[0];
                else alias = aliases.find((name)=>Object.keys(this.values).includes(name));
                if (alias) input = Object.assign(Object.assign({}, inputFromRemediation), {
                    name: alias
                });
            }
            if (!input) input = inputFromRemediation;
            if (Array.isArray(input)) input.forEach((i)=>inputs.push(i));
            else {
                if (messages) input.messages = messages;
                inputs.push(input);
            }
        });
        return inputs;
    }
    static getMessages(remediation) {
        var _a, _b;
        if (!remediation.value) return;
        return (_b = (_a = remediation.value[0]) === null || _a === void 0 ? void 0 : _a.form) === null || _b === void 0 ? void 0 : _b.value.reduce((messages, field)=>{
            if (field.messages) messages = [
                ...messages,
                ...field.messages.value
            ];
            return messages;
        }, []);
    }
    getValuesAfterProceed() {
        const inputsFromRemediation = this.remediation.value || [];
        const inputsFromRemediator = this.getInputs();
        const inputs = [
            ...inputsFromRemediation,
            ...inputsFromRemediator
        ];
        for (const input of inputs)delete this.values[input.name];
        return this.values;
    }
    getAuthenticator() {
        var _a, _b;
        const relatesTo = (_a = this.remediation.relatesTo) === null || _a === void 0 ? void 0 : _a.value;
        if (!relatesTo) return;
        const authenticatorFromRemediation = (0, $f063e89c0fabde24$export$2c4be893a02ba700)(this.remediation);
        if (!authenticatorFromRemediation) return relatesTo;
        const id = authenticatorFromRemediation.form.value.find(({ name: name })=>name === 'id').value;
        const enrollmentId = (_b = authenticatorFromRemediation.form.value.find(({ name: name })=>name === 'enrollmentId')) === null || _b === void 0 ? void 0 : _b.value;
        return Object.assign(Object.assign({}, relatesTo), {
            id: id,
            enrollmentId: enrollmentId
        });
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $73e27402055196f4$export$2ebaeb11fe49775c(remediation) {
    if (Array.isArray(remediation)) return remediation.map((item)=>{
        if (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean') return item;
        return $73e27402055196f4$export$2ebaeb11fe49775c(item);
    });
    const res = {};
    for (const [key, value] of Object.entries(remediation)){
        if (value === null || typeof value === 'undefined') continue;
        if (typeof value === 'object') {
            const formKeys = Object.keys(value);
            if ([
                'value',
                'form'
            ].includes(key) && formKeys.length === 1 && [
                'value',
                'form'
            ].includes(formKeys[0])) {
                const unwrappedForm = $73e27402055196f4$export$2ebaeb11fe49775c(value);
                Object.entries(unwrappedForm).forEach(([key, value])=>{
                    res[key] = value;
                });
            } else res[key] = $73e27402055196f4$export$2ebaeb11fe49775c(value);
        } else res[key] = value;
    }
    return res;
}


class $3604e1bdac767034$export$9e487c92809f61cb extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    canRemediate() {
        if (typeof this.remediation.action !== 'function') return false;
        if (this.remediation.name === 'poll' || this.remediation.name.endsWith('-poll')) return true;
        if (this.options.step) return true;
        return false;
    }
    getData() {
        const data = this.getInputs().reduce((acc, { name: name })=>{
            acc[name] = this.values[name];
            return acc;
        }, {});
        return data;
    }
    getNextStep(authClient, _context) {
        const name = this.getName();
        const inputs = this.getInputs();
        const _a = this.remediation, { href: href, method: method, rel: rel, accepts: accepts, produces: produces, value: value, action: action } = _a, rest = (0, $ca95e6f9e1ec9f80$export$3c9a16f847548506)(_a, [
            "href",
            "method",
            "rel",
            "accepts",
            "produces",
            "value",
            "action"
        ]);
        if (action) return Object.assign(Object.assign(Object.assign({}, rest), !!inputs.length && {
            inputs: inputs
        }), {
            action: async (params)=>{
                return authClient.idx.proceed(Object.assign({
                    step: name
                }, params));
            }
        });
        return Object.assign({}, this.remediation);
    }
    getInputs() {
        return (this.remediation.value || []).filter(({ name: name })=>name !== 'stateHandle').map((0, $73e27402055196f4$export$2ebaeb11fe49775c)).map((input)=>{
            input.type = input.type || 'string';
            return input;
        });
    }
}



const $b1d30d0c70179e88$var$ctx = {
    remediators: {},
    getFlowSpecification: function(_oktaAuth, _flow = 'default') {
        return {
            remediators: {}
        };
    }
};
function $b1d30d0c70179e88$export$36c62655b1577e54(newCtx) {
    Object.assign($b1d30d0c70179e88$var$ctx, newCtx);
}
function $b1d30d0c70179e88$export$d54c0e1d8c74ec70(oktaAuth, flow = 'default') {
    return $b1d30d0c70179e88$var$ctx.getFlowSpecification(oktaAuth, flow);
}
function $b1d30d0c70179e88$export$948059f37913b971(idxResponse) {
    const { neededToProceed: neededToProceed, interactionCode: interactionCode } = idxResponse;
    return !neededToProceed.length && !interactionCode;
}
function $b1d30d0c70179e88$export$f9ebcddf31580672(idxResponse) {
    return idxResponse.neededToProceed.some(({ name: name })=>name === 'skip');
}
function $b1d30d0c70179e88$export$4bc8275b5603234(idxResponse) {
    return Object.keys(idxResponse.actions).some((actionName)=>actionName.includes('resend'));
}
function $b1d30d0c70179e88$export$28307694da5b8ca7(value) {
    if (!value || !Array.isArray(value)) return;
    return value.reduce((messages, value)=>{
        if (value.messages) messages = [
            ...messages,
            ...value.messages.value
        ];
        if (value.form) {
            const messagesFromForm = $b1d30d0c70179e88$export$28307694da5b8ca7(value.form.value) || [];
            messages = [
                ...messages,
                ...messagesFromForm
            ];
        }
        if (value.options) {
            let optionValues = [];
            value.options.forEach((option)=>{
                if (!option.value || typeof option.value === 'string') return;
                optionValues = [
                    ...optionValues,
                    option.value
                ];
            });
            const messagesFromOptions = $b1d30d0c70179e88$export$28307694da5b8ca7(optionValues) || [];
            messages = [
                ...messages,
                ...messagesFromOptions
            ];
        }
        return messages;
    }, []);
}
function $b1d30d0c70179e88$export$1130a40ad82f0152(idxResponse, options) {
    var _a;
    let messages = [];
    const { rawIdxState: rawIdxState, neededToProceed: neededToProceed } = idxResponse;
    const globalMessages = (_a = rawIdxState.messages) === null || _a === void 0 ? void 0 : _a.value.map((message)=>message);
    if (globalMessages) messages = [
        ...messages,
        ...globalMessages
    ];
    if (!options.useGenericRemediator) for (let remediation of neededToProceed){
        const fieldMessages = $b1d30d0c70179e88$export$28307694da5b8ca7(remediation.value);
        if (fieldMessages) messages = [
            ...messages,
            ...fieldMessages
        ];
    }
    const seen = {};
    messages = messages.reduce((filtered, message)=>{
        var _a;
        const key = (_a = message.i18n) === null || _a === void 0 ? void 0 : _a.key;
        if (key && seen[key] && message.message === seen[key].message) return filtered;
        seen[key] = message;
        filtered = [
            ...filtered,
            message
        ];
        return filtered;
    }, []);
    return messages;
}
function $b1d30d0c70179e88$export$b223b1e857b805e7(idxResponse) {
    const res = [];
    const { actions: actions, neededToProceed: neededToProceed } = idxResponse;
    if (actions['currentAuthenticator-recover']) res.push((0, $23b7d84f5e759bd1$export$451922195d9391fb).PASSWORD_RECOVERY);
    if (neededToProceed.some(({ name: name })=>name === 'select-enroll-profile')) res.push((0, $23b7d84f5e759bd1$export$451922195d9391fb).REGISTRATION);
    if (neededToProceed.some(({ name: name })=>name === 'redirect-idp')) res.push((0, $23b7d84f5e759bd1$export$451922195d9391fb).SOCIAL_IDP);
    if (neededToProceed.some(({ name: name })=>name === 'unlock-account')) res.push((0, $23b7d84f5e759bd1$export$451922195d9391fb).ACCOUNT_UNLOCK);
    return res;
}
function $b1d30d0c70179e88$export$ed702e2b388d7c0e(authClient, idxResponse, useGenericRemediator) {
    var _a;
    const res = [];
    const remediatorMap = Object.values($b1d30d0c70179e88$var$ctx.remediators).reduce((map, remediatorClass)=>{
        if (remediatorClass.remediationName) map[remediatorClass.remediationName] = remediatorClass;
        return map;
    }, {});
    for (let remediation of idxResponse.neededToProceed){
        const T = $b1d30d0c70179e88$var$getRemediatorClass(remediation, {
            useGenericRemediator: useGenericRemediator,
            remediators: remediatorMap
        });
        if (T) {
            const remediator = new T(remediation);
            res.push(remediator.getNextStep(authClient, idxResponse.context));
        }
    }
    for (const [name] of Object.entries(idxResponse.actions || {})){
        let stepObj = {
            name: name,
            action: async (params)=>{
                return authClient.idx.proceed({
                    actions: [
                        {
                            name: name,
                            params: params
                        }
                    ]
                });
            }
        };
        if (name.startsWith('currentAuthenticator')) {
            const [part1, part2] = (0, $d7af732897cdd522$export$5f7ca8c53ac3b054)(name, '-');
            const actionObj = idxResponse.rawIdxState[part1].value[part2];
            const rest = (0, $ca95e6f9e1ec9f80$export$3c9a16f847548506)(actionObj, [
                "href",
                "method",
                "rel",
                "accepts",
                "produces"
            ]);
            const value = (_a = actionObj.value) === null || _a === void 0 ? void 0 : _a.filter((item)=>item.name !== 'stateHandle');
            stepObj = Object.assign(Object.assign(Object.assign({}, rest), value && {
                value: value
            }), stepObj);
        }
        res.push(stepObj);
    }
    return res;
}
function $b1d30d0c70179e88$export$3045fb2be2298cb1(idxResponse, remediationName, values) {
    const remediations = idxResponse.neededToProceed || [];
    const remediation = remediations.find((r)=>r.name === remediationName);
    if (!remediation) {
        (0, $5502e384469ea433$export$c106dd0671a0fc2d)(`filterValuesForRemediation: "${remediationName}" did not match any remediations`);
        return values;
    }
    const valuesForRemediation = remediation.value.reduce((res, entry)=>{
        const { name: name, value: value } = entry;
        if (name === 'stateHandle') res[name] = value;
        else res[name] = values[name];
        return res;
    }, {});
    return valuesForRemediation;
}
function $b1d30d0c70179e88$var$getRemediatorClass(remediation, options) {
    const { useGenericRemediator: useGenericRemediator, remediators: remediators } = options;
    if (!remediation) return undefined;
    if (useGenericRemediator) return 0, $3604e1bdac767034$export$9e487c92809f61cb;
    return remediators[remediation.name];
}
function $b1d30d0c70179e88$export$8d84c5cc4d0bda80(idxResponse, values, options) {
    const remediators = options.remediators;
    const useGenericRemediator = options.useGenericRemediator;
    const { neededToProceed: idxRemediations, context: context } = idxResponse;
    let remediator;
    if (options.step) {
        const remediation = idxRemediations.find(({ name: name })=>name === options.step);
        if (remediation) {
            const T = $b1d30d0c70179e88$var$getRemediatorClass(remediation, options);
            return T ? new T(remediation, values, options) : undefined;
        } else {
            (0, $5502e384469ea433$export$c106dd0671a0fc2d)(`step "${options.step}" did not match any remediations`);
            return;
        }
    }
    const remediatorCandidates = [];
    if (useGenericRemediator) remediatorCandidates.push(new (0, $3604e1bdac767034$export$9e487c92809f61cb)(idxRemediations[0], values, options));
    else for (let remediation of idxRemediations){
        const isRemeditionInFlow = Object.keys(remediators).includes(remediation.name);
        if (!isRemeditionInFlow) continue;
        const T = $b1d30d0c70179e88$var$getRemediatorClass(remediation, options);
        remediator = new T(remediation, values, options);
        if (remediator.canRemediate(context)) return remediator;
        remediatorCandidates.push(remediator);
    }
    return remediatorCandidates[0];
}
function $b1d30d0c70179e88$export$b6b54d9bbb742a92(authClient, remediator, idxResponse) {
    const nextStep = remediator.getNextStep(authClient, idxResponse.context);
    const canSkip = $b1d30d0c70179e88$export$f9ebcddf31580672(idxResponse);
    const canResend = $b1d30d0c70179e88$export$4bc8275b5603234(idxResponse);
    return Object.assign(Object.assign(Object.assign({}, nextStep), canSkip && {
        canSkip: canSkip
    }), canResend && {
        canResend: canResend
    });
}
function $b1d30d0c70179e88$export$3d2cbb102ee7774e(authClient, idxResponse, options = {}) {
    const terminal = $b1d30d0c70179e88$export$948059f37913b971(idxResponse);
    const messages = $b1d30d0c70179e88$export$1130a40ad82f0152(idxResponse, options);
    if (terminal) return {
        idxResponse: idxResponse,
        terminal: terminal,
        messages: messages
    };
    else {
        const remediator = $b1d30d0c70179e88$export$8d84c5cc4d0bda80(idxResponse, {}, options);
        const nextStep = remediator && $b1d30d0c70179e88$export$b6b54d9bbb742a92(authClient, remediator, idxResponse);
        return Object.assign({
            idxResponse: idxResponse,
            messages: messages
        }, nextStep && {
            nextStep: nextStep
        });
    }
}


function $b654e02dc4df45fd$var$getActionFromValues(values, idxResponse) {
    return Object.keys(idxResponse.actions).find((action)=>!!values.resend && action.includes('-resend'));
}
function $b654e02dc4df45fd$var$removeActionFromValues(values) {
    return Object.assign(Object.assign({}, values), {
        resend: undefined
    });
}
function $b654e02dc4df45fd$var$removeActionFromOptions(options, actionName) {
    let actions = options.actions || [];
    actions = actions.filter((entry)=>{
        if (typeof entry === 'string') return entry !== actionName;
        return entry.name !== actionName;
    });
    return Object.assign(Object.assign({}, options), {
        actions: actions
    });
}
async function $b654e02dc4df45fd$export$f75734e1eff13481(authClient, idxResponse, values, options) {
    let { neededToProceed: neededToProceed, interactionCode: interactionCode } = idxResponse;
    const { flow: flow } = options;
    if (interactionCode) return {
        idxResponse: idxResponse
    };
    const remediator = (0, $b1d30d0c70179e88$export$8d84c5cc4d0bda80)(idxResponse, values, options);
    const actionFromValues = $b654e02dc4df45fd$var$getActionFromValues(values, idxResponse);
    const actionFromOptions = options.actions || [];
    const actions = [
        ...actionFromOptions,
        ...actionFromValues && [
            actionFromValues
        ] || []
    ];
    if (actions) for (let action of actions){
        let params = {};
        if (typeof action !== 'string') {
            params = action.params || {};
            action = action.name;
        }
        let valuesWithoutExecutedAction = $b654e02dc4df45fd$var$removeActionFromValues(values);
        let optionsWithoutExecutedAction = $b654e02dc4df45fd$var$removeActionFromOptions(options, action);
        if (typeof idxResponse.actions[action] === 'function') {
            idxResponse = await idxResponse.actions[action](params);
            if (idxResponse.requestDidSucceed === false) return (0, $b1d30d0c70179e88$export$3d2cbb102ee7774e)(authClient, idxResponse, options);
            if (action === 'cancel') return {
                idxResponse: idxResponse,
                canceled: true
            };
            return $b654e02dc4df45fd$export$f75734e1eff13481(authClient, idxResponse, valuesWithoutExecutedAction, optionsWithoutExecutedAction);
        }
        const remediationAction = neededToProceed.find(({ name: name })=>name === action);
        if (remediationAction) {
            idxResponse = await idxResponse.proceed(action, params);
            if (idxResponse.requestDidSucceed === false) return (0, $b1d30d0c70179e88$export$3d2cbb102ee7774e)(authClient, idxResponse, options);
            return $b654e02dc4df45fd$export$f75734e1eff13481(authClient, idxResponse, values, optionsWithoutExecutedAction);
        }
    }
    const terminal = (0, $b1d30d0c70179e88$export$948059f37913b971)(idxResponse);
    if (terminal) return {
        idxResponse: idxResponse,
        terminal: terminal
    };
    if (!remediator) {
        if (options.step) {
            values = (0, $b1d30d0c70179e88$export$3045fb2be2298cb1)(idxResponse, options.step, values);
            idxResponse = await idxResponse.proceed(options.step, values);
            if (idxResponse.requestDidSucceed === false) return (0, $b1d30d0c70179e88$export$3d2cbb102ee7774e)(authClient, idxResponse, options);
            return {
                idxResponse: idxResponse
            };
        }
        if (flow === 'default') return {
            idxResponse: idxResponse
        };
        throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)(`
      No remediation can match current flow, check policy settings in your org.
      Remediations: [${neededToProceed.reduce((acc, curr)=>acc ? acc + ' ,' + curr.name : curr.name, '')}]
    `);
    }
    if (!remediator.canRemediate()) {
        const nextStep = (0, $b1d30d0c70179e88$export$b6b54d9bbb742a92)(authClient, remediator, idxResponse);
        return {
            idxResponse: idxResponse,
            nextStep: nextStep
        };
    }
    const name = remediator.getName();
    const data = remediator.getData();
    idxResponse = await idxResponse.proceed(name, data);
    if (idxResponse.requestDidSucceed === false) return (0, $b1d30d0c70179e88$export$3d2cbb102ee7774e)(authClient, idxResponse, options);
    values = remediator.getValuesAfterProceed();
    options = Object.assign(Object.assign({}, options), {
        step: undefined
    });
    if (options.useGenericRemediator && !idxResponse.interactionCode && !(0, $b1d30d0c70179e88$export$948059f37913b971)(idxResponse)) {
        const gr = (0, $b1d30d0c70179e88$export$8d84c5cc4d0bda80)(idxResponse, values, options);
        const nextStep = (0, $b1d30d0c70179e88$export$b6b54d9bbb742a92)(authClient, gr, idxResponse);
        return {
            idxResponse: idxResponse,
            nextStep: nextStep
        };
    }
    return $b654e02dc4df45fd$export$f75734e1eff13481(authClient, idxResponse, values, options);
}





function $0094051e22ab524c$var$initializeValues(options) {
    const knownOptions = [
        'flow',
        'remediators',
        'actions',
        'withCredentials',
        'step',
        'useGenericRemediator',
        'exchangeCodeForTokens'
    ];
    const values = Object.assign({}, options);
    knownOptions.forEach((option)=>{
        delete values[option];
    });
    return values;
}
function $0094051e22ab524c$var$initializeData(authClient, data) {
    var _a, _b, _c, _d;
    let { options: options } = data;
    options = Object.assign(Object.assign({}, authClient.options.idx), options);
    let { flow: flow, withCredentials: withCredentials, remediators: remediators, actions: actions } = options;
    const status = (0, $23b7d84f5e759bd1$export$c96dcb52978c0932).PENDING;
    flow = flow || ((_b = (_a = authClient.idx).getFlow) === null || _b === void 0 ? void 0 : _b.call(_a)) || 'default';
    if (flow) {
        (_d = (_c = authClient.idx).setFlow) === null || _d === void 0 || _d.call(_c, flow);
        const flowSpec = (0, $b1d30d0c70179e88$export$d54c0e1d8c74ec70)(authClient, flow);
        withCredentials = typeof withCredentials !== 'undefined' ? withCredentials : flowSpec.withCredentials;
        remediators = remediators || flowSpec.remediators;
        actions = actions || flowSpec.actions;
    }
    return Object.assign(Object.assign({}, data), {
        options: Object.assign(Object.assign({}, options), {
            flow: flow,
            withCredentials: withCredentials,
            remediators: remediators,
            actions: actions
        }),
        status: status
    });
}
async function $0094051e22ab524c$var$getDataFromIntrospect(authClient, data) {
    const { options: options } = data;
    const { stateHandle: stateHandle, withCredentials: withCredentials, version: version, state: state, scopes: scopes, recoveryToken: recoveryToken, activationToken: activationToken, maxAge: maxAge, acrValues: acrValues, nonce: nonce, useGenericRemediator: useGenericRemediator } = options;
    let idxResponse;
    let meta = (0, $c6cd386983d9ca48$export$ee78659ae5675f26)(authClient, {
        state: state,
        recoveryToken: recoveryToken,
        activationToken: activationToken
    });
    if (stateHandle) idxResponse = await (0, $21d92a1cc115c86c$export$3b41a86e379f8f15)(authClient, {
        withCredentials: withCredentials,
        version: version,
        stateHandle: stateHandle,
        useGenericRemediator: useGenericRemediator
    });
    else {
        let interactionHandle = meta === null || meta === void 0 ? void 0 : meta.interactionHandle;
        if (!interactionHandle) {
            authClient.transactionManager.clear();
            const interactResponse = await (0, $2027d28688355efb$export$20814a0f9b60f8cf)(authClient, {
                withCredentials: withCredentials,
                state: state,
                scopes: scopes,
                activationToken: activationToken,
                recoveryToken: recoveryToken,
                maxAge: maxAge,
                acrValues: acrValues,
                nonce: nonce
            });
            interactionHandle = interactResponse.interactionHandle;
            meta = interactResponse.meta;
        }
        idxResponse = await (0, $21d92a1cc115c86c$export$3b41a86e379f8f15)(authClient, {
            withCredentials: withCredentials,
            version: version,
            interactionHandle: interactionHandle,
            useGenericRemediator: useGenericRemediator
        });
    }
    return Object.assign(Object.assign({}, data), {
        idxResponse: idxResponse,
        meta: meta
    });
}
async function $0094051e22ab524c$var$getDataFromRemediate(authClient, data) {
    let { idxResponse: idxResponse, options: options, values: values } = data;
    const { autoRemediate: autoRemediate, remediators: remediators, actions: actions, flow: flow, step: step, useGenericRemediator: useGenericRemediator } = options;
    const shouldRemediate = autoRemediate !== false && (remediators || actions || step);
    if (!shouldRemediate) return data;
    values = Object.assign(Object.assign({}, values), {
        stateHandle: idxResponse.rawIdxState.stateHandle
    });
    const { idxResponse: idxResponseFromRemediation, nextStep: nextStep, canceled: canceled } = await (0, $b654e02dc4df45fd$export$f75734e1eff13481)(authClient, idxResponse, values, {
        remediators: remediators,
        actions: actions,
        flow: flow,
        step: step,
        useGenericRemediator: useGenericRemediator
    });
    idxResponse = idxResponseFromRemediation;
    return Object.assign(Object.assign({}, data), {
        idxResponse: idxResponse,
        nextStep: nextStep,
        canceled: canceled
    });
}
async function $0094051e22ab524c$var$getTokens(authClient, data) {
    let { meta: meta, idxResponse: idxResponse } = data;
    const { interactionCode: interactionCode } = idxResponse;
    const { clientId: clientId, codeVerifier: codeVerifier, ignoreSignature: ignoreSignature, redirectUri: redirectUri, urls: urls, scopes: scopes } = meta;
    const tokenResponse = await authClient.token.exchangeCodeForTokens({
        interactionCode: interactionCode,
        clientId: clientId,
        codeVerifier: codeVerifier,
        ignoreSignature: ignoreSignature,
        redirectUri: redirectUri,
        scopes: scopes
    }, urls);
    return tokenResponse.tokens;
}
async function $0094051e22ab524c$var$finalizeData(authClient, data) {
    let { options: options, idxResponse: idxResponse, canceled: canceled, status: status } = data;
    const { exchangeCodeForTokens: exchangeCodeForTokens } = options;
    let shouldSaveResponse = false;
    let shouldClearTransaction = false;
    let clearSharedStorage = true;
    let interactionCode;
    let tokens;
    let enabledFeatures;
    let availableSteps;
    let messages;
    let terminal;
    if (idxResponse) {
        shouldSaveResponse = !!(idxResponse.requestDidSucceed || idxResponse.stepUp);
        enabledFeatures = (0, $b1d30d0c70179e88$export$b223b1e857b805e7)(idxResponse);
        availableSteps = (0, $b1d30d0c70179e88$export$ed702e2b388d7c0e)(authClient, idxResponse, options.useGenericRemediator);
        messages = (0, $b1d30d0c70179e88$export$1130a40ad82f0152)(idxResponse, options);
        terminal = (0, $b1d30d0c70179e88$export$948059f37913b971)(idxResponse);
    }
    if (terminal) {
        status = (0, $23b7d84f5e759bd1$export$c96dcb52978c0932).TERMINAL;
        const hasActions = Object.keys(idxResponse.actions).length > 0;
        const hasErrors = !!messages.find((msg)=>msg.class === 'ERROR');
        const isTerminalSuccess = !hasActions && !hasErrors && idxResponse.requestDidSucceed === true;
        if (isTerminalSuccess) shouldClearTransaction = true;
        else shouldSaveResponse = !!hasActions;
        clearSharedStorage = false;
    } else if (canceled) {
        status = (0, $23b7d84f5e759bd1$export$c96dcb52978c0932).CANCELED;
        shouldClearTransaction = true;
    } else if (idxResponse === null || idxResponse === void 0 ? void 0 : idxResponse.interactionCode) {
        interactionCode = idxResponse.interactionCode;
        if (exchangeCodeForTokens === false) {
            status = (0, $23b7d84f5e759bd1$export$c96dcb52978c0932).SUCCESS;
            shouldClearTransaction = false;
        } else {
            tokens = await $0094051e22ab524c$var$getTokens(authClient, data);
            status = (0, $23b7d84f5e759bd1$export$c96dcb52978c0932).SUCCESS;
            shouldClearTransaction = true;
        }
    }
    return Object.assign(Object.assign({}, data), {
        status: status,
        interactionCode: interactionCode,
        tokens: tokens,
        shouldSaveResponse: shouldSaveResponse,
        shouldClearTransaction: shouldClearTransaction,
        clearSharedStorage: clearSharedStorage,
        enabledFeatures: enabledFeatures,
        availableSteps: availableSteps,
        messages: messages,
        terminal: terminal
    });
}
async function $0094051e22ab524c$export$889ea624f2cb2c57(authClient, options = {}) {
    var _a;
    let data = {
        options: options,
        values: $0094051e22ab524c$var$initializeValues(options)
    };
    data = $0094051e22ab524c$var$initializeData(authClient, data);
    data = await $0094051e22ab524c$var$getDataFromIntrospect(authClient, data);
    data = await $0094051e22ab524c$var$getDataFromRemediate(authClient, data);
    data = await $0094051e22ab524c$var$finalizeData(authClient, data);
    const { idxResponse: idxResponse, meta: meta, shouldSaveResponse: shouldSaveResponse, shouldClearTransaction: shouldClearTransaction, clearSharedStorage: clearSharedStorage, status: status, enabledFeatures: enabledFeatures, availableSteps: availableSteps, tokens: tokens, nextStep: nextStep, messages: messages, error: error, interactionCode: interactionCode } = data;
    if (shouldClearTransaction) authClient.transactionManager.clear({
        clearSharedStorage: clearSharedStorage
    });
    else {
        (0, $c6cd386983d9ca48$export$dc27696b235944d6)(authClient, Object.assign({}, meta));
        if (shouldSaveResponse) {
            const { rawIdxState: rawIdxResponse, requestDidSucceed: requestDidSucceed } = idxResponse;
            authClient.transactionManager.saveIdxResponse({
                rawIdxResponse: rawIdxResponse,
                requestDidSucceed: requestDidSucceed,
                stateHandle: (_a = idxResponse.context) === null || _a === void 0 ? void 0 : _a.stateHandle,
                interactionHandle: meta === null || meta === void 0 ? void 0 : meta.interactionHandle
            });
        }
    }
    const { actions: actions, context: context, neededToProceed: neededToProceed, proceed: proceed, rawIdxState: rawIdxState, requestDidSucceed: requestDidSucceed, stepUp: stepUp } = idxResponse || {};
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
        status: status
    }, meta && {
        meta: meta
    }), enabledFeatures && {
        enabledFeatures: enabledFeatures
    }), availableSteps && {
        availableSteps: availableSteps
    }), tokens && {
        tokens: tokens
    }), nextStep && {
        nextStep: nextStep
    }), messages && messages.length && {
        messages: messages
    }), error && {
        error: error
    }), stepUp && {
        stepUp: stepUp
    }), {
        interactionCode: interactionCode,
        actions: actions,
        context: context,
        neededToProceed: neededToProceed,
        proceed: proceed,
        rawIdxState: rawIdxState,
        requestDidSucceed: requestDidSucceed
    });
}


async function $dfab4b212fb2e0cf$export$61bb00ddedae72e4(authClient, options = {}) {
    if (options.password && !options.authenticator) options.authenticator = (0, $23b7d84f5e759bd1$export$b420a84de7aa04bd).OKTA_PASSWORD;
    return (0, $0094051e22ab524c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign({}, options), {
        flow: 'authenticate'
    }));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ class $f6fed6daa176d7c2$export$3d7a1e8452f884f3 {
    constructor(authenticator){
        this.meta = authenticator;
    }
}


class $2c032087cfb38313$export$c1fb04481f1165ad extends (0, $f6fed6daa176d7c2$export$3d7a1e8452f884f3) {
    canVerify(values) {
        return !!(values.credentials || values.verificationCode || values.otp);
    }
    mapCredentials(values) {
        const { credentials: credentials, verificationCode: verificationCode, otp: otp } = values;
        if (!credentials && !verificationCode && !otp) return;
        return credentials || {
            passcode: verificationCode || otp
        };
    }
    getInputs(idxRemediationValue) {
        var _a;
        return Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), {
            name: 'verificationCode',
            type: 'string',
            required: idxRemediationValue.required
        });
    }
}


class $9492b408da785001$export$47aa57e0362d0da8 extends (0, $2c032087cfb38313$export$c1fb04481f1165ad) {
    mapCredentials(values) {
        const { verificationCode: verificationCode } = values;
        if (!verificationCode) return;
        return {
            totp: verificationCode
        };
    }
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $b34c02e5eb72c0ad$export$df19360b11c3a265 extends (0, $f6fed6daa176d7c2$export$3d7a1e8452f884f3) {
    canVerify(values) {
        return !!(values.credentials || values.password || values.passcode);
    }
    mapCredentials(values) {
        const { credentials: credentials, password: password, passcode: passcode, revokeSessions: revokeSessions } = values;
        if (!credentials && !password && !passcode) return;
        return credentials || {
            passcode: passcode || password,
            revokeSessions: revokeSessions
        };
    }
    getInputs(idxRemediationValue) {
        var _a, _b;
        const inputs = [
            Object.assign(Object.assign({}, (_a = idxRemediationValue.form) === null || _a === void 0 ? void 0 : _a.value[0]), {
                name: 'password',
                type: 'string',
                required: idxRemediationValue.required
            })
        ];
        const revokeSessions = (_b = idxRemediationValue.form) === null || _b === void 0 ? void 0 : _b.value.find((input)=>input.name === 'revokeSessions');
        if (revokeSessions) inputs.push({
            name: 'revokeSessions',
            type: 'boolean',
            label: 'Sign me out of all other devices',
            required: false
        });
        return inputs;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $8f8d31a4a5022923$export$11ad7007318599fd extends (0, $f6fed6daa176d7c2$export$3d7a1e8452f884f3) {
    canVerify(values) {
        const { credentials: credentials } = values;
        if (credentials && credentials.questionKey && credentials.answer) return true;
        const { questionKey: questionKey, question: question, answer: answer } = values;
        return !!(questionKey && answer) || !!(question && answer);
    }
    mapCredentials(values) {
        const { questionKey: questionKey, question: question, answer: answer } = values;
        if (!answer || !questionKey && !question) return;
        return {
            questionKey: question ? 'custom' : questionKey,
            question: question,
            answer: answer
        };
    }
    getInputs() {
        return [
            {
                name: 'questionKey',
                type: 'string',
                required: true
            },
            {
                name: 'question',
                type: 'string',
                label: 'Create a security question'
            },
            {
                name: 'answer',
                type: 'string',
                label: 'Answer',
                required: true
            }
        ];
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $59f0c7b2a8a56b06$export$ada92dcbb68d964c extends (0, $f6fed6daa176d7c2$export$3d7a1e8452f884f3) {
    canVerify(values) {
        const { credentials: credentials } = values;
        if (credentials && credentials.answer) return true;
        const { answer: answer } = values;
        return !!answer;
    }
    mapCredentials(values) {
        const { answer: answer } = values;
        if (!answer) return;
        return {
            questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
            answer: answer
        };
    }
    getInputs() {
        return [
            {
                name: 'answer',
                type: 'string',
                label: 'Answer',
                required: true
            }
        ];
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $8d1c8d72694cac3b$export$780044389d0a529 extends (0, $f6fed6daa176d7c2$export$3d7a1e8452f884f3) {
    canVerify(values) {
        const { credentials: credentials } = values;
        const obj = credentials || values;
        const { clientData: clientData, attestation: attestation } = obj;
        return !!(clientData && attestation);
    }
    mapCredentials(values) {
        const { credentials: credentials, clientData: clientData, attestation: attestation } = values;
        if (!credentials && !clientData && !attestation) return;
        return credentials || {
            clientData: clientData,
            attestation: attestation
        };
    }
    getInputs() {
        return [
            {
                name: 'clientData',
                type: 'string',
                required: true,
                visible: false,
                label: 'Client Data'
            },
            {
                name: 'attestation',
                type: 'string',
                required: true,
                visible: false,
                label: 'Attestation'
            }
        ];
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $6a9f6bd8f52def9c$export$18c254bb3b1e28b8 extends (0, $f6fed6daa176d7c2$export$3d7a1e8452f884f3) {
    canVerify(values) {
        const { credentials: credentials } = values;
        const obj = credentials || values;
        const { clientData: clientData, authenticatorData: authenticatorData, signatureData: signatureData } = obj;
        return !!(clientData && authenticatorData && signatureData);
    }
    mapCredentials(values) {
        const { credentials: credentials, authenticatorData: authenticatorData, clientData: clientData, signatureData: signatureData } = values;
        if (!credentials && !authenticatorData && !clientData && !signatureData) return;
        return credentials || {
            authenticatorData: authenticatorData,
            clientData: clientData,
            signatureData: signatureData
        };
    }
    getInputs() {
        return [
            {
                name: 'authenticatorData',
                type: 'string',
                label: 'Authenticator Data',
                required: true,
                visible: false
            },
            {
                name: 'clientData',
                type: 'string',
                label: 'Client Data',
                required: true,
                visible: false
            },
            {
                name: 'signatureData',
                type: 'string',
                label: 'Signature Data',
                required: true,
                visible: false
            }
        ];
    }
}



function $a84e317fcb3cf8fb$export$2611727d0d25c416(remediation) {
    var _a, _b;
    const relatesTo = remediation.relatesTo;
    const value = (relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.value) || {};
    switch(value.key){
        case (0, $23b7d84f5e759bd1$export$b420a84de7aa04bd).OKTA_PASSWORD:
            return new (0, $b34c02e5eb72c0ad$export$df19360b11c3a265)(value);
        case (0, $23b7d84f5e759bd1$export$b420a84de7aa04bd).SECURITY_QUESTION:
            if ((_a = value.contextualData) === null || _a === void 0 ? void 0 : _a.enrolledQuestion) return new (0, $59f0c7b2a8a56b06$export$ada92dcbb68d964c)(value);
            else return new (0, $8f8d31a4a5022923$export$11ad7007318599fd)(value);
        case (0, $23b7d84f5e759bd1$export$b420a84de7aa04bd).OKTA_VERIFY:
            return new (0, $9492b408da785001$export$47aa57e0362d0da8)(value);
        case (0, $23b7d84f5e759bd1$export$b420a84de7aa04bd).WEBAUTHN:
            if ((_b = value.contextualData) === null || _b === void 0 ? void 0 : _b.challengeData) return new (0, $6a9f6bd8f52def9c$export$18c254bb3b1e28b8)(value);
            else return new (0, $8d1c8d72694cac3b$export$780044389d0a529)(value);
        default:
            return new (0, $2c032087cfb38313$export$c1fb04481f1165ad)(value);
    }
}


class $f76786eeacbfd1ca$export$e3100d946b350c5 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    constructor(remediation, values = {}){
        super(remediation, values);
        this.authenticator = (0, $a84e317fcb3cf8fb$export$2611727d0d25c416)(remediation);
    }
    getNextStep(authClient, context) {
        var _a;
        const nextStep = super.getNextStep(authClient, context);
        const authenticatorEnrollments = (_a = context === null || context === void 0 ? void 0 : context.authenticatorEnrollments) === null || _a === void 0 ? void 0 : _a.value;
        return Object.assign(Object.assign({}, nextStep), {
            authenticatorEnrollments: authenticatorEnrollments
        });
    }
    canRemediate() {
        return this.authenticator.canVerify(this.values);
    }
    mapCredentials() {
        return this.authenticator.mapCredentials(this.values);
    }
    getInputCredentials(input) {
        return this.authenticator.getInputs(input);
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>valueKey !== 'credentials');
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}


class $b34f17fa52d9cd06$export$f7157015cf11193f extends (0, $f76786eeacbfd1ca$export$e3100d946b350c5) {
}
$b34f17fa52d9cd06$export$f7157015cf11193f.remediationName = 'enroll-authenticator';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $7f0bcd5b671d3e75$export$2e21ed88eacb421f extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'enroll-poll';
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        let authenticator = this.getAuthenticator();
        if (!authenticator && (context === null || context === void 0 ? void 0 : context.currentAuthenticator)) authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), {
            authenticator: authenticator,
            poll: {
                required: true,
                refresh: this.remediation.refresh
            }
        });
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>valueKey !== 'startPolling');
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}
$7f0bcd5b671d3e75$export$2e21ed88eacb421f.remediationName = 'enroll-poll';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $00d2aff6510814d0$export$76e9de8555d9305a extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    canRemediate() {
        if (this.values.channel) return true;
        if (this.values.authenticator) {
            const { id: id, channel: channel } = this.values.authenticator;
            if (!!id && !!channel) return true;
        }
        return false;
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), {
            authenticator: authenticator
        });
    }
    getData() {
        var _a;
        const remediationValue = this.remediation.value[0].value;
        return {
            authenticator: {
                id: remediationValue.form.value[0].value,
                channel: ((_a = this.values.authenticator) === null || _a === void 0 ? void 0 : _a.channel) || this.values.channel
            },
            stateHandle: this.values.stateHandle
        };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        delete this.values.authenticators;
        const filterKey = this.values.channel ? 'channel' : 'authenticator';
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>valueKey !== filterKey);
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}
$00d2aff6510814d0$export$76e9de8555d9305a.remediationName = 'select-enrollment-channel';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $79e3288dea6d8cbd$export$c1bb923bb31fb3c9 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    getInputEmail() {
        return [
            {
                name: 'email',
                type: 'string',
                required: true,
                label: 'Email'
            }
        ];
    }
    getInputPhoneNumber() {
        return [
            {
                name: 'phoneNumber',
                type: 'string',
                required: true,
                label: 'Phone Number'
            }
        ];
    }
    canRemediate() {
        return Boolean(this.values.email || this.values.phoneNumber);
    }
    getNextStep(authClient, context) {
        const common = super.getNextStep(authClient, context);
        const authenticator = context.currentAuthenticator.value;
        return Object.assign(Object.assign({}, common), {
            authenticator: authenticator
        });
    }
    getData() {
        return {
            stateHandle: this.values.stateHandle,
            email: this.values.email,
            phoneNumber: this.values.phoneNumber
        };
    }
    getValuesAfterProceed() {
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>![
                'email',
                'phoneNumber'
            ].includes(valueKey));
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}
$79e3288dea6d8cbd$export$c1bb923bb31fb3c9.remediationName = 'enrollment-channel-data';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $91ec62d42c052ca0$export$2a2afff13894112f extends (0, $f76786eeacbfd1ca$export$e3100d946b350c5) {
}
$91ec62d42c052ca0$export$2a2afff13894112f.remediationName = 'challenge-authenticator';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $cc760a8af5379450$export$9da932f7758505ec extends (0, $7f0bcd5b671d3e75$export$2e21ed88eacb421f) {
    canRemediate() {
        return !!this.values.startPolling || this.options.step === 'challenge-poll';
    }
}
$cc760a8af5379450$export$9da932f7758505ec.remediationName = 'challenge-poll';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $cac25791d61330d7$export$3848083ec2ba1822 extends (0, $f76786eeacbfd1ca$export$e3100d946b350c5) {
}
$cac25791d61330d7$export$3848083ec2ba1822.remediationName = 'reset-authenticator';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


class $fdb9a10676475760$export$528e7bbca764a356 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    constructor(remediation, values = {}, options = {}){
        super(remediation, values, options);
        this.authenticator = null;
        const credentials = this.getCredentialsFromRemediation();
        if (credentials) this.authenticator = this.authenticator = new (0, $b34c02e5eb72c0ad$export$df19360b11c3a265)({});
    }
    canRemediate() {
        if (this.authenticator && !this.authenticator.canVerify(this.values)) return false;
        const userProfileFromValues = this.getData().userProfile;
        if (!userProfileFromValues) return false;
        const userProfileFromRemediation = this.remediation.value.find(({ name: name })=>name === 'userProfile');
        return userProfileFromRemediation.form.value.reduce((canRemediate, curr)=>{
            if (curr.required) canRemediate = canRemediate && !!userProfileFromValues[curr.name];
            return canRemediate;
        }, true);
    }
    getCredentialsFromRemediation() {
        return this.remediation.value.find(({ name: name })=>name === 'credentials');
    }
    mapUserProfile({ form: { value: profileAttributes } }) {
        const attributeNames = profileAttributes.map(({ name: name })=>name);
        const data = attributeNames.reduce((attributeValues, attributeName)=>this.values[attributeName] ? Object.assign(Object.assign({}, attributeValues), {
                [attributeName]: this.values[attributeName]
            }) : attributeValues, {});
        if (Object.keys(data).length === 0) return;
        return data;
    }
    mapCredentials() {
        const val = this.authenticator && this.authenticator.mapCredentials(this.values);
        if (!val) return;
        return val;
    }
    getInputUserProfile(input) {
        return [
            ...input.form.value
        ];
    }
    getInputCredentials(input) {
        return [
            ...input.form.value
        ];
    }
    getErrorMessages(errorRemediation) {
        return errorRemediation.value[0].form.value.reduce((errors, field)=>{
            if (field.messages) errors.push(field.messages.value[0].message);
            return errors;
        }, []);
    }
}
$fdb9a10676475760$export$528e7bbca764a356.remediationName = 'enroll-profile';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $92e11c41d7112f50$export$e513146db6535bff extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    constructor(){
        super(...arguments);
        this.map = {
            'identifier': [
                'username'
            ]
        };
    }
    canRemediate() {
        const { identifier: identifier } = this.getData();
        return !!identifier;
    }
    mapCredentials() {
        const { credentials: credentials, password: password } = this.values;
        if (!credentials && !password) return;
        return credentials || {
            passcode: password
        };
    }
    getInputCredentials(input) {
        return Object.assign(Object.assign({}, input.form.value[0]), {
            name: 'password',
            required: input.required
        });
    }
}
$92e11c41d7112f50$export$e513146db6535bff.remediationName = 'identify';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $c4e19db182eb4501$export$68450f7d95120a39 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    mapCredentials() {
        const { newPassword: newPassword } = this.values;
        if (!newPassword) return;
        return {
            passcode: newPassword
        };
    }
    getInputCredentials(input) {
        const challengeType = this.getAuthenticator().type;
        const name = challengeType === 'password' ? 'newPassword' : 'verificationCode';
        return Object.assign(Object.assign({}, input.form.value[0]), {
            name: name
        });
    }
}
$c4e19db182eb4501$export$68450f7d95120a39.remediationName = 'reenroll-authenticator';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $46ffacb7af9951b9$export$76c32f77c893cc76 extends (0, $c4e19db182eb4501$export$68450f7d95120a39) {
}
$46ffacb7af9951b9$export$76c32f77c893cc76.remediationName = 'reenroll-authenticator-warning';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $4cd2bb11a87017e4$export$772831dc8c7313c0 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    canRemediate() {
        return false;
    }
    getNextStep() {
        const { name: name, type: type, idp: idp, href: href } = this.remediation;
        return {
            name: name,
            type: type,
            idp: idp,
            href: href
        };
    }
}
$4cd2bb11a87017e4$export$772831dc8c7313c0.remediationName = 'redirect-idp';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



class $ce535f71de194920$export$21ef500697ce1d95 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    findMatchedOption(authenticators, options) {
        let option;
        for (let authenticator of authenticators){
            option = options.find(({ relatesTo: relatesTo })=>relatesTo.key && relatesTo.key === authenticator.key);
            if (option) break;
        }
        return option;
    }
    canRemediate(context) {
        var _a, _b;
        const { authenticators: authenticators, authenticator: authenticator } = this.values;
        const authenticatorFromRemediation = (0, $f063e89c0fabde24$export$2c4be893a02ba700)(this.remediation);
        const { options: options } = authenticatorFromRemediation;
        if (!authenticators || !authenticators.length) return false;
        if ((0, $23b7d84f5e759bd1$export$361ab32a8474b3c4)(authenticator) && authenticator.id) return true;
        const matchedOption = this.findMatchedOption(authenticators, options);
        if (matchedOption) {
            const isCurrentAuthenticator = (context === null || context === void 0 ? void 0 : context.currentAuthenticator) && (context === null || context === void 0 ? void 0 : context.currentAuthenticator.value.id) === ((_a = matchedOption.relatesTo) === null || _a === void 0 ? void 0 : _a.id);
            const isCurrentAuthenticatorEnrollment = (context === null || context === void 0 ? void 0 : context.currentAuthenticatorEnrollment) && (context === null || context === void 0 ? void 0 : context.currentAuthenticatorEnrollment.value.id) === ((_b = matchedOption.relatesTo) === null || _b === void 0 ? void 0 : _b.id);
            return !isCurrentAuthenticator && !isCurrentAuthenticatorEnrollment;
        }
        return false;
    }
    mapAuthenticator(remediationValue) {
        const { authenticators: authenticators, authenticator: authenticator } = this.values;
        if ((0, $23b7d84f5e759bd1$export$361ab32a8474b3c4)(authenticator) && authenticator.id) {
            this.selectedAuthenticator = authenticator;
            return authenticator;
        }
        const { options: options } = remediationValue;
        const selectedOption = (0, $c0eaea62dde87e17$export$fafdedfcbb7d2691)(authenticators, options);
        this.selectedAuthenticator = selectedOption.relatesTo;
        this.selectedOption = selectedOption;
        return {
            id: selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value.form.value.find(({ name: name })=>name === 'id').value
        };
    }
    getInputAuthenticator(remediation) {
        const options = remediation.options.map(({ label: label, relatesTo: relatesTo })=>{
            return {
                label: label,
                value: relatesTo.key
            };
        });
        return {
            name: 'authenticator',
            type: 'string',
            options: options
        };
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticators = this.values.authenticators.filter((authenticator)=>{
            return (0, $c0eaea62dde87e17$export$36b7fa650feebb56)(authenticator, this.selectedAuthenticator) !== true;
        });
        return Object.assign(Object.assign({}, this.values), {
            authenticators: authenticators
        });
    }
}




class $2bf37b9cf045baa0$export$c6bd0968af0af8c2 extends (0, $ce535f71de194920$export$21ef500697ce1d95) {
    constructor(remediation, values = {}, options = {}){
        var _a;
        super(remediation, values, options);
        const isRecoveryFlow = this.options.flow === 'recoverPassword';
        const hasPasswordInOptions = (_a = (0, $f063e89c0fabde24$export$2c4be893a02ba700)(remediation).options) === null || _a === void 0 ? void 0 : _a.some(({ relatesTo: relatesTo })=>(relatesTo === null || relatesTo === void 0 ? void 0 : relatesTo.key) === (0, $23b7d84f5e759bd1$export$b420a84de7aa04bd).OKTA_PASSWORD);
        if (hasPasswordInOptions && (isRecoveryFlow || this.values.password)) this.values.authenticators = [
            ...this.values.authenticators || [],
            {
                key: (0, $23b7d84f5e759bd1$export$b420a84de7aa04bd).OKTA_PASSWORD
            }
        ];
    }
}
$2bf37b9cf045baa0$export$c6bd0968af0af8c2.remediationName = 'select-authenticator-authenticate';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $5e73cf4db6f3ec83$export$616f0495c05b2e5e extends (0, $ce535f71de194920$export$21ef500697ce1d95) {
}
$5e73cf4db6f3ec83$export$616f0495c05b2e5e.remediationName = 'select-authenticator-enroll';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $9761101492cbce52$export$4171832ff6fa6156 extends (0, $ce535f71de194920$export$21ef500697ce1d95) {
    constructor(){
        super(...arguments);
        this.map = {
            identifier: [
                'username'
            ]
        };
    }
    canRemediate() {
        const identifier = this.getData('identifier');
        return !!identifier && super.canRemediate();
    }
    mapAuthenticator(remediationValue) {
        var _a, _b, _c;
        const authenticatorMap = super.mapAuthenticator(remediationValue);
        const methodTypeOption = (_a = this.selectedOption) === null || _a === void 0 ? void 0 : _a.value.form.value.find(({ name: name })=>name === 'methodType');
        const methodTypeValue = this.values.methodType || (methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.value) || ((_c = (_b = methodTypeOption === null || methodTypeOption === void 0 ? void 0 : methodTypeOption.options) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.value);
        if (methodTypeValue) return Object.assign(Object.assign({}, authenticatorMap), {
            methodType: methodTypeValue
        });
        return authenticatorMap;
    }
    getInputUsername() {
        return {
            name: 'username',
            type: 'string'
        };
    }
}
$9761101492cbce52$export$4171832ff6fa6156.remediationName = 'select-authenticator-unlock-account';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $395665287fb378ef$export$e96bca2a1d12839 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    canRemediate() {
        return true;
    }
}
$395665287fb378ef$export$e96bca2a1d12839.remediationName = 'select-enroll-profile';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


class $076f64411219981d$export$fe95ca2756091e61 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    constructor(remediation, values = {}){
        super(remediation, values);
        this.authenticator = this.getAuthenticator();
        this.formatAuthenticatorData();
    }
    formatAuthenticatorData() {
        const authenticatorData = this.getAuthenticatorData();
        if (authenticatorData) this.values.authenticatorsData = this.values.authenticatorsData.map((data)=>{
            if ((0, $c0eaea62dde87e17$export$36b7fa650feebb56)(this.authenticator, data)) return this.mapAuthenticatorDataFromValues(data);
            return data;
        });
        else {
            const data = this.mapAuthenticatorDataFromValues();
            if (data) this.values.authenticatorsData.push(data);
        }
    }
    getAuthenticatorData() {
        return this.values.authenticatorsData.find((data)=>(0, $c0eaea62dde87e17$export$36b7fa650feebb56)(this.authenticator, data));
    }
    canRemediate() {
        return this.values.authenticatorsData.some((data)=>(0, $c0eaea62dde87e17$export$36b7fa650feebb56)(this.authenticator, data));
    }
    mapAuthenticatorDataFromValues(authenticatorData) {
        let { methodType: methodType, authenticator: authenticator } = this.values;
        if (!methodType && (0, $23b7d84f5e759bd1$export$361ab32a8474b3c4)(authenticator)) methodType = authenticator === null || authenticator === void 0 ? void 0 : authenticator.methodType;
        const { id: id, enrollmentId: enrollmentId } = this.authenticator;
        const data = Object.assign(Object.assign({
            id: id,
            enrollmentId: enrollmentId
        }, authenticatorData && authenticatorData), methodType && {
            methodType: methodType
        });
        return data.methodType ? data : null;
    }
    getAuthenticatorFromRemediation() {
        const authenticator = this.remediation.value.find(({ name: name })=>name === 'authenticator');
        return authenticator;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        const authenticatorsData = this.values.authenticatorsData.filter((data)=>(0, $c0eaea62dde87e17$export$36b7fa650feebb56)(this.authenticator, data) !== true);
        return Object.assign(Object.assign({}, this.values), {
            authenticatorsData: authenticatorsData
        });
    }
}


class $4a91a7e534639814$export$53b35b6113db0f85 extends (0, $076f64411219981d$export$fe95ca2756091e61) {
    mapAuthenticator() {
        return this.getAuthenticatorData();
    }
    getInputAuthenticator() {
        const authenticator = this.getAuthenticatorFromRemediation();
        const methodType = authenticator.form.value.find(({ name: name })=>name === 'methodType');
        if (methodType && methodType.options) return {
            name: 'methodType',
            type: 'string',
            required: true,
            options: methodType.options
        };
        const inputs = [
            ...authenticator.form.value
        ];
        return inputs;
    }
    getValuesAfterProceed() {
        this.values = super.getValuesAfterProceed();
        let trimmedValues = Object.keys(this.values).filter((valueKey)=>valueKey !== 'authenticator');
        return trimmedValues.reduce((values, valueKey)=>Object.assign(Object.assign({}, values), {
                [valueKey]: this.values[valueKey]
            }), {});
    }
}
$4a91a7e534639814$export$53b35b6113db0f85.remediationName = 'authenticator-verification-data';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

class $7957fe28df12f1bc$export$8934d2d012992d26 extends (0, $076f64411219981d$export$fe95ca2756091e61) {
    mapAuthenticator() {
        const authenticatorData = this.getAuthenticatorData();
        const authenticatorFromRemediation = (0, $f063e89c0fabde24$export$2c4be893a02ba700)(this.remediation);
        return {
            id: authenticatorFromRemediation.form.value.find(({ name: name })=>name === 'id').value,
            methodType: authenticatorData.methodType,
            phoneNumber: authenticatorData.phoneNumber
        };
    }
    getInputAuthenticator(remediation) {
        return [
            {
                name: 'methodType',
                type: 'string'
            },
            {
                name: 'phoneNumber',
                label: 'Phone Number',
                type: 'string'
            }
        ].map((item)=>{
            const value = remediation.form.value.find((val)=>val.name === item.name);
            return Object.assign(Object.assign({}, value), item);
        });
    }
    mapAuthenticatorDataFromValues(data) {
        data = super.mapAuthenticatorDataFromValues(data);
        const { phoneNumber: phoneNumber } = this.values;
        if (!data && !phoneNumber) return;
        return Object.assign(Object.assign({}, data && data), phoneNumber && {
            phoneNumber: phoneNumber
        });
    }
}
$7957fe28df12f1bc$export$8934d2d012992d26.remediationName = 'authenticator-enrollment-data';


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $19aebc29362a45f0$export$38d24f5c1eb0e4c0 extends (0, $27bc8f98a25df821$export$8ab7a5763733596) {
    canRemediate() {
        return !!this.values.skip || this.options.step === 'skip';
    }
}
$19aebc29362a45f0$export$38d24f5c1eb0e4c0.remediationName = 'skip';




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





















const $a341783686098632$export$d49108c385f05cb4 = {
    'identify': (0, $92e11c41d7112f50$export$e513146db6535bff),
    'select-authenticator-authenticate': (0, $2bf37b9cf045baa0$export$c6bd0968af0af8c2),
    'select-authenticator-enroll': (0, $5e73cf4db6f3ec83$export$616f0495c05b2e5e),
    'authenticator-enrollment-data': (0, $7957fe28df12f1bc$export$8934d2d012992d26),
    'authenticator-verification-data': (0, $4a91a7e534639814$export$53b35b6113db0f85),
    'enroll-authenticator': (0, $b34f17fa52d9cd06$export$f7157015cf11193f),
    'challenge-authenticator': (0, $91ec62d42c052ca0$export$2a2afff13894112f),
    'challenge-poll': (0, $cc760a8af5379450$export$9da932f7758505ec),
    'reenroll-authenticator': (0, $c4e19db182eb4501$export$68450f7d95120a39),
    'reenroll-authenticator-warning': (0, $46ffacb7af9951b9$export$76c32f77c893cc76),
    'enroll-poll': (0, $7f0bcd5b671d3e75$export$2e21ed88eacb421f),
    'select-enrollment-channel': (0, $00d2aff6510814d0$export$76e9de8555d9305a),
    'enrollment-channel-data': (0, $79e3288dea6d8cbd$export$c1bb923bb31fb3c9),
    'redirect-idp': (0, $4cd2bb11a87017e4$export$772831dc8c7313c0),
    'skip': (0, $19aebc29362a45f0$export$38d24f5c1eb0e4c0)
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





















const $79a03aea29dc3864$export$6e2e200e9a83635 = {
    'identify': (0, $92e11c41d7112f50$export$e513146db6535bff),
    'identify-recovery': (0, $92e11c41d7112f50$export$e513146db6535bff),
    'select-authenticator-authenticate': (0, $2bf37b9cf045baa0$export$c6bd0968af0af8c2),
    'select-authenticator-enroll': (0, $5e73cf4db6f3ec83$export$616f0495c05b2e5e),
    'challenge-authenticator': (0, $91ec62d42c052ca0$export$2a2afff13894112f),
    'authenticator-verification-data': (0, $4a91a7e534639814$export$53b35b6113db0f85),
    'authenticator-enrollment-data': (0, $7957fe28df12f1bc$export$8934d2d012992d26),
    'reset-authenticator': (0, $cac25791d61330d7$export$3848083ec2ba1822),
    'reenroll-authenticator': (0, $c4e19db182eb4501$export$68450f7d95120a39),
    'reenroll-authenticator-warning': (0, $46ffacb7af9951b9$export$76c32f77c893cc76),
    'enroll-poll': (0, $7f0bcd5b671d3e75$export$2e21ed88eacb421f)
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





















const $c4bf17b222fb08a4$export$41f2a66c4e5194e4 = {
    'select-enroll-profile': (0, $395665287fb378ef$export$e96bca2a1d12839),
    'enroll-profile': (0, $fdb9a10676475760$export$528e7bbca764a356),
    'authenticator-enrollment-data': (0, $7957fe28df12f1bc$export$8934d2d012992d26),
    'select-authenticator-enroll': (0, $5e73cf4db6f3ec83$export$616f0495c05b2e5e),
    'enroll-poll': (0, $7f0bcd5b671d3e75$export$2e21ed88eacb421f),
    'select-enrollment-channel': (0, $00d2aff6510814d0$export$76e9de8555d9305a),
    'enrollment-channel-data': (0, $79e3288dea6d8cbd$export$c1bb923bb31fb3c9),
    'enroll-authenticator': (0, $b34f17fa52d9cd06$export$f7157015cf11193f),
    'skip': (0, $19aebc29362a45f0$export$38d24f5c1eb0e4c0)
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





















const $ba9daa25f783bc2f$export$a45fe067b739cc28 = {
    'identify': (0, $92e11c41d7112f50$export$e513146db6535bff),
    'select-authenticator-unlock-account': (0, $9761101492cbce52$export$4171832ff6fa6156),
    'select-authenticator-authenticate': (0, $2bf37b9cf045baa0$export$c6bd0968af0af8c2),
    'challenge-authenticator': (0, $91ec62d42c052ca0$export$2a2afff13894112f),
    'challenge-poll': (0, $cc760a8af5379450$export$9da932f7758505ec),
    'authenticator-verification-data': (0, $4a91a7e534639814$export$53b35b6113db0f85),
    'reenroll-authenticator-warning': (0, $46ffacb7af9951b9$export$76c32f77c893cc76)
};


function $6b2acbbab475610d$export$d54c0e1d8c74ec70(oktaAuth, flow = 'default') {
    let remediators, actions, withCredentials = true;
    switch(flow){
        case 'register':
        case 'signup':
        case 'enrollProfile':
            remediators = (0, $c4bf17b222fb08a4$export$41f2a66c4e5194e4);
            withCredentials = false;
            break;
        case 'recoverPassword':
        case 'resetPassword':
            remediators = (0, $79a03aea29dc3864$export$6e2e200e9a83635);
            actions = [
                'currentAuthenticator-recover',
                'currentAuthenticatorEnrollment-recover'
            ];
            withCredentials = false;
            break;
        case 'unlockAccount':
            remediators = (0, $ba9daa25f783bc2f$export$a45fe067b739cc28);
            withCredentials = false;
            actions = [
                'unlock-account'
            ];
            break;
        case 'authenticate':
        case 'login':
        case 'signin':
            remediators = (0, $a341783686098632$export$d49108c385f05cb4);
            break;
        default:
            remediators = (0, $a341783686098632$export$d49108c385f05cb4);
            break;
    }
    return {
        flow: flow,
        remediators: remediators,
        actions: actions,
        withCredentials: withCredentials
    };
}


async function $1a537db2b814e5be$export$70b61ad426ddbe54(authClient, options) {
    const meta = authClient.transactionManager.load();
    const flowSpec = (0, $6b2acbbab475610d$export$d54c0e1d8c74ec70)(authClient, meta.flow);
    return (0, $0094051e22ab524c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign(Object.assign({}, options), flowSpec), {
        actions: [
            'cancel'
        ]
    }));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $0ae2b8f64cf51c69$export$b4dca17ba2d0280(hashOrSearch) {
    var plus2space = /\+/g;
    var paramSplit = /([^&=]+)=?([^&]*)/g;
    var fragment = hashOrSearch || '';
    if (fragment.charAt(0) === '#' && fragment.charAt(1) === '/') fragment = fragment.substring(2);
    if (fragment.charAt(0) === '#' || fragment.charAt(0) === '?') fragment = fragment.substring(1);
    var obj = {};
    var param;
    while(true){
        param = paramSplit.exec(fragment);
        if (!param) break;
        var key = param[1];
        var value = param[2];
        if (key === 'id_token' || key === 'access_token' || key === 'code') obj[key] = value;
        else obj[key] = decodeURIComponent(value.replace(plus2space, ' '));
    }
    return obj;
}


class $a02f460bb0bd7a99$export$7924a0f6ccf797c7 extends (0, $8255b78460174178$export$2e2bcd8739ae039) {
    constructor(state, otp){
        super(`Enter the OTP code in the originating client: ${otp}`);
        this.name = 'EmailVerifyCallbackError';
        this.state = state;
        this.otp = otp;
    }
}
function $a02f460bb0bd7a99$export$40d2063037956ab3(error) {
    return error.name === 'EmailVerifyCallbackError';
}
function $a02f460bb0bd7a99$export$4081f8a7c53c0f1b(urlPath) {
    return /(otp=)/i.test(urlPath) && /(state=)/i.test(urlPath);
}
function $a02f460bb0bd7a99$export$ecbd7ac47d2433c0(urlPath) {
    return (0, $0ae2b8f64cf51c69$export$b4dca17ba2d0280)(urlPath);
}
async function $a02f460bb0bd7a99$export$7e5e1762b97d9db3(authClient, search) {
    if ($a02f460bb0bd7a99$export$4081f8a7c53c0f1b(search)) {
        const { state: state, otp: otp } = $a02f460bb0bd7a99$export$ecbd7ac47d2433c0(search);
        if (authClient.idx.canProceed({
            state: state
        })) return await authClient.idx.proceed({
            state: state,
            otp: otp
        });
        else throw new $a02f460bb0bd7a99$export$7924a0f6ccf797c7(state, otp);
    }
}




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $34685933a0d26280$export$2b22a8feb63a44b6(authClient, options = {}) {
    const meta = (0, $c6cd386983d9ca48$export$ee78659ae5675f26)(authClient, options);
    return !!(meta || options.stateHandle);
}
async function $34685933a0d26280$export$2eb0bdfd23e39c86(authClient, options = {}) {
    if (!$34685933a0d26280$export$2b22a8feb63a44b6(authClient, options)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to proceed: saved transaction could not be loaded');
    let { flow: flow, state: state } = options;
    if (!flow) {
        const meta = (0, $c6cd386983d9ca48$export$ee78659ae5675f26)(authClient, {
            state: state
        });
        flow = meta === null || meta === void 0 ? void 0 : meta.flow;
    }
    return (0, $0094051e22ab524c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign({}, options), {
        flow: flow
    }));
}




async function $a5a7d40682d15bb0$export$e0c10349b2c5e1d4(authClient, options = {}) {
    var _a;
    const { withCredentials: withCredentials, exchangeCodeForTokens: exchangeCodeForTokens } = options;
    let transaction = await (0, $34685933a0d26280$export$2eb0bdfd23e39c86)(authClient, {
        startPolling: true,
        withCredentials: withCredentials,
        exchangeCodeForTokens: exchangeCodeForTokens
    });
    const meta = (0, $c6cd386983d9ca48$export$ee78659ae5675f26)(authClient);
    let availablePollingRemeditaions = (_a = meta === null || meta === void 0 ? void 0 : meta.remediations) === null || _a === void 0 ? void 0 : _a.find((remediation)=>remediation.includes('poll'));
    if (!(availablePollingRemeditaions === null || availablePollingRemeditaions === void 0 ? void 0 : availablePollingRemeditaions.length)) (0, $5502e384469ea433$export$c106dd0671a0fc2d)('No polling remediations available at the current IDX flow stage');
    if (Number.isInteger(options.refresh)) return new Promise(function(resolve, reject) {
        setTimeout(async function() {
            var _a, _b;
            try {
                const refresh = (_b = (_a = transaction.nextStep) === null || _a === void 0 ? void 0 : _a.poll) === null || _b === void 0 ? void 0 : _b.refresh;
                if (refresh) resolve($a5a7d40682d15bb0$export$e0c10349b2c5e1d4(authClient, {
                    refresh: refresh
                }));
                else resolve(transaction);
            } catch (err) {
                reject(err);
            }
        }, options.refresh);
    });
    return transaction;
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
async function $c23e535dab837f8f$export$e262da7ae6480481(authClient, options = {}) {
    authClient.transactionManager.clear();
    return (0, $0094051e22ab524c$export$889ea624f2cb2c57)(authClient, Object.assign({
        exchangeCodeForTokens: false
    }, options));
}





async function $4e5bd7cad97cc55f$export$6503ec6e8aabbaf(authClient, options = {}) {
    if (!(0, $c6cd386983d9ca48$export$ca280d73913750db)(authClient)) {
        const { enabledFeatures: enabledFeatures } = await (0, $c23e535dab837f8f$export$e262da7ae6480481)(authClient, Object.assign(Object.assign({}, options), {
            flow: 'register',
            autoRemediate: false
        }));
        if (!options.activationToken && enabledFeatures && !enabledFeatures.includes((0, $23b7d84f5e759bd1$export$451922195d9391fb).REGISTRATION)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Registration is not supported based on your current org configuration.');
    }
    return (0, $0094051e22ab524c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign({}, options), {
        flow: 'register'
    }));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 























async function $2f56df9afde31e4e$export$1743464e5cd3b116(authClient, options = {}) {
    const flowSpec = (0, $6b2acbbab475610d$export$d54c0e1d8c74ec70)(authClient, 'recoverPassword');
    return (0, $0094051e22ab524c$export$889ea624f2cb2c57)(authClient, Object.assign(Object.assign({}, options), flowSpec));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


async function $0c936e1411d60762$export$47d3290ab3a41fe5(authClient, url) {
    const meta = authClient.transactionManager.load();
    if (!meta) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('No transaction data was found in storage');
    const { codeVerifier: codeVerifier, state: savedState } = meta;
    const { searchParams: searchParams } = new URL(url);
    const state = searchParams.get('state');
    const interactionCode = searchParams.get('interaction_code');
    const error = searchParams.get('error');
    if (error) throw new (0, $b17ce0de6fad00bb$export$2e2bcd8739ae039)(error, searchParams.get('error_description'));
    if (state !== savedState) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('State in redirect uri does not match with transaction state');
    if (!interactionCode) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to parse interaction_code from the url');
    const { tokens: tokens } = await authClient.token.exchangeCodeForTokens({
        interactionCode: interactionCode,
        codeVerifier: codeVerifier
    });
    authClient.tokenManager.setTokens(tokens);
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





async function $ff0f4d4324609b28$export$5edfb7a6a5229faf(authClient, options = {}) {
    options.flow = 'unlockAccount';
    if (!(0, $c6cd386983d9ca48$export$ca280d73913750db)(authClient)) {
        const { enabledFeatures: enabledFeatures } = await (0, $c23e535dab837f8f$export$e262da7ae6480481)(authClient, Object.assign(Object.assign({}, options), {
            autoRemediate: false
        }));
        if (enabledFeatures && !enabledFeatures.includes((0, $23b7d84f5e759bd1$export$451922195d9391fb).ACCOUNT_UNLOCK)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Self Service Account Unlock is not supported based on your current org configuration.');
    }
    return (0, $0094051e22ab524c$export$889ea624f2cb2c57)(authClient, Object.assign({}, options));
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $f5378b90fb42f11e$export$376c3c4c19cb933a(error) {
    if (error.name !== 'OAuthError') return false;
    const oauthError = error;
    return oauthError.errorCode === 'interaction_required';
}
function $f5378b90fb42f11e$export$802bd45553941f4b(sdk, error) {
    if (error.name !== 'AuthApiError') return false;
    const authApiError = error;
    const errorResponse = authApiError.xhr;
    const responseJSON = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.responseJSON;
    return sdk.options.pkce && (responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.error) === 'invalid_grant';
}
function $f5378b90fb42f11e$export$759948024dbf620d(error) {
    return (0, $00075bbb69b7d8b4$export$65ac14d4981b453f)(error) && error.errorCode === 'invalid_grant' && error.errorSummary === 'The refresh token is invalid or expired.';
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $e49ac4003f707fb9$export$36a79c777d90162d(hash) {
    return /((id|access)_token=)/i.test(hash);
}
function $e49ac4003f707fb9$export$269560c031e7bdd3(hashOrSearch) {
    return /(code=)/i.test(hashOrSearch);
}
function $e49ac4003f707fb9$export$292844be853a0f0(hashOrSearch) {
    return /(interaction_code=)/i.test(hashOrSearch);
}
function $e49ac4003f707fb9$export$da6c08b50b1641ee(hashOrSearch) {
    return /(error=)/i.test(hashOrSearch) || /(error_description)/i.test(hashOrSearch);
}
function $e49ac4003f707fb9$export$6a4ca2e010e82262(uri, sdk) {
    var authParams = sdk.options;
    if (!uri || !authParams.redirectUri) return false;
    return uri.indexOf(authParams.redirectUri) === 0;
}
function $e49ac4003f707fb9$export$8148c7f7e9a4b885(options) {
    return options.pkce || options.responseType === 'code' || options.responseMode === 'query';
}
function $e49ac4003f707fb9$export$85f1abab17a58c57(responseType, options) {
    let hasResponseType = false;
    if (Array.isArray(options.responseType) && options.responseType.length) hasResponseType = options.responseType.indexOf(responseType) >= 0;
    else hasResponseType = options.responseType === responseType;
    return hasResponseType;
}
function $e49ac4003f707fb9$export$a3b47430310a8cd8(options) {
    var codeFlow = $e49ac4003f707fb9$export$8148c7f7e9a4b885(options);
    var useQuery = codeFlow && options.responseMode !== 'fragment';
    return useQuery ? window.location.search : window.location.hash;
}
function $e49ac4003f707fb9$export$3488c667ccc91890(sdk) {
    if (!$e49ac4003f707fb9$export$6a4ca2e010e82262(window.location.href, sdk)) return false;
    var codeFlow = $e49ac4003f707fb9$export$8148c7f7e9a4b885(sdk.options);
    var hashOrSearch = $e49ac4003f707fb9$export$a3b47430310a8cd8(sdk.options);
    if ($e49ac4003f707fb9$export$da6c08b50b1641ee(hashOrSearch)) return true;
    if (codeFlow) {
        var hasCode = $e49ac4003f707fb9$export$269560c031e7bdd3(hashOrSearch) || $e49ac4003f707fb9$export$292844be853a0f0(hashOrSearch);
        return hasCode;
    }
    return $e49ac4003f707fb9$export$36a79c777d90162d(window.location.hash);
}
function $e49ac4003f707fb9$export$5d0b3676a90f01bf(sdk, hashOrSearch) {
    if (!hashOrSearch) {
        if (!$e49ac4003f707fb9$export$3488c667ccc91890(sdk)) return false;
        hashOrSearch = $e49ac4003f707fb9$export$a3b47430310a8cd8(sdk.options);
    }
    return /(error=interaction_required)/i.test(hashOrSearch);
}





parcelRequire("R5nvG");
















var $56fb3a1340b1b883$exports = {};

$parcel$export($56fb3a1340b1b883$exports, "Remediator", () => $27bc8f98a25df821$export$8ab7a5763733596);
$parcel$export($56fb3a1340b1b883$exports, "EnrollAuthenticator", () => $b34f17fa52d9cd06$export$f7157015cf11193f);
$parcel$export($56fb3a1340b1b883$exports, "EnrollPoll", () => $7f0bcd5b671d3e75$export$2e21ed88eacb421f);
$parcel$export($56fb3a1340b1b883$exports, "SelectEnrollmentChannel", () => $00d2aff6510814d0$export$76e9de8555d9305a);
$parcel$export($56fb3a1340b1b883$exports, "EnrollmentChannelData", () => $79e3288dea6d8cbd$export$c1bb923bb31fb3c9);
$parcel$export($56fb3a1340b1b883$exports, "ChallengeAuthenticator", () => $91ec62d42c052ca0$export$2a2afff13894112f);
$parcel$export($56fb3a1340b1b883$exports, "ChallengePoll", () => $cc760a8af5379450$export$9da932f7758505ec);
$parcel$export($56fb3a1340b1b883$exports, "ResetAuthenticator", () => $cac25791d61330d7$export$3848083ec2ba1822);
$parcel$export($56fb3a1340b1b883$exports, "EnrollProfile", () => $fdb9a10676475760$export$528e7bbca764a356);
$parcel$export($56fb3a1340b1b883$exports, "Identify", () => $92e11c41d7112f50$export$e513146db6535bff);
$parcel$export($56fb3a1340b1b883$exports, "ReEnrollAuthenticator", () => $c4e19db182eb4501$export$68450f7d95120a39);
$parcel$export($56fb3a1340b1b883$exports, "ReEnrollAuthenticatorWarning", () => $46ffacb7af9951b9$export$76c32f77c893cc76);
$parcel$export($56fb3a1340b1b883$exports, "RedirectIdp", () => $4cd2bb11a87017e4$export$772831dc8c7313c0);
$parcel$export($56fb3a1340b1b883$exports, "SelectAuthenticatorAuthenticate", () => $2bf37b9cf045baa0$export$c6bd0968af0af8c2);
$parcel$export($56fb3a1340b1b883$exports, "SelectAuthenticatorEnroll", () => $5e73cf4db6f3ec83$export$616f0495c05b2e5e);
$parcel$export($56fb3a1340b1b883$exports, "SelectAuthenticatorUnlockAccount", () => $9761101492cbce52$export$4171832ff6fa6156);
$parcel$export($56fb3a1340b1b883$exports, "SelectEnrollProfile", () => $395665287fb378ef$export$e96bca2a1d12839);
$parcel$export($56fb3a1340b1b883$exports, "AuthenticatorVerificationData", () => $4a91a7e534639814$export$53b35b6113db0f85);
$parcel$export($56fb3a1340b1b883$exports, "AuthenticatorEnrollmentData", () => $7957fe28df12f1bc$export$8934d2d012992d26);
$parcel$export($56fb3a1340b1b883$exports, "Skip", () => $19aebc29362a45f0$export$38d24f5c1eb0e4c0);
$parcel$export($56fb3a1340b1b883$exports, "GenericRemediator", () => $3604e1bdac767034$export$9e487c92809f61cb);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
























function $29e563c9dcc80d37$export$8e517878c6a5f058(sdk) {
    (0, $b1d30d0c70179e88$export$36c62655b1577e54)({
        remediators: $56fb3a1340b1b883$exports,
        getFlowSpecification: $6b2acbbab475610d$export$d54c0e1d8c74ec70
    });
    const boundStartTransaction = (0, $c23e535dab837f8f$export$e262da7ae6480481).bind(null, sdk);
    const idx = {
        interact: (0, $2027d28688355efb$export$20814a0f9b60f8cf).bind(null, sdk),
        introspect: (0, $21d92a1cc115c86c$export$3b41a86e379f8f15).bind(null, sdk),
        makeIdxResponse: (0, $40b25ced63ff9c03$export$67f6ec95030789e9).bind(null, sdk),
        authenticate: (0, $dfab4b212fb2e0cf$export$61bb00ddedae72e4).bind(null, sdk),
        register: (0, $4e5bd7cad97cc55f$export$6503ec6e8aabbaf).bind(null, sdk),
        start: boundStartTransaction,
        startTransaction: boundStartTransaction,
        poll: (0, $a5a7d40682d15bb0$export$e0c10349b2c5e1d4).bind(null, sdk),
        proceed: (0, $34685933a0d26280$export$2eb0bdfd23e39c86).bind(null, sdk),
        cancel: (0, $1a537db2b814e5be$export$70b61ad426ddbe54).bind(null, sdk),
        recoverPassword: (0, $2f56df9afde31e4e$export$1743464e5cd3b116).bind(null, sdk),
        handleInteractionCodeRedirect: (0, $0c936e1411d60762$export$47d3290ab3a41fe5).bind(null, sdk),
        isInteractionRequired: (0, $e49ac4003f707fb9$export$5d0b3676a90f01bf).bind(null, sdk),
        isInteractionRequiredError: $f5378b90fb42f11e$export$376c3c4c19cb933a,
        handleEmailVerifyCallback: (0, $a02f460bb0bd7a99$export$7e5e1762b97d9db3).bind(null, sdk),
        isEmailVerifyCallback: $a02f460bb0bd7a99$export$4081f8a7c53c0f1b,
        parseEmailVerifyCallback: $a02f460bb0bd7a99$export$ecbd7ac47d2433c0,
        isEmailVerifyCallbackError: $a02f460bb0bd7a99$export$40d2063037956ab3,
        getSavedTransactionMeta: (0, $c6cd386983d9ca48$export$ee78659ae5675f26).bind(null, sdk),
        createTransactionMeta: (0, $c6cd386983d9ca48$export$88d345acadfc62dd).bind(null, sdk),
        getTransactionMeta: (0, $c6cd386983d9ca48$export$701cc743c44cf8ae).bind(null, sdk),
        saveTransactionMeta: (0, $c6cd386983d9ca48$export$dc27696b235944d6).bind(null, sdk),
        clearTransactionMeta: (0, $c6cd386983d9ca48$export$750593bdfc027325).bind(null, sdk),
        isTransactionMetaValid: $c6cd386983d9ca48$export$e14be23af70c5fd,
        setFlow: (flow)=>{
            sdk.options.flow = flow;
        },
        getFlow: ()=>{
            return sdk.options.flow;
        },
        canProceed: (0, $34685933a0d26280$export$2b22a8feb63a44b6).bind(null, sdk),
        unlockAccount: (0, $ff0f4d4324609b28$export$5edfb7a6a5229faf).bind(null, sdk)
    };
    return idx;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $c9fbd110bc9c9442$export$2bc41dfbf048bfdc(OptionsConstructor) {
    class OktaAuthBase {
        constructor(...args){
            const options = new OptionsConstructor(args.length ? args[0] || {} : {});
            this.options = (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)(options);
            this.emitter = new (0, (/*@__PURE__*/$parcel$interopDefault($bb3d51bfa22856f3$exports)))();
            this.features = $cbeaafbff16be8ee$exports;
        }
    }
    OktaAuthBase.features = $cbeaafbff16be8ee$exports;
    OktaAuthBase.constants = $2119f0a66eb38a81$exports;
    OktaAuthBase.features = OktaAuthBase.prototype.features = $cbeaafbff16be8ee$exports;
    Object.assign(OktaAuthBase, {
        constants: $2119f0a66eb38a81$exports
    });
    return OktaAuthBase;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $a8d31580460d70f9$export$32ec6248008f35d1(Base, StorageManager) {
    return class OktaAuthStorage extends Base {
        constructor(...args){
            super(...args);
            const { storageManager: storageManager, cookies: cookies, storageUtil: storageUtil } = this.options;
            this.storageManager = new StorageManager(storageManager, cookies, storageUtil);
        }
        clearStorage() {}
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


class $e2b75c528c3cb892$export$cddb8b47eb189756 {
    constructor(){
        this.environments = [
            `okta-auth-js/${"7.14.0"}`
        ];
        this.maybeAddNodeEnvironment();
    }
    addEnvironment(env) {
        this.environments.push(env);
    }
    getHttpHeader() {
        return {
            'X-Okta-User-Agent-Extended': this.environments.join(' ')
        };
    }
    getVersion() {
        return "7.14.0";
    }
    maybeAddNodeEnvironment() {
        if ((0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)() || !$cfae44f0dfdf62c0$exports || !$cfae44f0dfdf62c0$exports.versions) return;
        const { node: version } = $cfae44f0dfdf62c0$exports.versions;
        this.environments.push(`nodejs/${version}`);
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $35d0a341d0c6f3da$export$4a0dedceb084213c(authClient, headerName, headerValue) {
    authClient.options.headers = authClient.options.headers || {};
    authClient.options.headers[headerName] = headerValue;
}




function $00e95a529c550931$export$b21483dcd2900eca(Base) {
    return class OktaAuthHttp extends Base {
        constructor(...args){
            super(...args);
            this._oktaUserAgent = new (0, $e2b75c528c3cb892$export$cddb8b47eb189756)();
            this.http = {
                setRequestHeader: (0, $35d0a341d0c6f3da$export$4a0dedceb084213c).bind(null, this)
            };
        }
        setHeaders(headers) {
            this.options.headers = Object.assign({}, this.options.headers, headers);
        }
        getIssuerOrigin() {
            return this.options.issuer.split('/oauth2/')[0];
        }
        webfinger(opts) {
            var url = '/.well-known/webfinger' + (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)(opts);
            var options = {
                headers: {
                    'Accept': 'application/jrd+json'
                }
            };
            return (0, $b8f53662f6ac3919$export$3988ae62b71be9a3)(this, url, options);
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
var $695ebb4ba08f1e79$exports = {};

$parcel$export($695ebb4ba08f1e79$exports, "base64ToBase64Url", () => $a2b7a7081fca65c9$export$3b91e21dac1023c6);
$parcel$export($695ebb4ba08f1e79$exports, "base64UrlDecode", () => $a2b7a7081fca65c9$export$ea8ee39e6b15f86f);
$parcel$export($695ebb4ba08f1e79$exports, "base64UrlToBase64", () => $a2b7a7081fca65c9$export$47c5265a25535d02);
$parcel$export($695ebb4ba08f1e79$exports, "base64UrlToBuffer", () => $a2b7a7081fca65c9$export$74669d1cb8191241);
$parcel$export($695ebb4ba08f1e79$exports, "base64UrlToString", () => $a2b7a7081fca65c9$export$aaa8dbd819f78142);
$parcel$export($695ebb4ba08f1e79$exports, "bufferToBase64Url", () => $a2b7a7081fca65c9$export$271320a6f6117eda);
$parcel$export($695ebb4ba08f1e79$exports, "stringToBase64Url", () => $a2b7a7081fca65c9$export$1494c20bc10d07ca);
$parcel$export($695ebb4ba08f1e79$exports, "stringToBuffer", () => $a2b7a7081fca65c9$export$1e95461c937e230d);
$parcel$export($695ebb4ba08f1e79$exports, "getOidcHash", () => $2eaba61097ed4c7a$export$7186055aabeea565);
$parcel$export($695ebb4ba08f1e79$exports, "verifyToken", () => $8498ea9d3e5853d4$export$c807668e63e7354b);
$parcel$export($695ebb4ba08f1e79$exports, "atob", () => $a8d4082f60e792f5$export$1406ac7a6dfd7b7a);
$parcel$export($695ebb4ba08f1e79$exports, "btoa", () => $a8d4082f60e792f5$export$a32219e24f8d1e2);
$parcel$export($695ebb4ba08f1e79$exports, "webcrypto", () => $a8d4082f60e792f5$export$96ce270682c18269);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $a2b7a7081fca65c9$export$1494c20bc10d07ca(str) {
    var b64 = (0, $a8d4082f60e792f5$export$a32219e24f8d1e2)(str);
    return $a2b7a7081fca65c9$export$3b91e21dac1023c6(b64);
}
function $a2b7a7081fca65c9$export$3b91e21dac1023c6(b64) {
    return b64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $a2b7a7081fca65c9$export$47c5265a25535d02(b64u) {
    return b64u.replace(/-/g, '+').replace(/_/g, '/');
}
function $a2b7a7081fca65c9$export$aaa8dbd819f78142(b64u) {
    var b64 = $a2b7a7081fca65c9$export$47c5265a25535d02(b64u);
    switch(b64.length % 4){
        case 0:
            break;
        case 2:
            b64 += '==';
            break;
        case 3:
            b64 += '=';
            break;
        default:
            throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Not a valid Base64Url');
    }
    var utf8 = (0, $a8d4082f60e792f5$export$1406ac7a6dfd7b7a)(b64);
    try {
        return decodeURIComponent(escape(utf8));
    } catch (e) {
        return utf8;
    }
}
function $a2b7a7081fca65c9$export$1e95461c937e230d(str) {
    var buffer = new Uint8Array(str.length);
    for(var i = 0; i < str.length; i++)buffer[i] = str.charCodeAt(i);
    return buffer;
}
function $a2b7a7081fca65c9$export$ea8ee39e6b15f86f(str) {
    return (0, $a8d4082f60e792f5$export$1406ac7a6dfd7b7a)($a2b7a7081fca65c9$export$47c5265a25535d02(str));
}
function $a2b7a7081fca65c9$export$74669d1cb8191241(b64u) {
    return Uint8Array.from($a2b7a7081fca65c9$export$ea8ee39e6b15f86f(b64u), (c)=>c.charCodeAt(0));
}
function $a2b7a7081fca65c9$export$271320a6f6117eda(bin) {
    return (0, $a8d4082f60e792f5$export$a32219e24f8d1e2)(new Uint8Array(bin).reduce((s, byte)=>s + String.fromCharCode(byte), ''));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

function $2eaba61097ed4c7a$export$7186055aabeea565(str) {
    var buffer = new TextEncoder().encode(str);
    return (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle.digest('SHA-256', buffer).then(function(arrayBuffer) {
        var intBuffer = new Uint8Array(arrayBuffer);
        var firstHalf = intBuffer.slice(0, 16);
        var hash = String.fromCharCode.apply(null, firstHalf);
        var b64u = (0, $a2b7a7081fca65c9$export$1494c20bc10d07ca)(hash);
        return b64u;
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $8498ea9d3e5853d4$export$c807668e63e7354b(idToken, key) {
    key = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(key);
    var format = 'jwk';
    var algo = {
        name: 'RSASSA-PKCS1-v1_5',
        hash: {
            name: 'SHA-256'
        }
    };
    var extractable = true;
    var usages = [
        'verify'
    ];
    delete key.use;
    return (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle.importKey(format, key, algo, extractable, usages).then(function(cryptoKey) {
        var jwt = idToken.split('.');
        var payload = (0, $a2b7a7081fca65c9$export$1e95461c937e230d)(jwt[0] + '.' + jwt[1]);
        var b64Signature = (0, $a2b7a7081fca65c9$export$ea8ee39e6b15f86f)(jwt[2]);
        var signature = (0, $a2b7a7081fca65c9$export$1e95461c937e230d)(b64Signature);
        return (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle.verify(algo, cryptoKey, signature, payload);
    });
}






/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

class $aa5cb4c154f96734$export$7ab95d2dbda3c98c {
    constructor(options = {
        quiet: false
    }){
        this.queue = [];
        this.running = false;
        this.options = options;
    }
    push(method, thisObject, ...args) {
        return new Promise((resolve, reject)=>{
            if (this.queue.length > 0) {
                if (this.options.quiet !== false) (0, $5502e384469ea433$export$c106dd0671a0fc2d)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes.");
            }
            this.queue.push({
                method: method,
                thisObject: thisObject,
                args: args,
                resolve: resolve,
                reject: reject
            });
            this.run();
        });
    }
    run() {
        if (this.running) return;
        if (this.queue.length === 0) return;
        this.running = true;
        var queueItem = this.queue.shift();
        var res = queueItem.method.apply(queueItem.thisObject, queueItem.args);
        if ((0, $307f2ba6550d7c99$export$4369c812aac99591)(res)) res.then(queueItem.resolve, queueItem.reject).finally(()=>{
            this.running = false;
            this.run();
        });
        else {
            queueItem.resolve(res);
            this.running = false;
            this.run();
        }
    }
}






parcelRequire("R5nvG");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $0d1779c11b1d7a45$var$dec2hex(dec) {
    return ('0' + dec.toString(16)).substr(-2);
}
function $0d1779c11b1d7a45$var$getRandomString(length) {
    var a = new Uint8Array(Math.ceil(length / 2));
    (0, $a8d4082f60e792f5$export$96ce270682c18269).getRandomValues(a);
    var str = Array.from(a, $0d1779c11b1d7a45$var$dec2hex).join('');
    return str.slice(0, length);
}
function $0d1779c11b1d7a45$var$generateVerifier(prefix) {
    var verifier = prefix || '';
    if (verifier.length < (0, $2119f0a66eb38a81$export$3429266d17ae1515)) verifier = verifier + $0d1779c11b1d7a45$var$getRandomString((0, $2119f0a66eb38a81$export$3429266d17ae1515) - verifier.length);
    return encodeURIComponent(verifier).slice(0, (0, $2119f0a66eb38a81$export$65dcf38d91740c9a));
}
function $0d1779c11b1d7a45$var$computeChallenge(str) {
    var buffer = new TextEncoder().encode(str);
    return (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle.digest('SHA-256', buffer).then(function(arrayBuffer) {
        var hash = String.fromCharCode.apply(null, new Uint8Array(arrayBuffer));
        var b64u = (0, $a2b7a7081fca65c9$export$1494c20bc10d07ca)(hash);
        return b64u;
    });
}
var $0d1779c11b1d7a45$export$2e2bcd8739ae039 = {
    DEFAULT_CODE_CHALLENGE_METHOD: $2119f0a66eb38a81$export$ed9a92f7e3f906d8,
    generateVerifier: $0d1779c11b1d7a45$var$generateVerifier,
    computeChallenge: $0d1779c11b1d7a45$var$computeChallenge
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $9048550239ebf2b7$export$4b61618bdb99cb7e(token) {
    var jwt = token.split('.');
    var decodedToken;
    try {
        decodedToken = {
            header: JSON.parse((0, $a2b7a7081fca65c9$export$aaa8dbd819f78142)(jwt[0])),
            payload: JSON.parse((0, $a2b7a7081fca65c9$export$aaa8dbd819f78142)(jwt[1])),
            signature: jwt[2]
        };
    } catch (e) {
        throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Malformed token');
    }
    return decodedToken;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $63643900107af5be$export$7b9316c0224bc208(sdk) {
    const { pkce: pkce, clientId: clientId, redirectUri: redirectUri, responseType: responseType, responseMode: responseMode, scopes: scopes, acrValues: acrValues, maxAge: maxAge, state: state, ignoreSignature: ignoreSignature, dpop: dpop } = sdk.options;
    const defaultRedirectUri = (0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)() ? window.location.href : undefined;
    return (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)({
        pkce: pkce,
        clientId: clientId,
        redirectUri: redirectUri || defaultRedirectUri,
        responseType: responseType || [
            'token',
            'id_token'
        ],
        responseMode: responseMode,
        state: state || (0, $28694eacc5911f05$export$9ccd2716e53a229b)(),
        nonce: (0, $28694eacc5911f05$export$3ff59198e2333fc6)(),
        scopes: scopes || [
            'openid',
            'email'
        ],
        acrValues: acrValues,
        maxAge: maxAge,
        ignoreSignature: ignoreSignature,
        dpop: dpop
    });
}







parcelRequire("R5nvG");

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







parcelRequire("R5nvG");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



const $567efc7b9cd21385$var$INDEXEDDB_NAME = 'OktaAuthJs';
const $567efc7b9cd21385$var$DB_KEY = 'DPoPKeys';
function $567efc7b9cd21385$export$283c6a56651b6b3(obj) {
    return ((0, $00075bbb69b7d8b4$export$65ac14d4981b453f)(obj) || (0, $00075bbb69b7d8b4$export$380e188e91bd13a1)(obj)) && obj.errorCode === 'use_dpop_nonce';
}
async function $567efc7b9cd21385$export$ff09bb9c32934be3(header, claims, signingKey) {
    const head = (0, $a2b7a7081fca65c9$export$1494c20bc10d07ca)(JSON.stringify(header));
    const body = (0, $a2b7a7081fca65c9$export$1494c20bc10d07ca)(JSON.stringify(claims));
    const signature = await (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle.sign({
        name: signingKey.algorithm.name
    }, signingKey, (0, $a2b7a7081fca65c9$export$1e95461c937e230d)(`${head}.${body}`));
    return `${head}.${body}.${(0, $a2b7a7081fca65c9$export$3b91e21dac1023c6)((0, $a2b7a7081fca65c9$export$271320a6f6117eda)(signature))}`;
}
function $567efc7b9cd21385$export$2838168319feb846(byteLen = 32) {
    return [
        ...(0, $a8d4082f60e792f5$export$96ce270682c18269).getRandomValues(new Uint8Array(byteLen))
    ].map((v)=>v.toString(16)).join('');
}
async function $567efc7b9cd21385$export$a949d36eab55b41f() {
    const algorithm = {
        name: 'RSASSA-PKCS1-v1_5',
        hash: 'SHA-256',
        modulusLength: 2048,
        publicExponent: new Uint8Array([
            0x01,
            0x00,
            0x01
        ])
    };
    return (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle.generateKey(algorithm, false, [
        'sign',
        'verify'
    ]);
}
async function $567efc7b9cd21385$var$hashAccessToken(accessToken) {
    const buffer = new TextEncoder().encode(accessToken);
    const hash = await (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle.digest('SHA-256', buffer);
    return (0, $a8d4082f60e792f5$export$a32219e24f8d1e2)(String.fromCharCode.apply(null, new Uint8Array(hash))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
function $567efc7b9cd21385$var$keyStore() {
    return new Promise((resolve, reject)=>{
        try {
            const indexedDB = window.indexedDB;
            const req = indexedDB.open($567efc7b9cd21385$var$INDEXEDDB_NAME, 1);
            req.onerror = function() {
                reject(req.error);
            };
            req.onupgradeneeded = function() {
                const db = req.result;
                db.createObjectStore($567efc7b9cd21385$var$DB_KEY);
            };
            req.onsuccess = function() {
                const db = req.result;
                const tx = db.transaction($567efc7b9cd21385$var$DB_KEY, 'readwrite');
                tx.onerror = function() {
                    reject(tx.error);
                };
                const store = tx.objectStore($567efc7b9cd21385$var$DB_KEY);
                resolve(store);
                tx.oncomplete = function() {
                    db.close();
                };
            };
        } catch (err) {
            reject(err);
        }
    });
}
async function $567efc7b9cd21385$var$invokeStoreMethod(method, ...args) {
    const store = await $567efc7b9cd21385$var$keyStore();
    return new Promise((resolve, reject)=>{
        const req = store[method](...args);
        req.onsuccess = function() {
            resolve(req);
        };
        req.onerror = function() {
            reject(req.error);
        };
    });
}
async function $567efc7b9cd21385$var$storeKeyPair(pairId, keyPair) {
    await $567efc7b9cd21385$var$invokeStoreMethod('add', keyPair, pairId);
    return keyPair;
}
async function $567efc7b9cd21385$export$846293577e1b1366(pairId) {
    if (pairId) {
        const req = await $567efc7b9cd21385$var$invokeStoreMethod('get', pairId);
        if (req.result) return req.result;
    }
    throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)(`Unable to locate dpop key pair required for refresh${pairId ? ` (${pairId})` : ''}`);
}
async function $567efc7b9cd21385$export$f33690fea154ad2d(pairId) {
    await $567efc7b9cd21385$var$invokeStoreMethod('delete', pairId);
}
async function $567efc7b9cd21385$export$20156800d73a71cb() {
    await $567efc7b9cd21385$var$invokeStoreMethod('clear');
}
async function $567efc7b9cd21385$export$791e6660a495fff2() {
    const keyPairId = $567efc7b9cd21385$export$2838168319feb846(4);
    const keyPair = await $567efc7b9cd21385$export$a949d36eab55b41f();
    await $567efc7b9cd21385$var$storeKeyPair(keyPairId, keyPair);
    return {
        keyPair: keyPair,
        keyPairId: keyPairId
    };
}
async function $567efc7b9cd21385$export$6afe52fd44d25eaf(revokedToken, tokens) {
    var _a;
    let shouldClear = false;
    const { accessToken: accessToken, refreshToken: refreshToken } = tokens;
    if (revokedToken === 'access' && accessToken && accessToken.tokenType === 'DPoP' && !refreshToken) shouldClear = true;
    if (revokedToken === 'refresh' && refreshToken && !accessToken) shouldClear = true;
    const pairId = (_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId) !== null && _a !== void 0 ? _a : refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.dpopPairId;
    if (shouldClear && pairId) await $567efc7b9cd21385$export$f33690fea154ad2d(pairId);
}
async function $567efc7b9cd21385$export$ac18780f7e57da({ keyPair: keyPair, url: url, method: method, nonce: nonce, accessToken: accessToken }) {
    const { kty: kty, crv: crv, e: e, n: n, x: x, y: y } = await (0, $a8d4082f60e792f5$export$96ce270682c18269).subtle.exportKey('jwk', keyPair.publicKey);
    const header = {
        alg: 'RS256',
        typ: 'dpop+jwt',
        jwk: {
            kty: kty,
            crv: crv,
            e: e,
            n: n,
            x: x,
            y: y
        }
    };
    const claims = {
        htm: method,
        htu: url,
        iat: Math.floor(Date.now() / 1000),
        jti: $567efc7b9cd21385$export$2838168319feb846()
    };
    if (nonce) claims.nonce = nonce;
    if (accessToken) claims.ath = await $567efc7b9cd21385$var$hashAccessToken(accessToken);
    return $567efc7b9cd21385$export$ff09bb9c32934be3(header, claims, keyPair.privateKey);
}
async function $567efc7b9cd21385$export$5c0f49fa17cf96e6({ keyPair: keyPair, url: url, method: method, nonce: nonce }) {
    const params = {
        keyPair: keyPair,
        url: url,
        method: method
    };
    if (nonce) params.nonce = nonce;
    return $567efc7b9cd21385$export$ac18780f7e57da(params);
}


function $1beeceac16d65c54$var$validateOptions(options) {
    if (!options.clientId) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to get a token');
    if (!options.redirectUri) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The redirectUri passed to /authorize must also be passed to /token');
    if (!options.authorizationCode && !options.interactionCode) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('An authorization code (returned from /authorize) must be passed to /token');
    if (!options.codeVerifier) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The "codeVerifier" (generated and saved by your app) must be passed to /token');
}
function $1beeceac16d65c54$var$getPostData(sdk, options) {
    var params = (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)({
        'client_id': options.clientId,
        'redirect_uri': options.redirectUri,
        'grant_type': options.interactionCode ? 'interaction_code' : 'authorization_code',
        'code_verifier': options.codeVerifier
    });
    if (options.interactionCode) params['interaction_code'] = options.interactionCode;
    else if (options.authorizationCode) params.code = options.authorizationCode;
    const { clientSecret: clientSecret } = sdk.options;
    if (clientSecret) params['client_secret'] = clientSecret;
    return (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)(params).slice(1);
}
async function $1beeceac16d65c54$var$makeTokenRequest(sdk, { url: url, data: data, nonce: nonce, dpopKeyPair: dpopKeyPair }) {
    var _a, _b;
    const method = 'POST';
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded'
    };
    if (sdk.options.dpop) {
        if (!dpopKeyPair) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('DPoP is configured but no key pair was provided');
        const proof = await (0, $567efc7b9cd21385$export$5c0f49fa17cf96e6)({
            url: url,
            method: method,
            nonce: nonce,
            keyPair: dpopKeyPair
        });
        headers.DPoP = proof;
    }
    try {
        const resp = await (0, $b8f53662f6ac3919$export$46f383001bf60e04)(sdk, {
            url: url,
            method: method,
            args: data,
            headers: headers
        });
        return resp;
    } catch (err) {
        if ((0, $567efc7b9cd21385$export$283c6a56651b6b3)(err) && !nonce) {
            const dpopNonce = (_a = err.resp) === null || _a === void 0 ? void 0 : _a.headers['dpop-nonce'];
            if (!dpopNonce) throw new (0, $b7e782aa925a4626$export$2e2bcd8739ae039)({
                errorSummary: 'No `dpop-nonce` header found when required'
            }, (_b = err.resp) !== null && _b !== void 0 ? _b : undefined);
            return $1beeceac16d65c54$var$makeTokenRequest(sdk, {
                url: url,
                data: data,
                dpopKeyPair: dpopKeyPair,
                nonce: dpopNonce
            });
        }
        throw err;
    }
}
async function $1beeceac16d65c54$export$8c39800e8683fe3(sdk, options, urls) {
    $1beeceac16d65c54$var$validateOptions(options);
    var data = $1beeceac16d65c54$var$getPostData(sdk, options);
    const params = {
        url: urls.tokenUrl,
        data: data,
        dpopKeyPair: options === null || options === void 0 ? void 0 : options.dpopKeyPair
    };
    return $1beeceac16d65c54$var$makeTokenRequest(sdk, params);
}
async function $1beeceac16d65c54$export$be1491fbe5a1fece(sdk, options, refreshToken) {
    const data = Object.entries({
        client_id: options.clientId,
        grant_type: 'refresh_token',
        scope: refreshToken.scopes.join(' '),
        refresh_token: refreshToken.refreshToken
    }).map(function([name, value]) {
        return name + '=' + encodeURIComponent(value);
    }).join('&');
    let url = refreshToken.tokenUrl;
    if (options.extraParams && Object.keys(options.extraParams).length >= 1) url += (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)(options.extraParams);
    const params = {
        url: url,
        data: data,
        dpopKeyPair: options === null || options === void 0 ? void 0 : options.dpopKeyPair
    };
    return $1beeceac16d65c54$var$makeTokenRequest(sdk, params);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





parcelRequire("R5nvG");
function $ecd3120dfbbfc420$export$2d91ea80a5884e36(sdk, issuer) {
    var authServerUri = issuer || sdk.options.issuer;
    return (0, $b8f53662f6ac3919$export$3988ae62b71be9a3)(sdk, authServerUri + '/.well-known/openid-configuration', {
        cacheResponse: true
    });
}
function $ecd3120dfbbfc420$export$a47fb462a08de82f(sdk, issuer, kid) {
    var httpCache = sdk.storageManager.getHttpCache(sdk.options.cookies);
    return $ecd3120dfbbfc420$export$2d91ea80a5884e36(sdk, issuer).then(function(wellKnown) {
        var jwksUri = wellKnown['jwks_uri'];
        var cacheContents = httpCache.getStorage();
        var cachedResponse = cacheContents[jwksUri];
        if (cachedResponse && Date.now() / 1000 < cachedResponse.expiresAt) {
            var cachedKey = (0, $12f7cf89ebb788f9$export$71aa6c912b956294)(cachedResponse.response.keys, {
                kid: kid
            });
            if (cachedKey) return cachedKey;
        }
        httpCache.clearStorage(jwksUri);
        return (0, $b8f53662f6ac3919$export$3988ae62b71be9a3)(sdk, jwksUri, {
            cacheResponse: true
        }).then(function(res) {
            var key = (0, $12f7cf89ebb788f9$export$71aa6c912b956294)(res.keys, {
                kid: kid
            });
            if (key) return key;
            throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The key id, ' + kid + ', was not found in the server\'s keys');
        });
    });
}






/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $29c14c190cbdd4e3$export$d9ea6b8d907b5e9a(sdk, claims, validationParams) {
    const aud = validationParams.clientId;
    const iss = validationParams.issuer;
    const nonce = validationParams.nonce;
    const acr = validationParams.acrValues;
    if (!claims || !iss || !aud) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The jwt, iss, and aud arguments are all required');
    if (nonce && claims.nonce !== nonce) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('OAuth flow response nonce doesn\'t match request nonce');
    const now = Math.floor(Date.now() / 1000);
    if (claims.iss !== iss) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The issuer [' + claims.iss + '] ' + 'does not match [' + iss + ']');
    if (Array.isArray(claims.aud) && claims.aud.indexOf(aud) < 0 || !Array.isArray(claims.aud) && claims.aud !== aud) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The audience [' + claims.aud + '] ' + 'does not match [' + aud + ']');
    if (acr && claims.acr !== acr) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The acr [' + claims.acr + '] ' + 'does not match acr_values [' + acr + ']');
    if (claims.iat > claims.exp) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The JWT expired before it was issued');
    if (!sdk.options.ignoreLifetime) {
        if (now - sdk.options.maxClockSkew > claims.exp) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The JWT expired and is no longer valid');
        if (claims.iat > now + sdk.options.maxClockSkew) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The JWT was issued in the future');
    }
}




async function $fc14fe38bb03aa55$export$c807668e63e7354b(sdk, token, validationParams) {
    if (!token || !token.idToken) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Only idTokens may be verified');
    const jwt = (0, $9048550239ebf2b7$export$4b61618bdb99cb7e)(token.idToken);
    const configuredIssuer = (validationParams === null || validationParams === void 0 ? void 0 : validationParams.issuer) || sdk.options.issuer;
    const { issuer: issuer } = await (0, $ecd3120dfbbfc420$export$2d91ea80a5884e36)(sdk, configuredIssuer);
    const validationOptions = Object.assign({
        clientId: sdk.options.clientId,
        ignoreSignature: sdk.options.ignoreSignature
    }, validationParams, {
        issuer: issuer
    });
    (0, $29c14c190cbdd4e3$export$d9ea6b8d907b5e9a)(sdk, jwt.payload, validationOptions);
    if (validationOptions.ignoreSignature == true || !sdk.features.isTokenVerifySupported()) return token;
    const key = await (0, $ecd3120dfbbfc420$export$a47fb462a08de82f)(sdk, token.issuer, jwt.header.kid);
    const valid = await (0, $8498ea9d3e5853d4$export$c807668e63e7354b)(token.idToken, key);
    if (!valid) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The token signature is not valid');
    if (validationParams && validationParams.accessToken && token.claims.at_hash) {
        const hash = await (0, $2eaba61097ed4c7a$export$7186055aabeea565)(validationParams.accessToken);
        if (hash !== token.claims.at_hash) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Token hash verification failed');
    }
    return token;
}






parcelRequire("R5nvG");

function $dcb6bfba314e7995$var$validateResponse(res, oauthParams) {
    if (res['error'] && res['error_description']) throw new (0, $b17ce0de6fad00bb$export$2e2bcd8739ae039)(res['error'], res['error_description']);
    if (res.state !== oauthParams.state) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('OAuth flow response state doesn\'t match request state');
}
async function $dcb6bfba314e7995$export$8e4ec53b32974551(sdk, tokenParams, res, urls) {
    var _a, _b;
    const pkce = sdk.options.pkce !== false;
    if (pkce && (res.code || res.interaction_code)) return sdk.token.exchangeCodeForTokens(Object.assign({}, tokenParams, {
        authorizationCode: res.code,
        interactionCode: res.interaction_code
    }), urls);
    tokenParams = tokenParams || (0, $63643900107af5be$export$7b9316c0224bc208)(sdk);
    urls = urls || (0, $28694eacc5911f05$export$1a398a8b679ebb76)(sdk, tokenParams);
    let responseType = tokenParams.responseType || [];
    if (!Array.isArray(responseType) && responseType !== 'none') responseType = [
        responseType
    ];
    let scopes;
    if (res.scope) scopes = res.scope.split(' ');
    else scopes = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(tokenParams.scopes);
    const clientId = tokenParams.clientId || sdk.options.clientId;
    $dcb6bfba314e7995$var$validateResponse(res, tokenParams);
    if (tokenParams.dpop) {
        const { allowBearerTokens: allowBearerTokens } = (_b = (_a = sdk.options) === null || _a === void 0 ? void 0 : _a.dpopOptions) !== null && _b !== void 0 ? _b : {
            allowBearerTokens: false
        };
        if (!allowBearerTokens && res.token_type !== 'DPoP') throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to parse OAuth flow response: DPoP was configured but "token_type" was not DPoP');
    }
    const tokenDict = {};
    const expiresIn = res.expires_in;
    const tokenType = res.token_type;
    const accessToken = res.access_token;
    const idToken = res.id_token;
    const refreshToken = res.refresh_token;
    const now = Math.floor(Date.now() / 1000);
    if (accessToken) {
        const accessJwt = sdk.token.decode(accessToken);
        tokenDict.accessToken = {
            accessToken: accessToken,
            claims: accessJwt.payload,
            expiresAt: Number(expiresIn) + now,
            tokenType: tokenType,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            userinfoUrl: urls.userinfoUrl
        };
        if (tokenParams.dpopPairId) tokenDict.accessToken.dpopPairId = tokenParams.dpopPairId;
        if (tokenParams.extraParams) tokenDict.accessToken.extraParams = tokenParams.extraParams;
    }
    if (refreshToken) {
        tokenDict.refreshToken = {
            refreshToken: refreshToken,
            expiresAt: Number(expiresIn) + now,
            scopes: scopes,
            tokenUrl: urls.tokenUrl,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer
        };
        if (tokenParams.dpopPairId) tokenDict.refreshToken.dpopPairId = tokenParams.dpopPairId;
        if (tokenParams.extraParams) tokenDict.refreshToken.extraParams = tokenParams.extraParams;
    }
    if (idToken) {
        const idJwt = sdk.token.decode(idToken);
        const idTokenObj = {
            idToken: idToken,
            claims: idJwt.payload,
            expiresAt: idJwt.payload.exp - idJwt.payload.iat + now,
            scopes: scopes,
            authorizeUrl: urls.authorizeUrl,
            issuer: urls.issuer,
            clientId: clientId
        };
        if (tokenParams.extraParams) idTokenObj.extraParams = tokenParams.extraParams;
        const validationParams = {
            clientId: clientId,
            issuer: urls.issuer,
            nonce: tokenParams.nonce,
            accessToken: accessToken,
            acrValues: tokenParams.acrValues
        };
        if (tokenParams.ignoreSignature !== undefined) validationParams.ignoreSignature = tokenParams.ignoreSignature;
        await (0, $fc14fe38bb03aa55$export$c807668e63e7354b)(sdk, idTokenObj, validationParams);
        tokenDict.idToken = idTokenObj;
    }
    if (responseType.indexOf('token') !== -1 && !tokenDict.accessToken) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
    if (responseType.indexOf('id_token') !== -1 && !tokenDict.idToken) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
    return {
        tokens: tokenDict,
        state: res.state,
        code: res.code,
        responseType: responseType
    };
}



async function $764e1439617c040b$export$b0d0dc26369c3965(sdk, tokenParams, urls) {
    urls = urls || (0, $28694eacc5911f05$export$1a398a8b679ebb76)(sdk, tokenParams);
    tokenParams = Object.assign({}, (0, $63643900107af5be$export$7b9316c0224bc208)(sdk), (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(tokenParams));
    const { authorizationCode: authorizationCode, interactionCode: interactionCode, codeVerifier: codeVerifier, clientId: clientId, redirectUri: redirectUri, scopes: scopes, ignoreSignature: ignoreSignature, state: state, acrValues: acrValues, dpop: dpop, dpopPairId: dpopPairId, extraParams: extraParams } = tokenParams;
    const getTokenOptions = {
        clientId: clientId,
        redirectUri: redirectUri,
        authorizationCode: authorizationCode,
        interactionCode: interactionCode,
        codeVerifier: codeVerifier,
        dpop: dpop
    };
    const responseType = [
        'token'
    ];
    if (scopes.indexOf('openid') !== -1) responseType.push('id_token');
    const handleResponseOptions = {
        clientId: clientId,
        redirectUri: redirectUri,
        scopes: scopes,
        responseType: responseType,
        ignoreSignature: ignoreSignature,
        acrValues: acrValues,
        extraParams: extraParams
    };
    try {
        if (dpop) {
            if (dpopPairId) {
                const keyPair = await (0, $567efc7b9cd21385$export$846293577e1b1366)(dpopPairId);
                getTokenOptions.dpopKeyPair = keyPair;
                handleResponseOptions.dpop = dpop;
                handleResponseOptions.dpopPairId = dpopPairId;
            } else {
                const { keyPair: keyPair, keyPairId: keyPairId } = await (0, $567efc7b9cd21385$export$791e6660a495fff2)();
                getTokenOptions.dpopKeyPair = keyPair;
                handleResponseOptions.dpop = dpop;
                handleResponseOptions.dpopPairId = keyPairId;
            }
        }
        const oauthResponse = await (0, $1beeceac16d65c54$export$8c39800e8683fe3)(sdk, getTokenOptions, urls);
        const tokenResponse = await (0, $dcb6bfba314e7995$export$8e4ec53b32974551)(sdk, handleResponseOptions, oauthResponse, urls);
        tokenResponse.code = authorizationCode;
        tokenResponse.state = state;
        return tokenResponse;
    } finally{
        sdk.transactionManager.clear();
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 






parcelRequire("R5nvG");

async function $555915b9bb1a98b7$export$801fe16824f675f7(sdk, accessTokenObject, idTokenObject) {
    if (!accessTokenObject) accessTokenObject = (await sdk.tokenManager.getTokens()).accessToken;
    if (!idTokenObject) idTokenObject = (await sdk.tokenManager.getTokens()).idToken;
    if (!accessTokenObject || !(0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(accessTokenObject)) return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('getUserInfo requires an access token object'));
    if (!idTokenObject || !(0, $1728265dc3c1bbda$export$e183da9b0d22b235)(idTokenObject)) return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('getUserInfo requires an ID token object'));
    const options = {
        url: accessTokenObject.userinfoUrl,
        method: 'GET',
        accessToken: accessTokenObject.accessToken
    };
    if (sdk.options.dpop) {
        const headers = await sdk.getDPoPAuthorizationHeaders(Object.assign(Object.assign({}, options), {
            accessToken: accessTokenObject
        }));
        options.headers = headers;
        delete options.accessToken;
    }
    return (0, $b8f53662f6ac3919$export$46f383001bf60e04)(sdk, options).then((userInfo)=>{
        if (userInfo.sub === idTokenObject.claims.sub) return userInfo;
        return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('getUserInfo request was rejected due to token mismatch'));
    }).catch(function(err) {
        var _a;
        if (err instanceof (0, $d28aec32d9343bab$export$2e2bcd8739ae039) && !sdk.options.dpop) {
            const { error: error, errorDescription: errorDescription } = err;
            throw new (0, $b17ce0de6fad00bb$export$2e2bcd8739ae039)(error, errorDescription);
        }
        if (!sdk.options.dpop) {
            let e = err;
            if (err instanceof (0, $b7e782aa925a4626$export$2e2bcd8739ae039) && ((_a = err === null || err === void 0 ? void 0 : err.meta) === null || _a === void 0 ? void 0 : _a.wwwAuthHeader)) e = (0, $d28aec32d9343bab$export$2e2bcd8739ae039).parseHeader(err.meta.wwwAuthHeader);
            if (e instanceof (0, $d28aec32d9343bab$export$2e2bcd8739ae039)) {
                const { error: error, errorDescription: errorDescription } = e;
                throw new (0, $b17ce0de6fad00bb$export$2e2bcd8739ae039)(error, errorDescription);
            }
        }
        throw err;
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

const $66c790c4f771c9c9$var$DEFAULT_TIMEOUT = 120000;
function $66c790c4f771c9c9$export$f03a6b845d3fb58b(eventTarget, name, fn) {
    if (eventTarget.addEventListener) eventTarget.addEventListener(name, fn);
    else eventTarget.attachEvent('on' + name, fn);
}
function $66c790c4f771c9c9$export$b03e9483f936dccb(eventTarget, name, fn) {
    if (eventTarget.removeEventListener) eventTarget.removeEventListener(name, fn);
    else eventTarget.detachEvent('on' + name, fn);
}
function $66c790c4f771c9c9$export$ce24fe47d96d8eb0(src) {
    var iframe = document.createElement('iframe');
    iframe.style.display = 'none';
    iframe.src = src;
    return document.body.appendChild(iframe);
}
function $66c790c4f771c9c9$export$2e9eedb5256b66f6(src, options) {
    var title = options.popupTitle || 'External Identity Provider User Authentication';
    var appearance = "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600";
    return window.open(src, title, appearance);
}
function $66c790c4f771c9c9$export$ecdcd46aa04cd83(sdk, timeout, state) {
    var responseHandler;
    var timeoutId;
    var msgReceivedOrTimeout = new Promise(function(resolve, reject) {
        responseHandler = function responseHandler(e) {
            if (!e.data || e.data.state !== state) return;
            if (e.origin !== sdk.getIssuerOrigin()) return reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The request does not match client configuration'));
            resolve(e.data);
        };
        $66c790c4f771c9c9$export$f03a6b845d3fb58b(window, 'message', responseHandler);
        timeoutId = setTimeout(function() {
            reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('OAuth flow timed out'));
        }, timeout || $66c790c4f771c9c9$var$DEFAULT_TIMEOUT);
    });
    return msgReceivedOrTimeout.finally(function() {
        clearTimeout(timeoutId);
        $66c790c4f771c9c9$export$b03e9483f936dccb(window, 'message', responseHandler);
    });
}
function $66c790c4f771c9c9$export$ad7c836560b19da9(sdk, timeout, channel, state) {
    let timeoutId;
    const promise = new Promise((resolve, reject)=>{
        channel.onmessage = (event)=>{
            if (!event.isTrusted || !event.data) return;
            if (typeof event.data === 'object' && state === event.data.state) return resolve(Object.assign({}, event.data));
            reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to complete auth code exchange'));
        };
        timeoutId = setTimeout(function() {
            reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('OAuth flow timed out'));
        }, timeout || $66c790c4f771c9c9$var$DEFAULT_TIMEOUT);
    });
    return promise.finally(()=>{
        clearTimeout(timeoutId);
        channel.close();
    });
}





/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





function $400c3bc75835f4ee$export$4026c5574adb7ca7(sdk) {
    if (!sdk.features.isPKCESupported()) {
        var errorMessage = 'PKCE requires a modern browser with encryption support running in a secure context.';
        if (!sdk.features.isHTTPS()) errorMessage += '\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol.';
        if (!sdk.features.hasTextEncoder()) errorMessage += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.';
        throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)(errorMessage);
    }
}
async function $400c3bc75835f4ee$export$64f0d9bafa89e3eb(sdk, codeChallengeMethod) {
    codeChallengeMethod = codeChallengeMethod || sdk.options.codeChallengeMethod || (0, $2119f0a66eb38a81$export$ed9a92f7e3f906d8);
    const wellKnownResponse = await (0, $ecd3120dfbbfc420$export$2d91ea80a5884e36)(sdk);
    var methods = wellKnownResponse['code_challenge_methods_supported'] || [];
    if (methods.indexOf(codeChallengeMethod) === -1) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Invalid code_challenge_method');
    return codeChallengeMethod;
}
async function $400c3bc75835f4ee$export$12649ebf497694d5(sdk, tokenParams) {
    let { codeVerifier: codeVerifier, codeChallenge: codeChallenge, codeChallengeMethod: codeChallengeMethod } = tokenParams;
    codeChallenge = codeChallenge || sdk.options.codeChallenge;
    if (!codeChallenge) {
        $400c3bc75835f4ee$export$4026c5574adb7ca7(sdk);
        codeVerifier = codeVerifier || (0, $0d1779c11b1d7a45$export$2e2bcd8739ae039).generateVerifier();
        codeChallenge = await (0, $0d1779c11b1d7a45$export$2e2bcd8739ae039).computeChallenge(codeVerifier);
    }
    codeChallengeMethod = await $400c3bc75835f4ee$export$64f0d9bafa89e3eb(sdk, codeChallengeMethod);
    tokenParams = Object.assign(Object.assign({}, tokenParams), {
        responseType: 'code',
        codeVerifier: codeVerifier,
        codeChallenge: codeChallenge,
        codeChallengeMethod: codeChallengeMethod
    });
    return tokenParams;
}
async function $400c3bc75835f4ee$export$6aa55a8b4ad50d4b(sdk, tokenParams = {}) {
    const defaults = (0, $63643900107af5be$export$7b9316c0224bc208)(sdk);
    tokenParams = Object.assign(Object.assign({}, defaults), tokenParams);
    if (tokenParams.dpop && !sdk.features.isDPoPSupported()) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('DPoP has been configured, but is not supported by browser');
    if (tokenParams.pkce === false) return tokenParams;
    return $400c3bc75835f4ee$export$12649ebf497694d5(sdk, tokenParams);
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




function $8d4c557d4d778c65$export$8f846dfe2e3e1886(tokenParams) {
    if (!tokenParams.clientId) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to get a token');
    if ((0, $307f2ba6550d7c99$export$844ec244b1367d54)(tokenParams.responseType) && tokenParams.responseType.indexOf(' ') !== -1) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Multiple OAuth responseTypes must be defined as an array');
    var oauthParams = {
        'client_id': tokenParams.clientId,
        'code_challenge': tokenParams.codeChallenge,
        'code_challenge_method': tokenParams.codeChallengeMethod,
        'display': tokenParams.display,
        'idp': tokenParams.idp,
        'idp_scope': tokenParams.idpScope,
        'login_hint': tokenParams.loginHint,
        'max_age': tokenParams.maxAge,
        'nonce': tokenParams.nonce,
        'prompt': tokenParams.prompt,
        'redirect_uri': tokenParams.redirectUri,
        'response_mode': tokenParams.responseMode,
        'response_type': tokenParams.responseType,
        'sessionToken': tokenParams.sessionToken,
        'state': tokenParams.state,
        'acr_values': tokenParams.acrValues,
        'enroll_amr_values': tokenParams.enrollAmrValues
    };
    oauthParams = (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)(oauthParams);
    [
        'idp_scope',
        'response_type',
        'enroll_amr_values'
    ].forEach(function(mayBeArray) {
        if (Array.isArray(oauthParams[mayBeArray])) oauthParams[mayBeArray] = oauthParams[mayBeArray].join(' ');
    });
    if (tokenParams.responseType.indexOf('id_token') !== -1 && tokenParams.scopes.indexOf('openid') === -1) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('openid scope must be specified in the scopes argument when requesting an id_token');
    else if (tokenParams.scopes) oauthParams.scope = tokenParams.scopes.join(' ');
    return oauthParams;
}
function $8d4c557d4d778c65$export$bee25a1283797bf6(tokenParams) {
    var oauthQueryParams = $8d4c557d4d778c65$export$8f846dfe2e3e1886(tokenParams);
    return (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)(Object.assign(Object.assign({}, oauthQueryParams), tokenParams.extraParams && Object.assign({}, tokenParams.extraParams)));
}



function $fd1ab2d8a068b4f2$export$257b2d10b709d8ef(sdk, options) {
    if (arguments.length > 2) return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('As of version 3.0, "getToken" takes only a single set of options'));
    options = options || {};
    const popupWindow = options.popupWindow;
    options.popupWindow = undefined;
    return (0, $400c3bc75835f4ee$export$6aa55a8b4ad50d4b)(sdk, options).then(function(tokenParams) {
        var sessionTokenOverrides = {
            prompt: 'none',
            responseMode: 'okta_post_message',
            display: null
        };
        var idpOverrides = {
            display: 'popup'
        };
        if (options.sessionToken) Object.assign(tokenParams, sessionTokenOverrides);
        else if (options.idp) Object.assign(tokenParams, idpOverrides);
        var requestUrl, endpoint, urls;
        urls = (0, $28694eacc5911f05$export$1a398a8b679ebb76)(sdk, tokenParams);
        endpoint = options.codeVerifier ? urls.tokenUrl : urls.authorizeUrl;
        requestUrl = endpoint + (0, $8d4c557d4d778c65$export$bee25a1283797bf6)(tokenParams);
        var flowType = 'IMPLICIT';
        if (tokenParams.sessionToken || tokenParams.display === null) flowType = 'IFRAME';
        else if (tokenParams.display === 'popup') flowType = options.idpPopup ? 'IDP_POPUP' : 'POPUP';
        else flowType = 'IMPLICIT';
        switch(flowType){
            case 'IFRAME':
                var iframePromise = (0, $66c790c4f771c9c9$export$ecdcd46aa04cd83)(sdk, options.timeout, tokenParams.state);
                var iframeEl = (0, $66c790c4f771c9c9$export$ce24fe47d96d8eb0)(requestUrl);
                return iframePromise.then(function(res) {
                    return (0, $dcb6bfba314e7995$export$8e4ec53b32974551)(sdk, tokenParams, res, urls);
                }).finally(function() {
                    var _a;
                    if (document.body.contains(iframeEl)) (_a = iframeEl.parentElement) === null || _a === void 0 || _a.removeChild(iframeEl);
                });
            case 'POPUP':
                var oauthPromise;
                if (tokenParams.responseMode === 'okta_post_message') {
                    if (!sdk.features.isPopupPostMessageSupported()) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('This browser doesn\'t have full postMessage support');
                    oauthPromise = (0, $66c790c4f771c9c9$export$ecdcd46aa04cd83)(sdk, options.timeout, tokenParams.state);
                }
                if (popupWindow) popupWindow.location.assign(requestUrl);
                var popupPromise = new Promise(function(resolve, reject) {
                    var closePoller = setInterval(function() {
                        if (!popupWindow || popupWindow.closed) {
                            clearInterval(closePoller);
                            reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to parse OAuth flow response'));
                        }
                    }, 100);
                    oauthPromise.then(function(res) {
                        clearInterval(closePoller);
                        resolve(res);
                    }).catch(function(err) {
                        clearInterval(closePoller);
                        reject(err);
                    });
                });
                return popupPromise.then(function(res) {
                    return (0, $dcb6bfba314e7995$export$8e4ec53b32974551)(sdk, tokenParams, res, urls);
                }).finally(function() {
                    if (popupWindow && !popupWindow.closed) popupWindow.close();
                });
            case 'IDP_POPUP':
                var idpPromise = (0, $66c790c4f771c9c9$export$ad7c836560b19da9)(sdk, options.timeout, options.channel, tokenParams.state);
                if (popupWindow) popupWindow.location.assign(requestUrl);
                else throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to open popup window');
                return idpPromise.then(function(res) {
                    return (0, $dcb6bfba314e7995$export$8e4ec53b32974551)(sdk, tokenParams, res, urls);
                });
            default:
                throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The full page redirect flow is not supported');
        }
    });
}


function $c8eb628ee275e679$export$86fab758b5485bc6(sdk, options) {
    if (arguments.length > 2) return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('As of version 3.0, "getWithoutPrompt" takes only a single set of options'));
    options = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(options) || {};
    Object.assign(options, {
        prompt: 'none',
        responseMode: 'okta_post_message',
        display: null
    });
    return (0, $fd1ab2d8a068b4f2$export$257b2d10b709d8ef)(sdk, options);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 









parcelRequire("R5nvG");

function $09a364aa9120ddec$export$20ffac22eb7d93bb(sdk, options) {
    if (arguments.length > 2) return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('As of version 3.0, "getWithPopup" takes only a single set of options'));
    const { initialPath: initialPath } = options, params = (0, $ca95e6f9e1ec9f80$export$3c9a16f847548506)(options, [
        "initialPath"
    ]);
    const popupWindow = (0, $66c790c4f771c9c9$export$2e9eedb5256b66f6)(initialPath !== null && initialPath !== void 0 ? initialPath : '/', params);
    options = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(params) || {};
    Object.assign(params, {
        display: 'popup',
        responseMode: 'okta_post_message',
        popupWindow: popupWindow
    });
    return (0, $fd1ab2d8a068b4f2$export$257b2d10b709d8ef)(sdk, params);
}
function $09a364aa9120ddec$export$cb67fa6698dae00e(sdk, options) {
    try {
        if (!BroadcastChannel) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Modern browser with `BroadcastChannel` support is required to use this method');
        if (!options.redirectUri) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('`redirectUri` is a required param for `getWithIDPPopup`');
        if (!options.state) options.state = (0, $28694eacc5911f05$export$9ccd2716e53a229b)();
        const popupWindow = (0, $66c790c4f771c9c9$export$2e9eedb5256b66f6)('/', options);
        const channel = new BroadcastChannel(`popup-callback:${options.state}`);
        options = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(options) || {};
        Object.assign(options, {
            display: 'popup',
            responseMode: 'query',
            popupWindow: popupWindow,
            idpPopup: true,
            channel: channel
        });
        let cancelPromise;
        const promise = new Promise((resolve, reject)=>{
            cancelPromise = reject;
            return (0, $fd1ab2d8a068b4f2$export$257b2d10b709d8ef)(sdk, options).then((res)=>resolve(res)).catch((err)=>reject(err));
        });
        const cancel = ()=>{
            channel.close();
            cancelPromise(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Popup flow canceled'));
        };
        return {
            promise: promise,
            cancel: cancel
        };
    } catch (err) {
        return {
            promise: Promise.reject(err),
            cancel: ()=>{}
        };
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 






async function $3532f2a6875d2eab$export$79d5ce5cae1648a2(sdk, options) {
    if (arguments.length > 2) return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('As of version 3.0, "getWithRedirect" takes only a single set of options'));
    options = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(options) || {};
    const tokenParams = await (0, $400c3bc75835f4ee$export$6aa55a8b4ad50d4b)(sdk, options);
    const meta = (0, $487672a81f8ed323$export$6fd737cbc709c406)(sdk, tokenParams);
    const requestUrl = meta.urls.authorizeUrl + (0, $8d4c557d4d778c65$export$bee25a1283797bf6)(tokenParams);
    sdk.transactionManager.save(meta);
    if (sdk.options.setLocation) sdk.options.setLocation(requestUrl);
    else window.location.assign(requestUrl);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 






parcelRequire("R5nvG");



function $ad10c9d1d686a8d3$var$removeHash(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.search);
    else nativeLoc.hash = '';
}
function $ad10c9d1d686a8d3$var$removeSearch(sdk) {
    var nativeHistory = sdk.token.parseFromUrl._getHistory();
    var nativeDoc = sdk.token.parseFromUrl._getDocument();
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    if (nativeHistory && nativeHistory.replaceState) nativeHistory.replaceState(null, nativeDoc.title, nativeLoc.pathname + nativeLoc.hash);
    else nativeLoc.search = '';
}
function $ad10c9d1d686a8d3$export$be434a300f162664(sdk) {
    var defaultResponseMode = sdk.options.pkce ? 'query' : 'fragment';
    var responseMode = sdk.options.responseMode || defaultResponseMode;
    return responseMode;
}
function $ad10c9d1d686a8d3$export$3cd68b6fe191e121(sdk, options) {
    options = options || {};
    if ((0, $307f2ba6550d7c99$export$844ec244b1367d54)(options)) options = {
        url: options
    };
    else options;
    var url = options.url;
    var responseMode = options.responseMode || $ad10c9d1d686a8d3$export$be434a300f162664(sdk);
    var nativeLoc = sdk.token.parseFromUrl._getLocation();
    var paramStr;
    if (responseMode === 'query') paramStr = url ? url.substring(url.indexOf('?')) : nativeLoc.search;
    else paramStr = url ? url.substring(url.indexOf('#')) : nativeLoc.hash;
    if (!paramStr) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to parse a token from the url');
    return (0, $0ae2b8f64cf51c69$export$b4dca17ba2d0280)(paramStr);
}
function $ad10c9d1d686a8d3$export$8d34907d21770eb0(sdk, options) {
    const responseMode = options.responseMode || $ad10c9d1d686a8d3$export$be434a300f162664(sdk);
    responseMode === 'query' ? $ad10c9d1d686a8d3$var$removeSearch(sdk) : $ad10c9d1d686a8d3$var$removeHash(sdk);
}
async function $ad10c9d1d686a8d3$export$519dd9458d58afc6(sdk, options) {
    options = options || {};
    if ((0, $307f2ba6550d7c99$export$844ec244b1367d54)(options)) options = {
        url: options
    };
    else options;
    const res = $ad10c9d1d686a8d3$export$3cd68b6fe191e121(sdk, options);
    const state = res.state;
    const oauthParams = sdk.transactionManager.load({
        state: state
    });
    if (!oauthParams) {
        if (sdk.options.pkce) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.', undefined);
        throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to retrieve OAuth redirect params from storage');
    }
    const urls = oauthParams.urls;
    delete oauthParams.urls;
    if (!options.url) $ad10c9d1d686a8d3$export$8d34907d21770eb0(sdk, options);
    return (0, $dcb6bfba314e7995$export$8e4ec53b32974551)(sdk, oauthParams, res, urls).catch((err)=>{
        if (!(0, $f5378b90fb42f11e$export$376c3c4c19cb933a)(err)) sdk.transactionManager.clear({
            state: state
        });
        throw err;
    }).then((res)=>{
        sdk.transactionManager.clear({
            state: state
        });
        return res;
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $312a83bacfbd4983$export$6b33887d89873bf(a, b) {
    return a.refreshToken === b.refreshToken;
}
function $312a83bacfbd4983$export$d61273b9c30fe75d(err) {
    if (!(0, $00075bbb69b7d8b4$export$4fe744aeb810d543)(err)) return false;
    if (!err.xhr || !err.xhr.responseJSON) return false;
    const { responseJSON: responseJSON } = err.xhr;
    if (responseJSON.error === 'invalid_grant') return true;
    return false;
}






async function $9d42f44a69c9b47a$export$baff7bee392261c2(sdk, tokenParams, refreshTokenObject) {
    const { clientId: clientId, dpop: dpop } = sdk.options;
    if (!clientId) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to renew tokens');
    try {
        const renewTokenParams = Object.assign({}, tokenParams, {
            clientId: clientId
        });
        if (refreshTokenObject.extraParams) renewTokenParams.extraParams = refreshTokenObject.extraParams;
        const endpointParams = Object.assign({}, renewTokenParams);
        if (dpop) {
            const keyPair = await (0, $567efc7b9cd21385$export$846293577e1b1366)(refreshTokenObject === null || refreshTokenObject === void 0 ? void 0 : refreshTokenObject.dpopPairId);
            endpointParams.dpopKeyPair = keyPair;
            renewTokenParams.dpop = dpop;
            renewTokenParams.dpopPairId = refreshTokenObject.dpopPairId;
        }
        const tokenResponse = await (0, $1beeceac16d65c54$export$be1491fbe5a1fece)(sdk, endpointParams, refreshTokenObject);
        const urls = (0, $28694eacc5911f05$export$1a398a8b679ebb76)(sdk, tokenParams);
        const { tokens: tokens } = await (0, $dcb6bfba314e7995$export$8e4ec53b32974551)(sdk, renewTokenParams, tokenResponse, urls);
        const { refreshToken: refreshToken } = tokens;
        if (refreshToken && !(0, $312a83bacfbd4983$export$6b33887d89873bf)(refreshToken, refreshTokenObject)) sdk.tokenManager.updateRefreshToken(refreshToken);
        return tokens;
    } catch (err) {
        if ((0, $f5378b90fb42f11e$export$759948024dbf620d)(err)) sdk.tokenManager.removeRefreshToken();
        throw err;
    }
}


function $edbc6a4ca5c614c9$var$throwInvalidTokenError() {
    throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Renew must be passed a token with an array of scopes and an accessToken or idToken');
}
function $edbc6a4ca5c614c9$var$getSingleToken(originalToken, tokens) {
    if ((0, $1728265dc3c1bbda$export$e183da9b0d22b235)(originalToken)) return tokens.idToken;
    if ((0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(originalToken)) return tokens.accessToken;
    $edbc6a4ca5c614c9$var$throwInvalidTokenError();
}
async function $edbc6a4ca5c614c9$export$9eb5d800a6b02c7(sdk, token) {
    if (!(0, $1728265dc3c1bbda$export$e183da9b0d22b235)(token) && !(0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(token)) $edbc6a4ca5c614c9$var$throwInvalidTokenError();
    let tokens = sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) {
        tokens = await (0, $9d42f44a69c9b47a$export$baff7bee392261c2)(sdk, {
            scopes: token.scopes
        }, tokens.refreshToken);
        return $edbc6a4ca5c614c9$var$getSingleToken(token, tokens);
    }
    var responseType;
    if (sdk.options.pkce) responseType = 'code';
    else if ((0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(token)) responseType = 'token';
    else responseType = 'id_token';
    const { scopes: scopes, authorizeUrl: authorizeUrl, userinfoUrl: userinfoUrl, issuer: issuer, dpopPairId: dpopPairId, extraParams: extraParams } = token;
    return (0, $c8eb628ee275e679$export$86fab758b5485bc6)(sdk, {
        responseType: responseType,
        scopes: scopes,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        issuer: issuer,
        dpopPairId: dpopPairId,
        extraParams: extraParams
    }).then(function(res) {
        return $edbc6a4ca5c614c9$var$getSingleToken(token, res.tokens);
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







parcelRequire("R5nvG");

async function $56ceabace777f552$export$55c3ad1b2cc96723(sdk, options) {
    var _a;
    const tokens = (_a = options === null || options === void 0 ? void 0 : options.tokens) !== null && _a !== void 0 ? _a : sdk.tokenManager.getTokensSync();
    if (tokens.refreshToken) return (0, $9d42f44a69c9b47a$export$baff7bee392261c2)(sdk, options || {}, tokens.refreshToken);
    if (!tokens.accessToken && !tokens.idToken) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('renewTokens() was called but there is no existing token');
    const accessToken = tokens.accessToken || {};
    const idToken = tokens.idToken || {};
    const scopes = accessToken.scopes || idToken.scopes;
    if (!scopes) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('renewTokens: invalid tokens: could not read scopes');
    const authorizeUrl = accessToken.authorizeUrl || idToken.authorizeUrl;
    if (!authorizeUrl) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('renewTokens: invalid tokens: could not read authorizeUrl');
    const userinfoUrl = accessToken.userinfoUrl || sdk.options.userinfoUrl;
    const issuer = idToken.issuer || sdk.options.issuer;
    const dpopPairId = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId;
    const extraParams = (accessToken === null || accessToken === void 0 ? void 0 : accessToken.extraParams) || (idToken === null || idToken === void 0 ? void 0 : idToken.extraParams);
    options = Object.assign({
        scopes: scopes,
        authorizeUrl: authorizeUrl,
        userinfoUrl: userinfoUrl,
        issuer: issuer,
        dpopPairId: dpopPairId,
        extraParams: extraParams
    }, options);
    if (sdk.options.pkce) options.responseType = 'code';
    else {
        const { responseType: responseType } = (0, $63643900107af5be$export$7b9316c0224bc208)(sdk);
        options.responseType = responseType;
    }
    return (0, $c8eb628ee275e679$export$86fab758b5485bc6)(sdk, options).then((res)=>res.tokens);
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 






parcelRequire("R5nvG");

async function $031a290ee9c727f8$export$2428f6ba65615593(sdk, token) {
    let accessToken = '';
    let refreshToken = '';
    if (token) {
        accessToken = token.accessToken;
        refreshToken = token.refreshToken;
    }
    if (!accessToken && !refreshToken) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('A valid access or refresh token object is required');
    var clientId = sdk.options.clientId;
    var clientSecret = sdk.options.clientSecret;
    if (!clientId) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to revoke a token');
    var revokeUrl = (0, $28694eacc5911f05$export$1a398a8b679ebb76)(sdk).revokeUrl;
    var args = (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)({
        token_type_hint: refreshToken ? 'refresh_token' : 'access_token',
        token: refreshToken || accessToken
    }).slice(1);
    var creds = clientSecret ? (0, $a8d4082f60e792f5$export$a32219e24f8d1e2)(`${clientId}:${clientSecret}`) : (0, $a8d4082f60e792f5$export$a32219e24f8d1e2)(clientId);
    return (0, $b8f53662f6ac3919$export$299ba2dee77727e9)(sdk, revokeUrl, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic ' + creds
        }
    });
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







parcelRequire("R5nvG");

const $73a947a1cd6f9db3$var$hintMap = {
    accessToken: 'access_token',
    idToken: 'id_token',
    refreshToken: 'refresh_token'
};
async function $73a947a1cd6f9db3$export$bb69de165ef829cf(sdk, kind, token) {
    var _a;
    let issuer;
    let clientId = sdk.options.clientId;
    let clientSecret = sdk.options.clientSecret;
    if (!token) token = sdk.tokenManager.getTokens()[kind];
    if (!token) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)(`unable to find ${kind} in storage or fn params`);
    if (kind !== (0, $1728265dc3c1bbda$export$8b9d26ab11394711).ACCESS) issuer = token === null || token === void 0 ? void 0 : token.issuer;
    else issuer = (_a = token === null || token === void 0 ? void 0 : token.claims) === null || _a === void 0 ? void 0 : _a.iss;
    issuer = issuer || sdk.options.issuer;
    if (!clientId) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('A clientId must be specified in the OktaAuth constructor to introspect a token');
    if (!issuer) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to find issuer');
    const { introspection_endpoint: introspectUrl } = await (0, $ecd3120dfbbfc420$export$2d91ea80a5884e36)(sdk, issuer);
    const authHeader = clientSecret ? (0, $a8d4082f60e792f5$export$a32219e24f8d1e2)(`${clientId}:${clientSecret}`) : (0, $a8d4082f60e792f5$export$a32219e24f8d1e2)(clientId);
    const args = (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)({
        token_type_hint: $73a947a1cd6f9db3$var$hintMap[kind],
        token: token[kind]
    }).slice(1);
    return (0, $b8f53662f6ac3919$export$299ba2dee77727e9)(sdk, introspectUrl, args, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': 'Basic ' + authHeader
        }
    });
}







/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
function $dd9ddc7cc1f5a80b$export$a6906103e688e7c4(sdk, params) {
    const issuer = sdk.options.issuer;
    const urls = (0, $28694eacc5911f05$export$1a398a8b679ebb76)(sdk, params);
    const oauthMeta = {
        issuer: issuer,
        urls: urls,
        clientId: params.clientId,
        redirectUri: params.redirectUri,
        responseType: params.responseType,
        responseMode: params.responseMode,
        state: params.state,
        acrValues: params.acrValues,
        enrollAmrValues: params.enrollAmrValues
    };
    return oauthMeta;
}





parcelRequire("R5nvG");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $4112c38dc45a857c$export$3925a584390f92ef(sdk) {
    const { clientId: clientId, redirectUri: redirectUri, responseMode: responseMode, state: state } = sdk.options;
    const defaultRedirectUri = (0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)() ? window.location.href : undefined;
    return (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)({
        clientId: clientId,
        redirectUri: redirectUri || defaultRedirectUri,
        responseMode: responseMode,
        state: state || (0, $28694eacc5911f05$export$9ccd2716e53a229b)(),
        responseType: 'none',
        prompt: 'enroll_authenticator'
    });
}


function $be96b4b4875d69e6$var$prepareParams(params) {
    params = Object.assign(Object.assign({}, params), {
        responseType: 'none',
        prompt: 'enroll_authenticator',
        maxAge: 0
    });
    if (!params.enrollAmrValues) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('enroll_amr_values must be specified');
    if (!params.acrValues) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('acr_values must be specified');
    delete params.scopes;
    delete params.nonce;
    return params;
}
function $be96b4b4875d69e6$export$a510a85512435dc5(sdk, options) {
    return $be96b4b4875d69e6$var$prepareParams(Object.assign(Object.assign({}, (0, $4112c38dc45a857c$export$3925a584390f92ef)(sdk)), options));
}




function $edae77cdf27d5ed4$export$9f57def5b7ea6999(sdk, options) {
    options = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(options) || {};
    const params = (0, $be96b4b4875d69e6$export$a510a85512435dc5)(sdk, options);
    const meta = (0, $dd9ddc7cc1f5a80b$export$a6906103e688e7c4)(sdk, params);
    const requestUrl = meta.urls.authorizeUrl + (0, $8d4c557d4d778c65$export$bee25a1283797bf6)(params);
    sdk.transactionManager.save(meta);
    if (sdk.options.setLocation) sdk.options.setLocation(requestUrl);
    else window.location.assign(requestUrl);
}


function $e432a4f0f177e2ec$export$bd3db6d56a375929(sdk, queue) {
    const useQueue = (method)=>{
        return (0, $aa5cb4c154f96734$export$7ab95d2dbda3c98c).prototype.push.bind(queue, method, null);
    };
    const getWithRedirectFn = useQueue((0, $3532f2a6875d2eab$export$79d5ce5cae1648a2).bind(null, sdk));
    const parseFromUrlFn = useQueue((0, $ad10c9d1d686a8d3$export$519dd9458d58afc6).bind(null, sdk));
    const parseFromUrlApi = Object.assign(parseFromUrlFn, {
        _getHistory: function() {
            return window.history;
        },
        _getLocation: function() {
            return window.location;
        },
        _getDocument: function() {
            return window.document;
        }
    });
    const token = {
        prepareTokenParams: (0, $400c3bc75835f4ee$export$6aa55a8b4ad50d4b).bind(null, sdk),
        exchangeCodeForTokens: (0, $764e1439617c040b$export$b0d0dc26369c3965).bind(null, sdk),
        getWithoutPrompt: (0, $c8eb628ee275e679$export$86fab758b5485bc6).bind(null, sdk),
        getWithPopup: (0, $09a364aa9120ddec$export$20ffac22eb7d93bb).bind(null, sdk),
        getWithIDPPopup: (0, $09a364aa9120ddec$export$cb67fa6698dae00e).bind(null, sdk),
        getWithRedirect: getWithRedirectFn,
        parseFromUrl: parseFromUrlApi,
        decode: (0, $9048550239ebf2b7$export$4b61618bdb99cb7e),
        revoke: (0, $031a290ee9c727f8$export$2428f6ba65615593).bind(null, sdk),
        renew: (0, $edbc6a4ca5c614c9$export$9eb5d800a6b02c7).bind(null, sdk),
        renewTokensWithRefresh: (0, $9d42f44a69c9b47a$export$baff7bee392261c2).bind(null, sdk),
        renewTokens: (0, $56ceabace777f552$export$55c3ad1b2cc96723).bind(null, sdk),
        getUserInfo: (accessTokenObject, idTokenObject)=>{
            return (0, $555915b9bb1a98b7$export$801fe16824f675f7)(sdk, accessTokenObject, idTokenObject);
        },
        verify: (0, $fc14fe38bb03aa55$export$c807668e63e7354b).bind(null, sdk),
        isLoginRedirect: (0, $e49ac4003f707fb9$export$3488c667ccc91890).bind(null, sdk),
        introspect: (0, $73a947a1cd6f9db3$export$bb69de165ef829cf).bind(null, sdk)
    };
    const toWrap = [
        'getWithoutPrompt',
        'getWithPopup',
        'revoke',
        'renew',
        'renewTokensWithRefresh',
        'renewTokens'
    ];
    toWrap.forEach((key)=>{
        token[key] = useQueue(token[key]);
    });
    return token;
}
function $e432a4f0f177e2ec$export$deedb2680d4aa92(sdk) {
    return {
        authorize: {
            enrollAuthenticator: (0, $edae77cdf27d5ed4$export$9f57def5b7ea6999).bind(null, sdk)
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 







parcelRequire("R5nvG");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


function $004eed1d8a4540c2$export$56cd50188d1996d0(token, type) {
    if (!(0, $1728265dc3c1bbda$export$e183da9b0d22b235)(token) && !(0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(token) && !(0, $1728265dc3c1bbda$export$178a2c036dbf8815)(token)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property');
    if (type === 'accessToken' && !(0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(token)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('invalid accessToken');
    if (type === 'idToken' && !(0, $1728265dc3c1bbda$export$e183da9b0d22b235)(token)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('invalid idToken');
    if (type === 'refreshToken' && !(0, $1728265dc3c1bbda$export$178a2c036dbf8815)(token)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('invalid refreshToken');
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ class $d9a7fcefb38ef5e0$export$2e2bcd8739ae039 {
    constructor(localOffset){
        this.localOffset = parseInt(localOffset || 0);
    }
    static create() {
        var localOffset = 0;
        return new $d9a7fcefb38ef5e0$export$2e2bcd8739ae039(localOffset);
    }
    now() {
        var now = (Date.now() + this.localOffset) / 1000;
        return now;
    }
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $d0286a6f22efd2ec$export$c0d46e39554d86f6 = 'expired';
const $d0286a6f22efd2ec$export$421812244c1f12f0 = 'renewed';
const $d0286a6f22efd2ec$export$e9f9d3905a889e02 = 'added';
const $d0286a6f22efd2ec$export$9995ae835670bd28 = 'removed';
const $d0286a6f22efd2ec$export$abaffdbbab0f22ba = 'error';
const $d0286a6f22efd2ec$export$772c2bdc9dda0203 = 'set_storage';


const $bad47c2464111bfd$var$DEFAULT_OPTIONS = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    clearPendingRemoveTokens: true,
    storage: undefined,
    expireEarlySeconds: 30,
    storageKey: (0, $2119f0a66eb38a81$export$45d1f6fc12799d40)
};
function $bad47c2464111bfd$var$defaultState() {
    return {
        expireTimeouts: {},
        renewPromise: null
    };
}
class $bad47c2464111bfd$export$aa9349e63a87bac1 {
    constructor(sdk, options = {}){
        this.sdk = sdk;
        this.emitter = sdk.emitter;
        if (!this.emitter) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Emitter should be initialized before TokenManager');
        options = Object.assign({}, $bad47c2464111bfd$var$DEFAULT_OPTIONS, (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)(options));
        if (!(0, $cbeaafbff16be8ee$export$ec8a6426516240fc)()) options.expireEarlySeconds = $bad47c2464111bfd$var$DEFAULT_OPTIONS.expireEarlySeconds;
        this.options = options;
        const storageOptions = (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)({
            storageKey: options.storageKey,
            secure: options.secure
        });
        if (typeof options.storage === 'object') storageOptions.storageProvider = options.storage;
        else if (options.storage) storageOptions.storageType = options.storage;
        this.storage = sdk.storageManager.getTokenStorage(Object.assign(Object.assign({}, storageOptions), {
            useSeparateCookies: true
        }));
        this.clock = (0, $d9a7fcefb38ef5e0$export$2e2bcd8739ae039).create();
        this.state = $bad47c2464111bfd$var$defaultState();
    }
    on(event, handler, context) {
        if (context) this.emitter.on(event, handler, context);
        else this.emitter.on(event, handler);
    }
    off(event, handler) {
        if (handler) this.emitter.off(event, handler);
        else this.emitter.off(event);
    }
    start() {
        if (this.options.clearPendingRemoveTokens) this.clearPendingRemoveTokens();
        this.setExpireEventTimeoutAll();
        this.state.started = true;
    }
    stop() {
        this.clearExpireEventTimeoutAll();
        this.state.started = false;
    }
    isStarted() {
        return !!this.state.started;
    }
    getOptions() {
        return (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(this.options);
    }
    getExpireTime(token) {
        const expireEarlySeconds = this.options.expireEarlySeconds || 0;
        var expireTime = token.expiresAt - expireEarlySeconds;
        return expireTime;
    }
    hasExpired(token) {
        var expireTime = this.getExpireTime(token);
        return expireTime <= this.clock.now();
    }
    emitExpired(key, token) {
        this.emitter.emit((0, $d0286a6f22efd2ec$export$c0d46e39554d86f6), key, token);
    }
    emitRenewed(key, freshToken, oldToken) {
        this.emitter.emit((0, $d0286a6f22efd2ec$export$421812244c1f12f0), key, freshToken, oldToken);
    }
    emitAdded(key, token) {
        this.emitter.emit((0, $d0286a6f22efd2ec$export$e9f9d3905a889e02), key, token);
    }
    emitRemoved(key, token) {
        this.emitter.emit((0, $d0286a6f22efd2ec$export$9995ae835670bd28), key, token);
    }
    emitError(error) {
        this.emitter.emit((0, $d0286a6f22efd2ec$export$abaffdbbab0f22ba), error);
    }
    clearExpireEventTimeout(key) {
        clearTimeout(this.state.expireTimeouts[key]);
        delete this.state.expireTimeouts[key];
        this.state.renewPromise = null;
    }
    clearExpireEventTimeoutAll() {
        var expireTimeouts = this.state.expireTimeouts;
        for(var key in expireTimeouts){
            if (!Object.prototype.hasOwnProperty.call(expireTimeouts, key)) continue;
            this.clearExpireEventTimeout(key);
        }
    }
    setExpireEventTimeout(key, token) {
        if ((0, $1728265dc3c1bbda$export$178a2c036dbf8815)(token)) return;
        var expireTime = this.getExpireTime(token);
        var expireEventWait = Math.max(expireTime - this.clock.now(), 0) * 1000;
        this.clearExpireEventTimeout(key);
        var expireEventTimeout = setTimeout(()=>{
            this.emitExpired(key, token);
        }, expireEventWait);
        this.state.expireTimeouts[key] = expireEventTimeout;
    }
    setExpireEventTimeoutAll() {
        var tokenStorage = this.storage.getStorage();
        for(var key in tokenStorage){
            if (!Object.prototype.hasOwnProperty.call(tokenStorage, key)) continue;
            var token = tokenStorage[key];
            this.setExpireEventTimeout(key, token);
        }
    }
    resetExpireEventTimeoutAll() {
        this.clearExpireEventTimeoutAll();
        this.setExpireEventTimeoutAll();
    }
    add(key, token) {
        var tokenStorage = this.storage.getStorage();
        (0, $004eed1d8a4540c2$export$56cd50188d1996d0)(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitAdded(key, token);
        this.setExpireEventTimeout(key, token);
    }
    getSync(key) {
        var tokenStorage = this.storage.getStorage();
        return tokenStorage[key];
    }
    async get(key) {
        return this.getSync(key);
    }
    getTokensSync() {
        const tokens = {};
        const tokenStorage = this.storage.getStorage();
        Object.keys(tokenStorage).forEach((key)=>{
            const token = tokenStorage[key];
            if ((0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(token)) tokens.accessToken = token;
            else if ((0, $1728265dc3c1bbda$export$e183da9b0d22b235)(token)) tokens.idToken = token;
            else if ((0, $1728265dc3c1bbda$export$178a2c036dbf8815)(token)) tokens.refreshToken = token;
        });
        return tokens;
    }
    async getTokens() {
        return this.getTokensSync();
    }
    getStorageKeyByType(type) {
        const tokenStorage = this.storage.getStorage();
        const key = Object.keys(tokenStorage).filter((key)=>{
            const token = tokenStorage[key];
            return (0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(token) && type === 'accessToken' || (0, $1728265dc3c1bbda$export$e183da9b0d22b235)(token) && type === 'idToken' || (0, $1728265dc3c1bbda$export$178a2c036dbf8815)(token) && type === 'refreshToken';
        })[0];
        return key;
    }
    getTokenType(token) {
        if ((0, $1728265dc3c1bbda$export$3a59e0981c18db3c)(token)) return 'accessToken';
        if ((0, $1728265dc3c1bbda$export$e183da9b0d22b235)(token)) return 'idToken';
        if ((0, $1728265dc3c1bbda$export$178a2c036dbf8815)(token)) return 'refreshToken';
        throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unknown token type');
    }
    emitSetStorageEvent() {
        if ((0, $cbeaafbff16be8ee$export$302f5f2c80ff991d)()) {
            const storage = this.storage.getStorage();
            this.emitter.emit((0, $d0286a6f22efd2ec$export$772c2bdc9dda0203), storage);
        }
    }
    getStorage() {
        return this.storage;
    }
    setTokens(tokens, accessTokenCb, idTokenCb, refreshTokenCb) {
        const handleTokenCallback = (key, token)=>{
            const type = this.getTokenType(token);
            if (type === 'accessToken') accessTokenCb && accessTokenCb(key, token);
            else if (type === 'idToken') idTokenCb && idTokenCb(key, token);
            else if (type === 'refreshToken') refreshTokenCb && refreshTokenCb(key, token);
        };
        const handleAdded = (key, token)=>{
            this.emitAdded(key, token);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRenewed = (key, token, oldToken)=>{
            this.emitRenewed(key, token, oldToken);
            this.clearExpireEventTimeout(key);
            this.setExpireEventTimeout(key, token);
            handleTokenCallback(key, token);
        };
        const handleRemoved = (key, token)=>{
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, token);
            handleTokenCallback(key, token);
        };
        const types = [
            'idToken',
            'accessToken',
            'refreshToken'
        ];
        const existingTokens = this.getTokensSync();
        types.forEach((type)=>{
            const token = tokens[type];
            if (token) (0, $004eed1d8a4540c2$export$56cd50188d1996d0)(token, type);
        });
        const storage = types.reduce((storage, type)=>{
            const token = tokens[type];
            if (token) {
                const storageKey = this.getStorageKeyByType(type) || type;
                storage[storageKey] = token;
            }
            return storage;
        }, {});
        this.storage.setStorage(storage);
        this.emitSetStorageEvent();
        types.forEach((type)=>{
            const newToken = tokens[type];
            const existingToken = existingTokens[type];
            const storageKey = this.getStorageKeyByType(type) || type;
            if (newToken && existingToken) {
                handleRemoved(storageKey, existingToken);
                handleAdded(storageKey, newToken);
                handleRenewed(storageKey, newToken, existingToken);
            } else if (newToken) handleAdded(storageKey, newToken);
            else if (existingToken) handleRemoved(storageKey, existingToken);
        });
    }
    remove(key) {
        this.clearExpireEventTimeout(key);
        var tokenStorage = this.storage.getStorage();
        var removedToken = tokenStorage[key];
        delete tokenStorage[key];
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        this.emitRemoved(key, removedToken);
    }
    async renewToken(token) {
        var _a;
        return (_a = this.sdk.token) === null || _a === void 0 ? void 0 : _a.renew(token);
    }
    validateToken(token) {
        return (0, $004eed1d8a4540c2$export$56cd50188d1996d0)(token);
    }
    renew(key) {
        if (this.state.renewPromise) return this.state.renewPromise;
        try {
            var token = this.getSync(key);
            let shouldRenew = token !== undefined;
            if (!token && key === 'accessToken') {
                const refreshKey = this.getStorageKeyByType('refreshToken');
                const refreshToken = this.getSync(refreshKey);
                shouldRenew = refreshToken !== undefined;
            }
            if (!shouldRenew) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('The tokenManager has no token for the key: ' + key);
        } catch (err) {
            this.emitError(err);
            return Promise.reject(err);
        }
        this.clearExpireEventTimeout(key);
        const renewPromise = this.state.renewPromise = this.sdk.token.renewTokens().then((tokens)=>{
            this.setTokens(tokens);
            if (!token && key === 'accessToken') {
                const accessToken = tokens['accessToken'];
                this.emitRenewed(key, accessToken, null);
                return accessToken;
            }
            const tokenType = this.getTokenType(token);
            return tokens[tokenType];
        }).catch((err)=>{
            this.remove(key);
            err.tokenKey = key;
            this.emitError(err);
            throw err;
        }).finally(()=>{
            this.state.renewPromise = null;
        });
        return renewPromise;
    }
    clear() {
        const tokens = this.getTokensSync();
        this.clearExpireEventTimeoutAll();
        this.storage.clearStorage();
        this.emitSetStorageEvent();
        Object.keys(tokens).forEach((key)=>{
            this.emitRemoved(key, tokens[key]);
        });
    }
    clearPendingRemoveTokens() {
        const tokenStorage = this.storage.getStorage();
        const removedTokens = {};
        Object.keys(tokenStorage).forEach((key)=>{
            if (tokenStorage[key].pendingRemove) {
                removedTokens[key] = tokenStorage[key];
                delete tokenStorage[key];
            }
        });
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
        Object.keys(removedTokens).forEach((key)=>{
            this.clearExpireEventTimeout(key);
            this.emitRemoved(key, removedTokens[key]);
        });
    }
    updateRefreshToken(token) {
        const key = this.getStorageKeyByType('refreshToken') || (0, $2119f0a66eb38a81$export$b04ebc518c9597f0);
        var tokenStorage = this.storage.getStorage();
        (0, $004eed1d8a4540c2$export$56cd50188d1996d0)(token);
        tokenStorage[key] = token;
        this.storage.setStorage(tokenStorage);
        this.emitSetStorageEvent();
    }
    removeRefreshToken() {
        const key = this.getStorageKeyByType('refreshToken') || (0, $2119f0a66eb38a81$export$b04ebc518c9597f0);
        this.remove(key);
    }
    addPendingRemoveFlags() {
        const tokens = this.getTokensSync();
        Object.keys(tokens).forEach((key)=>{
            tokens[key].pendingRemove = true;
        });
        this.setTokens(tokens);
    }
}







/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



var $ec110d42afefa4d4$export$2e2bcd8739ae039 = {
    browserHasLocalStorage: function() {
        try {
            var storage = this.getLocalStorage();
            return this.testStorage(storage);
        } catch (e) {
            return false;
        }
    },
    browserHasSessionStorage: function() {
        try {
            var storage = this.getSessionStorage();
            return this.testStorage(storage);
        } catch (e) {
            return false;
        }
    },
    testStorageType: function(storageType) {
        var supported = false;
        switch(storageType){
            case 'sessionStorage':
                supported = this.browserHasSessionStorage();
                break;
            case 'localStorage':
                supported = this.browserHasLocalStorage();
                break;
            case 'cookie':
            case 'memory':
                supported = true;
                break;
            default:
                supported = false;
                break;
        }
        return supported;
    },
    getStorageByType: function(storageType, options) {
        let storageProvider;
        switch(storageType){
            case 'sessionStorage':
                storageProvider = this.getSessionStorage();
                break;
            case 'localStorage':
                storageProvider = this.getLocalStorage();
                break;
            case 'cookie':
                storageProvider = this.getCookieStorage(options);
                break;
            case 'memory':
                storageProvider = this.getInMemoryStorage();
                break;
            default:
                throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)(`Unrecognized storage option: ${storageType}`);
        }
        return storageProvider;
    },
    findStorageType: function(types) {
        let curType;
        let nextType;
        types = types.slice();
        curType = types.shift();
        nextType = types.length ? types[0] : null;
        if (!nextType) return curType;
        if (this.testStorageType(curType)) return curType;
        (0, $5502e384469ea433$export$c106dd0671a0fc2d)(`This browser doesn't support ${curType}. Switching to ${nextType}.`);
        return this.findStorageType(types);
    },
    getLocalStorage: function() {
        if ((0, $cbeaafbff16be8ee$export$302f5f2c80ff991d)() && !window.onstorage) window.onstorage = function() {};
        return localStorage;
    },
    getSessionStorage: function() {
        return sessionStorage;
    },
    getCookieStorage: function(options) {
        const secure = options.secure;
        const sameSite = options.sameSite;
        const sessionCookie = options.sessionCookie;
        if (typeof secure === 'undefined' || typeof sameSite === 'undefined') throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('getCookieStorage: "secure" and "sameSite" options must be provided');
        const storage = {
            getItem: this.storage.get,
            setItem: (key, value, expiresAt = '2200-01-01T00:00:00.000Z')=>{
                expiresAt = sessionCookie ? null : expiresAt;
                this.storage.set(key, value, expiresAt, {
                    secure: secure,
                    sameSite: sameSite
                });
            },
            removeItem: (key)=>{
                this.storage.delete(key);
            }
        };
        if (!options.useSeparateCookies) return storage;
        return {
            getItem: function(key) {
                var data = storage.getItem();
                var value = {};
                Object.keys(data).forEach((k)=>{
                    if (k.indexOf(key) === 0) value[k.replace(`${key}_`, '')] = JSON.parse(data[k]);
                });
                return JSON.stringify(value);
            },
            setItem: function(key, value) {
                var existingValues = JSON.parse(this.getItem(key));
                value = JSON.parse(value);
                Object.keys(value).forEach((k)=>{
                    var storageKey = key + '_' + k;
                    var valueToStore = JSON.stringify(value[k]);
                    storage.setItem(storageKey, valueToStore);
                    delete existingValues[k];
                });
                Object.keys(existingValues).forEach((k)=>{
                    storage.removeItem(key + '_' + k);
                });
            },
            removeItem: function(key) {
                var existingValues = JSON.parse(this.getItem(key));
                Object.keys(existingValues).forEach((k)=>{
                    storage.removeItem(key + '_' + k);
                });
            }
        };
    },
    inMemoryStore: {},
    getInMemoryStorage: function() {
        return {
            getItem: (key)=>{
                return this.inMemoryStore[key];
            },
            setItem: (key, value)=>{
                this.inMemoryStore[key] = value;
            }
        };
    },
    testStorage: function(storage) {
        var key = 'okta-test-storage';
        try {
            storage.setItem(key, key);
            storage.removeItem(key);
            return true;
        } catch (e) {
            return false;
        }
    },
    storage: {
        set: function(name, value, expiresAt, options) {
            const { sameSite: sameSite, secure: secure } = options;
            if (typeof secure === 'undefined' || typeof sameSite === 'undefined') throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('storage.set: "secure" and "sameSite" options must be provided');
            var cookieOptions = {
                path: options.path || '/',
                secure: secure,
                sameSite: sameSite
            };
            if (!!Date.parse(expiresAt)) cookieOptions.expires = new Date(expiresAt);
            (0, $fb2bda4b905adee7$export$2e2bcd8739ae039).set(name, value, cookieOptions);
            return this.get(name);
        },
        get: function(name) {
            if (!arguments.length) return (0, $fb2bda4b905adee7$export$2e2bcd8739ae039).get();
            return (0, $fb2bda4b905adee7$export$2e2bcd8739ae039).get(name);
        },
        delete: function(name) {
            return (0, $fb2bda4b905adee7$export$2e2bcd8739ae039).remove(name, {
                path: '/'
            });
        }
    }
};


function $509a0e053a434de8$export$25690a1e8875419f(BaseClass) {
    return class WithOriginalUri extends BaseClass {
        setOriginalUri(originalUri, state) {
            const sessionStorage = (0, $ec110d42afefa4d4$export$2e2bcd8739ae039).getSessionStorage();
            sessionStorage.setItem((0, $2119f0a66eb38a81$export$dc0f85461823eff2), originalUri);
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                sharedStorage.setItem(state, originalUri);
            }
        }
        getOriginalUri(state) {
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                const originalUri = sharedStorage.getItem(state);
                if (originalUri) return originalUri;
            }
            const storage = (0, $ec110d42afefa4d4$export$2e2bcd8739ae039).getSessionStorage();
            return storage ? storage.getItem((0, $2119f0a66eb38a81$export$dc0f85461823eff2)) || undefined : undefined;
        }
        removeOriginalUri(state) {
            const storage = (0, $ec110d42afefa4d4$export$2e2bcd8739ae039).getSessionStorage();
            storage.removeItem((0, $2119f0a66eb38a81$export$dc0f85461823eff2));
            state = state || this.options.state;
            if (state) {
                const sharedStorage = this.storageManager.getOriginalUriStorage();
                sharedStorage.removeItem && sharedStorage.removeItem(state);
            }
        }
    };
}


function $f919f60b8d93e7bc$export$d2d79cf72153e095(Base, TransactionManagerConstructor) {
    var _a;
    const WithOriginalUri = (0, $509a0e053a434de8$export$25690a1e8875419f)(Base);
    return _a = class OktaAuthOAuth extends WithOriginalUri {
        constructor(...args){
            super(...args);
            this.transactionManager = new TransactionManagerConstructor(Object.assign({
                storageManager: this.storageManager
            }, this.options.transactionManager));
            this.pkce = {
                DEFAULT_CODE_CHALLENGE_METHOD: (0, $0d1779c11b1d7a45$export$2e2bcd8739ae039).DEFAULT_CODE_CHALLENGE_METHOD,
                generateVerifier: (0, $0d1779c11b1d7a45$export$2e2bcd8739ae039).generateVerifier,
                computeChallenge: (0, $0d1779c11b1d7a45$export$2e2bcd8739ae039).computeChallenge
            };
            this._pending = {
                handleLogin: false
            };
            this._tokenQueue = new (0, $aa5cb4c154f96734$export$7ab95d2dbda3c98c)();
            this.token = (0, $e432a4f0f177e2ec$export$bd3db6d56a375929)(this, this._tokenQueue);
            this.tokenManager = new (0, $bad47c2464111bfd$export$aa9349e63a87bac1)(this, this.options.tokenManager);
            this.endpoints = (0, $e432a4f0f177e2ec$export$deedb2680d4aa92)(this);
        }
        clearStorage() {
            super.clearStorage();
            this.tokenManager.clear();
        }
        async isAuthenticated(options = {}) {
            const { autoRenew: autoRenew, autoRemove: autoRemove } = this.tokenManager.getOptions();
            const shouldRenew = options.onExpiredToken ? options.onExpiredToken === 'renew' : autoRenew;
            const shouldRemove = options.onExpiredToken ? options.onExpiredToken === 'remove' : autoRemove;
            let { accessToken: accessToken } = this.tokenManager.getTokensSync();
            if (accessToken && this.tokenManager.hasExpired(accessToken)) {
                accessToken = undefined;
                if (shouldRenew) try {
                    accessToken = await this.tokenManager.renew('accessToken');
                } catch (_a) {}
                else if (shouldRemove) this.tokenManager.remove('accessToken');
            }
            let { idToken: idToken } = this.tokenManager.getTokensSync();
            if (idToken && this.tokenManager.hasExpired(idToken)) {
                idToken = undefined;
                if (shouldRenew) try {
                    idToken = await this.tokenManager.renew('idToken');
                } catch (_b) {}
                else if (shouldRemove) this.tokenManager.remove('idToken');
            }
            return !!(accessToken && idToken);
        }
        async signInWithRedirect(opts = {}) {
            const { originalUri: originalUri } = opts, additionalParams = (0, $ca95e6f9e1ec9f80$export$3c9a16f847548506)(opts, [
                "originalUri"
            ]);
            if (this._pending.handleLogin) return;
            this._pending.handleLogin = true;
            try {
                if (originalUri) this.setOriginalUri(originalUri);
                const params = Object.assign({
                    scopes: this.options.scopes || [
                        'openid',
                        'email',
                        'profile'
                    ]
                }, additionalParams);
                await this.token.getWithRedirect(params);
            } finally{
                this._pending.handleLogin = false;
            }
        }
        async getUser() {
            const { idToken: idToken, accessToken: accessToken } = this.tokenManager.getTokensSync();
            return this.token.getUserInfo(accessToken, idToken);
        }
        getIdToken() {
            const { idToken: idToken } = this.tokenManager.getTokensSync();
            return idToken ? idToken.idToken : undefined;
        }
        getAccessToken() {
            const { accessToken: accessToken } = this.tokenManager.getTokensSync();
            return accessToken ? accessToken.accessToken : undefined;
        }
        getRefreshToken() {
            const { refreshToken: refreshToken } = this.tokenManager.getTokensSync();
            return refreshToken ? refreshToken.refreshToken : undefined;
        }
        async getOrRenewAccessToken() {
            var _a;
            const { accessToken: accessToken } = this.tokenManager.getTokensSync();
            if (accessToken && !this.tokenManager.hasExpired(accessToken)) return accessToken.accessToken;
            try {
                const key = this.tokenManager.getStorageKeyByType('accessToken');
                const token = await this.tokenManager.renew(key !== null && key !== void 0 ? key : 'accessToken');
                return (_a = token === null || token === void 0 ? void 0 : token.accessToken) !== null && _a !== void 0 ? _a : null;
            } catch (err) {
                this.emitter.emit('error', err);
                return null;
            }
        }
        async storeTokensFromRedirect() {
            const { tokens: tokens, responseType: responseType } = await this.token.parseFromUrl();
            if (responseType !== 'none') this.tokenManager.setTokens(tokens);
        }
        isLoginRedirect() {
            return (0, $e49ac4003f707fb9$export$3488c667ccc91890)(this);
        }
        isPKCE() {
            return !!this.options.pkce;
        }
        hasResponseType(responseType) {
            return (0, $e49ac4003f707fb9$export$85f1abab17a58c57)(responseType, this.options);
        }
        isAuthorizationCodeFlow() {
            return this.hasResponseType('code');
        }
        async invokeApiMethod(options) {
            if (!options.accessToken) {
                const accessToken = (await this.tokenManager.getTokens()).accessToken;
                options.accessToken = accessToken === null || accessToken === void 0 ? void 0 : accessToken.accessToken;
            }
            return (0, $b8f53662f6ac3919$export$46f383001bf60e04)(this, options);
        }
        async revokeAccessToken(accessToken) {
            if (!accessToken) {
                const tokens = await this.tokenManager.getTokens();
                accessToken = tokens.accessToken;
                const accessTokenKey = this.tokenManager.getStorageKeyByType('accessToken');
                this.tokenManager.remove(accessTokenKey);
                if (this.options.dpop) await (0, $567efc7b9cd21385$export$6afe52fd44d25eaf)('access', tokens);
            }
            if (!accessToken) return Promise.resolve(null);
            return this.token.revoke(accessToken);
        }
        async revokeRefreshToken(refreshToken) {
            if (!refreshToken) {
                const tokens = await this.tokenManager.getTokens();
                refreshToken = tokens.refreshToken;
                const refreshTokenKey = this.tokenManager.getStorageKeyByType('refreshToken');
                this.tokenManager.remove(refreshTokenKey);
                if (this.options.dpop) await (0, $567efc7b9cd21385$export$6afe52fd44d25eaf)('refresh', tokens);
            }
            if (!refreshToken) return Promise.resolve(null);
            return this.token.revoke(refreshToken);
        }
        getSignOutRedirectUrl(options = {}) {
            let { idToken: idToken, postLogoutRedirectUri: postLogoutRedirectUri, state: state } = options;
            if (!idToken) idToken = this.tokenManager.getTokensSync().idToken;
            if (!idToken) return '';
            if (postLogoutRedirectUri === undefined) postLogoutRedirectUri = this.options.postLogoutRedirectUri;
            const logoutUrl = (0, $28694eacc5911f05$export$1a398a8b679ebb76)(this).logoutUrl;
            const idTokenHint = idToken.idToken;
            let logoutUri = logoutUrl + '?id_token_hint=' + encodeURIComponent(idTokenHint);
            if (postLogoutRedirectUri) logoutUri += '&post_logout_redirect_uri=' + encodeURIComponent(postLogoutRedirectUri);
            if (state) logoutUri += '&state=' + encodeURIComponent(state);
            return logoutUri;
        }
        async signOut(options) {
            var _a;
            options = Object.assign({}, options);
            const defaultUri = window.location.origin;
            const currentUri = window.location.href;
            const postLogoutRedirectUri = options.postLogoutRedirectUri === null ? null : options.postLogoutRedirectUri || this.options.postLogoutRedirectUri || defaultUri;
            const state = options === null || options === void 0 ? void 0 : options.state;
            let accessToken = options.accessToken;
            let refreshToken = options.refreshToken;
            const revokeAccessToken = options.revokeAccessToken !== false;
            const revokeRefreshToken = options.revokeRefreshToken !== false;
            if (revokeRefreshToken && typeof refreshToken === 'undefined') refreshToken = this.tokenManager.getTokensSync().refreshToken;
            if (revokeAccessToken && typeof accessToken === 'undefined') accessToken = this.tokenManager.getTokensSync().accessToken;
            if (!options.idToken) options.idToken = this.tokenManager.getTokensSync().idToken;
            if (revokeRefreshToken && refreshToken) await this.revokeRefreshToken(refreshToken);
            if (revokeAccessToken && accessToken) await this.revokeAccessToken(accessToken);
            const dpopPairId = (_a = accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId) !== null && _a !== void 0 ? _a : refreshToken === null || refreshToken === void 0 ? void 0 : refreshToken.dpopPairId;
            if (this.options.dpop && dpopPairId) await (0, $567efc7b9cd21385$export$f33690fea154ad2d)(dpopPairId);
            const logoutUri = this.getSignOutRedirectUrl(Object.assign(Object.assign({}, options), {
                postLogoutRedirectUri: postLogoutRedirectUri
            }));
            if (!logoutUri) {
                const sessionClosed = await this.closeSession();
                const redirectUri = new URL(postLogoutRedirectUri || defaultUri);
                if (state) redirectUri.searchParams.append('state', state);
                if (postLogoutRedirectUri === currentUri) window.location.href = redirectUri.href;
                else window.location.assign(redirectUri.href);
                return sessionClosed;
            } else {
                if (options.clearTokensBeforeRedirect) this.tokenManager.clear();
                else this.tokenManager.addPendingRemoveFlags();
                window.location.assign(logoutUri);
                return true;
            }
        }
        async getDPoPAuthorizationHeaders(params) {
            if (!this.options.dpop) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('DPoP is not configured for this client instance');
            let { accessToken: accessToken } = params;
            if (!accessToken) accessToken = this.tokenManager.getTokensSync().accessToken;
            if (!accessToken) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('AccessToken is required to generate a DPoP Proof');
            const keyPair = await (0, $567efc7b9cd21385$export$846293577e1b1366)(accessToken === null || accessToken === void 0 ? void 0 : accessToken.dpopPairId);
            const proof = await (0, $567efc7b9cd21385$export$ac18780f7e57da)(Object.assign(Object.assign({}, params), {
                keyPair: keyPair,
                accessToken: accessToken.accessToken
            }));
            return {
                Authorization: `DPoP ${accessToken.accessToken}`,
                Dpop: proof
            };
        }
        async clearDPoPStorage(clearAll = false) {
            var _a, _b;
            if (clearAll) return (0, $567efc7b9cd21385$export$20156800d73a71cb)();
            const tokens = await this.tokenManager.getTokens();
            const keyPair = ((_a = tokens.accessToken) === null || _a === void 0 ? void 0 : _a.dpopPairId) || ((_b = tokens.refreshToken) === null || _b === void 0 ? void 0 : _b.dpopPairId);
            if (keyPair) await (0, $567efc7b9cd21385$export$f33690fea154ad2d)(keyPair);
        }
        parseUseDPoPNonceError(headers) {
            var _a;
            const wwwAuth = (0, $d28aec32d9343bab$export$2e2bcd8739ae039).getWWWAuthenticateHeader(headers);
            const wwwErr = (0, $d28aec32d9343bab$export$2e2bcd8739ae039).parseHeader(wwwAuth !== null && wwwAuth !== void 0 ? wwwAuth : '');
            if ((0, $567efc7b9cd21385$export$283c6a56651b6b3)(wwwErr)) {
                let nonce = null;
                if ((0, $307f2ba6550d7c99$export$f6e2535fb5126e54)(headers === null || headers === void 0 ? void 0 : headers.get)) nonce = headers.get('DPoP-Nonce');
                nonce = (_a = nonce !== null && nonce !== void 0 ? nonce : headers['dpop-nonce']) !== null && _a !== void 0 ? _a : headers['DPoP-Nonce'];
                return nonce;
            }
            return null;
        }
    }, _a.crypto = $695ebb4ba08f1e79$exports, _a;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $c2eb4b1c06d512de$exports = {};
'use strict';
class $c2eb4b1c06d512de$var$CancelError extends Error {
    constructor(reason){
        super(reason || 'Promise was canceled');
        this.name = 'CancelError';
    }
    get isCanceled() {
        return true;
    }
}
class $c2eb4b1c06d512de$var$PCancelable {
    static fn(userFn) {
        return (...arguments_)=>{
            return new $c2eb4b1c06d512de$var$PCancelable((resolve, reject, onCancel)=>{
                arguments_.push(onCancel);
                // eslint-disable-next-line promise/prefer-await-to-then
                userFn(...arguments_).then(resolve, reject);
            });
        };
    }
    constructor(executor){
        this._cancelHandlers = [];
        this._isPending = true;
        this._isCanceled = false;
        this._rejectOnCancel = true;
        this._promise = new Promise((resolve, reject)=>{
            this._reject = reject;
            const onResolve = (value)=>{
                if (!this._isCanceled || !onCancel.shouldReject) {
                    this._isPending = false;
                    resolve(value);
                }
            };
            const onReject = (error)=>{
                this._isPending = false;
                reject(error);
            };
            const onCancel = (handler)=>{
                if (!this._isPending) throw new Error('The `onCancel` handler was attached after the promise settled.');
                this._cancelHandlers.push(handler);
            };
            Object.defineProperties(onCancel, {
                shouldReject: {
                    get: ()=>this._rejectOnCancel,
                    set: (boolean)=>{
                        this._rejectOnCancel = boolean;
                    }
                }
            });
            return executor(onResolve, onReject, onCancel);
        });
    }
    then(onFulfilled, onRejected) {
        // eslint-disable-next-line promise/prefer-await-to-then
        return this._promise.then(onFulfilled, onRejected);
    }
    catch(onRejected) {
        return this._promise.catch(onRejected);
    }
    finally(onFinally) {
        return this._promise.finally(onFinally);
    }
    cancel(reason) {
        if (!this._isPending || this._isCanceled) return;
        this._isCanceled = true;
        if (this._cancelHandlers.length > 0) try {
            for (const handler of this._cancelHandlers)handler();
        } catch (error) {
            this._reject(error);
            return;
        }
        if (this._rejectOnCancel) this._reject(new $c2eb4b1c06d512de$var$CancelError(reason));
    }
    get isCanceled() {
        return this._isCanceled;
    }
}
Object.setPrototypeOf($c2eb4b1c06d512de$var$PCancelable.prototype, Promise.prototype);
$c2eb4b1c06d512de$exports = $c2eb4b1c06d512de$var$PCancelable;
$c2eb4b1c06d512de$exports.CancelError = $c2eb4b1c06d512de$var$CancelError;









parcelRequire("R5nvG");



const $db58b37edb7f2918$export$237dc0bae177ad41 = null;
const $db58b37edb7f2918$var$DEFAULT_PENDING = {
    updateAuthStatePromise: null,
    canceledTimes: 0
};
const $db58b37edb7f2918$var$EVENT_AUTH_STATE_CHANGE = 'authStateChange';
const $db58b37edb7f2918$var$MAX_PROMISE_CANCEL_TIMES = 10;
const $db58b37edb7f2918$var$isSameAuthState = (prevState, state)=>{
    if (!prevState) return false;
    return prevState.isAuthenticated === state.isAuthenticated && JSON.stringify(prevState.idToken) === JSON.stringify(state.idToken) && JSON.stringify(prevState.accessToken) === JSON.stringify(state.accessToken) && prevState.error === state.error;
};
class $db58b37edb7f2918$export$98841555a7280e2b {
    constructor(sdk){
        if (!sdk.emitter) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Emitter should be initialized before AuthStateManager');
        this._sdk = sdk;
        this._pending = Object.assign({}, $db58b37edb7f2918$var$DEFAULT_PENDING);
        this._authState = $db58b37edb7f2918$export$237dc0bae177ad41;
        this._logOptions = {};
        this._prevAuthState = null;
        this._transformQueue = new (0, $aa5cb4c154f96734$export$7ab95d2dbda3c98c)({
            quiet: true
        });
        sdk.tokenManager.on((0, $d0286a6f22efd2ec$export$e9f9d3905a889e02), (key, token)=>{
            this._setLogOptions({
                event: (0, $d0286a6f22efd2ec$export$e9f9d3905a889e02),
                key: key,
                token: token
            });
            this.updateAuthState();
        });
        sdk.tokenManager.on((0, $d0286a6f22efd2ec$export$9995ae835670bd28), (key, token)=>{
            this._setLogOptions({
                event: (0, $d0286a6f22efd2ec$export$9995ae835670bd28),
                key: key,
                token: token
            });
            this.updateAuthState();
        });
    }
    _setLogOptions(options) {
        this._logOptions = options;
    }
    getAuthState() {
        return this._authState;
    }
    getPreviousAuthState() {
        return this._prevAuthState;
    }
    async updateAuthState() {
        const { transformAuthState: transformAuthState, devMode: devMode } = this._sdk.options;
        const log = (status)=>{
            const { event: event, key: key, token: token } = this._logOptions;
            (0, $5502e384469ea433$export$bbe488cec1edd401)().group(`OKTA-AUTH-JS:updateAuthState: Event:${event} Status:${status}`);
            (0, $5502e384469ea433$export$bbe488cec1edd401)().log(key, token);
            (0, $5502e384469ea433$export$bbe488cec1edd401)().log('Current authState', this._authState);
            (0, $5502e384469ea433$export$bbe488cec1edd401)().groupEnd();
            this._logOptions = {};
        };
        const emitAuthStateChange = (authState)=>{
            if ($db58b37edb7f2918$var$isSameAuthState(this._authState, authState)) {
                devMode && log('unchanged');
                return;
            }
            this._prevAuthState = this._authState;
            this._authState = authState;
            this._sdk.emitter.emit($db58b37edb7f2918$var$EVENT_AUTH_STATE_CHANGE, Object.assign({}, authState));
            devMode && log('emitted');
        };
        const finalPromise = (origPromise)=>{
            return this._pending.updateAuthStatePromise.then(()=>{
                const curPromise = this._pending.updateAuthStatePromise;
                if (curPromise && curPromise !== origPromise) return finalPromise(curPromise);
                return this.getAuthState();
            });
        };
        if (this._pending.updateAuthStatePromise) {
            if (this._pending.canceledTimes >= $db58b37edb7f2918$var$MAX_PROMISE_CANCEL_TIMES) {
                devMode && log('terminated');
                return finalPromise(this._pending.updateAuthStatePromise);
            } else this._pending.updateAuthStatePromise.cancel();
        }
        const cancelablePromise = new (0, (/*@__PURE__*/$parcel$interopDefault($c2eb4b1c06d512de$exports)))((resolve, _, onCancel)=>{
            onCancel.shouldReject = false;
            onCancel(()=>{
                this._pending.updateAuthStatePromise = null;
                this._pending.canceledTimes = this._pending.canceledTimes + 1;
                devMode && log('canceled');
            });
            const emitAndResolve = (authState)=>{
                if (cancelablePromise.isCanceled) {
                    resolve();
                    return;
                }
                emitAuthStateChange(authState);
                resolve();
                this._pending = Object.assign({}, $db58b37edb7f2918$var$DEFAULT_PENDING);
            };
            this._sdk.isAuthenticated().then(()=>{
                if (cancelablePromise.isCanceled) {
                    resolve();
                    return;
                }
                const { accessToken: accessToken, idToken: idToken, refreshToken: refreshToken } = this._sdk.tokenManager.getTokensSync();
                const authState = {
                    accessToken: accessToken,
                    idToken: idToken,
                    refreshToken: refreshToken,
                    isAuthenticated: !!(accessToken && idToken)
                };
                const promise = transformAuthState ? this._transformQueue.push(transformAuthState, null, this._sdk, authState) : Promise.resolve(authState);
                promise.then((authState)=>emitAndResolve(authState)).catch((error)=>emitAndResolve({
                        accessToken: accessToken,
                        idToken: idToken,
                        refreshToken: refreshToken,
                        isAuthenticated: false,
                        error: error
                    }));
            });
        });
        this._pending.updateAuthStatePromise = cancelablePromise;
        return finalPromise(cancelablePromise);
    }
    subscribe(handler) {
        this._sdk.emitter.on($db58b37edb7f2918$var$EVENT_AUTH_STATE_CHANGE, handler);
    }
    unsubscribe(handler) {
        this._sdk.emitter.off($db58b37edb7f2918$var$EVENT_AUTH_STATE_CHANGE, handler);
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




class $d20c78e661aa59fa$export$6493f06a8769bada {
    constructor(tokenManager, options = {}){
        this.started = false;
        this.tokenManager = tokenManager;
        this.options = options;
        this.renewTimeQueue = [];
        this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
    }
    shouldThrottleRenew() {
        let res = false;
        this.renewTimeQueue.push(Date.now());
        if (this.renewTimeQueue.length >= 10) {
            const firstTime = this.renewTimeQueue.shift();
            const lastTime = this.renewTimeQueue[this.renewTimeQueue.length - 1];
            res = lastTime - firstTime < 30000;
        }
        return res;
    }
    requiresLeadership() {
        return !!this.options.syncStorage && (0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)();
    }
    processExpiredTokens() {
        const tokenStorage = this.tokenManager.getStorage();
        const tokens = tokenStorage.getStorage();
        Object.keys(tokens).forEach((key)=>{
            const token = tokens[key];
            if (!(0, $1728265dc3c1bbda$export$178a2c036dbf8815)(token) && this.tokenManager.hasExpired(token)) this.onTokenExpiredHandler(key);
        });
    }
    onTokenExpiredHandler(key) {
        if (this.options.autoRenew) {
            if (this.shouldThrottleRenew()) {
                const error = new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Too many token renew requests');
                this.tokenManager.emitError(error);
            } else this.tokenManager.renew(key).catch(()=>{});
        } else if (this.options.autoRemove) this.tokenManager.remove(key);
    }
    canStart() {
        return (!!this.options.autoRenew || !!this.options.autoRemove) && !this.started;
    }
    async start() {
        if (this.canStart()) {
            this.tokenManager.on((0, $d0286a6f22efd2ec$export$c0d46e39554d86f6), this.onTokenExpiredHandler);
            if (this.tokenManager.isStarted()) this.processExpiredTokens();
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            this.tokenManager.off((0, $d0286a6f22efd2ec$export$c0d46e39554d86f6), this.onTokenExpiredHandler);
            this.renewTimeQueue = [];
            this.started = false;
        }
    }
    isStarted() {
        return this.started;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /**
 * returns true if the given object is a promise
 */ function $67b3163bad04cd41$export$4369c812aac99591(obj) {
    return obj && typeof obj.then === 'function';
}
var $67b3163bad04cd41$export$6332f88de91a4f29 = Promise.resolve(false);
var $67b3163bad04cd41$export$b5d9069fca1162b4 = Promise.resolve(true);
var $67b3163bad04cd41$export$5187ac309d2dbc09 = Promise.resolve();
function $67b3163bad04cd41$export$e772c8ff12451969(time, resolveWith) {
    if (!time) time = 0;
    return new Promise(function(res) {
        return setTimeout(function() {
            return res(resolveWith);
        }, time);
    });
}
function $67b3163bad04cd41$export$3c5f89dae98e900b(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
}
function $67b3163bad04cd41$export$4e61f672936bec77() {
    return Math.random().toString(36).substring(2);
}
var $67b3163bad04cd41$var$lastMs = 0;
var $67b3163bad04cd41$var$additional = 0;
function $67b3163bad04cd41$export$b3e55dfce5152d1d() {
    var ms = new Date().getTime();
    if (ms === $67b3163bad04cd41$var$lastMs) {
        $67b3163bad04cd41$var$additional++;
        return ms * 1000 + $67b3163bad04cd41$var$additional;
    } else {
        $67b3163bad04cd41$var$lastMs = ms;
        $67b3163bad04cd41$var$additional = 0;
        return ms * 1000;
    }
}
function $67b3163bad04cd41$export$9f0d99555d35e998() {
    if (typeof navigator !== 'undefined' && typeof navigator.locks !== 'undefined' && typeof navigator.locks.request === 'function') return true;
    else return false;
}



var $c001ca94b0c6eeb0$export$b3e55dfce5152d1d = (0, $67b3163bad04cd41$export$b3e55dfce5152d1d);
var $c001ca94b0c6eeb0$export$bf9fb029d174d554 = 'native';
function $c001ca94b0c6eeb0$export$185802fd694ee1f5(channelName) {
    var state = {
        messagesCallback: null,
        bc: new BroadcastChannel(channelName),
        subFns: [] // subscriberFunctions
    };
    state.bc.onmessage = function(msg) {
        if (state.messagesCallback) state.messagesCallback(msg.data);
    };
    return state;
}
function $c001ca94b0c6eeb0$export$8360e631d277ea4d(channelState) {
    channelState.bc.close();
    channelState.subFns = [];
}
function $c001ca94b0c6eeb0$export$6efe264be9505de7(channelState, messageJson) {
    try {
        channelState.bc.postMessage(messageJson, false);
        return 0, $67b3163bad04cd41$export$5187ac309d2dbc09;
    } catch (err) {
        return Promise.reject(err);
    }
}
function $c001ca94b0c6eeb0$export$7275a8dcb77dc20d(channelState, fn) {
    channelState.messagesCallback = fn;
}
function $c001ca94b0c6eeb0$export$edc1ec99af52c032() {
    if ((typeof window !== 'undefined' || typeof self !== 'undefined') && typeof BroadcastChannel === 'function') {
        if (BroadcastChannel._pubkey) throw new Error('BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill');
        return true;
    } else return false;
}
function $c001ca94b0c6eeb0$export$378952ed8d3ebcd6() {
    return 150;
}
var $c001ca94b0c6eeb0$export$c2e5cf752d4e2634 = {
    create: $c001ca94b0c6eeb0$export$185802fd694ee1f5,
    close: $c001ca94b0c6eeb0$export$8360e631d277ea4d,
    onMessage: $c001ca94b0c6eeb0$export$7275a8dcb77dc20d,
    postMessage: $c001ca94b0c6eeb0$export$6efe264be9505de7,
    canBeUsed: $c001ca94b0c6eeb0$export$edc1ec99af52c032,
    type: $c001ca94b0c6eeb0$export$bf9fb029d174d554,
    averageResponseTime: $c001ca94b0c6eeb0$export$378952ed8d3ebcd6,
    microSeconds: $c001ca94b0c6eeb0$export$b3e55dfce5152d1d
};


/**
 * this method uses indexeddb to store the messages
 * There is currently no observerAPI for idb
 * @link https://github.com/w3c/IndexedDB/issues/51
 * 
 * When working on this, ensure to use these performance optimizations:
 * @link https://rxdb.info/slow-indexeddb.html
 */ 
/**
 * this is a set which automatically forgets
 * a given entry when a new entry is set and the ttl
 * of the old one is over
 */ var $0b78b41d63d919c8$export$95f11f715943104f = /** @class */ function() {
    function ObliviousSet(ttl) {
        this.ttl = ttl;
        this.map = new Map();
        /**
         * Creating calls to setTimeout() is expensive,
         * so we only do that if there is not timeout already open.
         */ this._to = false;
    }
    ObliviousSet.prototype.has = function(value) {
        return this.map.has(value);
    };
    ObliviousSet.prototype.add = function(value) {
        var _this = this;
        this.map.set(value, $0b78b41d63d919c8$export$461939dd4422153());
        /**
         * When a new value is added,
         * start the cleanup at the next tick
         * to not block the cpu for more important stuff
         * that might happen.
         */ if (!this._to) {
            this._to = true;
            setTimeout(function() {
                _this._to = false;
                $0b78b41d63d919c8$export$bb2da5c3b0945a45(_this);
            }, 0);
        }
    };
    ObliviousSet.prototype.clear = function() {
        this.map.clear();
    };
    return ObliviousSet;
}();
function $0b78b41d63d919c8$export$bb2da5c3b0945a45(obliviousSet) {
    var olderThen = $0b78b41d63d919c8$export$461939dd4422153() - obliviousSet.ttl;
    var iterator = obliviousSet.map[Symbol.iterator]();
    /**
     * Because we can assume the new values are added at the bottom,
     * we start from the top and stop as soon as we reach a non-too-old value.
     */ while(true){
        var next = iterator.next().value;
        if (!next) return; // no more elements
        var value = next[0];
        var time = next[1];
        if (time < olderThen) obliviousSet.map.delete(value);
        else // We reached a value that is not old enough
        return;
    }
}
function $0b78b41d63d919c8$export$461939dd4422153() {
    return new Date().getTime();
}


function $40aa24b406984495$export$7ee70d6123309e38() {
    var originalOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = JSON.parse(JSON.stringify(originalOptions));
    // main
    if (typeof options.webWorkerSupport === 'undefined') options.webWorkerSupport = true;
    // indexed-db
    if (!options.idb) options.idb = {};
    //  after this time the messages get deleted
    if (!options.idb.ttl) options.idb.ttl = 45000;
    if (!options.idb.fallbackInterval) options.idb.fallbackInterval = 150;
    //  handles abrupt db onclose events.
    if (originalOptions.idb && typeof originalOptions.idb.onclose === 'function') options.idb.onclose = originalOptions.idb.onclose;
    // localstorage
    if (!options.localstorage) options.localstorage = {};
    if (!options.localstorage.removeTimeout) options.localstorage.removeTimeout = 60000;
    // custom methods
    if (originalOptions.methods) options.methods = originalOptions.methods;
    // node
    if (!options.node) options.node = {};
    if (!options.node.ttl) options.node.ttl = 120000; // 2 minutes;
    /**
   * On linux use 'ulimit -Hn' to get the limit of open files.
   * On ubuntu this was 4096 for me, so we use half of that as maxParallelWrites default.
   */ if (!options.node.maxParallelWrites) options.node.maxParallelWrites = 2048;
    if (typeof options.node.useFastPath === 'undefined') options.node.useFastPath = true;
    return options;
}


var $8db4ca222419bec6$export$b3e55dfce5152d1d = (0, $67b3163bad04cd41$export$b3e55dfce5152d1d);
var $8db4ca222419bec6$var$DB_PREFIX = 'pubkey.broadcast-channel-0-';
var $8db4ca222419bec6$var$OBJECT_STORE_ID = 'messages';
var $8db4ca222419bec6$export$158bac47d00a5c4c = {
    durability: 'relaxed'
};
var $8db4ca222419bec6$export$bf9fb029d174d554 = 'idb';
function $8db4ca222419bec6$export$9bb0279d2d49cfa2() {
    if (typeof indexedDB !== 'undefined') return indexedDB;
    if (typeof window !== 'undefined') {
        if (typeof window.mozIndexedDB !== 'undefined') return window.mozIndexedDB;
        if (typeof window.webkitIndexedDB !== 'undefined') return window.webkitIndexedDB;
        if (typeof window.msIndexedDB !== 'undefined') return window.msIndexedDB;
    }
    return false;
}
function $8db4ca222419bec6$export$17f2b65aeb68429e(tx) {
    if (tx.commit) tx.commit();
}
function $8db4ca222419bec6$export$44470c96608c2d07(channelName) {
    var IndexedDB = $8db4ca222419bec6$export$9bb0279d2d49cfa2();
    // create table
    var dbName = $8db4ca222419bec6$var$DB_PREFIX + channelName;
    /**
   * All IndexedDB databases are opened without version
   * because it is a bit faster, especially on firefox
   * @link http://nparashuram.com/IndexedDB/perf/#Open%20Database%20with%20version
   */ var openRequest = IndexedDB.open(dbName);
    openRequest.onupgradeneeded = function(ev) {
        var db = ev.target.result;
        db.createObjectStore($8db4ca222419bec6$var$OBJECT_STORE_ID, {
            keyPath: 'id',
            autoIncrement: true
        });
    };
    return new Promise(function(res, rej) {
        openRequest.onerror = function(ev) {
            return rej(ev);
        };
        openRequest.onsuccess = function() {
            res(openRequest.result);
        };
    });
}
function $8db4ca222419bec6$export$c1667a36001fc792(db, readerUuid, messageJson) {
    var time = new Date().getTime();
    var writeObject = {
        uuid: readerUuid,
        time: time,
        data: messageJson
    };
    var tx = db.transaction([
        $8db4ca222419bec6$var$OBJECT_STORE_ID
    ], 'readwrite', $8db4ca222419bec6$export$158bac47d00a5c4c);
    return new Promise(function(res, rej) {
        tx.oncomplete = function() {
            return res();
        };
        tx.onerror = function(ev) {
            return rej(ev);
        };
        var objectStore = tx.objectStore($8db4ca222419bec6$var$OBJECT_STORE_ID);
        objectStore.add(writeObject);
        $8db4ca222419bec6$export$17f2b65aeb68429e(tx);
    });
}
function $8db4ca222419bec6$export$a5cd77f28ca54edc(db) {
    var tx = db.transaction($8db4ca222419bec6$var$OBJECT_STORE_ID, 'readonly', $8db4ca222419bec6$export$158bac47d00a5c4c);
    var objectStore = tx.objectStore($8db4ca222419bec6$var$OBJECT_STORE_ID);
    var ret = [];
    return new Promise(function(res) {
        objectStore.openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                ret.push(cursor.value);
                //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
                cursor["continue"]();
            } else {
                $8db4ca222419bec6$export$17f2b65aeb68429e(tx);
                res(ret);
            }
        };
    });
}
function $8db4ca222419bec6$export$e72d678308de85b5(db, lastCursorId) {
    var tx = db.transaction($8db4ca222419bec6$var$OBJECT_STORE_ID, 'readonly', $8db4ca222419bec6$export$158bac47d00a5c4c);
    var objectStore = tx.objectStore($8db4ca222419bec6$var$OBJECT_STORE_ID);
    var ret = [];
    var keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
    /**
   * Optimization shortcut,
   * if getAll() can be used, do not use a cursor.
   * @link https://rxdb.info/slow-indexeddb.html
   */ if (objectStore.getAll) {
        var getAllRequest = objectStore.getAll(keyRangeValue);
        return new Promise(function(res, rej) {
            getAllRequest.onerror = function(err) {
                return rej(err);
            };
            getAllRequest.onsuccess = function(e) {
                res(e.target.result);
            };
        });
    }
    function openCursor() {
        // Occasionally Safari will fail on IDBKeyRange.bound, this
        // catches that error, having it open the cursor to the first
        // item. When it gets data it will advance to the desired key.
        try {
            keyRangeValue = IDBKeyRange.bound(lastCursorId + 1, Infinity);
            return objectStore.openCursor(keyRangeValue);
        } catch (e) {
            return objectStore.openCursor();
        }
    }
    return new Promise(function(res, rej) {
        var openCursorRequest = openCursor();
        openCursorRequest.onerror = function(err) {
            return rej(err);
        };
        openCursorRequest.onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                if (cursor.value.id < lastCursorId + 1) cursor["continue"](lastCursorId + 1);
                else {
                    ret.push(cursor.value);
                    cursor["continue"]();
                }
            } else {
                $8db4ca222419bec6$export$17f2b65aeb68429e(tx);
                res(ret);
            }
        };
    });
}
function $8db4ca222419bec6$export$5dbe2125dcd25309(channelState, ids) {
    if (channelState.closed) return Promise.resolve([]);
    var tx = channelState.db.transaction($8db4ca222419bec6$var$OBJECT_STORE_ID, 'readwrite', $8db4ca222419bec6$export$158bac47d00a5c4c);
    var objectStore = tx.objectStore($8db4ca222419bec6$var$OBJECT_STORE_ID);
    return Promise.all(ids.map(function(id) {
        var deleteRequest = objectStore["delete"](id);
        return new Promise(function(res) {
            deleteRequest.onsuccess = function() {
                return res();
            };
        });
    }));
}
function $8db4ca222419bec6$export$1ad276d59b1ab4d4(db, ttl) {
    var olderThen = new Date().getTime() - ttl;
    var tx = db.transaction($8db4ca222419bec6$var$OBJECT_STORE_ID, 'readonly', $8db4ca222419bec6$export$158bac47d00a5c4c);
    var objectStore = tx.objectStore($8db4ca222419bec6$var$OBJECT_STORE_ID);
    var ret = [];
    return new Promise(function(res) {
        objectStore.openCursor().onsuccess = function(ev) {
            var cursor = ev.target.result;
            if (cursor) {
                var msgObk = cursor.value;
                if (msgObk.time < olderThen) {
                    ret.push(msgObk);
                    //alert("Name for SSN " + cursor.key + " is " + cursor.value.name);
                    cursor["continue"]();
                } else {
                    // no more old messages,
                    $8db4ca222419bec6$export$17f2b65aeb68429e(tx);
                    res(ret);
                }
            } else res(ret);
        };
    });
}
function $8db4ca222419bec6$export$8511d136ef71f411(channelState) {
    return $8db4ca222419bec6$export$1ad276d59b1ab4d4(channelState.db, channelState.options.idb.ttl).then(function(tooOld) {
        return $8db4ca222419bec6$export$5dbe2125dcd25309(channelState, tooOld.map(function(msg) {
            return msg.id;
        }));
    });
}
function $8db4ca222419bec6$export$185802fd694ee1f5(channelName, options) {
    options = (0, $40aa24b406984495$export$7ee70d6123309e38)(options);
    return $8db4ca222419bec6$export$44470c96608c2d07(channelName).then(function(db) {
        var state = {
            closed: false,
            lastCursorId: 0,
            channelName: channelName,
            options: options,
            uuid: (0, $67b3163bad04cd41$export$4e61f672936bec77)(),
            /**
       * emittedMessagesIds
       * contains all messages that have been emitted before
       * @type {ObliviousSet}
       */ eMIs: new (0, $0b78b41d63d919c8$export$95f11f715943104f)(options.idb.ttl * 2),
            // ensures we do not read messages in parallel
            writeBlockPromise: (0, $67b3163bad04cd41$export$5187ac309d2dbc09),
            messagesCallback: null,
            readQueuePromises: [],
            db: db
        };
        /**
     * Handle abrupt closes that do not originate from db.close().
     * This could happen, for example, if the underlying storage is
     * removed or if the user clears the database in the browser's
     * history preferences.
     */ db.onclose = function() {
            state.closed = true;
            if (options.idb.onclose) options.idb.onclose();
        };
        /**
     * if service-workers are used,
     * we have no 'storage'-event if they post a message,
     * therefore we also have to set an interval
     */ $8db4ca222419bec6$var$_readLoop(state);
        return state;
    });
}
function $8db4ca222419bec6$var$_readLoop(state) {
    if (state.closed) return;
    $8db4ca222419bec6$var$readNewMessages(state).then(function() {
        return (0, $67b3163bad04cd41$export$e772c8ff12451969)(state.options.idb.fallbackInterval);
    }).then(function() {
        return $8db4ca222419bec6$var$_readLoop(state);
    });
}
function $8db4ca222419bec6$var$_filterMessage(msgObj, state) {
    if (msgObj.uuid === state.uuid) return false; // send by own
    if (state.eMIs.has(msgObj.id)) return false; // already emitted
    if (msgObj.data.time < state.messagesCallbackTime) return false; // older then onMessageCallback
    return true;
}
/**
 * reads all new messages from the database and emits them
 */ function $8db4ca222419bec6$var$readNewMessages(state) {
    // channel already closed
    if (state.closed) return 0, $67b3163bad04cd41$export$5187ac309d2dbc09;
    // if no one is listening, we do not need to scan for new messages
    if (!state.messagesCallback) return 0, $67b3163bad04cd41$export$5187ac309d2dbc09;
    return $8db4ca222419bec6$export$e72d678308de85b5(state.db, state.lastCursorId).then(function(newerMessages) {
        var useMessages = newerMessages/**
     * there is a bug in iOS where the msgObj can be undefined sometimes
     * so we filter them out
     * @link https://github.com/pubkey/broadcast-channel/issues/19
     */ .filter(function(msgObj) {
            return !!msgObj;
        }).map(function(msgObj) {
            if (msgObj.id > state.lastCursorId) state.lastCursorId = msgObj.id;
            return msgObj;
        }).filter(function(msgObj) {
            return $8db4ca222419bec6$var$_filterMessage(msgObj, state);
        }).sort(function(msgObjA, msgObjB) {
            return msgObjA.time - msgObjB.time;
        }); // sort by time
        useMessages.forEach(function(msgObj) {
            if (state.messagesCallback) {
                state.eMIs.add(msgObj.id);
                state.messagesCallback(msgObj.data);
            }
        });
        return 0, $67b3163bad04cd41$export$5187ac309d2dbc09;
    });
}
function $8db4ca222419bec6$export$8360e631d277ea4d(channelState) {
    channelState.closed = true;
    channelState.db.close();
}
function $8db4ca222419bec6$export$6efe264be9505de7(channelState, messageJson) {
    channelState.writeBlockPromise = channelState.writeBlockPromise.then(function() {
        return $8db4ca222419bec6$export$c1667a36001fc792(channelState.db, channelState.uuid, messageJson);
    }).then(function() {
        if ((0, $67b3163bad04cd41$export$3c5f89dae98e900b)(0, 10) === 0) /* await (do not await) */ $8db4ca222419bec6$export$8511d136ef71f411(channelState);
    });
    return channelState.writeBlockPromise;
}
function $8db4ca222419bec6$export$7275a8dcb77dc20d(channelState, fn, time) {
    channelState.messagesCallbackTime = time;
    channelState.messagesCallback = fn;
    $8db4ca222419bec6$var$readNewMessages(channelState);
}
function $8db4ca222419bec6$export$edc1ec99af52c032() {
    return !!$8db4ca222419bec6$export$9bb0279d2d49cfa2();
}
function $8db4ca222419bec6$export$378952ed8d3ebcd6(options) {
    return options.idb.fallbackInterval * 2;
}
var $8db4ca222419bec6$export$f9fb5084a1e99645 = {
    create: $8db4ca222419bec6$export$185802fd694ee1f5,
    close: $8db4ca222419bec6$export$8360e631d277ea4d,
    onMessage: $8db4ca222419bec6$export$7275a8dcb77dc20d,
    postMessage: $8db4ca222419bec6$export$6efe264be9505de7,
    canBeUsed: $8db4ca222419bec6$export$edc1ec99af52c032,
    type: $8db4ca222419bec6$export$bf9fb029d174d554,
    averageResponseTime: $8db4ca222419bec6$export$378952ed8d3ebcd6,
    microSeconds: $8db4ca222419bec6$export$b3e55dfce5152d1d
};


/**
 * A localStorage-only method which uses localstorage and its 'storage'-event
 * This does not work inside webworkers because they have no access to localstorage
 * This is basically implemented to support IE9 or your grandmother's toaster.
 * @link https://caniuse.com/#feat=namevalue-storage
 * @link https://caniuse.com/#feat=indexeddb
 */ 


var $0ca6280d4b191db4$export$b3e55dfce5152d1d = (0, $67b3163bad04cd41$export$b3e55dfce5152d1d);
var $0ca6280d4b191db4$var$KEY_PREFIX = 'pubkey.broadcastChannel-';
var $0ca6280d4b191db4$export$bf9fb029d174d554 = 'localstorage';
function $0ca6280d4b191db4$export$d3720feff416e85b() {
    var localStorage;
    if (typeof window === 'undefined') return null;
    try {
        localStorage = window.localStorage;
        localStorage = window['ie8-eventlistener/storage'] || window.localStorage;
    } catch (e) {
    // New versions of Firefox throw a Security exception
    // if cookies are disabled. See
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1028153
    }
    return localStorage;
}
function $0ca6280d4b191db4$export$7367158f2f597ab1(channelName) {
    return $0ca6280d4b191db4$var$KEY_PREFIX + channelName;
}
function $0ca6280d4b191db4$export$6efe264be9505de7(channelState, messageJson) {
    return new Promise(function(res) {
        (0, $67b3163bad04cd41$export$e772c8ff12451969)().then(function() {
            var key = $0ca6280d4b191db4$export$7367158f2f597ab1(channelState.channelName);
            var writeObj = {
                token: (0, $67b3163bad04cd41$export$4e61f672936bec77)(),
                time: new Date().getTime(),
                data: messageJson,
                uuid: channelState.uuid
            };
            var value = JSON.stringify(writeObj);
            $0ca6280d4b191db4$export$d3720feff416e85b().setItem(key, value);
            /**
       * StorageEvent does not fire the 'storage' event
       * in the window that changes the state of the local storage.
       * So we fire it manually
       */ var ev = document.createEvent('Event');
            ev.initEvent('storage', true, true);
            ev.key = key;
            ev.newValue = value;
            window.dispatchEvent(ev);
            res();
        });
    });
}
function $0ca6280d4b191db4$export$e760364ddd2998eb(channelName, fn) {
    var key = $0ca6280d4b191db4$export$7367158f2f597ab1(channelName);
    var listener = function listener(ev) {
        if (ev.key === key) fn(JSON.parse(ev.newValue));
    };
    window.addEventListener('storage', listener);
    return listener;
}
function $0ca6280d4b191db4$export$cec52acdd19fc469(listener) {
    window.removeEventListener('storage', listener);
}
function $0ca6280d4b191db4$export$185802fd694ee1f5(channelName, options) {
    options = (0, $40aa24b406984495$export$7ee70d6123309e38)(options);
    if (!$0ca6280d4b191db4$export$edc1ec99af52c032()) throw new Error('BroadcastChannel: localstorage cannot be used');
    var uuid = (0, $67b3163bad04cd41$export$4e61f672936bec77)();
    /**
   * eMIs
   * contains all messages that have been emitted before
   * @type {ObliviousSet}
   */ var eMIs = new (0, $0b78b41d63d919c8$export$95f11f715943104f)(options.localstorage.removeTimeout);
    var state = {
        channelName: channelName,
        uuid: uuid,
        eMIs: eMIs // emittedMessagesIds
    };
    state.listener = $0ca6280d4b191db4$export$e760364ddd2998eb(channelName, function(msgObj) {
        if (!state.messagesCallback) return; // no listener
        if (msgObj.uuid === uuid) return; // own message
        if (!msgObj.token || eMIs.has(msgObj.token)) return; // already emitted
        if (msgObj.data.time && msgObj.data.time < state.messagesCallbackTime) return; // too old
        eMIs.add(msgObj.token);
        state.messagesCallback(msgObj.data);
    });
    return state;
}
function $0ca6280d4b191db4$export$8360e631d277ea4d(channelState) {
    $0ca6280d4b191db4$export$cec52acdd19fc469(channelState.listener);
}
function $0ca6280d4b191db4$export$7275a8dcb77dc20d(channelState, fn, time) {
    channelState.messagesCallbackTime = time;
    channelState.messagesCallback = fn;
}
function $0ca6280d4b191db4$export$edc1ec99af52c032() {
    var ls = $0ca6280d4b191db4$export$d3720feff416e85b();
    if (!ls) return false;
    try {
        var key = '__broadcastchannel_check';
        ls.setItem(key, 'works');
        ls.removeItem(key);
    } catch (e) {
        // Safari 10 in private mode will not allow write access to local
        // storage and fail with a QuotaExceededError. See
        // https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API#Private_Browsing_Incognito_modes
        return false;
    }
    return true;
}
function $0ca6280d4b191db4$export$378952ed8d3ebcd6() {
    var defaultTime = 120;
    var userAgent = navigator.userAgent.toLowerCase();
    if (userAgent.includes('safari') && !userAgent.includes('chrome')) // safari is much slower so this time is higher
    return defaultTime * 2;
    return defaultTime;
}
var $0ca6280d4b191db4$export$9b9bc32d3762ca15 = {
    create: $0ca6280d4b191db4$export$185802fd694ee1f5,
    close: $0ca6280d4b191db4$export$8360e631d277ea4d,
    onMessage: $0ca6280d4b191db4$export$7275a8dcb77dc20d,
    postMessage: $0ca6280d4b191db4$export$6efe264be9505de7,
    canBeUsed: $0ca6280d4b191db4$export$edc1ec99af52c032,
    type: $0ca6280d4b191db4$export$bf9fb029d174d554,
    averageResponseTime: $0ca6280d4b191db4$export$378952ed8d3ebcd6,
    microSeconds: $0ca6280d4b191db4$export$b3e55dfce5152d1d
};



var $ed23b6b3d0f3e72f$export$b3e55dfce5152d1d = (0, $67b3163bad04cd41$export$b3e55dfce5152d1d);
var $ed23b6b3d0f3e72f$export$bf9fb029d174d554 = 'simulate';
var $ed23b6b3d0f3e72f$var$SIMULATE_CHANNELS = new Set();
function $ed23b6b3d0f3e72f$export$185802fd694ee1f5(channelName) {
    var state = {
        name: channelName,
        messagesCallback: null
    };
    $ed23b6b3d0f3e72f$var$SIMULATE_CHANNELS.add(state);
    return state;
}
function $ed23b6b3d0f3e72f$export$8360e631d277ea4d(channelState) {
    $ed23b6b3d0f3e72f$var$SIMULATE_CHANNELS["delete"](channelState);
}
function $ed23b6b3d0f3e72f$export$6efe264be9505de7(channelState, messageJson) {
    return new Promise(function(res) {
        return setTimeout(function() {
            var channelArray = Array.from($ed23b6b3d0f3e72f$var$SIMULATE_CHANNELS);
            channelArray.filter(function(channel) {
                return channel.name === channelState.name;
            }).filter(function(channel) {
                return channel !== channelState;
            }).filter(function(channel) {
                return !!channel.messagesCallback;
            }).forEach(function(channel) {
                return channel.messagesCallback(messageJson);
            });
            res();
        }, 5);
    });
}
function $ed23b6b3d0f3e72f$export$7275a8dcb77dc20d(channelState, fn) {
    channelState.messagesCallback = fn;
}
function $ed23b6b3d0f3e72f$export$edc1ec99af52c032() {
    return true;
}
function $ed23b6b3d0f3e72f$export$378952ed8d3ebcd6() {
    return 5;
}
var $ed23b6b3d0f3e72f$export$6cab4f14afd51a43 = {
    create: $ed23b6b3d0f3e72f$export$185802fd694ee1f5,
    close: $ed23b6b3d0f3e72f$export$8360e631d277ea4d,
    onMessage: $ed23b6b3d0f3e72f$export$7275a8dcb77dc20d,
    postMessage: $ed23b6b3d0f3e72f$export$6efe264be9505de7,
    canBeUsed: $ed23b6b3d0f3e72f$export$edc1ec99af52c032,
    type: $ed23b6b3d0f3e72f$export$bf9fb029d174d554,
    averageResponseTime: $ed23b6b3d0f3e72f$export$378952ed8d3ebcd6,
    microSeconds: $ed23b6b3d0f3e72f$export$b3e55dfce5152d1d
};


// the line below will be removed from es5/browser builds
// order is important
var $fc345cc680d715ae$var$METHODS = [
    (0, $c001ca94b0c6eeb0$export$c2e5cf752d4e2634),
    // fastest
    (0, $8db4ca222419bec6$export$f9fb5084a1e99645),
    (0, $0ca6280d4b191db4$export$9b9bc32d3762ca15)
];
function $fc345cc680d715ae$export$bc8f997dfd48bd57(options) {
    var chooseMethods = [].concat(options.methods, $fc345cc680d715ae$var$METHODS).filter(Boolean);
    // the line below will be removed from es5/browser builds
    // directly chosen
    if (options.type) {
        if (options.type === 'simulate') // only use simulate-method if directly chosen
        return 0, $ed23b6b3d0f3e72f$export$6cab4f14afd51a43;
        var ret = chooseMethods.find(function(m) {
            return m.type === options.type;
        });
        if (!ret) throw new Error('method-type ' + options.type + ' not found');
        else return ret;
    }
    /**
   * if no webworker support is needed,
   * remove idb from the list so that localstorage will be chosen
   */ if (!options.webWorkerSupport) chooseMethods = chooseMethods.filter(function(m) {
        return m.type !== 'idb';
    });
    var useMethod = chooseMethods.find(function(method) {
        return method.canBeUsed();
    });
    if (!useMethod) throw new Error("No usable method found in " + JSON.stringify($fc345cc680d715ae$var$METHODS.map(function(m) {
        return m.type;
    })));
    else return useMethod;
}



var $3df945c461bccc62$export$a36c4a9e1adc527 = new Set();
var $3df945c461bccc62$var$lastId = 0;
var $3df945c461bccc62$export$f0e5058d63a378d5 = function BroadcastChannel(name, options) {
    // identifier of the channel to debug stuff
    this.id = $3df945c461bccc62$var$lastId++;
    $3df945c461bccc62$export$a36c4a9e1adc527.add(this);
    this.name = name;
    if ($3df945c461bccc62$var$ENFORCED_OPTIONS) options = $3df945c461bccc62$var$ENFORCED_OPTIONS;
    this.options = (0, $40aa24b406984495$export$7ee70d6123309e38)(options);
    this.method = (0, $fc345cc680d715ae$export$bc8f997dfd48bd57)(this.options);
    // isListening
    this._iL = false;
    /**
   * _onMessageListener
   * setting onmessage twice,
   * will overwrite the first listener
   */ this._onML = null;
    /**
   * _addEventListeners
   */ this._addEL = {
        message: [],
        internal: []
    };
    /**
   * Unsent message promises
   * where the sending is still in progress
   * @type {Set<Promise>}
   */ this._uMP = new Set();
    /**
   * _beforeClose
   * array of promises that will be awaited
   * before the channel is closed
   */ this._befC = [];
    /**
   * _preparePromise
   */ this._prepP = null;
    $3df945c461bccc62$var$_prepareChannel(this);
};
// STATICS
/**
 * used to identify if someone overwrites
 * window.BroadcastChannel with this
 * See methods/native.js
 */ $3df945c461bccc62$export$f0e5058d63a378d5._pubkey = true;
function $3df945c461bccc62$export$88418e3e0b88b3ce(options) {
    options = (0, $40aa24b406984495$export$7ee70d6123309e38)(options);
    var method = (0, $fc345cc680d715ae$export$bc8f997dfd48bd57)(options);
    if (method.type === 'node') return method.clearNodeFolder().then(function() {
        return true;
    });
    else return 0, $67b3163bad04cd41$export$6332f88de91a4f29;
}
/**
 * if set, this method is enforced,
 * no mather what the options are
 */ var $3df945c461bccc62$var$ENFORCED_OPTIONS;
function $3df945c461bccc62$export$62d57cbacc8722b4(options) {
    $3df945c461bccc62$var$ENFORCED_OPTIONS = options;
}
// PROTOTYPE
$3df945c461bccc62$export$f0e5058d63a378d5.prototype = {
    postMessage: function postMessage(msg) {
        if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + /**
       * In the past when this error appeared, it was really hard to debug.
       * So now we log the msg together with the error so it at least
       * gives some clue about where in your application this happens.
       */ JSON.stringify(msg));
        return $3df945c461bccc62$var$_post(this, 'message', msg);
    },
    postInternal: function postInternal(msg) {
        return $3df945c461bccc62$var$_post(this, 'internal', msg);
    },
    set onmessage (fn){
        var time = this.method.microSeconds();
        var listenObj = {
            time: time,
            fn: fn
        };
        $3df945c461bccc62$var$_removeListenerObject(this, 'message', this._onML);
        if (fn && typeof fn === 'function') {
            this._onML = listenObj;
            $3df945c461bccc62$var$_addListenerObject(this, 'message', listenObj);
        } else this._onML = null;
    },
    addEventListener: function addEventListener(type, fn1) {
        var time = this.method.microSeconds();
        var listenObj = {
            time: time,
            fn: fn1
        };
        $3df945c461bccc62$var$_addListenerObject(this, type, listenObj);
    },
    removeEventListener: function removeEventListener(type, fn1) {
        var obj = this._addEL[type].find(function(obj) {
            return obj.fn === fn1;
        });
        $3df945c461bccc62$var$_removeListenerObject(this, type, obj);
    },
    close: function close() {
        var _this = this;
        if (this.closed) return;
        $3df945c461bccc62$export$a36c4a9e1adc527["delete"](this);
        this.closed = true;
        var awaitPrepare = this._prepP ? this._prepP : (0, $67b3163bad04cd41$export$5187ac309d2dbc09);
        this._onML = null;
        this._addEL.message = [];
        return awaitPrepare// wait until all current sending are processed
        .then(function() {
            return Promise.all(Array.from(_this._uMP));
        })// run before-close hooks
        .then(function() {
            return Promise.all(_this._befC.map(function(fn1) {
                return fn1();
            }));
        })// close the channel
        .then(function() {
            return _this.method.close(_this._state);
        });
    },
    get type () {
        return this.method.type;
    },
    get isClosed () {
        return this.closed;
    }
};
/**
 * Post a message over the channel
 * @returns {Promise} that resolved when the message sending is done
 */ function $3df945c461bccc62$var$_post(broadcastChannel, type, msg) {
    var time = broadcastChannel.method.microSeconds();
    var msgObj = {
        time: time,
        type: type,
        data: msg
    };
    var awaitPrepare = broadcastChannel._prepP ? broadcastChannel._prepP : (0, $67b3163bad04cd41$export$5187ac309d2dbc09);
    return awaitPrepare.then(function() {
        var sendPromise = broadcastChannel.method.postMessage(broadcastChannel._state, msgObj);
        // add/remove to unsent messages list
        broadcastChannel._uMP.add(sendPromise);
        sendPromise["catch"]().then(function() {
            return broadcastChannel._uMP["delete"](sendPromise);
        });
        return sendPromise;
    });
}
function $3df945c461bccc62$var$_prepareChannel(channel) {
    var maybePromise = channel.method.create(channel.name, channel.options);
    if ((0, $67b3163bad04cd41$export$4369c812aac99591)(maybePromise)) {
        channel._prepP = maybePromise;
        maybePromise.then(function(s) {
            // used in tests to simulate slow runtime
            /*if (channel.options.prepareDelay) {
           await new Promise(res => setTimeout(res, this.options.prepareDelay));
      }*/ channel._state = s;
        });
    } else channel._state = maybePromise;
}
function $3df945c461bccc62$var$_hasMessageListeners(channel) {
    if (channel._addEL.message.length > 0) return true;
    if (channel._addEL.internal.length > 0) return true;
    return false;
}
function $3df945c461bccc62$var$_addListenerObject(channel, type, obj) {
    channel._addEL[type].push(obj);
    $3df945c461bccc62$var$_startListening(channel);
}
function $3df945c461bccc62$var$_removeListenerObject(channel, type, obj) {
    channel._addEL[type] = channel._addEL[type].filter(function(o) {
        return o !== obj;
    });
    $3df945c461bccc62$var$_stopListening(channel);
}
function $3df945c461bccc62$var$_startListening(channel) {
    if (!channel._iL && $3df945c461bccc62$var$_hasMessageListeners(channel)) {
        // someone is listening, start subscribing
        var listenerFn = function listenerFn(msgObj) {
            channel._addEL[msgObj.type].forEach(function(listenerObject) {
                /**
         * Getting the current time in JavaScript has no good precision.
         * So instead of only listening to events that happened 'after' the listener
         * was added, we also listen to events that happened 100ms before it.
         * This ensures that when another process, like a WebWorker, sends events
         * we do not miss them out because their timestamp is a bit off compared to the main process.
         * Not doing this would make messages missing when we send data directly after subscribing and awaiting a response.
         * @link https://johnresig.com/blog/accuracy-of-javascript-time/
         */ var hundredMsInMicro = 100000;
                var minMessageTime = listenerObject.time - hundredMsInMicro;
                if (msgObj.time >= minMessageTime) listenerObject.fn(msgObj.data);
            });
        };
        var time = channel.method.microSeconds();
        if (channel._prepP) channel._prepP.then(function() {
            channel._iL = true;
            channel.method.onMessage(channel._state, listenerFn, time);
        });
        else {
            channel._iL = true;
            channel.method.onMessage(channel._state, listenerFn, time);
        }
    }
}
function $3df945c461bccc62$var$_stopListening(channel) {
    if (channel._iL && !$3df945c461bccc62$var$_hasMessageListeners(channel)) {
        // no one is listening, stop subscribing
        channel._iL = false;
        var time = channel.method.microSeconds();
        channel.method.onMessage(channel._state, null, time);
    }
}



/* global WorkerGlobalScope */ function $cde9b5acd0930df4$export$ae93c1693bb96e6(fn) {
    if (typeof WorkerGlobalScope === 'function' && self instanceof WorkerGlobalScope) {
        /**
     * Because killing a worker does directly stop the excution
     * of the code, our only chance is to overwrite the close function
     * which could work some times.
     * @link https://stackoverflow.com/q/72903255/3443137
     */ var oldClose = self.close.bind(self);
        self.close = function() {
            fn();
            return oldClose();
        };
    } else {
        /**
     * if we are on react-native, there is no window.addEventListener
     * @link https://github.com/pubkey/unload/issues/6
     */ if (typeof window.addEventListener !== 'function') return;
        /**
     * for normal browser-windows, we use the beforeunload-event
     */ window.addEventListener('beforeunload', function() {
            fn();
        }, true);
        /**
     * for iframes, we have to use the unload-event
     * @link https://stackoverflow.com/q/47533670/3443137
     */ window.addEventListener('unload', function() {
            fn();
        }, true);
    }
/**
   * TODO add fallback for safari-mobile
   * @link https://stackoverflow.com/a/26193516/3443137
   */ }



function $24056a6c7c21df14$export$2fed3c3ffa8e7fdf(fn) {
    $cfae44f0dfdf62c0$exports.on('exit', function() {
        return fn();
    });
    /**
   * on the following events,
   * the process will not end if there are
   * event-handlers attached,
   * therefore we have to call process.exit()
   */ $cfae44f0dfdf62c0$exports.on('beforeExit', function() {
        return fn().then(function() {
            return $cfae44f0dfdf62c0$exports.exit();
        });
    });
    // catches ctrl+c event
    $cfae44f0dfdf62c0$exports.on('SIGINT', function() {
        return fn().then(function() {
            return $cfae44f0dfdf62c0$exports.exit();
        });
    });
    // catches uncaught exceptions
    $cfae44f0dfdf62c0$exports.on('uncaughtException', function(err) {
        return fn().then(function() {
            console.trace(err);
            $cfae44f0dfdf62c0$exports.exit(101);
        });
    });
}


/**
 * Use the code directly to prevent import problems
 * with the detect-node package.
 * @link https://github.com/iliakan/detect-node/blob/master/index.js
 */ var $f6d3047ff3efcc17$var$isNode = Object.prototype.toString.call(0) === '[object process]';
var $f6d3047ff3efcc17$var$USE_METHOD = $f6d3047ff3efcc17$var$isNode ? (0, $24056a6c7c21df14$export$2fed3c3ffa8e7fdf) : (0, $cde9b5acd0930df4$export$ae93c1693bb96e6);
var $f6d3047ff3efcc17$var$LISTENERS = new Set();
var $f6d3047ff3efcc17$var$startedListening = false;
function $f6d3047ff3efcc17$var$startListening() {
    if ($f6d3047ff3efcc17$var$startedListening) return;
    $f6d3047ff3efcc17$var$startedListening = true;
    $f6d3047ff3efcc17$var$USE_METHOD($f6d3047ff3efcc17$export$62f8a3b655d92f84);
}
function $f6d3047ff3efcc17$export$e16d8520af44a096(fn) {
    $f6d3047ff3efcc17$var$startListening();
    if (typeof fn !== 'function') throw new Error('Listener is no function');
    $f6d3047ff3efcc17$var$LISTENERS.add(fn);
    var addReturn = {
        remove: function remove() {
            return $f6d3047ff3efcc17$var$LISTENERS["delete"](fn);
        },
        run: function run() {
            $f6d3047ff3efcc17$var$LISTENERS["delete"](fn);
            return fn();
        }
    };
    return addReturn;
}
function $f6d3047ff3efcc17$export$62f8a3b655d92f84() {
    var promises = [];
    $f6d3047ff3efcc17$var$LISTENERS.forEach(function(fn) {
        promises.push(fn());
        $f6d3047ff3efcc17$var$LISTENERS["delete"](fn);
    });
    return Promise.all(promises);
}
function $f6d3047ff3efcc17$export$1cfc7aad5cb1833b() {
    $f6d3047ff3efcc17$var$LISTENERS.clear();
}
function $f6d3047ff3efcc17$export$31b21d0167753bb4() {
    return $f6d3047ff3efcc17$var$LISTENERS.size;
}


function $8aef705a1e305940$export$3dc3e712f47e19f(leaderElector, action) {
    var msgJson = {
        context: 'leader',
        action: action,
        token: leaderElector.token
    };
    return leaderElector.broadcastChannel.postInternal(msgJson);
}
function $8aef705a1e305940$export$7ef45c3373dd6bfa(leaderElector) {
    leaderElector.isLeader = true;
    leaderElector._hasLeader = true;
    var unloadFn = (0, $f6d3047ff3efcc17$export$e16d8520af44a096)(function() {
        return leaderElector.die();
    });
    leaderElector._unl.push(unloadFn);
    var isLeaderListener = function isLeaderListener(msg) {
        if (msg.context === 'leader' && msg.action === 'apply') $8aef705a1e305940$export$3dc3e712f47e19f(leaderElector, 'tell');
        if (msg.context === 'leader' && msg.action === 'tell' && !leaderElector._dpLC) {
            /**
       * another instance is also leader!
       * This can happen on rare events
       * like when the CPU is at 100% for long time
       * or the tabs are open very long and the browser throttles them.
       * @link https://github.com/pubkey/broadcast-channel/issues/414
       * @link https://github.com/pubkey/broadcast-channel/issues/385
       */ leaderElector._dpLC = true;
            leaderElector._dpL(); // message the lib user so the app can handle the problem
            $8aef705a1e305940$export$3dc3e712f47e19f(leaderElector, 'tell'); // ensure other leader also knows the problem
        }
    };
    leaderElector.broadcastChannel.addEventListener('internal', isLeaderListener);
    leaderElector._lstns.push(isLeaderListener);
    return $8aef705a1e305940$export$3dc3e712f47e19f(leaderElector, 'tell');
}




var $ae5d539d5e66fba5$export$ec7ac9ac703b19d5 = function LeaderElectionWebLock(broadcastChannel, options) {
    var _this = this;
    this.broadcastChannel = broadcastChannel;
    broadcastChannel._befC.push(function() {
        return _this.die();
    });
    this._options = options;
    this.isLeader = false;
    this.isDead = false;
    this.token = (0, $67b3163bad04cd41$export$4e61f672936bec77)();
    this._lstns = [];
    this._unl = [];
    this._dpL = function() {}; // onduplicate listener
    this._dpLC = false; // true when onduplicate called
    this._wKMC = {}; // stuff for cleanup
    // lock name
    this.lN = 'pubkey-bc||' + broadcastChannel.method.type + '||' + broadcastChannel.name;
};
$ae5d539d5e66fba5$export$ec7ac9ac703b19d5.prototype = {
    hasLeader: function hasLeader() {
        var _this2 = this;
        return navigator.locks.query().then(function(locks) {
            var relevantLocks = locks.held ? locks.held.filter(function(lock) {
                return lock.name === _this2.lN;
            }) : [];
            if (relevantLocks && relevantLocks.length > 0) return true;
            else return false;
        });
    },
    awaitLeadership: function awaitLeadership() {
        var _this3 = this;
        if (!this._wLMP) {
            this._wKMC.c = new AbortController();
            var returnPromise = new Promise(function(res, rej) {
                _this3._wKMC.res = res;
                _this3._wKMC.rej = rej;
            });
            this._wLMP = new Promise(function(res) {
                navigator.locks.request(_this3.lN, {
                    signal: _this3._wKMC.c.signal
                }, function() {
                    // if the lock resolved, we can drop the abort controller
                    _this3._wKMC.c = undefined;
                    (0, $8aef705a1e305940$export$7ef45c3373dd6bfa)(_this3);
                    res();
                    return returnPromise;
                })["catch"](function() {});
            });
        }
        return this._wLMP;
    },
    set onduplicate (_fn){
    // Do nothing because there are no duplicates in the WebLock version
    },
    die: function die() {
        var _this4 = this;
        this._lstns.forEach(function(listener) {
            return _this4.broadcastChannel.removeEventListener('internal', listener);
        });
        this._lstns = [];
        this._unl.forEach(function(uFn) {
            return uFn.remove();
        });
        this._unl = [];
        if (this.isLeader) this.isLeader = false;
        this.isDead = true;
        if (this._wKMC.res) this._wKMC.res();
        if (this._wKMC.c) this._wKMC.c.abort('LeaderElectionWebLock.die() called');
        return (0, $8aef705a1e305940$export$3dc3e712f47e19f)(this, 'death');
    }
};


var $da392c4156e3f45a$var$LeaderElection = function LeaderElection(broadcastChannel, options) {
    var _this = this;
    this.broadcastChannel = broadcastChannel;
    this._options = options;
    this.isLeader = false;
    this._hasLeader = false;
    this.isDead = false;
    this.token = (0, $67b3163bad04cd41$export$4e61f672936bec77)();
    /**
   * Apply Queue,
   * used to ensure we do not run applyOnce()
   * in parallel.
   */ this._aplQ = (0, $67b3163bad04cd41$export$5187ac309d2dbc09);
    // amount of unfinished applyOnce() calls
    this._aplQC = 0;
    // things to clean up
    this._unl = []; // _unloads
    this._lstns = []; // _listeners
    this._dpL = function() {}; // onduplicate listener
    this._dpLC = false; // true when onduplicate called
    /**
   * Even when the own instance is not applying,
   * we still listen to messages to ensure the hasLeader flag
   * is set correctly.
   */ var hasLeaderListener = function hasLeaderListener(msg) {
        if (msg.context === 'leader') {
            if (msg.action === 'death') _this._hasLeader = false;
            if (msg.action === 'tell') _this._hasLeader = true;
        }
    };
    this.broadcastChannel.addEventListener('internal', hasLeaderListener);
    this._lstns.push(hasLeaderListener);
};
$da392c4156e3f45a$var$LeaderElection.prototype = {
    hasLeader: function hasLeader() {
        return Promise.resolve(this._hasLeader);
    },
    /**
   * Returns true if the instance is leader,
   * false if not.
   * @async
   */ applyOnce: function applyOnce(// true if the applyOnce() call came from the fallbackInterval cycle
    isFromFallbackInterval) {
        var _this2 = this;
        if (this.isLeader) return (0, $67b3163bad04cd41$export$e772c8ff12451969)(0, true);
        if (this.isDead) return (0, $67b3163bad04cd41$export$e772c8ff12451969)(0, false);
        /**
     * Already applying more than once,
     * -> wait for the apply queue to be finished.
     */ if (this._aplQC > 1) return this._aplQ;
        /**
     * Add a new apply-run
     */ var applyRun = function applyRun() {
            /**
       * Optimization shortcuts.
       * Directly return if a previous run
       * has already elected a leader.
       */ if (_this2.isLeader) return 0, $67b3163bad04cd41$export$b5d9069fca1162b4;
            var stopCriteria = false;
            var stopCriteriaPromiseResolve;
            /**
       * Resolves when a stop criteria is reached.
       * Uses as a performance shortcut so we do not
       * have to await the responseTime when it is already clear
       * that the election failed.
       */ var stopCriteriaPromise = new Promise(function(res) {
                stopCriteriaPromiseResolve = function stopCriteriaPromiseResolve() {
                    stopCriteria = true;
                    res();
                };
            });
            var handleMessage = function handleMessage(msg) {
                if (msg.context === 'leader' && msg.token != _this2.token) {
                    if (msg.action === 'apply') // other is applying
                    {
                        if (msg.token > _this2.token) /**
               * other has higher token
               * -> stop applying and let other become leader.
               */ stopCriteriaPromiseResolve();
                    }
                    if (msg.action === 'tell') {
                        // other is already leader
                        stopCriteriaPromiseResolve();
                        _this2._hasLeader = true;
                    }
                }
            };
            _this2.broadcastChannel.addEventListener('internal', handleMessage);
            /**
       * If the applyOnce() call came from the fallbackInterval,
       * we can assume that the election runs in the background and
       * not critical process is waiting for it.
       * When this is true, we give the other instances
       * more time to answer to messages in the election cycle.
       * This makes it less likely to elect duplicate leaders.
       * But also it takes longer which is not a problem because we anyway
       * run in the background.
       */ var waitForAnswerTime = isFromFallbackInterval ? _this2._options.responseTime * 4 : _this2._options.responseTime;
            return (0, $8aef705a1e305940$export$3dc3e712f47e19f)(_this2, 'apply') // send out that this one is applying
            .then(function() {
                return Promise.race([
                    (0, $67b3163bad04cd41$export$e772c8ff12451969)(waitForAnswerTime),
                    stopCriteriaPromise.then(function() {
                        return Promise.reject(new Error());
                    })
                ]);
            })// send again in case another instance was just created
            .then(function() {
                return (0, $8aef705a1e305940$export$3dc3e712f47e19f)(_this2, 'apply');
            })// let others time to respond
            .then(function() {
                return Promise.race([
                    (0, $67b3163bad04cd41$export$e772c8ff12451969)(waitForAnswerTime),
                    stopCriteriaPromise.then(function() {
                        return Promise.reject(new Error());
                    })
                ]);
            })["catch"](function() {}).then(function() {
                _this2.broadcastChannel.removeEventListener('internal', handleMessage);
                if (!stopCriteria) // no stop criteria -> own is leader
                return (0, $8aef705a1e305940$export$7ef45c3373dd6bfa)(_this2).then(function() {
                    return true;
                });
                else // other is leader
                return false;
            });
        };
        this._aplQC = this._aplQC + 1;
        this._aplQ = this._aplQ.then(function() {
            return applyRun();
        }).then(function() {
            _this2._aplQC = _this2._aplQC - 1;
        });
        return this._aplQ.then(function() {
            return _this2.isLeader;
        });
    },
    awaitLeadership: function awaitLeadership() {
        if (/* _awaitLeadershipPromise */ !this._aLP) this._aLP = $da392c4156e3f45a$var$_awaitLeadershipOnce(this);
        return this._aLP;
    },
    set onduplicate (fn){
        this._dpL = fn;
    },
    die: function die() {
        var _this3 = this;
        this._lstns.forEach(function(listener) {
            return _this3.broadcastChannel.removeEventListener('internal', listener);
        });
        this._lstns = [];
        this._unl.forEach(function(uFn) {
            return uFn.remove();
        });
        this._unl = [];
        if (this.isLeader) {
            this._hasLeader = false;
            this.isLeader = false;
        }
        this.isDead = true;
        return (0, $8aef705a1e305940$export$3dc3e712f47e19f)(this, 'death');
    }
};
/**
 * @param leaderElector {LeaderElector}
 */ function $da392c4156e3f45a$var$_awaitLeadershipOnce(leaderElector) {
    if (leaderElector.isLeader) return 0, $67b3163bad04cd41$export$5187ac309d2dbc09;
    return new Promise(function(res) {
        var resolved = false;
        function finish() {
            if (resolved) return;
            resolved = true;
            leaderElector.broadcastChannel.removeEventListener('internal', whenDeathListener);
            res(true);
        }
        // try once now
        leaderElector.applyOnce().then(function() {
            if (leaderElector.isLeader) finish();
        });
        /**
     * Try on fallbackInterval
     * @recursive
     */ var tryOnFallBack = function tryOnFallBack() {
            return (0, $67b3163bad04cd41$export$e772c8ff12451969)(leaderElector._options.fallbackInterval).then(function() {
                if (leaderElector.isDead || resolved) return;
                if (leaderElector.isLeader) finish();
                else return leaderElector.applyOnce(true).then(function() {
                    if (leaderElector.isLeader) finish();
                    else tryOnFallBack();
                });
            });
        };
        tryOnFallBack();
        // try when other leader dies
        var whenDeathListener = function whenDeathListener(msg) {
            if (msg.context === 'leader' && msg.action === 'death') {
                leaderElector._hasLeader = false;
                leaderElector.applyOnce().then(function() {
                    if (leaderElector.isLeader) finish();
                });
            }
        };
        leaderElector.broadcastChannel.addEventListener('internal', whenDeathListener);
        leaderElector._lstns.push(whenDeathListener);
    });
}
function $da392c4156e3f45a$var$fillOptionsWithDefaults(options, channel) {
    if (!options) options = {};
    options = JSON.parse(JSON.stringify(options));
    if (!options.fallbackInterval) options.fallbackInterval = 3000;
    if (!options.responseTime) options.responseTime = channel.method.averageResponseTime(channel.options);
    return options;
}
function $da392c4156e3f45a$export$36340bbbe5bc42fa(channel, options) {
    if (channel._leaderElector) throw new Error('BroadcastChannel already has a leader-elector');
    options = $da392c4156e3f45a$var$fillOptionsWithDefaults(options, channel);
    var elector = (0, $67b3163bad04cd41$export$9f0d99555d35e998)() ? new (0, $ae5d539d5e66fba5$export$ec7ac9ac703b19d5)(channel, options) : new $da392c4156e3f45a$var$LeaderElection(channel, options);
    channel._befC.push(function() {
        return elector.die();
    });
    channel._leaderElector = elector;
    return elector;
}










class $80bc0564d8a43503$export$3efe6bd3f56fa439 {
    constructor(tokenManager, options = {}){
        this.started = false;
        this.enablePostMessage = true;
        this.tokenManager = tokenManager;
        this.options = options;
        this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this);
        this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this);
        this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this);
        this.onSetStorageHandler = this.onSetStorageHandler.bind(this);
        this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return !!this.options.syncStorage && (0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)() && !this.started;
    }
    async start() {
        if (!this.canStart()) return;
        const { syncChannelName: syncChannelName } = this.options;
        try {
            this.channel = new (0, $3df945c461bccc62$export$f0e5058d63a378d5)(syncChannelName);
        } catch (err) {
            throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('SyncStorageService is not supported in current browser.');
        }
        this.tokenManager.on((0, $d0286a6f22efd2ec$export$e9f9d3905a889e02), this.onTokenAddedHandler);
        this.tokenManager.on((0, $d0286a6f22efd2ec$export$9995ae835670bd28), this.onTokenRemovedHandler);
        this.tokenManager.on((0, $d0286a6f22efd2ec$export$421812244c1f12f0), this.onTokenRenewedHandler);
        this.tokenManager.on((0, $d0286a6f22efd2ec$export$772c2bdc9dda0203), this.onSetStorageHandler);
        this.channel.addEventListener('message', this.onSyncMessageHandler);
        this.started = true;
    }
    async stop() {
        var _a, _b;
        if (this.started) {
            this.tokenManager.off((0, $d0286a6f22efd2ec$export$e9f9d3905a889e02), this.onTokenAddedHandler);
            this.tokenManager.off((0, $d0286a6f22efd2ec$export$9995ae835670bd28), this.onTokenRemovedHandler);
            this.tokenManager.off((0, $d0286a6f22efd2ec$export$421812244c1f12f0), this.onTokenRenewedHandler);
            this.tokenManager.off((0, $d0286a6f22efd2ec$export$772c2bdc9dda0203), this.onSetStorageHandler);
            (_a = this.channel) === null || _a === void 0 || _a.removeEventListener('message', this.onSyncMessageHandler);
            await ((_b = this.channel) === null || _b === void 0 ? void 0 : _b.close());
            this.channel = undefined;
            this.started = false;
        }
    }
    onTokenAddedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) return;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage({
            type: (0, $d0286a6f22efd2ec$export$e9f9d3905a889e02),
            key: key,
            token: token
        });
    }
    onTokenRemovedHandler(key, token) {
        var _a;
        if (!this.enablePostMessage) return;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage({
            type: (0, $d0286a6f22efd2ec$export$9995ae835670bd28),
            key: key,
            token: token
        });
    }
    onTokenRenewedHandler(key, token, oldToken) {
        var _a;
        if (!this.enablePostMessage) return;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage({
            type: (0, $d0286a6f22efd2ec$export$421812244c1f12f0),
            key: key,
            token: token,
            oldToken: oldToken
        });
    }
    onSetStorageHandler(storage) {
        var _a;
        (_a = this.channel) === null || _a === void 0 || _a.postMessage({
            type: (0, $d0286a6f22efd2ec$export$772c2bdc9dda0203),
            storage: storage
        });
    }
    onSyncMessageHandler(msg) {
        this.enablePostMessage = false;
        switch(msg.type){
            case 0, $d0286a6f22efd2ec$export$772c2bdc9dda0203:
                this.tokenManager.getStorage().setStorage(msg.storage);
                break;
            case 0, $d0286a6f22efd2ec$export$e9f9d3905a889e02:
                this.tokenManager.emitAdded(msg.key, msg.token);
                this.tokenManager.setExpireEventTimeout(msg.key, msg.token);
                break;
            case 0, $d0286a6f22efd2ec$export$9995ae835670bd28:
                this.tokenManager.clearExpireEventTimeout(msg.key);
                this.tokenManager.emitRemoved(msg.key, msg.token);
                break;
            case 0, $d0286a6f22efd2ec$export$421812244c1f12f0:
                this.tokenManager.emitRenewed(msg.key, msg.token, msg.oldToken);
                break;
        }
        this.enablePostMessage = true;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

class $bab1852f3cec4782$export$87fb4e9ce3c63b8d {
    constructor(options = {}){
        this.started = false;
        this.options = options;
        this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this);
        this.onLeader = this.onLeader.bind(this);
    }
    onLeaderDuplicate() {}
    async onLeader() {
        var _a, _b;
        await ((_b = (_a = this.options).onLeader) === null || _b === void 0 ? void 0 : _b.call(_a));
    }
    isLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.isLeader);
    }
    hasLeader() {
        var _a;
        return !!((_a = this.elector) === null || _a === void 0 ? void 0 : _a.hasLeader);
    }
    async start() {
        if (this.canStart()) {
            const { electionChannelName: electionChannelName } = this.options;
            this.channel = new (0, $3df945c461bccc62$export$f0e5058d63a378d5)(electionChannelName);
            this.elector = (0, $da392c4156e3f45a$export$36340bbbe5bc42fa)(this.channel);
            this.elector.onduplicate = this.onLeaderDuplicate;
            this.elector.awaitLeadership().then(this.onLeader);
            this.started = true;
        }
    }
    async stop() {
        if (this.started) {
            if (this.elector) {
                await this.elector.die();
                this.elector = undefined;
            }
            if (this.channel) {
                this.channel.postInternal = ()=>Promise.resolve();
                await this.channel.close();
                this.channel = undefined;
            }
            this.started = false;
        }
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
    canStart() {
        return (0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)() && !this.started;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
const $978b2168bdd3923e$var$getNow = ()=>Math.floor(Date.now() / 1000);
class $978b2168bdd3923e$export$138c2d43c98b1c32 {
    constructor(tokenManager, options = {}){
        this.started = false;
        this.lastHidden = -1;
        this.tokenManager = tokenManager;
        this.options = options;
        this.onPageVisbilityChange = this._onPageVisbilityChange.bind(this);
    }
    _onPageVisbilityChange() {
        if (document.hidden) this.lastHidden = $978b2168bdd3923e$var$getNow();
        else if (this.lastHidden > 0 && $978b2168bdd3923e$var$getNow() - this.lastHidden >= this.options.tabInactivityDuration) {
            const { accessToken: accessToken, idToken: idToken } = this.tokenManager.getTokensSync();
            if (!!accessToken && this.tokenManager.hasExpired(accessToken)) {
                const key = this.tokenManager.getStorageKeyByType('accessToken');
                this.tokenManager.renew(key).catch(()=>{});
            } else if (!!idToken && this.tokenManager.hasExpired(idToken)) {
                const key = this.tokenManager.getStorageKeyByType('idToken');
                this.tokenManager.renew(key).catch(()=>{});
            }
        }
    }
    async start() {
        if (this.canStart() && !!document) {
            document.addEventListener('visibilitychange', this.onPageVisbilityChange);
            this.started = true;
        }
    }
    async stop() {
        if (document) {
            document.removeEventListener('visibilitychange', this.onPageVisbilityChange);
            this.started = false;
        }
    }
    canStart() {
        return (0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)() && !!this.options.autoRenew && !!this.options.renewOnTabActivation && !this.started;
    }
    requiresLeadership() {
        return false;
    }
    isStarted() {
        return this.started;
    }
}



const $c9e5f165cd247c69$var$AUTO_RENEW = 'autoRenew';
const $c9e5f165cd247c69$var$SYNC_STORAGE = 'syncStorage';
const $c9e5f165cd247c69$var$LEADER_ELECTION = 'leaderElection';
const $c9e5f165cd247c69$var$RENEW_ON_TAB_ACTIVATION = 'renewOnTabActivation';
class $c9e5f165cd247c69$export$9af02ac651b5d289 {
    constructor(sdk, options = {}){
        this.sdk = sdk;
        this.onLeader = this.onLeader.bind(this);
        const { autoRenew: autoRenew, autoRemove: autoRemove, syncStorage: syncStorage } = sdk.tokenManager.getOptions();
        options.electionChannelName = options.electionChannelName || options.broadcastChannelName;
        this.options = Object.assign({}, $c9e5f165cd247c69$export$9af02ac651b5d289.defaultOptions, {
            autoRenew: autoRenew,
            autoRemove: autoRemove,
            syncStorage: syncStorage
        }, {
            electionChannelName: `${sdk.options.clientId}-election`,
            syncChannelName: `${sdk.options.clientId}-sync`
        }, (0, $12f7cf89ebb788f9$export$1ef1ad6eb7b897a2)(options));
        this.started = false;
        this.services = new Map();
        $c9e5f165cd247c69$export$9af02ac651b5d289.knownServices.forEach((name)=>{
            const svc = this.createService(name);
            if (svc) this.services.set(name, svc);
        });
    }
    async onLeader() {
        if (this.started) await this.startServices();
    }
    isLeader() {
        var _a;
        return (_a = this.getService($c9e5f165cd247c69$var$LEADER_ELECTION)) === null || _a === void 0 ? void 0 : _a.isLeader();
    }
    isLeaderRequired() {
        return [
            ...this.services.values()
        ].some((srv)=>srv.canStart() && srv.requiresLeadership());
    }
    async start() {
        if (this.started) return;
        await this.startServices();
        this.started = true;
    }
    async stop() {
        await this.stopServices();
        this.started = false;
    }
    getService(name) {
        return this.services.get(name);
    }
    async startServices() {
        for (const [name, srv] of this.services.entries())if (this.canStartService(name, srv)) await srv.start();
    }
    async stopServices() {
        for (const srv of this.services.values())await srv.stop();
    }
    canStartService(name, srv) {
        let canStart = srv.canStart() && !srv.isStarted();
        if (name === $c9e5f165cd247c69$var$LEADER_ELECTION) canStart && (canStart = this.isLeaderRequired());
        else if (srv.requiresLeadership()) canStart && (canStart = this.isLeader());
        return canStart;
    }
    createService(name) {
        const tokenManager = this.sdk.tokenManager;
        let service;
        switch(name){
            case $c9e5f165cd247c69$var$LEADER_ELECTION:
                service = new (0, $bab1852f3cec4782$export$87fb4e9ce3c63b8d)(Object.assign(Object.assign({}, this.options), {
                    onLeader: this.onLeader
                }));
                break;
            case $c9e5f165cd247c69$var$AUTO_RENEW:
                service = new (0, $d20c78e661aa59fa$export$6493f06a8769bada)(tokenManager, Object.assign({}, this.options));
                break;
            case $c9e5f165cd247c69$var$SYNC_STORAGE:
                service = new (0, $80bc0564d8a43503$export$3efe6bd3f56fa439)(tokenManager, Object.assign({}, this.options));
                break;
            case $c9e5f165cd247c69$var$RENEW_ON_TAB_ACTIVATION:
                service = new (0, $978b2168bdd3923e$export$138c2d43c98b1c32)(tokenManager, Object.assign({}, this.options));
                break;
            default:
                throw new Error(`Unknown service ${name}`);
        }
        return service;
    }
}
$c9e5f165cd247c69$export$9af02ac651b5d289.knownServices = [
    $c9e5f165cd247c69$var$AUTO_RENEW,
    $c9e5f165cd247c69$var$SYNC_STORAGE,
    $c9e5f165cd247c69$var$LEADER_ELECTION,
    $c9e5f165cd247c69$var$RENEW_ON_TAB_ACTIVATION
];
$c9e5f165cd247c69$export$9af02ac651b5d289.defaultOptions = {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
    renewOnTabActivation: true,
    tabInactivityDuration: 1800
};




function $4d45af1d4a8d9fdb$export$324af875a74d487c(Base) {
    return class OktaAuthCore extends Base {
        constructor(...args){
            super(...args);
            this.authStateManager = new (0, $db58b37edb7f2918$export$98841555a7280e2b)(this);
            this.serviceManager = new (0, $c9e5f165cd247c69$export$9af02ac651b5d289)(this, this.options.services);
        }
        async start() {
            await this.serviceManager.start();
            this.tokenManager.start();
            if (!this.token.isLoginRedirect()) await this.authStateManager.updateAuthState();
        }
        async stop() {
            this.tokenManager.stop();
            await this.serviceManager.stop();
        }
        async handleRedirect(originalUri) {
            await this.handleLoginRedirect(undefined, originalUri);
        }
        async handleLoginRedirect(tokens, originalUri) {
            let state = this.options.state;
            if (tokens) {
                this.tokenManager.setTokens(tokens);
                originalUri = originalUri || this.getOriginalUri(this.options.state);
            } else if (this.isLoginRedirect()) try {
                const oAuthResponse = await (0, $ad10c9d1d686a8d3$export$3cd68b6fe191e121)(this, {});
                state = oAuthResponse.state;
                originalUri = originalUri || this.getOriginalUri(state);
                await this.storeTokensFromRedirect();
            } catch (e) {
                await this.authStateManager.updateAuthState();
                throw e;
            }
            else return;
            await this.authStateManager.updateAuthState();
            this.removeOriginalUri(state);
            const { restoreOriginalUri: restoreOriginalUri } = this.options;
            if (restoreOriginalUri) await restoreOriginalUri(this, originalUri);
            else if (originalUri) window.location.replace(originalUri);
        }
        handleIDPPopupRedirect(url = window.location.href) {
            const res = (0, $ad10c9d1d686a8d3$export$3cd68b6fe191e121)(this, {
                responseMode: 'query',
                url: url
            });
            if (res.state) {
                const channel = new BroadcastChannel(`popup-callback:${res.state}`);
                channel.postMessage(res);
                channel.close();
            } else throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to parse auth code params');
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





parcelRequire("R5nvG");
function $d0f585b4acb5f4bc$export$761080fe0a1126b6(sdk) {
    return sdk.session.get().then(function(res) {
        if (res.status === 'ACTIVE') return true;
        return false;
    }).catch(function() {
        return false;
    });
}
function $d0f585b4acb5f4bc$export$12151e9ef3722552(sdk) {
    return (0, $b8f53662f6ac3919$export$3988ae62b71be9a3)(sdk, '/api/v1/sessions/me', {
        withCredentials: true
    }).then(function(session) {
        var res = (0, $12f7cf89ebb788f9$export$30a06c8d3562193f)(session, '_links');
        res.refresh = function() {
            return (0, $b8f53662f6ac3919$export$299ba2dee77727e9)(sdk, (0, $12f7cf89ebb788f9$export$67e8a86e59c99895)(session, 'refresh').href, {}, {
                withCredentials: true
            });
        };
        res.user = function() {
            return (0, $b8f53662f6ac3919$export$3988ae62b71be9a3)(sdk, (0, $12f7cf89ebb788f9$export$67e8a86e59c99895)(session, 'user').href, {
                withCredentials: true
            });
        };
        return res;
    }).catch(function() {
        return {
            status: 'INACTIVE'
        };
    });
}
function $d0f585b4acb5f4bc$export$56521d9ba90f62ee(sdk) {
    return (0, $b8f53662f6ac3919$export$46f383001bf60e04)(sdk, {
        url: sdk.getIssuerOrigin() + '/api/v1/sessions/me',
        method: 'DELETE',
        withCredentials: true
    });
}
function $d0f585b4acb5f4bc$export$296522b9b583854e(sdk) {
    return (0, $b8f53662f6ac3919$export$299ba2dee77727e9)(sdk, '/api/v1/sessions/me/lifecycle/refresh', {}, {
        withCredentials: true
    });
}
function $d0f585b4acb5f4bc$export$8b02a6d59e051725(sdk, sessionToken, redirectUrl) {
    redirectUrl = redirectUrl || window.location.href;
    window.location.assign(sdk.getIssuerOrigin() + '/login/sessionCookieRedirect' + (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)({
        checkAccountSetupComplete: true,
        token: sessionToken,
        redirectUrl: redirectUrl
    }));
}


function $8b18b2a629f70665$export$26f57a39a58e7109(sdk) {
    const session = {
        close: (0, $d0f585b4acb5f4bc$export$56521d9ba90f62ee).bind(null, sdk),
        exists: (0, $d0f585b4acb5f4bc$export$761080fe0a1126b6).bind(null, sdk),
        get: (0, $d0f585b4acb5f4bc$export$12151e9ef3722552).bind(null, sdk),
        refresh: (0, $d0f585b4acb5f4bc$export$296522b9b583854e).bind(null, sdk),
        setCookieAndRedirect: (0, $d0f585b4acb5f4bc$export$8b02a6d59e051725).bind(null, sdk)
    };
    return session;
}


function $17bebb0ac662acac$export$e29a1eee069c5053(Base) {
    return class OktaAuthSession extends Base {
        constructor(...args){
            super(...args);
            this.session = (0, $8b18b2a629f70665$export$26f57a39a58e7109)(this);
        }
        closeSession() {
            return this.session.close().then(async ()=>{
                this.clearStorage();
                return true;
            }).catch(function(e) {
                if (e.name === 'AuthApiError' && e.errorCode === 'E0000007') return false;
                throw e;
            });
        }
    };
}


function $fd07cc163b789d7f$export$30ddaac95d0f4b52(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = (0, $c9fbd110bc9c9442$export$2bc41dfbf048bfdc)(OptionsConstructor);
    const WithStorage = (0, $a8d31580460d70f9$export$32ec6248008f35d1)(Base, StorageManagerConstructor);
    const WithHttp = (0, $00e95a529c550931$export$b21483dcd2900eca)(WithStorage);
    const WithSession = (0, $17bebb0ac662acac$export$e29a1eee069c5053)(WithHttp);
    const WithOAuth = (0, $f919f60b8d93e7bc$export$d2d79cf72153e095)(WithSession, TransactionManagerConstructor);
    const Core = (0, $4d45af1d4a8d9fdb$export$324af875a74d487c)(WithOAuth);
    return Core;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 






parcelRequire("R5nvG");


const $888ed34a31dbe4d4$var$isMessageFromCorrectSource = (iframe, event)=>event.source === iframe.contentWindow;
function $888ed34a31dbe4d4$export$2e2bcd8739ae039(sdk, options) {
    var _a;
    if (!(0, $cbeaafbff16be8ee$export$cfef6ce26ae59877)()) return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Fingerprinting is not supported on this device'));
    const container = (_a = options === null || options === void 0 ? void 0 : options.container) !== null && _a !== void 0 ? _a : document.body;
    let timeout;
    let iframe;
    let listener;
    const promise = new Promise(function(resolve, reject) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        listener = function listener(e) {
            var _a;
            if (!$888ed34a31dbe4d4$var$isMessageFromCorrectSource(iframe, e)) return;
            if (!e || !e.data || e.origin !== sdk.getIssuerOrigin()) return;
            let msg;
            try {
                msg = JSON.parse(e.data);
            } catch (err) {
                return;
            }
            if (!msg) return;
            if (msg.type === 'FingerprintAvailable') return resolve(msg.fingerprint);
            else if (msg.type === 'FingerprintServiceReady') (_a = iframe === null || iframe === void 0 ? void 0 : iframe.contentWindow) === null || _a === void 0 || _a.postMessage(JSON.stringify({
                type: 'GetFingerprint'
            }), e.origin);
            else return reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('No data'));
        };
        (0, $66c790c4f771c9c9$export$f03a6b845d3fb58b)(window, 'message', listener);
        iframe.src = sdk.getIssuerOrigin() + '/auth/services/devicefingerprint';
        container.appendChild(iframe);
        timeout = setTimeout(function() {
            reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Fingerprinting timed out'));
        }, (options === null || options === void 0 ? void 0 : options.timeout) || 15000);
    });
    return promise.finally(function() {
        var _a;
        clearTimeout(timeout);
        (0, $66c790c4f771c9c9$export$b03e9483f936dccb)(window, 'message', listener);
        if (container.contains(iframe)) (_a = iframe.parentElement) === null || _a === void 0 || _a.removeChild(iframe);
    });
}


var $c28cbc44a96efb13$exports = {};

$parcel$export($c28cbc44a96efb13$exports, "buildCredentialCreationOptions", () => $c28cbc44a96efb13$export$8509032865b5aecb);
$parcel$export($c28cbc44a96efb13$exports, "buildCredentialRequestOptions", () => $c28cbc44a96efb13$export$b6208251c25a1fb5);
$parcel$export($c28cbc44a96efb13$exports, "getAttestation", () => $c28cbc44a96efb13$export$fbeebbd9ab90644e);
$parcel$export($c28cbc44a96efb13$exports, "getAssertion", () => $c28cbc44a96efb13$export$191af95378f46deb);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
const $c28cbc44a96efb13$var$getEnrolledCredentials = (authenticatorEnrollments = [])=>{
    const credentials = [];
    authenticatorEnrollments.forEach((enrollement)=>{
        if (enrollement.key === 'webauthn') credentials.push({
            type: 'public-key',
            id: (0, $a2b7a7081fca65c9$export$74669d1cb8191241)(enrollement.credentialId)
        });
    });
    return credentials;
};
const $c28cbc44a96efb13$export$8509032865b5aecb = (activationData, authenticatorEnrollments)=>{
    return {
        publicKey: {
            rp: activationData.rp,
            user: {
                id: (0, $a2b7a7081fca65c9$export$74669d1cb8191241)(activationData.user.id),
                name: activationData.user.name,
                displayName: activationData.user.displayName
            },
            challenge: (0, $a2b7a7081fca65c9$export$74669d1cb8191241)(activationData.challenge),
            pubKeyCredParams: activationData.pubKeyCredParams,
            attestation: activationData.attestation,
            authenticatorSelection: activationData.authenticatorSelection,
            excludeCredentials: $c28cbc44a96efb13$var$getEnrolledCredentials(authenticatorEnrollments)
        }
    };
};
const $c28cbc44a96efb13$export$b6208251c25a1fb5 = (challengeData, authenticatorEnrollments)=>{
    return {
        publicKey: Object.assign({
            challenge: (0, $a2b7a7081fca65c9$export$74669d1cb8191241)(challengeData.challenge),
            userVerification: challengeData.userVerification,
            allowCredentials: $c28cbc44a96efb13$var$getEnrolledCredentials(authenticatorEnrollments)
        }, challengeData.rpId && {
            rpId: challengeData.rpId
        })
    };
};
const $c28cbc44a96efb13$export$fbeebbd9ab90644e = (credential)=>{
    const response = credential.response;
    const id = credential.id;
    const clientData = (0, $a2b7a7081fca65c9$export$271320a6f6117eda)(response.clientDataJSON);
    const attestation = (0, $a2b7a7081fca65c9$export$271320a6f6117eda)(response.attestationObject);
    return {
        id: id,
        clientData: clientData,
        attestation: attestation
    };
};
const $c28cbc44a96efb13$export$191af95378f46deb = (credential)=>{
    const response = credential.response;
    const id = credential.id;
    const clientData = (0, $a2b7a7081fca65c9$export$271320a6f6117eda)(response.clientDataJSON);
    const authenticatorData = (0, $a2b7a7081fca65c9$export$271320a6f6117eda)(response.authenticatorData);
    const signatureData = (0, $a2b7a7081fca65c9$export$271320a6f6117eda)(response.signature);
    return {
        id: id,
        clientData: clientData,
        authenticatorData: authenticatorData,
        signatureData: signatureData
    };
};


function $eb053d7c9ac5ee1d$export$52c91c927fe5f302(Base) {
    var _a;
    return _a = class OktaAuthIdx extends Base {
        constructor(...args){
            super(...args);
            this.idx = (0, $29e563c9dcc80d37$export$8e517878c6a5f058)(this);
            this.fingerprint = (0, $888ed34a31dbe4d4$export$2e2bcd8739ae039).bind(null, this);
        }
    }, _a.webauthn = $c28cbc44a96efb13$exports, _a;
}


function $4840a53cd80d1314$export$2f30fde9bc853c45(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Core = (0, $fd07cc163b789d7f$export$30ddaac95d0f4b52)(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor);
    const WithIdx = (0, $eb053d7c9ac5ee1d$export$52c91c927fe5f302)(Core);
    return WithIdx;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $cd202855894c11b5$export$114e54a1663ffe2b(minimalSdk) {
    const sdk = minimalSdk;
    const boundStartTransaction = (0, $c23e535dab837f8f$export$e262da7ae6480481).bind(null, sdk);
    const idx = {
        makeIdxResponse: (0, $40b25ced63ff9c03$export$67f6ec95030789e9).bind(null, sdk),
        start: boundStartTransaction,
        startTransaction: boundStartTransaction,
        proceed: (0, $34685933a0d26280$export$2eb0bdfd23e39c86).bind(null, sdk),
        canProceed: (0, $34685933a0d26280$export$2b22a8feb63a44b6).bind(null, sdk),
        getSavedTransactionMeta: (0, $c6cd386983d9ca48$export$ee78659ae5675f26).bind(null, sdk),
        createTransactionMeta: (0, $c6cd386983d9ca48$export$88d345acadfc62dd).bind(null, sdk),
        getTransactionMeta: (0, $c6cd386983d9ca48$export$701cc743c44cf8ae).bind(null, sdk),
        saveTransactionMeta: (0, $c6cd386983d9ca48$export$dc27696b235944d6).bind(null, sdk),
        clearTransactionMeta: (0, $c6cd386983d9ca48$export$750593bdfc027325).bind(null, sdk),
        isTransactionMetaValid: $c6cd386983d9ca48$export$e14be23af70c5fd
    };
    return idx;
}




function $3f1ec4f234e491ce$export$48e102243775c07d(Base) {
    var _a;
    return _a = class OktaAuthIdx extends Base {
        constructor(...args){
            super(...args);
            this.idx = (0, $cd202855894c11b5$export$114e54a1663ffe2b)(this);
            this.fingerprint = (0, $888ed34a31dbe4d4$export$2e2bcd8739ae039).bind(null, this);
        }
    }, _a.webauthn = $c28cbc44a96efb13$exports, _a;
}






/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




function $c678a2f434f90b0a$export$e0734cedaf22f563(sdk) {
    const token = {
        prepareTokenParams: (0, $400c3bc75835f4ee$export$6aa55a8b4ad50d4b).bind(null, sdk),
        exchangeCodeForTokens: (0, $764e1439617c040b$export$b0d0dc26369c3965).bind(null, sdk),
        decode: (0, $9048550239ebf2b7$export$4b61618bdb99cb7e)
    };
    return token;
}







parcelRequire("R5nvG");

function $5fae114f58d90400$export$d24a04a5726d348a(Base, TransactionManagerConstructor) {
    return class OktaAuthOAuth extends Base {
        constructor(...args){
            super(...args);
            this.transactionManager = new TransactionManagerConstructor(Object.assign({
                storageManager: this.storageManager
            }, this.options.transactionManager));
            this.token = (0, $c678a2f434f90b0a$export$e0734cedaf22f563)(this);
        }
        isLoginRedirect() {
            return (0, $e49ac4003f707fb9$export$3488c667ccc91890)(this);
        }
        isPKCE() {
            return !!this.options.pkce;
        }
        hasResponseType(responseType) {
            return (0, $e49ac4003f707fb9$export$85f1abab17a58c57)(responseType, this.options);
        }
        isAuthorizationCodeFlow() {
            return this.hasResponseType('code');
        }
    };
}


function $7795613a5461b78c$export$6b6296e34782c8ba(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = (0, $c9fbd110bc9c9442$export$2bc41dfbf048bfdc)(OptionsConstructor);
    const WithStorage = (0, $a8d31580460d70f9$export$32ec6248008f35d1)(Base, StorageManagerConstructor);
    const WithHttp = (0, $00e95a529c550931$export$b21483dcd2900eca)(WithStorage);
    const WithSession = (0, $17bebb0ac662acac$export$e29a1eee069c5053)(WithHttp);
    const WithOAuth = (0, $5fae114f58d90400$export$d24a04a5726d348a)(WithSession, TransactionManagerConstructor);
    const WithIdx = (0, $3f1ec4f234e491ce$export$48e102243775c07d)(WithOAuth);
    return WithIdx;
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



parcelRequire("R5nvG");


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $bc12001d511bdec9$export$bca8fa66398c16c1() {
    return class BaseOptionsConstructor {
        constructor(args){
            this.devMode = !!args.devMode;
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

function $30dc471df413c06d$export$fbd9b57a66480737() {
    const storageUtil$1 = Object.assign({}, (0, $ec110d42afefa4d4$export$2e2bcd8739ae039), {
        inMemoryStore: {}
    });
    return storageUtil$1;
}
const $30dc471df413c06d$export$e228d94b1bf0c1f = {
    token: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    cache: {
        storageTypes: [
            'localStorage',
            'sessionStorage',
            'cookie'
        ]
    },
    transaction: {
        storageTypes: [
            'sessionStorage',
            'localStorage',
            'cookie'
        ]
    },
    'shared-transaction': {
        storageTypes: [
            'localStorage'
        ]
    },
    'original-uri': {
        storageTypes: [
            'localStorage'
        ]
    }
};
function $30dc471df413c06d$export$df8a26958a7f0c1a(args = {}, isHTTPS) {
    var cookieSettings = args.cookies || {};
    if (typeof cookieSettings.secure === 'undefined') cookieSettings.secure = isHTTPS;
    if (typeof cookieSettings.sameSite === 'undefined') cookieSettings.sameSite = cookieSettings.secure ? 'none' : 'lax';
    if (cookieSettings.secure && !isHTTPS) {
        (0, $5502e384469ea433$export$c106dd0671a0fc2d)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.');
        cookieSettings.secure = false;
    }
    if (cookieSettings.sameSite === 'none' && !cookieSettings.secure) cookieSettings.sameSite = 'lax';
    return cookieSettings;
}


function $f87612c25cb7ad7f$export$51d1a53a62bacfd9() {
    const BaseOptionsConstructor = (0, $bc12001d511bdec9$export$bca8fa66398c16c1)();
    return class StorageOptionsConstructor extends BaseOptionsConstructor {
        constructor(args){
            super(args);
            this.cookies = (0, $30dc471df413c06d$export$df8a26958a7f0c1a)(args, (0, $cbeaafbff16be8ee$export$ab537f3fcabe7053)());
            this.storageUtil = args.storageUtil || (0, $30dc471df413c06d$export$fbd9b57a66480737)();
            this.storageManager = Object.assign(Object.assign({}, (0, $30dc471df413c06d$export$e228d94b1bf0c1f)), args.storageManager);
        }
    };
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
var $R5nvG = parcelRequire("R5nvG");
const $5e62373b7ba6c71e$var$appJsonContentTypeRegex = /application\/\w*\+?json/;
function $5e62373b7ba6c71e$var$readData(response) {
    if (response.headers.get('Content-Type') && response.headers.get('Content-Type').toLowerCase().indexOf('application/json') >= 0) return response.json().catch((e)=>{
        return {
            error: e,
            errorSummary: 'Could not parse server response'
        };
    });
    else return response.text();
}
function $5e62373b7ba6c71e$var$formatResult(status, data, response) {
    const isObject = typeof data === 'object';
    const headers = {};
    for (const pair of response.headers.entries())headers[pair[0]] = pair[1];
    const result = {
        responseText: isObject ? JSON.stringify(data) : data,
        status: status,
        headers: headers
    };
    if (isObject) {
        result.responseType = 'json';
        result.responseJSON = data;
    }
    return result;
}
function $5e62373b7ba6c71e$export$2e2bcd8739ae039(method, url, args) {
    var body = args.data;
    var headers = args.headers || {};
    var contentType = headers['Content-Type'] || headers['content-type'] || '';
    if (body && typeof body !== 'string') {
        if ($5e62373b7ba6c71e$var$appJsonContentTypeRegex.test(contentType)) body = JSON.stringify(body);
        else if (contentType === 'application/x-www-form-urlencoded') body = Object.entries(body).map(([param, value])=>`${param}=${encodeURIComponent(value)}`).join('&');
    }
    var fetch = window.fetch || (0, (/*@__PURE__*/$parcel$interopDefault($R5nvG)));
    var fetchPromise = fetch(url, {
        method: method,
        headers: args.headers,
        body: body,
        credentials: args.withCredentials ? 'include' : 'omit'
    });
    if (!fetchPromise.finally) fetchPromise = Promise.resolve(fetchPromise);
    return fetchPromise.then(function(response) {
        var error = !response.ok;
        var status = response.status;
        return $5e62373b7ba6c71e$var$readData(response).then((data)=>{
            return $5e62373b7ba6c71e$var$formatResult(status, data, response);
        }).then((result)=>{
            var _a;
            if (error || ((_a = result.responseJSON) === null || _a === void 0 ? void 0 : _a.error)) throw result;
            return result;
        });
    });
}


function $b30ecf6ff5e4c654$export$b53ab73ced457e7c() {
    const StorageOptionsConstructor = (0, $f87612c25cb7ad7f$export$51d1a53a62bacfd9)();
    return class HttpOptionsConstructor extends StorageOptionsConstructor {
        constructor(args){
            super(args);
            this.issuer = args.issuer;
            this.transformErrorXHR = args.transformErrorXHR;
            this.headers = args.headers;
            this.httpRequestClient = args.httpRequestClient || (0, $5e62373b7ba6c71e$export$2e2bcd8739ae039);
            this.httpRequestInterceptors = args.httpRequestInterceptors;
            this.pollDelay = args.pollDelay;
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ const $407b79cf24adb79a$export$b5983bbbbf9d3e4b = true;



function $9b63573e7205fc5e$var$assertValidConfig(args) {
    args = args || {};
    var scopes = args.scopes;
    if (scopes && !Array.isArray(scopes)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
    var issuer = args.issuer;
    if (!issuer) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    var isUrlRegex = new RegExp('^http?s?://.+');
    if (!isUrlRegex.test(issuer)) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
    if (issuer.indexOf('-admin.okta') !== -1) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
}
function $9b63573e7205fc5e$export$a8a46368b9c2e15c() {
    const HttpOptionsConstructor = (0, $b30ecf6ff5e4c654$export$b53ab73ced457e7c)();
    return class OAuthOptionsConstructor extends HttpOptionsConstructor {
        constructor(options){
            super(options);
            $9b63573e7205fc5e$var$assertValidConfig(options);
            this.issuer = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.issuer);
            this.tokenUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.tokenUrl);
            this.authorizeUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.authorizeUrl);
            this.userinfoUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.userinfoUrl);
            this.revokeUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.revokeUrl);
            this.logoutUrl = (0, $83e7c3a0ba92185e$export$b6d465111d914331)(options.logoutUrl);
            this.pkce = options.pkce === false ? false : true;
            this.clientId = options.clientId;
            this.redirectUri = options.redirectUri;
            if ((0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)()) this.redirectUri = (0, $83e7c3a0ba92185e$export$7895c48e9c019048)(options.redirectUri, window.location.origin);
            this.responseType = options.responseType;
            this.responseMode = options.responseMode;
            this.state = options.state;
            this.scopes = options.scopes;
            this.ignoreSignature = !!options.ignoreSignature;
            this.codeChallenge = options.codeChallenge;
            this.codeChallengeMethod = options.codeChallengeMethod;
            this.acrValues = options.acrValues;
            this.maxAge = options.maxAge;
            this.dpop = options.dpop === true;
            this.dpopOptions = Object.assign({
                allowBearerTokens: false
            }, options.dpopOptions);
            this.tokenManager = options.tokenManager;
            this.postLogoutRedirectUri = options.postLogoutRedirectUri;
            this.restoreOriginalUri = options.restoreOriginalUri;
            this.transactionManager = Object.assign({
                enableSharedStorage: $407b79cf24adb79a$export$b5983bbbbf9d3e4b
            }, options.transactionManager);
            this.clientSecret = options.clientSecret;
            this.setLocation = options.setLocation;
            this.ignoreLifetime = !!options.ignoreLifetime;
            if (!options.maxClockSkew && options.maxClockSkew !== 0) this.maxClockSkew = (0, $2119f0a66eb38a81$export$a842e30d5ade6c4c);
            else this.maxClockSkew = options.maxClockSkew;
        }
    };
}


function $a40ca30023670f2c$export$91562c406dfe69db() {
    const OAuthOptionsConstructor = (0, $9b63573e7205fc5e$export$a8a46368b9c2e15c)();
    return class CoreOptionsConstructor extends OAuthOptionsConstructor {
        constructor(options){
            super(options);
            this.services = options.services;
            this.transformAuthState = options.transformAuthState;
        }
    };
}


function $1d6cfd8b0fe5848e$export$2fa277826aad984c() {
    const CoreOptionsConstructor = (0, $a40ca30023670f2c$export$91562c406dfe69db)();
    return class IdxOptionsConstructor extends CoreOptionsConstructor {
        constructor(options){
            super(options);
            this.flow = options.flow;
            this.activationToken = options.activationToken;
            this.recoveryToken = options.recoveryToken;
            this.idx = options.idx;
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $cedeae17a91a2fb6$export$97309a63b39c07f4 {
    constructor(storage, storageName){
        if (!storage) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('"storage" is required');
        if (typeof storageName !== 'string' || !storageName.length) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('"storageName" is required');
        this.storageName = storageName;
        this.storageProvider = storage;
    }
    getItem(key) {
        return this.getStorage()[key];
    }
    setItem(key, value) {
        return this.updateStorage(key, value);
    }
    removeItem(key) {
        return this.clearStorage(key);
    }
    getStorage() {
        var storageString = this.storageProvider.getItem(this.storageName);
        storageString = storageString || '{}';
        try {
            return JSON.parse(storageString);
        } catch (e) {
            throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to parse storage string: ' + this.storageName);
        }
    }
    setStorage(obj) {
        try {
            var storageString = obj ? JSON.stringify(obj) : '{}';
            this.storageProvider.setItem(this.storageName, storageString);
        } catch (e) {
            throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unable to set storage: ' + this.storageName);
        }
    }
    clearStorage(key) {
        if (!key) {
            if (this.storageProvider.removeItem) this.storageProvider.removeItem(this.storageName);
            else this.setStorage();
            return;
        }
        var obj = this.getStorage();
        delete obj[key];
        this.setStorage(obj);
    }
    updateStorage(key, value) {
        var obj = this.getStorage();
        obj[key] = value;
        this.setStorage(obj);
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $76a2c5ca937f4625$export$42dacca56fe5cf27(options) {
    if (!(0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)() && !options.storageProvider && !options.storageKey) (0, $5502e384469ea433$export$c106dd0671a0fc2d)('Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.');
}
class $76a2c5ca937f4625$export$d35eaa92cfe799ab {
    constructor(storageManagerOptions, cookieOptions, storageUtil){
        this.storageManagerOptions = storageManagerOptions;
        this.cookieOptions = cookieOptions;
        this.storageUtil = storageUtil;
    }
    getOptionsForSection(sectionName, overrideOptions) {
        return Object.assign({}, this.storageManagerOptions[sectionName], overrideOptions);
    }
    getStorage(options) {
        options = Object.assign({}, this.cookieOptions, options);
        if (options.storageProvider) return options.storageProvider;
        let { storageType: storageType, storageTypes: storageTypes } = options;
        if (storageType === 'sessionStorage') options.sessionCookie = true;
        if (storageType && storageTypes) {
            const idx = storageTypes.indexOf(storageType);
            if (idx >= 0) {
                storageTypes = storageTypes.slice(idx);
                storageType = undefined;
            }
        }
        if (!storageType) storageType = this.storageUtil.findStorageType(storageTypes);
        return this.storageUtil.getStorageByType(storageType, options);
    }
    getTokenStorage(options) {
        options = this.getOptionsForSection('token', options);
        $76a2c5ca937f4625$export$42dacca56fe5cf27(options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || (0, $2119f0a66eb38a81$export$45d1f6fc12799d40);
        return new (0, $cedeae17a91a2fb6$export$97309a63b39c07f4)(storage, storageKey);
    }
    getHttpCache(options) {
        options = this.getOptionsForSection('cache', options);
        const storage = this.getStorage(options);
        const storageKey = options.storageKey || (0, $2119f0a66eb38a81$export$e9f2fad0ae10585a);
        return new (0, $cedeae17a91a2fb6$export$97309a63b39c07f4)(storage, storageKey);
    }
}







function $24d65e79103ebb5e$export$b5a8c24775630d4() {
    return class OAuthStorageManager extends (0, $76a2c5ca937f4625$export$d35eaa92cfe799ab) {
        constructor(storageManagerOptions, cookieOptions, storageUtil){
            super(storageManagerOptions, cookieOptions, storageUtil);
        }
        getTransactionStorage(options) {
            options = this.getOptionsForSection('transaction', options);
            (0, $76a2c5ca937f4625$export$42dacca56fe5cf27)(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || (0, $2119f0a66eb38a81$export$8cc5d1fc2dba148d);
            return new (0, $cedeae17a91a2fb6$export$97309a63b39c07f4)(storage, storageKey);
        }
        getSharedTansactionStorage(options) {
            options = this.getOptionsForSection('shared-transaction', options);
            (0, $76a2c5ca937f4625$export$42dacca56fe5cf27)(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || (0, $2119f0a66eb38a81$export$b9b27de9edfa5b8);
            return new (0, $cedeae17a91a2fb6$export$97309a63b39c07f4)(storage, storageKey);
        }
        getOriginalUriStorage(options) {
            options = this.getOptionsForSection('original-uri', options);
            (0, $76a2c5ca937f4625$export$42dacca56fe5cf27)(options);
            const storage = this.getStorage(options);
            const storageKey = options.storageKey || (0, $2119f0a66eb38a81$export$ad9943119a111be1);
            return new (0, $cedeae17a91a2fb6$export$97309a63b39c07f4)(storage, storageKey);
        }
    };
}


function $f09f65bb6eb88043$export$369b2d2a586a4a97() {
    return (0, $24d65e79103ebb5e$export$b5a8c24775630d4)();
}


function $18a15d5a8bf62586$export$247998cd7cb1a236() {
    const CoreStorageManager = (0, $f09f65bb6eb88043$export$369b2d2a586a4a97)();
    return class IdxStorageManager extends CoreStorageManager {
        constructor(storageManagerOptions, cookieOptions, storageUtil){
            super(storageManagerOptions, cookieOptions, storageUtil);
        }
        getIdxResponseStorage(options) {
            let storage;
            if ((0, $cbeaafbff16be8ee$export$4e09c449d6c407f7)()) try {
                storage = this.storageUtil.getStorageByType('memory', options);
            } catch (e) {
                (0, $5502e384469ea433$export$c106dd0671a0fc2d)('No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic');
            }
            else {
                const transactionStorage = this.getTransactionStorage(options);
                if (transactionStorage) storage = {
                    getItem: (key)=>{
                        const transaction = transactionStorage.getStorage();
                        if (transaction && transaction[key]) return transaction[key];
                        return null;
                    },
                    setItem: (key, val)=>{
                        const transaction = transactionStorage.getStorage();
                        if (!transaction) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Transaction has been cleared, failed to save idxState');
                        transaction[key] = val;
                        transactionStorage.setStorage(transaction);
                    },
                    removeItem: (key)=>{
                        const transaction = transactionStorage.getStorage();
                        if (!transaction) return;
                        delete transaction[key];
                        transactionStorage.setStorage(transaction);
                    }
                };
            }
            if (!storage) return null;
            return new (0, $cedeae17a91a2fb6$export$97309a63b39c07f4)(storage, (0, $2119f0a66eb38a81$export$48bfce2bad4674d4));
        }
    };
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $81df3f8c0be53a1b$var$isObjectWithProperties(obj) {
    if (!obj || typeof obj !== 'object' || Object.values(obj).length === 0) return false;
    return true;
}
function $81df3f8c0be53a1b$export$2c31ab53ed7268d0(obj) {
    if (!$81df3f8c0be53a1b$var$isObjectWithProperties(obj)) return false;
    return !!obj.redirectUri || !!obj.responseType;
}
function $81df3f8c0be53a1b$export$9ff73b7b6b48b89b(obj) {
    if (!$81df3f8c0be53a1b$export$2c31ab53ed7268d0(obj)) return false;
    return !!obj.codeVerifier;
}
function $81df3f8c0be53a1b$export$12d8cd31b998c811(obj) {
    if (!$81df3f8c0be53a1b$export$9ff73b7b6b48b89b(obj)) return false;
    return !!obj.interactionHandle;
}
function $81df3f8c0be53a1b$export$af4ec149c0918e9e(obj) {
    if (!$81df3f8c0be53a1b$var$isObjectWithProperties(obj)) return false;
    const isAllStringValues = Object.values(obj).find((value)=>typeof value !== 'string') === undefined;
    return isAllStringValues;
}
function $81df3f8c0be53a1b$export$7534e1eab18cefa3(obj) {
    if ($81df3f8c0be53a1b$export$2c31ab53ed7268d0(obj) || $81df3f8c0be53a1b$export$af4ec149c0918e9e(obj)) return true;
    return false;
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

const $c3595a42fdd4d210$var$MAX_ENTRY_LIFETIME = 1800000;
function $c3595a42fdd4d210$export$3d13e64cc36d4572(storageManager) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    Object.keys(entries).forEach((state)=>{
        const entry = entries[state];
        const age = Date.now() - entry.dateCreated;
        if (age > $c3595a42fdd4d210$var$MAX_ENTRY_LIFETIME) delete entries[state];
    });
    sharedStorage.setStorage(entries);
}
function $c3595a42fdd4d210$export$3672cb2530753163(storageManager, state, meta) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    entries[state] = {
        dateCreated: Date.now(),
        transaction: meta
    };
    sharedStorage.setStorage(entries);
}
function $c3595a42fdd4d210$export$6620a91132e8e844(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    const entry = entries[state];
    if (entry && entry.transaction && (0, $81df3f8c0be53a1b$export$7534e1eab18cefa3)(entry.transaction)) return entry.transaction;
    return null;
}
function $c3595a42fdd4d210$export$9ef4c193f57137d6(storageManager, state) {
    const sharedStorage = storageManager.getSharedTansactionStorage();
    const entries = sharedStorage.getStorage();
    delete entries[state];
    sharedStorage.setStorage(entries);
}


function $a635f3738bb0e1c5$export$53d8870de99c17a6() {
    return class TransactionManager {
        constructor(options){
            this.storageManager = options.storageManager;
            this.enableSharedStorage = options.enableSharedStorage === false ? false : true;
            this.saveLastResponse = options.saveLastResponse === false ? false : true;
            this.options = options;
        }
        clear(options = {}) {
            const transactionStorage = this.storageManager.getTransactionStorage();
            const meta = transactionStorage.getStorage();
            transactionStorage.clearStorage();
            if (this.enableSharedStorage && options.clearSharedStorage !== false) {
                const state = options.state || (meta === null || meta === void 0 ? void 0 : meta.state);
                if (state) (0, $c3595a42fdd4d210$export$9ef4c193f57137d6)(this.storageManager, state);
            }
        }
        save(meta, options = {}) {
            let storage = this.storageManager.getTransactionStorage();
            const obj = storage.getStorage();
            if ((0, $81df3f8c0be53a1b$export$7534e1eab18cefa3)(obj) && !options.muteWarning) (0, $5502e384469ea433$export$c106dd0671a0fc2d)('a saved auth transaction exists in storage. This may indicate another auth flow is already in progress.');
            storage.setStorage(meta);
            if (this.enableSharedStorage && meta.state) (0, $c3595a42fdd4d210$export$3672cb2530753163)(this.storageManager, meta.state, meta);
        }
        exists(options = {}) {
            try {
                const meta = this.load(options);
                return !!meta;
            } catch (_a) {
                return false;
            }
        }
        load(options = {}) {
            let meta;
            if (this.enableSharedStorage && options.state) {
                (0, $c3595a42fdd4d210$export$3d13e64cc36d4572)(this.storageManager);
                meta = (0, $c3595a42fdd4d210$export$6620a91132e8e844)(this.storageManager, options.state);
                if ((0, $81df3f8c0be53a1b$export$7534e1eab18cefa3)(meta)) return meta;
            }
            let storage = this.storageManager.getTransactionStorage();
            meta = storage.getStorage();
            if ((0, $81df3f8c0be53a1b$export$7534e1eab18cefa3)(meta)) return meta;
            return null;
        }
    };
}



function $7e0af16c65d469cc$export$b5a6d650030beee() {
    const TransactionManager = (0, $a635f3738bb0e1c5$export$53d8870de99c17a6)();
    return class IdxTransactionManager extends TransactionManager {
        constructor(options){
            super(options);
        }
        clear(options = {}) {
            super.clear(options);
            if (options.clearIdxResponse !== false) this.clearIdxResponse();
        }
        saveIdxResponse(data) {
            if (!this.saveLastResponse) return;
            const storage = this.storageManager.getIdxResponseStorage();
            if (!storage) return;
            storage.setStorage(data);
        }
        loadIdxResponse(options) {
            if (!this.saveLastResponse) return null;
            const storage = this.storageManager.getIdxResponseStorage();
            if (!storage) return null;
            const storedValue = storage.getStorage();
            if (!storedValue || !(0, $b09480b83b84af67$export$e440ed50f1b21dd3)(storedValue.rawIdxResponse)) return null;
            if (options) {
                const { stateHandle: stateHandle, interactionHandle: interactionHandle } = options;
                if (!options.useGenericRemediator && stateHandle && storedValue.stateHandle !== stateHandle) return null;
                if (interactionHandle && storedValue.interactionHandle !== interactionHandle) return null;
            }
            return storedValue;
        }
        clearIdxResponse() {
            if (!this.saveLastResponse) return;
            const storage = this.storageManager.getIdxResponseStorage();
            storage === null || storage === void 0 || storage.clearStorage();
        }
    };
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $decb80f88c3e7cdc$export$2e2bcd8739ae039 {
    constructor(oktaAuth, options){
        const { res: res } = options;
        const { headers: headers } = res, rest = (0, $ca95e6f9e1ec9f80$export$3c9a16f847548506)(res, [
            "headers"
        ]);
        if (headers) this.headers = headers;
        Object.keys(rest).forEach((key)=>{
            if (key === '_links') return;
            this[key] = rest[key];
        });
    }
}







parcelRequire("R5nvG");
async function $8d4197a9d18ec07b$export$d5a1e65f8aa21b51(oktaAuth, options, TransactionClass = (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039)) {
    const { accessToken: accessTokenObj } = oktaAuth.tokenManager.getTokensSync();
    const atToken = options.accessToken || accessTokenObj;
    const issuer = oktaAuth.getIssuerOrigin();
    const { url: url, method: method, payload: payload } = options;
    const requestUrl = url.startsWith(issuer) ? url : `${issuer}${url}`;
    if (!atToken) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('AccessToken is required to request MyAccount API endpoints.');
    let accessToken = atToken;
    const httpOptions = Object.assign({
        headers: {
            'Accept': '*/*;okta-version=1.0.0'
        },
        url: requestUrl,
        method: method
    }, payload && {
        args: payload
    });
    if (oktaAuth.options.dpop) {
        if (typeof accessToken === 'string') throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('AccessToken object must be provided when using dpop');
        const { Authorization: Authorization, Dpop: Dpop } = await oktaAuth.getDPoPAuthorizationHeaders({
            method: method,
            url: requestUrl,
            accessToken: accessToken
        });
        httpOptions.headers.Authorization = Authorization;
        httpOptions.headers.Dpop = Dpop;
    } else {
        accessToken = typeof accessToken === 'string' ? accessToken : accessToken.accessToken;
        httpOptions.accessToken = accessToken;
    }
    const res = await (0, $b8f53662f6ac3919$export$46f383001bf60e04)(oktaAuth, httpOptions);
    let ret;
    if (Array.isArray(res)) ret = res.map((item)=>new TransactionClass(oktaAuth, {
            res: item,
            accessToken: accessToken
        }));
    else ret = new TransactionClass(oktaAuth, {
        res: res,
        accessToken: accessToken
    });
    return ret;
}
function $8d4197a9d18ec07b$export$cb8be9d51a72960a({ oktaAuth: oktaAuth, accessToken: accessToken, methodName: methodName, links: links }, TransactionClass = (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039)) {
    for (const method of [
        'GET',
        'POST',
        'PUT',
        'DELETE'
    ])if (method.toLowerCase() === methodName) {
        const link = links.self;
        return async (payload)=>$8d4197a9d18ec07b$export$d5a1e65f8aa21b51(oktaAuth, {
                accessToken: accessToken,
                url: link.href,
                method: method,
                payload: payload
            }, TransactionClass);
    }
    const link = links[methodName];
    if (!link) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)(`No link is found with methodName: ${methodName}`);
    return async (payload)=>$8d4197a9d18ec07b$export$d5a1e65f8aa21b51(oktaAuth, {
            accessToken: accessToken,
            url: link.href,
            method: link.hints.allow[0],
            payload: payload
        }, TransactionClass);
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $5d212680f2b653f3$export$2e2bcd8739ae039 extends (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { createdAt: createdAt, modifiedAt: modifiedAt, profile: profile } = options.res;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        this.profile = profile;
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $c6d6a2526e001e7b$export$2e2bcd8739ae039 extends (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        this.properties = options.res.properties;
    }
}



/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $4c49014ef42f9dad$export$764f5ac9df2299b9;
(function(EmailRole) {
    EmailRole["PRIMARY"] = "PRIMARY";
    EmailRole["SECONDARY"] = "SECONDARY";
})($4c49014ef42f9dad$export$764f5ac9df2299b9 || ($4c49014ef42f9dad$export$764f5ac9df2299b9 = {}));
var $4c49014ef42f9dad$export$96e9906d6d93a972;
(function(Status) {
    Status["VERIFIED"] = "VERIFIED";
    Status["UNVERIFIED"] = "UNVERIFIED";
})($4c49014ef42f9dad$export$96e9906d6d93a972 || ($4c49014ef42f9dad$export$96e9906d6d93a972 = {}));
var $4c49014ef42f9dad$export$51a8e1495775a8d0;
(function(PasswordStatus) {
    PasswordStatus["NOT_ENROLLED"] = "NOT_ENROLLED";
    PasswordStatus["ACTIVE"] = "ACTIVE";
})($4c49014ef42f9dad$export$51a8e1495775a8d0 || ($4c49014ef42f9dad$export$51a8e1495775a8d0 = {}));


const $dedac67b6379cedf$export$85d699ca8330b9a9 = async (oktaAuth, options)=>{
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $5d212680f2b653f3$export$2e2bcd8739ae039));
    return transaction;
};
const $dedac67b6379cedf$export$5880729c5d131040 = async (oktaAuth, options)=>{
    const { payload: payload, accessToken: accessToken } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/profile',
        method: 'PUT',
        payload: payload,
        accessToken: accessToken
    }, (0, $5d212680f2b653f3$export$2e2bcd8739ae039));
    return transaction;
};
const $dedac67b6379cedf$export$f2a1e5d37613e054 = async (oktaAuth, options)=>{
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/profile/schema',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $c6d6a2526e001e7b$export$2e2bcd8739ae039));
    return transaction;
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $f55f91ad5acca29a$export$2e2bcd8739ae039 extends (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { res: res } = options;
        const { id: id, profile: profile, expiresAt: expiresAt, status: status } = res;
        this.id = id;
        this.expiresAt = expiresAt;
        this.profile = profile;
        this.status = status;
    }
}




class $3fced14b826ec373$export$2e2bcd8739ae039 extends (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { accessToken: accessToken, res: res } = options;
        const { id: id, expiresAt: expiresAt, profile: profile, status: status, _links: _links } = res;
        this.id = id;
        this.expiresAt = expiresAt;
        this.profile = profile;
        this.status = status;
        this.poll = async ()=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'poll',
                links: _links
            }, (0, $f55f91ad5acca29a$export$2e2bcd8739ae039));
            return await fn();
        };
        this.verify = async (payload)=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'verify',
                links: _links
            }, $3fced14b826ec373$export$2e2bcd8739ae039);
            return await fn(payload);
        };
    }
}





class $42a93696ee9aca7c$export$2e2bcd8739ae039 extends (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { accessToken: accessToken, res: res } = options;
        const { id: id, profile: profile, roles: roles, status: status, _links: _links } = res;
        this.id = id;
        this.profile = profile;
        this.roles = roles;
        this.status = status;
        this.get = async ()=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'get',
                links: _links
            }, $42a93696ee9aca7c$export$2e2bcd8739ae039);
            return await fn();
        };
        this.delete = async ()=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async ()=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'challenge',
                links: _links
            }, (0, $3fced14b826ec373$export$2e2bcd8739ae039));
            return await fn();
        };
        if (_links.poll) this.poll = async ()=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'poll',
                links: _links
            }, (0, $f55f91ad5acca29a$export$2e2bcd8739ae039));
            return await fn();
        };
        if (_links.verify) this.verify = async (payload)=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'verify',
                links: _links
            });
            return await fn(payload);
        };
    }
}




const $501bf9da7d0c4fc0$export$415923841378f20f = async (oktaAuth, options)=>{
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $42a93696ee9aca7c$export$2e2bcd8739ae039));
    return transaction;
};
const $501bf9da7d0c4fc0$export$d29968a6889079e0 = async (oktaAuth, options)=>{
    const { id: id, accessToken: accessToken } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'GET',
        accessToken: accessToken
    }, (0, $42a93696ee9aca7c$export$2e2bcd8739ae039));
    return transaction;
};
const $501bf9da7d0c4fc0$export$56c422d8d4a8ba98 = async (oktaAuth, options)=>{
    const { accessToken: accessToken, payload: payload } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/emails',
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    }, (0, $42a93696ee9aca7c$export$2e2bcd8739ae039));
    return transaction;
};
const $501bf9da7d0c4fc0$export$cd50a17c6197d29c = async (oktaAuth, options)=>{
    const { id: id, accessToken: accessToken } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${id}`,
        method: 'DELETE',
        accessToken: accessToken
    });
    return transaction;
};
const $501bf9da7d0c4fc0$export$33c6aa473fcadf96 = async (oktaAuth, options)=>{
    const { id: id, accessToken: accessToken } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${id}/challenge`,
        method: 'POST',
        accessToken: accessToken
    }, (0, $3fced14b826ec373$export$2e2bcd8739ae039));
    return transaction;
};
const $501bf9da7d0c4fc0$export$422cd4806bab99c7 = async (oktaAuth, options)=>{
    const { emailId: emailId, challengeId: challengeId, accessToken: accessToken } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}`,
        method: 'POST',
        accessToken: accessToken
    }, (0, $3fced14b826ec373$export$2e2bcd8739ae039));
    return transaction;
};
const $501bf9da7d0c4fc0$export$deff038ef606a5c = async (oktaAuth, options)=>{
    const { emailId: emailId, challengeId: challengeId, payload: payload, accessToken: accessToken } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/emails/${emailId}/challenge/${challengeId}/verify`,
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    });
    return transaction;
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

class $2459254387a256f9$export$2e2bcd8739ae039 extends (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { res: res, accessToken: accessToken } = options;
        const { id: id, profile: profile, status: status, _links: _links } = res;
        this.id = id;
        this.profile = profile;
        this.status = status;
        this.get = async ()=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'get',
                links: _links
            }, $2459254387a256f9$export$2e2bcd8739ae039);
            return await fn();
        };
        this.delete = async ()=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'delete',
                links: _links
            });
            return await fn();
        };
        this.challenge = async (payload)=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'challenge',
                links: _links
            });
            return await fn(payload);
        };
        if (_links.verify) this.verify = async (payload)=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'verify',
                links: _links
            });
            return await fn(payload);
        };
    }
}



const $71218d9151676a91$export$900cea1a440d5573 = async (oktaAuth, options)=>{
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $2459254387a256f9$export$2e2bcd8739ae039));
    return transaction;
};
const $71218d9151676a91$export$6bc97fd71a5fa8b7 = async (oktaAuth, options)=>{
    const { accessToken: accessToken, id: id } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'GET',
        accessToken: accessToken
    }, (0, $2459254387a256f9$export$2e2bcd8739ae039));
    return transaction;
};
const $71218d9151676a91$export$99d5f6f1957f912c = async (oktaAuth, options)=>{
    const { accessToken: accessToken, payload: payload } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/phones',
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    }, (0, $2459254387a256f9$export$2e2bcd8739ae039));
    return transaction;
};
const $71218d9151676a91$export$fcffda62400b801e = async (oktaAuth, options)=>{
    const { id: id, accessToken: accessToken } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/phones/${id}`,
        method: 'DELETE',
        accessToken: accessToken
    });
    return transaction;
};
const $71218d9151676a91$export$e362ccb730b1664b = async (oktaAuth, options)=>{
    const { accessToken: accessToken, id: id, payload: payload } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/challenge`,
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    });
    return transaction;
};
const $71218d9151676a91$export$90d29807f6dbc0be = async (oktaAuth, options)=>{
    const { id: id, payload: payload, accessToken: accessToken } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/phones/${id}/verify`,
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    });
    return transaction;
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 


class $3937c7c76f32698d$export$2e2bcd8739ae039 extends (0, $decb80f88c3e7cdc$export$2e2bcd8739ae039) {
    constructor(oktaAuth, options){
        super(oktaAuth, options);
        const { res: res, accessToken: accessToken } = options;
        const { id: id, status: status, created: created, lastUpdated: lastUpdated, _links: _links } = res;
        this.id = id;
        this.status = status;
        this.created = created;
        this.lastUpdated = lastUpdated;
        if (this.status == (0, $4c49014ef42f9dad$export$51a8e1495775a8d0).NOT_ENROLLED) this.enroll = async (payload)=>{
            const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                oktaAuth: oktaAuth,
                accessToken: accessToken,
                methodName: 'enroll',
                links: _links
            }, $3937c7c76f32698d$export$2e2bcd8739ae039);
            return await fn(payload);
        };
        else {
            this.get = async ()=>{
                const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                    oktaAuth: oktaAuth,
                    accessToken: accessToken,
                    methodName: 'get',
                    links: _links
                }, $3937c7c76f32698d$export$2e2bcd8739ae039);
                return await fn();
            };
            this.update = async (payload)=>{
                const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                    oktaAuth: oktaAuth,
                    accessToken: accessToken,
                    methodName: 'put',
                    links: _links
                }, $3937c7c76f32698d$export$2e2bcd8739ae039);
                return await fn(payload);
            };
            this.delete = async ()=>{
                const fn = (0, $8d4197a9d18ec07b$export$cb8be9d51a72960a)({
                    oktaAuth: oktaAuth,
                    accessToken: accessToken,
                    methodName: 'delete',
                    links: _links
                });
                return await fn();
            };
        }
    }
}


const $fea22edb904f50c9$export$350bd33120f7413e = async (oktaAuth, options)=>{
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/password`,
        method: 'GET',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    }, (0, $3937c7c76f32698d$export$2e2bcd8739ae039));
    return transaction;
};
const $fea22edb904f50c9$export$73d5ec567681e4c5 = async (oktaAuth, options)=>{
    const { accessToken: accessToken, payload: payload } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/password',
        method: 'POST',
        payload: payload,
        accessToken: accessToken
    }, (0, $3937c7c76f32698d$export$2e2bcd8739ae039));
    return transaction;
};
const $fea22edb904f50c9$export$e2853351e15b7895 = async (oktaAuth, options)=>{
    const { accessToken: accessToken, payload: payload } = options;
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: '/idp/myaccount/password',
        method: 'PUT',
        payload: payload,
        accessToken: accessToken
    }, (0, $3937c7c76f32698d$export$2e2bcd8739ae039));
    return transaction;
};
const $fea22edb904f50c9$export$c9265b7aad3ac069 = async (oktaAuth, options)=>{
    const transaction = await (0, $8d4197a9d18ec07b$export$d5a1e65f8aa21b51)(oktaAuth, {
        url: `/idp/myaccount/password`,
        method: 'DELETE',
        accessToken: options === null || options === void 0 ? void 0 : options.accessToken
    });
    return transaction;
};


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ var $0ab35f76909ba48b$exports = {};

$parcel$export($0ab35f76909ba48b$exports, "getProfile", () => $dedac67b6379cedf$export$85d699ca8330b9a9);
$parcel$export($0ab35f76909ba48b$exports, "getProfileSchema", () => $dedac67b6379cedf$export$f2a1e5d37613e054);
$parcel$export($0ab35f76909ba48b$exports, "updateProfile", () => $dedac67b6379cedf$export$5880729c5d131040);
$parcel$export($0ab35f76909ba48b$exports, "addEmail", () => $501bf9da7d0c4fc0$export$56c422d8d4a8ba98);
$parcel$export($0ab35f76909ba48b$exports, "deleteEmail", () => $501bf9da7d0c4fc0$export$cd50a17c6197d29c);
$parcel$export($0ab35f76909ba48b$exports, "getEmail", () => $501bf9da7d0c4fc0$export$d29968a6889079e0);
$parcel$export($0ab35f76909ba48b$exports, "getEmailChallenge", () => $501bf9da7d0c4fc0$export$422cd4806bab99c7);
$parcel$export($0ab35f76909ba48b$exports, "getEmails", () => $501bf9da7d0c4fc0$export$415923841378f20f);
$parcel$export($0ab35f76909ba48b$exports, "sendEmailChallenge", () => $501bf9da7d0c4fc0$export$33c6aa473fcadf96);
$parcel$export($0ab35f76909ba48b$exports, "verifyEmailChallenge", () => $501bf9da7d0c4fc0$export$deff038ef606a5c);
$parcel$export($0ab35f76909ba48b$exports, "addPhone", () => $71218d9151676a91$export$99d5f6f1957f912c);
$parcel$export($0ab35f76909ba48b$exports, "deletePhone", () => $71218d9151676a91$export$fcffda62400b801e);
$parcel$export($0ab35f76909ba48b$exports, "getPhone", () => $71218d9151676a91$export$6bc97fd71a5fa8b7);
$parcel$export($0ab35f76909ba48b$exports, "getPhones", () => $71218d9151676a91$export$900cea1a440d5573);
$parcel$export($0ab35f76909ba48b$exports, "sendPhoneChallenge", () => $71218d9151676a91$export$e362ccb730b1664b);
$parcel$export($0ab35f76909ba48b$exports, "verifyPhoneChallenge", () => $71218d9151676a91$export$90d29807f6dbc0be);
$parcel$export($0ab35f76909ba48b$exports, "deletePassword", () => $fea22edb904f50c9$export$c9265b7aad3ac069);
$parcel$export($0ab35f76909ba48b$exports, "enrollPassword", () => $fea22edb904f50c9$export$73d5ec567681e4c5);
$parcel$export($0ab35f76909ba48b$exports, "getPassword", () => $fea22edb904f50c9$export$350bd33120f7413e);
$parcel$export($0ab35f76909ba48b$exports, "updatePassword", () => $fea22edb904f50c9$export$e2853351e15b7895);
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





function $1118ff406fcebb61$export$59a1e98a4e72b9c4(Base) {
    return class OktaAuthMyAccount extends Base {
        constructor(...args){
            super(...args);
            this.myaccount = Object.entries($0ab35f76909ba48b$exports).filter(([name])=>name !== 'default').reduce((acc, [name, fn])=>{
                acc[name] = fn.bind(null, this);
                return acc;
            }, {});
        }
    };
}


function $fd42b04d3978f433$export$6053a1f78419757b(StorageManagerConstructor, OptionsConstructor, TransactionManager) {
    const Core = (0, $fd07cc163b789d7f$export$30ddaac95d0f4b52)(StorageManagerConstructor, OptionsConstructor, TransactionManager);
    const WithMyAccount = (0, $1118ff406fcebb61$export$59a1e98a4e72b9c4)(Core);
    return WithMyAccount;
}




/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 





parcelRequire("R5nvG");
/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ function $3027f138ddd785fa$export$9299815b5f3154f3(res, options) {
    var builtArgs = {};
    Object.assign(builtArgs, options);
    if (!builtArgs.stateToken && res.stateToken) builtArgs.stateToken = res.stateToken;
    return builtArgs;
}
function $3027f138ddd785fa$export$2d4cfae4c1b81550(res) {
    return $3027f138ddd785fa$export$9299815b5f3154f3(res);
}


function $a7c5fc27ee1d4ca8$export$51ada3ca5c05a344(sdk, args) {
    args = (0, $3027f138ddd785fa$export$9299815b5f3154f3)(sdk, args);
    return (0, $b8f53662f6ac3919$export$299ba2dee77727e9)(sdk, sdk.getIssuerOrigin() + '/api/v1/authn', args, {
        withCredentials: true
    });
}
function $a7c5fc27ee1d4ca8$export$c77d5d5646490fda(sdk, tx, args) {
    if (!args || !args.stateToken) {
        var stateToken = $a7c5fc27ee1d4ca8$export$70099e8baba5f61a(sdk);
        if (stateToken) args = {
            stateToken: stateToken
        };
        else return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('No transaction to resume'));
    }
    return $a7c5fc27ee1d4ca8$export$51ada3ca5c05a344(sdk, args).then(function(res) {
        return tx.createTransaction(res);
    });
}
function $a7c5fc27ee1d4ca8$export$d7a8811716990051(sdk, tx, args) {
    if (!args || !args.stateToken) {
        var stateToken = $a7c5fc27ee1d4ca8$export$70099e8baba5f61a(sdk);
        if (stateToken) args = {
            stateToken: stateToken
        };
        else return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('No transaction to evaluate'));
    }
    return $a7c5fc27ee1d4ca8$export$f87af8010ee2d4f0(sdk, args).then(function(res) {
        return tx.createTransaction(res);
    });
}
function $a7c5fc27ee1d4ca8$export$f87af8010ee2d4f0(sdk, args) {
    args = (0, $3027f138ddd785fa$export$9299815b5f3154f3)(sdk, args);
    return (0, $b8f53662f6ac3919$export$299ba2dee77727e9)(sdk, sdk.getIssuerOrigin() + '/api/v1/authn/introspect', args, {
        withCredentials: true
    });
}
function $a7c5fc27ee1d4ca8$export$ec24f82f0c14002b(sdk) {
    return !!$a7c5fc27ee1d4ca8$export$70099e8baba5f61a(sdk);
}
function $a7c5fc27ee1d4ca8$export$ff6c438e8dbccc40(sdk, tx, url, args, options) {
    options = Object.assign({
        withCredentials: true
    }, options);
    return (0, $b8f53662f6ac3919$export$299ba2dee77727e9)(sdk, url, args, options).then(function(res) {
        return tx.createTransaction(res);
    });
}
function $a7c5fc27ee1d4ca8$export$70099e8baba5f61a(sdk) {
    const storage = sdk.options.storageUtil.storage;
    return storage.get((0, $2119f0a66eb38a81$export$511e8ed0baecd62c));
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 






parcelRequire("R5nvG");


function $ced0092ff119a180$export$e4684f3957f59145(sdk, tx, res, obj, link, ref) {
    if (Array.isArray(link)) return function(name, opts) {
        if (!name) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Must provide a link name');
        var lk = (0, $12f7cf89ebb788f9$export$71aa6c912b956294)(link, {
            name: name
        });
        if (!lk) throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('No link found for that name');
        return $ced0092ff119a180$export$e4684f3957f59145(sdk, tx, res, obj, lk, ref)(opts);
    };
    else if (link.hints && link.hints.allow && link.hints.allow.length === 1) {
        var method = link.hints.allow[0];
        switch(method){
            case 'GET':
                return function() {
                    return (0, $b8f53662f6ac3919$export$3988ae62b71be9a3)(sdk, link.href, {
                        withCredentials: true
                    });
                };
            case 'POST':
                return function(opts) {
                    if (ref && ref.isPolling) ref.isPolling = false;
                    var data = (0, $3027f138ddd785fa$export$9299815b5f3154f3)(res, opts);
                    if (res.status === 'MFA_ENROLL' || res.status === 'FACTOR_ENROLL') Object.assign(data, {
                        factorType: obj.factorType,
                        provider: obj.provider
                    });
                    var params = {};
                    var autoPush = data.autoPush;
                    if (autoPush !== undefined) {
                        if (typeof autoPush === 'function') try {
                            params.autoPush = !!autoPush();
                        } catch (e) {
                            return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('AutoPush resulted in an error.'));
                        }
                        else if (autoPush !== null) params.autoPush = !!autoPush;
                        data = (0, $12f7cf89ebb788f9$export$30a06c8d3562193f)(data, 'autoPush');
                    }
                    var rememberDevice = data.rememberDevice;
                    if (rememberDevice !== undefined) {
                        if (typeof rememberDevice === 'function') try {
                            params.rememberDevice = !!rememberDevice();
                        } catch (e) {
                            return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('RememberDevice resulted in an error.'));
                        }
                        else if (rememberDevice !== null) params.rememberDevice = !!rememberDevice;
                        data = (0, $12f7cf89ebb788f9$export$30a06c8d3562193f)(data, 'rememberDevice');
                    } else if (data.profile && data.profile.updatePhone !== undefined) {
                        if (data.profile.updatePhone) params.updatePhone = true;
                        data.profile = (0, $12f7cf89ebb788f9$export$30a06c8d3562193f)(data.profile, 'updatePhone');
                    }
                    var href = link.href + (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)(params);
                    return (0, $a7c5fc27ee1d4ca8$export$ff6c438e8dbccc40)(sdk, tx, href, data);
                };
        }
    }
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ /*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
class $ffd9b4e9b8d46d1a$export$2e2bcd8739ae039 extends (0, $8255b78460174178$export$2e2bcd8739ae039) {
    constructor(){
        const message = 'The poll was stopped by the sdk';
        super(message);
    }
}












parcelRequire("R5nvG");

function $ded5a1e28c4d9eae$export$dbf3bc1a5591d22f(sdk, res, ref) {
    return function(options) {
        var delay$1;
        var rememberDevice;
        var autoPush;
        var transactionCallBack;
        if ((0, $307f2ba6550d7c99$export$7e4aa119212bc614)(options)) delay$1 = options;
        else if ((0, $307f2ba6550d7c99$export$a6cdc56e425d0d0a)(options)) {
            options;
            delay$1 = options.delay;
            rememberDevice = options.rememberDevice;
            autoPush = options.autoPush;
            transactionCallBack = options.transactionCallBack;
        }
        if (!delay$1 && delay$1 !== 0) delay$1 = (0, $2119f0a66eb38a81$export$626063bdcc4f0775);
        var pollLink = (0, $12f7cf89ebb788f9$export$67e8a86e59c99895)(res, 'next', 'poll');
        function pollFn() {
            var opts = {};
            if (typeof autoPush === 'function') try {
                opts.autoPush = !!autoPush();
            } catch (e) {
                return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('AutoPush resulted in an error.'));
            }
            else if (autoPush !== undefined && autoPush !== null) opts.autoPush = !!autoPush;
            if (typeof rememberDevice === 'function') try {
                opts.rememberDevice = !!rememberDevice();
            } catch (e) {
                return Promise.reject(new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('RememberDevice resulted in an error.'));
            }
            else if (rememberDevice !== undefined && rememberDevice !== null) opts.rememberDevice = !!rememberDevice;
            var href = pollLink.href + (0, $83e7c3a0ba92185e$export$249cc09c933c4d7a)(opts);
            return (0, $b8f53662f6ac3919$export$299ba2dee77727e9)(sdk, href, (0, $3027f138ddd785fa$export$2d4cfae4c1b81550)(res), {
                saveAuthnState: false,
                withCredentials: true,
                pollingIntent: true
            });
        }
        ref.isPolling = true;
        var retryCount = 0;
        var recursivePoll = function() {
            if (!ref.isPolling) return Promise.reject(new (0, $ffd9b4e9b8d46d1a$export$2e2bcd8739ae039)());
            return pollFn().then(function(pollRes) {
                retryCount = 0;
                if (pollRes.factorResult && pollRes.factorResult === 'WAITING') {
                    if (!ref.isPolling) throw new (0, $ffd9b4e9b8d46d1a$export$2e2bcd8739ae039)();
                    if (typeof transactionCallBack === 'function') transactionCallBack(pollRes);
                    return (0, $d7af732897cdd522$export$1391212d75b2ee65)(delay$1).then(recursivePoll);
                } else {
                    ref.isPolling = false;
                    return sdk.tx.createTransaction(pollRes);
                }
            }).catch(function(err) {
                if (err.xhr && (err.xhr.status === 0 || err.xhr.status === 429) && retryCount <= 4) {
                    var delayLength = Math.pow(2, retryCount) * 1000;
                    retryCount++;
                    return (0, $d7af732897cdd522$export$1391212d75b2ee65)(delayLength).then(recursivePoll);
                }
                throw err;
            });
        };
        return recursivePoll().catch(function(err) {
            ref.isPolling = false;
            throw err;
        });
    };
}


function $7de596c18633a3c2$export$cfbf992c433a7257(sdk, tx, res, obj, ref) {
    var fns = {};
    for(var linkName in obj._links){
        if (!Object.prototype.hasOwnProperty.call(obj._links, linkName)) continue;
        var link = obj._links[linkName];
        if (linkName === 'next') linkName = link.name;
        if (link.type) {
            fns[linkName] = link;
            continue;
        }
        switch(linkName){
            case 'poll':
                fns.poll = (0, $ded5a1e28c4d9eae$export$dbf3bc1a5591d22f)(sdk, res, ref);
                break;
            default:
                var fn = (0, $ced0092ff119a180$export$e4684f3957f59145)(sdk, tx, res, obj, link, ref);
                if (fn) fns[linkName] = fn;
        }
    }
    return fns;
}


function $d5d80294acdefba8$export$2a8afff7473d9fcc(sdk, tx, res, obj, ref) {
    obj = obj || res;
    obj = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(obj);
    if (Array.isArray(obj)) {
        var objArr = [];
        for(var o = 0, ol = obj.length; o < ol; o++)objArr.push($d5d80294acdefba8$export$2a8afff7473d9fcc(sdk, tx, res, obj[o], ref));
        return objArr;
    }
    var embedded = obj._embedded || {};
    for(var key in embedded){
        if (!Object.prototype.hasOwnProperty.call(embedded, key)) continue;
        if ((0, $307f2ba6550d7c99$export$a6cdc56e425d0d0a)(embedded[key]) || Array.isArray(embedded[key])) embedded[key] = $d5d80294acdefba8$export$2a8afff7473d9fcc(sdk, tx, res, embedded[key], ref);
    }
    var fns = (0, $7de596c18633a3c2$export$cfbf992c433a7257)(sdk, tx, res, obj, ref);
    Object.assign(embedded, fns);
    obj = (0, $12f7cf89ebb788f9$export$30a06c8d3562193f)(obj, '_embedded', '_links');
    Object.assign(obj, embedded);
    return obj;
}


class $ae3cdffc8d2668fc$export$f580db0c9d44ff91 {
    constructor(sdk, tx, res = null){
        this.data = undefined;
        this.status = undefined;
        if (res) {
            this.data = res;
            Object.assign(this, (0, $d5d80294acdefba8$export$2a8afff7473d9fcc)(sdk, tx, res, res, {}));
            delete this.stateToken;
            if (res.status === 'RECOVERY_CHALLENGE' && !res._links) this.cancel = function() {
                return Promise.resolve(tx.createTransaction());
            };
        }
    }
}


function $8cac3de5d7ebd470$export$1d08820c24a6783a(sdk) {
    const tx = {
        status: (0, $a7c5fc27ee1d4ca8$export$51ada3ca5c05a344).bind(null, sdk),
        resume (args) {
            return (0, $a7c5fc27ee1d4ca8$export$c77d5d5646490fda)(sdk, tx, args);
        },
        exists: (0, $a7c5fc27ee1d4ca8$export$ec24f82f0c14002b).bind(null, sdk),
        introspect (args) {
            return (0, $a7c5fc27ee1d4ca8$export$d7a8811716990051)(sdk, tx, args);
        },
        createTransaction: (res)=>{
            return new (0, $ae3cdffc8d2668fc$export$f580db0c9d44ff91)(sdk, tx, res);
        },
        postToTransaction: (url, args, options)=>{
            return (0, $a7c5fc27ee1d4ca8$export$ff6c438e8dbccc40)(sdk, tx, url, args, options);
        }
    };
    return tx;
}


/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 



function $66d254503622f3c4$export$8bd4610dde10caeb(Base) {
    return class OktaAuthTx extends Base {
        constructor(...args){
            super(...args);
            this.authn = this.tx = (0, $8cac3de5d7ebd470$export$1d08820c24a6783a)(this);
            this.fingerprint = (0, $888ed34a31dbe4d4$export$2e2bcd8739ae039).bind(null, this);
        }
        async signIn(opts) {
            opts = (0, $12f7cf89ebb788f9$export$9cd59f9826255e47)(opts || {});
            const _postToTransaction = (options)=>{
                delete opts.sendFingerprint;
                return this.tx.postToTransaction('/api/v1/authn', opts, options);
            };
            if (!opts.sendFingerprint) return _postToTransaction();
            return this.fingerprint().then(function(fingerprint) {
                return _postToTransaction({
                    headers: {
                        'X-Device-Fingerprint': fingerprint
                    }
                });
            });
        }
        async signInWithCredentials(opts) {
            return this.signIn(opts);
        }
        forgotPassword(opts) {
            return this.tx.postToTransaction('/api/v1/authn/recovery/password', opts);
        }
        unlockAccount(opts) {
            return this.tx.postToTransaction('/api/v1/authn/recovery/unlock', opts);
        }
        verifyRecoveryToken(opts) {
            const { multiOptionalFactorEnroll: multiOptionalFactorEnroll } = opts, args = (0, $ca95e6f9e1ec9f80$export$3c9a16f847548506)(opts, [
                "multiOptionalFactorEnroll"
            ]);
            if (multiOptionalFactorEnroll) args.options = {
                multiOptionalFactorEnroll: multiOptionalFactorEnroll
            };
            return this.tx.postToTransaction('/api/v1/authn/recovery/token', args);
        }
    };
}



















/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */ 




function $802680a7b374c7ec$export$ab6ec7127a621091(StorageManagerConstructor, OptionsConstructor, TransactionManagerConstructor) {
    const Base = (0, $c9fbd110bc9c9442$export$2bc41dfbf048bfdc)(OptionsConstructor);
    const WithStorage = (0, $a8d31580460d70f9$export$32ec6248008f35d1)(Base, StorageManagerConstructor);
    const WithHttp = (0, $00e95a529c550931$export$b21483dcd2900eca)(WithStorage);
    const WithSession = (0, $17bebb0ac662acac$export$e29a1eee069c5053)(WithHttp);
    const WithOAuth = (0, $f919f60b8d93e7bc$export$d2d79cf72153e095)(WithSession, TransactionManagerConstructor);
    return WithOAuth;
}





























































const $95440d1ea7e2da18$var$OptionsConstructor = (0, $1d6cfd8b0fe5848e$export$2fa277826aad984c)();
const $95440d1ea7e2da18$var$StorageManager = (0, $18a15d5a8bf62586$export$247998cd7cb1a236)();
const $95440d1ea7e2da18$var$TransactionManager = (0, $7e0af16c65d469cc$export$b5a6d650030beee)();
const $95440d1ea7e2da18$var$WithIdx = (0, $4840a53cd80d1314$export$2f30fde9bc853c45)($95440d1ea7e2da18$var$StorageManager, $95440d1ea7e2da18$var$OptionsConstructor, $95440d1ea7e2da18$var$TransactionManager);
const $95440d1ea7e2da18$var$WithMyAccount = (0, $1118ff406fcebb61$export$59a1e98a4e72b9c4)($95440d1ea7e2da18$var$WithIdx);
const $95440d1ea7e2da18$var$WithAuthn = (0, $66d254503622f3c4$export$8bd4610dde10caeb)($95440d1ea7e2da18$var$WithMyAccount);
class $95440d1ea7e2da18$export$c998d4cdbfb7af8 extends $95440d1ea7e2da18$var$WithAuthn {
    constructor(options){
        super(options);
    }
}


function $0c15f44f3f7f8172$export$2e2bcd8739ae039(v1, v2) {
    // validate input and split into segments
    const n1 = $0c15f44f3f7f8172$var$validateAndParse(v1);
    const n2 = $0c15f44f3f7f8172$var$validateAndParse(v2);
    // pop off the patch
    const p1 = n1.pop();
    const p2 = n2.pop();
    // validate numbers
    const r = $0c15f44f3f7f8172$var$compareSegments(n1, n2);
    if (r !== 0) return r;
    // validate pre-release
    if (p1 && p2) return $0c15f44f3f7f8172$var$compareSegments(p1.split('.'), p2.split('.'));
    else if (p1 || p2) return p1 ? -1 : 1;
    return 0;
}
const $0c15f44f3f7f8172$export$a22775fa5e2eebd9 = (v)=>typeof v === 'string' && /^[v\d]/.test(v) && $0c15f44f3f7f8172$var$semver.test(v);
const $0c15f44f3f7f8172$export$398604a469f7de9a = (v1, v2, operator)=>{
    // validate input operator
    $0c15f44f3f7f8172$var$assertValidOperator(operator);
    // since result of compareVersions can only be -1 or 0 or 1
    // a simple map can be used to replace switch
    const res = $0c15f44f3f7f8172$export$2e2bcd8739ae039(v1, v2);
    return $0c15f44f3f7f8172$var$operatorResMap[operator].includes(res);
};
const $0c15f44f3f7f8172$export$b8fab89fe6d5d7da = (v, r)=>{
    // if no range operator then "="
    const m = r.match(/^([<>=~^]+)/);
    const op = m ? m[1] : '=';
    // if gt/lt/eq then operator compare
    if (op !== '^' && op !== '~') return $0c15f44f3f7f8172$export$398604a469f7de9a(v, r, op);
    // else range of either "~" or "^" is assumed
    const [v1, v2, v3] = $0c15f44f3f7f8172$var$validateAndParse(v);
    const [r1, r2, r3] = $0c15f44f3f7f8172$var$validateAndParse(r);
    if ($0c15f44f3f7f8172$var$compareStrings(v1, r1) !== 0) return false;
    if (op === '^') return $0c15f44f3f7f8172$var$compareSegments([
        v2,
        v3
    ], [
        r2,
        r3
    ]) >= 0;
    if ($0c15f44f3f7f8172$var$compareStrings(v2, r2) !== 0) return false;
    return $0c15f44f3f7f8172$var$compareStrings(v3, r3) >= 0;
};
// export CJS style for parity
$0c15f44f3f7f8172$export$2e2bcd8739ae039.validate = $0c15f44f3f7f8172$export$a22775fa5e2eebd9;
$0c15f44f3f7f8172$export$2e2bcd8739ae039.compare = $0c15f44f3f7f8172$export$398604a469f7de9a;
$0c15f44f3f7f8172$export$2e2bcd8739ae039.satisfies = $0c15f44f3f7f8172$export$b8fab89fe6d5d7da;
const $0c15f44f3f7f8172$var$semver = /^[v^~<>=]*?(\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+)(?:\.([x*]|\d+))?(?:-([\da-z\-]+(?:\.[\da-z\-]+)*))?(?:\+[\da-z\-]+(?:\.[\da-z\-]+)*)?)?)?$/i;
const $0c15f44f3f7f8172$var$validateAndParse = (v)=>{
    if (typeof v !== 'string') throw new TypeError('Invalid argument expected string');
    const match = v.match($0c15f44f3f7f8172$var$semver);
    if (!match) throw new Error(`Invalid argument not valid semver ('${v}' received)`);
    match.shift();
    return match;
};
const $0c15f44f3f7f8172$var$isWildcard = (s)=>s === '*' || s === 'x' || s === 'X';
const $0c15f44f3f7f8172$var$tryParse = (v)=>{
    const n = parseInt(v, 10);
    return isNaN(n) ? v : n;
};
const $0c15f44f3f7f8172$var$forceType = (a, b)=>typeof a !== typeof b ? [
        String(a),
        String(b)
    ] : [
        a,
        b
    ];
const $0c15f44f3f7f8172$var$compareStrings = (a, b)=>{
    if ($0c15f44f3f7f8172$var$isWildcard(a) || $0c15f44f3f7f8172$var$isWildcard(b)) return 0;
    const [ap, bp] = $0c15f44f3f7f8172$var$forceType($0c15f44f3f7f8172$var$tryParse(a), $0c15f44f3f7f8172$var$tryParse(b));
    if (ap > bp) return 1;
    if (ap < bp) return -1;
    return 0;
};
const $0c15f44f3f7f8172$var$compareSegments = (a, b)=>{
    for(let i = 0; i < Math.max(a.length, b.length); i++){
        const r = $0c15f44f3f7f8172$var$compareStrings(a[i] || 0, b[i] || 0);
        if (r !== 0) return r;
    }
    return 0;
};
const $0c15f44f3f7f8172$var$operatorResMap = {
    '>': [
        1
    ],
    '>=': [
        0,
        1
    ],
    '=': [
        0
    ],
    '<=': [
        -1,
        0
    ],
    '<': [
        -1
    ]
};
const $0c15f44f3f7f8172$var$allowedOperators = Object.keys($0c15f44f3f7f8172$var$operatorResMap);
const $0c15f44f3f7f8172$var$assertValidOperator = (op)=>{
    if (typeof op !== 'string') throw new TypeError(`Invalid operator type, expected string but got ${typeof op}`);
    if ($0c15f44f3f7f8172$var$allowedOperators.indexOf(op) === -1) throw new Error(`Invalid operator, expected one of ${$0c15f44f3f7f8172$var$allowedOperators.join('|')}`);
};


function $b8f57191916382d3$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $b8f57191916382d3$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b8f57191916382d3$export$2e2bcd8739ae039(o);
}



function $96eac03571e01dbf$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}


function $3a21fd50cbcd11cf$export$2e2bcd8739ae039(t) {
    var i = (0, $96eac03571e01dbf$export$2e2bcd8739ae039)(t, "string");
    return "symbol" == (0, $b8f57191916382d3$export$2e2bcd8739ae039)(i) ? i : i + "";
}


function $f329557dcab6d0bb$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}


function $133b6e059b2f6d5e$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $73ef9ce1c41fc0c0$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}


var $f6765cb7d08e9df0$exports = {};

$parcel$export($f6765cb7d08e9df0$exports, "HydratedRouter", () => $5fc20031e6d40819$export$63ce90781bf4d238);
$parcel$export($f6765cb7d08e9df0$exports, "RouterProvider", () => $5fc20031e6d40819$export$323e4fc2fa4753fb);
/**
 * react-router-dom v7.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ // index.ts
/**
 * react-router v7.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v7.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $acw62 = parcelRequire("acw62");
var $6e8912d375e5b322$exports = {};
"use strict";
Object.defineProperty($6e8912d375e5b322$exports, "__esModule", {
    value: true
});
$6e8912d375e5b322$exports.parseCookie = $6e8912d375e5b322$var$parseCookie;
$6e8912d375e5b322$exports.parse = $6e8912d375e5b322$var$parseCookie;
$6e8912d375e5b322$exports.stringifyCookie = $6e8912d375e5b322$var$stringifyCookie;
$6e8912d375e5b322$exports.stringifySetCookie = $6e8912d375e5b322$var$stringifySetCookie;
$6e8912d375e5b322$exports.serialize = $6e8912d375e5b322$var$stringifySetCookie;
$6e8912d375e5b322$exports.parseSetCookie = $6e8912d375e5b322$var$parseSetCookie;
$6e8912d375e5b322$exports.stringifySetCookie = $6e8912d375e5b322$var$stringifySetCookie;
$6e8912d375e5b322$exports.serialize = $6e8912d375e5b322$var$stringifySetCookie;
/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 *
 * Note: Allowing more characters - https://github.com/jshttp/cookie/issues/191
 * Allow same range as cookie value, except `=`, which delimits end of name.
 */ const $6e8912d375e5b322$var$cookieNameRegExp = /^[\u0021-\u003A\u003C\u003E-\u007E]+$/;
/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 *
 * Allowing more characters: https://github.com/jshttp/cookie/issues/191
 * Comma, backslash, and DQUOTE are not part of the parsing algorithm.
 */ const $6e8912d375e5b322$var$cookieValueRegExp = /^[\u0021-\u003A\u003C-\u007E]*$/;
/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 *
 * Keep support for leading dot: https://github.com/jshttp/cookie/issues/173
 *
 * > (Note that a leading %x2E ("."), if present, is ignored even though that
 * character is not permitted, but a trailing %x2E ("."), if present, will
 * cause the user agent to ignore the attribute.)
 */ const $6e8912d375e5b322$var$domainValueRegExp = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;
/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */ const $6e8912d375e5b322$var$pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;
/**
 * RegExp to match max-age-value in RFC 6265 sec 5.6.2
 */ const $6e8912d375e5b322$var$maxAgeRegExp = /^-?\d+$/;
const $6e8912d375e5b322$var$__toString = Object.prototype.toString;
const $6e8912d375e5b322$var$NullObject = /* @__PURE__ */ (()=>{
    const C = function() {};
    C.prototype = Object.create(null);
    return C;
})();
/**
 * Parse a `Cookie` header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 */ function $6e8912d375e5b322$var$parseCookie(str, options) {
    const obj = new $6e8912d375e5b322$var$NullObject();
    const len = str.length;
    // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
    if (len < 2) return obj;
    const dec = options?.decode || $6e8912d375e5b322$var$decode;
    let index = 0;
    do {
        const eqIdx = $6e8912d375e5b322$var$eqIndex(str, index, len);
        if (eqIdx === -1) break; // No more cookie pairs.
        const endIdx = $6e8912d375e5b322$var$endIndex(str, index, len);
        if (eqIdx > endIdx) {
            // backtrack on prior semicolon
            index = str.lastIndexOf(";", eqIdx - 1) + 1;
            continue;
        }
        const key = $6e8912d375e5b322$var$valueSlice(str, index, eqIdx);
        // only assign once
        if (obj[key] === undefined) obj[key] = dec($6e8912d375e5b322$var$valueSlice(str, eqIdx + 1, endIdx));
        index = endIdx + 1;
    }while (index < len);
    return obj;
}
/**
 * Stringifies an object into an HTTP `Cookie` header.
 */ function $6e8912d375e5b322$var$stringifyCookie(cookie, options) {
    const enc = options?.encode || encodeURIComponent;
    const cookieStrings = [];
    for (const name of Object.keys(cookie)){
        const val = cookie[name];
        if (val === undefined) continue;
        if (!$6e8912d375e5b322$var$cookieNameRegExp.test(name)) throw new TypeError(`cookie name is invalid: ${name}`);
        const value = enc(val);
        if (!$6e8912d375e5b322$var$cookieValueRegExp.test(value)) throw new TypeError(`cookie val is invalid: ${val}`);
        cookieStrings.push(`${name}=${value}`);
    }
    return cookieStrings.join("; ");
}
function $6e8912d375e5b322$var$stringifySetCookie(_name, _val, _opts) {
    const cookie = typeof _name === "object" ? _name : {
        ..._opts,
        name: _name,
        value: String(_val)
    };
    const options = typeof _val === "object" ? _val : _opts;
    const enc = options?.encode || encodeURIComponent;
    if (!$6e8912d375e5b322$var$cookieNameRegExp.test(cookie.name)) throw new TypeError(`argument name is invalid: ${cookie.name}`);
    const value = cookie.value ? enc(cookie.value) : "";
    if (!$6e8912d375e5b322$var$cookieValueRegExp.test(value)) throw new TypeError(`argument val is invalid: ${cookie.value}`);
    let str = cookie.name + "=" + value;
    if (cookie.maxAge !== undefined) {
        if (!Number.isInteger(cookie.maxAge)) throw new TypeError(`option maxAge is invalid: ${cookie.maxAge}`);
        str += "; Max-Age=" + cookie.maxAge;
    }
    if (cookie.domain) {
        if (!$6e8912d375e5b322$var$domainValueRegExp.test(cookie.domain)) throw new TypeError(`option domain is invalid: ${cookie.domain}`);
        str += "; Domain=" + cookie.domain;
    }
    if (cookie.path) {
        if (!$6e8912d375e5b322$var$pathValueRegExp.test(cookie.path)) throw new TypeError(`option path is invalid: ${cookie.path}`);
        str += "; Path=" + cookie.path;
    }
    if (cookie.expires) {
        if (!$6e8912d375e5b322$var$isDate(cookie.expires) || !Number.isFinite(cookie.expires.valueOf())) throw new TypeError(`option expires is invalid: ${cookie.expires}`);
        str += "; Expires=" + cookie.expires.toUTCString();
    }
    if (cookie.httpOnly) str += "; HttpOnly";
    if (cookie.secure) str += "; Secure";
    if (cookie.partitioned) str += "; Partitioned";
    if (cookie.priority) {
        const priority = typeof cookie.priority === "string" ? cookie.priority.toLowerCase() : undefined;
        switch(priority){
            case "low":
                str += "; Priority=Low";
                break;
            case "medium":
                str += "; Priority=Medium";
                break;
            case "high":
                str += "; Priority=High";
                break;
            default:
                throw new TypeError(`option priority is invalid: ${cookie.priority}`);
        }
    }
    if (cookie.sameSite) {
        const sameSite = typeof cookie.sameSite === "string" ? cookie.sameSite.toLowerCase() : cookie.sameSite;
        switch(sameSite){
            case true:
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError(`option sameSite is invalid: ${cookie.sameSite}`);
        }
    }
    return str;
}
/**
 * Deserialize a `Set-Cookie` header into an object.
 *
 * deserialize('foo=bar; httpOnly')
 *   => { name: 'foo', value: 'bar', httpOnly: true }
 */ function $6e8912d375e5b322$var$parseSetCookie(str, options) {
    const dec = options?.decode || $6e8912d375e5b322$var$decode;
    const len = str.length;
    const endIdx = $6e8912d375e5b322$var$endIndex(str, 0, len);
    const eqIdx = $6e8912d375e5b322$var$eqIndex(str, 0, endIdx);
    const setCookie = eqIdx === -1 ? {
        name: "",
        value: dec($6e8912d375e5b322$var$valueSlice(str, 0, endIdx))
    } : {
        name: $6e8912d375e5b322$var$valueSlice(str, 0, eqIdx),
        value: dec($6e8912d375e5b322$var$valueSlice(str, eqIdx + 1, endIdx))
    };
    let index = endIdx + 1;
    while(index < len){
        const endIdx = $6e8912d375e5b322$var$endIndex(str, index, len);
        const eqIdx = $6e8912d375e5b322$var$eqIndex(str, index, endIdx);
        const attr = eqIdx === -1 ? $6e8912d375e5b322$var$valueSlice(str, index, endIdx) : $6e8912d375e5b322$var$valueSlice(str, index, eqIdx);
        const val = eqIdx === -1 ? undefined : $6e8912d375e5b322$var$valueSlice(str, eqIdx + 1, endIdx);
        switch(attr.toLowerCase()){
            case "httponly":
                setCookie.httpOnly = true;
                break;
            case "secure":
                setCookie.secure = true;
                break;
            case "partitioned":
                setCookie.partitioned = true;
                break;
            case "domain":
                setCookie.domain = val;
                break;
            case "path":
                setCookie.path = val;
                break;
            case "max-age":
                if (val && $6e8912d375e5b322$var$maxAgeRegExp.test(val)) setCookie.maxAge = Number(val);
                break;
            case "expires":
                if (!val) break;
                const date = new Date(val);
                if (Number.isFinite(date.valueOf())) setCookie.expires = date;
                break;
            case "priority":
                if (!val) break;
                const priority = val.toLowerCase();
                if (priority === "low" || priority === "medium" || priority === "high") setCookie.priority = priority;
                break;
            case "samesite":
                if (!val) break;
                const sameSite = val.toLowerCase();
                if (sameSite === "lax" || sameSite === "strict" || sameSite === "none") setCookie.sameSite = sameSite;
                break;
        }
        index = endIdx + 1;
    }
    return setCookie;
}
/**
 * Find the `;` character between `min` and `len` in str.
 */ function $6e8912d375e5b322$var$endIndex(str, min, len) {
    const index = str.indexOf(";", min);
    return index === -1 ? len : index;
}
/**
 * Find the `=` character between `min` and `max` in str.
 */ function $6e8912d375e5b322$var$eqIndex(str, min, max) {
    const index = str.indexOf("=", min);
    return index < max ? index : -1;
}
/**
 * Slice out a value between startPod to max.
 */ function $6e8912d375e5b322$var$valueSlice(str, min, max) {
    let start = min;
    let end = max;
    do {
        const code = str.charCodeAt(start);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
    }while (++start < end);
    while(end > start){
        const code = str.charCodeAt(end - 1);
        if (code !== 0x20 /*   */  && code !== 0x09 /* \t */ ) break;
        end--;
    }
    return str.slice(start, end);
}
/**
 * URL-decode string value. Optimized to skip native call when no %.
 */ function $6e8912d375e5b322$var$decode(str) {
    if (str.indexOf("%") === -1) return str;
    try {
        return decodeURIComponent(str);
    } catch (e) {
        return str;
    }
}
/**
 * Determine if value is a Date.
 */ function $6e8912d375e5b322$var$isDate(val) {
    return $6e8912d375e5b322$var$__toString.call(val) === "[object Date]";
}


var $e4a96bcce5e8f1ac$exports = {};
"use strict";
var $e4a96bcce5e8f1ac$var$defaultParseOptions = {
    decodeValues: true,
    map: false,
    silent: false
};
function $e4a96bcce5e8f1ac$var$isForbiddenKey(key) {
    return typeof key !== "string" || key in {};
}
function $e4a96bcce5e8f1ac$var$createNullObj() {
    return Object.create(null);
}
function $e4a96bcce5e8f1ac$var$isNonEmptyString(str) {
    return typeof str === "string" && !!str.trim();
}
function $e4a96bcce5e8f1ac$var$parseString(setCookieValue, options) {
    var parts = setCookieValue.split(";").filter($e4a96bcce5e8f1ac$var$isNonEmptyString);
    var nameValuePairStr = parts.shift();
    var parsed = $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr);
    var name = parsed.name;
    var value = parsed.value;
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    if ($e4a96bcce5e8f1ac$var$isForbiddenKey(name)) return null;
    try {
        value = options.decodeValues ? decodeURIComponent(value) : value; // decode cookie value
    } catch (e) {
        console.error("set-cookie-parser: failed to decode cookie value. Set options.decodeValues=false to disable decoding.", e);
    }
    var cookie = $e4a96bcce5e8f1ac$var$createNullObj();
    cookie.name = name;
    cookie.value = value;
    parts.forEach(function(part) {
        var sides = part.split("=");
        var key = sides.shift().trimLeft().toLowerCase();
        if ($e4a96bcce5e8f1ac$var$isForbiddenKey(key)) return;
        var value = sides.join("=");
        if (key === "expires") cookie.expires = new Date(value);
        else if (key === "max-age") {
            var n = parseInt(value, 10);
            if (!Number.isNaN(n)) cookie.maxAge = n;
        } else if (key === "secure") cookie.secure = true;
        else if (key === "httponly") cookie.httpOnly = true;
        else if (key === "samesite") cookie.sameSite = value;
        else if (key === "partitioned") cookie.partitioned = true;
        else if (key) cookie[key] = value;
    });
    return cookie;
}
function $e4a96bcce5e8f1ac$var$parseNameValuePair(nameValuePairStr) {
    // Parses name-value-pair according to rfc6265bis draft
    var name = "";
    var value = "";
    var nameValueArr = nameValuePairStr.split("=");
    if (nameValueArr.length > 1) {
        name = nameValueArr.shift();
        value = nameValueArr.join("="); // everything after the first =, joined by a "=" if there was more than one part
    } else value = nameValuePairStr;
    return {
        name: name,
        value: value
    };
}
function $e4a96bcce5e8f1ac$var$parse(input, options) {
    options = options ? Object.assign({}, $e4a96bcce5e8f1ac$var$defaultParseOptions, options) : $e4a96bcce5e8f1ac$var$defaultParseOptions;
    if (!input) {
        if (!options.map) return [];
        else return $e4a96bcce5e8f1ac$var$createNullObj();
    }
    if (input.headers) {
        if (typeof input.headers.getSetCookie === "function") // for fetch responses - they combine headers of the same type in the headers array,
        // but getSetCookie returns an uncombined array
        input = input.headers.getSetCookie();
        else if (input.headers["set-cookie"]) // fast-path for node.js (which automatically normalizes header names to lower-case)
        input = input.headers["set-cookie"];
        else {
            // slow-path for other environments - see #25
            var sch = input.headers[Object.keys(input.headers).find(function(key) {
                return key.toLowerCase() === "set-cookie";
            })];
            // warn if called on a request-like object with a cookie header rather than a set-cookie header - see #34, 36
            if (!sch && input.headers.cookie && !options.silent) console.warn("Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning.");
            input = sch;
        }
    }
    if (!Array.isArray(input)) input = [
        input
    ];
    if (!options.map) return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).map(function(str) {
        return $e4a96bcce5e8f1ac$var$parseString(str, options);
    }).filter(Boolean);
    else {
        var cookies = $e4a96bcce5e8f1ac$var$createNullObj();
        return input.filter($e4a96bcce5e8f1ac$var$isNonEmptyString).reduce(function(cookies, str) {
            var cookie = $e4a96bcce5e8f1ac$var$parseString(str, options);
            if (cookie && !$e4a96bcce5e8f1ac$var$isForbiddenKey(cookie.name)) cookies[cookie.name] = cookie;
            return cookies;
        }, cookies);
    }
}
/*
  Set-Cookie header field-values are sometimes comma joined in one string. This splits them without choking on commas
  that are within a single set-cookie field-value, such as in the Expires portion.

  This is uncommon, but explicitly allowed - see https://tools.ietf.org/html/rfc2616#section-4.2
  Node.js does this for every header *except* set-cookie - see https://github.com/nodejs/node/blob/d5e363b77ebaf1caf67cd7528224b651c86815c1/lib/_http_incoming.js#L128
  React Native's fetch does this for *every* header, including set-cookie.

  Based on: https://github.com/google/j2objc/commit/16820fdbc8f76ca0c33472810ce0cb03d20efe25
  Credits to: https://github.com/tomball for original and https://github.com/chrusart for JavaScript implementation
*/ function $e4a96bcce5e8f1ac$var$splitCookiesString(cookiesString) {
    if (Array.isArray(cookiesString)) return cookiesString;
    if (typeof cookiesString !== "string") return [];
    var cookiesStrings = [];
    var pos = 0;
    var start;
    var ch;
    var lastComma;
    var nextStart;
    var cookiesSeparatorFound;
    function skipWhitespace() {
        while(pos < cookiesString.length && /\s/.test(cookiesString.charAt(pos)))pos += 1;
        return pos < cookiesString.length;
    }
    function notSpecialChar() {
        ch = cookiesString.charAt(pos);
        return ch !== "=" && ch !== ";" && ch !== ",";
    }
    while(pos < cookiesString.length){
        start = pos;
        cookiesSeparatorFound = false;
        while(skipWhitespace()){
            ch = cookiesString.charAt(pos);
            if (ch === ",") {
                // ',' is a cookie separator if we have later first '=', not ';' or ','
                lastComma = pos;
                pos += 1;
                skipWhitespace();
                nextStart = pos;
                while(pos < cookiesString.length && notSpecialChar())pos += 1;
                // currently special character
                if (pos < cookiesString.length && cookiesString.charAt(pos) === "=") {
                    // we found cookies separator
                    cookiesSeparatorFound = true;
                    // pos is inside the next cookie, so back up and return it.
                    pos = nextStart;
                    cookiesStrings.push(cookiesString.substring(start, lastComma));
                    start = pos;
                } else // in param ',' or param separator ';',
                // we continue from that comma
                pos = lastComma + 1;
            } else pos += 1;
        }
        if (!cookiesSeparatorFound || pos >= cookiesString.length) cookiesStrings.push(cookiesString.substring(start, cookiesString.length));
    }
    return cookiesStrings;
}
$e4a96bcce5e8f1ac$exports = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parse = $e4a96bcce5e8f1ac$var$parse;
$e4a96bcce5e8f1ac$exports.parseString = $e4a96bcce5e8f1ac$var$parseString;
$e4a96bcce5e8f1ac$exports.splitCookiesString = $e4a96bcce5e8f1ac$var$splitCookiesString;


function $279fdcca19aaa190$export$7246f7e18cebe1bd({ context: context, url: url, nonce: nonce }) {
    if (typeof url === "string") url = new URL(url);
    let { manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, serverHandoffString: serverHandoffString } = context;
    let routes = (0, $84c11e79798ea0cb$export$5be2318464878170)(manifest.routes, routeModules, context.future, context.isSpaMode);
    context.staticHandlerContext.loaderData = {
        ...context.staticHandlerContext.loaderData
    };
    for (let match of context.staticHandlerContext.matches){
        let routeId = match.route.id;
        let route = routeModules[routeId];
        let manifestRoute = context.manifest.routes[routeId];
        if (route && manifestRoute && (0, $84c11e79798ea0cb$export$6ac68922d4e92125)(routeId, route.clientLoader, manifestRoute.hasLoader, context.isSpaMode) && (route.HydrateFallback || !manifestRoute.hasLoader)) delete context.staticHandlerContext.loaderData[routeId];
    }
    let router = (0, $84c11e79798ea0cb$export$3dd6171c30258b6f)(routes, context.staticHandlerContext);
    return /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$208d6a3bc3aa62bd).Provider, {
        value: {
            manifest: manifest,
            routeModules: routeModules,
            criticalCss: criticalCss,
            serverHandoffString: serverHandoffString,
            future: context.future,
            ssr: context.ssr,
            isSpaMode: context.isSpaMode,
            routeDiscovery: context.routeDiscovery,
            serializeError: context.serializeError,
            renderMeta: context.renderMeta
        }
    }, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$32e57f52df4b6e34), {
        location: router.state.location
    }, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$3d80f15952491985), {
        router: router,
        context: context.staticHandlerContext,
        hydrate: false
    }))), context.serverHandoffStream ? /* @__PURE__ */ $acw62.createElement($acw62.Suspense, null, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$2b0b5f24fd77a79f), {
        context: context,
        identifier: 0,
        reader: context.serverHandoffStream.getReader(),
        textDecoder: new TextDecoder(),
        nonce: nonce
    })) : null);
}
function $279fdcca19aaa190$export$bea31554c7dfd2ad(routes, _context) {
    return function RoutesTestStub({ initialEntries: initialEntries, initialIndex: initialIndex, hydrationData: hydrationData, future: future }) {
        let routerRef = $acw62.useRef();
        let frameworkContextRef = $acw62.useRef();
        if (routerRef.current == null) {
            frameworkContextRef.current = {
                future: {
                    unstable_subResourceIntegrity: future?.unstable_subResourceIntegrity === true,
                    v8_middleware: future?.v8_middleware === true,
                    unstable_trailingSlashAwareDataRequests: future?.unstable_trailingSlashAwareDataRequests === true
                },
                manifest: {
                    routes: {},
                    entry: {
                        imports: [],
                        module: ""
                    },
                    url: "",
                    version: ""
                },
                routeModules: {},
                ssr: false,
                isSpaMode: false,
                routeDiscovery: {
                    mode: "lazy",
                    manifestPath: "/__manifest"
                }
            };
            let patched = $279fdcca19aaa190$var$processRoutes(// @ts-expect-error `StubRouteObject` is stricter about `loader`/`action`
            // types compared to `AgnosticRouteObject`
            (0, $84c11e79798ea0cb$export$87cb1a9238dc3fba)(routes, (r)=>r), _context !== void 0 ? _context : future?.v8_middleware ? new (0, $84c11e79798ea0cb$export$b8d3e69d4b3eff04)() : {}, frameworkContextRef.current.manifest, frameworkContextRef.current.routeModules);
            routerRef.current = (0, $84c11e79798ea0cb$export$f30f7e456d254e83)(patched, {
                initialEntries: initialEntries,
                initialIndex: initialIndex,
                hydrationData: hydrationData
            });
        }
        return /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$208d6a3bc3aa62bd).Provider, {
            value: frameworkContextRef.current
        }, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$323e4fc2fa4753fb), {
            router: routerRef.current
        }));
    };
}
function $279fdcca19aaa190$var$processRoutes(routes, context, manifest, routeModules, parentId) {
    return routes.map((route)=>{
        if (!route.id) throw new Error("Expected a route.id in react-router processRoutes() function");
        let newRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            Component: route.Component ? (0, $84c11e79798ea0cb$export$1a5de91a5c3255e0)(route.Component) : void 0,
            HydrateFallback: route.HydrateFallback ? (0, $84c11e79798ea0cb$export$cd4a5850c74ba029)(route.HydrateFallback) : void 0,
            ErrorBoundary: route.ErrorBoundary ? (0, $84c11e79798ea0cb$export$26aea97ad016e70c)(route.ErrorBoundary) : void 0,
            action: route.action ? (args)=>route.action({
                    ...args,
                    context: context
                }) : void 0,
            loader: route.loader ? (args)=>route.loader({
                    ...args,
                    context: context
                }) : void 0,
            middleware: route.middleware ? route.middleware.map((mw)=>(...args)=>mw({
                        ...args[0],
                        context: context
                    }, args[1])) : void 0,
            handle: route.handle,
            shouldRevalidate: route.shouldRevalidate
        };
        let entryRoute = {
            id: route.id,
            path: route.path,
            index: route.index,
            parentId: parentId,
            hasAction: route.action != null,
            hasLoader: route.loader != null,
            // When testing routes, you should be stubbing loader/action/middleware,
            // not trying to re-implement the full loader/clientLoader/SSR/hydration
            // flow. That is better tested via E2E tests.
            hasClientAction: false,
            hasClientLoader: false,
            hasClientMiddleware: false,
            hasErrorBoundary: route.ErrorBoundary != null,
            // any need for these?
            module: "build/stub-path-to-module.js",
            clientActionModule: void 0,
            clientLoaderModule: void 0,
            clientMiddlewareModule: void 0,
            hydrateFallbackModule: void 0
        };
        manifest.routes[newRoute.id] = entryRoute;
        routeModules[route.id] = {
            default: newRoute.Component || (0, $84c11e79798ea0cb$export$910ae8079b2c2852),
            ErrorBoundary: newRoute.ErrorBoundary || void 0,
            handle: route.handle,
            links: route.links,
            meta: route.meta,
            shouldRevalidate: route.shouldRevalidate
        };
        if (route.children) newRoute.children = $279fdcca19aaa190$var$processRoutes(route.children, context, manifest, routeModules, newRoute.id);
        return newRoute;
    });
}
// lib/server-runtime/crypto.ts
var $279fdcca19aaa190$var$encoder = /* @__PURE__ */ new TextEncoder();
var $279fdcca19aaa190$var$sign = async (value, secret)=>{
    let data2 = $279fdcca19aaa190$var$encoder.encode(value);
    let key = await $279fdcca19aaa190$var$createKey(secret, [
        "sign"
    ]);
    let signature = await crypto.subtle.sign("HMAC", key, data2);
    let hash = btoa(String.fromCharCode(...new Uint8Array(signature))).replace(/=+$/, "");
    return value + "." + hash;
};
var $279fdcca19aaa190$var$unsign = async (cookie, secret)=>{
    let index = cookie.lastIndexOf(".");
    let value = cookie.slice(0, index);
    let hash = cookie.slice(index + 1);
    let data2 = $279fdcca19aaa190$var$encoder.encode(value);
    let key = await $279fdcca19aaa190$var$createKey(secret, [
        "verify"
    ]);
    try {
        let signature = $279fdcca19aaa190$var$byteStringToUint8Array(atob(hash));
        let valid = await crypto.subtle.verify("HMAC", key, signature, data2);
        return valid ? value : false;
    } catch (error) {
        return false;
    }
};
var $279fdcca19aaa190$var$createKey = async (secret, usages)=>crypto.subtle.importKey("raw", $279fdcca19aaa190$var$encoder.encode(secret), {
        name: "HMAC",
        hash: "SHA-256"
    }, false, usages);
function $279fdcca19aaa190$var$byteStringToUint8Array(byteString) {
    let array = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)array[i] = byteString.charCodeAt(i);
    return array;
}
// lib/server-runtime/cookies.ts
var $279fdcca19aaa190$export$7892c26d6c7a7447 = (name, cookieOptions = {})=>{
    let { secrets: secrets = [], ...options } = {
        path: "/",
        sameSite: "lax",
        ...cookieOptions
    };
    $279fdcca19aaa190$var$warnOnceAboutExpiresCookie(name, options.expires);
    return {
        get name () {
            return name;
        },
        get isSigned () {
            return secrets.length > 0;
        },
        get expires () {
            return typeof options.maxAge !== "undefined" ? new Date(Date.now() + options.maxAge * 1e3) : options.expires;
        },
        async parse (cookieHeader, parseOptions) {
            if (!cookieHeader) return null;
            let cookies = (0, $6e8912d375e5b322$exports.parse)(cookieHeader, {
                ...options,
                ...parseOptions
            });
            if (name in cookies) {
                let value = cookies[name];
                if (typeof value === "string" && value !== "") {
                    let decoded = await $279fdcca19aaa190$var$decodeCookieValue(value, secrets);
                    return decoded;
                } else return "";
            } else return null;
        },
        async serialize (value, serializeOptions) {
            return (0, $6e8912d375e5b322$exports.serialize)(name, value === "" ? "" : await $279fdcca19aaa190$var$encodeCookieValue(value, secrets), {
                ...options,
                ...serializeOptions
            });
        }
    };
};
var $279fdcca19aaa190$export$f00768c7d8d5ffdb = (object)=>{
    return object != null && typeof object.name === "string" && typeof object.isSigned === "boolean" && typeof object.parse === "function" && typeof object.serialize === "function";
};
async function $279fdcca19aaa190$var$encodeCookieValue(value, secrets) {
    let encoded = $279fdcca19aaa190$var$encodeData(value);
    if (secrets.length > 0) encoded = await $279fdcca19aaa190$var$sign(encoded, secrets[0]);
    return encoded;
}
async function $279fdcca19aaa190$var$decodeCookieValue(value, secrets) {
    if (secrets.length > 0) {
        for (let secret of secrets){
            let unsignedValue = await $279fdcca19aaa190$var$unsign(value, secret);
            if (unsignedValue !== false) return $279fdcca19aaa190$var$decodeData(unsignedValue);
        }
        return null;
    }
    return $279fdcca19aaa190$var$decodeData(value);
}
function $279fdcca19aaa190$var$encodeData(value) {
    return btoa($279fdcca19aaa190$var$myUnescape(encodeURIComponent(JSON.stringify(value))));
}
function $279fdcca19aaa190$var$decodeData(value) {
    try {
        return JSON.parse(decodeURIComponent($279fdcca19aaa190$var$myEscape(atob(value))));
    } catch (error) {
        return {};
    }
}
function $279fdcca19aaa190$var$myEscape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, code;
    while(index < str.length){
        chr = str.charAt(index++);
        if (/[\w*+\-./@]/.exec(chr)) result += chr;
        else {
            code = chr.charCodeAt(0);
            if (code < 256) result += "%" + $279fdcca19aaa190$var$hex(code, 2);
            else result += "%u" + $279fdcca19aaa190$var$hex(code, 4).toUpperCase();
        }
    }
    return result;
}
function $279fdcca19aaa190$var$hex(code, length) {
    let result = code.toString(16);
    while(result.length < length)result = "0" + result;
    return result;
}
function $279fdcca19aaa190$var$myUnescape(value) {
    let str = value.toString();
    let result = "";
    let index = 0;
    let chr, part;
    while(index < str.length){
        chr = str.charAt(index++);
        if (chr === "%") {
            if (str.charAt(index) === "u") {
                part = str.slice(index + 1, index + 5);
                if (/^[\da-f]{4}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 5;
                    continue;
                }
            } else {
                part = str.slice(index, index + 2);
                if (/^[\da-f]{2}$/i.exec(part)) {
                    result += String.fromCharCode(parseInt(part, 16));
                    index += 2;
                    continue;
                }
            }
        }
        result += chr;
    }
    return result;
}
function $279fdcca19aaa190$var$warnOnceAboutExpiresCookie(name, expires) {
    (0, $84c11e79798ea0cb$export$5b28268982f175ba)(!expires, `The "${name}" cookie has an "expires" property set. This will cause the expires value to not be updated when the session is committed. Instead, you should set the expires value when serializing the cookie. You can use \`commitSession(session, { expires })\` if using a session storage object, or \`cookie.serialize("value", { expires })\` if you're using the cookie directly.`);
}
// lib/server-runtime/entry.ts
function $279fdcca19aaa190$var$createEntryRouteModules(manifest) {
    return Object.keys(manifest).reduce((memo, routeId)=>{
        let route = manifest[routeId];
        if (route) memo[routeId] = route.module;
        return memo;
    }, {});
}
// lib/server-runtime/mode.ts
var $279fdcca19aaa190$export$e7973f87fd96e4f2 = /* @__PURE__ */ ((ServerMode2)=>{
    ServerMode2["Development"] = "development";
    ServerMode2["Production"] = "production";
    ServerMode2["Test"] = "test";
    return ServerMode2;
})($279fdcca19aaa190$export$e7973f87fd96e4f2 || {});
function $279fdcca19aaa190$var$isServerMode(value) {
    return value === "development" /* Development */  || value === "production" /* Production */  || value === "test" /* Test */ ;
}
// lib/server-runtime/errors.ts
function $279fdcca19aaa190$var$sanitizeError(error, serverMode) {
    if (error instanceof Error && serverMode !== "development" /* Development */ ) {
        let sanitized = new Error("Unexpected Server Error");
        sanitized.stack = void 0;
        return sanitized;
    }
    return error;
}
function $279fdcca19aaa190$var$sanitizeErrors(errors, serverMode) {
    return Object.entries(errors).reduce((acc, [routeId, error])=>{
        return Object.assign(acc, {
            [routeId]: $279fdcca19aaa190$var$sanitizeError(error, serverMode)
        });
    }, {});
}
function $279fdcca19aaa190$var$serializeError(error, serverMode) {
    let sanitized = $279fdcca19aaa190$var$sanitizeError(error, serverMode);
    return {
        message: sanitized.message,
        stack: sanitized.stack
    };
}
function $279fdcca19aaa190$var$serializeErrors(errors, serverMode) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if ((0, $84c11e79798ea0cb$export$972111febbeef05b)(val)) serialized[key] = {
            ...val,
            __type: "RouteErrorResponse"
        };
        else if (val instanceof Error) {
            let sanitized = $279fdcca19aaa190$var$sanitizeError(val, serverMode);
            serialized[key] = {
                message: sanitized.message,
                stack: sanitized.stack,
                __type: "Error",
                // If this is a subclass (i.e., ReferenceError), send up the type so we
                // can re-create the same type during hydration.  This will only apply
                // in dev mode since all production errors are sanitized to normal
                // Error instances
                ...sanitized.name !== "Error" ? {
                    __subType: sanitized.name
                } : {}
            };
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/server-runtime/routeMatching.ts
function $279fdcca19aaa190$var$matchServerRoutes(routes, pathname, basename) {
    let matches = (0, $84c11e79798ea0cb$export$2708184779ceb39d)(routes, pathname, basename);
    if (!matches) return null;
    return matches.map((match)=>({
            params: match.params,
            pathname: match.pathname,
            route: match.route
        }));
}
// lib/server-runtime/data.ts
async function $279fdcca19aaa190$var$callRouteHandler(handler, args) {
    let result = await handler({
        request: $279fdcca19aaa190$var$stripRoutesParam($279fdcca19aaa190$var$stripIndexParam(args.request)),
        params: args.params,
        context: args.context,
        unstable_pattern: args.unstable_pattern
    });
    if ((0, $84c11e79798ea0cb$export$e0163cfdf7bc9cfa)(result) && result.init && result.init.status && (0, $84c11e79798ea0cb$export$794b2760043cf8cd)(result.init.status)) throw new Response(null, result.init);
    return result;
}
function $279fdcca19aaa190$var$stripIndexParam(request) {
    let url = new URL(request.url);
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
function $279fdcca19aaa190$var$stripRoutesParam(request) {
    let url = new URL(request.url);
    url.searchParams.delete("_routes");
    let init = {
        method: request.method,
        body: request.body,
        headers: request.headers,
        signal: request.signal
    };
    if (init.body) init.duplex = "half";
    return new Request(url.href, init);
}
// lib/server-runtime/invariant.ts
function $279fdcca19aaa190$var$invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") {
        console.error("The following error is a bug in React Router; please open an issue! https://github.com/remix-run/react-router/issues/new/choose");
        throw new Error(message);
    }
}
// lib/server-runtime/dev.ts
var $279fdcca19aaa190$var$globalDevServerHooksKey = "__reactRouterDevServerHooks";
function $279fdcca19aaa190$export$31bc6e795ff1cb0a(devServerHooks) {
    globalThis[$279fdcca19aaa190$var$globalDevServerHooksKey] = devServerHooks;
}
function $279fdcca19aaa190$var$getDevServerHooks() {
    return globalThis[$279fdcca19aaa190$var$globalDevServerHooksKey];
}
function $279fdcca19aaa190$var$getBuildTimeHeader(request, headerName) {
    var e;
    return null;
}
// lib/server-runtime/routes.ts
function $279fdcca19aaa190$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $279fdcca19aaa190$var$createRoutes(manifest, parentId = "", routesByParentId = $279fdcca19aaa190$var$groupRoutesByParentId(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>({
            ...route,
            children: $279fdcca19aaa190$var$createRoutes(manifest, route.id, routesByParentId)
        }));
}
function $279fdcca19aaa190$var$createStaticHandlerDataRoutes(manifest, future, parentId = "", routesByParentId = $279fdcca19aaa190$var$groupRoutesByParentId(manifest)) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let commonRoute = {
            // Always include root due to default boundaries
            hasErrorBoundary: route.id === "root" || route.module.ErrorBoundary != null,
            id: route.id,
            path: route.path,
            middleware: route.module.middleware,
            // Need to use RR's version in the param typed here to permit the optional
            // context even though we know it'll always be provided in remix
            loader: route.module.loader ? async (args)=>{
                let preRenderedData = $279fdcca19aaa190$var$getBuildTimeHeader(args.request, "X-React-Router-Prerender-Data");
                if (preRenderedData != null) {
                    let encoded = preRenderedData ? decodeURI(preRenderedData) : preRenderedData;
                    $279fdcca19aaa190$var$invariant(encoded, "Missing prerendered data for route");
                    let uint8array = new TextEncoder().encode(encoded);
                    let stream = new ReadableStream({
                        start (controller) {
                            controller.enqueue(uint8array);
                            controller.close();
                        }
                    });
                    let decoded = await (0, $84c11e79798ea0cb$export$4023ad4ecd4126a2)(stream, $parcel$global);
                    let data2 = decoded.value;
                    if (data2 && (0, $84c11e79798ea0cb$export$60644022b8b46aaa) in data2) {
                        let result = data2[0, $84c11e79798ea0cb$export$60644022b8b46aaa];
                        let init = {
                            status: result.status
                        };
                        if (result.reload) throw (0, $84c11e79798ea0cb$export$a6cd19cd1951a23c)(result.redirect, init);
                        else if (result.replace) throw (0, $84c11e79798ea0cb$export$77ad94ebf1c2b9ed)(result.redirect, init);
                        else throw (0, $84c11e79798ea0cb$export$89e12c5b50f7529d)(result.redirect, init);
                    } else {
                        $279fdcca19aaa190$var$invariant(data2 && route.id in data2, "Unable to decode prerendered data");
                        let result = data2[route.id];
                        $279fdcca19aaa190$var$invariant("data" in result, "Unable to process prerendered data");
                        return result.data;
                    }
                }
                let val = await $279fdcca19aaa190$var$callRouteHandler(route.module.loader, args);
                return val;
            } : void 0,
            action: route.module.action ? (args)=>$279fdcca19aaa190$var$callRouteHandler(route.module.action, args) : void 0,
            handle: route.module.handle
        };
        return route.index ? {
            index: true,
            ...commonRoute
        } : {
            caseSensitive: route.caseSensitive,
            children: $279fdcca19aaa190$var$createStaticHandlerDataRoutes(manifest, future, route.id, routesByParentId),
            ...commonRoute
        };
    });
}
// lib/server-runtime/serverHandoff.ts
function $279fdcca19aaa190$var$createServerHandoffString(serverHandoff) {
    return (0, $84c11e79798ea0cb$export$4cf11838cdc2a8a8)(JSON.stringify(serverHandoff));
}
function $279fdcca19aaa190$var$getDocumentHeaders(context, build) {
    return $279fdcca19aaa190$var$getDocumentHeadersImpl(context, (m)=>{
        let route = build.routes[m.route.id];
        $279fdcca19aaa190$var$invariant(route, `Route with id "${m.route.id}" not found in build`);
        return route.module.headers;
    });
}
function $279fdcca19aaa190$var$getDocumentHeadersImpl(context, getRouteHeadersFn, _defaultHeaders) {
    let boundaryIdx = context.errors ? context.matches.findIndex((m)=>context.errors[m.route.id]) : -1;
    let matches = boundaryIdx >= 0 ? context.matches.slice(0, boundaryIdx + 1) : context.matches;
    let errorHeaders;
    if (boundaryIdx >= 0) {
        let { actionHeaders: actionHeaders, actionData: actionData, loaderHeaders: loaderHeaders, loaderData: loaderData } = context;
        context.matches.slice(boundaryIdx).some((match)=>{
            let id = match.route.id;
            if (actionHeaders[id] && (!actionData || !actionData.hasOwnProperty(id))) errorHeaders = actionHeaders[id];
            else if (loaderHeaders[id] && !loaderData.hasOwnProperty(id)) errorHeaders = loaderHeaders[id];
            return errorHeaders != null;
        });
    }
    const defaultHeaders = new Headers(_defaultHeaders);
    return matches.reduce((parentHeaders, match, idx)=>{
        let { id: id } = match.route;
        let loaderHeaders = context.loaderHeaders[id] || new Headers();
        let actionHeaders = context.actionHeaders[id] || new Headers();
        let includeErrorHeaders = errorHeaders != null && idx === matches.length - 1;
        let includeErrorCookies = includeErrorHeaders && errorHeaders !== loaderHeaders && errorHeaders !== actionHeaders;
        let headersFn = getRouteHeadersFn(match);
        if (headersFn == null) {
            let headers2 = new Headers(parentHeaders);
            if (includeErrorCookies) $279fdcca19aaa190$var$prependCookies(errorHeaders, headers2);
            $279fdcca19aaa190$var$prependCookies(actionHeaders, headers2);
            $279fdcca19aaa190$var$prependCookies(loaderHeaders, headers2);
            return headers2;
        }
        let headers = new Headers(typeof headersFn === "function" ? headersFn({
            loaderHeaders: loaderHeaders,
            parentHeaders: parentHeaders,
            actionHeaders: actionHeaders,
            errorHeaders: includeErrorHeaders ? errorHeaders : void 0
        }) : headersFn);
        if (includeErrorCookies) $279fdcca19aaa190$var$prependCookies(errorHeaders, headers);
        $279fdcca19aaa190$var$prependCookies(actionHeaders, headers);
        $279fdcca19aaa190$var$prependCookies(loaderHeaders, headers);
        $279fdcca19aaa190$var$prependCookies(parentHeaders, headers);
        return headers;
    }, new Headers(defaultHeaders));
}
function $279fdcca19aaa190$var$prependCookies(parentHeaders, childHeaders) {
    let parentSetCookieString = parentHeaders.get("Set-Cookie");
    if (parentSetCookieString) {
        let cookies = (0, $e4a96bcce5e8f1ac$exports.splitCookiesString)(parentSetCookieString);
        let childCookies = new Set(childHeaders.getSetCookie());
        cookies.forEach((cookie)=>{
            if (!childCookies.has(cookie)) childHeaders.append("Set-Cookie", cookie);
        });
    }
}
// lib/actions.ts
function $279fdcca19aaa190$var$throwIfPotentialCSRFAttack(headers, allowedActionOrigins) {
    let originHeader = headers.get("origin");
    let originDomain = typeof originHeader === "string" && originHeader !== "null" ? new URL(originHeader).host : originHeader;
    let host = $279fdcca19aaa190$var$parseHostHeader(headers);
    if (originDomain && (!host || originDomain !== host.value)) {
        if (!$279fdcca19aaa190$var$isAllowedOrigin(originDomain, allowedActionOrigins)) {
            if (host) throw new Error(`${host.type} header does not match \`origin\` header from a forwarded action request. Aborting the action.`);
            else throw new Error("`x-forwarded-host` or `host` headers are not provided. One of these is needed to compare the `origin` header from a forwarded action request. Aborting the action.");
        }
    }
}
function $279fdcca19aaa190$var$matchWildcardDomain(domain, pattern) {
    const domainParts = domain.split(".");
    const patternParts = pattern.split(".");
    if (patternParts.length < 1) return false;
    if (domainParts.length < patternParts.length) return false;
    if (patternParts.length === 1 && (patternParts[0] === "*" || patternParts[0] === "**")) return false;
    while(patternParts.length){
        const patternPart = patternParts.pop();
        const domainPart = domainParts.pop();
        switch(patternPart){
            case "":
                return false;
            case "*":
                if (domainPart) continue;
                else return false;
            case "**":
                if (patternParts.length > 0) return false;
                return domainPart !== void 0;
            case void 0:
            default:
                if (domainPart !== patternPart) return false;
        }
    }
    return domainParts.length === 0;
}
function $279fdcca19aaa190$var$isAllowedOrigin(originDomain, allowedActionOrigins = []) {
    return allowedActionOrigins.some((allowedOrigin)=>allowedOrigin && (allowedOrigin === originDomain || $279fdcca19aaa190$var$matchWildcardDomain(originDomain, allowedOrigin)));
}
function $279fdcca19aaa190$var$parseHostHeader(headers) {
    let forwardedHostHeader = headers.get("x-forwarded-host");
    let forwardedHostValue = forwardedHostHeader?.split(",")[0]?.trim();
    let hostHeader = headers.get("host");
    return forwardedHostValue ? {
        type: "x-forwarded-host",
        value: forwardedHostValue
    } : hostHeader ? {
        type: "host",
        value: hostHeader
    } : void 0;
}
// lib/server-runtime/single-fetch.ts
var $279fdcca19aaa190$var$SERVER_NO_BODY_STATUS_CODES = /* @__PURE__ */ new Set([
    ...(0, $84c11e79798ea0cb$export$e35ccdcde387134d),
    304
]);
async function $279fdcca19aaa190$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    try {
        $279fdcca19aaa190$var$throwIfPotentialCSRFAttack(request.headers, Array.isArray(build.allowedActionOrigins) ? build.allowedActionOrigins : []);
        let handlerRequest = new Request(handlerUrl, {
            method: request.method,
            body: request.body,
            headers: request.headers,
            signal: request.signal,
            ...request.body ? {
                duplex: "half"
            } : void 0
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            skipLoaderErrorBubbling: true,
            skipRevalidation: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $84c11e79798ea0cb$export$3f1eb41d9a6a6a27)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error) {
        handleError(error);
        return $279fdcca19aaa190$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        });
    }
    function staticContextToResponse(context) {
        let headers = $279fdcca19aaa190$var$getDocumentHeaders(context, build);
        if ((0, $84c11e79798ea0cb$export$794b2760043cf8cd)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $84c11e79798ea0cb$export$972111febbeef05b)(err) || err.error) handleError(err);
            });
            context.errors = $279fdcca19aaa190$var$sanitizeErrors(context.errors, serverMode);
        }
        let singleFetchResult;
        if (context.errors) singleFetchResult = {
            error: Object.values(context.errors)[0]
        };
        else singleFetchResult = {
            data: Object.values(context.actionData || {})[0]
        };
        return $279fdcca19aaa190$var$generateSingleFetchResponse(request, build, serverMode, {
            result: singleFetchResult,
            headers: headers,
            status: context.statusCode
        });
    }
}
async function $279fdcca19aaa190$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) {
    let routesParam = new URL(request.url).searchParams.get("_routes");
    let loadRouteIds = routesParam ? new Set(routesParam.split(",")) : null;
    try {
        let handlerRequest = new Request(handlerUrl, {
            headers: request.headers,
            signal: request.signal
        });
        let result = await staticHandler.query(handlerRequest, {
            requestContext: loadContext,
            filterMatchesToLoad: (m)=>!loadRouteIds || loadRouteIds.has(m.route.id),
            skipLoaderErrorBubbling: true,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(handlerRequest);
                    return handleQueryResult(innerResult);
                } catch (error) {
                    return handleQueryError(error);
                }
            } : void 0
        });
        return handleQueryResult(result);
    } catch (error) {
        return handleQueryError(error);
    }
    function handleQueryResult(result) {
        return (0, $84c11e79798ea0cb$export$3f1eb41d9a6a6a27)(result) ? result : staticContextToResponse(result);
    }
    function handleQueryError(error) {
        handleError(error);
        return $279fdcca19aaa190$var$generateSingleFetchResponse(request, build, serverMode, {
            result: {
                error: error
            },
            headers: new Headers(),
            status: 500
        });
    }
    function staticContextToResponse(context) {
        let headers = $279fdcca19aaa190$var$getDocumentHeaders(context, build);
        if ((0, $84c11e79798ea0cb$export$794b2760043cf8cd)(context.statusCode) && headers.has("Location")) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $84c11e79798ea0cb$export$972111febbeef05b)(err) || err.error) handleError(err);
            });
            context.errors = $279fdcca19aaa190$var$sanitizeErrors(context.errors, serverMode);
        }
        let results = {};
        let loadedMatches = new Set(context.matches.filter((m)=>loadRouteIds ? loadRouteIds.has(m.route.id) : m.route.loader != null).map((m)=>m.route.id));
        if (context.errors) for (let [id, error] of Object.entries(context.errors))results[id] = {
            error: error
        };
        for (let [id, data2] of Object.entries(context.loaderData))if (!(id in results) && loadedMatches.has(id)) results[id] = {
            data: data2
        };
        return $279fdcca19aaa190$var$generateSingleFetchResponse(request, build, serverMode, {
            result: results,
            headers: headers,
            status: context.statusCode
        });
    }
}
function $279fdcca19aaa190$var$generateSingleFetchResponse(request, build, serverMode, { result: result, headers: headers, status: status }) {
    let resultHeaders = new Headers(headers);
    resultHeaders.set("X-Remix-Response", "yes");
    if ($279fdcca19aaa190$var$SERVER_NO_BODY_STATUS_CODES.has(status)) return new Response(null, {
        status: status,
        headers: resultHeaders
    });
    resultHeaders.set("Content-Type", "text/x-script");
    resultHeaders.delete("Content-Length");
    return new Response($279fdcca19aaa190$var$encodeViaTurboStream(result, request.signal, build.entry.module.streamTimeout, serverMode), {
        status: status || 200,
        headers: resultHeaders
    });
}
function $279fdcca19aaa190$var$generateSingleFetchRedirectResponse(redirectResponse, request, build, serverMode) {
    let redirect2 = $279fdcca19aaa190$var$getSingleFetchRedirect(redirectResponse.status, redirectResponse.headers, build.basename);
    let headers = new Headers(redirectResponse.headers);
    headers.delete("Location");
    headers.set("Content-Type", "text/x-script");
    return $279fdcca19aaa190$var$generateSingleFetchResponse(request, build, serverMode, {
        result: request.method === "GET" ? {
            [(0, $84c11e79798ea0cb$export$60644022b8b46aaa)]: redirect2
        } : redirect2,
        headers: headers,
        status: (0, $84c11e79798ea0cb$export$ae9272e641ead836)
    });
}
function $279fdcca19aaa190$var$getSingleFetchRedirect(status, headers, basename) {
    let redirect2 = headers.get("Location");
    if (basename) redirect2 = (0, $84c11e79798ea0cb$export$b69e3301ce081aa3)(redirect2, basename) || redirect2;
    return {
        redirect: redirect2,
        status: status,
        revalidate: // Technically X-Remix-Revalidate isn't needed here - that was an implementation
        // detail of ?_data requests as our way to tell the front end to revalidate when
        // we didn't have a response body to include that information in.
        // With single fetch, we tell the front end via this revalidate boolean field.
        // However, we're respecting it for now because it may be something folks have
        // used in their own responses
        // TODO(v3): Consider removing or making this official public API
        headers.has("X-Remix-Revalidate") || headers.has("Set-Cookie"),
        reload: headers.has("X-Remix-Reload-Document"),
        replace: headers.has("X-Remix-Replace")
    };
}
function $279fdcca19aaa190$var$encodeViaTurboStream(data2, requestSignal, streamTimeout, serverMode) {
    let controller = new AbortController();
    let timeoutId = setTimeout(()=>controller.abort(new Error("Server Timeout")), typeof streamTimeout === "number" ? streamTimeout : 4950);
    requestSignal.addEventListener("abort", ()=>clearTimeout(timeoutId));
    return (0, $84c11e79798ea0cb$export$c564cdbbe6da493)(data2, {
        signal: controller.signal,
        plugins: [
            (value)=>{
                if (value instanceof Error) {
                    let { name: name, message: message, stack: stack } = serverMode === "production" /* Production */  ? $279fdcca19aaa190$var$sanitizeError(value, serverMode) : value;
                    return [
                        "SanitizedError",
                        name,
                        message,
                        stack
                    ];
                }
                if (value instanceof (0, $84c11e79798ea0cb$export$f2680fa305b734ca)) {
                    let { data: data3, status: status, statusText: statusText } = value;
                    return [
                        "ErrorResponse",
                        data3,
                        status,
                        statusText
                    ];
                }
                if (value && typeof value === "object" && (0, $84c11e79798ea0cb$export$60644022b8b46aaa) in value) return [
                    "SingleFetchRedirect",
                    value[0, $84c11e79798ea0cb$export$60644022b8b46aaa]
                ];
            }
        ],
        postPlugins: [
            (value)=>{
                if (!value) return;
                if (typeof value !== "object") return;
                return [
                    "SingleFetchClassInstance",
                    Object.fromEntries(Object.entries(value))
                ];
            },
            ()=>[
                    "SingleFetchFallback"
                ]
        ]
    });
}
// lib/server-runtime/server.ts
function $279fdcca19aaa190$var$derive(build, mode) {
    let routes = $279fdcca19aaa190$var$createRoutes(build.routes);
    let dataRoutes = $279fdcca19aaa190$var$createStaticHandlerDataRoutes(build.routes, build.future);
    let serverMode = $279fdcca19aaa190$var$isServerMode(mode) ? mode : "production" /* Production */ ;
    let staticHandler = (0, $84c11e79798ea0cb$export$3336b097a6fbc59a)(dataRoutes, {
        basename: build.basename,
        unstable_instrumentations: build.entry.module.unstable_instrumentations
    });
    let errorHandler = build.entry.module.handleError || ((error, { request: request })=>{
        if (serverMode !== "test" /* Test */  && !request.signal.aborted) console.error(// @ts-expect-error This is "private" from users but intended for internal use
        (0, $84c11e79798ea0cb$export$972111febbeef05b)(error) && error.error ? error.error : error);
    });
    let requestHandler = async (request, initialContext)=>{
        let params = {};
        let loadContext;
        let handleError = (error)=>{
            if (mode === "development" /* Development */ ) $279fdcca19aaa190$var$getDevServerHooks()?.processRequestError?.(error);
            errorHandler(error, {
                context: loadContext,
                params: params,
                request: request
            });
        };
        if (build.future.v8_middleware) {
            if (initialContext && !(initialContext instanceof (0, $84c11e79798ea0cb$export$b8d3e69d4b3eff04))) {
                let error = new Error("Invalid `context` value provided to `handleRequest`. When middleware is enabled you must return an instance of `RouterContextProvider` from your `getLoadContext` function.");
                handleError(error);
                return $279fdcca19aaa190$var$returnLastResortErrorResponse(error, serverMode);
            }
            loadContext = initialContext || new (0, $84c11e79798ea0cb$export$b8d3e69d4b3eff04)();
        } else loadContext = initialContext || {};
        let url = new URL(request.url);
        let normalizedBasename = build.basename || "/";
        let normalizedPath = url.pathname;
        if (build.future.unstable_trailingSlashAwareDataRequests) {
            if (normalizedPath.endsWith("/_.data")) normalizedPath = normalizedPath.replace(/_.data$/, "");
            else normalizedPath = normalizedPath.replace(/\.data$/, "");
        } else {
            if ((0, $84c11e79798ea0cb$export$b69e3301ce081aa3)(normalizedPath, normalizedBasename) === "/_root.data") normalizedPath = normalizedBasename;
            else if (normalizedPath.endsWith(".data")) normalizedPath = normalizedPath.replace(/\.data$/, "");
            if ((0, $84c11e79798ea0cb$export$b69e3301ce081aa3)(normalizedPath, normalizedBasename) !== "/" && normalizedPath.endsWith("/")) normalizedPath = normalizedPath.slice(0, -1);
        }
        let isSpaMode = $279fdcca19aaa190$var$getBuildTimeHeader(request, "X-React-Router-SPA-Mode") === "yes";
        if (!build.ssr) {
            let decodedPath = decodeURI(normalizedPath);
            if (normalizedBasename !== "/") {
                let strippedPath = (0, $84c11e79798ea0cb$export$b69e3301ce081aa3)(decodedPath, normalizedBasename);
                if (strippedPath == null) {
                    errorHandler(new (0, $84c11e79798ea0cb$export$f2680fa305b734ca)(404, "Not Found", `Refusing to prerender the \`${decodedPath}\` path because it does not start with the basename \`${normalizedBasename}\``), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                }
                decodedPath = strippedPath;
            }
            if (build.prerender.length === 0) isSpaMode = true;
            else if (!build.prerender.includes(decodedPath) && !build.prerender.includes(decodedPath + "/")) {
                if (url.pathname.endsWith(".data")) {
                    errorHandler(new (0, $84c11e79798ea0cb$export$f2680fa305b734ca)(404, "Not Found", `Refusing to SSR the path \`${decodedPath}\` because \`ssr:false\` is set and the path is not included in the \`prerender\` config, so in production the path will be a 404.`), {
                        context: loadContext,
                        params: params,
                        request: request
                    });
                    return new Response("Not Found", {
                        status: 404,
                        statusText: "Not Found"
                    });
                } else isSpaMode = true;
            }
        }
        let manifestUrl = (0, $84c11e79798ea0cb$export$bcb79c3deff01d56)(build.routeDiscovery.manifestPath, normalizedBasename);
        if (url.pathname === manifestUrl) try {
            let res = await $279fdcca19aaa190$var$handleManifestRequest(build, routes, url);
            return res;
        } catch (e) {
            handleError(e);
            return new Response("Unknown Server Error", {
                status: 500
            });
        }
        let matches = $279fdcca19aaa190$var$matchServerRoutes(routes, normalizedPath, build.basename);
        if (matches && matches.length > 0) Object.assign(params, matches[0].params);
        let response;
        if (url.pathname.endsWith(".data")) {
            let handlerUrl = new URL(request.url);
            handlerUrl.pathname = normalizedPath;
            let singleFetchMatches = $279fdcca19aaa190$var$matchServerRoutes(routes, handlerUrl.pathname, build.basename);
            response = await $279fdcca19aaa190$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError);
            if ((0, $84c11e79798ea0cb$export$6e80290866a84dd4)(response)) response = $279fdcca19aaa190$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            if (build.entry.module.handleDataRequest) {
                response = await build.entry.module.handleDataRequest(response, {
                    context: loadContext,
                    params: singleFetchMatches ? singleFetchMatches[0].params : {},
                    request: request
                });
                if ((0, $84c11e79798ea0cb$export$6e80290866a84dd4)(response)) response = $279fdcca19aaa190$var$generateSingleFetchRedirectResponse(response, request, build, serverMode);
            }
        } else if (!isSpaMode && matches && matches[matches.length - 1].route.module.default == null && matches[matches.length - 1].route.module.ErrorBoundary == null) response = await $279fdcca19aaa190$var$handleResourceRequest(serverMode, build, staticHandler, matches.slice(-1)[0].route.id, request, loadContext, handleError);
        else {
            let { pathname: pathname } = url;
            let criticalCss = void 0;
            if (build.unstable_getCriticalCss) criticalCss = await build.unstable_getCriticalCss({
                pathname: pathname
            });
            else if (mode === "development" /* Development */  && $279fdcca19aaa190$var$getDevServerHooks()?.getCriticalCss) criticalCss = await $279fdcca19aaa190$var$getDevServerHooks()?.getCriticalCss?.(pathname);
            response = await $279fdcca19aaa190$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss);
        }
        if (request.method === "HEAD") return new Response(null, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
        return response;
    };
    if (build.entry.module.unstable_instrumentations) requestHandler = (0, $84c11e79798ea0cb$export$8f7a8e481272777)(requestHandler, build.entry.module.unstable_instrumentations.map((i)=>i.handler).filter(Boolean));
    return {
        routes: routes,
        dataRoutes: dataRoutes,
        serverMode: serverMode,
        staticHandler: staticHandler,
        errorHandler: errorHandler,
        requestHandler: requestHandler
    };
}
var $279fdcca19aaa190$export$6308091d8cbd0718 = (build, mode)=>{
    let _build;
    let routes;
    let serverMode;
    let staticHandler;
    let errorHandler;
    let _requestHandler;
    return async function requestHandler(request, initialContext) {
        _build = typeof build === "function" ? await build() : build;
        if (typeof build === "function") {
            let derived = $279fdcca19aaa190$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        } else if (!routes || !serverMode || !staticHandler || !errorHandler || !_requestHandler) {
            let derived = $279fdcca19aaa190$var$derive(_build, mode);
            routes = derived.routes;
            serverMode = derived.serverMode;
            staticHandler = derived.staticHandler;
            errorHandler = derived.errorHandler;
            _requestHandler = derived.requestHandler;
        }
        return _requestHandler(request, initialContext);
    };
};
async function $279fdcca19aaa190$var$handleManifestRequest(build, routes, url) {
    if (build.assets.version !== url.searchParams.get("version")) return new Response(null, {
        status: 204,
        headers: {
            "X-Remix-Reload-Document": "true"
        }
    });
    let patches = {};
    if (url.searchParams.has("paths")) {
        let paths = /* @__PURE__ */ new Set();
        let pathParam = url.searchParams.get("paths") || "";
        let requestedPaths = pathParam.split(",").filter(Boolean);
        requestedPaths.forEach((path)=>{
            if (!path.startsWith("/")) path = `/${path}`;
            let segments = path.split("/").slice(1);
            segments.forEach((_, i)=>{
                let partialPath = segments.slice(0, i + 1).join("/");
                paths.add(`/${partialPath}`);
            });
        });
        for (let path of paths){
            let matches = $279fdcca19aaa190$var$matchServerRoutes(routes, path, build.basename);
            if (matches) for (let match of matches){
                let routeId = match.route.id;
                let route = build.assets.routes[routeId];
                if (route) patches[routeId] = route;
            }
        }
        return Response.json(patches, {
            headers: {
                "Cache-Control": "public, max-age=31536000, immutable"
            }
        });
    }
    return new Response("Invalid Request", {
        status: 400
    });
}
async function $279fdcca19aaa190$var$handleSingleFetchRequest(serverMode, build, staticHandler, request, handlerUrl, loadContext, handleError) {
    let response = request.method !== "GET" ? await $279fdcca19aaa190$var$singleFetchAction(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError) : await $279fdcca19aaa190$var$singleFetchLoaders(build, serverMode, staticHandler, request, handlerUrl, loadContext, handleError);
    return response;
}
async function $279fdcca19aaa190$var$handleDocumentRequest(serverMode, build, staticHandler, request, loadContext, handleError, isSpaMode, criticalCss) {
    try {
        if (request.method === "POST") $279fdcca19aaa190$var$throwIfPotentialCSRFAttack(request.headers, Array.isArray(build.allowedActionOrigins) ? build.allowedActionOrigins : []);
        let result = await staticHandler.query(request, {
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (query)=>{
                try {
                    let innerResult = await query(request);
                    if (!(0, $84c11e79798ea0cb$export$3f1eb41d9a6a6a27)(innerResult)) innerResult = await renderHtml(innerResult, isSpaMode);
                    return innerResult;
                } catch (error) {
                    handleError(error);
                    return new Response(null, {
                        status: 500
                    });
                }
            } : void 0
        });
        if (!(0, $84c11e79798ea0cb$export$3f1eb41d9a6a6a27)(result)) result = await renderHtml(result, isSpaMode);
        return result;
    } catch (error) {
        handleError(error);
        return new Response(null, {
            status: 500
        });
    }
    async function renderHtml(context, isSpaMode2) {
        let headers = $279fdcca19aaa190$var$getDocumentHeaders(context, build);
        if ($279fdcca19aaa190$var$SERVER_NO_BODY_STATUS_CODES.has(context.statusCode)) return new Response(null, {
            status: context.statusCode,
            headers: headers
        });
        if (context.errors) {
            Object.values(context.errors).forEach((err)=>{
                if (!(0, $84c11e79798ea0cb$export$972111febbeef05b)(err) || err.error) handleError(err);
            });
            context.errors = $279fdcca19aaa190$var$sanitizeErrors(context.errors, serverMode);
        }
        let state = {
            loaderData: context.loaderData,
            actionData: context.actionData,
            errors: $279fdcca19aaa190$var$serializeErrors(context.errors, serverMode)
        };
        let baseServerHandoff = {
            basename: build.basename,
            future: build.future,
            routeDiscovery: build.routeDiscovery,
            ssr: build.ssr,
            isSpaMode: isSpaMode2
        };
        let entryContext = {
            manifest: build.assets,
            routeModules: $279fdcca19aaa190$var$createEntryRouteModules(build.routes),
            staticHandlerContext: context,
            criticalCss: criticalCss,
            serverHandoffString: $279fdcca19aaa190$var$createServerHandoffString({
                ...baseServerHandoff,
                criticalCss: criticalCss
            }),
            serverHandoffStream: $279fdcca19aaa190$var$encodeViaTurboStream(state, request.signal, build.entry.module.streamTimeout, serverMode),
            renderMeta: {},
            future: build.future,
            ssr: build.ssr,
            routeDiscovery: build.routeDiscovery,
            isSpaMode: isSpaMode2,
            serializeError: (err)=>$279fdcca19aaa190$var$serializeError(err, serverMode)
        };
        let handleDocumentRequestFunction = build.entry.module.default;
        try {
            return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
        } catch (error) {
            handleError(error);
            let errorForSecondRender = error;
            if ((0, $84c11e79798ea0cb$export$3f1eb41d9a6a6a27)(error)) try {
                let data2 = await $279fdcca19aaa190$var$unwrapResponse(error);
                errorForSecondRender = new (0, $84c11e79798ea0cb$export$f2680fa305b734ca)(error.status, error.statusText, data2);
            } catch (e) {}
            context = (0, $84c11e79798ea0cb$export$fec11da027c70692)(staticHandler.dataRoutes, context, errorForSecondRender);
            if (context.errors) context.errors = $279fdcca19aaa190$var$sanitizeErrors(context.errors, serverMode);
            let state2 = {
                loaderData: context.loaderData,
                actionData: context.actionData,
                errors: $279fdcca19aaa190$var$serializeErrors(context.errors, serverMode)
            };
            entryContext = {
                ...entryContext,
                staticHandlerContext: context,
                serverHandoffString: $279fdcca19aaa190$var$createServerHandoffString(baseServerHandoff),
                serverHandoffStream: $279fdcca19aaa190$var$encodeViaTurboStream(state2, request.signal, build.entry.module.streamTimeout, serverMode),
                renderMeta: {}
            };
            try {
                return await handleDocumentRequestFunction(request, context.statusCode, headers, entryContext, loadContext);
            } catch (error2) {
                handleError(error2);
                return $279fdcca19aaa190$var$returnLastResortErrorResponse(error2, serverMode);
            }
        }
    }
}
async function $279fdcca19aaa190$var$handleResourceRequest(serverMode, build, staticHandler, routeId, request, loadContext, handleError) {
    try {
        let result = await staticHandler.queryRoute(request, {
            routeId: routeId,
            requestContext: loadContext,
            generateMiddlewareResponse: build.future.v8_middleware ? async (queryRoute)=>{
                try {
                    let innerResult = await queryRoute(request);
                    return handleQueryRouteResult(innerResult);
                } catch (error) {
                    return handleQueryRouteError(error);
                }
            } : void 0
        });
        return handleQueryRouteResult(result);
    } catch (error) {
        return handleQueryRouteError(error);
    }
    function handleQueryRouteResult(result) {
        if ((0, $84c11e79798ea0cb$export$3f1eb41d9a6a6a27)(result)) return result;
        if (typeof result === "string") return new Response(result);
        return Response.json(result);
    }
    function handleQueryRouteError(error) {
        if ((0, $84c11e79798ea0cb$export$3f1eb41d9a6a6a27)(error)) return error;
        if ((0, $84c11e79798ea0cb$export$972111febbeef05b)(error)) {
            handleError(error);
            return $279fdcca19aaa190$var$errorResponseToJson(error, serverMode);
        }
        if (error instanceof Error && error.message === "Expected a response from queryRoute") {
            let newError = new Error("Expected a Response to be returned from resource route handler");
            handleError(newError);
            return $279fdcca19aaa190$var$returnLastResortErrorResponse(newError, serverMode);
        }
        handleError(error);
        return $279fdcca19aaa190$var$returnLastResortErrorResponse(error, serverMode);
    }
}
function $279fdcca19aaa190$var$errorResponseToJson(errorResponse, serverMode) {
    return Response.json($279fdcca19aaa190$var$serializeError(// @ts-expect-error This is "private" from users but intended for internal use
    errorResponse.error || new Error("Unexpected Server Error"), serverMode), {
        status: errorResponse.status,
        statusText: errorResponse.statusText
    });
}
function $279fdcca19aaa190$var$returnLastResortErrorResponse(error, serverMode) {
    let message = "Unexpected Server Error";
    if (serverMode !== "production" /* Production */ ) message += `

${String(error)}`;
    return new Response(message, {
        status: 500,
        headers: {
            "Content-Type": "text/plain"
        }
    });
}
function $279fdcca19aaa190$var$unwrapResponse(response) {
    let contentType = response.headers.get("Content-Type");
    return contentType && /\bapplication\/json\b/.test(contentType) ? response.body == null ? null : response.json() : response.text();
}
// lib/server-runtime/sessions.ts
function $279fdcca19aaa190$var$flash(name) {
    return `__flash_${name}__`;
}
var $279fdcca19aaa190$export$f7c62c73429afa28 = (initialData = {}, id = "")=>{
    let map = new Map(Object.entries(initialData));
    return {
        get id () {
            return id;
        },
        get data () {
            return Object.fromEntries(map);
        },
        has (name) {
            return map.has(name) || map.has($279fdcca19aaa190$var$flash(name));
        },
        get (name) {
            if (map.has(name)) return map.get(name);
            let flashName = $279fdcca19aaa190$var$flash(name);
            if (map.has(flashName)) {
                let value = map.get(flashName);
                map.delete(flashName);
                return value;
            }
            return void 0;
        },
        set (name, value) {
            map.set(name, value);
        },
        flash (name, value) {
            map.set($279fdcca19aaa190$var$flash(name), value);
        },
        unset (name) {
            map.delete(name);
        }
    };
};
var $279fdcca19aaa190$export$548944bd211b425f = (object)=>{
    return object != null && typeof object.id === "string" && typeof object.data !== "undefined" && typeof object.has === "function" && typeof object.get === "function" && typeof object.set === "function" && typeof object.flash === "function" && typeof object.unset === "function";
};
function $279fdcca19aaa190$export$1f1c547b06207ca3({ cookie: cookieArg, createData: createData, readData: readData, updateData: updateData, deleteData: deleteData }) {
    let cookie = $279fdcca19aaa190$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $279fdcca19aaa190$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $279fdcca19aaa190$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            let id = cookieHeader && await cookie.parse(cookieHeader, options);
            let data2 = id && await readData(id);
            return $279fdcca19aaa190$export$f7c62c73429afa28(data2 || {}, id || "");
        },
        async commitSession (session, options) {
            let { id: id, data: data2 } = session;
            let expires = options?.maxAge != null ? new Date(Date.now() + options.maxAge * 1e3) : options?.expires != null ? options.expires : cookie.expires;
            if (id) await updateData(id, data2, expires);
            else id = await createData(data2, expires);
            return cookie.serialize(id, options);
        },
        async destroySession (session, options) {
            await deleteData(session.id);
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
function $279fdcca19aaa190$var$warnOnceAboutSigningSessionCookie(cookie) {
    (0, $84c11e79798ea0cb$export$5b28268982f175ba)(cookie.isSigned, `The "${cookie.name}" cookie is not signed, but session cookies should be signed to prevent tampering on the client before they are sent back to the server. See https://reactrouter.com/explanation/sessions-and-cookies#signing-cookies for more information.`);
}
// lib/server-runtime/sessions/cookieStorage.ts
function $279fdcca19aaa190$export$2641c3ccec6bd360({ cookie: cookieArg } = {}) {
    let cookie = $279fdcca19aaa190$export$f00768c7d8d5ffdb(cookieArg) ? cookieArg : $279fdcca19aaa190$export$7892c26d6c7a7447(cookieArg?.name || "__session", cookieArg);
    $279fdcca19aaa190$var$warnOnceAboutSigningSessionCookie(cookie);
    return {
        async getSession (cookieHeader, options) {
            return $279fdcca19aaa190$export$f7c62c73429afa28(cookieHeader && await cookie.parse(cookieHeader, options) || {});
        },
        async commitSession (session, options) {
            let serializedCookie = await cookie.serialize(session.data, options);
            if (serializedCookie.length > 4096) throw new Error("Cookie length will exceed browser maximum. Length: " + serializedCookie.length);
            return serializedCookie;
        },
        async destroySession (_session, options) {
            return cookie.serialize("", {
                ...options,
                maxAge: void 0,
                expires: /* @__PURE__ */ new Date(0)
            });
        }
    };
}
// lib/server-runtime/sessions/memoryStorage.ts
function $279fdcca19aaa190$export$abd1f21611468758({ cookie: cookie } = {}) {
    let map = /* @__PURE__ */ new Map();
    return $279fdcca19aaa190$export$1f1c547b06207ca3({
        cookie: cookie,
        async createData (data2, expires) {
            let id = Math.random().toString(36).substring(2, 10);
            map.set(id, {
                data: data2,
                expires: expires
            });
            return id;
        },
        async readData (id) {
            if (map.has(id)) {
                let { data: data2, expires: expires } = map.get(id);
                if (!expires || expires > /* @__PURE__ */ new Date()) return data2;
                if (expires) map.delete(id);
            }
            return null;
        },
        async updateData (id, data2, expires) {
            map.set(id, {
                data: data2,
                expires: expires
            });
        },
        async deleteData (id) {
            map.delete(id);
        }
    });
}
// lib/href.ts
function $279fdcca19aaa190$export$8f51af5840e0602a(path, ...args) {
    let params = args[0];
    let result = $279fdcca19aaa190$var$trimTrailingSplat(path).replace(/\/:([\w-]+)(\?)?/g, // same regex as in .\router\utils.ts: compilePath().
    (_, param, questionMark)=>{
        const isRequired = questionMark === void 0;
        const value = params?.[param];
        if (isRequired && value === void 0) throw new Error(`Path '${path}' requires param '${param}' but it was not provided`);
        return value === void 0 ? "" : "/" + value;
    });
    if (path.endsWith("*")) {
        const value = params?.["*"];
        if (value !== void 0) result += "/" + value;
    }
    return result || "/";
}
function $279fdcca19aaa190$var$trimTrailingSplat(path) {
    let i = path.length - 1;
    let char = path[i];
    if (char !== "*" && char !== "/") return path;
    i--;
    for(; i >= 0; i--){
        if (path[i] !== "/") break;
    }
    return path.slice(0, i + 1);
}
// lib/rsc/html-stream/server.ts
var $279fdcca19aaa190$var$encoder2 = new TextEncoder();
var $279fdcca19aaa190$var$trailer = "</body></html>";
function $279fdcca19aaa190$var$injectRSCPayload(rscStream) {
    let decoder = new TextDecoder();
    let resolveFlightDataPromise;
    let flightDataPromise = new Promise((resolve)=>resolveFlightDataPromise = resolve);
    let startedRSC = false;
    let buffered = [];
    let timeout = null;
    function flushBufferedChunks(controller) {
        for (let chunk of buffered){
            let buf = decoder.decode(chunk, {
                stream: true
            });
            if (buf.endsWith($279fdcca19aaa190$var$trailer)) buf = buf.slice(0, -$279fdcca19aaa190$var$trailer.length);
            controller.enqueue($279fdcca19aaa190$var$encoder2.encode(buf));
        }
        buffered.length = 0;
        timeout = null;
    }
    return new TransformStream({
        transform (chunk, controller) {
            buffered.push(chunk);
            if (timeout) return;
            timeout = setTimeout(async ()=>{
                flushBufferedChunks(controller);
                if (!startedRSC) {
                    startedRSC = true;
                    $279fdcca19aaa190$var$writeRSCStream(rscStream, controller).catch((err)=>controller.error(err)).then(resolveFlightDataPromise);
                }
            }, 0);
        },
        async flush (controller) {
            await flightDataPromise;
            if (timeout) {
                clearTimeout(timeout);
                flushBufferedChunks(controller);
            }
            controller.enqueue($279fdcca19aaa190$var$encoder2.encode("</body></html>"));
        }
    });
}
async function $279fdcca19aaa190$var$writeRSCStream(rscStream, controller) {
    let decoder = new TextDecoder("utf-8", {
        fatal: true
    });
    const reader = rscStream.getReader();
    try {
        let read;
        while((read = await reader.read()) && !read.done){
            const chunk = read.value;
            try {
                $279fdcca19aaa190$var$writeChunk(JSON.stringify(decoder.decode(chunk, {
                    stream: true
                })), controller);
            } catch (err) {
                let base64 = JSON.stringify(btoa(String.fromCodePoint(...chunk)));
                $279fdcca19aaa190$var$writeChunk(`Uint8Array.from(atob(${base64}), m => m.codePointAt(0))`, controller);
            }
        }
    } finally{
        reader.releaseLock();
    }
    let remaining = decoder.decode();
    if (remaining.length) $279fdcca19aaa190$var$writeChunk(JSON.stringify(remaining), controller);
}
function $279fdcca19aaa190$var$writeChunk(chunk, controller) {
    controller.enqueue($279fdcca19aaa190$var$encoder2.encode(`<script>${$279fdcca19aaa190$var$escapeScript(`(self.__FLIGHT_DATA||=[]).push(${chunk})`)}</script>`));
}
function $279fdcca19aaa190$var$escapeScript(script) {
    return script.replace(/<!--/g, "<\\!--").replace(/<\/(script)/gi, "</\\$1");
}
var $279fdcca19aaa190$export$ea608ff93320d416 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component {
    constructor(props){
        super(props);
        this.state = {
            error: null,
            location: props.location
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: null,
            location: props.location
        };
        return {
            error: state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($279fdcca19aaa190$var$RSCDefaultRootErrorBoundaryImpl, {
            error: this.state.error,
            renderAppShell: true
        });
        else return this.props.children;
    }
};
function $279fdcca19aaa190$var$ErrorWrapper({ renderAppShell: renderAppShell, title: title, children: children }) {
    if (!renderAppShell) return children;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("head", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("title", null, title)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("body", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children)));
}
function $279fdcca19aaa190$var$RSCDefaultRootErrorBoundaryImpl({ error: error, renderAppShell: renderAppShell }) {
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("script", {
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $84c11e79798ea0cb$export$972111febbeef05b)(error)) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($279fdcca19aaa190$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), (0, $84c11e79798ea0cb$export$945fecf35a8ef089) ? heyDeveloper : null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($279fdcca19aaa190$var$ErrorWrapper, {
        renderAppShell: renderAppShell,
        title: "Application Error!"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $279fdcca19aaa190$export$a55eecbda762d267({ hasRootLayout: hasRootLayout }) {
    let error = (0, $84c11e79798ea0cb$export$ed527bf60f6e05f2)();
    if (hasRootLayout === void 0) throw new Error("Missing 'hasRootLayout' prop");
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($279fdcca19aaa190$var$RSCDefaultRootErrorBoundaryImpl, {
        renderAppShell: !hasRootLayout,
        error: error
    });
}
// lib/rsc/route-modules.ts
function $279fdcca19aaa190$var$createRSCRouteModules(payload) {
    const routeModules = {};
    for (const match of payload.matches)$279fdcca19aaa190$export$93a6ee970ac9d016(routeModules, match);
    return routeModules;
}
function $279fdcca19aaa190$export$93a6ee970ac9d016(routeModules, matches) {
    matches = Array.isArray(matches) ? matches : [
        matches
    ];
    for (const match of matches)routeModules[match.id] = {
        links: match.links,
        meta: match.meta,
        default: $279fdcca19aaa190$var$noopComponent
    };
}
var $279fdcca19aaa190$var$noopComponent = ()=>null;
// lib/rsc/server.ssr.tsx
var $279fdcca19aaa190$var$REACT_USE = "use";
var $279fdcca19aaa190$var$useImpl = $acw62[$279fdcca19aaa190$var$REACT_USE];
function $279fdcca19aaa190$var$useSafe(promise) {
    if ($279fdcca19aaa190$var$useImpl) return $279fdcca19aaa190$var$useImpl(promise);
    throw new Error("React Router v7 requires React 19+ for RSC features.");
}
async function $279fdcca19aaa190$export$144ccff01a5655fc({ request: request, serverResponse: serverResponse, createFromReadableStream: createFromReadableStream, renderHTML: renderHTML, hydrate: hydrate = true }) {
    const url = new URL(request.url);
    const isDataRequest = $279fdcca19aaa190$var$isReactServerRequest(url);
    const respondWithRSCPayload = isDataRequest || $279fdcca19aaa190$var$isManifestRequest(url) || request.headers.has("rsc-action-id");
    if (respondWithRSCPayload || serverResponse.headers.get("React-Router-Resource") === "true") return serverResponse;
    if (!serverResponse.body) throw new Error("Missing body in server response");
    const detectRedirectResponse = serverResponse.clone();
    let serverResponseB = null;
    if (hydrate) serverResponseB = serverResponse.clone();
    const body = serverResponse.body;
    let buffer;
    let streamControllers = [];
    const createStream = ()=>{
        if (!buffer) {
            buffer = [];
            return body.pipeThrough(new TransformStream({
                transform (chunk, controller) {
                    buffer.push(chunk);
                    controller.enqueue(chunk);
                    streamControllers.forEach((c)=>c.enqueue(chunk));
                },
                flush () {
                    streamControllers.forEach((c)=>c.close());
                    streamControllers = [];
                }
            }));
        }
        return new ReadableStream({
            start (controller) {
                buffer.forEach((chunk)=>controller.enqueue(chunk));
                streamControllers.push(controller);
            }
        });
    };
    let deepestRenderedBoundaryId = null;
    const getPayload = ()=>{
        const payloadPromise = Promise.resolve(createFromReadableStream(createStream()));
        return Object.defineProperties(payloadPromise, {
            _deepestRenderedBoundaryId: {
                get () {
                    return deepestRenderedBoundaryId;
                },
                set (boundaryId1) {
                    deepestRenderedBoundaryId = boundaryId1;
                }
            },
            formState: {
                get () {
                    return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                }
            }
        });
    };
    let renderRedirect;
    let renderError;
    try {
        if (!detectRedirectResponse.body) throw new Error("Failed to clone server response");
        const payload = await createFromReadableStream(detectRedirectResponse.body);
        if (serverResponse.status === (0, $84c11e79798ea0cb$export$ae9272e641ead836) && payload.type === "redirect") {
            const headers2 = new Headers(serverResponse.headers);
            headers2.delete("Content-Encoding");
            headers2.delete("Content-Length");
            headers2.delete("Content-Type");
            headers2.delete("X-Remix-Response");
            headers2.set("Location", payload.location);
            return new Response(serverResponseB?.body || "", {
                headers: headers2,
                status: payload.status,
                statusText: serverResponse.statusText
            });
        }
        let reactHeaders = new Headers();
        let status = serverResponse.status;
        let statusText = serverResponse.statusText;
        let html = await renderHTML(getPayload, {
            onError (error) {
                if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
                    renderRedirect = (0, $84c11e79798ea0cb$export$30db792b333fd2ee)(error.digest);
                    if (renderRedirect) return error.digest;
                    let routeErrorResponse = (0, $84c11e79798ea0cb$export$2b5950305b3e7eaf)(error.digest);
                    if (routeErrorResponse) {
                        renderError = routeErrorResponse;
                        status = routeErrorResponse.status;
                        statusText = routeErrorResponse.statusText;
                        return error.digest;
                    }
                }
            },
            onHeaders (headers2) {
                for (const [key, value] of headers2)reactHeaders.append(key, value);
            }
        });
        const headers = new Headers(reactHeaders);
        for (const [key, value] of serverResponse.headers)headers.append(key, value);
        headers.set("Content-Type", "text/html; charset=utf-8");
        if (renderRedirect) {
            headers.set("Location", renderRedirect.location);
            return new Response(html, {
                status: renderRedirect.status,
                headers: headers
            });
        }
        const redirectTransform = new TransformStream({
            flush (controller) {
                if (renderRedirect) controller.enqueue(new TextEncoder().encode(`<meta http-equiv="refresh" content="0;url=${(0, $84c11e79798ea0cb$export$4cf11838cdc2a8a8)(renderRedirect.location)}"/>`));
            }
        });
        if (!hydrate) return new Response(html.pipeThrough(redirectTransform), {
            status: status,
            statusText: statusText,
            headers: headers
        });
        if (!serverResponseB?.body) throw new Error("Failed to clone server response");
        const body2 = html.pipeThrough($279fdcca19aaa190$var$injectRSCPayload(serverResponseB.body)).pipeThrough(redirectTransform);
        return new Response(body2, {
            status: status,
            statusText: statusText,
            headers: headers
        });
    } catch (reason) {
        if (reason instanceof Response) return reason;
        if (renderRedirect) return new Response(`Redirect: ${renderRedirect.location}`, {
            status: renderRedirect.status,
            headers: {
                Location: renderRedirect.location
            }
        });
        try {
            reason = renderError ?? reason;
            let [status, statusText] = (0, $84c11e79798ea0cb$export$972111febbeef05b)(reason) ? [
                reason.status,
                reason.statusText
            ] : [
                500,
                ""
            ];
            let retryRedirect;
            let reactHeaders = new Headers();
            const html = await renderHTML(()=>{
                const decoded = Promise.resolve(createFromReadableStream(createStream()));
                const payloadPromise = decoded.then((payload)=>Object.assign(payload, {
                        status: status,
                        errors: deepestRenderedBoundaryId ? {
                            [deepestRenderedBoundaryId]: reason
                        } : {}
                    }));
                return Object.defineProperties(payloadPromise, {
                    _deepestRenderedBoundaryId: {
                        get () {
                            return deepestRenderedBoundaryId;
                        },
                        set (boundaryId1) {
                            deepestRenderedBoundaryId = boundaryId1;
                        }
                    },
                    formState: {
                        get () {
                            return payloadPromise.then((payload)=>payload.type === "render" ? payload.formState : void 0);
                        }
                    }
                });
            }, {
                onError (error) {
                    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
                        retryRedirect = (0, $84c11e79798ea0cb$export$30db792b333fd2ee)(error.digest);
                        if (retryRedirect) return error.digest;
                        let routeErrorResponse = (0, $84c11e79798ea0cb$export$2b5950305b3e7eaf)(error.digest);
                        if (routeErrorResponse) {
                            status = routeErrorResponse.status;
                            statusText = routeErrorResponse.statusText;
                            return error.digest;
                        }
                    }
                },
                onHeaders (headers2) {
                    for (const [key, value] of headers2)reactHeaders.append(key, value);
                }
            });
            const headers = new Headers(reactHeaders);
            for (const [key, value] of serverResponse.headers)headers.append(key, value);
            headers.set("Content-Type", "text/html; charset=utf-8");
            if (retryRedirect) {
                headers.set("Location", retryRedirect.location);
                return new Response(html, {
                    status: retryRedirect.status,
                    headers: headers
                });
            }
            const retryRedirectTransform = new TransformStream({
                flush (controller) {
                    if (retryRedirect) controller.enqueue(new TextEncoder().encode(`<meta http-equiv="refresh" content="0;url=${(0, $84c11e79798ea0cb$export$4cf11838cdc2a8a8)(retryRedirect.location)}"/>`));
                }
            });
            if (!hydrate) return new Response(html.pipeThrough(retryRedirectTransform), {
                status: status,
                statusText: statusText,
                headers: headers
            });
            if (!serverResponseB?.body) throw new Error("Failed to clone server response");
            const body2 = html.pipeThrough($279fdcca19aaa190$var$injectRSCPayload(serverResponseB.body)).pipeThrough(retryRedirectTransform);
            return new Response(body2, {
                status: status,
                statusText: statusText,
                headers: headers
            });
        } catch  {}
        throw reason;
    }
}
function $279fdcca19aaa190$export$7f2da8ab5e593830({ getPayload: getPayload }) {
    const decoded = getPayload();
    const payload = $279fdcca19aaa190$var$useSafe(decoded);
    if (payload.type === "redirect") throw new Response(null, {
        status: payload.status,
        headers: {
            Location: payload.location
        }
    });
    if (payload.type !== "render") return null;
    let patchedLoaderData = {
        ...payload.loaderData
    };
    for (const match of payload.matches)if ((0, $84c11e79798ea0cb$export$6ac68922d4e92125)(match.id, match.clientLoader, match.hasLoader, false) && (match.hydrateFallbackElement || !match.hasLoader)) delete patchedLoaderData[match.id];
    const context = {
        get _deepestRenderedBoundaryId () {
            return decoded._deepestRenderedBoundaryId ?? null;
        },
        set _deepestRenderedBoundaryId (boundaryId){
            decoded._deepestRenderedBoundaryId = boundaryId;
        },
        actionData: payload.actionData,
        actionHeaders: {},
        basename: payload.basename,
        errors: payload.errors,
        loaderData: patchedLoaderData,
        loaderHeaders: {},
        location: payload.location,
        statusCode: 200,
        matches: payload.matches.map((match)=>({
                params: match.params,
                pathname: match.pathname,
                pathnameBase: match.pathnameBase,
                route: {
                    id: match.id,
                    action: match.hasAction || !!match.clientAction,
                    handle: match.handle,
                    hasErrorBoundary: match.hasErrorBoundary,
                    loader: match.hasLoader || !!match.clientLoader,
                    index: match.index,
                    path: match.path,
                    shouldRevalidate: match.shouldRevalidate
                }
            }))
    };
    const router = (0, $84c11e79798ea0cb$export$3dd6171c30258b6f)(payload.matches.reduceRight((previous, match)=>{
        const route = {
            id: match.id,
            action: match.hasAction || !!match.clientAction,
            element: match.element,
            errorElement: match.errorElement,
            handle: match.handle,
            hasErrorBoundary: !!match.errorElement,
            hydrateFallbackElement: match.hydrateFallbackElement,
            index: match.index,
            loader: match.hasLoader || !!match.clientLoader,
            path: match.path,
            shouldRevalidate: match.shouldRevalidate
        };
        if (previous.length > 0) route.children = previous;
        return [
            route
        ];
    }, []), context);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            unstable_subResourceIntegrity: false,
            unstable_trailingSlashAwareDataRequests: true
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: {
            mode: "lazy",
            manifestPath: "/__manifest"
        },
        routeModules: $279fdcca19aaa190$var$createRSCRouteModules(payload)
    };
    return /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$717f757c655223f1).Provider, {
        value: true
    }, /* @__PURE__ */ $acw62.createElement($279fdcca19aaa190$export$ea608ff93320d416, {
        location: payload.location
    }, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$208d6a3bc3aa62bd).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$3d80f15952491985), {
        context: context,
        router: router,
        hydrate: false,
        nonce: payload.nonce
    }))));
}
function $279fdcca19aaa190$var$isReactServerRequest(url) {
    return url.pathname.endsWith(".rsc");
}
function $279fdcca19aaa190$var$isManifestRequest(url) {
    return url.pathname.endsWith(".manifest");
}
// lib/dom/ssr/errors.ts
function $279fdcca19aaa190$export$c923cb491441bb56(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $84c11e79798ea0cb$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    let error = new ErrorConstructor(val.message);
                    error.stack = val.stack;
                    serialized[key] = error;
                } catch (e) {}
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                error.stack = val.stack;
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
// lib/dom/ssr/hydration.tsx
function $279fdcca19aaa190$export$6fa8d910d97963ad({ state: state, routes: routes, getRouteInfo: getRouteInfo, location: location, basename: basename, isSpaMode: isSpaMode }) {
    let hydrationData = {
        ...state,
        loaderData: {
            ...state.loaderData
        }
    };
    let initialMatches = (0, $84c11e79798ea0cb$export$2708184779ceb39d)(routes, location, basename);
    if (initialMatches) for (let match of initialMatches){
        let routeId = match.route.id;
        let routeInfo = getRouteInfo(routeId);
        if ((0, $84c11e79798ea0cb$export$6ac68922d4e92125)(routeId, routeInfo.clientLoader, routeInfo.hasLoader, isSpaMode) && (routeInfo.hasHydrateFallback || !routeInfo.hasLoader)) delete hydrationData.loaderData[routeId];
        else if (!routeInfo.hasLoader) hydrationData.loaderData[routeId] = null;
    }
    return hydrationData;
}




var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
"use client";
function $5fc20031e6d40819$export$323e4fc2fa4753fb(props) {
    return /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$323e4fc2fa4753fb), {
        flushSync: $1u0KT.flushSync,
        ...props
    });
}
var $5fc20031e6d40819$var$ssrInfo = null;
var $5fc20031e6d40819$var$router = null;
function $5fc20031e6d40819$var$initSsrInfo() {
    if (!$5fc20031e6d40819$var$ssrInfo && window.__reactRouterContext && window.__reactRouterManifest && window.__reactRouterRouteModules) {
        if (window.__reactRouterManifest.sri === true) {
            const importMap = document.querySelector("script[rr-importmap]");
            if (importMap?.textContent) try {
                window.__reactRouterManifest.sri = JSON.parse(importMap.textContent).integrity;
            } catch (err) {
                console.error("Failed to parse import map", err);
            }
        }
        $5fc20031e6d40819$var$ssrInfo = {
            context: window.__reactRouterContext,
            manifest: window.__reactRouterManifest,
            routeModules: window.__reactRouterRouteModules,
            stateDecodingPromise: void 0,
            router: void 0,
            routerInitialized: false
        };
    }
}
function $5fc20031e6d40819$var$createHydratedRouter({ getContext: getContext, unstable_instrumentations: unstable_instrumentations }) {
    $5fc20031e6d40819$var$initSsrInfo();
    if (!$5fc20031e6d40819$var$ssrInfo) throw new Error("You must be using the SSR features of React Router in order to skip passing a `router` prop to `<RouterProvider>`");
    let localSsrInfo = $5fc20031e6d40819$var$ssrInfo;
    if (!$5fc20031e6d40819$var$ssrInfo.stateDecodingPromise) {
        let stream = $5fc20031e6d40819$var$ssrInfo.context.stream;
        (0, $84c11e79798ea0cb$export$f5708dca728d7177)(stream, "No stream found for single fetch decoding");
        $5fc20031e6d40819$var$ssrInfo.context.stream = void 0;
        $5fc20031e6d40819$var$ssrInfo.stateDecodingPromise = (0, $84c11e79798ea0cb$export$4023ad4ecd4126a2)(stream, window).then((value)=>{
            $5fc20031e6d40819$var$ssrInfo.context.state = value.value;
            localSsrInfo.stateDecodingPromise.value = true;
        }).catch((e)=>{
            localSsrInfo.stateDecodingPromise.error = e;
        });
    }
    if ($5fc20031e6d40819$var$ssrInfo.stateDecodingPromise.error) throw $5fc20031e6d40819$var$ssrInfo.stateDecodingPromise.error;
    if (!$5fc20031e6d40819$var$ssrInfo.stateDecodingPromise.value) throw $5fc20031e6d40819$var$ssrInfo.stateDecodingPromise;
    let routes = (0, $84c11e79798ea0cb$export$af76e85f27ba0229)($5fc20031e6d40819$var$ssrInfo.manifest.routes, $5fc20031e6d40819$var$ssrInfo.routeModules, $5fc20031e6d40819$var$ssrInfo.context.state, $5fc20031e6d40819$var$ssrInfo.context.ssr, $5fc20031e6d40819$var$ssrInfo.context.isSpaMode);
    let hydrationData = void 0;
    if ($5fc20031e6d40819$var$ssrInfo.context.isSpaMode) {
        let { loaderData: loaderData } = $5fc20031e6d40819$var$ssrInfo.context.state;
        if ($5fc20031e6d40819$var$ssrInfo.manifest.routes.root?.hasLoader && loaderData && "root" in loaderData) hydrationData = {
            loaderData: {
                root: loaderData.root
            }
        };
    } else {
        hydrationData = (0, $279fdcca19aaa190$export$6fa8d910d97963ad)({
            state: $5fc20031e6d40819$var$ssrInfo.context.state,
            routes: routes,
            getRouteInfo: (routeId)=>({
                    clientLoader: $5fc20031e6d40819$var$ssrInfo.routeModules[routeId]?.clientLoader,
                    hasLoader: $5fc20031e6d40819$var$ssrInfo.manifest.routes[routeId]?.hasLoader === true,
                    hasHydrateFallback: $5fc20031e6d40819$var$ssrInfo.routeModules[routeId]?.HydrateFallback != null
                }),
            location: window.location,
            basename: window.__reactRouterContext?.basename,
            isSpaMode: $5fc20031e6d40819$var$ssrInfo.context.isSpaMode
        });
        if (hydrationData && hydrationData.errors) hydrationData.errors = (0, $279fdcca19aaa190$export$c923cb491441bb56)(hydrationData.errors);
    }
    let router2 = (0, $84c11e79798ea0cb$export$baddd0131ee8c05b)({
        routes: routes,
        history: (0, $84c11e79798ea0cb$export$719fc203c4e16dee)(),
        basename: $5fc20031e6d40819$var$ssrInfo.context.basename,
        getContext: getContext,
        hydrationData: hydrationData,
        hydrationRouteProperties: $84c11e79798ea0cb$export$e2fd2c03906469db,
        unstable_instrumentations: unstable_instrumentations,
        mapRouteProperties: $84c11e79798ea0cb$export$9269a41d8c4635e,
        future: {
            middleware: $5fc20031e6d40819$var$ssrInfo.context.future.v8_middleware
        },
        dataStrategy: (0, $84c11e79798ea0cb$export$77d7799427e365da)(()=>router2, $5fc20031e6d40819$var$ssrInfo.manifest, $5fc20031e6d40819$var$ssrInfo.routeModules, $5fc20031e6d40819$var$ssrInfo.context.ssr, $5fc20031e6d40819$var$ssrInfo.context.basename, $5fc20031e6d40819$var$ssrInfo.context.future.unstable_trailingSlashAwareDataRequests),
        patchRoutesOnNavigation: (0, $84c11e79798ea0cb$export$72ab377a1030deb9)($5fc20031e6d40819$var$ssrInfo.manifest, $5fc20031e6d40819$var$ssrInfo.routeModules, $5fc20031e6d40819$var$ssrInfo.context.ssr, $5fc20031e6d40819$var$ssrInfo.context.routeDiscovery, $5fc20031e6d40819$var$ssrInfo.context.isSpaMode, $5fc20031e6d40819$var$ssrInfo.context.basename)
    });
    $5fc20031e6d40819$var$ssrInfo.router = router2;
    if (router2.state.initialized) {
        $5fc20031e6d40819$var$ssrInfo.routerInitialized = true;
        router2.initialize();
    }
    router2.createRoutesForHMR = /* spacer so ts-ignore does not affect the right hand of the assignment */ (0, $84c11e79798ea0cb$export$49d9dc160d22054c);
    window.__reactRouterDataRouter = router2;
    return router2;
}
function $5fc20031e6d40819$export$63ce90781bf4d238(props) {
    if (!$5fc20031e6d40819$var$router) $5fc20031e6d40819$var$router = $5fc20031e6d40819$var$createHydratedRouter({
        getContext: props.getContext,
        unstable_instrumentations: props.unstable_instrumentations
    });
    let [criticalCss, setCriticalCss] = $acw62.useState(void 0);
    $acw62.useEffect(()=>{}, []);
    $acw62.useEffect(()=>{
        var element;
    }, [
        criticalCss
    ]);
    let [location2, setLocation] = $acw62.useState($5fc20031e6d40819$var$router.state.location);
    $acw62.useLayoutEffect(()=>{
        if ($5fc20031e6d40819$var$ssrInfo && $5fc20031e6d40819$var$ssrInfo.router && !$5fc20031e6d40819$var$ssrInfo.routerInitialized) {
            $5fc20031e6d40819$var$ssrInfo.routerInitialized = true;
            $5fc20031e6d40819$var$ssrInfo.router.initialize();
        }
    }, []);
    $acw62.useLayoutEffect(()=>{
        if ($5fc20031e6d40819$var$ssrInfo && $5fc20031e6d40819$var$ssrInfo.router) return $5fc20031e6d40819$var$ssrInfo.router.subscribe((newState)=>{
            if (newState.location !== location2) setLocation(newState.location);
        });
    }, [
        location2
    ]);
    (0, $84c11e79798ea0cb$export$f5708dca728d7177)($5fc20031e6d40819$var$ssrInfo, "ssrInfo unavailable for HydratedRouter");
    (0, $84c11e79798ea0cb$export$5ef046b23d96090d)($5fc20031e6d40819$var$router, $5fc20031e6d40819$var$ssrInfo.manifest, $5fc20031e6d40819$var$ssrInfo.routeModules, $5fc20031e6d40819$var$ssrInfo.context.ssr, $5fc20031e6d40819$var$ssrInfo.context.routeDiscovery, $5fc20031e6d40819$var$ssrInfo.context.isSpaMode);
    return(// This fragment is important to ensure we match the <ServerRouter> JSX
    // structure so that useId values hydrate correctly
    /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$208d6a3bc3aa62bd).Provider, {
        value: {
            manifest: $5fc20031e6d40819$var$ssrInfo.manifest,
            routeModules: $5fc20031e6d40819$var$ssrInfo.routeModules,
            future: $5fc20031e6d40819$var$ssrInfo.context.future,
            criticalCss: criticalCss,
            ssr: $5fc20031e6d40819$var$ssrInfo.context.ssr,
            isSpaMode: $5fc20031e6d40819$var$ssrInfo.context.isSpaMode,
            routeDiscovery: $5fc20031e6d40819$var$ssrInfo.context.routeDiscovery
        }
    }, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$32e57f52df4b6e34), {
        location: location2
    }, /* @__PURE__ */ $acw62.createElement($5fc20031e6d40819$export$323e4fc2fa4753fb, {
        router: $5fc20031e6d40819$var$router,
        unstable_useTransitions: props.unstable_useTransitions,
        onError: props.onError
    }))), /* @__PURE__ */ $acw62.createElement($acw62.Fragment, null)));
}
function $5fc20031e6d40819$export$e5e8f3607b669df({ createFromReadableStream: createFromReadableStream, createTemporaryReferenceSet: createTemporaryReferenceSet, encodeReply: encodeReply, fetch: fetchImplementation = fetch }) {
    const globalVar = window;
    let landedActionId = 0;
    return async (id, args)=>{
        let actionId = globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
        const temporaryReferences = createTemporaryReferenceSet();
        const payloadPromise = fetchImplementation(new Request(location.href, {
            body: await encodeReply(args, {
                temporaryReferences: temporaryReferences
            }),
            method: "POST",
            headers: {
                Accept: "text/x-component",
                "rsc-action-id": id
            }
        })).then((response)=>{
            if (!response.body) throw new Error("No response body");
            return createFromReadableStream(response.body, {
                temporaryReferences: temporaryReferences
            });
        });
        $acw62.startTransition(()=>// @ts-expect-error - Needs React 19 types
            Promise.resolve(payloadPromise).then(async (payload)=>{
                if (payload.type === "redirect") {
                    if (payload.reload || $5fc20031e6d40819$var$isExternalLocation(payload.location)) {
                        window.location.href = payload.location;
                        return;
                    }
                    $acw62.startTransition(()=>{
                        globalVar.__reactRouterDataRouter.navigate(payload.location, {
                            replace: payload.replace
                        });
                    });
                    return;
                }
                if (payload.type !== "action") throw new Error("Unexpected payload type");
                const rerender = await payload.rerender;
                if (rerender && landedActionId < actionId && globalVar.__routerActionID <= actionId) {
                    if (rerender.type === "redirect") {
                        if (rerender.reload || $5fc20031e6d40819$var$isExternalLocation(rerender.location)) {
                            window.location.href = rerender.location;
                            return;
                        }
                        $acw62.startTransition(()=>{
                            globalVar.__reactRouterDataRouter.navigate(rerender.location, {
                                replace: rerender.replace
                            });
                        });
                        return;
                    }
                    $acw62.startTransition(()=>{
                        let lastMatch;
                        for (const match of rerender.matches){
                            globalVar.__reactRouterDataRouter.patchRoutes(lastMatch?.id ?? null, [
                                $5fc20031e6d40819$var$createRouteFromServerManifest(match)
                            ], true);
                            lastMatch = match;
                        }
                        window.__reactRouterDataRouter._internalSetStateDoNotUseOrYouWillBreakYourApp({
                            loaderData: Object.assign({}, globalVar.__reactRouterDataRouter.state.loaderData, rerender.loaderData),
                            errors: rerender.errors ? Object.assign({}, globalVar.__reactRouterDataRouter.state.errors, rerender.errors) : null
                        });
                    });
                }
            }).catch(()=>{}));
        return payloadPromise.then((payload)=>{
            if (payload.type !== "action" && payload.type !== "redirect") throw new Error("Unexpected payload type");
            return payload.actionResult;
        });
    };
}
function $5fc20031e6d40819$var$createRouterFromPayload({ fetchImplementation: fetchImplementation, createFromReadableStream: createFromReadableStream, getContext: getContext, payload: payload }) {
    const globalVar = window;
    if (globalVar.__reactRouterDataRouter && globalVar.__reactRouterRouteModules) return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
    if (payload.type !== "render") throw new Error("Invalid payload type");
    globalVar.__reactRouterRouteModules = globalVar.__reactRouterRouteModules ?? {};
    (0, $279fdcca19aaa190$export$93a6ee970ac9d016)(globalVar.__reactRouterRouteModules, payload.matches);
    let patches = /* @__PURE__ */ new Map();
    payload.patches?.forEach((patch)=>{
        (0, $84c11e79798ea0cb$export$f5708dca728d7177)(patch.parentId, "Invalid patch parentId");
        if (!patches.has(patch.parentId)) patches.set(patch.parentId, []);
        patches.get(patch.parentId)?.push(patch);
    });
    let routes = payload.matches.reduceRight((previous, match)=>{
        const route = $5fc20031e6d40819$var$createRouteFromServerManifest(match, payload);
        if (previous.length > 0) {
            route.children = previous;
            let childrenToPatch = patches.get(match.id);
            if (childrenToPatch) route.children.push(...childrenToPatch.map((r)=>$5fc20031e6d40819$var$createRouteFromServerManifest(r)));
        }
        return [
            route
        ];
    }, []);
    globalVar.__reactRouterDataRouter = (0, $84c11e79798ea0cb$export$baddd0131ee8c05b)({
        routes: routes,
        getContext: getContext,
        basename: payload.basename,
        history: (0, $84c11e79798ea0cb$export$719fc203c4e16dee)(),
        hydrationData: (0, $279fdcca19aaa190$export$6fa8d910d97963ad)({
            state: {
                loaderData: payload.loaderData,
                actionData: payload.actionData,
                errors: payload.errors
            },
            routes: routes,
            getRouteInfo: (routeId)=>{
                let match = payload.matches.find((m)=>m.id === routeId);
                (0, $84c11e79798ea0cb$export$f5708dca728d7177)(match, "Route not found in payload");
                return {
                    clientLoader: match.clientLoader,
                    hasLoader: match.hasLoader,
                    hasHydrateFallback: match.hydrateFallbackElement != null
                };
            },
            location: payload.location,
            basename: payload.basename,
            isSpaMode: false
        }),
        async patchRoutesOnNavigation ({ path: path, signal: signal }) {
            if ($5fc20031e6d40819$var$discoveredPaths.has(path)) return;
            await $5fc20031e6d40819$var$fetchAndApplyManifestPatches([
                path
            ], createFromReadableStream, fetchImplementation, signal);
        },
        // FIXME: Pass `build.ssr` into this function
        dataStrategy: $5fc20031e6d40819$var$getRSCSingleFetchDataStrategy(()=>globalVar.__reactRouterDataRouter, true, payload.basename, createFromReadableStream, fetchImplementation)
    });
    if (globalVar.__reactRouterDataRouter.state.initialized) {
        globalVar.__routerInitialized = true;
        globalVar.__reactRouterDataRouter.initialize();
    } else globalVar.__routerInitialized = false;
    let lastLoaderData = void 0;
    globalVar.__reactRouterDataRouter.subscribe(({ loaderData: loaderData, actionData: actionData })=>{
        if (lastLoaderData !== loaderData) globalVar.__routerActionID = (globalVar.__routerActionID ?? (globalVar.__routerActionID = 0)) + 1;
    });
    globalVar.__reactRouterDataRouter._updateRoutesForHMR = (routeUpdateByRouteId)=>{
        const oldRoutes = window.__reactRouterDataRouter.routes;
        const newRoutes = [];
        function walkRoutes(routes2, parentId) {
            return routes2.map((route)=>{
                const routeUpdate = routeUpdateByRouteId.get(route.id);
                if (routeUpdate) {
                    const { routeModule: routeModule, hasAction: hasAction, hasComponent: hasComponent, hasErrorBoundary: hasErrorBoundary, hasLoader: hasLoader } = routeUpdate;
                    const newRoute = $5fc20031e6d40819$var$createRouteFromServerManifest({
                        clientAction: routeModule.clientAction,
                        clientLoader: routeModule.clientLoader,
                        element: route.element,
                        errorElement: route.errorElement,
                        handle: route.handle,
                        hasAction: hasAction,
                        hasComponent: hasComponent,
                        hasErrorBoundary: hasErrorBoundary,
                        hasLoader: hasLoader,
                        hydrateFallbackElement: route.hydrateFallbackElement,
                        id: route.id,
                        index: route.index,
                        links: routeModule.links,
                        meta: routeModule.meta,
                        parentId: parentId,
                        path: route.path,
                        shouldRevalidate: routeModule.shouldRevalidate
                    });
                    if (route.children) newRoute.children = walkRoutes(route.children, route.id);
                    return newRoute;
                }
                const updatedRoute = {
                    ...route
                };
                if (route.children) updatedRoute.children = walkRoutes(route.children, route.id);
                return updatedRoute;
            });
        }
        newRoutes.push(...walkRoutes(oldRoutes, void 0));
        window.__reactRouterDataRouter._internalSetRoutes(newRoutes);
    };
    return {
        router: globalVar.__reactRouterDataRouter,
        routeModules: globalVar.__reactRouterRouteModules
    };
}
var $5fc20031e6d40819$var$renderedRoutesContext = (0, $84c11e79798ea0cb$export$fd42f52fd3ae1109)();
function $5fc20031e6d40819$var$getRSCSingleFetchDataStrategy(getRouter, ssr, basename, createFromReadableStream, fetchImplementation) {
    let dataStrategy = (0, $84c11e79798ea0cb$export$7144ac7f1a8613d3)(getRouter, (match)=>{
        let M = match;
        return {
            hasLoader: M.route.hasLoader,
            hasClientLoader: M.route.hasClientLoader,
            hasComponent: M.route.hasComponent,
            hasAction: M.route.hasAction,
            hasClientAction: M.route.hasClientAction,
            hasShouldRevalidate: M.route.hasShouldRevalidate
        };
    }, // pass map into fetchAndDecode so it can add payloads
    $5fc20031e6d40819$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation), ssr, basename, // .rsc requests are always trailing slash aware
    true, // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    (match)=>{
        let M = match;
        return M.route.hasComponent && !M.route.element;
    });
    return async (args)=>args.runClientMiddleware(async ()=>{
            let context = args.context;
            context.set($5fc20031e6d40819$var$renderedRoutesContext, []);
            let results = await dataStrategy(args);
            const renderedRoutesById = /* @__PURE__ */ new Map();
            for (const route of context.get($5fc20031e6d40819$var$renderedRoutesContext)){
                if (!renderedRoutesById.has(route.id)) renderedRoutesById.set(route.id, []);
                renderedRoutesById.get(route.id).push(route);
            }
            $acw62.startTransition(()=>{
                for (const match of args.matches){
                    const renderedRoutes = renderedRoutesById.get(match.route.id);
                    if (renderedRoutes) for (const rendered of renderedRoutes)window.__reactRouterDataRouter.patchRoutes(rendered.parentId ?? null, [
                        $5fc20031e6d40819$var$createRouteFromServerManifest(rendered)
                    ], true);
                }
            });
            return results;
        });
}
function $5fc20031e6d40819$var$getFetchAndDecodeViaRSC(createFromReadableStream, fetchImplementation) {
    return async (args, basename, trailingSlashAware, targetRoutes)=>{
        let { request: request, context: context } = args;
        let url = (0, $84c11e79798ea0cb$export$7b977381851b2c)(request.url, basename, trailingSlashAware, "rsc");
        if (request.method === "GET") {
            url = (0, $84c11e79798ea0cb$export$425969b7f98e2c9c)(url);
            if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
        }
        let res = await fetchImplementation(new Request(url, await (0, $84c11e79798ea0cb$export$a30aa2a0fce6c468)(request)));
        if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $84c11e79798ea0cb$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
        (0, $84c11e79798ea0cb$export$f5708dca728d7177)(res.body, "No response body to decode");
        try {
            const payload = await createFromReadableStream(res.body, {
                temporaryReferences: void 0
            });
            if (payload.type === "redirect") return {
                status: res.status,
                data: {
                    redirect: {
                        redirect: payload.location,
                        reload: payload.reload,
                        replace: payload.replace,
                        revalidate: false,
                        status: payload.status
                    }
                }
            };
            if (payload.type !== "render") throw new Error("Unexpected payload type");
            context.get($5fc20031e6d40819$var$renderedRoutesContext).push(...payload.matches);
            let results = {
                routes: {}
            };
            const dataKey = (0, $84c11e79798ea0cb$export$cbae47800eb95bc3)(request.method) ? "actionData" : "loaderData";
            for (let [routeId, data] of Object.entries(payload[dataKey] || {}))results.routes[routeId] = {
                data: data
            };
            if (payload.errors) for (let [routeId, error] of Object.entries(payload.errors))results.routes[routeId] = {
                error: error
            };
            return {
                status: res.status,
                data: results
            };
        } catch (e) {
            throw new Error("Unable to decode RSC response");
        }
    };
}
function $5fc20031e6d40819$export$af9dbdb90aaefbae({ createFromReadableStream: createFromReadableStream, fetch: fetchImplementation = fetch, payload: payload, routeDiscovery: routeDiscovery = "eager", getContext: getContext }) {
    if (payload.type !== "render") throw new Error("Invalid payload type");
    let { router: router2, routeModules: routeModules } = $acw62.useMemo(()=>$5fc20031e6d40819$var$createRouterFromPayload({
            payload: payload,
            fetchImplementation: fetchImplementation,
            getContext: getContext,
            createFromReadableStream: createFromReadableStream
        }), [
        createFromReadableStream,
        payload,
        fetchImplementation,
        getContext
    ]);
    $acw62.useEffect(()=>{
        (0, $84c11e79798ea0cb$export$3be068dde909e563)();
    }, []);
    $acw62.useLayoutEffect(()=>{
        const globalVar = window;
        if (!globalVar.__routerInitialized) {
            globalVar.__routerInitialized = true;
            globalVar.__reactRouterDataRouter.initialize();
        }
    }, []);
    let [{ routes: routes, state: state }, setState] = $acw62.useState(()=>({
            routes: $5fc20031e6d40819$var$cloneRoutes(router2.routes),
            state: router2.state
        }));
    $acw62.useLayoutEffect(()=>router2.subscribe((newState)=>{
            if ($5fc20031e6d40819$var$diffRoutes(router2.routes, routes)) $acw62.startTransition(()=>{
                setState({
                    routes: $5fc20031e6d40819$var$cloneRoutes(router2.routes),
                    state: newState
                });
            });
        }), [
        router2.subscribe,
        routes,
        router2
    ]);
    const transitionEnabledRouter = $acw62.useMemo(()=>({
            ...router2,
            state: state,
            routes: routes
        }), [
        router2,
        routes,
        state
    ]);
    $acw62.useEffect(()=>{
        if (routeDiscovery === "lazy" || // @ts-expect-error - TS doesn't know about this yet
        window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$5fc20031e6d40819$var$discoveredPaths.has(pathname)) $5fc20031e6d40819$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let paths = Array.from($5fc20031e6d40819$var$nextPaths.keys()).filter((path)=>{
                if ($5fc20031e6d40819$var$discoveredPaths.has(path)) {
                    $5fc20031e6d40819$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (paths.length === 0) return;
            try {
                await $5fc20031e6d40819$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $5fc20031e6d40819$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
    }, [
        routeDiscovery,
        createFromReadableStream,
        fetchImplementation
    ]);
    const frameworkContext = {
        future: {
            // These flags have no runtime impact so can always be false.  If we add
            // flags that drive runtime behavior they'll need to be proxied through.
            v8_middleware: false,
            unstable_subResourceIntegrity: false,
            unstable_trailingSlashAwareDataRequests: true
        },
        isSpaMode: false,
        ssr: true,
        criticalCss: "",
        manifest: {
            routes: {},
            version: "1",
            url: "",
            entry: {
                module: "",
                imports: []
            }
        },
        routeDiscovery: {
            mode: "lazy",
            manifestPath: "/__manifest"
        },
        routeModules: routeModules
    };
    return /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$717f757c655223f1).Provider, {
        value: true
    }, /* @__PURE__ */ $acw62.createElement((0, $279fdcca19aaa190$export$ea608ff93320d416), {
        location: state.location
    }, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$208d6a3bc3aa62bd).Provider, {
        value: frameworkContext
    }, /* @__PURE__ */ $acw62.createElement((0, $84c11e79798ea0cb$export$323e4fc2fa4753fb), {
        router: transitionEnabledRouter,
        flushSync: $1u0KT.flushSync
    }))));
}
function $5fc20031e6d40819$var$createRouteFromServerManifest(match, payload) {
    let hasInitialData = payload && match.id in payload.loaderData;
    let initialData = payload?.loaderData[match.id];
    let hasInitialError = payload?.errors && match.id in payload.errors;
    let initialError = payload?.errors?.[match.id];
    let isHydrationRequest = match.clientLoader?.hydrate === true || !match.hasLoader || // If the route has a component but we don't have an element, we need to hit
    // the server loader flow regardless of whether the client loader calls
    // `serverLoader` or not, otherwise we'll have nothing to render.
    match.hasComponent && !match.element;
    (0, $84c11e79798ea0cb$export$f5708dca728d7177)(window.__reactRouterRouteModules);
    (0, $279fdcca19aaa190$export$93a6ee970ac9d016)(window.__reactRouterRouteModules, match);
    let dataRoute = {
        id: match.id,
        element: match.element,
        errorElement: match.errorElement,
        handle: match.handle,
        hasErrorBoundary: match.hasErrorBoundary,
        hydrateFallbackElement: match.hydrateFallbackElement,
        index: match.index,
        loader: match.clientLoader ? async (args, singleFetch)=>{
            try {
                let result = await match.clientLoader({
                    ...args,
                    serverLoader: ()=>{
                        $5fc20031e6d40819$var$preventInvalidServerHandlerCall("loader", match.id, match.hasLoader);
                        if (isHydrationRequest) {
                            if (hasInitialData) return initialData;
                            if (hasInitialError) throw initialError;
                        }
                        return $5fc20031e6d40819$var$callSingleFetch(singleFetch);
                    }
                });
                return result;
            } finally{
                isHydrationRequest = false;
            }
        } : // We always make the call in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        (_, singleFetch)=>$5fc20031e6d40819$var$callSingleFetch(singleFetch),
        action: match.clientAction ? (args, singleFetch)=>match.clientAction({
                ...args,
                serverAction: async ()=>{
                    $5fc20031e6d40819$var$preventInvalidServerHandlerCall("action", match.id, match.hasLoader);
                    return await $5fc20031e6d40819$var$callSingleFetch(singleFetch);
                }
            }) : match.hasAction ? (_, singleFetch)=>$5fc20031e6d40819$var$callSingleFetch(singleFetch) : ()=>{
            throw (0, $84c11e79798ea0cb$export$2754e84c8e66e57d)("action", match.id);
        },
        path: match.path,
        shouldRevalidate: match.shouldRevalidate,
        // We always have a "loader" in this RSC world since even if we don't
        // have a `loader` we may need to get the `element` implementation
        hasLoader: true,
        hasClientLoader: match.clientLoader != null,
        hasAction: match.hasAction,
        hasClientAction: match.clientAction != null,
        hasShouldRevalidate: match.shouldRevalidate != null
    };
    if (typeof dataRoute.loader === "function") dataRoute.loader.hydrate = (0, $84c11e79798ea0cb$export$6ac68922d4e92125)(match.id, match.clientLoader, match.hasLoader, false);
    return dataRoute;
}
function $5fc20031e6d40819$var$callSingleFetch(singleFetch) {
    (0, $84c11e79798ea0cb$export$f5708dca728d7177)(typeof singleFetch === "function", "Invalid singleFetch parameter");
    return singleFetch();
}
function $5fc20031e6d40819$var$preventInvalidServerHandlerCall(type, routeId, hasHandler) {
    if (!hasHandler) {
        let fn = type === "action" ? "serverAction()" : "serverLoader()";
        let msg = `You are trying to call ${fn} on a route that does not have a server ${type} (routeId: "${routeId}")`;
        console.error(msg);
        throw new (0, $84c11e79798ea0cb$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
var $5fc20031e6d40819$var$nextPaths = /* @__PURE__ */ new Set();
var $5fc20031e6d40819$var$discoveredPathsMaxSize = 1e3;
var $5fc20031e6d40819$var$discoveredPaths = /* @__PURE__ */ new Set();
var $5fc20031e6d40819$var$URL_LIMIT = 7680;
function $5fc20031e6d40819$var$getManifestUrl(paths) {
    if (paths.length === 0) return null;
    if (paths.length === 1) return new URL(`${paths[0]}.manifest`, window.location.origin);
    const globalVar = window;
    let basename = (globalVar.__reactRouterDataRouter.basename ?? "").replace(/^\/|\/$/g, "");
    let url = new URL(`${basename}/.manifest`, window.location.origin);
    url.searchParams.set("paths", paths.sort().join(","));
    return url;
}
async function $5fc20031e6d40819$var$fetchAndApplyManifestPatches(paths, createFromReadableStream, fetchImplementation, signal) {
    let url = $5fc20031e6d40819$var$getManifestUrl(paths);
    if (url == null) return;
    if (url.toString().length > $5fc20031e6d40819$var$URL_LIMIT) {
        $5fc20031e6d40819$var$nextPaths.clear();
        return;
    }
    let response = await fetchImplementation(new Request(url, {
        signal: signal
    }));
    if (!response.body || response.status < 200 || response.status >= 300) throw new Error("Unable to fetch new route matches from the server");
    let payload = await createFromReadableStream(response.body, {
        temporaryReferences: void 0
    });
    if (payload.type !== "manifest") throw new Error("Failed to patch routes");
    paths.forEach((p)=>$5fc20031e6d40819$var$addToFifoQueue(p, $5fc20031e6d40819$var$discoveredPaths));
    $acw62.startTransition(()=>{
        payload.patches.forEach((p)=>{
            window.__reactRouterDataRouter.patchRoutes(p.parentId ?? null, [
                $5fc20031e6d40819$var$createRouteFromServerManifest(p)
            ]);
        });
    });
}
function $5fc20031e6d40819$var$addToFifoQueue(path, queue) {
    if (queue.size >= $5fc20031e6d40819$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (typeof first === "string") queue.delete(first);
    }
    queue.add(path);
}
function $5fc20031e6d40819$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}
function $5fc20031e6d40819$var$isExternalLocation(location2) {
    const newLocation = new URL(location2, window.location.href);
    return newLocation.origin !== window.location.origin;
}
function $5fc20031e6d40819$var$cloneRoutes(routes) {
    if (!routes) return void 0;
    return routes.map((route)=>({
            ...route,
            children: $5fc20031e6d40819$var$cloneRoutes(route.children)
        }));
}
function $5fc20031e6d40819$var$diffRoutes(a, b) {
    if (a.length !== b.length) return true;
    return a.some((route, index)=>{
        if (route.element !== b[index].element) return true;
        if (route.errorElement !== b[index].errorElement) return true;
        if (route.hydrateFallbackElement !== b[index].hydrateFallbackElement) return true;
        if (route.hasErrorBoundary !== b[index].hasErrorBoundary) return true;
        if (route.hasLoader !== b[index].hasLoader) return true;
        if (route.hasClientLoader !== b[index].hasClientLoader) return true;
        if (route.hasAction !== b[index].hasAction) return true;
        if (route.hasClientAction !== b[index].hasClientAction) return true;
        return $5fc20031e6d40819$var$diffRoutes(route.children || [], b[index].children || []);
    });
}
// lib/rsc/html-stream/browser.ts
function $5fc20031e6d40819$export$f4bb6b48866e43b() {
    let encoder = new TextEncoder();
    let streamController = null;
    let rscStream = new ReadableStream({
        start (controller) {
            if (typeof window === "undefined") return;
            let handleChunk = (chunk)=>{
                if (typeof chunk === "string") controller.enqueue(encoder.encode(chunk));
                else controller.enqueue(chunk);
            };
            window.__FLIGHT_DATA || (window.__FLIGHT_DATA = []);
            window.__FLIGHT_DATA.forEach(handleChunk);
            window.__FLIGHT_DATA.push = (chunk)=>{
                handleChunk(chunk);
                return 0;
            };
            streamController = controller;
        }
    });
    if (typeof document !== "undefined" && document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>{
        streamController?.close();
    });
    else streamController?.close();
    return rscStream;
}


var $f635dbd997866340$exports = {};

$parcel$export($f635dbd997866340$exports, "Await", () => $84c11e79798ea0cb$export$6ddabde395c8c576);
$parcel$export($f635dbd997866340$exports, "BrowserRouter", () => $84c11e79798ea0cb$export$9ba4e89fdfa1fc54);
$parcel$export($f635dbd997866340$exports, "Form", () => $84c11e79798ea0cb$export$a7fed597f4b8afd8);
$parcel$export($f635dbd997866340$exports, "HashRouter", () => $84c11e79798ea0cb$export$7221d69dcfc8e36b);
$parcel$export($f635dbd997866340$exports, "IDLE_BLOCKER", () => $84c11e79798ea0cb$export$386d57f03f0b2883);
$parcel$export($f635dbd997866340$exports, "IDLE_FETCHER", () => $84c11e79798ea0cb$export$52eace9c284d3585);
$parcel$export($f635dbd997866340$exports, "IDLE_NAVIGATION", () => $84c11e79798ea0cb$export$ed3e14b2f9e105d0);
$parcel$export($f635dbd997866340$exports, "Link", () => $84c11e79798ea0cb$export$a6c7ac8248d6e38a);
$parcel$export($f635dbd997866340$exports, "Links", () => $84c11e79798ea0cb$export$b2e089eb3692b073);
$parcel$export($f635dbd997866340$exports, "MemoryRouter", () => $84c11e79798ea0cb$export$ae46f04cfaffe093);
$parcel$export($f635dbd997866340$exports, "Meta", () => $84c11e79798ea0cb$export$b08a9033b36413fb);
$parcel$export($f635dbd997866340$exports, "NavLink", () => $84c11e79798ea0cb$export$b0d92dbee9b5b60d);
$parcel$export($f635dbd997866340$exports, "Navigate", () => $84c11e79798ea0cb$export$444b3ab0cb9aec40);
$parcel$export($f635dbd997866340$exports, "NavigationType", () => $84c11e79798ea0cb$export$e19cd5f9376f8cee);
$parcel$export($f635dbd997866340$exports, "Outlet", () => $84c11e79798ea0cb$export$910ae8079b2c2852);
$parcel$export($f635dbd997866340$exports, "PrefetchPageLinks", () => $84c11e79798ea0cb$export$60dcec93e67386bd);
$parcel$export($f635dbd997866340$exports, "Route", () => $84c11e79798ea0cb$export$e7b0ac011bb776c6);
$parcel$export($f635dbd997866340$exports, "Router", () => $84c11e79798ea0cb$export$55185c17a0fcbe46);
$parcel$export($f635dbd997866340$exports, "RouterContextProvider", () => $84c11e79798ea0cb$export$b8d3e69d4b3eff04);
$parcel$export($f635dbd997866340$exports, "RouterProvider", () => $84c11e79798ea0cb$export$323e4fc2fa4753fb);
$parcel$export($f635dbd997866340$exports, "Routes", () => $84c11e79798ea0cb$export$3565eb3d00ca5a74);
$parcel$export($f635dbd997866340$exports, "Scripts", () => $84c11e79798ea0cb$export$ff0bf87698939488);
$parcel$export($f635dbd997866340$exports, "ScrollRestoration", () => $84c11e79798ea0cb$export$11aac1aab828f1fa);
$parcel$export($f635dbd997866340$exports, "ServerRouter", () => $279fdcca19aaa190$export$7246f7e18cebe1bd);
$parcel$export($f635dbd997866340$exports, "StaticRouter", () => $84c11e79798ea0cb$export$cac06da4d76d935b);
$parcel$export($f635dbd997866340$exports, "StaticRouterProvider", () => $84c11e79798ea0cb$export$3d80f15952491985);
$parcel$export($f635dbd997866340$exports, "UNSAFE_AwaitContextProvider", () => $84c11e79798ea0cb$export$2666c20e15407622);
$parcel$export($f635dbd997866340$exports, "UNSAFE_DataRouterContext", () => $84c11e79798ea0cb$export$2eeee58951ff3c1c);
$parcel$export($f635dbd997866340$exports, "UNSAFE_DataRouterStateContext", () => $84c11e79798ea0cb$export$315e3ffb01f217);
$parcel$export($f635dbd997866340$exports, "UNSAFE_ErrorResponseImpl", () => $84c11e79798ea0cb$export$f2680fa305b734ca);
$parcel$export($f635dbd997866340$exports, "UNSAFE_FetchersContext", () => $84c11e79798ea0cb$export$cb3f1df1bef00a39);
$parcel$export($f635dbd997866340$exports, "UNSAFE_FrameworkContext", () => $84c11e79798ea0cb$export$208d6a3bc3aa62bd);
$parcel$export($f635dbd997866340$exports, "UNSAFE_LocationContext", () => $84c11e79798ea0cb$export$e6a44b110a0c44d3);
$parcel$export($f635dbd997866340$exports, "UNSAFE_NavigationContext", () => $84c11e79798ea0cb$export$3044ab7fdabeaee6);
$parcel$export($f635dbd997866340$exports, "UNSAFE_RSCDefaultRootErrorBoundary", () => $279fdcca19aaa190$export$a55eecbda762d267);
$parcel$export($f635dbd997866340$exports, "UNSAFE_RemixErrorBoundary", () => $84c11e79798ea0cb$export$32e57f52df4b6e34);
$parcel$export($f635dbd997866340$exports, "UNSAFE_RouteContext", () => $84c11e79798ea0cb$export$aac280ed165a4397);
$parcel$export($f635dbd997866340$exports, "UNSAFE_ServerMode", () => $279fdcca19aaa190$export$e7973f87fd96e4f2);
$parcel$export($f635dbd997866340$exports, "UNSAFE_SingleFetchRedirectSymbol", () => $84c11e79798ea0cb$export$60644022b8b46aaa);
$parcel$export($f635dbd997866340$exports, "UNSAFE_ViewTransitionContext", () => $84c11e79798ea0cb$export$3681f408decb40d1);
$parcel$export($f635dbd997866340$exports, "UNSAFE_WithComponentProps", () => $84c11e79798ea0cb$export$6c4f3826290c37af);
$parcel$export($f635dbd997866340$exports, "UNSAFE_WithErrorBoundaryProps", () => $84c11e79798ea0cb$export$e5afde5c4b6d747b);
$parcel$export($f635dbd997866340$exports, "UNSAFE_WithHydrateFallbackProps", () => $84c11e79798ea0cb$export$f8cff34f39c1932a);
$parcel$export($f635dbd997866340$exports, "UNSAFE_createBrowserHistory", () => $84c11e79798ea0cb$export$719fc203c4e16dee);
$parcel$export($f635dbd997866340$exports, "UNSAFE_createClientRoutes", () => $84c11e79798ea0cb$export$af76e85f27ba0229);
$parcel$export($f635dbd997866340$exports, "UNSAFE_createClientRoutesWithHMRRevalidationOptOut", () => $84c11e79798ea0cb$export$49d9dc160d22054c);
$parcel$export($f635dbd997866340$exports, "UNSAFE_createHashHistory", () => $84c11e79798ea0cb$export$b71fdd3798280242);
$parcel$export($f635dbd997866340$exports, "UNSAFE_createMemoryHistory", () => $84c11e79798ea0cb$export$2b76ad033c6e6d08);
$parcel$export($f635dbd997866340$exports, "UNSAFE_createRouter", () => $84c11e79798ea0cb$export$baddd0131ee8c05b);
$parcel$export($f635dbd997866340$exports, "UNSAFE_decodeViaTurboStream", () => $84c11e79798ea0cb$export$4023ad4ecd4126a2);
$parcel$export($f635dbd997866340$exports, "UNSAFE_deserializeErrors", () => $279fdcca19aaa190$export$c923cb491441bb56);
$parcel$export($f635dbd997866340$exports, "UNSAFE_getHydrationData", () => $279fdcca19aaa190$export$6fa8d910d97963ad);
$parcel$export($f635dbd997866340$exports, "UNSAFE_getPatchRoutesOnNavigationFunction", () => $84c11e79798ea0cb$export$72ab377a1030deb9);
$parcel$export($f635dbd997866340$exports, "UNSAFE_getTurboStreamSingleFetchDataStrategy", () => $84c11e79798ea0cb$export$77d7799427e365da);
$parcel$export($f635dbd997866340$exports, "UNSAFE_hydrationRouteProperties", () => $84c11e79798ea0cb$export$e2fd2c03906469db);
$parcel$export($f635dbd997866340$exports, "UNSAFE_invariant", () => $84c11e79798ea0cb$export$f5708dca728d7177);
$parcel$export($f635dbd997866340$exports, "UNSAFE_mapRouteProperties", () => $84c11e79798ea0cb$export$9269a41d8c4635e);
$parcel$export($f635dbd997866340$exports, "UNSAFE_shouldHydrateRouteLoader", () => $84c11e79798ea0cb$export$6ac68922d4e92125);
$parcel$export($f635dbd997866340$exports, "UNSAFE_useFogOFWarDiscovery", () => $84c11e79798ea0cb$export$5ef046b23d96090d);
$parcel$export($f635dbd997866340$exports, "UNSAFE_useScrollRestoration", () => $84c11e79798ea0cb$export$c4ffdfe23dd48040);
$parcel$export($f635dbd997866340$exports, "UNSAFE_withComponentProps", () => $84c11e79798ea0cb$export$1a5de91a5c3255e0);
$parcel$export($f635dbd997866340$exports, "UNSAFE_withErrorBoundaryProps", () => $84c11e79798ea0cb$export$26aea97ad016e70c);
$parcel$export($f635dbd997866340$exports, "UNSAFE_withHydrateFallbackProps", () => $84c11e79798ea0cb$export$cd4a5850c74ba029);
$parcel$export($f635dbd997866340$exports, "createBrowserRouter", () => $84c11e79798ea0cb$export$1f3f55432a00e06d);
$parcel$export($f635dbd997866340$exports, "createContext", () => $84c11e79798ea0cb$export$fd42f52fd3ae1109);
$parcel$export($f635dbd997866340$exports, "createCookie", () => $279fdcca19aaa190$export$7892c26d6c7a7447);
$parcel$export($f635dbd997866340$exports, "createCookieSessionStorage", () => $279fdcca19aaa190$export$2641c3ccec6bd360);
$parcel$export($f635dbd997866340$exports, "createHashRouter", () => $84c11e79798ea0cb$export$1ba7ed8a3a7b3765);
$parcel$export($f635dbd997866340$exports, "createMemoryRouter", () => $84c11e79798ea0cb$export$f30f7e456d254e83);
$parcel$export($f635dbd997866340$exports, "createMemorySessionStorage", () => $279fdcca19aaa190$export$abd1f21611468758);
$parcel$export($f635dbd997866340$exports, "createPath", () => $84c11e79798ea0cb$export$fe53371bee54353d);
$parcel$export($f635dbd997866340$exports, "createRequestHandler", () => $279fdcca19aaa190$export$6308091d8cbd0718);
$parcel$export($f635dbd997866340$exports, "createRoutesFromChildren", () => $84c11e79798ea0cb$export$16da398f5434bdec);
$parcel$export($f635dbd997866340$exports, "createRoutesFromElements", () => $84c11e79798ea0cb$export$9b5b6d122dea0c88);
$parcel$export($f635dbd997866340$exports, "createRoutesStub", () => $279fdcca19aaa190$export$bea31554c7dfd2ad);
$parcel$export($f635dbd997866340$exports, "createSearchParams", () => $84c11e79798ea0cb$export$a2e4e2dcc7b1f22f);
$parcel$export($f635dbd997866340$exports, "createSession", () => $279fdcca19aaa190$export$f7c62c73429afa28);
$parcel$export($f635dbd997866340$exports, "createSessionStorage", () => $279fdcca19aaa190$export$1f1c547b06207ca3);
$parcel$export($f635dbd997866340$exports, "createStaticHandler", () => $84c11e79798ea0cb$export$69163f0b72ec60d9);
$parcel$export($f635dbd997866340$exports, "createStaticRouter", () => $84c11e79798ea0cb$export$3dd6171c30258b6f);
$parcel$export($f635dbd997866340$exports, "data", () => $84c11e79798ea0cb$export$4051a07651545597);
$parcel$export($f635dbd997866340$exports, "generatePath", () => $84c11e79798ea0cb$export$82476f982757e71e);
$parcel$export($f635dbd997866340$exports, "href", () => $279fdcca19aaa190$export$8f51af5840e0602a);
$parcel$export($f635dbd997866340$exports, "isCookie", () => $279fdcca19aaa190$export$f00768c7d8d5ffdb);
$parcel$export($f635dbd997866340$exports, "isRouteErrorResponse", () => $84c11e79798ea0cb$export$972111febbeef05b);
$parcel$export($f635dbd997866340$exports, "isSession", () => $279fdcca19aaa190$export$548944bd211b425f);
$parcel$export($f635dbd997866340$exports, "matchPath", () => $84c11e79798ea0cb$export$81336c211d5ff295);
$parcel$export($f635dbd997866340$exports, "matchRoutes", () => $84c11e79798ea0cb$export$2708184779ceb39d);
$parcel$export($f635dbd997866340$exports, "parsePath", () => $84c11e79798ea0cb$export$8ccf933b0513f8d0);
$parcel$export($f635dbd997866340$exports, "redirect", () => $84c11e79798ea0cb$export$89e12c5b50f7529d);
$parcel$export($f635dbd997866340$exports, "redirectDocument", () => $84c11e79798ea0cb$export$a6cd19cd1951a23c);
$parcel$export($f635dbd997866340$exports, "renderMatches", () => $84c11e79798ea0cb$export$daf73786167a7f72);
$parcel$export($f635dbd997866340$exports, "replace", () => $84c11e79798ea0cb$export$77ad94ebf1c2b9ed);
$parcel$export($f635dbd997866340$exports, "resolvePath", () => $84c11e79798ea0cb$export$b09f2ff0bbcb43c7);
$parcel$export($f635dbd997866340$exports, "unstable_HistoryRouter", () => $84c11e79798ea0cb$export$de73885c9336221c);
$parcel$export($f635dbd997866340$exports, "unstable_RSCStaticRouter", () => $279fdcca19aaa190$export$7f2da8ab5e593830);
$parcel$export($f635dbd997866340$exports, "unstable_routeRSCServerRequest", () => $279fdcca19aaa190$export$144ccff01a5655fc);
$parcel$export($f635dbd997866340$exports, "unstable_setDevServerHooks", () => $279fdcca19aaa190$export$31bc6e795ff1cb0a);
$parcel$export($f635dbd997866340$exports, "unstable_usePrompt", () => $84c11e79798ea0cb$export$fc7731b33eb53a93);
$parcel$export($f635dbd997866340$exports, "unstable_useRoute", () => $84c11e79798ea0cb$export$3f79f0b98112cf57);
$parcel$export($f635dbd997866340$exports, "useActionData", () => $84c11e79798ea0cb$export$fdc00f3f26066d5e);
$parcel$export($f635dbd997866340$exports, "useAsyncError", () => $84c11e79798ea0cb$export$17f53340677d5831);
$parcel$export($f635dbd997866340$exports, "useAsyncValue", () => $84c11e79798ea0cb$export$78a72ddb39bdd145);
$parcel$export($f635dbd997866340$exports, "useBeforeUnload", () => $84c11e79798ea0cb$export$c0a586b329cae57d);
$parcel$export($f635dbd997866340$exports, "useBlocker", () => $84c11e79798ea0cb$export$b273b3273281a049);
$parcel$export($f635dbd997866340$exports, "useFetcher", () => $84c11e79798ea0cb$export$5b0d2d9a9921565a);
$parcel$export($f635dbd997866340$exports, "useFetchers", () => $84c11e79798ea0cb$export$fa996778a3a31087);
$parcel$export($f635dbd997866340$exports, "useFormAction", () => $84c11e79798ea0cb$export$89a6bd6db0d97c56);
$parcel$export($f635dbd997866340$exports, "useHref", () => $84c11e79798ea0cb$export$b66bb29c5006f12f);
$parcel$export($f635dbd997866340$exports, "useInRouterContext", () => $84c11e79798ea0cb$export$9c954a9d03d32f4a);
$parcel$export($f635dbd997866340$exports, "useLinkClickHandler", () => $84c11e79798ea0cb$export$67621102c14d847);
$parcel$export($f635dbd997866340$exports, "useLoaderData", () => $84c11e79798ea0cb$export$1448a5050d252c4d);
$parcel$export($f635dbd997866340$exports, "useLocation", () => $84c11e79798ea0cb$export$45d76561a5302f2b);
$parcel$export($f635dbd997866340$exports, "useMatch", () => $84c11e79798ea0cb$export$6c330e8992e8a295);
$parcel$export($f635dbd997866340$exports, "useMatches", () => $84c11e79798ea0cb$export$2378eb7f5ff86053);
$parcel$export($f635dbd997866340$exports, "useNavigate", () => $84c11e79798ea0cb$export$9770f232ac06a008);
$parcel$export($f635dbd997866340$exports, "useNavigation", () => $84c11e79798ea0cb$export$d0fd4b7106de2769);
$parcel$export($f635dbd997866340$exports, "useNavigationType", () => $84c11e79798ea0cb$export$1b3f31771c5d07c);
$parcel$export($f635dbd997866340$exports, "useOutlet", () => $84c11e79798ea0cb$export$a3be3530d8e40d0b);
$parcel$export($f635dbd997866340$exports, "useOutletContext", () => $84c11e79798ea0cb$export$4138103a3ae699cc);
$parcel$export($f635dbd997866340$exports, "useParams", () => $84c11e79798ea0cb$export$99eaa27ddbbb95ef);
$parcel$export($f635dbd997866340$exports, "useResolvedPath", () => $84c11e79798ea0cb$export$e75d2a2d1b3c245b);
$parcel$export($f635dbd997866340$exports, "useRevalidator", () => $84c11e79798ea0cb$export$600dc272ed516c15);
$parcel$export($f635dbd997866340$exports, "useRouteError", () => $84c11e79798ea0cb$export$ed527bf60f6e05f2);
$parcel$export($f635dbd997866340$exports, "useRouteLoaderData", () => $84c11e79798ea0cb$export$fd5d37484eab868d);
$parcel$export($f635dbd997866340$exports, "useRoutes", () => $84c11e79798ea0cb$export$5d3fca4a98652595);
$parcel$export($f635dbd997866340$exports, "useSearchParams", () => $84c11e79798ea0cb$export$f1a78c17382fe22a);
$parcel$export($f635dbd997866340$exports, "useSubmit", () => $84c11e79798ea0cb$export$47c85c6e3a081d3);
$parcel$export($f635dbd997866340$exports, "useViewTransitionState", () => $84c11e79798ea0cb$export$e262bd1977bea848);
/**
 * react-router v7.12.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

"use client";


$parcel$exportWildcard($f6765cb7d08e9df0$exports, $f635dbd997866340$exports);


var $54656f276146068e$export$df9a5fb346e7c0bb = /*#__PURE__*/ $acw62.createContext(null);
var $54656f276146068e$export$2ae4a19e09ca9a00 = function useOktaAuth() {
    return $acw62.useContext($54656f276146068e$export$df9a5fb346e7c0bb);
};
var $54656f276146068e$var$OktaError = function OktaError(_ref) {
    var error = _ref.error;
    if (error.name && error.message) return /*#__PURE__*/ $acw62.createElement("p", null, error.name, ": ", error.message);
    return /*#__PURE__*/ $acw62.createElement("p", null, "Error: ", error.toString());
};
var $54656f276146068e$export$9fb697de7778c436 = function Security(_ref) {
    var oktaAuth = _ref.oktaAuth, restoreOriginalUri = _ref.restoreOriginalUri, onAuthRequired = _ref.onAuthRequired, children = _ref.children;
    var _React$useState = $acw62.useState(function() {
        if (!oktaAuth) return null;
        return oktaAuth.authStateManager.getAuthState();
    }), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), authState = _React$useState2[0], setAuthState = _React$useState2[1];
    $acw62.useEffect(function() {
        if (!oktaAuth || !restoreOriginalUri) return;
        if (oktaAuth.options.restoreOriginalUri) console.warn('Two custom restoreOriginalUri callbacks are detected. The one from the OktaAuth configuration will be overridden by the provided restoreOriginalUri prop from the Security component.');
        oktaAuth.options.restoreOriginalUri = /*#__PURE__*/ function() {
            var _ref2 = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee(oktaAuth, originalUri) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            return _context.abrupt("return", restoreOriginalUri(oktaAuth, originalUri));
                        case 1:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x, _x2) {
                return _ref2.apply(this, arguments);
            };
        }();
    }, []);
    $acw62.useEffect(function() {
        if (!oktaAuth) return;
        if (oktaAuth._oktaUserAgent) oktaAuth._oktaUserAgent.addEnvironment("@okta/okta-react".concat("/", "6.10.0"));
        else console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
        var currentAuthState = oktaAuth.authStateManager.getAuthState();
        if (currentAuthState !== authState) setAuthState(currentAuthState);
        var handler = function handler(authState) {
            setAuthState(authState);
        };
        oktaAuth.authStateManager.subscribe(handler);
        oktaAuth.start();
        return function() {
            oktaAuth.authStateManager.unsubscribe(handler);
        };
    }, [
        oktaAuth
    ]);
    var oktaContextValue = $acw62.useMemo(function() {
        return {
            oktaAuth: oktaAuth,
            authState: authState,
            _onAuthRequired: onAuthRequired
        };
    }, [
        oktaAuth,
        authState,
        onAuthRequired
    ]);
    if (!oktaAuth) {
        var err = new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('No oktaAuth instance passed to Security Component.');
        return /*#__PURE__*/ $acw62.createElement($54656f276146068e$var$OktaError, {
            error: err
        });
    }
    if (!restoreOriginalUri) {
        var _err = new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('No restoreOriginalUri callback passed to Security Component.');
        return /*#__PURE__*/ $acw62.createElement($54656f276146068e$var$OktaError, {
            error: _err
        });
    }
    if (!oktaAuth._oktaUserAgent) console.warn('_oktaUserAgent is not available on auth SDK instance. Please use okta-auth-js@^5.3.1 .');
    else {
        var isAuthJsSupported = (0, $0c15f44f3f7f8172$export$398604a469f7de9a)(oktaAuth._oktaUserAgent.getVersion(), "5.3.1", '>=');
        if (!isAuthJsSupported) {
            var _err2 = new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)("\n        Passed in oktaAuth is not compatible with the SDK,\n        minimum supported okta-auth-js version is ".concat("5.3.1", ".\n      "));
            return /*#__PURE__*/ $acw62.createElement($54656f276146068e$var$OktaError, {
                error: _err2
            });
        }
    }
    return /*#__PURE__*/ $acw62.createElement($54656f276146068e$export$df9a5fb346e7c0bb.Provider, {
        value: oktaContextValue
    }, children);
};
function $54656f276146068e$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54656f276146068e$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $54656f276146068e$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $54656f276146068e$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $54656f276146068e$export$683729e5315f529b = function withOktaAuth(ComponentToWrap) {
    var WrappedComponent = function WrappedComponent(props) {
        var oktaAuthProps = $54656f276146068e$export$2ae4a19e09ca9a00();
        return /*#__PURE__*/ $acw62.createElement(ComponentToWrap, $54656f276146068e$var$_objectSpread$1($54656f276146068e$var$_objectSpread$1({}, oktaAuthProps), props));
    };
    WrappedComponent.displayName = 'withOktaAuth_' + (ComponentToWrap.displayName || ComponentToWrap.name);
    return WrappedComponent;
};
var $54656f276146068e$var$handledRedirect = false;
var $54656f276146068e$export$8f938467209eea73 = function LoginCallback(_ref) {
    var errorComponent = _ref.errorComponent, _ref$loadingElement = _ref.loadingElement, loadingElement = _ref$loadingElement === void 0 ? null : _ref$loadingElement, onAuthResume = _ref.onAuthResume;
    var _useOktaAuth = $54656f276146068e$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState;
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), callbackError = _React$useState2[0], setCallbackError = _React$useState2[1];
    var ErrorReporter = errorComponent || $54656f276146068e$var$OktaError;
    $acw62.useEffect(function() {
        var isInteractionRequired = oktaAuth.idx.isInteractionRequired || oktaAuth.isInteractionRequired.bind(oktaAuth);
        if (onAuthResume && isInteractionRequired()) {
            onAuthResume();
            return;
        }
        if (!$54656f276146068e$var$handledRedirect) {
            oktaAuth.handleLoginRedirect()["catch"](function(e) {
                setCallbackError(e);
            });
            $54656f276146068e$var$handledRedirect = true;
        }
    }, [
        oktaAuth
    ]);
    var authError = authState === null || authState === void 0 ? void 0 : authState.error;
    var displayError = callbackError || authError;
    if (displayError) return /*#__PURE__*/ $acw62.createElement(ErrorReporter, {
        error: displayError
    });
    return loadingElement;
};
var $54656f276146068e$var$_excluded = [
    "onAuthRequired",
    "errorComponent"
];
function $54656f276146068e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $54656f276146068e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $54656f276146068e$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $f329557dcab6d0bb$export$2e2bcd8739ae039)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $54656f276146068e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $54656f276146068e$var$useMatch;
if ('useRouteMatch' in $f6765cb7d08e9df0$exports) $54656f276146068e$var$useMatch = $f6765cb7d08e9df0$exports['useRouteMatch' in $f6765cb7d08e9df0$exports ? 'useRouteMatch' : ''];
else $54656f276146068e$var$useMatch = function useMatch() {
    throw new (0, $9789dcf8e8374992$export$2e2bcd8739ae039)('Unsupported: SecureRoute only works with react-router-dom v5 or any router library with compatible APIs. See examples under the "samples" folder for how to implement your own custom SecureRoute Component.');
};
var $54656f276146068e$export$d93cdd50e579241c = function SecureRoute(_ref) {
    var onAuthRequired = _ref.onAuthRequired, errorComponent = _ref.errorComponent, routeProps = (0, $73ef9ce1c41fc0c0$export$2e2bcd8739ae039)(_ref, $54656f276146068e$var$_excluded);
    var _useOktaAuth = $54656f276146068e$export$2ae4a19e09ca9a00(), oktaAuth = _useOktaAuth.oktaAuth, authState = _useOktaAuth.authState, _onAuthRequired = _useOktaAuth._onAuthRequired;
    var match = $54656f276146068e$var$useMatch(routeProps);
    var pendingLogin = $acw62.useRef(false);
    var _React$useState = $acw62.useState(null), _React$useState2 = (0, $adaabbc18727b3e6$export$2e2bcd8739ae039)(_React$useState, 2), handleLoginError = _React$useState2[0], setHandleLoginError = _React$useState2[1];
    var ErrorReporter = errorComponent || $54656f276146068e$var$OktaError;
    $acw62.useEffect(function() {
        var handleLogin = /*#__PURE__*/ function() {
            var _ref2 = (0, $4051039ece381ef4$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).mark(function _callee() {
                var originalUri, onAuthRequiredFn;
                return (0, (/*@__PURE__*/$parcel$interopDefault($c6598bdb60f83fe0$exports))).wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!pendingLogin.current) {
                                _context.next = 2;
                                break;
                            }
                            return _context.abrupt("return");
                        case 2:
                            pendingLogin.current = true;
                            originalUri = (0, $83e7c3a0ba92185e$export$4ebdca5513a016fe)(window.location.href, window.location.origin);
                            oktaAuth.setOriginalUri(originalUri);
                            onAuthRequiredFn = onAuthRequired || _onAuthRequired;
                            if (!onAuthRequiredFn) {
                                _context.next = 11;
                                break;
                            }
                            _context.next = 9;
                            return onAuthRequiredFn(oktaAuth);
                        case 9:
                            _context.next = 13;
                            break;
                        case 11:
                            _context.next = 13;
                            return oktaAuth.signInWithRedirect();
                        case 13:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function handleLogin() {
                return _ref2.apply(this, arguments);
            };
        }();
        if (!match) return;
        if (!authState) return;
        if (authState.isAuthenticated) {
            pendingLogin.current = false;
            return;
        }
        if (!authState.isAuthenticated) handleLogin()["catch"](function(err) {
            setHandleLoginError(err);
        });
    }, [
        authState,
        oktaAuth,
        match,
        onAuthRequired,
        _onAuthRequired
    ]);
    if (handleLoginError) return /*#__PURE__*/ $acw62.createElement(ErrorReporter, {
        error: handleLoginError
    });
    if (!authState || !authState.isAuthenticated) return null;
    return /*#__PURE__*/ $acw62.createElement($f6765cb7d08e9df0$exports.Route, $54656f276146068e$var$_objectSpread({}, routeProps));
};



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


const $8484d09248d25570$var$defaultGenerator = (componentName)=>componentName;
const $8484d09248d25570$var$createClassNameGenerator = ()=>{
    let generate = $8484d09248d25570$var$defaultGenerator;
    return {
        configure (generator) {
            generate = generator;
        },
        generate (componentName) {
            return generate(componentName);
        },
        reset () {
            generate = $8484d09248d25570$var$defaultGenerator;
        }
    };
};
const $8484d09248d25570$var$ClassNameGenerator = $8484d09248d25570$var$createClassNameGenerator();
var $8484d09248d25570$export$2e2bcd8739ae039 = $8484d09248d25570$var$ClassNameGenerator;


const $35cd7d64717698f7$export$9d6b9120de57c54 = {
    active: 'active',
    checked: 'checked',
    completed: 'completed',
    disabled: 'disabled',
    error: 'error',
    expanded: 'expanded',
    focused: 'focused',
    focusVisible: 'focusVisible',
    open: 'open',
    readOnly: 'readOnly',
    required: 'required',
    selected: 'selected'
};
function $35cd7d64717698f7$export$2e2bcd8739ae039(componentName, slot, globalStatePrefix = 'Mui') {
    const globalStateClass = $35cd7d64717698f7$export$9d6b9120de57c54[slot];
    return globalStateClass ? `${globalStatePrefix}-${globalStateClass}` : `${(0, $8484d09248d25570$export$2e2bcd8739ae039).generate(componentName)}-${slot}`;
}
function $35cd7d64717698f7$export$34c0130b1f3e8ae3(slot) {
    return $35cd7d64717698f7$export$9d6b9120de57c54[slot] !== undefined;
}


/* eslint no-restricted-syntax: 0, prefer-template: 0, guard-for-in: 0
   ---
   These rules are preventing the performance optimizations below.
 */ /**
 * Compose classes from multiple sources.
 *
 * @example
 * ```tsx
 * const slots = {
 *  root: ['root', 'primary'],
 *  label: ['label'],
 * };
 *
 * const getUtilityClass = (slot) => `MuiButton-${slot}`;
 *
 * const classes = {
 *   root: 'my-root-class',
 * };
 *
 * const output = composeClasses(slots, getUtilityClass, classes);
 * // {
 * //   root: 'MuiButton-root MuiButton-primary my-root-class',
 * //   label: 'MuiButton-label',
 * // }
 * ```
 *
 * @param slots a list of classes for each possible slot
 * @param getUtilityClass a function to resolve the class based on the slot name
 * @param classes the input classes from props
 * @returns the resolved classes for all slots
 */ function $65847140631d74af$export$2e2bcd8739ae039(slots, getUtilityClass, classes) {
    const output = {};
    for(const slotName in slots){
        const slot = slots[slotName];
        let buffer = '';
        let start = true;
        for(let i = 0; i < slot.length; i += 1){
            const value = slot[i];
            if (value) {
                buffer += (start === true ? '' : ' ') + getUtilityClass(value);
                start = false;
                if (classes && classes[value]) buffer += ' ' + classes[value];
            }
        }
        output[slotName] = buffer;
    }
    return output;
}




function $8ec30e4d54713c84$export$2e2bcd8739ae039(params) {
    const { theme: theme, name: name, props: props } = params;
    if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) return props;
    return (0, $367acbd429e20ec9$export$2e2bcd8739ae039)(theme.components[name].defaultProps, props);
}



'use client';
function $9f45a3834bb6880f$export$2e2bcd8739ae039({ props: props, name: name, defaultTheme: defaultTheme, themeId: themeId }) {
    let theme = (0, $ac16d208682bdb3f$export$2e2bcd8739ae039)(defaultTheme);
    if (themeId) theme = theme[themeId] || theme;
    return (0, $8ec30e4d54713c84$export$2e2bcd8739ae039)({
        theme: theme,
        name: name,
        props: props
    });
}



const $9dc40fba00dc8e3b$var$styled = (0, $9a7e913a82f46e5c$export$2e2bcd8739ae039)();
var $9dc40fba00dc8e3b$export$2e2bcd8739ae039 = $9dc40fba00dc8e3b$var$styled;




'use client';
const $9d2a35bf051ea407$var$defaultTheme = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
const $9d2a35bf051ea407$var$defaultCreateStyledComponent = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiContainer',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`maxWidth${(0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fixed && styles.fixed,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
});
const $9d2a35bf051ea407$var$useThemePropsDefault = (inProps)=>(0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiContainer',
        defaultTheme: $9d2a35bf051ea407$var$defaultTheme
    });
const $9d2a35bf051ea407$var$useUtilityClasses = (ownerState, componentName)=>{
    const getContainerUtilityClass = (slot)=>{
        return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)(componentName, slot);
    };
    const { classes: classes, fixed: fixed, disableGutters: disableGutters, maxWidth: maxWidth } = ownerState;
    const slots = {
        root: [
            'root',
            maxWidth && `maxWidth${(0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fixed && 'fixed',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, getContainerUtilityClass, classes);
};
function $9d2a35bf051ea407$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $9d2a35bf051ea407$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $9d2a35bf051ea407$var$useThemePropsDefault, componentName: componentName = 'MuiContainer' } = options;
    const ContainerRoot = createStyledComponent(({ theme: theme, ownerState: ownerState })=>({
            width: '100%',
            marginLeft: 'auto',
            boxSizing: 'border-box',
            marginRight: 'auto',
            ...!ownerState.disableGutters && {
                paddingLeft: theme.spacing(2),
                paddingRight: theme.spacing(2),
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('sm')]: {
                    paddingLeft: theme.spacing(3),
                    paddingRight: theme.spacing(3)
                }
            }
        }), ({ theme: theme, ownerState: ownerState })=>ownerState.fixed && Object.keys(theme.breakpoints.values).reduce((acc, breakpointValueKey)=>{
            const breakpoint = breakpointValueKey;
            const value = theme.breakpoints.values[breakpoint];
            if (value !== 0) // @ts-ignore
            acc[theme.breakpoints.up(breakpoint)] = {
                maxWidth: `${value}${theme.breakpoints.unit}`
            };
            return acc;
        }, {}), ({ theme: theme, ownerState: ownerState })=>({
            // @ts-ignore module augmentation fails if custom breakpoints are used
            ...ownerState.maxWidth === 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up('xs')]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: Math.max(theme.breakpoints.values.xs, 444)
                }
            },
            ...ownerState.maxWidth && // @ts-ignore module augmentation fails if custom breakpoints are used
            ownerState.maxWidth !== 'xs' && {
                // @ts-ignore module augmentation fails if custom breakpoints are used
                [theme.breakpoints.up(ownerState.maxWidth)]: {
                    // @ts-ignore module augmentation fails if custom breakpoints are used
                    maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`
                }
            }
        }));
    const Container = /*#__PURE__*/ $acw62.forwardRef(function Container(inProps, ref) {
        const props = useThemeProps(inProps);
        const { className: className, component: component = 'div', disableGutters: disableGutters = false, fixed: fixed = false, maxWidth: maxWidth = 'lg', classes: classesProp, ...other } = props;
        const ownerState = {
            ...props,
            component: component,
            disableGutters: disableGutters,
            fixed: fixed,
            maxWidth: maxWidth
        };
        // @ts-ignore module augmentation fails if custom breakpoints are used
        const classes = $9d2a35bf051ea407$var$useUtilityClasses(ownerState, componentName);
        return(/*#__PURE__*/ // @ts-ignore theme is injected by the styled util
        (0, $7b02d682eb115277$exports.jsx)(ContainerRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other
        }));
    });
    return Container;
}



var $29da0f32997f4b8c$export$2e2bcd8739ae039 = (0, $c0a836f2f53d8f74$export$2e2bcd8739ae039);




'use client';
const $13157ffc893b45e9$var$Container = (0, $9d2a35bf051ea407$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
        name: 'MuiContainer',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                styles[`maxWidth${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
                ownerState.fixed && styles.fixed,
                ownerState.disableGutters && styles.disableGutters
            ];
        }
    }),
    useThemeProps: (inProps)=>(0, $1bc4906ad0338fb8$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiContainer'
        })
});
var $13157ffc893b45e9$export$2e2bcd8739ae039 = $13157ffc893b45e9$var$Container;


var $acw62 = parcelRequire("acw62");





'use client';
var $51b2e046136200b6$export$2e2bcd8739ae039 = (0, $7a3a319e7e555608$export$2e2bcd8739ae039);




/* eslint-disable @typescript-eslint/naming-convention */ // We need to pass an argument as `{ theme }` for PigmentCSS, but we don't want to
// allocate more objects.
const $e06afda6b2197864$var$arg = {
    theme: undefined
};
function $e06afda6b2197864$export$2e2bcd8739ae039(styleFn) {
    let lastValue;
    let lastTheme;
    return function styleMemoized(props) {
        let value = lastValue;
        if (value === undefined || props.theme !== lastTheme) {
            $e06afda6b2197864$var$arg.theme = props.theme;
            value = (0, $7c4e0616915ca3a0$export$2e2bcd8739ae039)(styleFn($e06afda6b2197864$var$arg));
            lastValue = value;
            lastTheme = props.theme;
        }
        return value;
    };
}


const $fac58cb18f36893e$var$memoTheme = (0, $e06afda6b2197864$export$2e2bcd8739ae039);
var $fac58cb18f36893e$export$2e2bcd8739ae039 = $fac58cb18f36893e$var$memoTheme;


/**
 * Type guard to check if the object has a "main" property of type string.
 *
 * @param obj - the object to check
 * @returns boolean
 */ function $9bc172c5d9139290$var$hasCorrectMainProperty(obj) {
    return typeof obj.main === 'string';
}
/**
 * Checks if the object conforms to the SimplePaletteColorOptions type.
 * The minimum requirement is that the object has a "main" property of type string, this is always checked.
 * Optionally, you can pass additional properties to check.
 *
 * @param obj - The object to check
 * @param additionalPropertiesToCheck - Array containing "light", "dark", and/or "contrastText"
 * @returns boolean
 */ function $9bc172c5d9139290$var$checkSimplePaletteColorValues(obj, additionalPropertiesToCheck = []) {
    if (!$9bc172c5d9139290$var$hasCorrectMainProperty(obj)) return false;
    for (const value of additionalPropertiesToCheck){
        if (!obj.hasOwnProperty(value) || typeof obj[value] !== 'string') return false;
    }
    return true;
}
function $9bc172c5d9139290$export$2e2bcd8739ae039(additionalPropertiesToCheck = []) {
    return ([, value])=>value && $9bc172c5d9139290$var$checkSimplePaletteColorValues(value, additionalPropertiesToCheck);
}




var $acw62 = parcelRequire("acw62");





/**
 * Returns a boolean indicating if the event's target has :focus-visible
 */ function $3abd7e3358fc5f35$export$2e2bcd8739ae039(element) {
    try {
        return element.matches(':focus-visible');
    } catch (error) {}
    return false;
}





var $acw62 = parcelRequire("acw62");
'use client';
function $27fddc0219860a83$export$2e2bcd8739ae039(...refs) {
    const cleanupRef = $acw62.useRef(undefined);
    const refEffect = $acw62.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return null;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup?.());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $acw62.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- intentionally ignoring that the dependency array must be an array literal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}


'use client';
var $0a9974d6176bfa01$export$2e2bcd8739ae039 = (0, $27fddc0219860a83$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

'use client';
/**
 * Inspired by https://github.com/facebook/react/issues/14099#issuecomment-440013892
 * See RFC in https://github.com/reactjs/rfcs/pull/220
 */ function $0c5a7e8ccbc07697$var$useEventCallback(fn) {
    const ref = $acw62.useRef(fn);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        ref.current = fn;
    });
    return $acw62.useRef((...args)=>// @ts-expect-error hide `this`
        (0, ref.current)(...args)).current;
}
var $0c5a7e8ccbc07697$export$2e2bcd8739ae039 = $0c5a7e8ccbc07697$var$useEventCallback;


'use client';
var $52726edc538865d0$export$2e2bcd8739ae039 = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $dd1092ee97d527c8$var$UNINITIALIZED = {};
function $dd1092ee97d527c8$export$2e2bcd8739ae039(init, initArg) {
    const ref = $acw62.useRef($dd1092ee97d527c8$var$UNINITIALIZED);
    if (ref.current === $dd1092ee97d527c8$var$UNINITIALIZED) ref.current = init(initArg);
    return ref;
}


'use client';
class $ad3b5cbf2e7edbd2$export$f5de0641c7db4154 {
    /** React ref to the ripple instance */ /** If the ripple component should be mounted */ /** Promise that resolves when the ripple component is mounted */ /** If the ripple component has been mounted */ /** React state hook setter */ static create() {
        return new $ad3b5cbf2e7edbd2$export$f5de0641c7db4154();
    }
    static use() {
        /* eslint-disable */ const ripple = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($ad3b5cbf2e7edbd2$export$f5de0641c7db4154.create).current;
        const [shouldMount, setShouldMount] = $acw62.useState(false);
        ripple.shouldMount = shouldMount;
        ripple.setShouldMount = setShouldMount;
        $acw62.useEffect(ripple.mountEffect, [
            shouldMount
        ]);
        /* eslint-enable */ return ripple;
    }
    constructor(){
        this.ref = {
            current: null
        };
        this.mounted = null;
        this.didMount = false;
        this.shouldMount = false;
        this.setShouldMount = null;
    }
    mount() {
        if (!this.mounted) {
            this.mounted = $ad3b5cbf2e7edbd2$var$createControlledPromise();
            this.shouldMount = true;
            this.setShouldMount(this.shouldMount);
        }
        return this.mounted;
    }
    mountEffect = ()=>{
        if (this.shouldMount && !this.didMount) {
            if (this.ref.current !== null) {
                this.didMount = true;
                this.mounted.resolve();
            }
        }
    };
    /* Ripple API */ start(...args) {
        this.mount().then(()=>this.ref.current?.start(...args));
    }
    stop(...args) {
        this.mount().then(()=>this.ref.current?.stop(...args));
    }
    pulsate(...args) {
        this.mount().then(()=>this.ref.current?.pulsate(...args));
    }
}
function $ad3b5cbf2e7edbd2$export$2e2bcd8739ae039() {
    return $ad3b5cbf2e7edbd2$export$f5de0641c7db4154.use();
}
function $ad3b5cbf2e7edbd2$var$createControlledPromise() {
    let resolve;
    let reject;
    const p = new Promise((resolveFn, rejectFn)=>{
        resolve = resolveFn;
        reject = rejectFn;
    });
    p.resolve = resolve;
    p.reject = reject;
    return p;
}



var $acw62 = parcelRequire("acw62");



function $cd69a1d4c6210e44$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}


function $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e) {
    return $0ad5d8b55fe970db$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $0ad5d8b55fe970db$export$2e2bcd8739ae039(t, e);
}


function $bbb54ce93eb94a95$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $0ad5d8b55fe970db$export$2e2bcd8739ae039)(t, o);
}




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $4c26e32a51d8c622$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);



var $acw62 = parcelRequire("acw62");
function $04540450bf60efa1$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $acw62.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $acw62.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $04540450bf60efa1$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $04540450bf60efa1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $04540450bf60efa1$export$fa71e2345c31d7a2(props, onExited) {
    return $04540450bf60efa1$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $04540450bf60efa1$var$getProp(child, 'appear', props),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', props),
            exit: $04540450bf60efa1$var$getProp(child, 'exit', props)
        });
    });
}
function $04540450bf60efa1$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $04540450bf60efa1$export$bbc8a025727ea824(nextProps.children);
    var children = $04540450bf60efa1$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $acw62.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $acw62.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $acw62.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $acw62.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $04540450bf60efa1$var$getProp(child, 'exit', nextProps),
            enter: $04540450bf60efa1$var$getProp(child, 'enter', nextProps)
        });
    });
    return children;
}


var $e4ea38a8b431e8fc$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $e4ea38a8b431e8fc$var$defaultProps = {
    component: 'div',
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $e4ea38a8b431e8fc$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $cd69a1d4c6210e44$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $04540450bf60efa1$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $04540450bf60efa1$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $04540450bf60efa1$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $e4ea38a8b431e8fc$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$e4ea38a8b431e8fc$var$TransitionGroup.propTypes = {};
$e4ea38a8b431e8fc$var$TransitionGroup.defaultProps = $e4ea38a8b431e8fc$var$defaultProps;
var $e4ea38a8b431e8fc$export$2e2bcd8739ae039 = $e4ea38a8b431e8fc$var$TransitionGroup;





var $acw62 = parcelRequire("acw62");
'use client';
const $a0e38fa988f617e0$var$EMPTY = [];
function $a0e38fa988f617e0$export$2e2bcd8739ae039(fn) {
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler -- no need to put `fn` in the dependency array
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(fn, $a0e38fa988f617e0$var$EMPTY);
/* eslint-enable react-hooks/exhaustive-deps */ }


'use client';
class $fcd4c6205d65c7df$export$786b4da70f00938b {
    static create() {
        return new $fcd4c6205d65c7df$export$786b4da70f00938b();
    }
    currentId = null;
    /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */ start(delay, fn) {
        this.clear();
        this.currentId = setTimeout(()=>{
            this.currentId = null;
            fn();
        }, delay);
    }
    clear = ()=>{
        if (this.currentId !== null) {
            clearTimeout(this.currentId);
            this.currentId = null;
        }
    };
    disposeEffect = ()=>{
        return this.clear;
    };
}
function $fcd4c6205d65c7df$export$2e2bcd8739ae039() {
    const timeout = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($fcd4c6205d65c7df$export$786b4da70f00938b.create).current;
    (0, $a0e38fa988f617e0$export$2e2bcd8739ae039)(timeout.disposeEffect);
    return timeout;
}





var $acw62 = parcelRequire("acw62");



'use client';
function $171a3e689242bc25$var$Ripple(props) {
    const { className: className, classes: classes, pulsate: pulsate = false, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, in: inProp, onExited: onExited, timeout: timeout } = props;
    const [leaving, setLeaving] = $acw62.useState(false);
    const rippleClassName = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
    const rippleStyles = {
        width: rippleSize,
        height: rippleSize,
        top: -(rippleSize / 2) + rippleY,
        left: -(rippleSize / 2) + rippleX
    };
    const childClassName = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
    if (!inProp && !leaving) setLeaving(true);
    $acw62.useEffect(()=>{
        if (!inProp && onExited != null) {
            // react-transition-group#onExited
            const timeoutId = setTimeout(onExited, timeout);
            return ()=>{
                clearTimeout(timeoutId);
            };
        }
        return undefined;
    }, [
        onExited,
        inProp,
        timeout
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: rippleClassName,
        style: rippleStyles,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: childClassName
        })
    });
}
var $171a3e689242bc25$export$2e2bcd8739ae039 = $171a3e689242bc25$var$Ripple;



function $82df286c368a2a01$export$2e2bcd8739ae039(componentName, slots, globalStatePrefix = 'Mui') {
    const result = {};
    slots.forEach((slot)=>{
        result[slot] = (0, $35cd7d64717698f7$export$2e2bcd8739ae039)(componentName, slot, globalStatePrefix);
    });
    return result;
}



function $71da1f2c906d4bee$export$b464606f735ab902(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTouchRipple', slot);
}
const $71da1f2c906d4bee$var$touchRippleClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTouchRipple', [
    'root',
    'ripple',
    'rippleVisible',
    'ripplePulsate',
    'child',
    'childLeaving',
    'childPulsate'
]);
var $71da1f2c906d4bee$export$2e2bcd8739ae039 = $71da1f2c906d4bee$var$touchRippleClasses;



'use client';
const $ed95ec2260a9d464$var$DURATION = 550;
const $ed95ec2260a9d464$export$95d0c9356b2231a3 = 80;
const $ed95ec2260a9d464$var$enterKeyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`;
const $ed95ec2260a9d464$var$exitKeyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`;
const $ed95ec2260a9d464$var$pulsateKeyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`;
const $ed95ec2260a9d464$export$f6b7418508c72c25 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiTouchRipple',
    slot: 'Root'
})({
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    zIndex: 0,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit'
});
const $ed95ec2260a9d464$export$676cfe7b12693c4b = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $171a3e689242bc25$export$2e2bcd8739ae039), {
    name: 'MuiTouchRipple',
    slot: 'Ripple'
})`
  opacity: 0;
  position: absolute;

  &.${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).rippleVisible} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${$ed95ec2260a9d464$var$enterKeyframe};
    animation-duration: ${$ed95ec2260a9d464$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  &.${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripplePulsate} {
    animation-duration: ${({ theme: theme })=>theme.transitions.duration.shorter}ms;
  }

  & .${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).child} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childLeaving} {
    opacity: 0;
    animation-name: ${$ed95ec2260a9d464$var$exitKeyframe};
    animation-duration: ${$ed95ec2260a9d464$var$DURATION}ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
  }

  & .${(0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childPulsate} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${$ed95ec2260a9d464$var$pulsateKeyframe};
    animation-duration: 2500ms;
    animation-timing-function: ${({ theme: theme })=>theme.transitions.easing.easeInOut};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`;
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */ const $ed95ec2260a9d464$var$TouchRipple = /*#__PURE__*/ $acw62.forwardRef(function TouchRipple(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTouchRipple'
    });
    const { center: centerProp = false, classes: classes = {}, className: className, ...other } = props;
    const [ripples, setRipples] = $acw62.useState([]);
    const nextKey = $acw62.useRef(0);
    const rippleCallback = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (rippleCallback.current) {
            rippleCallback.current();
            rippleCallback.current = null;
        }
    }, [
        ripples
    ]);
    // Used to filter out mouse emulated events on mobile.
    const ignoringMouseDown = $acw62.useRef(false);
    // We use a timer in order to only show the ripples for touch "click" like events.
    // We don't want to display the ripple for touch scroll events.
    const startTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    // This is the hook called once the previous timeout is ready.
    const startTimerCommit = $acw62.useRef(null);
    const container = $acw62.useRef(null);
    const startCommit = $acw62.useCallback((params)=>{
        const { pulsate: pulsate, rippleX: rippleX, rippleY: rippleY, rippleSize: rippleSize, cb: cb } = params;
        setRipples((oldRipples)=>[
                ...oldRipples,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ed95ec2260a9d464$export$676cfe7b12693c4b, {
                    classes: {
                        ripple: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.ripple, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripple),
                        rippleVisible: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.rippleVisible, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).rippleVisible),
                        ripplePulsate: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.ripplePulsate, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).ripplePulsate),
                        child: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.child, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).child),
                        childLeaving: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.childLeaving, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childLeaving),
                        childPulsate: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.childPulsate, (0, $71da1f2c906d4bee$export$2e2bcd8739ae039).childPulsate)
                    },
                    timeout: $ed95ec2260a9d464$var$DURATION,
                    pulsate: pulsate,
                    rippleX: rippleX,
                    rippleY: rippleY,
                    rippleSize: rippleSize
                }, nextKey.current)
            ]);
        nextKey.current += 1;
        rippleCallback.current = cb;
    }, [
        classes
    ]);
    const start = $acw62.useCallback((event = {}, options = {}, cb = ()=>{})=>{
        const { pulsate: pulsate = false, center: center = centerProp || options.pulsate, fakeElement: fakeElement = false // For test purposes
         } = options;
        if (event?.type === 'mousedown' && ignoringMouseDown.current) {
            ignoringMouseDown.current = false;
            return;
        }
        if (event?.type === 'touchstart') ignoringMouseDown.current = true;
        const element = fakeElement ? null : container.current;
        const rect = element ? element.getBoundingClientRect() : {
            width: 0,
            height: 0,
            left: 0,
            top: 0
        };
        // Get the size of the ripple
        let rippleX;
        let rippleY;
        let rippleSize;
        if (center || event === undefined || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
            rippleX = Math.round(rect.width / 2);
            rippleY = Math.round(rect.height / 2);
        } else {
            const { clientX: clientX, clientY: clientY } = event.touches && event.touches.length > 0 ? event.touches[0] : event;
            rippleX = Math.round(clientX - rect.left);
            rippleY = Math.round(clientY - rect.top);
        }
        if (center) {
            rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3);
            // For some reason the animation is broken on Mobile Chrome if the size is even.
            if (rippleSize % 2 === 0) rippleSize += 1;
        } else {
            const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
            const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
            rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
        }
        // Touche devices
        if (event?.touches) // check that this isn't another touchstart due to multitouch
        // otherwise we will only clear a single timer when unmounting while two
        // are running
        {
            if (startTimerCommit.current === null) {
                // Prepare the ripple effect.
                startTimerCommit.current = ()=>{
                    startCommit({
                        pulsate: pulsate,
                        rippleX: rippleX,
                        rippleY: rippleY,
                        rippleSize: rippleSize,
                        cb: cb
                    });
                };
                // Delay the execution of the ripple effect.
                // We have to make a tradeoff with this delay value.
                startTimer.start($ed95ec2260a9d464$export$95d0c9356b2231a3, ()=>{
                    if (startTimerCommit.current) {
                        startTimerCommit.current();
                        startTimerCommit.current = null;
                    }
                });
            }
        } else startCommit({
            pulsate: pulsate,
            rippleX: rippleX,
            rippleY: rippleY,
            rippleSize: rippleSize,
            cb: cb
        });
    }, [
        centerProp,
        startCommit,
        startTimer
    ]);
    const pulsate = $acw62.useCallback(()=>{
        start({}, {
            pulsate: true
        });
    }, [
        start
    ]);
    const stop = $acw62.useCallback((event, cb)=>{
        startTimer.clear();
        // The touch interaction occurs too quickly.
        // We still want to show ripple effect.
        if (event?.type === 'touchend' && startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
            startTimer.start(0, ()=>{
                stop(event, cb);
            });
            return;
        }
        startTimerCommit.current = null;
        setRipples((oldRipples)=>{
            if (oldRipples.length > 0) return oldRipples.slice(1);
            return oldRipples;
        });
        rippleCallback.current = cb;
    }, [
        startTimer
    ]);
    $acw62.useImperativeHandle(ref, ()=>({
            pulsate: pulsate,
            start: start,
            stop: stop
        }), [
        pulsate,
        start,
        stop
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ed95ec2260a9d464$export$f6b7418508c72c25, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $71da1f2c906d4bee$export$2e2bcd8739ae039).root, classes.root, className),
        ref: container,
        ...other,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
            component: null,
            exit: true,
            children: ripples
        })
    });
});
var $ed95ec2260a9d464$export$2e2bcd8739ae039 = $ed95ec2260a9d464$var$TouchRipple;




function $fcd0c39d812092df$export$fccb0498dcd99783(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiButtonBase', slot);
}
const $fcd0c39d812092df$var$buttonBaseClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiButtonBase', [
    'root',
    'disabled',
    'focusVisible'
]);
var $fcd0c39d812092df$export$2e2bcd8739ae039 = $fcd0c39d812092df$var$buttonBaseClasses;



'use client';
const $21d0be68de155ec6$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, focusVisible: focusVisible, focusVisibleClassName: focusVisibleClassName, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            focusVisible && 'focusVisible'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $fcd0c39d812092df$export$fccb0498dcd99783), classes);
    if (focusVisible && focusVisibleClassName) composedClasses.root += ` ${focusVisibleClassName}`;
    return composedClasses;
};
const $21d0be68de155ec6$export$7ec0dcc5e3cdcd36 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('button', {
    name: 'MuiButtonBase',
    slot: 'Root'
})({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    boxSizing: 'border-box',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
        borderStyle: 'none' // Remove Firefox dotted outline.
    },
    [`&.${(0, $fcd0c39d812092df$export$2e2bcd8739ae039).disabled}`]: {
        pointerEvents: 'none',
        // Disable link interactions
        cursor: 'default'
    },
    '@media print': {
        colorAdjust: 'exact'
    }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */ const $21d0be68de155ec6$var$ButtonBase = /*#__PURE__*/ $acw62.forwardRef(function ButtonBase(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonBase'
    });
    const { action: action, centerRipple: centerRipple = false, children: children, className: className, component: component = 'button', disabled: disabled = false, disableRipple: disableRipple = false, disableTouchRipple: disableTouchRipple = false, focusRipple: focusRipple = false, focusVisibleClassName: focusVisibleClassName, LinkComponent: LinkComponent = 'a', onBlur: onBlur, onClick: onClick, onContextMenu: onContextMenu, onDragLeave: onDragLeave, onFocus: onFocus, onFocusVisible: onFocusVisible, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, tabIndex: tabIndex = 0, TouchRippleProps: TouchRippleProps, touchRippleRef: touchRippleRef, type: type, ...other } = props;
    const buttonRef = $acw62.useRef(null);
    const ripple = (0, $ad3b5cbf2e7edbd2$export$2e2bcd8739ae039)();
    const handleRippleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ripple.ref, touchRippleRef);
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    if (disabled && focusVisible) setFocusVisible(false);
    $acw62.useImperativeHandle(action, ()=>({
            focusVisible: ()=>{
                setFocusVisible(true);
                buttonRef.current.focus();
            }
        }), []);
    const enableTouchRipple = ripple.shouldMount && !disableRipple && !disabled;
    $acw62.useEffect(()=>{
        if (focusVisible && focusRipple && !disableRipple) ripple.pulsate();
    }, [
        disableRipple,
        focusRipple,
        focusVisible,
        ripple
    ]);
    const handleMouseDown = $21d0be68de155ec6$var$useRippleHandler(ripple, 'start', onMouseDown, disableTouchRipple);
    const handleContextMenu = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onContextMenu, disableTouchRipple);
    const handleDragLeave = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onDragLeave, disableTouchRipple);
    const handleMouseUp = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onMouseUp, disableTouchRipple);
    const handleMouseLeave = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (focusVisible) event.preventDefault();
        if (onMouseLeave) onMouseLeave(event);
    }, disableTouchRipple);
    const handleTouchStart = $21d0be68de155ec6$var$useRippleHandler(ripple, 'start', onTouchStart, disableTouchRipple);
    const handleTouchEnd = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onTouchEnd, disableTouchRipple);
    const handleTouchMove = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', onTouchMove, disableTouchRipple);
    const handleBlur = $21d0be68de155ec6$var$useRippleHandler(ripple, 'stop', (event)=>{
        if (!(0, $3abd7e3358fc5f35$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    }, false);
    const handleFocus = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // Fix for https://github.com/facebook/react/issues/7769
        if (!buttonRef.current) buttonRef.current = event.currentTarget;
        if ((0, $3abd7e3358fc5f35$export$2e2bcd8739ae039)(event.target)) {
            setFocusVisible(true);
            if (onFocusVisible) onFocusVisible(event);
        }
        if (onFocus) onFocus(event);
    });
    const isNonNativeButton = ()=>{
        const button = buttonRef.current;
        return component && component !== 'button' && !(button.tagName === 'A' && button.href);
    };
    const handleKeyDown = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // Check if key is already down to avoid repeats being counted as multiple activations
        if (focusRipple && !event.repeat && focusVisible && event.key === ' ') ripple.stop(event, ()=>{
            ripple.start(event);
        });
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') event.preventDefault();
        if (onKeyDown) onKeyDown(event);
        // Keyboard accessibility for non interactive elements
        if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
            event.preventDefault();
            if (onClick) onClick(event);
        }
    });
    const handleKeyUp = (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
        // https://codesandbox.io/p/sandbox/button-keyup-preventdefault-dn7f0
        if (focusRipple && event.key === ' ' && focusVisible && !event.defaultPrevented) ripple.stop(event, ()=>{
            ripple.pulsate(event);
        });
        if (onKeyUp) onKeyUp(event);
        // Keyboard accessibility for non interactive elements
        if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) onClick(event);
    });
    let ComponentProp = component;
    if (ComponentProp === 'button' && (other.href || other.to)) ComponentProp = LinkComponent;
    const buttonProps = {};
    if (ComponentProp === 'button') {
        buttonProps.type = type === undefined ? 'button' : type;
        buttonProps.disabled = disabled;
    } else {
        if (!other.href && !other.to) buttonProps.role = 'button';
        if (disabled) buttonProps['aria-disabled'] = disabled;
    }
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, buttonRef);
    const ownerState = {
        ...props,
        centerRipple: centerRipple,
        component: component,
        disabled: disabled,
        disableRipple: disableRipple,
        disableTouchRipple: disableTouchRipple,
        focusRipple: focusRipple,
        tabIndex: tabIndex,
        focusVisible: focusVisible
    };
    const classes = $21d0be68de155ec6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($21d0be68de155ec6$export$7ec0dcc5e3cdcd36, {
        as: ComponentProp,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        onBlur: handleBlur,
        onClick: onClick,
        onContextMenu: handleContextMenu,
        onFocus: handleFocus,
        onKeyDown: handleKeyDown,
        onKeyUp: handleKeyUp,
        onMouseDown: handleMouseDown,
        onMouseLeave: handleMouseLeave,
        onMouseUp: handleMouseUp,
        onDragLeave: handleDragLeave,
        onTouchEnd: handleTouchEnd,
        onTouchMove: handleTouchMove,
        onTouchStart: handleTouchStart,
        ref: handleRef,
        tabIndex: disabled ? -1 : tabIndex,
        type: type,
        ...buttonProps,
        ...other,
        children: [
            children,
            enableTouchRipple ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed95ec2260a9d464$export$2e2bcd8739ae039), {
                ref: handleRippleRef,
                center: centerRipple,
                ...TouchRippleProps
            }) : null
        ]
    });
});
function $21d0be68de155ec6$var$useRippleHandler(ripple, rippleAction, eventCallback, skipRippleAction = false) {
    return (0, $52726edc538865d0$export$2e2bcd8739ae039)((event)=>{
        if (eventCallback) eventCallback(event);
        if (!skipRippleAction) ripple[rippleAction](event);
        return true;
    });
}
var $21d0be68de155ec6$export$2e2bcd8739ae039 = $21d0be68de155ec6$var$ButtonBase;



var $acw62 = parcelRequire("acw62");











function $fd7829380e349eb6$export$29cad1383b3f235d(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiCircularProgress', slot);
}
const $fd7829380e349eb6$var$circularProgressClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiCircularProgress', [
    'root',
    'determinate',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'svg',
    'track',
    'circle',
    'circleDeterminate',
    'circleIndeterminate',
    'circleDisableShrink'
]);
var $fd7829380e349eb6$export$2e2bcd8739ae039 = $fd7829380e349eb6$var$circularProgressClasses;



'use client';
const $32db5964c492ae2d$var$SIZE = 44;
const $32db5964c492ae2d$var$circularRotateKeyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`;
const $32db5964c492ae2d$var$circularDashKeyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: -126px;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $32db5964c492ae2d$var$rotateAnimation = typeof $32db5964c492ae2d$var$circularRotateKeyframe !== 'string' ? (0, $63d46a01db878c10$export$dbf350e5966cf602)`
        animation: ${$32db5964c492ae2d$var$circularRotateKeyframe} 1.4s linear infinite;
      ` : null;
const $32db5964c492ae2d$var$dashAnimation = typeof $32db5964c492ae2d$var$circularDashKeyframe !== 'string' ? (0, $63d46a01db878c10$export$dbf350e5966cf602)`
        animation: ${$32db5964c492ae2d$var$circularDashKeyframe} 1.4s ease-in-out infinite;
      ` : null;
const $32db5964c492ae2d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color, disableShrink: disableShrink } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
        ],
        svg: [
            'svg'
        ],
        track: [
            'track'
        ],
        circle: [
            'circle',
            `circle${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}`,
            disableShrink && 'circleDisableShrink'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $fd7829380e349eb6$export$29cad1383b3f235d), classes);
};
const $32db5964c492ae2d$var$CircularProgressRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiCircularProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('transform')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: $32db5964c492ae2d$var$rotateAnimation || {
                    animation: `${$32db5964c492ae2d$var$circularRotateKeyframe} 1.4s linear infinite`
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $32db5964c492ae2d$var$CircularProgressSVG = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('svg', {
    name: 'MuiCircularProgress',
    slot: 'Svg'
})({
    display: 'block' // Keeps the progress centered
});
const $32db5964c492ae2d$var$CircularProgressCircle = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Circle',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.circle,
            styles[`circle${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.disableShrink && styles.circleDisableShrink
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        variants: [
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: theme.transitions.create('stroke-dashoffset')
                }
            },
            {
                props: {
                    variant: 'indeterminate'
                },
                style: {
                    // Some default value that looks fine waiting for the animation to kicks in.
                    strokeDasharray: '80px, 200px',
                    strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' && !ownerState.disableShrink,
                style: $32db5964c492ae2d$var$dashAnimation || {
                    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
                    animation: `${$32db5964c492ae2d$var$circularDashKeyframe} 1.4s ease-in-out infinite`
                }
            }
        ]
    })));
const $32db5964c492ae2d$var$CircularProgressTrack = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('circle', {
    name: 'MuiCircularProgress',
    slot: 'Track'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        stroke: 'currentColor',
        opacity: (theme.vars || theme).palette.action.activatedOpacity
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $32db5964c492ae2d$var$CircularProgress = /*#__PURE__*/ $acw62.forwardRef(function CircularProgress(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCircularProgress'
    });
    const { className: className, color: color = 'primary', disableShrink: disableShrink = false, enableTrackSlot: enableTrackSlot = false, size: size = 40, style: style, thickness: thickness = 3.6, value: value = 0, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disableShrink: disableShrink,
        size: size,
        thickness: thickness,
        value: value,
        variant: variant,
        enableTrackSlot: enableTrackSlot
    };
    const classes = $32db5964c492ae2d$var$useUtilityClasses(ownerState);
    const circleStyle = {};
    const rootStyle = {};
    const rootProps = {};
    if (variant === 'determinate') {
        const circumference = 2 * Math.PI * (($32db5964c492ae2d$var$SIZE - thickness) / 2);
        circleStyle.strokeDasharray = circumference.toFixed(3);
        rootProps['aria-valuenow'] = Math.round(value);
        circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
        rootStyle.transform = 'rotate(-90deg)';
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($32db5964c492ae2d$var$CircularProgressRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        style: {
            width: size,
            height: size,
            ...rootStyle,
            ...style
        },
        ownerState: ownerState,
        ref: ref,
        role: "progressbar",
        ...rootProps,
        ...other,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($32db5964c492ae2d$var$CircularProgressSVG, {
            className: classes.svg,
            ownerState: ownerState,
            viewBox: `${$32db5964c492ae2d$var$SIZE / 2} ${$32db5964c492ae2d$var$SIZE / 2} ${$32db5964c492ae2d$var$SIZE} ${$32db5964c492ae2d$var$SIZE}`,
            children: [
                enableTrackSlot ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($32db5964c492ae2d$var$CircularProgressTrack, {
                    className: classes.track,
                    ownerState: ownerState,
                    cx: $32db5964c492ae2d$var$SIZE,
                    cy: $32db5964c492ae2d$var$SIZE,
                    r: ($32db5964c492ae2d$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness,
                    "aria-hidden": "true"
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($32db5964c492ae2d$var$CircularProgressCircle, {
                    className: classes.circle,
                    style: circleStyle,
                    ownerState: ownerState,
                    cx: $32db5964c492ae2d$var$SIZE,
                    cy: $32db5964c492ae2d$var$SIZE,
                    r: ($32db5964c492ae2d$var$SIZE - thickness) / 2,
                    fill: "none",
                    strokeWidth: thickness
                })
            ]
        })
    });
});
var $32db5964c492ae2d$export$2e2bcd8739ae039 = $32db5964c492ae2d$var$CircularProgress;





function $51a63158336e7c66$export$5e8702d71474f093(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiIconButton', slot);
}
const $51a63158336e7c66$var$iconButtonClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiIconButton', [
    'root',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning',
    'edgeStart',
    'edgeEnd',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'loading',
    'loadingIndicator',
    'loadingWrapper'
]);
var $51a63158336e7c66$export$2e2bcd8739ae039 = $51a63158336e7c66$var$iconButtonClasses;



'use client';
const $05a469b554e6dcda$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, color: color, edge: edge, size: size, loading: loading } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            disabled && 'disabled',
            color !== 'default' && `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            edge && `edge${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $51a63158336e7c66$export$5e8702d71474f093), classes);
};
const $05a469b554e6dcda$var$IconButtonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiIconButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.loading && styles.loading,
            ownerState.color !== 'default' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.edge && styles[`edge${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        textAlign: 'center',
        flex: '0 0 auto',
        fontSize: theme.typography.pxToRem(24),
        padding: 8,
        borderRadius: '50%',
        color: (theme.vars || theme).palette.action.active,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: (props)=>!props.disableRipple,
                style: {
                    '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
                    '&:hover': {
                        backgroundColor: 'var(--IconButton-hoverBg)',
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: {
                    edge: 'start'
                },
                style: {
                    marginLeft: -12
                }
            },
            {
                props: {
                    edge: 'start',
                    size: 'small'
                },
                style: {
                    marginLeft: -3
                }
            },
            {
                props: {
                    edge: 'end'
                },
                style: {
                    marginRight: -12
                }
            },
            {
                props: {
                    edge: 'end',
                    size: 'small'
                },
                style: {
                    marginRight: -3
                }
            }
        ]
    })), (0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--IconButton-hoverBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                })),
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 5,
                    fontSize: theme.typography.pxToRem(18)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 12,
                    fontSize: theme.typography.pxToRem(28)
                }
            }
        ],
        [`&.${(0, $51a63158336e7c66$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: 'transparent',
            color: (theme.vars || theme).palette.action.disabled
        },
        [`&.${(0, $51a63158336e7c66$export$2e2bcd8739ae039).loading}`]: {
            color: 'transparent'
        }
    })));
const $05a469b554e6dcda$var$IconButtonLoadingIndicator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiIconButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: (theme.vars || theme).palette.action.disabled,
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            }
        ]
    }));
/**
 * Refer to the [Icons](/material-ui/icons/) section of the documentation
 * regarding the available icon options.
 */ const $05a469b554e6dcda$var$IconButton = /*#__PURE__*/ $acw62.forwardRef(function IconButton(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIconButton'
    });
    const { edge: edge = false, children: children, className: className, color: color = 'default', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, size: size = 'medium', id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, ...other } = props;
    const loadingId = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        edge: edge,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        loading: loading,
        loadingIndicator: loadingIndicator,
        size: size
    };
    const classes = $05a469b554e6dcda$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($05a469b554e6dcda$var$IconButtonRoot, {
        id: loading ? loadingId : idProp,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        centerRipple: true,
        focusRipple: !disableFocusRipple,
        disabled: disabled || loading,
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: [
            typeof loading === 'boolean' && /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
            (0, $7b02d682eb115277$exports.jsx)("span", {
                className: classes.loadingWrapper,
                style: {
                    display: 'contents'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($05a469b554e6dcda$var$IconButtonLoadingIndicator, {
                    className: classes.loadingIndicator,
                    ownerState: ownerState,
                    children: loading && loadingIndicator
                })
            }),
            children
        ]
    });
});
var $05a469b554e6dcda$export$2e2bcd8739ae039 = $05a469b554e6dcda$var$IconButton;



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");









function $4ec9549e6ca0a145$export$c7c50641356bdfa5(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiSvgIcon', slot);
}
const $4ec9549e6ca0a145$var$svgIconClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiSvgIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $4ec9549e6ca0a145$export$2e2bcd8739ae039 = $4ec9549e6ca0a145$var$svgIconClasses;



'use client';
const $221b46e996ce82df$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $4ec9549e6ca0a145$export$c7c50641356bdfa5), classes);
};
const $221b46e996ce82df$var$SvgIconRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('svg', {
    name: 'MuiSvgIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        display: 'inline-block',
        flexShrink: 0,
        transition: theme.transitions?.create?.('fill', {
            duration: (theme.vars ?? theme).transitions?.duration?.shorter
        }),
        variants: [
            {
                props: (props)=>!props.hasSvgAsChild,
                style: {
                    // the <svg> will define the property that has `currentColor`
                    // for example heroicons uses fill="none" and stroke="currentColor"
                    fill: 'currentColor'
                }
            },
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(20) || '1.25rem'
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(24) || '1.5rem'
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography?.pxToRem?.(35) || '2.1875rem'
                }
            },
            // TODO v5 deprecate color prop, v6 remove for sx
            ...Object.entries((theme.vars ?? theme).palette).filter(([, value])=>value && value.main).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars ?? theme).palette?.[color]?.main
                    }
                })),
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars ?? theme).palette?.action?.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            }
        ]
    })));
const $221b46e996ce82df$var$SvgIcon = /*#__PURE__*/ $acw62.forwardRef(function SvgIcon(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSvgIcon'
    });
    const { children: children, className: className, color: color = 'inherit', component: component = 'svg', fontSize: fontSize = 'medium', htmlColor: htmlColor, inheritViewBox: inheritViewBox = false, titleAccess: titleAccess, viewBox: viewBox = '0 0 24 24', ...other } = props;
    const hasSvgAsChild = /*#__PURE__*/ $acw62.isValidElement(children) && children.type === 'svg';
    const ownerState = {
        ...props,
        color: color,
        component: component,
        fontSize: fontSize,
        instanceFontSize: inProps.fontSize,
        inheritViewBox: inheritViewBox,
        viewBox: viewBox,
        hasSvgAsChild: hasSvgAsChild
    };
    const more = {};
    if (!inheritViewBox) more.viewBox = viewBox;
    const classes = $221b46e996ce82df$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($221b46e996ce82df$var$SvgIconRoot, {
        as: component,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        focusable: "false",
        color: htmlColor,
        "aria-hidden": titleAccess ? undefined : true,
        role: titleAccess ? 'img' : undefined,
        ref: ref,
        ...more,
        ...other,
        ...hasSvgAsChild && children.props,
        ownerState: ownerState,
        children: [
            hasSvgAsChild ? children.props.children : children,
            titleAccess ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: titleAccess
            }) : null
        ]
    });
});
$221b46e996ce82df$var$SvgIcon.muiName = 'SvgIcon';
var $221b46e996ce82df$export$2e2bcd8739ae039 = $221b46e996ce82df$var$SvgIcon;



'use client';
function $2f130330883526cb$export$2e2bcd8739ae039(path, displayName) {
    function Component(props, ref) {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $221b46e996ce82df$export$2e2bcd8739ae039), {
            "data-testid": undefined,
            ref: ref,
            ...props,
            children: path
        });
    }
    Component.muiName = (0, $221b46e996ce82df$export$2e2bcd8739ae039).muiName;
    return /*#__PURE__*/ $acw62.memo(/*#__PURE__*/ $acw62.forwardRef(Component));
}



"use client";
var $ccd4473bf517ef36$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.996.996 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z"
}), 'Edit');



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





'use client';
function $47b3077c5e8d33a3$export$2e2bcd8739ae039(options = {}) {
    const { themeId: themeId, defaultTheme: defaultTheme, defaultClassName: defaultClassName = 'MuiBox-root', generateClassName: generateClassName } = options;
    const BoxRoot = (0, $678bd0f6619332de$export$2e2bcd8739ae039)('div', {
        shouldForwardProp: (prop)=>prop !== 'theme' && prop !== 'sx' && prop !== 'as'
    })((0, $6b750d631801d296$export$2e2bcd8739ae039));
    const Box = /*#__PURE__*/ $acw62.forwardRef(function Box(inProps, ref) {
        const theme = (0, $ac16d208682bdb3f$export$2e2bcd8739ae039)(defaultTheme);
        const { className: className, component: component = 'div', ...other } = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)(inProps);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BoxRoot, {
            as: component,
            ref: ref,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, generateClassName ? generateClassName(defaultClassName) : defaultClassName),
            theme: themeId ? theme[themeId] || theme : theme,
            ...other
        });
    });
    return Box;
}







const $ae8612b04aef23cf$var$boxClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiBox', [
    'root'
]);
var $ae8612b04aef23cf$export$2e2bcd8739ae039 = $ae8612b04aef23cf$var$boxClasses;


'use client';
const $ed0dc78f73685bb9$var$defaultTheme = (0, $1c8355eadf532640$export$2e2bcd8739ae039)();
const $ed0dc78f73685bb9$var$Box = (0, $47b3077c5e8d33a3$export$2e2bcd8739ae039)({
    themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039),
    defaultTheme: $ed0dc78f73685bb9$var$defaultTheme,
    defaultClassName: (0, $ae8612b04aef23cf$export$2e2bcd8739ae039).root,
    generateClassName: (0, $8484d09248d25570$export$2e2bcd8739ae039).generate
});
var $ed0dc78f73685bb9$export$2e2bcd8739ae039 = $ed0dc78f73685bb9$var$Box;


const $0891c3550aaff5f4$var$Loading = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13157ffc893b45e9$export$2e2bcd8739ae039), {
            sx: {
                mt: 100,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '50vh'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
        })
    });
};
var $0891c3550aaff5f4$export$2e2bcd8739ae039 = $0891c3550aaff5f4$var$Loading;



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");















function $1c400751848b9b57$export$5a6f9035944c8119(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiButton', slot);
}
const $1c400751848b9b57$var$buttonClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiButton', [
    'root',
    'text',
    'textInherit',
    'textPrimary',
    'textSecondary',
    'textSuccess',
    'textError',
    'textInfo',
    'textWarning',
    'outlined',
    'outlinedInherit',
    'outlinedPrimary',
    'outlinedSecondary',
    'outlinedSuccess',
    'outlinedError',
    'outlinedInfo',
    'outlinedWarning',
    'contained',
    'containedInherit',
    'containedPrimary',
    'containedSecondary',
    'containedSuccess',
    'containedError',
    'containedInfo',
    'containedWarning',
    'disableElevation',
    'focusVisible',
    'disabled',
    'colorInherit',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorError',
    'colorInfo',
    'colorWarning',
    'textSizeSmall',
    'textSizeMedium',
    'textSizeLarge',
    'outlinedSizeSmall',
    'outlinedSizeMedium',
    'outlinedSizeLarge',
    'containedSizeSmall',
    'containedSizeMedium',
    'containedSizeLarge',
    'sizeMedium',
    'sizeSmall',
    'sizeLarge',
    'fullWidth',
    'startIcon',
    'endIcon',
    'icon',
    'iconSizeSmall',
    'iconSizeMedium',
    'iconSizeLarge',
    'loading',
    'loadingWrapper',
    'loadingIconPlaceholder',
    'loadingIndicator',
    'loadingPositionCenter',
    'loadingPositionStart',
    'loadingPositionEnd'
]);
var $1c400751848b9b57$export$2e2bcd8739ae039 = $1c400751848b9b57$var$buttonClasses;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $17e2bbdd939aa1be$var$ButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $17e2bbdd939aa1be$export$2e2bcd8739ae039 = $17e2bbdd939aa1be$var$ButtonGroupContext;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $c83825b43ed55336$var$ButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $c83825b43ed55336$export$2e2bcd8739ae039 = $c83825b43ed55336$var$ButtonGroupButtonContext;



'use client';
const $00a06c270f3ebd57$var$useUtilityClasses = (ownerState)=>{
    const { color: color, disableElevation: disableElevation, fullWidth: fullWidth, size: size, variant: variant, loading: loading, loadingPosition: loadingPosition, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            loading && 'loading',
            variant,
            `${variant}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            `${variant}Size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            disableElevation && 'disableElevation',
            fullWidth && 'fullWidth',
            loading && `loadingPosition${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(loadingPosition)}`
        ],
        startIcon: [
            'icon',
            'startIcon',
            `iconSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        endIcon: [
            'icon',
            'endIcon',
            `iconSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        loadingIndicator: [
            'loadingIndicator'
        ],
        loadingWrapper: [
            'loadingWrapper'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $1c400751848b9b57$export$5a6f9035944c8119), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the ButtonBase
        ...composedClasses
    };
};
const $00a06c270f3ebd57$var$commonIconStyles = [
    {
        props: {
            size: 'small'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 18
            }
        }
    },
    {
        props: {
            size: 'medium'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 20
            }
        }
    },
    {
        props: {
            size: 'large'
        },
        style: {
            '& > *:nth-of-type(1)': {
                fontSize: 22
            }
        }
    }
];
const $00a06c270f3ebd57$var$ButtonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`${ownerState.variant}Size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color === 'inherit' && styles.colorInherit,
            ownerState.disableElevation && styles.disableElevation,
            ownerState.fullWidth && styles.fullWidth,
            ownerState.loading && styles.loading
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const inheritContainedBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[800];
    const inheritContainedHoverBackgroundColor = theme.palette.mode === 'light' ? theme.palette.grey.A100 : theme.palette.grey[700];
    return {
        ...theme.typography.button,
        minWidth: 64,
        padding: '6px 16px',
        border: 0,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create([
            'background-color',
            'box-shadow',
            'border-color',
            'color'
        ], {
            duration: theme.transitions.duration.short
        }),
        '&:hover': {
            textDecoration: 'none'
        },
        [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    color: `var(--variant-containedColor)`,
                    backgroundColor: `var(--variant-containedBg)`,
                    boxShadow: (theme.vars || theme).shadows[2],
                    '&:hover': {
                        boxShadow: (theme.vars || theme).shadows[4],
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            boxShadow: (theme.vars || theme).shadows[2]
                        }
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[8]
                    },
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: (theme.vars || theme).shadows[6]
                    },
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.action.disabled,
                        boxShadow: (theme.vars || theme).shadows[0],
                        backgroundColor: (theme.vars || theme).palette.action.disabledBackground
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    padding: '5px 15px',
                    border: '1px solid currentColor',
                    borderColor: `var(--variant-outlinedBorder, currentColor)`,
                    backgroundColor: `var(--variant-outlinedBg)`,
                    color: `var(--variant-outlinedColor)`,
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
                        border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
                    }
                }
            },
            {
                props: {
                    variant: 'text'
                },
                style: {
                    padding: '6px 8px',
                    color: `var(--variant-textColor)`,
                    backgroundColor: `var(--variant-textBg)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--variant-textColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedColor': (theme.vars || theme).palette[color].main,
                        '--variant-outlinedBorder': theme.alpha((theme.vars || theme).palette[color].main, 0.5),
                        '--variant-containedColor': (theme.vars || theme).palette[color].contrastText,
                        '--variant-containedBg': (theme.vars || theme).palette[color].main,
                        '@media (hover: hover)': {
                            '&:hover': {
                                '--variant-containedBg': (theme.vars || theme).palette[color].dark,
                                '--variant-textBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '--variant-outlinedBorder': (theme.vars || theme).palette[color].main,
                                '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                            }
                        }
                    }
                })),
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit',
                    borderColor: 'currentColor',
                    '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedBg : inheritContainedBackgroundColor,
                    '@media (hover: hover)': {
                        '&:hover': {
                            '--variant-containedBg': theme.vars ? theme.vars.palette.Button.inheritContainedHoverBg : inheritContainedHoverBackgroundColor,
                            '--variant-textBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
                            '--variant-outlinedBg': theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'text'
                },
                style: {
                    padding: '4px 5px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'text'
                },
                style: {
                    padding: '8px 11px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'outlined'
                },
                style: {
                    padding: '3px 9px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'outlined'
                },
                style: {
                    padding: '7px 21px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    size: 'small',
                    variant: 'contained'
                },
                style: {
                    padding: '4px 10px',
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large',
                    variant: 'contained'
                },
                style: {
                    padding: '8px 22px',
                    fontSize: theme.typography.pxToRem(15)
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none',
                    '&:hover': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).focusVisible}`]: {
                        boxShadow: 'none'
                    },
                    '&:active': {
                        boxShadow: 'none'
                    },
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).disabled}`]: {
                        boxShadow: 'none'
                    }
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    transition: theme.transitions.create([
                        'background-color',
                        'box-shadow',
                        'border-color'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    [`&.${(0, $1c400751848b9b57$export$2e2bcd8739ae039).loading}`]: {
                        color: 'transparent'
                    }
                }
            }
        ]
    };
}));
const $00a06c270f3ebd57$var$ButtonStartIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'StartIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.startIcon,
            ownerState.loading && styles.startIconLoadingStart,
            styles[`iconSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: 8,
        marginLeft: -4,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginLeft: -2
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginRight: -8
                }
            },
            ...$00a06c270f3ebd57$var$commonIconStyles
        ]
    }));
const $00a06c270f3ebd57$var$ButtonEndIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'EndIcon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.endIcon,
            ownerState.loading && styles.endIconLoadingEnd,
            styles[`iconSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})(({ theme: theme })=>({
        display: 'inherit',
        marginRight: -4,
        marginLeft: 8,
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginRight: -2
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true
                },
                style: {
                    transition: theme.transitions.create([
                        'opacity'
                    ], {
                        duration: theme.transitions.duration.short
                    }),
                    opacity: 0
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    loading: true,
                    fullWidth: true
                },
                style: {
                    marginLeft: -8
                }
            },
            ...$00a06c270f3ebd57$var$commonIconStyles
        ]
    }));
const $00a06c270f3ebd57$var$ButtonLoadingIndicator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIndicator'
})(({ theme: theme })=>({
        display: 'none',
        position: 'absolute',
        visibility: 'visible',
        variants: [
            {
                props: {
                    loading: true
                },
                style: {
                    display: 'flex'
                }
            },
            {
                props: {
                    loadingPosition: 'start'
                },
                style: {
                    left: 14
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    size: 'small'
                },
                style: {
                    left: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'start'
                },
                style: {
                    left: 6
                }
            },
            {
                props: {
                    loadingPosition: 'center'
                },
                style: {
                    left: '50%',
                    transform: 'translate(-50%)',
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    loadingPosition: 'end'
                },
                style: {
                    right: 14
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    size: 'small'
                },
                style: {
                    right: 10
                }
            },
            {
                props: {
                    variant: 'text',
                    loadingPosition: 'end'
                },
                style: {
                    right: 6
                }
            },
            {
                props: {
                    loadingPosition: 'start',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    left: -10
                }
            },
            {
                props: {
                    loadingPosition: 'end',
                    fullWidth: true
                },
                style: {
                    position: 'relative',
                    right: -10
                }
            }
        ]
    }));
const $00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiButton',
    slot: 'LoadingIconPlaceholder'
})({
    display: 'inline-block',
    width: '1em',
    height: '1em'
});
const $00a06c270f3ebd57$var$Button = /*#__PURE__*/ $acw62.forwardRef(function Button(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const contextProps = $acw62.useContext((0, $17e2bbdd939aa1be$export$2e2bcd8739ae039));
    const buttonGroupButtonContextPositionClassName = $acw62.useContext((0, $c83825b43ed55336$export$2e2bcd8739ae039));
    const resolvedProps = (0, $367acbd429e20ec9$export$2e2bcd8739ae039)(contextProps, inProps);
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiButton'
    });
    const { children: children, color: color = 'primary', component: component = 'button', className: className, disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, endIcon: endIconProp, focusVisibleClassName: focusVisibleClassName, fullWidth: fullWidth = false, id: idProp, loading: loading = null, loadingIndicator: loadingIndicatorProp, loadingPosition: loadingPosition = 'center', size: size = 'medium', startIcon: startIconProp, type: type, variant: variant = 'text', ...other } = props;
    const loadingId = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(idProp);
    const loadingIndicator = loadingIndicatorProp ?? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {
        "aria-labelledby": loadingId,
        color: "inherit",
        size: 16
    });
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        loading: loading,
        loadingIndicator: loadingIndicator,
        loadingPosition: loadingPosition,
        size: size,
        type: type,
        variant: variant
    };
    const classes = $00a06c270f3ebd57$var$useUtilityClasses(ownerState);
    const startIcon = (startIconProp || loading && loadingPosition === 'start') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($00a06c270f3ebd57$var$ButtonStartIcon, {
        className: classes.startIcon,
        ownerState: ownerState,
        children: startIconProp || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const endIcon = (endIconProp || loading && loadingPosition === 'end') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($00a06c270f3ebd57$var$ButtonEndIcon, {
        className: classes.endIcon,
        ownerState: ownerState,
        children: endIconProp || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($00a06c270f3ebd57$var$ButtonLoadingIconPlaceholder, {
            className: classes.loadingIconPlaceholder,
            ownerState: ownerState
        })
    });
    const positionClassName = buttonGroupButtonContextPositionClassName || '';
    const loader = typeof loading === 'boolean' ? /*#__PURE__*/ // use plain HTML span to minimize the runtime overhead
    (0, $7b02d682eb115277$exports.jsx)("span", {
        className: classes.loadingWrapper,
        style: {
            display: 'contents'
        },
        children: loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($00a06c270f3ebd57$var$ButtonLoadingIndicator, {
            className: classes.loadingIndicator,
            ownerState: ownerState,
            children: loadingIndicator
        })
    }) : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($00a06c270f3ebd57$var$ButtonRoot, {
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        component: component,
        disabled: disabled || loading,
        focusRipple: !disableFocusRipple,
        focusVisibleClassName: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
        ref: ref,
        type: type,
        id: loading ? loadingId : idProp,
        ...other,
        classes: classes,
        children: [
            startIcon,
            loadingPosition !== 'end' && loader,
            children,
            loadingPosition === 'end' && loader,
            endIcon
        ]
    });
});
var $00a06c270f3ebd57$export$2e2bcd8739ae039 = $00a06c270f3ebd57$var$Button;




var $acw62 = parcelRequire("acw62");
/* eslint-disable @typescript-eslint/no-explicit-any */ const $6ac0c516c8224e48$export$7e7f35fe62a8a024 = !Object.fromEntries ? (entries)=>{
    if (!entries || !entries[Symbol.iterator]) throw new Error("Object.fromEntries() requires a single iterable argument");
    const o = {};
    Object.keys(entries).forEach((key)=>{
        const [k, v] = entries[key];
        o[k] = v;
    });
    return o;
} : Object.fromEntries;


/** Object.keys() with types */ function $8b4be8565bcccdec$export$259b4dd69e654a7a(o) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(o);
}


/** https://docs.tsafe.dev/assert */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e069e33f93fefb43$export$a7a9523472993e97(condition, msg) {
    if (!condition) throw new Error(msg);
}


/* eslint-disable @typescript-eslint/no-explicit-any */ /** https://docs.tsafe.dev/typeguard */ function $a1ce3a39a21fc2f6$export$f62628bb56170863(_value, isMatched) {
    return isMatched;
}


const $9cfee92e69102bc4$export$4efd812c32c0e4ed = (args)=>{
    const len = args.length;
    let i = 0;
    let cls = "";
    for(; i < len; i++){
        const arg = args[i];
        if (arg == null) continue;
        let toAdd;
        switch(typeof arg){
            case "boolean":
                break;
            case "object":
                if (Array.isArray(arg)) toAdd = $9cfee92e69102bc4$export$4efd812c32c0e4ed(arg);
                else {
                    (0, $e069e33f93fefb43$export$a7a9523472993e97)(!(0, $a1ce3a39a21fc2f6$export$f62628bb56170863)(arg, false));
                    toAdd = "";
                    for(const k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += " ");
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += " ");
            cls += toAdd;
        }
    }
    return cls;
};





var $acw62 = parcelRequire("acw62");
function $f9b90692575f49f8$export$482e5389fe22035d(fn, deps) {
    var _a;
    const ref = (0, $acw62.useRef)();
    if (!ref.current || deps.length !== ((_a = ref.current.prevDeps) === null || _a === void 0 ? void 0 : _a.length) || ref.current.prevDeps.map((v, i)=>v === deps[i]).indexOf(false) >= 0) ref.current = {
        "v": fn(),
        "prevDeps": [
            ...deps
        ]
    };
    return ref.current.v;
}


function $19e26edb1266cb7f$export$f7a7d0416784b90c(arg) {
    return arg instanceof Object && !("styles" in arg) && !("length" in arg) && !("__emotion_styles" in arg);
}


const { createCssAndCx: $d456898ca5ffcd56$export$9ec511a48b8098d3 } = (()=>{
    function merge(registered, css, className) {
        const registeredStyles = [];
        const rawClassName = (0, $1f6791d0a193b918$export$95d99596f328fd52)(registered, registeredStyles, className);
        if (registeredStyles.length < 2) return className;
        return rawClassName + css(registeredStyles);
    }
    function createCssAndCx(params) {
        const { cache: cache } = params;
        const css = (...args)=>{
            const serialized = (0, $62578605b07c8dad$export$6321afa313b251b5)(args, cache.registered);
            (0, $1f6791d0a193b918$export$6f077d94b33a01aa)(cache, serialized, false);
            const className = `${cache.key}-${serialized.name}`;
            scope: {
                const arg = args[0];
                if (!(0, $19e26edb1266cb7f$export$f7a7d0416784b90c)(arg)) break scope;
                $d456898ca5ffcd56$var$increaseSpecificityToTakePrecedenceOverMediaQueries.saveClassNameCSSObjectMapping(cache, className, arg);
            }
            return className;
        };
        const cx = (...args)=>{
            const className = (0, $9cfee92e69102bc4$export$4efd812c32c0e4ed)(args);
            const feat27FixedClassnames = $d456898ca5ffcd56$var$increaseSpecificityToTakePrecedenceOverMediaQueries.fixClassName(cache, className, css);
            return merge(cache.registered, css, feat27FixedClassnames);
        //return merge(cache.registered, css, className);
        };
        return {
            css: css,
            cx: cx
        };
    }
    return {
        createCssAndCx: createCssAndCx
    };
})();
function $d456898ca5ffcd56$export$81ba3a7007b50fc2(params) {
    const { useCache: useCache } = params;
    function useCssAndCx() {
        const cache = useCache();
        const { css: css, cx: cx } = (0, $f9b90692575f49f8$export$482e5389fe22035d)(()=>$d456898ca5ffcd56$export$9ec511a48b8098d3({
                cache: cache
            }), [
            cache
        ]);
        return {
            css: css,
            cx: cx
        };
    }
    return {
        useCssAndCx: useCssAndCx
    };
}
// https://github.com/garronej/tss-react/issues/27
const $d456898ca5ffcd56$var$increaseSpecificityToTakePrecedenceOverMediaQueries = (()=>{
    const cssObjectMapByCache = new WeakMap();
    return {
        "saveClassNameCSSObjectMapping": (cache, className, cssObject)=>{
            let cssObjectMap = cssObjectMapByCache.get(cache);
            if (cssObjectMap === undefined) {
                cssObjectMap = new Map();
                cssObjectMapByCache.set(cache, cssObjectMap);
            }
            cssObjectMap.set(className, cssObject);
        },
        "fixClassName": (()=>{
            function fix(classNameCSSObjects) {
                let isThereAnyMediaQueriesInPreviousClasses = false;
                return classNameCSSObjects.map(([className, cssObject])=>{
                    if (cssObject === undefined) return className;
                    let out;
                    if (!isThereAnyMediaQueriesInPreviousClasses) {
                        out = className;
                        for(const key in cssObject)if (key.startsWith("@media")) {
                            isThereAnyMediaQueriesInPreviousClasses = true;
                            break;
                        }
                    } else out = {
                        "&&": cssObject
                    };
                    return out;
                });
            }
            return (cache, className, css)=>{
                const cssObjectMap = cssObjectMapByCache.get(cache);
                return (0, $9cfee92e69102bc4$export$4efd812c32c0e4ed)(fix(className.split(" ").map((className)=>[
                        className,
                        cssObjectMap === null || cssObjectMap === void 0 ? void 0 : cssObjectMap.get(className)
                    ])).map((classNameOrCSSObject)=>typeof classNameOrCSSObject === "string" ? classNameOrCSSObject : css(classNameOrCSSObject)));
            };
        })()
    };
})();


/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * useEffect(
 *    ()=> { ... },
 *    [ { "foo": "bar" } ]
 * )
 * => The callback will be invoked every render.
 * because { "foo": "bar" } is a new instance every render.
 *
 * useEffect(
 *    ()=> { ... },
 *    [ getDependencyArrayRef({ "foo": "bar" }) ]
 * );
 * => The callback will only be invoked once.
 *
 * The optimization will be enabled only if obj is
 * of the form Record<string, string | number | undefined | null>
 * otherwise the object is returned (the function is the identity function).
 */ function $376d91a26fce248d$export$2eb823b286975306(obj) {
    if (!(obj instanceof Object) || typeof obj === "function") return obj;
    const arr = [];
    for(const key in obj){
        const value = obj[key];
        const typeofValue = typeof value;
        if (!(typeofValue === "string" || typeofValue === "number" && !isNaN(value) || typeofValue === "boolean" || value === undefined || value === null)) return obj;
        arr.push(`${key}:${typeofValue}_${value}`);
    }
    return "xSqLiJdLMd9s" + arr.join("|");
}




/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
function $63c5144db6634a83$export$3d46f4579dba46e5(classesFromUseStyles, classesOverrides, cx) {
    //NOTE: We use this test to be resilient in case classesOverrides is not of the expected type.
    if (!(classesOverrides instanceof Object)) return classesFromUseStyles;
    const out = {};
    (0, $8b4be8565bcccdec$export$259b4dd69e654a7a)(classesFromUseStyles).forEach((ruleName)=>out[ruleName] = cx(classesFromUseStyles[ruleName], classesOverrides[ruleName]));
    (0, $8b4be8565bcccdec$export$259b4dd69e654a7a)(classesOverrides).forEach((ruleName)=>{
        if (ruleName in classesFromUseStyles) return;
        const className = classesOverrides[ruleName];
        //...Same here, that why we don't do className === undefined
        if (typeof className !== "string") return;
        out[ruleName] = className;
    });
    return out;
}



var $acw62 = parcelRequire("acw62");


const $d4a93111296c8983$export$a26ac559f6e537b5 = ({ classes: classes, theme: theme, muiStyleOverridesParams: muiStyleOverridesParams, css: css, cx: cx, name: name })=>{
    var _a, _b;
    require_named: {
        // NOTE: Hack for backwards compatibility with the makeStyles API.
        if (name === "makeStyle no name") {
            name = undefined;
            break require_named;
        }
        if (muiStyleOverridesParams !== undefined && name === undefined) throw new Error("To use muiStyleOverridesParams, you must specify a name using .withName('MyComponent')");
    }
    let styleOverrides = undefined;
    try {
        styleOverrides = name === undefined ? undefined : ((_b = (_a = theme.components) === null || _a === void 0 ? void 0 : _a[name /*example*/ ]) === null || _b === void 0 ? void 0 : _b.styleOverrides) || undefined;
    // eslint-disable-next-line no-empty
    } catch (_c) {}
    const classesFromThemeStyleOverrides = (0, $acw62.useMemo)(()=>{
        if (styleOverrides === undefined) return undefined;
        const themeClasses = {};
        for(const ruleName in styleOverrides){
            const cssObjectOrGetCssObject = styleOverrides[ruleName];
            if (!(cssObjectOrGetCssObject instanceof Object)) continue;
            themeClasses[ruleName] = css(typeof cssObjectOrGetCssObject === "function" ? cssObjectOrGetCssObject({
                theme: theme,
                "ownerState": muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.ownerState,
                ...muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.props
            }) : cssObjectOrGetCssObject);
        }
        return themeClasses;
    }, [
        styleOverrides,
        (0, $376d91a26fce248d$export$2eb823b286975306)(muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.props),
        (0, $376d91a26fce248d$export$2eb823b286975306)(muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.ownerState),
        css
    ]);
    classes = (0, $acw62.useMemo)(()=>(0, $63c5144db6634a83$export$3d46f4579dba46e5)(classes, classesFromThemeStyleOverrides, cx), [
        classes,
        classesFromThemeStyleOverrides,
        cx
    ]);
    return {
        classes: classes
    };
};



"use client";
const $e73fa2735cbdfc15$var$useContextualCache = (0, $4eee05ec22b53782$export$71511d61b312f219);
let $e73fa2735cbdfc15$var$counter = 0;
function $e73fa2735cbdfc15$export$a7f15cdc5b5ebe7c(params) {
    const { useTheme: useTheme, cache: cacheProvidedAtInception } = params;
    const { useCache: useCache } = $e73fa2735cbdfc15$export$7b8ca6a575620f5f({
        cacheProvidedAtInception: cacheProvidedAtInception
    });
    const { useCssAndCx: useCssAndCx } = (0, $d456898ca5ffcd56$export$81ba3a7007b50fc2)({
        useCache: useCache
    });
    /** returns useStyle. */ function makeStyles(params) {
        const { name: nameOrWrappedName, uniqId: uniqId = `${$e73fa2735cbdfc15$var$counter++}` } = params !== null && params !== void 0 ? params : {};
        const name = typeof nameOrWrappedName !== "object" ? nameOrWrappedName : Object.keys(nameOrWrappedName)[0];
        return function(cssObjectByRuleNameOrGetCssObjectByRuleName) {
            const getCssObjectByRuleName = typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function" ? cssObjectByRuleNameOrGetCssObjectByRuleName : ()=>cssObjectByRuleNameOrGetCssObjectByRuleName;
            return function useStyles(params, muiStyleOverridesParams) {
                const theme = useTheme();
                let { css: css, cx: cx } = useCssAndCx();
                const cache = useCache();
                let classes = (0, $acw62.useMemo)(()=>{
                    const refClassesCache = {};
                    const refClasses = typeof Proxy !== "undefined" && new Proxy({}, {
                        "get": (_target, propertyKey)=>{
                            if (typeof propertyKey === "symbol") (0, $e069e33f93fefb43$export$a7a9523472993e97)(false);
                            return refClassesCache[propertyKey] = `${cache.key}-${uniqId}${name !== undefined ? `-${name}` : ""}-${propertyKey}-ref`;
                        }
                    });
                    const cssObjectByRuleName = getCssObjectByRuleName(theme, params, refClasses || {});
                    const classes = (0, $6ac0c516c8224e48$export$7e7f35fe62a8a024)((0, $8b4be8565bcccdec$export$259b4dd69e654a7a)(cssObjectByRuleName).map((ruleName)=>{
                        const cssObject = cssObjectByRuleName[ruleName];
                        if (!cssObject.label) cssObject.label = `${name !== undefined ? `${name}-` : ""}${ruleName}`;
                        return [
                            ruleName,
                            `${css(cssObject)}${(0, $a1ce3a39a21fc2f6$export$f62628bb56170863)(ruleName, ruleName in refClassesCache) ? ` ${refClassesCache[ruleName]}` : ""}`
                        ];
                    }));
                    (0, $8b4be8565bcccdec$export$259b4dd69e654a7a)(refClassesCache).forEach((ruleName)=>{
                        if (ruleName in classes) return;
                        classes[ruleName] = refClassesCache[ruleName];
                    });
                    return classes;
                }, [
                    cache,
                    css,
                    cx,
                    theme,
                    (0, $376d91a26fce248d$export$2eb823b286975306)(params)
                ]);
                {
                    const propsClasses = muiStyleOverridesParams === null || muiStyleOverridesParams === void 0 ? void 0 : muiStyleOverridesParams.props.classes;
                    classes = (0, $acw62.useMemo)(()=>(0, $63c5144db6634a83$export$3d46f4579dba46e5)(classes, propsClasses, cx), [
                        classes,
                        (0, $376d91a26fce248d$export$2eb823b286975306)(propsClasses),
                        cx
                    ]);
                }
                {
                    const pluginResultWrap = (0, $d4a93111296c8983$export$a26ac559f6e537b5)({
                        classes: classes,
                        css: css,
                        cx: cx,
                        "name": name !== null && name !== void 0 ? name : "makeStyle no name",
                        "idOfUseStyles": uniqId,
                        muiStyleOverridesParams: muiStyleOverridesParams,
                        // NOTE: If it's not a Mui Theme the plugin is resilient, it will not crash
                        "theme": theme
                    });
                    if (pluginResultWrap.classes !== undefined) classes = pluginResultWrap.classes;
                    if (pluginResultWrap.css !== undefined) css = pluginResultWrap.css;
                    if (pluginResultWrap.cx !== undefined) cx = pluginResultWrap.cx;
                }
                return {
                    classes: classes,
                    theme: theme,
                    css: css,
                    cx: cx
                };
            };
        };
    }
    function useStyles() {
        const theme = useTheme();
        const { css: css, cx: cx } = useCssAndCx();
        return {
            theme: theme,
            css: css,
            cx: cx
        };
    }
    return {
        makeStyles: makeStyles,
        useStyles: useStyles
    };
}
const $e73fa2735cbdfc15$var$reactContext = (0, $acw62.createContext)(undefined);
function $e73fa2735cbdfc15$export$f11c97a70d301b38(props) {
    const { children: children, value: value } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($e73fa2735cbdfc15$var$reactContext.Provider, {
        value: value
    }, children);
}
const { createUseCache: $e73fa2735cbdfc15$export$7b8ca6a575620f5f } = (()=>{
    function useCacheProvidedByProvider() {
        const cacheExplicitlyProvidedForTss = (0, $acw62.useContext)($e73fa2735cbdfc15$var$reactContext);
        return cacheExplicitlyProvidedForTss;
    }
    function createUseCache(params) {
        const { cacheProvidedAtInception: cacheProvidedAtInception } = params;
        function useCache() {
            var _a;
            const contextualCache = $e73fa2735cbdfc15$var$useContextualCache();
            const cacheExplicitlyProvidedForTss = useCacheProvidedByProvider();
            const cacheToBeUsed = (_a = cacheProvidedAtInception !== null && cacheProvidedAtInception !== void 0 ? cacheProvidedAtInception : cacheExplicitlyProvidedForTss) !== null && _a !== void 0 ? _a : contextualCache;
            if (cacheToBeUsed === null) throw new Error([
                "In order to get SSR working with tss-react you need to explicitly provide an Emotion cache.",
                "MUI users be aware: This is not an error strictly related to tss-react, with or without tss-react,",
                "MUI needs an Emotion cache to be provided for SSR to work.",
                "Here is the MUI documentation related to SSR setup: https://mui.com/material-ui/guides/server-rendering/",
                "TSS provides helper that makes the process of setting up SSR easier: https://docs.tss-react.dev/ssr"
            ].join("\n"));
            return cacheToBeUsed;
        }
        return {
            useCache: useCache
        };
    }
    return {
        createUseCache: createUseCache
    };
})();


/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $acw62 = parcelRequire("acw62");

/** @see <https://docs.tsafe.dev/capitalize> */ function $e980b9fe71080a5e$export$9a00dee1beb8f576(str) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return str.charAt(0).toUpperCase() + str.slice(1);
}


function $5bed353c43a8086b$export$cf3755a470351852(params) {
    const { useTheme: useTheme, cache: cache } = params;
    const { makeStyles: makeStyles } = (0, $e73fa2735cbdfc15$export$a7f15cdc5b5ebe7c)({
        useTheme: useTheme,
        cache: cache
    });
    function withStyles(Component, cssObjectByRuleNameOrGetCssObjectByRuleName, params) {
        const Component_ = typeof Component === "string" ? (()=>{
            const tag = Component;
            const Out = function({ children: children, ...props }) {
                return (0, $acw62.createElement)(tag, props, children);
            };
            Object.defineProperty(Out, "name", {
                "value": (0, $e980b9fe71080a5e$export$9a00dee1beb8f576)(tag)
            });
            return Out;
        })() : Component;
        /**
         * Get component name for wrapping
         * @see https://reactjs.org/docs/higher-order-components.html#convention-wrap-the-display-name-for-easy-debugging
         */ const name = (()=>{
            {
                const { name: nameOrWrappedName } = params !== null && params !== void 0 ? params : {};
                if (nameOrWrappedName !== undefined) return typeof nameOrWrappedName !== "object" ? nameOrWrappedName : Object.keys(nameOrWrappedName)[0];
            }
            let name = undefined;
            displayName: {
                const displayName = Component_.displayName;
                if (typeof displayName !== "string" || displayName === "") break displayName;
                name = displayName;
            }
            functionName: {
                if (name !== undefined) break functionName;
                const functionName = Component_.name;
                if (typeof functionName !== "string" || functionName === "") break functionName;
                name = functionName;
            }
            if (name === undefined) return undefined;
            // Special case for dollar sign
            name = name.replace(/\$/g, "usd");
            // Replacing open and close parentheses
            name = name.replace(/\(/g, "_").replace(/\)/g, "_");
            // Catch-all replacement for characters not allowed in CSS class names
            name = name.replace(/[^a-zA-Z0-9-_]/g, "_");
            return name;
        })();
        const useStyles = makeStyles({
            ...params,
            name: name
        })(typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function" ? (theme, props, classes)=>$5bed353c43a8086b$var$incorporateMediaQueries(cssObjectByRuleNameOrGetCssObjectByRuleName(theme, props, classes)) : $5bed353c43a8086b$var$incorporateMediaQueries(cssObjectByRuleNameOrGetCssObjectByRuleName));
        function getHasNonRootClasses(classes) {
            for(const name in classes){
                if (name === "root") continue;
                return true;
            }
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const Out = (0, $acw62.forwardRef)(function(props, ref) {
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const { className: className, classes: _classes, ...rest } = props;
            const { classes: classes, cx: cx } = useStyles(props, {
                props: props
            });
            const rootClassName = cx(classes.root, className);
            $5bed353c43a8086b$var$fixedClassesByClasses.set(classes, {
                ...classes,
                "root": rootClassName
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(Component_, {
                ref: ref,
                className: getHasNonRootClasses(classes) ? className : rootClassName,
                ...typeof Component === "string" ? {} : {
                    classes: classes
                },
                ...rest
            });
        });
        if (name !== undefined) {
            Out.displayName = `${(0, $e980b9fe71080a5e$export$9a00dee1beb8f576)(name)}WithStyles`;
            Object.defineProperty(Out, "name", {
                "value": Out.displayName
            });
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Out;
    }
    withStyles.getClasses = $5bed353c43a8086b$var$getClasses;
    return {
        withStyles: withStyles
    };
}
const $5bed353c43a8086b$var$fixedClassesByClasses = new WeakMap();
const $5bed353c43a8086b$var$errorMessageGetClasses = "getClasses should only be used in conjunction with withStyles";
function $5bed353c43a8086b$var$getClasses(props) {
    const classesIn = props.classes;
    if (classesIn === undefined) throw new Error($5bed353c43a8086b$var$errorMessageGetClasses);
    const classes = $5bed353c43a8086b$var$fixedClassesByClasses.get(classesIn);
    if (classes === undefined) throw new Error($5bed353c43a8086b$var$errorMessageGetClasses);
    return classes;
}
function $5bed353c43a8086b$var$incorporateMediaQueries(cssObjectByRuleNameWithMediaQueries) {
    const cssObjectByRuleName = {};
    const cssObjectByRuleNameWithMediaQueriesByMediaQuery = {};
    Object.keys(cssObjectByRuleNameWithMediaQueries).forEach((ruleNameOrMediaQuery)=>(ruleNameOrMediaQuery.startsWith("@media") ? cssObjectByRuleNameWithMediaQueriesByMediaQuery : cssObjectByRuleName)[ruleNameOrMediaQuery] = cssObjectByRuleNameWithMediaQueries[ruleNameOrMediaQuery]);
    Object.keys(cssObjectByRuleNameWithMediaQueriesByMediaQuery).forEach((mediaQuery)=>{
        const cssObjectByRuleNameBis = cssObjectByRuleNameWithMediaQueriesByMediaQuery[mediaQuery];
        Object.keys(cssObjectByRuleNameBis).forEach((ruleName)=>{
            var _a;
            return cssObjectByRuleName[ruleName] = {
                ...(_a = cssObjectByRuleName[ruleName]) !== null && _a !== void 0 ? _a : {},
                [mediaQuery]: cssObjectByRuleNameBis[ruleName]
            };
        });
    });
    return cssObjectByRuleName;
}


/* eslint-disable @typescript-eslint/ban-types */ 







const $1a33a29073f391e2$export$48d7c418edadb60c = (()=>{
    const isBrowser = typeof document === "object" && typeof (document === null || document === void 0 ? void 0 : document.getElementById) === "function";
    // Check for common testing framework global variables
    const isJest = typeof jest !== "undefined";
    const isMocha = typeof mocha !== "undefined";
    const isVitest = typeof __vitest_worker__ !== "undefined";
    return !isBrowser && !isJest && !isMocha && !isVitest;
})();


function $869fba29d10c1938$export$3d3874d62b23c316(params) {
    $869fba29d10c1938$var$counter = 0;
    $869fba29d10c1938$var$nestedSelectorUsageTrackRecord.splice(0, $869fba29d10c1938$var$nestedSelectorUsageTrackRecord.length);
    const { useContext: useContext, usePlugin: usePlugin, cache: cacheProvidedAtInception } = params;
    const { useCache: useCache } = (0, $e73fa2735cbdfc15$export$7b8ca6a575620f5f)({
        cacheProvidedAtInception: cacheProvidedAtInception
    });
    const { useCssAndCx: useCssAndCx } = (0, $d456898ca5ffcd56$export$81ba3a7007b50fc2)({
        useCache: useCache
    });
    const usePluginDefault = ({ classes: classes, cx: cx, css: css })=>({
            classes: classes,
            cx: cx,
            css: css
        });
    const tss = $869fba29d10c1938$var$createTss_internal({
        useContext: useContext,
        useCache: useCache,
        useCssAndCx: useCssAndCx,
        "usePlugin": usePlugin !== null && usePlugin !== void 0 ? usePlugin : usePluginDefault,
        "name": undefined,
        "doesUseNestedSelectors": false
    });
    return {
        tss: tss
    };
}
let $869fba29d10c1938$var$counter = 0;
const $869fba29d10c1938$var$nestedSelectorUsageTrackRecord = [];
function $869fba29d10c1938$var$createTss_internal(params) {
    const { useContext: useContext, useCache: useCache, useCssAndCx: useCssAndCx, usePlugin: usePlugin, name: name, doesUseNestedSelectors: doesUseNestedSelectors } = params;
    return {
        "withParams": ()=>$869fba29d10c1938$var$createTss_internal({
                ...params
            }),
        "withName": (nameOrWrappedName)=>$869fba29d10c1938$var$createTss_internal({
                ...params,
                "name": typeof nameOrWrappedName !== "object" ? nameOrWrappedName : Object.keys(nameOrWrappedName)[0]
            }),
        "withNestedSelectors": ()=>$869fba29d10c1938$var$createTss_internal({
                ...params,
                "doesUseNestedSelectors": true
            }),
        "create": (cssObjectByRuleNameOrGetCssObjectByRuleName)=>{
            // NOTE: Not isomorphic. Not guaranteed to be the same on client and server.
            // Do not attempt to 'simplify' the code without taking this fact into account.
            const idOfUseStyles = `x${$869fba29d10c1938$var$counter++}`;
            // NOTE: Cleanup for hot module reloading.
            if (name !== undefined) // eslint-disable-next-line no-constant-condition
            while(true){
                const wrap = $869fba29d10c1938$var$nestedSelectorUsageTrackRecord.find((wrap)=>wrap.name === name);
                if (wrap === undefined) break;
                $869fba29d10c1938$var$nestedSelectorUsageTrackRecord.splice($869fba29d10c1938$var$nestedSelectorUsageTrackRecord.indexOf(wrap), 1);
            }
            const getCssObjectByRuleName = typeof cssObjectByRuleNameOrGetCssObjectByRuleName === "function" ? cssObjectByRuleNameOrGetCssObjectByRuleName : ()=>cssObjectByRuleNameOrGetCssObjectByRuleName;
            return function useStyles(params) {
                var _a, _b, _c;
                const { classesOverrides: classesOverrides, ...paramsAndPluginParams } = params !== null && params !== void 0 ? params : {};
                const context = useContext();
                const { css: css, cx: cx } = useCssAndCx();
                const cache = useCache();
                const getClasses = ()=>{
                    const refClassesCache = {};
                    // @ts-expect-error: Type safety non achievable.
                    const cssObjectByRuleName = getCssObjectByRuleName({
                        ...params,
                        ...context,
                        ...!doesUseNestedSelectors ? {} : {
                            "classes": typeof Proxy === "undefined" ? {} : new Proxy({}, {
                                "get": (_target, ruleName)=>{
                                    /* prettier-ignore */ if (typeof ruleName === "symbol") (0, $e069e33f93fefb43$export$a7a9523472993e97)(false);
                                    if ((0, $1a33a29073f391e2$export$48d7c418edadb60c) && name === undefined) throw new Error([
                                        `tss-react: In SSR setups, in order to use nested selectors, you must also give a unique name to the useStyle function.`,
                                        `Solution: Use tss.withName("ComponentName").withNestedSelectors<...>()... to set a name.`
                                    ].join("\n"));
                                    update_nested_selector_usage_track_record: {
                                        if (name === undefined) break update_nested_selector_usage_track_record;
                                        /* prettier-ignore */ let wrap = $869fba29d10c1938$var$nestedSelectorUsageTrackRecord.find((wrap)=>wrap.name === name && wrap.idOfUseStyles === idOfUseStyles);
                                        /* prettier-ignore */ if (wrap === undefined) {
                                            /* prettier-ignore */ wrap = {
                                                name: name,
                                                idOfUseStyles: idOfUseStyles,
                                                "nestedSelectorRuleNames": new Set()
                                            };
                                            /* prettier-ignore */ $869fba29d10c1938$var$nestedSelectorUsageTrackRecord.push(wrap);
                                        }
                                        /* prettier-ignore */ wrap.nestedSelectorRuleNames.add(ruleName);
                                    }
                                    detect_potential_conflicts: {
                                        if (name === undefined) break detect_potential_conflicts;
                                        const hasPotentialConflict = $869fba29d10c1938$var$nestedSelectorUsageTrackRecord.find((wrap)=>wrap.name === name && wrap.idOfUseStyles !== idOfUseStyles && wrap.nestedSelectorRuleNames.has(ruleName)) !== undefined;
                                        if (!hasPotentialConflict) break detect_potential_conflicts;
                                        throw new Error([
                                            `tss-react: There are in your codebase two different useStyles named "${name}" that`,
                                            `both use use the nested selector ${ruleName}.\n`,
                                            `This may lead to CSS class name collisions, causing nested selectors to target elements outside of the intended scope.\n`,
                                            `Solution: Ensure each useStyles using nested selectors has a unique name.\n`,
                                            `Use: tss.withName("UniqueName").withNestedSelectors<...>()...`
                                        ].join(" "));
                                    }
                                    /* prettier-ignore */ return refClassesCache[ruleName] = `${cache.key}-${name !== undefined ? name : idOfUseStyles}-${ruleName}-ref`;
                                }
                            })
                        }
                    });
                    let classes = (0, $6ac0c516c8224e48$export$7e7f35fe62a8a024)((0, $8b4be8565bcccdec$export$259b4dd69e654a7a)(cssObjectByRuleName).map((ruleName)=>{
                        const cssObject = cssObjectByRuleName[ruleName];
                        if (!cssObject.label) cssObject.label = `${name !== undefined ? `${name}-` : ""}${ruleName}`;
                        return [
                            ruleName,
                            `${css(cssObject)}${(0, $a1ce3a39a21fc2f6$export$f62628bb56170863)(ruleName, ruleName in refClassesCache) ? ` ${refClassesCache[ruleName]}` : ""}`
                        ];
                    }));
                    (0, $8b4be8565bcccdec$export$259b4dd69e654a7a)(refClassesCache).forEach((ruleName)=>{
                        if (ruleName in classes) return;
                        classes[ruleName] = refClassesCache[ruleName];
                    });
                    classes = (0, $63c5144db6634a83$export$3d46f4579dba46e5)(classes, classesOverrides, cx);
                    return classes;
                };
                const classes = $869fba29d10c1938$var$runGetClassesOrUseCache({
                    cache: cache,
                    cssObjectByRuleNameOrGetCssObjectByRuleName: cssObjectByRuleNameOrGetCssObjectByRuleName,
                    "classesOverridesRef": (0, $376d91a26fce248d$export$2eb823b286975306)(classesOverrides),
                    "paramsAndPluginParamsRef": (0, $376d91a26fce248d$export$2eb823b286975306)(paramsAndPluginParams),
                    idOfUseStyles: idOfUseStyles,
                    context: context,
                    getClasses: getClasses
                });
                // @ts-expect-error: Type safety non achievable.
                const pluginResultWrap = usePlugin({
                    classes: classes,
                    css: css,
                    cx: cx,
                    idOfUseStyles: idOfUseStyles,
                    name: name,
                    ...context,
                    ...paramsAndPluginParams
                });
                return {
                    "classes": (_a = pluginResultWrap.classes) !== null && _a !== void 0 ? _a : classes,
                    "css": (_b = pluginResultWrap.css) !== null && _b !== void 0 ? _b : css,
                    "cx": (_c = pluginResultWrap.cx) !== null && _c !== void 0 ? _c : cx,
                    ...context
                };
            };
        }
    };
}
const $869fba29d10c1938$var$mapCache = new WeakMap();
function $869fba29d10c1938$var$runGetClassesOrUseCache(params) {
    const { cache: cache, cssObjectByRuleNameOrGetCssObjectByRuleName: cssObjectByRuleNameOrGetCssObjectByRuleName, classesOverridesRef: classesOverridesRef, paramsAndPluginParamsRef: paramsAndPluginParamsRef, idOfUseStyles: idOfUseStyles, context: context, getClasses: getClasses } = params;
    use_cache: {
        const mapCache_in = $869fba29d10c1938$var$mapCache.get(cache);
        if (mapCache_in === undefined) break use_cache;
        const mapCache_in_in = mapCache_in.get(cssObjectByRuleNameOrGetCssObjectByRuleName);
        if (mapCache_in_in === undefined) break use_cache;
        const mapCache_in_in_in = mapCache_in_in.get(classesOverridesRef);
        if (mapCache_in_in_in === undefined) break use_cache;
        const arr = mapCache_in_in_in.get(paramsAndPluginParamsRef);
        if (arr === undefined) break use_cache;
        const entry = arr.find(({ context: context_i })=>{
            if (context_i === context) return true;
            if ((0, $8b4be8565bcccdec$export$259b4dd69e654a7a)(context_i).length !== (0, $8b4be8565bcccdec$export$259b4dd69e654a7a)(context).length) return false;
            for(const key in context_i){
                if ((0, $376d91a26fce248d$export$2eb823b286975306)(context_i[key]) !== (0, $376d91a26fce248d$export$2eb823b286975306)(context[key])) return false;
            }
            return true;
        });
        if (entry === undefined) break use_cache;
        if ((entry === null || entry === void 0 ? void 0 : entry.idOfUseStyles) !== idOfUseStyles) {
            arr.splice(arr.indexOf(entry), 1);
            break use_cache;
        }
        return entry.result;
    }
    const result = getClasses();
    {
        if (!$869fba29d10c1938$var$mapCache.has(cache)) $869fba29d10c1938$var$mapCache.set(cache, new WeakMap());
        const mapCache_in = $869fba29d10c1938$var$mapCache.get(cache);
        (0, $e069e33f93fefb43$export$a7a9523472993e97)(mapCache_in !== undefined);
        if (!mapCache_in.has(cssObjectByRuleNameOrGetCssObjectByRuleName)) mapCache_in.set(cssObjectByRuleNameOrGetCssObjectByRuleName, new Map());
        const mapCache_in_in = mapCache_in.get(cssObjectByRuleNameOrGetCssObjectByRuleName);
        (0, $e069e33f93fefb43$export$a7a9523472993e97)(mapCache_in_in !== undefined);
        if (!mapCache_in_in.has(classesOverridesRef)) {
            if (mapCache_in_in.size > 200) mapCache_in_in.clear();
            mapCache_in_in.set(classesOverridesRef, new Map());
        }
        const mapCache_in_in_in = mapCache_in_in.get(classesOverridesRef);
        (0, $e069e33f93fefb43$export$a7a9523472993e97)(mapCache_in_in_in !== undefined);
        if (!mapCache_in_in_in.has(paramsAndPluginParamsRef)) {
            clear_cache: {
                const threshold = typeof paramsAndPluginParamsRef === "string" ? 257 : 5;
                if (mapCache_in_in_in.size < threshold) break clear_cache;
                mapCache_in_in_in.clear();
            }
            mapCache_in_in_in.set(paramsAndPluginParamsRef, []);
        }
        let arr = mapCache_in_in_in.get(paramsAndPluginParamsRef);
        (0, $e069e33f93fefb43$export$a7a9523472993e97)(arr !== undefined);
        if (arr.length > 5) arr = [];
        arr.push({
            idOfUseStyles: idOfUseStyles,
            context: context,
            result: result
        });
    }
    return result;
}




var $acw62 = parcelRequire("acw62");

"use client";
function $185defb6e8b5d852$export$c507fb1c2e1ac13a(props) {
    const { styles: styles } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($63d46a01db878c10$export$98f03c5d19621d70, {
        styles: $63d46a01db878c10$export$dbf350e5966cf602(styles)
    });
}


"use client";
function $1305c4c26c6782e6$export$70b505654481b347(params) {
    return {
        ...(0, $e73fa2735cbdfc15$export$a7f15cdc5b5ebe7c)(params),
        ...(0, $5bed353c43a8086b$export$cf3755a470351852)(params)
    };
}
const { tss: $1305c4c26c6782e6$export$4a9a879086c7d65f } = (0, $869fba29d10c1938$export$3d3874d62b23c316)({
    "useContext": ()=>({})
});
const $1305c4c26c6782e6$export$28e6b9b82ee883c = $1305c4c26c6782e6$export$4a9a879086c7d65f.create({});




const { makeStyles: $3d856d11b8f09dd7$export$b35517af9e0a5689, withStyles: $3d856d11b8f09dd7$export$99b4b78fb79d96b3 } = (0, $1305c4c26c6782e6$export$70b505654481b347)({
    useTheme: $81976569638fc3b7$export$2e2bcd8739ae039
});
const { tss: $3d856d11b8f09dd7$export$4a9a879086c7d65f } = (0, $869fba29d10c1938$export$3d3874d62b23c316)({
    "useContext": function useContext() {
        const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
        return {
            theme: theme
        };
    },
    "usePlugin": (0, $d4a93111296c8983$export$a26ac559f6e537b5)
});
const $3d856d11b8f09dd7$export$28e6b9b82ee883c = $3d856d11b8f09dd7$export$4a9a879086c7d65f.create({});






parcelRequire("acw62");
function $d42c3a87ce67e89d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            width: "27",
            height: "12",
            viewBox: "0 0 27 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M6 11L1 6L6 1",
                    stroke: "white",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M26 6H1",
                    stroke: "white",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    });
}





var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
// src/queryObserver.ts







var $2905803326ac545c$export$a06cf8c0066f0d4c = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    constructor(client, options){
        super();
        this.options = options;
        this.#client = client;
        this.#selectError = null;
        this.#currentThenable = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
        this.bindMethods();
        this.setOptions(options);
    }
    #client;
    #currentQuery = void 0;
    #currentQueryInitialState = void 0;
    #currentResult = void 0;
    #currentResultState;
    #currentResultOptions;
    #currentThenable;
    #selectError;
    #selectFn;
    #selectResult;
    // This property keeps track of the last query with defined data.
    // It will be used to pass the previous data and query to the placeholder function between renders.
    #lastQueryWithDefinedData;
    #staleTimeoutId;
    #refetchIntervalId;
    #currentRefetchInterval;
    #trackedProps = /* @__PURE__ */ new Set();
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            this.#currentQuery.addObserver(this);
            if ($2905803326ac545c$var$shouldFetchOnMount(this.#currentQuery, this.options)) this.#executeFetch();
            else this.updateResult();
            this.#updateTimers();
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return $2905803326ac545c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return $2905803326ac545c$var$shouldFetchOn(this.#currentQuery, this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        this.#clearStaleTimeout();
        this.#clearRefetchInterval();
        this.#currentQuery.removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = this.#currentQuery;
        this.options = this.#client.defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        this.#updateQuery();
        this.#currentQuery.setOptions(this.options);
        if (prevOptions._defaulted && !(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: this.#currentQuery,
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && $2905803326ac545c$var$shouldFetchOptionally(this.#currentQuery, prevQuery, this.options, prevOptions)) this.#executeFetch();
        this.updateResult();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, this.#currentQuery) || (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(prevOptions.staleTime, this.#currentQuery))) this.#updateStaleTimeout();
        const nextRefetchInterval = this.#computeRefetchInterval();
        if (mounted && (this.#currentQuery !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) !== (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, this.#currentQuery) || nextRefetchInterval !== this.#currentRefetchInterval)) this.#updateRefetchInterval(nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = this.#client.getQueryCache().build(this.#client, options);
        const result = this.createResult(query, options);
        if ($2905803326ac545c$var$shouldAssignObserverCurrentProperties(this, result)) {
            this.#currentResult = result;
            this.#currentResultOptions = this.options;
            this.#currentResultState = this.#currentQuery.state;
        }
        return result;
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked?.(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && this.#currentThenable.status === "pending") this.#currentThenable.reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        this.#trackedProps.add(key);
    }
    getCurrentQuery() {
        return this.#currentQuery;
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = this.#client.defaultQueryOptions(options);
        const query = this.#client.getQueryCache().build(this.#client, defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return this.#executeFetch({
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return this.#currentResult;
        });
    }
    #executeFetch(fetchOptions) {
        this.#updateQuery();
        let promise = this.#currentQuery.fetch(this.options, fetchOptions);
        if (!fetchOptions?.throwOnError) promise = promise.catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
        return promise;
    }
    #updateStaleTimeout() {
        this.#clearStaleTimeout();
        const staleTime = (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(this.options.staleTime, this.#currentQuery);
        if ((0, $938ae10f13d49bdc$export$6acf61af03e62db) || this.#currentResult.isStale || !(0, $938ae10f13d49bdc$export$e539f754e934e270)(staleTime)) return;
        const time = (0, $938ae10f13d49bdc$export$811b83d62bcf47f0)(this.#currentResult.dataUpdatedAt, staleTime);
        const timeout = time + 1;
        this.#staleTimeoutId = (0, $b7f1384d98eac5cd$export$94a2700736e69372).setTimeout(()=>{
            if (!this.#currentResult.isStale) this.updateResult();
        }, timeout);
    }
    #computeRefetchInterval() {
        return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval(this.#currentQuery) : this.options.refetchInterval) ?? false;
    }
    #updateRefetchInterval(nextInterval) {
        this.#clearRefetchInterval();
        this.#currentRefetchInterval = nextInterval;
        if ((0, $938ae10f13d49bdc$export$6acf61af03e62db) || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(this.options.enabled, this.#currentQuery) === false || !(0, $938ae10f13d49bdc$export$e539f754e934e270)(this.#currentRefetchInterval) || this.#currentRefetchInterval === 0) return;
        this.#refetchIntervalId = (0, $b7f1384d98eac5cd$export$94a2700736e69372).setInterval(()=>{
            if (this.options.refetchIntervalInBackground || (0, $3f1a0485b2ecb725$export$6bf54661be5b02cf).isFocused()) this.#executeFetch();
        }, this.#currentRefetchInterval);
    }
    #updateTimers() {
        this.#updateStaleTimeout();
        this.#updateRefetchInterval(this.#computeRefetchInterval());
    }
    #clearStaleTimeout() {
        if (this.#staleTimeoutId) {
            (0, $b7f1384d98eac5cd$export$94a2700736e69372).clearTimeout(this.#staleTimeoutId);
            this.#staleTimeoutId = void 0;
        }
    }
    #clearRefetchInterval() {
        if (this.#refetchIntervalId) {
            (0, $b7f1384d98eac5cd$export$94a2700736e69372).clearInterval(this.#refetchIntervalId);
            this.#refetchIntervalId = void 0;
        }
    }
    createResult(query, options) {
        const prevQuery = this.#currentQuery;
        const prevOptions = this.options;
        const prevResult = this.#currentResult;
        const prevResultState = this.#currentResultState;
        const prevResultOptions = this.#currentResultOptions;
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : this.#currentQueryInitialState;
        const { state: state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && $2905803326ac545c$var$shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && $2905803326ac545c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, $bbb5e4108fb61687$export$f3df9013f2b58bce)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error: error, errorUpdatedAt: errorUpdatedAt, status: status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if (prevResult?.isPlaceholderData && options.placeholderData === prevResultOptions?.placeholderData) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData(this.#lastQueryWithDefinedData?.state.data, this.#lastQueryWithDefinedData) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(prevResult?.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === prevResultState?.data && options.select === this.#selectFn) data = this.#selectResult;
            else try {
                this.#selectFn = options.select;
                data = options.select(data);
                data = (0, $938ae10f13d49bdc$export$17619bac5b909b23)(prevResult?.data, data, options);
                this.#selectResult = data;
                this.#selectError = null;
            } catch (selectError) {
                this.#selectError = selectError;
            }
        }
        if (this.#selectError) {
            error = this.#selectError;
            data = this.#selectResult;
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status: status,
            fetchStatus: newState.fetchStatus,
            isPending: isPending,
            isSuccess: status === "success",
            isError: isError,
            isInitialLoading: isLoading,
            isLoading: isLoading,
            data: data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error: error,
            errorUpdatedAt: errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching: isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData: isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: $2905803326ac545c$var$isStale(query, options),
            refetch: this.refetch,
            promise: this.#currentThenable,
            isEnabled: (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = this.#currentThenable = nextResult.promise = (0, $f6114de20f9a4572$export$d54630db02a12b72)();
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = this.#currentThenable;
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = this.#currentResult;
        const nextResult = this.createResult(this.#currentQuery, this.options);
        this.#currentResultState = this.#currentQuery.state;
        this.#currentResultOptions = this.options;
        if (this.#currentResultState.data !== void 0) this.#lastQueryWithDefinedData = this.#currentQuery;
        if ((0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(nextResult, prevResult)) return;
        this.#currentResult = nextResult;
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps: notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !this.#trackedProps.size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? this.#trackedProps);
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys(this.#currentResult).some((key)=>{
                const typedKey = key;
                const changed = this.#currentResult[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        this.#notify({
            listeners: shouldNotifyListeners()
        });
    }
    #updateQuery() {
        const query = this.#client.getQueryCache().build(this.#client, this.options);
        if (query === this.#currentQuery) return;
        const prevQuery = this.#currentQuery;
        this.#currentQuery = query;
        this.#currentQueryInitialState = query.state;
        if (this.hasListeners()) {
            prevQuery?.removeObserver(this);
            query.addObserver(this);
        }
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) this.#updateTimers();
    }
    #notify(notifyOptions) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
            this.#client.getQueryCache().notify({
                query: this.#currentQuery,
                type: "observerResultsUpdated"
            });
        });
    }
};
function $2905803326ac545c$var$shouldLoadOnMount(query, options) {
    return (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function $2905803326ac545c$var$shouldFetchOnMount(query, options) {
    return $2905803326ac545c$var$shouldLoadOnMount(query, options) || query.state.data !== void 0 && $2905803326ac545c$var$shouldFetchOn(query, options, options.refetchOnMount);
}
function $2905803326ac545c$var$shouldFetchOn(query, options, field) {
    if ((0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false && (0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && $2905803326ac545c$var$isStale(query, options);
    }
    return false;
}
function $2905803326ac545c$var$shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && $2905803326ac545c$var$isStale(query, options);
}
function $2905803326ac545c$var$isStale(query, options) {
    return (0, $938ae10f13d49bdc$export$8c88ee6f2357230d)(options.enabled, query) !== false && query.isStaleByTime((0, $938ae10f13d49bdc$export$cb3145f011bda3ac)(options.staleTime, query));
}
function $2905803326ac545c$var$shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}



var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

"use client";
function $3ccd03800b9b1a4a$var$createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var $3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext = $acw62.createContext($3ccd03800b9b1a4a$var$createValue());
var $3ccd03800b9b1a4a$export$50dfac555130cafd = ()=>$acw62.useContext($3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext);
var $3ccd03800b9b1a4a$export$ddb9962d870f2330 = ({ children: children })=>{
    const [value] = $acw62.useState(()=>$3ccd03800b9b1a4a$var$createValue());
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($3ccd03800b9b1a4a$var$QueryErrorResetBoundaryContext.Provider, {
        value: value,
        children: typeof children === "function" ? children(value) : children
    });
};



var $acw62 = parcelRequire("acw62");

"use client";
var $b8d88d7bae8d797f$export$ae8adb3de3d77633 = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var $b8d88d7bae8d797f$export$b2b17ca3a1fb0229 = (errorResetBoundary)=>{
    $acw62.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var $b8d88d7bae8d797f$export$1fbcf724762d607 = ({ result: result, errorResetBoundary: errorResetBoundary, throwOnError: throwOnError, query: query, suspense: suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, $938ae10f13d49bdc$export$2072f68e6c3507cf)(throwOnError, [
        result.error,
        query
    ]));
};



var $acw62 = parcelRequire("acw62");
"use client";
var $b2f924bc70e540d6$var$IsRestoringContext = $acw62.createContext(false);
var $b2f924bc70e540d6$export$4da0178d6b5f553 = ()=>$acw62.useContext($b2f924bc70e540d6$var$IsRestoringContext);
var $b2f924bc70e540d6$export$593807d4e94f9621 = $b2f924bc70e540d6$var$IsRestoringContext.Provider;


// src/suspense.ts
var $d9109c84b9b954d9$export$8bed2f8d02206063 = (_error, query)=>query.state.data === void 0;
var $d9109c84b9b954d9$export$274d2a1db5a20c09 = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var $d9109c84b9b954d9$export$e0a3f29513afe430 = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var $d9109c84b9b954d9$export$88d3586dfed64df9 = (defaultedOptions, result)=>defaultedOptions?.suspense && result.isPending;
var $d9109c84b9b954d9$export$defdc11a9c9acfcf = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });


"use client";
function $22b97878ddf0e02d$export$fff0865807e996c5(options, Observer, queryClient) {
    const isRestoring = (0, $b2f924bc70e540d6$export$4da0178d6b5f553)();
    const errorResetBoundary = (0, $3ccd03800b9b1a4a$export$50dfac555130cafd)();
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    client.getDefaultOptions().queries?._experimental_beforeQuery?.(defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, $d9109c84b9b954d9$export$274d2a1db5a20c09)(defaultedOptions);
    (0, $b8d88d7bae8d797f$export$ae8adb3de3d77633)(defaultedOptions, errorResetBoundary);
    (0, $b8d88d7bae8d797f$export$b2b17ca3a1fb0229)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = $acw62.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)) : (0, $938ae10f13d49bdc$export$8793edee2d425525);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    $acw62.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, $d9109c84b9b954d9$export$88d3586dfed64df9)(defaultedOptions, result)) throw (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary);
    if ((0, $b8d88d7bae8d797f$export$1fbcf724762d607)({
        result: result,
        errorResetBoundary: errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    client.getDefaultOptions().queries?._experimental_afterQuery?.(defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, $938ae10f13d49bdc$export$6acf61af03e62db) && (0, $d9109c84b9b954d9$export$e0a3f29513afe430)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, $d9109c84b9b954d9$export$defdc11a9c9acfcf)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        client.getQueryCache().get(defaultedOptions.queryHash)?.promise;
        promise?.catch((0, $938ae10f13d49bdc$export$8793edee2d425525)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


"use client";
function $4cdfd80436a5bb32$export$dd0a697e1782aedd(options, queryClient) {
    return (0, $22b97878ddf0e02d$export$fff0865807e996c5)(options, (0, $2905803326ac545c$export$a06cf8c0066f0d4c), queryClient);
}


var $8fe6cf9b4cd31a23$exports = {};
/**
 * @fileoverview gRPC-Web generated client stub for nexus_service
 * @enhanceable
 * @public
 */ // Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v3.17.3
// source: nexus_service.proto
/* eslint-disable */ // @ts-nocheck
const $8fe6cf9b4cd31a23$var$grpc = {};

$8fe6cf9b4cd31a23$var$grpc.web = (parcelRequire("gd5R7"));
parcelRequire("fcTGK");

var $7QrRI = parcelRequire("7QrRI");

var $26u10 = parcelRequire("26u10");

var $6EauF = parcelRequire("6EauF");
parcelRequire("1oiLe");

var $dFFtz = parcelRequire("dFFtz");
parcelRequire("3QqPt");

var $3EyMN = parcelRequire("3EyMN");

var $ghA5X = parcelRequire("ghA5X");

var $9HeMJ = parcelRequire("9HeMJ");

var $aqwEO = parcelRequire("aqwEO");

var $9c7Du = parcelRequire("9c7Du");
const $8fe6cf9b4cd31a23$var$proto = {};

$8fe6cf9b4cd31a23$var$proto.nexus_service = (parcelRequire("dsvHa"));
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $8fe6cf9b4cd31a23$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $8fe6cf9b4cd31a23$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.GetCustomerRequest,
 *   !proto.nexus_service.GetCustomerResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomer = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetCustomer', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetCustomerRequest, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetCustomerResponse, /**
   * @param {!proto.nexus_service.GetCustomerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetCustomerResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.nexus_service.GetCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.nexus_service.GetCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getCustomer = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetCustomer', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomer, callback);
};
/**
 * @param {!proto.nexus_service.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.nexus_service.GetCustomerResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getCustomer = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetCustomer', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomer);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.NexusListProgramPricingRequest,
 *   !proto.billing_service.ListProgramPricingResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListProgramPricing = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListProgramPricing', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusListProgramPricingRequest, $26u10.ListProgramPricingResponse, /**
   * @param {!proto.nexus_service.NexusListProgramPricingRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListProgramPricingResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.NexusListProgramPricingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListProgramPricingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListProgramPricingResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listProgramPricing = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListProgramPricing', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListProgramPricing, callback);
};
/**
 * @param {!proto.nexus_service.NexusListProgramPricingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListProgramPricingResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listProgramPricing = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListProgramPricing', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListProgramPricing);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.ListReservationsRequest,
 *   !proto.subscription_service.ListReservationsResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListReservations = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListReservations', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $9HeMJ.ListReservationsRequest, $9HeMJ.ListReservationsResponse, /**
   * @param {!proto.subscription_service.ListReservationsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.ListReservationsResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.ListReservationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.ListReservationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.ListReservationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listReservations = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListReservations', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListReservations, callback);
};
/**
 * @param {!proto.subscription_service.ListReservationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.ListReservationsResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listReservations = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListReservations', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListReservations);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.AddCustomerNoteRequest,
 *   !proto.nexus_service.AddCustomerNoteResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddCustomerNote = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/AddCustomerNote', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.AddCustomerNoteRequest, $8fe6cf9b4cd31a23$var$proto.nexus_service.AddCustomerNoteResponse, /**
   * @param {!proto.nexus_service.AddCustomerNoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8fe6cf9b4cd31a23$var$proto.nexus_service.AddCustomerNoteResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.AddCustomerNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.nexus_service.AddCustomerNoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.nexus_service.AddCustomerNoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.addCustomerNote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/AddCustomerNote', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddCustomerNote, callback);
};
/**
 * @param {!proto.nexus_service.AddCustomerNoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.nexus_service.AddCustomerNoteResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.addCustomerNote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/AddCustomerNote', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddCustomerNote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.GetCustomerNotesRequest,
 *   !proto.nexus_service.GetCustomerNotesResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerNotes = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetCustomerNotes', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetCustomerNotesRequest, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetCustomerNotesResponse, /**
   * @param {!proto.nexus_service.GetCustomerNotesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetCustomerNotesResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.GetCustomerNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.nexus_service.GetCustomerNotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.nexus_service.GetCustomerNotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getCustomerNotes = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetCustomerNotes', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerNotes, callback);
};
/**
 * @param {!proto.nexus_service.GetCustomerNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.nexus_service.GetCustomerNotesResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getCustomerNotes = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetCustomerNotes', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerNotes);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.OverrideQualificationRequest,
 *   !proto.customer_service.OverrideQualificationResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_OverrideCustomerQualification = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/OverrideCustomerQualification', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $6EauF.OverrideQualificationRequest, $6EauF.OverrideQualificationResponse, /**
   * @param {!proto.customer_service.OverrideQualificationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.OverrideQualificationResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.OverrideQualificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.OverrideQualificationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.OverrideQualificationResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.overrideCustomerQualification = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/OverrideCustomerQualification', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_OverrideCustomerQualification, callback);
};
/**
 * @param {!proto.customer_service.OverrideQualificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.OverrideQualificationResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.overrideCustomerQualification = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/OverrideCustomerQualification', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_OverrideCustomerQualification);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.RecalculateCustomerScoresRequest,
 *   !proto.customer_service.RecalculateCustomerScoresResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_RecalculateCustomerQualification = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/RecalculateCustomerQualification', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $6EauF.RecalculateCustomerScoresRequest, $6EauF.RecalculateCustomerScoresResponse, /**
   * @param {!proto.customer_service.RecalculateCustomerScoresRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.RecalculateCustomerScoresResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.RecalculateCustomerScoresRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.RecalculateCustomerScoresResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.RecalculateCustomerScoresResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.recalculateCustomerQualification = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/RecalculateCustomerQualification', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_RecalculateCustomerQualification, callback);
};
/**
 * @param {!proto.customer_service.RecalculateCustomerScoresRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.RecalculateCustomerScoresResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.recalculateCustomerQualification = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/RecalculateCustomerQualification', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_RecalculateCustomerQualification);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetAllCustomersByPhoneRequest,
 *   !proto.customer_service.GetAllCustomersByPhoneResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetAllCustomersByPhone = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetAllCustomersByPhone', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $6EauF.GetAllCustomersByPhoneRequest, $6EauF.GetAllCustomersByPhoneResponse, /**
   * @param {!proto.customer_service.GetAllCustomersByPhoneRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetAllCustomersByPhoneResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetAllCustomersByPhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetAllCustomersByPhoneResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetAllCustomersByPhoneResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getAllCustomersByPhone = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetAllCustomersByPhone', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetAllCustomersByPhone, callback);
};
/**
 * @param {!proto.customer_service.GetAllCustomersByPhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetAllCustomersByPhoneResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getAllCustomersByPhone = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetAllCustomersByPhone', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetAllCustomersByPhone);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetCQEScoresRequest,
 *   !proto.customer_service.GetCQEScoresResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerCQEScores = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetCustomerCQEScores', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $6EauF.GetCQEScoresRequest, $6EauF.GetCQEScoresResponse, /**
   * @param {!proto.customer_service.GetCQEScoresRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetCQEScoresResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetCQEScoresRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetCQEScoresResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetCQEScoresResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getCustomerCQEScores = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetCustomerCQEScores', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerCQEScores, callback);
};
/**
 * @param {!proto.customer_service.GetCQEScoresRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetCQEScoresResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getCustomerCQEScores = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetCustomerCQEScores', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerCQEScores);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.ListClientsRequest,
 *   !proto.customer_service.ListClientsResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListClients = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListClients', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $6EauF.ListClientsRequest, $6EauF.ListClientsResponse, /**
   * @param {!proto.customer_service.ListClientsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.ListClientsResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.ListClientsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.ListClientsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.ListClientsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listClients = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListClients', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListClients, callback);
};
/**
 * @param {!proto.customer_service.ListClientsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.ListClientsResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listClients = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListClients', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListClients);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.GetCustomerImagesRequest,
 *   !proto.customer_service.GetImagesResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerImages = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetCustomerImages', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetCustomerImagesRequest, $6EauF.GetImagesResponse, /**
   * @param {!proto.nexus_service.GetCustomerImagesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetImagesResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.GetCustomerImagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetImagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetImagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getCustomerImages = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetCustomerImages', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerImages, callback);
};
/**
 * @param {!proto.nexus_service.GetCustomerImagesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetImagesResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getCustomerImages = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetCustomerImages', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetCustomerImages);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CancelInsurancePolicyRequest,
 *   !proto.insurance_service.CancelInsurancePolicyResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CancelInsurancePolicy = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/CancelInsurancePolicy', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $ghA5X.CancelInsurancePolicyRequest, $ghA5X.CancelInsurancePolicyResponse, /**
   * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.CancelInsurancePolicyResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.CancelInsurancePolicyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.CancelInsurancePolicyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.cancelInsurancePolicy = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/CancelInsurancePolicy', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CancelInsurancePolicy, callback);
};
/**
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.CancelInsurancePolicyResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.cancelInsurancePolicy = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/CancelInsurancePolicy', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CancelInsurancePolicy);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsuredDriversRequest,
 *   !proto.insurance_service.GetInsuredDriversResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetInsuredDrivers = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetInsuredDrivers', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $ghA5X.GetInsuredDriversRequest, $ghA5X.GetInsuredDriversResponse, /**
   * @param {!proto.insurance_service.GetInsuredDriversRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetInsuredDriversResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsuredDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuredDriversResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuredDriversResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getInsuredDrivers = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetInsuredDrivers', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetInsuredDrivers, callback);
};
/**
 * @param {!proto.insurance_service.GetInsuredDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuredDriversResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getInsuredDrivers = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetInsuredDrivers', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetInsuredDrivers);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsuranceQuoteRequest,
 *   !proto.insurance_service.GetInsuranceQuoteResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetInsuranceQuote = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetInsuranceQuote', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $ghA5X.GetInsuranceQuoteRequest, $ghA5X.GetInsuranceQuoteResponse, /**
   * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetInsuranceQuoteResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuranceQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuranceQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getInsuranceQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetInsuranceQuote', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetInsuranceQuote, callback);
};
/**
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuranceQuoteResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getInsuranceQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetInsuranceQuote', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetInsuranceQuote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.UpsertInsurancePoliciesRequest,
 *   !proto.insurance_service.UpsertInsurancePoliciesResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpsertInsurancePolicies = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/UpsertInsurancePolicies', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $ghA5X.UpsertInsurancePoliciesRequest, $ghA5X.UpsertInsurancePoliciesResponse, /**
   * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.UpsertInsurancePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.UpsertInsurancePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.UpsertInsurancePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.upsertInsurancePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/UpsertInsurancePolicies', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpsertInsurancePolicies, callback);
};
/**
 * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.UpsertInsurancePoliciesResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.upsertInsurancePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/UpsertInsurancePolicies', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpsertInsurancePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.CreateAppointmentRequest,
 *   !proto.appointment_service.CreateAppointmentResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreateAppointment = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/CreateAppointment', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $7QrRI.CreateAppointmentRequest, $7QrRI.CreateAppointmentResponse, /**
   * @param {!proto.appointment_service.CreateAppointmentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.CreateAppointmentResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.CreateAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.CreateAppointmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.CreateAppointmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.createAppointment = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/CreateAppointment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreateAppointment, callback);
};
/**
 * @param {!proto.appointment_service.CreateAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.CreateAppointmentResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.createAppointment = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/CreateAppointment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreateAppointment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.CancelAppointmentRequest,
 *   !proto.appointment_service.CancelAppointmentResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CancelAppointment = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/CancelAppointment', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $7QrRI.CancelAppointmentRequest, $7QrRI.CancelAppointmentResponse, /**
   * @param {!proto.appointment_service.CancelAppointmentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.CancelAppointmentResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.CancelAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.CancelAppointmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.CancelAppointmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.cancelAppointment = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/CancelAppointment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CancelAppointment, callback);
};
/**
 * @param {!proto.appointment_service.CancelAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.CancelAppointmentResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.cancelAppointment = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/CancelAppointment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CancelAppointment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.ListAppointmentsRequest,
 *   !proto.nexus_service.ListAppointmentsResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListAppointments = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListAppointments', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.ListAppointmentsRequest, $8fe6cf9b4cd31a23$var$proto.nexus_service.ListAppointmentsResponse, /**
   * @param {!proto.nexus_service.ListAppointmentsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8fe6cf9b4cd31a23$var$proto.nexus_service.ListAppointmentsResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.ListAppointmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.nexus_service.ListAppointmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.nexus_service.ListAppointmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listAppointments = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListAppointments', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListAppointments, callback);
};
/**
 * @param {!proto.nexus_service.ListAppointmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.nexus_service.ListAppointmentsResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listAppointments = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListAppointments', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListAppointments);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.UpdateAppointmentRequest,
 *   !proto.appointment_service.UpdateAppointmentResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateAppointment = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/UpdateAppointment', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $7QrRI.UpdateAppointmentRequest, $7QrRI.UpdateAppointmentResponse, /**
   * @param {!proto.appointment_service.UpdateAppointmentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.UpdateAppointmentResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.UpdateAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.UpdateAppointmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.UpdateAppointmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.updateAppointment = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/UpdateAppointment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateAppointment, callback);
};
/**
 * @param {!proto.appointment_service.UpdateAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.UpdateAppointmentResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.updateAppointment = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/UpdateAppointment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateAppointment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.ListDealershipsRequest,
 *   !proto.dealership_service.ListDealershipsResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListDealerships = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListDealerships', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $dFFtz.ListDealershipsRequest, $dFFtz.ListDealershipsResponse, /**
   * @param {!proto.dealership_service.ListDealershipsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.ListDealershipsResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.ListDealershipsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.ListDealershipsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.ListDealershipsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listDealerships = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListDealerships', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListDealerships, callback);
};
/**
 * @param {!proto.dealership_service.ListDealershipsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.ListDealershipsResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listDealerships = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListDealerships', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListDealerships);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.ViewTeamRequest,
 *   !proto.dealership_service.ViewTeamResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ViewTeam = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ViewTeam', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $dFFtz.ViewTeamRequest, $dFFtz.ViewTeamResponse, /**
   * @param {!proto.dealership_service.ViewTeamRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.ViewTeamResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.ViewTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.ViewTeamResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.ViewTeamResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.viewTeam = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ViewTeam', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ViewTeam, callback);
};
/**
 * @param {!proto.dealership_service.ViewTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.ViewTeamResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.viewTeam = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ViewTeam', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ViewTeam);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.web.SearchParams,
 *   !proto.billing_service.ListPromotionsResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListPromotions = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListPromotions', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $9c7Du.SearchParams, $26u10.ListPromotionsResponse, /**
   * @param {!proto.web.SearchParams} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListPromotionsResponse.deserializeBinary);
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListPromotionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListPromotionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listPromotions = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListPromotions', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListPromotions, callback);
};
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListPromotionsResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listPromotions = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListPromotions', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListPromotions);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.web.SearchParams,
 *   !proto.billing_service.ListPromotionPartnersResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListPromotionPartners = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListPromotionPartners', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $9c7Du.SearchParams, $26u10.ListPromotionPartnersResponse, /**
   * @param {!proto.web.SearchParams} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListPromotionPartnersResponse.deserializeBinary);
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListPromotionPartnersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListPromotionPartnersResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listPromotionPartners = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListPromotionPartners', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListPromotionPartners, callback);
};
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListPromotionPartnersResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listPromotionPartners = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListPromotionPartners', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListPromotionPartners);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreatePromotionPartnerRequest,
 *   !proto.billing_service.CreatePromotionPartnerResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreatePromotionPartner = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/CreatePromotionPartner', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $26u10.CreatePromotionPartnerRequest, $26u10.CreatePromotionPartnerResponse, /**
   * @param {!proto.billing_service.CreatePromotionPartnerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.CreatePromotionPartnerResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.CreatePromotionPartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.CreatePromotionPartnerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.CreatePromotionPartnerResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.createPromotionPartner = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/CreatePromotionPartner', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreatePromotionPartner, callback);
};
/**
 * @param {!proto.billing_service.CreatePromotionPartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.CreatePromotionPartnerResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.createPromotionPartner = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/CreatePromotionPartner', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreatePromotionPartner);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreatePromotionRequest,
 *   !proto.billing_service.CreatePromotionResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreatePromotion = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/CreatePromotion', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $26u10.CreatePromotionRequest, $26u10.CreatePromotionResponse, /**
   * @param {!proto.billing_service.CreatePromotionRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.CreatePromotionResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.CreatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.CreatePromotionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.CreatePromotionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.createPromotion = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/CreatePromotion', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreatePromotion, callback);
};
/**
 * @param {!proto.billing_service.CreatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.CreatePromotionResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.createPromotion = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/CreatePromotion', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_CreatePromotion);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.AddVehicleRequest,
 *   !proto.fleet_service.AddVehicleResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicle = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/AddVehicle', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.AddVehicleRequest, $3EyMN.AddVehicleResponse, /**
   * @param {!proto.fleet_service.AddVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.AddVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.AddVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.AddVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.AddVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.addVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/AddVehicle', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicle, callback);
};
/**
 * @param {!proto.fleet_service.AddVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.AddVehicleResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.addVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/AddVehicle', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.AddVehiclesRequest,
 *   !proto.fleet_service.AddVehiclesResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicles = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/AddVehicles', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.AddVehiclesRequest, $3EyMN.AddVehiclesResponse, /**
   * @param {!proto.fleet_service.AddVehiclesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.AddVehiclesResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.AddVehiclesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.AddVehiclesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.AddVehiclesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.addVehicles = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/AddVehicles', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicles, callback);
};
/**
 * @param {!proto.fleet_service.AddVehiclesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.AddVehiclesResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.addVehicles = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/AddVehicles', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicles);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.DeleteVehicleMediaRequest,
 *   !proto.fleet_service.DeleteVehicleMediaResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_DeleteVehicleMedia = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/DeleteVehicleMedia', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.DeleteVehicleMediaRequest, $3EyMN.DeleteVehicleMediaResponse, /**
   * @param {!proto.fleet_service.DeleteVehicleMediaRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.DeleteVehicleMediaResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.DeleteVehicleMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.DeleteVehicleMediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.DeleteVehicleMediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.deleteVehicleMedia = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/DeleteVehicleMedia', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_DeleteVehicleMedia, callback);
};
/**
 * @param {!proto.fleet_service.DeleteVehicleMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.DeleteVehicleMediaResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.deleteVehicleMedia = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/DeleteVehicleMedia', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_DeleteVehicleMedia);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.GetLatestCustodyRequest,
 *   !proto.nexus_service.GetLatestCustodyResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetLatestCustody = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetLatestCustody', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetLatestCustodyRequest, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetLatestCustodyResponse, /**
   * @param {!proto.nexus_service.GetLatestCustodyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetLatestCustodyResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.GetLatestCustodyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.nexus_service.GetLatestCustodyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.nexus_service.GetLatestCustodyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getLatestCustody = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetLatestCustody', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetLatestCustody, callback);
};
/**
 * @param {!proto.nexus_service.GetLatestCustodyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.nexus_service.GetLatestCustodyResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getLatestCustody = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetLatestCustody', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetLatestCustody);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.GetVehicleMapRequest,
 *   !proto.nexus_service.GetVehicleMapResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetMapVehicles = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetMapVehicles', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetVehicleMapRequest, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetVehicleMapResponse, /**
   * @param {!proto.nexus_service.GetVehicleMapRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8fe6cf9b4cd31a23$var$proto.nexus_service.GetVehicleMapResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.GetVehicleMapRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.nexus_service.GetVehicleMapResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.nexus_service.GetVehicleMapResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getMapVehicles = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetMapVehicles', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetMapVehicles, callback);
};
/**
 * @param {!proto.nexus_service.GetVehicleMapRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.nexus_service.GetVehicleMapResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getMapVehicles = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetMapVehicles', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetMapVehicles);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetSubscriptionMileageRequest,
 *   !proto.fleet_service.GetSubscriptionMileageResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetSubscriptionMileage = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetSubscriptionMileage', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.GetSubscriptionMileageRequest, $3EyMN.GetSubscriptionMileageResponse, /**
   * @param {!proto.fleet_service.GetSubscriptionMileageRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetSubscriptionMileageResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetSubscriptionMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetSubscriptionMileageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetSubscriptionMileageResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getSubscriptionMileage = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetSubscriptionMileage', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetSubscriptionMileage, callback);
};
/**
 * @param {!proto.fleet_service.GetSubscriptionMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetSubscriptionMileageResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getSubscriptionMileage = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetSubscriptionMileage', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetSubscriptionMileage);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetSubscriptionMileagePurchasesRequest,
 *   !proto.fleet_service.GetSubscriptionMileagePurchasesResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetSubscriptionMileagePurchases = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetSubscriptionMileagePurchases', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.GetSubscriptionMileagePurchasesRequest, $3EyMN.GetSubscriptionMileagePurchasesResponse, /**
   * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetSubscriptionMileagePurchasesResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetSubscriptionMileagePurchasesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetSubscriptionMileagePurchasesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getSubscriptionMileagePurchases = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetSubscriptionMileagePurchases', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetSubscriptionMileagePurchases, callback);
};
/**
 * @param {!proto.fleet_service.GetSubscriptionMileagePurchasesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetSubscriptionMileagePurchasesResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getSubscriptionMileagePurchases = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetSubscriptionMileagePurchases', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetSubscriptionMileagePurchases);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetVehicleByIdRequest,
 *   !proto.fleet_service.GetVehicleByIdResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetVehicleById = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetVehicleById', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.GetVehicleByIdRequest, $3EyMN.GetVehicleByIdResponse, /**
   * @param {!proto.fleet_service.GetVehicleByIdRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetVehicleByIdResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetVehicleByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetVehicleByIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetVehicleByIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getVehicleById = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetVehicleById', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetVehicleById, callback);
};
/**
 * @param {!proto.fleet_service.GetVehicleByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetVehicleByIdResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getVehicleById = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetVehicleById', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetVehicleById);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetVehicleMediaRequest,
 *   !proto.fleet_service.GetVehicleMediaResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetVehicleMedia = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetVehicleMedia', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.GetVehicleMediaRequest, $3EyMN.GetVehicleMediaResponse, /**
   * @param {!proto.fleet_service.GetVehicleMediaRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetVehicleMediaResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetVehicleMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetVehicleMediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetVehicleMediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getVehicleMedia = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetVehicleMedia', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetVehicleMedia, callback);
};
/**
 * @param {!proto.fleet_service.GetVehicleMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetVehicleMediaResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getVehicleMedia = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetVehicleMedia', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetVehicleMedia);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.InitiateVehicleReturnRequest,
 *   !proto.fleet_service.InitiateVehicleReturnResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_InitiateVehicleReturn = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/InitiateVehicleReturn', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.InitiateVehicleReturnRequest, $3EyMN.InitiateVehicleReturnResponse, /**
   * @param {!proto.fleet_service.InitiateVehicleReturnRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.InitiateVehicleReturnResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.InitiateVehicleReturnRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.InitiateVehicleReturnResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.InitiateVehicleReturnResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.initiateVehicleReturn = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/InitiateVehicleReturn', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_InitiateVehicleReturn, callback);
};
/**
 * @param {!proto.fleet_service.InitiateVehicleReturnRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.InitiateVehicleReturnResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.initiateVehicleReturn = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/InitiateVehicleReturn', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_InitiateVehicleReturn);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ListVehicleMakesRequest,
 *   !proto.fleet_service.ListVehicleMakesResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListVehicleMakes = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListVehicleMakes', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.ListVehicleMakesRequest, $3EyMN.ListVehicleMakesResponse, /**
   * @param {!proto.fleet_service.ListVehicleMakesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ListVehicleMakesResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ListVehicleMakesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ListVehicleMakesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ListVehicleMakesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listVehicleMakes = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListVehicleMakes', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListVehicleMakes, callback);
};
/**
 * @param {!proto.fleet_service.ListVehicleMakesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ListVehicleMakesResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listVehicleMakes = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListVehicleMakes', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListVehicleMakes);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ListModelsByMakeRequest,
 *   !proto.fleet_service.ListModelsByMakeResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListModelsByMake = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListModelsByMake', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.ListModelsByMakeRequest, $3EyMN.ListModelsByMakeResponse, /**
   * @param {!proto.fleet_service.ListModelsByMakeRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ListModelsByMakeResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ListModelsByMakeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ListModelsByMakeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ListModelsByMakeResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listModelsByMake = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListModelsByMake', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListModelsByMake, callback);
};
/**
 * @param {!proto.fleet_service.ListModelsByMakeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ListModelsByMakeResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listModelsByMake = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListModelsByMake', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListModelsByMake);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ListVehiclesRequest,
 *   !proto.fleet_service.ListVehiclesResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListVehicles = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ListVehicles', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.ListVehiclesRequest, $3EyMN.ListVehiclesResponse, /**
   * @param {!proto.fleet_service.ListVehiclesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ListVehiclesResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ListVehiclesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ListVehiclesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ListVehiclesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.listVehicles = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ListVehicles', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListVehicles, callback);
};
/**
 * @param {!proto.fleet_service.ListVehiclesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ListVehiclesResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.listVehicles = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ListVehicles', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ListVehicles);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ReturnVehicleRequest,
 *   !proto.fleet_service.ReturnVehicleResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ReturnVehicle = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ReturnVehicle', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.ReturnVehicleRequest, $3EyMN.ReturnVehicleResponse, /**
   * @param {!proto.fleet_service.ReturnVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ReturnVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ReturnVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ReturnVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ReturnVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.returnVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ReturnVehicle', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ReturnVehicle, callback);
};
/**
 * @param {!proto.fleet_service.ReturnVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ReturnVehicleResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.returnVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ReturnVehicle', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ReturnVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpdateVehicleRequest,
 *   !proto.fleet_service.UpdateVehicleResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicle = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/UpdateVehicle', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.UpdateVehicleRequest, $3EyMN.UpdateVehicleResponse, /**
   * @param {!proto.fleet_service.UpdateVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpdateVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpdateVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpdateVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpdateVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.updateVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicle', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicle, callback);
};
/**
 * @param {!proto.fleet_service.UpdateVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpdateVehicleResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.updateVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicle', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpdateStateToInListingRequest,
 *   !proto.fleet_service.UpdateStateToInListingResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToInListing = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/UpdateVehicleStateToInListing', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.UpdateStateToInListingRequest, $3EyMN.UpdateStateToInListingResponse, /**
   * @param {!proto.fleet_service.UpdateStateToInListingRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpdateStateToInListingResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpdateStateToInListingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpdateStateToInListingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpdateStateToInListingResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.updateVehicleStateToInListing = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicleStateToInListing', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToInListing, callback);
};
/**
 * @param {!proto.fleet_service.UpdateStateToInListingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpdateStateToInListingResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.updateVehicleStateToInListing = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicleStateToInListing', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToInListing);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpdateStateToInProcessRequest,
 *   !proto.fleet_service.UpdateStateToInProcessResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToInProcess = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/UpdateVehicleStateToInProcess', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.UpdateStateToInProcessRequest, $3EyMN.UpdateStateToInProcessResponse, /**
   * @param {!proto.fleet_service.UpdateStateToInProcessRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpdateStateToInProcessResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpdateStateToInProcessRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpdateStateToInProcessResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpdateStateToInProcessResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.updateVehicleStateToInProcess = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicleStateToInProcess', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToInProcess, callback);
};
/**
 * @param {!proto.fleet_service.UpdateStateToInProcessRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpdateStateToInProcessResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.updateVehicleStateToInProcess = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicleStateToInProcess', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToInProcess);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpdateStateToSoldRequest,
 *   !proto.fleet_service.UpdateStateToSoldResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToSold = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/UpdateVehicleStateToSold', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.UpdateStateToSoldRequest, $3EyMN.UpdateStateToSoldResponse, /**
   * @param {!proto.fleet_service.UpdateStateToSoldRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpdateStateToSoldResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpdateStateToSoldRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpdateStateToSoldResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpdateStateToSoldResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.updateVehicleStateToSold = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicleStateToSold', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToSold, callback);
};
/**
 * @param {!proto.fleet_service.UpdateStateToSoldRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpdateStateToSoldResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.updateVehicleStateToSold = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicleStateToSold', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToSold);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpdateStateToTotalLossRequest,
 *   !proto.fleet_service.UpdateStateToTotalLossResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToTotalLoss = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/UpdateVehicleStateToTotalLoss', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.UpdateStateToTotalLossRequest, $3EyMN.UpdateStateToTotalLossResponse, /**
   * @param {!proto.fleet_service.UpdateStateToTotalLossRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpdateStateToTotalLossResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpdateStateToTotalLossRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpdateStateToTotalLossResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpdateStateToTotalLossResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.updateVehicleStateToTotalLoss = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicleStateToTotalLoss', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToTotalLoss, callback);
};
/**
 * @param {!proto.fleet_service.UpdateStateToTotalLossRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpdateStateToTotalLossResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.updateVehicleStateToTotalLoss = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/UpdateVehicleStateToTotalLoss', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpdateVehicleStateToTotalLoss);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpsertVehicleMediaRequest,
 *   !proto.fleet_service.UpsertVehicleMediaResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpsertVehicleMedia = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/UpsertVehicleMedia', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $3EyMN.UpsertVehicleMediaRequest, $3EyMN.UpsertVehicleMediaResponse, /**
   * @param {!proto.fleet_service.UpsertVehicleMediaRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpsertVehicleMediaResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpsertVehicleMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpsertVehicleMediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpsertVehicleMediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.upsertVehicleMedia = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/UpsertVehicleMedia', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpsertVehicleMedia, callback);
};
/**
 * @param {!proto.fleet_service.UpsertVehicleMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpsertVehicleMediaResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.upsertVehicleMedia = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/UpsertVehicleMedia', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_UpsertVehicleMedia);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.AddVehicleAssignmentRequest,
 *   !proto.subscription_service.AddVehicleAssignmentResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicleAssignment = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/AddVehicleAssignment', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $9HeMJ.AddVehicleAssignmentRequest, $9HeMJ.AddVehicleAssignmentResponse, /**
   * @param {!proto.subscription_service.AddVehicleAssignmentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.AddVehicleAssignmentResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.AddVehicleAssignmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.AddVehicleAssignmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.AddVehicleAssignmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.addVehicleAssignment = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/AddVehicleAssignment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicleAssignment, callback);
};
/**
 * @param {!proto.subscription_service.AddVehicleAssignmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.AddVehicleAssignmentResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.addVehicleAssignment = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/AddVehicleAssignment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_AddVehicleAssignment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.RemoveVehicleAssignmentRequest,
 *   !proto.subscription_service.RemoveVehicleAssignmentResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_RemoveVehicleAssignment = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/RemoveVehicleAssignment', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $9HeMJ.RemoveVehicleAssignmentRequest, $9HeMJ.RemoveVehicleAssignmentResponse, /**
   * @param {!proto.subscription_service.RemoveVehicleAssignmentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.RemoveVehicleAssignmentResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.RemoveVehicleAssignmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.RemoveVehicleAssignmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.RemoveVehicleAssignmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.removeVehicleAssignment = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/RemoveVehicleAssignment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_RemoveVehicleAssignment, callback);
};
/**
 * @param {!proto.subscription_service.RemoveVehicleAssignmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.RemoveVehicleAssignmentResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.removeVehicleAssignment = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/RemoveVehicleAssignment', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_RemoveVehicleAssignment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.telematics_service.GetTelematicsRequest,
 *   !proto.telematics_service.GetTelematicsResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetTelematics = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/GetTelematics', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $aqwEO.GetTelematicsRequest, $aqwEO.GetTelematicsResponse, /**
   * @param {!proto.telematics_service.GetTelematicsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $aqwEO.GetTelematicsResponse.deserializeBinary);
/**
 * @param {!proto.telematics_service.GetTelematicsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.telematics_service.GetTelematicsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.telematics_service.GetTelematicsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.getTelematics = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/GetTelematics', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetTelematics, callback);
};
/**
 * @param {!proto.telematics_service.GetTelematicsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.telematics_service.GetTelematicsResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.getTelematics = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/GetTelematics', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_GetTelematics);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.ConvertToGalpinTeslaRequest,
 *   !proto.nexus_service.ConvertToGalpinTeslaResponse>}
 */ const $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ConvertToGalpinTesla = new $8fe6cf9b4cd31a23$var$grpc.web.MethodDescriptor('/nexus_service.NexusService/ConvertToGalpinTesla', $8fe6cf9b4cd31a23$var$grpc.web.MethodType.UNARY, $8fe6cf9b4cd31a23$var$proto.nexus_service.ConvertToGalpinTeslaRequest, $8fe6cf9b4cd31a23$var$proto.nexus_service.ConvertToGalpinTeslaResponse, /**
   * @param {!proto.nexus_service.ConvertToGalpinTeslaRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8fe6cf9b4cd31a23$var$proto.nexus_service.ConvertToGalpinTeslaResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.ConvertToGalpinTeslaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.nexus_service.ConvertToGalpinTeslaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.nexus_service.ConvertToGalpinTeslaResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServiceClient.prototype.convertToGalpinTesla = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/nexus_service.NexusService/ConvertToGalpinTesla', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ConvertToGalpinTesla, callback);
};
/**
 * @param {!proto.nexus_service.ConvertToGalpinTeslaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.nexus_service.ConvertToGalpinTeslaResponse>}
 *     Promise that resolves to the response
 */ $8fe6cf9b4cd31a23$var$proto.nexus_service.NexusServicePromiseClient.prototype.convertToGalpinTesla = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/nexus_service.NexusService/ConvertToGalpinTesla', request, metadata || {}, $8fe6cf9b4cd31a23$var$methodDescriptor_NexusService_ConvertToGalpinTesla);
};
$8fe6cf9b4cd31a23$exports = $8fe6cf9b4cd31a23$var$proto.nexus_service;



var $dsvHa = parcelRequire("dsvHa");


var $f1q41 = parcelRequire("f1q41");
/**
 * Initially used to safely parse the JSON from CQE qualification raw data
 * @param json
 */ function $288e026a18a9870d$export$f205803a3961ad7(json) {
    if (json === '') return '';
    try {
        return JSON.parse(json);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    } catch (e) {
        return json;
    }
}


const $e3ab3b3b306c7d16$var$debugSettingsKey = 'gRPCDebugSettings';
function $e3ab3b3b306c7d16$var$loadDebugSettings() {
    const settings = localStorage.getItem($e3ab3b3b306c7d16$var$debugSettingsKey);
    if (!settings) return {
        logAuth: false,
        logMessageBinary: false,
        logMessageObject: false
    };
    return (0, $288e026a18a9870d$export$f205803a3961ad7)(settings);
}
const $e3ab3b3b306c7d16$var$debugSettings = $e3ab3b3b306c7d16$var$loadDebugSettings();
$e3ab3b3b306c7d16$var$initDebug();
function $e3ab3b3b306c7d16$var$initDebug() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    window.toggleGRPCDebug = (options)=>{
        $e3ab3b3b306c7d16$var$debugSettings.logAuth = options?.logAuth || !$e3ab3b3b306c7d16$var$debugSettings.logAuth;
        $e3ab3b3b306c7d16$var$debugSettings.logMessageObject = options?.logMessageObject || !$e3ab3b3b306c7d16$var$debugSettings.logMessageObject;
        $e3ab3b3b306c7d16$var$debugSettings.logMessageBinary = options?.logMessageBinary || false;
        localStorage.setItem($e3ab3b3b306c7d16$var$debugSettingsKey, JSON.stringify($e3ab3b3b306c7d16$var$debugSettings));
    };
}
const $e3ab3b3b306c7d16$var$config = {
    clientId: "0oa1g5dxubGuvAU5d5d7",
    issuer: "https://nxcr.okta.com/oauth2/default",
    redirectUri: "https://tools.beta.nxcr.com/login/callback",
    scopes: [
        'openid',
        'profile',
        'email',
        'groups'
    ],
    pkce: true
};
var $e3ab3b3b306c7d16$var$key, $e3ab3b3b306c7d16$var$key1, $e3ab3b3b306c7d16$var$value, $e3ab3b3b306c7d16$var$key2;
const $e3ab3b3b306c7d16$export$219078e38253958 = new (0, $95440d1ea7e2da18$export$c998d4cdbfb7af8)($e3ab3b3b306c7d16$var$config);
function $e3ab3b3b306c7d16$export$ce6d32fcd969c986(oktaAuthToken) {
    this.oktaAuthToken = oktaAuthToken;
}
async function $e3ab3b3b306c7d16$var$resolveAuthToken(fallbackToken) {
    const token = $e3ab3b3b306c7d16$export$219078e38253958.getIdToken() || fallbackToken;
    if (!token || !$e3ab3b3b306c7d16$var$isJwtExpired(token)) return token;
    try {
        const renewedToken = await $e3ab3b3b306c7d16$export$219078e38253958.tokenManager.renew('idToken');
        return renewedToken?.idToken || token;
    } catch (error) {
        console.error('Unable to renew id token before request', error);
        return token;
    }
}
function $e3ab3b3b306c7d16$var$isJwtExpired(token, skewSeconds = 60) {
    const tokenPayload = token.split('.')[1];
    if (!tokenPayload) return false;
    try {
        const { exp: exp } = (0, $288e026a18a9870d$export$f205803a3961ad7)(window.atob(tokenPayload));
        if (!exp) return false;
        return exp <= Math.floor(Date.now() / 1000) + skewSeconds;
    } catch  {
        return false;
    }
}
// Disable because it's not easy to type this generic.
$e3ab3b3b306c7d16$export$ce6d32fcd969c986.prototype.intercept = function(request, invoker) {
    return $e3ab3b3b306c7d16$var$resolveAuthToken(this.oktaAuthToken).then((token)=>{
        const reqMetadata = request.getMetadata();
        if (token) reqMetadata['authorization'] = token;
        if ($e3ab3b3b306c7d16$var$debugSettings.logAuth || $e3ab3b3b306c7d16$var$debugSettings.logMessageBinary || $e3ab3b3b306c7d16$var$debugSettings.logMessageObject) console.log({
            auth: $e3ab3b3b306c7d16$var$debugSettings.logAuth && request.getMetadata(),
            message: $e3ab3b3b306c7d16$var$debugSettings.logMessageObject && $e3ab3b3b306c7d16$var$getLogMessage(request.getRequestMessage()),
            instance: $e3ab3b3b306c7d16$var$debugSettings.logMessageBinary && request.getRequestMessage(),
            invoker: invoker,
            request: request,
            callOptions: request.getCallOptions()
        });
        return invoker(request);
    });
};
function $e3ab3b3b306c7d16$var$getLogMessage(message) {
    return (0, $f1q41.mapKeys)(message?.toObject(), (value, key)=>{
        return (0, $f1q41.snakeCase)(key);
    });
}


// ! This are here and commented as well as in the .env file because changing the .env file requires clearing parcel cache and restarting dev server. Easier to swap here.
// const endpointBase = 'https://pinot.dev.nxcr.com'
// const endpointBase = 'https://pinot.qa.nxcr.com'
const $4b3a74d272f69cbe$var$endpointBase = "https://pinot.beta.nxcr.com";
const $4b3a74d272f69cbe$export$6c0517834721cef7 = {
    endpoints: {
        fleet: $4b3a74d272f69cbe$var$endpointBase,
        listing: $4b3a74d272f69cbe$var$endpointBase,
        fleetUpload: "https://fleet-service.beta.nxcr.com",
        nexusBffService: $4b3a74d272f69cbe$var$endpointBase
    }
};



var $f1q41 = parcelRequire("f1q41");

var $26u10 = parcelRequire("26u10");
var $df70feab7068291e$exports = {};
/**
 * @fileoverview gRPC-Web generated client stub for gateway_service
 * @enhanceable
 * @public
 */ // Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v3.17.3
// source: gateway_service.proto
/* eslint-disable */ // @ts-nocheck
const $df70feab7068291e$var$grpc = {};

$df70feab7068291e$var$grpc.web = (parcelRequire("gd5R7"));

var $7QrRI = parcelRequire("7QrRI");

var $26u10 = parcelRequire("26u10");

var $an37o = parcelRequire("an37o");

var $k1gxg = parcelRequire("k1gxg");

var $6EauF = parcelRequire("6EauF");

var $g1LOb = parcelRequire("g1LOb");

var $dFFtz = parcelRequire("dFFtz");

var $cyjZp = parcelRequire("cyjZp");

var $3QqPt = parcelRequire("3QqPt");

var $3EyMN = parcelRequire("3EyMN");

var $gjhG2 = parcelRequire("gjhG2");

var $ghA5X = parcelRequire("ghA5X");

var $dsvHa = parcelRequire("dsvHa");

var $eAp0I = parcelRequire("eAp0I");

var $8ilIL = parcelRequire("8ilIL");

var $cIR06 = parcelRequire("cIR06");

var $9HeMJ = parcelRequire("9HeMJ");

var $9YICB = parcelRequire("9YICB");

var $2Yrcc = parcelRequire("2Yrcc");

var $9c7Du = parcelRequire("9c7Du");

var $aqwEO = parcelRequire("aqwEO");
const $df70feab7068291e$var$proto = {};

$df70feab7068291e$var$proto.gateway_service = (parcelRequire("ekuMq"));
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.TelematicsServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.TelematicsServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.telematics_service.CommandVehicleRequest,
 *   !proto.telematics_service.CommandVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_TelematicsService_CommandVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.TelematicsService/CommandVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $aqwEO.CommandVehicleRequest, $aqwEO.CommandVehicleResponse, /**
   * @param {!proto.telematics_service.CommandVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $aqwEO.CommandVehicleResponse.deserializeBinary);
/**
 * @param {!proto.telematics_service.CommandVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.telematics_service.CommandVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.telematics_service.CommandVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.TelematicsServiceClient.prototype.commandVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.TelematicsService/CommandVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_TelematicsService_CommandVehicle, callback);
};
/**
 * @param {!proto.telematics_service.CommandVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.telematics_service.CommandVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.TelematicsServicePromiseClient.prototype.commandVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.TelematicsService/CommandVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_TelematicsService_CommandVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.telematics_service.GetTelematicsRequest,
 *   !proto.telematics_service.GetTelematicsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_TelematicsService_GetTelematics = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.TelematicsService/GetTelematics', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $aqwEO.GetTelematicsRequest, $aqwEO.GetTelematicsResponse, /**
   * @param {!proto.telematics_service.GetTelematicsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $aqwEO.GetTelematicsResponse.deserializeBinary);
/**
 * @param {!proto.telematics_service.GetTelematicsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.telematics_service.GetTelematicsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.telematics_service.GetTelematicsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.TelematicsServiceClient.prototype.getTelematics = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.TelematicsService/GetTelematics', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_TelematicsService_GetTelematics, callback);
};
/**
 * @param {!proto.telematics_service.GetTelematicsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.telematics_service.GetTelematicsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.TelematicsServicePromiseClient.prototype.getTelematics = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.TelematicsService/GetTelematics', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_TelematicsService_GetTelematics);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.telematics_service.StreamTelematicsRequest,
 *   !proto.telematics_service.Telematics>}
 */ const $df70feab7068291e$var$methodDescriptor_TelematicsService_StreamTelematics = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.TelematicsService/StreamTelematics', $df70feab7068291e$var$grpc.web.MethodType.SERVER_STREAMING, $aqwEO.StreamTelematicsRequest, $aqwEO.Telematics, /**
   * @param {!proto.telematics_service.StreamTelematicsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $aqwEO.Telematics.deserializeBinary);
/**
 * @param {!proto.telematics_service.StreamTelematicsRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.telematics_service.Telematics>}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.TelematicsServiceClient.prototype.streamTelematics = function(request, metadata) {
    return this.client_.serverStreaming(this.hostname_ + '/gateway_service.TelematicsService/StreamTelematics', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_TelematicsService_StreamTelematics);
};
/**
 * @param {!proto.telematics_service.StreamTelematicsRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.telematics_service.Telematics>}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.TelematicsServicePromiseClient.prototype.streamTelematics = function(request, metadata) {
    return this.client_.serverStreaming(this.hostname_ + '/gateway_service.TelematicsService/StreamTelematics', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_TelematicsService_StreamTelematics);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.CreateAppointmentRequest,
 *   !proto.appointment_service.CreateAppointmentResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_CreateAppointment = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/CreateAppointment', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.CreateAppointmentRequest, $7QrRI.CreateAppointmentResponse, /**
   * @param {!proto.appointment_service.CreateAppointmentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.CreateAppointmentResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.CreateAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.CreateAppointmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.CreateAppointmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.createAppointment = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/CreateAppointment', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_CreateAppointment, callback);
};
/**
 * @param {!proto.appointment_service.CreateAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.CreateAppointmentResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.createAppointment = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/CreateAppointment', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_CreateAppointment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.ListAppointmentsRequest,
 *   !proto.appointment_service.ListAppointmentsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_ListAppointments = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/ListAppointments', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.ListAppointmentsRequest, $7QrRI.ListAppointmentsResponse, /**
   * @param {!proto.appointment_service.ListAppointmentsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.ListAppointmentsResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.ListAppointmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.ListAppointmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.ListAppointmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.listAppointments = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/ListAppointments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_ListAppointments, callback);
};
/**
 * @param {!proto.appointment_service.ListAppointmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.ListAppointmentsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.listAppointments = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/ListAppointments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_ListAppointments);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.UpdateAppointmentRequest,
 *   !proto.appointment_service.UpdateAppointmentResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_UpdateAppointment = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/UpdateAppointment', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.UpdateAppointmentRequest, $7QrRI.UpdateAppointmentResponse, /**
   * @param {!proto.appointment_service.UpdateAppointmentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.UpdateAppointmentResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.UpdateAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.UpdateAppointmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.UpdateAppointmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.updateAppointment = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/UpdateAppointment', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_UpdateAppointment, callback);
};
/**
 * @param {!proto.appointment_service.UpdateAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.UpdateAppointmentResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.updateAppointment = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/UpdateAppointment', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_UpdateAppointment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.CancelAppointmentRequest,
 *   !proto.appointment_service.CancelAppointmentResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_CancelAppointment = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/CancelAppointment', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.CancelAppointmentRequest, $7QrRI.CancelAppointmentResponse, /**
   * @param {!proto.appointment_service.CancelAppointmentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.CancelAppointmentResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.CancelAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.CancelAppointmentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.CancelAppointmentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.cancelAppointment = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/CancelAppointment', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_CancelAppointment, callback);
};
/**
 * @param {!proto.appointment_service.CancelAppointmentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.CancelAppointmentResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.cancelAppointment = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/CancelAppointment', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_CancelAppointment);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.GetAppointmentCheckoutStatusRequest,
 *   !proto.appointment_service.GetAppointmentCheckoutStatusResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentCheckoutStatus = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/GetAppointmentCheckoutStatus', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.GetAppointmentCheckoutStatusRequest, $7QrRI.GetAppointmentCheckoutStatusResponse, /**
   * @param {!proto.appointment_service.GetAppointmentCheckoutStatusRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.GetAppointmentCheckoutStatusResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.GetAppointmentCheckoutStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.GetAppointmentCheckoutStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.GetAppointmentCheckoutStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.getAppointmentCheckoutStatus = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/GetAppointmentCheckoutStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentCheckoutStatus, callback);
};
/**
 * @param {!proto.appointment_service.GetAppointmentCheckoutStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.GetAppointmentCheckoutStatusResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.getAppointmentCheckoutStatus = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/GetAppointmentCheckoutStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentCheckoutStatus);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.AppointmentKeyHandOffRequest,
 *   !proto.appointment_service.AppointmentKeyHandOffResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_AppointmentKeyHandOff = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/AppointmentKeyHandOff', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.AppointmentKeyHandOffRequest, $7QrRI.AppointmentKeyHandOffResponse, /**
   * @param {!proto.appointment_service.AppointmentKeyHandOffRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.AppointmentKeyHandOffResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.AppointmentKeyHandOffRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.AppointmentKeyHandOffResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.AppointmentKeyHandOffResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.appointmentKeyHandOff = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/AppointmentKeyHandOff', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_AppointmentKeyHandOff, callback);
};
/**
 * @param {!proto.appointment_service.AppointmentKeyHandOffRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.AppointmentKeyHandOffResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.appointmentKeyHandOff = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/AppointmentKeyHandOff', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_AppointmentKeyHandOff);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.GetAppointmentKeyHandOffRequest,
 *   !proto.appointment_service.GetAppointmentKeyHandOffResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentKeyHandOff = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/GetAppointmentKeyHandOff', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.GetAppointmentKeyHandOffRequest, $7QrRI.GetAppointmentKeyHandOffResponse, /**
   * @param {!proto.appointment_service.GetAppointmentKeyHandOffRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.GetAppointmentKeyHandOffResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.GetAppointmentKeyHandOffRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.GetAppointmentKeyHandOffResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.GetAppointmentKeyHandOffResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.getAppointmentKeyHandOff = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/GetAppointmentKeyHandOff', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentKeyHandOff, callback);
};
/**
 * @param {!proto.appointment_service.GetAppointmentKeyHandOffRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.GetAppointmentKeyHandOffResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.getAppointmentKeyHandOff = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/GetAppointmentKeyHandOff', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentKeyHandOff);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.GetAppointmentPickupDateRequest,
 *   !proto.appointment_service.GetAppointmentPickupDateResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentPickupDate = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/GetAppointmentPickupDate', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.GetAppointmentPickupDateRequest, $7QrRI.GetAppointmentPickupDateResponse, /**
   * @param {!proto.appointment_service.GetAppointmentPickupDateRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.GetAppointmentPickupDateResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.GetAppointmentPickupDateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.GetAppointmentPickupDateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.GetAppointmentPickupDateResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.getAppointmentPickupDate = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/GetAppointmentPickupDate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentPickupDate, callback);
};
/**
 * @param {!proto.appointment_service.GetAppointmentPickupDateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.GetAppointmentPickupDateResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.getAppointmentPickupDate = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/GetAppointmentPickupDate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_GetAppointmentPickupDate);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.ListCompletedAppointmentsRequest,
 *   !proto.appointment_service.ListCompletedAppointmentsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_ListCompletedAppointments = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/ListCompletedAppointments', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.ListCompletedAppointmentsRequest, $7QrRI.ListCompletedAppointmentsResponse, /**
   * @param {!proto.appointment_service.ListCompletedAppointmentsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.ListCompletedAppointmentsResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.ListCompletedAppointmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.ListCompletedAppointmentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.ListCompletedAppointmentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.listCompletedAppointments = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/ListCompletedAppointments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_ListCompletedAppointments, callback);
};
/**
 * @param {!proto.appointment_service.ListCompletedAppointmentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.ListCompletedAppointmentsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.listCompletedAppointments = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/ListCompletedAppointments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_ListCompletedAppointments);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.appointment_service.GetPreAppointmentCheckoutStatusRequest,
 *   !proto.appointment_service.GetPreAppointmentCheckoutStatusResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_AppointmentService_GetPreAppointmentCheckoutStatus = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.AppointmentService/GetPreAppointmentCheckoutStatus', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $7QrRI.GetPreAppointmentCheckoutStatusRequest, $7QrRI.GetPreAppointmentCheckoutStatusResponse, /**
   * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $7QrRI.GetPreAppointmentCheckoutStatusResponse.deserializeBinary);
/**
 * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.appointment_service.GetPreAppointmentCheckoutStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServiceClient.prototype.getPreAppointmentCheckoutStatus = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.AppointmentService/GetPreAppointmentCheckoutStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_GetPreAppointmentCheckoutStatus, callback);
};
/**
 * @param {!proto.appointment_service.GetPreAppointmentCheckoutStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.appointment_service.GetPreAppointmentCheckoutStatusResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.AppointmentServicePromiseClient.prototype.getPreAppointmentCheckoutStatus = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.AppointmentService/GetPreAppointmentCheckoutStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_AppointmentService_GetPreAppointmentCheckoutStatus);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.GetFleetDealershipInfoRequest,
 *   !proto.dealership_service.GetFleetDealershipInfoResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_GetFleetDealershipInfo = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/GetFleetDealershipInfo', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.GetFleetDealershipInfoRequest, $dFFtz.GetFleetDealershipInfoResponse, /**
   * @param {!proto.dealership_service.GetFleetDealershipInfoRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.GetFleetDealershipInfoResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.GetFleetDealershipInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.GetFleetDealershipInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.GetFleetDealershipInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.getFleetDealershipInfo = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/GetFleetDealershipInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_GetFleetDealershipInfo, callback);
};
/**
 * @param {!proto.dealership_service.GetFleetDealershipInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.GetFleetDealershipInfoResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.getFleetDealershipInfo = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/GetFleetDealershipInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_GetFleetDealershipInfo);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.GetDealerUserInfoRequest,
 *   !proto.dealership_service.GetDealerUserInfoResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_GetDealerUserInfo = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/GetDealerUserInfo', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.GetDealerUserInfoRequest, $dFFtz.GetDealerUserInfoResponse, /**
   * @param {!proto.dealership_service.GetDealerUserInfoRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.GetDealerUserInfoResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.GetDealerUserInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.GetDealerUserInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.GetDealerUserInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.getDealerUserInfo = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/GetDealerUserInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_GetDealerUserInfo, callback);
};
/**
 * @param {!proto.dealership_service.GetDealerUserInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.GetDealerUserInfoResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.getDealerUserInfo = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/GetDealerUserInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_GetDealerUserInfo);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.ViewTeamRequest,
 *   !proto.dealership_service.ViewTeamResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_ViewTeam = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/ViewTeam', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.ViewTeamRequest, $dFFtz.ViewTeamResponse, /**
   * @param {!proto.dealership_service.ViewTeamRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.ViewTeamResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.ViewTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.ViewTeamResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.ViewTeamResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.viewTeam = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/ViewTeam', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_ViewTeam, callback);
};
/**
 * @param {!proto.dealership_service.ViewTeamRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.ViewTeamResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.viewTeam = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/ViewTeam', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_ViewTeam);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.ListDealershipsRequest,
 *   !proto.dealership_service.ListDealershipsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_ListDealerships = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/ListDealerships', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.ListDealershipsRequest, $dFFtz.ListDealershipsResponse, /**
   * @param {!proto.dealership_service.ListDealershipsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.ListDealershipsResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.ListDealershipsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.ListDealershipsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.ListDealershipsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.listDealerships = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/ListDealerships', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_ListDealerships, callback);
};
/**
 * @param {!proto.dealership_service.ListDealershipsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.ListDealershipsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.listDealerships = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/ListDealerships', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_ListDealerships);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.CreateDealershipRequest,
 *   !proto.dealership_service.CreateDealershipResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_CreateDealership = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/CreateDealership', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.CreateDealershipRequest, $dFFtz.CreateDealershipResponse, /**
   * @param {!proto.dealership_service.CreateDealershipRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.CreateDealershipResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.CreateDealershipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.CreateDealershipResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.CreateDealershipResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.createDealership = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/CreateDealership', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_CreateDealership, callback);
};
/**
 * @param {!proto.dealership_service.CreateDealershipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.CreateDealershipResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.createDealership = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/CreateDealership', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_CreateDealership);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.CreateDealershipUserRequest,
 *   !proto.dealership_service.CreateDealershipUserResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_CreateDealershipUser = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/CreateDealershipUser', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.CreateDealershipUserRequest, $dFFtz.CreateDealershipUserResponse, /**
   * @param {!proto.dealership_service.CreateDealershipUserRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.CreateDealershipUserResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.CreateDealershipUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.CreateDealershipUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.CreateDealershipUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.createDealershipUser = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/CreateDealershipUser', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_CreateDealershipUser, callback);
};
/**
 * @param {!proto.dealership_service.CreateDealershipUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.CreateDealershipUserResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.createDealershipUser = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/CreateDealershipUser', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_CreateDealershipUser);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.UpdateDealershipUserRequest,
 *   !proto.dealership_service.UpdateDealershipUserResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_UpdateDealershipUser = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/UpdateDealershipUser', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.UpdateDealershipUserRequest, $dFFtz.UpdateDealershipUserResponse, /**
   * @param {!proto.dealership_service.UpdateDealershipUserRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.UpdateDealershipUserResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.UpdateDealershipUserRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.UpdateDealershipUserResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.UpdateDealershipUserResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.updateDealershipUser = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/UpdateDealershipUser', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_UpdateDealershipUser, callback);
};
/**
 * @param {!proto.dealership_service.UpdateDealershipUserRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.UpdateDealershipUserResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.updateDealershipUser = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/UpdateDealershipUser', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_UpdateDealershipUser);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.DealershipUserSignaturesRequest,
 *   !proto.dealership_service.DealershipUserSignaturesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_DealershipUserSignatures = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/DealershipUserSignatures', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.DealershipUserSignaturesRequest, $dFFtz.DealershipUserSignaturesResponse, /**
   * @param {!proto.dealership_service.DealershipUserSignaturesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.DealershipUserSignaturesResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.DealershipUserSignaturesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.DealershipUserSignaturesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.DealershipUserSignaturesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.dealershipUserSignatures = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/DealershipUserSignatures', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_DealershipUserSignatures, callback);
};
/**
 * @param {!proto.dealership_service.DealershipUserSignaturesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.DealershipUserSignaturesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.dealershipUserSignatures = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/DealershipUserSignatures', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_DealershipUserSignatures);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.UpdateDealershipRequest,
 *   !proto.dealership_service.UpdateDealershipResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_UpdateDealership = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/UpdateDealership', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.UpdateDealershipRequest, $dFFtz.UpdateDealershipResponse, /**
   * @param {!proto.dealership_service.UpdateDealershipRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.UpdateDealershipResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.UpdateDealershipRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.UpdateDealershipResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.UpdateDealershipResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.updateDealership = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/UpdateDealership', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_UpdateDealership, callback);
};
/**
 * @param {!proto.dealership_service.UpdateDealershipRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.UpdateDealershipResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.updateDealership = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/UpdateDealership', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_UpdateDealership);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.dealership_service.GetSelfRequest,
 *   !proto.dealership_service.GetSelfResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DealershipService_GetDealershipUserSelf = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DealershipService/GetDealershipUserSelf', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dFFtz.GetSelfRequest, $dFFtz.GetSelfResponse, /**
   * @param {!proto.dealership_service.GetSelfRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dFFtz.GetSelfResponse.deserializeBinary);
/**
 * @param {!proto.dealership_service.GetSelfRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.dealership_service.GetSelfResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.dealership_service.GetSelfResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServiceClient.prototype.getDealershipUserSelf = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DealershipService/GetDealershipUserSelf', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_GetDealershipUserSelf, callback);
};
/**
 * @param {!proto.dealership_service.GetSelfRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.dealership_service.GetSelfResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DealershipServicePromiseClient.prototype.getDealershipUserSelf = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DealershipService/GetDealershipUserSelf', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DealershipService_GetDealershipUserSelf);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.CommunicationServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.CommunicationServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.communication_service.OptOutRequest,
 *   !proto.communication_service.OptOutResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CommunicationService_OptOut = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CommunicationService/OptOut', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $an37o.OptOutRequest, $an37o.OptOutResponse, /**
   * @param {!proto.communication_service.OptOutRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $an37o.OptOutResponse.deserializeBinary);
/**
 * @param {!proto.communication_service.OptOutRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.communication_service.OptOutResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.communication_service.OptOutResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CommunicationServiceClient.prototype.optOut = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CommunicationService/OptOut', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CommunicationService_OptOut, callback);
};
/**
 * @param {!proto.communication_service.OptOutRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.communication_service.OptOutResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CommunicationServicePromiseClient.prototype.optOut = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CommunicationService/OptOut', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CommunicationService_OptOut);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.communication_service.UpsertCustomerDeviceRequest,
 *   !proto.communication_service.UpsertCustomerDeviceResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CommunicationService_UpsertCustomerDevice = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CommunicationService/UpsertCustomerDevice', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $an37o.UpsertCustomerDeviceRequest, $an37o.UpsertCustomerDeviceResponse, /**
   * @param {!proto.communication_service.UpsertCustomerDeviceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $an37o.UpsertCustomerDeviceResponse.deserializeBinary);
/**
 * @param {!proto.communication_service.UpsertCustomerDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.communication_service.UpsertCustomerDeviceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.communication_service.UpsertCustomerDeviceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CommunicationServiceClient.prototype.upsertCustomerDevice = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CommunicationService/UpsertCustomerDevice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CommunicationService_UpsertCustomerDevice, callback);
};
/**
 * @param {!proto.communication_service.UpsertCustomerDeviceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.communication_service.UpsertCustomerDeviceResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CommunicationServicePromiseClient.prototype.upsertCustomerDevice = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CommunicationService/UpsertCustomerDevice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CommunicationService_UpsertCustomerDevice);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.communication_service.SendPushRequest,
 *   !proto.communication_service.SendPushResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CommunicationService_SendPush = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CommunicationService/SendPush', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $an37o.SendPushRequest, $an37o.SendPushResponse, /**
   * @param {!proto.communication_service.SendPushRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $an37o.SendPushResponse.deserializeBinary);
/**
 * @param {!proto.communication_service.SendPushRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.communication_service.SendPushResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.communication_service.SendPushResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CommunicationServiceClient.prototype.sendPush = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CommunicationService/SendPush', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CommunicationService_SendPush, callback);
};
/**
 * @param {!proto.communication_service.SendPushRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.communication_service.SendPushResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CommunicationServicePromiseClient.prototype.sendPush = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CommunicationService/SendPush', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CommunicationService_SendPush);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.ContractServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.ContractServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.contract_service.AddTemplateRequest,
 *   !proto.contract_service.AddTemplateResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_ContractService_AddTemplate = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.ContractService/AddTemplate', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $k1gxg.AddTemplateRequest, $k1gxg.AddTemplateResponse, /**
   * @param {!proto.contract_service.AddTemplateRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $k1gxg.AddTemplateResponse.deserializeBinary);
/**
 * @param {!proto.contract_service.AddTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.contract_service.AddTemplateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.contract_service.AddTemplateResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.ContractServiceClient.prototype.addTemplate = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.ContractService/AddTemplate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_ContractService_AddTemplate, callback);
};
/**
 * @param {!proto.contract_service.AddTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.contract_service.AddTemplateResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.ContractServicePromiseClient.prototype.addTemplate = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.ContractService/AddTemplate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_ContractService_AddTemplate);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.SendDeepLinkRequest,
 *   !proto.customer_service.SendDeepLinkResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_CreateCustomerAndSendDeepLink = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/CreateCustomerAndSendDeepLink', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.SendDeepLinkRequest, $6EauF.SendDeepLinkResponse, /**
   * @param {!proto.customer_service.SendDeepLinkRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.SendDeepLinkResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.SendDeepLinkRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.SendDeepLinkResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.SendDeepLinkResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.createCustomerAndSendDeepLink = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/CreateCustomerAndSendDeepLink', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_CreateCustomerAndSendDeepLink, callback);
};
/**
 * @param {!proto.customer_service.SendDeepLinkRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.SendDeepLinkResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.createCustomerAndSendDeepLink = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/CreateCustomerAndSendDeepLink', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_CreateCustomerAndSendDeepLink);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.CreateCustomerRequest,
 *   !proto.customer_service.CreateCustomerResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_CreateCustomer = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/CreateCustomer', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.CreateCustomerRequest, $6EauF.CreateCustomerResponse, /**
   * @param {!proto.customer_service.CreateCustomerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.CreateCustomerResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.CreateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.CreateCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.CreateCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.createCustomer = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/CreateCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_CreateCustomer, callback);
};
/**
 * @param {!proto.customer_service.CreateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.CreateCustomerResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.createCustomer = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/CreateCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_CreateCustomer);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetCustomerByAccountNumberRequest,
 *   !proto.customer_service.GetCustomerByAccountNumberResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetCustomerByAccountNumber = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetCustomerByAccountNumber', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetCustomerByAccountNumberRequest, $6EauF.GetCustomerByAccountNumberResponse, /**
   * @param {!proto.customer_service.GetCustomerByAccountNumberRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetCustomerByAccountNumberResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetCustomerByAccountNumberRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetCustomerByAccountNumberResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetCustomerByAccountNumberResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getCustomerByAccountNumber = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetCustomerByAccountNumber', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetCustomerByAccountNumber, callback);
};
/**
 * @param {!proto.customer_service.GetCustomerByAccountNumberRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetCustomerByAccountNumberResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getCustomerByAccountNumber = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetCustomerByAccountNumber', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetCustomerByAccountNumber);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.SubscribeToActivationRequest,
 *   !proto.customer_service.ActivationState>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_SubscribeToActivation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/SubscribeToActivation', $df70feab7068291e$var$grpc.web.MethodType.SERVER_STREAMING, $6EauF.SubscribeToActivationRequest, $6EauF.ActivationState, /**
   * @param {!proto.customer_service.SubscribeToActivationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.ActivationState.deserializeBinary);
/**
 * @param {!proto.customer_service.SubscribeToActivationRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.ActivationState>}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.subscribeToActivation = function(request, metadata) {
    return this.client_.serverStreaming(this.hostname_ + '/gateway_service.CustomerService/SubscribeToActivation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SubscribeToActivation);
};
/**
 * @param {!proto.customer_service.SubscribeToActivationRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.ActivationState>}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.subscribeToActivation = function(request, metadata) {
    return this.client_.serverStreaming(this.hostname_ + '/gateway_service.CustomerService/SubscribeToActivation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SubscribeToActivation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.QualificationRequest,
 *   !proto.customer_service.QualificationResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_Qualify = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/Qualify', $df70feab7068291e$var$grpc.web.MethodType.SERVER_STREAMING, $6EauF.QualificationRequest, $6EauF.QualificationResponse, /**
   * @param {!proto.customer_service.QualificationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.QualificationResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.QualificationRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.QualificationResponse>}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.qualify = function(request, metadata) {
    return this.client_.serverStreaming(this.hostname_ + '/gateway_service.CustomerService/Qualify', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_Qualify);
};
/**
 * @param {!proto.customer_service.QualificationRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.QualificationResponse>}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.qualify = function(request, metadata) {
    return this.client_.serverStreaming(this.hostname_ + '/gateway_service.CustomerService/Qualify', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_Qualify);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.SendOTPRequest,
 *   !proto.customer_service.SendOTPResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_SendOTP = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/SendOTP', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.SendOTPRequest, $6EauF.SendOTPResponse, /**
   * @param {!proto.customer_service.SendOTPRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.SendOTPResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.SendOTPRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.SendOTPResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.SendOTPResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.sendOTP = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/SendOTP', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SendOTP, callback);
};
/**
 * @param {!proto.customer_service.SendOTPRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.SendOTPResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.sendOTP = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/SendOTP', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SendOTP);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.VerifyOTPRequest,
 *   !proto.customer_service.VerifyOTPResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_VerifyOTP = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/VerifyOTP', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.VerifyOTPRequest, $6EauF.VerifyOTPResponse, /**
   * @param {!proto.customer_service.VerifyOTPRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.VerifyOTPResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.VerifyOTPRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.VerifyOTPResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.VerifyOTPResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.verifyOTP = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/VerifyOTP', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_VerifyOTP, callback);
};
/**
 * @param {!proto.customer_service.VerifyOTPRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.VerifyOTPResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.verifyOTP = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/VerifyOTP', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_VerifyOTP);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.SubmitLicenseInfoRequest,
 *   !proto.customer_service.SubmitLicenseInfoResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitLicenseInfo = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/SubmitLicenseInfo', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.SubmitLicenseInfoRequest, $6EauF.SubmitLicenseInfoResponse, /**
   * @param {!proto.customer_service.SubmitLicenseInfoRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.SubmitLicenseInfoResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.SubmitLicenseInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.SubmitLicenseInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.SubmitLicenseInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.submitLicenseInfo = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/SubmitLicenseInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitLicenseInfo, callback);
};
/**
 * @param {!proto.customer_service.SubmitLicenseInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.SubmitLicenseInfoResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.submitLicenseInfo = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/SubmitLicenseInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitLicenseInfo);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.SubmitSelfiePhotoRequest,
 *   !proto.customer_service.SubmitSelfiePhotoResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitSelfiePhoto = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/SubmitSelfiePhoto', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.SubmitSelfiePhotoRequest, $6EauF.SubmitSelfiePhotoResponse, /**
   * @param {!proto.customer_service.SubmitSelfiePhotoRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.SubmitSelfiePhotoResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.SubmitSelfiePhotoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.SubmitSelfiePhotoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.SubmitSelfiePhotoResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.submitSelfiePhoto = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/SubmitSelfiePhoto', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitSelfiePhoto, callback);
};
/**
 * @param {!proto.customer_service.SubmitSelfiePhotoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.SubmitSelfiePhotoResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.submitSelfiePhoto = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/SubmitSelfiePhoto', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitSelfiePhoto);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.SubmitLicensePhotosRequest,
 *   !proto.customer_service.SubmitLicensePhotosResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitLicensePhotos = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/SubmitLicensePhotos', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.SubmitLicensePhotosRequest, $6EauF.SubmitLicensePhotosResponse, /**
   * @param {!proto.customer_service.SubmitLicensePhotosRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.SubmitLicensePhotosResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.SubmitLicensePhotosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.SubmitLicensePhotosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.SubmitLicensePhotosResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.submitLicensePhotos = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/SubmitLicensePhotos', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitLicensePhotos, callback);
};
/**
 * @param {!proto.customer_service.SubmitLicensePhotosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.SubmitLicensePhotosResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.submitLicensePhotos = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/SubmitLicensePhotos', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SubmitLicensePhotos);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetImageUploadURIRequest,
 *   !proto.customer_service.GetImageUploadURIResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetImageUploadURI = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetImageUploadURI', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetImageUploadURIRequest, $6EauF.GetImageUploadURIResponse, /**
   * @param {!proto.customer_service.GetImageUploadURIRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetImageUploadURIResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetImageUploadURIRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetImageUploadURIResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetImageUploadURIResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getImageUploadURI = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetImageUploadURI', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetImageUploadURI, callback);
};
/**
 * @param {!proto.customer_service.GetImageUploadURIRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetImageUploadURIResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getImageUploadURI = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetImageUploadURI', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetImageUploadURI);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.SetActivityRequest,
 *   !proto.customer_service.SetActivityResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_SetActivity = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/SetActivity', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.SetActivityRequest, $6EauF.SetActivityResponse, /**
   * @param {!proto.customer_service.SetActivityRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.SetActivityResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.SetActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.SetActivityResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.SetActivityResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.setActivity = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/SetActivity', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SetActivity, callback);
};
/**
 * @param {!proto.customer_service.SetActivityRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.SetActivityResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.setActivity = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/SetActivity', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_SetActivity);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetSelfRequest,
 *   !proto.customer_service.GetSelfResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetSelf = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetSelf', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetSelfRequest, $6EauF.GetSelfResponse, /**
   * @param {!proto.customer_service.GetSelfRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetSelfResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetSelfRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetSelfResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetSelfResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getSelf = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetSelf', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetSelf, callback);
};
/**
 * @param {!proto.customer_service.GetSelfRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetSelfResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getSelf = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetSelf', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetSelf);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetStateRequest,
 *   !proto.customer_service.GetStateResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetState = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetState', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetStateRequest, $6EauF.GetStateResponse, /**
   * @param {!proto.customer_service.GetStateRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetStateResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetStateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetStateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetStateResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getState = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetState', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetState, callback);
};
/**
 * @param {!proto.customer_service.GetStateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetStateResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getState = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetState', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetState);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetAddressesRequest,
 *   !proto.customer_service.GetAddressesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetAddresses = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetAddresses', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetAddressesRequest, $6EauF.GetAddressesResponse, /**
   * @param {!proto.customer_service.GetAddressesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetAddressesResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetAddressesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetAddressesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetAddressesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getAddresses = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetAddresses', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetAddresses, callback);
};
/**
 * @param {!proto.customer_service.GetAddressesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetAddressesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getAddresses = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetAddresses', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetAddresses);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetOwnAddressesRequest,
 *   !proto.customer_service.GetAddressesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetOwnAddresses = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetOwnAddresses', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetOwnAddressesRequest, $6EauF.GetAddressesResponse, /**
   * @param {!proto.customer_service.GetOwnAddressesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetAddressesResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetOwnAddressesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetAddressesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetAddressesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getOwnAddresses = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetOwnAddresses', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetOwnAddresses, callback);
};
/**
 * @param {!proto.customer_service.GetOwnAddressesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetAddressesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getOwnAddresses = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetOwnAddresses', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetOwnAddresses);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetInsurancePoliciesRequest,
 *   !proto.customer_service.GetInsurancePoliciesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetInsurancePolicies = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetInsurancePolicies', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetInsurancePoliciesRequest, $6EauF.GetInsurancePoliciesResponse, /**
   * @param {!proto.customer_service.GetInsurancePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetInsurancePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetInsurancePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetInsurancePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getInsurancePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetInsurancePolicies', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetInsurancePolicies, callback);
};
/**
 * @param {!proto.customer_service.GetInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetInsurancePoliciesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getInsurancePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetInsurancePolicies', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetInsurancePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetImagesRequest,
 *   !proto.customer_service.GetImagesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetImages = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetImages', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetImagesRequest, $6EauF.GetImagesResponse, /**
   * @param {!proto.customer_service.GetImagesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetImagesResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetImagesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetImagesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetImagesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getImages = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetImages', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetImages, callback);
};
/**
 * @param {!proto.customer_service.GetImagesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetImagesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getImages = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetImages', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetImages);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.UpdateEmailRequest,
 *   !proto.customer_service.UpdateEmailResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateEmail = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/UpdateEmail', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.UpdateEmailRequest, $6EauF.UpdateEmailResponse, /**
   * @param {!proto.customer_service.UpdateEmailRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.UpdateEmailResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.UpdateEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.UpdateEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.UpdateEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.updateEmail = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/UpdateEmail', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateEmail, callback);
};
/**
 * @param {!proto.customer_service.UpdateEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.UpdateEmailResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.updateEmail = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/UpdateEmail', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateEmail);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.UpsertInsurancePoliciesRequest,
 *   !proto.customer_service.UpsertInsurancePoliciesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertInsurancePolicies = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/UpsertInsurancePolicies', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.UpsertInsurancePoliciesRequest, $6EauF.UpsertInsurancePoliciesResponse, /**
   * @param {!proto.customer_service.UpsertInsurancePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.UpsertInsurancePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.UpsertInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.UpsertInsurancePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.UpsertInsurancePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.upsertInsurancePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/UpsertInsurancePolicies', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertInsurancePolicies, callback);
};
/**
 * @param {!proto.customer_service.UpsertInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.UpsertInsurancePoliciesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.upsertInsurancePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/UpsertInsurancePolicies', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertInsurancePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.UpsertAddressesRequest,
 *   !proto.customer_service.UpsertAddressesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertAddresses = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/UpsertAddresses', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.UpsertAddressesRequest, $6EauF.UpsertAddressesResponse, /**
   * @param {!proto.customer_service.UpsertAddressesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.UpsertAddressesResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.UpsertAddressesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.UpsertAddressesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.UpsertAddressesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.upsertAddresses = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/UpsertAddresses', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertAddresses, callback);
};
/**
 * @param {!proto.customer_service.UpsertAddressesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.UpsertAddressesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.upsertAddresses = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/UpsertAddresses', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertAddresses);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.UpsertOwnAddressesRequest,
 *   !proto.customer_service.UpsertAddressesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertOwnAddresses = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/UpsertOwnAddresses', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.UpsertOwnAddressesRequest, $6EauF.UpsertAddressesResponse, /**
   * @param {!proto.customer_service.UpsertOwnAddressesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.UpsertAddressesResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.UpsertOwnAddressesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.UpsertAddressesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.UpsertAddressesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.upsertOwnAddresses = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/UpsertOwnAddresses', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertOwnAddresses, callback);
};
/**
 * @param {!proto.customer_service.UpsertOwnAddressesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.UpsertAddressesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.upsertOwnAddresses = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/UpsertOwnAddresses', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpsertOwnAddresses);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.GetCustomerByIDRequest,
 *   !proto.customer_service.GetCustomerByIDResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_GetCustomerByID = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/GetCustomerByID', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.GetCustomerByIDRequest, $6EauF.GetCustomerByIDResponse, /**
   * @param {!proto.customer_service.GetCustomerByIDRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.GetCustomerByIDResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.GetCustomerByIDRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.GetCustomerByIDResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.GetCustomerByIDResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.getCustomerByID = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/GetCustomerByID', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetCustomerByID, callback);
};
/**
 * @param {!proto.customer_service.GetCustomerByIDRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.GetCustomerByIDResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.getCustomerByID = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/GetCustomerByID', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_GetCustomerByID);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.ValidateClientRequest,
 *   !proto.customer_service.ValidateClientResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_ValidateClient = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/ValidateClient', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.ValidateClientRequest, $6EauF.ValidateClientResponse, /**
   * @param {!proto.customer_service.ValidateClientRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.ValidateClientResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.ValidateClientRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.ValidateClientResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.ValidateClientResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.validateClient = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/ValidateClient', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_ValidateClient, callback);
};
/**
 * @param {!proto.customer_service.ValidateClientRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.ValidateClientResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.validateClient = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/ValidateClient', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_ValidateClient);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.ExistsByPhoneRequest,
 *   !proto.customer_service.ExistsByPhoneResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_ExistsByPhone = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/ExistsByPhone', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.ExistsByPhoneRequest, $6EauF.ExistsByPhoneResponse, /**
   * @param {!proto.customer_service.ExistsByPhoneRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.ExistsByPhoneResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.ExistsByPhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.ExistsByPhoneResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.ExistsByPhoneResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.existsByPhone = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/ExistsByPhone', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_ExistsByPhone, callback);
};
/**
 * @param {!proto.customer_service.ExistsByPhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.ExistsByPhoneResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.existsByPhone = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/ExistsByPhone', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_ExistsByPhone);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.RecalculateQualificationRequest,
 *   !proto.customer_service.RecalculateQualificationResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_RecalculateQualification = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/RecalculateQualification', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.RecalculateQualificationRequest, $6EauF.RecalculateQualificationResponse, /**
   * @param {!proto.customer_service.RecalculateQualificationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.RecalculateQualificationResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.RecalculateQualificationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.RecalculateQualificationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.RecalculateQualificationResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.recalculateQualification = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/RecalculateQualification', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_RecalculateQualification, callback);
};
/**
 * @param {!proto.customer_service.RecalculateQualificationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.RecalculateQualificationResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.recalculateQualification = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/RecalculateQualification', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_RecalculateQualification);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.ResetLoginAttemptsRequest,
 *   !proto.customer_service.ResetLoginAttemptsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_ResetLoginAttempts = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/ResetLoginAttempts', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.ResetLoginAttemptsRequest, $6EauF.ResetLoginAttemptsResponse, /**
   * @param {!proto.customer_service.ResetLoginAttemptsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.ResetLoginAttemptsResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.ResetLoginAttemptsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.ResetLoginAttemptsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.ResetLoginAttemptsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.resetLoginAttempts = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/ResetLoginAttempts', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_ResetLoginAttempts, callback);
};
/**
 * @param {!proto.customer_service.ResetLoginAttemptsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.ResetLoginAttemptsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.resetLoginAttempts = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/ResetLoginAttempts', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_ResetLoginAttempts);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.UpdateCustomerWithFakePhoneRequest,
 *   !proto.customer_service.UpdateCustomerWithFakePhoneResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateCustomerWithFakePhone = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/UpdateCustomerWithFakePhone', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.UpdateCustomerWithFakePhoneRequest, $6EauF.UpdateCustomerWithFakePhoneResponse, /**
   * @param {!proto.customer_service.UpdateCustomerWithFakePhoneRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.UpdateCustomerWithFakePhoneResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.UpdateCustomerWithFakePhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.UpdateCustomerWithFakePhoneResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.UpdateCustomerWithFakePhoneResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.updateCustomerWithFakePhone = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/UpdateCustomerWithFakePhone', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateCustomerWithFakePhone, callback);
};
/**
 * @param {!proto.customer_service.UpdateCustomerWithFakePhoneRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.UpdateCustomerWithFakePhoneResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.updateCustomerWithFakePhone = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/UpdateCustomerWithFakePhone', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateCustomerWithFakePhone);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.UpdateCustomerRequest,
 *   !proto.customer_service.UpdateCustomerResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateCustomer = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/UpdateCustomer', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.UpdateCustomerRequest, $6EauF.UpdateCustomerResponse, /**
   * @param {!proto.customer_service.UpdateCustomerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.UpdateCustomerResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.UpdateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.UpdateCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.UpdateCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.updateCustomer = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/UpdateCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateCustomer, callback);
};
/**
 * @param {!proto.customer_service.UpdateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.UpdateCustomerResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.updateCustomer = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/UpdateCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_UpdateCustomer);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_service.ListCustomersRequest,
 *   !proto.customer_service.ListCustomersResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerService_ListCustomers = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerService/ListCustomers', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $6EauF.ListCustomersRequest, $6EauF.ListCustomersResponse, /**
   * @param {!proto.customer_service.ListCustomersRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $6EauF.ListCustomersResponse.deserializeBinary);
/**
 * @param {!proto.customer_service.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_service.ListCustomersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_service.ListCustomersResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServiceClient.prototype.listCustomers = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerService/ListCustomers', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_ListCustomers, callback);
};
/**
 * @param {!proto.customer_service.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_service.ListCustomersResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerServicePromiseClient.prototype.listCustomers = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerService/ListCustomers', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerService_ListCustomers);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.GetPermissionsRequest,
 *   !proto.customer_support_service.Permissions>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetPermissions = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/GetPermissions', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.GetPermissionsRequest, $g1LOb.Permissions, /**
   * @param {!proto.customer_support_service.GetPermissionsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $g1LOb.Permissions.deserializeBinary);
/**
 * @param {!proto.customer_support_service.GetPermissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_support_service.Permissions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_support_service.Permissions>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.getPermissions = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetPermissions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetPermissions, callback);
};
/**
 * @param {!proto.customer_support_service.GetPermissionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_support_service.Permissions>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.getPermissions = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetPermissions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetPermissions);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.CustomerIdentity,
 *   !proto.domain.Customer>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomer = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/GetCustomer', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.CustomerIdentity, $3QqPt.Customer, /**
   * @param {!proto.customer_support_service.CustomerIdentity} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3QqPt.Customer.deserializeBinary);
/**
 * @param {!proto.customer_support_service.CustomerIdentity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.domain.Customer)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.domain.Customer>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.getCustomer = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomer, callback);
};
/**
 * @param {!proto.customer_support_service.CustomerIdentity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.domain.Customer>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.getCustomer = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomer);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.CustomerIdentity,
 *   !proto.customer_support_service.CustomerInfo>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerInfo = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/GetCustomerInfo', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.CustomerIdentity, $g1LOb.CustomerInfo, /**
   * @param {!proto.customer_support_service.CustomerIdentity} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $g1LOb.CustomerInfo.deserializeBinary);
/**
 * @param {!proto.customer_support_service.CustomerIdentity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_support_service.CustomerInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_support_service.CustomerInfo>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.getCustomerInfo = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetCustomerInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerInfo, callback);
};
/**
 * @param {!proto.customer_support_service.CustomerIdentity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_support_service.CustomerInfo>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.getCustomerInfo = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetCustomerInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerInfo);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.UpdateCustomerInfoRequest,
 *   !proto.customer_support_service.UpdateCustomerInfoResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerInfo = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/UpdateCustomerInfo', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.UpdateCustomerInfoRequest, $g1LOb.UpdateCustomerInfoResponse, /**
   * @param {!proto.customer_support_service.UpdateCustomerInfoRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $g1LOb.UpdateCustomerInfoResponse.deserializeBinary);
/**
 * @param {!proto.customer_support_service.UpdateCustomerInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_support_service.UpdateCustomerInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_support_service.UpdateCustomerInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.updateCustomerInfo = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/UpdateCustomerInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerInfo, callback);
};
/**
 * @param {!proto.customer_support_service.UpdateCustomerInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_support_service.UpdateCustomerInfoResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.updateCustomerInfo = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/UpdateCustomerInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerInfo);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.UpdateCustomerGarageAddressRequest,
 *   !proto.customer_support_service.UpdateCustomerGarageAddressResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerGarageAddress = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/UpdateCustomerGarageAddress', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.UpdateCustomerGarageAddressRequest, $g1LOb.UpdateCustomerGarageAddressResponse, /**
   * @param {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $g1LOb.UpdateCustomerGarageAddressResponse.deserializeBinary);
/**
 * @param {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_support_service.UpdateCustomerGarageAddressResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_support_service.UpdateCustomerGarageAddressResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.updateCustomerGarageAddress = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/UpdateCustomerGarageAddress', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerGarageAddress, callback);
};
/**
 * @param {!proto.customer_support_service.UpdateCustomerGarageAddressRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_support_service.UpdateCustomerGarageAddressResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.updateCustomerGarageAddress = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/UpdateCustomerGarageAddress', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerGarageAddress);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.CustomerIdentity,
 *   !proto.customer_support_service.CustomerInsuranceInfo>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerInsuranceInfo = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/GetCustomerInsuranceInfo', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.CustomerIdentity, $g1LOb.CustomerInsuranceInfo, /**
   * @param {!proto.customer_support_service.CustomerIdentity} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $g1LOb.CustomerInsuranceInfo.deserializeBinary);
/**
 * @param {!proto.customer_support_service.CustomerIdentity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_support_service.CustomerInsuranceInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_support_service.CustomerInsuranceInfo>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.getCustomerInsuranceInfo = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetCustomerInsuranceInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerInsuranceInfo, callback);
};
/**
 * @param {!proto.customer_support_service.CustomerIdentity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_support_service.CustomerInsuranceInfo>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.getCustomerInsuranceInfo = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetCustomerInsuranceInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerInsuranceInfo);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.UpdateCustomerInsuranceInfoRequest,
 *   !proto.customer_support_service.CustomerInsuranceInfo>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerInsuranceInfo = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/UpdateCustomerInsuranceInfo', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.UpdateCustomerInsuranceInfoRequest, $g1LOb.CustomerInsuranceInfo, /**
   * @param {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $g1LOb.CustomerInsuranceInfo.deserializeBinary);
/**
 * @param {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_support_service.CustomerInsuranceInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_support_service.CustomerInsuranceInfo>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.updateCustomerInsuranceInfo = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/UpdateCustomerInsuranceInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerInsuranceInfo, callback);
};
/**
 * @param {!proto.customer_support_service.UpdateCustomerInsuranceInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_support_service.CustomerInsuranceInfo>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.updateCustomerInsuranceInfo = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/UpdateCustomerInsuranceInfo', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_UpdateCustomerInsuranceInfo);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.CustomerIdentity,
 *   !proto.customer_support_service.CustomerSubscriptions>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerSubscriptions = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/GetCustomerSubscriptions', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.CustomerIdentity, $g1LOb.CustomerSubscriptions, /**
   * @param {!proto.customer_support_service.CustomerIdentity} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $g1LOb.CustomerSubscriptions.deserializeBinary);
/**
 * @param {!proto.customer_support_service.CustomerIdentity} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_support_service.CustomerSubscriptions)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_support_service.CustomerSubscriptions>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.getCustomerSubscriptions = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetCustomerSubscriptions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerSubscriptions, callback);
};
/**
 * @param {!proto.customer_support_service.CustomerIdentity} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_support_service.CustomerSubscriptions>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.getCustomerSubscriptions = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/GetCustomerSubscriptions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_GetCustomerSubscriptions);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.customer_support_service.WipeTwilioFactorsRequest,
 *   !proto.customer_support_service.WipeTwilioFactorsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSupportService_WipeTwilioFactors = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSupportService/WipeTwilioFactors', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $g1LOb.WipeTwilioFactorsRequest, $g1LOb.WipeTwilioFactorsResponse, /**
   * @param {!proto.customer_support_service.WipeTwilioFactorsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $g1LOb.WipeTwilioFactorsResponse.deserializeBinary);
/**
 * @param {!proto.customer_support_service.WipeTwilioFactorsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.customer_support_service.WipeTwilioFactorsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.customer_support_service.WipeTwilioFactorsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServiceClient.prototype.wipeTwilioFactors = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSupportService/WipeTwilioFactors', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_WipeTwilioFactors, callback);
};
/**
 * @param {!proto.customer_support_service.WipeTwilioFactorsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.customer_support_service.WipeTwilioFactorsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSupportServicePromiseClient.prototype.wipeTwilioFactors = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSupportService/WipeTwilioFactors', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSupportService_WipeTwilioFactors);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.PayByTokenRequest,
 *   !proto.payment_service.PayByTokenResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_PayByToken = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/PayByToken', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.PayByTokenRequest, $8ilIL.PayByTokenResponse, /**
   * @param {!proto.payment_service.PayByTokenRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.PayByTokenResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.PayByTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.PayByTokenResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.PayByTokenResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.payByToken = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/PayByToken', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_PayByToken, callback);
};
/**
 * @param {!proto.payment_service.PayByTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.PayByTokenResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.payByToken = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/PayByToken', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_PayByToken);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.ListOwnPaymentsRequest,
 *   !proto.payment_service.ListPaymentsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_ListOwnPayments = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/ListOwnPayments', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.ListOwnPaymentsRequest, $8ilIL.ListPaymentsResponse, /**
   * @param {!proto.payment_service.ListOwnPaymentsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.ListPaymentsResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.ListOwnPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.ListPaymentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.ListPaymentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.listOwnPayments = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/ListOwnPayments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_ListOwnPayments, callback);
};
/**
 * @param {!proto.payment_service.ListOwnPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.ListPaymentsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.listOwnPayments = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/ListOwnPayments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_ListOwnPayments);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.ListPaymentsRequest,
 *   !proto.payment_service.ListPaymentsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_ListPayments = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/ListPayments', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.ListPaymentsRequest, $8ilIL.ListPaymentsResponse, /**
   * @param {!proto.payment_service.ListPaymentsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.ListPaymentsResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.ListPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.ListPaymentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.ListPaymentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.listPayments = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/ListPayments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_ListPayments, callback);
};
/**
 * @param {!proto.payment_service.ListPaymentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.ListPaymentsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.listPayments = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/ListPayments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_ListPayments);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.ScheduledPickupRequest,
 *   !proto.payment_service.ScheduledPickupResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_SubmitScheduledPickupDate = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/SubmitScheduledPickupDate', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.ScheduledPickupRequest, $8ilIL.ScheduledPickupResponse, /**
   * @param {!proto.payment_service.ScheduledPickupRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.ScheduledPickupResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.ScheduledPickupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.ScheduledPickupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.ScheduledPickupResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.submitScheduledPickupDate = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/SubmitScheduledPickupDate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_SubmitScheduledPickupDate, callback);
};
/**
 * @param {!proto.payment_service.ScheduledPickupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.ScheduledPickupResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.submitScheduledPickupDate = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/SubmitScheduledPickupDate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_SubmitScheduledPickupDate);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.PaymentsVendorTokenRequest,
 *   !proto.payment_service.PaymentsVendorToken>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_GetPaymentsVendorToken = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/GetPaymentsVendorToken', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.PaymentsVendorTokenRequest, $8ilIL.PaymentsVendorToken, /**
   * @param {!proto.payment_service.PaymentsVendorTokenRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.PaymentsVendorToken.deserializeBinary);
/**
 * @param {!proto.payment_service.PaymentsVendorTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.PaymentsVendorToken)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.PaymentsVendorToken>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.getPaymentsVendorToken = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/GetPaymentsVendorToken', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_GetPaymentsVendorToken, callback);
};
/**
 * @param {!proto.payment_service.PaymentsVendorTokenRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.PaymentsVendorToken>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.getPaymentsVendorToken = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/GetPaymentsVendorToken', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_GetPaymentsVendorToken);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.GetOwnPrimaryPaymentMethodRequest,
 *   !proto.payment_service.GetPrimaryPaymentMethodResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_GetOwnPrimaryPaymentMethod = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/GetOwnPrimaryPaymentMethod', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.GetOwnPrimaryPaymentMethodRequest, $8ilIL.GetPrimaryPaymentMethodResponse, /**
   * @param {!proto.payment_service.GetOwnPrimaryPaymentMethodRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.GetPrimaryPaymentMethodResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.GetOwnPrimaryPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.GetPrimaryPaymentMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.GetPrimaryPaymentMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.getOwnPrimaryPaymentMethod = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/GetOwnPrimaryPaymentMethod', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_GetOwnPrimaryPaymentMethod, callback);
};
/**
 * @param {!proto.payment_service.GetOwnPrimaryPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.GetPrimaryPaymentMethodResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.getOwnPrimaryPaymentMethod = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/GetOwnPrimaryPaymentMethod', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_GetOwnPrimaryPaymentMethod);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.GetPrimaryPaymentMethodRequest,
 *   !proto.payment_service.GetPrimaryPaymentMethodResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_GetPrimaryPaymentMethod = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/GetPrimaryPaymentMethod', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.GetPrimaryPaymentMethodRequest, $8ilIL.GetPrimaryPaymentMethodResponse, /**
   * @param {!proto.payment_service.GetPrimaryPaymentMethodRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.GetPrimaryPaymentMethodResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.GetPrimaryPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.GetPrimaryPaymentMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.GetPrimaryPaymentMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.getPrimaryPaymentMethod = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/GetPrimaryPaymentMethod', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_GetPrimaryPaymentMethod, callback);
};
/**
 * @param {!proto.payment_service.GetPrimaryPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.GetPrimaryPaymentMethodResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.getPrimaryPaymentMethod = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/GetPrimaryPaymentMethod', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_GetPrimaryPaymentMethod);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.SetOwnPrimaryPaymentMethodRequest,
 *   !proto.payment_service.SetPrimaryPaymentMethodResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_SetOwnPrimaryPaymentMethod = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/SetOwnPrimaryPaymentMethod', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.SetOwnPrimaryPaymentMethodRequest, $8ilIL.SetPrimaryPaymentMethodResponse, /**
   * @param {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.SetPrimaryPaymentMethodResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.SetPrimaryPaymentMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.SetPrimaryPaymentMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.setOwnPrimaryPaymentMethod = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/SetOwnPrimaryPaymentMethod', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_SetOwnPrimaryPaymentMethod, callback);
};
/**
 * @param {!proto.payment_service.SetOwnPrimaryPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.SetPrimaryPaymentMethodResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.setOwnPrimaryPaymentMethod = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/SetOwnPrimaryPaymentMethod', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_SetOwnPrimaryPaymentMethod);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.SetPrimaryPaymentMethodRequest,
 *   !proto.payment_service.SetPrimaryPaymentMethodResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_SetPrimaryPaymentMethod = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/SetPrimaryPaymentMethod', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.SetPrimaryPaymentMethodRequest, $8ilIL.SetPrimaryPaymentMethodResponse, /**
   * @param {!proto.payment_service.SetPrimaryPaymentMethodRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.SetPrimaryPaymentMethodResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.SetPrimaryPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.SetPrimaryPaymentMethodResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.SetPrimaryPaymentMethodResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.setPrimaryPaymentMethod = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/SetPrimaryPaymentMethod', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_SetPrimaryPaymentMethod, callback);
};
/**
 * @param {!proto.payment_service.SetPrimaryPaymentMethodRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.SetPrimaryPaymentMethodResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.setPrimaryPaymentMethod = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/SetPrimaryPaymentMethod', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_SetPrimaryPaymentMethod);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.CreateVendorSetupIntentRequest,
 *   !proto.payment_service.CreateVendorSetupIntentResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_CreateVendorSetupIntent = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/CreateVendorSetupIntent', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.CreateVendorSetupIntentRequest, $8ilIL.CreateVendorSetupIntentResponse, /**
   * @param {!proto.payment_service.CreateVendorSetupIntentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.CreateVendorSetupIntentResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.CreateVendorSetupIntentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.CreateVendorSetupIntentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.CreateVendorSetupIntentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.createVendorSetupIntent = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/CreateVendorSetupIntent', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_CreateVendorSetupIntent, callback);
};
/**
 * @param {!proto.payment_service.CreateVendorSetupIntentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.CreateVendorSetupIntentResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.createVendorSetupIntent = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/CreateVendorSetupIntent', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_CreateVendorSetupIntent);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest,
 *   !proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_PaymentService_CreateVendorSetupIntentAndCustomerSession = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.PaymentService/CreateVendorSetupIntentAndCustomerSession', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $8ilIL.CreateVendorSetupIntentAndCustomerSessionRequest, $8ilIL.CreateVendorSetupIntentAndCustomerSessionResponse, /**
   * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $8ilIL.CreateVendorSetupIntentAndCustomerSessionResponse.deserializeBinary);
/**
 * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServiceClient.prototype.createVendorSetupIntentAndCustomerSession = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.PaymentService/CreateVendorSetupIntentAndCustomerSession', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_CreateVendorSetupIntentAndCustomerSession, callback);
};
/**
 * @param {!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.payment_service.CreateVendorSetupIntentAndCustomerSessionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.PaymentServicePromiseClient.prototype.createVendorSetupIntentAndCustomerSession = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.PaymentService/CreateVendorSetupIntentAndCustomerSession', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_PaymentService_CreateVendorSetupIntentAndCustomerSession);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.VehicleListingServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.VehicleListingServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.vehicle_listing_service.GetVehicleRequest,
 *   !proto.vehicle.Vehicle>}
 */ const $df70feab7068291e$var$methodDescriptor_VehicleListingService_GetVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.VehicleListingService/GetVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $2Yrcc.GetVehicleRequest, $9YICB.Vehicle, /**
   * @param {!proto.vehicle_listing_service.GetVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9YICB.Vehicle.deserializeBinary);
/**
 * @param {!proto.vehicle_listing_service.GetVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.vehicle.Vehicle)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.vehicle.Vehicle>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.VehicleListingServiceClient.prototype.getVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.VehicleListingService/GetVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_VehicleListingService_GetVehicle, callback);
};
/**
 * @param {!proto.vehicle_listing_service.GetVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.vehicle.Vehicle>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.VehicleListingServicePromiseClient.prototype.getVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.VehicleListingService/GetVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_VehicleListingService_GetVehicle);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.AddVehicleRequest,
 *   !proto.fleet_service.AddVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_AddVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/AddVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.AddVehicleRequest, $3EyMN.AddVehicleResponse, /**
   * @param {!proto.fleet_service.AddVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.AddVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.AddVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.AddVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.AddVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.addVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/AddVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_AddVehicle, callback);
};
/**
 * @param {!proto.fleet_service.AddVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.AddVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.addVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/AddVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_AddVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetVehicleRequest,
 *   !proto.fleet_service.GetVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetFleetVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetFleetVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetVehicleRequest, $3EyMN.GetVehicleResponse, /**
   * @param {!proto.fleet_service.GetVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getFleetVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetFleetVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetFleetVehicle, callback);
};
/**
 * @param {!proto.fleet_service.GetVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getFleetVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetFleetVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetFleetVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ListProfilesRequest,
 *   !proto.fleet_service.ListProfilesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_ListProfiles = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/ListProfiles', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.ListProfilesRequest, $3EyMN.ListProfilesResponse, /**
   * @param {!proto.fleet_service.ListProfilesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ListProfilesResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ListProfilesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ListProfilesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ListProfilesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.listProfiles = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/ListProfiles', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ListProfiles, callback);
};
/**
 * @param {!proto.fleet_service.ListProfilesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ListProfilesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.listProfiles = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/ListProfiles', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ListProfiles);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpdateVehicleRequest,
 *   !proto.fleet_service.UpdateVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/UpdateVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.UpdateVehicleRequest, $3EyMN.UpdateVehicleResponse, /**
   * @param {!proto.fleet_service.UpdateVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpdateVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpdateVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpdateVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpdateVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.updateVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/UpdateVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicle, callback);
};
/**
 * @param {!proto.fleet_service.UpdateVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpdateVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.updateVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/UpdateVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.AssignVehicleRequest,
 *   !proto.fleet_service.AssignVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_AssignVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/AssignVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.AssignVehicleRequest, $3EyMN.AssignVehicleResponse, /**
   * @param {!proto.fleet_service.AssignVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.AssignVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.AssignVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.AssignVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.AssignVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.assignVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/AssignVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_AssignVehicle, callback);
};
/**
 * @param {!proto.fleet_service.AssignVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.AssignVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.assignVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/AssignVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_AssignVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UnassignVehicleRequest,
 *   !proto.fleet_service.UnassignVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_UnassignVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/UnassignVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.UnassignVehicleRequest, $3EyMN.UnassignVehicleResponse, /**
   * @param {!proto.fleet_service.UnassignVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UnassignVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UnassignVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UnassignVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UnassignVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.unassignVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/UnassignVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_UnassignVehicle, callback);
};
/**
 * @param {!proto.fleet_service.UnassignVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UnassignVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.unassignVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/UnassignVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_UnassignVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ConfirmVehicleRequest,
 *   !proto.fleet_service.ConfirmVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_ConfirmVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/ConfirmVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.ConfirmVehicleRequest, $3EyMN.ConfirmVehicleResponse, /**
   * @param {!proto.fleet_service.ConfirmVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ConfirmVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ConfirmVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ConfirmVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ConfirmVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.confirmVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/ConfirmVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ConfirmVehicle, callback);
};
/**
 * @param {!proto.fleet_service.ConfirmVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ConfirmVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.confirmVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/ConfirmVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ConfirmVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ValidateVinRequest,
 *   !proto.fleet_service.ValidateVinResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_ValidateVin = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/ValidateVin', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.ValidateVinRequest, $3EyMN.ValidateVinResponse, /**
   * @param {!proto.fleet_service.ValidateVinRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ValidateVinResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ValidateVinRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ValidateVinResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ValidateVinResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.validateVin = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/ValidateVin', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ValidateVin, callback);
};
/**
 * @param {!proto.fleet_service.ValidateVinRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ValidateVinResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.validateVin = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/ValidateVin', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ValidateVin);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpdateVehicleCustodyRequest,
 *   !proto.fleet_service.UpdateVehicleCustodyResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicleCustody = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/UpdateVehicleCustody', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.UpdateVehicleCustodyRequest, $3EyMN.UpdateVehicleCustodyResponse, /**
   * @param {!proto.fleet_service.UpdateVehicleCustodyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpdateVehicleCustodyResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpdateVehicleCustodyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpdateVehicleCustodyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpdateVehicleCustodyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.updateVehicleCustody = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/UpdateVehicleCustody', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicleCustody, callback);
};
/**
 * @param {!proto.fleet_service.UpdateVehicleCustodyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpdateVehicleCustodyResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.updateVehicleCustody = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/UpdateVehicleCustody', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicleCustody);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetLatestCustodyRequest,
 *   !proto.fleet_service.GetLatestCustodyResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetLatestCustody = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetLatestCustody', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetLatestCustodyRequest, $3EyMN.GetLatestCustodyResponse, /**
   * @param {!proto.fleet_service.GetLatestCustodyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetLatestCustodyResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetLatestCustodyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetLatestCustodyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetLatestCustodyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getLatestCustody = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetLatestCustody', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetLatestCustody, callback);
};
/**
 * @param {!proto.fleet_service.GetLatestCustodyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetLatestCustodyResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getLatestCustody = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetLatestCustody', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetLatestCustody);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetVehicleByIdRequest,
 *   !proto.fleet_service.GetVehicleByIdResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleById = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetVehicleById', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetVehicleByIdRequest, $3EyMN.GetVehicleByIdResponse, /**
   * @param {!proto.fleet_service.GetVehicleByIdRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetVehicleByIdResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetVehicleByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetVehicleByIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetVehicleByIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getVehicleById = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetVehicleById', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleById, callback);
};
/**
 * @param {!proto.fleet_service.GetVehicleByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetVehicleByIdResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getVehicleById = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetVehicleById', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleById);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetVehicleInfleetingRequest,
 *   !proto.fleet_service.GetVehicleInfleetingResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleInfleeting = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetVehicleInfleeting', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetVehicleInfleetingRequest, $3EyMN.GetVehicleInfleetingResponse, /**
   * @param {!proto.fleet_service.GetVehicleInfleetingRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetVehicleInfleetingResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetVehicleInfleetingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetVehicleInfleetingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetVehicleInfleetingResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getVehicleInfleeting = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetVehicleInfleeting', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleInfleeting, callback);
};
/**
 * @param {!proto.fleet_service.GetVehicleInfleetingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetVehicleInfleetingResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getVehicleInfleeting = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetVehicleInfleeting', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleInfleeting);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.UpdateVehicleInfleetingRequest,
 *   !proto.fleet_service.UpdateVehicleInfleetingResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicleInfleeting = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/UpdateVehicleInfleeting', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.UpdateVehicleInfleetingRequest, $3EyMN.UpdateVehicleInfleetingResponse, /**
   * @param {!proto.fleet_service.UpdateVehicleInfleetingRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.UpdateVehicleInfleetingResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.UpdateVehicleInfleetingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.UpdateVehicleInfleetingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.UpdateVehicleInfleetingResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.updateVehicleInfleeting = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/UpdateVehicleInfleeting', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicleInfleeting, callback);
};
/**
 * @param {!proto.fleet_service.UpdateVehicleInfleetingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.UpdateVehicleInfleetingResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.updateVehicleInfleeting = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/UpdateVehicleInfleeting', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_UpdateVehicleInfleeting);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ReturnVehicleRequest,
 *   !proto.fleet_service.ReturnVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_ReturnVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/ReturnVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.ReturnVehicleRequest, $3EyMN.ReturnVehicleResponse, /**
   * @param {!proto.fleet_service.ReturnVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ReturnVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ReturnVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ReturnVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ReturnVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.returnVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/ReturnVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ReturnVehicle, callback);
};
/**
 * @param {!proto.fleet_service.ReturnVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ReturnVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.returnVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/ReturnVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ReturnVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.InitiateVehicleReturnRequest,
 *   !proto.fleet_service.InitiateVehicleReturnResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_InitiateVehicleReturn = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/InitiateVehicleReturn', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.InitiateVehicleReturnRequest, $3EyMN.InitiateVehicleReturnResponse, /**
   * @param {!proto.fleet_service.InitiateVehicleReturnRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.InitiateVehicleReturnResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.InitiateVehicleReturnRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.InitiateVehicleReturnResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.InitiateVehicleReturnResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.initiateVehicleReturn = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/InitiateVehicleReturn', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_InitiateVehicleReturn, callback);
};
/**
 * @param {!proto.fleet_service.InitiateVehicleReturnRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.InitiateVehicleReturnResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.initiateVehicleReturn = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/InitiateVehicleReturn', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_InitiateVehicleReturn);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ReturnAndPickupVehicleRequest,
 *   !proto.fleet_service.ReturnAndPickupVehicleResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_ReturnAndPickupVehicle = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/ReturnAndPickupVehicle', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.ReturnAndPickupVehicleRequest, $3EyMN.ReturnAndPickupVehicleResponse, /**
   * @param {!proto.fleet_service.ReturnAndPickupVehicleRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ReturnAndPickupVehicleResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ReturnAndPickupVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ReturnAndPickupVehicleResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ReturnAndPickupVehicleResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.returnAndPickupVehicle = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/ReturnAndPickupVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ReturnAndPickupVehicle, callback);
};
/**
 * @param {!proto.fleet_service.ReturnAndPickupVehicleRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ReturnAndPickupVehicleResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.returnAndPickupVehicle = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/ReturnAndPickupVehicle', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ReturnAndPickupVehicle);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetOwnBuyItNowDetailsRequest,
 *   !proto.fleet_service.GetOwnBuyItNowDetailsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetOwnBuyItNowDetails = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetOwnBuyItNowDetails', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetOwnBuyItNowDetailsRequest, $3EyMN.GetOwnBuyItNowDetailsResponse, /**
   * @param {!proto.fleet_service.GetOwnBuyItNowDetailsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetOwnBuyItNowDetailsResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetOwnBuyItNowDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetOwnBuyItNowDetailsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetOwnBuyItNowDetailsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getOwnBuyItNowDetails = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetOwnBuyItNowDetails', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetOwnBuyItNowDetails, callback);
};
/**
 * @param {!proto.fleet_service.GetOwnBuyItNowDetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetOwnBuyItNowDetailsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getOwnBuyItNowDetails = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetOwnBuyItNowDetails', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetOwnBuyItNowDetails);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetPrePaidMileageRateRequest,
 *   !proto.fleet_service.GetPrePaidMileageRateResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetPrePaidMileageRate = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetPrePaidMileageRate', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetPrePaidMileageRateRequest, $3EyMN.GetPrePaidMileageRateResponse, /**
   * @param {!proto.fleet_service.GetPrePaidMileageRateRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetPrePaidMileageRateResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetPrePaidMileageRateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetPrePaidMileageRateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetPrePaidMileageRateResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getPrePaidMileageRate = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetPrePaidMileageRate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetPrePaidMileageRate, callback);
};
/**
 * @param {!proto.fleet_service.GetPrePaidMileageRateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetPrePaidMileageRateResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getPrePaidMileageRate = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetPrePaidMileageRate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetPrePaidMileageRate);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetSubscriptionMileageRequest,
 *   !proto.fleet_service.GetSubscriptionMileageResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetSubscriptionMileage = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetSubscriptionMileage', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetSubscriptionMileageRequest, $3EyMN.GetSubscriptionMileageResponse, /**
   * @param {!proto.fleet_service.GetSubscriptionMileageRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetSubscriptionMileageResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetSubscriptionMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetSubscriptionMileageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetSubscriptionMileageResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getSubscriptionMileage = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetSubscriptionMileage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetSubscriptionMileage, callback);
};
/**
 * @param {!proto.fleet_service.GetSubscriptionMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetSubscriptionMileageResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getSubscriptionMileage = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetSubscriptionMileage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetSubscriptionMileage);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.CreateInspectionReportRequest,
 *   !proto.fleet_service.CreateInspectionReportResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_CreateInspectionReport = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/CreateInspectionReport', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.CreateInspectionReportRequest, $3EyMN.CreateInspectionReportResponse, /**
   * @param {!proto.fleet_service.CreateInspectionReportRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.CreateInspectionReportResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.CreateInspectionReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.CreateInspectionReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.CreateInspectionReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.createInspectionReport = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/CreateInspectionReport', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_CreateInspectionReport, callback);
};
/**
 * @param {!proto.fleet_service.CreateInspectionReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.CreateInspectionReportResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.createInspectionReport = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/CreateInspectionReport', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_CreateInspectionReport);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetPresignedWritePhotoURLRequest,
 *   !proto.fleet_service.GetPresignedWritePhotoURLResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetPresignedWritePhotoURL = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetPresignedWritePhotoURL', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetPresignedWritePhotoURLRequest, $3EyMN.GetPresignedWritePhotoURLResponse, /**
   * @param {!proto.fleet_service.GetPresignedWritePhotoURLRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetPresignedWritePhotoURLResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetPresignedWritePhotoURLRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetPresignedWritePhotoURLResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetPresignedWritePhotoURLResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getPresignedWritePhotoURL = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetPresignedWritePhotoURL', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetPresignedWritePhotoURL, callback);
};
/**
 * @param {!proto.fleet_service.GetPresignedWritePhotoURLRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetPresignedWritePhotoURLResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getPresignedWritePhotoURL = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetPresignedWritePhotoURL', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetPresignedWritePhotoURL);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetInspectionSignatureWriteURLRequest,
 *   !proto.fleet_service.GetInspectionSignatureWriteURLResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetInspectionSignatureWriteURL = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetInspectionSignatureWriteURL', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetInspectionSignatureWriteURLRequest, $3EyMN.GetInspectionSignatureWriteURLResponse, /**
   * @param {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetInspectionSignatureWriteURLResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetInspectionSignatureWriteURLResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetInspectionSignatureWriteURLResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getInspectionSignatureWriteURL = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetInspectionSignatureWriteURL', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetInspectionSignatureWriteURL, callback);
};
/**
 * @param {!proto.fleet_service.GetInspectionSignatureWriteURLRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetInspectionSignatureWriteURLResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getInspectionSignatureWriteURL = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetInspectionSignatureWriteURL', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetInspectionSignatureWriteURL);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ListInspectionReportsRequest,
 *   !proto.fleet_service.ListInspectionReportsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_ListInspectionReports = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/ListInspectionReports', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.ListInspectionReportsRequest, $3EyMN.ListInspectionReportsResponse, /**
   * @param {!proto.fleet_service.ListInspectionReportsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ListInspectionReportsResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ListInspectionReportsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ListInspectionReportsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ListInspectionReportsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.listInspectionReports = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/ListInspectionReports', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ListInspectionReports, callback);
};
/**
 * @param {!proto.fleet_service.ListInspectionReportsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ListInspectionReportsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.listInspectionReports = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/ListInspectionReports', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ListInspectionReports);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.SignInspectionReportRequest,
 *   !proto.fleet_service.SignInspectionReportResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_SignInspectionReport = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/SignInspectionReport', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.SignInspectionReportRequest, $3EyMN.SignInspectionReportResponse, /**
   * @param {!proto.fleet_service.SignInspectionReportRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.SignInspectionReportResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.SignInspectionReportRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.SignInspectionReportResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.SignInspectionReportResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.signInspectionReport = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/SignInspectionReport', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_SignInspectionReport, callback);
};
/**
 * @param {!proto.fleet_service.SignInspectionReportRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.SignInspectionReportResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.signInspectionReport = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/SignInspectionReport', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_SignInspectionReport);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.AddInspectionPhotosRequest,
 *   !proto.fleet_service.AddInspectionPhotosResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_AddInspectionPhotos = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/AddInspectionPhotos', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.AddInspectionPhotosRequest, $3EyMN.AddInspectionPhotosResponse, /**
   * @param {!proto.fleet_service.AddInspectionPhotosRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.AddInspectionPhotosResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.AddInspectionPhotosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.AddInspectionPhotosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.AddInspectionPhotosResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.addInspectionPhotos = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/AddInspectionPhotos', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_AddInspectionPhotos, callback);
};
/**
 * @param {!proto.fleet_service.AddInspectionPhotosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.AddInspectionPhotosResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.addInspectionPhotos = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/AddInspectionPhotos', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_AddInspectionPhotos);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetInspectionPhotosRequest,
 *   !proto.fleet_service.GetInspectionPhotosResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetInspectionPhotos = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetInspectionPhotos', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetInspectionPhotosRequest, $3EyMN.GetInspectionPhotosResponse, /**
   * @param {!proto.fleet_service.GetInspectionPhotosRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetInspectionPhotosResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetInspectionPhotosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetInspectionPhotosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetInspectionPhotosResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getInspectionPhotos = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetInspectionPhotos', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetInspectionPhotos, callback);
};
/**
 * @param {!proto.fleet_service.GetInspectionPhotosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetInspectionPhotosResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getInspectionPhotos = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetInspectionPhotos', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetInspectionPhotos);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.LogMilesPurchasedRequest,
 *   !proto.fleet_service.LogMilesPurchasedResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_LogMilesPurchased = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/LogMilesPurchased', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.LogMilesPurchasedRequest, $3EyMN.LogMilesPurchasedResponse, /**
   * @param {!proto.fleet_service.LogMilesPurchasedRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.LogMilesPurchasedResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.LogMilesPurchasedRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.LogMilesPurchasedResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.LogMilesPurchasedResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.logMilesPurchased = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/LogMilesPurchased', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_LogMilesPurchased, callback);
};
/**
 * @param {!proto.fleet_service.LogMilesPurchasedRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.LogMilesPurchasedResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.logMilesPurchased = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/LogMilesPurchased', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_LogMilesPurchased);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.DeleteMilesPurchasedLogRequest,
 *   !proto.fleet_service.DeleteMilesPurchasedLogResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_DeleteMilesPurchasedLog = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/DeleteMilesPurchasedLog', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.DeleteMilesPurchasedLogRequest, $3EyMN.DeleteMilesPurchasedLogResponse, /**
   * @param {!proto.fleet_service.DeleteMilesPurchasedLogRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.DeleteMilesPurchasedLogResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.DeleteMilesPurchasedLogRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.DeleteMilesPurchasedLogResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.DeleteMilesPurchasedLogResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.deleteMilesPurchasedLog = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/DeleteMilesPurchasedLog', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_DeleteMilesPurchasedLog, callback);
};
/**
 * @param {!proto.fleet_service.DeleteMilesPurchasedLogRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.DeleteMilesPurchasedLogResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.deleteMilesPurchasedLog = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/DeleteMilesPurchasedLog', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_DeleteMilesPurchasedLog);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.GetVehicleMediaRequest,
 *   !proto.fleet_service.GetVehicleMediaResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleMedia = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/GetVehicleMedia', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.GetVehicleMediaRequest, $3EyMN.GetVehicleMediaResponse, /**
   * @param {!proto.fleet_service.GetVehicleMediaRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.GetVehicleMediaResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.GetVehicleMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.GetVehicleMediaResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.GetVehicleMediaResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.getVehicleMedia = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/GetVehicleMedia', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleMedia, callback);
};
/**
 * @param {!proto.fleet_service.GetVehicleMediaRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.GetVehicleMediaResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.getVehicleMedia = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/GetVehicleMedia', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_GetVehicleMedia);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ListVehicleMakesRequest,
 *   !proto.fleet_service.ListVehicleMakesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_ListVehicleMakes = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/ListVehicleMakes', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.ListVehicleMakesRequest, $3EyMN.ListVehicleMakesResponse, /**
   * @param {!proto.fleet_service.ListVehicleMakesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ListVehicleMakesResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ListVehicleMakesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ListVehicleMakesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ListVehicleMakesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.listVehicleMakes = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/ListVehicleMakes', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ListVehicleMakes, callback);
};
/**
 * @param {!proto.fleet_service.ListVehicleMakesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ListVehicleMakesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.listVehicleMakes = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/ListVehicleMakes', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ListVehicleMakes);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.fleet_service.ListVehiclesRequest,
 *   !proto.fleet_service.ListVehiclesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_FleetService_ListVehicles = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.FleetService/ListVehicles', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $3EyMN.ListVehiclesRequest, $3EyMN.ListVehiclesResponse, /**
   * @param {!proto.fleet_service.ListVehiclesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $3EyMN.ListVehiclesResponse.deserializeBinary);
/**
 * @param {!proto.fleet_service.ListVehiclesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.fleet_service.ListVehiclesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.fleet_service.ListVehiclesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.FleetServiceClient.prototype.listVehicles = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.FleetService/ListVehicles', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ListVehicles, callback);
};
/**
 * @param {!proto.fleet_service.ListVehiclesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.fleet_service.ListVehiclesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.FleetServicePromiseClient.prototype.listVehicles = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.FleetService/ListVehicles', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_FleetService_ListVehicles);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.BeginInspectionRequest,
 *   !proto.inspection.BeginInspectionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_BeginInspection = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/BeginInspection', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.BeginInspectionRequest, $gjhG2.BeginInspectionResponse, /**
   * @param {!proto.inspection.BeginInspectionRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.BeginInspectionResponse.deserializeBinary);
/**
 * @param {!proto.inspection.BeginInspectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.BeginInspectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.BeginInspectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.beginInspection = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/BeginInspection', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_BeginInspection, callback);
};
/**
 * @param {!proto.inspection.BeginInspectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.BeginInspectionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.beginInspection = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/BeginInspection', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_BeginInspection);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.GetInspectionResultsRequest,
 *   !proto.inspection.GetInspectionResultsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionResults = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/GetInspectionResults', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.GetInspectionResultsRequest, $gjhG2.GetInspectionResultsResponse, /**
   * @param {!proto.inspection.GetInspectionResultsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.GetInspectionResultsResponse.deserializeBinary);
/**
 * @param {!proto.inspection.GetInspectionResultsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.GetInspectionResultsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.GetInspectionResultsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.getInspectionResults = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/GetInspectionResults', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionResults, callback);
};
/**
 * @param {!proto.inspection.GetInspectionResultsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.GetInspectionResultsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.getInspectionResults = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/GetInspectionResults', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionResults);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.GetInspectionPhotosRequest,
 *   !proto.inspection.GetInspectionPhotosResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_GetPaveInspectionPhotos = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/GetPaveInspectionPhotos', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.GetInspectionPhotosRequest, $gjhG2.GetInspectionPhotosResponse, /**
   * @param {!proto.inspection.GetInspectionPhotosRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.GetInspectionPhotosResponse.deserializeBinary);
/**
 * @param {!proto.inspection.GetInspectionPhotosRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.GetInspectionPhotosResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.GetInspectionPhotosResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.getPaveInspectionPhotos = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/GetPaveInspectionPhotos', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_GetPaveInspectionPhotos, callback);
};
/**
 * @param {!proto.inspection.GetInspectionPhotosRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.GetInspectionPhotosResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.getPaveInspectionPhotos = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/GetPaveInspectionPhotos', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_GetPaveInspectionPhotos);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.GetInspectionNotesRequest,
 *   !proto.inspection.GetInspectionNotesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionNotes = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/GetInspectionNotes', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.GetInspectionNotesRequest, $gjhG2.GetInspectionNotesResponse, /**
   * @param {!proto.inspection.GetInspectionNotesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.GetInspectionNotesResponse.deserializeBinary);
/**
 * @param {!proto.inspection.GetInspectionNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.GetInspectionNotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.GetInspectionNotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.getInspectionNotes = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/GetInspectionNotes', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionNotes, callback);
};
/**
 * @param {!proto.inspection.GetInspectionNotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.GetInspectionNotesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.getInspectionNotes = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/GetInspectionNotes', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionNotes);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.SubmitCustomerMileageRequest,
 *   !proto.inspection.SubmitCustomerMileageResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_SubmitCustomerMileage = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/SubmitCustomerMileage', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.SubmitCustomerMileageRequest, $gjhG2.SubmitCustomerMileageResponse, /**
   * @param {!proto.inspection.SubmitCustomerMileageRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.SubmitCustomerMileageResponse.deserializeBinary);
/**
 * @param {!proto.inspection.SubmitCustomerMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.SubmitCustomerMileageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.SubmitCustomerMileageResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.submitCustomerMileage = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/SubmitCustomerMileage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_SubmitCustomerMileage, callback);
};
/**
 * @param {!proto.inspection.SubmitCustomerMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.SubmitCustomerMileageResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.submitCustomerMileage = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/SubmitCustomerMileage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_SubmitCustomerMileage);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.StartInspectionCustomerRequest,
 *   !proto.inspection.StartInspectionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionCustomer = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/StartInspectionCustomer', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.StartInspectionCustomerRequest, $gjhG2.StartInspectionResponse, /**
   * @param {!proto.inspection.StartInspectionCustomerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.StartInspectionResponse.deserializeBinary);
/**
 * @param {!proto.inspection.StartInspectionCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.StartInspectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.StartInspectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.startInspectionCustomer = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/StartInspectionCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionCustomer, callback);
};
/**
 * @param {!proto.inspection.StartInspectionCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.StartInspectionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.startInspectionCustomer = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/StartInspectionCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionCustomer);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.StartInspectionDealerRequest,
 *   !proto.inspection.StartInspectionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionDealer = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/StartInspectionDealer', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.StartInspectionDealerRequest, $gjhG2.StartInspectionResponse, /**
   * @param {!proto.inspection.StartInspectionDealerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.StartInspectionResponse.deserializeBinary);
/**
 * @param {!proto.inspection.StartInspectionDealerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.StartInspectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.StartInspectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.startInspectionDealer = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/StartInspectionDealer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionDealer, callback);
};
/**
 * @param {!proto.inspection.StartInspectionDealerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.StartInspectionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.startInspectionDealer = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/StartInspectionDealer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionDealer);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.StartInspectionFleetRequest,
 *   !proto.inspection.StartInspectionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionFleet = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/StartInspectionFleet', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.StartInspectionFleetRequest, $gjhG2.StartInspectionResponse, /**
   * @param {!proto.inspection.StartInspectionFleetRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.StartInspectionResponse.deserializeBinary);
/**
 * @param {!proto.inspection.StartInspectionFleetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.StartInspectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.StartInspectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.startInspectionFleet = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/StartInspectionFleet', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionFleet, callback);
};
/**
 * @param {!proto.inspection.StartInspectionFleetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.StartInspectionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.startInspectionFleet = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/StartInspectionFleet', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_StartInspectionFleet);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.GetInspectionStatusRequest,
 *   !proto.inspection.GetInspectionStatusResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionStatus = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/GetInspectionStatus', $df70feab7068291e$var$grpc.web.MethodType.SERVER_STREAMING, $gjhG2.GetInspectionStatusRequest, $gjhG2.GetInspectionStatusResponse, /**
   * @param {!proto.inspection.GetInspectionStatusRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.GetInspectionStatusResponse.deserializeBinary);
/**
 * @param {!proto.inspection.GetInspectionStatusRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.GetInspectionStatusResponse>}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.getInspectionStatus = function(request, metadata) {
    return this.client_.serverStreaming(this.hostname_ + '/gateway_service.InspectionService/GetInspectionStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionStatus);
};
/**
 * @param {!proto.inspection.GetInspectionStatusRequest} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.GetInspectionStatusResponse>}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.getInspectionStatus = function(request, metadata) {
    return this.client_.serverStreaming(this.hostname_ + '/gateway_service.InspectionService/GetInspectionStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_GetInspectionStatus);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.inspection.CheckVehicleInspectionRequest,
 *   !proto.inspection.CheckVehicleInspectionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InspectionService_CheckVehicleInspection = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InspectionService/CheckVehicleInspection', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $gjhG2.CheckVehicleInspectionRequest, $gjhG2.CheckVehicleInspectionResponse, /**
   * @param {!proto.inspection.CheckVehicleInspectionRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $gjhG2.CheckVehicleInspectionResponse.deserializeBinary);
/**
 * @param {!proto.inspection.CheckVehicleInspectionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.inspection.CheckVehicleInspectionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.inspection.CheckVehicleInspectionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServiceClient.prototype.checkVehicleInspection = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InspectionService/CheckVehicleInspection', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_CheckVehicleInspection, callback);
};
/**
 * @param {!proto.inspection.CheckVehicleInspectionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.inspection.CheckVehicleInspectionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InspectionServicePromiseClient.prototype.checkVehicleInspection = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InspectionService/CheckVehicleInspection', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InspectionService_CheckVehicleInspection);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.UpsertOwnInsurancePoliciesRequest,
 *   !proto.insurance_service.UpsertInsurancePoliciesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_UpsertOwnInsurancePolicies = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/UpsertOwnInsurancePolicies', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.UpsertOwnInsurancePoliciesRequest, $ghA5X.UpsertInsurancePoliciesResponse, /**
   * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.UpsertInsurancePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.UpsertInsurancePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.UpsertInsurancePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.upsertOwnInsurancePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/UpsertOwnInsurancePolicies', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_UpsertOwnInsurancePolicies, callback);
};
/**
 * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.UpsertInsurancePoliciesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.upsertOwnInsurancePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/UpsertOwnInsurancePolicies', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_UpsertOwnInsurancePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CreateInsuranceQuoteRequest,
 *   !proto.insurance_service.GetInsuranceQuoteResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_CreateInsuranceQuote = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/CreateInsuranceQuote', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.CreateInsuranceQuoteRequest, $ghA5X.GetInsuranceQuoteResponse, /**
   * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetInsuranceQuoteResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuranceQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuranceQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.createInsuranceQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/CreateInsuranceQuote', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_CreateInsuranceQuote, callback);
};
/**
 * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuranceQuoteResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.createInsuranceQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/CreateInsuranceQuote', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_CreateInsuranceQuote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsuranceQuoteRequest,
 *   !proto.insurance_service.GetInsuranceQuoteResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuranceQuote = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/GetInsuranceQuote', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.GetInsuranceQuoteRequest, $ghA5X.GetInsuranceQuoteResponse, /**
   * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetInsuranceQuoteResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuranceQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuranceQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.getInsuranceQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/GetInsuranceQuote', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuranceQuote, callback);
};
/**
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuranceQuoteResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.getInsuranceQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/GetInsuranceQuote', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuranceQuote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetOwnInsurancePoliciesRequest,
 *   !proto.insurance_service.GetInsurancePoliciesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_GetOwnInsurancePolicies = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/GetOwnInsurancePolicies', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.GetOwnInsurancePoliciesRequest, $ghA5X.GetInsurancePoliciesResponse, /**
   * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetInsurancePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsurancePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsurancePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.getOwnInsurancePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/GetOwnInsurancePolicies', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetOwnInsurancePolicies, callback);
};
/**
 * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsurancePoliciesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.getOwnInsurancePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/GetOwnInsurancePolicies', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetOwnInsurancePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsurancePolicyRequest,
 *   !proto.insurance_service.GetInsurancePolicyResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsurancePolicy = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/GetInsurancePolicy', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.GetInsurancePolicyRequest, $ghA5X.GetInsurancePolicyResponse, /**
   * @param {!proto.insurance_service.GetInsurancePolicyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetInsurancePolicyResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsurancePolicyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsurancePolicyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.getInsurancePolicy = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/GetInsurancePolicy', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsurancePolicy, callback);
};
/**
 * @param {!proto.insurance_service.GetInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsurancePolicyResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.getInsurancePolicy = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/GetInsurancePolicy', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsurancePolicy);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.QualifyForLibertyInsuranceRequest,
 *   !proto.insurance_service.QualifyForLibertyInsuranceResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_QualifyForLibertyInsurance = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/QualifyForLibertyInsurance', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.QualifyForLibertyInsuranceRequest, $ghA5X.QualifyForLibertyInsuranceResponse, /**
   * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.QualifyForLibertyInsuranceResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.QualifyForLibertyInsuranceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.QualifyForLibertyInsuranceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.qualifyForLibertyInsurance = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/QualifyForLibertyInsurance', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_QualifyForLibertyInsurance, callback);
};
/**
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.QualifyForLibertyInsuranceResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.qualifyForLibertyInsurance = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/QualifyForLibertyInsurance', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_QualifyForLibertyInsurance);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsuredDriversRequest,
 *   !proto.insurance_service.GetInsuredDriversResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuredDrivers = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/GetInsuredDrivers', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.GetInsuredDriversRequest, $ghA5X.GetInsuredDriversResponse, /**
   * @param {!proto.insurance_service.GetInsuredDriversRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetInsuredDriversResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsuredDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuredDriversResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuredDriversResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.getInsuredDrivers = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/GetInsuredDrivers', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuredDrivers, callback);
};
/**
 * @param {!proto.insurance_service.GetInsuredDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuredDriversResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.getInsuredDrivers = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/GetInsuredDrivers', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuredDrivers);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsuranceStatusRequest,
 *   !proto.insurance_service.GetInsuranceStatusResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuranceStatus = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/GetInsuranceStatus', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.GetInsuranceStatusRequest, $ghA5X.GetInsuranceStatusResponse, /**
   * @param {!proto.insurance_service.GetInsuranceStatusRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetInsuranceStatusResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsuranceStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuranceStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuranceStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.getInsuranceStatus = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/GetInsuranceStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuranceStatus, callback);
};
/**
 * @param {!proto.insurance_service.GetInsuranceStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuranceStatusResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.getInsuranceStatus = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/GetInsuranceStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetInsuranceStatus);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CreateAllInsuranceQuotesRequest,
 *   !proto.insurance_service.CreateAllInsuranceQuotesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_CreateAllInsuranceQuotes = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/CreateAllInsuranceQuotes', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.CreateAllInsuranceQuotesRequest, $ghA5X.CreateAllInsuranceQuotesResponse, /**
   * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.CreateAllInsuranceQuotesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.CreateAllInsuranceQuotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.CreateAllInsuranceQuotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.createAllInsuranceQuotes = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/CreateAllInsuranceQuotes', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_CreateAllInsuranceQuotes, callback);
};
/**
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.CreateAllInsuranceQuotesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.createAllInsuranceQuotes = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/CreateAllInsuranceQuotes', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_CreateAllInsuranceQuotes);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.SelectInsuranceQuoteRequest,
 *   !proto.insurance_service.SelectInsuranceQuoteResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_SelectInsuranceQuote = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/SelectInsuranceQuote', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.SelectInsuranceQuoteRequest, $ghA5X.SelectInsuranceQuoteResponse, /**
   * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.SelectInsuranceQuoteResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.SelectInsuranceQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.SelectInsuranceQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.selectInsuranceQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/SelectInsuranceQuote', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_SelectInsuranceQuote, callback);
};
/**
 * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.SelectInsuranceQuoteResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.selectInsuranceQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/SelectInsuranceQuote', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_SelectInsuranceQuote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CancelInsurancePolicyRequest,
 *   !proto.insurance_service.CancelInsurancePolicyResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_CancelInsurancePolicy = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/CancelInsurancePolicy', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.CancelInsurancePolicyRequest, $ghA5X.CancelInsurancePolicyResponse, /**
   * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.CancelInsurancePolicyResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.CancelInsurancePolicyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.CancelInsurancePolicyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.cancelInsurancePolicy = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/CancelInsurancePolicy', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_CancelInsurancePolicy, callback);
};
/**
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.CancelInsurancePolicyResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.cancelInsurancePolicy = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/CancelInsurancePolicy', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_CancelInsurancePolicy);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetLatestQuoteGroupRequest,
 *   !proto.insurance_service.GetLatestQuoteGroupResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_GetLatestQuoteGroup = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/GetLatestQuoteGroup', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.GetLatestQuoteGroupRequest, $ghA5X.GetLatestQuoteGroupResponse, /**
   * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.GetLatestQuoteGroupResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetLatestQuoteGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetLatestQuoteGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.getLatestQuoteGroup = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/GetLatestQuoteGroup', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetLatestQuoteGroup, callback);
};
/**
 * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetLatestQuoteGroupResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.getLatestQuoteGroup = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/GetLatestQuoteGroup', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_GetLatestQuoteGroup);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.ModifyInsuranceDriversRequest,
 *   !proto.insurance_service.ModifyInsuranceDriversResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_InsuranceService_ModifyInsuranceDrivers = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.InsuranceService/ModifyInsuranceDrivers', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $ghA5X.ModifyInsuranceDriversRequest, $ghA5X.ModifyInsuranceDriversResponse, /**
   * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $ghA5X.ModifyInsuranceDriversResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.ModifyInsuranceDriversResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.ModifyInsuranceDriversResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServiceClient.prototype.modifyInsuranceDrivers = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.InsuranceService/ModifyInsuranceDrivers', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_ModifyInsuranceDrivers, callback);
};
/**
 * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.ModifyInsuranceDriversResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.InsuranceServicePromiseClient.prototype.modifyInsuranceDrivers = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.InsuranceService/ModifyInsuranceDrivers', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_InsuranceService_ModifyInsuranceDrivers);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.GetActiveOrLatestSubscriptionRequest,
 *   !proto.subscription_service.GetSubscriptionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnActiveOrLatestSubscription = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/GetOwnActiveOrLatestSubscription', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.GetActiveOrLatestSubscriptionRequest, $9HeMJ.GetSubscriptionResponse, /**
   * @param {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.GetSubscriptionResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.GetSubscriptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.GetSubscriptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.getOwnActiveOrLatestSubscription = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/GetOwnActiveOrLatestSubscription', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnActiveOrLatestSubscription, callback);
};
/**
 * @param {!proto.subscription_service.GetActiveOrLatestSubscriptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.GetSubscriptionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.getOwnActiveOrLatestSubscription = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/GetOwnActiveOrLatestSubscription', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnActiveOrLatestSubscription);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.PreviewOwnContractRequest,
 *   !proto.subscription_service.ContractResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_PreviewOwnContract = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/PreviewOwnContract', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.PreviewOwnContractRequest, $9HeMJ.ContractResponse, /**
   * @param {!proto.subscription_service.PreviewOwnContractRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.ContractResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.PreviewOwnContractRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.ContractResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.ContractResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.previewOwnContract = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/PreviewOwnContract', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_PreviewOwnContract, callback);
};
/**
 * @param {!proto.subscription_service.PreviewOwnContractRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.ContractResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.previewOwnContract = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/PreviewOwnContract', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_PreviewOwnContract);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.SignContractRequest,
 *   !proto.subscription_service.SignContractResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_SignOwnContract = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/SignOwnContract', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.SignContractRequest, $9HeMJ.SignContractResponse, /**
   * @param {!proto.subscription_service.SignContractRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.SignContractResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.SignContractRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.SignContractResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.SignContractResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.signOwnContract = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/SignOwnContract', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_SignOwnContract, callback);
};
/**
 * @param {!proto.subscription_service.SignContractRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.SignContractResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.signOwnContract = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/SignOwnContract', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_SignOwnContract);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.GetOwnContractRequest,
 *   !proto.subscription_service.ContractResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnContract = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/GetOwnContract', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.GetOwnContractRequest, $9HeMJ.ContractResponse, /**
   * @param {!proto.subscription_service.GetOwnContractRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.ContractResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.GetOwnContractRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.ContractResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.ContractResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.getOwnContract = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/GetOwnContract', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnContract, callback);
};
/**
 * @param {!proto.subscription_service.GetOwnContractRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.ContractResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.getOwnContract = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/GetOwnContract', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnContract);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.GetContractRequest,
 *   !proto.subscription_service.ContractResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetContract = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/GetContract', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.GetContractRequest, $9HeMJ.ContractResponse, /**
   * @param {!proto.subscription_service.GetContractRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.ContractResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.GetContractRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.ContractResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.ContractResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.getContract = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/GetContract', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetContract, callback);
};
/**
 * @param {!proto.subscription_service.GetContractRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.ContractResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.getContract = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/GetContract', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetContract);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.PreviewOwnPickupReceiptRequest,
 *   !proto.subscription_service.PickupReceiptResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_PreviewOwnPickupReceipt = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/PreviewOwnPickupReceipt', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.PreviewOwnPickupReceiptRequest, $9HeMJ.PickupReceiptResponse, /**
   * @param {!proto.subscription_service.PreviewOwnPickupReceiptRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.PickupReceiptResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.PreviewOwnPickupReceiptRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.PickupReceiptResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.PickupReceiptResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.previewOwnPickupReceipt = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/PreviewOwnPickupReceipt', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_PreviewOwnPickupReceipt, callback);
};
/**
 * @param {!proto.subscription_service.PreviewOwnPickupReceiptRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.PickupReceiptResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.previewOwnPickupReceipt = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/PreviewOwnPickupReceipt', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_PreviewOwnPickupReceipt);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.GetOwnPickupReceiptRequest,
 *   !proto.subscription_service.PickupReceiptResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnPickupReceipt = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/GetOwnPickupReceipt', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.GetOwnPickupReceiptRequest, $9HeMJ.PickupReceiptResponse, /**
   * @param {!proto.subscription_service.GetOwnPickupReceiptRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.PickupReceiptResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.GetOwnPickupReceiptRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.PickupReceiptResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.PickupReceiptResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.getOwnPickupReceipt = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/GetOwnPickupReceipt', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnPickupReceipt, callback);
};
/**
 * @param {!proto.subscription_service.GetOwnPickupReceiptRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.PickupReceiptResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.getOwnPickupReceipt = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/GetOwnPickupReceipt', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetOwnPickupReceipt);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.GetPickupReceiptRequest,
 *   !proto.subscription_service.PickupReceiptResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetPickupReceipt = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/GetPickupReceipt', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.GetPickupReceiptRequest, $9HeMJ.PickupReceiptResponse, /**
   * @param {!proto.subscription_service.GetPickupReceiptRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.PickupReceiptResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.GetPickupReceiptRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.PickupReceiptResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.PickupReceiptResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.getPickupReceipt = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/GetPickupReceipt', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetPickupReceipt, callback);
};
/**
 * @param {!proto.subscription_service.GetPickupReceiptRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.PickupReceiptResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.getPickupReceipt = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/GetPickupReceipt', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetPickupReceipt);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.ActivateRequest,
 *   !proto.subscription_service.ActivateResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_Activate = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/Activate', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.ActivateRequest, $9HeMJ.ActivateResponse, /**
   * @param {!proto.subscription_service.ActivateRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.ActivateResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.ActivateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.ActivateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.ActivateResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.activate = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/Activate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_Activate, callback);
};
/**
 * @param {!proto.subscription_service.ActivateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.ActivateResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.activate = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/Activate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_Activate);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.CreateWebReservationRequest,
 *   !proto.subscription_service.CreateWebReservationResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_CreateWebReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/CreateWebReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.CreateWebReservationRequest, $9HeMJ.CreateWebReservationResponse, /**
   * @param {!proto.subscription_service.CreateWebReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.CreateWebReservationResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.CreateWebReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.CreateWebReservationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.CreateWebReservationResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.createWebReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/CreateWebReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_CreateWebReservation, callback);
};
/**
 * @param {!proto.subscription_service.CreateWebReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.CreateWebReservationResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.createWebReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/CreateWebReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_CreateWebReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.ListReservationsRequest,
 *   !proto.subscription_service.ListReservationsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_ListReservations = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/ListReservations', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.ListReservationsRequest, $9HeMJ.ListReservationsResponse, /**
   * @param {!proto.subscription_service.ListReservationsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.ListReservationsResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.ListReservationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.ListReservationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.ListReservationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.listReservations = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/ListReservations', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_ListReservations, callback);
};
/**
 * @param {!proto.subscription_service.ListReservationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.ListReservationsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.listReservations = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/ListReservations', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_ListReservations);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.ListProgramsRequest,
 *   !proto.subscription_service.ListProgramsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_ListPrograms = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/ListPrograms', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.ListProgramsRequest, $9HeMJ.ListProgramsResponse, /**
   * @param {!proto.subscription_service.ListProgramsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.ListProgramsResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.ListProgramsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.ListProgramsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.ListProgramsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.listPrograms = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/ListPrograms', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_ListPrograms, callback);
};
/**
 * @param {!proto.subscription_service.ListProgramsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.ListProgramsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.listPrograms = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/ListPrograms', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_ListPrograms);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.GetReservationRequest,
 *   !proto.subscription_service.GetReservationResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/GetReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.GetReservationRequest, $9HeMJ.GetReservationResponse, /**
   * @param {!proto.subscription_service.GetReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.GetReservationResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.GetReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.GetReservationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.GetReservationResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.getReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/GetReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetReservation, callback);
};
/**
 * @param {!proto.subscription_service.GetReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.GetReservationResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.getReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/GetReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.CancelReservationRequest,
 *   !proto.subscription_service.CancelReservationResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_CancelReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/CancelReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.CancelReservationRequest, $9HeMJ.CancelReservationResponse, /**
   * @param {!proto.subscription_service.CancelReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.CancelReservationResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.CancelReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.CancelReservationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.CancelReservationResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.cancelReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/CancelReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_CancelReservation, callback);
};
/**
 * @param {!proto.subscription_service.CancelReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.CancelReservationResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.cancelReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/CancelReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_CancelReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.UpdateReservationRequest,
 *   !proto.subscription_service.UpdateReservationResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_UpdateReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/UpdateReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.UpdateReservationRequest, $9HeMJ.UpdateReservationResponse, /**
   * @param {!proto.subscription_service.UpdateReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.UpdateReservationResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.UpdateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.UpdateReservationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.UpdateReservationResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.updateReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/UpdateReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_UpdateReservation, callback);
};
/**
 * @param {!proto.subscription_service.UpdateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.UpdateReservationResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.updateReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/UpdateReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_UpdateReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.GetProgramRequest,
 *   !proto.subscription_service.GetProgramResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetProgram = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/GetProgram', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.GetProgramRequest, $9HeMJ.GetProgramResponse, /**
   * @param {!proto.subscription_service.GetProgramRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.GetProgramResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.GetProgramRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.GetProgramResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.GetProgramResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.getProgram = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/GetProgram', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetProgram, callback);
};
/**
 * @param {!proto.subscription_service.GetProgramRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.GetProgramResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.getProgram = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/GetProgram', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_GetProgram);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.subscription_service.SetReservationProgramRequest,
 *   !proto.subscription_service.SetReservationProgramResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_SubscriptionService_SetReservationProgram = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.SubscriptionService/SetReservationProgram', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9HeMJ.SetReservationProgramRequest, $9HeMJ.SetReservationProgramResponse, /**
   * @param {!proto.subscription_service.SetReservationProgramRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $9HeMJ.SetReservationProgramResponse.deserializeBinary);
/**
 * @param {!proto.subscription_service.SetReservationProgramRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.subscription_service.SetReservationProgramResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.subscription_service.SetReservationProgramResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServiceClient.prototype.setReservationProgram = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.SubscriptionService/SetReservationProgram', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_SetReservationProgram, callback);
};
/**
 * @param {!proto.subscription_service.SetReservationProgramRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.subscription_service.SetReservationProgramResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.SubscriptionServicePromiseClient.prototype.setReservationProgram = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.SubscriptionService/SetReservationProgram', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_SubscriptionService_SetReservationProgram);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSubscriptionPricingClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSubscriptionPricingPromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.spre.ListProgramPricingOptionsRequest,
 *   !proto.spre.ListProgramPricingOptionsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSubscriptionPricing_ListProgramPricingOptions = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSubscriptionPricing/ListProgramPricingOptions', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cIR06.ListProgramPricingOptionsRequest, $cIR06.ListProgramPricingOptionsResponse, /**
   * @param {!proto.spre.ListProgramPricingOptionsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cIR06.ListProgramPricingOptionsResponse.deserializeBinary);
/**
 * @param {!proto.spre.ListProgramPricingOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.spre.ListProgramPricingOptionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.spre.ListProgramPricingOptionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSubscriptionPricingClient.prototype.listProgramPricingOptions = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSubscriptionPricing/ListProgramPricingOptions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSubscriptionPricing_ListProgramPricingOptions, callback);
};
/**
 * @param {!proto.spre.ListProgramPricingOptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.spre.ListProgramPricingOptionsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSubscriptionPricingPromiseClient.prototype.listProgramPricingOptions = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSubscriptionPricing/ListProgramPricingOptions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSubscriptionPricing_ListProgramPricingOptions);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.spre.QuoteRequest,
 *   !proto.spre.CreateIdResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_CustomerSubscriptionPricing_CreateQuote = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.CustomerSubscriptionPricing/CreateQuote', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cIR06.QuoteRequest, $cIR06.CreateIdResponse, /**
   * @param {!proto.spre.QuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cIR06.CreateIdResponse.deserializeBinary);
/**
 * @param {!proto.spre.QuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.spre.CreateIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.spre.CreateIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSubscriptionPricingClient.prototype.createQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.CustomerSubscriptionPricing/CreateQuote', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSubscriptionPricing_CreateQuote, callback);
};
/**
 * @param {!proto.spre.QuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.spre.CreateIdResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.CustomerSubscriptionPricingPromiseClient.prototype.createQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.CustomerSubscriptionPricing/CreateQuote', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_CustomerSubscriptionPricing_CreateQuote);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.NotificationServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.NotificationServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification_service.SendDeepLinkRequest,
 *   !proto.notification_service.SendDeepLinkResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_NotificationService_SendDeepLink = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.NotificationService/SendDeepLink', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $eAp0I.SendDeepLinkRequest, $eAp0I.SendDeepLinkResponse, /**
   * @param {!proto.notification_service.SendDeepLinkRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $eAp0I.SendDeepLinkResponse.deserializeBinary);
/**
 * @param {!proto.notification_service.SendDeepLinkRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification_service.SendDeepLinkResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification_service.SendDeepLinkResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.NotificationServiceClient.prototype.sendDeepLink = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.NotificationService/SendDeepLink', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_NotificationService_SendDeepLink, callback);
};
/**
 * @param {!proto.notification_service.SendDeepLinkRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification_service.SendDeepLinkResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.NotificationServicePromiseClient.prototype.sendDeepLink = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.NotificationService/SendDeepLink', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_NotificationService_SendDeepLink);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification_service.GetNotificationsRequest,
 *   !proto.notification_service.GetNotificationsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_NotificationService_GetNotifications = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.NotificationService/GetNotifications', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $eAp0I.GetNotificationsRequest, $eAp0I.GetNotificationsResponse, /**
   * @param {!proto.notification_service.GetNotificationsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $eAp0I.GetNotificationsResponse.deserializeBinary);
/**
 * @param {!proto.notification_service.GetNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification_service.GetNotificationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification_service.GetNotificationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.NotificationServiceClient.prototype.getNotifications = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.NotificationService/GetNotifications', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_NotificationService_GetNotifications, callback);
};
/**
 * @param {!proto.notification_service.GetNotificationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification_service.GetNotificationsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.NotificationServicePromiseClient.prototype.getNotifications = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.NotificationService/GetNotifications', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_NotificationService_GetNotifications);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.notification_service.UpdateNotificationStatusRequest,
 *   !proto.notification_service.UpdateNotificationStatusResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_NotificationService_UpdateNotificationStatus = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.NotificationService/UpdateNotificationStatus', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $eAp0I.UpdateNotificationStatusRequest, $eAp0I.UpdateNotificationStatusResponse, /**
   * @param {!proto.notification_service.UpdateNotificationStatusRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $eAp0I.UpdateNotificationStatusResponse.deserializeBinary);
/**
 * @param {!proto.notification_service.UpdateNotificationStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.notification_service.UpdateNotificationStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.notification_service.UpdateNotificationStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.NotificationServiceClient.prototype.updateNotificationStatus = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.NotificationService/UpdateNotificationStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_NotificationService_UpdateNotificationStatus, callback);
};
/**
 * @param {!proto.notification_service.UpdateNotificationStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.notification_service.UpdateNotificationStatusResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.NotificationServicePromiseClient.prototype.updateNotificationStatus = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.NotificationService/UpdateNotificationStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_NotificationService_UpdateNotificationStatus);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.GetOwnDocumentsRequest,
 *   !proto.document_service.GetOwnDocumentsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_GetOwnDocuments = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/GetOwnDocuments', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.GetOwnDocumentsRequest, $cyjZp.GetOwnDocumentsResponse, /**
   * @param {!proto.document_service.GetOwnDocumentsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.GetOwnDocumentsResponse.deserializeBinary);
/**
 * @param {!proto.document_service.GetOwnDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.GetOwnDocumentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.GetOwnDocumentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.getOwnDocuments = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/GetOwnDocuments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_GetOwnDocuments, callback);
};
/**
 * @param {!proto.document_service.GetOwnDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.GetOwnDocumentsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.getOwnDocuments = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/GetOwnDocuments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_GetOwnDocuments);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.GetOwnDocumentRequest,
 *   !proto.document_service.GetOwnDocumentResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_GetOwnDocument = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/GetOwnDocument', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.GetOwnDocumentRequest, $cyjZp.GetOwnDocumentResponse, /**
   * @param {!proto.document_service.GetOwnDocumentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.GetOwnDocumentResponse.deserializeBinary);
/**
 * @param {!proto.document_service.GetOwnDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.GetOwnDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.GetOwnDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.getOwnDocument = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/GetOwnDocument', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_GetOwnDocument, callback);
};
/**
 * @param {!proto.document_service.GetOwnDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.GetOwnDocumentResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.getOwnDocument = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/GetOwnDocument', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_GetOwnDocument);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.UploadVehicleDocumentRequest,
 *   !proto.document_service.UploadVehicleDocumentResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_UploadVehicleDocument = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/UploadVehicleDocument', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.UploadVehicleDocumentRequest, $cyjZp.UploadVehicleDocumentResponse, /**
   * @param {!proto.document_service.UploadVehicleDocumentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.UploadVehicleDocumentResponse.deserializeBinary);
/**
 * @param {!proto.document_service.UploadVehicleDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.UploadVehicleDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.UploadVehicleDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.uploadVehicleDocument = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/UploadVehicleDocument', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_UploadVehicleDocument, callback);
};
/**
 * @param {!proto.document_service.UploadVehicleDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.UploadVehicleDocumentResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.uploadVehicleDocument = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/UploadVehicleDocument', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_UploadVehicleDocument);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.UploadSingleCustomerInspectionImageRequest,
 *   !proto.document_service.UploadSingleCustomerInspectionImageResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_UploadSingleCustomerInspectionImage = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/UploadSingleCustomerInspectionImage', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.UploadSingleCustomerInspectionImageRequest, $cyjZp.UploadSingleCustomerInspectionImageResponse, /**
   * @param {!proto.document_service.UploadSingleCustomerInspectionImageRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.UploadSingleCustomerInspectionImageResponse.deserializeBinary);
/**
 * @param {!proto.document_service.UploadSingleCustomerInspectionImageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.UploadSingleCustomerInspectionImageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.UploadSingleCustomerInspectionImageResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.uploadSingleCustomerInspectionImage = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/UploadSingleCustomerInspectionImage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_UploadSingleCustomerInspectionImage, callback);
};
/**
 * @param {!proto.document_service.UploadSingleCustomerInspectionImageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.UploadSingleCustomerInspectionImageResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.uploadSingleCustomerInspectionImage = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/UploadSingleCustomerInspectionImage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_UploadSingleCustomerInspectionImage);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.UploadCustomerInspectionImageRequest,
 *   !proto.document_service.UploadCustomerInspectionImageResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_UploadCustomerInspectionImage = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/UploadCustomerInspectionImage', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.UploadCustomerInspectionImageRequest, $cyjZp.UploadCustomerInspectionImageResponse, /**
   * @param {!proto.document_service.UploadCustomerInspectionImageRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.UploadCustomerInspectionImageResponse.deserializeBinary);
/**
 * @param {!proto.document_service.UploadCustomerInspectionImageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.UploadCustomerInspectionImageResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.UploadCustomerInspectionImageResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.uploadCustomerInspectionImage = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/UploadCustomerInspectionImage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_UploadCustomerInspectionImage, callback);
};
/**
 * @param {!proto.document_service.UploadCustomerInspectionImageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.UploadCustomerInspectionImageResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.uploadCustomerInspectionImage = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/UploadCustomerInspectionImage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_UploadCustomerInspectionImage);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.UploadInsuranceCardRequest,
 *   !proto.document_service.UploadInsuranceCardResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_UploadInsuranceCard = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/UploadInsuranceCard', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.UploadInsuranceCardRequest, $cyjZp.UploadInsuranceCardResponse, /**
   * @param {!proto.document_service.UploadInsuranceCardRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.UploadInsuranceCardResponse.deserializeBinary);
/**
 * @param {!proto.document_service.UploadInsuranceCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.UploadInsuranceCardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.UploadInsuranceCardResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.uploadInsuranceCard = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/UploadInsuranceCard', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_UploadInsuranceCard, callback);
};
/**
 * @param {!proto.document_service.UploadInsuranceCardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.UploadInsuranceCardResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.uploadInsuranceCard = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/UploadInsuranceCard', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_UploadInsuranceCard);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.GetCustomerDocumentRequest,
 *   !proto.document_service.GetCustomerDocumentResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_GetCustomerDocument = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/GetCustomerDocument', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.GetCustomerDocumentRequest, $cyjZp.GetCustomerDocumentResponse, /**
   * @param {!proto.document_service.GetCustomerDocumentRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.GetCustomerDocumentResponse.deserializeBinary);
/**
 * @param {!proto.document_service.GetCustomerDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.GetCustomerDocumentResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.GetCustomerDocumentResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.getCustomerDocument = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/GetCustomerDocument', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_GetCustomerDocument, callback);
};
/**
 * @param {!proto.document_service.GetCustomerDocumentRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.GetCustomerDocumentResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.getCustomerDocument = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/GetCustomerDocument', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_GetCustomerDocument);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.GetCustomerDocumentsRequest,
 *   !proto.document_service.GetCustomerDocumentsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_GetCustomerDocuments = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/GetCustomerDocuments', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.GetCustomerDocumentsRequest, $cyjZp.GetCustomerDocumentsResponse, /**
   * @param {!proto.document_service.GetCustomerDocumentsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.GetCustomerDocumentsResponse.deserializeBinary);
/**
 * @param {!proto.document_service.GetCustomerDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.GetCustomerDocumentsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.GetCustomerDocumentsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.getCustomerDocuments = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/GetCustomerDocuments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_GetCustomerDocuments, callback);
};
/**
 * @param {!proto.document_service.GetCustomerDocumentsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.GetCustomerDocumentsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.getCustomerDocuments = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/GetCustomerDocuments', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_GetCustomerDocuments);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.document_service.PopulateTemplateRequest,
 *   !proto.document_service.PopulateTemplateResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_DocumentService_PopulateTemplate = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.DocumentService/PopulateTemplate', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $cyjZp.PopulateTemplateRequest, $cyjZp.PopulateTemplateResponse, /**
   * @param {!proto.document_service.PopulateTemplateRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $cyjZp.PopulateTemplateResponse.deserializeBinary);
/**
 * @param {!proto.document_service.PopulateTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.document_service.PopulateTemplateResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.document_service.PopulateTemplateResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServiceClient.prototype.populateTemplate = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.DocumentService/PopulateTemplate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_PopulateTemplate, callback);
};
/**
 * @param {!proto.document_service.PopulateTemplateRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.document_service.PopulateTemplateResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.DocumentServicePromiseClient.prototype.populateTemplate = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.DocumentService/PopulateTemplate', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_DocumentService_PopulateTemplate);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.NexusServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.NexusServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.nexus_service.GetCustomerRequest,
 *   !proto.nexus_service.GetCustomerResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_NexusService_GetCustomer = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.NexusService/GetCustomer', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $dsvHa.GetCustomerRequest, $dsvHa.GetCustomerResponse, /**
   * @param {!proto.nexus_service.GetCustomerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $dsvHa.GetCustomerResponse.deserializeBinary);
/**
 * @param {!proto.nexus_service.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.nexus_service.GetCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.nexus_service.GetCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.NexusServiceClient.prototype.getCustomer = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.NexusService/GetCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_NexusService_GetCustomer, callback);
};
/**
 * @param {!proto.nexus_service.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.nexus_service.GetCustomerResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.NexusServicePromiseClient.prototype.getCustomer = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.NexusService/GetCustomer', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_NexusService_GetCustomer);
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $df70feab7068291e$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetOwnAccountBalanceRequest,
 *   !proto.billing_service.GetAccountBalanceResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnAccountBalance = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetOwnAccountBalance', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetOwnAccountBalanceRequest, $26u10.GetAccountBalanceResponse, /**
   * @param {!proto.billing_service.GetOwnAccountBalanceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetAccountBalanceResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.GetOwnAccountBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetAccountBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetAccountBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getOwnAccountBalance = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetOwnAccountBalance', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnAccountBalance, callback);
};
/**
 * @param {!proto.billing_service.GetOwnAccountBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetAccountBalanceResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getOwnAccountBalance = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetOwnAccountBalance', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnAccountBalance);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ListOwnInvoicesRequest,
 *   !proto.billing_service.ListInvoicesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnInvoices = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListOwnInvoices', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ListOwnInvoicesRequest, $26u10.ListInvoicesResponse, /**
   * @param {!proto.billing_service.ListOwnInvoicesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListInvoicesResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ListOwnInvoicesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListInvoicesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListInvoicesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listOwnInvoices = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListOwnInvoices', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnInvoices, callback);
};
/**
 * @param {!proto.billing_service.ListOwnInvoicesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListInvoicesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listOwnInvoices = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListOwnInvoices', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnInvoices);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreateReservationRequest,
 *   !proto.billing_service.Reservation>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_CreateProgramReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/CreateProgramReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.CreateReservationRequest, $26u10.Reservation, /**
   * @param {!proto.billing_service.CreateReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.Reservation.deserializeBinary);
/**
 * @param {!proto.billing_service.CreateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.Reservation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.Reservation>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.createProgramReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/CreateProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateProgramReservation, callback);
};
/**
 * @param {!proto.billing_service.CreateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.Reservation>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.createProgramReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/CreateProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateProgramReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreateReservationRequest,
 *   !proto.billing_service.Reservation>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_CreateOwnProgramReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/CreateOwnProgramReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.CreateReservationRequest, $26u10.Reservation, /**
   * @param {!proto.billing_service.CreateReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.Reservation.deserializeBinary);
/**
 * @param {!proto.billing_service.CreateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.Reservation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.Reservation>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.createOwnProgramReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/CreateOwnProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateOwnProgramReservation, callback);
};
/**
 * @param {!proto.billing_service.CreateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.Reservation>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.createOwnProgramReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/CreateOwnProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateOwnProgramReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdateReservationRequest,
 *   !proto.billing_service.Reservation>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOwnProgramReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdateOwnProgramReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdateReservationRequest, $26u10.Reservation, /**
   * @param {!proto.billing_service.UpdateReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.Reservation.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.Reservation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.Reservation>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updateOwnProgramReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdateOwnProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOwnProgramReservation, callback);
};
/**
 * @param {!proto.billing_service.UpdateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.Reservation>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updateOwnProgramReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdateOwnProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOwnProgramReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdateReservationRequest,
 *   !proto.billing_service.Reservation>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdateProgramReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdateProgramReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdateReservationRequest, $26u10.Reservation, /**
   * @param {!proto.billing_service.UpdateReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.Reservation.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.Reservation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.Reservation>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updateProgramReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdateProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateProgramReservation, callback);
};
/**
 * @param {!proto.billing_service.UpdateReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.Reservation>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updateProgramReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdateProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateProgramReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetReservationRequest,
 *   !proto.billing_service.Reservation>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnProgramReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetOwnProgramReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetReservationRequest, $26u10.Reservation, /**
   * @param {!proto.billing_service.GetReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.Reservation.deserializeBinary);
/**
 * @param {!proto.billing_service.GetReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.Reservation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.Reservation>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getOwnProgramReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetOwnProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnProgramReservation, callback);
};
/**
 * @param {!proto.billing_service.GetReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.Reservation>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getOwnProgramReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetOwnProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnProgramReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetReservationRequest,
 *   !proto.billing_service.Reservation>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetProgramReservation = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetProgramReservation', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetReservationRequest, $26u10.Reservation, /**
   * @param {!proto.billing_service.GetReservationRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.Reservation.deserializeBinary);
/**
 * @param {!proto.billing_service.GetReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.Reservation)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.Reservation>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getProgramReservation = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetProgramReservation, callback);
};
/**
 * @param {!proto.billing_service.GetReservationRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.Reservation>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getProgramReservation = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetProgramReservation', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetProgramReservation);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ListProgramsRequest,
 *   !proto.billing_service.ListProgramsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramOfferings = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListProgramOfferings', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ListProgramsRequest, $26u10.ListProgramsResponse, /**
   * @param {!proto.billing_service.ListProgramsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListProgramsResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ListProgramsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListProgramsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListProgramsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listProgramOfferings = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListProgramOfferings', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramOfferings, callback);
};
/**
 * @param {!proto.billing_service.ListProgramsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListProgramsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listProgramOfferings = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListProgramOfferings', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramOfferings);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.DetailsRequest,
 *   !proto.billing_service.PromotionDetails>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetPromotionDetails = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetPromotionDetails', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.DetailsRequest, $26u10.PromotionDetails, /**
   * @param {!proto.billing_service.DetailsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.PromotionDetails.deserializeBinary);
/**
 * @param {!proto.billing_service.DetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.PromotionDetails)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.PromotionDetails>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getPromotionDetails = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetPromotionDetails', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetPromotionDetails, callback);
};
/**
 * @param {!proto.billing_service.DetailsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.PromotionDetails>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getPromotionDetails = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetPromotionDetails', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetPromotionDetails);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.RedemptionRequest,
 *   !proto.billing_service.RedemptionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_RedeemPromotion = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/RedeemPromotion', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.RedemptionRequest, $26u10.RedemptionResponse, /**
   * @param {!proto.billing_service.RedemptionRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.RedemptionResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.RedemptionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.RedemptionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.RedemptionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.redeemPromotion = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/RedeemPromotion', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RedeemPromotion, callback);
};
/**
 * @param {!proto.billing_service.RedemptionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.RedemptionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.redeemPromotion = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/RedeemPromotion', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RedeemPromotion);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ReferralCodeRequest,
 *   !proto.billing_service.ReferralCodeResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetReferralCode = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetReferralCode', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ReferralCodeRequest, $26u10.ReferralCodeResponse, /**
   * @param {!proto.billing_service.ReferralCodeRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ReferralCodeResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ReferralCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ReferralCodeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ReferralCodeResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getReferralCode = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetReferralCode', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetReferralCode, callback);
};
/**
 * @param {!proto.billing_service.ReferralCodeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ReferralCodeResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getReferralCode = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetReferralCode', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetReferralCode);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetAccountBalanceRequest,
 *   !proto.billing_service.GetAccountBalanceResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetAccountBalance = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetAccountBalance', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetAccountBalanceRequest, $26u10.GetAccountBalanceResponse, /**
   * @param {!proto.billing_service.GetAccountBalanceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetAccountBalanceResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.GetAccountBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetAccountBalanceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetAccountBalanceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getAccountBalance = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetAccountBalance', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetAccountBalance, callback);
};
/**
 * @param {!proto.billing_service.GetAccountBalanceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetAccountBalanceResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getAccountBalance = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetAccountBalance', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetAccountBalance);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.web.SearchParams,
 *   !proto.billing_service.ListInvoicesResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListInvoices = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListInvoices', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9c7Du.SearchParams, $26u10.ListInvoicesResponse, /**
   * @param {!proto.web.SearchParams} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListInvoicesResponse.deserializeBinary);
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListInvoicesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListInvoicesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listInvoices = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListInvoices', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListInvoices, callback);
};
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListInvoicesResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listInvoices = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListInvoices', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListInvoices);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreatePromotionRequest,
 *   !proto.billing_service.CreatePromotionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_CreatePromotion = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/CreatePromotion', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.CreatePromotionRequest, $26u10.CreatePromotionResponse, /**
   * @param {!proto.billing_service.CreatePromotionRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.CreatePromotionResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.CreatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.CreatePromotionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.CreatePromotionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.createPromotion = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/CreatePromotion', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreatePromotion, callback);
};
/**
 * @param {!proto.billing_service.CreatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.CreatePromotionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.createPromotion = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/CreatePromotion', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreatePromotion);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdatePromotionRequest,
 *   !proto.billing_service.UpdatePromotionResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdatePromotion = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdatePromotion', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdatePromotionRequest, $26u10.UpdatePromotionResponse, /**
   * @param {!proto.billing_service.UpdatePromotionRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.UpdatePromotionResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.UpdatePromotionResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.UpdatePromotionResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updatePromotion = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdatePromotion', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdatePromotion, callback);
};
/**
 * @param {!proto.billing_service.UpdatePromotionRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.UpdatePromotionResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updatePromotion = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdatePromotion', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdatePromotion);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.web.SearchParams,
 *   !proto.billing_service.ListPromotionsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListPromotions = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListPromotions', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9c7Du.SearchParams, $26u10.ListPromotionsResponse, /**
   * @param {!proto.web.SearchParams} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListPromotionsResponse.deserializeBinary);
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListPromotionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListPromotionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listPromotions = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListPromotions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListPromotions, callback);
};
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListPromotionsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listPromotions = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListPromotions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListPromotions);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.web.SearchParams,
 *   !proto.billing_service.ListReservationsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramReservations = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListProgramReservations', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9c7Du.SearchParams, $26u10.ListReservationsResponse, /**
   * @param {!proto.web.SearchParams} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListReservationsResponse.deserializeBinary);
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListReservationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListReservationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listProgramReservations = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListProgramReservations', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramReservations, callback);
};
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListReservationsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listProgramReservations = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListProgramReservations', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramReservations);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ListOwnProgramReservationsRequest,
 *   !proto.billing_service.ListReservationsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnProgramReservations = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListOwnProgramReservations', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ListOwnProgramReservationsRequest, $26u10.ListReservationsResponse, /**
   * @param {!proto.billing_service.ListOwnProgramReservationsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListReservationsResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ListOwnProgramReservationsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListReservationsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListReservationsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listOwnProgramReservations = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListOwnProgramReservations', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnProgramReservations, callback);
};
/**
 * @param {!proto.billing_service.ListOwnProgramReservationsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListReservationsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listOwnProgramReservations = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListOwnProgramReservations', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnProgramReservations);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.web.SearchParams,
 *   !proto.billing_service.ListProductsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListProductOfferings = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListProductOfferings', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9c7Du.SearchParams, $26u10.ListProductsResponse, /**
   * @param {!proto.web.SearchParams} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListProductsResponse.deserializeBinary);
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListProductsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListProductsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listProductOfferings = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListProductOfferings', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListProductOfferings, callback);
};
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListProductsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listProductOfferings = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListProductOfferings', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListProductOfferings);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.AddToOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_AddToOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/AddToOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.AddToOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.AddToOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.AddToOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.addToOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/AddToOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_AddToOrder, callback);
};
/**
 * @param {!proto.billing_service.AddToOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.addToOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/AddToOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_AddToOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ListProgramPricingRequest,
 *   !proto.billing_service.ListProgramPricingResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramPricing = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListProgramPricing', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ListProgramPricingRequest, $26u10.ListProgramPricingResponse, /**
   * @param {!proto.billing_service.ListProgramPricingRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListProgramPricingResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ListProgramPricingRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListProgramPricingResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListProgramPricingResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listProgramPricing = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListProgramPricing', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramPricing, callback);
};
/**
 * @param {!proto.billing_service.ListProgramPricingRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListProgramPricingResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listProgramPricing = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListProgramPricing', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListProgramPricing);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreatePromotionPartnerRequest,
 *   !proto.billing_service.CreatePromotionPartnerResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_CreatePromotionPartner = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/CreatePromotionPartner', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.CreatePromotionPartnerRequest, $26u10.CreatePromotionPartnerResponse, /**
   * @param {!proto.billing_service.CreatePromotionPartnerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.CreatePromotionPartnerResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.CreatePromotionPartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.CreatePromotionPartnerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.CreatePromotionPartnerResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.createPromotionPartner = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/CreatePromotionPartner', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreatePromotionPartner, callback);
};
/**
 * @param {!proto.billing_service.CreatePromotionPartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.CreatePromotionPartnerResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.createPromotionPartner = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/CreatePromotionPartner', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreatePromotionPartner);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdatePromotionPartnerRequest,
 *   !proto.billing_service.UpdatePromotionPartnerResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdatePromotionPartner = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdatePromotionPartner', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdatePromotionPartnerRequest, $26u10.UpdatePromotionPartnerResponse, /**
   * @param {!proto.billing_service.UpdatePromotionPartnerRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.UpdatePromotionPartnerResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdatePromotionPartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.UpdatePromotionPartnerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.UpdatePromotionPartnerResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updatePromotionPartner = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdatePromotionPartner', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdatePromotionPartner, callback);
};
/**
 * @param {!proto.billing_service.UpdatePromotionPartnerRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.UpdatePromotionPartnerResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updatePromotionPartner = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdatePromotionPartner', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdatePromotionPartner);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.web.SearchParams,
 *   !proto.billing_service.ListPromotionPartnersResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListPromotionPartners = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListPromotionPartners', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9c7Du.SearchParams, $26u10.ListPromotionPartnersResponse, /**
   * @param {!proto.web.SearchParams} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListPromotionPartnersResponse.deserializeBinary);
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListPromotionPartnersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListPromotionPartnersResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listPromotionPartners = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListPromotionPartners', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListPromotionPartners, callback);
};
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListPromotionPartnersResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listPromotionPartners = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListPromotionPartners', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListPromotionPartners);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreateFeeInvoiceRequest,
 *   !proto.billing_service.CreateFeeInvoiceResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_CreateFeeInvoice = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/CreateFeeInvoice', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.CreateFeeInvoiceRequest, $26u10.CreateFeeInvoiceResponse, /**
   * @param {!proto.billing_service.CreateFeeInvoiceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.CreateFeeInvoiceResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.CreateFeeInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.CreateFeeInvoiceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.CreateFeeInvoiceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.createFeeInvoice = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/CreateFeeInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateFeeInvoice, callback);
};
/**
 * @param {!proto.billing_service.CreateFeeInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.CreateFeeInvoiceResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.createFeeInvoice = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/CreateFeeInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateFeeInvoice);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreateOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_CreateOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/CreateOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.CreateOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.CreateOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.CreateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.createOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/CreateOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateOrder, callback);
};
/**
 * @param {!proto.billing_service.CreateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.createOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/CreateOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.CreateOwnOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_CreateOwnOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/CreateOwnOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.CreateOwnOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.CreateOwnOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.CreateOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.createOwnOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/CreateOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateOwnOrder, callback);
};
/**
 * @param {!proto.billing_service.CreateOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.createOwnOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/CreateOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_CreateOwnOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdateOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdateOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdateOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.UpdateOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updateOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdateOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOrder, callback);
};
/**
 * @param {!proto.billing_service.UpdateOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updateOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdateOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdateOwnOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOwnOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdateOwnOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdateOwnOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.UpdateOwnOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdateOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updateOwnOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdateOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOwnOrder, callback);
};
/**
 * @param {!proto.billing_service.UpdateOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updateOwnOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdateOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateOwnOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.AddToOwnOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_AddToOwnOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/AddToOwnOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.AddToOwnOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.AddToOwnOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.AddToOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.addToOwnOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/AddToOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_AddToOwnOrder, callback);
};
/**
 * @param {!proto.billing_service.AddToOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.addToOwnOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/AddToOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_AddToOwnOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.RemoveFromOwnOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_RemoveFromOwnOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/RemoveFromOwnOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.RemoveFromOwnOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.RemoveFromOwnOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.RemoveFromOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.removeFromOwnOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/RemoveFromOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveFromOwnOrder, callback);
};
/**
 * @param {!proto.billing_service.RemoveFromOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.removeFromOwnOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/RemoveFromOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveFromOwnOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.RemoveFromOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_RemoveFromOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/RemoveFromOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.RemoveFromOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.RemoveFromOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.RemoveFromOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.removeFromOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/RemoveFromOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveFromOrder, callback);
};
/**
 * @param {!proto.billing_service.RemoveFromOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.removeFromOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/RemoveFromOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveFromOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetOwnLatestDraftOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnLatestDraftOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetOwnLatestDraftOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetOwnLatestDraftOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.GetOwnLatestDraftOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.GetOwnLatestDraftOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getOwnLatestDraftOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetOwnLatestDraftOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnLatestDraftOrder, callback);
};
/**
 * @param {!proto.billing_service.GetOwnLatestDraftOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getOwnLatestDraftOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetOwnLatestDraftOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnLatestDraftOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetLatestDraftOrderRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetLatestDraftOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetLatestDraftOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetLatestDraftOrderRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.GetLatestDraftOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.GetLatestDraftOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getLatestDraftOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetLatestDraftOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetLatestDraftOrder, callback);
};
/**
 * @param {!proto.billing_service.GetLatestDraftOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getLatestDraftOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetLatestDraftOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetLatestDraftOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.DeleteOrderRequest,
 *   !proto.billing_service.DeleteOrderResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_DeleteOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/DeleteOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.DeleteOrderRequest, $26u10.DeleteOrderResponse, /**
   * @param {!proto.billing_service.DeleteOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.DeleteOrderResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.DeleteOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.DeleteOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.DeleteOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.deleteOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/DeleteOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_DeleteOrder, callback);
};
/**
 * @param {!proto.billing_service.DeleteOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.DeleteOrderResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.deleteOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/DeleteOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_DeleteOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.DeleteOwnOrderRequest,
 *   !proto.billing_service.DeleteOrderResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_DeleteOwnOrder = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/DeleteOwnOrder', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.DeleteOwnOrderRequest, $26u10.DeleteOrderResponse, /**
   * @param {!proto.billing_service.DeleteOwnOrderRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.DeleteOrderResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.DeleteOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.DeleteOrderResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.DeleteOrderResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.deleteOwnOrder = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/DeleteOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_DeleteOwnOrder, callback);
};
/**
 * @param {!proto.billing_service.DeleteOwnOrderRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.DeleteOrderResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.deleteOwnOrder = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/DeleteOwnOrder', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_DeleteOwnOrder);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ConvertOrderToInvoiceRequest,
 *   !proto.billing_service.ConvertOrderToInvoiceResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ConvertOrderToInvoice = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ConvertOrderToInvoice', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ConvertOrderToInvoiceRequest, $26u10.ConvertOrderToInvoiceResponse, /**
   * @param {!proto.billing_service.ConvertOrderToInvoiceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ConvertOrderToInvoiceResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ConvertOrderToInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ConvertOrderToInvoiceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ConvertOrderToInvoiceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.convertOrderToInvoice = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ConvertOrderToInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ConvertOrderToInvoice, callback);
};
/**
 * @param {!proto.billing_service.ConvertOrderToInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ConvertOrderToInvoiceResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.convertOrderToInvoice = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ConvertOrderToInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ConvertOrderToInvoice);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ConvertOwnOrderToInvoiceRequest,
 *   !proto.billing_service.ConvertOrderToInvoiceResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ConvertOwnOrderToInvoice = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ConvertOwnOrderToInvoice', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ConvertOwnOrderToInvoiceRequest, $26u10.ConvertOrderToInvoiceResponse, /**
   * @param {!proto.billing_service.ConvertOwnOrderToInvoiceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ConvertOrderToInvoiceResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ConvertOwnOrderToInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ConvertOrderToInvoiceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ConvertOrderToInvoiceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.convertOwnOrderToInvoice = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ConvertOwnOrderToInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ConvertOwnOrderToInvoice, callback);
};
/**
 * @param {!proto.billing_service.ConvertOwnOrderToInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ConvertOrderToInvoiceResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.convertOwnOrderToInvoice = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ConvertOwnOrderToInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ConvertOwnOrderToInvoice);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.PayInvoiceRequest,
 *   !proto.billing_service.PayInvoiceResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_PayInvoice = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/PayInvoice', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.PayInvoiceRequest, $26u10.PayInvoiceResponse, /**
   * @param {!proto.billing_service.PayInvoiceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.PayInvoiceResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.PayInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.PayInvoiceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.PayInvoiceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.payInvoice = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/PayInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_PayInvoice, callback);
};
/**
 * @param {!proto.billing_service.PayInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.PayInvoiceResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.payInvoice = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/PayInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_PayInvoice);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetBillingStatusRequest,
 *   !proto.billing_service.GetBillingStatusResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetBillingStatus = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetBillingStatus', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetBillingStatusRequest, $26u10.GetBillingStatusResponse, /**
   * @param {!proto.billing_service.GetBillingStatusRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetBillingStatusResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.GetBillingStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetBillingStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetBillingStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getBillingStatus = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetBillingStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetBillingStatus, callback);
};
/**
 * @param {!proto.billing_service.GetBillingStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetBillingStatusResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getBillingStatus = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetBillingStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetBillingStatus);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetOwnBillingStatusRequest,
 *   !proto.billing_service.GetBillingStatusResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnBillingStatus = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetOwnBillingStatus', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetOwnBillingStatusRequest, $26u10.GetBillingStatusResponse, /**
   * @param {!proto.billing_service.GetOwnBillingStatusRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetBillingStatusResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.GetOwnBillingStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetBillingStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetBillingStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getOwnBillingStatus = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetOwnBillingStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnBillingStatus, callback);
};
/**
 * @param {!proto.billing_service.GetOwnBillingStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetBillingStatusResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getOwnBillingStatus = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetOwnBillingStatus', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnBillingStatus);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetDriveOffInvoiceRequest,
 *   !proto.billing_service.InvoiceFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetDriveOffInvoice = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetDriveOffInvoice', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetDriveOffInvoiceRequest, $26u10.InvoiceFE, /**
   * @param {!proto.billing_service.GetDriveOffInvoiceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.InvoiceFE.deserializeBinary);
/**
 * @param {!proto.billing_service.GetDriveOffInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.InvoiceFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.InvoiceFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getDriveOffInvoice = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetDriveOffInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetDriveOffInvoice, callback);
};
/**
 * @param {!proto.billing_service.GetDriveOffInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.InvoiceFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getDriveOffInvoice = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetDriveOffInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetDriveOffInvoice);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetOwnDriveOffInvoiceRequest,
 *   !proto.billing_service.InvoiceFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnDriveOffInvoice = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetOwnDriveOffInvoice', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetOwnDriveOffInvoiceRequest, $26u10.InvoiceFE, /**
   * @param {!proto.billing_service.GetOwnDriveOffInvoiceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.InvoiceFE.deserializeBinary);
/**
 * @param {!proto.billing_service.GetOwnDriveOffInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.InvoiceFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.InvoiceFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getOwnDriveOffInvoice = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetOwnDriveOffInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnDriveOffInvoice, callback);
};
/**
 * @param {!proto.billing_service.GetOwnDriveOffInvoiceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.InvoiceFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getOwnDriveOffInvoice = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetOwnDriveOffInvoice', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnDriveOffInvoice);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetSubscriptionByIdRequest,
 *   !proto.billing_service.Subscription>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetSubscriptionById = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetSubscriptionById', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetSubscriptionByIdRequest, $26u10.Subscription, /**
   * @param {!proto.billing_service.GetSubscriptionByIdRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.Subscription.deserializeBinary);
/**
 * @param {!proto.billing_service.GetSubscriptionByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.Subscription)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.Subscription>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getSubscriptionById = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetSubscriptionById', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetSubscriptionById, callback);
};
/**
 * @param {!proto.billing_service.GetSubscriptionByIdRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.Subscription>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getSubscriptionById = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetSubscriptionById', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetSubscriptionById);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.web.SearchParams,
 *   !proto.billing_service.ListSubscriptionsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListSubscriptions = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListSubscriptions', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $9c7Du.SearchParams, $26u10.ListSubscriptionsResponse, /**
   * @param {!proto.web.SearchParams} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListSubscriptionsResponse.deserializeBinary);
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListSubscriptionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListSubscriptionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listSubscriptions = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListSubscriptions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListSubscriptions, callback);
};
/**
 * @param {!proto.web.SearchParams} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListSubscriptionsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listSubscriptions = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListSubscriptions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListSubscriptions);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ListOwnSubscriptionsRequest,
 *   !proto.billing_service.ListSubscriptionsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnSubscriptions = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListOwnSubscriptions', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ListOwnSubscriptionsRequest, $26u10.ListSubscriptionsResponse, /**
   * @param {!proto.billing_service.ListOwnSubscriptionsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListSubscriptionsResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ListOwnSubscriptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListSubscriptionsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListSubscriptionsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listOwnSubscriptions = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListOwnSubscriptions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnSubscriptions, callback);
};
/**
 * @param {!proto.billing_service.ListOwnSubscriptionsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListSubscriptionsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listOwnSubscriptions = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListOwnSubscriptions', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListOwnSubscriptions);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ListRecurringBillableItemsRequest,
 *   !proto.billing_service.ListRecurringBillableItemsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ListRecurringBillableItems = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ListRecurringBillableItems', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ListRecurringBillableItemsRequest, $26u10.ListRecurringBillableItemsResponse, /**
   * @param {!proto.billing_service.ListRecurringBillableItemsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListRecurringBillableItemsResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ListRecurringBillableItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListRecurringBillableItemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListRecurringBillableItemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.listRecurringBillableItems = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ListRecurringBillableItems', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListRecurringBillableItems, callback);
};
/**
 * @param {!proto.billing_service.ListRecurringBillableItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListRecurringBillableItemsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.listRecurringBillableItems = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ListRecurringBillableItems', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ListRecurringBillableItems);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdateRecurringBillableItemsRequest,
 *   !proto.billing_service.ListRecurringBillableItemsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdateRecurringBillableItems = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdateRecurringBillableItems', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdateRecurringBillableItemsRequest, $26u10.ListRecurringBillableItemsResponse, /**
   * @param {!proto.billing_service.UpdateRecurringBillableItemsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListRecurringBillableItemsResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdateRecurringBillableItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListRecurringBillableItemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListRecurringBillableItemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updateRecurringBillableItems = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdateRecurringBillableItems', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateRecurringBillableItems, callback);
};
/**
 * @param {!proto.billing_service.UpdateRecurringBillableItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListRecurringBillableItemsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updateRecurringBillableItems = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdateRecurringBillableItems', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateRecurringBillableItems);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.AddRecurringBillableItemsRequest,
 *   !proto.billing_service.ListRecurringBillableItemsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_AddRecurringBillableItems = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/AddRecurringBillableItems', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.AddRecurringBillableItemsRequest, $26u10.ListRecurringBillableItemsResponse, /**
   * @param {!proto.billing_service.AddRecurringBillableItemsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListRecurringBillableItemsResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.AddRecurringBillableItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListRecurringBillableItemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListRecurringBillableItemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.addRecurringBillableItems = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/AddRecurringBillableItems', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_AddRecurringBillableItems, callback);
};
/**
 * @param {!proto.billing_service.AddRecurringBillableItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListRecurringBillableItemsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.addRecurringBillableItems = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/AddRecurringBillableItems', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_AddRecurringBillableItems);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.RemoveRecurringBillableItemsRequest,
 *   !proto.billing_service.ListRecurringBillableItemsResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_RemoveRecurringBillableItems = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/RemoveRecurringBillableItems', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.RemoveRecurringBillableItemsRequest, $26u10.ListRecurringBillableItemsResponse, /**
   * @param {!proto.billing_service.RemoveRecurringBillableItemsRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ListRecurringBillableItemsResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.RemoveRecurringBillableItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ListRecurringBillableItemsResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ListRecurringBillableItemsResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.removeRecurringBillableItems = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/RemoveRecurringBillableItems', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveRecurringBillableItems, callback);
};
/**
 * @param {!proto.billing_service.RemoveRecurringBillableItemsRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ListRecurringBillableItemsResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.removeRecurringBillableItems = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/RemoveRecurringBillableItems', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveRecurringBillableItems);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetMileageRecurringBillableItemRequest,
 *   !proto.billing_service.GetMileageRecurringBillableItemResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetMileageRecurringBillableItem = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetMileageRecurringBillableItem', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetMileageRecurringBillableItemRequest, $26u10.GetMileageRecurringBillableItemResponse, /**
   * @param {!proto.billing_service.GetMileageRecurringBillableItemRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetMileageRecurringBillableItemResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.GetMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetMileageRecurringBillableItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetMileageRecurringBillableItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getMileageRecurringBillableItem = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetMileageRecurringBillableItem, callback);
};
/**
 * @param {!proto.billing_service.GetMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetMileageRecurringBillableItemResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getMileageRecurringBillableItem = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetMileageRecurringBillableItem);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.GetOwnMileageRecurringBillableItemRequest,
 *   !proto.billing_service.GetMileageRecurringBillableItemResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnMileageRecurringBillableItem = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/GetOwnMileageRecurringBillableItem', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.GetOwnMileageRecurringBillableItemRequest, $26u10.GetMileageRecurringBillableItemResponse, /**
   * @param {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetMileageRecurringBillableItemResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetMileageRecurringBillableItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetMileageRecurringBillableItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.getOwnMileageRecurringBillableItem = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/GetOwnMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnMileageRecurringBillableItem, callback);
};
/**
 * @param {!proto.billing_service.GetOwnMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetMileageRecurringBillableItemResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.getOwnMileageRecurringBillableItem = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/GetOwnMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_GetOwnMileageRecurringBillableItem);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdateMileageRecurringBillableItemRequest,
 *   !proto.billing_service.GetMileageRecurringBillableItemResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdateMileageRecurringBillableItem = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdateMileageRecurringBillableItem', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdateMileageRecurringBillableItemRequest, $26u10.GetMileageRecurringBillableItemResponse, /**
   * @param {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetMileageRecurringBillableItemResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetMileageRecurringBillableItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetMileageRecurringBillableItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updateMileageRecurringBillableItem = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdateMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateMileageRecurringBillableItem, callback);
};
/**
 * @param {!proto.billing_service.UpdateMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetMileageRecurringBillableItemResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updateMileageRecurringBillableItem = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdateMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateMileageRecurringBillableItem);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.AddMileageRecurringBillableItemRequest,
 *   !proto.billing_service.GetMileageRecurringBillableItemResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_AddMileageRecurringBillableItem = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/AddMileageRecurringBillableItem', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.AddMileageRecurringBillableItemRequest, $26u10.GetMileageRecurringBillableItemResponse, /**
   * @param {!proto.billing_service.AddMileageRecurringBillableItemRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetMileageRecurringBillableItemResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.AddMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetMileageRecurringBillableItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetMileageRecurringBillableItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.addMileageRecurringBillableItem = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/AddMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_AddMileageRecurringBillableItem, callback);
};
/**
 * @param {!proto.billing_service.AddMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetMileageRecurringBillableItemResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.addMileageRecurringBillableItem = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/AddMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_AddMileageRecurringBillableItem);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.RemoveMileageRecurringBillableItemRequest,
 *   !proto.billing_service.GetMileageRecurringBillableItemResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_RemoveMileageRecurringBillableItem = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/RemoveMileageRecurringBillableItem', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.RemoveMileageRecurringBillableItemRequest, $26u10.GetMileageRecurringBillableItemResponse, /**
   * @param {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetMileageRecurringBillableItemResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetMileageRecurringBillableItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetMileageRecurringBillableItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.removeMileageRecurringBillableItem = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/RemoveMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveMileageRecurringBillableItem, callback);
};
/**
 * @param {!proto.billing_service.RemoveMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetMileageRecurringBillableItemResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.removeMileageRecurringBillableItem = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/RemoveMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveMileageRecurringBillableItem);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest,
 *   !proto.billing_service.GetMileageRecurringBillableItemResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_RemoveOwnMileageRecurringBillableItem = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/RemoveOwnMileageRecurringBillableItem', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.RemoveOwnMileageRecurringBillableItemRequest, $26u10.GetMileageRecurringBillableItemResponse, /**
   * @param {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.GetMileageRecurringBillableItemResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.GetMileageRecurringBillableItemResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.GetMileageRecurringBillableItemResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.removeOwnMileageRecurringBillableItem = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/RemoveOwnMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveOwnMileageRecurringBillableItem, callback);
};
/**
 * @param {!proto.billing_service.RemoveOwnMileageRecurringBillableItemRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.GetMileageRecurringBillableItemResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.removeOwnMileageRecurringBillableItem = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/RemoveOwnMileageRecurringBillableItem', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_RemoveOwnMileageRecurringBillableItem);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.UpdateRecurringBillingDayRequest,
 *   !proto.billing_service.UpdateRecurringBillingDayResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_UpdateRecurringBillingDay = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/UpdateRecurringBillingDay', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.UpdateRecurringBillingDayRequest, $26u10.UpdateRecurringBillingDayResponse, /**
   * @param {!proto.billing_service.UpdateRecurringBillingDayRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.UpdateRecurringBillingDayResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.UpdateRecurringBillingDayRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.UpdateRecurringBillingDayResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.UpdateRecurringBillingDayResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.updateRecurringBillingDay = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/UpdateRecurringBillingDay', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateRecurringBillingDay, callback);
};
/**
 * @param {!proto.billing_service.UpdateRecurringBillingDayRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.UpdateRecurringBillingDayResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.updateRecurringBillingDay = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/UpdateRecurringBillingDay', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_UpdateRecurringBillingDay);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.PurchaseOneTimeMileageRequest,
 *   !proto.billing_service.InvoiceFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_PurchaseOneTimeMileage = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/PurchaseOneTimeMileage', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.PurchaseOneTimeMileageRequest, $26u10.InvoiceFE, /**
   * @param {!proto.billing_service.PurchaseOneTimeMileageRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.InvoiceFE.deserializeBinary);
/**
 * @param {!proto.billing_service.PurchaseOneTimeMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.InvoiceFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.InvoiceFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.purchaseOneTimeMileage = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/PurchaseOneTimeMileage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_PurchaseOneTimeMileage, callback);
};
/**
 * @param {!proto.billing_service.PurchaseOneTimeMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.InvoiceFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.purchaseOneTimeMileage = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/PurchaseOneTimeMileage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_PurchaseOneTimeMileage);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.PurchaseRecurringMileageRequest,
 *   !proto.billing_service.OrderFE>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_PurchaseRecurringMileage = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/PurchaseRecurringMileage', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.PurchaseRecurringMileageRequest, $26u10.OrderFE, /**
   * @param {!proto.billing_service.PurchaseRecurringMileageRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.OrderFE.deserializeBinary);
/**
 * @param {!proto.billing_service.PurchaseRecurringMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.OrderFE)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.OrderFE>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.purchaseRecurringMileage = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/PurchaseRecurringMileage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_PurchaseRecurringMileage, callback);
};
/**
 * @param {!proto.billing_service.PurchaseRecurringMileageRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.OrderFE>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.purchaseRecurringMileage = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/PurchaseRecurringMileage', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_PurchaseRecurringMileage);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.billing_service.ReserveAndInfleetRequest,
 *   !proto.billing_service.ReserveAndInfleetResponse>}
 */ const $df70feab7068291e$var$methodDescriptor_BillingService_ReserveAndInfleet = new $df70feab7068291e$var$grpc.web.MethodDescriptor('/gateway_service.BillingService/ReserveAndInfleet', $df70feab7068291e$var$grpc.web.MethodType.UNARY, $26u10.ReserveAndInfleetRequest, $26u10.ReserveAndInfleetResponse, /**
   * @param {!proto.billing_service.ReserveAndInfleetRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $26u10.ReserveAndInfleetResponse.deserializeBinary);
/**
 * @param {!proto.billing_service.ReserveAndInfleetRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.billing_service.ReserveAndInfleetResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.billing_service.ReserveAndInfleetResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $df70feab7068291e$var$proto.gateway_service.BillingServiceClient.prototype.reserveAndInfleet = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/gateway_service.BillingService/ReserveAndInfleet', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ReserveAndInfleet, callback);
};
/**
 * @param {!proto.billing_service.ReserveAndInfleetRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.billing_service.ReserveAndInfleetResponse>}
 *     Promise that resolves to the response
 */ $df70feab7068291e$var$proto.gateway_service.BillingServicePromiseClient.prototype.reserveAndInfleet = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/gateway_service.BillingService/ReserveAndInfleet', request, metadata || {}, $df70feab7068291e$var$methodDescriptor_BillingService_ReserveAndInfleet);
};
$df70feab7068291e$exports = $df70feab7068291e$var$proto.gateway_service;



var $3QqPt = parcelRequire("3QqPt");


var $9c7Du = parcelRequire("9c7Du");



var $f1q41 = parcelRequire("f1q41");
function $45ee4ee0548ca22e$export$f14470e236d6ab6a(label = 'Spying on promise response') {
    console.log(`${label}: `);
    return function(res) {
        console.log(res);
        if ((0, $f1q41.isFunction)(res.toObject)) {
            console.log(`${label} \u{2014} As Object: `);
            console.log(res.toObject());
        }
        return res;
    };
}
function $45ee4ee0548ca22e$export$b35e4e49600c6304(label = 'Spying on promise error') {
    return function(err) {
        console.log(`${label}: `, err);
        throw err;
    };
}



var $dsvHa = parcelRequire("dsvHa");
const $756e67a155228bc1$export$a5d6e96836ac9239 = {
    listProducts: // addToOrder,
    $756e67a155228bc1$var$listProducts
};
function $756e67a155228bc1$var$getNexusService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $756e67a155228bc1$var$getBillingService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $df70feab7068291e$exports.BillingServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $756e67a155228bc1$export$eec313afae5c60c5(lineItemProduct) {
    const product = new (0, $3QqPt.Product)();
    const lineItemproductAmount = lineItemProduct.amount * 100;
    product.setId(lineItemProduct.id);
    product.setName(lineItemProduct.name);
    product.setDescription(lineItemProduct.description);
    product.setAmount(lineItemproductAmount);
    product.setCurrency(lineItemProduct.currency);
    product.setProductType(lineItemProduct.productType);
    product.setRecurring(lineItemProduct.recurring);
    product.setAddOn(lineItemProduct.addOn);
    return product;
}
async function $756e67a155228bc1$export$35b78bae575ec8aa() {
    const client = $756e67a155228bc1$var$getNexusService();
    const request = new (0, $9c7Du.SearchParams)();
    const pagination = new (0, $9c7Du.PaginationParams)();
    pagination.setLimit(1000);
    pagination.setOffset(0);
    request.setQueryList([]);
    request.setPagination(pagination);
    request.setOrderList([]);
    return client.listPromotions(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$26b1b4b5e5dc3cdb(params = {
    promoCode: '',
    rebateValue: 0,
    rebatePercent: 0,
    target: 0,
    source: 0,
    sourceId: '',
    validFrom: 0,
    validUntil: 0,
    status: true,
    constraintsList: []
}) {
    const client = $756e67a155228bc1$var$getNexusService();
    const request = $756e67a155228bc1$export$b17fbbafdbede568(params);
    return client.createPromotion(request).then((res)=>{
        return res.toObject();
    });
}
function $756e67a155228bc1$export$b17fbbafdbede568(promoRequest) {
    const request = new (0, $26u10.CreatePromotionRequest)();
    const promoConstraint = [];
    request.setPromoCode(promoRequest.promoCode);
    request.setRebateValue(promoRequest.rebateValue);
    request.setRebatePercent(promoRequest.rebatePercent);
    request.setTarget(promoRequest.target);
    request.setSource(promoRequest.source);
    request.setSourceId(promoRequest.sourceId);
    request.setValidFrom(promoRequest.validFrom);
    request.setValidUntil(promoRequest.validUntil);
    request.setStatus(promoRequest.status);
    request.setConstraintsList(promoConstraint);
    return request;
}
async function $756e67a155228bc1$export$29f92976ef700e34() {
    const client = $756e67a155228bc1$var$getNexusService();
    const request = new (0, $9c7Du.ListParams)();
    const pagination = new (0, $9c7Du.PaginationParams)();
    pagination.setLimit(50);
    pagination.setOffset(0);
    request.setQueryList([]);
    request.setPagination(pagination);
    request.setOrderList([]);
    return client.listPromotionPartners(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$dd1e464879d24301(params = {
    name: ''
}) {
    const client = $756e67a155228bc1$var$getNexusService();
    const request = new (0, $26u10.CreatePromotionPartnerRequest)();
    request.setName(params.name);
    return client.createPromotionPartner(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$3fea7341c6dda927(customerId) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $9c7Du.SearchParams)();
    const params = {
        queryList: [
            {
                property: 'customer_id',
                value: customerId,
                modifier: (0, $9c7Du.Modifier).EQUAL_TO
            }
        ],
        orderList: [
            {
                property: 'due_date',
                direction: 1
            }
        ],
        pagination: {
            limit: 100,
            offset: 0
        }
    };
    request.setQueryList($756e67a155228bc1$export$9e425aa3bc4615e4(params.queryList));
    request.setOrderList($756e67a155228bc1$export$6e056c4111eab585(params.orderList));
    request.setPagination($756e67a155228bc1$export$85165fa2c02223ff(params.pagination));
    return client.listInvoices(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$ca8160a3ac0b212(params = {
    customerId: ''
}) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $26u10.GetAccountBalanceRequest)();
    request.setCustomerId(params.customerId);
    return client.getAccountBalance(request).then((res)=>{
        return res.toObject();
    });
}
// function buildAddToOrderRequest(params: OrderFE.AsObject) {
//   const request = new AddToOrderRequest()
//   request.setCustomerId(params.customerId)
//   request.setDollarAmount(params.dollarAmount * 100)
//   request.setProductId(params.productId)
//   return request
// }
// async function addToOrder(params: AddToOrderRequest.AsObject) {
//   const client = getBillingService()
//   const request = buildAddToOrderRequest(params)
//   return client
//     .addToOrder(request)
//     .then((res) => res.toObject())
//     .catch(spyOnError('addToOrder'))
// }
async function $756e67a155228bc1$var$listProducts() {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $9c7Du.SearchParams)();
    return client.listProductOfferings(request).then((res)=>res.toObject()).catch((0, $45ee4ee0548ca22e$export$b35e4e49600c6304)('listProducts'));
}
function $756e67a155228bc1$export$9e425aa3bc4615e4(params) {
    const queryListRequestArray = params.map((queryParam)=>{
        const request = new (0, $9c7Du.QueryParams)();
        request.setProperty(queryParam.property);
        request.setValue(queryParam.value);
        request.setModifier(queryParam.modifier);
        return request;
    });
    return queryListRequestArray;
}
function $756e67a155228bc1$export$6e056c4111eab585(params) {
    const requestArray = params.map((queryParam)=>{
        const request = new (0, $9c7Du.OrderParams)();
        request.setProperty(queryParam.property);
        request.setDirection(queryParam.direction);
        return request;
    });
    return requestArray;
}
function $756e67a155228bc1$export$85165fa2c02223ff(params) {
    const request = new (0, $9c7Du.PaginationParams)();
    request.setLimit(params.limit);
    request.setOffset(params.offset);
    return request;
}
async function $756e67a155228bc1$export$715721e1ff07403e(clientId) {
    const client = $756e67a155228bc1$var$getNexusService();
    const request = new (0, $26u10.ListProgramPricingRequest)();
    request.setRemovehiddenprograms(false);
    request.setRemovehiddenprices(false);
    const newNexusReq = new (0, $dsvHa.NexusListProgramPricingRequest)();
    newNexusReq.setClientId(clientId);
    newNexusReq.setListProgramPricingRequest(request);
    return client.listProgramPricing(newNexusReq).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$a867816ede6e11d5(subscriptionId) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $26u10.GetBillingStatusRequest)();
    request.setSubscriptionId(subscriptionId);
    return client.getBillingStatus(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$16fd171b2bdd7a79(subscriptionId) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $26u10.GetSubscriptionByIdRequest)();
    request.setSubscriptionId(subscriptionId);
    return client.getSubscriptionById(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$4dc00ef85fd3c975(customerId) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $9c7Du.SearchParams)();
    const params = {
        queryList: [
            {
                property: 'customer_id',
                value: customerId,
                modifier: (0, $9c7Du.Modifier).EQUAL_TO
            }
        ],
        orderList: [
            {
                property: 'created_at',
                direction: 1
            }
        ],
        pagination: {
            limit: 100,
            offset: 0
        }
    };
    request.setQueryList($756e67a155228bc1$export$9e425aa3bc4615e4(params.queryList));
    request.setOrderList($756e67a155228bc1$export$6e056c4111eab585(params.orderList));
    request.setPagination($756e67a155228bc1$export$85165fa2c02223ff(params.pagination));
    return client.listSubscriptions(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$e61db6118c955e15(customerId, subscriptionId) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $26u10.ListRecurringBillableItemsRequest)();
    request.setSubscriptionId(subscriptionId);
    request.setCustomerId(customerId);
    return client.listRecurringBillableItems(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$8f54171fdd09839d(customerId, subscriptionId, recurringBillableItems) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $26u10.UpdateRecurringBillableItemsRequest)();
    request.setSubscriptionId(subscriptionId);
    request.setCustomerId(customerId);
    request.setRecurringBillableItemsList(recurringBillableItems);
    return client.updateRecurringBillableItems(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$e1f13c103914dd8e(customerId, subscriptionId, recurringBillableItemId) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $26u10.RemoveMileageRecurringBillableItemRequest)();
    request.setSubscriptionId(subscriptionId);
    request.setCustomerId(customerId);
    request.setMileageRecurringBillableItemId(recurringBillableItemId);
    return client.removeMileageRecurringBillableItem(request).then((res)=>{
        return res.toObject();
    });
}
async function $756e67a155228bc1$export$6544aa26cd8de610(documentNumber, subscriptionId, paymentAmount) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $26u10.PayInvoiceRequest)();
    request.setSubscriptionId(subscriptionId);
    request.setInvoiceNumber(documentNumber);
    request.setAmount(paymentAmount);
    return client.payInvoice(request).then((res)=>{
        return res.toObject();
    });
}
function $756e67a155228bc1$export$f6fc18f0c68d4f98(params) {
    const request = new (0, $26u10.UpdateReservationRequest)();
    if (!params.programId || params.programId.length === 0) throw new Error('Program ID must be provided.');
    if (!params.reservationId || params.reservationId.length === 0) throw new Error('Reservation ID must be provided.');
    if (!params.monthlyRent) throw new Error('Monthly amount must be provided.');
    request.setProgramId(params.programId);
    request.setReservationId(params.reservationId);
    request.setDeposit(params.deposit);
    request.setStartFee(params.startFee);
    request.setMonthlyRent(params.monthlyRent);
    request.setColor(params.color);
    request.setSecondaryColor(params.secondaryColor);
    request.setMake(params.make);
    request.setModel(params.model);
    request.setPostal(params.postal);
    request.setTrackingId(params.trackingId);
    return request;
}
async function $756e67a155228bc1$export$601a378d98897038(params) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = $756e67a155228bc1$export$f6fc18f0c68d4f98(params);
    return client.updateProgramReservation(request).catch((0, $45ee4ee0548ca22e$export$b35e4e49600c6304)('setReservationProgramError'));
}
async function $756e67a155228bc1$export$5c657c66d93f6525(reservationId) {
    const client = $756e67a155228bc1$var$getBillingService();
    const request = new (0, $26u10.GetReservationRequest)();
    request.setReservationId(reservationId);
    return client.getProgramReservation(request).then((res)=>{
        return res.toObject();
    });
}



var $3EyMN = parcelRequire("3EyMN");

var $9YICB = parcelRequire("9YICB");


var $dsvHa = parcelRequire("dsvHa");




//TODO: GET RID OF THIS WHEN PAYMENTS 2 ROLLS OUT
function $ee0ab4f78b3163c4$export$7a3fce93cf9ac967(dollarAmount) {
    return Number.isInteger(dollarAmount * 100) ? dollarAmount * 100 : parseInt((dollarAmount * 100).toFixed(0));
}
async function $ee0ab4f78b3163c4$export$e772c8ff12451969(ms) {
    return new Promise((resolve)=>setTimeout(resolve, ms));
}
function $ee0ab4f78b3163c4$export$441246a97b23a35f(value, radix, defaultReturn) {
    const parsed = parseInt(value, radix);
    if (isNaN(parsed)) switch(defaultReturn){
        case '0':
            return 0;
        case 'null':
            return null;
        case 'NaN':
            return NaN;
        default:
            return null;
    }
    return parsed;
}


const $1f7bb63928e45f23$var$Units = (0, $9YICB.Odometer).Units;
function $1f7bb63928e45f23$var$getNexusService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $1f7bb63928e45f23$var$getFleetService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $df70feab7068291e$exports.FleetServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $1f7bb63928e45f23$export$4031e147fa249d4c(params) {
    const request = new (0, $dsvHa.GetLatestCustodyRequest)();
    request.setCustodyType((0, $dsvHa.GetLatestCustodyRequest).CustodyType.ANY);
    request.setVehicleId(params.vehicleId);
    return request;
}
async function $1f7bb63928e45f23$export$6801ccf82ddf6afb(params) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = $1f7bb63928e45f23$export$4031e147fa249d4c(params);
    return client.getLatestCustody(request).then((res)=>{
        return res.toObject();
    }).catch((0, $45ee4ee0548ca22e$export$b35e4e49600c6304)('getLatestCustody')).catch(()=>{
        return {
            dealership: {
                name: 'Not Available',
                address: {
                    street: 'Not Available'
                }
            }
        };
    });
}
async function $1f7bb63928e45f23$export$c7b7bad5a1248c3e(subscriptionId) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.GetSubscriptionMileageRequest)();
    request.setSubscriptionId(subscriptionId);
    return client.getSubscriptionMileage(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$6131c0e0b3329316(subscriptionId) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.GetSubscriptionMileagePurchasesRequest)();
    request.setSubscriptionId(subscriptionId);
    return client.getSubscriptionMileagePurchases(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$99549ebb5105e7db(params) {
    const client = $1f7bb63928e45f23$var$getFleetService();
    const request = new (0, $3EyMN.LogMilesPurchasedRequest)();
    request.setVehicleId(params.vehicleId);
    request.setSubscriptionId(params.subscriptionId);
    request.setAmount(params.amount);
    request.setPrice(params.price);
    request.setTime(params.time);
    request.setReferenceId(params.referenceId);
    return client.logMilesPurchased(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$97220878af29b590(id) {
    const client = $1f7bb63928e45f23$var$getFleetService();
    const request = new (0, $3EyMN.DeleteMilesPurchasedLogRequest)();
    request.setId(id);
    return client.deleteMilesPurchasedLog(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$9262ceaa06b84b83() {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.ListVehicleMakesRequest)();
    return client.listVehicleMakes(request).then((res)=>{
        return res.toObject()?.makesList || [];
    });
}
async function $1f7bb63928e45f23$export$4079c7d438f07c9f(make) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const ListModelsByMakeRequest = $3EyMN.ListModelsByMakeRequest;
    const request = ListModelsByMakeRequest ? new ListModelsByMakeRequest() : new (0, $3EyMN.ListVehicleMakesRequest)();
    if (typeof request.setMake === 'function') request.setMake(make);
    const requestFn = client.listModelsByMake || client.ListModelsByMake;
    if (typeof requestFn !== 'function') return [];
    return requestFn.call(client, request).then((res)=>{
        const objectResponse = res?.toObject?.() || {};
        return objectResponse?.modelsList || [];
    });
}
async function $1f7bb63928e45f23$export$ba81ea9fb3979088(params) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.UpdateVehicleRequest)();
    request.setId(params.vehicle.getId());
    request.setVehicle(params.vehicle);
    return client.updateVehicle(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$a959b20bb630c9f4(params) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.AddVehicleRequest)();
    request.setProgramId(params.programId);
    request.setFinancier(params.financier);
    request.setVehicleJson(JSON.stringify(params.vehicleJson));
    return client.addVehicle(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$790260d39dc05e1c(params) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.AddVehiclesRequest)();
    request.setProgramId(params.programId);
    request.setFinancier(params.financier);
    // Convert each vehicle JSON to string and add to the request
    const vehicleJsonStringsList = params.vehicleJsons.map((vehicleJson)=>JSON.stringify(vehicleJson));
    request.setVehicleJsonsList(vehicleJsonStringsList);
    return client.addVehicles(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$240a68f088d6e40c(subscriptionId, vehicleId) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.ReturnVehicleRequest)();
    request.setSubscriptionId(subscriptionId);
    const rd = new (0, $3EyMN.ReturnDetails)();
    rd.setVehicleId(vehicleId);
    rd.setOdometer(10);
    rd.setTime(new Date().toISOString());
    rd.setInspectionReportId(1);
    request.setReturnDetails(rd);
    return client.returnVehicle(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$2266d036925a0e4b(clientId, make, model, year, trim) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.GetVehicleMediaRequest)();
    request.setMake(make);
    request.setModel(model);
    request.setYear((0, $ee0ab4f78b3163c4$export$441246a97b23a35f)(year, 10, '0'));
    request.setTrim(trim);
    const metadata = {
        'client-id': clientId
    };
    return client.getVehicleMedia(request, metadata).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$786b106d3ad84b80(params) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const metadata = {
        'client-id': params.clientId
    };
    return client.upsertVehicleMedia(params.upsertVehicleMediaRequest, metadata).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$74943467391554b(vehicleMediaId) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.DeleteVehicleMediaRequest)();
    request.setId(vehicleMediaId);
    return client.deleteVehicleMedia(request).then((res)=>{
        return res.toObject();
    });
}
async function $1f7bb63928e45f23$export$b05592a654483467(params) {
    const client = $1f7bb63928e45f23$var$getNexusService();
    const request = new (0, $3EyMN.InitiateVehicleReturnRequest)();
    const odometer = new (0, $9YICB.Odometer)();
    odometer.setUnits(params.odometer?.units || $1f7bb63928e45f23$var$Units.MILES);
    odometer.setReading(params.odometer?.reading || 0);
    odometer.setReadingType(params.odometer?.readingType || (0, $9YICB.Odometer).ReadingType.DROPOFF);
    odometer.setDate(params.odometer?.date || Date.now());
    request.setVehicleId(params.vehicleId);
    request.setVin(params.vin);
    request.setCustomerId(params.customerId);
    request.setOdometer(odometer);
    request.setSubscriptionId(params.subscriptionId);
    request.setReturnTime(params.returnTime || new Date().toISOString());
    if (params.missingAssetsAmount) request.setMissingAssetsAmount(params.missingAssetsAmount);
    if (params.initialDamagesAmount) request.setInitialDamagesAmount(params.initialDamagesAmount);
    return client.initiateVehicleReturn(request).then((res)=>{
        return res.toObject();
    });
}



var $ghA5X = parcelRequire("ghA5X");


var $919a4aef0d4f5e56$exports = {};
/**
 * @fileoverview gRPC-Web generated client stub for insurance_service
 * @enhanceable
 * @public
 */ // Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v2.0.2
// 	protoc              v3.17.3
// source: insurance_service.proto
/* eslint-disable */ // @ts-nocheck
const $919a4aef0d4f5e56$var$grpc = {};

$919a4aef0d4f5e56$var$grpc.web = (parcelRequire("gd5R7"));
parcelRequire("3QqPt");
parcelRequire("gQESC");
const $919a4aef0d4f5e56$var$proto = {};

$919a4aef0d4f5e56$var$proto.insurance_service = (parcelRequire("ghA5X"));
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $919a4aef0d4f5e56$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient = function(hostname, credentials, options) {
    if (!options) options = {};
    options.format = 'text';
    /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */ this.client_ = new $919a4aef0d4f5e56$var$grpc.web.GrpcWebClientBase(options);
    /**
   * @private @const {string} The hostname
   */ this.hostname_ = hostname.replace(/\/+$/, '');
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.UpsertOwnInsurancePoliciesRequest,
 *   !proto.insurance_service.UpsertInsurancePoliciesResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_UpsertOwnInsurancePolicies = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/UpsertOwnInsurancePolicies', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.UpsertOwnInsurancePoliciesRequest, $919a4aef0d4f5e56$var$proto.insurance_service.UpsertInsurancePoliciesResponse, /**
   * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.UpsertInsurancePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.UpsertInsurancePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.UpsertInsurancePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.upsertOwnInsurancePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/UpsertOwnInsurancePolicies', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_UpsertOwnInsurancePolicies, callback);
};
/**
 * @param {!proto.insurance_service.UpsertOwnInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.UpsertInsurancePoliciesResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.upsertOwnInsurancePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/UpsertOwnInsurancePolicies', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_UpsertOwnInsurancePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.UpsertInsurancePoliciesRequest,
 *   !proto.insurance_service.UpsertInsurancePoliciesResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_UpsertInsurancePolicies = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/UpsertInsurancePolicies', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.UpsertInsurancePoliciesRequest, $919a4aef0d4f5e56$var$proto.insurance_service.UpsertInsurancePoliciesResponse, /**
   * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.UpsertInsurancePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.UpsertInsurancePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.UpsertInsurancePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.upsertInsurancePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/UpsertInsurancePolicies', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_UpsertInsurancePolicies, callback);
};
/**
 * @param {!proto.insurance_service.UpsertInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.UpsertInsurancePoliciesResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.upsertInsurancePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/UpsertInsurancePolicies', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_UpsertInsurancePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetOwnInsurancePoliciesRequest,
 *   !proto.insurance_service.GetInsurancePoliciesResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetOwnInsurancePolicies = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/GetOwnInsurancePolicies', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.GetOwnInsurancePoliciesRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsurancePoliciesResponse, /**
   * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsurancePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsurancePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsurancePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.getOwnInsurancePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/GetOwnInsurancePolicies', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetOwnInsurancePolicies, callback);
};
/**
 * @param {!proto.insurance_service.GetOwnInsurancePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsurancePoliciesResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.getOwnInsurancePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/GetOwnInsurancePolicies', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetOwnInsurancePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CreateInsuranceQuoteRequest,
 *   !proto.insurance_service.GetInsuranceQuoteResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateInsuranceQuote = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/CreateInsuranceQuote', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.CreateInsuranceQuoteRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceQuoteResponse, /**
   * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceQuoteResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuranceQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuranceQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.createInsuranceQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/CreateInsuranceQuote', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateInsuranceQuote, callback);
};
/**
 * @param {!proto.insurance_service.CreateInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuranceQuoteResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.createInsuranceQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/CreateInsuranceQuote', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateInsuranceQuote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CreateAllInsuranceQuotesRequest,
 *   !proto.insurance_service.CreateAllInsuranceQuotesResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateAllInsuranceQuotes = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/CreateAllInsuranceQuotes', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.CreateAllInsuranceQuotesRequest, $919a4aef0d4f5e56$var$proto.insurance_service.CreateAllInsuranceQuotesResponse, /**
   * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.CreateAllInsuranceQuotesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.CreateAllInsuranceQuotesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.CreateAllInsuranceQuotesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.createAllInsuranceQuotes = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/CreateAllInsuranceQuotes', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateAllInsuranceQuotes, callback);
};
/**
 * @param {!proto.insurance_service.CreateAllInsuranceQuotesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.CreateAllInsuranceQuotesResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.createAllInsuranceQuotes = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/CreateAllInsuranceQuotes', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateAllInsuranceQuotes);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.SelectInsuranceQuoteRequest,
 *   !proto.insurance_service.SelectInsuranceQuoteResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_SelectInsuranceQuote = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/SelectInsuranceQuote', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.SelectInsuranceQuoteRequest, $919a4aef0d4f5e56$var$proto.insurance_service.SelectInsuranceQuoteResponse, /**
   * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.SelectInsuranceQuoteResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.SelectInsuranceQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.SelectInsuranceQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.selectInsuranceQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/SelectInsuranceQuote', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_SelectInsuranceQuote, callback);
};
/**
 * @param {!proto.insurance_service.SelectInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.SelectInsuranceQuoteResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.selectInsuranceQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/SelectInsuranceQuote', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_SelectInsuranceQuote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsuranceQuoteRequest,
 *   !proto.insurance_service.GetInsuranceQuoteResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuranceQuote = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/GetInsuranceQuote', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceQuoteRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceQuoteResponse, /**
   * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceQuoteResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuranceQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuranceQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.getInsuranceQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/GetInsuranceQuote', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuranceQuote, callback);
};
/**
 * @param {!proto.insurance_service.GetInsuranceQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuranceQuoteResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.getInsuranceQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/GetInsuranceQuote', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuranceQuote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CreateInsurancePolicyRequest,
 *   !proto.insurance_service.GetInsurancePolicyResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateInsurancePolicy = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/CreateInsurancePolicy', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.CreateInsurancePolicyRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsurancePolicyResponse, /**
   * @param {!proto.insurance_service.CreateInsurancePolicyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsurancePolicyResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CreateInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsurancePolicyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsurancePolicyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.createInsurancePolicy = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/CreateInsurancePolicy', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateInsurancePolicy, callback);
};
/**
 * @param {!proto.insurance_service.CreateInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsurancePolicyResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.createInsurancePolicy = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/CreateInsurancePolicy', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreateInsurancePolicy);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsurancePolicyRequest,
 *   !proto.insurance_service.GetInsurancePolicyResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsurancePolicy = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/GetInsurancePolicy', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsurancePolicyRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsurancePolicyResponse, /**
   * @param {!proto.insurance_service.GetInsurancePolicyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsurancePolicyResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsurancePolicyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsurancePolicyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.getInsurancePolicy = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/GetInsurancePolicy', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsurancePolicy, callback);
};
/**
 * @param {!proto.insurance_service.GetInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsurancePolicyResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.getInsurancePolicy = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/GetInsurancePolicy', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsurancePolicy);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CreatePolicyChangeQuoteRequest,
 *   !proto.insurance_service.GetInsuranceQuoteResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreatePolicyChangeQuote = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/CreatePolicyChangeQuote', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.CreatePolicyChangeQuoteRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceQuoteResponse, /**
   * @param {!proto.insurance_service.CreatePolicyChangeQuoteRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceQuoteResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CreatePolicyChangeQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuranceQuoteResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuranceQuoteResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.createPolicyChangeQuote = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/CreatePolicyChangeQuote', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreatePolicyChangeQuote, callback);
};
/**
 * @param {!proto.insurance_service.CreatePolicyChangeQuoteRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuranceQuoteResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.createPolicyChangeQuote = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/CreatePolicyChangeQuote', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreatePolicyChangeQuote);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CreatePolicyChangeRequest,
 *   !proto.insurance_service.CreatePolicyChangeResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreatePolicyChange = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/CreatePolicyChange', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.CreatePolicyChangeRequest, $919a4aef0d4f5e56$var$proto.insurance_service.CreatePolicyChangeResponse, /**
   * @param {!proto.insurance_service.CreatePolicyChangeRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.CreatePolicyChangeResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CreatePolicyChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.CreatePolicyChangeResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.CreatePolicyChangeResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.createPolicyChange = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/CreatePolicyChange', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreatePolicyChange, callback);
};
/**
 * @param {!proto.insurance_service.CreatePolicyChangeRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.CreatePolicyChangeResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.createPolicyChange = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/CreatePolicyChange', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CreatePolicyChange);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.CancelInsurancePolicyRequest,
 *   !proto.insurance_service.CancelInsurancePolicyResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CancelInsurancePolicy = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/CancelInsurancePolicy', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.CancelInsurancePolicyRequest, $919a4aef0d4f5e56$var$proto.insurance_service.CancelInsurancePolicyResponse, /**
   * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.CancelInsurancePolicyResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.CancelInsurancePolicyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.CancelInsurancePolicyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.cancelInsurancePolicy = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/CancelInsurancePolicy', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CancelInsurancePolicy, callback);
};
/**
 * @param {!proto.insurance_service.CancelInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.CancelInsurancePolicyResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.cancelInsurancePolicy = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/CancelInsurancePolicy', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_CancelInsurancePolicy);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.ExtendInsurancePolicyRequest,
 *   !proto.insurance_service.ExtendInsurancePolicyResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ExtendInsurancePolicy = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/ExtendInsurancePolicy', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.ExtendInsurancePolicyRequest, $919a4aef0d4f5e56$var$proto.insurance_service.ExtendInsurancePolicyResponse, /**
   * @param {!proto.insurance_service.ExtendInsurancePolicyRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.ExtendInsurancePolicyResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.ExtendInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.ExtendInsurancePolicyResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.ExtendInsurancePolicyResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.extendInsurancePolicy = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/ExtendInsurancePolicy', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ExtendInsurancePolicy, callback);
};
/**
 * @param {!proto.insurance_service.ExtendInsurancePolicyRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.ExtendInsurancePolicyResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.extendInsurancePolicy = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/ExtendInsurancePolicy', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ExtendInsurancePolicy);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.QualifyForLibertyInsuranceRequest,
 *   !proto.insurance_service.QualifyForLibertyInsuranceResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_QualifyForLibertyInsurance = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/QualifyForLibertyInsurance', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.QualifyForLibertyInsuranceRequest, $919a4aef0d4f5e56$var$proto.insurance_service.QualifyForLibertyInsuranceResponse, /**
   * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.QualifyForLibertyInsuranceResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.QualifyForLibertyInsuranceResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.QualifyForLibertyInsuranceResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.qualifyForLibertyInsurance = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/QualifyForLibertyInsurance', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_QualifyForLibertyInsurance, callback);
};
/**
 * @param {!proto.insurance_service.QualifyForLibertyInsuranceRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.QualifyForLibertyInsuranceResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.qualifyForLibertyInsurance = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/QualifyForLibertyInsurance', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_QualifyForLibertyInsurance);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsuredDriversRequest,
 *   !proto.insurance_service.GetInsuredDriversResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuredDrivers = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/GetInsuredDrivers', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuredDriversRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuredDriversResponse, /**
   * @param {!proto.insurance_service.GetInsuredDriversRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuredDriversResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsuredDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuredDriversResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuredDriversResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.getInsuredDrivers = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/GetInsuredDrivers', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuredDrivers, callback);
};
/**
 * @param {!proto.insurance_service.GetInsuredDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuredDriversResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.getInsuredDrivers = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/GetInsuredDrivers', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuredDrivers);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetUpdatedInsurancePolicyCardRequest,
 *   !proto.insurance_service.GetUpdatedInsurancePolicyCardResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetUpdatedInsurancePolicyCard = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/GetUpdatedInsurancePolicyCard', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.GetUpdatedInsurancePolicyCardRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetUpdatedInsurancePolicyCardResponse, /**
   * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetUpdatedInsurancePolicyCardResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetUpdatedInsurancePolicyCardResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetUpdatedInsurancePolicyCardResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.getUpdatedInsurancePolicyCard = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/GetUpdatedInsurancePolicyCard', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetUpdatedInsurancePolicyCard, callback);
};
/**
 * @param {!proto.insurance_service.GetUpdatedInsurancePolicyCardRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetUpdatedInsurancePolicyCardResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.getUpdatedInsurancePolicyCard = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/GetUpdatedInsurancePolicyCard', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetUpdatedInsurancePolicyCard);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetInsuranceStatusRequest,
 *   !proto.insurance_service.GetInsuranceStatusResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuranceStatus = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/GetInsuranceStatus', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceStatusRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceStatusResponse, /**
   * @param {!proto.insurance_service.GetInsuranceStatusRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetInsuranceStatusResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetInsuranceStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetInsuranceStatusResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetInsuranceStatusResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.getInsuranceStatus = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/GetInsuranceStatus', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuranceStatus, callback);
};
/**
 * @param {!proto.insurance_service.GetInsuranceStatusRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetInsuranceStatusResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.getInsuranceStatus = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/GetInsuranceStatus', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetInsuranceStatus);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetLatestQuoteGroupRequest,
 *   !proto.insurance_service.GetLatestQuoteGroupResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetLatestQuoteGroup = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/GetLatestQuoteGroup', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.GetLatestQuoteGroupRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetLatestQuoteGroupResponse, /**
   * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetLatestQuoteGroupResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetLatestQuoteGroupResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetLatestQuoteGroupResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.getLatestQuoteGroup = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/GetLatestQuoteGroup', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetLatestQuoteGroup, callback);
};
/**
 * @param {!proto.insurance_service.GetLatestQuoteGroupRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetLatestQuoteGroupResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.getLatestQuoteGroup = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/GetLatestQuoteGroup', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetLatestQuoteGroup);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.BulkUpdatePoliciesRequest,
 *   !proto.insurance_service.BulkUpdatePoliciesResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_BulkUpdatePolicies = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/BulkUpdatePolicies', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.BulkUpdatePoliciesRequest, $919a4aef0d4f5e56$var$proto.insurance_service.BulkUpdatePoliciesResponse, /**
   * @param {!proto.insurance_service.BulkUpdatePoliciesRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.BulkUpdatePoliciesResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.BulkUpdatePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.BulkUpdatePoliciesResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.BulkUpdatePoliciesResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.bulkUpdatePolicies = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/BulkUpdatePolicies', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_BulkUpdatePolicies, callback);
};
/**
 * @param {!proto.insurance_service.BulkUpdatePoliciesRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.BulkUpdatePoliciesResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.bulkUpdatePolicies = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/BulkUpdatePolicies', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_BulkUpdatePolicies);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.GetExternalPoliciesFromDsotRequest,
 *   !proto.insurance_service.GetExternalPoliciesFromDsotResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetExternalPoliciesFromDsot = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/GetExternalPoliciesFromDsot', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.GetExternalPoliciesFromDsotRequest, $919a4aef0d4f5e56$var$proto.insurance_service.GetExternalPoliciesFromDsotResponse, /**
   * @param {!proto.insurance_service.GetExternalPoliciesFromDsotRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.GetExternalPoliciesFromDsotResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.GetExternalPoliciesFromDsotRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.GetExternalPoliciesFromDsotResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.GetExternalPoliciesFromDsotResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.getExternalPoliciesFromDsot = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/GetExternalPoliciesFromDsot', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetExternalPoliciesFromDsot, callback);
};
/**
 * @param {!proto.insurance_service.GetExternalPoliciesFromDsotRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.GetExternalPoliciesFromDsotResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.getExternalPoliciesFromDsot = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/GetExternalPoliciesFromDsot', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_GetExternalPoliciesFromDsot);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.ImportInsuranceDataRequest,
 *   !proto.insurance_service.ImportInsuranceDataResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ImportInsuranceData = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/ImportInsuranceData', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.ImportInsuranceDataRequest, $919a4aef0d4f5e56$var$proto.insurance_service.ImportInsuranceDataResponse, /**
   * @param {!proto.insurance_service.ImportInsuranceDataRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.ImportInsuranceDataResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.ImportInsuranceDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.ImportInsuranceDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.ImportInsuranceDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.importInsuranceData = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/ImportInsuranceData', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ImportInsuranceData, callback);
};
/**
 * @param {!proto.insurance_service.ImportInsuranceDataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.ImportInsuranceDataResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.importInsuranceData = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/ImportInsuranceData', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ImportInsuranceData);
};
/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.insurance_service.ModifyInsuranceDriversRequest,
 *   !proto.insurance_service.ModifyInsuranceDriversResponse>}
 */ const $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ModifyInsuranceDrivers = new $919a4aef0d4f5e56$var$grpc.web.MethodDescriptor('/insurance_service.InsuranceService/ModifyInsuranceDrivers', $919a4aef0d4f5e56$var$grpc.web.MethodType.UNARY, $919a4aef0d4f5e56$var$proto.insurance_service.ModifyInsuranceDriversRequest, $919a4aef0d4f5e56$var$proto.insurance_service.ModifyInsuranceDriversResponse, /**
   * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} request
   * @return {!Uint8Array}
   */ function(request) {
    return request.serializeBinary();
}, $919a4aef0d4f5e56$var$proto.insurance_service.ModifyInsuranceDriversResponse.deserializeBinary);
/**
 * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.insurance_service.ModifyInsuranceDriversResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.insurance_service.ModifyInsuranceDriversResponse>|undefined}
 *     The XHR Node Readable Stream
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServiceClient.prototype.modifyInsuranceDrivers = function(request, metadata, callback) {
    return this.client_.rpcCall(this.hostname_ + '/insurance_service.InsuranceService/ModifyInsuranceDrivers', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ModifyInsuranceDrivers, callback);
};
/**
 * @param {!proto.insurance_service.ModifyInsuranceDriversRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.insurance_service.ModifyInsuranceDriversResponse>}
 *     Promise that resolves to the response
 */ $919a4aef0d4f5e56$var$proto.insurance_service.InsuranceServicePromiseClient.prototype.modifyInsuranceDrivers = function(request, metadata) {
    return this.client_.unaryCall(this.hostname_ + '/insurance_service.InsuranceService/ModifyInsuranceDrivers', request, metadata || {}, $919a4aef0d4f5e56$var$methodDescriptor_InsuranceService_ModifyInsuranceDrivers);
};
$919a4aef0d4f5e56$exports = $919a4aef0d4f5e56$var$proto.insurance_service;




var $3QqPt = parcelRequire("3QqPt");
const $dbaa63f10354f5f5$export$96c883eee005767e = {};
function $dbaa63f10354f5f5$export$a2a816d51ce0ccf6() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $919a4aef0d4f5e56$exports.InsuranceServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ]
    });
}
function $dbaa63f10354f5f5$export$7071f848737dad3a() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ]
    });
}
function $dbaa63f10354f5f5$export$d966a79b1da26514(customerId, subscriptionId) {
    const client = $dbaa63f10354f5f5$export$a2a816d51ce0ccf6();
    const request = new (0, $ghA5X.GetInsuranceStatusRequest)();
    request.setSubscriptionId(subscriptionId);
    request.setCustomerId(customerId);
    return client.getInsuranceStatus(request).then((res)=>res.toObject()).catch((error)=>console.log('Get insurance status error:', error));
}
function $dbaa63f10354f5f5$export$9d1ccecb4250caa(policyNumber, providerName, effectiveDate, expirationDate, customerId, subscriptionId) {
    const client = $dbaa63f10354f5f5$export$7071f848737dad3a();
    const request = new (0, $ghA5X.UpsertInsurancePoliciesRequest)();
    // Set the policy data based on the form input
    const customerIdentity = new (0, $ghA5X.CustomerIdentity)();
    customerIdentity.setCustomerId(customerId);
    const policy = new (0, $3QqPt.InsurancePolicy)();
    policy.setPolicyNumber(policyNumber);
    policy.setProviderName(providerName);
    policy.setEffectiveDateString(new Date(effectiveDate).toISOString().slice(0, 10));
    policy.setExpirationDateString(new Date(expirationDate).toISOString().slice(0, 10));
    request.setCustomerIdentity(customerIdentity);
    request.addInsurancePolicies(policy);
    request.setSubscriptionId(subscriptionId);
    return client.upsertInsurancePolicies(request).then((res)=>res.toObject()).catch((error)=>console.log('upsertExternalInsurancePolicies error:', error));
}
function $dbaa63f10354f5f5$export$cbbd242c6cae2632(subscriptionId) {
    const client = $dbaa63f10354f5f5$export$7071f848737dad3a();
    const request = new (0, $ghA5X.CancelInsurancePolicyRequest)();
    request.setSubscriptionId(subscriptionId);
    return client.cancelInsurancePolicy(request).then((res)=>res.toObject()).catch((error)=>console.log('cancelInsurancePolicy error:', error));
}
function $dbaa63f10354f5f5$export$6754c540bf6e6bf1(customerId, subscriptionId) {
    const client = $dbaa63f10354f5f5$export$7071f848737dad3a();
    const request = new (0, $ghA5X.GetInsuredDriversRequest)();
    request.setSubscriptionId(subscriptionId);
    request.setCustomerId(customerId);
    return client.getInsuredDrivers(request).then((res)=>res.toObject()).catch((error)=>console.log('Get insured drivers error:', error));
}
function $dbaa63f10354f5f5$export$9ade3a2b6295a98f({ subscriptionId: subscriptionId, customerId: customerId }) {
    const client = $dbaa63f10354f5f5$export$7071f848737dad3a();
    const request = new (0, $ghA5X.GetInsuranceQuoteRequest)();
    request.setSubscriptionId(subscriptionId);
    request.setCustomerId(customerId);
    return client.getInsuranceQuote(request).then((res)=>res.toObject()).catch((error)=>console.log('Get insurance quote error:', error));
}
function $dbaa63f10354f5f5$export$c0dc680866c8e1e9({ subscriptionId: subscriptionId }) {
    const client = $dbaa63f10354f5f5$export$a2a816d51ce0ccf6();
    const request = new (0, $ghA5X.GetLatestQuoteGroupRequest)();
    request.setSubscriptionId(subscriptionId);
    return client.getLatestQuoteGroup(request).then((res)=>res.toObject()).catch((error)=>console.log('Get latest quote error:', error));
}




var $dsvHa = parcelRequire("dsvHa");

var $7QrRI = parcelRequire("7QrRI");



var $fcTGK = parcelRequire("fcTGK");
const $0bc92389da5ca8f2$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $0bc92389da5ca8f2$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $0bc92389da5ca8f2$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $46af55383084911e$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $63c01f9040a729a9$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $63c01f9040a729a9$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $63c01f9040a729a9$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $63c01f9040a729a9$export$cbf60ecb96cbb82f = {
    date: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $46af55383084911e$export$38e44e97ce4dbb7d)({
        formats: $63c01f9040a729a9$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $f529b3bee3f6d835$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $f529b3bee3f6d835$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$f529b3bee3f6d835$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $39a1e2b6239b09b3$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $eb9cac2ee97a0b54$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $eb9cac2ee97a0b54$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $eb9cac2ee97a0b54$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $eb9cac2ee97a0b54$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $eb9cac2ee97a0b54$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $eb9cac2ee97a0b54$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $eb9cac2ee97a0b54$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $eb9cac2ee97a0b54$var$ordinalNumber,
    era: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $39a1e2b6239b09b3$export$63596d6ee8878b25)({
        values: $eb9cac2ee97a0b54$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $eb9cac2ee97a0b54$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $e4df69a5a2d494a3$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $e4df69a5a2d494a3$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $e4df69a5a2d494a3$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $e4df69a5a2d494a3$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $e4df69a5a2d494a3$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $2594a2c0202dabc6$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $d2fa28259adb3ab1$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $d2fa28259adb3ab1$var$parseOrdinalNumberPattern = /\d+/i;
const $d2fa28259adb3ab1$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $d2fa28259adb3ab1$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $d2fa28259adb3ab1$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $d2fa28259adb3ab1$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $d2fa28259adb3ab1$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $d2fa28259adb3ab1$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $d2fa28259adb3ab1$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $d2fa28259adb3ab1$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $d2fa28259adb3ab1$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $d2fa28259adb3ab1$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $2594a2c0202dabc6$export$fdaf2fd6d7edde95)({
        matchPattern: $d2fa28259adb3ab1$var$matchOrdinalNumberPattern,
        parsePattern: $d2fa28259adb3ab1$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $e4df69a5a2d494a3$export$1430a0f35710914d)({
        matchPatterns: $d2fa28259adb3ab1$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $d2fa28259adb3ab1$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $cd0c27002eb93234$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $0bc92389da5ca8f2$export$2c14ff85d6318973),
    formatLong: (0, $63c01f9040a729a9$export$cbf60ecb96cbb82f),
    formatRelative: (0, $f529b3bee3f6d835$export$8fbbfd65594f46a0),
    localize: (0, $eb9cac2ee97a0b54$export$b3bd0bc58e36cd63),
    match: (0, $d2fa28259adb3ab1$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$cd0c27002eb93234$export$2e2bcd8739ae039 = $cd0c27002eb93234$export$137380d9ce54f7f;


let $39440020b58e1ef8$var$defaultOptions = {};
function $39440020b58e1ef8$export$430a3269e24b912e() {
    return $39440020b58e1ef8$var$defaultOptions;
}
function $39440020b58e1ef8$export$95365be1b0704abc(newOptions) {
    $39440020b58e1ef8$var$defaultOptions = newOptions;
}


/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8540a44f59a4af84$export$dfd9b671c89acc8e = 7;
const $8540a44f59a4af84$export$3913210603d8e9ae = 365.2425;
const $8540a44f59a4af84$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $8540a44f59a4af84$export$4dec998e48f9c246 = -$8540a44f59a4af84$export$81caae6e1cc7a622;
const $8540a44f59a4af84$export$4fad13613e88edc8 = 604800000;
const $8540a44f59a4af84$export$b76b1809a2898f9a = 86400000;
const $8540a44f59a4af84$export$91246f0b9bd9beff = 60000;
const $8540a44f59a4af84$export$7f72910d6dfd237a = 3600000;
const $8540a44f59a4af84$export$397c2d5776aa9055 = 1000;
const $8540a44f59a4af84$export$3633035e63cee86a = 525600;
const $8540a44f59a4af84$export$ab7da2ccd1075c38 = 43200;
const $8540a44f59a4af84$export$2423174df8cd3cd2 = 1440;
const $8540a44f59a4af84$export$f2f5ae5a8e2d8f9f = 60;
const $8540a44f59a4af84$export$3c58128db900d44e = 3;
const $8540a44f59a4af84$export$80d7e435f744f319 = 12;
const $8540a44f59a4af84$export$4db7641526e3241f = 4;
const $8540a44f59a4af84$export$698aec755e92c695 = 3600;
const $8540a44f59a4af84$export$a77c1a7ebebe2a5a = 60;
const $8540a44f59a4af84$export$815a9362476d2fe3 = $8540a44f59a4af84$export$698aec755e92c695 * 24;
const $8540a44f59a4af84$export$34804a017b31e2fe = $8540a44f59a4af84$export$815a9362476d2fe3 * 7;
const $8540a44f59a4af84$export$7271e9e3478110d1 = $8540a44f59a4af84$export$815a9362476d2fe3 * $8540a44f59a4af84$export$3913210603d8e9ae;
const $8540a44f59a4af84$export$8e6600bbdee7dabb = $8540a44f59a4af84$export$7271e9e3478110d1 / 12;
const $8540a44f59a4af84$export$be1dccf2de902d31 = $8540a44f59a4af84$export$8e6600bbdee7dabb * 3;
const $8540a44f59a4af84$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $abb9adbdb26342b3$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $8540a44f59a4af84$export$2a7b97929c48d47d) in date) return date[0, $8540a44f59a4af84$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$abb9adbdb26342b3$export$2e2bcd8739ae039 = $abb9adbdb26342b3$export$ead8a1812b171991;


function $231bfb8d72679740$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$231bfb8d72679740$export$2e2bcd8739ae039 = $231bfb8d72679740$export$e67a095c620b86fe;


function $92dc0740ffabe180$export$113002b5eff6e430(date) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $002c8181c95d5119$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $abb9adbdb26342b3$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $b6caff0bf13dcaf5$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$b6caff0bf13dcaf5$export$2e2bcd8739ae039 = $b6caff0bf13dcaf5$export$63fa379ae8a9ba2;


function $737f54e9ffaddc15$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $92dc0740ffabe180$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $92dc0740ffabe180$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $8540a44f59a4af84$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$737f54e9ffaddc15$export$2e2bcd8739ae039 = $737f54e9ffaddc15$export$4a02e9c37dab4871;



function $29cc086f79701cd9$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$29cc086f79701cd9$export$2e2bcd8739ae039 = $29cc086f79701cd9$export$f91e89d3d0406102;



function $306b88ce50904f9c$export$d3b42cd8452deec(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $737f54e9ffaddc15$export$4a02e9c37dab4871)(_date, (0, $29cc086f79701cd9$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$306b88ce50904f9c$export$2e2bcd8739ae039 = $306b88ce50904f9c$export$d3b42cd8452deec;





function $61f11f7a26b3ab78$export$42c81a444fbfb5d4(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$61f11f7a26b3ab78$export$2e2bcd8739ae039 = $61f11f7a26b3ab78$export$42c81a444fbfb5d4;


function $1c9d32c6cb108460$export$6173213f95a4431e(date, options) {
    return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, {
        ...options,
        weekStartsOn: 1
    });
}
var // Fallback for modularized imports:
$1c9d32c6cb108460$export$2e2bcd8739ae039 = $1c9d32c6cb108460$export$6173213f95a4431e;






function $c95dff76bf2f692a$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$c95dff76bf2f692a$export$2e2bcd8739ae039 = $c95dff76bf2f692a$export$3dbc52535f6f8fcc;



function $3b2e6199275b27d6$export$236bdfa374eb69a9(date, options) {
    const year = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$3b2e6199275b27d6$export$2e2bcd8739ae039 = $3b2e6199275b27d6$export$236bdfa374eb69a9;



function $83e11b0db4cec366$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $1c9d32c6cb108460$export$6173213f95a4431e)(_date) - +(0, $3b2e6199275b27d6$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8540a44f59a4af84$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$83e11b0db4cec366$export$2e2bcd8739ae039 = $83e11b0db4cec366$export$7cabdc5698b63e2f;











function $0170e230c8468ebb$export$12d572480ceb6e58(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$0170e230c8468ebb$export$2e2bcd8739ae039 = $0170e230c8468ebb$export$12d572480ceb6e58;



function $ac7640a7ade5a435$export$bb7b45bb8e74da0f(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$ac7640a7ade5a435$export$2e2bcd8739ae039 = $ac7640a7ade5a435$export$bb7b45bb8e74da0f;



function $11b38d723fd57381$export$efe19b760242b2fc(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = +(0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(_date, options) - +(0, $ac7640a7ade5a435$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8540a44f59a4af84$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$11b38d723fd57381$export$2e2bcd8739ae039 = $11b38d723fd57381$export$efe19b760242b2fc;



function $03d75ed55eeb99fa$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $71a5e81f1193b7a8$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $008fe800ab658844$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $008fe800ab658844$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $c95dff76bf2f692a$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $306b88ce50904f9c$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $008fe800ab658844$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $71a5e81f1193b7a8$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $008fe800ab658844$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $008fe800ab658844$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $008fe800ab658844$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $008fe800ab658844$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(minutes, 2);
}
function $008fe800ab658844$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $008fe800ab658844$var$formatTimezone(offset, delimiter);
}
function $008fe800ab658844$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $03d75ed55eeb99fa$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $54cd66db3e5e74df$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $54cd66db3e5e74df$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $54cd66db3e5e74df$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $54cd66db3e5e74df$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $54cd66db3e5e74df$var$timeLongFormatter(timePattern, formatLong));
};
const $54cd66db3e5e74df$export$70cc8fd02856fd58 = {
    p: $54cd66db3e5e74df$var$timeLongFormatter,
    P: $54cd66db3e5e74df$var$dateTimeLongFormatter
};


const $7e8a5b0b77bf77b9$var$dayOfYearTokenRE = /^D+$/;
const $7e8a5b0b77bf77b9$var$weekYearTokenRE = /^Y+$/;
const $7e8a5b0b77bf77b9$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $7e8a5b0b77bf77b9$export$c6cc36aa33304772(token) {
    return $7e8a5b0b77bf77b9$var$dayOfYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1(token) {
    return $7e8a5b0b77bf77b9$var$weekYearTokenRE.test(token);
}
function $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $7e8a5b0b77bf77b9$var$message(token, format, input);
    console.warn(_message);
    if ($7e8a5b0b77bf77b9$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $7e8a5b0b77bf77b9$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $1896b5e28554d57b$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$1896b5e28554d57b$export$2e2bcd8739ae039 = $1896b5e28554d57b$export$871608497c498473;



function $f2a682b251363bc2$export$1ea939691cdc45b8(date) {
    return !(!(0, $1896b5e28554d57b$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $231bfb8d72679740$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$f2a682b251363bc2$export$2e2bcd8739ae039 = $f2a682b251363bc2$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $303ba10db2c74ab4$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $303ba10db2c74ab4$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $303ba10db2c74ab4$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $303ba10db2c74ab4$var$doubleQuoteRegExp = /''/g;
const $303ba10db2c74ab4$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $303ba10db2c74ab4$export$d9468344d3651243(date, formatStr, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (!(0, $f2a682b251363bc2$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($303ba10db2c74ab4$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($303ba10db2c74ab4$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $303ba10db2c74ab4$var$cleanEscapedString(substring)
        };
        if ((0, $008fe800ab658844$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($303ba10db2c74ab4$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token) || !options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $008fe800ab658844$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $303ba10db2c74ab4$var$cleanEscapedString(input) {
    const matched = input.match($303ba10db2c74ab4$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($303ba10db2c74ab4$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$303ba10db2c74ab4$export$2e2bcd8739ae039 = $303ba10db2c74ab4$export$d9468344d3651243;



function $f3e2f0f906df8397$export$430a3269e24b912e() {
    return Object.assign({}, (0, $39440020b58e1ef8$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$f3e2f0f906df8397$export$2e2bcd8739ae039 = $f3e2f0f906df8397$export$430a3269e24b912e;


function $c188e18c3892cda7$export$90e6cdae187a86ac(length, date, options) {
    const defaultOptions = (0, $f3e2f0f906df8397$export$430a3269e24b912e)();
    const dtf = $c188e18c3892cda7$var$getDTF(length, options.timeZone, options.locale ?? defaultOptions.locale);
    return 'formatToParts' in dtf ? $c188e18c3892cda7$var$partsTimeZone(dtf, date) : $c188e18c3892cda7$var$hackyTimeZone(dtf, date);
}
function $c188e18c3892cda7$var$partsTimeZone(dtf, date) {
    const formatted = dtf.formatToParts(date);
    for(let i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
    return undefined;
}
function $c188e18c3892cda7$var$hackyTimeZone(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, '');
    const tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function $c188e18c3892cda7$var$getDTF(length, timeZone, locale) {
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}


/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ function $ac3e95dde4ceb674$export$6f7bba78170cdfff(date, timeZone) {
    const dtf = $ac3e95dde4ceb674$var$getDateTimeFormat(timeZone);
    return 'formatToParts' in dtf ? $ac3e95dde4ceb674$var$partsOffset(dtf, date) : $ac3e95dde4ceb674$var$hackyOffset(dtf, date);
}
const $ac3e95dde4ceb674$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function $ac3e95dde4ceb674$var$partsOffset(dtf, date) {
    try {
        const formatted = dtf.formatToParts(date);
        const filled = [];
        for(let i = 0; i < formatted.length; i++){
            const pos = $ac3e95dde4ceb674$var$typeToPos[formatted[i].type];
            if (pos !== undefined) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function $ac3e95dde4ceb674$var$hackyOffset(dtf, date) {
    const formatted = dtf.format(date);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // const [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parseInt(parsed[3], 10),
        parseInt(parsed[1], 10),
        parseInt(parsed[2], 10),
        parseInt(parsed[4], 10),
        parseInt(parsed[5], 10),
        parseInt(parsed[6], 10)
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
const $ac3e95dde4ceb674$var$dtfCache = {};
// New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
const $ac3e95dde4ceb674$var$testDateFormatted = new Intl.DateTimeFormat('en-US', {
    hourCycle: 'h23',
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
}).format(new Date('2014-06-25T04:00:00.123Z'));
const $ac3e95dde4ceb674$var$hourCycleSupported = $ac3e95dde4ceb674$var$testDateFormatted === '06/25/2014, 00:00:00' || $ac3e95dde4ceb674$var$testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
function $ac3e95dde4ceb674$var$getDateTimeFormat(timeZone) {
    if (!$ac3e95dde4ceb674$var$dtfCache[timeZone]) $ac3e95dde4ceb674$var$dtfCache[timeZone] = $ac3e95dde4ceb674$var$hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
        hourCycle: 'h23',
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
        hour12: false,
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    return $ac3e95dde4ceb674$var$dtfCache[timeZone];
}


/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ function $dbbc94b2c9b7796e$export$461165d00818234e(fullYear, month, day, hour, minute, second, millisecond) {
    const utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}


const $3a1a3d9713aae3cd$var$MILLISECONDS_IN_HOUR = 3600000;
const $3a1a3d9713aae3cd$var$MILLISECONDS_IN_MINUTE = 60000;
const $3a1a3d9713aae3cd$var$patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function $3a1a3d9713aae3cd$export$57649162eea44a93(timezoneString, date, isUtcDate) {
    // Empty string
    if (!timezoneString) return 0;
    // Z
    let token = $3a1a3d9713aae3cd$var$patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    let hours;
    let absoluteOffset;
    // ±hh
    token = $3a1a3d9713aae3cd$var$patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!$3a1a3d9713aae3cd$var$validateTimezone(hours)) return NaN;
        return -(hours * $3a1a3d9713aae3cd$var$MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = $3a1a3d9713aae3cd$var$patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        const minutes = parseInt(token[3], 10);
        if (!$3a1a3d9713aae3cd$var$validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * $3a1a3d9713aae3cd$var$MILLISECONDS_IN_HOUR + minutes * $3a1a3d9713aae3cd$var$MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if ($3a1a3d9713aae3cd$var$isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        const utcDate = isUtcDate ? date : $3a1a3d9713aae3cd$var$toUtcDate(date);
        const offset = $3a1a3d9713aae3cd$var$calcOffset(utcDate, timezoneString);
        const fixedOffset = isUtcDate ? offset : $3a1a3d9713aae3cd$var$fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function $3a1a3d9713aae3cd$var$toUtcDate(date) {
    return (0, $dbbc94b2c9b7796e$export$461165d00818234e)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function $3a1a3d9713aae3cd$var$calcOffset(date, timezoneString) {
    const tokens = (0, $ac3e95dde4ceb674$export$6f7bba78170cdfff)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    const asUTC = (0, $dbbc94b2c9b7796e$export$461165d00818234e)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    let asTS = date.getTime();
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function $3a1a3d9713aae3cd$var$fixOffset(date, offset, timezoneString) {
    const localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    const o2 = $3a1a3d9713aae3cd$var$calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    const o3 = $3a1a3d9713aae3cd$var$calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function $3a1a3d9713aae3cd$var$validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
const $3a1a3d9713aae3cd$var$validIANATimezoneCache = {};
function $3a1a3d9713aae3cd$var$isValidTimezoneIANAString(timeZoneString) {
    if ($3a1a3d9713aae3cd$var$validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        $3a1a3d9713aae3cd$var$validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}


const $1f8f18832af08047$var$MILLISECONDS_IN_MINUTE = 60000;
const $1f8f18832af08047$export$fe98a034cfb96d55 = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, options) {
        const timezoneOffset = $1f8f18832af08047$var$getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return $1f8f18832af08047$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return $1f8f18832af08047$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return $1f8f18832af08047$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, options) {
        const timezoneOffset = $1f8f18832af08047$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return $1f8f18832af08047$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return $1f8f18832af08047$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return $1f8f18832af08047$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, options) {
        const timezoneOffset = $1f8f18832af08047$var$getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + $1f8f18832af08047$var$formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + $1f8f18832af08047$var$formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, $c188e18c3892cda7$export$90e6cdae187a86ac)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, $c188e18c3892cda7$export$90e6cdae187a86ac)('long', date, options);
        }
    }
};
function $1f8f18832af08047$var$getTimeZoneOffset(timeZone, originalDate) {
    const timeZoneOffset = timeZone ? (0, $3a1a3d9713aae3cd$export$57649162eea44a93)(timeZone, originalDate, true) / $1f8f18832af08047$var$MILLISECONDS_IN_MINUTE : originalDate?.getTimezoneOffset() ?? 0;
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function $1f8f18832af08047$var$addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? '-' : '';
    let output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function $1f8f18832af08047$var$formatTimezone(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = $1f8f18832af08047$var$addLeadingZeros(Math.floor(absOffset / 60), 2);
    const minutes = $1f8f18832af08047$var$addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimiter + minutes;
}
function $1f8f18832af08047$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? '-' : '+';
        return sign + $1f8f18832af08047$var$addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return $1f8f18832af08047$var$formatTimezone(offset, delimiter);
}
function $1f8f18832af08047$var$formatTimezoneShort(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + $1f8f18832af08047$var$addLeadingZeros(minutes, 2);
}


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $bbd26179fb93fcf7$export$113002b5eff6e430(date) {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return +date - +utcDate;
}



/** Regex to identify the presence of a time zone specifier in a date string */ const $86f91a3c7f9a9743$export$a859e97a80802e41 = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;


const $7a5e6daef75f68d9$var$MILLISECONDS_IN_HOUR = 3600000;
const $7a5e6daef75f68d9$var$MILLISECONDS_IN_MINUTE = 60000;
const $7a5e6daef75f68d9$var$DEFAULT_ADDITIONAL_DIGITS = 2;
const $7a5e6daef75f68d9$var$patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, $86f91a3c7f9a9743$export$a859e97a80802e41)
};
function $7a5e6daef75f68d9$export$e67a095c620b86fe(argument, options = {}) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    const additionalDigits = options.additionalDigits == null ? $7a5e6daef75f68d9$var$DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    const dateStrings = $7a5e6daef75f68d9$var$splitDateString(argument);
    const { year: year, restDateString: restDateString } = $7a5e6daef75f68d9$var$parseYear(dateStrings.date, additionalDigits);
    const date = $7a5e6daef75f68d9$var$parseDate(restDateString, year);
    if (date === null || isNaN(date.getTime())) return new Date(NaN);
    if (date) {
        const timestamp = date.getTime();
        let time = 0;
        let offset;
        if (dateStrings.time) {
            time = $7a5e6daef75f68d9$var$parseTime(dateStrings.time);
            if (time === null || isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, $3a1a3d9713aae3cd$export$57649162eea44a93)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, $bbd26179fb93fcf7$export$113002b5eff6e430)(new Date(timestamp + time));
            offset = (0, $bbd26179fb93fcf7$export$113002b5eff6e430)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function $7a5e6daef75f68d9$var$splitDateString(dateString) {
    const dateStrings = {};
    let parts = $7a5e6daef75f68d9$var$patterns.dateTimePattern.exec(dateString);
    let timeString;
    if (!parts) {
        parts = $7a5e6daef75f68d9$var$patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        const token = $7a5e6daef75f68d9$var$patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $7a5e6daef75f68d9$var$parseYear(dateString, additionalDigits) {
    if (dateString) {
        const patternYYY = $7a5e6daef75f68d9$var$patterns.YYY[additionalDigits];
        const patternYYYYY = $7a5e6daef75f68d9$var$patterns.YYYYY[additionalDigits];
        // YYYY or ±YYYYY
        let token = $7a5e6daef75f68d9$var$patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            const yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        // YY or ±YYY
        token = $7a5e6daef75f68d9$var$patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            const centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function $7a5e6daef75f68d9$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    let date;
    let month;
    let week;
    // YYYY
    if (!dateString || !dateString.length) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    let token = $7a5e6daef75f68d9$var$patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!$7a5e6daef75f68d9$var$validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = $7a5e6daef75f68d9$var$patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        const dayOfYear = parseInt(token[1], 10);
        if (!$7a5e6daef75f68d9$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = $7a5e6daef75f68d9$var$patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        const day = parseInt(token[2], 10);
        if (!$7a5e6daef75f68d9$var$validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = $7a5e6daef75f68d9$var$patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!$7a5e6daef75f68d9$var$validateWeekDate(week)) return new Date(NaN);
        return $7a5e6daef75f68d9$var$dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = $7a5e6daef75f68d9$var$patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        const dayOfWeek = parseInt(token[2], 10) - 1;
        if (!$7a5e6daef75f68d9$var$validateWeekDate(week, dayOfWeek)) return new Date(NaN);
        return $7a5e6daef75f68d9$var$dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function $7a5e6daef75f68d9$var$parseTime(timeString) {
    let hours;
    let minutes;
    // hh
    let token = $7a5e6daef75f68d9$var$patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!$7a5e6daef75f68d9$var$validateTime(hours)) return NaN;
        return hours % 24 * $7a5e6daef75f68d9$var$MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = $7a5e6daef75f68d9$var$patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!$7a5e6daef75f68d9$var$validateTime(hours, minutes)) return NaN;
        return hours % 24 * $7a5e6daef75f68d9$var$MILLISECONDS_IN_HOUR + minutes * $7a5e6daef75f68d9$var$MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = $7a5e6daef75f68d9$var$patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        const seconds = parseFloat(token[3].replace(',', '.'));
        if (!$7a5e6daef75f68d9$var$validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * $7a5e6daef75f68d9$var$MILLISECONDS_IN_HOUR + minutes * $7a5e6daef75f68d9$var$MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function $7a5e6daef75f68d9$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
const $7a5e6daef75f68d9$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $7a5e6daef75f68d9$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $7a5e6daef75f68d9$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $7a5e6daef75f68d9$var$validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        const isLeapYear = $7a5e6daef75f68d9$var$isLeapYearIndex(year);
        if (isLeapYear && date > $7a5e6daef75f68d9$var$DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > $7a5e6daef75f68d9$var$DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function $7a5e6daef75f68d9$var$validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    const isLeapYear = $7a5e6daef75f68d9$var$isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function $7a5e6daef75f68d9$var$validateWeekDate(week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function $7a5e6daef75f68d9$var$validateTime(hours, minutes, seconds) {
    if (hours < 0 || hours >= 25) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}


const $a752b949231e6c46$var$tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function $a752b949231e6c46$export$d9468344d3651243(date, formatStr, options = {}) {
    formatStr = String(formatStr);
    const matches = formatStr.match($a752b949231e6c46$var$tzFormattingTokensRegExp);
    if (matches) {
        const d = (0, $7a5e6daef75f68d9$export$e67a095c620b86fe)(options.originalDate || date, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result; // This is a quoted portion, matched only to ensure we don't match inside it
            const pos = result.indexOf(token);
            const precededByQuotedSection = result[pos - 1] === "'";
            const replaced = result.replace(token, "'" + (0, $1f8f18832af08047$export$fe98a034cfb96d55)[token[0]](d, token, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, $303ba10db2c74ab4$export$d9468344d3651243)(date, formatStr, options);
}





function $fb3cb721acf1a13d$export$3ee79d090bac6d33(date, timeZone, options) {
    date = (0, $7a5e6daef75f68d9$export$e67a095c620b86fe)(date, options);
    const offsetMilliseconds = (0, $3a1a3d9713aae3cd$export$57649162eea44a93)(timeZone, date, true);
    const d = new Date(date.getTime() - offsetMilliseconds);
    const resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}


function $a5f134591027a97b$export$b3ea52468069e196(date, timeZone, formatStr, options) {
    options = {
        ...options,
        timeZone: timeZone,
        originalDate: date
    };
    return (0, $a752b949231e6c46$export$d9468344d3651243)((0, $fb3cb721acf1a13d$export$3ee79d090bac6d33)(date, timeZone, {
        timeZone: options.timeZone
    }), formatStr, options);
}






function $2b10790150509276$export$7e1e8af4bb294f2b(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, $86f91a3c7f9a9743$export$a859e97a80802e41))) return (0, $7a5e6daef75f68d9$export$e67a095c620b86fe)(date, {
        ...options,
        timeZone: timeZone
    });
    date = (0, $7a5e6daef75f68d9$export$e67a095c620b86fe)(date, options);
    const utc = (0, $dbbc94b2c9b7796e$export$461165d00818234e)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()).getTime();
    const offsetMilliseconds = (0, $3a1a3d9713aae3cd$export$57649162eea44a93)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}




function $6e6234d3ea1e6c23$export$4c9db454e2785fd9(timeZone, date) {
    return -(0, $3a1a3d9713aae3cd$export$57649162eea44a93)(timeZone, date);
}









function $57397b9e44500b87$export$f645ddd439eb259d(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$57397b9e44500b87$export$2e2bcd8739ae039 = $57397b9e44500b87$export$f645ddd439eb259d;



function $16856745969af5fc$export$63264690f8e36790(date, month, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $57397b9e44500b87$export$f645ddd439eb259d)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$16856745969af5fc$export$2e2bcd8739ae039 = $16856745969af5fc$export$63264690f8e36790;



function $e8b97269a8745db5$export$adaa4cf7ef1b65be(date, values, options) {
    let _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+_date)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    if (values.year != null) _date.setFullYear(values.year);
    if (values.month != null) _date = (0, $16856745969af5fc$export$63264690f8e36790)(_date, values.month);
    if (values.date != null) _date.setDate(values.date);
    if (values.hours != null) _date.setHours(values.hours);
    if (values.minutes != null) _date.setMinutes(values.minutes);
    if (values.seconds != null) _date.setSeconds(values.seconds);
    if (values.milliseconds != null) _date.setMilliseconds(values.milliseconds);
    return _date;
}
var // Fallback for modularized imports:
$e8b97269a8745db5$export$2e2bcd8739ae039 = $e8b97269a8745db5$export$adaa4cf7ef1b65be;



var $f1q41 = parcelRequire("f1q41");
function $90fb957545aae5a4$export$e5ff5c01504275c4(startTime, timeZone, duration = 3600000) {
    const endTime = startTime + duration;
    const formattedStartTime = new Date(startTime).toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timeZone
    });
    const formattedEndTime = new Date(endTime).toLocaleString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timeZone
    });
    return formattedStartTime + ' - ' + formattedEndTime;
}
function $90fb957545aae5a4$export$b1ca0d3383204cb9(timeZone) {
    switch(timeZone){
        case 'America/Los_Angeles':
            return ' (PDT)';
    }
}
function $90fb957545aae5a4$export$ce26593672b242a5(appointmentDate) {
    const interval = 30; //minutes interval
    const startingHour = 8;
    const endingHour = 19.5;
    const startingMinutes = startingHour * 60; // start time in minutes
    const endingMinutes = endingHour * 60; // end time in minutes
    // get the user client timezone
    const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const timeZoneOffsetToUTC = (0, $6e6234d3ea1e6c23$export$4c9db454e2785fd9)(userTimeZone, appointmentDate);
    const offsetToLA = timeZoneOffsetToUTC + 25200000;
    const timeSlots = (0, $f1q41.map)($90fb957545aae5a4$var$generateIntervals(startingMinutes, endingMinutes, interval), ({ hour: hour, minute: minute })=>{
        const startTime = (0, $e8b97269a8745db5$export$adaa4cf7ef1b65be)(appointmentDate, {
            hours: hour,
            minutes: minute,
            seconds: 0,
            milliseconds: 0
        }).getTime();
        return {
            label: $90fb957545aae5a4$export$e5ff5c01504275c4(startTime + offsetToLA, 'America/Los_Angeles', 1800000),
            value: startTime + offsetToLA
        };
    });
    return timeSlots;
}
function $90fb957545aae5a4$var$generateIntervals(startHourInMinute, endHourInMinute, interval) {
    const times = [];
    for(let i = 0; startHourInMinute < 1440; i++){
        if (startHourInMinute > endHourInMinute) break;
        const hh = Math.floor(startHourInMinute / 60); // getting hours of day in 0-24 format
        const mm = startHourInMinute % 60; // getting minutes of the hour in 0-55 format
        startHourInMinute = startHourInMinute + interval;
        times[i] = {
            hour: hh,
            minute: mm
        };
    }
    return times;
}
function $90fb957545aae5a4$export$ae61533abf9ec8a1(appointmentDaysList) {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    return appointmentDaysList.filter((appointment)=>new Date(appointment.day).getTime() >= currentDate.getTime()).sort((a, b)=>new Date(a.day).getTime() - new Date(b.day).getTime());
}
function $90fb957545aae5a4$export$7beaceb52de4cf0b(appointmentDays) {
    return appointmentDays.map(({ day: day, appointmentsList: appointmentsList })=>({
            day: day,
            appointments: $90fb957545aae5a4$var$formatAppointments(appointmentsList, day)
        }));
}
function $90fb957545aae5a4$export$9677806c6bd86d45(appointmentDay) {
    const taskDate = new Date(appointmentDay);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const diff = taskDate.getTime() - today.getTime();
    if (today.getTime() == taskDate.getTime()) return `Today - ${Intl.DateTimeFormat().format(taskDate)}`;
    else if (diff <= 86400000 && diff > 0) return `Tomorrow - ${Intl.DateTimeFormat().format(taskDate)}`;
    return `${Intl.DateTimeFormat('en-us', {
        weekday: 'long'
    }).format(taskDate)} ${Intl.DateTimeFormat().format(taskDate)}`;
}
function $90fb957545aae5a4$export$5afee16442bde5ee(enumObject, value) {
    return Object.keys(enumObject).find((key)=>enumObject[key] === value);
}
function $90fb957545aae5a4$export$9259e371899a42d(key) {
    if (key && key.length > 0) {
        key = key.toLowerCase();
        key = key.charAt(0).toUpperCase() + key.slice(1);
        return key;
    }
    return null;
}
/*
 * Format Appointments response to FE usable appointments
 * */ function $90fb957545aae5a4$var$formatAppointments(appointments, day) {
    return appointments.filter((appointment)=>!!appointment.customerInfo) // filter any appointments with corrupted customer data so non-corrupted appointments are still rendered
    .map(({ appointmentType: type, appointmentStatus: status, dealershipInfo: dealershipInfo, startTime: startTime, notesList: notesList, customerInfo: customerInfo, vehicleInfo: vehicleInfo, timeZone: timeZone, id: id, duration: duration, reservationId: reservationId, subscriptionId: subscriptionId })=>{
        return {
            id: id,
            reservationId: reservationId,
            date: new Date(day),
            customerId: customerInfo.id,
            customerName: customerInfo.fullName,
            customerAccountNumber: customerInfo.accountNum,
            location: dealershipInfo.name,
            dealershipId: dealershipInfo.id,
            assigneeName: dealershipInfo.assignee,
            assigneeId: dealershipInfo.assigneeId,
            note: notesList?.[notesList?.length - 1]?.content,
            noteAuthor: notesList?.[notesList?.length - 1]?.author,
            notes: notesList,
            startTime: startTime,
            typeLabel: $90fb957545aae5a4$export$9259e371899a42d($90fb957545aae5a4$export$5afee16442bde5ee((0, $fcTGK.AppointmentType), type)),
            type: type,
            statusLabel: $90fb957545aae5a4$export$9259e371899a42d($90fb957545aae5a4$export$5afee16442bde5ee((0, $fcTGK.AppointmentStatus), status)),
            status: status,
            timeZone: timeZone,
            vehicleId: vehicleInfo?.id,
            vin: vehicleInfo?.vin,
            make: vehicleInfo?.make,
            model: vehicleInfo?.model,
            year: vehicleInfo?.year,
            color: vehicleInfo?.color,
            subscriptionId: subscriptionId,
            duration: duration
        };
    });
}
function $90fb957545aae5a4$export$8ea2f7d4d8422b8c(listItem) {
    const appointment = new (0, $fcTGK.Appointment)();
    const notesList = listItem.notes.map(({ id: id, author: author, content: content, created: created })=>{
        const note = new (0, $fcTGK.Note)();
        note.setAuthor(author);
        note.setId(id);
        note.setContent(content);
        note.setCreated(created);
        return note;
    });
    const dealershipInfo = new (0, $fcTGK.DealershipInfo)();
    dealershipInfo.setId(listItem.dealershipId);
    dealershipInfo.setName(listItem.location);
    dealershipInfo.setAssignee(listItem.assigneeName);
    dealershipInfo.setAssigneeId(listItem.assigneeId);
    const customerInfo = new (0, $fcTGK.CustomerInfo)();
    customerInfo.setFullName(listItem.customerName);
    customerInfo.setPhone('');
    customerInfo.setId(listItem.customerId);
    customerInfo.setAccountNum(listItem.customerAccountNumber);
    // Add a new note to the notesList if the note has been changed by the user
    if (!notesList[0] || notesList[0].getContent() !== listItem.note || notesList[0].getAuthor() !== listItem.noteAuthor) {
        const note = new (0, $fcTGK.Note)();
        note.setContent(listItem.note);
        note.setAuthor(listItem.noteAuthor);
        notesList.push(note);
    }
    appointment.setNotesList(notesList);
    appointment.setDealershipInfo(dealershipInfo);
    appointment.setId(listItem.id);
    appointment.setStartTime(listItem.startTime);
    appointment.setAppointmentType(listItem.type);
    appointment.setAppointmentStatus(listItem.status);
    appointment.setTimeZone(listItem.timeZone);
    appointment.setDuration(listItem.duration);
    appointment.setCustomerInfo(customerInfo);
    return appointment;
}



const $b5722c5c4f950bea$export$6a229b20781ed5e = {
    listAppointments: $b5722c5c4f950bea$export$fc0cb9bfb19195f3
};
function $b5722c5c4f950bea$var$getNexusService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
async function $b5722c5c4f950bea$export$fc0cb9bfb19195f3(params) {
    const client = $b5722c5c4f950bea$var$getNexusService();
    const request = new (0, $dsvHa.ListAppointmentsRequest)();
    request.setDealershipId(params.dealershipId);
    request.setDaysOut(365);
    return client.listAppointments(request).then((res)=>res.toObject());
}
async function $b5722c5c4f950bea$export$1fa0b8bea340a1b6(accountNumber) {
    const client = $b5722c5c4f950bea$var$getNexusService();
    const request = new (0, $dsvHa.ListAppointmentsRequest)();
    request.setAccountNumber(accountNumber);
    request.setDaysOut(365);
    return client.listAppointments(request).then((res)=>res.toObject());
}
function $b5722c5c4f950bea$export$b26c5fc583bec9a2(appointmentId) {
    const request = new (0, $7QrRI.CancelAppointmentRequest)();
    if (!appointmentId) throw new Error('Appointment ID must be provided.');
    request.setAppointmentId(appointmentId);
    return request;
}
async function $b5722c5c4f950bea$export$7515ecefb5bac325(appointmentId) {
    const client = $b5722c5c4f950bea$var$getNexusService();
    const request = $b5722c5c4f950bea$export$b26c5fc583bec9a2(appointmentId);
    return client.cancelAppointment(request).then((res)=>res.toObject());
}
function $b5722c5c4f950bea$export$f82349197e50b647(appointment) {
    const client = $b5722c5c4f950bea$var$getNexusService();
    const request = $b5722c5c4f950bea$export$9f370d3dcfda889b(appointment);
    return client.createAppointment(request).then((0, $45ee4ee0548ca22e$export$f14470e236d6ab6a)('create appointment')).then((res)=>{
        return res.toObject();
    });
}
function $b5722c5c4f950bea$export$9f370d3dcfda889b(appointment) {
    const request = new (0, $7QrRI.CreateAppointmentRequest)();
    if (!appointment.dealershipId) throw new Error('Dealership ID must be provided');
    if (!appointment.customerId) throw new Error('Customer ID must be provided');
    if (!appointment.timeZone) throw new Error('Timezone must be provided');
    if (appointment.note && !appointment.noteAuthor) throw new Error('Note author must be set');
    request.setReservationId(appointment.reservationId);
    request.setDealerId(appointment.dealershipId);
    request.setCustomerId(appointment.customerId);
    request.setStartTime(appointment.startTime);
    request.setDuration(appointment.duration);
    request.setTimeZone(appointment.timeZone);
    request.setAppointmentType(appointment.type);
    request.setNote(appointment.note);
    request.setNoteAuthor(appointment.noteAuthor);
    return request;
}
async function $b5722c5c4f950bea$export$bb787bfd62f316af(appointment) {
    const client = $b5722c5c4f950bea$var$getNexusService();
    const request = $b5722c5c4f950bea$export$24552c186cc223a3(appointment);
    return client.updateAppointment(request).then((0, $45ee4ee0548ca22e$export$f14470e236d6ab6a)('update appointment')).then((res)=>{
        return res.toObject();
    });
}
function $b5722c5c4f950bea$export$24552c186cc223a3(appointment) {
    const request = new (0, $7QrRI.UpdateAppointmentRequest)();
    request.setAppointment((0, $90fb957545aae5a4$export$8ea2f7d4d8422b8c)(appointment));
    return request;
}






var $dFFtz = parcelRequire("dFFtz");

function $3c0aa494c42ea012$var$getNexusService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
async function $3c0aa494c42ea012$export$bd366c9e0daf93b1() {
    const client = $3c0aa494c42ea012$var$getNexusService();
    const request = new (0, $dFFtz.ListDealershipsRequest)();
    return client.listDealerships(request).then((0, $45ee4ee0548ca22e$export$f14470e236d6ab6a)('listDealerships')).then((res)=>{
        return res.toObject();
    });
}
async function $3c0aa494c42ea012$export$c789addd151d575d(dealershipId) {
    const client = $3c0aa494c42ea012$var$getNexusService();
    const request = new (0, $dFFtz.ViewTeamRequest)();
    request.setDealershipId(dealershipId);
    return client.viewTeam(request).then((0, $45ee4ee0548ca22e$export$f14470e236d6ab6a)('viewTeam')).then((res)=>{
        return res.toObject();
    });
}



var $9c7Du = parcelRequire("9c7Du");





var $6EauF = parcelRequire("6EauF");

var $9c7Du = parcelRequire("9c7Du");

var $dsvHa = parcelRequire("dsvHa");

var $3QqPt = parcelRequire("3QqPt");

var $acw62 = parcelRequire("acw62");
let $64fc7f0b48dddbf7$var$e = {
    data: ""
}, $64fc7f0b48dddbf7$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $64fc7f0b48dddbf7$var$e, $64fc7f0b48dddbf7$export$54aba348a7896325 = (e)=>{
    let r = $64fc7f0b48dddbf7$var$t(e), l = r.data;
    return r.data = "", l;
}, $64fc7f0b48dddbf7$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $64fc7f0b48dddbf7$var$a = /\/\*[^]*?\*\/|  +/g, $64fc7f0b48dddbf7$var$n = /\n+/g, $64fc7f0b48dddbf7$var$o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? $64fc7f0b48dddbf7$var$o(c, n) : n + "{" + $64fc7f0b48dddbf7$var$o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += $64fc7f0b48dddbf7$var$o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $64fc7f0b48dddbf7$var$o.p ? $64fc7f0b48dddbf7$var$o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $64fc7f0b48dddbf7$var$c = {}, $64fc7f0b48dddbf7$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $64fc7f0b48dddbf7$var$s(e[r]);
        return t;
    }
    return e;
}, $64fc7f0b48dddbf7$var$i = (e, t, r, i, p)=>{
    let u = $64fc7f0b48dddbf7$var$s(e), d = $64fc7f0b48dddbf7$var$c[u] || ($64fc7f0b48dddbf7$var$c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$64fc7f0b48dddbf7$var$c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = $64fc7f0b48dddbf7$var$l.exec(e.replace($64fc7f0b48dddbf7$var$a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace($64fc7f0b48dddbf7$var$n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace($64fc7f0b48dddbf7$var$n, " ").trim();
            return o[0];
        })(e);
        $64fc7f0b48dddbf7$var$c[d] = $64fc7f0b48dddbf7$var$o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && $64fc7f0b48dddbf7$var$c.g ? $64fc7f0b48dddbf7$var$c.g : null;
    return r && ($64fc7f0b48dddbf7$var$c.g = $64fc7f0b48dddbf7$var$c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($64fc7f0b48dddbf7$var$c[d], t, i, f), d;
}, $64fc7f0b48dddbf7$var$p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $64fc7f0b48dddbf7$var$o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function $64fc7f0b48dddbf7$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $64fc7f0b48dddbf7$var$i(l.unshift ? l.raw ? $64fc7f0b48dddbf7$var$p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $64fc7f0b48dddbf7$var$t(r.target), r.g, r.o, r.k);
}
let $64fc7f0b48dddbf7$var$d, $64fc7f0b48dddbf7$var$f, $64fc7f0b48dddbf7$var$g, $64fc7f0b48dddbf7$export$442f1a04865e4790 = $64fc7f0b48dddbf7$export$dbf350e5966cf602.bind({
    g: 1
}), $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e = $64fc7f0b48dddbf7$export$dbf350e5966cf602.bind({
    k: 1
});
function $64fc7f0b48dddbf7$export$de27182ff8187d6c(e, t, r, l) {
    $64fc7f0b48dddbf7$var$o.p = t, $64fc7f0b48dddbf7$var$d = e, $64fc7f0b48dddbf7$var$f = r, $64fc7f0b48dddbf7$var$g = l;
}
function $64fc7f0b48dddbf7$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: $64fc7f0b48dddbf7$var$f && $64fc7f0b48dddbf7$var$f()
            }, c), r.o = / *go\d+/.test(s), c.className = $64fc7f0b48dddbf7$export$dbf350e5966cf602.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), $64fc7f0b48dddbf7$var$g && i[0] && $64fc7f0b48dddbf7$var$g(c), $64fc7f0b48dddbf7$var$d(i, c);
        }
        return t ? t(a) : a;
    };
}


"use client";
var $7d5e77dbd040e613$var$Z = (e)=>typeof e == "function", $7d5e77dbd040e613$export$d812c8e1906863d0 = (e, t)=>$7d5e77dbd040e613$var$Z(e) ? e(t) : e;
var $7d5e77dbd040e613$var$W = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), $7d5e77dbd040e613$var$E = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();
var $7d5e77dbd040e613$var$re = 20, $7d5e77dbd040e613$var$k = "default";
var $7d5e77dbd040e613$var$H = (e, t)=>{
    let { toastLimit: o } = e.settings;
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, o)
            };
        case 1:
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === t.toast.id ? {
                        ...r,
                        ...t.toast
                    } : r)
            };
        case 2:
            let { toast: s } = t;
            return $7d5e77dbd040e613$var$H(e, {
                type: e.toasts.find((r)=>r.id === s.id) ? 1 : 0,
                toast: s
            });
        case 3:
            let { toastId: a } = t;
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === a || a === void 0 ? {
                        ...r,
                        dismissed: !0,
                        visible: !1
                    } : r)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((r)=>r.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let i = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((r)=>({
                        ...r,
                        pauseDuration: r.pauseDuration + i
                    }))
            };
    }
}, $7d5e77dbd040e613$var$v = [], $7d5e77dbd040e613$var$j = {
    toasts: [],
    pausedAt: void 0,
    settings: {
        toastLimit: $7d5e77dbd040e613$var$re
    }
}, $7d5e77dbd040e613$var$f = {}, $7d5e77dbd040e613$var$Y = (e, t = $7d5e77dbd040e613$var$k)=>{
    $7d5e77dbd040e613$var$f[t] = $7d5e77dbd040e613$var$H($7d5e77dbd040e613$var$f[t] || $7d5e77dbd040e613$var$j, e), $7d5e77dbd040e613$var$v.forEach(([o, s])=>{
        o === t && s($7d5e77dbd040e613$var$f[t]);
    });
}, $7d5e77dbd040e613$var$_ = (e)=>Object.keys($7d5e77dbd040e613$var$f).forEach((t)=>$7d5e77dbd040e613$var$Y(e, t)), $7d5e77dbd040e613$var$Q = (e)=>Object.keys($7d5e77dbd040e613$var$f).find((t)=>$7d5e77dbd040e613$var$f[t].toasts.some((o)=>o.id === e)), $7d5e77dbd040e613$var$S = (e = $7d5e77dbd040e613$var$k)=>(t)=>{
        $7d5e77dbd040e613$var$Y(t, e);
    }, $7d5e77dbd040e613$var$se = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, $7d5e77dbd040e613$export$3960353ab538dc47 = (e = {}, t = $7d5e77dbd040e613$var$k)=>{
    let [o, s] = (0, $acw62.useState)($7d5e77dbd040e613$var$f[t] || $7d5e77dbd040e613$var$j), a = (0, $acw62.useRef)($7d5e77dbd040e613$var$f[t]);
    (0, $acw62.useEffect)(()=>(a.current !== $7d5e77dbd040e613$var$f[t] && s($7d5e77dbd040e613$var$f[t]), $7d5e77dbd040e613$var$v.push([
            t,
            s
        ]), ()=>{
            let r = $7d5e77dbd040e613$var$v.findIndex(([l])=>l === t);
            r > -1 && $7d5e77dbd040e613$var$v.splice(r, 1);
        }), [
        t
    ]);
    let i = o.toasts.map((r)=>{
        var l, g, T;
        return {
            ...e,
            ...e[r.type],
            ...r,
            removeDelay: r.removeDelay || ((l = e[r.type]) == null ? void 0 : l.removeDelay) || (e == null ? void 0 : e.removeDelay),
            duration: r.duration || ((g = e[r.type]) == null ? void 0 : g.duration) || (e == null ? void 0 : e.duration) || $7d5e77dbd040e613$var$se[r.type],
            style: {
                ...e.style,
                ...(T = e[r.type]) == null ? void 0 : T.style,
                ...r.style
            }
        };
    });
    return {
        ...o,
        toasts: i
    };
};
var $7d5e77dbd040e613$var$ie = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        dismissed: !1,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || $7d5e77dbd040e613$var$W()
    }), $7d5e77dbd040e613$var$P = (e)=>(t, o)=>{
        let s = $7d5e77dbd040e613$var$ie(t, e, o);
        return $7d5e77dbd040e613$var$S(s.toasterId || $7d5e77dbd040e613$var$Q(s.id))({
            type: 2,
            toast: s
        }), s.id;
    }, $7d5e77dbd040e613$export$b410431fab84fa58 = (e, t)=>$7d5e77dbd040e613$var$P("blank")(e, t);
$7d5e77dbd040e613$export$b410431fab84fa58.error = $7d5e77dbd040e613$var$P("error");
$7d5e77dbd040e613$export$b410431fab84fa58.success = $7d5e77dbd040e613$var$P("success");
$7d5e77dbd040e613$export$b410431fab84fa58.loading = $7d5e77dbd040e613$var$P("loading");
$7d5e77dbd040e613$export$b410431fab84fa58.custom = $7d5e77dbd040e613$var$P("custom");
$7d5e77dbd040e613$export$b410431fab84fa58.dismiss = (e, t)=>{
    let o = {
        type: 3,
        toastId: e
    };
    t ? $7d5e77dbd040e613$var$S(t)(o) : $7d5e77dbd040e613$var$_(o);
};
$7d5e77dbd040e613$export$b410431fab84fa58.dismissAll = (e)=>$7d5e77dbd040e613$export$b410431fab84fa58.dismiss(void 0, e);
$7d5e77dbd040e613$export$b410431fab84fa58.remove = (e, t)=>{
    let o = {
        type: 4,
        toastId: e
    };
    t ? $7d5e77dbd040e613$var$S(t)(o) : $7d5e77dbd040e613$var$_(o);
};
$7d5e77dbd040e613$export$b410431fab84fa58.removeAll = (e)=>$7d5e77dbd040e613$export$b410431fab84fa58.remove(void 0, e);
$7d5e77dbd040e613$export$b410431fab84fa58.promise = (e, t, o)=>{
    let s = $7d5e77dbd040e613$export$b410431fab84fa58.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return typeof e == "function" && (e = e()), e.then((a)=>{
        let i = t.success ? $7d5e77dbd040e613$export$d812c8e1906863d0(t.success, a) : void 0;
        return i ? $7d5e77dbd040e613$export$b410431fab84fa58.success(i, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }) : $7d5e77dbd040e613$export$b410431fab84fa58.dismiss(s), a;
    }).catch((a)=>{
        let i = t.error ? $7d5e77dbd040e613$export$d812c8e1906863d0(t.error, a) : void 0;
        i ? $7d5e77dbd040e613$export$b410431fab84fa58.error(i, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        }) : $7d5e77dbd040e613$export$b410431fab84fa58.dismiss(s);
    }), e;
};
var $7d5e77dbd040e613$var$ce = 1e3, $7d5e77dbd040e613$export$f46171b59bb094f9 = (e, t = "default")=>{
    let { toasts: o, pausedAt: s } = $7d5e77dbd040e613$export$3960353ab538dc47(e, t), a = (0, $acw62.useRef)(new Map).current, i = (0, $acw62.useCallback)((c, m = $7d5e77dbd040e613$var$ce)=>{
        if (a.has(c)) return;
        let p = setTimeout(()=>{
            a.delete(c), r({
                type: 4,
                toastId: c
            });
        }, m);
        a.set(c, p);
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (s) return;
        let c = Date.now(), m = o.map((p)=>{
            if (p.duration === 1 / 0) return;
            let R = (p.duration || 0) + p.pauseDuration - (c - p.createdAt);
            if (R < 0) {
                p.visible && $7d5e77dbd040e613$export$b410431fab84fa58.dismiss(p.id);
                return;
            }
            return setTimeout(()=>$7d5e77dbd040e613$export$b410431fab84fa58.dismiss(p.id, t), R);
        });
        return ()=>{
            m.forEach((p)=>p && clearTimeout(p));
        };
    }, [
        o,
        s,
        t
    ]);
    let r = (0, $acw62.useCallback)($7d5e77dbd040e613$var$S(t), [
        t
    ]), l = (0, $acw62.useCallback)(()=>{
        r({
            type: 5,
            time: Date.now()
        });
    }, [
        r
    ]), g = (0, $acw62.useCallback)((c, m)=>{
        r({
            type: 1,
            toast: {
                id: c,
                height: m
            }
        });
    }, [
        r
    ]), T = (0, $acw62.useCallback)(()=>{
        s && r({
            type: 6,
            time: Date.now()
        });
    }, [
        s,
        r
    ]), d = (0, $acw62.useCallback)((c, m)=>{
        let { reverseOrder: p = !1, gutter: R = 8, defaultPosition: z } = m || {}, O = o.filter((u)=>(u.position || z) === (c.position || z) && u.height), K = O.findIndex((u)=>u.id === c.id), B = O.filter((u, I)=>I < K && u.visible).length;
        return O.filter((u)=>u.visible).slice(...p ? [
            B + 1
        ] : [
            0,
            B
        ]).reduce((u, I)=>u + (I.height || 0) + R, 0);
    }, [
        o
    ]);
    return (0, $acw62.useEffect)(()=>{
        o.forEach((c)=>{
            if (c.dismissed) i(c.id, c.removeDelay);
            else {
                let m = a.get(c.id);
                m && (clearTimeout(m), a.delete(c.id));
            }
        });
    }, [
        o,
        i
    ]), {
        toasts: o,
        handlers: {
            updateHeight: g,
            startPause: l,
            endPause: T,
            calculateOffset: d
        }
    };
};
var $7d5e77dbd040e613$var$de = (0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, $7d5e77dbd040e613$var$me = (0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $7d5e77dbd040e613$var$le = (0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, $7d5e77dbd040e613$export$19bc16ee58e19b3d = (0, $64fc7f0b48dddbf7$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$7d5e77dbd040e613$var$de} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${$7d5e77dbd040e613$var$me} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${$7d5e77dbd040e613$var$le} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;
var $7d5e77dbd040e613$var$Te = (0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, $7d5e77dbd040e613$export$647aae5028016fe9 = (0, $64fc7f0b48dddbf7$export$3817b7a54a07cec7)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${$7d5e77dbd040e613$var$Te} 1s linear infinite;
`;
var $7d5e77dbd040e613$var$ge = (0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, $7d5e77dbd040e613$var$he = (0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, $7d5e77dbd040e613$export$906a919e30cdbd5c = (0, $64fc7f0b48dddbf7$export$3817b7a54a07cec7)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${$7d5e77dbd040e613$var$ge} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${$7d5e77dbd040e613$var$he} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var $7d5e77dbd040e613$var$be = (0, $64fc7f0b48dddbf7$export$3817b7a54a07cec7)("div")`
  position: absolute;
`, $7d5e77dbd040e613$var$Se = (0, $64fc7f0b48dddbf7$export$3817b7a54a07cec7)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, $7d5e77dbd040e613$var$Ae = (0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, $7d5e77dbd040e613$var$Pe = (0, $64fc7f0b48dddbf7$export$3817b7a54a07cec7)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${$7d5e77dbd040e613$var$Ae} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $7d5e77dbd040e613$export$55554e87ff8bb60f = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? $acw62.createElement($7d5e77dbd040e613$var$Pe, null, t) : t : o === "blank" ? null : $acw62.createElement($7d5e77dbd040e613$var$Se, null, $acw62.createElement($7d5e77dbd040e613$export$647aae5028016fe9, {
        ...s
    }), o !== "loading" && $acw62.createElement($7d5e77dbd040e613$var$be, null, o === "error" ? $acw62.createElement($7d5e77dbd040e613$export$19bc16ee58e19b3d, {
        ...s
    }) : $acw62.createElement($7d5e77dbd040e613$export$906a919e30cdbd5c, {
        ...s
    })));
};
var $7d5e77dbd040e613$var$Re = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, $7d5e77dbd040e613$var$Ee = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, $7d5e77dbd040e613$var$ve = "0%{opacity:0;} 100%{opacity:1;}", $7d5e77dbd040e613$var$De = "0%{opacity:1;} 100%{opacity:0;}", $7d5e77dbd040e613$var$Oe = (0, $64fc7f0b48dddbf7$export$3817b7a54a07cec7)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, $7d5e77dbd040e613$var$Ie = (0, $64fc7f0b48dddbf7$export$3817b7a54a07cec7)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, $7d5e77dbd040e613$var$ke = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [a, i] = $7d5e77dbd040e613$var$E() ? [
        $7d5e77dbd040e613$var$ve,
        $7d5e77dbd040e613$var$De
    ] : [
        $7d5e77dbd040e613$var$Re(s),
        $7d5e77dbd040e613$var$Ee(s)
    ];
    return {
        animation: t ? `${(0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, $64fc7f0b48dddbf7$export$d25ddfdf17c3ad3e)(i)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, $7d5e77dbd040e613$export$af68597b0c62c1df = $acw62.memo(({ toast: e, position: t, style: o, children: s })=>{
    let a = e.height ? $7d5e77dbd040e613$var$ke(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, i = $acw62.createElement($7d5e77dbd040e613$export$55554e87ff8bb60f, {
        toast: e
    }), r = $acw62.createElement($7d5e77dbd040e613$var$Ie, {
        ...e.ariaProps
    }, $7d5e77dbd040e613$export$d812c8e1906863d0(e.message, e));
    return $acw62.createElement($7d5e77dbd040e613$var$Oe, {
        className: e.className,
        style: {
            ...a,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: i,
        message: r
    }) : $acw62.createElement($acw62.Fragment, null, i, r));
});
(0, $64fc7f0b48dddbf7$export$de27182ff8187d6c)($acw62.createElement);
var $7d5e77dbd040e613$var$we = ({ id: e, className: t, style: o, onHeightUpdate: s, children: a })=>{
    let i = $acw62.useCallback((r)=>{
        if (r) {
            let l = ()=>{
                let g = r.getBoundingClientRect().height;
                s(e, g);
            };
            l(), new MutationObserver(l).observe(r, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return $acw62.createElement("div", {
        ref: i,
        className: t,
        style: o
    }, a);
}, $7d5e77dbd040e613$var$Me = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, a = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $7d5e77dbd040e613$var$E() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...a
    };
}, $7d5e77dbd040e613$var$Ce = (0, $64fc7f0b48dddbf7$export$dbf350e5966cf602)`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, $7d5e77dbd040e613$var$D = 16, $7d5e77dbd040e613$export$fb98e3a2a4cd92d7 = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: a, toasterId: i, containerStyle: r, containerClassName: l })=>{
    let { toasts: g, handlers: T } = $7d5e77dbd040e613$export$f46171b59bb094f9(o, i);
    return $acw62.createElement("div", {
        "data-rht-toaster": i || "",
        style: {
            position: "fixed",
            zIndex: 9999,
            top: $7d5e77dbd040e613$var$D,
            left: $7d5e77dbd040e613$var$D,
            right: $7d5e77dbd040e613$var$D,
            bottom: $7d5e77dbd040e613$var$D,
            pointerEvents: "none",
            ...r
        },
        className: l,
        onMouseEnter: T.startPause,
        onMouseLeave: T.endPause
    }, g.map((d)=>{
        let c = d.position || t, m = T.calculateOffset(d, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), p = $7d5e77dbd040e613$var$Me(c, m);
        return $acw62.createElement($7d5e77dbd040e613$var$we, {
            id: d.id,
            key: d.id,
            onHeightUpdate: T.updateHeight,
            className: d.visible ? $7d5e77dbd040e613$var$Ce : "",
            style: p
        }, d.type === "custom" ? $7d5e77dbd040e613$export$d812c8e1906863d0(d.message, d) : a ? a(d) : $acw62.createElement($7d5e77dbd040e613$export$af68597b0c62c1df, {
            toast: d,
            position: c
        }));
    }));
};
var $7d5e77dbd040e613$export$2e2bcd8739ae039 = $7d5e77dbd040e613$export$b410431fab84fa58;


function $a8158ebe03199986$export$9e425aa3bc4615e4(params) {
    return params.map((queryParam)=>{
        const request = new (0, $9c7Du.QueryParams)();
        request.setProperty(queryParam.property);
        request.setValue(queryParam.value);
        request.setModifier(queryParam.modifier);
        return request;
    });
}
function $a8158ebe03199986$export$6e056c4111eab585(params) {
    return params.map((queryParam)=>{
        const request = new (0, $9c7Du.OrderParams)();
        request.setProperty(queryParam.property);
        request.setDirection(queryParam.direction);
        return request;
    });
}
function $a8158ebe03199986$export$85165fa2c02223ff(params) {
    const request = new (0, $9c7Du.PaginationParams)();
    request.setLimit(params?.limit);
    request.setOffset(params?.offset);
    return request;
}
function $a8158ebe03199986$var$getCustomerService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $df70feab7068291e$exports.CustomerServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $a8158ebe03199986$var$getNexusService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $a8158ebe03199986$export$936f33e068d418dd(customerId) {
    const client = $a8158ebe03199986$var$getCustomerService();
    const request = new (0, $6EauF.UpdateCustomerWithFakePhoneRequest)();
    request.setCustomerId(customerId);
    return client.updateCustomerWithFakePhone(request).then((res)=>{
        return res.toObject();
    });
}
function $a8158ebe03199986$export$e6e17dabe8760570(customerId) {
    const client = $a8158ebe03199986$var$getCustomerService();
    const request = new (0, $6EauF.GetCustomerByIDRequest)();
    request.setCustomerId(customerId);
    return client.getCustomerByID(request).then((res)=>{
        return res.toObject();
    });
}
function $a8158ebe03199986$export$bb306fc1d45c1bdf(customerId) {
    const client = $a8158ebe03199986$var$getNexusService();
    const request = new (0, $dsvHa.GetCustomerImagesRequest)();
    request.setCustomerId(customerId);
    return client.getCustomerImages(request).then((res)=>{
        return res.toObject();
    });
}
function $a8158ebe03199986$export$455dff7b6867d4f0({ searchParam: searchParam }) {
    const client = $a8158ebe03199986$var$getCustomerService();
    const request = new (0, $6EauF.ListCustomersRequest)();
    const searchParamsObj = new (0, $9c7Du.SearchParams)();
    searchParamsObj.setQueryList($a8158ebe03199986$export$9e425aa3bc4615e4(searchParam?.query || []));
    searchParamsObj.setOrderList($a8158ebe03199986$export$6e056c4111eab585(searchParam?.order || []));
    searchParamsObj.setPagination($a8158ebe03199986$export$85165fa2c02223ff(searchParam?.pagination));
    request.setSearchParam(searchParamsObj);
    return client.listCustomers(request).then((res)=>{
        return res.toObject();
    });
}
async function $a8158ebe03199986$export$803613573e2b1f34(customer_id, addressObj) {
    try {
        const client = $a8158ebe03199986$var$getCustomerService();
        const request = new (0, $6EauF.UpsertAddressesRequest)();
        const addresses = [
            addressObj
        ].map((addr)=>{
            const address = new (0, $3QqPt.Address)();
            address.setStreet(addr.street);
            address.setStreet2(addr.street2);
            address.setState(addr.state);
            address.setCity(addr.city);
            address.setPostal(addr.postal);
            address.setAddressType(addr.addressType);
            address.setDeleted(false);
            address.setId(addr.id);
            return address;
        });
        request.setCustomerId(customer_id);
        request.setAddressesList(addresses);
        return await client.upsertAddresses(request);
    } catch (error) {
        (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error(error.message);
    }
}
function $a8158ebe03199986$export$ad8c0b0ef6fc17c1(phoneNumber) {
    try {
        const client = $a8158ebe03199986$var$getNexusService();
        // Note: This API call may need to be implemented on the backend
        // For now, we'll attempt to call it and gracefully handle any errors
        if (typeof client.getAllCustomersByPhone === 'function') {
            const request = new (0, $6EauF.GetAllCustomersByPhoneRequest)();
            request.setPhone(phoneNumber);
            return client.getAllCustomersByPhone(request).then((res)=>{
                return res.toObject ? res.toObject() : res;
            }).catch((error)=>{
                console.error('getAllCustomersByPhone error:', error);
                return {
                    customersList: []
                };
            });
        }
    } catch (error) {
        console.error('getAllCustomersByPhone client error:', error);
        return Promise.resolve({
            customersList: []
        });
    }
}



var $6EauF = parcelRequire("6EauF");

const $c01abb109ee4ca80$export$c540cfc05e7c00b1 = {
    getCustomer: $c01abb109ee4ca80$var$getCustomer,
    listAppointments: $b5722c5c4f950bea$export$fc0cb9bfb19195f3,
    cancelAppointment: $b5722c5c4f950bea$export$7515ecefb5bac325,
    createStatement: $c01abb109ee4ca80$var$notImplementedFunction,
    createAppointment: $b5722c5c4f950bea$export$f82349197e50b647,
    updateAppointment: $b5722c5c4f950bea$export$bb787bfd62f316af,
    listPromosRequest: $756e67a155228bc1$export$35b78bae575ec8aa,
    listAppointmentsByAccountNumber: $b5722c5c4f950bea$export$1fa0b8bea340a1b6,
    createPromoCode: $756e67a155228bc1$export$26b1b4b5e5dc3cdb,
    listPromoPartners: $756e67a155228bc1$export$29f92976ef700e34,
    createPromoPartner: $756e67a155228bc1$export$dd1e464879d24301,
    getCustomerInvoices: $756e67a155228bc1$export$3fea7341c6dda927,
    getVehicles: $c01abb109ee4ca80$var$getMapVehicles,
    listDealerships: $3c0aa494c42ea012$export$bd366c9e0daf93b1,
    listTransactions: $c01abb109ee4ca80$var$notImplementedFunction,
    getAccountBalance: $756e67a155228bc1$export$ca8160a3ac0b212,
    getLatestCustody: $1f7bb63928e45f23$export$6801ccf82ddf6afb,
    listProgramPricing: $756e67a155228bc1$export$715721e1ff07403e,
    getBillingStatus: $756e67a155228bc1$export$a867816ede6e11d5,
    getSubscriptionById: $756e67a155228bc1$export$16fd171b2bdd7a79,
    listCustomerSubscriptions: $756e67a155228bc1$export$4dc00ef85fd3c975,
    listRecurringBillableItems: $756e67a155228bc1$export$e61db6118c955e15,
    updateRecurringBillableItems: $756e67a155228bc1$export$8f54171fdd09839d,
    removeMileageRecurringBillableItem: $756e67a155228bc1$export$e1f13c103914dd8e,
    payInvoice: $756e67a155228bc1$export$6544aa26cd8de610,
    LogMilesPurchased: $1f7bb63928e45f23$export$99549ebb5105e7db,
    deleteMilesPurchasedLog: $1f7bb63928e45f23$export$97220878af29b590,
    UpdateProgramReservation: $756e67a155228bc1$export$601a378d98897038,
    getProgramReservation: $756e67a155228bc1$export$5c657c66d93f6525,
    UpdateCustomerWithFakePhone: $a8158ebe03199986$export$936f33e068d418dd,
    getCustomerById: $a8158ebe03199986$export$e6e17dabe8760570,
    ListCustomers: $a8158ebe03199986$export$455dff7b6867d4f0,
    updateCustomer: $c01abb109ee4ca80$var$updateCustomer,
    editCustomerAddresses: $a8158ebe03199986$export$803613573e2b1f34,
    getAllCustomersByPhone: $a8158ebe03199986$export$ad8c0b0ef6fc17c1,
    convertToGalpinTesla: $c01abb109ee4ca80$export$7c6e1bfa4bdfdf44,
    getListClients: $c01abb109ee4ca80$var$getListClients,
    viewTeam: $3c0aa494c42ea012$export$c789addd151d575d,
    listVehicleMakes: $1f7bb63928e45f23$export$9262ceaa06b84b83,
    listModelsByMake: $1f7bb63928e45f23$export$4079c7d438f07c9f,
    upsertInsurancePolicies: $dbaa63f10354f5f5$export$9d1ccecb4250caa,
    cancelInsurancePolicy: $dbaa63f10354f5f5$export$cbbd242c6cae2632,
    returnVehicle: $1f7bb63928e45f23$export$240a68f088d6e40c,
    addVehicle: $1f7bb63928e45f23$export$a959b20bb630c9f4,
    addVehicles: $1f7bb63928e45f23$export$790260d39dc05e1c,
    getVehicleMedia: $1f7bb63928e45f23$export$2266d036925a0e4b,
    upsertVehicleMedia: $1f7bb63928e45f23$export$786b106d3ad84b80,
    updateVehicle: $1f7bb63928e45f23$export$ba81ea9fb3979088,
    initiateVehicleReturn: $1f7bb63928e45f23$export$b05592a654483467,
    deleteVehicleMedia: $1f7bb63928e45f23$export$74943467391554b
};
function $c01abb109ee4ca80$var$getNexusService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $c01abb109ee4ca80$var$getCustomerService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $df70feab7068291e$exports.CustomerServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
async function $c01abb109ee4ca80$var$getListClients() {
    const client = $c01abb109ee4ca80$var$getNexusService();
    const request = new (0, $6EauF.ListClientsRequest)();
    return client.listClients(request).then((res)=>{
        return res.toObject()?.clientsList;
    });
}
function $c01abb109ee4ca80$var$getCustomer(params) {
    const client = $c01abb109ee4ca80$var$getNexusService();
    const request = $c01abb109ee4ca80$export$24693392fcfb3bb1(params);
    return client.getCustomer(request).then((res)=>{
        return res.toObject();
    });
}
function $c01abb109ee4ca80$var$updateCustomer(params) {
    const client = $c01abb109ee4ca80$var$getCustomerService();
    const request = new (0, $6EauF.UpdateCustomerRequest)();
    request.setCustomerId(params.customerId);
    request.setFirstName(params.firstName);
    request.setLastName(params.lastName);
    request.setEmail(params.email);
    request.setPhone(params.phone);
    return client.updateCustomer(request).then((res)=>{
        return res.toObject();
    });
}
function $c01abb109ee4ca80$export$7c6e1bfa4bdfdf44(reservationId) {
    try {
        const client = $c01abb109ee4ca80$var$getNexusService();
        // Note: This API call may need to be implemented on the backend
        if (typeof client.convertToGalpinTesla === 'function') {
            const request = new (0, $dsvHa.ConvertToGalpinTeslaRequest)();
            request.setReservationId(reservationId);
            return client.convertToGalpinTesla(request).then((res)=>{
                return res.toObject ? res.toObject() : res;
            });
        }
    } catch (error) {
        console.error('convertToGalpinTesla client error:', error);
        return Promise.reject(error);
    }
}
function $c01abb109ee4ca80$export$24693392fcfb3bb1(params) {
    const request = new (0, $dsvHa.GetCustomerRequest)();
    if (!(0, $f1q41.isString)(params.customerId)) throw new Error('Request requires customer ID');
    request.setCustomerId(params.customerId);
    return request;
}
function $c01abb109ee4ca80$var$getMapVehicles(params) {
    const client = $c01abb109ee4ca80$var$getNexusService();
    const request = $c01abb109ee4ca80$export$2352b438417f54cb(params);
    return client.getMapVehicles(request).then((res)=>res.toObject());
}
/**
 * Place in more central location.
 * @param params
 * @returns
 */ function $c01abb109ee4ca80$var$buildListParams(params) {
    const status = new (0, $9c7Du.ListParams)();
    if (params?.status?.queryList && params?.status?.queryList.length > 0) {
        const queries = $c01abb109ee4ca80$var$mapQueryParams(params?.status?.queryList);
        status.setQueryList(queries);
    }
    if (params?.status?.orderList && params?.status?.orderList.length > 0) {
        const order = $c01abb109ee4ca80$var$mapOrderList(params?.status?.orderList);
        status.setOrderList(order);
    }
    if (params?.status?.pagination && !(0, $f1q41.isEmpty)(params?.status?.pagination)) {
        const pagination = $c01abb109ee4ca80$var$buildPagination(params?.status?.pagination);
        status.setPagination(pagination);
    }
    return status;
}
function $c01abb109ee4ca80$var$buildPagination(params) {
    const pagination = new (0, $9c7Du.PaginationParams)();
    pagination.setLimit(params.limit);
    pagination.setOffset(params.offset);
    return pagination;
}
function $c01abb109ee4ca80$var$mapQueryParams(params = []) {
    return (0, $f1q41.map)(params, (query)=>{
        const queryParams = new (0, $9c7Du.QueryParams)();
        queryParams.setProperty(query.property);
        queryParams.setValue(query.value);
        queryParams.setModifier(query.modifier);
        return queryParams;
    });
}
function $c01abb109ee4ca80$var$mapOrderList(params = []) {
    return (0, $f1q41.map)(params, (order)=>{
        const orderParam = new (0, $9c7Du.OrderParams)();
        orderParam.setDirection(order.direction);
        orderParam.setProperty(order.property);
        return orderParam;
    });
}
function $c01abb109ee4ca80$export$2352b438417f54cb(params) {
    const request = new (0, $dsvHa.GetVehicleMapRequest)();
    const listParams = $c01abb109ee4ca80$var$buildListParams(params);
    request.setStatus(listParams);
    request.setCustomerName(params.customerName);
    request.setVehicleMake(params.vehicleMake);
    request.setVehicleModel(params.vehicleModel);
    request.setVehicleVin(params.vehicleVin);
    return request;
}
// create not implemented function that returns a promise
function $c01abb109ee4ca80$var$notImplementedFunction(params) {
    console.debug('called notImplementedFunction', params);
    return new Promise((resolve, reject)=>{
        reject('Not Implemented');
    });
}


const $1ed44f525ea4bba9$export$56e68f8f57ecfde4 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $1ed44f525ea4bba9$var$ClientIDProvider = ({ children: children })=>{
    const [clientId, setClientId] = (0, $acw62.useState)('');
    const { data: data } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'clients'
        ],
        queryFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getListClients(),
        placeholderData: []
    });
    const onHandleChange = (e)=>{
        setClientId(e.target.value);
    };
    const stateData = {
        clientId: clientId || data?.[0]?.id || '',
        onHandleChange: onHandleChange,
        clients: data,
        setClientId: setClientId // Expose setClientId if needed
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1ed44f525ea4bba9$export$56e68f8f57ecfde4.Provider, {
        value: stateData,
        children: children
    });
};
var $1ed44f525ea4bba9$export$2e2bcd8739ae039 = $1ed44f525ea4bba9$var$ClientIDProvider;


const $487c79b981d09aa9$export$6e58fb8e4a4eb1b2 = {
    red: '#FF3148',
    // danger
    green: '#00C100',
    // success
    // Note: I made up these colours to complete the palette, we should replace them with Design approved colours
    orange: '#FF8CDD',
    // warning > NOTE: in the designs the 'warning' colours are pink, so 'orange' is set to a pink hexcode for now. I think it should be some orange shade but discuss with UX first
    //yellows
    yellow: '#ebcc34',
    // info
    infoPillYellow: 'hsl(60deg 100% 90% / 71%)',
    // Blues
    cyan: '#00DAFF',
    lightBlue: '#00B9BF',
    mutedBlue: '#407085',
    mediumBlue: '#00415C',
    darkBlue: '#05364D',
    lightCyan: '#006785',
    deepBlue: '#0C2939',
    columnHeader: '#1F2937',
    purple: '#B20043',
    pink: '#FF8CDD',
    // Monochrome
    white: '#ffffff',
    gray: '#A6A6A6',
    dark: '#15161E',
    darker: '#1C1C1C',
    black: '#000000',
    lightGray: '#A1A5B3'
};


const $8570a4c7e09f797a$export$5e758e301d8cbdd = {
    ...(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2),
    // UI component colors for Autonomy theme
    sidebarBackground: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).deepBlue,
    sidebarActive: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).cyan,
    buttonColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).cyan,
    buttonHover: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).lightCyan
};
const $8570a4c7e09f797a$export$f1dd60f4a4247eae = {
    ...(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2),
    // Make primary accents more neutral
    cyan: '#4A90A4',
    // Muted cyan
    pink: '#A67C9A',
    // Muted pink
    // Softer blues
    lightBlue: '#5A8B94',
    lightCyan: '#4A6B75',
    // Maintain contrast but less vibrant
    deepBlue: '#1A2F3A',
    darkBlue: '#2A3F4A',
    mediumBlue: '#3A4F5A',
    // UI component colors for Default theme
    sidebarBackground: '#1A2F3A',
    sidebarActive: '#4A90A4',
    buttonColor: '#4A90A4',
    buttonHover: '#4A6B75'
};
const $8570a4c7e09f797a$export$e987a5c025c9967 = {
    ...(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2),
    // Ford Motor Company brand colors
    cyan: '#003478',
    // Ford Blue (primary brand color)
    pink: '#0066CC',
    // Lighter Ford Blue for accents
    // Ford-inspired blues
    lightBlue: '#0052A3',
    lightCyan: '#003478',
    // Ford brand backgrounds
    deepBlue: '#001A33',
    darkBlue: '#002244',
    mediumBlue: '#003478',
    // Ford complementary colors
    silver: '#C0C0C0',
    // Ford Silver
    lightSilver: '#E8E8E8',
    // UI component colors for Galpin theme
    sidebarBackground: '#001A33',
    // Dark Ford Blue for sidebar
    sidebarActive: '#C0C0C0',
    // Light silver for active items
    buttonColor: '#C0C0C0',
    // Light silver for buttons and links
    buttonHover: '#E8E8E8' // Lighter silver on hover
};
const $8570a4c7e09f797a$export$db29694ebcfc583a = (theme)=>{
    switch(theme){
        case 'autonomy':
            return $8570a4c7e09f797a$export$5e758e301d8cbdd;
        case 'galpin':
            return $8570a4c7e09f797a$export$e987a5c025c9967;
        case 'default':
        default:
            return $8570a4c7e09f797a$export$f1dd60f4a4247eae;
    }
};



const $9ce4840237893f49$export$d3bee11df92369b6 = (colors = (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2))=>({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 1000,
                lg: 1200,
                xl: 1920
            }
        },
        components: {
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        fontSize: 14,
                        fontWeight: 600,
                        letterSpacing: 0
                    }
                }
            },
            MuiButton: {
                defaultProps: {
                    disableElevation: true
                },
                styleOverrides: {
                    root: {
                        textTransform: 'none'
                    },
                    sizeSmall: {
                        padding: '6px 16px'
                    },
                    sizeMedium: {
                        padding: '8px 20px'
                    },
                    sizeLarge: {
                        padding: '11px 24px'
                    },
                    textSizeSmall: {
                        padding: '7px 12px'
                    },
                    textSizeMedium: {
                        padding: '9px 16px'
                    },
                    textSizeLarge: {
                        padding: '12px 16px'
                    }
                }
            },
            MuiButtonBase: {
                defaultProps: {
                    disableRipple: true
                }
            },
            MuiCardContent: {
                styleOverrides: {
                    root: {
                        padding: '32px 24px',
                        '&:last-child': {
                            paddingBottom: '32px'
                        }
                    }
                }
            },
            MuiCardHeader: {
                defaultProps: {
                    titleTypographyProps: {
                        variant: 'h6'
                    },
                    subheaderTypographyProps: {
                        variant: 'body2'
                    }
                },
                styleOverrides: {
                    root: {
                        padding: '32px 24px'
                    }
                }
            },
            MuiCssBaseline: {
                styleOverrides: {
                    '*': {
                        boxSizing: 'border-box',
                        margin: 0,
                        padding: 0
                    },
                    html: {
                        MozOsxFontSmoothing: 'grayscale',
                        WebkitFontSmoothing: 'antialiased',
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: '100%',
                        width: '100%'
                    },
                    body: {
                        display: 'flex',
                        flex: '1 1 auto',
                        flexDirection: 'column',
                        minHeight: '100%',
                        width: '100%'
                    },
                    '#__next': {
                        display: 'flex',
                        flex: '1 1 auto',
                        flexDirection: 'column',
                        height: '100%',
                        width: '100%'
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        '&::placeholder': {
                            opacity: 1,
                            color: colors.lightGray
                        }
                    }
                }
            },
            MuiInput: {
                styleOverrides: {
                    underline: {
                        '&:before': {
                            borderBottom: `1px solid ${colors.gray}`
                        }
                    }
                }
            },
            MuiFilledInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: 'transparent',
                        borderRadius: 8,
                        borderStyle: 'solid',
                        borderWidth: 1,
                        overflow: 'hidden',
                        borderColor: colors.gray,
                        transition: 'border-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                        '&:hover': {
                            backgroundColor: 'transparent'
                        },
                        '&:before, &:after': {
                            display: 'none'
                        },
                        '&.Mui-focused': {
                            backgroundColor: 'transparent',
                            borderColor: colors.cyan
                        }
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        '&:hover .MuiOutlinedInput-notchedOutline': {
                            borderColor: colors.gray
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: colors.cyan
                        }
                    }
                }
            },
            MuiFormLabel: {
                styleOverrides: {
                    root: {
                        fontSize: 14,
                        fontWeight: 500,
                        '&.Mui-focused': {
                            color: colors.cyan
                        }
                    }
                }
            },
            MuiTab: {
                styleOverrides: {
                    root: {
                        fontSize: 15,
                        fontWeight: 500,
                        lineHeight: 1.71,
                        minWidth: 'auto',
                        paddingLeft: 0,
                        paddingRight: 0,
                        textTransform: 'none',
                        '& + &': {
                            marginLeft: 24
                        },
                        marginLeft: 24,
                        color: colors.white,
                        '&.Mui-selected': {
                            color: colors.cyan,
                            borderBottom: `2px solid ${colors.cyan}`
                        }
                    }
                }
            },
            MuiTableHead: {
                styleOverrides: {
                    root: {
                        borderBottom: 'none',
                        '& .MuiTableCell-root': {
                            borderBottom: 'none',
                            fontSize: '12px',
                            fontWeight: 600,
                            lineHeight: 1,
                            letterSpacing: 0.5,
                            textTransform: 'uppercase',
                            color: `${colors.pink} !important`
                        },
                        '& .MuiTableCell-paddingCheckbox': {
                            paddingTop: 4,
                            paddingBottom: 4
                        }
                    }
                }
            },
            MuiDataGrid: {
                styleOverrides: {
                    root: {
                        border: 'none',
                        '& .MuiDataGrid-row': {
                            borderTop: 'thin solid #2D3748',
                            paddingLeft: '10px'
                        },
                        '& .MuiDataGrid-row.evenRow': {
                            backgroundColor: colors.darkBlue
                        },
                        '& .MuiDataGrid-cell.rtl': {
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        '& .MuiDataGrid-footerContainer': {
                            borderTop: 'thin solid #2D3748'
                        }
                    },
                    columnHeaders: {
                        backgroundColor: colors.columnHeader
                    },
                    columnHeaderTitle: {
                        color: `${colors.pink} !important`
                    }
                }
            }
        },
        direction: 'ltr',
        shape: {
            borderRadius: 8
        },
        typography: {
            button: {
                fontWeight: 600
            },
            fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"',
            body1: {
                fontSize: '1rem',
                fontWeight: 400,
                lineHeight: 1.5
            },
            body2: {
                fontSize: '0.875rem',
                fontWeight: 400,
                lineHeight: 1.57
            },
            subtitle1: {
                fontSize: '1rem',
                fontWeight: 500,
                lineHeight: 1.75
            },
            subtitle2: {
                fontSize: '0.875rem',
                fontWeight: 500,
                lineHeight: 1.57
            },
            overline: {
                fontSize: '0.75rem',
                fontWeight: 600,
                letterSpacing: '0.5px',
                lineHeight: 2.5,
                textTransform: 'uppercase'
            },
            caption: {
                fontSize: '0.75rem',
                fontWeight: 400,
                lineHeight: 1.66
            },
            h1: {
                fontWeight: 700,
                fontSize: '3.5rem',
                lineHeight: 1.375
            },
            h2: {
                fontWeight: 700,
                fontSize: '3rem',
                lineHeight: 1.375
            },
            h3: {
                fontWeight: 700,
                fontSize: '2.25rem',
                lineHeight: 1.375
            },
            h4: {
                fontWeight: 700,
                fontSize: '2rem',
                lineHeight: 1.375
            },
            h5: {
                fontWeight: 600,
                fontSize: '1.5rem',
                lineHeight: 1.375
            },
            h6: {
                fontWeight: 600,
                fontSize: '1.125rem',
                lineHeight: 1.375
            }
        },
        zIndex: {
            appBar: 1200,
            drawer: 1100
        }
    });



const $cdd96f89d073239e$export$59653532d2aea9cd = (colors = (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2))=>{
    const neutral = {
        100: '#F3F4F6',
        200: '#E5E7EB',
        300: '#D1D5DB',
        400: '#9CA3AF',
        500: '#6B7280',
        600: '#4B5563',
        700: '#374151',
        800: '#1F2937',
        900: '#111827'
    };
    const background = {
        default: colors.mediumBlue,
        paper: neutral[900]
    };
    const divider = '#2D3748';
    const primary = {
        main: colors.cyan,
        light: '#3FC79A',
        dark: colors.mediumBlue,
        contrastText: neutral[900]
    };
    const secondary = {
        main: colors.cyan,
        light: '#3FC79A',
        dark: colors.mediumBlue,
        contrastText: neutral[900]
    };
    const success = {
        main: '#14B8A6',
        light: '#43C6B7',
        dark: '#0E8074',
        contrastText: neutral[900]
    };
    const info = {
        main: '#2196F3',
        light: '#64B6F7',
        dark: '#0B79D0',
        contrastText: neutral[900]
    };
    const warning = {
        main: '#FFB020',
        light: '#FFBF4C',
        dark: '#B27B16',
        contrastText: neutral[900]
    };
    const error = {
        main: '#D14343',
        light: '#DA6868',
        dark: '#922E2E',
        contrastText: neutral[900]
    };
    const text = {
        primary: '#EDF2F7',
        secondary: '#A0AEC0',
        disabled: 'rgba(255, 255, 255, 0.48)'
    };
    return {
        components: {
            MuiAvatar: {
                styleOverrides: {
                    root: {
                        backgroundColor: neutral[500],
                        color: '#FFFFFF'
                    }
                }
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        '&.MuiChip-filledDefault': {
                            backgroundColor: neutral[800],
                            '& .MuiChip-deleteIcon': {
                                color: neutral[500]
                            }
                        },
                        '&.MuiChip-outlinedDefault': {
                            borderColor: neutral[700],
                            '& .MuiChip-deleteIcon': {
                                color: neutral[700]
                            }
                        }
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        '&::placeholder': {
                            opacity: 1,
                            color: text.secondary
                        }
                    }
                }
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        borderColor: divider
                    }
                }
            },
            MuiMenu: {
                styleOverrides: {
                    paper: {
                        borderColor: divider,
                        borderStyle: 'solid',
                        borderWidth: 1
                    }
                }
            },
            MuiPopover: {
                styleOverrides: {
                    paper: {
                        borderColor: divider,
                        borderStyle: 'solid',
                        borderWidth: 1
                    }
                }
            },
            MuiSwitch: {
                styleOverrides: {
                    switchBase: {
                        color: neutral[700]
                    },
                    track: {
                        backgroundColor: neutral[500],
                        opacity: 1
                    }
                }
            },
            MuiTableCell: {
                styleOverrides: {
                    root: {
                        borderBottom: `1px solid ${divider}`
                    }
                }
            },
            MuiTableHead: {
                styleOverrides: {
                    root: {
                        backgroundColor: neutral[800],
                        '.MuiTableCell-root': {
                            color: neutral[300]
                        }
                    }
                }
            }
        },
        palette: {
            action: {
                active: neutral[400],
                hover: colors.deepBlue,
                selected: 'rgba(255, 255, 255, 0.08)',
                disabledBackground: 'rgba(255, 255, 255, 0.12)',
                disabled: 'rgba(255, 255, 255, 0.26)'
            },
            background: background,
            divider: divider,
            error: error,
            info: info,
            mode: 'dark',
            neutral: neutral,
            primary: primary,
            secondary: secondary,
            success: success,
            text: text,
            warning: warning
        },
        shadows: [
            'none',
            '0px 1px 1px rgba(100, 116, 139, 0.06), 0px 1px 2px rgba(100, 116, 139, 0.1)',
            '0px 1px 2px rgba(100, 116, 139, 0.12)',
            '0px 1px 4px rgba(100, 116, 139, 0.12)',
            '0px 1px 5px rgba(100, 116, 139, 0.12)',
            '0px 1px 6px rgba(100, 116, 139, 0.12)',
            '0px 2px 6px rgba(100, 116, 139, 0.12)',
            '0px 3px 6px rgba(100, 116, 139, 0.12)',
            '0px 2px 4px rgba(31, 41, 55, 0.06), 0px 4px 6px rgba(100, 116, 139, 0.12)',
            '0px 5px 12px rgba(100, 116, 139, 0.12)',
            '0px 5px 14px rgba(100, 116, 139, 0.12)',
            '0px 5px 15px rgba(100, 116, 139, 0.12)',
            '0px 6px 15px rgba(100, 116, 139, 0.12)',
            '0px 7px 15px rgba(100, 116, 139, 0.12)',
            '0px 8px 15px rgba(100, 116, 139, 0.12)',
            '0px 9px 15px rgba(100, 116, 139, 0.12)',
            '0px 10px 15px rgba(100, 116, 139, 0.12)',
            '0px 12px 22px -8px rgba(100, 116, 139, 0.25)',
            '0px 13px 22px -8px rgba(100, 116, 139, 0.25)',
            '0px 14px 24px -8px rgba(100, 116, 139, 0.25)',
            '0px 10px 10px rgba(31, 41, 55, 0.04), 0px 20px 25px rgba(31, 41, 55, 0.1)',
            '0px 25px 50px rgba(100, 116, 139, 0.25)',
            '0px 25px 50px rgba(100, 116, 139, 0.25)',
            '0px 25px 50px rgba(100, 116, 139, 0.25)',
            '0px 25px 50px rgba(100, 116, 139, 0.25)'
        ]
    };
};


const $2c5be066ce1eeb09$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $acw62.createContext)(undefined);
const $2c5be066ce1eeb09$var$getThemeForClient = (clientId, clients)=>{
    // If no client is selected, use default theme
    if (!clientId) return 'default';
    // Find the client to determine theme
    const client = clients?.find((c)=>c.id === clientId);
    if (!client) return 'default';
    // Check if this is Galpin client (adjust this logic based on actual client data structure)
    if (client.name?.toLowerCase().includes('galpin')) return 'galpin';
    // Default to autonomy theme for other clients
    return 'autonomy';
};
const $2c5be066ce1eeb09$var$createClientTheme = (clientTheme)=>{
    const colors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(clientTheme);
    // Create theme options with client-specific colors
    const clientBaseThemeOptions = (0, $9ce4840237893f49$export$d3bee11df92369b6)(colors);
    const clientDarkThemeOptions = (0, $cdd96f89d073239e$export$59653532d2aea9cd)(colors);
    // Create the theme using MUI's createTheme
    const theme = (0, $1c8355eadf532640$export$2e2bcd8739ae039)(clientBaseThemeOptions, clientDarkThemeOptions, {
        direction: 'ltr'
    });
    return theme;
};
const $2c5be066ce1eeb09$export$d8964aec282183a3 = ({ children: children })=>{
    const clientContext = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const currentTheme = (0, $acw62.useMemo)(()=>{
        return $2c5be066ce1eeb09$var$getThemeForClient(clientContext?.clientId || '', clientContext?.clients || []);
    }, [
        clientContext?.clientId,
        clientContext?.clients
    ]);
    const theme = (0, $acw62.useMemo)(()=>{
        return $2c5be066ce1eeb09$var$createClientTheme(currentTheme);
    }, [
        currentTheme
    ]);
    const value = {
        theme: theme,
        currentTheme: currentTheme
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2c5be066ce1eeb09$export$2c657da244d00bd6.Provider, {
        value: value,
        children: children
    });
};
const $2c5be066ce1eeb09$export$93d4e7f90805808f = ()=>{
    const context = (0, $acw62.useContext)($2c5be066ce1eeb09$export$2c657da244d00bd6);
    if (!context) throw new Error('useTheme must be used within a ThemeProvider');
    return context;
};



const $b17c694846cf5b75$var$useStyles = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()(()=>{
    return {
        backButton: {
            border: 'none',
            marginTop: 80,
            marginBottom: 25,
            '&:hover': {
                border: 'none'
            },
            '& .MuiButton-startIcon': {
                marginBottom: 5
            }
        }
    };
});
const $b17c694846cf5b75$export$e0d897ee21382f67 = ({ lastPageRoute: lastPageRoute })=>{
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const { classes: classes } = $b17c694846cf5b75$var$useStyles();
    const navigate = (0, $84c11e79798ea0cb$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
        className: classes.backButton,
        onClick: lastPageRoute ? ()=>navigate(`${lastPageRoute}`) : ()=>navigate(-1),
        variant: "outlined",
        startIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d42c3a87ce67e89d$export$2e2bcd8739ae039), {}),
        sx: {
            color: themeColors.buttonColor,
            borderColor: themeColors.buttonColor,
            '&:hover': {
                borderColor: themeColors.buttonHover,
                color: themeColors.buttonHover
            }
        },
        children: "Back"
    });
};




var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");










function $6e9163c6dd169139$export$24c1f8f60cbac79e(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTypography', slot);
}
const $6e9163c6dd169139$var$typographyClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTypography', [
    'root',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'subtitle1',
    'subtitle2',
    'body1',
    'body2',
    'inherit',
    'button',
    'caption',
    'overline',
    'alignLeft',
    'alignRight',
    'alignCenter',
    'alignJustify',
    'noWrap',
    'gutterBottom',
    'paragraph'
]);
var $6e9163c6dd169139$export$2e2bcd8739ae039 = $6e9163c6dd169139$var$typographyClasses;



'use client';
const $5ca16cb6e72a53f1$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $5ca16cb6e72a53f1$var$extendSxProp = (0, $76e91e24afb64923$export$7e7f5719ff4debb1)();
const $5ca16cb6e72a53f1$var$useUtilityClasses = (ownerState)=>{
    const { align: align, gutterBottom: gutterBottom, noWrap: noWrap, paragraph: paragraph, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            ownerState.align !== 'inherit' && `align${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(align)}`,
            gutterBottom && 'gutterBottom',
            noWrap && 'noWrap',
            paragraph && 'paragraph'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $6e9163c6dd169139$export$24c1f8f60cbac79e), classes);
};
const $5ca16cb6e72a53f1$export$140e2f5526d3cad8 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiTypography',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.variant && styles[ownerState.variant],
            ownerState.align !== 'inherit' && styles[`align${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.noWrap && styles.noWrap,
            ownerState.gutterBottom && styles.gutterBottom,
            ownerState.paragraph && styles.paragraph
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        variants: [
            {
                props: {
                    variant: 'inherit'
                },
                style: {
                    // Some elements, like <button> on Chrome have default font that doesn't inherit, reset this.
                    font: 'inherit',
                    lineHeight: 'inherit',
                    letterSpacing: 'inherit'
                }
            },
            ...Object.entries(theme.typography).filter(([variant, value])=>variant !== 'inherit' && value && typeof value === 'object').map(([variant, value])=>({
                    props: {
                        variant: variant
                    },
                    style: value
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                })),
            ...Object.entries(theme.palette?.text || {}).filter(([, value])=>typeof value === 'string').map(([color])=>({
                    props: {
                        color: `text${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
                    },
                    style: {
                        color: (theme.vars || theme).palette.text[color]
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.align !== 'inherit',
                style: {
                    textAlign: 'var(--Typography-textAlign)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.noWrap,
                style: {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.gutterBottom,
                style: {
                    marginBottom: '0.35em'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.paragraph,
                style: {
                    marginBottom: 16
                }
            }
        ]
    })));
const $5ca16cb6e72a53f1$var$defaultVariantMapping = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    subtitle1: 'h6',
    subtitle2: 'h6',
    body1: 'p',
    body2: 'p',
    inherit: 'p'
};
const $5ca16cb6e72a53f1$var$Typography = /*#__PURE__*/ $acw62.forwardRef(function Typography(inProps, ref) {
    const { color: color, ...themeProps } = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTypography'
    });
    const isSxColor = !$5ca16cb6e72a53f1$var$v6Colors[color];
    // TODO: Remove `extendSxProp` in v7
    const props = $5ca16cb6e72a53f1$var$extendSxProp({
        ...themeProps,
        ...isSxColor && {
            color: color
        }
    });
    const { align: align = 'inherit', className: className, component: component, gutterBottom: gutterBottom = false, noWrap: noWrap = false, paragraph: paragraph = false, variant: variant = 'body1', variantMapping: variantMapping = $5ca16cb6e72a53f1$var$defaultVariantMapping, ...other } = props;
    const ownerState = {
        ...props,
        align: align,
        color: color,
        className: className,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant,
        variantMapping: variantMapping
    };
    const Component = component || (paragraph ? 'p' : variantMapping[variant] || $5ca16cb6e72a53f1$var$defaultVariantMapping[variant]) || 'span';
    const classes = $5ca16cb6e72a53f1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5ca16cb6e72a53f1$export$140e2f5526d3cad8, {
        as: Component,
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        style: {
            ...align !== 'inherit' && {
                '--Typography-textAlign': align
            },
            ...other.style
        }
    });
});
var $5ca16cb6e72a53f1$export$2e2bcd8739ae039 = $5ca16cb6e72a53f1$var$Typography;




function $884f3676036e9695$export$d6efab9620b78fec(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiLink', slot);
}
const $884f3676036e9695$var$linkClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiLink', [
    'root',
    'underlineNone',
    'underlineHover',
    'underlineAlways',
    'button',
    'focusVisible'
]);
var $884f3676036e9695$export$2e2bcd8739ae039 = $884f3676036e9695$var$linkClasses;




const $ad0717f3ca2b2499$var$getTextDecoration = ({ theme: theme, ownerState: ownerState })=>{
    const transformedColor = ownerState.color;
    if ('colorSpace' in theme && theme.colorSpace) {
        const color = (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.main`) || (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}`) || ownerState.color;
        return theme.alpha(color, 0.4);
    }
    // check the `main` color first for a custom palette, then fallback to the color itself
    const color = (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.main`, false) || (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}`, false) || ownerState.color;
    const channelColor = (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}.mainChannel`) || (0, $d50fcf9a3ec00b94$export$2aa3fd96c49a84a8)(theme, `palette.${transformedColor}Channel`);
    if ('vars' in theme && channelColor) return `rgba(${channelColor} / 0.4)`;
    return (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(color, 0.4);
};
var $ad0717f3ca2b2499$export$2e2bcd8739ae039 = $ad0717f3ca2b2499$var$getTextDecoration;



'use client';
const $b7fbb59cc24be7e9$var$v6Colors = {
    primary: true,
    secondary: true,
    error: true,
    info: true,
    success: true,
    warning: true,
    textPrimary: true,
    textSecondary: true,
    textDisabled: true
};
const $b7fbb59cc24be7e9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, component: component, focusVisible: focusVisible, underline: underline } = ownerState;
    const slots = {
        root: [
            'root',
            `underline${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(underline)}`,
            component === 'button' && 'button',
            focusVisible && 'focusVisible'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $884f3676036e9695$export$d6efab9620b78fec), classes);
};
const $b7fbb59cc24be7e9$var$LinkRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: 'MuiLink',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`underline${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.underline)}`],
            ownerState.component === 'button' && styles.button
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    return {
        variants: [
            {
                props: {
                    underline: 'none'
                },
                style: {
                    textDecoration: 'none'
                }
            },
            {
                props: {
                    underline: 'hover'
                },
                style: {
                    textDecoration: 'none',
                    '&:hover': {
                        textDecoration: 'underline'
                    }
                }
            },
            {
                props: {
                    underline: 'always'
                },
                style: {
                    textDecoration: 'underline',
                    '&:hover': {
                        textDecorationColor: 'inherit'
                    }
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color !== 'inherit',
                style: {
                    textDecorationColor: 'var(--Link-underlineColor)'
                }
            },
            {
                props: ({ underline: underline, ownerState: ownerState })=>underline === 'always' && ownerState.color === 'inherit',
                style: theme.colorSpace ? {
                    textDecorationColor: theme.alpha('currentColor', 0.4)
                } : null
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        underline: 'always',
                        color: color
                    },
                    style: {
                        '--Link-underlineColor': theme.alpha((theme.vars || theme).palette[color].main, 0.4)
                    }
                })),
            {
                props: {
                    underline: 'always',
                    color: 'textPrimary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textSecondary'
                },
                style: {
                    '--Link-underlineColor': theme.alpha((theme.vars || theme).palette.text.secondary, 0.4)
                }
            },
            {
                props: {
                    underline: 'always',
                    color: 'textDisabled'
                },
                style: {
                    '--Link-underlineColor': (theme.vars || theme).palette.text.disabled
                }
            },
            {
                props: {
                    component: 'button'
                },
                style: {
                    position: 'relative',
                    WebkitTapHighlightColor: 'transparent',
                    backgroundColor: 'transparent',
                    // Reset default value
                    // We disable the focus ring for mouse, touch and keyboard users.
                    outline: 0,
                    border: 0,
                    margin: 0,
                    // Remove the margin in Safari
                    borderRadius: 0,
                    padding: 0,
                    // Remove the padding in Firefox
                    cursor: 'pointer',
                    userSelect: 'none',
                    verticalAlign: 'middle',
                    MozAppearance: 'none',
                    // Reset
                    WebkitAppearance: 'none',
                    // Reset
                    '&::-moz-focus-inner': {
                        borderStyle: 'none' // Remove Firefox dotted outline.
                    },
                    [`&.${(0, $884f3676036e9695$export$2e2bcd8739ae039).focusVisible}`]: {
                        outline: 'auto'
                    }
                }
            }
        ]
    };
}));
const $b7fbb59cc24be7e9$var$Link = /*#__PURE__*/ $acw62.forwardRef(function Link(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiLink'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const { className: className, color: color = 'primary', component: component = 'a', onBlur: onBlur, onFocus: onFocus, TypographyClasses: TypographyClasses, underline: underline = 'always', variant: variant = 'inherit', sx: sx, ...other } = props;
    const [focusVisible, setFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $3abd7e3358fc5f35$export$2e2bcd8739ae039)(event.target)) setFocusVisible(false);
        if (onBlur) onBlur(event);
    };
    const handleFocus = (event)=>{
        if ((0, $3abd7e3358fc5f35$export$2e2bcd8739ae039)(event.target)) setFocusVisible(true);
        if (onFocus) onFocus(event);
    };
    const ownerState = {
        ...props,
        color: color,
        component: component,
        focusVisible: focusVisible,
        underline: underline,
        variant: variant
    };
    const classes = $b7fbb59cc24be7e9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b7fbb59cc24be7e9$var$LinkRoot, {
        color: color,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        classes: TypographyClasses,
        component: component,
        onBlur: handleBlur,
        onFocus: handleFocus,
        ref: ref,
        ownerState: ownerState,
        variant: variant,
        ...other,
        sx: [
            ...$b7fbb59cc24be7e9$var$v6Colors[color] === undefined ? [
                {
                    color: color
                }
            ] : [],
            ...Array.isArray(sx) ? sx : [
                sx
            ]
        ],
        style: {
            ...other.style,
            ...underline === 'always' && color !== 'inherit' && !$b7fbb59cc24be7e9$var$v6Colors[color] && {
                '--Link-underlineColor': (0, $ad0717f3ca2b2499$export$2e2bcd8739ae039)({
                    theme: theme,
                    ownerState: ownerState
                })
            }
        }
    });
});
var $b7fbb59cc24be7e9$export$2e2bcd8739ae039 = $b7fbb59cc24be7e9$var$Link;


parcelRequire("acw62");

parcelRequire("acw62");
const $8908c22edd89f492$var$ClickToClipboard = ({ className: className, children: children })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: className,
        onClick: ()=>navigator.clipboard.writeText(children),
        children: children
    });
};
var $8908c22edd89f492$export$2e2bcd8739ae039 = $8908c22edd89f492$var$ClickToClipboard;




var $f1q41 = parcelRequire("f1q41");

var $3EyMN = parcelRequire("3EyMN");


var $9YICB = parcelRequire("9YICB");


var $cyjZp = parcelRequire("cyjZp");



var $f1q41 = parcelRequire("f1q41");
function $2ae5027498da5e55$export$956310555b96755a(file) {
    return new Promise(function(resolve, reject) {
        const reader = new FileReader();
        reader.onerror = function onerror(ev) {
            reject(ev.target.error);
        };
        reader.onload = function onload(ev) {
            if ((0, $f1q41.isString)(ev.target.result)) return reject('Received string not buffer');
            resolve(ev.target.result);
        };
        reader.readAsArrayBuffer(file);
    });
}



const $fdaadf0aca83a870$export$136703b96b9b8f33 = {
    uploadDocument: $fdaadf0aca83a870$var$uploadDocument
};
function $fdaadf0aca83a870$var$getDocumentService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $df70feab7068291e$exports.DocumentServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
async function $fdaadf0aca83a870$export$9227a5af4422cb03(params) {
    const documentBuffer = await (0, $2ae5027498da5e55$export$956310555b96755a)(params.document);
    const documentPayload = new Uint8Array(documentBuffer);
    const request = new (0, $cyjZp.UploadVehicleDocumentRequest)();
    request.setVin(params.vin);
    request.setDocumentPayload(documentPayload);
    return request;
}
async function $fdaadf0aca83a870$var$uploadDocument(params) {
    const client = $fdaadf0aca83a870$var$getDocumentService();
    const request = await $fdaadf0aca83a870$export$9227a5af4422cb03(params);
    return client.uploadVehicleDocument(request);
}





var $aqwEO = parcelRequire("aqwEO");


function $a351150ce2eb3ddb$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$a351150ce2eb3ddb$export$2e2bcd8739ae039 = $a351150ce2eb3ddb$export$dd412b56f1e4d8aa;



function $8fcd3b0bf5df7635$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    if (isNaN(amount)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$8fcd3b0bf5df7635$export$2e2bcd8739ae039 = $8fcd3b0bf5df7635$export$17c93e242b2d3a22;


function $c5e772d389bae063$export$73d1c15a21f9fae5(date, amount, options) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, -amount, options);
}
var // Fallback for modularized imports:
$c5e772d389bae063$export$2e2bcd8739ae039 = $c5e772d389bae063$export$73d1c15a21f9fae5;


const $930f18d689e94983$export$7b639b94d0b7f4c4 = {
    getVehicles: $930f18d689e94983$var$getVehicles,
    addDocument: $930f18d689e94983$var$addDocument,
    updateStateToInProcess: $930f18d689e94983$var$updateStateToInProcess,
    updateStateToInListing: $930f18d689e94983$var$updateStateToInListing,
    updateStateToSold: $930f18d689e94983$var$updateStateToSold,
    updateStateToTotalLoss: $930f18d689e94983$var$updateStateToTotalLoss,
    getVehicleById: $930f18d689e94983$var$getVehicleById,
    getTelematics: $930f18d689e94983$var$getTelematics
};
function $930f18d689e94983$var$nexusClient() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $930f18d689e94983$export$2352b438417f54cb(params = {
    page: 0,
    customerId: '',
    criteriaList: [],
    resultsPerPage: 25,
    trimPropertiesList: [],
    listByStatus: false
}) {
    const request = new (0, $3EyMN.ListVehiclesRequest)();
    request.setPage(params.page);
    request.setResultsPerPage(params.resultsPerPage);
    (0, $f1q41.each)(params.criteriaList, (crit)=>{
        const criteria = new (0, $3EyMN.VehicleCriteria)();
        criteria.setProperty(crit.property);
        criteria.setQuery(crit.query);
        request.addCriteria(criteria);
    });
    return request;
}
async function $930f18d689e94983$var$getVehicles(params, programId) {
    const client = $930f18d689e94983$var$nexusClient();
    const request = $930f18d689e94983$export$2352b438417f54cb(params);
    request.setProgramIdsList([
        programId
    ]);
    return client.listVehicles(request).then((0, $45ee4ee0548ca22e$export$f14470e236d6ab6a)('Get Listing Vehicles')).then((res)=>{
        return res.toObject();
    });
}
async function $930f18d689e94983$var$getVehicleById(vehicleId) {
    const client = $930f18d689e94983$var$nexusClient();
    const request = new (0, $3EyMN.GetVehicleByIdRequest)();
    request.setId(vehicleId);
    return client.getVehicleById(request).then((res)=>res.toObject());
}
async function $930f18d689e94983$var$getTelematics(vehicleId) {
    const client = $930f18d689e94983$var$nexusClient();
    const request = new (0, $aqwEO.GetTelematicsRequest)();
    const nextDay = (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(new Date(), 1);
    const oneMonthAgo = (0, $c5e772d389bae063$export$73d1c15a21f9fae5)(new Date(), 1);
    const allParams = [
        {
            key: 'vehicle_id',
            value: vehicleId
        },
        {
            key: 'start_date',
            value: oneMonthAgo.toISOString()
        },
        {
            key: 'end_date',
            value: nextDay.toISOString()
        }
    ];
    const paramReq = allParams.map((param)=>{
        const newParamsReq = new (0, $aqwEO.Param)();
        newParamsReq.setKey(param.key);
        newParamsReq.setValue(param.value);
        return newParamsReq;
    });
    request.setVehicleIdsList([
        vehicleId
    ]);
    request.setParamsList(paramReq);
    return client.getTelematics(request).then((res)=>res.toObject()).catch((0, $45ee4ee0548ca22e$export$b35e4e49600c6304)('getTelematics')).catch(()=>{
        return {
            telematicsList: []
        };
    });
}
function $930f18d689e94983$export$606eb33411bf74d6({ meta: meta }) {
    const formData = new FormData();
    if (meta) (0, $f1q41.each)(meta, (val, key)=>{
        formData.append(key, val);
    });
    return formData;
}
async function $930f18d689e94983$var$addDocument({ vin: vin, document: document, kind: kind, vehicleId: vehicleId, meta: meta }) {
    return (0, $fdaadf0aca83a870$export$136703b96b9b8f33).uploadDocument({
        vin: vin,
        document: document
    }).then((res)=>{
        const body = $930f18d689e94983$export$606eb33411bf74d6({
            meta: meta
        });
        return fetch(`${(0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleetUpload}/fleet/upload/${res.getDocumentId()}/${kind}/${vehicleId}`, {
            method: 'POST',
            body: body
        }).then((res)=>res.json()).then((0, $45ee4ee0548ca22e$export$f14470e236d6ab6a)('Fetch file')).catch((err)=>{
            console.error(err);
        });
    });
}
function $930f18d689e94983$export$30f998d18360e2eb(isEligible) {
    if (isEligible) return (0, $9YICB.ActivityState).ELIGIBLE_FOR_FLEET;
    return (0, $9YICB.ActivityState).AGREED_SELLING_PRICE;
}
async function $930f18d689e94983$var$updateStateToInProcess(vehicleId) {
    const client = $930f18d689e94983$var$nexusClient();
    const request = new (0, $3EyMN.UpdateStateToInProcessRequest)();
    request.setVehicleId(vehicleId);
    return client.updateVehicleStateToInProcess(request);
}
async function $930f18d689e94983$var$updateStateToInListing(vehicleId) {
    const client = $930f18d689e94983$var$nexusClient();
    const request = new (0, $3EyMN.UpdateStateToInListingRequest)();
    request.setVehicleId(vehicleId);
    return client.updateVehicleStateToInListing(request);
}
async function $930f18d689e94983$var$updateStateToSold(vehicleId) {
    const client = $930f18d689e94983$var$nexusClient();
    const request = new (0, $3EyMN.UpdateStateToSoldRequest)();
    request.setVehicleId(vehicleId);
    return client.updateVehicleStateToSold(request);
}
async function $930f18d689e94983$var$updateStateToTotalLoss(vehicleId) {
    const client = $930f18d689e94983$var$nexusClient();
    const request = new (0, $3EyMN.UpdateStateToTotalLossRequest)();
    request.setVehicleId(vehicleId);
    return client.updateVehicleStateToTotalLoss(request);
}




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");







/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */ function $7a8a64e8a5211ee5$var$isHostComponent(element) {
    return typeof element === 'string';
}
var $7a8a64e8a5211ee5$export$2e2bcd8739ae039 = $7a8a64e8a5211ee5$var$isHostComponent;


/**
 * Type of the ownerState based on the type of an element it applies to.
 * This resolves to the provided OwnerState for React components and `undefined` for host components.
 * Falls back to `OwnerState | undefined` when the exact type can't be determined in development time.
 */ /**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node or undefined, `ownerState` is not applied.
 * @param otherProps Props of the element.
 * @param ownerState
 */ function $c20bfbd9e98e2eff$var$appendOwnerState(elementType, otherProps, ownerState) {
    if (elementType === undefined || (0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(elementType)) return otherProps;
    return {
        ...otherProps,
        ownerState: {
            ...otherProps.ownerState,
            ...ownerState
        }
    };
}
var $c20bfbd9e98e2eff$export$2e2bcd8739ae039 = $c20bfbd9e98e2eff$var$appendOwnerState;


/**
 * If `componentProps` is a function, calls it with the provided `ownerState`.
 * Otherwise, just returns `componentProps`.
 */ function $5f5557fdc8e8d8fa$var$resolveComponentProps(componentProps, ownerState, slotState) {
    if (typeof componentProps === 'function') return componentProps(ownerState, slotState);
    return componentProps;
}
var $5f5557fdc8e8d8fa$export$2e2bcd8739ae039 = $5f5557fdc8e8d8fa$var$resolveComponentProps;



/**
 * Extracts event handlers from a given object.
 * A prop is considered an event handler if it is a function and its name starts with `on`.
 *
 * @param object An object to extract event handlers from.
 * @param excludeKeys An array of keys to exclude from the returned object.
 */ function $afac4abdaa8d83ea$var$extractEventHandlers(object, excludeKeys = []) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>prop.match(/^on[A-Z]/) && typeof object[prop] === 'function' && !excludeKeys.includes(prop)).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $afac4abdaa8d83ea$export$2e2bcd8739ae039 = $afac4abdaa8d83ea$var$extractEventHandlers;


/**
 * Removes event handlers from the given object.
 * A field is considered an event handler if it is a function with a name beginning with `on`.
 *
 * @param object Object to remove event handlers from.
 * @returns Object with event handlers removed.
 */ function $3ebb326a10a78a15$var$omitEventHandlers(object) {
    if (object === undefined) return {};
    const result = {};
    Object.keys(object).filter((prop)=>!(prop.match(/^on[A-Z]/) && typeof object[prop] === 'function')).forEach((prop)=>{
        result[prop] = object[prop];
    });
    return result;
}
var $3ebb326a10a78a15$export$2e2bcd8739ae039 = $3ebb326a10a78a15$var$omitEventHandlers;


/**
 * Merges the slot component internal props (usually coming from a hook)
 * with the externally provided ones.
 *
 * The merge order is (the latter overrides the former):
 * 1. The internal props (specified as a getter function to work with get*Props hook result)
 * 2. Additional props (specified internally on a Base UI component)
 * 3. External props specified on the owner component. These should only be used on a root slot.
 * 4. External props specified in the `slotProps.*` prop.
 * 5. The `className` prop - combined from all the above.
 * @param parameters
 * @returns
 */ function $135391549c807611$var$mergeSlotProps(parameters) {
    const { getSlotProps: getSlotProps, additionalProps: additionalProps, externalSlotProps: externalSlotProps, externalForwardedProps: externalForwardedProps, className: className } = parameters;
    if (!getSlotProps) {
        // The simpler case - getSlotProps is not defined, so no internal event handlers are defined,
        // so we can simply merge all the props without having to worry about extracting event handlers.
        const joinedClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
        const mergedStyle = {
            ...additionalProps?.style,
            ...externalForwardedProps?.style,
            ...externalSlotProps?.style
        };
        const props = {
            ...additionalProps,
            ...externalForwardedProps,
            ...externalSlotProps
        };
        if (joinedClasses.length > 0) props.className = joinedClasses;
        if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
        return {
            props: props,
            internalRef: undefined
        };
    }
    // In this case, getSlotProps is responsible for calling the external event handlers.
    // We don't need to include them in the merged props because of this.
    const eventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)({
        ...externalForwardedProps,
        ...externalSlotProps
    });
    const componentsPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalSlotProps);
    const otherPropsWithoutEventHandlers = (0, $3ebb326a10a78a15$export$2e2bcd8739ae039)(externalForwardedProps);
    const internalSlotProps = getSlotProps(eventHandlers);
    // The order of classes is important here.
    // Emotion (that we use in libraries consuming Base UI) depends on this order
    // to properly override style. It requires the most important classes to be last
    // (see https://github.com/mui/material-ui/pull/33205) for the related discussion.
    const joinedClasses = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(internalSlotProps?.className, additionalProps?.className, className, externalForwardedProps?.className, externalSlotProps?.className);
    const mergedStyle = {
        ...internalSlotProps?.style,
        ...additionalProps?.style,
        ...externalForwardedProps?.style,
        ...externalSlotProps?.style
    };
    const props = {
        ...internalSlotProps,
        ...additionalProps,
        ...otherPropsWithoutEventHandlers,
        ...componentsPropsWithoutEventHandlers
    };
    if (joinedClasses.length > 0) props.className = joinedClasses;
    if (Object.keys(mergedStyle).length > 0) props.style = mergedStyle;
    return {
        props: props,
        internalRef: internalSlotProps.ref
    };
}
var $135391549c807611$export$2e2bcd8739ae039 = $135391549c807611$var$mergeSlotProps;


'use client';
function $25e19e282016bf82$export$2e2bcd8739ae039(/**
 * The slot's name. All Material UI components should have `root` slot.
 *
 * If the name is `root`, the logic behaves differently from other slots,
 * e.g. the `externalForwardedProps` are spread to `root` slot but not other slots.
 */ name, parameters) {
    const { className: className, elementType: initialElementType, ownerState: ownerState, externalForwardedProps: externalForwardedProps, internalForwardedProps: internalForwardedProps, shouldForwardComponentProp: shouldForwardComponentProp = false, ...useSlotPropsParams } = parameters;
    const { component: rootComponent, slots: slots = {
        [name]: undefined
    }, slotProps: slotProps = {
        [name]: undefined
    }, ...other } = externalForwardedProps;
    const elementType = slots[name] || initialElementType;
    // `slotProps[name]` can be a callback that receives the component's ownerState.
    // `resolvedComponentsProps` is always a plain object.
    const resolvedComponentsProps = (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(slotProps[name], ownerState);
    const { props: { component: slotComponent, ...mergedProps }, internalRef: internalRef } = (0, $135391549c807611$export$2e2bcd8739ae039)({
        className: className,
        ...useSlotPropsParams,
        externalForwardedProps: name === 'root' ? other : undefined,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.ref);
    const LeafComponent = name === 'root' ? slotComponent || rootComponent : slotComponent;
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, {
        ...name === 'root' && !rootComponent && !slots[name] && internalForwardedProps,
        ...name !== 'root' && !slots[name] && internalForwardedProps,
        ...mergedProps,
        ...LeafComponent && !shouldForwardComponentProp && {
            as: LeafComponent
        },
        ...LeafComponent && shouldForwardComponentProp && {
            component: LeafComponent
        },
        ref: ref
    }, ownerState);
    return [
        elementType,
        props
    ];
}





var $acw62 = parcelRequire("acw62");












function $5ce2784ff2666cf4$export$29cdb466b9b6f20b(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPaper', slot);
}
const $5ce2784ff2666cf4$var$paperClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPaper', [
    'root',
    'rounded',
    'outlined',
    'elevation',
    'elevation0',
    'elevation1',
    'elevation2',
    'elevation3',
    'elevation4',
    'elevation5',
    'elevation6',
    'elevation7',
    'elevation8',
    'elevation9',
    'elevation10',
    'elevation11',
    'elevation12',
    'elevation13',
    'elevation14',
    'elevation15',
    'elevation16',
    'elevation17',
    'elevation18',
    'elevation19',
    'elevation20',
    'elevation21',
    'elevation22',
    'elevation23',
    'elevation24'
]);
var $5ce2784ff2666cf4$export$2e2bcd8739ae039 = $5ce2784ff2666cf4$var$paperClasses;



'use client';
const $bca3355350079f94$var$useUtilityClasses = (ownerState)=>{
    const { square: square, elevation: elevation, variant: variant, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            !square && 'rounded',
            variant === 'elevation' && `elevation${elevation}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $5ce2784ff2666cf4$export$29cdb466b9b6f20b), classes);
};
const $bca3355350079f94$var$PaperRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPaper',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            !ownerState.square && styles.rounded,
            ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        color: (theme.vars || theme).palette.text.primary,
        transition: theme.transitions.create('box-shadow'),
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.square,
                style: {
                    borderRadius: theme.shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    border: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: {
                    variant: 'elevation'
                },
                style: {
                    boxShadow: 'var(--Paper-shadow)',
                    backgroundImage: 'var(--Paper-overlay)'
                }
            }
        ]
    })));
const $bca3355350079f94$var$Paper = /*#__PURE__*/ $acw62.forwardRef(function Paper(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPaper'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const { className: className, component: component = 'div', elevation: elevation = 1, square: square = false, variant: variant = 'elevation', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        elevation: elevation,
        square: square,
        variant: variant
    };
    const classes = $bca3355350079f94$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bca3355350079f94$var$PaperRoot, {
        as: component,
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        style: {
            ...variant === 'elevation' && {
                '--Paper-shadow': (theme.vars || theme).shadows[elevation],
                ...theme.vars && {
                    '--Paper-overlay': theme.vars.overlays?.[elevation]
                },
                ...!theme.vars && theme.palette.mode === 'dark' && {
                    '--Paper-overlay': `linear-gradient(${(0, $7ebe803ced17df29$export$58f0f39f63f3cf42)('#fff', (0, $399a169bab06dc0f$export$2e2bcd8739ae039)(elevation))}, ${(0, $7ebe803ced17df29$export$58f0f39f63f3cf42)('#fff', (0, $399a169bab06dc0f$export$2e2bcd8739ae039)(elevation))})`
                }
            },
            ...other.style
        }
    });
});
var $bca3355350079f94$export$2e2bcd8739ae039 = $bca3355350079f94$var$Paper;




function $2cd2c63af2aa1e89$export$69aecd24bc2cf7e3(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiAlert', slot);
}
const $2cd2c63af2aa1e89$var$alertClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiAlert', [
    'root',
    'action',
    'icon',
    'message',
    'filled',
    'colorSuccess',
    'colorInfo',
    'colorWarning',
    'colorError',
    'filledSuccess',
    'filledInfo',
    'filledWarning',
    'filledError',
    'outlined',
    'outlinedSuccess',
    'outlinedInfo',
    'outlinedWarning',
    'outlinedError',
    'standard',
    'standardSuccess',
    'standardInfo',
    'standardWarning',
    'standardError'
]);
var $2cd2c63af2aa1e89$export$2e2bcd8739ae039 = $2cd2c63af2aa1e89$var$alertClasses;



parcelRequire("acw62");


'use client';
var $4fe9ab3ffea456b8$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');


parcelRequire("acw62");


'use client';
var $caf1eafd8571d91c$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');


parcelRequire("acw62");


'use client';
var $72c6d34894446252$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');


parcelRequire("acw62");


'use client';
var $7dcb7ddf91c6cf94$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');


parcelRequire("acw62");


'use client';
var $7880a6389ac08655$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');



'use client';
const $11072e450c597f96$var$useUtilityClasses = (ownerState)=>{
    const { variant: variant, color: color, severity: severity, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color || severity)}`,
            `${variant}`
        ],
        icon: [
            'icon'
        ],
        message: [
            'message'
        ],
        action: [
            'action'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $2cd2c63af2aa1e89$export$69aecd24bc2cf7e3), classes);
};
const $11072e450c597f96$var$AlertRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiAlert',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`${ownerState.variant}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color || ownerState.severity)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const getColor = theme.palette.mode === 'light' ? theme.darken : theme.lighten;
    const getBackgroundColor = theme.palette.mode === 'light' ? theme.lighten : theme.darken;
    return {
        ...theme.typography.body2,
        backgroundColor: 'transparent',
        display: 'flex',
        padding: '6px 16px',
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'standard'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        backgroundColor: theme.vars ? theme.vars.palette.Alert[`${color}StandardBg`] : getBackgroundColor(theme.palette[color].light, 0.9),
                        [`& .${(0, $2cd2c63af2aa1e89$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'light'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'outlined'
                    },
                    style: {
                        color: theme.vars ? theme.vars.palette.Alert[`${color}Color`] : getColor(theme.palette[color].light, 0.6),
                        border: `1px solid ${(theme.vars || theme).palette[color].light}`,
                        [`& .${(0, $2cd2c63af2aa1e89$export$2e2bcd8739ae039).icon}`]: theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}IconColor`]
                        } : {
                            color: theme.palette[color].main
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        colorSeverity: color,
                        variant: 'filled'
                    },
                    style: {
                        fontWeight: theme.typography.fontWeightMedium,
                        ...theme.vars ? {
                            color: theme.vars.palette.Alert[`${color}FilledColor`],
                            backgroundColor: theme.vars.palette.Alert[`${color}FilledBg`]
                        } : {
                            backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main,
                            color: theme.palette.getContrastText(theme.palette[color].main)
                        }
                    }
                }))
        ]
    };
}));
const $11072e450c597f96$var$AlertIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Icon'
})({
    marginRight: 12,
    padding: '7px 0',
    display: 'flex',
    fontSize: 22,
    opacity: 0.9
});
const $11072e450c597f96$var$AlertMessage = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Message'
})({
    padding: '8px 0',
    minWidth: 0,
    overflow: 'auto'
});
const $11072e450c597f96$var$AlertAction = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAlert',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'flex-start',
    padding: '4px 0 0 16px',
    marginLeft: 'auto',
    marginRight: -8
});
const $11072e450c597f96$var$defaultIconMapping = {
    success: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4fe9ab3ffea456b8$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    warning: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $caf1eafd8571d91c$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    error: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $72c6d34894446252$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    }),
    info: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7dcb7ddf91c6cf94$export$2e2bcd8739ae039), {
        fontSize: "inherit"
    })
};
const $11072e450c597f96$var$Alert = /*#__PURE__*/ $acw62.forwardRef(function Alert(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAlert'
    });
    const { action: action, children: children, className: className, closeText: closeText = 'Close', color: color, components: components = {}, componentsProps: componentsProps = {}, icon: icon, iconMapping: iconMapping = $11072e450c597f96$var$defaultIconMapping, onClose: onClose, role: role = 'alert', severity: severity = 'success', slotProps: slotProps = {}, slots: slots = {}, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        severity: severity,
        variant: variant,
        colorSeverity: color || severity
    };
    const classes = $11072e450c597f96$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            closeButton: components.CloseButton,
            closeIcon: components.CloseIcon,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $11072e450c597f96$var$AlertRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            role: role,
            elevation: 0
        }
    });
    const [IconSlot, iconSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('icon', {
        className: classes.icon,
        elementType: $11072e450c597f96$var$AlertIcon,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MessageSlot, messageSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('message', {
        className: classes.message,
        elementType: $11072e450c597f96$var$AlertMessage,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('action', {
        className: classes.action,
        elementType: $11072e450c597f96$var$AlertAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseButtonSlot, closeButtonProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('closeButton', {
        elementType: (0, $05a469b554e6dcda$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [CloseIconSlot, closeIconProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('closeIcon', {
        elementType: (0, $7880a6389ac08655$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            icon !== false ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IconSlot, {
                ...iconSlotProps,
                children: icon || iconMapping[severity] || $11072e450c597f96$var$defaultIconMapping[severity]
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(MessageSlot, {
                ...messageSlotProps,
                children: children
            }),
            action != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            }) : null,
            action == null && onClose ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(CloseButtonSlot, {
                    size: "small",
                    "aria-label": closeText,
                    title: closeText,
                    color: "inherit",
                    onClick: onClose,
                    ...closeButtonProps,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(CloseIconSlot, {
                        fontSize: "small",
                        ...closeIconProps
                    })
                })
            }) : null
        ]
    });
});
var $11072e450c597f96$export$2e2bcd8739ae039 = $11072e450c597f96$var$Alert;


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



'use client';
function $849c73cb8392403d$var$useSnackbar(parameters = {}) {
    const { autoHideDuration: autoHideDuration = null, disableWindowBlurListener: disableWindowBlurListener = false, onClose: onClose, open: open, resumeHideDuration: resumeHideDuration } = parameters;
    const timerAutoHide = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (!nativeEvent.defaultPrevented) {
                if (nativeEvent.key === 'Escape') // not calling `preventDefault` since we don't know if people may ignore this event e.g. a permanently open snackbar
                onClose?.(nativeEvent, 'escapeKeyDown');
            }
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        open,
        onClose
    ]);
    const handleClose = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, reason)=>{
        onClose?.(event, reason);
    });
    const setAutoHideTimer = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((autoHideDurationParam)=>{
        if (!onClose || autoHideDurationParam == null) return;
        timerAutoHide.start(autoHideDurationParam, ()=>{
            handleClose(null, 'timeout');
        });
    });
    $acw62.useEffect(()=>{
        if (open) setAutoHideTimer(autoHideDuration);
        return timerAutoHide.clear;
    }, [
        open,
        autoHideDuration,
        setAutoHideTimer,
        timerAutoHide
    ]);
    const handleClickAway = (event)=>{
        onClose?.(event, 'clickaway');
    };
    // Pause the timer when the user is interacting with the Snackbar
    // or when the user hide the window.
    const handlePause = timerAutoHide.clear;
    // Restart the timer when the user is no longer interacting with the Snackbar
    // or when the window is shown back.
    const handleResume = $acw62.useCallback(()=>{
        if (autoHideDuration != null) setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
    }, [
        autoHideDuration,
        resumeHideDuration,
        setAutoHideTimer
    ]);
    const createHandleBlur = (otherHandlers)=>(event)=>{
            const onBlurCallback = otherHandlers.onBlur;
            onBlurCallback?.(event);
            handleResume();
        };
    const createHandleFocus = (otherHandlers)=>(event)=>{
            const onFocusCallback = otherHandlers.onFocus;
            onFocusCallback?.(event);
            handlePause();
        };
    const createMouseEnter = (otherHandlers)=>(event)=>{
            const onMouseEnterCallback = otherHandlers.onMouseEnter;
            onMouseEnterCallback?.(event);
            handlePause();
        };
    const createMouseLeave = (otherHandlers)=>(event)=>{
            const onMouseLeaveCallback = otherHandlers.onMouseLeave;
            onMouseLeaveCallback?.(event);
            handleResume();
        };
    $acw62.useEffect(()=>{
        // TODO: window global should be refactored here
        if (!disableWindowBlurListener && open) {
            window.addEventListener('focus', handleResume);
            window.addEventListener('blur', handlePause);
            return ()=>{
                window.removeEventListener('focus', handleResume);
                window.removeEventListener('blur', handlePause);
            };
        }
        return undefined;
    }, [
        disableWindowBlurListener,
        open,
        handleResume,
        handlePause
    ]);
    const getRootProps = (externalProps = {})=>{
        const externalEventHandlers = {
            ...(0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters),
            ...(0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(externalProps)
        };
        return {
            // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
            // See https://github.com/mui/material-ui/issues/29080
            role: 'presentation',
            ...externalProps,
            ...externalEventHandlers,
            onBlur: createHandleBlur(externalEventHandlers),
            onFocus: createHandleFocus(externalEventHandlers),
            onMouseEnter: createMouseEnter(externalEventHandlers),
            onMouseLeave: createMouseLeave(externalEventHandlers)
        };
    };
    return {
        getRootProps: getRootProps,
        onClickAway: handleClickAway
    };
}
var $849c73cb8392403d$export$2e2bcd8739ae039 = $849c73cb8392403d$var$useSnackbar;



var $acw62 = parcelRequire("acw62");

function $4c8156a231c9130b$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}







var $acw62 = parcelRequire("acw62");
function $1d88113360503233$export$2e2bcd8739ae039(element) {
    // 'ref' is passed as prop in React 19, whereas 'ref' is directly attached to children in older versions
    if (parseInt($acw62.version, 10) >= 19) return element?.props?.ref || null;
    // @ts-expect-error element.ref is not included in the ReactElement type
    // https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/70189
    return element?.ref || null;
}


'use client';
// TODO: return `EventHandlerName extends `on${infer EventName}` ? Lowercase<EventName> : never` once generatePropTypes runs with TS 4.1
function $21498506e622538e$var$mapEventPropToEvent(eventProp) {
    return eventProp.substring(2).toLowerCase();
}
function $21498506e622538e$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click-Away Listener](https://mui.com/material-ui/react-click-away-listener/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/material-ui/api/click-away-listener/)
 */ function $21498506e622538e$export$58385c17fee43f89(props) {
    const { children: children, disableReactTree: disableReactTree = false, mouseEvent: mouseEvent = 'onClick', onClickAway: onClickAway, touchEvent: touchEvent = 'onTouchEnd' } = props;
    const movedRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        // Ensure that this component is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        setTimeout(()=>{
            activatedRef.current = true;
        }, 0);
        return ()=>{
            activatedRef.current = false;
        };
    }, []);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), nodeRef);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!activatedRef.current || !nodeRef.current || 'clientX' in event && $21498506e622538e$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().includes(nodeRef.current);
        else insideDOM = !doc.documentElement.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target) || nodeRef.current.contains(// @ts-expect-error returns `false` as intended when not dispatched from a Node
        event.target);
        if (!insideDOM && (disableReactTree || !insideReactTree)) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const createHandleSynthetic = (handlerName)=>(event)=>{
            syntheticEventRef.current = true;
            const childrenPropsHandler = children.props[handlerName];
            if (childrenPropsHandler) childrenPropsHandler(event);
        };
    const childrenProps = {
        ref: handleRef
    };
    if (touchEvent !== false) childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
    $acw62.useEffect(()=>{
        if (touchEvent !== false) {
            const mappedTouchEvent = $21498506e622538e$var$mapEventPropToEvent(touchEvent);
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener(mappedTouchEvent, handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener(mappedTouchEvent, handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        touchEvent
    ]);
    if (mouseEvent !== false) childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
    $acw62.useEffect(()=>{
        if (mouseEvent !== false) {
            const mappedMouseEvent = $21498506e622538e$var$mapEventPropToEvent(mouseEvent);
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener(mappedMouseEvent, handleClickAway);
            return ()=>{
                doc.removeEventListener(mappedMouseEvent, handleClickAway);
            };
        }
        return undefined;
    }, [
        handleClickAway,
        mouseEvent
    ]);
    return /*#__PURE__*/ $acw62.cloneElement(children, childrenProps);
}







var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
var $9fc60dfb9203246b$export$2e2bcd8739ae039 = {
    disabled: false
};




var $37faf39349e00e45$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $0fef977f04119bf5$export$bb38bb9a1161268 = 'unmounted';
var $0fef977f04119bf5$export$84cbff306f539230 = 'exited';
var $0fef977f04119bf5$export$df38205c966be359 = 'entering';
var $0fef977f04119bf5$export$78e9e6e3e014d60a = 'entered';
var $0fef977f04119bf5$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $0fef977f04119bf5$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
                _this.appearStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else initialStatus = $0fef977f04119bf5$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $0fef977f04119bf5$export$bb38bb9a1161268;
        else initialStatus = $0fef977f04119bf5$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $0fef977f04119bf5$export$bb38bb9a1161268) return {
            status: $0fef977f04119bf5$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $0fef977f04119bf5$export$df38205c966be359 && status !== $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$df38205c966be359;
            } else if (status === $0fef977f04119bf5$export$df38205c966be359 || status === $0fef977f04119bf5$export$78e9e6e3e014d60a) nextStatus = $0fef977f04119bf5$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $0fef977f04119bf5$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $0fef977f04119bf5$export$84cbff306f539230) this.setState({
            status: $0fef977f04119bf5$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $0fef977f04119bf5$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $0fef977f04119bf5$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $9fc60dfb9203246b$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $0fef977f04119bf5$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $0fef977f04119bf5$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $0fef977f04119bf5$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($1u0KT))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $0fef977f04119bf5$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $4c26e32a51d8c622$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$0fef977f04119bf5$var$Transition.contextType = (0, $4c26e32a51d8c622$export$2e2bcd8739ae039);
$0fef977f04119bf5$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $0fef977f04119bf5$var$noop() {}
$0fef977f04119bf5$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $0fef977f04119bf5$var$noop,
    onEntering: $0fef977f04119bf5$var$noop,
    onEntered: $0fef977f04119bf5$var$noop,
    onExit: $0fef977f04119bf5$var$noop,
    onExiting: $0fef977f04119bf5$var$noop,
    onExited: $0fef977f04119bf5$var$noop
};
$0fef977f04119bf5$var$Transition.UNMOUNTED = $0fef977f04119bf5$export$bb38bb9a1161268;
$0fef977f04119bf5$var$Transition.EXITED = $0fef977f04119bf5$export$84cbff306f539230;
$0fef977f04119bf5$var$Transition.ENTERING = $0fef977f04119bf5$export$df38205c966be359;
$0fef977f04119bf5$var$Transition.ENTERED = $0fef977f04119bf5$export$78e9e6e3e014d60a;
$0fef977f04119bf5$var$Transition.EXITING = $0fef977f04119bf5$export$4aacc83d4d59139f;
var $0fef977f04119bf5$export$2e2bcd8739ae039 = $0fef977f04119bf5$var$Transition;



const $09228c405c75d141$export$b7a864e1eaef9de5 = (node)=>node.scrollTop;
function $09228c405c75d141$export$8cb1e9b404609ae9(props, options) {
    const { timeout: timeout, easing: easing, style: style = {} } = props;
    return {
        duration: style.transitionDuration ?? (typeof timeout === 'number' ? timeout : timeout[options.mode] || 0),
        easing: style.transitionTimingFunction ?? (typeof easing === 'object' ? easing[options.mode] : easing),
        delay: style.transitionDelay
    };
}




'use client';
function $5a8449c70e836e71$var$getScale(value) {
    return `scale(${value}, ${value ** 2})`;
}
const $5a8449c70e836e71$var$styles = {
    entering: {
        opacity: 1,
        transform: $5a8449c70e836e71$var$getScale(1)
    },
    entered: {
        opacity: 1,
        transform: 'none'
    }
};
/*
 TODO v6: remove
 Conditionally apply a workaround for the CSS transition bug in Safari 15.4 / WebKit browsers.
 */ const $5a8449c70e836e71$var$isWebKit154 = typeof navigator !== 'undefined' && /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) && /(os |version\/)15(.|_)4/i.test(navigator.userAgent);
/**
 * The Grow transition is used by the [Tooltip](/material-ui/react-tooltip/) and
 * [Popover](/material-ui/react-popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $5a8449c70e836e71$var$Grow = /*#__PURE__*/ $acw62.forwardRef(function Grow(props, ref) {
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = 'auto', TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039), ...other } = props;
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const autoTimeout = $acw62.useRef();
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $09228c405c75d141$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $5a8449c70e836e71$var$isWebKit154 ? duration : duration * 0.666,
                delay: delay,
                easing: transitionTimingFunction
            })
        ].join(',');
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const { duration: transitionDuration, delay: delay, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        let duration;
        if (timeout === 'auto') {
            duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
            autoTimeout.current = duration;
        } else duration = transitionDuration;
        node.style.transition = [
            theme.transitions.create('opacity', {
                duration: duration,
                delay: delay
            }),
            theme.transitions.create('transform', {
                duration: $5a8449c70e836e71$var$isWebKit154 ? duration : duration * 0.666,
                delay: $5a8449c70e836e71$var$isWebKit154 ? delay : delay || duration * 0.333,
                easing: transitionTimingFunction
            })
        ].join(',');
        node.style.opacity = 0;
        node.style.transform = $5a8449c70e836e71$var$getScale(0.75);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTimeout.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: nodeRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    transform: $5a8449c70e836e71$var$getScale(0.75),
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$5a8449c70e836e71$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
if ($5a8449c70e836e71$var$Grow) $5a8449c70e836e71$var$Grow.muiSupportAuto = true;
var $5a8449c70e836e71$export$2e2bcd8739ae039 = $5a8449c70e836e71$var$Grow;



var $acw62 = parcelRequire("acw62");










function $96f7b4ca6350aea0$export$def81488db1a3216(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiSnackbarContent', slot);
}
const $96f7b4ca6350aea0$var$snackbarContentClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiSnackbarContent', [
    'root',
    'message',
    'action'
]);
var $96f7b4ca6350aea0$export$2e2bcd8739ae039 = $96f7b4ca6350aea0$var$snackbarContentClasses;



'use client';
const $c10f30b5937de473$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        action: [
            'action'
        ],
        message: [
            'message'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $96f7b4ca6350aea0$export$def81488db1a3216), classes);
};
const $c10f30b5937de473$var$SnackbarContentRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiSnackbarContent',
    slot: 'Root'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const emphasis = theme.palette.mode === 'light' ? 0.8 : 0.98;
    return {
        ...theme.typography.body2,
        color: theme.vars ? theme.vars.palette.SnackbarContent.color : theme.palette.getContrastText((0, $7ebe803ced17df29$export$e665714f76e581fd)(theme.palette.background.default, emphasis)),
        backgroundColor: theme.vars ? theme.vars.palette.SnackbarContent.bg : (0, $7ebe803ced17df29$export$e665714f76e581fd)(theme.palette.background.default, emphasis),
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        padding: '6px 16px',
        flexGrow: 1,
        [theme.breakpoints.up('sm')]: {
            flexGrow: 'initial',
            minWidth: 288
        }
    };
}));
const $c10f30b5937de473$var$SnackbarContentMessage = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Message'
})({
    padding: '8px 0'
});
const $c10f30b5937de473$var$SnackbarContentAction = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbarContent',
    slot: 'Action'
})({
    display: 'flex',
    alignItems: 'center',
    marginLeft: 'auto',
    paddingLeft: 16,
    marginRight: -8
});
const $c10f30b5937de473$var$SnackbarContent = /*#__PURE__*/ $acw62.forwardRef(function SnackbarContent(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSnackbarContent'
    });
    const { action: action, className: className, message: message, role: role = 'alert', ...other } = props;
    const ownerState = props;
    const classes = $c10f30b5937de473$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c10f30b5937de473$var$SnackbarContentRoot, {
        role: role,
        elevation: 6,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c10f30b5937de473$var$SnackbarContentMessage, {
                className: classes.message,
                ownerState: ownerState,
                children: message
            }),
            action ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c10f30b5937de473$var$SnackbarContentAction, {
                className: classes.action,
                ownerState: ownerState,
                children: action
            }) : null
        ]
    });
});
var $c10f30b5937de473$export$2e2bcd8739ae039 = $c10f30b5937de473$var$SnackbarContent;




function $8da2e7a3a807d031$export$6cb096457f5926f4(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiSnackbar', slot);
}
const $8da2e7a3a807d031$var$snackbarClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiSnackbar', [
    'root',
    'anchorOriginTopCenter',
    'anchorOriginBottomCenter',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft'
]);
var $8da2e7a3a807d031$export$2e2bcd8739ae039 = $8da2e7a3a807d031$var$snackbarClasses;




'use client';
const $7323af1cd599e3bc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchorOrigin: anchorOrigin } = ownerState;
    const slots = {
        root: [
            'root',
            `anchorOrigin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $8da2e7a3a807d031$export$6cb096457f5926f4), classes);
};
const $7323af1cd599e3bc$var$SnackbarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiSnackbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`anchorOrigin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.snackbar,
        position: 'fixed',
        display: 'flex',
        left: 8,
        right: 8,
        justifyContent: 'center',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top',
                style: {
                    top: 8,
                    [theme.breakpoints.up('sm')]: {
                        top: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical !== 'top',
                style: {
                    bottom: 8,
                    [theme.breakpoints.up('sm')]: {
                        bottom: 24
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'left',
                style: {
                    justifyContent: 'flex-start',
                    [theme.breakpoints.up('sm')]: {
                        left: 24,
                        right: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'right',
                style: {
                    justifyContent: 'flex-end',
                    [theme.breakpoints.up('sm')]: {
                        right: 24,
                        left: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.horizontal === 'center',
                style: {
                    [theme.breakpoints.up('sm')]: {
                        left: '50%',
                        right: 'auto',
                        transform: 'translateX(-50%)'
                    }
                }
            }
        ]
    })));
const $7323af1cd599e3bc$var$Snackbar = /*#__PURE__*/ $acw62.forwardRef(function Snackbar(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSnackbar'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { action: action, anchorOrigin: { vertical: vertical, horizontal: horizontal } = {
        vertical: 'bottom',
        horizontal: 'left'
    }, autoHideDuration: autoHideDuration = null, children: children, className: className, ClickAwayListenerProps: ClickAwayListenerPropsProp, ContentProps: ContentPropsProp, disableWindowBlurListener: disableWindowBlurListener = false, message: message, onBlur: onBlur, onClose: onClose, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, open: open, resumeHideDuration: resumeHideDuration, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: { onEnter: onEnter, onExited: onExited, ...TransitionPropsProp } = {}, ...other } = props;
    const ownerState = {
        ...props,
        anchorOrigin: {
            vertical: vertical,
            horizontal: horizontal
        },
        autoHideDuration: autoHideDuration,
        disableWindowBlurListener: disableWindowBlurListener,
        TransitionComponent: TransitionComponentProp,
        transitionDuration: transitionDuration
    };
    const classes = $7323af1cd599e3bc$var$useUtilityClasses(ownerState);
    const { getRootProps: getRootProps, onClickAway: onClickAway } = (0, $849c73cb8392403d$export$2e2bcd8739ae039)({
        ...ownerState
    });
    const [exited, setExited] = $acw62.useState(true);
    const handleExited = (node)=>{
        setExited(true);
        if (onExited) onExited(node);
    };
    const handleEnter = (node, isAppearing)=>{
        setExited(false);
        if (onEnter) onEnter(node, isAppearing);
    };
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponentProp,
            ...slots
        },
        slotProps: {
            content: ContentPropsProp,
            clickAwayListener: ClickAwayListenerPropsProp,
            transition: TransitionPropsProp,
            ...slotProps
        }
    };
    const [Root, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: [
            classes.root,
            className
        ],
        elementType: $7323af1cd599e3bc$var$SnackbarRoot,
        getSlotProps: getRootProps,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState
    });
    const [ClickAwaySlot, { ownerState: clickAwayOwnerStateProp, ...clickAwayListenerProps }] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('clickAwayListener', {
        elementType: (0, $21498506e622538e$export$58385c17fee43f89),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onClickAway: (...params)=>{
                    const event = params[0];
                    handlers.onClickAway?.(...params);
                    if (event?.defaultMuiPrevented) return;
                    onClickAway(...params);
                }
            }),
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('content', {
        elementType: (0, $c10f30b5937de473$export$2e2bcd8739ae039),
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            message: message,
            action: action
        },
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $5a8449c70e836e71$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                onEnter: (...params)=>{
                    handlers.onEnter?.(...params);
                    handleEnter(...params);
                },
                onExited: (...params)=>{
                    handlers.onExited?.(...params);
                    handleExited(...params);
                }
            }),
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            direction: vertical === 'top' ? 'down' : 'up'
        },
        ownerState: ownerState
    });
    // So we only render active snackbars.
    if (!open && exited) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ClickAwaySlot, {
        ...clickAwayListenerProps,
        ...slots.clickAwayListener && {
            ownerState: clickAwayOwnerStateProp
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Root, {
            ...rootProps,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionSlot, {
                ...transitionProps,
                children: children || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ContentSlot, {
                    ...contentSlotProps
                })
            })
        })
    });
});
var $7323af1cd599e3bc$export$2e2bcd8739ae039 = $7323af1cd599e3bc$var$Snackbar;


class $9a01a3d7e8de91c6$export$80f1826369a4ab15 {
    message;
    color;
    autoHideDuration;
    open;
    anchorVertical;
    anchorHorizontal;
    constructor(data){
        this.message = data.message || '';
        this.color = data.color || 'info';
        this.autoHideDuration = data.autoHideDuration || 3000;
        this.open = data.open;
        this.anchorVertical = data.anchorVertical || 'bottom';
        this.anchorHorizontal = data.anchorHorizontal || 'right';
    }
}
const $9a01a3d7e8de91c6$export$216a88342db54c29 = /*#__PURE__*/ (0, $acw62.createContext)({
    snack: new $9a01a3d7e8de91c6$export$80f1826369a4ab15({
        open: false
    }),
    setSnack: ()=>undefined
});
const $9a01a3d7e8de91c6$export$fadc71ba47daf7b1 = ({ children: children })=>{
    const [snack, setSnack] = (0, $acw62.useState)(new $9a01a3d7e8de91c6$export$80f1826369a4ab15({
        open: false
    }));
    const handleClose = (event, reason)=>{
        if (reason === 'clickaway') return;
        setSnack(new $9a01a3d7e8de91c6$export$80f1826369a4ab15({
            color: snack.color,
            open: false
        }));
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($9a01a3d7e8de91c6$export$216a88342db54c29.Provider, {
        value: {
            snack: snack,
            setSnack: setSnack
        },
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7323af1cd599e3bc$export$2e2bcd8739ae039), {
                open: snack.open,
                autoHideDuration: snack.autoHideDuration,
                anchorOrigin: {
                    vertical: snack.anchorVertical,
                    horizontal: snack.anchorHorizontal
                },
                onClose: handleClose,
                style: {
                    position: 'fixed',
                    zIndex: 5500,
                    display: 'flex',
                    bottom: '16px',
                    left: '16px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                    severity: snack.color,
                    children: snack.message || ''
                })
            })
        ]
    });
};


function $72ce74282d291ac0$export$a6701c3d6388e341({ vehicle: vehicle }) {
    const { setSnack: setSnack } = (0, $acw62.useContext)((0, $9a01a3d7e8de91c6$export$216a88342db54c29));
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const [odometer, setOdometer] = (0, $acw62.useState)('N/A');
    const [accountNumber, setAccountNumber] = (0, $acw62.useState)('N/A');
    const onSuccessVehicleStateUpdate = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                'getVehicle',
                vehicle.id
            ]
        });
        setSnack(new (0, $9a01a3d7e8de91c6$export$80f1826369a4ab15)({
            message: 'Successfully changed vehicle state',
            color: 'success',
            open: true
        }));
    };
    const onErrorVehicleStateUpdate = (error)=>{
        setSnack(new (0, $9a01a3d7e8de91c6$export$80f1826369a4ab15)({
            message: `Error changing vehicle state: \n\n${error?.message}`,
            color: 'error',
            open: true
        }));
    };
    (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'telematics',
            vehicle.id
        ],
        queryFn: async ()=>{
            let telematicsResponse;
            try {
                telematicsResponse = await (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getTelematics(vehicle.id);
            } catch (err) {
                console.error('getTelematics Error', err);
                return 'N/A';
            }
            if (!telematicsResponse) setOdometer(telematicsResponse.telematicsList[0]?.odometer?.reading.toString());
            else return 'N/A';
        },
        enabled: !!vehicle.id,
        placeholderData: 'N/A'
    });
    (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'customer',
            vehicle.customerId
        ],
        queryFn: ()=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getCustomerById(vehicle.customerId).catch((err)=>{
                console.error('getCustomerById Error', err);
                return 'N/A';
            }).then((response)=>{
                if (response.customer) setAccountNumber(response?.customer?.accountNumber || 'N/A');
                return response || 'N/A';
            });
        },
        enabled: !!vehicle.customerId && vehicle.customerId !== '00000000-0000-0000-0000-000000000000'
    });
    return {
        odometer: odometer,
        accountNumber: accountNumber,
        onSuccessVehicleStateUpdate: onSuccessVehicleStateUpdate,
        onErrorVehicleStateUpdate: onErrorVehicleStateUpdate
    };
}





"use client";
var $48660cdefc9954f1$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "m7 10 5 5 5-5z"
}), 'ArrowDropDown');





var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
function $9b0e6fd5d31b1b95$export$2e2bcd8739ae039(children) {
    return $acw62.Children.toArray(children).filter((child)=>/*#__PURE__*/ $acw62.isValidElement(child));
}









function $f71187894d79d79d$export$b85c003f960b1f3a(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiButtonGroup', slot);
}
const $f71187894d79d79d$var$buttonGroupClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiButtonGroup', [
    'root',
    'contained',
    'outlined',
    'text',
    'disableElevation',
    'disabled',
    'firstButton',
    'fullWidth',
    'horizontal',
    'vertical',
    'colorPrimary',
    'colorSecondary',
    'grouped',
    'groupedHorizontal',
    'groupedVertical',
    'groupedText',
    'groupedTextHorizontal',
    'groupedTextVertical',
    'groupedTextPrimary',
    'groupedTextSecondary',
    'groupedOutlined',
    'groupedOutlinedHorizontal',
    'groupedOutlinedVertical',
    'groupedOutlinedPrimary',
    'groupedOutlinedSecondary',
    'groupedContained',
    'groupedContainedHorizontal',
    'groupedContainedVertical',
    'groupedContainedPrimary',
    'groupedContainedSecondary',
    'lastButton',
    'middleButton'
]);
var $f71187894d79d79d$export$2e2bcd8739ae039 = $f71187894d79d79d$var$buttonGroupClasses;





'use client';
const $5f8f3fc94b629807$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles.grouped
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}`]
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.orientation)}`]
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: styles[`grouped${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton}`]: styles.firstButton
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton}`]: styles.lastButton
        },
        {
            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: styles.middleButton
        },
        styles.root,
        styles[ownerState.variant],
        ownerState.disableElevation === true && styles.disableElevation,
        ownerState.fullWidth && styles.fullWidth,
        ownerState.orientation === 'vertical' && styles.vertical
    ];
};
const $5f8f3fc94b629807$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, disableElevation: disableElevation, fullWidth: fullWidth, orientation: orientation, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            orientation,
            fullWidth && 'fullWidth',
            disableElevation && 'disableElevation',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
        ],
        grouped: [
            'grouped',
            `grouped${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}`,
            `grouped${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(orientation)}`,
            `grouped${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled'
        ],
        firstButton: [
            'firstButton'
        ],
        lastButton: [
            'lastButton'
        ],
        middleButton: [
            'middleButton'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $f71187894d79d79d$export$b85c003f960b1f3a), classes);
};
const $5f8f3fc94b629807$var$ButtonGroupRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiButtonGroup',
    slot: 'Root',
    overridesResolver: $5f8f3fc94b629807$var$overridesResolver
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        variants: [
            {
                props: {
                    variant: 'contained'
                },
                style: {
                    boxShadow: (theme.vars || theme).shadows[2]
                }
            },
            {
                props: {
                    disableElevation: true
                },
                style: {
                    boxShadow: 'none'
                }
            },
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    flexDirection: 'column',
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderTopLeftRadius: 0
                    },
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0
                    },
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderTopLeftRadius: 0,
                        borderBottomLeftRadius: 0
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $f71187894d79d79d$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'text',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: theme.vars ? `1px solid ${theme.alpha(theme.vars.palette.common.onBackground, 0.23)}` : `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
                        [`&.${(0, $f71187894d79d79d$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).flatMap(([color])=>[
                    {
                        props: {
                            variant: 'text',
                            color: color
                        },
                        style: {
                            [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                                borderColor: theme.alpha((theme.vars || theme).palette[color].main, 0.5)
                            }
                        }
                    }
                ]),
            {
                props: {
                    variant: 'outlined',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRightColor: 'transparent',
                        '&:hover': {
                            borderRightColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        marginLeft: -1
                    }
                }
            },
            {
                props: {
                    variant: 'outlined',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottomColor: 'transparent',
                        '&:hover': {
                            borderBottomColor: 'currentColor'
                        }
                    },
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).lastButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        marginTop: -1
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'horizontal'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderRight: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $f71187894d79d79d$export$2e2bcd8739ae039).disabled}`]: {
                            borderRight: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            {
                props: {
                    variant: 'contained',
                    orientation: 'vertical'
                },
                style: {
                    [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.grey[400]}`,
                        [`&.${(0, $f71187894d79d79d$export$2e2bcd8739ae039).disabled}`]: {
                            borderBottom: `1px solid ${(theme.vars || theme).palette.action.disabled}`
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        variant: 'contained',
                        color: color
                    },
                    style: {
                        [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).firstButton},& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).middleButton}`]: {
                            borderColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                }))
        ],
        [`& .${(0, $f71187894d79d79d$export$2e2bcd8739ae039).grouped}`]: {
            minWidth: 40,
            boxShadow: 'none',
            props: {
                variant: 'contained'
            },
            style: {
                '&:hover': {
                    boxShadow: 'none'
                }
            }
        }
    })));
const $5f8f3fc94b629807$var$ButtonGroup = /*#__PURE__*/ $acw62.forwardRef(function ButtonGroup(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiButtonGroup'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, disableElevation: disableElevation = false, disableFocusRipple: disableFocusRipple = false, disableRipple: disableRipple = false, fullWidth: fullWidth = false, orientation: orientation = 'horizontal', size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        disableElevation: disableElevation,
        disableFocusRipple: disableFocusRipple,
        disableRipple: disableRipple,
        fullWidth: fullWidth,
        orientation: orientation,
        size: size,
        variant: variant
    };
    const classes = $5f8f3fc94b629807$var$useUtilityClasses(ownerState);
    const context = $acw62.useMemo(()=>({
            className: classes.grouped,
            color: color,
            disabled: disabled,
            disableElevation: disableElevation,
            disableFocusRipple: disableFocusRipple,
            disableRipple: disableRipple,
            fullWidth: fullWidth,
            size: size,
            variant: variant
        }), [
        color,
        disabled,
        disableElevation,
        disableFocusRipple,
        disableRipple,
        fullWidth,
        size,
        variant,
        classes.grouped
    ]);
    const validChildren = (0, $9b0e6fd5d31b1b95$export$2e2bcd8739ae039)(children);
    const childrenCount = validChildren.length;
    const getButtonPositionClassName = (index)=>{
        const isFirstButton = index === 0;
        const isLastButton = index === childrenCount - 1;
        if (isFirstButton && isLastButton) return '';
        if (isFirstButton) return classes.firstButton;
        if (isLastButton) return classes.lastButton;
        return classes.middleButton;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5f8f3fc94b629807$var$ButtonGroupRoot, {
        as: component,
        role: "group",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17e2bbdd939aa1be$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: validChildren.map((child, index)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c83825b43ed55336$export$2e2bcd8739ae039).Provider, {
                    value: getButtonPositionClassName(index),
                    children: child
                }, index);
            })
        })
    });
});
var $5f8f3fc94b629807$export$2e2bcd8739ae039 = $5f8f3fc94b629807$var$ButtonGroup;





var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $ccdf08267bdb07b4$var$ListContext = /*#__PURE__*/ $acw62.createContext({});
var $ccdf08267bdb07b4$export$2e2bcd8739ae039 = $ccdf08267bdb07b4$var$ListContext;




'use client';
var $6d0031115bbee1bb$export$2e2bcd8739ae039 = (0, $aab859a020ad749e$export$2e2bcd8739ae039);





function $0fc9796113f6362d$export$46f01d01378ec5a2(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDivider', slot);
}
const $0fc9796113f6362d$var$dividerClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDivider', [
    'root',
    'absolute',
    'fullWidth',
    'inset',
    'middle',
    'flexItem',
    'light',
    'vertical',
    'withChildren',
    'withChildrenVertical',
    'textAlignRight',
    'textAlignLeft',
    'wrapper',
    'wrapperVertical'
]);
var $0fc9796113f6362d$export$2e2bcd8739ae039 = $0fc9796113f6362d$var$dividerClasses;




function $863c8b42c24a5d20$export$81478e24460c57f2(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiListItemIcon', slot);
}
const $863c8b42c24a5d20$var$listItemIconClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiListItemIcon', [
    'root',
    'alignItemsFlexStart'
]);
var $863c8b42c24a5d20$export$2e2bcd8739ae039 = $863c8b42c24a5d20$var$listItemIconClasses;




function $8ffc2f5b8ea69aff$export$1061006a0db3aeb5(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiListItemText', slot);
}
const $8ffc2f5b8ea69aff$var$listItemTextClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiListItemText', [
    'root',
    'multiline',
    'dense',
    'inset',
    'primary',
    'secondary'
]);
var $8ffc2f5b8ea69aff$export$2e2bcd8739ae039 = $8ffc2f5b8ea69aff$var$listItemTextClasses;




function $52ee1ef7b0f3c27a$export$515f8c67b5305377(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiMenuItem', slot);
}
const $52ee1ef7b0f3c27a$var$menuItemClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiMenuItem', [
    'root',
    'focusVisible',
    'dense',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $52ee1ef7b0f3c27a$export$2e2bcd8739ae039 = $52ee1ef7b0f3c27a$var$menuItemClasses;



'use client';
const $45389177b9c2b08c$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters
    ];
};
const $45389177b9c2b08c$var$useUtilityClasses = (ownerState)=>{
    const { disabled: disabled, dense: dense, divider: divider, disableGutters: disableGutters, selected: selected, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            disabled && 'disabled',
            !disableGutters && 'gutters',
            divider && 'divider',
            selected && 'selected'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $52ee1ef7b0f3c27a$export$515f8c67b5305377), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $45389177b9c2b08c$var$MenuItemRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenuItem',
    slot: 'Root',
    overridesResolver: $45389177b9c2b08c$export$4334bb34c76fef24
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        minHeight: 48,
        paddingTop: 6,
        paddingBottom: 6,
        boxSizing: 'border-box',
        whiteSpace: 'nowrap',
        '&:hover': {
            textDecoration: 'none',
            backgroundColor: (theme.vars || theme).palette.action.hover,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).selected}:hover`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity)
            }
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $52ee1ef7b0f3c27a$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`& + .${(0, $0fc9796113f6362d$export$2e2bcd8739ae039).root}`]: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(1)
        },
        [`& + .${(0, $0fc9796113f6362d$export$2e2bcd8739ae039).inset}`]: {
            marginLeft: 52
        },
        [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).root}`]: {
            marginTop: 0,
            marginBottom: 0
        },
        [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).inset}`]: {
            paddingLeft: 36
        },
        [`& .${(0, $863c8b42c24a5d20$export$2e2bcd8739ae039).root}`]: {
            minWidth: 36
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dense,
                style: {
                    [theme.breakpoints.up('sm')]: {
                        minHeight: 'auto'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.dense,
                style: {
                    minHeight: 32,
                    // https://m2.material.io/components/menus#specs > Dense
                    paddingTop: 4,
                    paddingBottom: 4,
                    ...theme.typography.body2,
                    [`& .${(0, $863c8b42c24a5d20$export$2e2bcd8739ae039).root} svg`]: {
                        fontSize: '1.25rem'
                    }
                }
            }
        ]
    })));
const $45389177b9c2b08c$var$MenuItem = /*#__PURE__*/ $acw62.forwardRef(function MenuItem(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenuItem'
    });
    const { autoFocus: autoFocus = false, component: component = 'li', dense: dense = false, divider: divider = false, disableGutters: disableGutters = false, focusVisibleClassName: focusVisibleClassName, role: role = 'menuitem', tabIndex: tabIndexProp, className: className, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            disableGutters: disableGutters
        }), [
        context.dense,
        dense,
        disableGutters
    ]);
    const menuItemRef = $acw62.useRef(null);
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) {
            if (menuItemRef.current) menuItemRef.current.focus();
        }
    }, [
        autoFocus
    ]);
    const ownerState = {
        ...props,
        dense: childContext.dense,
        divider: divider,
        disableGutters: disableGutters
    };
    const classes = $45389177b9c2b08c$var$useUtilityClasses(props);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(menuItemRef, ref);
    let tabIndex;
    if (!props.disabled) tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($45389177b9c2b08c$var$MenuItemRoot, {
            ref: handleRef,
            role: role,
            tabIndex: tabIndex,
            component: component,
            focusVisibleClassName: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName),
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            ownerState: ownerState,
            classes: classes
        })
    });
});
var $45389177b9c2b08c$export$2e2bcd8739ae039 = $45389177b9c2b08c$var$MenuItem;



var $acw62 = parcelRequire("acw62");



var $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039 = (0, $4c8156a231c9130b$export$2e2bcd8739ae039);



var $acw62 = parcelRequire("acw62");








function $2036eb6d4835ac15$export$c6bd6795ed6e3203(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiList', slot);
}
const $2036eb6d4835ac15$var$listClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiList', [
    'root',
    'padding',
    'dense',
    'subheader'
]);
var $2036eb6d4835ac15$export$2e2bcd8739ae039 = $2036eb6d4835ac15$var$listClasses;



'use client';
const $d987fddc25cef197$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePadding: disablePadding, dense: dense, subheader: subheader } = ownerState;
    const slots = {
        root: [
            'root',
            !disablePadding && 'padding',
            dense && 'dense',
            subheader && 'subheader'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $2036eb6d4835ac15$export$c6bd6795ed6e3203), classes);
};
const $d987fddc25cef197$var$ListRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('ul', {
    name: 'MuiList',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disablePadding && styles.padding,
            ownerState.dense && styles.dense,
            ownerState.subheader && styles.subheader
        ];
    }
})({
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
            style: {
                paddingTop: 8,
                paddingBottom: 8
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.subheader,
            style: {
                paddingTop: 0
            }
        }
    ]
});
const $d987fddc25cef197$var$List = /*#__PURE__*/ $acw62.forwardRef(function List(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiList'
    });
    const { children: children, className: className, component: component = 'ul', dense: dense = false, disablePadding: disablePadding = false, subheader: subheader, ...other } = props;
    const context = $acw62.useMemo(()=>({
            dense: dense
        }), [
        dense
    ]);
    const ownerState = {
        ...props,
        component: component,
        dense: dense,
        disablePadding: disablePadding
    };
    const classes = $d987fddc25cef197$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d987fddc25cef197$var$ListRoot, {
            as: component,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ownerState: ownerState,
            ...other,
            children: [
                subheader,
                children
            ]
        })
    });
});
var $d987fddc25cef197$export$2e2bcd8739ae039 = $d987fddc25cef197$var$List;


// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function $0200cab69b9251c8$export$2e2bcd8739ae039(win = window) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
    const documentWidth = win.document.documentElement.clientWidth;
    return win.innerWidth - documentWidth;
}


var $6e949a478f594883$export$2e2bcd8739ae039 = (0, $0200cab69b9251c8$export$2e2bcd8739ae039);





function $71912e551e227707$export$2e2bcd8739ae039(node) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(node);
    return doc.defaultView || window;
}


var $85795f3c4e07aecf$export$2e2bcd8739ae039 = (0, $71912e551e227707$export$2e2bcd8739ae039);



'use client';
function $7c6e657321c9c45b$var$nextItem(list, item, disableListWrap) {
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return disableListWrap ? null : list.firstChild;
}
function $7c6e657321c9c45b$var$previousItem(list, item, disableListWrap) {
    if (list === item) return disableListWrap ? list.firstChild : list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return disableListWrap ? null : list.lastChild;
}
function $7c6e657321c9c45b$var$textCriteriaMatches(nextFocus, textCriteria) {
    if (textCriteria === undefined) return true;
    let text = nextFocus.innerText;
    if (text === undefined) // jsdom doesn't support innerText
    text = nextFocus.textContent;
    text = text.trim().toLowerCase();
    if (text.length === 0) return false;
    if (textCriteria.repeating) return text[0] === textCriteria.keys[0];
    return text.startsWith(textCriteria.keys.join(''));
}
function $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return false;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || !$7c6e657321c9c45b$var$textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus, disableListWrap);
        else {
            nextFocus.focus();
            return true;
        }
    }
    return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/WAI/ARIA/apg/patterns/menu-button/.
 * It's exposed to help customization of the [`Menu`](/material-ui/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */ const $7c6e657321c9c45b$var$MenuList = /*#__PURE__*/ $acw62.forwardRef(function MenuList(props, ref) {
    const { actions: // private
    // eslint-disable-next-line react/prop-types
    actions, autoFocus: autoFocus = false, autoFocusItem: autoFocusItem = false, children: children, className: className, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, onKeyDown: onKeyDown, variant: variant = 'selectedMenu', ...other } = props;
    const listRef = $acw62.useRef(null);
    const textCriteriaRef = $acw62.useRef({
        keys: [],
        repeating: true,
        previousKeyMatched: true,
        lastTime: null
    });
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) listRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useImperativeHandle(actions, ()=>({
            adjustStyleForScrollbar: (containerElement, { direction: direction })=>{
                // Let's ignore that piece of logic if users are already overriding the width
                // of the menu.
                const noExplicitWidth = !listRef.current.style.width;
                if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
                    const scrollbarSize = `${(0, $6e949a478f594883$export$2e2bcd8739ae039)((0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(containerElement))}px`;
                    listRef.current.style[direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
                    listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
                }
                return listRef.current;
            }
        }), []);
    const handleKeyDown = (event)=>{
        const list = listRef.current;
        const key = event.key;
        const isModifierKeyPressed = event.ctrlKey || event.metaKey || event.altKey;
        if (isModifierKeyPressed) {
            if (onKeyDown) onKeyDown(event);
            return;
        }
        /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */ const currentFocus = (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(list).activeElement;
        if (key === 'ArrowDown') {
            // Prevent scroll of the page
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem);
        } else if (key === 'ArrowUp') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$previousItem);
        } else if (key === 'Home') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem);
        } else if (key === 'End') {
            event.preventDefault();
            $7c6e657321c9c45b$var$moveFocus(list, null, disableListWrap, disabledItemsFocusable, $7c6e657321c9c45b$var$previousItem);
        } else if (key.length === 1) {
            const criteria = textCriteriaRef.current;
            const lowerKey = key.toLowerCase();
            const currTime = performance.now();
            if (criteria.keys.length > 0) {
                // Reset
                if (currTime - criteria.lastTime > 500) {
                    criteria.keys = [];
                    criteria.repeating = true;
                    criteria.previousKeyMatched = true;
                } else if (criteria.repeating && lowerKey !== criteria.keys[0]) criteria.repeating = false;
            }
            criteria.lastTime = currTime;
            criteria.keys.push(lowerKey);
            const keepFocusOnCurrent = currentFocus && !criteria.repeating && $7c6e657321c9c45b$var$textCriteriaMatches(currentFocus, criteria);
            if (criteria.previousKeyMatched && (keepFocusOnCurrent || $7c6e657321c9c45b$var$moveFocus(list, currentFocus, false, disabledItemsFocusable, $7c6e657321c9c45b$var$nextItem, criteria))) event.preventDefault();
            else criteria.previousKeyMatched = false;
        }
        if (onKeyDown) onKeyDown(event);
    };
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(listRef, ref);
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.forEach(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) {
            if (activeItemIndex === index) {
                activeItemIndex += 1;
                if (activeItemIndex >= children.length) // there are no focusable items within the list.
                activeItemIndex = -1;
            }
            return;
        }
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
        if (activeItemIndex === index && (child.props.disabled || child.props.muiSkipListHighlight || child.type.muiSkipListHighlight)) {
            activeItemIndex += 1;
            if (activeItemIndex >= children.length) // there are no focusable items within the list.
            activeItemIndex = -1;
        }
    });
    const items = $acw62.Children.map(children, (child, index)=>{
        if (index === activeItemIndex) {
            const newChildProps = {};
            if (autoFocusItem) newChildProps.autoFocus = true;
            if (child.props.tabIndex === undefined && variant === 'selectedMenu') newChildProps.tabIndex = 0;
            return /*#__PURE__*/ $acw62.cloneElement(child, newChildProps);
        }
        return child;
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
        role: "menu",
        ref: handleRef,
        className: className,
        onKeyDown: handleKeyDown,
        tabIndex: autoFocus ? 0 : -1,
        ...other,
        children: items
    });
});
var $7c6e657321c9c45b$export$2e2bcd8739ae039 = $7c6e657321c9c45b$var$MenuList;








var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");






function $6985093033570817$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $69730206aa270d41$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $69730206aa270d41$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $69730206aa270d41$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6985093033570817$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $3711db8b00de96df$export$8960430cfd85939f = Math.max;
var $3711db8b00de96df$export$96ec731ed4dcb222 = Math.min;
var $3711db8b00de96df$export$2077e0241d6afd3c = Math.round;



function $6de7caa8ee90d63c$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $bef5ff765617d084$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
}


function $2ef6a598263dba8e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $3711db8b00de96df$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? (0, $6985093033570817$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $bef5ff765617d084$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $39a9a96b6f99add9$export$2e2bcd8739ae039(node) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $d47756cb7a847081$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ac7dd8aeabb81fe8$export$2e2bcd8739ae039(node) {
    if (node === (0, $6985093033570817$export$2e2bcd8739ae039)(node) || !(0, $69730206aa270d41$export$1b3bfaa9684536aa)(node)) return (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(node);
    else return (0, $d47756cb7a847081$export$2e2bcd8739ae039)(node);
}


function $04a691b7a330df44$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $0d1d9daad62fa952$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60124eceeef28a28$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)).left + (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cbd21d1454570861$export$2e2bcd8739ae039(element) {
    return (0, $6985093033570817$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $12881c0013479a14$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $bcb265ed9201975a$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $3711db8b00de96df$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $bcb265ed9201975a$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent) && $bcb265ed9201975a$var$isElementScaled(offsetParent);
    var documentElement = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $12881c0013479a14$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ac7dd8aeabb81fe8$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60124eceeef28a28$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $9effe2b32f662e4a$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $773048fc1d2aa7ee$export$2e2bcd8739ae039(element) {
    if ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $69730206aa270d41$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $2cddda83e3357241$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $69730206aa270d41$export$1b3bfaa9684536aa)(node) && (0, $12881c0013479a14$export$2e2bcd8739ae039)(node)) return node;
    return $2cddda83e3357241$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(node));
}





function $90b72ed15edfd54a$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $2cddda83e3357241$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $12881c0013479a14$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($90b72ed15edfd54a$export$2e2bcd8739ae039((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(target)));
}







function $fd46d779ec622be4$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) >= 0;
}




function $42fc94c94931c781$var$getTrueOffsetParent(element) {
    if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $42fc94c94931c781$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $6de7caa8ee90d63c$export$2e2bcd8739ae039)());
    if (isIE && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element);
    if ((0, $69730206aa270d41$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $69730206aa270d41$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $04a691b7a330df44$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cbd21d1454570861$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $42fc94c94931c781$export$2e2bcd8739ae039(element) {
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $fd46d779ec622be4$export$2e2bcd8739ae039)(offsetParent) && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $42fc94c94931c781$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $04a691b7a330df44$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $42fc94c94931c781$var$getContainingBlock(element) || window;
}


var $1472b89a65155de2$export$1e95b668f3b82d = 'top';
var $1472b89a65155de2$export$40e543e69a8b3fbb = 'bottom';
var $1472b89a65155de2$export$79ffe56a765070d2 = 'right';
var $1472b89a65155de2$export$eabcd2c8791e7bf4 = 'left';
var $1472b89a65155de2$export$dfb5619354ba860 = 'auto';
var $1472b89a65155de2$export$aec2ce47c367b8c3 = [
    $1472b89a65155de2$export$1e95b668f3b82d,
    $1472b89a65155de2$export$40e543e69a8b3fbb,
    $1472b89a65155de2$export$79ffe56a765070d2,
    $1472b89a65155de2$export$eabcd2c8791e7bf4
];
var $1472b89a65155de2$export$b3571188c770cc5a = 'start';
var $1472b89a65155de2$export$bd5df0f255a350f8 = 'end';
var $1472b89a65155de2$export$390fd549c5303b4d = 'clippingParents';
var $1472b89a65155de2$export$d7b7311ec04a3e8f = 'viewport';
var $1472b89a65155de2$export$ae5ab1c730825774 = 'popper';
var $1472b89a65155de2$export$ca50aac9f3ba507f = 'reference';
var $1472b89a65155de2$export$368f9a87e87fa4e1 = /*#__PURE__*/ $1472b89a65155de2$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []);
var $1472b89a65155de2$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($1472b89a65155de2$export$aec2ce47c367b8c3, [
    $1472b89a65155de2$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $1472b89a65155de2$export$b3571188c770cc5a,
        placement + "-" + $1472b89a65155de2$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $1472b89a65155de2$export$421679a7c3d56e = 'beforeRead';
var $1472b89a65155de2$export$aafa59e2e03f2942 = 'read';
var $1472b89a65155de2$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $1472b89a65155de2$export$c65e99957a05207c = 'beforeMain';
var $1472b89a65155de2$export$f22da7240b7add18 = 'main';
var $1472b89a65155de2$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $1472b89a65155de2$export$8d4d2d70e7d46032 = 'beforeWrite';
var $1472b89a65155de2$export$68d8715fc104d294 = 'write';
var $1472b89a65155de2$export$70a6e5159acce2e6 = 'afterWrite';
var $1472b89a65155de2$export$d087d3878fdf71d5 = [
    $1472b89a65155de2$export$421679a7c3d56e,
    $1472b89a65155de2$export$aafa59e2e03f2942,
    $1472b89a65155de2$export$6964f6c886723980,
    $1472b89a65155de2$export$c65e99957a05207c,
    $1472b89a65155de2$export$f22da7240b7add18,
    $1472b89a65155de2$export$bab79516f2d662fe,
    $1472b89a65155de2$export$8d4d2d70e7d46032,
    $1472b89a65155de2$export$68d8715fc104d294,
    $1472b89a65155de2$export$70a6e5159acce2e6
];


function $77bc085de34276f2$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $77bc085de34276f2$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $77bc085de34276f2$var$order(modifiers); // order based on phase
    return (0, $1472b89a65155de2$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $9b685cb08303911c$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $f58f9fd4551b4b0f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $60bdf67e43f5dfcb$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $60bdf67e43f5dfcb$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $60bdf67e43f5dfcb$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(reference) ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $77bc085de34276f2$export$2e2bcd8739ae039)((0, $f58f9fd4551b4b0f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $bcb265ed9201975a$export$2e2bcd8739ae039)(reference, (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $9b685cb08303911c$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$60bdf67e43f5dfcb$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $60bdf67e43f5dfcb$export$8f7491d57c8f97a9 = /*#__PURE__*/ $60bdf67e43f5dfcb$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $e7d7845625089588$var$passive = {
    passive: true
};
function $e7d7845625089588$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6985093033570817$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $e7d7845625089588$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $e7d7845625089588$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e7d7845625089588$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $e7d7845625089588$var$effect,
    data: {}
};



function $c6075629d0814627$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $5553ed9c2ee225e3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $ba9a98a4204389e3$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $9a8b7e877fbba4f3$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $1472b89a65155de2$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $1472b89a65155de2$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $1472b89a65155de2$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $1472b89a65155de2$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $1472b89a65155de2$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $1472b89a65155de2$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $8e8ecd9a827a16d7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8e8ecd9a827a16d7$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8e8ecd9a827a16d7$var$popperOffsets,
    data: {}
};










var $45d468ca92a1d24b$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $45d468ca92a1d24b$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $3711db8b00de96df$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $45d468ca92a1d24b$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var sideY = (0, $1472b89a65155de2$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(popper);
            if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || placement === (0, $1472b89a65155de2$export$79ffe56a765070d2)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideY = (0, $1472b89a65155de2$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) || (placement === (0, $1472b89a65155de2$export$1e95b668f3b82d) || placement === (0, $1472b89a65155de2$export$40e543e69a8b3fbb)) && variation === (0, $1472b89a65155de2$export$bd5df0f255a350f8)) {
            sideX = (0, $1472b89a65155de2$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $45d468ca92a1d24b$var$unsetSides);
    var _ref4 = roundOffsets === true ? $45d468ca92a1d24b$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6985093033570817$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $45d468ca92a1d24b$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $45d468ca92a1d24b$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $45d468ca92a1d24b$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $45d468ca92a1d24b$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $7deefb3680d4558f$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $7deefb3680d4558f$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) || !(0, $04a691b7a330df44$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $7deefb3680d4558f$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $7deefb3680d4558f$var$applyStyles,
    effect: $7deefb3680d4558f$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $ff9a9783c10adebd$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $1472b89a65155de2$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $ff9a9783c10adebd$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ff9a9783c10adebd$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $ff9a9783c10adebd$var$offset
};


var $aaefa8315f14c8e2$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $aaefa8315f14c8e2$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $aaefa8315f14c8e2$var$hash[matched];
    });
}



var $37f85a49ff946cb6$var$hash = {
    start: 'end',
    end: 'start'
};
function $37f85a49ff946cb6$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $37f85a49ff946cb6$var$hash[matched];
    });
}







function $a35bf29d5fc5ab40$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6985093033570817$export$2e2bcd8739ae039)(element);
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $bef5ff765617d084$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $a5e625ef2dd801ec$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $39a9a96b6f99add9$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $3711db8b00de96df$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60124eceeef28a28$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cbd21d1454570861$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $3711db8b00de96df$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $8f3b5a3db2e59cbc$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $69730206aa270d41$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $d5700acdd3ba9a3c$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $449799046a13d100$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) ? (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a35bf29d5fc5ab40$export$2e2bcd8739ae039)(element, strategy)) : (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) ? $449799046a13d100$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)((0, $a5e625ef2dd801ec$export$2e2bcd8739ae039)((0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $449799046a13d100$var$getClippingParents(element) {
    var clippingParents = (0, $90b72ed15edfd54a$export$2e2bcd8739ae039)((0, $773048fc1d2aa7ee$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cbd21d1454570861$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $69730206aa270d41$export$1b3bfaa9684536aa)(element) ? (0, $42fc94c94931c781$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $69730206aa270d41$export$45a5e7f76e0caa8d)(clippingParent) && (0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $04a691b7a330df44$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $449799046a13d100$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $449799046a13d100$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $449799046a13d100$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $3711db8b00de96df$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $3711db8b00de96df$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $449799046a13d100$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $bcb51404109b5184$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $2c6bd604be4c867e$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $bcb51404109b5184$export$2e2bcd8739ae039)(), paddingObject);
}


function $c88039fe47959ef5$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $c24a1421ba2f823c$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $1472b89a65155de2$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $1472b89a65155de2$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $1472b89a65155de2$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? (0, $1472b89a65155de2$export$ca50aac9f3ba507f) : (0, $1472b89a65155de2$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $449799046a13d100$export$2e2bcd8739ae039)((0, $69730206aa270d41$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $0d1d9daad62fa952$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $2ef6a598263dba8e$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $9a8b7e877fbba4f3$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d5700acdd3ba9a3c$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $1472b89a65155de2$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $1472b89a65155de2$export$79ffe56a765070d2),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $1472b89a65155de2$export$1e95b668f3b82d),
                (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $dae0983d65fbfc0b$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $1472b89a65155de2$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $1472b89a65155de2$export$368f9a87e87fa4e1) : (0, $1472b89a65155de2$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $1472b89a65155de2$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $c6075629d0814627$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $cf1ba1dd94205465$var$getExpandedFallbackPlacements(placement) {
    if ((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(placement);
    return [
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $37f85a49ff946cb6$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $cf1ba1dd94205465$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $cf1ba1dd94205465$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $c6075629d0814627$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$dfb5619354ba860) ? (0, $dae0983d65fbfc0b$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(placement) === (0, $1472b89a65155de2$export$b3571188c770cc5a);
        var isVertical = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $1472b89a65155de2$export$79ffe56a765070d2) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $aaefa8315f14c8e2$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $cf1ba1dd94205465$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $cf1ba1dd94205465$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $61f76a8076c296c7$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $95428a5e75015184$export$f28d906d67a997f3(min, value, max) {
    return (0, $3711db8b00de96df$export$8960430cfd85939f)(min, (0, $3711db8b00de96df$export$96ec731ed4dcb222)(value, max));
}
function $95428a5e75015184$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $95428a5e75015184$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $865d356b2ca960a5$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $5553ed9c2ee225e3$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $61f76a8076c296c7$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $1472b89a65155de2$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $bcb51404109b5184$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $95428a5e75015184$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $42fc94c94931c781$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? (0, $3711db8b00de96df$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $3711db8b00de96df$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $1472b89a65155de2$export$1e95b668f3b82d),
            (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $95428a5e75015184$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $95428a5e75015184$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $865d356b2ca960a5$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $865d356b2ca960a5$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $f37d2f7eaf2ad10e$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $2c6bd604be4c867e$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $c88039fe47959ef5$export$2e2bcd8739ae039)(padding, (0, $1472b89a65155de2$export$aec2ce47c367b8c3)));
};
function $f37d2f7eaf2ad10e$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $c6075629d0814627$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $ba9a98a4204389e3$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4),
        (0, $1472b89a65155de2$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $f37d2f7eaf2ad10e$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $9effe2b32f662e4a$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $1472b89a65155de2$export$1e95b668f3b82d) : (0, $1472b89a65155de2$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $1472b89a65155de2$export$40e543e69a8b3fbb) : (0, $1472b89a65155de2$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $42fc94c94931c781$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $95428a5e75015184$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $f37d2f7eaf2ad10e$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $8f3b5a3db2e59cbc$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $f37d2f7eaf2ad10e$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $f37d2f7eaf2ad10e$var$arrow,
    effect: $f37d2f7eaf2ad10e$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $69d8d7bda7717b01$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $69d8d7bda7717b01$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $1472b89a65155de2$export$1e95b668f3b82d),
        (0, $1472b89a65155de2$export$79ffe56a765070d2),
        (0, $1472b89a65155de2$export$40e543e69a8b3fbb),
        (0, $1472b89a65155de2$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $69d8d7bda7717b01$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $c24a1421ba2f823c$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $69d8d7bda7717b01$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $69d8d7bda7717b01$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $69d8d7bda7717b01$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $69d8d7bda7717b01$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $69d8d7bda7717b01$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $69d8d7bda7717b01$var$hide
};




var $288fbeb449f53487$export$d34966752335dd47 = [
    (0, $e7d7845625089588$export$2e2bcd8739ae039),
    (0, $8e8ecd9a827a16d7$export$2e2bcd8739ae039),
    (0, $45d468ca92a1d24b$export$2e2bcd8739ae039),
    (0, $7deefb3680d4558f$export$2e2bcd8739ae039),
    (0, $ff9a9783c10adebd$export$2e2bcd8739ae039),
    (0, $cf1ba1dd94205465$export$2e2bcd8739ae039),
    (0, $865d356b2ca960a5$export$2e2bcd8739ae039),
    (0, $f37d2f7eaf2ad10e$export$2e2bcd8739ae039),
    (0, $69d8d7bda7717b01$export$2e2bcd8739ae039)
];
var $288fbeb449f53487$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $60bdf67e43f5dfcb$export$ed5e13716264f202)({
    defaultModifiers: $288fbeb449f53487$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules








'use client';
/**
 * @ignore - do not document.
 * Builds the props to be passed into the slot of an unstyled component.
 * It merges the internal props of the component with the ones supplied by the user, allowing to customize the behavior.
 * If the slot component is not a host component, it also merges in the `ownerState`.
 *
 * @param parameters.getSlotProps - A function that returns the props to be passed to the slot component.
 */ function $aa69d7725f45330b$var$useSlotProps(parameters) {
    const { elementType: elementType, externalSlotProps: externalSlotProps, ownerState: ownerState, skipResolvingSlotProps: skipResolvingSlotProps = false, ...other } = parameters;
    const resolvedComponentsProps = skipResolvingSlotProps ? {} : (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(externalSlotProps, ownerState);
    const { props: mergedProps, internalRef: internalRef } = (0, $135391549c807611$export$2e2bcd8739ae039)({
        ...other,
        externalSlotProps: resolvedComponentsProps
    });
    const ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalRef, resolvedComponentsProps?.ref, parameters.additionalProps?.ref);
    const props = (0, $c20bfbd9e98e2eff$export$2e2bcd8739ae039)(elementType, {
        ...mergedProps,
        ref: ref
    }, ownerState);
    return props;
}
var $aa69d7725f45330b$export$2e2bcd8739ae039 = $aa69d7725f45330b$var$useSlotProps;



var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");



/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */ function $c8b9145416f64bb2$export$2e2bcd8739ae039(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
}





'use client';
function $652518a1db38c266$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * Demos:
 *
 * - [Portal](https://mui.com/material-ui/react-portal/)
 *
 * API:
 *
 * - [Portal API](https://mui.com/material-ui/api/portal/)
 */ const $652518a1db38c266$var$Portal = /*#__PURE__*/ $acw62.forwardRef(function Portal(props, forwardedRef) {
    const { children: children, container: container, disablePortal: disablePortal = false } = props;
    const [mountNode, setMountNode] = $acw62.useState(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(/*#__PURE__*/ $acw62.isValidElement(children) ? (0, $1d88113360503233$export$2e2bcd8739ae039)(children) : null, forwardedRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!disablePortal) setMountNode($652518a1db38c266$var$getContainer(container) || document.body);
    }, [
        container,
        disablePortal
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (mountNode && !disablePortal) {
            (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, mountNode);
            return ()=>{
                (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(forwardedRef, null);
            };
        }
        return undefined;
    }, [
        forwardedRef,
        mountNode,
        disablePortal
    ]);
    if (disablePortal) {
        if (/*#__PURE__*/ $acw62.isValidElement(children)) {
            const newProps = {
                ref: handleRef
            };
            return /*#__PURE__*/ $acw62.cloneElement(children, newProps);
        }
        return children;
    }
    return mountNode ? /*#__PURE__*/ $1u0KT.createPortal(children, mountNode) : mountNode;
});
var $652518a1db38c266$export$2e2bcd8739ae039 = $652518a1db38c266$var$Portal;




function $9a19b57a2f88339a$export$1b69b6cd0fa638a1(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPopper', slot);
}
const $9a19b57a2f88339a$var$popperClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPopper', [
    'root'
]);
var $9a19b57a2f88339a$export$2e2bcd8739ae039 = $9a19b57a2f88339a$var$popperClasses;



'use client';
function $cff71a91c86529eb$var$flipPlacement(placement, direction) {
    if (direction === 'ltr') return placement;
    switch(placement){
        case 'bottom-end':
            return 'bottom-start';
        case 'bottom-start':
            return 'bottom-end';
        case 'top-end':
            return 'top-start';
        case 'top-start':
            return 'top-end';
        default:
            return placement;
    }
}
function $cff71a91c86529eb$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
function $cff71a91c86529eb$var$isHTMLElement(element) {
    return element.nodeType !== undefined;
}
function $cff71a91c86529eb$var$isVirtualElement(element) {
    return !$cff71a91c86529eb$var$isHTMLElement(element);
}
const $cff71a91c86529eb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $9a19b57a2f88339a$export$1b69b6cd0fa638a1), classes);
};
const $cff71a91c86529eb$var$defaultPopperOptions = {};
const $cff71a91c86529eb$var$PopperTooltip = /*#__PURE__*/ $acw62.forwardRef(function PopperTooltip(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, direction: direction, disablePortal: disablePortal, modifiers: modifiers, open: open, placement: initialPlacement, popperOptions: popperOptions, popperRef: popperRefProp, slotProps: slotProps = {}, slots: slots = {}, TransitionProps: TransitionProps, // @ts-ignore internal logic
    ownerState: ownerStateProp, // prevent from spreading to DOM, it can come from the parent component e.g. Select.
    ...other } = props;
    const tooltipRef = $acw62.useRef(null);
    const ownRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(tooltipRef, forwardedRef);
    const popperRef = $acw62.useRef(null);
    const handlePopperRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(popperRef, popperRefProp);
    const handlePopperRefRef = $acw62.useRef(handlePopperRef);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        handlePopperRefRef.current = handlePopperRef;
    }, [
        handlePopperRef
    ]);
    $acw62.useImperativeHandle(popperRefProp, ()=>popperRef.current, []);
    const rtlPlacement = $cff71a91c86529eb$var$flipPlacement(initialPlacement, direction);
    /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */ const [placement, setPlacement] = $acw62.useState(rtlPlacement);
    const [resolvedAnchorElement, setResolvedAnchorElement] = $acw62.useState($cff71a91c86529eb$var$resolveAnchorEl(anchorEl));
    $acw62.useEffect(()=>{
        if (popperRef.current) popperRef.current.forceUpdate();
    });
    $acw62.useEffect(()=>{
        if (anchorEl) setResolvedAnchorElement($cff71a91c86529eb$var$resolveAnchorEl(anchorEl));
    }, [
        anchorEl
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!resolvedAnchorElement || !open) return undefined;
        const handlePopperUpdate = (data)=>{
            setPlacement(data.placement);
        };
        let popperModifiers = [
            {
                name: 'preventOverflow',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'flip',
                options: {
                    altBoundary: disablePortal
                }
            },
            {
                name: 'onUpdate',
                enabled: true,
                phase: 'afterWrite',
                fn: ({ state: state })=>{
                    handlePopperUpdate(state);
                }
            }
        ];
        if (modifiers != null) popperModifiers = popperModifiers.concat(modifiers);
        if (popperOptions && popperOptions.modifiers != null) popperModifiers = popperModifiers.concat(popperOptions.modifiers);
        const popper = (0, $288fbeb449f53487$export$8f7491d57c8f97a9)(resolvedAnchorElement, tooltipRef.current, {
            placement: rtlPlacement,
            ...popperOptions,
            modifiers: popperModifiers
        });
        handlePopperRefRef.current(popper);
        return ()=>{
            popper.destroy();
            handlePopperRefRef.current(null);
        };
    }, [
        resolvedAnchorElement,
        disablePortal,
        modifiers,
        open,
        popperOptions,
        rtlPlacement
    ]);
    const childProps = {
        placement: placement
    };
    if (TransitionProps !== null) childProps.TransitionProps = TransitionProps;
    const classes = $cff71a91c86529eb$var$useUtilityClasses(props);
    const Root = slots.root ?? 'div';
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps.root,
        externalForwardedProps: other,
        additionalProps: {
            role: 'tooltip',
            ref: ownRef
        },
        ownerState: props,
        className: classes.root
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Root, {
        ...rootProps,
        children: typeof children === 'function' ? children(childProps) : children
    });
});
/**
 * @ignore - internal component.
 */ const $cff71a91c86529eb$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(props, forwardedRef) {
    const { anchorEl: anchorEl, children: children, container: containerProp, direction: direction = 'ltr', disablePortal: disablePortal = false, keepMounted: keepMounted = false, modifiers: modifiers, open: open, placement: placement = 'bottom', popperOptions: popperOptions = $cff71a91c86529eb$var$defaultPopperOptions, popperRef: popperRef, style: style, transition: transition = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const [exited, setExited] = $acw62.useState(true);
    const handleEnter = ()=>{
        setExited(false);
    };
    const handleExited = ()=>{
        setExited(true);
    };
    if (!keepMounted && !open && (!transition || exited)) return null;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    let container;
    if (containerProp) container = containerProp;
    else if (anchorEl) {
        const resolvedAnchorEl = $cff71a91c86529eb$var$resolveAnchorEl(anchorEl);
        container = resolvedAnchorEl && $cff71a91c86529eb$var$isHTMLElement(resolvedAnchorEl) ? (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(resolvedAnchorEl).body : (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(null).body;
    }
    const display = !open && keepMounted && (!transition || exited) ? 'none' : undefined;
    const transitionProps = transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
    } : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $652518a1db38c266$export$2e2bcd8739ae039), {
        disablePortal: disablePortal,
        container: container,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cff71a91c86529eb$var$PopperTooltip, {
            anchorEl: anchorEl,
            direction: direction,
            disablePortal: disablePortal,
            modifiers: modifiers,
            ref: forwardedRef,
            open: transition ? !exited : open,
            placement: placement,
            popperOptions: popperOptions,
            popperRef: popperRef,
            slotProps: slotProps,
            slots: slots,
            ...other,
            style: {
                // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
                position: 'fixed',
                // Fix Popper.js display issue
                top: 0,
                left: 0,
                display: display,
                ...style
            },
            TransitionProps: transitionProps,
            children: children
        })
    });
});
var $cff71a91c86529eb$export$2e2bcd8739ae039 = $cff71a91c86529eb$var$Popper;





'use client';
const $d825775ecf14115c$var$PopperRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $cff71a91c86529eb$export$2e2bcd8739ae039), {
    name: 'MuiPopper',
    slot: 'Root'
})({});
/**
 *
 * Demos:
 *
 * - [Autocomplete](https://mui.com/material-ui/react-autocomplete/)
 * - [Menu](https://mui.com/material-ui/react-menu/)
 * - [Popper](https://mui.com/material-ui/react-popper/)
 *
 * API:
 *
 * - [Popper API](https://mui.com/material-ui/api/popper/)
 */ const $d825775ecf14115c$var$Popper = /*#__PURE__*/ $acw62.forwardRef(function Popper(inProps, ref) {
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopper'
    });
    const { anchorEl: anchorEl, component: component, components: components, componentsProps: componentsProps, container: container, disablePortal: disablePortal, keepMounted: keepMounted, modifiers: modifiers, open: open, placement: placement, popperOptions: popperOptions, popperRef: popperRef, transition: transition, slots: slots, slotProps: slotProps, ...other } = props;
    const RootComponent = slots?.root ?? components?.Root;
    const otherProps = {
        anchorEl: anchorEl,
        container: container,
        disablePortal: disablePortal,
        keepMounted: keepMounted,
        modifiers: modifiers,
        open: open,
        placement: placement,
        popperOptions: popperOptions,
        popperRef: popperRef,
        transition: transition,
        ...other
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d825775ecf14115c$var$PopperRoot, {
        as: component,
        direction: isRtl ? 'rtl' : 'ltr',
        slots: {
            root: RootComponent
        },
        slotProps: slotProps ?? componentsProps,
        ...otherProps,
        ref: ref
    });
});
var $d825775ecf14115c$export$2e2bcd8739ae039 = $d825775ecf14115c$var$Popper;



var $acw62 = parcelRequire("acw62");



const $861447d3df26b933$var$options = [
    {
        text: 'In Process (delist)',
        updateFn: (0, $930f18d689e94983$export$7b639b94d0b7f4c4).updateStateToInProcess
    },
    {
        text: 'In Listing (list)',
        updateFn: (0, $930f18d689e94983$export$7b639b94d0b7f4c4).updateStateToInListing
    },
    {
        text: 'Sold',
        updateFn: (0, $930f18d689e94983$export$7b639b94d0b7f4c4).updateStateToSold
    },
    {
        text: 'Total Loss',
        updateFn: (0, $930f18d689e94983$export$7b639b94d0b7f4c4).updateStateToTotalLoss
    }
];
function $861447d3df26b933$export$2e2bcd8739ae039(props) {
    const { vehicleId: vehicleId, currentVehicleState: currentVehicleState, onSuccess: onSuccess, onError: onError } = props;
    const [open, setOpen] = $acw62.useState(false);
    const anchorRef = $acw62.useRef(null);
    const [selectedIndex, setSelectedIndex] = $acw62.useState(currentVehicleState == 'IN_PROCESS' ? 0 : 1);
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const changeStateEnabled = currentVehicleState === 'IN_LISTING' || currentVehicleState === 'IN_PROCESS';
    const handleClick = ()=>{
        $861447d3df26b933$var$options[selectedIndex].updateFn(vehicleId).then(onSuccess).catch(onError);
    };
    const handleMenuItemClick = (_event, index)=>{
        setSelectedIndex(index);
        setOpen(false);
    };
    const handleToggle = ()=>{
        setOpen((prevOpen)=>!prevOpen);
    };
    const handleClose = (event)=>{
        if (anchorRef.current && anchorRef.current.contains(event.target)) return;
        setOpen(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    !changeStateEnabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        children: "Current state does not allow manual changes."
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5f8f3fc94b629807$export$2e2bcd8739ae039), {
                        variant: "contained",
                        ref: anchorRef,
                        "aria-label": "Button group with a nested menu",
                        disabled: !changeStateEnabled,
                        sx: {
                            '& .MuiButton-root': {
                                backgroundColor: themeColors.buttonColor,
                                color: currentTheme === 'galpin' ? 'black' : 'white',
                                '&:hover': {
                                    backgroundColor: themeColors.buttonHover
                                },
                                padding: '3px 9px'
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                onClick: handleClick,
                                children: changeStateEnabled ? $861447d3df26b933$var$options[selectedIndex].text : currentVehicleState
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                "aria-controls": open ? 'split-button-menu' : undefined,
                                "aria-expanded": open ? 'true' : undefined,
                                "aria-label": "select state of vehicle",
                                "aria-haspopup": "menu",
                                onClick: handleToggle,
                                style: {
                                    padding: 0,
                                    minWidth: '20px'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48660cdefc9954f1$export$2e2bcd8739ae039), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d825775ecf14115c$export$2e2bcd8739ae039), {
                sx: {
                    zIndex: 1
                },
                open: open,
                anchorEl: anchorRef.current,
                role: undefined,
                transition: true,
                disablePortal: true,
                children: ({ TransitionProps: TransitionProps, placement: placement })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a8449c70e836e71$export$2e2bcd8739ae039), {
                        ...TransitionProps,
                        style: {
                            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21498506e622538e$export$58385c17fee43f89), {
                                onClickAway: handleClose,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c6e657321c9c45b$export$2e2bcd8739ae039), {
                                    id: "split-button-menu",
                                    autoFocusItem: true,
                                    children: $861447d3df26b933$var$options.map((option, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                            selected: index === selectedIndex,
                                            onClick: (event)=>handleMenuItemClick(event, index),
                                            children: option.text
                                        }, index))
                                })
                            })
                        })
                    })
            })
        ]
    });
}


const $ffb2ddecb0978f79$export$bc3cde56a28b78e3 = ({ vehicle: vehicle })=>{
    const { odometer: odometer, accountNumber: accountNumber, onSuccessVehicleStateUpdate: onSuccessVehicleStateUpdate, onErrorVehicleStateUpdate: onErrorVehicleStateUpdate } = (0, $72ce74282d291ac0$export$a6701c3d6388e341)({
        vehicle: vehicle
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            flexWrap: 'wrap',
            gap: '3rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Color"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: vehicle.exteriorColor || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Make"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: vehicle.make || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Model"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: vehicle.model || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Financier"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: vehicle.financier || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Odometer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: odometer
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "VIN"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            flexDirection: 'row'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                className: "hoverStyle",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8908c22edd89f492$export$2e2bcd8739ae039), {
                                    children: vehicle.vin
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
                                    width: "30",
                                    height: "15",
                                    viewBox: "0 0 10 12",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: "M9.67974 3.98087C9.67974 3.08648 8.95413 2.36087 8.05974 2.36087H6.9024C6.65911 1.51148 5.88216 0.925781 4.99908 0.925781C4.11525 0.925781 3.33829 1.51148 3.09576 2.36087H1.93982C1.04544 2.36087 0.319824 3.08648 0.319824 3.98087V10.4609C0.319824 11.3553 1.04544 12.0809 1.93982 12.0809H8.05981C8.9542 12.0809 9.67981 11.3553 9.67981 10.4609L9.67974 3.98087ZM4.09975 2.90087C4.09975 2.40376 4.50264 2.00087 4.99975 2.00087C5.49685 2.00087 5.89975 2.40376 5.89975 2.90087V3.26087C5.89975 3.30868 5.88076 3.35438 5.84701 3.38813C5.81326 3.42188 5.76756 3.44087 5.71975 3.44087H4.27975C4.18061 3.44087 4.09975 3.36001 4.09975 3.26087V2.90087ZM8.59974 10.4609C8.59974 10.759 8.35786 11.0009 8.05974 11.0009H1.93975C1.64163 11.0009 1.39975 10.759 1.39975 10.4609V3.98087C1.39975 3.68275 1.64163 3.44087 1.93975 3.44087H3.03381C3.12381 4.06032 3.65396 4.52017 4.27975 4.52087H5.71975C6.34553 4.52016 6.87569 4.06032 6.96569 3.44087H8.05974C8.35786 3.44087 8.59974 3.68275 8.59974 3.98087V10.4609Z",
                                        fill: "cyan"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "State"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $861447d3df26b933$export$2e2bcd8739ae039), {
                            vehicleId: vehicle.id,
                            currentVehicleState: vehicle.state,
                            onSuccess: onSuccessVehicleStateUpdate,
                            onError: onErrorVehicleStateUpdate
                        })
                    })
                ]
            }),
            vehicle?.customerId && vehicle?.customerId != '00000000-0000-0000-0000-000000000000' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Assigned To"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                            sx: {
                                fontWeight: 'bold',
                                color: 'rgb(0, 218, 255)'
                            },
                            href: '/customers/' + vehicle.customerId,
                            children: accountNumber
                        })
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
function $37dfa52af4926933$export$2e2bcd8739ae039(element, muiNames) {
    return /*#__PURE__*/ $acw62.isValidElement(element) && muiNames.indexOf(// For server components `muiName` is available in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    element.type.muiName ?? element.type?._payload?.value?.muiName) !== -1;
}









const $6693217541d03f3f$export$f1ce4856483bd995 = (breakpointsKeys, responsiveKeys)=>breakpointsKeys.filter((key)=>responsiveKeys.includes(key));
const $6693217541d03f3f$export$e04173f1577f18b7 = (breakpoints, responsive, iterator)=>{
    const smallestBreakpoint = breakpoints.keys[0]; // the keys is sorted from smallest to largest by `createBreakpoints`.
    if (Array.isArray(responsive)) responsive.forEach((breakpointValue, index)=>{
        iterator((responsiveStyles, style)=>{
            if (index <= breakpoints.keys.length - 1) {
                if (index === 0) Object.assign(responsiveStyles, style);
                else responsiveStyles[breakpoints.up(breakpoints.keys[index])] = style;
            }
        }, breakpointValue);
    });
    else if (responsive && typeof responsive === 'object') {
        // prevent null
        // responsive could be a very big object, pick the smallest responsive values
        const keys = Object.keys(responsive).length > breakpoints.keys.length ? breakpoints.keys : $6693217541d03f3f$export$f1ce4856483bd995(breakpoints.keys, Object.keys(responsive));
        keys.forEach((key)=>{
            if (breakpoints.keys.includes(key)) {
                // @ts-ignore already checked that responsive is an object
                const breakpointValue = responsive[key];
                if (breakpointValue !== undefined) iterator((responsiveStyles, style)=>{
                    if (smallestBreakpoint === key) Object.assign(responsiveStyles, style);
                    else responsiveStyles[breakpoints.up(key)] = style;
                }, breakpointValue);
            }
        });
    } else if (typeof responsive === 'number' || typeof responsive === 'string') iterator((responsiveStyles, style)=>{
        Object.assign(responsiveStyles, style);
    }, responsive);
};


function $30b2f4f9de1f3c09$var$getSelfSpacingVar(axis) {
    return `--Grid-${axis}Spacing`;
}
function $30b2f4f9de1f3c09$var$getParentSpacingVar(axis) {
    return `--Grid-parent-${axis}Spacing`;
}
const $30b2f4f9de1f3c09$var$selfColumnsVar = '--Grid-columns';
const $30b2f4f9de1f3c09$var$parentColumnsVar = '--Grid-parent-columns';
const $30b2f4f9de1f3c09$export$84053369756c53db = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.size, (appendStyle, value)=>{
        let style = {};
        if (value === 'grow') style = {
            flexBasis: 0,
            flexGrow: 1,
            maxWidth: '100%'
        };
        if (value === 'auto') style = {
            flexBasis: 'auto',
            flexGrow: 0,
            flexShrink: 0,
            maxWidth: 'none',
            width: 'auto'
        };
        if (typeof value === 'number') style = {
            flexGrow: 0,
            flexBasis: 'auto',
            width: `calc(100% * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) - (var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) - ${value}) * (var(${$30b2f4f9de1f3c09$var$getParentSpacingVar('column')}) / var(${$30b2f4f9de1f3c09$var$parentColumnsVar})))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$c1d4f281314969c2 = ({ theme: theme, ownerState: ownerState })=>{
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.offset, (appendStyle, value)=>{
        let style = {};
        if (value === 'auto') style = {
            marginLeft: 'auto'
        };
        if (typeof value === 'number') style = {
            marginLeft: value === 0 ? '0px' : `calc(100% * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}) + var(${$30b2f4f9de1f3c09$var$getParentSpacingVar('column')}) * ${value} / var(${$30b2f4f9de1f3c09$var$parentColumnsVar}))`
        };
        appendStyle(styles, style);
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$ccc4d4a4923f1b06 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {
        [$30b2f4f9de1f3c09$var$selfColumnsVar]: 12
    };
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columns, (appendStyle, value)=>{
        const columns = value ?? 12;
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$selfColumnsVar]: columns,
            '> *': {
                [$30b2f4f9de1f3c09$var$parentColumnsVar]: columns
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$68c4dad72dd49c74 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.rowSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$getSelfSpacingVar('row')]: spacing,
            '> *': {
                [$30b2f4f9de1f3c09$var$getParentSpacingVar('row')]: spacing
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$a89c28919b8e3bb5 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.columnSpacing, (appendStyle, value)=>{
        const spacing = typeof value === 'string' ? value : theme.spacing?.(value);
        appendStyle(styles, {
            [$30b2f4f9de1f3c09$var$getSelfSpacingVar('column')]: spacing,
            '> *': {
                [$30b2f4f9de1f3c09$var$getParentSpacingVar('column')]: spacing
            }
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$2a0a3c01032b3f4 = ({ theme: theme, ownerState: ownerState })=>{
    if (!ownerState.container) return {};
    const styles = {};
    (0, $6693217541d03f3f$export$e04173f1577f18b7)(theme.breakpoints, ownerState.direction, (appendStyle, value)=>{
        appendStyle(styles, {
            flexDirection: value
        });
    });
    return styles;
};
const $30b2f4f9de1f3c09$export$810b8c3ab5d46bf = ({ ownerState: ownerState })=>{
    return {
        minWidth: 0,
        boxSizing: 'border-box',
        ...ownerState.container && {
            display: 'flex',
            flexWrap: 'wrap',
            ...ownerState.wrap && ownerState.wrap !== 'wrap' && {
                flexWrap: ownerState.wrap
            },
            gap: `var(${$30b2f4f9de1f3c09$var$getSelfSpacingVar('row')}) var(${$30b2f4f9de1f3c09$var$getSelfSpacingVar('column')})`
        }
    };
};
const $30b2f4f9de1f3c09$export$e2d1175061442d38 = (size)=>{
    const classNames = [];
    Object.entries(size).forEach(([key, value])=>{
        if (value !== false && value !== undefined) classNames.push(`grid-${key}-${String(value)}`);
    });
    return classNames;
};
const $30b2f4f9de1f3c09$export$6c7087d27c3329d3 = (spacing, smallestBreakpoint = 'xs')=>{
    function isValidSpacing(val) {
        if (val === undefined) return false;
        return typeof val === 'string' && !Number.isNaN(Number(val)) || typeof val === 'number' && val > 0;
    }
    if (isValidSpacing(spacing)) return [
        `spacing-${smallestBreakpoint}-${String(spacing)}`
    ];
    if (typeof spacing === 'object' && !Array.isArray(spacing)) {
        const classNames = [];
        Object.entries(spacing).forEach(([key, value])=>{
            if (isValidSpacing(value)) classNames.push(`spacing-${key}-${String(value)}`);
        });
        return classNames;
    }
    return [];
};
const $30b2f4f9de1f3c09$export$a7c8efbe2b138a60 = (direction)=>{
    if (direction === undefined) return [];
    if (typeof direction === 'object') return Object.entries(direction).map(([key, value])=>`direction-${key}-${value}`);
    return [
        `direction-xs-${String(direction)}`
    ];
};


const $36a42d20d006905e$var$getLegacyGridWarning = (propName)=>{
    if ([
        'item',
        'zeroMinWidth'
    ].includes(propName)) return `The \`${propName}\` prop has been removed and is no longer necessary. You can safely remove it.`;
    // #host-reference
    return `The \`${propName}\` prop has been removed. See https://mui.com/material-ui/migration/upgrade-to-grid-v2/ for migration instructions.`;
};
const $36a42d20d006905e$var$warnedAboutProps = [];
function $36a42d20d006905e$export$2e2bcd8739ae039(props, breakpoints) {
    const propsToWarn = [];
    if (props.item !== undefined) {
        delete props.item;
        propsToWarn.push('item');
    }
    if (props.zeroMinWidth !== undefined) {
        delete props.zeroMinWidth;
        propsToWarn.push('zeroMinWidth');
    }
    breakpoints.keys.forEach((breakpoint)=>{
        if (props[breakpoint] !== undefined) {
            propsToWarn.push(breakpoint);
            delete props[breakpoint];
        }
    });
    var prop;
}



'use client';
const $71d3dec7f204ed17$var$defaultTheme = (0, $4a66cd95e497efc7$export$2e2bcd8739ae039)();
// widening Theme to any so that the consumer can own the theme structure.
const $71d3dec7f204ed17$var$defaultCreateStyledComponent = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiGrid',
    slot: 'Root'
});
function $71d3dec7f204ed17$var$useThemePropsDefault(props) {
    return (0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: props,
        name: 'MuiGrid',
        defaultTheme: $71d3dec7f204ed17$var$defaultTheme
    });
}
function $71d3dec7f204ed17$export$2e2bcd8739ae039(options = {}) {
    const { createStyledComponent: // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent = $71d3dec7f204ed17$var$defaultCreateStyledComponent, useThemeProps: useThemeProps = $71d3dec7f204ed17$var$useThemePropsDefault, useTheme: useTheme = (0, $ac16d208682bdb3f$export$2e2bcd8739ae039), componentName: componentName = 'MuiGrid' } = options;
    const useUtilityClasses = (ownerState, theme)=>{
        const { container: container, direction: direction, spacing: spacing, wrap: wrap, size: size } = ownerState;
        const slots = {
            root: [
                'root',
                container && 'container',
                wrap !== 'wrap' && `wrap-xs-${String(wrap)}`,
                ...(0, $30b2f4f9de1f3c09$export$a7c8efbe2b138a60)(direction),
                ...(0, $30b2f4f9de1f3c09$export$e2d1175061442d38)(size),
                ...container ? (0, $30b2f4f9de1f3c09$export$6c7087d27c3329d3)(spacing, theme.breakpoints.keys[0]) : []
            ]
        };
        return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (slot)=>(0, $35cd7d64717698f7$export$2e2bcd8739ae039)(componentName, slot), {});
    };
    function parseResponsiveProp(propValue, breakpoints, shouldUseValue = ()=>true) {
        const parsedProp = {};
        if (propValue === null) return parsedProp;
        if (Array.isArray(propValue)) propValue.forEach((value, index)=>{
            if (value !== null && shouldUseValue(value) && breakpoints.keys[index]) parsedProp[breakpoints.keys[index]] = value;
        });
        else if (typeof propValue === 'object') Object.keys(propValue).forEach((key)=>{
            const value = propValue[key];
            if (value !== null && value !== undefined && shouldUseValue(value)) parsedProp[key] = value;
        });
        else parsedProp[breakpoints.keys[0]] = propValue;
        return parsedProp;
    }
    const GridRoot = createStyledComponent((0, $30b2f4f9de1f3c09$export$ccc4d4a4923f1b06), (0, $30b2f4f9de1f3c09$export$a89c28919b8e3bb5), (0, $30b2f4f9de1f3c09$export$68c4dad72dd49c74), (0, $30b2f4f9de1f3c09$export$84053369756c53db), (0, $30b2f4f9de1f3c09$export$2a0a3c01032b3f4), (0, $30b2f4f9de1f3c09$export$810b8c3ab5d46bf), (0, $30b2f4f9de1f3c09$export$c1d4f281314969c2));
    const Grid = /*#__PURE__*/ $acw62.forwardRef(function Grid(inProps, ref) {
        const theme = useTheme();
        const themeProps = useThemeProps(inProps);
        const props = (0, $c85eb76b78f8a14c$export$2e2bcd8739ae039)(themeProps); // `color` type conflicts with html color attribute.
        // TODO v8: Remove when removing the legacy Grid component
        (0, $36a42d20d006905e$export$2e2bcd8739ae039)(props, theme.breakpoints);
        const { className: className, children: children, columns: columnsProp = 12, container: container = false, component: component = 'div', direction: direction = 'row', wrap: wrap = 'wrap', size: sizeProp = {}, offset: offsetProp = {}, spacing: spacingProp = 0, rowSpacing: rowSpacingProp = spacingProp, columnSpacing: columnSpacingProp = spacingProp, unstable_level: level = 0, ...other } = props;
        const size = parseResponsiveProp(sizeProp, theme.breakpoints, (val)=>val !== false);
        const offset = parseResponsiveProp(offsetProp, theme.breakpoints);
        const columns = inProps.columns ?? (level ? undefined : columnsProp);
        const spacing = inProps.spacing ?? (level ? undefined : spacingProp);
        const rowSpacing = inProps.rowSpacing ?? inProps.spacing ?? (level ? undefined : rowSpacingProp);
        const columnSpacing = inProps.columnSpacing ?? inProps.spacing ?? (level ? undefined : columnSpacingProp);
        const ownerState = {
            ...props,
            level: level,
            columns: columns,
            container: container,
            direction: direction,
            wrap: wrap,
            spacing: spacing,
            rowSpacing: rowSpacing,
            columnSpacing: columnSpacing,
            size: size,
            offset: offset
        };
        const classes = useUtilityClasses(ownerState, theme);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(GridRoot, {
            ref: ref,
            as: component,
            ownerState: ownerState,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ...other,
            children: $acw62.Children.map(children, (child)=>{
                if (/*#__PURE__*/ $acw62.isValidElement(child) && (0, $37dfa52af4926933$export$2e2bcd8739ae039)(child, [
                    'Grid'
                ]) && container && child.props.container) return /*#__PURE__*/ $acw62.cloneElement(child, {
                    unstable_level: child.props?.unstable_level ?? level + 1
                });
                return child;
            })
        });
    });
    // @ts-ignore internal logic for nested grid
    Grid.muiName = 'Grid';
    return Grid;
}






'use client';
/**
 *
 * Demos:
 *
 * - [Grid](https://mui.com/material-ui/react-grid/)
 *
 * API:
 *
 * - [Grid API](https://mui.com/material-ui/api/grid/)
 */ const $a2c903eb2263b589$var$Grid = (0, $71d3dec7f204ed17$export$2e2bcd8739ae039)({
    createStyledComponent: (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
        name: 'MuiGrid',
        slot: 'Root',
        overridesResolver: (props, styles)=>{
            const { ownerState: ownerState } = props;
            return [
                styles.root,
                ownerState.container && styles.container
            ];
        }
    }),
    componentName: 'MuiGrid',
    useThemeProps: (inProps)=>(0, $1bc4906ad0338fb8$export$2440da353cedad43)({
            props: inProps,
            name: 'MuiGrid'
        }),
    useTheme: $81976569638fc3b7$export$2e2bcd8739ae039
});
var $a2c903eb2263b589$export$2e2bcd8739ae039 = $a2c903eb2263b589$var$Grid;


var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function $7cf4d6c2077a48de$export$2e2bcd8739ae039(func, wait = 166) {
    let timeout;
    function debounced(...args) {
        const later = ()=>{
            // @ts-ignore
            func.apply(this, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    }
    debounced.clear = ()=>{
        clearTimeout(timeout);
    };
    return debounced;
}







'use client';
function $2bf53bc833721b52$var$getStyleValue(value) {
    return parseInt(value, 10) || 0;
}
const $2bf53bc833721b52$var$styles = {
    shadow: {
        // Visibility needed to hide the extra text area on iPads
        visibility: 'hidden',
        // Remove from the content flow
        position: 'absolute',
        // Ignore the scrollbar width
        overflow: 'hidden',
        height: 0,
        top: 0,
        left: 0,
        // Create a new layer, increase the isolation of the computed values
        transform: 'translateZ(0)'
    }
};
function $2bf53bc833721b52$var$isObjectEmpty(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}
function $2bf53bc833721b52$var$isEmpty(obj) {
    return $2bf53bc833721b52$var$isObjectEmpty(obj) || obj.outerHeightStyle === 0 && !obj.overflowing;
}
/**
 *
 * Demos:
 *
 * - [Textarea Autosize](https://mui.com/material-ui/react-textarea-autosize/)
 *
 * API:
 *
 * - [TextareaAutosize API](https://mui.com/material-ui/api/textarea-autosize/)
 */ const $2bf53bc833721b52$var$TextareaAutosize = /*#__PURE__*/ $acw62.forwardRef(function TextareaAutosize(props, forwardedRef) {
    const { onChange: onChange, maxRows: maxRows, minRows: minRows = 1, style: style, value: value, ...other } = props;
    const { current: isControlled } = $acw62.useRef(value != null);
    const textareaRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(forwardedRef, textareaRef);
    const heightRef = $acw62.useRef(null);
    const hiddenTextareaRef = $acw62.useRef(null);
    const calculateTextareaStyles = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const hiddenTextarea = hiddenTextareaRef.current;
        if (!textarea || !hiddenTextarea) return undefined;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(textarea);
        const computedStyle = containerWindow.getComputedStyle(textarea);
        // If input's width is shrunk and it's not visible, don't sync height.
        if (computedStyle.width === '0px') return {
            outerHeightStyle: 0,
            overflowing: false
        };
        hiddenTextarea.style.width = computedStyle.width;
        hiddenTextarea.value = textarea.value || props.placeholder || 'x';
        if (hiddenTextarea.value.slice(-1) === '\n') // Certain fonts which overflow the line height will cause the textarea
        // to report a different scrollHeight depending on whether the last line
        // is empty. Make it non-empty to avoid this issue.
        hiddenTextarea.value += ' ';
        const boxSizing = computedStyle.boxSizing;
        const padding = $2bf53bc833721b52$var$getStyleValue(computedStyle.paddingBottom) + $2bf53bc833721b52$var$getStyleValue(computedStyle.paddingTop);
        const border = $2bf53bc833721b52$var$getStyleValue(computedStyle.borderBottomWidth) + $2bf53bc833721b52$var$getStyleValue(computedStyle.borderTopWidth);
        // The height of the inner content
        const innerHeight = hiddenTextarea.scrollHeight;
        // Measure height of a textarea with a single row
        hiddenTextarea.value = 'x';
        const singleRowHeight = hiddenTextarea.scrollHeight;
        // The height of the outer content
        let outerHeight = innerHeight;
        if (minRows) outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
        if (maxRows) outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
        outerHeight = Math.max(outerHeight, singleRowHeight);
        // Take the box sizing into account for applying this value as a style.
        const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
        const overflowing = Math.abs(outerHeight - innerHeight) <= 1;
        return {
            outerHeightStyle: outerHeightStyle,
            overflowing: overflowing
        };
    }, [
        maxRows,
        minRows,
        props.placeholder
    ]);
    const didHeightChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $2bf53bc833721b52$var$isEmpty(textareaStyles)) return false;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        return heightRef.current != null && heightRef.current !== outerHeightStyle;
    });
    const syncHeight = $acw62.useCallback(()=>{
        const textarea = textareaRef.current;
        const textareaStyles = calculateTextareaStyles();
        if (!textarea || !textareaStyles || $2bf53bc833721b52$var$isEmpty(textareaStyles)) return;
        const outerHeightStyle = textareaStyles.outerHeightStyle;
        if (heightRef.current !== outerHeightStyle) {
            heightRef.current = outerHeightStyle;
            textarea.style.height = `${outerHeightStyle}px`;
        }
        textarea.style.overflow = textareaStyles.overflowing ? 'hidden' : '';
    }, [
        calculateTextareaStyles
    ]);
    const frameRef = $acw62.useRef(-1);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const debouncedHandleResize = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039)(syncHeight);
        const textarea = textareaRef?.current;
        if (!textarea) return undefined;
        const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(textarea);
        containerWindow.addEventListener('resize', debouncedHandleResize);
        let resizeObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(()=>{
                if (didHeightChange()) {
                    // avoid "ResizeObserver loop completed with undelivered notifications" error
                    // by temporarily unobserving the textarea element while manipulating the height
                    // and reobserving one frame later
                    resizeObserver.unobserve(textarea);
                    cancelAnimationFrame(frameRef.current);
                    syncHeight();
                    frameRef.current = requestAnimationFrame(()=>{
                        resizeObserver.observe(textarea);
                    });
                }
            });
            resizeObserver.observe(textarea);
        }
        return ()=>{
            debouncedHandleResize.clear();
            cancelAnimationFrame(frameRef.current);
            containerWindow.removeEventListener('resize', debouncedHandleResize);
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        calculateTextareaStyles,
        syncHeight,
        didHeightChange
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        syncHeight();
    });
    const handleChange = (event)=>{
        if (!isControlled) syncHeight();
        const textarea = event.target;
        const countOfCharacters = textarea.value.length;
        const isLastCharacterNewLine = textarea.value.endsWith('\n');
        const isEndOfTheLine = textarea.selectionStart === countOfCharacters;
        // Set the cursor position to the very end of the text.
        if (isLastCharacterNewLine && isEndOfTheLine) textarea.setSelectionRange(countOfCharacters, countOfCharacters);
        if (onChange) onChange(event);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                value: value,
                onChange: handleChange,
                ref: handleRef,
                rows: minRows,
                style: style,
                ...other
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                "aria-hidden": true,
                className: props.className,
                readOnly: true,
                ref: hiddenTextareaRef,
                tabIndex: -1,
                style: {
                    ...$2bf53bc833721b52$var$styles.shadow,
                    ...style,
                    paddingTop: 0,
                    paddingBottom: 0
                }
            })
        ]
    });
});
var $2bf53bc833721b52$export$2e2bcd8739ae039 = $2bf53bc833721b52$var$TextareaAutosize;


function $23f47324c549140d$export$2e2bcd8739ae039({ props: props, states: states, muiFormControl: muiFormControl }) {
    return states.reduce((acc, state)=>{
        acc[state] = props[state];
        if (muiFormControl) {
            if (typeof props[state] === 'undefined') acc[state] = muiFormControl[state];
        }
        return acc;
    }, {});
}



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $c51e307705f35677$var$FormControlContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $c51e307705f35677$export$2e2bcd8739ae039 = $c51e307705f35677$var$FormControlContext;



var $acw62 = parcelRequire("acw62");

'use client';
function $343072e2ec7ced8d$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $c51e307705f35677$export$2e2bcd8739ae039));
}








// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function $beb6670688e6a4c6$export$96bdbc84526f3739(value) {
    return value != null && !(Array.isArray(value) && value.length === 0);
}
function $beb6670688e6a4c6$export$d652b828d7fdeff8(obj, SSR = false) {
    return obj && ($beb6670688e6a4c6$export$96bdbc84526f3739(obj.value) && obj.value !== '' || SSR && $beb6670688e6a4c6$export$96bdbc84526f3739(obj.defaultValue) && obj.defaultValue !== '');
}
function $beb6670688e6a4c6$export$1b68bdfa56faeb5d(obj) {
    return obj.startAdornment;
}




function $587a42eced554844$export$ef57d5c8ca2278f6(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiInputBase', slot);
}
const $587a42eced554844$var$inputBaseClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiInputBase', [
    'root',
    'formControl',
    'focused',
    'disabled',
    'adornedStart',
    'adornedEnd',
    'error',
    'sizeSmall',
    'multiline',
    'colorSecondary',
    'fullWidth',
    'hiddenLabel',
    'readOnly',
    'input',
    'inputSizeSmall',
    'inputMultiline',
    'inputTypeSearch',
    'inputAdornedStart',
    'inputAdornedEnd',
    'inputHiddenLabel'
]);
var $587a42eced554844$export$2e2bcd8739ae039 = $587a42eced554844$var$inputBaseClasses;



'use client';
var $810f5d6293d4467f$var$_InputGlobalStyles;
const $810f5d6293d4467f$export$965edad20a84fa75 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.formControl && styles.formControl,
        ownerState.startAdornment && styles.adornedStart,
        ownerState.endAdornment && styles.adornedEnd,
        ownerState.error && styles.error,
        ownerState.size === 'small' && styles.sizeSmall,
        ownerState.multiline && styles.multiline,
        ownerState.color && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
        ownerState.fullWidth && styles.fullWidth,
        ownerState.hiddenLabel && styles.hiddenLabel
    ];
};
const $810f5d6293d4467f$export$cf507b112810e72d = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.input,
        ownerState.size === 'small' && styles.inputSizeSmall,
        ownerState.multiline && styles.inputMultiline,
        ownerState.type === 'search' && styles.inputTypeSearch,
        ownerState.startAdornment && styles.inputAdornedStart,
        ownerState.endAdornment && styles.inputAdornedEnd,
        ownerState.hiddenLabel && styles.inputHiddenLabel
    ];
};
const $810f5d6293d4467f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disabled: disabled, error: error, endAdornment: endAdornment, focused: focused, formControl: formControl, fullWidth: fullWidth, hiddenLabel: hiddenLabel, multiline: multiline, readOnly: readOnly, size: size, startAdornment: startAdornment, type: type } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            fullWidth && 'fullWidth',
            focused && 'focused',
            formControl && 'formControl',
            size && size !== 'medium' && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            multiline && 'multiline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            hiddenLabel && 'hiddenLabel',
            readOnly && 'readOnly'
        ],
        input: [
            'input',
            disabled && 'disabled',
            type === 'search' && 'inputTypeSearch',
            multiline && 'inputMultiline',
            size === 'small' && 'inputSizeSmall',
            hiddenLabel && 'inputHiddenLabel',
            startAdornment && 'inputAdornedStart',
            endAdornment && 'inputAdornedEnd',
            readOnly && 'readOnly'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $587a42eced554844$export$ef57d5c8ca2278f6), classes);
};
const $810f5d6293d4467f$export$298a043133d72a38 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputBase',
    slot: 'Root',
    overridesResolver: $810f5d6293d4467f$export$965edad20a84fa75
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        color: (theme.vars || theme).palette.text.primary,
        lineHeight: '1.4375em',
        // 23px
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        position: 'relative',
        cursor: 'text',
        display: 'inline-flex',
        alignItems: 'center',
        [`&.${(0, $587a42eced554844$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled,
            cursor: 'default'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '4px 0 5px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: '100%'
                }
            }
        ]
    })));
const $810f5d6293d4467f$export$ee10465db6ff6017 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('input', {
    name: 'MuiInputBase',
    slot: 'Input',
    overridesResolver: $810f5d6293d4467f$export$cf507b112810e72d
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const placeholder = {
        color: 'currentColor',
        ...theme.vars ? {
            opacity: theme.vars.opacity.inputPlaceholder
        } : {
            opacity: light ? 0.42 : 0.5
        },
        transition: theme.transitions.create('opacity', {
            duration: theme.transitions.duration.shorter
        })
    };
    const placeholderHidden = {
        opacity: '0 !important'
    };
    const placeholderVisible = theme.vars ? {
        opacity: theme.vars.opacity.inputPlaceholder
    } : {
        opacity: light ? 0.42 : 0.5
    };
    return {
        font: 'inherit',
        letterSpacing: 'inherit',
        color: 'currentColor',
        padding: '4px 0 5px',
        border: 0,
        boxSizing: 'content-box',
        background: 'none',
        height: '1.4375em',
        // Reset 23pxthe native input line-height
        margin: 0,
        // Reset for Safari
        WebkitTapHighlightColor: 'transparent',
        display: 'block',
        // Make the flex item shrink with Firefox
        minWidth: 0,
        width: '100%',
        '&::-webkit-input-placeholder': placeholder,
        '&::-moz-placeholder': placeholder,
        // Firefox 19+
        '&::-ms-input-placeholder': placeholder,
        // Edge
        '&:focus': {
            outline: 0
        },
        // Reset Firefox invalid required input style
        '&:invalid': {
            boxShadow: 'none'
        },
        '&::-webkit-search-decoration': {
            // Remove the padding when type=search.
            WebkitAppearance: 'none'
        },
        // Show and hide the placeholder logic
        [`label[data-shrink=false] + .${(0, $587a42eced554844$export$2e2bcd8739ae039).formControl} &`]: {
            '&::-webkit-input-placeholder': placeholderHidden,
            '&::-moz-placeholder': placeholderHidden,
            // Firefox 19+
            '&::-ms-input-placeholder': placeholderHidden,
            // Edge
            '&:focus::-webkit-input-placeholder': placeholderVisible,
            '&:focus::-moz-placeholder': placeholderVisible,
            // Firefox 19+
            '&:focus::-ms-input-placeholder': placeholderVisible // Edge
        },
        [`&.${(0, $587a42eced554844$export$2e2bcd8739ae039).disabled}`]: {
            opacity: 1,
            // Reset iOS opacity
            WebkitTextFillColor: (theme.vars || theme).palette.text.disabled // Fix opacity Safari bug
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInjectingGlobalStyles,
                style: {
                    animationName: 'mui-auto-fill-cancel',
                    animationDuration: '10ms',
                    '&:-webkit-autofill': {
                        animationDuration: '5000s',
                        animationName: 'mui-auto-fill'
                    }
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    height: 'auto',
                    resize: 'none',
                    padding: 0,
                    paddingTop: 0
                }
            },
            {
                props: {
                    type: 'search'
                },
                style: {
                    MozAppearance: 'textfield' // Improve type search style.
                }
            }
        ]
    };
}));
const $810f5d6293d4467f$var$InputGlobalStyles = (0, $76e91e24afb64923$export$db53682eef82cc11)({
    '@keyframes mui-auto-fill': {
        from: {
            display: 'block'
        }
    },
    '@keyframes mui-auto-fill-cancel': {
        from: {
            display: 'block'
        }
    }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */ const $810f5d6293d4467f$var$InputBase = /*#__PURE__*/ $acw62.forwardRef(function InputBase(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputBase'
    });
    const { 'aria-describedby': ariaDescribedby, autoComplete: autoComplete, autoFocus: autoFocus, className: className, color: color, components: components = {}, componentsProps: componentsProps = {}, defaultValue: defaultValue, disabled: disabled, disableInjectingGlobalStyles: disableInjectingGlobalStyles, endAdornment: endAdornment, error: error, fullWidth: fullWidth = false, id: id, inputComponent: inputComponent = 'input', inputProps: inputPropsProp = {}, inputRef: inputRefProp, margin: margin, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, placeholder: placeholder, readOnly: readOnly, renderSuffix: renderSuffix, rows: rows, size: size, slotProps: slotProps = {}, slots: slots = {}, startAdornment: startAdornment, type: type = 'text', value: valueProp, ...other } = props;
    const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
    const { current: isControlled } = $acw62.useRef(value != null);
    const inputRef = $acw62.useRef();
    const handleInputRefWarning = $acw62.useCallback((instance)=>{}, []);
    const handleInputRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(inputRef, inputRefProp, inputPropsProp.ref, handleInputRefWarning);
    const [focused, setFocused] = $acw62.useState(false);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'hiddenLabel',
            'size',
            'required',
            'filled'
        ]
    });
    fcs.focused = muiFormControl ? muiFormControl.focused : focused;
    // The blur won't fire when the disabled state is set on a focused input.
    // We need to book keep the focused state manually.
    $acw62.useEffect(()=>{
        if (!muiFormControl && disabled && focused) {
            setFocused(false);
            if (onBlur) onBlur();
        }
    }, [
        muiFormControl,
        disabled,
        focused,
        onBlur
    ]);
    const onFilled = muiFormControl && muiFormControl.onFilled;
    const onEmpty = muiFormControl && muiFormControl.onEmpty;
    const checkDirty = $acw62.useCallback((obj)=>{
        if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)(obj)) {
            if (onFilled) onFilled();
        } else if (onEmpty) onEmpty();
    }, [
        onFilled,
        onEmpty
    ]);
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        if (isControlled) checkDirty({
            value: value
        });
    }, [
        value,
        checkDirty,
        isControlled
    ]);
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (inputPropsProp.onFocus) inputPropsProp.onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
        else setFocused(true);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (inputPropsProp.onBlur) inputPropsProp.onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
        else setFocused(false);
    };
    const handleChange = (event, ...args)=>{
        if (!isControlled) {
            const element = event.target || inputRef.current;
            if (element == null) throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(1));
            checkDirty({
                value: element.value
            });
        }
        if (inputPropsProp.onChange) inputPropsProp.onChange(event, ...args);
        // Perform in the willUpdate
        if (onChange) onChange(event, ...args);
    };
    // Check the input state on mount, in case it was filled by the user
    // or auto filled by the browser before the hydration (for SSR).
    $acw62.useEffect(()=>{
        checkDirty(inputRef.current);
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const handleClick = (event)=>{
        if (inputRef.current && event.currentTarget === event.target) inputRef.current.focus();
        if (onClick) onClick(event);
    };
    let InputComponent = inputComponent;
    let inputProps = inputPropsProp;
    if (multiline && InputComponent === 'input') {
        if (rows) inputProps = {
            type: undefined,
            minRows: rows,
            maxRows: rows,
            ...inputProps
        };
        else inputProps = {
            type: undefined,
            maxRows: maxRows,
            minRows: minRows,
            ...inputProps
        };
        InputComponent = (0, $2bf53bc833721b52$export$2e2bcd8739ae039);
    }
    const handleAutoFill = (event)=>{
        // Provide a fake value as Chrome might not let you access it for security reasons.
        checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
            value: 'x'
        });
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        endAdornment: endAdornment,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        startAdornment: startAdornment,
        type: type
    };
    const classes = $810f5d6293d4467f$var$useUtilityClasses(ownerState);
    const Root = slots.root || components.Root || $810f5d6293d4467f$export$298a043133d72a38;
    const rootProps = slotProps.root || componentsProps.root || {};
    const Input = slots.input || components.Input || $810f5d6293d4467f$export$ee10465db6ff6017;
    inputProps = {
        ...inputProps,
        ...slotProps.input ?? componentsProps.input
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            !disableInjectingGlobalStyles && typeof $810f5d6293d4467f$var$InputGlobalStyles === 'function' && // For Pigment CSS, this has no effect because the InputGlobalStyles will be null.
            ($810f5d6293d4467f$var$_InputGlobalStyles || ($810f5d6293d4467f$var$_InputGlobalStyles = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($810f5d6293d4467f$var$InputGlobalStyles, {}))),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Root, {
                ...rootProps,
                ref: ref,
                onClick: handleClick,
                ...other,
                ...!(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                    ownerState: {
                        ...ownerState,
                        ...rootProps.ownerState
                    }
                },
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, rootProps.className, className, readOnly && 'MuiInputBase-readOnly'),
                children: [
                    startAdornment,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
                        value: null,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Input, {
                            "aria-invalid": fcs.error,
                            "aria-describedby": ariaDescribedby,
                            autoComplete: autoComplete,
                            autoFocus: autoFocus,
                            defaultValue: defaultValue,
                            disabled: fcs.disabled,
                            id: id,
                            onAnimationStart: handleAutoFill,
                            name: name,
                            placeholder: placeholder,
                            readOnly: readOnly,
                            required: fcs.required,
                            rows: rows,
                            value: value,
                            onKeyDown: onKeyDown,
                            onKeyUp: onKeyUp,
                            type: type,
                            ...inputProps,
                            ...!(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Input) && {
                                as: InputComponent,
                                ownerState: {
                                    ...ownerState,
                                    ...inputProps.ownerState
                                }
                            },
                            ref: handleInputRef,
                            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.input, inputProps.className, readOnly && 'MuiInputBase-readOnly'),
                            onBlur: handleBlur,
                            onChange: handleChange,
                            onFocus: handleFocus
                        })
                    }),
                    endAdornment,
                    renderSuffix ? renderSuffix({
                        ...fcs,
                        startAdornment: startAdornment
                    }) : null
                ]
            })
        ]
    });
});
var $810f5d6293d4467f$export$2e2bcd8739ae039 = $810f5d6293d4467f$var$InputBase;










function $4e32f80fb9096d1f$export$cdb270390122322b(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiInput', slot);
}
const $4e32f80fb9096d1f$var$inputClasses = {
    ...(0, $587a42eced554844$export$2e2bcd8739ae039),
    ...(0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiInput', [
        'root',
        'underline',
        'input'
    ])
};
var $4e32f80fb9096d1f$export$2e2bcd8739ae039 = $4e32f80fb9096d1f$var$inputClasses;




'use client';
const $3745a2c6ea1264ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $4e32f80fb9096d1f$export$cdb270390122322b), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $3745a2c6ea1264ac$var$InputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $810f5d6293d4467f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline);
    return {
        position: 'relative',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    'label + &': {
                        marginTop: 16
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).disabled}, .${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                }))
        ]
    };
}));
const $3745a2c6ea1264ac$var$InputInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$ee10465db6ff6017), {
    name: 'MuiInput',
    slot: 'Input',
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})({});
const $3745a2c6ea1264ac$var$Input = /*#__PURE__*/ $acw62.forwardRef(function Input(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const classes = $3745a2c6ea1264ac$var$useUtilityClasses(props);
    const ownerState = {
        disableUnderline: disableUnderline
    };
    const inputComponentsProps = {
        root: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $2985df77ba145d35$export$2e2bcd8739ae039)(slotProps ?? componentsPropsProp, inputComponentsProps) : inputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $3745a2c6ea1264ac$var$InputRoot;
    const InputSlot = slots.input ?? components.Input ?? $3745a2c6ea1264ac$var$InputInput;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$3745a2c6ea1264ac$var$Input.muiName = 'Input';
var $3745a2c6ea1264ac$export$2e2bcd8739ae039 = $3745a2c6ea1264ac$var$Input;



var $acw62 = parcelRequire("acw62");













function $5ba40350513245a8$export$3331e419f1a48437(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiFilledInput', slot);
}
const $5ba40350513245a8$var$filledInputClasses = {
    ...(0, $587a42eced554844$export$2e2bcd8739ae039),
    ...(0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiFilledInput', [
        'root',
        'underline',
        'input',
        'adornedStart',
        'adornedEnd',
        'sizeSmall',
        'multiline',
        'hiddenLabel'
    ])
};
var $5ba40350513245a8$export$2e2bcd8739ae039 = $5ba40350513245a8$var$filledInputClasses;





'use client';
const $215c05c02ba2f8f4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableUnderline: disableUnderline, startAdornment: startAdornment, endAdornment: endAdornment, size: size, hiddenLabel: hiddenLabel, multiline: multiline } = ownerState;
    const slots = {
        root: [
            'root',
            !disableUnderline && 'underline',
            startAdornment && 'adornedStart',
            endAdornment && 'adornedEnd',
            size === 'small' && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            hiddenLabel && 'hiddenLabel',
            multiline && 'multiline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $5ba40350513245a8$export$3331e419f1a48437), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $215c05c02ba2f8f4$var$FilledInputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiFilledInput',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            ...(0, $810f5d6293d4467f$export$965edad20a84fa75)(props, styles),
            !ownerState.disableUnderline && styles.underline
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        position: 'relative',
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableUnderline,
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).error}`]: {
                        '&::before, &::after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, theme.vars.opacity.inputUnderline) : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}, .${(0, $5ba40350513245a8$export$2e2bcd8739ae039).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $5ba40350513245a8$export$2e2bcd8739ae039).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        disableUnderline: false,
                        color: color
                    },
                    style: {
                        '&::after': {
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 12
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '25px 12px 8px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline && ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            }
        ]
    };
}));
const $215c05c02ba2f8f4$var$FilledInputInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$ee10465db6ff6017), {
    name: 'MuiFilledInput',
    slot: 'Input',
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        paddingTop: 25,
        paddingRight: 12,
        paddingBottom: 8,
        paddingLeft: 12,
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderTopLeftRadius: 'inherit',
                borderTopRightRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    paddingTop: 21,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel,
                style: {
                    paddingTop: 16,
                    paddingBottom: 17
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hiddenLabel && ownerState.size === 'small',
                style: {
                    paddingTop: 8,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: 0,
                    paddingRight: 0
                }
            }
        ]
    })));
const $215c05c02ba2f8f4$var$FilledInput = /*#__PURE__*/ $acw62.forwardRef(function FilledInput(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFilledInput'
    });
    const { disableUnderline: disableUnderline = false, components: components = {}, componentsProps: componentsPropsProp, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel, inputComponent: // declare here to prevent spreading to DOM
    inputComponent = 'input', multiline: multiline = false, slotProps: slotProps, slots: slots = {}, type: type = 'text', ...other } = props;
    const ownerState = {
        ...props,
        disableUnderline: disableUnderline,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        type: type
    };
    const classes = $215c05c02ba2f8f4$var$useUtilityClasses(props);
    const filledInputComponentsProps = {
        root: {
            ownerState: ownerState
        },
        input: {
            ownerState: ownerState
        }
    };
    const componentsProps = slotProps ?? componentsPropsProp ? (0, $2985df77ba145d35$export$2e2bcd8739ae039)(filledInputComponentsProps, slotProps ?? componentsPropsProp) : filledInputComponentsProps;
    const RootSlot = slots.root ?? components.Root ?? $215c05c02ba2f8f4$var$FilledInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $215c05c02ba2f8f4$var$FilledInputInput;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: componentsProps,
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: classes
    });
});
$215c05c02ba2f8f4$var$FilledInput.muiName = 'Input';
var $215c05c02ba2f8f4$export$2e2bcd8739ae039 = $215c05c02ba2f8f4$var$FilledInput;



var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");





'use client';
var $908e29d7221628c4$var$_span;
const $908e29d7221628c4$var$NotchedOutlineRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039)
})({
    textAlign: 'left',
    position: 'absolute',
    bottom: 0,
    right: 0,
    top: -5,
    left: 0,
    margin: 0,
    padding: '0 8px',
    pointerEvents: 'none',
    borderRadius: 'inherit',
    borderStyle: 'solid',
    borderWidth: 1,
    overflow: 'hidden',
    minWidth: '0%'
});
const $908e29d7221628c4$var$NotchedOutlineLegend = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('legend', {
    name: 'MuiNotchedOutlined',
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039)
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.withLabel,
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel,
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.withLabel && ownerState.notched,
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    })));
function $908e29d7221628c4$export$2e2bcd8739ae039(props) {
    const { children: children, classes: classes, className: className, label: label, notched: notched, ...other } = props;
    const withLabel = label != null && label !== '';
    const ownerState = {
        ...props,
        notched: notched,
        withLabel: withLabel
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($908e29d7221628c4$var$NotchedOutlineRoot, {
        "aria-hidden": true,
        className: className,
        ownerState: ownerState,
        ...other,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($908e29d7221628c4$var$NotchedOutlineLegend, {
            ownerState: ownerState,
            children: withLabel ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: label
            }) : $908e29d7221628c4$var$_span || ($908e29d7221628c4$var$_span = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "notranslate",
                "aria-hidden": true,
                children: "\u200B"
            }))
        })
    });
}












function $64077992b1d8b572$export$89922944c7227687(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiOutlinedInput', slot);
}
const $64077992b1d8b572$var$outlinedInputClasses = {
    ...(0, $587a42eced554844$export$2e2bcd8739ae039),
    ...(0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiOutlinedInput', [
        'root',
        'notchedOutline',
        'input'
    ])
};
var $64077992b1d8b572$export$2e2bcd8739ae039 = $64077992b1d8b572$var$outlinedInputClasses;





'use client';
const $fe946640f9150f45$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $64077992b1d8b572$export$89922944c7227687), classes);
    return {
        ...classes,
        // forward classes to the InputBase
        ...composedClasses
    };
};
const $fe946640f9150f45$var$OutlinedInputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$298a043133d72a38), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiOutlinedInput',
    slot: 'Root',
    overridesResolver: (0, $810f5d6293d4467f$export$965edad20a84fa75)
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        position: 'relative',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
            }
        },
        [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).focused} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
            borderWidth: 2
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).focused} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                            borderColor: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                // to override the above style
                style: {
                    [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).error} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.error.main
                    },
                    [`&.${(0, $64077992b1d8b572$export$2e2bcd8739ae039).disabled} .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).notchedOutline}`]: {
                        borderColor: (theme.vars || theme).palette.action.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 14
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: '16.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState, size: size })=>ownerState.multiline && size === 'small',
                style: {
                    padding: '8.5px 14px'
                }
            }
        ]
    };
}));
const $fe946640f9150f45$var$NotchedOutlineRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $908e29d7221628c4$export$2e2bcd8739ae039), {
    name: 'MuiOutlinedInput',
    slot: 'NotchedOutline'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        borderColor: theme.vars ? theme.alpha(theme.vars.palette.common.onBackground, 0.23) : borderColor
    };
}));
const $fe946640f9150f45$var$OutlinedInputInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $810f5d6293d4467f$export$ee10465db6ff6017), {
    name: 'MuiOutlinedInput',
    slot: 'Input',
    overridesResolver: (0, $810f5d6293d4467f$export$cf507b112810e72d)
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: '16.5px 14px',
        ...!theme.vars && {
            '&:-webkit-autofill': {
                WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
                WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
                caretColor: theme.palette.mode === 'light' ? null : '#fff',
                borderRadius: 'inherit'
            }
        },
        ...theme.vars && {
            '&:-webkit-autofill': {
                borderRadius: 'inherit'
            },
            [theme.getColorSchemeSelector('dark')]: {
                '&:-webkit-autofill': {
                    WebkitBoxShadow: '0 0 0 100px #266798 inset',
                    WebkitTextFillColor: '#fff',
                    caretColor: '#fff'
                }
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '8.5px 14px'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.multiline,
                style: {
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.startAdornment,
                style: {
                    paddingLeft: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.endAdornment,
                style: {
                    paddingRight: 0
                }
            }
        ]
    })));
const $fe946640f9150f45$var$OutlinedInput = /*#__PURE__*/ $acw62.forwardRef(function OutlinedInput(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiOutlinedInput'
    });
    const { components: components = {}, fullWidth: fullWidth = false, inputComponent: inputComponent = 'input', label: label, multiline: multiline = false, notched: notched, slots: slots = {}, slotProps: slotProps = {}, type: type = 'text', ...other } = props;
    const classes = $fe946640f9150f45$var$useUtilityClasses(props);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'disabled',
            'error',
            'focused',
            'hiddenLabel',
            'size',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        disabled: fcs.disabled,
        error: fcs.error,
        focused: fcs.focused,
        formControl: muiFormControl,
        fullWidth: fullWidth,
        hiddenLabel: fcs.hiddenLabel,
        multiline: multiline,
        size: fcs.size,
        type: type
    };
    const RootSlot = slots.root ?? components.Root ?? $fe946640f9150f45$var$OutlinedInputRoot;
    const InputSlot = slots.input ?? components.Input ?? $fe946640f9150f45$var$OutlinedInputInput;
    const [NotchedSlot, notchedProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('notchedOutline', {
        elementType: $fe946640f9150f45$var$NotchedOutlineRoot,
        className: classes.notchedOutline,
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        additionalProps: {
            label: label != null && label !== '' && fcs.required ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    "\u2009",
                    '*'
                ]
            }) : label
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), {
        slots: {
            root: RootSlot,
            input: InputSlot
        },
        slotProps: slotProps,
        renderSuffix: (state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NotchedSlot, {
                ...notchedProps,
                notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
            }),
        fullWidth: fullWidth,
        inputComponent: inputComponent,
        multiline: multiline,
        ref: ref,
        type: type,
        ...other,
        classes: {
            ...classes,
            notchedOutline: null
        }
    });
});
$fe946640f9150f45$var$OutlinedInput.muiName = 'Input';
var $fe946640f9150f45$export$2e2bcd8739ae039 = $fe946640f9150f45$var$OutlinedInput;



var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");












function $f349e4b76c0b885d$export$f7d501e40371cd17(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiFormLabel', slot);
}
const $f349e4b76c0b885d$var$formLabelClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiFormLabel', [
    'root',
    'colorSecondary',
    'focused',
    'disabled',
    'error',
    'filled',
    'required',
    'asterisk'
]);
var $f349e4b76c0b885d$export$2e2bcd8739ae039 = $f349e4b76c0b885d$var$formLabelClasses;



'use client';
const $db3da65b5688c8f8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, focused: focused, disabled: disabled, error: error, filled: filled, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            disabled && 'disabled',
            error && 'error',
            filled && 'filled',
            focused && 'focused',
            required && 'required'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $f349e4b76c0b885d$export$f7d501e40371cd17), classes);
};
const $db3da65b5688c8f8$export$aa5bc7f8a4705b27 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color === 'secondary' && styles.colorSecondary,
            ownerState.filled && styles.filled
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.body1,
        lineHeight: '1.4375em',
        padding: 0,
        position: 'relative',
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).focused}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                props: {},
                style: {
                    [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    },
                    [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).error}`]: {
                        color: (theme.vars || theme).palette.error.main
                    }
                }
            }
        ]
    })));
const $db3da65b5688c8f8$var$AsteriskComponent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormLabel',
    slot: 'Asterisk'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
const $db3da65b5688c8f8$var$FormLabel = /*#__PURE__*/ $acw62.forwardRef(function FormLabel(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormLabel'
    });
    const { children: children, className: className, color: color, component: component = 'label', disabled: disabled, error: error, filled: filled, focused: focused, required: required, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'color',
            'required',
            'focused',
            'disabled',
            'error',
            'filled'
        ]
    });
    const ownerState = {
        ...props,
        color: fcs.color || 'primary',
        component: component,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    const classes = $db3da65b5688c8f8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($db3da65b5688c8f8$export$aa5bc7f8a4705b27, {
        as: component,
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        children: [
            children,
            fcs.required && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($db3da65b5688c8f8$var$AsteriskComponent, {
                ownerState: ownerState,
                "aria-hidden": true,
                className: classes.asterisk,
                children: [
                    "\u2009",
                    '*'
                ]
            })
        ]
    });
});
var $db3da65b5688c8f8$export$2e2bcd8739ae039 = $db3da65b5688c8f8$var$FormLabel;









function $73574a1c301dedd6$export$c1c4b4545ad2ea5f(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiInputLabel', slot);
}
const $73574a1c301dedd6$var$inputLabelClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiInputLabel', [
    'root',
    'focused',
    'disabled',
    'error',
    'required',
    'asterisk',
    'formControl',
    'sizeSmall',
    'shrink',
    'animated',
    'standard',
    'filled',
    'outlined'
]);
var $73574a1c301dedd6$export$2e2bcd8739ae039 = $73574a1c301dedd6$var$inputLabelClasses;



'use client';
const $499ac2a9f7a67cb8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, formControl: formControl, size: size, shrink: shrink, disableAnimation: disableAnimation, variant: variant, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            formControl && 'formControl',
            !disableAnimation && 'animated',
            shrink && 'shrink',
            size && size !== 'medium' && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            variant
        ],
        asterisk: [
            required && 'asterisk'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $73574a1c301dedd6$export$c1c4b4545ad2ea5f), classes);
    return {
        ...classes,
        // forward the focused, disabled, etc. classes to the FormLabel
        ...composedClasses
    };
};
const $499ac2a9f7a67cb8$var$InputLabelRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $db3da65b5688c8f8$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiInputLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $f349e4b76c0b885d$export$2e2bcd8739ae039).asterisk}`]: styles.asterisk
            },
            styles.root,
            ownerState.formControl && styles.formControl,
            ownerState.size === 'small' && styles.sizeSmall,
            ownerState.shrink && styles.shrink,
            !ownerState.disableAnimation && styles.animated,
            ownerState.focused && styles.focused,
            styles[ownerState.variant]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'block',
        transformOrigin: 'top left',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.formControl,
                style: {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    // slight alteration to spec spacing to match visual spec result
                    transform: 'translate(0, 20px) scale(1)'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    // Compensation for the `Input.inputSizeSmall` style.
                    transform: 'translate(0, 17px) scale(1)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.shrink,
                style: {
                    transform: 'translate(0, -1.5px) scale(0.75)',
                    transformOrigin: 'top left',
                    maxWidth: '133%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableAnimation,
                style: {
                    transition: theme.transitions.create([
                        'color',
                        'transform',
                        'max-width'
                    ], {
                        duration: theme.transitions.duration.shorter,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    // Chrome's autofill feature gives the input field a yellow background.
                    // Since the input field is behind the label in the HTML tree,
                    // the input field is drawn last and hides the label with an opaque background color.
                    // zIndex: 1 will raise the label above opaque background-colors of input.
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(12px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'filled',
                    size: 'small'
                },
                style: {
                    transform: 'translate(12px, 13px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'filled' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    transform: 'translate(12px, 7px) scale(0.75)',
                    maxWidth: 'calc(133% - 24px)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState, size: size })=>variant === 'filled' && ownerState.shrink && size === 'small',
                style: {
                    transform: 'translate(12px, 4px) scale(0.75)'
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    // see comment above on filled.zIndex
                    zIndex: 1,
                    pointerEvents: 'none',
                    transform: 'translate(14px, 16px) scale(1)',
                    maxWidth: 'calc(100% - 24px)'
                }
            },
            {
                props: {
                    variant: 'outlined',
                    size: 'small'
                },
                style: {
                    transform: 'translate(14px, 9px) scale(1)'
                }
            },
            {
                props: ({ variant: variant, ownerState: ownerState })=>variant === 'outlined' && ownerState.shrink,
                style: {
                    userSelect: 'none',
                    pointerEvents: 'auto',
                    // Theoretically, we should have (8+5)*2/0.75 = 34px
                    // but it feels a better when it bleeds a bit on the left, so 32px.
                    maxWidth: 'calc(133% - 32px)',
                    transform: 'translate(14px, -9px) scale(0.75)'
                }
            }
        ]
    })));
const $499ac2a9f7a67cb8$var$InputLabel = /*#__PURE__*/ $acw62.forwardRef(function InputLabel(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        name: 'MuiInputLabel',
        props: inProps
    });
    const { disableAnimation: disableAnimation = false, margin: margin, shrink: shrinkProp, variant: variant, className: className, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    let shrink = shrinkProp;
    if (typeof shrink === 'undefined' && muiFormControl) shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'size',
            'variant',
            'required',
            'focused'
        ]
    });
    const ownerState = {
        ...props,
        disableAnimation: disableAnimation,
        formControl: muiFormControl,
        shrink: shrink,
        size: fcs.size,
        variant: fcs.variant,
        required: fcs.required,
        focused: fcs.focused
    };
    const classes = $499ac2a9f7a67cb8$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($499ac2a9f7a67cb8$var$InputLabelRoot, {
        "data-shrink": shrink,
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        ownerState: ownerState,
        classes: classes
    });
});
var $499ac2a9f7a67cb8$export$2e2bcd8739ae039 = $499ac2a9f7a67cb8$var$InputLabel;



var $acw62 = parcelRequire("acw62");








var $a313fb4a2074834f$export$2e2bcd8739ae039 = (0, $37dfa52af4926933$export$2e2bcd8739ae039);





function $9e00b477c7793448$export$149c8b8bab2289d1(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiFormControl', slot);
}
const $9e00b477c7793448$var$formControlClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiFormControl', [
    'root',
    'marginNone',
    'marginNormal',
    'marginDense',
    'fullWidth',
    'disabled'
]);
var $9e00b477c7793448$export$2e2bcd8739ae039 = $9e00b477c7793448$var$formControlClasses;



'use client';
const $88a0f3656f701f08$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, margin: margin, fullWidth: fullWidth } = ownerState;
    const slots = {
        root: [
            'root',
            margin !== 'none' && `margin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(margin)}`,
            fullWidth && 'fullWidth'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $9e00b477c7793448$export$149c8b8bab2289d1), classes);
};
const $88a0f3656f701f08$var$FormControlRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormControl',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`margin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.margin)}`],
            ownerState.fullWidth && styles.fullWidth
        ];
    }
})({
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top',
    // Fix alignment issue on Safari.
    variants: [
        {
            props: {
                margin: 'normal'
            },
            style: {
                marginTop: 16,
                marginBottom: 8
            }
        },
        {
            props: {
                margin: 'dense'
            },
            style: {
                marginTop: 8,
                marginBottom: 4
            }
        },
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        }
    ]
});
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/material-ui/react-text-field/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it creates visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */ const $88a0f3656f701f08$var$FormControl = /*#__PURE__*/ $acw62.forwardRef(function FormControl(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControl'
    });
    const { children: children, className: className, color: color = 'primary', component: component = 'div', disabled: disabled = false, error: error = false, focused: visuallyFocused, fullWidth: fullWidth = false, hiddenLabel: hiddenLabel = false, margin: margin = 'none', required: required = false, size: size = 'medium', variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        hiddenLabel: hiddenLabel,
        margin: margin,
        required: required,
        size: size,
        variant: variant
    };
    const classes = $88a0f3656f701f08$var$useUtilityClasses(ownerState);
    const [adornedStart, setAdornedStart] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialAdornedStart = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            const input = (0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                'Select'
            ]) ? child.props.input : child;
            if (input && (0, $beb6670688e6a4c6$export$1b68bdfa56faeb5d)(input.props)) initialAdornedStart = true;
        });
        return initialAdornedStart;
    });
    const [filled, setFilled] = $acw62.useState(()=>{
        // We need to iterate through the children and find the Input in order
        // to fully support server-side rendering.
        let initialFilled = false;
        if (children) $acw62.Children.forEach(children, (child)=>{
            if (!(0, $a313fb4a2074834f$export$2e2bcd8739ae039)(child, [
                'Input',
                'Select'
            ])) return;
            if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)(child.props, true) || (0, $beb6670688e6a4c6$export$d652b828d7fdeff8)(child.props.inputProps, true)) initialFilled = true;
        });
        return initialFilled;
    });
    const [focusedState, setFocused] = $acw62.useState(false);
    if (disabled && focusedState) setFocused(false);
    const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
    let registerEffect;
    const registeredInput = $acw62.useRef(false);
    const onFilled = $acw62.useCallback(()=>{
        setFilled(true);
    }, []);
    const onEmpty = $acw62.useCallback(()=>{
        setFilled(false);
    }, []);
    const childContext = $acw62.useMemo(()=>{
        return {
            adornedStart: adornedStart,
            setAdornedStart: setAdornedStart,
            color: color,
            disabled: disabled,
            error: error,
            filled: filled,
            focused: focused,
            fullWidth: fullWidth,
            hiddenLabel: hiddenLabel,
            size: size,
            onBlur: ()=>{
                setFocused(false);
            },
            onFocus: ()=>{
                setFocused(true);
            },
            onEmpty: onEmpty,
            onFilled: onFilled,
            registerEffect: registerEffect,
            required: required,
            variant: variant
        };
    }, [
        adornedStart,
        color,
        disabled,
        error,
        filled,
        focused,
        fullWidth,
        hiddenLabel,
        registerEffect,
        onEmpty,
        onFilled,
        required,
        size,
        variant
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($88a0f3656f701f08$var$FormControlRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: children
        })
    });
});
var $88a0f3656f701f08$export$2e2bcd8739ae039 = $88a0f3656f701f08$var$FormControl;



var $acw62 = parcelRequire("acw62");











function $bdd2baf6568f6f86$export$a394fa61b1d583a9(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiFormHelperText', slot);
}
const $bdd2baf6568f6f86$var$formHelperTextClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiFormHelperText', [
    'root',
    'error',
    'disabled',
    'sizeSmall',
    'sizeMedium',
    'contained',
    'focused',
    'filled',
    'required'
]);
var $bdd2baf6568f6f86$export$2e2bcd8739ae039 = $bdd2baf6568f6f86$var$formHelperTextClasses;



'use client';
var $937760e70ffc7914$var$_span;
const $937760e70ffc7914$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, contained: contained, size: size, disabled: disabled, error: error, filled: filled, focused: focused, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            error && 'error',
            size && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            contained && 'contained',
            focused && 'focused',
            filled && 'filled',
            required && 'required'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $bdd2baf6568f6f86$export$a394fa61b1d583a9), classes);
};
const $937760e70ffc7914$var$FormHelperTextRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('p', {
    name: 'MuiFormHelperText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size && styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.contained && styles.contained,
            ownerState.filled && styles.filled
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        ...theme.typography.caption,
        textAlign: 'left',
        marginTop: 3,
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        [`&.${(0, $bdd2baf6568f6f86$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $bdd2baf6568f6f86$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    marginTop: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.contained,
                style: {
                    marginLeft: 14,
                    marginRight: 14
                }
            }
        ]
    })));
const $937760e70ffc7914$var$FormHelperText = /*#__PURE__*/ $acw62.forwardRef(function FormHelperText(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormHelperText'
    });
    const { children: children, className: className, component: component = 'p', disabled: disabled, error: error, filled: filled, focused: focused, margin: margin, required: required, variant: variant, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'size',
            'disabled',
            'error',
            'filled',
            'focused',
            'required'
        ]
    });
    const ownerState = {
        ...props,
        component: component,
        contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
        variant: fcs.variant,
        size: fcs.size,
        disabled: fcs.disabled,
        error: fcs.error,
        filled: fcs.filled,
        focused: fcs.focused,
        required: fcs.required
    };
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $937760e70ffc7914$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($937760e70ffc7914$var$FormHelperTextRoot, {
        as: component,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ...other,
        ownerState: ownerState,
        children: children === ' ' ? $937760e70ffc7914$var$_span || ($937760e70ffc7914$var$_span = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            className: "notranslate",
            "aria-hidden": true,
            children: "\u200B"
        })) : children
    });
});
var $937760e70ffc7914$export$2e2bcd8739ae039 = $937760e70ffc7914$var$FormHelperText;



var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");












var $83167607eb9ed060$export$2e2bcd8739ae039 = (0, $7cf4d6c2077a48de$export$2e2bcd8739ae039);






var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");







'use client';
// Inspired by https://github.com/focus-trap/tabbable
const $29292f9ac60f4a63$var$candidatesSelector = [
    'input',
    'select',
    'textarea',
    'a[href]',
    'button',
    '[tabindex]',
    'audio[controls]',
    'video[controls]',
    '[contenteditable]:not([contenteditable="false"])'
].join(',');
function $29292f9ac60f4a63$var$getTabIndex(node) {
    const tabindexAttr = parseInt(node.getAttribute('tabindex') || '', 10);
    if (!Number.isNaN(tabindexAttr)) return tabindexAttr;
    // Browsers do not return `tabIndex` correctly for contentEditable nodes;
    // https://issues.chromium.org/issues/41283952
    // so if they don't have a tabindex attribute specifically set, assume it's 0.
    // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
    //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
    //  yet they are still part of the regular tab order; in FF, they get a default
    //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
    //  order, consider their tab index to be 0.
    if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) return 0;
    return node.tabIndex;
}
function $29292f9ac60f4a63$var$isNonTabbableRadio(node) {
    if (node.tagName !== 'INPUT' || node.type !== 'radio') return false;
    if (!node.name) return false;
    const getRadio = (selector)=>node.ownerDocument.querySelector(`input[type="radio"]${selector}`);
    let roving = getRadio(`[name="${node.name}"]:checked`);
    if (!roving) roving = getRadio(`[name="${node.name}"]`);
    return roving !== node;
}
function $29292f9ac60f4a63$var$isNodeMatchingSelectorFocusable(node) {
    if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || $29292f9ac60f4a63$var$isNonTabbableRadio(node)) return false;
    return true;
}
function $29292f9ac60f4a63$var$defaultGetTabbable(root) {
    const regularTabNodes = [];
    const orderedTabNodes = [];
    Array.from(root.querySelectorAll($29292f9ac60f4a63$var$candidatesSelector)).forEach((node, i)=>{
        const nodeTabIndex = $29292f9ac60f4a63$var$getTabIndex(node);
        if (nodeTabIndex === -1 || !$29292f9ac60f4a63$var$isNodeMatchingSelectorFocusable(node)) return;
        if (nodeTabIndex === 0) regularTabNodes.push(node);
        else orderedTabNodes.push({
            documentOrder: i,
            tabIndex: nodeTabIndex,
            node: node
        });
    });
    return orderedTabNodes.sort((a, b)=>a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map((a)=>a.node).concat(regularTabNodes);
}
function $29292f9ac60f4a63$var$defaultIsEnabled() {
    return true;
}
/**
 * @ignore - internal component.
 */ function $29292f9ac60f4a63$var$FocusTrap(props) {
    const { children: children, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableRestoreFocus: disableRestoreFocus = false, getTabbable: getTabbable = $29292f9ac60f4a63$var$defaultGetTabbable, isEnabled: isEnabled = $29292f9ac60f4a63$var$defaultIsEnabled, open: open } = props;
    const ignoreNextEnforceFocus = $acw62.useRef(false);
    const sentinelStart = $acw62.useRef(null);
    const sentinelEnd = $acw62.useRef(null);
    const nodeToRestore = $acw62.useRef(null);
    const reactFocusEventTarget = $acw62.useRef(null);
    // This variable is useful when disableAutoFocus is true.
    // It waits for the active element to move into the component to activate.
    const activated = $acw62.useRef(false);
    const rootRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), rootRef);
    const lastKeydown = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        activated.current = !disableAutoFocus;
    }, [
        disableAutoFocus,
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        if (!rootRef.current.contains(doc.activeElement)) {
            if (!rootRef.current.hasAttribute('tabIndex')) rootRef.current.setAttribute('tabIndex', '-1');
            if (activated.current) rootRef.current.focus();
        }
        return ()=>{
            // restoreLastFocus()
            if (!disableRestoreFocus) {
                // In IE11 it is possible for document.activeElement to be null resulting
                // in nodeToRestore.current being null.
                // Not all elements in IE11 have a focus method.
                // Once IE11 support is dropped the focus() call can be unconditional.
                if (nodeToRestore.current && nodeToRestore.current.focus) {
                    ignoreNextEnforceFocus.current = true;
                    nodeToRestore.current.focus();
                }
                nodeToRestore.current = null;
            }
        };
    // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open FocusTrap
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // We might render an empty child.
        if (!open || !rootRef.current) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(rootRef.current);
        const loopFocus = (nativeEvent)=>{
            lastKeydown.current = nativeEvent;
            if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') return;
            // Make sure the next tab starts from the right place.
            // doc.activeElement refers to the origin.
            if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
                // We need to ignore the next contain as
                // it will try to move the focus back to the rootRef element.
                ignoreNextEnforceFocus.current = true;
                if (sentinelEnd.current) sentinelEnd.current.focus();
            }
        };
        const contain = ()=>{
            const rootElement = rootRef.current;
            // Cleanup functions are executed lazily in React 17.
            // Contain can be called between the component being unmounted and its cleanup function being run.
            if (rootElement === null) return;
            if (!doc.hasFocus() || !isEnabled() || ignoreNextEnforceFocus.current) {
                ignoreNextEnforceFocus.current = false;
                return;
            }
            // The focus is already inside
            if (rootElement.contains(doc.activeElement)) return;
            // The disableEnforceFocus is set and the focus is outside of the focus trap (and sentinel nodes)
            if (disableEnforceFocus && doc.activeElement !== sentinelStart.current && doc.activeElement !== sentinelEnd.current) return;
            // if the focus event is not coming from inside the children's react tree, reset the refs
            if (doc.activeElement !== reactFocusEventTarget.current) reactFocusEventTarget.current = null;
            else if (reactFocusEventTarget.current !== null) return;
            if (!activated.current) return;
            let tabbable = [];
            if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) tabbable = getTabbable(rootRef.current);
            // one of the sentinel nodes was focused, so move the focus
            // to the first/last tabbable element inside the focus trap
            if (tabbable.length > 0) {
                const isShiftTab = Boolean(lastKeydown.current?.shiftKey && lastKeydown.current?.key === 'Tab');
                const focusNext = tabbable[0];
                const focusPrevious = tabbable[tabbable.length - 1];
                if (typeof focusNext !== 'string' && typeof focusPrevious !== 'string') {
                    if (isShiftTab) focusPrevious.focus();
                    else focusNext.focus();
                }
            // no tabbable elements in the trap focus or the focus was outside of the focus trap
            } else rootElement.focus();
        };
        doc.addEventListener('focusin', contain);
        doc.addEventListener('keydown', loopFocus, true);
        // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
        // for example https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
        // Instead, we can look if the active element was restored on the BODY element.
        //
        // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
        // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
        const interval = setInterval(()=>{
            if (doc.activeElement && doc.activeElement.tagName === 'BODY') contain();
        }, 50);
        return ()=>{
            clearInterval(interval);
            doc.removeEventListener('focusin', contain);
            doc.removeEventListener('keydown', loopFocus, true);
        };
    }, [
        disableAutoFocus,
        disableEnforceFocus,
        disableRestoreFocus,
        isEnabled,
        open,
        getTabbable
    ]);
    const onFocus = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
        reactFocusEventTarget.current = event.target;
        const childrenPropsHandler = children.props.onFocus;
        if (childrenPropsHandler) childrenPropsHandler(event);
    };
    const handleFocusSentinel = (event)=>{
        if (nodeToRestore.current === null) nodeToRestore.current = event.relatedTarget;
        activated.current = true;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelStart,
                "data-testid": "sentinelStart"
            }),
            /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                onFocus: onFocus
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                tabIndex: open ? 0 : -1,
                onFocus: handleFocusSentinel,
                ref: sentinelEnd,
                "data-testid": "sentinelEnd"
            })
        ]
    });
}
var $29292f9ac60f4a63$export$2e2bcd8739ae039 = $29292f9ac60f4a63$var$FocusTrap;







var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");








'use client';
const $b0a9dc0bcc2977a8$var$styles = {
    entering: {
        opacity: 1
    },
    entered: {
        opacity: 1
    }
};
/**
 * The Fade transition is used by the [Modal](/material-ui/react-modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $b0a9dc0bcc2977a8$var$Fade = /*#__PURE__*/ $acw62.forwardRef(function Fade(props, ref) {
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039), ...other } = props;
    const enableStrictModeCompat = true;
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(nodeRef, (0, $1d88113360503233$export$2e2bcd8739ae039)(children), ref);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const handleEntering = normalizedTransitionCallback(onEntering);
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        (0, $09228c405c75d141$export$b7a864e1eaef9de5)(node); // So the animation always start from the start.
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
        node.style.transition = theme.transitions.create('opacity', transitionProps);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionComponent, {
        appear: appear,
        in: inProp,
        nodeRef: enableStrictModeCompat ? nodeRef : undefined,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                style: {
                    opacity: 0,
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...$b0a9dc0bcc2977a8$var$styles[state],
                    ...style,
                    ...children.props.style
                },
                ref: handleRef,
                ...restChildProps
            });
        }
    });
});
var $b0a9dc0bcc2977a8$export$2e2bcd8739ae039 = $b0a9dc0bcc2977a8$var$Fade;




function $8aee358ee862b8d1$export$9927a91fd93152bd(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiBackdrop', slot);
}
const $8aee358ee862b8d1$var$backdropClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiBackdrop', [
    'root',
    'invisible'
]);
var $8aee358ee862b8d1$export$2e2bcd8739ae039 = $8aee358ee862b8d1$var$backdropClasses;



'use client';
const $89da4f4236459888$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, invisible: invisible } = ownerState;
    const slots = {
        root: [
            'root',
            invisible && 'invisible'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $8aee358ee862b8d1$export$9927a91fd93152bd), classes);
};
const $89da4f4236459888$var$BackdropRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiBackdrop',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.invisible && styles.invisible
        ];
    }
})({
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    WebkitTapHighlightColor: 'transparent',
    variants: [
        {
            props: {
                invisible: true
            },
            style: {
                backgroundColor: 'transparent'
            }
        }
    ]
});
const $89da4f4236459888$var$Backdrop = /*#__PURE__*/ $acw62.forwardRef(function Backdrop(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBackdrop'
    });
    const { children: children, className: className, component: component = 'div', invisible: invisible = false, open: open, components: components = {}, componentsProps: componentsProps = {}, slotProps: slotProps = {}, slots: slots = {}, TransitionComponent: TransitionComponentProp, transitionDuration: transitionDuration, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        invisible: invisible
    };
    const classes = $89da4f4236459888$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        root: components.Root,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        ...componentsProps,
        ...slotProps
    };
    const externalForwardedProps = {
        component: component,
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $89da4f4236459888$var$BackdropRoot,
        externalForwardedProps: externalForwardedProps,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionSlot, {
        in: open,
        timeout: transitionDuration,
        ...other,
        ...transitionProps,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RootSlot, {
            "aria-hidden": true,
            ...rootProps,
            classes: classes,
            ref: ref,
            children: children
        })
    });
});
var $89da4f4236459888$export$2e2bcd8739ae039 = $89da4f4236459888$var$Backdrop;



var $acw62 = parcelRequire("acw62");



/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */ function $cfb86ebe4ea00eb7$export$2e2bcd8739ae039(...funcs) {
    return funcs.reduce((acc, func)=>{
        if (func == null) return acc;
        return function chainedFunction(...args) {
            acc.apply(this, args);
            func.apply(this, args);
        };
    }, ()=>{});
}






// Is a vertical scrollbar displayed?
function $c082533c6a49e8e9$var$isOverflowing(container) {
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container);
    if (doc.body === container) return (0, $71912e551e227707$export$2e2bcd8739ae039)(container).innerWidth > doc.documentElement.clientWidth;
    return container.scrollHeight > container.clientHeight;
}
function $c082533c6a49e8e9$export$e1bd0c6150f13d96(element, hide) {
    if (hide) element.setAttribute('aria-hidden', 'true');
    else element.removeAttribute('aria-hidden');
}
function $c082533c6a49e8e9$var$getPaddingRight(element) {
    return parseInt((0, $71912e551e227707$export$2e2bcd8739ae039)(element).getComputedStyle(element).paddingRight, 10) || 0;
}
function $c082533c6a49e8e9$var$isAriaHiddenForbiddenOnElement(element) {
    // The forbidden HTML tags are the ones from ARIA specification that
    // can be children of body and can't have aria-hidden attribute.
    // cf. https://www.w3.org/TR/html-aria/#docconformance
    const forbiddenTagNames = [
        'TEMPLATE',
        'SCRIPT',
        'STYLE',
        'LINK',
        'MAP',
        'META',
        'NOSCRIPT',
        'PICTURE',
        'COL',
        'COLGROUP',
        'PARAM',
        'SLOT',
        'SOURCE',
        'TRACK'
    ];
    const isForbiddenTagName = forbiddenTagNames.includes(element.tagName);
    const isInputHidden = element.tagName === 'INPUT' && element.getAttribute('type') === 'hidden';
    return isForbiddenTagName || isInputHidden;
}
function $c082533c6a49e8e9$var$ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude, hide) {
    const blacklist = [
        mountElement,
        currentElement,
        ...elementsToExclude
    ];
    [].forEach.call(container.children, (element)=>{
        const isNotExcludedElement = !blacklist.includes(element);
        const isNotForbiddenElement = !$c082533c6a49e8e9$var$isAriaHiddenForbiddenOnElement(element);
        if (isNotExcludedElement && isNotForbiddenElement) $c082533c6a49e8e9$export$e1bd0c6150f13d96(element, hide);
    });
}
function $c082533c6a49e8e9$var$findIndexOf(items, callback) {
    let idx = -1;
    items.some((item, index)=>{
        if (callback(item)) {
            idx = index;
            return true;
        }
        return false;
    });
    return idx;
}
function $c082533c6a49e8e9$var$handleContainer(containerInfo, props) {
    const restoreStyle = [];
    const container = containerInfo.container;
    if (!props.disableScrollLock) {
        if ($c082533c6a49e8e9$var$isOverflowing(container)) {
            // Compute the size before applying overflow hidden to avoid any scroll jumps.
            const scrollbarSize = (0, $0200cab69b9251c8$export$2e2bcd8739ae039)((0, $71912e551e227707$export$2e2bcd8739ae039)(container));
            restoreStyle.push({
                value: container.style.paddingRight,
                property: 'padding-right',
                el: container
            });
            // Use computed style, here to get the real padding to add our scrollbar width.
            container.style.paddingRight = `${$c082533c6a49e8e9$var$getPaddingRight(container) + scrollbarSize}px`;
            // .mui-fixed is a global helper.
            const fixedElements = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).querySelectorAll('.mui-fixed');
            [].forEach.call(fixedElements, (element)=>{
                restoreStyle.push({
                    value: element.style.paddingRight,
                    property: 'padding-right',
                    el: element
                });
                element.style.paddingRight = `${$c082533c6a49e8e9$var$getPaddingRight(element) + scrollbarSize}px`;
            });
        }
        let scrollContainer;
        if (container.parentNode instanceof DocumentFragment) scrollContainer = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(container).body;
        else {
            // Support html overflow-y: auto for scroll stability between pages
            // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
            const parent = container.parentElement;
            const containerWindow = (0, $71912e551e227707$export$2e2bcd8739ae039)(container);
            scrollContainer = parent?.nodeName === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container;
        }
        // Block the scroll even if no scrollbar is visible to account for mobile keyboard
        // screensize shrink.
        restoreStyle.push({
            value: scrollContainer.style.overflow,
            property: 'overflow',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowX,
            property: 'overflow-x',
            el: scrollContainer
        }, {
            value: scrollContainer.style.overflowY,
            property: 'overflow-y',
            el: scrollContainer
        });
        scrollContainer.style.overflow = 'hidden';
    }
    const restore = ()=>{
        restoreStyle.forEach(({ value: value, el: el, property: property })=>{
            if (value) el.style.setProperty(property, value);
            else el.style.removeProperty(property);
        });
    };
    return restore;
}
function $c082533c6a49e8e9$var$getHiddenSiblings(container) {
    const hiddenSiblings = [];
    [].forEach.call(container.children, (element)=>{
        if (element.getAttribute('aria-hidden') === 'true') hiddenSiblings.push(element);
    });
    return hiddenSiblings;
}
class $c082533c6a49e8e9$export$ce11c4ecd08cea67 {
    constructor(){
        this.modals = [];
        this.containers = [];
    }
    add(modal, container) {
        let modalIndex = this.modals.indexOf(modal);
        if (modalIndex !== -1) return modalIndex;
        modalIndex = this.modals.length;
        this.modals.push(modal);
        // If the modal we are adding is already in the DOM.
        if (modal.modalRef) $c082533c6a49e8e9$export$e1bd0c6150f13d96(modal.modalRef, false);
        const hiddenSiblings = $c082533c6a49e8e9$var$getHiddenSiblings(container);
        $c082533c6a49e8e9$var$ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.container === container);
        if (containerIndex !== -1) {
            this.containers[containerIndex].modals.push(modal);
            return modalIndex;
        }
        this.containers.push({
            modals: [
                modal
            ],
            container: container,
            restore: null,
            hiddenSiblings: hiddenSiblings
        });
        return modalIndex;
    }
    mount(modal, props) {
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        if (!containerInfo.restore) containerInfo.restore = $c082533c6a49e8e9$var$handleContainer(containerInfo, props);
    }
    remove(modal, ariaHiddenState = true) {
        const modalIndex = this.modals.indexOf(modal);
        if (modalIndex === -1) return modalIndex;
        const containerIndex = $c082533c6a49e8e9$var$findIndexOf(this.containers, (item)=>item.modals.includes(modal));
        const containerInfo = this.containers[containerIndex];
        containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
        this.modals.splice(modalIndex, 1);
        // If that was the last modal in a container, clean up the container.
        if (containerInfo.modals.length === 0) {
            // The modal might be closed before it had the chance to be mounted in the DOM.
            if (containerInfo.restore) containerInfo.restore();
            if (modal.modalRef) // In case the modal wasn't in the DOM yet.
            $c082533c6a49e8e9$export$e1bd0c6150f13d96(modal.modalRef, ariaHiddenState);
            $c082533c6a49e8e9$var$ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
            this.containers.splice(containerIndex, 1);
        } else {
            // Otherwise make sure the next top modal is visible to a screen reader.
            const nextTop = containerInfo.modals[containerInfo.modals.length - 1];
            // as soon as a modal is adding its modalRef is undefined. it can't set
            // aria-hidden because the dom element doesn't exist either
            // when modal was unmounted before modalRef gets null
            if (nextTop.modalRef) $c082533c6a49e8e9$export$e1bd0c6150f13d96(nextTop.modalRef, false);
        }
        return modalIndex;
    }
    isTopModal(modal) {
        return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
}


'use client';
function $d27dad1a2ce77a45$var$getContainer(container) {
    return typeof container === 'function' ? container() : container;
}
function $d27dad1a2ce77a45$var$getHasTransition(children) {
    return children ? children.props.hasOwnProperty('in') : false;
}
const $d27dad1a2ce77a45$var$noop = ()=>{};
// A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.
const $d27dad1a2ce77a45$var$manager = new (0, $c082533c6a49e8e9$export$ce11c4ecd08cea67)();
function $d27dad1a2ce77a45$var$useModal(parameters) {
    const { container: container, disableEscapeKeyDown: disableEscapeKeyDown = false, disableScrollLock: disableScrollLock = false, closeAfterTransition: closeAfterTransition = false, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, children: children, onClose: onClose, open: open, rootRef: rootRef } = parameters;
    // @ts-ignore internal logic
    const modal = $acw62.useRef({});
    const mountNodeRef = $acw62.useRef(null);
    const modalRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(modalRef, rootRef);
    const [exited, setExited] = $acw62.useState(!open);
    const hasTransition = $d27dad1a2ce77a45$var$getHasTransition(children);
    let ariaHiddenProp = true;
    if (parameters['aria-hidden'] === 'false' || parameters['aria-hidden'] === false) ariaHiddenProp = false;
    const getDoc = ()=>(0, $4c8156a231c9130b$export$2e2bcd8739ae039)(mountNodeRef.current);
    const getModal = ()=>{
        modal.current.modalRef = modalRef.current;
        modal.current.mount = mountNodeRef.current;
        return modal.current;
    };
    const handleMounted = ()=>{
        $d27dad1a2ce77a45$var$manager.mount(getModal(), {
            disableScrollLock: disableScrollLock
        });
        // Fix a bug on Chrome where the scroll isn't initially 0.
        if (modalRef.current) modalRef.current.scrollTop = 0;
    };
    const handleOpen = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const resolvedContainer = $d27dad1a2ce77a45$var$getContainer(container) || getDoc().body;
        $d27dad1a2ce77a45$var$manager.add(getModal(), resolvedContainer);
        // The element was already mounted.
        if (modalRef.current) handleMounted();
    });
    const isTopModal = ()=>$d27dad1a2ce77a45$var$manager.isTopModal(getModal());
    const handlePortalRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        mountNodeRef.current = node;
        if (!node) return;
        if (open && isTopModal()) handleMounted();
        else if (modalRef.current) (0, $c082533c6a49e8e9$export$e1bd0c6150f13d96)(modalRef.current, ariaHiddenProp);
    });
    const handleClose = $acw62.useCallback(()=>{
        $d27dad1a2ce77a45$var$manager.remove(getModal(), ariaHiddenProp);
    }, [
        ariaHiddenProp
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            handleClose();
        };
    }, [
        handleClose
    ]);
    $acw62.useEffect(()=>{
        if (open) handleOpen();
        else if (!hasTransition || !closeAfterTransition) handleClose();
    }, [
        open,
        handleClose,
        hasTransition,
        closeAfterTransition,
        handleOpen
    ]);
    const createHandleKeyDown = (otherHandlers)=>(event)=>{
            otherHandlers.onKeyDown?.(event);
            // The handler doesn't take event.defaultPrevented into account:
            //
            // event.preventDefault() is meant to stop default behaviors like
            // clicking a checkbox to check it, hitting a button to submit a form,
            // and hitting left arrow to move the cursor in a text input etc.
            // Only special HTML elements have these default behaviors.
            if (event.key !== 'Escape' || event.which === 229 || // Wait until IME is settled.
            !isTopModal()) return;
            if (!disableEscapeKeyDown) {
                // Swallow the event, in case someone is listening for the escape key on the body.
                event.stopPropagation();
                if (onClose) onClose(event, 'escapeKeyDown');
            }
        };
    const createHandleBackdropClick = (otherHandlers)=>(event)=>{
            otherHandlers.onClick?.(event);
            if (event.target !== event.currentTarget) return;
            if (onClose) onClose(event, 'backdropClick');
        };
    const getRootProps = (otherHandlers = {})=>{
        const propsEventHandlers = (0, $afac4abdaa8d83ea$export$2e2bcd8739ae039)(parameters);
        // The custom event handlers shouldn't be spread on the root element
        delete propsEventHandlers.onTransitionEnter;
        delete propsEventHandlers.onTransitionExited;
        const externalEventHandlers = {
            ...propsEventHandlers,
            ...otherHandlers
        };
        return {
            /*
       * Marking an element with the role presentation indicates to assistive technology
       * that this element should be ignored; it exists to support the web application and
       * is not meant for humans to interact with directly.
       * https://github.com/evcohen/eslint-plugin-jsx-a11y/blob/master/docs/rules/no-static-element-interactions.md
       */ role: 'presentation',
            ...externalEventHandlers,
            onKeyDown: createHandleKeyDown(externalEventHandlers),
            ref: handleRef
        };
    };
    const getBackdropProps = (otherHandlers = {})=>{
        const externalEventHandlers = otherHandlers;
        return {
            'aria-hidden': true,
            ...externalEventHandlers,
            onClick: createHandleBackdropClick(externalEventHandlers),
            open: open
        };
    };
    const getTransitionProps = ()=>{
        const handleEnter = ()=>{
            setExited(false);
            if (onTransitionEnter) onTransitionEnter();
        };
        const handleExited = ()=>{
            setExited(true);
            if (onTransitionExited) onTransitionExited();
            if (closeAfterTransition) handleClose();
        };
        return {
            onEnter: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleEnter, children?.props.onEnter ?? $d27dad1a2ce77a45$var$noop),
            onExited: (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039)(handleExited, children?.props.onExited ?? $d27dad1a2ce77a45$var$noop)
        };
    };
    return {
        getRootProps: getRootProps,
        getBackdropProps: getBackdropProps,
        getTransitionProps: getTransitionProps,
        rootRef: handleRef,
        portalRef: handlePortalRef,
        isTopModal: isTopModal,
        exited: exited,
        hasTransition: hasTransition
    };
}
var $d27dad1a2ce77a45$export$2e2bcd8739ae039 = $d27dad1a2ce77a45$var$useModal;




function $9e1e7c05d81416a0$export$67960e22b12a638d(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiModal', slot);
}
const $9e1e7c05d81416a0$var$modalClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiModal', [
    'root',
    'hidden',
    'backdrop'
]);
var $9e1e7c05d81416a0$export$2e2bcd8739ae039 = $9e1e7c05d81416a0$var$modalClasses;




'use client';
const $4e95d56438178f01$var$useUtilityClasses = (ownerState)=>{
    const { open: open, exited: exited, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            !open && exited && 'hidden'
        ],
        backdrop: [
            'backdrop'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $9e1e7c05d81416a0$export$67960e22b12a638d), classes);
};
const $4e95d56438178f01$var$ModalRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiModal',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.open && ownerState.exited && styles.hidden
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'fixed',
        zIndex: (theme.vars || theme).zIndex.modal,
        right: 0,
        bottom: 0,
        top: 0,
        left: 0,
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.open && ownerState.exited,
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $4e95d56438178f01$var$ModalBackdrop = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $89da4f4236459888$export$2e2bcd8739ae039), {
    name: 'MuiModal',
    slot: 'Backdrop'
})({
    zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/material-ui/api/dialog/)
 * - [Drawer](/material-ui/api/drawer/)
 * - [Menu](/material-ui/api/menu/)
 * - [Popover](/material-ui/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/material-ui/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */ const $4e95d56438178f01$var$Modal = /*#__PURE__*/ $acw62.forwardRef(function Modal(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        name: 'MuiModal',
        props: inProps
    });
    const { BackdropComponent: BackdropComponent = $4e95d56438178f01$var$ModalBackdrop, BackdropProps: BackdropProps, classes: classesProp, className: className, closeAfterTransition: closeAfterTransition = false, children: children, container: container, component: component, components: components = {}, componentsProps: componentsProps = {}, disableAutoFocus: disableAutoFocus = false, disableEnforceFocus: disableEnforceFocus = false, disableEscapeKeyDown: disableEscapeKeyDown = false, disablePortal: disablePortal = false, disableRestoreFocus: disableRestoreFocus = false, disableScrollLock: disableScrollLock = false, hideBackdrop: hideBackdrop = false, keepMounted: keepMounted = false, onClose: onClose, onTransitionEnter: onTransitionEnter, onTransitionExited: onTransitionExited, open: open, slotProps: slotProps = {}, slots: slots = {}, theme: // eslint-disable-next-line react/prop-types
    theme, ...other } = props;
    const propsWithDefaults = {
        ...props,
        closeAfterTransition: closeAfterTransition,
        disableAutoFocus: disableAutoFocus,
        disableEnforceFocus: disableEnforceFocus,
        disableEscapeKeyDown: disableEscapeKeyDown,
        disablePortal: disablePortal,
        disableRestoreFocus: disableRestoreFocus,
        disableScrollLock: disableScrollLock,
        hideBackdrop: hideBackdrop,
        keepMounted: keepMounted
    };
    const { getRootProps: getRootProps, getBackdropProps: getBackdropProps, getTransitionProps: getTransitionProps, portalRef: portalRef, isTopModal: isTopModal, exited: exited, hasTransition: hasTransition } = (0, $d27dad1a2ce77a45$export$2e2bcd8739ae039)({
        ...propsWithDefaults,
        rootRef: ref
    });
    const ownerState = {
        ...propsWithDefaults,
        exited: exited
    };
    const classes = $4e95d56438178f01$var$useUtilityClasses(ownerState);
    const childProps = {};
    if (children.props.tabIndex === undefined) childProps.tabIndex = '-1';
    // It's a Transition like component
    if (hasTransition) {
        const { onEnter: onEnter, onExited: onExited } = getTransitionProps();
        childProps.onEnter = onEnter;
        childProps.onExited = onExited;
    }
    const externalForwardedProps = {
        slots: {
            root: components.Root,
            backdrop: components.Backdrop,
            ...slots
        },
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $4e95d56438178f01$var$ModalRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        getSlotProps: getRootProps,
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, classes?.root, !ownerState.open && ownerState.exited && classes?.hidden)
    });
    const [BackdropSlot, backdropProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('backdrop', {
        ref: BackdropProps?.ref,
        elementType: BackdropComponent,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: BackdropProps,
        getSlotProps: (otherHandlers)=>{
            return getBackdropProps({
                ...otherHandlers,
                onClick: (event)=>{
                    if (otherHandlers?.onClick) otherHandlers.onClick(event);
                }
            });
        },
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(BackdropProps?.className, classes?.backdrop),
        ownerState: ownerState
    });
    if (!keepMounted && !open && (!hasTransition || exited)) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $652518a1db38c266$export$2e2bcd8739ae039), {
        ref: portalRef,
        container: container,
        disablePortal: disablePortal,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
            ...rootProps,
            children: [
                !hideBackdrop && BackdropComponent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BackdropSlot, {
                    ...backdropProps
                }) : null,
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29292f9ac60f4a63$export$2e2bcd8739ae039), {
                    disableEnforceFocus: disableEnforceFocus,
                    disableAutoFocus: disableAutoFocus,
                    disableRestoreFocus: disableRestoreFocus,
                    isEnabled: isTopModal,
                    open: open,
                    children: /*#__PURE__*/ $acw62.cloneElement(children, childProps)
                })
            ]
        })
    });
});
var $4e95d56438178f01$export$2e2bcd8739ae039 = $4e95d56438178f01$var$Modal;





function $d57438dc3523b8a0$export$88f455dd56c95edb(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPopover', slot);
}
const $d57438dc3523b8a0$var$popoverClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPopover', [
    'root',
    'paper'
]);
var $d57438dc3523b8a0$export$2e2bcd8739ae039 = $d57438dc3523b8a0$var$popoverClasses;




// Brought from [Base UI](https://github.com/mui/base-ui/blob/master/packages/react/src/merge-props/mergeProps.ts#L119)
// Use it directly from Base UI once it's a package dependency.
function $b748e9827e4898eb$var$isEventHandler(key, value) {
    // This approach is more efficient than using a regex.
    const thirdCharCode = key.charCodeAt(2);
    return key[0] === 'o' && key[1] === 'n' && thirdCharCode >= 65 /* A */  && thirdCharCode <= 90 /* Z */  && typeof value === 'function';
}
function $b748e9827e4898eb$export$2e2bcd8739ae039(externalSlotProps, defaultSlotProps) {
    if (!externalSlotProps) return defaultSlotProps;
    function extractHandlers(externalSlotPropsValue, defaultSlotPropsValue) {
        const handlers = {};
        Object.keys(defaultSlotPropsValue).forEach((key)=>{
            if ($b748e9827e4898eb$var$isEventHandler(key, defaultSlotPropsValue[key]) && typeof externalSlotPropsValue[key] === 'function') // only compose the handlers if both default and external slot props match the event handler
            handlers[key] = (...args)=>{
                externalSlotPropsValue[key](...args);
                defaultSlotPropsValue[key](...args);
            };
        });
        return handlers;
    }
    if (typeof externalSlotProps === 'function' || typeof defaultSlotProps === 'function') return (ownerState)=>{
        const defaultSlotPropsValue = typeof defaultSlotProps === 'function' ? defaultSlotProps(ownerState) : defaultSlotProps;
        const externalSlotPropsValue = typeof externalSlotProps === 'function' ? externalSlotProps({
            ...ownerState,
            ...defaultSlotPropsValue
        }) : externalSlotProps;
        const className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(ownerState?.className, defaultSlotPropsValue?.className, externalSlotPropsValue?.className);
        const handlers = extractHandlers(externalSlotPropsValue, defaultSlotPropsValue);
        return {
            ...defaultSlotPropsValue,
            ...externalSlotPropsValue,
            ...handlers,
            ...!!className && {
                className: className
            },
            ...defaultSlotPropsValue?.style && externalSlotPropsValue?.style && {
                style: {
                    ...defaultSlotPropsValue.style,
                    ...externalSlotPropsValue.style
                }
            },
            ...defaultSlotPropsValue?.sx && externalSlotPropsValue?.sx && {
                sx: [
                    ...Array.isArray(defaultSlotPropsValue.sx) ? defaultSlotPropsValue.sx : [
                        defaultSlotPropsValue.sx
                    ],
                    ...Array.isArray(externalSlotPropsValue.sx) ? externalSlotPropsValue.sx : [
                        externalSlotPropsValue.sx
                    ]
                ]
            }
        };
    };
    const typedDefaultSlotProps = defaultSlotProps;
    const handlers = extractHandlers(externalSlotProps, typedDefaultSlotProps);
    const className = (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(typedDefaultSlotProps?.className, externalSlotProps?.className);
    return {
        ...defaultSlotProps,
        ...externalSlotProps,
        ...handlers,
        ...!!className && {
            className: className
        },
        ...typedDefaultSlotProps?.style && externalSlotProps?.style && {
            style: {
                ...typedDefaultSlotProps.style,
                ...externalSlotProps.style
            }
        },
        ...typedDefaultSlotProps?.sx && externalSlotProps?.sx && {
            sx: [
                ...Array.isArray(typedDefaultSlotProps.sx) ? typedDefaultSlotProps.sx : [
                    typedDefaultSlotProps.sx
                ],
                ...Array.isArray(externalSlotProps.sx) ? externalSlotProps.sx : [
                    externalSlotProps.sx
                ]
            ]
        }
    };
}



'use client';
function $0420c70951dd1796$export$6fcff0dc60346367(rect, vertical) {
    let offset = 0;
    if (typeof vertical === 'number') offset = vertical;
    else if (vertical === 'center') offset = rect.height / 2;
    else if (vertical === 'bottom') offset = rect.height;
    return offset;
}
function $0420c70951dd1796$export$a6a488ff68b1bf7b(rect, horizontal) {
    let offset = 0;
    if (typeof horizontal === 'number') offset = horizontal;
    else if (horizontal === 'center') offset = rect.width / 2;
    else if (horizontal === 'right') offset = rect.width;
    return offset;
}
function $0420c70951dd1796$var$getTransformOriginValue(transformOrigin) {
    return [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ].map((n)=>typeof n === 'number' ? `${n}px` : n).join(' ');
}
function $0420c70951dd1796$var$resolveAnchorEl(anchorEl) {
    return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}
const $0420c70951dd1796$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $d57438dc3523b8a0$export$88f455dd56c95edb), classes);
};
const $0420c70951dd1796$export$bcce13685275fc99 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Root'
})({});
const $0420c70951dd1796$export$821346c38a2d9390 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiPopover',
    slot: 'Paper'
})({
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $0420c70951dd1796$var$Popover = /*#__PURE__*/ $acw62.forwardRef(function Popover(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiPopover'
    });
    const { action: action, anchorEl: anchorEl, anchorOrigin: anchorOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, anchorPosition: anchorPosition, anchorReference: anchorReference = 'anchorEl', children: children, className: className, container: containerProp, elevation: elevation = 8, marginThreshold: marginThreshold = 16, open: open, PaperProps: PaperPropsProp = {}, slots: // TODO: remove in v7
    slots = {}, slotProps: slotProps = {}, transformOrigin: transformOrigin = {
        vertical: 'top',
        horizontal: 'left'
    }, TransitionComponent: TransitionComponent, // TODO: remove in v7
    transitionDuration: transitionDurationProp = 'auto', TransitionProps: TransitionProps = {}, disableScrollLock: // TODO: remove in v7
    disableScrollLock = false, ...other } = props;
    const paperRef = $acw62.useRef();
    const ownerState = {
        ...props,
        anchorOrigin: anchorOrigin,
        anchorReference: anchorReference,
        elevation: elevation,
        marginThreshold: marginThreshold,
        transformOrigin: transformOrigin,
        TransitionComponent: TransitionComponent,
        transitionDuration: transitionDurationProp,
        TransitionProps: TransitionProps
    };
    const classes = $0420c70951dd1796$var$useUtilityClasses(ownerState);
    // Returns the top/left offset of the position
    // to attach to on the anchor element (or body if none is provided)
    const getAnchorOffset = $acw62.useCallback(()=>{
        if (anchorReference === 'anchorPosition') return anchorPosition;
        const resolvedAnchorEl = $0420c70951dd1796$var$resolveAnchorEl(anchorEl);
        // If an anchor element wasn't provided, just use the parent body element of this Popover
        const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(paperRef.current).body;
        const anchorRect = anchorElement.getBoundingClientRect();
        return {
            top: anchorRect.top + $0420c70951dd1796$export$6fcff0dc60346367(anchorRect, anchorOrigin.vertical),
            left: anchorRect.left + $0420c70951dd1796$export$a6a488ff68b1bf7b(anchorRect, anchorOrigin.horizontal)
        };
    }, [
        anchorEl,
        anchorOrigin.horizontal,
        anchorOrigin.vertical,
        anchorPosition,
        anchorReference
    ]);
    // Returns the base transform origin using the element
    const getTransformOrigin = $acw62.useCallback((elemRect)=>{
        return {
            vertical: $0420c70951dd1796$export$6fcff0dc60346367(elemRect, transformOrigin.vertical),
            horizontal: $0420c70951dd1796$export$a6a488ff68b1bf7b(elemRect, transformOrigin.horizontal)
        };
    }, [
        transformOrigin.horizontal,
        transformOrigin.vertical
    ]);
    const getPositioningStyle = $acw62.useCallback((element)=>{
        const elemRect = {
            width: element.offsetWidth,
            height: element.offsetHeight
        };
        // Get the transform origin point on the element itself
        const elemTransformOrigin = getTransformOrigin(elemRect);
        if (anchorReference === 'none') return {
            top: null,
            left: null,
            transformOrigin: $0420c70951dd1796$var$getTransformOriginValue(elemTransformOrigin)
        };
        // Get the offset of the anchoring element
        const anchorOffset = getAnchorOffset();
        // Calculate element positioning
        let top = anchorOffset.top - elemTransformOrigin.vertical;
        let left = anchorOffset.left - elemTransformOrigin.horizontal;
        const bottom = top + elemRect.height;
        const right = left + elemRect.width;
        // Use the parent window of the anchorEl if provided
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)($0420c70951dd1796$var$resolveAnchorEl(anchorEl));
        // Window thresholds taking required margin into account
        const heightThreshold = containerWindow.innerHeight - marginThreshold;
        const widthThreshold = containerWindow.innerWidth - marginThreshold;
        // Check if the vertical axis needs shifting
        if (marginThreshold !== null && top < marginThreshold) {
            const diff = top - marginThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        } else if (marginThreshold !== null && bottom > heightThreshold) {
            const diff = bottom - heightThreshold;
            top -= diff;
            elemTransformOrigin.vertical += diff;
        }
        // Check if the horizontal axis needs shifting
        if (marginThreshold !== null && left < marginThreshold) {
            const diff = left - marginThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        } else if (right > widthThreshold) {
            const diff = right - widthThreshold;
            left -= diff;
            elemTransformOrigin.horizontal += diff;
        }
        return {
            top: `${Math.round(top)}px`,
            left: `${Math.round(left)}px`,
            transformOrigin: $0420c70951dd1796$var$getTransformOriginValue(elemTransformOrigin)
        };
    }, [
        anchorEl,
        anchorReference,
        getAnchorOffset,
        getTransformOrigin,
        marginThreshold
    ]);
    const [isPositioned, setIsPositioned] = $acw62.useState(open);
    const setPositioningStyles = $acw62.useCallback(()=>{
        const element = paperRef.current;
        if (!element) return;
        const positioning = getPositioningStyle(element);
        if (positioning.top !== null) element.style.setProperty('top', positioning.top);
        if (positioning.left !== null) element.style.left = positioning.left;
        element.style.transformOrigin = positioning.transformOrigin;
        setIsPositioned(true);
    }, [
        getPositioningStyle
    ]);
    $acw62.useEffect(()=>{
        if (disableScrollLock) window.addEventListener('scroll', setPositioningStyles);
        return ()=>window.removeEventListener('scroll', setPositioningStyles);
    }, [
        anchorEl,
        disableScrollLock,
        setPositioningStyles
    ]);
    const handleEntering = ()=>{
        setPositioningStyles();
    };
    const handleExited = ()=>{
        setIsPositioned(false);
    };
    $acw62.useEffect(()=>{
        if (open) setPositioningStyles();
    });
    $acw62.useImperativeHandle(action, ()=>open ? {
            updatePosition: ()=>{
                setPositioningStyles();
            }
        } : null, [
        open,
        setPositioningStyles
    ]);
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            setPositioningStyles();
        });
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)($0420c70951dd1796$var$resolveAnchorEl(anchorEl));
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        anchorEl,
        open,
        setPositioningStyles
    ]);
    let transitionDuration = transitionDurationProp;
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            transition: TransitionProps,
            paper: PaperPropsProp,
            ...slotProps
        }
    };
    const [TransitionSlot, transitionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $5a8449c70e836e71$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onEntering: (element, isAppearing)=>{
                    handlers.onEntering?.(element, isAppearing);
                    handleEntering();
                },
                onExited: (element)=>{
                    handlers.onExited?.(element);
                    handleExited();
                }
            }),
        additionalProps: {
            appear: true,
            in: open
        }
    });
    if (transitionDurationProp === 'auto' && !TransitionSlot.muiSupportAuto) transitionDuration = undefined;
    // If the container prop is provided, use that
    // If the anchorEl prop is provided, use its parent body element as the container
    // If neither are provided let the Modal take care of choosing the container
    const container = containerProp || (anchorEl ? (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)($0420c70951dd1796$var$resolveAnchorEl(anchorEl)).body : undefined);
    const [RootSlot, { slots: rootSlotsProp, slotProps: rootSlotPropsProp, ...rootProps }] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $0420c70951dd1796$export$bcce13685275fc99,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        shouldForwardComponentProp: true,
        additionalProps: {
            slots: {
                backdrop: slots.backdrop
            },
            slotProps: {
                backdrop: (0, $b748e9827e4898eb$export$2e2bcd8739ae039)(typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop, {
                    invisible: true
                })
            },
            container: container,
            open: open
        },
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className)
    });
    const [PaperSlot, paperProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        ref: paperRef,
        className: classes.paper,
        elementType: $0420c70951dd1796$export$821346c38a2d9390,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        additionalProps: {
            elevation: elevation,
            style: isPositioned ? undefined : {
                opacity: 0
            }
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RootSlot, {
        ...rootProps,
        ...!(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(RootSlot) && {
            slots: rootSlotsProp,
            slotProps: rootSlotPropsProp,
            disableScrollLock: disableScrollLock
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            timeout: transitionDuration,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PaperSlot, {
                ...paperProps,
                children: children
            })
        })
    });
});
var $0420c70951dd1796$export$2e2bcd8739ae039 = $0420c70951dd1796$var$Popover;







function $ef00757e7f408a3f$export$2cf86a63a84fe23d(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiMenu', slot);
}
const $ef00757e7f408a3f$var$menuClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiMenu', [
    'root',
    'paper',
    'list'
]);
var $ef00757e7f408a3f$export$2e2bcd8739ae039 = $ef00757e7f408a3f$var$menuClasses;




'use client';
const $81db31f1007c14e1$var$RTL_ORIGIN = {
    vertical: 'top',
    horizontal: 'right'
};
const $81db31f1007c14e1$var$LTR_ORIGIN = {
    vertical: 'top',
    horizontal: 'left'
};
const $81db31f1007c14e1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ],
        list: [
            'list'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $ef00757e7f408a3f$export$2cf86a63a84fe23d), classes);
};
const $81db31f1007c14e1$var$MenuRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $0420c70951dd1796$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiMenu',
    slot: 'Root'
})({});
const $81db31f1007c14e1$export$4f7c51a5920c9f33 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $0420c70951dd1796$export$821346c38a2d9390), {
    name: 'MuiMenu',
    slot: 'Paper'
})({
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tappable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling for iOS < 13.0
    WebkitOverflowScrolling: 'touch'
});
const $81db31f1007c14e1$var$MenuMenuList = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $7c6e657321c9c45b$export$2e2bcd8739ae039), {
    name: 'MuiMenu',
    slot: 'List'
})({
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
});
const $81db31f1007c14e1$var$Menu = /*#__PURE__*/ $acw62.forwardRef(function Menu(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiMenu'
    });
    const { autoFocus: autoFocus = true, children: children, className: className, disableAutoFocusItem: disableAutoFocusItem = false, MenuListProps: MenuListProps = {}, onClose: onClose, open: open, PaperProps: PaperProps = {}, PopoverClasses: PopoverClasses, transitionDuration: transitionDuration = 'auto', TransitionProps: { onEntering: onEntering, ...TransitionProps } = {}, variant: variant = 'selectedMenu', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        disableAutoFocusItem: disableAutoFocusItem,
        MenuListProps: MenuListProps,
        onEntering: onEntering,
        PaperProps: PaperProps,
        transitionDuration: transitionDuration,
        TransitionProps: TransitionProps,
        variant: variant
    };
    const classes = $81db31f1007c14e1$var$useUtilityClasses(ownerState);
    const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
    const menuListActionsRef = $acw62.useRef(null);
    const handleEntering = (element, isAppearing)=>{
        if (menuListActionsRef.current) menuListActionsRef.current.adjustStyleForScrollbar(element, {
            direction: isRtl ? 'rtl' : 'ltr'
        });
        if (onEntering) onEntering(element, isAppearing);
    };
    const handleListKeyDown = (event)=>{
        if (event.key === 'Tab') {
            event.preventDefault();
            if (onClose) onClose(event, 'tabKeyDown');
        }
    };
    /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */ let activeItemIndex = -1;
    // since we inject focus related props into children we have to do a lookahead
    // to check if there is a `selected` item. We're looking for the last `selected`
    // item and use the first valid item as a fallback
    $acw62.Children.map(children, (child, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return;
        if (!child.props.disabled) {
            if (variant === 'selectedMenu' && child.props.selected) activeItemIndex = index;
            else if (activeItemIndex === -1) activeItemIndex = index;
        }
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            list: MenuListProps,
            transition: TransitionProps,
            paper: PaperProps,
            ...slotProps
        }
    };
    const rootSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.root,
        externalSlotProps: slotProps.root,
        ownerState: ownerState,
        className: [
            classes.root,
            className
        ]
    });
    const [PaperSlot, paperSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        className: classes.paper,
        elementType: $81db31f1007c14e1$export$4f7c51a5920c9f33,
        externalForwardedProps: externalForwardedProps,
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    const [ListSlot, listSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('list', {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.list, MenuListProps.className),
        elementType: $81db31f1007c14e1$var$MenuMenuList,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleListKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            }),
        ownerState: ownerState
    });
    const resolvedTransitionProps = typeof externalForwardedProps.slotProps.transition === 'function' ? externalForwardedProps.slotProps.transition(ownerState) : externalForwardedProps.slotProps.transition;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($81db31f1007c14e1$var$MenuRoot, {
        onClose: onClose,
        anchorOrigin: {
            vertical: 'bottom',
            horizontal: isRtl ? 'right' : 'left'
        },
        transformOrigin: isRtl ? $81db31f1007c14e1$var$RTL_ORIGIN : $81db31f1007c14e1$var$LTR_ORIGIN,
        slots: {
            root: slots.root,
            paper: PaperSlot,
            backdrop: slots.backdrop,
            ...slots.transition && {
                // TODO: pass `slots.transition` directly once `TransitionComponent` is removed from Popover
                transition: slots.transition
            }
        },
        slotProps: {
            root: rootSlotProps,
            paper: paperSlotProps,
            backdrop: typeof slotProps.backdrop === 'function' ? slotProps.backdrop(ownerState) : slotProps.backdrop,
            transition: {
                ...resolvedTransitionProps,
                onEntering: (...args)=>{
                    handleEntering(...args);
                    resolvedTransitionProps?.onEntering?.(...args);
                }
            }
        },
        open: open,
        ref: ref,
        transitionDuration: transitionDuration,
        ownerState: ownerState,
        ...other,
        classes: PopoverClasses,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ListSlot, {
            actions: menuListActionsRef,
            autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
            autoFocusItem: autoFocusItem,
            variant: variant,
            ...listSlotProps,
            children: children
        })
    });
});
var $81db31f1007c14e1$export$2e2bcd8739ae039 = $81db31f1007c14e1$var$Menu;



var $acw62 = parcelRequire("acw62");







function $d0b029d306802dc1$export$1ee13051fd9e2ab5(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiNativeSelect', slot);
}
const $d0b029d306802dc1$var$nativeSelectClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiNativeSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $d0b029d306802dc1$export$2e2bcd8739ae039 = $d0b029d306802dc1$var$nativeSelectClasses;





'use client';
const $5218b8cdffce5874$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $d0b029d306802dc1$export$1ee13051fd9e2ab5), classes);
};
const $5218b8cdffce5874$export$50b3545a8ccd87af = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('select', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // Reset
        MozAppearance: 'none',
        // Reset
        WebkitAppearance: 'none',
        // When interacting quickly, the text can end up selected.
        // Native select can't be selected either.
        userSelect: 'none',
        // Reset
        borderRadius: 0,
        cursor: 'pointer',
        '&:focus': {
            // Reset Chrome style
            borderRadius: 0
        },
        [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        '&[multiple]': {
            height: 'auto'
        },
        '&:not([multiple]) option, &:not([multiple]) optgroup': {
            backgroundColor: (theme.vars || theme).palette.background.paper
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'filled' && ownerState.variant !== 'outlined',
                style: {
                    // Bump specificity to allow extending custom inputs
                    '&&&': {
                        paddingRight: 24,
                        minWidth: 16 // So it doesn't collapse.
                    }
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    '&&&': {
                        paddingRight: 32
                    }
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius,
                    '&:focus': {
                        borderRadius: (theme.vars || theme).shape.borderRadius // Reset the reset for Chrome style
                    },
                    '&&&': {
                        paddingRight: 32
                    }
                }
            }
        ]
    }));
const $5218b8cdffce5874$var$NativeSelectSelect = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)($5218b8cdffce5874$export$50b3545a8ccd87af, {
    name: 'MuiNativeSelect',
    slot: 'Select',
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039),
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.select,
            styles[ownerState.variant],
            ownerState.error && styles.error,
            {
                [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({});
const $5218b8cdffce5874$export$7dd4d92f143902e3 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('svg', {
    name: 'MuiNativeSelect'
})(({ theme: theme })=>({
        // We use a position absolute over a flexbox in order to forward the pointer events
        // to the input and to support wrapping tags..
        position: 'absolute',
        right: 0,
        // Center vertically, height is 1em
        top: 'calc(50% - .5em)',
        // Don't block pointer events on the select under the icon.
        pointerEvents: 'none',
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $d0b029d306802dc1$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.open,
                style: {
                    transform: 'rotate(180deg)'
                }
            },
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    right: 7
                }
            },
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    right: 7
                }
            }
        ]
    }));
const $5218b8cdffce5874$var$NativeSelectIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)($5218b8cdffce5874$export$7dd4d92f143902e3, {
    name: 'MuiNativeSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
/**
 * @ignore - internal component.
 */ const $5218b8cdffce5874$var$NativeSelectInput = /*#__PURE__*/ $acw62.forwardRef(function NativeSelectInput(props, ref) {
    const { className: className, disabled: disabled, error: error, IconComponent: IconComponent, inputRef: inputRef, variant: variant = 'standard', ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        variant: variant,
        error: error
    };
    const classes = $5218b8cdffce5874$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5218b8cdffce5874$var$NativeSelectSelect, {
                ownerState: ownerState,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.select, className),
                disabled: disabled,
                ref: inputRef || ref,
                ...other
            }),
            props.multiple ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5218b8cdffce5874$var$NativeSelectIcon, {
                as: IconComponent,
                ownerState: ownerState,
                className: classes.icon
            })
        ]
    });
});
var $5218b8cdffce5874$export$2e2bcd8739ae039 = $5218b8cdffce5874$var$NativeSelectInput;







var $acw62 = parcelRequire("acw62");
'use client';
function $77aad105771eb889$export$2e2bcd8739ae039(props) {
    const { controlled: controlled, default: defaultProp, name: name, state: state = 'value' } = props;
    // isControlled is ignored in the hook dependency lists as it should never change.
    const { current: isControlled } = $acw62.useRef(controlled !== undefined);
    const [valueState, setValue] = $acw62.useState(defaultProp);
    const value = isControlled ? controlled : valueState;
    const setValueIfUncontrolled = $acw62.useCallback((newValue)=>{
        if (!isControlled) setValue(newValue);
    }, []);
    // TODO: provide overloads for the useControlled function to account for the case where either
    // controlled or default is not undefined.
    // In that case the return type should be [T, React.Dispatch<React.SetStateAction<T>>]
    // otherwise it should be [T | undefined, React.Dispatch<React.SetStateAction<T | undefined>>]
    return [
        value,
        setValueIfUncontrolled
    ];
}


'use client';
var $3c946fbcfb716a43$export$2e2bcd8739ae039 = (0, $77aad105771eb889$export$2e2bcd8739ae039);




function $384af05952ac69db$export$2c0c1ee5a3392e(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiSelect', slot);
}
const $384af05952ac69db$var$selectClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiSelect', [
    'root',
    'select',
    'multiple',
    'filled',
    'outlined',
    'standard',
    'disabled',
    'focused',
    'icon',
    'iconOpen',
    'iconFilled',
    'iconOutlined',
    'iconStandard',
    'nativeInput',
    'error'
]);
var $384af05952ac69db$export$2e2bcd8739ae039 = $384af05952ac69db$var$selectClasses;



'use client';
var $0dd118e425182cac$var$_span;
const $0dd118e425182cac$var$SelectSelect = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5218b8cdffce5874$export$50b3545a8ccd87af), {
    name: 'MuiSelect',
    slot: 'Select',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            // Win specificity over the input base
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: styles.select
            },
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: styles[ownerState.variant]
            },
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).error}`]: styles.error
            },
            {
                [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).multiple}`]: styles.multiple
            }
        ];
    }
})({
    // Win specificity over the input base
    [`&.${(0, $384af05952ac69db$export$2e2bcd8739ae039).select}`]: {
        height: 'auto',
        // Resets for multiple select with chips
        minHeight: '1.4375em',
        // Required for select\text-field height consistency
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden'
    }
});
const $0dd118e425182cac$var$SelectIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5218b8cdffce5874$export$7dd4d92f143902e3), {
    name: 'MuiSelect',
    slot: 'Icon',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.icon,
            ownerState.variant && styles[`icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.variant)}`],
            ownerState.open && styles.iconOpen
        ];
    }
})({});
const $0dd118e425182cac$var$SelectNativeInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('input', {
    shouldForwardProp: (prop)=>(0, $7109435727661db9$export$2e2bcd8739ae039)(prop) && prop !== 'classes',
    name: 'MuiSelect',
    slot: 'NativeInput'
})({
    bottom: 0,
    left: 0,
    position: 'absolute',
    opacity: 0,
    pointerEvents: 'none',
    width: '100%',
    boxSizing: 'border-box'
});
function $0dd118e425182cac$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
function $0dd118e425182cac$var$isEmpty(display) {
    return display == null || typeof display === 'string' && !display.trim();
}
const $0dd118e425182cac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, disabled: disabled, multiple: multiple, open: open, error: error } = ownerState;
    const slots = {
        select: [
            'select',
            variant,
            disabled && 'disabled',
            multiple && 'multiple',
            error && 'error'
        ],
        icon: [
            'icon',
            `icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}`,
            open && 'iconOpen',
            disabled && 'disabled'
        ],
        nativeInput: [
            'nativeInput'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $384af05952ac69db$export$2c0c1ee5a3392e), classes);
};
/**
 * @ignore - internal component.
 */ const $0dd118e425182cac$var$SelectInput = /*#__PURE__*/ $acw62.forwardRef(function SelectInput(props, ref) {
    const { 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, autoFocus: autoFocus, autoWidth: autoWidth, children: children, className: className, defaultOpen: defaultOpen, defaultValue: defaultValue, disabled: disabled, displayEmpty: displayEmpty, error: error = false, IconComponent: IconComponent, inputRef: inputRefProp, labelId: labelId, MenuProps: MenuProps = {}, multiple: multiple, name: name, onBlur: onBlur, onChange: onChange, onClose: onClose, onFocus: onFocus, onOpen: onOpen, open: openProp, readOnly: readOnly, renderValue: renderValue, required: required, SelectDisplayProps: SelectDisplayProps = {}, tabIndex: tabIndexProp, type: // catching `type` from Input which makes no sense for SelectInput
    type, value: valueProp, variant: variant = 'standard', ...other } = props;
    const [value, setValueState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: 'Select'
    });
    const [openState, setOpenState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: defaultOpen,
        name: 'Select'
    });
    const inputRef = $acw62.useRef(null);
    const displayRef = $acw62.useRef(null);
    const [displayNode, setDisplayNode] = $acw62.useState(null);
    const { current: isOpenControlled } = $acw62.useRef(openProp != null);
    const [menuMinWidthState, setMenuMinWidthState] = $acw62.useState();
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, inputRefProp);
    const handleDisplayRef = $acw62.useCallback((node)=>{
        displayRef.current = node;
        if (node) setDisplayNode(node);
    }, []);
    const anchorElement = displayNode?.parentNode;
    $acw62.useImperativeHandle(handleRef, ()=>({
            focus: ()=>{
                displayRef.current.focus();
            },
            node: inputRef.current,
            value: value
        }), [
        value
    ]);
    // Resize menu on `defaultOpen` automatic toggle.
    $acw62.useEffect(()=>{
        if (defaultOpen && openState && displayNode && !isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            displayRef.current.focus();
        }
    // TODO: uncomment once we enable eslint-plugin-react-compiler // eslint-disable-next-line react-compiler/react-compiler
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        displayNode,
        autoWidth
    ]);
    // `isOpenControlled` is ignored because the component should never switch between controlled and uncontrolled modes.
    // `defaultOpen` and `openState` are ignored to avoid unnecessary callbacks.
    $acw62.useEffect(()=>{
        if (autoFocus) displayRef.current.focus();
    }, [
        autoFocus
    ]);
    $acw62.useEffect(()=>{
        if (!labelId) return undefined;
        const label = (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(displayRef.current).getElementById(labelId);
        if (label) {
            const handler = ()=>{
                if (getSelection().isCollapsed) displayRef.current.focus();
            };
            label.addEventListener('click', handler);
            return ()=>{
                label.removeEventListener('click', handler);
            };
        }
        return undefined;
    }, [
        labelId
    ]);
    const update = (open, event)=>{
        if (open) {
            if (onOpen) onOpen(event);
        } else if (onClose) onClose(event);
        if (!isOpenControlled) {
            setMenuMinWidthState(autoWidth ? null : anchorElement.clientWidth);
            setOpenState(open);
        }
    };
    const handleMouseDown = (event)=>{
        // Ignore everything but left-click
        if (event.button !== 0) return;
        // Hijack the default focus behavior.
        event.preventDefault();
        displayRef.current.focus();
        update(true, event);
    };
    const handleClose = (event)=>{
        update(false, event);
    };
    const childrenArray = $acw62.Children.toArray(children);
    // Support autofill.
    const handleChange = (event)=>{
        const child = childrenArray.find((childItem)=>childItem.props.value === event.target.value);
        if (child === undefined) return;
        setValueState(child.props.value);
        if (onChange) onChange(event, child);
    };
    const handleItemClick = (child)=>(event)=>{
            let newValue;
            // We use the tabindex attribute to signal the available options.
            if (!event.currentTarget.hasAttribute('tabindex')) return;
            if (multiple) {
                newValue = Array.isArray(value) ? value.slice() : [];
                const itemIndex = value.indexOf(child.props.value);
                if (itemIndex === -1) newValue.push(child.props.value);
                else newValue.splice(itemIndex, 1);
            } else newValue = child.props.value;
            if (child.props.onClick) child.props.onClick(event);
            if (value !== newValue) {
                setValueState(newValue);
                if (onChange) {
                    // Redefine target to allow name and value to be read.
                    // This allows seamless integration with the most popular form libraries.
                    // https://github.com/mui/material-ui/issues/13485#issuecomment-676048492
                    // Clone the event to not override `target` of the original event.
                    const nativeEvent = event.nativeEvent || event;
                    const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
                    Object.defineProperty(clonedEvent, 'target', {
                        writable: true,
                        value: {
                            value: newValue,
                            name: name
                        }
                    });
                    onChange(clonedEvent, child);
                }
            }
            if (!multiple) update(false, event);
        };
    const handleKeyDown = (event)=>{
        if (!readOnly) {
            const validKeys = [
                ' ',
                'ArrowUp',
                'ArrowDown',
                // The native select doesn't respond to enter on macOS, but it's recommended by
                // https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-select-only/
                'Enter'
            ];
            if (validKeys.includes(event.key)) {
                event.preventDefault();
                update(true, event);
            }
        }
    };
    const open = displayNode !== null && openState;
    const handleBlur = (event)=>{
        // if open event.stopImmediatePropagation
        if (!open && onBlur) {
            // Preact support, target is read only property on a native event.
            Object.defineProperty(event, 'target', {
                writable: true,
                value: {
                    value: value,
                    name: name
                }
            });
            onBlur(event);
        }
    };
    delete other['aria-invalid'];
    let display;
    let displaySingle;
    const displayMultiple = [];
    let computeDisplay = false;
    let foundMatch = false;
    // No need to display any value if the field is empty.
    if ((0, $beb6670688e6a4c6$export$d652b828d7fdeff8)({
        value: value
    }) || displayEmpty) {
        if (renderValue) display = renderValue(value);
        else computeDisplay = true;
    }
    const items = childrenArray.map((child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        let selected;
        if (multiple) {
            if (!Array.isArray(value)) throw new Error((0, $90895d1859655b11$export$2e2bcd8739ae039)(2));
            selected = value.some((v)=>$0dd118e425182cac$var$areEqualValues(v, child.props.value));
            if (selected && computeDisplay) displayMultiple.push(child.props.children);
        } else {
            selected = $0dd118e425182cac$var$areEqualValues(value, child.props.value);
            if (selected && computeDisplay) displaySingle = child.props.children;
        }
        if (selected) foundMatch = true;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            'aria-selected': selected ? 'true' : 'false',
            onClick: handleItemClick(child),
            onKeyUp: (event)=>{
                if (event.key === ' ') // otherwise our MenuItems dispatches a click event
                // it's not behavior of the native <option> and causes
                // the select to close immediately since we open on space keydown
                event.preventDefault();
                if (child.props.onKeyUp) child.props.onKeyUp(event);
            },
            role: 'option',
            selected: selected,
            value: undefined,
            // The value is most likely not a valid HTML attribute.
            'data-value': child.props.value // Instead, we provide it as a data attribute.
        });
    });
    var x, x1;
    if (computeDisplay) {
        if (multiple) {
            if (displayMultiple.length === 0) display = null;
            else display = displayMultiple.reduce((output, child, index)=>{
                output.push(child);
                if (index < displayMultiple.length - 1) output.push(', ');
                return output;
            }, []);
        } else display = displaySingle;
    }
    // Avoid performing a layout computation in the render method.
    let menuMinWidth = menuMinWidthState;
    if (!autoWidth && isOpenControlled && displayNode) menuMinWidth = anchorElement.clientWidth;
    let tabIndex;
    if (typeof tabIndexProp !== 'undefined') tabIndex = tabIndexProp;
    else tabIndex = disabled ? null : 0;
    const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);
    const ownerState = {
        ...props,
        variant: variant,
        value: value,
        open: open,
        error: error
    };
    const classes = $0dd118e425182cac$var$useUtilityClasses(ownerState);
    const paperProps = {
        ...MenuProps.PaperProps,
        ...typeof MenuProps.slotProps?.paper === 'function' ? MenuProps.slotProps.paper(ownerState) : MenuProps.slotProps?.paper
    };
    const listProps = {
        ...MenuProps.MenuListProps,
        ...typeof MenuProps.slotProps?.list === 'function' ? MenuProps.slotProps.list(ownerState) : MenuProps.slotProps?.list
    };
    const listboxId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0dd118e425182cac$var$SelectSelect, {
                as: "div",
                ref: handleDisplayRef,
                tabIndex: tabIndex,
                role: "combobox",
                "aria-controls": open ? listboxId : undefined,
                "aria-disabled": disabled ? 'true' : undefined,
                "aria-expanded": open ? 'true' : 'false',
                "aria-haspopup": "listbox",
                "aria-label": ariaLabel,
                "aria-labelledby": [
                    labelId,
                    buttonId
                ].filter(Boolean).join(' ') || undefined,
                "aria-describedby": ariaDescribedby,
                "aria-required": required ? 'true' : undefined,
                "aria-invalid": error ? 'true' : undefined,
                onKeyDown: handleKeyDown,
                onMouseDown: disabled || readOnly ? null : handleMouseDown,
                onBlur: handleBlur,
                onFocus: onFocus,
                ...SelectDisplayProps,
                ownerState: ownerState,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(SelectDisplayProps.className, classes.select, className),
                id: buttonId,
                children: $0dd118e425182cac$var$isEmpty(display) ? $0dd118e425182cac$var$_span || ($0dd118e425182cac$var$_span = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: "notranslate",
                    "aria-hidden": true,
                    children: "\u200B"
                })) : display
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0dd118e425182cac$var$SelectNativeInput, {
                "aria-invalid": error,
                value: Array.isArray(value) ? value.join(',') : value,
                name: name,
                ref: inputRef,
                "aria-hidden": true,
                onChange: handleChange,
                tabIndex: -1,
                disabled: disabled,
                className: classes.nativeInput,
                autoFocus: autoFocus,
                required: required,
                ...other,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0dd118e425182cac$var$SelectIcon, {
                as: IconComponent,
                className: classes.icon,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81db31f1007c14e1$export$2e2bcd8739ae039), {
                id: `menu-${name || ''}`,
                anchorEl: anchorElement,
                open: open,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                ...MenuProps,
                slotProps: {
                    ...MenuProps.slotProps,
                    list: {
                        'aria-labelledby': labelId,
                        role: 'listbox',
                        'aria-multiselectable': multiple ? 'true' : undefined,
                        disableListWrap: true,
                        id: listboxId,
                        ...listProps
                    },
                    paper: {
                        ...paperProps,
                        style: {
                            minWidth: menuMinWidth,
                            ...paperProps != null ? paperProps.style : null
                        }
                    }
                },
                children: items
            })
        ]
    });
});
var $0dd118e425182cac$export$2e2bcd8739ae039 = $0dd118e425182cac$var$SelectInput;




parcelRequire("acw62");


'use client';
var $ade182381ccbdcec$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');












'use client';
const $13a94221f14f71e8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $384af05952ac69db$export$2c0c1ee5a3392e), classes);
    return {
        ...classes,
        ...composedClasses
    };
};
const $13a94221f14f71e8$var$styledRootConfig = {
    name: 'MuiSelect',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) && prop !== 'variant'
};
const $13a94221f14f71e8$var$StyledInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3745a2c6ea1264ac$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$StyledOutlinedInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $fe946640f9150f45$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$StyledFilledInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $215c05c02ba2f8f4$export$2e2bcd8739ae039), $13a94221f14f71e8$var$styledRootConfig)('');
const $13a94221f14f71e8$var$Select = /*#__PURE__*/ $acw62.forwardRef(function Select(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        name: 'MuiSelect',
        props: inProps
    });
    const { autoWidth: autoWidth = false, children: children, classes: classesProp = {}, className: className, defaultOpen: defaultOpen = false, displayEmpty: displayEmpty = false, IconComponent: IconComponent = (0, $ade182381ccbdcec$export$2e2bcd8739ae039), id: id, input: input, inputProps: inputProps, label: label, labelId: labelId, MenuProps: MenuProps, multiple: multiple = false, native: native = false, onClose: onClose, onOpen: onOpen, open: open, renderValue: renderValue, SelectDisplayProps: SelectDisplayProps, variant: variantProp = 'outlined', ...other } = props;
    const inputComponent = native ? (0, $5218b8cdffce5874$export$2e2bcd8739ae039) : (0, $0dd118e425182cac$export$2e2bcd8739ae039);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'variant',
            'error'
        ]
    });
    const variant = fcs.variant || variantProp;
    const ownerState = {
        ...props,
        variant: variant,
        classes: classesProp
    };
    const classes = $13a94221f14f71e8$var$useUtilityClasses(ownerState);
    const { root: root, ...restOfClasses } = classes;
    const InputComponent = input || ({
        standard: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($13a94221f14f71e8$var$StyledInput, {
            ownerState: ownerState
        }),
        outlined: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($13a94221f14f71e8$var$StyledOutlinedInput, {
            label: label,
            ownerState: ownerState
        }),
        filled: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($13a94221f14f71e8$var$StyledFilledInput, {
            ownerState: ownerState
        })
    })[variant];
    const inputComponentRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, (0, $1d88113360503233$export$2e2bcd8739ae039)(InputComponent));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: /*#__PURE__*/ $acw62.cloneElement(InputComponent, {
            inputComponent: // Most of the logic is implemented in `SelectInput`.
            // The `Select` component is a simple API wrapper to expose something better to play with.
            inputComponent,
            inputProps: {
                children: children,
                error: fcs.error,
                IconComponent: IconComponent,
                variant: variant,
                type: undefined,
                multiple: // We render a select. We can ignore the type provided by the `Input`.
                multiple,
                ...native ? {
                    id: id
                } : {
                    autoWidth: autoWidth,
                    defaultOpen: defaultOpen,
                    displayEmpty: displayEmpty,
                    labelId: labelId,
                    MenuProps: MenuProps,
                    onClose: onClose,
                    onOpen: onOpen,
                    open: open,
                    renderValue: renderValue,
                    SelectDisplayProps: {
                        id: id,
                        ...SelectDisplayProps
                    }
                },
                ...inputProps,
                classes: inputProps ? (0, $2985df77ba145d35$export$2e2bcd8739ae039)(restOfClasses, inputProps.classes) : restOfClasses,
                ...input ? input.props.inputProps : {}
            },
            ...(multiple && native || displayEmpty) && variant === 'outlined' ? {
                notched: true
            } : {},
            ref: inputComponentRef,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(InputComponent.props.className, className, classes.root),
            // If a custom input is provided via 'input' prop, do not allow 'variant' to be propagated to it's root element. See https://github.com/mui/material-ui/issues/33894.
            ...!input && {
                variant: variant
            },
            ...other
        })
    });
});
$13a94221f14f71e8$var$Select.muiName = 'Select';
var $13a94221f14f71e8$export$2e2bcd8739ae039 = $13a94221f14f71e8$var$Select;




function $e71b8b43f7b2f425$export$c1bdcbaf0596aeda(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTextField', slot);
}
const $e71b8b43f7b2f425$var$textFieldClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTextField', [
    'root'
]);
var $e71b8b43f7b2f425$export$2e2bcd8739ae039 = $e71b8b43f7b2f425$var$textFieldClasses;




'use client';
const $f480fb6201951027$var$variantComponent = {
    standard: (0, $3745a2c6ea1264ac$export$2e2bcd8739ae039),
    filled: (0, $215c05c02ba2f8f4$export$2e2bcd8739ae039),
    outlined: (0, $fe946640f9150f45$export$2e2bcd8739ae039)
};
const $f480fb6201951027$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $e71b8b43f7b2f425$export$c1bdcbaf0596aeda), classes);
};
const $f480fb6201951027$var$TextFieldRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
    name: 'MuiTextField',
    slot: 'Root'
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/material-ui/api/form-control/)
 * - [InputLabel](/material-ui/api/input-label/)
 * - [FilledInput](/material-ui/api/filled-input/)
 * - [OutlinedInput](/material-ui/api/outlined-input/)
 * - [Input](/material-ui/api/input/)
 * - [FormHelperText](/material-ui/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */ const $f480fb6201951027$var$TextField = /*#__PURE__*/ $acw62.forwardRef(function TextField(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTextField'
    });
    const { autoComplete: autoComplete, autoFocus: autoFocus = false, children: children, className: className, color: color = 'primary', defaultValue: defaultValue, disabled: disabled = false, error: error = false, FormHelperTextProps: FormHelperTextPropsProp, fullWidth: fullWidth = false, helperText: helperText, id: idOverride, InputLabelProps: InputLabelPropsProp, inputProps: inputPropsProp, InputProps: InputPropsProp, inputRef: inputRef, label: label, maxRows: maxRows, minRows: minRows, multiline: multiline = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, placeholder: placeholder, required: required = false, rows: rows, select: select = false, SelectProps: SelectPropsProp, slots: slots = {}, slotProps: slotProps = {}, type: type, value: value, variant: variant = 'outlined', ...other } = props;
    const ownerState = {
        ...props,
        autoFocus: autoFocus,
        color: color,
        disabled: disabled,
        error: error,
        fullWidth: fullWidth,
        multiline: multiline,
        required: required,
        select: select,
        variant: variant
    };
    const classes = $f480fb6201951027$var$useUtilityClasses(ownerState);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idOverride);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const InputComponent = $f480fb6201951027$var$variantComponent[variant];
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: InputPropsProp,
            inputLabel: InputLabelPropsProp,
            htmlInput: inputPropsProp,
            formHelperText: FormHelperTextPropsProp,
            select: SelectPropsProp,
            ...slotProps
        }
    };
    const inputAdditionalProps = {};
    const inputLabelSlotProps = externalForwardedProps.slotProps.inputLabel;
    if (variant === 'outlined') {
        if (inputLabelSlotProps && typeof inputLabelSlotProps.shrink !== 'undefined') inputAdditionalProps.notched = inputLabelSlotProps.shrink;
        inputAdditionalProps.label = label;
    }
    if (select) {
        // unset defaults from textbox inputs
        if (!SelectPropsProp || !SelectPropsProp.native) inputAdditionalProps.id = undefined;
        inputAdditionalProps['aria-describedby'] = undefined;
    }
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $f480fb6201951027$var$TextFieldRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        additionalProps: {
            disabled: disabled,
            error: error,
            fullWidth: fullWidth,
            required: required,
            color: color,
            variant: variant
        }
    });
    const [InputSlot, inputProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('input', {
        elementType: InputComponent,
        externalForwardedProps: externalForwardedProps,
        additionalProps: inputAdditionalProps,
        ownerState: ownerState
    });
    const [InputLabelSlot, inputLabelProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('inputLabel', {
        elementType: (0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [HtmlInputSlot, htmlInputProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('htmlInput', {
        elementType: 'input',
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [FormHelperTextSlot, formHelperTextProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('formHelperText', {
        elementType: (0, $937760e70ffc7914$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectSlot, selectProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('select', {
        elementType: (0, $13a94221f14f71e8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const InputElement = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(InputSlot, {
        "aria-describedby": helperTextId,
        autoComplete: autoComplete,
        autoFocus: autoFocus,
        defaultValue: defaultValue,
        fullWidth: fullWidth,
        multiline: multiline,
        name: name,
        rows: rows,
        maxRows: maxRows,
        minRows: minRows,
        type: type,
        value: value,
        id: id,
        inputRef: inputRef,
        onBlur: onBlur,
        onChange: onChange,
        onFocus: onFocus,
        placeholder: placeholder,
        inputProps: htmlInputProps,
        slots: {
            input: slots.htmlInput ? HtmlInputSlot : undefined
        },
        ...inputProps
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            label != null && label !== '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(InputLabelSlot, {
                htmlFor: id,
                id: inputLabelId,
                ...inputLabelProps,
                children: label
            }),
            select ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SelectSlot, {
                "aria-describedby": helperTextId,
                id: id,
                labelId: inputLabelId,
                value: value,
                input: InputElement,
                ...selectProps,
                children: children
            }) : InputElement,
            helperText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FormHelperTextSlot, {
                id: helperTextId,
                ...formHelperTextProps,
                children: helperText
            })
        ]
    });
});
var $f480fb6201951027$export$2e2bcd8739ae039 = $f480fb6201951027$var$TextField;




var $acw62 = parcelRequire("acw62");
'use client';
let $48c046855f0cea4e$var$warnedOnce = false;
const $48c046855f0cea4e$var$warn = ()=>{
    if (!$48c046855f0cea4e$var$warnedOnce) {
        console.warn([
            'MUI: The DesktopDatePicker component was moved from `@mui/lab` to `@mui/x-date-pickers`.',
            '',
            "You should use `import { DesktopDatePicker } from '@mui/x-date-pickers'`",
            "or `import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker'`",
            '',
            'More information about this migration on our blog: https://mui.com/blog/lab-date-pickers-to-mui-x/.'
        ].join('\n'));
        $48c046855f0cea4e$var$warnedOnce = true;
    }
};
/**
 * @deprecated The DesktopDatePicker component was moved from `@mui/lab` to `@mui/x-date-pickers`. More information about this migration on our blog: https://mui.com/blog/lab-date-pickers-to-mui-x/.
 * @ignore - do not document.
 */ const $48c046855f0cea4e$var$DesktopDatePicker = /*#__PURE__*/ $acw62.forwardRef(function DeprecatedDesktopDatePicker() {
    $48c046855f0cea4e$var$warn();
    return null;
});
var $48c046855f0cea4e$export$2e2bcd8739ae039 = $48c046855f0cea4e$var$DesktopDatePicker;


var $acw62 = parcelRequire("acw62");
'use client';
let $b3c301d2ad4e8de6$var$warnedOnce = false;
const $b3c301d2ad4e8de6$var$warn = ()=>{
    if (!$b3c301d2ad4e8de6$var$warnedOnce) {
        console.warn([
            'MUI: The LocalizationProvider component was moved from `@mui/lab` to `@mui/x-date-pickers`.',
            '',
            "You should use `import { LocalizationProvider } from '@mui/x-date-pickers'`",
            "or `import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'`",
            '',
            'More information about this migration on our blog: https://mui.com/blog/lab-date-pickers-to-mui-x/.'
        ].join('\n'));
        $b3c301d2ad4e8de6$var$warnedOnce = true;
    }
};
/**
 * @deprecated The LocalizationProvider component was moved from `@mui/lab` to `@mui/x-date-pickers`. More information about this migration on our blog: https://mui.com/blog/lab-date-pickers-to-mui-x/.
 * @ignore - do not document.
 */ const $b3c301d2ad4e8de6$var$LocalizationProvider = /*#__PURE__*/ $acw62.forwardRef(function DeprecatedLocalizationProvider() {
    $b3c301d2ad4e8de6$var$warn();
    return null;
});
var $b3c301d2ad4e8de6$export$2e2bcd8739ae039 = $b3c301d2ad4e8de6$var$LocalizationProvider;


let $071313b40603d399$var$warnedOnce = false;
const $071313b40603d399$var$warn = ()=>{
    if (!$071313b40603d399$var$warnedOnce) {
        console.warn([
            'MUI: The AdapterDateFns class was moved from `@mui/lab` to `@mui/x-date-pickers`',
            '',
            "You should use `import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'`",
            '',
            'More information about this migration on our blog: https://mui.com/blog/lab-date-pickers-to-mui-x/.'
        ].join('\n'));
        $071313b40603d399$var$warnedOnce = true;
    }
};
class $071313b40603d399$export$2e2bcd8739ae039 {
    constructor(){
        $071313b40603d399$var$warn();
    }
}



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");










function $849b663ea7e799fa$export$2177af0aa15c34c2(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDialog', slot);
}
const $849b663ea7e799fa$var$dialogClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDialog', [
    'root',
    'scrollPaper',
    'scrollBody',
    'container',
    'paper',
    'paperScrollPaper',
    'paperScrollBody',
    'paperWidthFalse',
    'paperWidthXs',
    'paperWidthSm',
    'paperWidthMd',
    'paperWidthLg',
    'paperWidthXl',
    'paperFullWidth',
    'paperFullScreen'
]);
var $849b663ea7e799fa$export$2e2bcd8739ae039 = $849b663ea7e799fa$var$dialogClasses;



var $acw62 = parcelRequire("acw62");
'use client';
const $fde71ca8ed33ed16$var$DialogContext = /*#__PURE__*/ $acw62.createContext({});
var $fde71ca8ed33ed16$export$2e2bcd8739ae039 = $fde71ca8ed33ed16$var$DialogContext;








'use client';
const $37762b86c13fe370$var$DialogBackdrop = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $89da4f4236459888$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Backdrop',
    overrides: (props, styles)=>styles.backdrop
})({
    // Improve scrollable dialog support.
    zIndex: -1
});
const $37762b86c13fe370$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, scroll: scroll, maxWidth: maxWidth, fullWidth: fullWidth, fullScreen: fullScreen } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        container: [
            'container',
            `scroll${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(scroll)}`
        ],
        paper: [
            'paper',
            `paperScroll${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(scroll)}`,
            `paperWidth${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(String(maxWidth))}`,
            fullWidth && 'paperFullWidth',
            fullScreen && 'paperFullScreen'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $849b663ea7e799fa$export$2177af0aa15c34c2), classes);
};
const $37762b86c13fe370$var$DialogRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Root'
})({
    '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
    }
});
const $37762b86c13fe370$var$DialogContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialog',
    slot: 'Container',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.container,
            styles[`scroll${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.scroll)}`]
        ];
    }
})({
    height: '100%',
    '@media print': {
        height: 'auto'
    },
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    variants: [
        {
            props: {
                scroll: 'paper'
            },
            style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }
        },
        {
            props: {
                scroll: 'body'
            },
            style: {
                overflowY: 'auto',
                overflowX: 'hidden',
                textAlign: 'center',
                '&::after': {
                    content: '""',
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    height: '100%',
                    width: '0'
                }
            }
        }
    ]
});
const $37762b86c13fe370$var$DialogPaper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiDialog',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`scrollPaper${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.scroll)}`],
            styles[`paperWidth${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(String(ownerState.maxWidth))}`],
            ownerState.fullWidth && styles.paperFullWidth,
            ownerState.fullScreen && styles.paperFullScreen
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 32,
        position: 'relative',
        overflowY: 'auto',
        '@media print': {
            overflowY: 'visible',
            boxShadow: 'none'
        },
        variants: [
            {
                props: {
                    scroll: 'paper'
                },
                style: {
                    display: 'flex',
                    flexDirection: 'column',
                    maxHeight: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    scroll: 'body'
                },
                style: {
                    display: 'inline-block',
                    verticalAlign: 'middle',
                    textAlign: 'initial'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.maxWidth,
                style: {
                    maxWidth: 'calc(100% - 64px)'
                }
            },
            {
                props: {
                    maxWidth: 'xs'
                },
                style: {
                    maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `max(${theme.breakpoints.values.xs}${theme.breakpoints.unit}, 444px)`,
                    [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 64)]: {
                            maxWidth: 'calc(100% - 64px)'
                        }
                    }
                }
            },
            ...Object.keys(theme.breakpoints.values).filter((maxWidth)=>maxWidth !== 'xs').map((maxWidth)=>({
                    props: {
                        maxWidth: maxWidth
                    },
                    style: {
                        maxWidth: `${theme.breakpoints.values[maxWidth]}${theme.breakpoints.unit}`,
                        [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
                            [theme.breakpoints.down(theme.breakpoints.values[maxWidth] + 64)]: {
                                maxWidth: 'calc(100% - 64px)'
                            }
                        }
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    width: 'calc(100% - 64px)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullScreen,
                style: {
                    margin: 0,
                    width: '100%',
                    maxWidth: '100%',
                    height: '100%',
                    maxHeight: 'none',
                    borderRadius: 0,
                    [`&.${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paperScrollBody}`]: {
                        margin: 0,
                        maxWidth: '100%'
                    }
                }
            }
        ]
    })));
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */ const $37762b86c13fe370$var$Dialog = /*#__PURE__*/ $acw62.forwardRef(function Dialog(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialog'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { 'aria-describedby': ariaDescribedby, 'aria-labelledby': ariaLabelledbyProp, 'aria-modal': ariaModal = true, BackdropComponent: BackdropComponent, BackdropProps: BackdropProps, children: children, className: className, disableEscapeKeyDown: disableEscapeKeyDown = false, fullScreen: fullScreen = false, fullWidth: fullWidth = false, maxWidth: maxWidth = 'sm', onClick: onClick, onClose: onClose, open: open, PaperComponent: PaperComponent = (0, $bca3355350079f94$export$2e2bcd8739ae039), PaperProps: PaperProps = {}, scroll: scroll = 'paper', slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponent = (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039), transitionDuration: transitionDuration = defaultTransitionDuration, TransitionProps: TransitionProps, ...other } = props;
    const ownerState = {
        ...props,
        disableEscapeKeyDown: disableEscapeKeyDown,
        fullScreen: fullScreen,
        fullWidth: fullWidth,
        maxWidth: maxWidth,
        scroll: scroll
    };
    const classes = $37762b86c13fe370$var$useUtilityClasses(ownerState);
    const backdropClick = $acw62.useRef();
    const handleMouseDown = (event)=>{
        // We don't want to close the dialog when clicking the dialog content.
        // Make sure the event starts and ends on the same DOM element.
        backdropClick.current = event.target === event.currentTarget;
    };
    const handleBackdropClick = (event)=>{
        if (onClick) onClick(event);
        // Ignore the events not coming from the "backdrop".
        if (!backdropClick.current) return;
        backdropClick.current = null;
        if (onClose) onClose(event, 'backdropClick');
    };
    const ariaLabelledby = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(ariaLabelledbyProp);
    const dialogContextValue = $acw62.useMemo(()=>{
        return {
            titleId: ariaLabelledby
        };
    }, [
        ariaLabelledby
    ]);
    const backwardCompatibleSlots = {
        transition: TransitionComponent,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionProps,
        paper: PaperProps,
        backdrop: BackdropProps,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $37762b86c13fe370$var$DialogRoot,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref
    });
    const [BackdropSlot, backdropSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('backdrop', {
        elementType: $37762b86c13fe370$var$DialogBackdrop,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [PaperSlot, paperSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        elementType: $37762b86c13fe370$var$DialogPaper,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.paper, PaperProps.className)
    });
    const [ContainerSlot, containerSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('container', {
        elementType: $37762b86c13fe370$var$DialogContainer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.container
    });
    const [TransitionSlot, transitionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            appear: true,
            in: open,
            timeout: transitionDuration,
            role: 'presentation'
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RootSlot, {
        closeAfterTransition: true,
        slots: {
            backdrop: BackdropSlot
        },
        slotProps: {
            backdrop: {
                transitionDuration: transitionDuration,
                as: BackdropComponent,
                ...backdropSlotProps
            }
        },
        disableEscapeKeyDown: disableEscapeKeyDown,
        onClose: onClose,
        open: open,
        onClick: handleBackdropClick,
        ...rootSlotProps,
        ...other,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionSlot, {
            ...transitionSlotProps,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ContainerSlot, {
                onMouseDown: handleMouseDown,
                ...containerSlotProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PaperSlot, {
                    as: PaperComponent,
                    elevation: 24,
                    role: "dialog",
                    "aria-describedby": ariaDescribedby,
                    "aria-labelledby": ariaLabelledby,
                    "aria-modal": ariaModal,
                    ...paperSlotProps,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fde71ca8ed33ed16$export$2e2bcd8739ae039).Provider, {
                        value: dialogContextValue,
                        children: children
                    })
                })
            })
        })
    });
});
var $37762b86c13fe370$export$2e2bcd8739ae039 = $37762b86c13fe370$var$Dialog;


var $acw62 = parcelRequire("acw62");







function $26cda4b569d13e19$export$5e57a444791c63be(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDialogActions', slot);
}
const $26cda4b569d13e19$var$dialogActionsClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDialogActions', [
    'root',
    'spacing'
]);
var $26cda4b569d13e19$export$2e2bcd8739ae039 = $26cda4b569d13e19$var$dialogActionsClasses;



'use client';
const $ce32ef3e14a19991$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableSpacing: disableSpacing } = ownerState;
    const slots = {
        root: [
            'root',
            !disableSpacing && 'spacing'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $26cda4b569d13e19$export$5e57a444791c63be), classes);
};
const $ce32ef3e14a19991$var$DialogActionsRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogActions',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableSpacing && styles.spacing
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    variants: [
        {
            props: ({ ownerState: ownerState })=>!ownerState.disableSpacing,
            style: {
                '& > :not(style) ~ :not(style)': {
                    marginLeft: 8
                }
            }
        }
    ]
});
const $ce32ef3e14a19991$var$DialogActions = /*#__PURE__*/ $acw62.forwardRef(function DialogActions(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogActions'
    });
    const { className: className, disableSpacing: disableSpacing = false, ...other } = props;
    const ownerState = {
        ...props,
        disableSpacing: disableSpacing
    };
    const classes = $ce32ef3e14a19991$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ce32ef3e14a19991$var$DialogActionsRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $ce32ef3e14a19991$export$2e2bcd8739ae039 = $ce32ef3e14a19991$var$DialogActions;


var $acw62 = parcelRequire("acw62");








function $ad2dd284aafca16e$export$61b0ee1f05fb344e(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDialogContent', slot);
}
const $ad2dd284aafca16e$var$dialogContentClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDialogContent', [
    'root',
    'dividers'
]);
var $ad2dd284aafca16e$export$2e2bcd8739ae039 = $ad2dd284aafca16e$var$dialogContentClasses;




function $d28a3cfcf0fa99af$export$f5d2ec7e4c47e088(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDialogTitle', slot);
}
const $d28a3cfcf0fa99af$var$dialogTitleClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDialogTitle', [
    'root'
]);
var $d28a3cfcf0fa99af$export$2e2bcd8739ae039 = $d28a3cfcf0fa99af$var$dialogTitleClasses;



'use client';
const $17fd443c9302d537$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, dividers: dividers } = ownerState;
    const slots = {
        root: [
            'root',
            dividers && 'dividers'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $ad2dd284aafca16e$export$61b0ee1f05fb344e), classes);
};
const $17fd443c9302d537$var$DialogContentRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDialogContent',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.dividers && styles.dividers
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        flex: '1 1 auto',
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        overflowY: 'auto',
        padding: '20px 24px',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.dividers,
                style: {
                    padding: '16px 24px',
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`,
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.dividers,
                style: {
                    [`.${(0, $d28a3cfcf0fa99af$export$2e2bcd8739ae039).root} + &`]: {
                        paddingTop: 0
                    }
                }
            }
        ]
    })));
const $17fd443c9302d537$var$DialogContent = /*#__PURE__*/ $acw62.forwardRef(function DialogContent(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContent'
    });
    const { className: className, dividers: dividers = false, ...other } = props;
    const ownerState = {
        ...props,
        dividers: dividers
    };
    const classes = $17fd443c9302d537$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($17fd443c9302d537$var$DialogContentRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $17fd443c9302d537$export$2e2bcd8739ae039 = $17fd443c9302d537$var$DialogContent;


var $acw62 = parcelRequire("acw62");









'use client';
const $493ef287866e3611$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $d28a3cfcf0fa99af$export$f5d2ec7e4c47e088), classes);
};
const $493ef287866e3611$var$DialogTitleRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: 'MuiDialogTitle',
    slot: 'Root'
})({
    padding: '16px 24px',
    flex: '0 0 auto'
});
const $493ef287866e3611$var$DialogTitle = /*#__PURE__*/ $acw62.forwardRef(function DialogTitle(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogTitle'
    });
    const { className: className, id: idProp, ...other } = props;
    const ownerState = props;
    const classes = $493ef287866e3611$var$useUtilityClasses(ownerState);
    const { titleId: titleId = idProp } = $acw62.useContext((0, $fde71ca8ed33ed16$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($493ef287866e3611$var$DialogTitleRoot, {
        component: "h2",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        variant: "h6",
        id: idProp ?? titleId,
        ...other
    });
});
var $493ef287866e3611$export$2e2bcd8739ae039 = $493ef287866e3611$var$DialogTitle;


const $6c2e4567f61280e6$var$AddDocument = ({ open: open, handleClose: handleClose, types: types, children: children, documentType: documentType, setDocumentType: setDocumentType, handleFormSubmit: handleFormSubmit, disabled: disabled, setSelectedFile: setSelectedFile })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "form-dialog-title",
        sx: {
            minWidth: 600
        },
        fullWidth: true,
        maxWidth: "sm",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                id: "form-dialog-title",
                children: "Add Document"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
                                fullWidth: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), {
                                        id: "demo-simple-select-label",
                                        children: "Document Type"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                        labelId: "document-type",
                                        id: "select-document-type",
                                        value: documentType,
                                        label: "Document Type",
                                        onChange: (evt)=>{
                                            setSelectedFile(null);
                                            setDocumentType(evt.target.value);
                                        },
                                        children: types.map((type, i)=>{
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: type.value,
                                                children: type.key
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            item: true,
                            xs: 12,
                            children: children
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        onClick: handleClose,
                        color: "secondary",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        color: "primary",
                        variant: "contained",
                        type: "submit",
                        onClick: handleFormSubmit,
                        disabled: disabled,
                        children: "Add"
                    })
                ]
            })
        ]
    });
};
var $6c2e4567f61280e6$export$2e2bcd8739ae039 = $6c2e4567f61280e6$var$AddDocument;





parcelRequire("acw62");

const $555ecccb907b3aa4$export$15f5d04b23e60d3e = ({ type: type, id: id, title: title, variant: variant = 'outlined', color: color = 'primary', onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                accept: `${type}/*`,
                hidden: true,
                id: id,
                type: "file",
                multiple: false,
                onChange: (e)=>{
                    e.preventDefault();
                    onChange(e.target.files[0]);
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: id,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    variant: variant,
                    color: color,
                    component: "span",
                    children: title
                })
            })
        ]
    });
};


const $208c589505d83d7e$var$useStyles = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()({
    documentButton: {
        display: 'flex',
        alignItems: 'flex-end',
        flexDirection: 'row-reverse'
    }
});
const $208c589505d83d7e$var$RegistrationForm = ({ setSelectedFile: setSelectedFile, selectedDate: selectedDate, handleDateChange: handleDateChange, licensePlate: licensePlate, setLicensePlate: setLicensePlate })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            justifyContent: 'space-evenly',
            gap: '20px'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b3c301d2ad4e8de6$export$2e2bcd8739ae039), {
                    dateAdapter: (0, $071313b40603d399$export$2e2bcd8739ae039),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48c046855f0cea4e$export$2e2bcd8739ae039), {
                        disableToolbar: true,
                        variant: "inline",
                        inputVariant: "outlined",
                        format: "MM/dd/yyyy",
                        id: "expiration-date",
                        label: "Expiration date",
                        value: selectedDate,
                        onChange: handleDateChange,
                        required: true,
                        renderInput: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                ...params
                            }),
                        KeyboardButtonProps: {
                            'aria-label': 'change date'
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                    autoFocus: true,
                    id: "licensePlate",
                    label: "License Plate",
                    type: "text",
                    fullWidth: true,
                    variant: "outlined",
                    value: licensePlate,
                    required: true,
                    onChange: (evt)=>{
                        setLicensePlate(evt.target.value);
                    }
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $555ecccb907b3aa4$export$15f5d04b23e60d3e), {
                    type: 'pdf',
                    id: 'registrationFileBtn',
                    variant: "contained",
                    color: "secondary",
                    title: 'Select Registration',
                    onChange: setSelectedFile
                })
            })
        ]
    });
const $208c589505d83d7e$var$Title = ({ selectedFile: selectedFile, setSelectedFile: setSelectedFile })=>{
    const { classes: classes } = $208c589505d83d7e$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        spacing: 4,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 8,
                children: !!selectedFile && selectedFile.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 4,
                className: classes.documentButton,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $555ecccb907b3aa4$export$15f5d04b23e60d3e), {
                    type: 'pdf',
                    id: 'titleFileBtn',
                    variant: "contained",
                    color: "secondary",
                    title: 'Select Title',
                    onChange: setSelectedFile
                })
            })
        ]
    });
};
const $208c589505d83d7e$var$Warranty = ({ selectedFile: selectedFile, setSelectedFile: setSelectedFile })=>{
    const { classes: classes } = $208c589505d83d7e$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        spacing: 4,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 7,
                children: !!selectedFile && selectedFile.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 5,
                className: classes.documentButton,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $555ecccb907b3aa4$export$15f5d04b23e60d3e), {
                    type: 'pdf',
                    id: 'warrantyFileBtn',
                    title: 'Select Warranty',
                    variant: "contained",
                    color: "secondary",
                    onChange: setSelectedFile
                })
            })
        ]
    });
};
const $208c589505d83d7e$var$AddRegistration = (props)=>{
    const [documentType, setDocumentType] = (0, $acw62.useState)('registration');
    const [selectedDate, setSelectedDate] = (0, $acw62.useState)(undefined);
    const [selectedFile, setSelectedFile] = (0, $acw62.useState)(null);
    const [licensePlate, setLicensePlate] = (0, $acw62.useState)('');
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const handleDateChange = (date)=>{
        setSelectedDate(date);
    };
    const handleFormSubmit = ()=>{
        if (selectedFile) {
            setLoading(true);
            (0, $930f18d689e94983$export$7b639b94d0b7f4c4).addDocument({
                vin: props.vin,
                vehicleId: props.id,
                kind: documentType,
                document: selectedFile,
                meta: documentType === 'registration' && {
                    expiration: selectedDate.getTime(),
                    license_plate: licensePlate
                }
            }).then((response)=>{
                setLoading(false);
                setSelectedDate(undefined);
                setSelectedFile(null);
                setLicensePlate(null);
                console.log({
                    'AddRegistration.handleFormSubmit(res)': response
                });
            }).then(props.handleClose);
        }
    };
    const validate = ()=>{
        switch(documentType){
            case 'registration':
                return !(selectedFile && licensePlate && selectedDate);
            case 'warranty':
            case 'title':
                return !selectedFile;
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6c2e4567f61280e6$export$2e2bcd8739ae039), {
        ...props,
        selectedFile: selectedFile,
        setDocumentType: setDocumentType,
        documentType: documentType,
        handleFormSubmit: handleFormSubmit,
        disabled: validate(),
        setSelectedFile: setSelectedFile,
        types: [
            {
                key: 'Registration',
                value: 'registration'
            },
            {
                key: 'Title',
                value: 'title'
            },
            {
                key: 'Warranty',
                value: 'warranty'
            }
        ],
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0891c3550aaff5f4$export$2e2bcd8739ae039), {}),
            !loading && documentType === 'registration' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($208c589505d83d7e$var$RegistrationForm, {
                setSelectedFile: setSelectedFile,
                selectedDate: selectedDate,
                handleDateChange: handleDateChange,
                licensePlate: licensePlate,
                setLicensePlate: setLicensePlate
            }),
            !loading && documentType === 'title' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($208c589505d83d7e$var$Title, {
                selectedFile: selectedFile,
                setSelectedFile: setSelectedFile
            }),
            !loading && documentType === 'warranty' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($208c589505d83d7e$var$Warranty, {
                selectedFile: selectedFile,
                setSelectedFile: setSelectedFile
            })
        ]
    });
};
var $208c589505d83d7e$export$2e2bcd8739ae039 = $208c589505d83d7e$var$AddRegistration;




var $acw62 = parcelRequire("acw62");





const $8e21d75176cde62a$var$SelectFile = ({ selectedFile: selectedFile, setSelectedFile: setSelectedFile })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        spacing: 4,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 7,
                children: !!selectedFile && selectedFile.name
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 5,
                sx: {
                    display: 'flex',
                    alignItems: 'flex-end',
                    flexDirection: 'row-reverse'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $555ecccb907b3aa4$export$15f5d04b23e60d3e), {
                    type: 'pdf',
                    id: 'registrationFileBtn',
                    title: 'Select File',
                    variant: "contained",
                    color: "secondary",
                    onChange: setSelectedFile
                })
            })
        ]
    });
};
const $8e21d75176cde62a$var$AddDealDocuments = (props)=>{
    const [documentType, setDocumentType] = (0, $acw62.useState)('registration');
    const [selectedFile, setSelectedFile] = (0, $acw62.useState)(null);
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const handleFormSubmit = ()=>{
        setLoading(true);
        (0, $930f18d689e94983$export$7b639b94d0b7f4c4).addDocument({
            vin: props.vin,
            vehicleId: props.id,
            kind: documentType,
            document: selectedFile
        }).then(()=>{
            setLoading(false);
            setDocumentType('registration');
            setSelectedFile(null);
        }).then(props.handleClose);
    };
    const validate = ()=>!selectedFile;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6c2e4567f61280e6$export$2e2bcd8739ae039), {
        ...props,
        selectedFile: selectedFile,
        setDocumentType: setDocumentType,
        documentType: documentType,
        handleFormSubmit: handleFormSubmit,
        disabled: validate(),
        setSelectedFile: setSelectedFile,
        types: [
            {
                key: 'Reg262',
                value: 'reg262'
            },
            {
                key: 'Purchase Order',
                value: 'purchase_order'
            },
            {
                key: 'Reg51',
                value: 'reg51'
            },
            {
                key: 'Reg553',
                value: 'reg553'
            },
            {
                key: 'Buyers Guide',
                value: 'buyers_guide'
            },
            {
                key: 'Used Vehicle History Disclosure',
                value: 'used_vehicle_history_disclosure'
            }
        ],
        children: [
            loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0891c3550aaff5f4$export$2e2bcd8739ae039), {}),
            !loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8e21d75176cde62a$var$SelectFile, {
                selectedFile: selectedFile,
                setSelectedFile: setSelectedFile
            })
        ]
    });
};
var $8e21d75176cde62a$export$2e2bcd8739ae039 = $8e21d75176cde62a$var$AddDealDocuments;



parcelRequire("acw62");



var $f1q41 = parcelRequire("f1q41");

const $48a14f90dc08d980$export$28e6b9b82ee883c = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()((theme)=>{
    return {
        base: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(6),
            color: theme.palette.text.primary,
            borderRadius: 8
        },
        heading: {
            paddingBottom: theme.spacing(2)
        },
        header: {
            marginBottom: theme.spacing(2)
        },
        borderedHeader: {
            width: '100%',
            borderBottom: '1px solid ' + `${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`,
            marginBottom: theme.spacing(3)
        }
    };
});
const $48a14f90dc08d980$export$89693000420c0acd = ({ heading: heading, headerHasBottomBorder: headerHasBottomBorder, children: children, actionBlock: actionBlock })=>{
    const { classes: classes } = $48a14f90dc08d980$export$28e6b9b82ee883c();
    const header = (0, $f1q41.isString)(heading) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        variant: "h1",
        className: classes.heading,
        children: heading
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.heading,
        children: heading
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        className: classes.base,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "space-between",
                className: headerHasBottomBorder ? classes.borderedHeader : classes.header,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        children: header
                    }),
                    actionBlock && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        children: actionBlock
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                children: children
            })
        ]
    });
};





parcelRequire("acw62");

const $d2061fcabe0ae87b$export$28e6b9b82ee883c = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()((theme)=>{
    return {
        base: {
            margin: theme.spacing(2, 0, 4, 0),
            color: theme.palette.text.primary,
            width: '100%'
        },
        body: {
            padding: theme.spacing(3),
            marginTop: theme.spacing(2),
            backgroundColor: theme.palette.primary.dark,
            borderRadius: 8
        },
        wrapper: {
            width: '100%',
            marginTop: theme.spacing(2)
        },
        borderedHeader: {
            width: '100%',
            borderBottom: '1px solid ' + `${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`,
            marginBottom: theme.spacing(3)
        }
    };
});
const $d2061fcabe0ae87b$export$6e2c8f0811a474ce = ({ heading: heading, headerButtons: headerButtons, headerHasBottomBorder: headerHasBottomBorder, children: children, wrapperSection: wrapperSection, subSection: subSection })=>{
    const { classes: classes } = $d2061fcabe0ae87b$export$28e6b9b82ee883c();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        item: true,
        className: !wrapperSection ? classes.base : classes.wrapper,
        children: [
            !subSection && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "space-between",
                className: headerHasBottomBorder ? classes.borderedHeader : '',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "h3",
                            children: heading
                        })
                    }),
                    headerButtons
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                className: !wrapperSection ? classes.body : classes.wrapper,
                children: [
                    subSection && heading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h4",
                        style: {
                            marginBottom: 20
                        },
                        children: heading
                    }),
                    children
                ]
            })
        ]
    });
};



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");









function $9a4737a8a027d021$export$f3b76d2cce458caa(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiCard', slot);
}
const $9a4737a8a027d021$var$cardClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiCard', [
    'root'
]);
var $9a4737a8a027d021$export$2e2bcd8739ae039 = $9a4737a8a027d021$var$cardClasses;



'use client';
const $99712a90aa90aa89$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $9a4737a8a027d021$export$f3b76d2cce458caa), classes);
};
const $99712a90aa90aa89$var$CardRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiCard',
    slot: 'Root'
})({
    overflow: 'hidden'
});
const $99712a90aa90aa89$var$Card = /*#__PURE__*/ $acw62.forwardRef(function Card(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCard'
    });
    const { className: className, raised: raised = false, ...other } = props;
    const ownerState = {
        ...props,
        raised: raised
    };
    const classes = $99712a90aa90aa89$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($99712a90aa90aa89$var$CardRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        elevation: raised ? 8 : undefined,
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $99712a90aa90aa89$export$2e2bcd8739ae039 = $99712a90aa90aa89$var$Card;


var $acw62 = parcelRequire("acw62");







function $118171a03565b94b$export$964336739a8c7119(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiCardContent', slot);
}
const $118171a03565b94b$var$cardContentClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiCardContent', [
    'root'
]);
var $118171a03565b94b$export$2e2bcd8739ae039 = $118171a03565b94b$var$cardContentClasses;



'use client';
const $e721a73094186d5d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $118171a03565b94b$export$964336739a8c7119), classes);
};
const $e721a73094186d5d$var$CardContentRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardContent',
    slot: 'Root'
})({
    padding: 16,
    '&:last-child': {
        paddingBottom: 24
    }
});
const $e721a73094186d5d$var$CardContent = /*#__PURE__*/ $acw62.forwardRef(function CardContent(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCardContent'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $e721a73094186d5d$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e721a73094186d5d$var$CardContentRoot, {
        as: component,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $e721a73094186d5d$export$2e2bcd8739ae039 = $e721a73094186d5d$var$CardContent;


var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");












'use client';
function $a15b5db10b6f7d3d$var$getTranslateValue(direction, node, resolvedContainer) {
    const rect = node.getBoundingClientRect();
    const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
    const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(node);
    let transform;
    if (node.fakeTransform) transform = node.fakeTransform;
    else {
        const computedStyle = containerWindow.getComputedStyle(node);
        transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
    }
    let offsetX = 0;
    let offsetY = 0;
    if (transform && transform !== 'none' && typeof transform === 'string') {
        const transformValues = transform.split('(')[1].split(')')[0].split(',');
        offsetX = parseInt(transformValues[4], 10);
        offsetY = parseInt(transformValues[5], 10);
    }
    if (direction === 'left') {
        if (containerRect) return `translateX(${containerRect.right + offsetX - rect.left}px)`;
        return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
    }
    if (direction === 'right') {
        if (containerRect) return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
        return `translateX(-${rect.left + rect.width - offsetX}px)`;
    }
    if (direction === 'up') {
        if (containerRect) return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
        return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
    }
    // direction === 'down'
    if (containerRect) return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
    return `translateY(-${rect.top + rect.height - offsetY}px)`;
}
function $a15b5db10b6f7d3d$var$resolveContainer(containerPropProp) {
    return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}
function $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, node, containerProp) {
    const resolvedContainer = $a15b5db10b6f7d3d$var$resolveContainer(containerProp);
    const transform = $a15b5db10b6f7d3d$var$getTranslateValue(direction, node, resolvedContainer);
    if (transform) {
        node.style.webkitTransform = transform;
        node.style.transform = transform;
    }
}
/**
 * The Slide transition is used by the [Drawer](/material-ui/react-drawer/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $a15b5db10b6f7d3d$var$Slide = /*#__PURE__*/ $acw62.forwardRef(function Slide(props, ref) {
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const defaultEasing = {
        enter: theme.transitions.easing.easeOut,
        exit: theme.transitions.easing.sharp
    };
    const defaultTimeout = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { addEndListener: addEndListener, appear: appear = true, children: children, container: containerProp, direction: direction = 'down', easing: easingProp = defaultEasing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, style: style, timeout: timeout = defaultTimeout, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039), ...other } = props;
    const childrenRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), childrenRef, ref);
    const normalizedTransitionCallback = (callback)=>(isAppearing)=>{
            if (callback) {
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (isAppearing === undefined) callback(childrenRef.current);
                else callback(childrenRef.current, isAppearing);
            }
        };
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, node, containerProp);
        (0, $09228c405c75d141$export$b7a864e1eaef9de5)(node);
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'enter'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', {
            ...transitionProps
        });
        node.style.transition = theme.transitions.create('transform', {
            ...transitionProps
        });
        node.style.webkitTransform = 'none';
        node.style.transform = 'none';
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback(onEntered);
    const handleExiting = normalizedTransitionCallback(onExiting);
    const handleExit = normalizedTransitionCallback((node)=>{
        const transitionProps = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            timeout: timeout,
            style: style,
            easing: easingProp
        }, {
            mode: 'exit'
        });
        node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
        node.style.transition = theme.transitions.create('transform', transitionProps);
        $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, node, containerProp);
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback((node)=>{
        // No need for transitions when the component is hidden
        node.style.webkitTransition = '';
        node.style.transition = '';
        if (onExited) onExited(node);
    });
    const handleAddEndListener = (next)=>{
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(childrenRef.current, next);
    };
    const updatePosition = $acw62.useCallback(()=>{
        if (childrenRef.current) $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
    }, [
        direction,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        // Skip configuration where the position is screen size invariant.
        if (inProp || direction === 'down' || direction === 'right') return undefined;
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            if (childrenRef.current) $a15b5db10b6f7d3d$export$f820ccdc5b48abdf(direction, childrenRef.current, containerProp);
        });
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(childrenRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        direction,
        inProp,
        containerProp
    ]);
    $acw62.useEffect(()=>{
        if (!inProp) // We need to update the position of the drawer when the direction change and
        // when it's hidden.
        updatePosition();
    }, [
        inProp,
        updatePosition
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionComponent, {
        nodeRef: childrenRef,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        appear: appear,
        in: inProp,
        timeout: timeout,
        ...other,
        children: (state, { ownerState: ownerState, ...restChildProps })=>{
            return /*#__PURE__*/ $acw62.cloneElement(children, {
                ref: handleRef,
                style: {
                    visibility: state === 'exited' && !inProp ? 'hidden' : undefined,
                    ...style,
                    ...children.props.style
                },
                ...restChildProps
            });
        }
    });
});
var $a15b5db10b6f7d3d$export$2e2bcd8739ae039 = $a15b5db10b6f7d3d$var$Slide;










function $546564c0c42a58ae$export$b801318a856c9cd2(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDrawer', slot);
}
const $546564c0c42a58ae$var$drawerClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDrawer', [
    'root',
    'docked',
    'paper',
    'anchorLeft',
    'anchorRight',
    'anchorTop',
    'anchorBottom',
    'paperAnchorLeft',
    'paperAnchorRight',
    'paperAnchorTop',
    'paperAnchorBottom',
    'paperAnchorDockedLeft',
    'paperAnchorDockedRight',
    'paperAnchorDockedTop',
    'paperAnchorDockedBottom',
    'modal'
]);
var $546564c0c42a58ae$export$2e2bcd8739ae039 = $546564c0c42a58ae$var$drawerClasses;





'use client';
const $3c5e6c7e7e283ee4$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked,
        styles.modal
    ];
};
const $3c5e6c7e7e283ee4$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, anchor: anchor, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            `anchor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchor)}`
        ],
        docked: [
            (variant === 'permanent' || variant === 'persistent') && 'docked'
        ],
        modal: [
            'modal'
        ],
        paper: [
            'paper',
            `paperAnchor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchor)}`,
            variant !== 'temporary' && `paperAnchorDocked${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchor)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $546564c0c42a58ae$export$b801318a856c9cd2), classes);
};
const $3c5e6c7e7e283ee4$var$DrawerRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Root',
    overridesResolver: $3c5e6c7e7e283ee4$var$overridesResolver
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.drawer
    })));
const $3c5e6c7e7e283ee4$var$DrawerDockedRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039),
    name: 'MuiDrawer',
    slot: 'Docked',
    skipVariantsResolver: false,
    overridesResolver: $3c5e6c7e7e283ee4$var$overridesResolver
})({
    flex: '0 0 auto'
});
const $3c5e6c7e7e283ee4$var$DrawerPaper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiDrawer',
    slot: 'Paper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.paper,
            styles[`paperAnchor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.anchor)}`],
            ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.anchor)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        flex: '1 0 auto',
        zIndex: (theme.vars || theme).zIndex.drawer,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        // temporary style
        position: 'fixed',
        top: 0,
        // We disable the focus ring for mouse, touch and keyboard users.
        // At some point, it would be better to keep it for keyboard users.
        // :focus-ring CSS pseudo-class will help.
        outline: 0,
        variants: [
            {
                props: {
                    anchor: 'left'
                },
                style: {
                    left: 0
                }
            },
            {
                props: {
                    anchor: 'top'
                },
                style: {
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: {
                    anchor: 'right'
                },
                style: {
                    right: 0
                }
            },
            {
                props: {
                    anchor: 'bottom'
                },
                style: {
                    top: 'auto',
                    left: 0,
                    bottom: 0,
                    right: 0,
                    height: 'auto',
                    maxHeight: '100%'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'left' && ownerState.variant !== 'temporary',
                style: {
                    borderRight: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'top' && ownerState.variant !== 'temporary',
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'right' && ownerState.variant !== 'temporary',
                style: {
                    borderLeft: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary',
                style: {
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }
        ]
    })));
const $3c5e6c7e7e283ee4$var$oppositeDirection = {
    left: 'right',
    right: 'left',
    top: 'down',
    bottom: 'up'
};
function $3c5e6c7e7e283ee4$export$2a62b49acb270576(anchor) {
    return [
        'left',
        'right'
    ].includes(anchor);
}
function $3c5e6c7e7e283ee4$export$830f4f08342d299e({ direction: direction }, anchor) {
    return direction === 'rtl' && $3c5e6c7e7e283ee4$export$2a62b49acb270576(anchor) ? $3c5e6c7e7e283ee4$var$oppositeDirection[anchor] : anchor;
}
/**
 * The props of the [Modal](/material-ui/api/modal/) component are available
 * when `variant="temporary"` is set.
 */ const $3c5e6c7e7e283ee4$var$Drawer = /*#__PURE__*/ $acw62.forwardRef(function Drawer(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDrawer'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const defaultTransitionDuration = {
        enter: theme.transitions.duration.enteringScreen,
        exit: theme.transitions.duration.leavingScreen
    };
    const { anchor: anchorProp = 'left', BackdropProps: BackdropProps, children: children, className: className, elevation: elevation = 16, hideBackdrop: hideBackdrop = false, ModalProps: { BackdropProps: BackdropPropsProp, ...ModalProps } = {}, onClose: onClose, open: open = false, PaperProps: PaperProps = {}, SlideProps: SlideProps, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent, transitionDuration: transitionDuration = defaultTransitionDuration, variant: variant = 'temporary', slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    // Let's assume that the Drawer will always be rendered on user space.
    // We use this state is order to skip the appear transition during the
    // initial mount of the component.
    const mounted = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        mounted.current = true;
    }, []);
    const anchorInvariant = $3c5e6c7e7e283ee4$export$830f4f08342d299e({
        direction: isRtl ? 'rtl' : 'ltr'
    }, anchorProp);
    const anchor = anchorProp;
    const ownerState = {
        ...props,
        anchor: anchor,
        elevation: elevation,
        open: open,
        variant: variant,
        ...other
    };
    const classes = $3c5e6c7e7e283ee4$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            transition: TransitionComponent,
            ...slots
        },
        slotProps: {
            paper: PaperProps,
            transition: SlideProps,
            ...slotProps,
            backdrop: (0, $b748e9827e4898eb$export$2e2bcd8739ae039)(slotProps.backdrop || {
                ...BackdropProps,
                ...BackdropPropsProp
            }, {
                transitionDuration: transitionDuration
            })
        }
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $3c5e6c7e7e283ee4$var$DrawerRoot,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, classes.modal, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            ...ModalProps
        },
        additionalProps: {
            open: open,
            onClose: onClose,
            hideBackdrop: hideBackdrop,
            slots: {
                backdrop: externalForwardedProps.slots.backdrop
            },
            slotProps: {
                backdrop: externalForwardedProps.slotProps.backdrop
            }
        }
    });
    const [PaperSlot, paperSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        elementType: $3c5e6c7e7e283ee4$var$DrawerPaper,
        shouldForwardComponentProp: true,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.paper, PaperProps.className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            elevation: variant === 'temporary' ? elevation : 0,
            square: true,
            ...variant === 'temporary' && {
                role: 'dialog',
                'aria-modal': 'true'
            }
        }
    });
    const [DockedSlot, dockedSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('docked', {
        elementType: $3c5e6c7e7e283ee4$var$DrawerDockedRoot,
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, classes.docked, className),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: other // pass `other` here because `DockedSlot` is also a root slot for some variants
    });
    const [TransitionSlot, transitionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $a15b5db10b6f7d3d$export$2e2bcd8739ae039),
        ownerState: ownerState,
        externalForwardedProps: externalForwardedProps,
        additionalProps: {
            in: open,
            direction: $3c5e6c7e7e283ee4$var$oppositeDirection[anchorInvariant],
            timeout: transitionDuration,
            appear: mounted.current
        }
    });
    const drawer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PaperSlot, {
        ...paperSlotProps,
        children: children
    });
    if (variant === 'permanent') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: drawer
    });
    const slidingDrawer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionSlot, {
        ...transitionSlotProps,
        children: drawer
    });
    if (variant === 'persistent') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(DockedSlot, {
        ...dockedSlotProps,
        children: slidingDrawer
    });
    // variant === temporary
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        children: slidingDrawer
    });
});
var $3c5e6c7e7e283ee4$export$2e2bcd8739ae039 = $3c5e6c7e7e283ee4$var$Drawer;



var $acw62 = parcelRequire("acw62");
var $0d70f179cf56e662$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $0d70f179cf56e662$var$isDateObject = (value1)=>value1 instanceof Date;
var $0d70f179cf56e662$var$isNullOrUndefined = (value1)=>value1 == null;
const $0d70f179cf56e662$var$isObjectType = (value1)=>typeof value1 === 'object';
var $0d70f179cf56e662$var$isObject = (value1)=>!$0d70f179cf56e662$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $0d70f179cf56e662$var$isObjectType(value1) && !$0d70f179cf56e662$var$isDateObject(value1);
var $0d70f179cf56e662$var$getEventValue = (event)=>$0d70f179cf56e662$var$isObject(event) && event.target ? $0d70f179cf56e662$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $0d70f179cf56e662$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $0d70f179cf56e662$var$isNameInFieldArray = (names, name)=>names.has($0d70f179cf56e662$var$getNodeParentName(name));
var $0d70f179cf56e662$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $0d70f179cf56e662$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $0d70f179cf56e662$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $0d70f179cf56e662$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    const isFileListInstance = typeof FileList !== 'undefined' ? data instanceof FileList : false;
    if (data instanceof Date) copy = new Date(data);
    else if (!($0d70f179cf56e662$var$isWeb && (data instanceof Blob || isFileListInstance)) && (isArray || $0d70f179cf56e662$var$isObject(data))) {
        copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
        if (!isArray && !$0d70f179cf56e662$var$isPlainObject(data)) copy = data;
        else {
            for(const key in data)if (data.hasOwnProperty(key)) copy[key] = $0d70f179cf56e662$var$cloneObject(data[key]);
        }
    } else return data;
    return copy;
}
var $0d70f179cf56e662$var$isKey = (value1)=>/^\w*$/.test(value1);
var $0d70f179cf56e662$var$isUndefined = (val)=>val === undefined;
var $0d70f179cf56e662$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $0d70f179cf56e662$var$stringToPath = (input)=>$0d70f179cf56e662$var$compact(input.replace(/["|']|\]/g, '').split(/\.|\[/));
var $0d70f179cf56e662$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$0d70f179cf56e662$var$isObject(object)) return defaultValue;
    const result = ($0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path)).reduce((result, key)=>$0d70f179cf56e662$var$isNullOrUndefined(result) ? result : result[key], object);
    return $0d70f179cf56e662$var$isUndefined(result) || result === object ? $0d70f179cf56e662$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $0d70f179cf56e662$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $0d70f179cf56e662$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $0d70f179cf56e662$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return;
        object[key] = newValue;
        object = object[key];
    }
};
const $0d70f179cf56e662$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change'
};
const $0d70f179cf56e662$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $0d70f179cf56e662$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $0d70f179cf56e662$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createContext(null);
$0d70f179cf56e662$var$HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useContext($0d70f179cf56e662$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $0d70f179cf56e662$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($0d70f179cf56e662$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $0d70f179cf56e662$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $0d70f179cf56e662$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $0d70f179cf56e662$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect;
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$606f11b2eb45ecc6(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._formState);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState({
                    ...control._formState,
                    ...formState
                });
            }
        }), [
        name,
        disabled,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$0d70f179cf56e662$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $0d70f179cf56e662$var$isString = (value1)=>typeof value1 === 'string';
var $0d70f179cf56e662$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($0d70f179cf56e662$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
var $0d70f179cf56e662$var$isPrimitive = (value1)=>$0d70f179cf56e662$var$isNullOrUndefined(value1) || !$0d70f179cf56e662$var$isObjectType(value1);
function $0d70f179cf56e662$var$deepEqual(object1, object2, _internal_visited = new WeakSet()) {
    if ($0d70f179cf56e662$var$isPrimitive(object1) || $0d70f179cf56e662$var$isPrimitive(object2)) return object1 === object2;
    if ($0d70f179cf56e662$var$isDateObject(object1) && $0d70f179cf56e662$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if (_internal_visited.has(object1) || _internal_visited.has(object2)) return true;
    _internal_visited.add(object1);
    _internal_visited.add(object2);
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($0d70f179cf56e662$var$isDateObject(val1) && $0d70f179cf56e662$var$isDateObject(val2) || $0d70f179cf56e662$var$isObject(val1) && $0d70f179cf56e662$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$0d70f179cf56e662$var$deepEqual(val1, val2, _internal_visited) : val1 !== val2) return false;
        }
    }
    return true;
}
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $0d70f179cf56e662$export$3c773aa2b84f29e0(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    _compute.current = compute;
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>control._getWatch(name, _defaultValue.current), [
        control,
        name
    ]);
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(_compute.current ? _compute.current(defaultValueMemo) : defaultValueMemo);
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                if (!disabled) {
                    const formValues = $0d70f179cf56e662$var$generateWatchOutput(name, control._names, formState.values || control._formValues, false, _defaultValue.current);
                    if (_compute.current) {
                        const computedFormValues = _compute.current(formValues);
                        if (!$0d70f179cf56e662$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                            updateValue(computedFormValues);
                            _computeFormValues.current = computedFormValues;
                        }
                    } else updateValue(formValues);
                }
            }
        }), [
        control,
        disabled,
        name,
        exact
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._removeUnmounted());
    return value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$e8c786024a2b0a79(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { name: name, disabled: disabled, control: control = methods.control, shouldUnregister: shouldUnregister, defaultValue: defaultValue } = props;
    const isArrayField = $0d70f179cf56e662$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name, $0d70f179cf56e662$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: true
    });
    const formState = $0d70f179cf56e662$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: true
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(props);
    const _previousNameRef = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control.register(name, {
        ...props.rules,
        value: value1,
        ...$0d70f179cf56e662$var$isBoolean(props.disabled) ? {
            disabled: props.disabled
        } : {}
    }));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$0d70f179cf56e662$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$0d70f179cf56e662$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((event)=>_registerProps.current.onChange({
            target: {
                value: $0d70f179cf56e662$var$getEventValue(event),
                name: name
            },
            type: $0d70f179cf56e662$var$EVENTS.CHANGE
        }), [
        name
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $0d70f179cf56e662$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((elm)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
        if (field && elm) field._f.ref = {
            focus: ()=>elm.focus && elm.focus(),
            select: ()=>elm.select && elm.select(),
            setCustomValidity: (message)=>elm.setCustomValidity(message),
            reportValidity: ()=>elm.reportValidity()
        };
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            name: name,
            value: value1,
            ...$0d70f179cf56e662$var$isBoolean(disabled) || formState.disabled ? {
                disabled: formState.disabled || disabled
            } : {},
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const previousName = _previousNameRef.current;
        if (previousName && previousName !== name && !isArrayField) control.unregister(previousName);
        control.register(name, {
            ..._props.current.rules,
            ...$0d70f179cf56e662$var$isBoolean(_props.current.disabled) ? {
                disabled: _props.current.disabled
            } : {}
        });
        const updateMounted = (name, value1)=>{
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue));
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($0d70f179cf56e662$var$isUndefined($0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name))) $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        _previousNameRef.current = name;
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $0d70f179cf56e662$export$bd0bf19f25da8474 = (props)=>props.render($0d70f179cf56e662$export$e8c786024a2b0a79(props));
const $0d70f179cf56e662$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($0d70f179cf56e662$var$isObjectType(obj[key]) && obj[key] !== null) {
        const nested = $0d70f179cf56e662$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
const $0d70f179cf56e662$var$POST_REQUEST = 'post';
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$a7fed597f4b8afd8(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit, children: children, action: action, method: method = $0d70f179cf56e662$var$POST_REQUEST, headers: headers, encType: encType, onError: onError, render: render, onSuccess: onSuccess, validateStatus: validateStatus, ...rest } = props;
    const submit = async (event)=>{
        let hasError = false;
        let type = '';
        await control.handleSubmit(async (data)=>{
            const formData = new FormData();
            let formDataJson = '';
            try {
                formDataJson = JSON.stringify(data);
            } catch (_a) {}
            const flattenFormValues = $0d70f179cf56e662$var$flatten(control._formValues);
            for(const key in flattenFormValues)formData.append(key, flattenFormValues[key]);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if (action) try {
                const shouldStringifySubmissionData = [
                    headers && headers['Content-Type'],
                    encType
                ].some((value1)=>value1 && value1.includes('json'));
                const response = await fetch(String(action), {
                    method: method,
                    headers: {
                        ...headers,
                        ...encType && encType !== 'multipart/form-data' ? {
                            'Content-Type': encType
                        } : {}
                    },
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && (validateStatus ? !validateStatus(response.status) : response.status < 200 || response.status >= 300)) {
                    hasError = true;
                    onError && onError({
                        response: response
                    });
                    type = String(response.status);
                } else onSuccess && onSuccess({
                    response: response
                });
            } catch (error) {
                hasError = true;
                onError && onError({
                    error: error
                });
            }
        })(event);
        if (hasError && props.control) {
            props.control._subjects.state.next({
                isSubmitSuccessful: false
            });
            props.control.setError('root.server', {
                type: type
            });
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        setMounted(true);
    }, []);
    return render ? (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, render({
        submit: submit
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("form", {
        noValidate: mounted,
        action: action,
        method: method,
        encType: encType,
        onSubmit: submit,
        ...rest
    }, children);
}
var $0d70f179cf56e662$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
var $0d70f179cf56e662$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $0d70f179cf56e662$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $0d70f179cf56e662$var$extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && $0d70f179cf56e662$var$isObject(fieldState) && fieldValue) {
            const nestedFieldsState = $0d70f179cf56e662$var$extractFormValues(fieldState, fieldValue);
            if ($0d70f179cf56e662$var$isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
var $0d70f179cf56e662$var$isEmptyObject = (value1)=>$0d70f179cf56e662$var$isObject(value1) && !Object.keys(value1).length;
var $0d70f179cf56e662$var$isFileInput = (element)=>element.type === 'file';
var $0d70f179cf56e662$var$isFunction = (value1)=>typeof value1 === 'function';
var $0d70f179cf56e662$var$isHTMLElement = (value1)=>{
    if (!$0d70f179cf56e662$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $0d70f179cf56e662$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $0d70f179cf56e662$var$isRadioInput = (element)=>element.type === 'radio';
var $0d70f179cf56e662$var$isRadioOrCheckbox = (ref)=>$0d70f179cf56e662$var$isRadioInput(ref) || $0d70f179cf56e662$var$isCheckBoxInput(ref);
var $0d70f179cf56e662$var$live = (ref)=>$0d70f179cf56e662$var$isHTMLElement(ref) && ref.isConnected;
function $0d70f179cf56e662$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $0d70f179cf56e662$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $0d70f179cf56e662$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$0d70f179cf56e662$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $0d70f179cf56e662$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $0d70f179cf56e662$var$isKey(path) ? [
        path
    ] : $0d70f179cf56e662$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $0d70f179cf56e662$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($0d70f179cf56e662$var$isObject(childObject) && $0d70f179cf56e662$var$isEmptyObject(childObject) || Array.isArray(childObject) && $0d70f179cf56e662$var$isEmptyArray(childObject))) $0d70f179cf56e662$var$unset(object, paths.slice(0, -1));
    return object;
}
var $0d70f179cf56e662$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($0d70f179cf56e662$var$isFunction(data[key])) return true;
    }
    return false;
};
function $0d70f179cf56e662$var$isTraversable(value1) {
    return Array.isArray(value1) || $0d70f179cf56e662$var$isObject(value1) && !$0d70f179cf56e662$var$objectHasFunction(value1);
}
function $0d70f179cf56e662$var$markFieldsDirty(data, fields = {}) {
    for(const key in data){
        if ($0d70f179cf56e662$var$isTraversable(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $0d70f179cf56e662$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$0d70f179cf56e662$var$isUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $0d70f179cf56e662$var$getDirtyFields(data, formValues, dirtyFieldsFromValues) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $0d70f179cf56e662$var$markFieldsDirty(formValues);
    for(const key in data)if ($0d70f179cf56e662$var$isTraversable(data[key])) {
        if ($0d70f179cf56e662$var$isUndefined(formValues) || $0d70f179cf56e662$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $0d70f179cf56e662$var$markFieldsDirty(data[key], Array.isArray(data[key]) ? [] : {});
        else $0d70f179cf56e662$var$getDirtyFields(data[key], $0d70f179cf56e662$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
    } else dirtyFieldsFromValues[key] = !$0d70f179cf56e662$var$deepEqual(data[key], formValues[key]);
    return dirtyFieldsFromValues;
}
const $0d70f179cf56e662$var$defaultResult = {
    value: false,
    isValid: false
};
const $0d70f179cf56e662$var$validResult = {
    value: true,
    isValid: true
};
var $0d70f179cf56e662$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$0d70f179cf56e662$var$isUndefined(options[0].attributes.value) ? $0d70f179cf56e662$var$isUndefined(options[0].value) || options[0].value === '' ? $0d70f179cf56e662$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $0d70f179cf56e662$var$validResult : $0d70f179cf56e662$var$defaultResult;
    }
    return $0d70f179cf56e662$var$defaultResult;
};
var $0d70f179cf56e662$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$0d70f179cf56e662$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $0d70f179cf56e662$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
const $0d70f179cf56e662$var$defaultReturn = {
    isValid: false,
    value: null
};
var $0d70f179cf56e662$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $0d70f179cf56e662$var$defaultReturn) : $0d70f179cf56e662$var$defaultReturn;
function $0d70f179cf56e662$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($0d70f179cf56e662$var$isFileInput(ref)) return ref.files;
    if ($0d70f179cf56e662$var$isRadioInput(ref)) return $0d70f179cf56e662$var$getRadioValue(_f.refs).value;
    if ($0d70f179cf56e662$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($0d70f179cf56e662$var$isCheckBoxInput(ref)) return $0d70f179cf56e662$var$getCheckboxValue(_f.refs).value;
    return $0d70f179cf56e662$var$getFieldValueAs($0d70f179cf56e662$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $0d70f179cf56e662$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        field && $0d70f179cf56e662$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $0d70f179cf56e662$var$isRegex = (value1)=>value1 instanceof RegExp;
var $0d70f179cf56e662$var$getRuleValue = (rule)=>$0d70f179cf56e662$var$isUndefined(rule) ? rule : $0d70f179cf56e662$var$isRegex(rule) ? rule.source : $0d70f179cf56e662$var$isObject(rule) ? $0d70f179cf56e662$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $0d70f179cf56e662$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $0d70f179cf56e662$var$VALIDATION_MODE.all,
        isOnTouch: mode === $0d70f179cf56e662$var$VALIDATION_MODE.onTouched
    });
const $0d70f179cf56e662$var$ASYNC_FUNCTION = 'AsyncFunction';
var $0d70f179cf56e662$var$hasPromiseValidation = (fieldReference)=>!!fieldReference && !!fieldReference.validate && !!($0d70f179cf56e662$var$isFunction(fieldReference.validate) && fieldReference.validate.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION || $0d70f179cf56e662$var$isObject(fieldReference.validate) && Object.values(fieldReference.validate).find((validateFunction)=>validateFunction.constructor.name === $0d70f179cf56e662$var$ASYNC_FUNCTION));
var $0d70f179cf56e662$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
var $0d70f179cf56e662$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
const $0d70f179cf56e662$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
                }
            } else if ($0d70f179cf56e662$var$isObject(currentField)) {
                if ($0d70f179cf56e662$var$iterateFieldsByAction(currentField, action)) break;
            }
        }
    }
    return;
};
function $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, name) {
    const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
    if (error || $0d70f179cf56e662$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $0d70f179cf56e662$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $0d70f179cf56e662$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $0d70f179cf56e662$var$VALIDATION_MODE.all));
};
var $0d70f179cf56e662$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $0d70f179cf56e662$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $0d70f179cf56e662$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $0d70f179cf56e662$var$unsetEmptyArray = (ref, name)=>!$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(ref, name)).length && $0d70f179cf56e662$var$unset(ref, name);
var $0d70f179cf56e662$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$export$3988ae62b71be9a3(errors, name));
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(fieldArrayErrors, 'root', error[name]);
    $0d70f179cf56e662$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
function $0d70f179cf56e662$var$getValidateError(result, ref, type = 'validate') {
    if ($0d70f179cf56e662$var$isString(result) || Array.isArray(result) && result.every($0d70f179cf56e662$var$isString) || $0d70f179cf56e662$var$isBoolean(result) && !result) return {
        type: type,
        message: $0d70f179cf56e662$var$isString(result) ? result : '',
        ref: ref
    };
}
var $0d70f179cf56e662$var$getValueAndMessage = (validationData)=>$0d70f179cf56e662$var$isObject(validationData) && !$0d70f179cf56e662$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $0d70f179cf56e662$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $0d70f179cf56e662$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($0d70f179cf56e662$var$isBoolean(message) ? '' : message || '');
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $0d70f179cf56e662$var$isRadioInput(ref);
    const isCheckBox = $0d70f179cf56e662$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $0d70f179cf56e662$var$isFileInput(ref)) && $0d70f179cf56e662$var$isUndefined(ref.value) && $0d70f179cf56e662$var$isUndefined(inputValue) || $0d70f179cf56e662$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $0d70f179cf56e662$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.maxLength, minType = $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $0d70f179cf56e662$var$isNullOrUndefined(inputValue)) || $0d70f179cf56e662$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$0d70f179cf56e662$var$getCheckboxValue(refs).isValid || isRadio && !$0d70f179cf56e662$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $0d70f179cf56e662$var$isString(required) ? {
            value: !!required,
            message: required
        } : $0d70f179cf56e662$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$0d70f179cf56e662$var$isNullOrUndefined(min) || !$0d70f179cf56e662$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $0d70f179cf56e662$var$getValueAndMessage(max);
        const minOutput = $0d70f179cf56e662$var$getValueAndMessage(min);
        if (!$0d70f179cf56e662$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$0d70f179cf56e662$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$0d70f179cf56e662$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($0d70f179cf56e662$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($0d70f179cf56e662$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.max, $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($0d70f179cf56e662$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(maxLength);
        const minLengthOutput = $0d70f179cf56e662$var$getValueAndMessage(minLength);
        const exceedMax = !$0d70f179cf56e662$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$0d70f179cf56e662$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $0d70f179cf56e662$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $0d70f179cf56e662$var$getValueAndMessage(pattern);
        if ($0d70f179cf56e662$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($0d70f179cf56e662$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $0d70f179cf56e662$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($0d70f179cf56e662$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($0d70f179cf56e662$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$0d70f179cf56e662$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $0d70f179cf56e662$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$0d70f179cf56e662$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
const $0d70f179cf56e662$var$defaultOptions = {
    mode: $0d70f179cf56e662$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $0d70f179cf56e662$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $0d70f179cf56e662$export$1361f5e0e4cca3c3(props = {}) {
    let _options = {
        ...$0d70f179cf56e662$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isReady: false,
        isLoading: $0d70f179cf56e662$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        validatingFields: {},
        errors: _options.errors || {},
        disabled: _options.disabled || false
    };
    let _fields = {};
    let _defaultValues = $0d70f179cf56e662$var$isObject(_options.defaultValues) || $0d70f179cf56e662$var$isObject(_options.values) ? $0d70f179cf56e662$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $0d70f179cf56e662$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    let _proxySubscribeFormState = {
        ..._proxyFormState
    };
    const _subjects = {
        array: $0d70f179cf56e662$var$createSubject(),
        state: $0d70f179cf56e662$var$createSubject()
    };
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const isValid = _options.resolver ? $0d70f179cf56e662$var$isEmptyObject((await _runSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || Array.from(_names.mount)).forEach((name)=>{
                if (name) isValidating ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $0d70f179cf56e662$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$0d70f179cf56e662$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $0d70f179cf56e662$var$unsetEmptyArray(_formState.errors, name);
            }
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _formState.dirtyFields = $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, $0d70f179cf56e662$var$isUndefined(value1) ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $0d70f179cf56e662$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $0d70f179cf56e662$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _setValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!_options.disabled) {
            if (!isBlurEvent || shouldDirty) {
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                const isCurrentFieldPristine = $0d70f179cf56e662$var$deepEqual($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                isPreviousDirty = !!$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                isCurrentFieldPristine ? $0d70f179cf56e662$var$unset(_formState.dirtyFields, name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $0d70f179cf56e662$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(_options.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        if ((error ? !$0d70f179cf56e662$var$deepEqual(previousFieldError, error) : previousFieldError) || !$0d70f179cf56e662$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $0d70f179cf56e662$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        const result = await _options.resolver(_formValues, _options.context, $0d70f179cf56e662$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
        _updateIsValidating(name);
        return result;
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        if (names) for (const name of names){
            const error = $0d70f179cf56e662$export$3988ae62b71be9a3(errors, name);
            error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $0d70f179cf56e662$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $0d70f179cf56e662$var$hasPromiseValidation(field._f);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await $0d70f179cf56e662$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && _proxyFormState.validatingFields) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($0d70f179cf56e662$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $0d70f179cf56e662$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $0d70f179cf56e662$var$unset(_formState.errors, _f.name));
                }
                !$0d70f179cf56e662$var$isEmptyObject(fieldValue) && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$0d70f179cf56e662$var$live(ref)) : !$0d70f179cf56e662$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>!_options.disabled && (name && data && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, data), !$0d70f179cf56e662$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$0d70f179cf56e662$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $0d70f179cf56e662$var$isUndefined(defaultValue) ? _defaultValues : $0d70f179cf56e662$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$0d70f179cf56e662$var$compact($0d70f179cf56e662$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, $0d70f179cf56e662$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $0d70f179cf56e662$var$isHTMLElement(fieldReference.ref) && $0d70f179cf56e662$var$isNullOrUndefined(value1) ? '' : value1;
                if ($0d70f179cf56e662$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($0d70f179cf56e662$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($0d70f179cf56e662$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.state.next({
                        name: name,
                        values: $0d70f179cf56e662$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $0d70f179cf56e662$var$isObject(fieldValue) || field && !field._f) && !$0d70f179cf56e662$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $0d70f179cf56e662$var$cloneObject(value1);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: $0d70f179cf56e662$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$0d70f179cf56e662$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $0d70f179cf56e662$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState,
            name: name
        });
        _subjects.state.next({
            name: _state.mount ? name : undefined,
            values: $0d70f179cf56e662$var$cloneObject(_formValues)
        });
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $0d70f179cf56e662$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $0d70f179cf56e662$var$deepEqual(fieldValue, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        const validationModeBeforeSubmit = $0d70f179cf56e662$var$getValidationModes(_options.mode);
        const validationModeAfterSubmit = $0d70f179cf56e662$var$getValidationModes(_options.reValidateMode);
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $0d70f179cf56e662$var$getFieldValue(field._f) : $0d70f179cf56e662$var$getEventValue(event);
            const isBlurEvent = event.type === $0d70f179cf56e662$var$EVENTS.BLUR || event.type === $0d70f179cf56e662$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$0d70f179cf56e662$var$hasValidation(field._f) && !_options.resolver && !$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $0d70f179cf56e662$var$skipValidation(isBlurEvent, $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $0d70f179cf56e662$var$isWatched(name, _names, isBlurEvent);
            $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    delayErrorCallback && delayErrorCallback(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$0d70f179cf56e662$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next({
                name: name,
                type: event.type,
                values: $0d70f179cf56e662$var$cloneObject(_formValues)
            });
            if (shouldSkipValidation) {
                if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    const previousErrorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(_formState.errors, _fields, name);
                    const errorLookupResult = $0d70f179cf56e662$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                    error = errorLookupResult.error;
                    name = errorLookupResult.name;
                    isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
                }
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $0d70f179cf56e662$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $0d70f179cf56e662$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($0d70f179cf56e662$var$isUndefined(name) ? name : fieldNames);
            isValid = $0d70f179cf56e662$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$0d70f179cf56e662$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors
        });
        options.shouldFocus && !validationResult && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = {
            ..._state.mount ? _formValues : _defaultValues
        };
        if (config) values = $0d70f179cf56e662$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $0d70f179cf56e662$var$isUndefined(fieldNames) ? values : $0d70f179cf56e662$var$isString(fieldNames) ? $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$0d70f179cf56e662$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            error: $0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isValidating: !!$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$0d70f179cf56e662$export$3988ae62b71be9a3((formState || _formState).touchedFields, name)
        });
    const clearErrors = (name)=>{
        name && $0d70f179cf56e662$var$convertToArrayPayload(name).forEach((inputName)=>$0d70f179cf56e662$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $0d70f179cf56e662$export$3988ae62b71be9a3(_formState.errors, name) || {};
        // Don't override existing error messages elsewhere in the object tree.
        const { ref: currentRef, message: message, type: type, ...restOfErrorTree } = currentError;
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...restOfErrorTree,
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$0d70f179cf56e662$var$isFunction(name) ? _subjects.state.subscribe({
            next: (payload)=>'values' in payload && name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const _subscribe = (props)=>_subjects.state.subscribe({
            next: (formState)=>{
                if ($0d70f179cf56e662$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $0d70f179cf56e662$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) props.callback({
                    values: {
                        ..._formValues
                    },
                    ..._formState,
                    ...formState,
                    defaultValues: _defaultValues
                });
            }
        }).unsubscribe;
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = {
            ..._proxySubscribeFormState,
            ...props.formState
        };
        return _subscribe({
            ...props,
            formState: _proxySubscribeFormState
        });
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $0d70f179cf56e662$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $0d70f179cf56e662$var$unset(_fields, fieldName);
                $0d70f179cf56e662$var$unset(_formValues, fieldName);
            }
            !options.keepError && $0d70f179cf56e662$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $0d70f179cf56e662$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $0d70f179cf56e662$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $0d70f179cf56e662$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $0d70f179cf56e662$var$unset(_defaultValues, fieldName);
        }
        _subjects.state.next({
            values: $0d70f179cf56e662$var$cloneObject(_formValues)
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
    };
    const register = (name, options = {})=>{
        let field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $0d70f179cf56e662$var$isBoolean(options.disabled) || $0d70f179cf56e662$var$isBoolean(_options.disabled);
        $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        if (field) _setDisabledField({
            disabled: $0d70f179cf56e662$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled || _options.disabled
            } : {},
            ..._options.progressive ? {
                required: !!options.required,
                min: $0d70f179cf56e662$var$getRuleValue(options.min),
                max: $0d70f179cf56e662$var$getRuleValue(options.max),
                minLength: $0d70f179cf56e662$var$getRuleValue(options.minLength),
                maxLength: $0d70f179cf56e662$var$getRuleValue(options.maxLength),
                pattern: $0d70f179cf56e662$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $0d70f179cf56e662$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $0d70f179cf56e662$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $0d70f179cf56e662$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($0d70f179cf56e662$var$live),
                                    fieldRef,
                                    ...Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($0d70f179cf56e662$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $0d70f179cf56e662$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($0d70f179cf56e662$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $0d70f179cf56e662$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $0d70f179cf56e662$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _formState.errors = errors;
                fieldValues = $0d70f179cf56e662$var$cloneObject(values);
            } else await executeBuiltInValidation(_fields);
            if (_names.disabled.size) for (const name of _names.disabled)$0d70f179cf56e662$var$unset(fieldValues, name);
            $0d70f179cf56e662$var$unset(_formState.errors, 'root');
            if ($0d70f179cf56e662$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $0d70f179cf56e662$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
        };
    const resetField = (name, options = {})=>{
        if ($0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name)) {
            if ($0d70f179cf56e662$var$isUndefined(options.defaultValue)) setValue(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $0d70f179cf56e662$export$adaa4cf7ef1b65be(_defaultValues, name, $0d70f179cf56e662$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $0d70f179cf56e662$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $0d70f179cf56e662$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $0d70f179cf56e662$var$cloneObject($0d70f179cf56e662$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $0d70f179cf56e662$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $0d70f179cf56e662$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $0d70f179cf56e662$var$cloneObject(updatedValues);
        const isEmptyResetValues = $0d70f179cf56e662$var$isEmptyObject(formValues);
        const values = isEmptyResetValues ? _defaultValues : cloneUpdatedValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...Object.keys($0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues))
                ]);
                for (const fieldName of Array.from(fieldsToCheck))$0d70f179cf56e662$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(values, fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
            } else {
                if ($0d70f179cf56e662$var$isWeb && $0d70f179cf56e662$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($0d70f179cf56e662$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $0d70f179cf56e662$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            _formValues = _options.shouldUnregister ? keepStateOptions.keepDefaultValues ? $0d70f179cf56e662$var$cloneObject(_defaultValues) : {} : $0d70f179cf56e662$var$cloneObject(values);
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.state.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues;
        _state.watch = !!_options.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$0d70f179cf56e662$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, _formValues) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $0d70f179cf56e662$var$getDirtyFields(_defaultValues, formValues) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($0d70f179cf56e662$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $0d70f179cf56e662$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && $0d70f179cf56e662$var$isFunction(fieldRef.select) && fieldRef.select();
            }
        }
    };
    const _setFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$0d70f179cf56e662$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return {
        ...methods,
        formControl: methods
    };
}
var $0d70f179cf56e662$var$generateId = ()=>{
    if (typeof crypto !== 'undefined' && crypto.randomUUID) return crypto.randomUUID();
    const d = typeof performance === 'undefined' ? Date.now() : performance.now() * 1000;
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $0d70f179cf56e662$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $0d70f179cf56e662$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$0d70f179cf56e662$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $0d70f179cf56e662$var$appendAt = (data, value1)=>[
        ...data,
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1)
    ];
var $0d70f179cf56e662$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $0d70f179cf56e662$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $0d70f179cf56e662$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($0d70f179cf56e662$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $0d70f179cf56e662$var$prependAt = (data, value1)=>[
        ...$0d70f179cf56e662$var$convertToArrayPayload(value1),
        ...$0d70f179cf56e662$var$convertToArrayPayload(data)
    ];
function $0d70f179cf56e662$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $0d70f179cf56e662$var$compact(temp).length ? temp : [];
}
var $0d70f179cf56e662$var$removeArrayAt = (data, index)=>$0d70f179cf56e662$var$isUndefined(index) ? [] : $0d70f179cf56e662$var$removeAtIndexes(data, $0d70f179cf56e662$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $0d70f179cf56e662$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
var $0d70f179cf56e662$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$310131896651d559(props) {
    const methods = $0d70f179cf56e662$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = 'id', shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(control._getFieldArray(name).map($0d70f179cf56e662$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(false);
    control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules
    ]);
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $0d70f179cf56e662$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($0d70f179cf56e662$var$generateId);
                    }
                }
            }
        }).unsubscribe, [
        control,
        name
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        const appendValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $0d70f179cf56e662$var$appendAt(ids.current, appendValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$appendAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        const prependValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, 0, options);
        ids.current = $0d70f179cf56e662$var$prependAt(ids.current, prependValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$prependAt, {
            argA: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $0d70f179cf56e662$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name)) && $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        const updatedFieldArrayValues = $0d70f179cf56e662$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $0d70f179cf56e662$var$getFocusFieldName(name, index, options);
        ids.current = $0d70f179cf56e662$var$insert(ids.current, index, insertValue.map($0d70f179cf56e662$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$insert, {
            argA: index,
            argB: $0d70f179cf56e662$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $0d70f179cf56e662$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $0d70f179cf56e662$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $0d70f179cf56e662$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $0d70f179cf56e662$var$cloneObject(value1);
        const updatedFieldArrayValues = $0d70f179cf56e662$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $0d70f179cf56e662$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $0d70f179cf56e662$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $0d70f179cf56e662$var$convertToArrayPayload($0d70f179cf56e662$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($0d70f179cf56e662$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        control._state.action = false;
        $0d70f179cf56e662$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted) && !$0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                const error = $0d70f179cf56e662$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $0d70f179cf56e662$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type || error && (existingError.type !== error.type || existingError.message !== error.message) : error && error.type) {
                    error ? $0d70f179cf56e662$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $0d70f179cf56e662$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f && !($0d70f179cf56e662$var$getValidationModes(control._options.reValidateMode).isOnSubmit && $0d70f179cf56e662$var$getValidationModes(control._options.mode).isOnSubmit)) $0d70f179cf56e662$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $0d70f179cf56e662$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$0d70f179cf56e662$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $0d70f179cf56e662$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.state.next({
            name: name,
            values: $0d70f179cf56e662$var$cloneObject(control._formValues)
        });
        control._names.focus && $0d70f179cf56e662$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        !$0d70f179cf56e662$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            const updateMounted = (name, value1)=>{
                const field = $0d70f179cf56e662$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            control._options.shouldUnregister || shouldUnregister ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(prepend, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(append, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $0d70f179cf56e662$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $0d70f179cf56e662$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useRef(undefined);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $0d70f179cf56e662$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        validatingFields: {},
        errors: props.errors || {},
        disabled: props.disabled || false,
        isReady: false,
        defaultValues: $0d70f179cf56e662$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) {
        if (props.formControl) {
            _formControl.current = {
                ...props.formControl,
                formState: formState
            };
            if (props.defaultValues && !$0d70f179cf56e662$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const { formControl: formControl, ...rest } = $0d70f179cf56e662$export$1361f5e0e4cca3c3(props);
            _formControl.current = {
                ...rest,
                formState: formState
            };
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    $0d70f179cf56e662$var$useIsomorphicLayoutEffect(()=>{
        const sub = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState({
                    ...control._formState
                }),
            reRenderRoot: true
        });
        updateFormState((data)=>({
                ...data,
                isReady: true
            }));
        control._formState.isReady = true;
        return sub;
    }, [
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (props.values && !$0d70f179cf56e662$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, {
                keepFieldsRef: true,
                ...control._options.resetOptions
            });
            _values.current = props.values;
            updateFormState((state)=>({
                    ...state
                }));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $0d70f179cf56e662$var$getProxyFormState(formState, control);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param names - Array of field names to watch for changes
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const $0d70f179cf56e662$export$4c68f1a79f88778c = ({ control: control, names: names, render: render })=>render($0d70f179cf56e662$export$3c773aa2b84f29e0({
        control: control,
        name: names
    }));


const $755dbc5e78f72812$export$1fc34e4d2dc67769 = ({ isDrawerOpen: isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen, header: header, handleSave: handleSave, form: form, defaultValues: defaultValues = {}, submitButtonLabel: submitButtonLabel = 'Save' })=>{
    const { handleSubmit: handleSubmit, formState: { errors: errors }, control: control, reset: reset } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: defaultValues
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c5e6c7e7e283ee4$export$2e2bcd8739ae039), {
        anchor: "right",
        open: isDrawerOpen,
        onClose: ()=>{
            reset(defaultValues);
            setIsDrawerOpen(false);
        },
        ModalProps: {
            keepMounted: true // Better open performance on mobile.
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
            sx: {
                marginTop: '50px',
                width: '600px'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e721a73094186d5d$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    flexDirection: 'column',
                    minHeight: 400,
                    p: 4
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                    onSubmit: handleSubmit((data)=>handleSave(data)),
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                justifyContent: 'space-between'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "h5",
                                        children: header
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                    sx: {
                                        alignItems: 'center',
                                        display: 'flex'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                flexGrow: 1
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                            onClick: ()=>{
                                                reset(defaultValues);
                                                setIsDrawerOpen(false);
                                            },
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                            sx: {
                                                ml: 1
                                            },
                                            type: "submit",
                                            variant: "contained",
                                            children: submitButtonLabel
                                        })
                                    ]
                                })
                            ]
                        }),
                        form({
                            errors: errors,
                            control: control
                        })
                    ]
                })
            })
        })
    });
};



var $acw62 = parcelRequire("acw62");
// src/mutationObserver.ts




var $1ddf06f11bccca52$export$d3c1860ee66f291a = class extends (0, $f28bf069faa02086$export$d26086b469ecdbcc) {
    #client;
    #currentResult = void 0;
    #currentMutation;
    #mutateOptions;
    constructor(client, options){
        super();
        this.#client = client;
        this.setOptions(options);
        this.bindMethods();
        this.#updateResult();
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        this.options = this.#client.defaultMutationOptions(options);
        if (!(0, $938ae10f13d49bdc$export$3e67810a3f0e9f1c)(this.options, prevOptions)) this.#client.getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: this.#currentMutation,
            observer: this
        });
        if (prevOptions?.mutationKey && this.options.mutationKey && (0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(prevOptions.mutationKey) !== (0, $938ae10f13d49bdc$export$1e87d19d4aab5805)(this.options.mutationKey)) this.reset();
        else if (this.#currentMutation?.state.status === "pending") this.#currentMutation.setOptions(this.options);
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.#currentMutation?.removeObserver(this);
    }
    onMutationUpdate(action) {
        this.#updateResult();
        this.#notify(action);
    }
    getCurrentResult() {
        return this.#currentResult;
    }
    reset() {
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = void 0;
        this.#updateResult();
        this.#notify();
    }
    mutate(variables, options) {
        this.#mutateOptions = options;
        this.#currentMutation?.removeObserver(this);
        this.#currentMutation = this.#client.getMutationCache().build(this.#client, this.options);
        this.#currentMutation.addObserver(this);
        return this.#currentMutation.execute(variables);
    }
    #updateResult() {
        const state = this.#currentMutation?.state ?? (0, $524c502dbe70a85f$export$a1659b54bac3252a)();
        this.#currentResult = {
            ...state,
            isPending: state.status === "pending",
            isSuccess: state.status === "success",
            isError: state.status === "error",
            isIdle: state.status === "idle",
            mutate: this.mutate,
            reset: this.reset
        };
    }
    #notify(action) {
        (0, $e2307e33fb454067$export$520687f44db6e1ab).batch(()=>{
            if (this.#mutateOptions && this.hasListeners()) {
                const variables = this.#currentResult.variables;
                const onMutateResult = this.#currentResult.context;
                const context = {
                    client: this.#client,
                    meta: this.options.meta,
                    mutationKey: this.options.mutationKey
                };
                if (action?.type === "success") {
                    this.#mutateOptions.onSuccess?.(action.data, variables, onMutateResult, context);
                    this.#mutateOptions.onSettled?.(action.data, null, variables, onMutateResult, context);
                } else if (action?.type === "error") {
                    this.#mutateOptions.onError?.(action.error, variables, onMutateResult, context);
                    this.#mutateOptions.onSettled?.(void 0, action.error, variables, onMutateResult, context);
                }
            }
            this.listeners.forEach((listener)=>{
                listener(this.#currentResult);
            });
        });
    }
};



"use client";
function $6a05afbd57376433$export$609860bf8b0084c(options, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const [observer] = $acw62.useState(()=>new (0, $1ddf06f11bccca52$export$d3c1860ee66f291a)(client, options));
    $acw62.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>observer.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = $acw62.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, $938ae10f13d49bdc$export$8793edee2d425525));
    }, [
        observer
    ]);
    if (result.error && (0, $938ae10f13d49bdc$export$2072f68e6c3507cf)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate: mutate,
        mutateAsync: result.mutate
    };
}





var $acw62 = parcelRequire("acw62");
function $0d335ad283e2aa12$export$988a5bd7ab6663e0() {
    const { id: id } = (0, $84c11e79798ea0cb$export$99eaa27ddbbb95ef)();
    const [displayDialogState, setDisplayDialogState] = (0, $acw62.useState)({
        addRegistrationDialog: false,
        addDealDocumentsDialog: false
    });
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const addDocumentMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (params)=>(0, $930f18d689e94983$export$7b639b94d0b7f4c4).addDocument({
                vin: vehicle.vin,
                vehicleId: vehicle.id,
                kind: params.kind,
                document: params.document
            }),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'getVehicle',
                    id
                ]
            });
        }
    });
    const { data: vehicle, isLoading: isLoading } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'getVehicle',
            id
        ],
        queryFn: async ()=>{
            const response = await (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getVehicleById(id);
            return response.vehicle;
        }
    });
    return {
        vehicle: vehicle,
        isLoading: isLoading,
        displayDialogState: displayDialogState,
        setDisplayDialogState: setDisplayDialogState,
        addDocumentMutation: addDocumentMutation,
        setReload () {
            console.log('reload data n page pls...');
        }
    };
}
function $0d335ad283e2aa12$export$45e53ffcf3617ecf(state) {
    switch(state){
        case 0:
            return 'In process';
        case 1:
            return 'In listing';
        case 2:
            return 'In order';
        case 3:
            return 'On subscription';
        case 4:
            return 'Charge off skip';
        case 5:
            return 'Pending return';
        case 6:
            return 'Return scheduled';
        case 7:
            return 'Return cancelled';
        case 8:
            return 'Off subscription';
        case 9:
            return 'Vehicle recycled';
        case 10:
            return 'Vehicle sold';
        case 11:
            return 'Repo eligible';
        case 12:
            return 'Out for repo';
        case 13:
            return 'Charge off eligible';
        default:
            return 'N/A';
    }
}



var $acw62 = parcelRequire("acw62");



var $9YICB = parcelRequire("9YICB");
function $4d63bbbb0528907c$export$2f644254e633ac30(vehicle) {
    const [isEditDrawerOpen, setIsEditDrawerOpen] = (0, $acw62.useState)(false);
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const updateVehicleMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (data)=>{
            if (!vehicle?.id) throw new Error('Vehicle ID is required');
            const newVehicle = new (0, $9YICB.Vehicle)();
            newVehicle.setId(vehicle.id);
            newVehicle.setMake(data.make);
            newVehicle.setModel(data.model);
            const exteriorColor = new (0, $9YICB.Color)();
            exteriorColor.setTitle(data.exteriorColor);
            newVehicle.setExteriorColorsList([
                exteriorColor
            ]);
            newVehicle.setFinancier(data.financier);
            console.log(newVehicle);
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).updateVehicle({
                vehicle: newVehicle
            });
        },
        onSuccess: ()=>{
            // Invalidate and refetch vehicle data
            if (vehicle?.id) queryClient.invalidateQueries({
                queryKey: [
                    'getVehicle',
                    vehicle?.id
                ]
            });
            setIsEditDrawerOpen(false);
        },
        onError: (error)=>{
            console.error('Failed to update vehicle:', error);
        }
    });
    const handleSave = (data)=>{
        updateVehicleMutation.mutate(data);
    };
    const getDefaultValues = ()=>({
            exteriorColor: vehicle?.exteriorColor || '',
            make: vehicle?.make || '',
            model: vehicle?.model || '',
            financier: vehicle?.financier || ''
        });
    return {
        isEditDrawerOpen: isEditDrawerOpen,
        setIsEditDrawerOpen: setIsEditDrawerOpen,
        handleSave: handleSave,
        getDefaultValues: getDefaultValues,
        isLoading: updateVehicleMutation.status === 'pending'
    };
}



parcelRequire("acw62");


const $2eaedd59b2218695$export$8bfd441a2e56a609 = ({ errors: errors, control: control })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            mt: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "exteriorColor",
                control: control,
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        label: "Color",
                        variant: "outlined",
                        fullWidth: true,
                        error: !!errors.exteriorColor,
                        helperText: errors.exteriorColor?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "make",
                control: control,
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        label: "Make",
                        variant: "outlined",
                        fullWidth: true,
                        error: !!errors.make,
                        helperText: errors.make?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "model",
                control: control,
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        label: "Model",
                        variant: "outlined",
                        fullWidth: true,
                        error: !!errors.model,
                        helperText: errors.model?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "financier",
                control: control,
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        label: "Financier",
                        variant: "outlined",
                        fullWidth: true,
                        error: !!errors.financier,
                        helperText: errors.financier?.message
                    })
            })
        ]
    });
};


const $7260db35854db5df$export$14e1a0793cbc3278 = ()=>{
    const { isLoading: isLoading, vehicle: vehicle, setDisplayDialogState: setDisplayDialogState, displayDialogState: displayDialogState } = (0, $0d335ad283e2aa12$export$988a5bd7ab6663e0)();
    const { isEditDrawerOpen: isEditDrawerOpen, setIsEditDrawerOpen: setIsEditDrawerOpen, handleSave: handleSave, getDefaultValues: getDefaultValues } = (0, $4d63bbbb0528907c$export$2f644254e633ac30)(vehicle);
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0891c3550aaff5f4$export$2e2bcd8739ae039), {});
    const { year: year, make: make, model: model, id: id, vin: vin } = vehicle;
    const dialogs = [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $208c589505d83d7e$export$2e2bcd8739ae039), {
            open: displayDialogState.addRegistrationDialog,
            handleClose: ()=>{
                setDisplayDialogState({
                    ...displayDialogState,
                    addRegistrationDialog: false
                });
            },
            id: id,
            vin: vin
        }, "addRegistrationDialog"),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8e21d75176cde62a$export$2e2bcd8739ae039), {
            open: displayDialogState.addDealDocumentsDialog,
            handleClose: ()=>{
                setDisplayDialogState({
                    ...displayDialogState,
                    addDealDocumentsDialog: false
                });
            },
            id: id,
            vin: vin
        }, "addDeadDocumentsDialog")
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $13157ffc893b45e9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b17c694846cf5b75$export$e0d897ee21382f67), {
                lastPageRoute: "/fleet"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $48a14f90dc08d980$export$89693000420c0acd), {
                heading: `${year} ${make} ${model}`,
                headerHasBottomBorder: true,
                children: [
                    dialogs.map((dialog)=>dialog),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                        heading: "Vehicle Details",
                        headerButtons: vehicle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                            onClick: ()=>setIsEditDrawerOpen(true),
                            size: "small",
                            sx: {
                                color: 'text.primary'
                            },
                            title: "Edit Vehicle",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccd4473bf517ef36$export$2e2bcd8739ae039), {})
                        }),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffb2ddecb0978f79$export$bc3cde56a28b78e3), {
                            vehicle: vehicle
                        })
                    })
                ]
            }),
            vehicle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                isDrawerOpen: isEditDrawerOpen,
                setIsDrawerOpen: setIsEditDrawerOpen,
                header: "Edit Vehicle",
                handleSave: handleSave,
                defaultValues: getDefaultValues(),
                form: (0, $2eaedd59b2218695$export$8bfd441a2e56a609)
            })
        ]
    });
};



parcelRequire("acw62");




const $3e0d78e1eee9f656$var$NotFound = ()=>{
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                children: "404 - Not Found!"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                component: (0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a),
                to: "/",
                sx: {
                    color: themeColors.buttonColor,
                    '&:hover': {
                        color: themeColors.buttonHover
                    }
                },
                children: "Go Home"
            })
        ]
    });
};
var $3e0d78e1eee9f656$export$2e2bcd8739ae039 = $3e0d78e1eee9f656$var$NotFound;




parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

const $4eceee0bc3fcf8e7$export$fb87ee9166eebffa = ()=>{
    return [
        /*
  TODO: Broken after React updates - needs to be fixed before re-adding but not currently being used so deprioritized
  {
    label: 'General',
    routes: [
      {
        label: 'Vehicle Map',
        target: '/assets/inventory',
        icon: 'public',
        exact: true,
      },
      {
        label: 'Vestaboard',
        target: '/vestaboard',
        icon: 'bar_chart',
      },
    ],
  },
  */ {
            label: 'Fleet',
            routes: [
                {
                    label: 'Vehicle Inventory',
                    target: '/fleet',
                    icon: 'directions_car',
                    exact: true
                },
                {
                    label: 'Appointments',
                    target: '/fleet/tasks',
                    icon: 'calendar_month'
                }
            ]
        },
        {
            label: 'Account/Billing',
            routes: [
                {
                    label: 'Reservations',
                    // ! In the current navigation reservations is under pmt, but does that make sense?
                    target: '/fleet/reservations',
                    icon: 'event_available'
                }
            ]
        },
        {
            label: 'Customer Acquisition',
            routes: [
                {
                    label: 'Promos',
                    target: '/promotions',
                    icon: 'confirmation_number'
                },
                {
                    label: 'Customers',
                    target: '/customers',
                    icon: 'group'
                }
            ]
        },
        {
            label: 'Nexus',
            routes: [
                {
                    label: 'Team Settings',
                    target: '/fleet/teamsettings',
                    icon: 'settings_applications'
                },
                {
                    label: 'Vehicle Media',
                    target: '/fleet/vehiclemedia',
                    icon: 'photo_library'
                }
            ]
        }
    ];
};


function $4813628f7e03fa90$export$8dba1581250258f4() {
    const { oktaAuth: oktaAuth } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const [isSidebarOpen, setSidebarOpen] = (0, $acw62.useState)(true);
    const logout = async ()=>{
        oktaAuth.tokenManager.clear();
        await oktaAuth.signOut();
    };
    const toggleSidebar = ()=>{
        setSidebarOpen((wasOpen)=>!wasOpen);
    };
    const { data: user } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'authenticatedUser'
        ],
        queryFn: async ()=>{
            const user = await oktaAuth.getUser();
            const initials = `${user.given_name?.[0]}${user.family_name?.[0]}`;
            return {
                ...user,
                initials: initials
            };
        },
        placeholderData: {
            initials: '',
            sub: '',
            auth_time: undefined,
            aud: undefined,
            email: undefined,
            email_verified: undefined,
            exp: undefined,
            family_name: undefined,
            given_name: undefined,
            iat: undefined,
            iss: undefined,
            jti: undefined,
            locale: undefined,
            name: undefined,
            preferred_username: undefined,
            zoneinfo: undefined,
            acr: undefined
        }
    });
    return {
        logout: logout,
        routes: (0, $4eceee0bc3fcf8e7$export$fb87ee9166eebffa)(),
        user: user,
        isSidebarOpen: isSidebarOpen,
        toggleSidebar: toggleSidebar
    };
}




var $acw62 = parcelRequire("acw62");








'use client';
const $c2e2000df495a70f$var$useUtilityClasses = (ownerState)=>{
    const { absolute: absolute, children: children, classes: classes, flexItem: flexItem, light: light, orientation: orientation, textAlign: textAlign, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            absolute && 'absolute',
            variant,
            light && 'light',
            orientation === 'vertical' && 'vertical',
            flexItem && 'flexItem',
            children && 'withChildren',
            children && orientation === 'vertical' && 'withChildrenVertical',
            textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight',
            textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'
        ],
        wrapper: [
            'wrapper',
            orientation === 'vertical' && 'wrapperVertical'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $0fc9796113f6362d$export$46f01d01378ec5a2), classes);
};
const $c2e2000df495a70f$var$DividerRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDivider',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.absolute && styles.absolute,
            styles[ownerState.variant],
            ownerState.light && styles.light,
            ownerState.orientation === 'vertical' && styles.vertical,
            ownerState.flexItem && styles.flexItem,
            ownerState.children && styles.withChildren,
            ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical,
            ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight,
            ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        margin: 0,
        // Reset browser default style.
        flexShrink: 0,
        borderWidth: 0,
        borderStyle: 'solid',
        borderColor: (theme.vars || theme).palette.divider,
        borderBottomWidth: 'thin',
        variants: [
            {
                props: {
                    absolute: true
                },
                style: {
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    width: '100%'
                }
            },
            {
                props: {
                    light: true
                },
                style: {
                    borderColor: theme.alpha((theme.vars || theme).palette.divider, 0.08)
                }
            },
            {
                props: {
                    variant: 'inset'
                },
                style: {
                    marginLeft: 72
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'horizontal'
                },
                style: {
                    marginLeft: theme.spacing(2),
                    marginRight: theme.spacing(2)
                }
            },
            {
                props: {
                    variant: 'middle',
                    orientation: 'vertical'
                },
                style: {
                    marginTop: theme.spacing(1),
                    marginBottom: theme.spacing(1)
                }
            },
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    height: '100%',
                    borderBottomWidth: 0,
                    borderRightWidth: 'thin'
                }
            },
            {
                props: {
                    flexItem: true
                },
                style: {
                    alignSelf: 'stretch',
                    height: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.children,
                style: {
                    display: 'flex',
                    textAlign: 'center',
                    border: 0,
                    borderTopStyle: 'solid',
                    borderLeftStyle: 'solid',
                    '&::before, &::after': {
                        content: '""',
                        alignSelf: 'center'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.children && ownerState.orientation !== 'vertical',
                style: {
                    '&::before, &::after': {
                        width: '100%',
                        borderTop: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderTopStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.orientation === 'vertical' && ownerState.children,
                style: {
                    flexDirection: 'column',
                    '&::before, &::after': {
                        height: '100%',
                        borderLeft: `thin solid ${(theme.vars || theme).palette.divider}`,
                        borderLeftStyle: 'inherit'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '90%'
                    },
                    '&::after': {
                        width: '10%'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical',
                style: {
                    '&::before': {
                        width: '10%'
                    },
                    '&::after': {
                        width: '90%'
                    }
                }
            }
        ]
    })));
const $c2e2000df495a70f$var$DividerWrapper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiDivider',
    slot: 'Wrapper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.wrapper,
            ownerState.orientation === 'vertical' && styles.wrapperVertical
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-block',
        paddingLeft: `calc(${theme.spacing(1)} * 1.2)`,
        paddingRight: `calc(${theme.spacing(1)} * 1.2)`,
        whiteSpace: 'nowrap',
        variants: [
            {
                props: {
                    orientation: 'vertical'
                },
                style: {
                    paddingTop: `calc(${theme.spacing(1)} * 1.2)`,
                    paddingBottom: `calc(${theme.spacing(1)} * 1.2)`
                }
            }
        ]
    })));
const $c2e2000df495a70f$var$Divider = /*#__PURE__*/ $acw62.forwardRef(function Divider(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDivider'
    });
    const { absolute: absolute = false, children: children, className: className, orientation: orientation = 'horizontal', component: component = children || orientation === 'vertical' ? 'div' : 'hr', flexItem: flexItem = false, light: light = false, role: role = component !== 'hr' ? 'separator' : undefined, textAlign: textAlign = 'center', variant: variant = 'fullWidth', ...other } = props;
    const ownerState = {
        ...props,
        absolute: absolute,
        component: component,
        flexItem: flexItem,
        light: light,
        orientation: orientation,
        role: role,
        textAlign: textAlign,
        variant: variant
    };
    const classes = $c2e2000df495a70f$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c2e2000df495a70f$var$DividerRoot, {
        as: component,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        role: role,
        ref: ref,
        ownerState: ownerState,
        "aria-orientation": role === 'separator' && (component !== 'hr' || orientation === 'vertical') ? orientation : undefined,
        ...other,
        children: children ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c2e2000df495a70f$var$DividerWrapper, {
            className: classes.wrapper,
            ownerState: ownerState,
            children: children
        }) : null
    });
});
/**
 * The following flag is used to ensure that this component isn't tabbable i.e.
 * does not get highlight/focus inside of MUI List.
 */ if ($c2e2000df495a70f$var$Divider) $c2e2000df495a70f$var$Divider.muiSkipListHighlight = true;
var $c2e2000df495a70f$export$2e2bcd8739ae039 = $c2e2000df495a70f$var$Divider;


var $acw62 = parcelRequire("acw62");









function $6ee90eb78ea2438c$export$6816d4fc0981ec7(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiListSubheader', slot);
}
const $6ee90eb78ea2438c$var$listSubheaderClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiListSubheader', [
    'root',
    'colorPrimary',
    'colorInherit',
    'gutters',
    'inset',
    'sticky'
]);
var $6ee90eb78ea2438c$export$2e2bcd8739ae039 = $6ee90eb78ea2438c$var$listSubheaderClasses;



'use client';
const $43d645228959d4db$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, disableGutters: disableGutters, inset: inset, disableSticky: disableSticky } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'default' && `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            !disableGutters && 'gutters',
            inset && 'inset',
            !disableSticky && 'sticky'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $6ee90eb78ea2438c$export$6816d4fc0981ec7), classes);
};
const $43d645228959d4db$var$ListSubheaderRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('li', {
    name: 'MuiListSubheader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'default' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            !ownerState.disableGutters && styles.gutters,
            ownerState.inset && styles.inset,
            !ownerState.disableSticky && styles.sticky
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxSizing: 'border-box',
        lineHeight: '48px',
        listStyle: 'none',
        color: (theme.vars || theme).palette.text.secondary,
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(14),
        variants: [
            {
                props: {
                    color: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: 'inherit'
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.inset,
                style: {
                    paddingLeft: 72
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableSticky,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 1,
                    backgroundColor: (theme.vars || theme).palette.background.paper
                }
            }
        ]
    })));
const $43d645228959d4db$var$ListSubheader = /*#__PURE__*/ $acw62.forwardRef(function ListSubheader(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListSubheader'
    });
    const { className: className, color: color = 'default', component: component = 'li', disableGutters: disableGutters = false, disableSticky: disableSticky = false, inset: inset = false, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        component: component,
        disableGutters: disableGutters,
        disableSticky: disableSticky,
        inset: inset
    };
    const classes = $43d645228959d4db$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($43d645228959d4db$var$ListSubheaderRoot, {
        as: component,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
if ($43d645228959d4db$var$ListSubheader) $43d645228959d4db$var$ListSubheader.muiSkipListHighlight = true;
var $43d645228959d4db$export$2e2bcd8739ae039 = $43d645228959d4db$var$ListSubheader;


var $acw62 = parcelRequire("acw62");








function $11a5c049f91ec9c6$export$b12cb262231eef32(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiToolbar', slot);
}
const $11a5c049f91ec9c6$var$toolbarClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiToolbar', [
    'root',
    'gutters',
    'regular',
    'dense'
]);
var $11a5c049f91ec9c6$export$2e2bcd8739ae039 = $11a5c049f91ec9c6$var$toolbarClasses;



'use client';
const $e223a49097a073d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableGutters: disableGutters, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            !disableGutters && 'gutters',
            variant
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $11a5c049f91ec9c6$export$b12cb262231eef32), classes);
};
const $e223a49097a073d9$var$ToolbarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiToolbar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            !ownerState.disableGutters && styles.gutters,
            styles[ownerState.variant]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableGutters,
                style: {
                    paddingLeft: theme.spacing(2),
                    paddingRight: theme.spacing(2),
                    [theme.breakpoints.up('sm')]: {
                        paddingLeft: theme.spacing(3),
                        paddingRight: theme.spacing(3)
                    }
                }
            },
            {
                props: {
                    variant: 'dense'
                },
                style: {
                    minHeight: 48
                }
            },
            {
                props: {
                    variant: 'regular'
                },
                style: theme.mixins.toolbar
            }
        ]
    })));
const $e223a49097a073d9$var$Toolbar = /*#__PURE__*/ $acw62.forwardRef(function Toolbar(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiToolbar'
    });
    const { className: className, component: component = 'div', disableGutters: disableGutters = false, variant: variant = 'regular', ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableGutters: disableGutters,
        variant: variant
    };
    const classes = $e223a49097a073d9$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e223a49097a073d9$var$ToolbarRoot, {
        as: component,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $e223a49097a073d9$export$2e2bcd8739ae039 = $e223a49097a073d9$var$Toolbar;


var $acw62 = parcelRequire("acw62");



'use client';
// TODO React 17: Remove `useMediaQueryOld` once React 17 support is removed
function $942f413c6b94358c$var$useMediaQueryOld(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const [match, setMatch] = $acw62.useState(()=>{
        if (noSsr && matchMedia) return matchMedia(query).matches;
        if (ssrMatchMedia) return ssrMatchMedia(query).matches;
        // Once the component is mounted, we rely on the
        // event listeners to return the correct matches value.
        return defaultMatches;
    });
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!matchMedia) return undefined;
        const queryList = matchMedia(query);
        const updateMatch = ()=>{
            setMatch(queryList.matches);
        };
        updateMatch();
        queryList.addEventListener('change', updateMatch);
        return ()=>{
            queryList.removeEventListener('change', updateMatch);
        };
    }, [
        query,
        matchMedia
    ]);
    return match;
}
// See https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379 for why
const $942f413c6b94358c$var$safeReact = {
    ...$acw62
};
const $942f413c6b94358c$var$maybeReactUseSyncExternalStore = $942f413c6b94358c$var$safeReact.useSyncExternalStore;
function $942f413c6b94358c$var$useMediaQueryNew(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr) {
    const getDefaultSnapshot = $acw62.useCallback(()=>defaultMatches, [
        defaultMatches
    ]);
    const getServerSnapshot = $acw62.useMemo(()=>{
        if (noSsr && matchMedia) return ()=>matchMedia(query).matches;
        if (ssrMatchMedia !== null) {
            const { matches: matches } = ssrMatchMedia(query);
            return ()=>matches;
        }
        return getDefaultSnapshot;
    }, [
        getDefaultSnapshot,
        query,
        ssrMatchMedia,
        noSsr,
        matchMedia
    ]);
    const [getSnapshot, subscribe] = $acw62.useMemo(()=>{
        if (matchMedia === null) return [
            getDefaultSnapshot,
            ()=>()=>{}
        ];
        const mediaQueryList = matchMedia(query);
        return [
            ()=>mediaQueryList.matches,
            (notify)=>{
                mediaQueryList.addEventListener('change', notify);
                return ()=>{
                    mediaQueryList.removeEventListener('change', notify);
                };
            }
        ];
    }, [
        getDefaultSnapshot,
        matchMedia,
        query
    ]);
    const match = $942f413c6b94358c$var$maybeReactUseSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
    return match;
}
function $942f413c6b94358c$export$96d7927a982220b5(params = {}) {
    const { themeId: themeId } = params;
    return function useMediaQuery(queryInput, options = {}) {
        let theme = (0, $bba4444e1ea571ca$export$2e2bcd8739ae039)();
        if (theme && themeId) theme = theme[themeId] || theme;
        // Wait for jsdom to support the match media feature.
        // All the browsers MUI support have this built-in.
        // This defensive check is here for simplicity.
        // Most of the time, the match media logic isn't central to people tests.
        const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
        const { defaultMatches: defaultMatches = false, matchMedia: matchMedia = supportMatchMedia ? window.matchMedia : null, ssrMatchMedia: ssrMatchMedia = null, noSsr: noSsr = false } = (0, $8ec30e4d54713c84$export$2e2bcd8739ae039)({
            name: 'MuiUseMediaQuery',
            props: options,
            theme: theme
        });
        let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
        query = query.replace(/^@media( ?)/m, '');
        if (query.includes('print')) console.warn([
            `MUI: You have provided a \`print\` query to the \`useMediaQuery\` hook.`,
            'Using the print media query to modify print styles can lead to unexpected results.',
            'Consider using the `displayPrint` field in the `sx` prop instead.',
            'More information about `displayPrint` on our docs: https://mui.com/system/display/#display-in-print.'
        ].join('\n'));
        const useMediaQueryImplementation = $942f413c6b94358c$var$maybeReactUseSyncExternalStore !== undefined ? $942f413c6b94358c$var$useMediaQueryNew : $942f413c6b94358c$var$useMediaQueryOld;
        const match = useMediaQueryImplementation(query, defaultMatches, matchMedia, ssrMatchMedia, noSsr);
        return match;
    };
}
const $942f413c6b94358c$var$useMediaQuery = $942f413c6b94358c$export$96d7927a982220b5();
var $942f413c6b94358c$export$2e2bcd8739ae039 = $942f413c6b94358c$var$useMediaQuery;



const $4256528f2d3b21ab$var$useMediaQuery = (0, $942f413c6b94358c$export$96d7927a982220b5)({
    themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039)
});
var $4256528f2d3b21ab$export$2e2bcd8739ae039 = $4256528f2d3b21ab$var$useMediaQuery;



var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");










function $fcb7f5142d97d65c$export$e7545bb336f9a5fc(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiIcon', slot);
}
const $fcb7f5142d97d65c$var$iconClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiIcon', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'colorAction',
    'colorError',
    'colorDisabled',
    'fontSizeInherit',
    'fontSizeSmall',
    'fontSizeMedium',
    'fontSizeLarge'
]);
var $fcb7f5142d97d65c$export$2e2bcd8739ae039 = $fcb7f5142d97d65c$var$iconClasses;



'use client';
const $8ef87b97581793e1$var$useUtilityClasses = (ownerState)=>{
    const { color: color, fontSize: fontSize, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            color !== 'inherit' && `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `fontSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(fontSize)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $fcb7f5142d97d65c$export$e7545bb336f9a5fc), classes);
};
const $8ef87b97581793e1$var$IconRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.color !== 'inherit' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[`fontSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.fontSize)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        userSelect: 'none',
        width: '1em',
        height: '1em',
        // Chrome fix for https://issues.chromium.org/issues/41375697
        // To remove at some point.
        overflow: 'hidden',
        display: 'inline-block',
        // allow overflow hidden to take action
        textAlign: 'center',
        // support non-square icon
        flexShrink: 0,
        variants: [
            {
                props: {
                    fontSize: 'inherit'
                },
                style: {
                    fontSize: 'inherit'
                }
            },
            {
                props: {
                    fontSize: 'small'
                },
                style: {
                    fontSize: theme.typography.pxToRem(20)
                }
            },
            {
                props: {
                    fontSize: 'medium'
                },
                style: {
                    fontSize: theme.typography.pxToRem(24)
                }
            },
            {
                props: {
                    fontSize: 'large'
                },
                style: {
                    fontSize: theme.typography.pxToRem(36)
                }
            },
            {
                props: {
                    color: 'action'
                },
                style: {
                    color: (theme.vars || theme).palette.action.active
                }
            },
            {
                props: {
                    color: 'disabled'
                },
                style: {
                    color: (theme.vars || theme).palette.action.disabled
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    color: undefined
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main
                    }
                }))
        ]
    })));
const $8ef87b97581793e1$var$Icon = /*#__PURE__*/ $acw62.forwardRef(function Icon(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiIcon'
    });
    const { baseClassName: baseClassName = 'material-icons', className: className, color: color = 'inherit', component: Component = 'span', fontSize: fontSize = 'medium', ...other } = props;
    const ownerState = {
        ...props,
        baseClassName: baseClassName,
        color: color,
        component: Component,
        fontSize: fontSize
    };
    const classes = $8ef87b97581793e1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8ef87b97581793e1$var$IconRoot, {
        as: Component,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(baseClassName, // Prevent the translation of the text content.
        // The font relies on the exact text content to render the icon.
        'notranslate', classes.root, className),
        ownerState: ownerState,
        "aria-hidden": true,
        ref: ref,
        ...other
    });
});
$8ef87b97581793e1$var$Icon.muiName = 'Icon';
var $8ef87b97581793e1$export$2e2bcd8739ae039 = $8ef87b97581793e1$var$Icon;


var $acw62 = parcelRequire("acw62");














function $f57d788b3d4818ce$export$5682c366c0c669d9(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiListItem', slot);
}
const $f57d788b3d4818ce$var$listItemClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiListItem', [
    'root',
    'container',
    'dense',
    'alignItemsFlexStart',
    'divider',
    'gutters',
    'padding',
    'secondaryAction'
]);
var $f57d788b3d4818ce$export$2e2bcd8739ae039 = $f57d788b3d4818ce$var$listItemClasses;




function $9ec0b6032559d604$export$c09531d8563c67a5(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiListItemButton', slot);
}
const $9ec0b6032559d604$var$listItemButtonClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiListItemButton', [
    'root',
    'focusVisible',
    'dense',
    'alignItemsFlexStart',
    'disabled',
    'divider',
    'gutters',
    'selected'
]);
var $9ec0b6032559d604$export$2e2bcd8739ae039 = $9ec0b6032559d604$var$listItemButtonClasses;



var $acw62 = parcelRequire("acw62");








function $6e4beb15e8922c23$export$ccdb26aeba48a86e(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', slot);
}
const $6e4beb15e8922c23$var$listItemSecondaryActionClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiListItemSecondaryAction', [
    'root',
    'disableGutters'
]);
var $6e4beb15e8922c23$export$2e2bcd8739ae039 = $6e4beb15e8922c23$var$listItemSecondaryActionClasses;



'use client';
const $220479a88558a65e$var$useUtilityClasses = (ownerState)=>{
    const { disableGutters: disableGutters, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            disableGutters && 'disableGutters'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $6e4beb15e8922c23$export$ccdb26aeba48a86e), classes);
};
const $220479a88558a65e$var$ListItemSecondaryActionRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemSecondaryAction',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.disableGutters && styles.disableGutters
        ];
    }
})({
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.disableGutters,
            style: {
                right: 0
            }
        }
    ]
});
/**
 * Must be used as the last child of ListItem to function properly.
 *
 * @deprecated Use the `secondaryAction` prop in the `ListItem` component instead. This component will be removed in a future major release. See [Migrating from deprecated APIs](https://mui.com/material-ui/migration/migrating-from-deprecated-apis/) for more details.
 */ const $220479a88558a65e$var$ListItemSecondaryAction = /*#__PURE__*/ $acw62.forwardRef(function ListItemSecondaryAction(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemSecondaryAction'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        disableGutters: context.disableGutters
    };
    const classes = $220479a88558a65e$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($220479a88558a65e$var$ListItemSecondaryActionRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
$220479a88558a65e$var$ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var $220479a88558a65e$export$2e2bcd8739ae039 = $220479a88558a65e$var$ListItemSecondaryAction;



'use client';
const $c1d275280a204574$export$4334bb34c76fef24 = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        ownerState.dense && styles.dense,
        ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart,
        ownerState.divider && styles.divider,
        !ownerState.disableGutters && styles.gutters,
        !ownerState.disablePadding && styles.padding,
        ownerState.hasSecondaryAction && styles.secondaryAction
    ];
};
const $c1d275280a204574$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes, dense: dense, disableGutters: disableGutters, disablePadding: disablePadding, divider: divider, hasSecondaryAction: hasSecondaryAction } = ownerState;
    const slots = {
        root: [
            'root',
            dense && 'dense',
            !disableGutters && 'gutters',
            !disablePadding && 'padding',
            divider && 'divider',
            alignItems === 'flex-start' && 'alignItemsFlexStart',
            hasSecondaryAction && 'secondaryAction'
        ],
        container: [
            'container'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $f57d788b3d4818ce$export$5682c366c0c669d9), classes);
};
const $c1d275280a204574$export$aed538f7519abe89 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItem',
    slot: 'Root',
    overridesResolver: $c1d275280a204574$export$4334bb34c76fef24
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        textDecoration: 'none',
        width: '100%',
        boxSizing: 'border-box',
        textAlign: 'left',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding,
                style: {
                    paddingTop: 8,
                    paddingBottom: 8
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && ownerState.dense,
                style: {
                    paddingTop: 4,
                    paddingBottom: 4
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !ownerState.disableGutters,
                style: {
                    paddingLeft: 16,
                    paddingRight: 16
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.disablePadding && !!ownerState.secondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.secondaryAction,
                style: {
                    [`& > .${(0, $9ec0b6032559d604$export$2e2bcd8739ae039).root}`]: {
                        paddingRight: 48
                    }
                }
            },
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    alignItems: 'flex-start'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.divider,
                style: {
                    borderBottom: `1px solid ${(theme.vars || theme).palette.divider}`,
                    backgroundClip: 'padding-box'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.button,
                style: {
                    transition: theme.transitions.create('background-color', {
                        duration: theme.transitions.duration.shortest
                    }),
                    '&:hover': {
                        textDecoration: 'none',
                        backgroundColor: (theme.vars || theme).palette.action.hover,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasSecondaryAction,
                style: {
                    // Add some space to avoid collision as `ListItemSecondaryAction`
                    // is absolutely positioned.
                    paddingRight: 48
                }
            }
        ]
    })));
const $c1d275280a204574$var$ListItemContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('li', {
    name: 'MuiListItem',
    slot: 'Container'
})({
    position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */ const $c1d275280a204574$var$ListItem = /*#__PURE__*/ $acw62.forwardRef(function ListItem(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItem'
    });
    const { alignItems: alignItems = 'center', children: childrenProp, className: className, component: componentProp, components: components = {}, componentsProps: componentsProps = {}, ContainerComponent: ContainerComponent = 'li', ContainerProps: { className: ContainerClassName, ...ContainerProps } = {}, dense: dense = false, disableGutters: disableGutters = false, disablePadding: disablePadding = false, divider: divider = false, secondaryAction: secondaryAction, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const childContext = $acw62.useMemo(()=>({
            dense: dense || context.dense || false,
            alignItems: alignItems,
            disableGutters: disableGutters
        }), [
        alignItems,
        context.dense,
        dense,
        disableGutters
    ]);
    const listItemRef = $acw62.useRef(null);
    const children = $acw62.Children.toArray(childrenProp);
    // v4 implementation, deprecated in v6, will be removed in a future major release
    const hasSecondaryAction = children.length && (0, $a313fb4a2074834f$export$2e2bcd8739ae039)(children[children.length - 1], [
        'ListItemSecondaryAction'
    ]);
    const ownerState = {
        ...props,
        alignItems: alignItems,
        dense: childContext.dense,
        disableGutters: disableGutters,
        disablePadding: disablePadding,
        divider: divider,
        hasSecondaryAction: hasSecondaryAction
    };
    const classes = $c1d275280a204574$var$useUtilityClasses(ownerState);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(listItemRef, ref);
    const Root = slots.root || components.Root || $c1d275280a204574$export$aed538f7519abe89;
    const rootProps = slotProps.root || componentsProps.root || {};
    const componentProps = {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, rootProps.className, className),
        ...other
    };
    let Component = componentProp || 'li';
    // v4 implementation, deprecated in v6, will be removed in a future major release
    if (hasSecondaryAction) {
        // Use div by default.
        Component = !componentProps.component && !componentProp ? 'div' : Component;
        // Avoid nesting of li > li.
        if (ContainerComponent === 'li') {
            if (Component === 'li') Component = 'div';
            else if (componentProps.component === 'li') componentProps.component = 'div';
        }
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
            value: childContext,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c1d275280a204574$var$ListItemContainer, {
                as: ContainerComponent,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.container, ContainerClassName),
                ref: handleRef,
                ownerState: ownerState,
                ...ContainerProps,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Root, {
                        ...rootProps,
                        ...!(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                            as: Component,
                            ownerState: {
                                ...ownerState,
                                ...rootProps.ownerState
                            }
                        },
                        ...componentProps,
                        children: children
                    }),
                    children.pop()
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039).Provider, {
        value: childContext,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Root, {
            ...rootProps,
            as: Component,
            ref: handleRef,
            ...!(0, $7a8a64e8a5211ee5$export$2e2bcd8739ae039)(Root) && {
                ownerState: {
                    ...ownerState,
                    ...rootProps.ownerState
                }
            },
            ...componentProps,
            children: [
                children,
                secondaryAction && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $220479a88558a65e$export$2e2bcd8739ae039), {
                    children: secondaryAction
                })
            ]
        })
    });
});
var $c1d275280a204574$export$2e2bcd8739ae039 = $c1d275280a204574$var$ListItem;






const $f2d1cdb8e44df781$var$paddingLeft = 24;
const $f2d1cdb8e44df781$var$useSidebarItemStyles = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()((theme, { themeColors: themeColors })=>{
    return {
        base: {
            borderRadius: 1,
            justifyContent: 'flex-start',
            pl: `${$f2d1cdb8e44df781$var$paddingLeft}px`,
            pr: 3,
            textAlign: 'left',
            textTransform: 'none',
            width: '100%',
            '& span': {
                color: 'white'
            },
            '& div': {
                color: theme.palette.neutral?.[300]
            },
            '& .MuiButton-startIcon': {
                color: theme.palette.neutral?.[300]
            },
            '&:hover': {
                backgroundColor: 'rgba(255,255,255, 0.08)'
            }
        },
        active: {
            backgroundColor: 'rgba(255,255,255, 0.08)',
            color: themeColors.sidebarActive,
            fontWeight: 'fontWeightBold',
            '& span': {
                color: themeColors.sidebarActive
            },
            '& div': {
                color: themeColors.sidebarActive
            },
            '& .MuiButton-startIcon': {
                color: themeColors.sidebarActive
            }
        }
    };
});
const $f2d1cdb8e44df781$export$b09fc4897b18f7d8 = (props)=>{
    const { label: label, target: target, icon: icon } = props;
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const { classes: classes } = $f2d1cdb8e44df781$var$useSidebarItemStyles({
        themeColors: themeColors
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
        disableGutters: true,
        sx: {
            display: 'flex',
            mb: 0.5,
            py: 0,
            px: 2
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
            component: (0, $84c11e79798ea0cb$export$b0d92dbee9b5b60d),
            to: target,
            startIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ef87b97581793e1$export$2e2bcd8739ae039), {
                children: icon
            }),
            disableRipple: true,
            className: classes.base,
            classes: {
                root: classes.active
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    flexGrow: 1
                },
                children: label
            })
        })
    });
};


const $1f12bc9b3a583504$export$1ba59dacbcbf90fe = ({ routeGroups: routeGroups, isSidebarOpen: isSidebarOpen, toggleSidebar: toggleSidebar })=>{
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const lgUp = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)((theme)=>theme.breakpoints.up('lg'), {
        noSsr: true
    });
    const content = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e223a49097a073d9$export$2e2bcd8739ae039), {}),
            (0, $f1q41.map)(routeGroups, (routeGroup)=>{
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
                    subheader: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $43d645228959d4db$export$2e2bcd8739ae039), {
                        disableGutters: true,
                        disableSticky: true,
                        sx: {
                            color: 'neutral.500',
                            fontSize: '0.75rem',
                            fontWeight: 700,
                            lineHeight: 2.5,
                            ml: 2,
                            textTransform: 'uppercase'
                        },
                        children: routeGroup.label
                    }),
                    children: (0, $f1q41.map)(routeGroup.routes, (route)=>{
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f2d1cdb8e44df781$export$b09fc4897b18f7d8), {
                            exact: route.exact,
                            target: route.target,
                            label: route.label,
                            icon: route.icon
                        }, route.label);
                    })
                }, routeGroup.label);
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2e2000df495a70f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    paddingTop: 10,
                    padding: 2
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "subtitle1",
                        children: "Need Help?"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Join the slack channel!"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        variant: "contained",
                        target: "_blank",
                        href: "https://slack.com/app_redirect?channel=C03NYPE9L9K",
                        sx: {
                            backgroundColor: themeColors.buttonColor,
                            color: 'white',
                            '&:hover': {
                                backgroundColor: themeColors.buttonHover
                            }
                        },
                        children: "#nexus-support"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                style: {
                    flex: 1
                }
            })
        ]
    });
    if (lgUp) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c5e6c7e7e283ee4$export$2e2bcd8739ae039), {
            anchor: "left",
            onClose: toggleSidebar,
            open: isSidebarOpen,
            PaperProps: {
                sx: {
                    backgroundColor: themeColors.sidebarBackground,
                    borderRightColor: 'divider',
                    borderRightStyle: 'solid',
                    borderRightWidth: (theme)=>theme.palette.mode === 'dark' ? 1 : 0,
                    color: '#FFFFFF',
                    width: 280
                }
            },
            variant: "persistent",
            children: content
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c5e6c7e7e283ee4$export$2e2bcd8739ae039), {
        anchor: "left",
        onClose: toggleSidebar,
        open: isSidebarOpen,
        PaperProps: {
            sx: {
                backgroundColor: themeColors.sidebarBackground,
                color: '#FFFFFF',
                width: 280
            }
        },
        sx: {
            zIndex: (theme)=>theme.zIndex.appBar + 100
        },
        variant: "temporary",
        children: content
    });
};



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");











function $ecc4a2c716d1152c$export$47a2da616e55e8e9(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiAppBar', slot);
}
const $ecc4a2c716d1152c$var$appBarClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiAppBar', [
    'root',
    'positionFixed',
    'positionAbsolute',
    'positionSticky',
    'positionStatic',
    'positionRelative',
    'colorDefault',
    'colorPrimary',
    'colorSecondary',
    'colorInherit',
    'colorTransparent',
    'colorError',
    'colorInfo',
    'colorSuccess',
    'colorWarning'
]);
var $ecc4a2c716d1152c$export$2e2bcd8739ae039 = $ecc4a2c716d1152c$var$appBarClasses;



'use client';
const $75f50dd5200dc7fd$var$useUtilityClasses = (ownerState)=>{
    const { color: color, position: position, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `position${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(position)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $ecc4a2c716d1152c$export$47a2da616e55e8e9), classes);
};
// var2 is the fallback.
// Ex. var1: 'var(--a)', var2: 'var(--b)'; return: 'var(--a, var(--b))'
const $75f50dd5200dc7fd$var$joinVars = (var1, var2)=>var1 ? `${var1?.replace(')', '')}, ${var2})` : var2;
const $75f50dd5200dc7fd$var$AppBarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiAppBar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`position${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.position)}`],
            styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        boxSizing: 'border-box',
        // Prevent padding issue with the Modal and fixed positioned AppBar.
        flexShrink: 0,
        variants: [
            {
                props: {
                    position: 'fixed'
                },
                style: {
                    position: 'fixed',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0,
                    '@media print': {
                        // Prevent the app bar to be visible on each printed page.
                        position: 'absolute'
                    }
                }
            },
            {
                props: {
                    position: 'absolute'
                },
                style: {
                    position: 'absolute',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'sticky'
                },
                style: {
                    position: 'sticky',
                    zIndex: (theme.vars || theme).zIndex.appBar,
                    top: 0,
                    left: 'auto',
                    right: 0
                }
            },
            {
                props: {
                    position: 'static'
                },
                style: {
                    position: 'static'
                }
            },
            {
                props: {
                    position: 'relative'
                },
                style: {
                    position: 'relative'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    '--AppBar-color': 'inherit'
                }
            },
            {
                props: {
                    color: 'default'
                },
                style: {
                    '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[100],
                    '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[100]),
                    ...theme.applyStyles('dark', {
                        '--AppBar-background': theme.vars ? theme.vars.palette.AppBar.defaultBg : theme.palette.grey[900],
                        '--AppBar-color': theme.vars ? theme.vars.palette.text.primary : theme.palette.getContrastText(theme.palette.grey[900])
                    })
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--AppBar-background': (theme.vars ?? theme).palette[color].main,
                        '--AppBar-color': (theme.vars ?? theme).palette[color].contrastText
                    }
                })),
            {
                props: (props)=>props.enableColorOnDark === true && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)'
                }
            },
            {
                props: (props)=>props.enableColorOnDark === false && ![
                        'inherit',
                        'transparent'
                    ].includes(props.color),
                style: {
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundColor: theme.vars ? $75f50dd5200dc7fd$var$joinVars(theme.vars.palette.AppBar.darkBg, 'var(--AppBar-background)') : null,
                        color: theme.vars ? $75f50dd5200dc7fd$var$joinVars(theme.vars.palette.AppBar.darkColor, 'var(--AppBar-color)') : null
                    })
                }
            },
            {
                props: {
                    color: 'transparent'
                },
                style: {
                    '--AppBar-background': 'transparent',
                    '--AppBar-color': 'inherit',
                    backgroundColor: 'var(--AppBar-background)',
                    color: 'var(--AppBar-color)',
                    ...theme.applyStyles('dark', {
                        backgroundImage: 'none'
                    })
                }
            }
        ]
    })));
const $75f50dd5200dc7fd$var$AppBar = /*#__PURE__*/ $acw62.forwardRef(function AppBar(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAppBar'
    });
    const { className: className, color: color = 'primary', enableColorOnDark: enableColorOnDark = false, position: position = 'fixed', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        position: position,
        enableColorOnDark: enableColorOnDark
    };
    const classes = $75f50dd5200dc7fd$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($75f50dd5200dc7fd$var$AppBarRoot, {
        square: true,
        component: "header",
        ownerState: ownerState,
        elevation: 4,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className, position === 'fixed' && 'mui-fixed'),
        ref: ref,
        ...other
    });
});
var $75f50dd5200dc7fd$export$2e2bcd8739ae039 = $75f50dd5200dc7fd$var$AppBar;



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
'use client';
function $7027da6f4b17de9d$var$usePreviousProps(value) {
    const ref = $acw62.useRef({});
    $acw62.useEffect(()=>{
        ref.current = value;
    });
    return ref.current;
}
var $7027da6f4b17de9d$export$2e2bcd8739ae039 = $7027da6f4b17de9d$var$usePreviousProps;


'use client';
function $59fbdc39f1f5d354$var$areArraysSame({ array1: array1, array2: array2, parser: parser = (value)=>value }) {
    return array1 && array2 && array1.length === array2.length && array1.every((prevOption, index)=>parser(prevOption) === parser(array2[index]));
}
// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
function $59fbdc39f1f5d354$var$stripDiacritics(string) {
    return string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}
function $59fbdc39f1f5d354$export$f76f94b238d946d8(config = {}) {
    const { ignoreAccents: ignoreAccents = true, ignoreCase: ignoreCase = true, limit: limit, matchFrom: matchFrom = 'any', stringify: stringify, trim: trim = false } = config;
    return (options, { inputValue: inputValue, getOptionLabel: getOptionLabel })=>{
        let input = trim ? inputValue.trim() : inputValue;
        if (ignoreCase) input = input.toLowerCase();
        if (ignoreAccents) input = $59fbdc39f1f5d354$var$stripDiacritics(input);
        const filteredOptions = !input ? options : options.filter((option)=>{
            let candidate = (stringify || getOptionLabel)(option);
            if (ignoreCase) candidate = candidate.toLowerCase();
            if (ignoreAccents) candidate = $59fbdc39f1f5d354$var$stripDiacritics(candidate);
            return matchFrom === 'start' ? candidate.startsWith(input) : candidate.includes(input);
        });
        return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
    };
}
const $59fbdc39f1f5d354$var$defaultFilterOptions = $59fbdc39f1f5d354$export$f76f94b238d946d8();
// Number of options to jump in list box when `Page Up` and `Page Down` keys are used.
const $59fbdc39f1f5d354$var$pageSize = 5;
const $59fbdc39f1f5d354$var$defaultIsActiveElementInListbox = (listboxRef)=>listboxRef.current !== null && listboxRef.current.parentElement?.contains(document.activeElement);
const $59fbdc39f1f5d354$var$MULTIPLE_DEFAULT_VALUE = [];
function $59fbdc39f1f5d354$var$getInputValue(value, multiple, getOptionLabel, renderValue) {
    if (multiple || value == null || renderValue) return '';
    const optionLabel = getOptionLabel(value);
    return typeof optionLabel === 'string' ? optionLabel : '';
}
function $59fbdc39f1f5d354$var$useAutocomplete(props) {
    const { unstable_isActiveElementInListbox: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_isActiveElementInListbox = $59fbdc39f1f5d354$var$defaultIsActiveElementInListbox, unstable_classNamePrefix: // eslint-disable-next-line @typescript-eslint/naming-convention
    unstable_classNamePrefix = 'Mui', autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, componentName: componentName = 'useAutocomplete', defaultValue: defaultValue = props.multiple ? $59fbdc39f1f5d354$var$MULTIPLE_DEFAULT_VALUE : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabledProp, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, filterOptions: filterOptions = $59fbdc39f1f5d354$var$defaultFilterOptions, filterSelectedOptions: filterSelectedOptions = false, freeSolo: freeSolo = false, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp = (option)=>option.label ?? option, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, isOptionEqualToValue: isOptionEqualToValue = (option, value)=>option === value, multiple: multiple = false, onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: openProp, openOnFocus: openOnFocus = false, options: options, readOnly: readOnly = false, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, value: valueProp } = props;
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idProp);
    let getOptionLabel = getOptionLabelProp;
    getOptionLabel = (option)=>{
        const optionLabel = getOptionLabelProp(option);
        if (typeof optionLabel !== 'string') return String(optionLabel);
        return optionLabel;
    };
    const ignoreFocus = $acw62.useRef(false);
    const firstFocus = $acw62.useRef(true);
    const inputRef = $acw62.useRef(null);
    const listboxRef = $acw62.useRef(null);
    const [anchorEl, setAnchorEl] = $acw62.useState(null);
    const [focusedItem, setFocusedItem] = $acw62.useState(-1);
    const defaultHighlighted = autoHighlight ? 0 : -1;
    const highlightedIndexRef = $acw62.useRef(defaultHighlighted);
    // Calculate the initial inputValue on mount only.
    // useRef ensures it doesn't update dynamically with defaultValue or value props.
    const initialInputValue = $acw62.useRef($59fbdc39f1f5d354$var$getInputValue(defaultValue ?? valueProp, multiple, getOptionLabel)).current;
    const [value, setValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: valueProp,
        default: defaultValue,
        name: componentName
    });
    const [inputValue, setInputValueState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: inputValueProp,
        default: initialInputValue,
        name: componentName,
        state: 'inputValue'
    });
    const [focused, setFocused] = $acw62.useState(false);
    const resetInputValue = $acw62.useCallback((event, newValue, reason)=>{
        // retain current `inputValue` if new option isn't selected and `clearOnBlur` is false
        // When `multiple` is enabled, `newValue` is an array of all selected items including the newly selected item
        const isOptionSelected = multiple ? value.length < newValue.length : newValue !== null;
        if (!isOptionSelected && !clearOnBlur) return;
        const newInputValue = $59fbdc39f1f5d354$var$getInputValue(newValue, multiple, getOptionLabel, renderValue);
        if (inputValue === newInputValue) return;
        setInputValueState(newInputValue);
        if (onInputChange) onInputChange(event, newInputValue, reason);
    }, [
        getOptionLabel,
        inputValue,
        multiple,
        onInputChange,
        setInputValueState,
        clearOnBlur,
        value,
        renderValue
    ]);
    const [open, setOpenState] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: componentName,
        state: 'open'
    });
    const [inputPristine, setInputPristine] = $acw62.useState(true);
    const inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
    const popupOpen = open && !readOnly;
    const filteredOptions = popupOpen ? filterOptions(options.filter((option)=>{
        if (filterSelectedOptions && (multiple ? value : [
            value
        ]).some((value2)=>value2 !== null && isOptionEqualToValue(option, value2))) return false;
        return true;
    }), // we use the empty string to manipulate `filterOptions` to not filter any options
    // i.e. the filter predicate always returns true
    {
        inputValue: inputValueIsSelectedValue && inputPristine ? '' : inputValue,
        getOptionLabel: getOptionLabel
    }) : [];
    const previousProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        filteredOptions: filteredOptions,
        value: value,
        inputValue: inputValue
    });
    $acw62.useEffect(()=>{
        const valueChange = value !== previousProps.value;
        if (focused && !valueChange) return;
        // Only reset the input's value when freeSolo if the component's value changes.
        if (freeSolo && !valueChange) return;
        resetInputValue(null, value, 'reset');
    }, [
        value,
        resetInputValue,
        focused,
        previousProps.value,
        freeSolo
    ]);
    const listboxAvailable = open && filteredOptions.length > 0 && !readOnly;
    const focusItem = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((itemToFocus)=>{
        if (itemToFocus === -1) inputRef.current.focus();
        else {
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is gone.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            anchorEl.querySelector(`[${indexType}="${itemToFocus}"]`).focus();
        }
    });
    // Ensure the focusedItem is never inconsistent
    $acw62.useEffect(()=>{
        if (multiple && focusedItem > value.length - 1) {
            setFocusedItem(-1);
            focusItem(-1);
        }
    }, [
        value,
        multiple,
        focusedItem,
        focusItem
    ]);
    function validOptionIndex(index, direction) {
        if (!listboxRef.current || index < 0 || index >= filteredOptions.length) return -1;
        let nextFocus = index;
        while(true){
            const option = listboxRef.current.querySelector(`[data-option-index="${nextFocus}"]`);
            // Same logic as MenuList.js
            const nextFocusDisabled = disabledItemsFocusable ? false : !option || option.disabled || option.getAttribute('aria-disabled') === 'true';
            if (option && option.hasAttribute('tabindex') && !nextFocusDisabled) // The next option is available
            return nextFocus;
            // The next option is disabled, move to the next element.
            // with looped index
            if (direction === 'next') nextFocus = (nextFocus + 1) % filteredOptions.length;
            else nextFocus = (nextFocus - 1 + filteredOptions.length) % filteredOptions.length;
            // We end up with initial index, that means we don't have available options.
            // All of them are disabled
            if (nextFocus === index) return -1;
        }
    }
    const setHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, index: index, reason: reason })=>{
        highlightedIndexRef.current = index;
        // does the index exist?
        if (index === -1) inputRef.current.removeAttribute('aria-activedescendant');
        else inputRef.current.setAttribute('aria-activedescendant', `${id}-option-${index}`);
        if (onHighlightChange && [
            'mouse',
            'keyboard',
            'touch'
        ].includes(reason)) onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
        if (!listboxRef.current) return;
        const prev = listboxRef.current.querySelector(`[role="option"].${unstable_classNamePrefix}-focused`);
        if (prev) {
            prev.classList.remove(`${unstable_classNamePrefix}-focused`);
            prev.classList.remove(`${unstable_classNamePrefix}-focusVisible`);
        }
        let listboxNode = listboxRef.current;
        if (listboxRef.current.getAttribute('role') !== 'listbox') listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]');
        // "No results"
        if (!listboxNode) return;
        if (index === -1) {
            listboxNode.scrollTop = 0;
            return;
        }
        const option = listboxRef.current.querySelector(`[data-option-index="${index}"]`);
        if (!option) return;
        option.classList.add(`${unstable_classNamePrefix}-focused`);
        if (reason === 'keyboard') option.classList.add(`${unstable_classNamePrefix}-focusVisible`);
        // Scroll active descendant into view.
        // Logic copied from https://www.w3.org/WAI/content-assets/wai-aria-practices/patterns/combobox/examples/js/select-only.js
        // In case of mouse clicks and touch (in mobile devices) we avoid scrolling the element and keep both behaviors same.
        // Consider this API instead once it has a better browser support:
        // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
        if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse' && reason !== 'touch') {
            const element = option;
            const scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
            const elementBottom = element.offsetTop + element.offsetHeight;
            if (elementBottom > scrollBottom) listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
            else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
        }
    });
    const changeHighlightedIndex = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ event: event, diff: diff, direction: direction = 'next', reason: reason })=>{
        if (!popupOpen) return;
        const getNextIndex = ()=>{
            const maxIndex = filteredOptions.length - 1;
            if (diff === 'reset') return defaultHighlighted;
            if (diff === 'start') return 0;
            if (diff === 'end') return maxIndex;
            const newIndex = highlightedIndexRef.current + diff;
            if (newIndex < 0) {
                if (newIndex === -1 && includeInputInList) return -1;
                if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) return 0;
                return maxIndex;
            }
            if (newIndex > maxIndex) {
                if (newIndex === maxIndex + 1 && includeInputInList) return -1;
                if (disableListWrap || Math.abs(diff) > 1) return maxIndex;
                return 0;
            }
            return newIndex;
        };
        const nextIndex = validOptionIndex(getNextIndex(), direction);
        setHighlightedIndex({
            index: nextIndex,
            reason: reason,
            event: event
        });
        // Sync the content of the input with the highlighted option.
        if (autoComplete && diff !== 'reset') {
            if (nextIndex === -1) inputRef.current.value = inputValue;
            else {
                const option = getOptionLabel(filteredOptions[nextIndex]);
                inputRef.current.value = option;
                // The portion of the selected suggestion that has not been typed by the user,
                // a completion string, appears inline after the input cursor in the textbox.
                const index = option.toLowerCase().indexOf(inputValue.toLowerCase());
                if (index === 0 && inputValue.length > 0) inputRef.current.setSelectionRange(inputValue.length, option.length);
            }
        }
    });
    const filteredOptionsChanged = !$59fbdc39f1f5d354$var$areArraysSame({
        array1: previousProps.filteredOptions,
        array2: filteredOptions,
        parser: getOptionLabel
    });
    const getPreviousHighlightedOptionIndex = ()=>{
        const isSameValue = (value1, value2)=>{
            const label1 = value1 ? getOptionLabel(value1) : '';
            const label2 = value2 ? getOptionLabel(value2) : '';
            return label1 === label2;
        };
        if (highlightedIndexRef.current !== -1 && !$59fbdc39f1f5d354$var$areArraysSame({
            array1: previousProps.filteredOptions,
            array2: filteredOptions,
            parser: getOptionLabel
        }) && previousProps.inputValue === inputValue && (multiple ? value.length === previousProps.value.length && previousProps.value.every((val, i)=>getOptionLabel(value[i]) === getOptionLabel(val)) : isSameValue(previousProps.value, value))) {
            const previousHighlightedOption = previousProps.filteredOptions[highlightedIndexRef.current];
            if (previousHighlightedOption) return filteredOptions.findIndex((option)=>{
                return getOptionLabel(option) === getOptionLabel(previousHighlightedOption);
            });
        }
        return -1;
    };
    const syncHighlightedIndex = $acw62.useCallback(()=>{
        if (!popupOpen) return;
        // Check if the previously highlighted option still exists in the updated filtered options list and if the value and inputValue haven't changed
        // If it exists and the value and the inputValue haven't changed, just update its index, otherwise continue execution
        const previousHighlightedOptionIndex = getPreviousHighlightedOptionIndex();
        if (previousHighlightedOptionIndex !== -1) {
            highlightedIndexRef.current = previousHighlightedOptionIndex;
            return;
        }
        const valueItem = multiple ? value[0] : value;
        // The popup is empty, reset
        if (filteredOptions.length === 0 || valueItem == null) {
            changeHighlightedIndex({
                diff: 'reset'
            });
            return;
        }
        if (!listboxRef.current) return;
        // Synchronize the value with the highlighted index
        if (valueItem != null) {
            const currentOption = filteredOptions[highlightedIndexRef.current];
            // Keep the current highlighted index if possible
            if (multiple && currentOption && value.findIndex((val)=>isOptionEqualToValue(currentOption, val)) !== -1) return;
            const itemIndex = filteredOptions.findIndex((optionItem)=>isOptionEqualToValue(optionItem, valueItem));
            if (itemIndex === -1) changeHighlightedIndex({
                diff: 'reset'
            });
            else setHighlightedIndex({
                index: itemIndex
            });
            return;
        }
        // Prevent the highlighted index to leak outside the boundaries.
        if (highlightedIndexRef.current >= filteredOptions.length - 1) {
            setHighlightedIndex({
                index: filteredOptions.length - 1
            });
            return;
        }
        // Restore the focus to the previous index.
        setHighlightedIndex({
            index: highlightedIndexRef.current
        });
    // Ignore filteredOptions (and options, isOptionEqualToValue, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        // Only sync the highlighted index when the option switch between empty and not
        filteredOptions.length,
        // Don't sync the highlighted index with the value when multiple
        // eslint-disable-next-line react-hooks/exhaustive-deps
        multiple ? false : value,
        filterSelectedOptions,
        changeHighlightedIndex,
        setHighlightedIndex,
        popupOpen,
        inputValue,
        multiple
    ]);
    const handleListboxRef = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((node)=>{
        (0, $c8b9145416f64bb2$export$2e2bcd8739ae039)(listboxRef, node);
        if (!node) return;
        syncHighlightedIndex();
    });
    $acw62.useEffect(()=>{
        if (filteredOptionsChanged || popupOpen) syncHighlightedIndex();
    }, [
        syncHighlightedIndex,
        filteredOptionsChanged,
        popupOpen
    ]);
    const handleOpen = (event)=>{
        if (open) return;
        setOpenState(true);
        setInputPristine(true);
        if (onOpen) onOpen(event);
    };
    const handleClose = (event, reason)=>{
        if (!open) return;
        setOpenState(false);
        if (onClose) onClose(event, reason);
    };
    const handleValue = (event, newValue, reason, details)=>{
        if (multiple) {
            if (value.length === newValue.length && value.every((val, i)=>val === newValue[i])) return;
        } else if (value === newValue) return;
        if (onChange) onChange(event, newValue, reason, details);
        setValueState(newValue);
    };
    const isTouch = $acw62.useRef(false);
    const selectNewValue = (event, option, reasonProp = 'selectOption', origin = 'options')=>{
        let reason = reasonProp;
        let newValue = option;
        if (multiple) {
            newValue = Array.isArray(value) ? value.slice() : [];
            const itemIndex = newValue.findIndex((valueItem)=>isOptionEqualToValue(option, valueItem));
            if (itemIndex === -1) newValue.push(option);
            else if (origin !== 'freeSolo') {
                newValue.splice(itemIndex, 1);
                reason = 'removeOption';
            }
        }
        resetInputValue(event, newValue, reason);
        handleValue(event, newValue, reason, {
            option: option
        });
        if (!disableCloseOnSelect && (!event || !event.ctrlKey && !event.metaKey)) handleClose(event, reason);
        if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) inputRef.current.blur();
    };
    function validItemIndex(index, direction) {
        if (index === -1) return -1;
        let nextFocus = index;
        while(true){
            // Out of range
            if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) return -1;
            // Using `data-tag-index` for deprecated `renderTags`. Remove when `renderTags` is removed.
            const indexType = renderValue ? 'data-item-index' : 'data-tag-index';
            const option = anchorEl.querySelector(`[${indexType}="${nextFocus}"]`);
            // Same logic as MenuList.js
            if (!option || !option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true') nextFocus += direction === 'next' ? 1 : -1;
            else return nextFocus;
        }
    }
    const handleFocusItem = (event, direction)=>{
        if (!multiple) return;
        if (inputValue === '') handleClose(event, 'toggleInput');
        let nextItem = focusedItem;
        if (focusedItem === -1) {
            if (inputValue === '' && direction === 'previous') nextItem = value.length - 1;
        } else {
            nextItem += direction === 'next' ? 1 : -1;
            if (nextItem < 0) nextItem = 0;
            if (nextItem === value.length) nextItem = -1;
        }
        nextItem = validItemIndex(nextItem, direction);
        setFocusedItem(nextItem);
        focusItem(nextItem);
    };
    const handleClear = (event)=>{
        ignoreFocus.current = true;
        setInputValueState('');
        if (onInputChange) onInputChange(event, '', 'clear');
        handleValue(event, multiple ? [] : null, 'clear');
    };
    const handleKeyDown = (other)=>(event)=>{
            if (other.onKeyDown) other.onKeyDown(event);
            if (event.defaultMuiPrevented) return;
            if (focusedItem !== -1 && ![
                'ArrowLeft',
                'ArrowRight'
            ].includes(event.key)) {
                setFocusedItem(-1);
                focusItem(-1);
            }
            // Wait until IME is settled.
            if (event.which !== 229) switch(event.key){
                case 'Home':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'start',
                            direction: 'next',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'End':
                    if (popupOpen && handleHomeEndKeys) {
                        // Prevent scroll of the page
                        event.preventDefault();
                        changeHighlightedIndex({
                            diff: 'end',
                            direction: 'previous',
                            reason: 'keyboard',
                            event: event
                        });
                    }
                    break;
                case 'PageUp':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -$59fbdc39f1f5d354$var$pageSize,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'PageDown':
                    // Prevent scroll of the page
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: $59fbdc39f1f5d354$var$pageSize,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowDown':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: 1,
                        direction: 'next',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowUp':
                    // Prevent cursor move
                    event.preventDefault();
                    changeHighlightedIndex({
                        diff: -1,
                        direction: 'previous',
                        reason: 'keyboard',
                        event: event
                    });
                    handleOpen(event);
                    break;
                case 'ArrowLeft':
                    if (!multiple && renderValue) focusItem(0);
                    else handleFocusItem(event, 'previous');
                    break;
                case 'ArrowRight':
                    if (!multiple && renderValue) focusItem(-1);
                    else handleFocusItem(event, 'next');
                    break;
                case 'Enter':
                    if (highlightedIndexRef.current !== -1 && popupOpen) {
                        const option = filteredOptions[highlightedIndexRef.current];
                        const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
                        // Avoid early form validation, let the end-users continue filling the form.
                        event.preventDefault();
                        if (disabled) return;
                        selectNewValue(event, option, 'selectOption');
                        // Move the selection to the end.
                        if (autoComplete) inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
                    } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
                        if (multiple) // Allow people to add new values before they submit the form.
                        event.preventDefault();
                        selectNewValue(event, inputValue, 'createOption', 'freeSolo');
                    }
                    break;
                case 'Escape':
                    if (popupOpen) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClose(event, 'escape');
                    } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0 || renderValue)) {
                        // Avoid Opera to exit fullscreen mode.
                        event.preventDefault();
                        // Avoid the Modal to handle the event.
                        event.stopPropagation();
                        handleClear(event);
                    }
                    break;
                case 'Backspace':
                    // Remove the value on the left of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0) {
                        const index = focusedItem === -1 ? value.length - 1 : focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly) {
                        setValueState(null);
                        focusItem(-1);
                    }
                    break;
                case 'Delete':
                    // Remove the value on the right of the "cursor"
                    if (multiple && !readOnly && inputValue === '' && value.length > 0 && focusedItem !== -1) {
                        const index = focusedItem;
                        const newValue = value.slice();
                        newValue.splice(index, 1);
                        handleValue(event, newValue, 'removeOption', {
                            option: value[index]
                        });
                    }
                    if (!multiple && renderValue && !readOnly) {
                        setValueState(null);
                        focusItem(-1);
                    }
                    break;
                default:
            }
        };
    const handleFocus = (event)=>{
        setFocused(true);
        if (openOnFocus && !ignoreFocus.current) handleOpen(event);
    };
    const handleBlur = (event)=>{
        // Ignore the event when using the scrollbar with IE11
        if (unstable_isActiveElementInListbox(listboxRef)) {
            inputRef.current.focus();
            return;
        }
        setFocused(false);
        firstFocus.current = true;
        ignoreFocus.current = false;
        if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
        else if (autoSelect && freeSolo && inputValue !== '') selectNewValue(event, inputValue, 'blur', 'freeSolo');
        else if (clearOnBlur) resetInputValue(event, value, 'blur');
        handleClose(event, 'blur');
    };
    const handleInputChange = (event)=>{
        const newValue = event.target.value;
        if (inputValue !== newValue) {
            setInputValueState(newValue);
            setInputPristine(false);
            if (onInputChange) onInputChange(event, newValue, 'input');
        }
        if (newValue === '') {
            if (!disableClearable && !multiple) handleValue(event, null, 'clear');
        } else handleOpen(event);
    };
    const handleOptionMouseMove = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        if (highlightedIndexRef.current !== index) setHighlightedIndex({
            event: event,
            index: index,
            reason: 'mouse'
        });
    };
    const handleOptionTouchStart = (event)=>{
        setHighlightedIndex({
            event: event,
            index: Number(event.currentTarget.getAttribute('data-option-index')),
            reason: 'touch'
        });
        isTouch.current = true;
    };
    const handleOptionClick = (event)=>{
        const index = Number(event.currentTarget.getAttribute('data-option-index'));
        selectNewValue(event, filteredOptions[index], 'selectOption');
        isTouch.current = false;
    };
    const handleItemDelete = (index)=>(event)=>{
            const newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'removeOption', {
                option: value[index]
            });
        };
    const handleSingleItemDelete = (event)=>{
        handleValue(event, null, 'removeOption', {
            option: value
        });
    };
    const handlePopupIndicator = (event)=>{
        if (open) handleClose(event, 'toggleInput');
        else handleOpen(event);
    };
    // Prevent input blur when interacting with the combobox
    const handleMouseDown = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        if (event.target.getAttribute('id') !== id) event.preventDefault();
    };
    // Focus the input when interacting with the combobox
    const handleClick = (event)=>{
        // Prevent focusing the input if click is anywhere outside the Autocomplete
        if (!event.currentTarget.contains(event.target)) return;
        inputRef.current.focus();
        if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) inputRef.current.select();
        firstFocus.current = false;
    };
    const handleInputMouseDown = (event)=>{
        if (!disabledProp && (inputValue === '' || !open)) handlePopupIndicator(event);
    };
    let dirty = freeSolo && inputValue.length > 0;
    dirty = dirty || (multiple ? value.length > 0 : value !== null);
    let groupedOptions = filteredOptions;
    if (groupBy) {
        // used to keep track of key and indexes in the result array
        const indexBy = new Map();
        let warn = false;
        groupedOptions = filteredOptions.reduce((acc, option, index)=>{
            const group = groupBy(option);
            if (acc.length > 0 && acc[acc.length - 1].group === group) acc[acc.length - 1].options.push(option);
            else acc.push({
                key: index,
                index: index,
                group: group,
                options: [
                    option
                ]
            });
            return acc;
        }, []);
    }
    if (disabledProp && focused) handleBlur();
    return {
        getRootProps: (other = {})=>({
                ...other,
                onKeyDown: handleKeyDown(other),
                onMouseDown: handleMouseDown,
                onClick: handleClick
            }),
        getInputLabelProps: ()=>({
                id: `${id}-label`,
                htmlFor: id
            }),
        getInputProps: ()=>({
                id: id,
                value: inputValue,
                onBlur: handleBlur,
                onFocus: handleFocus,
                onChange: handleInputChange,
                onMouseDown: handleInputMouseDown,
                // if open then this is handled imperatively so don't let react override
                // only have an opinion about this when closed
                'aria-activedescendant': popupOpen ? '' : null,
                'aria-autocomplete': autoComplete ? 'both' : 'list',
                'aria-controls': listboxAvailable ? `${id}-listbox` : undefined,
                'aria-expanded': listboxAvailable,
                // Disable browser's suggestion that might overlap with the popup.
                // Handle autocomplete but not autofill.
                autoComplete: 'off',
                ref: inputRef,
                autoCapitalize: 'none',
                spellCheck: 'false',
                role: 'combobox',
                disabled: disabledProp
            }),
        getClearProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handleClear
            }),
        getItemProps: ({ index: index = 0 } = {})=>({
                ...multiple && {
                    key: index
                },
                ...renderValue ? {
                    'data-item-index': index
                } : {
                    'data-tag-index': index
                },
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: multiple ? handleItemDelete(index) : handleSingleItemDelete
                }
            }),
        getPopupIndicatorProps: ()=>({
                tabIndex: -1,
                type: 'button',
                onClick: handlePopupIndicator
            }),
        // deprecated
        getTagProps: ({ index: index })=>({
                key: index,
                'data-tag-index': index,
                tabIndex: -1,
                ...!readOnly && {
                    onDelete: handleItemDelete(index)
                }
            }),
        getListboxProps: ()=>({
                role: 'listbox',
                id: `${id}-listbox`,
                'aria-labelledby': `${id}-label`,
                ref: handleListboxRef,
                onMouseDown: (event)=>{
                    // Prevent blur
                    event.preventDefault();
                }
            }),
        getOptionProps: ({ index: index, option: option })=>{
            const selected = (multiple ? value : [
                value
            ]).some((value2)=>value2 != null && isOptionEqualToValue(option, value2));
            const disabled = getOptionDisabled ? getOptionDisabled(option) : false;
            return {
                key: getOptionKey?.(option) ?? getOptionLabel(option),
                tabIndex: -1,
                role: 'option',
                id: `${id}-option-${index}`,
                onMouseMove: handleOptionMouseMove,
                onClick: handleOptionClick,
                onTouchStart: handleOptionTouchStart,
                'data-option-index': index,
                'aria-disabled': disabled,
                'aria-selected': selected
            };
        },
        id: id,
        inputValue: inputValue,
        value: value,
        dirty: dirty,
        expanded: popupOpen && anchorEl,
        popupOpen: popupOpen,
        focused: focused || focusedItem !== -1,
        anchorEl: anchorEl,
        setAnchorEl: setAnchorEl,
        focusedItem: focusedItem,
        // deprecated
        focusedTag: focusedItem,
        groupedOptions: groupedOptions
    };
}
var $59fbdc39f1f5d354$export$2e2bcd8739ae039 = $59fbdc39f1f5d354$var$useAutocomplete;







var $acw62 = parcelRequire("acw62");



parcelRequire("acw62");


'use client';
var $7c95756399850c64$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');












function $34bb079dc5960b54$export$31444911e4ee6fdd(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiChip', slot);
}
const $34bb079dc5960b54$var$chipClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiChip', [
    'root',
    'sizeSmall',
    'sizeMedium',
    'colorDefault',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'disabled',
    'clickable',
    'clickableColorPrimary',
    'clickableColorSecondary',
    'deletable',
    'deletableColorPrimary',
    'deletableColorSecondary',
    'outlined',
    'filled',
    'outlinedPrimary',
    'outlinedSecondary',
    'filledPrimary',
    'filledSecondary',
    'avatar',
    'avatarSmall',
    'avatarMedium',
    'avatarColorPrimary',
    'avatarColorSecondary',
    'icon',
    'iconSmall',
    'iconMedium',
    'iconColorPrimary',
    'iconColorSecondary',
    'label',
    'labelSmall',
    'labelMedium',
    'deleteIcon',
    'deleteIconSmall',
    'deleteIconMedium',
    'deleteIconColorPrimary',
    'deleteIconColorSecondary',
    'deleteIconOutlinedColorPrimary',
    'deleteIconOutlinedColorSecondary',
    'deleteIconFilledColorPrimary',
    'deleteIconFilledColorSecondary',
    'focusVisible'
]);
var $34bb079dc5960b54$export$2e2bcd8739ae039 = $34bb079dc5960b54$var$chipClasses;




'use client';
const $08a2e84130921e51$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, size: size, color: color, iconColor: iconColor, onDelete: onDelete, clickable: clickable, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            disabled && 'disabled',
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            clickable && 'clickable',
            clickable && `clickableColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            onDelete && 'deletable',
            onDelete && `deletableColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `${variant}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
        ],
        label: [
            'label',
            `label${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        avatar: [
            'avatar',
            `avatar${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            `avatarColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
        ],
        icon: [
            'icon',
            `icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            `iconColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(iconColor)}`
        ],
        deleteIcon: [
            'deleteIcon',
            `deleteIcon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            `deleteIconColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `deleteIcon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}Color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $34bb079dc5960b54$export$31444911e4ee6fdd), classes);
};
const $08a2e84130921e51$var$ChipRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiChip',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { color: color, iconColor: iconColor, clickable: clickable, onDelete: onDelete, size: size, variant: variant } = ownerState;
        return [
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatar}`]: styles.avatar
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatar}`]: styles[`avatar${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatar}`]: styles[`avatarColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).icon}`]: styles.icon
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).icon}`]: styles[`icon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).icon}`]: styles[`iconColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(iconColor)}`]
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: styles.deleteIcon
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIconColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`]
            },
            {
                [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: styles[`deleteIcon${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(variant)}Color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`]
            },
            styles.root,
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`],
            styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`],
            clickable && styles.clickable,
            clickable && color !== 'default' && styles[`clickableColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)})`],
            onDelete && styles.deletable,
            onDelete && color !== 'default' && styles[`deletableColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`],
            styles[variant],
            styles[`${variant}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const textColor = theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300];
    return {
        maxWidth: '100%',
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(13),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: 32,
        lineHeight: 1.5,
        color: (theme.vars || theme).palette.text.primary,
        backgroundColor: (theme.vars || theme).palette.action.selected,
        borderRadius: 16,
        whiteSpace: 'nowrap',
        transition: theme.transitions.create([
            'background-color',
            'box-shadow'
        ]),
        // reset cursor explicitly in case ButtonBase is used
        cursor: 'unset',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        textDecoration: 'none',
        border: 0,
        // Remove `button` border
        padding: 0,
        // Remove `button` padding
        verticalAlign: 'middle',
        boxSizing: 'border-box',
        [`&.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity,
            pointerEvents: 'none'
        },
        [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatar}`]: {
            marginLeft: 5,
            marginRight: -6,
            width: 24,
            height: 24,
            color: theme.vars ? theme.vars.palette.Chip.defaultAvatarColor : textColor,
            fontSize: theme.typography.pxToRem(12)
        },
        [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatarColorPrimary}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.dark
        },
        [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatarColorSecondary}`]: {
            color: (theme.vars || theme).palette.secondary.contrastText,
            backgroundColor: (theme.vars || theme).palette.secondary.dark
        },
        [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatarSmall}`]: {
            marginLeft: 4,
            marginRight: -4,
            width: 18,
            height: 18,
            fontSize: theme.typography.pxToRem(10)
        },
        [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).icon}`]: {
            marginLeft: 5,
            marginRight: -6
        },
        [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: {
            WebkitTapHighlightColor: 'transparent',
            color: theme.alpha((theme.vars || theme).palette.text.primary, 0.26),
            fontSize: 22,
            cursor: 'pointer',
            margin: '0 5px 0 -6px',
            '&:hover': {
                color: theme.alpha((theme.vars || theme).palette.text.primary, 0.4)
            }
        },
        variants: [
            {
                props: {
                    size: 'small'
                },
                style: {
                    height: 24,
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).icon}`]: {
                        fontSize: 18,
                        marginLeft: 4,
                        marginRight: -4
                    },
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: {
                        fontSize: 16,
                        marginRight: 4,
                        marginLeft: -4
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText,
                        [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].contrastText, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].contrastText
                            }
                        }
                    }
                };
            }),
            {
                props: (props)=>props.iconColor === props.color,
                style: {
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).icon}`]: {
                        color: theme.vars ? theme.vars.palette.Chip.defaultIconColor : textColor
                    }
                }
            },
            {
                props: (props)=>props.iconColor === props.color && props.color !== 'default',
                style: {
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).icon}`]: {
                        color: 'inherit'
                    }
                }
            },
            {
                props: {
                    onDelete: true
                },
                style: {
                    [`&.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>{
                return {
                    props: {
                        color: color,
                        onDelete: true
                    },
                    style: {
                        [`&.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).focusVisible}`]: {
                            background: (theme.vars || theme).palette[color].dark
                        }
                    }
                };
            }),
            {
                props: {
                    clickable: true
                },
                style: {
                    userSelect: 'none',
                    WebkitTapHighlightColor: 'transparent',
                    cursor: 'pointer',
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
                    },
                    [`&.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.selected, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                    },
                    '&:active': {
                        boxShadow: (theme.vars || theme).shadows[1]
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'dark'
            ])).map(([color])=>({
                    props: {
                        color: color,
                        clickable: true
                    },
                    style: {
                        [`&:hover, &.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].dark
                        }
                    }
                })),
            {
                props: {
                    variant: 'outlined'
                },
                style: {
                    backgroundColor: 'transparent',
                    border: theme.vars ? `1px solid ${theme.vars.palette.Chip.defaultBorder}` : `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
                    [`&.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).clickable}:hover`]: {
                        backgroundColor: (theme.vars || theme).palette.action.hover
                    },
                    [`&.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).focusVisible}`]: {
                        backgroundColor: (theme.vars || theme).palette.action.focus
                    },
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatar}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).avatarSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: 4
                    },
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).iconSmall}`]: {
                        marginLeft: 2
                    },
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: {
                        marginRight: 5
                    },
                    [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIconSmall}`]: {
                        marginRight: 3
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()) // no need to check for mainChannel as it's calculated from main
            .map(([color])=>({
                    props: {
                        variant: 'outlined',
                        color: color
                    },
                    style: {
                        color: (theme.vars || theme).palette[color].main,
                        border: `1px solid ${theme.alpha((theme.vars || theme).palette[color].main, 0.7)}`,
                        [`&.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).clickable}:hover`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        },
                        [`&.${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).focusVisible}`]: {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.focusOpacity)
                        },
                        [`& .${(0, $34bb079dc5960b54$export$2e2bcd8739ae039).deleteIcon}`]: {
                            color: theme.alpha((theme.vars || theme).palette[color].main, 0.7),
                            '&:hover, &:active': {
                                color: (theme.vars || theme).palette[color].main
                            }
                        }
                    }
                }))
        ]
    };
}));
const $08a2e84130921e51$var$ChipLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiChip',
    slot: 'Label',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { size: size } = ownerState;
        return [
            styles.label,
            styles[`label${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`]
        ];
    }
})({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    paddingLeft: 12,
    paddingRight: 12,
    whiteSpace: 'nowrap',
    variants: [
        {
            props: {
                variant: 'outlined'
            },
            style: {
                paddingLeft: 11,
                paddingRight: 11
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                paddingLeft: 8,
                paddingRight: 8
            }
        },
        {
            props: {
                size: 'small',
                variant: 'outlined'
            },
            style: {
                paddingLeft: 7,
                paddingRight: 7
            }
        }
    ]
});
function $08a2e84130921e51$var$isDeleteKeyboardEvent(keyboardEvent) {
    return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */ const $08a2e84130921e51$var$Chip = /*#__PURE__*/ $acw62.forwardRef(function Chip(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiChip'
    });
    const { avatar: avatarProp, className: className, clickable: clickableProp, color: color = 'default', component: ComponentProp, deleteIcon: deleteIconProp, disabled: disabled = false, icon: iconProp, label: label, onClick: onClick, onDelete: onDelete, onKeyDown: onKeyDown, onKeyUp: onKeyUp, size: size = 'medium', variant: variant = 'filled', tabIndex: tabIndex, skipFocusWhenDisabled: skipFocusWhenDisabled = false, slots: // TODO v6: Rename to `focusableWhenDisabled`.
    slots = {}, slotProps: slotProps = {}, ...other } = props;
    const chipRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(chipRef, ref);
    const handleDeleteIconClick = (event)=>{
        // Stop the event from bubbling up to the `Chip`
        event.stopPropagation();
        if (onDelete) onDelete(event);
    };
    const handleKeyDown = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target && $08a2e84130921e51$var$isDeleteKeyboardEvent(event)) // Will be handled in keyUp, otherwise some browsers
        // might init navigation
        event.preventDefault();
        if (onKeyDown) onKeyDown(event);
    };
    const handleKeyUp = (event)=>{
        // Ignore events from children of `Chip`.
        if (event.currentTarget === event.target) {
            if (onDelete && $08a2e84130921e51$var$isDeleteKeyboardEvent(event)) onDelete(event);
        }
        if (onKeyUp) onKeyUp(event);
    };
    const clickable = clickableProp !== false && onClick ? true : clickableProp;
    const component = clickable || onDelete ? (0, $21d0be68de155ec6$export$2e2bcd8739ae039) : ComponentProp || 'div';
    const ownerState = {
        ...props,
        component: component,
        disabled: disabled,
        size: size,
        color: color,
        iconColor: /*#__PURE__*/ $acw62.isValidElement(iconProp) ? iconProp.props.color || color : color,
        onDelete: !!onDelete,
        clickable: clickable,
        variant: variant
    };
    const classes = $08a2e84130921e51$var$useUtilityClasses(ownerState);
    const moreProps = component === (0, $21d0be68de155ec6$export$2e2bcd8739ae039) ? {
        component: ComponentProp || 'div',
        focusVisibleClassName: classes.focusVisible,
        ...onDelete && {
            disableRipple: true
        }
    } : {};
    let deleteIcon = null;
    if (onDelete) deleteIcon = deleteIconProp && /*#__PURE__*/ $acw62.isValidElement(deleteIconProp) ? /*#__PURE__*/ $acw62.cloneElement(deleteIconProp, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(deleteIconProp.props.className, classes.deleteIcon),
        onClick: handleDeleteIconClick
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c95756399850c64$export$2e2bcd8739ae039), {
        className: classes.deleteIcon,
        onClick: handleDeleteIconClick
    });
    let avatar = null;
    if (avatarProp && /*#__PURE__*/ $acw62.isValidElement(avatarProp)) avatar = /*#__PURE__*/ $acw62.cloneElement(avatarProp, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.avatar, avatarProp.props.className)
    });
    let icon = null;
    if (iconProp && /*#__PURE__*/ $acw62.isValidElement(iconProp)) icon = /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    });
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $08a2e84130921e51$var$ChipRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        // The `component` prop is preserved because `Chip` relies on it for internal logic. If `shouldForwardComponentProp` were `false`, `useSlot` would remove the `component` prop, potentially breaking the component's behavior.
        shouldForwardComponentProp: true,
        ref: handleRef,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        additionalProps: {
            disabled: clickable && disabled ? true : undefined,
            tabIndex: skipFocusWhenDisabled && disabled ? -1 : tabIndex,
            ...moreProps
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    onClick?.(event);
                },
                onKeyDown: (event)=>{
                    handlers.onKeyDown?.(event);
                    handleKeyDown(event);
                },
                onKeyUp: (event)=>{
                    handlers.onKeyUp?.(event);
                    handleKeyUp(event);
                }
            })
    });
    const [LabelSlot, labelProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('label', {
        elementType: $08a2e84130921e51$var$ChipLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.label
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        as: component,
        ...rootProps,
        children: [
            avatar || icon,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(LabelSlot, {
                ...labelProps,
                children: label
            }),
            deleteIcon
        ]
    });
});
var $08a2e84130921e51$export$2e2bcd8739ae039 = $08a2e84130921e51$var$Chip;













function $771e13a664558c82$export$8ee01529667e66d9(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiAutocomplete', slot);
}
const $771e13a664558c82$var$autocompleteClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiAutocomplete', [
    'root',
    'expanded',
    'fullWidth',
    'focused',
    'focusVisible',
    'tag',
    'tagSizeSmall',
    'tagSizeMedium',
    'hasPopupIcon',
    'hasClearIcon',
    'inputRoot',
    'input',
    'inputFocused',
    'endAdornment',
    'clearIndicator',
    'popupIndicator',
    'popupIndicatorOpen',
    'popper',
    'popperDisablePortal',
    'paper',
    'listbox',
    'loading',
    'noOptions',
    'option',
    'groupLabel',
    'groupUl'
]);
var $771e13a664558c82$export$2e2bcd8739ae039 = $771e13a664558c82$var$autocompleteClasses;





'use client';
var $db86fcacc6287e65$var$_ClearIcon, $db86fcacc6287e65$var$_ArrowDropDownIcon;
const $db86fcacc6287e65$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePortal: disablePortal, expanded: expanded, focused: focused, fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, popupOpen: popupOpen, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            focused && 'focused',
            fullWidth && 'fullWidth',
            hasClearIcon && 'hasClearIcon',
            hasPopupIcon && 'hasPopupIcon'
        ],
        inputRoot: [
            'inputRoot'
        ],
        input: [
            'input',
            inputFocused && 'inputFocused'
        ],
        tag: [
            'tag',
            `tagSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        endAdornment: [
            'endAdornment'
        ],
        clearIndicator: [
            'clearIndicator'
        ],
        popupIndicator: [
            'popupIndicator',
            popupOpen && 'popupIndicatorOpen'
        ],
        popper: [
            'popper',
            disablePortal && 'popperDisablePortal'
        ],
        paper: [
            'paper'
        ],
        listbox: [
            'listbox'
        ],
        loading: [
            'loading'
        ],
        noOptions: [
            'noOptions'
        ],
        option: [
            'option'
        ],
        groupLabel: [
            'groupLabel'
        ],
        groupUl: [
            'groupUl'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $771e13a664558c82$export$8ee01529667e66d9), classes);
};
const $db86fcacc6287e65$var$AutocompleteRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        const { fullWidth: fullWidth, hasClearIcon: hasClearIcon, hasPopupIcon: hasPopupIcon, inputFocused: inputFocused, size: size } = ownerState;
        return [
            {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).tag}`]: styles.tag
            },
            {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).tag}`]: styles[`tagSize${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`]
            },
            {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).inputRoot}`]: styles.inputRoot
            },
            {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: styles.input
            },
            {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: inputFocused && styles.inputFocused
            },
            styles.root,
            fullWidth && styles.fullWidth,
            hasPopupIcon && styles.hasPopupIcon,
            hasClearIcon && styles.hasClearIcon
        ];
    }
})({
    [`&.${(0, $771e13a664558c82$export$2e2bcd8739ae039).focused} .${(0, $771e13a664558c82$export$2e2bcd8739ae039).clearIndicator}`]: {
        visibility: 'visible'
    },
    /* Avoid double tap issue on iOS */ '@media (pointer: fine)': {
        [`&:hover .${(0, $771e13a664558c82$export$2e2bcd8739ae039).clearIndicator}`]: {
            visibility: 'visible'
        }
    },
    [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).tag}`]: {
        margin: 3,
        maxWidth: 'calc(100% - 6px)'
    },
    [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).inputRoot}`]: {
        [`.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 30
        },
        [`.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 56
        },
        [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: {
            width: 0,
            minWidth: 30
        }
    },
    [`& .${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).root}`]: {
        paddingBottom: 1,
        '& .MuiInput-input': {
            padding: '4px 4px 4px 0px'
        }
    },
    [`& .${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).root}.${(0, $587a42eced554844$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $4e32f80fb9096d1f$export$2e2bcd8739ae039).input}`]: {
            padding: '2px 4px 3px 0'
        }
    },
    [`& .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).root}`]: {
        padding: 9,
        [`.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: {
            padding: '7.5px 4px 7.5px 5px'
        },
        [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $64077992b1d8b572$export$2e2bcd8739ae039).root}.${(0, $587a42eced554844$export$2e2bcd8739ae039).sizeSmall}`]: {
        // Don't specify paddingRight, as it overrides the default value set when there is only
        // one of the popup or clear icon as the specificity is equal so the latter one wins
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 6,
        [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px 2.5px 8px'
        }
    },
    [`& .${(0, $5ba40350513245a8$export$2e2bcd8739ae039).root}`]: {
        paddingTop: 19,
        paddingLeft: 8,
        [`.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasPopupIcon}&, .${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 39
        },
        [`.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasPopupIcon}.${(0, $771e13a664558c82$export$2e2bcd8739ae039).hasClearIcon}&`]: {
            paddingRight: 65
        },
        [`& .${(0, $5ba40350513245a8$export$2e2bcd8739ae039).input}`]: {
            padding: '7px 4px'
        },
        [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).endAdornment}`]: {
            right: 9
        }
    },
    [`& .${(0, $5ba40350513245a8$export$2e2bcd8739ae039).root}.${(0, $587a42eced554844$export$2e2bcd8739ae039).sizeSmall}`]: {
        paddingBottom: 1,
        [`& .${(0, $5ba40350513245a8$export$2e2bcd8739ae039).input}`]: {
            padding: '2.5px 4px'
        }
    },
    [`& .${(0, $587a42eced554844$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 8
    },
    [`& .${(0, $5ba40350513245a8$export$2e2bcd8739ae039).root}.${(0, $587a42eced554844$export$2e2bcd8739ae039).hiddenLabel}`]: {
        paddingTop: 0,
        paddingBottom: 0,
        [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 16,
            paddingBottom: 17
        }
    },
    [`& .${(0, $5ba40350513245a8$export$2e2bcd8739ae039).root}.${(0, $587a42eced554844$export$2e2bcd8739ae039).hiddenLabel}.${(0, $587a42eced554844$export$2e2bcd8739ae039).sizeSmall}`]: {
        [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: {
            paddingTop: 8,
            paddingBottom: 9
        }
    },
    [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: {
        flexGrow: 1,
        textOverflow: 'ellipsis',
        opacity: 0
    },
    variants: [
        {
            props: {
                fullWidth: true
            },
            style: {
                width: '100%'
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).tag}`]: {
                    margin: 2,
                    maxWidth: 'calc(100% - 4px)'
                }
            }
        },
        {
            props: {
                inputFocused: true
            },
            style: {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).input}`]: {
                    opacity: 1
                }
            }
        },
        {
            props: {
                multiple: true
            },
            style: {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).inputRoot}`]: {
                    flexWrap: 'wrap'
                }
            }
        }
    ]
});
const $db86fcacc6287e65$var$AutocompleteEndAdornment = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'EndAdornment'
})({
    // We use a position absolute to support wrapping tags.
    position: 'absolute',
    right: 0,
    top: '50%',
    transform: 'translate(0, -50%)'
});
const $db86fcacc6287e65$var$AutocompleteClearIndicator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'ClearIndicator'
})({
    marginRight: -2,
    padding: 4,
    visibility: 'hidden'
});
const $db86fcacc6287e65$var$AutocompletePopupIndicator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'PopupIndicator',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popupIndicator,
            ownerState.popupOpen && styles.popupIndicatorOpen
        ];
    }
})({
    padding: 2,
    marginRight: -2,
    variants: [
        {
            props: {
                popupOpen: true
            },
            style: {
                transform: 'rotate(180deg)'
            }
        }
    ]
});
const $db86fcacc6287e65$var$AutocompletePopper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $d825775ecf14115c$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).option}`]: styles.option
            },
            styles.popper,
            ownerState.disablePortal && styles.popperDisablePortal
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.modal,
        variants: [
            {
                props: {
                    disablePortal: true
                },
                style: {
                    position: 'absolute'
                }
            }
        ]
    })));
const $db86fcacc6287e65$var$AutocompletePaper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'Paper'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body1,
        overflow: 'auto'
    })));
const $db86fcacc6287e65$var$AutocompleteLoading = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'Loading'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $db86fcacc6287e65$var$AutocompleteNoOptions = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAutocomplete',
    slot: 'NoOptions'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        padding: '14px 16px'
    })));
const $db86fcacc6287e65$var$AutocompleteListbox = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('ul', {
    name: 'MuiAutocomplete',
    slot: 'Listbox'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        listStyle: 'none',
        margin: 0,
        padding: '8px 0',
        maxHeight: '40vh',
        overflow: 'auto',
        position: 'relative',
        [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).option}`]: {
            minHeight: 48,
            display: 'flex',
            overflow: 'hidden',
            justifyContent: 'flex-start',
            alignItems: 'center',
            cursor: 'pointer',
            paddingTop: 6,
            boxSizing: 'border-box',
            outline: '0',
            WebkitTapHighlightColor: 'transparent',
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [theme.breakpoints.up('sm')]: {
                minHeight: 'auto'
            },
            [`&.${(0, $771e13a664558c82$export$2e2bcd8739ae039).focused}`]: {
                backgroundColor: (theme.vars || theme).palette.action.hover,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            '&[aria-disabled="true"]': {
                opacity: (theme.vars || theme).palette.action.disabledOpacity,
                pointerEvents: 'none'
            },
            [`&.${(0, $771e13a664558c82$export$2e2bcd8739ae039).focusVisible}`]: {
                backgroundColor: (theme.vars || theme).palette.action.focus
            },
            '&[aria-selected="true"]': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
                [`&.${(0, $771e13a664558c82$export$2e2bcd8739ae039).focused}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                    // Reset on touch devices, it doesn't add specificity
                    '@media (hover: none)': {
                        backgroundColor: (theme.vars || theme).palette.action.selected
                    }
                },
                [`&.${(0, $771e13a664558c82$export$2e2bcd8739ae039).focusVisible}`]: {
                    backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.focusOpacity}`)
                }
            }
        }
    })));
const $db86fcacc6287e65$var$AutocompleteGroupLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $43d645228959d4db$export$2e2bcd8739ae039), {
    name: 'MuiAutocomplete',
    slot: 'GroupLabel'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: (theme.vars || theme).palette.background.paper,
        top: -8
    })));
const $db86fcacc6287e65$var$AutocompleteGroupUl = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('ul', {
    name: 'MuiAutocomplete',
    slot: 'GroupUl'
})({
    padding: 0,
    [`& .${(0, $771e13a664558c82$export$2e2bcd8739ae039).option}`]: {
        paddingLeft: 24
    }
});
const $db86fcacc6287e65$var$Autocomplete = /*#__PURE__*/ $acw62.forwardRef(function Autocomplete(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAutocomplete'
    });
    /* eslint-disable @typescript-eslint/no-unused-vars */ const { autoComplete: autoComplete = false, autoHighlight: autoHighlight = false, autoSelect: autoSelect = false, blurOnSelect: blurOnSelect = false, ChipProps: ChipPropsProp, className: className, clearIcon: clearIcon = $db86fcacc6287e65$var$_ClearIcon || ($db86fcacc6287e65$var$_ClearIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7880a6389ac08655$export$2e2bcd8739ae039), {
        fontSize: "small"
    })), clearOnBlur: clearOnBlur = !props.freeSolo, clearOnEscape: clearOnEscape = false, clearText: clearText = 'Clear', closeText: closeText = 'Close', componentsProps: componentsProps, defaultValue: defaultValue = props.multiple ? [] : null, disableClearable: disableClearable = false, disableCloseOnSelect: disableCloseOnSelect = false, disabled: disabled = false, disabledItemsFocusable: disabledItemsFocusable = false, disableListWrap: disableListWrap = false, disablePortal: disablePortal = false, filterOptions: filterOptions, filterSelectedOptions: filterSelectedOptions = false, forcePopupIcon: forcePopupIcon = 'auto', freeSolo: freeSolo = false, fullWidth: fullWidth = false, getLimitTagsText: getLimitTagsText = (more)=>`+${more}`, getOptionDisabled: getOptionDisabled, getOptionKey: getOptionKey, getOptionLabel: getOptionLabelProp, isOptionEqualToValue: isOptionEqualToValue, groupBy: groupBy, handleHomeEndKeys: handleHomeEndKeys = !props.freeSolo, id: idProp, includeInputInList: includeInputInList = false, inputValue: inputValueProp, limitTags: limitTags = -1, ListboxComponent: ListboxComponentProp, ListboxProps: ListboxPropsProp, loading: loading = false, loadingText: loadingText = "Loading\u2026", multiple: multiple = false, noOptionsText: noOptionsText = 'No options', onChange: onChange, onClose: onClose, onHighlightChange: onHighlightChange, onInputChange: onInputChange, onOpen: onOpen, open: open, openOnFocus: openOnFocus = false, openText: openText = 'Open', options: options, PaperComponent: PaperComponentProp, PopperComponent: PopperComponentProp, popupIcon: popupIcon = $db86fcacc6287e65$var$_ArrowDropDownIcon || ($db86fcacc6287e65$var$_ArrowDropDownIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ade182381ccbdcec$export$2e2bcd8739ae039), {})), readOnly: readOnly = false, renderGroup: renderGroupProp, renderInput: renderInput, renderOption: renderOptionProp, renderTags: renderTags, renderValue: renderValue, selectOnFocus: selectOnFocus = !props.freeSolo, size: size = 'medium', slots: slots = {}, slotProps: slotProps = {}, value: valueProp, ...other } = props;
    /* eslint-enable @typescript-eslint/no-unused-vars */ const { getRootProps: getRootProps, getInputProps: getInputProps, getInputLabelProps: getInputLabelProps, getPopupIndicatorProps: getPopupIndicatorProps, getClearProps: getClearProps, getItemProps: getItemProps, getListboxProps: getListboxProps, getOptionProps: getOptionProps, value: value, dirty: dirty, expanded: expanded, id: id, popupOpen: popupOpen, focused: focused, focusedItem: focusedItem, anchorEl: anchorEl, setAnchorEl: setAnchorEl, inputValue: inputValue, groupedOptions: groupedOptions } = (0, $59fbdc39f1f5d354$export$2e2bcd8739ae039)({
        ...props,
        componentName: 'Autocomplete'
    });
    const hasClearIcon = !disableClearable && !disabled && dirty && !readOnly;
    const hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
    const { onMouseDown: handleInputMouseDown } = getInputProps();
    const { ref: listboxRef, ...otherListboxProps } = getListboxProps();
    const defaultGetOptionLabel = (option)=>option.label ?? option;
    const getOptionLabel = getOptionLabelProp || defaultGetOptionLabel;
    // If you modify this, make sure to keep the `AutocompleteOwnerState` type in sync.
    const ownerState = {
        ...props,
        disablePortal: disablePortal,
        expanded: expanded,
        focused: focused,
        fullWidth: fullWidth,
        getOptionLabel: getOptionLabel,
        hasClearIcon: hasClearIcon,
        hasPopupIcon: hasPopupIcon,
        inputFocused: focusedItem === -1,
        popupOpen: popupOpen,
        size: size
    };
    const classes = $db86fcacc6287e65$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: {
            paper: PaperComponentProp,
            popper: PopperComponentProp,
            ...slots
        },
        slotProps: {
            chip: ChipPropsProp,
            listbox: ListboxPropsProp,
            ...componentsProps,
            ...slotProps
        }
    };
    const [ListboxSlot, listboxProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('listbox', {
        elementType: $db86fcacc6287e65$var$AutocompleteListbox,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.listbox,
        additionalProps: otherListboxProps,
        ref: listboxRef
    });
    const [PaperSlot, paperProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('paper', {
        elementType: (0, $bca3355350079f94$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.paper
    });
    const [PopperSlot, popperProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('popper', {
        elementType: (0, $d825775ecf14115c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.popper,
        additionalProps: {
            disablePortal: disablePortal,
            style: {
                width: anchorEl ? anchorEl.clientWidth : null
            },
            role: 'presentation',
            anchorEl: anchorEl,
            open: popupOpen
        }
    });
    let startAdornment;
    const getCustomizedItemProps = (params)=>({
            className: classes.tag,
            disabled: disabled,
            ...getItemProps(params)
        });
    if (multiple) {
        if (value.length > 0) {
            if (renderTags) startAdornment = renderTags(value, getCustomizedItemProps, ownerState);
            else if (renderValue) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
            else startAdornment = value.map((option, index)=>{
                const { key: key, ...customItemProps } = getCustomizedItemProps({
                    index: index
                });
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08a2e84130921e51$export$2e2bcd8739ae039), {
                    label: getOptionLabel(option),
                    size: size,
                    ...customItemProps,
                    ...externalForwardedProps.slotProps.chip
                }, key);
            });
        }
    } else if (renderValue && value != null) startAdornment = renderValue(value, getCustomizedItemProps, ownerState);
    if (limitTags > -1 && Array.isArray(startAdornment)) {
        const more = startAdornment.length - limitTags;
        if (!focused && more > 0) {
            startAdornment = startAdornment.splice(0, limitTags);
            startAdornment.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: classes.tag,
                children: getLimitTagsText(more)
            }, startAdornment.length));
        }
    }
    const defaultRenderGroup = (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db86fcacc6287e65$var$AutocompleteGroupLabel, {
                    className: classes.groupLabel,
                    ownerState: ownerState,
                    component: "div",
                    children: params.group
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db86fcacc6287e65$var$AutocompleteGroupUl, {
                    className: classes.groupUl,
                    ownerState: ownerState,
                    children: params.children
                })
            ]
        }, params.key);
    const renderGroup = renderGroupProp || defaultRenderGroup;
    const defaultRenderOption = (props2, option)=>{
        // Need to clearly apply key because of https://github.com/vercel/next.js/issues/55642
        const { key: key, ...otherProps } = props2;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
            ...otherProps,
            children: getOptionLabel(option)
        }, key);
    };
    const renderOption = renderOptionProp || defaultRenderOption;
    const renderListOption = (option, index)=>{
        const optionProps = getOptionProps({
            option: option,
            index: index
        });
        return renderOption({
            ...optionProps,
            className: classes.option
        }, option, {
            selected: optionProps['aria-selected'],
            index: index,
            inputValue: inputValue
        }, ownerState);
    };
    const clearIndicatorSlotProps = externalForwardedProps.slotProps.clearIndicator;
    const popupIndicatorSlotProps = externalForwardedProps.slotProps.popupIndicator;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db86fcacc6287e65$var$AutocompleteRoot, {
                ref: ref,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
                ownerState: ownerState,
                ...getRootProps(other),
                children: renderInput({
                    id: id,
                    disabled: disabled,
                    fullWidth: true,
                    size: size === 'small' ? 'small' : undefined,
                    InputLabelProps: getInputLabelProps(),
                    InputProps: {
                        ref: setAnchorEl,
                        className: classes.inputRoot,
                        startAdornment: startAdornment,
                        onMouseDown: (event)=>{
                            if (event.target === event.currentTarget) handleInputMouseDown(event);
                        },
                        ...(hasClearIcon || hasPopupIcon) && {
                            endAdornment: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($db86fcacc6287e65$var$AutocompleteEndAdornment, {
                                className: classes.endAdornment,
                                ownerState: ownerState,
                                children: [
                                    hasClearIcon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db86fcacc6287e65$var$AutocompleteClearIndicator, {
                                        ...getClearProps(),
                                        "aria-label": clearText,
                                        title: clearText,
                                        ownerState: ownerState,
                                        ...clearIndicatorSlotProps,
                                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.clearIndicator, clearIndicatorSlotProps?.className),
                                        children: clearIcon
                                    }) : null,
                                    hasPopupIcon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db86fcacc6287e65$var$AutocompletePopupIndicator, {
                                        ...getPopupIndicatorProps(),
                                        disabled: disabled,
                                        "aria-label": popupOpen ? closeText : openText,
                                        title: popupOpen ? closeText : openText,
                                        ownerState: ownerState,
                                        ...popupIndicatorSlotProps,
                                        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.popupIndicator, popupIndicatorSlotProps?.className),
                                        children: popupIcon
                                    }) : null
                                ]
                            })
                        }
                    },
                    inputProps: {
                        className: classes.input,
                        disabled: disabled,
                        readOnly: readOnly,
                        ...getInputProps()
                    }
                })
            }),
            anchorEl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db86fcacc6287e65$var$AutocompletePopper, {
                as: PopperSlot,
                ...popperProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($db86fcacc6287e65$var$AutocompletePaper, {
                    as: PaperSlot,
                    ...paperProps,
                    children: [
                        loading && groupedOptions.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db86fcacc6287e65$var$AutocompleteLoading, {
                            className: classes.loading,
                            ownerState: ownerState,
                            children: loadingText
                        }) : null,
                        groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($db86fcacc6287e65$var$AutocompleteNoOptions, {
                            className: classes.noOptions,
                            ownerState: ownerState,
                            role: "presentation",
                            onMouseDown: (event)=>{
                                // Prevent input blur when interacting with the "no options" content
                                event.preventDefault();
                            },
                            children: noOptionsText
                        }) : null,
                        groupedOptions.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ListboxSlot, {
                            as: ListboxComponentProp,
                            ...listboxProps,
                            children: groupedOptions.map((option, index)=>{
                                if (groupBy) return renderGroup({
                                    key: option.key,
                                    group: option.group,
                                    children: option.options.map((option2, index2)=>renderListOption(option2, option.index + index2))
                                });
                                return renderListOption(option, index);
                            })
                        }) : null
                    ]
                })
            }) : null
        ]
    });
});
var $db86fcacc6287e65$export$2e2bcd8739ae039 = $db86fcacc6287e65$var$Autocomplete;







"use client";
var $95f6704f80233608$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14"
}), 'Search');





var $acw62 = parcelRequire("acw62");



var $9YICB = parcelRequire("9YICB");
function $623906b687855dc4$export$2e2bcd8739ae039() {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [query, setQuery] = (0, $acw62.useState)('');
    const [results, setResults] = (0, $acw62.useState)([]);
    const navigate = (0, $84c11e79798ea0cb$export$9770f232ac06a008)();
    const location = (0, $84c11e79798ea0cb$export$45d76561a5302f2b)();
    const loading = open && results.length === 0 && query.length === 0;
    const reset = ()=>{
        setResults([]);
        setQuery('');
    };
    const searchVehicles = async ()=>{
        const criteria = [
            {
                property: 'vin',
                query: query
            }
        ];
        const response = await (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getVehicles({
            page: 0,
            resultsPerPage: 10,
            criteriaList: criteria
        });
        const resultOptions = [
            ...response.vehiclesList
        ].map((listing)=>{
            // if subscribe redirect to fleet path otherwise listings
            const path = listing.vehicle.state === (0, $9YICB.State).ON_SUBSCRIPTION ? 'fleet' : 'listings';
            return {
                ...listing,
                label: $623906b687855dc4$export$62492c35643d4b08(listing),
                navigateTo () {
                    navigate(`/view/${path}/${listing.vehicle.id}`);
                }
            };
        });
        setResults(resultOptions);
    };
    (0, $acw62.useEffect)(()=>{
        reset();
    }, [
        location
    ]);
    (0, $acw62.useEffect)(()=>{
        if (query.length === 0) return;
        searchVehicles();
    }, [
        query
    ]);
    return {
        results: results,
        open: open,
        loading: loading,
        query: query,
        reset: reset,
        setQuery: setQuery,
        setOpen: setOpen
    };
}
function $623906b687855dc4$export$62492c35643d4b08({ vehicle: vehicle }) {
    return `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.vin}`;
}


const $fb1046c54b655727$var$SearchBar = ()=>{
    const { results: results, open: open, setOpen: setOpen, loading: loading, query: query, setQuery: setQuery, reset: reset } = (0, $623906b687855dc4$export$2e2bcd8739ae039)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            alignItems: 'center',
            gap: 0,
            // Remove gap to combine elements
            position: 'relative',
            display: {
                xs: 'none',
                sm: 'flex'
            }
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db86fcacc6287e65$export$2e2bcd8739ae039), {
                id: "fleet-search",
                open: open,
                onOpen: ()=>setOpen(true),
                onClose: ()=>setOpen(false),
                loading: loading,
                options: results,
                blurOnSelect: true,
                clearOnBlur: true,
                inputValue: query,
                getOptionLabel: (option)=>{
                    return option.label;
                },
                isOptionEqualToValue: (option)=>{
                    return option.vehicle.vin;
                },
                onChange: (evt, option)=>{
                    option.navigateTo();
                    reset();
                },
                sx: {
                    minWidth: 280,
                    // Slightly reduced width
                    '& .MuiOutlinedInput-root': {
                        borderTopRightRadius: 0,
                        borderBottomRightRadius: 0,
                        height: '40px',
                        // Reduced height
                        paddingRight: '0px !important'
                    }
                },
                renderInput: (params)=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...params,
                        variant: "outlined",
                        value: query,
                        placeholder: "Search by VIN",
                        onChange: (evt)=>{
                            setQuery(evt.target.value);
                        },
                        slotProps: {
                            ...params.InputProps,
                            startAdornment: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f6704f80233608$export$2e2bcd8739ae039), {
                                    style: {
                                        color: themeColors.buttonColor,
                                        marginLeft: '8px'
                                    }
                                })
                            })
                        },
                        sx: {
                            '& .MuiOutlinedInput-root': {
                                height: '40px',
                                borderTopRightRadius: 0,
                                borderBottomRightRadius: 0,
                                '& fieldset': {
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0
                                },
                                '&:hover fieldset': {
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0
                                },
                                '&.Mui-focused fieldset': {
                                    borderTopRightRadius: 0,
                                    borderBottomRightRadius: 0
                                }
                            }
                        }
                    });
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                variant: "contained",
                sx: {
                    backgroundColor: themeColors.buttonColor,
                    color: 'white',
                    textTransform: 'none',
                    minWidth: '80px',
                    height: '40px',
                    // Match the reduced height
                    borderTopLeftRadius: 0,
                    borderBottomLeftRadius: 0,
                    borderTopRightRadius: '20px',
                    // Half circle edge
                    borderBottomRightRadius: '20px',
                    // Half circle edge
                    marginLeft: '-1px',
                    // Overlap border to create seamless appearance
                    '&:hover': {
                        backgroundColor: themeColors.buttonHover
                    }
                },
                onClick: ()=>{
                    // Handle search click if needed
                    if (query && results.length > 0) {
                        results[0].navigateTo();
                        reset();
                    }
                },
                children: "Search"
            })
        ]
    });
};
var $fb1046c54b655727$export$2e2bcd8739ae039 = $fb1046c54b655727$var$SearchBar;



parcelRequire("acw62");
function $7317c52b8ab6686e$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        style: {
            height: '100%',
            verticalAlign: 'top',
            width: 'auto'
        },
        height: "37",
        viewBox: "0 0 34 37",
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
            clipPath: "url(#a)",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M7.57829 13.1879H0V36.19H7.57829V13.1879Z",
                    fill: "#FF3148"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M22.7349 20.8552H7.57837V28.5226H22.7349V20.8552Z",
                    fill: "#00415C"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M22.7349 5.52051H7.57837V13.1879H22.7349V5.52051Z",
                    fill: "#00C100"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M30.3131 13.1879H22.7349V36.19H30.3131V13.1879Z",
                    fill: "#00DAFF"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M41.4198 22.7874H45.8122L43.6054 16.4174L41.4198 22.7874ZM36.5303 28.5226L42.0685 13.1879H45.1847L50.7229 28.5226H47.7795L46.5669 24.9772H40.662L39.4282 28.5226H36.5303Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M54.991 28.7864C53.6512 28.7864 52.6166 28.3631 51.8869 27.5167C51.1576 26.6702 50.7938 25.4291 50.7957 23.7934V17.6595H53.542V23.5327C53.542 24.465 53.73 25.1807 54.1059 25.6796C54.4817 26.1784 55.0728 26.4269 55.8792 26.4248C56.236 26.4342 56.59 26.3647 56.9174 26.2211C57.2445 26.0776 57.537 25.8634 57.7737 25.5937C58.2709 25.0396 58.5194 24.2657 58.5194 23.272V17.6656H61.287V28.5226H58.8438L58.6255 26.6825C58.2991 27.3204 57.801 27.8519 57.1887 28.2159C56.5218 28.6065 55.7616 28.8039 54.991 28.7864Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M67.6286 28.5226C66.501 28.5226 65.6007 28.2466 64.9217 27.6915C64.2426 27.1363 63.9062 26.158 63.9062 24.7349V20.0087H62.0662V17.6656H63.9062L64.2305 14.7551H66.6889V17.6656H69.5868V20.0087H66.6889V24.7564C66.6889 25.2839 66.798 25.6427 67.0224 25.8421C67.3619 26.0763 67.7708 26.1847 68.1803 26.1488H69.5232V28.5226H67.6286Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M75.3494 26.3543C75.702 26.3562 76.0512 26.2845 76.3752 26.1436C76.699 26.0027 76.9909 25.7956 77.2319 25.5354C77.7654 24.9854 78.0322 24.1675 78.0322 23.0818C78.0322 21.9961 77.7654 21.1783 77.2319 20.6283C76.9909 20.3697 76.6999 20.1637 76.3774 20.0228C76.0545 19.882 75.7068 19.8094 75.3555 19.8094C75.0042 19.8094 74.6565 19.882 74.3337 20.0228C74.0111 20.1637 73.7204 20.3697 73.4791 20.6283C72.9517 21.1773 72.691 21.99 72.691 23.0818C72.691 24.1737 72.9517 24.9741 73.4791 25.5354C73.7177 25.7959 74.0069 26.0032 74.3291 26.1442C74.651 26.2852 74.9987 26.3567 75.3494 26.3543ZM75.3494 28.7864C74.3688 28.8005 73.4024 28.5508 72.5485 28.0626C71.7267 27.5903 71.0468 26.9013 70.5812 26.069C70.0822 25.1636 69.8312 24.1398 69.8537 23.1033C69.8322 22.0658 70.0865 21.0415 70.5903 20.1376C71.0626 19.304 71.7458 18.6127 72.5697 18.1348C73.4255 17.66 74.3858 17.411 75.3616 17.411C76.3377 17.411 77.2977 17.66 78.1534 18.1348C78.9758 18.6106 79.6557 19.3026 80.1207 20.1376C80.6167 21.0442 80.8664 22.0674 80.8452 23.1033C80.8667 24.1393 80.617 25.1625 80.1207 26.069C79.6536 26.9066 78.9691 27.5991 78.1413 28.0718C77.2901 28.5577 76.3267 28.8074 75.3494 28.7956",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M81.8848 28.5226V17.6656H84.328L84.5463 19.5058C84.8721 18.8675 85.3705 18.3358 85.9831 17.9723C86.6597 17.5784 87.4305 17.3811 88.2111 17.4019C89.5388 17.4019 90.5695 17.8251 91.303 18.6716C92.0366 19.5181 92.4013 20.7571 92.3973 22.3887V28.5226H89.6298V22.6556C89.6298 21.7232 89.4418 21.0076 89.0659 20.5087C88.6901 20.0098 88.102 19.7624 87.3017 19.7665C86.9422 19.7561 86.5851 19.825 86.2547 19.9686C85.9243 20.1121 85.629 20.3268 85.389 20.5976C84.8879 21.1538 84.6381 21.9277 84.6402 22.9193V28.5226H81.8848Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M98.8391 26.3543C99.1917 26.3562 99.5409 26.2845 99.8649 26.1436C100.189 26.0027 100.48 25.7957 100.722 25.5354C101.255 24.9854 101.522 24.1676 101.522 23.0819C101.522 21.9962 101.255 21.1783 100.722 20.6283C100.481 20.3697 100.19 20.1637 99.867 20.0228C99.5442 19.882 99.1965 19.8094 98.8452 19.8094C98.4938 19.8094 98.1462 19.882 97.8233 20.0228C97.5008 20.1637 97.2101 20.3697 96.9688 20.6283C96.4413 21.1783 96.1776 21.9962 96.1776 23.0819C96.1776 24.1676 96.4413 24.9854 96.9688 25.5354C97.2071 25.7961 97.4965 26.0035 97.8185 26.1445C98.1407 26.2855 98.4881 26.357 98.8391 26.3543ZM98.8391 28.7864C97.8585 28.8013 96.8918 28.5515 96.0382 28.0626C95.2149 27.587 94.534 26.895 94.0678 26.0599C93.5716 25.1534 93.3218 24.1301 93.3433 23.0941C93.3215 22.0566 93.5761 21.0323 94.0799 20.1284C94.5513 19.2941 95.2349 18.6026 96.0594 18.1257C96.9145 17.6508 97.8742 17.4018 98.8497 17.4018C99.8252 17.4018 100.785 17.6508 101.64 18.1257C102.463 18.6013 103.144 19.2933 103.61 20.1284C104.106 21.035 104.356 22.0582 104.335 23.0941C104.358 24.1332 104.108 25.1599 103.61 26.0691C103.142 26.906 102.458 27.5983 101.631 28.0718C100.78 28.5577 99.8164 28.8074 98.8391 28.7956",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M105.156 28.5226V17.6656H107.612L107.848 19.1316C108.196 18.6043 108.668 18.1723 109.221 17.8742C109.831 17.5506 110.512 17.3882 111.201 17.4019C112.858 17.4019 114.034 18.0521 114.729 19.3524C115.123 18.75 115.662 18.26 116.296 17.9294C116.96 17.5768 117.699 17.3956 118.449 17.4019C119.849 17.4019 120.924 17.8251 121.674 18.6716C122.424 19.5181 122.795 20.7571 122.789 22.3887V28.5226H120.019V22.6555C120.019 21.7232 119.843 21.0076 119.491 20.5087C119.302 20.2569 119.053 20.0568 118.768 19.9267C118.483 19.7966 118.17 19.7405 117.857 19.7634C117.512 19.7498 117.167 19.8179 116.851 19.9621C116.536 20.1064 116.258 20.3229 116.039 20.5946C115.584 21.1507 115.357 21.9246 115.357 22.9162V28.5226H112.586V22.6555C112.586 21.7232 112.406 21.0076 112.046 20.5087C111.851 20.2552 111.596 20.0545 111.305 19.9245C111.015 19.7945 110.696 19.7392 110.379 19.7634C110.038 19.7539 109.7 19.824 109.391 19.9681C109.081 20.1122 108.808 20.3266 108.594 20.5946C108.141 21.1527 107.915 21.9277 107.915 22.9193V28.5226H105.156Z",
                    fill: "white"
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M124.672 33.3378L127.158 27.8019H126.509L122.335 17.6656H125.342L128.349 25.3054L131.486 17.6656H134.43L127.612 33.3378H124.672Z",
                    fill: "white"
                })
            ]
        })
    });
}



parcelRequire("acw62");
function $3e83eb58c2a950cd$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        style: {
            height: '100%',
            verticalAlign: 'top',
            width: 'auto'
        },
        height: "37",
        viewBox: "0 0 140 37",
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("linearGradient", {
                    id: "fordBlueGradient",
                    x1: "0%",
                    y1: "0%",
                    x2: "100%",
                    y2: "0%",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "0%",
                            stopColor: "#003478"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                            offset: "100%",
                            stopColor: "#0066CC"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                        cx: "70",
                        cy: "18.5",
                        rx: "68",
                        ry: "16",
                        fill: "url(#fordBlueGradient)",
                        stroke: "#002a5c",
                        strokeWidth: "1"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        x: "70",
                        y: "15",
                        fontSize: "14",
                        fontWeight: "bold",
                        fontFamily: "Arial, sans-serif",
                        fill: "white",
                        textAnchor: "middle",
                        letterSpacing: "1px",
                        children: "GALPIN"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        x: "70",
                        y: "26",
                        fontSize: "7",
                        fontFamily: "Arial, sans-serif",
                        fill: "#E8F4FD",
                        textAnchor: "middle",
                        letterSpacing: "0.5px",
                        children: "FORD DEALERSHIP"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        points: "8,18.5 16,14 16,23",
                        fill: "white",
                        opacity: "0.8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        points: "132,18.5 124,14 124,23",
                        fill: "white",
                        opacity: "0.8"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ellipse", {
                        cx: "25",
                        cy: "18.5",
                        rx: "8",
                        ry: "6",
                        fill: "white",
                        opacity: "0.9"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        x: "25",
                        y: "20",
                        fontSize: "5",
                        fontWeight: "bold",
                        fontFamily: "Arial, sans-serif",
                        fill: "#003478",
                        textAnchor: "middle",
                        children: "F"
                    })
                ]
            })
        ]
    });
}




var $acw62 = parcelRequire("acw62");


const $6715c531ccfda075$var$Clients = ()=>{
    const { clients: clients, onHandleChange: onHandleChange, clientId: clientId } = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: 'inline-flex',
            flexDirection: 'column',
            marginRight: '16px'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
            value: clientId,
            onChange: onHandleChange,
            children: clients?.map((client)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                    value: client.id,
                    children: client.name
                }, client.id))
        })
    });
};
var $6715c531ccfda075$export$2e2bcd8739ae039 = $6715c531ccfda075$var$Clients;




const $824b4d53fa05b79a$export$41d0d88a6b0e456f = ({ user: user, logout: logout, toggleSidebar: toggleSidebar, isSidebarOpen: isSidebarOpen })=>{
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    // Determine which logo to show based on current theme
    const LogoComponent = currentTheme === 'galpin' ? (0, $3e83eb58c2a950cd$export$2e2bcd8739ae039) : (0, $7317c52b8ab6686e$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $75f50dd5200dc7fd$export$2e2bcd8739ae039), {
            position: "fixed",
            sx: {
                zIndex: (theme)=>theme.zIndex.drawer + 1,
                backgroundColor: (theme)=>theme.palette.background.paper,
                height: '56px' // Reduced height
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e223a49097a073d9$export$2e2bcd8739ae039), {
                sx: {
                    minHeight: '56px !important',
                    height: '56px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                "aria-label": "toggle sidebar",
                                onClick: toggleSidebar,
                                sx: {
                                    marginRight: '10px',
                                    color: themeColors.buttonColor,
                                    '&:hover': {
                                        backgroundColor: 'rgba(0,0,0,0.04)'
                                    }
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ef87b97581793e1$export$2e2bcd8739ae039), {
                                    children: isSidebarOpen ? 'menu_open' : 'menu'
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a), {
                                to: "/",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(LogoComponent, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            flex: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fb1046c54b655727$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        style: {
                            flex: 0.5
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6715c531ccfda075$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        title: "Log Out",
                        variant: "outlined",
                        onClick: ()=>logout(),
                        sx: {
                            minWidth: '40px',
                            width: '40px',
                            height: '40px',
                            borderRadius: '50%',
                            // Make circular
                            borderColor: themeColors.buttonColor,
                            color: themeColors.buttonColor,
                            fontSize: '14px',
                            fontWeight: 'bold',
                            '&:hover': {
                                borderColor: themeColors.buttonHover,
                                backgroundColor: 'rgba(0,0,0,0.04)',
                                color: themeColors.buttonHover
                            }
                        },
                        children: user.initials
                    })
                ]
            })
        })
    });
};




const $78d6ed22988c03d1$var$useStyles = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()((theme, params)=>{
    return {
        root: {
            display: 'flex',
            flex: '1 1 auto',
            maxWidth: '100%',
            paddingTop: 64,
            [params.isSidebarOpen && `${theme.breakpoints.up('lg')}`]: {
                paddingLeft: 280
            }
        }
    };
});
const $78d6ed22988c03d1$export$c84671f46d6a1ca = ({ children: children })=>{
    const { logout: logout, routes: routes, user: user, isSidebarOpen: isSidebarOpen, toggleSidebar: toggleSidebar } = (0, $4813628f7e03fa90$export$8dba1581250258f4)();
    const { classes: classes } = $78d6ed22988c03d1$var$useStyles({
        isSidebarOpen: isSidebarOpen
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $824b4d53fa05b79a$export$41d0d88a6b0e456f), {
                logout: logout,
                user: user,
                toggleSidebar: toggleSidebar,
                isSidebarOpen: isSidebarOpen
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1f12bc9b3a583504$export$1ba59dacbcbf90fe), {
                routeGroups: routes,
                isSidebarOpen: isSidebarOpen,
                toggleSidebar: toggleSidebar
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    flex: '1 1 auto',
                    flexDirection: 'column',
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9a01a3d7e8de91c6$export$fadc71ba47daf7b1), {
                    children: children
                })
            })
        ]
    });
};



parcelRequire("acw62");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");











function $082f01778759dbca$export$baa0faa0c7ad8085(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('PrivateSwitchBase', slot);
}
const $082f01778759dbca$var$switchBaseClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('PrivateSwitchBase', [
    'root',
    'checked',
    'disabled',
    'input',
    'edgeStart',
    'edgeEnd'
]);
var $082f01778759dbca$export$2e2bcd8739ae039 = $082f01778759dbca$var$switchBaseClasses;




'use client';
const $dadefa050dca578a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, checked: checked, disabled: disabled, edge: edge } = ownerState;
    const slots = {
        root: [
            'root',
            checked && 'checked',
            disabled && 'disabled',
            edge && `edge${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(edge)}`
        ],
        input: [
            'input'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $082f01778759dbca$export$baa0faa0c7ad8085), classes);
};
const $dadefa050dca578a$var$SwitchBaseRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiSwitchBase'
})({
    padding: 9,
    borderRadius: '50%',
    variants: [
        {
            props: {
                edge: 'start',
                size: 'small'
            },
            style: {
                marginLeft: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'start' && ownerState.size !== 'small',
            style: {
                marginLeft: -12
            }
        },
        {
            props: {
                edge: 'end',
                size: 'small'
            },
            style: {
                marginRight: -3
            }
        },
        {
            props: ({ edge: edge, ownerState: ownerState })=>edge === 'end' && ownerState.size !== 'small',
            style: {
                marginRight: -12
            }
        }
    ]
});
const $dadefa050dca578a$var$SwitchBaseInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('input', {
    name: 'MuiSwitchBase',
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039)
})({
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
});
/**
 * @ignore - internal component.
 */ const $dadefa050dca578a$var$SwitchBase = /*#__PURE__*/ $acw62.forwardRef(function SwitchBase(props, ref) {
    const { autoFocus: autoFocus, checked: checkedProp, checkedIcon: checkedIcon, defaultChecked: defaultChecked, disabled: disabledProp, disableFocusRipple: disableFocusRipple = false, edge: edge = false, icon: icon, id: id, inputProps: inputProps, inputRef: inputRef, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, readOnly: readOnly, required: required = false, tabIndex: tabIndex, type: type, value: value, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const [checked, setCheckedState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: checkedProp,
        default: Boolean(defaultChecked),
        name: 'SwitchBase',
        state: 'checked'
    });
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const handleFocus = (event)=>{
        if (onFocus) onFocus(event);
        if (muiFormControl && muiFormControl.onFocus) muiFormControl.onFocus(event);
    };
    const handleBlur = (event)=>{
        if (onBlur) onBlur(event);
        if (muiFormControl && muiFormControl.onBlur) muiFormControl.onBlur(event);
    };
    const handleInputChange = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/9023
        if (event.nativeEvent.defaultPrevented) return;
        const newChecked = event.target.checked;
        setCheckedState(newChecked);
        if (onChange) // TODO v6: remove the second argument.
        onChange(event, newChecked);
    };
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    const hasLabelFor = type === 'checkbox' || type === 'radio';
    const ownerState = {
        ...props,
        checked: checked,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        edge: edge
    };
    const classes = $dadefa050dca578a$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            input: inputProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $dadefa050dca578a$var$SwitchBaseRoot,
        className: classes.root,
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: 'span',
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onFocus: (event)=>{
                    handlers.onFocus?.(event);
                    handleFocus(event);
                },
                onBlur: (event)=>{
                    handlers.onBlur?.(event);
                    handleBlur(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            centerRipple: true,
            focusRipple: !disableFocusRipple,
            disabled: disabled,
            role: undefined,
            tabIndex: null
        }
    });
    const [InputSlot, inputSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('input', {
        ref: inputRef,
        elementType: $dadefa050dca578a$var$SwitchBaseInput,
        className: classes.input,
        externalForwardedProps: externalForwardedProps,
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event)=>{
                    handlers.onChange?.(event);
                    handleInputChange(event);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            autoFocus: autoFocus,
            checked: checkedProp,
            defaultChecked: defaultChecked,
            disabled: disabled,
            id: hasLabelFor ? id : undefined,
            name: name,
            readOnly: readOnly,
            required: required,
            tabIndex: tabIndex,
            type: type,
            ...type === 'checkbox' && value === undefined ? {} : {
                value: value
            }
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(InputSlot, {
                ...inputSlotProps
            }),
            checked ? checkedIcon : icon
        ]
    });
});
var $dadefa050dca578a$export$2e2bcd8739ae039 = $dadefa050dca578a$var$SwitchBase;


parcelRequire("acw62");


'use client';
var $915769b4d8e5eccb$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');


parcelRequire("acw62");


'use client';
var $13bd0137e91b5d2a$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');


parcelRequire("acw62");


'use client';
var $41df310c6674b6f6$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');






function $6538b097db044083$export$6c57c6e16b4063b(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiCheckbox', slot);
}
const $6538b097db044083$var$checkboxClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiCheckbox', [
    'root',
    'checked',
    'disabled',
    'indeterminate',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium'
]);
var $6538b097db044083$export$2e2bcd8739ae039 = $6538b097db044083$var$checkboxClasses;









'use client';
const $e3ef6305be93c7af$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, indeterminate: indeterminate, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            indeterminate && 'indeterminate',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $6538b097db044083$export$6c57c6e16b4063b), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $e3ef6305be93c7af$var$CheckboxRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $dadefa050dca578a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiCheckbox',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.indeterminate && styles.indeterminate,
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.color !== 'default' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        variants: [
            {
                props: {
                    color: 'default',
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $6538b097db044083$export$2e2bcd8739ae039).checked}, &.${(0, $6538b097db044083$export$2e2bcd8739ae039).indeterminate}`]: {
                            color: (theme.vars || theme).palette[color].main
                        },
                        [`&.${(0, $6538b097db044083$export$2e2bcd8739ae039).disabled}`]: {
                            color: (theme.vars || theme).palette.action.disabled
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
const $e3ef6305be93c7af$var$defaultCheckedIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13bd0137e91b5d2a$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$defaultIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $915769b4d8e5eccb$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$defaultIndeterminateIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41df310c6674b6f6$export$2e2bcd8739ae039), {});
const $e3ef6305be93c7af$var$Checkbox = /*#__PURE__*/ $acw62.forwardRef(function Checkbox(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCheckbox'
    });
    const { checkedIcon: checkedIcon = $e3ef6305be93c7af$var$defaultCheckedIcon, color: color = 'primary', icon: iconProp = $e3ef6305be93c7af$var$defaultIcon, indeterminate: indeterminate = false, indeterminateIcon: indeterminateIconProp = $e3ef6305be93c7af$var$defaultIndeterminateIcon, inputProps: inputProps, size: size = 'medium', disableRipple: disableRipple = false, className: className, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const icon = indeterminate ? indeterminateIconProp : iconProp;
    const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;
    const ownerState = {
        ...props,
        disableRipple: disableRipple,
        color: color,
        indeterminate: indeterminate,
        size: size
    };
    const classes = $e3ef6305be93c7af$var$useUtilityClasses(ownerState);
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $e3ef6305be93c7af$var$CheckboxRoot,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            type: 'checkbox',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(indeterminateIcon, {
                fontSize: indeterminateIcon.props.fontSize ?? size
            }),
            disableRipple: disableRipple,
            slots: slots,
            slotProps: {
                input: (0, $b748e9827e4898eb$export$2e2bcd8739ae039)(typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps, {
                    'data-indeterminate': indeterminate
                })
            }
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $e3ef6305be93c7af$export$2e2bcd8739ae039 = $e3ef6305be93c7af$var$Checkbox;


var $acw62 = parcelRequire("acw62");












function $4ae0c5c6bd551796$export$717666c39ec07e12(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiFormControlLabel', slot);
}
const $4ae0c5c6bd551796$var$formControlLabelClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiFormControlLabel', [
    'root',
    'labelPlacementStart',
    'labelPlacementTop',
    'labelPlacementBottom',
    'disabled',
    'label',
    'error',
    'required',
    'asterisk'
]);
var $4ae0c5c6bd551796$export$2e2bcd8739ae039 = $4ae0c5c6bd551796$var$formControlLabelClasses;





'use client';
const $e29860be68ec3320$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disabled: disabled, labelPlacement: labelPlacement, error: error, required: required } = ownerState;
    const slots = {
        root: [
            'root',
            disabled && 'disabled',
            `labelPlacement${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(labelPlacement)}`,
            error && 'error',
            required && 'required'
        ],
        label: [
            'label',
            disabled && 'disabled'
        ],
        asterisk: [
            'asterisk',
            error && 'error'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $4ae0c5c6bd551796$export$717666c39ec07e12), classes);
};
const $e29860be68ec3320$export$1b479270917a5676 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('label', {
    name: 'MuiFormControlLabel',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).label}`]: styles.label
            },
            styles.root,
            styles[`labelPlacement${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.labelPlacement)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
        // For correct alignment with the text.
        verticalAlign: 'middle',
        WebkitTapHighlightColor: 'transparent',
        marginLeft: -11,
        marginRight: 16,
        // used for row presentation of radio/checkbox
        [`&.${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).disabled}`]: {
            cursor: 'default'
        },
        [`& .${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).label}`]: {
            [`&.${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).disabled}`]: {
                color: (theme.vars || theme).palette.text.disabled
            }
        },
        variants: [
            {
                props: {
                    labelPlacement: 'start'
                },
                style: {
                    flexDirection: 'row-reverse',
                    marginRight: -11
                }
            },
            {
                props: {
                    labelPlacement: 'top'
                },
                style: {
                    flexDirection: 'column-reverse'
                }
            },
            {
                props: {
                    labelPlacement: 'bottom'
                },
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ labelPlacement: labelPlacement })=>labelPlacement === 'start' || labelPlacement === 'top' || labelPlacement === 'bottom',
                style: {
                    marginLeft: 16 // used for row presentation of radio/checkbox
                }
            }
        ]
    })));
const $e29860be68ec3320$var$AsteriskComponent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiFormControlLabel',
    slot: 'Asterisk'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        [`&.${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).error}`]: {
            color: (theme.vars || theme).palette.error.main
        }
    })));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */ const $e29860be68ec3320$var$FormControlLabel = /*#__PURE__*/ $acw62.forwardRef(function FormControlLabel(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormControlLabel'
    });
    const { checked: checked, className: className, componentsProps: componentsProps = {}, control: control, disabled: disabledProp, disableTypography: disableTypography, inputRef: inputRef, label: labelProp, labelPlacement: labelPlacement = 'end', name: name, onChange: onChange, required: requiredProp, slots: slots = {}, slotProps: slotProps = {}, value: value, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const disabled = disabledProp ?? control.props.disabled ?? muiFormControl?.disabled;
    const required = requiredProp ?? control.props.required;
    const controlProps = {
        disabled: disabled,
        required: required
    };
    [
        'checked',
        'name',
        'onChange',
        'value',
        'inputRef'
    ].forEach((key)=>{
        if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') controlProps[key] = props[key];
    });
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        disabled: disabled,
        labelPlacement: labelPlacement,
        required: required,
        error: fcs.error
    };
    const classes = $e29860be68ec3320$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            ...componentsProps,
            ...slotProps
        }
    };
    const [TypographySlot, typographySlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('typography', {
        elementType: (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    let label = labelProp;
    if (label != null && label.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) label = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TypographySlot, {
        component: "span",
        ...typographySlotProps,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.label, typographySlotProps?.className),
        children: label
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e29860be68ec3320$export$1b479270917a5676, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other,
        children: [
            /*#__PURE__*/ $acw62.cloneElement(control, controlProps),
            required ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    label,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e29860be68ec3320$var$AsteriskComponent, {
                        ownerState: ownerState,
                        "aria-hidden": true,
                        className: classes.asterisk,
                        children: [
                            "\u2009",
                            '*'
                        ]
                    })
                ]
            }) : label
        ]
    });
});
var $e29860be68ec3320$export$2e2bcd8739ae039 = $e29860be68ec3320$var$FormControlLabel;


var $acw62 = parcelRequire("acw62");







function $54112a2ab124f669$export$d72d4cbdc30b331f(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiFormGroup', slot);
}
const $54112a2ab124f669$var$formGroupClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiFormGroup', [
    'root',
    'row',
    'error'
]);
var $54112a2ab124f669$export$2e2bcd8739ae039 = $54112a2ab124f669$var$formGroupClasses;





'use client';
const $a3c16f3270115bea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, row: row, error: error } = ownerState;
    const slots = {
        root: [
            'root',
            row && 'row',
            error && 'error'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $54112a2ab124f669$export$d72d4cbdc30b331f), classes);
};
const $a3c16f3270115bea$var$FormGroupRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiFormGroup',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.row && styles.row
        ];
    }
})({
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap',
    variants: [
        {
            props: {
                row: true
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */ const $a3c16f3270115bea$var$FormGroup = /*#__PURE__*/ $acw62.forwardRef(function FormGroup(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiFormGroup'
    });
    const { className: className, row: row = false, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const fcs = (0, $23f47324c549140d$export$2e2bcd8739ae039)({
        props: props,
        muiFormControl: muiFormControl,
        states: [
            'error'
        ]
    });
    const ownerState = {
        ...props,
        row: row,
        error: fcs.error
    };
    const classes = $a3c16f3270115bea$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a3c16f3270115bea$var$FormGroupRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $a3c16f3270115bea$export$2e2bcd8739ae039 = $a3c16f3270115bea$var$FormGroup;


parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $26u10 = parcelRequire("26u10");

var $3QqPt = parcelRequire("3QqPt");
function $80669f4b1b4c641a$export$351fd42c8499d2a1({ isQualified: isQualified, subscriptionId: subscriptionId }) {
    const [billingStatusError, setBillingStatusError] = (0, $acw62.useState)(null);
    const [subscriptionStatusError, setSubscriptionStatusError] = (0, $acw62.useState)(null);
    const statuses = getSubscriptionStatuses(subscriptionId, isQualified);
    const statusCol2 = getStatusCol2(subscriptionId);
    function getStatusCol2(subscriptionId) {
        const { isLoading: isLoading, data: data } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/billingStatus',
                {
                    subscriptionId: subscriptionId
                }
            ],
            queryFn: ()=>{
                return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getBillingStatus(subscriptionId).catch((err)=>{
                    console.error('getBillingStatus error', err);
                    setBillingStatusError(err);
                    return new (0, $26u10.GetBillingStatusResponse)().toObject();
                }).then((billingStatusResult)=>{
                    return billingStatusResult;
                });
            },
            enabled: !!subscriptionId,
            placeholderData: new (0, $26u10.GetBillingStatusResponse)().toObject()
        });
        if (billingStatusError) return getPlaceholderCheckbox('Error Loading Statuses');
        if (isLoading) return getPlaceholderCheckbox('Loading...');
        return [
            {
                label: 'Reservation Fee Paid',
                active: data.reservationFeePaid
            },
            {
                label: 'Drive Off Paid',
                active: data.driveOffPaid
            },
            {
                label: 'Signed Contract',
                active: data.signedContract
            }
        ];
    }
    function getSubscriptionStatuses(subscriptionId, isQualified) {
        const { isLoading: isLoading, data: data } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/subscription',
                {
                    subscriptionId: subscriptionId
                }
            ],
            queryFn: ()=>{
                return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getSubscriptionById(subscriptionId).catch((err)=>{
                    console.error('getSubscriptionById error', err);
                    setSubscriptionStatusError(err);
                    return new (0, $3QqPt.Subscription)().toObject();
                }).then((subscriptionResult)=>{
                    return subscriptionResult;
                });
            },
            enabled: !!subscriptionId,
            placeholderData: new (0, $3QqPt.Subscription)().toObject()
        });
        if (subscriptionStatusError) return getPlaceholderCheckbox('Error Loading Statuses');
        if (isLoading) return getPlaceholderCheckbox('Loading...');
        return [
            {
                label: 'Qualified',
                active: isQualified
            },
            {
                label: 'Vehicle Assigned',
                active: !!(typeof data.vehicleId !== 'undefined' && data.vehicleId)
            },
            {
                label: 'Activated',
                active: data.status == 'ACTIVE'
            }
        ];
    }
    function getPlaceholderCheckbox(label) {
        return [
            {
                label: label,
                active: false
            }
        ];
    }
    return {
        statuses: statuses,
        statusCol2: statusCol2,
        billingStatusError: billingStatusError,
        subscriptionStatusError: subscriptionStatusError
    };
}


const $2bc764fa5fcc997b$export$a5326926b495d2a4 = ({ isQualified: isQualified, customerId: customerId, subscriptionId: subscriptionId })=>{
    const { statuses: statuses, statusCol2: statusCol2, billingStatusError: billingStatusError, subscriptionStatusError: subscriptionStatusError } = (0, $80669f4b1b4c641a$export$351fd42c8499d2a1)({
        isQualified: isQualified,
        customerId: customerId,
        subscriptionId: subscriptionId
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        direction: "column",
        container: true,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                style: {
                    height: 15
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            size: {
                                xs: 12,
                                sm: 6
                            },
                            children: subscriptionStatusError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Error loading statuses"
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c16f3270115bea$export$2e2bcd8739ae039), {
                                children: (0, $f1q41.map)(statuses, (status)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
                                        className: `resetHoverStyle compactCheckboxList ${status.active ? 'active' : ''}`,
                                        control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3ef6305be93c7af$export$2e2bcd8739ae039), {
                                            checked: status.active,
                                            color: "primary"
                                        }),
                                        label: status.label
                                    }, status.label))
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            size: {
                                xs: 12,
                                sm: 6
                            },
                            children: billingStatusError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Error loading statuses"
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c16f3270115bea$export$2e2bcd8739ae039), {
                                children: (0, $f1q41.map)(statusCol2, (status)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
                                        className: `resetHoverStyle compactCheckboxList ${status.active ? 'active' : ''}`,
                                        control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3ef6305be93c7af$export$2e2bcd8739ae039), {
                                            checked: status.active,
                                            color: "primary"
                                        }),
                                        label: status.label
                                    }, status.label))
                            })
                        })
                    ]
                })
            })
        ]
    });
};




parcelRequire("acw62");
const $5f92f616d48bbd7d$export$59a692ba92dddb52 = ({ customerInfo: customerInfo, reservation: reservation, customer: customer })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            flexWrap: 'wrap',
            columnGap: '3rem',
            rowGap: '1.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Customer Name"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: customerInfo.fullName || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Email"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: customerInfo.email || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Phone Number"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: customerInfo.phone || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Reservation Created Date"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: reservation.formattedCreated || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Account Number"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: customer.accountNumber || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Dealer"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: customerInfo.dealer || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Zip Code"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: customerInfo.zipcode || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Reservation Number"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: customerInfo.reservationNumber || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Garaging Address"
                    }),
                    customerInfo?.garagingAddress?.street ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: customerInfo.garagingAddress.street
                            }),
                            customerInfo.garagingAddress.street2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: customerInfo.garagingAddress.street2
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: [
                                    customerInfo.garagingAddress.city,
                                    ",",
                                    ' ',
                                    customerInfo.garagingAddress.state,
                                    ' ',
                                    customerInfo.garagingAddress.postal
                                ]
                            })
                        ]
                    }) : 'N/A'
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "License Address"
                    }),
                    customerInfo?.licenseAddress?.street ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: customerInfo.licenseAddress.street
                            }),
                            customerInfo.licenseAddress.street2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: customerInfo.licenseAddress.street2
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: [
                                    customerInfo.licenseAddress.city,
                                    ",",
                                    ' ',
                                    customerInfo.licenseAddress.state,
                                    ' ',
                                    customerInfo.licenseAddress.postal
                                ]
                            })
                        ]
                    }) : 'N/A'
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Customer Address"
                    }),
                    customerInfo?.contactAddress?.street ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: customerInfo.contactAddress.street
                            }),
                            customerInfo.contactAddress.street2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: customerInfo.contactAddress.street2
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: [
                                    customerInfo.contactAddress.city,
                                    ",",
                                    ' ',
                                    customerInfo.contactAddress.state,
                                    ' ',
                                    customerInfo.contactAddress.postal
                                ]
                            })
                        ]
                    }) : 'N/A'
                ]
            })
        ]
    });
};



parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");


var $acw62 = parcelRequire("acw62");



var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");


"use client";
function $4f8e348a4679462a$export$625b2ff71316bcd3(filters, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    const queryCache = client.getQueryCache();
    return $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>queryCache.subscribe((0, $e2307e33fb454067$export$520687f44db6e1ab).batchCalls(onStoreChange)), [
        queryCache
    ]), ()=>client.isFetching(filters), ()=>client.isFetching(filters));
}


var $acw62 = parcelRequire("acw62");


"use client";
function $e8df1924a4e3fb84$export$32cc39cf62abf4fc(filters, queryClient) {
    const client = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient);
    return $e8df1924a4e3fb84$export$29ea95f3fea1dc1c({
        filters: {
            ...filters,
            status: "pending"
        }
    }, client).length;
}
function $e8df1924a4e3fb84$var$getResult(mutationCache, options) {
    return mutationCache.findAll(options.filters).map((mutation)=>options.select ? options.select(mutation) : mutation.state);
}
function $e8df1924a4e3fb84$export$29ea95f3fea1dc1c(options = {}, queryClient) {
    const mutationCache = (0, $c780594f51309d36$export$22e77b9572c4fded)(queryClient).getMutationCache();
    const optionsRef = $acw62.useRef(options);
    const result = $acw62.useRef(null);
    if (result.current === null) result.current = $e8df1924a4e3fb84$var$getResult(mutationCache, options);
    $acw62.useEffect(()=>{
        optionsRef.current = options;
    });
    return $acw62.useSyncExternalStore($acw62.useCallback((onStoreChange)=>mutationCache.subscribe(()=>{
            const nextResult = (0, $938ae10f13d49bdc$export$77a71fc411098696)(result.current, $e8df1924a4e3fb84$var$getResult(mutationCache, optionsRef.current));
            if (result.current !== nextResult) {
                result.current = nextResult;
                (0, $e2307e33fb454067$export$520687f44db6e1ab).schedule(onStoreChange);
            }
        }), [
        mutationCache
    ]), ()=>result.current, ()=>result.current);
}




var $3QqPt = parcelRequire("3QqPt");

var $hOsJC = parcelRequire("hOsJC");



var $f1q41 = parcelRequire("f1q41");





var $9HeMJ = parcelRequire("9HeMJ");

var $2Yrcc = parcelRequire("2Yrcc");

var $9YICB = parcelRequire("9YICB");

var $3QqPt = parcelRequire("3QqPt");

var $f1q41 = parcelRequire("f1q41");

var $3QqPt = parcelRequire("3QqPt");

var $26u10 = parcelRequire("26u10");

var $3EyMN = parcelRequire("3EyMN");

var $fcTGK = parcelRequire("fcTGK");

var $f1q41 = parcelRequire("f1q41");
function $2fe0bab7a0e34f9c$export$7b4c15ffe6a6b0c9(key) {
    return (0, $f1q41.startCase)((0, $f1q41.lowerCase)(key));
}
function $2fe0bab7a0e34f9c$export$afe72249c42899d9(enumObject) {
    return (0, $f1q41.mapValues)(enumObject, (value, key)=>{
        return {
            value: value,
            label: $2fe0bab7a0e34f9c$export$7b4c15ffe6a6b0c9(key)
        };
    });
}
function $2fe0bab7a0e34f9c$export$5b979a6faa693550(TypeObject, num) {
    const formattedEnumObject = $2fe0bab7a0e34f9c$export$afe72249c42899d9(TypeObject);
    let label = '';
    Object.keys(formattedEnumObject).map((type)=>{
        if (num === formattedEnumObject[type].value) label = formattedEnumObject[type].label;
    });
    return label;
}


const $33cc3a71f154a56f$export$178d6c82845332d2 = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $3QqPt.Subscription).SubscriptionAction.ActionReason);
const $33cc3a71f154a56f$export$2a19aeb1ef6f18bf = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $3QqPt.StatementStatus));
const $33cc3a71f154a56f$export$5aa41670483ac766 = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $3QqPt.Subscription).Status);
const $33cc3a71f154a56f$export$337f79c9f8c30060 = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $3QqPt.Address).AddressType);
const $33cc3a71f154a56f$export$2cb2327bfc349061 = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $26u10.PromotionSource));
const $33cc3a71f154a56f$export$f2b746ac4bfe2404 = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $3QqPt.Subscription).SubscriptionAction.UserType);
const $33cc3a71f154a56f$export$36c5d24873fc96ec = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $3EyMN.NexusVehicle).Status);
const $33cc3a71f154a56f$export$edb2942a85e0befa = [
    (0, $3QqPt.Subscription).SubscriptionAction.ActionReason.DEALER_VEHICLE_NOT_AVAILABLE,
    (0, $3QqPt.Subscription).SubscriptionAction.ActionReason.DEALER_VEHICLE_SELLING_PRICE_REJECTED,
    (0, $3QqPt.Subscription).SubscriptionAction.ActionReason.DEALER_VEHICLE_SOLD,
    (0, $3QqPt.Subscription).SubscriptionAction.ActionReason.CUSTOMER_VEHICLE_TOO_EXPENSIVE,
    (0, $3QqPt.Subscription).SubscriptionAction.ActionReason.CUSTOMER_VEHICLE_DRIVE_NOT_AS_EXPECTED,
    (0, $3QqPt.Subscription).SubscriptionAction.ActionReason.ANDROID_OS_UNSUPPORTED,
    (0, $3QqPt.Subscription).SubscriptionAction.ActionReason.CUSTOMER_VEHICLE_DOES_NOT_WANT_VEHICLE
];
const $33cc3a71f154a56f$export$e9f97f1cf0c75ecb = {
    actionReasons: $33cc3a71f154a56f$export$178d6c82845332d2,
    cancellationReasons: (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $f1q41.pick)((0, $3QqPt.Subscription).SubscriptionAction.ActionReason, $33cc3a71f154a56f$export$edb2942a85e0befa))
};
const $33cc3a71f154a56f$export$1b8a2894869f2463 = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $fcTGK.AppointmentType));
const $33cc3a71f154a56f$export$138aa6476b0a0a10 = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $fcTGK.AppointmentStatus));




var $dsvHa = parcelRequire("dsvHa");

var $26u10 = parcelRequire("26u10");
const $f647fd23fa4d1073$export$16d7a02b7436f06e = {
    getReservations: $f647fd23fa4d1073$var$getReservations,
    listPrograms: $f647fd23fa4d1073$var$listPrograms,
    cancelReservation: $f647fd23fa4d1073$var$cancelReservation
};
function $f647fd23fa4d1073$var$subscriptionClient() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $df70feab7068291e$exports.SubscriptionServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
function $f647fd23fa4d1073$var$billingClient() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
async function $f647fd23fa4d1073$var$getReservations(params = {
    pageState: '0',
    pageSize: 200,
    programId: null,
    query: '',
    clientId: ''
}) {
    const hasQuery = !!params.query;
    const client = $f647fd23fa4d1073$var$subscriptionClient();
    const request = new (0, $9HeMJ.ListReservationsRequest)();
    request.setClientId(params.clientId);
    request.setPageState(params.pageState);
    request.setPageSize(params.pageSize);
    if (params.programId !== 'all' && !hasQuery) request.setProgramId(params.programId);
    if (params.query) request.setQuery(`${params.query}*`.replace(/\s/g, ''));
    return client.listReservations(request).then((0, $45ee4ee0548ca22e$export$f14470e236d6ab6a)('List Reservations')).then((res)=>{
        return res.toObject();
    });
}
async function $f647fd23fa4d1073$var$listPrograms(clientId) {
    const client = $f647fd23fa4d1073$var$billingClient();
    const listProgramPricingRequest = new (0, $26u10.ListProgramPricingRequest)();
    listProgramPricingRequest.setRemovehiddenprograms(false);
    listProgramPricingRequest.setRemovehiddenprices(false);
    const request = new (0, $dsvHa.NexusListProgramPricingRequest)();
    request.setClientId(clientId);
    request.setListProgramPricingRequest(listProgramPricingRequest);
    return client.listProgramPricing(request).then((programs)=>{
        return programs.toObject();
    }).catch((err)=>console.log('LIST PROGRAM ERROR', err));
}
function $f647fd23fa4d1073$export$303312588eed9b3c({ monthly: monthly, start: start, securityDeposit: securityDeposit }) {
    const monthlyLineItem = new (0, $3QqPt.LineItem)();
    monthlyLineItem.setAmount(monthly * 100);
    monthlyLineItem.setItemType(0);
    const monthlyProduct = new (0, $3QqPt.Product)();
    monthlyProduct.setProductType(1);
    monthlyProduct.setAmount(monthly);
    monthlyLineItem.setProduct(monthlyProduct);
    const startPaymentLineItem = new (0, $3QqPt.LineItem)();
    startPaymentLineItem.setAmount(start * 100);
    startPaymentLineItem.setItemType(1);
    const depositLineItem = new (0, $3QqPt.LineItem)();
    depositLineItem.setAmount(securityDeposit * 100);
    depositLineItem.setItemType(0);
    const depositProduct = new (0, $3QqPt.Product)();
    depositProduct.setProductType(2);
    depositProduct.setAmount(securityDeposit * 100);
    depositLineItem.setProduct(depositProduct);
    return {
        monthlyLineItem: monthlyLineItem,
        startPaymentLineItem: startPaymentLineItem,
        depositLineItem: depositLineItem
    };
}
function $f647fd23fa4d1073$export$80e6bee03b366278({ monthly: monthly, start: start, vehicleId: vehicleId, securityDeposit: securityDeposit }) {
    const request = new (0, $2Yrcc.UpdateVehicleRequest)();
    const vehicle = new (0, $9YICB.Vehicle)();
    vehicle.setId(vehicleId);
    const { monthlyLineItem: monthlyLineItem, startPaymentLineItem: startPaymentLineItem, depositLineItem: depositLineItem } = $f647fd23fa4d1073$export$303312588eed9b3c({
        monthly: monthly,
        start: start,
        securityDeposit: securityDeposit
    });
    vehicle.addDefaultLineItems(monthlyLineItem);
    vehicle.addDefaultLineItems(startPaymentLineItem);
    vehicle.addDefaultLineItems(depositLineItem);
    request.setVehicle(vehicle);
    return request;
}
function $f647fd23fa4d1073$export$362a5a01094406b0(params) {
    const request = new (0, $9HeMJ.CancelReservationRequest)();
    if (!(0, $f1q41.isString)(params.customerId)) throw new Error('Request requires customer ID');
    if (!(0, $f1q41.isString)(params.reservationId)) throw new Error('Request requires reservation ID');
    if (params.userType !== (0, $3QqPt.Subscription).SubscriptionAction.UserType.CUSTOMER && params.userType !== (0, $3QqPt.Subscription).SubscriptionAction.UserType.DEALER) throw new Error('User type must be one of the valid user types');
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f1q41))).includes((0, $33cc3a71f154a56f$export$edb2942a85e0befa), params.actionReason)) throw new Error('Cancellation reason must be one of the valid reasons');
    request.setReservationId(params.reservationId);
    request.setCustomerId(params.customerId);
    request.setActionReason(params.actionReason);
    request.setUserType(params.userType);
    return request;
}
async function $f647fd23fa4d1073$var$cancelReservation(params) {
    const client = $f647fd23fa4d1073$var$subscriptionClient();
    const request = $f647fd23fa4d1073$export$362a5a01094406b0(params);
    return client.cancelReservation(request);
}






var $9HeMJ = parcelRequire("9HeMJ");
function $bba903e2deab5f0e$var$nexusClient() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
async function $bba903e2deab5f0e$var$addVehicleAssignment(params) {
    const client = $bba903e2deab5f0e$var$nexusClient();
    const request = new (0, $9HeMJ.AddVehicleAssignmentRequest)();
    request.setSubscriptionId(params.subscriptionId);
    request.setVehicleId(params.vehicleId);
    return client.addVehicleAssignment(request);
}
async function $bba903e2deab5f0e$var$removeVehicleAssignment(params) {
    const client = $bba903e2deab5f0e$var$nexusClient();
    const request = new (0, $9HeMJ.RemoveVehicleAssignmentRequest)();
    request.setSubscriptionId(params.subscriptionId);
    return client.removeVehicleAssignment(request);
}
const $bba903e2deab5f0e$export$557bff42f3c95df3 = {
    addVehicleAssignment: $bba903e2deab5f0e$var$addVehicleAssignment,
    removeVehicleAssignment: $bba903e2deab5f0e$var$removeVehicleAssignment
};


const $bd0736fcf235ae86$var$adminCQERoles = [
    'Nexus-CQE-Admin-Dev',
    'Nexus-CQE-Admin-Prod',
    'Nexus-CQE-SuperAdmin-Dev',
    'Nexus-CQE-SuperAdmin-Prod'
];
function $bd0736fcf235ae86$export$7d046765d192af80(userGroups) {
    if (!userGroups) return false;
    // Handle different types of userGroups
    if (Array.isArray(userGroups)) // If it's an array, check if any item in the array is in adminCQERoles
    return userGroups.some((group)=>typeof group === 'string' && $bd0736fcf235ae86$var$adminCQERoles.includes(group));
    // If it's not an array, convert to string and check
    const groupStr = String(userGroups);
    return $bd0736fcf235ae86$var$adminCQERoles.includes(groupStr);
}




var $3QqPt = parcelRequire("3QqPt");
function $e391ca76987e73a1$export$6b9d0d7462c6fcc0(reservationStatus, qualificationStatus) {
    let orderStatus;
    /** Using customer qualification status to identify the order status
      if reservation status is paid and customer is qualified
            .order status is Qualified
      if reservation status is paid and customer is DisQualified
            .order status is DisQualified
      if reservation status is paid and customer is qualification Pending
            .order status is Paid
    Aligns with: https://www.notion.so/nxcr/Customer-Approval-f13e968845fa499a8015e80a3ee881ab#e744d093e5744e6b9abff979960cb748
   */ if (reservationStatus === 'PAID') {
        const isApproved = qualificationStatus === (0, $3QqPt.QualificationTier).TIER_1 || qualificationStatus === (0, $3QqPt.QualificationTier).TIER_2 || qualificationStatus === (0, $3QqPt.QualificationTier).TIER_3;
        if (isApproved) orderStatus = 'Qualified';
        else if ((0, $3QqPt.QualificationTier).DISQUALIFIED === qualificationStatus) orderStatus = 'Disqualified';
        else if ((0, $3QqPt.QualificationTier).QUALIFICATION_PENDING === qualificationStatus) orderStatus = reservationStatus;
    } else orderStatus = reservationStatus;
    return orderStatus;
}



var $6EauF = parcelRequire("6EauF");


var $dsvHa = parcelRequire("dsvHa");




const $4bdfc929de3d2884$export$37ec5a33dd45773b = {
    addCustomerNote: $4bdfc929de3d2884$var$addCustomerNote,
    overrideCustomerQualification: $4bdfc929de3d2884$var$overrideCustomerQualification,
    recalculateCustomerQualification: $4bdfc929de3d2884$var$recalculateCustomerQualification,
    getCustomerNotes: $4bdfc929de3d2884$var$getCustomerNotes,
    getCustomerCQEScores: $4bdfc929de3d2884$var$getCustomerCQEScores
};
function $4bdfc929de3d2884$var$customerServiceClient() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $df70feab7068291e$exports.CustomerServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ]
    });
}
function $4bdfc929de3d2884$var$nexusClient() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $8fe6cf9b4cd31a23$exports.NexusServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ]
    });
}
function $4bdfc929de3d2884$var$overrideCustomerQualification(params) {
    const client = $4bdfc929de3d2884$var$nexusClient();
    const request = new (0, $6EauF.OverrideQualificationRequest)();
    request.setCustomerId(params.customerId);
    request.setTier(params.tier);
    request.setDisqualifiedScoreId(params.disqualifiedScoreId);
    return client.overrideCustomerQualification(request).catch((0, $45ee4ee0548ca22e$export$b35e4e49600c6304)('overrideCustomerQualification'));
}
function $4bdfc929de3d2884$var$getCustomerNotes(params) {
    const { customerId: customerId } = params;
    const client = $4bdfc929de3d2884$var$nexusClient();
    const request = new (0, $dsvHa.GetCustomerNotesRequest)();
    request.setCustomerId(customerId);
    return client.getCustomerNotes(request).then((res)=>res.toObject());
}
function $4bdfc929de3d2884$export$465b7fe444ad5a3d(params) {
    const request = new (0, $dsvHa.AddCustomerNoteRequest)();
    request.setCustomerId(params.customerId);
    request.setNoteText(params.noteText);
    return request;
}
function $4bdfc929de3d2884$var$addCustomerNote(params) {
    const client = $4bdfc929de3d2884$var$nexusClient();
    const request = $4bdfc929de3d2884$export$465b7fe444ad5a3d(params);
    return client.addCustomerNote(request).then((0, $45ee4ee0548ca22e$export$f14470e236d6ab6a)('addCustomerNote')).catch((0, $45ee4ee0548ca22e$export$b35e4e49600c6304)('addCustomerNote'));
}
function $4bdfc929de3d2884$export$1991187f01ea0261(params) {
    if (!params.customerId) throw new Error('Request requires customer ID');
    const request = new (0, $6EauF.RecalculateCustomerScoresRequest)();
    request.setCustomerId(params.customerId);
    request.setScoreNamesList(params.scoreNamesList);
    return request;
}
async function $4bdfc929de3d2884$var$recalculateCustomerQualification(params) {
    const client = $4bdfc929de3d2884$var$nexusClient();
    const request = $4bdfc929de3d2884$export$1991187f01ea0261(params);
    return client.recalculateCustomerQualification(request);
}
async function $4bdfc929de3d2884$var$getCustomerCQEScores(params) {
    const client = $4bdfc929de3d2884$var$nexusClient();
    const request = new (0, $6EauF.GetCQEScoresRequest)();
    request.setCustomerId(params.customerId);
    return client.getCustomerCQEScores(request).then((res)=>res.toObject());
}
function $4bdfc929de3d2884$export$3ebb475fb1fa8348(data) {
    const client = $4bdfc929de3d2884$var$customerServiceClient();
    const request = new (0, $6EauF.ResetLoginAttemptsRequest)();
    request.setAccountNumber(data.accountNumber);
    request.setCustomerId(data.customerId);
    request.setPhoneNumber(data.phoneNumber);
    return client.resetLoginAttempts(request);
}




function $ba66fc54ecff33a1$export$dba8ba4729e1fba8() {
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { reservationId: reservationId } = (0, $84c11e79798ea0cb$export$99eaa27ddbbb95ef)();
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const [currentNote, setCurrentNote] = (0, $acw62.useState)('');
    const [changeProgramOpen, setChangeProgramOpen] = (0, $acw62.useState)(false);
    const [overrideDisqualificationVendor, setOverrideDisqualificationVendor] = (0, $acw62.useState)(undefined);
    const userGroups = authState?.idToken?.claims?.groups;
    const isAdmin = (0, $bd0736fcf235ae86$export$7d046765d192af80)(userGroups);
    const { clientId: clientId, setClientId: setClientId } = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const { setSnack: setSnack } = (0, $acw62.useContext)((0, $9a01a3d7e8de91c6$export$216a88342db54c29));
    const toggleChangeProgram = ()=>{
        setChangeProgramOpen((currentState)=>!currentState);
    };
    const { data: reservation, isSuccess: reservationSuccess, error: reservationError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/reservation',
            reservationId
        ],
        queryFn: ()=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getProgramReservation(reservationId).then(handleReservationResponse);
        },
        placeholderData: $ba66fc54ecff33a1$var$getPlaceholderReservation()
    });
    const handleReservationResponse = async (res)=>{
        const subscriptionsList = (await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listCustomerSubscriptions(res.customerId)).subscriptionsList;
        const { customer: customer } = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getCustomerById(res.customerId);
        const activeSubscription = (0, $f1q41.find)(subscriptionsList, {
            status: 'ACTIVE'
        });
        const activeOrFirstSubscription = activeSubscription ? activeSubscription : subscriptionsList[0];
        const vehicleId = activeOrFirstSubscription.vehicleId;
        const assignedVehicle = vehicleId ? await $ba66fc54ecff33a1$var$getAssignedVehicle(vehicleId) : undefined;
        const customerInfo = $ba66fc54ecff33a1$export$b4ddc154cadabaf({
            customer: customer,
            reservation: res
        });
        const isQualified = $ba66fc54ecff33a1$export$94aae6a0d3dbf771(customerInfo.qualificationTier);
        if (clientId !== customer.clientId) setClientId(customer.clientId);
        return {
            ...res,
            customer: customer,
            customerInfo: customerInfo,
            isQualified: isQualified,
            reservationStatus: (0, $e391ca76987e73a1$export$6b9d0d7462c6fcc0)(res?.status, customer?.customerInfo?.qualificationTier),
            reservation: $ba66fc54ecff33a1$export$39a33b24a417f7c3(res),
            vehicle: $ba66fc54ecff33a1$export$23877bb3f6adf77(res, assignedVehicle, telematics),
            isCancelled: $ba66fc54ecff33a1$export$757ac562920db1cc(res),
            qualifications: {
                scores: $ba66fc54ecff33a1$export$2dccbe657ab23dc(customer?.customerInfo?.scoresList),
                hasQualifications: customer?.customerInfo?.scoresList?.length > 0
            },
            assignedVehicle: assignedVehicle,
            subscriptionId: activeOrFirstSubscription.id
        };
    };
    const { data: telematics } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'telematics',
            reservation?.assignedVehicle?.id
        ],
        queryFn: ()=>{
            return (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getTelematics(reservation?.assignedVehicle?.id).catch((err)=>{
                console.error('getTelematics Error', err);
                return {
                    telematics: []
                };
            });
        },
        enabled: !!reservation?.assignedVehicle?.id
    });
    const { data: mostRecentNote } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'notes',
            reservation?.customer?.id
        ],
        queryFn: async ()=>{
            let notesResponse;
            try {
                notesResponse = await (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).getCustomerNotes({
                    customerId: reservation?.customer?.id
                });
            } catch (err) {
                console.error('CQE error', err);
                notesResponse.notesList = [
                    {
                        noteText: 'CQE SERVICE ERROR ON NOTE FETCH',
                        customerId: '',
                        id: '',
                        timestamp: 0,
                        authorEmail: ''
                    }
                ];
            }
            const { notesList: notesList } = notesResponse;
            const lastestNote = notesList[0]?.noteText || '';
            setCurrentNote(lastestNote);
            return lastestNote;
        },
        enabled: reservationSuccess && !!reservation?.customer?.id
    });
    const { data: cqeScores } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'scores',
            reservation?.customer?.id
        ],
        queryFn: async ()=>{
            try {
                return await (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).getCustomerCQEScores({
                    customerId: reservation?.customer?.id
                });
            } catch (err) {
                console.error('getCQEScoresError', err);
                return {
                    scoresList: []
                };
            }
        },
        enabled: !!reservation?.customer?.id
    });
    const { mutateAsync: overrideQualification, isSuccess: overrideQualificationSuccess } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (result)=>{
            if (result.decision === 2) return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).overrideCustomerQualification({
                customerId: reservation.customer.id,
                tier: (0, $3QqPt.QualificationTier).TIER_3_MANUAL,
                disqualifiedScoreId: ''
            });
            if (!overrideDisqualificationVendor) throw new Error('No score set for disqualification');
            return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).overrideCustomerQualification({
                customerId: reservation.customer.id,
                tier: (0, $3QqPt.QualificationTier).DISQUALIFIED_MANUAL,
                disqualifiedScoreId: overrideDisqualificationVendor.id
            });
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    '/reservation',
                    reservationId
                ]
            });
        }
    });
    const { mutate: assignVehicle } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (vehicleId)=>{
            return (0, $bba903e2deab5f0e$export$557bff42f3c95df3).addVehicleAssignment({
                vehicleId: vehicleId,
                subscriptionId: reservation.subscriptionId
            });
        },
        async onSuccess () {
            await queryClient.refetchQueries({
                queryKey: [
                    '/reservation',
                    reservationId
                ]
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    'getVehicles'
                ]
            });
        },
        onError (error) {
            setSnack(new (0, $9a01a3d7e8de91c6$export$80f1826369a4ab15)({
                message: `Error assigning vehicle: \n\n${error?.message}`,
                color: 'error',
                open: true
            }));
        }
    });
    const { mutate: unassignVehicle } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            return (0, $bba903e2deab5f0e$export$557bff42f3c95df3).removeVehicleAssignment({
                subscriptionId: reservation.subscriptionId
            });
        },
        async onSuccess () {
            await queryClient.refetchQueries({
                queryKey: [
                    '/reservation',
                    reservationId
                ]
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    'getVehicles'
                ]
            });
        },
        onError (error) {
            setSnack(new (0, $9a01a3d7e8de91c6$export$80f1826369a4ab15)({
                message: `Error unassigning vehicle: \n\n${error?.message}`,
                color: 'error',
                open: true
            }));
        }
    });
    const { mutate: recalculateCustomerScores, error: cqeError, isSuccess: recalculateCustomerScoresSuccess } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).recalculateCustomerQualification({
                customerId: reservation?.customer?.id,
                scoreNamesList: [
                    0,
                    1,
                    2,
                    3
                ],
                skipQualification: false
            });
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    '/reservation',
                    reservationId
                ]
            });
        }
    });
    const { mutate: addNote } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            const data = {
                customerId: reservation.customer.id,
                noteText: currentNote
            };
            return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).addCustomerNote(data);
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    '/reservation',
                    reservationId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'notes',
                    reservation?.customer?.id
                ]
            });
        }
    });
    const { mutate: cancelReservation, error: cancelError } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ({ actionReason: actionReason, userType: userType })=>{
            try {
                return await (0, $f647fd23fa4d1073$export$16d7a02b7436f06e).cancelReservation({
                    actionReason: actionReason,
                    userType: userType,
                    subscriptionId: reservation.reservation.id,
                    customerId: reservation.customer.id,
                    reservationId: reservation.reservation.id,
                    customerReason: ''
                });
            } catch (err) {
                console.error({
                    message: 'Error cancelling subscription',
                    err: err,
                    params: {
                        actionReason: actionReason,
                        userType: userType
                    }
                });
                // ! Allow UI to handle but log error so that datadog picks up additional data
                throw err;
            }
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    '/reservation',
                    reservationId
                ]
            });
        }
    });
    const setReload = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                '/reservation',
                reservationId
            ]
        });
    };
    const isFetching = (0, $4f8e348a4679462a$export$625b2ff71316bcd3)({
        queryKey: [
            '/reservation'
        ]
    });
    const isMutating = (0, $e8df1924a4e3fb84$export$32cc39cf62abf4fc)();
    return {
        authState: authState,
        reservation: reservation,
        addNote: addNote,
        mostRecentNote: mostRecentNote,
        telematics: telematics,
        assignVehicle: assignVehicle,
        unassignVehicle: unassignVehicle,
        overrideQualification: overrideQualification,
        overrideQualificationSuccess: overrideQualificationSuccess,
        recalculateCustomerScores: recalculateCustomerScores,
        recalculateCustomerScoresSuccess: recalculateCustomerScoresSuccess,
        cancelReservation: cancelReservation,
        isAdmin: isAdmin,
        currentNote: currentNote,
        setCurrentNote: setCurrentNote,
        setReload: setReload,
        reservationError: reservationError,
        cqeError: cqeError,
        cqeScores: cqeScores?.scoresList,
        cancelError: cancelError,
        changeProgramOpen: changeProgramOpen,
        toggleChangeProgram: toggleChangeProgram,
        isLoading: isFetching > 0 || isMutating > 0,
        disqualificationVendor: $ba66fc54ecff33a1$export$b439d6f66e91ea32(cqeScores?.scoresList),
        overrideDisqualificationVendor: overrideDisqualificationVendor,
        setOverrideDisqualificationVendor: setOverrideDisqualificationVendor
    };
}
function $ba66fc54ecff33a1$export$94aae6a0d3dbf771(qualificationTier) {
    return qualificationTier === (0, $3QqPt.QualificationTier).TIER_1 || qualificationTier === (0, $3QqPt.QualificationTier).TIER_2 || qualificationTier === (0, $3QqPt.QualificationTier).TIER_3 || qualificationTier === (0, $3QqPt.QualificationTier).TIER_1_MANUAL || qualificationTier === (0, $3QqPt.QualificationTier).TIER_2_MANUAL || qualificationTier === (0, $3QqPt.QualificationTier).TIER_3_MANUAL;
}
function $ba66fc54ecff33a1$var$getPlaceholderReservation() {
    return {
        customer: {
            subscriptionsList: [
                {}
            ]
        },
        customerInfo: {},
        isQualified: false,
        reservationStatus: '',
        reservation: {
            customer: {
                subscriptionsList: [
                    {}
                ]
            }
        },
        vehicle: {},
        isCancelled: false,
        qualifications: {
            scores: [],
            hasQualifications: false
        },
        payments: {
            monthly: 0,
            securityDeposit: 0,
            start: 0
        },
        assignedVehicle: {}
    };
}
async function $ba66fc54ecff33a1$var$getAssignedVehicle(vehicleId) {
    return (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getVehicleById(vehicleId).then((res)=>{
        return res.vehicle;
    }).catch((err)=>{
        console.error({
            errorOnGetAssignedVehicle: err
        });
        return undefined;
    });
}
function $ba66fc54ecff33a1$export$23877bb3f6adf77(reservation, vehicle, mileage) {
    const colorPreference = reservation?.color === 'any' ? 'No Preference' : reservation?.color;
    return {
        make: vehicle?.make || reservation?.make,
        model: vehicle?.model || reservation?.model,
        colorPreference: colorPreference,
        mileage: mileage?.telematicsList?.[0]?.odometer.reading.toString() || 'N/A',
        vin: vehicle?.vin || 'N/A',
        startFee: reservation?.startFee,
        monthly: reservation?.monthlyRent,
        deposit: reservation?.deposit,
        trim: vehicle?.trim || 'N/A'
    };
}
function $ba66fc54ecff33a1$export$757ac562920db1cc(reservationObj) {
    return reservationObj.status === (0, (/*@__PURE__*/$parcel$interopDefault($hOsJC))).ReservationStatus.REFUND_REQUESTED.toString();
}
function $ba66fc54ecff33a1$export$2dccbe657ab23dc(scores) {
    return (0, $f1q41.map)(scores, (score)=>{
        const timeIsInNano = score.scoreName === 'liquidity' || score.scoreName === 'fico';
        const qualificationTime = timeIsInNano ? new Date(Math.round(score.timestamp / 1000000)) : new Date(score.timestamp);
        return {
            qualificationTime: (0, $303ba10db2c74ab4$export$d9468344d3651243)(qualificationTime, 'hh:mm aa'),
            qualificationDate: (0, $303ba10db2c74ab4$export$d9468344d3651243)(qualificationTime, 'MM/dd/yyyy'),
            result: score.isPassing ? 'Accepted' : 'Rejected',
            reason: 'TBD',
            score: score.scoreValue,
            tier: 'TBD',
            vendor: score.vendorName,
            sourceData: [
                {
                    ...score,
                    sourceData: (0, $288e026a18a9870d$export$f205803a3961ad7)(score.sourceData)
                }
            ],
            isDisqualifiedScore: score.isDisqualifiedScore
        };
    });
}
const $ba66fc54ecff33a1$var$getAddressFromAddressList = (addressesList, addressType)=>addressesList.find((address)=>address.addressType == addressType);
function $ba66fc54ecff33a1$export$b4ddc154cadabaf({ customer: customer, reservation: reservation }) {
    return {
        ...customer?.customerInfo,
        accountNumber: customer?.accountNumber,
        reservationNumber: reservation?.reservationNumber,
        fullName: `${customer?.customerInfo?.firstName} ${customer?.customerInfo?.lastName}`,
        zipcode: $ba66fc54ecff33a1$export$bb2619045c718779(customer?.customerInfo?.addressesList),
        dealer: 'Autonomy',
        hasVehicleAssigned: $ba66fc54ecff33a1$export$5f5cf1d02d592e57(customer),
        garagingAddress: $ba66fc54ecff33a1$var$getAddressFromAddressList(customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.PARKING),
        licenseAddress: $ba66fc54ecff33a1$var$getAddressFromAddressList(customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.LICENSE),
        contactAddress: $ba66fc54ecff33a1$var$getAddressFromAddressList(customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.CONTACT),
        //  @TODO: Should be currentActivityState
        currentActivity: $ba66fc54ecff33a1$export$539a5520bd6ef2d1(customer?.activityState)
    };
}
function $ba66fc54ecff33a1$export$5f5cf1d02d592e57(customer) {
    const subscriptionsList = customer.subscriptionsList || [];
    if (subscriptionsList.length === 0) return false;
    if (subscriptionsList.length === 1) return subscriptionsList[0].vehicleId?.length > 0;
    const assignedVehicle = (0, $f1q41.find)(subscriptionsList, (subscription)=>{
        const subscriptionIsntClosed = subscription.status !== (0, $3QqPt.Subscription).Status.CLOSED;
        return subscription.vehicleId?.length > 0 && subscriptionIsntClosed;
    });
    return !!assignedVehicle;
}
function $ba66fc54ecff33a1$export$bb2619045c718779(addresses) {
    if (addresses.length === 0) return 'N/A';
    return addresses[0].postal;
}
function $ba66fc54ecff33a1$export$39a33b24a417f7c3(reservation) {
    return {
        ...reservation,
        formattedCreated: (0, $303ba10db2c74ab4$export$d9468344d3651243)(new Date(reservation.created), 'MM/dd/yy HH:MM')
    };
}
function $ba66fc54ecff33a1$export$1cada7972236157e() {
    return (0, $f1q41.map)((0, $f1q41.keys)((0, $3QqPt.ActivityState)), (activity)=>(0, $f1q41.startCase)((0, $f1q41.lowerCase)(activity)));
}
function $ba66fc54ecff33a1$export$539a5520bd6ef2d1(customerActivityState) {
    const formattedActivities = $ba66fc54ecff33a1$export$1cada7972236157e();
    return formattedActivities[customerActivityState];
}
function $ba66fc54ecff33a1$export$b439d6f66e91ea32(cqeScores) {
    return cqeScores?.find((score)=>score.isDisqualifiedScore);
}
var $ba66fc54ecff33a1$export$62bab6355639dfe = /*#__PURE__*/ function(ProcessOptions) {
    ProcessOptions[ProcessOptions["unchanged"] = 0] = "unchanged";
    ProcessOptions[ProcessOptions["rejected"] = 1] = "rejected";
    ProcessOptions[ProcessOptions["approved"] = 2] = "approved";
    ProcessOptions[ProcessOptions["recalculate"] = 3] = "recalculate";
    return ProcessOptions;
}({});



const $a72062603a8a430a$export$eaad8caa32d2521d = {
    mode: 'dark',
    background: {
        default: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).dark,
        paper: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mediumBlue,
        accent: {
            primary: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).cyan,
            secondary: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).pink,
            muted: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue
        },
        white: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
        black: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).black
    },
    primary: {
        main: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mediumBlue,
        dark: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue
    },
    secondary: {
        main: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).cyan
    },
    tertiary: {
        main: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).pink,
        contrastText: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).dark
    },
    text: {
        primary: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
        secondary: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).black,
        error: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).red,
        warning: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).orange,
        success: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).green,
        info: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).pink,
        caption: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).gray,
        highlight: {
            primary: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).cyan,
            secondary: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).pink
        }
    }
};





var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $2347e0dbc69acf4a$var$initialState = {};
var $2347e0dbc69acf4a$var$Context = /*#__PURE__*/ (0, $acw62.createContext)($2347e0dbc69acf4a$var$initialState);
var $2347e0dbc69acf4a$var$reducer = (state, action)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action);
var $2347e0dbc69acf4a$export$9ebd5f6c8d10b3e6 = ()=>{
    return (0, $acw62.useContext)($2347e0dbc69acf4a$var$Context);
};
var $2347e0dbc69acf4a$var$DispatchShowTools = /*#__PURE__*/ (0, $acw62.createContext)(()=>{});
$2347e0dbc69acf4a$var$DispatchShowTools.displayName = 'JVR.DispatchShowTools';
function $2347e0dbc69acf4a$export$3eeb5d125136c73c() {
    return (0, $acw62.useReducer)($2347e0dbc69acf4a$var$reducer, $2347e0dbc69acf4a$var$initialState);
}
function $2347e0dbc69acf4a$export$45c1a77b1d18c54() {
    return (0, $acw62.useContext)($2347e0dbc69acf4a$var$DispatchShowTools);
}
var $2347e0dbc69acf4a$export$ddca470773396382 = (_ref)=>{
    var { initial: initial, dispatch: dispatch, children: children } = _ref;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2347e0dbc69acf4a$var$Context.Provider, {
        value: initial,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2347e0dbc69acf4a$var$DispatchShowTools.Provider, {
            value: dispatch,
            children: children
        })
    });
};
$2347e0dbc69acf4a$export$ddca470773396382.displayName = 'JVR.ShowTools';




var $acw62 = parcelRequire("acw62");

var $c093f23d3087c556$var$initialState = {};
var $c093f23d3087c556$var$Context = /*#__PURE__*/ (0, $acw62.createContext)($c093f23d3087c556$var$initialState);
var $c093f23d3087c556$var$reducer = (state, action)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action);
var $c093f23d3087c556$export$97a82d47391dc38e = ()=>{
    return (0, $acw62.useContext)($c093f23d3087c556$var$Context);
};
var $c093f23d3087c556$var$DispatchExpands = /*#__PURE__*/ (0, $acw62.createContext)(()=>{});
$c093f23d3087c556$var$DispatchExpands.displayName = 'JVR.DispatchExpands';
function $c093f23d3087c556$export$cd6a62c9a3ab22e1() {
    return (0, $acw62.useReducer)($c093f23d3087c556$var$reducer, $c093f23d3087c556$var$initialState);
}
function $c093f23d3087c556$export$488088d69da562f3() {
    return (0, $acw62.useContext)($c093f23d3087c556$var$DispatchExpands);
}
var $c093f23d3087c556$export$557cfbf730dd21b7 = (_ref)=>{
    var { initial: initial, dispatch: dispatch, children: children } = _ref;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c093f23d3087c556$var$Context.Provider, {
        value: initial,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c093f23d3087c556$var$DispatchExpands.Provider, {
            value: dispatch,
            children: children
        })
    });
};
$c093f23d3087c556$export$557cfbf730dd21b7.displayName = 'JVR.Expands';




var $acw62 = parcelRequire("acw62");

var $956f81d65beafa24$var$initialState = {
    Str: {
        as: 'span',
        'data-type': 'string',
        style: {
            color: 'var(--w-rjv-type-string-color, #cb4b16)'
        },
        className: 'w-rjv-type',
        children: 'string'
    },
    Url: {
        as: 'a',
        style: {
            color: 'var(--w-rjv-type-url-color, #0969da)'
        },
        'data-type': 'url',
        className: 'w-rjv-type',
        children: 'url'
    },
    Undefined: {
        style: {
            color: 'var(--w-rjv-type-undefined-color, #586e75)'
        },
        as: 'span',
        'data-type': 'undefined',
        className: 'w-rjv-type',
        children: 'undefined'
    },
    Null: {
        style: {
            color: 'var(--w-rjv-type-null-color, #d33682)'
        },
        as: 'span',
        'data-type': 'null',
        className: 'w-rjv-type',
        children: 'null'
    },
    Map: {
        style: {
            color: 'var(--w-rjv-type-map-color, #268bd2)',
            marginRight: 3
        },
        as: 'span',
        'data-type': 'map',
        className: 'w-rjv-type',
        children: 'Map'
    },
    Nan: {
        style: {
            color: 'var(--w-rjv-type-nan-color, #859900)'
        },
        as: 'span',
        'data-type': 'nan',
        className: 'w-rjv-type',
        children: 'NaN'
    },
    Bigint: {
        style: {
            color: 'var(--w-rjv-type-bigint-color, #268bd2)'
        },
        as: 'span',
        'data-type': 'bigint',
        className: 'w-rjv-type',
        children: 'bigint'
    },
    Int: {
        style: {
            color: 'var(--w-rjv-type-int-color, #268bd2)'
        },
        as: 'span',
        'data-type': 'int',
        className: 'w-rjv-type',
        children: 'int'
    },
    Set: {
        style: {
            color: 'var(--w-rjv-type-set-color, #268bd2)',
            marginRight: 3
        },
        as: 'span',
        'data-type': 'set',
        className: 'w-rjv-type',
        children: 'Set'
    },
    Float: {
        style: {
            color: 'var(--w-rjv-type-float-color, #859900)'
        },
        as: 'span',
        'data-type': 'float',
        className: 'w-rjv-type',
        children: 'float'
    },
    True: {
        style: {
            color: 'var(--w-rjv-type-boolean-color, #2aa198)'
        },
        as: 'span',
        'data-type': 'bool',
        className: 'w-rjv-type',
        children: 'bool'
    },
    False: {
        style: {
            color: 'var(--w-rjv-type-boolean-color, #2aa198)'
        },
        as: 'span',
        'data-type': 'bool',
        className: 'w-rjv-type',
        children: 'bool'
    },
    Date: {
        style: {
            color: 'var(--w-rjv-type-date-color, #268bd2)'
        },
        as: 'span',
        'data-type': 'date',
        className: 'w-rjv-type',
        children: 'date'
    }
};
var $956f81d65beafa24$var$Context = /*#__PURE__*/ (0, $acw62.createContext)($956f81d65beafa24$var$initialState);
var $956f81d65beafa24$var$reducer = (state, action)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action);
var $956f81d65beafa24$export$e0a349f0eeda6e64 = ()=>{
    return (0, $acw62.useContext)($956f81d65beafa24$var$Context);
};
var $956f81d65beafa24$var$DispatchTypes = /*#__PURE__*/ (0, $acw62.createContext)(()=>{});
$956f81d65beafa24$var$DispatchTypes.displayName = 'JVR.DispatchTypes';
function $956f81d65beafa24$export$d468cb4b0f9d5ab7() {
    return (0, $acw62.useReducer)($956f81d65beafa24$var$reducer, $956f81d65beafa24$var$initialState);
}
function $956f81d65beafa24$export$bd13e741f4eca19a() {
    return (0, $acw62.useContext)($956f81d65beafa24$var$DispatchTypes);
}
function $956f81d65beafa24$export$4624c240901a6889(_ref) {
    var { initial: initial, dispatch: dispatch, children: children } = _ref;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($956f81d65beafa24$var$Context.Provider, {
        value: initial,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($956f81d65beafa24$var$DispatchTypes.Provider, {
            value: dispatch,
            children: children
        })
    });
}
$956f81d65beafa24$export$4624c240901a6889.displayName = 'JVR.Types';




var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

var $70e1f7e82395e527$var$_excluded = [
    "style"
];
function $70e1f7e82395e527$export$5f5bfa133552ba6f(props) {
    var { style: style } = props, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $70e1f7e82395e527$var$_excluded);
    var defaultStyle = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        cursor: 'pointer',
        height: '1em',
        width: '1em',
        userSelect: 'none',
        display: 'inline-flex'
    }, style);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        viewBox: "0 0 24 24",
        fill: "var(--w-rjv-arrow-color, currentColor)",
        style: defaultStyle
    }, reset, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
        })
    }));
}
$70e1f7e82395e527$export$5f5bfa133552ba6f.displayName = 'JVR.TriangleArrow';



var $e7871616579c98de$var$initialState = {
    Arrow: {
        as: 'span',
        className: 'w-rjv-arrow',
        style: {
            transform: 'rotate(0deg)',
            transition: 'all 0.3s'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70e1f7e82395e527$export$5f5bfa133552ba6f), {})
    },
    Colon: {
        as: 'span',
        style: {
            color: 'var(--w-rjv-colon-color, var(--w-rjv-color))',
            marginLeft: 0,
            marginRight: 2
        },
        className: 'w-rjv-colon',
        children: ':'
    },
    Quote: {
        as: 'span',
        style: {
            color: 'var(--w-rjv-quotes-color, #236a7c)'
        },
        className: 'w-rjv-quotes',
        children: '"'
    },
    ValueQuote: {
        as: 'span',
        style: {
            color: 'var(--w-rjv-quotes-string-color, #cb4b16)'
        },
        className: 'w-rjv-quotes',
        children: '"'
    },
    BracketsLeft: {
        as: 'span',
        style: {
            color: 'var(--w-rjv-brackets-color, #236a7c)'
        },
        className: 'w-rjv-brackets-start',
        children: '['
    },
    BracketsRight: {
        as: 'span',
        style: {
            color: 'var(--w-rjv-brackets-color, #236a7c)'
        },
        className: 'w-rjv-brackets-end',
        children: ']'
    },
    BraceLeft: {
        as: 'span',
        style: {
            color: 'var(--w-rjv-curlybraces-color, #236a7c)'
        },
        className: 'w-rjv-curlybraces-start',
        children: '{'
    },
    BraceRight: {
        as: 'span',
        style: {
            color: 'var(--w-rjv-curlybraces-color, #236a7c)'
        },
        className: 'w-rjv-curlybraces-end',
        children: '}'
    }
};
var $e7871616579c98de$var$Context = /*#__PURE__*/ (0, $acw62.createContext)($e7871616579c98de$var$initialState);
var $e7871616579c98de$var$reducer = (state, action)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action);
var $e7871616579c98de$export$290c5145a07760ef = ()=>{
    return (0, $acw62.useContext)($e7871616579c98de$var$Context);
};
var $e7871616579c98de$var$DispatchSymbols = /*#__PURE__*/ (0, $acw62.createContext)(()=>{});
$e7871616579c98de$var$DispatchSymbols.displayName = 'JVR.DispatchSymbols';
function $e7871616579c98de$export$e568fe6105dcd29a() {
    return (0, $acw62.useReducer)($e7871616579c98de$var$reducer, $e7871616579c98de$var$initialState);
}
function $e7871616579c98de$export$4c8d5c8f3341070b() {
    return (0, $acw62.useContext)($e7871616579c98de$var$DispatchSymbols);
}
var $e7871616579c98de$export$fa456266707bf4e4 = (_ref)=>{
    var { initial: initial, dispatch: dispatch, children: children } = _ref;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e7871616579c98de$var$Context.Provider, {
        value: initial,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e7871616579c98de$var$DispatchSymbols.Provider, {
            value: dispatch,
            children: children
        })
    });
};
$e7871616579c98de$export$fa456266707bf4e4.displayName = 'JVR.Symbols';




var $acw62 = parcelRequire("acw62");

var $6977ed43d0c1c688$var$initialState = {
    Copied: {
        className: 'w-rjv-copied',
        style: {
            height: '1em',
            width: '1em',
            cursor: 'pointer',
            verticalAlign: 'middle',
            marginLeft: 5
        }
    },
    CountInfo: {
        as: 'span',
        className: 'w-rjv-object-size',
        style: {
            color: 'var(--w-rjv-info-color, #0000004d)',
            paddingLeft: 8,
            fontStyle: 'italic'
        }
    },
    CountInfoExtra: {
        as: 'span',
        className: 'w-rjv-object-extra',
        style: {
            paddingLeft: 8
        }
    },
    Ellipsis: {
        as: 'span',
        style: {
            cursor: 'pointer',
            color: 'var(--w-rjv-ellipsis-color, #cb4b16)',
            userSelect: 'none'
        },
        className: 'w-rjv-ellipsis',
        children: '...'
    },
    Row: {
        as: 'div',
        className: 'w-rjv-line'
    },
    KeyName: {
        as: 'span',
        className: 'w-rjv-object-key'
    }
};
var $6977ed43d0c1c688$var$Context = /*#__PURE__*/ (0, $acw62.createContext)($6977ed43d0c1c688$var$initialState);
var $6977ed43d0c1c688$var$reducer = (state, action)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action);
var $6977ed43d0c1c688$export$3dda1fbb9d1a8106 = ()=>{
    return (0, $acw62.useContext)($6977ed43d0c1c688$var$Context);
};
var $6977ed43d0c1c688$var$DispatchSection = /*#__PURE__*/ (0, $acw62.createContext)(()=>{});
$6977ed43d0c1c688$var$DispatchSection.displayName = 'JVR.DispatchSection';
function $6977ed43d0c1c688$export$f781df8610c5c2e0() {
    return (0, $acw62.useReducer)($6977ed43d0c1c688$var$reducer, $6977ed43d0c1c688$var$initialState);
}
function $6977ed43d0c1c688$export$3fd6255b2a1ffa26() {
    return (0, $acw62.useContext)($6977ed43d0c1c688$var$DispatchSection);
}
var $6977ed43d0c1c688$export$6e2c8f0811a474ce = (_ref)=>{
    var { initial: initial, dispatch: dispatch, children: children } = _ref;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6977ed43d0c1c688$var$Context.Provider, {
        value: initial,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6977ed43d0c1c688$var$DispatchSection.Provider, {
            value: dispatch,
            children: children
        })
    });
};
$6977ed43d0c1c688$export$6e2c8f0811a474ce.displayName = 'JVR.Section';



var $07cda60092545df8$export$d4c72bab9d6cc13a = {
    objectSortKeys: false,
    indentWidth: 15
};
var $07cda60092545df8$export$841858b892ce1f4c = /*#__PURE__*/ (0, $acw62.createContext)($07cda60092545df8$export$d4c72bab9d6cc13a);
$07cda60092545df8$export$841858b892ce1f4c.displayName = 'JVR.Context';
var $07cda60092545df8$var$DispatchContext = /*#__PURE__*/ (0, $acw62.createContext)(()=>{});
$07cda60092545df8$var$DispatchContext.displayName = 'JVR.DispatchContext';
function $07cda60092545df8$export$1650419e431d3ba3(state, action) {
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, action);
}
var $07cda60092545df8$export$6ccbb43953eebf8 = ()=>{
    return (0, $acw62.useContext)($07cda60092545df8$export$841858b892ce1f4c);
};
var $07cda60092545df8$export$2960e391a6dcc456 = ()=>{
    return (0, $acw62.useContext)($07cda60092545df8$var$DispatchContext);
};
var $07cda60092545df8$export$2881499e37b75b9a = (_ref)=>{
    var { children: children, initialState: init, initialTypes: initialTypes } = _ref;
    var [state, dispatch] = (0, $acw62.useReducer)($07cda60092545df8$export$1650419e431d3ba3, Object.assign({}, $07cda60092545df8$export$d4c72bab9d6cc13a, init));
    var [showTools, showToolsDispatch] = (0, $2347e0dbc69acf4a$export$3eeb5d125136c73c)();
    var [expands, expandsDispatch] = (0, $c093f23d3087c556$export$cd6a62c9a3ab22e1)();
    var [types, typesDispatch] = (0, $956f81d65beafa24$export$d468cb4b0f9d5ab7)();
    var [symbols, symbolsDispatch] = (0, $e7871616579c98de$export$e568fe6105dcd29a)();
    var [section, sectionDispatch] = (0, $6977ed43d0c1c688$export$f781df8610c5c2e0)();
    (0, $acw62.useEffect)(()=>dispatch((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, init)), [
        init
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07cda60092545df8$export$841858b892ce1f4c.Provider, {
        value: state,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($07cda60092545df8$var$DispatchContext.Provider, {
            value: dispatch,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2347e0dbc69acf4a$export$ddca470773396382), {
                initial: showTools,
                dispatch: showToolsDispatch,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c093f23d3087c556$export$557cfbf730dd21b7), {
                    initial: expands,
                    dispatch: expandsDispatch,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $956f81d65beafa24$export$4624c240901a6889), {
                        initial: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, types, initialTypes),
                        dispatch: typesDispatch,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e7871616579c98de$export$fa456266707bf4e4), {
                            initial: symbols,
                            dispatch: symbolsDispatch,
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6977ed43d0c1c688$export$6e2c8f0811a474ce), {
                                initial: section,
                                dispatch: sectionDispatch,
                                children: children
                            })
                        })
                    })
                })
            })
        })
    });
};
function $07cda60092545df8$export$8ad76b76a4c905f8() {
    return (0, $acw62.useContext)($07cda60092545df8$var$DispatchContext);
}
$07cda60092545df8$export$2881499e37b75b9a.displayName = 'JVR.Provider';





var $acw62 = parcelRequire("acw62");



function $23eccd30fa89cd48$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}







var $981c3e4d841969e7$var$_excluded = [
    "isNumber",
    "value",
    "parentValue",
    "keyName",
    "keys"
], $981c3e4d841969e7$var$_excluded2 = [
    "as",
    "render"
], $981c3e4d841969e7$var$_excluded3 = [
    "as",
    "render"
], $981c3e4d841969e7$var$_excluded4 = [
    "as",
    "render"
], $981c3e4d841969e7$var$_excluded5 = [
    "as",
    "style",
    "render"
], $981c3e4d841969e7$var$_excluded6 = [
    "as",
    "render"
], $981c3e4d841969e7$var$_excluded7 = [
    "as",
    "render"
], $981c3e4d841969e7$var$_excluded8 = [
    "as",
    "render"
], $981c3e4d841969e7$var$_excluded9 = [
    "as",
    "render"
];
var $981c3e4d841969e7$export$82b8d343c504672 = (props)=>{
    var { Quote: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    var { isNumber: isNumber, value: value, parentValue: parentValue, keyName: keyName, keys: keys } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $981c3e4d841969e7$var$_excluded);
    if (isNumber) return null;
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $981c3e4d841969e7$var$_excluded2);
    var Elm = as || 'span';
    var elmProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, reset);
    var result = {
        value: value,
        parentValue: parentValue,
        keyName: keyName,
        keys: keys || (keyName ? [
            keyName
        ] : [])
    };
    var child = render && typeof render === 'function' && render(elmProps, result);
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, elmProps));
};
$981c3e4d841969e7$export$82b8d343c504672.displayName = 'JVR.Quote';
var $981c3e4d841969e7$export$3371f364df92f618 = (props)=>{
    var { ValueQuote: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    var other = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ((0, $23eccd30fa89cd48$export$2e2bcd8739ae039)(props), props));
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $981c3e4d841969e7$var$_excluded3);
    var Elm = as || 'span';
    var elmProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, reset);
    var child = render && typeof render === 'function' && render(elmProps, {});
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, elmProps));
};
$981c3e4d841969e7$export$3371f364df92f618.displayName = 'JVR.ValueQuote';
var $981c3e4d841969e7$export$e20ebb298016f6 = (props)=>{
    var { value: value, parentValue: parentValue, keyName: keyName, keys: keys } = props;
    var { Colon: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $981c3e4d841969e7$var$_excluded4);
    var Elm = as || 'span';
    var child = render && typeof render === 'function' && render(reset, {
        value: value,
        parentValue: parentValue,
        keyName: keyName,
        keys: keys || (keyName ? [
            keyName
        ] : [])
    });
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset));
};
$981c3e4d841969e7$export$e20ebb298016f6.displayName = 'JVR.Colon';
var $981c3e4d841969e7$export$21b07c8f274aebd5 = (props)=>{
    var { Arrow: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    var expands = (0, $c093f23d3087c556$export$97a82d47391dc38e)();
    var { expandKey: expandKey, style: resetStyle, value: value, parentValue: parentValue, keyName: keyName, keys: keys } = props;
    var isExpanded = !!expands[expandKey];
    var { as: as, style: style, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $981c3e4d841969e7$var$_excluded5);
    var Elm = as || 'span';
    var isRender = render && typeof render === 'function';
    var elmProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        'data-expanded': isExpanded,
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, style, resetStyle)
    });
    var result = {
        value: value,
        parentValue: parentValue,
        keyName: keyName,
        keys: keys || (keyName ? [
            keyName
        ] : [])
    };
    var child = isRender && render(elmProps, result);
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, style, resetStyle)
    }));
};
$981c3e4d841969e7$export$21b07c8f274aebd5.displayName = 'JVR.Arrow';
var $981c3e4d841969e7$export$dda5939892ac6def = (props)=>{
    var { isBrackets: isBrackets, value: value, parentValue: parentValue, keyName: keyName, keys: keys } = props;
    var { BracketsLeft: BracketsLeft = {}, BraceLeft: BraceLeft = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    var result = {
        value: value,
        parentValue: parentValue,
        keyName: keyName,
        keys: keys || (keyName ? [
            keyName
        ] : [])
    };
    if (isBrackets) {
        var { as: as, render: _render } = BracketsLeft, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(BracketsLeft, $981c3e4d841969e7$var$_excluded6);
        var BracketsLeftComp = as || 'span';
        var _child = _render && typeof _render === 'function' && _render(reset, result);
        if (_child) return _child;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BracketsLeftComp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset));
    }
    var { as: elm, render: render } = BraceLeft, resetProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(BraceLeft, $981c3e4d841969e7$var$_excluded7);
    var BraceLeftComp = elm || 'span';
    var child = render && typeof render === 'function' && render(resetProps, result);
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BraceLeftComp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, resetProps));
};
$981c3e4d841969e7$export$dda5939892ac6def.displayName = 'JVR.BracketsOpen';
var $981c3e4d841969e7$export$b8ad950cc15c1779 = (props)=>{
    var { isBrackets: isBrackets, isVisiable: isVisiable, value: value, parentValue: parentValue, keyName: keyName, keys: keys } = props;
    var result = {
        value: value,
        parentValue: parentValue,
        keyName: keyName,
        keys: keys || (keyName ? [
            keyName
        ] : [])
    };
    if (!isVisiable) return null;
    var { BracketsRight: BracketsRight = {}, BraceRight: BraceRight = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    if (isBrackets) {
        var { as: as, render: _render2 } = BracketsRight, _reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(BracketsRight, $981c3e4d841969e7$var$_excluded8);
        var BracketsRightComp = as || 'span';
        var _child2 = _render2 && typeof _render2 === 'function' && _render2(_reset, result);
        if (_child2) return _child2;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BracketsRightComp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, _reset));
    }
    var { as: elm, render: render } = BraceRight, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(BraceRight, $981c3e4d841969e7$var$_excluded9);
    var BraceRightComp = elm || 'span';
    var child = render && typeof render === 'function' && render(reset, result);
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BraceRightComp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset));
};
$981c3e4d841969e7$export$b8ad950cc15c1779.displayName = 'JVR.BracketsClose';



var $70c5a13b7c930dfc$export$11fd4f17364d5e5 = (props)=>{
    var _expands$expandKey;
    var { keyName: keyName, value: value, expandKey: expandKey, parentValue: parentValue, level: level, keys: keys = [] } = props;
    var expands = (0, $c093f23d3087c556$export$97a82d47391dc38e)();
    var { collapsed: collapsed, shouldExpandNodeInitially: shouldExpandNodeInitially } = (0, $07cda60092545df8$export$6ccbb43953eebf8)();
    var defaultExpanded = typeof collapsed === 'boolean' ? collapsed : typeof collapsed === 'number' ? level > collapsed : false;
    var isExpanded = (_expands$expandKey = expands[expandKey]) != null ? _expands$expandKey : shouldExpandNodeInitially ? false : defaultExpanded;
    var shouldExpand = shouldExpandNodeInitially && shouldExpandNodeInitially(!isExpanded, {
        value: value,
        keys: keys,
        level: level,
        keyName: keyName,
        parentValue: parentValue
    });
    if (expands[expandKey] === undefined && !shouldExpand) return null;
    var len = Object.keys(value).length;
    if (isExpanded || len === 0) return null;
    var style = {
        paddingLeft: 4
    };
    var compProps = {
        keyName: keyName,
        value: value,
        keys: keys,
        parentValue: parentValue
    };
    var isArray = Array.isArray(value);
    var isMySet = value instanceof Set;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: style,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$b8ad950cc15c1779), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            isBrackets: isArray || isMySet
        }, compProps, {
            isVisiable: true
        }))
    });
};
$70c5a13b7c930dfc$export$11fd4f17364d5e5.displayName = 'JVR.NestedClose';





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");




var $cde5e87cebf7704d$var$_excluded = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded2 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded3 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded4 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded5 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded6 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded7 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded8 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded9 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded0 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded1 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded10 = [
    "as",
    "render"
], $cde5e87cebf7704d$var$_excluded11 = [
    "as",
    "render"
];
var $cde5e87cebf7704d$export$d92b0ad786a01597 = (bi)=>{
    if (bi === undefined) return '0n';
    else if (typeof bi === 'string') try {
        bi = BigInt(bi);
    } catch (e) {
        return '0n';
    }
    return bi ? bi.toString() + 'n' : '0n';
};
var $cde5e87cebf7704d$export$28e541733e48be77 = (_ref)=>{
    var { value: value, keyName: keyName } = _ref;
    var { Set: Comp = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var isSet = value instanceof Set;
    if (!isSet || !displayDataTypes) return null;
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $cde5e87cebf7704d$var$_excluded);
    var isRender = render && typeof render === 'function';
    var type = isRender && render(reset, {
        type: 'type',
        value: value,
        keyName: keyName
    });
    if (type) return type;
    var Elm = as || 'span';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset));
};
$cde5e87cebf7704d$export$28e541733e48be77.displayName = 'JVR.SetComp';
var $cde5e87cebf7704d$export$94e12a7a0342154f = (_ref2)=>{
    var { value: value, keyName: keyName } = _ref2;
    var { Map: Comp = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var isMap = value instanceof Map;
    if (!isMap || !displayDataTypes) return null;
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $cde5e87cebf7704d$var$_excluded2);
    var isRender = render && typeof render === 'function';
    var type = isRender && render(reset, {
        type: 'type',
        value: value,
        keyName: keyName
    });
    if (type) return type;
    var Elm = as || 'span';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset));
};
$cde5e87cebf7704d$export$94e12a7a0342154f.displayName = 'JVR.MapComp';
var $cde5e87cebf7704d$var$defalutStyle = {
    opacity: 0.75,
    paddingRight: 4
};
var $cde5e87cebf7704d$export$5acdbb26462d6a84 = (_ref3)=>{
    var { children: children = '', keyName: keyName, keys: keys } = _ref3;
    var { Str: Str = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { shortenTextAfterLength: length = 30, stringEllipsis: stringEllipsis = '...' } = (0, $07cda60092545df8$export$6ccbb43953eebf8)();
    var { as: as, render: render } = Str, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Str, $cde5e87cebf7704d$var$_excluded3);
    var childrenStr = children;
    var [shorten, setShorten] = (0, $acw62.useState)(length && childrenStr.length > length);
    (0, $acw62.useEffect)(()=>setShorten(length && childrenStr.length > length), [
        length
    ]);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, Str.style || {});
    if (length > 0) {
        reset.style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset.style, {
            cursor: childrenStr.length <= length ? 'initial' : 'pointer'
        });
        if (childrenStr.length > length) reset.onClick = ()=>{
            setShorten(!shorten);
        };
    }
    var text = shorten ? "" + childrenStr.slice(0, length) + stringEllipsis : childrenStr;
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var cls = shorten ? 'w-rjv-value w-rjv-value-short' : 'w-rjv-value';
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: text,
        className: cls
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$3371f364df92f618), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                        className: cls,
                        children: text
                    })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$3371f364df92f618), {})
                ]
            })
        ]
    });
};
$cde5e87cebf7704d$export$5acdbb26462d6a84.displayName = 'JVR.TypeString';
var $cde5e87cebf7704d$export$17a2b2ce6c35976f = (_ref4)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref4;
    var { True: True = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = True, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(True, $cde5e87cebf7704d$var$_excluded4);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, True.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                className: "w-rjv-value",
                children: children == null ? void 0 : children.toString()
            }))
        ]
    });
};
$cde5e87cebf7704d$export$17a2b2ce6c35976f.displayName = 'JVR.TypeTrue';
var $cde5e87cebf7704d$export$a1caaa315625c64b = (_ref5)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref5;
    var { False: False = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = False, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(False, $cde5e87cebf7704d$var$_excluded5);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, False.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                className: "w-rjv-value",
                children: children == null ? void 0 : children.toString()
            }))
        ]
    });
};
$cde5e87cebf7704d$export$a1caaa315625c64b.displayName = 'JVR.TypeFalse';
var $cde5e87cebf7704d$export$7dbd461f3e4824dd = (_ref6)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref6;
    var { Float: Float = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = Float, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Float, $cde5e87cebf7704d$var$_excluded6);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, Float.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                className: "w-rjv-value",
                children: children == null ? void 0 : children.toString()
            }))
        ]
    });
};
$cde5e87cebf7704d$export$7dbd461f3e4824dd.displayName = 'JVR.TypeFloat';
var $cde5e87cebf7704d$export$1f11939f0903c877 = (_ref7)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref7;
    var { Int: Int = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = Int, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Int, $cde5e87cebf7704d$var$_excluded7);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, Int.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                className: "w-rjv-value",
                children: children == null ? void 0 : children.toString()
            }))
        ]
    });
};
$cde5e87cebf7704d$export$1f11939f0903c877.displayName = 'JVR.TypeInt';
var $cde5e87cebf7704d$export$fe426a0f13c83aa5 = (_ref8)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref8;
    var { Bigint: CompBigint = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = CompBigint, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(CompBigint, $cde5e87cebf7704d$var$_excluded8);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, CompBigint.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                className: "w-rjv-value",
                children: $cde5e87cebf7704d$export$d92b0ad786a01597(children == null ? void 0 : children.toString())
            }))
        ]
    });
};
$cde5e87cebf7704d$export$fe426a0f13c83aa5.displayName = 'JVR.TypeFloat';
var $cde5e87cebf7704d$export$e6338987395d5cdb = (_ref9)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref9;
    var { Url: Url = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = Url, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Url, $cde5e87cebf7704d$var$_excluded9);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, Url.style);
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children == null ? void 0 : children.href,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                href: children == null ? void 0 : children.href,
                target: "_blank"
            }, reset, {
                className: "w-rjv-value",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$3371f364df92f618), {}),
                    children == null ? void 0 : children.href,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$3371f364df92f618), {})
                ]
            }))
        ]
    });
};
$cde5e87cebf7704d$export$e6338987395d5cdb.displayName = 'JVR.TypeUrl';
var $cde5e87cebf7704d$export$3e80c470b184fb99 = (_ref0)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref0;
    var { Date: CompData = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = CompData, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(CompData, $cde5e87cebf7704d$var$_excluded0);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, CompData.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var childStr = children instanceof Date ? children.toLocaleString() : children;
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: childStr,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                className: "w-rjv-value",
                children: childStr
            }))
        ]
    });
};
$cde5e87cebf7704d$export$3e80c470b184fb99.displayName = 'JVR.TypeDate';
var $cde5e87cebf7704d$export$3a2cbf65011b70ec = (_ref1)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref1;
    var { Undefined: Undefined = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = Undefined, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Undefined, $cde5e87cebf7704d$var$_excluded1);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, Undefined.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child
        ]
    });
};
$cde5e87cebf7704d$export$3a2cbf65011b70ec.displayName = 'JVR.TypeUndefined';
var $cde5e87cebf7704d$export$d34d4a2e036e364f = (_ref10)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref10;
    var { Null: Null = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = Null, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Null, $cde5e87cebf7704d$var$_excluded10);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, Null.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children,
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child
        ]
    });
};
$cde5e87cebf7704d$export$d34d4a2e036e364f.displayName = 'JVR.TypeNull';
var $cde5e87cebf7704d$export$1d63fc9edbd62715 = (_ref11)=>{
    var { children: children, keyName: keyName, keys: keys } = _ref11;
    var { Nan: Nan = {}, displayDataTypes: displayDataTypes } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    var { as: as, render: render } = Nan, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Nan, $cde5e87cebf7704d$var$_excluded11);
    var Comp = as || 'span';
    var style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $cde5e87cebf7704d$var$defalutStyle, Nan.style || {});
    var isRender = render && typeof render === 'function';
    var type = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        style: style
    }), {
        type: 'type',
        value: children,
        keyName: keyName,
        keys: keys
    });
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children == null ? void 0 : children.toString(),
        className: 'w-rjv-value'
    }), {
        type: 'value',
        value: children,
        keyName: keyName,
        keys: keys
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            displayDataTypes && (type || /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Comp, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
                style: style
            }))),
            child
        ]
    });
};
$cde5e87cebf7704d$export$1d63fc9edbd62715.displayName = 'JVR.TypeNan';



var $b662e58338bd48f9$export$4ba1d6600e2a2892 = (n)=>Number(n) === n && n % 1 !== 0 || isNaN(n);
var $b662e58338bd48f9$export$4c8d1a57a761ef94 = (props)=>{
    var { value: value, keyName: keyName, keys: keys } = props;
    var reset = {
        keyName: keyName,
        keys: keys
    };
    if (value instanceof URL) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$e6338987395d5cdb), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    if (typeof value === 'string') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$5acdbb26462d6a84), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    if (value === true) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$17a2b2ce6c35976f), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    if (value === false) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$a1caaa315625c64b), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    if (value === null) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$d34d4a2e036e364f), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    if (value === undefined) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$3a2cbf65011b70ec), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    if (value instanceof Date) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$3e80c470b184fb99), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    if (typeof value === 'number' && isNaN(value)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$1d63fc9edbd62715), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    else if (typeof value === 'number' && $b662e58338bd48f9$export$4ba1d6600e2a2892(value)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$7dbd461f3e4824dd), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    else if (typeof value === 'bigint') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$fe426a0f13c83aa5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    else if (typeof value === 'number') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$1f11939f0903c877), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: value
    }));
    return null;
};
$b662e58338bd48f9$export$4c8d1a57a761ef94.displayName = 'JVR.Value';







var $acw62 = parcelRequire("acw62");



function $d7faa034b23d79cc$export$13941268da83b68e(currentProps, props, key) {
    var dispatch = (0, $e7871616579c98de$export$4c8d5c8f3341070b)();
    var cls = [
        currentProps.className,
        props.className
    ].filter(Boolean).join(' ');
    var reset = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentProps, props, {
        className: cls,
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentProps.style, props.style),
        children: props.children || currentProps.children
    });
    (0, $acw62.useEffect)(()=>dispatch({
            [key]: reset
        }), [
        props
    ]);
}
function $d7faa034b23d79cc$export$f2df60bacb12ff60(currentProps, props, key) {
    var dispatch = (0, $956f81d65beafa24$export$bd13e741f4eca19a)();
    var cls = [
        currentProps.className,
        props.className
    ].filter(Boolean).join(' ');
    var reset = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentProps, props, {
        className: cls,
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentProps.style, props.style),
        children: props.children || currentProps.children
    });
    (0, $acw62.useEffect)(()=>dispatch({
            [key]: reset
        }), [
        props
    ]);
}
function $d7faa034b23d79cc$export$7abe9c32505c6519(currentProps, props, key) {
    var dispatch = (0, $6977ed43d0c1c688$export$3fd6255b2a1ffa26)();
    var cls = [
        currentProps.className,
        props.className
    ].filter(Boolean).join(' ');
    var reset = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentProps, props, {
        className: cls,
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentProps.style, props.style),
        children: props.children || currentProps.children
    });
    (0, $acw62.useEffect)(()=>dispatch({
            [key]: reset
        }), [
        props
    ]);
}



var $6420d3a998dd8794$var$_excluded = [
    "as",
    "render"
];
var $6420d3a998dd8794$export$6f15ac9d8a016c94 = (props)=>{
    var { KeyName: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    (0, $d7faa034b23d79cc$export$7abe9c32505c6519)(Comp, props, 'KeyName');
    return null;
};
$6420d3a998dd8794$export$6f15ac9d8a016c94.displayName = 'JVR.KeyName';
var $6420d3a998dd8794$export$b712ced46791f3b = (props)=>{
    var { children: children, value: value, parentValue: parentValue, keyName: keyName, keys: keys } = props;
    var isNumber = typeof children === 'number';
    var style = {
        color: isNumber ? 'var(--w-rjv-key-number, #268bd2)' : 'var(--w-rjv-key-string, #002b36)'
    };
    var { KeyName: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $6420d3a998dd8794$var$_excluded);
    reset.style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset.style, style);
    var Elm = as || 'span';
    var child = render && typeof render === 'function' && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children
    }), {
        value: value,
        parentValue: parentValue,
        keyName: keyName,
        keys: keys || (keyName ? [
            keyName
        ] : [])
    });
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: children
    }));
};
$6420d3a998dd8794$export$b712ced46791f3b.displayName = 'JVR.KeyNameComp';







var $ff0c20dd77024464$var$_excluded = [
    "children",
    "value",
    "parentValue",
    "keyName",
    "keys"
], $ff0c20dd77024464$var$_excluded2 = [
    "as",
    "render",
    "children"
];
var $ff0c20dd77024464$export$b59bdbef9ce70de2 = (props)=>{
    var { Row: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    (0, $d7faa034b23d79cc$export$7abe9c32505c6519)(Comp, props, 'Row');
    return null;
};
$ff0c20dd77024464$export$b59bdbef9ce70de2.displayName = 'JVR.Row';
var $ff0c20dd77024464$export$8af35ed184dd0113 = (props)=>{
    var { children: children, value: value, parentValue: parentValue, keyName: keyName, keys: keys } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $ff0c20dd77024464$var$_excluded);
    var { Row: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $ff0c20dd77024464$var$_excluded2);
    var Elm = as || 'div';
    var child = render && typeof render === 'function' && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, reset, {
        children: children
    }), {
        value: value,
        keyName: keyName,
        parentValue: parentValue,
        keys: keys
    });
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, reset, {
        children: children
    }));
};
$ff0c20dd77024464$export$8af35ed184dd0113.displayName = 'JVR.RowComp';





var $acw62 = parcelRequire("acw62");
function $727dfec5650f7635$export$5cae361ad82dce8b(value) {
    var ref = (0, $acw62.useRef)();
    (0, $acw62.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}
function $727dfec5650f7635$export$8fa04b7e8216bb21(_ref) {
    var { value: value, highlightUpdates: highlightUpdates, highlightContainer: highlightContainer } = _ref;
    var prevValue = $727dfec5650f7635$export$5cae361ad82dce8b(value);
    var isHighlight = (0, $acw62.useMemo)(()=>{
        if (!highlightUpdates || prevValue === undefined) return false;
        // highlight if value type changed
        if (typeof value !== typeof prevValue) return true;
        if (typeof value === 'number') {
            // notice: NaN !== NaN
            if (isNaN(value) && isNaN(prevValue)) return false;
            return value !== prevValue;
        }
        // highlight if isArray changed
        if (Array.isArray(value) !== Array.isArray(prevValue)) return true;
        // not highlight object/function
        // deep compare they will be slow
        if (typeof value === 'object' || typeof value === 'function') return false;
        // highlight if not equal
        if (value !== prevValue) return true;
    }, [
        highlightUpdates,
        value
    ]);
    (0, $acw62.useEffect)(()=>{
        if (highlightContainer && highlightContainer.current && isHighlight && 'animate' in highlightContainer.current) highlightContainer.current.animate([
            {
                backgroundColor: 'var(--w-rjv-update-color, #ebcb8b)'
            },
            {
                backgroundColor: ''
            }
        ], {
            duration: 1000,
            easing: 'ease-in'
        });
    }, [
        isHighlight,
        value,
        highlightContainer
    ]);
}





var $acw62 = parcelRequire("acw62");





var $6dfbc10bc3e37007$var$_excluded = [
    "keyName",
    "value",
    "parentValue",
    "expandKey",
    "keys",
    "beforeCopy"
], $6dfbc10bc3e37007$var$_excluded2 = [
    "as",
    "render"
];
var $6dfbc10bc3e37007$export$7166b2a50edce6b6 = (props)=>{
    var { keyName: keyName, value: value, parentValue: parentValue, expandKey: expandKey, keys: keys, beforeCopy: beforeCopy } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $6dfbc10bc3e37007$var$_excluded);
    var { onCopied: onCopied, enableClipboard: enableClipboard, beforeCopy: globalBeforeCopy } = (0, $07cda60092545df8$export$6ccbb43953eebf8)();
    var showTools = (0, $2347e0dbc69acf4a$export$9ebd5f6c8d10b3e6)();
    var isShowTools = showTools[expandKey];
    var [copied, setCopied] = (0, $acw62.useState)(false);
    var { Copied: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    var sectionBeforeCopy = Comp == null ? void 0 : Comp.beforeCopy;
    if (enableClipboard === false || !isShowTools) return null;
    var click = (event)=>{
        event.stopPropagation();
        var copyText = '';
        if (typeof value === 'number' && value === Infinity) copyText = 'Infinity';
        else if (typeof value === 'number' && isNaN(value)) copyText = 'NaN';
        else if (typeof value === 'bigint') copyText = (0, $cde5e87cebf7704d$export$d92b0ad786a01597)(value);
        else if (value instanceof Date) copyText = value.toLocaleString();
        else copyText = JSON.stringify(value, (_, v)=>typeof v === 'bigint' ? (0, $cde5e87cebf7704d$export$d92b0ad786a01597)(v) : v, 2);
        // Apply beforeCopy transformation if provided
        // Priority: component prop > section prop > global prop
        var finalBeforeCopy = beforeCopy || sectionBeforeCopy || globalBeforeCopy;
        if (finalBeforeCopy && typeof finalBeforeCopy === 'function') copyText = finalBeforeCopy(copyText, keyName, value, parentValue, expandKey, keys);
        onCopied && onCopied(copyText, value);
        setCopied(true);
        var _clipboard = navigator.clipboard || {
            writeText (text) {
                return new Promise((reslove, reject)=>{
                    var textarea = document.createElement('textarea');
                    textarea.style.position = 'absolute';
                    textarea.style.opacity = '0';
                    textarea.style.left = '-99999999px';
                    textarea.value = text;
                    document.body.appendChild(textarea);
                    textarea.select();
                    if (!document.execCommand('copy')) reject();
                    else reslove();
                    textarea.remove();
                });
            }
        };
        _clipboard.writeText(copyText).then(()=>{
            var timer = setTimeout(()=>{
                setCopied(false);
                clearTimeout(timer);
            }, 3000);
        }).catch((error)=>{});
    };
    var svgProps = {
        style: {
            display: 'inline-flex'
        },
        fill: copied ? 'var(--w-rjv-copied-success-color, #28a745)' : 'var(--w-rjv-copied-color, currentColor)',
        onClick: click
    };
    var { render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $6dfbc10bc3e37007$var$_excluded2);
    var elmProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, other, svgProps, {
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset.style, other.style, svgProps.style)
    });
    var isRender = render && typeof render === 'function';
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, elmProps, {
        'data-copied': copied
    }), {
        value: value,
        keyName: keyName,
        keys: keys,
        parentValue: parentValue
    });
    if (child) return child;
    if (copied) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        viewBox: "0 0 32 36"
    }, elmProps, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M27.5,33 L2.5,33 L2.5,12.5 L27.5,12.5 L27.5,15.2249049 C29.1403264,13.8627542 29.9736597,13.1778155 30,13.1700887 C30,11.9705278 30,10.0804982 30,7.5 C30,6.1 28.9,5 27.5,5 L20,5 C20,2.2 17.8,0 15,0 C12.2,0 10,2.2 10,5 L2.5,5 C1.1,5 0,6.1 0,7.5 L0,33 C0,34.4 1.1,36 2.5,36 L27.5,36 C28.9,36 30,34.4 30,33 L30,26.1114493 L27.5,28.4926435 L27.5,33 Z M7.5,7.5 L10,7.5 C10,7.5 12.5,6.4 12.5,5 C12.5,3.6 13.6,2.5 15,2.5 C16.4,2.5 17.5,3.6 17.5,5 C17.5,6.4 18.8,7.5 20,7.5 L22.5,7.5 C22.5,7.5 25,8.6 25,10 L5,10 C5,8.5 6.1,7.5 7.5,7.5 Z M5,27.5 L10,27.5 L10,25 L5,25 L5,27.5 Z M28.5589286,16 L32,19.6 L21.0160714,30.5382252 L13.5303571,24.2571429 L17.1303571,20.6571429 L21.0160714,24.5428571 L28.5589286,16 Z M17.5,15 L5,15 L5,17.5 L17.5,17.5 L17.5,15 Z M10,20 L5,20 L5,22.5 L10,22.5 L10,20 Z"
        })
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        viewBox: "0 0 32 36"
    }, elmProps, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M27.5,33 L2.5,33 L2.5,12.5 L27.5,12.5 L27.5,20 L30,20 L30,7.5 C30,6.1 28.9,5 27.5,5 L20,5 C20,2.2 17.8,0 15,0 C12.2,0 10,2.2 10,5 L2.5,5 C1.1,5 0,6.1 0,7.5 L0,33 C0,34.4 1.1,36 2.5,36 L27.5,36 C28.9,36 30,34.4 30,33 L30,29 L27.5,29 L27.5,33 Z M7.5,7.5 L10,7.5 C10,7.5 12.5,6.4 12.5,5 C12.5,3.6 13.6,2.5 15,2.5 C16.4,2.5 17.5,3.6 17.5,5 C17.5,6.4 18.8,7.5 20,7.5 L22.5,7.5 C22.5,7.5 25,8.6 25,10 L5,10 C5,8.5 6.1,7.5 7.5,7.5 Z M5,27.5 L10,27.5 L10,25 L5,25 L5,27.5 Z M22.5,21.5 L22.5,16.5 L12.5,24 L22.5,31.5 L22.5,26.5 L32,26.5 L32,21.5 L22.5,21.5 Z M17.5,15 L5,15 L5,17.5 L17.5,17.5 L17.5,15 Z M10,20 L5,20 L5,22.5 L10,22.5 L10,20 Z"
        })
    }));
};
$6dfbc10bc3e37007$export$7166b2a50edce6b6.displayName = 'JVR.Copied';



var $acw62 = parcelRequire("acw62");
function $2658a5dcd48fa689$export$d7d2eefee820cb71() {
    var idRef = (0, $acw62.useRef)(null);
    if (idRef.current === null) idRef.current = 'custom-id-' + Math.random().toString(36).substr(2, 9);
    return idRef.current;
}



var $cb5251e8c69af62e$export$48a3f3ecb131f4ae = (props)=>{
    var _expands$expandKey;
    var { keyName: keyName, value: value, expandKey: expandKey = '', level: level, keys: keys = [], parentValue: parentValue } = props;
    var expands = (0, $c093f23d3087c556$export$97a82d47391dc38e)();
    var { objectSortKeys: objectSortKeys, indentWidth: indentWidth, collapsed: collapsed, shouldExpandNodeInitially: shouldExpandNodeInitially } = (0, $07cda60092545df8$export$6ccbb43953eebf8)();
    var defaultExpanded = typeof collapsed === 'boolean' ? collapsed : typeof collapsed === 'number' ? level > collapsed : false;
    var isExpanded = (_expands$expandKey = expands[expandKey]) != null ? _expands$expandKey : shouldExpandNodeInitially ? false : defaultExpanded;
    var shouldExpand = shouldExpandNodeInitially && shouldExpandNodeInitially(!isExpanded, {
        value: value,
        keys: keys,
        level: level,
        keyName: keyName,
        parentValue: parentValue
    });
    if (expands[expandKey] === undefined && !shouldExpand) return null;
    if (isExpanded) return null;
    var isMyArray = Array.isArray(value);
    // object
    var entries = isMyArray ? Object.entries(value).map((m)=>[
            Number(m[0]),
            m[1]
        ]) : Object.entries(value);
    if (objectSortKeys) entries = objectSortKeys === true ? entries.sort((_ref, _ref2)=>{
        var [a] = _ref;
        var [b] = _ref2;
        return typeof a === 'string' && typeof b === 'string' ? a.localeCompare(b) : 0;
    }) : entries.sort((_ref3, _ref4)=>{
        var [a, valA] = _ref3;
        var [b, valB] = _ref4;
        return typeof a === 'string' && typeof b === 'string' ? objectSortKeys(a, b, valA, valB) : 0;
    });
    var style = {
        borderLeft: 'var(--w-rjv-border-left-width, 1px) var(--w-rjv-line-style, solid) var(--w-rjv-line-color, #ebebeb)',
        paddingLeft: indentWidth,
        marginLeft: 6
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "w-rjv-wrap",
        style: style,
        children: entries.map((_ref5, idx)=>{
            var [key, val] = _ref5;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cb5251e8c69af62e$export$dae4a885c66898ba, {
                parentValue: value,
                keyName: key,
                keys: [
                    ...keys,
                    key
                ],
                value: val,
                level: level
            }, idx);
        })
    });
};
$cb5251e8c69af62e$export$48a3f3ecb131f4ae.displayName = 'JVR.KeyValues';
var $cb5251e8c69af62e$export$907ef63418ed8b7c = (props)=>{
    var { keyName: keyName, parentValue: parentValue, keys: keys, value: value } = props;
    var { highlightUpdates: highlightUpdates } = (0, $07cda60092545df8$export$6ccbb43953eebf8)();
    var isNumber = typeof keyName === 'number';
    var highlightContainer = (0, $acw62.useRef)(null);
    (0, $727dfec5650f7635$export$8fa04b7e8216bb21)({
        value: value,
        highlightUpdates: highlightUpdates,
        highlightContainer: highlightContainer
    });
    var compProps = {
        keyName: keyName,
        value: value,
        keys: keys,
        parentValue: parentValue
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                ref: highlightContainer,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$82b8d343c504672), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        isNumber: isNumber,
                        "data-placement": "left"
                    }, compProps)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6420d3a998dd8794$export$b712ced46791f3b), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, compProps, {
                        children: keyName
                    })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$82b8d343c504672), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        isNumber: isNumber,
                        "data-placement": "right"
                    }, compProps))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$e20ebb298016f6), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, compProps))
        ]
    });
};
$cb5251e8c69af62e$export$907ef63418ed8b7c.displayName = 'JVR.KayName';
var $cb5251e8c69af62e$export$dae4a885c66898ba = (props)=>{
    var { keyName: keyName, value: value, parentValue: parentValue, level: level = 0, keys: keys = [] } = props;
    var dispatch = (0, $2347e0dbc69acf4a$export$45c1a77b1d18c54)();
    var subkeyid = (0, $2658a5dcd48fa689$export$d7d2eefee820cb71)();
    var isMyArray = Array.isArray(value);
    var isMySet = value instanceof Set;
    var isMyMap = value instanceof Map;
    var isDate = value instanceof Date;
    var isUrl = value instanceof URL;
    var isMyObject = value && typeof value === 'object' && !isMyArray && !isMySet && !isMyMap && !isDate && !isUrl;
    var isNested = isMyObject || isMyArray || isMySet || isMyMap;
    if (isNested) {
        var myValue = isMySet ? Array.from(value) : isMyMap ? Object.fromEntries(value) : value;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fce8446fb9318b9$export$42a852a2b6b56249), {
            keyName: keyName,
            value: myValue,
            parentValue: parentValue,
            initialValue: value,
            keys: keys,
            level: level + 1
        });
    }
    var reset = {
        onMouseEnter: ()=>dispatch({
                [subkeyid]: true
            }),
        onMouseLeave: ()=>dispatch({
                [subkeyid]: false
            })
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ff0c20dd77024464$export$8af35ed184dd0113), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: "w-rjv-line",
        value: value,
        keyName: keyName,
        keys: keys,
        parentValue: parentValue
    }, reset, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cb5251e8c69af62e$export$907ef63418ed8b7c, {
                keyName: keyName,
                value: value,
                keys: keys,
                parentValue: parentValue
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b662e58338bd48f9$export$4c8d1a57a761ef94), {
                keyName: keyName,
                value: value,
                keys: keys
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dfbc10bc3e37007$export$7166b2a50edce6b6), {
                keyName: keyName,
                value: value,
                keys: keys,
                parentValue: parentValue,
                expandKey: subkeyid
            })
        ]
    }));
};
$cb5251e8c69af62e$export$dae4a885c66898ba.displayName = 'JVR.KeyValuesItem';










var $85113ac23e143c3e$var$_excluded = [
    "value",
    "keyName"
], $85113ac23e143c3e$var$_excluded2 = [
    "as",
    "render"
];
var $85113ac23e143c3e$export$b788e6d3fbc4251d = (props)=>{
    var { CountInfoExtra: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    (0, $d7faa034b23d79cc$export$7abe9c32505c6519)(Comp, props, 'CountInfoExtra');
    return null;
};
$85113ac23e143c3e$export$b788e6d3fbc4251d.displayName = 'JVR.CountInfoExtra';
var $85113ac23e143c3e$export$e31b64e69b92ebcd = (props)=>{
    var { value: value = {}, keyName: keyName } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $85113ac23e143c3e$var$_excluded);
    var { CountInfoExtra: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $85113ac23e143c3e$var$_excluded2);
    if (!render && !reset.children) return null;
    var Elm = as || 'span';
    var isRender = render && typeof render === 'function';
    var elmProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, other);
    var child = isRender && render(elmProps, {
        value: value,
        keyName: keyName
    });
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, elmProps));
};
$85113ac23e143c3e$export$e31b64e69b92ebcd.displayName = 'JVR.CountInfoExtraComps';








var $b2a24ad9c194d5b4$var$_excluded = [
    "value",
    "keyName"
], $b2a24ad9c194d5b4$var$_excluded2 = [
    "as",
    "render"
];
var $b2a24ad9c194d5b4$export$66efb521e2914e9e = (props)=>{
    var { CountInfo: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    (0, $d7faa034b23d79cc$export$7abe9c32505c6519)(Comp, props, 'CountInfo');
    return null;
};
$b2a24ad9c194d5b4$export$66efb521e2914e9e.displayName = 'JVR.CountInfo';
var $b2a24ad9c194d5b4$export$18caac8d456e26b4 = (props)=>{
    var { value: value = {}, keyName: keyName } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $b2a24ad9c194d5b4$var$_excluded);
    var { displayObjectSize: displayObjectSize } = (0, $07cda60092545df8$export$6ccbb43953eebf8)();
    var { CountInfo: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    if (!displayObjectSize) return null;
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $b2a24ad9c194d5b4$var$_excluded2);
    var Elm = as || 'span';
    reset.style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset.style, props.style);
    var len = Object.keys(value).length;
    if (!reset.children) reset.children = len + " item" + (len === 1 ? '' : 's');
    var elmProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, other);
    var isRender = render && typeof render === 'function';
    var child = isRender && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, elmProps, {
        'data-length': len
    }), {
        value: value,
        keyName: keyName
    });
    if (child) return child;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, elmProps));
};
$b2a24ad9c194d5b4$export$18caac8d456e26b4.displayName = 'JVR.CountInfoComp';








var $77e39edcec7c499d$var$_excluded = [
    "as",
    "render"
];
var $77e39edcec7c499d$export$1297970233533a7d = (props)=>{
    var { Ellipsis: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    (0, $d7faa034b23d79cc$export$7abe9c32505c6519)(Comp, props, 'Ellipsis');
    return null;
};
$77e39edcec7c499d$export$1297970233533a7d.displayName = 'JVR.Ellipsis';
var $77e39edcec7c499d$export$896e950e33021b61 = (_ref)=>{
    var { isExpanded: isExpanded, value: value, keyName: keyName } = _ref;
    var { Ellipsis: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    var { as: as, render: render } = Comp, reset = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(Comp, $77e39edcec7c499d$var$_excluded);
    var Elm = as || 'span';
    var child = render && typeof render === 'function' && render((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        'data-expanded': isExpanded
    }), {
        value: value,
        keyName: keyName
    });
    if (child) return child;
    if (!isExpanded || typeof value === 'object' && Object.keys(value).length == 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Elm, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset));
};
$77e39edcec7c499d$export$896e950e33021b61.displayName = 'JVR.EllipsisComp';




var $533cc919321ad9e7$export$c74add035bc16ab4 = (props)=>{
    var _expands$expandKey;
    var { keyName: keyName, expandKey: expandKey, keys: keys = [], initialValue: initialValue, value: value, parentValue: parentValue, level: level } = props;
    var expands = (0, $c093f23d3087c556$export$97a82d47391dc38e)();
    var dispatchExpands = (0, $c093f23d3087c556$export$488088d69da562f3)();
    var { onExpand: onExpand, collapsed: collapsed, shouldExpandNodeInitially: shouldExpandNodeInitially } = (0, $07cda60092545df8$export$6ccbb43953eebf8)();
    var defaultExpanded = typeof collapsed === 'boolean' ? collapsed : typeof collapsed === 'number' ? level > collapsed : false;
    var isExpanded = (_expands$expandKey = expands[expandKey]) != null ? _expands$expandKey : shouldExpandNodeInitially ? false : defaultExpanded;
    var shouldExpand = shouldExpandNodeInitially && shouldExpandNodeInitially(!isExpanded, {
        value: value,
        keys: keys,
        level: level,
        keyName: keyName,
        parentValue: parentValue
    });
    if (expands[expandKey] === undefined && shouldExpandNodeInitially) isExpanded = !shouldExpand;
    var click = ()=>{
        var opt = {
            expand: !isExpanded,
            value: value,
            keyid: expandKey,
            keyName: keyName
        };
        onExpand && onExpand(opt);
        dispatchExpands({
            [expandKey]: opt.expand
        });
    };
    var style = {
        display: 'inline-flex',
        alignItems: 'center'
    };
    var arrowStyle = {
        transform: "rotate(" + (!isExpanded ? '0' : '-90') + "deg)",
        transition: 'all 0.3s'
    };
    var len = Object.keys(value).length;
    var isObject = typeof value === 'object';
    var isArray = Array.isArray(value);
    var isMySet = value instanceof Set;
    var showArrow = len !== 0 && (isArray || isMySet || isObject);
    var reset = {
        style: style
    };
    if (showArrow) reset.onClick = click;
    var compProps = {
        keyName: keyName,
        value: value,
        keys: keys,
        parentValue: parentValue
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, reset, {
        children: [
            showArrow && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$21b07c8f274aebd5), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                style: arrowStyle,
                expandKey: expandKey
            }, compProps)),
            (keyName || typeof keyName === 'number') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb5251e8c69af62e$export$907ef63418ed8b7c), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, compProps)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$28e541733e48be77), {
                value: initialValue,
                keyName: keyName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cde5e87cebf7704d$export$94e12a7a0342154f), {
                value: initialValue,
                keyName: keyName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$dda5939892ac6def), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                isBrackets: isArray || isMySet
            }, compProps)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $77e39edcec7c499d$export$896e950e33021b61), {
                keyName: keyName,
                value: value,
                isExpanded: isExpanded
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $981c3e4d841969e7$export$b8ad950cc15c1779), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                isVisiable: isExpanded || !showArrow,
                isBrackets: isArray || isMySet
            }, compProps)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b2a24ad9c194d5b4$export$18caac8d456e26b4), {
                value: value,
                keyName: keyName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $85113ac23e143c3e$export$e31b64e69b92ebcd), {
                value: value,
                keyName: keyName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6dfbc10bc3e37007$export$7166b2a50edce6b6), {
                keyName: keyName,
                value: value,
                expandKey: expandKey,
                parentValue: parentValue,
                keys: keys
            })
        ]
    }));
};
$533cc919321ad9e7$export$c74add035bc16ab4.displayName = 'JVR.NestedOpen';






var $2fce8446fb9318b9$var$_excluded = [
    "className",
    "children",
    "parentValue",
    "keyid",
    "level",
    "value",
    "initialValue",
    "keys",
    "keyName"
];
var $2fce8446fb9318b9$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { className: className = '', parentValue: parentValue, level: level = 1, value: value, initialValue: initialValue, keys: keys, keyName: keyName } = props, elmProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $2fce8446fb9318b9$var$_excluded);
    var dispatch = (0, $2347e0dbc69acf4a$export$45c1a77b1d18c54)();
    var subkeyid = (0, $2658a5dcd48fa689$export$d7d2eefee820cb71)();
    var defaultClassNames = [
        className,
        'w-rjv-inner'
    ].filter(Boolean).join(' ');
    var reset = {
        onMouseEnter: ()=>dispatch({
                [subkeyid]: true
            }),
        onMouseLeave: ()=>dispatch({
                [subkeyid]: false
            })
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: defaultClassNames,
        ref: ref
    }, elmProps, reset, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $533cc919321ad9e7$export$c74add035bc16ab4), {
                expandKey: subkeyid,
                value: value,
                level: level,
                keys: keys,
                parentValue: parentValue,
                keyName: keyName,
                initialValue: initialValue
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cb5251e8c69af62e$export$48a3f3ecb131f4ae), {
                expandKey: subkeyid,
                value: value,
                level: level,
                keys: keys,
                parentValue: parentValue,
                keyName: keyName
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $70c5a13b7c930dfc$export$11fd4f17364d5e5), {
                expandKey: subkeyid,
                value: value,
                level: level,
                keys: keys,
                parentValue: parentValue,
                keyName: keyName
            })
        ]
    }));
});
$2fce8446fb9318b9$export$42a852a2b6b56249.displayName = 'JVR.Container';




var $4ed432bc77dd0ff5$export$c523599699c4a3d8 = (props)=>{
    var { BraceLeft: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    (0, $d7faa034b23d79cc$export$13941268da83b68e)(Comp, props, 'BraceLeft');
    return null;
};
$4ed432bc77dd0ff5$export$c523599699c4a3d8.displayName = 'JVR.BraceLeft';




var $c96fb64dd221374b$export$86c0c4432fd6afbd = (props)=>{
    var { BraceRight: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    (0, $d7faa034b23d79cc$export$13941268da83b68e)(Comp, props, 'BraceRight');
    return null;
};
$c96fb64dd221374b$export$86c0c4432fd6afbd.displayName = 'JVR.BraceRight';




var $da874bbb7c189609$export$eb4957d7abe635f4 = (props)=>{
    var { BracketsLeft: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    (0, $d7faa034b23d79cc$export$13941268da83b68e)(Comp, props, 'BracketsLeft');
    return null;
};
$da874bbb7c189609$export$eb4957d7abe635f4.displayName = 'JVR.BracketsLeft';




var $4009f39c1054444f$export$24280a8f7da23431 = (props)=>{
    var { BracketsRight: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    (0, $d7faa034b23d79cc$export$13941268da83b68e)(Comp, props, 'BracketsRight');
    return null;
};
$4009f39c1054444f$export$24280a8f7da23431.displayName = 'JVR.BracketsRight';




var $af9fb1c5a6c4e8b7$export$21b07c8f274aebd5 = (props)=>{
    var { Arrow: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    (0, $d7faa034b23d79cc$export$13941268da83b68e)(Comp, props, 'Arrow');
    return null;
};
$af9fb1c5a6c4e8b7$export$21b07c8f274aebd5.displayName = 'JVR.Arrow';




var $81bf712119d05d3b$export$e20ebb298016f6 = (props)=>{
    var { Colon: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    (0, $d7faa034b23d79cc$export$13941268da83b68e)(Comp, props, 'Colon');
    return null;
};
$81bf712119d05d3b$export$e20ebb298016f6.displayName = 'JVR.Colon';




var $e9c033806de899ec$export$82b8d343c504672 = (props)=>{
    var { Quote: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    (0, $d7faa034b23d79cc$export$13941268da83b68e)(Comp, props, 'Quote');
    return null;
};
$e9c033806de899ec$export$82b8d343c504672.displayName = 'JVR.Quote';




var $f7083a1f5b066122$export$3371f364df92f618 = (props)=>{
    var { ValueQuote: Comp = {} } = (0, $e7871616579c98de$export$290c5145a07760ef)();
    (0, $d7faa034b23d79cc$export$13941268da83b68e)(Comp, props, 'ValueQuote');
    return null;
};
$f7083a1f5b066122$export$3371f364df92f618.displayName = 'JVR.ValueQuote';




var $f46525deac5c83d9$export$5a103dfb966183ca = (props)=>{
    var { Bigint: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Bigint');
    return null;
};
$f46525deac5c83d9$export$5a103dfb966183ca.displayName = 'JVR.Bigint';




var $15bde9fd81255299$export$6341f9a885713487 = (props)=>{
    var { Date: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Date');
    return null;
};
$15bde9fd81255299$export$6341f9a885713487.displayName = 'JVR.Date';




var $63b479f0cdc0b46e$export$5d3e9aafef2fffbe = (props)=>{
    var { False: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'False');
    return null;
};
$63b479f0cdc0b46e$export$5d3e9aafef2fffbe.displayName = 'JVR.False';




var $7ae36e5f72da0d68$export$bb89b76e902dbdb5 = (props)=>{
    var { Float: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Float');
    return null;
};
$7ae36e5f72da0d68$export$bb89b76e902dbdb5.displayName = 'JVR.Float';




var $2a6f8bbed098f7ba$export$fdd676b64b72b00 = (props)=>{
    var { Int: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Int');
    return null;
};
$2a6f8bbed098f7ba$export$fdd676b64b72b00.displayName = 'JVR.Int';




var $fb98257aebcc5764$export$a5c7b93649eaf8f8 = (props)=>{
    var { Map: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Map');
    return null;
};
$fb98257aebcc5764$export$a5c7b93649eaf8f8.displayName = 'JVR.Map';




var $20cc82e4b3a0803b$export$9b79cefd61e05165 = (props)=>{
    var { Nan: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Nan');
    return null;
};
$20cc82e4b3a0803b$export$9b79cefd61e05165.displayName = 'JVR.Nan';




var $36a160420784aec7$export$26c9c3a80cd996ae = (props)=>{
    var { Null: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Null');
    return null;
};
$36a160420784aec7$export$26c9c3a80cd996ae.displayName = 'JVR.Null';




var $a98e73f48d282f5e$export$bdf4ff5a442cbbc5 = (props)=>{
    var { Set: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Set');
    return null;
};
$a98e73f48d282f5e$export$bdf4ff5a442cbbc5.displayName = 'JVR.Set';




var $e4ca8b6652d26638$export$8c8db1bcd10ec036 = (props)=>{
    var { Str: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Str');
    return null;
};
$e4ca8b6652d26638$export$8c8db1bcd10ec036.displayName = 'JVR.StringText';




var $dd5bf377ea540068$export$4bc0976997a4d94e = (props)=>{
    var { True: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'True');
    return null;
};
$dd5bf377ea540068$export$4bc0976997a4d94e.displayName = 'JVR.True';




var $d6577c3af3211475$export$3bac393b8225adab = (props)=>{
    var { Undefined: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Undefined');
    return null;
};
$d6577c3af3211475$export$3bac393b8225adab.displayName = 'JVR.Undefined';




var $e8f65c8523ca4ddb$export$59d795186a5d3f58 = (props)=>{
    var { Url: Comp = {} } = (0, $956f81d65beafa24$export$e0a349f0eeda6e64)();
    (0, $d7faa034b23d79cc$export$f2df60bacb12ff60)(Comp, props, 'Url');
    return null;
};
$e8f65c8523ca4ddb$export$59d795186a5d3f58.displayName = 'JVR.Url';




var $df1832e5602eb549$export$7166b2a50edce6b6 = (props)=>{
    var { Copied: Comp = {} } = (0, $6977ed43d0c1c688$export$3dda1fbb9d1a8106)();
    (0, $d7faa034b23d79cc$export$7abe9c32505c6519)(Comp, props, 'Copied');
    return null;
};
$df1832e5602eb549$export$7166b2a50edce6b6.displayName = 'JVR.Copied';













var $9f6f8982f63abb9b$var$_excluded = [
    "className",
    "style",
    "value",
    "children",
    "collapsed",
    "shouldExpandNodeInitially",
    "indentWidth",
    "displayObjectSize",
    "shortenTextAfterLength",
    "stringEllipsis",
    "highlightUpdates",
    "enableClipboard",
    "displayDataTypes",
    "objectSortKeys",
    "onExpand",
    "onCopied",
    "beforeCopy"
];
var $9f6f8982f63abb9b$var$JsonView = /*#__PURE__*/ (0, $acw62.forwardRef)((props, ref)=>{
    var { className: className = '', style: style, value: value, children: children, collapsed: collapsed = false, shouldExpandNodeInitially: shouldExpandNodeInitially = ()=>true, indentWidth: indentWidth = 15, displayObjectSize: displayObjectSize = true, shortenTextAfterLength: shortenTextAfterLength = 30, stringEllipsis: stringEllipsis, highlightUpdates: highlightUpdates = true, enableClipboard: enableClipboard = true, displayDataTypes: displayDataTypes = true, objectSortKeys: objectSortKeys = false, onExpand: onExpand, onCopied: onCopied, beforeCopy: beforeCopy } = props, elmProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9f6f8982f63abb9b$var$_excluded);
    var defaultStyle = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        lineHeight: 1.4,
        fontFamily: 'var(--w-rjv-font-family, Menlo, monospace)',
        color: 'var(--w-rjv-color, #002b36)',
        backgroundColor: 'var(--w-rjv-background-color, #00000000)',
        fontSize: 13
    }, style);
    var cls = [
        'w-json-view-container',
        'w-rjv',
        className
    ].filter(Boolean).join(' ');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $07cda60092545df8$export$2881499e37b75b9a), {
        initialState: {
            value: value,
            objectSortKeys: objectSortKeys,
            indentWidth: indentWidth,
            shouldExpandNodeInitially: collapsed === false ? shouldExpandNodeInitially : ()=>false,
            displayObjectSize: displayObjectSize,
            collapsed: collapsed,
            enableClipboard: enableClipboard,
            shortenTextAfterLength: shortenTextAfterLength,
            stringEllipsis: stringEllipsis,
            highlightUpdates: highlightUpdates,
            onCopied: onCopied,
            onExpand: onExpand,
            beforeCopy: beforeCopy
        },
        initialTypes: {
            displayDataTypes: displayDataTypes
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fce8446fb9318b9$export$42a852a2b6b56249), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                value: value
            }, elmProps, {
                ref: ref,
                className: cls,
                style: defaultStyle
            })),
            children
        ]
    });
});
$9f6f8982f63abb9b$var$JsonView.Bigint = (0, $f46525deac5c83d9$export$5a103dfb966183ca);
$9f6f8982f63abb9b$var$JsonView.Date = (0, $15bde9fd81255299$export$6341f9a885713487);
$9f6f8982f63abb9b$var$JsonView.False = (0, $63b479f0cdc0b46e$export$5d3e9aafef2fffbe);
$9f6f8982f63abb9b$var$JsonView.Float = (0, $7ae36e5f72da0d68$export$bb89b76e902dbdb5);
$9f6f8982f63abb9b$var$JsonView.Int = (0, $2a6f8bbed098f7ba$export$fdd676b64b72b00);
$9f6f8982f63abb9b$var$JsonView.Map = (0, $fb98257aebcc5764$export$a5c7b93649eaf8f8);
$9f6f8982f63abb9b$var$JsonView.Nan = (0, $20cc82e4b3a0803b$export$9b79cefd61e05165);
$9f6f8982f63abb9b$var$JsonView.Null = (0, $36a160420784aec7$export$26c9c3a80cd996ae);
$9f6f8982f63abb9b$var$JsonView.Set = (0, $a98e73f48d282f5e$export$bdf4ff5a442cbbc5);
$9f6f8982f63abb9b$var$JsonView.String = (0, $e4ca8b6652d26638$export$8c8db1bcd10ec036);
$9f6f8982f63abb9b$var$JsonView.True = (0, $dd5bf377ea540068$export$4bc0976997a4d94e);
$9f6f8982f63abb9b$var$JsonView.Undefined = (0, $d6577c3af3211475$export$3bac393b8225adab);
$9f6f8982f63abb9b$var$JsonView.Url = (0, $e8f65c8523ca4ddb$export$59d795186a5d3f58);
$9f6f8982f63abb9b$var$JsonView.ValueQuote = (0, $f7083a1f5b066122$export$3371f364df92f618);
$9f6f8982f63abb9b$var$JsonView.Arrow = (0, $af9fb1c5a6c4e8b7$export$21b07c8f274aebd5);
$9f6f8982f63abb9b$var$JsonView.Colon = (0, $81bf712119d05d3b$export$e20ebb298016f6);
$9f6f8982f63abb9b$var$JsonView.Quote = (0, $e9c033806de899ec$export$82b8d343c504672);
$9f6f8982f63abb9b$var$JsonView.Ellipsis = (0, $77e39edcec7c499d$export$1297970233533a7d);
$9f6f8982f63abb9b$var$JsonView.BraceLeft = (0, $4ed432bc77dd0ff5$export$c523599699c4a3d8);
$9f6f8982f63abb9b$var$JsonView.BraceRight = (0, $c96fb64dd221374b$export$86c0c4432fd6afbd);
$9f6f8982f63abb9b$var$JsonView.BracketsLeft = (0, $da874bbb7c189609$export$eb4957d7abe635f4);
$9f6f8982f63abb9b$var$JsonView.BracketsRight = (0, $4009f39c1054444f$export$24280a8f7da23431);
$9f6f8982f63abb9b$var$JsonView.Copied = (0, $df1832e5602eb549$export$7166b2a50edce6b6);
$9f6f8982f63abb9b$var$JsonView.CountInfo = (0, $b2a24ad9c194d5b4$export$66efb521e2914e9e);
$9f6f8982f63abb9b$var$JsonView.CountInfoExtra = (0, $85113ac23e143c3e$export$b788e6d3fbc4251d);
$9f6f8982f63abb9b$var$JsonView.KeyName = (0, $6420d3a998dd8794$export$6f15ac9d8a016c94);
$9f6f8982f63abb9b$var$JsonView.Row = (0, $ff0c20dd77024464$export$b59bdbef9ce70de2);
$9f6f8982f63abb9b$var$JsonView.displayName = 'JVR.JsonView';
var $9f6f8982f63abb9b$export$2e2bcd8739ae039 = $9f6f8982f63abb9b$var$JsonView;


var $98d505a00bc654a2$export$3e936a8db52a10a0 = {
    '--w-rjv-font-family': 'monospace',
    '--w-rjv-color': '#0184a6',
    '--w-rjv-key-string': '#0184a6',
    '--w-rjv-background-color': '#202020',
    '--w-rjv-line-color': '#323232',
    '--w-rjv-arrow-color': 'var(--w-rjv-color)',
    '--w-rjv-edit-color': 'var(--w-rjv-color)',
    '--w-rjv-info-color': '#656565',
    '--w-rjv-update-color': '#ebcb8b',
    '--w-rjv-copied-color': '#0184a6',
    '--w-rjv-copied-success-color': '#28a745',
    '--w-rjv-curlybraces-color': '#1896b6',
    '--w-rjv-brackets-color': '#1896b6',
    '--w-rjv-quotes-color': 'var(--w-rjv-key-string)',
    '--w-rjv-quotes-string-color': 'var(--w-rjv-type-string-color)',
    '--w-rjv-type-string-color': '#cb4b16',
    '--w-rjv-type-int-color': '#268bd2',
    '--w-rjv-type-float-color': '#859900',
    '--w-rjv-type-bigint-color': '#268bd2',
    '--w-rjv-type-boolean-color': '#2aa198',
    '--w-rjv-type-date-color': '#586e75',
    '--w-rjv-type-url-color': '#649bd8',
    '--w-rjv-type-null-color': '#d33682',
    '--w-rjv-type-nan-color': '#076678',
    '--w-rjv-type-undefined-color': '#586e75'
};


const $f6b7d9384424390e$export$f686aa0f89bcde3b = ()=>{
    const { cqeScores: cqeScores } = (0, $ba66fc54ecff33a1$export$dba8ba4729e1fba8)();
    const scores = (0, $ba66fc54ecff33a1$export$2dccbe657ab23dc)(cqeScores);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
        heading: "Qualification",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            container: true,
            direction: "column",
            spacing: 6,
            children: [
                !scores.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        children: "No qualification scores available"
                    })
                }),
                (0, $f1q41.map)(scores, (score, index)=>{
                    const sourceData = (0, $f1q41.find)(score.sourceData, {
                        vendorName: score.vendor
                    });
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 2,
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                    sx: {
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        columnGap: '3rem',
                                        rowGap: '1.5rem'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Date"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: score.qualificationDate
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Time"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: score.qualificationTime
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Result"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: score.result === 'Accepted' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.success,
                                                        children: score.result
                                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.warning,
                                                        children: score.result
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Reason"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: score.reason || 'N/A'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Score"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: score.score || 'N/A'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Tier"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: score.tier || 'N/A'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Vendor"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                    children: score.vendor || 'N/A'
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                style: {
                                    maxWidth: '100%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Full Qualification Response"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f6f8982f63abb9b$export$2e2bcd8739ae039), {
                                        displayDataTypes: false,
                                        value: sourceData || score.sourceData,
                                        collapsed: 1,
                                        style: (0, $98d505a00bc654a2$export$3e936a8db52a10a0)
                                    })
                                ]
                            })
                        ]
                    }, index);
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");



"use client";
var $0953557707017bc5$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');





var $3QqPt = parcelRequire("3QqPt");

const $e69f7b626a0e7d77$export$beedd889d2c3df2f = (currentTier)=>{
    switch(currentTier){
        case (0, $3QqPt.QualificationTier).TIER_1:
        case (0, $3QqPt.QualificationTier).TIER_2:
        case (0, $3QqPt.QualificationTier).TIER_3:
        case (0, $3QqPt.QualificationTier).TIER_1_MANUAL:
        case (0, $3QqPt.QualificationTier).TIER_2_MANUAL:
        case (0, $3QqPt.QualificationTier).TIER_3_MANUAL:
            return (0, $ba66fc54ecff33a1$export$62bab6355639dfe).approved;
        case (0, $3QqPt.QualificationTier).DISQUALIFIED:
            return (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected;
        default:
            return (0, $ba66fc54ecff33a1$export$62bab6355639dfe).unchanged;
    }
};




const $804346d7295114d5$var$getFeedbackMessage = (decision)=>{
    if (decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).approved) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.success,
        children: `Qualification Result Updated Successfully: Approved ${new Date()}`
    });
    if (decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.info,
        children: `Qualification Result Updated Successfully: Rejected ${new Date()}`
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
};
const $804346d7295114d5$export$597ca2d8e7b20542 = ({ overrideQualification: overrideQualification, overrideQualificationSuccess: overrideQualificationSuccess, currentTier: currentTier, note: note, setNote: setNote, mostRecentNote: mostRecentNote, recalculateCustomerScores: recalculateCustomerScores, isAdmin: isAdmin, addNote: addNote, cqeScores: cqeScores, disqualificationVendor: disqualificationVendor, overrideDisqualificationVendor: overrideDisqualificationVendor, setOverrideDisqualificationVendor: setOverrideDisqualificationVendor })=>{
    const [decision, setDecision] = (0, $acw62.useState)((0, $e69f7b626a0e7d77$export$beedd889d2c3df2f)(currentTier));
    const [feedbackMessage, setFeedbackMessage] = (0, $acw62.useState)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {}));
    const showOverrideRejectionDropdown = decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected;
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    (0, $acw62.useEffect)(()=>{
        if (disqualificationVendor) {
            setDecision((0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected);
            setOverrideDisqualificationVendor(disqualificationVendor);
        }
    }, [
        disqualificationVendor
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    flexDirection: 'row',
                    marginTop: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'inline-flex',
                            columnGap: 4,
                            rowGap: 2,
                            flexWrap: 'wrap',
                            paddingLeft: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'inline-flex',
                                    flexDirection: 'column'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Qualification Result"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                        value: decision,
                                        onChange: (evt)=>{
                                            setFeedbackMessage(null);
                                            setDecision(evt.target.value);
                                            if (disqualificationVendor) setOverrideDisqualificationVendor(disqualificationVendor);
                                        },
                                        IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                disabled: true,
                                                value: (0, $ba66fc54ecff33a1$export$62bab6355639dfe).unchanged,
                                                children: "Select a Qualification Result"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $ba66fc54ecff33a1$export$62bab6355639dfe).approved,
                                                children: "Approve"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected,
                                                children: "Reject"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $ba66fc54ecff33a1$export$62bab6355639dfe).recalculate,
                                                children: "Repeat CQE"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            showOverrideRejectionDropdown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'inline-flex',
                                    flexDirection: 'column'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Rejection Used"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                        defaultValue: disqualificationVendor?.id,
                                        value: overrideDisqualificationVendor?.id,
                                        onChange: (evt)=>setOverrideDisqualificationVendor(cqeScores.find((score)=>score.id === evt.target.value)),
                                        IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                                        children: cqeScores?.map((score)=>{
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: score.id,
                                                children: score.vendorName
                                            }, score.id);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    flexDirection: 'column',
                                    width: '60%'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Notes"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                        value: note,
                                        onChange: (evt)=>setNote(evt.target.value),
                                        fullWidth: true,
                                        placeholder: "Add notes about this update",
                                        variant: "outlined"
                                    })
                                ]
                            })
                        ]
                    }),
                    showOverrideRejectionDropdown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "caption",
                                children: "Reason Codes"
                            }),
                            disqualificationVendor && !overrideDisqualificationVendor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
                                sx: {
                                    listStyleType: 'disc',
                                    pl: 2,
                                    '& .MuiListItem-root': {
                                        display: 'list-item'
                                    }
                                },
                                children: disqualificationVendor.disqualifiedReasonsList.map((reason, index)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                                        children: reason
                                    }, index);
                                })
                            }),
                            overrideDisqualificationVendor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
                                sx: {
                                    listStyleType: 'disc',
                                    pl: 2,
                                    '& .MuiListItem-root': {
                                        display: 'list-item'
                                    }
                                },
                                children: overrideDisqualificationVendor.disqualifiedReasonsList.map((reason, index)=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                                        children: reason
                                    }, index);
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                children: overrideQualificationSuccess && feedbackMessage
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'center'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'inline-flex',
                        flexDirection: 'column'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        disabled: !isAdmin || !decision && note === mostRecentNote,
                        onClick: ()=>{
                            if (decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).approved || decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected) overrideQualification({
                                note: note,
                                decision: decision
                            }).then(()=>{
                                setFeedbackMessage($804346d7295114d5$var$getFeedbackMessage(decision));
                                setDecision((0, $ba66fc54ecff33a1$export$62bab6355639dfe).unchanged);
                            });
                            else if (decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).recalculate) recalculateCustomerScores();
                            if (note) addNote();
                        },
                        variant: "contained",
                        color: "primary",
                        sx: {
                            backgroundColor: themeColors.buttonColor,
                            color: currentTheme === 'galpin' ? 'black' : 'white',
                            '&:hover': {
                                backgroundColor: themeColors.buttonHover
                            }
                        },
                        children: "Update"
                    })
                })
            })
        ]
    });
};





parcelRequire("acw62");
const $154ed310eb944a43$export$8f79f7e8574c1588 = ({ make: make, model: model, colorPreference: colorPreference, vin: vin, mileage: mileage, dateListed: dateListed, trim: trim })=>{
    const formatDateListed = dateListed ? (0, $303ba10db2c74ab4$export$d9468344d3651243)(new Date(dateListed), 'MM/dd/yy') : 'N/A';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex',
            flexWrap: 'wrap',
            columnGap: '3rem',
            rowGap: '1.5rem'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Make/Model"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: make ? `${make}/${model}` : 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Trim"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: trim || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Miles"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: mileage || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Color Preference"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: colorPreference || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Date Listed"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: formatDateListed
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "VIN"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: vin || 'N/A'
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");




parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");











function $95ecb421de4cff36$export$bc8a6ea1eb17d7c6(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiLinearProgress', slot);
}
const $95ecb421de4cff36$var$linearProgressClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiLinearProgress', [
    'root',
    'colorPrimary',
    'colorSecondary',
    'determinate',
    'indeterminate',
    'buffer',
    'query',
    'dashed',
    'dashedColorPrimary',
    'dashedColorSecondary',
    'bar',
    'bar1',
    'bar2',
    'barColorPrimary',
    'barColorSecondary',
    'bar1Indeterminate',
    'bar1Determinate',
    'bar1Buffer',
    'bar2Indeterminate',
    'bar2Buffer'
]);
var $95ecb421de4cff36$export$2e2bcd8739ae039 = $95ecb421de4cff36$var$linearProgressClasses;



'use client';
const $87e33f68a58c76cf$var$TRANSITION_DURATION = 4; // seconds
const $87e33f68a58c76cf$var$indeterminate1Keyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $87e33f68a58c76cf$var$indeterminate1Animation = typeof $87e33f68a58c76cf$var$indeterminate1Keyframe !== 'string' ? (0, $63d46a01db878c10$export$dbf350e5966cf602)`
        animation: ${$87e33f68a58c76cf$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
      ` : null;
const $87e33f68a58c76cf$var$indeterminate2Keyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`;
const $87e33f68a58c76cf$var$indeterminate2Animation = typeof $87e33f68a58c76cf$var$indeterminate2Keyframe !== 'string' ? (0, $63d46a01db878c10$export$dbf350e5966cf602)`
        animation: ${$87e33f68a58c76cf$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
      ` : null;
const $87e33f68a58c76cf$var$bufferKeyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`;
const $87e33f68a58c76cf$var$bufferAnimation = typeof $87e33f68a58c76cf$var$bufferKeyframe !== 'string' ? (0, $63d46a01db878c10$export$dbf350e5966cf602)`
        animation: ${$87e33f68a58c76cf$var$bufferKeyframe} 3s infinite linear;
      ` : null;
const $87e33f68a58c76cf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            variant
        ],
        dashed: [
            'dashed',
            `dashedColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
        ],
        bar1: [
            'bar',
            'bar1',
            `barColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate',
            variant === 'determinate' && 'bar1Determinate',
            variant === 'buffer' && 'bar1Buffer'
        ],
        bar2: [
            'bar',
            'bar2',
            variant !== 'buffer' && `barColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            variant === 'buffer' && `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate',
            variant === 'buffer' && 'bar2Buffer'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $95ecb421de4cff36$export$bc8a6ea1eb17d7c6), classes);
};
const $87e33f68a58c76cf$var$getColorShade = (theme, color)=>{
    if (theme.vars) return theme.vars.palette.LinearProgress[`${color}Bg`];
    return theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.5);
};
const $87e33f68a58c76cf$var$LinearProgressRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            styles[ownerState.variant]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        overflow: 'hidden',
        display: 'block',
        height: 4,
        // Fix Safari's bug during composition of different paint.
        zIndex: 0,
        '@media print': {
            colorAdjust: 'exact'
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: $87e33f68a58c76cf$var$getColorShade(theme, color)
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.color === 'inherit' && ownerState.variant !== 'buffer',
                style: {
                    '&::before': {
                        content: '""',
                        position: 'absolute',
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'currentColor',
                        opacity: 0.3
                    }
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    backgroundColor: 'transparent'
                }
            },
            {
                props: {
                    variant: 'query'
                },
                style: {
                    transform: 'rotate(180deg)'
                }
            }
        ]
    })));
const $87e33f68a58c76cf$var$LinearProgressDashed = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Dashed',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.dashed,
            styles[`dashedColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        marginTop: 0,
        height: '100%',
        width: '100%',
        backgroundSize: '10px 10px',
        backgroundPosition: '0 -23px',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3,
                    backgroundImage: `radial-gradient(currentColor 0%, currentColor 16%, transparent 42%)`
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>{
                const backgroundColor = $87e33f68a58c76cf$var$getColorShade(theme, color);
                return {
                    props: {
                        color: color
                    },
                    style: {
                        backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`
                    }
                };
            })
        ]
    })), $87e33f68a58c76cf$var$bufferAnimation || {
    // At runtime for Pigment CSS, `bufferAnimation` will be null and the generated keyframe will be used.
    animation: `${$87e33f68a58c76cf$var$bufferKeyframe} 3s infinite linear`
});
const $87e33f68a58c76cf$var$LinearProgressBar1 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar1',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar1,
            styles[`barColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate,
            ownerState.variant === 'determinate' && styles.bar1Determinate,
            ownerState.variant === 'buffer' && styles.bar1Buffer
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: {
                    variant: 'determinate'
                },
                style: {
                    transition: `transform .${$87e33f68a58c76cf$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: {
                    variant: 'buffer'
                },
                style: {
                    zIndex: 1,
                    transition: `transform .${$87e33f68a58c76cf$var$TRANSITION_DURATION}s linear`
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $87e33f68a58c76cf$var$indeterminate1Animation || {
                    animation: `${$87e33f68a58c76cf$var$indeterminate1Keyframe} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite`
                }
            }
        ]
    })));
const $87e33f68a58c76cf$var$LinearProgressBar2 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiLinearProgress',
    slot: 'Bar2',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.bar,
            styles.bar2,
            styles[`barColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate,
            ownerState.variant === 'buffer' && styles.bar2Buffer
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        width: '100%',
        position: 'absolute',
        left: 0,
        bottom: 0,
        top: 0,
        transition: 'transform 0.2s linear',
        transformOrigin: 'left',
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        '--LinearProgressBar2-barColor': (theme.vars || theme).palette[color].main
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color !== 'inherit',
                style: {
                    backgroundColor: 'var(--LinearProgressBar2-barColor, currentColor)'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant !== 'buffer' && ownerState.color === 'inherit',
                style: {
                    backgroundColor: 'currentColor'
                }
            },
            {
                props: {
                    color: 'inherit'
                },
                style: {
                    opacity: 0.3
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        variant: 'buffer'
                    },
                    style: {
                        backgroundColor: $87e33f68a58c76cf$var$getColorShade(theme, color),
                        transition: `transform .${$87e33f68a58c76cf$var$TRANSITION_DURATION}s linear`
                    }
                })),
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.variant === 'indeterminate' || ownerState.variant === 'query',
                style: $87e33f68a58c76cf$var$indeterminate2Animation || {
                    animation: `${$87e33f68a58c76cf$var$indeterminate2Keyframe} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite`
                }
            }
        ]
    })));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */ const $87e33f68a58c76cf$var$LinearProgress = /*#__PURE__*/ $acw62.forwardRef(function LinearProgress(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiLinearProgress'
    });
    const { className: className, color: color = 'primary', value: value, valueBuffer: valueBuffer, variant: variant = 'indeterminate', ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        variant: variant
    };
    const classes = $87e33f68a58c76cf$var$useUtilityClasses(ownerState);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const rootProps = {};
    const inlineStyles = {
        bar1: {},
        bar2: {}
    };
    if (variant === 'determinate' || variant === 'buffer') {
        if (value !== undefined) {
            rootProps['aria-valuenow'] = Math.round(value);
            rootProps['aria-valuemin'] = 0;
            rootProps['aria-valuemax'] = 100;
            let transform = value - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar1.transform = `translateX(${transform}%)`;
        }
    }
    if (variant === 'buffer') {
        if (valueBuffer !== undefined) {
            let transform = (valueBuffer || 0) - 100;
            if (isRtl) transform = -transform;
            inlineStyles.bar2.transform = `translateX(${transform}%)`;
        }
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($87e33f68a58c76cf$var$LinearProgressRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "progressbar",
        ...rootProps,
        ref: ref,
        ...other,
        children: [
            variant === 'buffer' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($87e33f68a58c76cf$var$LinearProgressDashed, {
                className: classes.dashed,
                ownerState: ownerState
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($87e33f68a58c76cf$var$LinearProgressBar1, {
                className: classes.bar1,
                ownerState: ownerState,
                style: inlineStyles.bar1
            }),
            variant === 'determinate' ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($87e33f68a58c76cf$var$LinearProgressBar2, {
                className: classes.bar2,
                ownerState: ownerState,
                style: inlineStyles.bar2
            })
        ]
    });
});
var $87e33f68a58c76cf$export$2e2bcd8739ae039 = $87e33f68a58c76cf$var$LinearProgress;



const $40544e870f97f0db$export$7fce389886c4768b = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            width: '100%'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87e33f68a58c76cf$export$2e2bcd8739ae039), {
            color: "secondary"
        })
    });



var $acw62 = parcelRequire("acw62");


var $3QqPt = parcelRequire("3QqPt");

var $f1q41 = parcelRequire("f1q41");


function $9ec6fed6833ce794$export$fec774b859aeb20(reservation) {
    const CUSTOM_PRICING_OPTION_ID = 'custom-input-pricing-option';
    const vehicleOptions = reservation?.vehicle;
    const { clientId: clientId } = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const [isEdit, setIsEdit] = (0, $acw62.useState)(false);
    const [isCustomPriceInput, setIsCustomPriceInputState] = (0, $acw62.useState)(false);
    const [monthlyPayment, setMonthly] = (0, $acw62.useState)(vehicleOptions.monthly);
    const [startFee, setStartFee] = (0, $acw62.useState)(vehicleOptions.startFee);
    const [selectedOption, setSelectedOption] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        setIsCustomPriceInputState(false);
        setMonthly(vehicleOptions.monthly);
        setStartFee(vehicleOptions.startFee);
    }, [
        vehicleOptions.monthly,
        vehicleOptions.startFee
    ]);
    const setIsCustomPriceInput = (isEnabled)=>{
        setIsCustomPriceInputState(isEnabled);
        if (isEnabled) {
            setSelectedOption({
                id: CUSTOM_PRICING_OPTION_ID
            });
            return;
        }
        setSelectedOption(null);
    };
    const { data: programOptions } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/programOptions',
            clientId
        ],
        queryFn: ()=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listProgramPricing(clientId);
        },
        placeholderData: {
            programsList: []
        },
        enabled: !!clientId
    });
    const handleChange = (e)=>{
        if (e.target.value === CUSTOM_PRICING_OPTION_ID) {
            setIsCustomPriceInput(true);
            return;
        }
        const selectedOption = (0, $f1q41.find)($9ec6fed6833ce794$export$f257fc13afe8d3f5(programOptions?.programsList, reservation?.programId), {
            id: e.target.value
        });
        if (!selectedOption) return;
        setIsCustomPriceInputState(false);
        setSelectedOption(selectedOption);
        setMonthly(selectedOption.monthlyRent || selectedOption.monthly);
        setStartFee(selectedOption.startFee);
    };
    const cancelChanges = ()=>{
        setIsEdit(false);
        setIsCustomPriceInputState(false);
        setSelectedOption(null);
        setMonthly(vehicleOptions.monthly);
        setStartFee(vehicleOptions.startFee);
    };
    const isValidSubscriptionStatus = (reservation)=>{
        return reservation.customer.activityState === (0, $3QqPt.ActivityState).SUBSCRIPTION_ACTIVATED || reservation.customer.activityState === (0, $3QqPt.ActivityState).SUBSCRIPTION_CANCELLED;
    };
    const savePricing = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            const hasValidCustomPricing = monthlyPayment > 0 && startFee >= 0;
            if (!selectedOption?.id && !isCustomPriceInput) return Promise.reject('Select a new pricing option or cancel');
            if (isCustomPriceInput && !hasValidCustomPricing) return Promise.reject('Enter a valid custom monthly payment and start fee');
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).UpdateProgramReservation({
                reservationId: reservation?.reservation.id,
                deposit: vehicleOptions?.deposit,
                color: reservation?.reservation?.color,
                // using model options object , in previous implimetation only model3 properties were used.
                secondaryColor: reservation?.reservation?.secondaryColor,
                startFee: startFee,
                monthlyRent: monthlyPayment,
                make: reservation?.reservation.make,
                model: reservation?.reservation.model,
                postal: reservation?.reservation?.postal,
                trackingId: reservation?.reservation?.id,
                programId: reservation?.programId
            });
        }
    });
    return {
        isEdit: isEdit,
        setIsEdit: setIsEdit,
        isCustomPriceInput: isCustomPriceInput,
        setIsCustomPriceInput: setIsCustomPriceInput,
        customPricingOptionId: CUSTOM_PRICING_OPTION_ID,
        monthlyPayment: monthlyPayment,
        setMonthly: setMonthly,
        startFee: startFee,
        setStartFee: setStartFee,
        handleChange: handleChange,
        cancelChanges: cancelChanges,
        savePricing: savePricing,
        isValidSubscriptionStatus: isValidSubscriptionStatus,
        programPricingOptions: $9ec6fed6833ce794$export$f257fc13afe8d3f5(programOptions?.programsList, reservation?.programId)
    };
}
function $9ec6fed6833ce794$export$f257fc13afe8d3f5(programOptions, programId) {
    if (!programOptions?.length || !programId) return [];
    const programOption = programOptions?.find((option)=>option?.id === programId);
    const pricingOptions = programOption?.pricingOptionsList[0]?.pricingOptionsList;
    return pricingOptions;
}



/**
 * @note Is this truly needed? Validation systems should be reviewed, inputs should handle minimum values in forms automatically.
 * @param value 
 * @returns 
 */ const $3fb5ab36eedcf141$export$8ff4a7c3470f3714 = (value)=>value > 0;


const $c21ede28b8496a52$var$currencyFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});
function $c21ede28b8496a52$export$4ead0eaee86eb5fb(value) {
    return $c21ede28b8496a52$var$currencyFormatter.format(value / 100);
}
function $c21ede28b8496a52$export$a17b3c2052469c69(amount) {
    const amountInDollars = $c21ede28b8496a52$export$4ead0eaee86eb5fb(amount);
    return `${amountInDollars}`;
}


// @TODO: Ideally put it this in a Section component, but will need to be adjusted a bit
const $56e17ea657bb7318$var$useStyles = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()((theme)=>{
    return {
        root: {
            margin: theme.spacing(2, 0, 4, 0),
            width: '100%'
        },
        body: {
            marginTop: 24,
            padding: theme.spacing(3),
            backgroundColor: theme.palette.primary.dark,
            borderRadius: 8
        },
        loader: {
            backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).lightBlue
        },
        termLength: {
            marginTop: 16
        }
    };
});
const $56e17ea657bb7318$export$bbcf1fe2cd8eca8b = ({ reservation: reservation, isAdmin: isAdmin, setReload: setReload })=>{
    const { classes: classes } = $56e17ea657bb7318$var$useStyles();
    const { isEdit: isEdit, setIsEdit: setIsEdit, customPricingOptionId: customPricingOptionId, isCustomPriceInput: isCustomPriceInput, monthlyPayment: monthlyPayment, setMonthly: setMonthly, startFee: startFee, setStartFee: setStartFee, handleChange: handleChange, cancelChanges: cancelChanges, savePricing: savePricing, isValidSubscriptionStatus: isValidSubscriptionStatus, programPricingOptions: programPricingOptions } = (0, $9ec6fed6833ce794$export$fec774b859aeb20)(reservation);
    const selectedPricingOption = programPricingOptions?.find((option)=>{
        return option.startFee === startFee && option.monthlyRent === monthlyPayment;
    });
    const selectedPricingOptionId = isCustomPriceInput ? customPricingOptionId : selectedPricingOption?.id || 'none';
    const isCustomOption = (option)=>option.id.startsWith('custom');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                size: {
                    xs: 12
                },
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h3",
                        children: "Program Pricing"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: [
                            !isEdit && !isValidSubscriptionStatus(reservation) && isAdmin && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                color: "primary",
                                onClick: ()=>setIsEdit(true),
                                children: "Edit"
                            }),
                            isEdit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    columnGap: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        color: "primary",
                                        onClick: ()=>{
                                            savePricing.reset();
                                            cancelChanges();
                                        },
                                        children: "Cancel"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                        variant: "contained",
                                        color: "primary",
                                        onClick: ()=>{
                                            savePricing.mutateAsync().then(()=>{
                                                setIsEdit(false);
                                                setReload();
                                            }).catch(()=>{
                                            // Error is visually shown
                                            });
                                        },
                                        disabled: !(0, $3fb5ab36eedcf141$export$8ff4a7c3470f3714)(monthlyPayment),
                                        children: "Save"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            savePricing.isPending && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $40544e870f97f0db$export$7fce389886c4768b), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                className: classes.body,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "column",
                    spacing: 1,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: !isValidSubscriptionStatus(reservation) && isAdmin && !isEdit && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: [
                                    "Select ",
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        children: "Edit"
                                    }),
                                    " to update this pricing."
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'inline-flex',
                                    flexDirection: 'column'
                                },
                                children: isEdit ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: [
                                                "Select ",
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                                    children: "new"
                                                }),
                                                " monthly payment and start fee (legacy pricing not shown)"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                            displayEmpty: true,
                                            id: "pricing-options-select",
                                            value: selectedPricingOptionId,
                                            label: "pricingOptions",
                                            onChange: (e)=>handleChange(e),
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                    disabled: true,
                                                    value: "none",
                                                    children: "Select a pricing option"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                    value: customPricingOptionId,
                                                    children: "Custom input pricing"
                                                }),
                                                programPricingOptions.map((option)=>{
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                        value: option.id,
                                                        children: [
                                                            `${(0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(option.monthlyRent)}/ mo and ${(0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(option.startFee)} / start fee`,
                                                            isCustomOption(option) ? ' (custom)' : ''
                                                        ]
                                                    }, option.id);
                                                })
                                            ]
                                        }),
                                        isCustomPriceInput && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                            container: true,
                                            spacing: 1,
                                            sx: {
                                                marginTop: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                                        type: "number",
                                                        label: "Monthly Rent",
                                                        value: monthlyPayment / 100,
                                                        onChange: (event)=>{
                                                            const dollars = Number(event.target.value);
                                                            if (Number.isNaN(dollars)) {
                                                                setMonthly(0);
                                                                return;
                                                            }
                                                            setMonthly(Math.round(dollars * 100));
                                                        },
                                                        slotProps: {
                                                            htmlInput: {
                                                                min: 0,
                                                                step: '0.01'
                                                            }
                                                        }
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                                        type: "number",
                                                        label: "Start Fee",
                                                        value: startFee / 100,
                                                        onChange: (event)=>{
                                                            const dollars = Number(event.target.value);
                                                            if (Number.isNaN(dollars)) {
                                                                setStartFee(0);
                                                                return;
                                                            }
                                                            setStartFee(Math.round(dollars * 100));
                                                        },
                                                        slotProps: {
                                                            htmlInput: {
                                                                min: 0,
                                                                step: '0.01'
                                                            }
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Monthly Payment and Start Fee"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: [
                                                ' ',
                                                (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(monthlyPayment),
                                                "/mo and",
                                                ' ',
                                                (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(startFee),
                                                " start fee"
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: [
                                savePricing.isSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.success,
                                    children: "Changes saved successfully"
                                }),
                                savePricing.isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.error,
                                    children: savePricing.error
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



var $f1q41 = parcelRequire("f1q41");



const $af3984dcab9b625b$export$1f6dee4e45145df4 = (props)=>{
    const [userType, setUserType] = (0, $acw62.useState)(0);
    const [reason, setReason] = (0, $acw62.useState)(0);
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        direction: "column",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    rowSpacing: 2,
                    columnSpacing: 6,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            size: {
                                lg: 3
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Cancel As"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                        value: userType,
                                        onChange: (evt)=>{
                                            setUserType(evt.target.value);
                                        },
                                        IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                                        children: (0, $f1q41.map)((0, $33cc3a71f154a56f$export$f2b746ac4bfe2404), (userType, index)=>{
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: userType.value,
                                                children: userType.label
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            size: {
                                lg: 3
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Cancel Reason"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                        value: reason,
                                        onChange: (evt)=>{
                                            setReason(evt.target.value);
                                        },
                                        IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $33cc3a71f154a56f$export$178d6c82845332d2).DEALER_VEHICLE_NOT_AVAILABLE.value,
                                                children: (0, $33cc3a71f154a56f$export$178d6c82845332d2).DEALER_VEHICLE_NOT_AVAILABLE.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $33cc3a71f154a56f$export$178d6c82845332d2).DEALER_VEHICLE_SELLING_PRICE_REJECTED.value,
                                                children: (0, $33cc3a71f154a56f$export$178d6c82845332d2).DEALER_VEHICLE_SELLING_PRICE_REJECTED.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $33cc3a71f154a56f$export$178d6c82845332d2).DEALER_VEHICLE_SOLD.value,
                                                children: (0, $33cc3a71f154a56f$export$178d6c82845332d2).DEALER_VEHICLE_SOLD.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $33cc3a71f154a56f$export$178d6c82845332d2).CUSTOMER_VEHICLE_TOO_EXPENSIVE.value,
                                                children: (0, $33cc3a71f154a56f$export$178d6c82845332d2).CUSTOMER_VEHICLE_TOO_EXPENSIVE.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $33cc3a71f154a56f$export$178d6c82845332d2).CUSTOMER_VEHICLE_DRIVE_NOT_AS_EXPECTED.value,
                                                children: (0, $33cc3a71f154a56f$export$178d6c82845332d2).CUSTOMER_VEHICLE_DRIVE_NOT_AS_EXPECTED.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $33cc3a71f154a56f$export$178d6c82845332d2).ANDROID_OS_UNSUPPORTED.value,
                                                children: (0, $33cc3a71f154a56f$export$178d6c82845332d2).ANDROID_OS_UNSUPPORTED.label
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                value: (0, $33cc3a71f154a56f$export$178d6c82845332d2).CUSTOMER_VEHICLE_DOES_NOT_WANT_VEHICLE.value,
                                                children: (0, $33cc3a71f154a56f$export$178d6c82845332d2).CUSTOMER_VEHICLE_DOES_NOT_WANT_VEHICLE.label
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        lg: 6
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: [
                            "By clicking ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "caption",
                                className: "bold",
                                children: "Cancel Order"
                            }),
                            ", the customer\u2019s order will be cancelled. Their security deposit, if paid, will be refunded. Please verify this is the correct action you\u2019d like to take."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                size: {
                    xs: 12
                },
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                variant: "contained",
                                disabled: props.isCancelled,
                                onClick: ()=>{
                                    props.cancelSubscription({
                                        actionReason: reason,
                                        userType: userType
                                    });
                                },
                                sx: {
                                    backgroundColor: themeColors.buttonColor,
                                    color: currentTheme === 'galpin' ? 'black' : 'white',
                                    '&:hover': {
                                        backgroundColor: themeColors.buttonHover
                                    }
                                },
                                children: "Cancel Order"
                            }),
                            props.isCancelled ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: "Order already cancelled"
                                })
                            }) : null
                        ]
                    }),
                    props.errorCancelling ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            children: props.errorCancelling.message
                        })
                    }) : null
                ]
            })
        ]
    });
};




var $3QqPt = parcelRequire("3QqPt");




parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");




function $1d73dff201b2cd5d$export$c2d9dbd5dc729937({ programId: programId, onClose: onClose, reservation: { color: color, secondaryColor: secondaryColor, reservationNumber: reservationNumber, id: reservationId, startFee: startFee, monthlyRent: monthlyRent }, postal: postal }) {
    const DEFAULT_PROGRAM_ID = '8c91f7f3-84db-4ee9-99af-4e7af3a09b6f';
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const [program, setSelectedProgram] = (0, $acw62.useState)(null);
    const [pricingId, setPricingId] = (0, $acw62.useState)('');
    const { clientId: clientId } = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const { data: programOptions, isLoading: isLoading } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/programOptions'
        ],
        queryFn: ()=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listProgramPricing(clientId);
        },
        placeholderData: {
            programsList: []
        }
    });
    const setProgram = (newProgramId)=>{
        const newProgram = (0, $f1q41.find)(programOptions.programsList, {
            id: newProgramId
        });
        setSelectedProgram(newProgram);
        setPricingId(newProgram.pricingOptionsList?.[0]?.id);
    };
    const { mutate: saveProgramSelection } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            const pricingOption = (0, $f1q41.find)((0, $9ec6fed6833ce794$export$f257fc13afe8d3f5)(programOptions?.programsList, program.id), {
                id: pricingId
            });
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).UpdateProgramReservation({
                reservationId: reservationId,
                deposit: pricingOption.deposit,
                startFee: pricingOption.startFee,
                monthlyRent: pricingOption.monthlyRent,
                color: color,
                secondaryColor: secondaryColor,
                make: program.make,
                model: program.model,
                postal: postal,
                trackingId: reservationNumber,
                programId: program.id
            }).then((res)=>{
                console.log('update program reservation', res);
                onClose();
            }).catch(onClose);
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    '/reservation',
                    reservationId
                ]
            });
        }
    });
    // TEMP - needed since program options might be cached initially
    (0, $acw62.useEffect)(()=>{
        if (programOptions) {
            const selectedProgram = (0, $f1q41.find)(programOptions.programsList, {
                id: program?.id || programId || DEFAULT_PROGRAM_ID
            });
            const pricingList = selectedProgram?.pricingOptionsList[0];
            const findPricing = (0, $f1q41.find)(pricingList?.pricingOptionsList, {
                monthlyRent: monthlyRent,
                startFee: startFee
            });
            if (findPricing) setPricingId(findPricing.id);
            setSelectedProgram(selectedProgram);
        }
    }, [
        programOptions
    ]);
    return {
        programs: programOptions,
        pricingId: pricingId,
        isLoading: isLoading,
        program: program,
        setProgram: setProgram,
        setPricingId: setPricingId,
        saveProgramSelection: saveProgramSelection,
        programPricingOptions: (0, $9ec6fed6833ce794$export$f257fc13afe8d3f5)(programOptions?.programsList, program?.id || programId || DEFAULT_PROGRAM_ID),
        DEFAULT_PROGRAM_ID: DEFAULT_PROGRAM_ID
    };
}



var $f1q41 = parcelRequire("f1q41");


const $d53cbb930fafe5f4$export$f7eacdcc8a20fc9d = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()((theme)=>{
    return {
        base: {
            backgroundColor: theme.palette.background.paper,
            padding: theme.spacing(6),
            color: theme.palette.text.primary,
            borderRadius: 8,
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: '75%',
            transform: 'translate(-50%, -50%)'
        },
        body: {
            marginTop: 24,
            padding: 24,
            alignContent: 'center',
            justifyContent: 'space-between',
            borderRadius: 10,
            backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue,
            marginBottom: 20
        },
        programSection: {
            display: 'flex',
            flexDirection: 'column'
        },
        disclaimer: {
            fontSize: 10,
            color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).lightGray,
            margin: '25px 0'
        }
    };
});



const $29492eb6bf2c8d13$export$32cfcb97eb24bd66 = ({ onClose: onClose, isOpen: isOpen, programId: programId, customerId: customerId, reservation: reservation, postal: postal })=>{
    const { classes: classes } = (0, $d53cbb930fafe5f4$export$f7eacdcc8a20fc9d)();
    const { programs: programs, program: program, pricingId: pricingId, setProgram: setProgram, setPricingId: setPricingId, saveProgramSelection: saveProgramSelection, isLoading: isLoading, programPricingOptions: programPricingOptions, DEFAULT_PROGRAM_ID: DEFAULT_PROGRAM_ID } = (0, $1d73dff201b2cd5d$export$c2d9dbd5dc729937)({
        reservation: reservation,
        programId: programId,
        customerId: customerId,
        onClose: onClose,
        postal: postal
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: !isLoading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            className: classes.base,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    size: {
                        xs: 12
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "h1",
                                children: "Switching Programs"
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                            style: {
                                flex: 1
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                color: "primary",
                                onClick: ()=>onClose(),
                                children: "Cancel"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    className: classes.body,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    className: classes.programSection,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Program Type"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                            value: program?.id || DEFAULT_PROGRAM_ID,
                                            label: "Program Type",
                                            onChange: (evt)=>setProgram(evt.target.value),
                                            children: (0, $f1q41.map)((0, $f1q41.sortBy)(programs?.programsList, 'description'), (programOption)=>{
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                    value: programOption.id,
                                                    children: programOption.description
                                                }, programOption.id);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    className: classes.programSection,
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Start Fee/Monthly Fee"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                            displayEmpty: true,
                                            label: "Start Fee/Monthly Fee",
                                            value: pricingId,
                                            onChange: (evt)=>setPricingId(evt.target.value),
                                            children: (0, $f1q41.map)(programPricingOptions, (pricingOption)=>{
                                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                    value: pricingOption.id,
                                                    children: [
                                                        (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(pricingOption.startFee),
                                                        " /",
                                                        (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(pricingOption.monthlyRent)
                                                    ]
                                                }, pricingOption.id);
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                className: classes.disclaimer,
                                children: "By clicking Confirm Program Change, the customer acknowledges that switching programs may change their start fee, monthly fee, how long the current price is active, and other various fees. The customer also acknowledges that they must go through the CQE approval process again to qualify for this particular program."
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            container: true,
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                color: "primary",
                                onClick: ()=>saveProgramSelection(),
                                children: "Confirm Program Change"
                            })
                        })
                    ]
                })
            ]
        })
    });
};



parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

const $f676e8498abab22d$export$83bfe2f5414ae1b2 = (accountNumber)=>{
    const [createAppointmentModalIsVisible, setCreateAppointmentModalIsVisible] = (0, $acw62.useState)(false);
    const { data: listAppointments, isLoading: isLoading } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/listAppointments',
            '/listAppointmentsByAccountNumber',
            accountNumber
        ],
        queryFn: ()=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listAppointmentsByAccountNumber(accountNumber).then((response)=>{
                return (0, $90fb957545aae5a4$export$ae61533abf9ec8a1)((0, $90fb957545aae5a4$export$7beaceb52de4cf0b)(response.appointmentDaysList));
            });
        }
    });
    function handleClose() {
        setCreateAppointmentModalIsVisible(false);
    }
    // check if all listed appointments are cancelled
    const noOpenAppointments = listAppointments?.every((listAppointments)=>listAppointments.appointments?.every((appointment)=>appointment.status === (0, $33cc3a71f154a56f$export$138aa6476b0a0a10).CANCELLED.value));
    const noListedAppointments = !(listAppointments && listAppointments.length > 0);
    return {
        listAppointments: listAppointments,
        noOpenAppointments: noOpenAppointments,
        noListedAppointments: noListedAppointments,
        isLoading: isLoading,
        createAppointmentModalIsVisible: createAppointmentModalIsVisible,
        setCreateAppointmentModalIsVisible: setCreateAppointmentModalIsVisible,
        handleClose: handleClose
    };
};



parcelRequire("acw62");







parcelRequire("acw62");




parcelRequire("acw62");


parcelRequire("acw62");


parcelRequire("acw62");



var $f1q41 = parcelRequire("f1q41");
const $d57c569ea6f82ef2$export$e05fc2ba4c750766 = ({ label: label, value: value, disabled: disabled = false, isEditing: isEditing, options: options, onChange: onChange })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "caption",
                children: label
            }),
            isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                value: value,
                displayEmpty: true,
                autoWidth: true,
                IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                onChange: (e)=>onChange(options.find((option)=>option.value === e.target.value)),
                name: label,
                disabled: disabled,
                className: "compactSelect",
                renderValue: (selected)=>{
                    const selectedOption = options.find((option)=>option.value === selected)?.label;
                    if ((0, $f1q41.isString)(selected)) return selected.length ? selectedOption : label;
                    return selected !== undefined ? selectedOption : label;
                },
                children: [
                    label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                        value: "",
                        disabled: true,
                        children: label
                    }),
                    options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                            value: option.value,
                            children: option.label
                        }, option.value))
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: options.find((option)=>option.value === value)?.label || 'N/A'
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");


function $b7b40115c69e5f0f$export$babeed77dd4c5122(date, disabledDates = [], openDays = [], value, minDate, maxDate) {
    const dateWithoutTime = new Date(date);
    dateWithoutTime.setHours(0, 0, 0, 0);
    // Disable dates falling outside of the allowed range
    if (!!minDate && dateWithoutTime.getTime() < minDate.getTime()) return true;
    if (!!maxDate && dateWithoutTime.getTime() > maxDate.getTime()) return true;
    // Disable date if it can be found in the array of disabled dates (unless it is the already selected date)
    const disabledDate = disabledDates.find((dd)=>dd.getTime() === dateWithoutTime.getTime());
    if (disabledDate) return disabledDate.getTime() !== value.getTime();
    // Disable if this day isn't an open day ( a regular closed day of the week )
    const day = dateWithoutTime.toLocaleDateString('en-US', {
        weekday: 'long'
    });
    if (openDays.length) return !(openDays.indexOf(day) !== -1);
    return false;
}



var $fcTGK = parcelRequire("fcTGK");



var $fcTGK = parcelRequire("fcTGK");

function $311229f5b11e8df8$export$5935c6a5ae23d43f(appointmentTypeConfigsList) {
    return appointmentTypeConfigsList.map(({ id: id, type: type, durationMinutes: durationMinutes, countPerSlot: countPerSlot })=>{
        return {
            id: id,
            type: type,
            typeLabel: (0, $90fb957545aae5a4$export$9259e371899a42d)((0, $90fb957545aae5a4$export$5afee16442bde5ee)((0, $fcTGK.AppointmentType), type)),
            durationMinutes: durationMinutes,
            countPerSlot: countPerSlot
        };
    });
}
function $311229f5b11e8df8$export$464270970e498347(dealershipUsers) {
    return dealershipUsers.map(({ id: id, dealershipId: dealershipId, firstName: firstName, lastName: lastName, cellPhone: cellPhone, ...dealershipUsers })=>{
        return {
            id: id,
            dealershipId: dealershipId,
            name: `${firstName} ${lastName}`,
            cell: cellPhone,
            ...dealershipUsers
        };
    });
}
function $311229f5b11e8df8$export$118f6f303872ba1a(dealershipList) {
    return dealershipList.map(({ id: id, name: name, ...dealershipList })=>{
        return {
            id: id,
            location: name,
            name: name,
            ...dealershipList
        };
    });
}
function $311229f5b11e8df8$export$40bc8795d0208795(appointmentTypeConfigsList) {
    return appointmentTypeConfigsList.map(({ id: id, type: type, countPerSlot: countPerSlot, durationMinutes: durationMinutes })=>{
        const appointmentTypeConfig = new (0, $fcTGK.AppointmentTypeConfig)();
        appointmentTypeConfig.setId(id);
        appointmentTypeConfig.setType(type);
        appointmentTypeConfig.setCountPerSlot(countPerSlot);
        appointmentTypeConfig.setDurationMinutes(durationMinutes);
        return appointmentTypeConfig;
    });
}





var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");


const $717acf5975a336d7$var$NXCRDealershipID = 'b1d68de5-0f55-4470-9030-a5d3d7b3d84b';
const $717acf5975a336d7$export$ed5c3368304694 = ()=>{
    const [createAppointmentModalIsVisible, setCreateAppointmentModalIsVisible] = (0, $acw62.useState)(false);
    const [{ dealershipId: dealershipId }, setQueryParams] = (0, $9963aa6f9102c92d$export$b37ee0d76c6d2fbc)({
        dealershipId: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$cc4e5467ec2866fa), $717acf5975a336d7$var$NXCRDealershipID)
    });
    const { data: dealershipOptions } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/listDealerships'
        ],
        queryFn: async ()=>{
            const dealershipResponse = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listDealerships();
            return $717acf5975a336d7$export$6a64b1d73f06441b(dealershipResponse);
        },
        placeholderData: []
    });
    const { data: appointments } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/listAppointments',
            '/listAppointmentsByAccountNumber',
            dealershipId
        ],
        queryFn: async ()=>{
            const response = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listAppointments({
                dealershipId: dealershipId
            });
            return (0, $90fb957545aae5a4$export$ae61533abf9ec8a1)((0, $90fb957545aae5a4$export$7beaceb52de4cf0b)(response.appointmentDaysList));
        }
    });
    const selectDealership = (dealershipId)=>{
        setQueryParams({
            dealershipId: dealershipId
        });
    };
    function handleClose() {
        setCreateAppointmentModalIsVisible(false);
    }
    return {
        dealershipOptions: dealershipOptions,
        dealershipId: dealershipId,
        appointments: appointments,
        selectDealership: selectDealership,
        createAppointmentModalIsVisible: createAppointmentModalIsVisible,
        setCreateAppointmentModalIsVisible: setCreateAppointmentModalIsVisible,
        handleClose: handleClose
    };
};
function $717acf5975a336d7$export$6a64b1d73f06441b(dealershipResponse) {
    return (0, $f1q41.map)(dealershipResponse.dealersList, (dealership)=>{
        return {
            label: dealership.name,
            value: dealership.id
        };
    });
}


const $4a65c9c5e5494742$export$da76e6c5514d04e3 = (appointment)=>{
    const { oktaAuth: oktaAuth, authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const [userInfo, setUserInfo] = (0, $acw62.useState)(undefined);
    const [dealershipId, setDealershipId] = (0, $acw62.useState)();
    const [eventTimesOptions, setEventTimesOptions] = (0, $acw62.useState)([]);
    const [dealershipUserOptions, setDealershipUserOptions] = (0, $acw62.useState)([]);
    const [disableEventTime, setDisableEventTime] = (0, $acw62.useState)(false);
    const { data: dealershipOptions } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/listDealerships'
        ],
        queryFn: async ()=>{
            const dealershipResponse = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listDealerships();
            return (0, $717acf5975a336d7$export$6a64b1d73f06441b)(dealershipResponse);
        },
        placeholderData: []
    });
    const { data: viewTeam } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/viewTeam',
            dealershipId
        ],
        queryFn: async ()=>{
            const response = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).viewTeam(dealershipId);
            return (0, $311229f5b11e8df8$export$464270970e498347)(response.dealershipTeamList);
        },
        enabled: Boolean(dealershipId)
    });
    // Handle viewTeam success - convert from onSuccess callback to useEffect
    (0, $acw62.useEffect)(()=>{
        if (viewTeam) setDealershipUserOptions(viewTeam.map(({ name: name, id: id })=>({
                label: name,
                value: id
            })));
    }, [
        viewTeam
    ]);
    /*
   * Minimum date is 'today', and the maximum selectable date
   * will be 21 days from the minDate, from 12:00 AM
   * */ const minDate = new Date();
    minDate.setHours(0);
    minDate.setMinutes(0);
    minDate.setSeconds(0);
    minDate.setMilliseconds(0);
    (0, $acw62.useEffect)(()=>{
        if (authState && authState.isAuthenticated) oktaAuth.getUser().then((user)=>{
            if (user) setUserInfo(user);
        });
    }, [
        oktaAuth,
        authState
    ]);
    (0, $acw62.useEffect)(()=>{
        setDealershipId(appointment.dealershipId);
    }, [
        appointment
    ]);
    (0, $acw62.useEffect)(()=>{
        setEventTimesOptions((0, $90fb957545aae5a4$export$ce26593672b242a5)(appointment.date.getTime()));
        const disable = (0, $b7b40115c69e5f0f$export$babeed77dd4c5122)(appointment.date, undefined, undefined, appointment.date, minDate);
        setDisableEventTime(disable);
    }, [
        appointment.date
    ]);
    const appointmentTypeOptions = Object.keys((0, $fcTGK.AppointmentType)).map((appointmentType)=>({
            label: (0, $90fb957545aae5a4$export$9259e371899a42d)(appointmentType),
            value: (0, $fcTGK.AppointmentType)[appointmentType]
        }));
    const appointmentStatusOptions = Object.keys((0, $fcTGK.AppointmentStatus)).map((appointmentStatus)=>({
            label: (0, $90fb957545aae5a4$export$9259e371899a42d)(appointmentStatus),
            value: (0, $fcTGK.AppointmentStatus)[appointmentStatus]
        }));
    const eventTimeLabel = `Event time ${(0, $90fb957545aae5a4$export$b1ca0d3383204cb9)(appointment.timeZone)}`;
    return {
        dealershipId: dealershipId,
        appointmentTypeOptions: appointmentTypeOptions,
        appointmentStatusOptions: appointmentStatusOptions,
        dealershipUserOptions: dealershipUserOptions,
        eventTimesOptions: eventTimesOptions,
        eventTimeLabel: eventTimeLabel,
        disableEventTime: disableEventTime,
        minDate: minDate,
        userInfo: userInfo,
        setDisableEventTime: setDisableEventTime,
        setDealershipId: setDealershipId,
        dealershipOptions: dealershipOptions,
        viewTeam: viewTeam
    };
};



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");





'use client';
function $90952e82d066041a$export$2e2bcd8739ae039({ props: props, name: name }) {
    return (0, $9f45a3834bb6880f$export$2e2bcd8739ae039)({
        props: props,
        name: name,
        defaultTheme: $a477e5500cafdc51$export$2e2bcd8739ae039,
        themeId: (0, $8b4c3f6e5c407120$export$2e2bcd8739ae039)
    });
}





var $acw62 = parcelRequire("acw62");
var $8da5bfbbed271cd7$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8da5bfbbed271cd7$var$ReactIs, $8da5bfbbed271cd7$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$8da5bfbbed271cd7$exports = (parcelRequire("hOzOt"))();




const $d29eef8283105e84$var$refType = (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
]);
var $d29eef8283105e84$export$2e2bcd8739ae039 = $d29eef8283105e84$var$refType;




const $38ae9feef3ab2fb0$export$f07872cd524bec98 = (views, expectedViews)=>{
    if (views.length !== expectedViews.length) return false;
    return expectedViews.every((expectedView)=>views.includes(expectedView));
};
const $38ae9feef3ab2fb0$export$bdf8d867ddc968e = ({ openTo: openTo, defaultOpenTo: defaultOpenTo, views: views, defaultViews: defaultViews })=>{
    const viewsWithDefault = views ?? defaultViews;
    let openToWithDefault;
    if (openTo != null) openToWithDefault = openTo;
    else if (viewsWithDefault.includes(defaultOpenTo)) openToWithDefault = defaultOpenTo;
    else if (viewsWithDefault.length > 0) openToWithDefault = viewsWithDefault[0];
    else throw new Error('MUI X: The `views` prop must contain at least one view.');
    return {
        views: viewsWithDefault,
        openTo: openToWithDefault
    };
};


const $b8d019f986eaf72a$export$a98b123b8f29e004 = (adapter, dateParam, timeParam)=>{
    let mergedDate = dateParam;
    mergedDate = adapter.setHours(mergedDate, adapter.getHours(timeParam));
    mergedDate = adapter.setMinutes(mergedDate, adapter.getMinutes(timeParam));
    mergedDate = adapter.setSeconds(mergedDate, adapter.getSeconds(timeParam));
    mergedDate = adapter.setMilliseconds(mergedDate, adapter.getMilliseconds(timeParam));
    return mergedDate;
};
const $b8d019f986eaf72a$export$ca1f317ae8db2ee8 = ({ date: date, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, isDateDisabled: isDateDisabled, adapter: adapter, timezone: timezone })=>{
    const today = $b8d019f986eaf72a$export$a98b123b8f29e004(adapter, adapter.date(undefined, timezone), date);
    if (disablePast && adapter.isBefore(minDate, today)) minDate = today;
    if (disableFuture && adapter.isAfter(maxDate, today)) maxDate = today;
    let forward = date;
    let backward = date;
    if (adapter.isBefore(date, minDate)) {
        forward = minDate;
        backward = null;
    }
    if (adapter.isAfter(date, maxDate)) {
        if (backward) backward = maxDate;
        forward = null;
    }
    while(forward || backward){
        if (forward && adapter.isAfter(forward, maxDate)) forward = null;
        if (backward && adapter.isBefore(backward, minDate)) backward = null;
        if (forward) {
            if (!isDateDisabled(forward)) return forward;
            forward = adapter.addDays(forward, 1);
        }
        if (backward) {
            if (!isDateDisabled(backward)) return backward;
            backward = adapter.addDays(backward, -1);
        }
    }
    return null;
};
const $b8d019f986eaf72a$export$36ca889e039badd5 = (adapter, value)=>!adapter.isValid(value) ? null : value;
const $b8d019f986eaf72a$export$eb73579ccade48fd = (adapter, value, defaultValue)=>{
    if (value == null || !adapter.isValid(value)) return defaultValue;
    return value;
};
const $b8d019f986eaf72a$export$8fabf9a4cbada414 = (adapter, a, b)=>{
    if (!adapter.isValid(a) && a != null && !adapter.isValid(b) && b != null) return true;
    return adapter.isEqual(a, b);
};
const $b8d019f986eaf72a$export$62591b96a734eacd = (adapter, year)=>{
    const firstMonth = adapter.startOfYear(year);
    const months = [
        firstMonth
    ];
    while(months.length < 12){
        const prevMonth = months[months.length - 1];
        months.push(adapter.addMonths(prevMonth, 1));
    }
    return months;
};
const $b8d019f986eaf72a$export$1118e4272ea1e258 = (adapter, timezone, valueType)=>valueType === 'date' ? adapter.startOfDay(adapter.date(undefined, timezone)) : adapter.date(undefined, timezone);
const $b8d019f986eaf72a$export$fae94c0a662107ef = (adapter, meridiem)=>{
    const date = adapter.setHours(adapter.date(), meridiem === 'am' ? 2 : 14);
    return adapter.format(date, 'meridiem');
};
const $b8d019f986eaf72a$export$76f4ff1fc64d3035 = [
    'year',
    'month',
    'day'
];
const $b8d019f986eaf72a$export$b32dfef9f07dea64 = (view)=>$b8d019f986eaf72a$export$76f4ff1fc64d3035.includes(view);
const $b8d019f986eaf72a$export$bb1c921f313ec928 = (adapter, { format: format, views: views }, isInToolbar)=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'year'
    ])) return formats.year;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'month'
    ])) return formats.month;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'day'
    ])) return formats.dayOfMonth;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'month',
        'year'
    ])) return `${formats.month} ${formats.year}`;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'day',
        'month'
    ])) return `${formats.month} ${formats.dayOfMonth}`;
    if (isInToolbar) // Little localization hack (Google is doing the same for android native pickers):
    // For english localization it is convenient to include weekday into the date "Mon, Jun 1".
    // For other locales using strings like "June 1", without weekday.
    return /en/.test(adapter.getCurrentLocaleCode()) ? formats.normalDateWithWeekday : formats.normalDate;
    return formats.keyboardDate;
};
const $b8d019f986eaf72a$export$24c38139da66592d = (adapter, date)=>{
    const start = adapter.startOfWeek(date);
    return [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ].map((diff)=>adapter.addDays(start, diff));
};



const $d83ac1c1cf9e346e$export$cf292de8b6883a7f = [
    'hours',
    'minutes',
    'seconds'
];
const $d83ac1c1cf9e346e$export$570ec1747e4b1938 = [
    'hours',
    'minutes',
    'seconds',
    'meridiem'
];
const $d83ac1c1cf9e346e$export$8f04d380cefd5a0d = (view)=>$d83ac1c1cf9e346e$export$cf292de8b6883a7f.includes(view);
const $d83ac1c1cf9e346e$export$a3328136ac50623d = (view)=>$d83ac1c1cf9e346e$export$570ec1747e4b1938.includes(view);
const $d83ac1c1cf9e346e$export$c3352ead7b032236 = (date, adapter)=>{
    if (!date) return null;
    return adapter.getHours(date) >= 12 ? 'pm' : 'am';
};
const $d83ac1c1cf9e346e$export$4159dc823695870e = (value, meridiem, ampm)=>{
    if (ampm) {
        const currentMeridiem = value >= 12 ? 'pm' : 'am';
        if (currentMeridiem !== meridiem) return meridiem === 'am' ? value - 12 : value + 12;
    }
    return value;
};
const $d83ac1c1cf9e346e$export$c368d4ff66779998 = (time, meridiem, ampm, adapter)=>{
    const newHoursAmount = $d83ac1c1cf9e346e$export$4159dc823695870e(adapter.getHours(time), meridiem, ampm);
    return adapter.setHours(time, newHoursAmount);
};
const $d83ac1c1cf9e346e$export$888a1ce13aa61986 = (date, adapter)=>{
    return adapter.getHours(date) * 3600 + adapter.getMinutes(date) * 60 + adapter.getSeconds(date);
};
const $d83ac1c1cf9e346e$export$fb87c80b35a46b89 = (disableIgnoringDatePartForTimeValidation, adapter)=>(dateLeft, dateRight)=>{
        if (disableIgnoringDatePartForTimeValidation) return adapter.isAfter(dateLeft, dateRight);
        return $d83ac1c1cf9e346e$export$888a1ce13aa61986(dateLeft, adapter) > $d83ac1c1cf9e346e$export$888a1ce13aa61986(dateRight, adapter);
    };
const $d83ac1c1cf9e346e$export$3a6776b3863772fe = (adapter, { format: format, views: views, ampm: ampm })=>{
    if (format != null) return format;
    const formats = adapter.formats;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'hours'
    ])) return ampm ? `${formats.hours12h} ${formats.meridiem}` : formats.hours24h;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'minutes'
    ])) return formats.minutes;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'seconds'
    ])) return formats.seconds;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'minutes',
        'seconds'
    ])) return `${formats.minutes}:${formats.seconds}`;
    if ((0, $38ae9feef3ab2fb0$export$f07872cd524bec98)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) return ampm ? `${formats.hours12h}:${formats.minutes}:${formats.seconds} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}:${formats.seconds}`;
    return ampm ? `${formats.hours12h}:${formats.minutes} ${formats.meridiem}` : `${formats.hours24h}:${formats.minutes}`;
};



const $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac = {
    year: 1,
    month: 2,
    day: 3,
    hours: 4,
    minutes: 5,
    seconds: 6,
    milliseconds: 7
};
const $66a7cb510b2c76f4$export$3f2547ddf892237a = (sections)=>Math.max(...sections.map((section)=>$66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac[section.type] ?? 1));
const $66a7cb510b2c76f4$var$roundDate = (adapter, granularity, date)=>{
    if (granularity === $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.year) return adapter.startOfYear(date);
    if (granularity === $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.month) return adapter.startOfMonth(date);
    if (granularity === $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.day) return adapter.startOfDay(date);
    // We don't have startOfHour / startOfMinute / startOfSecond
    let roundedDate = date;
    if (granularity < $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.minutes) roundedDate = adapter.setMinutes(roundedDate, 0);
    if (granularity < $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.seconds) roundedDate = adapter.setSeconds(roundedDate, 0);
    if (granularity < $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac.milliseconds) roundedDate = adapter.setMilliseconds(roundedDate, 0);
    return roundedDate;
};
const $66a7cb510b2c76f4$export$6a31d56794238e4e = ({ props: props, adapter: adapter, granularity: granularity, timezone: timezone, getTodayDate: inGetTodayDate })=>{
    let referenceDate = inGetTodayDate ? inGetTodayDate() : $66a7cb510b2c76f4$var$roundDate(adapter, granularity, (0, $b8d019f986eaf72a$export$1118e4272ea1e258)(adapter, timezone));
    if (props.minDate != null && adapter.isAfterDay(props.minDate, referenceDate)) referenceDate = $66a7cb510b2c76f4$var$roundDate(adapter, granularity, props.minDate);
    if (props.maxDate != null && adapter.isBeforeDay(props.maxDate, referenceDate)) referenceDate = $66a7cb510b2c76f4$var$roundDate(adapter, granularity, props.maxDate);
    const isAfter = (0, $d83ac1c1cf9e346e$export$fb87c80b35a46b89)(props.disableIgnoringDatePartForTimeValidation ?? false, adapter);
    if (props.minTime != null && isAfter(props.minTime, referenceDate)) referenceDate = $66a7cb510b2c76f4$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.minTime : (0, $b8d019f986eaf72a$export$a98b123b8f29e004)(adapter, referenceDate, props.minTime));
    if (props.maxTime != null && isAfter(referenceDate, props.maxTime)) referenceDate = $66a7cb510b2c76f4$var$roundDate(adapter, granularity, props.disableIgnoringDatePartForTimeValidation ? props.maxTime : (0, $b8d019f986eaf72a$export$a98b123b8f29e004)(adapter, referenceDate, props.maxTime));
    return referenceDate;
};



const $4a0e020deed3b4b7$export$2f3c5fac7a2a65f6 = (adapter, formatToken)=>{
    const config = adapter.formatTokenMap[formatToken];
    if (config == null) throw new Error([
        `MUI X: The token "${formatToken}" is not supported by the Date and Time Pickers.`,
        'Please try using another token or open an issue on https://github.com/mui/mui-x/issues/new/choose if you think it should be supported.'
    ].join('\n'));
    if (typeof config === 'string') return {
        type: config,
        contentType: config === 'meridiem' ? 'letter' : 'digit',
        maxLength: undefined
    };
    return {
        type: config.sectionType,
        contentType: config.contentType,
        maxLength: config.maxLength
    };
};
const $4a0e020deed3b4b7$export$c65c7173f879039f = (adapter, format)=>{
    const elements = [];
    const now = adapter.date(undefined, 'default');
    const startDate = adapter.startOfWeek(now);
    const endDate = adapter.endOfWeek(now);
    let current = startDate;
    while(adapter.isBefore(current, endDate)){
        elements.push(current);
        current = adapter.addDays(current, 1);
    }
    return elements.map((weekDay)=>adapter.formatByString(weekDay, format));
};
const $4a0e020deed3b4b7$export$3ee1e7e19c2b047a = (adapter, timezone, sectionType, format)=>{
    switch(sectionType){
        case 'month':
            return (0, $b8d019f986eaf72a$export$62591b96a734eacd)(adapter, adapter.date(undefined, timezone)).map((month)=>adapter.formatByString(month, format));
        case 'weekDay':
            return $4a0e020deed3b4b7$export$c65c7173f879039f(adapter, format);
        case 'meridiem':
            {
                const now = adapter.date(undefined, timezone);
                return [
                    adapter.startOfDay(now),
                    adapter.endOfDay(now)
                ].map((date)=>adapter.formatByString(date, format));
            }
        default:
            return [];
    }
};
const $4a0e020deed3b4b7$export$b918512475916205 = 's';
const $4a0e020deed3b4b7$var$NON_LOCALIZED_DIGITS = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9'
];
const $4a0e020deed3b4b7$export$b42be9ae7016ef5d = (adapter)=>{
    const today = adapter.date(undefined);
    const formattedZero = adapter.formatByString(adapter.setSeconds(today, 0), $4a0e020deed3b4b7$export$b918512475916205);
    if (formattedZero === '0') return $4a0e020deed3b4b7$var$NON_LOCALIZED_DIGITS;
    return Array.from({
        length: 10
    }).map((_, index)=>adapter.formatByString(adapter.setSeconds(today, index), $4a0e020deed3b4b7$export$b918512475916205));
};
const $4a0e020deed3b4b7$export$7dd321105a319e8 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    const digits = [];
    let currentFormattedDigit = '';
    for(let i = 0; i < valueStr.length; i += 1){
        currentFormattedDigit += valueStr[i];
        const matchingDigitIndex = localizedDigits.indexOf(currentFormattedDigit);
        if (matchingDigitIndex > -1) {
            digits.push(matchingDigitIndex.toString());
            currentFormattedDigit = '';
        }
    }
    return digits.join('');
};
const $4a0e020deed3b4b7$export$80dbbc19eba82070 = (valueStr, localizedDigits)=>{
    if (localizedDigits[0] === '0') return valueStr;
    return valueStr.split('').map((char)=>localizedDigits[Number(char)]).join('');
};
const $4a0e020deed3b4b7$export$c28be6c4c9d8f124 = (valueStr, localizedDigits)=>{
    const nonLocalizedValueStr = $4a0e020deed3b4b7$export$7dd321105a319e8(valueStr, localizedDigits);
    // `Number(' ')` returns `0` even if ' ' is not a valid number.
    return nonLocalizedValueStr !== ' ' && !Number.isNaN(Number(nonLocalizedValueStr));
};
const $4a0e020deed3b4b7$export$713c6d756c12fc27 = (valueStr, size)=>{
    // Remove the leading zeros and then add back as many as needed.
    return Number(valueStr).toString().padStart(size, '0');
};
const $4a0e020deed3b4b7$export$ef88db4bceade9fd = (adapter, value, sectionBoundaries, localizedDigits, section)=>{
    if (section.type === 'day' && section.contentType === 'digit-with-letter') {
        const date = adapter.setDate(sectionBoundaries.longestMonth, value);
        return adapter.formatByString(date, section.format);
    }
    // queryValue without leading `0` (`01` => `1`)
    let valueStr = value.toString();
    if (section.hasLeadingZerosInInput) valueStr = $4a0e020deed3b4b7$export$713c6d756c12fc27(valueStr, section.maxLength);
    return $4a0e020deed3b4b7$export$80dbbc19eba82070(valueStr, localizedDigits);
};
const $4a0e020deed3b4b7$export$85daa91f6c6e875f = (section, target, localizedDigits)=>{
    let value = section.value || section.placeholder;
    const hasLeadingZeros = target === 'non-input' ? section.hasLeadingZerosInFormat : section.hasLeadingZerosInInput;
    if (target === 'non-input' && section.hasLeadingZerosInInput && !section.hasLeadingZerosInFormat) value = Number($4a0e020deed3b4b7$export$7dd321105a319e8(value, localizedDigits)).toString();
    // In the input, we add an empty character at the end of each section without leading zeros.
    // This makes sure that `onChange` will always be fired.
    // Otherwise, when your input value equals `1/dd/yyyy` (format `M/DD/YYYY` on DayJs),
    // If you press `1`, on the first section, the new value is also `1/dd/yyyy`,
    // So the browser will not fire the input `onChange`.
    const shouldAddInvisibleSpace = [
        'input-rtl',
        'input-ltr'
    ].includes(target) && section.contentType === 'digit' && !hasLeadingZeros && value.length === 1;
    if (shouldAddInvisibleSpace) value = `${value}\u200e`;
    if (target === 'input-rtl') value = `\u2068${value}\u2069`;
    return value;
};
const $4a0e020deed3b4b7$export$2816862a602354ce = (adapter, valueStr, currentFormat, newFormat)=>{
    return adapter.formatByString(adapter.parse(valueStr, currentFormat), newFormat);
};
const $4a0e020deed3b4b7$var$isFourDigitYearFormat = (adapter, format)=>adapter.formatByString(adapter.date(undefined, 'system'), format).length === 4;
const $4a0e020deed3b4b7$export$78b5830e2dd2de49 = (adapter, contentType, sectionType, format)=>{
    if (contentType !== 'digit') return false;
    const now = adapter.date(undefined, 'default');
    switch(sectionType){
        // We can't use `changeSectionValueFormat`, because  `adapter.parse('1', 'YYYY')` returns `1971` instead of `1`.
        case 'year':
            // Remove once https://github.com/iamkun/dayjs/pull/2847 is merged and bump dayjs version
            if (adapter.lib === 'dayjs' && format === 'YY') return true;
            return adapter.formatByString(adapter.setYear(now, 1), format).startsWith('0');
        case 'month':
            return adapter.formatByString(adapter.startOfYear(now), format).length > 1;
        case 'day':
            return adapter.formatByString(adapter.startOfMonth(now), format).length > 1;
        case 'weekDay':
            return adapter.formatByString(adapter.startOfWeek(now), format).length > 1;
        case 'hours':
            return adapter.formatByString(adapter.setHours(now, 1), format).length > 1;
        case 'minutes':
            return adapter.formatByString(adapter.setMinutes(now, 1), format).length > 1;
        case 'seconds':
            return adapter.formatByString(adapter.setSeconds(now, 1), format).length > 1;
        default:
            throw new Error('Invalid section type');
    }
};
const $4a0e020deed3b4b7$export$b0c1bfd065bfe742 = (adapter, sections, localizedDigits)=>{
    // If we have both a day and a weekDay section,
    // Then we skip the weekDay in the parsing because libraries like dayjs can't parse complicated formats containing a weekDay.
    // dayjs(dayjs().format('dddd MMMM D YYYY'), 'dddd MMMM D YYYY')) // returns `Invalid Date` even if the format is valid.
    const shouldSkipWeekDays = sections.some((section)=>section.type === 'day');
    const sectionFormats = [];
    const sectionValues = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const shouldSkip = shouldSkipWeekDays && section.type === 'weekDay';
        if (!shouldSkip) {
            sectionFormats.push(section.format);
            sectionValues.push($4a0e020deed3b4b7$export$85daa91f6c6e875f(section, 'non-input', localizedDigits));
        }
    }
    const formatWithoutSeparator = sectionFormats.join(' ');
    const dateWithoutSeparatorStr = sectionValues.join(' ');
    return adapter.parse(dateWithoutSeparatorStr, formatWithoutSeparator);
};
const $4a0e020deed3b4b7$export$9e6af343db7dd2 = (sections)=>sections.map((section)=>{
        return `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`;
    }).join('');
const $4a0e020deed3b4b7$export$7ffdf006c6dc825f = (sections, localizedDigits, isRtl)=>{
    const formattedSections = sections.map((section)=>{
        const dateValue = $4a0e020deed3b4b7$export$85daa91f6c6e875f(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        return `${section.startSeparator}${dateValue}${section.endSeparator}`;
    });
    const dateStr = formattedSections.join('');
    if (!isRtl) return dateStr;
    // \u2066: start left-to-right isolation
    // \u2067: start right-to-left isolation
    // \u2068: start first strong character isolation
    // \u2069: pop isolation
    // wrap into an isolated group such that separators can split the string in smaller ones by adding \u2069\u2068
    return `\u2066${dateStr}\u2069`;
};
const $4a0e020deed3b4b7$export$360600f456ea7d5f = (adapter, localizedDigits, timezone)=>{
    const today = adapter.date(undefined, timezone);
    const endOfYear = adapter.endOfYear(today);
    const endOfDay = adapter.endOfDay(today);
    const { maxDaysInMonth: maxDaysInMonth, longestMonth: longestMonth } = (0, $b8d019f986eaf72a$export$62591b96a734eacd)(adapter, today).reduce((acc, month)=>{
        const daysInMonth = adapter.getDaysInMonth(month);
        if (daysInMonth > acc.maxDaysInMonth) return {
            maxDaysInMonth: daysInMonth,
            longestMonth: month
        };
        return acc;
    }, {
        maxDaysInMonth: 0,
        longestMonth: null
    });
    return {
        year: ({ format: format })=>({
                minimum: 0,
                maximum: $4a0e020deed3b4b7$var$isFourDigitYearFormat(adapter, format) ? 9999 : 99
            }),
        month: ()=>({
                minimum: 1,
                // Assumption: All years have the same amount of months
                maximum: adapter.getMonth(endOfYear) + 1
            }),
        day: ({ currentDate: currentDate })=>({
                minimum: 1,
                maximum: adapter.isValid(currentDate) ? adapter.getDaysInMonth(currentDate) : maxDaysInMonth,
                longestMonth: longestMonth
            }),
        weekDay: ({ format: format, contentType: contentType })=>{
            if (contentType === 'digit') {
                const daysInWeek = $4a0e020deed3b4b7$export$c65c7173f879039f(adapter, format).map(Number);
                return {
                    minimum: Math.min(...daysInWeek),
                    maximum: Math.max(...daysInWeek)
                };
            }
            return {
                minimum: 1,
                maximum: 7
            };
        },
        hours: ({ format: format })=>{
            const lastHourInDay = adapter.getHours(endOfDay);
            const hasMeridiem = $4a0e020deed3b4b7$export$7dd321105a319e8(adapter.formatByString(adapter.endOfDay(today), format), localizedDigits) !== lastHourInDay.toString();
            if (hasMeridiem) return {
                minimum: 1,
                maximum: Number($4a0e020deed3b4b7$export$7dd321105a319e8(adapter.formatByString(adapter.startOfDay(today), format), localizedDigits))
            };
            return {
                minimum: 0,
                maximum: lastHourInDay
            };
        },
        minutes: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of minutes
                maximum: adapter.getMinutes(endOfDay)
            }),
        seconds: ()=>({
                minimum: 0,
                // Assumption: All years have the same amount of seconds
                maximum: adapter.getSeconds(endOfDay)
            }),
        meridiem: ()=>({
                minimum: 0,
                maximum: 1
            }),
        empty: ()=>({
                minimum: 0,
                maximum: 0
            })
    };
};
let $4a0e020deed3b4b7$var$warnedOnceInvalidSection = false;
const $4a0e020deed3b4b7$export$ef6fbc09372bd65c = (sections, valueType)=>{};
const $4a0e020deed3b4b7$var$transferDateSectionValue = (adapter, section, dateToTransferFrom, dateToTransferTo)=>{
    switch(section.type){
        case 'year':
            return adapter.setYear(dateToTransferTo, adapter.getYear(dateToTransferFrom));
        case 'month':
            return adapter.setMonth(dateToTransferTo, adapter.getMonth(dateToTransferFrom));
        case 'weekDay':
            {
                let dayInWeekStrOfActiveDate = adapter.formatByString(dateToTransferFrom, section.format);
                if (section.hasLeadingZerosInInput) dayInWeekStrOfActiveDate = $4a0e020deed3b4b7$export$713c6d756c12fc27(dayInWeekStrOfActiveDate, section.maxLength);
                const formattedDaysInWeek = $4a0e020deed3b4b7$export$c65c7173f879039f(adapter, section.format);
                const dayInWeekOfActiveDate = formattedDaysInWeek.indexOf(dayInWeekStrOfActiveDate);
                const dayInWeekOfNewSectionValue = formattedDaysInWeek.indexOf(section.value);
                const diff = dayInWeekOfNewSectionValue - dayInWeekOfActiveDate;
                return adapter.addDays(dateToTransferFrom, diff);
            }
        case 'day':
            return adapter.setDate(dateToTransferTo, adapter.getDate(dateToTransferFrom));
        case 'meridiem':
            {
                const isAM = adapter.getHours(dateToTransferFrom) < 12;
                const mergedDateHours = adapter.getHours(dateToTransferTo);
                if (isAM && mergedDateHours >= 12) return adapter.addHours(dateToTransferTo, -12);
                if (!isAM && mergedDateHours < 12) return adapter.addHours(dateToTransferTo, 12);
                return dateToTransferTo;
            }
        case 'hours':
            return adapter.setHours(dateToTransferTo, adapter.getHours(dateToTransferFrom));
        case 'minutes':
            return adapter.setMinutes(dateToTransferTo, adapter.getMinutes(dateToTransferFrom));
        case 'seconds':
            return adapter.setSeconds(dateToTransferTo, adapter.getSeconds(dateToTransferFrom));
        default:
            return dateToTransferTo;
    }
};
const $4a0e020deed3b4b7$var$reliableSectionModificationOrder = {
    year: 1,
    month: 2,
    day: 3,
    weekDay: 4,
    hours: 5,
    minutes: 6,
    seconds: 7,
    meridiem: 8,
    empty: 9
};
const $4a0e020deed3b4b7$export$6c6df982c77f60a9 = (adapter, dateToTransferFrom, sections, referenceDate, shouldLimitToEditedSections)=>// cloning sections before sort to avoid mutating it
    [
        ...sections
    ].sort((a, b)=>$4a0e020deed3b4b7$var$reliableSectionModificationOrder[a.type] - $4a0e020deed3b4b7$var$reliableSectionModificationOrder[b.type]).reduce((mergedDate, section)=>{
        if (!shouldLimitToEditedSections || section.modified) return $4a0e020deed3b4b7$var$transferDateSectionValue(adapter, section, dateToTransferFrom, mergedDate);
        return mergedDate;
    }, referenceDate);
const $4a0e020deed3b4b7$export$a11b0059900ceec8 = ()=>navigator.userAgent.toLowerCase().includes('android');
const $4a0e020deed3b4b7$export$7725fd6fe0a2aadf = (sections, shouldApplyRTL)=>{
    const neighbors = {};
    if (!shouldApplyRTL) {
        sections.forEach((_, index)=>{
            const leftIndex = index === 0 ? null : index - 1;
            const rightIndex = index === sections.length - 1 ? null : index + 1;
            neighbors[index] = {
                leftIndex: leftIndex,
                rightIndex: rightIndex
            };
        });
        return {
            neighbors: neighbors,
            startIndex: 0,
            endIndex: sections.length - 1
        };
    }
    const rtl2ltr = {};
    const ltr2rtl = {};
    let groupedSectionsStart = 0;
    let groupedSectionsEnd = 0;
    let RTLIndex = sections.length - 1;
    while(RTLIndex >= 0){
        groupedSectionsEnd = sections.findIndex(// eslint-disable-next-line @typescript-eslint/no-loop-func
        (section, index)=>index >= groupedSectionsStart && section.endSeparator?.includes(' ') && // Special case where the spaces were not there in the initial input
            section.endSeparator !== ' / ');
        if (groupedSectionsEnd === -1) groupedSectionsEnd = sections.length - 1;
        for(let i = groupedSectionsEnd; i >= groupedSectionsStart; i -= 1){
            ltr2rtl[i] = RTLIndex;
            rtl2ltr[RTLIndex] = i;
            RTLIndex -= 1;
        }
        groupedSectionsStart = groupedSectionsEnd + 1;
    }
    sections.forEach((_, index)=>{
        const rtlIndex = ltr2rtl[index];
        const leftIndex = rtlIndex === 0 ? null : rtl2ltr[rtlIndex - 1];
        const rightIndex = rtlIndex === sections.length - 1 ? null : rtl2ltr[rtlIndex + 1];
        neighbors[index] = {
            leftIndex: leftIndex,
            rightIndex: rightIndex
        };
    });
    return {
        neighbors: neighbors,
        startIndex: rtl2ltr[0],
        endIndex: rtl2ltr[sections.length - 1]
    };
};
const $4a0e020deed3b4b7$export$b31f27a6e35a0b27 = (selectedSections, sections)=>{
    if (selectedSections == null) return null;
    if (selectedSections === 'all') return 'all';
    if (typeof selectedSections === 'string') {
        const index = sections.findIndex((section)=>section.type === selectedSections);
        return index === -1 ? null : index;
    }
    return selectedSections;
};


const $235c2ad72f19522e$var$_excluded = [
    "value",
    "referenceDate"
];
const $235c2ad72f19522e$export$2764b246aa3b75ba = {
    emptyValue: null,
    getTodayValue: (0, $b8d019f986eaf72a$export$1118e4272ea1e258),
    getInitialReferenceValue: (_ref)=>{
        let { value: value, referenceDate: referenceDate } = _ref, params = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $235c2ad72f19522e$var$_excluded);
        if (params.adapter.isValid(value)) return value;
        if (referenceDate != null) return referenceDate;
        return (0, $66a7cb510b2c76f4$export$6a31d56794238e4e)(params);
    },
    cleanValue: (0, $b8d019f986eaf72a$export$36ca889e039badd5),
    areValuesEqual: (0, $b8d019f986eaf72a$export$8fabf9a4cbada414),
    isSameError: (a, b)=>a === b,
    hasError: (error)=>error != null,
    defaultErrorState: null,
    getTimezone: (adapter, value)=>adapter.isValid(value) ? adapter.getTimezone(value) : null,
    setTimezone: (adapter, timezone, value)=>value == null ? null : adapter.setTimezone(value, timezone)
};
const $235c2ad72f19522e$export$b602c94f557316b4 = {
    updateReferenceValue: (adapter, value, prevReferenceValue)=>adapter.isValid(value) ? value : prevReferenceValue,
    getSectionsFromValue: (date, getSectionsFromDate)=>getSectionsFromDate(date),
    getV7HiddenInputValueFromSections: (0, $4a0e020deed3b4b7$export$9e6af343db7dd2),
    getV6InputValueFromSections: (0, $4a0e020deed3b4b7$export$7ffdf006c6dc825f),
    parseValueStr: (valueStr, referenceValue, parseDate)=>parseDate(valueStr.trim(), referenceValue),
    getDateFromSection: (value)=>value,
    getDateSectionsFromValue: (sections)=>sections,
    updateDateInValue: (value, activeSection, activeDate)=>activeDate,
    clearDateSections: (sections)=>sections.map((section)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, section, {
                value: ''
            }))
};




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");







function $cd064f23093812c7$export$b109c489973c3d80(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersToolbar', slot);
}
const $cd064f23093812c7$export$59f09e5e2b3d9913 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersToolbar', [
    'root',
    'title',
    'content'
]);




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



'use client';
const $b713746033a911a9$var$_excluded = [
    "localeText"
];
const $b713746033a911a9$export$41298298dbe382b = /*#__PURE__*/ $acw62.createContext(null);
const $b713746033a911a9$export$544976378534cf9 = $b713746033a911a9$export$41298298dbe382b;
const $b713746033a911a9$export$dc45bdc734ce6f1e = function LocalizationProvider(inProps) {
    const { localeText: inLocaleText } = inProps, otherInProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(inProps, $b713746033a911a9$var$_excluded);
    const { adapter: parentAdapter, localeText: parentLocaleText } = $acw62.useContext($b713746033a911a9$export$41298298dbe382b) ?? {
        utils: undefined,
        adapter: undefined,
        localeText: undefined
    };
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        // We don't want to pass the `localeText` prop to the theme, that way it will always return the theme value,
        // We will then merge this theme value with our value manually
        props: otherInProps,
        name: 'MuiLocalizationProvider'
    });
    const { children: children, dateAdapter: DateAdapter, dateFormats: dateFormats, dateLibInstance: dateLibInstance, adapterLocale: adapterLocale, localeText: themeLocaleText } = props;
    const localeText = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeLocaleText, parentLocaleText, inLocaleText), [
        themeLocaleText,
        parentLocaleText,
        inLocaleText
    ]);
    const adapter = $acw62.useMemo(()=>{
        if (!DateAdapter) {
            if (parentAdapter) return parentAdapter;
            return null;
        }
        const dateAdapter = new DateAdapter({
            locale: adapterLocale,
            formats: dateFormats,
            instance: dateLibInstance
        });
        if (!dateAdapter.isMUIAdapter) throw new Error([
            'MUI X: The date adapter should be imported from `@mui/x-date-pickers` or `@mui/x-date-pickers-pro`, not from `@date-io`',
            "For example, `import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'` instead of `import AdapterDayjs from '@date-io/dayjs'`",
            'More information on the installation documentation: https://mui.com/x/react-date-pickers/quickstart/#installation'
        ].join(`\n`));
        return dateAdapter;
    }, [
        DateAdapter,
        adapterLocale,
        dateFormats,
        dateLibInstance,
        parentAdapter
    ]);
    const defaultDates = $acw62.useMemo(()=>{
        if (!adapter) return null;
        return {
            minDate: adapter.date('1900-01-01T00:00:00.000'),
            maxDate: adapter.date('2099-12-31T00:00:00.000')
        };
    }, [
        adapter
    ]);
    const contextValue = $acw62.useMemo(()=>{
        return {
            utils: adapter,
            adapter: adapter,
            defaultDates: defaultDates,
            localeText: localeText
        };
    }, [
        defaultDates,
        adapter,
        localeText
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b713746033a911a9$export$41298298dbe382b.Provider, {
        value: contextValue,
        children: children
    });
};



var $acw62 = parcelRequire("acw62");
'use client';
const $bbd57edb25eace5e$export$5e8d511415c09dec = /*#__PURE__*/ $acw62.createContext(()=>true);
function $bbd57edb25eace5e$export$52df06af7329e367() {
    return $acw62.useContext($bbd57edb25eace5e$export$5e8d511415c09dec);
}



var $acw62 = parcelRequire("acw62");
'use client';
const $20b835eaf21df543$export$263a5df151942441 = /*#__PURE__*/ $acw62.createContext(null);
function $20b835eaf21df543$export$700ab01cf24fdb1() {
    return $acw62.useContext($20b835eaf21df543$export$263a5df151942441);
}



var $acw62 = parcelRequire("acw62");
'use client';
const $bc077554c64169c5$export$b72b8dade9393cd5 = /*#__PURE__*/ $acw62.createContext(null);
const $bc077554c64169c5$export$4495bebe53492ac8 = ()=>{
    const value = $acw62.useContext($bc077554c64169c5$export$b72b8dade9393cd5);
    if (value == null) throw new Error('MUI X: The `usePickerContext` hook can only be called inside the context of a Picker component');
    return value;
};



'use client';
const $c33c428cfda4b7d5$export$d1dfa4910c58a4e = /*#__PURE__*/ $acw62.createContext(null);
const $c33c428cfda4b7d5$export$3a79edaa4b9c6a3e = /*#__PURE__*/ $acw62.createContext({
    ownerState: {
        isPickerDisabled: false,
        isPickerReadOnly: false,
        isPickerValueEmpty: false,
        isPickerOpen: false,
        pickerVariant: 'desktop',
        pickerOrientation: 'portrait'
    },
    rootRefObject: {
        current: null
    },
    labelId: undefined,
    dismissViews: ()=>{},
    hasUIView: true,
    getCurrentViewMode: ()=>'UI',
    triggerElement: null,
    viewContainerRole: null,
    defaultActionBarActions: [],
    onPopperExited: undefined
});
function $c33c428cfda4b7d5$export$aae9fbe9dd4050fa(props) {
    const { contextValue: contextValue, actionsContextValue: actionsContextValue, privateContextValue: privateContextValue, fieldPrivateContextValue: fieldPrivateContextValue, isValidContextValue: isValidContextValue, localeText: localeText, children: children } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bc077554c64169c5$export$b72b8dade9393cd5).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c33c428cfda4b7d5$export$d1dfa4910c58a4e.Provider, {
            value: actionsContextValue,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c33c428cfda4b7d5$export$3a79edaa4b9c6a3e.Provider, {
                value: privateContextValue,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $20b835eaf21df543$export$263a5df151942441).Provider, {
                    value: fieldPrivateContextValue,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bbd57edb25eace5e$export$5e8d511415c09dec).Provider, {
                        value: isValidContextValue,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                            localeText: localeText,
                            children: children
                        })
                    })
                })
            })
        })
    });
}


'use client';
const $a4bd2cc29c71e7d6$export$ceff2e8b47408642 = ()=>$acw62.useContext((0, $c33c428cfda4b7d5$export$3a79edaa4b9c6a3e));


function $7488814d8bbee125$export$52d82af37dec73b2() {
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            toolbarDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        isRtl
    ]);
}



const $f3ba643fb3747006$var$_excluded = [
    "children",
    "className",
    "classes",
    "toolbarTitle",
    "hidden",
    "titleId",
    "classes",
    "landscapeDirection"
];
const $f3ba643fb3747006$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ],
        content: [
            'content'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $cd064f23093812c7$export$b109c489973c3d80), classes);
};
const $f3ba643fb3747006$var$PickersToolbarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Root'
})(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        padding: theme.spacing(2, 3),
        variants: [
            {
                props: {
                    pickerOrientation: 'landscape'
                },
                style: {
                    height: 'auto',
                    maxWidth: 160,
                    padding: 16,
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap'
                }
            }
        ]
    }));
const $f3ba643fb3747006$var$PickersToolbarContent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersToolbar',
    slot: 'Content',
    shouldForwardProp: (prop)=>(0, $9a7e913a82f46e5c$export$3ba67b570e26eea0)(prop) && prop !== 'landscapeDirection'
})({
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    flex: 1,
    justifyContent: 'space-between',
    alignItems: 'center',
    flexDirection: 'row',
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                flexDirection: 'column'
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                landscapeDirection: 'row'
            },
            style: {
                flexDirection: 'row'
            }
        }
    ]
});
const $f3ba643fb3747006$export$eb3c4d84783d6feb = /*#__PURE__*/ $acw62.forwardRef(function PickersToolbar(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersToolbar'
    });
    const { children: children, className: className, classes: classesProp, toolbarTitle: toolbarTitle, hidden: hidden, titleId: titleId, landscapeDirection: landscapeDirection } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $f3ba643fb3747006$var$_excluded);
    const ownerState = (0, $7488814d8bbee125$export$52d82af37dec73b2)();
    const classes = $f3ba643fb3747006$var$useUtilityClasses(classesProp);
    if (hidden) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f3ba643fb3747006$var$PickersToolbarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                color: "text.secondary",
                variant: "overline",
                id: titleId,
                className: classes.title,
                children: toolbarTitle
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f3ba643fb3747006$var$PickersToolbarContent, {
                className: classes.content,
                ownerState: ownerState,
                landscapeDirection: landscapeDirection,
                children: children
            })
        ]
    }));
});




var $acw62 = parcelRequire("acw62");

const $64a485abd5675192$export$67c96d35a1b010b3 = (pickersTranslations)=>{
    return {
        components: {
            MuiLocalizationProvider: {
                defaultProps: {
                    localeText: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickersTranslations)
                }
            }
        }
    };
};


// This object is not Partial<PickersLocaleText> because it is the default values
const $0390a67dda8aa0eb$var$enUSPickers = {
    // Calendar navigation
    previousMonth: 'Previous month',
    nextMonth: 'Next month',
    // View navigation
    openPreviousView: 'Open previous view',
    openNextView: 'Open next view',
    calendarViewSwitchingButtonAriaLabel: (view)=>view === 'year' ? 'year view is open, switch to calendar view' : 'calendar view is open, switch to year view',
    // DateRange labels
    start: 'Start',
    end: 'End',
    startDate: 'Start date',
    startTime: 'Start time',
    endDate: 'End date',
    endTime: 'End time',
    // Action bar
    cancelButtonLabel: 'Cancel',
    clearButtonLabel: 'Clear',
    okButtonLabel: 'OK',
    todayButtonLabel: 'Today',
    nextStepButtonLabel: 'Next',
    // Toolbar titles
    datePickerToolbarTitle: 'Select date',
    dateTimePickerToolbarTitle: 'Select date & time',
    timePickerToolbarTitle: 'Select time',
    dateRangePickerToolbarTitle: 'Select date range',
    timeRangePickerToolbarTitle: 'Select time range',
    // Clock labels
    clockLabelText: (view, formattedTime)=>`Select ${view}. ${!formattedTime ? 'No time selected' : `Selected time is ${formattedTime}`}`,
    hoursClockNumberText: (hours)=>`${hours} hours`,
    minutesClockNumberText: (minutes)=>`${minutes} minutes`,
    secondsClockNumberText: (seconds)=>`${seconds} seconds`,
    // Digital clock labels
    selectViewText: (view)=>`Select ${view}`,
    // Calendar labels
    calendarWeekNumberHeaderLabel: 'Week number',
    calendarWeekNumberHeaderText: '#',
    calendarWeekNumberAriaLabelText: (weekNumber)=>`Week ${weekNumber}`,
    calendarWeekNumberText: (weekNumber)=>`${weekNumber}`,
    // Open Picker labels
    openDatePickerDialogue: (formattedDate)=>formattedDate ? `Choose date, selected date is ${formattedDate}` : 'Choose date',
    openTimePickerDialogue: (formattedTime)=>formattedTime ? `Choose time, selected time is ${formattedTime}` : 'Choose time',
    openRangePickerDialogue: (formattedRange)=>formattedRange ? `Choose range, selected range is ${formattedRange}` : 'Choose range',
    fieldClearLabel: 'Clear',
    // Table labels
    timeTableLabel: 'pick time',
    dateTableLabel: 'pick date',
    // Field section placeholders
    fieldYearPlaceholder: (params)=>'Y'.repeat(params.digitAmount),
    fieldMonthPlaceholder: (params)=>params.contentType === 'letter' ? 'MMMM' : 'MM',
    fieldDayPlaceholder: ()=>'DD',
    fieldWeekDayPlaceholder: (params)=>params.contentType === 'letter' ? 'EEEE' : 'EE',
    fieldHoursPlaceholder: ()=>'hh',
    fieldMinutesPlaceholder: ()=>'mm',
    fieldSecondsPlaceholder: ()=>'ss',
    fieldMeridiemPlaceholder: ()=>'aa',
    // View names
    year: 'Year',
    month: 'Month',
    day: 'Day',
    weekDay: 'Week day',
    hours: 'Hours',
    minutes: 'Minutes',
    seconds: 'Seconds',
    meridiem: 'Meridiem',
    // Common
    empty: 'Empty'
};
const $0390a67dda8aa0eb$export$1af4c7e47ad72f44 = $0390a67dda8aa0eb$var$enUSPickers;
const $0390a67dda8aa0eb$export$137380d9ce54f7f = (0, $64a485abd5675192$export$67c96d35a1b010b3)($0390a67dda8aa0eb$var$enUSPickers);



'use client';
const $75a4cb957586789c$export$4b5a24245de9f7f9 = ()=>{
    const localization = $acw62.useContext((0, $b713746033a911a9$export$41298298dbe382b));
    if (localization === null) throw new Error([
        'MUI X: Can not find the date and time pickers localization context.',
        'It looks like you forgot to wrap your component in LocalizationProvider.',
        'This can also happen if you are bundling multiple versions of the `@mui/x-date-pickers` package'
    ].join('\n'));
    if (localization.adapter === null) throw new Error([
        'MUI X: Can not find the date and time pickers adapter from its localization context.',
        'It looks like you forgot to pass a `dateAdapter` to your LocalizationProvider.'
    ].join('\n'));
    const localeText = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $0390a67dda8aa0eb$export$1af4c7e47ad72f44), localization.localeText), [
        localization.localeText
    ]);
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, localization, {
            localeText: localeText
        }), [
        localization,
        localeText
    ]);
};
const $75a4cb957586789c$export$e5c01b0ea0b41b2b = ()=>$75a4cb957586789c$export$4b5a24245de9f7f9().adapter;


'use client';
const $66648da3b075d888$export$a795e6ca852975b9 = ()=>(0, $75a4cb957586789c$export$4b5a24245de9f7f9)().localeText;




function $283658a86bbff667$export$a1c3879af2c3b694(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDatePickerToolbar', slot);
}
const $283658a86bbff667$export$2e35fa7d24ef4179 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDatePickerToolbar', [
    'root',
    'title'
]);





'use client';
const $e99b23969f5ded13$var$_excluded = [
    "toolbarFormat",
    "toolbarPlaceholder",
    "className",
    "classes"
];
const $e99b23969f5ded13$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        title: [
            'title'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $283658a86bbff667$export$a1c3879af2c3b694), classes);
};
const $e99b23969f5ded13$var$DatePickerToolbarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $f3ba643fb3747006$export$eb3c4d84783d6feb), {
    name: 'MuiDatePickerToolbar',
    slot: 'Root'
})({});
const $e99b23969f5ded13$var$DatePickerToolbarTitle = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: 'MuiDatePickerToolbar',
    slot: 'Title'
})({
    variants: [
        {
            props: {
                pickerOrientation: 'landscape'
            },
            style: {
                margin: 'auto 16px auto auto'
            }
        }
    ]
});
const $e99b23969f5ded13$export$21b7f8ea763109eb = /*#__PURE__*/ $acw62.forwardRef(function DatePickerToolbar(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePickerToolbar'
    });
    const { toolbarFormat: toolbarFormat, toolbarPlaceholder: toolbarPlaceholder = "\u2013\u2013", className: className, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e99b23969f5ded13$var$_excluded);
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { value: value, views: views, orientation: orientation } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const ownerState = (0, $7488814d8bbee125$export$52d82af37dec73b2)();
    const classes = $e99b23969f5ded13$var$useUtilityClasses(classesProp);
    const dateText = $acw62.useMemo(()=>{
        if (!adapter.isValid(value)) return toolbarPlaceholder;
        const formatFromViews = (0, $b8d019f986eaf72a$export$bb1c921f313ec928)(adapter, {
            format: toolbarFormat,
            views: views
        }, true);
        return adapter.formatByString(value, formatFromViews);
    }, [
        value,
        toolbarFormat,
        toolbarPlaceholder,
        adapter,
        views
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e99b23969f5ded13$var$DatePickerToolbarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        toolbarTitle: translations.datePickerToolbarTitle,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e99b23969f5ded13$var$DatePickerToolbarTitle, {
            variant: "h4",
            align: orientation === 'landscape' ? 'left' : 'center',
            ownerState: ownerState,
            className: classes.title,
            children: dateText
        })
    }));
});




var $acw62 = parcelRequire("acw62");



const $cee5e9e903761e8a$export$ffb3d0046ef3a2 = ({ props: props, value: value, timezone: timezone, adapter: adapter })=>{
    if (value === null) return null;
    const { shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate } = props;
    const now = adapter.date(undefined, timezone);
    switch(true){
        case !adapter.isValid(value):
            return 'invalidDate';
        case Boolean(shouldDisableDate && shouldDisableDate(value)):
            return 'shouldDisableDate';
        case Boolean(shouldDisableMonth && shouldDisableMonth(value)):
            return 'shouldDisableMonth';
        case Boolean(shouldDisableYear && shouldDisableYear(value)):
            return 'shouldDisableYear';
        case Boolean(disableFuture && adapter.isAfterDay(value, now)):
            return 'disableFuture';
        case Boolean(disablePast && adapter.isBeforeDay(value, now)):
            return 'disablePast';
        case Boolean(minDate && adapter.isBeforeDay(value, minDate)):
            return 'minDate';
        case Boolean(maxDate && adapter.isAfterDay(value, maxDate)):
            return 'maxDate';
        default:
            return null;
    }
};
$cee5e9e903761e8a$export$ffb3d0046ef3a2.valueManager = (0, $235c2ad72f19522e$export$2764b246aa3b75ba);



var $acw62 = parcelRequire("acw62");

const $06e5a97a469e375c$export$7c38da3a2e90fa83 = ()=>(0, $75a4cb957586789c$export$4b5a24245de9f7f9)().defaultDates;
const $06e5a97a469e375c$export$3a404aece3dff2fa = (timezone)=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const now = $acw62.useRef(undefined);
    if (now.current === undefined) now.current = adapter.date(undefined, timezone);
    return now.current;
};



'use client';
function $53fd543f3597ad7b$export$6b73f8c5013b806e(parameters = {}) {
    const { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true } = parameters;
    return $acw62.useMemo(()=>({
            valueType: 'date',
            validator: (0, $cee5e9e903761e8a$export$ffb3d0046ef3a2),
            internal_valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
            internal_fieldValueManager: (0, $235c2ad72f19522e$export$b602c94f557316b4),
            internal_enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            internal_useApplyDefaultValuesToFieldInternalProps: $53fd543f3597ad7b$var$useApplyDefaultValuesToDateFieldInternalProps,
            internal_useOpenPickerButtonAriaLabel: $53fd543f3597ad7b$var$useOpenPickerButtonAriaLabel
        }), [
        enableAccessibleFieldDOMStructure
    ]);
}
function $53fd543f3597ad7b$var$useOpenPickerButtonAriaLabel(value) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    return $acw62.useMemo(()=>{
        const formattedValue = adapter.isValid(value) ? adapter.format(value, 'fullDate') : null;
        return translations.openDatePickerDialogue(formattedValue);
    }, [
        value,
        translations,
        adapter
    ]);
}
function $53fd543f3597ad7b$var$useApplyDefaultValuesToDateFieldInternalProps(internalProps) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const validationProps = $53fd543f3597ad7b$export$82ecc8c5f467152f(internalProps);
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, internalProps, validationProps, {
            format: internalProps.format ?? adapter.formats.keyboardDate
        }), [
        internalProps,
        validationProps,
        adapter
    ]);
}
function $53fd543f3597ad7b$export$82ecc8c5f467152f(props) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const defaultDates = (0, $06e5a97a469e375c$export$7c38da3a2e90fa83)();
    return $acw62.useMemo(()=>({
            disablePast: props.disablePast ?? false,
            disableFuture: props.disableFuture ?? false,
            minDate: (0, $b8d019f986eaf72a$export$eb73579ccade48fd)(adapter, props.minDate, defaultDates.minDate),
            maxDate: (0, $b8d019f986eaf72a$export$eb73579ccade48fd)(adapter, props.maxDate, defaultDates.maxDate)
        }), [
        props.minDate,
        props.maxDate,
        props.disableFuture,
        props.disablePast,
        adapter,
        defaultDates
    ]);
}


function $039011ab24769564$export$a552c17ed3587731(props, name) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $53fd543f3597ad7b$export$82ecc8c5f467152f)(themeProps);
    const localeText = $acw62.useMemo(()=>{
        if (themeProps.localeText?.toolbarTitle == null) return themeProps.localeText;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps.localeText, {
            datePickerToolbarTitle: themeProps.localeText.toolbarTitle
        });
    }, [
        themeProps.localeText
    ]);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        localeText: localeText
    }, (0, $38ae9feef3ab2fb0$export$bdf8d867ddc968e)({
        views: themeProps.views,
        openTo: themeProps.openTo,
        defaultViews: [
            'year',
            'day'
        ],
        defaultOpenTo: 'day'
    }), {
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            toolbar: (0, $e99b23969f5ded13$export$21b7f8ea763109eb)
        }, themeProps.slots)
    });
}



const $ddd12d3841a65e00$export$430d9fc64cf058d6 = [
    'disablePast',
    'disableFuture',
    'minDate',
    'maxDate',
    'shouldDisableDate',
    'shouldDisableMonth',
    'shouldDisableYear'
];
const $ddd12d3841a65e00$export$fd5e0f8b4115a8c7 = [
    'disablePast',
    'disableFuture',
    'minTime',
    'maxTime',
    'shouldDisableTime',
    'minutesStep',
    'ampm',
    'disableIgnoringDatePartForTimeValidation'
];
const $ddd12d3841a65e00$export$1df62d3ba2121371 = [
    'minDateTime',
    'maxDateTime'
];
const $ddd12d3841a65e00$var$VALIDATION_PROP_NAMES = [
    ...$ddd12d3841a65e00$export$430d9fc64cf058d6,
    ...$ddd12d3841a65e00$export$fd5e0f8b4115a8c7,
    ...$ddd12d3841a65e00$export$1df62d3ba2121371
];
const $ddd12d3841a65e00$export$5890f750904acddb = (props)=>$ddd12d3841a65e00$var$VALIDATION_PROP_NAMES.reduce((extractedProps, propName)=>{
        if (props.hasOwnProperty(propName)) extractedProps[propName] = props[propName];
        return extractedProps;
    }, {});




parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");













function $b7732b7b1a3865b1$export$13707a1542cd4ff5(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickerPopper', slot);
}
const $b7732b7b1a3865b1$export$e7d83f8e0f3c53d3 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickerPopper', [
    'root',
    'paper'
]);



function $7c44784990d74e44$export$22012a5c726bef55(array, itemOrItems) {
    if (Array.isArray(itemOrItems)) return itemOrItems.every((item)=>array.indexOf(item) !== -1);
    return array.indexOf(itemOrItems) !== -1;
}
const $7c44784990d74e44$export$4467fe8634707c85 = (innerFn, externalEvent)=>(event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            innerFn(event);
            // prevent any side effects
            event.preventDefault();
            event.stopPropagation();
        }
        if (externalEvent) externalEvent(event);
    };
const $7c44784990d74e44$export$2e03bc8dde24716b = (fn)=>{
    setTimeout(fn, 0);
};
// https://www.abeautifulsite.net/posts/finding-the-active-element-in-a-shadow-root/
const $7c44784990d74e44$var$getActiveElementInternal = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $7c44784990d74e44$var$getActiveElementInternal(activeEl.shadowRoot);
    return activeEl;
};
const $7c44784990d74e44$export$cd4e5573fbe2b576 = (node)=>{
    return $7c44784990d74e44$var$getActiveElementInternal((0, $4c8156a231c9130b$export$2e2bcd8739ae039)(node));
};
const $7c44784990d74e44$export$4165ccf43f4d7767 = (listElement)=>{
    const children = Array.from(listElement.children);
    return children.indexOf($7c44784990d74e44$export$cd4e5573fbe2b576(listElement));
};
const $7c44784990d74e44$export$9ae5b19305db48ce = '@media (pointer: fine)';
function $7c44784990d74e44$export$3da104473fe9d2e8(...sxProps) {
    return sxProps.reduce((acc, sxProp)=>{
        if (Array.isArray(sxProp)) acc.push(...sxProp);
        else if (sxProp != null) acc.push(sxProp);
        return acc;
    }, []);
}





'use client';
const $d41682fbe562e739$var$_excluded = [
    "PaperComponent",
    "ownerState",
    "children",
    "paperSlotProps",
    "paperClasses",
    "onPaperClick",
    "onPaperTouchStart"
];
const $d41682fbe562e739$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        paper: [
            'paper'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $b7732b7b1a3865b1$export$13707a1542cd4ff5), classes);
};
const $d41682fbe562e739$var$PickerPopperRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $d825775ecf14115c$export$2e2bcd8739ae039), {
    name: 'MuiPickerPopper',
    slot: 'Root'
})(({ theme: theme })=>({
        zIndex: theme.zIndex.modal
    }));
const $d41682fbe562e739$var$PickerPopperPaper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiPickerPopper',
    slot: 'Paper'
})({
    outline: 0,
    transformOrigin: 'top center',
    variants: [
        {
            props: ({ popperPlacement: popperPlacement })=>new Set([
                    'top',
                    'top-start',
                    'top-end'
                ]).has(popperPlacement),
            style: {
                transformOrigin: 'bottom center'
            }
        }
    ]
});
function $d41682fbe562e739$var$clickedRootScrollbar(event, doc) {
    return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}
/**
 * Based on @mui/material/ClickAwayListener without the customization.
 * We can probably strip away even more since children won't be portaled.
 * @param {boolean} active Only listen to clicks when the popper is opened.
 * @param {(event: MouseEvent | TouchEvent) => void} onClickAway The callback to call when clicking outside the popper.
 * @returns {Array} The ref and event handler to listen to the outside clicks.
 */ function $d41682fbe562e739$var$useClickAwayListener(active, onClickAway) {
    const movedRef = $acw62.useRef(false);
    const syntheticEventRef = $acw62.useRef(false);
    const nodeRef = $acw62.useRef(null);
    const activatedRef = $acw62.useRef(false);
    $acw62.useEffect(()=>{
        if (!active) return undefined;
        // Ensure that this hook is not "activated" synchronously.
        // https://github.com/facebook/react/issues/20074
        function armClickAwayListener() {
            activatedRef.current = true;
        }
        document.addEventListener('mousedown', armClickAwayListener, true);
        document.addEventListener('touchstart', armClickAwayListener, true);
        return ()=>{
            document.removeEventListener('mousedown', armClickAwayListener, true);
            document.removeEventListener('touchstart', armClickAwayListener, true);
            activatedRef.current = false;
        };
    }, [
        active
    ]);
    // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    const handleClickAway = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (!activatedRef.current) return;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = syntheticEventRef.current;
        syntheticEventRef.current = false;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
        // 1. IE11 support, which trigger the handleClickAway even after the unbind
        // 2. The child might render null.
        // 3. Behave like a blur listener.
        if (!nodeRef.current || // is a TouchEvent?
        'clientX' in event && $d41682fbe562e739$var$clickedRootScrollbar(event, doc)) return;
        // Do not act if user performed touchmove
        if (movedRef.current) {
            movedRef.current = false;
            return;
        }
        let insideDOM;
        // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
        if (event.composedPath) insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
        else insideDOM = !doc.documentElement.contains(event.target) || nodeRef.current.contains(event.target);
        if (!insideDOM && !insideReactTree) onClickAway(event);
    });
    // Keep track of mouse/touch events that bubbled up through the portal.
    const handleSynthetic = (event)=>{
        // Ignore events handled by our internal components
        if (!event.defaultMuiPrevented) syntheticEventRef.current = true;
    };
    $acw62.useEffect(()=>{
        if (active) {
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            const handleTouchMove = ()=>{
                movedRef.current = true;
            };
            doc.addEventListener('touchstart', handleClickAway);
            doc.addEventListener('touchmove', handleTouchMove);
            return ()=>{
                doc.removeEventListener('touchstart', handleClickAway);
                doc.removeEventListener('touchmove', handleTouchMove);
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    $acw62.useEffect(()=>{
        // TODO This behavior is not tested automatically
        // It's unclear whether this is due to different update semantics in test (batched in act() vs discrete on click).
        // Or if this is a timing related issues due to different Transition components
        // Once we get rid of all the manual scheduling (for example setTimeout(update, 0)) we can revisit this code+test.
        if (active) {
            const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(nodeRef.current);
            doc.addEventListener('click', handleClickAway);
            return ()=>{
                doc.removeEventListener('click', handleClickAway);
                // cleanup `handleClickAway`
                syntheticEventRef.current = false;
            };
        }
        return undefined;
    }, [
        active,
        handleClickAway
    ]);
    return [
        nodeRef,
        handleSynthetic,
        handleSynthetic
    ];
}
const $d41682fbe562e739$var$PickerPopperPaperWrapper = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
    const { PaperComponent: PaperComponent, ownerState: ownerState, children: children, paperSlotProps: paperSlotProps, paperClasses: paperClasses, onPaperClick: onPaperClick, onPaperTouchStart: onPaperTouchStart } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d41682fbe562e739$var$_excluded);
    const paperProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PaperComponent,
        externalSlotProps: paperSlotProps,
        additionalProps: {
            tabIndex: -1,
            elevation: 8,
            ref: ref
        },
        className: paperClasses,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PaperComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, paperProps, {
        onClick: (event)=>{
            onPaperClick(event);
            paperProps.onClick?.(event);
        },
        onTouchStart: (event)=>{
            onPaperTouchStart(event);
            paperProps.onTouchStart?.(event);
        },
        ownerState: ownerState,
        children: children
    }));
});
function $d41682fbe562e739$export$ac84dff7cf037abd(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickerPopper'
    });
    const { children: children, placement: placement = 'bottom-start', slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const { open: open, popupRef: popupRef, reduceAnimations: reduceAnimations } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const { ownerState: pickerOwnerState, rootRefObject: rootRefObject } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const { dismissViews: dismissViews, getCurrentViewMode: getCurrentViewMode, onPopperExited: onPopperExited, triggerElement: triggerElement, viewContainerRole: viewContainerRole } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    $acw62.useEffect(()=>{
        function handleKeyDown(nativeEvent) {
            if (open && nativeEvent.key === 'Escape') dismissViews();
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        dismissViews,
        open
    ]);
    const lastFocusedElementRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (viewContainerRole === 'tooltip' || getCurrentViewMode() === 'field') return;
        if (open) lastFocusedElementRef.current = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(rootRefObject.current);
        else if (lastFocusedElementRef.current && lastFocusedElementRef.current instanceof HTMLElement) // make sure the button is flushed with updated label, before returning focus to it
        // avoids issue, where screen reader could fail to announce selected date after selection
        setTimeout(()=>{
            if (lastFocusedElementRef.current instanceof HTMLElement) lastFocusedElementRef.current.focus();
        });
    }, [
        open,
        viewContainerRole,
        getCurrentViewMode,
        rootRefObject
    ]);
    const classes = $d41682fbe562e739$var$useUtilityClasses(classesProp);
    const handleClickAway = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        if (viewContainerRole === 'tooltip') (0, $7c44784990d74e44$export$2e03bc8dde24716b)(()=>{
            if (rootRefObject.current?.contains((0, $7c44784990d74e44$export$cd4e5573fbe2b576)(rootRefObject.current)) || popupRef.current?.contains((0, $7c44784990d74e44$export$cd4e5573fbe2b576)(popupRef.current))) return;
            dismissViews();
        });
        else dismissViews();
    });
    const [clickAwayRef, onPaperClick, onPaperTouchStart] = $d41682fbe562e739$var$useClickAwayListener(open, handleClickAway);
    const paperRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(paperRef, popupRef);
    const handlePaperRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(handleRef, clickAwayRef);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            // stop the propagation to avoid closing parent modal
            event.stopPropagation();
            dismissViews();
        }
    };
    const Transition = slots?.desktopTransition ?? reduceAnimations ? (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039) : (0, $5a8449c70e836e71$export$2e2bcd8739ae039);
    const FocusTrap = slots?.desktopTrapFocus ?? (0, $29292f9ac60f4a63$export$2e2bcd8739ae039);
    const Paper = slots?.desktopPaper ?? $d41682fbe562e739$var$PickerPopperPaper;
    const Popper = slots?.popper ?? $d41682fbe562e739$var$PickerPopperRoot;
    const popperProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Popper,
        externalSlotProps: slotProps?.popper,
        additionalProps: {
            transition: true,
            role: viewContainerRole == null ? undefined : viewContainerRole,
            open: open,
            placement: placement,
            anchorEl: triggerElement,
            onKeyDown: handleKeyDown
        },
        className: classes.root,
        ownerState: pickerOwnerState
    });
    const ownerState = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            popperPlacement: popperProps.placement
        }), [
        pickerOwnerState,
        popperProps.placement
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Popper, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, popperProps, {
        children: ({ TransitionProps: TransitionProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FocusTrap, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                open: open,
                disableAutoFocus: true,
                disableRestoreFocus: true,
                disableEnforceFocus: viewContainerRole === 'tooltip',
                isEnabled: ()=>true
            }, slotProps?.desktopTrapFocus, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Transition, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, TransitionProps, slotProps?.desktopTransition, {
                    onExited: (event)=>{
                        onPopperExited?.();
                        slotProps?.desktopTransition?.onExited?.(event);
                        TransitionProps?.onExited?.();
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d41682fbe562e739$var$PickerPopperPaperWrapper, {
                        PaperComponent: Paper,
                        ownerState: ownerState,
                        ref: handlePaperRef,
                        onPaperClick: onPaperClick,
                        onPaperTouchStart: onPaperTouchStart,
                        paperClasses: classes.paper,
                        paperSlotProps: slotProps?.desktopPaper,
                        children: children
                    })
                }))
            }))
    }));
}





var $acw62 = parcelRequire("acw62");






const $fb5fb152771bc52e$var$PREFERS_REDUCED_MOTION = '@media (prefers-reduced-motion: reduce)';
// detect if user agent has Android version < 10 or iOS version < 13
const $fb5fb152771bc52e$var$mobileVersionMatches = typeof navigator !== 'undefined' && navigator.userAgent.match(/android\s(\d+)|OS\s(\d+)/i);
const $fb5fb152771bc52e$var$androidVersion = $fb5fb152771bc52e$var$mobileVersionMatches && $fb5fb152771bc52e$var$mobileVersionMatches[1] ? parseInt($fb5fb152771bc52e$var$mobileVersionMatches[1], 10) : null;
const $fb5fb152771bc52e$var$iOSVersion = $fb5fb152771bc52e$var$mobileVersionMatches && $fb5fb152771bc52e$var$mobileVersionMatches[2] ? parseInt($fb5fb152771bc52e$var$mobileVersionMatches[2], 10) : null;
const $fb5fb152771bc52e$export$7e3b2a595fb375e5 = $fb5fb152771bc52e$var$androidVersion && $fb5fb152771bc52e$var$androidVersion < 10 || $fb5fb152771bc52e$var$iOSVersion && $fb5fb152771bc52e$var$iOSVersion < 13 || false;
function $fb5fb152771bc52e$export$7e40eba507bb97c4(customReduceAnimations) {
    const prefersReduced = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)($fb5fb152771bc52e$var$PREFERS_REDUCED_MOTION, {
        defaultMatches: false
    });
    if (customReduceAnimations != null) return customReduceAnimations;
    return prefersReduced || $fb5fb152771bc52e$export$7e3b2a595fb375e5;
}





var $acw62 = parcelRequire("acw62");



const $93c878f075509e16$export$c9a0b669a5b51c7d = {
    hasNextStep: false,
    hasSeveralSteps: false,
    goToNextStep: ()=>{},
    areViewsInSameStep: ()=>true
};
function $93c878f075509e16$export$768f745bfa10c92a(parameters) {
    const { steps: steps, isViewMatchingStep: isViewMatchingStep, onStepChange: onStepChange } = parameters;
    return (parametersBis)=>{
        if (steps == null) return $93c878f075509e16$export$c9a0b669a5b51c7d;
        const currentStepIndex = steps.findIndex((step)=>isViewMatchingStep(parametersBis.view, step));
        const nextStep = currentStepIndex === -1 || currentStepIndex === steps.length - 1 ? null : steps[currentStepIndex + 1];
        return {
            hasNextStep: nextStep != null,
            hasSeveralSteps: steps.length > 1,
            goToNextStep: ()=>{
                if (nextStep == null) return;
                onStepChange((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parametersBis, {
                    step: nextStep
                }));
            },
            areViewsInSameStep: (viewA, viewB)=>{
                const stepA = steps.find((step)=>isViewMatchingStep(viewA, step));
                const stepB = steps.find((step)=>isViewMatchingStep(viewB, step));
                return stepA === stepB;
            }
        };
    };
}


'use client';
let $30cf9c7f82fc091d$var$warnedOnceNotValidView = false;
function $30cf9c7f82fc091d$export$9b46cba8f8ccd954({ onChange: onChange, onViewChange: onViewChange, openTo: openTo, view: inView, views: views, autoFocus: autoFocus, focusedView: inFocusedView, onFocusedViewChange: onFocusedViewChange, getStepNavigation: getStepNavigation }) {
    const previousOpenTo = $acw62.useRef(openTo);
    const previousViews = $acw62.useRef(views);
    const defaultView = $acw62.useRef(views.includes(openTo) ? openTo : views[0]);
    const [view, setView] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'view',
        controlled: inView,
        default: defaultView.current
    });
    const defaultFocusedView = $acw62.useRef(autoFocus ? view : null);
    const [focusedView, setFocusedView] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'useViews',
        state: 'focusedView',
        controlled: inFocusedView,
        default: defaultFocusedView.current
    });
    const stepNavigation = getStepNavigation ? getStepNavigation({
        setView: setView,
        view: view,
        defaultView: defaultView.current,
        views: views
    }) : (0, $93c878f075509e16$export$c9a0b669a5b51c7d);
    $acw62.useEffect(()=>{
        // Update the current view when `openTo` or `views` props change
        if (previousOpenTo.current && previousOpenTo.current !== openTo || previousViews.current && previousViews.current.some((previousView)=>!views.includes(previousView))) {
            setView(views.includes(openTo) ? openTo : views[0]);
            previousViews.current = views;
            previousOpenTo.current = openTo;
        }
    }, [
        openTo,
        setView,
        view,
        views
    ]);
    const viewIndex = views.indexOf(view);
    const previousView = views[viewIndex - 1] ?? null;
    const nextView = views[viewIndex + 1] ?? null;
    const handleFocusedViewChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((viewToFocus, hasFocus)=>{
        if (hasFocus) // Focus event
        setFocusedView(viewToFocus);
        else // Blur event
        setFocusedView((prevFocusedView)=>viewToFocus === prevFocusedView ? null : prevFocusedView // If false the blur is due to view switching
        );
        onFocusedViewChange?.(viewToFocus, hasFocus);
    });
    const handleChangeView = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newView)=>{
        // always keep the focused view in sync
        handleFocusedViewChange(newView, true);
        if (newView === view) return;
        setView(newView);
        if (onViewChange) onViewChange(newView);
    });
    const goToNextView = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        if (nextView) handleChangeView(nextView);
    });
    const setValueAndGoToNextView = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((value, currentViewSelectionState, selectedView)=>{
        const isSelectionFinishedOnCurrentView = currentViewSelectionState === 'finish';
        const hasMoreViews = selectedView ? // handles case like `DateTimePicker`, where a view might return a `finish` selection state
        // but when it's not the final view given all `views` -> overall selection state should be `partial`.
        views.indexOf(selectedView) < views.length - 1 : Boolean(nextView);
        const globalSelectionState = isSelectionFinishedOnCurrentView && hasMoreViews ? 'partial' : currentViewSelectionState;
        onChange(value, globalSelectionState, selectedView);
        // The selected view can be different from the active view,
        // This can happen if multiple views are displayed, like in `DesktopDateTimePicker` or `MultiSectionDigitalClock`.
        let currentView = null;
        if (selectedView != null && selectedView !== view) currentView = selectedView;
        else if (isSelectionFinishedOnCurrentView) currentView = view;
        if (currentView == null) return;
        const viewToNavigateTo = views[views.indexOf(currentView) + 1];
        if (viewToNavigateTo == null || !stepNavigation.areViewsInSameStep(currentView, viewToNavigateTo)) return;
        handleChangeView(viewToNavigateTo);
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, stepNavigation, {
        view: view,
        setView: handleChangeView,
        focusedView: focusedView,
        setFocusedView: handleFocusedViewChange,
        nextView: nextView,
        previousView: previousView,
        // Always return up-to-date default view instead of the initial one (i.e. defaultView.current)
        defaultView: views.includes(openTo) ? openTo : views[0],
        goToNextView: goToNextView,
        setValueAndGoToNextView: setValueAndGoToNextView
    });
}



var $acw62 = parcelRequire("acw62");


'use client';
function $dc73f3acfd5fdff0$var$getOrientation() {
    if (typeof window === 'undefined') return 'portrait';
    if (window.screen && window.screen.orientation && window.screen.orientation.angle) return Math.abs(window.screen.orientation.angle) === 90 ? 'landscape' : 'portrait';
    // Support IOS safari
    if (window.orientation) return Math.abs(Number(window.orientation)) === 90 ? 'landscape' : 'portrait';
    return 'portrait';
}
function $dc73f3acfd5fdff0$export$550084c67147f6c4(views, customOrientation) {
    const [orientation, setOrientation] = $acw62.useState($dc73f3acfd5fdff0$var$getOrientation);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const eventHandler = ()=>{
            setOrientation($dc73f3acfd5fdff0$var$getOrientation());
        };
        window.addEventListener('orientationchange', eventHandler);
        return ()=>{
            window.removeEventListener('orientationchange', eventHandler);
        };
    }, []);
    if ((0, $7c44784990d74e44$export$22012a5c726bef55)(views, [
        'hours',
        'minutes',
        'seconds'
    ])) // could not display 13:34:44 in landscape mode
    return 'portrait';
    return customOrientation ?? orientation;
}




var $acw62 = parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



const $f4770a33870ed562$export$ac06ac6808815c7c = ({ name: name, timezone: timezoneProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChangeProp, valueManager: valueManager })=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const [valueWithInputTimezone, setValue] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: name,
        state: 'value',
        controlled: valueProp,
        default: defaultValue ?? valueManager.emptyValue
    });
    const inputTimezone = $acw62.useMemo(()=>valueManager.getTimezone(adapter, valueWithInputTimezone), [
        adapter,
        valueManager,
        valueWithInputTimezone
    ]);
    const setInputTimezone = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue)=>{
        if (inputTimezone == null) return newValue;
        return valueManager.setTimezone(adapter, inputTimezone, newValue);
    });
    const timezoneToRender = $acw62.useMemo(()=>{
        if (timezoneProp) return timezoneProp;
        if (inputTimezone) return inputTimezone;
        if (referenceDate) return adapter.getTimezone(Array.isArray(referenceDate) ? referenceDate[0] : referenceDate);
        return 'default';
    }, [
        timezoneProp,
        inputTimezone,
        referenceDate,
        adapter
    ]);
    const valueWithTimezoneToRender = $acw62.useMemo(()=>valueManager.setTimezone(adapter, timezoneToRender, valueWithInputTimezone), [
        valueManager,
        adapter,
        timezoneToRender,
        valueWithInputTimezone
    ]);
    const handleValueChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue, ...otherParams)=>{
        const newValueWithInputTimezone = setInputTimezone(newValue);
        setValue(newValueWithInputTimezone);
        onChangeProp?.(newValueWithInputTimezone, ...otherParams);
    });
    return {
        value: valueWithTimezoneToRender,
        handleValueChange: handleValueChange,
        timezone: timezoneToRender
    };
};




var $acw62 = parcelRequire("acw62");


'use client';
function $3811c2c4b61492d0$export$87fe492f99f25a20(options) {
    const { props: props, validator: validator, value: value, timezone: timezone, onError: onError } = options;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const previousValidationErrorRef = $acw62.useRef(validator.valueManager.defaultErrorState);
    const validationError = validator({
        adapter: adapter,
        value: value,
        timezone: timezone,
        props: props
    });
    const hasValidationError = validator.valueManager.hasError(validationError);
    $acw62.useEffect(()=>{
        if (onError && !validator.valueManager.isSameError(validationError, previousValidationErrorRef.current)) onError(validationError, value);
        previousValidationErrorRef.current = validationError;
    }, [
        validator,
        onError,
        validationError,
        value
    ]);
    const getValidationErrorForNewValue = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue)=>{
        return validator({
            adapter: adapter,
            value: newValue,
            timezone: timezone,
            props: props
        });
    });
    return {
        validationError: validationError,
        hasValidationError: hasValidationError,
        getValidationErrorForNewValue: getValidationErrorForNewValue
    };
}


'use client';
function $38c52d6ac7972c3f$export$475fd52a3cfe883b(parameters) {
    const { props: props, valueManager: valueManager, validator: validator } = parameters;
    const { value: valueProp, defaultValue: defaultValueProp, onChange: onChange, referenceDate: referenceDate, timezone: timezoneProp, onAccept: onAccept, closeOnSelect: closeOnSelect, open: openProp, onOpen: onOpen, onClose: onClose } = props;
    const { current: defaultValue } = $acw62.useRef(defaultValueProp);
    const { current: isValueControlled } = $acw62.useRef(valueProp !== undefined);
    const { current: isOpenControlled } = $acw62.useRef(openProp !== undefined);
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    /* eslint-enable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */ const { timezone: timezone, value: value, handleValueChange: handleValueChange } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'a picker component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        valueManager: valueManager
    });
    const [state, setState] = $acw62.useState(()=>({
            open: false,
            lastExternalValue: value,
            clockShallowValue: undefined,
            lastCommittedValue: value,
            hasBeenModifiedSinceMount: false
        }));
    const { getValidationErrorForNewValue: getValidationErrorForNewValue } = (0, $3811c2c4b61492d0$export$87fe492f99f25a20)({
        props: props,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: props.onError
    });
    const setOpen = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((action)=>{
        const newOpen = typeof action === 'function' ? action(state.open) : action;
        if (!isOpenControlled) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                open: newOpen
            }));
        if (newOpen && onOpen) onOpen();
        if (!newOpen) onClose?.();
    });
    const setValue = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue, options)=>{
        const { changeImportance: changeImportance = 'accept', skipPublicationIfPristine: skipPublicationIfPristine = false, validationError: validationError, shortcut: shortcut, shouldClose: shouldClose = changeImportance === 'accept' } = options ?? {};
        let shouldFireOnChange;
        let shouldFireOnAccept;
        if (!skipPublicationIfPristine && !isValueControlled && !state.hasBeenModifiedSinceMount) {
            // If the value is not controlled and the value has never been modified before,
            // Then clicking on any value (including the one equal to `defaultValue`) should call `onChange` and `onAccept`
            shouldFireOnChange = true;
            shouldFireOnAccept = changeImportance === 'accept';
        } else {
            shouldFireOnChange = !valueManager.areValuesEqual(adapter, newValue, value);
            shouldFireOnAccept = changeImportance === 'accept' && !valueManager.areValuesEqual(adapter, newValue, state.lastCommittedValue);
        }
        setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                // We reset the shallow value whenever we fire onChange.
                clockShallowValue: shouldFireOnChange ? undefined : prevState.clockShallowValue,
                lastCommittedValue: shouldFireOnAccept ? newValue : prevState.lastCommittedValue,
                hasBeenModifiedSinceMount: true
            }));
        let cachedContext = null;
        const getContext = ()=>{
            if (!cachedContext) {
                cachedContext = {
                    validationError: validationError == null ? getValidationErrorForNewValue(newValue) : validationError
                };
                if (shortcut) cachedContext.shortcut = shortcut;
            }
            return cachedContext;
        };
        if (shouldFireOnChange) handleValueChange(newValue, getContext());
        if (shouldFireOnAccept && onAccept) onAccept(newValue, getContext());
        if (shouldClose) setOpen(false);
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            lastExternalValue: value,
            clockShallowValue: undefined,
            hasBeenModifiedSinceMount: true
        }));
    const setValueFromView = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newValue, selectionState = 'partial')=>{
        // TODO: Expose a new method (private?) like `setView` that only updates the clock shallow value.
        if (selectionState === 'shallow') {
            setState((prev)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prev, {
                    clockShallowValue: newValue,
                    hasBeenModifiedSinceMount: true
                }));
            return;
        }
        setValue(newValue, {
            changeImportance: selectionState === 'finish' && closeOnSelect ? 'accept' : 'set'
        });
    });
    // It is required to update inner state in useEffect in order to avoid situation when
    // Our component is not mounted yet, but `open` state is set to `true` (for example initially opened)
    $acw62.useEffect(()=>{
        if (isOpenControlled) {
            if (openProp === undefined) throw new Error('You must not mix controlling and uncontrolled mode for `open` prop');
            setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                    open: openProp
                }));
        }
    }, [
        isOpenControlled,
        openProp
    ]);
    const viewValue = $acw62.useMemo(()=>valueManager.cleanValue(adapter, state.clockShallowValue === undefined ? value : state.clockShallowValue), [
        adapter,
        valueManager,
        state.clockShallowValue,
        value
    ]);
    return {
        timezone: timezone,
        state: state,
        setValue: setValue,
        setValueFromView: setValueFromView,
        setOpen: setOpen,
        value: value,
        viewValue: viewValue
    };
}



'use client';
const $eb07fb7878304460$var$_excluded = [
    "className",
    "sx"
];
const $eb07fb7878304460$export$fc3313977ac596c4 = ({ ref: ref, props: props, valueManager: valueManager, valueType: valueType, variant: variant, validator: validator, onPopperExited: onPopperExited, autoFocusView: autoFocusView, rendererInterceptor: RendererInterceptor, localeText: localeText, viewContainerRole: viewContainerRole, getStepNavigation: getStepNavigation })=>{
    const { views: // View props
    views, view: viewProp, openTo: openTo, onViewChange: onViewChange, viewRenderers: viewRenderers, reduceAnimations: reduceAnimationsProp, orientation: orientationProp, disableOpenPicker: disableOpenPicker, closeOnSelect: closeOnSelect, disabled: // Form props
    disabled, readOnly: readOnly, formatDensity: // Field props
    formatDensity, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure, selectedSections: selectedSections, onSelectedSectionsChange: onSelectedSectionsChange, format: format, label: label, autoFocus: // Other props
    autoFocus, name: name } = props;
    const { className: className, sx: sx } = props, propsToForwardToView = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $eb07fb7878304460$var$_excluded);
    /**
   * TODO: Improve how we generate the aria-label and aria-labelledby attributes.
   */ const labelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const reduceAnimations = (0, $fb5fb152771bc52e$export$7e40eba507bb97c4)(reduceAnimationsProp);
    const orientation = (0, $dc73f3acfd5fdff0$export$550084c67147f6c4)(views, orientationProp);
    const { current: initialView } = $acw62.useRef(openTo ?? null);
    /**
   * Refs
   */ const [triggerElement, triggerRef] = $acw62.useState(null);
    const popupRef = $acw62.useRef(null);
    const fieldRef = $acw62.useRef(null);
    const rootRefObject = $acw62.useRef(null);
    const rootRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, rootRefObject);
    const { timezone: timezone, state: state, setOpen: setOpen, setValue: setValue, setValueFromView: setValueFromView, value: value, viewValue: viewValue } = (0, $38c52d6ac7972c3f$export$475fd52a3cfe883b)({
        props: props,
        valueManager: valueManager,
        validator: validator
    });
    const { view: view, setView: setView, defaultView: defaultView, focusedView: focusedView, setFocusedView: setFocusedView, setValueAndGoToNextView: setValueAndGoToNextView, goToNextStep: goToNextStep, hasNextStep: hasNextStep, hasSeveralSteps: hasSeveralSteps } = (0, $30cf9c7f82fc091d$export$9b46cba8f8ccd954)({
        view: viewProp,
        views: views,
        openTo: openTo,
        onChange: setValueFromView,
        onViewChange: onViewChange,
        autoFocus: autoFocusView,
        getStepNavigation: getStepNavigation
    });
    const clearValue = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>setValue(valueManager.emptyValue));
    const setValueToToday = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>setValue(valueManager.getTodayValue(adapter, timezone, valueType)));
    const acceptValueChanges = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>setValue(value));
    const cancelValueChanges = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>setValue(state.lastCommittedValue, {
            skipPublicationIfPristine: true
        }));
    const dismissViews = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        setValue(value, {
            skipPublicationIfPristine: true
        });
    });
    const { hasUIView: hasUIView, viewModeLookup: viewModeLookup, timeViewsCount: timeViewsCount } = $acw62.useMemo(()=>views.reduce((acc, viewForReduce)=>{
            const viewMode = viewRenderers[viewForReduce] == null ? 'field' : 'UI';
            acc.viewModeLookup[viewForReduce] = viewMode;
            if (viewMode === 'UI') {
                acc.hasUIView = true;
                if ((0, $d83ac1c1cf9e346e$export$8f04d380cefd5a0d)(viewForReduce)) acc.timeViewsCount += 1;
            }
            return acc;
        }, {
            hasUIView: false,
            viewModeLookup: {},
            timeViewsCount: 0
        }), [
        viewRenderers,
        views
    ]);
    const currentViewMode = viewModeLookup[view];
    const getCurrentViewMode = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>currentViewMode);
    const [popperView, setPopperView] = $acw62.useState(currentViewMode === 'UI' ? view : null);
    if (popperView !== view && viewModeLookup[view] === 'UI') setPopperView(view);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        // Handle case of Date Time Picker without time renderers
        if (currentViewMode === 'field' && state.open) {
            setOpen(false);
            setTimeout(()=>{
                fieldRef?.current?.setSelectedSections(view);
                // focusing the input before the range selection is done
                // calling it outside of timeout results in an inconsistent behavior between Safari And Chrome
                fieldRef?.current?.focusField(view);
            });
        }
    }, [
        view
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!state.open) return;
        let newView = view;
        // If the current view is a field view, go to the last popper view
        if (currentViewMode === 'field' && popperView != null) newView = popperView;
        // If the current view is not the default view and both are UI views
        if (newView !== defaultView && viewModeLookup[newView] === 'UI' && viewModeLookup[defaultView] === 'UI') newView = defaultView;
        if (newView !== view) setView(newView);
        setFocusedView(newView, true);
    }, [
        state.open
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    const ownerState = $acw62.useMemo(()=>({
            isPickerValueEmpty: valueManager.areValuesEqual(adapter, value, valueManager.emptyValue),
            isPickerOpen: state.open,
            isPickerDisabled: props.disabled ?? false,
            isPickerReadOnly: props.readOnly ?? false,
            pickerOrientation: orientation,
            pickerVariant: variant
        }), [
        adapter,
        valueManager,
        value,
        state.open,
        orientation,
        variant,
        props.disabled,
        props.readOnly
    ]);
    const triggerStatus = $acw62.useMemo(()=>{
        if (disableOpenPicker || !hasUIView) return 'hidden';
        if (disabled || readOnly) return 'disabled';
        return 'enabled';
    }, [
        disableOpenPicker,
        hasUIView,
        disabled,
        readOnly
    ]);
    const wrappedGoToNextStep = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(goToNextStep);
    const defaultActionBarActions = $acw62.useMemo(()=>{
        if (closeOnSelect && !hasSeveralSteps) return [];
        return [
            'cancel',
            'nextOrAccept'
        ];
    }, [
        closeOnSelect,
        hasSeveralSteps
    ]);
    const actionsContextValue = $acw62.useMemo(()=>({
            setValue: setValue,
            setOpen: setOpen,
            clearValue: clearValue,
            setValueToToday: setValueToToday,
            acceptValueChanges: acceptValueChanges,
            cancelValueChanges: cancelValueChanges,
            setView: setView,
            goToNextStep: wrappedGoToNextStep
        }), [
        setValue,
        setOpen,
        clearValue,
        setValueToToday,
        acceptValueChanges,
        cancelValueChanges,
        setView,
        wrappedGoToNextStep
    ]);
    const contextValue = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, actionsContextValue, {
            value: value,
            timezone: timezone,
            open: state.open,
            views: views,
            view: popperView,
            initialView: initialView,
            disabled: disabled ?? false,
            readOnly: readOnly ?? false,
            autoFocus: autoFocus ?? false,
            variant: variant,
            orientation: orientation,
            popupRef: popupRef,
            reduceAnimations: reduceAnimations,
            triggerRef: triggerRef,
            triggerStatus: triggerStatus,
            hasNextStep: hasNextStep,
            fieldFormat: format ?? '',
            name: name,
            label: label,
            rootSx: sx,
            rootRef: rootRef,
            rootClassName: className
        }), [
        actionsContextValue,
        value,
        rootRef,
        variant,
        orientation,
        reduceAnimations,
        disabled,
        readOnly,
        format,
        className,
        name,
        label,
        sx,
        triggerStatus,
        hasNextStep,
        timezone,
        state.open,
        popperView,
        views,
        initialView,
        autoFocus
    ]);
    const privateContextValue = $acw62.useMemo(()=>({
            dismissViews: dismissViews,
            ownerState: ownerState,
            hasUIView: hasUIView,
            getCurrentViewMode: getCurrentViewMode,
            rootRefObject: rootRefObject,
            labelId: labelId,
            triggerElement: triggerElement,
            viewContainerRole: viewContainerRole,
            defaultActionBarActions: defaultActionBarActions,
            onPopperExited: onPopperExited
        }), [
        dismissViews,
        ownerState,
        hasUIView,
        getCurrentViewMode,
        labelId,
        triggerElement,
        viewContainerRole,
        defaultActionBarActions,
        onPopperExited
    ]);
    const fieldPrivateContextValue = $acw62.useMemo(()=>({
            formatDensity: formatDensity,
            enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
            selectedSections: selectedSections,
            onSelectedSectionsChange: onSelectedSectionsChange,
            fieldRef: fieldRef
        }), [
        formatDensity,
        enableAccessibleFieldDOMStructure,
        selectedSections,
        onSelectedSectionsChange,
        fieldRef
    ]);
    const isValidContextValue = (testedValue)=>{
        const error = validator({
            adapter: adapter,
            value: testedValue,
            timezone: timezone,
            props: props
        });
        return !valueManager.hasError(error);
    };
    const renderCurrentView = ()=>{
        if (popperView == null) return null;
        const renderer = viewRenderers[popperView];
        if (renderer == null) return null;
        const rendererProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, propsToForwardToView, {
            views: views,
            timezone: timezone,
            value: viewValue,
            onChange: setValueAndGoToNextView,
            view: popperView,
            onViewChange: setView,
            showViewSwitcher: timeViewsCount > 1,
            timeViewsCount: timeViewsCount
        }, viewContainerRole === 'tooltip' ? {
            focusedView: null,
            onFocusedViewChange: ()=>{}
        } : {
            focusedView: focusedView,
            onFocusedViewChange: setFocusedView
        });
        if (RendererInterceptor) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RendererInterceptor, {
            viewRenderers: viewRenderers,
            popperView: popperView,
            rendererProps: rendererProps
        });
        return renderer(rendererProps);
    };
    return {
        providerProps: {
            localeText: localeText,
            contextValue: contextValue,
            privateContextValue: privateContextValue,
            actionsContextValue: actionsContextValue,
            fieldPrivateContextValue: fieldPrivateContextValue,
            isValidContextValue: isValidContextValue
        },
        renderCurrentView: renderCurrentView,
        ownerState: ownerState
    };
};



var $acw62 = parcelRequire("acw62");






function $155427cbf9212b77$export$1671c31de798d429(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersLayout', slot);
}
const $155427cbf9212b77$export$7a6dac186703fe4c = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersLayout', [
    'root',
    'landscape',
    'contentWrapper',
    'toolbar',
    'actionBar',
    'tabs',
    'shortcuts'
]);





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");







'use client';
const $6693fe5c74d9d803$var$_excluded = [
    "actions"
];
const $6693fe5c74d9d803$var$PickersActionBarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
    name: 'MuiPickersLayout',
    slot: 'ActionBar'
})({});
/**
 * Demos:
 *
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersActionBar API](https://mui.com/x/api/date-pickers/pickers-action-bar/)
 */ function $6693fe5c74d9d803$var$PickersActionBarComponent(props) {
    const { actions: actions } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $6693fe5c74d9d803$var$_excluded);
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const { clearValue: clearValue, setValueToToday: setValueToToday, acceptValueChanges: acceptValueChanges, cancelValueChanges: cancelValueChanges, goToNextStep: goToNextStep, hasNextStep: hasNextStep } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    if (actions == null || actions.length === 0) return null;
    const buttons = actions?.map((actionType)=>{
        switch(actionType){
            case 'clear':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: clearValue,
                    children: translations.clearButtonLabel
                }, actionType);
            case 'cancel':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: cancelValueChanges,
                    children: translations.cancelButtonLabel
                }, actionType);
            case 'accept':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            case 'today':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: setValueToToday,
                    children: translations.todayButtonLabel
                }, actionType);
            case 'next':
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
            case 'nextOrAccept':
                if (hasNextStep) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: goToNextStep,
                    children: translations.nextStepButtonLabel
                }, actionType);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: acceptValueChanges,
                    children: translations.okButtonLabel
                }, actionType);
            default:
                return null;
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6693fe5c74d9d803$var$PickersActionBarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        children: buttons
    }));
}
const $6693fe5c74d9d803$export$72ffda3bb7ecf665 = /*#__PURE__*/ $acw62.memo($6693fe5c74d9d803$var$PickersActionBarComponent);





parcelRequire("acw62");





const $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0 = 36;
const $e7cd373dd46c88ee$export$dde58b009b497666 = 2;
const $e7cd373dd46c88ee$export$ee46b8a74d6c94d3 = 320;
const $e7cd373dd46c88ee$export$73724491020e90c7 = 280;
const $e7cd373dd46c88ee$export$f2fef360e2df0cb7 = 336;
const $e7cd373dd46c88ee$export$1c2eabda4acea0e4 = 232;
const $e7cd373dd46c88ee$export$a462ceb9cfdb5d71 = 48;



var $acw62 = parcelRequire("acw62");

'use client';
const $d6cf70c05c8e3b39$export$64b5b0e74c5c8445 = ()=>{
    const value = $acw62.useContext((0, $c33c428cfda4b7d5$export$d1dfa4910c58a4e));
    if (value == null) throw new Error([
        'MUI X: The `usePickerActionsContext` can only be called in fields that are used as a slot of a Picker component'
    ].join('\n'));
    return value;
};



'use client';
const $a2757c031fec5fda$var$_excluded = [
    "items",
    "changeImportance"
], $a2757c031fec5fda$var$_excluded2 = [
    "getValue"
];
const $a2757c031fec5fda$var$PickersShortcutsRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
    name: 'MuiPickersLayout',
    slot: 'Shortcuts'
})({});
/**
 * Demos:
 *
 * - [Shortcuts](https://mui.com/x/react-date-pickers/shortcuts/)
 *
 * API:
 *
 * - [PickersShortcuts API](https://mui.com/x/api/date-pickers/pickers-shortcuts/)
 */ function $a2757c031fec5fda$export$8ba8fc65919fa1fe(props) {
    const { items: items, changeImportance: changeImportance = 'accept' } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a2757c031fec5fda$var$_excluded);
    const { setValue: setValue } = (0, $d6cf70c05c8e3b39$export$64b5b0e74c5c8445)();
    const isValidValue = (0, $bbd57edb25eace5e$export$52df06af7329e367)();
    if (items == null || items.length === 0) return null;
    const resolvedItems = items.map((_ref)=>{
        let { getValue: getValue } = _ref, item = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $a2757c031fec5fda$var$_excluded2);
        const newValue = getValue({
            isValid: isValidValue
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
            label: item.label,
            onClick: ()=>{
                setValue(newValue, {
                    changeImportance: changeImportance,
                    shortcut: item
                });
            },
            disabled: !isValidValue(newValue)
        });
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a2757c031fec5fda$var$PickersShortcutsRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        dense: true,
        sx: [
            {
                maxHeight: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7),
                maxWidth: 200,
                overflow: 'auto'
            },
            ...Array.isArray(other.sx) ? other.sx : [
                other.sx
            ]
        ]
    }, other, {
        children: resolvedItems.map((item)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08a2e84130921e51$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item))
            }, item.id ?? item.label);
        })
    }));
}





'use client';
const $93d540a51b4256a1$var$_excluded = [
    "ownerState"
];
function $93d540a51b4256a1$var$toolbarHasView(toolbarProps) {
    return toolbarProps.view !== null;
}
const $93d540a51b4256a1$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ],
        toolbar: [
            'toolbar'
        ],
        actionBar: [
            'actionBar'
        ],
        tabs: [
            'tabs'
        ],
        landscape: [
            'landscape'
        ],
        shortcuts: [
            'shortcuts'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $155427cbf9212b77$export$1671c31de798d429), classes);
};
const $93d540a51b4256a1$var$usePickerLayout = (props)=>{
    const { ownerState: pickerOwnerState, defaultActionBarActions: defaultActionBarActions } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const { view: view } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const { children: children, slots: slots, slotProps: slotProps, classes: classesProp } = props;
    const ownerState = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            layoutDirection: isRtl ? 'rtl' : 'ltr',
            hasShortcuts: false
        }), [
        pickerOwnerState,
        isRtl
    ]);
    const classes = $93d540a51b4256a1$var$useUtilityClasses(classesProp, ownerState);
    // Action bar
    const ActionBar = slots?.actionBar ?? (0, $6693fe5c74d9d803$export$72ffda3bb7ecf665);
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: ActionBar,
        externalSlotProps: slotProps?.actionBar,
        additionalProps: {
            actions: defaultActionBarActions
        },
        className: classes.actionBar,
        ownerState: ownerState
    }), actionBarProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $93d540a51b4256a1$var$_excluded);
    const actionBar = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ActionBar, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, actionBarProps));
    // Toolbar
    const Toolbar = slots?.toolbar;
    const toolbarProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Toolbar,
        externalSlotProps: slotProps?.toolbar,
        className: classes.toolbar,
        ownerState: ownerState
    });
    const toolbar = $93d540a51b4256a1$var$toolbarHasView(toolbarProps) && !!Toolbar ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Toolbar, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, toolbarProps)) : null;
    // Content
    const content = children;
    // Tabs
    const Tabs = slots?.tabs;
    const tabs = view && Tabs ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Tabs, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classes.tabs
    }, slotProps?.tabs)) : null;
    // Shortcuts
    const Shortcuts = slots?.shortcuts ?? (0, $a2757c031fec5fda$export$8ba8fc65919fa1fe);
    const shortcutsProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Shortcuts,
        externalSlotProps: slotProps?.shortcuts,
        className: classes.shortcuts,
        ownerState: ownerState
    });
    const hasShortcuts = Array.isArray(shortcutsProps?.items) && shortcutsProps.items.length > 0;
    const shortcuts = view && !!Shortcuts ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Shortcuts, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, shortcutsProps)) : null;
    return {
        toolbar: toolbar,
        content: content,
        tabs: tabs,
        actionBar: actionBar,
        shortcuts: shortcuts,
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            hasShortcuts: hasShortcuts
        })
    };
};
var $93d540a51b4256a1$export$2e2bcd8739ae039 = $93d540a51b4256a1$var$usePickerLayout;




'use client';
const $c6a4a7c871810436$var$useUtilityClasses = (classes, ownerState)=>{
    const { pickerOrientation: pickerOrientation } = ownerState;
    const slots = {
        root: [
            'root',
            pickerOrientation === 'landscape' && 'landscape'
        ],
        contentWrapper: [
            'contentWrapper'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $155427cbf9212b77$export$1671c31de798d429), classes);
};
const $c6a4a7c871810436$export$9a9363506c13836 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersLayout',
    slot: 'Root'
})({
    display: 'grid',
    gridAutoColumns: 'max-content auto max-content',
    gridAutoRows: 'max-content auto max-content',
    [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).actionBar}`]: {
        gridColumn: '1 / 4',
        gridRow: 3
    },
    variants: [
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: false
            },
            style: {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: 1,
                    gridRow: '1 / 3'
                }
            }
        },
        {
            props: {
                pickerOrientation: 'landscape',
                hasShortcuts: true
            },
            style: {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1,
                    maxWidth: 'max-content'
                },
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: 2
                }
            }
        },
        {
            props: {
                pickerOrientation: 'portrait'
            },
            style: {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).toolbar}`]: {
                    gridColumn: '2 / 4',
                    gridRow: 1
                },
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 1,
                    gridRow: '2 / 3'
                }
            }
        },
        {
            props: {
                hasShortcuts: true,
                layoutDirection: 'rtl'
            },
            style: {
                [`& .${(0, $155427cbf9212b77$export$7a6dac186703fe4c).shortcuts}`]: {
                    gridColumn: 4
                }
            }
        }
    ]
});
const $c6a4a7c871810436$export$bc1494d918129235 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersLayout',
    slot: 'ContentWrapper'
})({
    gridColumn: '2 / 4',
    gridRow: 2,
    display: 'flex',
    flexDirection: 'column'
});
/**
 * Demos:
 *
 * - [Custom layout](https://mui.com/x/react-date-pickers/custom-layout/)
 *
 * API:
 *
 * - [PickersLayout API](https://mui.com/x/api/date-pickers/pickers-layout/)
 */ const $c6a4a7c871810436$export$647f604ea2397c05 = /*#__PURE__*/ $acw62.forwardRef(function PickersLayout(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersLayout'
    });
    const { toolbar: toolbar, content: content, tabs: tabs, actionBar: actionBar, shortcuts: shortcuts, ownerState: ownerState } = (0, $93d540a51b4256a1$export$2e2bcd8739ae039)(props);
    const { orientation: orientation, variant: variant } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const { sx: sx, className: className, classes: classesProp } = props;
    const classes = $c6a4a7c871810436$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c6a4a7c871810436$export$9a9363506c13836, {
        ref: ref,
        sx: sx,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        children: [
            orientation === 'landscape' ? shortcuts : toolbar,
            orientation === 'landscape' ? toolbar : shortcuts,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c6a4a7c871810436$export$bc1494d918129235, {
                className: classes.contentWrapper,
                ownerState: ownerState,
                children: variant === 'desktop' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        content,
                        tabs
                    ]
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        tabs,
                        content
                    ]
                })
            }),
            actionBar
        ]
    });
});




function $f154a91c12ef630c$export$57511d4166284144(parameters) {
    const { steps: steps } = parameters;
    return (0, $93c878f075509e16$export$768f745bfa10c92a)({
        steps: steps,
        isViewMatchingStep: (view, step)=>{
            return step.views == null || step.views.includes(view);
        },
        onStepChange: ({ step: step, defaultView: defaultView, setView: setView, view: view, views: views })=>{
            const targetView = step.views == null ? defaultView : step.views.find((viewBis)=>views.includes(viewBis));
            if (targetView !== view) setView(targetView);
        }
    });
}



const $921f50d8d6fdef68$var$_excluded = [
    "props",
    "steps"
], $921f50d8d6fdef68$var$_excluded2 = [
    "ownerState"
];
const $921f50d8d6fdef68$export$b1b70bc56ac5be0e = (_ref)=>{
    let { props: props, steps: steps } = _ref, pickerParams = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $921f50d8d6fdef68$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $f154a91c12ef630c$export$57511d4166284144)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $eb07fb7878304460$export$fc3313977ac596c4)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'desktop',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $921f50d8d6fdef68$var$_excluded2);
    const Layout = slots.layout ?? (0, $c6a4a7c871810436$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        popper: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.popper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c33c428cfda4b7d5$export$aae9fbe9dd4050fa), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slots,
                    slotProps: slotProps,
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d41682fbe562e739$export$ac84dff7cf037abd), {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Layout, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker: renderPicker
    };
};




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");

'use client';
const $d87bf966383f793e$var$SHARED_FIELD_INTERNAL_PROP_NAMES = [
    'value',
    'defaultValue',
    'referenceDate',
    'format',
    'formatDensity',
    'onChange',
    'timezone',
    'onError',
    'shouldRespectLeadingZeros',
    'selectedSections',
    'onSelectedSectionsChange',
    'unstableFieldRef',
    'unstableStartFieldRef',
    'unstableEndFieldRef',
    'enableAccessibleFieldDOMStructure',
    'disabled',
    'readOnly',
    'dateSeparator',
    'autoFocus',
    'focused'
];
const $d87bf966383f793e$export$be857fabf132acea = (props, valueType)=>{
    return $acw62.useMemo(()=>{
        const forwardedProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props);
        const internalProps = {};
        const extractProp = (propName)=>{
            if (forwardedProps.hasOwnProperty(propName)) {
                // @ts-ignore
                internalProps[propName] = forwardedProps[propName];
                delete forwardedProps[propName];
            }
        };
        $d87bf966383f793e$var$SHARED_FIELD_INTERNAL_PROP_NAMES.forEach(extractProp);
        if (valueType === 'date') (0, $ddd12d3841a65e00$export$430d9fc64cf058d6).forEach(extractProp);
        else if (valueType === 'time') (0, $ddd12d3841a65e00$export$fd5e0f8b4115a8c7).forEach(extractProp);
        else if (valueType === 'date-time') {
            (0, $ddd12d3841a65e00$export$430d9fc64cf058d6).forEach(extractProp);
            (0, $ddd12d3841a65e00$export$fd5e0f8b4115a8c7).forEach(extractProp);
            (0, $ddd12d3841a65e00$export$1df62d3ba2121371).forEach(extractProp);
        }
        return {
            forwardedProps: forwardedProps,
            internalProps: internalProps
        };
    }, [
        props,
        valueType
    ]);
}; /**
 * Extract the internal props from the props received by the field component.
 * This makes sure that the internal props not defined in the props are not present in the result.
 */ 






const $5fd1fe7e071df6b9$var$isQueryResponseWithoutValue = (response)=>response.saveQuery != null;
const $5fd1fe7e071df6b9$export$66d00048b8bb82f6 = ({ stateResponse: { localizedDigits: // States and derived states
localizedDigits, sectionsValueBoundaries: sectionsValueBoundaries, state: state, timezone: timezone, setCharacterQuery: // Methods to update the states
setCharacterQuery, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue } })=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const applyQuery = ({ keyPressed: keyPressed, sectionIndex: sectionIndex }, getFirstSectionValueMatchingWithQuery, isValidQueryValue)=>{
        const cleanKeyPressed = keyPressed.toLowerCase();
        const activeSection = state.sections[sectionIndex];
        // The current query targets the section being editing
        // We can try to concatenate the value
        if (state.characterQuery != null && (!isValidQueryValue || isValidQueryValue(state.characterQuery.value)) && state.characterQuery.sectionIndex === sectionIndex) {
            const concatenatedQueryValue = `${state.characterQuery.value}${cleanKeyPressed}`;
            const queryResponse = getFirstSectionValueMatchingWithQuery(concatenatedQueryValue, activeSection);
            if (!$5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(queryResponse)) {
                setCharacterQuery({
                    sectionIndex: sectionIndex,
                    value: concatenatedQueryValue,
                    sectionType: activeSection.type
                });
                return queryResponse;
            }
        }
        const queryResponse = getFirstSectionValueMatchingWithQuery(cleanKeyPressed, activeSection);
        if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(queryResponse) && !queryResponse.saveQuery) {
            setCharacterQuery(null);
            return null;
        }
        setCharacterQuery({
            sectionIndex: sectionIndex,
            value: cleanKeyPressed,
            sectionType: activeSection.type
        });
        if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(queryResponse)) return null;
        return queryResponse;
    };
    const applyLetterEditing = (params)=>{
        const findMatchingOptions = (format, options, queryValue)=>{
            const matchingValues = options.filter((option)=>option.toLowerCase().startsWith(queryValue));
            if (matchingValues.length === 0) return {
                saveQuery: false
            };
            return {
                sectionValue: matchingValues[0],
                shouldGoToNextSection: matchingValues.length === 1
            };
        };
        const testQueryOnFormatAndFallbackFormat = (queryValue, activeSection, fallbackFormat, formatFallbackValue)=>{
            const getOptions = (format)=>(0, $4a0e020deed3b4b7$export$3ee1e7e19c2b047a)(adapter, timezone, activeSection.type, format);
            if (activeSection.contentType === 'letter') return findMatchingOptions(activeSection.format, getOptions(activeSection.format), queryValue);
            // When editing a digit-format month / weekDay and the user presses a letter,
            // We can support the letter editing by using the letter-format month / weekDay and re-formatting the result.
            // We just have to make sure that the default month / weekDay format is a letter format,
            if (fallbackFormat && formatFallbackValue != null && (0, $4a0e020deed3b4b7$export$2f3c5fac7a2a65f6)(adapter, fallbackFormat).contentType === 'letter') {
                const fallbackOptions = getOptions(fallbackFormat);
                const response = findMatchingOptions(fallbackFormat, fallbackOptions, queryValue);
                if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(response)) return {
                    saveQuery: false
                };
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formatFallbackValue(response.sectionValue, fallbackOptions)
                });
            }
            return {
                saveQuery: false
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            switch(activeSection.type){
                case 'month':
                    {
                        const formatFallbackValue = (fallbackValue)=>(0, $4a0e020deed3b4b7$export$2816862a602354ce)(adapter, fallbackValue, adapter.formats.month, activeSection.format);
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.month, formatFallbackValue);
                    }
                case 'weekDay':
                    {
                        const formatFallbackValue = (fallbackValue, fallbackOptions)=>fallbackOptions.indexOf(fallbackValue).toString();
                        return testQueryOnFormatAndFallbackFormat(queryValue, activeSection, adapter.formats.weekday, formatFallbackValue);
                    }
                case 'meridiem':
                    return testQueryOnFormatAndFallbackFormat(queryValue, activeSection);
                default:
                    return {
                        saveQuery: false
                    };
            }
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery);
    };
    const applyNumericEditing = (params)=>{
        const getNewSectionValue = ({ queryValue: queryValue, skipIfBelowMinimum: skipIfBelowMinimum, section: section })=>{
            const cleanQueryValue = (0, $4a0e020deed3b4b7$export$7dd321105a319e8)(queryValue, localizedDigits);
            const queryValueNumber = Number(cleanQueryValue);
            const sectionBoundaries = sectionsValueBoundaries[section.type]({
                currentDate: null,
                format: section.format,
                contentType: section.contentType
            });
            if (queryValueNumber > sectionBoundaries.maximum) return {
                saveQuery: false
            };
            // If the user types `0` on a month section,
            // It is below the minimum, but we want to store the `0` in the query,
            // So that when he pressed `1`, it will store `01` and move to the next section.
            if (skipIfBelowMinimum && queryValueNumber < sectionBoundaries.minimum) return {
                saveQuery: true
            };
            const shouldGoToNextSection = queryValueNumber * 10 > sectionBoundaries.maximum || cleanQueryValue.length === sectionBoundaries.maximum.toString().length;
            const newSectionValue = (0, $4a0e020deed3b4b7$export$ef88db4bceade9fd)(adapter, queryValueNumber, sectionBoundaries, localizedDigits, section);
            return {
                sectionValue: newSectionValue,
                shouldGoToNextSection: shouldGoToNextSection
            };
        };
        const getFirstSectionValueMatchingWithQuery = (queryValue, activeSection)=>{
            if (activeSection.contentType === 'digit' || activeSection.contentType === 'digit-with-letter') return getNewSectionValue({
                queryValue: queryValue,
                skipIfBelowMinimum: false,
                section: activeSection
            });
            // When editing a letter-format month and the user presses a digit,
            // We can support the numeric editing by using the digit-format month and re-formatting the result.
            if (activeSection.type === 'month') {
                const hasLeadingZerosInFormat = (0, $4a0e020deed3b4b7$export$78b5830e2dd2de49)(adapter, 'digit', 'month', 'MM');
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: {
                        type: activeSection.type,
                        format: 'MM',
                        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
                        hasLeadingZerosInInput: true,
                        contentType: 'digit',
                        maxLength: 2
                    }
                });
                if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $4a0e020deed3b4b7$export$2816862a602354ce)(adapter, response.sectionValue, 'MM', activeSection.format);
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            // When editing a letter-format weekDay and the user presses a digit,
            // We can support the numeric editing by returning the nth day in the week day array.
            if (activeSection.type === 'weekDay') {
                const response = getNewSectionValue({
                    queryValue: queryValue,
                    skipIfBelowMinimum: true,
                    section: activeSection
                });
                if ($5fd1fe7e071df6b9$var$isQueryResponseWithoutValue(response)) return response;
                const formattedValue = (0, $4a0e020deed3b4b7$export$c65c7173f879039f)(adapter, activeSection.format)[Number(response.sectionValue) - 1];
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response, {
                    sectionValue: formattedValue
                });
            }
            return {
                saveQuery: false
            };
        };
        return applyQuery(params, getFirstSectionValueMatchingWithQuery, (queryValue)=>(0, $4a0e020deed3b4b7$export$c28be6c4c9d8f124)(queryValue, localizedDigits));
    };
    return (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((params)=>{
        const section = state.sections[params.sectionIndex];
        const isNumericEditing = (0, $4a0e020deed3b4b7$export$c28be6c4c9d8f124)(params.keyPressed, localizedDigits);
        const response = isNumericEditing ? applyNumericEditing((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
            keyPressed: (0, $4a0e020deed3b4b7$export$80dbbc19eba82070)(params.keyPressed, localizedDigits)
        })) : applyLetterEditing(params);
        if (response == null) {
            setTempAndroidValueStr(null);
            return;
        }
        updateSectionValue({
            section: section,
            newSectionValue: response.sectionValue,
            shouldGoToNextSection: response.shouldGoToNextSection
        });
    });
}; /**
 * The letter editing and the numeric editing each define a `CharacterEditingApplier`.
 * This function decides what the new section value should be and if the focus should switch to the next section.
 *
 * If it returns `null`, then the section value is not updated and the focus does not move.
 */  /**
 * Function called by `applyQuery` which decides:
 * - what is the new section value ?
 * - should the query used to get this value be stored for the next key press ?
 *
 * If it returns `{ sectionValue: string; shouldGoToNextSection: boolean }`,
 * Then we store the query and update the section with the new value.
 *
 * If it returns `{ saveQuery: true` },
 * Then we store the query and don't update the section.
 *
 * If it returns `{ saveQuery: false },
 * Then we do nothing.
 */ 




var $acw62 = parcelRequire("acw62");








const $2d53cb473eb5b582$var$expandFormat = ({ adapter: adapter, format: format })=>{
    // Expand the provided format
    let formatExpansionOverflow = 10;
    let prevFormat = format;
    let nextFormat = adapter.expandFormat(format);
    while(nextFormat !== prevFormat){
        prevFormat = nextFormat;
        nextFormat = adapter.expandFormat(prevFormat);
        formatExpansionOverflow -= 1;
        if (formatExpansionOverflow < 0) throw new Error('MUI X: The format expansion seems to be in an infinite loop. Please open an issue with the format passed to the component.');
    }
    return nextFormat;
};
const $2d53cb473eb5b582$var$getEscapedPartsFromFormat = ({ adapter: adapter, expandedFormat: expandedFormat })=>{
    const escapedParts = [];
    const { start: startChar, end: endChar } = adapter.escapedCharacters;
    const regExp = new RegExp(`(\\${startChar}[^\\${endChar}]*\\${endChar})+`, 'g');
    let match = null;
    // eslint-disable-next-line no-cond-assign
    while(match = regExp.exec(expandedFormat))escapedParts.push({
        start: match.index,
        end: regExp.lastIndex - 1
    });
    return escapedParts;
};
const $2d53cb473eb5b582$var$getSectionPlaceholder = (adapter, localeText, sectionConfig, sectionFormat)=>{
    switch(sectionConfig.type){
        case 'year':
            return localeText.fieldYearPlaceholder({
                digitAmount: adapter.formatByString(adapter.date(undefined, 'default'), sectionFormat).length,
                format: sectionFormat
            });
        case 'month':
            return localeText.fieldMonthPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'day':
            return localeText.fieldDayPlaceholder({
                format: sectionFormat
            });
        case 'weekDay':
            return localeText.fieldWeekDayPlaceholder({
                contentType: sectionConfig.contentType,
                format: sectionFormat
            });
        case 'hours':
            return localeText.fieldHoursPlaceholder({
                format: sectionFormat
            });
        case 'minutes':
            return localeText.fieldMinutesPlaceholder({
                format: sectionFormat
            });
        case 'seconds':
            return localeText.fieldSecondsPlaceholder({
                format: sectionFormat
            });
        case 'meridiem':
            return localeText.fieldMeridiemPlaceholder({
                format: sectionFormat
            });
        default:
            return sectionFormat;
    }
};
const $2d53cb473eb5b582$var$createSection = ({ adapter: adapter, date: date, shouldRespectLeadingZeros: shouldRespectLeadingZeros, localeText: localeText, localizedDigits: localizedDigits, now: now, token: token, startSeparator: startSeparator })=>{
    if (token === '') throw new Error('MUI X: Should not call `commitToken` with an empty token');
    const sectionConfig = (0, $4a0e020deed3b4b7$export$2f3c5fac7a2a65f6)(adapter, token);
    const hasLeadingZerosInFormat = (0, $4a0e020deed3b4b7$export$78b5830e2dd2de49)(adapter, sectionConfig.contentType, sectionConfig.type, token);
    const hasLeadingZerosInInput = shouldRespectLeadingZeros ? hasLeadingZerosInFormat : sectionConfig.contentType === 'digit';
    const isValidDate = adapter.isValid(date);
    let sectionValue = isValidDate ? adapter.formatByString(date, token) : '';
    let maxLength = null;
    if (hasLeadingZerosInInput) {
        if (hasLeadingZerosInFormat) maxLength = sectionValue === '' ? adapter.formatByString(now, token).length : sectionValue.length;
        else {
            if (sectionConfig.maxLength == null) throw new Error(`MUI X: The token ${token} should have a 'maxLength' property on it's adapter`);
            maxLength = sectionConfig.maxLength;
            if (isValidDate) sectionValue = (0, $4a0e020deed3b4b7$export$80dbbc19eba82070)((0, $4a0e020deed3b4b7$export$713c6d756c12fc27)((0, $4a0e020deed3b4b7$export$7dd321105a319e8)(sectionValue, localizedDigits), maxLength), localizedDigits);
        }
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionConfig, {
        format: token,
        maxLength: maxLength,
        value: sectionValue,
        placeholder: $2d53cb473eb5b582$var$getSectionPlaceholder(adapter, localeText, sectionConfig, token),
        hasLeadingZerosInFormat: hasLeadingZerosInFormat,
        hasLeadingZerosInInput: hasLeadingZerosInInput,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
};
const $2d53cb473eb5b582$var$buildSections = (parameters)=>{
    const { adapter: adapter, expandedFormat: expandedFormat, escapedParts: escapedParts } = parameters;
    const now = adapter.date(undefined);
    const sections = [];
    let startSeparator = '';
    // This RegExp tests if the beginning of a string corresponds to a supported token
    const validTokens = Object.keys(adapter.formatTokenMap).sort((a, b)=>b.length - a.length); // Sort to put longest word first
    const regExpFirstWordInFormat = /^([a-zA-Z]+)/;
    const regExpWordOnlyComposedOfTokens = new RegExp(`^(${validTokens.join('|')})*$`);
    const regExpFirstTokenInWord = new RegExp(`^(${validTokens.join('|')})`);
    const getEscapedPartOfCurrentChar = (i)=>escapedParts.find((escapeIndex)=>escapeIndex.start <= i && escapeIndex.end >= i);
    let i = 0;
    while(i < expandedFormat.length){
        const escapedPartOfCurrentChar = getEscapedPartOfCurrentChar(i);
        const isEscapedChar = escapedPartOfCurrentChar != null;
        const firstWordInFormat = regExpFirstWordInFormat.exec(expandedFormat.slice(i))?.[1];
        // The first word in the format is only composed of tokens.
        // We extract those tokens to create a new sections.
        if (!isEscapedChar && firstWordInFormat != null && regExpWordOnlyComposedOfTokens.test(firstWordInFormat)) {
            let word = firstWordInFormat;
            while(word.length > 0){
                const firstWord = regExpFirstTokenInWord.exec(word)[1];
                word = word.slice(firstWord.length);
                sections.push($2d53cb473eb5b582$var$createSection((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parameters, {
                    now: now,
                    token: firstWord,
                    startSeparator: startSeparator
                })));
                startSeparator = '';
            }
            i += firstWordInFormat.length;
        } else {
            const char = expandedFormat[i];
            // If we are on the opening or closing character of an escaped part of the format,
            // Then we ignore this character.
            const isEscapeBoundary = isEscapedChar && escapedPartOfCurrentChar?.start === i || escapedPartOfCurrentChar?.end === i;
            if (!isEscapeBoundary) {
                if (sections.length === 0) startSeparator += char;
                else {
                    sections[sections.length - 1].endSeparator += char;
                    sections[sections.length - 1].isEndFormatSeparator = true;
                }
            }
            i += 1;
        }
    }
    if (sections.length === 0 && startSeparator.length > 0) sections.push({
        type: 'empty',
        contentType: 'letter',
        maxLength: null,
        format: '',
        value: '',
        placeholder: '',
        hasLeadingZerosInFormat: false,
        hasLeadingZerosInInput: false,
        startSeparator: startSeparator,
        endSeparator: '',
        modified: false
    });
    return sections;
};
const $2d53cb473eb5b582$var$postProcessSections = ({ isRtl: isRtl, formatDensity: formatDensity, sections: sections })=>{
    return sections.map((section)=>{
        const cleanSeparator = (separator)=>{
            let cleanedSeparator = separator;
            if (isRtl && cleanedSeparator !== null && cleanedSeparator.includes(' ')) cleanedSeparator = `\u2069${cleanedSeparator}\u2066`;
            if (formatDensity === 'spacious' && [
                '/',
                '.',
                '-'
            ].includes(cleanedSeparator)) cleanedSeparator = ` ${cleanedSeparator} `;
            return cleanedSeparator;
        };
        section.startSeparator = cleanSeparator(section.startSeparator);
        section.endSeparator = cleanSeparator(section.endSeparator);
        return section;
    });
};
const $2d53cb473eb5b582$export$34084be60bfe3b3b = (parameters)=>{
    let expandedFormat = $2d53cb473eb5b582$var$expandFormat(parameters);
    if (parameters.isRtl && parameters.enableAccessibleFieldDOMStructure) expandedFormat = expandedFormat.split(' ').reverse().join(' ');
    const escapedParts = $2d53cb473eb5b582$var$getEscapedPartsFromFormat((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parameters, {
        expandedFormat: expandedFormat
    }));
    const sections = $2d53cb473eb5b582$var$buildSections((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parameters, {
        expandedFormat: expandedFormat,
        escapedParts: escapedParts
    }));
    return $2d53cb473eb5b582$var$postProcessSections((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, parameters, {
        sections: sections
    }));
};





'use client';
const $7a048fc6e80d7310$var$QUERY_LIFE_DURATION_MS = 5000;
const $7a048fc6e80d7310$export$4e8d6353e50062e7 = (parameters)=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const { manager: { validator: validator, valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: internalPropsWithDefaults, internalPropsWithDefaults: { value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, onChange: onChange, format: format, formatDensity: formatDensity = 'dense', selectedSections: selectedSectionsProp, onSelectedSectionsChange: onSelectedSectionsChange, shouldRespectLeadingZeros: shouldRespectLeadingZeros = false, timezone: timezoneProp, enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure = true }, forwardedProps: { error: errorProp } } = parameters;
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'a field component',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: valueManager
    });
    const valueRef = $acw62.useRef(value);
    $acw62.useEffect(()=>{
        valueRef.current = value;
    }, [
        value
    ]);
    const { hasValidationError: hasValidationError } = (0, $3811c2c4b61492d0$export$87fe492f99f25a20)({
        props: internalPropsWithDefaults,
        validator: validator,
        timezone: timezone,
        value: value,
        onError: internalPropsWithDefaults.onError
    });
    const error = $acw62.useMemo(()=>{
        // only override when `error` is undefined.
        // in case of multi input fields, the `error` value is provided externally and will always be defined.
        if (errorProp !== undefined) return errorProp;
        return hasValidationError;
    }, [
        hasValidationError,
        errorProp
    ]);
    const localizedDigits = $acw62.useMemo(()=>(0, $4a0e020deed3b4b7$export$b42be9ae7016ef5d)(adapter), [
        adapter
    ]);
    const sectionsValueBoundaries = $acw62.useMemo(()=>(0, $4a0e020deed3b4b7$export$360600f456ea7d5f)(adapter, localizedDigits, timezone), [
        adapter,
        localizedDigits,
        timezone
    ]);
    const getSectionsFromValue = $acw62.useCallback((valueToAnalyze)=>fieldValueManager.getSectionsFromValue(valueToAnalyze, (date)=>(0, $2d53cb473eb5b582$export$34084be60bfe3b3b)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            })), [
        fieldValueManager,
        format,
        translations,
        localizedDigits,
        isRtl,
        shouldRespectLeadingZeros,
        adapter,
        formatDensity,
        enableAccessibleFieldDOMStructure
    ]);
    const [state, setState] = $acw62.useState(()=>{
        const sections = getSectionsFromValue(value);
        (0, $4a0e020deed3b4b7$export$ef6fbc09372bd65c)(sections, valueType);
        const stateWithoutReferenceDate = {
            sections: sections,
            lastExternalValue: value,
            lastSectionsDependencies: {
                format: format,
                isRtl: isRtl,
                locale: adapter.locale
            },
            tempValueStrAndroid: null,
            characterQuery: null
        };
        const granularity = (0, $66a7cb510b2c76f4$export$3f2547ddf892237a)(sections);
        const referenceValue = valueManager.getInitialReferenceValue({
            referenceDate: referenceDateProp,
            value: value,
            adapter: adapter,
            props: internalPropsWithDefaults,
            granularity: granularity,
            timezone: timezone
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, stateWithoutReferenceDate, {
            referenceValue: referenceValue
        });
    });
    const [selectedSections, innerSetSelectedSections] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        controlled: selectedSectionsProp,
        default: null,
        name: 'useField',
        state: 'selectedSections'
    });
    const setSelectedSections = (newSelectedSections)=>{
        innerSetSelectedSections(newSelectedSections);
        onSelectedSectionsChange?.(newSelectedSections);
    };
    const parsedSelectedSections = $acw62.useMemo(()=>(0, $4a0e020deed3b4b7$export$b31f27a6e35a0b27)(selectedSections, state.sections), [
        selectedSections,
        state.sections
    ]);
    const activeSectionIndex = parsedSelectedSections === 'all' ? 0 : parsedSelectedSections;
    const sectionOrder = $acw62.useMemo(()=>(0, $4a0e020deed3b4b7$export$7725fd6fe0a2aadf)(state.sections, isRtl && !enableAccessibleFieldDOMStructure), [
        state.sections,
        isRtl,
        enableAccessibleFieldDOMStructure
    ]);
    const areAllSectionsEmpty = $acw62.useMemo(()=>state.sections.every((section)=>section.value === ''), [
        state.sections
    ]);
    const publishValue = (newValue)=>{
        const context = {
            validationError: validator({
                adapter: adapter,
                value: newValue,
                timezone: timezone,
                props: internalPropsWithDefaults
            })
        };
        handleValueChange(newValue, context);
    };
    const setSectionValue = (sectionIndex, newSectionValue)=>{
        const newSections = [
            ...state.sections
        ];
        newSections[sectionIndex] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newSections[sectionIndex], {
            value: newSectionValue,
            modified: true
        });
        return newSections;
    };
    const sectionToUpdateOnNextInvalidDateRef = $acw62.useRef(null);
    const updateSectionValueOnNextInvalidDateTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const setSectionUpdateToApplyOnNextInvalidDate = (newSectionValue)=>{
        if (activeSectionIndex == null) return;
        sectionToUpdateOnNextInvalidDateRef.current = {
            sectionIndex: activeSectionIndex,
            value: newSectionValue
        };
        updateSectionValueOnNextInvalidDateTimeout.start(0, ()=>{
            sectionToUpdateOnNextInvalidDateRef.current = null;
        });
    };
    const clearValue = ()=>{
        if (valueManager.areValuesEqual(adapter, value, valueManager.emptyValue)) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                sections: prevState.sections.map((section)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, section, {
                        value: ''
                    })),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(valueManager.emptyValue);
        }
    };
    const clearActiveSection = ()=>{
        if (activeSectionIndex == null) return;
        const activeSection = state.sections[activeSectionIndex];
        if (activeSection.value === '') return;
        setSectionUpdateToApplyOnNextInvalidDate('');
        if (fieldValueManager.getDateFromSection(value, activeSection) === null) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                sections: setSectionValue(activeSectionIndex, ''),
                tempValueStrAndroid: null,
                characterQuery: null
            }));
        else {
            setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                    characterQuery: null
                }));
            publishValue(fieldValueManager.updateDateInValue(value, activeSection, null));
        }
    };
    const updateValueFromValueStr = (valueStr)=>{
        const parseDateStr = (dateStr, referenceDate)=>{
            const date = adapter.parse(dateStr, format);
            if (!adapter.isValid(date)) return null;
            const sections = (0, $2d53cb473eb5b582$export$34084be60bfe3b3b)({
                adapter: adapter,
                localeText: translations,
                localizedDigits: localizedDigits,
                format: format,
                date: date,
                formatDensity: formatDensity,
                shouldRespectLeadingZeros: shouldRespectLeadingZeros,
                enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure,
                isRtl: isRtl
            });
            return (0, $4a0e020deed3b4b7$export$6c6df982c77f60a9)(adapter, date, sections, referenceDate, false);
        };
        const newValue = fieldValueManager.parseValueStr(valueStr, state.referenceValue, parseDateStr);
        publishValue(newValue);
    };
    const cleanActiveDateSectionsIfValueNullTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const updateSectionValue = ({ section: section, newSectionValue: newSectionValue, shouldGoToNextSection: shouldGoToNextSection })=>{
        updateSectionValueOnNextInvalidDateTimeout.clear();
        cleanActiveDateSectionsIfValueNullTimeout.clear();
        const activeDate = fieldValueManager.getDateFromSection(value, section);
        /**
     * Decide which section should be focused
     */ if (shouldGoToNextSection && activeSectionIndex < state.sections.length - 1) setSelectedSections(activeSectionIndex + 1);
        /**
     * Try to build a valid date from the new section value
     */ const newSections = setSectionValue(activeSectionIndex, newSectionValue);
        const newActiveDateSections = fieldValueManager.getDateSectionsFromValue(newSections, section);
        const newActiveDate = (0, $4a0e020deed3b4b7$export$b0c1bfd065bfe742)(adapter, newActiveDateSections, localizedDigits);
        /**
     * If the new date is valid,
     * Then we merge the value of the modified sections into the reference date.
     * This makes sure that we don't lose some information of the initial date (like the time on a date field).
     */ if (adapter.isValid(newActiveDate)) {
            const mergedDate = (0, $4a0e020deed3b4b7$export$6c6df982c77f60a9)(adapter, newActiveDate, newActiveDateSections, fieldValueManager.getDateFromSection(state.referenceValue, section), true);
            if (activeDate == null) cleanActiveDateSectionsIfValueNullTimeout.start(0, ()=>{
                if (valueRef.current === value) setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                        sections: fieldValueManager.clearDateSections(state.sections, section),
                        tempValueStrAndroid: null
                    }));
            });
            return publishValue(fieldValueManager.updateDateInValue(value, section, mergedDate));
        }
        /**
     * If all the sections are filled but the date is invalid and the previous date is valid or null,
     * Then we publish an invalid date.
     */ if (newActiveDateSections.every((sectionBis)=>sectionBis.value !== '') && (activeDate == null || adapter.isValid(activeDate))) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, newActiveDate));
        }
        /**
     * If the previous date is not null,
     * Then we publish the date as `null`.
     */ if (activeDate != null) {
            setSectionUpdateToApplyOnNextInvalidDate(newSectionValue);
            return publishValue(fieldValueManager.updateDateInValue(value, section, null));
        }
        /**
     * If the previous date is already null,
     * Then we don't publish the date and we update the sections.
     */ return setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                sections: newSections,
                tempValueStrAndroid: null
            }));
    };
    const setTempAndroidValueStr = (tempValueStrAndroid)=>setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                tempValueStrAndroid: tempValueStrAndroid
            }));
    const setCharacterQuery = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newCharacterQuery)=>{
        setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                characterQuery: newCharacterQuery
            }));
    });
    // If `prop.value` changes, we update the state to reflect the new value
    if (value !== state.lastExternalValue) {
        const isActiveDateInvalid = sectionToUpdateOnNextInvalidDateRef.current != null && !adapter.isValid(fieldValueManager.getDateFromSection(value, state.sections[sectionToUpdateOnNextInvalidDateRef.current.sectionIndex]));
        let sections;
        if (isActiveDateInvalid) sections = setSectionValue(sectionToUpdateOnNextInvalidDateRef.current.sectionIndex, sectionToUpdateOnNextInvalidDateRef.current.value);
        else sections = getSectionsFromValue(value);
        setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                lastExternalValue: value,
                sections: sections,
                sectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                referenceValue: isActiveDateInvalid ? prevState.referenceValue : fieldValueManager.updateReferenceValue(adapter, value, prevState.referenceValue),
                tempValueStrAndroid: null
            }));
    }
    if (isRtl !== state.lastSectionsDependencies.isRtl || format !== state.lastSectionsDependencies.format || adapter.locale !== state.lastSectionsDependencies.locale) {
        const sections = getSectionsFromValue(value);
        (0, $4a0e020deed3b4b7$export$ef6fbc09372bd65c)(sections, valueType);
        setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                lastSectionsDependencies: {
                    format: format,
                    isRtl: isRtl,
                    locale: adapter.locale
                },
                sections: sections,
                tempValueStrAndroid: null,
                characterQuery: null
            }));
    }
    if (state.characterQuery != null && !error && activeSectionIndex == null) setCharacterQuery(null);
    if (state.characterQuery != null && state.sections[state.characterQuery.sectionIndex]?.type !== state.characterQuery.sectionType) setCharacterQuery(null);
    $acw62.useEffect(()=>{
        if (sectionToUpdateOnNextInvalidDateRef.current != null) sectionToUpdateOnNextInvalidDateRef.current = null;
    });
    const cleanCharacterQueryTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    $acw62.useEffect(()=>{
        if (state.characterQuery != null) cleanCharacterQueryTimeout.start($7a048fc6e80d7310$var$QUERY_LIFE_DURATION_MS, ()=>setCharacterQuery(null));
        return ()=>{};
    }, [
        state.characterQuery,
        setCharacterQuery,
        cleanCharacterQueryTimeout
    ]);
    // If `tempValueStrAndroid` is still defined for some section when running `useEffect`,
    // Then `onChange` has only been called once, which means the user pressed `Backspace` to reset the section.
    // This causes a small flickering on Android,
    // But we can't use `useEnhancedEffect` which is always called before the second `onChange` call and then would cause false positives.
    $acw62.useEffect(()=>{
        if (state.tempValueStrAndroid != null && activeSectionIndex != null) clearActiveSection();
    }, [
        state.sections
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    return {
        activeSectionIndex: // States and derived states
        activeSectionIndex,
        areAllSectionsEmpty: areAllSectionsEmpty,
        error: error,
        localizedDigits: localizedDigits,
        parsedSelectedSections: parsedSelectedSections,
        sectionOrder: sectionOrder,
        sectionsValueBoundaries: sectionsValueBoundaries,
        state: state,
        timezone: timezone,
        value: value,
        clearValue: // Methods to update the states
        clearValue,
        clearActiveSection: clearActiveSection,
        setCharacterQuery: setCharacterQuery,
        setSelectedSections: setSelectedSections,
        setTempAndroidValueStr: setTempAndroidValueStr,
        updateSectionValue: updateSectionValue,
        updateValueFromValueStr: updateValueFromValueStr,
        getSectionsFromValue: // Utilities methods
        getSectionsFromValue
    };
};




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

'use client';
const $38272c59950c5653$export$20c6f014e602a134 = ()=>$acw62.useContext((0, $bc077554c64169c5$export$b72b8dade9393cd5));



function $31671c418f538ceb$export$e2fe2bbcb0489bc7(parameters) {
    const { manager: { internal_useApplyDefaultValuesToFieldInternalProps: useApplyDefaultValuesToFieldInternalProps }, internalProps: internalProps, skipContextFieldRefAssignment: skipContextFieldRefAssignment } = parameters;
    const pickerContext = (0, $38272c59950c5653$export$20c6f014e602a134)();
    const fieldPrivateContext = (0, $20b835eaf21df543$export$700ab01cf24fdb1)();
    const handleFieldRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(internalProps.unstableFieldRef, skipContextFieldRefAssignment ? null : fieldPrivateContext?.fieldRef);
    const setValue = pickerContext?.setValue;
    const handleChangeFromPicker = $acw62.useCallback((newValue, ctx)=>{
        return setValue?.(newValue, {
            validationError: ctx.validationError,
            shouldClose: false
        });
    }, [
        setValue
    ]);
    const internalPropsWithDefaultsFromContext = $acw62.useMemo(()=>{
        // If one of the context is null,
        // Then the field is used as a standalone component and the other context will be null as well.
        if (fieldPrivateContext != null && pickerContext != null) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            value: pickerContext.value,
            onChange: handleChangeFromPicker,
            timezone: pickerContext.timezone,
            disabled: pickerContext.disabled,
            readOnly: pickerContext.readOnly,
            autoFocus: pickerContext.autoFocus && !pickerContext.open,
            focused: pickerContext.open ? true : undefined,
            format: pickerContext.fieldFormat,
            formatDensity: fieldPrivateContext.formatDensity,
            enableAccessibleFieldDOMStructure: fieldPrivateContext.enableAccessibleFieldDOMStructure,
            selectedSections: fieldPrivateContext.selectedSections,
            onSelectedSectionsChange: fieldPrivateContext.onSelectedSectionsChange,
            unstableFieldRef: handleFieldRef
        }, internalProps);
        return internalProps;
    }, [
        pickerContext,
        fieldPrivateContext,
        internalProps,
        handleChangeFromPicker,
        handleFieldRef
    ]);
    return useApplyDefaultValuesToFieldInternalProps(internalPropsWithDefaultsFromContext);
}




function $0536e200dfbb7842$export$ce8bf2f461033ebb(parameters) {
    const { focused: focused, domGetters: domGetters, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, state: state } } = parameters;
    if (!domGetters.isReady()) return;
    const selection = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(domGetters.getRoot()).getSelection();
    if (!selection) return;
    if (parsedSelectedSections == null) {
        // If the selection contains an element inside the field, we reset it.
        if (selection.rangeCount > 0 && // Firefox can return a Restricted object here
        selection.getRangeAt(0).startContainer instanceof Node && domGetters.getRoot().contains(selection.getRangeAt(0).startContainer)) selection.removeAllRanges();
        if (focused) domGetters.getRoot().blur();
        return;
    }
    // On multi input range pickers we want to update selection range only for the active input
    if (!domGetters.getRoot().contains((0, $7c44784990d74e44$export$cd4e5573fbe2b576)(domGetters.getRoot()))) return;
    const range = new window.Range();
    let target;
    if (parsedSelectedSections === 'all') target = domGetters.getRoot();
    else {
        const section = state.sections[parsedSelectedSections];
        if (section.type === 'empty') target = domGetters.getSectionContainer(parsedSelectedSections);
        else target = domGetters.getSectionContent(parsedSelectedSections);
    }
    range.selectNodeContents(target);
    target.focus();
    selection.removeAllRanges();
    selection.addRange(range);
}







function $259504e265932f66$export$35b4b3d12d0cd3bd(parameters) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { manager: { internal_fieldValueManager: fieldValueManager }, internalPropsWithDefaults: { minutesStep: minutesStep, disabled: disabled, readOnly: readOnly }, stateResponse: { state: // States and derived states
    state, value: value, activeSectionIndex: activeSectionIndex, parsedSelectedSections: parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, localizedDigits: localizedDigits, timezone: timezone, sectionOrder: sectionOrder, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue } } = parameters;
    return (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        // eslint-disable-next-line default-case
        switch(true){
            // Select all
            case (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'A' && !event.shiftKey && !event.altKey:
                // prevent default to make sure that the next line "select all" while updating
                // the internal state at the same time.
                event.preventDefault();
                setSelectedSections('all');
                break;
            // Move selection to next section
            case event.key === 'ArrowRight':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.startIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.endIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].rightIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Move selection to previous section
            case event.key === 'ArrowLeft':
                event.preventDefault();
                if (parsedSelectedSections == null) setSelectedSections(sectionOrder.endIndex);
                else if (parsedSelectedSections === 'all') setSelectedSections(sectionOrder.startIndex);
                else {
                    const nextSectionIndex = sectionOrder.neighbors[parsedSelectedSections].leftIndex;
                    if (nextSectionIndex !== null) setSelectedSections(nextSectionIndex);
                }
                break;
            // Reset the value of the selected section
            case event.key === 'Delete':
                event.preventDefault();
                if (readOnly) break;
                if (parsedSelectedSections == null || parsedSelectedSections === 'all') clearValue();
                else clearActiveSection();
                break;
            // Increment / decrement the selected section value
            case [
                'ArrowUp',
                'ArrowDown',
                'Home',
                'End',
                'PageUp',
                'PageDown'
            ].includes(event.key):
                {
                    event.preventDefault();
                    if (readOnly || activeSectionIndex == null) break;
                    // if all sections are selected, mark the currently editing one as selected
                    if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
                    const activeSection = state.sections[activeSectionIndex];
                    const newSectionValue = $259504e265932f66$var$adjustSectionValue(adapter, timezone, activeSection, event.key, sectionsValueBoundaries, localizedDigits, fieldValueManager.getDateFromSection(value, activeSection), {
                        minutesStep: minutesStep
                    });
                    updateSectionValue({
                        section: activeSection,
                        newSectionValue: newSectionValue,
                        shouldGoToNextSection: false
                    });
                    break;
                }
        }
    });
}
function $259504e265932f66$var$getDeltaFromKeyCode(keyCode) {
    switch(keyCode){
        case 'ArrowUp':
            return 1;
        case 'ArrowDown':
            return -1;
        case 'PageUp':
            return 5;
        case 'PageDown':
            return -5;
        default:
            return 0;
    }
}
function $259504e265932f66$var$adjustSectionValue(adapter, timezone, section, keyCode, sectionsValueBoundaries, localizedDigits, activeDate, stepsAttributes) {
    const delta = $259504e265932f66$var$getDeltaFromKeyCode(keyCode);
    const isStart = keyCode === 'Home';
    const isEnd = keyCode === 'End';
    const shouldSetAbsolute = section.value === '' || isStart || isEnd;
    const adjustDigitSection = ()=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: activeDate,
            format: section.format,
            contentType: section.contentType
        });
        const getCleanValue = (value)=>(0, $4a0e020deed3b4b7$export$ef88db4bceade9fd)(adapter, value, sectionBoundaries, localizedDigits, section);
        const step = section.type === 'minutes' && stepsAttributes?.minutesStep ? stepsAttributes.minutesStep : 1;
        let newSectionValueNumber;
        if (shouldSetAbsolute) {
            if (section.type === 'year' && !isEnd && !isStart) return adapter.formatByString(adapter.date(undefined, timezone), section.format);
            if (delta > 0 || isStart) newSectionValueNumber = sectionBoundaries.minimum;
            else newSectionValueNumber = sectionBoundaries.maximum;
        } else {
            const currentSectionValue = parseInt((0, $4a0e020deed3b4b7$export$7dd321105a319e8)(section.value, localizedDigits), 10);
            newSectionValueNumber = currentSectionValue + delta * step;
        }
        if (newSectionValueNumber % step !== 0) {
            if (delta < 0 || isStart) newSectionValueNumber += step - (step + newSectionValueNumber) % step; // for JS -3 % 5 = -3 (should be 2)
            if (delta > 0 || isEnd) newSectionValueNumber -= newSectionValueNumber % step;
        }
        if (newSectionValueNumber > sectionBoundaries.maximum) return getCleanValue(sectionBoundaries.minimum + (newSectionValueNumber - sectionBoundaries.maximum - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        if (newSectionValueNumber < sectionBoundaries.minimum) return getCleanValue(sectionBoundaries.maximum - (sectionBoundaries.minimum - newSectionValueNumber - 1) % (sectionBoundaries.maximum - sectionBoundaries.minimum + 1));
        return getCleanValue(newSectionValueNumber);
    };
    const adjustLetterSection = ()=>{
        const options = (0, $4a0e020deed3b4b7$export$3ee1e7e19c2b047a)(adapter, timezone, section.type, section.format);
        if (options.length === 0) return section.value;
        if (shouldSetAbsolute) {
            if (delta > 0 || isStart) return options[0];
            return options[options.length - 1];
        }
        const currentOptionIndex = options.indexOf(section.value);
        const newOptionIndex = (currentOptionIndex + delta) % options.length;
        const clampedIndex = (newOptionIndex + options.length) % options.length;
        return options[clampedIndex];
    };
    if (section.contentType === 'digit' || section.contentType === 'digit-with-letter') return adjustDigitSection();
    return adjustLetterSection();
}




function $3deb6ecb213f842a$export$45510bb94d9a4b66(parameters) {
    const { manager: manager, focused: focused, setFocused: setFocused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, internalPropsWithDefaults: internalPropsWithDefaults, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionOrder: sectionOrder, state: state, clearValue: // Methods to update the states
    clearValue, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    // TODO: Inline onContainerKeyDown once the old DOM structure is removed
    const handleKeyDown = (0, $259504e265932f66$export$35b4b3d12d0cd3bd)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse
    });
    const containerClickTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const handleClick = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (disabled || !domGetters.isReady()) return;
        setFocused(true);
        if (parsedSelectedSections === 'all') containerClickTimeout.start(0, ()=>{
            const cursorPosition = document.getSelection().getRangeAt(0).startOffset;
            if (cursorPosition === 0) {
                setSelectedSections(sectionOrder.startIndex);
                return;
            }
            let sectionIndex = 0;
            let cursorOnStartOfSection = 0;
            while(cursorOnStartOfSection < cursorPosition && sectionIndex < state.sections.length){
                const section = state.sections[sectionIndex];
                sectionIndex += 1;
                cursorOnStartOfSection += `${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`.length;
            }
            setSelectedSections(sectionIndex - 1);
        });
        else if (!focused) {
            setFocused(true);
            setSelectedSections(sectionOrder.startIndex);
        } else {
            const hasClickedOnASection = domGetters.getRoot().contains(event.target);
            if (!hasClickedOnASection) setSelectedSections(sectionOrder.startIndex);
        }
    });
    const handleInput = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (!domGetters.isReady() || parsedSelectedSections !== 'all') return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        domGetters.getRoot().innerHTML = state.sections.map((section)=>`${section.startSeparator}${section.value || section.placeholder}${section.endSeparator}`).join('');
        (0, $0536e200dfbb7842$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
        if (keyPressed.length === 0 || keyPressed.charCodeAt(0) === 10) {
            clearValue();
            setSelectedSections('all');
        } else if (keyPressed.length > 1) updateValueFromValueStr(keyPressed);
        else {
            if (parsedSelectedSections === 'all') setSelectedSections(0);
            applyCharacterEditing({
                keyPressed: keyPressed,
                sectionIndex: 0
            });
        }
    });
    const handlePaste = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (readOnly || parsedSelectedSections !== 'all') {
            event.preventDefault();
            return;
        }
        const pastedValue = event.clipboardData.getData('text');
        event.preventDefault();
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        if (focused || disabled || !domGetters.isReady()) return;
        const activeElement = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(domGetters.getRoot());
        setFocused(true);
        const isFocusInsideASection = domGetters.getSectionIndexFromDOMElement(activeElement) != null;
        if (!isFocusInsideASection) setSelectedSections(sectionOrder.startIndex);
    });
    const handleBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        setTimeout(()=>{
            if (!domGetters.isReady()) return;
            const activeElement = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(domGetters.getRoot());
            const shouldBlur = !domGetters.getRoot().contains(activeElement);
            if (shouldBlur) {
                setFocused(false);
                setSelectedSections(null);
            }
        });
    });
    return {
        // Event handlers
        onKeyDown: handleKeyDown,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onClick: handleClick,
        onPaste: handlePaste,
        onInput: handleInput,
        // Other
        contentEditable: parsedSelectedSections === 'all',
        tabIndex: internalPropsWithDefaults.disabled || parsedSelectedSections === 0 ? -1 : 0 // TODO: Try to set to undefined when there is a section selected.
    };
}



var $acw62 = parcelRequire("acw62");

function $73c4b20a15544393$export$9c7e79f1afdc4487(parameters) {
    const { manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, state: state, updateValueFromValueStr: // Methods to update the states
    updateValueFromValueStr } } = parameters;
    const handleChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        updateValueFromValueStr(event.target.value);
    });
    const valueStr = $acw62.useMemo(()=>areAllSectionsEmpty ? '' : fieldValueManager.getV7HiddenInputValueFromSections(state.sections), [
        areAllSectionsEmpty,
        state.sections,
        fieldValueManager
    ]);
    return {
        value: valueStr,
        onChange: handleChange
    };
}



var $acw62 = parcelRequire("acw62");
function $3e4c3a1655c6f6d0$export$b8da0597bcdfa361(parameters) {
    const { stateResponse: { setSelectedSections: // Methods to update the states
    setSelectedSections }, internalPropsWithDefaults: { disabled: disabled = false } } = parameters;
    const createHandleClick = $acw62.useCallback((sectionIndex)=>(event)=>{
            // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
            // We avoid this by checking if the call to this function is actually intended, or a side effect.
            if (disabled || event.isDefaultPrevented()) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $acw62.useCallback((sectionIndex)=>({
            'data-sectionindex': sectionIndex,
            onClick: createHandleClick(sectionIndex)
        }), [
        createHandleClick
    ]);
}



var $acw62 = parcelRequire("acw62");



function $90a949e99722d90f$export$ef10e76e860835f1(parameters) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const { focused: focused, domGetters: domGetters, stateResponse: stateResponse, applyCharacterEditing: applyCharacterEditing, manager: { internal_fieldValueManager: fieldValueManager }, stateResponse: { parsedSelectedSections: // States and derived states
    parsedSelectedSections, sectionsValueBoundaries: sectionsValueBoundaries, state: state, value: value, clearActiveSection: // Methods to update the states
    clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr }, internalPropsWithDefaults: { disabled: disabled = false, readOnly: readOnly = false } } = parameters;
    const isContainerEditable = parsedSelectedSections === 'all';
    const isEditable = !isContainerEditable && !disabled && !readOnly;
    /**
   * If a section content has been updated with a value we don't want to keep,
   * Then we need to imperatively revert it (we can't let React do it because the value did not change in his internal representation).
   */ const revertDOMSectionChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((sectionIndex)=>{
        if (!domGetters.isReady()) return;
        const section = state.sections[sectionIndex];
        domGetters.getSectionContent(sectionIndex).innerHTML = section.value || section.placeholder;
        (0, $0536e200dfbb7842$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    const handleInput = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (!domGetters.isReady()) return;
        const target = event.target;
        const keyPressed = target.textContent ?? '';
        const sectionIndex = domGetters.getSectionIndexFromDOMElement(target);
        const section = state.sections[sectionIndex];
        if (readOnly) {
            revertDOMSectionChange(sectionIndex);
            return;
        }
        if (keyPressed.length === 0) {
            if (section.value === '') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            const inputType = event.nativeEvent.inputType;
            if (inputType === 'insertParagraph' || inputType === 'insertLineBreak') {
                revertDOMSectionChange(sectionIndex);
                return;
            }
            revertDOMSectionChange(sectionIndex);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: sectionIndex
        });
        // The DOM value needs to remain the one React is expecting.
        revertDOMSectionChange(sectionIndex);
    });
    const handleMouseUp = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // Without this, the browser will remove the selected when clicking inside an already-selected section.
        event.preventDefault();
    });
    const handlePaste = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // prevent default to avoid the input `onInput` handler being called
        event.preventDefault();
        if (readOnly || disabled || typeof parsedSelectedSections !== 'number') return;
        const activeSection = state.sections[parsedSelectedSections];
        const pastedValue = event.clipboardData.getData('text');
        const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
        const digitsOnly = /^[0-9]+$/.test(pastedValue);
        const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
        const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
        if (isValidPastedValue) {
            setCharacterQuery(null);
            updateSectionValue({
                section: activeSection,
                newSectionValue: pastedValue,
                shouldGoToNextSection: true
            });
        } else if (!lettersOnly && !digitsOnly) {
            setCharacterQuery(null);
            updateValueFromValueStr(pastedValue);
        }
    });
    const handleDragOver = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        event.dataTransfer.dropEffect = 'none';
    });
    const createFocusHandler = $acw62.useCallback((sectionIndex)=>()=>{
            if (disabled) return;
            setSelectedSections(sectionIndex);
        }, [
        disabled,
        setSelectedSections
    ]);
    return $acw62.useCallback((section, sectionIndex)=>{
        const sectionBoundaries = sectionsValueBoundaries[section.type]({
            currentDate: fieldValueManager.getDateFromSection(value, section),
            contentType: section.contentType,
            format: section.format
        });
        return {
            // Event handlers
            onInput: handleInput,
            onPaste: handlePaste,
            onMouseUp: handleMouseUp,
            onDragOver: handleDragOver,
            onFocus: createFocusHandler(sectionIndex),
            // Aria attributes
            'aria-readonly': readOnly,
            'aria-valuenow': $90a949e99722d90f$var$getSectionValueNow(section, adapter),
            'aria-valuemin': sectionBoundaries.minimum,
            'aria-valuemax': sectionBoundaries.maximum,
            'aria-valuetext': section.value ? $90a949e99722d90f$var$getSectionValueText(section, adapter) : translations.empty,
            'aria-label': translations[section.type],
            'aria-disabled': disabled,
            // Other
            tabIndex: !isEditable || isContainerEditable || sectionIndex > 0 ? -1 : 0,
            contentEditable: !isContainerEditable && !disabled && !readOnly,
            role: 'spinbutton',
            'data-range-position': section.dateName || undefined,
            spellCheck: isEditable ? false : undefined,
            // Firefox hydrates this as `'none`' instead of `'off'`. No problems in chromium with both values.
            // For reference https://github.com/mui/mui-x/issues/19012
            autoCapitalize: isEditable ? 'none' : undefined,
            autoCorrect: isEditable ? 'off' : undefined,
            children: section.value || section.placeholder,
            inputMode: section.contentType === 'letter' ? 'text' : 'numeric'
        };
    }, [
        sectionsValueBoundaries,
        isContainerEditable,
        disabled,
        readOnly,
        isEditable,
        translations,
        adapter,
        handleInput,
        handlePaste,
        handleMouseUp,
        handleDragOver,
        createFocusHandler,
        fieldValueManager,
        value
    ]);
}
function $90a949e99722d90f$var$getSectionValueText(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'month':
            {
                if (section.contentType === 'digit') {
                    const dateWithMonth = adapter.setMonth(adapter.date(), Number(section.value) - 1);
                    return adapter.isValid(dateWithMonth) ? adapter.format(dateWithMonth, 'month') : '';
                }
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate && adapter.isValid(parsedDate) ? adapter.format(parsedDate, 'month') : undefined;
            }
        case 'day':
            if (section.contentType === 'digit') {
                const dateWithDay = adapter.setDate(adapter.startOfYear(adapter.date()), Number(section.value));
                return adapter.isValid(dateWithDay) ? adapter.format(dateWithDay, 'dayOfMonthFull') : '';
            }
            return section.value;
        case 'weekDay':
            // TODO: improve by providing the label of the week day
            return undefined;
        default:
            return undefined;
    }
}
function $90a949e99722d90f$var$getSectionValueNow(section, adapter) {
    if (!section.value) return undefined;
    switch(section.type){
        case 'weekDay':
            if (section.contentType === 'letter') // TODO: improve by resolving the week day number from a letter week day
            return undefined;
            return Number(section.value);
        case 'meridiem':
            {
                const parsedDate = adapter.parse(`01:00 ${section.value}`, `${adapter.formats.hours12h}:${adapter.formats.minutes} ${section.format}`);
                if (parsedDate) return adapter.getHours(parsedDate) >= 12 ? 1 : 0;
                return undefined;
            }
        case 'day':
            return section.contentType === 'digit-with-letter' ? parseInt(section.value, 10) : Number(section.value);
        case 'month':
            {
                if (section.contentType === 'digit') return Number(section.value);
                const parsedDate = adapter.parse(section.value, section.format);
                return parsedDate ? adapter.getMonth(parsedDate) + 1 : undefined;
            }
        default:
            return section.contentType !== 'letter' ? Number(section.value) : undefined;
    }
}


'use client';
const $6837d80005de3c6f$export$3b5f62b9baf9717e = (parameters)=>{
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $d87bf966383f793e$export$be857fabf132acea)(props, valueType);
    const internalPropsWithDefaults = (0, $31671c418f538ceb$export$e2fe2bbcb0489bc7)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { sectionListRef: sectionListRefProp, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable } = forwardedProps;
    const { disabled: disabled = false, readOnly: readOnly = false, autoFocus: autoFocus = false, focused: focusedProp, unstableFieldRef: unstableFieldRef } = internalPropsWithDefaults;
    const sectionListRef = $acw62.useRef(null);
    const handleSectionListRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(sectionListRefProp, sectionListRef);
    const domGetters = $acw62.useMemo(()=>({
            isReady: ()=>sectionListRef.current != null,
            getRoot: ()=>sectionListRef.current.getRoot(),
            getSectionContainer: (sectionIndex)=>sectionListRef.current.getSectionContainer(sectionIndex),
            getSectionContent: (sectionIndex)=>sectionListRef.current.getSectionContent(sectionIndex),
            getSectionIndexFromDOMElement: (element)=>sectionListRef.current.getSectionIndexFromDOMElement(element)
        }), [
        sectionListRef
    ]);
    const stateResponse = (0, $7a048fc6e80d7310$export$4e8d6353e50062e7)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { areAllSectionsEmpty: // States and derived states
    areAllSectionsEmpty, error: error, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, setSelectedSections: setSelectedSections } = stateResponse;
    const applyCharacterEditing = (0, $5fd1fe7e071df6b9$export$66d00048b8bb82f6)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const [focused, setFocused] = $acw62.useState(false);
    function focusField(newSelectedSections = 0) {
        if (disabled || !sectionListRef.current || // if the field is already focused, we don't need to focus it again
        $6837d80005de3c6f$var$getActiveSectionIndex(sectionListRef) != null) return;
        const newParsedSelectedSections = (0, $4a0e020deed3b4b7$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
        setFocused(true);
        sectionListRef.current.getSectionContent(newParsedSelectedSections).focus();
    }
    const rootProps = (0, $3deb6ecb213f842a$export$45510bb94d9a4b66)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        focused: focused,
        setFocused: setFocused,
        domGetters: domGetters
    });
    const hiddenInputProps = (0, $73c4b20a15544393$export$9c7e79f1afdc4487)({
        manager: manager,
        stateResponse: stateResponse
    });
    const createSectionContainerProps = (0, $3e4c3a1655c6f6d0$export$b8da0597bcdfa361)({
        stateResponse: stateResponse,
        internalPropsWithDefaults: internalPropsWithDefaults
    });
    const createSectionContentProps = (0, $90a949e99722d90f$export$ef10e76e860835f1)({
        manager: manager,
        stateResponse: stateResponse,
        applyCharacterEditing: applyCharacterEditing,
        internalPropsWithDefaults: internalPropsWithDefaults,
        domGetters: domGetters,
        focused: focused
    });
    const handleRootKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onKeyDown?.(event);
        rootProps.onKeyDown(event);
    });
    const handleRootBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onBlur?.(event);
        rootProps.onBlur(event);
    });
    const handleRootFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onFocus?.(event);
        rootProps.onFocus(event);
    });
    const handleRootClick = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        // The click event on the clear or open button would propagate to the input, trigger this handler and result in an inadvertent section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a propagated call, which should be skipped.
        if (event.isDefaultPrevented()) return;
        onClick?.(event);
        rootProps.onClick(event);
    });
    const handleRootPaste = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        rootProps.onPaste(event);
    });
    const handleRootInput = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onInput?.(event);
        rootProps.onInput(event);
    });
    const handleClear = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!$6837d80005de3c6f$var$isFieldFocused(sectionListRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const elements = $acw62.useMemo(()=>{
        return state.sections.map((section, sectionIndex)=>{
            const content = createSectionContentProps(section, sectionIndex);
            return {
                container: createSectionContainerProps(sectionIndex),
                content: createSectionContentProps(section, sectionIndex),
                before: {
                    children: section.startSeparator
                },
                after: {
                    children: section.endSeparator,
                    'data-range-position': section.isEndFormatSeparator ? content['data-range-position'] : undefined
                }
            };
        });
    }, [
        state.sections,
        createSectionContainerProps,
        createSectionContentProps
    ]);
    $acw62.useEffect(()=>{
        if (sectionListRef.current == null) throw new Error([
            'MUI X: The `sectionListRef` prop has not been initialized by `PickersSectionList`',
            'You probably tried to pass a component to the `textField` slot that contains an `<input />` element instead of a `PickersSectionList`.',
            '',
            'If you want to keep using an `<input />` HTML element for the editing, please add the `enableAccessibleFieldDOMStructure={false}` prop to your Picker or Field component:',
            '',
            '<DatePicker enableAccessibleFieldDOMStructure={false} slots={{ textField: MyCustomTextField }} />',
            '',
            'Learn more about the field accessible DOM structure on the MUI documentation: https://mui.com/x/react-date-pickers/fields/#fields-to-edit-a-single-element'
        ].join('\n'));
        if (autoFocus && !disabled && sectionListRef.current) sectionListRef.current.getSectionContent(sectionOrder.startIndex).focus();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!focused || !sectionListRef.current) return;
        if (parsedSelectedSections === 'all') sectionListRef.current.getRoot().focus();
        else if (typeof parsedSelectedSections === 'number') {
            const domElement = sectionListRef.current.getSectionContent(parsedSelectedSections);
            if (domElement) domElement.focus();
        }
    }, [
        parsedSelectedSections,
        focused
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        (0, $0536e200dfbb7842$export$ce8bf2f461033ebb)({
            focused: focused,
            domGetters: domGetters,
            stateResponse: stateResponse
        });
    });
    $acw62.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>$6837d80005de3c6f$var$getActiveSectionIndex(sectionListRef),
            setSelectedSections: (newSelectedSections)=>{
                if (disabled || !sectionListRef.current) return;
                const newParsedSelectedSections = (0, $4a0e020deed3b4b7$export$b31f27a6e35a0b27)(newSelectedSections, state.sections);
                const newActiveSectionIndex = newParsedSelectedSections === 'all' ? 0 : newParsedSelectedSections;
                setFocused(newActiveSectionIndex !== null);
                setSelectedSections(newSelectedSections);
            },
            focusField: focusField,
            isFieldFocused: ()=>$6837d80005de3c6f$var$isFieldFocused(sectionListRef)
        }));
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, forwardedProps, rootProps, {
        onBlur: handleRootBlur,
        onClick: handleRootClick,
        onFocus: handleRootFocus,
        onInput: handleRootInput,
        onPaste: handleRootPaste,
        onKeyDown: handleRootKeyDown,
        onClear: handleClear
    }, hiddenInputProps, {
        error: error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        focused: focusedProp ?? focused,
        sectionListRef: handleSectionListRef,
        // Additional
        enableAccessibleFieldDOMStructure: true,
        elements: elements,
        areAllSectionsEmpty: areAllSectionsEmpty,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
function $6837d80005de3c6f$var$getActiveSectionIndex(sectionListRef) {
    const activeElement = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(sectionListRef.current?.getRoot());
    if (!activeElement || !sectionListRef.current || !sectionListRef.current.getRoot().contains(activeElement)) return null;
    return sectionListRef.current.getSectionIndexFromDOMElement(activeElement);
}
function $6837d80005de3c6f$var$isFieldFocused(sectionListRef) {
    const activeElement = (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(sectionListRef.current?.getRoot());
    return !!sectionListRef.current && sectionListRef.current.getRoot().contains(activeElement);
}




var $acw62 = parcelRequire("acw62");












'use client';
const $691502d482840442$var$cleanString = (dirtyString)=>dirtyString.replace(/[\u2066\u2067\u2068\u2069]/g, '');
const $691502d482840442$export$8bb5d1c9951d10ca = (sections, localizedDigits, isRtl)=>{
    let position = 0;
    let positionInInput = isRtl ? 1 : 0;
    const newSections = [];
    for(let i = 0; i < sections.length; i += 1){
        const section = sections[i];
        const renderedValue = (0, $4a0e020deed3b4b7$export$85daa91f6c6e875f)(section, isRtl ? 'input-rtl' : 'input-ltr', localizedDigits);
        const sectionStr = `${section.startSeparator}${renderedValue}${section.endSeparator}`;
        const sectionLength = $691502d482840442$var$cleanString(sectionStr).length;
        const sectionLengthInInput = sectionStr.length;
        // The ...InInput values consider the unicode characters but do include them in their indexes
        const cleanedValue = $691502d482840442$var$cleanString(renderedValue);
        const startInInput = positionInInput + (cleanedValue === '' ? 0 : renderedValue.indexOf(cleanedValue[0])) + section.startSeparator.length;
        const endInInput = startInInput + cleanedValue.length;
        newSections.push((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, section, {
            start: position,
            end: position + sectionLength,
            startInInput: startInInput,
            endInInput: endInInput
        }));
        position += sectionLength;
        // Move position to the end of string associated to the current section
        positionInInput += sectionLengthInInput;
    }
    return newSections;
};
const $691502d482840442$export$4995d3b7b56fcd3f = (parameters)=>{
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const focusTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const selectionSyncTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const { props: props, manager: manager, skipContextFieldRefAssignment: skipContextFieldRefAssignment, manager: { valueType: valueType, internal_valueManager: valueManager, internal_fieldValueManager: fieldValueManager, internal_useOpenPickerButtonAriaLabel: useOpenPickerButtonAriaLabel } } = parameters;
    const { internalProps: internalProps, forwardedProps: forwardedProps } = (0, $d87bf966383f793e$export$be857fabf132acea)(props, valueType);
    const internalPropsWithDefaults = (0, $31671c418f538ceb$export$e2fe2bbcb0489bc7)({
        manager: manager,
        internalProps: internalProps,
        skipContextFieldRefAssignment: skipContextFieldRefAssignment
    });
    const { onFocus: onFocus, onClick: onClick, onPaste: onPaste, onBlur: onBlur, onKeyDown: onKeyDown, onClear: onClear, clearable: clearable, inputRef: inputRefProp, placeholder: inPlaceholder } = forwardedProps;
    const { readOnly: readOnly = false, disabled: disabled = false, autoFocus: autoFocus = false, focused: focused, unstableFieldRef: unstableFieldRef } = internalPropsWithDefaults;
    const inputRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(inputRefProp, inputRef);
    const stateResponse = (0, $7a048fc6e80d7310$export$4e8d6353e50062e7)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        forwardedProps: forwardedProps
    });
    const { activeSectionIndex: // States and derived states
    activeSectionIndex, areAllSectionsEmpty: areAllSectionsEmpty, error: error, localizedDigits: localizedDigits, parsedSelectedSections: parsedSelectedSections, sectionOrder: sectionOrder, state: state, value: value, clearValue: // Methods to update the states
    clearValue, clearActiveSection: clearActiveSection, setCharacterQuery: setCharacterQuery, setSelectedSections: setSelectedSections, setTempAndroidValueStr: setTempAndroidValueStr, updateSectionValue: updateSectionValue, updateValueFromValueStr: updateValueFromValueStr, getSectionsFromValue: // Utilities methods
    getSectionsFromValue } = stateResponse;
    const applyCharacterEditing = (0, $5fd1fe7e071df6b9$export$66d00048b8bb82f6)({
        stateResponse: stateResponse
    });
    const openPickerAriaLabel = useOpenPickerButtonAriaLabel(value);
    const sections = $acw62.useMemo(()=>$691502d482840442$export$8bb5d1c9951d10ca(state.sections, localizedDigits, isRtl), [
        state.sections,
        localizedDigits,
        isRtl
    ]);
    function syncSelectionFromDOM() {
        const browserStartIndex = inputRef.current.selectionStart ?? 0;
        let nextSectionIndex;
        if (browserStartIndex <= sections[0].startInInput) // Special case if browser index is in invisible characters at the beginning
        nextSectionIndex = 1;
        else if (browserStartIndex >= sections[sections.length - 1].endInInput) // If the click is after the last character of the input, then we want to select the 1st section.
        nextSectionIndex = 1;
        else nextSectionIndex = sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
        const sectionIndex = nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
        setSelectedSections(sectionIndex);
    }
    function focusField(newSelectedSection = 0) {
        if ((0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current) === inputRef.current) return;
        inputRef.current?.focus();
        setSelectedSections(newSelectedSection);
    }
    const handleInputFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onFocus?.(event);
        // The ref is guaranteed to be resolved at this point.
        const input = inputRef.current;
        focusTimeout.start(0, ()=>{
            // The ref changed, the component got remounted, the focus event is no longer relevant.
            if (!input || input !== inputRef.current) return;
            if (activeSectionIndex != null) return;
            if (// avoid selecting all sections when focusing empty field without value
            input.value.length && Number(input.selectionEnd) - Number(input.selectionStart) === input.value.length) setSelectedSections('all');
            else syncSelectionFromDOM();
        });
    });
    const handleInputClick = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, ...args)=>{
        // The click event on the clear button would propagate to the input, trigger this handler and result in a wrong section selection.
        // We avoid this by checking if the call of `handleInputClick` is actually intended, or a side effect.
        if (event.isDefaultPrevented()) return;
        onClick?.(event, ...args);
        syncSelectionFromDOM();
    });
    const handleInputPaste = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onPaste?.(event);
        // prevent default to avoid the input `onChange` handler being called
        event.preventDefault();
        if (readOnly || disabled) return;
        const pastedValue = event.clipboardData.getData('text');
        if (typeof parsedSelectedSections === 'number') {
            const activeSection = state.sections[parsedSelectedSections];
            const lettersOnly = /^[a-zA-Z]+$/.test(pastedValue);
            const digitsOnly = /^[0-9]+$/.test(pastedValue);
            const digitsAndLetterOnly = /^(([a-zA-Z]+)|)([0-9]+)(([a-zA-Z]+)|)$/.test(pastedValue);
            const isValidPastedValue = activeSection.contentType === 'letter' && lettersOnly || activeSection.contentType === 'digit' && digitsOnly || activeSection.contentType === 'digit-with-letter' && digitsAndLetterOnly;
            if (isValidPastedValue) {
                setCharacterQuery(null);
                updateSectionValue({
                    section: activeSection,
                    newSectionValue: pastedValue,
                    shouldGoToNextSection: true
                });
                return;
            }
            if (lettersOnly || digitsOnly) // The pasted value corresponds to a single section, but not the expected type,
            // skip the modification
            return;
        }
        setCharacterQuery(null);
        updateValueFromValueStr(pastedValue);
    });
    const handleContainerBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onBlur?.(event);
        setSelectedSections(null);
    });
    const handleInputChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (readOnly) return;
        const targetValue = event.target.value;
        if (targetValue === '') {
            clearValue();
            return;
        }
        const eventData = event.nativeEvent.data;
        // Calling `.fill(04/11/2022)` in playwright will trigger a change event with the requested content to insert in `event.nativeEvent.data`
        // usual changes have only the currently typed character in the `event.nativeEvent.data`
        const shouldUseEventData = eventData && eventData.length > 1;
        const valueStr = shouldUseEventData ? eventData : targetValue;
        const cleanValueStr = $691502d482840442$var$cleanString(valueStr);
        if (parsedSelectedSections === 'all') setSelectedSections(activeSectionIndex);
        // If no section is selected or eventData should be used, we just try to parse the new value
        // This line is mostly triggered by imperative code / application tests.
        if (activeSectionIndex == null || shouldUseEventData) {
            updateValueFromValueStr(shouldUseEventData ? eventData : cleanValueStr);
            return;
        }
        let keyPressed;
        if (parsedSelectedSections === 'all' && cleanValueStr.length === 1) keyPressed = cleanValueStr;
        else {
            const prevValueStr = $691502d482840442$var$cleanString(fieldValueManager.getV6InputValueFromSections(sections, localizedDigits, isRtl));
            let startOfDiffIndex = -1;
            let endOfDiffIndex = -1;
            for(let i = 0; i < prevValueStr.length; i += 1){
                if (startOfDiffIndex === -1 && prevValueStr[i] !== cleanValueStr[i]) startOfDiffIndex = i;
                if (endOfDiffIndex === -1 && prevValueStr[prevValueStr.length - i - 1] !== cleanValueStr[cleanValueStr.length - i - 1]) endOfDiffIndex = i;
            }
            const activeSection = sections[activeSectionIndex];
            const hasDiffOutsideOfActiveSection = startOfDiffIndex < activeSection.start || prevValueStr.length - endOfDiffIndex - 1 > activeSection.end;
            if (hasDiffOutsideOfActiveSection) // TODO: Support if the new date is valid
            return;
            // The active section being selected, the browser has replaced its value with the key pressed by the user.
            const activeSectionEndRelativeToNewValue = cleanValueStr.length - prevValueStr.length + activeSection.end - $691502d482840442$var$cleanString(activeSection.endSeparator || '').length;
            keyPressed = cleanValueStr.slice(activeSection.start + $691502d482840442$var$cleanString(activeSection.startSeparator || '').length, activeSectionEndRelativeToNewValue);
        }
        if (keyPressed.length === 0) {
            if ((0, $4a0e020deed3b4b7$export$a11b0059900ceec8)()) setTempAndroidValueStr(valueStr);
            clearActiveSection();
            return;
        }
        applyCharacterEditing({
            keyPressed: keyPressed,
            sectionIndex: activeSectionIndex
        });
    });
    const handleClear = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, ...args)=>{
        event.preventDefault();
        onClear?.(event, ...args);
        clearValue();
        if (!$691502d482840442$var$isFieldFocused(inputRef)) // setSelectedSections is called internally
        focusField(0);
        else setSelectedSections(sectionOrder.startIndex);
    });
    const handleContainerKeyDown = (0, $259504e265932f66$export$35b4b3d12d0cd3bd)({
        manager: manager,
        internalPropsWithDefaults: internalPropsWithDefaults,
        stateResponse: stateResponse
    });
    const wrappedHandleContainerKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        onKeyDown?.(event);
        handleContainerKeyDown(event);
    });
    const placeholder = $acw62.useMemo(()=>{
        if (inPlaceholder !== undefined) return inPlaceholder;
        return fieldValueManager.getV6InputValueFromSections(getSectionsFromValue(valueManager.emptyValue), localizedDigits, isRtl);
    }, [
        inPlaceholder,
        fieldValueManager,
        getSectionsFromValue,
        valueManager.emptyValue,
        localizedDigits,
        isRtl
    ]);
    const valueStr = $acw62.useMemo(()=>state.tempValueStrAndroid ?? fieldValueManager.getV6InputValueFromSections(state.sections, localizedDigits, isRtl), [
        state.sections,
        fieldValueManager,
        state.tempValueStrAndroid,
        localizedDigits,
        isRtl
    ]);
    $acw62.useEffect(()=>{
        // Select all the sections when focused on mount (`autoFocus = true` on the input)
        if (inputRef.current && inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current)) setSelectedSections('all');
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        function syncSelectionToDOM() {
            if (!inputRef.current) return;
            if (parsedSelectedSections == null) {
                if (inputRef.current.scrollLeft) // Ensure that input content is not marked as selected.
                // setting selection range to 0 causes issues in Safari.
                // https://bugs.webkit.org/show_bug.cgi?id=224425
                inputRef.current.scrollLeft = 0;
                return;
            }
            // On multi input range pickers we want to update selection range only for the active input
            // This helps to avoid the focus jumping on Safari https://github.com/mui/mui-x/issues/9003
            // because WebKit implements the `setSelectionRange` based on the spec: https://bugs.webkit.org/show_bug.cgi?id=224425
            if (inputRef.current !== (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current)) return;
            // Fix scroll jumping on iOS browser: https://github.com/mui/mui-x/issues/8321
            const currentScrollTop = inputRef.current.scrollTop;
            if (parsedSelectedSections === 'all') inputRef.current.select();
            else {
                const selectedSection = sections[parsedSelectedSections];
                const selectionStart = selectedSection.type === 'empty' ? selectedSection.startInInput - selectedSection.startSeparator.length : selectedSection.startInInput;
                const selectionEnd = selectedSection.type === 'empty' ? selectedSection.endInInput + selectedSection.endSeparator.length : selectedSection.endInInput;
                if (selectionStart !== inputRef.current.selectionStart || selectionEnd !== inputRef.current.selectionEnd) {
                    if (inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current)) inputRef.current.setSelectionRange(selectionStart, selectionEnd);
                }
                selectionSyncTimeout.start(0, ()=>{
                    // handle case when the selection is not updated correctly
                    // could happen on Android
                    if (inputRef.current && inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current) && // The section might loose all selection, where `selectionStart === selectionEnd`
                    // https://github.com/mui/mui-x/pull/13652
                    inputRef.current.selectionStart === inputRef.current.selectionEnd && (inputRef.current.selectionStart !== selectionStart || inputRef.current.selectionEnd !== selectionEnd)) syncSelectionToDOM();
                });
            }
            // Even reading this variable seems to do the trick, but also setting it just to make use of it
            inputRef.current.scrollTop = currentScrollTop;
        }
        syncSelectionToDOM();
    });
    const inputMode = $acw62.useMemo(()=>{
        if (activeSectionIndex == null) return 'text';
        if (state.sections[activeSectionIndex].contentType === 'letter') return 'text';
        return 'numeric';
    }, [
        activeSectionIndex,
        state.sections
    ]);
    const inputHasFocus = inputRef.current && inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current);
    const shouldShowPlaceholder = !inputHasFocus && areAllSectionsEmpty;
    $acw62.useImperativeHandle(unstableFieldRef, ()=>({
            getSections: ()=>state.sections,
            getActiveSectionIndex: ()=>{
                const browserStartIndex = inputRef.current.selectionStart ?? 0;
                const browserEndIndex = inputRef.current.selectionEnd ?? 0;
                if (browserStartIndex === 0 && browserEndIndex === 0) return null;
                const nextSectionIndex = browserStartIndex <= sections[0].startInInput ? 1 // Special case if browser index is in invisible characters at the beginning.
                 : sections.findIndex((section)=>section.startInInput - section.startSeparator.length > browserStartIndex);
                return nextSectionIndex === -1 ? sections.length - 1 : nextSectionIndex - 1;
            },
            setSelectedSections: (newSelectedSections)=>setSelectedSections(newSelectedSections),
            focusField: focusField,
            isFieldFocused: ()=>$691502d482840442$var$isFieldFocused(inputRef)
        }));
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, forwardedProps, {
        error: error,
        clearable: Boolean(clearable && !areAllSectionsEmpty && !readOnly && !disabled),
        onBlur: handleContainerBlur,
        onClick: handleInputClick,
        onFocus: handleInputFocus,
        onPaste: handleInputPaste,
        onKeyDown: wrappedHandleContainerKeyDown,
        onClear: handleClear,
        inputRef: handleRef,
        // Additional
        enableAccessibleFieldDOMStructure: false,
        placeholder: placeholder,
        inputMode: inputMode,
        autoComplete: 'off',
        value: shouldShowPlaceholder ? '' : valueStr,
        onChange: handleInputChange,
        focused: focused,
        disabled: disabled,
        readOnly: readOnly,
        autoFocus: autoFocus,
        openPickerAriaLabel: openPickerAriaLabel
    });
};
function $691502d482840442$var$isFieldFocused(inputRef) {
    return inputRef.current === (0, $7c44784990d74e44$export$cd4e5573fbe2b576)(inputRef.current);
}



const $84499ee97b37b33a$export$294aa081a6c6f55d = (parameters)=>{
    const fieldPrivateContext = (0, $20b835eaf21df543$export$700ab01cf24fdb1)();
    const enableAccessibleFieldDOMStructure = parameters.props.enableAccessibleFieldDOMStructure ?? fieldPrivateContext?.enableAccessibleFieldDOMStructure ?? true;
    const useFieldTextField = enableAccessibleFieldDOMStructure ? (0, $6837d80005de3c6f$export$3b5f62b9baf9717e) : (0, $691502d482840442$export$4995d3b7b56fcd3f);
    return useFieldTextField(parameters);
};



'use client';
const $f117aff76d53d0eb$export$5591b0b878c1a989 = (props)=>{
    const manager = (0, $53fd543f3597ad7b$export$6b73f8c5013b806e)(props);
    return (0, $84499ee97b37b33a$export$294aa081a6c6f55d)({
        manager: manager,
        props: props
    });
};





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");












function $df1adf37dbd0f6dd$export$4b135a4b3a6c4550(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiInputAdornment', slot);
}
const $df1adf37dbd0f6dd$var$inputAdornmentClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiInputAdornment', [
    'root',
    'filled',
    'standard',
    'outlined',
    'positionStart',
    'positionEnd',
    'disablePointerEvents',
    'hiddenLabel',
    'sizeSmall'
]);
var $df1adf37dbd0f6dd$export$2e2bcd8739ae039 = $df1adf37dbd0f6dd$var$inputAdornmentClasses;



'use client';
var $0ffab78552448ba6$var$_span;
const $0ffab78552448ba6$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        styles[`position${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.position)}`],
        ownerState.disablePointerEvents === true && styles.disablePointerEvents,
        styles[ownerState.variant]
    ];
};
const $0ffab78552448ba6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disablePointerEvents: disablePointerEvents, hiddenLabel: hiddenLabel, position: position, size: size, variant: variant } = ownerState;
    const slots = {
        root: [
            'root',
            disablePointerEvents && 'disablePointerEvents',
            position && `position${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(position)}`,
            variant,
            hiddenLabel && 'hiddenLabel',
            size && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $df1adf37dbd0f6dd$export$4b135a4b3a6c4550), classes);
};
const $0ffab78552448ba6$var$InputAdornmentRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiInputAdornment',
    slot: 'Root',
    overridesResolver: $0ffab78552448ba6$var$overridesResolver
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        maxHeight: '2em',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        color: (theme.vars || theme).palette.action.active,
        variants: [
            {
                props: {
                    variant: 'filled'
                },
                style: {
                    [`&.${(0, $df1adf37dbd0f6dd$export$2e2bcd8739ae039).positionStart}&:not(.${(0, $df1adf37dbd0f6dd$export$2e2bcd8739ae039).hiddenLabel})`]: {
                        marginTop: 16
                    }
                }
            },
            {
                props: {
                    position: 'start'
                },
                style: {
                    marginRight: 8
                }
            },
            {
                props: {
                    position: 'end'
                },
                style: {
                    marginLeft: 8
                }
            },
            {
                props: {
                    disablePointerEvents: true
                },
                style: {
                    pointerEvents: 'none'
                }
            }
        ]
    })));
const $0ffab78552448ba6$var$InputAdornment = /*#__PURE__*/ $acw62.forwardRef(function InputAdornment(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiInputAdornment'
    });
    const { children: children, className: className, component: component = 'div', disablePointerEvents: disablePointerEvents = false, disableTypography: disableTypography = false, position: position, variant: variantProp, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)() || {};
    let variant = variantProp;
    variantProp && muiFormControl.variant;
    if (muiFormControl && !variant) variant = muiFormControl.variant;
    const ownerState = {
        ...props,
        hiddenLabel: muiFormControl.hiddenLabel,
        size: muiFormControl.size,
        disablePointerEvents: disablePointerEvents,
        position: position,
        variant: variant
    };
    const classes = $0ffab78552448ba6$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c51e307705f35677$export$2e2bcd8739ae039).Provider, {
        value: null,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0ffab78552448ba6$var$InputAdornmentRoot, {
            as: component,
            ownerState: ownerState,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            ...other,
            children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                color: "textSecondary",
                children: children
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    position === 'start' ? /* notranslate needed while Google Translate will not fix zero-width space issue */ $0ffab78552448ba6$var$_span || ($0ffab78552448ba6$var$_span = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "notranslate",
                        "aria-hidden": true,
                        children: "\u200B"
                    })) : null,
                    children
                ]
            })
        })
    });
});
var $0ffab78552448ba6$export$2e2bcd8739ae039 = $0ffab78552448ba6$var$InputAdornment;


const $725dc7d66274f756$export$83d89fbfd8236492 = "7.3.4";
const $725dc7d66274f756$export$c7133ab33cb183d1 = Number("7");
const $725dc7d66274f756$export$b65c007c1e3a96bd = Number("3");
const $725dc7d66274f756$export$b76953f99ab2be78 = Number("4");
const $725dc7d66274f756$export$c7862566fc3cc35e = undefined;
var $725dc7d66274f756$export$2e2bcd8739ae039 = $725dc7d66274f756$export$83d89fbfd8236492;





var $acw62 = parcelRequire("acw62");


function $99bc14e4e693dcb7$export$fe06f3f35a7c97cd(parameters) {
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            isFieldDisabled: parameters.disabled ?? false,
            isFieldReadOnly: parameters.readOnly ?? false,
            isFieldRequired: parameters.required ?? false,
            fieldDirection: isRtl ? 'rtl' : 'ltr'
        }), [
        pickerOwnerState,
        parameters.disabled,
        parameters.readOnly,
        parameters.required,
        isRtl
    ]);
}





var $acw62 = parcelRequire("acw62");

const $ef8448afaa732d42$export$ed0fe318cc298673 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');
const $ef8448afaa732d42$export$8afed21ef5c2afa5 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"
}), 'ArrowLeft');
const $ef8448afaa732d42$export$9ca09caa9c849d9c = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'ArrowRight');
const $ef8448afaa732d42$export$5fda1783bb83f57b = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
}), 'Calendar');
const $ef8448afaa732d42$export$8099ab97743c966c = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
    children: [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Clock');
const $ef8448afaa732d42$export$90a8eab2a2411720 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
}), 'DateRange');
const $ef8448afaa732d42$export$7e95adcf912503e3 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
    children: [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z"
        })
    ]
}), 'Time');
const $ef8448afaa732d42$export$cefbac224a47f32 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Clear');






var $acw62 = parcelRequire("acw62");












function $7fe03890faaa1098$export$d99678ed7aad1677(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersTextField', slot);
}
const $7fe03890faaa1098$export$284739773a7ae972 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersTextField', [
    'root',
    'focused',
    'disabled',
    'error',
    'required'
]);





var $acw62 = parcelRequire("acw62");










function $64a3e1d35e70fd8e$export$3821cb625ac26962(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersInputBase', slot);
}
const $64a3e1d35e70fd8e$export$f20b5ba262568322 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersInputBase', [
    'root',
    'focused',
    'disabled',
    'error',
    'notchedOutline',
    'sectionContent',
    'sectionBefore',
    'sectionAfter',
    'adornedStart',
    'adornedEnd',
    'input',
    'inputSizeSmall',
    'activeBar'
]);


function $046b91bebd4eb52f$export$c0dd951a3959ac7f(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersOutlinedInput', slot);
}
const $046b91bebd4eb52f$export$a7da60486bcc91df = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $64a3e1d35e70fd8e$export$f20b5ba262568322), (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersOutlinedInput', [
    'root',
    'notchedOutline',
    'input'
]));




parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");
'use client';
const $2e5837635cabff28$export$b7e46bfe0a5d9502 = /*#__PURE__*/ $acw62.createContext(null);
const $2e5837635cabff28$export$589d98a5b6c57f51 = ()=>{
    const value = $acw62.useContext($2e5837635cabff28$export$b7e46bfe0a5d9502);
    if (value == null) throw new Error([
        'MUI X: The `usePickerTextFieldOwnerState` can only be called in components that are used inside a PickerTextField component'
    ].join('\n'));
    return value;
};



const $1e64c57782485ef2$var$_excluded = [
    "children",
    "className",
    "label",
    "notched",
    "shrink"
];
const $1e64c57782485ef2$var$OutlineRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('fieldset', {
    name: 'MuiPickersOutlinedInput',
    slot: 'NotchedOutline'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        textAlign: 'left',
        position: 'absolute',
        bottom: 0,
        right: 0,
        top: -5,
        left: 0,
        margin: 0,
        padding: '0 8px',
        pointerEvents: 'none',
        borderRadius: 'inherit',
        borderStyle: 'solid',
        borderWidth: 1,
        overflow: 'hidden',
        minWidth: '0%',
        borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
    };
});
const $1e64c57782485ef2$var$OutlineLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span')(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit'
    }));
const $1e64c57782485ef2$var$OutlineLegend = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('legend', {
    shouldForwardProp: (prop)=>(0, $9a7e913a82f46e5c$export$3ba67b570e26eea0)(prop) && prop !== 'notched'
})(({ theme: theme })=>({
        float: 'unset',
        // Fix conflict with bootstrap
        width: 'auto',
        // Fix conflict with bootstrap
        overflow: 'hidden',
        // Fix Horizontal scroll when label too long
        variants: [
            {
                props: {
                    inputHasLabel: false
                },
                style: {
                    padding: 0,
                    lineHeight: '11px',
                    // sync with `height` in `legend` styles
                    transition: theme.transitions.create('width', {
                        duration: 150,
                        easing: theme.transitions.easing.easeOut
                    })
                }
            },
            {
                props: {
                    inputHasLabel: true
                },
                style: {
                    display: 'block',
                    // Fix conflict with normalize.css and sanitize.css
                    padding: 0,
                    height: 11,
                    // sync with `lineHeight` in `legend` styles
                    fontSize: '0.75em',
                    visibility: 'hidden',
                    maxWidth: 0.01,
                    transition: theme.transitions.create('max-width', {
                        duration: 50,
                        easing: theme.transitions.easing.easeOut
                    }),
                    whiteSpace: 'nowrap',
                    '& > span': {
                        paddingLeft: 5,
                        paddingRight: 5,
                        display: 'inline-block',
                        opacity: 0,
                        visibility: 'visible'
                    }
                }
            },
            {
                props: {
                    inputHasLabel: true,
                    notched: true
                },
                style: {
                    maxWidth: '100%',
                    transition: theme.transitions.create('max-width', {
                        duration: 100,
                        easing: theme.transitions.easing.easeOut,
                        delay: 50
                    })
                }
            }
        ]
    }));
function $1e64c57782485ef2$export$2e2bcd8739ae039(props) {
    const { className: className, label: label, notched: notched } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $1e64c57782485ef2$var$_excluded);
    const ownerState = (0, $2e5837635cabff28$export$589d98a5b6c57f51)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1e64c57782485ef2$var$OutlineRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        className: className
    }, other, {
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1e64c57782485ef2$var$OutlineLegend, {
            ownerState: ownerState,
            notched: notched,
            children: label ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1e64c57782485ef2$var$OutlineLabel, {
                children: label
            }) : /*#__PURE__*/ // notranslate needed while Google Translate will not fix zero-width space issue
            (0, $7b02d682eb115277$exports.jsx)($1e64c57782485ef2$var$OutlineLabel, {
                className: "notranslate",
                children: "\u200B"
            })
        })
    }));
}





var $acw62 = parcelRequire("acw62");








const $0acaed42692b8720$var$visuallyHidden = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    whiteSpace: 'nowrap',
    width: '1px'
};
var $0acaed42692b8720$export$2e2bcd8739ae039 = $0acaed42692b8720$var$visuallyHidden;






var $acw62 = parcelRequire("acw62");







function $ef78634a4721646b$export$f891a98d04ce6513(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersSectionList', slot);
}
const $ef78634a4721646b$export$8455939b33d2ee90 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersSectionList', [
    'root',
    'section',
    'sectionContent'
]);




'use client';
const $af9e880f422bb0e7$var$_excluded = [
    "slots",
    "slotProps",
    "elements",
    "sectionListRef",
    "classes"
];
const $af9e880f422bb0e7$export$4ee86b293725486c = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersSectionList',
    slot: 'Root'
})({
    direction: 'ltr /*! @noflip */',
    outline: 'none'
});
const $af9e880f422bb0e7$export$30e7187e386feb4f = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'Section'
})({});
const $af9e880f422bb0e7$export$c403b59604f63120 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionSeparator'
})({
    whiteSpace: 'pre'
});
const $af9e880f422bb0e7$export$1f2c61561fe3d6 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiPickersSectionList',
    slot: 'SectionContent'
})({
    outline: 'none'
});
const $af9e880f422bb0e7$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        section: [
            'section'
        ],
        sectionContent: [
            'sectionContent'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $ef78634a4721646b$export$f891a98d04ce6513), classes);
};
function $af9e880f422bb0e7$var$PickersSection(props) {
    const { slots: slots, slotProps: slotProps, element: element, classes: classes } = props;
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const Section = slots?.section ?? $af9e880f422bb0e7$export$30e7187e386feb4f;
    const sectionProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Section,
        externalSlotProps: slotProps?.section,
        externalForwardedProps: element.container,
        className: classes.section,
        ownerState: ownerState
    });
    const SectionContent = slots?.sectionContent ?? $af9e880f422bb0e7$export$1f2c61561fe3d6;
    const sectionContentProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SectionContent,
        externalSlotProps: slotProps?.sectionContent,
        externalForwardedProps: element.content,
        additionalProps: {
            suppressContentEditableWarning: true
        },
        className: classes.sectionContent,
        ownerState: ownerState
    });
    const SectionSeparator = slots?.sectionSeparator ?? $af9e880f422bb0e7$export$c403b59604f63120;
    const sectionSeparatorBeforeProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.before,
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            separatorPosition: 'before'
        })
    });
    const sectionSeparatorAfterProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SectionSeparator,
        externalSlotProps: slotProps?.sectionSeparator,
        externalForwardedProps: element.after,
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            separatorPosition: 'after'
        })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(Section, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionProps, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SectionSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionSeparatorBeforeProps)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SectionContent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionContentProps)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SectionSeparator, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sectionSeparatorAfterProps))
        ]
    }));
}
/**
 * Demos:
 *
 * - [Custom field](https://mui.com/x/react-date-pickers/custom-field/)
 *
 * API:
 *
 * - [PickersSectionList API](https://mui.com/x/api/date-pickers/pickers-section-list/)
 */ const $af9e880f422bb0e7$export$847fd4b97819700 = /*#__PURE__*/ $acw62.forwardRef(function PickersSectionList(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSectionList'
    });
    const { slots: slots, slotProps: slotProps, elements: elements, sectionListRef: sectionListRef, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $af9e880f422bb0e7$var$_excluded);
    const classes = $af9e880f422bb0e7$var$useUtilityClasses(classesProp);
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const rootRef = $acw62.useRef(null);
    const handleRootRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, rootRef);
    const getRoot = (methodName)=>{
        if (!rootRef.current) throw new Error(`MUI X: Cannot call sectionListRef.${methodName} before the mount of the component.`);
        return rootRef.current;
    };
    $acw62.useImperativeHandle(sectionListRef, ()=>({
            getRoot () {
                return getRoot('getRoot');
            },
            getSectionContainer (index) {
                const root = getRoot('getSectionContainer');
                return root.querySelector(`.${(0, $ef78634a4721646b$export$8455939b33d2ee90).section}[data-sectionindex="${index}"]`);
            },
            getSectionContent (index) {
                const root = getRoot('getSectionContent');
                return root.querySelector(`.${(0, $ef78634a4721646b$export$8455939b33d2ee90).section}[data-sectionindex="${index}"] .${(0, $ef78634a4721646b$export$8455939b33d2ee90).sectionContent}`);
            },
            getSectionIndexFromDOMElement (element) {
                const root = getRoot('getSectionIndexFromDOMElement');
                if (element == null || !root.contains(element)) return null;
                let sectionContainer = null;
                if (element.classList.contains((0, $ef78634a4721646b$export$8455939b33d2ee90).section)) sectionContainer = element;
                else if (element.classList.contains((0, $ef78634a4721646b$export$8455939b33d2ee90).sectionContent)) sectionContainer = element.parentElement;
                if (sectionContainer == null) return null;
                return Number(sectionContainer.dataset.sectionindex);
            }
        }));
    const Root = slots?.root ?? $af9e880f422bb0e7$export$4ee86b293725486c;
    const rootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Root,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            ref: handleRootRef,
            suppressContentEditableWarning: true
        },
        className: classes.root,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Root, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps, {
        children: rootProps.contentEditable ? elements.map(({ content: content, before: before, after: after })=>`${before.children}${content.children}${after.children}`).join('') : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
            children: elements.map((element, elementIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($af9e880f422bb0e7$var$PickersSection, {
                    slots: slots,
                    slotProps: slotProps,
                    element: element,
                    classes: classes
                }, elementIndex))
        })
    }));
});




'use client';
const $a746f7ad5ddbedef$var$_excluded = [
    "elements",
    "areAllSectionsEmpty",
    "defaultValue",
    "label",
    "value",
    "onChange",
    "id",
    "autoFocus",
    "endAdornment",
    "startAdornment",
    "renderSuffix",
    "slots",
    "slotProps",
    "contentEditable",
    "tabIndex",
    "onInput",
    "onPaste",
    "onKeyDown",
    "fullWidth",
    "name",
    "readOnly",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "onFocus",
    "onBlur",
    "classes",
    "ownerState"
];
const $a746f7ad5ddbedef$var$round = (value)=>Math.round(value * 1e5) / 1e5;
const $a746f7ad5ddbedef$export$ddc18880178d980e = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersInputBase',
    slot: 'Root'
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, theme.typography.body1, {
        color: (theme.vars || theme).palette.text.primary,
        cursor: 'text',
        padding: 0,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box',
        // Prevent padding issue with fullWidth.
        letterSpacing: `${$a746f7ad5ddbedef$var$round(0.15 / 16)}em`,
        variants: [
            {
                props: {
                    isInputInFullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $a746f7ad5ddbedef$export$52f3fbbfe9321824 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $af9e880f422bb0e7$export$4ee86b293725486c), {
    name: 'MuiPickersInputBase',
    slot: 'SectionsContainer'
})(({ theme: theme })=>({
        padding: '4px 0 5px',
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        flexGrow: 1,
        outline: 'none',
        display: 'flex',
        flexWrap: 'nowrap',
        overflow: 'hidden',
        letterSpacing: 'inherit',
        // Baseline behavior
        width: '182px',
        variants: [
            {
                props: {
                    fieldDirection: 'rtl'
                },
                style: {
                    justifyContent: 'end'
                }
            },
            {
                props: {
                    inputSize: 'small'
                },
                style: {
                    paddingTop: 1
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true
                },
                style: {
                    color: 'currentColor',
                    opacity: 0
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: false
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            },
            {
                props: {
                    hasStartAdornment: false,
                    isFieldFocused: false,
                    isFieldValueEmpty: true,
                    inputHasLabel: true,
                    isLabelShrunk: true
                },
                style: theme.vars ? {
                    opacity: theme.vars.opacity.inputPlaceholder
                } : {
                    opacity: theme.palette.mode === 'light' ? 0.42 : 0.5
                }
            }
        ]
    }));
const $a746f7ad5ddbedef$var$PickersInputBaseSection = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $af9e880f422bb0e7$export$30e7187e386feb4f), {
    name: 'MuiPickersInputBase',
    slot: 'Section'
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        fontSize: 'inherit',
        letterSpacing: 'inherit',
        lineHeight: '1.4375em',
        // 23px
        display: 'inline-block',
        whiteSpace: 'nowrap'
    }));
const $a746f7ad5ddbedef$var$PickersInputBaseSectionContent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $af9e880f422bb0e7$export$1f2c61561fe3d6), {
    name: 'MuiPickersInputBase',
    slot: 'SectionContent',
    overridesResolver: (props, styles)=>styles.content // FIXME: Inconsistent naming with slot
})(({ theme: theme })=>({
        fontFamily: theme.typography.fontFamily,
        lineHeight: '1.4375em',
        // 23px
        letterSpacing: 'inherit',
        width: 'fit-content',
        outline: 'none'
    }));
const $a746f7ad5ddbedef$var$PickersInputBaseSectionSeparator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $af9e880f422bb0e7$export$c403b59604f63120), {
    name: 'MuiPickersInputBase',
    slot: 'Separator'
})(()=>({
        whiteSpace: 'pre',
        letterSpacing: 'inherit'
    }));
const $a746f7ad5ddbedef$var$PickersInputBaseInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('input', {
    name: 'MuiPickersInputBase',
    slot: 'Input',
    overridesResolver: (props, styles)=>styles.hiddenInput // FIXME: Inconsistent naming with slot
})((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $0acaed42692b8720$export$2e2bcd8739ae039)));
const $a746f7ad5ddbedef$var$PickersInputBaseActiveBar = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersInputBase',
    slot: 'ActiveBar'
})(({ theme: theme, ownerState: ownerState })=>({
        display: 'none',
        position: 'absolute',
        height: 2,
        bottom: 2,
        borderTopLeftRadius: 2,
        borderTopRightRadius: 2,
        transition: theme.transitions.create([
            'width',
            'left'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: (theme.vars || theme).palette.primary.main,
        '[data-active-range-position="start"] &, [data-active-range-position="end"] &': {
            display: 'block'
        },
        '[data-active-range-position="start"] &': {
            left: ownerState.sectionOffsets[0]
        },
        '[data-active-range-position="end"] &': {
            left: ownerState.sectionOffsets[1]
        }
    }));
const $a746f7ad5ddbedef$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldReadOnly: isFieldReadOnly, hasFieldError: hasFieldError, inputSize: inputSize, isInputInFullWidth: isInputInFullWidth, inputColor: inputColor, hasStartAdornment: hasStartAdornment, hasEndAdornment: hasEndAdornment } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldReadOnly && 'readOnly',
            hasFieldError && 'error',
            isInputInFullWidth && 'fullWidth',
            `color${(0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(inputColor)}`,
            inputSize === 'small' && 'inputSizeSmall',
            hasStartAdornment && 'adornedStart',
            hasEndAdornment && 'adornedEnd'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ],
        sectionsContainer: [
            'sectionsContainer'
        ],
        sectionContent: [
            'sectionContent'
        ],
        sectionBefore: [
            'sectionBefore'
        ],
        sectionAfter: [
            'sectionAfter'
        ],
        activeBar: [
            'activeBar'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $64a3e1d35e70fd8e$export$3821cb625ac26962), classes);
};
function $a746f7ad5ddbedef$var$resolveSectionElementWidth(sectionElement, rootRef, index, dateRangePosition) {
    if (sectionElement.content.id) {
        const activeSectionElements = rootRef.current?.querySelectorAll(`[data-sectionindex="${index}"] [data-range-position="${dateRangePosition}"]`);
        if (activeSectionElements) return Array.from(activeSectionElements).reduce((currentActiveBarWidth, element)=>{
            return currentActiveBarWidth + element.offsetWidth;
        }, 0);
    }
    return 0;
}
function $a746f7ad5ddbedef$var$resolveSectionWidthAndOffsets(elements, rootRef) {
    let activeBarWidth = 0;
    const activeRangePosition = rootRef.current?.getAttribute('data-active-range-position');
    if (activeRangePosition === 'end') for(let i = elements.length - 1; i >= elements.length / 2; i -= 1)activeBarWidth += $a746f7ad5ddbedef$var$resolveSectionElementWidth(elements[i], rootRef, i, 'end');
    else for(let i = 0; i < elements.length / 2; i += 1)activeBarWidth += $a746f7ad5ddbedef$var$resolveSectionElementWidth(elements[i], rootRef, i, 'start');
    return {
        activeBarWidth: activeBarWidth,
        sectionOffsets: [
            rootRef.current?.querySelector(`[data-sectionindex="0"]`)?.offsetLeft || 0,
            rootRef.current?.querySelector(`[data-sectionindex="${elements.length / 2}"]`)?.offsetLeft || 0
        ]
    };
}
/**
 * @ignore - internal component.
 */ const $a746f7ad5ddbedef$export$ff827734ba831074 = /*#__PURE__*/ $acw62.forwardRef(function PickersInputBase(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInputBase'
    });
    const { elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, value: value, onChange: onChange, id: id, endAdornment: endAdornment, startAdornment: startAdornment, renderSuffix: renderSuffix, slots: slots, slotProps: slotProps, contentEditable: contentEditable, tabIndex: tabIndex, onInput: onInput, onPaste: onPaste, onKeyDown: onKeyDown, name: name, readOnly: readOnly, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, onFocus: onFocus, onBlur: onBlur, classes: classesProp, ownerState: ownerStateProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a746f7ad5ddbedef$var$_excluded);
    const ownerStateContext = (0, $2e5837635cabff28$export$589d98a5b6c57f51)();
    const rootRef = $acw62.useRef(null);
    const activeBarRef = $acw62.useRef(null);
    const sectionOffsetsRef = $acw62.useRef([]);
    const handleRootRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, rootRef);
    const handleInputRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(inputProps?.ref, inputRef);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    if (!muiFormControl) throw new Error('MUI X: PickersInputBase should always be used inside a PickersTextField component');
    const ownerState = ownerStateProp ?? ownerStateContext;
    const handleInputFocus = (event)=>{
        muiFormControl.onFocus?.(event);
        onFocus?.(event);
    };
    const handleHiddenInputFocus = (event)=>{
        handleInputFocus(event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown?.(event);
        if (event.key === 'Enter' && !event.defaultMuiPrevented) {
            // Do nothing if it's a multi input field
            if (rootRef.current?.dataset.multiInput) return;
            const closestForm = rootRef.current?.closest('form');
            const submitTrigger = closestForm?.querySelector('[type="submit"]');
            if (!closestForm || !submitTrigger) // do nothing if there is no form or no submit button (trigger)
            return;
            event.preventDefault();
            // native input trigger submit with the `submitter` field set
            closestForm.requestSubmit(submitTrigger);
        }
    };
    const handleInputBlur = (event)=>{
        muiFormControl.onBlur?.(event);
        onBlur?.(event);
    };
    $acw62.useEffect(()=>{
        if (muiFormControl) muiFormControl.setAdornedStart(Boolean(startAdornment));
    }, [
        muiFormControl,
        startAdornment
    ]);
    $acw62.useEffect(()=>{
        if (!muiFormControl) return;
        if (areAllSectionsEmpty) muiFormControl.onEmpty();
        else muiFormControl.onFilled();
    }, [
        muiFormControl,
        areAllSectionsEmpty
    ]);
    const classes = $a746f7ad5ddbedef$var$useUtilityClasses(classesProp, ownerState);
    const InputRoot = slots?.root || $a746f7ad5ddbedef$export$ddc18880178d980e;
    const inputRootProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: InputRoot,
        externalSlotProps: slotProps?.root,
        externalForwardedProps: other,
        additionalProps: {
            'aria-invalid': muiFormControl.error,
            ref: handleRootRef
        },
        className: classes.root,
        ownerState: ownerState
    });
    const InputSectionsContainer = slots?.input || $a746f7ad5ddbedef$export$52f3fbbfe9321824;
    const isSingleInputRange = elements.some((element)=>element.content['data-range-position'] !== undefined);
    $acw62.useEffect(()=>{
        if (!isSingleInputRange || !ownerState.isPickerOpen) return;
        const { activeBarWidth: activeBarWidth, sectionOffsets: sectionOffsets } = $a746f7ad5ddbedef$var$resolveSectionWidthAndOffsets(elements, rootRef);
        sectionOffsetsRef.current = [
            sectionOffsets[0],
            sectionOffsets[1]
        ];
        if (activeBarRef.current) activeBarRef.current.style.width = `${activeBarWidth}px`;
    }, [
        elements,
        isSingleInputRange,
        ownerState.isPickerOpen
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(InputRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, inputRootProps, {
        children: [
            startAdornment,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af9e880f422bb0e7$export$847fd4b97819700), {
                sectionListRef: sectionListRef,
                elements: elements,
                contentEditable: contentEditable,
                tabIndex: tabIndex,
                className: classes.sectionsContainer,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                onInput: onInput,
                onPaste: onPaste,
                onKeyDown: handleKeyDown,
                slots: {
                    root: InputSectionsContainer,
                    section: $a746f7ad5ddbedef$var$PickersInputBaseSection,
                    sectionContent: $a746f7ad5ddbedef$var$PickersInputBaseSectionContent,
                    sectionSeparator: $a746f7ad5ddbedef$var$PickersInputBaseSectionSeparator
                },
                slotProps: {
                    root: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps?.input, {
                        ownerState: ownerState
                    }),
                    sectionContent: {
                        className: (0, $64a3e1d35e70fd8e$export$f20b5ba262568322).sectionContent
                    },
                    sectionSeparator: ({ separatorPosition: separatorPosition })=>({
                            className: separatorPosition === 'before' ? (0, $64a3e1d35e70fd8e$export$f20b5ba262568322).sectionBefore : (0, $64a3e1d35e70fd8e$export$f20b5ba262568322).sectionAfter
                        })
                }
            }),
            endAdornment,
            renderSuffix ? renderSuffix((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, muiFormControl)) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a746f7ad5ddbedef$var$PickersInputBaseInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                name: name,
                className: classes.input,
                value: value,
                onChange: onChange,
                id: id,
                "aria-hidden": "true",
                tabIndex: -1,
                readOnly: readOnly,
                required: muiFormControl.required,
                disabled: muiFormControl.disabled,
                onFocus: handleHiddenInputFocus
            }, inputProps, {
                ref: handleInputRef
            })),
            isSingleInputRange && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a746f7ad5ddbedef$var$PickersInputBaseActiveBar, {
                className: classes.activeBar,
                ref: activeBarRef,
                ownerState: {
                    sectionOffsets: sectionOffsetsRef.current
                }
            })
        ]
    }));
});




const $5546139708981d3e$var$_excluded = [
    "label",
    "autoFocus",
    "ownerState",
    "classes",
    "notched"
];
const $5546139708981d3e$var$PickersOutlinedInputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $a746f7ad5ddbedef$export$ddc18880178d980e), {
    name: 'MuiPickersOutlinedInput',
    slot: 'Root'
})(({ theme: theme })=>{
    const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
    return {
        padding: '0 14px',
        borderRadius: (theme.vars || theme).shape.borderRadius,
        [`&:hover .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.text.primary
        },
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
            [`&:hover .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / 0.23)` : borderColor
            }
        },
        [`&.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).focused} .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
            borderStyle: 'solid',
            borderWidth: 2
        },
        [`&.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).disabled}`]: {
            [`& .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
                borderColor: (theme.vars || theme).palette.action.disabled
            },
            '*': {
                color: (theme.vars || theme).palette.action.disabled
            }
        },
        [`&.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).error} .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
            borderColor: (theme.vars || theme).palette.error.main
        },
        variants: Object.keys((theme.vars ?? theme).palette)// @ts-ignore
        .filter((key)=>(theme.vars ?? theme).palette[key]?.main ?? false).map((color)=>({
                props: {
                    inputColor: color
                },
                style: {
                    [`&.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).focused}:not(.${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).error}) .${(0, $046b91bebd4eb52f$export$a7da60486bcc91df).notchedOutline}`]: {
                        // @ts-ignore
                        borderColor: (theme.vars || theme).palette[color].main
                    }
                }
            }))
    };
});
const $5546139708981d3e$var$PickersOutlinedInputSectionsContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $a746f7ad5ddbedef$export$52f3fbbfe9321824), {
    name: 'MuiPickersOutlinedInput',
    slot: 'SectionsContainer'
})({
    padding: '16.5px 0',
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                padding: '8.5px 0'
            }
        }
    ]
});
const $5546139708981d3e$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        notchedOutline: [
            'notchedOutline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $046b91bebd4eb52f$export$c0dd951a3959ac7f), classes);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $5546139708981d3e$export$44d4d00edb0c710f = /*#__PURE__*/ $acw62.forwardRef(function PickersOutlinedInput(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersOutlinedInput'
    });
    const { label: label, classes: classesProp, notched: notched } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $5546139708981d3e$var$_excluded);
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    const classes = $5546139708981d3e$var$useUtilityClasses(classesProp);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a746f7ad5ddbedef$export$ff827734ba831074), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        slots: {
            root: $5546139708981d3e$var$PickersOutlinedInputRoot,
            input: $5546139708981d3e$var$PickersOutlinedInputSectionsContainer
        },
        renderSuffix: (state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1e64c57782485ef2$export$2e2bcd8739ae039), {
                shrink: Boolean(notched || state.adornedStart || state.focused || state.filled),
                notched: Boolean(notched || state.adornedStart || state.focused || state.filled),
                className: classes.notchedOutline,
                label: label != null && label !== '' && muiFormControl?.required ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                    children: [
                        label,
                        "\u2009",
                        '*'
                    ]
                }) : label
            })
    }, other, {
        label: label,
        classes: classes,
        ref: ref
    }));
});
$5546139708981d3e$export$44d4d00edb0c710f.muiName = 'Input';





var $acw62 = parcelRequire("acw62");









function $a7f921572f185f66$export$6cb188bdacb35d0e(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersFilledInput', slot);
}
const $a7f921572f185f66$export$3964d3188824d772 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $64a3e1d35e70fd8e$export$f20b5ba262568322), (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersFilledInput', [
    'root',
    'underline',
    'input'
]));






const $c00015b46befd213$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "hiddenLabel",
    "classes"
];
const $c00015b46befd213$var$PickersFilledInputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $a746f7ad5ddbedef$export$ddc18880178d980e), {
    name: 'MuiPickersFilledInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $9a7e913a82f46e5c$export$3ba67b570e26eea0)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
    const hoverBackground = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)';
    const disabledBackground = light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)';
    return {
        backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor,
        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
        borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.shorter,
            easing: theme.transitions.easing.easeOut
        }),
        '&:hover': {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.hoverBg : hoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
            }
        },
        [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).focused}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.bg : backgroundColor
        },
        [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).disabled}`]: {
            backgroundColor: theme.vars ? theme.vars.palette.FilledInput.disabledBg : disabledBackground
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        disableUnderline: false
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color]?.main}`
                        }
                    }
                })),
            {
                props: {
                    disableUnderline: false
                },
                style: {
                    '&::after': {
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${theme.vars ? `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})` : bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $a7f921572f185f66$export$3964d3188824d772).disabled}, .${(0, $a7f921572f185f66$export$3964d3188824d772).error}):before`]: {
                        borderBottom: `1px solid ${(theme.vars || theme).palette.text.primary}`
                    },
                    [`&.${(0, $a7f921572f185f66$export$3964d3188824d772).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            },
            {
                props: {
                    hasStartAdornment: true
                },
                style: {
                    paddingLeft: 12
                }
            },
            {
                props: {
                    hasEndAdornment: true
                },
                style: {
                    paddingRight: 12
                }
            }
        ]
    };
});
const $c00015b46befd213$var$PickersFilledSectionsContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $a746f7ad5ddbedef$export$52f3fbbfe9321824), {
    name: 'MuiPickersFilledInput',
    slot: 'sectionsContainer',
    shouldForwardProp: (prop)=>(0, $9a7e913a82f46e5c$export$3ba67b570e26eea0)(prop) && prop !== 'hiddenLabel'
})({
    paddingTop: 25,
    paddingRight: 12,
    paddingBottom: 8,
    paddingLeft: 12,
    variants: [
        {
            props: {
                inputSize: 'small'
            },
            style: {
                paddingTop: 21,
                paddingBottom: 4
            }
        },
        {
            props: {
                hasStartAdornment: true
            },
            style: {
                paddingLeft: 0
            }
        },
        {
            props: {
                hasEndAdornment: true
            },
            style: {
                paddingRight: 0
            }
        },
        {
            props: {
                hiddenLabel: true
            },
            style: {
                paddingTop: 16,
                paddingBottom: 17
            }
        },
        {
            props: {
                hiddenLabel: true,
                inputSize: 'small'
            },
            style: {
                paddingTop: 8,
                paddingBottom: 9
            }
        }
    ]
});
const $c00015b46befd213$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $a7f921572f185f66$export$6cb188bdacb35d0e), classes);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $c00015b46befd213$export$8cc8c624890b5045 = /*#__PURE__*/ $acw62.forwardRef(function PickersFilledInput(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFilledInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, hiddenLabel: hiddenLabel = false, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $c00015b46befd213$var$_excluded);
    const pickerTextFieldOwnerState = (0, $2e5837635cabff28$export$589d98a5b6c57f51)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $c00015b46befd213$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a746f7ad5ddbedef$export$ff827734ba831074), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        slots: {
            root: $c00015b46befd213$var$PickersFilledInputRoot,
            input: $c00015b46befd213$var$PickersFilledSectionsContainer
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            },
            input: {
                hiddenLabel: hiddenLabel
            }
        }
    }, other, {
        label: label,
        classes: classes,
        ref: ref,
        ownerState: ownerState
    }));
});
$c00015b46befd213$export$8cc8c624890b5045.muiName = 'Input';





var $acw62 = parcelRequire("acw62");









function $56d7847b44348f39$export$defbb17803ff7cff(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersFilledInput', slot);
}
const $56d7847b44348f39$export$f5c5ba079c8bb9dd = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $64a3e1d35e70fd8e$export$f20b5ba262568322), (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersInput', [
    'root',
    'underline',
    'input'
]));






const $9255c83398e974d0$var$_excluded = [
    "label",
    "autoFocus",
    "disableUnderline",
    "ownerState",
    "classes"
];
const $9255c83398e974d0$var$PickersInputRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $a746f7ad5ddbedef$export$ddc18880178d980e), {
    name: 'MuiPickersInput',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $9a7e913a82f46e5c$export$3ba67b570e26eea0)(prop) && prop !== 'disableUnderline'
})(({ theme: theme })=>{
    const light = theme.palette.mode === 'light';
    let bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
    if (theme.vars) bottomLineColor = `rgba(${theme.vars.palette.common.onBackgroundChannel} / ${theme.vars.opacity.inputUnderline})`;
    return {
        'label + &': {
            marginTop: 16
        },
        variants: [
            ...Object.keys((theme.vars ?? theme).palette)// @ts-ignore
            .filter((key)=>(theme.vars ?? theme).palette[key].main).map((color)=>({
                    props: {
                        inputColor: color,
                        inputHasUnderline: true
                    },
                    style: {
                        '&::after': {
                            // @ts-ignore
                            borderBottom: `2px solid ${(theme.vars || theme).palette[color].main}`
                        }
                    }
                })),
            {
                props: {
                    inputHasUnderline: true
                },
                style: {
                    '&::after': {
                        background: 'red',
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '""',
                        position: 'absolute',
                        right: 0,
                        transform: 'scaleX(0)',
                        transition: theme.transitions.create('transform', {
                            duration: theme.transitions.duration.shorter,
                            easing: theme.transitions.easing.easeOut
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&.${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).focused}:after`]: {
                        // translateX(0) is a workaround for Safari transform scale bug
                        // See https://github.com/mui/material-ui/issues/31766
                        transform: 'scaleX(1) translateX(0)'
                    },
                    [`&.${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).error}`]: {
                        '&:before, &:after': {
                            borderBottomColor: (theme.vars || theme).palette.error.main
                        }
                    },
                    '&::before': {
                        borderBottom: `1px solid ${bottomLineColor}`,
                        left: 0,
                        bottom: 0,
                        // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
                        content: '"\\00a0"',
                        position: 'absolute',
                        right: 0,
                        transition: theme.transitions.create('border-bottom-color', {
                            duration: theme.transitions.duration.shorter
                        }),
                        pointerEvents: 'none' // Transparent to the hover style.
                    },
                    [`&:hover:not(.${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).disabled}, .${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).error}):before`]: {
                        borderBottom: `2px solid ${(theme.vars || theme).palette.text.primary}`,
                        // Reset on touch devices, it doesn't add specificity
                        '@media (hover: none)': {
                            borderBottom: `1px solid ${bottomLineColor}`
                        }
                    },
                    [`&.${(0, $56d7847b44348f39$export$f5c5ba079c8bb9dd).disabled}:before`]: {
                        borderBottomStyle: 'dotted'
                    }
                }
            }
        ]
    };
});
const $9255c83398e974d0$var$useUtilityClasses = (classes, ownerState)=>{
    const { inputHasUnderline: inputHasUnderline } = ownerState;
    const slots = {
        root: [
            'root',
            !inputHasUnderline && 'underline'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $56d7847b44348f39$export$defbb17803ff7cff), classes);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, classes, composedClasses);
};
/**
 * @ignore - internal component.
 */ const $9255c83398e974d0$export$7c4ebb2cfaf4f474 = /*#__PURE__*/ $acw62.forwardRef(function PickersInput(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersInput'
    });
    const { label: label, disableUnderline: disableUnderline = false, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9255c83398e974d0$var$_excluded);
    const pickerTextFieldOwnerState = (0, $2e5837635cabff28$export$589d98a5b6c57f51)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerTextFieldOwnerState, {
        inputHasUnderline: !disableUnderline
    });
    const classes = $9255c83398e974d0$var$useUtilityClasses(classesProp, ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a746f7ad5ddbedef$export$ff827734ba831074), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        slots: {
            root: $9255c83398e974d0$var$PickersInputRoot
        },
        slotProps: {
            root: {
                disableUnderline: disableUnderline
            }
        }
    }, other, {
        ownerState: ownerState,
        label: label,
        classes: classes,
        ref: ref
    }));
});
$9255c83398e974d0$export$7c4ebb2cfaf4f474.muiName = 'Input';





'use client';
const $e1cfb92b1b93cb9b$var$_excluded = [
    "onFocus",
    "onBlur",
    "className",
    "classes",
    "color",
    "disabled",
    "error",
    "variant",
    "required",
    "hiddenLabel",
    "InputProps",
    "inputProps",
    "inputRef",
    "sectionListRef",
    "elements",
    "areAllSectionsEmpty",
    "onClick",
    "onKeyDown",
    "onKeyUp",
    "onPaste",
    "onInput",
    "endAdornment",
    "startAdornment",
    "tabIndex",
    "contentEditable",
    "focused",
    "value",
    "onChange",
    "fullWidth",
    "id",
    "name",
    "helperText",
    "FormHelperTextProps",
    "label",
    "InputLabelProps",
    "data-active-range-position"
];
const $e1cfb92b1b93cb9b$var$VARIANT_COMPONENT = {
    standard: (0, $9255c83398e974d0$export$7c4ebb2cfaf4f474),
    filled: (0, $c00015b46befd213$export$8cc8c624890b5045),
    outlined: (0, $5546139708981d3e$export$44d4d00edb0c710f)
};
const $e1cfb92b1b93cb9b$var$PickersTextFieldRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
    name: 'MuiPickersTextField',
    slot: 'Root'
})({
    maxWidth: '100%'
});
const $e1cfb92b1b93cb9b$var$useUtilityClasses = (classes, ownerState)=>{
    const { isFieldFocused: isFieldFocused, isFieldDisabled: isFieldDisabled, isFieldRequired: isFieldRequired } = ownerState;
    const slots = {
        root: [
            'root',
            isFieldFocused && !isFieldDisabled && 'focused',
            isFieldDisabled && 'disabled',
            isFieldRequired && 'required'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $7fe03890faaa1098$export$d99678ed7aad1677), classes);
};
const $e1cfb92b1b93cb9b$export$b3e9b101d92e4d4d = /*#__PURE__*/ $acw62.forwardRef(function PickersTextField(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersTextField'
    });
    const { onFocus: // Props used by FormControl
    onFocus, onBlur: onBlur, className: className, classes: classesProp, color: color = 'primary', disabled: disabled = false, error: error = false, variant: variant = 'outlined', required: required = false, hiddenLabel: hiddenLabel = false, InputProps: // Props used by PickersInput
    InputProps, inputProps: inputProps, inputRef: inputRef, sectionListRef: sectionListRef, elements: elements, areAllSectionsEmpty: areAllSectionsEmpty, onClick: onClick, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onPaste: onPaste, onInput: onInput, endAdornment: endAdornment, startAdornment: startAdornment, tabIndex: tabIndex, contentEditable: contentEditable, focused: focused, value: value, onChange: onChange, fullWidth: fullWidth, id: idProp, name: name, helperText: // Props used by FormHelperText
    helperText, FormHelperTextProps: FormHelperTextProps, label: // Props used by InputLabel
    label, InputLabelProps: InputLabelProps, // @ts-ignore
    'data-active-range-position': dataActiveRangePosition } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e1cfb92b1b93cb9b$var$_excluded);
    const rootRef = $acw62.useRef(null);
    const handleRootRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, rootRef);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)(idProp);
    const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
    const inputLabelId = label && id ? `${id}-label` : undefined;
    const fieldOwnerState = (0, $99bc14e4e693dcb7$export$fe06f3f35a7c97cd)({
        disabled: props.disabled,
        required: props.required,
        readOnly: InputProps?.readOnly
    });
    const ownerState = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fieldOwnerState, {
            isFieldValueEmpty: areAllSectionsEmpty,
            isFieldFocused: focused ?? false,
            hasFieldError: error ?? false,
            inputSize: props.size ?? 'medium',
            inputColor: color ?? 'primary',
            isInputInFullWidth: fullWidth ?? false,
            hasStartAdornment: Boolean(startAdornment ?? InputProps?.startAdornment),
            hasEndAdornment: Boolean(endAdornment ?? InputProps?.endAdornment),
            inputHasLabel: !!label,
            isLabelShrunk: Boolean(InputLabelProps?.shrink)
        }), [
        fieldOwnerState,
        areAllSectionsEmpty,
        focused,
        error,
        props.size,
        color,
        fullWidth,
        startAdornment,
        endAdornment,
        InputProps?.startAdornment,
        InputProps?.endAdornment,
        label,
        InputLabelProps?.shrink
    ]);
    const classes = $e1cfb92b1b93cb9b$var$useUtilityClasses(classesProp, ownerState);
    const PickersInputComponent = $e1cfb92b1b93cb9b$var$VARIANT_COMPONENT[variant];
    const inputAdditionalProps = {};
    if (variant === 'outlined') {
        if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') inputAdditionalProps.notched = InputLabelProps.shrink;
        inputAdditionalProps.label = label;
    } else if (variant === 'filled') inputAdditionalProps.hiddenLabel = hiddenLabel;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e5837635cabff28$export$b7e46bfe0a5d9502).Provider, {
        value: ownerState,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e1cfb92b1b93cb9b$var$PickersTextFieldRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ref: handleRootRef,
            focused: focused,
            disabled: disabled,
            variant: variant,
            error: error,
            color: color,
            fullWidth: fullWidth,
            required: required,
            ownerState: ownerState
        }, other, {
            children: [
                label != null && label !== '' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    htmlFor: id,
                    id: inputLabelId
                }, InputLabelProps, {
                    children: label
                })),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PickersInputComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    elements: elements,
                    areAllSectionsEmpty: areAllSectionsEmpty,
                    onClick: onClick,
                    onKeyDown: onKeyDown,
                    onKeyUp: onKeyUp,
                    onInput: onInput,
                    onPaste: onPaste,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    endAdornment: endAdornment,
                    startAdornment: startAdornment,
                    tabIndex: tabIndex,
                    contentEditable: contentEditable,
                    value: value,
                    onChange: onChange,
                    id: id,
                    fullWidth: fullWidth,
                    inputProps: inputProps,
                    inputRef: inputRef,
                    sectionListRef: sectionListRef,
                    label: label,
                    name: name,
                    role: "group",
                    "aria-labelledby": inputLabelId,
                    "aria-describedby": helperTextId,
                    "aria-live": helperTextId ? 'polite' : undefined,
                    "data-active-range-position": dataActiveRangePosition
                }, inputAdditionalProps, InputProps)),
                helperText && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $937760e70ffc7914$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: helperTextId
                }, FormHelperTextProps, {
                    children: helperText
                }))
            ]
        }))
    });
});



'use client';
const $d2d3640b21a65392$var$_excluded = [
    "enableAccessibleFieldDOMStructure"
], $d2d3640b21a65392$var$_excluded2 = [
    "InputProps",
    "readOnly",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], $d2d3640b21a65392$var$_excluded3 = [
    "onPaste",
    "onKeyDown",
    "inputMode",
    "readOnly",
    "InputProps",
    "inputProps",
    "inputRef",
    "onClear",
    "clearable",
    "clearButtonPosition",
    "openPickerButtonPosition",
    "openPickerAriaLabel"
], $d2d3640b21a65392$var$_excluded4 = [
    "ownerState"
], $d2d3640b21a65392$var$_excluded5 = [
    "ownerState"
], $d2d3640b21a65392$var$_excluded6 = [
    "ownerState"
], $d2d3640b21a65392$var$_excluded7 = [
    "ownerState"
], $d2d3640b21a65392$var$_excluded8 = [
    "InputProps",
    "inputProps"
];
const $d2d3640b21a65392$var$noop = ()=>{};
const $d2d3640b21a65392$export$d31e0c72c716cd73 = (_ref)=>{
    let { enableAccessibleFieldDOMStructure: enableAccessibleFieldDOMStructure } = _ref, fieldResponse = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $d2d3640b21a65392$var$_excluded);
    if (enableAccessibleFieldDOMStructure) {
        const { InputProps: InputProps, readOnly: readOnly, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel } = fieldResponse, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(fieldResponse, $d2d3640b21a65392$var$_excluded2);
        const mergedInputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && other?.slotProps?.input ? $d2d3640b21a65392$export$b01d1e419b049226(other?.slotProps?.input, InputProps) : $d2d3640b21a65392$var$noop;
        return {
            clearable: clearable,
            onClear: onClear,
            clearButtonPosition: clearButtonPosition,
            openPickerButtonPosition: openPickerButtonPosition,
            openPickerAriaLabel: openPickerAriaLabel,
            textFieldProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && other?.slotProps?.input ? {
                slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other?.slotProps, {
                    input: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(mergedInputProps, ownerState), {
                            readOnly: readOnly
                        })
                })
            } : {
                InputProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
                    readOnly: readOnly
                })
            })
        };
    }
    const { onPaste: onPaste, onKeyDown: onKeyDown, inputMode: inputMode, readOnly: readOnly, InputProps: InputProps, inputProps: inputProps, inputRef: inputRef, onClear: onClear, clearable: clearable, clearButtonPosition: clearButtonPosition, openPickerButtonPosition: openPickerButtonPosition, openPickerAriaLabel: openPickerAriaLabel } = fieldResponse, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(fieldResponse, $d2d3640b21a65392$var$_excluded3);
    const mergedInputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && other?.slotProps?.input ? $d2d3640b21a65392$export$b01d1e419b049226(other?.slotProps?.input, InputProps) : $d2d3640b21a65392$var$noop;
    const mergedHtmlInputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && other?.slotProps?.htmlInput ? $d2d3640b21a65392$export$b01d1e419b049226(other?.slotProps?.htmlInput, inputProps) : $d2d3640b21a65392$var$noop;
    return {
        clearable: clearable,
        onClear: onClear,
        clearButtonPosition: clearButtonPosition,
        openPickerButtonPosition: openPickerButtonPosition,
        openPickerAriaLabel: openPickerAriaLabel,
        textFieldProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && (other?.slotProps?.input || other?.slotProps?.htmlInput) ? {
            slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other?.slotProps, {
                input: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(mergedInputProps, ownerState), {
                        readOnly: readOnly
                    }),
                htmlInput: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(mergedHtmlInputProps, ownerState), {
                        inputMode: inputMode,
                        onPaste: onPaste,
                        onKeyDown: onKeyDown,
                        ref: inputRef
                    })
            })
        } : {
            InputProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, InputProps ?? {}, {
                readOnly: readOnly
            }),
            inputProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, inputProps ?? {}, {
                inputMode: inputMode,
                onPaste: onPaste,
                onKeyDown: onKeyDown,
                ref: inputRef
            })
        })
    };
};
const $d2d3640b21a65392$export$f5bc58012fe60483 = /*#__PURE__*/ $acw62.createContext({
    slots: {},
    slotProps: {},
    inputRef: undefined
});
function $d2d3640b21a65392$export$f83254b974f9d6d3(props) {
    const { fieldResponse: fieldResponse, defaultOpenPickerIcon: defaultOpenPickerIcon } = props;
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const pickerContext = (0, $38272c59950c5653$export$20c6f014e602a134)();
    const pickerFieldUIContext = $acw62.useContext($d2d3640b21a65392$export$f5bc58012fe60483);
    const { textFieldProps: textFieldProps, onClear: onClear, clearable: clearable, openPickerAriaLabel: openPickerAriaLabel, clearButtonPosition: clearButtonPositionProp = 'end', openPickerButtonPosition: openPickerButtonPositionProp = 'end' } = $d2d3640b21a65392$export$d31e0c72c716cd73(fieldResponse);
    const ownerState = (0, $99bc14e4e693dcb7$export$fe06f3f35a7c97cd)(textFieldProps);
    const handleClickOpeningButton = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        event.preventDefault();
        pickerContext?.setOpen((prev)=>!prev);
    });
    const triggerStatus = pickerContext ? pickerContext.triggerStatus : 'hidden';
    const clearButtonPosition = clearable ? clearButtonPositionProp : null;
    const openPickerButtonPosition = triggerStatus !== 'hidden' ? openPickerButtonPositionProp : null;
    const TextField = pickerFieldUIContext.slots.textField ?? (fieldResponse.enableAccessibleFieldDOMStructure === false ? (0, $f480fb6201951027$export$2e2bcd8739ae039) : (0, $e1cfb92b1b93cb9b$export$b3e9b101d92e4d4d));
    const InputAdornment = pickerFieldUIContext.slots.inputAdornment ?? (0, $0ffab78552448ba6$export$2e2bcd8739ae039);
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'start'
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            position: 'start'
        })
    }), startInputAdornmentProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $d2d3640b21a65392$var$_excluded4);
    const _useSlotProps2 = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: InputAdornment,
        externalSlotProps: pickerFieldUIContext.slotProps.inputAdornment,
        additionalProps: {
            position: 'end'
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            position: 'end'
        })
    }), endInputAdornmentProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps2, $d2d3640b21a65392$var$_excluded5);
    const OpenPickerButton = pickerFieldUIContext.slots.openPickerButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps3 = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: OpenPickerButton,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerButton,
        additionalProps: {
            disabled: triggerStatus === 'disabled',
            onClick: handleClickOpeningButton,
            'aria-label': openPickerAriaLabel,
            edge: // open button is always rendered at the edge
            textFieldProps.variant !== 'standard' ? openPickerButtonPosition : false
        },
        ownerState: ownerState
    }), openPickerButtonProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps3, $d2d3640b21a65392$var$_excluded6);
    const OpenPickerIcon = pickerFieldUIContext.slots.openPickerIcon ?? defaultOpenPickerIcon;
    const openPickerIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: OpenPickerIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.openPickerIcon,
        ownerState: ownerState
    });
    const ClearButton = pickerFieldUIContext.slots.clearButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    // We don't want to forward the `ownerState` to the `<IconButton />` component, see mui/material-ui#34056
    const _useSlotProps4 = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: ClearButton,
        externalSlotProps: pickerFieldUIContext.slotProps.clearButton,
        className: 'clearButton',
        additionalProps: {
            title: translations.fieldClearLabel,
            tabIndex: -1,
            onClick: onClear,
            disabled: fieldResponse.disabled || fieldResponse.readOnly,
            edge: // clear button can only be at the edge if it's position differs from the open button
            textFieldProps.variant !== 'standard' && clearButtonPosition !== openPickerButtonPosition ? clearButtonPosition : false
        },
        ownerState: ownerState
    }), clearButtonProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps4, $d2d3640b21a65392$var$_excluded7);
    const ClearIcon = pickerFieldUIContext.slots.clearIcon ?? (0, $ef8448afaa732d42$export$cefbac224a47f32);
    const clearIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: ClearIcon,
        externalSlotProps: pickerFieldUIContext.slotProps.clearIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    textFieldProps.ref = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(textFieldProps.ref, pickerContext?.rootRef);
    const additionalTextFieldInputProps = {};
    const textFieldInputProps = (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(((0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && textFieldProps?.slotProps?.input) ?? textFieldProps.InputProps, ownerState);
    if (pickerContext) additionalTextFieldInputProps.ref = pickerContext.triggerRef;
    if (!textFieldInputProps?.startAdornment && (clearButtonPosition === 'start' || openPickerButtonPosition === 'start')) additionalTextFieldInputProps.startAdornment = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(InputAdornment, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, startInputAdornmentProps, {
        children: [
            openPickerButtonPosition === 'start' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(OpenPickerButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(OpenPickerIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, openPickerIconProps))
            })),
            clearButtonPosition === 'start' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ClearButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ClearIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, clearIconProps))
            }))
        ]
    }));
    if (!textFieldInputProps?.endAdornment && (clearButtonPosition === 'end' || openPickerButtonPosition === 'end')) additionalTextFieldInputProps.endAdornment = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(InputAdornment, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, endInputAdornmentProps, {
        children: [
            clearButtonPosition === 'end' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ClearButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, clearButtonProps, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ClearIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, clearIconProps))
            })),
            openPickerButtonPosition === 'end' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(OpenPickerButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, openPickerButtonProps, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(OpenPickerIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, openPickerIconProps))
            }))
        ]
    }));
    // handle the case of showing custom `inputAdornment` for Field components
    if (!additionalTextFieldInputProps?.endAdornment && !additionalTextFieldInputProps?.startAdornment && pickerFieldUIContext.slots.inputAdornment) additionalTextFieldInputProps.endAdornment = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(InputAdornment, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, endInputAdornmentProps));
    if (clearButtonPosition != null) textFieldProps.sx = [
        {
            '& .clearButton': {
                opacity: 1
            },
            '@media (pointer: fine)': {
                '& .clearButton': {
                    opacity: 0
                },
                '&:hover, &:focus-within': {
                    '.clearButton': {
                        opacity: 1
                    }
                }
            }
        },
        ...Array.isArray(textFieldProps.sx) ? textFieldProps.sx : [
            textFieldProps.sx
        ]
    ];
    const resolvedTextFieldInputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && textFieldProps?.slotProps?.input ? (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)($d2d3640b21a65392$export$b01d1e419b049226(textFieldInputProps, additionalTextFieldInputProps), ownerState) : (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, textFieldInputProps, additionalTextFieldInputProps);
    // We need to resolve the `inputProps` since we are messing with those props in this component.
    textFieldProps.inputProps = (0, $725dc7d66274f756$export$c7133ab33cb183d1) >= 6 && textFieldProps?.slotProps?.htmlInput ? (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(textFieldProps.slotProps.htmlInput, ownerState) : textFieldProps.inputProps;
    // Remove the `input` slotProps to avoid them overriding the manually resolved `InputProps`.
    // Relevant on `materialMajor >= 6` since `slotProps` would take precedence.
    delete textFieldProps?.slotProps?.input;
    if (fieldResponse.enableAccessibleFieldDOMStructure) // Remove the `slotProps` on `PickersTextField` as they are not supported.
    delete textFieldProps?.slotProps;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TextField, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, textFieldProps, {
        InputProps: resolvedTextFieldInputProps
    }));
}
function $d2d3640b21a65392$export$b01d1e419b049226(slotPropsA, slotPropsB) {
    if (!slotPropsA) return slotPropsB;
    if (!slotPropsB) return slotPropsA;
    return (ownerState)=>{
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(slotPropsB, ownerState), (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(slotPropsA, ownerState));
    };
}
function $d2d3640b21a65392$export$fa1adc26aa0d007a(parameters) {
    const { ref: ref, externalForwardedProps: externalForwardedProps, slotProps: slotProps } = parameters;
    const pickerFieldUIContext = $acw62.useContext($d2d3640b21a65392$export$f5bc58012fe60483);
    const pickerContext = (0, $38272c59950c5653$export$20c6f014e602a134)();
    const ownerState = (0, $99bc14e4e693dcb7$export$fe06f3f35a7c97cd)(externalForwardedProps);
    const { InputProps: InputProps, inputProps: inputProps } = externalForwardedProps, otherExternalForwardedProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(externalForwardedProps, $d2d3640b21a65392$var$_excluded8);
    const textFieldProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: (0, $e1cfb92b1b93cb9b$export$b3e9b101d92e4d4d),
        externalSlotProps: $d2d3640b21a65392$export$b01d1e419b049226(pickerFieldUIContext.slotProps.textField, slotProps?.textField),
        externalForwardedProps: otherExternalForwardedProps,
        additionalProps: {
            ref: ref,
            sx: pickerContext?.rootSx,
            label: pickerContext?.label,
            name: pickerContext?.name,
            className: pickerContext?.rootClassName,
            inputRef: pickerFieldUIContext.inputRef
        },
        ownerState: ownerState
    });
    // TODO: Remove when mui/material-ui#35088 will be merged
    textFieldProps.inputProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, inputProps, textFieldProps.inputProps);
    textFieldProps.InputProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, InputProps, textFieldProps.InputProps);
    return textFieldProps;
}
function $d2d3640b21a65392$export$5a824d9f5f1d0778(props) {
    const { slots: slots = {}, slotProps: slotProps = {}, inputRef: inputRef, children: children } = props;
    const contextValue = $acw62.useMemo(()=>({
            inputRef: inputRef,
            slots: {
                openPickerButton: slots.openPickerButton,
                openPickerIcon: slots.openPickerIcon,
                textField: slots.textField,
                inputAdornment: slots.inputAdornment,
                clearIcon: slots.clearIcon,
                clearButton: slots.clearButton
            },
            slotProps: {
                openPickerButton: slotProps.openPickerButton,
                openPickerIcon: slotProps.openPickerIcon,
                textField: slotProps.textField,
                inputAdornment: slotProps.inputAdornment,
                clearIcon: slotProps.clearIcon,
                clearButton: slotProps.clearButton
            }
        }), [
        inputRef,
        slots.openPickerButton,
        slots.openPickerIcon,
        slots.textField,
        slots.inputAdornment,
        slots.clearIcon,
        slots.clearButton,
        slotProps.openPickerButton,
        slotProps.openPickerIcon,
        slotProps.textField,
        slotProps.inputAdornment,
        slotProps.clearIcon,
        slotProps.clearButton
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d2d3640b21a65392$export$f5bc58012fe60483.Provider, {
        value: contextValue,
        children: children
    });
}




'use client';
const $e0ec0b3c450466b8$var$_excluded = [
    "slots",
    "slotProps"
];
/**
 * Demos:
 *
 * - [DateField](http://mui.com/x/react-date-pickers/date-field/)
 * - [Fields](https://mui.com/x/react-date-pickers/fields/)
 *
 * API:
 *
 * - [DateField API](https://mui.com/x/api/date-pickers/date-field/)
 */ const $e0ec0b3c450466b8$export$d9781c7894a82487 = /*#__PURE__*/ $acw62.forwardRef(function DateField(inProps, inRef) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDateField'
    });
    const { slots: slots, slotProps: slotProps } = themeProps, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(themeProps, $e0ec0b3c450466b8$var$_excluded);
    const textFieldProps = (0, $d2d3640b21a65392$export$fa1adc26aa0d007a)({
        slotProps: slotProps,
        ref: inRef,
        externalForwardedProps: other
    });
    const fieldResponse = (0, $f117aff76d53d0eb$export$5591b0b878c1a989)(textFieldProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2d3640b21a65392$export$5a824d9f5f1d0778), {
        slots: slots,
        slotProps: slotProps,
        inputRef: other.inputRef,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2d3640b21a65392$export$f83254b974f9d6d3), {
            fieldResponse: fieldResponse,
            defaultOpenPickerIcon: (0, $ef8448afaa732d42$export$5fda1783bb83f57b)
        })
    });
});


parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


'use client';
const $80335e50844415f8$export$7d1a419f34475191 = ({ shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, minDate: minDate, maxDate: maxDate, disableFuture: disableFuture, disablePast: disablePast, timezone: timezone })=>{
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    return $acw62.useCallback((day)=>(0, $cee5e9e903761e8a$export$ffb3d0046ef3a2)({
            adapter: adapter,
            value: day,
            timezone: timezone,
            props: {
                shouldDisableDate: shouldDisableDate,
                shouldDisableMonth: shouldDisableMonth,
                shouldDisableYear: shouldDisableYear,
                minDate: minDate,
                maxDate: maxDate,
                disableFuture: disableFuture,
                disablePast: disablePast
            }
        }) !== null, [
        adapter,
        shouldDisableDate,
        shouldDisableMonth,
        shouldDisableYear,
        minDate,
        maxDate,
        disableFuture,
        disablePast,
        timezone
    ]);
};






'use client';
const $5efae1633883dea7$var$createCalendarStateReducer = (reduceAnimations, adapter)=>(state, action)=>{
        switch(action.type){
            case 'setVisibleDate':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    slideDirection: action.direction,
                    currentMonth: action.month,
                    isMonthSwitchingAnimating: !adapter.isSameMonth(action.month, state.currentMonth) && !reduceAnimations && !action.skipAnimation,
                    focusedDay: action.focusedDay
                });
            case 'changeMonthTimezone':
                {
                    const newTimezone = action.newTimezone;
                    if (adapter.getTimezone(state.currentMonth) === newTimezone) return state;
                    let newCurrentMonth = adapter.setTimezone(state.currentMonth, newTimezone);
                    if (adapter.getMonth(newCurrentMonth) !== adapter.getMonth(state.currentMonth)) newCurrentMonth = adapter.setMonth(newCurrentMonth, adapter.getMonth(state.currentMonth));
                    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                        currentMonth: newCurrentMonth
                    });
                }
            case 'finishMonthSwitchingAnimation':
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    isMonthSwitchingAnimating: false
                });
            default:
                throw new Error('missing support');
        }
    };
const $5efae1633883dea7$export$6d095e787d2b5e1f = (params)=>{
    const { value: value, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onYearChange: onYearChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, timezone: timezone, getCurrentMonthFromVisibleDate: getCurrentMonthFromVisibleDate } = params;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const reducerFn = $acw62.useRef($5efae1633883dea7$var$createCalendarStateReducer(Boolean(reduceAnimations), adapter)).current;
    const referenceDate = $acw62.useMemo(()=>{
        return (0, $235c2ad72f19522e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            timezone: timezone,
            props: params,
            referenceDate: referenceDateProp,
            granularity: (0, $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac).day
        });
    }, // We want the `referenceDate` to update on prop and `timezone` change (https://github.com/mui/mui-x/issues/10804)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        referenceDateProp,
        timezone
    ]);
    const [calendarState, dispatch] = $acw62.useReducer(reducerFn, {
        isMonthSwitchingAnimating: false,
        focusedDay: referenceDate,
        currentMonth: adapter.startOfMonth(referenceDate),
        slideDirection: 'left'
    });
    const isDateDisabled = (0, $80335e50844415f8$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        minDate: minDate,
        maxDate: maxDate,
        disableFuture: disableFuture,
        disablePast: disablePast,
        timezone: timezone
    });
    // Ensure that `calendarState.currentMonth` timezone is updated when `referenceDate` (or timezone changes)
    // https://github.com/mui/mui-x/issues/10804
    $acw62.useEffect(()=>{
        dispatch({
            type: 'changeMonthTimezone',
            newTimezone: adapter.getTimezone(referenceDate)
        });
    }, [
        referenceDate,
        adapter
    ]);
    const setVisibleDate = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ target: target, reason: reason })=>{
        if (reason === 'cell-interaction' && calendarState.focusedDay != null && adapter.isSameDay(target, calendarState.focusedDay)) return;
        const skipAnimation = reason === 'cell-interaction';
        let month;
        let focusedDay;
        if (reason === 'cell-interaction') {
            month = getCurrentMonthFromVisibleDate(target, calendarState.currentMonth);
            focusedDay = target;
        } else {
            month = adapter.isSameMonth(target, calendarState.currentMonth) ? calendarState.currentMonth : adapter.startOfMonth(target);
            focusedDay = target;
            // If the date is disabled, we try to find a non-disabled date inside the same month.
            if (isDateDisabled(focusedDay)) {
                const startOfMonth = adapter.startOfMonth(target);
                const endOfMonth = adapter.endOfMonth(target);
                focusedDay = (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
                    adapter: adapter,
                    date: focusedDay,
                    minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
                    maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
                    disablePast: disablePast,
                    disableFuture: disableFuture,
                    isDateDisabled: isDateDisabled,
                    timezone: timezone
                });
            }
        }
        const hasChangedMonth = !adapter.isSameMonth(calendarState.currentMonth, month);
        const hasChangedYear = !adapter.isSameYear(calendarState.currentMonth, month);
        if (hasChangedMonth) onMonthChange?.(month);
        if (hasChangedYear) onYearChange?.(adapter.startOfYear(month));
        dispatch({
            type: 'setVisibleDate',
            month: month,
            direction: adapter.isAfterDay(month, calendarState.currentMonth) ? 'left' : 'right',
            focusedDay: calendarState.focusedDay != null && focusedDay != null && adapter.isSameDay(focusedDay, calendarState.focusedDay) ? calendarState.focusedDay : focusedDay,
            skipAnimation: skipAnimation
        });
    });
    const onMonthSwitchingAnimationEnd = $acw62.useCallback(()=>{
        dispatch({
            type: 'finishMonthSwitchingAnimation'
        });
    }, []);
    return {
        referenceDate: referenceDate,
        calendarState: calendarState,
        setVisibleDate: setVisibleDate,
        isDateDisabled: isDateDisabled,
        onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd
    };
};



parcelRequire("acw62");







const $9692949b07390f50$export$5b0bb0174eb448ca = (slot)=>(0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', slot);
const $9692949b07390f50$export$1461f245817ac559 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersFadeTransitionGroup', [
    'root'
]);



const $9c2e6cdd3bb22caf$var$_excluded = [
    "children"
];
const $9c2e6cdd3bb22caf$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $9692949b07390f50$export$5b0bb0174eb448ca), classes);
};
const $9c2e6cdd3bb22caf$var$PickersFadeTransitionGroupRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
    name: 'MuiPickersFadeTransitionGroup',
    slot: 'Root'
})({
    display: 'block',
    position: 'relative'
});
function $9c2e6cdd3bb22caf$export$5262185daf493fee(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersFadeTransitionGroup'
    });
    const { className: className, reduceAnimations: reduceAnimations, transKey: transKey, classes: classesProp } = props;
    const { children: children } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9c2e6cdd3bb22caf$var$_excluded);
    const classes = $9c2e6cdd3bb22caf$var$useUtilityClasses(classesProp);
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    if (reduceAnimations) return children;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9c2e6cdd3bb22caf$var$PickersFadeTransitionGroupRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: other,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039), {
            appear: false,
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: {
                appear: theme.transitions.duration.enteringScreen,
                enter: theme.transitions.duration.enteringScreen,
                exit: 0
            },
            children: children
        }, transKey)
    });
}





var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");











function $df0c8e310c59ad79$export$4b25deb0350d3e53(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersDay', slot);
}
const $df0c8e310c59ad79$export$68b221ad3c35e288 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersDay', [
    'root',
    'dayWithMargin',
    'dayOutsideMonth',
    'hiddenDaySpacingFiller',
    'today',
    'selected',
    'disabled'
]);




var $acw62 = parcelRequire("acw62");


function $0611e97a4959ebfc$export$250873c81c19b1fa(parameters) {
    const { disabled: disabled, selected: selected, today: today, outsideCurrentMonth: outsideCurrentMonth, day: day, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = parameters;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
            day: day,
            isDaySelected: selected ?? false,
            isDayDisabled: disabled ?? false,
            isDayCurrent: today ?? false,
            isDayOutsideMonth: outsideCurrentMonth ?? false,
            isDayStartOfWeek: adapter.isSameDay(day, adapter.startOfWeek(day)),
            isDayEndOfWeek: adapter.isSameDay(day, adapter.endOfWeek(day)),
            disableMargin: disableMargin ?? false,
            disableHighlightToday: disableHighlightToday ?? false,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth ?? false
        }), [
        adapter,
        pickerOwnerState,
        day,
        selected,
        disabled,
        today,
        outsideCurrentMonth,
        disableMargin,
        disableHighlightToday,
        showDaysOutsideCurrentMonth
    ]);
}



'use client';
const $debdf8ecd16a24d2$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "hidden",
    "isAnimating",
    "onClick",
    "onDaySelect",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "onMouseDown",
    "onMouseEnter",
    "children",
    "isFirstVisibleCell",
    "isLastVisibleCell",
    "day",
    "selected",
    "disabled",
    "today",
    "outsideCurrentMonth",
    "disableMargin",
    "disableHighlightToday",
    "showDaysOutsideCurrentMonth"
];
const $debdf8ecd16a24d2$var$useUtilityClasses = (classes, ownerState)=>{
    const { isDaySelected: isDaySelected, isDayDisabled: isDayDisabled, isDayCurrent: isDayCurrent, isDayOutsideMonth: isDayOutsideMonth, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = ownerState;
    const isHiddenDaySpacingFiller = isDayOutsideMonth && !showDaysOutsideCurrentMonth;
    const slots = {
        root: [
            'root',
            isDaySelected && !isHiddenDaySpacingFiller && 'selected',
            isDayDisabled && 'disabled',
            !disableMargin && 'dayWithMargin',
            !disableHighlightToday && isDayCurrent && 'today',
            isDayOutsideMonth && showDaysOutsideCurrentMonth && 'dayOutsideMonth',
            isHiddenDaySpacingFiller && 'hiddenDaySpacingFiller'
        ],
        hiddenDaySpacingFiller: [
            'hiddenDaySpacingFiller'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $df0c8e310c59ad79$export$4b25deb0350d3e53), classes);
};
const $debdf8ecd16a24d2$var$styleArg = ({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0),
        height: (0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0),
        borderRadius: '50%',
        padding: 0,
        // explicitly setting to `transparent` to avoid potentially getting impacted by change from the overridden component
        backgroundColor: 'transparent',
        transition: theme.transitions.create('background-color', {
            duration: theme.transitions.duration.short
        }),
        color: (theme.vars || theme).palette.text.primary,
        '@media (pointer: fine)': {
            '&:hover': {
                backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
            }
        },
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.primary.mainChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.primary.main, theme.palette.action.focusOpacity),
            [`&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected}`]: {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            fontWeight: theme.typography.fontWeightMedium,
            '&:hover': {
                willChange: 'background-color',
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        },
        [`&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).disabled}:not(.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected})`]: {
            color: (theme.vars || theme).palette.text.disabled
        },
        [`&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).disabled}&.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected}`]: {
            opacity: 0.6
        },
        variants: [
            {
                props: {
                    disableMargin: false
                },
                style: {
                    margin: `0 ${(0, $e7cd373dd46c88ee$export$dde58b009b497666)}px`
                }
            },
            {
                props: {
                    isDayOutsideMonth: true,
                    showDaysOutsideCurrentMonth: true
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary
                }
            },
            {
                props: {
                    disableHighlightToday: false,
                    isDayCurrent: true
                },
                style: {
                    [`&:not(.${(0, $df0c8e310c59ad79$export$68b221ad3c35e288).selected})`]: {
                        border: `1px solid ${(theme.vars || theme).palette.text.secondary}`
                    }
                }
            }
        ]
    });
const $debdf8ecd16a24d2$var$overridesResolver = (props, styles)=>{
    const { ownerState: ownerState } = props;
    return [
        styles.root,
        !ownerState.disableMargin && styles.dayWithMargin,
        !ownerState.disableHighlightToday && ownerState.isDayCurrent && styles.today,
        !ownerState.isDayOutsideMonth && ownerState.showDaysOutsideCurrentMonth && styles.dayOutsideMonth,
        ownerState.isDayOutsideMonth && !ownerState.showDaysOutsideCurrentMonth && styles.hiddenDaySpacingFiller
    ];
};
const $debdf8ecd16a24d2$var$PickersDayRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $debdf8ecd16a24d2$var$overridesResolver
})($debdf8ecd16a24d2$var$styleArg);
const $debdf8ecd16a24d2$var$PickersDayFiller = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersDay',
    slot: 'Root',
    overridesResolver: $debdf8ecd16a24d2$var$overridesResolver
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $debdf8ecd16a24d2$var$styleArg({
        theme: theme
    }), {
        // visibility: 'hidden' does not work here as it hides the element from screen readers as well
        opacity: 0,
        pointerEvents: 'none'
    }));
const $debdf8ecd16a24d2$var$noop = ()=>{};
const $debdf8ecd16a24d2$var$PickersDayRaw = /*#__PURE__*/ $acw62.forwardRef(function PickersDay(inProps, forwardedRef) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersDay'
    });
    const { autoFocus: autoFocus = false, className: className, classes: classesProp, isAnimating: isAnimating, onClick: onClick, onDaySelect: onDaySelect, onFocus: onFocus = $debdf8ecd16a24d2$var$noop, onBlur: onBlur = $debdf8ecd16a24d2$var$noop, onKeyDown: onKeyDown = $debdf8ecd16a24d2$var$noop, onMouseDown: onMouseDown = $debdf8ecd16a24d2$var$noop, onMouseEnter: onMouseEnter = $debdf8ecd16a24d2$var$noop, children: children, day: day, selected: selected, disabled: disabled, today: today, outsideCurrentMonth: outsideCurrentMonth, disableMargin: disableMargin, disableHighlightToday: disableHighlightToday, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $debdf8ecd16a24d2$var$_excluded);
    const ownerState = (0, $0611e97a4959ebfc$export$250873c81c19b1fa)({
        day: day,
        selected: selected,
        disabled: disabled,
        today: today,
        outsideCurrentMonth: outsideCurrentMonth,
        disableMargin: disableMargin,
        disableHighlightToday: disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const classes = $debdf8ecd16a24d2$var$useUtilityClasses(classesProp, ownerState);
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const ref = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, forwardedRef);
    // Since this is rendered when a Popper is opened we can't use passive effects.
    // Focusing in passive effects in Popper causes scroll jump.
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (autoFocus && !disabled && !isAnimating && !outsideCurrentMonth) // ref.current being null would be a bug in MUI
        ref.current.focus();
    }, [
        autoFocus,
        disabled,
        isAnimating,
        outsideCurrentMonth
    ]);
    // For a day outside the current month, move the focus from mouseDown to mouseUp
    // Goal: have the onClick ends before sliding to the new month
    const handleMouseDown = (event)=>{
        onMouseDown(event);
        if (outsideCurrentMonth) event.preventDefault();
    };
    const handleClick = (event)=>{
        event.defaultMuiPrevented = true;
        if (!disabled) onDaySelect(day);
        if (outsideCurrentMonth) event.currentTarget.focus();
        if (onClick) onClick(event);
    };
    if (outsideCurrentMonth && !showDaysOutsideCurrentMonth) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($debdf8ecd16a24d2$var$PickersDayFiller, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, classes.hiddenDaySpacingFiller, className),
        ownerState: ownerState,
        role: other.role
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($debdf8ecd16a24d2$var$PickersDayRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: handleRef,
        centerRipple: true,
        disabled: disabled,
        tabIndex: selected ? 0 : -1,
        onKeyDown: (event)=>onKeyDown(event, day),
        onFocus: (event)=>onFocus(event, day),
        onBlur: (event)=>onBlur(event, day),
        onMouseEnter: (event)=>onMouseEnter(event, day),
        onClick: handleClick,
        onMouseDown: handleMouseDown
    }, other, {
        ownerState: ownerState,
        children: children ?? adapter.format(day, 'dayOfMonth')
    }));
});
const $debdf8ecd16a24d2$export$d7378e6e864346fa = /*#__PURE__*/ $acw62.memo($debdf8ecd16a24d2$var$PickersDayRaw);








var $acw62 = parcelRequire("acw62");







/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $3c0eef4e7b8d3866$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $620ffe1c3bcccf8e$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3c0eef4e7b8d3866$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}


function $c22b31c675df16bf$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $c22b31c675df16bf$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $c22b31c675df16bf$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $c22b31c675df16bf$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



var $acw62 = parcelRequire("acw62");



var $ee2e736fe07a2c40$var$_addClass = function addClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $620ffe1c3bcccf8e$export$2e2bcd8739ae039)(node, c);
    });
};
var $ee2e736fe07a2c40$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(' ').forEach(function(c) {
        return (0, $c22b31c675df16bf$export$2e2bcd8739ae039)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](https://docs.angularjs.org/api/ngAnimate) library, you should
 * use it if you're using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**, so it's
 * important to add `transition` declaration only to them, otherwise transitions
 * might not behave as intended! This might not be obvious when the transitions
 * are symmetrical, i.e. when `*-enter-active` is the same as `*-exit`, like in
 * the example above (minus `transition`), but it becomes apparent in more
 * complex transitions.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */ var $ee2e736fe07a2c40$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    (0, $bbb54ce93eb94a95$export$2e2bcd8739ae039)(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.appliedClasses = {
            appear: {},
            enter: {},
            exit: {}
        };
        _this.onEnter = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument[0], appearing = _this$resolveArgument[1];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
            if (_this.props.onEnter) _this.props.onEnter(maybeNode, maybeAppearing);
        };
        _this.onEntering = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument2 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument2[0], appearing = _this$resolveArgument2[1];
            var type = appearing ? 'appear' : 'enter';
            _this.addClass(node, type, 'active');
            if (_this.props.onEntering) _this.props.onEntering(maybeNode, maybeAppearing);
        };
        _this.onEntered = function(maybeNode, maybeAppearing) {
            var _this$resolveArgument3 = _this.resolveArguments(maybeNode, maybeAppearing), node = _this$resolveArgument3[0], appearing = _this$resolveArgument3[1];
            var type = appearing ? 'appear' : 'enter';
            _this.removeClasses(node, type);
            _this.addClass(node, type, 'done');
            if (_this.props.onEntered) _this.props.onEntered(maybeNode, maybeAppearing);
        };
        _this.onExit = function(maybeNode) {
            var _this$resolveArgument4 = _this.resolveArguments(maybeNode), node = _this$resolveArgument4[0];
            _this.removeClasses(node, 'appear');
            _this.removeClasses(node, 'enter');
            _this.addClass(node, 'exit', 'base');
            if (_this.props.onExit) _this.props.onExit(maybeNode);
        };
        _this.onExiting = function(maybeNode) {
            var _this$resolveArgument5 = _this.resolveArguments(maybeNode), node = _this$resolveArgument5[0];
            _this.addClass(node, 'exit', 'active');
            if (_this.props.onExiting) _this.props.onExiting(maybeNode);
        };
        _this.onExited = function(maybeNode) {
            var _this$resolveArgument6 = _this.resolveArguments(maybeNode), node = _this$resolveArgument6[0];
            _this.removeClasses(node, 'exit');
            _this.addClass(node, 'exit', 'done');
            if (_this.props.onExited) _this.props.onExited(maybeNode);
        };
        _this.resolveArguments = function(maybeNode, maybeAppearing) {
            return _this.props.nodeRef ? [
                _this.props.nodeRef.current,
                maybeNode
            ] // here `maybeNode` is actually `appearing`
             : [
                maybeNode,
                maybeAppearing
            ];
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === 'string';
            var prefix = isStringClassNames && classNames ? classNames + "-" : '';
            var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
            return {
                baseClassName: baseClassName,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.addClass = function addClass(node, type, phase) {
        var className = this.getClassNames(type)[phase + "ClassName"];
        var _this$getClassNames = this.getClassNames('enter'), doneClassName = _this$getClassNames.doneClassName;
        if (type === 'appear' && phase === 'done' && doneClassName) className += " " + doneClassName;
         // This is to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (phase === 'active') {
            if (node) (0, $37faf39349e00e45$export$7d26bbb1236dafd6)(node);
        }
        if (className) {
            this.appliedClasses[type][phase] = className;
            $ee2e736fe07a2c40$var$_addClass(node, className);
        }
    };
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$appliedClasses$ = this.appliedClasses[type], baseClassName = _this$appliedClasses$.base, activeClassName = _this$appliedClasses$.active, doneClassName = _this$appliedClasses$.done;
        this.appliedClasses[type] = {};
        if (baseClassName) $ee2e736fe07a2c40$var$removeClass(node, baseClassName);
        if (activeClassName) $ee2e736fe07a2c40$var$removeClass(node, activeClassName);
        if (doneClassName) $ee2e736fe07a2c40$var$removeClass(node, doneClassName);
    };
    _proto.render = function render() {
        var _this$props = this.props, _ = _this$props.classNames, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_this$props, [
            "classNames"
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, $0fef977f04119bf5$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Component);
$ee2e736fe07a2c40$var$CSSTransition.defaultProps = {
    classNames: ''
};
$ee2e736fe07a2c40$var$CSSTransition.propTypes = {};
var $ee2e736fe07a2c40$export$2e2bcd8739ae039 = $ee2e736fe07a2c40$var$CSSTransition;




const $3d4cac44a9271592$export$e98c1b6c3bbc3c59 = (slot)=>(0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersSlideTransition', slot);
const $3d4cac44a9271592$export$d251a58673156a67 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersSlideTransition', [
    'root',
    'slideEnter-left',
    'slideEnter-right',
    'slideEnterActive',
    'slideExit',
    'slideExitActiveLeft-left',
    'slideExitActiveLeft-right'
]);




const $ef9c59b47aaa2788$var$_excluded = [
    "children",
    "className",
    "reduceAnimations",
    "slideDirection",
    "transKey",
    "classes"
];
const $ef9c59b47aaa2788$var$useUtilityClasses = (classes, ownerState)=>{
    const { slideDirection: slideDirection } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        exit: [
            'slideExit'
        ],
        enterActive: [
            'slideEnterActive'
        ],
        enter: [
            `slideEnter-${slideDirection}`
        ],
        exitActive: [
            `slideExitActiveLeft-${slideDirection}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $3d4cac44a9271592$export$e98c1b6c3bbc3c59), classes);
};
const $ef9c59b47aaa2788$var$PickersSlideTransitionRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $e4ea38a8b431e8fc$export$2e2bcd8739ae039), {
    name: 'MuiPickersSlideTransition',
    slot: 'Root',
    overridesResolver: (_, styles)=>[
            styles.root,
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideEnter-left']}`]: styles['slideEnter-left']
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideEnter-right']}`]: styles['slideEnter-right']
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67).slideEnterActive}`]: styles.slideEnterActive
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67).slideExit}`]: styles.slideExit
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: styles['slideExitActiveLeft-left']
            },
            {
                [`.${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: styles['slideExitActiveLeft-right']
            }
        ]
})(({ theme: theme })=>{
    const slideTransition = theme.transitions.create('transform', {
        duration: theme.transitions.duration.complex,
        easing: 'cubic-bezier(0.35, 0.8, 0.4, 1)'
    });
    return {
        display: 'block',
        position: 'relative',
        overflowX: 'hidden',
        '& > *': {
            position: 'absolute',
            top: 0,
            right: 0,
            left: 0
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideEnter-left']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            zIndex: 1
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideEnter-right']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            zIndex: 1
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67).slideEnterActive}`]: {
            transform: 'translate(0%)',
            transition: slideTransition
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67).slideExit}`]: {
            transform: 'translate(0%)'
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideExitActiveLeft-left']}`]: {
            willChange: 'transform',
            transform: 'translate(-100%)',
            transition: slideTransition,
            zIndex: 0
        },
        [`& .${(0, $3d4cac44a9271592$export$d251a58673156a67)['slideExitActiveLeft-right']}`]: {
            willChange: 'transform',
            transform: 'translate(100%)',
            transition: slideTransition,
            zIndex: 0
        }
    };
});
function $ef9c59b47aaa2788$export$e868fcc7557d3a06(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersSlideTransition'
    });
    const { children: children, className: className, reduceAnimations: reduceAnimations, slideDirection: slideDirection, transKey: transKey, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $ef9c59b47aaa2788$var$_excluded);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        slideDirection: slideDirection
    });
    const classes = $ef9c59b47aaa2788$var$useUtilityClasses(classesProp, ownerState);
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    if (reduceAnimations) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        children: children
    });
    const transitionClasses = {
        exit: classes.exit,
        enterActive: classes.enterActive,
        enter: classes.enter,
        exitActive: classes.exitActive
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ef9c59b47aaa2788$var$PickersSlideTransitionRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        childFactory: (element)=>/*#__PURE__*/ $acw62.cloneElement(element, {
                classNames: transitionClasses
            }),
        role: "presentation",
        ownerState: ownerState,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ee2e736fe07a2c40$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            mountOnEnter: true,
            unmountOnExit: true,
            timeout: theme.transitions.duration.complex,
            classNames: transitionClasses
        }, other, {
            children: children
        }), transKey)
    });
}






const $4b3f532e169788fc$export$fbe827982a69894a = (slot)=>(0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDayCalendar', slot);
const $4b3f532e169788fc$export$b3f91ee59da1294a = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDayCalendar', [
    'root',
    'header',
    'weekDayLabel',
    'loadingContainer',
    'slideTransition',
    'monthContainer',
    'weekContainer',
    'weekNumberLabel',
    'weekNumber'
]);




'use client';
const $8b3294d04d14a0d3$var$_excluded = [
    "parentProps",
    "day",
    "focusedDay",
    "selectedDays",
    "isDateDisabled",
    "currentMonthNumber",
    "isViewFocused"
], $8b3294d04d14a0d3$var$_excluded2 = [
    "ownerState"
];
const $8b3294d04d14a0d3$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        header: [
            'header'
        ],
        weekDayLabel: [
            'weekDayLabel'
        ],
        loadingContainer: [
            'loadingContainer'
        ],
        slideTransition: [
            'slideTransition'
        ],
        monthContainer: [
            'monthContainer'
        ],
        weekContainer: [
            'weekContainer'
        ],
        weekNumberLabel: [
            'weekNumberLabel'
        ],
        weekNumber: [
            'weekNumber'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $4b3f532e169788fc$export$fbe827982a69894a), classes);
};
const $8b3294d04d14a0d3$var$weeksContainerHeight = ((0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0) + (0, $e7cd373dd46c88ee$export$dde58b009b497666) * 2) * 6;
const $8b3294d04d14a0d3$var$PickersCalendarDayRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'Root'
})({});
const $8b3294d04d14a0d3$var$PickersCalendarDayHeader = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'Header'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $8b3294d04d14a0d3$var$PickersCalendarWeekDayLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekDayLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.secondary
    }));
const $8b3294d04d14a0d3$var$PickersCalendarWeekNumberLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumberLabel'
})(({ theme: theme })=>({
        width: 36,
        height: 40,
        margin: '0 2px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: (theme.vars || theme).palette.text.disabled
    }));
const $8b3294d04d14a0d3$var$PickersCalendarWeekNumber = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    name: 'MuiDayCalendar',
    slot: 'WeekNumber'
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, theme.typography.caption, {
        width: (0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0),
        height: (0, $e7cd373dd46c88ee$export$3f0060ce4cc8f4d0),
        padding: 0,
        margin: `0 ${(0, $e7cd373dd46c88ee$export$dde58b009b497666)}px`,
        color: (theme.vars || theme).palette.text.disabled,
        fontSize: '0.75rem',
        alignItems: 'center',
        justifyContent: 'center',
        display: 'inline-flex'
    }));
const $8b3294d04d14a0d3$var$PickersCalendarLoadingContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'LoadingContainer'
})({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: $8b3294d04d14a0d3$var$weeksContainerHeight
});
const $8b3294d04d14a0d3$var$PickersCalendarSlideTransition = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $ef9c59b47aaa2788$export$e868fcc7557d3a06), {
    name: 'MuiDayCalendar',
    slot: 'SlideTransition'
})({
    minHeight: $8b3294d04d14a0d3$var$weeksContainerHeight
});
const $8b3294d04d14a0d3$var$PickersCalendarWeekContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'MonthContainer'
})({
    overflow: 'hidden'
});
const $8b3294d04d14a0d3$var$PickersCalendarWeek = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDayCalendar',
    slot: 'WeekContainer'
})({
    margin: `${(0, $e7cd373dd46c88ee$export$dde58b009b497666)}px 0`,
    display: 'flex',
    justifyContent: 'center'
});
function $8b3294d04d14a0d3$var$WrappedDay(_ref) {
    let { parentProps: parentProps, day: day, focusedDay: focusedDay, selectedDays: selectedDays, isDateDisabled: isDateDisabled, currentMonthNumber: currentMonthNumber, isViewFocused: isViewFocused } = _ref, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $8b3294d04d14a0d3$var$_excluded);
    const { disabled: disabled, disableHighlightToday: disableHighlightToday, isMonthSwitchingAnimating: isMonthSwitchingAnimating, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, slots: slots, slotProps: slotProps, timezone: timezone } = parentProps;
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const isFocusableDay = focusedDay != null && adapter.isSameDay(day, focusedDay);
    const isFocusedDay = isViewFocused && isFocusableDay;
    const isSelected = selectedDays.some((selectedDay)=>adapter.isSameDay(selectedDay, day));
    const isToday = adapter.isSameDay(day, now);
    const isDisabled = $acw62.useMemo(()=>disabled || isDateDisabled(day), [
        disabled,
        isDateDisabled,
        day
    ]);
    const isOutsideCurrentMonth = $acw62.useMemo(()=>adapter.getMonth(day) !== currentMonthNumber, [
        adapter,
        day,
        currentMonthNumber
    ]);
    const ownerState = (0, $0611e97a4959ebfc$export$250873c81c19b1fa)({
        day: day,
        selected: isSelected,
        disabled: isDisabled,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        disableMargin: undefined,
        disableHighlightToday: // This prop can only be defined using slotProps.day so the ownerState for useSlotProps cannot have its value.
        disableHighlightToday,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth
    });
    const Day = slots?.day ?? (0, $debdf8ecd16a24d2$export$d7378e6e864346fa);
    // We don't want to pass to ownerState down, to avoid re-rendering all the day whenever a prop changes.
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Day,
        externalSlotProps: slotProps?.day,
        additionalProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            disableHighlightToday: disableHighlightToday,
            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
            role: 'gridcell',
            isAnimating: isMonthSwitchingAnimating,
            // it is used in date range dragging logic by accessing `dataset.timestamp`
            'data-timestamp': adapter.toJsDate(day).valueOf()
        }, other),
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            day: day,
            isDayDisabled: isDisabled,
            isDaySelected: isSelected
        })
    }), dayProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $8b3294d04d14a0d3$var$_excluded2);
    const isFirstVisibleCell = $acw62.useMemo(()=>{
        const startOfMonth = adapter.startOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, startOfMonth);
        return adapter.isSameDay(day, adapter.startOfWeek(startOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    const isLastVisibleCell = $acw62.useMemo(()=>{
        const endOfMonth = adapter.endOfMonth(adapter.setMonth(day, currentMonthNumber));
        if (!showDaysOutsideCurrentMonth) return adapter.isSameDay(day, endOfMonth);
        return adapter.isSameDay(day, adapter.endOfWeek(endOfMonth));
    }, [
        currentMonthNumber,
        day,
        showDaysOutsideCurrentMonth,
        adapter
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Day, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, dayProps, {
        day: day,
        disabled: isDisabled,
        autoFocus: !isOutsideCurrentMonth && isFocusedDay,
        today: isToday,
        outsideCurrentMonth: isOutsideCurrentMonth,
        isFirstVisibleCell: isFirstVisibleCell,
        isLastVisibleCell: isLastVisibleCell,
        selected: isSelected,
        tabIndex: isFocusableDay ? 0 : -1,
        "aria-selected": isSelected,
        "aria-current": isToday ? 'date' : undefined
    }));
}
function $8b3294d04d14a0d3$export$8fb56b32a5df6314(inProps) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDayCalendar'
    });
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { onFocusedDayChange: onFocusedDayChange, className: className, classes: classesProp, currentMonth: currentMonth, selectedDays: selectedDays, focusedDay: focusedDay, loading: loading, onSelectedDaysChange: onSelectedDaysChange, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd, readOnly: readOnly, reduceAnimations: reduceAnimations, renderLoading: renderLoading = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
            children: "..."
        }), slideDirection: slideDirection, TransitionProps: TransitionProps, disablePast: disablePast, disableFuture: disableFuture, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, dayOfWeekFormatter: dayOfWeekFormatter = (date)=>adapter.format(date, 'weekdayShort').charAt(0).toUpperCase(), hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, gridLabelId: gridLabelId, displayWeekNumber: displayWeekNumber, fixedWeekNumber: fixedWeekNumber, timezone: timezone } = props;
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const classes = $8b3294d04d14a0d3$var$useUtilityClasses(classesProp);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const isDateDisabled = (0, $80335e50844415f8$export$7d1a419f34475191)({
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        minDate: minDate,
        maxDate: maxDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone
    });
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const handleDaySelect = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((day)=>{
        if (readOnly) return;
        onSelectedDaysChange(day);
    });
    const focusDay = (day)=>{
        if (!isDateDisabled(day)) {
            onFocusedDayChange(day);
            onFocusedViewChange?.(true);
        }
    };
    const handleKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, day)=>{
        switch(event.key){
            case 'ArrowUp':
                focusDay(adapter.addDays(day, -7));
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusDay(adapter.addDays(day, 7));
                event.preventDefault();
                break;
            case 'ArrowLeft':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? 1 : -1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? 1 : -1);
                    const closestDayToFocus = (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? newFocusedDayDefault : adapter.startOfMonth(nextAvailableMonth),
                        maxDate: isRtl ? adapter.endOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'ArrowRight':
                {
                    const newFocusedDayDefault = adapter.addDays(day, isRtl ? -1 : 1);
                    const nextAvailableMonth = adapter.addMonths(day, isRtl ? -1 : 1);
                    const closestDayToFocus = (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
                        adapter: adapter,
                        date: newFocusedDayDefault,
                        minDate: isRtl ? adapter.startOfMonth(nextAvailableMonth) : newFocusedDayDefault,
                        maxDate: isRtl ? newFocusedDayDefault : adapter.endOfMonth(nextAvailableMonth),
                        isDateDisabled: isDateDisabled,
                        timezone: timezone
                    });
                    focusDay(closestDayToFocus || newFocusedDayDefault);
                    event.preventDefault();
                    break;
                }
            case 'Home':
                focusDay(adapter.startOfWeek(day));
                event.preventDefault();
                break;
            case 'End':
                focusDay(adapter.endOfWeek(day));
                event.preventDefault();
                break;
            case 'PageUp':
                focusDay(adapter.addMonths(day, 1));
                event.preventDefault();
                break;
            case 'PageDown':
                focusDay(adapter.addMonths(day, -1));
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, day)=>focusDay(day));
    const handleBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, day)=>{
        if (focusedDay != null && adapter.isSameDay(focusedDay, day)) onFocusedViewChange?.(false);
    });
    const currentMonthNumber = adapter.getMonth(currentMonth);
    const currentYearNumber = adapter.getYear(currentMonth);
    const validSelectedDays = $acw62.useMemo(()=>selectedDays.filter((day)=>!!day).map((day)=>adapter.startOfDay(day)), [
        adapter,
        selectedDays
    ]);
    // need a new ref whenever the `key` of the transition changes: https://reactcommunity.org/react-transition-group/transition/#Transition-prop-nodeRef.
    const transitionKey = `${currentYearNumber}-${currentMonthNumber}`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const slideNodeRef = $acw62.useMemo(()=>/*#__PURE__*/ $acw62.createRef(), [
        transitionKey
    ]);
    const weeksToDisplay = $acw62.useMemo(()=>{
        const toDisplay = adapter.getWeekArray(currentMonth);
        let nextMonth = adapter.addMonths(currentMonth, 1);
        while(fixedWeekNumber && toDisplay.length < fixedWeekNumber){
            const additionalWeeks = adapter.getWeekArray(nextMonth);
            const hasCommonWeek = adapter.isSameDay(toDisplay[toDisplay.length - 1][0], additionalWeeks[0][0]);
            additionalWeeks.slice(hasCommonWeek ? 1 : 0).forEach((week)=>{
                if (toDisplay.length < fixedWeekNumber) toDisplay.push(week);
            });
            nextMonth = adapter.addMonths(nextMonth, 1);
        }
        return toDisplay;
    }, [
        currentMonth,
        fixedWeekNumber,
        adapter
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8b3294d04d14a0d3$var$PickersCalendarDayRoot, {
        role: "grid",
        "aria-labelledby": gridLabelId,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8b3294d04d14a0d3$var$PickersCalendarDayHeader, {
                role: "row",
                className: classes.header,
                children: [
                    displayWeekNumber && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b3294d04d14a0d3$var$PickersCalendarWeekNumberLabel, {
                        variant: "caption",
                        role: "columnheader",
                        "aria-label": translations.calendarWeekNumberHeaderLabel,
                        className: classes.weekNumberLabel,
                        children: translations.calendarWeekNumberHeaderText
                    }),
                    (0, $b8d019f986eaf72a$export$24c38139da66592d)(adapter, now).map((weekday, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b3294d04d14a0d3$var$PickersCalendarWeekDayLabel, {
                            variant: "caption",
                            role: "columnheader",
                            "aria-label": adapter.format(weekday, 'weekday'),
                            className: classes.weekDayLabel,
                            children: dayOfWeekFormatter(weekday)
                        }, i.toString()))
                ]
            }),
            loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b3294d04d14a0d3$var$PickersCalendarLoadingContainer, {
                className: classes.loadingContainer,
                children: renderLoading()
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b3294d04d14a0d3$var$PickersCalendarSlideTransition, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                transKey: transitionKey,
                onExited: onMonthSwitchingAnimationEnd,
                reduceAnimations: reduceAnimations,
                slideDirection: slideDirection,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, classes.slideTransition)
            }, TransitionProps, {
                nodeRef: slideNodeRef,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b3294d04d14a0d3$var$PickersCalendarWeekContainer, {
                    ref: slideNodeRef,
                    role: "rowgroup",
                    className: classes.monthContainer,
                    children: weeksToDisplay.map((week, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($8b3294d04d14a0d3$var$PickersCalendarWeek, {
                            role: "row",
                            className: classes.weekContainer,
                            "aria-rowindex": index + 1,
                            children: [
                                displayWeekNumber && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b3294d04d14a0d3$var$PickersCalendarWeekNumber, {
                                    className: classes.weekNumber,
                                    role: "rowheader",
                                    "aria-label": translations.calendarWeekNumberAriaLabelText(adapter.getWeekNumber(week[0])),
                                    children: translations.calendarWeekNumberText(adapter.getWeekNumber(week[0]))
                                }),
                                week.map((day, dayIndex)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8b3294d04d14a0d3$var$WrappedDay, {
                                        parentProps: props,
                                        day: day,
                                        selectedDays: validSelectedDays,
                                        isViewFocused: hasFocus,
                                        focusedDay: focusedDay,
                                        onKeyDown: handleKeyDown,
                                        onFocus: handleFocus,
                                        onBlur: handleBlur,
                                        onDaySelect: handleDaySelect,
                                        isDateDisabled: isDateDisabled,
                                        currentMonthNumber: currentMonthNumber,
                                        "aria-colindex": dayIndex + 1
                                    }, day.toString()))
                            ]
                        }, `week-${week[0]}`))
                })
            }))
        ]
    });
}





var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");







function $382e5932c87afd31$export$da0c97315339ebd9(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiMonthCalendar', slot);
}
const $382e5932c87afd31$export$edf77d5566c7007c = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiMonthCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);



const $32226c2fe1be6a89$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $32226c2fe1be6a89$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isMonthDisabled && 'disabled',
            ownerState.isMonthSelected && 'selected'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $382e5932c87afd31$export$da0c97315339ebd9), classes);
};
const $32226c2fe1be6a89$var$DefaultMonthButton = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('button', {
    name: 'MuiMonthCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, $382e5932c87afd31$export$edf77d5566c7007c).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $382e5932c87afd31$export$edf77d5566c7007c).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $382e5932c87afd31$export$edf77d5566c7007c).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $382e5932c87afd31$export$edf77d5566c7007c).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $32226c2fe1be6a89$export$ca92875d3d780f06 = /*#__PURE__*/ $acw62.memo(function MonthCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $32226c2fe1be6a89$var$_excluded);
    const ref = $acw62.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isMonthDisabled: disabled,
        isMonthSelected: selected
    });
    const classes = $32226c2fe1be6a89$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const MonthButton = slots?.monthButton ?? $32226c2fe1be6a89$var$DefaultMonthButton;
    const monthButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: MonthButton,
        externalSlotProps: slotProps?.monthButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(MonthButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, monthButtonProps));
});













'use client';
const $bcb80215d92225f5$var$_excluded = [
    "autoFocus",
    "className",
    "currentMonth",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "shouldDisableMonth",
    "readOnly",
    "disableHighlightToday",
    "onMonthFocus",
    "hasFocus",
    "onFocusedViewChange",
    "monthsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $bcb80215d92225f5$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $382e5932c87afd31$export$da0c97315339ebd9), classes);
};
function $bcb80215d92225f5$export$5b6e066572408095(props, name) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $53fd543f3597ad7b$export$82ecc8c5f467152f)(themeProps);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        monthsPerRow: themeProps.monthsPerRow ?? 3
    });
}
const $bcb80215d92225f5$var$isSameMonth = (monthA, monthB, yearA, yearB, adapter)=>Boolean(monthA === monthB && yearB && adapter.isSameYear(yearA, yearB));
const $bcb80215d92225f5$var$MonthCalendarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiMonthCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $9a7e913a82f46e5c$export$3ba67b570e26eea0)(prop) && prop !== 'monthsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 16,
    padding: '8px 0',
    width: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    variants: [
        {
            props: {
                monthsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                monthsPerRow: 4
            },
            style: {
                columnGap: 0
            }
        }
    ]
});
const $bcb80215d92225f5$export$d7a7c85c0f5afc4a = /*#__PURE__*/ $acw62.forwardRef(function MonthCalendar(inProps, ref) {
    const props = $bcb80215d92225f5$export$5b6e066572408095(inProps, 'MuiMonthCalendar');
    const { autoFocus: autoFocus, className: className, currentMonth: currentMonth, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, shouldDisableMonth: shouldDisableMonth, readOnly: readOnly, onMonthFocus: onMonthFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, monthsPerRow: monthsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $bcb80215d92225f5$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'MonthCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const referenceDate = $acw62.useMemo(()=>(0, $235c2ad72f19522e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac).month
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $bcb80215d92225f5$var$useUtilityClasses(classesProp);
    const todayMonth = $acw62.useMemo(()=>adapter.getMonth(now), [
        adapter,
        now
    ]);
    const selectedMonth = $acw62.useMemo(()=>{
        if (value != null) return adapter.getMonth(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedMonth, setFocusedMonth] = $acw62.useState(()=>selectedMonth || adapter.getMonth(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'MonthCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isMonthDisabled = $acw62.useCallback((dateToValidate)=>{
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        const monthToValidate = adapter.startOfMonth(dateToValidate);
        if (adapter.isBefore(monthToValidate, firstEnabledMonth)) return true;
        if (adapter.isAfter(monthToValidate, lastEnabledMonth)) return true;
        if (!shouldDisableMonth) return false;
        return shouldDisableMonth(monthToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableMonth,
        adapter
    ]);
    const handleMonthSelection = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, month)=>{
        if (readOnly) return;
        const currentValue = value && currentMonth && !adapter.isSameYear(value, currentMonth) ? adapter.setYear(value, adapter.getYear(currentMonth)) : value;
        const newDate = adapter.setMonth(currentValue ?? referenceDate, month);
        handleValueChange(newDate);
    });
    const focusMonth = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((month)=>{
        if (!isMonthDisabled(adapter.setMonth(value ?? currentMonth ?? referenceDate, month))) {
            setFocusedMonth(month);
            changeHasFocus(true);
            if (onMonthFocus) onMonthFocus(month);
        }
    });
    $acw62.useEffect(()=>{
        setFocusedMonth((prevFocusedMonth)=>selectedMonth !== null && prevFocusedMonth !== selectedMonth ? selectedMonth : prevFocusedMonth);
    }, [
        selectedMonth
    ]);
    const handleKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, month)=>{
        const monthsInYear = 12;
        const monthsInRow = 3;
        switch(event.key){
            case 'ArrowUp':
                focusMonth((monthsInYear + month - monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusMonth((monthsInYear + month + monthsInRow) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusMonth((monthsInYear + month + (isRtl ? 1 : -1)) % monthsInYear);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusMonth((monthsInYear + month + (isRtl ? -1 : 1)) % monthsInYear);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleMonthFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, month)=>{
        focusMonth(month);
    });
    const handleMonthBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, month)=>{
        if (focusedMonth === month) changeHasFocus(false);
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bcb80215d92225f5$var$MonthCalendarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        monthsPerRow: monthsPerRow
    }, other, {
        children: (0, $b8d019f986eaf72a$export$62591b96a734eacd)(adapter, currentMonth ?? value ?? referenceDate).map((month)=>{
            const monthNumber = adapter.getMonth(month);
            const monthText = adapter.format(month, 'monthShort');
            const monthLabel = adapter.format(month, 'month');
            const isSelected = $bcb80215d92225f5$var$isSameMonth(monthNumber, selectedMonth, month, value, adapter);
            const isDisabled = disabled || isMonthDisabled(month);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32226c2fe1be6a89$export$ca92875d3d780f06), {
                selected: isSelected,
                value: monthNumber,
                onClick: handleMonthSelection,
                onKeyDown: handleKeyDown,
                autoFocus: internalHasFocus && monthNumber === focusedMonth,
                disabled: isDisabled,
                tabIndex: monthNumber === focusedMonth && !isDisabled ? 0 : -1,
                onFocus: handleMonthFocus,
                onBlur: handleMonthBlur,
                "aria-current": $bcb80215d92225f5$var$isSameMonth(monthNumber, todayMonth, month, now, adapter) ? 'date' : undefined,
                "aria-label": monthLabel,
                slots: slots,
                slotProps: slotProps,
                classes: classesProp,
                children: monthText
            }, monthText);
        })
    }));
});





var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");







function $8113954354676ea0$export$4477acc520094dec(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiYearCalendar', slot);
}
const $8113954354676ea0$export$e42d427cd9fe5fd7 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiYearCalendar', [
    'root',
    'button',
    'disabled',
    'selected'
]);



const $daf9ac3ae8412985$var$_excluded = [
    "autoFocus",
    "classes",
    "disabled",
    "selected",
    "value",
    "onClick",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "slots",
    "slotProps"
];
const $daf9ac3ae8412985$var$useUtilityClasses = (classes, ownerState)=>{
    const slots = {
        button: [
            'button',
            ownerState.isYearDisabled && 'disabled',
            ownerState.isYearSelected && 'selected'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $8113954354676ea0$export$4477acc520094dec), classes);
};
const $daf9ac3ae8412985$var$DefaultYearButton = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('button', {
    name: 'MuiYearCalendar',
    slot: 'Button',
    overridesResolver: (_, styles)=>[
            styles.button,
            {
                [`&.${(0, $8113954354676ea0$export$e42d427cd9fe5fd7).disabled}`]: styles.disabled
            },
            {
                [`&.${(0, $8113954354676ea0$export$e42d427cd9fe5fd7).selected}`]: styles.selected
            }
        ]
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        color: 'unset',
        backgroundColor: 'transparent',
        border: 0,
        outline: 0
    }, theme.typography.subtitle1, {
        height: 36,
        width: 72,
        borderRadius: 18,
        cursor: 'pointer',
        '&:focus': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.focusOpacity})` : (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.focusOpacity)
        },
        '&:hover': {
            backgroundColor: theme.vars ? `rgba(${theme.vars.palette.action.activeChannel} / ${theme.vars.palette.action.hoverOpacity})` : (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.action.active, theme.palette.action.hoverOpacity)
        },
        '&:disabled': {
            cursor: 'auto',
            pointerEvents: 'none'
        },
        [`&.${(0, $8113954354676ea0$export$e42d427cd9fe5fd7).disabled}`]: {
            color: (theme.vars || theme).palette.text.secondary
        },
        [`&.${(0, $8113954354676ea0$export$e42d427cd9fe5fd7).selected}`]: {
            color: (theme.vars || theme).palette.primary.contrastText,
            backgroundColor: (theme.vars || theme).palette.primary.main,
            '&:focus, &:hover': {
                backgroundColor: (theme.vars || theme).palette.primary.dark
            }
        }
    }));
const $daf9ac3ae8412985$export$cc9e2b0aa124cbe6 = /*#__PURE__*/ $acw62.memo(function YearCalendarButton(props) {
    const { autoFocus: autoFocus, classes: classesProp, disabled: disabled, selected: selected, value: value, onClick: onClick, onKeyDown: onKeyDown, onFocus: onFocus, onBlur: onBlur, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $daf9ac3ae8412985$var$_excluded);
    const ref = $acw62.useRef(null);
    const { ownerState: pickerOwnerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerOwnerState, {
        isYearDisabled: disabled,
        isYearSelected: selected
    });
    const classes = $daf9ac3ae8412985$var$useUtilityClasses(classesProp, ownerState);
    // We can't forward the `autoFocus` to the button because it is a native button, not a MUI Button
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (autoFocus) // `ref.current` being `null` would be a bug in MUI.
        ref.current?.focus();
    }, [
        autoFocus
    ]);
    const YearButton = slots?.yearButton ?? $daf9ac3ae8412985$var$DefaultYearButton;
    const yearButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: YearButton,
        externalSlotProps: slotProps?.yearButton,
        externalForwardedProps: other,
        additionalProps: {
            disabled: disabled,
            ref: ref,
            type: 'button',
            role: 'radio',
            'aria-checked': selected,
            onClick: (event)=>onClick(event, value),
            onKeyDown: (event)=>onKeyDown(event, value),
            onFocus: (event)=>onFocus(event, value),
            onBlur: (event)=>onBlur(event, value)
        },
        ownerState: ownerState,
        className: classes.button
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(YearButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, yearButtonProps));
});












'use client';
const $f8af41512995675d$var$_excluded = [
    "autoFocus",
    "className",
    "classes",
    "value",
    "defaultValue",
    "referenceDate",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onChange",
    "readOnly",
    "shouldDisableYear",
    "disableHighlightToday",
    "onYearFocus",
    "hasFocus",
    "onFocusedViewChange",
    "yearsOrder",
    "yearsPerRow",
    "timezone",
    "gridLabelId",
    "slots",
    "slotProps"
];
const $f8af41512995675d$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $8113954354676ea0$export$4477acc520094dec), classes);
};
function $f8af41512995675d$var$useYearCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const validationProps = (0, $53fd543f3597ad7b$export$82ecc8c5f467152f)(themeProps);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        yearsPerRow: themeProps.yearsPerRow ?? 3,
        yearsOrder: themeProps.yearsOrder ?? 'asc'
    });
}
const $f8af41512995675d$var$YearCalendarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiYearCalendar',
    slot: 'Root',
    shouldForwardProp: (prop)=>(0, $9a7e913a82f46e5c$export$3ba67b570e26eea0)(prop) && prop !== 'yearsPerRow'
})({
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
    rowGap: 12,
    padding: '6px 0',
    overflowY: 'auto',
    height: '100%',
    width: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3),
    maxHeight: (0, $e7cd373dd46c88ee$export$73724491020e90c7),
    // avoid padding increasing width over defined
    boxSizing: 'border-box',
    position: 'relative',
    variants: [
        {
            props: {
                yearsPerRow: 3
            },
            style: {
                columnGap: 24
            }
        },
        {
            props: {
                yearsPerRow: 4
            },
            style: {
                columnGap: 0,
                padding: '0 2px'
            }
        }
    ]
});
const $f8af41512995675d$var$YearCalendarButtonFiller = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiYearCalendar',
    slot: 'ButtonFiller'
})({
    height: 36,
    width: 72
});
const $f8af41512995675d$export$657f9200591b2b71 = /*#__PURE__*/ $acw62.forwardRef(function YearCalendar(inProps, ref) {
    const props = $f8af41512995675d$var$useYearCalendarDefaultizedProps(inProps, 'MuiYearCalendar');
    const { autoFocus: autoFocus, className: className, classes: classesProp, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onChange: onChange, readOnly: readOnly, shouldDisableYear: shouldDisableYear, onYearFocus: onYearFocus, hasFocus: hasFocus, onFocusedViewChange: onFocusedViewChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, timezone: timezoneProp, gridLabelId: gridLabelId, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $f8af41512995675d$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'YearCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const now = (0, $06e5a97a469e375c$export$3a404aece3dff2fa)(timezone);
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const referenceDate = $acw62.useMemo(()=>(0, $235c2ad72f19522e$export$2764b246aa3b75ba).getInitialReferenceValue({
            value: value,
            adapter: adapter,
            props: props,
            timezone: timezone,
            referenceDate: referenceDateProp,
            granularity: (0, $66a7cb510b2c76f4$export$8f74e8f4ed8ae0ac).year
        }), [] // eslint-disable-line react-hooks/exhaustive-deps
    );
    const classes = $f8af41512995675d$var$useUtilityClasses(classesProp);
    const todayYear = $acw62.useMemo(()=>adapter.getYear(now), [
        adapter,
        now
    ]);
    const selectedYear = $acw62.useMemo(()=>{
        if (value != null) return adapter.getYear(value);
        return null;
    }, [
        value,
        adapter
    ]);
    const [focusedYear, setFocusedYear] = $acw62.useState(()=>selectedYear || adapter.getYear(referenceDate));
    const [internalHasFocus, setInternalHasFocus] = (0, $77aad105771eb889$export$2e2bcd8739ae039)({
        name: 'YearCalendar',
        state: 'hasFocus',
        controlled: hasFocus,
        default: autoFocus ?? false
    });
    const changeHasFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newHasFocus)=>{
        setInternalHasFocus(newHasFocus);
        if (onFocusedViewChange) onFocusedViewChange(newHasFocus);
    });
    const isYearDisabled = $acw62.useCallback((dateToValidate)=>{
        if (disablePast && adapter.isBeforeYear(dateToValidate, now)) return true;
        if (disableFuture && adapter.isAfterYear(dateToValidate, now)) return true;
        if (minDate && adapter.isBeforeYear(dateToValidate, minDate)) return true;
        if (maxDate && adapter.isAfterYear(dateToValidate, maxDate)) return true;
        if (!shouldDisableYear) return false;
        const yearToValidate = adapter.startOfYear(dateToValidate);
        return shouldDisableYear(yearToValidate);
    }, [
        disableFuture,
        disablePast,
        maxDate,
        minDate,
        now,
        shouldDisableYear,
        adapter
    ]);
    const handleYearSelection = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, year)=>{
        if (readOnly) return;
        const newDate = adapter.setYear(value ?? referenceDate, year);
        handleValueChange(newDate);
    });
    const focusYear = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((year)=>{
        if (!isYearDisabled(adapter.setYear(value ?? referenceDate, year))) {
            setFocusedYear(year);
            changeHasFocus(true);
            onYearFocus?.(year);
        }
    });
    $acw62.useEffect(()=>{
        setFocusedYear((prevFocusedYear)=>selectedYear !== null && prevFocusedYear !== selectedYear ? selectedYear : prevFocusedYear);
    }, [
        selectedYear
    ]);
    const verticalDirection = yearsOrder !== 'desc' ? yearsPerRow * 1 : yearsPerRow * -1;
    const horizontalDirection = isRtl && yearsOrder === 'asc' || !isRtl && yearsOrder === 'desc' ? -1 : 1;
    const handleKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, year)=>{
        switch(event.key){
            case 'ArrowUp':
                focusYear(year - verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowDown':
                focusYear(year + verticalDirection);
                event.preventDefault();
                break;
            case 'ArrowLeft':
                focusYear(year - horizontalDirection);
                event.preventDefault();
                break;
            case 'ArrowRight':
                focusYear(year + horizontalDirection);
                event.preventDefault();
                break;
            default:
                break;
        }
    });
    const handleYearFocus = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, year)=>{
        focusYear(year);
    });
    const handleYearBlur = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event, year)=>{
        if (focusedYear === year) changeHasFocus(false);
    });
    const scrollerRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, scrollerRef);
    $acw62.useEffect(()=>{
        if (autoFocus || scrollerRef.current === null) return;
        const tabbableButton = scrollerRef.current.querySelector('[tabindex="0"]');
        if (!tabbableButton) return;
        // Taken from useScroll in x-data-grid, but vertically centered
        const offsetHeight = tabbableButton.offsetHeight;
        const offsetTop = tabbableButton.offsetTop;
        const clientHeight = scrollerRef.current.clientHeight;
        const scrollTop = scrollerRef.current.scrollTop;
        const elementBottom = offsetTop + offsetHeight;
        if (offsetHeight > clientHeight || offsetTop < scrollTop) // Button already visible
        return;
        scrollerRef.current.scrollTop = elementBottom - clientHeight / 2 - offsetHeight / 2;
    }, [
        autoFocus
    ]);
    const yearRange = adapter.getYearRange([
        minDate,
        maxDate
    ]);
    if (yearsOrder === 'desc') yearRange.reverse();
    let fillerAmount = yearsPerRow - yearRange.length % yearsPerRow;
    if (fillerAmount === yearsPerRow) fillerAmount = 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($f8af41512995675d$var$YearCalendarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: handleRef,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        role: "radiogroup",
        "aria-labelledby": gridLabelId,
        yearsPerRow: yearsPerRow
    }, other, {
        children: [
            yearRange.map((year)=>{
                const yearNumber = adapter.getYear(year);
                const isSelected = yearNumber === selectedYear;
                const isDisabled = disabled || isYearDisabled(year);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $daf9ac3ae8412985$export$cc9e2b0aa124cbe6), {
                    selected: isSelected,
                    value: yearNumber,
                    onClick: handleYearSelection,
                    onKeyDown: handleKeyDown,
                    autoFocus: internalHasFocus && yearNumber === focusedYear,
                    disabled: isDisabled,
                    tabIndex: yearNumber === focusedYear && !isDisabled ? 0 : -1,
                    onFocus: handleYearFocus,
                    onBlur: handleYearBlur,
                    "aria-current": todayYear === yearNumber ? 'date' : undefined,
                    slots: slots,
                    slotProps: slotProps,
                    classes: classesProp,
                    children: adapter.format(year, 'year')
                }, adapter.format(year, 'year'));
            }),
            Array.from({
                length: fillerAmount
            }, (_, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f8af41512995675d$var$YearCalendarButtonFiller, {}, index))
        ]
    }));
});






var $acw62 = parcelRequire("acw62");













var $acw62 = parcelRequire("acw62");










function $6a19e334ff9f8c78$export$cef978c25740de90(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', slot);
}
const $6a19e334ff9f8c78$export$f8819209558cd362 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersArrowSwitcher', [
    'root',
    'spacer',
    'button',
    'previousIconButton',
    'nextIconButton',
    'leftArrowIcon',
    'rightArrowIcon'
]);




const $e6440e639c149fbf$var$_excluded = [
    "children",
    "className",
    "slots",
    "slotProps",
    "isNextDisabled",
    "isNextHidden",
    "onGoToNext",
    "nextLabel",
    "isPreviousDisabled",
    "isPreviousHidden",
    "onGoToPrevious",
    "previousLabel",
    "labelId",
    "classes"
], $e6440e639c149fbf$var$_excluded2 = [
    "ownerState"
], $e6440e639c149fbf$var$_excluded3 = [
    "ownerState"
];
const $e6440e639c149fbf$var$PickersArrowSwitcherRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Root'
})({
    display: 'flex'
});
const $e6440e639c149fbf$var$PickersArrowSwitcherSpacer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Spacer'
})(({ theme: theme })=>({
        width: theme.spacing(3)
    }));
const $e6440e639c149fbf$var$PickersArrowSwitcherButton = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
    name: 'MuiPickersArrowSwitcher',
    slot: 'Button'
})({
    variants: [
        {
            props: {
                isButtonHidden: true
            },
            style: {
                visibility: 'hidden'
            }
        }
    ]
});
const $e6440e639c149fbf$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        spacer: [
            'spacer'
        ],
        button: [
            'button'
        ],
        previousIconButton: [
            'previousIconButton'
        ],
        nextIconButton: [
            'nextIconButton'
        ],
        leftArrowIcon: [
            'leftArrowIcon'
        ],
        rightArrowIcon: [
            'rightArrowIcon'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $6a19e334ff9f8c78$export$cef978c25740de90), classes);
};
const $e6440e639c149fbf$export$597b7cbdb7b2a24c = /*#__PURE__*/ $acw62.forwardRef(function PickersArrowSwitcher(inProps, ref) {
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersArrowSwitcher'
    });
    const { children: children, className: className, slots: slots, slotProps: slotProps, isNextDisabled: isNextDisabled, isNextHidden: isNextHidden, onGoToNext: onGoToNext, nextLabel: nextLabel, isPreviousDisabled: isPreviousDisabled, isPreviousHidden: isPreviousHidden, onGoToPrevious: onGoToPrevious, previousLabel: previousLabel, labelId: labelId, classes: classesProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e6440e639c149fbf$var$_excluded);
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const classes = $e6440e639c149fbf$var$useUtilityClasses(classesProp);
    const nextProps = {
        isDisabled: isNextDisabled,
        isHidden: isNextHidden,
        goTo: onGoToNext,
        label: nextLabel
    };
    const previousProps = {
        isDisabled: isPreviousDisabled,
        isHidden: isPreviousHidden,
        goTo: onGoToPrevious,
        label: previousLabel
    };
    const PreviousIconButton = slots?.previousIconButton ?? $e6440e639c149fbf$var$PickersArrowSwitcherButton;
    const previousIconButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: PreviousIconButton,
        externalSlotProps: slotProps?.previousIconButton,
        additionalProps: {
            size: 'medium',
            title: previousProps.label,
            'aria-label': previousProps.label,
            disabled: previousProps.isDisabled,
            edge: 'end',
            onClick: previousProps.goTo
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            isButtonHidden: previousProps.isHidden ?? false
        }),
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.button, classes.previousIconButton)
    });
    const NextIconButton = slots?.nextIconButton ?? $e6440e639c149fbf$var$PickersArrowSwitcherButton;
    const nextIconButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: NextIconButton,
        externalSlotProps: slotProps?.nextIconButton,
        additionalProps: {
            size: 'medium',
            title: nextProps.label,
            'aria-label': nextProps.label,
            disabled: nextProps.isDisabled,
            edge: 'start',
            onClick: nextProps.goTo
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            isButtonHidden: nextProps.isHidden ?? false
        }),
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.button, classes.nextIconButton)
    });
    const LeftArrowIcon = slots?.leftArrowIcon ?? (0, $ef8448afaa732d42$export$8afed21ef5c2afa5);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: LeftArrowIcon,
        externalSlotProps: slotProps?.leftArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.leftArrowIcon
    }), leftArrowIconProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $e6440e639c149fbf$var$_excluded2);
    const RightArrowIcon = slots?.rightArrowIcon ?? (0, $ef8448afaa732d42$export$9ca09caa9c849d9c);
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps2 = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: RightArrowIcon,
        externalSlotProps: slotProps?.rightArrowIcon,
        additionalProps: {
            fontSize: 'inherit'
        },
        ownerState: ownerState,
        className: classes.rightArrowIcon
    }), rightArrowIconProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps2, $e6440e639c149fbf$var$_excluded3);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($e6440e639c149fbf$var$PickersArrowSwitcherRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PreviousIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RightArrowIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rightArrowIconProps)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(LeftArrowIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, leftArrowIconProps))
            })),
            children ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "subtitle1",
                component: "span",
                id: labelId,
                children: children
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e6440e639c149fbf$var$PickersArrowSwitcherSpacer, {
                className: classes.spacer,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NextIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, nextIconButtonProps, {
                children: isRtl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(LeftArrowIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, leftArrowIconProps)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RightArrowIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rightArrowIconProps))
            }))
        ]
    }));
});



var $acw62 = parcelRequire("acw62");


function $8992dd6789b4ad9e$export$923e8cc135843169(month, { disableFuture: disableFuture, maxDate: maxDate, timezone: timezone }) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    return $acw62.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const lastEnabledMonth = adapter.startOfMonth(disableFuture && adapter.isBefore(now, maxDate) ? now : maxDate);
        return !adapter.isAfter(lastEnabledMonth, month);
    }, [
        disableFuture,
        maxDate,
        month,
        adapter,
        timezone
    ]);
}
function $8992dd6789b4ad9e$export$3b46d38ff4932cf7(month, { disablePast: disablePast, minDate: minDate, timezone: timezone }) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    return $acw62.useMemo(()=>{
        const now = adapter.date(undefined, timezone);
        const firstEnabledMonth = adapter.startOfMonth(disablePast && adapter.isAfter(now, minDate) ? now : minDate);
        return !adapter.isBefore(firstEnabledMonth, month);
    }, [
        disablePast,
        minDate,
        month,
        adapter,
        timezone
    ]);
}
function $8992dd6789b4ad9e$export$6aaabc31cb076d17(date, ampm, onChange, selectionState) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const cleanDate = $acw62.useMemo(()=>!adapter.isValid(date) ? null : date, [
        adapter,
        date
    ]);
    const meridiemMode = (0, $d83ac1c1cf9e346e$export$c3352ead7b032236)(cleanDate, adapter);
    const handleMeridiemChange = $acw62.useCallback((mode)=>{
        const timeWithMeridiem = cleanDate == null ? null : (0, $d83ac1c1cf9e346e$export$c368d4ff66779998)(cleanDate, mode, Boolean(ampm), adapter);
        onChange(timeWithMeridiem, selectionState ?? 'partial');
    }, [
        ampm,
        cleanDate,
        onChange,
        selectionState,
        adapter
    ]);
    return {
        meridiemMode: meridiemMode,
        handleMeridiemChange: handleMeridiemChange
    };
}




const $31260ac424c24a7a$export$457ac4d3a1ad92b4 = (slot)=>(0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', slot);
const $31260ac424c24a7a$export$63db7afb9247cb91 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiPickersCalendarHeader', [
    'root',
    'labelContainer',
    'label',
    'switchViewButton',
    'switchViewIcon'
]);




'use client';
const $d89bffda0f64a7a5$var$_excluded = [
    "slots",
    "slotProps",
    "currentMonth",
    "disabled",
    "disableFuture",
    "disablePast",
    "maxDate",
    "minDate",
    "onMonthChange",
    "onViewChange",
    "view",
    "reduceAnimations",
    "views",
    "labelId",
    "className",
    "classes",
    "timezone",
    "format"
], $d89bffda0f64a7a5$var$_excluded2 = [
    "ownerState"
];
const $d89bffda0f64a7a5$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        labelContainer: [
            'labelContainer'
        ],
        label: [
            'label'
        ],
        switchViewButton: [
            'switchViewButton'
        ],
        switchViewIcon: [
            'switchViewIcon'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $31260ac424c24a7a$export$457ac4d3a1ad92b4), classes);
};
const $d89bffda0f64a7a5$var$PickersCalendarHeaderRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Root'
})({
    display: 'flex',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 4,
    paddingLeft: 24,
    paddingRight: 12,
    // prevent jumping in safari
    maxHeight: 40,
    minHeight: 40
});
const $d89bffda0f64a7a5$var$PickersCalendarHeaderLabelContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'LabelContainer'
})(({ theme: theme })=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        display: 'flex',
        overflow: 'hidden',
        alignItems: 'center',
        cursor: 'pointer',
        marginRight: 'auto'
    }, theme.typography.body1, {
        fontWeight: theme.typography.fontWeightMedium
    }));
const $d89bffda0f64a7a5$var$PickersCalendarHeaderLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiPickersCalendarHeader',
    slot: 'Label'
})({
    marginRight: 6
});
const $d89bffda0f64a7a5$var$PickersCalendarHeaderSwitchViewButton = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewButton'
})({
    marginRight: 'auto',
    variants: [
        {
            props: {
                view: 'year'
            },
            style: {
                [`.${(0, $31260ac424c24a7a$export$63db7afb9247cb91).switchViewIcon}`]: {
                    transform: 'rotate(180deg)'
                }
            }
        }
    ]
});
const $d89bffda0f64a7a5$var$PickersCalendarHeaderSwitchViewIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $ef8448afaa732d42$export$ed0fe318cc298673), {
    name: 'MuiPickersCalendarHeader',
    slot: 'SwitchViewIcon'
})(({ theme: theme })=>({
        willChange: 'transform',
        transition: theme.transitions.create('transform'),
        transform: 'rotate(0deg)'
    }));
/**
 * Demos:
 *
 * - [DateCalendar](https://mui.com/x/react-date-pickers/date-calendar/)
 * - [DateRangeCalendar](https://mui.com/x/react-date-pickers/date-range-calendar/)
 * - [Custom slots and subcomponents](https://mui.com/x/react-date-pickers/custom-components/)
 *
 * API:
 *
 * - [PickersCalendarHeader API](https://mui.com/x/api/date-pickers/pickers-calendar-header/)
 */ const $d89bffda0f64a7a5$export$6801ffebb353f473 = /*#__PURE__*/ $acw62.forwardRef(function PickersCalendarHeader(inProps, ref) {
    const translations = (0, $66648da3b075d888$export$a795e6ca852975b9)();
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiPickersCalendarHeader'
    });
    const { slots: slots, slotProps: slotProps, currentMonth: month, disabled: disabled, disableFuture: disableFuture, disablePast: disablePast, maxDate: maxDate, minDate: minDate, onMonthChange: onMonthChange, onViewChange: onViewChange, view: view, reduceAnimations: reduceAnimations, views: views, labelId: labelId, className: className, classes: classesProp, timezone: timezone, format: format = `${adapter.formats.month} ${adapter.formats.year}` } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d89bffda0f64a7a5$var$_excluded);
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const classes = $d89bffda0f64a7a5$var$useUtilityClasses(classesProp);
    const SwitchViewButton = slots?.switchViewButton ?? $d89bffda0f64a7a5$var$PickersCalendarHeaderSwitchViewButton;
    const switchViewButtonProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SwitchViewButton,
        externalSlotProps: slotProps?.switchViewButton,
        additionalProps: {
            size: 'small',
            'aria-label': translations.calendarViewSwitchingButtonAriaLabel(view)
        },
        ownerState: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
            view: view
        }),
        className: classes.switchViewButton
    });
    const SwitchViewIcon = slots?.switchViewIcon ?? $d89bffda0f64a7a5$var$PickersCalendarHeaderSwitchViewIcon;
    // The spread is here to avoid this bug mui/material-ui#34056
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: SwitchViewIcon,
        externalSlotProps: slotProps?.switchViewIcon,
        ownerState: ownerState,
        className: classes.switchViewIcon
    }), switchViewIconProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $d89bffda0f64a7a5$var$_excluded2);
    const selectNextMonth = ()=>onMonthChange(adapter.addMonths(month, 1));
    const selectPreviousMonth = ()=>onMonthChange(adapter.addMonths(month, -1));
    const isNextMonthDisabled = (0, $8992dd6789b4ad9e$export$923e8cc135843169)(month, {
        disableFuture: disableFuture,
        maxDate: maxDate,
        timezone: timezone
    });
    const isPreviousMonthDisabled = (0, $8992dd6789b4ad9e$export$3b46d38ff4932cf7)(month, {
        disablePast: disablePast,
        minDate: minDate,
        timezone: timezone
    });
    const handleToggleView = ()=>{
        if (views.length === 1 || !onViewChange || disabled) return;
        if (views.length === 2) onViewChange(views.find((el)=>el !== view) || views[0]);
        else {
            // switching only between first 2
            const nextIndexToOpen = views.indexOf(view) !== 0 ? 0 : 1;
            onViewChange(views[nextIndexToOpen]);
        }
    };
    // No need to display more information
    if (views.length === 1 && views[0] === 'year') return null;
    const label = adapter.formatByString(month, format);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d89bffda0f64a7a5$var$PickersCalendarHeaderRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d89bffda0f64a7a5$var$PickersCalendarHeaderLabelContainer, {
                role: "presentation",
                onClick: handleToggleView,
                ownerState: ownerState,
                "aria-live": "polite",
                className: classes.labelContainer,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9c2e6cdd3bb22caf$export$5262185daf493fee), {
                        reduceAnimations: reduceAnimations,
                        transKey: label,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d89bffda0f64a7a5$var$PickersCalendarHeaderLabel, {
                            id: labelId,
                            ownerState: ownerState,
                            className: classes.label,
                            children: label
                        })
                    }),
                    views.length > 1 && !disabled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SwitchViewButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, switchViewButtonProps, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SwitchViewIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, switchViewIconProps))
                    }))
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039), {
                in: view === 'day',
                appear: !reduceAnimations,
                enter: !reduceAnimations,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e6440e639c149fbf$export$597b7cbdb7b2a24c), {
                    slots: slots,
                    slotProps: slotProps,
                    onGoToPrevious: selectPreviousMonth,
                    isPreviousDisabled: isPreviousMonthDisabled,
                    previousLabel: translations.previousMonth,
                    onGoToNext: selectNextMonth,
                    isNextDisabled: isNextMonthDisabled,
                    nextLabel: translations.nextMonth
                })
            })
        ]
    }));
});





const $88548032dcbf72cd$export$512b066b8abdfde4 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div')({
    overflow: 'hidden',
    width: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3),
    maxHeight: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7),
    display: 'flex',
    flexDirection: 'column',
    margin: '0 auto'
});





const $5bfbcb5a53a6644f$export$da8c2318897a6672 = (slot)=>(0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDateCalendar', slot);
const $5bfbcb5a53a6644f$export$d0237e2bb9598e8d = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDateCalendar', [
    'root',
    'viewTransitionContainer'
]);









'use client';
const $d3f0ed23ac3123aa$var$_excluded = [
    "autoFocus",
    "onViewChange",
    "value",
    "defaultValue",
    "referenceDate",
    "disableFuture",
    "disablePast",
    "onChange",
    "onYearChange",
    "onMonthChange",
    "reduceAnimations",
    "shouldDisableDate",
    "shouldDisableMonth",
    "shouldDisableYear",
    "view",
    "views",
    "openTo",
    "className",
    "classes",
    "disabled",
    "readOnly",
    "minDate",
    "maxDate",
    "disableHighlightToday",
    "focusedView",
    "onFocusedViewChange",
    "showDaysOutsideCurrentMonth",
    "fixedWeekNumber",
    "dayOfWeekFormatter",
    "slots",
    "slotProps",
    "loading",
    "renderLoading",
    "displayWeekNumber",
    "yearsOrder",
    "yearsPerRow",
    "monthsPerRow",
    "timezone"
];
const $d3f0ed23ac3123aa$var$useUtilityClasses = (classes)=>{
    const slots = {
        root: [
            'root'
        ],
        viewTransitionContainer: [
            'viewTransitionContainer'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $5bfbcb5a53a6644f$export$da8c2318897a6672), classes);
};
function $d3f0ed23ac3123aa$var$useDateCalendarDefaultizedProps(props, name) {
    const themeProps = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: props,
        name: name
    });
    const reduceAnimations = (0, $fb5fb152771bc52e$export$7e40eba507bb97c4)(themeProps.reduceAnimations);
    const validationProps = (0, $53fd543f3597ad7b$export$82ecc8c5f467152f)(themeProps);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themeProps, validationProps, {
        loading: themeProps.loading ?? false,
        openTo: themeProps.openTo ?? 'day',
        views: themeProps.views ?? [
            'year',
            'day'
        ],
        reduceAnimations: reduceAnimations,
        renderLoading: themeProps.renderLoading ?? (()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: "..."
            }))
    });
}
const $d3f0ed23ac3123aa$var$DateCalendarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $88548032dcbf72cd$export$512b066b8abdfde4), {
    name: 'MuiDateCalendar',
    slot: 'Root'
})({
    display: 'flex',
    flexDirection: 'column',
    height: (0, $e7cd373dd46c88ee$export$f2fef360e2df0cb7)
});
const $d3f0ed23ac3123aa$var$DateCalendarViewTransitionContainer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $9c2e6cdd3bb22caf$export$5262185daf493fee), {
    name: 'MuiDateCalendar',
    slot: 'ViewTransitionContainer'
})({});
const $d3f0ed23ac3123aa$export$68078fe5d2bf8909 = /*#__PURE__*/ $acw62.forwardRef(function DateCalendar(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    const { ownerState: ownerState } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const props = $d3f0ed23ac3123aa$var$useDateCalendarDefaultizedProps(inProps, 'MuiDateCalendar');
    const { autoFocus: autoFocus, onViewChange: onViewChange, value: valueProp, defaultValue: defaultValue, referenceDate: referenceDateProp, disableFuture: disableFuture, disablePast: disablePast, onChange: onChange, onMonthChange: onMonthChange, reduceAnimations: reduceAnimations, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, view: inView, views: views, openTo: openTo, className: className, classes: classesProp, disabled: disabled, readOnly: readOnly, minDate: minDate, maxDate: maxDate, disableHighlightToday: disableHighlightToday, focusedView: focusedViewProp, onFocusedViewChange: onFocusedViewChange, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, fixedWeekNumber: fixedWeekNumber, dayOfWeekFormatter: dayOfWeekFormatter, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, displayWeekNumber: displayWeekNumber, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, monthsPerRow: monthsPerRow, timezone: timezoneProp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d3f0ed23ac3123aa$var$_excluded);
    const { value: value, handleValueChange: handleValueChange, timezone: timezone } = (0, $f4770a33870ed562$export$ac06ac6808815c7c)({
        name: 'DateCalendar',
        timezone: timezoneProp,
        value: valueProp,
        defaultValue: defaultValue,
        referenceDate: referenceDateProp,
        onChange: onChange,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba)
    });
    const { view: view, setView: setView, focusedView: focusedView, setFocusedView: setFocusedView, goToNextView: goToNextView, setValueAndGoToNextView: setValueAndGoToNextView } = (0, $30cf9c7f82fc091d$export$9b46cba8f8ccd954)({
        view: inView,
        views: views,
        openTo: openTo,
        onChange: handleValueChange,
        onViewChange: onViewChange,
        autoFocus: autoFocus,
        focusedView: focusedViewProp,
        onFocusedViewChange: onFocusedViewChange
    });
    const { referenceDate: referenceDate, calendarState: calendarState, setVisibleDate: setVisibleDate, isDateDisabled: isDateDisabled, onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd } = (0, $5efae1633883dea7$export$6d095e787d2b5e1f)({
        value: value,
        referenceDate: referenceDateProp,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        disablePast: disablePast,
        disableFuture: disableFuture,
        timezone: timezone,
        getCurrentMonthFromVisibleDate: (visibleDate, prevMonth)=>{
            if (adapter.isSameMonth(visibleDate, prevMonth)) return prevMonth;
            return adapter.startOfMonth(visibleDate);
        }
    });
    // When disabled, limit the view to the selected date
    const minDateWithDisabled = disabled && value || minDate;
    const maxDateWithDisabled = disabled && value || maxDate;
    const gridLabelId = `${id}-grid-label`;
    const hasFocus = focusedView !== null;
    const CalendarHeader = slots?.calendarHeader ?? (0, $d89bffda0f64a7a5$export$6801ffebb353f473);
    const calendarHeaderProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: CalendarHeader,
        externalSlotProps: slotProps?.calendarHeader,
        additionalProps: {
            views: views,
            view: view,
            currentMonth: calendarState.currentMonth,
            onViewChange: setView,
            onMonthChange: (month)=>setVisibleDate({
                    target: month,
                    reason: 'header-navigation'
                }),
            minDate: minDateWithDisabled,
            maxDate: maxDateWithDisabled,
            disabled: disabled,
            disablePast: disablePast,
            disableFuture: disableFuture,
            reduceAnimations: reduceAnimations,
            timezone: timezone,
            labelId: gridLabelId
        },
        ownerState: ownerState
    });
    const handleDateMonthChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newDate)=>{
        const startOfMonth = adapter.startOfMonth(newDate);
        const endOfMonth = adapter.endOfMonth(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfMonth) ? startOfMonth : minDate,
            maxDate: adapter.isAfter(maxDate, endOfMonth) ? endOfMonth : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfMonth,
                reason: 'cell-interaction'
            });
        }
    });
    const handleDateYearChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newDate)=>{
        const startOfYear = adapter.startOfYear(newDate);
        const endOfYear = adapter.endOfYear(newDate);
        const closestEnabledDate = isDateDisabled(newDate) ? (0, $b8d019f986eaf72a$export$ca1f317ae8db2ee8)({
            adapter: adapter,
            date: newDate,
            minDate: adapter.isBefore(minDate, startOfYear) ? startOfYear : minDate,
            maxDate: adapter.isAfter(maxDate, endOfYear) ? endOfYear : maxDate,
            disablePast: disablePast,
            disableFuture: disableFuture,
            isDateDisabled: isDateDisabled,
            timezone: timezone
        }) : newDate;
        if (closestEnabledDate) {
            setValueAndGoToNextView(closestEnabledDate, 'finish');
            setVisibleDate({
                target: closestEnabledDate,
                reason: 'cell-interaction'
            });
        } else {
            goToNextView();
            setVisibleDate({
                target: startOfYear,
                reason: 'cell-interaction'
            });
        }
    });
    const handleSelectedDayChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((day)=>{
        if (day) // If there is a date already selected, then we want to keep its time
        return handleValueChange((0, $b8d019f986eaf72a$export$a98b123b8f29e004)(adapter, day, value ?? referenceDate), 'finish', view);
        return handleValueChange(day, 'finish', view);
    });
    $acw62.useEffect(()=>{
        if (adapter.isValid(value)) setVisibleDate({
            target: value,
            reason: 'controlled-value-change'
        });
    }, [
        value
    ]); // eslint-disable-line
    const classes = $d3f0ed23ac3123aa$var$useUtilityClasses(classesProp);
    const baseDateValidationProps = {
        disablePast: disablePast,
        disableFuture: disableFuture,
        maxDate: maxDate,
        minDate: minDate
    };
    const commonViewProps = {
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        timezone: timezone,
        gridLabelId: gridLabelId,
        slots: slots,
        slotProps: slotProps
    };
    const prevOpenViewRef = $acw62.useRef(view);
    $acw62.useEffect(()=>{
        // If the view change and the focus was on the previous view
        // Then we update the focus.
        if (prevOpenViewRef.current === view) return;
        if (focusedView === prevOpenViewRef.current) setFocusedView(view, true);
        prevOpenViewRef.current = view;
    }, [
        focusedView,
        setFocusedView,
        view
    ]);
    const selectedDays = $acw62.useMemo(()=>[
            value
        ], [
        value
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($d3f0ed23ac3123aa$var$DateCalendarRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(CalendarHeader, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, calendarHeaderProps, {
                slots: slots,
                slotProps: slotProps
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d3f0ed23ac3123aa$var$DateCalendarViewTransitionContainer, {
                reduceAnimations: reduceAnimations,
                className: classes.viewTransitionContainer,
                transKey: view,
                ownerState: ownerState,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    children: [
                        view === 'year' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f8af41512995675d$export$657f9200591b2b71), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            value: value,
                            onChange: handleDateYearChange,
                            shouldDisableYear: shouldDisableYear,
                            hasFocus: hasFocus,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('year', isViewFocused),
                            yearsOrder: yearsOrder,
                            yearsPerRow: yearsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'month' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bcb80215d92225f5$export$d7a7c85c0f5afc4a), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseDateValidationProps, commonViewProps, {
                            currentMonth: calendarState.currentMonth,
                            hasFocus: hasFocus,
                            className: className,
                            value: value,
                            onChange: handleDateMonthChange,
                            shouldDisableMonth: shouldDisableMonth,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('month', isViewFocused),
                            monthsPerRow: monthsPerRow,
                            referenceDate: referenceDate
                        })),
                        view === 'day' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b3294d04d14a0d3$export$8fb56b32a5df6314), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, calendarState, baseDateValidationProps, commonViewProps, {
                            onMonthSwitchingAnimationEnd: onMonthSwitchingAnimationEnd,
                            hasFocus: hasFocus,
                            onFocusedDayChange: (focusedDate)=>setVisibleDate({
                                    target: focusedDate,
                                    reason: 'cell-interaction'
                                }),
                            reduceAnimations: reduceAnimations,
                            selectedDays: selectedDays,
                            onSelectedDaysChange: handleSelectedDayChange,
                            shouldDisableDate: shouldDisableDate,
                            shouldDisableMonth: shouldDisableMonth,
                            shouldDisableYear: shouldDisableYear,
                            onFocusedViewChange: (isViewFocused)=>setFocusedView('day', isViewFocused),
                            showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
                            fixedWeekNumber: fixedWeekNumber,
                            dayOfWeekFormatter: dayOfWeekFormatter,
                            displayWeekNumber: displayWeekNumber,
                            loading: loading,
                            renderLoading: renderLoading
                        }))
                    ]
                })
            })
        ]
    }));
});




const $4f7c04d922b20a4c$export$69888ffe06193e5e = ({ view: view, onViewChange: onViewChange, views: views, focusedView: focusedView, onFocusedViewChange: onFocusedViewChange, value: value, defaultValue: defaultValue, referenceDate: referenceDate, onChange: onChange, className: className, classes: classes, disableFuture: disableFuture, disablePast: disablePast, minDate: minDate, maxDate: maxDate, shouldDisableDate: shouldDisableDate, shouldDisableMonth: shouldDisableMonth, shouldDisableYear: shouldDisableYear, reduceAnimations: reduceAnimations, onMonthChange: onMonthChange, monthsPerRow: monthsPerRow, onYearChange: onYearChange, yearsOrder: yearsOrder, yearsPerRow: yearsPerRow, slots: slots, slotProps: slotProps, loading: loading, renderLoading: renderLoading, disableHighlightToday: disableHighlightToday, readOnly: readOnly, disabled: disabled, showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth, dayOfWeekFormatter: dayOfWeekFormatter, sx: sx, autoFocus: autoFocus, fixedWeekNumber: fixedWeekNumber, displayWeekNumber: displayWeekNumber, timezone: timezone })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d3f0ed23ac3123aa$export$68078fe5d2bf8909), {
        view: view,
        onViewChange: onViewChange,
        views: views.filter((0, $b8d019f986eaf72a$export$b32dfef9f07dea64)),
        focusedView: focusedView && (0, $b8d019f986eaf72a$export$b32dfef9f07dea64)(focusedView) ? focusedView : null,
        onFocusedViewChange: onFocusedViewChange,
        value: value,
        defaultValue: defaultValue,
        referenceDate: referenceDate,
        onChange: onChange,
        className: className,
        classes: classes,
        disableFuture: disableFuture,
        disablePast: disablePast,
        minDate: minDate,
        maxDate: maxDate,
        shouldDisableDate: shouldDisableDate,
        shouldDisableMonth: shouldDisableMonth,
        shouldDisableYear: shouldDisableYear,
        reduceAnimations: reduceAnimations,
        onMonthChange: onMonthChange,
        monthsPerRow: monthsPerRow,
        onYearChange: onYearChange,
        yearsOrder: yearsOrder,
        yearsPerRow: yearsPerRow,
        slots: slots,
        slotProps: slotProps,
        loading: loading,
        renderLoading: renderLoading,
        disableHighlightToday: disableHighlightToday,
        readOnly: readOnly,
        disabled: disabled,
        showDaysOutsideCurrentMonth: showDaysOutsideCurrentMonth,
        dayOfWeekFormatter: dayOfWeekFormatter,
        sx: sx,
        autoFocus: autoFocus,
        fixedWeekNumber: fixedWeekNumber,
        displayWeekNumber: displayWeekNumber,
        timezone: timezone
    });



'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DesktopDatePicker API](https://mui.com/x/api/date-pickers/desktop-date-picker/)
 */ const $b4ee73b378d7ff2f$export$5a73641f0156e1e4 = /*#__PURE__*/ $acw62.forwardRef(function DesktopDatePicker(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $039011ab24769564$export$a552c17ed3587731)(inProps, 'MuiDesktopDatePicker');
    const viewRenderers = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        day: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        month: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        year: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the desktop variant
    const props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps, {
        closeOnSelect: defaultizedProps.closeOnSelect ?? true,
        viewRenderers: viewRenderers,
        format: (0, $b8d019f986eaf72a$export$bb1c921f313ec928)(adapter, defaultizedProps, false),
        yearsPerRow: defaultizedProps.yearsPerRow ?? 4,
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            field: (0, $e0ec0b3c450466b8$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $ddd12d3841a65e00$export$5890f750904acddb)(defaultizedProps)),
            toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                hidden: true
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $921f50d8d6fdef68$export$b1b70bc56ac5be0e)({
        ref: ref,
        props: props,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
        valueType: 'date',
        validator: (0, $cee5e9e903761e8a$export$ffb3d0046ef3a2),
        steps: null
    });
    return renderPicker();
});
$b4ee73b378d7ff2f$export$5a73641f0156e1e4.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default true
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $d29eef8283105e84$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 4
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        3,
        4
    ])
};




var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");


parcelRequire("acw62");








const $5205dd229acf7a16$var$PickersModalDialogRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $37762b86c13fe370$export$2e2bcd8739ae039))({
    [`& .${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).container}`]: {
        outline: 0
    },
    [`& .${(0, $849b663ea7e799fa$export$2e2bcd8739ae039).paper}`]: {
        outline: 0,
        minWidth: (0, $e7cd373dd46c88ee$export$ee46b8a74d6c94d3)
    }
});
const $5205dd229acf7a16$var$PickersModalDialogContent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $17fd443c9302d537$export$2e2bcd8739ae039))({
    '&:first-of-type': {
        padding: 0
    }
});
function $5205dd229acf7a16$export$99f83c99e1491f77(props) {
    const { children: children, slots: slots, slotProps: slotProps } = props;
    const { open: open } = (0, $bc077554c64169c5$export$4495bebe53492ac8)();
    const { dismissViews: dismissViews, onPopperExited: onPopperExited } = (0, $a4bd2cc29c71e7d6$export$ceff2e8b47408642)();
    const Dialog = slots?.dialog ?? $5205dd229acf7a16$var$PickersModalDialogRoot;
    const Transition = slots?.mobileTransition ?? (0, $b0a9dc0bcc2977a8$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Dialog, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        open: open,
        onClose: ()=>{
            dismissViews();
            onPopperExited?.();
        }
    }, slotProps?.dialog, {
        TransitionComponent: Transition,
        TransitionProps: slotProps?.mobileTransition,
        PaperComponent: slots?.mobilePaper,
        PaperProps: slotProps?.mobilePaper,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5205dd229acf7a16$var$PickersModalDialogContent, {
            children: children
        })
    }));
}







const $9c54f8e6b9d53c05$var$_excluded = [
    "props",
    "steps"
], $9c54f8e6b9d53c05$var$_excluded2 = [
    "ownerState"
];
const $9c54f8e6b9d53c05$export$5ca0153a626a7dd7 = (_ref)=>{
    let { props: props, steps: steps } = _ref, pickerParams = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $9c54f8e6b9d53c05$var$_excluded);
    const { slots: slots, slotProps: innerSlotProps, label: label, inputRef: inputRef, localeText: localeText } = props;
    const getStepNavigation = (0, $f154a91c12ef630c$export$57511d4166284144)({
        steps: steps
    });
    const { providerProps: providerProps, renderCurrentView: renderCurrentView, ownerState: ownerState } = (0, $eb07fb7878304460$export$fc3313977ac596c4)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, pickerParams, {
        props: props,
        localeText: localeText,
        autoFocusView: true,
        viewContainerRole: 'dialog',
        variant: 'mobile',
        getStepNavigation: getStepNavigation
    }));
    const labelId = providerProps.privateContextValue.labelId;
    const isToolbarHidden = innerSlotProps?.toolbar?.hidden ?? false;
    const Field = slots.field;
    const _useSlotProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: Field,
        externalSlotProps: innerSlotProps?.field,
        additionalProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, isToolbarHidden && {
            id: labelId
        }),
        ownerState: ownerState
    }), fieldProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_useSlotProps, $9c54f8e6b9d53c05$var$_excluded2);
    const Layout = slots.layout ?? (0, $c6a4a7c871810436$export$647f604ea2397c05);
    let labelledById = labelId;
    if (isToolbarHidden) {
        if (label) labelledById = `${labelId}-label`;
        else labelledById = undefined;
    }
    const slotProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerSlotProps, {
        toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, innerSlotProps?.toolbar, {
            titleId: labelId
        }),
        mobilePaper: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            'aria-labelledby': labelledById
        }, innerSlotProps?.mobilePaper)
    });
    const renderPicker = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c33c428cfda4b7d5$export$aae9fbe9dd4050fa), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, providerProps, {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fieldProps, {
                    slots: slots,
                    slotProps: slotProps,
                    inputRef: inputRef
                })),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5205dd229acf7a16$export$99f83c99e1491f77), {
                    slots: slots,
                    slotProps: slotProps,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Layout, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps?.layout, {
                        slots: slots,
                        slotProps: slotProps,
                        children: renderCurrentView()
                    }))
                })
            ]
        }));
    return {
        renderPicker: renderPicker
    };
};









'use client';
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [MobileDatePicker API](https://mui.com/x/api/date-pickers/mobile-date-picker/)
 */ const $c796e8df31479cec$export$97b476d7a92fee62 = /*#__PURE__*/ $acw62.forwardRef(function MobileDatePicker(inProps, ref) {
    const adapter = (0, $75a4cb957586789c$export$e5c01b0ea0b41b2b)();
    // Props with the default values common to all date pickers
    const defaultizedProps = (0, $039011ab24769564$export$a552c17ed3587731)(inProps, 'MuiMobileDatePicker');
    const viewRenderers = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        day: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        month: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e),
        year: (0, $4f7c04d922b20a4c$export$69888ffe06193e5e)
    }, defaultizedProps.viewRenderers);
    // Props with the default values specific to the mobile variant
    const props = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps, {
        viewRenderers: viewRenderers,
        format: (0, $b8d019f986eaf72a$export$bb1c921f313ec928)(adapter, defaultizedProps, false),
        slots: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            field: (0, $e0ec0b3c450466b8$export$d9781c7894a82487)
        }, defaultizedProps.slots),
        slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultizedProps.slotProps, {
            field: (ownerState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $5f5557fdc8e8d8fa$export$2e2bcd8739ae039)(defaultizedProps.slotProps?.field, ownerState), (0, $ddd12d3841a65e00$export$5890f750904acddb)(defaultizedProps)),
            toolbar: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                hidden: false
            }, defaultizedProps.slotProps?.toolbar)
        })
    });
    const { renderPicker: renderPicker } = (0, $9c54f8e6b9d53c05$export$5ca0153a626a7dd7)({
        ref: ref,
        props: props,
        valueManager: (0, $235c2ad72f19522e$export$2764b246aa3b75ba),
        valueType: 'date',
        validator: (0, $cee5e9e903761e8a$export$ffb3d0046ef3a2),
        steps: null
    });
    return renderPicker();
});
$c796e8df31479cec$export$97b476d7a92fee62.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * If `true`, the main element is focused during the first mount.
   * This main element is:
   * - the element chosen by the visible view if any (i.e: the selected day on the `day` view).
   * - the `input` element if there is a field rendered.
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * If `true`, the Picker will close after submitting the full date.
   * @default false
   */ closeOnSelect: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Formats the day of week displayed in the calendar header.
   * @param {PickerValidDate} date The date of the day of week provided by the adapter.
   * @returns {string} The name to display.
   * @default (date: PickerValidDate) => adapter.format(date, 'weekdayShort').charAt(0).toUpperCase()
   */ dayOfWeekFormatter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * The default value.
   * Used when the component is not controlled.
   */ defaultValue: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * If `true`, the component is disabled.
   * When disabled, the value cannot be changed and no interaction is possible.
   * @default false
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, disable values after the current date for date components, time for time components and both for date time components.
   * @default false
   */ disableFuture: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, today's date is rendering without highlighting with circle.
   * @default false
   */ disableHighlightToday: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the button to open the Picker will not be rendered (it will only render the field).
   * @deprecated Use the [field component](https://mui.com/x/react-date-pickers/fields/) instead.
   * @default false
   */ disableOpenPicker: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, disable values before the current date for date components, time for time components and both for date time components.
   * @default false
   */ disablePast: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the week number will be display in the calendar.
   */ displayWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * @default true
   */ enableAccessibleFieldDOMStructure: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any,
    /**
   * The day view will show as many weeks as needed after the end of the current month to match this value.
   * Put it to 6 to have a fixed number of weeks in Gregorian calendars
   */ fixedWeekNumber: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Format of the date when rendered in the input(s).
   * Defaults to localized format based on the used `views`.
   */ format: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * Density of the format when rendered in the input.
   * Setting `formatDensity` to `"spacious"` will add a space before and after each `/`, `-` and `.` character.
   * @default "dense"
   */ formatDensity: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'dense',
        'spacious'
    ]),
    /**
   * Pass a ref to the `input` element.
   */ inputRef: (0, $d29eef8283105e84$export$2e2bcd8739ae039),
    /**
   * The label content.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).node,
    /**
   * If `true`, calls `renderLoading` instead of rendering the day calendar.
   * Can be used to preload information and show it in calendar.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Locale for components texts.
   * Allows overriding texts coming from `LocalizationProvider` and `theme`.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Maximal selectable date.
   * @default 2099-12-31
   */ maxDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Minimal selectable date.
   * @default 1900-01-01
   */ minDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Months rendered per row.
   * @default 3
   */ monthsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        3,
        4
    ]),
    /**
   * Name attribute used by the `input` element in the Field.
   */ name: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * Callback fired when the value is accepted.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The value that was just accepted.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onAccept: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the value changes.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @param {TValue} value The new value.
   * @param {FieldChangeHandlerContext<TError>} context The context containing the validation result of the current value.
   */ onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see `open`).
   */ onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the error associated with the current value changes.
   * When a validation error is detected, the `error` parameter contains a non-null value.
   * This can be used to render an appropriate form error.
   * @template TError The validation error type. It will be either `string` or a `null`. It can be in `[start, end]` format in case of range value.
   * @template TValue The value type. It will be the same type as `value` or `null`. It can be in `[start, end]` format in case of range value.
   * @param {TError} error The reason why the current value is not valid.
   * @param {TValue} value The value associated with the error.
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired on month change.
   * @param {PickerValidDate} month The new month.
   */ onMonthChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see `open`).
   */ onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the selected sections change.
   * @param {FieldSelectedSections} newValue The new selected sections.
   */ onSelectedSectionsChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired on view change.
   * @template TView Type of the view. It will vary based on the Picker type and the `views` it uses.
   * @param {TView} view The new view.
   */ onViewChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired on year change.
   * @param {PickerValidDate} year The new year.
   */ onYearChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Control the popup or dialog open state.
   * @default false
   */ open: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The default visible view.
   * Used when the component view is not controlled.
   * Must be a valid option from `views` list.
   */ openTo: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Force rendering in particular orientation.
   */ orientation: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'landscape',
        'portrait'
    ]),
    /**
   * If `true`, the component is read-only.
   * When read-only, the value cannot be changed but the user can interact with the interface.
   * @default false
   */ readOnly: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, disable heavy animations.
   * @default `@media(prefers-reduced-motion: reduce)` || `navigator.userAgent` matches Android <10 or iOS <13
   */ reduceAnimations: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The date used to generate the new value when both `value` and `defaultValue` are empty.
   * @default The closest valid date-time using the validation props, except callbacks like `shouldDisable<...>`.
   */ referenceDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Component displaying when passed `loading` true.
   * @returns {React.ReactNode} The node to render when loading.
   * @default () => <span>...</span>
   */ renderLoading: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * The currently selected sections.
   * This prop accepts four formats:
   * 1. If a number is provided, the section at this index will be selected.
   * 2. If a string of type `FieldSectionType` is provided, the first section with that name will be selected.
   * 3. If `"all"` is provided, all the sections will be selected.
   * 4. If `null` is provided, no section will be selected.
   * If not provided, the selected sections will be handled internally.
   */ selectedSections: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
            'all',
            'day',
            'empty',
            'hours',
            'meridiem',
            'minutes',
            'month',
            'seconds',
            'weekDay',
            'year'
        ]),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    ]),
    /**
   * Disable specific date.
   *
   * Warning: This function can be called multiple times (for example when rendering date calendar, checking if focus can be moved to a certain date, etc.). Expensive computations can impact performance.
   *
   * @param {PickerValidDate} day The date to test.
   * @returns {boolean} If `true` the date will be disabled.
   */ shouldDisableDate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Disable specific month.
   * @param {PickerValidDate} month The month to test.
   * @returns {boolean} If `true`, the month will be disabled.
   */ shouldDisableMonth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Disable specific year.
   * @param {PickerValidDate} year The year to test.
   * @returns {boolean} If `true`, the year will be disabled.
   */ shouldDisableYear: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * If `true`, days outside the current month are rendered:
   *
   * - if `fixedWeekNumber` is defined, renders days to have the weeks requested.
   *
   * - if `fixedWeekNumber` is not defined, renders day to fill the first and last week of the current month.
   *
   * - ignored if `calendars` equals more than `1` on range pickers.
   * @default false
   */ showDaysOutsideCurrentMonth: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The props used for each component slot.
   * @default {}
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Overridable component slots.
   * @default {}
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    ]),
    /**
   * Choose which timezone to use for the value.
   * Example: "default", "system", "UTC", "America/New_York".
   * If you pass values from other timezones to some props, they will be converted to this timezone before being used.
   * @see See the {@link https://mui.com/x/react-date-pickers/timezone/ timezones documentation} for more details.
   * @default The timezone of the `value` or `defaultValue` prop is defined, 'default' otherwise.
   */ timezone: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * The selected value.
   * Used when the component is controlled.
   */ value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * The visible view.
   * Used when the component view is controlled.
   * Must be a valid option from `views` list.
   */ view: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'day',
        'month',
        'year'
    ]),
    /**
   * Define custom view renderers for each section.
   * If `null`, the section will only have field editing.
   * If `undefined`, internally defined view will be used.
   */ viewRenderers: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        day: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        month: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        year: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    }),
    /**
   * Available views.
   */ views: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'day',
        'month',
        'year'
    ]).isRequired),
    /**
   * Years are displayed in ascending (chronological) order by default.
   * If `desc`, years are displayed in descending order.
   * @default 'asc'
   */ yearsOrder: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'asc',
        'desc'
    ]),
    /**
   * Years rendered per row.
   * @default 3
   */ yearsPerRow: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        3,
        4
    ])
};




'use client';
const $41015e883ddba84d$var$_excluded = [
    "desktopModeMediaQuery"
];
/**
 * Demos:
 *
 * - [DatePicker](https://mui.com/x/react-date-pickers/date-picker/)
 * - [Validation](https://mui.com/x/react-date-pickers/validation/)
 *
 * API:
 *
 * - [DatePicker API](https://mui.com/x/api/date-pickers/date-picker/)
 */ const $41015e883ddba84d$export$5109c6dd95d8fb00 = /*#__PURE__*/ $acw62.forwardRef(function DatePicker(inProps, ref) {
    const props = (0, $90952e82d066041a$export$2e2bcd8739ae039)({
        props: inProps,
        name: 'MuiDatePicker'
    });
    const { desktopModeMediaQuery: desktopModeMediaQuery = (0, $7c44784990d74e44$export$9ae5b19305db48ce) } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $41015e883ddba84d$var$_excluded);
    // defaults to `true` in environments where `window.matchMedia` would not be available (i.e. test/jsdom)
    const isDesktop = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)(desktopModeMediaQuery, {
        defaultMatches: true
    });
    if (isDesktop) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b4ee73b378d7ff2f$export$5a73641f0156e1e4), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c796e8df31479cec$export$97b476d7a92fee62), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref
    }, other));
});





function $a1665abf6052bbc9$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$a1665abf6052bbc9$export$2e2bcd8739ae039 = $a1665abf6052bbc9$export$baf757aaf0c95c94;


function $ec74b6b01c6372f4$export$3cb31b0df13be68(date, amount, options) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * 1000, options);
}
var // Fallback for modularized imports:
$ec74b6b01c6372f4$export$2e2bcd8739ae039 = $ec74b6b01c6372f4$export$3cb31b0df13be68;




function $e8dac3cf5df5dbc8$export$2287e3d29250119e(date, amount, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setTime(_date.getTime() + amount * (0, $8540a44f59a4af84$export$91246f0b9bd9beff));
    return _date;
}
var // Fallback for modularized imports:
$e8dac3cf5df5dbc8$export$2e2bcd8739ae039 = $e8dac3cf5df5dbc8$export$2287e3d29250119e;




function $dada8b88b0873e8d$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $a1665abf6052bbc9$export$baf757aaf0c95c94)(date, amount * (0, $8540a44f59a4af84$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$dada8b88b0873e8d$export$2e2bcd8739ae039 = $dada8b88b0873e8d$export$4a4306ad4fa0e5e6;



function $bce641bd93181421$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$bce641bd93181421$export$2e2bcd8739ae039 = $bce641bd93181421$export$ef501a2bb4f3ee6b;




function $25460c542fb3bf74$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$25460c542fb3bf74$export$2e2bcd8739ae039 = $25460c542fb3bf74$export$3d83eec43f4ea476;



function $b6a2419fd0059687$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$b6a2419fd0059687$export$2e2bcd8739ae039 = $b6a2419fd0059687$export$eb9a03f0e9aa6cea;




function $d53308c42f1e4c62$export$ef8b6d9133084f4e(date, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$d53308c42f1e4c62$export$2e2bcd8739ae039 = $d53308c42f1e4c62$export$ef8b6d9133084f4e;



function $6cbfdc6d008595cd$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$6cbfdc6d008595cd$export$2e2bcd8739ae039 = $6cbfdc6d008595cd$export$8b7aa55c66d5569e;




function $d60f4829c70cb6da$export$aa350b96d91cd94(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getDate();
}
var // Fallback for modularized imports:
$d60f4829c70cb6da$export$2e2bcd8739ae039 = $d60f4829c70cb6da$export$aa350b96d91cd94;




function $fcf1b449283ad4a9$export$257b40f71c07d58f(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getHours();
}
var // Fallback for modularized imports:
$fcf1b449283ad4a9$export$2e2bcd8739ae039 = $fcf1b449283ad4a9$export$257b40f71c07d58f;



function $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getMinutes();
}
var // Fallback for modularized imports:
$0c14dd26da4d9afe$export$2e2bcd8739ae039 = $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145;



function $6f30fa731c19b802$export$6ce1b5acc29cb53b(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getMonth();
}
var // Fallback for modularized imports:
$6f30fa731c19b802$export$2e2bcd8739ae039 = $6f30fa731c19b802$export$6ce1b5acc29cb53b;



function $a54ac051af9fd19a$export$5e9417507ff28427(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getSeconds();
}
var // Fallback for modularized imports:
$a54ac051af9fd19a$export$2e2bcd8739ae039 = $a54ac051af9fd19a$export$5e9417507ff28427;



function $8c11bc9b369aea05$export$b8e4380f312797af(date) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date).getMilliseconds();
}
var // Fallback for modularized imports:
$8c11bc9b369aea05$export$2e2bcd8739ae039 = $8c11bc9b369aea05$export$b8e4380f312797af;




function $4189f4c9c3b9878d$export$5846dc2d57a5c860(date, options) {
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getFullYear();
}
var // Fallback for modularized imports:
$4189f4c9c3b9878d$export$2e2bcd8739ae039 = $4189f4c9c3b9878d$export$5846dc2d57a5c860;



function $7c47abeb099a42c0$export$e4de839670987035(date, dateToCompare) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) > +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$7c47abeb099a42c0$export$2e2bcd8739ae039 = $7c47abeb099a42c0$export$e4de839670987035;



function $d2aab93838002ade$export$5c007e10c6929c95(date, dateToCompare) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date) < +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$d2aab93838002ade$export$2e2bcd8739ae039 = $d2aab93838002ade$export$5c007e10c6929c95;



function $7a7e68b5aa0b9077$export$248d38f6296296c5(leftDate, rightDate) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(leftDate) === +(0, $231bfb8d72679740$export$e67a095c620b86fe)(rightDate);
}
var // Fallback for modularized imports:
$7a7e68b5aa0b9077$export$2e2bcd8739ae039 = $7a7e68b5aa0b9077$export$248d38f6296296c5;




function $27a7db21eafd685b$export$ea39ec197993aef0(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return +(0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateLeft_) === +(0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(dateRight_);
}
var // Fallback for modularized imports:
$27a7db21eafd685b$export$2e2bcd8739ae039 = $27a7db21eafd685b$export$ea39ec197993aef0;



function $a4f3c61641c4093b$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$a4f3c61641c4093b$export$2e2bcd8739ae039 = $a4f3c61641c4093b$export$5841f9eb9773f25f;



function $06e3609fc2fbc2e2$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
var // Fallback for modularized imports:
$06e3609fc2fbc2e2$export$2e2bcd8739ae039 = $06e3609fc2fbc2e2$export$a18c89cbd24170ff;




function $d153613108f3ff12$export$24f91f68e7c9d9d5(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setMinutes(0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$d153613108f3ff12$export$2e2bcd8739ae039 = $d153613108f3ff12$export$24f91f68e7c9d9d5;


function $3d9e3b90112ffc43$export$f9f3a94a0371013(dateLeft, dateRight, options) {
    const [dateLeft_, dateRight_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, dateLeft, dateRight);
    return +(0, $d153613108f3ff12$export$24f91f68e7c9d9d5)(dateLeft_) === +(0, $d153613108f3ff12$export$24f91f68e7c9d9d5)(dateRight_);
}
var // Fallback for modularized imports:
$3d9e3b90112ffc43$export$2e2bcd8739ae039 = $3d9e3b90112ffc43$export$f9f3a94a0371013;











function $59425df5ba0b4bea$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $59425df5ba0b4bea$var$isConstructor(constructor) ? new constructor(0) : (0, $abb9adbdb26342b3$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $59425df5ba0b4bea$var$isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
var // Fallback for modularized imports:
$59425df5ba0b4bea$export$2e2bcd8739ae039 = $59425df5ba0b4bea$export$9cb09a71b7d66923;


const $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5 extends $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class $2c074b7ab8cd2d6d$export$8be15fe85ad72f86 extends $2c074b7ab8cd2d6d$export$81d53e3678089a6 {
    priority = $2c074b7ab8cd2d6d$var$TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, (0, $59425df5ba0b4bea$export$9cb09a71b7d66923)(date, this.context));
    }
}



class $bc2b96d39fc4c3d8$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $2c074b7ab8cd2d6d$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $db0c34f9a22bf78d$export$8e5a1d3f85a9688 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}




const $90ea69bf2b625c49$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $90ea69bf2b625c49$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7caea2161b2082cf$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7caea2161b2082cf$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff) + seconds * (0, $8540a44f59a4af84$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7caea2161b2082cf$export$d931c43c4608a164(dateString) {
    return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $7caea2161b2082cf$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388((0, $90ea69bf2b625c49$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $7caea2161b2082cf$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7caea2161b2082cf$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7caea2161b2082cf$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7caea2161b2082cf$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $66195bae0f19f15a$export$48d352de7cd4a988 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}






class $9fda39b31cab7345$export$b8ef38dfcf05d5db extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $0170e230c8468ebb$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7caea2161b2082cf$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}






class $1a189db5f2a1065c$export$951d1df011fde06f extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $c3854b7a937037cd$export$bad9d2ea38e8f1a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7caea2161b2082cf$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d1988bf983127f3e$export$5cb0f701186dde1d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $62b79555ac1f33b0$export$300c0c2990e20e6d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $44a198f4e488a239$export$400dd8b40ef138a3 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}





class $f7643ab884280f91$export$1d7eaa53eaa5deba extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}




function $66c7729eb95aa501$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $11b38d723fd57381$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(date_, options?.in);
}
var // Fallback for modularized imports:
$66c7729eb95aa501$export$2e2bcd8739ae039 = $66c7729eb95aa501$export$4b3066ce4afafd88;






class $0da9b6c0b13ee7fd$export$c4005ffc174e07c0 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)((0, $66c7729eb95aa501$export$4b3066ce4afafd88)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}




function $d0815b4ed45bc80a$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const diff = (0, $83e11b0db4cec366$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$d0815b4ed45bc80a$export$2e2bcd8739ae039 = $d0815b4ed45bc80a$export$6542bebf6be94082;






class $6803ee1ef2b46eaa$export$6fc8dbedd560a6af extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $1c9d32c6cb108460$export$6173213f95a4431e)((0, $d0815b4ed45bc80a$export$6542bebf6be94082)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}





const $e06f3f7fc9153746$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $e06f3f7fc9153746$export$e8d4b28a20981dd2 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $e06f3f7fc9153746$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $6b2b75646543924f$export$6cfe0d613455f615 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7caea2161b2082cf$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





function $13939a537621d91b$export$b04fdcda82decc6c(date, day, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$13939a537621d91b$export$2e2bcd8739ae039 = $13939a537621d91b$export$b04fdcda82decc6c;



class $9c29ecc5d15fe12f$export$1b03c8b76262f7bd extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}





class $fff6beaa36b4d0e5$export$44d1c127ab42c480 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}





class $1516c9543f7b6045$export$e447a647caaaec1d extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $13939a537621d91b$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}




function $6f80ca66d6710e40$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$6f80ca66d6710e40$export$2e2bcd8739ae039 = $6f80ca66d6710e40$export$c514f4c1a8ed5e9e;



function $87a68208fbd57247$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const currentDay = (0, $6f80ca66d6710e40$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$87a68208fbd57247$export$2e2bcd8739ae039 = $87a68208fbd57247$export$1fd9df65adb0d1aa;




class $6410865f895f2a05$export$693fb1e525095b2a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $87a68208fbd57247$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}




class $d5f00db985cb1985$export$8d1e08492351df91 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $40ef93898dc5fd94$export$73ca2bd0a17d273 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}




class $74a8f7a92cf7f4b7$export$bb9212adf05373db extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7caea2161b2082cf$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}





class $c4e91a5550a4af76$export$8a04050a727a1756 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $04e380d05021e0e6$export$e56f4dea2c3e56dd extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}





class $b7df994bc976acad$export$cbbe855312f87d77 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}





class $2a786c11f89b58f4$export$6008046d2b34b6a5 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}





class $fccac2a30b38ae4c$export$2b52670d9e2be53 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}





class $1cf805ecbd4f0c4e$export$94d46d540cf1366a extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7caea2161b2082cf$export$cc7cc9e2a3ff9388)((0, $90ea69bf2b625c49$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}




class $93458d2bd887c060$export$b8e6f8b2d70893b1 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7caea2161b2082cf$export$4f84e3a82c7b538)((0, $7caea2161b2082cf$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}







class $8e1ac7071c05f7b7$export$104d901d49fea29b extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}







class $817e75c4dd06b66a$export$12910e5204b52b9 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7caea2161b2082cf$export$6497f4c0ecdfba8e)((0, $90ea69bf2b625c49$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, date.getTime() - (0, $92dc0740ffabe180$export$113002b5eff6e430)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}





class $a7e39061a4ba0a45$export$2cd8bf877a05e96 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 40;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}





class $dff03ff1496c0b81$export$6d8f69c6906d6368 extends (0, $bc2b96d39fc4c3d8$export$7acfa6ed01010e37) {
    priority = 20;
    parse(dateString) {
        return (0, $7caea2161b2082cf$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}


const $5cf2b811a6ff5b69$export$19131010e7fd8373 = {
    G: new (0, $db0c34f9a22bf78d$export$8e5a1d3f85a9688)(),
    y: new (0, $66195bae0f19f15a$export$48d352de7cd4a988)(),
    Y: new (0, $9fda39b31cab7345$export$b8ef38dfcf05d5db)(),
    R: new (0, $1a189db5f2a1065c$export$951d1df011fde06f)(),
    u: new (0, $c3854b7a937037cd$export$bad9d2ea38e8f1a)(),
    Q: new (0, $d1988bf983127f3e$export$5cb0f701186dde1d)(),
    q: new (0, $62b79555ac1f33b0$export$300c0c2990e20e6d)(),
    M: new (0, $44a198f4e488a239$export$400dd8b40ef138a3)(),
    L: new (0, $f7643ab884280f91$export$1d7eaa53eaa5deba)(),
    w: new (0, $0da9b6c0b13ee7fd$export$c4005ffc174e07c0)(),
    I: new (0, $6803ee1ef2b46eaa$export$6fc8dbedd560a6af)(),
    d: new (0, $e06f3f7fc9153746$export$e8d4b28a20981dd2)(),
    D: new (0, $6b2b75646543924f$export$6cfe0d613455f615)(),
    E: new (0, $9c29ecc5d15fe12f$export$1b03c8b76262f7bd)(),
    e: new (0, $fff6beaa36b4d0e5$export$44d1c127ab42c480)(),
    c: new (0, $1516c9543f7b6045$export$e447a647caaaec1d)(),
    i: new (0, $6410865f895f2a05$export$693fb1e525095b2a)(),
    a: new (0, $d5f00db985cb1985$export$8d1e08492351df91)(),
    b: new (0, $40ef93898dc5fd94$export$73ca2bd0a17d273)(),
    B: new (0, $74a8f7a92cf7f4b7$export$bb9212adf05373db)(),
    h: new (0, $c4e91a5550a4af76$export$8a04050a727a1756)(),
    H: new (0, $04e380d05021e0e6$export$e56f4dea2c3e56dd)(),
    K: new (0, $b7df994bc976acad$export$cbbe855312f87d77)(),
    k: new (0, $2a786c11f89b58f4$export$6008046d2b34b6a5)(),
    m: new (0, $fccac2a30b38ae4c$export$2b52670d9e2be53)(),
    s: new (0, $1cf805ecbd4f0c4e$export$94d46d540cf1366a)(),
    S: new (0, $93458d2bd887c060$export$b8e6f8b2d70893b1)(),
    X: new (0, $8e1ac7071c05f7b7$export$104d901d49fea29b)(),
    x: new (0, $817e75c4dd06b66a$export$12910e5204b52b9)(),
    t: new (0, $a7e39061a4ba0a45$export$2cd8bf877a05e96)(),
    T: new (0, $dff03ff1496c0b81$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $8abb93379891fb3e$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $8abb93379891fb3e$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $8abb93379891fb3e$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $8abb93379891fb3e$var$doubleQuoteRegExp = /''/g;
const $8abb93379891fb3e$var$notWhitespaceRegExp = /\S/;
const $8abb93379891fb3e$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $8abb93379891fb3e$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, $f3e2f0f906df8397$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $2c074b7ab8cd2d6d$export$8be15fe85ad72f86)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match($8abb93379891fb3e$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $54cd66db3e5e74df$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($8abb93379891fb3e$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, $7e8a5b0b77bf77b9$export$c6b49d6dceb604a1)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, $7e8a5b0b77bf77b9$export$c6cc36aa33304772)(token)) (0, $7e8a5b0b77bf77b9$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $5cf2b811a6ff5b69$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($8abb93379891fb3e$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $8abb93379891fb3e$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $8abb93379891fb3e$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $8abb93379891fb3e$var$cleanEscapedString(input) {
    return input.match($8abb93379891fb3e$var$escapedStringRegExp)[1].replace($8abb93379891fb3e$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$8abb93379891fb3e$export$2e2bcd8739ae039 = $8abb93379891fb3e$export$98e6a39c04603d36;



function $e4a235b7a447c4f0$export$566174fa40823587(date, dayOfMonth, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setDate(dayOfMonth);
    return _date;
}
var // Fallback for modularized imports:
$e4a235b7a447c4f0$export$2e2bcd8739ae039 = $e4a235b7a447c4f0$export$566174fa40823587;



function $612758c85246c1d0$export$f86b797a4659b781(date, hours, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$612758c85246c1d0$export$2e2bcd8739ae039 = $612758c85246c1d0$export$f86b797a4659b781;



function $089730068462d950$export$ad569bf1c79ea89d(date, minutes, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    date_.setMinutes(minutes);
    return date_;
}
var // Fallback for modularized imports:
$089730068462d950$export$2e2bcd8739ae039 = $089730068462d950$export$ad569bf1c79ea89d;




function $af19e5fb9b37deaf$export$aec44746644cbf43(date, seconds, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setSeconds(seconds);
    return _date;
}
var // Fallback for modularized imports:
$af19e5fb9b37deaf$export$2e2bcd8739ae039 = $af19e5fb9b37deaf$export$aec44746644cbf43;



function $db2197e0fa774070$export$de5664029b35e06d(date, milliseconds, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setMilliseconds(milliseconds);
    return _date;
}
var // Fallback for modularized imports:
$db2197e0fa774070$export$2e2bcd8739ae039 = $db2197e0fa774070$export$de5664029b35e06d;




function $529c31b1ede64581$export$a8408b6c5639cab7(date, year, options) {
    const date_ = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in || date, NaN);
    date_.setFullYear(year);
    return date_;
}
var // Fallback for modularized imports:
$529c31b1ede64581$export$2e2bcd8739ae039 = $529c31b1ede64581$export$a8408b6c5639cab7;




function $c0b4ec5551eca4c9$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$c0b4ec5551eca4c9$export$2e2bcd8739ae039 = $c0b4ec5551eca4c9$export$a5a3b454ada2268e;



function $e58340063d97ab50$export$a2258d9c4118825c(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$e58340063d97ab50$export$2e2bcd8739ae039 = $e58340063d97ab50$export$a2258d9c4118825c;





function $9e26b76e988d89a9$export$d7deef7a3738e19d(date, interval, options) {
    const time = +(0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    const [startTime, endTime] = [
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.start, options?.in),
        +(0, $231bfb8d72679740$export$e67a095c620b86fe)(interval.end, options?.in)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$9e26b76e988d89a9$export$2e2bcd8739ae039 = $9e26b76e988d89a9$export$d7deef7a3738e19d;




const $ff3d867ec0a13b51$var$formatTokenMap = {
    // Year
    y: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yy: 'year',
    yyy: {
        sectionType: 'year',
        contentType: 'digit',
        maxLength: 4
    },
    yyyy: 'year',
    // Month
    M: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    MM: 'month',
    MMMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    MMM: {
        sectionType: 'month',
        contentType: 'letter'
    },
    L: {
        sectionType: 'month',
        contentType: 'digit',
        maxLength: 2
    },
    LL: 'month',
    LLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    LLLL: {
        sectionType: 'month',
        contentType: 'letter'
    },
    // Day of the month
    d: {
        sectionType: 'day',
        contentType: 'digit',
        maxLength: 2
    },
    dd: 'day',
    do: {
        sectionType: 'day',
        contentType: 'digit-with-letter'
    },
    // Day of the week
    E: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    EEEEE: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    i: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ii: 'weekDay',
    iii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    iiii: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // eslint-disable-next-line id-denylist
    e: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    ee: 'weekDay',
    eee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    eeeeee: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    c: {
        sectionType: 'weekDay',
        contentType: 'digit',
        maxLength: 1
    },
    cc: 'weekDay',
    ccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    ccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    cccccc: {
        sectionType: 'weekDay',
        contentType: 'letter'
    },
    // Meridiem
    a: 'meridiem',
    aa: 'meridiem',
    aaa: 'meridiem',
    // Hours
    H: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    HH: 'hours',
    h: {
        sectionType: 'hours',
        contentType: 'digit',
        maxLength: 2
    },
    hh: 'hours',
    // Minutes
    m: {
        sectionType: 'minutes',
        contentType: 'digit',
        maxLength: 2
    },
    mm: 'minutes',
    // Seconds
    s: {
        sectionType: 'seconds',
        contentType: 'digit',
        maxLength: 2
    },
    ss: 'seconds'
};
const $ff3d867ec0a13b51$var$defaultFormats = {
    year: 'yyyy',
    month: 'LLLL',
    monthShort: 'MMM',
    dayOfMonth: 'd',
    dayOfMonthFull: 'do',
    weekday: 'EEEE',
    weekdayShort: 'EEEEEE',
    hours24h: 'HH',
    hours12h: 'hh',
    meridiem: 'aa',
    minutes: 'mm',
    seconds: 'ss',
    fullDate: 'PP',
    keyboardDate: 'P',
    shortDate: 'MMM d',
    normalDate: 'd MMMM',
    normalDateWithWeekday: 'EEE, MMM d',
    fullTime12h: 'hh:mm aa',
    fullTime24h: 'HH:mm',
    keyboardDateTime12h: 'P hh:mm aa',
    keyboardDateTime24h: 'P HH:mm'
};
class $ff3d867ec0a13b51$export$e330e9acbbe873f1 {
    isMUIAdapter = true;
    isTimezoneCompatible = false;
    formatTokenMap = (()=>$ff3d867ec0a13b51$var$formatTokenMap)();
    escapedCharacters = {
        start: "'",
        end: "'"
    };
    constructor(props){
        const { locale: locale, formats: formats, longFormatters: longFormatters, lib: lib } = props;
        this.locale = locale;
        this.formats = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $ff3d867ec0a13b51$var$defaultFormats, formats);
        this.longFormatters = longFormatters;
        this.lib = lib || 'date-fns';
    }
    date = (value)=>{
        if (typeof value === 'undefined') return new Date();
        if (value === null) return null;
        return new Date(value);
    };
    getInvalidDate = ()=>new Date('Invalid Date');
    getTimezone = ()=>{
        return 'default';
    };
    setTimezone = (value)=>{
        return value;
    };
    toJsDate = (value)=>{
        return value;
    };
    getCurrentLocaleCode = ()=>{
        // `code` is undefined only in `date-fns` types, but all locales have it
        return this.locale.code;
    };
    // Note: date-fns input types are more lenient than this adapter, so we need to expose our more
    // strict signature and delegate to the more lenient signature. Otherwise, we have downstream type errors upon usage.
    is12HourCycleInCurrentLocale = ()=>{
        return /a/.test(this.locale.formatLong.time({
            width: 'short'
        }));
    };
    expandFormat = (format)=>{
        const longFormatRegexp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
        // @see https://github.com/date-fns/date-fns/blob/master/src/format/index.js#L31
        return format.match(longFormatRegexp).map((token)=>{
            const firstCharacter = token[0];
            if (firstCharacter === 'p' || firstCharacter === 'P') {
                const longFormatter = this.longFormatters[firstCharacter];
                return longFormatter(token, this.locale.formatLong);
            }
            return token;
        }).join('');
    };
    formatNumber = (numberToFormat)=>{
        return numberToFormat;
    };
    getDayOfWeek = (value)=>{
        return value.getDay() + 1;
    };
}


class $cf2ede53d164004b$export$81f56c0329a1921d extends (0, $ff3d867ec0a13b51$export$e330e9acbbe873f1) {
    constructor({ locale: locale, formats: formats } = {}){
        /* v8 ignore stop */ super({
            locale: locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f),
            formats: formats,
            longFormatters: $54cd66db3e5e74df$export$70cc8fd02856fd58
        });
    }
    // TODO: explicit return types can be removed once there is only one date-fns version supported
    parse = (value, format)=>{
        if (value === '') return null;
        return (0, $8abb93379891fb3e$export$98e6a39c04603d36)(value, format, new Date(), {
            locale: this.locale
        });
    };
    isValid = (value)=>{
        if (value == null) return false;
        return (0, $f2a682b251363bc2$export$1ea939691cdc45b8)(value);
    };
    format = (value, formatKey)=>{
        return this.formatByString(value, this.formats[formatKey]);
    };
    formatByString = (value, formatString)=>{
        return (0, $303ba10db2c74ab4$export$d9468344d3651243)(value, formatString, {
            locale: this.locale
        });
    };
    isEqual = (value, comparing)=>{
        if (value === null && comparing === null) return true;
        if (value === null || comparing === null) return false;
        return (0, $7a7e68b5aa0b9077$export$248d38f6296296c5)(value, comparing);
    };
    isSameYear = (value, comparing)=>{
        return (0, $a4f3c61641c4093b$export$5841f9eb9773f25f)(value, comparing);
    };
    isSameMonth = (value, comparing)=>{
        return (0, $06e3609fc2fbc2e2$export$a18c89cbd24170ff)(value, comparing);
    };
    isSameDay = (value, comparing)=>{
        return (0, $27a7db21eafd685b$export$ea39ec197993aef0)(value, comparing);
    };
    isSameHour = (value, comparing)=>{
        return (0, $3d9e3b90112ffc43$export$f9f3a94a0371013)(value, comparing);
    };
    isAfter = (value, comparing)=>{
        return (0, $7c47abeb099a42c0$export$e4de839670987035)(value, comparing);
    };
    isAfterYear = (value, comparing)=>{
        return (0, $7c47abeb099a42c0$export$e4de839670987035)(value, (0, $6cbfdc6d008595cd$export$8b7aa55c66d5569e)(comparing));
    };
    isAfterDay = (value, comparing)=>{
        return (0, $7c47abeb099a42c0$export$e4de839670987035)(value, (0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(comparing));
    };
    isBefore = (value, comparing)=>{
        return (0, $d2aab93838002ade$export$5c007e10c6929c95)(value, comparing);
    };
    isBeforeYear = (value, comparing)=>{
        return (0, $d2aab93838002ade$export$5c007e10c6929c95)(value, this.startOfYear(comparing));
    };
    isBeforeDay = (value, comparing)=>{
        return (0, $d2aab93838002ade$export$5c007e10c6929c95)(value, this.startOfDay(comparing));
    };
    isWithinRange = (value, [start, end])=>{
        return (0, $9e26b76e988d89a9$export$d7deef7a3738e19d)(value, {
            start: start,
            end: end
        });
    };
    startOfYear = (value)=>{
        return (0, $29cc086f79701cd9$export$f91e89d3d0406102)(value);
    };
    startOfMonth = (value)=>{
        return (0, $c0b4ec5551eca4c9$export$a5a3b454ada2268e)(value);
    };
    startOfWeek = (value)=>{
        return (0, $61f11f7a26b3ab78$export$42c81a444fbfb5d4)(value, {
            locale: this.locale
        });
    };
    startOfDay = (value)=>{
        return (0, $b6caff0bf13dcaf5$export$63fa379ae8a9ba2)(value);
    };
    endOfYear = (value)=>{
        return (0, $6cbfdc6d008595cd$export$8b7aa55c66d5569e)(value);
    };
    endOfMonth = (value)=>{
        return (0, $e58340063d97ab50$export$a2258d9c4118825c)(value);
    };
    endOfWeek = (value)=>{
        return (0, $d53308c42f1e4c62$export$ef8b6d9133084f4e)(value, {
            locale: this.locale
        });
    };
    endOfDay = (value)=>{
        return (0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(value);
    };
    addYears = (value, amount)=>{
        return (0, $25460c542fb3bf74$export$3d83eec43f4ea476)(value, amount);
    };
    addMonths = (value, amount)=>{
        return (0, $8fcd3b0bf5df7635$export$17c93e242b2d3a22)(value, amount);
    };
    addWeeks = (value, amount)=>{
        return (0, $bce641bd93181421$export$ef501a2bb4f3ee6b)(value, amount);
    };
    addDays = (value, amount)=>{
        return (0, $a351150ce2eb3ddb$export$dd412b56f1e4d8aa)(value, amount);
    };
    addHours = (value, amount)=>{
        return (0, $dada8b88b0873e8d$export$4a4306ad4fa0e5e6)(value, amount);
    };
    addMinutes = (value, amount)=>{
        return (0, $e8dac3cf5df5dbc8$export$2287e3d29250119e)(value, amount);
    };
    addSeconds = (value, amount)=>{
        return (0, $ec74b6b01c6372f4$export$3cb31b0df13be68)(value, amount);
    };
    getYear = (value)=>{
        return (0, $4189f4c9c3b9878d$export$5846dc2d57a5c860)(value);
    };
    getMonth = (value)=>{
        return (0, $6f30fa731c19b802$export$6ce1b5acc29cb53b)(value);
    };
    getDate = (value)=>{
        return (0, $d60f4829c70cb6da$export$aa350b96d91cd94)(value);
    };
    getHours = (value)=>{
        return (0, $fcf1b449283ad4a9$export$257b40f71c07d58f)(value);
    };
    getMinutes = (value)=>{
        return (0, $0c14dd26da4d9afe$export$b7f1bc3ea3ac4145)(value);
    };
    getSeconds = (value)=>{
        return (0, $a54ac051af9fd19a$export$5e9417507ff28427)(value);
    };
    getMilliseconds = (value)=>{
        return (0, $8c11bc9b369aea05$export$b8e4380f312797af)(value);
    };
    setYear = (value, year)=>{
        return (0, $529c31b1ede64581$export$a8408b6c5639cab7)(value, year);
    };
    setMonth = (value, month)=>{
        return (0, $16856745969af5fc$export$63264690f8e36790)(value, month);
    };
    setDate = (value, date)=>{
        return (0, $e4a235b7a447c4f0$export$566174fa40823587)(value, date);
    };
    setHours = (value, hours)=>{
        return (0, $612758c85246c1d0$export$f86b797a4659b781)(value, hours);
    };
    setMinutes = (value, minutes)=>{
        return (0, $089730068462d950$export$ad569bf1c79ea89d)(value, minutes);
    };
    setSeconds = (value, seconds)=>{
        return (0, $af19e5fb9b37deaf$export$aec44746644cbf43)(value, seconds);
    };
    setMilliseconds = (value, milliseconds)=>{
        return (0, $db2197e0fa774070$export$de5664029b35e06d)(value, milliseconds);
    };
    getDaysInMonth = (value)=>{
        return (0, $57397b9e44500b87$export$f645ddd439eb259d)(value);
    };
    getWeekArray = (value)=>{
        const start = this.startOfWeek(this.startOfMonth(value));
        const end = this.endOfWeek(this.endOfMonth(value));
        let count = 0;
        let current = start;
        const nestedWeeks = [];
        while(this.isBefore(current, end)){
            const weekNumber = Math.floor(count / 7);
            nestedWeeks[weekNumber] = nestedWeeks[weekNumber] || [];
            nestedWeeks[weekNumber].push(current);
            current = this.addDays(current, 1);
            count += 1;
        }
        return nestedWeeks;
    };
    getWeekNumber = (value)=>{
        return (0, $11b38d723fd57381$export$efe19b760242b2fc)(value, {
            locale: this.locale
        });
    };
    getYearRange = ([start, end])=>{
        const startDate = this.startOfYear(start);
        const endDate = this.endOfYear(end);
        const years = [];
        let current = startDate;
        while(this.isBefore(current, endDate)){
            years.push(current);
            current = this.addYears(current, 1);
        }
        return years;
    };
}





const $4332780aab9f215d$export$a6ab8310e121a30a = ({ value: value, disabledDates: disabledDates, openDays: openDays, onChange: onChange, disabled: disabled, minDate: minDate, maxDate: maxDate })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
        dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
            views: [
                'month',
                'day',
                'year'
            ],
            value: value,
            onChange: onChange,
            disabled: disabled,
            enableAccessibleFieldDOMStructure: false,
            slots: {
                openPickerIcon: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                textField: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...params,
                        className: "compactTextField"
                    })
            },
            shouldDisableDate: (date)=>(0, $b7b40115c69e5f0f$export$babeed77dd4c5122)(date, disabledDates, openDays, value, minDate, maxDate)
        })
    });
};






const $6683c169b9a36309$export$c8f84815904a8534 = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()(()=>{
    return {
        textArea: {
            backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mediumBlue,
            width: '100%',
            border: '1px solid ' + `${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`,
            color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
            borderRadius: 5,
            padding: '5px 10px',
            fontFamily: 'Helvetica Neue',
            fontSize: 15,
            '::placeholder': {
                color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue
            }
        }
    };
});
const $6683c169b9a36309$export$8a758d0dd9d6f0d = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()((theme)=>{
    return {
        root: {
            '&.MuiAutocomplete-root': {
                '& .MuiOutlinedInput-root': {
                    borderRadius: 50,
                    border: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`,
                    [theme.breakpoints.up('lg')]: {
                        width: '60%'
                    },
                    '&.Mui-focused': {
                        borderRadius: '50px !important',
                        border: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`
                    },
                    '& input::placeholder': {
                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white
                    },
                    '& .MuiSvgIcon-root': {
                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white
                    },
                    '& .MuiAutocomplete-endAdornment': {
                        display: 'none'
                    }
                }
            }
        },
        popper: {
            color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
            borderRadius: '0px 0px 8px 8px',
            border: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`,
            backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue,
            borderTop: 'none'
        },
        option: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-around',
            color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
            margin: '25px 0',
            cursor: 'pointer'
        }
    };
});


const $9e1fc93e87468679$export$9981aa0ace68f857 = ({ appointment: appointment, isEditing: isEditing, setAppointment: setAppointment })=>{
    const { setDealershipId: setDealershipId, disableEventTime: disableEventTime, dealershipUserOptions: dealershipUserOptions, appointmentStatusOptions: appointmentStatusOptions, appointmentTypeOptions: appointmentTypeOptions, eventTimesOptions: eventTimesOptions, eventTimeLabel: eventTimeLabel, minDate: minDate, userInfo: userInfo, dealershipOptions: dealershipOptions } = (0, $4a65c9c5e5494742$export$da76e6c5514d04e3)(appointment);
    const { classes: classes } = (0, $6683c169b9a36309$export$c8f84815904a8534)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            container: true,
            direction: "column",
            spacing: 6,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d57c569ea6f82ef2$export$e05fc2ba4c750766), {
                                    label: "Event location",
                                    value: appointment?.dealershipId,
                                    isEditing: isEditing,
                                    options: dealershipOptions,
                                    onChange: (option)=>{
                                        setDealershipId(option.value);
                                        setAppointment({
                                            ...appointment,
                                            location: option.label,
                                            dealershipId: option.value
                                        });
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d57c569ea6f82ef2$export$e05fc2ba4c750766), {
                                    label: "Event type",
                                    value: appointment?.type,
                                    isEditing: isEditing,
                                    options: appointmentTypeOptions,
                                    disabled: !appointmentTypeOptions.length,
                                    onChange: (option)=>{
                                        setAppointment({
                                            ...appointment,
                                            type: option.value,
                                            typeLabel: option.label
                                        });
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Event Date"
                                    }),
                                    isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4332780aab9f215d$export$a6ab8310e121a30a), {
                                        minDate: minDate,
                                        value: appointment?.date,
                                        disabled: appointment?.type === null || appointment?.type === undefined,
                                        onChange: (date)=>{
                                            setAppointment({
                                                ...appointment,
                                                date: date,
                                                startTime: 0
                                            });
                                        }
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: (0, $303ba10db2c74ab4$export$d9468344d3651243)(appointment?.date, 'MM/dd/yyyy')
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d57c569ea6f82ef2$export$e05fc2ba4c750766), {
                                    label: eventTimeLabel,
                                    value: appointment?.startTime,
                                    isEditing: isEditing,
                                    options: eventTimesOptions,
                                    disabled: disableEventTime || !appointment?.date,
                                    onChange: (option)=>{
                                        setAppointment({
                                            ...appointment,
                                            startTime: option.value
                                        });
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d57c569ea6f82ef2$export$e05fc2ba4c750766), {
                                    label: "Status",
                                    value: appointment?.status,
                                    isEditing: isEditing,
                                    disabled: true,
                                    options: appointmentStatusOptions,
                                    onChange: (option)=>{
                                        setAppointment({
                                            ...appointment,
                                            status: option.value,
                                            statusLabel: option.label
                                        });
                                    }
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d57c569ea6f82ef2$export$e05fc2ba4c750766), {
                                    label: "Assignee",
                                    value: appointment?.assigneeId,
                                    isEditing: isEditing,
                                    options: dealershipUserOptions,
                                    disabled: dealershipUserOptions.length < 1,
                                    onChange: (option)=>{
                                        setAppointment({
                                            ...appointment,
                                            assigneeId: option.value,
                                            assigneeName: option.label
                                        });
                                    }
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        container: true,
                        direction: "column",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "caption",
                                children: "Notes"
                            }),
                            isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bf53bc833721b52$export$2e2bcd8739ae039), {
                                minRows: 2,
                                value: appointment?.note,
                                placeholder: "Add any additional notes about this appointment here",
                                className: classes.textArea,
                                onChange: (e)=>{
                                    setAppointment({
                                        ...appointment,
                                        note: e.target.value,
                                        noteAuthor: userInfo.name
                                    });
                                }
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: appointment?.note || 'No notes available'
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};



const $0e8aa1c232efdd1e$export$bdee8ff9da1a3299 = ({ appointment: appointment, isEditing: isEditing, setAppointment: setAppointment, isDriveOffPaid: isDriveOffPaid })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                heading: "General information",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9e1fc93e87468679$export$9981aa0ace68f857), {
                    setAppointment: setAppointment,
                    appointment: appointment,
                    isEditing: isEditing
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                heading: "Customer and vehicle information",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "row",
                    justifyContent: "space-between",
                    spacing: 4,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Customer name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: appointment?.customerName || 'N/A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Account #"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: appointment?.customerAccountNumber || 'N/A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Color"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: appointment?.color || 'N/A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Vin #"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: appointment?.vin || 'N/A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Make"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: appointment?.make || 'N/A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Model"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: appointment?.model || 'N/A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Year"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: appointment?.year || 'N/A'
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                direction: "column",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Drive Off Paid"
                                    }),
                                    isDriveOffPaid !== undefined ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: isDriveOffPaid ? 'Yes' : 'No'
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: "N/A"
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");

var $fcTGK = parcelRequire("fcTGK");

var $26u10 = parcelRequire("26u10");
const $1ca8fa36f1e7a1fa$export$381860f91ca63784 = (handleClose, selectedAppointment)=>{
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const [appointment, setAppointment] = (0, $acw62.useState)();
    const [displayCancellationConfirmation, setDisplayCancellationConfirmation] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        setAppointment(selectedAppointment);
    }, [
        selectedAppointment
    ]);
    const isAppointmentCancelled = (0, $fcTGK.AppointmentStatus).CANCELLED === appointment?.status;
    const updateAppointment = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).updateAppointment(appointment);
        },
        onSuccess (data) {
            setIsEditing(false);
            setAppointment({
                ...appointment,
                id: data?.appointmentId
            });
            invalidateAllQueries();
        },
        // when a double booking response comes back, an error is thrown
        // but the appointment is still created. We must invalidate the queries
        // here as well to have proper refreshed data
        onError () {
            invalidateAllQueries();
        }
    });
    const cancelAppointment = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (id)=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).cancelAppointment(id);
        },
        onSuccess () {
            invalidateAllQueries();
        }
    });
    function invalidateAllQueries() {
        queryClient.invalidateQueries({
            queryKey: [
                '/listAppointments',
                '/listAppointmentsByAccountNumber'
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                '/listAppointments',
                '/listAppointmentsByVin'
            ]
        });
    }
    function closeModal() {
        setIsEditing(false);
        setDisplayCancellationConfirmation(false);
        updateAppointment.reset();
        handleClose();
    }
    function cancelChanges() {
        setAppointment(selectedAppointment);
        setIsEditing(false);
    }
    return {
        isEditing: isEditing,
        updateAppointment: updateAppointment,
        appointment: appointment,
        cancelAppointment: cancelAppointment,
        displayCancellationConfirmation: displayCancellationConfirmation,
        setDisplayCancellationConfirmation: setDisplayCancellationConfirmation,
        setAppointment: setAppointment,
        setIsEditing: setIsEditing,
        closeModal: closeModal,
        cancelChanges: cancelChanges,
        isAppointmentCancelled: isAppointmentCancelled
    };
};
const $1ca8fa36f1e7a1fa$export$43878bd15b395794 = ({ subscriptionId: subscriptionId })=>{
    const { data: billingStatus } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/billingStatusDriveOffPaid',
            {
                subscriptionId: subscriptionId
            }
        ],
        queryFn: async ()=>{
            let billingStatusResult;
            try {
                billingStatusResult = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getBillingStatus(subscriptionId);
            } catch (err) {
                console.error('getBillingStatus error', err);
                billingStatusResult = new (0, $26u10.GetBillingStatusResponse)().toObject();
            }
            return {
                driveOffPaid: billingStatusResult.driveOffPaid
            };
        },
        enabled: !!subscriptionId,
        placeholderData: {
            driveOffPaid: false
        }
    });
    return {
        billingStatus: billingStatus
    };
};


const $992d7a08fd97d0aa$export$d64e7f92127bb3c = ({ modalIsOpen: modalIsOpen, handleClose: handleClose, selectedAppointment: selectedAppointment, subscriptionId: subscriptionId })=>{
    const { isEditing: isEditing, updateAppointment: updateAppointment, appointment: appointment, displayCancellationConfirmation: displayCancellationConfirmation, cancelAppointment: cancelAppointment, setDisplayCancellationConfirmation: setDisplayCancellationConfirmation, setAppointment: setAppointment, cancelChanges: cancelChanges, setIsEditing: setIsEditing, closeModal: closeModal, isAppointmentCancelled: isAppointmentCancelled } = (0, $1ca8fa36f1e7a1fa$export$381860f91ca63784)(handleClose, selectedAppointment);
    const { billingStatus: billingStatus } = (0, $1ca8fa36f1e7a1fa$export$43878bd15b395794)({
        subscriptionId: subscriptionId
    });
    function getHeaderButtons() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                columnGap: 2,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            color: "primary",
                            onClick: ()=>isEditing ? cancelChanges() : closeModal(),
                            children: isEditing ? 'Cancel' : 'Close'
                        })
                    }),
                    !displayCancellationConfirmation && !isAppointmentCancelled && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "contained",
                            color: "primary",
                            onClick: ()=>isEditing ? updateAppointment.mutate() : setIsEditing(true),
                            children: isEditing ? 'Save' : 'Edit'
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
        open: modalIsOpen,
        onClose: closeModal,
        sx: {
            backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue
        },
        className: "modal-xl",
        "aria-labelledby": "appointment-modal",
        "aria-describedby": "create-appointment-modal",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48a14f90dc08d980$export$89693000420c0acd), {
                heading: "Appointment details",
                headerHasBottomBorder: true,
                actionBlock: getHeaderButtons(),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                    wrapperSection: true,
                    children: !displayCancellationConfirmation ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: updateAppointment.isPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                width: '100%',
                                textAlign: 'center'
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                updateAppointment.isSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    className: "success",
                                    children: `Appointment ${updateAppointment?.data?.appointmentId} updated successfully`
                                }),
                                updateAppointment.isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    className: "error",
                                    children: updateAppointment?.error?.message
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e8aa1c232efdd1e$export$bdee8ff9da1a3299), {
                                    appointment: appointment,
                                    isEditing: isEditing,
                                    setAppointment: setAppointment,
                                    isDriveOffPaid: billingStatus.driveOffPaid
                                }),
                                appointment?.status !== 2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    justifyContent: "center",
                                    alignSelf: "center",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                        disabled: isEditing,
                                        onClick: ()=>setDisplayCancellationConfirmation(true),
                                        variant: "contained",
                                        color: "secondary",
                                        children: "Cancel Appointment"
                                    })
                                })
                            ]
                        })
                    }) : // Cancellation confirmation content
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                        subSection: true,
                        heading: "Cancel appointment",
                        children: cancelAppointment.isPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                width: '100%',
                                textAlign: 'center'
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            container: true,
                            direction: "column",
                            spacing: 2,
                            children: cancelAppointment.isSuccess ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    className: "success",
                                    children: [
                                        'Appointment "',
                                        `${appointment?.id}`,
                                        '" Cancelled Successfully'
                                    ]
                                })
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: "Are you sure you want to cancel this appointment? You cannot undo this action. Click confirm to continue, or cancel to go back."
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        container: true,
                                        direction: "row",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                                    variant: "outlined",
                                                    color: "primary",
                                                    onClick: ()=>setDisplayCancellationConfirmation(false),
                                                    children: "Cancel"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                                    variant: "contained",
                                                    color: "secondary",
                                                    onClick: ()=>{
                                                        cancelAppointment.mutate(appointment?.id);
                                                    },
                                                    children: "Confirm"
                                                })
                                            })
                                        ]
                                    }),
                                    cancelAppointment.isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            className: "error",
                                            children: cancelAppointment?.error?.message
                                        })
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};



var $acw62 = parcelRequire("acw62");
const $9a22d39d3ec8cdbc$export$ffca14f71cd01d93 = ()=>{
    const [selectedAppointment, setSelectedAppointment] = (0, $acw62.useState)();
    function handleClose() {
        setSelectedAppointment(undefined);
    }
    return {
        selectedAppointment: selectedAppointment,
        setSelectedAppointment: setSelectedAppointment,
        handleClose: handleClose
    };
};


const $eb6ac201fa409201$export$675aa2c02f1bc1a0 = ({ isLoading: isLoading, appointment: appointment, displayCustomerDetails: displayCustomerDetails })=>{
    const { selectedAppointment: selectedAppointment, setSelectedAppointment: setSelectedAppointment, handleClose: handleClose } = (0, $9a22d39d3ec8cdbc$export$ffca14f71cd01d93)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            sx: {
                width: '100%',
                textAlign: 'center'
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            sx: {
                marginBottom: '30px'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                    subSection: true,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        container: true,
                        direction: "row",
                        justifyContent: "space-around",
                        children: [
                            displayCustomerDetails && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                            container: true,
                                            item: true,
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Customer name"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    children: appointment?.customerName || 'N/A'
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                            container: true,
                                            item: true,
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Vin #"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    children: appointment?.vin || 'N/A'
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        item: true,
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                            container: true,
                                            item: true,
                                            direction: "column",
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    children: "Account #"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    children: appointment?.customerAccountNumber || 'N/A'
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Event location"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: appointment?.location || 'N/A'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Event type"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: appointment?.typeLabel || 'N/A'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Event date"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: (0, $303ba10db2c74ab4$export$2e2bcd8739ae039)(appointment?.date, 'MM/dd/yyyy') || 'N/A'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: [
                                                "Event time ",
                                                (0, $90fb957545aae5a4$export$b1ca0d3383204cb9)(appointment?.timeZone)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: appointment?.startTime ? (0, $90fb957545aae5a4$export$e5ff5c01504275c4)(appointment?.startTime, appointment?.timeZone, 1800000) : 'N/A'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Assignee"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: appointment?.assigneeName || 'N/A'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    direction: "column",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            className: appointment?.statusLabel === 'Cancelled' ? 'secondaryAccent' : '',
                                            children: appointment?.statusLabel || 'N/A'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                item: true,
                                justifyContent: "center",
                                alignSelf: "center",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    container: true,
                                    item: true,
                                    direction: "column",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                        variant: "text",
                                        onClick: ()=>setSelectedAppointment(appointment),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            className: "primaryAccent bold",
                                            children: "View"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $992d7a08fd97d0aa$export$d64e7f92127bb3c), {
                    selectedAppointment: selectedAppointment,
                    modalIsOpen: !!selectedAppointment,
                    handleClose: handleClose,
                    customerId: selectedAppointment?.customerId,
                    subscriptionId: selectedAppointment?.subscriptionId
                })
            ]
        })
    });
};



parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");



const $4255990f5fa14d45$export$bd36a39497534430 = (number)=>new Intl.NumberFormat().format(number);
const $4255990f5fa14d45$export$93fa2a2811360063 = {
    ACTIVATED: 'Activated',
    CANCELLED: 'Cancelled',
    ASSIGNED_VEHICLE: 'Assigned Vehicle',
    PENDING: 'Pending',
    PAID: 'Paid',
    QUALIFIED: 'Qualified',
    DISQUALIFIED: 'Disqualified'
};
const $4255990f5fa14d45$export$b42757a6b1d6a0e7 = (vehicle, type)=>{
    if (vehicle?.makeModel?.length > 0) {
        const makeModel = vehicle?.makeModel.split('/');
        return type === 'make' ? makeModel[0] : makeModel[1];
    }
    return 'N/A';
};


const $9eab64c79de53909$export$b5989a86cdd64d1d = (handleClose, onReservationPage, reservation)=>{
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const [appointment, setAppointment] = (0, $acw62.useState)();
    const [isEditing, setIsEditing] = (0, $acw62.useState)(true);
    const [isReservationAppointment, setIsReservationAppointment] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (onReservationPage) {
            buildAppointment(reservation?.reservation?.id, reservation?.customer?.id, reservation?.customerInfo?.firstName, reservation?.customerInfo?.lastName, reservation?.customerInfo?.accountNumber, reservation?.vehicle?.vin, reservation?.vehicle?.color, (0, $4255990f5fa14d45$export$b42757a6b1d6a0e7)(reservation?.vehicle, 'model'), (0, $4255990f5fa14d45$export$b42757a6b1d6a0e7)(reservation?.vehicle, 'make'));
            setIsReservationAppointment(true);
        }
    }, [
        isReservationAppointment
    ]);
    const createAppointment = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (subscriptionId)=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).createAppointment({
                ...appointment,
                subscriptionId: subscriptionId
            });
        },
        onSuccess (data) {
            setAppointment({
                ...appointment,
                id: data?.appointmentId
            });
            setIsEditing(false);
            queryClient.invalidateQueries({
                queryKey: [
                    '/listAppointments',
                    '/listAppointmentsByAccountNumber'
                ]
            });
        },
        // when a double booking response comes back, an error is thrown
        // but the appointment is still created. We must invalidate the queries
        // here as well to have proper refreshed data
        onError () {
            queryClient.invalidateQueries({
                queryKey: [
                    '/listAppointments',
                    '/listAppointmentsByAccountNumber'
                ]
            });
        }
    });
    function buildAppointment(reservationId, customerId, firstName, lastName, accountNumber, vin, color, model, make) {
        setIsEditing(true);
        const customerName = `${firstName} ${lastName}`;
        setAppointment($9eab64c79de53909$var$createInitialAppointment(reservationId, customerId, customerName, accountNumber, vin, color, model, make));
    }
    function closeModal() {
        // this is necessary to 'retrigger' buildAppointment when there is a
        // reservation. On initial opening of the modal, the searchbar is skipped
        // ( as intended ), but on close and reopen it would open the searchbar
        // again. By resetting this, we can ensure the searchbar is always skipped
        // and the reservation is handled as intended.
        if (onReservationPage) setIsReservationAppointment(false);
        setAppointment(undefined);
        createAppointment.reset();
        handleClose();
    }
    return {
        isEditing: isEditing,
        appointment: appointment,
        createAppointment: createAppointment,
        buildAppointment: buildAppointment,
        setAppointment: setAppointment,
        closeModal: closeModal
    };
};
function $9eab64c79de53909$var$createInitialAppointment(reservationId, // subscriptionId: string,
customerId, customerName, accountNumber, vin, color, model, make) {
    return {
        id: '',
        reservationId: reservationId,
        customerId: // subscriptionId,
        customerId,
        customerName: customerName,
        customerAccountNumber: accountNumber,
        location: '',
        dealershipId: 'b1d68de5-0f55-4470-9030-a5d3d7b3d84b',
        // temporarily hardcoded until BE is prepared
        date: new Date(),
        assigneeName: '',
        assigneeId: '',
        note: '',
        noteAuthor: '',
        startTime: 0,
        duration: 60,
        // temporary until BE is prepared
        // below type and status preferred default values are Select placeholders,
        // but MUI doesn't like that. Passing 'undefined' here will result in the correct
        // placeholder, but MUI console error and warnings
        type: (0, $33cc3a71f154a56f$export$1b8a2894869f2463).PICKUP.value,
        typeLabel: (0, $33cc3a71f154a56f$export$1b8a2894869f2463).PICKUP.label,
        status: (0, $33cc3a71f154a56f$export$138aa6476b0a0a10).SCHEDULED.value,
        statusLabel: (0, $33cc3a71f154a56f$export$138aa6476b0a0a10).SCHEDULED.label,
        timeZone: 'America/Los_Angeles',
        // hardcoded as such in BE right now
        notes: [],
        vin: vin,
        color: color,
        make: make,
        model: model
    };
}



parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");


function $6186b1d891198576$export$6fc1085f1a67fc65() {
    const [searchQuery, setSearchQuery] = (0, $acw62.useState)('');
    const [searchResults, setSearchResults] = (0, $acw62.useState)([]);
    const searchReservation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (searchQuery)=>(0, $f647fd23fa4d1073$export$16d7a02b7436f06e).getReservations({
                pageState: '0',
                pageSize: searchQuery.length > 1 ? 1 : 0,
                programId: 'all',
                query: searchQuery,
                clientId: 'default-client-id' // Replace with actual clientId
            }),
        onSuccess (data) {
            const searchResults = [
                ...data.reservationsList
            ].map((listing)=>{
                return {
                    ...listing,
                    label: $6186b1d891198576$export$62492c35643d4b08(listing)
                };
            });
            setSearchResults(searchResults);
        }
    });
    function resetSearch() {
        setSearchResults([]);
        setSearchQuery('');
    }
    return {
        searchQuery: searchQuery,
        setSearchQuery: setSearchQuery,
        isLoading: searchReservation.isPending,
        searchReservation: searchReservation,
        searchResults: searchResults,
        resetSearch: resetSearch
    };
}
function $6186b1d891198576$export$62492c35643d4b08(listing) {
    const { year: year, make: make, model: model, vin: vin, accountNumber: accountNumber } = listing;
    return `${year} ${make} ${model} ${vin} ${accountNumber}`;
}


const $0119578da50b4585$export$79d13b60110f33be = ({ onOptionSelect: onOptionSelect })=>{
    const { isLoading: isLoading, searchQuery: searchQuery, searchReservation: searchReservation, searchResults: searchResults, resetSearch: resetSearch, setSearchQuery: setSearchQuery } = (0, $6186b1d891198576$export$6fc1085f1a67fc65)();
    const { classes: classes } = (0, $6683c169b9a36309$export$8a758d0dd9d6f0d)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db86fcacc6287e65$export$2e2bcd8739ae039), {
        id: "account-number-search",
        open: !!searchResults.length,
        loading: isLoading,
        options: searchResults,
        blurOnSelect: true,
        classes: {
            root: classes.root,
            popper: classes.popper
        },
        clearOnBlur: true,
        inputValue: searchQuery,
        getOptionLabel: (option)=>{
            return option.label;
        },
        renderOption: (props, option)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                className: classes.option,
                onClick: ()=>{
                    onOptionSelect(searchResults.find((result)=>result.accountNumber === option?.accountNumber));
                    resetSearch();
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "caption",
                                children: "Customer Name"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: [
                                    option?.firstName,
                                    " ",
                                    option?.lastName
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "caption",
                                children: "Vin #"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: option?.vin || 'N/A'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "caption",
                                children: "Account #"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: option?.accountNumber || 'N/A'
                            })
                        ]
                    })
                ]
            }, props.id);
        },
        freeSolo: true,
        sx: {
            display: {
                xs: 'none',
                sm: 'flex'
            }
        },
        renderInput: (params)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                ...params,
                autoFocus: true,
                variant: "outlined",
                value: searchQuery,
                placeholder: "Search by Account Number",
                onChange: (evt)=>{
                    setSearchQuery(evt.target.value);
                    searchReservation.mutate(evt.target.value);
                },
                InputProps: {
                    ...params.InputProps,
                    startAdornment: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f6704f80233608$export$2e2bcd8739ae039), {})
                    })
                }
            });
        }
    });
};





const $ebc551e8e2aef5a1$export$7512f38e436d47e7 = ({ modalIsOpen: modalIsOpen, handleClose: handleClose, onReservationPage: onReservationPage, reservation: reservation })=>{
    const { isEditing: isEditing, appointment: appointment, createAppointment: createAppointment, setAppointment: setAppointment, buildAppointment: buildAppointment, closeModal: closeModal } = (0, $9eab64c79de53909$export$b5989a86cdd64d1d)(handleClose, onReservationPage, reservation);
    const getCustomerSubscription = async (customerId)=>{
        try {
            const subscriptionsList = (await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listCustomerSubscriptions(customerId)).subscriptionsList;
            if (!subscriptionsList || subscriptionsList.length === 0) throw new Error('No subscriptions found for customer');
            const activeSubscription = subscriptionsList.find((subscription)=>subscription.status === 'ACTIVE');
            return activeSubscription || subscriptionsList[0];
        } catch (error) {
            console.error('Error fetching customer subscription:', error);
            throw error;
        }
    };
    const createAppointmentRequest = async ()=>{
        if (!appointment.customerId) throw new Error('Customer ID is required');
        try {
            const subscription = await getCustomerSubscription(appointment.customerId);
            createAppointment.mutate(subscription.id);
        } catch (error) {
            console.error('Error creating appointment:', error);
            throw error;
        }
    };
    function getHeaderButtons() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                columnGap: 2,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            color: "primary",
                            onClick: closeModal,
                            children: isEditing ? 'Cancel' : 'Close'
                        })
                    }),
                    isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "contained",
                            color: "primary",
                            disabled: !appointment || !appointment.startTime,
                            onClick: createAppointmentRequest,
                            children: "Save"
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
        open: modalIsOpen,
        onClose: closeModal,
        sx: {
            backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue
        },
        className: "modal-xl",
        "aria-labelledby": "appointment-modal",
        "aria-describedby": "create-appointment-modal",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48a14f90dc08d980$export$89693000420c0acd), {
                heading: "Add New Appointment",
                headerHasBottomBorder: true,
                actionBlock: getHeaderButtons(),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                    wrapperSection: true,
                    children: !appointment ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                        subSection: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            container: true,
                            direction: "column",
                            rowSpacing: 4,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        children: "Please search for an Account number to associate with this appointment"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0119578da50b4585$export$79d13b60110f33be), {
                                        onOptionSelect: ({ reservationId: reservationId, customerId: customerId, firstName: firstName, lastName: lastName, accountNumber: accountNumber, vin: vin, color: color, model: model })=>{
                                            buildAppointment(reservationId, customerId, firstName, lastName, accountNumber, vin, color, model);
                                        }
                                    })
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                        children: createAppointment.isPending ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                width: '100%',
                                textAlign: 'center'
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                            children: [
                                createAppointment.isSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    className: "success",
                                    children: `Appointment ${createAppointment?.data?.appointmentId} created successfully `
                                }),
                                createAppointment.isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    className: "error",
                                    children: createAppointment?.error?.message
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e8aa1c232efdd1e$export$bdee8ff9da1a3299), {
                                    appointment: appointment,
                                    isEditing: isEditing,
                                    setAppointment: setAppointment,
                                    isDriveOffPaid: false
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};


const $cc6d71f55d833bda$export$8edc068b3cbba07f = ({ reservation: reservation })=>{
    const { listAppointments: listAppointments, noOpenAppointments: noOpenAppointments, noListedAppointments: noListedAppointments, isLoading: isLoading, createAppointmentModalIsVisible: createAppointmentModalIsVisible, setCreateAppointmentModalIsVisible: setCreateAppointmentModalIsVisible, handleClose: handleClose } = (0, $f676e8498abab22d$export$83bfe2f5414ae1b2)(reservation.customerInfo.accountNumber);
    const { classes: classes } = $cc6d71f55d833bda$var$useStyles();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                size: {
                    xs: 12
                },
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h3",
                        children: "Appointments"
                    }),
                    (noOpenAppointments || noListedAppointments) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            color: "primary",
                            onClick: ()=>{
                                setCreateAppointmentModalIsVisible(true);
                            },
                            children: "Create"
                        })
                    })
                ]
            }),
            noListedAppointments && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                className: classes.body,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        children: "Appointment not yet scheduled"
                    })
                })
            }),
            listAppointments?.map((listAppointments)=>listAppointments?.appointments?.map((appointment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb6ac201fa409201$export$675aa2c02f1bc1a0), {
                        displayCustomerDetails: false,
                        isLoading: isLoading,
                        appointment: appointment
                    }, appointment?.id))),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc551e8e2aef5a1$export$7512f38e436d47e7), {
                modalIsOpen: createAppointmentModalIsVisible,
                handleClose: handleClose,
                onReservationPage: true,
                reservation: reservation
            })
        ]
    });
};
const $cc6d71f55d833bda$var$useStyles = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()((theme)=>{
    return {
        root: {
            margin: theme.spacing(2, 0, 4, 0),
            width: '100%'
        },
        body: {
            marginTop: 24,
            padding: theme.spacing(3),
            backgroundColor: theme.palette.primary.dark,
            borderRadius: 8
        }
    };
});




var $acw62 = parcelRequire("acw62");





















function $6bdb694b99441ccf$export$837848f5f6cee923(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTooltip', slot);
}
const $6bdb694b99441ccf$var$tooltipClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTooltip', [
    'popper',
    'popperInteractive',
    'popperArrow',
    'popperClose',
    'tooltip',
    'tooltipArrow',
    'touch',
    'tooltipPlacementLeft',
    'tooltipPlacementRight',
    'tooltipPlacementTop',
    'tooltipPlacementBottom',
    'arrow'
]);
var $6bdb694b99441ccf$export$2e2bcd8739ae039 = $6bdb694b99441ccf$var$tooltipClasses;



'use client';
function $0c12c30993373593$var$round(value) {
    return Math.round(value * 1e5) / 1e5;
}
const $0c12c30993373593$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, disableInteractive: disableInteractive, arrow: arrow, touch: touch, placement: placement } = ownerState;
    const slots = {
        popper: [
            'popper',
            !disableInteractive && 'popperInteractive',
            arrow && 'popperArrow'
        ],
        tooltip: [
            'tooltip',
            arrow && 'tooltipArrow',
            touch && 'touch',
            `tooltipPlacement${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(placement.split('-')[0])}`
        ],
        arrow: [
            'arrow'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $6bdb694b99441ccf$export$837848f5f6cee923), classes);
};
const $0c12c30993373593$var$TooltipPopper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $d825775ecf14115c$export$2e2bcd8739ae039), {
    name: 'MuiTooltip',
    slot: 'Popper',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.popper,
            !ownerState.disableInteractive && styles.popperInteractive,
            ownerState.arrow && styles.popperArrow,
            !ownerState.open && styles.popperClose
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        zIndex: (theme.vars || theme).zIndex.tooltip,
        pointerEvents: 'none',
        variants: [
            {
                props: ({ ownerState: ownerState })=>!ownerState.disableInteractive,
                style: {
                    pointerEvents: 'auto'
                }
            },
            {
                props: ({ open: open })=>!open,
                style: {
                    pointerEvents: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    [`&[data-popper-placement*="bottom"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
                        top: 0,
                        marginTop: '-0.71em',
                        '&::before': {
                            transformOrigin: '0 100%'
                        }
                    },
                    [`&[data-popper-placement*="top"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
                        bottom: 0,
                        marginBottom: '-0.71em',
                        '&::before': {
                            transformOrigin: '100% 0'
                        }
                    },
                    [`&[data-popper-placement*="right"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '100% 100%'
                        }
                    },
                    [`&[data-popper-placement*="left"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
                        height: '1em',
                        width: '0.71em',
                        '&::before': {
                            transformOrigin: '0 0'
                        }
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="right"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
                        right: 0,
                        marginRight: '-0.71em'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow && !!ownerState.isRtl,
                style: {
                    [`&[data-popper-placement*="left"] .${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).arrow}`]: {
                        left: 0,
                        marginLeft: '-0.71em'
                    }
                }
            }
        ]
    })));
const $0c12c30993373593$var$TooltipTooltip = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTooltip',
    slot: 'Tooltip',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.tooltip,
            ownerState.touch && styles.touch,
            ownerState.arrow && styles.tooltipArrow,
            styles[`tooltipPlacement${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.placement.split('-')[0])}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        backgroundColor: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.92),
        borderRadius: (theme.vars || theme).shape.borderRadius,
        color: (theme.vars || theme).palette.common.white,
        fontFamily: theme.typography.fontFamily,
        padding: '4px 8px',
        fontSize: theme.typography.pxToRem(11),
        maxWidth: 300,
        margin: 2,
        wordWrap: 'break-word',
        fontWeight: theme.typography.fontWeightMedium,
        [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
            transformOrigin: 'right center'
        },
        [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
            transformOrigin: 'left center'
        },
        [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
            transformOrigin: 'center bottom',
            marginBottom: '14px'
        },
        [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
            transformOrigin: 'center top',
            marginTop: '14px'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.arrow,
                style: {
                    position: 'relative',
                    margin: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    padding: '8px 16px',
                    fontSize: theme.typography.pxToRem(14),
                    lineHeight: `${$0c12c30993373593$var$round(16 / 14)}em`,
                    fontWeight: theme.typography.fontWeightRegular
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl,
                style: {
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '14px'
                    },
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginRight: '24px'
                    },
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginLeft: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl,
                style: {
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '14px'
                    },
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '14px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>!!ownerState.isRtl && ownerState.touch,
                style: {
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="left"] &`]: {
                        marginLeft: '24px'
                    },
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="right"] &`]: {
                        marginRight: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="top"] &`]: {
                        marginBottom: '24px'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.touch,
                style: {
                    [`.${(0, $6bdb694b99441ccf$export$2e2bcd8739ae039).popper}[data-popper-placement*="bottom"] &`]: {
                        marginTop: '24px'
                    }
                }
            }
        ]
    })));
const $0c12c30993373593$var$TooltipArrow = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiTooltip',
    slot: 'Arrow'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        position: 'absolute',
        width: '1em',
        height: '0.71em' /* = width / sqrt(2) = (length of the hypotenuse) */ ,
        boxSizing: 'border-box',
        color: theme.vars ? theme.vars.palette.Tooltip.bg : theme.alpha(theme.palette.grey[700], 0.9),
        '&::before': {
            content: '""',
            margin: 'auto',
            display: 'block',
            width: '100%',
            height: '100%',
            backgroundColor: 'currentColor',
            transform: 'rotate(45deg)'
        }
    })));
let $0c12c30993373593$var$hystersisOpen = false;
const $0c12c30993373593$var$hystersisTimer = new (0, $fcd4c6205d65c7df$export$786b4da70f00938b)();
let $0c12c30993373593$var$cursorPosition = {
    x: 0,
    y: 0
};
function $0c12c30993373593$export$b9ee5a7ace0541f8() {
    $0c12c30993373593$var$hystersisOpen = false;
    $0c12c30993373593$var$hystersisTimer.clear();
}
function $0c12c30993373593$var$composeEventHandler(handler, eventHandler) {
    return (event, ...params)=>{
        if (eventHandler) eventHandler(event, ...params);
        handler(event, ...params);
    };
}
// TODO v6: Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.
const $0c12c30993373593$var$Tooltip = /*#__PURE__*/ $acw62.forwardRef(function Tooltip(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTooltip'
    });
    const { arrow: arrow = false, children: childrenProp, classes: classesProp, components: components = {}, componentsProps: componentsProps = {}, describeChild: describeChild = false, disableFocusListener: disableFocusListener = false, disableHoverListener: disableHoverListener = false, disableInteractive: disableInteractiveProp = false, disableTouchListener: disableTouchListener = false, enterDelay: enterDelay = 100, enterNextDelay: enterNextDelay = 0, enterTouchDelay: enterTouchDelay = 700, followCursor: followCursor = false, id: idProp, leaveDelay: leaveDelay = 0, leaveTouchDelay: leaveTouchDelay = 1500, onClose: onClose, onOpen: onOpen, open: openProp, placement: placement = 'bottom', PopperComponent: PopperComponentProp, PopperProps: PopperProps = {}, slotProps: slotProps = {}, slots: slots = {}, title: title, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionProps, ...other } = props;
    // to prevent runtime errors, developers will need to provide a child as a React element anyway.
    const children = /*#__PURE__*/ $acw62.isValidElement(childrenProp) ? childrenProp : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        children: childrenProp
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const [childNode, setChildNode] = $acw62.useState();
    const [arrowRef, setArrowRef] = $acw62.useState(null);
    const ignoreNonTouchEvents = $acw62.useRef(false);
    const disableInteractive = disableInteractiveProp || followCursor;
    const closeTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const enterTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const leaveTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const touchTimer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const [openState, setOpenState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: openProp,
        default: false,
        name: 'Tooltip',
        state: 'open'
    });
    let open = openState;
    const id = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(idProp);
    const prevUserSelect = $acw62.useRef();
    const stopTouchInteraction = (0, $52726edc538865d0$export$2e2bcd8739ae039)(()=>{
        if (prevUserSelect.current !== undefined) {
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            prevUserSelect.current = undefined;
        }
        touchTimer.clear();
    });
    $acw62.useEffect(()=>stopTouchInteraction, [
        stopTouchInteraction
    ]);
    const handleOpen = (event)=>{
        $0c12c30993373593$var$hystersisTimer.clear();
        $0c12c30993373593$var$hystersisOpen = true;
        // The mouseover event will trigger for every nested element in the tooltip.
        // We can skip rerendering when the tooltip is already open.
        // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
        setOpenState(true);
        if (onOpen && !open) onOpen(event);
    };
    const handleClose = (0, $52726edc538865d0$export$2e2bcd8739ae039)(/**
   * @param {React.SyntheticEvent | Event} event
   */ (event)=>{
        $0c12c30993373593$var$hystersisTimer.start(800 + leaveDelay, ()=>{
            $0c12c30993373593$var$hystersisOpen = false;
        });
        setOpenState(false);
        if (onClose && open) onClose(event);
        closeTimer.start(theme.transitions.duration.shortest, ()=>{
            ignoreNonTouchEvents.current = false;
        });
    });
    const handleMouseOver = (event)=>{
        if (ignoreNonTouchEvents.current && event.type !== 'touchstart') return;
        // Remove the title ahead of time.
        // We don't want to wait for the next render commit.
        // We would risk displaying two tooltips at the same time (native + this one).
        if (childNode) childNode.removeAttribute('title');
        enterTimer.clear();
        leaveTimer.clear();
        if (enterDelay || $0c12c30993373593$var$hystersisOpen && enterNextDelay) enterTimer.start($0c12c30993373593$var$hystersisOpen ? enterNextDelay : enterDelay, ()=>{
            handleOpen(event);
        });
        else handleOpen(event);
    };
    const handleMouseLeave = (event)=>{
        enterTimer.clear();
        leaveTimer.start(leaveDelay, ()=>{
            handleClose(event);
        });
    };
    const [, setChildIsFocusVisible] = $acw62.useState(false);
    const handleBlur = (event)=>{
        if (!(0, $3abd7e3358fc5f35$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(false);
            handleMouseLeave(event);
        }
    };
    const handleFocus = (event)=>{
        // Workaround for https://github.com/facebook/react/issues/7769
        // The autoFocus of React might trigger the event before the componentDidMount.
        // We need to account for this eventuality.
        if (!childNode) setChildNode(event.currentTarget);
        if ((0, $3abd7e3358fc5f35$export$2e2bcd8739ae039)(event.target)) {
            setChildIsFocusVisible(true);
            handleMouseOver(event);
        }
    };
    const detectTouchStart = (event)=>{
        ignoreNonTouchEvents.current = true;
        const childrenProps = children.props;
        if (childrenProps.onTouchStart) childrenProps.onTouchStart(event);
    };
    const handleTouchStart = (event)=>{
        detectTouchStart(event);
        leaveTimer.clear();
        closeTimer.clear();
        stopTouchInteraction();
        prevUserSelect.current = document.body.style.WebkitUserSelect;
        // Prevent iOS text selection on long-tap.
        document.body.style.WebkitUserSelect = 'none';
        touchTimer.start(enterTouchDelay, ()=>{
            document.body.style.WebkitUserSelect = prevUserSelect.current;
            handleMouseOver(event);
        });
    };
    const handleTouchEnd = (event)=>{
        if (children.props.onTouchEnd) children.props.onTouchEnd(event);
        stopTouchInteraction();
        leaveTimer.start(leaveTouchDelay, ()=>{
            handleClose(event);
        });
    };
    $acw62.useEffect(()=>{
        if (!open) return undefined;
        /**
     * @param {KeyboardEvent} nativeEvent
     */ function handleKeyDown(nativeEvent) {
            if (nativeEvent.key === 'Escape') handleClose(nativeEvent);
        }
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        handleClose,
        open
    ]);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)((0, $1d88113360503233$export$2e2bcd8739ae039)(children), setChildNode, ref);
    // There is no point in displaying an empty tooltip.
    // So we exclude all falsy values, except 0, which is valid.
    if (!title && title !== 0) open = false;
    const popperRef = $acw62.useRef();
    const handleMouseMove = (event)=>{
        const childrenProps = children.props;
        if (childrenProps.onMouseMove) childrenProps.onMouseMove(event);
        $0c12c30993373593$var$cursorPosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (popperRef.current) popperRef.current.update();
    };
    const nameOrDescProps = {};
    const titleIsString = typeof title === 'string';
    if (describeChild) {
        nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
        nameOrDescProps['aria-describedby'] = open ? id : null;
    } else {
        nameOrDescProps['aria-label'] = titleIsString ? title : null;
        nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
    }
    const childrenProps = {
        ...nameOrDescProps,
        ...other,
        ...children.props,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(other.className, children.props.className),
        onTouchStart: detectTouchStart,
        ref: handleRef,
        ...followCursor ? {
            onMouseMove: handleMouseMove
        } : {}
    };
    const interactiveWrapperListeners = {};
    if (!disableTouchListener) {
        childrenProps.onTouchStart = handleTouchStart;
        childrenProps.onTouchEnd = handleTouchEnd;
    }
    if (!disableHoverListener) {
        childrenProps.onMouseOver = $0c12c30993373593$var$composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
        childrenProps.onMouseLeave = $0c12c30993373593$var$composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);
        if (!disableInteractive) {
            interactiveWrapperListeners.onMouseOver = handleMouseOver;
            interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
        }
    }
    if (!disableFocusListener) {
        childrenProps.onFocus = $0c12c30993373593$var$composeEventHandler(handleFocus, childrenProps.onFocus);
        childrenProps.onBlur = $0c12c30993373593$var$composeEventHandler(handleBlur, childrenProps.onBlur);
        if (!disableInteractive) {
            interactiveWrapperListeners.onFocus = handleFocus;
            interactiveWrapperListeners.onBlur = handleBlur;
        }
    }
    const ownerState = {
        ...props,
        isRtl: isRtl,
        arrow: arrow,
        disableInteractive: disableInteractive,
        placement: placement,
        PopperComponentProp: PopperComponentProp,
        touch: ignoreNonTouchEvents.current
    };
    const resolvedPopperProps = typeof slotProps.popper === 'function' ? slotProps.popper(ownerState) : slotProps.popper;
    const popperOptions = $acw62.useMemo(()=>{
        let tooltipModifiers = [
            {
                name: 'arrow',
                enabled: Boolean(arrowRef),
                options: {
                    element: arrowRef,
                    padding: 4
                }
            }
        ];
        if (PopperProps.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
        if (resolvedPopperProps?.popperOptions?.modifiers) tooltipModifiers = tooltipModifiers.concat(resolvedPopperProps.popperOptions.modifiers);
        return {
            ...PopperProps.popperOptions,
            ...resolvedPopperProps?.popperOptions,
            modifiers: tooltipModifiers
        };
    }, [
        arrowRef,
        PopperProps.popperOptions,
        resolvedPopperProps?.popperOptions
    ]);
    const classes = $0c12c30993373593$var$useUtilityClasses(ownerState);
    const resolvedTransitionProps = typeof slotProps.transition === 'function' ? slotProps.transition(ownerState) : slotProps.transition;
    const externalForwardedProps = {
        slots: {
            popper: components.Popper,
            transition: components.Transition ?? TransitionComponentProp,
            tooltip: components.Tooltip,
            arrow: components.Arrow,
            ...slots
        },
        slotProps: {
            arrow: slotProps.arrow ?? componentsProps.arrow,
            popper: {
                ...PopperProps,
                ...resolvedPopperProps ?? componentsProps.popper
            },
            // resolvedPopperProps can be spread because it's already an object
            tooltip: slotProps.tooltip ?? componentsProps.tooltip,
            transition: {
                ...TransitionProps,
                ...resolvedTransitionProps ?? componentsProps.transition
            }
        }
    };
    const [PopperSlot, popperSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('popper', {
        elementType: $0c12c30993373593$var$TooltipPopper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.popper, PopperProps?.className)
    });
    const [TransitionSlot, transitionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $5a8449c70e836e71$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [TooltipSlot, tooltipSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('tooltip', {
        elementType: $0c12c30993373593$var$TooltipTooltip,
        className: classes.tooltip,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ArrowSlot, arrowSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('arrow', {
        elementType: $0c12c30993373593$var$TooltipArrow,
        className: classes.arrow,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        ref: setArrowRef
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ $acw62.cloneElement(children, childrenProps),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PopperSlot, {
                as: PopperComponentProp ?? (0, $d825775ecf14115c$export$2e2bcd8739ae039),
                placement: placement,
                anchorEl: followCursor ? {
                    getBoundingClientRect: ()=>({
                            top: $0c12c30993373593$var$cursorPosition.y,
                            left: $0c12c30993373593$var$cursorPosition.x,
                            right: $0c12c30993373593$var$cursorPosition.x,
                            bottom: $0c12c30993373593$var$cursorPosition.y,
                            width: 0,
                            height: 0
                        })
                } : childNode,
                popperRef: popperRef,
                open: childNode ? open : false,
                id: id,
                transition: true,
                ...interactiveWrapperListeners,
                ...popperSlotProps,
                popperOptions: popperOptions,
                children: ({ TransitionProps: TransitionPropsInner })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionSlot, {
                        timeout: theme.transitions.duration.shorter,
                        ...TransitionPropsInner,
                        ...transitionSlotProps,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(TooltipSlot, {
                            ...tooltipSlotProps,
                            children: [
                                title,
                                arrow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ArrowSlot, {
                                    ...arrowSlotProps
                                }) : null
                            ]
                        })
                    })
            })
        ]
    });
});
var $0c12c30993373593$export$2e2bcd8739ae039 = $0c12c30993373593$var$Tooltip;




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
var $9de1b976e3511f42$export$2e2bcd8739ae039 = parseInt($acw62.version, 10);


const $c2e72fc2a32cb61d$export$257a8862b851cb5b = (render)=>{
    if ((0, $9de1b976e3511f42$export$2e2bcd8739ae039) >= 19) {
        const Component = (props)=>render(props, props.ref ?? null);
        Component.displayName = render.displayName ?? render.name;
        return Component;
    }
    return /*#__PURE__*/ $acw62.forwardRef(render);
};





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");
const $89c6d962740be425$var$is = Object.is;
function $89c6d962740be425$export$84d14f151b531ccb(a, b) {
    if (a === b) return true;
    if (!(a instanceof Object) || !(b instanceof Object)) return false;
    let aLength = 0;
    let bLength = 0;
    /* eslint-disable guard-for-in */ for(const key in a){
        aLength += 1;
        if (!$89c6d962740be425$var$is(a[key], b[key])) return false;
        if (!(key in b)) return false;
    }
    /* eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars */ for(const _ in b)bLength += 1;
    return aLength === bLength;
}


function $f39f4e89b691584e$export$fa306e0bc9a9d6b4(component) {
    return /*#__PURE__*/ $acw62.memo(component, (0, $89c6d962740be425$export$84d14f151b531ccb));
}






function $59e5f6b0ce3da023$export$a2aa36217b862c23(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDataGrid', slot);
}
const $59e5f6b0ce3da023$export$2100d54e36406477 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDataGrid', [
    'aiAssistantPanel',
    'aiAssistantPanelHeader',
    'aiAssistantPanelTitleContainer',
    'aiAssistantPanelTitle',
    'aiAssistantPanelBody',
    'aiAssistantPanelEmptyText',
    'aiAssistantPanelFooter',
    'aiAssistantPanelConversation',
    'aiAssistantPanelConversationList',
    'aiAssistantPanelConversationTitle',
    'aiAssistantPanelSuggestions',
    'aiAssistantPanelSuggestionsList',
    'aiAssistantPanelSuggestionsItem',
    'aiAssistantPanelSuggestionsLabel',
    'actionsCell',
    'aggregationColumnHeader',
    'aggregationColumnHeader--alignLeft',
    'aggregationColumnHeader--alignCenter',
    'aggregationColumnHeader--alignRight',
    'aggregationColumnHeaderLabel',
    'aggregationRowOverlayWrapper',
    'autoHeight',
    'autosizing',
    'mainContent',
    'withSidePanel',
    'booleanCell',
    'cell--editable',
    'cell--editing',
    'cell--flex',
    'cell--textCenter',
    'cell--textLeft',
    'cell--textRight',
    'cell--rangeTop',
    'cell--rangeBottom',
    'cell--rangeLeft',
    'cell--rangeRight',
    'cell--pinnedLeft',
    'cell--pinnedRight',
    'cell--selectionMode',
    'cell',
    'cellCheckbox',
    'cellEmpty',
    'cellSkeleton',
    'cellOffsetLeft',
    'checkboxInput',
    'collapsible',
    'collapsibleTrigger',
    'collapsibleIcon',
    'collapsiblePanel',
    'columnHeader',
    'columnHeader--alignCenter',
    'columnHeader--alignLeft',
    'columnHeader--alignRight',
    'columnHeader--dragging',
    'columnHeader--moving',
    'columnHeader--numeric',
    'columnHeader--sortable',
    'columnHeader--sorted',
    'columnHeader--filtered',
    'columnHeader--pinnedLeft',
    'columnHeader--pinnedRight',
    'columnHeader--last',
    'columnHeader--siblingFocused',
    'columnHeader--filter',
    'columnHeaderFilterInput',
    'columnHeaderFilterOperatorLabel',
    'columnHeaderCheckbox',
    'columnHeaderDraggableContainer',
    'columnHeaderTitle',
    'columnHeaderTitleContainer',
    'columnHeaderTitleContainerContent',
    'columnHeader--filledGroup',
    'columnHeader--emptyGroup',
    'columnHeaders',
    'columnSeparator--resizable',
    'columnSeparator--resizing',
    'columnSeparator--sideLeft',
    'columnSeparator--sideRight',
    'columnSeparator',
    'columnsManagement',
    'columnsManagementRow',
    'columnsManagementHeader',
    'columnsManagementSearchInput',
    'columnsManagementFooter',
    'columnsManagementScrollArea',
    'columnsManagementEmptyText',
    'container--top',
    'container--bottom',
    'detailPanel',
    'detailPanelToggleCell',
    'detailPanelToggleCell--expanded',
    'footerCell',
    'panel',
    'panelHeader',
    'panelWrapper',
    'panelContent',
    'panelFooter',
    'paper',
    'editBooleanCell',
    'editInputCell',
    'filler',
    'filler--borderBottom',
    'filler--pinnedLeft',
    'filler--pinnedRight',
    'filterForm',
    'filterFormDeleteIcon',
    'filterFormLogicOperatorInput',
    'filterFormColumnInput',
    'filterFormOperatorInput',
    'filterFormValueInput',
    'filterIcon',
    'footerContainer',
    'headerFilterRow',
    'iconButtonContainer',
    'iconSeparator',
    'main',
    'main--hasPinnedRight',
    'main--hiddenContent',
    'menu',
    'menuIcon',
    'menuIconButton',
    'menuOpen',
    'menuList',
    'overlay',
    'overlayWrapper',
    'overlayWrapperInner',
    'root',
    'root--densityStandard',
    'root--densityComfortable',
    'root--densityCompact',
    'root--disableUserSelection',
    'root--noToolbar',
    'row',
    'row--editable',
    'row--editing',
    'row--firstVisible',
    'row--lastVisible',
    // TODO v9: Rename to `cell--dragging`
    'row--dragging',
    'row--dropAbove',
    'row--dropBelow',
    'row--beingDragged',
    'row--dynamicHeight',
    'row--detailPanelExpanded',
    'row--borderBottom',
    'rowReorderCellPlaceholder',
    'rowCount',
    'rowReorderCellContainer',
    'rowReorderCell',
    'rowReorderCell--draggable',
    'rowReorderIcon',
    'rowSkeleton',
    'scrollArea--left',
    'scrollArea--right',
    'scrollArea--up',
    'scrollArea--down',
    'scrollArea',
    'scrollbar',
    'scrollbar--vertical',
    'scrollbar--horizontal',
    'scrollbarFiller',
    'scrollbarFiller--pinnedRight',
    'scrollShadow',
    'scrollShadow--vertical',
    'scrollShadow--horizontal',
    'selectedRowCount',
    'sortButton',
    'sortIcon',
    'shadowScrollArea',
    'sidebar',
    'sidebarHeader',
    'toolbarContainer',
    'toolbar',
    'toolbarLabel',
    'toolbarDivider',
    'toolbarFilterList',
    'toolbarQuickFilter',
    'toolbarQuickFilterTrigger',
    'toolbarQuickFilterControl',
    'virtualScroller',
    'virtualScroller--hasScrollX',
    'virtualScrollerContent',
    'virtualScrollerContent--overflowed',
    'virtualScrollerRenderZone',
    'withVerticalBorder',
    'withBorderColor',
    'cell--withRightBorder',
    'cell--withLeftBorder',
    'columnHeader--withRightBorder',
    'columnHeader--withLeftBorder',
    'treeDataGroupingCell',
    'treeDataGroupingCellToggle',
    'treeDataGroupingCellLoadingContainer',
    'groupingCriteriaCell',
    'groupingCriteriaCellToggle',
    'groupingCriteriaCellLoadingContainer',
    'pinnedRows',
    'pinnedRows--top',
    'pinnedRows--bottom',
    'pivotPanelAvailableFields',
    'pivotPanelField',
    'pivotPanelField--sorted',
    'pivotPanelFieldActionContainer',
    'pivotPanelFieldCheckbox',
    'pivotPanelFieldDragIcon',
    'pivotPanelFieldList',
    'pivotPanelFieldName',
    'pivotPanelHeader',
    'pivotPanelPlaceholder',
    'pivotPanelScrollArea',
    'pivotPanelSearchContainer',
    'pivotPanelSection',
    'pivotPanelSectionTitle',
    'pivotPanelSections',
    'pivotPanelSwitch',
    'pivotPanelSwitchLabel',
    'prompt',
    'promptContent',
    'promptText',
    'promptFeedback',
    'promptChangeList',
    'promptChangesToggle',
    'promptChangesToggleIcon',
    'promptIcon',
    'promptIconContainer',
    'promptError',
    'promptAction'
]);



// NOTE: Breakpoints can't come from the theme because we need access to them at
// initialization time and media-queries can't use CSS variables. For users with
// custom breakpoints, we might want to provide a way to configure them globally
// instead of through the theme.
const $ee6c62dfac1c40eb$var$breakpoints = {
    values: {
        xs: 0,
        // phone
        sm: 600,
        // tablet
        md: 900,
        // small laptop
        lg: 1200,
        // desktop
        xl: 1536 // large screen
    },
    up: (key)=>{
        const values = $ee6c62dfac1c40eb$var$breakpoints.values;
        const value = typeof values[key] === 'number' ? values[key] : key;
        return `@media (min-width:${value}px)`;
    }
};
const $ee6c62dfac1c40eb$var$keys = {
    spacingUnit: '--DataGrid-t-spacing-unit',
    /* Variables */ colors: {
        border: {
            base: '--DataGrid-t-color-border-base'
        },
        foreground: {
            base: '--DataGrid-t-color-foreground-base',
            muted: '--DataGrid-t-color-foreground-muted',
            accent: '--DataGrid-t-color-foreground-accent',
            disabled: '--DataGrid-t-color-foreground-disabled',
            error: '--DataGrid-t-color-foreground-error'
        },
        background: {
            base: '--DataGrid-t-color-background-base',
            overlay: '--DataGrid-t-color-background-overlay',
            backdrop: '--DataGrid-t-color-background-backdrop'
        },
        interactive: {
            hover: '--DataGrid-t-color-interactive-hover',
            hoverOpacity: '--DataGrid-t-color-interactive-hover-opacity',
            focus: '--DataGrid-t-color-interactive-focus',
            focusOpacity: '--DataGrid-t-color-interactive-focus-opacity',
            disabled: '--DataGrid-t-color-interactive-disabled',
            disabledOpacity: '--DataGrid-t-color-interactive-disabled-opacity',
            selected: '--DataGrid-t-color-interactive-selected',
            selectedOpacity: '--DataGrid-t-color-interactive-selected-opacity'
        }
    },
    header: {
        background: {
            base: '--DataGrid-t-header-background-base'
        }
    },
    cell: {
        background: {
            pinned: '--DataGrid-t-cell-background-pinned'
        }
    },
    radius: {
        base: '--DataGrid-t-radius-base'
    },
    typography: {
        font: {
            body: '--DataGrid-t-typography-font-body',
            small: '--DataGrid-t-typography-font-small',
            large: '--DataGrid-t-typography-font-large'
        },
        fontFamily: {
            base: '--DataGrid-t-typography-font-family-base'
        },
        fontWeight: {
            light: '--DataGrid-t-typography-font-weight-light',
            regular: '--DataGrid-t-typography-font-weight-regular',
            medium: '--DataGrid-t-typography-font-weight-medium',
            bold: '--DataGrid-t-typography-font-weight-bold'
        }
    },
    transitions: {
        easing: {
            easeIn: '--DataGrid-t-transition-easing-ease-in',
            easeOut: '--DataGrid-t-transition-easing-ease-out',
            easeInOut: '--DataGrid-t-transition-easing-ease-in-out'
        },
        duration: {
            short: '--DataGrid-t-transition-duration-short',
            base: '--DataGrid-t-transition-duration-base',
            long: '--DataGrid-t-transition-duration-long'
        }
    },
    shadows: {
        base: '--DataGrid-t-shadow-base',
        overlay: '--DataGrid-t-shadow-overlay'
    },
    zIndex: {
        panel: '--DataGrid-t-z-index-panel',
        menu: '--DataGrid-t-z-index-menu'
    }
};
const $ee6c62dfac1c40eb$var$values = $ee6c62dfac1c40eb$var$wrap($ee6c62dfac1c40eb$var$keys);
const $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
    breakpoints: $ee6c62dfac1c40eb$var$breakpoints,
    spacing: $ee6c62dfac1c40eb$var$spacing,
    transition: $ee6c62dfac1c40eb$var$transition,
    keys: $ee6c62dfac1c40eb$var$keys
}, $ee6c62dfac1c40eb$var$values);
function $ee6c62dfac1c40eb$var$spacing(a, b, c, d) {
    /* eslint-disable prefer-template */ if (a === undefined) return $ee6c62dfac1c40eb$var$spacingString(1);
    if (b === undefined) return $ee6c62dfac1c40eb$var$spacingString(a);
    if (c === undefined) return $ee6c62dfac1c40eb$var$spacingString(a) + ' ' + $ee6c62dfac1c40eb$var$spacingString(b);
    if (d === undefined) return $ee6c62dfac1c40eb$var$spacingString(a) + ' ' + $ee6c62dfac1c40eb$var$spacingString(b) + ' ' + $ee6c62dfac1c40eb$var$spacingString(c);
    return $ee6c62dfac1c40eb$var$spacingString(a) + ' ' + $ee6c62dfac1c40eb$var$spacingString(b) + ' ' + $ee6c62dfac1c40eb$var$spacingString(c) + ' ' + $ee6c62dfac1c40eb$var$spacingString(d);
/* eslint-enable prefer-template */ }
function $ee6c62dfac1c40eb$var$spacingString(value) {
    if (value === 0) return '0';
    return `calc(var(--DataGrid-t-spacing-unit) * ${value})`;
}
function $ee6c62dfac1c40eb$var$transition(props, options) {
    const { duration: duration = $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4.transitions.duration.base, easing: easing = $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4.transitions.easing.easeInOut, delay: delay = 0 } = options ?? {};
    return props.map((prop)=>`${prop} ${duration} ${easing} ${delay}ms`).join(', ');
}
function $ee6c62dfac1c40eb$var$wrap(input) {
    if (typeof input === 'string') return `var(${input})`;
    const result = {};
    for(const key in input)if (Object.hasOwn(input, key)) result[key] = $ee6c62dfac1c40eb$var$wrap(input[key]);
    return result;
}



var $acw62 = parcelRequire("acw62");



var $hfliI = parcelRequire("hfliI");

'use client';
const $ef323e860abde413$var$defaultCompare = Object.is;
const $ef323e860abde413$export$8da4c691e5695191 = (0, $89c6d962740be425$export$84d14f151b531ccb);
const $ef323e860abde413$var$arrayShallowCompare = (a, b)=>{
    if (a === b) return true;
    return a.length === b.length && a.every((v, i)=>v === b[i]);
};
const $ef323e860abde413$export$5a7c3a25f6dab637 = (prev, curr)=>{
    let fn = Object.is;
    if (curr instanceof Array) fn = $ef323e860abde413$var$arrayShallowCompare;
    else if (curr instanceof Object) fn = $ef323e860abde413$export$8da4c691e5695191;
    return fn(prev, curr);
};
const $ef323e860abde413$var$createRefs = ()=>({
        state: null,
        equals: null,
        selector: null,
        args: undefined
    });
const $ef323e860abde413$var$EMPTY = [];
const $ef323e860abde413$var$emptyGetSnapshot = ()=>null;
function $ef323e860abde413$export$f96fd476863f2e4a(apiRef, selector, args, equals = $ef323e860abde413$var$defaultCompare) {
    const refs = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($ef323e860abde413$var$createRefs);
    const didInit = refs.current.selector !== null;
    const [state, setState] = $acw62.useState(// We don't use an initialization function to avoid allocations
    didInit ? null : selector(apiRef, args));
    refs.current.state = state;
    refs.current.equals = equals;
    refs.current.selector = selector;
    const prevArgs = refs.current.args;
    refs.current.args = args;
    if (didInit && !$ef323e860abde413$export$5a7c3a25f6dab637(prevArgs, args)) {
        const newState = refs.current.selector(apiRef, refs.current.args);
        if (!refs.current.equals(refs.current.state, newState)) {
            refs.current.state = newState;
            setState(newState);
        }
    }
    const subscribe = $acw62.useCallback(()=>{
        if (refs.current.subscription) return null;
        refs.current.subscription = apiRef.current.store.subscribe(()=>{
            const newState = refs.current.selector(apiRef, refs.current.args);
            if (!refs.current.equals(refs.current.state, newState)) {
                refs.current.state = newState;
                setState(newState);
            }
        });
        return null;
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    $ef323e860abde413$var$EMPTY);
    const unsubscribe = $acw62.useCallback(()=>{
        // Fixes issue in React Strict Mode, where getSnapshot is not called
        if (!refs.current.subscription) subscribe();
        return ()=>{
            if (refs.current.subscription) {
                refs.current.subscription();
                refs.current.subscription = undefined;
            }
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $ef323e860abde413$var$EMPTY);
    (0, $hfliI.useSyncExternalStore)(unsubscribe, subscribe, $ef323e860abde413$var$emptyGetSnapshot);
    return state;
}



var $acw62 = parcelRequire("acw62");
'use client';
const $caa6246df345d6fe$export$37099e7a34cbf988 = /*#__PURE__*/ $acw62.createContext(undefined);
function $caa6246df345d6fe$export$e1fd9274eb96ee18() {
    const privateApiRef = $acw62.useContext($caa6246df345d6fe$export$37099e7a34cbf988);
    if (privateApiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid private context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return privateApiRef;
}


const $c0a4879b2d654e0c$var$columnSeparatorTargetSize = 10;
const $c0a4879b2d654e0c$var$columnSeparatorOffset = -5;
const $c0a4879b2d654e0c$var$focusOutlineWidth = 1;
const $c0a4879b2d654e0c$var$separatorIconDragStyles = {
    width: 3,
    rx: 1.5,
    x: 10.5
};
// Emotion thinks it knows better than us which selector we should use.
// https://github.com/emotion-js/emotion/issues/1105#issuecomment-1722524968
const $c0a4879b2d654e0c$var$ignoreSsrWarning = '/* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */';
const $c0a4879b2d654e0c$var$shouldShowBorderTopRightRadiusSelector = (apiRef)=>apiRef.current.state.dimensions.hasScrollX && (!apiRef.current.state.dimensions.hasScrollY || apiRef.current.state.dimensions.scrollbarSize === 0);
const $c0a4879b2d654e0c$export$42458c7ae3a97297 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Root',
    overridesResolver: (props, styles)=>[
            // Root overrides
            styles.root,
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).autoHeight}`]: styles.autoHeight
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).autosizing}`]: styles.autosizing
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['root--densityStandard']}`]: styles['root--densityStandard']
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['root--densityComfortable']}`]: styles['root--densityComfortable']
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['root--densityCompact']}`]: styles['root--densityCompact']
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['root--disableUserSelection']}`]: styles['root--disableUserSelection']
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['root--noToolbar']}`]: styles['root--noToolbar']
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).withVerticalBorder}`]: styles.withVerticalBorder
            },
            // Child element overrides
            // - Only declare overrides here for class names that are not applied to `styled` components.
            // - For `styled` components, declare overrides in the component itself.
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).actionsCell}`]: styles.actionsCell
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).booleanCell}`]: styles.booleanCell
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`]: styles.cell
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--editable']}`]: styles['cell--editable']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--editing']}`]: styles['cell--editing']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--flex']}`]: styles['cell--flex']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedLeft']}`]: styles['cell--pinnedLeft']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedRight']}`]: styles['cell--pinnedRight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--rangeBottom']}`]: styles['cell--rangeBottom']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--rangeLeft']}`]: styles['cell--rangeLeft']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--rangeRight']}`]: styles['cell--rangeRight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--rangeTop']}`]: styles['cell--rangeTop']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--selectionMode']}`]: styles['cell--selectionMode']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--textCenter']}`]: styles['cell--textCenter']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--textLeft']}`]: styles['cell--textLeft']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--textRight']}`]: styles['cell--textRight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--withLeftBorder']}`]: styles['cell--withLeftBorder']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--withRightBorder']}`]: styles['cell--withRightBorder']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cellCheckbox}`]: styles.cellCheckbox
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cellEmpty}`]: styles.cellEmpty
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cellOffsetLeft}`]: styles.cellOffsetLeft
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cellSkeleton}`]: styles.cellSkeleton
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).checkboxInput}`]: styles.checkboxInput
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}`]: styles.columnHeader
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--alignCenter']}`]: styles['columnHeader--alignCenter']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--alignLeft']}`]: styles['columnHeader--alignLeft']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--alignRight']}`]: styles['columnHeader--alignRight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--dragging']}`]: styles['columnHeader--dragging']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--emptyGroup']}`]: styles['columnHeader--emptyGroup']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--filledGroup']}`]: styles['columnHeader--filledGroup']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--filtered']}`]: styles['columnHeader--filtered']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--last']}`]: styles['columnHeader--last']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--moving']}`]: styles['columnHeader--moving']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--numeric']}`]: styles['columnHeader--numeric']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--pinnedLeft']}`]: styles['columnHeader--pinnedLeft']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--pinnedRight']}`]: styles['columnHeader--pinnedRight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--siblingFocused']}`]: styles['columnHeader--siblingFocused']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--sortable']}`]: styles['columnHeader--sortable']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--sorted']}`]: styles['columnHeader--sorted']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withLeftBorder']}`]: styles['columnHeader--withLeftBorder']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withRightBorder']}`]: styles['columnHeader--withRightBorder']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderCheckbox}`]: styles.columnHeaderCheckbox
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderDraggableContainer}`]: styles.columnHeaderDraggableContainer
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainer}`]: styles.columnHeaderTitleContainer
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainerContent}`]: styles.columnHeaderTitleContainerContent
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnSeparator}`]: styles.columnSeparator
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable']}`]: styles['columnSeparator--resizable']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizing']}`]: styles['columnSeparator--resizing']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideLeft']}`]: styles['columnSeparator--sideLeft']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideRight']}`]: styles['columnSeparator--sideRight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['container--bottom']}`]: styles['container--bottom']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['container--top']}`]: styles['container--top']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).detailPanelToggleCell}`]: styles.detailPanelToggleCell
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['detailPanelToggleCell--expanded']}`]: styles['detailPanelToggleCell--expanded']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).editBooleanCell}`]: styles.editBooleanCell
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).filterIcon}`]: styles.filterIcon
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['filler--borderBottom']}`]: styles['filler--borderBottom']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['filler--pinnedLeft']}`]: styles['filler--pinnedLeft']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['filler--pinnedRight']}`]: styles['filler--pinnedRight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).groupingCriteriaCell}`]: styles.groupingCriteriaCell
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).groupingCriteriaCellLoadingContainer}`]: styles.groupingCriteriaCellLoadingContainer
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).groupingCriteriaCellToggle}`]: styles.groupingCriteriaCellToggle
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).headerFilterRow}`]: styles.headerFilterRow
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconSeparator}`]: styles.iconSeparator
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIcon}`]: styles.menuIcon
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIconButton}`]: styles.menuIconButton
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuList}`]: styles.menuList
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuOpen}`]: styles.menuOpen
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).overlayWrapperInner}`]: styles.overlayWrapperInner
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).pinnedRows}`]: styles.pinnedRows
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['pinnedRows--bottom']}`]: styles['pinnedRows--bottom']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['pinnedRows--top']}`]: styles['pinnedRows--top']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).row}`]: styles.row
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--borderBottom']}`]: styles['row--borderBottom']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--detailPanelExpanded']}`]: styles['row--detailPanelExpanded']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--dragging']}`]: styles['row--dragging']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--dynamicHeight']}`]: styles['row--dynamicHeight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--editable']}`]: styles['row--editable']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--editing']}`]: styles['row--editing']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--firstVisible']}`]: styles['row--firstVisible']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--lastVisible']}`]: styles['row--lastVisible']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowReorderCell}`]: styles.rowReorderCell
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['rowReorderCell--draggable']}`]: styles['rowReorderCell--draggable']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowReorderCellContainer}`]: styles.rowReorderCellContainer
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowReorderCellPlaceholder}`]: styles.rowReorderCellPlaceholder
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowSkeleton}`]: styles.rowSkeleton
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).scrollbar}`]: styles.scrollbar
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollbar--horizontal']}`]: styles['scrollbar--horizontal']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollbar--vertical']}`]: styles['scrollbar--vertical']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).scrollbarFiller}`]: styles.scrollbarFiller
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollbarFiller--pinnedRight']}`]: styles['scrollbarFiller--pinnedRight']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).sortIcon}`]: styles.sortIcon
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).treeDataGroupingCell}`]: styles.treeDataGroupingCell
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).treeDataGroupingCellLoadingContainer}`]: styles.treeDataGroupingCellLoadingContainer
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).treeDataGroupingCellToggle}`]: styles.treeDataGroupingCellToggle
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).withBorderColor}`]: styles.withBorderColor
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--dropAbove']}`]: styles['row--dropAbove']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--dropBelow']}`]: styles['row--dropBelow']
            },
            {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--beingDragged']}`]: styles['row--beingDragged']
            }
        ]
})(()=>{
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const shouldShowBorderTopRightRadius = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, $c0a4879b2d654e0c$var$shouldShowBorderTopRightRadiusSelector);
    const baseBackground = (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.background.base;
    const headerBackground = (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).header.background.base;
    const pinnedBackground = (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).cell.background.pinned;
    const hoverColor = $c0a4879b2d654e0c$var$removeOpacity((0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.hover);
    const hoverOpacity = (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.hoverOpacity;
    const selectedColor = (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.selected;
    const selectedOpacity = (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.selectedOpacity;
    const selectedHoverColor = selectedColor;
    const selectedHoverOpacity = `calc(${selectedOpacity} + ${hoverOpacity})`;
    const hoverBackground = $c0a4879b2d654e0c$var$mix(baseBackground, hoverColor, hoverOpacity);
    const selectedBackground = $c0a4879b2d654e0c$var$mix(baseBackground, selectedColor, selectedOpacity);
    const selectedHoverBackground = $c0a4879b2d654e0c$var$mix(baseBackground, selectedHoverColor, selectedHoverOpacity);
    const pinnedHoverBackground = $c0a4879b2d654e0c$var$mix(pinnedBackground, hoverColor, hoverOpacity);
    const pinnedSelectedBackground = $c0a4879b2d654e0c$var$mix(pinnedBackground, selectedColor, selectedOpacity);
    const pinnedSelectedHoverBackground = $c0a4879b2d654e0c$var$mix(pinnedBackground, selectedHoverColor, selectedHoverOpacity);
    const getPinnedBackgroundStyles = (backgroundColor)=>({
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedLeft']}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedRight']}`]: {
                backgroundColor: backgroundColor,
                '&.Mui-selected': {
                    backgroundColor: $c0a4879b2d654e0c$var$mix(backgroundColor, selectedBackground, selectedOpacity),
                    '&:hover': {
                        backgroundColor: $c0a4879b2d654e0c$var$mix(backgroundColor, selectedHoverBackground, selectedHoverOpacity)
                    }
                }
            }
        });
    const pinnedHoverStyles = getPinnedBackgroundStyles(pinnedHoverBackground);
    const pinnedSelectedStyles = getPinnedBackgroundStyles(pinnedSelectedBackground);
    const pinnedSelectedHoverStyles = getPinnedBackgroundStyles(pinnedSelectedHoverBackground);
    const selectedStyles = {
        backgroundColor: selectedBackground,
        '&:hover': {
            backgroundColor: selectedHoverBackground,
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: selectedBackground
            }
        }
    };
    const gridStyle = {
        '--unstable_DataGrid-radius': (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).radius.base,
        '--unstable_DataGrid-headWeight': (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).typography.fontWeight.medium,
        '--DataGrid-rowBorderColor': (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.border.base,
        '--DataGrid-cellOffsetMultiplier': 2,
        '--DataGrid-width': '0px',
        '--DataGrid-hasScrollX': '0',
        '--DataGrid-hasScrollY': '0',
        '--DataGrid-scrollbarSize': '10px',
        '--DataGrid-rowWidth': '0px',
        '--DataGrid-columnsTotalWidth': '0px',
        '--DataGrid-leftPinnedWidth': '0px',
        '--DataGrid-rightPinnedWidth': '0px',
        '--DataGrid-headerHeight': '0px',
        '--DataGrid-headersTotalHeight': '0px',
        '--DataGrid-topContainerHeight': '0px',
        '--DataGrid-bottomContainerHeight': '0px',
        flex: 1,
        boxSizing: 'border-box',
        position: 'relative',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.border.base,
        borderRadius: 'var(--unstable_DataGrid-radius)',
        backgroundColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.background.base,
        color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.foreground.base,
        font: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).typography.font.body,
        outline: 'none',
        height: '100%',
        display: 'flex',
        minWidth: 0,
        // See https://github.com/mui/mui-x/issues/8547
        minHeight: 0,
        flexDirection: 'column',
        overflow: 'hidden',
        overflowAnchor: 'none',
        // Keep the same scrolling position
        transform: 'translate(0, 0)',
        // Create a stacking context to keep scrollbars from showing on top
        [`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).main} > *:first-child${$c0a4879b2d654e0c$var$ignoreSsrWarning}`]: {
            borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
            borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
        },
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).autoHeight}`]: {
            height: 'auto'
        },
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).autosizing}`]: {
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainerContent} > *`]: {
                overflow: 'visible !important'
            },
            '@media (hover: hover)': {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIcon}`]: {
                    width: '0 !important',
                    visibility: 'hidden !important'
                }
            },
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`]: {
                overflow: 'visible !important',
                whiteSpace: 'nowrap',
                minWidth: 'max-content !important',
                maxWidth: 'max-content !important'
            },
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).groupingCriteriaCell}`]: {
                width: 'unset'
            },
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).treeDataGroupingCell}`]: {
                width: 'unset'
            }
        },
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).withSidePanel}`]: {
            flexDirection: 'row'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).mainContent}`]: {
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            flex: 1
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`]: {
            WebkitTapHighlightColor: 'transparent',
            padding: '0 10px',
            boxSizing: 'border-box'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}:focus-within, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}:focus-within`]: {
            outline: `solid ${$c0a4879b2d654e0c$var$setOpacity((0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.focus, 0.5)} ${$c0a4879b2d654e0c$var$focusOutlineWidth}px`,
            outlineOffset: $c0a4879b2d654e0c$var$focusOutlineWidth * -1
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}:focus, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}:focus`]: {
            outline: `solid ${(0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.focus} ${$c0a4879b2d654e0c$var$focusOutlineWidth}px`,
            outlineOffset: $c0a4879b2d654e0c$var$focusOutlineWidth * -1
        },
        // Hide the column separator when:
        // - the column is focused and has an outline
        // - the next column is focused and has an outline
        // - the column has a left or right border
        // - the next column is pinned right and has a left border
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}:focus,
      & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withLeftBorder']},
      & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withRightBorder']},
      & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--siblingFocused']}
      `]: {
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnSeparator}`]: {
                opacity: 0
            },
            // Show resizable separators at all times on touch devices
            '@media (hover: none)': {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable']}`]: {
                    opacity: 1
                }
            },
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable']}:hover`]: {
                opacity: 1
            }
        },
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['root--noToolbar']} [aria-rowindex="1"] [aria-colindex="1"]`]: {
            borderTopLeftRadius: 'calc(var(--unstable_DataGrid-radius) - 1px)'
        },
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['root--noToolbar']} [aria-rowindex="1"] .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--last']}`]: {
            borderTopRightRadius: shouldShowBorderTopRightRadius ? 'calc(var(--unstable_DataGrid-radius) - 1px)' : undefined
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderCheckbox}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cellCheckbox}`]: {
            padding: 0,
            justifyContent: 'center',
            alignItems: 'center'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}`]: {
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            backgroundColor: headerBackground
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--filter']}`]: {
            paddingTop: 8,
            paddingBottom: 8,
            paddingRight: 5,
            minHeight: 'min-content',
            overflow: 'hidden'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['virtualScroller--hasScrollX']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--last']}`]: {
            overflow: 'hidden'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['pivotPanelField--sorted']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconButtonContainer},
      & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--sorted']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconButtonContainer},
      & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--filtered']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconButtonContainer}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).pivotPanelField}:not(.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['pivotPanelField--sorted']}) .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).sortButton},
      & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}:not(.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--sorted']}) .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).sortButton}`]: {
            opacity: 0,
            transition: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transition([
                'opacity'
            ], {
                duration: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transitions.duration.short
            })
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            gap: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(0.25),
            minWidth: 0,
            flex: 1,
            whiteSpace: 'nowrap',
            overflow: 'hidden'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainerContent}`]: {
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--filledGroup']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid',
            boxSizing: 'border-box'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).sortIcon}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).filterIcon}`]: {
            fontSize: 'inherit'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--sortable']}`]: {
            cursor: 'pointer'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--alignCenter']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            justifyContent: 'center'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderDraggableContainer}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainer}`]: {
            flexDirection: 'row-reverse'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--alignCenter']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIcon}`]: {
            marginLeft: 'auto'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--alignRight']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIcon}`]: {
            marginRight: 'auto',
            marginLeft: -5
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--moving']}`]: {
            backgroundColor: hoverBackground
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--pinnedLeft']}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 40,
            // Should be above the column separator
            background: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).header.background.base
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnSeparator}`]: {
            position: 'absolute',
            overflow: 'hidden',
            zIndex: 30,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxWidth: $c0a4879b2d654e0c$var$columnSeparatorTargetSize,
            color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.border.base
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaders}`]: {
            width: 'var(--DataGrid-rowWidth)',
            backgroundColor: headerBackground
        },
        '@media (hover: hover)': {
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}:hover`]: {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIcon}`]: {
                    width: 'auto',
                    visibility: 'visible'
                },
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconButtonContainer}`]: {
                    visibility: 'visible',
                    width: 'auto'
                }
            },
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}:not(.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--sorted']}):hover .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).sortButton},
        & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).pivotPanelField}:not(.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['pivotPanelField--sorted']}):hover .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).sortButton},
        & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).pivotPanelField}:not(.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['pivotPanelField--sorted']}) .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).sortButton}:focus-visible`]: {
                opacity: 0.5
            }
        },
        '@media (hover: none)': {
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIcon}`]: {
                width: 'auto',
                visibility: 'visible'
            },
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}:focus,
        & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--siblingFocused']}`]: {
                [`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable']}`]: {
                    color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.foreground.accent
                }
            },
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).pivotPanelField}:not(.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['pivotPanelField--sorted']}) .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).sortButton}`]: {
                opacity: 0.5
            }
        },
        // Hide the column separator when the column has border and it is not resizable
        // In this case, this column separator may block interaction with the separator from the adjacent column that is resizable
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withLeftBorder']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideLeft']}:not(.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable']}), & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withRightBorder']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideRight']}:not(.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable']})`]: {
            display: 'none'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideLeft']}`]: {
            left: $c0a4879b2d654e0c$var$columnSeparatorOffset
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideRight']}`]: {
            right: $c0a4879b2d654e0c$var$columnSeparatorOffset
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withRightBorder']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideLeft']}`]: {
            left: $c0a4879b2d654e0c$var$columnSeparatorOffset - 0.5
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withRightBorder']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideRight']}`]: {
            right: $c0a4879b2d654e0c$var$columnSeparatorOffset - 0.5
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable']}`]: {
            cursor: 'col-resize',
            touchAction: 'none',
            [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizing']}`]: {
                color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.foreground.accent
            },
            // Always appear as draggable on touch devices
            '@media (hover: none)': {
                [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconSeparator} rect`]: $c0a4879b2d654e0c$var$separatorIconDragStyles
            },
            '@media (hover: hover)': {
                '&:hover': {
                    color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.foreground.accent,
                    [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconSeparator} rect`]: $c0a4879b2d654e0c$var$separatorIconDragStyles
                }
            },
            '& svg': {
                pointerEvents: 'none'
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconSeparator}`]: {
            color: 'inherit',
            transition: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transition([
                'color',
                'width'
            ], {
                duration: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transitions.duration.short
            })
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIcon}`]: {
            width: 0,
            visibility: 'hidden',
            fontSize: 20,
            marginRight: -5,
            display: 'flex',
            alignItems: 'center'
        },
        [`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuOpen}`]: {
            visibility: 'visible',
            width: 'auto'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).headerFilterRow}`]: {
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).scrollbarFiller}`]: {
                boxSizing: 'border-box',
                borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
            }
        },
        /* Bottom border of the top-container */ [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--borderBottom']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader},
      & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--borderBottom']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).filler},
      & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--borderBottom']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).scrollbarFiller}`]: {
            borderBottom: `1px solid var(--DataGrid-rowBorderColor)`
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--borderBottom']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`]: {
            borderBottom: `1px solid var(--rowBorderColor)`
        },
        /* Row styles */ [`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).row}`]: {
            display: 'flex',
            width: 'var(--DataGrid-rowWidth)',
            breakInside: 'avoid',
            // Avoid the row to be broken in two different print pages.
            '--rowBorderColor': 'var(--DataGrid-rowBorderColor)',
            [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--firstVisible']}`]: {
                '--rowBorderColor': 'transparent'
            },
            '&:hover': {
                backgroundColor: hoverBackground,
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: 'transparent'
                }
            },
            [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowSkeleton}:hover`]: {
                backgroundColor: 'transparent'
            },
            '&.Mui-selected': selectedStyles
        },
        /* Cell styles */ [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`]: {
            flex: '0 0 auto',
            height: 'var(--height)',
            width: 'var(--width)',
            lineHeight: 'calc(var(--height) - 1px)',
            // -1px for the border
            boxSizing: 'border-box',
            borderTop: `1px solid var(--rowBorderColor)`,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            '&.Mui-selected': selectedStyles
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['virtualScrollerContent--overflowed']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--lastVisible']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`]: {
            borderTopColor: 'transparent'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).pinnedRows} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).row}, .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).aggregationRowOverlayWrapper} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).row}`]: {
            backgroundColor: pinnedBackground,
            '&:hover': {
                backgroundColor: pinnedHoverBackground
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['pinnedRows--top']} :first-of-type`]: {
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}, .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).scrollbarFiller}`]: {
                borderTop: 'none'
            }
        },
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['root--disableUserSelection']}`]: {
            userSelect: 'none'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--dynamicHeight']} > .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`]: {
            whiteSpace: 'initial',
            lineHeight: 'inherit'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cellEmpty}`]: {
            flex: 1,
            padding: 0,
            height: 'unset'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--selectionMode']}`]: {
            cursor: 'default'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--editing']}`]: {
            padding: 1,
            display: 'flex',
            boxShadow: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).shadows.base,
            backgroundColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.background.overlay,
            '&:focus-within': {
                outline: `${$c0a4879b2d654e0c$var$focusOutlineWidth}px solid ${(0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.focus}`,
                outlineOffset: $c0a4879b2d654e0c$var$focusOutlineWidth * -1
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--editing']}`]: {
            '& .MuiInputBase-root': {
                height: '100%'
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--editing']}`]: {
            boxShadow: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).shadows.base
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--editing']} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`]: {
            boxShadow: 'none',
            backgroundColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.background.overlay
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).editBooleanCell}`]: {
            display: 'flex',
            height: '100%',
            width: '100%',
            alignItems: 'center',
            justifyContent: 'center'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).booleanCell}[data-value="true"]`]: {
            color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.foreground.muted
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).booleanCell}[data-value="false"]`]: {
            color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.foreground.disabled
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).actionsCell}`]: {
            display: 'inline-flex',
            alignItems: 'center',
            gridGap: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(1)
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowReorderCell}`]: {
            display: 'inline-flex',
            flex: 1,
            alignItems: 'center',
            justifyContent: 'center',
            opacity: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.disabledOpacity
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['rowReorderCell--draggable']}`]: {
            cursor: 'grab',
            opacity: 1
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowReorderCellContainer}`]: {
            padding: 0,
            display: 'flex',
            alignItems: 'stretch'
        },
        [`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).withBorderColor}`]: {
            borderColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.border.base
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--withLeftBorder']}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withLeftBorder']}`]: {
            borderLeftColor: 'var(--DataGrid-rowBorderColor)',
            borderLeftWidth: '1px',
            borderLeftStyle: 'solid'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--withRightBorder']}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--withRightBorder']}`]: {
            borderRightColor: 'var(--DataGrid-rowBorderColor)',
            borderRightWidth: '1px',
            borderRightStyle: 'solid'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--flex']}`]: {
            display: 'flex',
            alignItems: 'center',
            lineHeight: 'inherit'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--textLeft']}`]: {
            textAlign: 'left',
            justifyContent: 'flex-start'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--textRight']}`]: {
            textAlign: 'right',
            justifyContent: 'flex-end'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--textCenter']}`]: {
            textAlign: 'center',
            justifyContent: 'center'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedLeft']}, & .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedRight']}`]: {
            position: 'sticky',
            zIndex: 30,
            background: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).cell.background.pinned,
            '&.Mui-selected': {
                backgroundColor: pinnedSelectedBackground
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).row}`]: {
            '&:hover': pinnedHoverStyles,
            '&.Mui-selected': pinnedSelectedStyles,
            '&.Mui-selected:hover': pinnedSelectedHoverStyles
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cellOffsetLeft}`]: {
            flex: '0 0 auto',
            display: 'inline-block'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cellSkeleton}`]: {
            flex: '0 0 auto',
            height: '100%',
            display: 'inline-flex',
            alignItems: 'center'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderDraggableContainer}`]: {
            display: 'flex',
            width: '100%',
            height: '100%'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowReorderCellPlaceholder}`]: {
            display: 'none'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--dragging']}`]: {
            background: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.background.overlay,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            opacity: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.disabledOpacity
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--dragging']}`]: {
            background: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.background.overlay,
            padding: '0 12px',
            borderRadius: 'var(--unstable_DataGrid-radius)',
            border: '1px solid var(--DataGrid-rowBorderColor)',
            color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.foreground.base,
            transform: 'translateZ(0)',
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).rowReorderCellPlaceholder}`]: {
                padding: '0 6px',
                display: 'flex'
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).treeDataGroupingCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).treeDataGroupingCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(2)
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).treeDataGroupingCellLoadingContainer}, .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).groupingCriteriaCellLoadingContainer}`]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).groupingCriteriaCell}`]: {
            display: 'flex',
            alignItems: 'center',
            width: '100%'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).groupingCriteriaCellToggle}`]: {
            flex: '0 0 28px',
            alignSelf: 'stretch',
            marginRight: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(2)
        },
        /* ScrollbarFiller styles */ [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaders} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).scrollbarFiller}`]: {
            backgroundColor: headerBackground
        },
        [`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).scrollbarFiller}`]: {
            minWidth: 'calc(var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
            alignSelf: 'stretch',
            backgroundColor: headerBackground,
            [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollbarFiller--pinnedRight']}`]: {
                position: 'sticky',
                zIndex: 40,
                // Should be above the column separator
                right: 0
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).filler}`]: {
            flex: '1 0 auto'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['filler--borderBottom']}`]: {
            borderBottom: '1px solid var(--DataGrid-rowBorderColor)'
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaders} .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).filler}`]: {
            backgroundColor: headerBackground
        },
        /* Used when skeleton/no columns overlay is visible */ [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['main--hiddenContent']}`]: {
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).virtualScrollerContent}`]: {
                // We use visibility hidden so that the virtual scroller content retains its height.
                // Position fixed is used to remove the virtual scroller content from the flow.
                // https://github.com/mui/mui-x/issues/14061
                position: 'fixed',
                visibility: 'hidden'
            },
            // Hide grid content
            [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).pinnedRows}`]: {
                display: 'none'
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--dropAbove']}`]: {
            position: 'relative',
            '&::before': {
                pointerEvents: 'none',
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '2px',
                backgroundColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.selected
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--dropBelow']}`]: {
            position: 'relative',
            '&::after': {
                zIndex: 100,
                pointerEvents: 'none',
                content: '""',
                position: 'absolute',
                bottom: '-2px',
                left: 0,
                width: '100%',
                height: '2px',
                backgroundColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.interactive.selected
            },
            [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--lastVisible']}`]: {
                '&::after': {
                    bottom: 'calc(var(--DataGrid-hasScrollY) * 0px + (1 - var(--DataGrid-hasScrollY)) * -2px)'
                }
            }
        },
        [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--beingDragged']}`]: {
            color: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.foreground.disabled,
            '&:hover': {
                backgroundColor: 'transparent'
            }
        }
    };
    return gridStyle;
});
function $c0a4879b2d654e0c$var$setOpacity(color, opacity) {
    return `rgba(from ${color} r g b / ${opacity})`;
}
function $c0a4879b2d654e0c$var$removeOpacity(color) {
    return $c0a4879b2d654e0c$var$setOpacity(color, 1);
}
function $c0a4879b2d654e0c$var$mix(background, overlay, opacity) {
    return `color-mix(in srgb,${background}, ${overlay} calc(${opacity} * 100%))`;
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $11abf6438ce67a48$export$e00c5fe7e13db7ba = /*#__PURE__*/ $acw62.createContext(undefined);


const $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3 = ()=>{
    const contextValue = $acw62.useContext((0, $11abf6438ce67a48$export$e00c5fe7e13db7ba));
    if (!contextValue) throw new Error('MUI X: useGridRootProps should only be used inside the DataGrid, DataGridPro or DataGridPremium component.');
    return contextValue;
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $662a26edaf9ba9f0$export$714d6aa898a12d6c = /*#__PURE__*/ $acw62.createContext(undefined);


const $c6f13e845e117797$export$9fe1679701f06bb7 = ()=>{
    const configuration = $acw62.useContext((0, $662a26edaf9ba9f0$export$714d6aa898a12d6c));
    if (configuration === undefined) throw new Error([
        'MUI X: Could not find the Data Grid configuration context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return configuration;
};



'use client';
const $cadacf9afeddf573$var$CLASSNAME_PREFIX = 'MuiDataGridVariables';
const $cadacf9afeddf573$var$CSSVariablesContext = /*#__PURE__*/ $acw62.createContext({
    className: 'unset',
    tag: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
        href: "/unset"
    })
});
function $cadacf9afeddf573$export$bce43ff91e115a9b() {
    return $acw62.useContext($cadacf9afeddf573$var$CSSVariablesContext).className;
}
function $cadacf9afeddf573$export$82522e07c85e7b6a() {
    return $acw62.useContext($cadacf9afeddf573$var$CSSVariablesContext);
}
function $cadacf9afeddf573$export$f48ffcf34a3b8840({ children: children }) {
    const className = $cadacf9afeddf573$export$bce43ff91e115a9b();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: className,
        children: children
    });
}
function $cadacf9afeddf573$export$377b45915d3a03ca(props) {
    const config = (0, $c6f13e845e117797$export$9fe1679701f06bb7)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const description = config.hooks.useCSSVariables();
    const context = $acw62.useMemo(()=>{
        const className = `${$cadacf9afeddf573$var$CLASSNAME_PREFIX}-${description.id}`;
        const cssString = `.${className}{${$cadacf9afeddf573$var$variablesToString(description.variables)}}`;
        const tag = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
            href: `/${className}`,
            nonce: rootProps.nonce,
            children: cssString
        });
        return {
            className: className,
            tag: tag
        };
    }, [
        rootProps.nonce,
        description
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cadacf9afeddf573$var$CSSVariablesContext.Provider, {
        value: context,
        children: props.children
    });
}
function $cadacf9afeddf573$var$variablesToString(variables) {
    let output = '';
    for(const key in variables)if (Object.hasOwn(variables, key) && variables[key] !== undefined) output += `${key}:${variables[key]};`;
    return output;
}






// src/devModeChecks/identityFunctionCheck.ts
var $310dad19a2812331$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch  {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $310dad19a2812331$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $310dad19a2812331$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $310dad19a2812331$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($310dad19a2812331$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $310dad19a2812331$var$NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function $310dad19a2812331$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $310dad19a2812331$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $310dad19a2812331$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $310dad19a2812331$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $310dad19a2812331$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $310dad19a2812331$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $310dad19a2812331$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $310dad19a2812331$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = {
        ...$310dad19a2812331$var$globalDevModeChecks,
        ...devModeChecks
    };
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $310dad19a2812331$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $310dad19a2812331$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $310dad19a2812331$var$$REVISION = 0;
var $310dad19a2812331$var$CURRENT_TRACKER = null;
var $310dad19a2812331$var$Cell = class {
    revision = $310dad19a2812331$var$$REVISION;
    _value;
    _lastValue;
    _isEqual = $310dad19a2812331$var$tripleEq;
    constructor(initialValue, isEqual = $310dad19a2812331$var$tripleEq){
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $310dad19a2812331$var$CURRENT_TRACKER?.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$310dad19a2812331$var$$REVISION;
    }
};
function $310dad19a2812331$var$tripleEq(a, b) {
    return a === b;
}
var $310dad19a2812331$var$TrackingCache = class {
    _cachedValue;
    _cachedRevision = -1;
    _deps = [];
    hits = 0;
    fn;
    constructor(fn){
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $310dad19a2812331$var$CURRENT_TRACKER;
            $310dad19a2812331$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $310dad19a2812331$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $310dad19a2812331$var$CURRENT_TRACKER?.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $310dad19a2812331$var$getValue(cell) {
    if (!(cell instanceof $310dad19a2812331$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $310dad19a2812331$var$setValue(storage, value) {
    if (!(storage instanceof $310dad19a2812331$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $310dad19a2812331$var$createCell(initialValue, isEqual = $310dad19a2812331$var$tripleEq) {
    return new $310dad19a2812331$var$Cell(initialValue, isEqual);
}
function $310dad19a2812331$var$createCache(fn) {
    $310dad19a2812331$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $310dad19a2812331$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $310dad19a2812331$var$neverEq = (a, b)=>false;
function $310dad19a2812331$var$createTag() {
    return $310dad19a2812331$var$createCell(null, $310dad19a2812331$var$neverEq);
}
function $310dad19a2812331$var$dirtyTag(tag, value) {
    $310dad19a2812331$var$setValue(tag, value);
}
var $310dad19a2812331$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $310dad19a2812331$var$createTag();
    $310dad19a2812331$var$getValue(tag);
};
var $310dad19a2812331$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $310dad19a2812331$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $310dad19a2812331$var$REDUX_PROXY_LABEL = Symbol();
var $310dad19a2812331$var$nextId = 0;
var $310dad19a2812331$var$proto = Object.getPrototypeOf({});
var $310dad19a2812331$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy(this, $310dad19a2812331$var$objectProxyHandler);
    tag = $310dad19a2812331$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $310dad19a2812331$var$nextId++;
};
var $310dad19a2812331$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $310dad19a2812331$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $310dad19a2812331$var$createNode(childValue);
                if (childNode.tag) $310dad19a2812331$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $310dad19a2812331$var$createTag();
                    tag.value = childValue;
                }
                $310dad19a2812331$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $310dad19a2812331$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $310dad19a2812331$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        this.value = value;
        this.tag.value = value;
    }
    proxy = new Proxy([
        this
    ], $310dad19a2812331$var$arrayProxyHandler);
    tag = $310dad19a2812331$var$createTag();
    tags = {};
    children = {};
    collectionTag = null;
    id = $310dad19a2812331$var$nextId++;
};
var $310dad19a2812331$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $310dad19a2812331$var$consumeCollection(node);
        return $310dad19a2812331$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $310dad19a2812331$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $310dad19a2812331$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $310dad19a2812331$var$objectProxyHandler.has(node, prop);
    }
};
function $310dad19a2812331$var$createNode(value) {
    if (Array.isArray(value)) return new $310dad19a2812331$var$ArrayTreeNode(value);
    return new $310dad19a2812331$var$ObjectTreeNode(value);
}
function $310dad19a2812331$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $310dad19a2812331$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $310dad19a2812331$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $310dad19a2812331$var$dirtyCollection(node);
            $310dad19a2812331$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $310dad19a2812331$var$updateNode(childNode, newChildValue);
        else {
            $310dad19a2812331$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $310dad19a2812331$var$deleteNode(node) {
    if (node.tag) $310dad19a2812331$var$dirtyTag(node.tag, null);
    $310dad19a2812331$var$dirtyCollection(node);
    for(const key in node.tags)$310dad19a2812331$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$310dad19a2812331$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $310dad19a2812331$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $310dad19a2812331$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $310dad19a2812331$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $310dad19a2812331$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $310dad19a2812331$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $310dad19a2812331$export$3f025202a230c6dd = (a, b)=>a === b;
function $310dad19a2812331$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $310dad19a2812331$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $310dad19a2812331$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $310dad19a2812331$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? $310dad19a2812331$var$createSingletonCache(comparator) : $310dad19a2812331$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $310dad19a2812331$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $310dad19a2812331$export$c8f9cf88d9fdee55(func) {
    const node = $310dad19a2812331$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $310dad19a2812331$var$createCacheKeyComparator($310dad19a2812331$export$3f025202a230c6dd);
    const cache = $310dad19a2812331$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $310dad19a2812331$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $310dad19a2812331$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $310dad19a2812331$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $310dad19a2812331$var$StrongRef;
var $310dad19a2812331$var$UNTERMINATED = 0;
var $310dad19a2812331$var$TERMINATED = 1;
function $310dad19a2812331$var$createCacheNode() {
    return {
        s: $310dad19a2812331$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $310dad19a2812331$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $310dad19a2812331$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $310dad19a2812331$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $310dad19a2812331$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $310dad19a2812331$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = lastResult?.deref?.() ?? lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new $310dad19a2812331$var$Ref(result) : result;
            }
        }
        terminatedNode.s = $310dad19a2812331$var$TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $310dad19a2812331$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $310dad19a2812331$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $310dad19a2812331$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = {
            ...createSelectorCreatorOptions,
            ...directlyPassedOptions
        };
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $310dad19a2812331$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $310dad19a2812331$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $310dad19a2812331$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $310dad19a2812331$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $310dad19a2812331$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $310dad19a2812331$export$595d22ed68ca2841 = /* @__PURE__ */ $310dad19a2812331$export$5943f4447f6ef248($310dad19a2812331$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $310dad19a2812331$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $310dad19a2812331$export$595d22ed68ca2841)=>{
    $310dad19a2812331$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$310dad19a2812331$export$75979cfcd91bf38f
});


/* eslint-disable no-underscore-dangle */ // __cacheKey__
const $76700507203bf92b$var$reselectCreateSelector = (0, $310dad19a2812331$export$5943f4447f6ef248)({
    memoize: (0, $310dad19a2812331$export$d8ead1d92249919b),
    memoizeOptions: {
        maxSize: 1,
        equalityCheck: Object.is
    }
});
const $76700507203bf92b$export$595d22ed68ca2841 = (a, b, c, d, e, f, ...other)=>{
    if (other.length > 0) throw new Error('Unsupported number of selectors');
    let selector;
    if (a && b && c && d && e && f) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        const ve = e(state, a1, a2, a3);
        return f(va, vb, vc, vd, ve, a1, a2, a3);
    };
    else if (a && b && c && d && e) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        const vd = d(state, a1, a2, a3);
        return e(va, vb, vc, vd, a1, a2, a3);
    };
    else if (a && b && c && d) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        const vc = c(state, a1, a2, a3);
        return d(va, vb, vc, a1, a2, a3);
    };
    else if (a && b && c) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        const vb = b(state, a1, a2, a3);
        return c(va, vb, a1, a2, a3);
    };
    else if (a && b) selector = (state, a1, a2, a3)=>{
        const va = a(state, a1, a2, a3);
        return b(va, a1, a2, a3);
    };
    else if (a) selector = a;
    else throw new Error('Missing arguments');
    return selector;
};
const $76700507203bf92b$export$2a3ca4704a61d1f4 = (...inputs)=>{
    const cache = new WeakMap();
    let nextCacheId = 1;
    const combiner = inputs[inputs.length - 1];
    const nSelectors = inputs.length - 1 || 1;
    // (s1, s2, ..., sN, a1, a2, a3) => { ... }
    const argsLength = Math.max(combiner.length - nSelectors, 0);
    if (argsLength > 3) throw new Error('Unsupported number of arguments');
    // prettier-ignore
    const selector = (state, a1, a2, a3)=>{
        let cacheKey = state.__cacheKey__;
        if (!cacheKey) {
            cacheKey = {
                id: nextCacheId
            };
            state.__cacheKey__ = cacheKey;
            nextCacheId += 1;
        }
        let fn = cache.get(cacheKey);
        if (!fn) {
            const selectors = inputs.length === 1 ? [
                (x)=>x,
                combiner
            ] : inputs;
            let reselectArgs = inputs;
            const selectorArgs = [
                undefined,
                undefined,
                undefined
            ];
            switch(argsLength){
                case 0:
                    break;
                case 1:
                    reselectArgs = [
                        ...selectors.slice(0, -1),
                        ()=>selectorArgs[0],
                        combiner
                    ];
                    break;
                case 2:
                    reselectArgs = [
                        ...selectors.slice(0, -1),
                        ()=>selectorArgs[0],
                        ()=>selectorArgs[1],
                        combiner
                    ];
                    break;
                case 3:
                    reselectArgs = [
                        ...selectors.slice(0, -1),
                        ()=>selectorArgs[0],
                        ()=>selectorArgs[1],
                        ()=>selectorArgs[2],
                        combiner
                    ];
                    break;
                default:
                    throw new Error('Unsupported number of arguments');
            }
            fn = $76700507203bf92b$var$reselectCreateSelector(...reselectArgs);
            fn.selectorArgs = selectorArgs;
            cache.set(cacheKey, fn);
        }
        /* eslint-disable no-fallthrough */ switch(argsLength){
            case 3:
                fn.selectorArgs[2] = a3;
            case 2:
                fn.selectorArgs[1] = a2;
            case 1:
                fn.selectorArgs[0] = a1;
            case 0:
            default:
        }
        switch(argsLength){
            case 0:
                return fn(state);
            case 1:
                return fn(state, a1);
            case 2:
                return fn(state, a1, a2);
            case 3:
                return fn(state, a1, a2, a3);
            default:
                throw new Error('unreachable');
        }
    };
    return selector;
};


const $24e415a76b2eb9fb$export$595d22ed68ca2841 = (...args)=>{
    const baseSelector = (0, $76700507203bf92b$export$595d22ed68ca2841)(...args);
    const selector = (apiRef, a1, a2, a3)=>baseSelector($24e415a76b2eb9fb$var$unwrapIfNeeded(apiRef), a1, a2, a3);
    return selector;
};
const $24e415a76b2eb9fb$export$2a3ca4704a61d1f4 = (...args)=>{
    const baseSelector = (0, $76700507203bf92b$export$2a3ca4704a61d1f4)(...args);
    const selector = (apiRef, a1, a2, a3)=>baseSelector($24e415a76b2eb9fb$var$unwrapIfNeeded(apiRef), a1, a2, a3);
    return selector;
};
const $24e415a76b2eb9fb$export$a62918fde9b59371 = (fn)=>(apiRef, args)=>fn($24e415a76b2eb9fb$var$unwrapIfNeeded(apiRef), args);
function $24e415a76b2eb9fb$var$unwrapIfNeeded(refOrState) {
    if ('current' in refOrState) return refOrState.current.state;
    return refOrState;
}


const $3d9afbbff3fa8293$export$44e428f429332330 = 0.7;
const $3d9afbbff3fa8293$export$ff72d9a37c8f7b58 = 1.3;
const $3d9afbbff3fa8293$var$DENSITY_FACTORS = {
    compact: $3d9afbbff3fa8293$export$44e428f429332330,
    comfortable: $3d9afbbff3fa8293$export$ff72d9a37c8f7b58,
    standard: 1
};
const $3d9afbbff3fa8293$export$806a039ece4425b4 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.density);
const $3d9afbbff3fa8293$export$c646201fb1d3e7a6 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($3d9afbbff3fa8293$export$806a039ece4425b4, (density)=>$3d9afbbff3fa8293$var$DENSITY_FACTORS[density]);



var $hfliI = parcelRequire("hfliI");
const $824e939a1ebbddfa$var$emptySubscribe = ()=>()=>{};
const $824e939a1ebbddfa$var$clientSnapshot = ()=>false;
const $824e939a1ebbddfa$var$serverSnapshot = ()=>true;
const $824e939a1ebbddfa$export$535bd6ca7f90a273 = ()=>(0, $hfliI.useSyncExternalStore)($824e939a1ebbddfa$var$emptySubscribe, $824e939a1ebbddfa$var$clientSnapshot, $824e939a1ebbddfa$var$serverSnapshot);




var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");

let $c660c9275391bc0a$export$64f54b460f67389c = /*#__PURE__*/ function(GridPinnedColumnPosition) {
    GridPinnedColumnPosition["LEFT"] = "left";
    GridPinnedColumnPosition["RIGHT"] = "right";
    return GridPinnedColumnPosition;
}({});
const $c660c9275391bc0a$export$77439b544edbbd66 = {
    left: [],
    right: []
};



const $711cd8ecfb37ea99$export$ece6490d69662ba0 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.isRtl);



const $cd4a4e6d71563ab7$export$38c05a14586f769 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.props.listView ?? false);
const $cd4a4e6d71563ab7$export$aeeda57ada9bc1ee = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.listViewColumn);


const $1781ebe27505055c$export$858d15abb6cddc08 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.columns);
const $1781ebe27505055c$export$d8a3dfbb129c80db = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($1781ebe27505055c$export$858d15abb6cddc08, (columnsState)=>columnsState.orderedFields);
const $1781ebe27505055c$export$8a3a9a6db584d7fd = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($1781ebe27505055c$export$858d15abb6cddc08, (columnsState)=>columnsState.lookup);
const $1781ebe27505055c$export$da85f06e3c19f1fd = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$d8a3dfbb129c80db, $1781ebe27505055c$export$8a3a9a6db584d7fd, (allFields, lookup)=>allFields.map((field)=>lookup[field]));
const $1781ebe27505055c$export$eb0d33595fe29bb4 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($1781ebe27505055c$export$858d15abb6cddc08, (columnsState)=>columnsState.columnVisibilityModel);
const $1781ebe27505055c$export$7212e0fec3c2218 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($1781ebe27505055c$export$858d15abb6cddc08, (columnsState)=>columnsState.initialColumnVisibilityModel);
const $1781ebe27505055c$export$16a65a9447d3dda9 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$da85f06e3c19f1fd, $1781ebe27505055c$export$eb0d33595fe29bb4, (0, $cd4a4e6d71563ab7$export$38c05a14586f769), (0, $cd4a4e6d71563ab7$export$aeeda57ada9bc1ee), (columns, columnVisibilityModel, listView, listColumn)=>listView && listColumn ? [
        listColumn
    ] : columns.filter((column)=>columnVisibilityModel[column.field] !== false));
const $1781ebe27505055c$export$c9491722e1d6e8d3 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$16a65a9447d3dda9, (visibleColumns)=>visibleColumns.map((column)=>column.field));
const $1781ebe27505055c$export$1eea0bd4db853467 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.pinnedColumns);
const $1781ebe27505055c$export$92910475beda795c = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$1eea0bd4db853467, $1781ebe27505055c$export$d8a3dfbb129c80db, (0, $711cd8ecfb37ea99$export$ece6490d69662ba0), (model, orderedFields, isRtl)=>$1781ebe27505055c$var$filterMissingColumns(model, orderedFields, isRtl));
const $1781ebe27505055c$export$297e8079713afa11 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$858d15abb6cddc08, $1781ebe27505055c$export$1eea0bd4db853467, $1781ebe27505055c$export$c9491722e1d6e8d3, (0, $711cd8ecfb37ea99$export$ece6490d69662ba0), (0, $cd4a4e6d71563ab7$export$38c05a14586f769), (columnsState, model, visibleColumnFields, isRtl, listView)=>{
    if (listView) return 0, $c660c9275391bc0a$export$77439b544edbbd66;
    const visiblePinnedFields = $1781ebe27505055c$var$filterMissingColumns(model, visibleColumnFields, isRtl);
    const visiblePinnedColumns = {
        left: visiblePinnedFields.left.map((field)=>columnsState.lookup[field]),
        right: visiblePinnedFields.right.map((field)=>columnsState.lookup[field])
    };
    return visiblePinnedColumns;
});
function $1781ebe27505055c$var$filterMissingColumns(pinnedColumns, columns, invert) {
    if (!Array.isArray(pinnedColumns.left) && !Array.isArray(pinnedColumns.right)) return 0, $c660c9275391bc0a$export$77439b544edbbd66;
    if (pinnedColumns.left?.length === 0 && pinnedColumns.right?.length === 0) return 0, $c660c9275391bc0a$export$77439b544edbbd66;
    const filter = (newPinnedColumns, remainingColumns)=>{
        if (!Array.isArray(newPinnedColumns)) return [];
        return newPinnedColumns.filter((field)=>remainingColumns.includes(field));
    };
    const leftPinnedColumns = filter(pinnedColumns.left, columns);
    const columnsWithoutLeftPinnedColumns = columns.filter(// Filter out from the remaining columns those columns already pinned to the left
    (field)=>!leftPinnedColumns.includes(field));
    const rightPinnedColumns = filter(pinnedColumns.right, columnsWithoutLeftPinnedColumns);
    if (invert) return {
        left: rightPinnedColumns,
        right: leftPinnedColumns
    };
    return {
        left: leftPinnedColumns,
        right: rightPinnedColumns
    };
}
const $1781ebe27505055c$export$fce7d810e48021e3 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$16a65a9447d3dda9, (visibleColumns)=>{
    const positions = [];
    let currentPosition = 0;
    for(let i = 0; i < visibleColumns.length; i += 1){
        positions.push(currentPosition);
        currentPosition += visibleColumns[i].computedWidth;
    }
    return positions;
});
const $1781ebe27505055c$export$2cad659ba95fed71 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$da85f06e3c19f1fd, (columns)=>columns.filter((col)=>col.filterable));
const $1781ebe27505055c$export$e84218276cc24419 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$da85f06e3c19f1fd, (columns)=>columns.reduce((acc, col)=>{
        if (col.filterable) acc[col.field] = col;
        return acc;
    }, {}));
const $1781ebe27505055c$export$7aac81e7227448b4 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($1781ebe27505055c$export$da85f06e3c19f1fd, (columns)=>columns.some((column)=>column.colSpan !== undefined));




const $9a7998a995118469$export$37e5474577e02878 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.preferencePanel);
const $9a7998a995118469$export$d19024d6f0cb2c88 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9a7998a995118469$export$37e5474577e02878, (panel, labelId)=>{
    if (panel.open && panel.labelId === labelId) return true;
    return false;
});


var $e38c9af0748d9173$export$e7e5652452e44b = /*#__PURE__*/ function(GridPreferencePanelsValue) {
    GridPreferencePanelsValue["filters"] = "filters";
    GridPreferencePanelsValue["columns"] = "columns";
    GridPreferencePanelsValue["aiAssistant"] = "aiAssistant";
    return GridPreferencePanelsValue;
}($e38c9af0748d9173$export$e7e5652452e44b || {});



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
const $15d0738a634b2067$export$70c437c2dab15e52 = /*#__PURE__*/ $acw62.createContext(undefined);


function $c4277a4fee22a087$export$2d14edd3a7db3bbf() {
    const apiRef = $acw62.useContext((0, $15d0738a634b2067$export$70c437c2dab15e52));
    if (apiRef === undefined) throw new Error([
        'MUI X: Could not find the Data Grid context.',
        'It looks like you rendered your component outside of a DataGrid, DataGridPro or DataGridPremium parent component.',
        'This can also happen if you are bundling multiple versions of the Data Grid.'
    ].join('\n'));
    return apiRef;
}




var $acw62 = parcelRequire("acw62");

'use client';
const $9638e12379adda14$export$177b8de1d34bfd61 = /*#__PURE__*/ $acw62.createContext(undefined);
function $9638e12379adda14$export$82b7333a15124fb5() {
    const context = $acw62.useContext($9638e12379adda14$export$177b8de1d34bfd61);
    if (context === undefined) throw new Error('MUI X: Missing context.');
    return context;
}
function $9638e12379adda14$export$df24b15a5e161339({ children: children }) {
    const columnsPanelTriggerRef = $acw62.useRef(null);
    const filterPanelTriggerRef = $acw62.useRef(null);
    const aiAssistantPanelTriggerRef = $acw62.useRef(null);
    const value = $acw62.useMemo(()=>({
            columnsPanelTriggerRef: columnsPanelTriggerRef,
            filterPanelTriggerRef: filterPanelTriggerRef,
            aiAssistantPanelTriggerRef: aiAssistantPanelTriggerRef
        }), []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9638e12379adda14$export$177b8de1d34bfd61.Provider, {
        value: value,
        children: children
    });
}



function $9d972379a48bf0b9$export$6cff59e5608ce17d() {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const columns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$da85f06e3c19f1fd));
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const preferencePanelState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9a7998a995118469$export$37e5474577e02878));
    const { columnsPanelTriggerRef: columnsPanelTriggerRef, filterPanelTriggerRef: filterPanelTriggerRef, aiAssistantPanelTriggerRef: aiAssistantPanelTriggerRef } = (0, $9638e12379adda14$export$82b7333a15124fb5)();
    const panelContent = apiRef.current.unstable_applyPipeProcessors('preferencePanel', null, preferencePanelState.openedPanelValue ?? (0, $e38c9af0748d9173$export$e7e5652452e44b).filters);
    let target = null;
    switch(preferencePanelState.openedPanelValue){
        case (0, $e38c9af0748d9173$export$e7e5652452e44b).filters:
            target = filterPanelTriggerRef.current;
            break;
        case (0, $e38c9af0748d9173$export$e7e5652452e44b).columns:
            target = columnsPanelTriggerRef.current;
            break;
        case (0, $e38c9af0748d9173$export$e7e5652452e44b).aiAssistant:
            target = aiAssistantPanelTriggerRef.current;
            break;
        default:
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.panel, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: preferencePanelState.panelId,
        open: columns.length > 0 && preferencePanelState.open,
        "aria-labelledby": preferencePanelState.labelId,
        target: target,
        onClose: ()=>apiRef.current.hidePreferences()
    }, rootProps.slotProps?.panel, {
        children: panelContent
    }));
}



function $099e862ec7130a3f$export$74ac40502a3200d3() {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9d972379a48bf0b9$export$6cff59e5608ce17d), {}),
            rootProps.showToolbar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.toolbar, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.toolbar))
        ]
    });
}




var $acw62 = parcelRequire("acw62");



const $9f487993152f6061$export$26d8768b83a52ffd = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.dimensions);
const $9f487993152f6061$export$ab20f9d33edc7794 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.columnsTotalWidth);
const $9f487993152f6061$export$2ca09da26466c31a = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.rowHeight);
const $9f487993152f6061$export$83bdaba2ad532c80 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.contentSize.height);
const $9f487993152f6061$export$5dfe533d5e873745 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.hasScrollX);
const $9f487993152f6061$export$4fe814c21f610df = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.hasScrollY);
const $9f487993152f6061$export$34d7a8c547584228 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width);
const $9f487993152f6061$export$4b70ef0159fef49b = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.headerHeight);
const $9f487993152f6061$export$f49d78f35ee113b0 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.groupHeaderHeight);
const $9f487993152f6061$export$c297d104bfb637f0 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.headerFilterHeight);
const $9f487993152f6061$export$bfc2d49082e0c9a2 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
const $9f487993152f6061$export$6615095b3c921727 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, (dimensions)=>dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
const $9f487993152f6061$export$98dc8438c286cc21 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($9f487993152f6061$export$26d8768b83a52ffd, $9f487993152f6061$export$bfc2d49082e0c9a2, (dimensions, height)=>{
    const needsLastRowBorder = dimensions.viewportOuterSize.height - dimensions.minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return false;
    return true;
});



const $4fc0d4cb0e570e63$export$340c7411f183facf = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.rows);
const $4fc0d4cb0e570e63$export$1641ef9d08e265ca = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.totalRowCount);
const $4fc0d4cb0e570e63$export$3c966d405f950b08 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.loading);
const $4fc0d4cb0e570e63$export$800ab0a68a9efc4f = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.totalTopLevelRowCount);
const $4fc0d4cb0e570e63$export$37767f9110c99048 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.dataRowIdToModelLookup);
const $4fc0d4cb0e570e63$export$89666e0bb1ed05df = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$37767f9110c99048, (rows, id)=>rows[id]);
const $4fc0d4cb0e570e63$export$de9a43d646a9821d = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.tree);
const $4fc0d4cb0e570e63$export$895b25a1c5f3cc22 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$de9a43d646a9821d, (rowTree, rowId)=>rowTree[rowId]);
const $4fc0d4cb0e570e63$export$6c1cdbc7b5e9a3f4 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.groupsToFetch);
const $4fc0d4cb0e570e63$export$c263d91fb644e7a0 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.groupingName);
const $4fc0d4cb0e570e63$export$eb24598525413286 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.treeDepths);
const $4fc0d4cb0e570e63$export$4cdbe576751dd8e2 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>{
    const entries = Object.entries(rows.treeDepths);
    if (entries.length === 0) return 1;
    return (entries.filter(([, nodeCount])=>nodeCount > 0).map(([depth])=>Number(depth)).sort((a, b)=>b - a)[0] ?? 0) + 1;
});
const $4fc0d4cb0e570e63$export$c7dcaab5e573753 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows.dataRowIds);
const $4fc0d4cb0e570e63$export$161f5ccecdc30f42 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($4fc0d4cb0e570e63$export$c7dcaab5e573753, $4fc0d4cb0e570e63$export$37767f9110c99048, (dataRowIds, rowsLookup)=>dataRowIds.reduce((acc, id)=>{
        if (!rowsLookup[id]) return acc;
        acc.push(rowsLookup[id]);
        return acc;
    }, []));
const $4fc0d4cb0e570e63$export$e8db8ec5e43400fa = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$340c7411f183facf, (rows)=>rows?.additionalRowGroups);
const $4fc0d4cb0e570e63$export$ffe7071c481e32b0 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($4fc0d4cb0e570e63$export$e8db8ec5e43400fa, (additionalRowGroups)=>{
    const rawPinnedRows = additionalRowGroups?.pinnedRows;
    return {
        bottom: rawPinnedRows?.bottom?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? [],
        top: rawPinnedRows?.top?.map((rowEntry)=>({
                id: rowEntry.id,
                model: rowEntry.model ?? {}
            })) ?? []
    };
});
const $4fc0d4cb0e570e63$export$8e3fb3525d7db988 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4fc0d4cb0e570e63$export$ffe7071c481e32b0, (pinnedRows)=>{
    return (pinnedRows?.top?.length || 0) + (pinnedRows?.bottom?.length || 0);
});




var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");
// If no effect ran after this amount of time, we assume that the render was not committed by React
const $ab6fe22a9ac56983$var$CLEANUP_TIMER_LOOP_MILLIS = 1000;
class $ab6fe22a9ac56983$export$c16cf791cc6bf0c7 {
    timeouts = (()=>new Map())();
    cleanupTimeout = (()=>$ab6fe22a9ac56983$var$CLEANUP_TIMER_LOOP_MILLIS)();
    constructor(timeout = $ab6fe22a9ac56983$var$CLEANUP_TIMER_LOOP_MILLIS){
        this.cleanupTimeout = timeout;
    }
    register(object, unsubscribe, unregisterToken) {
        if (!this.timeouts) this.timeouts = new Map();
        const timeout = setTimeout(()=>{
            if (typeof unsubscribe === 'function') unsubscribe();
            this.timeouts.delete(unregisterToken.cleanupToken);
        }, this.cleanupTimeout);
        this.timeouts.set(unregisterToken.cleanupToken, timeout);
    }
    unregister(unregisterToken) {
        const timeout = this.timeouts.get(unregisterToken.cleanupToken);
        if (timeout) {
            this.timeouts.delete(unregisterToken.cleanupToken);
            clearTimeout(timeout);
        }
    }
    reset() {
        if (this.timeouts) {
            this.timeouts.forEach((value, key)=>{
                this.unregister({
                    cleanupToken: key
                });
            });
            this.timeouts = undefined;
        }
    }
}


class $3f2a75511aec8500$export$86b678dc9d8f7603 {
    registry = (()=>new FinalizationRegistry((unsubscribe)=>{
            if (typeof unsubscribe === 'function') unsubscribe();
        }))();
    register(object, unsubscribe, unregisterToken) {
        this.registry.register(object, unsubscribe, unregisterToken);
    }
    unregister(unregisterToken) {
        this.registry.unregister(unregisterToken);
    }
    reset() {}
}


'use client';
// Based on https://github.com/Bnaya/use-dispose-uncommitted/blob/main/src/finalization-registry-based-impl.ts
// Check https://github.com/facebook/react/issues/15317 to get more information
// We use class to make it easier to detect in heap snapshots by name
class $d5a5cf36ee2ab74a$var$ObjectToBeRetainedByReact {
    static create() {
        return new $d5a5cf36ee2ab74a$var$ObjectToBeRetainedByReact();
    }
}
const $d5a5cf36ee2ab74a$var$registryContainer = {
    current: $d5a5cf36ee2ab74a$var$createRegistry()
};
let $d5a5cf36ee2ab74a$var$cleanupTokensCounter = 0;
function $d5a5cf36ee2ab74a$export$87c9e82e743b0449(apiRef, eventName, handler, options) {
    const objectRetainedByReact = $acw62.useState($d5a5cf36ee2ab74a$var$ObjectToBeRetainedByReact.create)[0];
    const subscription = $acw62.useRef(null);
    const handlerRef = $acw62.useRef(null);
    handlerRef.current = handler;
    const cleanupTokenRef = $acw62.useRef(null);
    if (!subscription.current && handlerRef.current) {
        const enhancedHandler = (params, event, details)=>{
            if (!event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
        };
        subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
        $d5a5cf36ee2ab74a$var$cleanupTokensCounter += 1;
        cleanupTokenRef.current = {
            cleanupToken: $d5a5cf36ee2ab74a$var$cleanupTokensCounter
        };
        $d5a5cf36ee2ab74a$var$registryContainer.current.register(objectRetainedByReact, // The callback below will be called once this reference stops being retained
        ()=>{
            subscription.current?.();
            subscription.current = null;
            cleanupTokenRef.current = null;
        }, cleanupTokenRef.current);
    } else if (!handlerRef.current && subscription.current) {
        subscription.current();
        subscription.current = null;
        if (cleanupTokenRef.current) {
            $d5a5cf36ee2ab74a$var$registryContainer.current.unregister(cleanupTokenRef.current);
            cleanupTokenRef.current = null;
        }
    }
    $acw62.useEffect(()=>{
        if (!subscription.current && handlerRef.current) {
            const enhancedHandler = (params, event, details)=>{
                if (!event.defaultMuiPrevented) handlerRef.current?.(params, event, details);
            };
            subscription.current = apiRef.current.subscribeEvent(eventName, enhancedHandler, options);
        }
        if (cleanupTokenRef.current && $d5a5cf36ee2ab74a$var$registryContainer.current) {
            // If the effect was called, it means that this render was committed
            // so we can trust the cleanup function to remove the listener.
            $d5a5cf36ee2ab74a$var$registryContainer.current.unregister(cleanupTokenRef.current);
            cleanupTokenRef.current = null;
        }
        return ()=>{
            subscription.current?.();
            subscription.current = null;
        };
    }, [
        apiRef,
        eventName,
        options
    ]);
}
const $d5a5cf36ee2ab74a$var$OPTIONS_IS_FIRST = {
    isFirst: true
};
function $d5a5cf36ee2ab74a$export$7e1eac1309f32c44(apiRef, eventName, handler) {
    $d5a5cf36ee2ab74a$export$87c9e82e743b0449(apiRef, eventName, handler, $d5a5cf36ee2ab74a$var$OPTIONS_IS_FIRST);
}
function $d5a5cf36ee2ab74a$export$c5af18cc30c6146f() {
    $d5a5cf36ee2ab74a$var$registryContainer.current?.reset();
    $d5a5cf36ee2ab74a$var$registryContainer.current = $d5a5cf36ee2ab74a$var$createRegistry();
}
const $d5a5cf36ee2ab74a$export$cffdedbb97f82e98 = $d5a5cf36ee2ab74a$var$registryContainer;
function $d5a5cf36ee2ab74a$var$createRegistry() {
    return typeof FinalizationRegistry !== 'undefined' ? new (0, $3f2a75511aec8500$export$86b678dc9d8f7603)() : new (0, $ab6fe22a9ac56983$export$c16cf791cc6bf0c7)();
}











var $acw62 = parcelRequire("acw62");





function $3ffccd8eb47e448b$export$c9fa229ee44f9a9d(_props) {
    throw new Error('Failed assertion: should not be rendered');
}







'use client';
const $4a04192e6b868250$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "isValidating",
    "debounceMs",
    "isProcessingProps",
    "onValueChange",
    "slotProps"
];
const $4a04192e6b868250$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $4a04192e6b868250$var$GridEditInputCellRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d), {
    name: 'MuiDataGrid',
    slot: 'EditInputCell'
})({
    font: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).typography.font.body,
    padding: '1px 0',
    '& input': {
        padding: '0 16px',
        height: '100%'
    }
});
const $4a04192e6b868250$export$cd10ed3250a4d414 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)((props, ref)=>{
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { id: id, value: value, field: field, colDef: colDef, hasFocus: hasFocus, debounceMs: debounceMs = 200, isProcessingProps: isProcessingProps, onValueChange: onValueChange, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $4a04192e6b868250$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const inputRef = $acw62.useRef(null);
    const [valueState, setValueState] = $acw62.useState(value);
    const classes = $4a04192e6b868250$var$useUtilityClasses(rootProps);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newValue = event.target.value;
        const column = apiRef.current.getColumn(field);
        let parsedValue = newValue;
        if (column.valueParser) parsedValue = column.valueParser(newValue, apiRef.current.getRow(id), column, apiRef);
        setValueState(parsedValue);
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: parsedValue,
            debounceMs: debounceMs,
            unstable_skipValueParser: true
        }, event);
        if (onValueChange) await onValueChange(event, newValue);
    }, [
        apiRef,
        debounceMs,
        field,
        id,
        onValueChange
    ]);
    const meta = apiRef.current.unstable_getEditCellMeta(id, field);
    $acw62.useEffect(()=>{
        if (meta?.changeReason !== 'debouncedSetEditCellValue') setValueState(value);
    }, [
        meta,
        value
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4a04192e6b868250$var$GridEditInputCellRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        as: rootProps.slots.baseInput,
        inputRef: inputRef,
        className: classes.root,
        ownerState: rootProps,
        fullWidth: true,
        type: colDef.type === 'number' ? colDef.type : 'text',
        value: valueState ?? '',
        onChange: handleChange,
        endAdornment: isProcessingProps ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.loadIcon, {
            fontSize: "small",
            color: "action"
        }) : undefined
    }, other, slotProps?.root, {
        ref: ref
    }));
});
const $4a04192e6b868250$export$d1015f41e7e48c2e = (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($4a04192e6b868250$export$cd10ed3250a4d414, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params));





const $877e98c7ff4d0a4a$export$13eeac5ac15e0be5 = (model, disableMultipleColumnsSorting)=>{
    if (disableMultipleColumnsSorting && model.length > 1) return [
        model[0]
    ];
    return model;
};
const $877e98c7ff4d0a4a$export$3fc28d475ac000c0 = (sortModel, disableMultipleColumnsSorting)=>(state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
            sorting: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.sorting, {
                sortModel: $877e98c7ff4d0a4a$export$13eeac5ac15e0be5(sortModel, disableMultipleColumnsSorting)
            })
        });
const $877e98c7ff4d0a4a$var$isDesc = (direction)=>direction === 'desc';
/**
 * @name sortValueGetter
 * @param {GridRowId} id The id of the row.
 * @param {string} field The field to sort by.
 *
 * Transform an item of the sorting model into a method comparing two rows.
 * @param {GridSortItem} sortItem The sort item we want to apply.
 * @param {RefObject<GridApiCommunity>} apiRef The API of the grid.
 * @returns {GridParsedSortItem | null} The parsed sort item. Returns `null` is the sort item is not valid.
 */ const $877e98c7ff4d0a4a$var$parseSortItem = (sortItem, apiRef)=>{
    const column = apiRef.current.getColumn(sortItem.field);
    if (!column || sortItem.sort === null) return null;
    let comparator;
    if (column.getSortComparator) comparator = column.getSortComparator(sortItem.sort);
    else comparator = $877e98c7ff4d0a4a$var$isDesc(sortItem.sort) ? (...args)=>-1 * column.sortComparator(...args) : column.sortComparator;
    if (!comparator) return null;
    const getSortCellParams = (id)=>({
            id: id,
            field: column.field,
            rowNode: (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, id),
            value: apiRef.current.getCellValue(id, column.field),
            api: apiRef.current
        });
    return {
        getSortCellParams: getSortCellParams,
        comparator: comparator
    };
};
/**
 * Compare two rows according to a list of valid sort items.
 * The `row1Params` and `row2Params` must have the same length as `parsedSortItems`,
 * and each of their index must contain the `GridSortCellParams` of the sort item with the same index.
 * @param {GridParsedSortItem[]} parsedSortItems All the sort items with which we want to compare the rows.
 * @param {GridRowAggregatedSortingParams} row1 The node and params of the 1st row for each sort item.
 * @param {GridRowAggregatedSortingParams} row2 The node and params of the 2nd row for each sort item.
 */ const $877e98c7ff4d0a4a$var$compareRows = (parsedSortItems, row1, row2)=>{
    return parsedSortItems.reduce((res, item, index)=>{
        if (res !== 0) // return the results of the first comparator which distinguish the two rows
        return res;
        const sortCellParams1 = row1.params[index];
        const sortCellParams2 = row2.params[index];
        res = item.comparator(sortCellParams1.value, sortCellParams2.value, sortCellParams1, sortCellParams2);
        return res;
    }, 0);
};
const $877e98c7ff4d0a4a$export$b29e353d1a72dfda = (sortModel, apiRef)=>{
    const comparatorList = sortModel.map((item)=>$877e98c7ff4d0a4a$var$parseSortItem(item, apiRef)).filter((comparator)=>!!comparator);
    if (comparatorList.length === 0) return null;
    return (rowList)=>rowList.map((node)=>({
                node: node,
                params: comparatorList.map((el)=>el.getSortCellParams(node.id))
            })).sort((a, b)=>$877e98c7ff4d0a4a$var$compareRows(comparatorList, a, b)).map((row)=>row.node.id);
};
const $877e98c7ff4d0a4a$export$b3d84351ab2e3580 = (sortingOrder, current)=>{
    const currentIdx = sortingOrder.indexOf(current);
    if (!current || currentIdx === -1 || currentIdx + 1 === sortingOrder.length) return sortingOrder[0];
    return sortingOrder[currentIdx + 1];
};
const $877e98c7ff4d0a4a$var$gridNillComparator = (v1, v2)=>{
    if (v1 == null && v2 != null) return -1;
    if (v2 == null && v1 != null) return 1;
    if (v1 == null && v2 == null) return 0;
    return null;
};
const $877e98c7ff4d0a4a$var$collator = new Intl.Collator();
const $877e98c7ff4d0a4a$export$db324d0b741f4529 = (value1, value2)=>{
    const nillResult = $877e98c7ff4d0a4a$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (typeof value1 === 'string') return $877e98c7ff4d0a4a$var$collator.compare(value1.toString(), value2.toString());
    return value1 - value2;
};
const $877e98c7ff4d0a4a$export$ecfdaa3722003888 = (value1, value2)=>{
    const nillResult = $877e98c7ff4d0a4a$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    return Number(value1) - Number(value2);
};
const $877e98c7ff4d0a4a$export$74e685f55e96d6bc = (value1, value2)=>{
    const nillResult = $877e98c7ff4d0a4a$var$gridNillComparator(value1, value2);
    if (nillResult !== null) return nillResult;
    if (value1 > value2) return 1;
    if (value1 < value2) return -1;
    return 0;
};





var $acw62 = parcelRequire("acw62");





'use client';
const $05b50a8c03e88d2f$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "disabled",
    "isFilterActive",
    "slotProps",
    "clearButton",
    "headerFilterMenu"
];
function $05b50a8c03e88d2f$export$99d1f108a3f21b3(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, disabled: disabled, slotProps: slotProps, clearButton: clearButton, headerFilterMenu: headerFilterMenu } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $05b50a8c03e88d2f$var$_excluded);
    const textFieldProps = slotProps?.root;
    const filterTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const [filterValueState, setFilterValueState] = $acw62.useState($05b50a8c03e88d2f$var$sanitizeFilterItemValue(item.value));
    const [applying, setIsApplying] = $acw62.useState(false);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const onFilterChange = $acw62.useCallback((event)=>{
        const value = $05b50a8c03e88d2f$var$sanitizeFilterItemValue(event.target.value);
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const newItem = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
                value: type === 'number' && !Number.isNaN(Number(value)) ? Number(value) : value,
                fromInput: id
            });
            applyValue(newItem);
            setIsApplying(false);
        });
    }, [
        filterTimeout,
        rootProps.filterDebounceMs,
        item,
        type,
        id,
        applyValue
    ]);
    $acw62.useEffect(()=>{
        const itemPlusTag = item;
        if (itemPlusTag.fromInput !== id || item.value == null) setFilterValueState($05b50a8c03e88d2f$var$sanitizeFilterItemValue(item.value));
    }, [
        id,
        item
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTextField, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                id: id,
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                value: filterValueState ?? '',
                onChange: onFilterChange,
                type: type || 'text',
                disabled: disabled,
                slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, textFieldProps?.slotProps, {
                    input: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        endAdornment: applying ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.loadIcon, {
                            fontSize: "small",
                            color: "action"
                        }) : null
                    }, textFieldProps?.slotProps?.input),
                    htmlInput: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        tabIndex: tabIndex
                    }, textFieldProps?.slotProps?.htmlInput)
                }),
                inputRef: focusElementRef
            }, rootProps.slotProps?.baseTextField, other, textFieldProps)),
            headerFilterMenu,
            clearButton
        ]
    });
}
function $05b50a8c03e88d2f$var$sanitizeFilterItemValue(value) {
    if (value == null || value === '') return undefined;
    return String(value);
}


function $07a64ebfd26f4296$export$7e4aa119212bc614(value) {
    return typeof value === 'number' && !Number.isNaN(value);
}
function $07a64ebfd26f4296$export$f6e2535fb5126e54(value) {
    return typeof value === 'function';
}
function $07a64ebfd26f4296$export$a6cdc56e425d0d0a(value) {
    return typeof value === 'object' && value !== null;
}
function $07a64ebfd26f4296$export$c43914e0cb16a981() {
    try {
        // Incognito mode might reject access to the localStorage for security reasons.
        // window isn't defined on Node.js
        // https://stackoverflow.com/questions/16427636/check-if-localstorage-is-available
        const key = '__some_random_key_you_are_not_going_to_use__';
        window.localStorage.setItem(key, key);
        window.localStorage.removeItem(key);
        return true;
    } catch (err) {
        return false;
    }
}
function $07a64ebfd26f4296$export$7c57da42ce8e346f(value) {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
const $07a64ebfd26f4296$export$7d15b64cf5a3a4c4 = (value, min, max)=>Math.max(min, Math.min(max, value));
function $07a64ebfd26f4296$export$d02631cccf789723(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
// Pseudo random number. See https://stackoverflow.com/a/47593316
function $07a64ebfd26f4296$var$mulberry32(a) {
    return ()=>{
        /* eslint-disable */ let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    /* eslint-enable */ };
}
function $07a64ebfd26f4296$export$90ad2d37c2cc187e(seed) {
    const random = $07a64ebfd26f4296$var$mulberry32(seed);
    return (min, max)=>min + (max - min) * random();
}
function $07a64ebfd26f4296$export$b7d58db314e0ac27(obj) {
    if (typeof structuredClone === 'function') return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
function $07a64ebfd26f4296$export$ec5767fa5c351320(_) {}
const $07a64ebfd26f4296$export$f546127afff6208d = (condition, fn)=>(params)=>{
        if (condition) fn(params);
    };




var $acw62 = parcelRequire("acw62");




'use client';
function $661f336e4681898d$export$fec959c3691e0645(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps } = props;
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const [options, setOptions] = $acw62.useState([]);
    const [filterValueState, setFilterValueState] = $acw62.useState(item.value || []);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    $acw62.useEffect(()=>{
        const itemValue = item.value ?? [];
        setFilterValueState(itemValue.map(String));
    }, [
        item.value
    ]);
    const handleChange = $acw62.useCallback((event, value)=>{
        setFilterValueState(value.map(String));
        applyValue((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
            value: [
                ...value.map((filterItemValue)=>type === 'number' ? Number(filterItemValue) : filterItemValue)
            ]
        }));
    }, [
        applyValue,
        item,
        type
    ]);
    const handleInputChange = $acw62.useCallback((event, value)=>{
        if (value === '') setOptions([]);
        else setOptions([
            value
        ]);
    }, [
        setOptions
    ]);
    const BaseAutocomplete = rootProps.slots.baseAutocomplete;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BaseAutocomplete, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        multiple: true,
        freeSolo: true,
        options: options,
        id: id,
        value: filterValueState,
        onChange: handleChange,
        onInputChange: handleInputChange,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        slotProps: {
            textField: {
                type: type || 'text',
                inputRef: focusElementRef
            }
        }
    }, slotProps?.root));
}




/**
 * Filter item definition interface.
 * @demos
 *   - [Custom filter operator](/x/react-data-grid/filtering/customization/#create-a-custom-operator)
 */ var $4993f96105ede556$export$90be184ccbab1c7a = /*#__PURE__*/ function(GridLogicOperator) {
    GridLogicOperator["And"] = "and";
    GridLogicOperator["Or"] = "or";
    return GridLogicOperator;
}($4993f96105ede556$export$90be184ccbab1c7a || {});



const $943740e60fd58c10$export$f5e27122a659c0c = {
    filteredRowsLookup: {},
    filteredChildrenCountLookup: {},
    filteredDescendantCountLookup: {}
};
const $943740e60fd58c10$export$7ea23129b8e10cdb = ()=>({
        items: [],
        logicOperator: (0, $4993f96105ede556$export$90be184ccbab1c7a).And,
        quickFilterValues: [],
        quickFilterLogicOperator: (0, $4993f96105ede556$export$90be184ccbab1c7a).And
    }); /**
 * @param {GridValidRowModel} row The model of the row we want to filter.
 * @param {(filterItem: GridFilterItem) => boolean} shouldApplyItem An optional callback to allow the filtering engine to only apply some items.
 * @param {GridAggregatedFilterItemApplierResult} result The previous result of the filtering engine.
 */  /**
 * Visibility status for each row.
 * A row is visible if it is passing the filters AND if its parents are expanded.
 * If a row is not registered in this lookup, it is visible.
 */ 


function $4dd1bc39a2828c97$export$fbb0da9fc679f98a(apiRef) {
    return {
        current: apiRef.current.getPublicApi()
    };
}



let $376859af45b845ed$var$hasEval;
function $376859af45b845ed$var$getHasEval() {
    if ($376859af45b845ed$var$hasEval !== undefined) return $376859af45b845ed$var$hasEval;
    try {
        // eslint-disable-next-line no-new-func
        $376859af45b845ed$var$hasEval = new Function('return true')();
    } catch (_) {
        $376859af45b845ed$var$hasEval = false;
    }
    return $376859af45b845ed$var$hasEval;
}
const $376859af45b845ed$export$eb76493d113de092 = (item, apiRef)=>{
    const cleanItem = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item);
    if (cleanItem.id == null) cleanItem.id = Math.round(Math.random() * 1e5);
    if (cleanItem.operator == null) {
        // Selects a default operator
        // We don't use `apiRef.current.getColumn` because it is not ready during state initialization
        const column = (0, $1781ebe27505055c$export$8a3a9a6db584d7fd)(apiRef)[cleanItem.field];
        cleanItem.operator = column && column.filterOperators[0].value;
    }
    return cleanItem;
};
const $376859af45b845ed$export$2a370a0aad2ac7e1 = (model, disableMultipleColumnsFiltering, apiRef)=>{
    const hasSeveralItems = model.items.length > 1;
    let items;
    if (hasSeveralItems && disableMultipleColumnsFiltering) items = [
        model.items[0]
    ];
    else items = model.items;
    const hasItemsWithoutIds = hasSeveralItems && items.some((item)=>item.id == null);
    const hasItemWithoutOperator = items.some((item)=>item.operator == null);
    if (hasItemWithoutOperator || hasItemsWithoutIds) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, model, {
        items: items.map((item)=>$376859af45b845ed$export$eb76493d113de092(item, apiRef))
    });
    if (model.items !== items) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, model, {
        items: items
    });
    return model;
};
const $376859af45b845ed$export$f4189e6c713e6dd8 = (filterModel, disableMultipleColumnsFiltering, apiRef)=>(filteringState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filteringState, {
            filterModel: $376859af45b845ed$export$2a370a0aad2ac7e1(filterModel, disableMultipleColumnsFiltering, apiRef)
        });
const $376859af45b845ed$export$626da389515c02b3 = (value)=>{
    if (typeof value === 'string') return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return value;
};
const $376859af45b845ed$var$getFilterCallbackFromItem = (filterItem, filterValueGetter, apiRef)=>{
    if (!filterItem.field || !filterItem.operator) return null;
    const column = apiRef.current.getColumn(filterItem.field);
    if (!column) return null;
    let parsedValue;
    if (column.valueParser) {
        const parser = column.valueParser;
        parsedValue = Array.isArray(filterItem.value) ? filterItem.value?.map((x)=>parser(x, undefined, column, apiRef)) : parser(filterItem.value, undefined, column, apiRef);
    } else parsedValue = filterItem.value;
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    if (ignoreDiacritics) parsedValue = $376859af45b845ed$export$626da389515c02b3(parsedValue);
    const newFilterItem = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterItem, {
        value: parsedValue
    });
    const filterOperators = column.filterOperators;
    if (!filterOperators?.length) throw new Error(`MUI X: No filter operators found for column '${column.field}'.`);
    const filterOperator = filterOperators.find((operator)=>operator.value === newFilterItem.operator);
    if (!filterOperator) throw new Error(`MUI X: No filter operator found for column '${column.field}' and operator value '${newFilterItem.operator}'.`);
    const publicApiRef = (0, $4dd1bc39a2828c97$export$fbb0da9fc679f98a)(apiRef);
    const applyFilterOnRow = filterOperator.getApplyFilterFn(newFilterItem, column);
    if (typeof applyFilterOnRow !== 'function') return null;
    return {
        item: newFilterItem,
        fn: (row)=>{
            let value = filterValueGetter(row, column);
            if (ignoreDiacritics) value = $376859af45b845ed$export$626da389515c02b3(value);
            return applyFilterOnRow(value, row, column, publicApiRef);
        }
    };
};
let $376859af45b845ed$var$filterItemsApplierId = 1;
/**
 * @name filterValueGetter
 * @param {GridRowModel} row The row to get the value from.
 * @param {GridColDef} column The column that the filter is applied on.
 *
 * Generates a method to easily check if a row is matching the current filter model.
 * @param {GridFilterModel} filterModel The model with which we want to filter the rows.
 * @param {FilterValueGetterFn} filterValueGetter The function to get the value to filter by.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $376859af45b845ed$var$buildAggregatedFilterItemsApplier = (filterModel, filterValueGetter, apiRef, disableEval)=>{
    const { items: items } = filterModel;
    const appliers = items.map((item)=>$376859af45b845ed$var$getFilterCallbackFromItem(item, filterValueGetter, apiRef)).filter((callback)=>!!callback);
    if (appliers.length === 0) return null;
    if (disableEval || !$376859af45b845ed$var$getHasEval()) // This is the original logic, which is used if `eval()` is not supported (aka prevented by CSP).
    return (row, shouldApplyFilter)=>{
        const resultPerItemId = {};
        for(let i = 0; i < appliers.length; i += 1){
            const applier = appliers[i];
            if (!shouldApplyFilter || shouldApplyFilter(applier.item.field)) resultPerItemId[applier.item.id] = applier.fn(row);
        }
        return resultPerItemId;
    };
    // We generate a new function with `new Function()` to avoid expensive patterns for JS engines
    // such as a dynamic object assignment, for example `{ [dynamicKey]: value }`.
    // eslint-disable-next-line no-new-func
    const filterItemCore = new Function('appliers', 'row', 'shouldApplyFilter', `"use strict";
${appliers.map((applier, i)=>`const shouldApply${i} = !shouldApplyFilter || shouldApplyFilter(${JSON.stringify(applier.item.field)});`).join('\n')}

const result$$ = {
${appliers.map((applier, i)=>`  ${JSON.stringify(String(applier.item.id))}: !shouldApply${i} ? false : appliers[${i}].fn(row),`).join('\n')}
};

return result$$;`.replaceAll('$$', String($376859af45b845ed$var$filterItemsApplierId)));
    $376859af45b845ed$var$filterItemsApplierId += 1;
    // Assign to the arrow function a name to help debugging
    const filterItem = (row, shouldApplyItem)=>filterItemCore(appliers, row, shouldApplyItem);
    return filterItem;
};
const $376859af45b845ed$export$cabca178b367efe0 = (filterModel)=>{
    return filterModel.quickFilterExcludeHiddenColumns ?? true;
};
/**
 * @name filterValueGetter
 * @param {GridRowModel} row The row to get the value from.
 * @param {GridColDef} column The column that the filter is applied on.
 *
 * Generates a method to easily check if a row is matching the current quick filter.
 * @param {any[]} filterModel The model with which we want to filter the rows.
 * @param {FilterValueGetterFn} filterValueGetter The function to get the value to filter by.
 * @param {RefObject<GridPrivateApiCommunity>} apiRef The API of the grid.
 * @returns {GridAggregatedFilterItemApplier | null} A method that checks if a row is matching the current filter model. If `null`, we consider that all the rows are matching the filters.
 */ const $376859af45b845ed$var$buildAggregatedQuickFilterApplier = (filterModel, filterValueGetter, apiRef)=>{
    const quickFilterValues = filterModel.quickFilterValues?.filter(Boolean) ?? [];
    if (quickFilterValues.length === 0) return null;
    const allColumnFields = (0, $1781ebe27505055c$export$d8a3dfbb129c80db)(apiRef);
    const columnVisibilityModel = (0, $1781ebe27505055c$export$eb0d33595fe29bb4)(apiRef);
    let columnFields;
    if ($376859af45b845ed$export$cabca178b367efe0(filterModel)) // Do not use gridVisibleColumnFieldsSelector here, because quick filter won't work in the list view mode
    // See https://github.com/mui/mui-x/issues/19145
    columnFields = allColumnFields.filter((field)=>columnVisibilityModel[field] !== false);
    else columnFields = allColumnFields;
    const appliersPerField = [];
    const { ignoreDiacritics: ignoreDiacritics } = apiRef.current.rootProps;
    const publicApiRef = (0, $4dd1bc39a2828c97$export$fbb0da9fc679f98a)(apiRef);
    columnFields.forEach((field)=>{
        const column = apiRef.current.getColumn(field);
        const getApplyQuickFilterFn = column?.getApplyQuickFilterFn;
        if (getApplyQuickFilterFn) appliersPerField.push({
            column: column,
            appliers: quickFilterValues.map((quickFilterValue)=>{
                const value = ignoreDiacritics ? $376859af45b845ed$export$626da389515c02b3(quickFilterValue) : quickFilterValue;
                return {
                    fn: getApplyQuickFilterFn(value, column, publicApiRef)
                };
            })
        });
    });
    return function isRowMatchingQuickFilter(row, shouldApplyFilter) {
        const result = {};
        /* eslint-disable no-labels */ outer: for(let v = 0; v < quickFilterValues.length; v += 1){
            const filterValue = quickFilterValues[v];
            for(let i = 0; i < appliersPerField.length; i += 1){
                const { column: column, appliers: appliers } = appliersPerField[i];
                const { field: field } = column;
                if (shouldApplyFilter && !shouldApplyFilter(field)) continue;
                const applier = appliers[v];
                let value = filterValueGetter(row, column);
                if (applier.fn === null) continue;
                if (ignoreDiacritics) value = $376859af45b845ed$export$626da389515c02b3(value);
                const isMatching = applier.fn(value, row, column, publicApiRef);
                if (isMatching) {
                    result[filterValue] = true;
                    continue outer;
                }
            }
            result[filterValue] = false;
        }
        return result;
    };
};
const $376859af45b845ed$export$1c795c7c9654905e = (filterModel, filterValueGetter, apiRef, disableEval)=>{
    const isRowMatchingFilterItems = $376859af45b845ed$var$buildAggregatedFilterItemsApplier(filterModel, filterValueGetter, apiRef, disableEval);
    const isRowMatchingQuickFilter = $376859af45b845ed$var$buildAggregatedQuickFilterApplier(filterModel, filterValueGetter, apiRef);
    return function isRowMatchingFilters(row, shouldApplyFilter, result) {
        result.passingFilterItems = isRowMatchingFilterItems?.(row, shouldApplyFilter) ?? null;
        result.passingQuickFilterValues = isRowMatchingQuickFilter?.(row, shouldApplyFilter) ?? null;
    };
};
const $376859af45b845ed$var$isNotNull = (result)=>result != null;
const $376859af45b845ed$var$filterModelItems = (cache, filterValueGetter, apiRef, items)=>{
    if (!cache.cleanedFilterItems) cache.cleanedFilterItems = items.filter((item)=>$376859af45b845ed$var$getFilterCallbackFromItem(item, filterValueGetter, apiRef) !== null);
    return cache.cleanedFilterItems;
};
const $376859af45b845ed$export$8d82b4490466f182 = (allFilterItemResults, allQuickFilterResults, filterModel, filterValueGetter, apiRef, cache)=>{
    const cleanedFilterItems = $376859af45b845ed$var$filterModelItems(cache, filterValueGetter, apiRef, filterModel.items);
    const cleanedFilterItemResults = allFilterItemResults.filter($376859af45b845ed$var$isNotNull);
    const cleanedQuickFilterResults = allQuickFilterResults.filter($376859af45b845ed$var$isNotNull);
    // get result for filter items model
    if (cleanedFilterItemResults.length > 0) {
        // Return true if the item pass with one of the rows
        const filterItemPredicate = (item)=>{
            return cleanedFilterItemResults.some((filterItemResult)=>filterItemResult[item.id]);
        };
        const logicOperator = filterModel.logicOperator ?? (0, $943740e60fd58c10$export$7ea23129b8e10cdb)().logicOperator;
        if (logicOperator === (0, $4993f96105ede556$export$90be184ccbab1c7a).And) {
            const passesAllFilters = cleanedFilterItems.every(filterItemPredicate);
            if (!passesAllFilters) return false;
        } else {
            const passesSomeFilters = cleanedFilterItems.some(filterItemPredicate);
            if (!passesSomeFilters) return false;
        }
    }
    // get result for quick filter model
    if (cleanedQuickFilterResults.length > 0 && filterModel.quickFilterValues != null) {
        // Return true if the item pass with one of the rows
        const quickFilterValuePredicate = (value)=>{
            return cleanedQuickFilterResults.some((quickFilterValueResult)=>quickFilterValueResult[value]);
        };
        const quickFilterLogicOperator = filterModel.quickFilterLogicOperator ?? (0, $943740e60fd58c10$export$7ea23129b8e10cdb)().quickFilterLogicOperator;
        if (quickFilterLogicOperator === (0, $4993f96105ede556$export$90be184ccbab1c7a).And) {
            const passesAllQuickFilterValues = filterModel.quickFilterValues.every(quickFilterValuePredicate);
            if (!passesAllQuickFilterValues) return false;
        } else {
            const passesSomeQuickFilterValues = filterModel.quickFilterValues.some(quickFilterValuePredicate);
            if (!passesSomeQuickFilterValues) return false;
        }
    }
    return true;
};


const $945683b39acb2c9b$export$4326c0ebf0c2f84b = (value)=>{
    if (!value) return null;
    const filterRegex = new RegExp((0, $07a64ebfd26f4296$export$7c57da42ce8e346f)(value), 'i');
    return (_, row, column, apiRef)=>{
        let columnValue = apiRef.current.getRowFormattedValue(row, column);
        if (apiRef.current.ignoreDiacritics) columnValue = (0, $376859af45b845ed$export$626da389515c02b3)(columnValue);
        return columnValue != null ? filterRegex.test(columnValue.toString()) : false;
    };
};
const $945683b39acb2c9b$var$createContainsFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const filterRegex = new RegExp((0, $07a64ebfd26f4296$export$7c57da42ce8e346f)(trimmedValue), 'i');
        return (value)=>{
            if (value == null) return negate;
            const matches = filterRegex.test(String(value));
            return negate ? !matches : matches;
        };
    };
const $945683b39acb2c9b$var$createEqualityFilterFn = (disableTrim, negate)=>(filterItem)=>{
        if (!filterItem.value) return null;
        const trimmedValue = disableTrim ? filterItem.value : filterItem.value.trim();
        const collator = new Intl.Collator(undefined, {
            sensitivity: 'base',
            usage: 'search'
        });
        return (value)=>{
            if (value == null) return negate;
            const isEqual = collator.compare(trimmedValue, value.toString()) === 0;
            return negate ? !isEqual : isEqual;
        };
    };
const $945683b39acb2c9b$var$createEmptyFilterFn = (negate)=>()=>{
        return (value)=>{
            const isEmpty = value === '' || value == null;
            return negate ? !isEmpty : isEmpty;
        };
    };
const $945683b39acb2c9b$export$dff3a5bcde5c5e41 = (disableTrim = false)=>[
        {
            value: 'contains',
            getApplyFilterFn: $945683b39acb2c9b$var$createContainsFilterFn(disableTrim, false),
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3)
        },
        {
            value: 'doesNotContain',
            getApplyFilterFn: $945683b39acb2c9b$var$createContainsFilterFn(disableTrim, true),
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3)
        },
        {
            value: 'equals',
            getApplyFilterFn: $945683b39acb2c9b$var$createEqualityFilterFn(disableTrim, false),
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3)
        },
        {
            value: 'doesNotEqual',
            getApplyFilterFn: $945683b39acb2c9b$var$createEqualityFilterFn(disableTrim, true),
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3)
        },
        {
            value: 'startsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`^${(0, $07a64ebfd26f4296$export$7c57da42ce8e346f)(filterItemValue)}.*$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3)
        },
        {
            value: 'endsWith',
            getApplyFilterFn: (filterItem)=>{
                if (!filterItem.value) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.trim();
                const filterRegex = new RegExp(`.*${(0, $07a64ebfd26f4296$export$7c57da42ce8e346f)(filterItemValue)}$`, 'i');
                return (value)=>{
                    return value != null ? filterRegex.test(value.toString()) : false;
                };
            },
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3)
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: $945683b39acb2c9b$var$createEmptyFilterFn(false),
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: $945683b39acb2c9b$var$createEmptyFilterFn(true),
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValue = disableTrim ? filterItem.value : filterItem.value.map((val)=>val.trim());
                const collator = new Intl.Collator(undefined, {
                    sensitivity: 'base',
                    usage: 'search'
                });
                return (value)=>value != null ? filterItemValue.some((filterValue)=>{
                        return collator.compare(filterValue, value.toString() || '') === 0;
                    }) : false;
            },
            InputComponent: (0, $661f336e4681898d$export$fec959c3691e0645)
        }
    ];


const $3e6386ba32760615$export$db6fa9d0a45573e4 = {
    width: 100,
    minWidth: 50,
    maxWidth: Infinity,
    hideable: true,
    sortable: true,
    resizable: true,
    filterable: true,
    groupable: true,
    pinnable: true,
    // @ts-ignore
    aggregable: true,
    chartable: true,
    editable: false,
    sortComparator: (0, $877e98c7ff4d0a4a$export$db324d0b741f4529),
    type: 'string',
    align: 'left',
    filterOperators: (0, $945683b39acb2c9b$export$dff3a5bcde5c5e41)(),
    renderEditCell: (0, $4a04192e6b868250$export$d1015f41e7e48c2e),
    getApplyQuickFilterFn: (0, $945683b39acb2c9b$export$4326c0ebf0c2f84b)
};







const $3fdd9d6a21ac304d$var$parseNumericValue = (value)=>{
    if (value == null) return null;
    return Number(value);
};
const $3fdd9d6a21ac304d$export$78c55b2f3096aac8 = (value)=>{
    if (value == null || Number.isNaN(value) || value === '') return null;
    return (columnValue)=>{
        return $3fdd9d6a21ac304d$var$parseNumericValue(columnValue) === $3fdd9d6a21ac304d$var$parseNumericValue(value);
    };
};
const $3fdd9d6a21ac304d$export$37d963e5ee49abc6 = ()=>[
        {
            value: '=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $3fdd9d6a21ac304d$var$parseNumericValue(value) === filterItem.value;
                };
            },
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '!=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    return $3fdd9d6a21ac304d$var$parseNumericValue(value) !== filterItem.value;
                };
            },
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $3fdd9d6a21ac304d$var$parseNumericValue(value) > filterItem.value;
                };
            },
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '>=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $3fdd9d6a21ac304d$var$parseNumericValue(value) >= filterItem.value;
                };
            },
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $3fdd9d6a21ac304d$var$parseNumericValue(value) < filterItem.value;
                };
            },
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: '<=',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || Number.isNaN(filterItem.value)) return null;
                return (value)=>{
                    if (value == null) return false;
                    return $3fdd9d6a21ac304d$var$parseNumericValue(value) <= filterItem.value;
                };
            },
            InputComponent: (0, $05b50a8c03e88d2f$export$99d1f108a3f21b3),
            InputComponentProps: {
                type: 'number'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                return (value)=>{
                    return value != null && filterItem.value.includes(Number(value));
                };
            },
            InputComponent: (0, $661f336e4681898d$export$fec959c3691e0645),
            InputComponentProps: {
                type: 'number'
            }
        }
    ];



const $170542d728408808$export$ba08f73736670f91 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $3e6386ba32760615$export$db6fa9d0a45573e4), {
    type: 'number',
    align: 'right',
    headerAlign: 'right',
    sortComparator: (0, $877e98c7ff4d0a4a$export$ecfdaa3722003888),
    valueParser: (value)=>value === '' ? null : Number(value),
    valueFormatter: (value)=>(0, $07a64ebfd26f4296$export$7e4aa119212bc614)(value) ? value.toLocaleString() : value || '',
    filterOperators: (0, $3fdd9d6a21ac304d$export$37d963e5ee49abc6)(),
    getApplyQuickFilterFn: (0, $3fdd9d6a21ac304d$export$78c55b2f3096aac8)
});







var $acw62 = parcelRequire("acw62");





'use client';
const $28a6a3b76b080f52$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "slotProps",
    "isFilterActive",
    "headerFilterMenu",
    "clearButton",
    "tabIndex",
    "disabled"
];
function $28a6a3b76b080f52$var$convertFilterItemValueToInputValue(itemValue, inputType) {
    if (itemValue == null) return '';
    const dateCopy = new Date(itemValue);
    if (Number.isNaN(dateCopy.getTime())) return '';
    if (inputType === 'date') return dateCopy.toISOString().substring(0, 10);
    if (inputType === 'datetime-local') {
        // The date picker expects the date to be in the local timezone.
        // But .toISOString() converts it to UTC with zero offset.
        // So we need to subtract the timezone offset.
        dateCopy.setMinutes(dateCopy.getMinutes() - dateCopy.getTimezoneOffset());
        return dateCopy.toISOString().substring(0, 19);
    }
    return dateCopy.toISOString().substring(0, 10);
}
function $28a6a3b76b080f52$export$f82b14e11ca0a1b4(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps, headerFilterMenu: headerFilterMenu, clearButton: clearButton, tabIndex: tabIndex, disabled: disabled } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $28a6a3b76b080f52$var$_excluded);
    const rootSlotProps = slotProps?.root.slotProps;
    const filterTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const [filterValueState, setFilterValueState] = $acw62.useState(()=>$28a6a3b76b080f52$var$convertFilterItemValueToInputValue(item.value, type));
    const [applying, setIsApplying] = $acw62.useState(false);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const onFilterChange = $acw62.useCallback((event)=>{
        filterTimeout.clear();
        const value = event.target.value;
        setFilterValueState(value);
        setIsApplying(true);
        filterTimeout.start(rootProps.filterDebounceMs, ()=>{
            const date = new Date(value);
            applyValue((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
                value: Number.isNaN(date.getTime()) ? undefined : date
            }));
            setIsApplying(false);
        });
    }, [
        applyValue,
        item,
        rootProps.filterDebounceMs,
        filterTimeout
    ]);
    $acw62.useEffect(()=>{
        const value = $28a6a3b76b080f52$var$convertFilterItemValueToInputValue(item.value, type);
        setFilterValueState(value);
    }, [
        item.value,
        type
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTextField, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                fullWidth: true,
                id: id,
                label: apiRef.current.getLocaleText('filterPanelInputLabel'),
                placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
                value: filterValueState,
                onChange: onFilterChange,
                type: type || 'text',
                disabled: disabled,
                inputRef: focusElementRef,
                slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootSlotProps, {
                    input: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        endAdornment: applying ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.loadIcon, {
                            fontSize: "small",
                            color: "action"
                        }) : null
                    }, rootSlotProps?.input),
                    htmlInput: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        max: type === 'datetime-local' ? '9999-12-31T23:59' : '9999-12-31',
                        tabIndex: tabIndex
                    }, rootSlotProps?.htmlInput)
                })
            }, rootProps.slotProps?.baseTextField, other, slotProps?.root)),
            headerFilterMenu,
            clearButton
        ]
    });
}


function $947a7cb82f78c5f4$var$buildApplyFilterFn(filterItem, compareFn, showTime, keepHours) {
    if (!filterItem.value) return null;
    const date = new Date(filterItem.value);
    if (showTime) date.setSeconds(0, 0);
    else {
        // In GMT-X timezone, the date will be one day behind.
        // For 2022-08-16:
        // GMT+2: Tue Aug 16 2022 02:00:00 GMT+0200
        // GMT-4: Mon Aug 15 2022 20:00:00 GMT-0400
        //
        // We need to add the offset before resetting the hours.
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        date.setHours(0, 0, 0, 0);
    }
    const time = date.getTime();
    return (value)=>{
        if (!value) return false;
        if (keepHours) return compareFn(value.getTime(), time);
        // Make a copy of the date to not reset the hours in the original object
        const dateCopy = new Date(value);
        if (showTime) dateCopy.setSeconds(0, 0);
        else dateCopy.setHours(0, 0, 0, 0);
        return compareFn(dateCopy.getTime(), time);
    };
}
const $947a7cb82f78c5f4$export$2fa54515db89172d = (showTime)=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                return $947a7cb82f78c5f4$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 === value2, showTime);
            },
            InputComponent: (0, $28a6a3b76b080f52$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                return $947a7cb82f78c5f4$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 !== value2, showTime);
            },
            InputComponent: (0, $28a6a3b76b080f52$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'after',
            getApplyFilterFn: (filterItem)=>{
                return $947a7cb82f78c5f4$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 > value2, showTime);
            },
            InputComponent: (0, $28a6a3b76b080f52$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrAfter',
            getApplyFilterFn: (filterItem)=>{
                return $947a7cb82f78c5f4$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 >= value2, showTime);
            },
            InputComponent: (0, $28a6a3b76b080f52$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'before',
            getApplyFilterFn: (filterItem)=>{
                return $947a7cb82f78c5f4$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 < value2, showTime, !showTime);
            },
            InputComponent: (0, $28a6a3b76b080f52$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'onOrBefore',
            getApplyFilterFn: (filterItem)=>{
                return $947a7cb82f78c5f4$var$buildApplyFilterFn(filterItem, (value1, value2)=>value1 <= value2, showTime);
            },
            InputComponent: (0, $28a6a3b76b080f52$export$f82b14e11ca0a1b4),
            InputComponentProps: {
                type: showTime ? 'datetime-local' : 'date'
            }
        },
        {
            value: 'isEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value == null;
                };
            },
            requiresFilterValue: false
        },
        {
            value: 'isNotEmpty',
            getApplyFilterFn: ()=>{
                return (value)=>{
                    return value != null;
                };
            },
            requiresFilterValue: false
        }
    ];






var $acw62 = parcelRequire("acw62");









'use client';
const $307352240c11a1fa$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "hasFocus",
    "inputProps",
    "isValidating",
    "isProcessingProps",
    "onValueChange",
    "slotProps"
];
const $307352240c11a1fa$var$StyledInputBase = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d))({
    fontSize: 'inherit'
});
const $307352240c11a1fa$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editInputCell'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
function $307352240c11a1fa$export$b4fb7433f4444e3f(props) {
    const { id: id, value: valueProp, field: field, colDef: colDef, hasFocus: hasFocus, onValueChange: onValueChange, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $307352240c11a1fa$var$_excluded);
    const isDateTime = colDef.type === 'dateTime';
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const inputRef = $acw62.useRef(null);
    const valueTransformed = $acw62.useMemo(()=>{
        let parsedDate;
        if (valueProp == null) parsedDate = null;
        else if (valueProp instanceof Date) parsedDate = valueProp;
        else parsedDate = new Date((valueProp ?? '').toString());
        let formattedDate;
        if (parsedDate == null || Number.isNaN(parsedDate.getTime())) formattedDate = '';
        else {
            const localDate = new Date(parsedDate.getTime() - parsedDate.getTimezoneOffset() * 60000);
            formattedDate = localDate.toISOString().substr(0, isDateTime ? 16 : 10);
        }
        return {
            parsed: parsedDate,
            formatted: formattedDate
        };
    }, [
        valueProp,
        isDateTime
    ]);
    const [valueState, setValueState] = $acw62.useState(valueTransformed);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $307352240c11a1fa$var$useUtilityClasses(ownerState);
    const parseValueToDate = $acw62.useCallback((value)=>{
        if (value === '') return null;
        const [date, time] = value.split('T');
        const [year, month, day] = date.split('-');
        const parsedDate = new Date();
        parsedDate.setFullYear(Number(year), Number(month) - 1, Number(day));
        parsedDate.setHours(0, 0, 0, 0);
        if (time) {
            const [hours, minutes] = time.split(':');
            parsedDate.setHours(Number(hours), Number(minutes), 0, 0);
        }
        return parsedDate;
    }, []);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newFormattedDate = event.target.value;
        const newParsedDate = parseValueToDate(newFormattedDate);
        if (onValueChange) await onValueChange(event, newParsedDate);
        setValueState({
            parsed: newParsedDate,
            formatted: newFormattedDate
        });
        apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: newParsedDate
        }, event);
    }, [
        apiRef,
        field,
        id,
        onValueChange,
        parseValueToDate
    ]);
    $acw62.useEffect(()=>{
        setValueState((state)=>{
            if (valueTransformed.parsed !== state.parsed && valueTransformed.parsed?.getTime() !== state.parsed?.getTime()) return valueTransformed;
            return state;
        });
    }, [
        valueTransformed
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($307352240c11a1fa$var$StyledInputBase, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        as: rootProps.slots.baseInput,
        inputRef: inputRef,
        fullWidth: true,
        className: classes.root,
        type: isDateTime ? 'datetime-local' : 'date',
        value: valueState.formatted,
        onChange: handleChange
    }, other, slotProps?.root, {
        slotProps: {
            htmlInput: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                max: isDateTime ? '9999-12-31T23:59' : '9999-12-31'
            }, slotProps?.root?.slotProps?.htmlInput)
        }
    }));
}
const $307352240c11a1fa$export$b815d37f7a90225c = (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($307352240c11a1fa$export$b4fb7433f4444e3f, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params));




const $4ab53eafabc4b920$export$433b924dc2506913 = `auto-generated-group-node-root`;
const $4ab53eafabc4b920$export$e8632b32bb8837db = Symbol('mui.id_autogenerated');
const $4ab53eafabc4b920$export$96a607054e9bfd0c = ()=>({
        type: 'group',
        id: $4ab53eafabc4b920$export$433b924dc2506913,
        depth: -1,
        groupingField: null,
        groupingKey: null,
        isAutoGenerated: true,
        children: [],
        childrenFromPath: {},
        childrenExpanded: true,
        parent: null
    });
function $4ab53eafabc4b920$export$de0419c0281531ca(id, row, detailErrorMessage = 'A row was provided without id in the rows prop:') {
    if (id == null) throw new Error([
        'MUI X: The Data Grid component requires all rows to have a unique `id` property.',
        'Alternatively, you can use the `getRowId` prop to specify a custom id for each row.',
        detailErrorMessage,
        JSON.stringify(row)
    ].join('\n'));
}
const $4ab53eafabc4b920$export$a95fb784d0ca2e72 = (rowModel, getRowId, detailErrorMessage)=>{
    const id = getRowId ? getRowId(rowModel) : rowModel.id;
    $4ab53eafabc4b920$export$de0419c0281531ca(id, rowModel, detailErrorMessage);
    return id;
};
const $4ab53eafabc4b920$export$67e819ef21602bdb = (row, colDef, apiRef)=>{
    const field = colDef.field;
    if (!colDef || !colDef.valueGetter) return row[field];
    const value = row[colDef.field];
    return colDef.valueGetter(value, row, colDef, apiRef);
};
const $4ab53eafabc4b920$export$3496927f169f2d35 = ({ rows: rows, getRowId: getRowId, loading: loading, rowCount: rowCount })=>{
    const updates = {
        type: 'full',
        rows: []
    };
    const dataRowIdToModelLookup = {};
    for(let i = 0; i < rows.length; i += 1){
        const model = rows[i];
        const id = $4ab53eafabc4b920$export$a95fb784d0ca2e72(model, getRowId);
        dataRowIdToModelLookup[id] = model;
        updates.rows.push(id);
    }
    return {
        rowsBeforePartialUpdates: rows,
        loadingPropBeforePartialUpdates: loading,
        rowCountPropBeforePartialUpdates: rowCount,
        updates: updates,
        dataRowIdToModelLookup: dataRowIdToModelLookup
    };
};
const $4ab53eafabc4b920$export$e6ee03f0394a9759 = ({ tree: tree, rowCountProp: rowCountProp = 0 })=>{
    const rootGroupNode = tree[$4ab53eafabc4b920$export$433b924dc2506913];
    return Math.max(rowCountProp, rootGroupNode.children.length + (rootGroupNode.footerId == null ? 0 : 1));
};
const $4ab53eafabc4b920$export$4dcb6d8dd06e4f39 = ({ apiRef: apiRef, rowCountProp: rowCountProp = 0, loadingProp: loadingProp, previousTree: previousTree, previousTreeDepths: previousTreeDepths, previousGroupsToFetch: previousGroupsToFetch })=>{
    const cache = apiRef.current.caches.rows;
    // 1. Apply the "rowTreeCreation" family processing.
    const { tree: unProcessedTree, treeDepths: unProcessedTreeDepths, dataRowIds: unProcessedDataRowIds, groupingName: groupingName, groupsToFetch: groupsToFetch = [] } = apiRef.current.applyStrategyProcessor('rowTreeCreation', {
        previousTree: previousTree,
        previousTreeDepths: previousTreeDepths,
        updates: cache.updates,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup,
        previousGroupsToFetch: previousGroupsToFetch
    });
    // 2. Apply the "hydrateRows" pipe-processing.
    const groupingParamsWithHydrateRows = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
        tree: unProcessedTree,
        treeDepths: unProcessedTreeDepths,
        dataRowIds: unProcessedDataRowIds,
        dataRowIdToModelLookup: cache.dataRowIdToModelLookup
    });
    // 3. Reset the cache updates
    apiRef.current.caches.rows.updates = {
        type: 'partial',
        actions: {
            insert: [],
            modify: [],
            remove: []
        },
        idToActionLookup: {}
    };
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, groupingParamsWithHydrateRows, {
        totalRowCount: Math.max(rowCountProp, groupingParamsWithHydrateRows.dataRowIds.length),
        totalTopLevelRowCount: $4ab53eafabc4b920$export$e6ee03f0394a9759({
            tree: groupingParamsWithHydrateRows.tree,
            rowCountProp: rowCountProp
        }),
        groupingName: groupingName,
        loading: loadingProp,
        groupsToFetch: groupsToFetch
    });
};
const $4ab53eafabc4b920$export$fe02ef72917d9a07 = (row)=>$4ab53eafabc4b920$export$e8632b32bb8837db in row;
const $4ab53eafabc4b920$export$5f983e16b1e55860 = (rowNode)=>rowNode.type === 'skeletonRow' || rowNode.type === 'footer' || rowNode.type === 'group' && rowNode.isAutoGenerated || rowNode.type === 'pinnedRow' && rowNode.isAutoGenerated;
const $4ab53eafabc4b920$export$9380f4bcafb87e49 = (tree, parentId, skipAutoGeneratedRows, directChildrenOnly)=>{
    const node = tree[parentId];
    if (node.type !== 'group') return [];
    const validDescendants = [];
    for(let i = 0; i < node.children.length; i += 1){
        const child = node.children[i];
        if (!skipAutoGeneratedRows || !$4ab53eafabc4b920$export$5f983e16b1e55860(tree[child])) validDescendants.push(child);
        if (directChildrenOnly) continue;
        const childDescendants = $4ab53eafabc4b920$export$9380f4bcafb87e49(tree, child, skipAutoGeneratedRows, directChildrenOnly);
        for(let j = 0; j < childDescendants.length; j += 1)validDescendants.push(childDescendants[j]);
    }
    if (!skipAutoGeneratedRows && node.footerId != null) validDescendants.push(node.footerId);
    return validDescendants;
};
const $4ab53eafabc4b920$export$b593607f8b00d104 = ({ previousCache: previousCache, getRowId: getRowId, updates: updates, groupKeys: groupKeys })=>{
    if (previousCache.updates.type === 'full') throw new Error('MUI X: Unable to prepare a partial update if a full update is not applied yet.');
    // Remove duplicate updates.
    // A server can batch updates, and send several updates for the same row in one fn call.
    const uniqueUpdates = new Map();
    updates.forEach((update)=>{
        const id = $4ab53eafabc4b920$export$a95fb784d0ca2e72(update, getRowId, 'A row was provided without id when calling updateRows():');
        if (uniqueUpdates.has(id)) uniqueUpdates.set(id, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, uniqueUpdates.get(id), update));
        else uniqueUpdates.set(id, update);
    });
    const partialUpdates = {
        type: 'partial',
        actions: {
            insert: [
                ...previousCache.updates.actions.insert ?? []
            ],
            modify: [
                ...previousCache.updates.actions.modify ?? []
            ],
            remove: [
                ...previousCache.updates.actions.remove ?? []
            ]
        },
        idToActionLookup: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousCache.updates.idToActionLookup),
        groupKeys: groupKeys
    };
    const dataRowIdToModelLookup = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousCache.dataRowIdToModelLookup);
    const alreadyAppliedActionsToRemove = {
        insert: {},
        modify: {},
        remove: {}
    };
    // Depending on the action already applied to the data row,
    // We might want drop the already-applied-update.
    // For instance:
    // - if you delete then insert, then you don't want to apply the deletion in the tree.
    // - if you insert, then modify, then you just want to apply the insertion in the tree.
    uniqueUpdates.forEach((partialRow, id)=>{
        const actionAlreadyAppliedToRow = partialUpdates.idToActionLookup[id];
        // Action === "delete"
        // eslint-disable-next-line no-underscore-dangle
        if (partialRow._action === 'delete') {
            // If the data row has been removed since the last state update,
            // Then do nothing.
            if (actionAlreadyAppliedToRow === 'remove' || !dataRowIdToModelLookup[id]) return;
            // If the data row has been inserted / modified since the last state update,
            // Then drop this "insert" / "modify" update.
            if (actionAlreadyAppliedToRow != null) alreadyAppliedActionsToRemove[actionAlreadyAppliedToRow][id] = true;
            // Remove the data row from the lookups and add it to the "delete" update.
            partialUpdates.actions.remove.push(id);
            delete dataRowIdToModelLookup[id];
            return;
        }
        const oldRow = dataRowIdToModelLookup[id];
        // Action === "modify"
        if (oldRow) {
            // If the data row has been removed since the last state update,
            // Then drop this "remove" update and add it to the "modify" update instead.
            if (actionAlreadyAppliedToRow === 'remove') {
                alreadyAppliedActionsToRemove.remove[id] = true;
                partialUpdates.actions.modify.push(id);
            } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.modify.push(id);
            // Update the data row lookups.
            dataRowIdToModelLookup[id] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, oldRow, partialRow);
            return;
        }
        // Action === "insert"
        // If the data row has been removed since the last state update,
        // Then drop the "remove" update and add it to the "insert" update instead.
        if (actionAlreadyAppliedToRow === 'remove') {
            alreadyAppliedActionsToRemove.remove[id] = true;
            partialUpdates.actions.insert.push(id);
        } else if (actionAlreadyAppliedToRow == null) partialUpdates.actions.insert.push(id);
        // Update the data row lookups.
        dataRowIdToModelLookup[id] = partialRow;
    });
    const actionTypeWithActionsToRemove = Object.keys(alreadyAppliedActionsToRemove);
    for(let i = 0; i < actionTypeWithActionsToRemove.length; i += 1){
        const actionType = actionTypeWithActionsToRemove[i];
        const idsToRemove = alreadyAppliedActionsToRemove[actionType];
        if (Object.keys(idsToRemove).length > 0) partialUpdates.actions[actionType] = partialUpdates.actions[actionType].filter((id)=>!idsToRemove[id]);
    }
    return {
        dataRowIdToModelLookup: dataRowIdToModelLookup,
        updates: partialUpdates,
        rowsBeforePartialUpdates: previousCache.rowsBeforePartialUpdates,
        loadingPropBeforePartialUpdates: previousCache.loadingPropBeforePartialUpdates,
        rowCountPropBeforePartialUpdates: previousCache.rowCountPropBeforePartialUpdates
    };
};
const $4ab53eafabc4b920$export$a95780409968416e = 'var(--DataGrid-overlayHeight, calc(var(--height) * 2))';
function $4ab53eafabc4b920$export$1560eaf12ed72130(apiRef, updates, getRowId) {
    const nonPinnedRowsUpdates = [];
    updates.forEach((update)=>{
        const id = $4ab53eafabc4b920$export$a95fb784d0ca2e72(update, getRowId, 'A row was provided without id when calling updateRows():');
        const rowNode = (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, id);
        if (rowNode?.type === 'pinnedRow') {
            // @ts-ignore because otherwise `release:build` doesn't work
            const pinnedRowsCache = apiRef.current.caches.pinnedRows;
            const prevModel = pinnedRowsCache.idLookup[id];
            if (prevModel) pinnedRowsCache.idLookup[id] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevModel, update);
        } else nonPinnedRowsUpdates.push(update);
    });
    return nonPinnedRowsUpdates;
}
let $4ab53eafabc4b920$var$warnedOnceInvalidRowHeight = false;
const $4ab53eafabc4b920$export$fa15c17c0798a441 = (rowHeightProp, defaultRowHeight, warningMessage)=>{
    if (typeof rowHeightProp === 'number' && rowHeightProp > 0) return rowHeightProp;
    return defaultRowHeight;
};
const $4ab53eafabc4b920$export$abf6a2a1a7dde56b = [
    `MUI X: The \`rowHeight\` prop should be a number greater than 0.`,
    `The default value will be used instead.`
].join('\n');
const $4ab53eafabc4b920$export$b35665e48a78b958 = [
    `MUI X: The \`getRowHeight\` prop should return a number greater than 0 or 'auto'.`,
    `The default value will be used instead.`
].join('\n');



const $f84d89d92301bd81$export$5e766ecd73f055ed = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state, row)=>{
    if ((0, $4ab53eafabc4b920$export$e8632b32bb8837db) in row) return row[0, $4ab53eafabc4b920$export$e8632b32bb8837db];
    return state.props.getRowId ? state.props.getRowId(row) : row.id;
});



function $fbc056db19043e98$var$throwIfNotDateObject({ value: value, columnType: columnType, rowId: rowId, field: field }) {
    if (!(value instanceof Date)) throw new Error([
        `MUI X: \`${columnType}\` column type only accepts \`Date\` objects as values.`,
        'Use `valueGetter` to transform the value into a `Date` object.',
        `Row ID: ${rowId}, field: "${field}".`
    ].join('\n'));
}
const $fbc056db19043e98$export$c46cd449e66842a5 = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $f84d89d92301bd81$export$5e766ecd73f055ed)(apiRef, row);
    if ((0, $4ab53eafabc4b920$export$fe02ef72917d9a07)(row) && !(value instanceof Date)) return value;
    $fbc056db19043e98$var$throwIfNotDateObject({
        value: value,
        columnType: 'date',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleDateString();
};
const $fbc056db19043e98$export$a62990620750ce8c = (value, row, column, apiRef)=>{
    if (!value) return '';
    const rowId = (0, $f84d89d92301bd81$export$5e766ecd73f055ed)(apiRef, row);
    if ((0, $4ab53eafabc4b920$export$fe02ef72917d9a07)(row) && !(value instanceof Date)) return value;
    $fbc056db19043e98$var$throwIfNotDateObject({
        value: value,
        columnType: 'dateTime',
        rowId: rowId,
        field: column.field
    });
    return value.toLocaleString();
};
const $fbc056db19043e98$export$4c3b89749ea40e50 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $3e6386ba32760615$export$db6fa9d0a45573e4), {
    type: 'date',
    sortComparator: (0, $877e98c7ff4d0a4a$export$74e685f55e96d6bc),
    valueFormatter: $fbc056db19043e98$export$c46cd449e66842a5,
    filterOperators: (0, $947a7cb82f78c5f4$export$2fa54515db89172d)(),
    renderEditCell: (0, $307352240c11a1fa$export$b815d37f7a90225c),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});
const $fbc056db19043e98$export$5bc7079eed6f3d7f = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $3e6386ba32760615$export$db6fa9d0a45573e4), {
    type: 'dateTime',
    sortComparator: (0, $877e98c7ff4d0a4a$export$74e685f55e96d6bc),
    valueFormatter: $fbc056db19043e98$export$a62990620750ce8c,
    filterOperators: (0, $947a7cb82f78c5f4$export$2fa54515db89172d)(true),
    renderEditCell: (0, $307352240c11a1fa$export$b815d37f7a90225c),
    // @ts-ignore
    pastedValueParser: (value)=>new Date(value)
});







var $acw62 = parcelRequire("acw62");








const $d6d7a429fd810b6e$export$9cce4aaa860dd90a = '__tree_data_group__';
const $d6d7a429fd810b6e$export$bc5b5ba34587442e = '__row_group_by_columns_group__';
const $d6d7a429fd810b6e$export$6e5a576305a34719 = '__detail_panel_toggle__';
let $d6d7a429fd810b6e$export$f35946017bbd5a24 = /*#__PURE__*/ function(PinnedColumnPosition) {
    PinnedColumnPosition[PinnedColumnPosition["NONE"] = 0] = "NONE";
    PinnedColumnPosition[PinnedColumnPosition["LEFT"] = 1] = "LEFT";
    PinnedColumnPosition[PinnedColumnPosition["RIGHT"] = 2] = "RIGHT";
    PinnedColumnPosition[PinnedColumnPosition["VIRTUAL"] = 3] = "VIRTUAL";
    return PinnedColumnPosition;
}({});



const $a88e5b60cfd880df$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "hasFocus",
    "tabIndex",
    "hideDescendantCount"
];
const $a88e5b60cfd880df$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'booleanCell'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
function $a88e5b60cfd880df$var$GridBooleanCellRaw(props) {
    const { value: value, rowNode: rowNode } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a88e5b60cfd880df$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $a88e5b60cfd880df$var$useUtilityClasses(ownerState);
    const maxDepth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$4cdbe576751dd8e2));
    const isServerSideRowGroupingRow = // @ts-expect-error - Access tree data prop
    maxDepth > 0 && rowNode.type === 'group' && rootProps.treeData === false;
    const Icon = $acw62.useMemo(()=>value ? rootProps.slots.booleanCellTrueIcon : rootProps.slots.booleanCellFalseIcon, [
        rootProps.slots.booleanCellFalseIcon,
        rootProps.slots.booleanCellTrueIcon,
        value
    ]);
    if (isServerSideRowGroupingRow && value === undefined) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        fontSize: "small",
        className: classes.root,
        titleAccess: apiRef.current.getLocaleText(value ? 'booleanCellTrueLabel' : 'booleanCellFalseLabel'),
        "data-value": Boolean(value)
    }, other));
}
const $a88e5b60cfd880df$export$9cc4d0e939884340 = /*#__PURE__*/ $acw62.memo($a88e5b60cfd880df$var$GridBooleanCellRaw);
const $a88e5b60cfd880df$export$6c5a2392a8d4c6d6 = (params)=>{
    if (params.field !== (0, $d6d7a429fd810b6e$export$bc5b5ba34587442e) && (0, $4ab53eafabc4b920$export$5f983e16b1e55860)(params.rowNode)) return '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a88e5b60cfd880df$export$9cc4d0e939884340, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params));
};





var $acw62 = parcelRequire("acw62");









'use client';
const $888c5f49011e366c$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange"
];
const $888c5f49011e366c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'editBooleanCell'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
function $888c5f49011e366c$export$22bee653ea92336f(props) {
    const { id: idProp, value: value, field: field, className: className, hasFocus: hasFocus, onValueChange: onValueChange } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $888c5f49011e366c$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const inputRef = $acw62.useRef(null);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const [valueState, setValueState] = $acw62.useState(value);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $888c5f49011e366c$var$useUtilityClasses(ownerState);
    const handleChange = $acw62.useCallback(async (event)=>{
        const newValue = event.target.checked;
        if (onValueChange) await onValueChange(event, newValue);
        setValueState(newValue);
        await apiRef.current.setEditCellValue({
            id: idProp,
            field: field,
            value: newValue
        }, event);
    }, [
        apiRef,
        field,
        idProp,
        onValueChange
    ]);
    $acw62.useEffect(()=>{
        setValueState(value);
    }, [
        value
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current.focus();
    }, [
        hasFocus
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        htmlFor: id,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseCheckbox, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            id: id,
            inputRef: inputRef,
            checked: Boolean(valueState),
            onChange: handleChange,
            size: "small"
        }, rootProps.slotProps?.baseCheckbox))
    }));
}
const $888c5f49011e366c$export$9ef52be99fb661 = (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($888c5f49011e366c$export$22bee653ea92336f, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params));






var $acw62 = parcelRequire("acw62");





'use client';
const $9f5ac00c3049d4a3$var$_excluded = [
    "item",
    "applyValue",
    "apiRef",
    "focusElementRef",
    "isFilterActive",
    "headerFilterMenu",
    "clearButton",
    "tabIndex",
    "slotProps"
];
function $9f5ac00c3049d4a3$export$f1030df85ee00af9(props) {
    const { item: item, applyValue: applyValue, apiRef: apiRef, focusElementRef: focusElementRef, headerFilterMenu: headerFilterMenu, clearButton: clearButton, tabIndex: tabIndex, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9f5ac00c3049d4a3$var$_excluded);
    const [filterValueState, setFilterValueState] = $acw62.useState($9f5ac00c3049d4a3$export$ed06ceaa973db73f(item.value));
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const labelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const selectId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const onFilterChange = $acw62.useCallback((event)=>{
        const value = $9f5ac00c3049d4a3$export$ed06ceaa973db73f(event.target.value);
        setFilterValueState(value);
        applyValue((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
            value: value
        }));
    }, [
        applyValue,
        item
    ]);
    $acw62.useEffect(()=>{
        setFilterValueState($9f5ac00c3049d4a3$export$ed06ceaa973db73f(item.value));
    }, [
        item.value
    ]);
    const label = slotProps?.root.label ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    const rootSlotProps = slotProps?.root.slotProps;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(rootProps.slots.baseSelect, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                fullWidth: true,
                labelId: labelId,
                id: selectId,
                label: label,
                value: filterValueState === undefined ? '' : String(filterValueState),
                onChange: onFilterChange,
                native: isSelectNative,
                slotProps: {
                    htmlInput: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        ref: focusElementRef,
                        tabIndex: tabIndex
                    }, rootSlotProps?.htmlInput)
                }
            }, baseSelectProps, other, slotProps?.root, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseSelectOption, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "",
                        children: apiRef.current.getLocaleText('filterValueAny')
                    })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseSelectOption, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "true",
                        children: apiRef.current.getLocaleText('filterValueTrue')
                    })),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseSelectOption, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                        native: isSelectNative,
                        value: "false",
                        children: apiRef.current.getLocaleText('filterValueFalse')
                    }))
                ]
            })),
            headerFilterMenu,
            clearButton
        ]
    });
}
function $9f5ac00c3049d4a3$export$ed06ceaa973db73f(value) {
    if (String(value).toLowerCase() === 'true') return true;
    if (String(value).toLowerCase() === 'false') return false;
    return undefined;
}


const $2e56ac04572c23ce$export$906a46f6c2359ef6 = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                const sanitizedValue = (0, $9f5ac00c3049d4a3$export$ed06ceaa973db73f)(filterItem.value);
                if (sanitizedValue === undefined) return null;
                return (value)=>Boolean(value) === sanitizedValue;
            },
            InputComponent: (0, $9f5ac00c3049d4a3$export$f1030df85ee00af9)
        }
    ];


const $ccbab3147b17f664$var$gridBooleanFormatter = (value, row, column, apiRef)=>{
    return value ? apiRef.current.getLocaleText('booleanCellTrueLabel') : apiRef.current.getLocaleText('booleanCellFalseLabel');
};
const $ccbab3147b17f664$var$stringToBoolean = (value)=>{
    switch(value.toLowerCase().trim()){
        case 'true':
        case 'yes':
        case '1':
            return true;
        case 'false':
        case 'no':
        case '0':
        case 'null':
        case 'undefined':
            return false;
        default:
            return undefined;
    }
};
const $ccbab3147b17f664$export$220b51460e149ea9 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $3e6386ba32760615$export$db6fa9d0a45573e4), {
    type: 'boolean',
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    renderCell: (0, $a88e5b60cfd880df$export$6c5a2392a8d4c6d6),
    renderEditCell: (0, $888c5f49011e366c$export$9ef52be99fb661),
    sortComparator: (0, $877e98c7ff4d0a4a$export$ecfdaa3722003888),
    valueFormatter: $ccbab3147b17f664$var$gridBooleanFormatter,
    filterOperators: (0, $2e56ac04572c23ce$export$906a46f6c2359ef6)(),
    getApplyQuickFilterFn: ()=>null,
    // @ts-ignore
    aggregable: false,
    chartable: false,
    // @ts-ignore
    pastedValueParser: (value)=>$ccbab3147b17f664$var$stringToBoolean(value)
});







var $acw62 = parcelRequire("acw62");


/**
 * Params passed to `apiRef.current.setEditCellValue`.
 */ var $b0887bea925b8b78$export$66744c3b0d0c6217 = /*#__PURE__*/ function(GridCellEditStartReasons) {
    GridCellEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridCellEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridCellEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    GridCellEditStartReasons["pasteKeyDown"] = "pasteKeyDown";
    return GridCellEditStartReasons;
}($b0887bea925b8b78$export$66744c3b0d0c6217 || {});
/**
 * Params passed to the `cellEditStart` event.
 */ var $b0887bea925b8b78$export$73fccbaa325472ee = /*#__PURE__*/ function(GridCellEditStopReasons) {
    GridCellEditStopReasons["cellFocusOut"] = "cellFocusOut";
    GridCellEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridCellEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridCellEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridCellEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridCellEditStopReasons;
}($b0887bea925b8b78$export$73fccbaa325472ee || {});



var $181c044302967209$export$bad6b7a934346f26 = /*#__PURE__*/ function(GridEditModes) {
    GridEditModes["Cell"] = "cell";
    GridEditModes["Row"] = "row";
    return GridEditModes;
}($181c044302967209$export$bad6b7a934346f26 || {});
var $181c044302967209$export$84e4fdd8f295ca31 = /*#__PURE__*/ function(GridCellModes) {
    GridCellModes["Edit"] = "edit";
    GridCellModes["View"] = "view";
    return GridCellModes;
}($181c044302967209$export$84e4fdd8f295ca31 || {});
var $181c044302967209$export$d98c76b959bb0b5c = /*#__PURE__*/ function(GridRowModes) {
    GridRowModes["Edit"] = "edit";
    GridRowModes["View"] = "view";
    return GridRowModes;
}($181c044302967209$export$d98c76b959bb0b5c || {});



function $be429daa670a91f7$export$74006a51f68c6262(colDef) {
    return colDef?.type === 'singleSelect';
}
function $be429daa670a91f7$export$b871910a1101d890(column, additionalParams) {
    if (!column) return undefined;
    return typeof column.valueOptions === 'function' ? column.valueOptions((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        field: column.field
    }, additionalParams)) : column.valueOptions;
}
function $be429daa670a91f7$export$b31a7985e33f7505(value, valueOptions, getOptionValue) {
    if (valueOptions === undefined) return undefined;
    const result = valueOptions.find((option)=>{
        const optionValue = getOptionValue(option);
        return String(optionValue) === String(value);
    });
    return getOptionValue(result);
}




'use client';
const $ca85994650549ff8$var$_excluded = [
    "id",
    "value",
    "formattedValue",
    "api",
    "field",
    "row",
    "rowNode",
    "colDef",
    "cellMode",
    "isEditable",
    "tabIndex",
    "className",
    "hasFocus",
    "isValidating",
    "isProcessingProps",
    "error",
    "onValueChange",
    "initialOpen",
    "slotProps"
];
function $ca85994650549ff8$var$isKeyboardEvent(event) {
    return 'key' in event && !!event.key;
}
function $ca85994650549ff8$export$df7446df636ddbed(props) {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { id: id, value: valueProp, field: field, row: row, colDef: colDef, hasFocus: hasFocus, error: error, onValueChange: onValueChange, initialOpen: initialOpen = rootProps.editMode === (0, $181c044302967209$export$bad6b7a934346f26).Cell, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $ca85994650549ff8$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const ref = $acw62.useRef(null);
    const inputRef = $acw62.useRef(null);
    const [open, setOpen] = $acw62.useState(initialOpen);
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isSelectNative = baseSelectProps.native ?? false;
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (hasFocus) inputRef.current?.focus();
    }, [
        hasFocus
    ]);
    if (!(0, $be429daa670a91f7$export$74006a51f68c6262)(colDef)) return null;
    const valueOptions = (0, $be429daa670a91f7$export$b871910a1101d890)(colDef, {
        id: id,
        row: row
    });
    if (!valueOptions) return null;
    const getOptionValue = colDef.getOptionValue;
    const getOptionLabel = colDef.getOptionLabel;
    const handleChange = async (event)=>{
        if (!(0, $be429daa670a91f7$export$74006a51f68c6262)(colDef) || !valueOptions) return;
        setOpen(false);
        const target = event.target;
        // NativeSelect casts the value to a string.
        const formattedTargetValue = (0, $be429daa670a91f7$export$b31a7985e33f7505)(target.value, valueOptions, getOptionValue);
        if (onValueChange) await onValueChange(event, formattedTargetValue);
        await apiRef.current.setEditCellValue({
            id: id,
            field: field,
            value: formattedTargetValue
        }, event);
    };
    const handleClose = (event, reason)=>{
        if (rootProps.editMode === (0, $181c044302967209$export$bad6b7a934346f26).Row) {
            setOpen(false);
            return;
        }
        if (reason === 'backdropClick' || event.key === 'Escape') {
            const params = apiRef.current.getCellParams(id, field);
            apiRef.current.publishEvent('cellEditStop', (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
                reason: event.key === 'Escape' ? (0, $b0887bea925b8b78$export$73fccbaa325472ee).escapeKeyDown : (0, $b0887bea925b8b78$export$73fccbaa325472ee).cellFocusOut
            }));
        }
    };
    const handleOpen = (event)=>{
        if ($ca85994650549ff8$var$isKeyboardEvent(event) && event.key === 'Enter') return;
        setOpen(true);
    };
    if (!valueOptions || !colDef) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseSelect, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: ref,
        value: valueProp,
        onChange: handleChange,
        open: open,
        onOpen: handleOpen,
        onClose: handleClose,
        error: error,
        native: isSelectNative,
        fullWidth: true,
        slotProps: {
            htmlInput: {
                ref: inputRef
            }
        }
    }, other, slotProps?.root, rootProps.slotProps?.baseSelect, {
        children: valueOptions.map((valueOption)=>{
            const value = getOptionValue(valueOption);
            return /*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseSelectOption || {}, {
                native: isSelectNative,
                key: value,
                value: value
            }), getOptionLabel(valueOption));
        })
    }));
}
const $ca85994650549ff8$export$13060fab7d49b7a1 = (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ca85994650549ff8$export$df7446df636ddbed, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params));





var $acw62 = parcelRequire("acw62");





const $d7ce620800a4005c$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "tabIndex",
    "isFilterActive",
    "clearButton",
    "headerFilterMenu",
    "slotProps"
];
const $d7ce620800a4005c$var$renderSingleSelectOptions = ({ column: column, OptionComponent: OptionComponent, getOptionLabel: getOptionLabel, getOptionValue: getOptionValue, isSelectNative: isSelectNative, baseSelectOptionProps: baseSelectOptionProps })=>{
    const iterableColumnValues = [
        '',
        ...(0, $be429daa670a91f7$export$b871910a1101d890)(column) || []
    ];
    return iterableColumnValues.map((option)=>{
        const value = getOptionValue(option);
        let label = getOptionLabel(option);
        if (label === '') label = "\u2003"; // To force the height of the empty option
        return /*#__PURE__*/ (0, $acw62.createElement)(OptionComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
            native: isSelectNative,
            key: value,
            value: value
        }), label);
    });
};
function $d7ce620800a4005c$export$760eb819dd95d361(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, tabIndex: tabIndex, clearButton: clearButton, headerFilterMenu: headerFilterMenu, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d7ce620800a4005c$var$_excluded);
    const filterValue = item.value ?? '';
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const labelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const isSelectNative = rootProps.slotProps?.baseSelect?.native ?? false;
    const resolvedColumn = apiRef.current.getColumn(item.field);
    const getOptionValue = resolvedColumn.getOptionValue;
    const getOptionLabel = resolvedColumn.getOptionLabel;
    const currentValueOptions = $acw62.useMemo(()=>{
        return (0, $be429daa670a91f7$export$b871910a1101d890)(resolvedColumn);
    }, [
        resolvedColumn
    ]);
    const onFilterChange = $acw62.useCallback((event)=>{
        let value = event.target.value;
        // NativeSelect casts the value to a string.
        value = (0, $be429daa670a91f7$export$b31a7985e33f7505)(value, currentValueOptions, getOptionValue);
        applyValue((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
            value: value
        }));
    }, [
        currentValueOptions,
        getOptionValue,
        applyValue,
        item
    ]);
    if (!resolvedColumn || !(0, $be429daa670a91f7$export$74006a51f68c6262)(resolvedColumn)) return null;
    const label = slotProps?.root.label ?? apiRef.current.getLocaleText('filterPanelInputLabel');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseSelect, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                fullWidth: true,
                id: id,
                label: label,
                labelId: labelId,
                value: filterValue,
                onChange: onFilterChange,
                slotProps: {
                    htmlInput: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        tabIndex: tabIndex,
                        ref: focusElementRef,
                        type: type || 'text',
                        placeholder: slotProps?.root.placeholder ?? apiRef.current.getLocaleText('filterPanelInputPlaceholder')
                    }, slotProps?.root.slotProps?.htmlInput)
                },
                native: isSelectNative
            }, rootProps.slotProps?.baseSelect, other, slotProps?.root, {
                children: $d7ce620800a4005c$var$renderSingleSelectOptions({
                    column: resolvedColumn,
                    OptionComponent: rootProps.slots.baseSelectOption,
                    getOptionLabel: getOptionLabel,
                    getOptionValue: getOptionValue,
                    isSelectNative: isSelectNative,
                    baseSelectOptionProps: rootProps.slotProps?.baseSelectOption
                })
            })),
            headerFilterMenu,
            clearButton
        ]
    });
}





var $acw62 = parcelRequire("acw62");





const $9db6f7703f4aef53$var$_excluded = [
    "item",
    "applyValue",
    "type",
    "apiRef",
    "focusElementRef",
    "slotProps"
];
function $9db6f7703f4aef53$export$a61be354e4fcf2c5(props) {
    const { item: item, applyValue: applyValue, type: type, apiRef: apiRef, focusElementRef: focusElementRef, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9db6f7703f4aef53$var$_excluded);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const resolvedColumn = apiRef.current.getColumn(item.field);
    const getOptionValue = resolvedColumn.getOptionValue;
    const getOptionLabel = resolvedColumn.getOptionLabel;
    const isOptionEqualToValue = $acw62.useCallback((option, value)=>getOptionValue(option) === getOptionValue(value), [
        getOptionValue
    ]);
    const resolvedValueOptions = $acw62.useMemo(()=>{
        return (0, $be429daa670a91f7$export$b871910a1101d890)(resolvedColumn) || [];
    }, [
        resolvedColumn
    ]);
    // The value is computed from the item.value and used directly
    // If it was done by a useEffect/useState, the Autocomplete could receive incoherent value and options
    const filteredValues = $acw62.useMemo(()=>{
        if (!Array.isArray(item.value)) return [];
        return item.value.reduce((acc, value)=>{
            const resolvedValue = resolvedValueOptions.find((v)=>getOptionValue(v) === value);
            if (resolvedValue != null) acc.push(resolvedValue);
            return acc;
        }, []);
    }, [
        getOptionValue,
        item.value,
        resolvedValueOptions
    ]);
    const handleChange = $acw62.useCallback((event, value)=>{
        applyValue((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
            value: value.map(getOptionValue)
        }));
    }, [
        applyValue,
        item,
        getOptionValue
    ]);
    if (!resolvedColumn || !(0, $be429daa670a91f7$export$74006a51f68c6262)(resolvedColumn)) return null;
    const BaseAutocomplete = rootProps.slots.baseAutocomplete;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BaseAutocomplete, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        multiple: true,
        options: resolvedValueOptions,
        isOptionEqualToValue: isOptionEqualToValue,
        id: id,
        value: filteredValues,
        onChange: handleChange,
        getOptionLabel: getOptionLabel,
        label: apiRef.current.getLocaleText('filterPanelInputLabel'),
        placeholder: apiRef.current.getLocaleText('filterPanelInputPlaceholder'),
        slotProps: {
            textField: {
                type: type || 'text',
                inputRef: focusElementRef
            }
        }
    }, other, slotProps?.root));
}



const $4697414880df61a0$var$parseObjectValue = (value)=>{
    if (value == null || !(0, $07a64ebfd26f4296$export$a6cdc56e425d0d0a)(value)) return value;
    return value.value;
};
const $4697414880df61a0$export$fe632a61ba1bdc90 = ()=>[
        {
            value: 'is',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$4697414880df61a0$var$parseObjectValue(value) === $4697414880df61a0$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $d7ce620800a4005c$export$760eb819dd95d361)
        },
        {
            value: 'not',
            getApplyFilterFn: (filterItem)=>{
                if (filterItem.value == null || filterItem.value === '') return null;
                return (value)=>$4697414880df61a0$var$parseObjectValue(value) !== $4697414880df61a0$var$parseObjectValue(filterItem.value);
            },
            InputComponent: (0, $d7ce620800a4005c$export$760eb819dd95d361)
        },
        {
            value: 'isAnyOf',
            getApplyFilterFn: (filterItem)=>{
                if (!Array.isArray(filterItem.value) || filterItem.value.length === 0) return null;
                const filterItemValues = filterItem.value.map($4697414880df61a0$var$parseObjectValue);
                return (value)=>filterItemValues.includes($4697414880df61a0$var$parseObjectValue(value));
            },
            InputComponent: (0, $9db6f7703f4aef53$export$a61be354e4fcf2c5)
        }
    ];





const $ca71555e523099ad$var$isArrayOfObjects = (options)=>{
    return typeof options[0] === 'object';
};
const $ca71555e523099ad$var$defaultGetOptionValue = (value)=>{
    return (0, $07a64ebfd26f4296$export$a6cdc56e425d0d0a)(value) ? value.value : value;
};
const $ca71555e523099ad$var$defaultGetOptionLabel = (value)=>{
    return (0, $07a64ebfd26f4296$export$a6cdc56e425d0d0a)(value) ? value.label : String(value);
};
const $ca71555e523099ad$export$7acf0d6e5e468a51 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $3e6386ba32760615$export$db6fa9d0a45573e4), {
    type: 'singleSelect',
    getOptionLabel: $ca71555e523099ad$var$defaultGetOptionLabel,
    getOptionValue: $ca71555e523099ad$var$defaultGetOptionValue,
    valueFormatter (value, row, colDef, apiRef) {
        const rowId = (0, $f84d89d92301bd81$export$5e766ecd73f055ed)(apiRef, row);
        if (!(0, $be429daa670a91f7$export$74006a51f68c6262)(colDef)) return '';
        const valueOptions = (0, $be429daa670a91f7$export$b871910a1101d890)(colDef, {
            id: rowId,
            row: row
        });
        if (value == null) return '';
        if (!valueOptions) return value;
        if (!$ca71555e523099ad$var$isArrayOfObjects(valueOptions)) return colDef.getOptionLabel(value);
        const valueOption = valueOptions.find((option)=>colDef.getOptionValue(option) === value);
        return valueOption ? colDef.getOptionLabel(valueOption) : '';
    },
    renderEditCell: (0, $ca85994650549ff8$export$13060fab7d49b7a1),
    filterOperators: (0, $4697414880df61a0$export$fe632a61ba1bdc90)(),
    // @ts-ignore
    pastedValueParser: (value, row, column)=>{
        const colDef = column;
        const valueOptions = (0, $be429daa670a91f7$export$b871910a1101d890)(colDef) || [];
        const getOptionValue = colDef.getOptionValue;
        const valueOption = valueOptions.find((option)=>{
            if (getOptionValue(option) === value) return true;
            return false;
        });
        if (valueOption) return value;
        // do not paste the value if it is not in the valueOptions
        return undefined;
    }
});







var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");






// Non printable keys have a name, for example "ArrowRight", see the whole list:
// https://developer.mozilla.org/en-US/docs/Web/API/UI_Events/Keyboard_event_key_values
// So event.key.length === 1 is often enough.
//
// However, we also need to ignore shortcuts, for example: select all:
// - Windows: Ctrl+A, event.ctrlKey is true
// - macOS: ⌘ Command+A, event.metaKey is true
function $2c033a607636d88a$export$b3f2c64190cf8c4(event) {
    return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
const $2c033a607636d88a$export$b7d709ba679d3811 = [
    'Meta',
    'Control',
    'Shift'
];
const $2c033a607636d88a$export$cb76cac5e13767b3 = [
    'Enter',
    'Escape',
    'Tab'
];
const $2c033a607636d88a$export$88516d667267d515 = [
    'Enter',
    'Tab'
];
const $2c033a607636d88a$export$6ac2fcffa1f825f7 = (key)=>$2c033a607636d88a$export$b7d709ba679d3811.indexOf(key) > -1;
const $2c033a607636d88a$export$a8f5f024431d9642 = (event)=>$2c033a607636d88a$export$b3f2c64190cf8c4(event) || event.key === 'Enter' || event.key === 'Backspace' || event.key === 'Delete';
const $2c033a607636d88a$export$f6a96f75820f81fd = (key)=>$2c033a607636d88a$export$cb76cac5e13767b3.indexOf(key) > -1;
const $2c033a607636d88a$export$d3e9cf1edead7ecb = (key)=>$2c033a607636d88a$export$88516d667267d515.indexOf(key) > -1;
const $2c033a607636d88a$export$e13d96c38a470518 = (key)=>key.indexOf('Arrow') === 0 || key.indexOf('Page') === 0 || key === ' ' || key === 'Home' || key === 'End';
const $2c033a607636d88a$export$130b789831072f4c = (event)=>!!event.key;
const $2c033a607636d88a$export$81301abbcd0c8143 = (key)=>key === 'Tab' || key === 'Escape';
function $2c033a607636d88a$export$dc044e3b830c7edc(event) {
    return (event.ctrlKey || event.metaKey) && // We can't use event.code === 'KeyV' as event.code assumes a QWERTY keyboard layout,
    // for example, it would be another letter on a Dvorak physical keyboard.
    // We can't use event.key === 'v' as event.key is not stable with key modifiers and keyboard layouts,
    // for example, it would be ה on a Hebrew keyboard layout.
    // https://github.com/w3c/uievents/issues/377 could be a long-term solution
    String.fromCharCode(event.keyCode) === 'V' && !event.shiftKey && !event.altKey;
}
function $2c033a607636d88a$export$b3bab6a2e94206d4(event) {
    return (event.ctrlKey || event.metaKey) && String.fromCharCode(event.keyCode) === 'C' && !event.shiftKey && !event.altKey;
}









'use client';
const $dbffbc66fe757e53$var$_excluded = [
    "open",
    "target",
    "onClose",
    "children",
    "position",
    "className",
    "onExited"
];
const $dbffbc66fe757e53$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'menu'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $dbffbc66fe757e53$var$GridMenuRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d), {
    name: 'MuiDataGrid',
    slot: 'Menu'
})({
    zIndex: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).zIndex.menu,
    [`& .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuList}`]: {
        outline: 0
    }
});
function $dbffbc66fe757e53$export$237948c71948075(props) {
    const { open: open, target: target, onClose: onClose, children: children, position: position, className: className, onExited: onExited } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $dbffbc66fe757e53$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $dbffbc66fe757e53$var$useUtilityClasses(rootProps);
    const variablesClass = (0, $cadacf9afeddf573$export$bce43ff91e115a9b)();
    const savedFocusRef = $acw62.useRef(null);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (open) savedFocusRef.current = document.activeElement instanceof HTMLElement ? document.activeElement : null;
        else {
            savedFocusRef.current?.focus?.();
            savedFocusRef.current = null;
        }
    }, [
        open
    ]);
    $acw62.useEffect(()=>{
        // Emit menuOpen or menuClose events
        const eventName = open ? 'menuOpen' : 'menuClose';
        apiRef.current.publishEvent(eventName, {
            target: target
        });
    }, [
        apiRef,
        open,
        target
    ]);
    const handleClickAway = (event)=>{
        if (event.target && (target === event.target || target?.contains(event.target))) return;
        onClose(event);
    };
    const handleKeyDown = (event)=>{
        if ((0, $2c033a607636d88a$export$81301abbcd0c8143)(event.key)) onClose(event);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dbffbc66fe757e53$var$GridMenuRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        as: rootProps.slots.basePopper,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className, variablesClass),
        ownerState: rootProps,
        open: open,
        target: target,
        transition: true,
        placement: position,
        onClickAway: handleClickAway,
        onExited: onExited,
        clickAwayMouseEvent: "onMouseDown",
        onKeyDown: handleKeyDown
    }, other, rootProps.slotProps?.basePopper, {
        children: children
    }));
}





'use client';
const $638346e476495ead$var$_excluded = [
    "api",
    "colDef",
    "id",
    "hasFocus",
    "isEditable",
    "field",
    "value",
    "formattedValue",
    "row",
    "rowNode",
    "cellMode",
    "tabIndex",
    "position",
    "focusElementRef"
];
const $638346e476495ead$var$hasActions = (colDef)=>typeof colDef.getActions === 'function';
function $638346e476495ead$export$e8966cddc2f9f685(props) {
    const { colDef: colDef, id: id, hasFocus: hasFocus, tabIndex: tabIndex, position: position = 'bottom-end', focusElementRef: focusElementRef } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $638346e476495ead$var$_excluded);
    const [focusedButtonIndex, setFocusedButtonIndex] = $acw62.useState(-1);
    const [open, setOpen] = $acw62.useState(false);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootRef = $acw62.useRef(null);
    const buttonRef = $acw62.useRef(null);
    const ignoreCallToFocus = $acw62.useRef(false);
    const touchRippleRefs = $acw62.useRef({});
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const menuId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const buttonId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    if (!$638346e476495ead$var$hasActions(colDef)) throw new Error('MUI X: Missing the `getActions` property in the `GridColDef`.');
    const options = colDef.getActions(apiRef.current.getRowParams(id));
    const iconButtons = options.filter((option)=>!option.props.showInMenu);
    const menuButtons = options.filter((option)=>option.props.showInMenu);
    const numberOfButtons = iconButtons.length + (menuButtons.length ? 1 : 0);
    $acw62.useLayoutEffect(()=>{
        if (!hasFocus) Object.entries(touchRippleRefs.current).forEach(([index, ref])=>{
            ref?.stop({}, ()=>{
                delete touchRippleRefs.current[index];
            });
        });
    }, [
        hasFocus
    ]);
    $acw62.useEffect(()=>{
        if (focusedButtonIndex < 0 || !rootRef.current) return;
        if (focusedButtonIndex >= rootRef.current.children.length) return;
        const child = rootRef.current.children[focusedButtonIndex];
        child.focus({
            preventScroll: true
        });
    }, [
        focusedButtonIndex
    ]);
    $acw62.useEffect(()=>{
        if (!hasFocus) {
            setFocusedButtonIndex(-1);
            ignoreCallToFocus.current = false;
        }
    }, [
        hasFocus
    ]);
    $acw62.useImperativeHandle(focusElementRef, ()=>({
            focus () {
                // If ignoreCallToFocus is true, then one of the buttons was clicked and the focus is already set
                if (!ignoreCallToFocus.current) {
                    // find the first focusable button and pass the index to the state
                    const focusableButtonIndex = options.findIndex((o)=>!o.props.disabled);
                    setFocusedButtonIndex(focusableButtonIndex);
                }
            }
        }), [
        options
    ]);
    $acw62.useEffect(()=>{
        if (focusedButtonIndex >= numberOfButtons) setFocusedButtonIndex(numberOfButtons - 1);
    }, [
        focusedButtonIndex,
        numberOfButtons
    ]);
    const showMenu = ()=>{
        setOpen(true);
        setFocusedButtonIndex(numberOfButtons - 1);
        ignoreCallToFocus.current = true;
    };
    const hideMenu = ()=>{
        setOpen(false);
    };
    const toggleMenu = (event)=>{
        event.stopPropagation();
        event.preventDefault();
        if (open) hideMenu();
        else showMenu();
    };
    const handleTouchRippleRef = (index)=>(instance)=>{
            touchRippleRefs.current[index] = instance;
        };
    const handleButtonClick = (index, onClick)=>(event)=>{
            setFocusedButtonIndex(index);
            ignoreCallToFocus.current = true;
            if (onClick) onClick(event);
        };
    const handleRootKeyDown = (event)=>{
        if (numberOfButtons <= 1) return;
        const getNewIndex = (index, direction)=>{
            if (index < 0 || index > options.length) return index;
            // for rtl mode we need to reverse the direction
            const rtlMod = isRtl ? -1 : 1;
            const indexMod = (direction === 'left' ? -1 : 1) * rtlMod;
            // if the button that should receive focus is disabled go one more step
            return options[index + indexMod]?.props.disabled ? getNewIndex(index + indexMod, direction) : index + indexMod;
        };
        let newIndex = focusedButtonIndex;
        if (event.key === 'ArrowRight') newIndex = getNewIndex(focusedButtonIndex, 'right');
        else if (event.key === 'ArrowLeft') newIndex = getNewIndex(focusedButtonIndex, 'left');
        if (newIndex < 0 || newIndex >= numberOfButtons) return; // We're already in the first or last item = do nothing and let the grid listen the event
        if (newIndex !== focusedButtonIndex) {
            event.preventDefault(); // Prevent scrolling
            event.stopPropagation(); // Don't stop propagation for other keys, for example ArrowUp
            setFocusedButtonIndex(newIndex);
        }
    };
    // role="menu" requires at least one child element
    const attributes = numberOfButtons > 0 ? {
        role: 'menu',
        onKeyDown: handleRootKeyDown
    } : undefined;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: rootRef,
        tabIndex: -1,
        className: (0, $59e5f6b0ce3da023$export$2100d54e36406477).actionsCell
    }, attributes, other, {
        children: [
            iconButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button, {
                    key: index,
                    touchRippleRef: handleTouchRippleRef(index),
                    onClick: handleButtonClick(index, button.props.onClick),
                    tabIndex: focusedButtonIndex === index ? tabIndex : -1
                })),
            menuButtons.length > 0 && buttonId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                ref: buttonRef,
                id: buttonId,
                "aria-label": apiRef.current.getLocaleText('actionsCellMore'),
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? menuId : undefined,
                role: "menuitem",
                size: "small",
                onClick: toggleMenu,
                touchRippleRef: handleTouchRippleRef(buttonId),
                tabIndex: focusedButtonIndex === iconButtons.length ? tabIndex : -1
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.moreActionsIcon, {
                    fontSize: "small"
                })
            })),
            menuButtons.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbffbc66fe757e53$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                position: position,
                onClose: hideMenu,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuList, {
                    id: menuId,
                    className: (0, $59e5f6b0ce3da023$export$2100d54e36406477).menuList,
                    "aria-labelledby": buttonId,
                    autoFocusItem: true,
                    children: menuButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button, {
                            key: index,
                            closeMenu: hideMenu
                        }))
                })
            })
        ]
    }));
}
const $638346e476495ead$export$974043ff7a6a1028 = (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($638346e476495ead$export$e8966cddc2f9f685, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params));


const $09b8609275e30076$export$e2523ab9efeb7465 = 'actions';
const $09b8609275e30076$export$cc51a5e65f00f971 = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $3e6386ba32760615$export$db6fa9d0a45573e4), {
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    chartable: false,
    width: 100,
    display: 'flex',
    align: 'center',
    headerAlign: 'center',
    headerName: '',
    disableColumnMenu: true,
    disableExport: true,
    renderCell: (0, $638346e476495ead$export$974043ff7a6a1028),
    getApplyQuickFilterFn: ()=>null
});


const $2fc3cef2ea623369$export$9459349d75dc87fe = 'string';
const $2fc3cef2ea623369$export$625c4e4511cf2d66 = ()=>{
    const nativeColumnTypes = {
        string: (0, $3e6386ba32760615$export$db6fa9d0a45573e4),
        number: (0, $170542d728408808$export$ba08f73736670f91),
        date: (0, $fbc056db19043e98$export$4c3b89749ea40e50),
        dateTime: (0, $fbc056db19043e98$export$5bc7079eed6f3d7f),
        boolean: (0, $ccbab3147b17f664$export$220b51460e149ea9),
        singleSelect: (0, $ca71555e523099ad$export$7acf0d6e5e468a51),
        [(0, $09b8609275e30076$export$e2523ab9efeb7465)]: (0, $09b8609275e30076$export$cc51a5e65f00f971),
        custom: (0, $3e6386ba32760615$export$db6fa9d0a45573e4)
    };
    return nativeColumnTypes;
};






const $61c7e1ee2666e841$export$372ceb7d0877dfb4 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.headerFiltering);
const $61c7e1ee2666e841$export$5e071b12b66f124d = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($61c7e1ee2666e841$export$372ceb7d0877dfb4, // No initialization in MIT, so we need to default to false to be used by `getTotalHeaderHeight`
(headerFilteringState)=>headerFilteringState?.enabled ?? false);
const $61c7e1ee2666e841$export$d5104e3dccc7c49d = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($61c7e1ee2666e841$export$372ceb7d0877dfb4, (headerFilteringState)=>headerFilteringState.editing);
const $61c7e1ee2666e841$export$c564e60305059ea4 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($61c7e1ee2666e841$export$372ceb7d0877dfb4, (headerFilteringState)=>headerFilteringState.menuOpen);



const $424decc09f6745ae$export$6f71a66e6e099ab2 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.columnGrouping);
const $424decc09f6745ae$export$78f140ad2e1dbc2b = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($424decc09f6745ae$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.unwrappedGroupingModel ?? {});
const $424decc09f6745ae$export$bdc2ff4432d8b29b = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($424decc09f6745ae$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.lookup ?? {});
const $424decc09f6745ae$export$8f859ed1f2777746 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($424decc09f6745ae$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.headerStructure ?? []);
const $424decc09f6745ae$export$4cf0369c079b29be = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($424decc09f6745ae$export$6f71a66e6e099ab2, (columnGrouping)=>columnGrouping?.maxDepth ?? 0);


const $7560da5e35f787e6$export$cd7252624d377ce0 = [
    'maxWidth',
    'minWidth',
    'width',
    'flex'
];
const $7560da5e35f787e6$var$COLUMN_TYPES = (0, $2fc3cef2ea623369$export$625c4e4511cf2d66)();
function $7560da5e35f787e6$export$1719bda669685455({ initialFreeSpace: initialFreeSpace, totalFlexUnits: totalFlexUnits, flexColumns: flexColumns }) {
    const uniqueFlexColumns = new Set(flexColumns.map((col)=>col.field));
    const flexColumnsLookup = {
        all: {},
        frozenFields: [],
        freeze: (field)=>{
            const value = flexColumnsLookup.all[field];
            if (value && value.frozen !== true) {
                flexColumnsLookup.all[field].frozen = true;
                flexColumnsLookup.frozenFields.push(field);
            }
        }
    };
    // Step 5 of https://drafts.csswg.org/css-flexbox-1/#resolve-flexible-lengths
    function loopOverFlexItems() {
        // 5a: If all the flex items on the line are frozen, free space has been distributed.
        if (flexColumnsLookup.frozenFields.length === uniqueFlexColumns.size) return;
        const violationsLookup = {
            min: {},
            max: {}
        };
        let remainingFreeSpace = initialFreeSpace;
        let flexUnits = totalFlexUnits;
        let totalViolation = 0;
        // 5b: Calculate the remaining free space
        flexColumnsLookup.frozenFields.forEach((field)=>{
            remainingFreeSpace -= flexColumnsLookup.all[field].computedWidth;
            flexUnits -= flexColumnsLookup.all[field].flex;
        });
        for(let i = 0; i < flexColumns.length; i += 1){
            const column = flexColumns[i];
            if (flexColumnsLookup.all[column.field] && flexColumnsLookup.all[column.field].frozen === true) continue;
            // 5c: Distribute remaining free space proportional to the flex factors
            const widthPerFlexUnit = remainingFreeSpace / flexUnits;
            let computedWidth = widthPerFlexUnit * column.flex;
            // 5d: Fix min/max violations
            if (computedWidth < column.minWidth) {
                totalViolation += column.minWidth - computedWidth;
                computedWidth = column.minWidth;
                violationsLookup.min[column.field] = true;
            } else if (computedWidth > column.maxWidth) {
                totalViolation += column.maxWidth - computedWidth;
                computedWidth = column.maxWidth;
                violationsLookup.max[column.field] = true;
            }
            flexColumnsLookup.all[column.field] = {
                frozen: false,
                computedWidth: computedWidth,
                flex: column.flex
            };
        }
        // 5e: Freeze over-flexed items
        if (totalViolation < 0) // Freeze all the items with max violations
        Object.keys(violationsLookup.max).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else if (totalViolation > 0) // Freeze all the items with min violations
        Object.keys(violationsLookup.min).forEach((field)=>{
            flexColumnsLookup.freeze(field);
        });
        else // Freeze all items
        flexColumns.forEach(({ field: field })=>{
            flexColumnsLookup.freeze(field);
        });
        // 5f: Return to the start of this loop
        loopOverFlexItems();
    }
    loopOverFlexItems();
    return flexColumnsLookup.all;
}
const $7560da5e35f787e6$export$cd8dc1fa232954ad = (rawState, dimensions)=>{
    const columnsLookup = {};
    let totalFlexUnits = 0;
    let widthAllocatedBeforeFlex = 0;
    const flexColumns = [];
    // For the non-flex columns, compute their width
    // For the flex columns, compute their minimum width and how much width must be allocated during the flex allocation
    rawState.orderedFields.forEach((columnField)=>{
        let column = rawState.lookup[columnField];
        let computedWidth = 0;
        let isFlex = false;
        if (rawState.columnVisibilityModel[columnField] !== false) {
            if (column.flex && column.flex > 0) {
                totalFlexUnits += column.flex;
                isFlex = true;
            } else computedWidth = (0, $07a64ebfd26f4296$export$7d15b64cf5a3a4c4)(column.width || (0, $3e6386ba32760615$export$db6fa9d0a45573e4).width, column.minWidth || (0, $3e6386ba32760615$export$db6fa9d0a45573e4).minWidth, column.maxWidth || (0, $3e6386ba32760615$export$db6fa9d0a45573e4).maxWidth);
            widthAllocatedBeforeFlex += computedWidth;
        }
        if (column.computedWidth !== computedWidth) column = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, column, {
            computedWidth: computedWidth
        });
        if (isFlex) flexColumns.push(column);
        columnsLookup[columnField] = column;
    });
    const availableWidth = dimensions === undefined ? 0 : dimensions.viewportOuterSize.width - (dimensions.hasScrollY ? dimensions.scrollbarSize : 0);
    const initialFreeSpace = Math.max(availableWidth - widthAllocatedBeforeFlex, 0);
    // Allocate the remaining space to the flex columns
    if (totalFlexUnits > 0 && availableWidth > 0) {
        const computedColumnWidths = $7560da5e35f787e6$export$1719bda669685455({
            initialFreeSpace: initialFreeSpace,
            totalFlexUnits: totalFlexUnits,
            flexColumns: flexColumns
        });
        Object.keys(computedColumnWidths).forEach((field)=>{
            columnsLookup[field] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, columnsLookup[field], {
                computedWidth: computedColumnWidths[field].computedWidth
            });
        });
    }
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rawState, {
        lookup: columnsLookup
    });
};
const $7560da5e35f787e6$export$6e8a0938c76079c7 = (columnsState, initialState)=>{
    if (!initialState) return columnsState;
    const { orderedFields: orderedFields = [], dimensions: dimensions = {} } = initialState;
    const columnsWithUpdatedDimensions = Object.keys(dimensions);
    if (columnsWithUpdatedDimensions.length === 0 && orderedFields.length === 0) return columnsState;
    const orderedFieldsLookup = {};
    const cleanOrderedFields = [];
    for(let i = 0; i < orderedFields.length; i += 1){
        const field = orderedFields[i];
        // Ignores the fields in the initialState that matches no field on the current column state
        if (columnsState.lookup[field]) {
            orderedFieldsLookup[field] = true;
            cleanOrderedFields.push(field);
        }
    }
    const newOrderedFields = cleanOrderedFields.length === 0 ? columnsState.orderedFields : [
        ...cleanOrderedFields,
        ...columnsState.orderedFields.filter((field)=>!orderedFieldsLookup[field])
    ];
    const newColumnLookup = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, columnsState.lookup);
    for(let i = 0; i < columnsWithUpdatedDimensions.length; i += 1){
        const field = columnsWithUpdatedDimensions[i];
        const newColDef = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newColumnLookup[field], {
            hasBeenResized: true
        });
        Object.entries(dimensions[field]).forEach(([key, value])=>{
            newColDef[key] = value === -1 ? Infinity : value;
        });
        newColumnLookup[field] = newColDef;
    }
    const newColumnsState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, columnsState, {
        orderedFields: newOrderedFields,
        lookup: newColumnLookup
    });
    return newColumnsState;
};
function $7560da5e35f787e6$export$af9bf9d59a64e4c7(type) {
    let colDef = $7560da5e35f787e6$var$COLUMN_TYPES[0, $2fc3cef2ea623369$export$9459349d75dc87fe];
    if (type && $7560da5e35f787e6$var$COLUMN_TYPES[type]) colDef = $7560da5e35f787e6$var$COLUMN_TYPES[type];
    return colDef;
}
const $7560da5e35f787e6$export$f3ba81d24bd05452 = ({ apiRef: apiRef, columnsToUpsert: columnsToUpsert, initialState: initialState, columnVisibilityModel: columnVisibilityModel = (0, $1781ebe27505055c$export$eb0d33595fe29bb4)(apiRef), keepOnlyColumnsToUpsert: keepOnlyColumnsToUpsert = false, updateInitialVisibilityModel: updateInitialVisibilityModel = false })=>{
    const isInsideStateInitializer = !apiRef.current.state.columns;
    let columnsState;
    if (isInsideStateInitializer) columnsState = {
        orderedFields: [],
        lookup: {},
        columnVisibilityModel: columnVisibilityModel,
        initialColumnVisibilityModel: columnVisibilityModel
    };
    else {
        const currentState = (0, $1781ebe27505055c$export$858d15abb6cddc08)(apiRef);
        columnsState = {
            orderedFields: keepOnlyColumnsToUpsert ? [] : [
                ...currentState.orderedFields
            ],
            lookup: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentState.lookup),
            columnVisibilityModel: // Will be cleaned later if keepOnlyColumnsToUpsert=true
            columnVisibilityModel,
            initialColumnVisibilityModel: updateInitialVisibilityModel ? columnVisibilityModel : currentState.initialColumnVisibilityModel
        };
    }
    const columnsToKeep = {};
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) {
        for(const key in columnsState.lookup)if (Object.prototype.hasOwnProperty.call(columnsState.lookup, key)) columnsToKeep[key] = false;
    }
    const columnsToUpsertLookup = {};
    columnsToUpsert.forEach((newColumn)=>{
        const { field: field } = newColumn;
        columnsToUpsertLookup[field] = true;
        columnsToKeep[field] = true;
        let existingState = columnsState.lookup[field];
        if (existingState == null) {
            existingState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $7560da5e35f787e6$export$af9bf9d59a64e4c7(newColumn.type), {
                field: field,
                hasBeenResized: false
            });
            columnsState.orderedFields.push(field);
        } else if (keepOnlyColumnsToUpsert) columnsState.orderedFields.push(field);
        // If the column type has changed - merge the existing state with the default column type definition
        if (existingState && existingState.type !== newColumn.type) existingState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $7560da5e35f787e6$export$af9bf9d59a64e4c7(newColumn.type), {
            field: field
        });
        let hasBeenResized = existingState.hasBeenResized;
        $7560da5e35f787e6$export$cd7252624d377ce0.forEach((key)=>{
            if (newColumn[key] !== undefined) {
                hasBeenResized = true;
                if (newColumn[key] === -1) newColumn[key] = Infinity;
            }
        });
        columnsState.lookup[field] = (0, $367acbd429e20ec9$export$2e2bcd8739ae039)(existingState, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $7560da5e35f787e6$export$af9bf9d59a64e4c7(newColumn.type), newColumn, {
            hasBeenResized: hasBeenResized
        }));
    });
    if (keepOnlyColumnsToUpsert && !isInsideStateInitializer) Object.keys(columnsState.lookup).forEach((field)=>{
        if (!columnsToKeep[field]) delete columnsState.lookup[field];
    });
    const columnsStateWithPreProcessing = apiRef.current.unstable_applyPipeProcessors('hydrateColumns', columnsState);
    const columnsStateWithPortableColumns = $7560da5e35f787e6$export$6e8a0938c76079c7(columnsStateWithPreProcessing, initialState);
    return $7560da5e35f787e6$export$cd8dc1fa232954ad(columnsStateWithPortableColumns, apiRef.current.getRootDimensions?.() ?? undefined);
};
function $7560da5e35f787e6$export$6143417adb92779f({ firstColumnToRender: firstColumnToRender, apiRef: apiRef, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    let foundStableColumn = false;
    // Keep checking columns until we find one that's not spanned in any visible row
    while(!foundStableColumn && firstNonSpannedColumnToRender >= 0){
        foundStableColumn = true;
        for(let i = firstRowToRender; i < lastRowToRender; i += 1){
            const row = visibleRows[i];
            if (row) {
                const rowId = visibleRows[i].id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, firstNonSpannedColumnToRender);
                if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan && cellColSpanInfo.leftVisibleCellIndex < firstNonSpannedColumnToRender) {
                    firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
                    foundStableColumn = false;
                    break; // Check the new column index against the visible rows, because it might be spanned
                }
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
function $7560da5e35f787e6$export$659109c29172602f(apiRef, props) {
    if (props.listView) return 0;
    const densityFactor = (0, $3d9afbbff3fa8293$export$c646201fb1d3e7a6)(apiRef);
    const maxDepth = (0, $424decc09f6745ae$export$4cf0369c079b29be)(apiRef);
    const isHeaderFilteringEnabled = (0, $61c7e1ee2666e841$export$5e071b12b66f124d)(apiRef);
    const columnHeadersHeight = Math.floor(props.columnHeaderHeight * densityFactor);
    const columnGroupHeadersHeight = Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * densityFactor);
    const filterHeadersHeight = isHeaderFilteringEnabled ? Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * densityFactor) : 0;
    return columnHeadersHeight + columnGroupHeadersHeight * maxDepth + filterHeadersHeight;
}




const $a2b185594e10a6a1$export$4f32bfc70efeb4ab = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.rowsMeta);



'use client';
const $e1dc77693aecc816$var$CLIFF = 1;
const $e1dc77693aecc816$var$SLOP = 1.5;
const $e1dc77693aecc816$var$useUtilityClasses = (ownerState)=>{
    const { scrollDirection: scrollDirection, classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollArea',
            `scrollArea--${scrollDirection}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $e1dc77693aecc816$var$GridScrollAreaRawRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollArea',
    overridesResolver: (props, styles)=>[
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollArea--left']}`]: styles['scrollArea--left']
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollArea--right']}`]: styles['scrollArea--right']
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollArea--up']}`]: styles['scrollArea--up']
            },
            {
                [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollArea--down']}`]: styles['scrollArea--down']
            },
            styles.scrollArea
        ]
})(()=>({
        position: 'absolute',
        zIndex: 101,
        // Horizontal scroll areas
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollArea--left']}`]: {
            top: 0,
            left: 0,
            width: 20,
            bottom: 0
        },
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollArea--right']}`]: {
            top: 0,
            right: 0,
            width: 20,
            bottom: 0
        },
        // Vertical scroll areas
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollArea--up']}`]: {
            top: 0,
            left: 0,
            right: 0,
            height: 20
        },
        [`&.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollArea--down']}`]: {
            bottom: 0,
            left: 0,
            right: 0,
            height: 20
        }
    }));
const $e1dc77693aecc816$var$offsetSelector = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)((0, $9f487993152f6061$export$26d8768b83a52ffd), (dimensions, direction)=>{
    if (direction === 'left') return dimensions.leftPinnedWidth;
    if (direction === 'right') return dimensions.rightPinnedWidth + (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
    // For vertical scroll areas, we don't need horizontal offset
    return 0;
});
function $e1dc77693aecc816$var$GridScrollAreaWrapper(props) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const [dragDirection, setDragDirection] = $acw62.useState('none');
    // Listen for both column and row drag events
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderDragStart', ()=>setDragDirection('horizontal'));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderDragEnd', ()=>setDragDirection('none'));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowDragStart', ()=>setDragDirection('vertical'));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowDragEnd', ()=>setDragDirection('none'));
    if (dragDirection === 'none') return null;
    if (dragDirection === 'horizontal') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1dc77693aecc816$var$GridHorizontalScrollAreaContent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1dc77693aecc816$var$GridVerticalScrollAreaContent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props));
}
function $e1dc77693aecc816$var$GridHorizontalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $acw62.useRef(null);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const timeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const densityFactor = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $3d9afbbff3fa8293$export$c646201fb1d3e7a6));
    const columnsTotalWidth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$ab20f9d33edc7794));
    const sideOffset = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, $e1dc77693aecc816$var$offsetSelector, scrollDirection);
    const getCanScrollMore = ()=>{
        const dimensions = (0, $9f487993152f6061$export$26d8768b83a52ffd)(apiRef);
        if (scrollDirection === 'left') // Only render if the user has not reached yet the start of the list
        return scrollPosition.current.left > 0;
        if (scrollDirection === 'right') {
            // Only render if the user has not reached yet the end of the list
            const maxScrollLeft = columnsTotalWidth - dimensions.viewportInnerSize.width;
            return scrollPosition.current.left < maxScrollLeft;
        }
        return false;
    };
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const totalHeaderHeight = (0, $7560da5e35f787e6$export$659109c29172602f)(apiRef, rootProps);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * densityFactor);
    const style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        height: headerHeight,
        top: totalHeaderHeight - headerHeight
    }, scrollDirection === 'left' ? {
        left: sideOffset
    } : {}, scrollDirection === 'right' ? {
        right: sideOffset
    } : {});
    const handleDragOver = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'left') offset = event.clientX - rootRef.current.getBoundingClientRect().right;
        else if (scrollDirection === 'right') offset = Math.max(1, event.clientX - rootRef.current.getBoundingClientRect().left);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $e1dc77693aecc816$var$CLIFF) * $e1dc77693aecc816$var$SLOP + $e1dc77693aecc816$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left + offset,
                top: scrollPosition.current.top
            });
        });
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1dc77693aecc816$var$GridScrollAreaContent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
function $e1dc77693aecc816$var$GridVerticalScrollAreaContent(props) {
    const { scrollDirection: scrollDirection, scrollPosition: scrollPosition } = props;
    const rootRef = $acw62.useRef(null);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const timeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const rowsMeta = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $a2b185594e10a6a1$export$4f32bfc70efeb4ab));
    const getCanScrollMore = ()=>{
        const dimensions = (0, $9f487993152f6061$export$26d8768b83a52ffd)(apiRef);
        if (scrollDirection === 'up') // Only render if the user has not reached yet the top of the list
        return scrollPosition.current.top > 0;
        if (scrollDirection === 'down') {
            // Only render if the user has not reached yet the bottom of the list
            const totalRowsHeight = rowsMeta.currentPageTotalHeight || 0;
            const maxScrollTop = totalRowsHeight - dimensions.viewportInnerSize.height - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0);
            return scrollPosition.current.top < maxScrollTop;
        }
        return false;
    };
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const totalHeaderHeight = (0, $7560da5e35f787e6$export$659109c29172602f)(apiRef, rootProps);
    const style = {
        top: scrollDirection === 'up' ? totalHeaderHeight : undefined,
        bottom: scrollDirection === 'down' ? 0 : undefined
    };
    const handleDragOver = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        let offset;
        // Prevents showing the forbidden cursor
        event.preventDefault();
        if (scrollDirection === 'up') offset = event.clientY - rootRef.current.getBoundingClientRect().bottom;
        else if (scrollDirection === 'down') offset = Math.max(1, event.clientY - rootRef.current.getBoundingClientRect().top);
        else throw new Error('MUI X: Wrong drag direction');
        offset = (offset - $e1dc77693aecc816$var$CLIFF) * $e1dc77693aecc816$var$SLOP + $e1dc77693aecc816$var$CLIFF;
        // Avoid freeze and inertia.
        timeout.start(0, ()=>{
            apiRef.current.scroll({
                left: scrollPosition.current.left,
                top: scrollPosition.current.top + offset
            });
        });
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1dc77693aecc816$var$GridScrollAreaContent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: rootRef,
        getCanScrollMore: getCanScrollMore,
        style: style,
        handleDragOver: handleDragOver
    }));
}
const $e1dc77693aecc816$var$GridScrollAreaContent = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridScrollAreaContent(props, ref) {
    const { scrollDirection: scrollDirection, getCanScrollMore: getCanScrollMore, style: style, handleDragOver: handleDragOver } = props;
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const [canScrollMore, setCanScrollMore] = $acw62.useState(getCanScrollMore);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps, {
        scrollDirection: scrollDirection
    });
    const classes = $e1dc77693aecc816$var$useUtilityClasses(ownerState);
    const handleScrolling = ()=>{
        setCanScrollMore(getCanScrollMore);
    };
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'scrollPositionChange', handleScrolling);
    if (!canScrollMore) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e1dc77693aecc816$var$GridScrollAreaRawRoot, {
        ref: ref,
        className: classes.root,
        ownerState: ownerState,
        onDragOver: handleDragOver,
        style: style
    });
});
const $e1dc77693aecc816$export$40bcbdb719b20690 = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($e1dc77693aecc816$var$GridScrollAreaWrapper);







function $4928b2b12bcd438c$export$23cfe696632d10f4(object) {
    // eslint-disable-next-line
    for(const _ in object)return false;
    return true;
}






/**
 * @category Sorting
 * @ignore - do not document.
 */ const $f0897a6c670e0208$var$gridSortingStateSelector = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.sorting);
const $f0897a6c670e0208$export$e4979ad0a2db8752 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($f0897a6c670e0208$var$gridSortingStateSelector, (sortingState)=>sortingState.sortedRows);
const $f0897a6c670e0208$export$8919e81647813e61 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($f0897a6c670e0208$export$e4979ad0a2db8752, (0, $4fc0d4cb0e570e63$export$37767f9110c99048), (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d), (sortedIds, idRowsLookup, rowTree)=>sortedIds.reduce((acc, id)=>{
        const model = idRowsLookup[id];
        if (model) acc.push({
            id: id,
            model: model
        });
        else {
            const rowNode = rowTree[id];
            if (rowNode && (0, $4ab53eafabc4b920$export$5f983e16b1e55860)(rowNode)) acc.push({
                id: id,
                model: {
                    [(0, $4ab53eafabc4b920$export$e8632b32bb8837db)]: id
                }
            });
        }
        return acc;
    }, []));
const $f0897a6c670e0208$export$55dcc66b73d9a0f9 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($f0897a6c670e0208$var$gridSortingStateSelector, (sorting)=>sorting.sortModel);
const $f0897a6c670e0208$export$4dfdcc434a6c5081 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($f0897a6c670e0208$export$55dcc66b73d9a0f9, (sortModel)=>{
    const result = sortModel.reduce((res, sortItem, index)=>{
        res[sortItem.field] = {
            sortDirection: sortItem.sort,
            sortIndex: sortModel.length > 1 ? index + 1 : undefined
        };
        return res;
    }, {});
    return result;
});
const $f0897a6c670e0208$export$d0aac76ef888d9fe = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($f0897a6c670e0208$export$e4979ad0a2db8752, (sortedIds)=>{
    return sortedIds.reduce((acc, id, index)=>{
        acc[id] = index;
        return acc;
    }, Object.create(null));
});




/**
 * @category Filtering
 */ const $51d9da8b83918212$var$gridFilterStateSelector = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.filter);
const $51d9da8b83918212$export$280aedb9454597a5 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$var$gridFilterStateSelector, (filterState)=>filterState.filterModel);
const $51d9da8b83918212$export$6f9fe133e2c56816 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$export$280aedb9454597a5, (filterModel)=>filterModel.quickFilterValues);
const $51d9da8b83918212$export$7dcadad908a379a4 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.visibleRowsLookup);
const $51d9da8b83918212$export$6d031b6e8cbaf41c = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$var$gridFilterStateSelector, (filterState)=>filterState.filteredRowsLookup);
const $51d9da8b83918212$export$5f10eab80a0f79a0 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$var$gridFilterStateSelector, (filterState)=>filterState.filteredChildrenCountLookup);
const $51d9da8b83918212$export$28e99d5260ff82e7 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$var$gridFilterStateSelector, (filterState)=>filterState.filteredDescendantCountLookup);
const $51d9da8b83918212$export$2f31562143a3e5d4 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$7dcadad908a379a4, (0, $f0897a6c670e0208$export$8919e81647813e61), (visibleRowsLookup, sortedRows)=>{
    if ((0, $4928b2b12bcd438c$export$23cfe696632d10f4)(visibleRowsLookup)) return sortedRows;
    return sortedRows.filter((row)=>visibleRowsLookup[row.id] !== false);
});
const $51d9da8b83918212$export$7a99837e2fd93e42 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$2f31562143a3e5d4, (visibleSortedRowEntries)=>visibleSortedRowEntries.map((row)=>row.id));
const $51d9da8b83918212$export$cd53824a2b232e36 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$6d031b6e8cbaf41c, (0, $f0897a6c670e0208$export$8919e81647813e61), (filteredRowsLookup, sortedRows)=>(0, $4928b2b12bcd438c$export$23cfe696632d10f4)(filteredRowsLookup) ? sortedRows : sortedRows.filter((row)=>filteredRowsLookup[row.id] !== false));
const $51d9da8b83918212$export$4e2a9d76902d271c = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.map((row)=>row.id));
const $51d9da8b83918212$export$a77377d29742e9a9 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$7a99837e2fd93e42, (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d), (visibleSortedRowIds, rowTree)=>{
    const depthPositionCounter = {};
    let lastDepth = 0;
    return visibleSortedRowIds.reduce((acc, rowId)=>{
        const rowNode = rowTree[rowId];
        if (!depthPositionCounter[rowNode.depth]) depthPositionCounter[rowNode.depth] = 0;
        // going deeper in the tree should reset the counter
        // since it might have been used in some other branch at the same level, up in the tree
        // going back up should keep the counter and continue where it left off
        if (rowNode.depth > lastDepth) depthPositionCounter[rowNode.depth] = 0;
        lastDepth = rowNode.depth;
        depthPositionCounter[rowNode.depth] += 1;
        acc[rowId] = depthPositionCounter[rowNode.depth];
        return acc;
    }, {});
});
const $51d9da8b83918212$export$79dd3d05597d4e5a = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$cd53824a2b232e36, (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d), (0, $4fc0d4cb0e570e63$export$4cdbe576751dd8e2), (sortedRows, rowTree, rowTreeDepth)=>{
    if (rowTreeDepth < 2) return [
        sortedRows
    ];
    return sortedRows.reduce((acc, row)=>{
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) return acc;
        if (!acc[depth]) acc[depth] = [];
        acc[depth].push(row);
        return acc;
    }, [
        []
    ]);
});
const $51d9da8b83918212$export$b8a7110d1a4c4623 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$export$79dd3d05597d4e5a, (filteredSortedDepthRows)=>filteredSortedDepthRows[0] ?? []);
const $51d9da8b83918212$export$96919017bbfaec0d = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$export$2f31562143a3e5d4, (visibleSortedRows)=>visibleSortedRows.length);
const $51d9da8b83918212$export$f88efd30675963d1 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$export$b8a7110d1a4c4623, (visibleSortedTopLevelRows)=>visibleSortedTopLevelRows.length);
const $51d9da8b83918212$export$ee3e723e6d15f78c = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$export$cd53824a2b232e36, (filteredSortedRowEntries)=>filteredSortedRowEntries.length);
const $51d9da8b83918212$export$821b542222c57b39 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($51d9da8b83918212$export$ee3e723e6d15f78c, $51d9da8b83918212$export$f88efd30675963d1, (totalRowCount, topLevelRowCount)=>totalRowCount - topLevelRowCount);
const $51d9da8b83918212$export$c7447bfbd4ecafcc = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$280aedb9454597a5, (0, $1781ebe27505055c$export$8a3a9a6db584d7fd), (filterModel, columnLookup)=>filterModel.items?.filter((item)=>{
        if (!item.field) return false;
        const column = columnLookup[item.field];
        if (!column?.filterOperators || column?.filterOperators?.length === 0) return false;
        const filterOperator = column.filterOperators.find((operator)=>operator.value === item.operator);
        if (!filterOperator) return false;
        return !filterOperator.InputComponent || item.value != null && item.value?.toString() !== '';
    }));
const $51d9da8b83918212$export$6b2da1ecc84b757a = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$c7447bfbd4ecafcc, (activeFilters)=>{
    const result = activeFilters.reduce((res, filterItem)=>{
        if (!res[filterItem.field]) res[filterItem.field] = [
            filterItem
        ];
        else res[filterItem.field].push(filterItem);
        return res;
    }, {});
    return result;
});
const $51d9da8b83918212$export$d5f0bb1725448774 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($51d9da8b83918212$export$7a99837e2fd93e42, (expandedSortedIds)=>{
    return expandedSortedIds.reduce((acc, id, index)=>{
        acc[id] = index;
        return acc;
    }, Object.create(null));
});






const $8f88c26e7e51121c$var$gridPivotingStateSelector = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)(// @ts-ignore
(state)=>state.pivoting);
const $8f88c26e7e51121c$export$c1e9ba02e25d9a4d = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($8f88c26e7e51121c$var$gridPivotingStateSelector, (pivoting)=>pivoting?.active);
const $8f88c26e7e51121c$var$emptyColumns = new Map();
const $8f88c26e7e51121c$export$c994aaa19f0be33d = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($8f88c26e7e51121c$var$gridPivotingStateSelector, (pivoting)=>pivoting?.initialColumns || $8f88c26e7e51121c$var$emptyColumns);


const $5b89fc3f616edf04$export$ba0092e600a72afc = (apiRef, props)=>{
    const totalRowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$1641ef9d08e265ca));
    const visibleRowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$96919017bbfaec0d));
    const pinnedRowsCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$8e3fb3525d7db988));
    const visibleColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$16a65a9447d3dda9));
    const noRows = totalRowCount === 0 && pinnedRowsCount === 0;
    const loading = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$3c966d405f950b08));
    const pivotActive = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $8f88c26e7e51121c$export$c1e9ba02e25d9a4d));
    const showNoRowsOverlay = !loading && noRows;
    const showNoResultsOverlay = !loading && totalRowCount > 0 && visibleRowCount === 0;
    const showNoColumnsOverlay = !loading && visibleColumns.length === 0;
    const showEmptyPivotOverlay = showNoRowsOverlay && pivotActive;
    let overlayType = null;
    let loadingOverlayVariant = null;
    if (showNoRowsOverlay) overlayType = 'noRowsOverlay';
    if (showNoColumnsOverlay) overlayType = 'noColumnsOverlay';
    if (showEmptyPivotOverlay) overlayType = 'emptyPivotOverlay';
    if (showNoResultsOverlay) overlayType = 'noResultsOverlay';
    if (loading) {
        overlayType = 'loadingOverlay';
        loadingOverlayVariant = props.slotProps?.loadingOverlay?.[noRows ? 'noRowsVariant' : 'variant'] ?? (noRows ? 'skeleton' : 'linear-progress');
    }
    return {
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
};



parcelRequire("acw62");








const $578d1f15adc16cb4$export$ce21bef7bd3a9c4e = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.focus);
const $578d1f15adc16cb4$export$74af8aada6269d3 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($578d1f15adc16cb4$export$ce21bef7bd3a9c4e, (focusState)=>focusState.cell);
const $578d1f15adc16cb4$export$cefd405855792f4a = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($578d1f15adc16cb4$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeader);
const $578d1f15adc16cb4$export$50853df99eaddaf5 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($578d1f15adc16cb4$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnHeaderFilter);
const $578d1f15adc16cb4$export$3eeedc3f7263df61 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($578d1f15adc16cb4$export$ce21bef7bd3a9c4e, (focusState)=>focusState.columnGroupHeader);
const $578d1f15adc16cb4$export$3ab3abde27f70192 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.tabIndex);
const $578d1f15adc16cb4$export$2c47652a1f657d56 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($578d1f15adc16cb4$export$3ab3abde27f70192, (state)=>state.cell);
const $578d1f15adc16cb4$export$29da670438604dbd = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($578d1f15adc16cb4$export$3ab3abde27f70192, (state)=>state.columnHeader);
const $578d1f15adc16cb4$export$441ae2090306a1e2 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($578d1f15adc16cb4$export$3ab3abde27f70192, (state)=>state.columnHeaderFilter);
const $578d1f15adc16cb4$export$37a54bd010f498d2 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($578d1f15adc16cb4$export$3ab3abde27f70192, (state)=>state.columnGroupHeader);




const $54021b85ff01fa29$export$5479c2fb8e9fd070 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.columnMenu);



function $9244b53123902fe1$var$GridHeaders() {
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$16a65a9447d3dda9));
    const filterColumnLookup = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$6b2da1ecc84b757a));
    const sortColumnLookup = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $f0897a6c670e0208$export$4dfdcc434a6c5081));
    const columnHeaderTabIndexState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $578d1f15adc16cb4$export$29da670438604dbd));
    const hasNoCellTabIndexState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, ()=>(0, $578d1f15adc16cb4$export$2c47652a1f657d56)(apiRef) === null);
    const columnGroupHeaderTabIndexState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $578d1f15adc16cb4$export$37a54bd010f498d2));
    const columnHeaderFocus = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $578d1f15adc16cb4$export$cefd405855792f4a));
    const columnGroupHeaderFocus = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $578d1f15adc16cb4$export$3eeedc3f7263df61));
    const headerGroupingMaxDepth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $424decc09f6745ae$export$4cf0369c079b29be));
    const columnMenuState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $54021b85ff01fa29$export$5479c2fb8e9fd070));
    const columnVisibility = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$eb0d33595fe29bb4));
    const columnGroupsHeaderStructure = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $424decc09f6745ae$export$8f859ed1f2777746));
    const hasOtherElementInTabSequence = !(columnGroupHeaderTabIndexState === null && columnHeaderTabIndexState === null && hasNoCellTabIndexState);
    const columnsContainerRef = apiRef.current.columnHeadersContainerRef;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnHeaders, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: columnsContainerRef,
        visibleColumns: visibleColumns,
        filterColumnLookup: filterColumnLookup,
        sortColumnLookup: sortColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    }, rootProps.slotProps?.columnHeaders));
}
const $9244b53123902fe1$export$151397d1f4bb9231 = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($9244b53123902fe1$var$GridHeaders);



parcelRequire("acw62");





const $2c42d23fff385703$var$GridPanelAnchor = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div')({
    position: 'absolute',
    top: `var(--DataGrid-headersTotalHeight)`,
    left: 0,
    width: 'calc(100% - (var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))'
});
const $2c42d23fff385703$var$Element = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Main',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState, loadingOverlayVariant: loadingOverlayVariant, overlayType: overlayType } = props;
        const hideContent = loadingOverlayVariant === 'skeleton' || overlayType === 'noColumnsOverlay';
        return [
            styles.main,
            ownerState.hasPinnedRight && styles['main--hasPinnedRight'],
            hideContent && styles['main--hiddenContent']
        ];
    }
})({
    flexGrow: 1,
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column'
});
const $2c42d23fff385703$export$74039dccf215bc2a = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)((props, ref)=>{
    const { ownerState: ownerState } = props;
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const configuration = (0, $c6f13e845e117797$export$9fe1679701f06bb7)();
    const ariaAttributes = configuration.hooks.useGridAriaAttributes();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($2c42d23fff385703$var$Element, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ownerState: ownerState,
        className: props.className,
        tabIndex: -1
    }, ariaAttributes, rootProps.slotProps?.main, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2c42d23fff385703$var$GridPanelAnchor, {
                role: "presentation",
                "data-id": "gridPanelAnchor"
            }),
            props.children
        ]
    }));
});



parcelRequire("acw62");





const $2da8e1075d115d7b$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'topContainer'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), {});
};
const $2da8e1075d115d7b$var$Element = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div')({
    position: 'sticky',
    zIndex: 40,
    top: 0
});
function $2da8e1075d115d7b$export$820d93aabd2ee77d(props) {
    const classes = $2da8e1075d115d7b$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2da8e1075d115d7b$var$Element, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, (0, $59e5f6b0ce3da023$export$2100d54e36406477)['container--top']),
        role: "presentation"
    }));
}



parcelRequire("acw62");







const $74384f08de97887a$var$useUtilityClasses = (props, overflowedContent)=>{
    const { classes: classes } = props;
    const slots = {
        root: [
            'virtualScrollerContent',
            overflowedContent && 'virtualScrollerContent--overflowed'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $74384f08de97887a$var$VirtualScrollerContentRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerContent',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScrollerContent,
            ownerState.overflowedContent && styles['virtualScrollerContent--overflowed']
        ];
    }
})({});
const $74384f08de97887a$export$97d48eb8ba00afb8 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridVirtualScrollerContent(props, ref) {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const overflowedContent = !rootProps.autoHeight && props.style?.minHeight === 'auto';
    const classes = $74384f08de97887a$var$useUtilityClasses(rootProps, overflowedContent);
    const ownerState = {
        classes: rootProps.classes,
        overflowedContent: overflowedContent
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($74384f08de97887a$var$VirtualScrollerContentRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, props.className),
        ref: ref
    }));
});


parcelRequire("acw62");








const $25fbc570ad250e93$var$Filler = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div')({
    display: 'flex',
    flexDirection: 'row',
    width: 'var(--DataGrid-rowWidth)',
    boxSizing: 'border-box'
});
const $25fbc570ad250e93$var$Pinned = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div')({
    position: 'sticky',
    height: '100%',
    boxSizing: 'border-box',
    borderTop: '1px solid var(--rowBorderColor)',
    backgroundColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).cell.background.pinned
});
const $25fbc570ad250e93$var$PinnedLeft = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)($25fbc570ad250e93$var$Pinned)({
    left: 0
});
const $25fbc570ad250e93$var$PinnedRight = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)($25fbc570ad250e93$var$Pinned)({
    right: 0
});
const $25fbc570ad250e93$var$Main = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div')({
    flexGrow: 1,
    borderTop: '1px solid var(--rowBorderColor)'
});
function $25fbc570ad250e93$var$GridVirtualScrollerFiller({ rowsLength: rowsLength }) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const { viewportOuterSize: viewportOuterSize, minimumSize: minimumSize, hasScrollX: hasScrollX, hasScrollY: hasScrollY, scrollbarSize: scrollbarSize, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth } = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$26d8768b83a52ffd));
    const height = hasScrollX ? scrollbarSize : 0;
    const needsLastRowBorder = viewportOuterSize.height - minimumSize.height > 0;
    if (height === 0 && !needsLastRowBorder) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($25fbc570ad250e93$var$Filler, {
        className: (0, $59e5f6b0ce3da023$export$2100d54e36406477).filler,
        role: "presentation",
        style: {
            height: height,
            '--rowBorderColor': rowsLength === 0 ? 'transparent' : 'var(--DataGrid-rowBorderColor)'
        },
        children: [
            leftPinnedWidth > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($25fbc570ad250e93$var$PinnedLeft, {
                className: (0, $59e5f6b0ce3da023$export$2100d54e36406477)['filler--pinnedLeft'],
                style: {
                    width: leftPinnedWidth
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($25fbc570ad250e93$var$Main, {}),
            rightPinnedWidth > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($25fbc570ad250e93$var$PinnedRight, {
                className: (0, $59e5f6b0ce3da023$export$2100d54e36406477)['filler--pinnedRight'],
                style: {
                    width: rightPinnedWidth + (hasScrollY ? scrollbarSize : 0)
                }
            })
        ]
    });
}
const $25fbc570ad250e93$export$832a8b454433e1c8 = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($25fbc570ad250e93$var$GridVirtualScrollerFiller);




parcelRequire("acw62");








const $0c4420d9d70612dc$var$_excluded = [
    "className"
];
const $0c4420d9d70612dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'virtualScrollerRenderZone'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $0c4420d9d70612dc$var$VirtualScrollerRenderZoneRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScrollerRenderZone'
})({
    position: 'absolute',
    display: 'flex',
    // Prevents margin collapsing when using `getRowSpacing`
    flexDirection: 'column'
});
const $0c4420d9d70612dc$export$95930d31e6a9269f = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridVirtualScrollerRenderZone(props, ref) {
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $0c4420d9d70612dc$var$_excluded);
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $0c4420d9d70612dc$var$useUtilityClasses(rootProps);
    const offsetTop = apiRef.current.virtualizer.api.useVirtualization().getters.getOffsetTop();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0c4420d9d70612dc$var$VirtualScrollerRenderZoneRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps,
        style: {
            transform: `translate3d(0, ${offsetTop}px, 0)`
        }
    }, other, {
        ref: ref
    }));
});



var $acw62 = parcelRequire("acw62");











'use client';
const $8ed8d355dd6e3c48$var$useUtilityClasses = (ownerState, position)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'scrollbar',
            `scrollbar--${position}`
        ],
        content: [
            'scrollbarContent'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $8ed8d355dd6e3c48$var$Scrollbar = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div')({
    position: 'absolute',
    display: 'inline-block',
    zIndex: 60,
    '&:hover': {
        zIndex: 70
    },
    // In macOS Safari and Gnome Web, scrollbars are overlaid and don't affect the layout. So we consider
    // their size to be 0px throughout all the calculations, but the floating scrollbar container does need
    // to appear and have a real size. We set it to 14px because it seems like an acceptable value and we
    // don't have a method to find the required size for scrollbars on those platforms.
    '--size': 'calc(max(var(--DataGrid-scrollbarSize), 14px))'
});
const $8ed8d355dd6e3c48$var$ScrollbarVertical = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)($8ed8d355dd6e3c48$var$Scrollbar)({
    width: 'var(--size)',
    height: 'calc(var(--DataGrid-hasScrollY) * (100% - var(--DataGrid-headersTotalHeight) - var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize)))',
    overflowY: 'auto',
    overflowX: 'hidden',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        width: 'var(--size)'
    },
    top: 'var(--DataGrid-headersTotalHeight)',
    right: 0
});
const $8ed8d355dd6e3c48$var$ScrollbarHorizontal = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)($8ed8d355dd6e3c48$var$Scrollbar)({
    width: 'calc(var(--DataGrid-hasScrollX) * (100% - var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize)))',
    height: 'var(--size)',
    overflowY: 'hidden',
    overflowX: 'auto',
    // Disable focus-visible style, it's a scrollbar.
    outline: 0,
    '& > div': {
        height: 'var(--size)'
    },
    bottom: 0
});
const $8ed8d355dd6e3c48$export$af368460b527b7b2 = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)($8ed8d355dd6e3c48$var$Scrollbar)({
    width: 'var(--size)',
    height: 'var(--size)',
    right: 0,
    bottom: 0,
    overflow: 'scroll'
});
const $8ed8d355dd6e3c48$export$96aeae8bf32b76b8 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridVirtualScrollbar(props, ref) {
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const isLocked = $acw62.useRef(false);
    const lastPosition = $acw62.useRef(0);
    const scrollbarRef = $acw62.useRef(null);
    const classes = $8ed8d355dd6e3c48$var$useUtilityClasses(rootProps, props.position);
    const dimensions = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$26d8768b83a52ffd));
    const propertyDimension = props.position === 'vertical' ? 'height' : 'width';
    const propertyScroll = props.position === 'vertical' ? 'scrollTop' : 'scrollLeft';
    const propertyScrollPosition = props.position === 'vertical' ? 'top' : 'left';
    const scrollbarInnerSize = props.position === 'horizontal' ? dimensions.minimumSize.width : dimensions.minimumSize.height - dimensions.headersTotalHeight;
    const onScrollerScroll = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const scrollbar = scrollbarRef.current;
        const scrollPosition = props.scrollPosition.current;
        if (!scrollbar) return;
        if (scrollPosition[propertyScrollPosition] === lastPosition.current) return;
        lastPosition.current = scrollPosition[propertyScrollPosition];
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        scrollbar[propertyScroll] = scrollPosition[propertyScrollPosition];
    });
    const onScrollbarScroll = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        if (!scrollbar) return;
        if (isLocked.current) {
            isLocked.current = false;
            return;
        }
        isLocked.current = true;
        scroller[propertyScroll] = scrollbar[propertyScroll];
    });
    (0, $a0e38fa988f617e0$export$2e2bcd8739ae039)(()=>{
        const scroller = apiRef.current.virtualScrollerRef.current;
        const scrollbar = scrollbarRef.current;
        const options = {
            passive: true
        };
        scroller.addEventListener('scroll', onScrollerScroll, options);
        scrollbar.addEventListener('scroll', onScrollbarScroll, options);
        return ()=>{
            scroller.removeEventListener('scroll', onScrollerScroll, options);
            scrollbar.removeEventListener('scroll', onScrollbarScroll, options);
        };
    });
    const Container = props.position === 'vertical' ? $8ed8d355dd6e3c48$var$ScrollbarVertical : $8ed8d355dd6e3c48$var$ScrollbarHorizontal;
    const scrollbarInnerStyle = $acw62.useMemo(()=>({
            [propertyDimension]: `${scrollbarInnerSize}px`
        }), [
        propertyDimension,
        scrollbarInnerSize
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Container, {
        ref: (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, scrollbarRef),
        className: classes.root,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: (event)=>{
            event.target.blur();
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: classes.content,
            style: scrollbarInnerStyle
        })
    });
});



var $acw62 = parcelRequire("acw62");











'use client';
const $b88a04cfc9f9993e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, position: position } = ownerState;
    const slots = {
        root: [
            'scrollShadow',
            `scrollShadow--${position}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $b88a04cfc9f9993e$var$ScrollShadow = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ScrollShadow',
    overridesResolver: (props, styles)=>[
            styles.root,
            styles[props.position]
        ]
})(({ theme: theme })=>({
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        transition: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transition([
            'box-shadow'
        ], {
            duration: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transitions.duration.short
        }),
        '--length': theme.palette.mode === 'dark' ? '8px' : '6px',
        '--length-inverse': 'calc(var(--length) * -1)',
        '--opacity': theme.palette.mode === 'dark' ? '0.7' : '0.18',
        '--blur': 'var(--length)',
        '--spread': 'calc(var(--length) * -1)',
        '--color': '0, 0, 0',
        '--color-start': 'rgba(var(--color), calc(var(--hasScrollStart) * var(--opacity)))',
        '--color-end': 'rgba(var(--color), calc(var(--hasScrollEnd) * var(--opacity)))',
        variants: [
            {
                props: {
                    position: 'vertical'
                },
                style: {
                    top: 'var(--DataGrid-topContainerHeight)',
                    bottom: 'calc(var(--DataGrid-bottomContainerHeight) + var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))',
                    boxShadow: 'inset 0 var(--length) var(--blur) var(--spread) var(--color-start), inset 0 var(--length-inverse) var(--blur) var(--spread) var(--color-end)'
                }
            },
            {
                props: {
                    position: 'horizontal'
                },
                style: {
                    left: 'var(--DataGrid-leftPinnedWidth)',
                    right: 'calc(var(--DataGrid-rightPinnedWidth) + var(--DataGrid-hasScrollY) * var(--DataGrid-scrollbarSize))',
                    boxShadow: 'inset var(--length) 0 var(--blur) var(--spread) var(--color-start), inset var(--length-inverse) 0 var(--blur) var(--spread) var(--color-end)'
                }
            }
        ]
    }));
function $b88a04cfc9f9993e$export$8cc2c93652fb1a3d(props) {
    const { position: position } = props;
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes,
        position: position
    };
    const classes = $b88a04cfc9f9993e$var$useUtilityClasses(ownerState);
    const ref = $acw62.useRef(null);
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const hasScrollX = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$5dfe533d5e873745));
    const hasScrollY = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$4fe814c21f610df));
    const pinnedRows = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$ffe7071c481e32b0));
    const pinnedColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$1eea0bd4db853467));
    const initialScrollable = position === 'vertical' ? hasScrollY && pinnedRows?.bottom?.length > 0 : hasScrollX && pinnedColumns?.right?.length !== undefined && pinnedColumns?.right?.length > 0;
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const updateScrollShadowVisibility = $acw62.useCallback((scrollPosition)=>{
        if (!ref.current) return;
        // Math.abs to convert negative scroll position (RTL) to positive
        const scroll = Math.abs(Math.round(scrollPosition));
        const dimensions = (0, $9f487993152f6061$export$26d8768b83a52ffd)(apiRef);
        const maxScroll = Math.round(dimensions.contentSize[position === 'vertical' ? 'height' : 'width'] - dimensions.viewportInnerSize[position === 'vertical' ? 'height' : 'width']);
        const hasPinnedStart = position === 'vertical' ? pinnedRows?.top?.length > 0 : pinnedColumns?.left?.length !== undefined && pinnedColumns?.left?.length > 0;
        const hasPinnedEnd = position === 'vertical' ? pinnedRows?.bottom?.length > 0 : pinnedColumns?.right?.length !== undefined && pinnedColumns?.right?.length > 0;
        const scrollIsNotAtStart = isRtl ? scroll < maxScroll : scroll > 0;
        const scrollIsNotAtEnd = isRtl ? scroll > 0 : scroll < maxScroll;
        ref.current.style.setProperty('--hasScrollStart', hasPinnedStart && scrollIsNotAtStart ? '1' : '0');
        ref.current.style.setProperty('--hasScrollEnd', hasPinnedEnd && scrollIsNotAtEnd ? '1' : '0');
    }, [
        pinnedRows,
        pinnedColumns,
        isRtl,
        position,
        apiRef
    ]);
    const handleScrolling = (scrollParams)=>{
        updateScrollShadowVisibility(scrollParams[position === 'vertical' ? 'top' : 'left']);
    };
    const handleColumnResizeStop = ()=>{
        if (position === 'horizontal') updateScrollShadowVisibility(apiRef.current.virtualScrollerRef?.current?.scrollLeft || 0);
    };
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'scrollPositionChange', handleScrolling);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    $acw62.useEffect(()=>{
        updateScrollShadowVisibility((position === 'horizontal' ? apiRef.current.virtualScrollerRef?.current?.scrollLeft : apiRef.current.virtualScrollerRef?.current?.scrollTop) ?? 0);
    }, [
        updateScrollShadowVisibility,
        apiRef,
        position
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b88a04cfc9f9993e$var$ScrollShadow, {
        className: classes.root,
        ownerState: ownerState,
        ref: ref,
        style: {
            '--hasScrollStart': 0,
            '--hasScrollEnd': initialScrollable ? '1' : '0'
        }
    });
}



parcelRequire("acw62");










const $2ddf06e0cdf7a327$var$GridOverlayWrapperRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapper',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant' && prop !== 'right'
})(({ overlayType: overlayType, loadingOverlayVariant: loadingOverlayVariant, right: right })=>// Skeleton overlay should flow with the scroll container and not be sticky
    loadingOverlayVariant !== 'skeleton' ? {
        position: 'sticky',
        // To stay in place while scrolling
        top: 'var(--DataGrid-headersTotalHeight)',
        // TODO: take pinned rows into account
        left: 0,
        right: `${right}px`,
        width: 0,
        // To stay above the content instead of shifting it down
        height: 0,
        // To stay above the content instead of shifting it down
        zIndex: overlayType === 'loadingOverlay' ? 5 // Should be above pinned columns, pinned rows, and detail panel
         : 4 // Should be above pinned columns and detail panel
    } : {});
const $2ddf06e0cdf7a327$var$GridOverlayWrapperInner = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'OverlayWrapperInner',
    shouldForwardProp: (prop)=>prop !== 'overlayType' && prop !== 'loadingOverlayVariant'
})({});
const $2ddf06e0cdf7a327$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlayWrapper'
        ],
        inner: [
            'overlayWrapperInner'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
function $2ddf06e0cdf7a327$export$e9c94d54c23374cb(props) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const dimensions = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$26d8768b83a52ffd));
    let height = Math.max(dimensions.viewportOuterSize.height - dimensions.topContainerHeight - dimensions.bottomContainerHeight - (dimensions.hasScrollX ? dimensions.scrollbarSize : 0), 0);
    if (height === 0) height = (0, $4ab53eafabc4b920$export$a95780409968416e);
    const classes = $2ddf06e0cdf7a327$var$useUtilityClasses((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2ddf06e0cdf7a327$var$GridOverlayWrapperRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classes.root
    }, props, {
        right: dimensions.columnsTotalWidth - dimensions.viewportOuterSize.width,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2ddf06e0cdf7a327$var$GridOverlayWrapperInner, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            className: classes.inner,
            style: {
                height: height,
                width: dimensions.viewportOuterSize.width
            }
        }, props))
    }));
}



const $c8324974e3b4f8b5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, hasScrollX: hasScrollX, hasPinnedRight: hasPinnedRight, loadingOverlayVariant: loadingOverlayVariant, overlayType: overlayType } = ownerState;
    const hideContent = loadingOverlayVariant === 'skeleton' || overlayType === 'noColumnsOverlay';
    const slots = {
        root: [
            'main',
            hasPinnedRight && 'main--hasPinnedRight',
            hideContent && 'main--hiddenContent'
        ],
        scroller: [
            'virtualScroller',
            hasScrollX && 'virtualScroller--hasScrollX'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $c8324974e3b4f8b5$var$Scroller = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'VirtualScroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.virtualScroller,
            ownerState.hasScrollX && styles['virtualScroller--hasScrollX']
        ];
    }
})({
    position: 'relative',
    height: '100%',
    flexGrow: 1,
    overflow: 'scroll',
    scrollbarWidth: 'none' /* Firefox */ ,
    display: 'flex',
    flexDirection: 'column',
    '&::-webkit-scrollbar': {
        display: 'none' /* Safari and Chrome */ 
    },
    '@media print': {
        overflow: 'hidden'
    },
    // See https://github.com/mui/mui-x/issues/10547
    zIndex: 0
});
const $c8324974e3b4f8b5$var$hasPinnedRightSelector = (apiRef)=>apiRef.current.state.dimensions.rightPinnedWidth > 0;
function $c8324974e3b4f8b5$export$febd8ae712031b27(props) {
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const hasScrollY = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$4fe814c21f610df));
    const hasScrollX = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$5dfe533d5e873745));
    const hasPinnedRight = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, $c8324974e3b4f8b5$var$hasPinnedRightSelector);
    const hasBottomFiller = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$98dc8438c286cc21));
    const { overlayType: overlayType, loadingOverlayVariant: loadingOverlayVariant } = (0, $5b89fc3f616edf04$export$ba0092e600a72afc)(apiRef, rootProps);
    const Overlay = rootProps.slots?.[overlayType];
    const ownerState = {
        classes: rootProps.classes,
        hasScrollX: hasScrollX,
        hasPinnedRight: hasPinnedRight,
        overlayType: overlayType,
        loadingOverlayVariant: loadingOverlayVariant
    };
    const classes = $c8324974e3b4f8b5$var$useUtilityClasses(ownerState);
    const virtualScroller = apiRef.current.virtualizer.api.useVirtualization().getters;
    const { getContainerProps: getContainerProps, getScrollerProps: getScrollerProps, getContentProps: getContentProps, getScrollbarVerticalProps: getScrollbarVerticalProps, getScrollbarHorizontalProps: getScrollbarHorizontalProps, getRows: getRows, getScrollAreaProps: getScrollAreaProps } = virtualScroller;
    const rows = getRows(undefined, (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2c42d23fff385703$export$74039dccf215bc2a), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classes.root
    }, getContainerProps(), {
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1dc77693aecc816$export$40bcbdb719b20690), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                scrollDirection: "left"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1dc77693aecc816$export$40bcbdb719b20690), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                scrollDirection: "right"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1dc77693aecc816$export$40bcbdb719b20690), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                scrollDirection: "up"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e1dc77693aecc816$export$40bcbdb719b20690), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                scrollDirection: "down"
            }, getScrollAreaProps())),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c8324974e3b4f8b5$var$Scroller, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                className: classes.scroller
            }, getScrollerProps(), {
                ownerState: ownerState,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $2da8e1075d115d7b$export$820d93aabd2ee77d), {
                        children: [
                            !rootProps.listView && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9244b53123902fe1$export$151397d1f4bb9231), {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.pinnedRows, {
                                position: "top",
                                virtualScroller: virtualScroller
                            })
                        ]
                    }),
                    overlayType && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2ddf06e0cdf7a327$export$e9c94d54c23374cb), {
                        overlayType: overlayType,
                        loadingOverlayVariant: loadingOverlayVariant,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Overlay, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.[overlayType]))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74384f08de97887a$export$97d48eb8ba00afb8), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, getContentProps(), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0c4420d9d70612dc$export$95930d31e6a9269f), {
                            role: "rowgroup",
                            children: [
                                rows,
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.detailPanels, {
                                    virtualScroller: virtualScroller
                                })
                            ]
                        })
                    })),
                    hasBottomFiller && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25fbc570ad250e93$export$832a8b454433e1c8), {
                        rowsLength: rows.length
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.bottomContainer, {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.pinnedRows, {
                            position: "bottom",
                            virtualScroller: virtualScroller
                        })
                    })
                ]
            })),
            hasScrollX && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    rootProps.pinnedColumnsSectionSeparator?.endsWith('shadow') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b88a04cfc9f9993e$export$8cc2c93652fb1a3d), {
                        position: "horizontal"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ed8d355dd6e3c48$export$96aeae8bf32b76b8), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        position: "horizontal"
                    }, getScrollbarHorizontalProps()))
                ]
            }),
            hasScrollY && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    rootProps.pinnedRowsSectionSeparator?.endsWith('shadow') && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b88a04cfc9f9993e$export$8cc2c93652fb1a3d), {
                        position: "vertical"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ed8d355dd6e3c48$export$96aeae8bf32b76b8), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        position: "vertical"
                    }, getScrollbarVerticalProps()))
                ]
            }),
            hasScrollX && hasScrollY && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ed8d355dd6e3c48$export$af368460b527b7b2), {
                "aria-hidden": "true"
            }),
            props.children
        ]
    }));
}


parcelRequire("acw62");


function $3c4cbea6e8b4ad20$export$6d80c98441abb3ab() {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    if (rootProps.hideFooter) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.footer, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.footer /* FIXME: typing error */ ));
}



const $eb0770698da179d3$var$_excluded = [
    "className",
    "children",
    "sidePanel"
];
const $eb0770698da179d3$var$useUtilityClasses = (ownerState, density)=>{
    const { autoHeight: autoHeight, classes: classes, showCellVerticalBorder: showCellVerticalBorder } = ownerState;
    const slots = {
        root: [
            'root',
            autoHeight && 'autoHeight',
            `root--density${(0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(density)}`,
            ownerState.slots.toolbar === null && 'root--noToolbar',
            'withBorderColor',
            showCellVerticalBorder && 'withVerticalBorder'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $eb0770698da179d3$var$GridRoot = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridRoot(props, ref) {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { className: className, children: children, sidePanel: sidePanel } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $eb0770698da179d3$var$_excluded);
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const density = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $3d9afbbff3fa8293$export$806a039ece4425b4));
    const rootElementRef = apiRef.current.rootElementRef;
    const rootMountCallback = $acw62.useCallback((node)=>{
        if (node === null) return;
        apiRef.current.publishEvent('rootMount', node);
    }, [
        apiRef
    ]);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(rootElementRef, ref, rootMountCallback);
    const ownerState = rootProps;
    const classes = $eb0770698da179d3$var$useUtilityClasses(ownerState, density);
    const cssVariables = (0, $cadacf9afeddf573$export$82522e07c85e7b6a)();
    const isSSR = (0, $824e939a1ebbddfa$export$535bd6ca7f90a273)();
    if (isSSR) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c0a4879b2d654e0c$export$42458c7ae3a97297), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className, cssVariables.className, sidePanel && (0, $59e5f6b0ce3da023$export$2100d54e36406477).withSidePanel),
        ownerState: ownerState
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $59e5f6b0ce3da023$export$2100d54e36406477).mainContent,
                role: "presentation",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $099e862ec7130a3f$export$74ac40502a3200d3), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c8324974e3b4f8b5$export$febd8ae712031b27), {
                        children: children
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4cbea6e8b4ad20$export$6d80c98441abb3ab), {})
                ]
            }),
            sidePanel,
            cssVariables.tag
        ]
    }));
});
const $eb0770698da179d3$export$8cdbcd3b320d39bf = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($eb0770698da179d3$var$GridRoot);








/**
 * Signal to the underlying logic what version of the public component API
 * of the Data Grid is exposed.
 */ let $bf2466368e56dd38$export$544be0bdf85b5af1 = /*#__PURE__*/ function(GridSignature) {
    GridSignature["DataGrid"] = "DataGrid";
    GridSignature["DataGridPro"] = "DataGridPro";
    GridSignature["DataGridPremium"] = "DataGridPremium";
    return GridSignature;
}({});








class $0f89d07cedceae67$var$IncludeManager {
    constructor(model){
        this.data = model.ids;
    }
    has(id) {
        return this.data.has(id);
    }
    select(id) {
        this.data.add(id);
    }
    unselect(id) {
        this.data.delete(id);
    }
}
class $0f89d07cedceae67$var$ExcludeManager {
    constructor(model){
        this.data = model.ids;
    }
    has(id) {
        return !this.data.has(id);
    }
    select(id) {
        this.data.delete(id);
    }
    unselect(id) {
        this.data.add(id);
    }
}
const $0f89d07cedceae67$export$c0efd9f64c7d532a = (model)=>{
    if (model.type === 'include') return new $0f89d07cedceae67$var$IncludeManager(model);
    return new $0f89d07cedceae67$var$ExcludeManager(model);
};


const $32777ac93d35a3f3$export$f663bee74a6091fc = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.rowSelection);
const $32777ac93d35a3f3$export$a13307f39ccef042 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($32777ac93d35a3f3$export$f663bee74a6091fc, (0, $0f89d07cedceae67$export$c0efd9f64c7d532a));
const $32777ac93d35a3f3$export$408e67b791fe352 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($32777ac93d35a3f3$export$f663bee74a6091fc, (0, $51d9da8b83918212$export$ee3e723e6d15f78c), (selection, filteredRowCount)=>{
    if (selection.type === 'include') return selection.ids.size;
    // In exclude selection, all rows are selectable.
    return filteredRowCount - selection.ids.size;
});
const $32777ac93d35a3f3$export$815b73af677cc8a1 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($32777ac93d35a3f3$export$f663bee74a6091fc, (0, $4fc0d4cb0e570e63$export$37767f9110c99048), (0, $4fc0d4cb0e570e63$export$c7dcaab5e573753), (selectionModel, rowsLookup, rowIds)=>{
    const map = new Map();
    if (selectionModel.type === 'include') for (const id of selectionModel.ids)map.set(id, rowsLookup[id]);
    else for(let i = 0; i < rowIds.length; i += 1){
        const id = rowIds[i];
        if (!selectionModel.ids.has(id)) map.set(id, rowsLookup[id]);
    }
    return map;
});




const $5e9cd545f0675d8f$export$aec8936a41d479a2 = {
    parents: true,
    descendants: true
};
function $5e9cd545f0675d8f$var$getGridRowGroupSelectableDescendants(apiRef, groupId) {
    const rowTree = (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef);
    const sortedRowIds = (0, $f0897a6c670e0208$export$e4979ad0a2db8752)(apiRef);
    const filteredRowsLookup = (0, $51d9da8b83918212$export$6d031b6e8cbaf41c)(apiRef);
    const groupNode = rowTree[groupId];
    if (!groupNode || groupNode.type !== 'group') return [];
    const descendants = [];
    const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
    for(let index = startIndex; index < sortedRowIds.length && rowTree[sortedRowIds[index]]?.depth > groupNode.depth; index += 1){
        const id = sortedRowIds[index];
        if (filteredRowsLookup[id] !== false && apiRef.current.isRowSelectable(id)) descendants.push(id);
    }
    return descendants;
}
const $5e9cd545f0675d8f$export$3183bf7cf206881f = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)((0, $4fc0d4cb0e570e63$export$de9a43d646a9821d), (0, $51d9da8b83918212$export$6d031b6e8cbaf41c), (0, $32777ac93d35a3f3$export$a13307f39ccef042), (rowTree, filteredRowsLookup, rowSelectionManager, { groupId: groupId, autoSelectParents: autoSelectParents })=>{
    const groupNode = rowTree[groupId];
    if (!groupNode || groupNode.type !== 'group' || rowSelectionManager.has(groupId)) return {
        isIndeterminate: false,
        isChecked: rowSelectionManager.has(groupId)
    };
    let hasSelectedDescendant = false;
    let hasUnSelectedDescendant = false;
    const traverseDescendants = (itemToTraverseId)=>{
        if (filteredRowsLookup[itemToTraverseId] === false || // Perf: Skip checking the rest of the descendants if we already
        // know that there is a selected and an unselected descendant
        hasSelectedDescendant && hasUnSelectedDescendant) return;
        const node = rowTree[itemToTraverseId];
        if (node?.type === 'group') node.children.forEach(traverseDescendants);
        if (rowSelectionManager.has(itemToTraverseId)) hasSelectedDescendant = true;
        else hasUnSelectedDescendant = true;
    };
    traverseDescendants(groupId);
    return {
        isIndeterminate: hasSelectedDescendant && hasUnSelectedDescendant,
        isChecked: autoSelectParents ? hasSelectedDescendant && !hasUnSelectedDescendant : false
    };
});
function $5e9cd545f0675d8f$export$cfcdc2e1121f7851(props) {
    if (props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid) // DataGrid Community has multiple row selection enabled only if checkbox selection is enabled.
    return props.checkboxSelection && props.disableMultipleRowSelection !== true;
    return !props.disableMultipleRowSelection;
}
const $5e9cd545f0675d8f$var$getRowNodeParents = (tree, id)=>{
    const parents = [];
    let parent = id;
    while(parent != null && parent !== (0, $4ab53eafabc4b920$export$433b924dc2506913)){
        const node = tree[parent];
        if (!node) return parents;
        parents.push(parent);
        parent = node.parent;
    }
    return parents;
};
const $5e9cd545f0675d8f$var$getFilteredRowNodeSiblings = (tree, filteredRows, id)=>{
    const node = tree[id];
    if (!node) return [];
    const parent = node.parent;
    if (parent == null) return [];
    const parentNode = tree[parent];
    return parentNode.children.filter((childId)=>childId !== id && filteredRows[childId] !== false);
};
const $5e9cd545f0675d8f$export$a8171774e887a9d0 = (apiRef, tree, selectedRow, autoSelectDescendants, autoSelectParents, addRow, rowSelectionManager = (0, $32777ac93d35a3f3$export$a13307f39ccef042)(apiRef))=>{
    const filteredRows = (0, $51d9da8b83918212$export$6d031b6e8cbaf41c)(apiRef);
    const selectedDescendants = new Set([]);
    if (!autoSelectDescendants && !autoSelectParents || filteredRows[selectedRow] === false) return;
    if (autoSelectDescendants) {
        const rowNode = tree[selectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $5e9cd545f0675d8f$var$getGridRowGroupSelectableDescendants(apiRef, selectedRow);
            descendants.forEach((rowId)=>{
                addRow(rowId);
                selectedDescendants.add(rowId);
            });
        }
    }
    if (autoSelectParents) {
        const checkAllDescendantsSelected = (rowId)=>{
            if (!rowSelectionManager.has(rowId) && !selectedDescendants.has(rowId)) return false;
            const node = tree[rowId];
            if (!node) return false;
            if (node.type !== 'group') return true;
            return node.children.every(checkAllDescendantsSelected);
        };
        const traverseParents = (rowId)=>{
            const siblings = $5e9cd545f0675d8f$var$getFilteredRowNodeSiblings(tree, filteredRows, rowId);
            if (siblings.length === 0 || siblings.every(checkAllDescendantsSelected)) {
                const rowNode = tree[rowId];
                const parent = rowNode?.parent;
                if (parent != null && parent !== (0, $4ab53eafabc4b920$export$433b924dc2506913) && apiRef.current.isRowSelectable(parent)) {
                    addRow(parent);
                    selectedDescendants.add(parent);
                    traverseParents(parent);
                }
            }
        };
        // For root level rows, we don't need to traverse parents
        const rowNode = tree[selectedRow];
        if (!rowNode || rowNode.parent === (0, $4ab53eafabc4b920$export$433b924dc2506913)) return;
        traverseParents(selectedRow);
    }
};
const $5e9cd545f0675d8f$export$dbbc58cbb95afec2 = (apiRef, tree, deselectedRow, autoSelectDescendants, autoSelectParents, removeRow)=>{
    const rowSelectionManager = (0, $32777ac93d35a3f3$export$a13307f39ccef042)(apiRef);
    if (!autoSelectParents && !autoSelectDescendants) return;
    if (autoSelectParents) {
        const allParents = $5e9cd545f0675d8f$var$getRowNodeParents(tree, deselectedRow);
        allParents.forEach((parent)=>{
            const isSelected = rowSelectionManager.has(parent);
            if (isSelected) removeRow(parent);
        });
    }
    if (autoSelectDescendants) {
        const rowNode = tree[deselectedRow];
        if (rowNode?.type === 'group') {
            const descendants = $5e9cd545f0675d8f$var$getGridRowGroupSelectableDescendants(apiRef, deselectedRow);
            descendants.forEach((descendant)=>{
                removeRow(descendant);
            });
        }
    }
};



const $11f858f5913b140b$export$89716d1110d32214 = ()=>{
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$16a65a9447d3dda9));
    const accessibleRowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$96919017bbfaec0d));
    const headerGroupingMaxDepth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $424decc09f6745ae$export$4cf0369c079b29be));
    const pinnedRowsCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$8e3fb3525d7db988));
    const ariaLabel = rootProps['aria-label'];
    const ariaLabelledby = rootProps['aria-labelledby'];
    // `aria-label` and `aria-labelledby` should take precedence over `label`
    const shouldUseLabelAsAriaLabel = !ariaLabel && !ariaLabelledby && rootProps.label;
    return {
        role: 'grid',
        'aria-label': shouldUseLabelAsAriaLabel ? rootProps.label : ariaLabel,
        'aria-labelledby': ariaLabelledby,
        'aria-colcount': visibleColumns.length,
        'aria-rowcount': headerGroupingMaxDepth + 1 + pinnedRowsCount + accessibleRowCount,
        'aria-multiselectable': (0, $5e9cd545f0675d8f$export$cfcdc2e1121f7851)(rootProps)
    };
};



var $acw62 = parcelRequire("acw62");



const $07351265ddaf321c$export$c27cdb450c323320 = ()=>{
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const headerGroupingMaxDepth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $424decc09f6745ae$export$4cf0369c079b29be));
    return $acw62.useCallback((rowNode, index)=>{
        const ariaAttributes = {};
        const ariaRowIndex = index + headerGroupingMaxDepth + 2; // 1 for the header row and 1 as it's 1-based
        ariaAttributes['aria-rowindex'] = ariaRowIndex;
        // XXX: fix this properly
        if (rowNode && apiRef.current.isRowSelectable(rowNode.id)) ariaAttributes['aria-selected'] = apiRef.current.isRowSelected(rowNode.id);
        return ariaAttributes;
    }, [
        apiRef,
        headerGroupingMaxDepth
    ]);
};




var $acw62 = parcelRequire("acw62");


const $de203767b3639384$export$7fd6bd072bc860f3 = (apiRef)=>{
    const setRowIndex = $acw62.useCallback((rowId, targetIndex)=>{
        const node = (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, rowId);
        if (!node) throw new Error(`MUI X: No row with id #${rowId} found.`);
        // TODO: Remove irrelevant checks
        if (node.parent !== (0, $4ab53eafabc4b920$export$433b924dc2506913)) throw new Error(`MUI X: The row reordering do not support reordering of grouped rows yet.`);
        if (node.type !== 'leaf') throw new Error(`MUI X: The row reordering do not support reordering of footer or grouping rows.`);
        apiRef.current.setState((state)=>{
            const group = (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef)[0, $4ab53eafabc4b920$export$433b924dc2506913];
            const allRows = group.children;
            const oldIndex = allRows.findIndex((row)=>row === rowId);
            if (oldIndex === -1 || oldIndex === targetIndex) return state;
            const updatedRows = [
                ...allRows
            ];
            updatedRows.splice(targetIndex, 0, updatedRows.splice(oldIndex, 1)[0]);
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, {
                    tree: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows.tree, {
                        [(0, $4ab53eafabc4b920$export$433b924dc2506913)]: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, group, {
                            children: updatedRows
                        })
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef
    ]);
    return {
        setRowIndex: setRowIndex
    };
};



var $acw62 = parcelRequire("acw62");

const $341a55c994058083$export$e09fb8462b5f4ab6 = (apiRef)=>{
    const getCellValue = $acw62.useCallback((id, field)=>{
        const colDef = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        if (!row) throw new Error(`No row with id #${id} found`);
        if (!colDef || !colDef.valueGetter) return row[field];
        return colDef.valueGetter(row[colDef.field], row, colDef, apiRef);
    }, [
        apiRef
    ]);
    const getRowValue = $acw62.useCallback((row, colDef)=>(0, $4ab53eafabc4b920$export$67e819ef21602bdb)(row, colDef, apiRef), [
        apiRef
    ]);
    const getRowFormattedValue = $acw62.useCallback((row, colDef)=>{
        const value = getRowValue(row, colDef);
        if (!colDef || !colDef.valueFormatter) return value;
        return colDef.valueFormatter(value, row, colDef, apiRef);
    }, [
        apiRef,
        getRowValue
    ]);
    return {
        getCellValue: getCellValue,
        getRowValue: getRowValue,
        getRowFormattedValue: getRowFormattedValue
    };
};



var $acw62 = parcelRequire("acw62");







function $80cd1013749013f5$export$4fd26c08a15cabb4({ privateApiRef: privateApiRef, configuration: configuration, props: props, children: children }) {
    const apiRef = $acw62.useRef(privateApiRef.current.getPublicApi());
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $662a26edaf9ba9f0$export$714d6aa898a12d6c).Provider, {
        value: configuration,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11abf6438ce67a48$export$e00c5fe7e13db7ba).Provider, {
            value: props,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $caa6246df345d6fe$export$37099e7a34cbf988).Provider, {
                value: privateApiRef,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $15d0738a634b2067$export$70c437c2dab15e52).Provider, {
                    value: apiRef,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9638e12379adda14$export$df24b15a5e161339), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cadacf9afeddf573$export$377b45915d3a03ca), {
                            children: children
                        })
                    })
                })
            })
        })
    });
}



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
const $88da962386c0fa94$export$9f7c27985c4a3681 = (apiRef)=>{
    const rootElementRef = $acw62.useRef(null);
    const mainElementRef = $acw62.useRef(null);
    const virtualScrollerRef = $acw62.useRef(null);
    const virtualScrollbarVerticalRef = $acw62.useRef(null);
    const virtualScrollbarHorizontalRef = $acw62.useRef(null);
    const columnHeadersContainerRef = $acw62.useRef(null);
    apiRef.current.register('public', {
        rootElementRef: rootElementRef
    });
    apiRef.current.register('private', {
        mainElementRef: mainElementRef,
        virtualScrollerRef: virtualScrollerRef,
        virtualScrollbarVerticalRef: virtualScrollbarVerticalRef,
        virtualScrollbarHorizontalRef: virtualScrollbarHorizontalRef,
        columnHeadersContainerRef: columnHeadersContainerRef
    });
};




var $acw62 = parcelRequire("acw62");

'use client';
const $d4b9fcf4d1a7eaaf$export$f9172a9d6b7b2acd = (apiRef)=>{
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    if (apiRef.current.state.isRtl === undefined) apiRef.current.state.isRtl = isRtl;
    const isFirstEffect = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstEffect.current) isFirstEffect.current = false;
        else apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                isRtl: isRtl
            }));
    }, [
        apiRef,
        isRtl
    ]);
};



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $c84301dfe99ee71f$export$739f6b6a65e76d6c(privateApiRef, apiMethods, visibility) {
    const isFirstRender = $acw62.useRef(true);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        isFirstRender.current = false;
        privateApiRef.current.register(visibility, apiMethods);
    }, [
        privateApiRef,
        visibility,
        apiMethods
    ]);
    if (isFirstRender.current) privateApiRef.current.register(visibility, apiMethods);
}


const $8dacc08a655be3f0$var$forceDebug = (0, $07a64ebfd26f4296$export$c43914e0cb16a981)() && window.localStorage.getItem('DEBUG') != null;
const $8dacc08a655be3f0$var$noop = ()=>{};
const $8dacc08a655be3f0$var$noopLogger = {
    debug: $8dacc08a655be3f0$var$noop,
    info: $8dacc08a655be3f0$var$noop,
    warn: $8dacc08a655be3f0$var$noop,
    error: $8dacc08a655be3f0$var$noop
};
const $8dacc08a655be3f0$var$LOG_LEVELS = [
    'debug',
    'info',
    'warn',
    'error'
];
function $8dacc08a655be3f0$var$getAppender(name, logLevel, appender = console) {
    const minLogLevelIdx = $8dacc08a655be3f0$var$LOG_LEVELS.indexOf(logLevel);
    if (minLogLevelIdx === -1) throw new Error(`MUI X: Log level ${logLevel} not recognized.`);
    const logger = $8dacc08a655be3f0$var$LOG_LEVELS.reduce((loggerObj, method, idx)=>{
        if (idx >= minLogLevelIdx) loggerObj[method] = (...args)=>{
            const [message, ...other] = args;
            appender[method](`MUI X: ${name} - ${message}`, ...other);
        };
        else loggerObj[method] = $8dacc08a655be3f0$var$noop;
        return loggerObj;
    }, {});
    return logger;
}
const $8dacc08a655be3f0$export$db6c72f4003d67df = (apiRef, props)=>{
    const getLogger = $acw62.useCallback((name)=>{
        if ($8dacc08a655be3f0$var$forceDebug) return $8dacc08a655be3f0$var$getAppender(name, 'debug', props.logger);
        if (!props.logLevel) return $8dacc08a655be3f0$var$noopLogger;
        return $8dacc08a655be3f0$var$getAppender(name, props.logLevel.toString(), props.logger);
    }, [
        props.logLevel,
        props.logger
    ]);
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, {
        getLogger: getLogger
    }, 'private');
};



var $acw62 = parcelRequire("acw62");
const $3d53e5c9b2d80ef2$export$9943f2ed4ddf85bf = (apiRef, props)=>{
    const getLocaleText = $acw62.useCallback((key)=>{
        if (props.localeText[key] == null) throw new Error(`Missing translation for key ${key}.`);
        return props.localeText[key];
    }, [
        props.localeText
    ]);
    apiRef.current.register('public', {
        getLocaleText: getLocaleText
    });
};





var $acw62 = parcelRequire("acw62");

const $19cc5a5eeb6f2141$export$1c5794e7ed1dc58f = (apiRef)=>{
    const cache = $acw62.useRef({});
    const isRunning = $acw62.useRef(false);
    const runAppliers = $acw62.useCallback((groupCache)=>{
        if (isRunning.current || !groupCache) return;
        isRunning.current = true;
        Object.values(groupCache.appliers).forEach((callback)=>{
            callback();
        });
        isRunning.current = false;
    }, []);
    const registerPipeProcessor = $acw62.useCallback((group, id, processor)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {},
            processorsUpdated: false
        };
        const groupCache = cache.current[group];
        const oldProcessor = groupCache.processors.get(id);
        if (oldProcessor !== processor) {
            groupCache.processors.set(id, processor);
            groupCache.processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
            groupCache.processorsUpdated = true;
        }
        return ()=>{
            cache.current[group].processors.set(id, null);
            cache.current[group].processorsAsArray = Array.from(cache.current[group].processors.values()).filter((processorValue)=>processorValue !== null);
        };
    }, []);
    const registerPipeApplier = $acw62.useCallback((group, id, applier)=>{
        if (!cache.current[group]) cache.current[group] = {
            processors: new Map(),
            processorsAsArray: [],
            appliers: {},
            processorsUpdated: false
        };
        cache.current[group].appliers[id] = applier;
        return ()=>{
            const _appliers = cache.current[group].appliers, otherAppliers = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_appliers, [
                id
            ].map((0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)));
            cache.current[group].appliers = otherAppliers;
        };
    }, []);
    const requestPipeProcessorsApplication = $acw62.useCallback((group)=>{
        runAppliers(cache.current[group]);
    }, [
        runAppliers
    ]);
    const runAppliersForPendingProcessors = $acw62.useCallback(()=>{
        for(const group in cache.current){
            if (!Object.prototype.hasOwnProperty.call(cache.current, group)) continue;
            const groupCache = cache.current[group];
            if (groupCache.processorsUpdated) {
                groupCache.processorsUpdated = false;
                runAppliers(groupCache);
            }
        }
    }, [
        runAppliers
    ]);
    const applyPipeProcessors = $acw62.useCallback((...args)=>{
        const [group, value, context] = args;
        if (!cache.current[group]) return value;
        const processors = cache.current[group].processorsAsArray;
        let result = value;
        for(let i = 0; i < processors.length; i += 1)result = processors[i](result, context);
        return result;
    }, []);
    const preProcessingPrivateApi = {
        registerPipeProcessor: registerPipeProcessor,
        registerPipeApplier: registerPipeApplier,
        requestPipeProcessorsApplication: requestPipeProcessorsApplication,
        runAppliersForPendingProcessors: runAppliersForPendingProcessors
    };
    const preProcessingPublicApi = {
        unstable_applyPipeProcessors: applyPipeProcessors
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, preProcessingPrivateApi, 'private');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, preProcessingPublicApi, 'public');
};





var $acw62 = parcelRequire("acw62");
let $327d142a03593356$export$b63360e46a4e6d92 = /*#__PURE__*/ function(GridStrategyGroup) {
    GridStrategyGroup["DataSource"] = "dataSource";
    GridStrategyGroup["RowTree"] = "rowTree";
    return GridStrategyGroup;
}({});



const $9e68111fb02b49e8$export$84214fbf04c4094 = 'none';
const $9e68111fb02b49e8$export$8c4aa1977ad5d106 = {
    dataSourceRowsUpdate: (0, $327d142a03593356$export$b63360e46a4e6d92).DataSource,
    rowTreeCreation: (0, $327d142a03593356$export$b63360e46a4e6d92).RowTree,
    filtering: (0, $327d142a03593356$export$b63360e46a4e6d92).RowTree,
    sorting: (0, $327d142a03593356$export$b63360e46a4e6d92).RowTree,
    visibleRowsLookupCreation: (0, $327d142a03593356$export$b63360e46a4e6d92).RowTree
};
const $9e68111fb02b49e8$export$594711f8e5fa9b04 = (apiRef)=>{
    const availableStrategies = $acw62.useRef(new Map());
    const strategiesCache = $acw62.useRef({});
    const registerStrategyProcessor = $acw62.useCallback((strategyName, processorName, processor)=>{
        const cleanup = ()=>{
            const _ref = strategiesCache.current[processorName], otherProcessors = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, [
                strategyName
            ].map((0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)));
            strategiesCache.current[processorName] = otherProcessors;
        };
        if (!strategiesCache.current[processorName]) strategiesCache.current[processorName] = {};
        const groupPreProcessors = strategiesCache.current[processorName];
        const previousProcessor = groupPreProcessors[strategyName];
        groupPreProcessors[strategyName] = processor;
        if (!previousProcessor || previousProcessor === processor) return cleanup;
        if (strategyName === apiRef.current.getActiveStrategy($9e68111fb02b49e8$export$8c4aa1977ad5d106[processorName])) apiRef.current.publishEvent('activeStrategyProcessorChange', processorName);
        return cleanup;
    }, [
        apiRef
    ]);
    const applyStrategyProcessor = $acw62.useCallback((processorName, params)=>{
        const activeStrategy = apiRef.current.getActiveStrategy($9e68111fb02b49e8$export$8c4aa1977ad5d106[processorName]);
        if (activeStrategy == null) throw new Error("Can't apply a strategy processor before defining an active strategy");
        const groupCache = strategiesCache.current[processorName];
        if (!groupCache || !groupCache[activeStrategy]) throw new Error(`No processor found for processor "${processorName}" on strategy "${activeStrategy}"`);
        const processor = groupCache[activeStrategy];
        return processor(params);
    }, [
        apiRef
    ]);
    const getActiveStrategy = $acw62.useCallback((strategyGroup)=>{
        const strategyEntries = Array.from(availableStrategies.current.entries());
        const availableStrategyEntry = strategyEntries.find(([, strategy])=>{
            if (strategy.group !== strategyGroup) return false;
            return strategy.isAvailable();
        });
        return availableStrategyEntry?.[0] ?? $9e68111fb02b49e8$export$84214fbf04c4094;
    }, []);
    const setStrategyAvailability = $acw62.useCallback((strategyGroup, strategyName, isAvailable)=>{
        availableStrategies.current.set(strategyName, {
            group: strategyGroup,
            isAvailable: isAvailable
        });
        apiRef.current.publishEvent('strategyAvailabilityChange');
    }, [
        apiRef
    ]);
    const strategyProcessingApi = {
        registerStrategyProcessor: registerStrategyProcessor,
        applyStrategyProcessor: applyStrategyProcessor,
        getActiveStrategy: getActiveStrategy,
        setStrategyAvailability: setStrategyAvailability
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, strategyProcessingApi, 'private');
};




var $acw62 = parcelRequire("acw62");


const $d2a05b927b778944$export$53c7ec825c1e4d3f = (apiRef)=>{
    const controlStateMapRef = $acw62.useRef({});
    const registerControlState = $acw62.useCallback((controlStateItem)=>{
        controlStateMapRef.current[controlStateItem.stateId] = controlStateItem;
    }, []);
    const setState = $acw62.useCallback((state, reason)=>{
        let newState;
        if ((0, $07a64ebfd26f4296$export$f6e2535fb5126e54)(state)) newState = state(apiRef.current.state);
        else newState = state;
        if (apiRef.current.state === newState) return false;
        const apiRefWithNewState = {
            current: {
                state: newState
            }
        };
        let ignoreSetState = false;
        // Apply the control state constraints
        const updatedControlStateIds = [];
        Object.keys(controlStateMapRef.current).forEach((stateId)=>{
            const controlState = controlStateMapRef.current[stateId];
            const oldSubState = controlState.stateSelector(apiRef);
            const newSubState = controlState.stateSelector(apiRefWithNewState);
            if (newSubState === oldSubState) return;
            updatedControlStateIds.push({
                stateId: controlState.stateId,
                hasPropChanged: newSubState !== controlState.propModel
            });
            // The state is controlled, the prop should always win
            if (controlState.propModel !== undefined && newSubState !== controlState.propModel) ignoreSetState = true;
        });
        if (updatedControlStateIds.length > 1) // Each hook modify its own state, and it should not leak
        // Events are here to forward to other hooks and apply changes.
        // You are trying to update several states in a no isolated way.
        throw new Error(`You're not allowed to update several sub-state in one transaction. You already updated ${updatedControlStateIds[0].stateId}, therefore, you're not allowed to update ${updatedControlStateIds.map((el)=>el.stateId).join(', ')} in the same transaction.`);
        if (!ignoreSetState) {
            // We always assign it as we mutate rows for perf reason.
            apiRef.current.state = newState;
            apiRef.current.publishEvent('stateChange', newState);
            apiRef.current.store.update(newState);
        }
        if (updatedControlStateIds.length === 1) {
            const { stateId: stateId, hasPropChanged: hasPropChanged } = updatedControlStateIds[0];
            const controlState = controlStateMapRef.current[stateId];
            const model = controlState.stateSelector(apiRefWithNewState);
            if (controlState.propOnChange && hasPropChanged) controlState.propOnChange(model, {
                reason: reason,
                api: apiRef.current
            });
            if (!ignoreSetState) apiRef.current.publishEvent(controlState.changeEvent, model, {
                reason: reason
            });
        }
        return !ignoreSetState;
    }, [
        apiRef
    ]);
    const updateControlState = $acw62.useCallback((key, state, reason)=>{
        return apiRef.current.setState((previousState)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousState, {
                [key]: state(previousState[key])
            });
        }, reason);
    }, [
        apiRef
    ]);
    const publicStateApi = {
        setState: setState
    };
    const privateStateApi = {
        updateControlState: updateControlState,
        registerControlState: registerControlState
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, publicStateApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, privateStateApi, 'private');
};




var $acw62 = parcelRequire("acw62");
'use client';
const $84b6d5fd8ab003aa$export$eb04177a3403979f = (state, props)=>{
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        props: {
            listView: props.listView,
            getRowId: props.getRowId,
            isCellEditable: props.isCellEditable
        }
    });
};
const $84b6d5fd8ab003aa$export$38bbfdfacac6e6c2 = (apiRef, props)=>{
    $acw62.useEffect(()=>{
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                props: {
                    listView: props.listView,
                    getRowId: props.getRowId,
                    isCellEditable: props.isCellEditable
                }
            }));
    }, [
        apiRef,
        props.listView,
        props.getRowId,
        props.isCellEditable
    ]);
};


const $8e3bb8b59d89563f$export$b77462c86b28bbf0 = (privateApiRef, props)=>{
    (0, $88da962386c0fa94$export$9f7c27985c4a3681)(privateApiRef);
    (0, $84b6d5fd8ab003aa$export$38bbfdfacac6e6c2)(privateApiRef, props);
    (0, $d4b9fcf4d1a7eaaf$export$f9172a9d6b7b2acd)(privateApiRef);
    (0, $8dacc08a655be3f0$export$db6c72f4003d67df)(privateApiRef, props);
    (0, $d2a05b927b778944$export$53c7ec825c1e4d3f)(privateApiRef);
    (0, $19cc5a5eeb6f2141$export$1c5794e7ed1dc58f)(privateApiRef);
    (0, $9e68111fb02b49e8$export$594711f8e5fa9b04)(privateApiRef);
    (0, $3d53e5c9b2d80ef2$export$9943f2ed4ddf85bf)(privateApiRef, props);
    privateApiRef.current.register('private', {
        rootProps: props
    });
};




var $acw62 = parcelRequire("acw62");



function $145ef8aeadc094b1$export$28cd30446ab5724a(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}





const $e5fd677936fa6c9d$var$noop = ()=>{};
function $e5fd677936fa6c9d$export$c6cc86f9120e9aa4(store, selector, effect) {
    const instance = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($e5fd677936fa6c9d$var$initialize, {
        store: store,
        selector: selector
    }).current;
    instance.effect = effect;
    (0, $a0e38fa988f617e0$export$2e2bcd8739ae039)(instance.onMount);
}
// `useLazyRef` typings are incorrect, `params` should not be optional
function $e5fd677936fa6c9d$var$initialize(params) {
    const { store: store, selector: selector } = params;
    let previousState = selector(store.state);
    const instance = {
        effect: $e5fd677936fa6c9d$var$noop,
        dispose: null,
        // We want a single subscription done right away and cleared on unmount only,
        // but React triggers `useOnMount` multiple times in dev, so we need to manage
        // the subscription anyway.
        subscribe: ()=>{
            instance.dispose ??= store.subscribe((state)=>{
                const nextState = selector(state);
                instance.effect(previousState, nextState);
                previousState = nextState;
            });
        },
        onMount: ()=>{
            instance.subscribe();
            return ()=>{
                instance.dispose?.();
                instance.dispose = null;
            };
        }
    };
    instance.subscribe();
    return instance;
}




var $acw62 = parcelRequire("acw62");




function $62ba831024416c9b$export$de363e709c412c8a(func, wait = 166) {
    let timeout;
    let lastArgs;
    const later = ()=>{
        timeout = undefined;
        func(...lastArgs);
    };
    function throttled(...args) {
        lastArgs = args;
        if (timeout === undefined) timeout = setTimeout(later, wait);
    }
    throttled.clear = ()=>{
        clearTimeout(timeout);
        timeout = undefined;
    };
    return throttled;
}


/**
 * Based on `fast-deep-equal`
 *
 * MIT License
 *
 * Copyright (c) 2017 Evgeny Poberezkin
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * Check if two values are deeply equal.
 */ function $5ece57da2e97951f$export$78fdc9adc3f30400(a, b) {
    if (a === b) return true;
    if (a && b && typeof a === 'object' && typeof b === 'object') {
        if (a.constructor !== b.constructor) return false;
        if (Array.isArray(a)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (!$5ece57da2e97951f$export$78fdc9adc3f30400(a[i], b[i])) return false;
            }
            return true;
        }
        if (a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            const entriesA = Array.from(a.entries());
            for(let i = 0; i < entriesA.length; i += 1){
                if (!b.has(entriesA[i][0])) return false;
            }
            for(let i = 0; i < entriesA.length; i += 1){
                const entryA = entriesA[i];
                if (!$5ece57da2e97951f$export$78fdc9adc3f30400(entryA[1], b.get(entryA[0]))) return false;
            }
            return true;
        }
        if (a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            const entries = Array.from(a.entries());
            for(let i = 0; i < entries.length; i += 1){
                if (!b.has(entries[i][0])) return false;
            }
            return true;
        }
        if (ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            const length = a.length;
            if (length !== b.length) return false;
            for(let i = 0; i < length; i += 1){
                if (a[i] !== b[i]) return false;
            }
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        const keys = Object.keys(a);
        const length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(let i = 0; i < length; i += 1){
            if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        }
        for(let i = 0; i < length; i += 1){
            const key = keys[i];
            if (!$5ece57da2e97951f$export$78fdc9adc3f30400(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    // eslint-disable-next-line no-self-compare
    return a !== a && b !== b;
}



/* We need to import the shim because React 17 does not support the `useSyncExternalStore` API.
 * More info: https://github.com/mui/mui-x/issues/18303#issuecomment-2958392341 */ var $6ae5e5baff12bbf7$exports = {};
'use strict';

$6ae5e5baff12bbf7$exports = (parcelRequire("i5mAx"));


function $f49e45cf623984ce$export$6ccbb43953eebf8(store, selector, a1, a2, a3) {
    const selectorWithArgs = (state)=>selector(state, a1, a2, a3);
    return (0, $6ae5e5baff12bbf7$exports.useSyncExternalStoreWithSelector)(store.subscribe, store.getSnapshot, store.getSnapshot, selectorWithArgs);
}


/* eslint-disable @typescript-eslint/no-redeclare */ const $660aae1dda9f87cc$export$cb6da89c6af1a8ec = {
    EMPTY: {
        width: 0,
        height: 0
    },
    equals: (a, b)=>a.width === b.width && a.height === b.height
};
const $660aae1dda9f87cc$export$52f1af0f200d37e4 = {
    EMPTY: {
        top: [],
        bottom: []
    }
};
const $660aae1dda9f87cc$export$77c7ceff57ca1d7 = {
    EMPTY: {
        left: [],
        right: []
    }
};
let $660aae1dda9f87cc$export$ef1760368e0f70e4 = /*#__PURE__*/ function(ScrollDirection) {
    ScrollDirection[ScrollDirection["NONE"] = 0] = "NONE";
    ScrollDirection[ScrollDirection["UP"] = 1] = "UP";
    ScrollDirection[ScrollDirection["DOWN"] = 2] = "DOWN";
    ScrollDirection[ScrollDirection["LEFT"] = 3] = "LEFT";
    ScrollDirection[ScrollDirection["RIGHT"] = 4] = "RIGHT";
    return ScrollDirection;
}({});
(function(_ScrollDirection) {
    function forDelta(dx, dy) {
        if (dx === 0 && dy === 0) return $660aae1dda9f87cc$export$ef1760368e0f70e4.NONE;
        /* eslint-disable */ if (Math.abs(dy) >= Math.abs(dx)) {
            if (dy > 0) return $660aae1dda9f87cc$export$ef1760368e0f70e4.DOWN;
            else return $660aae1dda9f87cc$export$ef1760368e0f70e4.UP;
        } else {
            if (dx > 0) return $660aae1dda9f87cc$export$ef1760368e0f70e4.RIGHT;
            else return $660aae1dda9f87cc$export$ef1760368e0f70e4.LEFT;
        }
    /* eslint-enable */ }
    _ScrollDirection.forDelta = forDelta;
})($660aae1dda9f87cc$export$ef1760368e0f70e4 || ($660aae1dda9f87cc$export$ef1760368e0f70e4 = {}));


'use client';
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ /* eslint-disable no-underscore-dangle */ const $31773ba16720ede9$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: (0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).EMPTY,
    viewportOuterSize: (0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).EMPTY,
    viewportInnerSize: (0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).EMPTY,
    contentSize: (0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).EMPTY,
    minimumSize: (0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).EMPTY,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0
};
const $31773ba16720ede9$var$selectors = {
    rootSize: (state)=>state.rootSize,
    dimensions: (state)=>state.dimensions,
    rowHeight: (state)=>state.dimensions.rowHeight,
    contentHeight: (state)=>state.dimensions.contentSize.height,
    rowsMeta: (state)=>state.rowsMeta,
    columnPositions: (0, $76700507203bf92b$export$2a3ca4704a61d1f4)((_, columns)=>{
        const positions = [];
        let currentPosition = 0;
        for(let i = 0; i < columns.length; i += 1){
            positions.push(currentPosition);
            currentPosition += columns[i].computedWidth;
        }
        return positions;
    }),
    needsHorizontalScrollbar: (state)=>state.dimensions.viewportOuterSize.width > 0 && state.dimensions.columnsTotalWidth > state.dimensions.viewportOuterSize.width
};
const $31773ba16720ede9$export$d5b8c1948b345816 = {
    initialize: $31773ba16720ede9$var$initializeState,
    use: $31773ba16720ede9$var$useDimensions,
    selectors: $31773ba16720ede9$var$selectors
};
function $31773ba16720ede9$var$initializeState(params) {
    const dimensions = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $31773ba16720ede9$var$EMPTY_DIMENSIONS, params.dimensions);
    const { rowCount: rowCount } = params;
    const { rowHeight: rowHeight } = dimensions;
    const rowsMeta = {
        currentPageTotalHeight: rowCount * rowHeight,
        positions: Array.from({
            length: rowCount
        }, (_, i)=>i * rowHeight),
        pinnedTopRowsTotalHeight: 0,
        pinnedBottomRowsTotalHeight: 0
    };
    const rowHeights = new Map();
    return {
        rootSize: (0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).EMPTY,
        dimensions: dimensions,
        rowsMeta: rowsMeta,
        rowHeights: rowHeights
    };
}
function $31773ba16720ede9$var$useDimensions(store, params, _api) {
    const isFirstSizing = $acw62.useRef(true);
    const { refs: refs, dimensions: { rowHeight: rowHeight, columnsTotalWidth: columnsTotalWidth, leftPinnedWidth: leftPinnedWidth, rightPinnedWidth: rightPinnedWidth, topPinnedHeight: topPinnedHeight, bottomPinnedHeight: bottomPinnedHeight }, onResize: onResize } = params;
    const containerNode = refs.container.current;
    const updateDimensions = $acw62.useCallback(()=>{
        if (isFirstSizing.current) return;
        const rootSize = $31773ba16720ede9$var$selectors.rootSize(store.state);
        const rowsMeta = $31773ba16720ede9$var$selectors.rowsMeta(store.state);
        // All the floating point dimensions should be rounded to .1 decimal places to avoid subpixel rendering issues
        // https://github.com/mui/mui-x/issues/9550#issuecomment-1619020477
        // https://github.com/mui/mui-x/issues/15721
        const scrollbarSize = $31773ba16720ede9$var$measureScrollbarSize(containerNode, params.dimensions.scrollbarSize);
        const topContainerHeight = topPinnedHeight + rowsMeta.pinnedTopRowsTotalHeight;
        const bottomContainerHeight = bottomPinnedHeight + rowsMeta.pinnedBottomRowsTotalHeight;
        const contentSize = {
            width: columnsTotalWidth,
            height: (0, $145ef8aeadc094b1$export$28cd30446ab5724a)(rowsMeta.currentPageTotalHeight, 1)
        };
        let viewportOuterSize;
        let viewportInnerSize;
        let hasScrollX = false;
        let hasScrollY = false;
        if (params.autoHeight) {
            hasScrollY = false;
            hasScrollX = Math.round(columnsTotalWidth) > Math.round(rootSize.width);
            viewportOuterSize = {
                width: rootSize.width,
                height: topContainerHeight + bottomContainerHeight + contentSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width - (hasScrollY ? scrollbarSize : 0)),
                height: Math.max(0, viewportOuterSize.height - (hasScrollX ? scrollbarSize : 0))
            };
        } else {
            viewportOuterSize = {
                width: rootSize.width,
                height: rootSize.height
            };
            viewportInnerSize = {
                width: Math.max(0, viewportOuterSize.width),
                height: Math.max(0, viewportOuterSize.height - topContainerHeight - bottomContainerHeight)
            };
            const content = contentSize;
            const container = viewportInnerSize;
            const hasScrollXIfNoYScrollBar = content.width > container.width;
            const hasScrollYIfNoXScrollBar = content.height > container.height;
            if (hasScrollXIfNoYScrollBar || hasScrollYIfNoXScrollBar) {
                hasScrollY = hasScrollYIfNoXScrollBar;
                hasScrollX = content.width + (hasScrollY ? scrollbarSize : 0) > container.width;
                // We recalculate the scroll y to consider the size of the x scrollbar.
                if (hasScrollX) hasScrollY = content.height + scrollbarSize > container.height;
            }
            if (hasScrollY) viewportInnerSize.width -= scrollbarSize;
            if (hasScrollX) viewportInnerSize.height -= scrollbarSize;
        }
        if (params.disableHorizontalScroll) hasScrollX = false;
        if (params.disableVerticalScroll) hasScrollY = false;
        const rowWidth = Math.max(viewportOuterSize.width, columnsTotalWidth + (hasScrollY ? scrollbarSize : 0));
        const minimumSize = {
            width: columnsTotalWidth,
            height: topContainerHeight + contentSize.height + bottomContainerHeight
        };
        const newDimensions = {
            isReady: true,
            root: rootSize,
            viewportOuterSize: viewportOuterSize,
            viewportInnerSize: viewportInnerSize,
            contentSize: contentSize,
            minimumSize: minimumSize,
            hasScrollX: hasScrollX,
            hasScrollY: hasScrollY,
            scrollbarSize: scrollbarSize,
            rowWidth: rowWidth,
            rowHeight: rowHeight,
            columnsTotalWidth: columnsTotalWidth,
            leftPinnedWidth: leftPinnedWidth,
            rightPinnedWidth: rightPinnedWidth,
            topContainerHeight: topContainerHeight,
            bottomContainerHeight: bottomContainerHeight
        };
        const prevDimensions = store.state.dimensions;
        if ((0, $5ece57da2e97951f$export$78fdc9adc3f30400)(prevDimensions, newDimensions)) return;
        store.update({
            dimensions: newDimensions
        });
        onResize?.(newDimensions.root);
    }, [
        store,
        containerNode,
        params.dimensions.scrollbarSize,
        params.autoHeight,
        params.disableHorizontalScroll,
        params.disableVerticalScroll,
        onResize,
        rowHeight,
        columnsTotalWidth,
        leftPinnedWidth,
        rightPinnedWidth,
        topPinnedHeight,
        bottomPinnedHeight
    ]);
    const { resizeThrottleMs: resizeThrottleMs } = params;
    const updateDimensionCallback = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(updateDimensions);
    const debouncedUpdateDimensions = $acw62.useMemo(()=>resizeThrottleMs > 0 ? (0, $62ba831024416c9b$export$de363e709c412c8a)(updateDimensionCallback, resizeThrottleMs) : undefined, [
        resizeThrottleMs,
        updateDimensionCallback
    ]);
    $acw62.useEffect(()=>debouncedUpdateDimensions?.clear, [
        debouncedUpdateDimensions
    ]);
    const setRootSize = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((rootSize)=>{
        store.state.rootSize = rootSize;
        if (isFirstSizing.current || !debouncedUpdateDimensions) {
            // We want to initialize the grid dimensions as soon as possible to avoid flickering
            isFirstSizing.current = false;
            updateDimensions();
        } else debouncedUpdateDimensions();
    });
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>$31773ba16720ede9$var$observeRootNode(containerNode, store, setRootSize), [
        containerNode,
        store,
        setRootSize
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(updateDimensions, [
        updateDimensions
    ]);
    const rowsMeta = $31773ba16720ede9$var$useRowsMeta(store, params, updateDimensions);
    return {
        updateDimensions: updateDimensions,
        debouncedUpdateDimensions: debouncedUpdateDimensions,
        rowsMeta: rowsMeta
    };
}
function $31773ba16720ede9$var$useRowsMeta(store, params, updateDimensions) {
    const heightCache = store.state.rowHeights;
    const { rows: rows, getRowHeight: getRowHeightProp, getRowSpacing: getRowSpacing, getEstimatedRowHeight: getEstimatedRowHeight } = params;
    const lastMeasuredRowIndex = $acw62.useRef(-1);
    const hasRowWithAutoHeight = $acw62.useRef(false);
    const isHeightMetaValid = $acw62.useRef(false);
    const pinnedRows = params.pinnedRows;
    const rowHeight = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, $31773ba16720ede9$var$selectors.rowHeight);
    const getRowHeightEntry = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((rowId)=>{
        let entry = heightCache.get(rowId);
        if (entry === undefined) {
            entry = {
                content: store.state.dimensions.rowHeight,
                spacingTop: 0,
                spacingBottom: 0,
                detail: 0,
                autoHeight: false,
                needsFirstMeasurement: true
            };
            heightCache.set(rowId, entry);
        }
        return entry;
    });
    const { applyRowHeight: applyRowHeight } = params;
    const processHeightEntry = $acw62.useCallback((row)=>{
        // HACK: rowHeight trails behind the most up-to-date value just enough to
        // mess the initial rowsMeta hydration :/
        $31773ba16720ede9$var$eslintUseValue(rowHeight);
        const dimensions = $31773ba16720ede9$var$selectors.dimensions(store.state);
        const baseRowHeight = dimensions.rowHeight;
        const entry = getRowHeightEntry(row.id);
        if (!getRowHeightProp) {
            entry.content = baseRowHeight;
            entry.needsFirstMeasurement = false;
        } else {
            const rowHeightFromUser = getRowHeightProp(row);
            if (rowHeightFromUser === 'auto') {
                if (entry.needsFirstMeasurement) {
                    const estimatedRowHeight = getEstimatedRowHeight ? getEstimatedRowHeight(row) : baseRowHeight;
                    // If the row was not measured yet use the estimated row height
                    entry.content = estimatedRowHeight ?? baseRowHeight;
                }
                hasRowWithAutoHeight.current = true;
                entry.autoHeight = true;
            } else {
                // Default back to base rowHeight if getRowHeight returns null value.
                entry.content = rowHeightFromUser ?? dimensions.rowHeight;
                entry.needsFirstMeasurement = false;
                entry.autoHeight = false;
            }
        }
        if (getRowSpacing) {
            const spacing = getRowSpacing(row);
            entry.spacingTop = spacing.top ?? 0;
            entry.spacingBottom = spacing.bottom ?? 0;
        } else {
            entry.spacingTop = 0;
            entry.spacingBottom = 0;
        }
        applyRowHeight?.(entry, row);
        return entry;
    }, [
        store,
        getRowHeightProp,
        getRowHeightEntry,
        getEstimatedRowHeight,
        rowHeight,
        getRowSpacing,
        applyRowHeight
    ]);
    const hydrateRowsMeta = $acw62.useCallback(()=>{
        hasRowWithAutoHeight.current = false;
        const pinnedTopRowsTotalHeight = pinnedRows?.top.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0) ?? 0;
        const pinnedBottomRowsTotalHeight = pinnedRows?.bottom.reduce((acc, row)=>{
            const entry = processHeightEntry(row);
            return acc + entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
        }, 0) ?? 0;
        const positions = [];
        const currentPageTotalHeight = rows.reduce((acc, row)=>{
            positions.push(acc);
            const entry = processHeightEntry(row);
            const total = entry.content + entry.spacingTop + entry.spacingBottom + entry.detail;
            return acc + total;
        }, 0);
        if (!hasRowWithAutoHeight.current) // No row has height=auto, so all rows are already measured
        lastMeasuredRowIndex.current = Infinity;
        const didHeightsChange = pinnedTopRowsTotalHeight !== store.state.rowsMeta.pinnedTopRowsTotalHeight || pinnedBottomRowsTotalHeight !== store.state.rowsMeta.pinnedBottomRowsTotalHeight || currentPageTotalHeight !== store.state.rowsMeta.currentPageTotalHeight;
        const rowsMeta = {
            currentPageTotalHeight: currentPageTotalHeight,
            positions: positions,
            pinnedTopRowsTotalHeight: pinnedTopRowsTotalHeight,
            pinnedBottomRowsTotalHeight: pinnedBottomRowsTotalHeight
        };
        store.set('rowsMeta', rowsMeta);
        if (didHeightsChange) updateDimensions();
        isHeightMetaValid.current = true;
    }, [
        store,
        pinnedRows,
        rows,
        processHeightEntry,
        updateDimensions
    ]);
    const hydrateRowsMetaLatest = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(hydrateRowsMeta);
    const getRowHeight = (rowId)=>{
        return heightCache.get(rowId)?.content ?? $31773ba16720ede9$var$selectors.rowHeight(store.state);
    };
    const storeRowHeightMeasurement = (id, height)=>{
        const entry = getRowHeightEntry(id);
        const didChange = entry.content !== height;
        entry.needsFirstMeasurement = false;
        entry.content = height;
        isHeightMetaValid.current &&= !didChange;
    };
    const rowHasAutoHeight = (id)=>{
        return heightCache.get(id)?.autoHeight ?? false;
    };
    const getLastMeasuredRowIndex = ()=>{
        return lastMeasuredRowIndex.current;
    };
    const setLastMeasuredRowIndex = (index)=>{
        if (hasRowWithAutoHeight.current && index > lastMeasuredRowIndex.current) lastMeasuredRowIndex.current = index;
    };
    const resetRowHeights = ()=>{
        heightCache.clear();
        hydrateRowsMeta();
    };
    const resizeObserver = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)(()=>typeof ResizeObserver === 'undefined' ? undefined : new ResizeObserver((entries)=>{
            for(let i = 0; i < entries.length; i += 1){
                const entry = entries[i];
                const height = entry.borderBoxSize && entry.borderBoxSize.length > 0 ? entry.borderBoxSize[0].blockSize : entry.contentRect.height;
                const rowId = entry.target.__mui_id;
                const focusedVirtualRowId = params.focusedVirtualCell?.()?.id;
                if (focusedVirtualRowId === rowId && height === 0) // Focused virtual row has 0 height.
                // We don't want to store it to avoid scroll jumping.
                // https://github.com/mui/mui-x/issues/14726
                return;
                storeRowHeightMeasurement(rowId, height);
            }
            if (!isHeightMetaValid.current) // Avoids "ResizeObserver loop completed with undelivered notifications" error
            requestAnimationFrame(()=>{
                hydrateRowsMetaLatest();
            });
        })).current;
    const observeRowHeight = (element, rowId)=>{
        element.__mui_id = rowId;
        resizeObserver?.observe(element);
        return ()=>resizeObserver?.unobserve(element);
    };
    // The effect is used to build the rows meta data - currentPageTotalHeight and positions.
    // Because of variable row height this is needed for the virtualization
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        hydrateRowsMeta();
    }, [
        hydrateRowsMeta
    ]);
    return {
        getRowHeight: getRowHeight,
        setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        storeRowHeightMeasurement: storeRowHeightMeasurement,
        hydrateRowsMeta: hydrateRowsMeta,
        observeRowHeight: observeRowHeight,
        rowHasAutoHeight: rowHasAutoHeight,
        getRowHeightEntry: getRowHeightEntry,
        getLastMeasuredRowIndex: getLastMeasuredRowIndex,
        resetRowHeights: resetRowHeights
    };
}
function $31773ba16720ede9$var$observeRootNode(node, store, setRootSize) {
    if (!node) return undefined;
    const bounds = node.getBoundingClientRect();
    const initialSize = {
        width: (0, $145ef8aeadc094b1$export$28cd30446ab5724a)(bounds.width, 1),
        height: (0, $145ef8aeadc094b1$export$28cd30446ab5724a)(bounds.height, 1)
    };
    if (store.state.rootSize === (0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).EMPTY || !(0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).equals(initialSize, store.state.rootSize)) setRootSize(initialSize);
    if (typeof ResizeObserver === 'undefined') return undefined;
    const observer = new ResizeObserver(([entry])=>{
        if (!entry) return;
        const rootSize = {
            width: (0, $145ef8aeadc094b1$export$28cd30446ab5724a)(entry.contentRect.width, 1),
            height: (0, $145ef8aeadc094b1$export$28cd30446ab5724a)(entry.contentRect.height, 1)
        };
        if (!(0, $660aae1dda9f87cc$export$cb6da89c6af1a8ec).equals(rootSize, store.state.rootSize)) setRootSize(rootSize);
    });
    observer.observe(node);
    return ()=>{
        observer.disconnect();
    };
}
const $31773ba16720ede9$var$scrollbarSizeCache = new WeakMap();
function $31773ba16720ede9$var$measureScrollbarSize(element, scrollbarSize) {
    if (scrollbarSize !== undefined) return scrollbarSize;
    if (element === null) return 0;
    const cachedSize = $31773ba16720ede9$var$scrollbarSizeCache.get(element);
    if (cachedSize !== undefined) return cachedSize;
    const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(element);
    const scrollDiv = doc.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.overflow = 'scroll';
    scrollDiv.className = 'scrollDiv';
    element.appendChild(scrollDiv);
    const size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    element.removeChild(scrollDiv);
    $31773ba16720ede9$var$scrollbarSizeCache.set(element, size);
    return size;
}
function $31773ba16720ede9$var$eslintUseValue(_) {}



class $3c7b0ee63f2f60b9$export$390f32400eaf98c9 {
    // HACK: `any` fixes adding listeners that accept partial state.
    // Internal state to handle recursive `setState()` calls
    static create(state) {
        return new $3c7b0ee63f2f60b9$export$390f32400eaf98c9(state);
    }
    constructor(state){
        this.state = state;
        this.listeners = new Set();
        this.updateTick = 0;
    }
    subscribe = (fn)=>{
        this.listeners.add(fn);
        return ()=>{
            this.listeners.delete(fn);
        };
    };
    getSnapshot = ()=>{
        return this.state;
    };
    setState(newState) {
        this.state = newState;
        this.updateTick += 1;
        const currentTick = this.updateTick;
        const it = this.listeners.values();
        let result;
        while(result = it.next(), !result.done){
            if (currentTick !== this.updateTick) // If the tick has changed, a recursive `setState` call has been made,
            // and it has already notified all listeners.
            return;
            const listener = result.value;
            listener(newState);
        }
    }
    update(changes) {
        for(const key in changes)if (!Object.is(this.state[key], changes[key])) {
            this.setState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.state, changes));
            return;
        }
    }
    set(key, value) {
        if (!Object.is(this.state[key], value)) this.setState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, this.state, {
            [key]: value
        }));
    }
}



/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $becbf92d24ec01ad$var$selectors = {};
const $becbf92d24ec01ad$export$2de9373493591e8b = {
    initialize: $becbf92d24ec01ad$var$initializeState,
    use: $becbf92d24ec01ad$var$useColspan,
    selectors: $becbf92d24ec01ad$var$selectors
};
function $becbf92d24ec01ad$var$initializeState(_params) {
    return {
        colspanMap: new Map()
    };
}
function $becbf92d24ec01ad$var$useColspan(store, params, api) {
    const getColspan = params.colspan?.getColspan;
    const resetColSpan = ()=>{
        store.state.colspanMap = new Map();
    };
    const getCellColSpanInfo = (rowId, columnIndex)=>{
        return store.state.colspanMap.get(rowId)?.[columnIndex];
    };
    // Calculate `colSpan` for each cell in the row
    const calculateColSpan = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(getColspan ? (rowId, minFirstColumn, maxLastColumn, columns)=>{
        for(let i = minFirstColumn; i < maxLastColumn; i += 1){
            const cellProps = $becbf92d24ec01ad$var$calculateCellColSpan(store.state.colspanMap, i, rowId, minFirstColumn, maxLastColumn, columns, getColspan);
            if (cellProps.colSpan > 1) i += cellProps.colSpan - 1;
        }
    } : ()=>{});
    api.calculateColSpan = calculateColSpan;
    return {
        resetColSpan: resetColSpan,
        getCellColSpanInfo: getCellColSpanInfo,
        calculateColSpan: calculateColSpan
    };
}
function $becbf92d24ec01ad$var$calculateCellColSpan(lookup, columnIndex, rowId, minFirstColumnIndex, maxLastColumnIndex, columns, getColspan) {
    const columnsLength = columns.length;
    const column = columns[columnIndex];
    const colSpan = getColspan(rowId, column, columnIndex);
    if (!colSpan || colSpan === 1) {
        $becbf92d24ec01ad$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: 1,
                width: column.computedWidth
            }
        });
        return {
            colSpan: 1
        };
    }
    let width = column.computedWidth;
    for(let j = 1; j < colSpan; j += 1){
        const nextColumnIndex = columnIndex + j;
        // Cells should be spanned only within their column section (left-pinned, right-pinned and unpinned).
        if (nextColumnIndex >= minFirstColumnIndex && nextColumnIndex < maxLastColumnIndex) {
            const nextColumn = columns[nextColumnIndex];
            width += nextColumn.computedWidth;
            $becbf92d24ec01ad$var$setCellColSpanInfo(lookup, rowId, columnIndex + j, {
                spannedByColSpan: true,
                rightVisibleCellIndex: Math.min(columnIndex + colSpan, columnsLength - 1),
                leftVisibleCellIndex: columnIndex
            });
        }
        $becbf92d24ec01ad$var$setCellColSpanInfo(lookup, rowId, columnIndex, {
            spannedByColSpan: false,
            cellProps: {
                colSpan: colSpan,
                width: width
            }
        });
    }
    return {
        colSpan: colSpan
    };
}
function $becbf92d24ec01ad$var$setCellColSpanInfo(colspanMap, rowId, columnIndex, cellColSpanInfo) {
    let columnInfo = colspanMap.get(rowId);
    if (!columnInfo) {
        columnInfo = {};
        colspanMap.set(rowId, columnInfo);
    }
    columnInfo[columnIndex] = cellColSpanInfo;
}






var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");




const $fccc46144a12f3b4$var$userAgent = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : 'empty';
const $fccc46144a12f3b4$export$b7d78993b74f766d = $fccc46144a12f3b4$var$userAgent.includes('firefox');
const $fccc46144a12f3b4$export$c8f880a2d81914c4 = typeof window !== 'undefined' && /jsdom|HappyDOM/.test(window.navigator.userAgent);
var $fccc46144a12f3b4$export$2e2bcd8739ae039 = {
    isFirefox: $fccc46144a12f3b4$export$b7d78993b74f766d,
    isJSDOM: $fccc46144a12f3b4$export$c8f880a2d81914c4
};



var $acw62 = parcelRequire("acw62");

const $d121c8e59e43d335$var$noop = ()=>{};
const $d121c8e59e43d335$export$a3576ea6e6df583c = (condition, effect)=>{
    const didRun = $acw62.useRef(false);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (didRun.current || !condition) return $d121c8e59e43d335$var$noop;
        didRun.current = true;
        return effect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        didRun.current || condition
    ]);
};



var $acw62 = parcelRequire("acw62");
function $ed0481f6b43b34b3$export$c5623aa1c38918b6(callback) {
    const isFirstRender = $acw62.useRef(true);
    if (isFirstRender.current) {
        isFirstRender.current = false;
        callback();
    }
}






'use client';
/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $4cc7a762081bc0b0$var$clamp = (value, min, max)=>Math.max(min, Math.min(max, value));
const $4cc7a762081bc0b0$var$MINIMUM_COLUMN_WIDTH = 50;
const $4cc7a762081bc0b0$var$EMPTY_SCROLL_POSITION = {
    top: 0,
    left: 0
};
const $4cc7a762081bc0b0$var$EMPTY_DETAIL_PANELS = Object.freeze(new Map());
const $4cc7a762081bc0b0$export$27eb37bbcd78f450 = {
    firstRowIndex: 0,
    lastRowIndex: 0,
    firstColumnIndex: 0,
    lastColumnIndex: 0
};
const $4cc7a762081bc0b0$var$selectors = {
    renderContext: (0, $76700507203bf92b$export$595d22ed68ca2841)((state)=>state.virtualization.renderContext),
    enabledForRows: (0, $76700507203bf92b$export$595d22ed68ca2841)((state)=>state.virtualization.enabledForRows),
    enabledForColumns: (0, $76700507203bf92b$export$595d22ed68ca2841)((state)=>state.virtualization.enabledForColumns)
};
const $4cc7a762081bc0b0$export$7d6c73b1cdfb632f = {
    initialize: $4cc7a762081bc0b0$var$initializeState,
    use: $4cc7a762081bc0b0$var$useVirtualization,
    selectors: $4cc7a762081bc0b0$var$selectors
};
function $4cc7a762081bc0b0$var$initializeState(params) {
    const state = {
        virtualization: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            enabled: !$fccc46144a12f3b4$export$c8f880a2d81914c4,
            enabledForRows: !$fccc46144a12f3b4$export$c8f880a2d81914c4,
            enabledForColumns: !$fccc46144a12f3b4$export$c8f880a2d81914c4,
            renderContext: $4cc7a762081bc0b0$export$27eb37bbcd78f450
        }, params.initialState?.virtualization),
        // FIXME: refactor once the state shape is settled
        getters: null
    };
    return state;
}
/** APIs to override for colspan/rowspan */ function $4cc7a762081bc0b0$var$useVirtualization(store, params, api) {
    const { refs: refs, dimensions: { rowHeight: rowHeight, columnsTotalWidth: columnsTotalWidth }, virtualization: { isRtl: isRtl = false, rowBufferPx: rowBufferPx = 150, columnBufferPx: columnBufferPx = 150 }, colspan: colspan, initialState: initialState, rows: rows, range: range, columns: columns, pinnedRows: pinnedRows = (0, $660aae1dda9f87cc$export$52f1af0f200d37e4).EMPTY, pinnedColumns: pinnedColumns = (0, $660aae1dda9f87cc$export$77c7ceff57ca1d7).EMPTY, minimalContentHeight: minimalContentHeight, autoHeight: autoHeight, onWheel: onWheel, onTouchMove: onTouchMove, onRenderContextChange: onRenderContextChange, onScrollChange: onScrollChange, scrollReset: scrollReset, renderRow: renderRow, renderInfiniteLoadingTrigger: renderInfiniteLoadingTrigger } = params;
    const needsHorizontalScrollbar = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.needsHorizontalScrollbar);
    const hasBottomPinnedRows = pinnedRows.bottom.length > 0;
    const [panels, setPanels] = $acw62.useState($4cc7a762081bc0b0$var$EMPTY_DETAIL_PANELS);
    const [, setRefTick] = $acw62.useState(0);
    const isRenderContextReady = $acw62.useRef(false);
    const renderContext = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, $4cc7a762081bc0b0$var$selectors.renderContext);
    const enabledForRows = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, $4cc7a762081bc0b0$var$selectors.enabledForRows);
    const enabledForColumns = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, $4cc7a762081bc0b0$var$selectors.enabledForColumns);
    const rowsMeta = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.rowsMeta);
    const contentHeight = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.contentHeight);
    /*
   * Scroll context logic
   * ====================
   * We only render the cells contained in the `renderContext`. However, when the user starts scrolling the grid
   * in a direction, we want to render as many cells as possible in that direction, as to avoid presenting white
   * areas if the user scrolls too fast/far and the viewport ends up in a region we haven't rendered yet. To render
   * more cells, we store some offsets to add to the viewport in `scrollCache.buffer`. Those offsets make the render
   * context wider in the direction the user is going, but also makes the buffer around the viewport `0` for the
   * dimension (horizontal or vertical) in which the user is not scrolling. So if the normal viewport is 8 columns
   * wide, with a 1 column buffer (10 columns total), then we want it to be exactly 8 columns wide during vertical
   * scroll.
   * However, we don't want the rows in the old context to re-render from e.g. 10 columns to 8 columns, because that's
   * work that's not necessary. Thus we store the context at the start of the scroll in `frozenContext`, and the rows
   * that are part of this old context will keep their same render context as to avoid re-rendering.
   */ const scrollPosition = $acw62.useRef(initialState?.scroll ?? $4cc7a762081bc0b0$var$EMPTY_SCROLL_POSITION);
    const ignoreNextScrollEvent = $acw62.useRef(false);
    const previousContextScrollPosition = $acw62.useRef($4cc7a762081bc0b0$var$EMPTY_SCROLL_POSITION);
    const previousRowContext = $acw62.useRef($4cc7a762081bc0b0$export$27eb37bbcd78f450);
    const scrollTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const frozenContext = $acw62.useRef(undefined);
    const scrollCache = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)(()=>$4cc7a762081bc0b0$var$createScrollCache(isRtl, rowBufferPx, columnBufferPx, rowHeight * 15, $4cc7a762081bc0b0$var$MINIMUM_COLUMN_WIDTH * 6)).current;
    const updateRenderContext = $acw62.useCallback((nextRenderContext)=>{
        if (!$4cc7a762081bc0b0$export$6eb241d16b36f3b8(nextRenderContext, store.state.virtualization.renderContext)) store.set('virtualization', (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, store.state.virtualization, {
            renderContext: nextRenderContext
        }));
        // The lazy-loading hook is listening to `renderedRowsIntervalChange`,
        // but only does something if we already have a render context, because
        // otherwise we would call an update directly on mount
        const isReady = (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.dimensions(store.state).isReady;
        const didRowsIntervalChange = nextRenderContext.firstRowIndex !== previousRowContext.current.firstRowIndex || nextRenderContext.lastRowIndex !== previousRowContext.current.lastRowIndex;
        if (isReady && didRowsIntervalChange) {
            previousRowContext.current = nextRenderContext;
            onRenderContextChange?.(nextRenderContext);
        }
        previousContextScrollPosition.current = scrollPosition.current;
    }, [
        store,
        onRenderContextChange
    ]);
    const triggerUpdateRenderContext = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const scroller = refs.scroller.current;
        if (!scroller) return undefined;
        const dimensions = (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.dimensions(store.state);
        const maxScrollTop = Math.ceil(dimensions.contentSize.height - dimensions.viewportInnerSize.height);
        const maxScrollLeft = Math.ceil(dimensions.contentSize.width - dimensions.viewportInnerSize.width);
        // Clamp the scroll position to the viewport to avoid re-calculating the render context for scroll bounce
        const newScroll = {
            top: $4cc7a762081bc0b0$var$clamp(scroller.scrollTop, 0, maxScrollTop),
            left: isRtl ? $4cc7a762081bc0b0$var$clamp(scroller.scrollLeft, -maxScrollLeft, 0) : $4cc7a762081bc0b0$var$clamp(scroller.scrollLeft, 0, maxScrollLeft)
        };
        const dx = newScroll.left - scrollPosition.current.left;
        const dy = newScroll.top - scrollPosition.current.top;
        const isScrolling = dx !== 0 || dy !== 0;
        scrollPosition.current = newScroll;
        const direction = isScrolling ? (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).forDelta(dx, dy) : (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).NONE;
        // Since previous render, we have scrolled...
        const rowScroll = Math.abs(scrollPosition.current.top - previousContextScrollPosition.current.top);
        const columnScroll = Math.abs(scrollPosition.current.left - previousContextScrollPosition.current.left);
        // PERF: use the computed minimum column width instead of a static one
        const didCrossThreshold = rowScroll >= rowHeight || columnScroll >= $4cc7a762081bc0b0$var$MINIMUM_COLUMN_WIDTH;
        const didChangeDirection = scrollCache.direction !== direction;
        const shouldUpdate = didCrossThreshold || didChangeDirection;
        if (!shouldUpdate) return renderContext;
        // Render a new context
        if (didChangeDirection) switch(direction){
            case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).NONE:
            case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).LEFT:
            case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).RIGHT:
                frozenContext.current = undefined;
                break;
            default:
                frozenContext.current = renderContext;
                break;
        }
        scrollCache.direction = direction;
        scrollCache.buffer = $4cc7a762081bc0b0$var$bufferForDirection(isRtl, direction, rowBufferPx, columnBufferPx, rowHeight * 15, $4cc7a762081bc0b0$var$MINIMUM_COLUMN_WIDTH * 6);
        const inputs = $4cc7a762081bc0b0$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns);
        const nextRenderContext = $4cc7a762081bc0b0$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        if (!$4cc7a762081bc0b0$export$6eb241d16b36f3b8(nextRenderContext, renderContext)) {
            // Prevents batching render context changes
            $1u0KT.flushSync(()=>{
                updateRenderContext(nextRenderContext);
            });
            scrollTimeout.start(1000, triggerUpdateRenderContext);
        }
        return nextRenderContext;
    });
    const forceUpdateRenderContext = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        // skip update if dimensions are not ready and virtualization is enabled
        if (!(0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.dimensions(store.state).isReady && (enabledForRows || enabledForColumns)) return;
        const inputs = $4cc7a762081bc0b0$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns);
        const nextRenderContext = $4cc7a762081bc0b0$var$computeRenderContext(inputs, scrollPosition.current, scrollCache);
        // Reset the frozen context when the render context changes, see the illustration in https://github.com/mui/mui-x/pull/12353
        frozenContext.current = undefined;
        updateRenderContext(nextRenderContext);
    });
    const handleScroll = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        if (ignoreNextScrollEvent.current) {
            ignoreNextScrollEvent.current = false;
            return;
        }
        const nextRenderContext = triggerUpdateRenderContext();
        if (nextRenderContext) onScrollChange?.(scrollPosition.current, nextRenderContext);
    });
    const getOffsetTop = ()=>{
        return rowsMeta.positions[renderContext.firstRowIndex] ?? 0;
    };
    /**
   * HACK: unstable_rowTree fixes the issue described below, but does it by tightly coupling this
   * section of code to the DataGrid's rowTree model. The `unstable_rowTree` param is a temporary
   * solution to decouple the code.
   */ const getRows = (rowParams = {}, unstable_rowTree)=>{
        if (!rowParams.rows && !range) return [];
        let baseRenderContext = renderContext;
        if (rowParams.renderContext) {
            baseRenderContext = rowParams.renderContext;
            baseRenderContext.firstColumnIndex = renderContext.firstColumnIndex;
            baseRenderContext.lastColumnIndex = renderContext.lastColumnIndex;
        }
        const isLastSection = !hasBottomPinnedRows && rowParams.position === undefined || hasBottomPinnedRows && rowParams.position === 'bottom';
        const isPinnedSection = rowParams.position !== undefined;
        let rowIndexOffset;
        switch(rowParams.position){
            case 'top':
                rowIndexOffset = 0;
                break;
            case 'bottom':
                rowIndexOffset = pinnedRows.top.length + rows.length;
                break;
            case undefined:
            default:
                rowIndexOffset = pinnedRows.top.length;
                break;
        }
        const rowModels = rowParams.rows ?? rows;
        const firstRowToRender = baseRenderContext.firstRowIndex;
        const lastRowToRender = Math.min(baseRenderContext.lastRowIndex, rowModels.length);
        const rowIndexes = rowParams.rows ? $4cc7a762081bc0b0$var$createRange(0, rowParams.rows.length) : $4cc7a762081bc0b0$var$createRange(firstRowToRender, lastRowToRender);
        let virtualRowIndex = -1;
        const focusedVirtualCell = params.focusedVirtualCell?.();
        if (!isPinnedSection && focusedVirtualCell) {
            if (focusedVirtualCell.rowIndex < firstRowToRender) {
                rowIndexes.unshift(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
            if (focusedVirtualCell.rowIndex > lastRowToRender) {
                rowIndexes.push(focusedVirtualCell.rowIndex);
                virtualRowIndex = focusedVirtualCell.rowIndex;
            }
        }
        const rowElements = [];
        const columnPositions = (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.columnPositions(store.state, columns);
        rowIndexes.forEach((rowIndexInPage)=>{
            const { id: id, model: model } = rowModels[rowIndexInPage];
            // In certain cases, the state might already be updated and `params.rows` (which sets `rowModels`)
            // contains stale data.
            // In that case, skip any further row processing.
            // See:
            // - https://github.com/mui/mui-x/issues/16638
            // - https://github.com/mui/mui-x/issues/17022
            if (unstable_rowTree && !unstable_rowTree[id]) return;
            const rowIndex = (range?.firstRowIndex || 0) + rowIndexOffset + rowIndexInPage;
            // NOTE: This is an expensive feature, the colSpan code could be optimized.
            if (colspan?.enabled) {
                const minFirstColumn = pinnedColumns.left.length;
                const maxLastColumn = columns.length - pinnedColumns.right.length;
                api.calculateColSpan(id, minFirstColumn, maxLastColumn, columns);
                if (pinnedColumns.left.length > 0) api.calculateColSpan(id, 0, pinnedColumns.left.length, columns);
                if (pinnedColumns.right.length > 0) api.calculateColSpan(id, columns.length - pinnedColumns.right.length, columns.length, columns);
            }
            const baseRowHeight = !api.rowsMeta.rowHasAutoHeight(id) ? api.rowsMeta.getRowHeight(id) : 'auto';
            let isFirstVisible = false;
            if (rowParams.position === undefined) isFirstVisible = rowIndexInPage === 0;
            let isLastVisible = false;
            const isLastVisibleInSection = rowIndexInPage === rowModels.length - 1;
            if (isLastSection) {
                if (!isPinnedSection) {
                    const lastIndex = rows.length - 1;
                    const isLastVisibleRowIndex = rowIndexInPage === lastIndex;
                    if (isLastVisibleRowIndex) isLastVisible = true;
                } else isLastVisible = isLastVisibleInSection;
            }
            let currentRenderContext = baseRenderContext;
            if (frozenContext.current && rowIndexInPage >= frozenContext.current.firstRowIndex && rowIndexInPage < frozenContext.current.lastRowIndex) currentRenderContext = frozenContext.current;
            const isVirtualFocusRow = rowIndexInPage === virtualRowIndex;
            const isVirtualFocusColumn = focusedVirtualCell?.rowIndex === rowIndex;
            const offsetLeft = $4cc7a762081bc0b0$export$fe1f1566870c3cbc(columnPositions, currentRenderContext, pinnedColumns.left.length);
            const showBottomBorder = isLastVisibleInSection && rowParams.position === 'top';
            const firstColumnIndex = currentRenderContext.firstColumnIndex;
            const lastColumnIndex = currentRenderContext.lastColumnIndex;
            rowElements.push(renderRow({
                id: id,
                model: model,
                rowIndex: rowIndex,
                offsetLeft: offsetLeft,
                columnsTotalWidth: columnsTotalWidth,
                baseRowHeight: baseRowHeight,
                firstColumnIndex: firstColumnIndex,
                lastColumnIndex: lastColumnIndex,
                focusedColumnIndex: isVirtualFocusColumn ? focusedVirtualCell.columnIndex : undefined,
                isFirstVisible: isFirstVisible,
                isLastVisible: isLastVisible,
                isVirtualFocusRow: isVirtualFocusRow,
                showBottomBorder: showBottomBorder
            }));
            if (isVirtualFocusRow) return;
            const panel = panels.get(id);
            if (panel) rowElements.push(panel);
            if (rowParams.position === undefined && isLastVisibleInSection) rowElements.push(renderInfiniteLoadingTrigger(id));
        });
        return rowElements;
    };
    const scrollerStyle = $acw62.useMemo(()=>({
            overflowX: !needsHorizontalScrollbar ? 'hidden' : undefined,
            overflowY: autoHeight ? 'hidden' : undefined
        }), [
        needsHorizontalScrollbar,
        autoHeight
    ]);
    const contentSize = $acw62.useMemo(()=>{
        const size = {
            width: needsHorizontalScrollbar ? columnsTotalWidth : 'auto',
            flexBasis: contentHeight,
            flexShrink: 0
        };
        if (size.flexBasis === 0) size.flexBasis = minimalContentHeight; // Give room to show the overlay when there no rows.
        return size;
    }, [
        columnsTotalWidth,
        contentHeight,
        needsHorizontalScrollbar,
        minimalContentHeight
    ]);
    const scrollRestoreCallback = $acw62.useRef(null);
    const contentNodeRef = $acw62.useCallback((node)=>{
        if (!node) return;
        scrollRestoreCallback.current?.(columnsTotalWidth, contentHeight);
    }, [
        columnsTotalWidth,
        contentHeight
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (!isRenderContextReady.current) return;
        forceUpdateRenderContext();
    }, [
        enabledForColumns,
        enabledForRows,
        forceUpdateRenderContext
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (refs.scroller.current) refs.scroller.current.scrollLeft = 0;
    }, [
        refs.scroller,
        scrollReset
    ]);
    (0, $d121c8e59e43d335$export$a3576ea6e6df583c)(renderContext !== $4cc7a762081bc0b0$export$27eb37bbcd78f450, ()=>{
        onScrollChange?.(scrollPosition.current, renderContext);
        isRenderContextReady.current = true;
        if (initialState?.scroll && refs.scroller.current) {
            const scroller = refs.scroller.current;
            const { top: top, left: left } = initialState.scroll;
            const isScrollRestored = {
                top: !(top > 0),
                left: !(left > 0)
            };
            if (!isScrollRestored.left && columnsTotalWidth) {
                scroller.scrollLeft = left;
                isScrollRestored.left = true;
                ignoreNextScrollEvent.current = true;
            }
            // To restore the vertical scroll, we need to wait until the rows are available in the DOM (otherwise
            // there's nowhere to scroll). We still set the scrollTop to the initial value at this point in case
            // there already are rows rendered in the DOM, but we only confirm `isScrollRestored.top = true` in the
            // asynchronous callback below.
            if (!isScrollRestored.top && contentHeight) {
                scroller.scrollTop = top;
                ignoreNextScrollEvent.current = true;
            }
            if (!isScrollRestored.top || !isScrollRestored.left) scrollRestoreCallback.current = (columnsTotalWidthCurrent, contentHeightCurrent)=>{
                if (!isScrollRestored.left && columnsTotalWidthCurrent) {
                    scroller.scrollLeft = left;
                    isScrollRestored.left = true;
                    ignoreNextScrollEvent.current = true;
                }
                if (!isScrollRestored.top && contentHeightCurrent) {
                    scroller.scrollTop = top;
                    isScrollRestored.top = true;
                    ignoreNextScrollEvent.current = true;
                }
                if (isScrollRestored.left && isScrollRestored.top) scrollRestoreCallback.current = null;
            };
        }
    });
    (0, $e5fd677936fa6c9d$export$c6cc86f9120e9aa4)(store, (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.dimensions, forceUpdateRenderContext);
    const refSetter = (name)=>(node)=>{
            if (node && refs[name].current !== node) {
                refs[name].current = node;
                setRefTick((tick)=>tick + 1);
            }
        };
    const getters = {
        setPanels: setPanels,
        getOffsetTop: getOffsetTop,
        getRows: getRows,
        getContainerProps: ()=>({
                ref: refSetter('container')
            }),
        getScrollerProps: ()=>({
                ref: refSetter('scroller'),
                onScroll: handleScroll,
                onWheel: onWheel,
                onTouchMove: onTouchMove,
                style: scrollerStyle,
                role: 'presentation',
                // `tabIndex` shouldn't be used along role=presentation, but it fixes a Firefox bug
                // https://github.com/mui/mui-x/pull/13891#discussion_r1683416024
                tabIndex: $fccc46144a12f3b4$export$b7d78993b74f766d ? -1 : undefined
            }),
        getContentProps: ()=>({
                ref: contentNodeRef,
                style: contentSize,
                role: 'presentation'
            }),
        getScrollbarVerticalProps: ()=>({
                ref: refSetter('scrollbarVertical'),
                scrollPosition: scrollPosition
            }),
        getScrollbarHorizontalProps: ()=>({
                ref: refSetter('scrollbarHorizontal'),
                scrollPosition: scrollPosition
            }),
        getScrollAreaProps: ()=>({
                scrollPosition: scrollPosition
            })
    };
    (0, $ed0481f6b43b34b3$export$c5623aa1c38918b6)(()=>{
        store.state = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, store.state, {
            getters: getters
        });
    });
    $acw62.useEffect(()=>{
        store.update({
            getters: getters
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, Object.values(getters));
    /* Placeholder API functions for colspan & rowspan to re-implement */ const getCellColSpanInfo = ()=>{
        throw new Error('Unimplemented: colspan feature is required');
    };
    const calculateColSpan = ()=>{
        throw new Error('Unimplemented: colspan feature is required');
    };
    const getHiddenCellsOrigin = ()=>{
        throw new Error('Unimplemented: rowspan feature is required');
    };
    return {
        getters: getters,
        useVirtualization: ()=>(0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, (state)=>state),
        setPanels: setPanels,
        forceUpdateRenderContext: forceUpdateRenderContext,
        getCellColSpanInfo: getCellColSpanInfo,
        calculateColSpan: calculateColSpan,
        getHiddenCellsOrigin: getHiddenCellsOrigin
    };
}
function $4cc7a762081bc0b0$var$inputsSelector(store, params, api, enabledForRows, enabledForColumns) {
    const dimensions = (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.dimensions(store.state);
    const rows = params.rows;
    const range = params.range;
    const columns = params.columns;
    const hiddenCellsOriginMap = api.getHiddenCellsOrigin();
    const lastRowId = params.rows.at(-1)?.id;
    const lastColumn = columns.at(-1);
    return {
        api: api,
        enabledForRows: enabledForRows,
        enabledForColumns: enabledForColumns,
        autoHeight: params.autoHeight,
        rowBufferPx: params.virtualization.rowBufferPx,
        columnBufferPx: params.virtualization.columnBufferPx,
        leftPinnedWidth: dimensions.leftPinnedWidth,
        columnsTotalWidth: dimensions.columnsTotalWidth,
        viewportInnerWidth: dimensions.viewportInnerSize.width,
        viewportInnerHeight: dimensions.viewportInnerSize.height,
        lastRowHeight: lastRowId !== undefined ? api.rowsMeta.getRowHeight(lastRowId) : 0,
        lastColumnWidth: lastColumn?.computedWidth ?? 0,
        rowsMeta: (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.rowsMeta(store.state),
        columnPositions: (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.columnPositions(store.state, params.columns),
        rows: rows,
        range: range,
        pinnedColumns: params.pinnedColumns,
        columns: columns,
        hiddenCellsOriginMap: hiddenCellsOriginMap,
        virtualizeColumnsWithAutoRowHeight: params.virtualizeColumnsWithAutoRowHeight
    };
}
function $4cc7a762081bc0b0$var$computeRenderContext(inputs, scrollPosition, scrollCache) {
    const renderContext = {
        firstRowIndex: 0,
        lastRowIndex: inputs.rows.length,
        firstColumnIndex: 0,
        lastColumnIndex: inputs.columns.length
    };
    const { top: top, left: left } = scrollPosition;
    const realLeft = Math.abs(left) + inputs.leftPinnedWidth;
    if (inputs.enabledForRows) {
        // Clamp the value because the search may return an index out of bounds.
        // In the last index, this is not needed because Array.slice doesn't include it.
        let firstRowIndex = Math.min($4cc7a762081bc0b0$var$getNearestIndexToRender(inputs, top, {
            atStart: true,
            lastPosition: inputs.rowsMeta.positions[inputs.rowsMeta.positions.length - 1] + inputs.lastRowHeight
        }), inputs.rowsMeta.positions.length - 1);
        // If any of the cells in the `firstRowIndex` is hidden due to an extended row span,
        // Make sure the row from where the rowSpan is originated is visible.
        const rowSpanHiddenCellOrigin = inputs.hiddenCellsOriginMap[firstRowIndex];
        if (rowSpanHiddenCellOrigin) {
            const minSpannedRowIndex = Math.min(...Object.values(rowSpanHiddenCellOrigin));
            firstRowIndex = Math.min(firstRowIndex, minSpannedRowIndex);
        }
        const lastRowIndex = inputs.autoHeight ? firstRowIndex + inputs.rows.length : $4cc7a762081bc0b0$var$getNearestIndexToRender(inputs, top + inputs.viewportInnerHeight);
        renderContext.firstRowIndex = firstRowIndex;
        renderContext.lastRowIndex = lastRowIndex;
    }
    // XXX
    // if (inputs.listView) {
    //   return {
    //     ...renderContext,
    //     lastColumnIndex: 1,
    //   };
    // }
    if (inputs.enabledForColumns) {
        let firstColumnIndex = 0;
        let lastColumnIndex = inputs.columnPositions.length;
        let hasRowWithAutoHeight = false;
        const [firstRowToRender, lastRowToRender] = $4cc7a762081bc0b0$var$getIndexesToRender({
            firstIndex: renderContext.firstRowIndex,
            lastIndex: renderContext.lastRowIndex,
            minFirstIndex: 0,
            maxLastIndex: inputs.rows.length,
            bufferBefore: scrollCache.buffer.rowBefore,
            bufferAfter: scrollCache.buffer.rowAfter,
            positions: inputs.rowsMeta.positions,
            lastSize: inputs.lastRowHeight
        });
        if (!inputs.virtualizeColumnsWithAutoRowHeight) for(let i = firstRowToRender; i < lastRowToRender && !hasRowWithAutoHeight; i += 1){
            const row = inputs.rows[i];
            hasRowWithAutoHeight = inputs.api.rowsMeta.rowHasAutoHeight(row.id);
        }
        if (!hasRowWithAutoHeight || inputs.virtualizeColumnsWithAutoRowHeight) {
            firstColumnIndex = $4cc7a762081bc0b0$var$binarySearch(realLeft, inputs.columnPositions, {
                atStart: true,
                lastPosition: inputs.columnsTotalWidth
            });
            lastColumnIndex = $4cc7a762081bc0b0$var$binarySearch(realLeft + inputs.viewportInnerWidth, inputs.columnPositions);
        }
        renderContext.firstColumnIndex = firstColumnIndex;
        renderContext.lastColumnIndex = lastColumnIndex;
    }
    const actualRenderContext = $4cc7a762081bc0b0$var$deriveRenderContext(inputs, renderContext, scrollCache);
    return actualRenderContext;
}
function $4cc7a762081bc0b0$var$getNearestIndexToRender(inputs, offset, options) {
    const lastMeasuredIndexRelativeToAllRows = inputs.api.rowsMeta.getLastMeasuredRowIndex();
    let allRowsMeasured = lastMeasuredIndexRelativeToAllRows === Infinity;
    if (inputs.range?.lastRowIndex && !allRowsMeasured) // Check if all rows in this page are already measured
    allRowsMeasured = lastMeasuredIndexRelativeToAllRows >= inputs.range.lastRowIndex;
    const lastMeasuredIndexRelativeToCurrentPage = $4cc7a762081bc0b0$var$clamp(lastMeasuredIndexRelativeToAllRows - (inputs.range?.firstRowIndex || 0), 0, inputs.rowsMeta.positions.length);
    if (allRowsMeasured || inputs.rowsMeta.positions[lastMeasuredIndexRelativeToCurrentPage] >= offset) // If all rows were measured (when no row has "auto" as height) or all rows before the offset
    // were measured, then use a binary search because it's faster.
    return $4cc7a762081bc0b0$var$binarySearch(offset, inputs.rowsMeta.positions, options);
    // Otherwise, use an exponential search.
    // If rows have "auto" as height, their positions will be based on estimated heights.
    // In this case, we can skip several steps until we find a position higher than the offset.
    // Inspired by https://github.com/bvaughn/react-virtualized/blob/master/source/Grid/utils/CellSizeAndPositionManager.js
    return $4cc7a762081bc0b0$var$exponentialSearch(offset, inputs.rowsMeta.positions, lastMeasuredIndexRelativeToCurrentPage, options);
}
/**
 * Accepts as input a raw render context (the area visible in the viewport) and adds
 * computes the actual render context based on pinned elements, buffer dimensions and
 * spanning.
 */ function $4cc7a762081bc0b0$var$deriveRenderContext(inputs, nextRenderContext, scrollCache) {
    const [firstRowToRender, lastRowToRender] = $4cc7a762081bc0b0$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstRowIndex,
        lastIndex: nextRenderContext.lastRowIndex,
        minFirstIndex: 0,
        maxLastIndex: inputs.rows.length,
        bufferBefore: scrollCache.buffer.rowBefore,
        bufferAfter: scrollCache.buffer.rowAfter,
        positions: inputs.rowsMeta.positions,
        lastSize: inputs.lastRowHeight
    });
    const [initialFirstColumnToRender, lastColumnToRender] = $4cc7a762081bc0b0$var$getIndexesToRender({
        firstIndex: nextRenderContext.firstColumnIndex,
        lastIndex: nextRenderContext.lastColumnIndex,
        minFirstIndex: inputs.pinnedColumns?.left.length ?? 0,
        maxLastIndex: inputs.columns.length - (inputs.pinnedColumns?.right.length ?? 0),
        bufferBefore: scrollCache.buffer.columnBefore,
        bufferAfter: scrollCache.buffer.columnAfter,
        positions: inputs.columnPositions,
        lastSize: inputs.lastColumnWidth
    });
    const firstColumnToRender = $4cc7a762081bc0b0$var$getFirstNonSpannedColumnToRender({
        api: inputs.api,
        firstColumnToRender: initialFirstColumnToRender,
        firstRowToRender: firstRowToRender,
        lastRowToRender: lastRowToRender,
        visibleRows: inputs.rows
    });
    return {
        firstRowIndex: firstRowToRender,
        lastRowIndex: lastRowToRender,
        firstColumnIndex: firstColumnToRender,
        lastColumnIndex: lastColumnToRender
    };
}
/**
 * Use binary search to avoid looping through all possible positions.
 * The `options.atStart` provides the possibility to match for the first element that
 * intersects the screen, even if said element's start position is before `offset`. In
 * other words, we search for `offset + width`.
 */ function $4cc7a762081bc0b0$var$binarySearch(offset, positions, options, sliceStart = 0, sliceEnd = positions.length) {
    if (positions.length <= 0) return -1;
    if (sliceStart >= sliceEnd) return sliceStart;
    const pivot = sliceStart + Math.floor((sliceEnd - sliceStart) / 2);
    const position = positions[pivot];
    let isBefore;
    if (options?.atStart) {
        const width = (pivot === positions.length - 1 ? options.lastPosition : positions[pivot + 1]) - position;
        isBefore = offset - width < position;
    } else isBefore = offset <= position;
    return isBefore ? $4cc7a762081bc0b0$var$binarySearch(offset, positions, options, sliceStart, pivot) : $4cc7a762081bc0b0$var$binarySearch(offset, positions, options, pivot + 1, sliceEnd);
}
function $4cc7a762081bc0b0$var$exponentialSearch(offset, positions, index, options) {
    let interval = 1;
    while(index < positions.length && Math.abs(positions[index]) < offset){
        index += interval;
        interval *= 2;
    }
    return $4cc7a762081bc0b0$var$binarySearch(offset, positions, options, Math.floor(index / 2), Math.min(index, positions.length));
}
function $4cc7a762081bc0b0$var$getIndexesToRender({ firstIndex: firstIndex, lastIndex: lastIndex, bufferBefore: bufferBefore, bufferAfter: bufferAfter, minFirstIndex: minFirstIndex, maxLastIndex: maxLastIndex, positions: positions, lastSize: lastSize }) {
    const firstPosition = positions[firstIndex] - bufferBefore;
    const lastPosition = positions[lastIndex] + bufferAfter;
    const firstIndexPadded = $4cc7a762081bc0b0$var$binarySearch(firstPosition, positions, {
        atStart: true,
        lastPosition: positions[positions.length - 1] + lastSize
    });
    const lastIndexPadded = $4cc7a762081bc0b0$var$binarySearch(lastPosition, positions);
    return [
        $4cc7a762081bc0b0$var$clamp(firstIndexPadded, minFirstIndex, maxLastIndex),
        $4cc7a762081bc0b0$var$clamp(lastIndexPadded, minFirstIndex, maxLastIndex)
    ];
}
function $4cc7a762081bc0b0$export$6eb241d16b36f3b8(context1, context2) {
    if (context1 === context2) return true;
    return context1.firstRowIndex === context2.firstRowIndex && context1.lastRowIndex === context2.lastRowIndex && context1.firstColumnIndex === context2.firstColumnIndex && context1.lastColumnIndex === context2.lastColumnIndex;
}
function $4cc7a762081bc0b0$export$fe1f1566870c3cbc(columnPositions, renderContext, pinnedLeftLength) {
    const left = (columnPositions[renderContext.firstColumnIndex] ?? 0) - (columnPositions[pinnedLeftLength] ?? 0);
    return Math.abs(left);
}
function $4cc7a762081bc0b0$var$bufferForDirection(isRtl, direction, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    if (isRtl) switch(direction){
        case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).LEFT:
            direction = (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).RIGHT;
            break;
        case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).RIGHT:
            direction = (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).LEFT;
            break;
        default:
    }
    switch(direction){
        case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).NONE:
            return {
                rowAfter: rowBufferPx,
                rowBefore: rowBufferPx,
                columnAfter: columnBufferPx,
                columnBefore: columnBufferPx
            };
        case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).LEFT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: horizontalBuffer
            };
        case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).RIGHT:
            return {
                rowAfter: 0,
                rowBefore: 0,
                columnAfter: horizontalBuffer,
                columnBefore: 0
            };
        case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).UP:
            return {
                rowAfter: 0,
                rowBefore: verticalBuffer,
                columnAfter: 0,
                columnBefore: 0
            };
        case (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).DOWN:
            return {
                rowAfter: verticalBuffer,
                rowBefore: 0,
                columnAfter: 0,
                columnBefore: 0
            };
        default:
            // eslint unable to figure out enum exhaustiveness
            throw new Error('unreachable');
    }
}
function $4cc7a762081bc0b0$var$createScrollCache(isRtl, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer) {
    return {
        direction: (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).NONE,
        buffer: $4cc7a762081bc0b0$var$bufferForDirection(isRtl, (0, $660aae1dda9f87cc$export$ef1760368e0f70e4).NONE, rowBufferPx, columnBufferPx, verticalBuffer, horizontalBuffer)
    };
}
function $4cc7a762081bc0b0$var$createRange(from, to) {
    return Array.from({
        length: to - from
    }).map((_, i)=>from + i);
}
function $4cc7a762081bc0b0$var$getFirstNonSpannedColumnToRender({ api: api, firstColumnToRender: firstColumnToRender, firstRowToRender: firstRowToRender, lastRowToRender: lastRowToRender, visibleRows: visibleRows }) {
    let firstNonSpannedColumnToRender = firstColumnToRender;
    let foundStableColumn = false;
    // Keep checking columns until we find one that's not spanned in any visible row
    while(!foundStableColumn && firstNonSpannedColumnToRender >= 0){
        foundStableColumn = true;
        for(let i = firstRowToRender; i < lastRowToRender; i += 1){
            const row = visibleRows[i];
            if (row) {
                const rowId = visibleRows[i].id;
                const cellColSpanInfo = api.getCellColSpanInfo(rowId, firstNonSpannedColumnToRender);
                if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan && cellColSpanInfo.leftVisibleCellIndex < firstNonSpannedColumnToRender) {
                    firstNonSpannedColumnToRender = cellColSpanInfo.leftVisibleCellIndex;
                    foundStableColumn = false;
                    break; // Check the new column index against the visible rows, because it might be spanned
                }
            }
        }
    }
    return firstNonSpannedColumnToRender;
}
function $4cc7a762081bc0b0$export$28cd30446ab5724a(value, decimals) {
    return Math.round(value * 10 ** decimals) / 10 ** decimals;
}


/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $c723315f364baa66$var$selectors = {};
const $c723315f364baa66$export$16e4d70cc375e707 = {
    initialize: $c723315f364baa66$var$initializeState,
    use: $c723315f364baa66$var$useKeyboard,
    selectors: $c723315f364baa66$var$selectors
};
function $c723315f364baa66$var$initializeState(_params) {
    return {};
}
function $c723315f364baa66$var$useKeyboard(store, params, _api) {
    const getViewportPageSize = ()=>{
        const dimensions = (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.dimensions(store.state);
        if (!dimensions.isReady) return 0;
        // TODO: Use a combination of scrollTop, dimensions.viewportInnerSize.height and rowsMeta.possitions
        // to find out the maximum number of rows that can fit in the visible part of the grid
        if (params.getRowHeight) {
            const renderContext = (0, $4cc7a762081bc0b0$export$7d6c73b1cdfb632f).selectors.renderContext(store.state);
            const viewportPageSize = renderContext.lastRowIndex - renderContext.firstRowIndex;
            return Math.min(viewportPageSize - 1, params.rows.length);
        }
        const maximumPageSizeWithoutScrollBar = Math.floor(dimensions.viewportInnerSize.height / dimensions.rowHeight);
        return Math.min(maximumPageSizeWithoutScrollBar, params.rows.length);
    };
    return {
        getViewportPageSize: getViewportPageSize
    };
}


/* eslint-disable import/export, @typescript-eslint/no-redeclare */ const $4c1c3a63996032a6$var$EMPTY_RANGE = {
    firstRowIndex: 0,
    lastRowIndex: 0
};
const $4c1c3a63996032a6$var$EMPTY_CACHES = {
    spannedCells: {},
    hiddenCells: {},
    hiddenCellOriginMap: {}
};
const $4c1c3a63996032a6$var$selectors = {
    state: (state)=>state.rowSpanning,
    hiddenCells: (state)=>state.rowSpanning.caches.hiddenCells,
    spannedCells: (state)=>state.rowSpanning.caches.spannedCells,
    hiddenCellsOriginMap: (state)=>state.rowSpanning.caches.hiddenCellOriginMap
};
const $4c1c3a63996032a6$export$a282c9f2bcea1074 = {
    initialize: $4c1c3a63996032a6$var$initializeState,
    use: $4c1c3a63996032a6$var$useRowspan,
    selectors: $4c1c3a63996032a6$var$selectors
};
function $4c1c3a63996032a6$var$initializeState(params) {
    return {
        rowSpanning: params.initialState?.rowSpanning ?? {
            caches: $4c1c3a63996032a6$var$EMPTY_CACHES,
            processedRange: $4c1c3a63996032a6$var$EMPTY_RANGE
        }
    };
}
function $4c1c3a63996032a6$var$useRowspan(store, _params, _api) {
    const getHiddenCellsOrigin = ()=>$4c1c3a63996032a6$var$selectors.hiddenCellsOriginMap(store.state);
    return {
        getHiddenCellsOrigin: getHiddenCellsOrigin
    };
}



/* eslint-disable jsdoc/require-param-type */ /* eslint-disable jsdoc/require-param-description */ /* eslint-disable jsdoc/require-returns-type */ const $eda8c654dff1d26f$var$FEATURES = [
    (0, $31773ba16720ede9$export$d5b8c1948b345816),
    (0, $4cc7a762081bc0b0$export$7d6c73b1cdfb632f),
    (0, $becbf92d24ec01ad$export$2de9373493591e8b),
    (0, $4c1c3a63996032a6$export$a282c9f2bcea1074),
    (0, $c723315f364baa66$export$16e4d70cc375e707)
];
const $eda8c654dff1d26f$export$dd6d526d88b5a137 = (params)=>{
    const store = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)(()=>{
        return new (0, $3c7b0ee63f2f60b9$export$390f32400eaf98c9)($eda8c654dff1d26f$var$FEATURES.map((f)=>f.initialize(params)).reduce((state, partial)=>Object.assign(state, partial), {}));
    }).current;
    const api = {};
    for (const feature of $eda8c654dff1d26f$var$FEATURES)Object.assign(api, feature.use(store, params, api));
    return {
        store: store,
        api: api
    };
};













const $e7d42f0773505d53$var$MAX_PAGE_SIZE = 100;
const $e7d42f0773505d53$export$d515e179bb47bd84 = (autoPageSize)=>autoPageSize ? 0 : 100;
const $e7d42f0773505d53$export$b287f0ca5dbff6af = (rowCount, pageSize, page)=>{
    if (pageSize > 0 && rowCount > 0) return Math.ceil(rowCount / pageSize);
    if (rowCount === -1) // With unknown row-count, we can assume a page after the current one
    return page + 2;
    return 0;
};
const $e7d42f0773505d53$export$73aa7e9d0fff5ee4 = (autoPageSize)=>({
        page: 0,
        pageSize: autoPageSize ? 0 : 100
    });
const $e7d42f0773505d53$export$41142e40198ee144 = (page, pageCount = 0)=>{
    if (pageCount === 0) return page;
    return Math.max(Math.min(page, pageCount - 1), 0);
};
const $e7d42f0773505d53$export$d3cf54bfe8b6931 = (pageSize, signatureProp)=>{
    if (signatureProp === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid && pageSize > $e7d42f0773505d53$var$MAX_PAGE_SIZE) throw new Error([
        'MUI X: `pageSize` cannot exceed 100 in the MIT version of the DataGrid.',
        'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
    ].join('\n'));
};


const $e164e26c82788fb1$var$ALL_RESULTS_PAGE_VALUE = -1;
const $e164e26c82788fb1$export$24c945ea033ce6cf = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.pagination);
const $e164e26c82788fb1$export$19be8ebb403c941f = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($e164e26c82788fb1$export$24c945ea033ce6cf, (pagination)=>pagination.enabled && pagination.paginationMode === 'client');
const $e164e26c82788fb1$export$ccc9f04e59d0d8e6 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($e164e26c82788fb1$export$24c945ea033ce6cf, (pagination)=>pagination.paginationModel);
const $e164e26c82788fb1$export$946e4ae85da77ef6 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($e164e26c82788fb1$export$24c945ea033ce6cf, (pagination)=>pagination.rowCount);
const $e164e26c82788fb1$export$4dee702a38e33bdb = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($e164e26c82788fb1$export$24c945ea033ce6cf, (pagination)=>pagination.meta);
const $e164e26c82788fb1$export$1f7f64fcb62ccdad = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($e164e26c82788fb1$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.page);
const $e164e26c82788fb1$export$721a46720a2de097 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($e164e26c82788fb1$export$ccc9f04e59d0d8e6, (paginationModel)=>paginationModel.pageSize);
const $e164e26c82788fb1$export$b81026f1aaf843a4 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($e164e26c82788fb1$export$ccc9f04e59d0d8e6, $e164e26c82788fb1$export$946e4ae85da77ef6, (paginationModel, rowCount)=>(0, $e7d42f0773505d53$export$b287f0ca5dbff6af)(rowCount, paginationModel.pageSize, paginationModel.page));
const $e164e26c82788fb1$export$b76c99ac6ae901da = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($e164e26c82788fb1$export$19be8ebb403c941f, $e164e26c82788fb1$export$ccc9f04e59d0d8e6, (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d), (0, $4fc0d4cb0e570e63$export$4cdbe576751dd8e2), (0, $51d9da8b83918212$export$2f31562143a3e5d4), (0, $51d9da8b83918212$export$b8a7110d1a4c4623), (clientSidePaginationEnabled, paginationModel, rowTree, rowTreeDepth, visibleSortedRowEntries, visibleSortedTopLevelRowEntries)=>{
    if (!clientSidePaginationEnabled) return null;
    const visibleTopLevelRowCount = visibleSortedTopLevelRowEntries.length;
    const topLevelFirstRowIndex = Math.min(paginationModel.pageSize * paginationModel.page, visibleTopLevelRowCount - 1);
    const topLevelLastRowIndex = paginationModel.pageSize === $e164e26c82788fb1$var$ALL_RESULTS_PAGE_VALUE ? visibleTopLevelRowCount - 1 : Math.min(topLevelFirstRowIndex + paginationModel.pageSize - 1, visibleTopLevelRowCount - 1);
    // The range contains no element
    if (topLevelFirstRowIndex === -1 || topLevelLastRowIndex === -1) return null;
    // The tree is flat, there is no need to look for children
    if (rowTreeDepth < 2) return {
        firstRowIndex: topLevelFirstRowIndex,
        lastRowIndex: topLevelLastRowIndex
    };
    const topLevelFirstRow = visibleSortedTopLevelRowEntries[topLevelFirstRowIndex];
    const topLevelRowsInCurrentPageCount = topLevelLastRowIndex - topLevelFirstRowIndex + 1;
    const firstRowIndex = visibleSortedRowEntries.findIndex((row)=>row.id === topLevelFirstRow.id);
    let lastRowIndex = firstRowIndex;
    let topLevelRowAdded = 0;
    while(lastRowIndex < visibleSortedRowEntries.length && topLevelRowAdded <= topLevelRowsInCurrentPageCount){
        const row = visibleSortedRowEntries[lastRowIndex];
        const depth = rowTree[row.id]?.depth;
        if (depth === undefined) lastRowIndex += 1;
        else {
            if (topLevelRowAdded < topLevelRowsInCurrentPageCount || depth > 0) lastRowIndex += 1;
            if (depth === 0) topLevelRowAdded += 1;
        }
    }
    return {
        firstRowIndex: firstRowIndex,
        lastRowIndex: lastRowIndex - 1
    };
});
const $e164e26c82788fb1$export$abcd649e974e3e96 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)((0, $51d9da8b83918212$export$2f31562143a3e5d4), $e164e26c82788fb1$export$b76c99ac6ae901da, (visibleSortedRowEntries, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowEntries.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $e164e26c82788fb1$export$c1f6a976375edd4a = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)((0, $51d9da8b83918212$export$7a99837e2fd93e42), $e164e26c82788fb1$export$b76c99ac6ae901da, (visibleSortedRowIds, paginationRange)=>{
    if (!paginationRange) return [];
    return visibleSortedRowIds.slice(paginationRange.firstRowIndex, paginationRange.lastRowIndex + 1);
});
const $e164e26c82788fb1$export$33f627fc0fc60be4 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($e164e26c82788fb1$export$19be8ebb403c941f, $e164e26c82788fb1$export$b76c99ac6ae901da, $e164e26c82788fb1$export$abcd649e974e3e96, (0, $51d9da8b83918212$export$2f31562143a3e5d4), (clientPaginationEnabled, paginationRowRange, paginationRows, expandedSortedRowEntries)=>{
    if (clientPaginationEnabled) return {
        rows: paginationRows,
        range: paginationRowRange,
        rowIdToIndexMap: paginationRows.reduce((lookup, row, index)=>{
            lookup.set(row.id, index);
            return lookup;
        }, new Map())
    };
    return {
        rows: expandedSortedRowEntries,
        range: expandedSortedRowEntries.length === 0 ? null : {
            firstRowIndex: 0,
            lastRowIndex: expandedSortedRowEntries.length - 1
        },
        rowIdToIndexMap: expandedSortedRowEntries.reduce((lookup, row, index)=>{
            lookup.set(row.id, index);
            return lookup;
        }, new Map())
    };
});



const $2b6a1e01125c3822$export$79b9fa322a34430b = (apiRef, props)=>{
    return (0, $e164e26c82788fb1$export$33f627fc0fc60be4)(apiRef);
};
const $2b6a1e01125c3822$export$d1914c80ff11e37a = (apiRef, props)=>{
    return (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$33f627fc0fc60be4));
};







const $542ae311f57ccc4a$export$38fd8a77b05bfddf = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.virtualization);
const $542ae311f57ccc4a$export$fb3400598da0ae89 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($542ae311f57ccc4a$export$38fd8a77b05bfddf, (state)=>state.enabled);
const $542ae311f57ccc4a$export$ad2aa1e9d465cafa = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($542ae311f57ccc4a$export$38fd8a77b05bfddf, (state)=>state.enabledForColumns);
const $542ae311f57ccc4a$export$896d309ea36b40bd = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($542ae311f57ccc4a$export$38fd8a77b05bfddf, (state)=>state.enabledForRows);
const $542ae311f57ccc4a$export$4cf9f333a030f780 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($542ae311f57ccc4a$export$38fd8a77b05bfddf, (state)=>state.renderContext);
const $542ae311f57ccc4a$var$firstColumnIndexSelector = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.virtualization.renderContext.firstColumnIndex);
const $542ae311f57ccc4a$var$lastColumnIndexSelector = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.virtualization.renderContext.lastColumnIndex);
const $542ae311f57ccc4a$export$3a5705edd3d1af7e = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($542ae311f57ccc4a$var$firstColumnIndexSelector, $542ae311f57ccc4a$var$lastColumnIndexSelector, (firstColumnIndex, lastColumnIndex)=>({
        firstColumnIndex: firstColumnIndex,
        lastColumnIndex: lastColumnIndex
    }));




const $b543c0a272bcc69f$var$gridIsFocusedCellOutOfContext = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)((0, $578d1f15adc16cb4$export$74af8aada6269d3), (0, $542ae311f57ccc4a$export$4cf9f333a030f780), (0, $e164e26c82788fb1$export$33f627fc0fc60be4), (0, $1781ebe27505055c$export$16a65a9447d3dda9), (focusedCell, renderContext, currentPage, visibleColumns)=>{
    if (!focusedCell) return false;
    const rowIndex = currentPage.rowIdToIndexMap.get(focusedCell.id);
    const columnIndex = visibleColumns.slice(renderContext.firstColumnIndex, renderContext.lastColumnIndex).findIndex((column)=>column.field === focusedCell.field);
    const isInRenderContext = rowIndex !== undefined && columnIndex !== -1 && rowIndex >= renderContext.firstRowIndex && rowIndex <= renderContext.lastRowIndex;
    return !isInRenderContext;
});
const $b543c0a272bcc69f$export$6082669fb6748800 = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)($b543c0a272bcc69f$var$gridIsFocusedCellOutOfContext, (0, $1781ebe27505055c$export$16a65a9447d3dda9), (0, $e164e26c82788fb1$export$33f627fc0fc60be4), (0, $578d1f15adc16cb4$export$74af8aada6269d3), (isFocusedCellOutOfRenderContext, visibleColumns, currentPage, focusedCell)=>{
    if (!isFocusedCellOutOfRenderContext) return null;
    const rowIndex = currentPage.rowIdToIndexMap.get(focusedCell.id);
    if (rowIndex === undefined) return null;
    const columnIndex = visibleColumns.findIndex((column)=>column.field === focusedCell.field);
    if (columnIndex === -1) return null;
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, focusedCell, {
        rowIndex: rowIndex,
        columnIndex: columnIndex
    });
});




const $b3f45ec6f75f29f1$export$2733e0e1a1d288e7 = {
    autoHeight: false,
    autoPageSize: false,
    autosizeOnMount: false,
    checkboxSelection: false,
    checkboxSelectionVisibleOnly: false,
    clipboardCopyCellDelimiter: '\t',
    columnBufferPx: 150,
    columnFilterDebounceMs: 150,
    columnHeaderHeight: 56,
    disableAutosize: false,
    disableColumnFilter: false,
    disableColumnMenu: false,
    disableColumnReorder: false,
    disableColumnResize: false,
    disableColumnSelector: false,
    disableColumnSorting: false,
    disableDensitySelector: false,
    disableEval: false,
    disableMultipleColumnsFiltering: false,
    disableMultipleColumnsSorting: false,
    disableMultipleRowSelection: false,
    disableRowSelectionOnClick: false,
    disableRowSelectionExcludeModel: false,
    disableVirtualization: false,
    editMode: (0, $181c044302967209$export$bad6b7a934346f26).Cell,
    filterDebounceMs: 150,
    filterMode: 'client',
    hideFooter: false,
    hideFooterPagination: false,
    hideFooterRowCount: false,
    hideFooterSelectedRowCount: false,
    ignoreDiacritics: false,
    ignoreValueFormatterDuringExport: false,
    keepColumnPositionIfDraggedOutside: false,
    keepNonExistentRowsSelected: false,
    loading: false,
    logger: console,
    logLevel: 'error',
    pageSizeOptions: [
        25,
        50,
        100
    ],
    pagination: false,
    paginationMode: 'client',
    resizeThrottleMs: 60,
    rowBufferPx: 150,
    rowHeight: 52,
    rows: [],
    rowSelection: true,
    rowSpacingType: 'margin',
    rowSpanning: false,
    showCellVerticalBorder: false,
    showColumnVerticalBorder: false,
    showToolbar: false,
    sortingMode: 'client',
    sortingOrder: [
        'asc',
        'desc',
        null
    ],
    throttleRowsMs: 0,
    virtualizeColumnsWithAutoRowHeight: false
};






function $9667034338309ff9$var$identity(x) {
    return x;
}
const $9667034338309ff9$var$columnsTotalWidthSelector = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)((0, $1781ebe27505055c$export$16a65a9447d3dda9), (0, $1781ebe27505055c$export$fce7d810e48021e3), (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return (0, $145ef8aeadc094b1$export$28cd30446ab5724a)(positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth, 1);
});
/** Translates virtualizer state to grid state */ const $9667034338309ff9$var$addGridDimensionsCreator = ()=>(0, $310dad19a2812331$export$d8ead1d92249919b)((dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight)=>{
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, dimensions, {
            headerHeight: headerHeight,
            groupHeaderHeight: groupHeaderHeight,
            headerFilterHeight: headerFilterHeight,
            headersTotalHeight: headersTotalHeight
        });
    }, {
        maxSize: 1
    });
function $9667034338309ff9$export$face678f9a86c7e0(apiRef, rootProps) {
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const { listView: listView } = rootProps;
    const visibleColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$16a65a9447d3dda9));
    const pinnedRows = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$ffe7071c481e32b0));
    const pinnedColumns = (0, $1781ebe27505055c$export$297e8079713afa11)(apiRef);
    const rowSelectionManager = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $32777ac93d35a3f3$export$a13307f39ccef042));
    const isRowSelected = $acw62.useCallback((id)=>rowSelectionManager.has(id) && apiRef.current.isRowSelectable(id), [
        rowSelectionManager,
        apiRef
    ]);
    const currentPage = (0, $2b6a1e01125c3822$export$d1914c80ff11e37a)(apiRef);
    const hasColSpan = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$7aac81e7227448b4));
    const verticalScrollbarWidth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$6615095b3c921727));
    const hasFiller = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$34d7a8c547584228));
    const { autoHeight: autoHeight } = rootProps;
    const scrollReset = listView;
    // <DIMENSIONS>
    const density = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $3d9afbbff3fa8293$export$c646201fb1d3e7a6));
    const baseRowHeight = (0, $4ab53eafabc4b920$export$fa15c17c0798a441)(rootProps.rowHeight, (0, $b3f45ec6f75f29f1$export$2733e0e1a1d288e7).rowHeight, (0, $4ab53eafabc4b920$export$abf6a2a1a7dde56b));
    const rowHeight = Math.floor(baseRowHeight * density);
    const headerHeight = Math.floor(rootProps.columnHeaderHeight * density);
    const groupHeaderHeight = Math.floor((rootProps.columnGroupHeaderHeight ?? rootProps.columnHeaderHeight) * density);
    const headerFilterHeight = Math.floor((rootProps.headerFilterHeight ?? rootProps.columnHeaderHeight) * density);
    const columnsTotalWidth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, $9667034338309ff9$var$columnsTotalWidthSelector);
    const headersTotalHeight = (0, $7560da5e35f787e6$export$659109c29172602f)(apiRef, rootProps);
    const leftPinnedWidth = pinnedColumns.left.reduce((w, col)=>w + col.computedWidth, 0);
    const rightPinnedWidth = pinnedColumns.right.reduce((w, col)=>w + col.computedWidth, 0);
    const overlayState = (0, $5b89fc3f616edf04$export$ba0092e600a72afc)(apiRef, rootProps);
    const dimensionsParams = {
        rowHeight: rowHeight,
        headerHeight: headerHeight,
        columnsTotalWidth: columnsTotalWidth,
        leftPinnedWidth: leftPinnedWidth,
        rightPinnedWidth: rightPinnedWidth,
        topPinnedHeight: headersTotalHeight,
        bottomPinnedHeight: 0,
        scrollbarSize: rootProps.scrollbarSize
    };
    const addGridDimensions = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($9667034338309ff9$var$addGridDimensionsCreator).current;
    // </DIMENSIONS>
    // <ROWS_META>
    const dataRowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$1641ef9d08e265ca));
    const pagination = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$24c945ea033ce6cf));
    const rowCount = Math.min(pagination.enabled ? pagination.paginationModel.pageSize : dataRowCount, dataRowCount);
    const { getRowHeight: getRowHeight, getEstimatedRowHeight: getEstimatedRowHeight, getRowSpacing: getRowSpacing } = rootProps;
    // </ROWS_META>
    const focusedVirtualCell = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $b543c0a272bcc69f$export$6082669fb6748800));
    const RowSlot = rootProps.slots.row;
    const rowSlotProps = rootProps.slotProps?.row;
    const virtualizer = (0, $eda8c654dff1d26f$export$dd6d526d88b5a137)({
        refs: {
            container: apiRef.current.mainElementRef,
            scroller: apiRef.current.virtualScrollerRef,
            scrollbarVertical: apiRef.current.virtualScrollbarVerticalRef,
            scrollbarHorizontal: apiRef.current.virtualScrollbarHorizontalRef
        },
        dimensions: dimensionsParams,
        virtualization: {
            isRtl: isRtl,
            rowBufferPx: rootProps.rowBufferPx,
            columnBufferPx: rootProps.columnBufferPx
        },
        colspan: {
            enabled: hasColSpan,
            getColspan: $acw62.useCallback((rowId, column)=>{
                if (typeof column.colSpan === 'function') {
                    const row = apiRef.current.getRow(rowId);
                    const value = apiRef.current.getRowValue(row, column);
                    return column.colSpan(value, row, column, apiRef) ?? 0;
                }
                return column.colSpan ?? 1;
            }, [
                apiRef
            ])
        },
        initialState: {
            scroll: rootProps.initialState?.scroll,
            rowSpanning: apiRef.current.state.rowSpanning,
            virtualization: apiRef.current.state.virtualization
        },
        rows: currentPage.rows,
        range: currentPage.range,
        rowCount: rowCount,
        columns: visibleColumns,
        pinnedRows: pinnedRows,
        pinnedColumns: pinnedColumns,
        autoHeight: autoHeight,
        disableHorizontalScroll: listView,
        disableVerticalScroll: overlayState.overlayType === 'noColumnsOverlay' || overlayState.loadingOverlayVariant === 'skeleton',
        minimalContentHeight: $4ab53eafabc4b920$export$a95780409968416e,
        getRowHeight: $acw62.useMemo(()=>{
            if (!getRowHeight) return undefined;
            return (rowEntry)=>getRowHeight((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowEntry, {
                    densityFactor: density
                }));
        }, [
            getRowHeight,
            density
        ]),
        getEstimatedRowHeight: $acw62.useMemo(()=>getEstimatedRowHeight ? (rowEntry)=>getEstimatedRowHeight((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowEntry, {
                    densityFactor: density
                })) : undefined, [
            getEstimatedRowHeight,
            density
        ]),
        getRowSpacing: $acw62.useMemo(()=>getRowSpacing ? (rowEntry)=>{
                const indexRelativeToCurrentPage = currentPage.rowIdToIndexMap.get(rowEntry.id) ?? -1;
                const visibility = {
                    isFirstVisible: indexRelativeToCurrentPage === 0,
                    isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
                    indexRelativeToCurrentPage: indexRelativeToCurrentPage
                };
                return getRowSpacing((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowEntry, visibility, {
                    indexRelativeToCurrentPage: apiRef.current.getRowIndexRelativeToVisibleRows(rowEntry.id)
                }));
            } : undefined, [
            apiRef,
            getRowSpacing,
            currentPage.rows,
            currentPage.rowIdToIndexMap
        ]),
        applyRowHeight: (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((entry, row)=>apiRef.current.unstable_applyPipeProcessors('rowHeight', entry, row)),
        virtualizeColumnsWithAutoRowHeight: rootProps.virtualizeColumnsWithAutoRowHeight,
        focusedVirtualCell: (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>focusedVirtualCell),
        resizeThrottleMs: rootProps.resizeThrottleMs,
        onResize: (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((size)=>apiRef.current.publishEvent('resize', size)),
        onWheel: (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
            apiRef.current.publishEvent('virtualScrollerWheel', {}, event);
        }),
        onTouchMove: (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
            apiRef.current.publishEvent('virtualScrollerTouchMove', {}, event);
        }),
        onRenderContextChange: (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nextRenderContext)=>{
            apiRef.current.publishEvent('renderedRowsIntervalChange', nextRenderContext);
        }),
        onScrollChange: $acw62.useCallback((scrollPosition, nextRenderContext)=>{
            apiRef.current.publishEvent('scrollPositionChange', {
                top: scrollPosition.top,
                left: scrollPosition.left,
                renderContext: nextRenderContext
            });
        }, [
            apiRef
        ]),
        scrollReset: scrollReset,
        renderRow: $acw62.useCallback((params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RowSlot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                row: params.model,
                rowId: params.id,
                index: params.rowIndex,
                selected: isRowSelected(params.id),
                offsetLeft: params.offsetLeft,
                columnsTotalWidth: columnsTotalWidth,
                rowHeight: params.baseRowHeight,
                pinnedColumns: pinnedColumns,
                visibleColumns: visibleColumns,
                firstColumnIndex: params.firstColumnIndex,
                lastColumnIndex: params.lastColumnIndex,
                focusedColumnIndex: params.focusedColumnIndex,
                isFirstVisible: params.isFirstVisible,
                isLastVisible: params.isLastVisible,
                isNotVisible: params.isVirtualFocusRow,
                showBottomBorder: params.showBottomBorder,
                scrollbarWidth: verticalScrollbarWidth,
                gridHasFiller: hasFiller
            }, rowSlotProps), params.id), [
            columnsTotalWidth,
            hasFiller,
            isRowSelected,
            pinnedColumns,
            RowSlot,
            rowSlotProps,
            verticalScrollbarWidth,
            visibleColumns
        ]),
        renderInfiniteLoadingTrigger: $acw62.useCallback((id)=>apiRef.current.getInfiniteLoadingTriggerElement?.({
                lastRowId: id
            }), [
            apiRef
        ])
    });
    // HACK: Keep the grid's store in sync with the virtualizer store. We set up the
    // subscription in the render phase rather than in an effect because other grid
    // initialization code runs between those two moments.
    //
    // TODO(v9): Remove this
    (0, $ed0481f6b43b34b3$export$c5623aa1c38918b6)(()=>{
        apiRef.current.store.state.dimensions = addGridDimensions(virtualizer.store.state.dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight);
        apiRef.current.store.state.rowsMeta = virtualizer.store.state.rowsMeta;
        apiRef.current.store.state.virtualization = virtualizer.store.state.virtualization;
    });
    (0, $e5fd677936fa6c9d$export$c6cc86f9120e9aa4)(virtualizer.store, (0, $31773ba16720ede9$export$d5b8c1948b345816).selectors.dimensions, (_, dimensions)=>{
        apiRef.current.setState((gridState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, gridState, {
                dimensions: addGridDimensions(dimensions, headerHeight, groupHeaderHeight, headerFilterHeight, headersTotalHeight)
            }));
    });
    (0, $e5fd677936fa6c9d$export$c6cc86f9120e9aa4)(virtualizer.store, $9667034338309ff9$var$identity, (_, state)=>{
        if (state.rowsMeta !== apiRef.current.state.rowsMeta) apiRef.current.setState((gridState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, gridState, {
                rowsMeta: state.rowsMeta
            }));
        if (state.virtualization !== apiRef.current.state.virtualization) apiRef.current.setState((gridState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, gridState, {
                virtualization: state.virtualization
            }));
    });
    apiRef.current.register('private', {
        virtualizer: virtualizer
    });
}



var $acw62 = parcelRequire("acw62");
const $7a5470fd1b8a53b1$export$f9587d613f2caeec = (initializer, privateApiRef, props, key)=>{
    const previousKey = $acw62.useRef(key);
    const isInitialized = $acw62.useRef(false);
    if (key !== previousKey.current) {
        isInitialized.current = false;
        previousKey.current = key;
    }
    if (!isInitialized.current) {
        privateApiRef.current.state = initializer(privateApiRef.current.state, props, privateApiRef);
        isInitialized.current = true;
    }
};



var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
function $9de2ec91bb565794$export$eb512164890e58f0(privateApiRef, name) {
    const logger = $acw62.useRef(null);
    if (logger.current) return logger.current;
    const newLogger = privateApiRef.current.getLogger(name);
    logger.current = newLogger;
    return newLogger;
}



const $f38aaf0a32a5127f$export$265f4c39182036e = (apiRef, ref, eventName, handler, options)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useNativeEventListener');
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'rootMount', ()=>{
        const targetElement = ref();
        if (!targetElement || !eventName) return undefined;
        logger.debug(`Binding native ${eventName} event`);
        targetElement.addEventListener(eventName, handler, options);
        return ()=>{
            logger.debug(`Clearing native ${eventName} event`);
            targetElement.removeEventListener(eventName, handler, options);
        };
    });
};





parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");









'use client';
const $3e398bf5184f2a38$var$_excluded = [
    "field",
    "id",
    "formattedValue",
    "row",
    "rowNode",
    "colDef",
    "isEditable",
    "cellMode",
    "hasFocus",
    "tabIndex",
    "api"
];
const $3e398bf5184f2a38$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $3e398bf5184f2a38$export$de9fc2d8e98d780 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridCellCheckboxRenderer(props, ref) {
    const { field: field, id: id, rowNode: rowNode, tabIndex: tabIndex } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $3e398bf5184f2a38$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $3e398bf5184f2a38$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked,
            id: id
        };
        apiRef.current.publishEvent('rowSelectionCheckboxChange', params, event);
    };
    $acw62.useLayoutEffect(()=>{
        if (tabIndex === 0) {
            const element = apiRef.current.getCellElement(id, field);
            if (element) element.tabIndex = -1;
        }
    }, [
        apiRef,
        tabIndex,
        id,
        field
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (event.key === ' ') // We call event.stopPropagation to avoid selecting the row and also scrolling to bottom
        // TODO: Remove and add a check inside useGridKeyboardNavigation
        event.stopPropagation();
    }, []);
    const isSelectable = apiRef.current.isRowSelectable(id);
    const { isIndeterminate: isIndeterminate, isChecked: isChecked } = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $5e9cd545f0675d8f$export$3183bf7cf206881f), {
        groupId: id,
        autoSelectParents: rootProps.rowSelectionPropagation?.parents ?? false
    });
    if (rowNode.type === 'footer' || rowNode.type === 'pinnedRow') return null;
    const label = apiRef.current.getLocaleText(isChecked && !isIndeterminate ? 'checkboxSelectionUnselectRow' : 'checkboxSelectionSelectRow');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseCheckbox, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: tabIndex,
        checked: isChecked && !isIndeterminate,
        onChange: handleChange,
        className: classes.root,
        slotProps: {
            htmlInput: {
                'aria-label': label,
                name: 'select_row'
            }
        },
        onKeyDown: handleKeyDown,
        indeterminate: isIndeterminate,
        disabled: !isSelectable
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: ref
    }));
});
const $3e398bf5184f2a38$export$6df0a29182db5ff8 = $3e398bf5184f2a38$export$de9fc2d8e98d780;





var $acw62 = parcelRequire("acw62");














'use client';
const $01adcc05745387d9$var$_excluded = [
    "field",
    "colDef"
];
const $01adcc05745387d9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'checkboxInput'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $01adcc05745387d9$export$22c0c31c5dd8f5aa = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridHeaderCheckbox(props, ref) {
    const other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $01adcc05745387d9$var$_excluded);
    const [, forceUpdate] = $acw62.useState(false);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes
    };
    const classes = $01adcc05745387d9$var$useUtilityClasses(ownerState);
    const tabIndexState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $578d1f15adc16cb4$export$29da670438604dbd));
    const selection = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $32777ac93d35a3f3$export$f663bee74a6091fc));
    const visibleRowIds = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$7a99837e2fd93e42));
    const paginatedVisibleRowIds = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$c1f6a976375edd4a));
    const filteredSelection = $acw62.useMemo(()=>{
        const isRowSelectable = rootProps.isRowSelectable;
        if (typeof isRowSelectable !== 'function') return selection;
        if (selection.type === 'exclude') return selection;
        // selection.type === 'include'
        const selectionModel = {
            type: 'include',
            ids: new Set()
        };
        for (const id of selection.ids){
            if (rootProps.keepNonExistentRowsSelected) selectionModel.ids.add(id);
            // The row might have been deleted
            if (!apiRef.current.getRow(id)) continue;
            if (isRowSelectable(apiRef.current.getRowParams(id))) selectionModel.ids.add(id);
        }
        return selectionModel;
    }, [
        apiRef,
        rootProps.isRowSelectable,
        rootProps.keepNonExistentRowsSelected,
        selection
    ]);
    // All the rows that could be selected / unselected by toggling this checkbox
    const selectionCandidates = $acw62.useMemo(()=>{
        const rowIds = !rootProps.pagination || !rootProps.checkboxSelectionVisibleOnly || rootProps.paginationMode === 'server' ? visibleRowIds : paginatedVisibleRowIds;
        // Convert to a Set to make O(1) checking if a row exists or not
        const candidates = new Set();
        for(let i = 0; i < rowIds.length; i += 1){
            const id = rowIds[i];
            if (!apiRef.current.getRow(id)) continue;
            if (apiRef.current.isRowSelectable(id)) candidates.add(id);
        }
        return candidates;
    }, [
        apiRef,
        rootProps.pagination,
        rootProps.paginationMode,
        rootProps.checkboxSelectionVisibleOnly,
        paginatedVisibleRowIds,
        visibleRowIds
    ]);
    // Amount of rows selected and that are visible in the current page
    const currentSelectionSize = $acw62.useMemo(()=>{
        const selectionManager = (0, $0f89d07cedceae67$export$c0efd9f64c7d532a)(filteredSelection);
        let size = 0;
        for (const id of selectionCandidates)if (selectionManager.has(id)) size += 1;
        return size;
    }, [
        filteredSelection,
        selectionCandidates
    ]);
    const isIndeterminate = $acw62.useMemo(()=>{
        if (currentSelectionSize === 0) return false;
        const selectionManager = (0, $0f89d07cedceae67$export$c0efd9f64c7d532a)(filteredSelection);
        for (const rowId of selectionCandidates){
            if (!selectionManager.has(rowId)) return true;
        }
        return false;
    }, [
        currentSelectionSize,
        filteredSelection,
        selectionCandidates
    ]);
    const isChecked = currentSelectionSize > 0;
    const handleChange = (event)=>{
        const params = {
            value: event.target.checked
        };
        apiRef.current.publishEvent('headerSelectionCheckboxChange', params);
    };
    const tabIndex = tabIndexState !== null && tabIndexState.field === props.field ? 0 : -1;
    $acw62.useLayoutEffect(()=>{
        const element = apiRef.current.getColumnHeaderElement(props.field);
        if (tabIndex === 0 && element) element.tabIndex = -1;
    }, [
        tabIndex,
        apiRef,
        props.field
    ]);
    const handleKeyDown = $acw62.useCallback((event)=>{
        if (event.key === ' ') // imperative toggle the checkbox because Space is disable by some preventDefault
        apiRef.current.publishEvent('headerSelectionCheckboxChange', {
            value: !isChecked
        });
    }, [
        apiRef,
        isChecked
    ]);
    const handleSelectionChange = $acw62.useCallback(()=>{
        forceUpdate((p)=>!p);
    }, []);
    $acw62.useEffect(()=>{
        return apiRef.current.subscribeEvent('rowSelectionChange', handleSelectionChange);
    }, [
        apiRef,
        handleSelectionChange
    ]);
    const label = apiRef.current.getLocaleText(isChecked && !isIndeterminate ? 'checkboxSelectionUnselectAllRows' : 'checkboxSelectionSelectAllRows');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseCheckbox, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        indeterminate: isIndeterminate,
        checked: isChecked && !isIndeterminate,
        onChange: handleChange,
        className: classes.root,
        slotProps: {
            htmlInput: {
                'aria-label': label,
                name: 'select_all_rows'
            }
        },
        tabIndex: tabIndex,
        onKeyDown: handleKeyDown,
        disabled: !(0, $5e9cd545f0675d8f$export$cfcdc2e1121f7851)(rootProps)
    }, rootProps.slotProps?.baseCheckbox, other, {
        ref: ref
    }));
});





const $fa1dc905b3e7910f$export$322dfed7a1df1b02 = '__check__';
const $fa1dc905b3e7910f$export$b2e9ab6103a664ad = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $ccbab3147b17f664$export$220b51460e149ea9), {
    type: 'custom',
    field: $fa1dc905b3e7910f$export$322dfed7a1df1b02,
    width: 50,
    resizable: false,
    sortable: false,
    filterable: false,
    // @ts-ignore
    aggregable: false,
    chartable: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    getApplyQuickFilterFn: ()=>null,
    display: 'flex',
    valueGetter: (value, row, column, apiRef)=>{
        const rowId = (0, $f84d89d92301bd81$export$5e766ecd73f055ed)(apiRef, row);
        return apiRef.current.isRowSelected(rowId);
    },
    rowSpanValueGetter: (_, row, column, apiRef)=>(0, $f84d89d92301bd81$export$5e766ecd73f055ed)(apiRef, row),
    renderHeader: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $01adcc05745387d9$export$22c0c31c5dd8f5aa), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params)),
    renderCell: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e398bf5184f2a38$export$6df0a29182db5ff8), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params))
});


function $33177d49663b743c$var$sanitizeCellValue(value, csvOptions) {
    if (value === null || value === undefined) return '';
    const valueStr = typeof value === 'string' ? value : `${value}`;
    if (csvOptions.shouldAppendQuotes || csvOptions.escapeFormulas) {
        const escapedValue = valueStr.replace(/"/g, '""');
        if (csvOptions.escapeFormulas) {
            // See https://owasp.org/www-community/attacks/CSV_Injection
            if ([
                '=',
                '+',
                '-',
                '@',
                '\t',
                '\r'
            ].includes(escapedValue[0])) return `"'${escapedValue}"`;
        }
        // Make sure value containing delimiter or line break won't be split into multiple cells
        if ([
            csvOptions.delimiter,
            '\n',
            '\r',
            '"'
        ].some((delimiter)=>valueStr.includes(delimiter))) return `"${escapedValue}"`;
        return escapedValue;
    }
    return valueStr;
}
const $33177d49663b743c$export$edda57d2a460473d = (cellParams, options)=>{
    const { csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter } = options;
    let value;
    if (ignoreValueFormatter) {
        const columnType = cellParams.colDef.type;
        if (columnType === 'number') value = String(cellParams.value);
        else if (columnType === 'date' || columnType === 'dateTime') value = cellParams.value?.toISOString();
        else if (typeof cellParams.value?.toString === 'function') value = cellParams.value.toString();
        else value = cellParams.value;
    } else value = cellParams.formattedValue;
    return $33177d49663b743c$var$sanitizeCellValue(value, csvOptions);
};
class $33177d49663b743c$var$CSVRow {
    rowString = '';
    isEmpty = true;
    constructor(options){
        this.options = options;
    }
    addValue(value) {
        if (!this.isEmpty) this.rowString += this.options.csvOptions.delimiter;
        if (typeof this.options.sanitizeCellValue === 'function') this.rowString += this.options.sanitizeCellValue(value, this.options.csvOptions);
        else this.rowString += value;
        this.isEmpty = false;
    }
    getRowString() {
        return this.rowString;
    }
}
const $33177d49663b743c$var$serializeRow = ({ id: id, columns: columns, getCellParams: getCellParams, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter })=>{
    const row = new $33177d49663b743c$var$CSVRow({
        csvOptions: csvOptions
    });
    columns.forEach((column)=>{
        const cellParams = getCellParams(id, column.field);
        row.addValue($33177d49663b743c$export$edda57d2a460473d(cellParams, {
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        }));
    });
    return row.getRowString();
};
function $33177d49663b743c$export$8bfbf32dccc29440(options) {
    const { columns: columns, rowIds: rowIds, csvOptions: csvOptions, ignoreValueFormatter: ignoreValueFormatter, apiRef: apiRef } = options;
    const CSVBody = rowIds.reduce((acc, id)=>`${acc}${$33177d49663b743c$var$serializeRow({
            id: id,
            columns: columns,
            getCellParams: apiRef.current.getCellParams,
            ignoreValueFormatter: ignoreValueFormatter,
            csvOptions: csvOptions
        })}\r\n`, '').trim();
    if (!csvOptions.includeHeaders) return CSVBody;
    const filteredColumns = columns.filter((column)=>column.field !== (0, $fa1dc905b3e7910f$export$b2e9ab6103a664ad).field);
    const headerRows = [];
    if (csvOptions.includeColumnGroupsHeaders) {
        const columnGroupLookup = apiRef.current.getAllGroupDetails();
        let maxColumnGroupsDepth = 0;
        const columnGroupPathsLookup = filteredColumns.reduce((acc, column)=>{
            const columnGroupPath = apiRef.current.getColumnGroupPath(column.field);
            acc[column.field] = columnGroupPath;
            maxColumnGroupsDepth = Math.max(maxColumnGroupsDepth, columnGroupPath.length);
            return acc;
        }, {});
        for(let i = 0; i < maxColumnGroupsDepth; i += 1){
            const headerGroupRow = new $33177d49663b743c$var$CSVRow({
                csvOptions: csvOptions,
                sanitizeCellValue: $33177d49663b743c$var$sanitizeCellValue
            });
            headerRows.push(headerGroupRow);
            filteredColumns.forEach((column)=>{
                const columnGroupId = (columnGroupPathsLookup[column.field] || [])[i];
                const columnGroup = columnGroupLookup[columnGroupId];
                headerGroupRow.addValue(columnGroup ? columnGroup.headerName || columnGroup.groupId : '');
            });
        }
    }
    const mainHeaderRow = new $33177d49663b743c$var$CSVRow({
        csvOptions: csvOptions,
        sanitizeCellValue: $33177d49663b743c$var$sanitizeCellValue
    });
    filteredColumns.forEach((column)=>{
        mainHeaderRow.addValue(column.headerName || column.field);
    });
    headerRows.push(mainHeaderRow);
    const CSVHead = `${headerRows.map((row)=>row.getRowString()).join('\r\n')}\r\n`;
    return `${CSVHead}${CSVBody}`.trim();
}




function $631874dc7efcb08b$var$writeToClipboardPolyfill(data) {
    const span = document.createElement('span');
    span.style.whiteSpace = 'pre';
    span.style.userSelect = 'all';
    span.style.opacity = '0px';
    span.textContent = data;
    document.body.appendChild(span);
    const range = document.createRange();
    range.selectNode(span);
    const selection = window.getSelection();
    selection.removeAllRanges();
    selection.addRange(range);
    try {
        document.execCommand('copy');
    } finally{
        document.body.removeChild(span);
    }
}
function $631874dc7efcb08b$var$copyToClipboard(data) {
    if (navigator.clipboard) navigator.clipboard.writeText(data).catch(()=>{
        $631874dc7efcb08b$var$writeToClipboardPolyfill(data);
    });
    else $631874dc7efcb08b$var$writeToClipboardPolyfill(data);
}
function $631874dc7efcb08b$var$hasNativeSelection(element) {
    // When getSelection is called on an <iframe> that is not displayed Firefox will return null.
    if (window.getSelection()?.toString()) return true;
    // window.getSelection() returns an empty string in Firefox for selections inside a form element.
    // See: https://bugzilla.mozilla.org/show_bug.cgi?id=85686.
    // Instead, we can use element.selectionStart that is only defined on form elements.
    if (element && (element.selectionEnd || 0) - (element.selectionStart || 0) > 0) return true;
    return false;
}
const $631874dc7efcb08b$export$a44b2f69ac6aef73 = (apiRef, props)=>{
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.clipboardExport : ignoreValueFormatterProp) || false;
    const clipboardCopyCellDelimiter = props.clipboardCopyCellDelimiter;
    const handleCopy = $acw62.useCallback((event)=>{
        if (!(0, $2c033a607636d88a$export$b3bab6a2e94206d4)(event)) return;
        // Do nothing if there's a native selection
        if ($631874dc7efcb08b$var$hasNativeSelection(event.target)) return;
        let textToCopy = '';
        const selectedRowsCount = (0, $32777ac93d35a3f3$export$408e67b791fe352)(apiRef);
        if (selectedRowsCount > 0) textToCopy = apiRef.current.getDataAsCsv({
            includeHeaders: false,
            delimiter: clipboardCopyCellDelimiter,
            shouldAppendQuotes: false,
            escapeFormulas: false
        });
        else {
            const focusedCell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
            if (focusedCell) {
                const cellParams = apiRef.current.getCellParams(focusedCell.id, focusedCell.field);
                textToCopy = (0, $33177d49663b743c$export$edda57d2a460473d)(cellParams, {
                    csvOptions: {
                        delimiter: clipboardCopyCellDelimiter,
                        shouldAppendQuotes: false,
                        escapeFormulas: false
                    },
                    ignoreValueFormatter: ignoreValueFormatter
                });
            }
        }
        textToCopy = apiRef.current.unstable_applyPipeProcessors('clipboardCopy', textToCopy);
        if (textToCopy) {
            $631874dc7efcb08b$var$copyToClipboard(textToCopy);
            apiRef.current.publishEvent('clipboardCopy', textToCopy);
        }
    }, [
        apiRef,
        ignoreValueFormatter,
        clipboardCopyCellDelimiter
    ]);
    (0, $f38aaf0a32a5127f$export$265f4c39182036e)(apiRef, ()=>apiRef.current.rootElementRef.current, 'keydown', handleCopy);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'clipboardCopy', props.onClipboardCopy);
};




var $acw62 = parcelRequire("acw62");



const $2698549d3c7037cb$export$8574ffe06bf26347 = (state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        columnMenu: {
            open: false
        }
    });
const $2698549d3c7037cb$export$1fc2975c9a725449 = (apiRef)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridColumnMenu');
    /**
   * API METHODS
   */ const showColumnMenu = $acw62.useCallback((field)=>{
        const columnMenuState = (0, $54021b85ff01fa29$export$5479c2fb8e9fd070)(apiRef);
        const newState = {
            open: true,
            field: field
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) {
            apiRef.current.setState((state)=>{
                if (state.columnMenu.open && state.columnMenu.field === field) return state;
                logger.debug('Opening Column Menu');
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    columnMenu: {
                        open: true,
                        field: field
                    }
                });
            });
            apiRef.current.hidePreferences();
        }
    }, [
        apiRef,
        logger
    ]);
    const hideColumnMenu = $acw62.useCallback(()=>{
        const columnMenuState = (0, $54021b85ff01fa29$export$5479c2fb8e9fd070)(apiRef);
        if (columnMenuState.field) {
            const columnLookup = (0, $1781ebe27505055c$export$8a3a9a6db584d7fd)(apiRef);
            const columnVisibilityModel = (0, $1781ebe27505055c$export$eb0d33595fe29bb4)(apiRef);
            const orderedFields = (0, $1781ebe27505055c$export$d8a3dfbb129c80db)(apiRef);
            let fieldToFocus = columnMenuState.field;
            // If the column was removed from the grid, we need to find the closest visible field
            if (!columnLookup[fieldToFocus]) fieldToFocus = orderedFields[0];
            // If the field to focus is hidden, we need to find the closest visible field
            if (columnVisibilityModel[fieldToFocus] === false) {
                // contains visible column fields + the field that was just hidden
                const visibleOrderedFields = orderedFields.filter((field)=>{
                    if (field === fieldToFocus) return true;
                    return columnVisibilityModel[field] !== false;
                });
                const fieldIndex = visibleOrderedFields.indexOf(fieldToFocus);
                fieldToFocus = visibleOrderedFields[fieldIndex + 1] || visibleOrderedFields[fieldIndex - 1];
            }
            apiRef.current.setColumnHeaderFocus(fieldToFocus);
        }
        const newState = {
            open: false,
            field: undefined
        };
        const shouldUpdate = newState.open !== columnMenuState.open || newState.field !== columnMenuState.field;
        if (shouldUpdate) apiRef.current.setState((state)=>{
            logger.debug('Hiding Column Menu');
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                columnMenu: newState
            });
        });
    }, [
        apiRef,
        logger
    ]);
    const toggleColumnMenu = $acw62.useCallback((field)=>{
        logger.debug('Toggle Column Menu');
        const columnMenu = (0, $54021b85ff01fa29$export$5479c2fb8e9fd070)(apiRef);
        if (!columnMenu.open || columnMenu.field !== field) showColumnMenu(field);
        else hideColumnMenu();
    }, [
        apiRef,
        logger,
        showColumnMenu,
        hideColumnMenu
    ]);
    const columnMenuApi = {
        showColumnMenu: showColumnMenu,
        hideColumnMenu: hideColumnMenu,
        toggleColumnMenu: toggleColumnMenu
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, columnMenuApi, 'public');
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnResizeStart', hideColumnMenu);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'virtualScrollerWheel', apiRef.current.hideColumnMenu);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'virtualScrollerTouchMove', apiRef.current.hideColumnMenu);
};




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");

'use client';
const $c1adda9e70e08895$export$98b68054bf03cb4 = (apiRef, group, callback)=>{
    const cleanup = $acw62.useRef(null);
    const id = $acw62.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $acw62.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeApplier(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $ed0481f6b43b34b3$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor
    ]);
};


var $acw62 = parcelRequire("acw62");

'use client';
const $94c21951d8062459$export$faa98381ad228894 = (apiRef, group, callback, enabled = true)=>{
    const cleanup = $acw62.useRef(null);
    const id = $acw62.useRef(`mui-${Math.round(Math.random() * 1e9)}`);
    const registerPreProcessor = $acw62.useCallback(()=>{
        cleanup.current = apiRef.current.registerPipeProcessor(group, id.current, callback);
    }, [
        apiRef,
        callback,
        group
    ]);
    (0, $ed0481f6b43b34b3$export$c5623aa1c38918b6)(()=>{
        if (enabled) registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else if (enabled) registerPreProcessor();
        return ()=>{
            if (cleanup.current) {
                cleanup.current();
                cleanup.current = null;
            }
        };
    }, [
        registerPreProcessor,
        enabled
    ]);
};







'use client';
const $05c4ec08891f4206$export$8dcda879a58a8f96 = (state, props, apiRef)=>{
    apiRef.current.caches.columns = {
        lastColumnsProp: props.columns
    };
    const columnsState = (0, $7560da5e35f787e6$export$f3ba81d24bd05452)({
        apiRef: apiRef,
        columnsToUpsert: props.columns,
        initialState: props.initialState?.columns,
        columnVisibilityModel: props.columnVisibilityModel ?? props.initialState?.columns?.columnVisibilityModel ?? {},
        keepOnlyColumnsToUpsert: true
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        columns: columnsState,
        // In pro/premium, this part of the state is defined. We give it an empty but defined value
        // for the community version.
        pinnedColumns: state.pinnedColumns ?? (0, $c660c9275391bc0a$export$77439b544edbbd66)
    });
};
function $05c4ec08891f4206$export$fe9b9b8b4620abff(apiRef, props) {
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridColumns');
    apiRef.current.registerControlState({
        stateId: 'visibleColumns',
        propModel: props.columnVisibilityModel,
        propOnChange: props.onColumnVisibilityModelChange,
        stateSelector: (0, $1781ebe27505055c$export$eb0d33595fe29bb4),
        changeEvent: 'columnVisibilityModelChange'
    });
    const setGridColumnsState = $acw62.useCallback((columnsState)=>{
        logger.debug('Updating columns state.');
        apiRef.current.setState($05c4ec08891f4206$var$mergeColumnsState(columnsState));
        apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
    }, [
        logger,
        apiRef
    ]);
    /**
   * API METHODS
   */ const getColumn = $acw62.useCallback((field)=>(0, $1781ebe27505055c$export$8a3a9a6db584d7fd)(apiRef)[field], [
        apiRef
    ]);
    const getAllColumns = $acw62.useCallback(()=>(0, $1781ebe27505055c$export$da85f06e3c19f1fd)(apiRef), [
        apiRef
    ]);
    const getVisibleColumns = $acw62.useCallback(()=>(0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef), [
        apiRef
    ]);
    const getColumnIndex = $acw62.useCallback((field, useVisibleColumns = true)=>{
        const columns = useVisibleColumns ? (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef) : (0, $1781ebe27505055c$export$da85f06e3c19f1fd)(apiRef);
        return columns.findIndex((col)=>col.field === field);
    }, [
        apiRef
    ]);
    const getColumnPosition = $acw62.useCallback((field)=>{
        const index = getColumnIndex(field);
        return (0, $1781ebe27505055c$export$fce7d810e48021e3)(apiRef)[index];
    }, [
        apiRef,
        getColumnIndex
    ]);
    const setColumnVisibilityModel = $acw62.useCallback((model)=>{
        const currentModel = (0, $1781ebe27505055c$export$eb0d33595fe29bb4)(apiRef);
        if (currentModel !== model) {
            apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    columns: (0, $7560da5e35f787e6$export$f3ba81d24bd05452)({
                        apiRef: apiRef,
                        columnsToUpsert: [],
                        initialState: undefined,
                        columnVisibilityModel: model,
                        keepOnlyColumnsToUpsert: false
                    })
                }));
            apiRef.current.updateRenderContext?.();
        }
    }, [
        apiRef
    ]);
    const updateColumns = $acw62.useCallback((columns)=>{
        let columnsToUpdate = columns;
        if ((0, $8f88c26e7e51121c$export$c1e9ba02e25d9a4d)(apiRef)) {
            const nonPivotColumns = [];
            const pivotColumns = [];
            const pivotInitialColumns = (0, $8f88c26e7e51121c$export$c994aaa19f0be33d)(apiRef);
            columns.forEach((column)=>{
                const isNonPivotColumn = pivotInitialColumns.has(column.field);
                if (isNonPivotColumn) nonPivotColumns.push(column);
                else pivotColumns.push(column);
            });
            if (nonPivotColumns.length > 0) apiRef.current.updateNonPivotColumns(nonPivotColumns);
            if (pivotColumns.length === 0) return;
            columnsToUpdate = pivotColumns;
        }
        const columnsState = (0, $7560da5e35f787e6$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: columnsToUpdate,
            initialState: undefined,
            keepOnlyColumnsToUpsert: false,
            updateInitialVisibilityModel: true
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        setGridColumnsState
    ]);
    const setColumnVisibility = $acw62.useCallback((field, isVisible)=>{
        const columnVisibilityModel = (0, $1781ebe27505055c$export$eb0d33595fe29bb4)(apiRef);
        const isCurrentlyVisible = columnVisibilityModel[field] ?? true;
        if (isVisible !== isCurrentlyVisible) {
            const newModel = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, columnVisibilityModel, {
                [field]: isVisible
            });
            apiRef.current.setColumnVisibilityModel(newModel);
        }
    }, [
        apiRef
    ]);
    const getColumnIndexRelativeToVisibleColumns = $acw62.useCallback((field)=>{
        const allColumns = (0, $1781ebe27505055c$export$d8a3dfbb129c80db)(apiRef);
        return allColumns.findIndex((col)=>col === field);
    }, [
        apiRef
    ]);
    const setColumnIndex = $acw62.useCallback((field, targetIndexPosition)=>{
        const allColumns = (0, $1781ebe27505055c$export$d8a3dfbb129c80db)(apiRef);
        const oldIndexPosition = getColumnIndexRelativeToVisibleColumns(field);
        if (oldIndexPosition === targetIndexPosition) return;
        logger.debug(`Moving column ${field} to index ${targetIndexPosition}`);
        const updatedColumns = [
            ...allColumns
        ];
        const fieldRemoved = updatedColumns.splice(oldIndexPosition, 1)[0];
        updatedColumns.splice(targetIndexPosition, 0, fieldRemoved);
        setGridColumnsState((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $1781ebe27505055c$export$858d15abb6cddc08)(apiRef), {
            orderedFields: updatedColumns
        }));
        const params = {
            column: apiRef.current.getColumn(field),
            targetIndex: apiRef.current.getColumnIndexRelativeToVisibleColumns(field),
            oldIndex: oldIndexPosition
        };
        apiRef.current.publishEvent('columnIndexChange', params);
    }, [
        apiRef,
        logger,
        setGridColumnsState,
        getColumnIndexRelativeToVisibleColumns
    ]);
    const setColumnWidth = $acw62.useCallback((field, width)=>{
        logger.debug(`Updating column ${field} width to ${width}`);
        const columnsState = (0, $1781ebe27505055c$export$858d15abb6cddc08)(apiRef);
        const column = columnsState.lookup[field];
        const newColumn = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, column, {
            width: width,
            hasBeenResized: true
        });
        setGridColumnsState((0, $7560da5e35f787e6$export$cd8dc1fa232954ad)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, columnsState, {
            lookup: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, columnsState.lookup, {
                [field]: newColumn
            })
        }), apiRef.current.getRootDimensions()));
        apiRef.current.publishEvent('columnWidthChange', {
            element: apiRef.current.getColumnHeaderElement(field),
            colDef: newColumn,
            width: width
        });
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    const columnApi = {
        getColumn: getColumn,
        getAllColumns: getAllColumns,
        getColumnIndex: getColumnIndex,
        getColumnPosition: getColumnPosition,
        getVisibleColumns: getVisibleColumns,
        getColumnIndexRelativeToVisibleColumns: getColumnIndexRelativeToVisibleColumns,
        updateColumns: updateColumns,
        setColumnVisibilityModel: setColumnVisibilityModel,
        setColumnVisibility: setColumnVisibility,
        setColumnWidth: setColumnWidth
    };
    const columnReorderApi = {
        setColumnIndex: setColumnIndex
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, columnApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, columnReorderApi, props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const columnsStateToExport = {};
        const columnVisibilityModelToExport = (0, $1781ebe27505055c$export$eb0d33595fe29bb4)(apiRef);
        const shouldExportColumnVisibilityModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.columnVisibilityModel != null || // Always export if the model has been initialized
        // TODO v6 Do a nullish check instead to export even if the initial model equals "{}"
        Object.keys(props.initialState?.columns?.columnVisibilityModel ?? {}).length > 0 || // Always export if the model is not empty
        Object.keys(columnVisibilityModelToExport).length > 0;
        if (shouldExportColumnVisibilityModel) columnsStateToExport.columnVisibilityModel = columnVisibilityModelToExport;
        columnsStateToExport.orderedFields = (0, $1781ebe27505055c$export$d8a3dfbb129c80db)(apiRef);
        const columns = (0, $1781ebe27505055c$export$da85f06e3c19f1fd)(apiRef);
        const dimensions = {};
        columns.forEach((colDef)=>{
            if (colDef.hasBeenResized) {
                const colDefDimensions = {};
                (0, $7560da5e35f787e6$export$cd7252624d377ce0).forEach((propertyName)=>{
                    let propertyValue = colDef[propertyName];
                    if (propertyValue === Infinity) propertyValue = -1;
                    colDefDimensions[propertyName] = propertyValue;
                });
                dimensions[colDef.field] = colDefDimensions;
            }
        });
        if (Object.keys(dimensions).length > 0) columnsStateToExport.dimensions = dimensions;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            columns: columnsStateToExport
        });
    }, [
        apiRef,
        props.columnVisibilityModel,
        props.initialState?.columns
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const initialState = context.stateToRestore.columns;
        const columnVisibilityModelToImport = initialState?.columnVisibilityModel;
        if (initialState == null) return params;
        const columnsState = (0, $7560da5e35f787e6$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: initialState,
            columnVisibilityModel: columnVisibilityModelToImport,
            keepOnlyColumnsToUpsert: false
        });
        if (initialState != null) apiRef.current.setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                columns: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState.columns, {
                    lookup: columnsState.lookup,
                    orderedFields: columnsState.orderedFields,
                    initialColumnVisibilityModel: columnsState.initialColumnVisibilityModel
                })
            }));
        // separate column visibility model state update as it can be controlled
        // https://github.com/mui/mui-x/issues/17681#issuecomment-3012528602
        if (columnVisibilityModelToImport != null) apiRef.current.setState((prevState)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
                columns: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState.columns, {
                    columnVisibilityModel: columnVisibilityModelToImport
                })
            }));
        if (initialState != null) apiRef.current.publishEvent('columnsChange', columnsState.orderedFields);
        return params;
    }, [
        apiRef
    ]);
    const preferencePanelPreProcessing = $acw62.useCallback((initialValue, value)=>{
        if (value === (0, $e38c9af0748d9173$export$e7e5652452e44b).columns) {
            const ColumnsPanel = props.slots.columnsPanel;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ColumnsPanel, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props.slotProps?.columnsPanel));
        }
        return initialValue;
    }, [
        props.slots.columnsPanel,
        props.slotProps?.columnsPanel
    ]);
    const addColumnMenuItems = $acw62.useCallback((columnMenuItems)=>{
        const isPivotActive = (0, $8f88c26e7e51121c$export$c1e9ba02e25d9a4d)(apiRef);
        if (props.disableColumnSelector || isPivotActive) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuColumnsItem'
        ];
    }, [
        props.disableColumnSelector,
        apiRef
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItems);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    /*
   * EVENTS
   */ const prevInnerWidth = $acw62.useRef(null);
    const handleGridSizeChange = (size)=>{
        if (prevInnerWidth.current !== size.width) {
            prevInnerWidth.current = size.width;
            const hasFlexColumns = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef).some((col)=>col.flex && col.flex > 0);
            if (!hasFlexColumns) return;
            setGridColumnsState((0, $7560da5e35f787e6$export$cd8dc1fa232954ad)((0, $1781ebe27505055c$export$858d15abb6cddc08)(apiRef), apiRef.current.getRootDimensions()));
        }
    };
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    /**
   * APPLIERS
   */ const hydrateColumns = $acw62.useCallback(()=>{
        logger.info(`Columns pipe processing have changed, regenerating the columns`);
        const columnsState = (0, $7560da5e35f787e6$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            columnsToUpsert: [],
            initialState: undefined,
            keepOnlyColumnsToUpsert: false
        });
        setGridColumnsState(columnsState);
    }, [
        apiRef,
        logger,
        setGridColumnsState
    ]);
    (0, $c1adda9e70e08895$export$98b68054bf03cb4)(apiRef, 'hydrateColumns', hydrateColumns);
    /*
   * EFFECTS
   */ // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridColumns`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    $acw62.useEffect(()=>{
        if (apiRef.current.caches.columns.lastColumnsProp === props.columns) return;
        apiRef.current.caches.columns.lastColumnsProp = props.columns;
        logger.info(`GridColumns have changed, new length ${props.columns.length}`);
        const columnsState = (0, $7560da5e35f787e6$export$f3ba81d24bd05452)({
            apiRef: apiRef,
            initialState: undefined,
            // If the user provides a model, we don't want to set it in the state here because it has it's dedicated `useEffect` which calls `setColumnVisibilityModel`
            columnsToUpsert: props.columns,
            keepOnlyColumnsToUpsert: true,
            updateInitialVisibilityModel: true,
            columnVisibilityModel: props.columnVisibilityModel
        });
        setGridColumnsState(columnsState);
    }, [
        logger,
        apiRef,
        setGridColumnsState,
        props.columns,
        props.columnVisibilityModel
    ]);
    $acw62.useEffect(()=>{
        if (props.columnVisibilityModel !== undefined) apiRef.current.setColumnVisibilityModel(props.columnVisibilityModel);
    }, [
        apiRef,
        logger,
        props.columnVisibilityModel
    ]);
}
function $05c4ec08891f4206$var$mergeColumnsState(columnsState) {
    return (state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
            columns: columnsState
        });
}




var $acw62 = parcelRequire("acw62");





'use client';
const $c70f7017dba888d7$export$d6d71dbaaa6fec72 = (state, props)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        density: props.initialState?.density ?? props.density ?? 'standard'
    });
const $c70f7017dba888d7$export$836c4be63cf7a42d = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useDensity');
    apiRef.current.registerControlState({
        stateId: 'density',
        propModel: props.density,
        propOnChange: props.onDensityChange,
        stateSelector: (0, $3d9afbbff3fa8293$export$806a039ece4425b4),
        changeEvent: 'densityChange'
    });
    const setDensity = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newDensity)=>{
        const currentDensity = (0, $3d9afbbff3fa8293$export$806a039ece4425b4)(apiRef);
        if (currentDensity === newDensity) return;
        logger.debug(`Set grid density to ${newDensity}`);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                density: newDensity
            }));
    });
    const densityApi = {
        setDensity: setDensity
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, densityApi, 'public');
    const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const exportedDensity = (0, $3d9afbbff3fa8293$export$806a039ece4425b4)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `density` is controlled
        props.density != null || // Always export if the `density` has been initialized
        props.initialState?.density != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            density: exportedDensity
        });
    }, [
        apiRef,
        props.density,
        props.initialState?.density
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const restoredDensity = context.stateToRestore?.density ? context.stateToRestore.density : (0, $3d9afbbff3fa8293$export$806a039ece4425b4)(apiRef);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                density: restoredDensity
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    $acw62.useEffect(()=>{
        if (props.density) apiRef.current.setDensity(props.density);
    }, [
        apiRef,
        props.density
    ]);
};



var $acw62 = parcelRequire("acw62");


/**
 * I have hesitated to use https://github.com/eligrey/FileSaver.js.
 * If we get bug reports that this project solves, we should consider using it.
 *
 * Related resources.
 * https://blog.logrocket.com/programmatic-file-downloads-in-the-browser-9a5186298d5c/
 * https://github.com/mbrn/filefy/blob/ec4ed0b7415d93be7158c23029f2ea1fa0b8e2d9/src/core/BaseBuilder.ts
 * https://unpkg.com/browse/@progress/kendo-file-saver@1.0.7/dist/es/save-as.js
 * https://github.com/ag-grid/ag-grid/blob/9565c219b6210aa85fa833c929d0728f9d163a91/community-modules/csv-export/src/csvExport/downloader.ts
 */ function $d93f3f3a0e338941$export$f95aebe89510930(blob, extension = 'csv', filename = document.title || 'untitled') {
    const fullName = `${filename}.${extension}`;
    // Test download attribute first
    // https://github.com/eligrey/FileSaver.js/issues/193
    if ('download' in HTMLAnchorElement.prototype) {
        // Create an object URL for the blob object
        const url = URL.createObjectURL(blob);
        // Create a new anchor element
        const a = document.createElement('a');
        a.href = url;
        a.download = fullName;
        // Programmatically trigger a click on the anchor element
        // Useful if you want the download to happen automatically
        // Without attaching the anchor element to the DOM
        a.click();
        // https://github.com/eligrey/FileSaver.js/issues/205
        setTimeout(()=>{
            URL.revokeObjectURL(url);
        });
        return;
    }
    throw new Error('MUI X: exportAs not supported.');
}







const $1319f3d8c75c728d$export$c5c7f3bb5f79a15d = ({ apiRef: apiRef, options: options })=>{
    const columns = (0, $1781ebe27505055c$export$da85f06e3c19f1fd)(apiRef);
    if (options.fields) return options.fields.reduce((currentColumns, field)=>{
        const column = columns.find((col)=>col.field === field);
        if (column) currentColumns.push(column);
        return currentColumns;
    }, []);
    const validColumns = options.allColumns ? columns : (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef);
    return validColumns.filter((column)=>column.disableExport !== true);
};
const $1319f3d8c75c728d$export$99156d1572dee776 = ({ apiRef: apiRef })=>{
    const filteredSortedRowIds = (0, $51d9da8b83918212$export$4e2a9d76902d271c)(apiRef);
    const rowTree = (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef);
    const selectedRowsCount = (0, $32777ac93d35a3f3$export$408e67b791fe352)(apiRef);
    const bodyRows = filteredSortedRowIds.filter((id)=>rowTree[id].type !== 'footer');
    const pinnedRows = (0, $4fc0d4cb0e570e63$export$ffe7071c481e32b0)(apiRef);
    const topPinnedRowsIds = pinnedRows?.top?.map((row)=>row.id) || [];
    const bottomPinnedRowsIds = pinnedRows?.bottom?.map((row)=>row.id) || [];
    bodyRows.unshift(...topPinnedRowsIds);
    bodyRows.push(...bottomPinnedRowsIds);
    if (selectedRowsCount > 0) {
        const selectedRows = (0, $32777ac93d35a3f3$export$815b73af677cc8a1)(apiRef);
        return bodyRows.filter((id)=>selectedRows.has(id));
    }
    return bodyRows;
};






var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");









'use client';
const $976d1b24e6aea797$export$9c3c7dbe6f1101cf = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridToolbarExportContainer(props, ref) {
    const { children: children, slotProps: slotProps = {} } = props;
    const buttonProps = slotProps.button || {};
    const tooltipProps = slotProps.tooltip || {};
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const exportButtonId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const exportMenuId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const [open, setOpen] = $acw62.useState(false);
    const buttonRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, buttonRef);
    const handleMenuOpen = (event)=>{
        setOpen((prevOpen)=>!prevOpen);
        buttonProps.onClick?.(event);
    };
    const handleMenuClose = ()=>setOpen(false);
    if (children == null) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTooltip, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                title: apiRef.current.getLocaleText('toolbarExportLabel'),
                enterDelay: 1000
            }, rootProps.slotProps?.baseTooltip, tooltipProps, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    size: "small",
                    startIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.exportIcon, {}),
                    "aria-expanded": open,
                    "aria-label": apiRef.current.getLocaleText('toolbarExportLabel'),
                    "aria-haspopup": "menu",
                    "aria-controls": open ? exportMenuId : undefined,
                    id: exportButtonId
                }, rootProps.slotProps?.baseButton, buttonProps, {
                    onClick: handleMenuOpen,
                    ref: handleRef,
                    children: apiRef.current.getLocaleText('toolbarExport')
                }))
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbffbc66fe757e53$export$237948c71948075), {
                open: open,
                target: buttonRef.current,
                onClose: handleMenuClose,
                position: "bottom-end",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuList, {
                    id: exportMenuId,
                    className: (0, $59e5f6b0ce3da023$export$2100d54e36406477).menuList,
                    "aria-labelledby": exportButtonId,
                    autoFocusItem: open,
                    children: $acw62.Children.map(children, (child)=>{
                        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return child;
                        return /*#__PURE__*/ $acw62.cloneElement(child, {
                            hideMenu: handleMenuClose
                        });
                    })
                })
            })
        ]
    });
});



const $59b065a027d02e77$var$_excluded = [
    "hideMenu",
    "options"
], $59b065a027d02e77$var$_excluded2 = [
    "hideMenu",
    "options"
], $59b065a027d02e77$var$_excluded3 = [
    "csvOptions",
    "printOptions",
    "excelOptions"
];
function $59b065a027d02e77$export$c0e66088a5c9ffbf(props) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $59b065a027d02e77$var$_excluded);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        onClick: ()=>{
            apiRef.current.exportDataAsCsv(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportCSV')
    }));
}
function $59b065a027d02e77$export$a6cd094b30f69b92(props) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { hideMenu: hideMenu, options: options } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $59b065a027d02e77$var$_excluded2);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        onClick: ()=>{
            apiRef.current.exportDataAsPrint(options);
            hideMenu?.();
        }
    }, other, {
        children: apiRef.current.getLocaleText('toolbarExportPrint')
    }));
}
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/export/ Export} components instead. This component will be removed in a future major release.
 */ const $59b065a027d02e77$export$ef68b449b329deb5 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridToolbarExport(props, ref) {
    const _ref = props, { csvOptions: csvOptions = {}, printOptions: printOptions = {}, excelOptions: excelOptions } = _ref, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $59b065a027d02e77$var$_excluded3);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const preProcessedButtons = apiRef.current.unstable_applyPipeProcessors('exportMenu', [], {
        excelOptions: excelOptions,
        csvOptions: csvOptions,
        printOptions: printOptions
    }).sort((a, b)=>a.componentName > b.componentName ? 1 : -1);
    if (preProcessedButtons.length === 0) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $976d1b24e6aea797$export$9c3c7dbe6f1101cf), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        children: preProcessedButtons.map((button, index)=>/*#__PURE__*/ $acw62.cloneElement(button.component, {
                key: index
            }))
    }));
});



const $7a92b1676fe8176d$export$6178dbab26611702 = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridCsvExport');
    const ignoreValueFormatterProp = props.ignoreValueFormatterDuringExport;
    const ignoreValueFormatter = (typeof ignoreValueFormatterProp === 'object' ? ignoreValueFormatterProp?.csvExport : ignoreValueFormatterProp) || false;
    const getDataAsCsv = $acw62.useCallback((options = {})=>{
        logger.debug(`Get data as CSV`);
        const exportedColumns = (0, $1319f3d8c75c728d$export$c5c7f3bb5f79a15d)({
            apiRef: apiRef,
            options: options
        });
        const getRowsToExport = options.getRowsToExport ?? (0, $1319f3d8c75c728d$export$99156d1572dee776);
        const exportedRowIds = getRowsToExport({
            apiRef: apiRef
        });
        return (0, $33177d49663b743c$export$8bfbf32dccc29440)({
            columns: exportedColumns,
            rowIds: exportedRowIds,
            csvOptions: {
                delimiter: options.delimiter || ',',
                shouldAppendQuotes: options.shouldAppendQuotes ?? true,
                includeHeaders: options.includeHeaders ?? true,
                includeColumnGroupsHeaders: options.includeColumnGroupsHeaders ?? true,
                escapeFormulas: options.escapeFormulas ?? true
            },
            ignoreValueFormatter: ignoreValueFormatter,
            apiRef: apiRef
        });
    }, [
        logger,
        apiRef,
        ignoreValueFormatter
    ]);
    const exportDataAsCsv = $acw62.useCallback((options)=>{
        logger.debug(`Export data as CSV`);
        const csv = getDataAsCsv(options);
        const blob = new Blob([
            options?.utf8WithBom ? new Uint8Array([
                0xef,
                0xbb,
                0xbf
            ]) : '',
            csv
        ], {
            type: 'text/csv'
        });
        (0, $d93f3f3a0e338941$export$f95aebe89510930)(blob, 'csv', options?.fileName);
    }, [
        logger,
        getDataAsCsv
    ]);
    const csvExportApi = {
        getDataAsCsv: getDataAsCsv,
        exportDataAsCsv: exportDataAsCsv
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, csvExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $acw62.useCallback((initialValue, options)=>{
        if (options.csvOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59b065a027d02e77$export$c0e66088a5c9ffbf), {
                    options: options.csvOptions
                }),
                componentName: 'csvExport'
            }
        ];
    }, []);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportMenu', addExportMenuButtons);
};




var $acw62 = parcelRequire("acw62");

/**
 * Loads all stylesheets from the given root element into the document.
 * @returns an array of promises that resolve when each stylesheet is loaded
 * @param document Document to load stylesheets into
 * @param root Document or ShadowRoot to load stylesheets from
 */ function $a3689efd757d1d61$export$c6b5bed05c215de5(document, root) {
    const stylesheetLoadPromises = [];
    const headStyleElements = root.querySelectorAll("style, link[rel='stylesheet']");
    for(let i = 0; i < headStyleElements.length; i += 1){
        const node = headStyleElements[i];
        if (node.tagName === 'STYLE') {
            const newHeadStyleElements = document.createElement(node.tagName);
            const sheet = node.sheet;
            if (sheet) {
                let styleCSS = '';
                for(let j = 0; j < sheet.cssRules.length; j += 1)if (typeof sheet.cssRules[j].cssText === 'string') styleCSS += `${sheet.cssRules[j].cssText}\r\n`;
                newHeadStyleElements.appendChild(document.createTextNode(styleCSS));
                document.head.appendChild(newHeadStyleElements);
            }
        } else if (node.getAttribute('href')) {
            // If `href` tag is empty, avoid loading these links
            const newHeadStyleElements = document.createElement(node.tagName);
            for(let j = 0; j < node.attributes.length; j += 1){
                const attr = node.attributes[j];
                if (attr) newHeadStyleElements.setAttribute(attr.nodeName, attr.nodeValue || '');
            }
            stylesheetLoadPromises.push(new Promise((resolve)=>{
                newHeadStyleElements.addEventListener('load', ()=>resolve());
            }));
            document.head.appendChild(newHeadStyleElements);
        }
    }
    return stylesheetLoadPromises;
}












var $acw62 = parcelRequire("acw62");







'use client';
const $59c9ca30cf4d11cd$export$16d1dc8477d07e4 = (paginationState, signature, paginationModelProp)=>{
    let paginationModel = paginationState.paginationModel;
    const rowCount = paginationState.rowCount;
    const pageSize = paginationModelProp?.pageSize ?? paginationModel.pageSize;
    const page = paginationModelProp?.page ?? paginationModel.page;
    const pageCount = (0, $e7d42f0773505d53$export$b287f0ca5dbff6af)(rowCount, pageSize, page);
    if (paginationModelProp && (paginationModelProp?.page !== paginationModel.page || paginationModelProp?.pageSize !== paginationModel.pageSize)) paginationModel = paginationModelProp;
    const validPage = pageSize === -1 ? 0 : (0, $e7d42f0773505d53$export$41142e40198ee144)(paginationModel.page, pageCount);
    if (validPage !== paginationModel.page) paginationModel = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, paginationModel, {
        page: validPage
    });
    (0, $e7d42f0773505d53$export$d3cf54bfe8b6931)(paginationModel.pageSize, signature);
    return paginationModel;
};
const $59c9ca30cf4d11cd$export$fb13b4a85293b054 = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridPaginationModel');
    const densityFactor = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $3d9afbbff3fa8293$export$c646201fb1d3e7a6));
    const previousFilterModel = $acw62.useRef((0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef));
    const rowHeight = Math.floor(props.rowHeight * densityFactor);
    apiRef.current.registerControlState({
        stateId: 'paginationModel',
        propModel: props.paginationModel,
        propOnChange: props.onPaginationModelChange,
        stateSelector: (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6),
        changeEvent: 'paginationModelChange'
    });
    /**
   * API METHODS
   */ const setPage = $acw62.useCallback((page)=>{
        const currentModel = (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef);
        if (page === currentModel.page) return;
        logger.debug(`Setting page to ${page}`);
        apiRef.current.setPaginationModel({
            page: page,
            pageSize: currentModel.pageSize
        });
    }, [
        apiRef,
        logger
    ]);
    const setPageSize = $acw62.useCallback((pageSize)=>{
        const currentModel = (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef);
        if (pageSize === currentModel.pageSize) return;
        logger.debug(`Setting page size to ${pageSize}`);
        apiRef.current.setPaginationModel({
            pageSize: pageSize,
            page: currentModel.page
        });
    }, [
        apiRef,
        logger
    ]);
    const setPaginationModel = $acw62.useCallback((paginationModel)=>{
        const currentModel = (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef);
        if (paginationModel === currentModel) return;
        logger.debug("Setting 'paginationModel' to", paginationModel);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                    paginationModel: $59c9ca30cf4d11cd$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }), 'setPaginationModel');
    }, [
        apiRef,
        logger,
        props.signature
    ]);
    const paginationModelApi = {
        setPage: setPage,
        setPageSize: setPageSize,
        setPaginationModel: setPaginationModel
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, paginationModelApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const paginationModel = (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef);
        const shouldExportPaginationModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationModel` is controlled
        props.paginationModel != null || // Always export if the `paginationModel` has been initialized
        props.initialState?.pagination?.paginationModel != null || // Export if `page` or `pageSize` is not equal to the default value
        paginationModel.page !== 0 && paginationModel.pageSize !== (0, $e7d42f0773505d53$export$d515e179bb47bd84)(props.autoPageSize);
        if (!shouldExportPaginationModel) return prevState;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState.pagination, {
                paginationModel: paginationModel
            })
        });
    }, [
        apiRef,
        props.paginationModel,
        props.initialState?.pagination?.paginationModel,
        props.autoPageSize
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const paginationModel = context.stateToRestore.pagination?.paginationModel ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $e7d42f0773505d53$export$73aa7e9d0fff5ee4)(props.autoPageSize), context.stateToRestore.pagination?.paginationModel) : (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                    paginationModel: $59c9ca30cf4d11cd$export$16d1dc8477d07e4(state.pagination, props.signature, paginationModel)
                })
            }), 'stateRestorePreProcessing');
        return params;
    }, [
        apiRef,
        props.autoPageSize,
        props.signature
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = ()=>{
        const paginationModel = (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef);
        if (apiRef.current.virtualScrollerRef?.current) apiRef.current.scrollToIndexes({
            rowIndex: paginationModel.page * paginationModel.pageSize
        });
    };
    const handleUpdateAutoPageSize = $acw62.useCallback(()=>{
        if (!props.autoPageSize) return;
        const dimensions = apiRef.current.getRootDimensions();
        const maximumPageSizeWithoutScrollBar = Math.max(1, Math.floor(dimensions.viewportInnerSize.height / rowHeight));
        apiRef.current.setPageSize(maximumPageSizeWithoutScrollBar);
    }, [
        apiRef,
        props.autoPageSize,
        rowHeight
    ]);
    const handleRowCountChange = $acw62.useCallback((newRowCount)=>{
        if (newRowCount == null) return;
        const paginationModel = (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef);
        if (paginationModel.page === 0) return;
        const pageCount = (0, $e164e26c82788fb1$export$b81026f1aaf843a4)(apiRef);
        if (paginationModel.page > pageCount - 1) apiRef.current.setPage(Math.max(0, pageCount - 1));
    }, [
        apiRef
    ]);
    /**
   * Goes to the first row of the grid
   */ const navigateToStart = $acw62.useCallback(()=>{
        const paginationModel = (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef);
        if (paginationModel.page !== 0) apiRef.current.setPage(0);
        // If the page was not changed it might be needed to scroll to the top
        const scrollPosition = apiRef.current.getScrollPosition();
        if (scrollPosition.top !== 0) apiRef.current.scroll({
            top: 0
        });
    }, [
        apiRef
    ]);
    /**
   * Resets the page only if the active items or quick filter has changed from the last time.
   * This is to avoid resetting the page when the filter model is changed
   * because of and update of the operator from an item that does not have the value
   * or reseting when the filter panel is just opened
   */ const handleFilterModelChange = $acw62.useCallback((filterModel)=>{
        const currentActiveFilters = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
            // replace items with the active items
            items: (0, $51d9da8b83918212$export$c7447bfbd4ecafcc)(apiRef)
        });
        if ((0, $5ece57da2e97951f$export$78fdc9adc3f30400)(currentActiveFilters, previousFilterModel.current)) return;
        previousFilterModel.current = currentActiveFilters;
        navigateToStart();
    }, [
        apiRef,
        navigateToStart
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'viewportInnerSizeChange', handleUpdateAutoPageSize);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowCountChange', handleRowCountChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'sortModelChange', navigateToStart);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'filterModelChange', handleFilterModelChange);
    /**
   * EFFECTS
   */ const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (!props.pagination) return;
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                    paginationModel: $59c9ca30cf4d11cd$export$16d1dc8477d07e4(state.pagination, props.signature, props.paginationModel)
                })
            }));
    }, [
        apiRef,
        props.paginationModel,
        props.signature,
        props.pagination
    ]);
    $acw62.useEffect(()=>{
        apiRef.current.setState((state)=>{
            const isEnabled = props.pagination === true;
            if (state.pagination.paginationMode === props.paginationMode && state.pagination.enabled === isEnabled) return state;
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                    paginationMode: props.paginationMode,
                    enabled: isEnabled
                })
            });
        });
    }, [
        apiRef,
        props.paginationMode,
        props.pagination
    ]);
    $acw62.useEffect(handleUpdateAutoPageSize, [
        handleUpdateAutoPageSize
    ]);
};







'use client';
function $921d2aba9b9d3a7e$var$raf() {
    return new Promise((resolve)=>{
        requestAnimationFrame(()=>{
            resolve();
        });
    });
}
function $921d2aba9b9d3a7e$var$buildPrintWindow(title) {
    const iframeEl = document.createElement('iframe');
    iframeEl.style.position = 'absolute';
    iframeEl.style.width = '0px';
    iframeEl.style.height = '0px';
    iframeEl.title = title || document.title;
    return iframeEl;
}
const $921d2aba9b9d3a7e$export$41205b2521d4edd4 = (apiRef, props)=>{
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridPrintExport');
    const doc = $acw62.useRef(null);
    const previousGridState = $acw62.useRef(null);
    const previousColumnVisibility = $acw62.useRef({});
    const previousRows = $acw62.useRef([]);
    const previousVirtualizationState = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        doc.current = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
    }, [
        apiRef,
        hasRootReference
    ]);
    // Returns a promise because updateColumns triggers state update and
    // the new state needs to be in place before the grid can be sized correctly
    const updateGridColumnsForPrint = $acw62.useCallback((fields, allColumns, includeCheckboxes)=>new Promise((resolve)=>{
            const exportedColumnFields = (0, $1319f3d8c75c728d$export$c5c7f3bb5f79a15d)({
                apiRef: apiRef,
                options: {
                    fields: fields,
                    allColumns: allColumns
                }
            }).map((column)=>column.field);
            const columns = (0, $1781ebe27505055c$export$da85f06e3c19f1fd)(apiRef);
            const newColumnVisibilityModel = {};
            columns.forEach((column)=>{
                newColumnVisibilityModel[column.field] = exportedColumnFields.includes(column.field);
            });
            if (includeCheckboxes) newColumnVisibilityModel[(0, $fa1dc905b3e7910f$export$b2e9ab6103a664ad).field] = true;
            apiRef.current.setColumnVisibilityModel(newColumnVisibilityModel);
            resolve();
        }), [
        apiRef
    ]);
    const updateGridRowsForPrint = $acw62.useCallback((getRowsToExport)=>{
        const rowsToExportIds = getRowsToExport({
            apiRef: apiRef
        });
        const newRows = rowsToExportIds.reduce((acc, id)=>{
            const row = apiRef.current.getRow(id);
            if (!row[0, $4ab53eafabc4b920$export$e8632b32bb8837db]) acc.push(row);
            return acc;
        }, []);
        apiRef.current.setRows(newRows);
    }, [
        apiRef
    ]);
    const handlePrintWindowLoad = $acw62.useCallback((printWindow, options)=>{
        const normalizeOptions = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            copyStyles: true,
            hideToolbar: false,
            hideFooter: false,
            includeCheckboxes: false
        }, options);
        const printDoc = printWindow.contentDocument;
        if (!printDoc) return;
        const rowsMeta = (0, $a2b185594e10a6a1$export$4f32bfc70efeb4ab)(apiRef);
        const gridRootElement = apiRef.current.rootElementRef.current;
        const gridClone = gridRootElement.cloneNode(true);
        // Allow to overflow to not hide the border of the last row
        const gridMain = gridClone.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).main}`);
        gridMain.style.overflow = 'visible';
        // See https://support.google.com/chrome/thread/191619088?hl=en&msgid=193009642
        gridClone.style.contain = 'size';
        let gridToolbarElementHeight = gridRootElement.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).toolbar}`)?.offsetHeight || 0;
        let gridFooterElementHeight = gridRootElement.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).footerContainer}`)?.offsetHeight || 0;
        const gridFooterElement = gridClone.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).footerContainer}`);
        if (normalizeOptions.hideToolbar) {
            gridClone.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).toolbar}`)?.remove();
            gridToolbarElementHeight = 0;
        }
        if (normalizeOptions.hideFooter && gridFooterElement) {
            gridFooterElement.remove();
            gridFooterElementHeight = 0;
        }
        // Expand container height to accommodate all rows
        const computedTotalHeight = rowsMeta.currentPageTotalHeight + (0, $7560da5e35f787e6$export$659109c29172602f)(apiRef, props) + gridToolbarElementHeight + gridFooterElementHeight;
        gridClone.style.height = `${computedTotalHeight}px`;
        // The height above does not include grid border width, so we need to exclude it
        gridClone.style.boxSizing = 'content-box';
        if (!normalizeOptions.hideFooter && gridFooterElement) {
            // the footer is always being placed at the bottom of the page as if all rows are exported
            // so if getRowsToExport is being used to only export a subset of rows then we need to
            // adjust the footer position to be correctly placed at the bottom of the grid
            gridFooterElement.style.position = 'absolute';
            gridFooterElement.style.width = '100%';
            gridFooterElement.style.top = `${computedTotalHeight - gridFooterElementHeight}px`;
        }
        // printDoc.body.appendChild(gridClone); should be enough but a clone isolation bug in Safari
        // prevents us to do it
        const container = document.createElement('div');
        container.appendChild(gridClone);
        // To avoid an empty page in start on Chromium based browsers
        printDoc.body.style.marginTop = '0px';
        printDoc.body.innerHTML = container.innerHTML;
        const defaultPageStyle = typeof normalizeOptions.pageStyle === 'function' ? normalizeOptions.pageStyle() : normalizeOptions.pageStyle;
        if (typeof defaultPageStyle === 'string') {
            // TODO custom styles should always win
            const styleElement = printDoc.createElement('style');
            styleElement.appendChild(printDoc.createTextNode(defaultPageStyle));
            printDoc.head.appendChild(styleElement);
        }
        if (normalizeOptions.bodyClassName) printDoc.body.classList.add(...normalizeOptions.bodyClassName.split(' '));
        let stylesheetLoadPromises = [];
        if (normalizeOptions.copyStyles) {
            const rootCandidate = gridRootElement.getRootNode();
            const root = rootCandidate.constructor.name === 'ShadowRoot' ? rootCandidate : doc.current;
            stylesheetLoadPromises = (0, $a3689efd757d1d61$export$c6b5bed05c215de5)(printDoc, root);
        }
        // wait for remote stylesheets to load
        Promise.all(stylesheetLoadPromises).then(()=>{
            printWindow.contentWindow.print();
        });
    }, [
        apiRef,
        doc,
        props
    ]);
    const handlePrintWindowAfterPrint = $acw62.useCallback((printWindow)=>{
        // Remove the print iframe
        doc.current.body.removeChild(printWindow);
        // Revert grid to previous state
        apiRef.current.restoreState(previousGridState.current || {});
        if (!previousGridState.current?.columns?.columnVisibilityModel) // if the apiRef.current.exportState(); did not exported the column visibility, we update it
        apiRef.current.setColumnVisibilityModel(previousColumnVisibility.current);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                virtualization: previousVirtualizationState.current
            }));
        apiRef.current.setRows(previousRows.current);
        // Clear local state
        previousGridState.current = null;
        previousColumnVisibility.current = {};
        previousRows.current = [];
    }, [
        apiRef
    ]);
    const exportDataAsPrint = $acw62.useCallback(async (options)=>{
        logger.debug(`Export data as Print`);
        if (!apiRef.current.rootElementRef.current) throw new Error('MUI X: No grid root element available.');
        previousGridState.current = apiRef.current.exportState();
        // It appends that the visibility model is not exported, especially if columnVisibility is not controlled
        previousColumnVisibility.current = (0, $1781ebe27505055c$export$eb0d33595fe29bb4)(apiRef);
        previousRows.current = apiRef.current.getSortedRows().filter((row)=>!row[0, $4ab53eafabc4b920$export$e8632b32bb8837db]);
        if (props.pagination) {
            const visibleRowCount = (0, $51d9da8b83918212$export$96919017bbfaec0d)(apiRef);
            const paginationModel = {
                page: 0,
                pageSize: visibleRowCount
            };
            apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                        paginationModel: (0, $59c9ca30cf4d11cd$export$16d1dc8477d07e4)(state.pagination, // Using signature `DataGridPro` to allow more than 100 rows in the print export
                        'DataGridPro', paginationModel)
                    })
                }));
        }
        previousVirtualizationState.current = apiRef.current.state.virtualization;
        apiRef.current.unstable_setVirtualization(false);
        await updateGridColumnsForPrint(options?.fields, options?.allColumns, options?.includeCheckboxes);
        updateGridRowsForPrint(options?.getRowsToExport ?? (0, $1319f3d8c75c728d$export$99156d1572dee776));
        await $921d2aba9b9d3a7e$var$raf(); // wait for the state changes to take action
        const printWindow = $921d2aba9b9d3a7e$var$buildPrintWindow(options?.fileName);
        printWindow.onload = ()=>{
            handlePrintWindowLoad(printWindow, options);
            const mediaQueryList = printWindow.contentWindow.matchMedia('print');
            mediaQueryList.addEventListener('change', (mql)=>{
                const isAfterPrint = mql.matches === false;
                if (isAfterPrint) handlePrintWindowAfterPrint(printWindow);
            });
        };
        doc.current.body.appendChild(printWindow);
    }, [
        props,
        logger,
        apiRef,
        handlePrintWindowLoad,
        handlePrintWindowAfterPrint,
        updateGridColumnsForPrint,
        updateGridRowsForPrint
    ]);
    const printExportApi = {
        exportDataAsPrint: exportDataAsPrint
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, printExportApi, 'public');
    /**
   * PRE-PROCESSING
   */ const addExportMenuButtons = $acw62.useCallback((initialValue, options)=>{
        if (options.printOptions?.disableToolbarButton) return initialValue;
        return [
            ...initialValue,
            {
                component: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59b065a027d02e77$export$a6cd094b30f69b92), {
                    options: options.printOptions
                }),
                componentName: 'printExport'
            }
        ];
    }, []);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportMenu', addExportMenuButtons);
};




var $acw62 = parcelRequire("acw62");















var $acw62 = parcelRequire("acw62");

'use client';
const $0e27fd6eb449426d$export$102a3f5a042c47c4 = (apiRef, strategyName, group, processor)=>{
    const registerPreProcessor = $acw62.useCallback(()=>{
        apiRef.current.registerStrategyProcessor(strategyName, group, processor);
    }, [
        apiRef,
        processor,
        group,
        strategyName
    ]);
    (0, $ed0481f6b43b34b3$export$c5623aa1c38918b6)(()=>{
        registerPreProcessor();
    });
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
        else registerPreProcessor();
    }, [
        registerPreProcessor
    ]);
};




const $2d580c76b635f021$export$a3e5a984fe72a5db = (state, props, apiRef)=>{
    const filterModel = props.filterModel ?? props.initialState?.filter?.filterModel ?? (0, $943740e60fd58c10$export$7ea23129b8e10cdb)();
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        filter: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            filterModel: (0, $376859af45b845ed$export$2a370a0aad2ac7e1)(filterModel, props.disableMultipleColumnsFiltering, apiRef)
        }, (0, $943740e60fd58c10$export$f5e27122a659c0c)),
        visibleRowsLookup: {}
    });
};
const $2d580c76b635f021$var$getVisibleRowsLookup = (params)=>{
    // For flat tree, the `visibleRowsLookup` and the `filteredRowsLookup` are equals since no row is collapsed.
    return params.filteredRowsLookup;
};
function $2d580c76b635f021$var$getVisibleRowsLookupState(apiRef, state) {
    return apiRef.current.applyStrategyProcessor('visibleRowsLookupCreation', {
        tree: state.rows.tree,
        filteredRowsLookup: state.filter.filteredRowsLookup
    });
}
function $2d580c76b635f021$var$createMemoizedValues() {
    return (0, $310dad19a2812331$export$d8ead1d92249919b)(Object.values);
}
const $2d580c76b635f021$export$42838275cbf666c4 = (apiRef, props, configuration)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridFilter');
    apiRef.current.registerControlState({
        stateId: 'filter',
        propModel: props.filterModel,
        propOnChange: props.onFilterModelChange,
        stateSelector: (0, $51d9da8b83918212$export$280aedb9454597a5),
        changeEvent: 'filterModelChange'
    });
    const updateFilteredRows = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
            const filterState = apiRef.current.getFilterState(filterModel);
            const newState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                filter: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.filter, filterState)
            });
            const visibleRowsLookupState = $2d580c76b635f021$var$getVisibleRowsLookupState(apiRef, newState);
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newState, {
                visibleRowsLookup: visibleRowsLookupState
            });
        });
        apiRef.current.publishEvent('filteredRowsSet');
    }, [
        apiRef
    ]);
    const addColumnMenuItem = $acw62.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.filterable === false || props.disableColumnFilter) return columnMenuItems;
        return [
            ...columnMenuItems,
            'columnMenuFilterItem'
        ];
    }, [
        props.disableColumnFilter
    ]);
    /**
   * API METHODS
   */ const upsertFilterItem = $acw62.useCallback((item)=>{
        const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        const items = [
            ...filterModel.items
        ];
        const itemIndex = items.findIndex((filterItem)=>filterItem.id === item.id);
        if (itemIndex === -1) items.push(item);
        else items[itemIndex] = item;
        apiRef.current.setFilterModel((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
            items: items
        }), 'upsertFilterItem');
    }, [
        apiRef
    ]);
    const upsertFilterItems = $acw62.useCallback((items)=>{
        const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        const existingItems = [
            ...filterModel.items
        ];
        items.forEach((item)=>{
            const itemIndex = existingItems.findIndex((filterItem)=>filterItem.id === item.id);
            if (itemIndex === -1) existingItems.push(item);
            else existingItems[itemIndex] = item;
        });
        apiRef.current.setFilterModel((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
            items: existingItems
        }), 'upsertFilterItems');
    }, [
        apiRef
    ]);
    const deleteFilterItem = $acw62.useCallback((itemToDelete)=>{
        const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        const items = filterModel.items.filter((item)=>item.id !== itemToDelete.id);
        if (items.length === filterModel.items.length) return;
        apiRef.current.setFilterModel((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
            items: items
        }), 'deleteFilterItem');
    }, [
        apiRef
    ]);
    const showFilterPanel = $acw62.useCallback((targetColumnField, panelId, labelId)=>{
        logger.debug('Displaying filter panel');
        if (targetColumnField) {
            const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
            const filterItemsWithValue = filterModel.items.filter((item)=>{
                if (item.value !== undefined) {
                    // Some filters like `isAnyOf` support array as `item.value`.
                    // If array is empty, we want to remove it from the filter model.
                    if (Array.isArray(item.value) && item.value.length === 0) return false;
                    return true;
                }
                const column = apiRef.current.getColumn(item.field);
                const filterOperator = column.filterOperators?.find((operator)=>operator.value === item.operator);
                const requiresFilterValue = typeof filterOperator?.requiresFilterValue === 'undefined' ? true : filterOperator?.requiresFilterValue;
                // Operators like `isEmpty` don't have and don't require `item.value`.
                // So we don't want to remove them from the filter model if `item.value === undefined`.
                // See https://github.com/mui/mui-x/issues/5402
                if (requiresFilterValue) return false;
                return true;
            });
            let newFilterItems;
            const filterItemOnTarget = filterItemsWithValue.find((item)=>item.field === targetColumnField);
            const targetColumn = apiRef.current.getColumn(targetColumnField);
            if (filterItemOnTarget) newFilterItems = filterItemsWithValue;
            else if (props.disableMultipleColumnsFiltering) newFilterItems = [
                (0, $376859af45b845ed$export$eb76493d113de092)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            else newFilterItems = [
                ...filterItemsWithValue,
                (0, $376859af45b845ed$export$eb76493d113de092)({
                    field: targetColumnField,
                    operator: targetColumn.filterOperators[0].value
                }, apiRef)
            ];
            apiRef.current.setFilterModel((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
                items: newFilterItems
            }));
        }
        apiRef.current.showPreferences((0, $e38c9af0748d9173$export$e7e5652452e44b).filters, panelId, labelId);
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const hideFilterPanel = $acw62.useCallback(()=>{
        logger.debug('Hiding filter panel');
        apiRef.current.hidePreferences();
    }, [
        apiRef,
        logger
    ]);
    const setFilterLogicOperator = $acw62.useCallback((logicOperator)=>{
        const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        if (filterModel.logicOperator === logicOperator) return;
        apiRef.current.setFilterModel((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
            logicOperator: logicOperator
        }), 'changeLogicOperator');
    }, [
        apiRef
    ]);
    const setQuickFilterValues = $acw62.useCallback((values)=>{
        const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        if ((0, $5ece57da2e97951f$export$78fdc9adc3f30400)(filterModel.quickFilterValues, values)) return;
        apiRef.current.setFilterModel((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
            quickFilterValues: [
                ...values
            ]
        }));
    }, [
        apiRef
    ]);
    const setFilterModel = $acw62.useCallback((model, reason)=>{
        const currentModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        if (currentModel !== model) {
            logger.debug('Setting filter model');
            apiRef.current.updateControlState('filter', (0, $376859af45b845ed$export$f4189e6c713e6dd8)(model, props.disableMultipleColumnsFiltering, apiRef), reason);
            apiRef.current.unstable_applyFilters();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsFiltering
    ]);
    const getFilterState = $acw62.useCallback((inputFilterModel)=>{
        const filterModel = (0, $376859af45b845ed$export$2a370a0aad2ac7e1)(inputFilterModel, props.disableMultipleColumnsFiltering, apiRef);
        const filterValueGetter = configuration.hooks.useFilterValueGetter(apiRef, props);
        const isRowMatchingFilters = props.filterMode === 'client' ? (0, $376859af45b845ed$export$1c795c7c9654905e)(filterModel, filterValueGetter, apiRef, props.disableEval) : null;
        const filterResult = apiRef.current.applyStrategyProcessor('filtering', {
            isRowMatchingFilters: isRowMatchingFilters,
            filterModel: filterModel ?? (0, $943740e60fd58c10$export$7ea23129b8e10cdb)(),
            filterValueGetter: filterValueGetter
        });
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterResult, {
            filterModel: filterModel
        });
    }, [
        apiRef,
        configuration.hooks,
        props
    ]);
    const filterApi = {
        setFilterLogicOperator: setFilterLogicOperator,
        unstable_applyFilters: updateFilteredRows,
        deleteFilterItem: deleteFilterItem,
        upsertFilterItem: upsertFilterItem,
        upsertFilterItems: upsertFilterItems,
        setFilterModel: setFilterModel,
        showFilterPanel: showFilterPanel,
        hideFilterPanel: hideFilterPanel,
        setQuickFilterValues: setQuickFilterValues,
        ignoreDiacritics: props.ignoreDiacritics,
        getFilterState: getFilterState
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, filterApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const filterModelToExport = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        // Remove the additional `fromInput` property from the filter model
        filterModelToExport.items.forEach((item)=>{
            delete item.fromInput;
        });
        const shouldExportFilterModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.filterModel != null || // Always export if the model has been initialized
        props.initialState?.filter?.filterModel != null || // Export if the model is not equal to the default value
        !(0, $5ece57da2e97951f$export$78fdc9adc3f30400)(filterModelToExport, (0, $943740e60fd58c10$export$7ea23129b8e10cdb)());
        if (!shouldExportFilterModel) return prevState;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            filter: {
                filterModel: filterModelToExport
            }
        });
    }, [
        apiRef,
        props.filterModel,
        props.initialState?.filter?.filterModel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const filterModel = context.stateToRestore.filter?.filterModel;
        if (filterModel == null) return params;
        apiRef.current.updateControlState('filter', (0, $376859af45b845ed$export$f4189e6c713e6dd8)(filterModel, props.disableMultipleColumnsFiltering, apiRef), 'restoreState');
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.unstable_applyFilters
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsFiltering
    ]);
    const preferencePanelPreProcessing = $acw62.useCallback((initialValue, value)=>{
        if (value === (0, $e38c9af0748d9173$export$e7e5652452e44b).filters) {
            const FilterPanel = props.slots.filterPanel;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FilterPanel, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props.slotProps?.filterPanel));
        }
        return initialValue;
    }, [
        props.slots.filterPanel,
        props.slotProps?.filterPanel
    ]);
    const { getRowId: getRowId } = props;
    const getRowsRef = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($2d580c76b635f021$var$createMemoizedValues);
    const flatFilteringMethod = $acw62.useCallback((params)=>{
        if (props.filterMode !== 'client' || !params.isRowMatchingFilters || !params.filterModel.items.length && !params.filterModel.quickFilterValues?.length) return 0, $943740e60fd58c10$export$f5e27122a659c0c;
        const dataRowIdToModelLookup = (0, $4fc0d4cb0e570e63$export$37767f9110c99048)(apiRef);
        const filteredRowsLookup = {};
        const { isRowMatchingFilters: isRowMatchingFilters } = params;
        const filterCache = {};
        const result = {
            passingFilterItems: null,
            passingQuickFilterValues: null
        };
        const rows = getRowsRef.current(apiRef.current.state.rows.dataRowIdToModelLookup);
        for(let i = 0; i < rows.length; i += 1){
            const row = rows[i];
            const id = getRowId ? getRowId(row) : row.id;
            isRowMatchingFilters(row, undefined, result);
            const isRowPassing = (0, $376859af45b845ed$export$8d82b4490466f182)([
                result.passingFilterItems
            ], [
                result.passingQuickFilterValues
            ], params.filterModel, params.filterValueGetter, apiRef, filterCache);
            if (!isRowPassing) filteredRowsLookup[id] = isRowPassing;
        }
        const footerId = 'auto-generated-group-footer-root';
        const footer = dataRowIdToModelLookup[footerId];
        if (footer) filteredRowsLookup[footerId] = true;
        return {
            filteredRowsLookup: filteredRowsLookup,
            filteredChildrenCountLookup: {},
            filteredDescendantCountLookup: {}
        };
    }, [
        apiRef,
        props.filterMode,
        getRowId,
        getRowsRef
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'preferencePanel', preferencePanelPreProcessing);
    (0, $0e27fd6eb449426d$export$102a3f5a042c47c4)(apiRef, (0, $9e68111fb02b49e8$export$84214fbf04c4094), 'filtering', flatFilteringMethod);
    (0, $0e27fd6eb449426d$export$102a3f5a042c47c4)(apiRef, (0, $9e68111fb02b49e8$export$84214fbf04c4094), 'visibleRowsLookupCreation', $2d580c76b635f021$var$getVisibleRowsLookup);
    /**
   * EVENTS
   */ const handleColumnsChange = $acw62.useCallback(()=>{
        logger.debug('onColUpdated - GridColumns changed, applying filters');
        const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        const columnsLookup = (0, $1781ebe27505055c$export$8a3a9a6db584d7fd)(apiRef);
        const newFilterItems = filterModel.items.filter((item)=>item.field && columnsLookup[item.field]);
        if (newFilterItems.length < filterModel.items.length) apiRef.current.setFilterModel((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
            items: newFilterItems
        }));
    }, [
        apiRef,
        logger
    ]);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (methodName === 'filtering') apiRef.current.unstable_applyFilters();
    }, [
        apiRef
    ]);
    const updateVisibleRowsLookupState = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                visibleRowsLookup: $2d580c76b635f021$var$getVisibleRowsLookupState(apiRef, state)
            });
        });
    }, [
        apiRef
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowsSet', updateFilteredRows);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowExpansionChange', updateVisibleRowsLookupState);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnVisibilityModelChange', ()=>{
        const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        if (filterModel.quickFilterValues?.length && (0, $376859af45b845ed$export$cabca178b367efe0)(filterModel)) // re-apply filters because the quick filter results may have changed
        updateFilteredRows();
    });
    /**
   * 1ST RENDER
   */ (0, $ed0481f6b43b34b3$export$c5623aa1c38918b6)(()=>{
        updateFilteredRows();
    });
    /**
   * EFFECTS
   */ (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (props.filterModel !== undefined) apiRef.current.setFilterModel(props.filterModel);
    }, [
        apiRef,
        logger,
        props.filterModel
    ]);
};




var $acw62 = parcelRequire("acw62");












'use client';
const $8ed6099d59a73278$export$bfde38b067fac467 = (state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        focus: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        },
        tabIndex: {
            cell: null,
            columnHeader: null,
            columnHeaderFilter: null,
            columnGroupHeader: null
        }
    });
const $8ed6099d59a73278$export$8b69791fef06a777 = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridFocus');
    const lastClickedCell = $acw62.useRef(null);
    const hasRootReference = apiRef.current.rootElementRef.current !== null;
    const publishCellFocusOut = $acw62.useCallback((cell, event)=>{
        if (cell) // The row might have been deleted
        {
            if (apiRef.current.getRow(cell.id)) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        }
    }, [
        apiRef
    ]);
    const setCellFocus = $acw62.useCallback((id, field)=>{
        const focusedCell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        if (focusedCell?.id === id && focusedCell?.field === field) return;
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on cell with id=${id} and field=${field}`);
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                },
                focus: {
                    cell: {
                        id: id,
                        field: field
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            });
        });
        // The row might have been deleted
        if (!apiRef.current.getRow(id)) return;
        if (focusedCell) // There's a focused cell but another cell was clicked
        // Publishes an event to notify that the focus was lost
        publishCellFocusOut(focusedCell, {});
        apiRef.current.publishEvent('cellFocusIn', apiRef.current.getCellParams(id, field));
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFocus = $acw62.useCallback((field, event = {})=>{
        const cell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header with colIndex=${field}`);
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: {
                        field: field
                    },
                    columnHeaderFilter: null,
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnHeaderFilterFocus = $acw62.useCallback((field, event = {})=>{
        const cell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        publishCellFocusOut(cell, event);
        apiRef.current.setState((state)=>{
            logger.debug(`Focusing on column header filter with colIndex=${field}`);
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                },
                focus: {
                    columnHeader: null,
                    columnHeaderFilter: {
                        field: field
                    },
                    cell: null,
                    columnGroupHeader: null
                }
            });
        });
    }, [
        apiRef,
        logger,
        publishCellFocusOut
    ]);
    const setColumnGroupHeaderFocus = $acw62.useCallback((field, depth, event = {})=>{
        const cell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        if (cell) apiRef.current.publishEvent('cellFocusOut', apiRef.current.getCellParams(cell.id, cell.field), event);
        apiRef.current.setState((state)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                },
                focus: {
                    columnGroupHeader: {
                        field: field,
                        depth: depth
                    },
                    columnHeader: null,
                    columnHeaderFilter: null,
                    cell: null
                }
            });
        });
    }, [
        apiRef
    ]);
    const getColumnGroupHeaderFocus = $acw62.useCallback(()=>(0, $578d1f15adc16cb4$export$3eeedc3f7263df61)(apiRef), [
        apiRef
    ]);
    const moveFocusToRelativeCell = $acw62.useCallback((id, field, direction)=>{
        let columnIndexToFocus = apiRef.current.getColumnIndex(field);
        const visibleColumns = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef);
        const currentPage = (0, $2b6a1e01125c3822$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const pinnedRows = (0, $4fc0d4cb0e570e63$export$ffe7071c481e32b0)(apiRef);
        // Include pinned rows as well
        const currentPageRows = [].concat(pinnedRows.top || [], currentPage.rows, pinnedRows.bottom || []);
        let rowIndexToFocus = currentPageRows.findIndex((row)=>row.id === id);
        if (direction === 'right') columnIndexToFocus += 1;
        else if (direction === 'left') columnIndexToFocus -= 1;
        else rowIndexToFocus += 1;
        if (columnIndexToFocus >= visibleColumns.length) {
            // Go to next row if we are after the last column
            rowIndexToFocus += 1;
            if (rowIndexToFocus < currentPageRows.length) // Go to first column of the next row if there's one more row
            columnIndexToFocus = 0;
        } else if (columnIndexToFocus < 0) {
            // Go to previous row if we are before the first column
            rowIndexToFocus -= 1;
            if (rowIndexToFocus >= 0) // Go to last column of the previous if there's one more row
            columnIndexToFocus = visibleColumns.length - 1;
        }
        rowIndexToFocus = (0, $07a64ebfd26f4296$export$7d15b64cf5a3a4c4)(rowIndexToFocus, 0, currentPageRows.length - 1);
        const rowToFocus = currentPageRows[rowIndexToFocus];
        if (!rowToFocus) return;
        const colSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowToFocus.id, columnIndexToFocus);
        if (colSpanInfo && colSpanInfo.spannedByColSpan) {
            if (direction === 'left' || direction === 'below') columnIndexToFocus = colSpanInfo.leftVisibleCellIndex;
            else if (direction === 'right') columnIndexToFocus = colSpanInfo.rightVisibleCellIndex;
        }
        columnIndexToFocus = (0, $07a64ebfd26f4296$export$7d15b64cf5a3a4c4)(columnIndexToFocus, 0, visibleColumns.length - 1);
        const columnToFocus = visibleColumns[columnIndexToFocus];
        apiRef.current.setCellFocus(rowToFocus.id, columnToFocus.field);
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handleCellDoubleClick = $acw62.useCallback(({ id: id, field: field })=>{
        apiRef.current.setCellFocus(id, field);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // GRID_CELL_NAVIGATION_KEY_DOWN handles the focus on Enter, Tab and navigation keys
        if (event.key === 'Enter' || event.key === 'Tab' || event.key === 'Shift' || (0, $2c033a607636d88a$export$e13d96c38a470518)(event.key)) return;
        apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleColumnHeaderFocus = $acw62.useCallback(({ field: field }, event)=>{
        if (event.target !== event.currentTarget) return;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef
    ]);
    const handleColumnGroupHeaderFocus = $acw62.useCallback(({ fields: fields, depth: depth }, event)=>{
        if (event.target !== event.currentTarget) return;
        const focusedColumnGroup = (0, $578d1f15adc16cb4$export$3eeedc3f7263df61)(apiRef);
        if (focusedColumnGroup !== null && focusedColumnGroup.depth === depth && fields.includes(focusedColumnGroup.field)) // This group cell has already been focused
        return;
        apiRef.current.setColumnGroupHeaderFocus(fields[0], depth, event);
    }, [
        apiRef
    ]);
    const handleBlur = $acw62.useCallback((_, event)=>{
        if (event.relatedTarget?.getAttribute('class')?.includes((0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader)) return;
        logger.debug(`Clearing focus`);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                focus: {
                    cell: null,
                    columnHeader: null,
                    columnHeaderFilter: null,
                    columnGroupHeader: null
                }
            }));
    }, [
        logger,
        apiRef
    ]);
    const handleCellMouseDown = $acw62.useCallback((params)=>{
        lastClickedCell.current = params;
    }, []);
    const handleDocumentClick = $acw62.useCallback((event)=>{
        const cellParams = lastClickedCell.current;
        lastClickedCell.current = null;
        const focusedCell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        if (!focusedCell) {
            if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
            return;
        }
        if (cellParams?.id === focusedCell.id && cellParams?.field === focusedCell.field) return;
        const cellElement = apiRef.current.getCellElement(focusedCell.id, focusedCell.field);
        if (cellElement?.contains(event.target)) return;
        if (cellParams) apiRef.current.setCellFocus(cellParams.id, cellParams.field);
        else {
            apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    focus: {
                        cell: null,
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
            // There's a focused cell but another element (not a cell) was clicked
            // Publishes an event to notify that the focus was lost
            publishCellFocusOut(focusedCell, event);
        }
    }, [
        apiRef,
        publishCellFocusOut
    ]);
    const handleCellModeChange = $acw62.useCallback((params)=>{
        if (params.cellMode === 'view') return;
        const cell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        if (cell?.id !== params.id || cell?.field !== params.field) apiRef.current.setCellFocus(params.id, params.field);
    }, [
        apiRef
    ]);
    const handleRowSet = $acw62.useCallback(()=>{
        const cell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        // If the focused cell is in a row which does not exist anymore,
        // focus previous row or remove the focus
        if (cell && !apiRef.current.getRow(cell.id)) {
            const lastFocusedRowId = cell.id;
            let nextRowId = null;
            if (typeof lastFocusedRowId !== 'undefined') {
                const rowEl = apiRef.current.getRowElement(lastFocusedRowId);
                const lastFocusedRowIndex = rowEl?.dataset.rowindex ? Number(rowEl?.dataset.rowindex) : 0;
                const currentPage = (0, $2b6a1e01125c3822$export$79b9fa322a34430b)(apiRef, {
                    pagination: props.pagination,
                    paginationMode: props.paginationMode
                });
                const nextRow = currentPage.rows[(0, $07a64ebfd26f4296$export$7d15b64cf5a3a4c4)(lastFocusedRowIndex, 0, currentPage.rows.length - 1)];
                nextRowId = nextRow?.id ?? null;
            }
            apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    focus: {
                        cell: nextRowId === null ? null : {
                            id: nextRowId,
                            field: cell.field
                        },
                        columnHeader: null,
                        columnHeaderFilter: null,
                        columnGroupHeader: null
                    }
                }));
        }
    }, [
        apiRef,
        props.pagination,
        props.paginationMode
    ]);
    const handlePaginationModelChange = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const currentFocusedCell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        if (!currentFocusedCell) return;
        const currentPage = (0, $2b6a1e01125c3822$export$79b9fa322a34430b)(apiRef, {
            pagination: props.pagination,
            paginationMode: props.paginationMode
        });
        const rowIsInCurrentPage = currentPage.rows.find((row)=>row.id === currentFocusedCell.id);
        if (rowIsInCurrentPage || currentPage.rows.length === 0) return;
        const visibleColumns = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef);
        apiRef.current.setState((state)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                tabIndex: {
                    cell: {
                        id: currentPage.rows[0].id,
                        field: visibleColumns[0].field
                    },
                    columnGroupHeader: null,
                    columnHeader: null,
                    columnHeaderFilter: null
                }
            });
        });
    });
    const focusApi = {
        setCellFocus: setCellFocus,
        setColumnHeaderFocus: setColumnHeaderFocus,
        setColumnHeaderFilterFocus: setColumnHeaderFilterFocus
    };
    const focusPrivateApi = {
        moveFocusToRelativeCell: moveFocusToRelativeCell,
        setColumnGroupHeaderFocus: setColumnGroupHeaderFocus,
        getColumnGroupHeaderFocus: getColumnGroupHeaderFocus
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, focusApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, focusPrivateApi, 'private');
    $acw62.useEffect(()=>{
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.addEventListener('mouseup', handleDocumentClick);
        return ()=>{
            doc.removeEventListener('mouseup', handleDocumentClick);
        };
    }, [
        apiRef,
        hasRootReference,
        handleDocumentClick
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderBlur', handleBlur);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellDoubleClick', handleCellDoubleClick);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellMouseDown', handleCellMouseDown);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellKeyDown', handleCellKeyDown);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellModeChange', handleCellModeChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderFocus', handleColumnHeaderFocus);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnGroupHeaderFocus', handleColumnGroupHeaderFocus);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowsSet', handleRowSet);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'paginationModelChange', handlePaginationModelChange);
};



var $acw62 = parcelRequire("acw62");



const $734c0c465b6331e7$export$2c704fed6d7c53ee = (groupingColDefField)=>{
    const match = groupingColDefField.match(/^__row_group_by_columns_group_(.*)__$/);
    if (!match) return null;
    return match[1];
};
const $734c0c465b6331e7$export$452ffe3c6554619d = (field)=>field === (0, $d6d7a429fd810b6e$export$bc5b5ba34587442e) || $734c0c465b6331e7$export$2c704fed6d7c53ee(field) !== null;















function $b2637ba08a26ef7b$export$c8be9a8325efa7ee(element) {
    return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
function $b2637ba08a26ef7b$export$2a63f1401414fc1a(elem, className) {
    return elem.closest(`.${className}`);
}
function $b2637ba08a26ef7b$export$77eab2954df72e62(operand) {
    return operand.replace(/["\\]/g, '\\$&');
}
function $b2637ba08a26ef7b$export$94318ffb75913a0b(root, field) {
    return root.querySelector(`[role="columnheader"][data-field="${$b2637ba08a26ef7b$export$77eab2954df72e62(field)}"]`);
}
function $b2637ba08a26ef7b$var$getGridRowElementSelector(id) {
    return `.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).row}[data-id="${$b2637ba08a26ef7b$export$77eab2954df72e62(String(id))}"]`;
}
function $b2637ba08a26ef7b$export$9bc8bb868a922a5f(root, id) {
    return root.querySelector($b2637ba08a26ef7b$var$getGridRowElementSelector(id));
}
function $b2637ba08a26ef7b$export$44827662627a59(root, { id: id, field: field }) {
    const rowSelector = $b2637ba08a26ef7b$var$getGridRowElementSelector(id);
    const cellSelector = `.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}[data-field="${$b2637ba08a26ef7b$export$77eab2954df72e62(field)}"]`;
    const selector = `${rowSelector} ${cellSelector}`;
    return root.querySelector(selector);
}
const $b2637ba08a26ef7b$export$cd4e5573fbe2b576 = (root = document)=>{
    const activeEl = root.activeElement;
    if (!activeEl) return null;
    if (activeEl.shadowRoot) return $b2637ba08a26ef7b$export$cd4e5573fbe2b576(activeEl.shadowRoot);
    return activeEl;
};
function $b2637ba08a26ef7b$export$8ce496ad3bfbe3a6(event) {
    if (// The target is not an element when triggered by a Select inside the cell
    // See https://github.com/mui/material-ui/issues/10534
    event.target.nodeType === 1 && !event.currentTarget.contains(event.target)) return true;
    return false;
}
function $b2637ba08a26ef7b$export$2c4260a98d98f894(colCellEl) {
    return colCellEl.getAttribute('data-field');
}
function $b2637ba08a26ef7b$export$a2d3aec9ff63900b(elem, field) {
    return elem.querySelector(`[data-field="${$b2637ba08a26ef7b$export$77eab2954df72e62(field)}"]`);
}
function $b2637ba08a26ef7b$export$5d6880d172f0ecbb(colCellEl) {
    return colCellEl.getAttribute('data-fields').slice(2, -2).split('-|-');
}
function $b2637ba08a26ef7b$export$1e5569d10c3ebc8b(elem, field) {
    return Array.from(elem.querySelectorAll(`[data-fields*="|-${$b2637ba08a26ef7b$export$77eab2954df72e62(field)}-|"]`) ?? []);
}
function $b2637ba08a26ef7b$export$53d8041b57f0055(col, api) {
    const root = $b2637ba08a26ef7b$export$2a63f1401414fc1a(col, (0, $59e5f6b0ce3da023$export$2100d54e36406477).root);
    if (!root) throw new Error('MUI X: The root element is not found.');
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return [];
    const colIndex = Number(ariaColIndex) - 1;
    const cells = [];
    if (!api.virtualScrollerRef?.current) return [];
    $b2637ba08a26ef7b$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        let columnIndex = colIndex;
        const cellColSpanInfo = api.unstable_getCellColSpanInfo(rowId, colIndex);
        if (cellColSpanInfo && cellColSpanInfo.spannedByColSpan) columnIndex = cellColSpanInfo.leftVisibleCellIndex;
        const cell = rowElement.querySelector(`[data-colindex="${columnIndex}"]`);
        if (cell) cells.push(cell);
    });
    return cells;
}
function $b2637ba08a26ef7b$export$c16d6f1be06f3423(api, klass) {
    return api.rootElementRef.current.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)[klass]}`);
}
const $b2637ba08a26ef7b$var$findPinnedCells = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (colIndex === null) return [];
    const cells = [];
    $b2637ba08a26ef7b$var$queryRows(api).forEach((rowElement)=>{
        const rowId = rowElement.getAttribute('data-id');
        if (!rowId) return;
        rowElement.querySelectorAll(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)[position === 'left' ? 'cell--pinnedLeft' : 'cell--pinnedRight']}`).forEach((cell)=>{
            const currentColIndex = $b2637ba08a26ef7b$var$parseCellColIndex(cell);
            if (currentColIndex !== null && filterFn(currentColIndex)) cells.push(cell);
        });
    });
    return cells;
};
function $b2637ba08a26ef7b$export$71cc5934f05ca0a1(api, col, isRtl) {
    const colIndex = $b2637ba08a26ef7b$var$parseCellColIndex(col);
    return $b2637ba08a26ef7b$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'right' : 'left',
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $b2637ba08a26ef7b$export$2eb3bec73fd25ab(api, col, isRtl) {
    const colIndex = $b2637ba08a26ef7b$var$parseCellColIndex(col);
    return $b2637ba08a26ef7b$var$findPinnedCells({
        api: api,
        colIndex: colIndex,
        position: isRtl ? 'left' : 'right',
        filterFn: (index)=>isRtl ? index > colIndex : index < colIndex
    });
}
const $b2637ba08a26ef7b$var$findPinnedHeaders = ({ api: api, colIndex: colIndex, position: position, filterFn: filterFn })=>{
    if (!api.columnHeadersContainerRef?.current) return [];
    if (colIndex === null) return [];
    const elements = [];
    api.columnHeadersContainerRef.current.querySelectorAll(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)[position === 'left' ? 'columnHeader--pinnedLeft' : 'columnHeader--pinnedRight']}`).forEach((element)=>{
        const currentColIndex = $b2637ba08a26ef7b$var$parseCellColIndex(element);
        if (currentColIndex !== null && filterFn(currentColIndex, element)) elements.push(element);
    });
    return elements;
};
function $b2637ba08a26ef7b$export$18b98bbb853bc2c4(api, col, isRtl) {
    const colIndex = $b2637ba08a26ef7b$var$parseCellColIndex(col);
    return $b2637ba08a26ef7b$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'right' : 'left',
        colIndex: colIndex,
        filterFn: (index)=>isRtl ? index < colIndex : index > colIndex
    });
}
function $b2637ba08a26ef7b$export$a2731c8163776b73(api, col, isRtl) {
    const colIndex = $b2637ba08a26ef7b$var$parseCellColIndex(col);
    return $b2637ba08a26ef7b$var$findPinnedHeaders({
        api: api,
        position: isRtl ? 'left' : 'right',
        colIndex: colIndex,
        filterFn: (index, element)=>{
            if (element.classList.contains((0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--last'])) return false;
            return isRtl ? index > colIndex : index < colIndex;
        }
    });
}
function $b2637ba08a26ef7b$export$5c4f873e8f18904d(api, field) {
    const headers = api.columnHeadersContainerRef.current;
    return headers.querySelector(`:scope > div > [data-field="${$b2637ba08a26ef7b$export$77eab2954df72e62(field)}"][role="columnheader"]`);
}
function $b2637ba08a26ef7b$export$ee9bd404f74f7c9(api, field) {
    const container = api.virtualScrollerRef.current;
    return Array.from(container.querySelectorAll(`:scope > div > div > div > [data-field="${$b2637ba08a26ef7b$export$77eab2954df72e62(field)}"][role="gridcell"]`));
}
function $b2637ba08a26ef7b$var$queryRows(api) {
    return api.virtualScrollerRef.current.querySelectorAll(// Use > to ignore rows from nested Data Grids (for example in detail panel)
    `:scope > div > div > .${(0, $59e5f6b0ce3da023$export$2100d54e36406477).row}`);
}
function $b2637ba08a26ef7b$var$parseCellColIndex(col) {
    const ariaColIndex = col.getAttribute('aria-colindex');
    if (!ariaColIndex) return null;
    return Number(ariaColIndex) - 1;
}




const $e34a7a84ba705f98$export$7c625e86ddfff1ed = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    } else if (!isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    }
    return null;
};
const $e34a7a84ba705f98$export$21527d4fb6084929 = ({ currentColIndex: currentColIndex, firstColIndex: firstColIndex, lastColIndex: lastColIndex, isRtl: isRtl })=>{
    if (isRtl) {
        if (currentColIndex > firstColIndex) return currentColIndex - 1;
    } else if (!isRtl) {
        if (currentColIndex < lastColIndex) return currentColIndex + 1;
    }
    return null;
};
function $e34a7a84ba705f98$export$d48a7b476a2f0ae5(apiRef, rowId, colIndex, rowSpanScanDirection) {
    const rowSpanHiddenCells = (0, $4c1c3a63996032a6$export$a282c9f2bcea1074).selectors.hiddenCells(apiRef.current.virtualizer.store.state);
    if (!rowSpanHiddenCells[rowId]?.[colIndex]) return rowId;
    const filteredSortedRowIds = (0, $51d9da8b83918212$export$4e2a9d76902d271c)(apiRef);
    // find closest non row spanned cell in the given `rowSpanScanDirection`
    let nextRowIndex = filteredSortedRowIds.indexOf(rowId) + (rowSpanScanDirection === 'down' ? 1 : -1);
    while(nextRowIndex >= 0 && nextRowIndex < filteredSortedRowIds.length){
        const nextRowId = filteredSortedRowIds[nextRowIndex];
        if (!rowSpanHiddenCells[nextRowId]?.[colIndex]) return nextRowId;
        nextRowIndex += rowSpanScanDirection === 'down' ? 1 : -1;
    }
    return rowId;
}





const $e13f2e399710c6dc$var$gridVisibleRowsWithPinnedRowsSelector = (0, $24e415a76b2eb9fb$export$2a3ca4704a61d1f4)((0, $e164e26c82788fb1$export$33f627fc0fc60be4), (0, $4fc0d4cb0e570e63$export$ffe7071c481e32b0), (visibleRows, pinnedRows)=>{
    return (pinnedRows.top || []).concat(visibleRows.rows, pinnedRows.bottom || []);
});
const $e13f2e399710c6dc$export$142b8bb1fe6da473 = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridKeyboardNavigation');
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const getCurrentPageRows = $acw62.useCallback(()=>{
        return $e13f2e399710c6dc$var$gridVisibleRowsWithPinnedRowsSelector(apiRef);
    }, [
        apiRef
    ]);
    const headerFilteringEnabled = props.signature !== 'DataGrid' && props.headerFilters;
    /**
   * @param {number} colIndex Index of the column to focus
   * @param {GridRowId} rowId index of the row to focus
   * @param {string} closestColumnToUse Which closest column cell to use when the cell is spanned by `colSpan`.
   * @param {string} rowSpanScanDirection Which direction to search to find the next cell not hidden by `rowSpan`.
   * TODO replace with apiRef.current.moveFocusToRelativeCell()
   */ const goToCell = $acw62.useCallback((colIndex, rowId, closestColumnToUse = 'left', rowSpanScanDirection = 'up')=>{
        const visibleSortedRows = (0, $51d9da8b83918212$export$2f31562143a3e5d4)(apiRef);
        const nextCellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, colIndex);
        if (nextCellColSpanInfo && nextCellColSpanInfo.spannedByColSpan) {
            if (closestColumnToUse === 'left') colIndex = nextCellColSpanInfo.leftVisibleCellIndex;
            else if (closestColumnToUse === 'right') colIndex = nextCellColSpanInfo.rightVisibleCellIndex;
        }
        const field = (0, $1781ebe27505055c$export$c9491722e1d6e8d3)(apiRef)[colIndex];
        const nonRowSpannedRowId = (0, $e34a7a84ba705f98$export$d48a7b476a2f0ae5)(apiRef, rowId, colIndex, rowSpanScanDirection);
        // `scrollToIndexes` requires a rowIndex relative to all visible rows.
        // Those rows do not include pinned rows, but pinned rows do not need scroll anyway.
        const rowIndexRelativeToAllRows = visibleSortedRows.findIndex((row)=>row.id === nonRowSpannedRowId);
        logger.debug(`Navigating to cell row ${rowIndexRelativeToAllRows}, col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex,
            rowIndex: rowIndexRelativeToAllRows
        });
        apiRef.current.setCellFocus(nonRowSpannedRowId, field);
    }, [
        apiRef,
        logger
    ]);
    const goToHeader = $acw62.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToHeaderFilter = $acw62.useCallback((colIndex, event)=>{
        logger.debug(`Navigating to header filter col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const field = apiRef.current.getVisibleColumns()[colIndex].field;
        apiRef.current.setColumnHeaderFilterFocus(field, event);
    }, [
        apiRef,
        logger
    ]);
    const goToGroupHeader = $acw62.useCallback((colIndex, depth, event)=>{
        logger.debug(`Navigating to header col ${colIndex}`);
        apiRef.current.scrollToIndexes({
            colIndex: colIndex
        });
        const { field: field } = apiRef.current.getVisibleColumns()[colIndex];
        apiRef.current.setColumnGroupHeaderFocus(field, depth, event);
    }, [
        apiRef,
        logger
    ]);
    const getRowIdFromIndex = $acw62.useCallback((rowIndex)=>{
        return getCurrentPageRows()[rowIndex]?.id;
    }, [
        getCurrentPageRows
    ]);
    const handleColumnHeaderKeyDown = $acw62.useCallback((params, event)=>{
        const headerTitleNode = event.currentTarget.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainerContent}`);
        const isFromInsideContent = !!headerTitleNode && headerTitleNode.contains(event.target);
        if (isFromInsideContent && params.field !== (0, $fa1dc905b3e7910f$export$b2e9ab6103a664ad).field) // When focus is on a nested input, keyboard events have no effect to avoid conflicts with native events.
        // There is one exception for the checkBoxHeader
        return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = currentPageRows.length > 0 ? 0 : null;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef).length - 1;
        const columnGroupMaxDepth = (0, $424decc09f6745ae$export$4cf0369c079b29be)(apiRef);
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else if (firstRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(firstRowIndexInPage));
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $e34a7a84ba705f98$export$21527d4fb6084929)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeader(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $e34a7a84ba705f98$export$7c625e86ddfff1ed)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeader(leftColIndex, event);
                    break;
                }
            case 'ArrowUp':
                if (columnGroupMaxDepth > 0) goToGroupHeader(colIndexBefore, columnGroupMaxDepth - 1, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeader(firstColIndex, event);
                break;
            case 'End':
                goToHeader(lastColIndex, event);
                break;
            case 'Enter':
                if (event.ctrlKey || event.metaKey) apiRef.current.toggleColumnMenu(params.field);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToCell,
        getRowIdFromIndex,
        isRtl,
        goToHeader,
        goToGroupHeader
    ]);
    const handleHeaderFilterKeyDown = $acw62.useCallback((params, event)=>{
        const isEditing = (0, $61c7e1ee2666e841$export$d5104e3dccc7c49d)(apiRef) === params.field;
        const isHeaderMenuOpen = (0, $61c7e1ee2666e841$export$c564e60305059ea4)(apiRef) === params.field;
        if (isEditing || isHeaderMenuOpen || !(0, $2c033a607636d88a$export$e13d96c38a470518)(event.key)) return;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                {
                    const rowId = getRowIdFromIndex(firstRowIndexInPage);
                    if (firstRowIndexInPage !== null && rowId != null) goToCell(colIndexBefore, rowId);
                    break;
                }
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $e34a7a84ba705f98$export$21527d4fb6084929)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToHeaderFilter(rightColIndex, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $e34a7a84ba705f98$export$7c625e86ddfff1ed)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToHeaderFilter(leftColIndex, event);
                    else apiRef.current.setColumnHeaderFilterFocus(params.field, event);
                    break;
                }
            case 'ArrowUp':
                goToHeader(colIndexBefore, event);
                break;
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToHeaderFilter(firstColIndex, event);
                break;
            case 'End':
                goToHeaderFilter(lastColIndex, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        goToHeaderFilter,
        isRtl,
        goToHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleColumnGroupHeaderKeyDown = $acw62.useCallback((params, event)=>{
        const focusedColumnGroup = (0, $578d1f15adc16cb4$export$3eeedc3f7263df61)(apiRef);
        if (focusedColumnGroup === null) return;
        const { field: currentField, depth: currentDepth } = focusedColumnGroup;
        const { fields: fields, depth: depth, maxDepth: maxDepth } = params;
        const currentPageRows = getCurrentPageRows();
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const currentColIndex = apiRef.current.getColumnIndex(currentField);
        const colIndexBefore = currentField ? apiRef.current.getColumnIndex(currentField) : 0;
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                if (depth === maxDepth - 1) goToHeader(currentColIndex, event);
                else goToGroupHeader(currentColIndex, currentDepth + 1, event);
                break;
            case 'ArrowUp':
                if (depth > 0) goToGroupHeader(currentColIndex, currentDepth - 1, event);
                break;
            case 'ArrowRight':
                {
                    const remainingRightColumns = fields.length - fields.indexOf(currentField) - 1;
                    if (currentColIndex + remainingRightColumns + 1 <= lastColIndex) goToGroupHeader(currentColIndex + remainingRightColumns + 1, currentDepth, event);
                    break;
                }
            case 'ArrowLeft':
                {
                    const remainingLeftColumns = fields.indexOf(currentField);
                    if (currentColIndex - remainingLeftColumns - 1 >= firstColIndex) goToGroupHeader(currentColIndex - remainingLeftColumns - 1, currentDepth, event);
                    break;
                }
            case 'PageDown':
                if (firstRowIndexInPage !== null && lastRowIndexInPage !== null) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(firstRowIndexInPage + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'Home':
                goToGroupHeader(firstColIndex, currentDepth, event);
                break;
            case 'End':
                goToGroupHeader(lastColIndex, currentDepth, event);
                break;
            case ' ':
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        goToHeader,
        goToGroupHeader,
        goToCell,
        getRowIdFromIndex
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // Ignore portal
        if ((0, $b2637ba08a26ef7b$export$8ce496ad3bfbe3a6)(event)) return;
        // Get the most recent params because the cell mode may have changed by another listener
        const cellParams = apiRef.current.getCellParams(params.id, params.field);
        if (cellParams.cellMode === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit || !(0, $2c033a607636d88a$export$e13d96c38a470518)(event.key)) return;
        const canUpdateFocus = apiRef.current.unstable_applyPipeProcessors('canUpdateFocus', true, {
            event: event,
            cell: cellParams
        });
        if (!canUpdateFocus) return;
        const currentPageRows = getCurrentPageRows();
        if (currentPageRows.length === 0) return;
        const viewportPageSize = apiRef.current.getViewportPageSize();
        const colIndexBefore = params.field ? apiRef.current.getColumnIndex(params.field) : 0;
        const rowIndexBefore = currentPageRows.findIndex((row)=>row.id === params.id);
        const firstRowIndexInPage = 0;
        const lastRowIndexInPage = currentPageRows.length - 1;
        const firstColIndex = 0;
        const lastColIndex = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef).length - 1;
        let shouldPreventDefault = true;
        switch(event.key){
            case 'ArrowDown':
                // "Enter" is only triggered by the row / cell editing feature
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore + 1), isRtl ? 'right' : 'left', 'down');
                break;
            case 'ArrowUp':
                if (rowIndexBefore > firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(rowIndexBefore - 1));
                else if (headerFilteringEnabled) goToHeaderFilter(colIndexBefore, event);
                else goToHeader(colIndexBefore, event);
                break;
            case 'ArrowRight':
                {
                    const rightColIndex = (0, $e34a7a84ba705f98$export$21527d4fb6084929)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (rightColIndex !== null) goToCell(rightColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'left' : 'right');
                    break;
                }
            case 'ArrowLeft':
                {
                    const leftColIndex = (0, $e34a7a84ba705f98$export$7c625e86ddfff1ed)({
                        currentColIndex: colIndexBefore,
                        firstColIndex: firstColIndex,
                        lastColIndex: lastColIndex,
                        isRtl: isRtl
                    });
                    if (leftColIndex !== null) goToCell(leftColIndex, getRowIdFromIndex(rowIndexBefore), isRtl ? 'right' : 'left');
                    break;
                }
            case 'Tab':
                // "Tab" is only triggered by the row / cell editing feature
                if (event.shiftKey && colIndexBefore > firstColIndex) goToCell(colIndexBefore - 1, getRowIdFromIndex(rowIndexBefore), 'left');
                else if (!event.shiftKey && colIndexBefore < lastColIndex) goToCell(colIndexBefore + 1, getRowIdFromIndex(rowIndexBefore), 'right');
                break;
            case ' ':
                {
                    const field = params.field;
                    if (field === (0, $d6d7a429fd810b6e$export$6e5a576305a34719)) break;
                    const colDef = params.colDef;
                    if (colDef && (colDef.field === (0, $d6d7a429fd810b6e$export$9cce4aaa860dd90a) || (0, $734c0c465b6331e7$export$452ffe3c6554619d)(colDef.field))) break;
                    if (!event.shiftKey && rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                    break;
                }
            case 'PageDown':
                if (rowIndexBefore < lastRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(Math.min(rowIndexBefore + viewportPageSize, lastRowIndexInPage)));
                break;
            case 'PageUp':
                {
                    // Go to the first row before going to header
                    const nextRowIndex = Math.max(rowIndexBefore - viewportPageSize, firstRowIndexInPage);
                    if (nextRowIndex !== rowIndexBefore && nextRowIndex >= firstRowIndexInPage) goToCell(colIndexBefore, getRowIdFromIndex(nextRowIndex));
                    else goToHeader(colIndexBefore, event);
                    break;
                }
            case 'Home':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(firstColIndex, getRowIdFromIndex(firstRowIndexInPage));
                else goToCell(firstColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            case 'End':
                if (event.ctrlKey || event.metaKey || event.shiftKey) goToCell(lastColIndex, getRowIdFromIndex(lastRowIndexInPage));
                else goToCell(lastColIndex, getRowIdFromIndex(rowIndexBefore));
                break;
            default:
                shouldPreventDefault = false;
        }
        if (shouldPreventDefault) event.preventDefault();
    }, [
        apiRef,
        getCurrentPageRows,
        isRtl,
        goToCell,
        getRowIdFromIndex,
        headerFilteringEnabled,
        goToHeaderFilter,
        goToHeader
    ]);
    const checkIfCanStartEditing = $acw62.useCallback((initialValue, { event: event })=>{
        if (event.key === ' ') // Space scrolls to the last row
        return false;
        return initialValue;
    }, []);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'canStartEditing', checkIfCanStartEditing);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'headerFilterKeyDown', handleHeaderFilterKeyDown);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnGroupHeaderKeyDown', handleColumnGroupHeaderKeyDown);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellKeyDown', handleCellKeyDown);
};







var $acw62 = parcelRequire("acw62");





'use client';
const $95c69aa9cfa905d6$export$229d07cf557fa73f = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridRowCount');
    const visibleTopLevelRowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$f88efd30675963d1));
    const rowCountState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$946e4ae85da77ef6));
    const paginationMeta = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$4dee702a38e33bdb));
    const paginationModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6));
    const previousPageSize = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)(()=>(0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6)(apiRef).pageSize);
    apiRef.current.registerControlState({
        stateId: 'paginationRowCount',
        propModel: props.rowCount,
        propOnChange: props.onRowCountChange,
        stateSelector: (0, $e164e26c82788fb1$export$946e4ae85da77ef6),
        changeEvent: 'rowCountChange'
    });
    /**
   * API METHODS
   */ const setRowCount = $acw62.useCallback((newRowCount)=>{
        if (rowCountState === newRowCount) return;
        logger.debug("Setting 'rowCount' to", newRowCount);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                    rowCount: newRowCount
                })
            }));
    }, [
        apiRef,
        logger,
        rowCountState
    ]);
    const paginationRowCountApi = {
        setRowCount: setRowCount
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, paginationRowCountApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const exportedRowCount = (0, $e164e26c82788fb1$export$946e4ae85da77ef6)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `rowCount` is controlled
        props.rowCount != null || // Always export if the `rowCount` has been initialized
        props.initialState?.pagination?.rowCount != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState.pagination, {
                rowCount: exportedRowCount
            })
        });
    }, [
        apiRef,
        props.rowCount,
        props.initialState?.pagination?.rowCount
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const restoredRowCount = context.stateToRestore.pagination?.rowCount ? context.stateToRestore.pagination.rowCount : (0, $e164e26c82788fb1$export$946e4ae85da77ef6)(apiRef);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                    rowCount: restoredRowCount
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EVENTS
   */ const handlePaginationModelChange = $acw62.useCallback((model)=>{
        if (props.paginationMode === 'client' || !previousPageSize.current) return;
        if (model.pageSize !== previousPageSize.current) {
            previousPageSize.current = model.pageSize;
            if (rowCountState === -1) // Row count unknown and page size changed, reset the page
            apiRef.current.setPage(0);
        }
    }, [
        props.paginationMode,
        previousPageSize,
        rowCountState,
        apiRef
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'paginationModelChange', handlePaginationModelChange);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        if (props.paginationMode === 'client') apiRef.current.setRowCount(visibleTopLevelRowCount);
        else if (props.rowCount != null) apiRef.current.setRowCount(props.rowCount);
    }, [
        apiRef,
        props.paginationMode,
        visibleTopLevelRowCount,
        props.rowCount
    ]);
    const isLastPage = paginationMeta.hasNextPage === false;
    $acw62.useEffect(()=>{
        if (isLastPage && rowCountState === -1) apiRef.current.setRowCount(paginationModel.pageSize * paginationModel.page + visibleTopLevelRowCount);
    }, [
        apiRef,
        visibleTopLevelRowCount,
        isLastPage,
        rowCountState,
        paginationModel
    ]);
};




var $acw62 = parcelRequire("acw62");



'use client';
const $f047726b77946eb6$export$3e4f856d83dbf104 = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridPaginationMeta');
    const paginationMeta = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$4dee702a38e33bdb));
    apiRef.current.registerControlState({
        stateId: 'paginationMeta',
        propModel: props.paginationMeta,
        propOnChange: props.onPaginationMetaChange,
        stateSelector: (0, $e164e26c82788fb1$export$4dee702a38e33bdb),
        changeEvent: 'paginationMetaChange'
    });
    /**
   * API METHODS
   */ const setPaginationMeta = $acw62.useCallback((newPaginationMeta)=>{
        if (paginationMeta === newPaginationMeta) return;
        logger.debug("Setting 'paginationMeta' to", newPaginationMeta);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                    meta: newPaginationMeta
                })
            }));
    }, [
        apiRef,
        logger,
        paginationMeta
    ]);
    const paginationMetaApi = {
        setPaginationMeta: setPaginationMeta
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, paginationMetaApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const exportedPaginationMeta = (0, $e164e26c82788fb1$export$4dee702a38e33bdb)(apiRef);
        const shouldExportRowCount = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the `paginationMeta` is controlled
        props.paginationMeta != null || // Always export if the `paginationMeta` has been initialized
        props.initialState?.pagination?.meta != null;
        if (!shouldExportRowCount) return prevState;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState.pagination, {
                meta: exportedPaginationMeta
            })
        });
    }, [
        apiRef,
        props.paginationMeta,
        props.initialState?.pagination?.meta
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const restoredPaginationMeta = context.stateToRestore.pagination?.meta ? context.stateToRestore.pagination.meta : (0, $e164e26c82788fb1$export$4dee702a38e33bdb)(apiRef);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
                    meta: restoredPaginationMeta
                })
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        if (props.paginationMeta) apiRef.current.setPaginationMeta(props.paginationMeta);
    }, [
        apiRef,
        props.paginationMeta
    ]);
};


const $390722a54a10e3ba$export$951a05deca7e869f = (state, props)=>{
    const paginationModel = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $e7d42f0773505d53$export$73aa7e9d0fff5ee4)(props.autoPageSize), props.paginationModel ?? props.initialState?.pagination?.paginationModel);
    (0, $e7d42f0773505d53$export$d3cf54bfe8b6931)(paginationModel.pageSize, props.signature);
    const rowCount = props.rowCount ?? props.initialState?.pagination?.rowCount ?? (props.paginationMode === 'client' ? state.rows?.totalRowCount : undefined);
    const meta = props.paginationMeta ?? props.initialState?.pagination?.meta ?? {};
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        pagination: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.pagination, {
            paginationModel: paginationModel,
            rowCount: rowCount,
            meta: meta,
            enabled: props.pagination === true,
            paginationMode: props.paginationMode
        })
    });
};
const $390722a54a10e3ba$export$f1c8f1c02d202e22 = (apiRef, props)=>{
    (0, $f047726b77946eb6$export$3e4f856d83dbf104)(apiRef, props);
    (0, $59c9ca30cf4d11cd$export$fb13b4a85293b054)(apiRef, props);
    (0, $95c69aa9cfa905d6$export$229d07cf557fa73f)(apiRef, props);
};




var $acw62 = parcelRequire("acw62");




const $14905bacef5a00cd$export$a9f45f767b8ade48 = (state, props)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        preferencePanel: props.initialState?.preferencePanel ?? {
            open: false
        }
    });
const $14905bacef5a00cd$export$343dd9a605dbb75b = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridPreferencesPanel');
    /**
   * API METHODS
   */ const hidePreferences = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (!state.preferencePanel.open) return state;
            logger.debug('Hiding Preferences Panel');
            const preferencePanelState = (0, $9a7998a995118469$export$37e5474577e02878)(apiRef);
            apiRef.current.publishEvent('preferencePanelClose', {
                openedPanelValue: preferencePanelState.openedPanelValue
            });
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                preferencePanel: {
                    open: false
                }
            });
        });
    }, [
        apiRef,
        logger
    ]);
    const showPreferences = $acw62.useCallback((newValue, panelId, labelId)=>{
        logger.debug('Opening Preferences Panel');
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                preferencePanel: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.preferencePanel, {
                    open: true,
                    openedPanelValue: newValue,
                    panelId: panelId,
                    labelId: labelId
                })
            }));
        apiRef.current.publishEvent('preferencePanelOpen', {
            openedPanelValue: newValue
        });
    }, [
        logger,
        apiRef
    ]);
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, {
        showPreferences: showPreferences,
        hidePreferences: hidePreferences
    }, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const preferencePanelToExport = (0, $9a7998a995118469$export$37e5474577e02878)(apiRef);
        const shouldExportPreferencePanel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the panel was initialized
        props.initialState?.preferencePanel != null || // Always export if the panel is opened
        preferencePanelToExport.open;
        if (!shouldExportPreferencePanel) return prevState;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            preferencePanel: preferencePanelToExport
        });
    }, [
        apiRef,
        props.initialState?.preferencePanel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const preferencePanel = context.stateToRestore.preferencePanel;
        if (preferencePanel != null) apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                preferencePanel: preferencePanel
            }));
        return params;
    }, [
        apiRef
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
};




var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");









const $4255bcbc0a0ba839$export$91ed78b95c9e6636 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.editRows);
const $4255bcbc0a0ba839$export$3ca6aabd7600f0b3 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4255bcbc0a0ba839$export$91ed78b95c9e6636, (editRows, { rowId: rowId, editMode: editMode })=>editMode === (0, $181c044302967209$export$bad6b7a934346f26).Row && Boolean(editRows[rowId]));
const $4255bcbc0a0ba839$export$e6f93ce5e9b42cd9 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($4255bcbc0a0ba839$export$91ed78b95c9e6636, (editRows, { rowId: rowId, field: field })=>editRows[rowId]?.[field] ?? null);






const $f32e85eaccc42aab$export$311bd602ebd44399 = (colDef)=>{
    switch(colDef.type){
        case 'boolean':
            return false;
        case 'date':
        case 'dateTime':
        case 'number':
            return undefined;
        case 'singleSelect':
            return null;
        case 'string':
        default:
            return '';
    }
};


'use client';
const $c82a96954c234fd6$var$_excluded = [
    "id",
    "field"
], $c82a96954c234fd6$var$_excluded2 = [
    "id",
    "field"
];
const $c82a96954c234fd6$export$2c9a271ac5d3f446 = (apiRef, props)=>{
    const [cellModesModel, setCellModesModel] = $acw62.useState({});
    const cellModesModelRef = $acw62.useRef(cellModesModel);
    const prevCellModesModel = $acw62.useRef({});
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, cellModesModel: cellModesModelProp, onCellModesModelChange: onCellModesModelChange } = props;
    const runIfEditModeIsCell = (callback)=>(...args)=>{
            if (props.editMode === (0, $181c044302967209$export$bad6b7a934346f26).Cell) callback(...args);
        };
    const throwIfNotEditable = $acw62.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $acw62.useCallback((id, field, mode)=>{
        if (apiRef.current.getCellMode(id, field) !== mode) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (params.cellMode === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit) return;
        const newParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
            reason: (0, $b0887bea925b8b78$export$66744c3b0d0c6217).cellDoubleClick
        });
        apiRef.current.publishEvent('cellEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusOut = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $181c044302967209$export$84e4fdd8f295ca31).View) return;
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $181c044302967209$export$84e4fdd8f295ca31).View) return;
        const newParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
            reason: (0, $b0887bea925b8b78$export$73fccbaa325472ee).cellFocusOut
        });
        apiRef.current.publishEvent('cellEditStop', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $b0887bea925b8b78$export$73fccbaa325472ee).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $b0887bea925b8b78$export$73fccbaa325472ee).enterKeyDown;
            else if (event.key === 'Tab') {
                reason = event.shiftKey ? (0, $b0887bea925b8b78$export$73fccbaa325472ee).shiftTabKeyDown : (0, $b0887bea925b8b78$export$73fccbaa325472ee).tabKeyDown;
                event.preventDefault(); // Prevent going to the next element in the tab sequence
            }
            if (reason) {
                const newParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
                    reason: reason
                });
                apiRef.current.publishEvent('cellEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'cell'
            });
            if (!canStartEditing) return;
            if ((0, $2c033a607636d88a$export$b3f2c64190cf8c4)(event)) reason = (0, $b0887bea925b8b78$export$66744c3b0d0c6217).printableKeyDown;
            else if ((0, $2c033a607636d88a$export$dc044e3b830c7edc)(event)) reason = (0, $b0887bea925b8b78$export$66744c3b0d0c6217).pasteKeyDown;
            else if (event.key === 'Enter') reason = (0, $b0887bea925b8b78$export$66744c3b0d0c6217).enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = (0, $b0887bea925b8b78$export$66744c3b0d0c6217).deleteKeyDown;
            if (reason) {
                const newParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
                    reason: reason,
                    key: event.key
                });
                apiRef.current.publishEvent('cellEditStart', newParams, event);
            }
        }
    }, [
        apiRef
    ]);
    const handleCellEditStart = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startCellEditModeParams = {
            id: id,
            field: field
        };
        if (reason === (0, $b0887bea925b8b78$export$66744c3b0d0c6217).printableKeyDown || reason === (0, $b0887bea925b8b78$export$66744c3b0d0c6217).deleteKeyDown || reason === (0, $b0887bea925b8b78$export$66744c3b0d0c6217).pasteKeyDown) startCellEditModeParams.deleteValue = true;
        apiRef.current.startCellEditMode(startCellEditModeParams);
    }, [
        apiRef
    ]);
    const handleCellEditStop = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        apiRef.current.runPendingEditCellValueMutation(id, field);
        let cellToFocusAfter;
        if (reason === (0, $b0887bea925b8b78$export$73fccbaa325472ee).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $b0887bea925b8b78$export$73fccbaa325472ee).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $b0887bea925b8b78$export$73fccbaa325472ee).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopCellEditMode({
            id: id,
            field: field,
            ignoreModifications: ignoreModifications,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    const runIfNoFieldErrors = (callback)=>async (...args)=>{
            if (callback) {
                const { id: id, field: field } = args[0];
                const editRowsState = apiRef.current.state.editRows;
                const hasFieldErrors = editRowsState[id][field]?.error;
                if (!hasFieldErrors) callback(...args);
            }
        };
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellDoubleClick', runIfEditModeIsCell(handleCellDoubleClick));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellFocusOut', runIfEditModeIsCell(handleCellFocusOut));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellKeyDown', runIfEditModeIsCell(handleCellKeyDown));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellEditStart', runIfEditModeIsCell(handleCellEditStart));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellEditStop', runIfEditModeIsCell(handleCellEditStop));
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'cellEditStart', props.onCellEditStart);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'cellEditStop', runIfNoFieldErrors(props.onCellEditStop));
    const getCellMode = $acw62.useCallback((id, field)=>{
        const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        const isEditing = editingState[id] && editingState[id][field];
        return isEditing ? (0, $181c044302967209$export$84e4fdd8f295ca31).Edit : (0, $181c044302967209$export$84e4fdd8f295ca31).View;
    }, [
        apiRef
    ]);
    const updateCellModesModel = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.cellModesModel;
        if (onCellModesModelChange && isNewModelDifferentFromProp) onCellModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.cellModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setCellModesModel(newModel);
        cellModesModelRef.current = newModel;
        apiRef.current.publishEvent('cellModesModelChange', newModel);
    });
    const updateFieldInCellModesModel = $acw62.useCallback((id, field, newProps)=>{
        // We use the ref because it always contain the up-to-date value, different from the state
        // that needs a rerender to reflect the new value
        const newModel = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, cellModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newModel[id], {
            [field]: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newProps)
        });
        else {
            const _newModel$id = newModel[id], otherFields = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_newModel$id, [
                field
            ].map((0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039))); // Ensure that we have a new object, not a reference
            newModel[id] = otherFields;
            if (Object.keys(newModel[id]).length === 0) delete newModel[id];
        }
        updateCellModesModel(newModel);
    }, [
        updateCellModesModel
    ]);
    const updateOrDeleteFieldState = $acw62.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newEditingState[id], {
                [field]: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const startCellEditMode = $acw62.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(params, $c82a96954c234fd6$var$_excluded);
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $181c044302967209$export$84e4fdd8f295ca31).View);
        updateFieldInCellModesModel(id, field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            mode: (0, $181c044302967209$export$84e4fdd8f295ca31).Edit
        }, other));
    }, [
        throwIfNotEditable,
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStartCellEditMode = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(async (params)=>{
        const { id: id, field: field, deleteValue: deleteValue, initialValue: initialValue } = params;
        const value = apiRef.current.getCellValue(id, field);
        let newValue = value;
        if (deleteValue) newValue = (0, $f32e85eaccc42aab$export$311bd602ebd44399)(apiRef.current.getColumn(field));
        else if (initialValue) newValue = initialValue;
        const column = apiRef.current.getColumn(field);
        const shouldProcessEditCellProps = !!column.preProcessEditCellProps && deleteValue;
        let newProps = {
            value: newValue,
            error: false,
            isProcessingProps: shouldProcessEditCellProps
        };
        updateOrDeleteFieldState(id, field, newProps);
        apiRef.current.setCellFocus(id, field);
        if (shouldProcessEditCellProps) {
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: apiRef.current.getRow(id),
                props: newProps,
                hasChanged: newValue !== value
            }));
            // Check if still in edit mode before updating
            if (apiRef.current.getCellMode(id, field) === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit) {
                const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
                updateOrDeleteFieldState(id, field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newProps, {
                    value: editingState[id][field].value,
                    isProcessingProps: false
                }));
            }
        }
    });
    const stopCellEditMode = $acw62.useCallback((params)=>{
        const { id: id, field: field } = params, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(params, $c82a96954c234fd6$var$_excluded2);
        throwIfNotInMode(id, field, (0, $181c044302967209$export$84e4fdd8f295ca31).Edit);
        updateFieldInCellModesModel(id, field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            mode: (0, $181c044302967209$export$84e4fdd8f295ca31).View
        }, other));
    }, [
        throwIfNotInMode,
        updateFieldInCellModesModel
    ]);
    const updateStateToStopCellEditMode = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(async (params)=>{
        const { id: id, field: field, ignoreModifications: ignoreModifications, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        throwIfNotInMode(id, field, (0, $181c044302967209$export$84e4fdd8f295ca31).Edit);
        apiRef.current.runPendingEditCellValueMutation(id, field);
        const finishCellEditMode = ()=>{
            updateOrDeleteFieldState(id, field, null);
            updateFieldInCellModesModel(id, field, null);
            if (cellToFocusAfter !== 'none') apiRef.current.moveFocusToRelativeCell(id, field, cellToFocusAfter);
        };
        if (ignoreModifications) {
            finishCellEditMode();
            return;
        }
        const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        const { error: error, isProcessingProps: isProcessingProps } = editingState[id][field];
        const row = apiRef.current.getRow(id);
        if (error || isProcessingProps) {
            // Attempt to change cell mode to "view" was not successful
            // Update previous mode to allow another attempt
            prevCellModesModel.current[id][field].mode = (0, $181c044302967209$export$84e4fdd8f295ca31).Edit;
            // Revert the mode in the cellModesModel prop back to "edit"
            updateFieldInCellModesModel(id, field, {
                mode: (0, $181c044302967209$export$84e4fdd8f295ca31).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field);
        if (props.dataSource?.updateRow) {
            if ((0, $5ece57da2e97951f$export$78fdc9adc3f30400)(row, rowUpdate)) {
                finishCellEditMode();
                return;
            }
            const handleError = ()=>{
                prevCellModesModel.current[id][field].mode = (0, $181c044302967209$export$84e4fdd8f295ca31).Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: (0, $181c044302967209$export$84e4fdd8f295ca31).Edit
                });
            };
            const updateRowParams = {
                rowId: id,
                updatedRow: rowUpdate,
                previousRow: row
            };
            try {
                await apiRef.current.dataSource.editRow(updateRowParams);
                finishCellEditMode();
            } catch  {
                handleError();
            }
        } else if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                prevCellModesModel.current[id][field].mode = (0, $181c044302967209$export$84e4fdd8f295ca31).Edit;
                // Revert the mode in the cellModesModel prop back to "edit"
                updateFieldInCellModesModel(id, field, {
                    mode: (0, $181c044302967209$export$84e4fdd8f295ca31).Edit
                });
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishCellEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishCellEditMode();
        }
    });
    const setCellEditingEditCellValue = $acw62.useCallback(async (params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        throwIfNotInMode(id, field, (0, $181c044302967209$export$84e4fdd8f295ca31).Edit);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        let newProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (column.preProcessEditCellProps) {
            const hasChanged = value !== editingState[id][field].value;
            newProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newProps, {
                isProcessingProps: true
            });
            updateOrDeleteFieldState(id, field, newProps);
            newProps = await Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps,
                hasChanged: hasChanged
            }));
        }
        // Check again if the cell is in edit mode because the user may have
        // discarded the changes while the props were being processed.
        if (apiRef.current.getCellMode(id, field) === (0, $181c044302967209$export$84e4fdd8f295ca31).View) return false;
        editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        newProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newProps, {
            isProcessingProps: false
        });
        // We don't update the value with the one coming from the props pre-processing
        // because when the promise resolves it may be already outdated. The only
        // exception to this rule is when there's no pre-processing.
        newProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
        updateOrDeleteFieldState(id, field, newProps);
        editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        return !editingState[id]?.[field]?.error;
    }, [
        apiRef,
        throwIfNotEditable,
        throwIfNotInMode,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromCellEditing = $acw62.useCallback((id, field)=>{
        const column = apiRef.current.getColumn(field);
        const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        const row = apiRef.current.getRow(id);
        if (!editingState[id] || !editingState[id][field]) return apiRef.current.getRow(id);
        const { value: value } = editingState[id][field];
        return column.valueSetter ? column.valueSetter(value, row, column, apiRef) : (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, row, {
            [field]: value
        });
    }, [
        apiRef
    ]);
    const editingApi = {
        getCellMode: getCellMode,
        startCellEditMode: startCellEditMode,
        stopCellEditMode: stopCellEditMode
    };
    const editingPrivateApi = {
        setCellEditingEditCellValue: setCellEditingEditCellValue,
        getRowWithUpdatedValuesFromCellEditing: getRowWithUpdatedValuesFromCellEditing
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, editingApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, editingPrivateApi, 'private');
    $acw62.useEffect(()=>{
        if (cellModesModelProp) updateCellModesModel(cellModesModelProp);
    }, [
        cellModesModelProp,
        updateCellModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const rowsLookup = (0, $4fc0d4cb0e570e63$export$37767f9110c99048)(apiRef);
        // Update the ref here because updateStateToStopCellEditMode may change it later
        const copyOfPrevCellModes = prevCellModesModel.current;
        prevCellModesModel.current = (0, $07a64ebfd26f4296$export$b7d58db314e0ac27)(cellModesModel); // Do a deep-clone because the attributes might be changed later
        Object.entries(cellModesModel).forEach(([id, fields])=>{
            Object.entries(fields).forEach(([field, params])=>{
                const prevMode = copyOfPrevCellModes[id]?.[field]?.mode || (0, $181c044302967209$export$84e4fdd8f295ca31).View;
                const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
                if (params.mode === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit && prevMode === (0, $181c044302967209$export$84e4fdd8f295ca31).View) updateStateToStartCellEditMode((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: originalId,
                    field: field
                }, params));
                else if (params.mode === (0, $181c044302967209$export$84e4fdd8f295ca31).View && prevMode === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit) updateStateToStopCellEditMode((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    id: originalId,
                    field: field
                }, params));
            });
        });
    }, [
        apiRef,
        cellModesModel,
        updateStateToStartCellEditMode,
        updateStateToStopCellEditMode
    ]);
};







var $acw62 = parcelRequire("acw62");












/**
 * Object passed as parameter in the row callbacks.
 * @demos
 *   - [Master-detail row panels](/x/react-data-grid/master-detail/)
 */ /**
 * Object passed as parameter in the row `getRowClassName` callback prop.
 * @demos
 *   - [Styling rows](/x/react-data-grid/style/#styling-rows)
 */ /**
 * Object passed as parameter in the row `getRowHeight` callback prop.
 */ /**
 * The getRowHeight return value.
 */ var $dff4e305ee1aa2cf$export$535533732d8f5c0a = /*#__PURE__*/ function(GridRowEditStartReasons) {
    GridRowEditStartReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStartReasons["cellDoubleClick"] = "cellDoubleClick";
    GridRowEditStartReasons["printableKeyDown"] = "printableKeyDown";
    GridRowEditStartReasons["deleteKeyDown"] = "deleteKeyDown";
    return GridRowEditStartReasons;
}($dff4e305ee1aa2cf$export$535533732d8f5c0a || {});
/**
 * Params passed to the `rowEditStart` event.
 */ var $dff4e305ee1aa2cf$export$723957c53726785f = /*#__PURE__*/ function(GridRowEditStopReasons) {
    GridRowEditStopReasons["rowFocusOut"] = "rowFocusOut";
    GridRowEditStopReasons["escapeKeyDown"] = "escapeKeyDown";
    GridRowEditStopReasons["enterKeyDown"] = "enterKeyDown";
    GridRowEditStopReasons["tabKeyDown"] = "tabKeyDown";
    GridRowEditStopReasons["shiftTabKeyDown"] = "shiftTabKeyDown";
    return GridRowEditStopReasons;
}($dff4e305ee1aa2cf$export$723957c53726785f || {});




'use client';
const $3179e24def668f51$var$_excluded = [
    "id"
], $3179e24def668f51$var$_excluded2 = [
    "id"
];
const $3179e24def668f51$export$a43bf4f64ed7f919 = (apiRef, props)=>{
    const [rowModesModel, setRowModesModel] = $acw62.useState({});
    const rowModesModelRef = $acw62.useRef(rowModesModel);
    const prevRowModesModel = $acw62.useRef({});
    const prevRowValuesLookup = $acw62.useRef({});
    const focusTimeout = $acw62.useRef(undefined);
    const nextFocusedCell = $acw62.useRef(null);
    const { processRowUpdate: processRowUpdate, onProcessRowUpdateError: onProcessRowUpdateError, rowModesModel: rowModesModelProp, onRowModesModelChange: onRowModesModelChange } = props;
    const runIfEditModeIsRow = (callback)=>(...args)=>{
            if (props.editMode === (0, $181c044302967209$export$bad6b7a934346f26).Row) callback(...args);
        };
    const throwIfNotEditable = $acw62.useCallback((id, field)=>{
        const params = apiRef.current.getCellParams(id, field);
        if (!apiRef.current.isCellEditable(params)) throw new Error(`MUI X: The cell with id=${id} and field=${field} is not editable.`);
    }, [
        apiRef
    ]);
    const throwIfNotInMode = $acw62.useCallback((id, mode)=>{
        if (apiRef.current.getRowMode(id) !== mode) throw new Error(`MUI X: The row with id=${id} is not in ${mode} mode.`);
    }, [
        apiRef
    ]);
    const hasFieldsWithErrors = $acw62.useCallback((rowId)=>{
        const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        return Object.values(editingState[rowId]).some((fieldProps)=>fieldProps.error);
    }, [
        apiRef
    ]);
    const handleCellDoubleClick = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $181c044302967209$export$d98c76b959bb0b5c).Edit) return;
        const rowParams = apiRef.current.getRowParams(params.id);
        const newParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowParams, {
            field: params.field,
            reason: (0, $dff4e305ee1aa2cf$export$535533732d8f5c0a).cellDoubleClick
        });
        apiRef.current.publishEvent('rowEditStart', newParams, event);
    }, [
        apiRef
    ]);
    const handleCellFocusIn = $acw62.useCallback((params)=>{
        nextFocusedCell.current = params;
    }, []);
    const handleCellFocusOut = $acw62.useCallback((params, event)=>{
        if (!params.isEditable) return;
        if (apiRef.current.getRowMode(params.id) === (0, $181c044302967209$export$d98c76b959bb0b5c).View) return;
        // The mechanism to detect if we can stop editing a row is different from
        // the cell editing. Instead of triggering it when clicking outside a cell,
        // we must check if another cell in the same row was not clicked. To achieve
        // that, first we keep track of all cells that gained focus. When a cell loses
        // focus we check if the next cell that received focus is from a different row.
        nextFocusedCell.current = null;
        focusTimeout.current = setTimeout(()=>{
            if (nextFocusedCell.current?.id !== params.id) {
                // The row might have been deleted during the click
                if (!apiRef.current.getRow(params.id)) return;
                // The row may already changed its mode
                if (apiRef.current.getRowMode(params.id) === (0, $181c044302967209$export$d98c76b959bb0b5c).View) return;
                if (hasFieldsWithErrors(params.id)) return;
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowParams, {
                    field: params.field,
                    reason: (0, $dff4e305ee1aa2cf$export$723957c53726785f).rowFocusOut
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        });
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    $acw62.useEffect(()=>{
        return ()=>{
            clearTimeout(focusTimeout.current);
        };
    }, []);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        if (params.cellMode === (0, $181c044302967209$export$d98c76b959bb0b5c).Edit) {
            // Wait until IME is settled for Asian languages like Japanese and Chinese
            // TODO: to replace at one point. See https://github.com/mui/material-ui/pull/39713#discussion_r1381678957.
            if (event.which === 229) return;
            let reason;
            if (event.key === 'Escape') reason = (0, $dff4e305ee1aa2cf$export$723957c53726785f).escapeKeyDown;
            else if (event.key === 'Enter') reason = (0, $dff4e305ee1aa2cf$export$723957c53726785f).enterKeyDown;
            else if (event.key === 'Tab') {
                const columnFields = (0, $1781ebe27505055c$export$c9491722e1d6e8d3)(apiRef).filter((field)=>{
                    const column = apiRef.current.getColumn(field);
                    if (column.type === (0, $09b8609275e30076$export$e2523ab9efeb7465)) return true;
                    return apiRef.current.isCellEditable(apiRef.current.getCellParams(params.id, field));
                });
                if (event.shiftKey) {
                    if (params.field === columnFields[0]) // Exit if user pressed Shift+Tab on the first field
                    reason = (0, $dff4e305ee1aa2cf$export$723957c53726785f).shiftTabKeyDown;
                } else if (params.field === columnFields[columnFields.length - 1]) // Exit if user pressed Tab on the last field
                reason = (0, $dff4e305ee1aa2cf$export$723957c53726785f).tabKeyDown;
                // Always prevent going to the next element in the tab sequence because the focus is
                // handled manually to support edit components rendered inside Portals
                event.preventDefault();
                if (!reason) {
                    const index = columnFields.findIndex((field)=>field === params.field);
                    const nextFieldToFocus = columnFields[event.shiftKey ? index - 1 : index + 1];
                    apiRef.current.setCellFocus(params.id, nextFieldToFocus);
                }
            }
            if (reason) {
                if (reason !== (0, $dff4e305ee1aa2cf$export$723957c53726785f).escapeKeyDown && hasFieldsWithErrors(params.id)) return;
                const newParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, apiRef.current.getRowParams(params.id), {
                    reason: reason,
                    field: params.field
                });
                apiRef.current.publishEvent('rowEditStop', newParams, event);
            }
        } else if (params.isEditable) {
            let reason;
            const canStartEditing = apiRef.current.unstable_applyPipeProcessors('canStartEditing', true, {
                event: event,
                cellParams: params,
                editMode: 'row'
            });
            if (!canStartEditing) return;
            if ((0, $2c033a607636d88a$export$b3f2c64190cf8c4)(event)) reason = (0, $dff4e305ee1aa2cf$export$535533732d8f5c0a).printableKeyDown;
            else if ((0, $2c033a607636d88a$export$dc044e3b830c7edc)(event)) reason = (0, $dff4e305ee1aa2cf$export$535533732d8f5c0a).printableKeyDown;
            else if (event.key === 'Enter') reason = (0, $dff4e305ee1aa2cf$export$535533732d8f5c0a).enterKeyDown;
            else if (event.key === 'Backspace' || event.key === 'Delete') reason = (0, $dff4e305ee1aa2cf$export$535533732d8f5c0a).deleteKeyDown;
            if (reason) {
                const rowParams = apiRef.current.getRowParams(params.id);
                const newParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowParams, {
                    field: params.field,
                    reason: reason
                });
                apiRef.current.publishEvent('rowEditStart', newParams, event);
            }
        }
    }, [
        apiRef,
        hasFieldsWithErrors
    ]);
    const handleRowEditStart = $acw62.useCallback((params)=>{
        const { id: id, field: field, reason: reason } = params;
        const startRowEditModeParams = {
            id: id,
            fieldToFocus: field
        };
        if (reason === (0, $dff4e305ee1aa2cf$export$535533732d8f5c0a).printableKeyDown || reason === (0, $dff4e305ee1aa2cf$export$535533732d8f5c0a).deleteKeyDown) startRowEditModeParams.deleteValue = !!field;
        apiRef.current.startRowEditMode(startRowEditModeParams);
    }, [
        apiRef
    ]);
    const handleRowEditStop = $acw62.useCallback((params)=>{
        const { id: id, reason: reason, field: field } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        let cellToFocusAfter;
        if (reason === (0, $dff4e305ee1aa2cf$export$723957c53726785f).enterKeyDown) cellToFocusAfter = 'below';
        else if (reason === (0, $dff4e305ee1aa2cf$export$723957c53726785f).tabKeyDown) cellToFocusAfter = 'right';
        else if (reason === (0, $dff4e305ee1aa2cf$export$723957c53726785f).shiftTabKeyDown) cellToFocusAfter = 'left';
        const ignoreModifications = reason === 'escapeKeyDown';
        apiRef.current.stopRowEditMode({
            id: id,
            ignoreModifications: ignoreModifications,
            field: field,
            cellToFocusAfter: cellToFocusAfter
        });
    }, [
        apiRef
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellDoubleClick', runIfEditModeIsRow(handleCellDoubleClick));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellFocusIn', runIfEditModeIsRow(handleCellFocusIn));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellFocusOut', runIfEditModeIsRow(handleCellFocusOut));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellKeyDown', runIfEditModeIsRow(handleCellKeyDown));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowEditStart', runIfEditModeIsRow(handleRowEditStart));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowEditStop', runIfEditModeIsRow(handleRowEditStop));
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'rowEditStart', props.onRowEditStart);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'rowEditStop', props.onRowEditStop);
    const getRowMode = $acw62.useCallback((id)=>{
        const isEditing = (0, $4255bcbc0a0ba839$export$3ca6aabd7600f0b3)(apiRef, {
            rowId: id,
            editMode: props.editMode
        });
        return isEditing ? (0, $181c044302967209$export$d98c76b959bb0b5c).Edit : (0, $181c044302967209$export$d98c76b959bb0b5c).View;
    }, [
        apiRef,
        props.editMode
    ]);
    const updateRowModesModel = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((newModel)=>{
        const isNewModelDifferentFromProp = newModel !== props.rowModesModel;
        if (onRowModesModelChange && isNewModelDifferentFromProp) onRowModesModelChange(newModel, {
            api: apiRef.current
        });
        if (props.rowModesModel && isNewModelDifferentFromProp) return; // The prop always win
        setRowModesModel(newModel);
        rowModesModelRef.current = newModel;
        apiRef.current.publishEvent('rowModesModelChange', newModel);
    });
    const updateRowInRowModesModel = $acw62.useCallback((id, newProps)=>{
        const newModel = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rowModesModelRef.current);
        if (newProps !== null) newModel[id] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newProps);
        else delete newModel[id];
        updateRowModesModel(newModel);
    }, [
        updateRowModesModel
    ]);
    const updateOrDeleteRowState = $acw62.useCallback((id, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = newProps;
            else delete newEditingState[id];
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const updateOrDeleteFieldState = $acw62.useCallback((id, field, newProps)=>{
        apiRef.current.setState((state)=>{
            const newEditingState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.editRows);
            if (newProps !== null) newEditingState[id] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newEditingState[id], {
                [field]: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newProps)
            });
            else {
                delete newEditingState[id][field];
                if (Object.keys(newEditingState[id]).length === 0) delete newEditingState[id];
            }
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                editRows: newEditingState
            });
        });
    }, [
        apiRef
    ]);
    const startRowEditMode = $acw62.useCallback((params)=>{
        const { id: id } = params, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(params, $3179e24def668f51$var$_excluded);
        throwIfNotInMode(id, (0, $181c044302967209$export$d98c76b959bb0b5c).View);
        updateRowInRowModesModel(id, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            mode: (0, $181c044302967209$export$d98c76b959bb0b5c).Edit
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStartRowEditMode = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((params)=>{
        const { id: id, fieldToFocus: fieldToFocus, deleteValue: deleteValue, initialValue: initialValue } = params;
        const row = apiRef.current.getRow(id);
        const columns = (0, $1781ebe27505055c$export$da85f06e3c19f1fd)(apiRef);
        const newProps = columns.reduce((acc, col)=>{
            const field = col.field;
            const cellParams = apiRef.current.getCellParams(id, field);
            if (!cellParams.isEditable) return acc;
            const column = apiRef.current.getColumn(field);
            let newValue = apiRef.current.getCellValue(id, field);
            if (fieldToFocus === field && (deleteValue || initialValue)) {
                if (deleteValue) newValue = (0, $f32e85eaccc42aab$export$311bd602ebd44399)(column);
                else if (initialValue) newValue = initialValue;
            }
            acc[field] = {
                value: newValue,
                error: false,
                isProcessingProps: column.editable && !!column.preProcessEditCellProps && deleteValue
            };
            return acc;
        }, {});
        prevRowValuesLookup.current[id] = row;
        updateOrDeleteRowState(id, newProps);
        if (fieldToFocus) apiRef.current.setCellFocus(id, fieldToFocus);
        columns.filter((column)=>{
            const isCellEditable = apiRef.current.getCellParams(id, column.field).isEditable;
            return isCellEditable && column.editable && !!column.preProcessEditCellProps && deleteValue;
        }).forEach((column)=>{
            const field = column.field;
            const value = apiRef.current.getCellValue(id, field);
            const newValue = deleteValue ? (0, $f32e85eaccc42aab$export$311bd602ebd44399)(column) : initialValue ?? value;
            Promise.resolve(column.preProcessEditCellProps({
                id: id,
                row: row,
                props: newProps[field],
                hasChanged: newValue !== value
            })).then((processedProps)=>{
                // Check if still in edit mode before updating
                if (apiRef.current.getRowMode(id) === (0, $181c044302967209$export$d98c76b959bb0b5c).Edit) {
                    const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
                    updateOrDeleteFieldState(id, field, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, processedProps, {
                        value: editingState[id][field].value,
                        isProcessingProps: false
                    }));
                }
            });
        });
    });
    const stopRowEditMode = $acw62.useCallback((params)=>{
        const { id: id } = params, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(params, $3179e24def668f51$var$_excluded2);
        throwIfNotInMode(id, (0, $181c044302967209$export$d98c76b959bb0b5c).Edit);
        updateRowInRowModesModel(id, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            mode: (0, $181c044302967209$export$d98c76b959bb0b5c).View
        }, other));
    }, [
        throwIfNotInMode,
        updateRowInRowModesModel
    ]);
    const updateStateToStopRowEditMode = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(async (params)=>{
        const { id: id, ignoreModifications: ignoreModifications, field: focusedField, cellToFocusAfter: cellToFocusAfter = 'none' } = params;
        apiRef.current.runPendingEditCellValueMutation(id);
        const finishRowEditMode = ()=>{
            if (cellToFocusAfter !== 'none' && focusedField) apiRef.current.moveFocusToRelativeCell(id, focusedField, cellToFocusAfter);
            updateOrDeleteRowState(id, null);
            updateRowInRowModesModel(id, null);
            delete prevRowValuesLookup.current[id];
        };
        if (ignoreModifications) {
            finishRowEditMode();
            return;
        }
        const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        const row = prevRowValuesLookup.current[id];
        const isSomeFieldProcessingProps = Object.values(editingState[id]).some((fieldProps)=>fieldProps.isProcessingProps);
        if (isSomeFieldProcessingProps) {
            prevRowModesModel.current[id].mode = (0, $181c044302967209$export$d98c76b959bb0b5c).Edit;
            return;
        }
        if (hasFieldsWithErrors(id)) {
            prevRowModesModel.current[id].mode = (0, $181c044302967209$export$d98c76b959bb0b5c).Edit;
            // Revert the mode in the rowModesModel prop back to "edit"
            updateRowInRowModesModel(id, {
                mode: (0, $181c044302967209$export$d98c76b959bb0b5c).Edit
            });
            return;
        }
        const rowUpdate = apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
        if (props.dataSource?.updateRow) {
            if ((0, $5ece57da2e97951f$export$78fdc9adc3f30400)(row, rowUpdate)) {
                finishRowEditMode();
                return;
            }
            const handleError = ()=>{
                prevRowModesModel.current[id].mode = (0, $181c044302967209$export$d98c76b959bb0b5c).Edit;
                // Revert the mode in the rowModesModel prop back to "edit"
                updateRowInRowModesModel(id, {
                    mode: (0, $181c044302967209$export$d98c76b959bb0b5c).Edit
                });
            };
            const updateRowParams = {
                rowId: id,
                updatedRow: rowUpdate,
                previousRow: row
            };
            try {
                await apiRef.current.dataSource.editRow(updateRowParams);
                finishRowEditMode();
            } catch  {
                handleError();
            }
        } else if (processRowUpdate) {
            const handleError = (errorThrown)=>{
                // The row might have been deleted
                if (prevRowModesModel.current[id]) {
                    prevRowModesModel.current[id].mode = (0, $181c044302967209$export$d98c76b959bb0b5c).Edit;
                    // Revert the mode in the rowModesModel prop back to "edit"
                    updateRowInRowModesModel(id, {
                        mode: (0, $181c044302967209$export$d98c76b959bb0b5c).Edit
                    });
                }
                if (onProcessRowUpdateError) onProcessRowUpdateError(errorThrown);
            };
            try {
                Promise.resolve(processRowUpdate(rowUpdate, row, {
                    rowId: id
                })).then((finalRowUpdate)=>{
                    apiRef.current.updateRows([
                        finalRowUpdate
                    ]);
                    finishRowEditMode();
                }).catch(handleError);
            } catch (errorThrown) {
                handleError(errorThrown);
            }
        } else {
            apiRef.current.updateRows([
                rowUpdate
            ]);
            finishRowEditMode();
        }
    });
    const setRowEditingEditCellValue = $acw62.useCallback((params)=>{
        const { id: id, field: field, value: value, debounceMs: debounceMs, unstable_skipValueParser: skipValueParser } = params;
        throwIfNotEditable(id, field);
        const column = apiRef.current.getColumn(field);
        const row = apiRef.current.getRow(id);
        let parsedValue = value;
        if (column.valueParser && !skipValueParser) parsedValue = column.valueParser(value, row, column, apiRef);
        let editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        let newProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, editingState[id][field], {
            value: parsedValue,
            changeReason: debounceMs ? 'debouncedSetEditCellValue' : 'setEditCellValue'
        });
        if (!column.preProcessEditCellProps) updateOrDeleteFieldState(id, field, newProps);
        return new Promise((resolve)=>{
            const promises = [];
            if (column.preProcessEditCellProps) {
                const hasChanged = newProps.value !== editingState[id][field].value;
                newProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, newProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, field, newProps);
                const _editingState$id = editingState[id], otherFieldsProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_editingState$id, [
                    field
                ].map((0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)));
                const promise = Promise.resolve(column.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: newProps,
                    hasChanged: hasChanged,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $181c044302967209$export$d98c76b959bb0b5c).View) {
                        resolve(false);
                        return;
                    }
                    editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
                    processedProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, processedProps, {
                        isProcessingProps: false
                    });
                    // We don't reuse the value from the props pre-processing because when the
                    // promise resolves it may be already outdated. The only exception to this rule
                    // is when there's no pre-processing.
                    processedProps.value = column.preProcessEditCellProps ? editingState[id][field].value : parsedValue;
                    updateOrDeleteFieldState(id, field, processedProps);
                });
                promises.push(promise);
            }
            Object.entries(editingState[id]).forEach(([thisField, fieldProps])=>{
                if (thisField === field) return;
                const fieldColumn = apiRef.current.getColumn(thisField);
                if (!fieldColumn.preProcessEditCellProps) return;
                fieldProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, fieldProps, {
                    isProcessingProps: true
                });
                updateOrDeleteFieldState(id, thisField, fieldProps);
                editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
                const _editingState$id2 = editingState[id], otherFieldsProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_editingState$id2, [
                    thisField
                ].map((0, $3a21fd50cbcd11cf$export$2e2bcd8739ae039)));
                const promise = Promise.resolve(fieldColumn.preProcessEditCellProps({
                    id: id,
                    row: row,
                    props: fieldProps,
                    hasChanged: false,
                    otherFieldsProps: otherFieldsProps
                })).then((processedProps)=>{
                    // Check again if the row is in edit mode because the user may have
                    // discarded the changes while the props were being processed.
                    if (apiRef.current.getRowMode(id) === (0, $181c044302967209$export$d98c76b959bb0b5c).View) {
                        resolve(false);
                        return;
                    }
                    processedProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, processedProps, {
                        isProcessingProps: false
                    });
                    updateOrDeleteFieldState(id, thisField, processedProps);
                });
                promises.push(promise);
            });
            Promise.all(promises).then(()=>{
                if (apiRef.current.getRowMode(id) === (0, $181c044302967209$export$d98c76b959bb0b5c).Edit) {
                    editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
                    resolve(!editingState[id][field].error);
                } else resolve(false);
            });
        });
    }, [
        apiRef,
        throwIfNotEditable,
        updateOrDeleteFieldState
    ]);
    const getRowWithUpdatedValuesFromRowEditing = $acw62.useCallback((id)=>{
        const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        const row = apiRef.current.getRow(id);
        if (!editingState[id]) return apiRef.current.getRow(id);
        let rowUpdate = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevRowValuesLookup.current[id], row);
        Object.entries(editingState[id]).forEach(([field, fieldProps])=>{
            const column = apiRef.current.getColumn(field);
            // Column might have been removed
            // see https://github.com/mui/mui-x/pull/16888
            if (column?.valueSetter) rowUpdate = column.valueSetter(fieldProps.value, rowUpdate, column, apiRef);
            else rowUpdate[field] = fieldProps.value;
        });
        return rowUpdate;
    }, [
        apiRef
    ]);
    const editingApi = {
        getRowMode: getRowMode,
        startRowEditMode: startRowEditMode,
        stopRowEditMode: stopRowEditMode
    };
    const editingPrivateApi = {
        setRowEditingEditCellValue: setRowEditingEditCellValue,
        getRowWithUpdatedValuesFromRowEditing: getRowWithUpdatedValuesFromRowEditing
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, editingApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, editingPrivateApi, 'private');
    $acw62.useEffect(()=>{
        if (rowModesModelProp) updateRowModesModel(rowModesModelProp);
    }, [
        rowModesModelProp,
        updateRowModesModel
    ]);
    // Run this effect synchronously so that the keyboard event can impact the yet-to-be-rendered input.
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const rowsLookup = (0, $4fc0d4cb0e570e63$export$37767f9110c99048)(apiRef);
        // Update the ref here because updateStateToStopRowEditMode may change it later
        const copyOfPrevRowModesModel = prevRowModesModel.current;
        prevRowModesModel.current = (0, $07a64ebfd26f4296$export$b7d58db314e0ac27)(rowModesModel); // Do a deep-clone because the attributes might be changed later
        const ids = new Set([
            ...Object.keys(rowModesModel),
            ...Object.keys(copyOfPrevRowModesModel)
        ]);
        Array.from(ids).forEach((id)=>{
            const params = rowModesModel[id] ?? {
                mode: (0, $181c044302967209$export$d98c76b959bb0b5c).View
            };
            const prevMode = copyOfPrevRowModesModel[id]?.mode || (0, $181c044302967209$export$d98c76b959bb0b5c).View;
            const originalId = rowsLookup[id] ? apiRef.current.getRowId(rowsLookup[id]) : id;
            if (params.mode === (0, $181c044302967209$export$d98c76b959bb0b5c).Edit && prevMode === (0, $181c044302967209$export$d98c76b959bb0b5c).View) updateStateToStartRowEditMode((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                id: originalId
            }, params));
            else if (params.mode === (0, $181c044302967209$export$d98c76b959bb0b5c).View && prevMode === (0, $181c044302967209$export$d98c76b959bb0b5c).Edit) updateStateToStopRowEditMode((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                id: originalId
            }, params));
        });
    }, [
        apiRef,
        rowModesModel,
        updateStateToStartRowEditMode,
        updateStateToStopRowEditMode
    ]);
};




'use client';
const $c5e6d994a8de55eb$export$1094a2c822d71ffd = (state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        editRows: {}
    });
const $c5e6d994a8de55eb$export$3a0db16b152b4c54 = (apiRef, props)=>{
    (0, $c82a96954c234fd6$export$2c9a271ac5d3f446)(apiRef, props);
    (0, $3179e24def668f51$export$a43bf4f64ed7f919)(apiRef, props);
    const debounceMap = $acw62.useRef({});
    const { isCellEditable: isCellEditableProp } = props;
    const isCellEditable = $acw62.useCallback((params)=>{
        if ((0, $4ab53eafabc4b920$export$5f983e16b1e55860)(params.rowNode)) return false;
        if (!params.colDef.editable) return false;
        if (!params.colDef.renderEditCell) return false;
        if (isCellEditableProp) return isCellEditableProp(params);
        return true;
    }, [
        isCellEditableProp
    ]);
    const maybeDebounce = (id, field, debounceMs, callback)=>{
        if (!debounceMs) {
            callback();
            return;
        }
        if (!debounceMap.current[id]) debounceMap.current[id] = {};
        if (debounceMap.current[id][field]) {
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
        }
        // To run the callback immediately without waiting the timeout
        const runImmediately = ()=>{
            const [timeout] = debounceMap.current[id][field];
            clearTimeout(timeout);
            callback();
            delete debounceMap.current[id][field];
        };
        const timeout = setTimeout(()=>{
            callback();
            delete debounceMap.current[id][field];
        }, debounceMs);
        debounceMap.current[id][field] = [
            timeout,
            runImmediately
        ];
    };
    $acw62.useEffect(()=>{
        const debounces = debounceMap.current;
        return ()=>{
            Object.entries(debounces).forEach(([id, fields])=>{
                Object.keys(fields).forEach((field)=>{
                    const [timeout] = debounces[id][field];
                    clearTimeout(timeout);
                    delete debounces[id][field];
                });
            });
        };
    }, []);
    const runPendingEditCellValueMutation = $acw62.useCallback((id, field)=>{
        if (!debounceMap.current[id]) return;
        if (!field) Object.keys(debounceMap.current[id]).forEach((debouncedField)=>{
            const [, runCallback] = debounceMap.current[id][debouncedField];
            runCallback();
        });
        else if (debounceMap.current[id][field]) {
            const [, runCallback] = debounceMap.current[id][field];
            runCallback();
        }
    }, []);
    const setEditCellValue = $acw62.useCallback((params)=>{
        const { id: id, field: field, debounceMs: debounceMs } = params;
        return new Promise((resolve)=>{
            maybeDebounce(id, field, debounceMs, async ()=>{
                const setEditCellValueToCall = props.editMode === (0, $181c044302967209$export$bad6b7a934346f26).Row ? apiRef.current.setRowEditingEditCellValue : apiRef.current.setCellEditingEditCellValue;
                // Check if the cell is in edit mode
                // By the time this callback runs the user may have cancelled the editing
                if (apiRef.current.getCellMode(id, field) === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit) {
                    const result = await setEditCellValueToCall(params);
                    resolve(result);
                }
            });
        });
    }, [
        apiRef,
        props.editMode
    ]);
    const getRowWithUpdatedValues = $acw62.useCallback((id, field)=>{
        return props.editMode === (0, $181c044302967209$export$bad6b7a934346f26).Cell ? apiRef.current.getRowWithUpdatedValuesFromCellEditing(id, field) : apiRef.current.getRowWithUpdatedValuesFromRowEditing(id);
    }, [
        apiRef,
        props.editMode
    ]);
    const getEditCellMeta = $acw62.useCallback((id, field)=>{
        const editingState = (0, $4255bcbc0a0ba839$export$91ed78b95c9e6636)(apiRef);
        return editingState[id]?.[field] ?? null;
    }, [
        apiRef
    ]);
    const editingSharedApi = {
        isCellEditable: isCellEditable,
        setEditCellValue: setEditCellValue,
        getRowWithUpdatedValues: getRowWithUpdatedValues,
        unstable_getEditCellMeta: getEditCellMeta
    };
    const editingSharedPrivateApi = {
        runPendingEditCellValueMutation: runPendingEditCellValueMutation
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, editingSharedApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, editingSharedPrivateApi, 'private');
};




var $acw62 = parcelRequire("acw62");
















'use client';
const $aee1fe628b61e3de$export$1a6bb5bb341eadaa = (state, props, apiRef)=>{
    const isDataSourceAvailable = !!props.dataSource;
    apiRef.current.caches.rows = (0, $4ab53eafabc4b920$export$3496927f169f2d35)({
        rows: isDataSourceAvailable ? [] : props.rows,
        getRowId: props.getRowId,
        loading: props.loading,
        rowCount: props.rowCount
    });
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        rows: (0, $4ab53eafabc4b920$export$4dcb6d8dd06e4f39)({
            apiRef: apiRef,
            rowCountProp: props.rowCount,
            loadingProp: isDataSourceAvailable ? true : props.loading,
            previousTree: null,
            previousTreeDepths: null
        })
    });
};
const $aee1fe628b61e3de$export$dd1a4469bbd9394e = (apiRef, props, configuration)=>{
    var error;
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridRows');
    const lastUpdateMs = $acw62.useRef(Date.now());
    const lastRowCount = $acw62.useRef(props.rowCount);
    const timeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    // Get overridable methods from configuration
    const { setRowIndex: setRowIndex } = configuration.hooks.useGridRowsOverridableMethods(apiRef, props);
    const getRow = $acw62.useCallback((id)=>{
        const model = (0, $4fc0d4cb0e570e63$export$37767f9110c99048)(apiRef)[id];
        if (model) return model;
        const node = (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, id);
        if (node && (0, $4ab53eafabc4b920$export$5f983e16b1e55860)(node)) return {
            [(0, $4ab53eafabc4b920$export$e8632b32bb8837db)]: id
        };
        return null;
    }, [
        apiRef
    ]);
    const getRowId = $acw62.useCallback((row)=>(0, $f84d89d92301bd81$export$5e766ecd73f055ed)(apiRef, row), [
        apiRef
    ]);
    const throttledRowsChange = $acw62.useCallback(({ cache: cache, throttle: throttle })=>{
        const run = ()=>{
            lastUpdateMs.current = Date.now();
            apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    rows: (0, $4ab53eafabc4b920$export$4dcb6d8dd06e4f39)({
                        apiRef: apiRef,
                        rowCountProp: props.rowCount,
                        loadingProp: props.loading,
                        previousTree: (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef),
                        previousTreeDepths: (0, $4fc0d4cb0e570e63$export$eb24598525413286)(apiRef),
                        previousGroupsToFetch: (0, $4fc0d4cb0e570e63$export$6c1cdbc7b5e9a3f4)(apiRef)
                    })
                }));
            apiRef.current.publishEvent('rowsSet');
        };
        timeout.clear();
        apiRef.current.caches.rows = cache;
        if (!throttle) {
            run();
            return;
        }
        const throttleRemainingTimeMs = props.throttleRowsMs - (Date.now() - lastUpdateMs.current);
        if (throttleRemainingTimeMs > 0) {
            timeout.start(throttleRemainingTimeMs, run);
            return;
        }
        run();
    }, [
        props.throttleRowsMs,
        props.rowCount,
        props.loading,
        apiRef,
        timeout
    ]);
    /**
   * API METHODS
   */ const setRows = $acw62.useCallback((rows)=>{
        logger.debug(`Updating all rows, new length ${rows.length}`);
        if (!props.dataSource && (0, $8f88c26e7e51121c$export$c1e9ba02e25d9a4d)(apiRef)) {
            apiRef.current.updateNonPivotRows(rows, false);
            return;
        }
        const cache = (0, $4ab53eafabc4b920$export$3496927f169f2d35)({
            rows: rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        const prevCache = apiRef.current.caches.rows;
        cache.rowsBeforePartialUpdates = prevCache.rowsBeforePartialUpdates;
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        logger,
        props.getRowId,
        props.dataSource,
        props.loading,
        props.rowCount,
        throttledRowsChange,
        apiRef
    ]);
    const updateRows = $acw62.useCallback((updates)=>{
        if (props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid && updates.length > 1) throw new Error([
            'MUI X: You cannot update several rows at once in `apiRef.current.updateRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (!props.dataSource && (0, $8f88c26e7e51121c$export$c1e9ba02e25d9a4d)(apiRef)) {
            apiRef.current.updateNonPivotRows(updates);
            return;
        }
        const nonPinnedRowsUpdates = (0, $4ab53eafabc4b920$export$1560eaf12ed72130)(apiRef, updates, props.getRowId);
        const cache = (0, $4ab53eafabc4b920$export$b593607f8b00d104)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows
        });
        throttledRowsChange({
            cache: cache,
            throttle: true
        });
    }, [
        props.signature,
        props.dataSource,
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const updateNestedRows = $acw62.useCallback((updates, groupKeys)=>{
        const nonPinnedRowsUpdates = (0, $4ab53eafabc4b920$export$1560eaf12ed72130)(apiRef, updates, props.getRowId);
        const cache = (0, $4ab53eafabc4b920$export$b593607f8b00d104)({
            updates: nonPinnedRowsUpdates,
            getRowId: props.getRowId,
            previousCache: apiRef.current.caches.rows,
            groupKeys: groupKeys ?? []
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        props.getRowId,
        throttledRowsChange,
        apiRef
    ]);
    const setLoading = $acw62.useCallback((loading)=>{
        logger.debug(`Setting loading to ${loading}`);
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, {
                    loading: loading
                })
            }));
        apiRef.current.caches.rows.loadingPropBeforePartialUpdates = loading;
    }, [
        apiRef,
        logger
    ]);
    const getRowModels = $acw62.useCallback(()=>{
        const dataRows = (0, $4fc0d4cb0e570e63$export$c7dcaab5e573753)(apiRef);
        const idRowsLookup = (0, $4fc0d4cb0e570e63$export$37767f9110c99048)(apiRef);
        return new Map(dataRows.map((id)=>[
                id,
                idRowsLookup[id] ?? {}
            ]));
    }, [
        apiRef
    ]);
    const getRowsCount = $acw62.useCallback(()=>(0, $4fc0d4cb0e570e63$export$1641ef9d08e265ca)(apiRef), [
        apiRef
    ]);
    const getAllRowIds = $acw62.useCallback(()=>(0, $4fc0d4cb0e570e63$export$c7dcaab5e573753)(apiRef), [
        apiRef
    ]);
    const getRowIndexRelativeToVisibleRows = $acw62.useCallback((id)=>{
        const { rowIdToIndexMap: rowIdToIndexMap } = (0, $2b6a1e01125c3822$export$79b9fa322a34430b)(apiRef);
        return rowIdToIndexMap.get(id);
    }, [
        apiRef
    ]);
    const setRowChildrenExpansion = $acw62.useCallback((id, isExpanded)=>{
        const currentNode = (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, id);
        if (!currentNode) throw new Error(`MUI X: No row with id #${id} found.`);
        if (currentNode.type !== 'group') throw new Error('MUI X: Only group nodes can be expanded or collapsed.');
        const newNode = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentNode, {
            childrenExpanded: isExpanded
        });
        apiRef.current.setState((state)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, {
                    tree: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows.tree, {
                        [id]: newNode
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowExpansionChange', newNode);
    }, [
        apiRef
    ]);
    const expandAllRows = $acw62.useCallback(()=>{
        const tree = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef));
        const traverse = (nodeId)=>{
            const node = tree[nodeId];
            if (node?.type === 'group') {
                tree[nodeId] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, node, {
                    childrenExpanded: true
                });
                node.children.forEach(traverse);
            }
        };
        traverse((0, $4ab53eafabc4b920$export$433b924dc2506913));
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, {
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowExpansionChange', tree[0, $4ab53eafabc4b920$export$433b924dc2506913]);
    }, [
        apiRef
    ]);
    const collapseAllRows = $acw62.useCallback(()=>{
        const tree = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef));
        const traverse = (nodeId)=>{
            const node = tree[nodeId];
            if (node?.type === 'group') {
                tree[nodeId] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, node, {
                    childrenExpanded: false
                });
                node.children.forEach(traverse);
            }
        };
        traverse((0, $4ab53eafabc4b920$export$433b924dc2506913));
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, {
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowExpansionChange', tree[0, $4ab53eafabc4b920$export$433b924dc2506913]);
    }, [
        apiRef
    ]);
    const getRowNode = $acw62.useCallback((id)=>(0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, id) ?? null, [
        apiRef
    ]);
    const getRowGroupChildren = $acw62.useCallback(({ skipAutoGeneratedRows: skipAutoGeneratedRows = true, groupId: groupId, applySorting: applySorting, applyFiltering: applyFiltering, directChildrenOnly: directChildrenOnly = false })=>{
        const tree = (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef);
        let children;
        if (applySorting) {
            const groupNode = tree[groupId];
            if (!groupNode) return [];
            const sortedRowIds = (0, $f0897a6c670e0208$export$e4979ad0a2db8752)(apiRef);
            children = [];
            const startIndex = sortedRowIds.findIndex((id)=>id === groupId) + 1;
            for(let index = startIndex; index < sortedRowIds.length && (directChildrenOnly ? tree[sortedRowIds[index]].depth === groupNode.depth + 1 : tree[sortedRowIds[index]].depth > groupNode.depth); index += 1){
                const id = sortedRowIds[index];
                if (!skipAutoGeneratedRows || !(0, $4ab53eafabc4b920$export$5f983e16b1e55860)(tree[id])) children.push(id);
            }
        } else children = (0, $4ab53eafabc4b920$export$9380f4bcafb87e49)(tree, groupId, skipAutoGeneratedRows, directChildrenOnly);
        if (applyFiltering) {
            const filteredRowsLookup = (0, $51d9da8b83918212$export$6d031b6e8cbaf41c)(apiRef);
            children = (0, $4928b2b12bcd438c$export$23cfe696632d10f4)(filteredRowsLookup) ? children : children.filter((childId)=>filteredRowsLookup[childId] !== false);
        }
        return children;
    }, [
        apiRef
    ]);
    const replaceRows = $acw62.useCallback((firstRowToRender, newRows)=>{
        if (props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid && newRows.length > 1) throw new Error([
            'MUI X: You cannot replace rows using `apiRef.current.unstable_replaceRows` on the DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock this feature.'
        ].join('\n'));
        if (newRows.length === 0) return;
        const treeDepth = (0, $4fc0d4cb0e570e63$export$4cdbe576751dd8e2)(apiRef);
        if (treeDepth > 1) throw new Error('`apiRef.current.unstable_replaceRows` is not compatible with tree data and row grouping');
        const tree = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef));
        const dataRowIdToModelLookup = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $4fc0d4cb0e570e63$export$37767f9110c99048)(apiRef));
        const rootGroup = tree[0, $4ab53eafabc4b920$export$433b924dc2506913];
        const rootGroupChildren = [
            ...rootGroup.children
        ];
        const seenIds = new Set();
        for(let i = 0; i < newRows.length; i += 1){
            const rowModel = newRows[i];
            const rowId = (0, $4ab53eafabc4b920$export$a95fb784d0ca2e72)(rowModel, props.getRowId, 'A row was provided without id when calling replaceRows().');
            const [removedRowId] = rootGroupChildren.splice(firstRowToRender + i, 1, rowId);
            if (!seenIds.has(removedRowId)) {
                delete dataRowIdToModelLookup[removedRowId];
                delete tree[removedRowId];
            }
            const rowTreeNodeConfig = {
                id: rowId,
                depth: 0,
                parent: (0, $4ab53eafabc4b920$export$433b924dc2506913),
                type: 'leaf',
                groupingKey: null
            };
            dataRowIdToModelLookup[rowId] = rowModel;
            tree[rowId] = rowTreeNodeConfig;
            seenIds.add(rowId);
        }
        tree[0, $4ab53eafabc4b920$export$433b924dc2506913] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootGroup, {
            children: rootGroupChildren
        });
        // Removes potential remaining skeleton rows from the dataRowIds.
        const dataRowIds = rootGroupChildren.filter((childId)=>tree[childId]?.type === 'leaf');
        apiRef.current.caches.rows.dataRowIdToModelLookup = dataRowIdToModelLookup;
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, {
                    loading: props.loading,
                    totalRowCount: Math.max(props.rowCount || 0, rootGroupChildren.length),
                    dataRowIdToModelLookup: dataRowIdToModelLookup,
                    dataRowIds: dataRowIds,
                    tree: tree
                })
            }));
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.signature,
        props.getRowId,
        props.loading,
        props.rowCount
    ]);
    const rowApi = {
        getRow: getRow,
        setLoading: setLoading,
        getRowId: getRowId,
        getRowModels: getRowModels,
        getRowsCount: getRowsCount,
        getAllRowIds: getAllRowIds,
        setRows: setRows,
        updateRows: updateRows,
        getRowNode: getRowNode,
        getRowIndexRelativeToVisibleRows: getRowIndexRelativeToVisibleRows,
        unstable_replaceRows: replaceRows
    };
    const rowProApi = {
        setRowIndex: setRowIndex,
        setRowChildrenExpansion: setRowChildrenExpansion,
        getRowGroupChildren: getRowGroupChildren,
        expandAllRows: expandAllRows,
        collapseAllRows: collapseAllRows
    };
    const rowProPrivateApi = {
        updateNestedRows: updateNestedRows
    };
    /**
   * EVENTS
   */ const groupRows = $acw62.useCallback(()=>{
        logger.info(`Row grouping pre-processing have changed, regenerating the row tree`);
        let cache;
        if (apiRef.current.caches.rows.rowsBeforePartialUpdates === props.rows) // The `props.rows` did not change since the last row grouping
        // We can use the current rows cache which contains the partial updates done recently.
        cache = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, apiRef.current.caches.rows, {
            updates: {
                type: 'full',
                rows: (0, $4fc0d4cb0e570e63$export$c7dcaab5e573753)(apiRef)
            }
        });
        else // The `props.rows` has changed since the last row grouping
        // We must use the new `props.rows` on the new grouping
        // This occurs because this event is triggered before the `useEffect` on the rows when both the grouping pre-processing and the rows changes on the same render
        cache = (0, $4ab53eafabc4b920$export$3496927f169f2d35)({
            rows: props.rows,
            getRowId: props.getRowId,
            loading: props.loading,
            rowCount: props.rowCount
        });
        throttledRowsChange({
            cache: cache,
            throttle: false
        });
    }, [
        logger,
        apiRef,
        props.rows,
        props.getRowId,
        props.loading,
        props.rowCount,
        throttledRowsChange
    ]);
    const previousDataSource = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)(()=>props.dataSource);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (props.dataSource && props.dataSource !== previousDataSource.current) {
            previousDataSource.current = props.dataSource;
            return;
        }
        if (methodName === 'rowTreeCreation') groupRows();
    }, [
        groupRows,
        previousDataSource,
        props.dataSource
    ]);
    const handleStrategyActivityChange = $acw62.useCallback(()=>{
        // `rowTreeCreation` is the only processor ran when `strategyAvailabilityChange` is fired.
        // All the other processors listen to `rowsSet` which will be published by the `groupRows` method below.
        if (apiRef.current.getActiveStrategy((0, $327d142a03593356$export$b63360e46a4e6d92).RowTree) !== (0, $4fc0d4cb0e570e63$export$c263d91fb644e7a0)(apiRef)) groupRows();
    }, [
        apiRef,
        groupRows
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'strategyAvailabilityChange', handleStrategyActivityChange);
    /**
   * APPLIERS
   */ const applyHydrateRowsProcessor = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            const response = apiRef.current.unstable_applyPipeProcessors('hydrateRows', {
                tree: (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef),
                treeDepths: (0, $4fc0d4cb0e570e63$export$eb24598525413286)(apiRef),
                dataRowIds: (0, $4fc0d4cb0e570e63$export$c7dcaab5e573753)(apiRef),
                dataRowIdToModelLookup: (0, $4fc0d4cb0e570e63$export$37767f9110c99048)(apiRef)
            });
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, response, {
                    totalTopLevelRowCount: (0, $4ab53eafabc4b920$export$e6ee03f0394a9759)({
                        tree: response.tree,
                        rowCountProp: props.rowCount
                    })
                })
            });
        });
        apiRef.current.publishEvent('rowsSet');
    }, [
        apiRef,
        props.rowCount
    ]);
    (0, $c1adda9e70e08895$export$98b68054bf03cb4)(apiRef, 'hydrateRows', applyHydrateRowsProcessor);
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, rowApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, rowProApi, props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, rowProPrivateApi, 'private');
    // The effect do not track any value defined synchronously during the 1st render by hooks called after `useGridRows`
    // As a consequence, the state generated by the 1st run of this useEffect will always be equal to the initialization one
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        let isRowCountPropUpdated = false;
        if (props.rowCount !== lastRowCount.current) {
            isRowCountPropUpdated = true;
            lastRowCount.current = props.rowCount;
        }
        const currentRows = props.dataSource ? (0, $4fc0d4cb0e570e63$export$161f5ccecdc30f42)(apiRef) : props.rows;
        const areNewRowsAlreadyInState = apiRef.current.caches.rows.rowsBeforePartialUpdates === currentRows;
        const isNewLoadingAlreadyInState = apiRef.current.caches.rows.loadingPropBeforePartialUpdates === props.loading;
        const isNewRowCountAlreadyInState = apiRef.current.caches.rows.rowCountPropBeforePartialUpdates === props.rowCount;
        // The new rows have already been applied (most likely in the `'rowGroupsPreProcessingChange'` listener)
        if (areNewRowsAlreadyInState) {
            // If the loading prop has changed, we need to update its value in the state because it won't be done by `throttledRowsChange`
            if (!isNewLoadingAlreadyInState) {
                apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                        rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, {
                            loading: props.loading
                        })
                    }));
                apiRef.current.caches.rows.loadingPropBeforePartialUpdates = props.loading;
            }
            if (!isNewRowCountAlreadyInState) {
                apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                        rows: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.rows, {
                            totalRowCount: Math.max(props.rowCount || 0, state.rows.totalRowCount),
                            totalTopLevelRowCount: Math.max(props.rowCount || 0, state.rows.totalTopLevelRowCount)
                        })
                    }));
                apiRef.current.caches.rows.rowCountPropBeforePartialUpdates = props.rowCount;
            }
            if (!isRowCountPropUpdated) return;
        }
        logger.debug(`Updating all rows, new length ${currentRows?.length}`);
        throttledRowsChange({
            cache: (0, $4ab53eafabc4b920$export$3496927f169f2d35)({
                rows: currentRows,
                getRowId: props.getRowId,
                loading: props.loading,
                rowCount: props.rowCount
            }),
            throttle: false
        });
    }, [
        props.rows,
        props.rowCount,
        props.getRowId,
        props.loading,
        props.dataSource,
        logger,
        throttledRowsChange,
        apiRef
    ]);
};





const $6767afadae519c6d$var$createFlatRowTree = (rows)=>{
    const tree = {
        [(0, $4ab53eafabc4b920$export$433b924dc2506913)]: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $4ab53eafabc4b920$export$96a607054e9bfd0c)(), {
            children: rows
        })
    };
    for(let i = 0; i < rows.length; i += 1){
        const rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: (0, $4ab53eafabc4b920$export$433b924dc2506913),
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: (0, $9e68111fb02b49e8$export$84214fbf04c4094),
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
const $6767afadae519c6d$var$updateFlatRowTree = ({ previousTree: previousTree, actions: actions })=>{
    const tree = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousTree);
    const idsToRemoveFromRootGroup = {};
    for(let i = 0; i < actions.remove.length; i += 1){
        const idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(let i = 0; i < actions.insert.length; i += 1){
        const idToInsert = actions.insert[i];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: (0, $4ab53eafabc4b920$export$433b924dc2506913),
            type: 'leaf',
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    const rootGroup = tree[0, $4ab53eafabc4b920$export$433b924dc2506913];
    let rootGroupChildren = [
        ...rootGroup.children,
        ...actions.insert
    ];
    if (Object.values(idsToRemoveFromRootGroup).length) rootGroupChildren = rootGroupChildren.filter((id)=>!idsToRemoveFromRootGroup[id]);
    tree[0, $4ab53eafabc4b920$export$433b924dc2506913] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: (0, $9e68111fb02b49e8$export$84214fbf04c4094),
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
const $6767afadae519c6d$var$flatRowTreeCreationMethod = (params)=>{
    if (params.updates.type === 'full') return $6767afadae519c6d$var$createFlatRowTree(params.updates.rows);
    return $6767afadae519c6d$var$updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
const $6767afadae519c6d$export$cc1daa683bbe5702 = (apiRef)=>{
    (0, $0e27fd6eb449426d$export$102a3f5a042c47c4)(apiRef, (0, $9e68111fb02b49e8$export$84214fbf04c4094), 'rowTreeCreation', $6767afadae519c6d$var$flatRowTreeCreationMethod);
};



var $acw62 = parcelRequire("acw62");





class $c0ea11a50e686349$export$f6bd549412d13610 extends Error {
}
function $c0ea11a50e686349$export$d5da41ef394db9ef(apiRef, props, configuration) {
    const getColumnHeaderParams = $acw62.useCallback((field)=>({
            field: field,
            colDef: apiRef.current.getColumn(field)
        }), [
        apiRef
    ]);
    const getRowParams = $acw62.useCallback((id)=>{
        const row = apiRef.current.getRow(id);
        if (!row) throw new $c0ea11a50e686349$export$f6bd549412d13610(`No row with id #${id} found`);
        const params = {
            id: id,
            columns: apiRef.current.getAllColumns(),
            row: row
        };
        return params;
    }, [
        apiRef
    ]);
    const getCellParamsForRow = $acw62.useCallback((id, field, row, { cellMode: cellMode, colDef: colDef, hasFocus: hasFocus, rowNode: rowNode, tabIndex: tabIndex, value: forcedValue, formattedValue: forcedFormattedValue })=>{
        let value = row[field];
        if (forcedValue !== undefined) value = forcedValue;
        else if (colDef?.valueGetter) value = colDef.valueGetter(value, row, colDef, apiRef);
        let formattedValue = value;
        if (forcedFormattedValue !== undefined) formattedValue = forcedFormattedValue;
        else if (colDef?.valueFormatter) formattedValue = colDef.valueFormatter(value, row, colDef, apiRef);
        const params = {
            id: id,
            field: field,
            row: row,
            rowNode: rowNode,
            colDef: colDef,
            cellMode: cellMode,
            hasFocus: hasFocus,
            tabIndex: tabIndex,
            value: value,
            formattedValue: formattedValue,
            isEditable: false,
            api: apiRef.current
        };
        params.isEditable = colDef && apiRef.current.isCellEditable(params);
        return params;
    }, [
        apiRef
    ]);
    const getCellParams = $acw62.useCallback((id, field)=>{
        const row = apiRef.current.getRow(id);
        const rowNode = (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, id);
        if (!row || !rowNode) throw new $c0ea11a50e686349$export$f6bd549412d13610(`No row with id #${id} found`);
        const cellFocus = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
        const cellTabIndex = (0, $578d1f15adc16cb4$export$2c47652a1f657d56)(apiRef);
        const cellMode = apiRef.current.getCellMode(id, field);
        return apiRef.current.getCellParamsForRow(id, field, row, {
            colDef: props.listView && props.listViewColumn?.field === field ? (0, $cd4a4e6d71563ab7$export$aeeda57ada9bc1ee)(apiRef) : apiRef.current.getColumn(field),
            rowNode: rowNode,
            hasFocus: cellFocus !== null && cellFocus.field === field && cellFocus.id === id,
            tabIndex: cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === id ? 0 : -1,
            cellMode: cellMode
        });
    }, [
        apiRef,
        props.listView,
        props.listViewColumn?.field
    ]);
    const getColumnHeaderElement = $acw62.useCallback((field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $b2637ba08a26ef7b$export$94318ffb75913a0b)(apiRef.current.rootElementRef.current, field);
    }, [
        apiRef
    ]);
    const getRowElement = $acw62.useCallback((id)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $b2637ba08a26ef7b$export$9bc8bb868a922a5f)(apiRef.current.rootElementRef.current, id);
    }, [
        apiRef
    ]);
    const getCellElement = $acw62.useCallback((id, field)=>{
        if (!apiRef.current.rootElementRef.current) return null;
        return (0, $b2637ba08a26ef7b$export$44827662627a59)(apiRef.current.rootElementRef.current, {
            id: id,
            field: field
        });
    }, [
        apiRef
    ]);
    const overridableParamsMethods = configuration.hooks.useGridParamsOverridableMethods(apiRef);
    const paramsApi = {
        getCellValue: overridableParamsMethods.getCellValue,
        getCellParams: getCellParams,
        getCellElement: getCellElement,
        getRowValue: overridableParamsMethods.getRowValue,
        getRowFormattedValue: overridableParamsMethods.getRowFormattedValue,
        getRowParams: getRowParams,
        getRowElement: getRowElement,
        getColumnHeaderParams: getColumnHeaderParams,
        getColumnHeaderElement: getColumnHeaderElement
    };
    const paramsPrivateApi = {
        getCellParamsForRow: getCellParamsForRow
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, paramsApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, paramsPrivateApi, 'private');
}




var $acw62 = parcelRequire("acw62");




















'use client';
const $a568d9675a7040bd$var$emptyModel = {
    type: 'include',
    ids: new Set()
};
const $a568d9675a7040bd$export$73be1d69367eeb5b = (state, props)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        rowSelection: props.rowSelection ? props.rowSelectionModel ?? $a568d9675a7040bd$var$emptyModel : $a568d9675a7040bd$var$emptyModel
    });
const $a568d9675a7040bd$export$3e2b6b991d9d83f0 = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridSelection');
    const runIfRowSelectionIsEnabled = $acw62.useCallback((callback)=>(...args)=>{
            if (props.rowSelection) callback(...args);
        }, [
        props.rowSelection
    ]);
    const isNestedData = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$4cdbe576751dd8e2)) > 1;
    const applyAutoSelection = props.signature !== (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid && (props.rowSelectionPropagation?.parents || props.rowSelectionPropagation?.descendants) && isNestedData;
    const propRowSelectionModel = $acw62.useMemo(()=>{
        return props.rowSelectionModel;
    }, [
        props.rowSelectionModel
    ]);
    const lastRowToggled = $acw62.useRef(null);
    apiRef.current.registerControlState({
        stateId: 'rowSelection',
        propModel: propRowSelectionModel,
        propOnChange: props.onRowSelectionModelChange,
        stateSelector: (0, $32777ac93d35a3f3$export$f663bee74a6091fc),
        changeEvent: 'rowSelectionChange'
    });
    const { checkboxSelection: checkboxSelection, disableRowSelectionOnClick: disableRowSelectionOnClick, isRowSelectable: propIsRowSelectable } = props;
    const canHaveMultipleSelection = (0, $5e9cd545f0675d8f$export$cfcdc2e1121f7851)(props);
    const tree = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d));
    const expandMouseRowRangeSelection = $acw62.useCallback((id)=>{
        let endId = id;
        const startId = lastRowToggled.current ?? id;
        const isSelected = apiRef.current.isRowSelected(id);
        if (isSelected) {
            const visibleRowIds = (0, $51d9da8b83918212$export$7a99837e2fd93e42)(apiRef);
            const startIndex = visibleRowIds.findIndex((rowId)=>rowId === startId);
            const endIndex = visibleRowIds.findIndex((rowId)=>rowId === endId);
            if (startIndex === endIndex) return;
            if (startIndex > endIndex) endId = visibleRowIds[endIndex + 1];
            else endId = visibleRowIds[endIndex - 1];
        }
        lastRowToggled.current = id;
        apiRef.current.selectRowRange({
            startId: startId,
            endId: endId
        }, !isSelected);
    }, [
        apiRef
    ]);
    const getRowsToBeSelected = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        const rowsToBeSelected = props.pagination && props.checkboxSelectionVisibleOnly && props.paginationMode === 'client' ? (0, $e164e26c82788fb1$export$c1f6a976375edd4a)(apiRef) : (0, $51d9da8b83918212$export$7a99837e2fd93e42)(apiRef);
        return rowsToBeSelected;
    });
    /*
   * API METHODS
   */ const setRowSelectionModel = $acw62.useCallback((model, reason)=>{
        if (props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid && !canHaveMultipleSelection && (model.type !== 'include' || model.ids.size > 1)) throw new Error([
            'MUI X: `rowSelectionModel` can only contain 1 item in DataGrid.',
            'You need to upgrade to DataGridPro or DataGridPremium component to unlock multiple selection.'
        ].join('\n'));
        const currentModel = (0, $32777ac93d35a3f3$export$f663bee74a6091fc)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting selection model`);
            apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    rowSelection: props.rowSelection ? model : $a568d9675a7040bd$var$emptyModel
                }), reason);
        }
    }, [
        apiRef,
        logger,
        props.rowSelection,
        props.signature,
        canHaveMultipleSelection
    ]);
    const isRowSelected = $acw62.useCallback((id)=>{
        const selectionManager = (0, $32777ac93d35a3f3$export$a13307f39ccef042)(apiRef);
        return selectionManager.has(id);
    }, [
        apiRef
    ]);
    const isRowSelectable = $acw62.useCallback((id)=>{
        if (props.rowSelection === false) return false;
        if (propIsRowSelectable && !propIsRowSelectable(apiRef.current.getRowParams(id))) return false;
        const rowNode = (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, id);
        if (rowNode?.type === 'footer' || rowNode?.type === 'pinnedRow') return false;
        return true;
    }, [
        apiRef,
        props.rowSelection,
        propIsRowSelectable
    ]);
    const getSelectedRows = $acw62.useCallback(()=>(0, $32777ac93d35a3f3$export$815b73af677cc8a1)(apiRef), [
        apiRef
    ]);
    const selectRow = $acw62.useCallback((id, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.isRowSelectable(id)) return;
        lastRowToggled.current = id;
        if (resetSelection) {
            logger.debug(`Setting selection for row ${id}`);
            const newSelectionModel = {
                type: 'include',
                ids: new Set()
            };
            const addRow = (rowId)=>{
                newSelectionModel.ids.add(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $5e9cd545f0675d8f$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            }
            apiRef.current.setRowSelectionModel(newSelectionModel, 'singleRowSelection');
        } else {
            logger.debug(`Toggling selection for row ${id}`);
            const selectionModel = (0, $32777ac93d35a3f3$export$f663bee74a6091fc)(apiRef);
            const newSelectionModel = {
                type: selectionModel.type,
                ids: new Set(selectionModel.ids)
            };
            const selectionManager = (0, $0f89d07cedceae67$export$c0efd9f64c7d532a)(newSelectionModel);
            selectionManager.unselect(id);
            const addRow = (rowId)=>{
                selectionManager.select(rowId);
            };
            const removeRow = (rowId)=>{
                selectionManager.unselect(rowId);
            };
            if (isSelected) {
                addRow(id);
                if (applyAutoSelection) (0, $5e9cd545f0675d8f$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            } else if (applyAutoSelection) (0, $5e9cd545f0675d8f$export$dbbc58cbb95afec2)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
            const isSelectionValid = newSelectionModel.type === 'include' && newSelectionModel.ids.size < 2 || canHaveMultipleSelection;
            if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelectionModel, 'singleRowSelection');
        }
    }, [
        apiRef,
        logger,
        applyAutoSelection,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        canHaveMultipleSelection
    ]);
    const selectRows = $acw62.useCallback((ids, isSelected = true, resetSelection = false)=>{
        logger.debug(`Setting selection for several rows`);
        if (props.rowSelection === false) return;
        const selectableIds = new Set();
        for(let i = 0; i < ids.length; i += 1){
            const id = ids[i];
            if (apiRef.current.isRowSelectable(id)) selectableIds.add(id);
        }
        const currentSelectionModel = (0, $32777ac93d35a3f3$export$f663bee74a6091fc)(apiRef);
        let newSelectionModel;
        if (resetSelection) {
            newSelectionModel = {
                type: 'include',
                ids: selectableIds
            };
            if (isSelected) {
                const selectionManager = (0, $0f89d07cedceae67$export$c0efd9f64c7d532a)(newSelectionModel);
                if (applyAutoSelection) {
                    const addRow = (rowId)=>{
                        selectionManager.select(rowId);
                    };
                    for (const id of selectableIds)(0, $5e9cd545f0675d8f$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
                }
            } else newSelectionModel.ids = new Set();
            if (currentSelectionModel.type === newSelectionModel.type && newSelectionModel.ids.size === currentSelectionModel.ids.size && Array.from(newSelectionModel.ids).every((id)=>currentSelectionModel.ids.has(id))) return;
        } else {
            newSelectionModel = {
                type: currentSelectionModel.type,
                ids: new Set(currentSelectionModel.ids)
            };
            const selectionManager = (0, $0f89d07cedceae67$export$c0efd9f64c7d532a)(newSelectionModel);
            const addRow = (rowId)=>{
                selectionManager.select(rowId);
            };
            const removeRow = (rowId)=>{
                selectionManager.unselect(rowId);
            };
            for (const id of selectableIds)if (isSelected) {
                selectionManager.select(id);
                if (applyAutoSelection) (0, $5e9cd545f0675d8f$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow);
            } else {
                removeRow(id);
                if (applyAutoSelection) (0, $5e9cd545f0675d8f$export$dbbc58cbb95afec2)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, removeRow);
            }
        }
        const isSelectionValid = newSelectionModel.type === 'include' && newSelectionModel.ids.size < 2 || canHaveMultipleSelection;
        if (isSelectionValid) apiRef.current.setRowSelectionModel(newSelectionModel, 'multipleRowsSelection');
    }, [
        logger,
        applyAutoSelection,
        canHaveMultipleSelection,
        apiRef,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        props.rowSelection
    ]);
    const getPropagatedRowSelectionModel = $acw62.useCallback((inputSelectionModel)=>{
        if (!isNestedData || !applyAutoSelection || inputSelectionModel.type === 'exclude' || inputSelectionModel.ids.size === 0 && inputSelectionModel.type === 'include') return inputSelectionModel;
        const propagatedSelectionModel = {
            type: inputSelectionModel.type,
            ids: new Set(inputSelectionModel.ids)
        };
        const selectionManager = (0, $0f89d07cedceae67$export$c0efd9f64c7d532a)(propagatedSelectionModel);
        const addRow = (rowId)=>{
            selectionManager.select(rowId);
        };
        for (const id of inputSelectionModel.ids)(0, $5e9cd545f0675d8f$export$a8171774e887a9d0)(apiRef, tree, id, props.rowSelectionPropagation?.descendants ?? false, props.rowSelectionPropagation?.parents ?? false, addRow, selectionManager);
        return propagatedSelectionModel;
    }, [
        apiRef,
        tree,
        props.rowSelectionPropagation?.descendants,
        props.rowSelectionPropagation?.parents,
        isNestedData,
        applyAutoSelection
    ]);
    const selectRowRange = $acw62.useCallback(({ startId: startId, endId: endId }, isSelected = true, resetSelection = false)=>{
        if (!apiRef.current.getRow(startId) || !apiRef.current.getRow(endId)) return;
        logger.debug(`Expanding selection from row ${startId} to row ${endId}`);
        // Using rows from all pages allow to select a range across several pages
        const allPagesRowIds = (0, $51d9da8b83918212$export$7a99837e2fd93e42)(apiRef);
        const startIndex = allPagesRowIds.indexOf(startId);
        const endIndex = allPagesRowIds.indexOf(endId);
        const [start, end] = startIndex > endIndex ? [
            endIndex,
            startIndex
        ] : [
            startIndex,
            endIndex
        ];
        const rowsBetweenStartAndEnd = allPagesRowIds.slice(start, end + 1);
        apiRef.current.selectRows(rowsBetweenStartAndEnd, isSelected, resetSelection);
    }, [
        apiRef,
        logger
    ]);
    const selectionPublicApi = {
        selectRow: selectRow,
        setRowSelectionModel: setRowSelectionModel,
        getSelectedRows: getSelectedRows,
        isRowSelected: isRowSelected,
        isRowSelectable: isRowSelectable
    };
    const selectionPrivateApi = {
        selectRows: selectRows,
        selectRowRange: selectRowRange,
        getPropagatedRowSelectionModel: getPropagatedRowSelectionModel
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, selectionPublicApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, selectionPrivateApi, props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGrid ? 'private' : 'public');
    /*
   * EVENTS
   */ const isFirstRender = $acw62.useRef(true);
    const removeOutdatedSelection = $acw62.useCallback((sortModelUpdated = false)=>{
        if (isFirstRender.current) return;
        const currentSelection = (0, $32777ac93d35a3f3$export$f663bee74a6091fc)(apiRef);
        const rowsLookup = (0, $4fc0d4cb0e570e63$export$37767f9110c99048)(apiRef);
        const rowTree = (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef);
        const filteredRowsLookup = (0, $51d9da8b83918212$export$6d031b6e8cbaf41c)(apiRef);
        const isNonExistent = (id)=>{
            if (props.filterMode === 'server') return !rowsLookup[id];
            return !rowTree[id] || filteredRowsLookup[id] === false;
        };
        const newSelectionModel = {
            type: currentSelection.type,
            ids: new Set(currentSelection.ids)
        };
        const selectionManager = (0, $0f89d07cedceae67$export$c0efd9f64c7d532a)(newSelectionModel);
        let hasChanged = false;
        for (const id of currentSelection.ids){
            if (isNonExistent(id)) {
                if (props.keepNonExistentRowsSelected) continue;
                selectionManager.unselect(id);
                hasChanged = true;
                continue;
            }
            if (!props.rowSelectionPropagation?.parents) continue;
            const node = tree[id];
            if (node?.type === 'group') {
                const isAutoGenerated = node.isAutoGenerated;
                if (isAutoGenerated) {
                    selectionManager.unselect(id);
                    hasChanged = true;
                    continue;
                }
                // Keep previously selected tree data parents selected if all their children are filtered out
                if (!node.children.every((childId)=>filteredRowsLookup[childId] === false)) {
                    selectionManager.unselect(id);
                    hasChanged = true;
                }
            }
        }
        // For nested data, on row tree updation (filtering, adding rows, etc.) when the selection is
        // not empty, we need to re-run scanning of the tree to propagate the selection changes
        // Example: A parent whose de-selected children are filtered out should now be selected
        const shouldReapplyPropagation = isNestedData && props.rowSelectionPropagation?.parents && (newSelectionModel.ids.size > 0 || // In case of exclude selection, newSelectionModel.ids.size === 0 means all rows are selected
        newSelectionModel.type === 'exclude');
        if (hasChanged || shouldReapplyPropagation && !sortModelUpdated) {
            if (shouldReapplyPropagation) {
                if (newSelectionModel.type === 'exclude') {
                    const unfilteredSelectedRowIds = getRowsToBeSelected();
                    const selectedRowIds = [];
                    for(let i = 0; i < unfilteredSelectedRowIds.length; i += 1){
                        const rowId = unfilteredSelectedRowIds[i];
                        if ((props.keepNonExistentRowsSelected || !isNonExistent(rowId)) && selectionManager.has(rowId)) selectedRowIds.push(rowId);
                    }
                    apiRef.current.selectRows(selectedRowIds, true, true);
                } else apiRef.current.selectRows(Array.from(newSelectionModel.ids), true, true);
            } else apiRef.current.setRowSelectionModel(newSelectionModel, 'multipleRowsSelection');
        }
    }, [
        apiRef,
        isNestedData,
        props.rowSelectionPropagation?.parents,
        props.keepNonExistentRowsSelected,
        props.filterMode,
        tree,
        getRowsToBeSelected
    ]);
    const handleSingleRowSelection = $acw62.useCallback((id, event)=>{
        const hasCtrlKey = event.metaKey || event.ctrlKey;
        // multiple selection is only allowed if:
        // - it is a checkboxSelection
        // - it is a keyboard selection
        // - Ctrl is pressed
        const isMultipleSelectionDisabled = !checkboxSelection && !hasCtrlKey && !(0, $2c033a607636d88a$export$130b789831072f4c)(event);
        const resetSelection = !canHaveMultipleSelection || isMultipleSelectionDisabled;
        const isSelected = apiRef.current.isRowSelected(id);
        const selectedRowsCount = (0, $32777ac93d35a3f3$export$408e67b791fe352)(apiRef);
        // Clicking on a row should toggle the selection except when a range of rows is already selected and the selection should reset
        // In that case, we want to keep the current row selected (https://github.com/mui/mui-x/pull/15509#discussion_r1878082687)
        const shouldStaySelected = selectedRowsCount > 1 && resetSelection;
        const newSelectionState = shouldStaySelected || !isSelected;
        apiRef.current.selectRow(id, newSelectionState, resetSelection);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection
    ]);
    const handleRowClick = $acw62.useCallback((params, event)=>{
        if (disableRowSelectionOnClick) return;
        const field = event.target.closest(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).cell}`)?.getAttribute('data-field');
        if (field === (0, $fa1dc905b3e7910f$export$b2e9ab6103a664ad).field) // click on checkbox should not trigger row selection
        return;
        if (field === (0, $d6d7a429fd810b6e$export$6e5a576305a34719)) // click to open the detail panel should not select the row
        return;
        if (field) {
            const column = apiRef.current.getColumn(field);
            if (column?.type === (0, $09b8609275e30076$export$e2523ab9efeb7465)) return;
        }
        const rowNode = (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, params.id);
        if (rowNode.type === 'pinnedRow') return;
        if (event.shiftKey && canHaveMultipleSelection) expandMouseRowRangeSelection(params.id);
        else handleSingleRowSelection(params.id, event);
    }, [
        disableRowSelectionOnClick,
        canHaveMultipleSelection,
        apiRef,
        expandMouseRowRangeSelection,
        handleSingleRowSelection
    ]);
    const preventSelectionOnShift = $acw62.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.shiftKey) window.getSelection()?.removeAllRanges();
    }, [
        canHaveMultipleSelection
    ]);
    const handleRowSelectionCheckboxChange = $acw62.useCallback((params, event)=>{
        if (canHaveMultipleSelection && event.nativeEvent.shiftKey) expandMouseRowRangeSelection(params.id);
        else apiRef.current.selectRow(params.id, params.value, !canHaveMultipleSelection);
    }, [
        apiRef,
        expandMouseRowRangeSelection,
        canHaveMultipleSelection
    ]);
    const toggleAllRows = $acw62.useCallback((value)=>{
        const filterModel = (0, $51d9da8b83918212$export$280aedb9454597a5)(apiRef);
        const quickFilterModel = (0, $51d9da8b83918212$export$6f9fe133e2c56816)(apiRef);
        const hasFilters = filterModel.items.length > 0 || quickFilterModel?.some((val)=>val.length);
        if (!props.isRowSelectable && !props.checkboxSelectionVisibleOnly && (!isNestedData || props.rowSelectionPropagation?.descendants) && !hasFilters && !props.disableRowSelectionExcludeModel) apiRef.current.setRowSelectionModel({
            type: value ? 'exclude' : 'include',
            ids: new Set()
        }, 'multipleRowsSelection');
        else apiRef.current.selectRows(getRowsToBeSelected(), value);
    }, [
        apiRef,
        getRowsToBeSelected,
        props.checkboxSelectionVisibleOnly,
        props.isRowSelectable,
        props.rowSelectionPropagation?.descendants,
        props.disableRowSelectionExcludeModel,
        isNestedData
    ]);
    const handleHeaderSelectionCheckboxChange = $acw62.useCallback((params)=>{
        toggleAllRows(params.value);
    }, [
        toggleAllRows
    ]);
    const handleCellKeyDown = $acw62.useCallback((params, event)=>{
        // Get the most recent cell mode because it may have been changed by another listener
        if (apiRef.current.getCellMode(params.id, params.field) === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit) return;
        // Ignore portal
        // Do not apply shortcuts if the focus is not on the cell root component
        if ((0, $b2637ba08a26ef7b$export$8ce496ad3bfbe3a6)(event)) return;
        if ((0, $2c033a607636d88a$export$e13d96c38a470518)(event.key) && event.shiftKey) {
            // The cell that has focus after the keyboard navigation
            const focusCell = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
            if (focusCell && focusCell.id !== params.id) {
                event.preventDefault();
                const isNextRowSelected = apiRef.current.isRowSelected(focusCell.id);
                if (!canHaveMultipleSelection) {
                    apiRef.current.selectRow(focusCell.id, !isNextRowSelected, true);
                    return;
                }
                const newRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(focusCell.id);
                const previousRowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(params.id);
                let start;
                let end;
                if (newRowIndex > previousRowIndex) {
                    if (isNextRowSelected) {
                        // We are navigating to the bottom of the page and adding selected rows
                        start = previousRowIndex;
                        end = newRowIndex - 1;
                    } else {
                        // We are navigating to the bottom of the page and removing selected rows
                        start = previousRowIndex;
                        end = newRowIndex;
                    }
                } else // eslint-disable-next-line no-lonely-if
                if (isNextRowSelected) {
                    // We are navigating to the top of the page and removing selected rows
                    start = newRowIndex + 1;
                    end = previousRowIndex;
                } else {
                    // We are navigating to the top of the page and adding selected rows
                    start = newRowIndex;
                    end = previousRowIndex;
                }
                const visibleRows = (0, $2b6a1e01125c3822$export$79b9fa322a34430b)(apiRef);
                const rowsBetweenStartAndEnd = [];
                for(let i = start; i <= end; i += 1)rowsBetweenStartAndEnd.push(visibleRows.rows[i].id);
                apiRef.current.selectRows(rowsBetweenStartAndEnd, !isNextRowSelected);
                return;
            }
        }
        if (event.key === ' ' && event.shiftKey) {
            event.preventDefault();
            handleSingleRowSelection(params.id, event);
            return;
        }
        if (String.fromCharCode(event.keyCode) === 'A' && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            toggleAllRows(true);
        }
    }, [
        apiRef,
        canHaveMultipleSelection,
        handleSingleRowSelection,
        toggleAllRows
    ]);
    const syncControlledState = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        if (!props.rowSelection) {
            apiRef.current.setRowSelectionModel($a568d9675a7040bd$var$emptyModel);
            return;
        }
        if (propRowSelectionModel === undefined) return;
        if (!applyAutoSelection || !isNestedData || propRowSelectionModel.type === 'include' && propRowSelectionModel.ids.size === 0) {
            apiRef.current.setRowSelectionModel(propRowSelectionModel);
            return;
        }
        const newSelectionModel = apiRef.current.getPropagatedRowSelectionModel(propRowSelectionModel);
        if (newSelectionModel.type !== propRowSelectionModel.type || newSelectionModel.ids.size !== propRowSelectionModel.ids.size || !Array.from(propRowSelectionModel.ids).every((id)=>newSelectionModel.ids.has(id))) {
            apiRef.current.setRowSelectionModel(newSelectionModel);
            return;
        }
        apiRef.current.setRowSelectionModel(propRowSelectionModel);
    });
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'sortedRowsSet', runIfRowSelectionIsEnabled(()=>removeOutdatedSelection(true)));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'filteredRowsSet', runIfRowSelectionIsEnabled(()=>removeOutdatedSelection()));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowClick', runIfRowSelectionIsEnabled(handleRowClick));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowSelectionCheckboxChange', runIfRowSelectionIsEnabled(handleRowSelectionCheckboxChange));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'headerSelectionCheckboxChange', handleHeaderSelectionCheckboxChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellMouseDown', runIfRowSelectionIsEnabled(preventSelectionOnShift));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'cellKeyDown', runIfRowSelectionIsEnabled(handleCellKeyDown));
    /*
   * EFFECTS
   */ $acw62.useEffect(()=>{
        syncControlledState();
    }, [
        apiRef,
        propRowSelectionModel,
        props.rowSelection,
        syncControlledState
    ]);
    const isStateControlled = propRowSelectionModel != null;
    $acw62.useEffect(()=>{
        if (isStateControlled || !props.rowSelection || typeof isRowSelectable !== 'function') return;
        // props.isRowSelectable changed
        const currentSelection = (0, $32777ac93d35a3f3$export$f663bee74a6091fc)(apiRef);
        if (currentSelection.type !== 'include') return;
        const selectableIds = new Set();
        for (const id of currentSelection.ids)if (isRowSelectable(id)) selectableIds.add(id);
        if (selectableIds.size < currentSelection.ids.size) apiRef.current.setRowSelectionModel({
            type: currentSelection.type,
            ids: selectableIds
        });
    }, [
        apiRef,
        isRowSelectable,
        isStateControlled,
        props.rowSelection
    ]);
    $acw62.useEffect(()=>{
        if (!props.rowSelection || isStateControlled) return;
        const currentSelection = (0, $32777ac93d35a3f3$export$f663bee74a6091fc)(apiRef);
        if (!canHaveMultipleSelection && (currentSelection.type === 'include' && currentSelection.ids.size > 1 || currentSelection.type === 'exclude')) // See https://github.com/mui/mui-x/issues/8455
        apiRef.current.setRowSelectionModel($a568d9675a7040bd$var$emptyModel);
    }, [
        apiRef,
        canHaveMultipleSelection,
        checkboxSelection,
        isStateControlled,
        props.rowSelection
    ]);
    $acw62.useEffect(()=>{
        runIfRowSelectionIsEnabled(removeOutdatedSelection);
    }, [
        removeOutdatedSelection,
        runIfRowSelectionIsEnabled
    ]);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) isFirstRender.current = false;
    }, []);
};




var $acw62 = parcelRequire("acw62");




const $380be33724089901$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    return $acw62.useMemo(()=>{
        const slots = {
            cellCheckbox: [
                'cellCheckbox'
            ],
            columnHeaderCheckbox: [
                'columnHeaderCheckbox'
            ]
        };
        return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
    }, [
        classes
    ]);
};
const $380be33724089901$export$fa1d7b0897c018ea = (apiRef, props)=>{
    const ownerState = {
        classes: props.classes
    };
    const classes = $380be33724089901$var$useUtilityClasses(ownerState);
    const updateSelectionColumn = $acw62.useCallback((columnsState)=>{
        const selectionColumn = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $fa1dc905b3e7910f$export$b2e9ab6103a664ad), {
            cellClassName: classes.cellCheckbox,
            headerClassName: classes.columnHeaderCheckbox,
            headerName: apiRef.current.getLocaleText('checkboxSelectionHeaderName')
        });
        const shouldHaveSelectionColumn = props.checkboxSelection;
        const hasSelectionColumn = columnsState.lookup[0, $fa1dc905b3e7910f$export$322dfed7a1df1b02] != null;
        if (shouldHaveSelectionColumn && !hasSelectionColumn) {
            columnsState.lookup[0, $fa1dc905b3e7910f$export$322dfed7a1df1b02] = selectionColumn;
            columnsState.orderedFields = [
                (0, $fa1dc905b3e7910f$export$322dfed7a1df1b02),
                ...columnsState.orderedFields
            ];
        } else if (!shouldHaveSelectionColumn && hasSelectionColumn) {
            delete columnsState.lookup[0, $fa1dc905b3e7910f$export$322dfed7a1df1b02];
            columnsState.orderedFields = columnsState.orderedFields.filter((field)=>field !== (0, $fa1dc905b3e7910f$export$322dfed7a1df1b02));
        } else if (shouldHaveSelectionColumn && hasSelectionColumn) {
            columnsState.lookup[0, $fa1dc905b3e7910f$export$322dfed7a1df1b02] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, selectionColumn, columnsState.lookup[0, $fa1dc905b3e7910f$export$322dfed7a1df1b02]);
            // If the column is not in the columns array (not a custom selection column), move it to the beginning of the column order
            if (!props.columns.some((col)=>col.field === (0, $fa1dc905b3e7910f$export$322dfed7a1df1b02))) columnsState.orderedFields = [
                (0, $fa1dc905b3e7910f$export$322dfed7a1df1b02),
                ...columnsState.orderedFields.filter((field)=>field !== (0, $fa1dc905b3e7910f$export$322dfed7a1df1b02))
            ];
        }
        return columnsState;
    }, [
        apiRef,
        classes,
        props.columns,
        props.checkboxSelection
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'hydrateColumns', updateSelectionColumn);
};




var $acw62 = parcelRequire("acw62");












const $76936a01e0647ff8$export$996e35c2eef351ae = (state, props)=>{
    const sortModel = props.sortModel ?? props.initialState?.sorting?.sortModel ?? [];
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        sorting: {
            sortModel: (0, $877e98c7ff4d0a4a$export$13eeac5ac15e0be5)(sortModel, props.disableMultipleColumnsSorting),
            sortedRows: []
        }
    });
};
const $76936a01e0647ff8$export$951287757eb5d93c = (apiRef, props)=>{
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridSorting');
    apiRef.current.registerControlState({
        stateId: 'sortModel',
        propModel: props.sortModel,
        propOnChange: props.onSortModelChange,
        stateSelector: (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9),
        changeEvent: 'sortModelChange'
    });
    const upsertSortModel = $acw62.useCallback((field, sortItem)=>{
        const sortModel = (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9)(apiRef);
        const existingIdx = sortModel.findIndex((c)=>c.field === field);
        let newSortModel = [
            ...sortModel
        ];
        if (existingIdx > -1) {
            if (sortItem?.sort == null) newSortModel.splice(existingIdx, 1);
            else newSortModel.splice(existingIdx, 1, sortItem);
        } else newSortModel = [
            ...sortModel,
            sortItem
        ];
        return newSortModel;
    }, [
        apiRef
    ]);
    const createSortItem = $acw62.useCallback((col, directionOverride)=>{
        const sortModel = (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9)(apiRef);
        const existing = sortModel.find((c)=>c.field === col.field);
        if (existing) {
            const nextSort = directionOverride === undefined ? (0, $877e98c7ff4d0a4a$export$b3d84351ab2e3580)(col.sortingOrder ?? props.sortingOrder, existing.sort) : directionOverride;
            return nextSort === undefined ? undefined : (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, existing, {
                sort: nextSort
            });
        }
        return {
            field: col.field,
            sort: directionOverride === undefined ? (0, $877e98c7ff4d0a4a$export$b3d84351ab2e3580)(col.sortingOrder ?? props.sortingOrder) : directionOverride
        };
    }, [
        apiRef,
        props.sortingOrder
    ]);
    const addColumnMenuItem = $acw62.useCallback((columnMenuItems, colDef)=>{
        if (colDef == null || colDef.sortable === false || props.disableColumnSorting) return columnMenuItems;
        const sortingOrder = colDef.sortingOrder || props.sortingOrder;
        if (sortingOrder.some((item)=>!!item)) return [
            ...columnMenuItems,
            'columnMenuSortItem'
        ];
        return columnMenuItems;
    }, [
        props.sortingOrder,
        props.disableColumnSorting
    ]);
    /**
   * API METHODS
   */ const applySorting = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>{
            if (props.sortingMode === 'server') {
                logger.debug('Skipping sorting rows as sortingMode = server');
                return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                    sorting: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.sorting, {
                        sortedRows: (0, $4ab53eafabc4b920$export$9380f4bcafb87e49)((0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef), (0, $4ab53eafabc4b920$export$433b924dc2506913), false)
                    })
                });
            }
            const sortModel = (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9)(apiRef);
            const sortRowList = (0, $877e98c7ff4d0a4a$export$b29e353d1a72dfda)(sortModel, apiRef);
            const sortedRows = apiRef.current.applyStrategyProcessor('sorting', {
                sortRowList: sortRowList
            });
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                sorting: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.sorting, {
                    sortedRows: sortedRows
                })
            });
        });
        apiRef.current.publishEvent('sortedRowsSet');
    }, [
        apiRef,
        logger,
        props.sortingMode
    ]);
    const setSortModel = $acw62.useCallback((model)=>{
        const currentModel = (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9)(apiRef);
        if (currentModel !== model) {
            logger.debug(`Setting sort model`);
            apiRef.current.setState((0, $877e98c7ff4d0a4a$export$3fc28d475ac000c0)(model, props.disableMultipleColumnsSorting));
            apiRef.current.applySorting();
        }
    }, [
        apiRef,
        logger,
        props.disableMultipleColumnsSorting
    ]);
    const sortColumn = $acw62.useCallback((field, direction, allowMultipleSorting)=>{
        const column = apiRef.current.getColumn(field);
        const sortItem = createSortItem(column, direction);
        let sortModel;
        if (!allowMultipleSorting || props.disableMultipleColumnsSorting) sortModel = sortItem?.sort == null ? [] : [
            sortItem
        ];
        else sortModel = upsertSortModel(column.field, sortItem);
        apiRef.current.setSortModel(sortModel);
    }, [
        apiRef,
        upsertSortModel,
        createSortItem,
        props.disableMultipleColumnsSorting
    ]);
    const getSortModel = $acw62.useCallback(()=>(0, $f0897a6c670e0208$export$55dcc66b73d9a0f9)(apiRef), [
        apiRef
    ]);
    const getSortedRows = $acw62.useCallback(()=>{
        const sortedRows = (0, $f0897a6c670e0208$export$8919e81647813e61)(apiRef);
        return sortedRows.map((row)=>row.model);
    }, [
        apiRef
    ]);
    const getSortedRowIds = $acw62.useCallback(()=>(0, $f0897a6c670e0208$export$e4979ad0a2db8752)(apiRef), [
        apiRef
    ]);
    const getRowIdFromRowIndex = $acw62.useCallback((index)=>apiRef.current.getSortedRowIds()[index], [
        apiRef
    ]);
    const sortApi = {
        getSortModel: getSortModel,
        getSortedRows: getSortedRows,
        getSortedRowIds: getSortedRowIds,
        getRowIdFromRowIndex: getRowIdFromRowIndex,
        setSortModel: setSortModel,
        sortColumn: sortColumn,
        applySorting: applySorting
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, sortApi, 'public');
    /**
   * PRE-PROCESSING
   */ const stateExportPreProcessing = $acw62.useCallback((prevState, context)=>{
        const sortModelToExport = (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9)(apiRef);
        const shouldExportSortModel = // Always export if the `exportOnlyDirtyModels` property is not activated
        !context.exportOnlyDirtyModels || // Always export if the model is controlled
        props.sortModel != null || // Always export if the model has been initialized
        props.initialState?.sorting?.sortModel != null || // Export if the model is not empty
        sortModelToExport.length > 0;
        if (!shouldExportSortModel) return prevState;
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, prevState, {
            sorting: {
                sortModel: sortModelToExport
            }
        });
    }, [
        apiRef,
        props.sortModel,
        props.initialState?.sorting?.sortModel
    ]);
    const stateRestorePreProcessing = $acw62.useCallback((params, context)=>{
        const sortModel = context.stateToRestore.sorting?.sortModel;
        if (sortModel == null) return params;
        apiRef.current.setState((0, $877e98c7ff4d0a4a$export$3fc28d475ac000c0)(sortModel, props.disableMultipleColumnsSorting));
        return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
            callbacks: [
                ...params.callbacks,
                apiRef.current.applySorting
            ]
        });
    }, [
        apiRef,
        props.disableMultipleColumnsSorting
    ]);
    const flatSortingMethod = $acw62.useCallback((params)=>{
        const rowTree = (0, $4fc0d4cb0e570e63$export$de9a43d646a9821d)(apiRef);
        const rootGroupNode = rowTree[0, $4ab53eafabc4b920$export$433b924dc2506913];
        const sortedChildren = params.sortRowList ? params.sortRowList(rootGroupNode.children.map((childId)=>rowTree[childId])) : [
            ...rootGroupNode.children
        ];
        if (rootGroupNode.footerId != null) sortedChildren.push(rootGroupNode.footerId);
        return sortedChildren;
    }, [
        apiRef
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'exportState', stateExportPreProcessing);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'restoreState', stateRestorePreProcessing);
    (0, $0e27fd6eb449426d$export$102a3f5a042c47c4)(apiRef, (0, $9e68111fb02b49e8$export$84214fbf04c4094), 'sorting', flatSortingMethod);
    /**
   * EVENTS
   */ const handleColumnHeaderClick = $acw62.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        const allowMultipleSorting = props.multipleColumnsSortingMode === 'always' || event.shiftKey || event.metaKey || event.ctrlKey;
        sortColumn(field, undefined, allowMultipleSorting);
    }, [
        sortColumn,
        props.disableColumnSorting,
        props.multipleColumnsSortingMode
    ]);
    const handleColumnHeaderKeyDown = $acw62.useCallback(({ field: field, colDef: colDef }, event)=>{
        if (!colDef.sortable || props.disableColumnSorting) return;
        // Ctrl + Enter opens the column menu
        if (event.key === 'Enter' && !event.ctrlKey && !event.metaKey) sortColumn(field, undefined, props.multipleColumnsSortingMode === 'always' || event.shiftKey);
    }, [
        sortColumn,
        props.disableColumnSorting,
        props.multipleColumnsSortingMode
    ]);
    const handleColumnsChange = $acw62.useCallback(()=>{
        // When the columns change we check that the sorted columns are still part of the dataset
        const sortModel = (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9)(apiRef);
        const latestColumns = (0, $1781ebe27505055c$export$8a3a9a6db584d7fd)(apiRef);
        if (sortModel.length > 0) {
            const newModel = sortModel.filter((sortItem)=>latestColumns[sortItem.field]);
            if (newModel.length < sortModel.length) apiRef.current.setSortModel(newModel);
        }
    }, [
        apiRef
    ]);
    const handleStrategyProcessorChange = $acw62.useCallback((methodName)=>{
        if (methodName === 'sorting') apiRef.current.applySorting();
    }, [
        apiRef
    ]);
    (0, $94c21951d8062459$export$faa98381ad228894)(apiRef, 'columnMenu', addColumnMenuItem);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderClick', handleColumnHeaderClick);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderKeyDown', handleColumnHeaderKeyDown);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'rowsSet', apiRef.current.applySorting);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnsChange', handleColumnsChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'activeStrategyProcessorChange', handleStrategyProcessorChange);
    /**
   * 1ST RENDER
   */ (0, $ed0481f6b43b34b3$export$c5623aa1c38918b6)(()=>{
        apiRef.current.applySorting();
    });
    /**
   * EFFECTS
   */ (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (props.sortModel !== undefined) apiRef.current.setSortModel(props.sortModel);
    }, [
        apiRef,
        props.sortModel
    ]);
};



var $acw62 = parcelRequire("acw62");










// Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
// Similar to https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollIntoView
function $2c4202bdcc1b9fe3$var$scrollIntoView(dimensions) {
    const { containerSize: containerSize, scrollPosition: scrollPosition, elementSize: elementSize, elementOffset: elementOffset } = dimensions;
    const elementEnd = elementOffset + elementSize;
    // Always scroll to top when cell is higher than viewport to avoid scroll jump
    // See https://github.com/mui/mui-x/issues/4513 and https://github.com/mui/mui-x/issues/4514
    if (elementSize > containerSize) return elementOffset;
    if (elementEnd - containerSize > scrollPosition) return elementEnd - containerSize;
    if (elementOffset < scrollPosition) return elementOffset;
    return undefined;
}
const $2c4202bdcc1b9fe3$export$d3441dc29db31b8c = (apiRef, props)=>{
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridScroll');
    const colRef = apiRef.current.columnHeadersContainerRef;
    const virtualScrollerRef = apiRef.current.virtualScrollerRef;
    const visibleSortedRows = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$2f31562143a3e5d4));
    const scrollToIndexes = $acw62.useCallback((params)=>{
        const dimensions = (0, $9f487993152f6061$export$26d8768b83a52ffd)(apiRef);
        const totalRowCount = (0, $4fc0d4cb0e570e63$export$1641ef9d08e265ca)(apiRef);
        const visibleColumns = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef);
        const scrollToHeader = params.rowIndex == null;
        if (!scrollToHeader && totalRowCount === 0 || visibleColumns.length === 0) return false;
        logger.debug(`Scrolling to cell at row ${params.rowIndex}, col: ${params.colIndex} `);
        let scrollCoordinates = {};
        if (params.colIndex !== undefined) {
            const columnPositions = (0, $1781ebe27505055c$export$fce7d810e48021e3)(apiRef);
            let cellWidth;
            if (typeof params.rowIndex !== 'undefined') {
                const rowId = visibleSortedRows[params.rowIndex]?.id;
                const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, params.colIndex);
                if (cellColSpanInfo && !cellColSpanInfo.spannedByColSpan) cellWidth = cellColSpanInfo.cellProps.width;
            }
            if (typeof cellWidth === 'undefined') cellWidth = visibleColumns[params.colIndex].computedWidth;
            // When using RTL, `scrollLeft` becomes negative, so we must ensure that we only compare values.
            scrollCoordinates.left = $2c4202bdcc1b9fe3$var$scrollIntoView({
                containerSize: dimensions.viewportOuterSize.width,
                scrollPosition: Math.abs(virtualScrollerRef.current.scrollLeft),
                elementSize: cellWidth,
                elementOffset: columnPositions[params.colIndex]
            });
        }
        if (params.rowIndex !== undefined) {
            const rowsMeta = (0, $a2b185594e10a6a1$export$4f32bfc70efeb4ab)(apiRef);
            const page = (0, $e164e26c82788fb1$export$1f7f64fcb62ccdad)(apiRef);
            const pageSize = (0, $e164e26c82788fb1$export$721a46720a2de097)(apiRef);
            const elementIndex = !props.pagination ? params.rowIndex : params.rowIndex - page * pageSize;
            const targetOffsetHeight = rowsMeta.positions[elementIndex + 1] ? rowsMeta.positions[elementIndex + 1] - rowsMeta.positions[elementIndex] : rowsMeta.currentPageTotalHeight - rowsMeta.positions[elementIndex];
            scrollCoordinates.top = $2c4202bdcc1b9fe3$var$scrollIntoView({
                containerSize: dimensions.viewportInnerSize.height,
                scrollPosition: virtualScrollerRef.current.scrollTop,
                elementSize: targetOffsetHeight,
                elementOffset: rowsMeta.positions[elementIndex]
            });
        }
        scrollCoordinates = apiRef.current.unstable_applyPipeProcessors('scrollToIndexes', scrollCoordinates, params);
        if (typeof scrollCoordinates.left !== 'undefined' || typeof scrollCoordinates.top !== 'undefined') {
            apiRef.current.scroll(scrollCoordinates);
            return true;
        }
        return false;
    }, [
        logger,
        apiRef,
        virtualScrollerRef,
        props.pagination,
        visibleSortedRows
    ]);
    const scroll = $acw62.useCallback((params)=>{
        if (virtualScrollerRef.current && params.left !== undefined && colRef.current) {
            const direction = isRtl ? -1 : 1;
            colRef.current.scrollLeft = params.left;
            virtualScrollerRef.current.scrollLeft = direction * params.left;
            logger.debug(`Scrolling left: ${params.left}`);
        }
        if (virtualScrollerRef.current && params.top !== undefined) {
            virtualScrollerRef.current.scrollTop = params.top;
            logger.debug(`Scrolling top: ${params.top}`);
        }
        logger.debug(`Scrolling, updating container, and viewport`);
    }, [
        virtualScrollerRef,
        isRtl,
        colRef,
        logger
    ]);
    const getScrollPosition = $acw62.useCallback(()=>{
        if (!virtualScrollerRef?.current) return {
            top: 0,
            left: 0
        };
        return {
            top: virtualScrollerRef.current.scrollTop,
            left: virtualScrollerRef.current.scrollLeft
        };
    }, [
        virtualScrollerRef
    ]);
    const scrollApi = {
        scroll: scroll,
        scrollToIndexes: scrollToIndexes,
        getScrollPosition: getScrollPosition
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, scrollApi, 'public');
};



function $35ae6592ae751374$export$8456f443918812d4(apiRef, props) {
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnHeaderClick', props.onColumnHeaderClick);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnHeaderContextMenu', props.onColumnHeaderContextMenu);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnHeaderDoubleClick', props.onColumnHeaderDoubleClick);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnHeaderOver', props.onColumnHeaderOver);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnHeaderOut', props.onColumnHeaderOut);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnHeaderEnter', props.onColumnHeaderEnter);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnHeaderLeave', props.onColumnHeaderLeave);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'cellClick', props.onCellClick);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'cellDoubleClick', props.onCellDoubleClick);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'cellKeyDown', props.onCellKeyDown);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'preferencePanelClose', props.onPreferencePanelClose);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'preferencePanelOpen', props.onPreferencePanelOpen);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'menuOpen', props.onMenuOpen);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'menuClose', props.onMenuClose);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'rowDoubleClick', props.onRowDoubleClick);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'rowClick', props.onRowClick);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'stateChange', props.onStateChange);
}




var $acw62 = parcelRequire("acw62");













'use client';
const $f72b666d60f795fd$var$EMPTY_SIZE = {
    width: 0,
    height: 0
};
const $f72b666d60f795fd$var$EMPTY_DIMENSIONS = {
    isReady: false,
    root: $f72b666d60f795fd$var$EMPTY_SIZE,
    viewportOuterSize: $f72b666d60f795fd$var$EMPTY_SIZE,
    viewportInnerSize: $f72b666d60f795fd$var$EMPTY_SIZE,
    contentSize: $f72b666d60f795fd$var$EMPTY_SIZE,
    minimumSize: $f72b666d60f795fd$var$EMPTY_SIZE,
    hasScrollX: false,
    hasScrollY: false,
    scrollbarSize: 0,
    headerHeight: 0,
    groupHeaderHeight: 0,
    headerFilterHeight: 0,
    rowWidth: 0,
    rowHeight: 0,
    columnsTotalWidth: 0,
    leftPinnedWidth: 0,
    rightPinnedWidth: 0,
    headersTotalHeight: 0,
    topContainerHeight: 0,
    bottomContainerHeight: 0
};
const $f72b666d60f795fd$export$c29f872c616fae5b = (state, props, apiRef)=>{
    const dimensions = $f72b666d60f795fd$var$EMPTY_DIMENSIONS;
    const density = (0, $3d9afbbff3fa8293$export$c646201fb1d3e7a6)(apiRef);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        dimensions: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, dimensions, $f72b666d60f795fd$var$getStaticDimensions(props, apiRef, density, (0, $1781ebe27505055c$export$297e8079713afa11)(apiRef)))
    });
};
const $f72b666d60f795fd$var$columnsTotalWidthSelector = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)((0, $1781ebe27505055c$export$16a65a9447d3dda9), (0, $1781ebe27505055c$export$fce7d810e48021e3), (visibleColumns, positions)=>{
    const colCount = visibleColumns.length;
    if (colCount === 0) return 0;
    return (0, $145ef8aeadc094b1$export$28cd30446ab5724a)(positions[colCount - 1] + visibleColumns[colCount - 1].computedWidth, 1);
});
function $f72b666d60f795fd$export$b8364994f9eec67d(apiRef, props) {
    const virtualizer = apiRef.current.virtualizer;
    const updateDimensions = virtualizer.api.updateDimensions;
    const getViewportPageSize = virtualizer.api.getViewportPageSize;
    const getRootDimensions = $acw62.useCallback(()=>(0, $9f487993152f6061$export$26d8768b83a52ffd)(apiRef), [
        apiRef
    ]);
    const apiPublic = {
        getRootDimensions: getRootDimensions
    };
    const apiPrivate = {
        updateDimensions: updateDimensions,
        getViewportPageSize: getViewportPageSize
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, apiPublic, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, apiPrivate, 'private');
    const handleRootMount = (root)=>{
        $f72b666d60f795fd$var$setCSSVariables(root, (0, $9f487993152f6061$export$26d8768b83a52ffd)(apiRef));
    };
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'rootMount', handleRootMount);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'debouncedResize', props.onResize);
    var size;
    (0, $e5fd677936fa6c9d$export$c6cc86f9120e9aa4)(apiRef.current.store, (s)=>s.dimensions, (previous, next)=>{
        if (apiRef.current.rootElementRef.current) $f72b666d60f795fd$var$setCSSVariables(apiRef.current.rootElementRef.current, next);
        if (!$f72b666d60f795fd$var$areElementSizesEqual(next.viewportInnerSize, previous.viewportInnerSize)) apiRef.current.publishEvent('viewportInnerSizeChange', next.viewportInnerSize);
        apiRef.current.publishEvent('debouncedResize', next.root);
    });
}
function $f72b666d60f795fd$var$setCSSVariables(root, dimensions) {
    const set = (k, v)=>root.style.setProperty(k, v);
    set('--DataGrid-hasScrollX', `${Number(dimensions.hasScrollX)}`);
    set('--DataGrid-hasScrollY', `${Number(dimensions.hasScrollY)}`);
    set('--DataGrid-scrollbarSize', `${dimensions.scrollbarSize}px`);
    set('--DataGrid-rowWidth', `${dimensions.rowWidth}px`);
    set('--DataGrid-columnsTotalWidth', `${dimensions.columnsTotalWidth}px`);
    set('--DataGrid-leftPinnedWidth', `${dimensions.leftPinnedWidth}px`);
    set('--DataGrid-rightPinnedWidth', `${dimensions.rightPinnedWidth}px`);
    set('--DataGrid-headerHeight', `${dimensions.headerHeight}px`);
    set('--DataGrid-headersTotalHeight', `${dimensions.headersTotalHeight}px`);
    set('--DataGrid-topContainerHeight', `${dimensions.topContainerHeight}px`);
    set('--DataGrid-bottomContainerHeight', `${dimensions.bottomContainerHeight}px`);
    set('--height', `${dimensions.rowHeight}px`);
}
function $f72b666d60f795fd$var$getStaticDimensions(props, apiRef, density, pinnedColumnns) {
    const validRowHeight = (0, $4ab53eafabc4b920$export$fa15c17c0798a441)(props.rowHeight, (0, $b3f45ec6f75f29f1$export$2733e0e1a1d288e7).rowHeight, (0, $4ab53eafabc4b920$export$abf6a2a1a7dde56b));
    return {
        rowHeight: Math.floor(validRowHeight * density),
        headerHeight: Math.floor(props.columnHeaderHeight * density),
        groupHeaderHeight: Math.floor((props.columnGroupHeaderHeight ?? props.columnHeaderHeight) * density),
        headerFilterHeight: Math.floor((props.headerFilterHeight ?? props.columnHeaderHeight) * density),
        columnsTotalWidth: $f72b666d60f795fd$var$columnsTotalWidthSelector(apiRef),
        headersTotalHeight: (0, $7560da5e35f787e6$export$659109c29172602f)(apiRef, props),
        leftPinnedWidth: pinnedColumnns.left.reduce((w, col)=>w + col.computedWidth, 0),
        rightPinnedWidth: pinnedColumnns.right.reduce((w, col)=>w + col.computedWidth, 0)
    };
}
function $f72b666d60f795fd$var$areElementSizesEqual(a, b) {
    return a.width === b.width && a.height === b.height;
}








const $552fd44b9758bdc1$export$4224c70cd0329965 = (state, props, apiRef)=>{
    // FIXME: This should be handled in the virtualizer eventually, but there are interdependencies
    // between state initializers that need to be untangled carefully.
    const baseRowHeight = (0, $9f487993152f6061$export$2ca09da26466c31a)(apiRef);
    const dataRowCount = (0, $4fc0d4cb0e570e63$export$1641ef9d08e265ca)(apiRef);
    const pagination = (0, $e164e26c82788fb1$export$24c945ea033ce6cf)(apiRef);
    const rowCount = Math.min(pagination.enabled ? pagination.paginationModel.pageSize : dataRowCount, dataRowCount);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        rowsMeta: {
            currentPageTotalHeight: rowCount * baseRowHeight,
            positions: Array.from({
                length: rowCount
            }, (_, i)=>i * baseRowHeight),
            pinnedTopRowsTotalHeight: 0,
            pinnedBottomRowsTotalHeight: 0
        }
    });
};
const $552fd44b9758bdc1$export$8a4468671da3a64f = (apiRef, _props)=>{
    const virtualizer = apiRef.current.virtualizer;
    const { getRowHeight: getRowHeight, setLastMeasuredRowIndex: setLastMeasuredRowIndex, storeRowHeightMeasurement: storeRowHeightMeasurement, resetRowHeights: resetRowHeights, hydrateRowsMeta: hydrateRowsMeta, observeRowHeight: observeRowHeight, rowHasAutoHeight: rowHasAutoHeight, getRowHeightEntry: getRowHeightEntry, getLastMeasuredRowIndex: getLastMeasuredRowIndex } = virtualizer.api.rowsMeta;
    (0, $c1adda9e70e08895$export$98b68054bf03cb4)(apiRef, 'rowHeight', hydrateRowsMeta);
    const rowsMetaApi = {
        unstable_getRowHeight: getRowHeight,
        unstable_setLastMeasuredRowIndex: setLastMeasuredRowIndex,
        unstable_storeRowHeightMeasurement: storeRowHeightMeasurement,
        resetRowHeights: resetRowHeights
    };
    const rowsMetaPrivateApi = {
        hydrateRowsMeta: hydrateRowsMeta,
        observeRowHeight: observeRowHeight,
        rowHasAutoHeight: rowHasAutoHeight,
        getRowHeightEntry: getRowHeightEntry,
        getLastMeasuredRowIndex: getLastMeasuredRowIndex
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, rowsMetaApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, rowsMetaPrivateApi, 'private');
};



var $acw62 = parcelRequire("acw62");

const $4bde36936796bcb2$export$971de86bde7f86a1 = (apiRef)=>{
    const exportState = $acw62.useCallback((params = {})=>{
        const stateToExport = apiRef.current.unstable_applyPipeProcessors('exportState', {}, params);
        return stateToExport;
    }, [
        apiRef
    ]);
    const restoreState = $acw62.useCallback((stateToRestore)=>{
        const response = apiRef.current.unstable_applyPipeProcessors('restoreState', {
            callbacks: []
        }, {
            stateToRestore: stateToRestore
        });
        response.callbacks.forEach((callback)=>{
            callback();
        });
    }, [
        apiRef
    ]);
    const statePersistenceApi = {
        exportState: exportState,
        restoreState: restoreState
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, statePersistenceApi, 'public');
};




const $692cb6384e752278$export$ce7ce4871097b52e = (apiRef)=>{
    const virtualizer = apiRef.current.virtualizer;
    const resetColSpan = virtualizer.api.resetColSpan;
    const getCellColSpanInfo = virtualizer.api.getCellColSpanInfo;
    const calculateColSpan = virtualizer.api.calculateColSpan;
    const columnSpanningPublicApi = {
        unstable_getCellColSpanInfo: getCellColSpanInfo
    };
    const columnSpanningPrivateApi = {
        resetColSpan: resetColSpan,
        calculateColSpan: calculateColSpan
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, columnSpanningPublicApi, 'public');
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, columnSpanningPrivateApi, 'private');
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnOrderChange', resetColSpan);
};




var $acw62 = parcelRequire("acw62");




function $8299e69cdfa2bd4b$export$e132ced8f644a612(node) {
    return node.field !== undefined;
} /**
 * A function used to process headerClassName params.
 * @param {GridColumnGroupHeaderParams} params The parameters of the column group header.
 * @returns {string} The class name to be added to the column group header cell.
 */  /**
 * The union type representing the [[GridColDef]] column header class type.
 */ 


const $5285e5959537aa38$var$_excluded = [
    "groupId",
    "children"
];
const $5285e5959537aa38$export$eff39450771c126e = (columnGroupingModel)=>{
    const groupLookup = {};
    for(let i = 0; i < columnGroupingModel.length; i += 1){
        const node = columnGroupingModel[i];
        if ((0, $8299e69cdfa2bd4b$export$e132ced8f644a612)(node)) continue;
        const { groupId: groupId, children: children } = node, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(node, $5285e5959537aa38$var$_excluded);
        if (!groupId) throw new Error('MUI X: An element of the columnGroupingModel does not have either `field` or `groupId`.');
        const groupParam = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
            groupId: groupId
        });
        const subTreeLookup = $5285e5959537aa38$export$eff39450771c126e(children);
        if (subTreeLookup[groupId] !== undefined || groupLookup[groupId] !== undefined) throw new Error(`MUI X: The groupId ${groupId} is used multiple times in the columnGroupingModel.`);
        Object.assign(groupLookup, subTreeLookup);
        groupLookup[groupId] = groupParam;
    }
    return groupLookup;
};
// This is the recurrence function that help writing `unwrapGroupingColumnModel()`
const $5285e5959537aa38$var$recurrentUnwrapGroupingColumnModel = (columnGroupNode, parents, unwrappedGroupingModelToComplete)=>{
    if ((0, $8299e69cdfa2bd4b$export$e132ced8f644a612)(columnGroupNode)) {
        if (unwrappedGroupingModelToComplete[columnGroupNode.field] !== undefined) throw new Error([
            `MUI X: columnGroupingModel contains duplicated field`,
            `column field ${columnGroupNode.field} occurs two times in the grouping model:`,
            `- ${unwrappedGroupingModelToComplete[columnGroupNode.field].join(' > ')}`,
            `- ${parents.join(' > ')}`
        ].join('\n'));
        unwrappedGroupingModelToComplete[columnGroupNode.field] = parents;
        return;
    }
    const { groupId: groupId, children: children } = columnGroupNode;
    children.forEach((child)=>{
        $5285e5959537aa38$var$recurrentUnwrapGroupingColumnModel(child, [
            ...parents,
            groupId
        ], unwrappedGroupingModelToComplete);
    });
};
const $5285e5959537aa38$export$ea425f87fd536c4d = (columnGroupingModel)=>{
    if (!columnGroupingModel) return {};
    const unwrappedSubTree = {};
    columnGroupingModel.forEach((columnGroupNode)=>{
        $5285e5959537aa38$var$recurrentUnwrapGroupingColumnModel(columnGroupNode, [], unwrappedSubTree);
    });
    return unwrappedSubTree;
};
const $5285e5959537aa38$export$c41225ff45feeb0e = (orderedColumns, unwrappedGroupingModel, pinnedFields)=>{
    const getParents = (field)=>unwrappedGroupingModel[field] ?? [];
    const groupingHeaderStructure = [];
    const maxDepth = Math.max(0, ...orderedColumns.map((field)=>getParents(field).length));
    const haveSameParents = (field1, field2, depth)=>{
        const a = getParents(field1);
        const b = getParents(field2);
        for(let i = 0; i <= depth; i += 1){
            if (a[i] !== b[i]) return false;
        }
        return true;
    };
    const haveDifferentContainers = (field1, field2)=>{
        const left = pinnedFields?.left;
        const right = pinnedFields?.right;
        const inLeft1 = !!left?.includes(field1);
        const inLeft2 = !!left?.includes(field2);
        const inRight1 = !!right?.includes(field1);
        const inRight2 = !!right?.includes(field2);
        return inLeft1 !== inLeft2 || inRight1 !== inRight2;
    };
    for(let depth = 0; depth < maxDepth; depth += 1){
        const depthStructure = [];
        for(let i = 0; i < orderedColumns.length; i += 1){
            const field = orderedColumns[i];
            const groupId = getParents(field)[depth] ?? null;
            if (depthStructure.length === 0) {
                depthStructure.push({
                    columnFields: [
                        field
                    ],
                    groupId: groupId
                });
                continue;
            }
            const lastGroup = depthStructure[depthStructure.length - 1];
            const prevField = lastGroup.columnFields[lastGroup.columnFields.length - 1];
            if (lastGroup.groupId !== groupId || !haveSameParents(prevField, field, depth) || haveDifferentContainers(prevField, field)) depthStructure.push({
                columnFields: [
                    field
                ],
                groupId: groupId
            });
            else lastGroup.columnFields.push(field);
        }
        groupingHeaderStructure.push(depthStructure);
    }
    return groupingHeaderStructure;
};




'use client';
const $4351539a6fe76c97$export$21c841dc431b3cd0 = (state, props, apiRef)=>{
    apiRef.current.caches.columnGrouping = {
        lastColumnGroupingModel: props.columnGroupingModel
    };
    if (!props.columnGroupingModel) return state;
    const columnFields = (0, $1781ebe27505055c$export$d8a3dfbb129c80db)(apiRef);
    const visibleColumnFields = (0, $1781ebe27505055c$export$c9491722e1d6e8d3)(apiRef);
    const groupLookup = (0, $5285e5959537aa38$export$eff39450771c126e)(props.columnGroupingModel ?? []);
    const unwrappedGroupingModel = (0, $5285e5959537aa38$export$ea425f87fd536c4d)(props.columnGroupingModel ?? []);
    const columnGroupsHeaderStructure = (0, $5285e5959537aa38$export$c41225ff45feeb0e)(columnFields, unwrappedGroupingModel, apiRef.current.state.pinnedColumns ?? {});
    const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        columnGrouping: {
            lookup: groupLookup,
            unwrappedGroupingModel: unwrappedGroupingModel,
            headerStructure: columnGroupsHeaderStructure,
            maxDepth: maxDepth
        }
    });
};
const $4351539a6fe76c97$export$510984a37e2e33f3 = (apiRef, props)=>{
    /**
   * API METHODS
   */ const getColumnGroupPath = $acw62.useCallback((field)=>{
        const unwrappedGroupingModel = (0, $424decc09f6745ae$export$78f140ad2e1dbc2b)(apiRef);
        return unwrappedGroupingModel[field] ?? [];
    }, [
        apiRef
    ]);
    const getAllGroupDetails = $acw62.useCallback(()=>{
        const columnGroupLookup = (0, $424decc09f6745ae$export$bdc2ff4432d8b29b)(apiRef);
        return columnGroupLookup;
    }, [
        apiRef
    ]);
    const columnGroupingApi = {
        getColumnGroupPath: getColumnGroupPath,
        getAllGroupDetails: getAllGroupDetails
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, columnGroupingApi, 'public');
    const handleColumnIndexChange = $acw62.useCallback(()=>{
        const unwrappedGroupingModel = (0, $5285e5959537aa38$export$ea425f87fd536c4d)(props.columnGroupingModel ?? []);
        apiRef.current.setState((state)=>{
            const orderedFields = state.columns?.orderedFields ?? [];
            const pinnedColumns = state.pinnedColumns ?? {};
            const columnGroupsHeaderStructure = (0, $5285e5959537aa38$export$c41225ff45feeb0e)(orderedFields, unwrappedGroupingModel, pinnedColumns);
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                columnGrouping: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.columnGrouping, {
                    headerStructure: columnGroupsHeaderStructure
                })
            });
        });
    }, [
        apiRef,
        props.columnGroupingModel
    ]);
    const updateColumnGroupingState = $acw62.useCallback((columnGroupingModel)=>{
        apiRef.current.caches.columnGrouping.lastColumnGroupingModel = columnGroupingModel;
        // @ts-expect-error Move this logic to `Pro` package
        const pinnedColumns = apiRef.current.getPinnedColumns?.() ?? {};
        const columnFields = (0, $1781ebe27505055c$export$d8a3dfbb129c80db)(apiRef);
        const visibleColumnFields = (0, $1781ebe27505055c$export$c9491722e1d6e8d3)(apiRef);
        const groupLookup = (0, $5285e5959537aa38$export$eff39450771c126e)(columnGroupingModel ?? []);
        const unwrappedGroupingModel = (0, $5285e5959537aa38$export$ea425f87fd536c4d)(columnGroupingModel ?? []);
        const columnGroupsHeaderStructure = (0, $5285e5959537aa38$export$c41225ff45feeb0e)(columnFields, unwrappedGroupingModel, pinnedColumns);
        const maxDepth = visibleColumnFields.length === 0 ? 0 : Math.max(...visibleColumnFields.map((field)=>unwrappedGroupingModel[field]?.length ?? 0));
        apiRef.current.setState((state)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                columnGrouping: {
                    lookup: groupLookup,
                    unwrappedGroupingModel: unwrappedGroupingModel,
                    headerStructure: columnGroupsHeaderStructure,
                    maxDepth: maxDepth
                }
            });
        });
    }, [
        apiRef
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnIndexChange', handleColumnIndexChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnsChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnVisibilityModelChange', ()=>{
        updateColumnGroupingState(props.columnGroupingModel);
    });
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>{
        if (props.columnGroupingModel === apiRef.current.caches.columnGrouping.lastColumnGroupingModel) return;
        updateColumnGroupingState(props.columnGroupingModel);
    }, [
        apiRef,
        updateColumnGroupingState,
        props.columnGroupingModel
    ]);
};




var $acw62 = parcelRequire("acw62");

const $27ef06d405f88fa3$export$c8f880a2d81914c4 = typeof window !== 'undefined' && /jsdom|HappyDOM/.test(window.navigator.userAgent);




'use client';
const $2df47bd4a91f0934$var$HAS_LAYOUT = !(0, $27ef06d405f88fa3$export$c8f880a2d81914c4);
const $2df47bd4a91f0934$export$42963ad70bb69f54 = (state, props)=>{
    const { disableVirtualization: disableVirtualization, autoHeight: autoHeight } = props;
    const virtualization = {
        enabled: !disableVirtualization && $2df47bd4a91f0934$var$HAS_LAYOUT,
        enabledForColumns: !disableVirtualization && $2df47bd4a91f0934$var$HAS_LAYOUT,
        enabledForRows: !disableVirtualization && !autoHeight && $2df47bd4a91f0934$var$HAS_LAYOUT,
        renderContext: (0, $4cc7a762081bc0b0$export$27eb37bbcd78f450)
    };
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        virtualization: virtualization
    });
};
function $2df47bd4a91f0934$export$aa0d6df32cccbd53(apiRef, rootProps) {
    const { virtualizer: virtualizer } = apiRef.current;
    const { autoHeight: autoHeight, disableVirtualization: disableVirtualization } = rootProps;
    /*
   * API METHODS
   */ const setVirtualization = (enabled)=>{
        enabled &&= $2df47bd4a91f0934$var$HAS_LAYOUT;
        virtualizer.store.set('virtualization', (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, virtualizer.store.state.virtualization, {
            enabled: enabled,
            enabledForColumns: enabled,
            enabledForRows: enabled && !autoHeight
        }));
    };
    const setColumnVirtualization = (enabled)=>{
        enabled &&= $2df47bd4a91f0934$var$HAS_LAYOUT;
        virtualizer.store.set('virtualization', (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, virtualizer.store.state.virtualization, {
            enabledForColumns: enabled
        }));
    };
    const api = {
        unstable_setVirtualization: setVirtualization,
        unstable_setColumnVirtualization: setColumnVirtualization
    };
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, api, 'public');
    const forceUpdateRenderContext = virtualizer.api.forceUpdateRenderContext;
    apiRef.current.register('private', {
        updateRenderContext: forceUpdateRenderContext
    });
    /*
   * EFFECTS
   */ (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'sortedRowsSet', forceUpdateRenderContext);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'paginationModelChange', forceUpdateRenderContext);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnsChange', forceUpdateRenderContext);
    /* eslint-disable react-hooks/exhaustive-deps */ $acw62.useEffect(()=>{
        setVirtualization(!rootProps.disableVirtualization);
    }, [
        disableVirtualization,
        autoHeight
    ]);
/* eslint-enable react-hooks/exhaustive-deps */ }




var $acw62 = parcelRequire("acw62");





const $65f98549df96a65f$export$9707fe779d390182 = {
    includeHeaders: true,
    includeOutliers: false,
    outliersFactor: 1.5,
    expand: false,
    disableColumnVirtualization: true
}; /**
 * The Resize API interface that is available in the grid `apiRef`.
 */ 





function $a3edc600c78ec3db$export$7e10cfd0168dec8f() {
    let resolve;
    let reject;
    const promise = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    promise.resolve = resolve;
    promise.reject = reject;
    return promise;
}







'use client';
function $668be7296f663159$var$trackFinger(event, currentTouchId) {
    if (currentTouchId !== undefined && event.changedTouches) {
        for(let i = 0; i < event.changedTouches.length; i += 1){
            const touch = event.changedTouches[i];
            if (touch.identifier === currentTouchId) return {
                x: touch.clientX,
                y: touch.clientY
            };
        }
        return false;
    }
    return {
        x: event.clientX,
        y: event.clientY
    };
}
function $668be7296f663159$var$computeNewWidth(initialOffsetToSeparator, clickX, columnBounds, resizeDirection) {
    let newWidth = initialOffsetToSeparator;
    if (resizeDirection === 'Right') newWidth += clickX - columnBounds.left;
    else newWidth += columnBounds.right - clickX;
    return Math.round(newWidth);
}
function $668be7296f663159$var$computeOffsetToSeparator(clickX, columnBounds, resizeDirection) {
    if (resizeDirection === 'Left') return clickX - columnBounds.left;
    return columnBounds.right - clickX;
}
function $668be7296f663159$var$flipResizeDirection(side) {
    if (side === 'Right') return 'Left';
    return 'Right';
}
function $668be7296f663159$var$getResizeDirection(separator, isRtl) {
    const side = separator.classList.contains((0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--sideRight']) ? 'Right' : 'Left';
    if (isRtl) // Resizing logic should be mirrored in the RTL case
    return $668be7296f663159$var$flipResizeDirection(side);
    return side;
}
function $668be7296f663159$var$getPinnedWidthProperty(isRtl, pinnedPosition) {
    if (pinnedPosition === (0, $c660c9275391bc0a$export$64f54b460f67389c).LEFT) return isRtl ? '--DataGrid-rightPinnedWidth' : '--DataGrid-leftPinnedWidth';
    return isRtl ? '--DataGrid-leftPinnedWidth' : '--DataGrid-rightPinnedWidth';
}
function $668be7296f663159$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) {
    if (pinnedPosition === (0, $c660c9275391bc0a$export$64f54b460f67389c).LEFT) return isRtl ? dimensions.rightPinnedWidth : dimensions.leftPinnedWidth;
    return isRtl ? dimensions.leftPinnedWidth : dimensions.rightPinnedWidth;
}
function $668be7296f663159$var$preventClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
}
/**
 * Checker that returns a promise that resolves when the column virtualization
 * is disabled.
 */ function $668be7296f663159$var$useColumnVirtualizationDisabled(apiRef) {
    const promise = $acw62.useRef(undefined);
    const selector = ()=>(0, $542ae311f57ccc4a$export$ad2aa1e9d465cafa)(apiRef);
    const value = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, selector);
    $acw62.useEffect(()=>{
        if (promise.current && value === false) {
            promise.current.resolve();
            promise.current = undefined;
        }
    });
    const asyncCheck = ()=>{
        if (!promise.current) {
            if (selector() === false) return Promise.resolve();
            promise.current = (0, $a3edc600c78ec3db$export$7e10cfd0168dec8f)();
        }
        return promise.current;
    };
    return asyncCheck;
}
/**
 * Basic statistical outlier detection, checks if the value is `F * IQR` away from
 * the Q1 and Q3 boundaries. IQR: interquartile range.
 */ function $668be7296f663159$var$excludeOutliers(inputValues, factor) {
    if (inputValues.length < 4) return inputValues;
    const values = inputValues.slice();
    values.sort((a, b)=>a - b);
    const q1 = values[Math.floor(values.length * 0.25)];
    const q3 = values[Math.floor(values.length * 0.75) - 1];
    const iqr = q3 - q1;
    // We make a small adjustment if `iqr < 5` for the cases where the IQR is
    // very small (for example zero) due to very close by values in the input data.
    // Otherwise, with an IQR of `0`, anything outside that would be considered
    // an outlier, but it makes more sense visually to allow for this 5px variance
    // rather than showing a cropped cell.
    const deviation = iqr < 5 ? 5 : iqr * factor;
    return values.filter((v)=>v > q1 - deviation && v < q3 + deviation);
}
function $668be7296f663159$var$extractColumnWidths(apiRef, options, columns) {
    const widthByField = {};
    const root = apiRef.current.rootElementRef.current;
    root.classList.add((0, $59e5f6b0ce3da023$export$2100d54e36406477).autosizing);
    columns.forEach((column)=>{
        const cells = (0, $b2637ba08a26ef7b$export$ee9bd404f74f7c9)(apiRef.current, column.field);
        const widths = cells.map((cell)=>{
            return cell.getBoundingClientRect().width ?? 0;
        });
        const filteredWidths = options.includeOutliers ? widths : $668be7296f663159$var$excludeOutliers(widths, options.outliersFactor);
        if (options.includeHeaders) {
            const header = (0, $b2637ba08a26ef7b$export$5c4f873e8f18904d)(apiRef.current, column.field);
            if (header) {
                const title = header.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitle}`);
                const content = header.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeaderTitleContainerContent}`);
                const iconContainer = header.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).iconButtonContainer}`);
                const menuContainer = header.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).menuIcon}`);
                const element = title ?? content;
                const style = window.getComputedStyle(header, null);
                const paddingWidth = parseInt(style.paddingLeft, 10) + parseInt(style.paddingRight, 10);
                const contentWidth = element.scrollWidth + 1;
                const width = contentWidth + paddingWidth + (iconContainer?.clientWidth ?? 0) + (menuContainer?.clientWidth ?? 0);
                filteredWidths.push(width);
            }
        }
        const hasColumnMin = column.minWidth !== -Infinity && column.minWidth !== undefined;
        const hasColumnMax = column.maxWidth !== Infinity && column.maxWidth !== undefined;
        const min = hasColumnMin ? column.minWidth : 0;
        const max = hasColumnMax ? column.maxWidth : Infinity;
        const maxContent = filteredWidths.length === 0 ? 0 : Math.max(...filteredWidths);
        widthByField[column.field] = (0, $07a64ebfd26f4296$export$7d15b64cf5a3a4c4)(maxContent, min, max);
    });
    root.classList.remove((0, $59e5f6b0ce3da023$export$2100d54e36406477).autosizing);
    return widthByField;
}
const $668be7296f663159$export$ac6ed2ccd52f643f = (state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        columnResize: {
            resizingColumnField: ''
        }
    });
function $668be7296f663159$var$createResizeRefs() {
    return {
        colDef: undefined,
        initialColWidth: 0,
        initialTotalWidth: 0,
        previousMouseClickEvent: undefined,
        columnHeaderElement: undefined,
        headerFilterElement: undefined,
        groupHeaderElements: [],
        cellElements: [],
        leftPinnedCellsAfter: [],
        rightPinnedCellsBefore: [],
        fillerLeft: undefined,
        fillerRight: undefined,
        leftPinnedHeadersAfter: [],
        rightPinnedHeadersBefore: []
    };
}
const $668be7296f663159$export$6761a7afeb3daa64 = (apiRef, props)=>{
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const logger = (0, $9de2ec91bb565794$export$eb512164890e58f0)(apiRef, 'useGridColumnResize');
    const refs = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)($668be7296f663159$var$createResizeRefs).current;
    // To improve accessibility, the separator has padding on both sides.
    // Clicking inside the padding area should be treated as a click in the separator.
    // This ref stores the offset between the click and the separator.
    const initialOffsetToSeparator = $acw62.useRef(null);
    const resizeDirection = $acw62.useRef(null);
    const stopResizeEventTimeout = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const touchId = $acw62.useRef(undefined);
    const updateWidth = (newWidth)=>{
        logger.debug(`Updating width to ${newWidth} for col ${refs.colDef.field}`);
        const prevWidth = refs.columnHeaderElement.offsetWidth;
        const widthDiff = newWidth - prevWidth;
        const columnWidthDiff = newWidth - refs.initialColWidth;
        if (columnWidthDiff > 0) {
            const newTotalWidth = refs.initialTotalWidth + columnWidthDiff;
            apiRef.current.rootElementRef?.current?.style.setProperty('--DataGrid-rowWidth', `${newTotalWidth}px`);
        }
        refs.colDef.computedWidth = newWidth;
        refs.colDef.width = newWidth;
        refs.colDef.flex = 0;
        refs.columnHeaderElement.style.width = `${newWidth}px`;
        const headerFilterElement = refs.headerFilterElement;
        if (headerFilterElement) headerFilterElement.style.width = `${newWidth}px`;
        refs.groupHeaderElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.width = finalWidth;
        });
        refs.cellElements.forEach((element)=>{
            const div = element;
            let finalWidth;
            if (div.getAttribute('aria-colspan') === '1') finalWidth = `${newWidth}px`;
            else // Cell with colspan > 1 cannot be just updated width new width.
            // Instead, we add width diff to the current width.
            finalWidth = `${div.offsetWidth + widthDiff}px`;
            div.style.setProperty('--width', finalWidth);
        });
        const dimensions = (0, $9f487993152f6061$export$26d8768b83a52ffd)(apiRef);
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        if (pinnedPosition === (0, $c660c9275391bc0a$export$64f54b460f67389c).LEFT) {
            $668be7296f663159$var$updateProperty(refs.fillerLeft, 'width', widthDiff);
            refs.leftPinnedCellsAfter.forEach((cell)=>{
                $668be7296f663159$var$updateProperty(cell, 'left', widthDiff);
            });
            refs.leftPinnedHeadersAfter.forEach((header)=>{
                $668be7296f663159$var$updateProperty(header, 'left', widthDiff);
            });
            apiRef.current.rootElementRef?.current?.style.setProperty($668be7296f663159$var$getPinnedWidthProperty(isRtl, pinnedPosition), `${$668be7296f663159$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) + columnWidthDiff}px`);
        }
        if (pinnedPosition === (0, $c660c9275391bc0a$export$64f54b460f67389c).RIGHT) {
            $668be7296f663159$var$updateProperty(refs.fillerRight, 'width', widthDiff);
            refs.rightPinnedCellsBefore.forEach((cell)=>{
                $668be7296f663159$var$updateProperty(cell, 'right', widthDiff);
            });
            refs.rightPinnedHeadersBefore.forEach((header)=>{
                $668be7296f663159$var$updateProperty(header, 'right', widthDiff);
            });
            apiRef.current.rootElementRef?.current?.style.setProperty($668be7296f663159$var$getPinnedWidthProperty(isRtl, pinnedPosition), `${$668be7296f663159$var$getPinnedWidth(dimensions, isRtl, pinnedPosition) + columnWidthDiff}px`);
        }
    };
    const finishResize = (nativeEvent)=>{
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        stopListening();
        // Prevent double-clicks from being interpreted as two separate clicks
        if (refs.previousMouseClickEvent) {
            const prevEvent = refs.previousMouseClickEvent;
            const prevTimeStamp = prevEvent.timeStamp;
            const prevClientX = prevEvent.clientX;
            const prevClientY = prevEvent.clientY;
            // Check if the current event is part of a double-click
            if (nativeEvent.timeStamp - prevTimeStamp < 300 && nativeEvent.clientX === prevClientX && nativeEvent.clientY === prevClientY) {
                refs.previousMouseClickEvent = undefined;
                apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
                return;
            }
        }
        if (refs.colDef) {
            apiRef.current.setColumnWidth(refs.colDef.field, refs.colDef.width);
            logger.debug(`Updating col ${refs.colDef.field} with new width: ${refs.colDef.width}`);
            // Since during resizing we update the columns width outside of React, React is unable to
            // reapply the right style properties. We need to sync the state manually.
            // So we reapply the same logic as in https://github.com/mui/mui-x/blob/0511bf65543ca05d2602a5a3e0a6156f2fc8e759/packages/x-data-grid/src/hooks/features/columnHeaders/useGridColumnHeaders.tsx#L405
            const columnsState = (0, $1781ebe27505055c$export$858d15abb6cddc08)(apiRef);
            refs.groupHeaderElements.forEach((element)=>{
                const fields = (0, $b2637ba08a26ef7b$export$5d6880d172f0ecbb)(element);
                const div = element;
                const newWidth = fields.reduce((acc, field)=>{
                    if (columnsState.columnVisibilityModel[field] !== false) return acc + columnsState.lookup[field].computedWidth;
                    return acc;
                }, 0);
                const finalWidth = `${newWidth}px`;
                div.style.width = finalWidth;
            });
        }
        stopResizeEventTimeout.start(0, ()=>{
            apiRef.current.publishEvent('columnResizeStop', null, nativeEvent);
        });
    };
    const storeReferences = (colDef, separator, xStart)=>{
        const root = apiRef.current.rootElementRef.current;
        refs.initialColWidth = colDef.computedWidth;
        refs.initialTotalWidth = apiRef.current.getRootDimensions().rowWidth;
        refs.colDef = colDef;
        refs.columnHeaderElement = (0, $b2637ba08a26ef7b$export$a2d3aec9ff63900b)(apiRef.current.columnHeadersContainerRef.current, colDef.field);
        const headerFilterElement = root.querySelector(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477).headerFilterRow} [data-field="${(0, $b2637ba08a26ef7b$export$77eab2954df72e62)(colDef.field)}"]`);
        if (headerFilterElement) refs.headerFilterElement = headerFilterElement;
        refs.groupHeaderElements = (0, $b2637ba08a26ef7b$export$1e5569d10c3ebc8b)(apiRef.current.columnHeadersContainerRef?.current, colDef.field);
        refs.cellElements = (0, $b2637ba08a26ef7b$export$53d8041b57f0055)(refs.columnHeaderElement, apiRef.current);
        refs.fillerLeft = (0, $b2637ba08a26ef7b$export$c16d6f1be06f3423)(apiRef.current, isRtl ? 'filler--pinnedRight' : 'filler--pinnedLeft');
        refs.fillerRight = (0, $b2637ba08a26ef7b$export$c16d6f1be06f3423)(apiRef.current, isRtl ? 'filler--pinnedLeft' : 'filler--pinnedRight');
        const pinnedPosition = apiRef.current.unstable_applyPipeProcessors('isColumnPinned', false, refs.colDef.field);
        refs.leftPinnedCellsAfter = pinnedPosition !== (0, $c660c9275391bc0a$export$64f54b460f67389c).LEFT ? [] : (0, $b2637ba08a26ef7b$export$71cc5934f05ca0a1)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedCellsBefore = pinnedPosition !== (0, $c660c9275391bc0a$export$64f54b460f67389c).RIGHT ? [] : (0, $b2637ba08a26ef7b$export$2eb3bec73fd25ab)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.leftPinnedHeadersAfter = pinnedPosition !== (0, $c660c9275391bc0a$export$64f54b460f67389c).LEFT ? [] : (0, $b2637ba08a26ef7b$export$18b98bbb853bc2c4)(apiRef.current, refs.columnHeaderElement, isRtl);
        refs.rightPinnedHeadersBefore = pinnedPosition !== (0, $c660c9275391bc0a$export$64f54b460f67389c).RIGHT ? [] : (0, $b2637ba08a26ef7b$export$a2731c8163776b73)(apiRef.current, refs.columnHeaderElement, isRtl);
        resizeDirection.current = $668be7296f663159$var$getResizeDirection(separator, isRtl);
        initialOffsetToSeparator.current = $668be7296f663159$var$computeOffsetToSeparator(xStart, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
    };
    const handleResizeMouseUp = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(finishResize);
    const handleResizeMouseMove = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        // Cancel move in case some other element consumed a mouseup event and it was not fired.
        if (nativeEvent.buttons === 0) {
            handleResizeMouseUp(nativeEvent);
            return;
        }
        let newWidth = $668be7296f663159$var$computeNewWidth(initialOffsetToSeparator.current, nativeEvent.clientX, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $07a64ebfd26f4296$export$7d15b64cf5a3a4c4)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchEnd = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $668be7296f663159$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        finishResize(nativeEvent);
    });
    const handleTouchMove = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((nativeEvent)=>{
        const finger = $668be7296f663159$var$trackFinger(nativeEvent, touchId.current);
        if (!finger) return;
        // Cancel move in case some other element consumed a touchmove event and it was not fired.
        if (nativeEvent.type === 'mousemove' && nativeEvent.buttons === 0) {
            handleTouchEnd(nativeEvent);
            return;
        }
        let newWidth = $668be7296f663159$var$computeNewWidth(initialOffsetToSeparator.current, finger.x, refs.columnHeaderElement.getBoundingClientRect(), resizeDirection.current);
        newWidth = (0, $07a64ebfd26f4296$export$7d15b64cf5a3a4c4)(newWidth, refs.colDef.minWidth, refs.colDef.maxWidth);
        updateWidth(newWidth);
        const params = {
            element: refs.columnHeaderElement,
            colDef: refs.colDef,
            width: newWidth
        };
        apiRef.current.publishEvent('columnResize', params, nativeEvent);
    });
    const handleTouchStart = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        const cellSeparator = (0, $b2637ba08a26ef7b$export$2a63f1401414fc1a)(event.target, (0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable']);
        // Let the event bubble if the target is not a col separator
        if (!cellSeparator) return;
        const touch = event.changedTouches[0];
        if (touch != null) // A number that uniquely identifies the current finger in the touch session.
        touchId.current = touch.identifier;
        const columnHeaderElement = (0, $b2637ba08a26ef7b$export$2a63f1401414fc1a)(event.target, (0, $59e5f6b0ce3da023$export$2100d54e36406477).columnHeader);
        const field = (0, $b2637ba08a26ef7b$export$2c4260a98d98f894)(columnHeaderElement);
        const colDef = apiRef.current.getColumn(field);
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: field
        }, event);
        storeReferences(colDef, cellSeparator, touch.clientX);
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(event.currentTarget);
        doc.addEventListener('touchmove', handleTouchMove);
        doc.addEventListener('touchend', handleTouchEnd);
    });
    const stopListening = $acw62.useCallback(()=>{
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.body.style.removeProperty('cursor');
        doc.removeEventListener('mousemove', handleResizeMouseMove);
        doc.removeEventListener('mouseup', handleResizeMouseUp);
        doc.removeEventListener('touchmove', handleTouchMove);
        doc.removeEventListener('touchend', handleTouchEnd);
        // The click event runs right after the mouseup event, we want to wait until it
        // has been canceled before removing our handler.
        setTimeout(()=>{
            doc.removeEventListener('click', $668be7296f663159$var$preventClick, true);
        }, 100);
        if (refs.columnHeaderElement) refs.columnHeaderElement.style.pointerEvents = 'unset';
    }, [
        apiRef,
        refs,
        handleResizeMouseMove,
        handleResizeMouseUp,
        handleTouchMove,
        handleTouchEnd
    ]);
    const handleResizeStart = $acw62.useCallback(({ field: field })=>{
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                columnResize: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.columnResize, {
                    resizingColumnField: field
                })
            }));
    }, [
        apiRef
    ]);
    const handleResizeStop = $acw62.useCallback(()=>{
        apiRef.current.setState((state)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                columnResize: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.columnResize, {
                    resizingColumnField: ''
                })
            }));
    }, [
        apiRef
    ]);
    const handleColumnResizeMouseDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(({ colDef: colDef }, event)=>{
        // Only handle left clicks
        if (event.button !== 0) return;
        // Skip if the column isn't resizable
        if (!event.currentTarget.classList.contains((0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnSeparator--resizable'])) return;
        // Avoid text selection
        event.preventDefault();
        logger.debug(`Start Resize on col ${colDef.field}`);
        apiRef.current.publishEvent('columnResizeStart', {
            field: colDef.field
        }, event);
        storeReferences(colDef, event.currentTarget, event.clientX);
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        doc.body.style.cursor = 'col-resize';
        refs.previousMouseClickEvent = event.nativeEvent;
        doc.addEventListener('mousemove', handleResizeMouseMove);
        doc.addEventListener('mouseup', handleResizeMouseUp);
        // Prevent the click event if we have resized the column.
        // Fixes https://github.com/mui/mui-x/issues/4777
        doc.addEventListener('click', $668be7296f663159$var$preventClick, true);
    });
    const handleColumnSeparatorDoubleClick = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((params, event)=>{
        if (props.disableAutosize) return;
        // Only handle left clicks
        if (event.button !== 0) return;
        const column = apiRef.current.state.columns.lookup[params.field];
        if (column.resizable === false) return;
        apiRef.current.autosizeColumns((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props.autosizeOptions, {
            disableColumnVirtualization: false,
            columns: [
                column.field
            ]
        }));
    });
    /**
   * API METHODS
   */ const columnVirtualizationDisabled = $668be7296f663159$var$useColumnVirtualizationDisabled(apiRef);
    const isAutosizingRef = $acw62.useRef(false);
    const autosizeColumns = $acw62.useCallback(async (userOptions)=>{
        const root = apiRef.current.rootElementRef?.current;
        if (!root) return;
        if (isAutosizingRef.current) return;
        isAutosizingRef.current = true;
        const state = (0, $1781ebe27505055c$export$858d15abb6cddc08)(apiRef);
        const options = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $65f98549df96a65f$export$9707fe779d390182), userOptions, {
            columns: userOptions?.columns ?? state.orderedFields
        });
        options.columns = options.columns.filter((c)=>state.columnVisibilityModel[c] !== false);
        const columns = options.columns.map((c)=>apiRef.current.state.columns.lookup[c]);
        try {
            if (!props.disableVirtualization && options.disableColumnVirtualization) {
                apiRef.current.unstable_setColumnVirtualization(false);
                await columnVirtualizationDisabled();
            }
            const widthByField = $668be7296f663159$var$extractColumnWidths(apiRef, options, columns);
            const newColumns = columns.map((column)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, column, {
                    width: widthByField[column.field],
                    computedWidth: widthByField[column.field],
                    flex: 0
                }));
            if (options.expand) {
                const visibleColumns = state.orderedFields.map((field)=>state.lookup[field]).filter((c)=>state.columnVisibilityModel[c.field] !== false);
                const totalWidth = visibleColumns.reduce((total, column)=>total + (widthByField[column.field] ?? column.computedWidth ?? column.width), 0);
                const dimensions = apiRef.current.getRootDimensions();
                const availableWidth = dimensions.viewportInnerSize.width;
                const remainingWidth = availableWidth - totalWidth;
                if (remainingWidth > 0) {
                    const widthPerColumn = remainingWidth / (newColumns.length || 1);
                    newColumns.forEach((column)=>{
                        column.width += widthPerColumn;
                        column.computedWidth += widthPerColumn;
                    });
                }
            }
            apiRef.current.updateColumns(newColumns);
            newColumns.forEach((newColumn, index)=>{
                if (newColumn.width !== columns[index].width) {
                    const width = newColumn.width;
                    apiRef.current.publishEvent('columnWidthChange', {
                        element: apiRef.current.getColumnHeaderElement(newColumn.field),
                        colDef: newColumn,
                        width: width
                    });
                }
            });
        } finally{
            if (!props.disableVirtualization) apiRef.current.unstable_setColumnVirtualization(true);
            isAutosizingRef.current = false;
        }
    }, [
        apiRef,
        columnVirtualizationDisabled,
        props.disableVirtualization
    ]);
    /**
   * EFFECTS
   */ $acw62.useEffect(()=>stopListening, [
        stopListening
    ]);
    (0, $a0e38fa988f617e0$export$2e2bcd8739ae039)(()=>{
        if (props.autosizeOnMount) Promise.resolve().then(()=>{
            apiRef.current.autosizeColumns(props.autosizeOptions);
        });
    });
    (0, $f38aaf0a32a5127f$export$265f4c39182036e)(apiRef, ()=>apiRef.current.columnHeadersContainerRef?.current, 'touchstart', handleTouchStart, {
        passive: true
    });
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, {
        autosizeColumns: autosizeColumns
    }, 'public');
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnResizeStop', handleResizeStop);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnResizeStart', handleResizeStart);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnSeparatorMouseDown', handleColumnResizeMouseDown);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnSeparatorDoubleClick', handleColumnSeparatorDoubleClick);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnResize', props.onColumnResize);
    (0, $d5a5cf36ee2ab74a$export$7e1eac1309f32c44)(apiRef, 'columnWidthChange', props.onColumnWidthChange);
};
function $668be7296f663159$var$updateProperty(element, property, delta) {
    if (!element) return;
    element.style[property] = `${Math.round(parseFloat(element.style[property])) + delta}px`;
}




var $acw62 = parcelRequire("acw62");




function $c0018b8fe0569f42$export$dfe82022b99d331c(testRange, processedRange) {
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return null;
    // Overflowing at the end
    // Example: testRange={ firstRowIndex: 10, lastRowIndex: 20 }, processedRange={ firstRowIndex: 0, lastRowIndex: 15 }
    // Unprocessed Range={ firstRowIndex: 16, lastRowIndex: 20 }
    if (testRange.firstRowIndex >= processedRange.firstRowIndex && testRange.lastRowIndex > processedRange.lastRowIndex) return {
        firstRowIndex: processedRange.lastRowIndex,
        lastRowIndex: testRange.lastRowIndex
    };
    // Overflowing at the beginning
    // Example: testRange={ firstRowIndex: 0, lastRowIndex: 20 }, processedRange={ firstRowIndex: 16, lastRowIndex: 30 }
    // Unprocessed Range={ firstRowIndex: 0, lastRowIndex: 15 }
    if (testRange.firstRowIndex < processedRange.firstRowIndex && testRange.lastRowIndex <= processedRange.lastRowIndex) return {
        firstRowIndex: testRange.firstRowIndex,
        lastRowIndex: processedRange.firstRowIndex - 1
    };
    // TODO: Should return two ranges handle overflowing at both ends ?
    return testRange;
}
function $c0018b8fe0569f42$export$55e910ce057d7a27(renderContext) {
    return renderContext.firstRowIndex !== 0 || renderContext.lastRowIndex !== 0;
}
function $c0018b8fe0569f42$export$23d54c9043f34b98(range1, range2) {
    return range1.firstRowIndex !== range2.firstRowIndex || range1.lastRowIndex !== range2.lastRowIndex;
}
const $c0018b8fe0569f42$export$b1f6fa0c5f374def = (row, colDef, apiRef)=>{
    if (!row) return null;
    let cellValue = row[colDef.field];
    const valueGetter = colDef.rowSpanValueGetter ?? colDef.valueGetter;
    if (valueGetter) cellValue = valueGetter(cellValue, row, colDef, apiRef);
    return cellValue;
};






'use client';
const $a765e8ff0a46abd0$var$EMPTY_CACHES = {
    spannedCells: {},
    hiddenCells: {},
    hiddenCellOriginMap: {}
};
const $a765e8ff0a46abd0$var$EMPTY_RANGE = {
    firstRowIndex: 0,
    lastRowIndex: 0
};
const $a765e8ff0a46abd0$var$EMPTY_STATE = {
    caches: $a765e8ff0a46abd0$var$EMPTY_CACHES,
    processedRange: $a765e8ff0a46abd0$var$EMPTY_RANGE
};
/**
 * Default number of rows to process during state initialization to avoid flickering.
 * Number `20` is arbitrarily chosen to be large enough to cover most of the cases without
 * compromising performance.
 */ const $a765e8ff0a46abd0$var$DEFAULT_ROWS_TO_PROCESS = 20;
const $a765e8ff0a46abd0$var$computeRowSpanningState = (apiRef, colDefs, visibleRows, range, rangeToProcess, resetState)=>{
    const virtualizer = apiRef.current.virtualizer;
    const previousState = resetState ? $a765e8ff0a46abd0$var$EMPTY_STATE : (0, $4c1c3a63996032a6$export$a282c9f2bcea1074).selectors.state(virtualizer.store.state);
    const spannedCells = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousState.caches.spannedCells);
    const hiddenCells = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousState.caches.hiddenCells);
    const hiddenCellOriginMap = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, previousState.caches.hiddenCellOriginMap);
    const processedRange = {
        firstRowIndex: Math.min(previousState.processedRange.firstRowIndex, rangeToProcess.firstRowIndex),
        lastRowIndex: Math.max(previousState.processedRange.lastRowIndex, rangeToProcess.lastRowIndex)
    };
    colDefs.forEach((colDef, columnIndex)=>{
        for(let index = rangeToProcess.firstRowIndex; index < rangeToProcess.lastRowIndex; index += 1){
            const row = visibleRows[index];
            if (hiddenCells[row.id]?.[columnIndex]) continue;
            const cellValue = (0, $c0018b8fe0569f42$export$b1f6fa0c5f374def)(row.model, colDef, apiRef);
            if (cellValue == null) continue;
            let spannedRowId = row.id;
            let spannedRowIndex = index;
            let rowSpan = 0;
            // For first index, also scan in the previous rows to handle the reset state case e.g by sorting
            const backwardsHiddenCells = [];
            if (index === rangeToProcess.firstRowIndex) {
                let prevIndex = index - 1;
                let prevRowEntry = visibleRows[prevIndex];
                while(prevIndex >= range.firstRowIndex && prevRowEntry && (0, $c0018b8fe0569f42$export$b1f6fa0c5f374def)(prevRowEntry.model, colDef, apiRef) === cellValue){
                    const currentRow = visibleRows[prevIndex + 1];
                    if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][columnIndex] = true;
                    else hiddenCells[currentRow.id] = {
                        [columnIndex]: true
                    };
                    backwardsHiddenCells.push(index);
                    rowSpan += 1;
                    spannedRowId = prevRowEntry.id;
                    spannedRowIndex = prevIndex;
                    prevIndex -= 1;
                    prevRowEntry = visibleRows[prevIndex];
                }
            }
            backwardsHiddenCells.forEach((hiddenCellIndex)=>{
                if (hiddenCellOriginMap[hiddenCellIndex]) hiddenCellOriginMap[hiddenCellIndex][columnIndex] = spannedRowIndex;
                else hiddenCellOriginMap[hiddenCellIndex] = {
                    [columnIndex]: spannedRowIndex
                };
            });
            // Scan the next rows
            let relativeIndex = index + 1;
            while(relativeIndex <= range.lastRowIndex && visibleRows[relativeIndex] && (0, $c0018b8fe0569f42$export$b1f6fa0c5f374def)(visibleRows[relativeIndex].model, colDef, apiRef) === cellValue){
                const currentRow = visibleRows[relativeIndex];
                if (hiddenCells[currentRow.id]) hiddenCells[currentRow.id][columnIndex] = true;
                else hiddenCells[currentRow.id] = {
                    [columnIndex]: true
                };
                if (hiddenCellOriginMap[relativeIndex]) hiddenCellOriginMap[relativeIndex][columnIndex] = spannedRowIndex;
                else hiddenCellOriginMap[relativeIndex] = {
                    [columnIndex]: spannedRowIndex
                };
                relativeIndex += 1;
                rowSpan += 1;
            }
            if (rowSpan > 0) {
                if (spannedCells[spannedRowId]) spannedCells[spannedRowId][columnIndex] = rowSpan + 1;
                else spannedCells[spannedRowId] = {
                    [columnIndex]: rowSpan + 1
                };
            }
        }
    });
    return {
        caches: {
            spannedCells: spannedCells,
            hiddenCells: hiddenCells,
            hiddenCellOriginMap: hiddenCellOriginMap
        },
        processedRange: processedRange
    };
};
const $a765e8ff0a46abd0$var$getInitialRangeToProcess = (props, apiRef)=>{
    const rowCount = (0, $4fc0d4cb0e570e63$export$c7dcaab5e573753)(apiRef).length;
    if (props.pagination) {
        const pageSize = (0, $e164e26c82788fb1$export$721a46720a2de097)(apiRef);
        let paginationLastRowIndex = $a765e8ff0a46abd0$var$DEFAULT_ROWS_TO_PROCESS;
        if (pageSize > 0) paginationLastRowIndex = pageSize - 1;
        return {
            firstRowIndex: 0,
            lastRowIndex: Math.min(paginationLastRowIndex, rowCount)
        };
    }
    return {
        firstRowIndex: 0,
        lastRowIndex: Math.min($a765e8ff0a46abd0$var$DEFAULT_ROWS_TO_PROCESS, rowCount)
    };
};
const $a765e8ff0a46abd0$export$1fc0574395a3c13e = (state, props, apiRef)=>{
    if (!props.rowSpanning) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        rowSpanning: $a765e8ff0a46abd0$var$EMPTY_STATE
    });
    const rowIds = state.rows.dataRowIds || [];
    const orderedFields = state.columns.orderedFields || [];
    const dataRowIdToModelLookup = state.rows.dataRowIdToModelLookup;
    const columnsLookup = state.columns.lookup;
    const isFilteringPending = Boolean(state.filter.filterModel.items.length) || Boolean(state.filter.filterModel.quickFilterValues?.length);
    if (!rowIds.length || !orderedFields.length || !dataRowIdToModelLookup || !columnsLookup || isFilteringPending) return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        rowSpanning: $a765e8ff0a46abd0$var$EMPTY_STATE
    });
    const rangeToProcess = $a765e8ff0a46abd0$var$getInitialRangeToProcess(props, apiRef);
    const rows = rowIds.map((id)=>({
            id: id,
            model: dataRowIdToModelLookup[id]
        }));
    const colDefs = orderedFields.map((field)=>columnsLookup[field]);
    const rowSpanning = $a765e8ff0a46abd0$var$computeRowSpanningState(apiRef, colDefs, rows, rangeToProcess, rangeToProcess, true);
    return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        rowSpanning: rowSpanning
    });
};
const $a765e8ff0a46abd0$export$bd58ae04485aa5f5 = (apiRef, props)=>{
    const store = apiRef.current.virtualizer.store;
    const updateRowSpanningState = $acw62.useCallback((renderContext, resetState = false)=>{
        const { range: range, rows: visibleRows } = (0, $2b6a1e01125c3822$export$79b9fa322a34430b)(apiRef);
        if (resetState && store.getSnapshot().rowSpanning !== $a765e8ff0a46abd0$var$EMPTY_STATE) store.set('rowSpanning', $a765e8ff0a46abd0$var$EMPTY_STATE);
        if (range === null || !(0, $c0018b8fe0569f42$export$55e910ce057d7a27)(renderContext)) return;
        const previousState = resetState ? $a765e8ff0a46abd0$var$EMPTY_STATE : (0, $4c1c3a63996032a6$export$a282c9f2bcea1074).selectors.state(store.state);
        const rangeToProcess = (0, $c0018b8fe0569f42$export$dfe82022b99d331c)({
            firstRowIndex: renderContext.firstRowIndex,
            lastRowIndex: Math.min(renderContext.lastRowIndex, range.lastRowIndex - range.firstRowIndex + 1)
        }, previousState.processedRange);
        if (rangeToProcess === null) return;
        const colDefs = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef);
        const newState = $a765e8ff0a46abd0$var$computeRowSpanningState(apiRef, colDefs, visibleRows, range, rangeToProcess, resetState);
        const newSpannedCellsCount = Object.keys(newState.caches.spannedCells).length;
        const newHiddenCellsCount = Object.keys(newState.caches.hiddenCells).length;
        const previousSpannedCellsCount = Object.keys(previousState.caches.spannedCells).length;
        const previousHiddenCellsCount = Object.keys(previousState.caches.hiddenCells).length;
        const shouldUpdateState = resetState || newSpannedCellsCount !== previousSpannedCellsCount || newHiddenCellsCount !== previousHiddenCellsCount;
        const hasNoSpannedCells = newSpannedCellsCount === 0 && previousSpannedCellsCount === 0;
        if (!shouldUpdateState || hasNoSpannedCells) return;
        store.set('rowSpanning', newState);
    }, [
        apiRef,
        store
    ]);
    // Reset events trigger a full re-computation of the row spanning state:
    // - The `rowSpanning` prop is updated (feature flag)
    // - The filtering is applied
    // - The sorting is applied
    // - The `paginationModel` is updated
    // - The rows are updated
    const resetRowSpanningState = $acw62.useCallback(()=>{
        const renderContext = (0, $542ae311f57ccc4a$export$4cf9f333a030f780)(apiRef);
        if (!(0, $c0018b8fe0569f42$export$55e910ce057d7a27)(renderContext)) return;
        updateRowSpanningState(renderContext, true);
    }, [
        apiRef,
        updateRowSpanningState
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'renderedRowsIntervalChange', (0, $07a64ebfd26f4296$export$f546127afff6208d)(props.rowSpanning, updateRowSpanningState));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'sortedRowsSet', (0, $07a64ebfd26f4296$export$f546127afff6208d)(props.rowSpanning, resetRowSpanningState));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'paginationModelChange', (0, $07a64ebfd26f4296$export$f546127afff6208d)(props.rowSpanning, resetRowSpanningState));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'filteredRowsSet', (0, $07a64ebfd26f4296$export$f546127afff6208d)(props.rowSpanning, resetRowSpanningState));
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnsChange', (0, $07a64ebfd26f4296$export$f546127afff6208d)(props.rowSpanning, resetRowSpanningState));
    $acw62.useEffect(()=>{
        if (!props.rowSpanning) {
            if (store.state.rowSpanning !== $a765e8ff0a46abd0$var$EMPTY_STATE) store.set('rowSpanning', $a765e8ff0a46abd0$var$EMPTY_STATE);
        } else if (store.state.rowSpanning.caches === $a765e8ff0a46abd0$var$EMPTY_CACHES) resetRowSpanningState();
    }, [
        apiRef,
        store,
        resetRowSpanningState,
        props.rowSpanning
    ]);
};




var $acw62 = parcelRequire("acw62");

const $e9344d451944e2b7$var$warnedOnceCache = new Set();
function $e9344d451944e2b7$export$5b28268982f175ba(message, gravity = 'warning') {
    return;
}
function $e9344d451944e2b7$export$f090597298dd5ce2() {
    $e9344d451944e2b7$var$warnedOnceCache.clear();
}




'use client';
const $cda07b36619cbd82$export$5505a327712c37f5 = (state, props, apiRef)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
        listViewColumn: props.listViewColumn ? (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props.listViewColumn, {
            computedWidth: $cda07b36619cbd82$var$getListColumnWidth(apiRef)
        }) : undefined
    });
function $cda07b36619cbd82$export$5ab13dce76367dce(apiRef, props) {
    /*
   * EVENTS
   */ const updateListColumnWidth = ()=>{
        apiRef.current.setState((state)=>{
            if (!state.listViewColumn) return state;
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                listViewColumn: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state.listViewColumn, {
                    computedWidth: $cda07b36619cbd82$var$getListColumnWidth(apiRef)
                })
            });
        });
    };
    const prevInnerWidth = $acw62.useRef(null);
    const handleGridSizeChange = (viewportInnerSize)=>{
        if (prevInnerWidth.current !== viewportInnerSize.width) {
            prevInnerWidth.current = viewportInnerSize.width;
            updateListColumnWidth();
        }
    };
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'viewportInnerSizeChange', handleGridSizeChange);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnVisibilityModelChange', updateListColumnWidth);
    /*
   * EFFECTS
   */ (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        const listColumn = props.listViewColumn;
        if (listColumn) apiRef.current.setState((state)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, state, {
                listViewColumn: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, listColumn, {
                    computedWidth: $cda07b36619cbd82$var$getListColumnWidth(apiRef)
                })
            });
        });
    }, [
        apiRef,
        props.listViewColumn
    ]);
    $acw62.useEffect(()=>{
        if (props.listView && !props.listViewColumn) (0, $e9344d451944e2b7$export$5b28268982f175ba)([
            'MUI X: The `listViewColumn` prop must be set if `listView` is enabled.',
            'To fix, pass a column definition to the `listViewColumn` prop, e.g. `{ field: "example", renderCell: (params) => <div>{params.row.id}</div> }`.',
            'For more details, see https://mui.com/x/react-data-grid/list-view/'
        ]);
    }, [
        props.listView,
        props.listViewColumn
    ]);
}
function $cda07b36619cbd82$var$getListColumnWidth(apiRef) {
    return (0, $9f487993152f6061$export$26d8768b83a52ffd)(apiRef).viewportInnerSize.width;
}




var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");













const $37cbf4d6c4569db7$export$85108be54a256312 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)((0, $51d9da8b83918212$export$280aedb9454597a5), (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9), (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6), (filterModel, sortModel, paginationModel)=>({
        groupKeys: [],
        paginationModel: paginationModel,
        sortModel: sortModel,
        filterModel: filterModel,
        start: paginationModel.page * paginationModel.pageSize,
        end: paginationModel.page * paginationModel.pageSize + paginationModel.pageSize - 1
    }));



let $8abd6f0841aafd4f$export$3fe2313f3ab9e54b = /*#__PURE__*/ function(DataSourceRowsUpdateStrategy) {
    DataSourceRowsUpdateStrategy["Default"] = "set-flat-rows";
    DataSourceRowsUpdateStrategy["LazyLoading"] = "replace-row-range";
    DataSourceRowsUpdateStrategy["GroupedData"] = "set-grouped-rows";
    return DataSourceRowsUpdateStrategy;
}({});
class $8abd6f0841aafd4f$export$fe047e438c4bfa1b {
    /**
   * @param chunkSize The number of rows to store in each cache entry.
   * If not set, the whole array will be stored in a single cache entry.
   * Setting this value to smallest page size will result in better cache hit rate.
   * Has no effect if cursor pagination is used.
   */ constructor(chunkSize){
        this.chunkSize = chunkSize;
    }
    getCacheKeys = (key)=>{
        if (this.chunkSize < 1 || typeof key.start !== 'number') return [
            key
        ];
        // split the range into chunks
        const chunkedKeys = [];
        for(let i = key.start; i <= key.end; i += this.chunkSize){
            const end = Math.min(i + this.chunkSize - 1, key.end);
            chunkedKeys.push((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, key, {
                start: i,
                end: end
            }));
        }
        return chunkedKeys;
    };
    splitResponse = (key, response)=>{
        const cacheKeys = this.getCacheKeys(key);
        if (cacheKeys.length === 1) return new Map([
            [
                key,
                response
            ]
        ]);
        const responses = new Map();
        cacheKeys.forEach((chunkKey)=>{
            const isLastChunk = chunkKey.end === key.end;
            const responseSlice = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response, {
                pageInfo: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response.pageInfo, {
                    // If the original response had page info, update that information for all but last chunk and keep the original value for the last chunk
                    hasNextPage: response.pageInfo?.hasNextPage !== undefined && !isLastChunk ? true : response.pageInfo?.hasNextPage,
                    nextCursor: response.pageInfo?.nextCursor !== undefined && !isLastChunk ? response.rows[chunkKey.end + 1].id : response.pageInfo?.nextCursor
                }),
                rows: typeof chunkKey.start !== 'number' || typeof key.start !== 'number' ? response.rows : response.rows.slice(chunkKey.start - key.start, chunkKey.end - key.start + 1)
            });
            responses.set(chunkKey, responseSlice);
        });
        return responses;
    };
    static mergeResponses = (responses)=>{
        if (responses.length === 1) return responses[0];
        return responses.reduce((acc, response)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, response, {
                rows: [
                    ...acc.rows,
                    ...response.rows
                ]
            }), {
            rows: [],
            rowCount: 0,
            pageInfo: {}
        });
    };
}


function $e098942a9ee6d36a$export$97761c0e5b2ac1e8(params) {
    return JSON.stringify([
        params.filterModel,
        params.sortModel,
        params.start,
        params.end
    ]);
}
class $e098942a9ee6d36a$export$116641d28fa9a089 {
    constructor({ ttl: ttl = 300000, getKey: getKey = $e098942a9ee6d36a$export$97761c0e5b2ac1e8 }){
        this.cache = {};
        this.ttl = ttl;
        this.getKey = getKey;
    }
    set(key, value) {
        const keyString = this.getKey(key);
        const expiry = Date.now() + this.ttl;
        this.cache[keyString] = {
            value: value,
            expiry: expiry
        };
    }
    get(key) {
        const keyString = this.getKey(key);
        const entry = this.cache[keyString];
        if (!entry) return undefined;
        if (Date.now() > entry.expiry) {
            delete this.cache[keyString];
            return undefined;
        }
        return entry.value;
    }
    clear() {
        this.cache = {};
    }
}


class $6970e5d2c138eebf$export$f9e0e15dddb52b6f extends Error {
    /**
   * The parameters used in the failed request
   */ /**
   * The original error that caused this error
   */ constructor(options){
        super(options.message);
        this.name = 'GridGetRowsError';
        this.params = options.params;
        this.cause = options.cause;
    }
}
class $6970e5d2c138eebf$export$de7b8b20add8c65d extends Error {
    /**
   * The parameters used in the failed request
   */ /**
   * The original error that caused this error
   */ constructor(options){
        super(options.message);
        this.name = 'GridUpdateRowError';
        this.params = options.params;
        this.cause = options.cause;
    }
}


'use client';
const $b443f56bc4fab7f8$var$_excluded = [
    "skipCache",
    "keepChildrenExpanded"
];
const $b443f56bc4fab7f8$var$noopCache = {
    clear: ()=>{},
    get: ()=>undefined,
    set: ()=>{}
};
function $b443f56bc4fab7f8$var$getCache(cacheProp, options = {}) {
    if (cacheProp === null) return $b443f56bc4fab7f8$var$noopCache;
    return cacheProp ?? new (0, $e098942a9ee6d36a$export$116641d28fa9a089)(options);
}
const $b443f56bc4fab7f8$export$e603fccf86b9cd8b = (apiRef, props, options = {})=>{
    const setStrategyAvailability = $acw62.useCallback(()=>{
        apiRef.current.setStrategyAvailability((0, $327d142a03593356$export$b63360e46a4e6d92).DataSource, (0, $8abd6f0841aafd4f$export$3fe2313f3ab9e54b).Default, props.dataSource ? ()=>true : ()=>false);
    }, [
        apiRef,
        props.dataSource
    ]);
    const [currentStrategy, setCurrentStrategy] = $acw62.useState(apiRef.current.getActiveStrategy((0, $327d142a03593356$export$b63360e46a4e6d92).DataSource));
    const standardRowsUpdateStrategyActive = $acw62.useMemo(()=>{
        return currentStrategy === (0, $8abd6f0841aafd4f$export$3fe2313f3ab9e54b).Default || currentStrategy === (0, $8abd6f0841aafd4f$export$3fe2313f3ab9e54b).GroupedData;
    }, [
        currentStrategy
    ]);
    const paginationModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6));
    const lastRequestId = $acw62.useRef(0);
    const onDataSourceErrorProp = props.onDataSourceError;
    const cacheChunkManager = (0, $dd1092ee97d527c8$export$2e2bcd8739ae039)(()=>{
        if (!props.pagination) return new (0, $8abd6f0841aafd4f$export$fe047e438c4bfa1b)(paginationModel.pageSize);
        const sortedPageSizeOptions = props.pageSizeOptions.map((option)=>typeof option === 'number' ? option : option.value).sort((a, b)=>a - b);
        const cacheChunkSize = Math.min(paginationModel.pageSize, sortedPageSizeOptions[0]);
        return new (0, $8abd6f0841aafd4f$export$fe047e438c4bfa1b)(cacheChunkSize);
    }).current;
    const [cache, setCache] = $acw62.useState(()=>$b443f56bc4fab7f8$var$getCache(props.dataSourceCache, options.cacheOptions));
    const fetchRows = $acw62.useCallback(async (parentId, params)=>{
        const getRows = props.dataSource?.getRows;
        if (!getRows) return;
        if (parentId && parentId !== (0, $4ab53eafabc4b920$export$433b924dc2506913) && props.signature !== 'DataGrid') {
            options.fetchRowChildren?.([
                parentId
            ]);
            return;
        }
        options.clearDataSourceState?.();
        const _ref = params || {}, { skipCache: skipCache, keepChildrenExpanded: keepChildrenExpanded } = _ref, getRowsParams = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $b443f56bc4fab7f8$var$_excluded);
        const fetchParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $37cbf4d6c4569db7$export$85108be54a256312)(apiRef), apiRef.current.unstable_applyPipeProcessors('getRowsParams', {}), getRowsParams);
        const cacheKeys = cacheChunkManager.getCacheKeys(fetchParams);
        const responses = cacheKeys.map((cacheKey)=>cache.get(cacheKey));
        if (!skipCache && responses.every((response)=>response !== undefined)) {
            apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                response: (0, $8abd6f0841aafd4f$export$fe047e438c4bfa1b).mergeResponses(responses),
                fetchParams: fetchParams,
                options: {
                    skipCache: skipCache,
                    keepChildrenExpanded: keepChildrenExpanded
                }
            });
            return;
        }
        // Manage loading state only for the default strategy
        if (standardRowsUpdateStrategyActive || apiRef.current.getRowsCount() === 0) apiRef.current.setLoading(true);
        const requestId = lastRequestId.current + 1;
        lastRequestId.current = requestId;
        try {
            const getRowsResponse = await getRows(fetchParams);
            const cacheResponses = cacheChunkManager.splitResponse(fetchParams, getRowsResponse);
            cacheResponses.forEach((response, key)=>cache.set(key, response));
            if (lastRequestId.current === requestId) apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                response: getRowsResponse,
                fetchParams: fetchParams,
                options: {
                    skipCache: skipCache,
                    keepChildrenExpanded: keepChildrenExpanded
                }
            });
        } catch (originalError) {
            if (lastRequestId.current === requestId) {
                apiRef.current.applyStrategyProcessor('dataSourceRowsUpdate', {
                    error: originalError,
                    fetchParams: fetchParams,
                    options: {
                        skipCache: skipCache,
                        keepChildrenExpanded: keepChildrenExpanded
                    }
                });
                if (typeof onDataSourceErrorProp === 'function') onDataSourceErrorProp(new (0, $6970e5d2c138eebf$export$f9e0e15dddb52b6f)({
                    message: originalError?.message,
                    params: fetchParams,
                    cause: originalError
                }));
            }
        } finally{
            if (standardRowsUpdateStrategyActive && lastRequestId.current === requestId) apiRef.current.setLoading(false);
        }
    }, [
        cacheChunkManager,
        cache,
        apiRef,
        standardRowsUpdateStrategyActive,
        props.dataSource?.getRows,
        onDataSourceErrorProp,
        options,
        props.signature
    ]);
    const handleStrategyActivityChange = $acw62.useCallback(()=>{
        setCurrentStrategy(apiRef.current.getActiveStrategy((0, $327d142a03593356$export$b63360e46a4e6d92).DataSource));
    }, [
        apiRef
    ]);
    const handleDataUpdate = $acw62.useCallback((params)=>{
        if ('error' in params) {
            apiRef.current.setRows([]);
            return;
        }
        const { response: response } = params;
        if (response.rowCount !== undefined) apiRef.current.setRowCount(response.rowCount);
        apiRef.current.setRows(response.rows);
        apiRef.current.unstable_applyPipeProcessors('processDataSourceRows', {
            params: params.fetchParams,
            response: response
        }, true);
    }, [
        apiRef
    ]);
    const dataSourceUpdateRow = props.dataSource?.updateRow;
    const handleEditRowOption = options.handleEditRow;
    const editRow = $acw62.useCallback(async (params)=>{
        if (!dataSourceUpdateRow) return undefined;
        try {
            const finalRowUpdate = await dataSourceUpdateRow(params);
            if (typeof handleEditRowOption === 'function') {
                handleEditRowOption(params, finalRowUpdate);
                return finalRowUpdate;
            }
            if (finalRowUpdate && !(0, $5ece57da2e97951f$export$78fdc9adc3f30400)(finalRowUpdate, params.previousRow)) // Reset the outdated cache, only if the row is _actually_ updated
            apiRef.current.dataSource.cache.clear();
            apiRef.current.updateNestedRows([
                finalRowUpdate
            ], []);
            return finalRowUpdate;
        } catch (errorThrown) {
            if (typeof onDataSourceErrorProp === 'function') onDataSourceErrorProp(new (0, $6970e5d2c138eebf$export$de7b8b20add8c65d)({
                message: errorThrown?.message,
                params: params,
                cause: errorThrown
            }));
            throw errorThrown; // Let the caller handle the error further
        }
    }, [
        apiRef,
        dataSourceUpdateRow,
        onDataSourceErrorProp,
        handleEditRowOption
    ]);
    const dataSourceApi = {
        dataSource: {
            fetchRows: fetchRows,
            cache: cache,
            editRow: editRow
        }
    };
    const debouncedFetchRows = $acw62.useMemo(()=>(0, $7cf4d6c2077a48de$export$2e2bcd8739ae039)(fetchRows, 0), [
        fetchRows
    ]);
    const isFirstRender = $acw62.useRef(true);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        if (props.dataSourceCache === undefined) return;
        const newCache = $b443f56bc4fab7f8$var$getCache(props.dataSourceCache, options.cacheOptions);
        setCache((prevCache)=>prevCache !== newCache ? newCache : prevCache);
    }, [
        props.dataSourceCache,
        options.cacheOptions
    ]);
    $acw62.useEffect(()=>{
        // Return early if the proper strategy isn't set yet
        // Context: https://github.com/mui/mui-x/issues/19650
        if (currentStrategy !== (0, $8abd6f0841aafd4f$export$3fe2313f3ab9e54b).Default && currentStrategy !== (0, $8abd6f0841aafd4f$export$3fe2313f3ab9e54b).LazyLoading && currentStrategy !== (0, $8abd6f0841aafd4f$export$3fe2313f3ab9e54b).GroupedData) return undefined;
        if (props.dataSource) {
            apiRef.current.dataSource.cache.clear();
            apiRef.current.dataSource.fetchRows();
        }
        return ()=>{
            // ignore the current request on unmount
            lastRequestId.current += 1;
        };
    }, [
        apiRef,
        props.dataSource,
        currentStrategy
    ]);
    return {
        api: {
            public: dataSourceApi
        },
        debouncedFetchRows: debouncedFetchRows,
        strategyProcessor: {
            strategyName: (0, $8abd6f0841aafd4f$export$3fe2313f3ab9e54b).Default,
            group: 'dataSourceRowsUpdate',
            processor: handleDataUpdate
        },
        setStrategyAvailability: setStrategyAvailability,
        cacheChunkManager: cacheChunkManager,
        cache: cache,
        events: {
            strategyAvailabilityChange: handleStrategyActivityChange,
            sortModelChange: (0, $07a64ebfd26f4296$export$f546127afff6208d)(standardRowsUpdateStrategyActive, ()=>debouncedFetchRows()),
            filterModelChange: (0, $07a64ebfd26f4296$export$f546127afff6208d)(standardRowsUpdateStrategyActive, ()=>debouncedFetchRows()),
            paginationModelChange: (0, $07a64ebfd26f4296$export$f546127afff6208d)(standardRowsUpdateStrategyActive, ()=>debouncedFetchRows())
        }
    };
};


'use client';
const $05511c1a426314ee$export$eb01c6fd4adcb288 = (apiRef, props)=>{
    const { api: api, strategyProcessor: strategyProcessor, events: events, setStrategyAvailability: setStrategyAvailability } = (0, $b443f56bc4fab7f8$export$e603fccf86b9cd8b)(apiRef, props);
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(apiRef, api.public, 'public');
    (0, $0e27fd6eb449426d$export$102a3f5a042c47c4)(apiRef, strategyProcessor.strategyName, strategyProcessor.group, strategyProcessor.processor);
    Object.entries(events).forEach(([event, handler])=>{
        (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, event, handler);
    });
    $acw62.useEffect(()=>{
        setStrategyAvailability();
    }, [
        setStrategyAvailability
    ]);
};


'use client';
const $6bd7eabf2f63dc76$export$4b018ab7873d790d = (apiRef, props, configuration)=>{
    (0, $8e3bb8b59d89563f$export$b77462c86b28bbf0)(apiRef, props);
    /**
   * Register all pre-processors called during state initialization here.
   */ (0, $380be33724089901$export$fa1d7b0897c018ea)(apiRef, props);
    (0, $6767afadae519c6d$export$cc1daa683bbe5702)(apiRef);
    /**
   * Register all state initializers here.
   */ (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $84b6d5fd8ab003aa$export$eb04177a3403979f), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $a568d9675a7040bd$export$73be1d69367eeb5b), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $05c4ec08891f4206$export$8dcda879a58a8f96), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $aee1fe628b61e3de$export$1a6bb5bb341eadaa), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $390722a54a10e3ba$export$951a05deca7e869f), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $c5e6d994a8de55eb$export$1094a2c822d71ffd), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $8ed6099d59a73278$export$bfde38b067fac467), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $76936a01e0647ff8$export$996e35c2eef351ae), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $14905bacef5a00cd$export$a9f45f767b8ade48), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $2d580c76b635f021$export$a3e5a984fe72a5db), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $a765e8ff0a46abd0$export$1fc0574395a3c13e), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $c70f7017dba888d7$export$d6d71dbaaa6fec72), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $668be7296f663159$export$ac6ed2ccd52f643f), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $2698549d3c7037cb$export$8574ffe06bf26347), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $4351539a6fe76c97$export$21c841dc431b3cd0), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $2df47bd4a91f0934$export$42963ad70bb69f54), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $f72b666d60f795fd$export$c29f872c616fae5b), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $552fd44b9758bdc1$export$4224c70cd0329965), apiRef, props);
    (0, $7a5470fd1b8a53b1$export$f9587d613f2caeec)((0, $cda07b36619cbd82$export$5505a327712c37f5), apiRef, props);
    (0, $9667034338309ff9$export$face678f9a86c7e0)(apiRef, props);
    (0, $e13f2e399710c6dc$export$142b8bb1fe6da473)(apiRef, props);
    (0, $a568d9675a7040bd$export$3e2b6b991d9d83f0)(apiRef, props);
    (0, $05c4ec08891f4206$export$fe9b9b8b4620abff)(apiRef, props);
    (0, $aee1fe628b61e3de$export$dd1a4469bbd9394e)(apiRef, props, configuration);
    (0, $a765e8ff0a46abd0$export$bd58ae04485aa5f5)(apiRef, props);
    (0, $c0ea11a50e686349$export$d5da41ef394db9ef)(apiRef, props, configuration);
    (0, $692cb6384e752278$export$ce7ce4871097b52e)(apiRef);
    (0, $4351539a6fe76c97$export$510984a37e2e33f3)(apiRef, props);
    (0, $c5e6d994a8de55eb$export$3a0db16b152b4c54)(apiRef, props);
    (0, $8ed6099d59a73278$export$8b69791fef06a777)(apiRef, props);
    (0, $14905bacef5a00cd$export$343dd9a605dbb75b)(apiRef, props);
    (0, $2d580c76b635f021$export$42838275cbf666c4)(apiRef, props, configuration);
    (0, $76936a01e0647ff8$export$951287757eb5d93c)(apiRef, props);
    (0, $c70f7017dba888d7$export$836c4be63cf7a42d)(apiRef, props);
    (0, $668be7296f663159$export$6761a7afeb3daa64)(apiRef, props);
    (0, $390722a54a10e3ba$export$f1c8f1c02d202e22)(apiRef, props);
    (0, $552fd44b9758bdc1$export$8a4468671da3a64f)(apiRef, props);
    (0, $2c4202bdcc1b9fe3$export$d3441dc29db31b8c)(apiRef, props);
    (0, $2698549d3c7037cb$export$1fc2975c9a725449)(apiRef);
    (0, $7a92b1676fe8176d$export$6178dbab26611702)(apiRef, props);
    (0, $921d2aba9b9d3a7e$export$41205b2521d4edd4)(apiRef, props);
    (0, $631874dc7efcb08b$export$a44b2f69ac6aef73)(apiRef, props);
    (0, $f72b666d60f795fd$export$b8364994f9eec67d)(apiRef, props);
    (0, $35ae6592ae751374$export$8456f443918812d4)(apiRef, props);
    (0, $4bde36936796bcb2$export$971de86bde7f86a1)(apiRef);
    (0, $2df47bd4a91f0934$export$aa0d6df32cccbd53)(apiRef, props);
    (0, $cda07b36619cbd82$export$5ab13dce76367dce)(apiRef, props);
    (0, $05511c1a426314ee$export$eb01c6fd4adcb288)(apiRef, props);
    // Should be the last thing to run, because all pre-processors should have been registered by now.
    $acw62.useEffect(()=>{
        apiRef.current.runAppliersForPendingProcessors();
    });
};




var $acw62 = parcelRequire("acw62");


const $9b88dcc9f58ffb5d$export$d217cc4e11b3c706 = {
    // Root
    noRowsLabel: 'No rows',
    noResultsOverlayLabel: 'No results found.',
    noColumnsOverlayLabel: 'No columns',
    noColumnsOverlayManageColumns: 'Manage columns',
    emptyPivotOverlayLabel: 'Add fields to rows, columns, and values to create a pivot table',
    // Density selector toolbar button text
    toolbarDensity: 'Density',
    toolbarDensityLabel: 'Density',
    toolbarDensityCompact: 'Compact',
    toolbarDensityStandard: 'Standard',
    toolbarDensityComfortable: 'Comfortable',
    // Columns selector toolbar button text
    toolbarColumns: 'Columns',
    toolbarColumnsLabel: 'Select columns',
    // Filters toolbar button text
    toolbarFilters: 'Filters',
    toolbarFiltersLabel: 'Show filters',
    toolbarFiltersTooltipHide: 'Hide filters',
    toolbarFiltersTooltipShow: 'Show filters',
    toolbarFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    // Quick filter toolbar field
    toolbarQuickFilterPlaceholder: "Search\u2026",
    toolbarQuickFilterLabel: 'Search',
    toolbarQuickFilterDeleteIconLabel: 'Clear',
    // Export selector toolbar button text
    toolbarExport: 'Export',
    toolbarExportLabel: 'Export',
    toolbarExportCSV: 'Download as CSV',
    toolbarExportPrint: 'Print',
    toolbarExportExcel: 'Download as Excel',
    // Toolbar pivot button
    toolbarPivot: 'Pivot',
    // Toolbar charts button
    toolbarCharts: 'Charts',
    // Toolbar AI Assistant button
    toolbarAssistant: 'AI Assistant',
    // Columns management text
    columnsManagementSearchTitle: 'Search',
    columnsManagementNoColumns: 'No columns',
    columnsManagementShowHideAllText: 'Show/Hide All',
    columnsManagementReset: 'Reset',
    columnsManagementDeleteIconLabel: 'Clear',
    // Filter panel text
    filterPanelAddFilter: 'Add filter',
    filterPanelRemoveAll: 'Remove all',
    filterPanelDeleteIconLabel: 'Delete',
    filterPanelLogicOperator: 'Logic operator',
    filterPanelOperator: 'Operator',
    filterPanelOperatorAnd: 'And',
    filterPanelOperatorOr: 'Or',
    filterPanelColumns: 'Columns',
    filterPanelInputLabel: 'Value',
    filterPanelInputPlaceholder: 'Filter value',
    // Filter operators text
    filterOperatorContains: 'contains',
    filterOperatorDoesNotContain: 'does not contain',
    filterOperatorEquals: 'equals',
    filterOperatorDoesNotEqual: 'does not equal',
    filterOperatorStartsWith: 'starts with',
    filterOperatorEndsWith: 'ends with',
    filterOperatorIs: 'is',
    filterOperatorNot: 'is not',
    filterOperatorAfter: 'is after',
    filterOperatorOnOrAfter: 'is on or after',
    filterOperatorBefore: 'is before',
    filterOperatorOnOrBefore: 'is on or before',
    filterOperatorIsEmpty: 'is empty',
    filterOperatorIsNotEmpty: 'is not empty',
    filterOperatorIsAnyOf: 'is any of',
    'filterOperator=': '=',
    'filterOperator!=': '!=',
    'filterOperator>': '>',
    'filterOperator>=': '>=',
    'filterOperator<': '<',
    'filterOperator<=': '<=',
    // Header filter operators text
    headerFilterOperatorContains: 'Contains',
    headerFilterOperatorDoesNotContain: 'Does not contain',
    headerFilterOperatorEquals: 'Equals',
    headerFilterOperatorDoesNotEqual: 'Does not equal',
    headerFilterOperatorStartsWith: 'Starts with',
    headerFilterOperatorEndsWith: 'Ends with',
    headerFilterOperatorIs: 'Is',
    headerFilterOperatorNot: 'Is not',
    headerFilterOperatorAfter: 'Is after',
    headerFilterOperatorOnOrAfter: 'Is on or after',
    headerFilterOperatorBefore: 'Is before',
    headerFilterOperatorOnOrBefore: 'Is on or before',
    headerFilterOperatorIsEmpty: 'Is empty',
    headerFilterOperatorIsNotEmpty: 'Is not empty',
    headerFilterOperatorIsAnyOf: 'Is any of',
    'headerFilterOperator=': 'Equals',
    'headerFilterOperator!=': 'Not equals',
    'headerFilterOperator>': 'Greater than',
    'headerFilterOperator>=': 'Greater than or equal to',
    'headerFilterOperator<': 'Less than',
    'headerFilterOperator<=': 'Less than or equal to',
    headerFilterClear: 'Clear filter',
    // Filter values text
    filterValueAny: 'any',
    filterValueTrue: 'true',
    filterValueFalse: 'false',
    // Column menu text
    columnMenuLabel: 'Menu',
    columnMenuAriaLabel: (columnName)=>`${columnName} column menu`,
    columnMenuShowColumns: 'Show columns',
    columnMenuManageColumns: 'Manage columns',
    columnMenuFilter: 'Filter',
    columnMenuHideColumn: 'Hide column',
    columnMenuUnsort: 'Unsort',
    columnMenuSortAsc: 'Sort by ASC',
    columnMenuSortDesc: 'Sort by DESC',
    columnMenuManagePivot: 'Manage pivot',
    columnMenuManageCharts: 'Manage charts',
    // Column header text
    columnHeaderFiltersTooltipActive: (count)=>count !== 1 ? `${count} active filters` : `${count} active filter`,
    columnHeaderFiltersLabel: 'Show filters',
    columnHeaderSortIconLabel: 'Sort',
    // Rows selected footer text
    footerRowSelected: (count)=>count !== 1 ? `${count.toLocaleString()} rows selected` : `${count.toLocaleString()} row selected`,
    // Total row amount footer text
    footerTotalRows: 'Total Rows:',
    // Total visible row amount footer text
    footerTotalVisibleRows: (visibleCount, totalCount)=>`${visibleCount.toLocaleString()} of ${totalCount.toLocaleString()}`,
    // Checkbox selection text
    checkboxSelectionHeaderName: 'Checkbox selection',
    checkboxSelectionSelectAllRows: 'Select all rows',
    checkboxSelectionUnselectAllRows: 'Unselect all rows',
    checkboxSelectionSelectRow: 'Select row',
    checkboxSelectionUnselectRow: 'Unselect row',
    // Boolean cell text
    booleanCellTrueLabel: 'yes',
    booleanCellFalseLabel: 'no',
    // Actions cell more text
    actionsCellMore: 'more',
    // Column pinning text
    pinToLeft: 'Pin to left',
    pinToRight: 'Pin to right',
    unpin: 'Unpin',
    // Tree Data
    treeDataGroupingHeaderName: 'Group',
    treeDataExpand: 'see children',
    treeDataCollapse: 'hide children',
    // Grouping columns
    groupingColumnHeaderName: 'Group',
    groupColumn: (name)=>`Group by ${name}`,
    unGroupColumn: (name)=>`Stop grouping by ${name}`,
    // Master/detail
    detailPanelToggle: 'Detail panel toggle',
    expandDetailPanel: 'Expand',
    collapseDetailPanel: 'Collapse',
    // Pagination
    paginationRowsPerPage: 'Rows per page:',
    paginationDisplayedRows: ({ from: from, to: to, count: count, estimated: estimated })=>{
        if (!estimated) return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
        const estimatedLabel = estimated && estimated > to ? `around ${estimated}` : `more than ${to}`;
        return `${from}\u{2013}${to} of ${count !== -1 ? count : estimatedLabel}`;
    },
    paginationItemAriaLabel: (type)=>{
        if (type === 'first') return 'Go to first page';
        if (type === 'last') return 'Go to last page';
        if (type === 'next') return 'Go to next page';
        // if (type === 'previous') {
        return 'Go to previous page';
    },
    // Row reordering text
    rowReorderingHeaderName: 'Row reordering',
    // Aggregation
    aggregationMenuItemHeader: 'Aggregation',
    aggregationFunctionLabelNone: 'none',
    aggregationFunctionLabelSum: 'sum',
    aggregationFunctionLabelAvg: 'avg',
    aggregationFunctionLabelMin: 'min',
    aggregationFunctionLabelMax: 'max',
    aggregationFunctionLabelSize: 'size',
    // Pivot panel
    pivotToggleLabel: 'Pivot',
    pivotRows: 'Rows',
    pivotColumns: 'Columns',
    pivotValues: 'Values',
    pivotCloseButton: 'Close pivot settings',
    pivotSearchButton: 'Search fields',
    pivotSearchControlPlaceholder: 'Search fields',
    pivotSearchControlLabel: 'Search fields',
    pivotSearchControlClear: 'Clear search',
    pivotNoFields: 'No fields',
    pivotMenuMoveUp: 'Move up',
    pivotMenuMoveDown: 'Move down',
    pivotMenuMoveToTop: 'Move to top',
    pivotMenuMoveToBottom: 'Move to bottom',
    pivotMenuRows: 'Rows',
    pivotMenuColumns: 'Columns',
    pivotMenuValues: 'Values',
    pivotMenuOptions: 'Field options',
    pivotMenuAddToRows: 'Add to Rows',
    pivotMenuAddToColumns: 'Add to Columns',
    pivotMenuAddToValues: 'Add to Values',
    pivotMenuRemove: 'Remove',
    pivotDragToRows: 'Drag here to create rows',
    pivotDragToColumns: 'Drag here to create columns',
    pivotDragToValues: 'Drag here to create values',
    pivotYearColumnHeaderName: '(Year)',
    pivotQuarterColumnHeaderName: '(Quarter)',
    // Charts configuration panel
    chartsNoCharts: 'There are no charts available',
    chartsChartNotSelected: 'Select a chart type to configure its options',
    chartsTabChart: 'Chart',
    chartsTabFields: 'Fields',
    chartsTabCustomize: 'Customize',
    chartsCloseButton: 'Close charts configuration',
    chartsSyncButtonLabel: 'Sync chart',
    chartsSearchPlaceholder: 'Search fields',
    chartsSearchLabel: 'Search fields',
    chartsSearchClear: 'Clear search',
    chartsNoFields: 'No fields',
    chartsFieldBlocked: 'This field cannot be added to any section',
    chartsCategories: 'Categories',
    chartsSeries: 'Series',
    chartsMenuAddToDimensions: (dimensionLabel)=>`Add to ${dimensionLabel}`,
    chartsMenuAddToValues: (valuesLabel)=>`Add to ${valuesLabel}`,
    chartsMenuMoveUp: 'Move up',
    chartsMenuMoveDown: 'Move down',
    chartsMenuMoveToTop: 'Move to top',
    chartsMenuMoveToBottom: 'Move to bottom',
    chartsMenuOptions: 'Field options',
    chartsMenuRemove: 'Remove',
    chartsDragToDimensions: (dimensionLabel)=>`Drag here to use column as ${dimensionLabel}`,
    chartsDragToValues: (valuesLabel)=>`Drag here to use column as ${valuesLabel}`,
    // AI Assistant panel
    aiAssistantPanelTitle: 'AI Assistant',
    aiAssistantPanelClose: 'Close AI Assistant',
    aiAssistantPanelNewConversation: 'New conversation',
    aiAssistantPanelConversationHistory: 'Conversation history',
    aiAssistantPanelEmptyConversation: 'No prompt history',
    aiAssistantSuggestions: 'Suggestions',
    // Prompt field
    promptFieldLabel: 'Prompt',
    promptFieldPlaceholder: "Type a prompt\u2026",
    promptFieldPlaceholderWithRecording: "Type or record a prompt\u2026",
    promptFieldPlaceholderListening: "Listening for prompt\u2026",
    promptFieldSpeechRecognitionNotSupported: 'Speech recognition is not supported in this browser',
    promptFieldSend: 'Send',
    promptFieldRecord: 'Record',
    promptFieldStopRecording: 'Stop recording',
    // Prompt
    promptRerun: 'Run again',
    promptProcessing: "Processing\u2026",
    promptAppliedChanges: 'Applied changes',
    // Prompt changes
    promptChangeGroupDescription: (column)=>`Group by ${column}`,
    promptChangeAggregationLabel: (column, aggregation)=>`${column} (${aggregation})`,
    promptChangeAggregationDescription: (column, aggregation)=>`Aggregate ${column} (${aggregation})`,
    promptChangeFilterLabel: (column, operator, value)=>{
        if (operator === 'is any of') return `${column} is any of: ${value}`;
        return `${column} ${operator} ${value}`;
    },
    promptChangeFilterDescription: (column, operator, value)=>{
        if (operator === 'is any of') return `Filter where ${column} is any of: ${value}`;
        return `Filter where ${column} ${operator} ${value}`;
    },
    promptChangeSortDescription: (column, direction)=>`Sort by ${column} (${direction})`,
    promptChangePivotEnableLabel: 'Pivot',
    promptChangePivotEnableDescription: 'Enable pivot',
    promptChangePivotColumnsLabel: (count)=>`Columns (${count})`,
    promptChangePivotColumnsDescription: (column, direction)=>`${column}${direction ? ` (${direction})` : ''}`,
    promptChangePivotRowsLabel: (count)=>`Rows (${count})`,
    promptChangePivotValuesLabel: (count)=>`Values (${count})`,
    promptChangePivotValuesDescription: (column, aggregation)=>`${column} (${aggregation})`,
    promptChangeChartsLabel: (dimensionsCount, valuesCount)=>`Dimensions (${dimensionsCount}), Values (${valuesCount})`
};





var $acw62 = parcelRequire("acw62");











parcelRequire("acw62");







const $7eb64cdcad453fb6$var$_excluded = [
    "className"
];
const $7eb64cdcad453fb6$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'iconButtonContainer'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $7eb64cdcad453fb6$var$GridIconButtonContainerRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'IconButtonContainer'
})(()=>({
        display: 'flex',
        visibility: 'hidden',
        width: 0
    }));
const $7eb64cdcad453fb6$export$e67562d5b709404c = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridIconButtonContainer(props, ref) {
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $7eb64cdcad453fb6$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $7eb64cdcad453fb6$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7eb64cdcad453fb6$var$GridIconButtonContainerRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});



const $5bcf7c74dc2b204c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        icon: [
            'filterIcon'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
function $5bcf7c74dc2b204c$export$35b5c67d267fafd7(props) {
    if (!props.counter) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($5bcf7c74dc2b204c$var$GridColumnHeaderFilterIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props));
}
function $5bcf7c74dc2b204c$var$GridColumnHeaderFilterIconButton(props) {
    const { counter: counter, field: field, onClick: onClick } = props;
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes
    });
    const classes = $5bcf7c74dc2b204c$var$useUtilityClasses(ownerState);
    const labelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const isOpen = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9a7998a995118469$export$d19024d6f0cb2c88), labelId);
    const panelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const toggleFilter = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        const { open: open, openedPanelValue: openedPanelValue } = (0, $9a7998a995118469$export$37e5474577e02878)(apiRef);
        if (open && openedPanelValue === (0, $e38c9af0748d9173$export$e7e5652452e44b).filters) apiRef.current.hideFilterPanel();
        else apiRef.current.showFilterPanel(undefined, panelId, labelId);
        if (onClick) onClick(apiRef.current.getColumnHeaderParams(field), event);
    }, [
        apiRef,
        field,
        onClick,
        panelId,
        labelId
    ]);
    if (!counter) return null;
    const iconButton = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: labelId,
        onClick: toggleFilter,
        "aria-label": apiRef.current.getLocaleText('columnHeaderFiltersLabel'),
        size: "small",
        tabIndex: -1,
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        "aria-controls": isOpen ? panelId : undefined
    }, rootProps.slotProps?.baseIconButton, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnFilteredIcon, {
            className: classes.icon,
            fontSize: "small"
        })
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTooltip, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        title: apiRef.current.getLocaleText('columnHeaderFiltersTooltipActive')(counter),
        enterDelay: 1000
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7eb64cdcad453fb6$export$e67562d5b709404c), {
            children: [
                counter > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseBadge, {
                    badgeContent: counter,
                    color: "default",
                    children: iconButton
                }),
                counter === 1 && iconButton
            ]
        })
    }));
}



var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");










const $9ab20ae328d1ea37$var$_excluded = [
    "direction",
    "index",
    "sortingOrder",
    "disabled",
    "className"
];
const $9ab20ae328d1ea37$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'sortButton'
        ],
        icon: [
            'sortIcon'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $9ab20ae328d1ea37$var$GridColumnSortButtonRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d), {
    name: 'MuiDataGrid',
    slot: 'SortButton'
})({
    transition: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transition([
        'opacity'
    ], {
        duration: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transitions.duration.short,
        easing: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transitions.easing.easeInOut
    })
});
function $9ab20ae328d1ea37$var$getIcon(icons, direction, className, sortingOrder) {
    let Icon;
    const iconProps = {};
    if (direction === 'asc') Icon = icons.columnSortedAscendingIcon;
    else if (direction === 'desc') Icon = icons.columnSortedDescendingIcon;
    else {
        Icon = icons.columnUnsortedIcon;
        iconProps.sortingOrder = sortingOrder;
    }
    return Icon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        fontSize: "small",
        className: className
    }, iconProps)) : null;
}
function $9ab20ae328d1ea37$export$2b3058b643ada0cd(props) {
    const { direction: direction, index: index, sortingOrder: sortingOrder, disabled: disabled, className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9ab20ae328d1ea37$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes
    });
    const classes = $9ab20ae328d1ea37$var$useUtilityClasses(ownerState);
    const iconElement = $9ab20ae328d1ea37$var$getIcon(rootProps.slots, direction, classes.icon, sortingOrder);
    if (!iconElement) return null;
    const iconButton = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9ab20ae328d1ea37$var$GridColumnSortButtonRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        as: rootProps.slots.baseIconButton,
        ownerState: ownerState,
        "aria-label": apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        title: apiRef.current.getLocaleText('columnHeaderSortIconLabel'),
        size: "small",
        disabled: disabled,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className)
    }, rootProps.slotProps?.baseIconButton, other, {
        children: iconElement
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            index != null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseBadge, {
                badgeContent: index,
                color: "default",
                overlap: "circular",
                children: iconButton
            }),
            index == null && iconButton
        ]
    });
}



function $469a87926117c22e$var$GridColumnHeaderSortIconRaw(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7eb64cdcad453fb6$export$e67562d5b709404c), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ab20ae328d1ea37$export$2b3058b643ada0cd), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
            tabIndex: -1
        }))
    });
}
const $469a87926117c22e$export$80cd75c5dceceac6 = /*#__PURE__*/ $acw62.memo($469a87926117c22e$var$GridColumnHeaderSortIconRaw);

/* eslint-disable @typescript-eslint/no-use-before-define */ 

var $acw62 = parcelRequire("acw62");











const $a919bc3d2da94886$export$bfa7dd6f7574dd6b = (a, b)=>{
    // Filter `false` values only, as `true` and not having a key are the same
    const aFalseValues = new Set(Object.keys(a).filter((key)=>a[key] === false));
    const bFalseValues = new Set(Object.keys(b).filter((key)=>b[key] === false));
    if (aFalseValues.size !== bFalseValues.size) return false;
    let result = true;
    aFalseValues.forEach((key)=>{
        if (!bFalseValues.has(key)) result = false;
    });
    return result;
};
const $a919bc3d2da94886$export$cbdfd8d51f352d2a = (column, searchValue)=>(column.headerName || column.field).toLowerCase().indexOf(searchValue) > -1;





parcelRequire("acw62");




const $3aefe18f0f6f1226$var$_excluded = [
    "children"
];
const $3aefe18f0f6f1226$var$reveal = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    from: {
        opacity: 0
    },
    to: {
        opacity: 1
    }
});
const $3aefe18f0f6f1226$var$detectScroll = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)({
    'from, to': {
        '--scrollable': '" "'
    }
});
// This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.
const $3aefe18f0f6f1226$var$ShadowScrollArea = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ShadowScrollArea'
})`
  flex: 1;
  display: flex;
  flex-direction: column;
  animation: ${$3aefe18f0f6f1226$var$detectScroll};
  animation-timeline: --scroll-timeline;
  animation-fill-mode: none;
  box-sizing: border-box;
  overflow: auto;
  scrollbar-width: thin;
  scroll-timeline: --scroll-timeline block;

  &::before,
  &::after {
    content: '';
    flex-shrink: 0;
    display: block;
    position: sticky;
    left: 0;
    width: 100%;
    height: 4px;
    animation: ${$3aefe18f0f6f1226$var$reveal} linear both;
    animation-timeline: --scroll-timeline;

    // Custom property toggle trick:
    // - Detects if the element is scrollable
    // - https://css-tricks.com/the-css-custom-property-toggle-trick/
    --visibility-scrollable: var(--scrollable) visible;
    --visibility-not-scrollable: hidden;
    visibility: var(--visibility-scrollable, var(--visibility-not-scrollable));
  }

  &::before {
    top: 0;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0.05) 0, transparent 100%);
    animation-range: 0 4px;
  }

  &::after {
    bottom: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 0.05) 0, transparent 100%);
    animation-direction: reverse;
    animation-range: calc(100% - 4px) 100%;
  }
`;
/**
 * Adds scroll shadows above and below content in a scrollable container.
 */ const $3aefe18f0f6f1226$export$9970c91383b8a107 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridShadowScrollArea(props, ref) {
    const { children: children } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $3aefe18f0f6f1226$var$_excluded);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3aefe18f0f6f1226$var$ShadowScrollArea, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        children: children
    }));
});




'use client';
const $a0f87d3bf8a4e691$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnsManagement'
        ],
        header: [
            'columnsManagementHeader'
        ],
        searchInput: [
            'columnsManagementSearchInput'
        ],
        footer: [
            'columnsManagementFooter'
        ],
        row: [
            'columnsManagementRow'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $a0f87d3bf8a4e691$var$collator = new Intl.Collator();
function $a0f87d3bf8a4e691$export$3710e0bb3d9954d(props) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const searchInputRef = $acw62.useRef(null);
    const initialColumnVisibilityModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$7212e0fec3c2218));
    const columnVisibilityModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$eb0d33595fe29bb4));
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const [searchValue, setSearchValue] = $acw62.useState('');
    const classes = $a0f87d3bf8a4e691$var$useUtilityClasses(rootProps);
    const columnDefinitions = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$da85f06e3c19f1fd));
    const pivotActive = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $8f88c26e7e51121c$export$c1e9ba02e25d9a4d));
    const pivotInitialColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $8f88c26e7e51121c$export$c994aaa19f0be33d));
    const columns = $acw62.useMemo(()=>pivotActive ? Array.from(pivotInitialColumns.values()) : columnDefinitions, [
        pivotActive,
        pivotInitialColumns,
        columnDefinitions
    ]);
    const { sort: sort, searchPredicate: searchPredicate = (0, $a919bc3d2da94886$export$cbdfd8d51f352d2a), autoFocusSearchField: autoFocusSearchField = true, disableShowHideToggle: disableShowHideToggle = false, disableResetButton: disableResetButton = false, toggleAllMode: toggleAllMode = 'all', getTogglableColumns: getTogglableColumns, searchInputProps: searchInputProps, searchDebounceMs: searchDebounceMs = rootProps.columnFilterDebounceMs } = props;
    const debouncedFilter = $acw62.useMemo(()=>(0, $7cf4d6c2077a48de$export$2e2bcd8739ae039)((value)=>{
            setSearchValue(value);
        }, searchDebounceMs ?? 150), [
        searchDebounceMs
    ]);
    const isResetDisabled = $acw62.useMemo(()=>(0, $a919bc3d2da94886$export$bfa7dd6f7574dd6b)(columnVisibilityModel, initialColumnVisibilityModel), [
        columnVisibilityModel,
        initialColumnVisibilityModel
    ]);
    const sortedColumns = $acw62.useMemo(()=>{
        switch(sort){
            case 'asc':
                return [
                    ...columns
                ].sort((a, b)=>$a0f87d3bf8a4e691$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            case 'desc':
                return [
                    ...columns
                ].sort((a, b)=>-$a0f87d3bf8a4e691$var$collator.compare(a.headerName || a.field, b.headerName || b.field));
            default:
                return columns;
        }
    }, [
        columns,
        sort
    ]);
    const toggleColumn = (event)=>{
        const { name: field } = event.target;
        apiRef.current.setColumnVisibility(field, columnVisibilityModel[field] === false);
    };
    const currentColumns = $acw62.useMemo(()=>{
        const togglableColumns = getTogglableColumns ? getTogglableColumns(sortedColumns) : null;
        const togglableSortedColumns = togglableColumns ? sortedColumns.filter(({ field: field })=>togglableColumns.includes(field)) : sortedColumns;
        if (!searchValue) return togglableSortedColumns;
        return togglableSortedColumns.filter((column)=>searchPredicate(column, searchValue.toLowerCase()));
    }, [
        sortedColumns,
        searchValue,
        searchPredicate,
        getTogglableColumns
    ]);
    const toggleAllColumns = $acw62.useCallback((isVisible)=>{
        const currentModel = (0, $1781ebe27505055c$export$eb0d33595fe29bb4)(apiRef);
        const newModel = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentModel);
        const togglableColumns = getTogglableColumns ? getTogglableColumns(columns) : null;
        (toggleAllMode === 'filteredOnly' ? currentColumns : columns).forEach((col)=>{
            if (col.hideable && (togglableColumns == null || togglableColumns.includes(col.field))) {
                if (isVisible) // delete the key from the model instead of setting it to `true`
                delete newModel[col.field];
                else newModel[col.field] = false;
            }
        });
        return apiRef.current.setColumnVisibilityModel(newModel);
    }, [
        apiRef,
        columns,
        getTogglableColumns,
        toggleAllMode,
        currentColumns
    ]);
    const handleSearchValueChange = $acw62.useCallback((event)=>{
        debouncedFilter(event.target.value);
    }, [
        debouncedFilter
    ]);
    const hideableColumns = $acw62.useMemo(()=>currentColumns.filter((col)=>col.hideable), [
        currentColumns
    ]);
    const allHideableColumnsVisible = $acw62.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] == null || columnVisibilityModel[column.field] !== false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const allHideableColumnsHidden = $acw62.useMemo(()=>hideableColumns.every((column)=>columnVisibilityModel[column.field] === false), [
        columnVisibilityModel,
        hideableColumns
    ]);
    const firstSwitchRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (autoFocusSearchField) searchInputRef.current?.focus();
        else if (firstSwitchRef.current && typeof firstSwitchRef.current.focus === 'function') firstSwitchRef.current.focus();
    }, [
        autoFocusSearchField
    ]);
    let firstHideableColumnFound = false;
    const isFirstHideableColumn = (column)=>{
        if (firstHideableColumnFound === false && column.hideable !== false) {
            firstHideableColumnFound = true;
            return true;
        }
        return false;
    };
    const handleSearchReset = $acw62.useCallback(()=>{
        setSearchValue('');
        if (searchInputRef.current) {
            searchInputRef.current.value = '';
            searchInputRef.current.focus();
        }
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a0f87d3bf8a4e691$var$GridColumnsManagementHeader, {
                className: classes.header,
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a0f87d3bf8a4e691$var$SearchInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    as: rootProps.slots.baseTextField,
                    ownerState: rootProps,
                    placeholder: apiRef.current.getLocaleText('columnsManagementSearchTitle'),
                    inputRef: searchInputRef,
                    className: classes.searchInput,
                    onChange: handleSearchValueChange,
                    size: "small",
                    type: "search",
                    slotProps: {
                        input: {
                            startAdornment: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.quickFilterIcon, {
                                fontSize: "small"
                            }),
                            endAdornment: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                                size: "small",
                                "aria-label": apiRef.current.getLocaleText('columnsManagementDeleteIconLabel'),
                                style: searchValue ? {
                                    visibility: 'visible'
                                } : {
                                    visibility: 'hidden'
                                },
                                tabIndex: -1,
                                onClick: handleSearchReset,
                                edge: "end"
                            }, rootProps.slotProps?.baseIconButton, {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.quickFilterClearIcon, {
                                    fontSize: "small"
                                })
                            }))
                        },
                        htmlInput: {
                            'aria-label': apiRef.current.getLocaleText('columnsManagementSearchTitle')
                        }
                    },
                    autoComplete: "off",
                    fullWidth: true
                }, rootProps.slotProps?.baseTextField, searchInputProps))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a0f87d3bf8a4e691$var$GridColumnsManagementScrollArea, {
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a0f87d3bf8a4e691$var$GridColumnsManagementBody, {
                    className: classes.root,
                    ownerState: rootProps,
                    children: [
                        currentColumns.map((column)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a0f87d3bf8a4e691$var$GridColumnsManagementRow, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                                as: rootProps.slots.baseCheckbox,
                                className: classes.row,
                                disabled: column.hideable === false || pivotActive,
                                checked: columnVisibilityModel[column.field] !== false,
                                onChange: toggleColumn,
                                name: column.field,
                                inputRef: isFirstHideableColumn(column) ? firstSwitchRef : undefined,
                                label: column.headerName || column.field,
                                density: "compact",
                                fullWidth: true
                            }, rootProps.slotProps?.baseCheckbox), column.field)),
                        currentColumns.length === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a0f87d3bf8a4e691$var$GridColumnsManagementEmptyText, {
                            ownerState: rootProps,
                            children: apiRef.current.getLocaleText('columnsManagementNoColumns')
                        })
                    ]
                })
            }),
            !disableShowHideToggle || !disableResetButton ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a0f87d3bf8a4e691$var$GridColumnsManagementFooter, {
                ownerState: rootProps,
                className: classes.footer,
                children: [
                    !disableShowHideToggle ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseCheckbox, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        disabled: hideableColumns.length === 0 || pivotActive,
                        checked: allHideableColumnsVisible,
                        indeterminate: !allHideableColumnsVisible && !allHideableColumnsHidden,
                        onChange: ()=>toggleAllColumns(!allHideableColumnsVisible),
                        name: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                        label: apiRef.current.getLocaleText('columnsManagementShowHideAllText'),
                        density: "compact"
                    }, rootProps.slotProps?.baseCheckbox)) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                    !disableResetButton ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        onClick: ()=>apiRef.current.setColumnVisibilityModel(initialColumnVisibilityModel),
                        disabled: isResetDisabled || pivotActive
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('columnsManagementReset')
                    })) : null
                ]
            }) : null
        ]
    });
}
const $a0f87d3bf8a4e691$var$GridColumnsManagementBody = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagement'
})({
    display: 'flex',
    flexDirection: 'column',
    padding: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(0.5, 1.5)
});
const $a0f87d3bf8a4e691$var$GridColumnsManagementScrollArea = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3aefe18f0f6f1226$export$9970c91383b8a107), {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementScrollArea'
})({
    maxHeight: 300
});
const $a0f87d3bf8a4e691$var$GridColumnsManagementHeader = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementHeader'
})({
    padding: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(1.5, 2),
    borderBottom: `1px solid ${(0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.border.base}`
});
const $a0f87d3bf8a4e691$var$SearchInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d), {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementSearchInput'
})({
    [`& .${(0, $587a42eced554844$export$2e2bcd8739ae039).input}::-webkit-search-decoration,
      & .${(0, $587a42eced554844$export$2e2bcd8739ae039).input}::-webkit-search-cancel-button,
      & .${(0, $587a42eced554844$export$2e2bcd8739ae039).input}::-webkit-search-results-button,
      & .${(0, $587a42eced554844$export$2e2bcd8739ae039).input}::-webkit-search-results-decoration`]: {
        /* clears the 'X' icon from Chrome */ display: 'none'
    }
});
const $a0f87d3bf8a4e691$var$GridColumnsManagementFooter = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementFooter'
})({
    padding: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(1, 1, 1, 1.5),
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${(0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.border.base}`
});
const $a0f87d3bf8a4e691$var$GridColumnsManagementEmptyText = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementEmptyText'
})({
    padding: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(1, 0),
    alignSelf: 'center',
    font: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).typography.font.body
});
const $a0f87d3bf8a4e691$var$GridColumnsManagementRow = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d), {
    name: 'MuiDataGrid',
    slot: 'ColumnsManagementRow'
})({});


parcelRequire("acw62");


parcelRequire("acw62");







const $54d6c141b0e5cff8$var$_excluded = [
    "className"
];
const $54d6c141b0e5cff8$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelWrapper'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $54d6c141b0e5cff8$var$GridPanelWrapperRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelWrapper'
})({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    '&:focus': {
        outline: 0
    }
});
const $54d6c141b0e5cff8$export$6a36e1ca07bd502c = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridPanelWrapper(props, ref) {
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $54d6c141b0e5cff8$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $54d6c141b0e5cff8$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($54d6c141b0e5cff8$var$GridPanelWrapperRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        tabIndex: -1,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});




function $f84855c4cf095e9d$export$39d43456ec96cf57(props) {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54d6c141b0e5cff8$export$6a36e1ca07bd502c), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnsManagement, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.columnsManagement))
    }));
}




var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");








const $365a149208d904dc$var$_excluded = [
    "className"
];
const $365a149208d904dc$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelContent'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $365a149208d904dc$var$GridPanelContentRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelContent'
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    flex: '1 1',
    maxHeight: 400,
    padding: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(2.5, 1.5, 2, 1),
    gap: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(2.5)
});
function $365a149208d904dc$export$1b4102a66373332b(props) {
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $365a149208d904dc$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $365a149208d904dc$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($365a149208d904dc$var$GridPanelContentRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other));
}




parcelRequire("acw62");








const $116c3809d51a1833$var$_excluded = [
    "className"
];
const $116c3809d51a1833$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'panelFooter'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $116c3809d51a1833$var$GridPanelFooterRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'PanelFooter'
})({
    padding: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(1),
    display: 'flex',
    justifyContent: 'space-between',
    borderTop: `1px solid ${(0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.border.base}`
});
function $116c3809d51a1833$export$18e44097a2744a(props) {
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $116c3809d51a1833$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $116c3809d51a1833$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($116c3809d51a1833$var$GridPanelFooterRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other));
}






var $acw62 = parcelRequire("acw62");


















const $7fcbeccc9211499d$var$_excluded = [
    "item",
    "hasMultipleFilters",
    "deleteFilter",
    "applyFilterChanges",
    "showMultiFilterOperators",
    "disableMultiFilterOperator",
    "applyMultiFilterOperatorChanges",
    "focusElementRef",
    "logicOperators",
    "columnsSort",
    "filterColumns",
    "deleteIconProps",
    "logicOperatorInputProps",
    "operatorInputProps",
    "columnInputProps",
    "valueInputProps",
    "readOnly",
    "children"
], $7fcbeccc9211499d$var$_excluded2 = [
    "InputComponentProps"
];
const $7fcbeccc9211499d$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'filterForm'
        ],
        deleteIcon: [
            'filterFormDeleteIcon'
        ],
        logicOperatorInput: [
            'filterFormLogicOperatorInput'
        ],
        columnInput: [
            'filterFormColumnInput'
        ],
        operatorInput: [
            'filterFormOperatorInput'
        ],
        valueInput: [
            'filterFormValueInput'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $7fcbeccc9211499d$var$GridFilterFormRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterForm'
})({
    display: 'flex',
    gap: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(1.5)
});
const $7fcbeccc9211499d$var$FilterFormDeleteIcon = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormDeleteIcon'
})({
    flexShrink: 0,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
});
const $7fcbeccc9211499d$var$FilterFormLogicOperatorInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormLogicOperatorInput'
})({
    minWidth: 75,
    justifyContent: 'end'
});
const $7fcbeccc9211499d$var$FilterFormColumnInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormColumnInput'
})({
    width: 150
});
const $7fcbeccc9211499d$var$FilterFormOperatorInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormOperatorInput'
})({
    width: 150
});
const $7fcbeccc9211499d$var$FilterFormValueInput = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FilterFormValueInput'
})({
    width: 190
});
const $7fcbeccc9211499d$var$getLogicOperatorLocaleKey = (logicOperator)=>{
    switch(logicOperator){
        case (0, $4993f96105ede556$export$90be184ccbab1c7a).And:
            return 'filterPanelOperatorAnd';
        case (0, $4993f96105ede556$export$90be184ccbab1c7a).Or:
            return 'filterPanelOperatorOr';
        default:
            throw new Error('MUI X: Invalid `logicOperator` property in the `GridFilterPanel`.');
    }
};
const $7fcbeccc9211499d$var$getColumnLabel = (col)=>col.headerName || col.field;
const $7fcbeccc9211499d$var$collator = new Intl.Collator();
const $7fcbeccc9211499d$export$4c95feba7016dbe7 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridFilterForm(props, ref) {
    const { item: item, hasMultipleFilters: hasMultipleFilters, deleteFilter: deleteFilter, applyFilterChanges: applyFilterChanges, showMultiFilterOperators: showMultiFilterOperators, disableMultiFilterOperator: disableMultiFilterOperator, applyMultiFilterOperatorChanges: applyMultiFilterOperatorChanges, focusElementRef: focusElementRef, logicOperators: logicOperators = [
        (0, $4993f96105ede556$export$90be184ccbab1c7a).And,
        (0, $4993f96105ede556$export$90be184ccbab1c7a).Or
    ], columnsSort: columnsSort, filterColumns: filterColumns, deleteIconProps: deleteIconProps = {}, logicOperatorInputProps: logicOperatorInputProps = {}, operatorInputProps: operatorInputProps = {}, columnInputProps: columnInputProps = {}, valueInputProps: valueInputProps = {}, readOnly: readOnly } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $7fcbeccc9211499d$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const columnLookup = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$8a3a9a6db584d7fd));
    const filterableColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$2cad659ba95fed71));
    const filterModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$280aedb9454597a5));
    const columnSelectId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const columnSelectLabelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const operatorSelectId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const operatorSelectLabelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $7fcbeccc9211499d$var$useUtilityClasses(rootProps);
    const valueRef = $acw62.useRef(null);
    const filterSelectorRef = $acw62.useRef(null);
    const multiFilterOperator = filterModel.logicOperator ?? (0, $4993f96105ede556$export$90be184ccbab1c7a).And;
    const hasLogicOperatorColumn = hasMultipleFilters && logicOperators.length > 0;
    const baseSelectProps = rootProps.slotProps?.baseSelect || {};
    const isBaseSelectNative = baseSelectProps.native ?? false;
    const baseSelectOptionProps = rootProps.slotProps?.baseSelectOption || {};
    const { InputComponentProps: InputComponentProps } = valueInputProps, valueInputPropsOther = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(valueInputProps, $7fcbeccc9211499d$var$_excluded2);
    const pivotActive = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $8f88c26e7e51121c$export$c1e9ba02e25d9a4d));
    const initialColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $8f88c26e7e51121c$export$c994aaa19f0be33d));
    const { filteredColumns: filteredColumns, selectedField: selectedField } = $acw62.useMemo(()=>{
        let itemField = item.field;
        // Yields a valid value if the current filter belongs to a column that is not filterable
        const selectedNonFilterableColumn = columnLookup[item.field].filterable === false ? columnLookup[item.field] : null;
        if (selectedNonFilterableColumn) return {
            filteredColumns: [
                selectedNonFilterableColumn
            ],
            selectedField: itemField
        };
        if (pivotActive) return {
            filteredColumns: filterableColumns.filter((column)=>initialColumns.get(column.field) !== undefined),
            selectedField: itemField
        };
        if (filterColumns === undefined || typeof filterColumns !== 'function') return {
            filteredColumns: filterableColumns,
            selectedField: itemField
        };
        const filteredFields = filterColumns({
            field: item.field,
            columns: filterableColumns,
            currentFilters: filterModel?.items || []
        });
        return {
            filteredColumns: filterableColumns.filter((column)=>{
                const isFieldIncluded = filteredFields.includes(column.field);
                if (column.field === item.field && !isFieldIncluded) itemField = undefined;
                return isFieldIncluded;
            }),
            selectedField: itemField
        };
    }, [
        item.field,
        columnLookup,
        pivotActive,
        filterColumns,
        filterableColumns,
        filterModel?.items,
        initialColumns
    ]);
    const sortedFilteredColumns = $acw62.useMemo(()=>{
        switch(columnsSort){
            case 'asc':
                return filteredColumns.sort((a, b)=>$7fcbeccc9211499d$var$collator.compare($7fcbeccc9211499d$var$getColumnLabel(a), $7fcbeccc9211499d$var$getColumnLabel(b)));
            case 'desc':
                return filteredColumns.sort((a, b)=>-$7fcbeccc9211499d$var$collator.compare($7fcbeccc9211499d$var$getColumnLabel(a), $7fcbeccc9211499d$var$getColumnLabel(b)));
            default:
                return filteredColumns;
        }
    }, [
        filteredColumns,
        columnsSort
    ]);
    const currentColumn = item.field ? apiRef.current.getColumn(item.field) : null;
    const currentOperator = $acw62.useMemo(()=>{
        if (!item.operator || !currentColumn) return null;
        return currentColumn.filterOperators?.find((operator)=>operator.value === item.operator);
    }, [
        item,
        currentColumn
    ]);
    const changeColumn = $acw62.useCallback((event)=>{
        const field = event.target.value;
        const column = apiRef.current.getColumn(field);
        if (column.field === currentColumn.field) // column did not change
        return;
        // try to keep the same operator when column change
        const newOperator = column.filterOperators.find((operator)=>operator.value === item.operator) || column.filterOperators[0];
        // Erase filter value if the input component or filtered column type is modified
        const eraseFilterValue = !newOperator.InputComponent || newOperator.InputComponent !== currentOperator?.InputComponent || column.type !== currentColumn.type;
        let filterValue = eraseFilterValue ? undefined : item.value;
        // Check filter value against the new valueOptions
        if (column.type === 'singleSelect' && filterValue !== undefined) {
            const colDef = column;
            const valueOptions = (0, $be429daa670a91f7$export$b871910a1101d890)(colDef);
            if (Array.isArray(filterValue)) filterValue = filterValue.filter((val)=>{
                return(// Only keep values that are in the new value options
                (0, $be429daa670a91f7$export$b31a7985e33f7505)(val, valueOptions, colDef?.getOptionValue) !== undefined);
            });
            else if ((0, $be429daa670a91f7$export$b31a7985e33f7505)(item.value, valueOptions, colDef?.getOptionValue) === undefined) // Reset the filter value if it is not in the new value options
            filterValue = undefined;
        }
        applyFilterChanges((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
            field: field,
            operator: newOperator.value,
            value: filterValue
        }));
    }, [
        apiRef,
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeOperator = $acw62.useCallback((event)=>{
        const operator = event.target.value;
        const newOperator = currentColumn?.filterOperators.find((op)=>op.value === operator);
        const eraseItemValue = !newOperator?.InputComponent || newOperator?.InputComponent !== currentOperator?.InputComponent;
        applyFilterChanges((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, item, {
            operator: operator,
            value: eraseItemValue ? undefined : item.value
        }));
    }, [
        applyFilterChanges,
        item,
        currentColumn,
        currentOperator
    ]);
    const changeLogicOperator = $acw62.useCallback((event)=>{
        const logicOperator = event.target.value === (0, $4993f96105ede556$export$90be184ccbab1c7a).And.toString() ? (0, $4993f96105ede556$export$90be184ccbab1c7a).And : (0, $4993f96105ede556$export$90be184ccbab1c7a).Or;
        applyMultiFilterOperatorChanges(logicOperator);
    }, [
        applyMultiFilterOperatorChanges
    ]);
    const handleDeleteFilter = ()=>{
        deleteFilter(item);
    };
    $acw62.useImperativeHandle(focusElementRef, ()=>({
            focus: ()=>{
                if (currentOperator?.InputComponent) valueRef?.current?.focus();
                else filterSelectorRef.current.focus();
            }
        }), [
        currentOperator
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($7fcbeccc9211499d$var$GridFilterFormRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classes.root,
        "data-id": item.id,
        ownerState: rootProps
    }, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7fcbeccc9211499d$var$FilterFormDeleteIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, deleteIconProps, {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.deleteIcon, deleteIconProps.className),
                ownerState: rootProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    "aria-label": apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    title: apiRef.current.getLocaleText('filterPanelDeleteIconLabel'),
                    onClick: handleDeleteFilter,
                    size: "small",
                    disabled: readOnly
                }, rootProps.slotProps?.baseIconButton, {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.filterPanelDeleteIcon, {
                        fontSize: "small"
                    })
                }))
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7fcbeccc9211499d$var$FilterFormLogicOperatorInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                as: rootProps.slots.baseSelect,
                sx: [
                    hasLogicOperatorColumn ? {
                        display: 'flex'
                    } : {
                        display: 'none'
                    },
                    showMultiFilterOperators ? {
                        visibility: 'visible'
                    } : {
                        visibility: 'hidden'
                    },
                    logicOperatorInputProps.sx
                ],
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.logicOperatorInput, logicOperatorInputProps.className),
                ownerState: rootProps
            }, logicOperatorInputProps, {
                size: "small",
                slotProps: {
                    htmlInput: {
                        'aria-label': apiRef.current.getLocaleText('filterPanelLogicOperator')
                    }
                },
                value: multiFilterOperator ?? '',
                onChange: changeLogicOperator,
                disabled: !!disableMultiFilterOperator || logicOperators.length === 1,
                native: isBaseSelectNative
            }, rootProps.slotProps?.baseSelect, {
                children: logicOperators.map((logicOperator)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: logicOperator.toString(),
                        value: logicOperator.toString()
                    }), apiRef.current.getLocaleText($7fcbeccc9211499d$var$getLogicOperatorLocaleKey(logicOperator))))
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7fcbeccc9211499d$var$FilterFormColumnInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                as: rootProps.slots.baseSelect
            }, columnInputProps, {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.columnInput, columnInputProps.className),
                ownerState: rootProps,
                size: "small",
                labelId: columnSelectLabelId,
                id: columnSelectId,
                label: apiRef.current.getLocaleText('filterPanelColumns'),
                value: selectedField ?? '',
                onChange: changeColumn,
                native: isBaseSelectNative,
                disabled: readOnly
            }, rootProps.slotProps?.baseSelect, {
                children: sortedFilteredColumns.map((col)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: col.field,
                        value: col.field
                    }), $7fcbeccc9211499d$var$getColumnLabel(col)))
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7fcbeccc9211499d$var$FilterFormOperatorInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                as: rootProps.slots.baseSelect,
                size: "small"
            }, operatorInputProps, {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.operatorInput, operatorInputProps.className),
                ownerState: rootProps,
                labelId: operatorSelectLabelId,
                label: apiRef.current.getLocaleText('filterPanelOperator'),
                id: operatorSelectId,
                value: item.operator,
                onChange: changeOperator,
                native: isBaseSelectNative,
                inputRef: filterSelectorRef,
                disabled: readOnly
            }, rootProps.slotProps?.baseSelect, {
                children: currentColumn?.filterOperators?.map((operator)=>/*#__PURE__*/ (0, $acw62.createElement)(rootProps.slots.baseSelectOption, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, baseSelectOptionProps, {
                        native: isBaseSelectNative,
                        key: operator.value,
                        value: operator.value
                    }), operator.label || apiRef.current.getLocaleText(`filterOperator${(0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(operator.value)}`)))
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7fcbeccc9211499d$var$FilterFormValueInput, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, valueInputPropsOther, {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.valueInput, valueInputPropsOther.className),
                ownerState: rootProps,
                children: currentOperator?.InputComponent ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(currentOperator.InputComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    apiRef: apiRef,
                    item: item,
                    applyValue: applyFilterChanges,
                    focusElementRef: valueRef,
                    disabled: readOnly,
                    slotProps: {
                        root: {
                            size: 'small'
                        }
                    }
                }, currentOperator.InputComponentProps, InputComponentProps), item.field) : null
            }))
        ]
    }));
});







'use client';
const $d05dc368815103de$var$_excluded = [
    "logicOperators",
    "columnsSort",
    "filterFormProps",
    "getColumnForNewFilter",
    "children",
    "disableAddFilterButton",
    "disableRemoveAllButton"
];
const $d05dc368815103de$export$7530149911670467 = (col)=>({
        field: col.field,
        operator: col.filterOperators[0].value,
        id: Math.round(Math.random() * 1e5)
    });
const $d05dc368815103de$export$32c6e72be8ad862c = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridFilterPanel(props, ref) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const filterModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$280aedb9454597a5));
    const filterableColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$2cad659ba95fed71));
    const filterableColumnsLookup = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$e84218276cc24419));
    const lastFilterRef = $acw62.useRef(null);
    const placeholderFilter = $acw62.useRef(null);
    const { logicOperators: logicOperators = [
        (0, $4993f96105ede556$export$90be184ccbab1c7a).And,
        (0, $4993f96105ede556$export$90be184ccbab1c7a).Or
    ], columnsSort: columnsSort, filterFormProps: filterFormProps, getColumnForNewFilter: getColumnForNewFilter, disableAddFilterButton: disableAddFilterButton = false, disableRemoveAllButton: disableRemoveAllButton = false } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d05dc368815103de$var$_excluded);
    const applyFilter = apiRef.current.upsertFilterItem;
    const applyFilterLogicOperator = $acw62.useCallback((operator)=>{
        apiRef.current.setFilterLogicOperator(operator);
    }, [
        apiRef
    ]);
    const getDefaultFilter = $acw62.useCallback(()=>{
        let nextColumnWithOperator;
        if (getColumnForNewFilter && typeof getColumnForNewFilter === 'function') {
            // To allow override the column for default (first) filter
            const nextFieldName = getColumnForNewFilter({
                currentFilters: filterModel?.items || [],
                columns: filterableColumns
            });
            if (nextFieldName === null) return null;
            nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextFieldName);
        } else nextColumnWithOperator = filterableColumns.find((colDef)=>colDef.filterOperators?.length);
        if (!nextColumnWithOperator) return null;
        return $d05dc368815103de$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel?.items,
        filterableColumns,
        getColumnForNewFilter
    ]);
    const getNewFilter = $acw62.useCallback(()=>{
        if (getColumnForNewFilter === undefined || typeof getColumnForNewFilter !== 'function') return getDefaultFilter();
        const currentFilters = filterModel.items.length ? filterModel.items : [
            getDefaultFilter()
        ].filter(Boolean);
        // If no items are there in filterModel, we have to pass defaultFilter
        const nextColumnFieldName = getColumnForNewFilter({
            currentFilters: currentFilters,
            columns: filterableColumns
        });
        if (nextColumnFieldName === null) return null;
        const nextColumnWithOperator = filterableColumns.find(({ field: field })=>field === nextColumnFieldName);
        if (!nextColumnWithOperator) return null;
        return $d05dc368815103de$export$7530149911670467(nextColumnWithOperator);
    }, [
        filterModel.items,
        filterableColumns,
        getColumnForNewFilter,
        getDefaultFilter
    ]);
    const items = $acw62.useMemo(()=>{
        if (filterModel.items.length) return filterModel.items;
        if (!placeholderFilter.current) placeholderFilter.current = getDefaultFilter();
        return placeholderFilter.current ? [
            placeholderFilter.current
        ] : [];
    }, [
        filterModel.items,
        getDefaultFilter
    ]);
    const hasMultipleFilters = items.length > 1;
    const { readOnlyFilters: readOnlyFilters, validFilters: validFilters } = $acw62.useMemo(()=>items.reduce((acc, item)=>{
            if (filterableColumnsLookup[item.field]) acc.validFilters.push(item);
            else acc.readOnlyFilters.push(item);
            return acc;
        }, {
            readOnlyFilters: [],
            validFilters: []
        }), [
        items,
        filterableColumnsLookup
    ]);
    const addNewFilter = $acw62.useCallback(()=>{
        const newFilter = getNewFilter();
        if (!newFilter) return;
        apiRef.current.upsertFilterItems([
            ...items,
            newFilter
        ]);
    }, [
        apiRef,
        getNewFilter,
        items
    ]);
    const deleteFilter = $acw62.useCallback((item)=>{
        const shouldCloseFilterPanel = validFilters.length === 1;
        apiRef.current.deleteFilterItem(item);
        if (shouldCloseFilterPanel) apiRef.current.hideFilterPanel();
    }, [
        apiRef,
        validFilters.length
    ]);
    const handleRemoveAll = $acw62.useCallback(()=>{
        if (validFilters.length === 1 && validFilters[0].value === undefined) {
            apiRef.current.deleteFilterItem(validFilters[0]);
            return apiRef.current.hideFilterPanel();
        }
        return apiRef.current.setFilterModel((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, filterModel, {
            items: readOnlyFilters
        }), 'removeAllFilterItems');
    }, [
        apiRef,
        readOnlyFilters,
        filterModel,
        validFilters
    ]);
    $acw62.useEffect(()=>{
        if (logicOperators.length > 0 && filterModel.logicOperator && !logicOperators.includes(filterModel.logicOperator)) applyFilterLogicOperator(logicOperators[0]);
    }, [
        logicOperators,
        applyFilterLogicOperator,
        filterModel.logicOperator
    ]);
    $acw62.useEffect(()=>{
        if (validFilters.length > 0) lastFilterRef.current.focus();
    }, [
        validFilters.length
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $54d6c141b0e5cff8$export$6a36e1ca07bd502c), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $365a149208d904dc$export$1b4102a66373332b), {
                children: [
                    readOnlyFilters.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7fcbeccc9211499d$export$4c95feba7016dbe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: index > 0,
                            disableMultiFilterOperator: index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: null,
                            readOnly: true,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index : item.id)),
                    validFilters.map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7fcbeccc9211499d$export$4c95feba7016dbe7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                            item: item,
                            applyFilterChanges: applyFilter,
                            deleteFilter: deleteFilter,
                            hasMultipleFilters: hasMultipleFilters,
                            showMultiFilterOperators: readOnlyFilters.length + index > 0,
                            disableMultiFilterOperator: readOnlyFilters.length + index !== 1,
                            applyMultiFilterOperatorChanges: applyFilterLogicOperator,
                            focusElementRef: index === validFilters.length - 1 ? lastFilterRef : null,
                            logicOperators: logicOperators,
                            columnsSort: columnsSort
                        }, filterFormProps), item.id == null ? index + readOnlyFilters.length : item.id))
                ]
            }),
            !rootProps.disableMultipleColumnsFiltering && !(disableAddFilterButton && disableRemoveAllButton) ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $116c3809d51a1833$export$18e44097a2744a), {
                children: [
                    !disableAddFilterButton ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        onClick: addNewFilter,
                        startIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.filterPanelAddIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelAddFilter')
                    })) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                    !disableRemoveAllButton && validFilters.length > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        onClick: handleRemoveAll,
                        startIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.filterPanelRemoveAllIcon, {})
                    }, rootProps.slotProps?.baseButton, {
                        children: apiRef.current.getLocaleText('filterPanelRemoveAll')
                    })) : null
                ]
            }) : null
        ]
    }));
});


parcelRequire("acw62");









parcelRequire("acw62");










const $66f9e21b46b0751f$var$_excluded = [
    "className",
    "selectedRowCount"
];
const $66f9e21b46b0751f$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'selectedRowCount'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $66f9e21b46b0751f$var$GridSelectedRowCountRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'SelectedRowCount'
})({
    alignItems: 'center',
    display: 'flex',
    margin: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(0, 2),
    visibility: 'hidden',
    width: 0,
    height: 0,
    [(0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).breakpoints.up('sm')]: {
        visibility: 'visible',
        width: 'auto',
        height: 'auto'
    }
});
const $66f9e21b46b0751f$export$e4c9f87515ca4b49 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridSelectedRowCount(props, ref) {
    const { className: className, selectedRowCount: selectedRowCount } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $66f9e21b46b0751f$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const ownerState = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $66f9e21b46b0751f$var$useUtilityClasses(ownerState);
    const rowSelectedText = apiRef.current.getLocaleText('footerRowSelected')(selectedRowCount);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($66f9e21b46b0751f$var$GridSelectedRowCountRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: rowSelectedText
    }));
});




parcelRequire("acw62");








const $e9f32ab8fc90cf2a$var$_excluded = [
    "className"
];
const $e9f32ab8fc90cf2a$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'footerContainer',
            'withBorderColor'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $e9f32ab8fc90cf2a$var$GridFooterContainerRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'FooterContainer'
})({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    minHeight: 52,
    borderTop: '1px solid'
});
const $e9f32ab8fc90cf2a$export$dc81d5e0847a9805 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridFooterContainer(props, ref) {
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e9f32ab8fc90cf2a$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $e9f32ab8fc90cf2a$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e9f32ab8fc90cf2a$var$GridFooterContainerRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});




const $50ce5ddf6b8d81fc$export$6ef0bfefb022d11e = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridFooter(props, ref) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const totalTopLevelRowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$800ab0a68a9efc4f));
    const selectedRowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $32777ac93d35a3f3$export$408e67b791fe352));
    const visibleTopLevelRowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$f88efd30675963d1));
    const selectedRowCountElement = !rootProps.hideFooterSelectedRowCount && selectedRowCount > 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $66f9e21b46b0751f$export$e4c9f87515ca4b49), {
        selectedRowCount: selectedRowCount
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
    const rowCountElement = !rootProps.hideFooterRowCount && !rootProps.pagination ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.footerRowCount, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.footerRowCount, {
        rowCount: totalTopLevelRowCount,
        visibleRowCount: visibleTopLevelRowCount
    })) : null;
    const paginationElement = rootProps.pagination && !rootProps.hideFooterPagination && rootProps.slots.pagination && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.pagination, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.pagination));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e9f32ab8fc90cf2a$export$dc81d5e0847a9805), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        children: [
            selectedRowCountElement,
            rowCountElement,
            paginationElement
        ]
    }));
});



parcelRequire("acw62");





parcelRequire("acw62");









const $0ceaf4ba20b7dea1$var$_excluded = [
    "className"
];
const $0ceaf4ba20b7dea1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'overlay'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $0ceaf4ba20b7dea1$var$GridOverlayRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Overlay'
})({
    width: '100%',
    height: '100%',
    display: 'flex',
    gap: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(1),
    flexDirection: 'column',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    textWrap: 'balance',
    backgroundColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.background.backdrop
});
const $0ceaf4ba20b7dea1$export$1c41ff9dbe11e487 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridOverlay(props, ref) {
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $0ceaf4ba20b7dea1$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $0ceaf4ba20b7dea1$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0ceaf4ba20b7dea1$var$GridOverlayRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});





var $acw62 = parcelRequire("acw62");













const $f1f6b5b1c24e4f9a$export$29949f0e748b68b8 = (pinnedPosition, computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth)=>{
    let pinnedOffset;
    switch(pinnedPosition){
        case (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT:
            pinnedOffset = columnPositions[columnIndex];
            break;
        case (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT:
            pinnedOffset = columnsTotalWidth - columnPositions[columnIndex] - computedWidth + scrollbarWidth;
            break;
        default:
            pinnedOffset = undefined;
            break;
    }
    // XXX: fix this properly
    if (Number.isNaN(pinnedOffset)) pinnedOffset = undefined;
    return pinnedOffset;
};



const $77c35924535e8cce$export$646c95cff4790794 = (pinnedPosition, indexInSection, sectionLength, showCellVerticalBorderRootProp, gridHasFiller, pinnedColumnsSectionSeparatorRootProp)=>{
    const isSectionLastCell = indexInSection === sectionLength - 1;
    if (pinnedColumnsSectionSeparatorRootProp?.startsWith('border') && pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT && isSectionLastCell) return true;
    if (showCellVerticalBorderRootProp) {
        if (pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT) return true;
        if (pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT) return !isSectionLastCell;
        // pinnedPosition === undefined, middle section
        return !isSectionLastCell || gridHasFiller;
    }
    return false;
};
const $77c35924535e8cce$export$c01fd18a9a3d03b3 = (pinnedPosition, indexInSection, showCellVerticalBorderRootProp, pinnedColumnsSectionSeparatorRootProp)=>{
    if (pinnedColumnsSectionSeparatorRootProp?.startsWith('border')) return pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT && indexInSection === 0;
    return showCellVerticalBorderRootProp && pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT && indexInSection === 0;
};




const $2c096afb328e2fa5$export$5859c8b8d085a0c0 = (position, isRtl)=>{
    if (!position) return undefined;
    if (!isRtl) {
        if (position === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT) return 'left';
        if (position === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT) return 'right';
    } else {
        if (position === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT) return 'right';
        if (position === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT) return 'left';
    }
    return undefined;
};



function $3692da1bdaccd764$export$175ada5333288b48(style, isRtl, pinnedPosition, pinnedOffset) {
    const side = (0, $2c096afb328e2fa5$export$5859c8b8d085a0c0)(pinnedPosition, isRtl);
    if (!side || pinnedOffset === undefined) return style;
    style[side] = pinnedOffset;
    return style;
}



const $8a323e800d5b085b$var$_excluded = [
    "skeletonRowsCount",
    "visibleColumns",
    "showFirstRowBorder"
];
const $8a323e800d5b085b$var$SkeletonOverlay = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'SkeletonLoadingOverlay'
})({
    minWidth: '100%',
    width: 'max-content',
    // prevents overflow: clip; cutting off the x axis
    height: '100%',
    overflow: 'clip' // y axis is hidden while the x axis is allowed to overflow
});
const $8a323e800d5b085b$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'skeletonLoadingOverlay'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $8a323e800d5b085b$var$getColIndex = (el)=>parseInt(el.getAttribute('data-colindex'), 10);
const $8a323e800d5b085b$export$26c65b7f55c83af1 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridSkeletonLoadingOverlayInner(props, forwardedRef) {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { slots: slots } = rootProps;
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const classes = $8a323e800d5b085b$var$useUtilityClasses({
        classes: rootProps.classes
    });
    const ref = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, forwardedRef);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const dimensions = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$26d8768b83a52ffd));
    const totalWidth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$ab20f9d33edc7794));
    const positions = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$fce7d810e48021e3));
    const inViewportCount = $acw62.useMemo(()=>positions.filter((value)=>value <= totalWidth).length, [
        totalWidth,
        positions
    ]);
    const { skeletonRowsCount: skeletonRowsCount, visibleColumns: visibleColumns, showFirstRowBorder: showFirstRowBorder } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $8a323e800d5b085b$var$_excluded);
    const allVisibleColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$16a65a9447d3dda9));
    const columns = $acw62.useMemo(()=>allVisibleColumns.slice(0, inViewportCount), [
        allVisibleColumns,
        inViewportCount
    ]);
    const pinnedColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$297e8079713afa11));
    const getPinnedPosition = $acw62.useCallback((field)=>{
        if (pinnedColumns.left.findIndex((col)=>col.field === field) !== -1) return (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT;
        if (pinnedColumns.right.findIndex((col)=>col.field === field) !== -1) return (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT;
        return undefined;
    }, [
        pinnedColumns.left,
        pinnedColumns.right
    ]);
    const children = $acw62.useMemo(()=>{
        const array = [];
        for(let i = 0; i < skeletonRowsCount; i += 1){
            const rowCells = [];
            for(let colIndex = 0; colIndex < columns.length; colIndex += 1){
                const column = columns[colIndex];
                const pinnedPosition = getPinnedPosition(column.field);
                const isPinnedLeft = pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT;
                const isPinnedRight = pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT;
                const pinnedSide = (0, $2c096afb328e2fa5$export$5859c8b8d085a0c0)(pinnedPosition, isRtl);
                const sectionLength = pinnedSide ? pinnedColumns[pinnedSide].length // pinned section
                 : columns.length - pinnedColumns.left.length - pinnedColumns.right.length; // middle section
                const sectionIndex = pinnedSide ? pinnedColumns[pinnedSide].findIndex((col)=>col.field === column.field) // pinned section
                 : colIndex - pinnedColumns.left.length; // middle section
                const scrollbarWidth = dimensions.hasScrollY ? dimensions.scrollbarSize : 0;
                const pinnedStyle = (0, $3692da1bdaccd764$export$175ada5333288b48)({}, isRtl, pinnedPosition, (0, $f1f6b5b1c24e4f9a$export$29949f0e748b68b8)(pinnedPosition, column.computedWidth, colIndex, positions, dimensions.columnsTotalWidth, scrollbarWidth));
                const gridHasFiller = dimensions.columnsTotalWidth < dimensions.viewportOuterSize.width;
                const showRightBorder = (0, $77c35924535e8cce$export$646c95cff4790794)(pinnedPosition, sectionIndex, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
                const showLeftBorder = (0, $77c35924535e8cce$export$c01fd18a9a3d03b3)(pinnedPosition, sectionIndex, rootProps.showCellVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
                const isLastColumn = colIndex === columns.length - 1;
                const isFirstPinnedRight = isPinnedRight && sectionIndex === 0;
                const hasFillerBefore = isFirstPinnedRight && gridHasFiller;
                const hasFillerAfter = isLastColumn && !isFirstPinnedRight && gridHasFiller;
                const expandedWidth = dimensions.viewportOuterSize.width - dimensions.columnsTotalWidth;
                const emptyCellWidth = Math.max(0, expandedWidth);
                const emptyCell = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(slots.skeletonCell, {
                    width: emptyCellWidth,
                    empty: true
                }, `skeleton-filler-column-${i}`);
                if (hasFillerBefore) rowCells.push(emptyCell);
                rowCells.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(slots.skeletonCell, {
                    field: column.field,
                    type: column.type,
                    align: column.align,
                    width: "var(--width)",
                    height: dimensions.rowHeight,
                    "data-colindex": colIndex,
                    empty: visibleColumns && !visibleColumns.has(column.field),
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(isPinnedLeft && (0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedLeft'], isPinnedRight && (0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedRight'], showRightBorder && (0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--withRightBorder'], showLeftBorder && (0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--withLeftBorder']),
                    style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                        '--width': `${column.computedWidth}px`
                    }, pinnedStyle)
                }, `skeleton-column-${i}-${column.field}`));
                if (hasFillerAfter) rowCells.push(emptyCell);
            }
            array.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $59e5f6b0ce3da023$export$2100d54e36406477).row, (0, $59e5f6b0ce3da023$export$2100d54e36406477).rowSkeleton, i === 0 && !showFirstRowBorder && (0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--firstVisible']),
                children: rowCells
            }, `skeleton-row-${i}`));
        }
        return array;
    }, [
        skeletonRowsCount,
        columns,
        getPinnedPosition,
        isRtl,
        pinnedColumns,
        dimensions.hasScrollY,
        dimensions.scrollbarSize,
        dimensions.columnsTotalWidth,
        dimensions.viewportOuterSize.width,
        dimensions.rowHeight,
        positions,
        rootProps.showCellVerticalBorder,
        rootProps.pinnedColumnsSectionSeparator,
        slots,
        visibleColumns,
        showFirstRowBorder
    ]);
    // Sync the column resize of the overlay columns with the grid
    const handleColumnResize = (params)=>{
        const { colDef: colDef, width: width } = params;
        const cells = ref.current?.querySelectorAll(`[data-field="${(0, $b2637ba08a26ef7b$export$77eab2954df72e62)(colDef.field)}"]`);
        if (!cells) throw new Error('MUI X: Expected skeleton cells to be defined with `data-field` attribute.');
        const resizedColIndex = columns.findIndex((col)=>col.field === colDef.field);
        const pinnedPosition = getPinnedPosition(colDef.field);
        const isPinnedLeft = pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT;
        const isPinnedRight = pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT;
        const currentWidth = getComputedStyle(cells[0]).getPropertyValue('--width');
        const delta = parseInt(currentWidth, 10) - width;
        if (cells) cells.forEach((element)=>{
            element.style.setProperty('--width', `${width}px`);
        });
        if (isPinnedLeft) {
            const pinnedCells = ref.current?.querySelectorAll(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedLeft']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $8a323e800d5b085b$var$getColIndex(element);
                if (colIndex > resizedColIndex) element.style.left = `${parseInt(getComputedStyle(element).left, 10) - delta}px`;
            });
        }
        if (isPinnedRight) {
            const pinnedCells = ref.current?.querySelectorAll(`.${(0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--pinnedRight']}`);
            pinnedCells?.forEach((element)=>{
                const colIndex = $8a323e800d5b085b$var$getColIndex(element);
                if (colIndex < resizedColIndex) element.style.right = `${parseInt(getComputedStyle(element).right, 10) + delta}px`;
            });
        }
    };
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnResize', handleColumnResize);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8a323e800d5b085b$var$SkeletonOverlay, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classes.root
    }, other, {
        ref: handleRef,
        children: children
    }));
});
const $8a323e800d5b085b$export$123bd4ede2d9ef98 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridSkeletonLoadingOverlay(props, forwardedRef) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const dimensions = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$26d8768b83a52ffd));
    const viewportHeight = dimensions?.viewportInnerSize.height ?? 0;
    const skeletonRowsCount = Math.ceil(viewportHeight / dimensions.rowHeight);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($8a323e800d5b085b$export$26c65b7f55c83af1, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        skeletonRowsCount: skeletonRowsCount,
        ref: forwardedRef
    }));
});





const $926382940e04f0b4$var$_excluded = [
    "variant",
    "noRowsVariant",
    "style"
];
const $926382940e04f0b4$var$LOADING_VARIANTS = {
    'circular-progress': {
        component: (rootProps)=>rootProps.slots.baseCircularProgress,
        style: {}
    },
    'linear-progress': {
        component: (rootProps)=>rootProps.slots.baseLinearProgress,
        style: {
            display: 'block'
        }
    },
    skeleton: {
        component: ()=>(0, $8a323e800d5b085b$export$123bd4ede2d9ef98),
        style: {
            display: 'block'
        }
    }
};
const $926382940e04f0b4$export$69e47a4ea5ffa191 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridLoadingOverlay(props, ref) {
    const { variant: variant = 'linear-progress', noRowsVariant: noRowsVariant = 'skeleton', style: style } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $926382940e04f0b4$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const rowsCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4fc0d4cb0e570e63$export$1641ef9d08e265ca));
    const activeVariant = $926382940e04f0b4$var$LOADING_VARIANTS[rowsCount === 0 ? noRowsVariant : variant];
    const Component = activeVariant.component(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ceaf4ba20b7dea1$export$1c41ff9dbe11e487), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, activeVariant.style, style)
    }, other, {
        ref: ref,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, {})
    }));
});


parcelRequire("acw62");








const $a13f3a6d66c545df$export$e65b720c06138814 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridNoColumnsOverlay(props, ref) {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const columns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$d8a3dfbb129c80db));
    const handleOpenManageColumns = ()=>{
        apiRef.current.showPreferences((0, $e38c9af0748d9173$export$e7e5652452e44b).columns);
    };
    const showManageColumnsButton = !rootProps.disableColumnSelector && columns.length > 0;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $0ceaf4ba20b7dea1$export$1c41ff9dbe11e487), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        children: [
            apiRef.current.getLocaleText('noColumnsOverlayLabel'),
            showManageColumnsButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                size: "small"
            }, rootProps.slotProps?.baseButton, {
                onClick: handleOpenManageColumns,
                children: apiRef.current.getLocaleText('noColumnsOverlayManageColumns')
            }))
        ]
    }));
});


parcelRequire("acw62");





const $f0f13edf3ed2bd2a$export$a25f04494ce53510 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridNoRowsOverlay(props, ref) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const noRowsLabel = apiRef.current.getLocaleText('noRowsLabel');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ceaf4ba20b7dea1$export$1c41ff9dbe11e487), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        children: noRowsLabel
    }));
});



var $acw62 = parcelRequire("acw62");








const $464632ac69454085$var$GridPaginationRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d))({
    maxHeight: 'calc(100% + 1px)',
    // border width
    flexGrow: 1
});
function $464632ac69454085$export$fa9a503101f8d472() {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const paginationModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$ccc9f04e59d0d8e6));
    const rowCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$946e4ae85da77ef6));
    const pageCount = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $e164e26c82788fb1$export$b81026f1aaf843a4));
    const { paginationMode: paginationMode, loading: loading } = rootProps;
    const disabled = rowCount === -1 && paginationMode === 'server' && loading;
    const lastPage = $acw62.useMemo(()=>Math.max(0, pageCount - 1), [
        pageCount
    ]);
    const computedPage = $acw62.useMemo(()=>{
        if (rowCount === -1) return paginationModel.page;
        return paginationModel.page <= lastPage ? paginationModel.page : lastPage;
    }, [
        lastPage,
        paginationModel.page,
        rowCount
    ]);
    const handlePageSizeChange = $acw62.useCallback((pageSize)=>{
        apiRef.current.setPageSize(pageSize);
    }, [
        apiRef
    ]);
    const handlePageChange = $acw62.useCallback((_, page)=>{
        apiRef.current.setPage(page);
    }, [
        apiRef
    ]);
    const isPageSizeIncludedInPageSizeOptions = (pageSize)=>{
        for(let i = 0; i < rootProps.pageSizeOptions.length; i += 1){
            const option = rootProps.pageSizeOptions[i];
            if (typeof option === 'number') {
                if (option === pageSize) return true;
            } else if (option.value === pageSize) return true;
        }
        return false;
    };
    const pageSizeOptions = isPageSizeIncludedInPageSizeOptions(paginationModel.pageSize) ? rootProps.pageSizeOptions : [];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($464632ac69454085$var$GridPaginationRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        as: rootProps.slots.basePagination,
        count: rowCount,
        page: computedPage,
        rowsPerPageOptions: pageSizeOptions,
        rowsPerPage: paginationModel.pageSize,
        onPageChange: handlePageChange,
        onRowsPerPageChange: handlePageSizeChange,
        disabled: disabled
    }, rootProps.slotProps?.basePagination));
}




var $acw62 = parcelRequire("acw62");












'use client';
const $266faff44edb200b$var$_excluded = [
    "children",
    "className",
    "classes",
    "onClose"
];
const $266faff44edb200b$export$e95ad8c1c287de86 = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDataGrid', [
    'panel',
    'paper'
]);
const $266faff44edb200b$var$GridPanelRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d), {
    name: 'MuiDataGrid',
    slot: 'panel'
})({
    zIndex: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).zIndex.panel
});
const $266faff44edb200b$var$GridPanelContent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'panelContent'
})({
    backgroundColor: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.background.overlay,
    borderRadius: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).radius.base,
    boxShadow: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).shadows.overlay,
    display: 'flex',
    maxWidth: `calc(100vw - ${(0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(2)})`,
    overflow: 'auto'
});
const $266faff44edb200b$export$cf917897ad2588b = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)((props, ref)=>{
    const { children: children, className: className, onClose: onClose } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $266faff44edb200b$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $266faff44edb200b$export$e95ad8c1c287de86;
    const [isPlaced, setIsPlaced] = $acw62.useState(false);
    const variablesClass = (0, $cadacf9afeddf573$export$bce43ff91e115a9b)();
    const onDidShow = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>setIsPlaced(true));
    const onDidHide = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>setIsPlaced(false));
    const handleClickAway = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)(()=>{
        onClose?.();
    });
    const handleKeyDown = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (event.key === 'Escape') onClose?.();
    });
    const [fallbackTarget, setFallbackTarget] = $acw62.useState(null);
    $acw62.useEffect(()=>{
        const panelAnchor = apiRef.current.rootElementRef?.current?.querySelector('[data-id="gridPanelAnchor"]');
        if (panelAnchor) setFallbackTarget(panelAnchor);
    }, [
        apiRef
    ]);
    if (!fallbackTarget) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($266faff44edb200b$var$GridPanelRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        as: rootProps.slots.basePopper,
        ownerState: rootProps,
        placement: "bottom-end",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.panel, className, variablesClass),
        flip: true,
        onDidShow: onDidShow,
        onDidHide: onDidHide,
        onClickAway: handleClickAway,
        clickAwayMouseEvent: "onPointerUp",
        clickAwayTouchEvent: false,
        focusTrap: true
    }, other, rootProps.slotProps?.basePopper, {
        target: props.target ?? fallbackTarget,
        ref: ref,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($266faff44edb200b$var$GridPanelContent, {
            className: classes.paper,
            ownerState: rootProps,
            onKeyDown: handleKeyDown,
            children: isPlaced && children
        })
    }));
});




var $acw62 = parcelRequire("acw62");










function $ddab142a3d4cf0b4$export$4631f4813a5310ce(classes, slots) {
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
}















const $6706944b42b4dbe5$export$854c5e46cd7a67b3 = (0, $24e415a76b2eb9fb$export$a62918fde9b59371)((state)=>state.rowReorder);
const $6706944b42b4dbe5$export$9fd0536b8ff8739 = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)($6706944b42b4dbe5$export$854c5e46cd7a67b3, (rowReorder)=>rowReorder?.isActive ?? false);







'use client';
const $e006f53d53e7fc50$var$_excluded = [
    "selected",
    "rowId",
    "row",
    "index",
    "style",
    "rowHeight",
    "className",
    "visibleColumns",
    "pinnedColumns",
    "offsetLeft",
    "columnsTotalWidth",
    "firstColumnIndex",
    "lastColumnIndex",
    "focusedColumnIndex",
    "isFirstVisible",
    "isLastVisible",
    "isNotVisible",
    "showBottomBorder",
    "scrollbarWidth",
    "gridHasFiller",
    "onClick",
    "onDoubleClick",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseOut",
    "onMouseOver"
];
const $e006f53d53e7fc50$var$isRowReorderingEnabledSelector = (0, $24e415a76b2eb9fb$export$595d22ed68ca2841)((0, $4255bcbc0a0ba839$export$91ed78b95c9e6636), (editRows, { rowReordering: rowReordering, treeData: treeData })=>{
    if (!rowReordering || treeData) return false;
    const isEditingRows = !(0, $4928b2b12bcd438c$export$23cfe696632d10f4)(editRows);
    return !isEditingRows;
});
const $e006f53d53e7fc50$var$GridRow = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridRow(props, refProp) {
    const { selected: selected, rowId: rowId, row: row, index: index, style: styleProp, rowHeight: rowHeight, className: className, visibleColumns: visibleColumns, pinnedColumns: pinnedColumns, offsetLeft: offsetLeft, columnsTotalWidth: columnsTotalWidth, firstColumnIndex: firstColumnIndex, lastColumnIndex: lastColumnIndex, focusedColumnIndex: focusedColumnIndex, isFirstVisible: isFirstVisible, isLastVisible: isLastVisible, isNotVisible: isNotVisible, showBottomBorder: showBottomBorder, scrollbarWidth: scrollbarWidth, gridHasFiller: gridHasFiller, onClick: onClick, onDoubleClick: onDoubleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onMouseOut: onMouseOut, onMouseOver: onMouseOver } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $e006f53d53e7fc50$var$_excluded);
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const configuration = (0, $c6f13e845e117797$export$9fe1679701f06bb7)();
    const ref = $acw62.useRef(null);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const currentPage = (0, $2b6a1e01125c3822$export$d1914c80ff11e37a)(apiRef, rootProps);
    const sortModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9));
    const columnPositions = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$fce7d810e48021e3));
    const rowReordering = rootProps.rowReordering;
    const treeData = rootProps.treeData;
    const isRowReorderingEnabled = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, $e006f53d53e7fc50$var$isRowReorderingEnabledSelector, {
        rowReordering: rowReordering,
        treeData: treeData
    });
    const isRowDragActive = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $6706944b42b4dbe5$export$9fd0536b8ff8739));
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, refProp);
    const rowNode = (0, $4fc0d4cb0e570e63$export$895b25a1c5f3cc22)(apiRef, rowId);
    const editing = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4255bcbc0a0ba839$export$3ca6aabd7600f0b3), {
        rowId: rowId,
        editMode: rootProps.editMode
    });
    const editable = rootProps.editMode === (0, $181c044302967209$export$bad6b7a934346f26).Row;
    const hasFocusCell = focusedColumnIndex !== undefined;
    const hasVirtualFocusCellLeft = hasFocusCell && focusedColumnIndex >= pinnedColumns.left.length && focusedColumnIndex < firstColumnIndex;
    const hasVirtualFocusCellRight = hasFocusCell && focusedColumnIndex < visibleColumns.length - pinnedColumns.right.length && focusedColumnIndex >= lastColumnIndex;
    const classes = (0, $ddab142a3d4cf0b4$export$4631f4813a5310ce)(rootProps.classes, {
        root: [
            'row',
            selected && 'selected',
            editable && 'row--editable',
            editing && 'row--editing',
            isFirstVisible && 'row--firstVisible',
            isLastVisible && 'row--lastVisible',
            showBottomBorder && 'row--borderBottom',
            rowHeight === 'auto' && 'row--dynamicHeight'
        ]
    });
    const getRowAriaAttributes = configuration.hooks.useGridRowAriaAttributes();
    $acw62.useLayoutEffect(()=>{
        if (currentPage.range) {
            const rowIndex = apiRef.current.getRowIndexRelativeToVisibleRows(rowId);
            // Pinned rows are not part of the visible rows
            if (rowIndex !== undefined) apiRef.current.unstable_setLastMeasuredRowIndex(rowIndex);
        }
        if (ref.current && rowHeight === 'auto') return apiRef.current.observeRowHeight(ref.current, rowId);
        return undefined;
    }, [
        apiRef,
        currentPage.range,
        rowHeight,
        rowId
    ]);
    const publish = $acw62.useCallback((eventName, propHandler)=>(event)=>{
            // Ignore portal
            if ((0, $b2637ba08a26ef7b$export$8ce496ad3bfbe3a6)(event)) return;
            // The row might have been deleted
            if (!apiRef.current.getRow(rowId)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getRowParams(rowId), event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        rowId
    ]);
    const publishClick = $acw62.useCallback((event)=>{
        const cell = (0, $b2637ba08a26ef7b$export$2a63f1401414fc1a)(event.target, (0, $59e5f6b0ce3da023$export$2100d54e36406477).cell);
        const field = cell?.getAttribute('data-field');
        // Check if the field is available because the cell that fills the empty
        // space of the row has no field.
        if (field) {
            // User clicked in the checkbox added by checkboxSelection
            if (field === (0, $fa1dc905b3e7910f$export$b2e9ab6103a664ad).field) return;
            // User opened a detail panel
            if (field === (0, $d6d7a429fd810b6e$export$6e5a576305a34719)) return;
            // User reorders a row
            if (field === '__reorder__') return;
            // User is editing a cell
            if (apiRef.current.getCellMode(rowId, field) === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit) return;
            // User clicked a button from the "actions" column type
            const column = apiRef.current.getColumn(field);
            if (column?.type === (0, $09b8609275e30076$export$e2523ab9efeb7465)) return;
        }
        publish('rowClick', onClick)(event);
    }, [
        apiRef,
        onClick,
        publish,
        rowId
    ]);
    const { slots: slots, slotProps: slotProps, disableColumnReorder: disableColumnReorder } = rootProps;
    const heightEntry = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, ()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, apiRef.current.getRowHeightEntry(rowId)), undefined, (0, $ef323e860abde413$export$8da4c691e5695191));
    const style = $acw62.useMemo(()=>{
        if (isNotVisible) return {
            opacity: 0,
            width: 0,
            height: 0
        };
        const rowStyle = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, styleProp, {
            maxHeight: rowHeight === 'auto' ? 'none' : rowHeight,
            // max-height doesn't support "auto"
            minHeight: rowHeight,
            '--height': typeof rowHeight === 'number' ? `${rowHeight}px` : rowHeight
        });
        if (heightEntry.spacingTop) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderTopWidth' : 'marginTop';
            rowStyle[property] = heightEntry.spacingTop;
        }
        if (heightEntry.spacingBottom) {
            const property = rootProps.rowSpacingType === 'border' ? 'borderBottomWidth' : 'marginBottom';
            let propertyValue = rowStyle[property];
            // avoid overriding existing value
            if (typeof propertyValue !== 'number') propertyValue = parseInt(propertyValue || '0', 10);
            propertyValue += heightEntry.spacingBottom;
            rowStyle[property] = propertyValue;
        }
        return rowStyle;
    }, [
        isNotVisible,
        rowHeight,
        styleProp,
        heightEntry,
        rootProps.rowSpacingType
    ]);
    // HACK: Sometimes, the rowNode has already been removed from the state but the row is still rendered.
    if (!rowNode) return null;
    const rowClassNames = apiRef.current.unstable_applyPipeProcessors('rowClassName', [], rowId);
    const ariaAttributes = getRowAriaAttributes(rowNode, index);
    if (typeof rootProps.getRowClassName === 'function') {
        const indexRelativeToCurrentPage = index - (currentPage.range?.firstRowIndex || 0);
        const rowParams = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, apiRef.current.getRowParams(rowId), {
            isFirstVisible: indexRelativeToCurrentPage === 0,
            isLastVisible: indexRelativeToCurrentPage === currentPage.rows.length - 1,
            indexRelativeToCurrentPage: indexRelativeToCurrentPage
        });
        rowClassNames.push(rootProps.getRowClassName(rowParams));
    }
    const getCell = (column, indexInSection, indexRelativeToAllColumns, sectionLength, pinnedPosition = (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).NONE)=>{
        const cellColSpanInfo = apiRef.current.unstable_getCellColSpanInfo(rowId, indexRelativeToAllColumns);
        if (cellColSpanInfo?.spannedByColSpan) return null;
        const width = cellColSpanInfo?.cellProps.width ?? column.computedWidth;
        const colSpan = cellColSpanInfo?.cellProps.colSpan ?? 1;
        const pinnedOffset = (0, $f1f6b5b1c24e4f9a$export$29949f0e748b68b8)(pinnedPosition, column.computedWidth, indexRelativeToAllColumns, columnPositions, columnsTotalWidth, scrollbarWidth);
        if (rowNode.type === 'skeletonRow') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(slots.skeletonCell, {
            type: column.type,
            width: width,
            height: rowHeight,
            field: column.field,
            align: column.align
        }, column.field);
        // when the cell is a reorder cell we are not allowing to reorder the col
        // fixes https://github.com/mui/mui-x/issues/11126
        const isReorderCell = column.field === '__reorder__';
        const canReorderColumn = !(disableColumnReorder || column.disableReorder);
        const canReorderRow = isRowReorderingEnabled && !sortModel.length;
        const disableDragEvents = !(canReorderColumn || isReorderCell && canReorderRow || isRowDragActive);
        const cellIsNotVisible = pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).VIRTUAL;
        const showLeftBorder = (0, $77c35924535e8cce$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection, rootProps.showCellVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
        const showRightBorder = (0, $77c35924535e8cce$export$646c95cff4790794)(pinnedPosition, indexInSection, sectionLength, rootProps.showCellVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(slots.cell, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            column: column,
            width: width,
            rowId: rowId,
            align: column.align || 'left',
            colIndex: indexRelativeToAllColumns,
            colSpan: colSpan,
            disableDragEvents: disableDragEvents,
            isNotVisible: cellIsNotVisible,
            pinnedOffset: pinnedOffset,
            pinnedPosition: pinnedPosition,
            showLeftBorder: showLeftBorder,
            showRightBorder: showRightBorder,
            row: row,
            rowNode: rowNode
        }, slotProps?.cell), column.field);
    };
    const leftCells = pinnedColumns.left.map((column, i)=>{
        const indexRelativeToAllColumns = i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.left.length, (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT);
    });
    const rightCells = pinnedColumns.right.map((column, i)=>{
        const indexRelativeToAllColumns = visibleColumns.length - pinnedColumns.right.length + i;
        return getCell(column, i, indexRelativeToAllColumns, pinnedColumns.right.length, (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT);
    });
    const middleColumnsLength = visibleColumns.length - pinnedColumns.left.length - pinnedColumns.right.length;
    const cells = [];
    if (hasVirtualFocusCellLeft) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).VIRTUAL));
    for(let i = firstColumnIndex; i < lastColumnIndex; i += 1){
        const column = visibleColumns[i];
        const indexInSection = i - pinnedColumns.left.length;
        if (!column) continue;
        cells.push(getCell(column, indexInSection, i, middleColumnsLength));
    }
    if (hasVirtualFocusCellRight) cells.push(getCell(visibleColumns[focusedColumnIndex], focusedColumnIndex - pinnedColumns.left.length, focusedColumnIndex, middleColumnsLength, (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).VIRTUAL));
    const eventHandlers = row ? {
        onClick: publishClick,
        onDoubleClick: publish('rowDoubleClick', onDoubleClick),
        onMouseEnter: publish('rowMouseEnter', onMouseEnter),
        onMouseLeave: publish('rowMouseLeave', onMouseLeave),
        onMouseOut: publish('rowMouseOut', onMouseOut),
        onMouseOver: publish('rowMouseOver', onMouseOver)
    } : null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-id": rowId,
        "data-rowindex": index,
        role: "row",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(...rowClassNames, classes.root, className),
        style: style
    }, ariaAttributes, eventHandlers, other, {
        ref: handleRef,
        children: [
            leftCells,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "presentation",
                className: (0, $59e5f6b0ce3da023$export$2100d54e36406477).cellOffsetLeft,
                style: {
                    width: offsetLeft
                }
            }),
            cells,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                role: "presentation",
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $59e5f6b0ce3da023$export$2100d54e36406477).cell, (0, $59e5f6b0ce3da023$export$2100d54e36406477).cellEmpty)
            }),
            rightCells
        ]
    }));
});
const $e006f53d53e7fc50$export$1fc5a7f035870658 = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($e006f53d53e7fc50$var$GridRow);



parcelRequire("acw62");










const $a1695791b9b8bbfd$var$_excluded = [
    "className",
    "rowCount",
    "visibleRowCount"
];
const $a1695791b9b8bbfd$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'rowCount'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $a1695791b9b8bbfd$var$GridRowCountRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'RowCount'
})({
    alignItems: 'center',
    display: 'flex',
    margin: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(0, 2)
});
const $a1695791b9b8bbfd$export$b92875c9af3e0a77 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridRowCount(props, ref) {
    const { className: className, rowCount: rowCount, visibleRowCount: visibleRowCount } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a1695791b9b8bbfd$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const ownerState = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $a1695791b9b8bbfd$var$useUtilityClasses(ownerState);
    if (rowCount === 0) return null;
    const text = visibleRowCount < rowCount ? apiRef.current.getLocaleText('footerTotalVisibleRows')(visibleRowCount, rowCount) : rowCount.toLocaleString();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($a1695791b9b8bbfd$var$GridRowCountRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState
    }, other, {
        ref: ref,
        children: [
            apiRef.current.getLocaleText('footerTotalRows'),
            " ",
            text
        ]
    }));
});




var $acw62 = parcelRequire("acw62");









const $7dd4f51b3a81ca3c$var$_excluded = [
    "field",
    "type",
    "align",
    "width",
    "height",
    "empty",
    "style",
    "className"
];
const $7dd4f51b3a81ca3c$var$CIRCULAR_CONTENT_SIZE = '1.3em';
const $7dd4f51b3a81ca3c$var$CONTENT_HEIGHT = '1.2em';
const $7dd4f51b3a81ca3c$var$DEFAULT_CONTENT_WIDTH_RANGE = [
    40,
    80
];
const $7dd4f51b3a81ca3c$var$CONTENT_WIDTH_RANGE_BY_TYPE = {
    number: [
        40,
        60
    ],
    string: [
        40,
        80
    ],
    date: [
        40,
        60
    ],
    dateTime: [
        60,
        80
    ],
    singleSelect: [
        40,
        80
    ]
};
const $7dd4f51b3a81ca3c$var$useUtilityClasses = (ownerState)=>{
    const { align: align, classes: classes, empty: empty } = ownerState;
    const slots = {
        root: [
            'cell',
            'cellSkeleton',
            `cell--text${align ? (0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(align) : 'Left'}`,
            empty && 'cellEmpty'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $7dd4f51b3a81ca3c$var$randomNumberGenerator = (0, $07a64ebfd26f4296$export$90ad2d37c2cc187e)(12345);
function $7dd4f51b3a81ca3c$var$GridSkeletonCell(props) {
    const { field: field, type: type, align: align, width: width, height: height, empty: empty = false, style: style, className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $7dd4f51b3a81ca3c$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes,
        align: align,
        empty: empty
    };
    const classes = $7dd4f51b3a81ca3c$var$useUtilityClasses(ownerState);
    // Memo prevents the non-circular skeleton widths changing to random widths on every render
    const skeletonProps = $acw62.useMemo(()=>{
        const isCircularContent = type === 'boolean' || type === 'actions';
        if (isCircularContent) return {
            variant: 'circular',
            width: $7dd4f51b3a81ca3c$var$CIRCULAR_CONTENT_SIZE,
            height: $7dd4f51b3a81ca3c$var$CIRCULAR_CONTENT_SIZE
        };
        // The width of the skeleton is a random number between the min and max values
        // The min and max values are determined by the type of the column
        const [min, max] = type ? $7dd4f51b3a81ca3c$var$CONTENT_WIDTH_RANGE_BY_TYPE[type] ?? $7dd4f51b3a81ca3c$var$DEFAULT_CONTENT_WIDTH_RANGE : $7dd4f51b3a81ca3c$var$DEFAULT_CONTENT_WIDTH_RANGE;
        return {
            variant: 'text',
            width: `${Math.round($7dd4f51b3a81ca3c$var$randomNumberGenerator(min, max))}%`,
            height: $7dd4f51b3a81ca3c$var$CONTENT_HEIGHT
        };
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        "data-field": field,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            height: height,
            maxWidth: width,
            minWidth: width
        }, style)
    }, other, {
        children: !empty && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseSkeleton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, skeletonProps))
    }));
}
const $7dd4f51b3a81ca3c$export$d922c88d466d9c21 = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($7dd4f51b3a81ca3c$var$GridSkeletonCell);





var $acw62 = parcelRequire("acw62");











// Based on https://stackoverflow.com/a/59518678
let $3cc4d0090b3d135c$var$cachedSupportsPreventScroll;
function $3cc4d0090b3d135c$export$ed1f8daf96fc68fb() {
    if ($3cc4d0090b3d135c$var$cachedSupportsPreventScroll === undefined) document.createElement('div').focus({
        get preventScroll () {
            $3cc4d0090b3d135c$var$cachedSupportsPreventScroll = true;
            return false;
        }
    });
    return $3cc4d0090b3d135c$var$cachedSupportsPreventScroll;
}














'use client';
const $a95a85cb097c106e$var$_excluded = [
    "column",
    "row",
    "rowId",
    "rowNode",
    "align",
    "children",
    "colIndex",
    "width",
    "className",
    "style",
    "colSpan",
    "disableDragEvents",
    "isNotVisible",
    "pinnedOffset",
    "pinnedPosition",
    "showRightBorder",
    "showLeftBorder",
    "onClick",
    "onDoubleClick",
    "onMouseDown",
    "onMouseUp",
    "onMouseOver",
    "onKeyDown",
    "onKeyUp",
    "onDragEnter",
    "onDragOver"
], $a95a85cb097c106e$var$_excluded2 = [
    "changeReason",
    "unstable_updateValueOnRender"
];
const $a95a85cb097c106e$export$e4b557c91de463d4 = {
    [(0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT]: (0, $c660c9275391bc0a$export$64f54b460f67389c).LEFT,
    [(0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT]: (0, $c660c9275391bc0a$export$64f54b460f67389c).RIGHT,
    [(0, $d6d7a429fd810b6e$export$f35946017bbd5a24).NONE]: undefined,
    [(0, $d6d7a429fd810b6e$export$f35946017bbd5a24).VIRTUAL]: undefined
};
const $a95a85cb097c106e$var$useUtilityClasses = (ownerState)=>{
    const { align: align, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, isEditable: isEditable, isSelected: isSelected, isSelectionMode: isSelectionMode, classes: classes } = ownerState;
    const slots = {
        root: [
            'cell',
            `cell--text${(0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(align)}`,
            isSelected && 'selected',
            isEditable && 'cell--editable',
            showLeftBorder && 'cell--withLeftBorder',
            showRightBorder && 'cell--withRightBorder',
            pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT && 'cell--pinnedLeft',
            pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT && 'cell--pinnedRight',
            isSelectionMode && !isEditable && 'cell--selectionMode'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
let $a95a85cb097c106e$var$warnedOnce = false;
// TODO(v7): Removing the wrapper will break the docs performance visualization demo.
const $a95a85cb097c106e$var$GridCell = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridCell(props, ref) {
    const { column: column, row: row, rowId: rowId, rowNode: rowNode, align: align, colIndex: colIndex, width: width, className: className, style: styleProp, colSpan: colSpan, disableDragEvents: disableDragEvents, isNotVisible: isNotVisible, pinnedOffset: pinnedOffset, pinnedPosition: pinnedPosition, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, onClick: onClick, onDoubleClick: onDoubleClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseOver: onMouseOver, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onDragEnter: onDragEnter, onDragOver: onDragOver } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a95a85cb097c106e$var$_excluded);
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const field = column.field;
    const editCellState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $4255bcbc0a0ba839$export$e6f93ce5e9b42cd9), {
        rowId: rowId,
        field: field
    });
    const config = (0, $c6f13e845e117797$export$9fe1679701f06bb7)();
    const cellAggregationResult = config.hooks.useCellAggregationResult(rowId, field);
    const cellMode = editCellState ? (0, $181c044302967209$export$84e4fdd8f295ca31).Edit : (0, $181c044302967209$export$84e4fdd8f295ca31).View;
    const { value: forcedValue, formattedValue: forcedFormattedValue } = cellAggregationResult || {};
    const cellParams = apiRef.current.getCellParamsForRow(rowId, field, row, {
        colDef: column,
        cellMode: cellMode,
        rowNode: rowNode,
        tabIndex: (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, ()=>{
            const cellTabIndex = (0, $578d1f15adc16cb4$export$2c47652a1f657d56)(apiRef);
            return cellTabIndex && cellTabIndex.field === field && cellTabIndex.id === rowId ? 0 : -1;
        }),
        hasFocus: (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, ()=>{
            const focus = (0, $578d1f15adc16cb4$export$74af8aada6269d3)(apiRef);
            return focus?.id === rowId && focus.field === field;
        }),
        value: forcedValue,
        formattedValue: forcedFormattedValue
    });
    cellParams.api = apiRef.current;
    cellParams.isEditable = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.isCellEditable(cellParams));
    const isSelected = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('isCellSelected', false, {
            id: rowId,
            field: field
        }));
    const store = apiRef.current.virtualizer.store;
    const hiddenCells = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, (0, $4c1c3a63996032a6$export$a282c9f2bcea1074).selectors.hiddenCells);
    const spannedCells = (0, $f49e45cf623984ce$export$6ccbb43953eebf8)(store, (0, $4c1c3a63996032a6$export$a282c9f2bcea1074).selectors.spannedCells);
    const { hasFocus: hasFocus, isEditable: isEditable = false, value: value } = cellParams;
    const canManageOwnFocus = column.type === 'actions' && 'getActions' in column && typeof column.getActions === 'function' && column.getActions(apiRef.current.getRowParams(rowId)).some((action)=>!action.props.disabled);
    const tabIndex = (cellMode === 'view' || !isEditable) && !canManageOwnFocus ? cellParams.tabIndex : -1;
    const { classes: rootClasses, getCellClassName: getCellClassName } = rootProps;
    // There is a hidden grid state access in `applyPipeProcessor('cellClassName', ...)`
    const pipesClassName = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, ()=>apiRef.current.unstable_applyPipeProcessors('cellClassName', [], {
            id: rowId,
            field: field
        }).filter(Boolean).join(' '));
    const classNames = [
        pipesClassName
    ];
    if (column.cellClassName) classNames.push(typeof column.cellClassName === 'function' ? column.cellClassName(cellParams) : column.cellClassName);
    if (column.display === 'flex') classNames.push((0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--flex']);
    if (getCellClassName) classNames.push(getCellClassName(cellParams));
    const valueToRender = cellParams.formattedValue ?? value;
    const cellRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, cellRef);
    const focusElementRef = $acw62.useRef(null);
    const isSelectionMode = rootProps.cellSelection ?? false;
    const ownerState = {
        align: align,
        showLeftBorder: showLeftBorder,
        showRightBorder: showRightBorder,
        isEditable: isEditable,
        classes: rootProps.classes,
        pinnedPosition: pinnedPosition,
        isSelected: isSelected,
        isSelectionMode: isSelectionMode
    };
    const classes = $a95a85cb097c106e$var$useUtilityClasses(ownerState);
    const publishMouseUp = $acw62.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseUp) onMouseUp(event);
        }, [
        apiRef,
        field,
        onMouseUp,
        rowId
    ]);
    const publishMouseDown = $acw62.useCallback((eventName)=>(event)=>{
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (onMouseDown) onMouseDown(event);
        }, [
        apiRef,
        field,
        onMouseDown,
        rowId
    ]);
    const publish = $acw62.useCallback((eventName, propHandler)=>(event)=>{
            // The row might have been deleted during the click
            if (!apiRef.current.getRow(rowId)) return;
            const params = apiRef.current.getCellParams(rowId, field || '');
            apiRef.current.publishEvent(eventName, params, event);
            if (propHandler) propHandler(event);
        }, [
        apiRef,
        field,
        rowId
    ]);
    const isCellRowSpanned = hiddenCells[rowId]?.[colIndex] ?? false;
    const rowSpan = spannedCells[rowId]?.[colIndex] ?? 1;
    const style = $acw62.useMemo(()=>{
        if (isNotVisible) return {
            padding: 0,
            opacity: 0,
            width: 0,
            height: 0,
            border: 0
        };
        const cellStyle = (0, $3692da1bdaccd764$export$175ada5333288b48)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            '--width': `${width}px`
        }, styleProp), isRtl, pinnedPosition, pinnedOffset);
        const isLeftPinned = pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT;
        const isRightPinned = pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT;
        if (rowSpan > 1) {
            cellStyle.height = `calc(var(--height) * ${rowSpan})`;
            cellStyle.zIndex = 10;
            if (isLeftPinned || isRightPinned) cellStyle.zIndex = 40;
        }
        return cellStyle;
    }, [
        width,
        isNotVisible,
        styleProp,
        pinnedOffset,
        pinnedPosition,
        isRtl,
        rowSpan
    ]);
    $acw62.useEffect(()=>{
        if (!hasFocus || cellMode === (0, $181c044302967209$export$84e4fdd8f295ca31).Edit) return;
        const doc = (0, $4c8156a231c9130b$export$2e2bcd8739ae039)(apiRef.current.rootElementRef.current);
        if (cellRef.current && !cellRef.current.contains(doc.activeElement)) {
            const focusableElement = cellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusElementRef.current || focusableElement || cellRef.current;
            if ((0, $3cc4d0090b3d135c$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        hasFocus,
        cellMode,
        apiRef
    ]);
    if (isCellRowSpanned) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        "data-colindex": colIndex,
        role: "presentation",
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            width: 'var(--width)'
        }, style)
    });
    let handleFocus = other.onFocus;
    var event;
    let children;
    let title;
    if (editCellState === null && column.renderCell) children = column.renderCell(cellParams);
    if (editCellState !== null && column.renderEditCell) {
        const updatedRow = apiRef.current.getRowWithUpdatedValues(rowId, column.field);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const editCellStateRest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(editCellState, $a95a85cb097c106e$var$_excluded2);
        const formattedValue = column.valueFormatter ? column.valueFormatter(editCellState.value, updatedRow, column, apiRef) : cellParams.formattedValue;
        const params = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, cellParams, {
            row: updatedRow,
            formattedValue: formattedValue
        }, editCellStateRest);
        children = column.renderEditCell(params);
        classNames.push((0, $59e5f6b0ce3da023$export$2100d54e36406477)['cell--editing']);
        classNames.push(rootClasses?.['cell--editing']);
    }
    if (children === undefined) {
        const valueString = valueToRender?.toString();
        children = valueString;
        title = valueString;
    }
    if (/*#__PURE__*/ $acw62.isValidElement(children) && canManageOwnFocus) children = /*#__PURE__*/ $acw62.cloneElement(children, {
        focusElementRef: focusElementRef
    });
    const draggableEventHandlers = disableDragEvents ? null : {
        onDragEnter: publish('cellDragEnter', onDragEnter),
        onDragOver: publish('cellDragOver', onDragOver)
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, classNames, className),
        role: "gridcell",
        "data-field": field,
        "data-colindex": colIndex,
        "aria-colindex": colIndex + 1,
        "aria-colspan": colSpan,
        "aria-rowspan": rowSpan,
        style: style,
        title: title,
        tabIndex: tabIndex,
        onClick: publish('cellClick', onClick),
        onDoubleClick: publish('cellDoubleClick', onDoubleClick),
        onMouseOver: publish('cellMouseOver', onMouseOver),
        onMouseDown: publishMouseDown('cellMouseDown'),
        onMouseUp: publishMouseUp('cellMouseUp'),
        onKeyDown: publish('cellKeyDown', onKeyDown),
        onKeyUp: publish('cellKeyUp', onKeyUp)
    }, draggableEventHandlers, other, {
        onFocus: handleFocus,
        ref: handleRef,
        children: children
    }));
});
const $a95a85cb097c106e$export$1ce951ee41d30605 = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($a95a85cb097c106e$var$GridCell);




parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");









var $acw62 = parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");





const $4506815aa03628c9$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, open: open } = ownerState;
    const slots = {
        root: [
            'menuIcon',
            open && 'menuOpen'
        ],
        button: [
            'menuIconButton'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $4506815aa03628c9$export$941072bb8af39847 = /*#__PURE__*/ $acw62.memo((props)=>{
    const { colDef: colDef, open: open, columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, iconButtonRef: iconButtonRef } = props;
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes
    });
    const classes = $4506815aa03628c9$var$useUtilityClasses(ownerState);
    const handleMenuIconClick = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
        apiRef.current.toggleColumnMenu(colDef.field);
    }, [
        apiRef,
        colDef.field
    ]);
    const columnName = colDef.headerName ?? colDef.field;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: classes.root,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTooltip, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            title: apiRef.current.getLocaleText('columnMenuLabel'),
            enterDelay: 1000
        }, rootProps.slotProps?.baseTooltip, {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                ref: iconButtonRef,
                tabIndex: -1,
                className: classes.button,
                "aria-label": apiRef.current.getLocaleText('columnMenuAriaLabel')(columnName),
                size: "small",
                onClick: handleMenuIconClick,
                "aria-haspopup": "menu",
                "aria-expanded": open,
                "aria-controls": open ? columnMenuId : undefined,
                id: columnMenuButtonId
            }, rootProps.slotProps?.baseIconButton, {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnMenuIcon, {
                    fontSize: "inherit"
                })
            }))
        }))
    });
});



parcelRequire("acw62");






function $a4c8d5c5064f4a42$export$c096196819b00a09({ columnMenuId: columnMenuId, columnMenuButtonId: columnMenuButtonId, ContentComponent: ContentComponent, contentComponentProps: contentComponentProps, field: field, open: open, target: target, onExited: onExited }) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const colDef = apiRef.current.getColumn(field);
    const hideMenu = (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
        if (event) {
            // Prevent triggering the sorting
            event.stopPropagation();
            if (target?.contains(event.target)) return;
        }
        apiRef.current.hideColumnMenu();
    });
    if (!target || !colDef) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbffbc66fe757e53$export$237948c71948075), {
        position: `bottom-${colDef.align === 'right' ? 'start' : 'end'}`,
        open: open,
        target: target,
        onClose: hideMenu,
        onExited: onExited,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ContentComponent, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            colDef: colDef,
            hideMenu: hideMenu,
            open: open,
            id: columnMenuId,
            labelledby: columnMenuButtonId
        }, contentComponentProps))
    });
}







var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");









'use client';
const $329a1687709b19ee$var$_excluded = [
    "className",
    "aria-label"
];
const $329a1687709b19ee$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaderTitle'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $329a1687709b19ee$var$GridColumnHeaderTitleRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderTitle'
})({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    fontWeight: 'var(--unstable_DataGrid-headWeight)',
    lineHeight: 'normal'
});
const $329a1687709b19ee$var$ColumnHeaderInnerTitle = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function ColumnHeaderInnerTitle(props, ref) {
    // Tooltip adds aria-label to the props, which is not needed since the children prop is a string
    // See https://github.com/mui/mui-x/pull/14482
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $329a1687709b19ee$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $329a1687709b19ee$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($329a1687709b19ee$var$GridColumnHeaderTitleRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        ref: ref
    }));
});
// No React.memo here as if we display the sort icon, we need to recalculate the isOver
function $329a1687709b19ee$export$926bb04b6af55e42(props) {
    const { label: label, description: description } = props;
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const titleRef = $acw62.useRef(null);
    const [tooltip, setTooltip] = $acw62.useState('');
    const handleMouseOver = $acw62.useCallback(()=>{
        if (!description && titleRef?.current) {
            const isOver = (0, $b2637ba08a26ef7b$export$c8be9a8325efa7ee)(titleRef.current);
            if (isOver) setTooltip(label);
            else setTooltip('');
        }
    }, [
        description,
        label
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTooltip, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        title: description || tooltip
    }, rootProps.slotProps?.baseTooltip, {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($329a1687709b19ee$var$ColumnHeaderInnerTitle, {
            onMouseOver: handleMouseOver,
            ref: titleRef,
            children: label
        })
    }));
}





var $acw62 = parcelRequire("acw62");






const $4faf12a5eab2593b$var$_excluded = [
    "resizable",
    "resizing",
    "height",
    "side"
];
var $4faf12a5eab2593b$export$71ed79b4ccf06d60 = /*#__PURE__*/ function(GridColumnHeaderSeparatorSides) {
    GridColumnHeaderSeparatorSides["Left"] = "left";
    GridColumnHeaderSeparatorSides["Right"] = "right";
    return GridColumnHeaderSeparatorSides;
}($4faf12a5eab2593b$export$71ed79b4ccf06d60 || {});
const $4faf12a5eab2593b$var$useUtilityClasses = (ownerState)=>{
    const { resizable: resizable, resizing: resizing, classes: classes, side: side } = ownerState;
    const slots = {
        root: [
            'columnSeparator',
            resizable && 'columnSeparator--resizable',
            resizing && 'columnSeparator--resizing',
            side && `columnSeparator--side${(0, $c0a836f2f53d8f74$export$2e2bcd8739ae039)(side)}`
        ],
        icon: [
            'iconSeparator'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
function $4faf12a5eab2593b$var$GridColumnHeaderSeparatorRaw(props) {
    const { height: height, side: side = $4faf12a5eab2593b$export$71ed79b4ccf06d60.Right } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $4faf12a5eab2593b$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        side: side,
        classes: rootProps.classes
    });
    const classes = $4faf12a5eab2593b$var$useUtilityClasses(ownerState);
    const stopClick = $acw62.useCallback((event)=>{
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    (0, $7b02d682eb115277$exports.jsx)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classes.root,
        style: {
            minHeight: height
        }
    }, other, {
        onClick: stopClick,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnResizeIcon, {
            className: classes.icon
        })
    })));
}
const $4faf12a5eab2593b$export$a264529bdbb7adb7 = /*#__PURE__*/ $acw62.memo($4faf12a5eab2593b$var$GridColumnHeaderSeparatorRaw);




'use client';
const $80e7bbfd320611d2$var$_excluded = [
    "classes",
    "columnMenuOpen",
    "colIndex",
    "height",
    "isResizing",
    "sortDirection",
    "hasFocus",
    "tabIndex",
    "separatorSide",
    "isDraggable",
    "headerComponent",
    "description",
    "elementId",
    "width",
    "columnMenuIconButton",
    "columnMenu",
    "columnTitleIconButtons",
    "headerClassName",
    "label",
    "resizable",
    "draggableContainerProps",
    "columnHeaderSeparatorProps",
    "style"
];
const $80e7bbfd320611d2$export$fd75c0d5b714072b = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridGenericColumnHeaderItem(props, ref) {
    const { classes: classes, colIndex: colIndex, height: height, isResizing: isResizing, sortDirection: sortDirection, tabIndex: tabIndex, separatorSide: separatorSide, isDraggable: isDraggable, headerComponent: headerComponent, description: description, width: width, columnMenuIconButton: columnMenuIconButton = null, columnMenu: columnMenu = null, columnTitleIconButtons: columnTitleIconButtons = null, headerClassName: headerClassName, label: label, resizable: resizable, draggableContainerProps: draggableContainerProps, columnHeaderSeparatorProps: columnHeaderSeparatorProps, style: style } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $80e7bbfd320611d2$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const headerCellRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(headerCellRef, ref);
    let ariaSort = 'none';
    if (sortDirection != null) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, headerClassName),
        style: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, style, {
            width: width
        }),
        role: "columnheader",
        tabIndex: tabIndex,
        "aria-colindex": colIndex + 1,
        "aria-sort": ariaSort
    }, other, {
        ref: handleRef,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                className: classes.draggableContainer,
                draggable: isDraggable,
                role: "presentation"
            }, draggableContainerProps, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: classes.titleContainer,
                        role: "presentation",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: classes.titleContainerContent,
                                children: headerComponent !== undefined ? headerComponent : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $329a1687709b19ee$export$926bb04b6af55e42), {
                                    label: label,
                                    description: description,
                                    columnWidth: width
                                })
                            }),
                            columnTitleIconButtons
                        ]
                    }),
                    columnMenuIconButton
                ]
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4faf12a5eab2593b$export$a264529bdbb7adb7), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                resizable: !rootProps.disableColumnResize && !!resizable,
                resizing: isResizing,
                height: height,
                side: separatorSide
            }, columnHeaderSeparatorProps)),
            columnMenu
        ]
    }));
});






'use client';
const $e63a0a0cbbd92747$var$useUtilityClasses = (ownerState)=>{
    const { disableColumnSorting: disableColumnSorting } = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { colDef: colDef, classes: classes, isDragging: isDragging, sortDirection: sortDirection, showRightBorder: showRightBorder, showLeftBorder: showLeftBorder, filterItemsCounter: filterItemsCounter, pinnedPosition: pinnedPosition, isSiblingFocused: isSiblingFocused } = ownerState;
    const isColumnSortable = colDef.sortable && !disableColumnSorting;
    const isColumnSorted = sortDirection != null;
    const isColumnFiltered = filterItemsCounter != null && filterItemsCounter > 0;
    // todo refactor to a prop on col isNumeric or ?? ie: coltype===price wont work
    const isColumnNumeric = colDef.type === 'number';
    const slots = {
        root: [
            'columnHeader',
            colDef.headerAlign === 'left' && 'columnHeader--alignLeft',
            colDef.headerAlign === 'center' && 'columnHeader--alignCenter',
            colDef.headerAlign === 'right' && 'columnHeader--alignRight',
            isColumnSortable && 'columnHeader--sortable',
            isDragging && 'columnHeader--moving',
            isColumnSorted && 'columnHeader--sorted',
            isColumnFiltered && 'columnHeader--filtered',
            isColumnNumeric && 'columnHeader--numeric',
            'withBorderColor',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT && 'columnHeader--pinnedRight',
            // TODO: Remove classes below and restore `:has` selectors when they are supported in jsdom
            // See https://github.com/mui/mui-x/pull/14559
            isSiblingFocused && 'columnHeader--siblingFocused'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
function $e63a0a0cbbd92747$var$GridColumnHeaderItem(props) {
    const { colDef: colDef, columnMenuOpen: columnMenuOpen, colIndex: colIndex, headerHeight: headerHeight, isResizing: isResizing, isLast: isLast, sortDirection: sortDirection, sortIndex: sortIndex, filterItemsCounter: filterItemsCounter, hasFocus: hasFocus, tabIndex: tabIndex, disableReorder: disableReorder, separatorSide: separatorSide, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const headerCellRef = $acw62.useRef(null);
    const columnMenuId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const columnMenuButtonId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const iconButtonRef = $acw62.useRef(null);
    const [showColumnMenuIcon, setShowColumnMenuIcon] = $acw62.useState(columnMenuOpen);
    const isDraggable = $acw62.useMemo(()=>!rootProps.disableColumnReorder && !disableReorder && !colDef.disableReorder, [
        rootProps.disableColumnReorder,
        disableReorder,
        colDef.disableReorder
    ]);
    let headerComponent;
    if (colDef.renderHeader) headerComponent = colDef.renderHeader(apiRef.current.getColumnHeaderParams(colDef.field));
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes,
        showRightBorder: showRightBorder,
        showLeftBorder: showLeftBorder
    });
    const classes = $e63a0a0cbbd92747$var$useUtilityClasses(ownerState);
    const publish = $acw62.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $b2637ba08a26ef7b$export$8ce496ad3bfbe3a6)(event)) return;
            apiRef.current.publishEvent(eventName, apiRef.current.getColumnHeaderParams(colDef.field), event);
        }, [
        apiRef,
        colDef.field
    ]);
    const mouseEventsHandlers = $acw62.useMemo(()=>({
            onClick: publish('columnHeaderClick'),
            onContextMenu: publish('columnHeaderContextMenu'),
            onDoubleClick: publish('columnHeaderDoubleClick'),
            onMouseOver: publish('columnHeaderOver'),
            // TODO remove as it's not used
            onMouseOut: publish('columnHeaderOut'),
            // TODO remove as it's not used
            onMouseEnter: publish('columnHeaderEnter'),
            // TODO remove as it's not used
            onMouseLeave: publish('columnHeaderLeave'),
            // TODO remove as it's not used
            onKeyDown: publish('columnHeaderKeyDown'),
            onFocus: publish('columnHeaderFocus'),
            onBlur: publish('columnHeaderBlur')
        }), [
        publish
    ]);
    const draggableEventHandlers = $acw62.useMemo(()=>isDraggable ? {
            onDragStart: publish('columnHeaderDragStart'),
            onDragEnter: publish('columnHeaderDragEnter'),
            onDragOver: publish('columnHeaderDragOver'),
            onDragEndCapture: publish('columnHeaderDragEnd')
        } : {}, [
        isDraggable,
        publish
    ]);
    const columnHeaderSeparatorProps = $acw62.useMemo(()=>({
            onMouseDown: publish('columnSeparatorMouseDown'),
            onDoubleClick: publish('columnSeparatorDoubleClick')
        }), [
        publish
    ]);
    $acw62.useEffect(()=>{
        if (!showColumnMenuIcon) setShowColumnMenuIcon(columnMenuOpen);
    }, [
        showColumnMenuIcon,
        columnMenuOpen
    ]);
    const handleExited = $acw62.useCallback(()=>{
        setShowColumnMenuIcon(false);
    }, []);
    const columnMenuIconButton = !rootProps.disableColumnMenu && !colDef.disableColumnMenu && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4506815aa03628c9$export$941072bb8af39847), {
        colDef: colDef,
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        open: showColumnMenuIcon,
        iconButtonRef: iconButtonRef
    });
    const columnMenu = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a4c8d5c5064f4a42$export$c096196819b00a09), {
        columnMenuId: columnMenuId,
        columnMenuButtonId: columnMenuButtonId,
        field: colDef.field,
        open: columnMenuOpen,
        target: iconButtonRef.current,
        ContentComponent: rootProps.slots.columnMenu,
        contentComponentProps: rootProps.slotProps?.columnMenu,
        onExited: handleExited
    });
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const showSortIcon = (colDef.sortable || sortDirection != null) && !colDef.hideSortIcons && !rootProps.disableColumnSorting;
    const columnTitleIconButtons = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnHeaderFilterIconButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                field: colDef.field,
                counter: filterItemsCounter
            }, rootProps.slotProps?.columnHeaderFilterIconButton)),
            showSortIcon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnHeaderSortIcon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                field: colDef.field,
                direction: sortDirection,
                index: sortIndex,
                sortingOrder: sortingOrder,
                disabled: !colDef.sortable
            }, rootProps.slotProps?.columnHeaderSortIcon))
        ]
    });
    $acw62.useLayoutEffect(()=>{
        const columnMenuState = apiRef.current.state.columnMenu;
        if (hasFocus && !columnMenuState.open) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            if (!elementToFocus) return;
            if ((0, $3cc4d0090b3d135c$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const headerClassName = typeof colDef.headerClassName === 'function' ? colDef.headerClassName({
        field: colDef.field,
        colDef: colDef
    }) : colDef.headerClassName;
    const label = colDef.headerName ?? colDef.field;
    const style = $acw62.useMemo(()=>(0, $3692da1bdaccd764$export$175ada5333288b48)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80e7bbfd320611d2$export$fd75c0d5b714072b), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: columnMenuOpen,
        colIndex: colIndex,
        height: headerHeight,
        isResizing: isResizing,
        sortDirection: sortDirection,
        hasFocus: hasFocus,
        tabIndex: tabIndex,
        separatorSide: separatorSide,
        isDraggable: isDraggable,
        headerComponent: headerComponent,
        description: colDef.description,
        elementId: colDef.field,
        width: colDef.computedWidth,
        columnMenuIconButton: columnMenuIconButton,
        columnTitleIconButtons: columnTitleIconButtons,
        headerClassName: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(headerClassName, isLast && (0, $59e5f6b0ce3da023$export$2100d54e36406477)['columnHeader--last']),
        label: label,
        resizable: !rootProps.disableColumnResize && !!colDef.resizable,
        "data-field": colDef.field,
        columnMenu: columnMenu,
        draggableContainerProps: draggableEventHandlers,
        columnHeaderSeparatorProps: columnHeaderSeparatorProps,
        style: style
    }, mouseEventsHandlers));
}
const $e63a0a0cbbd92747$export$10f6faff2f47edd = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($e63a0a0cbbd92747$var$GridColumnHeaderItem);






var $acw62 = parcelRequire("acw62");














'use client';
const $d0129d86485ab542$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, headerAlign: headerAlign, isDragging: isDragging, isLastColumn: isLastColumn, showLeftBorder: showLeftBorder, showRightBorder: showRightBorder, groupId: groupId, pinnedPosition: pinnedPosition } = ownerState;
    const slots = {
        root: [
            'columnHeader',
            headerAlign === 'left' && 'columnHeader--alignLeft',
            headerAlign === 'center' && 'columnHeader--alignCenter',
            headerAlign === 'right' && 'columnHeader--alignRight',
            isDragging && 'columnHeader--moving',
            showRightBorder && 'columnHeader--withRightBorder',
            showLeftBorder && 'columnHeader--withLeftBorder',
            'withBorderColor',
            groupId === null ? 'columnHeader--emptyGroup' : 'columnHeader--filledGroup',
            pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT && 'columnHeader--pinnedLeft',
            pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT && 'columnHeader--pinnedRight',
            isLastColumn && 'columnHeader--last'
        ],
        draggableContainer: [
            'columnHeaderDraggableContainer'
        ],
        titleContainer: [
            'columnHeaderTitleContainer',
            'withBorderColor'
        ],
        titleContainerContent: [
            'columnHeaderTitleContainerContent'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
function $d0129d86485ab542$export$ff426d40d02e21be(props) {
    const { groupId: groupId, width: width, depth: depth, maxDepth: maxDepth, fields: fields, height: height, colIndex: colIndex, hasFocus: hasFocus, tabIndex: tabIndex, isLastColumn: isLastColumn, pinnedPosition: pinnedPosition, pinnedOffset: pinnedOffset } = props;
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const headerCellRef = $acw62.useRef(null);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const columnGroupsLookup = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $424decc09f6745ae$export$bdc2ff4432d8b29b));
    const group = groupId ? columnGroupsLookup[groupId] : {};
    const { headerName: headerName = groupId ?? '', description: description = '', headerAlign: headerAlign } = group;
    let headerComponent;
    const render = groupId && columnGroupsLookup[groupId]?.renderHeaderGroup;
    const renderParams = $acw62.useMemo(()=>({
            groupId: groupId,
            headerName: headerName,
            description: description,
            depth: depth,
            maxDepth: maxDepth,
            fields: fields,
            colIndex: colIndex,
            isLastColumn: isLastColumn
        }), [
        groupId,
        headerName,
        description,
        depth,
        maxDepth,
        fields,
        colIndex,
        isLastColumn
    ]);
    if (groupId && render) headerComponent = render(renderParams);
    const ownerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        classes: rootProps.classes,
        headerAlign: headerAlign,
        depth: depth,
        isDragging: false
    });
    const label = headerName ?? groupId;
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const elementId = groupId === null ? `empty-group-cell-${id}` : groupId;
    const classes = $d0129d86485ab542$var$useUtilityClasses(ownerState);
    $acw62.useLayoutEffect(()=>{
        if (hasFocus) {
            const focusableElement = headerCellRef.current.querySelector('[tabindex="0"]');
            const elementToFocus = focusableElement || headerCellRef.current;
            if (!elementToFocus) return;
            if ((0, $3cc4d0090b3d135c$export$ed1f8daf96fc68fb)()) elementToFocus.focus({
                preventScroll: true
            });
            else {
                const scrollPosition = apiRef.current.getScrollPosition();
                elementToFocus.focus();
                apiRef.current.scroll(scrollPosition);
            }
        }
    }, [
        apiRef,
        hasFocus
    ]);
    const publish = $acw62.useCallback((eventName)=>(event)=>{
            // Ignore portal
            // See https://github.com/mui/mui-x/issues/1721
            if ((0, $b2637ba08a26ef7b$export$8ce496ad3bfbe3a6)(event)) return;
            apiRef.current.publishEvent(eventName, renderParams, event);
        }, // For now this is stupid, because renderParams change all the time.
    // Need to move it's computation in the api, such that for a given depth+columnField, I can get the group parameters
    [
        apiRef,
        renderParams
    ]);
    const mouseEventsHandlers = $acw62.useMemo(()=>({
            onKeyDown: publish('columnGroupHeaderKeyDown'),
            onFocus: publish('columnGroupHeaderFocus'),
            onBlur: publish('columnGroupHeaderBlur')
        }), [
        publish
    ]);
    const headerClassName = typeof group.headerClassName === 'function' ? group.headerClassName(renderParams) : group.headerClassName;
    const style = $acw62.useMemo(()=>(0, $3692da1bdaccd764$export$175ada5333288b48)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props.style), isRtl, pinnedPosition, pinnedOffset), [
        pinnedPosition,
        pinnedOffset,
        props.style,
        isRtl
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80e7bbfd320611d2$export$fd75c0d5b714072b), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        ref: headerCellRef,
        classes: classes,
        columnMenuOpen: false,
        colIndex: colIndex,
        height: height,
        isResizing: false,
        sortDirection: null,
        hasFocus: false,
        tabIndex: tabIndex,
        isDraggable: false,
        headerComponent: headerComponent,
        headerClassName: headerClassName,
        description: description,
        elementId: elementId,
        width: width,
        columnMenuIconButton: null,
        columnTitleIconButtons: null,
        resizable: false,
        label: label,
        "aria-colspan": fields.length,
        "data-fields": `|-${fields.join('-|-')}-|`,
        style: style
    }, mouseEventsHandlers));
}




parcelRequire("acw62");



const $7a112108c435607d$var$classes = {
    root: (0, $59e5f6b0ce3da023$export$2100d54e36406477).scrollbarFiller,
    pinnedRight: (0, $59e5f6b0ce3da023$export$2100d54e36406477)['scrollbarFiller--pinnedRight']
};
function $7a112108c435607d$export$69d401a304b172b5({ pinnedRight: pinnedRight }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        role: "presentation",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)($7a112108c435607d$var$classes.root, pinnedRight && $7a112108c435607d$var$classes.pinnedRight)
    });
}








'use client';
const $fd1ef6f912157383$export$7b391e1fd04597c4 = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaderRow'
})({
    display: 'flex'
});
const $fd1ef6f912157383$export$dd7dbc7d3ee10272 = (props)=>{
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props;
    const [dragCol, setDragCol] = $acw62.useState('');
    const [resizeCol, setResizeCol] = $acw62.useState('');
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const columnGroupsModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $424decc09f6745ae$export$78f140ad2e1dbc2b));
    const columnPositions = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$fce7d810e48021e3));
    const renderContext = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $542ae311f57ccc4a$export$3a5705edd3d1af7e));
    const pinnedColumns = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$297e8079713afa11));
    const columnsLookup = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $1781ebe27505055c$export$8a3a9a6db584d7fd));
    const offsetLeft = (0, $4cc7a762081bc0b0$export$fe1f1566870c3cbc)(columnPositions, renderContext, pinnedColumns.left.length);
    const columnsTotalWidth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$ab20f9d33edc7794));
    const gridHasFiller = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$34d7a8c547584228));
    const headerHeight = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$4b70ef0159fef49b));
    const groupHeaderHeight = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$f49d78f35ee113b0));
    const scrollbarWidth = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9f487993152f6061$export$6615095b3c921727));
    const handleColumnResizeStart = $acw62.useCallback((params)=>setResizeCol(params.field), []);
    const handleColumnResizeStop = $acw62.useCallback(()=>setResizeCol(''), []);
    const handleColumnReorderStart = $acw62.useCallback((params)=>setDragCol(params.field), []);
    const handleColumnReorderStop = $acw62.useCallback(()=>setDragCol(''), []);
    const leftRenderContext = $acw62.useMemo(()=>{
        return pinnedColumns.left.length ? {
            firstColumnIndex: 0,
            lastColumnIndex: pinnedColumns.left.length
        } : null;
    }, [
        pinnedColumns.left.length
    ]);
    const rightRenderContext = $acw62.useMemo(()=>{
        return pinnedColumns.right.length ? {
            firstColumnIndex: visibleColumns.length - pinnedColumns.right.length,
            lastColumnIndex: visibleColumns.length
        } : null;
    }, [
        pinnedColumns.right.length,
        visibleColumns.length
    ]);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnResizeStart', handleColumnResizeStart);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnResizeStop', handleColumnResizeStop);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderDragStart', handleColumnReorderStart);
    (0, $d5a5cf36ee2ab74a$export$87c9e82e743b0449)(apiRef, 'columnHeaderDragEndNative', handleColumnReorderStop);
    // Helper for computation common between getColumnHeaders and getColumnGroupHeaders
    const getColumnsToRender = (params)=>{
        const { renderContext: currentContext = renderContext } = params || {};
        const firstColumnToRender = currentContext.firstColumnIndex;
        // HACK: renderContext ins't always synchronized, this should be handled properly.
        const lastColumnToRender = Math.min(currentContext.lastColumnIndex, visibleColumns.length);
        const renderedColumns = visibleColumns.slice(firstColumnToRender, lastColumnToRender);
        return {
            renderedColumns: renderedColumns,
            firstColumnToRender: firstColumnToRender,
            lastColumnToRender: lastColumnToRender
        };
    };
    const getFillers = (params, children, leftOverflow, borderBottom = false)=>{
        const isPinnedRight = params?.position === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT;
        const isNotPinned = params?.position === undefined;
        const hasScrollbarFiller = pinnedColumns.right.length > 0 && isPinnedRight || pinnedColumns.right.length === 0 && isNotPinned;
        const leftOffsetWidth = offsetLeft - leftOverflow;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
            children: [
                isNotPinned && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "presentation",
                    style: {
                        width: leftOffsetWidth
                    }
                }),
                children,
                isNotPinned && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    role: "presentation",
                    className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $59e5f6b0ce3da023$export$2100d54e36406477).filler, borderBottom && (0, $59e5f6b0ce3da023$export$2100d54e36406477)['filler--borderBottom'])
                }),
                hasScrollbarFiller && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7a112108c435607d$export$69d401a304b172b5), {
                    pinnedRight: isPinnedRight
                })
            ]
        });
    };
    const getColumnHeaders = (params, other = {})=>{
        const { renderedColumns: renderedColumns, firstColumnToRender: firstColumnToRender } = getColumnsToRender(params);
        const columns = [];
        for(let i = 0; i < renderedColumns.length; i += 1){
            const colDef = renderedColumns[i];
            const columnIndex = firstColumnToRender + i;
            const isFirstColumn = columnIndex === 0;
            const tabIndex = columnHeaderTabIndexState !== null && columnHeaderTabIndexState.field === colDef.field || isFirstColumn && !hasOtherElementInTabSequence ? 0 : -1;
            const hasFocus = columnHeaderFocus !== null && columnHeaderFocus.field === colDef.field;
            const open = columnMenuState.open && columnMenuState.field === colDef.field;
            const pinnedPosition = params?.position;
            const pinnedOffset = (0, $f1f6b5b1c24e4f9a$export$29949f0e748b68b8)(pinnedPosition, colDef.computedWidth, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            const siblingWithBorderingSeparator = pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT ? renderedColumns[i - 1] : renderedColumns[i + 1];
            const isSiblingFocused = siblingWithBorderingSeparator ? columnHeaderFocus !== null && columnHeaderFocus.field === siblingWithBorderingSeparator.field : false;
            const indexInSection = i;
            const sectionLength = renderedColumns.length;
            const showLeftBorder = (0, $77c35924535e8cce$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection, rootProps.showColumnVerticalBorder, rootProps.pinnedColumnsSectionSeparator);
            const showRightBorder = (0, $77c35924535e8cce$export$646c95cff4790794)(pinnedPosition, indexInSection, sectionLength, rootProps.showColumnVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator);
            columns.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e63a0a0cbbd92747$export$10f6faff2f47edd), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, sortColumnLookup[colDef.field], {
                columnMenuOpen: open,
                filterItemsCounter: filterColumnLookup[colDef.field] && filterColumnLookup[colDef.field].length,
                headerHeight: headerHeight,
                isDragging: colDef.field === dragCol,
                colDef: colDef,
                colIndex: columnIndex,
                isResizing: resizeCol === colDef.field,
                isLast: columnIndex === columnPositions.length - 1,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                isSiblingFocused: isSiblingFocused,
                showLeftBorder: showLeftBorder,
                showRightBorder: showRightBorder
            }, other), colDef.field));
        }
        return getFillers(params, columns, 0);
    };
    const getColumnHeadersRow = ()=>{
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fd1ef6f912157383$export$7b391e1fd04597c4, {
            role: "row",
            "aria-rowindex": headerGroupingMaxDepth + 1,
            ownerState: rootProps,
            className: (0, $59e5f6b0ce3da023$export$2100d54e36406477)['row--borderBottom'],
            style: {
                height: headerHeight
            },
            children: [
                leftRenderContext && getColumnHeaders({
                    position: (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT,
                    renderContext: leftRenderContext
                }, {
                    disableReorder: true
                }),
                getColumnHeaders({
                    renderContext: renderContext
                }),
                rightRenderContext && getColumnHeaders({
                    position: (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT,
                    renderContext: rightRenderContext
                }, {
                    disableReorder: true,
                    separatorSide: (0, $4faf12a5eab2593b$export$71ed79b4ccf06d60).Left
                })
            ]
        });
    };
    const getColumnGroupHeaders = ({ depth: depth, params: params })=>{
        const columnsToRender = getColumnsToRender(params);
        if (columnsToRender.renderedColumns.length === 0) return null;
        const { firstColumnToRender: firstColumnToRender, lastColumnToRender: lastColumnToRender } = columnsToRender;
        const rowStructure = columnGroupsHeaderStructure[depth];
        const firstColumnFieldToRender = visibleColumns[firstColumnToRender].field;
        const firstGroupToRender = columnGroupsModel[firstColumnFieldToRender]?.[depth] ?? null;
        const firstGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === firstGroupToRender && columnFields.includes(firstColumnFieldToRender));
        const lastColumnFieldToRender = visibleColumns[lastColumnToRender - 1].field;
        const lastGroupToRender = columnGroupsModel[lastColumnFieldToRender]?.[depth] ?? null;
        const lastGroupIndex = rowStructure.findIndex(({ groupId: groupId, columnFields: columnFields })=>groupId === lastGroupToRender && columnFields.includes(lastColumnFieldToRender));
        const visibleColumnGroupHeader = rowStructure.slice(firstGroupIndex, lastGroupIndex + 1).map((groupStructure)=>{
            return (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, groupStructure, {
                columnFields: groupStructure.columnFields.filter((field)=>columnVisibility[field] !== false)
            });
        }).filter((groupStructure)=>groupStructure.columnFields.length > 0);
        const firstVisibleColumnIndex = visibleColumnGroupHeader[0].columnFields.indexOf(firstColumnFieldToRender);
        const hiddenGroupColumns = visibleColumnGroupHeader[0].columnFields.slice(0, firstVisibleColumnIndex);
        const leftOverflow = hiddenGroupColumns.reduce((acc, field)=>{
            const column = columnsLookup[field];
            return acc + (column.computedWidth ?? 0);
        }, 0);
        let columnIndex = firstColumnToRender;
        const children = visibleColumnGroupHeader.map(({ groupId: groupId, columnFields: columnFields }, index)=>{
            const hasFocus = columnGroupHeaderFocus !== null && columnGroupHeaderFocus.depth === depth && columnFields.includes(columnGroupHeaderFocus.field);
            const tabIndex = columnGroupHeaderTabIndexState !== null && columnGroupHeaderTabIndexState.depth === depth && columnFields.includes(columnGroupHeaderTabIndexState.field) ? 0 : -1;
            const headerInfo = {
                groupId: groupId,
                width: columnFields.reduce((acc, field)=>acc + columnsLookup[field].computedWidth, 0),
                fields: columnFields,
                colIndex: columnIndex,
                hasFocus: hasFocus,
                tabIndex: tabIndex
            };
            const pinnedPosition = params.position;
            const pinnedOffset = (0, $f1f6b5b1c24e4f9a$export$29949f0e748b68b8)(pinnedPosition, headerInfo.width, columnIndex, columnPositions, columnsTotalWidth, scrollbarWidth);
            columnIndex += columnFields.length;
            let indexInSection = index;
            if (pinnedPosition === (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT) // Group headers can expand to multiple columns, we need to adjust the index
            indexInSection = columnIndex - 1;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d0129d86485ab542$export$ff426d40d02e21be), {
                groupId: groupId,
                width: headerInfo.width,
                fields: headerInfo.fields,
                colIndex: headerInfo.colIndex,
                depth: depth,
                isLastColumn: index === visibleColumnGroupHeader.length - 1,
                maxDepth: headerGroupingMaxDepth,
                height: groupHeaderHeight,
                hasFocus: hasFocus,
                tabIndex: tabIndex,
                pinnedPosition: pinnedPosition,
                pinnedOffset: pinnedOffset,
                showLeftBorder: (0, $77c35924535e8cce$export$c01fd18a9a3d03b3)(pinnedPosition, indexInSection, rootProps.showColumnVerticalBorder, rootProps.pinnedColumnsSectionSeparator),
                showRightBorder: (0, $77c35924535e8cce$export$646c95cff4790794)(pinnedPosition, indexInSection, visibleColumnGroupHeader.length, rootProps.showColumnVerticalBorder, gridHasFiller, rootProps.pinnedColumnsSectionSeparator)
            }, index);
        });
        return getFillers(params, children, leftOverflow);
    };
    const getColumnGroupHeadersRows = ()=>{
        if (headerGroupingMaxDepth === 0) return null;
        const headerRows = [];
        for(let depth = 0; depth < headerGroupingMaxDepth; depth += 1)headerRows.push(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($fd1ef6f912157383$export$7b391e1fd04597c4, {
            role: "row",
            "aria-rowindex": depth + 1,
            ownerState: rootProps,
            style: {
                height: groupHeaderHeight
            },
            children: [
                leftRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).LEFT,
                        renderContext: leftRenderContext,
                        maxLastColumn: leftRenderContext.lastColumnIndex
                    }
                }),
                getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        renderContext: renderContext
                    }
                }),
                rightRenderContext && getColumnGroupHeaders({
                    depth: depth,
                    params: {
                        position: (0, $d6d7a429fd810b6e$export$f35946017bbd5a24).RIGHT,
                        renderContext: rightRenderContext,
                        maxLastColumn: rightRenderContext.lastColumnIndex
                    }
                })
            ]
        }, depth));
        return headerRows;
    };
    return {
        renderContext: renderContext,
        leftRenderContext: leftRenderContext,
        rightRenderContext: rightRenderContext,
        pinnedColumns: pinnedColumns,
        visibleColumns: visibleColumns,
        columnPositions: columnPositions,
        getFillers: getFillers,
        getColumnHeadersRow: getColumnHeadersRow,
        getColumnsToRender: getColumnsToRender,
        getColumnGroupHeadersRows: getColumnGroupHeadersRows,
        getPinnedCellOffset: $f1f6b5b1c24e4f9a$export$29949f0e748b68b8,
        isDragging: !!dragCol,
        getInnerProps: ()=>({
                role: 'rowgroup'
            })
    };
};




parcelRequire("acw62");







const $868b20ba7e24d7ea$var$_excluded = [
    "className"
];
const $868b20ba7e24d7ea$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'columnHeaders'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $868b20ba7e24d7ea$var$GridColumnHeadersRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ColumnHeaders'
})({
    display: 'flex',
    flexDirection: 'column',
    borderTopLeftRadius: 'var(--unstable_DataGrid-radius)',
    borderTopRightRadius: 'var(--unstable_DataGrid-radius)'
});
const $868b20ba7e24d7ea$export$de91f7b8bf842ed8 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridColumnHeaders(props, ref) {
    const { className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $868b20ba7e24d7ea$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $868b20ba7e24d7ea$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($868b20ba7e24d7ea$var$GridColumnHeadersRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: rootProps
    }, other, {
        role: "presentation",
        ref: ref
    }));
});



const $755cb1f5d55489d9$var$_excluded = [
    "className",
    "visibleColumns",
    "sortColumnLookup",
    "filterColumnLookup",
    "columnHeaderTabIndexState",
    "columnGroupHeaderTabIndexState",
    "columnHeaderFocus",
    "columnGroupHeaderFocus",
    "headerGroupingMaxDepth",
    "columnMenuState",
    "columnVisibility",
    "columnGroupsHeaderStructure",
    "hasOtherElementInTabSequence"
];
const $755cb1f5d55489d9$var$GridColumnHeaders = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridColumnHeaders(props, ref) {
    const { visibleColumns: visibleColumns, sortColumnLookup: sortColumnLookup, filterColumnLookup: filterColumnLookup, columnHeaderTabIndexState: columnHeaderTabIndexState, columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState, columnHeaderFocus: columnHeaderFocus, columnGroupHeaderFocus: columnGroupHeaderFocus, headerGroupingMaxDepth: headerGroupingMaxDepth, columnMenuState: columnMenuState, columnVisibility: columnVisibility, columnGroupsHeaderStructure: columnGroupsHeaderStructure, hasOtherElementInTabSequence: hasOtherElementInTabSequence } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $755cb1f5d55489d9$var$_excluded);
    const { getInnerProps: getInnerProps, getColumnHeadersRow: getColumnHeadersRow, getColumnGroupHeadersRows: getColumnGroupHeadersRows } = (0, $fd1ef6f912157383$export$dd7dbc7d3ee10272)({
        visibleColumns: visibleColumns,
        sortColumnLookup: sortColumnLookup,
        filterColumnLookup: filterColumnLookup,
        columnHeaderTabIndexState: columnHeaderTabIndexState,
        columnGroupHeaderTabIndexState: columnGroupHeaderTabIndexState,
        columnHeaderFocus: columnHeaderFocus,
        columnGroupHeaderFocus: columnGroupHeaderFocus,
        headerGroupingMaxDepth: headerGroupingMaxDepth,
        columnMenuState: columnMenuState,
        columnVisibility: columnVisibility,
        columnGroupsHeaderStructure: columnGroupsHeaderStructure,
        hasOtherElementInTabSequence: hasOtherElementInTabSequence
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $868b20ba7e24d7ea$export$de91f7b8bf842ed8), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, getInnerProps(), {
        ref: ref,
        children: [
            getColumnGroupHeadersRows(),
            getColumnHeadersRow()
        ]
    }));
});
const $755cb1f5d55489d9$export$4a3a74c44d0a6c04 = (0, $f39f4e89b691584e$export$fa306e0bc9a9d6b4)($755cb1f5d55489d9$var$GridColumnHeaders);




parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");


const $d311795c23dcb228$var$_excluded = [
    "displayOrder"
];
const $d311795c23dcb228$export$2ba37d64bee4cf68 = (props)=>{
    const apiRef = (0, $caa6246df345d6fe$export$e1fd9274eb96ee18)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots = {}, slotProps: slotProps = {}, hideMenu: hideMenu, colDef: colDef, addDividers: addDividers = true } = props;
    const processedComponents = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultSlots, slots), [
        defaultSlots,
        slots
    ]);
    const processedSlotProps = $acw62.useMemo(()=>{
        if (!slotProps || Object.keys(slotProps).length === 0) return defaultSlotProps;
        const mergedProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, slotProps);
        Object.entries(defaultSlotProps).forEach(([key, currentSlotProps])=>{
            mergedProps[key] = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, currentSlotProps, slotProps[key] || {});
        });
        return mergedProps;
    }, [
        defaultSlotProps,
        slotProps
    ]);
    const defaultItems = apiRef.current.unstable_applyPipeProcessors('columnMenu', [], props.colDef);
    const userItems = $acw62.useMemo(()=>{
        const defaultComponentKeys = Object.keys(defaultSlots);
        return Object.keys(slots).filter((key)=>!defaultComponentKeys.includes(key));
    }, [
        slots,
        defaultSlots
    ]);
    return $acw62.useMemo(()=>{
        const uniqueItems = Array.from(new Set([
            ...defaultItems,
            ...userItems
        ]));
        const cleansedItems = uniqueItems.filter((key)=>processedComponents[key] != null);
        const sorted = cleansedItems.sort((a, b)=>{
            const leftItemProps = processedSlotProps[a];
            const rightItemProps = processedSlotProps[b];
            const leftDisplayOrder = Number.isFinite(leftItemProps?.displayOrder) ? leftItemProps.displayOrder : 100;
            const rightDisplayOrder = Number.isFinite(rightItemProps?.displayOrder) ? rightItemProps.displayOrder : 100;
            return leftDisplayOrder - rightDisplayOrder;
        });
        return sorted.reduce((acc, key, index)=>{
            let itemProps = {
                colDef: colDef,
                onClick: hideMenu
            };
            const processedComponentProps = processedSlotProps[key];
            if (processedComponentProps) {
                const customProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(processedComponentProps, $d311795c23dcb228$var$_excluded);
                itemProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, itemProps, customProps);
            }
            return addDividers && index !== sorted.length - 1 ? [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ],
                [
                    rootProps.slots.baseDivider,
                    {}
                ]
            ] : [
                ...acc,
                [
                    processedComponents[key],
                    itemProps
                ]
            ];
        }, []);
    }, [
        addDividers,
        colDef,
        defaultItems,
        hideMenu,
        processedComponents,
        processedSlotProps,
        userItems,
        rootProps.slots.baseDivider
    ]);
};







var $acw62 = parcelRequire("acw62");







const $a96840848a47b734$var$_excluded = [
    "hideMenu",
    "colDef",
    "id",
    "labelledby",
    "className",
    "children",
    "open"
];
const $a96840848a47b734$var$StyledMenuList = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d))(()=>({
        minWidth: 248
    }));
function $a96840848a47b734$var$handleMenuScrollCapture(event) {
    if (!event.currentTarget.contains(event.target)) return;
    event.stopPropagation();
}
const $a96840848a47b734$export$595ece458604adc3 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridColumnMenuContainer(props, ref) {
    const { hideMenu: hideMenu, id: id, labelledby: labelledby, className: className, children: children, open: open } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $a96840848a47b734$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const handleListKeyDown = $acw62.useCallback((event)=>{
        if (event.key === 'Tab') event.preventDefault();
        if ((0, $2c033a607636d88a$export$81301abbcd0c8143)(event.key)) hideMenu(event);
    }, [
        hideMenu
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($a96840848a47b734$var$StyledMenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        as: rootProps.slots.baseMenuList,
        id: id,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)((0, $59e5f6b0ce3da023$export$2100d54e36406477).menuList, className),
        "aria-labelledby": labelledby,
        onKeyDown: handleListKeyDown,
        onWheel: $a96840848a47b734$var$handleMenuScrollCapture,
        onTouchMove: $a96840848a47b734$var$handleMenuScrollCapture,
        autoFocus: open
    }, other, {
        ref: ref,
        children: children
    }));
});




var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");





function $63cab38491e1324f$export$43421c0d197b(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const visibleColumns = (0, $1781ebe27505055c$export$16a65a9447d3dda9)(apiRef);
    const columnsWithMenu = visibleColumns.filter((col)=>col.disableColumnMenu !== true);
    // do not allow to hide the last column with menu
    const disabled = columnsWithMenu.length === 1;
    const toggleColumn = $acw62.useCallback((event)=>{
        /**
     * Disabled `MenuItem` would trigger `click` event
     * after imperative `.click()` call on HTML element.
     * Also, click is triggered in testing environment as well.
     */ if (disabled) return;
        apiRef.current.setColumnVisibility(colDef.field, false);
        onClick(event);
    }, [
        apiRef,
        colDef.field,
        onClick,
        disabled
    ]);
    if (rootProps.disableColumnSelector) return null;
    if (colDef.hideable === false) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, {
        onClick: toggleColumn,
        disabled: disabled,
        iconStart: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnMenuHideIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuHideColumn')
    });
}



var $acw62 = parcelRequire("acw62");





function $bf67084c022208dc$export$dfc5e58327b7921f(props) {
    const { onClick: onClick } = props;
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const showColumns = $acw62.useCallback((event)=>{
        onClick(event); // hide column menu
        apiRef.current.showPreferences((0, $e38c9af0748d9173$export$e7e5652452e44b).columns);
    }, [
        apiRef,
        onClick
    ]);
    if (rootProps.disableColumnSelector) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, {
        onClick: showColumns,
        iconStart: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnMenuManageColumnsIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuManageColumns')
    });
}



function $798e833f8d16882b$export$fee567ee855db2cc(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $63cab38491e1324f$export$43421c0d197b), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf67084c022208dc$export$dfc5e58327b7921f), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props))
        ]
    });
}



var $acw62 = parcelRequire("acw62");




function $6be09e29b39e087a$export$a4dd856446268ffe(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const showFilter = $acw62.useCallback((event)=>{
        onClick(event);
        apiRef.current.showFilterPanel(colDef.field);
    }, [
        apiRef,
        colDef.field,
        onClick
    ]);
    if (rootProps.disableColumnFilter || !colDef.filterable) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, {
        onClick: showFilter,
        iconStart: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnMenuFilterIcon, {
            fontSize: "small"
        }),
        children: apiRef.current.getLocaleText('columnMenuFilter')
    });
}



var $acw62 = parcelRequire("acw62");






function $5462e6249dae7f56$export$e58710c52f856e65(props) {
    const { colDef: colDef, onClick: onClick } = props;
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const sortModel = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $f0897a6c670e0208$export$55dcc66b73d9a0f9));
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const sortDirection = $acw62.useMemo(()=>{
        if (!colDef) return null;
        const sortItem = sortModel.find((item)=>item.field === colDef.field);
        return sortItem?.sort;
    }, [
        colDef,
        sortModel
    ]);
    const sortingOrder = colDef.sortingOrder ?? rootProps.sortingOrder;
    const onSortMenuItemClick = $acw62.useCallback((event)=>{
        onClick(event);
        const direction = event.currentTarget.getAttribute('data-value') || null;
        const allowMultipleSorting = rootProps.multipleColumnsSortingMode === 'always';
        apiRef.current.sortColumn(colDef.field, direction === sortDirection ? null : direction, allowMultipleSorting);
    }, [
        apiRef,
        colDef,
        onClick,
        sortDirection,
        rootProps.multipleColumnsSortingMode
    ]);
    if (rootProps.disableColumnSorting || !colDef || !colDef.sortable || !sortingOrder.some((item)=>!!item)) return null;
    const getLabel = (key)=>{
        const label = apiRef.current.getLocaleText(key);
        return typeof label === 'function' ? label(colDef) : label;
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            sortingOrder.includes('asc') && sortDirection !== 'asc' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                "data-value": "asc",
                iconStart: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnMenuSortAscendingIcon, {
                    fontSize: "small"
                }),
                children: getLabel('columnMenuSortAsc')
            }) : null,
            sortingOrder.includes('desc') && sortDirection !== 'desc' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                "data-value": "desc",
                iconStart: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnMenuSortDescendingIcon, {
                    fontSize: "small"
                }),
                children: getLabel('columnMenuSortDesc')
            }) : null,
            sortingOrder.includes(null) && sortDirection != null ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, {
                onClick: onSortMenuItemClick,
                iconStart: rootProps.slots.columnMenuUnsortIcon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnMenuUnsortIcon, {
                    fontSize: "small"
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                children: apiRef.current.getLocaleText('columnMenuUnsort')
            }) : null
        ]
    });
}



const $9bccf585bf07c9ed$var$_excluded = [
    "defaultSlots",
    "defaultSlotProps",
    "slots",
    "slotProps"
];
const $9bccf585bf07c9ed$export$5983f95fe9d3e659 = {
    columnMenuSortItem: (0, $5462e6249dae7f56$export$e58710c52f856e65),
    columnMenuFilterItem: (0, $6be09e29b39e087a$export$a4dd856446268ffe),
    columnMenuColumnsItem: (0, $798e833f8d16882b$export$fee567ee855db2cc)
};
const $9bccf585bf07c9ed$export$c107bd4c779cece6 = {
    columnMenuSortItem: {
        displayOrder: 10
    },
    columnMenuFilterItem: {
        displayOrder: 20
    },
    columnMenuColumnsItem: {
        displayOrder: 30
    }
};
const $9bccf585bf07c9ed$export$61ffa20907ac4a8e = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridGenericColumnMenu(props, ref) {
    const { defaultSlots: defaultSlots, defaultSlotProps: defaultSlotProps, slots: slots, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $9bccf585bf07c9ed$var$_excluded);
    const orderedSlots = (0, $d311795c23dcb228$export$2ba37d64bee4cf68)((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        defaultSlots: defaultSlots,
        defaultSlotProps: defaultSlotProps,
        slots: slots,
        slotProps: slotProps
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a96840848a47b734$export$595ece458604adc3), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        ref: ref,
        children: orderedSlots.map(([Component, otherProps], index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Component, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, otherProps), index))
    }));
});
const $9bccf585bf07c9ed$export$53fbb13480dfeb67 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridColumnMenu(props, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9bccf585bf07c9ed$export$61ffa20907ac4a8e, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        defaultSlots: $9bccf585bf07c9ed$export$5983f95fe9d3e659,
        defaultSlotProps: $9bccf585bf07c9ed$export$c107bd4c779cece6
    }));
});


function $103429e767a13c46$export$aa888f5144097c35(_) {
    return null;
}


function $32354e26a56a0956$export$58309d5251e10b9e(_) {
    return null;
}



parcelRequire("acw62");




const $2a9f2233e80308ec$export$82fb990ffc125278 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function GridNoResultsOverlay(props, ref) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const noResultsOverlayLabel = apiRef.current.getLocaleText('noResultsOverlayLabel');
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ceaf4ba20b7dea1$export$1c41ff9dbe11e487), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        ref: ref,
        children: noResultsOverlayLabel
    }));
});





var $acw62 = parcelRequire("acw62");






var $acw62 = parcelRequire("acw62");





'use client';
function $3932ee7923050386$var$useBadge(parameters) {
    const { badgeContent: badgeContentProp, invisible: invisibleProp = false, max: maxProp = 99, showZero: showZero = false } = parameters;
    const prevProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        badgeContent: badgeContentProp,
        max: maxProp
    });
    let invisible = invisibleProp;
    if (invisibleProp === false && badgeContentProp === 0 && !showZero) invisible = true;
    const { badgeContent: badgeContent, max: max = maxProp } = invisible ? prevProps : parameters;
    const displayValue = badgeContent && Number(badgeContent) > max ? `${max}+` : badgeContent;
    return {
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue
    };
}
var $3932ee7923050386$export$2e2bcd8739ae039 = $3932ee7923050386$var$useBadge;









function $9030a949247111b3$export$aaccef17e6dab084(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiBadge', slot);
}
const $9030a949247111b3$var$badgeClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiBadge', [
    'root',
    'badge',
    'dot',
    'standard',
    'anchorOriginTopRight',
    'anchorOriginBottomRight',
    'anchorOriginTopLeft',
    'anchorOriginBottomLeft',
    'invisible',
    'colorError',
    'colorInfo',
    'colorPrimary',
    'colorSecondary',
    'colorSuccess',
    'colorWarning',
    'overlapRectangular',
    'overlapCircular',
    // TODO: v6 remove the overlap value from these class keys
    'anchorOriginTopLeftCircular',
    'anchorOriginTopLeftRectangular',
    'anchorOriginTopRightCircular',
    'anchorOriginTopRightRectangular',
    'anchorOriginBottomLeftCircular',
    'anchorOriginBottomLeftRectangular',
    'anchorOriginBottomRightCircular',
    'anchorOriginBottomRightRectangular'
]);
var $9030a949247111b3$export$2e2bcd8739ae039 = $9030a949247111b3$var$badgeClasses;




'use client';
const $f18835d59a9187d7$var$RADIUS_STANDARD = 10;
const $f18835d59a9187d7$var$RADIUS_DOT = 4;
const $f18835d59a9187d7$var$useUtilityClasses = (ownerState)=>{
    const { color: color, anchorOrigin: anchorOrigin, invisible: invisible, overlap: overlap, variant: variant, classes: classes = {} } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        badge: [
            'badge',
            variant,
            invisible && 'invisible',
            `anchorOrigin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}`,
            `anchorOrigin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchorOrigin.vertical)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(anchorOrigin.horizontal)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(overlap)}`,
            `overlap${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(overlap)}`,
            color !== 'default' && `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $9030a949247111b3$export$aaccef17e6dab084), classes);
};
const $f18835d59a9187d7$var$BadgeRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiBadge',
    slot: 'Root'
})({
    position: 'relative',
    display: 'inline-flex',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    flexShrink: 0
});
const $f18835d59a9187d7$var$BadgeBadge = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiBadge',
    slot: 'Badge',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.badge,
            styles[ownerState.variant],
            styles[`anchorOrigin${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.vertical)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.anchorOrigin.horizontal)}${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.overlap)}`],
            ownerState.color !== 'default' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`],
            ownerState.invisible && styles.invisible
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        position: 'absolute',
        boxSizing: 'border-box',
        fontFamily: theme.typography.fontFamily,
        fontWeight: theme.typography.fontWeightMedium,
        fontSize: theme.typography.pxToRem(12),
        minWidth: $f18835d59a9187d7$var$RADIUS_STANDARD * 2,
        lineHeight: 1,
        padding: '0 6px',
        height: $f18835d59a9187d7$var$RADIUS_STANDARD * 2,
        borderRadius: $f18835d59a9187d7$var$RADIUS_STANDARD,
        zIndex: 1,
        // Render the badge on top of potential ripples.
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeInOut,
            duration: theme.transitions.duration.enteringScreen
        }),
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'contrastText'
            ])).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        backgroundColor: (theme.vars || theme).palette[color].main,
                        color: (theme.vars || theme).palette[color].contrastText
                    }
                })),
            {
                props: {
                    variant: 'dot'
                },
                style: {
                    borderRadius: $f18835d59a9187d7$var$RADIUS_DOT,
                    height: $f18835d59a9187d7$var$RADIUS_DOT * 2,
                    minWidth: $f18835d59a9187d7$var$RADIUS_DOT * 2,
                    padding: 0
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    right: 0,
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    top: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'rectangular',
                style: {
                    bottom: 0,
                    left: 0,
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, -50%)',
                    transformOrigin: '100% 0%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'right' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    right: '14%',
                    transform: 'scale(1) translate(50%, 50%)',
                    transformOrigin: '100% 100%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(50%, 50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'top' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    top: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, -50%)',
                    transformOrigin: '0% 0%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, -50%)'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.anchorOrigin.vertical === 'bottom' && ownerState.anchorOrigin.horizontal === 'left' && ownerState.overlap === 'circular',
                style: {
                    bottom: '14%',
                    left: '14%',
                    transform: 'scale(1) translate(-50%, 50%)',
                    transformOrigin: '0% 100%',
                    [`&.${(0, $9030a949247111b3$export$2e2bcd8739ae039).invisible}`]: {
                        transform: 'scale(0) translate(-50%, 50%)'
                    }
                }
            },
            {
                props: {
                    invisible: true
                },
                style: {
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeInOut,
                        duration: theme.transitions.duration.leavingScreen
                    })
                }
            }
        ]
    })));
function $f18835d59a9187d7$var$getAnchorOrigin(anchorOrigin) {
    return {
        vertical: anchorOrigin?.vertical ?? 'top',
        horizontal: anchorOrigin?.horizontal ?? 'right'
    };
}
const $f18835d59a9187d7$var$Badge = /*#__PURE__*/ $acw62.forwardRef(function Badge(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiBadge'
    });
    const { anchorOrigin: anchorOriginProp, className: className, classes: classesProp, component: component, components: components = {}, componentsProps: componentsProps = {}, children: children, overlap: overlapProp = 'rectangular', color: colorProp = 'default', invisible: invisibleProp = false, max: maxProp = 99, badgeContent: badgeContentProp, slots: slots, slotProps: slotProps, showZero: showZero = false, variant: variantProp = 'standard', ...other } = props;
    const { badgeContent: badgeContent, invisible: invisibleFromHook, max: max, displayValue: displayValueFromHook } = (0, $3932ee7923050386$export$2e2bcd8739ae039)({
        max: maxProp,
        invisible: invisibleProp,
        badgeContent: badgeContentProp,
        showZero: showZero
    });
    const prevProps = (0, $7027da6f4b17de9d$export$2e2bcd8739ae039)({
        anchorOrigin: $f18835d59a9187d7$var$getAnchorOrigin(anchorOriginProp),
        color: colorProp,
        overlap: overlapProp,
        variant: variantProp,
        badgeContent: badgeContentProp
    });
    const invisible = invisibleFromHook || badgeContent == null && variantProp !== 'dot';
    const { color: color = colorProp, overlap: overlap = overlapProp, anchorOrigin: anchorOriginPropProp, variant: variant = variantProp } = invisible ? prevProps : props;
    const anchorOrigin = $f18835d59a9187d7$var$getAnchorOrigin(anchorOriginPropProp);
    const displayValue = variant !== 'dot' ? displayValueFromHook : undefined;
    const ownerState = {
        ...props,
        badgeContent: badgeContent,
        invisible: invisible,
        max: max,
        displayValue: displayValue,
        showZero: showZero,
        anchorOrigin: anchorOrigin,
        color: color,
        overlap: overlap,
        variant: variant
    };
    const classes = $f18835d59a9187d7$var$useUtilityClasses(ownerState);
    // support both `slots` and `components` for backward compatibility
    const externalForwardedProps = {
        slots: {
            root: slots?.root ?? components.Root,
            badge: slots?.badge ?? components.Badge
        },
        slotProps: {
            root: slotProps?.root ?? componentsProps.root,
            badge: slotProps?.badge ?? componentsProps.badge
        }
    };
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $f18835d59a9187d7$var$BadgeRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        additionalProps: {
            as: component
        }
    });
    const [BadgeSlot, badgeProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('badge', {
        elementType: $f18835d59a9187d7$var$BadgeBadge,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.badge
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            children,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(BadgeSlot, {
                ...badgeProps,
                children: displayValue
            })
        ]
    });
});
var $f18835d59a9187d7$export$2e2bcd8739ae039 = $f18835d59a9187d7$var$Badge;










var $acw62 = parcelRequire("acw62");









'use client';
const $ab586b5c8bd0ab7a$var$useUtilityClasses = (ownerState)=>{
    const { alignItems: alignItems, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            alignItems === 'flex-start' && 'alignItemsFlexStart'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $863c8b42c24a5d20$export$81478e24460c57f2), classes);
};
const $ab586b5c8bd0ab7a$var$ListItemIconRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemIcon',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        minWidth: 56,
        color: (theme.vars || theme).palette.action.active,
        flexShrink: 0,
        display: 'inline-flex',
        variants: [
            {
                props: {
                    alignItems: 'flex-start'
                },
                style: {
                    marginTop: 8
                }
            }
        ]
    })));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */ const $ab586b5c8bd0ab7a$var$ListItemIcon = /*#__PURE__*/ $acw62.forwardRef(function ListItemIcon(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemIcon'
    });
    const { className: className, ...other } = props;
    const context = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        alignItems: context.alignItems
    };
    const classes = $ab586b5c8bd0ab7a$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ab586b5c8bd0ab7a$var$ListItemIconRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ref: ref,
        ...other
    });
});
var $ab586b5c8bd0ab7a$export$2e2bcd8739ae039 = $ab586b5c8bd0ab7a$var$ListItemIcon;



var $acw62 = parcelRequire("acw62");










'use client';
const $a7cd8ac1360c47a2$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, inset: inset, primary: primary, secondary: secondary, dense: dense } = ownerState;
    const slots = {
        root: [
            'root',
            inset && 'inset',
            dense && 'dense',
            primary && secondary && 'multiline'
        ],
        primary: [
            'primary'
        ],
        secondary: [
            'secondary'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $8ffc2f5b8ea69aff$export$1061006a0db3aeb5), classes);
};
const $a7cd8ac1360c47a2$var$ListItemTextRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiListItemText',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).primary}`]: styles.primary
            },
            {
                [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).secondary}`]: styles.secondary
            },
            styles.root,
            ownerState.inset && styles.inset,
            ownerState.primary && ownerState.secondary && styles.multiline,
            ownerState.dense && styles.dense
        ];
    }
})({
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4,
    [`.${(0, $6e9163c6dd169139$export$2e2bcd8739ae039).root}:where(& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).primary})`]: {
        display: 'block'
    },
    [`.${(0, $6e9163c6dd169139$export$2e2bcd8739ae039).root}:where(& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).secondary})`]: {
        display: 'block'
    },
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.primary && ownerState.secondary,
            style: {
                marginTop: 6,
                marginBottom: 6
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.inset,
            style: {
                paddingLeft: 56
            }
        }
    ]
});
const $a7cd8ac1360c47a2$var$ListItemText = /*#__PURE__*/ $acw62.forwardRef(function ListItemText(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiListItemText'
    });
    const { children: children, className: className, disableTypography: disableTypography = false, inset: inset = false, primary: primaryProp, primaryTypographyProps: primaryTypographyProps, secondary: secondaryProp, secondaryTypographyProps: secondaryTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const { dense: dense } = $acw62.useContext((0, $ccdf08267bdb07b4$export$2e2bcd8739ae039));
    let primary = primaryProp != null ? primaryProp : children;
    let secondary = secondaryProp;
    const ownerState = {
        ...props,
        disableTypography: disableTypography,
        inset: inset,
        primary: !!primary,
        secondary: !!secondary,
        dense: dense
    };
    const classes = $a7cd8ac1360c47a2$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            primary: primaryTypographyProps,
            secondary: secondaryTypographyProps,
            ...slotProps
        }
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $a7cd8ac1360c47a2$var$ListItemTextRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        ref: ref
    });
    const [PrimarySlot, primarySlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('primary', {
        className: classes.primary,
        elementType: (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SecondarySlot, secondarySlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('secondary', {
        className: classes.secondary,
        elementType: (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    if (primary != null && primary.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) primary = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PrimarySlot, {
        variant: dense ? 'body2' : 'body1',
        component: primarySlotProps?.variant ? undefined : 'span',
        ...primarySlotProps,
        children: primary
    });
    if (secondary != null && secondary.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) secondary = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SecondarySlot, {
        variant: "body2",
        color: "textSecondary",
        ...secondarySlotProps,
        children: secondary
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            primary,
            secondary
        ]
    });
});
var $a7cd8ac1360c47a2$export$2e2bcd8739ae039 = $a7cd8ac1360c47a2$var$ListItemText;









var $acw62 = parcelRequire("acw62");












function $2b33e2f571fef2d8$export$39f6debbec19b3ba(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiSwitch', slot);
}
const $2b33e2f571fef2d8$var$switchClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiSwitch', [
    'root',
    'edgeStart',
    'edgeEnd',
    'switchBase',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall',
    'sizeMedium',
    'checked',
    'disabled',
    'input',
    'thumb',
    'track'
]);
var $2b33e2f571fef2d8$export$2e2bcd8739ae039 = $2b33e2f571fef2d8$var$switchClasses;




'use client';
const $e276246268a3078e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, edge: edge, size: size, color: color, checked: checked, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            edge && `edge${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(edge)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ],
        switchBase: [
            'switchBase',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            checked && 'checked',
            disabled && 'disabled'
        ],
        thumb: [
            'thumb'
        ],
        track: [
            'track'
        ],
        input: [
            'input'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $2b33e2f571fef2d8$export$39f6debbec19b3ba), classes);
    return {
        ...classes,
        // forward the disabled and checked classes to the SwitchBase
        ...composedClasses
    };
};
const $e276246268a3078e$var$SwitchRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.edge && styles[`edge${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.edge)}`],
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})({
    display: 'inline-flex',
    width: 58,
    height: 38,
    overflow: 'hidden',
    padding: 12,
    boxSizing: 'border-box',
    position: 'relative',
    flexShrink: 0,
    zIndex: 0,
    // Reset the stacking context.
    verticalAlign: 'middle',
    // For correct alignment with the text.
    '@media print': {
        colorAdjust: 'exact'
    },
    variants: [
        {
            props: {
                edge: 'start'
            },
            style: {
                marginLeft: -8
            }
        },
        {
            props: {
                edge: 'end'
            },
            style: {
                marginRight: -8
            }
        },
        {
            props: {
                size: 'small'
            },
            style: {
                width: 40,
                height: 24,
                padding: 7,
                [`& .${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).thumb}`]: {
                    width: 16,
                    height: 16
                },
                [`& .${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).switchBase}`]: {
                    padding: 4,
                    [`&.${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).checked}`]: {
                        transform: 'translateX(16px)'
                    }
                }
            }
        }
    ]
});
const $e276246268a3078e$var$SwitchSwitchBase = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $dadefa050dca578a$export$2e2bcd8739ae039), {
    name: 'MuiSwitch',
    slot: 'SwitchBase',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.switchBase,
            {
                [`& .${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).input}`]: styles.input
            },
            ownerState.color !== 'default' && styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        top: 0,
        left: 0,
        zIndex: 1,
        // Render above the focus ripple.
        color: theme.vars ? theme.vars.palette.Switch.defaultColor : `${theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300]}`,
        transition: theme.transitions.create([
            'left',
            'transform'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).checked}`]: {
            transform: 'translateX(20px)'
        },
        [`&.${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).disabled}`]: {
            color: theme.vars ? theme.vars.palette.Switch.defaultDisabledColor : `${theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]}`
        },
        [`&.${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).checked} + .${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).track}`]: {
            opacity: 0.5
        },
        [`&.${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).disabled} + .${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).track}`]: {
            opacity: theme.vars ? theme.vars.opacity.switchTrackDisabled : `${theme.palette.mode === 'light' ? 0.12 : 0.2}`
        },
        [`& .${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).input}`]: {
            left: '-100%',
            width: '300%'
        }
    })), (0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        '&:hover': {
            backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity),
            // Reset on touch devices, it doesn't add specificity
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)([
                'light'
            ])) // check all the used fields in the style below
            .map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity),
                                '@media (hover: none)': {
                                    backgroundColor: 'transparent'
                                }
                            },
                            [`&.${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).disabled}`]: {
                                color: theme.vars ? theme.vars.palette.Switch[`${color}DisabledColor`] : `${theme.palette.mode === 'light' ? theme.lighten(theme.palette[color].main, 0.62) : theme.darken(theme.palette[color].main, 0.55)}`
                            }
                        },
                        [`&.${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).checked} + .${(0, $2b33e2f571fef2d8$export$2e2bcd8739ae039).track}`]: {
                            backgroundColor: (theme.vars || theme).palette[color].main
                        }
                    }
                }))
        ]
    })));
const $e276246268a3078e$var$SwitchTrack = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Track'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        height: '100%',
        width: '100%',
        borderRadius: 7,
        zIndex: -1,
        transition: theme.transitions.create([
            'opacity',
            'background-color'
        ], {
            duration: theme.transitions.duration.shortest
        }),
        backgroundColor: theme.vars ? theme.vars.palette.common.onBackground : `${theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white}`,
        opacity: theme.vars ? theme.vars.opacity.switchTrack : `${theme.palette.mode === 'light' ? 0.38 : 0.3}`
    })));
const $e276246268a3078e$var$SwitchThumb = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiSwitch',
    slot: 'Thumb'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        boxShadow: (theme.vars || theme).shadows[1],
        backgroundColor: 'currentColor',
        width: 20,
        height: 20,
        borderRadius: '50%'
    })));
const $e276246268a3078e$var$Switch = /*#__PURE__*/ $acw62.forwardRef(function Switch(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSwitch'
    });
    const { className: className, color: color = 'primary', edge: edge = false, size: size = 'medium', sx: sx, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        edge: edge,
        size: size
    };
    const classes = $e276246268a3078e$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $e276246268a3078e$var$SwitchRoot,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            sx: sx
        }
    });
    const [ThumbSlot, thumbSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('thumb', {
        className: classes.thumb,
        elementType: $e276246268a3078e$var$SwitchThumb,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const icon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ThumbSlot, {
        ...thumbSlotProps
    });
    const [TrackSlot, trackSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('track', {
        className: classes.track,
        elementType: $e276246268a3078e$var$SwitchTrack,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($e276246268a3078e$var$SwitchSwitchBase, {
                type: "checkbox",
                icon: icon,
                checkedIcon: icon,
                ref: ref,
                ownerState: ownerState,
                ...other,
                classes: {
                    ...classes,
                    root: classes.switchBase
                },
                slots: {
                    ...slots.switchBase && {
                        root: slots.switchBase
                    },
                    ...slots.input && {
                        input: slots.input
                    }
                },
                slotProps: {
                    ...slotProps.switchBase && {
                        root: typeof slotProps.switchBase === 'function' ? slotProps.switchBase(ownerState) : slotProps.switchBase
                    },
                    input: {
                        role: 'switch'
                    },
                    ...slotProps.input && {
                        input: typeof slotProps.input === 'function' ? slotProps.input(ownerState) : slotProps.input
                    }
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TrackSlot, {
                ...trackSlotProps
            })
        ]
    });
});
var $e276246268a3078e$export$2e2bcd8739ae039 = $e276246268a3078e$var$Switch;







var $acw62 = parcelRequire("acw62");












var $acw62 = parcelRequire("acw62");





var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $607c3485b4f38191$var$TableContext = /*#__PURE__*/ $acw62.createContext();
var $607c3485b4f38191$export$2e2bcd8739ae039 = $607c3485b4f38191$var$TableContext;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $59c9ddddb511cdd6$var$Tablelvl2Context = /*#__PURE__*/ $acw62.createContext();
var $59c9ddddb511cdd6$export$2e2bcd8739ae039 = $59c9ddddb511cdd6$var$Tablelvl2Context;







function $0f3b8fb4e961edd5$export$33a0f07a16a10b1b(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTableCell', slot);
}
const $0f3b8fb4e961edd5$var$tableCellClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTableCell', [
    'root',
    'head',
    'body',
    'footer',
    'sizeSmall',
    'sizeMedium',
    'paddingCheckbox',
    'paddingNone',
    'alignLeft',
    'alignCenter',
    'alignRight',
    'alignJustify',
    'stickyHeader'
]);
var $0f3b8fb4e961edd5$export$2e2bcd8739ae039 = $0f3b8fb4e961edd5$var$tableCellClasses;



'use client';
const $c63602040c542751$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, align: align, padding: padding, size: size, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            stickyHeader && 'stickyHeader',
            align !== 'inherit' && `align${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(align)}`,
            padding !== 'normal' && `padding${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(padding)}`,
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $0f3b8fb4e961edd5$export$33a0f07a16a10b1b), classes);
};
const $c63602040c542751$var$TableCellRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('td', {
    name: 'MuiTableCell',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            ownerState.padding !== 'normal' && styles[`padding${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.padding)}`],
            ownerState.align !== 'inherit' && styles[`align${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.align)}`],
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        display: 'table-cell',
        verticalAlign: 'inherit',
        // Workaround for a rendering bug with spanned columns in Chrome 62.0.
        // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
        borderBottom: theme.vars ? `1px solid ${theme.vars.palette.TableCell.border}` : `1px solid
    ${theme.palette.mode === 'light' ? theme.lighten(theme.alpha(theme.palette.divider, 1), 0.88) : theme.darken(theme.alpha(theme.palette.divider, 1), 0.68)}`,
        textAlign: 'left',
        padding: 16,
        variants: [
            {
                props: {
                    variant: 'head'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary,
                    lineHeight: theme.typography.pxToRem(24),
                    fontWeight: theme.typography.fontWeightMedium
                }
            },
            {
                props: {
                    variant: 'body'
                },
                style: {
                    color: (theme.vars || theme).palette.text.primary
                }
            },
            {
                props: {
                    variant: 'footer'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    lineHeight: theme.typography.pxToRem(21),
                    fontSize: theme.typography.pxToRem(12)
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: '6px 16px',
                    [`&.${(0, $0f3b8fb4e961edd5$export$2e2bcd8739ae039).paddingCheckbox}`]: {
                        width: 24,
                        // prevent the checkbox column from growing
                        padding: '0 12px 0 16px',
                        '& > *': {
                            padding: 0
                        }
                    }
                }
            },
            {
                props: {
                    padding: 'checkbox'
                },
                style: {
                    width: 48,
                    // prevent the checkbox column from growing
                    padding: '0 0 0 4px'
                }
            },
            {
                props: {
                    padding: 'none'
                },
                style: {
                    padding: 0
                }
            },
            {
                props: {
                    align: 'left'
                },
                style: {
                    textAlign: 'left'
                }
            },
            {
                props: {
                    align: 'center'
                },
                style: {
                    textAlign: 'center'
                }
            },
            {
                props: {
                    align: 'right'
                },
                style: {
                    textAlign: 'right',
                    flexDirection: 'row-reverse'
                }
            },
            {
                props: {
                    align: 'justify'
                },
                style: {
                    textAlign: 'justify'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    position: 'sticky',
                    top: 0,
                    zIndex: 2,
                    backgroundColor: (theme.vars || theme).palette.background.default
                }
            }
        ]
    })));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */ const $c63602040c542751$var$TableCell = /*#__PURE__*/ $acw62.forwardRef(function TableCell(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableCell'
    });
    const { align: align = 'inherit', className: className, component: componentProp, padding: paddingProp, scope: scopeProp, size: sizeProp, sortDirection: sortDirection, variant: variantProp, ...other } = props;
    const table = $acw62.useContext((0, $607c3485b4f38191$export$2e2bcd8739ae039));
    const tablelvl2 = $acw62.useContext((0, $59c9ddddb511cdd6$export$2e2bcd8739ae039));
    const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
    let component;
    if (componentProp) component = componentProp;
    else component = isHeadCell ? 'th' : 'td';
    let scope = scopeProp;
    // scope is not a valid attribute for <td/> elements.
    // source: https://html.spec.whatwg.org/multipage/tables.html#the-td-element
    if (component === 'td') scope = undefined;
    else if (!scope && isHeadCell) scope = 'col';
    const variant = variantProp || tablelvl2 && tablelvl2.variant;
    const ownerState = {
        ...props,
        align: align,
        component: component,
        padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
        size: sizeProp || (table && table.size ? table.size : 'medium'),
        sortDirection: sortDirection,
        stickyHeader: variant === 'head' && table && table.stickyHeader,
        variant: variant
    };
    const classes = $c63602040c542751$var$useUtilityClasses(ownerState);
    let ariaSort = null;
    if (sortDirection) ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c63602040c542751$var$TableCellRoot, {
        as: component,
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        "aria-sort": ariaSort,
        scope: scope,
        ownerState: ownerState,
        ...other
    });
});
var $c63602040c542751$export$2e2bcd8739ae039 = $c63602040c542751$var$TableCell;




var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");


'use client';
var $d997f00fcbb3883b$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft');


parcelRequire("acw62");


'use client';
var $d91db4839e2bc3bb$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight');



parcelRequire("acw62");


'use client';
var $d071034c982194cf$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');


parcelRequire("acw62");


'use client';
var $a65fb2f9fd7a7465$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');




function $cb9999951d5d2ac3$export$e7e9b1c332bb0588(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTablePaginationActions', slot);
}
const $cb9999951d5d2ac3$var$tablePaginationActionsClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTablePaginationActions', [
    'root'
]);
var $cb9999951d5d2ac3$export$2e2bcd8739ae039 = $cb9999951d5d2ac3$var$tablePaginationActionsClasses;



'use client';
const $274989d83c1a4bae$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $cb9999951d5d2ac3$export$e7e9b1c332bb0588), classes);
};
const $274989d83c1a4bae$var$TablePaginationActionsRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTablePaginationActions',
    slot: 'Root'
})({});
const $274989d83c1a4bae$var$TablePaginationActions = /*#__PURE__*/ $acw62.forwardRef(function TablePaginationActions(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTablePaginationActions'
    });
    const { backIconButtonProps: backIconButtonProps, className: className, count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel, nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, page: page, rowsPerPage: rowsPerPage, showFirstButton: showFirstButton, showLastButton: showLastButton, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const ownerState = props;
    const classes = $274989d83c1a4bae$var$useUtilityClasses(ownerState);
    const handleFirstPageButtonClick = (event)=>{
        onPageChange(event, 0);
    };
    const handleBackButtonClick = (event)=>{
        onPageChange(event, page - 1);
    };
    const handleNextButtonClick = (event)=>{
        onPageChange(event, page + 1);
    };
    const handleLastPageButtonClick = (event)=>{
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };
    const FirstButton = slots.firstButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const LastButton = slots.lastButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const NextButton = slots.nextButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const PreviousButton = slots.previousButton ?? (0, $05a469b554e6dcda$export$2e2bcd8739ae039);
    const FirstButtonIcon = slots.firstButtonIcon ?? (0, $a65fb2f9fd7a7465$export$2e2bcd8739ae039);
    const LastButtonIcon = slots.lastButtonIcon ?? (0, $d071034c982194cf$export$2e2bcd8739ae039);
    const NextButtonIcon = slots.nextButtonIcon ?? (0, $d91db4839e2bc3bb$export$2e2bcd8739ae039);
    const PreviousButtonIcon = slots.previousButtonIcon ?? (0, $d997f00fcbb3883b$export$2e2bcd8739ae039);
    const FirstButtonSlot = isRtl ? LastButton : FirstButton;
    const PreviousButtonSlot = isRtl ? NextButton : PreviousButton;
    const NextButtonSlot = isRtl ? PreviousButton : NextButton;
    const LastButtonSlot = isRtl ? FirstButton : LastButton;
    const firstButtonSlotProps = isRtl ? slotProps.lastButton : slotProps.firstButton;
    const previousButtonSlotProps = isRtl ? slotProps.nextButton : slotProps.previousButton;
    const nextButtonSlotProps = isRtl ? slotProps.previousButton : slotProps.nextButton;
    const lastButtonSlotProps = isRtl ? slotProps.firstButton : slotProps.lastButton;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($274989d83c1a4bae$var$TablePaginationActionsRoot, {
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ...other,
        children: [
            showFirstButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FirstButtonSlot, {
                onClick: handleFirstPageButtonClick,
                disabled: disabled || page === 0,
                "aria-label": getItemAriaLabel('first', page),
                title: getItemAriaLabel('first', page),
                ...firstButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PreviousButtonSlot, {
                onClick: handleBackButtonClick,
                disabled: disabled || page === 0,
                color: "inherit",
                "aria-label": getItemAriaLabel('previous', page),
                title: getItemAriaLabel('previous', page),
                ...previousButtonSlotProps ?? backIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NextButtonSlot, {
                onClick: handleNextButtonClick,
                disabled: disabled || (count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false),
                color: "inherit",
                "aria-label": getItemAriaLabel('next', page),
                title: getItemAriaLabel('next', page),
                ...nextButtonSlotProps ?? nextIconButtonProps,
                children: isRtl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(PreviousButtonIcon, {
                    ...slotProps.previousButtonIcon
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(NextButtonIcon, {
                    ...slotProps.nextButtonIcon
                })
            }),
            showLastButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(LastButtonSlot, {
                onClick: handleLastPageButtonClick,
                disabled: disabled || page >= Math.ceil(count / rowsPerPage) - 1,
                "aria-label": getItemAriaLabel('last', page),
                title: getItemAriaLabel('last', page),
                ...lastButtonSlotProps,
                children: isRtl ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FirstButtonIcon, {
                    ...slotProps.firstButtonIcon
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(LastButtonIcon, {
                    ...slotProps.lastButtonIcon
                })
            })
        ]
    });
});
var $274989d83c1a4bae$export$2e2bcd8739ae039 = $274989d83c1a4bae$var$TablePaginationActions;





function $f6b9903d0b727400$export$909e637b22246f4c(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTablePagination', slot);
}
const $f6b9903d0b727400$var$tablePaginationClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTablePagination', [
    'root',
    'toolbar',
    'spacer',
    'selectLabel',
    'selectRoot',
    'select',
    'selectIcon',
    'input',
    'menuItem',
    'displayedRows',
    'actions'
]);
var $f6b9903d0b727400$export$2e2bcd8739ae039 = $f6b9903d0b727400$var$tablePaginationClasses;




'use client';
var $e88806fdab3fc1ac$var$_InputBase;
const $e88806fdab3fc1ac$var$TablePaginationRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $c63602040c542751$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Root'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'auto',
        color: (theme.vars || theme).palette.text.primary,
        fontSize: theme.typography.pxToRem(14),
        // Increase the specificity to override TableCell.
        '&:last-child': {
            padding: 0
        }
    })));
const $e88806fdab3fc1ac$var$TablePaginationToolbar = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $e223a49097a073d9$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Toolbar',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).actions}`]: styles.actions,
            ...styles.toolbar
        })
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        minHeight: 52,
        paddingRight: 2,
        [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
            minHeight: 52
        },
        [theme.breakpoints.up('sm')]: {
            minHeight: 52,
            paddingRight: 2
        },
        [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).actions}`]: {
            flexShrink: 0,
            marginLeft: 20
        }
    })));
const $e88806fdab3fc1ac$var$TablePaginationSpacer = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTablePagination',
    slot: 'Spacer'
})({
    flex: '1 1 100%'
});
const $e88806fdab3fc1ac$var$TablePaginationSelectLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('p', {
    name: 'MuiTablePagination',
    slot: 'SelectLabel'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
const $e88806fdab3fc1ac$var$TablePaginationSelect = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'Select',
    overridesResolver: (props, styles)=>({
            [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).selectIcon}`]: styles.selectIcon,
            [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).select}`]: styles.select,
            ...styles.input,
            ...styles.selectRoot
        })
})({
    color: 'inherit',
    fontSize: 'inherit',
    flexShrink: 0,
    marginRight: 32,
    marginLeft: 8,
    [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).select}`]: {
        paddingLeft: 8,
        paddingRight: 24,
        textAlign: 'right',
        textAlignLast: 'right' // Align <select> on Chrome.
    }
});
const $e88806fdab3fc1ac$var$TablePaginationMenuItem = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
    name: 'MuiTablePagination',
    slot: 'MenuItem'
})({});
const $e88806fdab3fc1ac$var$TablePaginationDisplayedRows = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('p', {
    name: 'MuiTablePagination',
    slot: 'DisplayedRows'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.body2,
        flexShrink: 0
    })));
function $e88806fdab3fc1ac$var$defaultLabelDisplayedRows({ from: from, to: to, count: count }) {
    return `${from}\u{2013}${to} of ${count !== -1 ? count : `more than ${to}`}`;
}
function $e88806fdab3fc1ac$var$defaultGetAriaLabel(type) {
    return `Go to ${type} page`;
}
const $e88806fdab3fc1ac$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        toolbar: [
            'toolbar'
        ],
        spacer: [
            'spacer'
        ],
        selectLabel: [
            'selectLabel'
        ],
        select: [
            'select'
        ],
        input: [
            'input'
        ],
        selectIcon: [
            'selectIcon'
        ],
        menuItem: [
            'menuItem'
        ],
        displayedRows: [
            'displayedRows'
        ],
        actions: [
            'actions'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $f6b9903d0b727400$export$909e637b22246f4c), classes);
};
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */ const $e88806fdab3fc1ac$var$TablePagination = /*#__PURE__*/ $acw62.forwardRef(function TablePagination(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTablePagination'
    });
    const { ActionsComponent: ActionsComponent = (0, $274989d83c1a4bae$export$2e2bcd8739ae039), backIconButtonProps: backIconButtonProps, colSpan: colSpanProp, component: component = (0, $c63602040c542751$export$2e2bcd8739ae039), count: count, disabled: disabled = false, getItemAriaLabel: getItemAriaLabel = $e88806fdab3fc1ac$var$defaultGetAriaLabel, labelDisplayedRows: labelDisplayedRows = $e88806fdab3fc1ac$var$defaultLabelDisplayedRows, labelRowsPerPage: labelRowsPerPage = 'Rows per page:', nextIconButtonProps: nextIconButtonProps, onPageChange: onPageChange, onRowsPerPageChange: onRowsPerPageChange, page: page, rowsPerPage: rowsPerPage, rowsPerPageOptions: rowsPerPageOptions = [
        10,
        25,
        50,
        100
    ], SelectProps: SelectProps = {}, showFirstButton: showFirstButton = false, showLastButton: showLastButton = false, slotProps: slotProps = {}, slots: slots = {}, ...other } = props;
    const ownerState = props;
    const classes = $e88806fdab3fc1ac$var$useUtilityClasses(ownerState);
    const selectProps = slotProps?.select ?? SelectProps;
    const MenuItemComponent = selectProps.native ? 'option' : $e88806fdab3fc1ac$var$TablePaginationMenuItem;
    let colSpan;
    if (component === (0, $c63602040c542751$export$2e2bcd8739ae039) || component === 'td') colSpan = colSpanProp || 1000; // col-span over everything
    const selectId = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(selectProps.id);
    const labelId = (0, $51b2e046136200b6$export$2e2bcd8739ae039)(selectProps.labelId);
    const getLabelDisplayedRowsTo = ()=>{
        if (count === -1) return (page + 1) * rowsPerPage;
        return rowsPerPage === -1 ? count : Math.min(count, (page + 1) * rowsPerPage);
    };
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: classes.root,
        elementType: $e88806fdab3fc1ac$var$TablePaginationRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            component: component,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            colSpan: colSpan
        }
    });
    const [ToolbarSlot, toolbarSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('toolbar', {
        className: classes.toolbar,
        elementType: $e88806fdab3fc1ac$var$TablePaginationToolbar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SpacerSlot, spacerSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('spacer', {
        className: classes.spacer,
        elementType: $e88806fdab3fc1ac$var$TablePaginationSpacer,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [SelectLabelSlot, selectLabelSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('selectLabel', {
        className: classes.selectLabel,
        elementType: $e88806fdab3fc1ac$var$TablePaginationSelectLabel,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            id: labelId
        }
    });
    const [SelectSlot, selectSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('select', {
        className: classes.select,
        elementType: $e88806fdab3fc1ac$var$TablePaginationSelect,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [MenuItemSlot, menuItemSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('menuItem', {
        className: classes.menuItem,
        elementType: MenuItemComponent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [DisplayedRows, displayedRowsProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('displayedRows', {
        className: classes.displayedRows,
        elementType: $e88806fdab3fc1ac$var$TablePaginationDisplayedRows,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(ToolbarSlot, {
            ...toolbarSlotProps,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SpacerSlot, {
                    ...spacerSlotProps
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SelectLabelSlot, {
                    ...selectLabelSlotProps,
                    children: labelRowsPerPage
                }),
                rowsPerPageOptions.length > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SelectSlot, {
                    variant: "standard",
                    ...!selectProps.variant && {
                        input: $e88806fdab3fc1ac$var$_InputBase || ($e88806fdab3fc1ac$var$_InputBase = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), {}))
                    },
                    value: rowsPerPage,
                    onChange: onRowsPerPageChange,
                    id: selectId,
                    labelId: labelId,
                    ...selectProps,
                    classes: {
                        ...selectProps.classes,
                        // TODO v5 remove `classes.input`
                        root: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.input, classes.selectRoot, (selectProps.classes || {}).root),
                        select: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.select, (selectProps.classes || {}).select),
                        // TODO v5 remove `selectIcon`
                        icon: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.selectIcon, (selectProps.classes || {}).icon)
                    },
                    disabled: disabled,
                    ...selectSlotProps,
                    children: rowsPerPageOptions.map((rowsPerPageOption)=>/*#__PURE__*/ (0, $acw62.createElement)(MenuItemSlot, {
                            ...menuItemSlotProps,
                            key: rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption,
                            value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
                        }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(DisplayedRows, {
                    ...displayedRowsProps,
                    children: labelDisplayedRows({
                        from: count === 0 ? 0 : page * rowsPerPage + 1,
                        to: getLabelDisplayedRowsTo(),
                        count: count === -1 ? -1 : count,
                        page: page
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ActionsComponent, {
                    className: classes.actions,
                    backIconButtonProps: backIconButtonProps,
                    count: count,
                    nextIconButtonProps: nextIconButtonProps,
                    onPageChange: onPageChange,
                    page: page,
                    rowsPerPage: rowsPerPage,
                    showFirstButton: showFirstButton,
                    showLastButton: showLastButton,
                    slotProps: slotProps.actions,
                    slots: slots.actions,
                    getItemAriaLabel: getItemAriaLabel,
                    disabled: disabled
                })
            ]
        })
    });
});
var $e88806fdab3fc1ac$export$2e2bcd8739ae039 = $e88806fdab3fc1ac$var$TablePagination;








var $acw62 = parcelRequire("acw62");



function $e62dec54699515d7$export$9623ad5dc13f2eaa(value) {
    return String(parseFloat(value)).length === String(value).length;
}
function $e62dec54699515d7$export$65f2564e9a9b9222(input) {
    return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
}
function $e62dec54699515d7$export$8af1d214c6c2f0f1(length) {
    return parseFloat(length);
}
function $e62dec54699515d7$export$ea1536a749e80563(baseFontSize) {
    return (length, toUnit)=>{
        const fromUnit = $e62dec54699515d7$export$65f2564e9a9b9222(length);
        // Optimize for cases where `from` and `to` units are accidentally the same.
        if (fromUnit === toUnit) return length;
        // Convert input length to pixels.
        let pxLength = $e62dec54699515d7$export$8af1d214c6c2f0f1(length);
        if (fromUnit !== 'px') {
            if (fromUnit === 'em') pxLength = $e62dec54699515d7$export$8af1d214c6c2f0f1(length) * $e62dec54699515d7$export$8af1d214c6c2f0f1(baseFontSize);
            else if (fromUnit === 'rem') pxLength = $e62dec54699515d7$export$8af1d214c6c2f0f1(length) * $e62dec54699515d7$export$8af1d214c6c2f0f1(baseFontSize);
        }
        // Convert length in pixels to the output unit
        let outputLength = pxLength;
        if (toUnit !== 'px') {
            if (toUnit === 'em') outputLength = pxLength / $e62dec54699515d7$export$8af1d214c6c2f0f1(baseFontSize);
            else if (toUnit === 'rem') outputLength = pxLength / $e62dec54699515d7$export$8af1d214c6c2f0f1(baseFontSize);
            else return length;
        }
        return parseFloat(outputLength.toFixed(5)) + toUnit;
    };
}
function $e62dec54699515d7$export$aec9aaffd8096b21({ size: size, grid: grid }) {
    const sizeBelow = size - size % grid;
    const sizeAbove = sizeBelow + grid;
    return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
}
function $e62dec54699515d7$export$63653082df276400({ lineHeight: lineHeight, pixels: pixels, htmlFontSize: htmlFontSize }) {
    return pixels / (lineHeight * htmlFontSize);
}
function $e62dec54699515d7$export$26a139329f9dd721({ cssProperty: cssProperty, min: min, max: max, unit: unit = 'rem', breakpoints: breakpoints = [
    600,
    900,
    1200
], transform: transform = null }) {
    const output = {
        [cssProperty]: `${min}${unit}`
    };
    const factor = (max - min) / breakpoints[breakpoints.length - 1];
    breakpoints.forEach((breakpoint)=>{
        let value = min + factor * breakpoint;
        if (transform !== null) value = transform(value);
        output[`@media (min-width:${breakpoint}px)`] = {
            [cssProperty]: `${Math.round(value * 10000) / 10000}${unit}`
        };
    });
    return output;
}







function $b8c362dd35eec98c$export$c987db9fc844f86(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiSkeleton', slot);
}
const $b8c362dd35eec98c$var$skeletonClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiSkeleton', [
    'root',
    'text',
    'rectangular',
    'rounded',
    'circular',
    'pulse',
    'wave',
    'withChildren',
    'fitContent',
    'heightAuto'
]);
var $b8c362dd35eec98c$export$2e2bcd8739ae039 = $b8c362dd35eec98c$var$skeletonClasses;



'use client';
const $39a1b6ae48c4cf7c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, animation: animation, hasChildren: hasChildren, width: width, height: height } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            animation,
            hasChildren && 'withChildren',
            hasChildren && !width && 'fitContent',
            hasChildren && !height && 'heightAuto'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $b8c362dd35eec98c$export$c987db9fc844f86), classes);
};
const $39a1b6ae48c4cf7c$var$pulseKeyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`;
const $39a1b6ae48c4cf7c$var$waveKeyframe = (0, $63d46a01db878c10$export$d25ddfdf17c3ad3e)`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`;
// This implementation is for supporting both Styled-components v4+ and Pigment CSS.
// A global animation has to be created here for Styled-components v4+ (https://github.com/styled-components/styled-components/blob/main/packages/styled-components/src/utils/errors.md#12).
// which can be done by checking typeof indeterminate1Keyframe !== 'string' (at runtime, Pigment CSS transform keyframes`` to a string).
const $39a1b6ae48c4cf7c$var$pulseAnimation = typeof $39a1b6ae48c4cf7c$var$pulseKeyframe !== 'string' ? (0, $63d46a01db878c10$export$dbf350e5966cf602)`
        animation: ${$39a1b6ae48c4cf7c$var$pulseKeyframe} 2s ease-in-out 0.5s infinite;
      ` : null;
const $39a1b6ae48c4cf7c$var$waveAnimation = typeof $39a1b6ae48c4cf7c$var$waveKeyframe !== 'string' ? (0, $63d46a01db878c10$export$dbf350e5966cf602)`
        &::after {
          animation: ${$39a1b6ae48c4cf7c$var$waveKeyframe} 2s linear 0.5s infinite;
        }
      ` : null;
const $39a1b6ae48c4cf7c$var$SkeletonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiSkeleton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.animation !== false && styles[ownerState.animation],
            ownerState.hasChildren && styles.withChildren,
            ownerState.hasChildren && !ownerState.width && styles.fitContent,
            ownerState.hasChildren && !ownerState.height && styles.heightAuto
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const radiusUnit = (0, $e62dec54699515d7$export$65f2564e9a9b9222)(theme.shape.borderRadius) || 'px';
    const radiusValue = (0, $e62dec54699515d7$export$8af1d214c6c2f0f1)(theme.shape.borderRadius);
    return {
        display: 'block',
        // Create a "on paper" color with sufficient contrast retaining the color
        backgroundColor: theme.vars ? theme.vars.palette.Skeleton.bg : theme.alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
        height: '1.2em',
        variants: [
            {
                props: {
                    variant: 'text'
                },
                style: {
                    marginTop: 0,
                    marginBottom: 0,
                    height: 'auto',
                    transformOrigin: '0 55%',
                    transform: 'scale(1, 0.60)',
                    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
                    '&:empty:before': {
                        content: '"\\00a0"'
                    }
                }
            },
            {
                props: {
                    variant: 'circular'
                },
                style: {
                    borderRadius: '50%'
                }
            },
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren,
                style: {
                    '& > *': {
                        visibility: 'hidden'
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.width,
                style: {
                    maxWidth: 'fit-content'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.hasChildren && !ownerState.height,
                style: {
                    height: 'auto'
                }
            },
            {
                props: {
                    animation: 'pulse'
                },
                style: $39a1b6ae48c4cf7c$var$pulseAnimation || {
                    animation: `${$39a1b6ae48c4cf7c$var$pulseKeyframe} 2s ease-in-out 0.5s infinite`
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: {
                    position: 'relative',
                    overflow: 'hidden',
                    /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */ WebkitMaskImage: '-webkit-radial-gradient(white, black)',
                    '&::after': {
                        background: `linear-gradient(
                90deg,
                transparent,
                ${(theme.vars || theme).palette.action.hover},
                transparent
              )`,
                        content: '""',
                        position: 'absolute',
                        transform: 'translateX(-100%)' /* Avoid flash during server-side hydration */ ,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        top: 0
                    }
                }
            },
            {
                props: {
                    animation: 'wave'
                },
                style: $39a1b6ae48c4cf7c$var$waveAnimation || {
                    '&::after': {
                        animation: `${$39a1b6ae48c4cf7c$var$waveKeyframe} 2s linear 0.5s infinite`
                    }
                }
            }
        ]
    };
}));
const $39a1b6ae48c4cf7c$var$Skeleton = /*#__PURE__*/ $acw62.forwardRef(function Skeleton(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiSkeleton'
    });
    const { animation: animation = 'pulse', className: className, component: component = 'span', height: height, style: style, variant: variant = 'text', width: width, ...other } = props;
    const ownerState = {
        ...props,
        animation: animation,
        component: component,
        variant: variant,
        hasChildren: Boolean(other.children)
    };
    const classes = $39a1b6ae48c4cf7c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($39a1b6ae48c4cf7c$var$SkeletonRoot, {
        as: component,
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ...other,
        style: {
            width: width,
            height: height,
            ...style
        }
    });
});
var $39a1b6ae48c4cf7c$export$2e2bcd8739ae039 = $39a1b6ae48c4cf7c$var$Skeleton;



var $acw62 = parcelRequire("acw62");











function $84c81c1996222460$var$easeInOutSin(time) {
    return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}
function $84c81c1996222460$export$2e2bcd8739ae039(property, element, to, options = {}, cb = ()=>{}) {
    const { ease: ease = $84c81c1996222460$var$easeInOutSin, duration: duration = 300 // standard
     } = options;
    let start = null;
    const from = element[property];
    let cancelled = false;
    const cancel = ()=>{
        cancelled = true;
    };
    const step = (timestamp)=>{
        if (cancelled) {
            cb(new Error('Animation cancelled'));
            return;
        }
        if (start === null) start = timestamp;
        const time = Math.min(1, (timestamp - start) / duration);
        element[property] = ease(time) * (to - from) + from;
        if (time >= 1) {
            requestAnimationFrame(()=>{
                cb(null);
            });
            return;
        }
        requestAnimationFrame(step);
    };
    if (from === to) {
        cb(new Error('Element already at target position'));
        return cancel;
    }
    requestAnimationFrame(step);
    return cancel;
}



var $acw62 = parcelRequire("acw62");




'use client';
const $1dc918b66cbea078$var$styles = {
    width: 99,
    height: 99,
    position: 'absolute',
    top: -9999,
    overflow: 'scroll'
};
function $1dc918b66cbea078$export$2e2bcd8739ae039(props) {
    const { onChange: onChange, ...other } = props;
    const scrollbarHeight = $acw62.useRef();
    const nodeRef = $acw62.useRef(null);
    const setMeasurements = ()=>{
        scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
    };
    (0, $6d0031115bbee1bb$export$2e2bcd8739ae039)(()=>{
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            const prevHeight = scrollbarHeight.current;
            setMeasurements();
            if (prevHeight !== scrollbarHeight.current) onChange(scrollbarHeight.current);
        });
        const containerWindow = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(nodeRef.current);
        containerWindow.addEventListener('resize', handleResize);
        return ()=>{
            handleResize.clear();
            containerWindow.removeEventListener('resize', handleResize);
        };
    }, [
        onChange
    ]);
    $acw62.useEffect(()=>{
        setMeasurements();
        onChange(scrollbarHeight.current);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        style: $1dc918b66cbea078$var$styles,
        ...other,
        ref: nodeRef
    });
}



var $acw62 = parcelRequire("acw62");












function $78e5777b5eeee81f$export$34861783d3c2eef8(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTabScrollButton', slot);
}
const $78e5777b5eeee81f$var$tabScrollButtonClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTabScrollButton', [
    'root',
    'vertical',
    'horizontal',
    'disabled'
]);
var $78e5777b5eeee81f$export$2e2bcd8739ae039 = $78e5777b5eeee81f$var$tabScrollButtonClasses;



'use client';
const $dd89d34ceba12c96$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, orientation: orientation, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            orientation,
            disabled && 'disabled'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $78e5777b5eeee81f$export$34861783d3c2eef8), classes);
};
const $dd89d34ceba12c96$var$TabScrollButtonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiTabScrollButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.orientation && styles[ownerState.orientation]
        ];
    }
})({
    width: 40,
    flexShrink: 0,
    opacity: 0.8,
    [`&.${(0, $78e5777b5eeee81f$export$2e2bcd8739ae039).disabled}`]: {
        opacity: 0
    },
    variants: [
        {
            props: {
                orientation: 'vertical'
            },
            style: {
                width: '100%',
                height: 40,
                '& svg': {
                    transform: 'var(--TabScrollButton-svgRotate)'
                }
            }
        }
    ]
});
const $dd89d34ceba12c96$var$TabScrollButton = /*#__PURE__*/ $acw62.forwardRef(function TabScrollButton(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabScrollButton'
    });
    const { className: className, slots: slots = {}, slotProps: slotProps = {}, direction: direction, orientation: orientation, disabled: disabled, ...other } = props;
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const ownerState = {
        isRtl: isRtl,
        ...props
    };
    const classes = $dd89d34ceba12c96$var$useUtilityClasses(ownerState);
    const StartButtonIcon = slots.StartScrollButtonIcon ?? (0, $d997f00fcbb3883b$export$2e2bcd8739ae039);
    const EndButtonIcon = slots.EndScrollButtonIcon ?? (0, $d91db4839e2bc3bb$export$2e2bcd8739ae039);
    const startButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: StartButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    const endButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: EndButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        additionalProps: {
            fontSize: 'small'
        },
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($dd89d34ceba12c96$var$TabScrollButtonRoot, {
        component: "div",
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        role: null,
        ownerState: ownerState,
        tabIndex: null,
        ...other,
        style: {
            ...other.style,
            ...orientation === 'vertical' && {
                '--TabScrollButton-svgRotate': `rotate(${isRtl ? -90 : 90}deg)`
            }
        },
        children: direction === 'left' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(StartButtonIcon, {
            ...startButtonIconProps
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(EndButtonIcon, {
            ...endButtonIconProps
        })
    });
});
var $dd89d34ceba12c96$export$2e2bcd8739ae039 = $dd89d34ceba12c96$var$TabScrollButton;





function $499ba0703d8ef45f$export$cdd93bd054dec359(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTabs', slot);
}
const $499ba0703d8ef45f$var$tabsClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTabs', [
    'root',
    'vertical',
    'list',
    'flexContainer',
    'flexContainerVertical',
    'centered',
    'scroller',
    'fixed',
    'scrollableX',
    'scrollableY',
    'hideScrollbar',
    'scrollButtons',
    'scrollButtonsHideMobile',
    'indicator'
]);
var $499ba0703d8ef45f$export$2e2bcd8739ae039 = $499ba0703d8ef45f$var$tabsClasses;






'use client';
const $ade8931e75b51e59$var$nextItem = (list, item)=>{
    if (list === item) return list.firstChild;
    if (item && item.nextElementSibling) return item.nextElementSibling;
    return list.firstChild;
};
const $ade8931e75b51e59$var$previousItem = (list, item)=>{
    if (list === item) return list.lastChild;
    if (item && item.previousElementSibling) return item.previousElementSibling;
    return list.lastChild;
};
const $ade8931e75b51e59$var$moveFocus = (list, currentFocus, traversalFunction)=>{
    let wrappedOnce = false;
    let nextFocus = traversalFunction(list, currentFocus);
    while(nextFocus){
        // Prevent infinite loop.
        if (nextFocus === list.firstChild) {
            if (wrappedOnce) return;
            wrappedOnce = true;
        }
        // Same logic as useAutocomplete.js
        const nextFocusDisabled = nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
        if (!nextFocus.hasAttribute('tabindex') || nextFocusDisabled) // Move to the next element.
        nextFocus = traversalFunction(list, nextFocus);
        else {
            nextFocus.focus();
            return;
        }
    }
};
const $ade8931e75b51e59$var$useUtilityClasses = (ownerState)=>{
    const { vertical: vertical, fixed: fixed, hideScrollbar: hideScrollbar, scrollableX: scrollableX, scrollableY: scrollableY, centered: centered, scrollButtonsHideMobile: scrollButtonsHideMobile, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            vertical && 'vertical'
        ],
        scroller: [
            'scroller',
            fixed && 'fixed',
            hideScrollbar && 'hideScrollbar',
            scrollableX && 'scrollableX',
            scrollableY && 'scrollableY'
        ],
        list: [
            'list',
            'flexContainer',
            vertical && 'flexContainerVertical',
            vertical && 'vertical',
            centered && 'centered'
        ],
        indicator: [
            'indicator'
        ],
        scrollButtons: [
            'scrollButtons',
            scrollButtonsHideMobile && 'scrollButtonsHideMobile'
        ],
        scrollableX: [
            scrollableX && 'scrollableX'
        ],
        hideScrollbar: [
            hideScrollbar && 'hideScrollbar'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $499ba0703d8ef45f$export$cdd93bd054dec359), classes);
};
const $ade8931e75b51e59$var$TabsRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $499ba0703d8ef45f$export$2e2bcd8739ae039).scrollButtons}`]: styles.scrollButtons
            },
            {
                [`& .${(0, $499ba0703d8ef45f$export$2e2bcd8739ae039).scrollButtons}`]: ownerState.scrollButtonsHideMobile && styles.scrollButtonsHideMobile
            },
            styles.root,
            ownerState.vertical && styles.vertical
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        overflow: 'hidden',
        minHeight: 48,
        // Add iOS momentum scrolling for iOS < 13.0
        WebkitOverflowScrolling: 'touch',
        display: 'flex',
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.scrollButtonsHideMobile,
                style: {
                    [`& .${(0, $499ba0703d8ef45f$export$2e2bcd8739ae039).scrollButtons}`]: {
                        [theme.breakpoints.down('sm')]: {
                            display: 'none'
                        }
                    }
                }
            }
        ]
    })));
const $ade8931e75b51e59$var$TabsScroller = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'Scroller',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.scroller,
            ownerState.fixed && styles.fixed,
            ownerState.hideScrollbar && styles.hideScrollbar,
            ownerState.scrollableX && styles.scrollableX,
            ownerState.scrollableY && styles.scrollableY
        ];
    }
})({
    position: 'relative',
    display: 'inline-block',
    flex: '1 1 auto',
    whiteSpace: 'nowrap',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.fixed,
            style: {
                overflowX: 'hidden',
                width: '100%'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.hideScrollbar,
            style: {
                // Hide dimensionless scrollbar on macOS
                scrollbarWidth: 'none',
                // Firefox
                '&::-webkit-scrollbar': {
                    display: 'none' // Safari + Chrome
                }
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableX,
            style: {
                overflowX: 'auto',
                overflowY: 'hidden'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.scrollableY,
            style: {
                overflowY: 'auto',
                overflowX: 'hidden'
            }
        }
    ]
});
const $ade8931e75b51e59$var$List = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTabs',
    slot: 'List',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.list,
            styles.flexContainer,
            ownerState.vertical && styles.flexContainerVertical,
            ownerState.centered && styles.centered
        ];
    }
})({
    display: 'flex',
    variants: [
        {
            props: ({ ownerState: ownerState })=>ownerState.vertical,
            style: {
                flexDirection: 'column'
            }
        },
        {
            props: ({ ownerState: ownerState })=>ownerState.centered,
            style: {
                justifyContent: 'center'
            }
        }
    ]
});
const $ade8931e75b51e59$var$TabsIndicator = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiTabs',
    slot: 'Indicator'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'absolute',
        height: 2,
        bottom: 0,
        width: '100%',
        transition: theme.transitions.create(),
        variants: [
            {
                props: {
                    indicatorColor: 'primary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.primary.main
                }
            },
            {
                props: {
                    indicatorColor: 'secondary'
                },
                style: {
                    backgroundColor: (theme.vars || theme).palette.secondary.main
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.vertical,
                style: {
                    height: '100%',
                    width: 2,
                    right: 0
                }
            }
        ]
    })));
const $ade8931e75b51e59$var$TabsScrollbarSize = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $1dc918b66cbea078$export$2e2bcd8739ae039))({
    overflowX: 'auto',
    overflowY: 'hidden',
    // Hide dimensionless scrollbar on macOS
    scrollbarWidth: 'none',
    // Firefox
    '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome
    }
});
const $ade8931e75b51e59$var$defaultIndicatorStyle = {};
let $ade8931e75b51e59$var$warnedOnceTabPresent = false;
const $ade8931e75b51e59$var$Tabs = /*#__PURE__*/ $acw62.forwardRef(function Tabs(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTabs'
    });
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const isRtl = (0, $3bcebab40d8ce666$export$b2dd014b6c321cb)();
    const { 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, action: action, centered: centered = false, children: childrenProp, className: className, component: component = 'div', allowScrollButtonsMobile: allowScrollButtonsMobile = false, indicatorColor: indicatorColor = 'primary', onChange: onChange, orientation: orientation = 'horizontal', ScrollButtonComponent: ScrollButtonComponent, scrollButtons: // TODO: remove in v7 (deprecated in v6)
    scrollButtons = 'auto', selectionFollowsFocus: selectionFollowsFocus, slots: slots = {}, slotProps: slotProps = {}, TabIndicatorProps: TabIndicatorProps = {}, TabScrollButtonProps: // TODO: remove in v7 (deprecated in v6)
    TabScrollButtonProps = {}, textColor: // TODO: remove in v7 (deprecated in v6)
    textColor = 'primary', value: value, variant: variant = 'standard', visibleScrollbar: visibleScrollbar = false, ...other } = props;
    const scrollable = variant === 'scrollable';
    const vertical = orientation === 'vertical';
    const scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
    const start = vertical ? 'top' : 'left';
    const end = vertical ? 'bottom' : 'right';
    const clientSize = vertical ? 'clientHeight' : 'clientWidth';
    const size = vertical ? 'height' : 'width';
    const ownerState = {
        ...props,
        component: component,
        allowScrollButtonsMobile: allowScrollButtonsMobile,
        indicatorColor: indicatorColor,
        orientation: orientation,
        vertical: vertical,
        scrollButtons: scrollButtons,
        textColor: textColor,
        variant: variant,
        visibleScrollbar: visibleScrollbar,
        fixed: !scrollable,
        hideScrollbar: scrollable && !visibleScrollbar,
        scrollableX: scrollable && !vertical,
        scrollableY: scrollable && vertical,
        centered: centered && !scrollable,
        scrollButtonsHideMobile: !allowScrollButtonsMobile
    };
    const classes = $ade8931e75b51e59$var$useUtilityClasses(ownerState);
    const startScrollButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.StartScrollButtonIcon,
        externalSlotProps: slotProps.startScrollButtonIcon,
        ownerState: ownerState
    });
    const endScrollButtonIconProps = (0, $aa69d7725f45330b$export$2e2bcd8739ae039)({
        elementType: slots.EndScrollButtonIcon,
        externalSlotProps: slotProps.endScrollButtonIcon,
        ownerState: ownerState
    });
    const [mounted, setMounted] = $acw62.useState(false);
    const [indicatorStyle, setIndicatorStyle] = $acw62.useState($ade8931e75b51e59$var$defaultIndicatorStyle);
    const [displayStartScroll, setDisplayStartScroll] = $acw62.useState(false);
    const [displayEndScroll, setDisplayEndScroll] = $acw62.useState(false);
    const [updateScrollObserver, setUpdateScrollObserver] = $acw62.useState(false);
    const [scrollerStyle, setScrollerStyle] = $acw62.useState({
        overflow: 'hidden',
        scrollbarWidth: 0
    });
    const valueToIndex = new Map();
    const tabsRef = $acw62.useRef(null);
    const tabListRef = $acw62.useRef(null);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            indicator: TabIndicatorProps,
            scrollButton: TabScrollButtonProps,
            ...slotProps
        }
    };
    const getTabsMeta = ()=>{
        const tabsNode = tabsRef.current;
        let tabsMeta;
        if (tabsNode) {
            const rect = tabsNode.getBoundingClientRect();
            // create a new object with ClientRect class props + scrollLeft
            tabsMeta = {
                clientWidth: tabsNode.clientWidth,
                scrollLeft: tabsNode.scrollLeft,
                scrollTop: tabsNode.scrollTop,
                scrollWidth: tabsNode.scrollWidth,
                top: rect.top,
                bottom: rect.bottom,
                left: rect.left,
                right: rect.right
            };
        }
        let tabMeta;
        if (tabsNode && value !== false) {
            const children = tabListRef.current.children;
            if (children.length > 0) {
                const tab = children[valueToIndex.get(value)];
                tabMeta = tab ? tab.getBoundingClientRect() : null;
            }
        }
        return {
            tabsMeta: tabsMeta,
            tabMeta: tabMeta
        };
    };
    const updateIndicatorState = (0, $52726edc538865d0$export$2e2bcd8739ae039)(()=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        let startValue = 0;
        let startIndicator;
        if (vertical) {
            startIndicator = 'top';
            if (tabMeta && tabsMeta) startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
        } else {
            startIndicator = isRtl ? 'right' : 'left';
            if (tabMeta && tabsMeta) startValue = (isRtl ? -1 : 1) * (tabMeta[startIndicator] - tabsMeta[startIndicator] + tabsMeta.scrollLeft);
        }
        const newIndicatorStyle = {
            [startIndicator]: startValue,
            // May be wrong until the font is loaded.
            [size]: tabMeta ? tabMeta[size] : 0
        };
        if (typeof indicatorStyle[startIndicator] !== 'number' || typeof indicatorStyle[size] !== 'number') setIndicatorStyle(newIndicatorStyle);
        else {
            const dStart = Math.abs(indicatorStyle[startIndicator] - newIndicatorStyle[startIndicator]);
            const dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
            if (dStart >= 1 || dSize >= 1) setIndicatorStyle(newIndicatorStyle);
        }
    });
    const scroll = (scrollValue, { animation: animation = true } = {})=>{
        if (animation) (0, $84c81c1996222460$export$2e2bcd8739ae039)(scrollStart, tabsRef.current, scrollValue, {
            duration: theme.transitions.duration.standard
        });
        else tabsRef.current[scrollStart] = scrollValue;
    };
    const moveTabsScroll = (delta)=>{
        let scrollValue = tabsRef.current[scrollStart];
        if (vertical) scrollValue += delta;
        else scrollValue += delta * (isRtl ? -1 : 1);
        scroll(scrollValue);
    };
    const getScrollSize = ()=>{
        const containerSize = tabsRef.current[clientSize];
        let totalSize = 0;
        const children = Array.from(tabListRef.current.children);
        for(let i = 0; i < children.length; i += 1){
            const tab = children[i];
            if (totalSize + tab[clientSize] > containerSize) {
                // If the first item is longer than the container size, then only scroll
                // by the container size.
                if (i === 0) totalSize = containerSize;
                break;
            }
            totalSize += tab[clientSize];
        }
        return totalSize;
    };
    const handleStartScrollClick = ()=>{
        moveTabsScroll(-1 * getScrollSize());
    };
    const handleEndScrollClick = ()=>{
        moveTabsScroll(getScrollSize());
    };
    const [ScrollbarSlot, { onChange: scrollbarOnChange, ...scrollbarSlotProps }] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('scrollbar', {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.scrollableX, classes.hideScrollbar),
        elementType: $ade8931e75b51e59$var$TabsScrollbarSize,
        shouldForwardComponentProp: true,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    // TODO Remove <ScrollbarSize /> as browser support for hiding the scrollbar
    // with CSS improves.
    const handleScrollbarSizeChange = $acw62.useCallback((scrollbarWidth)=>{
        scrollbarOnChange?.(scrollbarWidth);
        setScrollerStyle({
            overflow: null,
            scrollbarWidth: scrollbarWidth
        });
    }, [
        scrollbarOnChange
    ]);
    const [ScrollButtonsSlot, scrollButtonSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('scrollButtons', {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.scrollButtons, TabScrollButtonProps.className),
        elementType: (0, $dd89d34ceba12c96$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            orientation: orientation,
            slots: {
                StartScrollButtonIcon: slots.startScrollButtonIcon || slots.StartScrollButtonIcon,
                EndScrollButtonIcon: slots.endScrollButtonIcon || slots.EndScrollButtonIcon
            },
            slotProps: {
                startScrollButtonIcon: startScrollButtonIconProps,
                endScrollButtonIcon: endScrollButtonIconProps
            }
        }
    });
    const getConditionalElements = ()=>{
        const conditionalElements = {};
        conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ScrollbarSlot, {
            ...scrollbarSlotProps,
            onChange: handleScrollbarSizeChange
        }) : null;
        const scrollButtonsActive = displayStartScroll || displayEndScroll;
        const showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === true);
        conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'right' : 'left',
            onClick: handleStartScrollClick,
            disabled: !displayStartScroll,
            ...scrollButtonSlotProps
        }) : null;
        conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ScrollButtonsSlot, {
            direction: isRtl ? 'left' : 'right',
            onClick: handleEndScrollClick,
            disabled: !displayEndScroll,
            ...scrollButtonSlotProps
        }) : null;
        return conditionalElements;
    };
    const scrollSelectedIntoView = (0, $52726edc538865d0$export$2e2bcd8739ae039)((animation)=>{
        const { tabsMeta: tabsMeta, tabMeta: tabMeta } = getTabsMeta();
        if (!tabMeta || !tabsMeta) return;
        if (tabMeta[start] < tabsMeta[start]) {
            // left side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
            scroll(nextScrollStart, {
                animation: animation
            });
        } else if (tabMeta[end] > tabsMeta[end]) {
            // right side of button is out of view
            const nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
            scroll(nextScrollStart, {
                animation: animation
            });
        }
    });
    const updateScrollButtonState = (0, $52726edc538865d0$export$2e2bcd8739ae039)(()=>{
        if (scrollable && scrollButtons !== false) setUpdateScrollObserver(!updateScrollObserver);
    });
    $acw62.useEffect(()=>{
        const handleResize = (0, $83167607eb9ed060$export$2e2bcd8739ae039)(()=>{
            // If the Tabs component is replaced by Suspense with a fallback, the last
            // ResizeObserver's handler that runs because of the change in the layout is trying to
            // access a dom node that is no longer there (as the fallback component is being shown instead).
            // See https://github.com/mui/material-ui/issues/33276
            // TODO: Add tests that will ensure the component is not failing when
            // replaced by Suspense with a fallback, once React is updated to version 18
            if (tabsRef.current) updateIndicatorState();
        });
        let resizeObserver;
        /**
     * @type {MutationCallback}
     */ const handleMutation = (records)=>{
            records.forEach((record)=>{
                record.removedNodes.forEach((item)=>{
                    resizeObserver?.unobserve(item);
                });
                record.addedNodes.forEach((item)=>{
                    resizeObserver?.observe(item);
                });
            });
            handleResize();
            updateScrollButtonState();
        };
        const win = (0, $85795f3c4e07aecf$export$2e2bcd8739ae039)(tabsRef.current);
        win.addEventListener('resize', handleResize);
        let mutationObserver;
        if (typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(handleResize);
            Array.from(tabListRef.current.children).forEach((child)=>{
                resizeObserver.observe(child);
            });
        }
        if (typeof MutationObserver !== 'undefined') {
            mutationObserver = new MutationObserver(handleMutation);
            mutationObserver.observe(tabListRef.current, {
                childList: true
            });
        }
        return ()=>{
            handleResize.clear();
            win.removeEventListener('resize', handleResize);
            mutationObserver?.disconnect();
            resizeObserver?.disconnect();
        };
    }, [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    /**
   * Toggle visibility of start and end scroll buttons
   * Using IntersectionObserver on first and last Tabs.
   */ $acw62.useEffect(()=>{
        const tabListChildren = Array.from(tabListRef.current.children);
        const length = tabListChildren.length;
        if (typeof IntersectionObserver !== 'undefined' && length > 0 && scrollable && scrollButtons !== false) {
            const firstTab = tabListChildren[0];
            const lastTab = tabListChildren[length - 1];
            const observerOptions = {
                root: tabsRef.current,
                threshold: 0.99
            };
            const handleScrollButtonStart = (entries)=>{
                setDisplayStartScroll(!entries[0].isIntersecting);
            };
            const firstObserver = new IntersectionObserver(handleScrollButtonStart, observerOptions);
            firstObserver.observe(firstTab);
            const handleScrollButtonEnd = (entries)=>{
                setDisplayEndScroll(!entries[0].isIntersecting);
            };
            const lastObserver = new IntersectionObserver(handleScrollButtonEnd, observerOptions);
            lastObserver.observe(lastTab);
            return ()=>{
                firstObserver.disconnect();
                lastObserver.disconnect();
            };
        }
        return undefined;
    }, [
        scrollable,
        scrollButtons,
        updateScrollObserver,
        childrenProp?.length
    ]);
    $acw62.useEffect(()=>{
        setMounted(true);
    }, []);
    $acw62.useEffect(()=>{
        updateIndicatorState();
    });
    $acw62.useEffect(()=>{
        // Don't animate on the first render.
        scrollSelectedIntoView($ade8931e75b51e59$var$defaultIndicatorStyle !== indicatorStyle);
    }, [
        scrollSelectedIntoView,
        indicatorStyle
    ]);
    $acw62.useImperativeHandle(action, ()=>({
            updateIndicator: updateIndicatorState,
            updateScrollButtons: updateScrollButtonState
        }), [
        updateIndicatorState,
        updateScrollButtonState
    ]);
    const [IndicatorSlot, indicatorSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('indicator', {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.indicator, TabIndicatorProps.className),
        elementType: $ade8931e75b51e59$var$TabsIndicator,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: indicatorStyle
        }
    });
    const indicator = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(IndicatorSlot, {
        ...indicatorSlotProps
    });
    let childIndex = 0;
    const children = $acw62.Children.map(childrenProp, (child)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(child)) return null;
        const childValue = child.props.value === undefined ? childIndex : child.props.value;
        valueToIndex.set(childValue, childIndex);
        const selected = childValue === value;
        childIndex += 1;
        return /*#__PURE__*/ $acw62.cloneElement(child, {
            fullWidth: variant === 'fullWidth',
            indicator: selected && !mounted && indicator,
            selected: selected,
            selectionFollowsFocus: selectionFollowsFocus,
            onChange: onChange,
            textColor: textColor,
            value: childValue,
            ...childIndex === 1 && value === false && !child.props.tabIndex ? {
                tabIndex: 0
            } : {}
        });
    });
    const handleKeyDown = (event)=>{
        // Check if a modifier key (Alt, Shift, Ctrl, Meta) is pressed
        if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
        const list = tabListRef.current;
        const currentFocus = (0, $8fe7cdb8f9cbdf1f$export$2e2bcd8739ae039)(list).activeElement;
        // Keyboard navigation assumes that [role="tab"] are siblings
        // though we might warn in the future about nested, interactive elements
        // as a a11y violation
        const role = currentFocus.getAttribute('role');
        if (role !== 'tab') return;
        let previousItemKey = orientation === 'horizontal' ? 'ArrowLeft' : 'ArrowUp';
        let nextItemKey = orientation === 'horizontal' ? 'ArrowRight' : 'ArrowDown';
        if (orientation === 'horizontal' && isRtl) {
            // swap previousItemKey with nextItemKey
            previousItemKey = 'ArrowRight';
            nextItemKey = 'ArrowLeft';
        }
        switch(event.key){
            case previousItemKey:
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, currentFocus, $ade8931e75b51e59$var$previousItem);
                break;
            case nextItemKey:
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, currentFocus, $ade8931e75b51e59$var$nextItem);
                break;
            case 'Home':
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, null, $ade8931e75b51e59$var$nextItem);
                break;
            case 'End':
                event.preventDefault();
                $ade8931e75b51e59$var$moveFocus(list, null, $ade8931e75b51e59$var$previousItem);
                break;
            default:
                break;
        }
    };
    const conditionalElements = getConditionalElements();
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $ade8931e75b51e59$var$TabsRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [ScrollerSlot, scrollerSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('scroller', {
        ref: tabsRef,
        className: classes.scroller,
        elementType: $ade8931e75b51e59$var$TabsScroller,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            style: {
                overflow: scrollerStyle.overflow,
                [vertical ? `margin${isRtl ? 'Left' : 'Right'}` : 'marginBottom']: visibleScrollbar ? undefined : -scrollerStyle.scrollbarWidth
            }
        }
    });
    const [ListSlot, listSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('list', {
        ref: tabListRef,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.list, classes.flexContainer),
        elementType: $ade8931e75b51e59$var$List,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        getSlotProps: (handlers)=>({
                ...handlers,
                onKeyDown: (event)=>{
                    handleKeyDown(event);
                    handlers.onKeyDown?.(event);
                }
            })
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            conditionalElements.scrollButtonStart,
            conditionalElements.scrollbarSizeListener,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(ScrollerSlot, {
                ...scrollerSlotProps,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ListSlot, {
                        "aria-label": ariaLabel,
                        "aria-labelledby": ariaLabelledBy,
                        "aria-orientation": orientation === 'vertical' ? 'vertical' : null,
                        role: "tablist",
                        ...listSlotProps,
                        children: children
                    }),
                    mounted && indicator
                ]
            }),
            conditionalElements.scrollButtonEnd
        ]
    });
});
var $ade8931e75b51e59$export$2e2bcd8739ae039 = $ade8931e75b51e59$var$Tabs;



var $acw62 = parcelRequire("acw62");











function $b390f03b616903a9$export$72aef224d6115253(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTab', slot);
}
const $b390f03b616903a9$var$tabClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTab', [
    'root',
    'labelIcon',
    'textColorInherit',
    'textColorPrimary',
    'textColorSecondary',
    'selected',
    'disabled',
    'fullWidth',
    'wrapped',
    'iconWrapper',
    'icon'
]);
var $b390f03b616903a9$export$2e2bcd8739ae039 = $b390f03b616903a9$var$tabClasses;



'use client';
const $c1f657281bee3142$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, textColor: textColor, fullWidth: fullWidth, wrapped: wrapped, icon: icon, label: label, selected: selected, disabled: disabled } = ownerState;
    const slots = {
        root: [
            'root',
            icon && label && 'labelIcon',
            `textColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(textColor)}`,
            fullWidth && 'fullWidth',
            wrapped && 'wrapped',
            selected && 'selected',
            disabled && 'disabled'
        ],
        icon: [
            'iconWrapper',
            'icon'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $b390f03b616903a9$export$72aef224d6115253), classes);
};
const $c1f657281bee3142$var$TabRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiTab',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.label && ownerState.icon && styles.labelIcon,
            styles[`textColor${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.textColor)}`],
            ownerState.fullWidth && styles.fullWidth,
            ownerState.wrapped && styles.wrapped,
            {
                [`& .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).iconWrapper}`]: styles.iconWrapper
            },
            {
                [`& .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: styles.icon
            }
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.button,
        maxWidth: 360,
        minWidth: 90,
        position: 'relative',
        minHeight: 48,
        flexShrink: 0,
        padding: '12px 16px',
        overflow: 'hidden',
        whiteSpace: 'normal',
        textAlign: 'center',
        lineHeight: 1.25,
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.label && (ownerState.iconPosition === 'top' || ownerState.iconPosition === 'bottom'),
                style: {
                    flexDirection: 'column'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.label && ownerState.iconPosition !== 'top' && ownerState.iconPosition !== 'bottom',
                style: {
                    flexDirection: 'row'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.icon && ownerState.label,
                style: {
                    minHeight: 72,
                    paddingTop: 9,
                    paddingBottom: 9
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'top',
                style: {
                    [`& > .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: {
                        marginBottom: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'bottom',
                style: {
                    [`& > .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: {
                        marginTop: 6
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'start',
                style: {
                    [`& > .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: {
                        marginRight: theme.spacing(1)
                    }
                }
            },
            {
                props: ({ ownerState: ownerState, iconPosition: iconPosition })=>ownerState.icon && ownerState.label && iconPosition === 'end',
                style: {
                    [`& > .${(0, $b390f03b616903a9$export$2e2bcd8739ae039).icon}`]: {
                        marginLeft: theme.spacing(1)
                    }
                }
            },
            {
                props: {
                    textColor: 'inherit'
                },
                style: {
                    color: 'inherit',
                    opacity: 0.6,
                    // same opacity as theme.palette.text.secondary
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).selected}`]: {
                        opacity: 1
                    },
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).disabled}`]: {
                        opacity: (theme.vars || theme).palette.action.disabledOpacity
                    }
                }
            },
            {
                props: {
                    textColor: 'primary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.primary.main
                    },
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: {
                    textColor: 'secondary'
                },
                style: {
                    color: (theme.vars || theme).palette.text.secondary,
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.secondary.main
                    },
                    [`&.${(0, $b390f03b616903a9$export$2e2bcd8739ae039).disabled}`]: {
                        color: (theme.vars || theme).palette.text.disabled
                    }
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.fullWidth,
                style: {
                    flexShrink: 1,
                    flexGrow: 1,
                    flexBasis: 0,
                    maxWidth: 'none'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.wrapped,
                style: {
                    fontSize: theme.typography.pxToRem(12)
                }
            }
        ]
    })));
const $c1f657281bee3142$var$Tab = /*#__PURE__*/ $acw62.forwardRef(function Tab(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTab'
    });
    const { className: className, disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: // eslint-disable-next-line react/prop-types
    fullWidth, icon: iconProp, iconPosition: iconPosition = 'top', indicator: // eslint-disable-next-line react/prop-types
    indicator, label: label, onChange: onChange, onClick: onClick, onFocus: onFocus, selected: // eslint-disable-next-line react/prop-types
    selected, selectionFollowsFocus: // eslint-disable-next-line react/prop-types
    selectionFollowsFocus, textColor: // eslint-disable-next-line react/prop-types
    textColor = 'inherit', value: value, wrapped: wrapped = false, ...other } = props;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        selected: selected,
        icon: !!iconProp,
        iconPosition: iconPosition,
        label: !!label,
        fullWidth: fullWidth,
        textColor: textColor,
        wrapped: wrapped
    };
    const classes = $c1f657281bee3142$var$useUtilityClasses(ownerState);
    const icon = iconProp && label && /*#__PURE__*/ $acw62.isValidElement(iconProp) ? /*#__PURE__*/ $acw62.cloneElement(iconProp, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.icon, iconProp.props.className)
    }) : iconProp;
    const handleClick = (event)=>{
        if (!selected && onChange) onChange(event, value);
        if (onClick) onClick(event);
    };
    const handleFocus = (event)=>{
        if (selectionFollowsFocus && !selected && onChange) onChange(event, value);
        if (onFocus) onFocus(event);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c1f657281bee3142$var$TabRoot, {
        focusRipple: !disableFocusRipple,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        role: "tab",
        "aria-selected": selected,
        disabled: disabled,
        onClick: handleClick,
        onFocus: handleFocus,
        ownerState: ownerState,
        tabIndex: selected ? 0 : -1,
        ...other,
        children: [
            iconPosition === 'top' || iconPosition === 'start' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    icon,
                    label
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    label,
                    icon
                ]
            }),
            indicator
        ]
    });
});
var $c1f657281bee3142$export$2e2bcd8739ae039 = $c1f657281bee3142$var$Tab;



var $acw62 = parcelRequire("acw62");












function $bc173f8dae20385f$export$21f89b560b65a301(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiToggleButton', slot);
}
const $bc173f8dae20385f$var$toggleButtonClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiToggleButton', [
    'root',
    'disabled',
    'selected',
    'standard',
    'primary',
    'secondary',
    'sizeSmall',
    'sizeMedium',
    'sizeLarge',
    'fullWidth'
]);
var $bc173f8dae20385f$export$2e2bcd8739ae039 = $bc173f8dae20385f$var$toggleButtonClasses;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $54f954c286d90c50$var$ToggleButtonGroupContext = /*#__PURE__*/ $acw62.createContext({});
var $54f954c286d90c50$export$2e2bcd8739ae039 = $54f954c286d90c50$var$ToggleButtonGroupContext;



var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $723c26d281bdc124$var$ToggleButtonGroupButtonContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $723c26d281bdc124$export$2e2bcd8739ae039 = $723c26d281bdc124$var$ToggleButtonGroupButtonContext;


// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function $15b205bf5e066562$export$2e2bcd8739ae039(value, candidate) {
    if (candidate === undefined || value === undefined) return false;
    if (Array.isArray(candidate)) return candidate.includes(value);
    return value === candidate;
}



'use client';
const $654477ebc3cb437e$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, fullWidth: fullWidth, selected: selected, disabled: disabled, size: size, color: color } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            disabled && 'disabled',
            fullWidth && 'fullWidth',
            `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`,
            color
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $bc173f8dae20385f$export$21f89b560b65a301), classes);
};
const $654477ebc3cb437e$var$ToggleButtonRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiToggleButton',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        ...theme.typography.button,
        borderRadius: (theme.vars || theme).shape.borderRadius,
        padding: 11,
        border: `1px solid ${(theme.vars || theme).palette.divider}`,
        color: (theme.vars || theme).palette.action.active,
        [`&.${(0, $bc173f8dae20385f$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled,
            border: `1px solid ${(theme.vars || theme).palette.action.disabledBackground}`
        },
        '&:hover': {
            textDecoration: 'none',
            // Reset on mouse devices
            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.hoverOpacity),
            '@media (hover: none)': {
                backgroundColor: 'transparent'
            }
        },
        variants: [
            {
                props: {
                    color: 'standard'
                },
                style: {
                    [`&.${(0, $bc173f8dae20385f$export$2e2bcd8739ae039).selected}`]: {
                        color: (theme.vars || theme).palette.text.primary,
                        backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity),
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                            // Reset on touch devices, it doesn't add specificity
                            '@media (hover: none)': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette.text.primary, (theme.vars || theme).palette.action.selectedOpacity)
                            }
                        }
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color
                    },
                    style: {
                        [`&.${(0, $bc173f8dae20385f$export$2e2bcd8739ae039).selected}`]: {
                            color: (theme.vars || theme).palette[color].main,
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity),
                            '&:hover': {
                                backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`),
                                // Reset on touch devices, it doesn't add specificity
                                '@media (hover: none)': {
                                    backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.selectedOpacity)
                                }
                            }
                        }
                    }
                })),
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            },
            {
                props: {
                    size: 'small'
                },
                style: {
                    padding: 7,
                    fontSize: theme.typography.pxToRem(13)
                }
            },
            {
                props: {
                    size: 'large'
                },
                style: {
                    padding: 15,
                    fontSize: theme.typography.pxToRem(15)
                }
            }
        ]
    })));
const $654477ebc3cb437e$var$ToggleButton = /*#__PURE__*/ $acw62.forwardRef(function ToggleButton(inProps, ref) {
    // props priority: `inProps` > `contextProps` > `themeDefaultProps`
    const { value: contextValue, ...contextProps } = $acw62.useContext((0, $54f954c286d90c50$export$2e2bcd8739ae039));
    const toggleButtonGroupButtonContextPositionClassName = $acw62.useContext((0, $723c26d281bdc124$export$2e2bcd8739ae039));
    const resolvedProps = (0, $367acbd429e20ec9$export$2e2bcd8739ae039)({
        ...contextProps,
        selected: (0, $15b205bf5e066562$export$2e2bcd8739ae039)(inProps.value, contextValue)
    }, inProps);
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: resolvedProps,
        name: 'MuiToggleButton'
    });
    const { children: children, className: className, color: color = 'standard', disabled: disabled = false, disableFocusRipple: disableFocusRipple = false, fullWidth: fullWidth = false, onChange: onChange, onClick: onClick, selected: selected, size: size = 'medium', value: value, ...other } = props;
    const ownerState = {
        ...props,
        color: color,
        disabled: disabled,
        disableFocusRipple: disableFocusRipple,
        fullWidth: fullWidth,
        size: size
    };
    const classes = $654477ebc3cb437e$var$useUtilityClasses(ownerState);
    const handleChange = (event)=>{
        if (onClick) {
            onClick(event, value);
            if (event.defaultPrevented) return;
        }
        if (onChange) onChange(event, value);
    };
    const positionClassName = toggleButtonGroupButtonContextPositionClassName || '';
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($654477ebc3cb437e$var$ToggleButtonRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(contextProps.className, classes.root, className, positionClassName),
        disabled: disabled,
        focusRipple: !disableFocusRipple,
        ref: ref,
        onClick: handleChange,
        onChange: onChange,
        value: value,
        ownerState: ownerState,
        "aria-pressed": selected,
        ...other,
        children: children
    });
});
var $654477ebc3cb437e$export$2e2bcd8739ae039 = $654477ebc3cb437e$var$ToggleButton;




parcelRequire("acw62");

const $7c2407cf63ad64a5$export$b3135a5ec3d4881c = (0, $2f130330883526cb$export$2e2bcd8739ae039);



const $585ee0b8d948e38e$export$6de472a3df735882 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
}), 'ArrowUpward');
const $585ee0b8d948e38e$export$1f2d4db4a79871d4 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');
const $585ee0b8d948e38e$export$8da6370d9999894a = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"
}), 'KeyboardArrowRight');
const $585ee0b8d948e38e$export$5b6f85a3ddabf4ca = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');
const $585ee0b8d948e38e$export$cb1a577169e125de = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
}), 'FilterList');
const $585ee0b8d948e38e$export$4f4f59585ffe8deb = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61z"
}), 'FilterAlt');
const $585ee0b8d948e38e$export$d33e6ad54b379a5d = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');
const $585ee0b8d948e38e$export$3c3b03774b2ed8ce = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');
const $585ee0b8d948e38e$export$7a7700ab3e9c7e95 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');
const $585ee0b8d948e38e$export$10a5a2f68ff67c50 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M14.67 5v14H9.33V5zm1 14H21V5h-5.33zm-7.34 0V5H3v14z"
}), 'ColumnIcon');
const $585ee0b8d948e38e$export$e918bd395b324de6 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
    width: "1",
    height: "24",
    x: "11.5",
    rx: "0.5"
}), 'Separator');
const $585ee0b8d948e38e$export$3bcf566f7053b242 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
}), 'ViewHeadline');
const $585ee0b8d948e38e$export$adcade5d1a52a335 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M21,8H3V4h18V8z M21,10H3v4h18V10z M21,16H3v4h18V16z"
}), 'TableRows');
const $585ee0b8d948e38e$export$60a4c153d2d7b084 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
}), 'ViewStream');
const $585ee0b8d948e38e$export$2fbf0de7557957a8 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'TripleDotsVertical');
const $585ee0b8d948e38e$export$cbefef3cfb8e2783 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');
const $585ee0b8d948e38e$export$e483c1441c7fca0b = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');
const $585ee0b8d948e38e$export$d8fa92cc66e4dec8 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 13H5v-2h14v2z"
}), 'Remove');
const $585ee0b8d948e38e$export$52992a9d5fa53c3c = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Load');
const $585ee0b8d948e38e$export$305773dd821bb81d = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'Drag');
const $585ee0b8d948e38e$export$1f9ec58b2f66f46d = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
}), 'Check');
const $585ee0b8d948e38e$export$6eaba7fcfbaac527 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreVert');
const $585ee0b8d948e38e$export$9267feb6a6149971 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
}), 'VisibilityOff');
const $585ee0b8d948e38e$export$109d60d29e96616d = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
        d: "M14.67,5v14H9.33V5H14.67z M15.67,19H21V5h-5.33V19z M8.33,19V5H3v14H8.33z"
    })
}), 'ViewColumn');
const $585ee0b8d948e38e$export$ab03f96923842ba7 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z"
}), 'Clear');
const $585ee0b8d948e38e$export$4830297c7288dee4 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $585ee0b8d948e38e$export$fc6ef585bd0ee189 = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');
const $585ee0b8d948e38e$export$6eaed8bd7158657a = (0, $7c2407cf63ad64a5$export$b3135a5ec3d4881c)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');





var $acw62 = parcelRequire("acw62");


const $8e57892bb82e0017$var$_excluded = [
    "sortingOrder"
];
const $8e57892bb82e0017$export$9e3e7f6bf3b8c7a7 = /*#__PURE__*/ $acw62.memo(function GridColumnHeaderSortIcon(props) {
    const { sortingOrder: sortingOrder } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $8e57892bb82e0017$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const [nextSortDirection] = sortingOrder;
    const Icon = nextSortDirection === 'asc' ? rootProps.slots.columnSortedAscendingIcon : rootProps.slots.columnSortedDescendingIcon;
    return Icon ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(Icon, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other)) : null;
});







const $d0e3a07ac9c4618d$var$_excluded = [
    "id",
    "label",
    "labelId",
    "material",
    "disabled",
    "slotProps",
    "onChange",
    "onKeyDown",
    "onOpen",
    "onClose",
    "size",
    "style",
    "fullWidth"
], $d0e3a07ac9c4618d$var$_excluded2 = [
    "onRowsPerPageChange",
    "material",
    "disabled"
], $d0e3a07ac9c4618d$var$_excluded3 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded4 = [
    "autoFocus",
    "label",
    "fullWidth",
    "slotProps",
    "className",
    "material"
], $d0e3a07ac9c4618d$var$_excluded5 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded6 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded7 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded8 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded9 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded0 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded1 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded10 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded11 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded12 = [
    "material",
    "label",
    "className"
], $d0e3a07ac9c4618d$var$_excluded13 = [
    "material"
], $d0e3a07ac9c4618d$var$_excluded14 = [
    "inert",
    "iconStart",
    "iconEnd",
    "children",
    "material"
], $d0e3a07ac9c4618d$var$_excluded15 = [
    "slotProps",
    "material"
], $d0e3a07ac9c4618d$var$_excluded16 = [
    "id",
    "multiple",
    "freeSolo",
    "options",
    "getOptionLabel",
    "isOptionEqualToValue",
    "value",
    "onChange",
    "label",
    "placeholder",
    "slotProps",
    "material"
], $d0e3a07ac9c4618d$var$_excluded17 = [
    "key"
], $d0e3a07ac9c4618d$var$_excluded18 = [
    "inputProps",
    "InputProps",
    "InputLabelProps"
], $d0e3a07ac9c4618d$var$_excluded19 = [
    "slotProps",
    "material"
], $d0e3a07ac9c4618d$var$_excluded20 = [
    "ref",
    "open",
    "children",
    "className",
    "clickAwayTouchEvent",
    "clickAwayMouseEvent",
    "flip",
    "focusTrap",
    "onExited",
    "onClickAway",
    "onDidShow",
    "onDidHide",
    "id",
    "target",
    "transition",
    "placement",
    "material"
], $d0e3a07ac9c4618d$var$_excluded21 = [
    "native"
], $d0e3a07ac9c4618d$var$_excluded22 = [
    "children",
    "value",
    "active"
], $d0e3a07ac9c4618d$var$_excluded23 = [
    "items",
    "value",
    "material"
];
/* eslint-disable material-ui/disallow-react-api-in-server-components */ const $d0e3a07ac9c4618d$var$InputAdornment = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $0ffab78552448ba6$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`&.${(0, $df1adf37dbd0f6dd$export$2e2bcd8739ae039).positionEnd} .${(0, $51a63158336e7c66$export$2e2bcd8739ae039).sizeSmall}`]: {
            marginRight: theme.spacing(-0.75)
        }
    }));
const $d0e3a07ac9c4618d$var$FormControlLabel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'fullWidth'
})(({ theme: theme })=>({
        gap: theme.spacing(0.5),
        margin: 0,
        overflow: 'hidden',
        [`& .${(0, $4ae0c5c6bd551796$export$2e2bcd8739ae039).label}`]: {
            fontSize: theme.typography.pxToRem(14),
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
        },
        variants: [
            {
                props: {
                    fullWidth: true
                },
                style: {
                    width: '100%'
                }
            }
        ]
    }));
const $d0e3a07ac9c4618d$var$Checkbox = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $e3ef6305be93c7af$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>prop !== 'density'
})(({ theme: theme })=>({
        variants: [
            {
                props: {
                    density: 'compact'
                },
                style: {
                    padding: theme.spacing(0.5)
                }
            }
        ]
    }));
const $d0e3a07ac9c4618d$var$ListItemText = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $a7cd8ac1360c47a2$export$2e2bcd8739ae039))({
    [`& .${(0, $8ffc2f5b8ea69aff$export$2e2bcd8739ae039).primary}`]: {
        overflowX: 'clip',
        textOverflow: 'ellipsis',
        maxWidth: '300px'
    }
});
const $d0e3a07ac9c4618d$var$BaseSelect = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseSelect(props, ref) {
    const { id: id, label: label, labelId: labelId, material: material, disabled: disabled, slotProps: slotProps, onChange: onChange, onKeyDown: onKeyDown, onOpen: onOpen, onClose: onClose, size: size, style: style, fullWidth: fullWidth } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded);
    const menuProps = {
        PaperProps: {
            onKeyDown: onKeyDown
        }
    };
    if (onClose) menuProps.onClose = onClose;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
        size: size,
        fullWidth: fullWidth,
        style: style,
        disabled: disabled,
        ref: ref,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), {
                id: labelId,
                htmlFor: id,
                shrink: true,
                variant: "outlined",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                id: id,
                labelId: labelId,
                label: label,
                displayEmpty: true,
                onChange: onChange,
                variant: "outlined"
            }, other, {
                notched: true,
                inputProps: slotProps?.htmlInput,
                onOpen: onOpen,
                MenuProps: menuProps,
                size: size
            }, material))
        ]
    });
});
const $d0e3a07ac9c4618d$var$StyledPagination = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $e88806fdab3fc1ac$export$2e2bcd8739ae039))(({ theme: theme })=>({
        [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).selectLabel}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'block'
            }
        },
        [`& .${(0, $f6b9903d0b727400$export$2e2bcd8739ae039).input}`]: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'inline-flex'
            }
        }
    }));
const $d0e3a07ac9c4618d$var$BasePagination = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BasePagination(props, ref) {
    const { onRowsPerPageChange: onRowsPerPageChange, material: material, disabled: disabled } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded2);
    const computedProps = $acw62.useMemo(()=>{
        if (!disabled) return undefined;
        return {
            backIconButtonProps: {
                disabled: true
            },
            nextIconButtonProps: {
                disabled: true
            }
        };
    }, [
        disabled
    ]);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { estimatedRowCount: estimatedRowCount } = rootProps;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$StyledPagination, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        component: "div",
        onRowsPerPageChange: (0, $0c5a7e8ccbc07697$export$2e2bcd8739ae039)((event)=>{
            onRowsPerPageChange?.(Number(event.target.value));
        }),
        labelRowsPerPage: apiRef.current.getLocaleText('paginationRowsPerPage'),
        labelDisplayedRows: (params)=>apiRef.current.getLocaleText('paginationDisplayedRows')((0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, params, {
                estimated: estimatedRowCount
            })),
        getItemAriaLabel: apiRef.current.getLocaleText('paginationItemAriaLabel')
    }, computedProps, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseBadge = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseBadge(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded3);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f18835d59a9187d7$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseCheckbox = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseCheckbox(props, ref) {
    const { autoFocus: autoFocus, label: label, fullWidth: fullWidth, slotProps: slotProps, className: className, material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded4);
    const elementRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(elementRef, ref);
    const rippleRef = $acw62.useRef(null);
    $acw62.useEffect(()=>{
        if (autoFocus) {
            const input = elementRef.current?.querySelector('input');
            input?.focus({
                preventScroll: true
            });
        } else if (autoFocus === false && rippleRef.current) // Only available in @mui/material v5.4.1 or later
        // @ts-ignore
        rippleRef.current.stop({});
    }, [
        autoFocus
    ]);
    if (!label) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$Checkbox, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(className, material?.className),
        inputProps: slotProps?.htmlInput,
        ref: handleRef,
        touchRippleRef: rippleRef
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$FormControlLabel, {
        className: className,
        control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$Checkbox, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
            inputProps: slotProps?.htmlInput,
            ref: handleRef,
            touchRippleRef: rippleRef
        })),
        label: label,
        fullWidth: fullWidth
    });
});
const $d0e3a07ac9c4618d$var$BaseCircularProgress = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseCircularProgress(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded5);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseDivider = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseDivider(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded6);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2e2000df495a70f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseLinearProgress = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseLinearProgress(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded7);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $87e33f68a58c76cf$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseButton = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseButton(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded8);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$StyledToggleButton = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $654477ebc3cb437e$export$2e2bcd8739ae039))(({ theme: theme })=>({
        gap: theme.spacing(1),
        border: 0
    }));
const $d0e3a07ac9c4618d$var$BaseToggleButton = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseToggleButton(props, ref) {
    const { material: material } = props, rest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded9);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$StyledToggleButton, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        size: "small",
        color: "primary"
    }, rest, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseChip = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseChip(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded0);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08a2e84130921e51$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseIconButton = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseIconButton(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded1);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseTooltip = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseTooltip(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded10);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseSkeleton = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseSkeleton(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded11);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $39a1b6ae48c4cf7c$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
const $d0e3a07ac9c4618d$var$BaseSwitch = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseSwitch(props, ref) {
    const { material: material, label: label, className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded12);
    if (!label) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e276246268a3078e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        className: className,
        ref: ref
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$FormControlLabel, {
        className: className,
        control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e276246268a3078e$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
            ref: ref
        })),
        label: label
    });
});
const $d0e3a07ac9c4618d$var$BaseMenuList = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function BaseMenuList(props, ref) {
    const { material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded13);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c6e657321c9c45b$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material, {
        ref: ref
    }));
});
function $d0e3a07ac9c4618d$var$BaseMenuItem(props) {
    const { inert: inert, iconStart: iconStart, iconEnd: iconEnd, children: children, material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded14);
    if (inert) other.disableRipple = true;
    return /*#__PURE__*/ $acw62.createElement((0, $45389177b9c2b08c$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, material), [
        iconStart && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab586b5c8bd0ab7a$export$2e2bcd8739ae039), {
            children: iconStart
        }, "1"),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$ListItemText, {
            children: children
        }, "2"),
        iconEnd && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab586b5c8bd0ab7a$export$2e2bcd8739ae039), {
            children: iconEnd
        }, "3")
    ]);
}
function $d0e3a07ac9c4618d$var$BaseTextField(props) {
    // MaterialUI v5 doesn't support slotProps, until we drop v5 support we need to
    // translate the pattern.
    const { slotProps: slotProps, material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded15);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        variant: "outlined"
    }, other, material, {
        inputProps: slotProps?.htmlInput,
        InputProps: $d0e3a07ac9c4618d$var$transformInputProps(slotProps?.input),
        InputLabelProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            shrink: true
        }, slotProps?.inputLabel)
    }));
}
function $d0e3a07ac9c4618d$var$BaseAutocomplete(props) {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { id: id, multiple: multiple, freeSolo: freeSolo, options: options, getOptionLabel: getOptionLabel, isOptionEqualToValue: isOptionEqualToValue, value: value, onChange: onChange, label: label, placeholder: placeholder, slotProps: slotProps, material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded16);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db86fcacc6287e65$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: id,
        multiple: multiple,
        freeSolo: freeSolo,
        options: options,
        getOptionLabel: getOptionLabel,
        isOptionEqualToValue: isOptionEqualToValue,
        value: value,
        onChange: onChange,
        renderTags: (currentValue, getTagProps)=>currentValue.map((option, index)=>{
                const _getTagProps = getTagProps({
                    index: index
                }), { key: key } = _getTagProps, tagProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_getTagProps, $d0e3a07ac9c4618d$var$_excluded17);
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08a2e84130921e51$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    variant: "outlined",
                    size: "small",
                    label: typeof option === 'string' ? option : getOptionLabel?.(option)
                }, tagProps), key);
            }),
        renderInput: (params)=>{
            const { inputProps: inputProps, InputProps: InputProps, InputLabelProps: InputLabelProps } = params, inputRest = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(params, $d0e3a07ac9c4618d$var$_excluded18);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, inputRest, {
                label: label,
                placeholder: placeholder,
                inputProps: inputProps,
                InputProps: $d0e3a07ac9c4618d$var$transformInputProps(InputProps, false),
                InputLabelProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                    shrink: true
                }, InputLabelProps)
            }, slotProps?.textField, rootProps.slotProps?.baseTextField));
        }
    }, other, material));
}
function $d0e3a07ac9c4618d$var$BaseInput(props) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $810f5d6293d4467f$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $d0e3a07ac9c4618d$var$transformInputProps(props)));
}
function $d0e3a07ac9c4618d$var$transformInputProps(props, wrapAdornments = true) {
    if (!props) return undefined;
    const { slotProps: slotProps, material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded19);
    const result = other;
    if (wrapAdornments) {
        if (result.startAdornment) result.startAdornment = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$InputAdornment, {
            position: "start",
            children: result.startAdornment
        });
        if (result.endAdornment) result.endAdornment = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$InputAdornment, {
            position: "end",
            children: result.endAdornment
        });
    }
    for(const k in material)if (Object.hasOwn(material, k)) result[k] = material[k];
    if (slotProps?.htmlInput) {
        if (result.inputProps) result.inputProps = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, result.inputProps, slotProps?.htmlInput);
        else result.inputProps = slotProps?.htmlInput;
    }
    return result;
}
const $d0e3a07ac9c4618d$var$transformOrigin = {
    'bottom-start': 'top left',
    'bottom-end': 'top right'
};
function $d0e3a07ac9c4618d$var$BasePopper(props) {
    const { open: open, children: children, className: className, flip: flip, onExited: onExited, onDidShow: onDidShow, onDidHide: onDidHide, id: id, target: target, transition: transition, placement: placement, material: material } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded20);
    const modifiers = $acw62.useMemo(()=>{
        const result = [
            {
                name: 'preventOverflow',
                options: {
                    padding: 8
                }
            }
        ];
        if (flip) result.push({
            name: 'flip',
            enabled: true,
            options: {
                rootBoundary: 'document'
            }
        });
        if (onDidShow || onDidHide) result.push({
            name: 'isPlaced',
            enabled: true,
            phase: 'main',
            fn: ()=>{
                onDidShow?.();
            },
            effect: ()=>()=>{
                    onDidHide?.();
                }
        });
        return result;
    }, [
        flip,
        onDidShow,
        onDidHide
    ]);
    let content;
    if (!transition) content = $d0e3a07ac9c4618d$var$wrappers(props, children);
    else {
        const handleExited = (popperOnExited)=>(node)=>{
                if (popperOnExited) popperOnExited();
                if (onExited) onExited(node);
            };
        content = (p)=>$d0e3a07ac9c4618d$var$wrappers(props, /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5a8449c70e836e71$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, p.TransitionProps, {
                style: {
                    transformOrigin: $d0e3a07ac9c4618d$var$transformOrigin[p.placement]
                },
                onExited: handleExited(p.TransitionProps?.onExited),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
                    children: children
                })
            })));
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d825775ecf14115c$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        id: id,
        className: className,
        open: open,
        anchorEl: target,
        transition: transition,
        placement: placement,
        modifiers: modifiers
    }, other, material, {
        children: content
    }));
}
function $d0e3a07ac9c4618d$var$wrappers(props, content) {
    return $d0e3a07ac9c4618d$var$focusTrapWrapper(props, $d0e3a07ac9c4618d$var$clickAwayWrapper(props, content));
}
function $d0e3a07ac9c4618d$var$clickAwayWrapper(props, content) {
    if (props.onClickAway === undefined) return content;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $21498506e622538e$export$58385c17fee43f89), {
        onClickAway: props.onClickAway,
        touchEvent: props.clickAwayTouchEvent,
        mouseEvent: props.clickAwayMouseEvent,
        children: content
    });
}
function $d0e3a07ac9c4618d$var$focusTrapWrapper(props, content) {
    if (props.focusTrap === undefined) return content;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29292f9ac60f4a63$export$2e2bcd8739ae039), {
        open: true,
        disableEnforceFocus: true,
        disableAutoFocus: true,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
            tabIndex: -1,
            children: content
        })
    });
}
function $d0e3a07ac9c4618d$var$BaseSelectOption(_ref) {
    let { native: native } = _ref, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $d0e3a07ac9c4618d$var$_excluded21);
    if (native) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("option", (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props));
}
const $d0e3a07ac9c4618d$var$StyledTabs = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $ade8931e75b51e59$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'Tabs'
})(({ theme: theme })=>({
        borderBottom: `1px solid ${theme.palette.divider}`
    }));
const $d0e3a07ac9c4618d$var$StyledTab = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
    name: 'MuiDataGrid',
    slot: 'Tab'
})({
    flex: 1,
    minWidth: 'fit-content'
});
const $d0e3a07ac9c4618d$var$StyledTabPanel = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'TabPanel'
})({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden'
});
function $d0e3a07ac9c4618d$var$TabPanel(props) {
    const { children: children, active: active } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $d0e3a07ac9c4618d$var$_excluded22);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$StyledTabPanel, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: "tabpanel",
        style: {
            display: active ? 'flex' : 'none'
        }
    }, other, {
        children: children
    }));
}
function $d0e3a07ac9c4618d$var$BaseTabs(_ref2) {
    let { items: items, value: value, material: material } = _ref2, props = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref2, $d0e3a07ac9c4618d$var$_excluded23);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const labelId = `${id}-tab-${value}`;
    const panelId = `${id}-tabpanel-${value}`;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$StyledTabs, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
                value: value,
                variant: "scrollable",
                scrollButtons: "auto"
            }, material, {
                children: items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$StyledTab, {
                        value: item.value,
                        label: item.label,
                        id: labelId,
                        "aria-controls": panelId
                    }, item.value))
            })),
            items.map((item)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d0e3a07ac9c4618d$var$TabPanel, {
                    value: item.value,
                    active: value === item.value,
                    id: panelId,
                    "aria-labelledby": labelId,
                    children: item.children
                }, item.value))
        ]
    });
}
const $d0e3a07ac9c4618d$var$iconSlots = {
    booleanCellTrueIcon: (0, $585ee0b8d948e38e$export$1f9ec58b2f66f46d),
    booleanCellFalseIcon: (0, $585ee0b8d948e38e$export$cbefef3cfb8e2783),
    columnMenuIcon: (0, $585ee0b8d948e38e$export$2fbf0de7557957a8),
    openFilterButtonIcon: (0, $585ee0b8d948e38e$export$cb1a577169e125de),
    filterPanelDeleteIcon: (0, $585ee0b8d948e38e$export$cbefef3cfb8e2783),
    columnFilteredIcon: (0, $585ee0b8d948e38e$export$4f4f59585ffe8deb),
    columnSelectorIcon: (0, $585ee0b8d948e38e$export$10a5a2f68ff67c50),
    columnUnsortedIcon: (0, $8e57892bb82e0017$export$9e3e7f6bf3b8c7a7),
    columnSortedAscendingIcon: (0, $585ee0b8d948e38e$export$6de472a3df735882),
    columnSortedDescendingIcon: (0, $585ee0b8d948e38e$export$1f2d4db4a79871d4),
    columnResizeIcon: (0, $585ee0b8d948e38e$export$e918bd395b324de6),
    densityCompactIcon: (0, $585ee0b8d948e38e$export$3bcf566f7053b242),
    densityStandardIcon: (0, $585ee0b8d948e38e$export$adcade5d1a52a335),
    densityComfortableIcon: (0, $585ee0b8d948e38e$export$60a4c153d2d7b084),
    exportIcon: (0, $585ee0b8d948e38e$export$6eaed8bd7158657a),
    moreActionsIcon: (0, $585ee0b8d948e38e$export$6eaba7fcfbaac527),
    treeDataCollapseIcon: (0, $585ee0b8d948e38e$export$5b6f85a3ddabf4ca),
    treeDataExpandIcon: (0, $585ee0b8d948e38e$export$8da6370d9999894a),
    groupingCriteriaCollapseIcon: (0, $585ee0b8d948e38e$export$5b6f85a3ddabf4ca),
    groupingCriteriaExpandIcon: (0, $585ee0b8d948e38e$export$8da6370d9999894a),
    detailPanelExpandIcon: (0, $585ee0b8d948e38e$export$e483c1441c7fca0b),
    detailPanelCollapseIcon: (0, $585ee0b8d948e38e$export$d8fa92cc66e4dec8),
    rowReorderIcon: (0, $585ee0b8d948e38e$export$305773dd821bb81d),
    quickFilterIcon: (0, $585ee0b8d948e38e$export$d33e6ad54b379a5d),
    quickFilterClearIcon: (0, $585ee0b8d948e38e$export$ab03f96923842ba7),
    columnMenuHideIcon: (0, $585ee0b8d948e38e$export$9267feb6a6149971),
    columnMenuSortAscendingIcon: (0, $585ee0b8d948e38e$export$6de472a3df735882),
    columnMenuSortDescendingIcon: (0, $585ee0b8d948e38e$export$1f2d4db4a79871d4),
    columnMenuUnsortIcon: null,
    columnMenuFilterIcon: (0, $585ee0b8d948e38e$export$4f4f59585ffe8deb),
    columnMenuManageColumnsIcon: (0, $585ee0b8d948e38e$export$109d60d29e96616d),
    columnMenuClearIcon: (0, $585ee0b8d948e38e$export$ab03f96923842ba7),
    loadIcon: (0, $585ee0b8d948e38e$export$52992a9d5fa53c3c),
    filterPanelAddIcon: (0, $585ee0b8d948e38e$export$e483c1441c7fca0b),
    filterPanelRemoveAllIcon: (0, $585ee0b8d948e38e$export$fc6ef585bd0ee189),
    columnReorderIcon: (0, $585ee0b8d948e38e$export$305773dd821bb81d),
    menuItemCheckIcon: (0, $585ee0b8d948e38e$export$1f9ec58b2f66f46d)
};
const $d0e3a07ac9c4618d$var$baseSlots = {
    baseAutocomplete: $d0e3a07ac9c4618d$var$BaseAutocomplete,
    baseBadge: $d0e3a07ac9c4618d$var$BaseBadge,
    baseCheckbox: $d0e3a07ac9c4618d$var$BaseCheckbox,
    baseChip: $d0e3a07ac9c4618d$var$BaseChip,
    baseCircularProgress: $d0e3a07ac9c4618d$var$BaseCircularProgress,
    baseDivider: $d0e3a07ac9c4618d$var$BaseDivider,
    baseInput: $d0e3a07ac9c4618d$var$BaseInput,
    baseLinearProgress: $d0e3a07ac9c4618d$var$BaseLinearProgress,
    baseMenuList: $d0e3a07ac9c4618d$var$BaseMenuList,
    baseMenuItem: $d0e3a07ac9c4618d$var$BaseMenuItem,
    baseTextField: $d0e3a07ac9c4618d$var$BaseTextField,
    baseButton: $d0e3a07ac9c4618d$var$BaseButton,
    baseIconButton: $d0e3a07ac9c4618d$var$BaseIconButton,
    baseToggleButton: $d0e3a07ac9c4618d$var$BaseToggleButton,
    baseTooltip: $d0e3a07ac9c4618d$var$BaseTooltip,
    baseTabs: $d0e3a07ac9c4618d$var$BaseTabs,
    basePagination: $d0e3a07ac9c4618d$var$BasePagination,
    basePopper: $d0e3a07ac9c4618d$var$BasePopper,
    baseSelect: $d0e3a07ac9c4618d$var$BaseSelect,
    baseSelectOption: $d0e3a07ac9c4618d$var$BaseSelectOption,
    baseSkeleton: $d0e3a07ac9c4618d$var$BaseSkeleton,
    baseSwitch: $d0e3a07ac9c4618d$var$BaseSwitch
};
const $d0e3a07ac9c4618d$var$materialSlots = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $d0e3a07ac9c4618d$var$baseSlots, $d0e3a07ac9c4618d$var$iconSlots);
var $d0e3a07ac9c4618d$export$2e2bcd8739ae039 = $d0e3a07ac9c4618d$var$materialSlots;



parcelRequire("acw62");





const $c79f76231315b978$var$useUtilityClasses = ()=>{
    const slots = {
        root: [
            'bottomContainer'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), {});
};
const $c79f76231315b978$var$Element = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div')({
    position: 'sticky',
    zIndex: 40,
    bottom: 'calc(var(--DataGrid-hasScrollX) * var(--DataGrid-scrollbarSize))'
});
function $c79f76231315b978$export$7b1aa135d0232b20(props) {
    const classes = $c79f76231315b978$var$useUtilityClasses();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c79f76231315b978$var$Element, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, (0, $59e5f6b0ce3da023$export$2100d54e36406477)['container--bottom']),
        role: "presentation"
    }));
}





var $acw62 = parcelRequire("acw62");








var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
function $1bb07bda818259ae$export$89f3e2246bb370d8(defaultElement, render, props, state = {}) {
    if (typeof render === 'function') return render(props, state);
    if (render) {
        if (render.props.className) props.className = $1bb07bda818259ae$var$mergeClassNames(render.props.className, props.className);
        if (render.props.style || props.style) props.style = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, props.style, render.props.style);
        return /*#__PURE__*/ $acw62.cloneElement(render, props);
    }
    return /*#__PURE__*/ $acw62.createElement(defaultElement, props);
}
function $1bb07bda818259ae$var$mergeClassNames(className, otherClassName) {
    if (!className || !otherClassName) return className || otherClassName;
    return `${className} ${otherClassName}`;
}





var $acw62 = parcelRequire("acw62");
'use client';
const $25d2b76011cadf10$export$6311e7ab80ef752f = /*#__PURE__*/ $acw62.createContext(undefined);
function $25d2b76011cadf10$export$194c7727cbdc0cac() {
    const context = $acw62.useContext($25d2b76011cadf10$export$6311e7ab80ef752f);
    if (context === undefined) throw new Error('MUI X: Missing context. Toolbar subcomponents must be placed within a <Toolbar /> component.');
    return context;
}



/* eslint-disable no-bitwise */ function $dcac9011c89ffb9b$export$6345817df26c3bd3(a, b) {
    if (!a.ref.current || !b.ref.current) return 0;
    const position = a.ref.current.compareDocumentPosition(b.ref.current);
    if (!position) return 0;
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}



'use client';
const $dad27cdc79053c14$var$_excluded = [
    "render",
    "className"
];
const $dad27cdc79053c14$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbar'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $dad27cdc79053c14$var$ToolbarRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'Toolbar'
})({
    flex: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'end',
    gap: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(0.25),
    padding: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(0.75),
    minHeight: 52,
    boxSizing: 'border-box',
    borderBottom: `1px solid ${(0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).colors.border.base}`
});
/**
 * The top level Toolbar component that provides context to child components.
 * It renders a styled `<div />` element.
 *
 * Demos:
 *
 * - [Toolbar](https://mui.com/x/react-data-grid/components/toolbar/)
 *
 * API:
 *
 * - [Toolbar API](https://mui.com/x/api/data-grid/toolbar/)
 */ const $dad27cdc79053c14$export$4c260019440d418f = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function Toolbar(props, ref) {
    const { render: render, className: className } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $dad27cdc79053c14$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $dad27cdc79053c14$var$useUtilityClasses(rootProps);
    const [focusableItemId, setFocusableItemId] = $acw62.useState(null);
    const [items, setItems] = $acw62.useState([]);
    const getSortedItems = $acw62.useCallback(()=>items.sort((0, $dcac9011c89ffb9b$export$6345817df26c3bd3)), [
        items
    ]);
    const findEnabledItem = $acw62.useCallback((startIndex, step, wrap = true)=>{
        let index = startIndex;
        const sortedItems = getSortedItems();
        const itemCount = sortedItems.length;
        // Look for enabled items in the specified direction
        for(let i = 0; i < itemCount; i += 1){
            index += step;
            // Handle wrapping around the ends
            if (index >= itemCount) {
                if (!wrap) return -1;
                index = 0;
            } else if (index < 0) {
                if (!wrap) return -1;
                index = itemCount - 1;
            }
            // Return if we found an enabled item
            if (!sortedItems[index].ref.current?.disabled && sortedItems[index].ref.current?.ariaDisabled !== 'true') return index;
        }
        // If we've checked all items and found none enabled
        return -1;
    }, [
        getSortedItems
    ]);
    const registerItem = $acw62.useCallback((id, itemRef)=>{
        setItems((prevItems)=>[
                ...prevItems,
                {
                    id: id,
                    ref: itemRef
                }
            ]);
    }, []);
    const unregisterItem = $acw62.useCallback((id)=>{
        setItems((prevItems)=>prevItems.filter((i)=>i.id !== id));
    }, []);
    const onItemKeyDown = $acw62.useCallback((event)=>{
        if (!focusableItemId) return;
        const sortedItems = getSortedItems();
        const focusableItemIndex = sortedItems.findIndex((item)=>item.id === focusableItemId);
        let newIndex = -1;
        if (event.key === 'ArrowRight') {
            event.preventDefault();
            newIndex = findEnabledItem(focusableItemIndex, 1);
        } else if (event.key === 'ArrowLeft') {
            event.preventDefault();
            newIndex = findEnabledItem(focusableItemIndex, -1);
        } else if (event.key === 'Home') {
            event.preventDefault();
            newIndex = findEnabledItem(-1, 1, false);
        } else if (event.key === 'End') {
            event.preventDefault();
            newIndex = findEnabledItem(sortedItems.length, -1, false);
        }
        // TODO: Check why this is necessary
        if (newIndex >= 0 && newIndex < sortedItems.length) {
            const item = sortedItems[newIndex];
            setFocusableItemId(item.id);
            item.ref.current?.focus();
        }
    }, [
        getSortedItems,
        focusableItemId,
        findEnabledItem
    ]);
    const onItemFocus = $acw62.useCallback((id)=>{
        if (focusableItemId !== id) setFocusableItemId(id);
    }, [
        focusableItemId,
        setFocusableItemId
    ]);
    const onItemDisabled = $acw62.useCallback((id)=>{
        const sortedItems = getSortedItems();
        const currentIndex = sortedItems.findIndex((item)=>item.id === id);
        const newIndex = findEnabledItem(currentIndex, 1);
        if (newIndex >= 0 && newIndex < sortedItems.length) {
            const item = sortedItems[newIndex];
            setFocusableItemId(item.id);
            item.ref.current?.focus();
        }
    }, [
        getSortedItems,
        findEnabledItem
    ]);
    $acw62.useEffect(()=>{
        const sortedItems = getSortedItems();
        if (sortedItems.length > 0) {
            // Set initial focusable item
            if (!focusableItemId) {
                setFocusableItemId(sortedItems[0].id);
                return;
            }
            const focusableItemIndex = sortedItems.findIndex((item)=>item.id === focusableItemId);
            if (!sortedItems[focusableItemIndex]) {
                // Last item has been removed from the items array
                const item = sortedItems[sortedItems.length - 1];
                if (item) {
                    setFocusableItemId(item.id);
                    item.ref.current?.focus();
                }
            } else if (focusableItemIndex === -1) {
                // Focused item has been removed from the items array
                const item = sortedItems[focusableItemIndex];
                if (item) {
                    setFocusableItemId(item.id);
                    item.ref.current?.focus();
                }
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        getSortedItems,
        findEnabledItem
    ]);
    const contextValue = $acw62.useMemo(()=>({
            focusableItemId: focusableItemId,
            registerItem: registerItem,
            unregisterItem: unregisterItem,
            onItemKeyDown: onItemKeyDown,
            onItemFocus: onItemFocus,
            onItemDisabled: onItemDisabled
        }), [
        focusableItemId,
        registerItem,
        unregisterItem,
        onItemKeyDown,
        onItemFocus,
        onItemDisabled
    ]);
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)($dad27cdc79053c14$var$ToolbarRoot, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        role: 'toolbar',
        'aria-orientation': 'horizontal',
        'aria-label': rootProps.label || undefined,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className)
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25d2b76011cadf10$export$6311e7ab80ef752f).Provider, {
        value: contextValue,
        children: element
    });
});





var $acw62 = parcelRequire("acw62");








'use client';
const $76ab67c0faab9ba1$var$_excluded = [
    "render",
    "onKeyDown",
    "onFocus",
    "disabled",
    "aria-disabled"
];
/**
 * A button for performing actions from the toolbar.
 * It renders the `baseIconButton` slot.
 *
 * Demos:
 *
 * - [Toolbar](https://mui.com/x/react-data-grid/components/toolbar/)
 *
 * API:
 *
 * - [ToolbarButton API](https://mui.com/x/api/data-grid/toolbar-button/)
 */ const $76ab67c0faab9ba1$export$e5c1a33878e86e9e = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function ToolbarButton(props, ref) {
    const { render: render, onKeyDown: onKeyDown, onFocus: onFocus, disabled: disabled, 'aria-disabled': ariaDisabled } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $76ab67c0faab9ba1$var$_excluded);
    const id = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const buttonRef = $acw62.useRef(null);
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(buttonRef, ref);
    const { focusableItemId: focusableItemId, registerItem: registerItem, unregisterItem: unregisterItem, onItemKeyDown: onItemKeyDown, onItemFocus: onItemFocus, onItemDisabled: onItemDisabled } = (0, $25d2b76011cadf10$export$194c7727cbdc0cac)();
    const handleKeyDown = (event)=>{
        onItemKeyDown(event);
        onKeyDown?.(event);
    };
    const handleFocus = (event)=>{
        onItemFocus(id);
        onFocus?.(event);
    };
    $acw62.useEffect(()=>{
        registerItem(id, buttonRef);
        return ()=>unregisterItem(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const previousDisabled = $acw62.useRef(disabled);
    $acw62.useEffect(()=>{
        if (previousDisabled.current !== disabled && disabled === true) onItemDisabled(id, disabled);
        previousDisabled.current = disabled;
    }, [
        disabled,
        id,
        onItemDisabled
    ]);
    const previousAriaDisabled = $acw62.useRef(ariaDisabled);
    $acw62.useEffect(()=>{
        if (previousAriaDisabled.current !== ariaDisabled && ariaDisabled === true) onItemDisabled(id, true);
        previousAriaDisabled.current = ariaDisabled;
    }, [
        ariaDisabled,
        id,
        onItemDisabled
    ]);
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)(rootProps.slots.baseIconButton, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseIconButton, {
        tabIndex: focusableItemId === id ? 0 : -1
    }, other, {
        disabled: disabled,
        'aria-disabled': ariaDisabled,
        onKeyDown: handleKeyDown,
        onFocus: handleFocus,
        ref: handleRef
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: element
    });
});





var $acw62 = parcelRequire("acw62");










const $ec6832d63353aad3$var$_excluded = [
    "render",
    "className",
    "onClick",
    "onPointerUp"
];
/**
 * A button that opens and closes the filter panel.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Filter Panel](https://mui.com/x/react-data-grid/components/filter-panel/)
 *
 * API:
 *
 * - [FilterPanelTrigger API](https://mui.com/x/api/data-grid/filter-panel-trigger/)
 */ const $ec6832d63353aad3$export$cd3e70dcfe49cc06 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function FilterPanelTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick, onPointerUp: onPointerUp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $ec6832d63353aad3$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const buttonId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const panelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const panelState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9a7998a995118469$export$37e5474577e02878));
    const open = panelState.open && panelState.openedPanelValue === (0, $e38c9af0748d9173$export$e7e5652452e44b).filters;
    const activeFilters = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$c7447bfbd4ecafcc));
    const filterCount = activeFilters.length;
    const state = {
        open: open,
        filterCount: filterCount
    };
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const { filterPanelTriggerRef: filterPanelTriggerRef } = (0, $9638e12379adda14$export$82b7333a15124fb5)();
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, filterPanelTriggerRef);
    const handleClick = (event)=>{
        if (open) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences((0, $e38c9af0748d9173$export$e7e5652452e44b).filters, panelId, buttonId);
        onClick?.(event);
    };
    const handlePointerUp = (event)=>{
        if (open) event.stopPropagation();
        onPointerUp?.(event);
    };
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)(rootProps.slots.baseButton, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseButton, {
        id: buttonId,
        'aria-haspopup': 'true',
        'aria-expanded': open ? 'true' : undefined,
        'aria-controls': open ? panelId : undefined,
        onClick: handleClick,
        onPointerUp: handlePointerUp,
        className: resolvedClassName
    }, other, {
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: element
    });
});





var $acw62 = parcelRequire("acw62");










const $1ddc4ece5cbb3452$var$_excluded = [
    "render",
    "className",
    "onClick",
    "onPointerUp"
];
/**
 * A button that opens and closes the columns panel.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Columns Panel](https://mui.com/x/react-data-grid/components/columns-panel/)
 *
 * API:
 *
 * - [ColumnsPanelTrigger API](https://mui.com/x/api/data-grid/columns-panel-trigger/)
 */ const $1ddc4ece5cbb3452$export$79ee56e02ed5507a = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function ColumnsPanelTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick, onPointerUp: onPointerUp } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $1ddc4ece5cbb3452$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const buttonId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const panelId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const panelState = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $9a7998a995118469$export$37e5474577e02878));
    const open = panelState.open && panelState.openedPanelValue === (0, $e38c9af0748d9173$export$e7e5652452e44b).columns;
    const state = {
        open: open
    };
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const { columnsPanelTriggerRef: columnsPanelTriggerRef } = (0, $9638e12379adda14$export$82b7333a15124fb5)();
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(ref, columnsPanelTriggerRef);
    const handleClick = (event)=>{
        if (open) apiRef.current.hidePreferences();
        else apiRef.current.showPreferences((0, $e38c9af0748d9173$export$e7e5652452e44b).columns, panelId, buttonId);
        onClick?.(event);
    };
    const handlePointerUp = (event)=>{
        if (open) event.stopPropagation();
        onPointerUp?.(event);
    };
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)(rootProps.slots.baseButton, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseButton, {
        id: buttonId,
        'aria-haspopup': 'true',
        'aria-expanded': open ? 'true' : undefined,
        'aria-controls': open ? panelId : undefined,
        className: resolvedClassName
    }, other, {
        onPointerUp: handlePointerUp,
        onClick: handleClick,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: element
    });
});





var $acw62 = parcelRequire("acw62");






const $ca906ddfec1688be$var$_excluded = [
    "render",
    "options",
    "onClick"
];
/**
 * A button that triggers a CSV export.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Export](https://mui.com/x/react-data-grid/components/export/)
 *
 * API:
 *
 * - [ExportCsv API](https://mui.com/x/api/data-grid/export-csv/)
 */ const $ca906ddfec1688be$export$15f90d471ceeeb3a = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function ExportCsv(props, ref) {
    const { render: render, options: options, onClick: onClick } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $ca906ddfec1688be$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const handleClick = (event)=>{
        apiRef.current.exportDataAsCsv(options);
        onClick?.(event);
    };
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)(rootProps.slots.baseButton, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseButton, {
        onClick: handleClick
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: element
    });
});




var $acw62 = parcelRequire("acw62");






const $1c0130aff0a57757$var$_excluded = [
    "render",
    "options",
    "onClick"
];
/**
 * A button that triggers a print export.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Export](https://mui.com/x/react-data-grid/components/export/)
 *
 * API:
 *
 * - [ExportPrint API](https://mui.com/x/api/data-grid/export-print/)
 */ const $1c0130aff0a57757$export$b2a4bd1af329cddc = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function ExportPrint(props, ref) {
    const { render: render, options: options, onClick: onClick } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $1c0130aff0a57757$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const handleClick = (event)=>{
        apiRef.current.exportDataAsPrint(options);
        onClick?.(event);
    };
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)(rootProps.slots.baseButton, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseButton, {
        onClick: handleClick
    }, other, {
        ref: ref
    }));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: element
    });
});




parcelRequire("acw62");










var $acw62 = parcelRequire("acw62");







var $acw62 = parcelRequire("acw62");
'use client';
const $edc00a603bfb88a2$export$bc5cb762fe16ddbd = /*#__PURE__*/ $acw62.createContext(undefined);
function $edc00a603bfb88a2$export$c780863ac5a2232e() {
    const context = $acw62.useContext($edc00a603bfb88a2$export$bc5cb762fe16ddbd);
    if (context === undefined) throw new Error('MUI X: Missing context. Quick Filter subcomponents must be placed within a <QuickFilter /> component.');
    return context;
}







'use client';
const $1b142656b9c850fd$var$_excluded = [
    "render",
    "className",
    "parser",
    "formatter",
    "debounceMs",
    "defaultExpanded",
    "expanded",
    "onExpandedChange"
];
const $1b142656b9c850fd$var$DEFAULT_PARSER = (searchText)=>searchText.split(' ').filter((word)=>word !== '');
const $1b142656b9c850fd$var$DEFAULT_FORMATTER = (values)=>values.join(' ');
/**
 * The top level Quick Filter component that provides context to child components.
 * It renders a `<div />` element.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilter API](https://mui.com/x/api/data-grid/quick-filter/)
 */ function $1b142656b9c850fd$export$d210f27ff79988(props) {
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { render: render, className: className, parser: parser = $1b142656b9c850fd$var$DEFAULT_PARSER, formatter: formatter = $1b142656b9c850fd$var$DEFAULT_FORMATTER, debounceMs: debounceMs = rootProps.filterDebounceMs, defaultExpanded: defaultExpanded, expanded: expanded, onExpandedChange: onExpandedChange } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $1b142656b9c850fd$var$_excluded);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const controlRef = $acw62.useRef(null);
    const triggerRef = $acw62.useRef(null);
    const quickFilterValues = (0, $ef323e860abde413$export$f96fd476863f2e4a)(apiRef, (0, $51d9da8b83918212$export$6f9fe133e2c56816));
    const [value, setValue] = $acw62.useState(formatter(quickFilterValues ?? []));
    const [internalExpanded, setInternalExpanded] = $acw62.useState(defaultExpanded ?? value.length > 0);
    const expandedValue = expanded ?? internalExpanded;
    const state = $acw62.useMemo(()=>({
            value: value,
            expanded: expandedValue
        }), [
        value,
        expandedValue
    ]);
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const ref = $acw62.useRef(null);
    const controlId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const handleExpandedChange = $acw62.useCallback((newExpanded)=>{
        if (onExpandedChange) onExpandedChange(newExpanded);
        if (expanded === undefined) setInternalExpanded(newExpanded);
    }, [
        onExpandedChange,
        expanded
    ]);
    const prevQuickFilterValuesRef = $acw62.useRef(quickFilterValues);
    $acw62.useEffect(()=>{
        if (!(0, $5ece57da2e97951f$export$78fdc9adc3f30400)(prevQuickFilterValuesRef.current, quickFilterValues)) {
            // The model of quick filter value has been updated
            prevQuickFilterValuesRef.current = quickFilterValues;
            // Update the input value if needed to match the new model
            setValue((prevSearchValue)=>(0, $5ece57da2e97951f$export$78fdc9adc3f30400)(parser(prevSearchValue), quickFilterValues) ? prevSearchValue : formatter(quickFilterValues ?? []));
        }
    }, [
        quickFilterValues,
        formatter,
        parser
    ]);
    const isFirstRender = $acw62.useRef(true);
    const previousExpandedValue = $acw62.useRef(expandedValue);
    $acw62.useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        // Ensure the expanded state has actually changed before focusing
        if (previousExpandedValue.current !== expandedValue) {
            if (expandedValue) // Ensures the focus does not interupt CSS transitions and animations on the control
            requestAnimationFrame(()=>{
                controlRef.current?.focus({
                    preventScroll: true
                });
            });
            else triggerRef.current?.focus({
                preventScroll: true
            });
            previousExpandedValue.current = expandedValue;
        }
    }, [
        expandedValue
    ]);
    const setQuickFilterValueDebounced = $acw62.useMemo(()=>(0, $7cf4d6c2077a48de$export$2e2bcd8739ae039)((newValue)=>{
            const newQuickFilterValues = parser(newValue);
            prevQuickFilterValuesRef.current = newQuickFilterValues;
            apiRef.current.setQuickFilterValues(newQuickFilterValues);
        }, debounceMs), [
        apiRef,
        debounceMs,
        parser
    ]);
    $acw62.useEffect(()=>setQuickFilterValueDebounced.clear, [
        setQuickFilterValueDebounced
    ]);
    const handleValueChange = $acw62.useCallback((event)=>{
        const newValue = event.target.value;
        setValue(newValue);
        setQuickFilterValueDebounced(newValue);
    }, [
        setQuickFilterValueDebounced
    ]);
    const handleClearValue = $acw62.useCallback(()=>{
        setValue('');
        apiRef.current.setQuickFilterValues([]);
        controlRef.current?.focus();
    }, [
        apiRef,
        controlRef
    ]);
    const contextValue = $acw62.useMemo(()=>({
            controlRef: controlRef,
            triggerRef: triggerRef,
            state: state,
            controlId: controlId,
            clearValue: handleClearValue,
            onValueChange: handleValueChange,
            onExpandedChange: handleExpandedChange
        }), [
        controlId,
        state,
        handleValueChange,
        handleClearValue,
        handleExpandedChange
    ]);
    (0, $aab859a020ad749e$export$2e2bcd8739ae039)(()=>{
        if (ref.current && triggerRef.current) ref.current.style.setProperty('--trigger-width', `${triggerRef.current?.offsetWidth}px`);
    }, []);
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)('div', render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: resolvedClassName
    }, other, {
        ref: ref
    }), state);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $edc00a603bfb88a2$export$bc5cb762fe16ddbd).Provider, {
        value: contextValue,
        children: element
    });
}




var $acw62 = parcelRequire("acw62");






const $32d7e8b4ec8ce1c6$var$_excluded = [
    "render",
    "className",
    "onClick"
];
/**
 * A button that resets the filter value.
 * It renders the `baseIconButton` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterClear API](https://mui.com/x/api/data-grid/quick-filter-clear/)
 */ const $32d7e8b4ec8ce1c6$export$8f2f2f258f66f54 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function QuickFilterClear(props, ref) {
    const { render: render, className: className, onClick: onClick } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $32d7e8b4ec8ce1c6$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { state: state, clearValue: clearValue } = (0, $edc00a603bfb88a2$export$c780863ac5a2232e)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleClick = (event)=>{
        clearValue();
        onClick?.(event);
    };
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)(rootProps.slots.baseIconButton, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseIconButton, {
        className: resolvedClassName,
        tabIndex: -1
    }, other, {
        onClick: handleClick,
        ref: ref
    }), state);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: element
    });
});




var $acw62 = parcelRequire("acw62");







const $51db330ab796d0e3$var$_excluded = [
    "render",
    "className",
    "slotProps",
    "onKeyDown",
    "onChange"
];
/**
 * A component that takes user input and filters row data.
 * It renders the `baseTextField` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterControl API](https://mui.com/x/api/data-grid/quick-filter-control/)
 */ const $51db330ab796d0e3$export$c2b83922a7ff9d48 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function QuickFilterControl(props, ref) {
    const { render: render, className: className, slotProps: slotProps, onKeyDown: onKeyDown, onChange: onChange } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $51db330ab796d0e3$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { state: state, controlId: controlId, controlRef: controlRef, onValueChange: onValueChange, onExpandedChange: onExpandedChange, clearValue: clearValue } = (0, $edc00a603bfb88a2$export$c780863ac5a2232e)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(controlRef, ref);
    const handleKeyDown = (event)=>{
        if (event.key === 'Escape') {
            if (state.value === '') onExpandedChange(false);
            else clearValue();
        }
        onKeyDown?.(event);
    };
    const handleBlur = (event)=>{
        if (state.value === '') onExpandedChange(false);
        slotProps?.htmlInput?.onBlur?.(event);
    };
    const handleChange = (event)=>{
        if (!state.expanded) onExpandedChange(true);
        onValueChange(event);
        onChange?.(event);
    };
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)(rootProps.slots.baseTextField, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseTextField, {
        slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            htmlInput: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                role: 'searchbox',
                id: controlId,
                tabIndex: state.expanded ? undefined : -1
            }, slotProps?.htmlInput, {
                onBlur: handleBlur
            })
        }, slotProps),
        value: state.value,
        className: resolvedClassName
    }, other, {
        onChange: handleChange,
        onKeyDown: handleKeyDown,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: element
    });
});




var $acw62 = parcelRequire("acw62");







const $10d059d784abe502$var$_excluded = [
    "render",
    "className",
    "onClick"
];
/**
 * A button that expands/collapses the quick filter.
 * It renders the `baseButton` slot.
 *
 * Demos:
 *
 * - [Quick Filter](https://mui.com/x/react-data-grid/components/quick-filter/)
 *
 * API:
 *
 * - [QuickFilterTrigger API](https://mui.com/x/api/data-grid/quick-filter-trigger/)
 */ const $10d059d784abe502$export$4c7a45a31c2a8b28 = (0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)(function QuickFilterTrigger(props, ref) {
    const { render: render, className: className, onClick: onClick } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $10d059d784abe502$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const { state: state, controlId: controlId, onExpandedChange: onExpandedChange, triggerRef: triggerRef } = (0, $edc00a603bfb88a2$export$c780863ac5a2232e)();
    const resolvedClassName = typeof className === 'function' ? className(state) : className;
    const handleRef = (0, $27fddc0219860a83$export$2e2bcd8739ae039)(triggerRef, ref);
    const handleClick = (event)=>{
        onExpandedChange(!state.expanded);
        onClick?.(event);
    };
    const element = (0, $1bb07bda818259ae$export$89f3e2246bb370d8)(rootProps.slots.baseButton, render, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseButton, {
        className: resolvedClassName,
        'aria-controls': controlId,
        'aria-expanded': state.expanded
    }, other, {
        onClick: handleClick,
        ref: handleRef
    }), state);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($acw62.Fragment, {
        children: element
    });
});





const $c6a81d65e09b51c3$var$_excluded = [
    "quickFilterParser",
    "quickFilterFormatter",
    "debounceMs",
    "className",
    "slotProps"
], $c6a81d65e09b51c3$var$_excluded2 = [
    "ref",
    "slotProps"
];
const $c6a81d65e09b51c3$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'toolbarQuickFilter'
        ],
        trigger: [
            'toolbarQuickFilterTrigger'
        ],
        control: [
            'toolbarQuickFilterControl'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $c6a81d65e09b51c3$var$GridQuickFilterRoot = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('div', {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilter'
})({
    display: 'grid',
    alignItems: 'center'
});
const $c6a81d65e09b51c3$var$GridQuickFilterTrigger = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)((0, $76ab67c0faab9ba1$export$e5c1a33878e86e9e), {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilterTrigger'
})(({ ownerState: ownerState })=>({
        gridArea: '1 / 1',
        width: 'min-content',
        height: 'min-content',
        zIndex: 1,
        opacity: ownerState.expanded ? 0 : 1,
        pointerEvents: ownerState.expanded ? 'none' : 'auto',
        transition: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transition([
            'opacity'
        ])
    }));
// TODO: Use NotRendered from /utils/assert
// Currently causes react-docgen to fail
const $c6a81d65e09b51c3$var$GridQuickFilterTextField = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)((_props)=>{
    throw new Error('Failed assertion: should not be rendered');
}, {
    name: 'MuiDataGrid',
    slot: 'ToolbarQuickFilterControl'
})(({ ownerState: ownerState })=>({
        gridArea: '1 / 1',
        overflowX: 'clip',
        width: ownerState.expanded ? 260 : 'var(--trigger-width)',
        opacity: ownerState.expanded ? 1 : 0,
        transition: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).transition([
            'width',
            'opacity'
        ])
    }));
/**
 * @deprecated Use the {@link https://mui.com/x/react-data-grid/components/quick-filter/ Quick Filter} component instead. This component will be removed in a future major release.
 */ function $c6a81d65e09b51c3$export$d7fbfb032c6d5ccc(props) {
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const ownerState = {
        classes: rootProps.classes,
        expanded: false
    };
    const classes = $c6a81d65e09b51c3$var$useUtilityClasses(ownerState);
    const { quickFilterParser: quickFilterParser, quickFilterFormatter: quickFilterFormatter, debounceMs: debounceMs, className: className, slotProps: slotProps } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $c6a81d65e09b51c3$var$_excluded);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b142656b9c850fd$export$d210f27ff79988), {
        parser: quickFilterParser,
        formatter: quickFilterFormatter,
        debounceMs: debounceMs,
        render: (quickFilterProps, state)=>{
            const currentOwnerState = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, ownerState, {
                expanded: state.expanded
            });
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($c6a81d65e09b51c3$var$GridQuickFilterRoot, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, quickFilterProps, {
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $10d059d784abe502$export$4c7a45a31c2a8b28), {
                        render: (triggerProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTooltip, {
                                title: apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
                                enterDelay: 0 // Prevents tooltip lagging behind transitioning trigger element
                                ,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c6a81d65e09b51c3$var$GridQuickFilterTrigger, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                                    className: classes.trigger
                                }, triggerProps, {
                                    ownerState: currentOwnerState,
                                    color: "default",
                                    "aria-disabled": state.expanded,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.quickFilterIcon, {
                                        fontSize: "small"
                                    })
                                }))
                            })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $51db330ab796d0e3$export$c2b83922a7ff9d48), {
                        render: (_ref)=>{
                            let { ref: ref, slotProps: controlSlotProps } = _ref, controlProps = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(_ref, $c6a81d65e09b51c3$var$_excluded2);
                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c6a81d65e09b51c3$var$GridQuickFilterTextField, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                                as: rootProps.slots.baseTextField,
                                className: classes.control,
                                ownerState: currentOwnerState,
                                inputRef: ref,
                                "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterLabel'),
                                placeholder: apiRef.current.getLocaleText('toolbarQuickFilterPlaceholder'),
                                size: "small",
                                slotProps: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                                    input: (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                                        startAdornment: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.quickFilterIcon, {
                                            fontSize: "small"
                                        }),
                                        endAdornment: controlProps.value ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32d7e8b4ec8ce1c6$export$8f2f2f258f66f54), {
                                            render: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseIconButton, {
                                                size: "small",
                                                edge: "end",
                                                "aria-label": apiRef.current.getLocaleText('toolbarQuickFilterDeleteIconLabel'),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.quickFilterClearIcon, {
                                                    fontSize: "small"
                                                })
                                            })
                                        }) : null
                                    }, controlSlotProps?.input)
                                }, controlSlotProps)
                            }, rootProps.slotProps?.baseTextField, controlProps, slotProps?.root, other));
                        }
                    })
                ]
            }));
        }
    });
}








'use client';
const $b5103e83dd965068$var$_excluded = [
    "className"
], $b5103e83dd965068$var$_excluded2 = [
    "className"
], $b5103e83dd965068$var$_excluded3 = [
    "showQuickFilter",
    "quickFilterProps",
    "csvOptions",
    "printOptions",
    "additionalItems",
    "additionalExportMenuItems"
];
const $b5103e83dd965068$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        divider: [
            'toolbarDivider'
        ],
        label: [
            'toolbarLabel'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $59e5f6b0ce3da023$export$a2aa36217b862c23), classes);
};
const $b5103e83dd965068$var$Divider = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)((0, $3ffccd8eb47e448b$export$c9fa229ee44f9a9d), {
    name: 'MuiDataGrid',
    slot: 'ToolbarDivider'
})({
    height: '50%',
    margin: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(0, 0.5)
});
const $b5103e83dd965068$var$Label = (0, $9dc40fba00dc8e3b$export$2e2bcd8739ae039)('span', {
    name: 'MuiDataGrid',
    slot: 'ToolbarLabel'
})({
    flex: 1,
    font: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).typography.font.large,
    fontWeight: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).typography.fontWeight.medium,
    margin: (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).spacing(0, 0.5),
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
function $b5103e83dd965068$export$d64f5182547aafdb(props) {
    const other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $b5103e83dd965068$var$_excluded);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $b5103e83dd965068$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b5103e83dd965068$var$Divider, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        as: rootProps.slots.baseDivider,
        orientation: "vertical",
        className: classes.divider
    }, other));
}
function $b5103e83dd965068$export$b4501e5f230154c4(props) {
    const other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $b5103e83dd965068$var$_excluded2);
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const classes = $b5103e83dd965068$var$useUtilityClasses(rootProps);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b5103e83dd965068$var$Label, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
        className: classes.label
    }, other));
}
function $b5103e83dd965068$export$6f17559aa1de380e(props) {
    const { showQuickFilter: showQuickFilter = true, quickFilterProps: quickFilterProps, csvOptions: csvOptions, printOptions: printOptions, additionalItems: additionalItems, additionalExportMenuItems: additionalExportMenuItems } = props, other = (0, $133b6e059b2f6d5e$export$2e2bcd8739ae039)(props, $b5103e83dd965068$var$_excluded3);
    const apiRef = (0, $c4277a4fee22a087$export$2d14edd3a7db3bbf)();
    const rootProps = (0, $4c6b1657b7154fcd$export$8b0f8e71b71b7ed3)();
    const [exportMenuOpen, setExportMenuOpen] = $acw62.useState(false);
    const exportMenuTriggerRef = $acw62.useRef(null);
    const exportMenuId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const exportMenuTriggerId = (0, $7a3a319e7e555608$export$2e2bcd8739ae039)();
    const showExportMenu = !csvOptions?.disableToolbarButton || !printOptions?.disableToolbarButton || additionalExportMenuItems;
    const closeExportMenu = ()=>setExportMenuOpen(false);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $dad27cdc79053c14$export$4c260019440d418f), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, other, {
        children: [
            rootProps.label && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b5103e83dd965068$export$b4501e5f230154c4, {
                children: rootProps.label
            }),
            !rootProps.disableColumnSelector && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTooltip, {
                title: apiRef.current.getLocaleText('toolbarColumns'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ddc4ece5cbb3452$export$79ee56e02ed5507a), {
                    render: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76ab67c0faab9ba1$export$e5c1a33878e86e9e), {}),
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.columnSelectorIcon, {
                        fontSize: "small"
                    })
                })
            }),
            !rootProps.disableColumnFilter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTooltip, {
                title: apiRef.current.getLocaleText('toolbarFilters'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec6832d63353aad3$export$cd3e70dcfe49cc06), {
                    render: (triggerProps, state)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76ab67c0faab9ba1$export$e5c1a33878e86e9e), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, triggerProps, {
                            color: state.filterCount > 0 ? 'primary' : 'default',
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseBadge, {
                                badgeContent: state.filterCount,
                                color: "primary",
                                variant: "dot",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.openFilterButtonIcon, {
                                    fontSize: "small"
                                })
                            })
                        }))
                })
            }),
            additionalItems,
            showExportMenu && (!rootProps.disableColumnFilter || !rootProps.disableColumnSelector) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b5103e83dd965068$export$d64f5182547aafdb, {}),
            showExportMenu && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseTooltip, {
                        title: apiRef.current.getLocaleText('toolbarExport'),
                        disableInteractive: exportMenuOpen,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $76ab67c0faab9ba1$export$e5c1a33878e86e9e), {
                            ref: exportMenuTriggerRef,
                            id: exportMenuTriggerId,
                            "aria-controls": exportMenuId,
                            "aria-haspopup": "true",
                            "aria-expanded": exportMenuOpen ? 'true' : undefined,
                            onClick: ()=>setExportMenuOpen(!exportMenuOpen),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.exportIcon, {
                                fontSize: "small"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbffbc66fe757e53$export$237948c71948075), {
                        target: exportMenuTriggerRef.current,
                        open: exportMenuOpen,
                        onClose: closeExportMenu,
                        position: "bottom-end",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(rootProps.slots.baseMenuList, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
                            id: exportMenuId,
                            "aria-labelledby": exportMenuTriggerId,
                            autoFocusItem: true
                        }, rootProps.slotProps?.baseMenuList, {
                            children: [
                                !printOptions?.disableToolbarButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c0130aff0a57757$export$b2a4bd1af329cddc), {
                                    render: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseMenuItem)),
                                    options: printOptions,
                                    onClick: closeExportMenu,
                                    children: apiRef.current.getLocaleText('toolbarExportPrint')
                                }),
                                !csvOptions?.disableToolbarButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ca906ddfec1688be$export$15f90d471ceeeb3a), {
                                    render: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(rootProps.slots.baseMenuItem, (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, rootProps.slotProps?.baseMenuItem)),
                                    options: csvOptions,
                                    onClick: closeExportMenu,
                                    children: apiRef.current.getLocaleText('toolbarExportCSV')
                                }),
                                additionalExportMenuItems?.(closeExportMenu)
                            ]
                        }))
                    })
                ]
            }),
            showQuickFilter && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($acw62.Fragment, {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($b5103e83dd965068$export$d64f5182547aafdb, {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c6a81d65e09b51c3$export$d7fbfb032c6d5ccc), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, quickFilterProps))
                ]
            })
        ]
    }));
}


const $bf2a92ec24b2f6b7$export$8a57bda01657743f = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $d0e3a07ac9c4618d$export$2e2bcd8739ae039), {
    cell: (0, $a95a85cb097c106e$export$1ce951ee41d30605),
    skeletonCell: (0, $7dd4f51b3a81ca3c$export$d922c88d466d9c21),
    columnHeaderFilterIconButton: (0, $5bcf7c74dc2b204c$export$35b5c67d267fafd7),
    columnHeaderSortIcon: (0, $469a87926117c22e$export$80cd75c5dceceac6),
    columnMenu: (0, $9bccf585bf07c9ed$export$53fbb13480dfeb67),
    columnHeaders: (0, $755cb1f5d55489d9$export$4a3a74c44d0a6c04),
    detailPanels: (0, $103429e767a13c46$export$aa888f5144097c35),
    bottomContainer: (0, $c79f76231315b978$export$7b1aa135d0232b20),
    footer: (0, $50ce5ddf6b8d81fc$export$6ef0bfefb022d11e),
    footerRowCount: (0, $a1695791b9b8bbfd$export$b92875c9af3e0a77),
    toolbar: (0, $b5103e83dd965068$export$6f17559aa1de380e),
    pinnedRows: (0, $32354e26a56a0956$export$58309d5251e10b9e),
    loadingOverlay: (0, $926382940e04f0b4$export$69e47a4ea5ffa191),
    noResultsOverlay: (0, $2a9f2233e80308ec$export$82fb990ffc125278),
    noRowsOverlay: (0, $f0f13edf3ed2bd2a$export$a25f04494ce53510),
    noColumnsOverlay: (0, $a13f3a6d66c545df$export$e65b720c06138814),
    pagination: (0, $464632ac69454085$export$fa9a503101f8d472),
    filterPanel: (0, $d05dc368815103de$export$32c6e72be8ad862c),
    columnsPanel: (0, $f84855c4cf095e9d$export$39d43456ec96cf57),
    columnsManagement: (0, $a0f87d3bf8a4e691$export$3710e0bb3d9954d),
    panel: (0, $266faff44edb200b$export$cf917897ad2588b),
    row: (0, $e006f53d53e7fc50$export$1fc5a7f035870658)
});



function $7967abbb3e813cc4$export$247af54f7c54fca({ defaultSlots: defaultSlots, slots: slots }) {
    const overrides = slots;
    if (!overrides || Object.keys(overrides).length === 0) return defaultSlots;
    const result = (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, defaultSlots);
    Object.keys(overrides).forEach((key)=>{
        const k = key;
        if (overrides[k] !== undefined) result[k] = overrides[k];
    });
    return result;
}



const $2b0c1b41d44701f6$var$DATA_GRID_FORCED_PROPS = {
    disableMultipleColumnsFiltering: true,
    disableMultipleColumnsSorting: true,
    throttleRowsMs: undefined,
    hideFooterRowCount: false,
    pagination: true,
    checkboxSelectionVisibleOnly: false,
    disableColumnReorder: true,
    keepColumnPositionIfDraggedOutside: false,
    signature: 'DataGrid',
    listView: false
};
const $2b0c1b41d44701f6$var$getDataGridForcedProps = (themedProps)=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, $2b0c1b41d44701f6$var$DATA_GRID_FORCED_PROPS, themedProps.dataSource ? {
        filterMode: 'server',
        sortingMode: 'server',
        paginationMode: 'server'
    } : {});
const $2b0c1b41d44701f6$var$defaultSlots = (0, $bf2a92ec24b2f6b7$export$8a57bda01657743f);
const $2b0c1b41d44701f6$export$23366c9f040a985 = (inProps)=>{
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const themedProps = $acw62.useMemo(()=>(0, $8ec30e4d54713c84$export$2e2bcd8739ae039)({
            props: inProps,
            theme: theme,
            name: 'MuiDataGrid'
        }), [
        theme,
        inProps
    ]);
    const localeText = $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, (0, $9b88dcc9f58ffb5d$export$d217cc4e11b3c706), themedProps.localeText), [
        themedProps.localeText
    ]);
    const slots = $acw62.useMemo(()=>(0, $7967abbb3e813cc4$export$247af54f7c54fca)({
            defaultSlots: $2b0c1b41d44701f6$var$defaultSlots,
            slots: themedProps.slots
        }), [
        themedProps.slots
    ]);
    const injectDefaultProps = $acw62.useMemo(()=>{
        return Object.keys((0, $b3f45ec6f75f29f1$export$2733e0e1a1d288e7)).reduce((acc, key)=>{
            // @ts-ignore
            acc[key] = themedProps[key] ?? (0, $b3f45ec6f75f29f1$export$2733e0e1a1d288e7)[key];
            return acc;
        }, {});
    }, [
        themedProps
    ]);
    return $acw62.useMemo(()=>(0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({}, themedProps, injectDefaultProps, {
            localeText: localeText,
            slots: slots
        }, $2b0c1b41d44701f6$var$getDataGridForcedProps(themedProps)), [
        themedProps,
        localeText,
        slots,
        injectDefaultProps
    ]);
};




var $acw62 = parcelRequire("acw62");

const $24a7b220686e1fff$var$encoder = new TextEncoder();
// bufferLength must be a multiple of 4 to satisfy Int32Array constraints
let $24a7b220686e1fff$var$bufferLength = 2048;
let $24a7b220686e1fff$var$buffer = new ArrayBuffer($24a7b220686e1fff$var$bufferLength);
let $24a7b220686e1fff$var$uint8View = new Uint8Array($24a7b220686e1fff$var$buffer);
let $24a7b220686e1fff$var$int32View = new Int32Array($24a7b220686e1fff$var$buffer);
const $24a7b220686e1fff$export$d6af199866bfb566 = $24a7b220686e1fff$var$xxh;
/**
 * Returns an xxh hash of `input` formatted as a decimal string.
 */ // prettier-ignore
function $24a7b220686e1fff$var$xxh(input) {
    /* eslint-disable no-bitwise */ // Worst-case scenario: full string of 2-byte characters
    const requiredLength = input.length * 2;
    if (requiredLength > $24a7b220686e1fff$var$bufferLength) {
        // buffer.resize() is only available in recent browsers, so we re-allocate
        // a new and views
        $24a7b220686e1fff$var$bufferLength = requiredLength + (4 - requiredLength % 4);
        $24a7b220686e1fff$var$buffer = new ArrayBuffer($24a7b220686e1fff$var$bufferLength);
        $24a7b220686e1fff$var$uint8View = new Uint8Array($24a7b220686e1fff$var$buffer);
        $24a7b220686e1fff$var$int32View = new Int32Array($24a7b220686e1fff$var$buffer);
    }
    const length8 = $24a7b220686e1fff$var$encoder.encodeInto(input, $24a7b220686e1fff$var$uint8View).written;
    const seed = 0;
    const len = length8 | 0;
    let i = 0;
    let h = (seed + len | 0) + 0x165667B1 | 0;
    if (len < 16) for(; (i + 3 | 0) < len; i = i + 4 | 0)h = Math.imul($24a7b220686e1fff$var$rotl32(h + Math.imul($24a7b220686e1fff$var$int32View[i] | 0, 0xC2B2AE3D) | 0, 17) | 0, 0x27D4EB2F);
    else {
        let v0 = seed + 0x24234428 | 0;
        let v1 = seed + 0x85EBCA77 | 0;
        let v2 = seed;
        let v3 = seed - 0x9E3779B1 | 0;
        for(; (i + 15 | 0) < len; i = i + 16 | 0){
            v0 = Math.imul($24a7b220686e1fff$var$rotl32(v0 + Math.imul($24a7b220686e1fff$var$int32View[i + 0 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v1 = Math.imul($24a7b220686e1fff$var$rotl32(v1 + Math.imul($24a7b220686e1fff$var$int32View[i + 4 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v2 = Math.imul($24a7b220686e1fff$var$rotl32(v2 + Math.imul($24a7b220686e1fff$var$int32View[i + 8 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
            v3 = Math.imul($24a7b220686e1fff$var$rotl32(v3 + Math.imul($24a7b220686e1fff$var$int32View[i + 12 | 0] | 0, 0x85EBCA77) | 0, 13) | 0, 0x9E3779B1);
        }
        h = ((($24a7b220686e1fff$var$rotl32(v0, 1) | 0 + $24a7b220686e1fff$var$rotl32(v1, 7) | 0) + $24a7b220686e1fff$var$rotl32(v2, 12) | 0) + $24a7b220686e1fff$var$rotl32(v3, 18) | 0) + len | 0;
        for(; (i + 3 | 0) < len; i = i + 4 | 0)h = Math.imul($24a7b220686e1fff$var$rotl32(h + Math.imul($24a7b220686e1fff$var$int32View[i] | 0, 0xC2B2AE3D) | 0, 17) | 0, 0x27D4EB2F);
    }
    for(; i < len; i = i + 1 | 0)h = Math.imul($24a7b220686e1fff$var$rotl32(h + Math.imul($24a7b220686e1fff$var$uint8View[i] | 0, 0x165667B1) | 0, 11) | 0, 0x9E3779B1);
    h = Math.imul(h ^ h >>> 15, 0x85EBCA77);
    h = Math.imul(h ^ h >>> 13, 0xC2B2AE3D);
    return ((h ^ h >>> 16) >>> 0).toString();
}
function $24a7b220686e1fff$var$rotl32(x, r) {
    return x << r | x >>> 32 - r;
}



function $dd19112e6413d9e0$export$ff1d6e6a098eac0b() {
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    return $acw62.useMemo(()=>{
        const id = (0, $24a7b220686e1fff$export$d6af199866bfb566)($dd19112e6413d9e0$var$stringifyTheme(theme));
        const variables = $dd19112e6413d9e0$var$transformTheme(theme);
        return {
            id: id,
            variables: variables
        };
    }, [
        theme
    ]);
}
function $dd19112e6413d9e0$var$transformTheme(t) {
    const borderColor = $dd19112e6413d9e0$var$getBorderColor(t);
    const dataGridPalette = (t.vars || t).palette.DataGrid;
    const backgroundBase = dataGridPalette?.bg ?? (t.palette.mode === 'dark' ? `color-mix(in srgb, ${(t.vars || t).palette.background.paper} 95%, #fff)` : (t.vars || t).palette.background.paper);
    const backgroundHeader = dataGridPalette?.headerBg ?? backgroundBase;
    const backgroundPinned = dataGridPalette?.pinnedBg ?? backgroundBase;
    const backgroundBackdrop = t.vars ? `rgba(${t.vars.palette.background.defaultChannel} / ${t.vars.palette.action.disabledOpacity})` : (0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(t.palette.background.default, t.palette.action.disabledOpacity);
    const backgroundOverlay = t.palette.mode === 'dark' ? `color-mix(in srgb, ${(t.vars || t).palette.background.paper} 90%, #fff)` : (t.vars || t).palette.background.paper;
    const selectedColor = t.vars ? `rgb(${t.vars.palette.primary.mainChannel})` : t.palette.primary.main;
    const radius = $dd19112e6413d9e0$var$getRadius(t);
    const fontBody = t.vars?.font?.body2 ?? $dd19112e6413d9e0$var$formatFont(t.typography.body2);
    const fontSmall = t.vars?.font?.caption ?? $dd19112e6413d9e0$var$formatFont(t.typography.caption);
    const fontLarge = t.vars?.font?.body1 ?? $dd19112e6413d9e0$var$formatFont(t.typography.body1);
    const k = (0, $ee6c62dfac1c40eb$export$3cb96c9f6c8d16a4).keys;
    return {
        [k.spacingUnit]: t.vars ? t.vars.spacing ?? t.spacing(1) : t.spacing(1),
        [k.colors.border.base]: borderColor,
        [k.colors.background.base]: backgroundBase,
        [k.colors.background.overlay]: backgroundOverlay,
        [k.colors.background.backdrop]: backgroundBackdrop,
        [k.colors.foreground.base]: (t.vars || t).palette.text.primary,
        [k.colors.foreground.muted]: (t.vars || t).palette.text.secondary,
        [k.colors.foreground.accent]: (t.vars || t).palette.primary.dark,
        [k.colors.foreground.disabled]: (t.vars || t).palette.text.disabled,
        [k.colors.foreground.error]: (t.vars || t).palette.error.dark,
        [k.colors.interactive.hover]: (t.vars || t).palette.action.hover,
        [k.colors.interactive.hoverOpacity]: (t.vars || t).palette.action.hoverOpacity,
        [k.colors.interactive.focus]: $dd19112e6413d9e0$var$removeOpacity((t.vars || t).palette.primary.main),
        [k.colors.interactive.focusOpacity]: (t.vars || t).palette.action.focusOpacity,
        [k.colors.interactive.disabled]: $dd19112e6413d9e0$var$removeOpacity((t.vars || t).palette.action.disabled),
        [k.colors.interactive.disabledOpacity]: (t.vars || t).palette.action.disabledOpacity,
        [k.colors.interactive.selected]: selectedColor,
        [k.colors.interactive.selectedOpacity]: (t.vars || t).palette.action.selectedOpacity,
        [k.header.background.base]: backgroundHeader,
        [k.cell.background.pinned]: backgroundPinned,
        [k.radius.base]: radius,
        [k.typography.fontFamily.base]: t.typography.fontFamily,
        [k.typography.fontWeight.light]: t.typography.fontWeightLight,
        [k.typography.fontWeight.regular]: t.typography.fontWeightRegular,
        [k.typography.fontWeight.medium]: t.typography.fontWeightMedium,
        [k.typography.fontWeight.bold]: t.typography.fontWeightBold,
        [k.typography.font.body]: fontBody,
        [k.typography.font.small]: fontSmall,
        [k.typography.font.large]: fontLarge,
        [k.transitions.easing.easeIn]: t.transitions.easing.easeIn,
        [k.transitions.easing.easeOut]: t.transitions.easing.easeOut,
        [k.transitions.easing.easeInOut]: t.transitions.easing.easeInOut,
        [k.transitions.duration.short]: `${t.transitions.duration.shorter}ms`,
        [k.transitions.duration.base]: `${t.transitions.duration.short}ms`,
        [k.transitions.duration.long]: `${t.transitions.duration.standard}ms`,
        [k.shadows.base]: (t.vars || t).shadows[2],
        [k.shadows.overlay]: (t.vars || t).shadows[8],
        [k.zIndex.panel]: (t.vars || t).zIndex.modal,
        [k.zIndex.menu]: (t.vars || t).zIndex.modal
    };
}
function $dd19112e6413d9e0$var$getRadius(theme) {
    if (theme.vars) return theme.vars.shape.borderRadius;
    return typeof theme.shape.borderRadius === 'number' ? `${theme.shape.borderRadius}px` : theme.shape.borderRadius;
}
function $dd19112e6413d9e0$var$getBorderColor(theme) {
    if (theme.vars) return theme.vars.palette.TableCell.border;
    if (theme.palette.mode === 'light') return (0, $7ebe803ced17df29$export$c0816ed86df316af)((0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.88);
    return (0, $7ebe803ced17df29$export$4b073707ff63303)((0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.divider, 1), 0.68);
}
function $dd19112e6413d9e0$var$setOpacity(color, opacity) {
    return `rgba(from ${color} r g b / ${opacity})`;
}
function $dd19112e6413d9e0$var$removeOpacity(color) {
    return $dd19112e6413d9e0$var$setOpacity(color, 1);
}
function $dd19112e6413d9e0$var$formatFont(font) {
    // Accounts for disabled typography variants
    // See: https://github.com/mui/mui-x/issues/17812
    if (!font) return undefined;
    const fontSize = typeof font.fontSize === 'number' ? `${font.fontSize}px` : font.fontSize;
    return `${font.fontWeight} ${fontSize} / ${font.lineHeight} ${font.fontFamily}`;
}
/**
 * A version of JSON.stringify for theme objects.
 * Fixes: https://github.com/mui/mui-x/issues/17521
 * Source: https://www.30secondsofcode.org/js/s/stringify-circular-json/
 */ function $dd19112e6413d9e0$var$stringifyTheme(input) {
    const seen = new WeakSet();
    return JSON.stringify(input, (_, v)=>{
        // https://github.com/mui/mui-x/issues/17855
        if (typeof window !== 'undefined' && v === window || typeof document !== 'undefined' && v === document) return v.toString();
        if (v !== null && typeof v === 'object') {
            // Do not attempt to serialize React elements due to performance concerns.
            // Fixes https://github.com/mui/mui-x/issues/19414
            if (/*#__PURE__*/ $acw62.isValidElement(v)) return null;
            if (seen.has(v)) return null;
            seen.add(v);
        }
        return v;
    });
}



var $acw62 = parcelRequire("acw62");
// Used https://gist.github.com/mudge/5830382 as a starting point.
// See https://github.com/browserify/events/blob/master/events.js for
// the Node.js (https://nodejs.org/api/events.html) polyfill used by webpack.
class $98b7954737600c67$export$cc74486daaaef499 {
    maxListeners = 20;
    warnOnce = false;
    events = {};
    on(eventName, listener, options = {}) {
        let collection = this.events[eventName];
        if (!collection) {
            collection = {
                highPriority: new Map(),
                regular: new Map()
            };
            this.events[eventName] = collection;
        }
        if (options.isFirst) collection.highPriority.set(listener, true);
        else collection.regular.set(listener, true);
    }
    removeListener(eventName, listener) {
        if (this.events[eventName]) {
            this.events[eventName].regular.delete(listener);
            this.events[eventName].highPriority.delete(listener);
        }
    }
    removeAllListeners() {
        this.events = {};
    }
    emit(eventName, ...args) {
        const collection = this.events[eventName];
        if (!collection) return;
        const highPriorityListeners = Array.from(collection.highPriority.keys());
        const regularListeners = Array.from(collection.regular.keys());
        for(let i = highPriorityListeners.length - 1; i >= 0; i -= 1){
            const listener = highPriorityListeners[i];
            if (collection.highPriority.has(listener)) listener.apply(this, args);
        }
        for(let i = 0; i < regularListeners.length; i += 1){
            const listener = regularListeners[i];
            if (collection.regular.has(listener)) listener.apply(this, args);
        }
    }
    once(eventName, listener) {
        // eslint-disable-next-line consistent-this
        const that = this;
        this.on(eventName, function oneTimeListener(...args) {
            that.removeListener(eventName, oneTimeListener);
            listener.apply(that, args);
        });
    }
}





'use client';
const $961f5b5fd3f1d2bb$var$SYMBOL_API_PRIVATE = Symbol('mui.api_private');
const $961f5b5fd3f1d2bb$var$isSyntheticEvent = (event)=>{
    return event.isPropagationStopped !== undefined;
};
function $961f5b5fd3f1d2bb$export$37686f243ec62a21(publicApi) {
    return publicApi[$961f5b5fd3f1d2bb$var$SYMBOL_API_PRIVATE];
}
let $961f5b5fd3f1d2bb$var$globalId = 0;
function $961f5b5fd3f1d2bb$var$createPrivateAPI(publicApiRef) {
    const existingPrivateApi = publicApiRef.current?.[$961f5b5fd3f1d2bb$var$SYMBOL_API_PRIVATE];
    if (existingPrivateApi) return existingPrivateApi;
    const state = {};
    const privateApi = {
        state: state,
        store: (0, $3c7b0ee63f2f60b9$export$390f32400eaf98c9).create(state),
        instanceId: {
            id: $961f5b5fd3f1d2bb$var$globalId
        }
    };
    $961f5b5fd3f1d2bb$var$globalId += 1;
    privateApi.getPublicApi = ()=>publicApiRef.current;
    privateApi.register = (visibility, methods)=>{
        Object.keys(methods).forEach((methodName)=>{
            const method = methods[methodName];
            const currentPrivateMethod = privateApi[methodName];
            if (currentPrivateMethod?.spying === true) currentPrivateMethod.target = method;
            else privateApi[methodName] = method;
            if (visibility === 'public') {
                const publicApi = publicApiRef.current;
                const currentPublicMethod = publicApi[methodName];
                if (currentPublicMethod?.spying === true) currentPublicMethod.target = method;
                else publicApi[methodName] = method;
            }
        });
    };
    privateApi.register('private', {
        caches: {},
        eventManager: new (0, $98b7954737600c67$export$cc74486daaaef499)()
    });
    return privateApi;
}
function $961f5b5fd3f1d2bb$var$createPublicAPI(privateApiRef) {
    const publicApi = {
        get state () {
            return privateApiRef.current.state;
        },
        get store () {
            return privateApiRef.current.store;
        },
        get instanceId () {
            return privateApiRef.current.instanceId;
        },
        [$961f5b5fd3f1d2bb$var$SYMBOL_API_PRIVATE]: privateApiRef.current
    };
    return publicApi;
}
function $961f5b5fd3f1d2bb$export$72d4a6c5ec1a4b32(inputApiRef, props) {
    const publicApiRef = $acw62.useRef(null);
    const privateApiRef = $acw62.useRef(null);
    if (!privateApiRef.current) privateApiRef.current = $961f5b5fd3f1d2bb$var$createPrivateAPI(publicApiRef);
    if (!publicApiRef.current) publicApiRef.current = $961f5b5fd3f1d2bb$var$createPublicAPI(privateApiRef);
    const publishEvent = $acw62.useCallback((...args)=>{
        const [name, params, event = {}] = args;
        event.defaultMuiPrevented = false;
        if ($961f5b5fd3f1d2bb$var$isSyntheticEvent(event) && event.isPropagationStopped()) return;
        const details = props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGridPro || props.signature === (0, $bf2466368e56dd38$export$544be0bdf85b5af1).DataGridPremium ? {
            api: privateApiRef.current.getPublicApi()
        } : {};
        privateApiRef.current.eventManager.emit(name, params, event, details);
    }, [
        privateApiRef,
        props.signature
    ]);
    const subscribeEvent = $acw62.useCallback((event, handler, options)=>{
        privateApiRef.current.eventManager.on(event, handler, options);
        const api = privateApiRef.current;
        return ()=>{
            api.eventManager.removeListener(event, handler);
        };
    }, [
        privateApiRef
    ]);
    (0, $c84301dfe99ee71f$export$739f6b6a65e76d6c)(privateApiRef, {
        subscribeEvent: subscribeEvent,
        publishEvent: publishEvent
    }, 'public');
    if (inputApiRef && !inputApiRef.current?.state) inputApiRef.current = publicApiRef.current;
    $acw62.useImperativeHandle(inputApiRef, ()=>publicApiRef.current, [
        publicApiRef
    ]);
    $acw62.useEffect(()=>{
        const api = privateApiRef.current;
        return ()=>{
            api.publishEvent('unmount');
        };
    }, [
        privateApiRef
    ]);
    return privateApiRef;
}



'use client';
const $91898409b7dc5553$var$configuration = {
    hooks: {
        useCSSVariables: (0, $dd19112e6413d9e0$export$ff1d6e6a098eac0b),
        useGridAriaAttributes: $11f858f5913b140b$export$89716d1110d32214,
        useGridRowAriaAttributes: $07351265ddaf321c$export$c27cdb450c323320,
        useGridRowsOverridableMethods: $de203767b3639384$export$7fd6bd072bc860f3,
        useGridParamsOverridableMethods: $341a55c994058083$export$e09fb8462b5f4ab6,
        useCellAggregationResult: ()=>null,
        useFilterValueGetter: (apiRef)=>apiRef.current.getRowValue
    }
};
const $91898409b7dc5553$var$DataGridRaw = function DataGrid(inProps, ref) {
    const props = (0, $2b0c1b41d44701f6$export$23366c9f040a985)(inProps);
    const privateApiRef = (0, $961f5b5fd3f1d2bb$export$72d4a6c5ec1a4b32)(props.apiRef, props);
    (0, $6bd7eabf2f63dc76$export$4b018ab7873d790d)(privateApiRef, props, $91898409b7dc5553$var$configuration);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $80cd1013749013f5$export$4fd26c08a15cabb4), {
        privateApiRef: privateApiRef,
        configuration: $91898409b7dc5553$var$configuration,
        props: props,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb0770698da179d3$export$8cdbcd3b320d39bf), (0, $618a8e53233cd9fa$export$2e2bcd8739ae039)({
            className: props.className,
            style: props.style,
            sx: props.sx
        }, props.slotProps?.root, {
            ref: ref
        }))
    });
};
const $91898409b7dc5553$export$c8dd51eb24f71762 = /*#__PURE__*/ $acw62.memo((0, $c2e72fc2a32cb61d$export$257a8862b851cb5b)($91898409b7dc5553$var$DataGridRaw));
$91898409b7dc5553$var$DataGridRaw.propTypes = {
    // ----------------------------- Warning --------------------------------
    // | These PropTypes are generated from the TypeScript type definitions |
    // | To update them edit the TypeScript types and run "pnpm proptypes"  |
    // ----------------------------------------------------------------------
    /**
   * The ref object that allows Data Grid manipulation. Can be instantiated with `useGridApiRef()`.
   */ apiRef: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        current: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    }),
    /**
   * The `aria-label` of the Data Grid.
   */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * The `id` of the element containing a label for the Data Grid.
   */ 'aria-labelledby': (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * If `true`, the Data Grid height is dynamic and follows the number of rows in the Data Grid.
   * @default false
   * @deprecated Use flex parent container instead: https://mui.com/x/react-data-grid/layout/#flex-parent-container
   * @example
   * <div style={{ display: 'flex', flexDirection: 'column' }}>
   *   <DataGrid />
   * </div>
   */ autoHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the pageSize is calculated according to the container size and the max number of rows to avoid rendering a vertical scroll bar.
   * @default false
   */ autoPageSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, columns are autosized after the datagrid is mounted.
   * @default false
   */ autosizeOnMount: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The options for autosize when user-initiated.
   */ autosizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        columns: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string),
        disableColumnVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        expand: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        includeHeaders: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        includeOutliers: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        outliersFactor: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number
    }),
    /**
   * Controls the modes of the cells.
   */ cellModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * If `true`, the Data Grid will display an extra column with checkboxes for selecting rows.
   * @default false
   */ checkboxSelection: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Override or extend the styles applied to the component.
   */ classes: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * The character used to separate cell values when copying to the clipboard.
   * @default '\t'
   */ clipboardCopyCellDelimiter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * Column region in pixels to render before/after the viewport
   * @default 150
   */ columnBufferPx: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering in the columns menu.
   * @default 150
   */ columnFilterDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Sets the height in pixels of the column group headers in the Data Grid.
   * Inherits the `columnHeaderHeight` value if not set.
   */ columnGroupHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    columnGroupingModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object),
    /**
   * Sets the height in pixel of the column headers in the Data Grid.
   * @default 56
   */ columnHeaderHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Set of columns of type [[GridColDef]][].
   */ columns: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object).isRequired,
    /**
   * Set the column visibility model of the Data Grid.
   * If defined, the Data Grid will ignore the `hide` property in [[GridColDef]].
   */ columnVisibilityModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * The data source object.
   */ dataSource: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        getRows: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        updateRow: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func
    }),
    /**
   * Data source cache object.
   */ dataSourceCache: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        clear: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        get: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        set: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
    }),
    /**
   * Set the density of the Data Grid.
   * @default "standard"
   */ density: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'comfortable',
        'compact',
        'standard'
    ]),
    /**
   * If `true`, column autosizing on header separator double-click is disabled.
   * @default false
   */ disableAutosize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, column filters are disabled.
   * @default false
   */ disableColumnFilter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the column menu is disabled.
   * @default false
   */ disableColumnMenu: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, resizing columns is disabled.
   * @default false
   */ disableColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, hiding/showing columns is disabled.
   * @default false
   */ disableColumnSelector: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the column sorting feature will be disabled.
   * @default false
   */ disableColumnSorting: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the density selector is disabled.
   * @default false
   */ disableDensitySelector: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, `eval()` is not used for performance optimization.
   * @default false
   */ disableEval: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, multiple selection using the Ctrl/CMD or Shift key is disabled.
   * The MIT DataGrid will ignore this prop, unless `checkboxSelection` is enabled.
   * @default false (`!props.checkboxSelection` for MIT Data Grid)
   */ disableMultipleRowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the Data Grid will not use the exclude model optimization when selecting all rows.
   * @default false
   */ disableRowSelectionExcludeModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the selection on click on a row or cell is disabled.
   * @default false
   */ disableRowSelectionOnClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the virtualization is disabled.
   * @default false
   */ disableVirtualization: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Controls whether to use the cell or row editing.
   * @default "cell"
   */ editMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'cell',
        'row'
    ]),
    /**
   * Use if the actual rowCount is not known upfront, but an estimation is available.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Applicable only with `paginationMode="server"` and when `rowCount="-1"`
   */ estimatedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Unstable features, breaking changes might be introduced.
   * For each feature, if the flag is not explicitly set to `true`, the feature will be fully disabled and any property / method call will not have any effect.
   */ experimentalFeatures: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        warnIfFocusStateIsNotSynced: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
    }),
    /**
   * The milliseconds delay to wait after a keystroke before triggering filtering.
   * @default 150
   */ filterDebounceMs: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Filtering can be processed on the server or client-side.
   * Set it to 'server' if you would like to handle filtering on the server-side.
   * @default "client"
   */ filterMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'client',
        'server'
    ]),
    /**
   * Set the filter model of the Data Grid.
   */ filterModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        items: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            field: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
            id: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
                (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string
            ]),
            operator: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).any
        })).isRequired,
        logicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
            'and',
            'or'
        ]),
        quickFilterExcludeHiddenColumns: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
        quickFilterLogicOperator: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
            'and',
            'or'
        ]),
        quickFilterValues: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).array
    }),
    /**
   * Function that applies CSS classes dynamically on cells.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {string} The CSS class to apply to the cell.
   */ getCellClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Function that returns the element to render in row detail.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {React.JSX.Element} The row detail element.
   */ getDetailPanelContent: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Function that returns the estimated height for a row.
   * Only works if dynamic row height is used.
   * Once the row height is measured this value is discarded.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {number | null} The estimated row height value. If `null` or `undefined` then the default row height, based on the density, is applied.
   */ getEstimatedRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Function that applies CSS classes dynamically on rows.
   * @param {GridRowClassNameParams} params With all properties from [[GridRowClassNameParams]].
   * @returns {string} The CSS class to apply to the row.
   */ getRowClassName: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Function that sets the row height per row.
   * @param {GridRowHeightParams} params With all properties from [[GridRowHeightParams]].
   * @returns {GridRowHeightReturnValue} The row height value. If `null` or `undefined` then the default row height is applied. If "auto" then the row height is calculated based on the content.
   */ getRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Return the id of a given [[GridRowModel]].
   * Ensure the reference of this prop is stable to avoid performance implications.
   * It could be done by either defining the prop outside of the component or by memoizing it.
   */ getRowId: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Function that allows to specify the spacing between rows.
   * @param {GridRowSpacingParams} params With all properties from [[GridRowSpacingParams]].
   * @returns {GridRowSpacing} The row spacing values.
   */ getRowSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * If `true`, the footer component is hidden.
   * @default false
   */ hideFooter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the pagination component in the footer is hidden.
   * @default false
   */ hideFooterPagination: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the selected row count in the footer is hidden.
   * @default false
   */ hideFooterSelectedRowCount: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the diacritics (accents) are ignored when filtering or quick filtering.
   * E.g. when filter value is `cafe`, the rows with `café` will be visible.
   * @default false
   */ ignoreDiacritics: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the Data Grid will not use `valueFormatter` when exporting to CSV or copying to clipboard.
   * If an object is provided, you can choose to ignore the `valueFormatter` for CSV export or clipboard export.
   * @default false
   */ ignoreValueFormatterDuringExport: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            clipboardExport: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
            csvExport: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
        }),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
    ]),
    /**
   * The initial state of the DataGrid.
   * The data in it will be set in the state on initialization but will not be controlled.
   * If one of the data in `initialState` is also being controlled, then the control state wins.
   */ initialState: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Callback fired when a cell is rendered, returns true if the cell is editable.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @returns {boolean} A boolean indicating if the cell is editable.
   */ isCellEditable: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Determines if a row can be selected.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @returns {boolean} A boolean indicating if the row is selectable.
   */ isRowSelectable: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * If `true`, the selection model will retain selected rows that do not exist.
   * Useful when using server side pagination and row selections need to be retained
   * when changing pages.
   * @default false
   */ keepNonExistentRowsSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * The label of the Data Grid.
   * If the `showToolbar` prop is `true`, the label will be displayed in the toolbar and applied to the `aria-label` attribute of the grid.
   * If the `showToolbar` prop is `false`, the label will not be visible but will be applied to the `aria-label` attribute of the grid.
   */ label: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * If `true`, a loading overlay is displayed.
   * @default false
   */ loading: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Set the locale text of the Data Grid.
   * You can find all the translation keys supported in [the source](https://github.com/mui/mui-x/blob/HEAD/packages/x-data-grid/src/constants/localeTextConstants.ts) in the GitHub repository.
   */ localeText: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Pass a custom logger in the components that implements the [[Logger]] interface.
   * @default console
   */ logger: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        debug: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        error: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        info: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired,
        warn: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func.isRequired
    }),
    /**
   * Allows to pass the logging level or false to turn off logging.
   * @default "error" ("warn" in dev mode)
   */ logLevel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'debug',
        'error',
        'info',
        'warn',
        false
    ]),
    /**
   * Nonce of the inline styles for [Content Security Policy](https://www.w3.org/TR/2016/REC-CSP2-20161215/#script-src-the-nonce-attribute).
   */ nonce: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string,
    /**
   * Callback fired when any cell is clicked.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a double click event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the cell turns to edit mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onCellEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the cell turns to view mode.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onCellEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a keydown event comes from a cell element.
   * @param {GridCellParams} params With all properties from [[GridCellParams]].
   * @param {MuiEvent<React.KeyboardEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellKeyDown: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the `cellModesModel` prop changes.
   * @param {GridCellModesModel} cellModesModel Object containing which cells are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onCellModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback called when the data is copied to the clipboard.
   * @param {string} data The data copied to the clipboard.
   */ onClipboardCopy: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a contextmenu event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   */ onColumnHeaderContextMenu: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a double click event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a mouse enter event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderEnter: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a mouse leave event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a mouseout event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOut: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a mouseover event comes from a column header element.
   * @param {GridColumnHeaderParams} params With all properties from [[GridColumnHeaderParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnHeaderOver: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a column is reordered.
   * @param {GridColumnOrderChangeParams} params With all properties from [[GridColumnOrderChangeParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnOrderChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired while a column is being resized.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnResize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the column visibility model changes.
   * @param {GridColumnVisibilityModel} model The new model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnVisibilityModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the width of a column is changed.
   * @param {GridColumnResizeParams} params With all properties from [[GridColumnResizeParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onColumnWidthChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a data source request fails.
   * @param {GridGetRowsError | GridUpdateRowError} error The data source error object.
   */ onDataSourceError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the density changes.
   * @param {GridDensity} density New density value.
   */ onDensityChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the Filter model changes before the filters are applied.
   * @param {GridFilterModel} model With all properties from [[GridFilterModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onFilterModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the menu is closed.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuClose: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the menu is opened.
   * @param {GridMenuParams} params With all properties from [[GridMenuParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the pagination meta has changed.
   * @param {GridPaginationMeta} paginationMeta Updated pagination meta.
   */ onPaginationMetaChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the pagination model has changed.
   * @param {GridPaginationModel} model Updated pagination model.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPaginationModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the preferences panel is closed.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelClose: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the preferences panel is opened.
   * @param {GridPreferencePanelParams} params With all properties from [[GridPreferencePanelParams]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onPreferencePanelOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback called when `processRowUpdate()` throws an error or rejects.
   * @param {any} error The error thrown.
   */ onProcessRowUpdateError: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the Data Grid is resized.
   * @param {ElementSize} containerSize With all properties from [[ElementSize]].
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onResize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a row is clicked.
   * Not called if the target clicked is an interactive element added by the built-in columns.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the row count has changed.
   * @param {number} count Updated row count.
   */ onRowCountChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when a double click event comes from a row container element.
   * @param {GridRowParams} params With all properties from [[RowParams]].
   * @param {MuiEvent<React.MouseEvent>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowDoubleClick: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the row turns to edit mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<React.KeyboardEvent | React.MouseEvent>} event The event that caused this prop to be called.
   */ onRowEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the row turns to view mode.
   * @param {GridRowParams} params With all properties from [[GridRowParams]].
   * @param {MuiEvent<MuiBaseEvent>} event The event that caused this prop to be called.
   */ onRowEditStop: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the `rowModesModel` prop changes.
   * @param {GridRowModesModel} rowModesModel Object containing which rows are in "edit" mode.
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowModesModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the selection state of one or multiple rows changes.
   * @param {GridRowSelectionModel} rowSelectionModel With all the row ids [[GridSelectionModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onRowSelectionModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the sort model changes before a column is sorted.
   * @param {GridSortModel} model With all properties from [[GridSortModel]].
   * @param {GridCallbackDetails} details Additional details for this callback.
   */ onSortModelChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Callback fired when the state of the Data Grid is updated.
   * @param {GridState} state The new state.
   * @param {MuiEvent<{}>} event The event object.
   * @param {GridCallbackDetails} details Additional details for this callback.
   * @ignore - do not document.
   */ onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * Select the pageSize dynamically using the component UI.
   * @default [25, 50, 100]
   */ pageSizeOptions: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
            label: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
        })
    ]).isRequired),
    pagination: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        true
    ]),
    /**
   * The extra information about the pagination state of the Data Grid.
   * Only applicable with `paginationMode="server"`.
   */ paginationMeta: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        hasNextPage: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
    }),
    /**
   * Pagination can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle the pagination on the client-side.
   * Set it to 'server' if you would like to handle the pagination on the server-side.
   * @default "client"
   */ paginationMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The pagination model of type [[GridPaginationModel]] which refers to current `page` and `pageSize`.
   */ paginationModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        page: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired,
        pageSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number.isRequired
    }),
    /**
   * Callback called before updating a row with new values in the row and cell editing.
   * @template R
   * @param {R} newRow Row object with the new values.
   * @param {R} oldRow Row object with the old values.
   * @param {{ rowId: GridRowId }} params Additional parameters.
   * @returns {Promise<R> | R} The final values to update the row.
   */ processRowUpdate: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
    /**
   * The milliseconds throttle delay for resizing the grid.
   * @default 60
   */ resizeThrottleMs: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Row region in pixels to render before/after the viewport
   * @default 150
   */ rowBufferPx: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Set the total number of rows, if it is different from the length of the value `rows` prop.
   * If some rows have children (for instance in the tree data), this number represents the amount of top level rows.
   * Only works with `paginationMode="server"`, ignored when `paginationMode="client"`.
   */ rowCount: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Sets the height in pixel of a row in the Data Grid.
   * @default 52
   */ rowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * Controls the modes of the rows.
   */ rowModesModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Set of rows of type [[GridRowsProp]].
   * @default []
   */ rows: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object),
    /**
   * If `false`, the row selection mode is disabled.
   * @default true
   */ rowSelection: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Sets the row selection model of the Data Grid.
   */ rowSelectionModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports)) /* @typescript-to-proptypes-ignore */ ).shape({
        ids: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).instanceOf(Set).isRequired,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
            'exclude',
            'include'
        ]).isRequired
    }),
    /**
   * Sets the type of space between rows added by `getRowSpacing`.
   * @default "margin"
   */ rowSpacingType: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'border',
        'margin'
    ]),
    /**
   * If `true`, the Data Grid will auto span the cells over the rows having the same value.
   * @default false
   */ rowSpanning: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Override the height/width of the Data Grid inner scrollbar.
   */ scrollbarSize: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).number,
    /**
   * If `true`, vertical borders will be displayed between cells.
   * @default false
   */ showCellVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, vertical borders will be displayed between column header items.
   * @default false
   */ showColumnVerticalBorder: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * If `true`, the toolbar is displayed.
   * @default false
   */ showToolbar: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool,
    /**
   * Overridable components props dynamically passed to the component at rendering.
   */ slotProps: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Overridable components.
   */ slots: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * Sorting can be processed on the server or client-side.
   * Set it to 'client' if you would like to handle sorting on the client-side.
   * Set it to 'server' if you would like to handle sorting on the server-side.
   * @default "client"
   */ sortingMode: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'client',
        'server'
    ]),
    /**
   * The order of the sorting sequence.
   * @default ['asc', 'desc', null]
   */ sortingOrder: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
        'asc',
        'desc'
    ])),
    /**
   * Set the sort model of the Data Grid.
   */ sortModel: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).shape({
        field: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).string.isRequired,
        sort: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOf([
            'asc',
            'desc'
        ])
    })),
    style: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
    /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */ sx: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object,
            (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
        ])),
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).object
    ]),
    /**
   * If `true`, the Data Grid enables column virtualization when `getRowHeight` is set to `() => 'auto'`.
   * By default, column virtualization is disabled when dynamic row height is enabled to measure the row height correctly.
   * For datasets with a large number of columns, this can cause performance issues.
   * The downside of enabling this prop is that the row height will be estimated based the cells that are currently rendered, which can cause row height change when scrolling horizontally.
   * @default false
   */ virtualizeColumnsWithAutoRowHeight: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};


parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $35a2ae7aa7a495fb$export$5f98a4d34d356b3a(vehicle) {
    return vehicle.custodiesList ? vehicle.custodiesList[vehicle.custodiesList.length - 1] : undefined;
}
function $35a2ae7aa7a495fb$export$a5c9c5d07279e16f(vehicle) {
    return vehicle.custodiesList ? vehicle.custodiesList[vehicle.custodiesList.length - 1]?.dealership?.street : undefined;
}
function $35a2ae7aa7a495fb$export$9356c5112a6b6d3a(vehicle) {
    return vehicle.custodiesList ? vehicle.custodiesList[vehicle.custodiesList.length - 1]?.dealership?.name : undefined;
}




function $f8a966b44356c3ef$export$daac4493292fef86({ assignVehicle: assignVehicle, customerTier: customerTier, assignedVehicle: assignedVehicle, unAssignVehicle: unAssignVehicle, reservationStatus: reservationStatus, make: make, programId: programId, vehicleId: vehicleId }) {
    const [{ visibleAssignmentColumns: visibleAssignmentColumns, vehiclePage: vehiclePage, vin: vin }, setQueryParams] = (0, $9963aa6f9102c92d$export$b37ee0d76c6d2fbc)({
        vehiclePage: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 0),
        visibleAssignmentColumns: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$4c7eaae15e9a9af5), {
            color: true,
            make: true,
            model: true,
            mileage: true,
            trim: true,
            dealerName: true,
            dealerAddress: false,
            acquired: true,
            vin: true,
            assignment: true
        }),
        vin: (0, $edbc22aa0be45f44$export$cc4e5467ec2866fa)
    });
    const criteria = [
        {
            property: 'make',
            query: make?.toLowerCase?.() || 'tesla'
        },
        {
            property: 'status',
            query: 'eligible'
        },
        ...vin?.length ? [
            {
                property: 'vin',
                query: vin
            }
        ] : []
    ];
    // TODO - remove?
    // criteria.push({
    //   property: 'model',
    //   query: '',
    //   // query: isModel3 ? '3' : 'Y',
    // })
    const requestParams = {
        page: vehiclePage,
        customerId: '',
        criteriaList: criteria,
        resultsPerPage: 5
    };
    const onColumnVisibilityModelChange = (newModel)=>{
        setQueryParams({
            visibleAssignmentColumns: newModel
        });
    };
    const setPage = (nextPage)=>{
        setQueryParams({
            vehiclePage: nextPage
        });
    };
    const setVIN = (nextVIN)=>{
        setQueryParams({
            vin: nextVIN
        });
    };
    const defaultVinModalState = {
        open: false,
        onClose: undefined,
        handleYesClick: undefined,
        headerText: ''
    };
    const [vinModal, setVinModal] = (0, $acw62.useState)(defaultVinModalState);
    const { data: vehicles, isFetching: isFetching } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'getVehicles',
            requestParams,
            vin,
            customerTier,
            assignedVehicle
        ],
        queryFn: async ()=>{
            return (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getVehicles(requestParams, programId).then(async (vehicleResponse)=>{
                const customerIsQualified = (0, $ba66fc54ecff33a1$export$94aae6a0d3dbf771)(customerTier);
                const vehicles = vehicleResponse.vehiclesList.map((v)=>({
                        ...v.vehicle,
                        color: $f8a966b44356c3ef$var$getExteriorColor(v.vehicle),
                        dealerAddress: (0, $35a2ae7aa7a495fb$export$a5c9c5d07279e16f)(v.vehicle),
                        dealerName: (0, $35a2ae7aa7a495fb$export$9356c5112a6b6d3a)(v.vehicle),
                        text: 'Assign',
                        assignVehicle: ()=>assignVehicle(v.vehicle.id),
                        disabled: !customerIsQualified
                    }));
                return {
                    vehiclesList: vehicles,
                    total: vehicleResponse.total
                };
            });
        },
        placeholderData: {
            vehiclesList: [],
            total: 0
        },
        enabled: !!make
    });
    const { data: vehicleById } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'getVehicleById',
            vehicleId
        ],
        queryFn: async ()=>{
            return (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getVehicleById(vehicleId).then(async (vehicle)=>{
                const telematics = await (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getTelematics(vehicle.vehicle.id);
                return {
                    vehiclesList: [
                        {
                            ...vehicle.vehicle,
                            text: 'Unassign',
                            assignVehicle: ()=>unAssignVehicle(),
                            color: vehicle.vehicle.exteriorColor,
                            mileage: telematics.telematicsList[0]?.odometer?.reading || '',
                            odo_date: telematics.telematicsList[0]?.odometer?.date || ''
                        }
                    ],
                    total: 1
                };
            });
        },
        enabled: !!vehicleId
    });
    return {
        vehicles: reservationStatus === 'ASSIGNED_VEHICLE' && vehicleId ? vehicleById : vehicles,
        visibleAssignmentColumns: visibleAssignmentColumns,
        onColumnVisibilityModelChange: onColumnVisibilityModelChange,
        setPage: setPage,
        vehiclePage: vehiclePage,
        isFetching: isFetching,
        setVIN: setVIN,
        vin: vin,
        vinModal: vinModal,
        setVinModal: setVinModal,
        defaultVinModalState: defaultVinModalState
    };
}
function $f8a966b44356c3ef$var$getExteriorColor(vehicle) {
    return vehicle?.exteriorColorsList?.[0]?.title;
}






parcelRequire("acw62");

const $b73b1a1a7f4cd50c$export$4b85d3515bd863a5 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
        fillRule: "evenodd",
        d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
        clipRule: "evenodd"
    })
}), 'Search');


parcelRequire("acw62");
const $6bca7e63d5d08434$export$b373baffdd40f8d5 = ({ setQuery: setQuery, setSearch: setSearch, search: search, label: label })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            m: 1,
            maxWidth: '100%',
            width: 500
        },
        children: setSearch ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
            fullWidth: true,
            InputProps: {
                startAdornment: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                    position: "start",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b73b1a1a7f4cd50c$export$4b85d3515bd863a5), {
                        fontSize: "small"
                    })
                })
            },
            placeholder: label,
            onChange: (e)=>setSearch(e.target.value),
            value: search
        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
            fullWidth: true,
            InputProps: {
                startAdornment: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ffab78552448ba6$export$2e2bcd8739ae039), {
                    position: "start",
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b73b1a1a7f4cd50c$export$4b85d3515bd863a5), {
                        fontSize: "small"
                    })
                })
            },
            placeholder: label,
            onChange: setQuery,
            value: search
        })
    });
};



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

function $64a991b625bf2127$var$Transition(props, ref) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a15b5db10b6f7d3d$export$2e2bcd8739ae039), {
        direction: "up",
        ref: ref,
        ...props
    });
}
var $64a991b625bf2127$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).forwardRef($64a991b625bf2127$var$Transition);


const $2e38d778218a8111$export$74bcd60541ea52d2 = ({ open: open, onClose: onClose, headerText: headerText, handleYesClick: handleYesClick })=>{
    return null;
};


const $03d3e6e469d38706$export$f68eea315d32c2d5 = (props)=>{
    const { make: make, programId: programId, vehicleId: vehicleId } = props;
    const { vehicles: vehicles, setPage: setPage, vehiclePage: vehiclePage, isFetching: isFetching, onColumnVisibilityModelChange: onColumnVisibilityModelChange, visibleAssignmentColumns: visibleAssignmentColumns, setVIN: setVIN, vin: vin, vinModal: vinModal, setVinModal: setVinModal, defaultVinModalState: defaultVinModalState } = (0, $f8a966b44356c3ef$export$daac4493292fef86)({
        assignVehicle: props.assignVehicle,
        customerTier: props.customerTier,
        reload: props.reload,
        assignedVehicle: props.assignedVehicle,
        unAssignVehicle: props.unAssignVehicle,
        reservationStatus: props.reservationStatus,
        make: make,
        programId: programId,
        vehicleId: vehicleId
    });
    const columns = [
        {
            field: 'color',
            headerName: 'Color',
            flex: 0.75
        },
        {
            field: 'year',
            headerName: 'Year',
            flex: 0.75
        },
        {
            field: 'make',
            headerName: 'Make',
            flex: 0.5
        },
        {
            field: 'model',
            headerName: 'Model',
            flex: 0.5
        },
        {
            field: 'trim',
            headerName: 'Trim',
            flex: 0.75,
            renderCell (props) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                    title: props.row.trim,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: props.row.trim
                    })
                });
            }
        },
        {
            field: 'mileage',
            headerName: 'Odometer',
            flex: 0.5
        },
        {
            field: 'odo_date',
            headerName: 'Odo Date',
            flex: 0.5
        },
        {
            field: 'dealerName',
            headerName: 'Dealership',
            flex: 1.2,
            renderCell (props) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                    title: props.row.dealerAddress,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: props.row.dealerName
                    })
                });
            }
        },
        {
            field: 'dealerAddress',
            headerName: 'Dealer Address',
            flex: 1.2,
            renderCell (props) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                    title: props.row.dealerAddress,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: props.row.dealerAddress
                    })
                });
            }
        },
        {
            field: 'vin',
            headerName: 'VIN',
            flex: 1.2,
            renderCell (props) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                    title: props.row.vin,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: props.row.vin
                    })
                });
            }
        },
        {
            field: 'assignment',
            headerName: '',
            flex: 1,
            renderCell (props) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>props.row.assignVehicle(),
                    disabled: props.row.disabled,
                    children: props.row.text
                });
            }
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        component: "div",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: 6,
                        component: "div",
                        children: [
                            (0, $ba66fc54ecff33a1$export$94aae6a0d3dbf771)(props.customerTier) && !props.assignedVehicle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: "Select a vehicle to assign to this customer."
                            }),
                            !(0, $ba66fc54ecff33a1$export$94aae6a0d3dbf771)(props.customerTier) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                children: "Approve the customer before assigning a vehicle"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: 6,
                        justifyContent: "flex-end",
                        component: "div",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bca7e63d5d08434$export$b373baffdd40f8d5), {
                            label: "Search by VIN",
                            search: vin,
                            setQuery: (evt)=>{
                                setVIN(evt.target.value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                columns: columns,
                rows: vehicles?.vehiclesList || [],
                rowCount: vehicles?.total ?? 0,
                loading: props.reservationLoading || isFetching,
                pagination: true,
                paginationModel: {
                    page: vehiclePage,
                    pageSize: 5
                },
                onColumnVisibilityModelChange: onColumnVisibilityModelChange,
                columnVisibilityModel: visibleAssignmentColumns,
                disableColumnFilter: true,
                paginationMode: "server",
                onPaginationModelChange: (newPage)=>setPage(newPage.page)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2e38d778218a8111$export$74bcd60541ea52d2), {
                open: vinModal.open,
                onClose: ()=>setVinModal(defaultVinModalState),
                headerText: vinModal.headerText,
                handleYesClick: vinModal.handleYesClick
            })
        ]
    });
};



parcelRequire("acw62");




parcelRequire("acw62");

function $b52c145902c76ee3$export$2e2bcd8739ae039({ label: label, value: value }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        size: {
            xs: 12,
            sm: 6,
            md: 3
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "caption",
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: value || 'N/A'
            })
        ]
    });
}





var $gQESC = parcelRequire("gQESC");

function $5ce3a959b6628486$var$getPolicyStatusFromEnum(num) {
    return (0, $2fe0bab7a0e34f9c$export$5b979a6faa693550)((0, $gQESC.PolicyStatus), num);
}
function $5ce3a959b6628486$export$cfb655cde9661b99({ customerId: customerId, subscriptionId: subscriptionId }) {
    const { data: insuranceStatus } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'insurance-status',
            subscriptionId
        ],
        queryFn: async ()=>{
            const result = await (0, $dbaa63f10354f5f5$export$d966a79b1da26514)(customerId, subscriptionId);
            return result ?? '';
        },
        enabled: !!subscriptionId
    });
    const { isQualified: isQualified, policyId: policyId, effectiveDate: effectiveDate, expirationDate: expirationDate, monthlyRate: monthlyRate, excessMileageRate: excessMileageRate, status: status } = insuranceStatus || {};
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        direction: "column",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 5,
                        mb: 5,
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b52c145902c76ee3$export$2e2bcd8739ae039), {
                                label: "Insurance Type",
                                value: isQualified ? 'Integrated' : 'BYOI'
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b52c145902c76ee3$export$2e2bcd8739ae039), {
                                label: "Status",
                                value: $5ce3a959b6628486$var$getPolicyStatusFromEnum(status)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b52c145902c76ee3$export$2e2bcd8739ae039), {
                                label: "Effective Date",
                                value: effectiveDate > 0 ? (0, $303ba10db2c74ab4$export$d9468344d3651243)(new Date(effectiveDate), 'MM/dd/yyyy') : ''
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b52c145902c76ee3$export$2e2bcd8739ae039), {
                                label: "Expiration Date",
                                value: expirationDate > 0 ? (0, $303ba10db2c74ab4$export$d9468344d3651243)(new Date(expirationDate), 'MM/dd/yyyy') : ''
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        container: true,
                        spacing: 5,
                        direction: "row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b52c145902c76ee3$export$2e2bcd8739ae039), {
                                label: "Policy Number",
                                value: policyId
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b52c145902c76ee3$export$2e2bcd8739ae039), {
                                label: "Premium Monthly / Daily",
                                value: `${(0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(monthlyRate)} / Month`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b52c145902c76ee3$export$2e2bcd8739ae039), {
                                label: "Mileage Overage Premium",
                                value: `${(0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(excessMileageRate)} / Mile`
                            })
                        ]
                    })
                ]
            })
        })
    });
}



parcelRequire("acw62");



const $3a0e47c7ac790cec$var$useInsuranceQuoteBlock = ()=>{
    function useInsuranceQuote({ subscriptionId: subscriptionId, customerId: customerId }) {
        const { data: insuranceQuote } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/insuranceQuote'
            ],
            queryFn: ()=>(0, $dbaa63f10354f5f5$export$9ade3a2b6295a98f)({
                    subscriptionId: subscriptionId,
                    customerId: customerId
                }).then((res)=>res)
        });
        return {
            insuranceQuote: insuranceQuote
        };
    }
    function useLatestQuoteGroup({ subscriptionId: subscriptionId }) {
        const { data: latestQuoteGroup } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/latestQuoteGroup'
            ],
            queryFn: ()=>(0, $dbaa63f10354f5f5$export$c0dc680866c8e1e9)({
                    subscriptionId: subscriptionId
                }).then((res)=>res.latestquoteresponseList),
            placeholderData: []
        });
        return {
            latestQuoteGroup: latestQuoteGroup
        };
    }
    return {
        useInsuranceQuote: useInsuranceQuote,
        useLatestQuoteGroup: useLatestQuoteGroup
    };
};
var $3a0e47c7ac790cec$export$2e2bcd8739ae039 = $3a0e47c7ac790cec$var$useInsuranceQuoteBlock;




const $3c4d6745e58e085e$var$columns = [
    {
        field: 'quoteId',
        headerName: 'Quote Id',
        flex: 0.75
    },
    {
        field: 'limits',
        headerName: 'Limits',
        flex: 0.5
    },
    {
        field: 'deductible',
        headerName: 'Deductible',
        flex: 0.5,
        renderCell: (params)=>{
            return (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(params.row.deductible);
        }
    },
    {
        field: 'monthlyRate',
        headerName: 'Monthly Rate',
        flex: 0.5,
        renderCell: (params)=>{
            return (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(params.row.monthlyRate);
        }
    },
    {
        field: 'mileageRate',
        headerName: 'Mileage Rate',
        flex: 0.5,
        renderCell: (params)=>{
            return (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(params.row.mileageRate);
        }
    }
];
const $3c4d6745e58e085e$var$quoteColumns = [
    {
        field: 'quoteId',
        headerName: 'Quote Id',
        flex: 0.75
    },
    {
        field: 'limits',
        headerName: 'Limits',
        flex: 1
    },
    {
        field: 'deductible',
        headerName: 'Deductible',
        flex: 0.5,
        renderCell: (params)=>{
            return (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(params.row.deductible);
        }
    },
    {
        field: 'monthlyRate',
        headerName: 'Monthly Rate',
        flex: 0.5,
        renderCell: (params)=>{
            return (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(params.row.monthlyRate);
        }
    },
    {
        field: 'mileageRate',
        headerName: 'Mileage Rate',
        flex: 0.5,
        renderCell: (params)=>{
            return (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(params.row.mileageRate);
        }
    },
    {
        field: 'state',
        headerName: 'State',
        flex: 0.5
    },
    {
        field: 'zip',
        headerName: 'Zip',
        flex: 0.5
    },
    {
        field: 'vehicleMake',
        headerName: 'Make',
        flex: 0.5
    },
    {
        field: 'vehicleModel',
        headerName: 'Model',
        flex: 0.5
    },
    {
        field: 'vehicleVin',
        headerName: 'VIN',
        flex: 0.5
    },
    {
        field: 'createdAt',
        headerName: 'Created At',
        flex: 0.75,
        renderCell: (params)=>{
            return new Date(params.row.createdAt).toLocaleDateString();
        }
    }
];
const $3c4d6745e58e085e$var$EMPTY_QUOTE = '00000000-0000-0000-0000-000000000000';
const $3c4d6745e58e085e$var$InsuranceQuoteBlock = ({ subscriptionId: subscriptionId, customerId: customerId })=>{
    const { useInsuranceQuote: useInsuranceQuote } = (0, $3a0e47c7ac790cec$export$2e2bcd8739ae039)();
    const { insuranceQuote: insuranceQuote } = useInsuranceQuote({
        subscriptionId: subscriptionId,
        customerId: customerId
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        direction: "column",
        spacing: 6,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            children: insuranceQuote?.quoteId && insuranceQuote?.quoteId !== $3c4d6745e58e085e$var$EMPTY_QUOTE ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                autoHeight: true,
                columns: $3c4d6745e58e085e$var$columns,
                rows: insuranceQuote || [],
                getRowId: (row)=>row.quoteId,
                disableColumnFilter: true
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($3c4d6745e58e085e$var$LatestQuoteGroup, {
                subscriptionId: subscriptionId
            })
        })
    });
};
const $3c4d6745e58e085e$var$LatestQuoteGroup = ({ subscriptionId: subscriptionId })=>{
    const { useLatestQuoteGroup: useLatestQuoteGroup } = (0, $3a0e47c7ac790cec$export$2e2bcd8739ae039)();
    const { latestQuoteGroup: latestQuoteGroup } = useLatestQuoteGroup({
        subscriptionId: subscriptionId
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        direction: "column",
        spacing: 6,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            children: latestQuoteGroup?.length ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                autoHeight: true,
                columns: $3c4d6745e58e085e$var$quoteColumns,
                rows: latestQuoteGroup || [],
                getRowId: (row)=>row.quoteId,
                // pageSize={6}
                disableColumnFilter: true
            }) : 'Latest quote group not found'
        })
    });
};
var $3c4d6745e58e085e$export$2e2bcd8739ae039 = $3c4d6745e58e085e$var$InsuranceQuoteBlock;






var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");









function $64c9c67b6531c050$export$315cb19215f77ce0(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTable', slot);
}
const $64c9c67b6531c050$var$tableClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTable', [
    'root',
    'stickyHeader'
]);
var $64c9c67b6531c050$export$2e2bcd8739ae039 = $64c9c67b6531c050$var$tableClasses;



'use client';
const $f087e22488590525$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, stickyHeader: stickyHeader } = ownerState;
    const slots = {
        root: [
            'root',
            stickyHeader && 'stickyHeader'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $64c9c67b6531c050$export$315cb19215f77ce0), classes);
};
const $f087e22488590525$var$TableRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('table', {
    name: 'MuiTable',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.stickyHeader && styles.stickyHeader
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'table',
        width: '100%',
        borderCollapse: 'collapse',
        borderSpacing: 0,
        '& caption': {
            ...theme.typography.body2,
            padding: theme.spacing(2),
            color: (theme.vars || theme).palette.text.secondary,
            textAlign: 'left',
            captionSide: 'bottom'
        },
        variants: [
            {
                props: ({ ownerState: ownerState })=>ownerState.stickyHeader,
                style: {
                    borderCollapse: 'separate'
                }
            }
        ]
    })));
const $f087e22488590525$var$defaultComponent = 'table';
const $f087e22488590525$var$Table = /*#__PURE__*/ $acw62.forwardRef(function Table(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTable'
    });
    const { className: className, component: component = $f087e22488590525$var$defaultComponent, padding: padding = 'normal', size: size = 'medium', stickyHeader: stickyHeader = false, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        padding: padding,
        size: size,
        stickyHeader: stickyHeader
    };
    const classes = $f087e22488590525$var$useUtilityClasses(ownerState);
    const table = $acw62.useMemo(()=>({
            padding: padding,
            size: size,
            stickyHeader: stickyHeader
        }), [
        padding,
        size,
        stickyHeader
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $607c3485b4f38191$export$2e2bcd8739ae039).Provider, {
        value: table,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f087e22488590525$var$TableRoot, {
            as: component,
            role: component === $f087e22488590525$var$defaultComponent ? null : 'table',
            ref: ref,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ownerState: ownerState,
            ...other
        })
    });
});
var $f087e22488590525$export$2e2bcd8739ae039 = $f087e22488590525$var$Table;


var $acw62 = parcelRequire("acw62");








function $43d98f398793ab7d$export$98bd2a9b566ec665(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTableBody', slot);
}
const $43d98f398793ab7d$var$tableBodyClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTableBody', [
    'root'
]);
var $43d98f398793ab7d$export$2e2bcd8739ae039 = $43d98f398793ab7d$var$tableBodyClasses;



'use client';
const $791aa0d72f2174bf$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $43d98f398793ab7d$export$98bd2a9b566ec665), classes);
};
const $791aa0d72f2174bf$var$TableBodyRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('tbody', {
    name: 'MuiTableBody',
    slot: 'Root'
})({
    display: 'table-row-group'
});
const $791aa0d72f2174bf$var$tablelvl2 = {
    variant: 'body'
};
const $791aa0d72f2174bf$var$defaultComponent = 'tbody';
const $791aa0d72f2174bf$var$TableBody = /*#__PURE__*/ $acw62.forwardRef(function TableBody(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableBody'
    });
    const { className: className, component: component = $791aa0d72f2174bf$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $791aa0d72f2174bf$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59c9ddddb511cdd6$export$2e2bcd8739ae039).Provider, {
        value: $791aa0d72f2174bf$var$tablelvl2,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($791aa0d72f2174bf$var$TableBodyRoot, {
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            as: component,
            ref: ref,
            role: component === $791aa0d72f2174bf$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $791aa0d72f2174bf$export$2e2bcd8739ae039 = $791aa0d72f2174bf$var$TableBody;


var $acw62 = parcelRequire("acw62");







function $73e1f9234e51787e$export$eed427986a7abdf9(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTableContainer', slot);
}
const $73e1f9234e51787e$var$tableContainerClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTableContainer', [
    'root'
]);
var $73e1f9234e51787e$export$2e2bcd8739ae039 = $73e1f9234e51787e$var$tableContainerClasses;



'use client';
const $0d8d66642fc2c080$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $73e1f9234e51787e$export$eed427986a7abdf9), classes);
};
const $0d8d66642fc2c080$var$TableContainerRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiTableContainer',
    slot: 'Root'
})({
    width: '100%',
    overflowX: 'auto'
});
const $0d8d66642fc2c080$var$TableContainer = /*#__PURE__*/ $acw62.forwardRef(function TableContainer(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableContainer'
    });
    const { className: className, component: component = 'div', ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $0d8d66642fc2c080$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0d8d66642fc2c080$var$TableContainerRoot, {
        ref: ref,
        as: component,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ownerState: ownerState,
        ...other
    });
});
var $0d8d66642fc2c080$export$2e2bcd8739ae039 = $0d8d66642fc2c080$var$TableContainer;


var $acw62 = parcelRequire("acw62");








function $42315241ec1b66a7$export$2e731cea2d1c2392(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTableHead', slot);
}
const $42315241ec1b66a7$var$tableHeadClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTableHead', [
    'root'
]);
var $42315241ec1b66a7$export$2e2bcd8739ae039 = $42315241ec1b66a7$var$tableHeadClasses;



'use client';
const $9fd7c480e10ebc69$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $42315241ec1b66a7$export$2e731cea2d1c2392), classes);
};
const $9fd7c480e10ebc69$var$TableHeadRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('thead', {
    name: 'MuiTableHead',
    slot: 'Root'
})({
    display: 'table-header-group'
});
const $9fd7c480e10ebc69$var$tablelvl2 = {
    variant: 'head'
};
const $9fd7c480e10ebc69$var$defaultComponent = 'thead';
const $9fd7c480e10ebc69$var$TableHead = /*#__PURE__*/ $acw62.forwardRef(function TableHead(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableHead'
    });
    const { className: className, component: component = $9fd7c480e10ebc69$var$defaultComponent, ...other } = props;
    const ownerState = {
        ...props,
        component: component
    };
    const classes = $9fd7c480e10ebc69$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $59c9ddddb511cdd6$export$2e2bcd8739ae039).Provider, {
        value: $9fd7c480e10ebc69$var$tablelvl2,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($9fd7c480e10ebc69$var$TableHeadRoot, {
            as: component,
            className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
            ref: ref,
            role: component === $9fd7c480e10ebc69$var$defaultComponent ? null : 'rowgroup',
            ownerState: ownerState,
            ...other
        })
    });
});
var $9fd7c480e10ebc69$export$2e2bcd8739ae039 = $9fd7c480e10ebc69$var$TableHead;


var $acw62 = parcelRequire("acw62");









function $dc6dc2b9872aeb3e$export$ba0a6d6c28940107(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiTableRow', slot);
}
const $dc6dc2b9872aeb3e$var$tableRowClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiTableRow', [
    'root',
    'selected',
    'hover',
    'head',
    'footer'
]);
var $dc6dc2b9872aeb3e$export$2e2bcd8739ae039 = $dc6dc2b9872aeb3e$var$tableRowClasses;



'use client';
const $7e1593b31b92bf3c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, selected: selected, hover: hover, head: head, footer: footer } = ownerState;
    const slots = {
        root: [
            'root',
            selected && 'selected',
            hover && 'hover',
            head && 'head',
            footer && 'footer'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $dc6dc2b9872aeb3e$export$ba0a6d6c28940107), classes);
};
const $7e1593b31b92bf3c$var$TableRowRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('tr', {
    name: 'MuiTableRow',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.head && styles.head,
            ownerState.footer && styles.footer
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: 'inherit',
        display: 'table-row',
        verticalAlign: 'middle',
        // We disable the focus ring for mouse, touch and keyboard users.
        outline: 0,
        [`&.${(0, $dc6dc2b9872aeb3e$export$2e2bcd8739ae039).hover}:hover`]: {
            backgroundColor: (theme.vars || theme).palette.action.hover
        },
        [`&.${(0, $dc6dc2b9872aeb3e$export$2e2bcd8739ae039).selected}`]: {
            backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, (theme.vars || theme).palette.action.selectedOpacity),
            '&:hover': {
                backgroundColor: theme.alpha((theme.vars || theme).palette.primary.main, `${(theme.vars || theme).palette.action.selectedOpacity} + ${(theme.vars || theme).palette.action.hoverOpacity}`)
            }
        }
    })));
const $7e1593b31b92bf3c$var$defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */ const $7e1593b31b92bf3c$var$TableRow = /*#__PURE__*/ $acw62.forwardRef(function TableRow(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiTableRow'
    });
    const { className: className, component: component = $7e1593b31b92bf3c$var$defaultComponent, hover: hover = false, selected: selected = false, ...other } = props;
    const tablelvl2 = $acw62.useContext((0, $59c9ddddb511cdd6$export$2e2bcd8739ae039));
    const ownerState = {
        ...props,
        component: component,
        hover: hover,
        selected: selected,
        head: tablelvl2 && tablelvl2.variant === 'head',
        footer: tablelvl2 && tablelvl2.variant === 'footer'
    };
    const classes = $7e1593b31b92bf3c$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($7e1593b31b92bf3c$var$TableRowRoot, {
        as: component,
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        role: component === $7e1593b31b92bf3c$var$defaultComponent ? null : 'row',
        ownerState: ownerState,
        ...other
    });
});
var $7e1593b31b92bf3c$export$2e2bcd8739ae039 = $7e1593b31b92bf3c$var$TableRow;








const $f87fe1403bd28bb8$var$ConvertToGalpinModal = ({ isOpen: isOpen, onClose: onClose, onConfirm: onConfirm, loading: loading })=>{
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4e95d56438178f01$export$2e2bcd8739ae039), {
        open: isOpen,
        onClose: onClose,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            sx: {
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 400,
                bgcolor: 'background.paper',
                border: '2px solid #000',
                boxShadow: 24,
                p: 4
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "h6",
                            component: "h2",
                            children: "Convert to Galpin"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "body2",
                            children: "Are you sure you want to convert this customer to Galpin? This action cannot be undone."
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                justifyContent: 'flex-end',
                                gap: 2
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                    variant: "outlined",
                                    onClick: onClose,
                                    disabled: loading,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                    variant: "contained",
                                    color: "primary",
                                    onClick: onConfirm,
                                    disabled: loading,
                                    sx: {
                                        ...currentTheme === 'galpin' && {
                                            backgroundColor: themeColors.buttonColor,
                                            color: 'black',
                                            '&:hover': {
                                                backgroundColor: themeColors.buttonHover
                                            }
                                        }
                                    },
                                    children: loading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {
                                        size: 20
                                    }) : 'Confirm'
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const $f87fe1403bd28bb8$export$3722f4e6102a7b0a = ({ reservation: reservation })=>{
    const [isModalOpen, setIsModalOpen] = (0, $acw62.useState)(false);
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const customerId = reservation?.customer?.id;
    const customerPhone = reservation?.customerInfo?.phone;
    const reservationId = reservation?.id;
    // Fetch list of clients to map client IDs to names
    const { data: clients } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'clients'
        ],
        queryFn: (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getListClients,
        placeholderData: []
    });
    // Create a mapping function from client ID to client name
    const getClientName = (clientId)=>{
        const client = clients?.find((client)=>client.id === clientId);
        return client?.name || clientId || 'Unknown';
    };
    // Fetch related accounts based on phone number
    const { data: relatedAccounts, isLoading: isLoading, error: error } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'related-accounts',
            customerPhone
        ],
        queryFn: async ()=>{
            if (!customerPhone) return [];
            try {
                const response = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getAllCustomersByPhone(customerPhone);
                return response.customersList?.map((customer)=>({
                        customerId: customer.customerId,
                        clientId: customer.clientId || 'Unknown',
                        accountNumber: customer.accountNumber || 'N/A'
                    })) || [];
            } catch (error) {
                console.error('Error fetching related accounts:', error);
                return [];
            }
        },
        enabled: !!customerPhone,
        staleTime: 300000,
        // 5 minutes
        retry: 1
    });
    // Exclude current customer
    const filteredRelatedAccounts = relatedAccounts?.filter((customer)=>customer.customerId !== customerId);
    // Convert to Galpin mutation
    const convertToGalpinMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).convertToGalpinTesla(reservationId),
        onSuccess: ()=>{
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Successfully converted to Galpin');
            setIsModalOpen(false);
            queryClient.invalidateQueries({
                queryKey: [
                    'related-accounts'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    '/reservation'
                ]
            });
        },
        onError: (error)=>{
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Failed to convert to Galpin');
            console.error('Convert to Galpin error:', error);
        }
    });
    // Check if any related customer has Galpin client ID or name
    const hasGalpinCustomer = relatedAccounts?.some((customer)=>{
        const clientName = getClientName(customer.clientId);
        return clientName?.toLowerCase().includes('galpin');
    });
    // Don't render anything if loading, no phone number, or error occurred
    if (isLoading || !customerPhone || error) {
        if (error) console.error('related accounts error:', error);
        return null;
    }
    // Render the component if we have connected customers OR if we need to show Convert to Galpin button
    const shouldRender = filteredRelatedAccounts?.length > 0 || !hasGalpinCustomer && !reservation?.vehicleId;
    if (!shouldRender) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
        sx: {
            mb: 3,
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "h6",
                component: "h2",
                sx: {
                    mb: 2
                },
                children: "Related Accounts"
            }),
            filteredRelatedAccounts?.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d8d66642fc2c080$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Client Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Account Number"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                            children: filteredRelatedAccounts.map((customer)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: getClientName(customer.clientId)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a), {
                                                to: `/customers/${customer.customerId}`,
                                                style: {
                                                    color: themeColors.buttonColor,
                                                    textDecoration: 'none'
                                                },
                                                children: customer.accountNumber
                                            })
                                        })
                                    ]
                                }, customer.customerId))
                        })
                    ]
                })
            }),
            !hasGalpinCustomer && !reservation?.vehicleId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    mt: 2
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    variant: "contained",
                    color: "primary",
                    onClick: ()=>setIsModalOpen(true),
                    sx: {
                        ...currentTheme === 'galpin' && {
                            backgroundColor: themeColors.buttonColor,
                            color: 'black',
                            '&:hover': {
                                backgroundColor: themeColors.buttonHover
                            }
                        }
                    },
                    children: "Convert to Galpin"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($f87fe1403bd28bb8$var$ConvertToGalpinModal, {
                isOpen: isModalOpen,
                onClose: ()=>setIsModalOpen(false),
                onConfirm: ()=>convertToGalpinMutation.mutate(),
                loading: convertToGalpinMutation.isPending
            })
        ]
    });
};


const $435a806a26a7beb9$var$ReservationPage = ()=>{
    const { reservation: reservation, isAdmin: isAdmin, overrideQualification: overrideQualification, overrideQualificationSuccess: overrideQualificationSuccess, mostRecentNote: mostRecentNote, currentNote: currentNote, setCurrentNote: setCurrentNote, recalculateCustomerScores: recalculateCustomerScores, recalculateCustomerScoresSuccess: recalculateCustomerScoresSuccess, setReload: setReload, assignVehicle: assignVehicle, unassignVehicle: unassignVehicle, addNote: addNote, cancelReservation: cancelReservation, cancelError: cancelError, isLoading: isLoading, reservationError: reservationError, toggleChangeProgram: toggleChangeProgram, changeProgramOpen: changeProgramOpen, cqeScores: cqeScores, disqualificationVendor: disqualificationVendor, overrideDisqualificationVendor: overrideDisqualificationVendor, setOverrideDisqualificationVendor: setOverrideDisqualificationVendor } = (0, $ba66fc54ecff33a1$export$dba8ba4729e1fba8)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $13157ffc893b45e9$export$2e2bcd8739ae039), {
        maxWidth: false,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $89da4f4236459888$export$2e2bcd8739ae039), {
                open: isLoading,
                sx: {
                    color: '#fff',
                    zIndex: (theme)=>theme.zIndex.drawer + 1
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b17c694846cf5b75$export$e0d897ee21382f67), {
                lastPageRoute: "/fleet/reservations"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $48a14f90dc08d980$export$89693000420c0acd), {
                heading: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "h1",
                    children: [
                        "Reservation Details /",
                        ' ',
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                            children: reservation?.assignedVehicle?.model || ''
                        })
                    ]
                }),
                headerHasBottomBorder: true,
                actionBlock: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: toggleChangeProgram,
                    variant: "contained",
                    sx: {
                        backgroundColor: themeColors.buttonColor,
                        color: currentTheme === 'galpin' ? 'black' : 'white',
                        '&:hover': {
                            backgroundColor: themeColors.buttonHover
                        }
                    },
                    children: "Switch Programs"
                }),
                children: [
                    reservationError ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        children: reservationError['message']
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                                heading: reservation.customer.clientId == '613e89a2-2a57-4050-9b7e-eda0a1bf94a7' ? 'Galpin Customer' : 'Autonomy Customer',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5f92f616d48bbd7d$export$59a692ba92dddb52), {
                                    ...reservation
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f87fe1403bd28bb8$export$3722f4e6102a7b0a), {
                                reservation: reservation
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                                heading: "Vehicle",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $154ed310eb944a43$export$8f79f7e8574c1588), {
                                    ...reservation.vehicle
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                                heading: "Activation status",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2bc764fa5fcc997b$export$a5326926b495d2a4), {
                                    currentActivity: reservation.customerInfo.currentActivity,
                                    currentStatus: reservation.status,
                                    isQualified: reservation.isQualified,
                                    customerId: reservation?.customerId,
                                    subscriptionId: reservation?.subscriptionId
                                })
                            }),
                            reservation?.customerInfo?.accountNumber && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cc6d71f55d833bda$export$8edc068b3cbba07f), {
                                reservation: reservation
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f6b7d9384424390e$export$f686aa0f89bcde3b), {}),
                            (reservation.qualifications?.hasQualifications || isAdmin) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                                heading: "Update Record",
                                subSection: true,
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $804346d7295114d5$export$597ca2d8e7b20542), {
                                    currentTier: reservation.customerInfo.qualificationTier,
                                    overrideQualification: overrideQualification,
                                    overrideQualificationSuccess: overrideQualificationSuccess,
                                    note: currentNote,
                                    setNote: setCurrentNote,
                                    mostRecentNote: mostRecentNote,
                                    addNote: addNote,
                                    customer: reservation?.customer,
                                    recalculateCustomerScores: recalculateCustomerScores,
                                    recalculateCustomerScoresSuccess: recalculateCustomerScoresSuccess,
                                    isAdmin: isAdmin,
                                    cqeScores: cqeScores,
                                    disqualificationVendor: disqualificationVendor,
                                    overrideDisqualificationVendor: overrideDisqualificationVendor,
                                    setOverrideDisqualificationVendor: setOverrideDisqualificationVendor
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56e17ea657bb7318$export$bbcf1fe2cd8eca8b), {
                                reservation: reservation,
                                isAdmin: isAdmin,
                                setReload: setReload
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                                heading: "Reservation Assignment",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $03d3e6e469d38706$export$f68eea315d32c2d5), {
                                    customerTier: reservation.customerInfo.qualificationTier,
                                    reload: false,
                                    reservationLoading: isLoading,
                                    assignVehicle: (vehicleId)=>{
                                        assignVehicle(vehicleId);
                                    },
                                    assignedVehicle: reservation?.assignedVehicle,
                                    unAssignVehicle: unassignVehicle,
                                    reservationStatus: reservation?.reservationStatus,
                                    make: reservation?.make,
                                    programId: reservation?.programId,
                                    vehicleId: reservation?.vehicleId
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                                heading: "Insurance",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce3a959b6628486$export$cfb655cde9661b99), {
                                    subscriptionId: reservation?.subscriptionId,
                                    customerId: reservation?.customerId
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                                heading: "Insurance Quote",
                                children: reservation.subscriptionId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c4d6745e58e085e$export$2e2bcd8739ae039), {
                                    subscriptionId: reservation?.subscriptionId,
                                    customerId: reservation?.customer?.id
                                }) : null
                            }),
                            reservation.customer.activityState !== (0, $3QqPt.ActivityState).SUBSCRIPTION_ACTIVATED && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                                heading: "Cancel Order",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af3984dcab9b625b$export$1f6dee4e45145df4), {
                                    isCancelled: reservation.isCancelled,
                                    cancelSubscription: cancelReservation,
                                    errorCancelling: cancelError
                                })
                            })
                        ]
                    }),
                    changeProgramOpen && // replaced current program with programId
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29492eb6bf2c8d13$export$32cfcb97eb24bd66), {
                        isOpen: changeProgramOpen,
                        onClose: toggleChangeProgram,
                        programId: reservation?.programId,
                        customerId: reservation?.customer?.id,
                        reservation: reservation?.reservation,
                        postal: reservation?.reservation.postal
                    })
                ]
            })
        ]
    });
};
var $435a806a26a7beb9$export$2e2bcd8739ae039 = $435a806a26a7beb9$var$ReservationPage;




parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");






parcelRequire("acw62");


'use client';
var $10ff9607852514f4$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');




function $a7f45ab90486060a$export$ffd560f22c0ecf04(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiAvatar', slot);
}
const $a7f45ab90486060a$var$avatarClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiAvatar', [
    'root',
    'colorDefault',
    'circular',
    'rounded',
    'square',
    'img',
    'fallback'
]);
var $a7f45ab90486060a$export$2e2bcd8739ae039 = $a7f45ab90486060a$var$avatarClasses;




'use client';
const $d8ccf690a89a14e5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, variant: variant, colorDefault: colorDefault } = ownerState;
    const slots = {
        root: [
            'root',
            variant,
            colorDefault && 'colorDefault'
        ],
        img: [
            'img'
        ],
        fallback: [
            'fallback'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $a7f45ab90486060a$export$ffd560f22c0ecf04), classes);
};
const $d8ccf690a89a14e5$var$AvatarRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAvatar',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.variant],
            ownerState.colorDefault && styles.colorDefault
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 40,
        height: 40,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(20),
        lineHeight: 1,
        borderRadius: '50%',
        overflow: 'hidden',
        userSelect: 'none',
        variants: [
            {
                props: {
                    variant: 'rounded'
                },
                style: {
                    borderRadius: (theme.vars || theme).shape.borderRadius
                }
            },
            {
                props: {
                    variant: 'square'
                },
                style: {
                    borderRadius: 0
                }
            },
            {
                props: {
                    colorDefault: true
                },
                style: {
                    color: (theme.vars || theme).palette.background.default,
                    ...theme.vars ? {
                        backgroundColor: theme.vars.palette.Avatar.defaultBg
                    } : {
                        backgroundColor: theme.palette.grey[400],
                        ...theme.applyStyles('dark', {
                            backgroundColor: theme.palette.grey[600]
                        })
                    }
                }
            }
        ]
    })));
const $d8ccf690a89a14e5$var$AvatarImg = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('img', {
    name: 'MuiAvatar',
    slot: 'Img'
})({
    width: '100%',
    height: '100%',
    textAlign: 'center',
    // Handle non-square image.
    objectFit: 'cover',
    // Hide alt text.
    color: 'transparent',
    // Hide the image broken icon, only works on Chrome.
    textIndent: 10000
});
const $d8ccf690a89a14e5$var$AvatarFallback = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $10ff9607852514f4$export$2e2bcd8739ae039), {
    name: 'MuiAvatar',
    slot: 'Fallback'
})({
    width: '75%',
    height: '75%'
});
function $d8ccf690a89a14e5$var$useLoaded({ crossOrigin: crossOrigin, referrerPolicy: referrerPolicy, src: src, srcSet: srcSet }) {
    const [loaded, setLoaded] = $acw62.useState(false);
    $acw62.useEffect(()=>{
        if (!src && !srcSet) return undefined;
        setLoaded(false);
        let active = true;
        const image = new Image();
        image.onload = ()=>{
            if (!active) return;
            setLoaded('loaded');
        };
        image.onerror = ()=>{
            if (!active) return;
            setLoaded('error');
        };
        image.crossOrigin = crossOrigin;
        image.referrerPolicy = referrerPolicy;
        image.src = src;
        if (srcSet) image.srcset = srcSet;
        return ()=>{
            active = false;
        };
    }, [
        crossOrigin,
        referrerPolicy,
        src,
        srcSet
    ]);
    return loaded;
}
const $d8ccf690a89a14e5$var$Avatar = /*#__PURE__*/ $acw62.forwardRef(function Avatar(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAvatar'
    });
    const { alt: alt, children: childrenProp, className: className, component: component = 'div', slots: slots = {}, slotProps: slotProps = {}, imgProps: imgProps, sizes: sizes, src: src, srcSet: srcSet, variant: variant = 'circular', ...other } = props;
    let children = null;
    const ownerState = {
        ...props,
        component: component,
        variant: variant
    };
    // Use a hook instead of onError on the img element to support server-side rendering.
    const loaded = $d8ccf690a89a14e5$var$useLoaded({
        ...imgProps,
        ...typeof slotProps.img === 'function' ? slotProps.img(ownerState) : slotProps.img,
        src: src,
        srcSet: srcSet
    });
    const hasImg = src || srcSet;
    const hasImgNotFailing = hasImg && loaded !== 'error';
    ownerState.colorDefault = !hasImgNotFailing;
    // This issue explains why this is required: https://github.com/mui/material-ui/issues/42184
    delete ownerState.ownerState;
    const classes = $d8ccf690a89a14e5$var$useUtilityClasses(ownerState);
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $d8ccf690a89a14e5$var$AvatarRoot,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            component: component,
            ...other
        },
        ownerState: ownerState
    });
    const [ImgSlot, imgSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('img', {
        className: classes.img,
        elementType: $d8ccf690a89a14e5$var$AvatarImg,
        externalForwardedProps: {
            slots: slots,
            slotProps: {
                img: {
                    ...imgProps,
                    ...slotProps.img
                }
            }
        },
        additionalProps: {
            alt: alt,
            src: src,
            srcSet: srcSet,
            sizes: sizes
        },
        ownerState: ownerState
    });
    const [FallbackSlot, fallbackSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('fallback', {
        className: classes.fallback,
        elementType: $d8ccf690a89a14e5$var$AvatarFallback,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps
        },
        shouldForwardComponentProp: true,
        ownerState: ownerState
    });
    if (hasImgNotFailing) children = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ImgSlot, {
        ...imgSlotProps
    });
    else if (!!childrenProp || childrenProp === 0) children = childrenProp;
    else if (hasImg && alt) children = alt[0];
    else children = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(FallbackSlot, {
        ...fallbackSlotProps
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        children: children
    });
});
var $d8ccf690a89a14e5$export$2e2bcd8739ae039 = $d8ccf690a89a14e5$var$Avatar;





var $acw62 = parcelRequire("acw62");




function $8f939e503a4cc6d3$export$3ae94a2503e890a1(date) {
    if (date === 0 || date == undefined || date == null) return 'Not Available';
    return (0, $303ba10db2c74ab4$export$d9468344d3651243)(date, 'MM/dd/yyyy');
}
const $8f939e503a4cc6d3$export$69ac1778977ccd3b = (unit = 'seconds')=>{
    // Get the current date and time
    const now = new Date();
    // Get the timestamp in milliseconds since epoch
    const timestampMilliseconds = now.getTime();
    // Return the timestamp in the specified unit
    if (unit === 'milliseconds') return timestampMilliseconds;
    else if (unit === 'seconds') return Math.floor(timestampMilliseconds / 1000);
    throw new Error('Invalid unit. Please specify "seconds" or "milliseconds".');
};
const $8f939e503a4cc6d3$export$6f32b2293d1d7b88 = (date, unit = 'seconds')=>{
    // Parse the date if it's a string
    const parsedDate = typeof date === 'string' ? new Date(date) : date;
    // Check if the parsed date is valid
    if (isNaN(parsedDate.getTime())) throw new Error('Invalid date. Please provide a valid date string or Date object.');
    // Get the timestamp in milliseconds since epoch
    const timestampMilliseconds = parsedDate.getTime();
    // Return the timestamp in the specified unit
    if (unit === 'milliseconds') return timestampMilliseconds;
    else if (unit === 'seconds') return Math.floor(timestampMilliseconds / 1000);
    throw new Error('Invalid unit. Please specify "seconds" or "milliseconds".');
};



var $3QqPt = parcelRequire("3QqPt");

function $f2f778d43eec38b2$export$578f7347ca8140dd(value) {
    if (value === undefined || value === null || value === '' || value == ' ') return 'Not Available';
    return value;
}
function $f2f778d43eec38b2$export$6dbf02895378f949(reservation) {
    return `${reservation?.customer?.customerInfo?.firstName} ${reservation?.customer?.customerInfo?.lastName}`;
}
function $f2f778d43eec38b2$export$a7b62c66cbe5cfdc(number) {
    if (number !== 'Not Available') {
        const tenDigitNum = number.substr(-10);
        return `(${tenDigitNum.substr(0, 3)}) ${tenDigitNum.substr(3, 3)} - ${tenDigitNum.substr(-4)}`;
    }
    return number;
}
function $f2f778d43eec38b2$export$6530c096a296138b(statementStatusEnum) {
    if (statementStatusEnum === (0, $3QqPt.StatementStatus).PENDING) return (0, $33cc3a71f154a56f$export$2a19aeb1ef6f18bf).PENDING.label;
    if (statementStatusEnum === (0, $3QqPt.StatementStatus).PAID) return (0, $33cc3a71f154a56f$export$2a19aeb1ef6f18bf).PAID.label;
    if (statementStatusEnum === (0, $3QqPt.StatementStatus).OVERDUE) return (0, $33cc3a71f154a56f$export$2a19aeb1ef6f18bf).OVERDUE.label;
    if (statementStatusEnum === (0, $3QqPt.StatementStatus).DUE) return (0, $33cc3a71f154a56f$export$2a19aeb1ef6f18bf).DUE.label;
    return (0, $33cc3a71f154a56f$export$2a19aeb1ef6f18bf).CANCELLED.label;
}
function $f2f778d43eec38b2$export$8a55d8c21190bedc(statement, status) {
    if (status === (0, $3QqPt.StatementStatus).PAID && statement.transactionsList.length) return statement.transactionsList.find(({ transactionType: transactionType })=>transactionType === (0, $3QqPt.Transaction).TransactionType.CAPTURE)?.gatewayTransactionId;
    return null;
}
function $f2f778d43eec38b2$export$9ab766ce7f4c1f3c(addresses, addressTypeEnum) {
    const address = addresses.find((address)=>address.addressType === addressTypeEnum);
    return address ? `${address.street}, ${address.street2 ? address.street2 : ''}, ${address.city}, ${address.state}, ${address.postal}` : 'Not Available';
}
function $f2f778d43eec38b2$export$824fbc6d67da65c5(addresses, addressTypeEnum) {
    const address = addresses.find((address)=>address.addressType === addressTypeEnum);
    return address ? address.id : null;
}
function $f2f778d43eec38b2$export$1135c229e41c145c(addressTypeEnum) {
    if (addressTypeEnum === (0, $3QqPt.Address).AddressType.PARKING) return (0, $33cc3a71f154a56f$export$337f79c9f8c30060).PARKING.label;
    if (addressTypeEnum === (0, $3QqPt.Address).AddressType.LICENSE) return (0, $33cc3a71f154a56f$export$337f79c9f8c30060).LICENSE.label;
    return (0, $33cc3a71f154a56f$export$337f79c9f8c30060).CONTACT.label;
}
function $f2f778d43eec38b2$export$c5848ec2255dec3d(lineItems) {
    return lineItems.reduce((acc, lineItem)=>{
        return acc + lineItem.amount;
    }, 0);
}
function $f2f778d43eec38b2$export$db6b4ceaaa022ac4(lineItems) {
    return lineItems.reduce((acc, lineItem)=>{
        return acc + lineItem.balance;
    }, 0);
}
function $f2f778d43eec38b2$export$a32e53414ab3e3fc(reservation) {
    return {
        firstName: $f2f778d43eec38b2$export$578f7347ca8140dd(reservation?.customer?.customerInfo?.firstName),
        lastName: $f2f778d43eec38b2$export$578f7347ca8140dd(reservation?.customer?.customerInfo?.lastName),
        email: $f2f778d43eec38b2$export$578f7347ca8140dd(reservation?.customer?.customerInfo?.email),
        phone: $f2f778d43eec38b2$export$578f7347ca8140dd(reservation?.customer?.customerInfo?.phone),
        parkingAddress: $f2f778d43eec38b2$export$9ab766ce7f4c1f3c(reservation?.customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.PARKING),
        licenseAddress: $f2f778d43eec38b2$export$9ab766ce7f4c1f3c(reservation?.customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.LICENSE),
        contactAddress: $f2f778d43eec38b2$export$9ab766ce7f4c1f3c(reservation?.customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.CONTACT),
        accountNumber: $f2f778d43eec38b2$export$578f7347ca8140dd(reservation?.customer?.accountNumber),
        licenseExpirationDate: (0, $8f939e503a4cc6d3$export$3ae94a2503e890a1)(reservation?.customer?.customerInfo?.licenseExpirationDate),
        parkingAddressId: $f2f778d43eec38b2$export$824fbc6d67da65c5(reservation?.customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.PARKING),
        licenseAddressId: $f2f778d43eec38b2$export$824fbc6d67da65c5(reservation?.customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.LICENSE),
        contactAddressId: $f2f778d43eec38b2$export$824fbc6d67da65c5(reservation?.customer?.customerInfo?.addressesList, (0, $3QqPt.Address).AddressType.CONTACT)
    };
}




function $669372cabeb8bdf2$export$d532413968a6b27b() {
    const { customerId: customerId } = (0, $84c11e79798ea0cb$export$99eaa27ddbbb95ef)();
    const { clientId: clientId, setClientId: setClientId } = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { data: customer } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/customers',
            customerId
        ],
        queryFn: async ()=>{
            const customerDetails = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getCustomerById(customerId).then((res)=>{
                if (clientId !== res.customer.clientId) setClientId(res.customer.clientId);
                return {
                    customerId: customerId,
                    customerName: (0, $f2f778d43eec38b2$export$6dbf02895378f949)(res),
                    customerInfo: (0, $f2f778d43eec38b2$export$a32e53414ab3e3fc)(res),
                    isCustomerError: false,
                    clientId: res.customer.clientId
                };
            });
            const subscriptionIds = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listCustomerSubscriptions(customerId).then((res)=>{
                return res.subscriptionsList.map((subscription)=>{
                    return subscription.id;
                });
            });
            const firstSubscriptionId = subscriptionIds[0];
            // Multiple subscriptions on customer not supported in nexus yet.
            // Log error if there is more than one subscription
            if (subscriptionIds.length > 1) console.error('Customer has more than one subscription');
            const subscriptionDetails = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getSubscriptionById(firstSubscriptionId).then((res)=>{
                return {
                    subscriptionId: firstSubscriptionId,
                    subscriptionStatus: res.status,
                    recurringBillingDay: res.recurringBillingDay,
                    vehicleId: res.vehicleId
                };
            });
            return {
                ...customerDetails,
                ...subscriptionDetails
            };
        },
        placeholderData: {
            customerId: '',
            customerName: '',
            customerInfo: {},
            subscriptionStatus: '',
            subscriptionId: '',
            recurringBillingDay: 0,
            isCustomerError: false,
            vehicleId: '',
            clientId: '1f40fe9f-6819-4277-b4f5-33e5a4a95e12'
        }
    });
    const mutationUpdateFakePhoneNumber = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (customerId)=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).UpdateCustomerWithFakePhone(customerId);
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    '/customers',
                    customerId
                ]
            });
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Record updated.');
        },
        onError (e) {
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Something went wrong or there is an error updating the record.');
            console.log('Error: ', e);
        }
    });
    const updateCustomerWithFakePhone = (customerId)=>{
        return mutationUpdateFakePhoneNumber.mutateAsync(customerId);
    };
    return {
        customerId: customerId,
        customerName: customer?.customerName,
        customerInfo: customer?.customerInfo,
        subscriptionStatus: customer?.subscriptionStatus,
        subscriptionId: customer?.subscriptionId,
        recurringBillingDay: customer?.recurringBillingDay,
        isCustomerError: customer?.isCustomerError,
        updateCustomerWithFakePhone: updateCustomerWithFakePhone,
        vehicleId: customer?.vehicleId,
        clientId: customer.clientId
    };
}
const $669372cabeb8bdf2$var$CustomerContext = /*#__PURE__*/ (0, $acw62.createContext)(null);
// ! An optional step that we might consider using? Makes it easier to identify it in react dev tools
$669372cabeb8bdf2$var$CustomerContext.displayName = 'CustomerContext';
const $669372cabeb8bdf2$export$3f89740658197ba2 = ()=>{
    return (0, $acw62.useContext)($669372cabeb8bdf2$var$CustomerContext);
};
const $669372cabeb8bdf2$export$64955b2e44f9e48f = ({ children: children })=>{
    const value = $669372cabeb8bdf2$export$d532413968a6b27b();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($669372cabeb8bdf2$var$CustomerContext.Provider, {
        value: value,
        children: children
    });
};







var $acw62 = parcelRequire("acw62");



function $88eea4e5230f159b$export$813cd56b64316822() {
    const { customerId: customerId, customerInfo: customerInfo } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const [loading, setLoading] = (0, $acw62.useState)(false);
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const handleOnClick = async ()=>{
        const { accountNumber: accountNumber, phone: phone } = customerInfo;
        setLoading(true);
        try {
            await (0, $4bdfc929de3d2884$export$3ebb475fb1fa8348)({
                accountNumber: accountNumber,
                customerId: customerId,
                phoneNumber: `+1${phone.replace(/\D/g, '')}`
            });
        } catch (error) {
            console.error('Error:', error);
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
            color: "error",
            disabled: loading,
            onClick: handleOnClick,
            type: "button",
            variant: "contained",
            sx: {
                backgroundColor: 'error.main',
                color: 'white',
                '&:hover': {
                    backgroundColor: 'error.dark'
                },
                // For Galpin theme, override with silver when not error state
                ...currentTheme === 'galpin' && {
                    backgroundColor: themeColors.buttonColor,
                    color: 'black',
                    '&:hover': {
                        backgroundColor: themeColors.buttonHover
                    }
                }
            },
            children: [
                "Reset Login Attempts",
                ' ',
                loading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {
                    sx: {
                        marginLeft: 1
                    },
                    size: 20
                })
            ]
        })
    });
}








var $acw62 = parcelRequire("acw62");

const $36e6d184a1a4e3c5$export$5b34b48eec116bc0 = ()=>{
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { customerId: customerId } = (0, $84c11e79798ea0cb$export$99eaa27ddbbb95ef)();
    const [isEditCustomerModalOpen, setIsEditCustomerModalOpen] = (0, $acw62.useState)(false);
    const { mutate: updateCustomer, error: updateCustomerError } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ({ firstName: firstName, lastName: lastName, email: email, phone: phone })=>{
            try {
                return await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).updateCustomer({
                    customerId: customerId,
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    phone: phone
                });
            } catch (err) {
                console.error({
                    message: 'Error',
                    err: err,
                    params: {
                        firstName: firstName,
                        lastName: lastName,
                        email: email,
                        phone: phone
                    }
                });
                // ! Allow UI to handle but log error so that datadog picks up additional data
                throw err;
            }
        },
        onSuccess () {
            setIsEditCustomerModalOpen(false);
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Customer details updated.');
            queryClient.invalidateQueries([
                '/customers',
                customerId
            ]);
        },
        onError () {
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Something went wrong');
            console.log('Error: ', updateCustomerError);
        }
    });
    return {
        updateCustomer: updateCustomer,
        isEditCustomerModalOpen: isEditCustomerModalOpen,
        setIsEditCustomerModalOpen: setIsEditCustomerModalOpen
    };
};




parcelRequire("acw62");





parcelRequire("acw62");




"use client";
var $2684aca16ee287df$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M1 21h22L12 2zm12-3h-2v-2h2zm0-4h-2v-4h2z"
}), 'WarningOutlined');


const $1c636adc2e18838b$export$942b2219c902021e = ({ text: text })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            display: 'flex'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8ccf690a89a14e5$export$2e2bcd8739ae039), {
                sx: {
                    backgroundColor: (theme)=>(0, $7ebe803ced17df29$export$58f0f39f63f3cf42)(theme.palette.error.main, 0.08),
                    color: 'error.main',
                    mr: 2
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2684aca16ee287df$export$2e2bcd8739ae039), {
                    fontSize: "small"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                color: "textSecondary",
                sx: {
                    mt: 1
                },
                variant: "body2",
                children: text
            })
        ]
    });
};


const $945f23a59ed0c9e6$export$1101813cf03a97d3 = ({ errors: errors, control: control })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "firstName",
                control: control,
                rules: {
                    required: 'This field is required',
                    max: 100
                },
                render: ({ field: { onChange: onChange, ...rest } })=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "First Name",
                        margin: "normal",
                        onChange: onChange,
                        ...rest
                    });
                }
            }),
            errors?.firstName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.firstName.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "lastName",
                control: control,
                rules: {
                    required: 'This field is required',
                    max: 100
                },
                render: ({ field: { onChange: onChange, ...rest } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "Last Name",
                        margin: "normal",
                        onChange: onChange,
                        ...rest
                    })
            }),
            errors?.lastName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.lastName.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: "phone",
                    control: control,
                    rules: {
                        required: 'This field is Required',
                        pattern: {
                            value: /^\+?[1-9]\d{1,14}$/,
                            message: 'Phone format includes the country code and then numeric only ie +10000000000'
                        }
                    },
                    defaultValue: null,
                    render: ({ field: { onChange: onChange, ...rest } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: "Phone Number",
                            margin: "normal",
                            onChange: onChange,
                            ...rest
                        })
                })
            }),
            errors?.phone && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.phone.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: "email",
                    control: control,
                    rules: {
                        required: 'This field is Required',
                        pattern: {
                            value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                            message: 'Invalid email address'
                        }
                    },
                    defaultValue: null,
                    render: ({ field: { onChange: onChange, ...rest } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            fullWidth: true,
                            label: "Email",
                            margin: "normal",
                            onChange: onChange,
                            ...rest
                        })
                })
            }),
            errors?.email && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.email.message
            })
        ]
    });
};


const $bf12675b18a38fc7$var$CustomerDetailsTabsWrapper = ()=>{
    const { customerId: customerId, customerName: customerName, recurringBillingDay: recurringBillingDay, customerInfo: currentCustomer, clientId: clientId } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const { updateCustomer: updateCustomer, isEditCustomerModalOpen: isEditCustomerModalOpen, setIsEditCustomerModalOpen: setIsEditCustomerModalOpen } = (0, $36e6d184a1a4e3c5$export$5b34b48eec116bc0)();
    const { pathname: pathname } = (0, $84c11e79798ea0cb$export$45d76561a5302f2b)();
    const handleClickOpen = ()=>{
    // Empty function for onClick event
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    backgroundColor: 'background.default',
                    p: 3
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        alignItems: 'center',
                        display: 'flex',
                        justifyContent: 'space-between',
                        backgroundColor: 'background.default',
                        p: 3
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d8ccf690a89a14e5$export$2e2bcd8739ae039), {
                                    src: '',
                                    sx: {
                                        height: 42,
                                        width: 42
                                    },
                                    onClick: ()=>{
                                        setIsEditCustomerModalOpen(true);
                                    }
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                    sx: {
                                        ml: 1
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            sx: {
                                                fontSize: 25
                                            },
                                            color: "inherit",
                                            variant: "subtitle2",
                                            children: customerName
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                            variant: "body2",
                                            children: clientId == '613e89a2-2a57-4050-9b7e-eda0a1bf94a7' ? 'Galpin Customer' : 'Autonomy Customer'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                            variant: "body2",
                                            children: [
                                                "customer_id: ",
                                                customerId
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex'
                            },
                            children: recurringBillingDay != 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    ml: 1,
                                    marginRight: '60px'
                                },
                                onClick: handleClickOpen,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).pink,
                                        variant: "overline",
                                        children: "Recurring Billing Day"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "h4",
                                        align: 'center',
                                        children: recurringBillingDay
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ade8931e75b51e59$export$2e2bcd8739ae039), {
                        sx: {
                            px: 3
                        },
                        value: pathname,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                                component: (0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a),
                                label: 'Details',
                                value: `/customers/${customerId}`,
                                to: `/customers/${customerId}`,
                                sx: {
                                    color: themeColors.buttonColor,
                                    '&.Mui-selected': {
                                        color: themeColors.buttonColor
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                                component: (0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a),
                                label: 'Invoices',
                                value: `/customers/${customerId}/invoices`,
                                to: `/customers/${customerId}/invoices`,
                                sx: {
                                    color: themeColors.buttonColor,
                                    '&.Mui-selected': {
                                        color: themeColors.buttonColor
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                                component: (0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a),
                                label: 'CQE',
                                value: `/customers/${customerId}/cqe`,
                                to: `/customers/${customerId}/cqe`,
                                sx: {
                                    color: themeColors.buttonColor,
                                    '&.Mui-selected': {
                                        color: themeColors.buttonColor
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                                component: (0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a),
                                label: 'Mileage',
                                value: `/customers/${customerId}/mileage`,
                                to: `/customers/${customerId}/mileage`,
                                sx: {
                                    color: themeColors.buttonColor,
                                    '&.Mui-selected': {
                                        color: themeColors.buttonColor
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                                component: (0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a),
                                label: 'Documents',
                                value: `/customers/${customerId}/documents`,
                                to: `/customers/${customerId}/documents`,
                                sx: {
                                    color: themeColors.buttonColor,
                                    '&.Mui-selected': {
                                        color: themeColors.buttonColor
                                    }
                                }
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1f657281bee3142$export$2e2bcd8739ae039), {
                                component: (0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a),
                                label: 'Insurance',
                                value: `/customers/${customerId}/insurance`,
                                to: `/customers/${customerId}/insurance`,
                                sx: {
                                    color: themeColors.buttonColor,
                                    '&.Mui-selected': {
                                        color: themeColors.buttonColor
                                    }
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2e2000df495a70f$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$910ae8079b2c2852), {})
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    alignItems: 'center',
                    display: 'flex',
                    justifyContent: 'flex-end',
                    marginTop: 3,
                    marginBottom: 5
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $88eea4e5230f159b$export$813cd56b64316822), {})
            }),
            isEditCustomerModalOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                isDrawerOpen: isEditCustomerModalOpen,
                setIsDrawerOpen: setIsEditCustomerModalOpen,
                header: 'Edit Customer',
                handleSave: updateCustomer,
                defaultValues: currentCustomer,
                form: ({ errors: errors, control: control })=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $945f23a59ed0c9e6$export$1101813cf03a97d3), {
                        errors: errors,
                        control: control
                    });
                }
            })
        ]
    });
};
const $bf12675b18a38fc7$export$7adf003668c36e7b = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $669372cabeb8bdf2$export$64955b2e44f9e48f), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($bf12675b18a38fc7$var$CustomerDetailsTabsWrapper, {})
    });
};



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");







function $04899bf9b90c69d2$export$f54c8b0d04b67946(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiCardHeader', slot);
}
const $04899bf9b90c69d2$var$cardHeaderClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiCardHeader', [
    'root',
    'avatar',
    'action',
    'content',
    'title',
    'subheader'
]);
var $04899bf9b90c69d2$export$2e2bcd8739ae039 = $04899bf9b90c69d2$var$cardHeaderClasses;




'use client';
const $4d96ced3da041714$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ],
        avatar: [
            'avatar'
        ],
        action: [
            'action'
        ],
        content: [
            'content'
        ],
        title: [
            'title'
        ],
        subheader: [
            'subheader'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $04899bf9b90c69d2$export$f54c8b0d04b67946), classes);
};
const $4d96ced3da041714$var$CardHeaderRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardHeader',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        return [
            {
                [`& .${(0, $04899bf9b90c69d2$export$2e2bcd8739ae039).title}`]: styles.title
            },
            {
                [`& .${(0, $04899bf9b90c69d2$export$2e2bcd8739ae039).subheader}`]: styles.subheader
            },
            styles.root
        ];
    }
})({
    display: 'flex',
    alignItems: 'center',
    padding: 16
});
const $4d96ced3da041714$var$CardHeaderAvatar = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardHeader',
    slot: 'Avatar'
})({
    display: 'flex',
    flex: '0 0 auto',
    marginRight: 16
});
const $4d96ced3da041714$var$CardHeaderAction = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardHeader',
    slot: 'Action'
})({
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -4,
    marginRight: -8,
    marginBottom: -4
});
const $4d96ced3da041714$var$CardHeaderContent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiCardHeader',
    slot: 'Content'
})({
    flex: '1 1 auto',
    [`.${(0, $6e9163c6dd169139$export$2e2bcd8739ae039).root}:where(& .${(0, $04899bf9b90c69d2$export$2e2bcd8739ae039).title})`]: {
        display: 'block'
    },
    [`.${(0, $6e9163c6dd169139$export$2e2bcd8739ae039).root}:where(& .${(0, $04899bf9b90c69d2$export$2e2bcd8739ae039).subheader})`]: {
        display: 'block'
    }
});
const $4d96ced3da041714$var$CardHeader = /*#__PURE__*/ $acw62.forwardRef(function CardHeader(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCardHeader'
    });
    const { action: action, avatar: avatar, component: component = 'div', disableTypography: disableTypography = false, subheader: subheaderProp, subheaderTypographyProps: subheaderTypographyProps, title: titleProp, titleTypographyProps: titleTypographyProps, slots: slots = {}, slotProps: slotProps = {}, ...other } = props;
    const ownerState = {
        ...props,
        component: component,
        disableTypography: disableTypography
    };
    const classes = $4d96ced3da041714$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: {
            title: titleTypographyProps,
            subheader: subheaderTypographyProps,
            ...slotProps
        }
    };
    let title = titleProp;
    const [TitleSlot, titleSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('title', {
        className: classes.title,
        elementType: (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'h5',
            component: 'span'
        }
    });
    if (title != null && title.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) title = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TitleSlot, {
        ...titleSlotProps,
        children: title
    });
    let subheader = subheaderProp;
    const [SubheaderSlot, subheaderSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('subheader', {
        className: classes.subheader,
        elementType: (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        additionalProps: {
            variant: avatar ? 'body2' : 'body1',
            color: 'textSecondary',
            component: 'span'
        }
    });
    if (subheader != null && subheader.type !== (0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039) && !disableTypography) subheader = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(SubheaderSlot, {
        ...subheaderSlotProps,
        children: subheader
    });
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        className: classes.root,
        elementType: $4d96ced3da041714$var$CardHeaderRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other,
            component: component
        },
        ownerState: ownerState
    });
    const [AvatarSlot, avatarSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('avatar', {
        className: classes.avatar,
        elementType: $4d96ced3da041714$var$CardHeaderAvatar,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ContentSlot, contentSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('content', {
        className: classes.content,
        elementType: $4d96ced3da041714$var$CardHeaderContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ActionSlot, actionSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('action', {
        className: classes.action,
        elementType: $4d96ced3da041714$var$CardHeaderAction,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            avatar && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(AvatarSlot, {
                ...avatarSlotProps,
                children: avatar
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(ContentSlot, {
                ...contentSlotProps,
                children: [
                    title,
                    subheader
                ]
            }),
            action && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ActionSlot, {
                ...actionSlotProps,
                children: action
            })
        ]
    });
});
var $4d96ced3da041714$export$2e2bcd8739ae039 = $4d96ced3da041714$var$CardHeader;







const $a33b36f0b3a60b4d$export$fd73ac02e5d7c765 = ()=>{
    const { data: promos } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/promotions'
        ],
        queryFn: async ()=>{
            const res = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listPromosRequest();
            return {
                promotions: res.resultsList
            };
        },
        placeholderData: {
            promotions: []
        }
    });
    const [{ page: page, rowsPerPage: rowsPerPage }, setQueryParams] = (0, $9963aa6f9102c92d$export$b37ee0d76c6d2fbc)({
        page: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 0),
        rowsPerPage: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 10)
    });
    const setPage = (nextPage)=>{
        setQueryParams({
            page: nextPage
        });
    };
    const setRowsPerPage = (nextRowsPerPage)=>{
        setQueryParams({
            rowsPerPage: nextRowsPerPage
        });
    };
    return {
        promos: promos,
        getPromotionSourceFromEnum: $a33b36f0b3a60b4d$export$62642a4ecb76d7fe,
        page: page,
        setPage: setPage,
        rowsPerPage: rowsPerPage,
        setRowsPerPage: setRowsPerPage,
        getPromoPartnerName: $a33b36f0b3a60b4d$export$c6a59d664fe0e2b8
    };
};
function $a33b36f0b3a60b4d$export$62642a4ecb76d7fe(promoSourceType) {
    if (promoSourceType === (0, $33cc3a71f154a56f$export$2cb2327bfc349061).CUSTOMER.value) return (0, $33cc3a71f154a56f$export$2cb2327bfc349061).CUSTOMER.label;
    return (0, $33cc3a71f154a56f$export$2cb2327bfc349061).PARTNER.label;
}
function $a33b36f0b3a60b4d$export$c6a59d664fe0e2b8(promoSourceId, promoPartners) {
    return promoPartners.find((partnerObj)=>promoSourceId === partnerObj.id)?.name;
}








const $b53946c651842b4e$export$7b3ecea59367e0a1 = ()=>{
    const { data: promoPartners } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/promopartners'
        ],
        queryFn: async ()=>{
            const res = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listPromoPartners();
            return {
                promoPartners: res.resultsList
            };
        },
        placeholderData: {
            promoPartners: []
        }
    });
    return {
        promoPartners: promoPartners
    };
};






var $acw62 = parcelRequire("acw62");
const $f9574e15466648b3$export$97a28c91c0f95a30 = ()=>{
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const [newPartnerId, setNewPartnerId] = (0, $acw62.useState)(undefined);
    const { mutate: createPromoPartner, error: createPromoPartnerError } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ({ name: name })=>{
            try {
                const res = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).createPromoPartner({
                    name: name
                });
                return setNewPartnerId(res.id);
            } catch (err) {
                console.error({
                    message: 'Error',
                    err: err,
                    params: {
                        name: name
                    }
                });
                // ! Allow UI to handle but log error so that datadog picks up additional data
                throw err;
            }
        },
        onSuccess () {
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Promo Partner Created!');
            queryClient.invalidateQueries({
                queryKey: [
                    '/promopartners'
                ]
            });
            setNewPartnerId(undefined);
        },
        onError () {
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Something went wrong with adding new promo partner');
            console.log('Error: ', createPromoPartnerError);
        }
    });
    return {
        createPromoPartner: createPromoPartner,
        newPartnerId: newPartnerId
    };
};
function $f9574e15466648b3$export$34547807b5ef7bdc(partnerInput) {
    if (partnerInput.includes('Add')) return partnerInput.replace('Add ', '').replace(/"/g, '');
    return partnerInput.toUpperCase();
}



var $acw62 = parcelRequire("acw62");
const $f41fc7c84a61d8e9$export$b187c129d2cbe9f4 = ()=>{
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { promoPartners: { promoPartners: promoPartners } } = (0, $b53946c651842b4e$export$7b3ecea59367e0a1)();
    const [isCreatePromoModalOpen, setIsCreatePromoModalOpen] = (0, $acw62.useState)(false);
    const [formInput, setFormInput] = (0, $acw62.useState)({});
    const { createPromoPartner: createPromoPartner, newPartnerId: newPartnerId } = (0, $f9574e15466648b3$export$97a28c91c0f95a30)();
    (0, $acw62.useEffect)(()=>{
        if (newPartnerId) {
            const formattedRequest = $f41fc7c84a61d8e9$export$8604ccdc8802918a(formInput, newPartnerId);
            createPromo(formattedRequest);
        }
    }, [
        newPartnerId
    ]);
    const { mutate: createPromo, error: createPromoError } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ({ promoCode: promoCode, rebateValue: rebateValue, rebatePercent: rebatePercent, target: target, source: source, sourceId: sourceId, validFrom: validFrom, validUntil: validUntil, status: status, constraintsList: constraintsList })=>{
            try {
                return await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).createPromoCode({
                    promoCode: promoCode,
                    rebateValue: rebateValue,
                    rebatePercent: rebatePercent,
                    target: target,
                    source: source,
                    sourceId: sourceId,
                    validFrom: validFrom,
                    validUntil: validUntil,
                    status: status,
                    constraintsList: constraintsList
                });
            } catch (err) {
                console.error({
                    message: 'Error',
                    err: err,
                    params: {
                        promoCode: promoCode,
                        rebateValue: rebateValue,
                        rebatePercent: rebatePercent,
                        target: target,
                        source: source,
                        sourceId: sourceId,
                        validFrom: validFrom,
                        validUntil: validUntil,
                        status: status,
                        constraintsList: constraintsList
                    }
                });
                // ! Allow UI to handle but log error so that datadog picks up additional data
                throw err;
            }
        },
        onSuccess () {
            setIsCreatePromoModalOpen(false);
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Promo Created!');
            queryClient.invalidateQueries({
                queryKey: [
                    '/promotions'
                ]
            });
        },
        onError () {
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Something went wrong or Promo code already exists!');
            console.log('Error: ', createPromoError);
        }
    });
    function getPartner(formData) {
        return promoPartners.find((partnerObj)=>formData.promoPartner === partnerObj.name);
    }
    function saveNewPromo(formData) {
        setFormInput(formData);
        const partner = getPartner(formData);
        if (partner) {
            const formattedPromoRequest = $f41fc7c84a61d8e9$export$8604ccdc8802918a(formData, partner.id);
            createPromo(formattedPromoRequest);
        } else createPromoPartner({
            name: formData.promoPartner
        });
    }
    return {
        saveNewPromo: saveNewPromo,
        isCreatePromoModalOpen: isCreatePromoModalOpen,
        setIsCreatePromoModalOpen: setIsCreatePromoModalOpen
    };
};
function $f41fc7c84a61d8e9$export$8604ccdc8802918a(formData, partnerId) {
    return {
        promoCode: formData.promoCode,
        rebateValue: (0, $ee0ab4f78b3163c4$export$7a3fce93cf9ac967)(formData.rebateValue),
        rebatePercent: 0,
        validFrom: formData.validFrom.getTime(),
        validUntil: formData.validUntil.getTime(),
        target: 0,
        source: 0,
        status: true,
        constraintsList: [],
        sourceId: partnerId
    };
}





parcelRequire("acw62");








const $108e423a4d645c7a$export$97df391fefd0049a = ({ promoPartners: promoPartners, errors: errors, control: control })=>{
    const filter = (0, $59fbdc39f1f5d354$export$f76f94b238d946d8)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "promoCode",
                control: control,
                rules: {
                    required: 'This field is required'
                },
                render: ({ field: { onChange: onChange } })=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "Promo Code",
                        margin: "normal",
                        onChange: onChange
                    });
                }
            }),
            errors?.promoCode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.promoCode.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "rebateValue",
                control: control,
                rules: {
                    required: 'This field is required',
                    max: 1000,
                    pattern: {
                        value: /^[1-9]\d*(\.\d+)?$/,
                        message: 'This input is number only'
                    }
                },
                render: ({ field: { onChange: onChange } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "Promo Amount",
                        margin: "normal",
                        onChange: onChange
                    })
            }),
            errors?.rebateValue && (errors.rebateValue.message ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.rebateValue.message
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: 'Promo Amount must be less than $1000.00'
            })),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: "validFrom",
                    control: control,
                    rules: {
                        required: 'This field is Required'
                    },
                    defaultValue: null,
                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                            label: "Start Date",
                            sx: {
                                width: '100%',
                                margin: '7.5px 0 7.5px 0'
                            },
                            onChange: onChange,
                            value: value
                        })
                })
            }),
            errors?.validFrom && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.validFrom.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                    name: "validUntil",
                    control: control,
                    rules: {
                        required: 'This field is Required'
                    },
                    defaultValue: null,
                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                            label: "End Date",
                            sx: {
                                width: '100%',
                                margin: '7.5px 0 7.5px 0'
                            },
                            onChange: onChange,
                            value: value
                        })
                })
            }),
            errors?.validUntil && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.validUntil.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "promoPartner",
                control: control,
                rules: {
                    required: 'This field is Required'
                },
                render: ({ field: { onChange: onChange } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db86fcacc6287e65$export$2e2bcd8739ae039), {
                        disableClearable: true,
                        options: promoPartners?.promoPartners?.map((partnerObj)=>partnerObj.name),
                        renderInput: (inputProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                ...inputProps,
                                label: "Promo Partner",
                                margin: "normal",
                                variant: "outlined"
                            }),
                        onChange: (_, data)=>onChange((0, $f9574e15466648b3$export$34547807b5ef7bdc)(data)),
                        filterOptions: (options, params)=>{
                            const filtered = filter(options, params);
                            const { inputValue: inputValue } = params;
                            // Suggest the creation of a new value
                            const isExisting = options.some((option)=>inputValue === option);
                            if (inputValue !== '' && !isExisting) filtered.push(`Add "${inputValue.toUpperCase()}"`);
                            return filtered;
                        }
                    })
            }),
            errors?.promoPartner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.promoPartner.message
            })
        ]
    });
};



const $4b760d6aa7d016e3$export$6ba7dff125b299e8 = ()=>{
    const { getPromotionSourceFromEnum: getPromotionSourceFromEnum, promos: promos, page: page, setPage: setPage, rowsPerPage: rowsPerPage, setRowsPerPage: setRowsPerPage, getPromoPartnerName: getPromoPartnerName } = (0, $a33b36f0b3a60b4d$export$fd73ac02e5d7c765)();
    const { saveNewPromo: saveNewPromo, isCreatePromoModalOpen: isCreatePromoModalOpen, setIsCreatePromoModalOpen: setIsCreatePromoModalOpen } = (0, $f41fc7c84a61d8e9$export$b187c129d2cbe9f4)();
    const { promoPartners: promoPartners } = (0, $b53946c651842b4e$export$7b3ecea59367e0a1)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            backgroundColor: 'background.default',
            p: 3
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    height: '30px',
                    marginBottom: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4d96ced3da041714$export$2e2bcd8739ae039), {
                        sx: {
                            padding: 'none'
                        },
                        title: 'Promotions'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        sx: {
                            mr: 3
                        },
                        color: "primary",
                        variant: "contained",
                        onClick: ()=>setIsCreatePromoModalOpen(true),
                        children: "Create Promotion"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                        size: 'small',
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: "Code Name"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: "Promo Amount"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: "Start"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: "End"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: "Partner"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: "Source Type"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                                children: promos.promotions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((promo)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                        hover: true,
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        alignItems: 'center',
                                                        display: 'flex'
                                                    },
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                        sx: {
                                                            ml: 1
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                            color: "inherit",
                                                            variant: "subtitle2",
                                                            children: promo.promoCode
                                                        })
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: (0, $c21ede28b8496a52$export$4ead0eaee86eb5fb)(promo.rebateValue)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: (0, $8f939e503a4cc6d3$export$3ae94a2503e890a1)(promo.validFrom)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: (0, $8f939e503a4cc6d3$export$3ae94a2503e890a1)(promo.validUntil)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: getPromoPartnerName(promo.sourceId, promoPartners.promoPartners)
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: getPromotionSourceFromEnum(promo.source)
                                            })
                                        ]
                                    }, promo?.promotionId))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e88806fdab3fc1ac$export$2e2bcd8739ae039), {
                        component: "div",
                        count: promos.promotions.length,
                        onPageChange: (event, newPage)=>setPage(newPage),
                        onRowsPerPageChange: (event)=>{
                            setRowsPerPage(parseInt(event.target.value, 10));
                            setPage(0);
                        },
                        page: page,
                        rowsPerPage: rowsPerPage,
                        rowsPerPageOptions: [
                            10,
                            25,
                            50
                        ]
                    })
                ]
            }),
            isCreatePromoModalOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                isDrawerOpen: isCreatePromoModalOpen,
                setIsDrawerOpen: setIsCreatePromoModalOpen,
                header: 'Create Promo',
                handleSave: saveNewPromo,
                form: ({ errors: errors, control: control })=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $108e423a4d645c7a$export$97df391fefd0049a), {
                        promoPartners: promoPartners,
                        errors: errors,
                        control: control
                    });
                }
            })
        ]
    });
};



parcelRequire("acw62");

parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $64c812a720876a94$export$c6c68f6e4db55944 = $acw62.createContext(null);
const $64c812a720876a94$export$507c997ee09bb471 = (props)=>{
    const [maps, setMaps] = (0, $acw62.useState)({});
    const onMapMount = (0, $acw62.useCallback)((map, id = 'default')=>{
        setMaps((currMaps)=>{
            if (id === 'current') throw new Error("'current' cannot be used as map id");
            if (currMaps[id]) throw new Error(`Multiple maps with the same id: ${id}`);
            return {
                ...currMaps,
                [id]: map
            };
        });
    }, []);
    const onMapUnmount = (0, $acw62.useCallback)((id = 'default')=>{
        setMaps((currMaps)=>{
            if (currMaps[id]) {
                const nextMaps = {
                    ...currMaps
                };
                delete nextMaps[id];
                return nextMaps;
            }
            return currMaps;
        });
    }, []);
    return $acw62.createElement($64c812a720876a94$export$c6c68f6e4db55944.Provider, {
        value: {
            maps: maps,
            onMapMount: onMapMount,
            onMapUnmount: onMapUnmount
        }
    }, props.children);
};
function $64c812a720876a94$export$86f8f9f08863e403() {
    const maps = (0, $acw62.useContext)($64c812a720876a94$export$c6c68f6e4db55944)?.maps;
    const currentMap = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85));
    const mapsWithCurrent = (0, $acw62.useMemo)(()=>{
        return {
            ...maps,
            current: currentMap?.map
        };
    }, [
        maps,
        currentMap
    ]);
    return mapsWithCurrent;
}


/**
 * Capture a transform's current state
 * @param transform
 * @returns descriptor of the view state
 */ function $ff5c44d8dbab1cdc$export$6a605c5aa5bd97a8(tr) {
    return {
        longitude: tr.center.lng,
        latitude: tr.center.lat,
        zoom: tr._seaLevelZoom ?? tr.zoom,
        pitch: tr.pitch,
        bearing: tr.bearing,
        padding: tr.padding,
        elevation: tr._centerAltitude
    };
}
function $ff5c44d8dbab1cdc$export$b36064f1be29a03f(v) {
    return Number.isFinite(v.longitude) || Number.isFinite(v.latitude) || Number.isFinite(v.zoom) || Number.isFinite(v.pitch) || Number.isFinite(v.bearing);
}
function $ff5c44d8dbab1cdc$export$b3dd58694e7dc7d6(tr, v) {
    if (Number.isFinite(v.longitude) && tr.center.lng !== v.longitude) return true;
    if (Number.isFinite(v.latitude) && tr.center.lat !== v.latitude) return true;
    if (Number.isFinite(v.bearing) && tr.bearing !== v.bearing) return true;
    if (Number.isFinite(v.pitch) && tr.pitch !== v.pitch) return true;
    if (Number.isFinite(v.zoom) && (tr._seaLevelZoom ?? tr.zoom) !== v.zoom) return true;
    if (v.padding && !tr.isPaddingEqual(v.padding)) return true;
    return false;
}
function $ff5c44d8dbab1cdc$var$noOp() {}
function $ff5c44d8dbab1cdc$export$5cf06eaeb862e3ce(tr, v) {
    // prevent constrain from running until all properties are set
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const constrain = tr._constrain;
    // eslint-disable-next-line @typescript-eslint/unbound-method
    const calcMatrices = tr._calcMatrices;
    tr._constrain = $ff5c44d8dbab1cdc$var$noOp;
    tr._calcMatrices = $ff5c44d8dbab1cdc$var$noOp;
    if (Number.isFinite(v.bearing)) tr.bearing = v.bearing;
    if (Number.isFinite(v.pitch)) tr.pitch = v.pitch;
    if (v.padding && !tr.isPaddingEqual(v.padding)) tr.padding = v.padding;
    if (Number.isFinite(v.longitude) || Number.isFinite(v.latitude)) {
        const center = tr.center;
        // @ts-expect-error LngLat constructor is not typed
        tr._center = new center.constructor(v.longitude ?? center.lng, v.latitude ?? center.lat);
    }
    if (Number.isFinite(v.zoom)) {
        tr._centerAltitude = v.elevation ?? 0;
        if (tr.elevation) {
            tr._seaLevelZoom = v.zoom;
            const mercatorElevation = tr.pixelsPerMeter / tr.worldSize * tr._centerAltitude;
            const altitude = tr._mercatorZfromZoom(v.zoom);
            const minHeight = tr._mercatorZfromZoom(tr._maxZoom);
            const height = Math.max(altitude - mercatorElevation, minHeight);
            tr._setZoom(tr._zoomFromMercatorZ(height));
        } else {
            tr._seaLevelZoom = null;
            tr.zoom = v.zoom;
        }
    }
    // restore methods
    tr._constrain = constrain;
    tr._calcMatrices = calcMatrices;
    if (!tr._unmodified) {
        tr._constrain();
        tr._calcMatrices();
    }
}



// These are Transform class methods that:
// + do not mutate any view state properties
// + populate private members derived from view state properties
// They should always reflect the state of their owning instance and NOT trigger any proxied getter/setter
const $77de42fa790a40cd$var$unproxiedMethods = new Set([
    '_calcMatrices',
    '_calcFogMatrices',
    '_updateCameraState',
    '_updateSeaLevelZoom'
]);
function $77de42fa790a40cd$export$3f6fb66aeea526f4(tr) {
    let internalUpdate = false;
    let reactViewState = {};
    /**
     * Reflects view state set by react props
     * This is the transform seen by painter, style etc.
     */ const controlledTransform = tr;
    /** Populated during camera move (handler/easeTo) if there is a discrepency between react props and proposed view state
     * This is the transform seen by Mapbox's input handlers
     */ let proposedTransform = null;
    const handlers = {
        get (target, prop) {
            // Props added by us
            if (prop === '$reactViewState') return reactViewState;
            if (prop === '$proposedTransform') return proposedTransform;
            if (prop === '$internalUpdate') return internalUpdate;
            // Ugly - this method is called from HandlerManager bypassing zoom setter
            if (prop === '_setZoom') return (z)=>{
                if (internalUpdate) proposedTransform?.[prop](z);
                if (!Number.isFinite(reactViewState.zoom)) controlledTransform[prop](z);
            };
            // Ugly - this method is called from HandlerManager and mutates transform._camera
            if (internalUpdate && prop === '_translateCameraConstrained' && (0, $ff5c44d8dbab1cdc$export$b36064f1be29a03f)(reactViewState)) proposedTransform = proposedTransform || controlledTransform.clone();
            if ($77de42fa790a40cd$var$unproxiedMethods.has(prop)) // When this function is executed, it updates both transforms respectively
            return function(...parms) {
                proposedTransform?.[prop](...parms);
                controlledTransform[prop](...parms);
            };
            // Expose the proposed transform to input handlers
            if (internalUpdate && proposedTransform) return proposedTransform[prop];
            // Expose the controlled transform to renderer, markers, and event listeners
            return controlledTransform[prop];
        },
        set (target, prop, value) {
            // Props added by us
            if (prop === '$reactViewState') {
                reactViewState = value;
                (0, $ff5c44d8dbab1cdc$export$5cf06eaeb862e3ce)(controlledTransform, reactViewState);
                return true;
            }
            if (prop === '$proposedTransform') {
                proposedTransform = value;
                return true;
            }
            if (prop === '$internalUpdate') {
                internalUpdate = value;
                return true;
            }
            // Controlled props
            let controlledValue = value;
            if (prop === 'center' || prop === '_center') {
                if (Number.isFinite(reactViewState.longitude) || Number.isFinite(reactViewState.latitude)) // @ts-expect-error LngLat constructor is not typed
                controlledValue = new value.constructor(reactViewState.longitude ?? value.lng, reactViewState.latitude ?? value.lat);
            } else if (prop === 'zoom' || prop === '_zoom' || prop === '_seaLevelZoom') {
                if (Number.isFinite(reactViewState.zoom)) controlledValue = controlledTransform[prop];
            } else if (prop === '_centerAltitude') {
                if (Number.isFinite(reactViewState.elevation)) controlledValue = controlledTransform[prop];
            } else if (prop === 'pitch' || prop === '_pitch') {
                if (Number.isFinite(reactViewState.pitch)) controlledValue = controlledTransform[prop];
            } else if (prop === 'bearing' || prop === 'rotation' || prop === 'angle') {
                if (Number.isFinite(reactViewState.bearing)) controlledValue = controlledTransform[prop];
            }
            // During camera update, we save view states that are overriden by controlled values in proposedTransform
            if (internalUpdate && controlledValue !== value) proposedTransform = proposedTransform || controlledTransform.clone();
            if (internalUpdate && proposedTransform) proposedTransform[prop] = value;
            // controlledTransform is not exposed to view state mutation
            controlledTransform[prop] = controlledValue;
            return true;
        }
    };
    return new Proxy(tr, handlers);
}


const $a094c77ab2bfe883$var$refProps = [
    'type',
    'source',
    'source-layer',
    'minzoom',
    'maxzoom',
    'filter',
    'layout'
];
function $a094c77ab2bfe883$export$8756898546458274(style) {
    if (!style) return null;
    if (typeof style === 'string') return style;
    if ('toJS' in style) style = style.toJS();
    if (!style.layers) return style;
    const layerIndex = {};
    for (const layer of style.layers)layerIndex[layer.id] = layer;
    const layers = style.layers.map((layer)=>{
        let normalizedLayer = null;
        if ('interactive' in layer) {
            normalizedLayer = Object.assign({}, layer);
            // Breaks style diffing :(
            // @ts-ignore legacy field not typed
            delete normalizedLayer.interactive;
        }
        // Style diffing doesn't work with refs so expand them out manually before diffing.
        // @ts-ignore legacy field not typed
        const layerRef = layerIndex[layer.ref];
        if (layerRef) {
            normalizedLayer = normalizedLayer || Object.assign({}, layer);
            // @ts-ignore
            delete normalizedLayer.ref;
            // https://github.com/mapbox/mapbox-gl-js/blob/master/src/style-spec/deref.js
            for (const propName of $a094c77ab2bfe883$var$refProps)if (propName in layerRef) normalizedLayer[propName] = layerRef[propName];
        }
        return normalizedLayer || layer;
    });
    // Do not mutate the style object provided by the user
    return {
        ...style,
        layers: layers
    };
}


/**
 * Compare two points
 * @param a
 * @param b
 * @returns true if the points are equal
 */ function $fa9a11b39cbae09c$export$cb7477365ef68362(a, b) {
    const ax = Array.isArray(a) ? a[0] : a ? a.x : 0;
    const ay = Array.isArray(a) ? a[1] : a ? a.y : 0;
    const bx = Array.isArray(b) ? b[0] : b ? b.x : 0;
    const by = Array.isArray(b) ? b[1] : b ? b.y : 0;
    return ax === bx && ay === by;
}
function $fa9a11b39cbae09c$export$9cb4719e2e525b7a(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    if (Array.isArray(a)) {
        if (!Array.isArray(b) || a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (!$fa9a11b39cbae09c$export$9cb4719e2e525b7a(a[i], b[i])) return false;
        }
        return true;
    } else if (Array.isArray(b)) return false;
    if (typeof a === 'object' && typeof b === 'object') {
        const aKeys = Object.keys(a);
        const bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        for (const key of aKeys){
            if (!b.hasOwnProperty(key)) return false;
            if (!$fa9a11b39cbae09c$export$9cb4719e2e525b7a(a[key], b[key])) return false;
        }
        return true;
    }
    return false;
}


const $dd2aa969fed7ce36$var$DEFAULT_STYLE = {
    version: 8,
    sources: {},
    layers: []
};
const $dd2aa969fed7ce36$var$pointerEvents = {
    mousedown: 'onMouseDown',
    mouseup: 'onMouseUp',
    mouseover: 'onMouseOver',
    mousemove: 'onMouseMove',
    click: 'onClick',
    dblclick: 'onDblClick',
    mouseenter: 'onMouseEnter',
    mouseleave: 'onMouseLeave',
    mouseout: 'onMouseOut',
    contextmenu: 'onContextMenu',
    touchstart: 'onTouchStart',
    touchend: 'onTouchEnd',
    touchmove: 'onTouchMove',
    touchcancel: 'onTouchCancel'
};
const $dd2aa969fed7ce36$var$cameraEvents = {
    movestart: 'onMoveStart',
    move: 'onMove',
    moveend: 'onMoveEnd',
    dragstart: 'onDragStart',
    drag: 'onDrag',
    dragend: 'onDragEnd',
    zoomstart: 'onZoomStart',
    zoom: 'onZoom',
    zoomend: 'onZoomEnd',
    rotatestart: 'onRotateStart',
    rotate: 'onRotate',
    rotateend: 'onRotateEnd',
    pitchstart: 'onPitchStart',
    pitch: 'onPitch',
    pitchend: 'onPitchEnd'
};
const $dd2aa969fed7ce36$var$otherEvents = {
    wheel: 'onWheel',
    boxzoomstart: 'onBoxZoomStart',
    boxzoomend: 'onBoxZoomEnd',
    boxzoomcancel: 'onBoxZoomCancel',
    resize: 'onResize',
    load: 'onLoad',
    render: 'onRender',
    idle: 'onIdle',
    remove: 'onRemove',
    data: 'onData',
    styledata: 'onStyleData',
    sourcedata: 'onSourceData',
    error: 'onError'
};
const $dd2aa969fed7ce36$var$settingNames = [
    'minZoom',
    'maxZoom',
    'minPitch',
    'maxPitch',
    'maxBounds',
    'projection',
    'renderWorldCopies'
];
const $dd2aa969fed7ce36$var$handlerNames = [
    'scrollZoom',
    'boxZoom',
    'dragRotate',
    'dragPan',
    'keyboard',
    'doubleClickZoom',
    'touchZoomRotate',
    'touchPitch'
];
/**
 * A wrapper for mapbox-gl's Map class
 */ class $dd2aa969fed7ce36$var$Mapbox {
    constructor(MapClass, props, container){
        /** mapboxgl.Map instance */ this._map = null;
        // Internal states
        /** Making updates driven by React props. Do not trigger React callbacks to avoid infinite loop */ this._internalUpdate = false;
        /** Map is currently rendering */ this._inRender = false;
        /** Map features under the pointer */ this._hoveredFeatures = null;
        /** View state changes driven by React props
         * They still need to fire move/etc. events because controls such as marker/popup
         * subscribe to the move event internally to update their position
         * React callbacks like onMove are not called for these */ this._deferredEvents = {
            move: false,
            zoom: false,
            pitch: false,
            rotate: false
        };
        this._onEvent = (e)=>{
            // @ts-ignore
            const cb = this.props[$dd2aa969fed7ce36$var$otherEvents[e.type]];
            if (cb) cb(e);
            else if (e.type === 'error') console.error(e.error); // eslint-disable-line
        };
        this._onPointerEvent = (e)=>{
            if (e.type === 'mousemove' || e.type === 'mouseout') this._updateHover(e);
            // @ts-ignore
            const cb = this.props[$dd2aa969fed7ce36$var$pointerEvents[e.type]];
            if (cb) {
                if (this.props.interactiveLayerIds && e.type !== 'mouseover' && e.type !== 'mouseout') e.features = this._hoveredFeatures || this._queryRenderedFeatures(e.point);
                cb(e);
                delete e.features;
            }
        };
        this._onCameraEvent = (e)=>{
            if (!this._internalUpdate) {
                // @ts-ignore
                const cb = this.props[$dd2aa969fed7ce36$var$cameraEvents[e.type]];
                const tr = this._proxyTransform;
                if (cb) {
                    e.viewState = (0, $ff5c44d8dbab1cdc$export$6a605c5aa5bd97a8)(tr.$proposedTransform ?? tr);
                    cb(e);
                }
                if (e.type === 'moveend') tr.$proposedTransform = null;
            }
            if (e.type in this._deferredEvents) this._deferredEvents[e.type] = false;
        };
        this._MapClass = MapClass;
        this.props = props;
        this._initialize(container);
    }
    get map() {
        return this._map;
    }
    get transform() {
        return this._map.transform;
    }
    setProps(props) {
        const oldProps = this.props;
        this.props = props;
        const settingsChanged = this._updateSettings(props, oldProps);
        if (settingsChanged) this._createProxyTransform(this._map);
        const sizeChanged = this._updateSize(props);
        const viewStateChanged = this._updateViewState(props, true);
        this._updateStyle(props, oldProps);
        this._updateStyleComponents(props, oldProps);
        this._updateHandlers(props, oldProps);
        // If 1) view state has changed to match props and
        //    2) the props change is not triggered by map events,
        // it's driven by an external state change. Redraw immediately
        if (settingsChanged || sizeChanged || viewStateChanged && !this._map.isMoving()) this.redraw();
    }
    static reuse(props, container) {
        const that = $dd2aa969fed7ce36$var$Mapbox.savedMaps.pop();
        if (!that) return null;
        const map = that.map;
        // When reusing the saved map, we need to reparent the map(canvas) and other child nodes
        // intoto the new container from the props.
        // Step 1: reparenting child nodes from old container to new container
        const oldContainer = map.getContainer();
        container.className = oldContainer.className;
        while(oldContainer.childNodes.length > 0)container.appendChild(oldContainer.childNodes[0]);
        // Step 2: replace the internal container with new container from the react component
        // @ts-ignore
        map._container = container;
        // Step 4: apply new props
        that.setProps({
            ...props,
            styleDiffing: false
        });
        map.resize();
        const { initialViewState: initialViewState } = props;
        if (initialViewState) {
            if (initialViewState.bounds) map.fitBounds(initialViewState.bounds, {
                ...initialViewState.fitBoundsOptions,
                duration: 0
            });
            else that._updateViewState(initialViewState, false);
        }
        // Simulate load event
        if (map.isStyleLoaded()) map.fire('load');
        else map.once('styledata', ()=>map.fire('load'));
        // Force reload
        // @ts-ignore
        map._update();
        return that;
    }
    /* eslint-disable complexity,max-statements */ _initialize(container) {
        const { props: props } = this;
        const { mapStyle: mapStyle = $dd2aa969fed7ce36$var$DEFAULT_STYLE } = props;
        const mapOptions = {
            ...props,
            ...props.initialViewState,
            accessToken: props.mapboxAccessToken || $dd2aa969fed7ce36$var$getAccessTokenFromEnv() || null,
            container: container,
            style: (0, $a094c77ab2bfe883$export$8756898546458274)(mapStyle)
        };
        const viewState = mapOptions.initialViewState || mapOptions.viewState || mapOptions;
        Object.assign(mapOptions, {
            center: [
                viewState.longitude || 0,
                viewState.latitude || 0
            ],
            zoom: viewState.zoom || 0,
            pitch: viewState.pitch || 0,
            bearing: viewState.bearing || 0
        });
        if (props.gl) {
            // eslint-disable-next-line
            const getContext = HTMLCanvasElement.prototype.getContext;
            // Hijack canvas.getContext to return our own WebGLContext
            // This will be called inside the mapboxgl.Map constructor
            // @ts-expect-error
            HTMLCanvasElement.prototype.getContext = ()=>{
                // Unhijack immediately
                HTMLCanvasElement.prototype.getContext = getContext;
                return props.gl;
            };
        }
        const map = new this._MapClass(mapOptions);
        // Props that are not part of constructor options
        if (viewState.padding) map.setPadding(viewState.padding);
        if (props.cursor) map.getCanvas().style.cursor = props.cursor;
        this._createProxyTransform(map);
        // Hack
        // Insert code into map's render cycle
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const renderMap = map._render;
        map._render = (arg)=>{
            // Hijacked to set this state flag
            this._inRender = true;
            renderMap.call(map, arg);
            this._inRender = false;
        };
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const runRenderTaskQueue = map._renderTaskQueue.run;
        map._renderTaskQueue.run = (arg)=>{
            // This is where camera updates from input handler/animation happens
            // And where all view state change events are fired
            this._proxyTransform.$internalUpdate = true;
            runRenderTaskQueue.call(map._renderTaskQueue, arg);
            this._proxyTransform.$internalUpdate = false;
            this._fireDefferedEvents();
        };
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const jumpTo = map.jumpTo;
        map.jumpTo = (...args)=>{
            // This method will fire view state change events immediately
            this._proxyTransform.$internalUpdate = true;
            jumpTo.apply(map, args);
            this._proxyTransform.$internalUpdate = false;
            return map;
        };
        // Insert code into map's event pipeline
        // eslint-disable-next-line @typescript-eslint/unbound-method
        const fireEvent = map.fire;
        map.fire = this._fireEvent.bind(this, fireEvent);
        // add listeners
        map.on('styledata', ()=>{
            this._updateStyleComponents(this.props, {});
        });
        map.on('sourcedata', ()=>{
            this._updateStyleComponents(this.props, {});
        });
        for(const eventName in $dd2aa969fed7ce36$var$pointerEvents)map.on(eventName, this._onPointerEvent);
        for(const eventName in $dd2aa969fed7ce36$var$cameraEvents)map.on(eventName, this._onCameraEvent);
        for(const eventName in $dd2aa969fed7ce36$var$otherEvents)map.on(eventName, this._onEvent);
        this._map = map;
    }
    /* eslint-enable complexity,max-statements */ recycle() {
        // Clean up unnecessary elements before storing for reuse.
        const container = this.map.getContainer();
        const children = container.querySelector('[mapboxgl-children]');
        children?.remove();
        $dd2aa969fed7ce36$var$Mapbox.savedMaps.push(this);
    }
    destroy() {
        this._map.remove();
    }
    // Force redraw the map now. Typically resize() and jumpTo() is reflected in the next
    // render cycle, which is managed by Mapbox's animation loop.
    // This removes the synchronization issue caused by requestAnimationFrame.
    redraw() {
        const map = this._map;
        // map._render will throw error if style does not exist
        // https://github.com/mapbox/mapbox-gl-js/blob/fb9fc316da14e99ff4368f3e4faa3888fb43c513
        //   /src/ui/map.js#L1834
        if (!this._inRender && map.style) {
            // cancel the scheduled update
            if (map._frame) {
                map._frame.cancel();
                map._frame = null;
            }
            // the order is important - render() may schedule another update
            map._render();
        }
    }
    _createProxyTransform(map) {
        const proxyTransform = (0, $77de42fa790a40cd$export$3f6fb66aeea526f4)(map.transform);
        map.transform = proxyTransform;
        map.painter.transform = proxyTransform;
        this._proxyTransform = proxyTransform;
    }
    /* Trigger map resize if size is controlled
       @param {object} nextProps
       @returns {bool} true if size has changed
     */ _updateSize(nextProps) {
        // Check if size is controlled
        const { viewState: viewState } = nextProps;
        if (viewState) {
            const map = this._map;
            if (viewState.width !== map.transform.width || viewState.height !== map.transform.height) {
                map.resize();
                return true;
            }
        }
        return false;
    }
    // Adapted from map.jumpTo
    /* Update camera to match props
       @param {object} nextProps
       @param {bool} triggerEvents - should fire camera events
       @returns {bool} true if anything is changed
     */ _updateViewState(nextProps, triggerEvents) {
        const viewState = nextProps.viewState || nextProps;
        const tr = this._proxyTransform;
        const { zoom: zoom, pitch: pitch, bearing: bearing } = tr;
        const changed = (0, $ff5c44d8dbab1cdc$export$b3dd58694e7dc7d6)(this._proxyTransform, viewState);
        tr.$reactViewState = viewState;
        if (changed && triggerEvents) {
            const deferredEvents = this._deferredEvents;
            // Delay DOM control updates to the next render cycle
            deferredEvents.move = true;
            deferredEvents.zoom || (deferredEvents.zoom = zoom !== tr.zoom);
            deferredEvents.rotate || (deferredEvents.rotate = bearing !== tr.bearing);
            deferredEvents.pitch || (deferredEvents.pitch = pitch !== tr.pitch);
        }
        return changed;
    }
    /* Update camera constraints and projection settings to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateSettings(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $dd2aa969fed7ce36$var$settingNames)if (propName in nextProps && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(nextProps[propName], currProps[propName])) {
            changed = true;
            const setter = map[`set${propName[0].toUpperCase()}${propName.slice(1)}`];
            setter?.call(map, nextProps[propName]);
        }
        return changed;
    }
    /* Update map style to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if style is changed
     */ _updateStyle(nextProps, currProps) {
        if (nextProps.cursor !== currProps.cursor) this._map.getCanvas().style.cursor = nextProps.cursor || '';
        if (nextProps.mapStyle !== currProps.mapStyle) {
            const { mapStyle: mapStyle = $dd2aa969fed7ce36$var$DEFAULT_STYLE, styleDiffing: styleDiffing = true } = nextProps;
            const options = {
                diff: styleDiffing
            };
            if ('localIdeographFontFamily' in nextProps) // @ts-ignore Mapbox specific prop
            options.localIdeographFontFamily = nextProps.localIdeographFontFamily;
            this._map.setStyle((0, $a094c77ab2bfe883$export$8756898546458274)(mapStyle), options);
            return true;
        }
        return false;
    }
    /* Update fog, light and terrain to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateStyleComponents(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        if (map.isStyleLoaded()) {
            if ('light' in nextProps && map.setLight && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(nextProps.light, currProps.light)) {
                changed = true;
                map.setLight(nextProps.light);
            }
            if ('fog' in nextProps && map.setFog && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(nextProps.fog, currProps.fog)) {
                changed = true;
                map.setFog(nextProps.fog);
            }
            if ('terrain' in nextProps && map.setTerrain && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(nextProps.terrain, currProps.terrain)) {
                if (!nextProps.terrain || map.getSource(nextProps.terrain.source)) {
                    changed = true;
                    map.setTerrain(nextProps.terrain);
                }
            }
        }
        return changed;
    }
    /* Update interaction handlers to match props
       @param {object} nextProps
       @param {object} currProps
       @returns {bool} true if anything is changed
     */ _updateHandlers(nextProps, currProps) {
        const map = this._map;
        let changed = false;
        for (const propName of $dd2aa969fed7ce36$var$handlerNames){
            const newValue = nextProps[propName] ?? true;
            const oldValue = currProps[propName] ?? true;
            if (!(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(newValue, oldValue)) {
                changed = true;
                if (newValue) map[propName].enable(newValue);
                else map[propName].disable();
            }
        }
        return changed;
    }
    _queryRenderedFeatures(point) {
        const map = this._map;
        const { interactiveLayerIds: interactiveLayerIds = [] } = this.props;
        try {
            return map.queryRenderedFeatures(point, {
                layers: interactiveLayerIds.filter(map.getLayer.bind(map))
            });
        } catch  {
            // May fail if style is not loaded
            return [];
        }
    }
    _updateHover(e) {
        const { props: props } = this;
        const shouldTrackHoveredFeatures = props.interactiveLayerIds && (props.onMouseMove || props.onMouseEnter || props.onMouseLeave);
        if (shouldTrackHoveredFeatures) {
            const eventType = e.type;
            const wasHovering = this._hoveredFeatures?.length > 0;
            const features = this._queryRenderedFeatures(e.point);
            const isHovering = features.length > 0;
            if (!isHovering && wasHovering) {
                e.type = 'mouseleave';
                this._onPointerEvent(e);
            }
            this._hoveredFeatures = features;
            if (isHovering && !wasHovering) {
                e.type = 'mouseenter';
                this._onPointerEvent(e);
            }
            e.type = eventType;
        } else this._hoveredFeatures = null;
    }
    _fireEvent(baseFire, event, properties) {
        const map = this._map;
        const tr = this._proxyTransform;
        // Always expose the controlled transform to controls/end user
        const internal = tr.$internalUpdate;
        try {
            tr.$internalUpdate = false;
            baseFire.call(map, event, properties);
        } finally{
            tr.$internalUpdate = internal;
        }
        return map;
    }
    // If there are camera changes driven by props, invoke camera events so that DOM controls are synced
    _fireDefferedEvents() {
        const map = this._map;
        this._internalUpdate = true;
        for(const eventType in this._deferredEvents)if (this._deferredEvents[eventType]) map.fire(eventType);
        this._internalUpdate = false;
    }
}
$dd2aa969fed7ce36$var$Mapbox.savedMaps = [];
var $dd2aa969fed7ce36$export$2e2bcd8739ae039 = $dd2aa969fed7ce36$var$Mapbox;
/**
 * Access token can be provided via one of:
 *   mapboxAccessToken prop
 *   access_token query parameter
 *   MapboxAccessToken environment variable
 *   REACT_APP_MAPBOX_ACCESS_TOKEN environment variable
 * @returns access token
 */ function $dd2aa969fed7ce36$var$getAccessTokenFromEnv() {
    let accessToken = null;
    /* global location, process */ if (typeof location !== 'undefined') {
        const match = /access_token=([^&\/]*)/.exec(location.search);
        accessToken = match && match[1];
    }
    // Note: This depends on bundler plugins (e.g. webpack) importing environment correctly
    try {
        // eslint-disable-next-line no-process-env
        accessToken = accessToken || undefined;
    } catch  {
    // ignore
    }
    try {
        // eslint-disable-next-line no-process-env
        accessToken = accessToken || undefined;
    } catch  {
    // ignore
    }
    return accessToken;
}


/** These methods may break the react binding if called directly */ const $446437da5c611ae3$var$skipMethods = [
    'setMaxBounds',
    'setMinZoom',
    'setMaxZoom',
    'setMinPitch',
    'setMaxPitch',
    'setRenderWorldCopies',
    'setProjection',
    'setStyle',
    'addSource',
    'removeSource',
    'addLayer',
    'removeLayer',
    'setLayerZoomRange',
    'setFilter',
    'setPaintProperty',
    'setLayoutProperty',
    'setLight',
    'setTerrain',
    'setFog',
    'remove'
];
function $446437da5c611ae3$export$2e2bcd8739ae039(mapInstance) {
    if (!mapInstance) return null;
    const map = mapInstance.map;
    const ref = {
        getMap: ()=>map,
        // Overwrite getters to use our shadow transform
        getCenter: ()=>mapInstance.transform.center,
        getZoom: ()=>mapInstance.transform.zoom,
        getBearing: ()=>mapInstance.transform.bearing,
        getPitch: ()=>mapInstance.transform.pitch,
        getPadding: ()=>mapInstance.transform.padding,
        getBounds: ()=>mapInstance.transform.getBounds(),
        project: (lnglat)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.project(lnglat);
            map.transform = tr;
            return result;
        },
        unproject: (point)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.unproject(point);
            map.transform = tr;
            return result;
        },
        // options diverge between mapbox and maplibre
        queryTerrainElevation: (lnglat, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryTerrainElevation(lnglat, options);
            map.transform = tr;
            return result;
        },
        queryRenderedFeatures: (geometry, options)=>{
            const tr = map.transform;
            map.transform = mapInstance.transform;
            const result = map.queryRenderedFeatures(geometry, options);
            map.transform = tr;
            return result;
        }
    };
    for (const key of $446437da5c611ae3$var$getMethodNames(map))// @ts-expect-error
    if (!(key in ref) && !$446437da5c611ae3$var$skipMethods.includes(key)) ref[key] = map[key].bind(map);
    return ref;
}
function $446437da5c611ae3$var$getMethodNames(obj) {
    const result = new Set();
    let proto = obj;
    while(proto){
        for (const key of Object.getOwnPropertyNames(proto))if (key[0] !== '_' && typeof obj[key] === 'function' && key !== 'fire' && key !== 'setEventedParent') result.add(key);
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(result);
}


// From https://github.com/streamich/react-use/blob/master/src/useIsomorphicLayoutEffect.ts
// useLayoutEffect but does not trigger warning in server-side rendering

var $acw62 = parcelRequire("acw62");
const $f8b3d6ab422d616a$var$useIsomorphicLayoutEffect = typeof document !== 'undefined' ? (0, $acw62.useLayoutEffect) : (0, $acw62.useEffect);
var $f8b3d6ab422d616a$export$2e2bcd8739ae039 = $f8b3d6ab422d616a$var$useIsomorphicLayoutEffect;


const $6bc0917fdb1df427$var$globalSettings = [
    'baseApiUrl',
    'maxParallelImageRequests',
    'workerClass',
    'workerCount',
    'workerUrl'
];
function $6bc0917fdb1df427$export$2e2bcd8739ae039(mapLib, props) {
    for (const key of $6bc0917fdb1df427$var$globalSettings)if (key in props) mapLib[key] = props[key];
    const { RTLTextPlugin: RTLTextPlugin = 'https://api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-rtl-text/v0.2.3/mapbox-gl-rtl-text.js' } = props;
    if (RTLTextPlugin && mapLib.getRTLTextPluginStatus && mapLib.getRTLTextPluginStatus() === 'unavailable') mapLib.setRTLTextPlugin(RTLTextPlugin, (error)=>{
        if (error) // eslint-disable-next-line
        console.error(error);
    }, true);
}


const $9bfa0fb4992bfff5$export$dc7344301ae78f85 = $acw62.createContext(null);

function $9bfa0fb4992bfff5$var$_Map(props, ref) {
    const mountedMapsContext = (0, $acw62.useContext)((0, $64c812a720876a94$export$c6c68f6e4db55944));
    const [mapInstance, setMapInstance] = (0, $acw62.useState)(null);
    const containerRef = (0, $acw62.useRef)();
    const { current: contextValue } = (0, $acw62.useRef)({
        mapLib: null,
        map: null
    });
    (0, $acw62.useEffect)(()=>{
        const mapLib = props.mapLib;
        let isMounted = true;
        let mapbox;
        Promise.resolve(mapLib || (parcelRequire("2hToY"))).then((module)=>{
            if (!isMounted) return;
            if (!module) throw new Error('Invalid mapLib');
            const mapboxgl = 'Map' in module ? module : module.default;
            if (!mapboxgl.Map) throw new Error('Invalid mapLib');
            (0, $6bc0917fdb1df427$export$2e2bcd8739ae039)(mapboxgl, props);
            if (props.reuseMaps) mapbox = (0, $dd2aa969fed7ce36$export$2e2bcd8739ae039).reuse(props, containerRef.current);
            if (!mapbox) mapbox = new (0, $dd2aa969fed7ce36$export$2e2bcd8739ae039)(mapboxgl.Map, props, containerRef.current);
            contextValue.map = (0, $446437da5c611ae3$export$2e2bcd8739ae039)(mapbox);
            contextValue.mapLib = mapboxgl;
            setMapInstance(mapbox);
            mountedMapsContext?.onMapMount(contextValue.map, props.id);
        }).catch((error)=>{
            const { onError: onError } = props;
            if (onError) onError({
                type: 'error',
                target: null,
                error: error
            });
            else console.error(error); // eslint-disable-line
        });
        return ()=>{
            isMounted = false;
            if (mapbox) {
                mountedMapsContext?.onMapUnmount(props.id);
                if (props.reuseMaps) mapbox.recycle();
                else mapbox.destroy();
            }
        };
    }, []);
    (0, $f8b3d6ab422d616a$export$2e2bcd8739ae039)(()=>{
        if (mapInstance) mapInstance.setProps(props);
    });
    (0, $acw62.useImperativeHandle)(ref, ()=>contextValue.map, [
        mapInstance
    ]);
    const style = (0, $acw62.useMemo)(()=>({
            position: 'relative',
            width: '100%',
            height: '100%',
            ...props.style
        }), [
        props.style
    ]);
    const CHILD_CONTAINER_STYLE = {
        height: '100%'
    };
    return $acw62.createElement("div", {
        id: props.id,
        ref: containerRef,
        style: style
    }, mapInstance && $acw62.createElement($9bfa0fb4992bfff5$export$dc7344301ae78f85.Provider, {
        value: contextValue
    }, $acw62.createElement("div", {
        "mapboxgl-children": "",
        style: CHILD_CONTAINER_STYLE
    }, props.children)));
}
const $9bfa0fb4992bfff5$export$a5c7b93649eaf8f8 = $acw62.forwardRef($9bfa0fb4992bfff5$var$_Map);


/* global document */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
// This is a simplified version of
// https://github.com/facebook/react/blob/4131af3e4bf52f3a003537ec95a1655147c81270/src/renderers/dom/shared/CSSPropertyOperations.js#L62
const $18b1ed6b4fa22416$var$unitlessNumber = /box|flex|grid|column|lineHeight|fontWeight|opacity|order|tabSize|zIndex/;
function $18b1ed6b4fa22416$export$cd93e47e6d398387(element, styles) {
    if (!element || !styles) return;
    const style = element.style;
    for(const key in styles){
        const value = styles[key];
        if (Number.isFinite(value) && !$18b1ed6b4fa22416$var$unitlessNumber.test(key)) style[key] = `${value}px`;
        else style[key] = value;
    }
}




/** Compare two classNames string and return the difference */ function $f3ff1de5d4153981$export$a97e6c0d7c843e54(prevClassName, nextClassName) {
    if (prevClassName === nextClassName) return null;
    const prevClassList = $f3ff1de5d4153981$var$getClassList(prevClassName);
    const nextClassList = $f3ff1de5d4153981$var$getClassList(nextClassName);
    const diff = [];
    for (const c of nextClassList)if (!prevClassList.has(c)) diff.push(c);
    for (const c of prevClassList)if (!nextClassList.has(c)) diff.push(c);
    return diff.length === 0 ? null : diff;
}
function $f3ff1de5d4153981$var$getClassList(className) {
    return new Set(className ? className.trim().split(/\s+/) : []);
}


const $b6e420bcc59cd8fc$export$e98856a975cab58e = (0, $acw62.memo)((0, $acw62.forwardRef)((props, ref)=>{
    const { map: map, mapLib: mapLib } = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85));
    const thisRef = (0, $acw62.useRef)({
        props: props
    });
    const marker = (0, $acw62.useMemo)(()=>{
        let hasChildren = false;
        $acw62.Children.forEach(props.children, (el)=>{
            if (el) hasChildren = true;
        });
        const options = {
            ...props,
            element: hasChildren ? document.createElement('div') : null
        };
        const mk = new mapLib.Marker(options);
        mk.setLngLat([
            props.longitude,
            props.latitude
        ]);
        mk.getElement().addEventListener('click', (e)=>{
            thisRef.current.props.onClick?.({
                type: 'click',
                target: mk,
                originalEvent: e
            });
        });
        mk.on('dragstart', (e)=>{
            const evt = e;
            evt.lngLat = marker.getLngLat();
            thisRef.current.props.onDragStart?.(evt);
        });
        mk.on('drag', (e)=>{
            const evt = e;
            evt.lngLat = marker.getLngLat();
            thisRef.current.props.onDrag?.(evt);
        });
        mk.on('dragend', (e)=>{
            const evt = e;
            evt.lngLat = marker.getLngLat();
            thisRef.current.props.onDragEnd?.(evt);
        });
        return mk;
    }, []);
    (0, $acw62.useEffect)(()=>{
        marker.addTo(map.getMap());
        return ()=>{
            marker.remove();
        };
    }, []);
    const { longitude: longitude, latitude: latitude, offset: offset, style: style, draggable: draggable = false, popup: popup = null, rotation: rotation = 0, rotationAlignment: rotationAlignment = 'auto', pitchAlignment: pitchAlignment = 'auto' } = props;
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(marker.getElement(), style);
    }, [
        style
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>marker, []);
    const oldProps = thisRef.current.props;
    if (marker.getLngLat().lng !== longitude || marker.getLngLat().lat !== latitude) marker.setLngLat([
        longitude,
        latitude
    ]);
    if (offset && !(0, $fa9a11b39cbae09c$export$cb7477365ef68362)(marker.getOffset(), offset)) marker.setOffset(offset);
    if (marker.isDraggable() !== draggable) marker.setDraggable(draggable);
    if (marker.getRotation() !== rotation) marker.setRotation(rotation);
    if (marker.getRotationAlignment() !== rotationAlignment) marker.setRotationAlignment(rotationAlignment);
    if (marker.getPitchAlignment() !== pitchAlignment) marker.setPitchAlignment(pitchAlignment);
    if (marker.getPopup() !== popup) marker.setPopup(popup);
    const classNameDiff = (0, $f3ff1de5d4153981$export$a97e6c0d7c843e54)(oldProps.className, props.className);
    if (classNameDiff) for (const c of classNameDiff)marker.toggleClassName(c);
    thisRef.current.props = props;
    return (0, $1u0KT.createPortal)(props.children, marker.getElement());
}));



var $1u0KT = parcelRequire("1u0KT");

var $acw62 = parcelRequire("acw62");




const $01b7fef3c5ac1f78$export$129a32eedafa97c5 = (0, $acw62.memo)((0, $acw62.forwardRef)((props, ref)=>{
    const { map: map, mapLib: mapLib } = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85));
    const container = (0, $acw62.useMemo)(()=>{
        return document.createElement('div');
    }, []);
    const thisRef = (0, $acw62.useRef)({
        props: props
    });
    const popup = (0, $acw62.useMemo)(()=>{
        const options = {
            ...props
        };
        const pp = new mapLib.Popup(options);
        pp.setLngLat([
            props.longitude,
            props.latitude
        ]);
        pp.once('open', (e)=>{
            thisRef.current.props.onOpen?.(e);
        });
        return pp;
    }, []);
    (0, $acw62.useEffect)(()=>{
        const onClose = (e)=>{
            thisRef.current.props.onClose?.(e);
        };
        popup.on('close', onClose);
        popup.setDOMContent(container).addTo(map.getMap());
        return ()=>{
            // https://github.com/visgl/react-map-gl/issues/1825
            // onClose should not be fired if the popup is removed by unmounting
            // When using React strict mode, the component is mounted twice.
            // Firing the onClose callback here would be a false signal to remove the component.
            popup.off('close', onClose);
            if (popup.isOpen()) popup.remove();
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(popup.getElement(), props.style);
    }, [
        props.style
    ]);
    (0, $acw62.useImperativeHandle)(ref, ()=>popup, []);
    if (popup.isOpen()) {
        const oldProps = thisRef.current.props;
        if (popup.getLngLat().lng !== props.longitude || popup.getLngLat().lat !== props.latitude) popup.setLngLat([
            props.longitude,
            props.latitude
        ]);
        if (props.offset && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(oldProps.offset, props.offset)) {
            popup.options.anchor = props.anchor;
            popup.setOffset(props.offset);
        }
        if (oldProps.anchor !== props.anchor || oldProps.maxWidth !== props.maxWidth) popup.setMaxWidth(props.maxWidth);
        const classNameDiff = (0, $f3ff1de5d4153981$export$a97e6c0d7c843e54)(oldProps.className, props.className);
        if (classNameDiff) for (const c of classNameDiff)popup.toggleClassName(c);
        thisRef.current.props = props;
    }
    return (0, $1u0KT.createPortal)(props.children, container);
}));



var $acw62 = parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");

function $546917c3aede178b$export$62ad9a427fe0e7c8(onCreate, arg1, arg2, arg3) {
    const context = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85));
    const ctrl = (0, $acw62.useMemo)(()=>onCreate(context), []);
    (0, $acw62.useEffect)(()=>{
        const opts = arg3 || arg2 || arg1;
        const onAdd = typeof arg1 === 'function' && typeof arg2 === 'function' ? arg1 : null;
        const onRemove = typeof arg2 === 'function' ? arg2 : typeof arg1 === 'function' ? arg1 : null;
        const { map: map } = context;
        if (!map.hasControl(ctrl)) {
            map.addControl(ctrl, opts?.position);
            if (onAdd) onAdd(context);
        }
        return ()=>{
            if (onRemove) onRemove(context);
            // Map might have been removed (parent effects are destroyed before child ones)
            if (map.hasControl(ctrl)) map.removeControl(ctrl);
        };
    }, []);
    return ctrl;
}


function $2b5e08a8536025a8$var$_AttributionControl(props) {
    const ctrl = (0, $546917c3aede178b$export$62ad9a427fe0e7c8)(({ mapLib: mapLib })=>new mapLib.AttributionControl(props), {
        position: props.position
    });
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
const $2b5e08a8536025a8$export$5af5c3cc9905683 = (0, $acw62.memo)($2b5e08a8536025a8$var$_AttributionControl);



var $acw62 = parcelRequire("acw62");


function $84bb7b8c989e3187$var$_FullscreenControl(props) {
    const ctrl = (0, $546917c3aede178b$export$62ad9a427fe0e7c8)(({ mapLib: mapLib })=>new mapLib.FullscreenControl({
            container: props.containerId && document.getElementById(props.containerId)
        }), {
        position: props.position
    });
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(ctrl._controlContainer, props.style);
    }, [
        props.style
    ]);
    return null;
}
const $84bb7b8c989e3187$export$91e8ffb52c2b32c5 = (0, $acw62.memo)($84bb7b8c989e3187$var$_FullscreenControl);



var $acw62 = parcelRequire("acw62");


function $c468eaa4d383d52d$var$_GeolocateControl(props, ref) {
    const thisRef = (0, $acw62.useRef)({
        props: props
    });
    const ctrl = (0, $546917c3aede178b$export$62ad9a427fe0e7c8)(({ mapLib: mapLib })=>{
        const gc = new mapLib.GeolocateControl(props);
        // Hack: fix GeolocateControl reuse
        // When using React strict mode, the component is mounted twice.
        // GeolocateControl's UI creation is asynchronous. Removing and adding it back causes the UI to be initialized twice.
        const setupUI = gc._setupUI.bind(gc);
        gc._setupUI = (args)=>{
            if (!gc._container.hasChildNodes()) setupUI(args);
        };
        gc.on('geolocate', (e)=>{
            thisRef.current.props.onGeolocate?.(e);
        });
        gc.on('error', (e)=>{
            thisRef.current.props.onError?.(e);
        });
        gc.on('outofmaxbounds', (e)=>{
            thisRef.current.props.onOutOfMaxBounds?.(e);
        });
        gc.on('trackuserlocationstart', (e)=>{
            thisRef.current.props.onTrackUserLocationStart?.(e);
        });
        gc.on('trackuserlocationend', (e)=>{
            thisRef.current.props.onTrackUserLocationEnd?.(e);
        });
        return gc;
    }, {
        position: props.position
    });
    thisRef.current.props = props;
    (0, $acw62.useImperativeHandle)(ref, ()=>ctrl, []);
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
const $c468eaa4d383d52d$export$15e4ff48f7e9d8e0 = (0, $acw62.memo)((0, $acw62.forwardRef)($c468eaa4d383d52d$var$_GeolocateControl));



var $acw62 = parcelRequire("acw62");


function $b4c62ddd92212ae9$var$_NavigationControl(props) {
    const ctrl = (0, $546917c3aede178b$export$62ad9a427fe0e7c8)(({ mapLib: mapLib })=>new mapLib.NavigationControl(props), {
        position: props.position
    });
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(ctrl._container, props.style);
    }, [
        props.style
    ]);
    return null;
}
const $b4c62ddd92212ae9$export$49a437922edc1bd9 = (0, $acw62.memo)($b4c62ddd92212ae9$var$_NavigationControl);



var $acw62 = parcelRequire("acw62");


function $eba45a941aa53283$var$_ScaleControl(props) {
    const ctrl = (0, $546917c3aede178b$export$62ad9a427fe0e7c8)(({ mapLib: mapLib })=>new mapLib.ScaleControl(props), {
        position: props.position
    });
    const propsRef = (0, $acw62.useRef)(props);
    const prevProps = propsRef.current;
    propsRef.current = props;
    const { style: style } = props;
    if (props.maxWidth !== undefined && props.maxWidth !== prevProps.maxWidth) ctrl.options.maxWidth = props.maxWidth;
    if (props.unit !== undefined && props.unit !== prevProps.unit) ctrl.setUnit(props.unit);
    (0, $acw62.useEffect)(()=>{
        (0, $18b1ed6b4fa22416$export$cd93e47e6d398387)(ctrl._container, style);
    }, [
        style
    ]);
    return null;
}
const $eba45a941aa53283$export$1fb16e435eedcce9 = (0, $acw62.memo)($eba45a941aa53283$var$_ScaleControl);



var $acw62 = parcelRequire("acw62");

function $e69de7c82be7d2bb$export$2e2bcd8739ae039(condition, message) {
    if (!condition) throw new Error(message);
}



let $c2d35c3db04f1ab9$var$sourceCounter = 0;
function $c2d35c3db04f1ab9$var$createSource(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded) {
        const options = {
            ...props
        };
        delete options.id;
        delete options.children;
        // @ts-ignore
        map.addSource(id, options);
        return map.getSource(id);
    }
    return null;
}
/* eslint-disable complexity */ function $c2d35c3db04f1ab9$var$updateSource(source, props, prevProps) {
    (0, $e69de7c82be7d2bb$export$2e2bcd8739ae039)(props.id === prevProps.id, 'source id changed');
    (0, $e69de7c82be7d2bb$export$2e2bcd8739ae039)(props.type === prevProps.type, 'source type changed');
    let changedKey = '';
    let changedKeyCount = 0;
    for(const key in props)if (key !== 'children' && key !== 'id' && !(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(prevProps[key], props[key])) {
        changedKey = key;
        changedKeyCount++;
    }
    if (!changedKeyCount) return;
    const type = props.type;
    if (type === 'geojson') source.setData(props.data);
    else if (type === 'image') source.updateImage({
        url: props.url,
        coordinates: props.coordinates
    });
    else if ('setCoordinates' in source && changedKeyCount === 1 && changedKey === 'coordinates') source.setCoordinates(props.coordinates);
    else if ('setUrl' in source && changedKey === 'url') source.setUrl(props.url);
    else if ('setTiles' in source && changedKey === 'tiles') source.setTiles(props.tiles);
    else // eslint-disable-next-line
    console.warn(`Unable to update <Source> prop: ${changedKey}`);
}
function $c2d35c3db04f1ab9$export$1d2df86270c81ecb(props) {
    const map = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $acw62.useRef)(props);
    const [, setStyleLoaded] = (0, $acw62.useState)(0);
    const id = (0, $acw62.useMemo)(()=>props.id || `jsx-source-${$c2d35c3db04f1ab9$var$sourceCounter++}`, []);
    (0, $acw62.useEffect)(()=>{
        if (map) {
            /* global setTimeout */ const forceUpdate = ()=>setTimeout(()=>setStyleLoaded((version)=>version + 1), 0);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getSource(id)) {
                    // Parent effects are destroyed before child ones, see
                    // https://github.com/facebook/react/issues/16728
                    // Source can only be removed after all child layers are removed
                    const allLayers = map.getStyle()?.layers;
                    if (allLayers) {
                        for (const layer of allLayers)// @ts-ignore (2339) source does not exist on all layer types
                        if (layer.source === id) map.removeLayer(layer.id);
                    }
                    map.removeSource(id);
                }
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    let source = map && map.style && map.getSource(id);
    if (source) $c2d35c3db04f1ab9$var$updateSource(source, props, propsRef.current);
    else source = $c2d35c3db04f1ab9$var$createSource(map, id, props);
    propsRef.current = props;
    return source && $acw62.Children.map(props.children, (child)=>child && (0, $acw62.cloneElement)(child, {
            source: id
        })) || null;
}



var $acw62 = parcelRequire("acw62");



/* eslint-disable complexity, max-statements */ function $baf7a1f21323fe66$var$updateLayer(map, id, props, prevProps) {
    (0, $e69de7c82be7d2bb$export$2e2bcd8739ae039)(props.id === prevProps.id, 'layer id changed');
    (0, $e69de7c82be7d2bb$export$2e2bcd8739ae039)(props.type === prevProps.type, 'layer type changed');
    if (props.type === 'custom' || prevProps.type === 'custom') return;
    // @ts-ignore filter does not exist in some Layer types
    const { layout: layout = {}, paint: paint = {}, filter: filter, minzoom: minzoom, maxzoom: maxzoom, beforeId: beforeId } = props;
    if (beforeId !== prevProps.beforeId) map.moveLayer(id, beforeId);
    if (layout !== prevProps.layout) {
        const prevLayout = prevProps.layout || {};
        for(const key in layout)if (!(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(layout[key], prevLayout[key])) map.setLayoutProperty(id, key, layout[key]);
        for(const key in prevLayout)if (!layout.hasOwnProperty(key)) map.setLayoutProperty(id, key, undefined);
    }
    if (paint !== prevProps.paint) {
        const prevPaint = prevProps.paint || {};
        for(const key in paint)if (!(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(paint[key], prevPaint[key])) map.setPaintProperty(id, key, paint[key]);
        for(const key in prevPaint)if (!paint.hasOwnProperty(key)) map.setPaintProperty(id, key, undefined);
    }
    // @ts-ignore filter does not exist in some Layer types
    if (!(0, $fa9a11b39cbae09c$export$9cb4719e2e525b7a)(filter, prevProps.filter)) map.setFilter(id, filter);
    if (minzoom !== prevProps.minzoom || maxzoom !== prevProps.maxzoom) map.setLayerZoomRange(id, minzoom, maxzoom);
}
function $baf7a1f21323fe66$var$createLayer(map, id, props) {
    // @ts-ignore
    if (map.style && map.style._loaded && (!('source' in props) || map.getSource(props.source))) {
        const options = {
            ...props,
            id: id
        };
        delete options.beforeId;
        // @ts-ignore
        map.addLayer(options, props.beforeId);
    }
}
/* eslint-enable complexity, max-statements */ let $baf7a1f21323fe66$var$layerCounter = 0;
function $baf7a1f21323fe66$export$936d0764594b6eb3(props) {
    const map = (0, $acw62.useContext)((0, $9bfa0fb4992bfff5$export$dc7344301ae78f85)).map.getMap();
    const propsRef = (0, $acw62.useRef)(props);
    const [, setStyleLoaded] = (0, $acw62.useState)(0);
    const id = (0, $acw62.useMemo)(()=>props.id || `jsx-layer-${$baf7a1f21323fe66$var$layerCounter++}`, []);
    (0, $acw62.useEffect)(()=>{
        if (map) {
            const forceUpdate = ()=>setStyleLoaded((version)=>version + 1);
            map.on('styledata', forceUpdate);
            forceUpdate();
            return ()=>{
                map.off('styledata', forceUpdate);
                // @ts-ignore
                if (map.style && map.style._loaded && map.getLayer(id)) map.removeLayer(id);
            };
        }
        return undefined;
    }, [
        map
    ]);
    // @ts-ignore
    const layer = map && map.style && map.getLayer(id);
    if (layer) try {
        $baf7a1f21323fe66$var$updateLayer(map, id, props, propsRef.current);
    } catch (error) {
        console.warn(error); // eslint-disable-line
    }
    else $baf7a1f21323fe66$var$createLayer(map, id, props);
    // Store last rendered props
    propsRef.current = props;
    return null;
}












var $e92445ef245d46f7$export$2e2bcd8739ae039 = (0, $9bfa0fb4992bfff5$export$a5c7b93649eaf8f8);





var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");




var $9c7Du = parcelRequire("9c7Du");

function $6a9a7fb72d1b9eb1$export$2a167ddb0a4e0420() {
    return (0, $9963aa6f9102c92d$export$b37ee0d76c6d2fbc)({
        status: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$cc4e5467ec2866fa), ''),
        customerName: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$cc4e5467ec2866fa), ''),
        make: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$cc4e5467ec2866fa), ''),
        model: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$cc4e5467ec2866fa), ''),
        vin: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$cc4e5467ec2866fa), '')
    });
}


function $0e67cb29c6be6bb5$export$86f8f9f08863e403() {
    const [selectedVehicle, setSelectedVehicle] = (0, $acw62.useState)(false);
    const map = (0, $64c812a720876a94$export$86f8f9f08863e403)();
    const [{ status: status, customerName: customerName, make: make, model: model, vin: vin }] = (0, $6a9a7fb72d1b9eb1$export$2a167ddb0a4e0420)();
    const initialViewState = {
        latitude: 37.67521882607042,
        longitude: -97.4297319194973,
        zoom: 4
    };
    const selectVehicle = ({ vehicle: vehicle, customer: customer })=>{
        setSelectedVehicle({
            vehicle: JSON.parse(vehicle),
            customer: JSON.parse(customer)
        });
    };
    const deselectVehicle = ()=>{
        setSelectedVehicle(false);
    };
    const onClick = (0, $acw62.useCallback)((event)=>{
        console.log(event.features);
        const feature = event.features && event.features[0];
        //const featureIsCluster = feature?.properties?.cluster
        const featureIsVehicle = !!feature?.properties?.vehicle && !!feature?.properties?.customer;
        if (featureIsVehicle) return selectVehicle({
            vehicle: feature?.properties?.vehicle,
            customer: feature?.properties?.customer
        });
        /*  COMMENTING OUT BROKEN CODE
    if(featureIsCluster){
      const clusterId = feature.properties.cluster_id
      const source = map.assets.getSource('car-source')
      return source?.getClusterExpansionZoom(clusterId, (err, zoom) => {
        if (err) {
          return
        }
         map.assets.easeTo({
          center: feature.geometry.coordinates,
          zoom,
          duration: 500,
        })
      })
     }*/ return deselectVehicle();
    }, [
        map
    ]);
    const { data: vehicles } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/vehicles',
            status,
            make,
            model,
            vin,
            customerName
        ],
        queryFn: async ()=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getVehicles({
                status: {
                    queryList: [
                        {
                            value: status,
                            property: 'status',
                            modifier: (0, $9c7Du.Modifier).EQUAL_TO
                        }
                    ],
                    orderList: [],
                    pagination: {
                        limit: 10000,
                        offset: 0
                    }
                },
                vehicleModel: model,
                vehicleMake: make,
                vehicleVin: vin,
                customerId: '',
                customerName: customerName,
                level: 0,
                maxItems: 0,
                vehicleId: '',
                geoReverseLookup: false
            }).then(async (res)=>{
                console.log({
                    res: res
                });
                return {
                    vehicles: res.vehiclesList,
                    geoJSON: $0e67cb29c6be6bb5$var$generateGeoJSON(res.vehiclesList)
                };
            }).catch((err)=>{
                // TODO: Should show a toast or message
                console.log({
                    err: err
                });
                return {
                    vehicles: [],
                    geoJSON: {
                        type: 'FeatureCollection',
                        features: []
                    }
                };
            });
        },
        refetchInterval: 25000,
        placeholderData: {
            vehicles: [],
            geoJSON: {
                type: 'FeatureCollection',
                features: []
            }
        }
    });
    return {
        onClick: onClick,
        vehicles: vehicles,
        initialViewState: initialViewState,
        selectedVehicle: selectedVehicle,
        deselectVehicle: deselectVehicle
    };
}
function $0e67cb29c6be6bb5$var$generateGeoJSON(vehicles) {
    return {
        type: 'FeatureCollection',
        features: $f1q41.chain(vehicles).filter((fleetVehicle)=>{
            return !!fleetVehicle.vehicle.locationLat && !!fleetVehicle.vehicle.locationLng;
        }).map((fleetVehicle)=>{
            return {
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [
                        Number.parseFloat(fleetVehicle.vehicle.locationLng),
                        Number.parseFloat(fleetVehicle.vehicle.locationLat)
                    ]
                },
                id: fleetVehicle.vehicle.id,
                properties: {
                    vehicleId: fleetVehicle?.vehicle?.id,
                    vehicle: fleetVehicle?.vehicle,
                    customer: fleetVehicle?.customer
                }
            };
        }).value()
    };
}



parcelRequire("acw62");




var $f1q41 = parcelRequire("f1q41");
const $911cc79afb37f8e1$var$token = "pk.eyJ1IjoicGF0cmlja2F1dG9ub215IiwiYSI6ImNsNnkxcGFjODJ4MjgzY3JxMWhwazlsNWYifQ.fy2CD5LfoSAhjVoq3MZlHg";
const $911cc79afb37f8e1$export$7f77ba4ae5a92f72 = {
    reverseGeoCode: $911cc79afb37f8e1$var$reverseGeoCode,
    getAddressFromPoint: $911cc79afb37f8e1$var$getAddressFromPoint
};
async function $911cc79afb37f8e1$var$reverseGeoCode(point) {
    return fetch(`https://api.mapbox.com/geocoding/v5/mapbox.places/${point.long},${point.lat}.json?access_token=${$911cc79afb37f8e1$var$token}`).then((res)=>{
        return res.json();
    });
}
async function $911cc79afb37f8e1$var$getAddressFromPoint(point) {
    return $911cc79afb37f8e1$var$reverseGeoCode(point).then((res)=>{
        return (0, $f1q41.find)(res.features, {
            place_type: [
                'address'
            ]
        });
    });
}




var $f1q41 = parcelRequire("f1q41");

var $3QqPt = parcelRequire("3QqPt");

function $d8623e255497753b$export$18c3c6510fb97afc(date) {
    return (0, $abb9adbdb26342b3$export$ead8a1812b171991)(date, Date.now());
}
var // Fallback for modularized imports:
$d8623e255497753b$export$2e2bcd8739ae039 = $d8623e255497753b$export$18c3c6510fb97afc;







function $e9cff913190bd013$export$fe114145ae75d197(dateLeft, dateRight) {
    const diff = +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateLeft) - +(0, $231bfb8d72679740$export$e67a095c620b86fe)(dateRight);
    if (diff < 0) return -1;
    else if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$e9cff913190bd013$export$2e2bcd8739ae039 = $e9cff913190bd013$export$fe114145ae75d197;






function $8aa264ebd3f03841$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$8aa264ebd3f03841$export$2e2bcd8739ae039 = $8aa264ebd3f03841$export$489984ac7c996389;





function $d2050f4e5c1a3003$export$c817d0312007ea5e(date, options) {
    const _date = (0, $231bfb8d72679740$export$e67a095c620b86fe)(date, options?.in);
    return +(0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(_date, options) === +(0, $e58340063d97ab50$export$a2258d9c4118825c)(_date, options);
}
var // Fallback for modularized imports:
$d2050f4e5c1a3003$export$2e2bcd8739ae039 = $d2050f4e5c1a3003$export$c817d0312007ea5e;


function $4bb5df50b9b59298$export$fc1ed482c2861792(laterDate, earlierDate, options) {
    const [laterDate_, workingLaterDate, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, laterDate, laterDate, earlierDate);
    const sign = (0, $e9cff913190bd013$export$fe114145ae75d197)(workingLaterDate, earlierDate_);
    const difference = Math.abs((0, $8aa264ebd3f03841$export$489984ac7c996389)(workingLaterDate, earlierDate_));
    if (difference < 1) return 0;
    if (workingLaterDate.getMonth() === 1 && workingLaterDate.getDate() > 27) workingLaterDate.setDate(30);
    workingLaterDate.setMonth(workingLaterDate.getMonth() - sign * difference);
    let isLastMonthNotFull = (0, $e9cff913190bd013$export$fe114145ae75d197)(workingLaterDate, earlierDate_) === -sign;
    if ((0, $d2050f4e5c1a3003$export$c817d0312007ea5e)(laterDate_) && difference === 1 && (0, $e9cff913190bd013$export$fe114145ae75d197)(laterDate_, earlierDate_) === 1) isLastMonthNotFull = false;
    const result = sign * (difference - +isLastMonthNotFull);
    return result === 0 ? 0 : result;
}
var // Fallback for modularized imports:
$4bb5df50b9b59298$export$2e2bcd8739ae039 = $4bb5df50b9b59298$export$fc1ed482c2861792;


function $495af4000bb18bf7$export$b6474a47258c1211(method) {
    return (number)=>{
        const round = method ? Math[method] : Math.trunc;
        const result = round(number);
        // Prevent negative zero
        return result === 0 ? 0 : result;
    };
}



function $b7913fc338fe28ad$export$7be94d13716b4bf6(laterDate, earlierDate) {
    return +(0, $231bfb8d72679740$export$e67a095c620b86fe)(laterDate) - +(0, $231bfb8d72679740$export$e67a095c620b86fe)(earlierDate);
}
var // Fallback for modularized imports:
$b7913fc338fe28ad$export$2e2bcd8739ae039 = $b7913fc338fe28ad$export$7be94d13716b4bf6;


function $e9186d0161460806$export$c1889aec51783710(laterDate, earlierDate, options) {
    const diff = (0, $b7913fc338fe28ad$export$7be94d13716b4bf6)(laterDate, earlierDate) / 1000;
    return (0, $495af4000bb18bf7$export$b6474a47258c1211)(options?.roundingMethod)(diff);
}
var // Fallback for modularized imports:
$e9186d0161460806$export$2e2bcd8739ae039 = $e9186d0161460806$export$c1889aec51783710;


function $9d83b4c514336dd1$export$2c14ff85d6318973(laterDate, earlierDate, options) {
    const defaultOptions = (0, $39440020b58e1ef8$export$430a3269e24b912e)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, $cd0c27002eb93234$export$137380d9ce54f7f);
    const minutesInAlmostTwoDays = 2520;
    const comparison = (0, $e9cff913190bd013$export$fe114145ae75d197)(laterDate, earlierDate);
    if (isNaN(comparison)) throw new RangeError("Invalid time value");
    const localizeOptions = Object.assign({}, options, {
        addSuffix: options?.addSuffix,
        comparison: comparison
    });
    const [laterDate_, earlierDate_] = (0, $002c8181c95d5119$export$9f53b88e82f64d8d)(options?.in, ...comparison > 0 ? [
        earlierDate,
        laterDate
    ] : [
        laterDate,
        earlierDate
    ]);
    const seconds = (0, $e9186d0161460806$export$c1889aec51783710)(earlierDate_, laterDate_);
    const offsetInSeconds = ((0, $92dc0740ffabe180$export$113002b5eff6e430)(earlierDate_) - (0, $92dc0740ffabe180$export$113002b5eff6e430)(laterDate_)) / 1000;
    const minutes = Math.round((seconds - offsetInSeconds) / 60);
    let months;
    // 0 up to 2 mins
    if (minutes < 2) {
        if (options?.includeSeconds) {
            if (seconds < 5) return locale.formatDistance("lessThanXSeconds", 5, localizeOptions);
            else if (seconds < 10) return locale.formatDistance("lessThanXSeconds", 10, localizeOptions);
            else if (seconds < 20) return locale.formatDistance("lessThanXSeconds", 20, localizeOptions);
            else if (seconds < 40) return locale.formatDistance("halfAMinute", 0, localizeOptions);
            else if (seconds < 60) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", 1, localizeOptions);
        } else {
            if (minutes === 0) return locale.formatDistance("lessThanXMinutes", 1, localizeOptions);
            else return locale.formatDistance("xMinutes", minutes, localizeOptions);
        }
    } else if (minutes < 45) return locale.formatDistance("xMinutes", minutes, localizeOptions);
    else if (minutes < 90) return locale.formatDistance("aboutXHours", 1, localizeOptions);
    else if (minutes < (0, $8540a44f59a4af84$export$2423174df8cd3cd2)) {
        const hours = Math.round(minutes / 60);
        return locale.formatDistance("aboutXHours", hours, localizeOptions);
    // 1 day up to 1.75 days
    } else if (minutes < minutesInAlmostTwoDays) return locale.formatDistance("xDays", 1, localizeOptions);
    else if (minutes < (0, $8540a44f59a4af84$export$ab7da2ccd1075c38)) {
        const days = Math.round(minutes / (0, $8540a44f59a4af84$export$2423174df8cd3cd2));
        return locale.formatDistance("xDays", days, localizeOptions);
    // 1 month up to 2 months
    } else if (minutes < (0, $8540a44f59a4af84$export$ab7da2ccd1075c38) * 2) {
        months = Math.round(minutes / (0, $8540a44f59a4af84$export$ab7da2ccd1075c38));
        return locale.formatDistance("aboutXMonths", months, localizeOptions);
    }
    months = (0, $4bb5df50b9b59298$export$fc1ed482c2861792)(earlierDate_, laterDate_);
    // 2 months up to 12 months
    if (months < 12) {
        const nearestMonth = Math.round(minutes / (0, $8540a44f59a4af84$export$ab7da2ccd1075c38));
        return locale.formatDistance("xMonths", nearestMonth, localizeOptions);
    // 1 year up to max Date
    } else {
        const monthsSinceStartOfYear = months % 12;
        const years = Math.trunc(months / 12);
        // N years up to 1 years 3 months
        if (monthsSinceStartOfYear < 3) return locale.formatDistance("aboutXYears", years, localizeOptions);
        else if (monthsSinceStartOfYear < 9) return locale.formatDistance("overXYears", years, localizeOptions);
        else return locale.formatDistance("almostXYears", years + 1, localizeOptions);
    }
}
var // Fallback for modularized imports:
$9d83b4c514336dd1$export$2e2bcd8739ae039 = $9d83b4c514336dd1$export$2c14ff85d6318973;


function $b8de4dab140c0dd6$export$d130c20a256f8817(date, options) {
    return (0, $9d83b4c514336dd1$export$2c14ff85d6318973)(date, (0, $d8623e255497753b$export$18c3c6510fb97afc)(date), options);
}
var // Fallback for modularized imports:
$b8de4dab140c0dd6$export$2e2bcd8739ae039 = $b8de4dab140c0dd6$export$d130c20a256f8817;


function $78ef9a8e3e6f443c$export$2bfab775185626e6({ vehicle: { vehicle: vehicle, customer: customer } }) {
    const { data: location, isLoading: locationIsLoading } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)([
        'reverseGeoCode',
        vehicle.locationLat,
        vehicle.locationLng
    ], ()=>{
        return (0, $911cc79afb37f8e1$export$7f77ba4ae5a92f72).getAddressFromPoint({
            long: Number.parseFloat(vehicle.locationLng),
            lat: Number.parseFloat(vehicle.locationLat)
        });
    });
    const { data: data, isLoading: customerIsLoading } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'customer',
            customer?.id
        ],
        queryFn: ()=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getCustomer({
                customerId: customer.id
            }).then((res)=>{
                return {
                    accountNumber: res.customer.accountNumber,
                    subscriptionDuration: $78ef9a8e3e6f443c$export$a097fa39f0389e5d(res)
                };
            });
        },
        enabled: !!customer
    });
    return {
        location: location,
        locationIsLoading: locationIsLoading,
        customerIsLoading: customerIsLoading,
        accountNumber: data?.accountNumber,
        subscriptionDuration: data?.subscriptionDuration
    };
}
function $78ef9a8e3e6f443c$export$a097fa39f0389e5d(customer) {
    const activeSubscription = (0, $f1q41.find)(customer.customer.subscriptionsList, {
        status: (0, $3QqPt.Subscription).Status.ACTIVE
    });
    if (!activeSubscription) return 'Inactive';
    try {
        return (0, $b8de4dab140c0dd6$export$d130c20a256f8817)(new Date(activeSubscription.activationDate));
    } catch (err) {
        console.log(err);
        return 'N/A';
    }
}


const $6d50ea0691693cf6$export$7203b6f87333b9a2 = new Intl.NumberFormat();


const $c4c967f9944d729d$export$19c6a4d9e02ba0d8 = ({ vehicle: vehicle, customer: customer, showDialog: showDialog, closeDialog: closeDialog })=>{
    const { location: location, locationIsLoading: locationIsLoading, customerIsLoading: customerIsLoading, accountNumber: accountNumber, subscriptionDuration: subscriptionDuration } = (0, $78ef9a8e3e6f443c$export$2bfab775185626e6)({
        vehicle: {
            vehicle: vehicle,
            customer: customer
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
        maxWidth: "lg",
        fullWidth: true,
        open: showDialog,
        onClose: closeDialog,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                variant: "h2",
                sx: {
                    backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mediumBlue
                },
                children: [
                    vehicle.year,
                    " ",
                    vehicle.make,
                    " ",
                    vehicle.model,
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                        onClick: closeDialog,
                        "aria-label": "close",
                        sx: {
                            position: 'absolute',
                            right: 10,
                            top: 10,
                            color: (theme)=>theme.palette.grey[500]
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ef87b97581793e1$export$2e2bcd8739ae039), {
                            children: "close"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                sx: {
                    backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mediumBlue
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    spacing: 2,
                    alignContent: "space-between",
                    sx: {
                        backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue,
                        padding: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            xs: 1,
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "Account #"
                                }),
                                customerIsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: accountNumber || 'N/A'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            xs: 2,
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "VIN"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: vehicle.vin
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            xs: 1,
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "Color"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: vehicle.color
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            xs: 1,
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "Odometer"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: (0, $6d50ea0691693cf6$export$7203b6f87333b9a2).format(vehicle.odometerReading)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            xs: 2,
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "Customer"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: customer.name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            xs: 3,
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "Location"
                                }),
                                locationIsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    children: location?.place_name
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            flex: 3,
                            item: true,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    children: "Subscription Duration"
                                }),
                                customerIsLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    sx: {
                                        textTransform: 'capitalize'
                                    },
                                    children: subscriptionDuration || 'N/A'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};


const $856e76a15751d807$export$f3f695e33b6720f2 = {
    id: 'point',
    type: 'circle',
    filter: [
        'has',
        'point_count'
    ],
    paint: {
        'circle-color': [
            'step',
            [
                'get',
                'point_count'
            ],
            '#FF8CDD',
            100,
            '#FF8CDD',
            750,
            '#FF8CDD'
        ],
        'circle-radius': [
            'step',
            [
                'get',
                'point_count'
            ],
            15,
            100,
            20,
            750,
            40
        ]
    }
};
const $856e76a15751d807$export$bd9fe56bda97a9a3 = {
    id: 'cluster-count',
    type: 'symbol',
    source: 'clusteredVehicles',
    filter: [
        'has',
        'point_count'
    ],
    layout: {
        'text-field': '{point_count_abbreviated}',
        'text-font': [
            'DIN Offc Pro Medium',
            'Arial Unicode MS Bold'
        ],
        'text-size': 16
    },
    paint: {
        'text-color': '#ffffff'
    }
};
const $856e76a15751d807$export$5be09500a70bd839 = {
    id: 'unclustered-point',
    type: 'circle',
    source: 'vehicles',
    filter: [
        '!',
        [
            'has',
            'point_count'
        ]
    ],
    paint: {
        'circle-color': '#FF8CDD',
        'circle-radius': 7
    }
};





const $725fb7b463823880$export$d846a084e680d8e = {
    fontFamily: [
        '"DM Sans"',
        '"Helvetica Neue"',
        'sans-serif'
    ].join(','),
    h1: {
        fontSize: 30,
        fontWeight: 700
    },
    h3: {
        fontSize: 24,
        fontWeight: 500
    },
    h4: {
        fontSize: 20,
        fontWeight: 500
    },
    h2: {
        fontSize: 24,
        fontWeight: 500
    },
    caption: {
        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.caption,
        fontSize: 14,
        '&.largeCaption': {
            fontSize: 15
        }
    }
};






const $c9c3598ac5d6d2df$export$9b5ac10f59f76296 = {
    ///////// BUTTON /////////
    MuiButton: {
        defaultProps: {
            disableElevation: true
        },
        styleOverrides: {
            root: {
                textTransform: 'none',
                textDecoration: 'none',
                borderRadius: '50px',
                padding: '2px 36px',
                fontSize: 16,
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary,
                border: '1px solid transparent',
                '&.round': {
                    borderRadius: '50%',
                    padding: 0,
                    minHeight: 40,
                    minWidth: 40
                },
                '&.ctaBtn': {
                    border: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).lightCyan}`,
                    borderRadius: 5,
                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).cyan,
                    '> .ctaBtnIcon': {
                        marginLeft: 15
                    }
                }
            },
            containedPrimary: {
                variant: 'contained',
                backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.primary,
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.secondary,
                '&:hover': {
                    border: `1px solid ${(0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.primary}`,
                    backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue,
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.highlight.primary
                },
                '&:disabled': {
                    backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.primary,
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.secondary,
                    opacity: 0.5
                }
            },
            containedSecondary: {
                variant: 'contained',
                backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.secondary,
                borderColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.secondary,
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.secondary,
                '&:hover': {
                    border: `1px solid ${(0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.secondary}`,
                    backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue,
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.highlight.secondary
                },
                '&:disabled': {
                    backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.secondary,
                    borderColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.secondary,
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.secondary,
                    opacity: 0.5
                }
            },
            outlinedPrimary: {
                variant: 'outlined',
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary,
                border: '1px solid ' + `${(0, $a72062603a8a430a$export$eaad8caa32d2521d).background.white}`,
                '&:hover': {
                    border: `1px solid ${(0, $a72062603a8a430a$export$eaad8caa32d2521d).background.white}`,
                    backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.white,
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.secondary
                }
            }
        }
    },
    MuiTablePagination: {
        styleOverrides: {
            root: {
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary
            }
        }
    },
    ///////// DATA GRID /////////
    MuiDataGrid: {
        styleOverrides: {
            columnSeparator: {
                display: 'none'
            },
            root: {
                backgroundColor: 'transparent',
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary,
                flexGrow: 1,
                fontSize: 16,
                fontWeight: 400,
                border: 'none',
                width: '100%',
                '& .MuiDataGrid-cell a': {
                    textDecoration: 'none'
                },
                '& .MuiDataGrid-cell a.documentLink': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary,
                    '&:hover': {
                        textDecoration: 'underline'
                    },
                    '&:visited': {
                        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary
                    }
                },
                '& .MuiDataGrid-virtualScroller': {
                    overflowY: 'hidden'
                },
                '& .MuiDataGrid-columnHeaders': {
                    borderBottom: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`
                },
                '& .MuiDataGrid-columnHeader.captionColumnHeader': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.caption,
                    fontSize: 14
                },
                '& .MuiDataGrid-row': {
                    borderTop: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`,
                    '&:first-of-type': {
                        borderTop: '1px solid transparent'
                    }
                },
                '& .MuiDataGrid-footerContainer': {
                    borderTop: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`
                },
                '& .MuiDataGrid-overlay': {
                    backgroundColor: 'transparent'
                },
                '& .MuiDataGrid-cell.alignCenter': {
                    justifyContent: 'center'
                },
                // Resetting MUI DataGrid default behaviour on renderEditCell
                // this should only affect / apply to cells with TextFields
                '& .MuiDataGrid-cell.MuiDataGrid-cell--editing': {
                    paddingLeft: '11px',
                    paddingRight: '11px',
                    backgroundColor: 'transparent'
                }
            }
        }
    },
    MuiCircularProgress: {
        styleOverrides: {
            root: {
                color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue
            }
        }
    },
    ///////// TYPOGRAPHY /////////
    MuiTypography: {
        styleOverrides: {
            root: {
                '&.primaryAccent': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.highlight.primary,
                    fontWeight: 'bold'
                },
                '&.secondaryAccent': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.highlight.secondary
                },
                // force pointer cursor on elements with non-inherent pointer hover styles
                '&.hoverStyle': {
                    cursor: 'pointer'
                },
                '&.bold': {
                    fontWeight: 700
                },
                '&.muted': {
                    opacity: 0.3
                },
                '&.success': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.success
                },
                '&.error': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.error
                }
            }
        }
    },
    ///////// APP BAR /////////
    MuiAppBar: {
        styleOverrides: {
            root: {
                height: 64,
                minHeight: 64,
                backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.default,
                backgroundImage: 'none',
                // remove linear gradient from appbar
                '& .MuiAutocomplete-root': {
                    boxSizing: 'border-box',
                    flex: 0.8,
                    height: 37,
                    maxHeight: 37,
                    '& .MuiOutlinedInput-root': {
                        backgroundColor: 'transparent',
                        padding: '0 0 0 10px !important',
                        '& .MuiOutlinedInput-notchedOutline': {
                            border: `1px solid ${(0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.primary}`,
                            borderRadius: 50
                        },
                        '& .MuiInputAdornment-root.MuiInputAdornment-positionEnd': {
                            backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.primary,
                            height: '100%',
                            maxHeight: '100%',
                            borderRadius: '0 50px 50px 0',
                            paddingLeft: 20,
                            paddingRight: 20
                        },
                        '> input::placeholder': {
                            color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.highlight.primary
                        }
                    },
                    '& .MuiTextField-root': {
                        backgroundColor: 'transparent',
                        boxSizing: 'border-box',
                        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary,
                        height: 37,
                        maxHeight: 37
                    }
                }
            }
        }
    },
    ///////// DIALOGS /////////
    MuiDialog: {
        styleOverrides: {
            root: {
                '& .MuiDialog-container': {
                    margin: '0 auto'
                },
                '& .MuiGrid-root': {
                    marginTop: 0,
                    width: '100%',
                    marginLeft: 0,
                    '& .MuiGrid-item': {
                        paddingLeft: 0
                    }
                }
            }
        }
    },
    MuiDialogContent: {
        styleOverrides: {
            root: {
                '& .MuiInputLabel-root': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary
                }
            }
        }
    },
    MuiDialogActions: {
        styleOverrides: {
            root: {
                padding: 20
            }
        }
    },
    ///////// CHECKBOX /////////
    MuiCheckbox: {
        styleOverrides: {
            colorPrimary: {
                opacity: 0.3,
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.white,
                '&.Mui-checked': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.white,
                    opacity: 1
                }
            }
        }
    },
    ///////// FORM CONTROL LABEL /////////
    MuiFormControlLabel: {
        styleOverrides: {
            root: {
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.muted,
                '&.active': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.white
                },
                // reset cursor on elements with inherent pointer hover style
                '&.resetHoverStyle': {
                    ':hover': {
                        cursor: 'not-allowed'
                    }
                },
                '&.resetHoverStyle .MuiCheckbox-root': {
                    ':hover': {
                        cursor: 'not-allowed'
                    }
                },
                '&.compactCheckboxList': {
                    '> .MuiCheckbox-root': {
                        padding: '5px 19px 5px 9px'
                    }
                },
                '&.switchLabel': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary,
                    '&.muted': {
                        opacity: 0.3
                    }
                },
                '&.checkboxLabel': {
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary
                }
            }
        }
    },
    ///////// INPUTS /////////
    MuiOutlinedInput: {
        styleOverrides: {
            root: {
                backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.paper,
                color: '#80a0ad',
                fontSize: '.9rem',
                padding: '5px 19px',
                '> .MuiOutlinedInput-input': {
                    padding: 0
                },
                minWidth: '245px',
                '&.compactSelect': {
                    minWidth: 0,
                    height: '30px',
                    maxHeight: '30px',
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary
                },
                transition: 'opacity 200ms ease-in',
                '&.Mui-disabled': {
                    opacity: 0.3,
                    ':hover': {
                        cursor: 'not-allowed'
                    },
                    '& .MuiSelect-select:hover': {
                        cursor: 'not-allowed'
                    }
                }
            }
        }
    },
    MuiTextField: {
        styleOverrides: {
            root: {
                '&.MuiTextField-root': {
                    '&.compactTextField': {
                        '> .MuiOutlinedInput-root': {
                            color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary,
                            minWidth: 0
                        },
                        '&.roundedTextField': {
                            '> .MuiOutlinedInput-root': {
                                borderRadius: 50,
                                minWidth: 0,
                                width: 'auto',
                                '&.xs': {
                                    maxWidth: '100px'
                                },
                                '> .MuiInputBase-input': {
                                    textAlign: 'center'
                                }
                            }
                        }
                    },
                    '&.wideTextField': {
                        '> .MuiOutlinedInput-root': {
                            color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary,
                            minWidth: '300px'
                        }
                    }
                }
            }
        }
    },
    MuiSelect: {
        defaultProps: {
            autoWidth: false
        }
    },
    MuiInputLabel: {
        styleOverrides: {
            root: {
                color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary
            }
        }
    },
    ///////// PAPER /////////
    MuiPaper: {
        styleOverrides: {
            root: {
                '> .MuiList-root': {
                    backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.paper,
                    paddingTop: 0
                },
                // the currently selected value in a Select dropdown
                '> .MuiList-root > li.Mui-selected': {
                    paddingTop: 10,
                    backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.muted
                },
                '> .MuiList-root > li': {
                    paddingLeft: '29px',
                    paddingRight: '29px',
                    color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.primary
                },
                '> .MuiList-root > li:not(:last-of-type)': {
                    paddingBottom: 10,
                    borderBottom: '0.5px solid #80a0ad'
                },
                ///////// TEMP MUI X-DATE-PICKERS /////////
                // note: this should only be temporary, until the x-date-picker package gets
                // bumped out of alpha version. Then we should ( be able to ) just use MuiDatePicker
                '.MuiCalendarPicker-root': {
                    backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue,
                    // S M T etc.
                    '.MuiTypography-caption': {
                        color: '#E6F200',
                        fontWeight: 800
                    },
                    '.PrivatePickersSlideTransition-root': {
                        height: 'auto'
                    },
                    // the days in the calendar month
                    '.MuiPickersDay-root': {
                        backgroundColor: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue,
                        border: 'none',
                        fontWeight: 800,
                        // selected date
                        '&.Mui-selected': {
                            backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.accent.secondary,
                            color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).darkBlue
                        },
                        '&.Mui-disabled': {
                            color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue
                        }
                    }
                }
            }
        }
    },
    ///////// MUI ICON BUTTON /////////
    MuiIconButton: {
        styleOverrides: {
            root: {
                '&.xsIcon': {
                    '& .MuiSvgIcon-root': {
                        height: '.7em',
                        width: 'auto'
                    }
                }
            }
        }
    },
    ///////// MUI SWITCH /////////
    MuiSwitch: {
        styleOverrides: {
            root: {
                width: '70px',
                '.MuiSwitch-thumb': {
                    transform: 'translateX(6px)'
                },
                '.MuiSwitch-track': {
                    backgroundColor: 'transparent',
                    border: `1px solid ${(0, $a72062603a8a430a$export$eaad8caa32d2521d).background.white}`,
                    borderRadius: '50px',
                    height: '26px',
                    transform: 'translateY(-6px)'
                }
            },
            colorPrimary: {
                // unchecked base styles
                opacity: 0.3,
                '& .MuiSwitch-thumb': {
                    backgroundColor: (0, $a72062603a8a430a$export$eaad8caa32d2521d).background.white
                },
                // checked style
                '&.Mui-checked': {
                    opacity: 1
                }
            }
        }
    },
    ///////// MUI TABLE /////////
    MuiTableRow: {
        styleOverrides: {
            root: {
                '& .MuiTableCell-root': {
                    borderBottom: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`
                },
                '& .MuiTableCell-root:first-of-type': {
                    paddingLeft: 0
                },
                '& .MuiTableCell-root:last-of-type': {
                    paddingRight: 0
                },
                '&:last-child': {
                    '& .MuiTableCell-root': {
                        borderBottom: '1px solid transparent'
                    }
                }
            }
        }
    },
    ///////// MUI ACCORDION /////////
    MuiAccordion: {
        styleOverrides: {
            root: {
                backgroundImage: 'none',
                boxShadow: 'none',
                paddingTop: 50,
                paddingBottom: 50,
                position: 'initial',
                borderBottom: `1px solid ${(0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).mutedBlue}`
            }
        }
    },
    MuiAccordionDetails: {
        styleOverrides: {
            root: {
                '&.horizontal > .MuiGrid-root': {
                    '> .MuiGrid-root': {
                        '> .MuiGrid-root': {
                            columnGap: '20px',
                            rowGap: '20px'
                        }
                    }
                }
            }
        }
    },
    ///////// MUI MODAL /////////
    MuiModal: {
        styleOverrides: {
            root: {
                display: 'flex',
                alignItems: 'center',
                '&.modal-xl': {
                    width: '90%',
                    margin: '0 auto'
                }
            }
        }
    }
};


const $afc5623fd0e14791$var$theme = (0, $1c8355eadf532640$export$2e2bcd8739ae039)({
    palette: $a72062603a8a430a$export$eaad8caa32d2521d,
    components: $c9c3598ac5d6d2df$export$9b5ac10f59f76296,
    typography: $725fb7b463823880$export$d846a084e680d8e
});
var $afc5623fd0e14791$export$2e2bcd8739ae039 = $afc5623fd0e14791$var$theme;


const $c86b2778de2e9c5d$export$5eda721ee2d60efe = {
    LARGE: '93vh',
    SMALL: '40vh',
    MIN: '5vh'
};
const $c86b2778de2e9c5d$export$ff0a5c3b387ab1ad = (0, $3d856d11b8f09dd7$export$b35517af9e0a5689)()({
    mapContainer: {
        width: '100vw',
        height: $c86b2778de2e9c5d$export$5eda721ee2d60efe.LARGE,
        minHeight: $c86b2778de2e9c5d$export$5eda721ee2d60efe.LARGE,
        zIndex: 2,
        display: 'block',
        position: 'relative',
        transition: 'all 0.33s ease-out'
    },
    mapBar: {
        backgroundColor: (0, $afc5623fd0e14791$export$2e2bcd8739ae039).palette.background.default,
        height: '5vh',
        cursor: 'pointer',
        position: 'absolute',
        bottom: 0,
        left: 0,
        zIndex: 100,
        minWidth: '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '300%',
        lineHeight: '12px',
        borderRadius: '12px 12px 0 0'
    }
});



parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");














function $d763330bc495c775$export$5162da8f798e0959(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiCollapse', slot);
}
const $d763330bc495c775$var$collapseClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiCollapse', [
    'root',
    'horizontal',
    'vertical',
    'entered',
    'hidden',
    'wrapper',
    'wrapperInner'
]);
var $d763330bc495c775$export$2e2bcd8739ae039 = $d763330bc495c775$var$collapseClasses;



'use client';
const $691c7db844a32c8c$var$useUtilityClasses = (ownerState)=>{
    const { orientation: orientation, classes: classes } = ownerState;
    const slots = {
        root: [
            'root',
            `${orientation}`
        ],
        entered: [
            'entered'
        ],
        hidden: [
            'hidden'
        ],
        wrapper: [
            'wrapper',
            `${orientation}`
        ],
        wrapperInner: [
            'wrapperInner',
            `${orientation}`
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $d763330bc495c775$export$5162da8f798e0959), classes);
};
const $691c7db844a32c8c$var$CollapseRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            styles[ownerState.orientation],
            ownerState.state === 'entered' && styles.entered,
            ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        height: 0,
        overflow: 'hidden',
        transition: theme.transitions.create('height'),
        variants: [
            {
                props: {
                    orientation: 'horizontal'
                },
                style: {
                    height: 'auto',
                    width: 0,
                    transition: theme.transitions.create('width')
                }
            },
            {
                props: {
                    state: 'entered'
                },
                style: {
                    height: 'auto',
                    overflow: 'visible'
                }
            },
            {
                props: {
                    state: 'entered',
                    orientation: 'horizontal'
                },
                style: {
                    width: 'auto'
                }
            },
            {
                props: ({ ownerState: ownerState })=>ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px',
                style: {
                    visibility: 'hidden'
                }
            }
        ]
    })));
const $691c7db844a32c8c$var$CollapseWrapper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'Wrapper'
})({
    // Hack to get children with a negative margin to not falsify the height computation.
    display: 'flex',
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
const $691c7db844a32c8c$var$CollapseWrapperInner = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiCollapse',
    slot: 'WrapperInner'
})({
    width: '100%',
    variants: [
        {
            props: {
                orientation: 'horizontal'
            },
            style: {
                width: 'auto',
                height: '100%'
            }
        }
    ]
});
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/material-ui/react-stepper/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */ const $691c7db844a32c8c$var$Collapse = /*#__PURE__*/ $acw62.forwardRef(function Collapse(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiCollapse'
    });
    const { addEndListener: addEndListener, children: children, className: className, collapsedSize: collapsedSizeProp = '0px', component: component, easing: easing, in: inProp, onEnter: onEnter, onEntered: onEntered, onEntering: onEntering, onExit: onExit, onExited: onExited, onExiting: onExiting, orientation: orientation = 'vertical', style: style, timeout: timeout = (0, $b3dcd50dcf07bac9$export$1f34108aa9eb96ab).standard, TransitionComponent: // eslint-disable-next-line react/prop-types
    TransitionComponent = (0, $0fef977f04119bf5$export$2e2bcd8739ae039), ...other } = props;
    const ownerState = {
        ...props,
        orientation: orientation,
        collapsedSize: collapsedSizeProp
    };
    const classes = $691c7db844a32c8c$var$useUtilityClasses(ownerState);
    const theme = (0, $81976569638fc3b7$export$2e2bcd8739ae039)();
    const timer = (0, $fcd4c6205d65c7df$export$2e2bcd8739ae039)();
    const wrapperRef = $acw62.useRef(null);
    const autoTransitionDuration = $acw62.useRef();
    const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
    const isHorizontal = orientation === 'horizontal';
    const size = isHorizontal ? 'width' : 'height';
    const nodeRef = $acw62.useRef(null);
    const handleRef = (0, $0a9974d6176bfa01$export$2e2bcd8739ae039)(ref, nodeRef);
    const normalizedTransitionCallback = (callback)=>(maybeIsAppearing)=>{
            if (callback) {
                const node = nodeRef.current;
                // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
                if (maybeIsAppearing === undefined) callback(node);
                else callback(node, maybeIsAppearing);
            }
        };
    const getWrapperSize = ()=>wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;
    const handleEnter = normalizedTransitionCallback((node, isAppearing)=>{
        if (wrapperRef.current && isHorizontal) // Set absolute position to get the size of collapsed content
        wrapperRef.current.style.position = 'absolute';
        node.style[size] = collapsedSize;
        if (onEnter) onEnter(node, isAppearing);
    });
    const handleEntering = normalizedTransitionCallback((node, isAppearing)=>{
        const wrapperSize = getWrapperSize();
        if (wrapperRef.current && isHorizontal) // After the size is read reset the position back to default
        wrapperRef.current.style.position = '';
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'enter'
        });
        if (timeout === 'auto') {
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = `${wrapperSize}px`;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onEntering) onEntering(node, isAppearing);
    });
    const handleEntered = normalizedTransitionCallback((node, isAppearing)=>{
        node.style[size] = 'auto';
        if (onEntered) onEntered(node, isAppearing);
    });
    const handleExit = normalizedTransitionCallback((node)=>{
        node.style[size] = `${getWrapperSize()}px`;
        if (onExit) onExit(node);
    });
    const handleExited = normalizedTransitionCallback(onExited);
    const handleExiting = normalizedTransitionCallback((node)=>{
        const wrapperSize = getWrapperSize();
        const { duration: transitionDuration, easing: transitionTimingFunction } = (0, $09228c405c75d141$export$8cb1e9b404609ae9)({
            style: style,
            timeout: timeout,
            easing: easing
        }, {
            mode: 'exit'
        });
        if (timeout === 'auto') {
            // TODO: rename getAutoHeightDuration to something more generic (width support)
            // Actually it just calculates animation duration based on size
            const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
            node.style.transitionDuration = `${duration2}ms`;
            autoTransitionDuration.current = duration2;
        } else node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
        node.style[size] = collapsedSize;
        node.style.transitionTimingFunction = transitionTimingFunction;
        if (onExiting) onExiting(node);
    });
    const handleAddEndListener = (next)=>{
        if (timeout === 'auto') timer.start(autoTransitionDuration.current || 0, next);
        if (addEndListener) // Old call signature before `react-transition-group` implemented `nodeRef`
        addEndListener(nodeRef.current, next);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionComponent, {
        in: inProp,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        timeout: timeout === 'auto' ? null : timeout,
        ...other,
        children: (state, { ownerState: incomingOwnerState, ...restChildProps })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($691c7db844a32c8c$var$CollapseRoot, {
                as: component,
                className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className, {
                    'entered': classes.entered,
                    'exited': !inProp && collapsedSize === '0px' && classes.hidden
                }[state]),
                style: {
                    [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize,
                    ...style
                },
                ref: handleRef,
                ownerState: {
                    ...ownerState,
                    state: state
                },
                ...restChildProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($691c7db844a32c8c$var$CollapseWrapper, {
                    ownerState: {
                        ...ownerState,
                        state: state
                    },
                    className: classes.wrapper,
                    ref: wrapperRef,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($691c7db844a32c8c$var$CollapseWrapperInner, {
                        ownerState: {
                            ...ownerState,
                            state: state
                        },
                        className: classes.wrapperInner,
                        children: children
                    })
                })
            })
    });
});
if ($691c7db844a32c8c$var$Collapse) $691c7db844a32c8c$var$Collapse.muiSupportAuto = true;
var $691c7db844a32c8c$export$2e2bcd8739ae039 = $691c7db844a32c8c$var$Collapse;



var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");

var $9YICB = parcelRequire("9YICB");


function $5bfae9134e028e0d$export$75fe111fe20c852e() {
    const [{ status: status, customerName: customerName, vin: vin, make: make, model: model }, setQueryParams] = (0, $6a9a7fb72d1b9eb1$export$2a167ddb0a4e0420)();
    const [expanded, setExpanded] = (0, $acw62.useState)(false);
    const handleExpandClick = ()=>{
        setExpanded(!expanded);
    };
    const statusOptions = [
        {
            label: 'Any Status',
            key: '',
            value: 1000
        }
    ].concat((0, $f1q41.map)((0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $9YICB.State)), (val, key)=>{
        return {
            ...val,
            key: key
        };
    }));
    const setStatusOption = (evt, value, reason, details)=>{
        console.log({
            reason: reason,
            details: details,
            value: value,
            evt: evt
        });
        if (reason === 'clear') return setQueryParams({
            status: undefined
        });
        if (value.key.length === 0) return setQueryParams({
            status: undefined
        });
        setQueryParams({
            status: value.key
        });
    };
    const buildSetQueryCallback = (key)=>{
        return (evt)=>{
            setQueryParams({
                [key]: evt.target.value
            });
        };
    };
    const setCustomerName = buildSetQueryCallback('customerName');
    const setVIN = buildSetQueryCallback('vin');
    const setMake = buildSetQueryCallback('make');
    const setModel = buildSetQueryCallback('model');
    return {
        status: status,
        statusOptions: statusOptions,
        setStatusOption: setStatusOption,
        customerName: customerName,
        vin: vin,
        make: make,
        model: model,
        setCustomerName: setCustomerName,
        setVIN: setVIN,
        setMake: setMake,
        setModel: setModel,
        expanded: expanded,
        setExpanded: setExpanded,
        handleExpandClick: handleExpandClick
    };
}





var $f1q41 = parcelRequire("f1q41");

const $151e2eca973d529b$var$textFieldStyle = {
    marginTop: 1,
    marginBottom: 1
};
const $151e2eca973d529b$var$ExpandMore = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((props)=>{
    //eslint-disable-next-line
    const { expanded: expanded, ...other } = props;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
        ...other
    });
})(({ theme: theme, expanded: expanded })=>({
        transform: !expanded ? 'rotate(0deg)' : 'rotate(180deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        })
    }));
const $151e2eca973d529b$export$7dfdbec7ea56a17a = ()=>{
    const mapQuery = (0, $5bfae9134e028e0d$export$75fe111fe20c852e)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
        sx: {
            position: 'absolute',
            zIndex: 1000,
            right: 400,
            top: 50,
            width: 300
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: '10px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h5",
                        sx: {
                            marginLeft: '10px'
                        },
                        children: "Filter Map"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($151e2eca973d529b$var$ExpandMore, {
                        expand: mapQuery.expanded,
                        onClick: mapQuery.handleExpandClick,
                        "aria-expanded": mapQuery.expanded,
                        "aria-label": "show more",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $691c7db844a32c8c$export$2e2bcd8739ae039), {
                in: mapQuery.expanded,
                timeout: "auto",
                unmountOnExit: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e721a73094186d5d$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db86fcacc6287e65$export$2e2bcd8739ae039), {
                            options: mapQuery.statusOptions,
                            onChange: mapQuery.setStatusOption,
                            value: mapQuery.status,
                            isOptionEqualToValue: (option, value)=>{
                                return option?.key === value;
                            },
                            getOptionLabel: (option)=>{
                                if (!(0, $f1q41.isString)(option)) return option.label;
                                return (0, $2fe0bab7a0e34f9c$export$7b4c15ffe6a6b0c9)(option);
                            },
                            renderInput: (params)=>{
                                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    sx: $151e2eca973d529b$var$textFieldStyle,
                                    label: "Status",
                                    ...params
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            sx: $151e2eca973d529b$var$textFieldStyle,
                            label: "Customer Name",
                            value: mapQuery.customerName,
                            onChange: mapQuery.setCustomerName
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            sx: $151e2eca973d529b$var$textFieldStyle,
                            label: "VIN",
                            value: mapQuery.vin,
                            onChange: mapQuery.setVIN
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            sx: $151e2eca973d529b$var$textFieldStyle,
                            label: "Make",
                            value: mapQuery.make,
                            onChange: mapQuery.setMake
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            sx: $151e2eca973d529b$var$textFieldStyle,
                            label: "Model",
                            value: mapQuery.model,
                            onChange: mapQuery.setModel
                        })
                    ]
                })
            })
        ]
    });
};


const $1606b8e6ca4fdaa8$var$AssetMap = ()=>{
    const { classes: classes } = (0, $c86b2778de2e9c5d$export$ff0a5c3b387ab1ad)();
    const { onClick: onClick, vehicles: vehicles, initialViewState: initialViewState, selectedVehicle: selectedVehicle, deselectVehicle: deselectVehicle } = (0, $0e67cb29c6be6bb5$export$86f8f9f08863e403)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: classes.mapContainer,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $151e2eca973d529b$export$7dfdbec7ea56a17a), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9bfa0fb4992bfff5$export$a5c7b93649eaf8f8), {
                id: "assets",
                mapboxAccessToken: "pk.eyJ1IjoicGF0cmlja2F1dG9ub215IiwiYSI6ImNsNnkxcGFjODJ4MjgzY3JxMWhwazlsNWYifQ.fy2CD5LfoSAhjVoq3MZlHg",
                mapStyle: "mapbox://styles/mapbox/light-v11",
                // TODO: move to NXCR mapbox account
                // mapStyle="mapbox://styles/patrickautonomy/cl77tj18w003j14lodmmjtcro"
                onClick: onClick,
                interactiveLayerIds: [
                    (0, $856e76a15751d807$export$f3f695e33b6720f2).id,
                    (0, $856e76a15751d807$export$5be09500a70bd839).id
                ],
                doubleClickZoom: true,
                initialViewState: initialViewState,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c2d35c3db04f1ab9$export$1d2df86270c81ecb), {
                    id: "car-source",
                    type: "geojson",
                    data: vehicles.geoJSON,
                    cluster: true,
                    clusterMaxZoom: 14,
                    clusterRadius: 50,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $baf7a1f21323fe66$export$936d0764594b6eb3), {
                            ...(0, $856e76a15751d807$export$f3f695e33b6720f2)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $baf7a1f21323fe66$export$936d0764594b6eb3), {
                            ...(0, $856e76a15751d807$export$bd9fe56bda97a9a3)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $baf7a1f21323fe66$export$936d0764594b6eb3), {
                            ...(0, $856e76a15751d807$export$5be09500a70bd839)
                        })
                    ]
                })
            }),
            selectedVehicle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c4c967f9944d729d$export$19c6a4d9e02ba0d8), {
                customer: selectedVehicle.customer,
                vehicle: selectedVehicle.vehicle,
                closeDialog: deselectVehicle,
                showDialog: !!selectedVehicle
            })
        ]
    });
};
var $1606b8e6ca4fdaa8$export$2e2bcd8739ae039 = $1606b8e6ca4fdaa8$var$AssetMap;


const $ffa7abbb5f0060a7$export$23f3dfd47374502b = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1606b8e6ca4fdaa8$export$2e2bcd8739ae039), {});
};



parcelRequire("acw62");


var $f1q41 = parcelRequire("f1q41");

var $f1q41 = parcelRequire("f1q41");

var $acw62 = parcelRequire("acw62");

function $18d60b1761851bb0$var$getTime() {
    return new Date().getTime();
}
const $18d60b1761851bb0$var$vestaboardURL = 'wss://platform.vestaboard.com/ws/';
function $18d60b1761851bb0$var$uuidv4() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c)=>(c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}
const $18d60b1761851bb0$var$uid = $18d60b1761851bb0$var$uuidv4();
function $18d60b1761851bb0$export$ecebce6c3cc8ca46() {
    const [vbData, setVBData] = (0, $acw62.useState)({
        fleet: '',
        val: '',
        cost: '',
        arp: '',
        inv: '',
        paid: '',
        subs: '',
        app: '',
        resv: '',
        qual: '',
        cars: '',
        daily: ''
    });
    (0, $acw62.useEffect)(()=>{
        const socket = new WebSocket(`${$18d60b1761851bb0$var$vestaboardURL}${$18d60b1761851bb0$var$uid}`);
        socket.onopen = function() {
            socket.send('{"message":{"type":"DeviceHeartbeatMessage","deviceId":"' + $18d60b1761851bb0$var$uid + '","clientTime":' + $18d60b1761851bb0$var$getTime() + '}}');
            socket.send('{"message":{"type":"DeviceIdentifyMessage","deviceId":"' + $18d60b1761851bb0$var$uid + '","clientTime":' + $18d60b1761851bb0$var$getTime() + ',"boardId":"20c647fe-3057-4531-888d-a9e81faed9c7"}}');
        };
        socket.onmessage = (event)=>{
            const data = (0, $288e026a18a9870d$export$f205803a3961ad7)(event.data);
            if (!$18d60b1761851bb0$var$isDisplayCommand(data)) return;
            const characters = data.message.characters.characters;
            const vestaLines = (0, $f1q41.map)(characters, (chars)=>{
                return (0, $f1q41.map)(chars, (char)=>{
                    return $18d60b1761851bb0$var$convertCharacterCodeToCharacter(char);
                });
            });
            const vestaboardData = {
                fleet: vestaLines[0].slice(0, 6).join('').trim(),
                val: vestaLines[1].slice(0, 6).join('').trim(),
                cost: vestaLines[2].slice(0, 6).join('').trim(),
                arp: vestaLines[3].slice(0, 6).join('').trim(),
                inv: vestaLines[4].slice(0, 6).join('').trim(),
                paid: vestaLines[5].slice(0, 6).join('').trim(),
                subs: vestaLines[0].slice(13, 17).join('').trim(),
                app: vestaLines[1].slice(13, 17).join('').trim(),
                resv: vestaLines[2].slice(13, 17).join('').trim(),
                qual: vestaLines[3].slice(13, 17).join('').trim(),
                cars: vestaLines[4].slice(12, 17).join('').trim(),
                daily: vestaLines[5].slice(13, 17).join('').trim()
            };
            setVBData(vestaboardData);
        };
        return ()=>{
            return socket.close();
        };
    }, []);
    return {
        vbData: vbData
    };
}
function $18d60b1761851bb0$var$isDisplayCommand(data) {
    return data?.message?.type === 'DeviceMessageDisplayCommand';
}
function $18d60b1761851bb0$var$convertCharacterCodeToCharacter(characterCode) {
    switch(characterCode){
        case 0:
            return ' ';
        case 1:
            return 'A';
        case 2:
            return 'B';
        case 3:
            return 'C';
        case 4:
            return 'D';
        case 5:
            return 'E';
        case 6:
            return 'F';
        case 7:
            return 'G';
        case 8:
            return 'H';
        case 9:
            return 'I';
        case 10:
            return 'J';
        case 11:
            return 'K';
        case 12:
            return 'L';
        case 13:
            return 'M';
        case 14:
            return 'N';
        case 15:
            return 'O';
        case 16:
            return 'P';
        case 17:
            return 'Q';
        case 18:
            return 'R';
        case 19:
            return 'S';
        case 20:
            return 'T';
        case 21:
            return 'U';
        case 22:
            return 'V';
        case 23:
            return 'W';
        case 24:
            return 'X';
        case 25:
            return 'Y';
        case 26:
            return 'Z';
        case 27:
            return '1';
        case 28:
            return '2';
        case 29:
            return '3';
        case 30:
            return '4';
        case 31:
            return '5';
        case 32:
            return '6';
        case 33:
            return '7';
        case 34:
            return '8';
        case 35:
            return '9';
        case 36:
            return '0';
        case 37:
            return '!';
        case 38:
            return '@';
        case 39:
            return '#';
        case 40:
            return '$';
        case 41:
            return '(';
        case 42:
            return ')';
        case 44:
            return '-';
        case 46:
            return '+';
        case 47:
            return '&';
        case 48:
            return '=';
        case 49:
            return ';';
        case 50:
            return ':';
        case 52:
            return '\'';
        case 53:
            return '"';
        case 54:
            return '%';
        case 55:
            return ',';
        case 56:
            return '.';
        case 59:
            return '/';
        case 60:
            return '?';
        case 62:
            return "\xb0";
        case 63:
            return '`R';
        case 64:
            return '`O';
        case 65:
            return '`Y';
        case 66:
            return '`G';
        case 67:
            return '`B';
        case 68:
            return '`V';
        case 69:
            return '`W';
        default:
            return '?';
    }
}



parcelRequire("acw62");


const $fd2136e34b3773d6$export$6ed2eaa6b6429d44 = ({ label: label, value: value })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).cyan,
                    textAlign: 'center',
                    textTransform: 'uppercase'
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    textAlign: 'center',
                    fontSize: '2em'
                },
                children: value
            })
        ]
    });
};


const $d2ec6c8a31991a5b$export$94d79dfc96f95537 = ()=>{
    const { vbData: vbData } = (0, $18d60b1761851bb0$export$ecebce6c3cc8ca46)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        sx: {
            maxWidth: 800,
            margin: '20px auto'
        },
        children: (0, $f1q41.map)(vbData, (val, key)=>{
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                xs: 6,
                sx: {
                    padding: '10px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd2136e34b3773d6$export$6ed2eaa6b6429d44), {
                    label: key,
                    value: val
                })
            });
        })
    });
};



parcelRequire("acw62");

var $3QqPt = parcelRequire("3QqPt");



var $3QqPt = parcelRequire("3QqPt");

var $9c7Du = parcelRequire("9c7Du");

var $9f51a89cd36da6dd$exports = {};
var $0b2d21aee1d97729$exports = {};
var $1389b3710f5da9e8$exports = {};
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $1389b3710f5da9e8$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
$1389b3710f5da9e8$exports = $1389b3710f5da9e8$var$arrayReduce;


var $ed80fa8833e2b532$exports = {};
var $3384256242a1b577$exports = {};
var $dcb2a7eb44d37cba$exports = {};
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $dcb2a7eb44d37cba$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
$dcb2a7eb44d37cba$exports = $dcb2a7eb44d37cba$var$basePropertyOf;


/** Used to map Latin Unicode letters to basic Latin letters. */ var $3384256242a1b577$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $3384256242a1b577$var$deburrLetter = $dcb2a7eb44d37cba$exports($3384256242a1b577$var$deburredLetters);
$3384256242a1b577$exports = $3384256242a1b577$var$deburrLetter;


var $f5d9385a9cc7e413$exports = {};
var $f16f644742c27c21$exports = {};
var $3ba72ebe7e4419b5$exports = {};
var $180b2bc3c0deaf6c$exports = {};
var $f84e62f9db5b9ccd$exports = {};
/** Detect free variable `global` from Node.js. */ var $f84e62f9db5b9ccd$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$f84e62f9db5b9ccd$exports = $f84e62f9db5b9ccd$var$freeGlobal;


/** Detect free variable `self`. */ var $180b2bc3c0deaf6c$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $180b2bc3c0deaf6c$var$root = $f84e62f9db5b9ccd$exports || $180b2bc3c0deaf6c$var$freeSelf || Function('return this')();
$180b2bc3c0deaf6c$exports = $180b2bc3c0deaf6c$var$root;


/** Built-in value references. */ var $3ba72ebe7e4419b5$var$Symbol = $180b2bc3c0deaf6c$exports.Symbol;
$3ba72ebe7e4419b5$exports = $3ba72ebe7e4419b5$var$Symbol;


var $d26d80da1ba3948c$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $d26d80da1ba3948c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$d26d80da1ba3948c$exports = $d26d80da1ba3948c$var$arrayMap;


var $0488fde9aa355453$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0488fde9aa355453$var$isArray = Array.isArray;
$0488fde9aa355453$exports = $0488fde9aa355453$var$isArray;


var $6b5a5095e0934938$exports = {};
var $a7f8a2555793d7d3$exports = {};

var $dabe9ecbecc6d0b5$exports = {};

/** Used for built-in method references. */ var $dabe9ecbecc6d0b5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $dabe9ecbecc6d0b5$var$hasOwnProperty = $dabe9ecbecc6d0b5$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dabe9ecbecc6d0b5$var$nativeObjectToString = $dabe9ecbecc6d0b5$var$objectProto.toString;
/** Built-in value references. */ var $dabe9ecbecc6d0b5$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $dabe9ecbecc6d0b5$var$getRawTag(value) {
    var isOwn = $dabe9ecbecc6d0b5$var$hasOwnProperty.call(value, $dabe9ecbecc6d0b5$var$symToStringTag), tag = value[$dabe9ecbecc6d0b5$var$symToStringTag];
    try {
        value[$dabe9ecbecc6d0b5$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $dabe9ecbecc6d0b5$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$dabe9ecbecc6d0b5$var$symToStringTag] = tag;
        else delete value[$dabe9ecbecc6d0b5$var$symToStringTag];
    }
    return result;
}
$dabe9ecbecc6d0b5$exports = $dabe9ecbecc6d0b5$var$getRawTag;


var $3fce91ec3914aaed$exports = {};
/** Used for built-in method references. */ var $3fce91ec3914aaed$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3fce91ec3914aaed$var$nativeObjectToString = $3fce91ec3914aaed$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $3fce91ec3914aaed$var$objectToString(value) {
    return $3fce91ec3914aaed$var$nativeObjectToString.call(value);
}
$3fce91ec3914aaed$exports = $3fce91ec3914aaed$var$objectToString;


/** `Object#toString` result references. */ var $a7f8a2555793d7d3$var$nullTag = '[object Null]', $a7f8a2555793d7d3$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $a7f8a2555793d7d3$var$symToStringTag = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $a7f8a2555793d7d3$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $a7f8a2555793d7d3$var$undefinedTag : $a7f8a2555793d7d3$var$nullTag;
    return $a7f8a2555793d7d3$var$symToStringTag && $a7f8a2555793d7d3$var$symToStringTag in Object(value) ? $dabe9ecbecc6d0b5$exports(value) : $3fce91ec3914aaed$exports(value);
}
$a7f8a2555793d7d3$exports = $a7f8a2555793d7d3$var$baseGetTag;


var $61269cf1f3e020be$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61269cf1f3e020be$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$61269cf1f3e020be$exports = $61269cf1f3e020be$var$isObjectLike;


/** `Object#toString` result references. */ var $6b5a5095e0934938$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $6b5a5095e0934938$var$isSymbol(value) {
    return typeof value == 'symbol' || $61269cf1f3e020be$exports(value) && $a7f8a2555793d7d3$exports(value) == $6b5a5095e0934938$var$symbolTag;
}
$6b5a5095e0934938$exports = $6b5a5095e0934938$var$isSymbol;


/** Used as references for various `Number` constants. */ var $f16f644742c27c21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $f16f644742c27c21$var$symbolProto = $3ba72ebe7e4419b5$exports ? $3ba72ebe7e4419b5$exports.prototype : undefined, $f16f644742c27c21$var$symbolToString = $f16f644742c27c21$var$symbolProto ? $f16f644742c27c21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $f16f644742c27c21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ($0488fde9aa355453$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $d26d80da1ba3948c$exports(value, $f16f644742c27c21$var$baseToString) + '';
    if ($6b5a5095e0934938$exports(value)) return $f16f644742c27c21$var$symbolToString ? $f16f644742c27c21$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$f16f644742c27c21$var$INFINITY ? '-0' : result;
}
$f16f644742c27c21$exports = $f16f644742c27c21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $f5d9385a9cc7e413$var$toString(value) {
    return value == null ? '' : $f16f644742c27c21$exports(value);
}
$f5d9385a9cc7e413$exports = $f5d9385a9cc7e413$var$toString;


/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ed80fa8833e2b532$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ed80fa8833e2b532$var$rsComboMarksRange = '\\u0300-\\u036f', $ed80fa8833e2b532$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ed80fa8833e2b532$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ed80fa8833e2b532$var$rsComboRange = $ed80fa8833e2b532$var$rsComboMarksRange + $ed80fa8833e2b532$var$reComboHalfMarksRange + $ed80fa8833e2b532$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ed80fa8833e2b532$var$rsCombo = '[' + $ed80fa8833e2b532$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ed80fa8833e2b532$var$reComboMark = RegExp($ed80fa8833e2b532$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ed80fa8833e2b532$var$deburr(string) {
    string = $f5d9385a9cc7e413$exports(string);
    return string && string.replace($ed80fa8833e2b532$var$reLatin, $3384256242a1b577$exports).replace($ed80fa8833e2b532$var$reComboMark, '');
}
$ed80fa8833e2b532$exports = $ed80fa8833e2b532$var$deburr;


var $12f2ccb7e11b3895$exports = {};
var $7e165cbd28a9af51$exports = {};
/** Used to match words composed of alphanumeric characters. */ var $7e165cbd28a9af51$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $7e165cbd28a9af51$var$asciiWords(string) {
    return string.match($7e165cbd28a9af51$var$reAsciiWord) || [];
}
$7e165cbd28a9af51$exports = $7e165cbd28a9af51$var$asciiWords;


var $8688e0b23f5a081b$exports = {};
/** Used to detect strings that need a more robust regexp to match words. */ var $8688e0b23f5a081b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $8688e0b23f5a081b$var$hasUnicodeWord(string) {
    return $8688e0b23f5a081b$var$reHasUnicodeWord.test(string);
}
$8688e0b23f5a081b$exports = $8688e0b23f5a081b$var$hasUnicodeWord;



var $325a565efdffbc96$exports = {};
/** Used to compose unicode character classes. */ var $325a565efdffbc96$var$rsAstralRange = '\\ud800-\\udfff', $325a565efdffbc96$var$rsComboMarksRange = '\\u0300-\\u036f', $325a565efdffbc96$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $325a565efdffbc96$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $325a565efdffbc96$var$rsComboRange = $325a565efdffbc96$var$rsComboMarksRange + $325a565efdffbc96$var$reComboHalfMarksRange + $325a565efdffbc96$var$rsComboSymbolsRange, $325a565efdffbc96$var$rsDingbatRange = '\\u2700-\\u27bf', $325a565efdffbc96$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $325a565efdffbc96$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $325a565efdffbc96$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $325a565efdffbc96$var$rsPunctuationRange = '\\u2000-\\u206f', $325a565efdffbc96$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $325a565efdffbc96$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $325a565efdffbc96$var$rsVarRange = '\\ufe0e\\ufe0f', $325a565efdffbc96$var$rsBreakRange = $325a565efdffbc96$var$rsMathOpRange + $325a565efdffbc96$var$rsNonCharRange + $325a565efdffbc96$var$rsPunctuationRange + $325a565efdffbc96$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $325a565efdffbc96$var$rsApos = "['\u2019]", $325a565efdffbc96$var$rsBreak = '[' + $325a565efdffbc96$var$rsBreakRange + ']', $325a565efdffbc96$var$rsCombo = '[' + $325a565efdffbc96$var$rsComboRange + ']', $325a565efdffbc96$var$rsDigits = '\\d+', $325a565efdffbc96$var$rsDingbat = '[' + $325a565efdffbc96$var$rsDingbatRange + ']', $325a565efdffbc96$var$rsLower = '[' + $325a565efdffbc96$var$rsLowerRange + ']', $325a565efdffbc96$var$rsMisc = '[^' + $325a565efdffbc96$var$rsAstralRange + $325a565efdffbc96$var$rsBreakRange + $325a565efdffbc96$var$rsDigits + $325a565efdffbc96$var$rsDingbatRange + $325a565efdffbc96$var$rsLowerRange + $325a565efdffbc96$var$rsUpperRange + ']', $325a565efdffbc96$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $325a565efdffbc96$var$rsModifier = '(?:' + $325a565efdffbc96$var$rsCombo + '|' + $325a565efdffbc96$var$rsFitz + ')', $325a565efdffbc96$var$rsNonAstral = '[^' + $325a565efdffbc96$var$rsAstralRange + ']', $325a565efdffbc96$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $325a565efdffbc96$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $325a565efdffbc96$var$rsUpper = '[' + $325a565efdffbc96$var$rsUpperRange + ']', $325a565efdffbc96$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $325a565efdffbc96$var$rsMiscLower = '(?:' + $325a565efdffbc96$var$rsLower + '|' + $325a565efdffbc96$var$rsMisc + ')', $325a565efdffbc96$var$rsMiscUpper = '(?:' + $325a565efdffbc96$var$rsUpper + '|' + $325a565efdffbc96$var$rsMisc + ')', $325a565efdffbc96$var$rsOptContrLower = '(?:' + $325a565efdffbc96$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $325a565efdffbc96$var$rsOptContrUpper = '(?:' + $325a565efdffbc96$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $325a565efdffbc96$var$reOptMod = $325a565efdffbc96$var$rsModifier + '?', $325a565efdffbc96$var$rsOptVar = '[' + $325a565efdffbc96$var$rsVarRange + ']?', $325a565efdffbc96$var$rsOptJoin = '(?:' + $325a565efdffbc96$var$rsZWJ + '(?:' + [
    $325a565efdffbc96$var$rsNonAstral,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join('|') + ')' + $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + ')*', $325a565efdffbc96$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $325a565efdffbc96$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $325a565efdffbc96$var$rsSeq = $325a565efdffbc96$var$rsOptVar + $325a565efdffbc96$var$reOptMod + $325a565efdffbc96$var$rsOptJoin, $325a565efdffbc96$var$rsEmoji = '(?:' + [
    $325a565efdffbc96$var$rsDingbat,
    $325a565efdffbc96$var$rsRegional,
    $325a565efdffbc96$var$rsSurrPair
].join('|') + ')' + $325a565efdffbc96$var$rsSeq;
/** Used to match complex or compound words. */ var $325a565efdffbc96$var$reUnicodeWord = RegExp([
    $325a565efdffbc96$var$rsUpper + '?' + $325a565efdffbc96$var$rsLower + '+' + $325a565efdffbc96$var$rsOptContrLower + '(?=' + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper,
        '$'
    ].join('|') + ')',
    $325a565efdffbc96$var$rsMiscUpper + '+' + $325a565efdffbc96$var$rsOptContrUpper + '(?=' + [
        $325a565efdffbc96$var$rsBreak,
        $325a565efdffbc96$var$rsUpper + $325a565efdffbc96$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $325a565efdffbc96$var$rsUpper + '?' + $325a565efdffbc96$var$rsMiscLower + '+' + $325a565efdffbc96$var$rsOptContrLower,
    $325a565efdffbc96$var$rsUpper + '+' + $325a565efdffbc96$var$rsOptContrUpper,
    $325a565efdffbc96$var$rsOrdUpper,
    $325a565efdffbc96$var$rsOrdLower,
    $325a565efdffbc96$var$rsDigits,
    $325a565efdffbc96$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $325a565efdffbc96$var$unicodeWords(string) {
    return string.match($325a565efdffbc96$var$reUnicodeWord) || [];
}
$325a565efdffbc96$exports = $325a565efdffbc96$var$unicodeWords;


/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $12f2ccb7e11b3895$var$words(string, pattern, guard) {
    string = $f5d9385a9cc7e413$exports(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $8688e0b23f5a081b$exports(string) ? $325a565efdffbc96$exports(string) : $7e165cbd28a9af51$exports(string);
    return string.match(pattern) || [];
}
$12f2ccb7e11b3895$exports = $12f2ccb7e11b3895$var$words;


/** Used to compose unicode capture groups. */ var $0b2d21aee1d97729$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $0b2d21aee1d97729$var$reApos = RegExp($0b2d21aee1d97729$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $0b2d21aee1d97729$var$createCompounder(callback) {
    return function(string) {
        return $1389b3710f5da9e8$exports($12f2ccb7e11b3895$exports($ed80fa8833e2b532$exports(string).replace($0b2d21aee1d97729$var$reApos, '')), callback, '');
    };
}
$0b2d21aee1d97729$exports = $0b2d21aee1d97729$var$createCompounder;


var $da6130e1e4702e32$exports = {};
var $0d9811a54a2f955a$exports = {};
var $cfe77c1a7b7c7d6e$exports = {};
var $109fb88fe59de104$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $109fb88fe59de104$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$109fb88fe59de104$exports = $109fb88fe59de104$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $cfe77c1a7b7c7d6e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $109fb88fe59de104$exports(array, start, end);
}
$cfe77c1a7b7c7d6e$exports = $cfe77c1a7b7c7d6e$var$castSlice;


var $00fdf7eab00be2e7$exports = {};
/** Used to compose unicode character classes. */ var $00fdf7eab00be2e7$var$rsAstralRange = '\\ud800-\\udfff', $00fdf7eab00be2e7$var$rsComboMarksRange = '\\u0300-\\u036f', $00fdf7eab00be2e7$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $00fdf7eab00be2e7$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $00fdf7eab00be2e7$var$rsComboRange = $00fdf7eab00be2e7$var$rsComboMarksRange + $00fdf7eab00be2e7$var$reComboHalfMarksRange + $00fdf7eab00be2e7$var$rsComboSymbolsRange, $00fdf7eab00be2e7$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $00fdf7eab00be2e7$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $00fdf7eab00be2e7$var$reHasUnicode = RegExp('[' + $00fdf7eab00be2e7$var$rsZWJ + $00fdf7eab00be2e7$var$rsAstralRange + $00fdf7eab00be2e7$var$rsComboRange + $00fdf7eab00be2e7$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $00fdf7eab00be2e7$var$hasUnicode(string) {
    return $00fdf7eab00be2e7$var$reHasUnicode.test(string);
}
$00fdf7eab00be2e7$exports = $00fdf7eab00be2e7$var$hasUnicode;


var $9a986c87d425808c$exports = {};
var $43b96a6d93895c83$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $43b96a6d93895c83$var$asciiToArray(string) {
    return string.split('');
}
$43b96a6d93895c83$exports = $43b96a6d93895c83$var$asciiToArray;



var $c3bf9ebcb1b53b1d$exports = {};
/** Used to compose unicode character classes. */ var $c3bf9ebcb1b53b1d$var$rsAstralRange = '\\ud800-\\udfff', $c3bf9ebcb1b53b1d$var$rsComboMarksRange = '\\u0300-\\u036f', $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $c3bf9ebcb1b53b1d$var$rsComboRange = $c3bf9ebcb1b53b1d$var$rsComboMarksRange + $c3bf9ebcb1b53b1d$var$reComboHalfMarksRange + $c3bf9ebcb1b53b1d$var$rsComboSymbolsRange, $c3bf9ebcb1b53b1d$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $c3bf9ebcb1b53b1d$var$rsAstral = '[' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsCombo = '[' + $c3bf9ebcb1b53b1d$var$rsComboRange + ']', $c3bf9ebcb1b53b1d$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $c3bf9ebcb1b53b1d$var$rsModifier = '(?:' + $c3bf9ebcb1b53b1d$var$rsCombo + '|' + $c3bf9ebcb1b53b1d$var$rsFitz + ')', $c3bf9ebcb1b53b1d$var$rsNonAstral = '[^' + $c3bf9ebcb1b53b1d$var$rsAstralRange + ']', $c3bf9ebcb1b53b1d$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $c3bf9ebcb1b53b1d$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $c3bf9ebcb1b53b1d$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $c3bf9ebcb1b53b1d$var$reOptMod = $c3bf9ebcb1b53b1d$var$rsModifier + '?', $c3bf9ebcb1b53b1d$var$rsOptVar = '[' + $c3bf9ebcb1b53b1d$var$rsVarRange + ']?', $c3bf9ebcb1b53b1d$var$rsOptJoin = '(?:' + $c3bf9ebcb1b53b1d$var$rsZWJ + '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair
].join('|') + ')' + $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + ')*', $c3bf9ebcb1b53b1d$var$rsSeq = $c3bf9ebcb1b53b1d$var$rsOptVar + $c3bf9ebcb1b53b1d$var$reOptMod + $c3bf9ebcb1b53b1d$var$rsOptJoin, $c3bf9ebcb1b53b1d$var$rsSymbol = '(?:' + [
    $c3bf9ebcb1b53b1d$var$rsNonAstral + $c3bf9ebcb1b53b1d$var$rsCombo + '?',
    $c3bf9ebcb1b53b1d$var$rsCombo,
    $c3bf9ebcb1b53b1d$var$rsRegional,
    $c3bf9ebcb1b53b1d$var$rsSurrPair,
    $c3bf9ebcb1b53b1d$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $c3bf9ebcb1b53b1d$var$reUnicode = RegExp($c3bf9ebcb1b53b1d$var$rsFitz + '(?=' + $c3bf9ebcb1b53b1d$var$rsFitz + ')|' + $c3bf9ebcb1b53b1d$var$rsSymbol + $c3bf9ebcb1b53b1d$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $c3bf9ebcb1b53b1d$var$unicodeToArray(string) {
    return string.match($c3bf9ebcb1b53b1d$var$reUnicode) || [];
}
$c3bf9ebcb1b53b1d$exports = $c3bf9ebcb1b53b1d$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $9a986c87d425808c$var$stringToArray(string) {
    return $00fdf7eab00be2e7$exports(string) ? $c3bf9ebcb1b53b1d$exports(string) : $43b96a6d93895c83$exports(string);
}
$9a986c87d425808c$exports = $9a986c87d425808c$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $0d9811a54a2f955a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $f5d9385a9cc7e413$exports(string);
        var strSymbols = $00fdf7eab00be2e7$exports(string) ? $9a986c87d425808c$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $cfe77c1a7b7c7d6e$exports(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$0d9811a54a2f955a$exports = $0d9811a54a2f955a$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $da6130e1e4702e32$var$upperFirst = $0d9811a54a2f955a$exports('toUpperCase');
$da6130e1e4702e32$exports = $da6130e1e4702e32$var$upperFirst;


/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */ var $9f51a89cd36da6dd$var$startCase = $0b2d21aee1d97729$exports(function(result, word, index) {
    return result + (index ? ' ' : '') + $da6130e1e4702e32$exports(word);
});
$9f51a89cd36da6dd$exports = $9f51a89cd36da6dd$var$startCase;



var $acw62 = parcelRequire("acw62");




const $fb4da9fc46b812f6$var$mapRows = (row)=>{
    return {
        ...row,
        cqeStatus: $fb4da9fc46b812f6$var$getCQEStatus(row.cqeStatus),
        createdAt: new Date(row.createdAt * 1000).toLocaleDateString()
    };
};
const $fb4da9fc46b812f6$var$getCQEStatus = (status)=>{
    const cqeStatusString = (0, (/*@__PURE__*/$parcel$interopDefault($9f51a89cd36da6dd$exports)))((0, $90fb957545aae5a4$export$5afee16442bde5ee)((0, $3QqPt.QualificationTier), status).toLowerCase());
    switch(status){
        case 2:
        case 3:
        case 4:
            return 'Auto Approved';
        default:
            return cqeStatusString;
    }
};
function $fb4da9fc46b812f6$export$ac13392f72023d92() {
    const { clientId: clientId } = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const [{ page: page, rowsPerPage: rowsPerPage, search: search, cqeStatus: cqeStatus, state: state, blankNames: blankNames }, setQueryParams] = (0, $9963aa6f9102c92d$export$b37ee0d76c6d2fbc)({
        search: (0, $edbc22aa0be45f44$export$cc4e5467ec2866fa),
        page: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 0),
        rowsPerPage: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 25),
        cqeStatus: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), undefined),
        state: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), undefined),
        blankNames: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$3117e3aa90640455), false)
    });
    const setPaginationModel = (newPaginationModel)=>{
        setQueryParams({
            page: newPaginationModel.page,
            rowsPerPage: newPaginationModel.pageSize
        });
    };
    const setQuery = (evt)=>{
        setQueryParams({
            search: evt.target.value
        });
    };
    const setCQEStatus = (newCQEStatus)=>{
        setQueryParams({
            cqeStatus: newCQEStatus
        });
    };
    const setState = (newState)=>{
        setQueryParams({
            state: newState
        });
    };
    const setBlankNames = (newValue)=>{
        setQueryParams({
            blankNames: newValue
        });
    };
    const isFetching = (0, $4f8e348a4679462a$export$625b2ff71316bcd3)();
    const { data: customers } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/customers',
            {
                page: page,
                rowsPerPage: rowsPerPage,
                search: search,
                cqeStatus: cqeStatus,
                state: state,
                blankNames: blankNames,
                clientId: clientId
            }
        ],
        queryFn: async ()=>{
            const query = [];
            if (search) query.push({
                property: 'search',
                value: search,
                modifier: (0, $9c7Du.Modifier).EQUAL_TO
            });
            if (cqeStatus) query.push({
                property: 'cqeStatus',
                value: `${cqeStatus}`,
                modifier: (0, $9c7Du.Modifier).EQUAL_TO
            });
            if (clientId) query.push({
                property: 'clientId',
                value: clientId,
                modifier: (0, $9c7Du.Modifier).EQUAL_TO
            });
            if (blankNames) query.push({
                property: 'blankNames',
                // modifier: Modifier.CONTAINS,
                modifier: 13,
                value: blankNames.toString()
            });
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).ListCustomers({
                searchParam: {
                    pagination: {
                        limit: rowsPerPage,
                        offset: page * rowsPerPage
                    },
                    query: query,
                    order: [
                        {
                            property: 'updated_at',
                            direction: 1
                        }
                    ]
                }
            }).then((res)=>{
                return {
                    total: res.total,
                    customers: res.dataList.map($fb4da9fc46b812f6$var$mapRows)
                };
            });
        },
        placeholderData: (previousData)=>previousData,
        enabled: !!clientId
    });
    return {
        total: customers?.total || 0,
        page: page,
        rowsPerPage: rowsPerPage,
        setPaginationModel: setPaginationModel,
        customers: customers?.customers || [],
        setQuery: setQuery,
        setCQEStatus: setCQEStatus,
        search: search,
        cqeStatus: cqeStatus,
        setBlankNames: setBlankNames,
        state: state,
        setState: setState,
        isLoading: isFetching > 0
    };
}






const $a1f62b3b3c756a85$var$qualificationTier = (0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $3QqPt.QualificationTier));
const $a1f62b3b3c756a85$export$56e258bc8091b7e5 = ()=>{
    const { customers: customers, total: total, page: page, rowsPerPage: rowsPerPage, setPaginationModel: setPaginationModel, isLoading: isLoading, setQuery: setQuery, search: search, setCQEStatus: setCQEStatus, setBlankNames: setBlankNames } = (0, $fb4da9fc46b812f6$export$ac13392f72023d92)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const columns = [
        {
            field: 'customerName',
            headerName: 'Customer Name',
            cellClassName: 'primaryAccent',
            flex: 0.75,
            renderCell: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: 'bold',
                        color: themeColors.buttonColor,
                        '&:hover': {
                            color: themeColors.buttonHover
                        }
                    },
                    href: `/customers/${props.row.id}`,
                    children: props.row.customerName?.trim() ? props.row.customerName : '{blank}'
                })
        },
        {
            field: 'accountNumber',
            headerName: 'Account Number',
            flex: 0.4
        },
        {
            field: 'cqeStatus',
            headerName: 'CQE Status',
            flex: 0.75
        },
        {
            field: 'createdAt',
            headerName: 'Creation Date',
            flex: 0.5
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            backgroundColor: 'background.default',
            p: 3
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    marginLeft: '5px'
                },
                variant: "h1",
                children: "Customers"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            flexDirection: 'row'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bca7e63d5d08434$export$b373baffdd40f8d5), {
                                label: "id, customer name, account number...",
                                setQuery: setQuery,
                                search: search
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db86fcacc6287e65$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '50%',
                                    paddingRight: '10px',
                                    marginTop: '-8px'
                                },
                                disableClearable: true,
                                options: [
                                    {
                                        id: undefined,
                                        description: 'All'
                                    },
                                    {
                                        id: 0,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.QUALIFICATION_PENDING.label
                                    },
                                    {
                                        id: 1,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.DISQUALIFIED.label
                                    },
                                    {
                                        id: 2,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.TIER_1.label
                                    },
                                    {
                                        id: 3,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.TIER_2.label
                                    },
                                    {
                                        id: 4,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.TIER_3.label
                                    },
                                    {
                                        id: 5,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.THIN_FILE.label
                                    },
                                    {
                                        id: 6,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.BORDERLINE_FICO.label
                                    },
                                    {
                                        id: 7,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.NO_HIT.label
                                    },
                                    {
                                        id: 8,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.LIQUIDITY_GENERIC.label
                                    },
                                    {
                                        id: 10,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.ERROR.label
                                    },
                                    {
                                        id: 11,
                                        description: $a1f62b3b3c756a85$var$qualificationTier.NEEDS_REVIEW.label
                                    }
                                ],
                                //@ts-ignore
                                getOptionLabel: (option)=>option.description,
                                renderInput: (inputProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                        ...inputProps,
                                        label: "CQE Status ",
                                        margin: "normal",
                                        variant: "outlined"
                                    }),
                                onChange: (e, value)=>setCQEStatus(value.id)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c16f3270115bea$export$2e2bcd8739ae039), {
                                sx: {
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
                                    sx: {
                                        fontSize: '14px',
                                        width: '140px'
                                    },
                                    control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3ef6305be93c7af$export$2e2bcd8739ae039), {
                                        color: "primary",
                                        onChange: (e)=>setBlankNames(e.target.checked)
                                    }),
                                    label: "Blank Names"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                        columns: columns,
                        rows: customers,
                        rowCount: total,
                        autoHeight: true,
                        loading: isLoading,
                        paginationMode: "server",
                        pageSizeOptions: [
                            25,
                            50,
                            100
                        ],
                        paginationModel: {
                            page: page,
                            pageSize: rowsPerPage
                        },
                        onPaginationModelChange: (newPaginationModel)=>setPaginationModel(newPaginationModel)
                    })
                ]
            })
        ]
    });
};


/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ 

var $acw62 = parcelRequire("acw62");



/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */ 
parcelRequire("acw62");
const $5dbd7ef26ebbcc73$var$Loading = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
        id: "loading-icon",
        children: "Loading..."
    });
};
var $5dbd7ef26ebbcc73$export$2e2bcd8739ae039 = $5dbd7ef26ebbcc73$var$Loading;


const $a3e5af206e1ac05b$export$2885ecfb6342598b = ()=>{
    const { oktaAuth: oktaAuth, authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    (0, $acw62.useEffect)(()=>{
        if (!authState) return;
        if (!authState?.isAuthenticated) {
            const originalUri = (0, $83e7c3a0ba92185e$export$4ebdca5513a016fe)(window.location.href, window.location.origin);
            oktaAuth.setOriginalUri(originalUri);
            oktaAuth.signInWithRedirect();
        }
    }, [
        oktaAuth,
        !!authState,
        authState?.isAuthenticated
    ]);
    if (!authState || !authState?.isAuthenticated) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dbd7ef26ebbcc73$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$910ae8079b2c2852), {});
};



parcelRequire("acw62");




var $f1q41 = parcelRequire("f1q41");



var $acw62 = parcelRequire("acw62");

function $03e40bd3dfd5d42f$export$fbd4050d970d4fff() {
    const { clientId: clientId } = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const [{ page: page, rowsPerPage: rowsPerPage, search: search, programId: programId }, setQueryParams] = (0, $9963aa6f9102c92d$export$b37ee0d76c6d2fbc)({
        search: (0, $edbc22aa0be45f44$export$cc4e5467ec2866fa),
        page: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 0),
        rowsPerPage: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 100),
        programId: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$cc4e5467ec2866fa), 'all')
    });
    // note: we should useQuery here later on when we move to NexusService?
    const setPaginationModel = (newPaginationModel)=>{
        setQueryParams({
            page: newPaginationModel.page,
            rowsPerPage: newPaginationModel.pageSize
        });
    };
    const setQuery = (evt)=>{
        setQueryParams({
            search: evt.target.value
        });
    };
    const setProgram = (newProgramId)=>{
        setQueryParams({
            programId: newProgramId ? newProgramId : 'all'
        });
    };
    const isFetching = (0, $4f8e348a4679462a$export$625b2ff71316bcd3)();
    const { data: programs } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/listPrograms',
            clientId
        ],
        queryFn: ()=>{
            return (0, $f647fd23fa4d1073$export$16d7a02b7436f06e).listPrograms(clientId);
        },
        initialData: {
            programsList: []
        },
        enabled: !!clientId
    });
    const { data: reservations } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/reservations',
            {
                search: search,
                page: page,
                rowsPerPage: rowsPerPage,
                programId: programId,
                clientId: clientId
            }
        ],
        queryFn: async ()=>{
            const res = await (0, $f647fd23fa4d1073$export$16d7a02b7436f06e).getReservations({
                // calculate the index of the last item on the requested page
                pageState: (rowsPerPage * page).toString(10),
                pageSize: rowsPerPage,
                programId: programId,
                query: search,
                clientId: clientId
            });
            return {
                total: res.total,
                reservations: $03e40bd3dfd5d42f$var$createReservationRows(res.reservationsList)
            };
        },
        placeholderData: (previousData)=>previousData
    });
    return {
        total: reservations?.total || 0,
        page: page,
        setPaginationModel: setPaginationModel,
        rowsPerPage: rowsPerPage,
        reservations: reservations?.reservations || [],
        setQuery: setQuery,
        setProgram: setProgram,
        search: search,
        programs: programs || {
            programsList: []
        },
        programId: programId,
        isLoading: isFetching > 0
    };
}
function $03e40bd3dfd5d42f$var$createReservationRows(reservations) {
    return (0, $f1q41.map)(reservations, (reservation)=>{
        const customerName = `${reservation?.firstName} ${reservation?.lastName}`;
        const customerId = `${reservation?.customerId}`;
        return {
            id: reservation.reservationId,
            accountNumber: reservation.accountNumber,
            customerId: customerId,
            customerName: customerName,
            make: reservation.make,
            model: reservation.model,
            isPending: false,
            status: reservation.status,
            reservationId: reservation.reservationId,
            subscriptionId: reservation.customerId,
            waitlistStart: reservation.waitlistStart,
            color: reservation.color || 'N/A',
            zipcode: reservation.postal
        };
    });
}





const $fd6332adf46d8500$export$565ca80fd56969d7 = ()=>{
    const isDesktop = (0, $4256528f2d3b21ab$export$2e2bcd8739ae039)('(min-width:1400px)');
    const { reservations: reservations, total: total, page: page, rowsPerPage: rowsPerPage, setPaginationModel: setPaginationModel, isLoading: isLoading, setQuery: setQuery, programs: programs, search: search, setProgram: setProgram } = (0, $03e40bd3dfd5d42f$export$fbd4050d970d4fff)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const columns = [
        {
            field: 'customerName',
            headerName: 'Customer Name',
            cellClassName: 'primaryAccent',
            flex: 1,
            renderCell: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                    sx: {
                        fontWeight: 'bold',
                        color: themeColors.buttonColor,
                        '&:hover': {
                            color: themeColors.buttonHover
                        }
                    },
                    href: `/customers/${props.row.customerId}`,
                    children: props?.row?.customerName?.trim() ? props?.row?.customerName : '{blank}'
                })
        },
        {
            field: 'accountNumber',
            headerName: 'Account Number',
            flex: 0.75
        },
        {
            field: 'make',
            headerName: 'Make',
            flex: 0.5
        },
        {
            field: 'model',
            headerName: 'Model',
            flex: 0.5
        },
        {
            field: 'waitlistStart',
            headerName: 'Start Date',
            flex: 0.75
        },
        {
            field: 'color',
            headerName: 'Color Preferences',
            flex: 0.75
        },
        {
            field: 'zipcode',
            headerName: 'ZIP Code',
            flex: 0.5
        },
        {
            field: 'status',
            headerName: 'Reservation Status',
            flex: 1
        },
        {
            field: 'vehicleDetail',
            headerName: '',
            flex: 1,
            renderCell: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                    href: `/reservations/${props.row.reservationId}`,
                    sx: {
                        fontWeight: 'bold',
                        color: themeColors.buttonColor,
                        '&:hover': {
                            color: themeColors.buttonHover
                        },
                        textDecoration: 'none'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        sx: {
                            backgroundColor: themeColors.buttonColor,
                            color: currentTheme === 'galpin' ? 'black' : 'white',
                            '&:hover': {
                                backgroundColor: themeColors.buttonHover
                            }
                        },
                        variant: "contained",
                        children: isDesktop ? 'View Reservation' : 'View'
                    })
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            backgroundColor: 'background.default',
            p: 3
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    marginLeft: '5px'
                },
                variant: "h1",
                children: "Reservations"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            flexDirection: 'row'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bca7e63d5d08434$export$b373baffdd40f8d5), {
                                label: "Search by account number",
                                setQuery: setQuery,
                                search: search
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $db86fcacc6287e65$export$2e2bcd8739ae039), {
                                sx: {
                                    width: '100%',
                                    paddingRight: '10px',
                                    marginTop: '-8px'
                                },
                                disableClearable: true,
                                options: [
                                    {
                                        id: undefined,
                                        description: 'All Programs'
                                    },
                                    ...Array.isArray(programs?.programsList) ? programs.programsList : []
                                ],
                                getOptionLabel: (option)=>option.description,
                                renderInput: (inputProps)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                        ...inputProps,
                                        label: "All Programs",
                                        margin: "normal",
                                        variant: "outlined"
                                    }),
                                onChange: (e, value)=>setProgram(value.id)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                        columns: columns,
                        rows: reservations,
                        rowCount: total,
                        paginationModel: {
                            page: page,
                            pageSize: rowsPerPage
                        },
                        autoHeight: true,
                        loading: isLoading,
                        paginationMode: "server",
                        onPaginationModelChange: (newPaginationModel)=>setPaginationModel(newPaginationModel)
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");


parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");



// stubs

var $fcTGK = parcelRequire("fcTGK");
const $646901577e3d2d5c$export$642cf55f906ae4f0 = [
    {
        dayOfWeek: (0, $fcTGK.AvailableTime).DayOfWeek.MONDAY,
        startTime: '09:00',
        endTime: '17:00',
        timezone: 'UTC'
    },
    {
        dayOfWeek: (0, $fcTGK.AvailableTime).DayOfWeek.TUESDAY,
        startTime: '09:00',
        endTime: '17:00',
        timezone: 'UTC'
    },
    {
        dayOfWeek: (0, $fcTGK.AvailableTime).DayOfWeek.WEDNESDAY,
        startTime: '09:00',
        endTime: '17:00',
        timezone: 'UTC'
    },
    {
        dayOfWeek: (0, $fcTGK.AvailableTime).DayOfWeek.THURSDAY,
        startTime: '09:00',
        endTime: '17:00',
        timezone: 'UTC'
    },
    {
        dayOfWeek: (0, $fcTGK.AvailableTime).DayOfWeek.FRIDAY,
        startTime: '09:00',
        endTime: '17:00',
        timezone: 'UTC'
    }
];
const $646901577e3d2d5c$export$24ea5600bdf4007e = {
    year: 2022,
    month: 7,
    datesList: [
        {
            description: 'I should not be visible',
            datetype: 'Autonomy Holiday A',
            datestring: '2021-06-18',
            dow: 4,
            month: 6,
            day: 18,
            year: 2022
        },
        {
            description: 'Autonomy Holiday B',
            datetype: 'Holiday',
            datestring: '2022-09-29',
            dow: 4,
            month: 6,
            day: 18,
            year: 2022
        },
        {
            description: 'Autonomy Holiday C',
            datetype: 'Holiday',
            datestring: '2022-10-29',
            dow: 4,
            month: 6,
            day: 19,
            year: 2022
        }
    ],
    timezone: 'UTC',
    dateformat: 'yyyy-MM-dd'
};
const $646901577e3d2d5c$export$f2be8a9d56352cdb = [
    {
        date: '2022-10-10',
        reason: 'Extreme weather'
    },
    {
        date: '2022-10-20',
        reason: 'Special reason'
    }
];
const $646901577e3d2d5c$export$f6ab7b6f5e096e80 = {
    closedDatesList: [],
    // deprecated
    closedDatesWithReasonsList: $646901577e3d2d5c$export$f2be8a9d56352cdb,
    dealershipId: 'b1d68de5-0f55-4470-9030-a5d3d7b3d84b',
    error: undefined,
    errorCode: undefined,
    success: true
};
const $646901577e3d2d5c$export$6ce52eac46c7ef46 = {
    calendar: $646901577e3d2d5c$export$24ea5600bdf4007e,
    error: undefined,
    errorCode: undefined,
    success: true
};
const $646901577e3d2d5c$export$b5ee73e5e513a038 = {
    success: true,
    dealershipId: 'b1d68de5-0f55-4470-9030-a5d3d7b3d84b',
    openDaysOfWeekList: $646901577e3d2d5c$export$642cf55f906ae4f0,
    error: undefined,
    errorCode: undefined
};



var $acw62 = parcelRequire("acw62");


var $1oiLe = parcelRequire("1oiLe");

const $2e5850e46a20c778$var$defaultOpeningHours = new Date(new Date().setHours(9, 0, 0, 0));
const $2e5850e46a20c778$var$defaultClosingHours = new Date(new Date().setHours(17, 0, 0, 0));
const $2e5850e46a20c778$export$a33394a36de8aebe = Object.values((0, $2fe0bab7a0e34f9c$export$afe72249c42899d9)((0, $1oiLe.OpenDayOfWeek)?.DayOfWeek)).filter((day)=>day.value !== 0).map((day)=>({
        index: day.value,
        dayOfWeek: day.label,
        startTime: (0, $303ba10db2c74ab4$export$d9468344d3651243)($2e5850e46a20c778$var$defaultOpeningHours, 'HH:mm'),
        endTime: (0, $303ba10db2c74ab4$export$d9468344d3651243)($2e5850e46a20c778$var$defaultClosingHours, 'HH:mm'),
        timezone: undefined
    }));
function $2e5850e46a20c778$export$ea0830439c7fc698(dayOfWeek, businessDays) {
    return businessDays.find((bd)=>bd.dayOfWeek === dayOfWeek) !== undefined;
}
function $2e5850e46a20c778$export$1428f42a7de81803(dayOfWeek, businessDays, time = 'startTime') {
    return $2e5850e46a20c778$export$ea0830439c7fc698(dayOfWeek, businessDays) ? businessDays.find((bd)=>bd.dayOfWeek === dayOfWeek)[time] : $2e5850e46a20c778$export$a33394a36de8aebe.find((fd)=>fd.dayOfWeek === dayOfWeek)[time];
}
const $2e5850e46a20c778$export$dd0ed304582c330a = (businessDays, setBusinessDays)=>{
    const [isOpenSameTimeEveryDay, setIsOpenSameTimeEveryDay] = (0, $acw62.useState)(true);
    const [startTime, setStartTime] = (0, $acw62.useState)((0, $303ba10db2c74ab4$export$d9468344d3651243)($2e5850e46a20c778$var$defaultOpeningHours, 'HH:mm'));
    const [endTime, setEndTime] = (0, $acw62.useState)((0, $303ba10db2c74ab4$export$d9468344d3651243)($2e5850e46a20c778$var$defaultClosingHours, 'HH:mm'));
    // the start and end ranges of possible opening hours. Random values, ask Product for preferred ranges
    const openingRangeStart = new Date(new Date().setHours(7, 0, 0, 0));
    const openingRangeEnd = new Date(new Date().setHours(11, 0, 0, 0));
    // the start and end ranges of possible closing hours. Random values, ask Product for preferred ranges
    const closingRangeStart = new Date(new Date().setHours(17, 0, 0, 0));
    const closingRangeEnd = new Date(new Date().setHours(21, 0, 0, 0));
    (0, $acw62.useEffect)(()=>{
        if (isOpenSameTimeEveryDay) setBusinessDays(businessDays.map((businessDay)=>{
            businessDay.startTime = startTime;
            businessDay.endTime = endTime;
            return businessDay;
        }));
    }, [
        isOpenSameTimeEveryDay
    ]);
    return {
        startTime: startTime,
        endTime: endTime,
        defaultOpeningHours: $2e5850e46a20c778$var$defaultOpeningHours,
        defaultClosingHours: $2e5850e46a20c778$var$defaultClosingHours,
        openingRangeStart: openingRangeStart,
        openingRangeEnd: openingRangeEnd,
        closingRangeStart: closingRangeStart,
        closingRangeEnd: closingRangeEnd,
        isOpenSameTimeEveryDay: isOpenSameTimeEveryDay,
        setIsOpenSameTimeEveryDay: setIsOpenSameTimeEveryDay,
        setStartTime: setStartTime,
        setEndTime: setEndTime
    };
};



function $08d791c1f17d4ad4$export$4fa67ba1352ae50f(dealership, setDealership) {
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const [isEditing, setIsEditing] = (0, $acw62.useState)(false);
    const { data: listDealerships } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/listDealerships'
        ],
        queryFn: async ()=>{
            const response = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listDealerships();
            return (0, $311229f5b11e8df8$export$118f6f303872ba1a)(response.dealersList);
        }
    });
    (0, $acw62.useEffect)(()=>{
        if (listDealerships && listDealerships.length) setDealership(listDealerships[0]);
    }, [
        listDealerships,
        setDealership
    ]);
    const { data: viewTeam } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/viewTeam',
            dealership?.id
        ],
        queryFn: async ()=>{
            const response = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).viewTeam(dealership.id);
            return (0, $311229f5b11e8df8$export$464270970e498347)(response.dealershipTeamList);
        },
        enabled: !!dealership
    });
    function handleCancellation() {
        queryClient.invalidateQueries({
            queryKey: [
                '/dealership',
                dealership.id
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                '/dealership',
                'businessDays'
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                '/dealership',
                'closedDays'
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                '/dealership',
                'holidays'
            ]
        });
        // ...invalidate all queries here
        setIsEditing(false);
    }
    function saveChanges() {
        const mutations = [
            mutateBusinessDays(),
            mutateClosedDates()
        ];
        // perform all mutations asynchronously
        return Promise.all(mutations).then(()=>{
            setIsEditing(!isEditing);
        });
    }
    function filterFutureHolidays(holidays) {
        const currentDate = Date.now();
        return holidays.filter((holiday)=>{
            return holiday.date.getTime() > currentDate;
        });
    }
    ////////////////////////////////////////////////
    ///////////////////// MOCK /////////////////////
    ////////////////////////////////////////////////
    // NOTE: For everything below here: endpoints not available yet in NexusService,
    // so are currently mocked with mockData.ts
    // @START MOCK BUSINESS DAYS BLOCK
    const { data: businessDays } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/dealership',
            'businessDays'
        ],
        queryFn: async ()=>{
            return handleBusinessDaysResponse((0, $646901577e3d2d5c$export$b5ee73e5e513a038).openDaysOfWeekList);
        },
        enabled: !!dealership,
        placeholderData: []
    });
    const { mutateAsync: mutateBusinessDays } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            // simulates an API PUT request that takes 1 second to complete
            return new Promise(function(resolve) {
                setTimeout(function() {
                    resolve();
                }, 1000);
            });
        }
    });
    function setBusinessDays(updatedBusinessDays) {
        queryClient.setQueryData([
            '/dealership',
            'businessDays'
        ], updatedBusinessDays);
    }
    function handleBusinessDaysResponse(businessDays) {
        return businessDays.map((day)=>({
                ...day,
                dayOfWeek: (0, $2e5850e46a20c778$export$a33394a36de8aebe).find((formattedDay)=>formattedDay.index === day.dayOfWeek).dayOfWeek
            }));
    }
    // @END MOCK BUSINESS DAYS BLOCK
    // @START MOCK HOLIDAYS DAYS BLOCK
    const { data: closedDates } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/dealership',
            'closedDates'
        ],
        queryFn: async ()=>{
            return handleClosedDatesResponse((0, $646901577e3d2d5c$export$f6ab7b6f5e096e80).closedDatesWithReasonsList);
        },
        enabled: !!dealership,
        initialData: []
    });
    const { data: holidays } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/dealership',
            'holidays'
        ],
        queryFn: async ()=>{
            return handleHolidaysResponse((0, $646901577e3d2d5c$export$6ce52eac46c7ef46).calendar);
        },
        enabled: !!dealership,
        initialData: []
    });
    const { mutateAsync: mutateClosedDates } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            // simulates an API PUT request that takes 1 second to complete
            return new Promise(function(resolve) {
                setTimeout(function() {
                    resolve();
                }, 1000);
            });
        }
    });
    function setClosedDates(updatedClosedDates) {
        queryClient.setQueryData([
            '/dealership',
            'closedDates'
        ], updatedClosedDates);
    }
    function setHolidays(holidays) {
        queryClient.setQueryData([
            '/dealership',
            'holidays'
        ], {
            ...dealership,
            holidays: holidays
        });
    }
    function handleClosedDatesResponse(closedDates) {
        return closedDates.map(({ reason: reason, date: date })=>({
                id: date,
                reason: reason,
                date: (0, $8abb93379891fb3e$export$98e6a39c04603d36)(date, 'yyyy-MM-dd', new Date())
            }));
    }
    function handleHolidaysResponse(calendar) {
        return filterFutureHolidays(calendar.datesList.map((date)=>({
                id: date.datestring,
                date: (0, $8abb93379891fb3e$export$98e6a39c04603d36)(date.datestring, calendar.dateformat, new Date()),
                reason: date.description
            })));
    }
    // @END MOCK HOLIDAYS DAYS BLOCK
    ////////////////////////////////////////////////
    ///////////////// END MOCK /////////////////////
    ////////////////////////////////////////////////
    const isFetching = (0, $4f8e348a4679462a$export$625b2ff71316bcd3)();
    const isMutating = (0, $e8df1924a4e3fb84$export$32cc39cf62abf4fc)();
    return {
        dealership: dealership,
        setDealership: setDealership,
        listDealerships: listDealerships,
        isEditing: isEditing,
        isLoading: isFetching > 0 || isMutating > 0,
        businessDays: businessDays,
        closedDates: closedDates,
        holidays: holidays,
        setClosedDates: setClosedDates,
        setHolidays: setHolidays,
        setBusinessDays: setBusinessDays,
        saveChanges: saveChanges,
        setIsEditing: setIsEditing,
        viewTeam: viewTeam,
        handleCancellation: handleCancellation
    };
}



parcelRequire("acw62");


const $f50813a5b46ebe68$export$893a3658c7a78fe9 = ({ listDealerships: listDealerships, dealership: dealership, setDealership: setDealership, isEditing: isEditing, isLoading: isLoading })=>{
    return isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            textAlign: 'center'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        columnSpacing: 8,
        rowSpacing: 4,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "caption",
                        children: "Team Name"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        children: dealership?.location || 'N/A'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "caption",
                            children: "Location"
                        }),
                        isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                            autoWidth: false,
                            className: "compactSelect",
                            IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                            value: dealership?.id,
                            onChange: (e)=>setDealership(listDealerships.find((dealer)=>dealer.id === e.target.value)),
                            children: listDealerships?.map(({ id: id, location: location })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                    value: id,
                                    children: location
                                }, id))
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            children: dealership?.location || 'N/A'
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("acw62");


const $8ebcc216c7fc8e55$export$98822dca39d91151 = ({ dealerships: dealerships, dealership: dealership, teamMembers: teamMembers, isEditing: isEditing, isLoading: isLoading })=>{
    return isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            textAlign: 'center'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Member name"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Phone number"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Assigned team"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                        children: teamMembers?.map((user)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        width: "15%",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: user.name || 'N/A'
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        width: "15%",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: user.cell || 'N/A'
                                        })
                                    }),
                                    isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        width: "70%",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                            autoWidth: false,
                                            className: "compactSelect",
                                            IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                                            value: dealership?.name,
                                            disabled: true,
                                            onChange: (e)=>{
                                                console.log(e);
                                            // @TODO: assign to another team. On hold for now
                                            },
                                            children: dealerships?.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                    value: name,
                                                    children: name
                                                }, id))
                                        })
                                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        width: "70%",
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            children: dealership?.name || 'N/A'
                                        })
                                    })
                                ]
                            }, user.id))
                    })
                ]
            })
        })
    });
};



parcelRequire("acw62");






parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");

const $26f2848c206fdbb7$export$21a588f09cc6a2f8 = (value, defaultTime, rangeStart, rangeEnd, interval)=>{
    const [selectOption, setSelectedOption] = (0, $acw62.useState)((()=>value ? value : (0, $303ba10db2c74ab4$export$d9468344d3651243)(defaultTime, 'HH:mm'))());
    const timeOptions = $26f2848c206fdbb7$export$73a87dc9f2ec14cf(rangeStart, rangeEnd, interval);
    return {
        selectOption: selectOption,
        setSelectedOption: setSelectedOption,
        timeOptions: timeOptions
    };
};
const $26f2848c206fdbb7$export$73a87dc9f2ec14cf = (start, end, interval = 30)=>{
    const deltaHours = end.getHours() - start.getHours();
    const range = [];
    for(let i = 0; i <= deltaHours; i++){
        const numIntervals = 60 / interval;
        let date = new Date();
        date.setHours(start.getHours() + i);
        for(let j = 0; j < numIntervals; j++){
            date = new Date(date);
            date.setMinutes(j * interval);
            range.push(date);
        }
    }
    return range;
};


const $37a02f1b4de8325f$export$23a763f30e31d106 = ({ value: value, disabled: disabled, rangeStart: rangeStart, rangeEnd: rangeEnd, interval: interval, defaultTime: defaultTime, onChange: onChange })=>{
    const { timeOptions: timeOptions, selectOption: selectOption, setSelectedOption: setSelectedOption } = (0, $26f2848c206fdbb7$export$21a588f09cc6a2f8)(value, defaultTime, rangeStart, rangeEnd, interval);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
        className: "compactSelect",
        value: value,
        autoWidth: false,
        disabled: disabled,
        IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
        onChange: (e)=>{
            setSelectedOption(e.target.value);
            onChange(e.target.value);
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                value: selectOption,
                children: selectOption
            }),
            timeOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                    value: (0, $303ba10db2c74ab4$export$2e2bcd8739ae039)(option, 'HH:mm'),
                    children: (0, $303ba10db2c74ab4$export$2e2bcd8739ae039)(option, 'HH:mm')
                }, (0, $303ba10db2c74ab4$export$2e2bcd8739ae039)(option, 'HH:mm')))
        ]
    });
};



const $3febc5d97db41535$export$9e36ab49f78a4fbd = ({ businessDays: businessDays, setBusinessDays: setBusinessDays, isEditing: isEditing, isLoading: isLoading })=>{
    const { startTime: startTime, endTime: endTime, defaultOpeningHours: defaultOpeningHours, defaultClosingHours: defaultClosingHours, openingRangeStart: openingRangeStart, openingRangeEnd: openingRangeEnd, closingRangeStart: closingRangeStart, closingRangeEnd: closingRangeEnd, isOpenSameTimeEveryDay: isOpenSameTimeEveryDay, setIsOpenSameTimeEveryDay: setIsOpenSameTimeEveryDay, setStartTime: setStartTime, setEndTime: setEndTime } = (0, $2e5850e46a20c778$export$dd0ed304582c330a)(businessDays, setBusinessDays);
    return isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            textAlign: 'center'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        direction: "column",
        children: [
            isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                container: true,
                direction: "row",
                spacing: 5,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c16f3270115bea$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
                                className: "checkboxLabel",
                                control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3ef6305be93c7af$export$2e2bcd8739ae039), {
                                    checked: isOpenSameTimeEveryDay,
                                    onChange: (e)=>setIsOpenSameTimeEveryDay(e.target.checked)
                                }),
                                label: "Same Time Every Day"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37a02f1b4de8325f$export$23a763f30e31d106), {
                            value: startTime,
                            disabled: !isOpenSameTimeEveryDay,
                            rangeStart: openingRangeStart,
                            rangeEnd: openingRangeEnd,
                            defaultTime: defaultOpeningHours,
                            onChange: (time)=>{
                                setStartTime(time);
                                const updatedBusinessDays = businessDays.map((businessDay)=>({
                                        ...businessDay,
                                        startTime: time
                                    }));
                                setBusinessDays(updatedBusinessDays);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "caption",
                            children: "To"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        item: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37a02f1b4de8325f$export$23a763f30e31d106), {
                            value: endTime,
                            disabled: !isOpenSameTimeEveryDay,
                            rangeStart: closingRangeStart,
                            rangeEnd: closingRangeEnd,
                            defaultTime: defaultClosingHours,
                            onChange: (time)=>{
                                setEndTime(time);
                                const updatedBusinessDays = businessDays.map((businessDay)=>({
                                        ...businessDay,
                                        endTime: time
                                    }));
                                setBusinessDays(updatedBusinessDays);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                item: true,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Day open"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Start time"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "End time"
                                        })
                                    })
                                ]
                            })
                        }),
                        isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                            children: (0, $2e5850e46a20c778$export$a33394a36de8aebe).map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            width: "15%",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3c16f3270115bea$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
                                                    className: `switchLabel ${!(0, $2e5850e46a20c778$export$ea0830439c7fc698)(row.dayOfWeek, businessDays) && 'muted'}`,
                                                    control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e276246268a3078e$export$2e2bcd8739ae039), {
                                                        color: "primary",
                                                        checked: (0, $2e5850e46a20c778$export$ea0830439c7fc698)(row.dayOfWeek, businessDays),
                                                        onChange: ()=>{
                                                            if ((0, $2e5850e46a20c778$export$ea0830439c7fc698)(row.dayOfWeek, businessDays)) // remove this business day from the array
                                                            setBusinessDays(businessDays.filter((bd)=>bd.dayOfWeek !== row.dayOfWeek));
                                                            else {
                                                                // add a business day to the array
                                                                const updatedBusinessDays = [
                                                                    ...businessDays,
                                                                    {
                                                                        dayOfWeek: row.dayOfWeek,
                                                                        startTime: (0, $303ba10db2c74ab4$export$2e2bcd8739ae039)(defaultOpeningHours, 'HH:mm'),
                                                                        endTime: (0, $303ba10db2c74ab4$export$2e2bcd8739ae039)(defaultClosingHours, 'HH:mm'),
                                                                        timezone: 'UTC'
                                                                    }
                                                                ];
                                                                setBusinessDays(updatedBusinessDays);
                                                            }
                                                        }
                                                    }),
                                                    label: row.dayOfWeek
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            width: "10%",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37a02f1b4de8325f$export$23a763f30e31d106), {
                                                value: (0, $2e5850e46a20c778$export$1428f42a7de81803)(row.dayOfWeek, businessDays),
                                                disabled: isOpenSameTimeEveryDay || !(0, $2e5850e46a20c778$export$ea0830439c7fc698)(row.dayOfWeek, businessDays),
                                                rangeStart: openingRangeStart,
                                                rangeEnd: openingRangeEnd,
                                                defaultTime: defaultOpeningHours,
                                                onChange: (time)=>{
                                                    const index = businessDays.findIndex((businessDay)=>businessDay.dayOfWeek === row.dayOfWeek);
                                                    const updatedBusinessDays = [
                                                        ...businessDays.slice(0, index),
                                                        {
                                                            ...businessDays[index],
                                                            startTime: time
                                                        },
                                                        ...businessDays.slice(index + 1)
                                                    ];
                                                    setBusinessDays(updatedBusinessDays);
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            width: "5%",
                                            align: "center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                children: "to"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            width: "70%",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37a02f1b4de8325f$export$23a763f30e31d106), {
                                                value: (0, $2e5850e46a20c778$export$1428f42a7de81803)(row.dayOfWeek, businessDays, 'endTime'),
                                                disabled: isOpenSameTimeEveryDay || !(0, $2e5850e46a20c778$export$ea0830439c7fc698)(row.dayOfWeek, businessDays),
                                                rangeStart: closingRangeStart,
                                                rangeEnd: closingRangeEnd,
                                                defaultTime: defaultClosingHours,
                                                onChange: (time)=>{
                                                    const index = businessDays.findIndex((businessDay)=>businessDay.dayOfWeek === row.dayOfWeek);
                                                    const updatedBusinessDays = [
                                                        ...businessDays.slice(0, index),
                                                        {
                                                            ...businessDays[index],
                                                            endTime: time
                                                        },
                                                        ...businessDays.slice(index + 1)
                                                    ];
                                                    setBusinessDays(updatedBusinessDays);
                                                }
                                            })
                                        })
                                    ]
                                }, row.dayOfWeek))
                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                            children: businessDays.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            width: "15%",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                children: row.dayOfWeek
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            width: "6%",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                children: row.startTime
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            width: "4%",
                                            align: "center",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                children: "to"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            width: "75%",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                children: row.endTime
                                            })
                                        })
                                    ]
                                }, row.dayOfWeek))
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");
const $0d6f9a0594f1cdbd$export$980fe6d394d2ebe8 = ()=>{
    const [rowToDelete, setRowToDelete] = (0, $acw62.useState)(null);
    return {
        rowToDelete: rowToDelete,
        setRowToDelete: setRowToDelete
    };
};




"use client";
var $b7b80b55889b1286$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'CloseOutlined');



const $5bf4b79cfe3748de$export$fb03cc73b2301607 = ({ holidays: holidays, closedDates: closedDates, openDays: openDays, setClosedDates: setClosedDates, isEditing: isEditing, isAdmin: isAdmin, isLoading: isLoading })=>{
    const { rowToDelete: rowToDelete, setRowToDelete: setRowToDelete } = (0, $0d6f9a0594f1cdbd$export$980fe6d394d2ebe8)();
    // put both 'kinds' of closed day arrays ( AutonomyHolidays and closedDatesWithReason ) together to disable those in the calendar
    const disabledDates = [
        ...holidays.map((holiday)=>holiday.date),
        ...closedDates.map((closedDate)=>closedDate.date)
    ];
    return isLoading ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            width: '100%',
            textAlign: 'center'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $32db5964c492ae2d$export$2e2bcd8739ae039), {})
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        direction: "column",
        spacing: 6,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Date"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Reason"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                            children: [
                                holidays.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    children: row.date.toLocaleDateString()
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    children: row.reason
                                                })
                                            })
                                        ]
                                    }, `'holiday-'+${row.id}`)),
                                closedDates.map((row)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4332780aab9f215d$export$a6ab8310e121a30a), {
                                                    value: row.date,
                                                    disabledDates: disabledDates,
                                                    openDays: openDays,
                                                    onChange: (date)=>{
                                                        closedDates[closedDates.findIndex((closedDate)=>closedDate.id === row.id)].date = date;
                                                        setClosedDates(closedDates);
                                                    }
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    children: row.date.toLocaleDateString()
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                width: "85%",
                                                children: isEditing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                    sx: {
                                                        display: 'flex',
                                                        width: '100%',
                                                        justifyContent: 'space-between'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                                                placeholder: "Set a reason",
                                                                value: row.reason,
                                                                onChange: (e)=>{
                                                                    closedDates[closedDates.findIndex((closedDate)=>closedDate.id === row.id)].reason = e.target.value;
                                                                    setClosedDates(closedDates);
                                                                },
                                                                className: "compactTextField roundedTextField"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                                className: "xsIcon",
                                                                onClick: ()=>{
                                                                    setRowToDelete(row);
                                                                },
                                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7b80b55889b1286$export$2e2bcd8739ae039), {})
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    children: row.reason
                                                })
                                            })
                                        ]
                                    }, row.id))
                            ]
                        })
                    ]
                })
            }),
            isAdmin && isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                alignSelf: "center",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    variant: "outlined",
                    color: "primary",
                    onClick: ()=>{
                        const newRow = {
                            id: new Date().toString(),
                            date: new Date(),
                            reason: ''
                        };
                        setClosedDates([
                            ...closedDates,
                            newRow
                        ]);
                    },
                    children: "Add Date"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
                open: !!rowToDelete,
                onClose: ()=>setRowToDelete(null),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                        children: "Delete a date"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            children: "Are you sure you want to delete this date?"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "outlined",
                                onClick: ()=>setRowToDelete(null),
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                color: "primary",
                                variant: "contained",
                                onClick: ()=>{
                                    const index = closedDates.findIndex((closedDate)=>closedDate.id === rowToDelete.id);
                                    setClosedDates([
                                        ...closedDates.slice(0, index),
                                        ...closedDates.slice(index + 1)
                                    ]);
                                    setRowToDelete(null);
                                },
                                children: "Confirm"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $f187952a5e5c885d$export$20bbf5d997482b31 = ({ dealership: dealership, setDealership: setDealership, isAdmin: isAdmin })=>{
    const { listDealerships: listDealerships, viewTeam: viewTeam, businessDays: businessDays, closedDates: closedDates, holidays: holidays, isEditing: isEditing, isLoading: isLoading, setClosedDates: setClosedDates, setBusinessDays: setBusinessDays, setIsEditing: setIsEditing, handleCancellation: handleCancellation, saveChanges: saveChanges } = (0, $08d791c1f17d4ad4$export$4fa67ba1352ae50f)(dealership, setDealership);
    function getHeaderButtons() {
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                columnGap: 2,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "outlined",
                            color: "primary",
                            onClick: ()=>{
                                setIsEditing(!isEditing);
                                if (isEditing) handleCancellation();
                            },
                            children: !isEditing ? 'Edit' : 'Cancel'
                        })
                    }),
                    isEditing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "contained",
                            color: "primary",
                            onClick: ()=>{
                                saveChanges();
                            },
                            children: "Save"
                        })
                    })
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
        wrapperSection: true,
        heading: "Team Settings",
        headerButtons: isAdmin && getHeaderButtons(),
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                subSection: true,
                heading: "Team Details",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f50813a5b46ebe68$export$893a3658c7a78fe9), {
                    listDealerships: listDealerships,
                    isLoading: isLoading,
                    isEditing: isEditing,
                    setDealership: setDealership,
                    dealership: dealership
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                subSection: true,
                heading: "Business Hours",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3febc5d97db41535$export$9e36ab49f78a4fbd), {
                    isLoading: isLoading,
                    businessDays: businessDays,
                    setBusinessDays: setBusinessDays,
                    isEditing: isEditing
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                subSection: true,
                heading: "Holidays & Closed Days",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5bf4b79cfe3748de$export$fb03cc73b2301607), {
                    closedDates: closedDates,
                    holidays: holidays,
                    openDays: businessDays.map((businessDay)=>businessDay.dayOfWeek),
                    setClosedDates: setClosedDates,
                    isEditing: isEditing,
                    isAdmin: isAdmin,
                    isLoading: isLoading
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                subSection: true,
                heading: "Team Members",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8ebcc216c7fc8e55$export$98822dca39d91151), {
                    dealerships: listDealerships,
                    teamMembers: viewTeam,
                    isLoading: isLoading,
                    isEditing: isEditing,
                    dealership: dealership
                })
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");


const $d1b4032acc7c53f1$export$9115b42802a3e44f = ()=>{
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const userGroups = authState?.idToken?.claims?.groups;
    const isAdmin = (0, $bd0736fcf235ae86$export$7d046765d192af80)(userGroups);
    const [dealership, setDealership] = (0, $acw62.useState)();
    return {
        isAdmin: isAdmin,
        dealership: dealership,
        setDealership: setDealership
    };
};


const $5dbc5936ee69e9e3$export$c72f6eaae7b9adff = ()=>{
    const { isAdmin: isAdmin, dealership: dealership, setDealership: setDealership } = (0, $d1b4032acc7c53f1$export$9115b42802a3e44f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $48a14f90dc08d980$export$89693000420c0acd), {
        heading: "Team Settings",
        headerHasBottomBorder: false,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f187952a5e5c885d$export$20bbf5d997482b31), {
            dealership: dealership,
            setDealership: setDealership,
            isAdmin: isAdmin
        })
    });
};



parcelRequire("acw62");

parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");











var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */ const $105d163ff744545c$var$AccordionContext = /*#__PURE__*/ $acw62.createContext({});
var $105d163ff744545c$export$2e2bcd8739ae039 = $105d163ff744545c$var$AccordionContext;






function $6780e0f06b9fdbd4$export$80fb6a2cb3f13b8b(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiAccordion', slot);
}
const $6780e0f06b9fdbd4$var$accordionClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiAccordion', [
    'root',
    'heading',
    'rounded',
    'expanded',
    'disabled',
    'gutters',
    'region'
]);
var $6780e0f06b9fdbd4$export$2e2bcd8739ae039 = $6780e0f06b9fdbd4$var$accordionClasses;



'use client';
const $8128d19b7581a50c$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, square: square, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            !square && 'rounded',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        heading: [
            'heading'
        ],
        region: [
            'region'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $6780e0f06b9fdbd4$export$80fb6a2cb3f13b8b), classes);
};
const $8128d19b7581a50c$var$AccordionRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
    name: 'MuiAccordion',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            {
                [`& .${(0, $6780e0f06b9fdbd4$export$2e2bcd8739ae039).region}`]: styles.region
            },
            styles.root,
            !ownerState.square && styles.rounded,
            !ownerState.disableGutters && styles.gutters
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        position: 'relative',
        transition: theme.transitions.create([
            'margin'
        ], transition),
        overflowAnchor: 'none',
        // Keep the same scrolling position
        '&::before': {
            position: 'absolute',
            left: 0,
            top: -1,
            right: 0,
            height: 1,
            content: '""',
            opacity: 1,
            backgroundColor: (theme.vars || theme).palette.divider,
            transition: theme.transitions.create([
                'opacity',
                'background-color'
            ], transition)
        },
        '&:first-of-type': {
            '&::before': {
                display: 'none'
            }
        },
        [`&.${(0, $6780e0f06b9fdbd4$export$2e2bcd8739ae039).expanded}`]: {
            '&::before': {
                opacity: 0
            },
            '&:first-of-type': {
                marginTop: 0
            },
            '&:last-of-type': {
                marginBottom: 0
            },
            '& + &': {
                '&::before': {
                    display: 'none'
                }
            }
        },
        [`&.${(0, $6780e0f06b9fdbd4$export$2e2bcd8739ae039).disabled}`]: {
            backgroundColor: (theme.vars || theme).palette.action.disabledBackground
        }
    };
}), (0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        variants: [
            {
                props: (props)=>!props.square,
                style: {
                    borderRadius: 0,
                    '&:first-of-type': {
                        borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                    },
                    '&:last-of-type': {
                        borderBottomLeftRadius: (theme.vars || theme).shape.borderRadius,
                        borderBottomRightRadius: (theme.vars || theme).shape.borderRadius,
                        // Fix a rendering issue on Edge
                        '@supports (-ms-ime-align: auto)': {
                            borderBottomLeftRadius: 0,
                            borderBottomRightRadius: 0
                        }
                    }
                }
            },
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $6780e0f06b9fdbd4$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '16px 0'
                    }
                }
            }
        ]
    })));
const $8128d19b7581a50c$var$AccordionHeading = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('h3', {
    name: 'MuiAccordion',
    slot: 'Heading'
})({
    all: 'unset'
});
const $8128d19b7581a50c$var$AccordionRegion = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAccordion',
    slot: 'Region'
})({});
const $8128d19b7581a50c$var$Accordion = /*#__PURE__*/ $acw62.forwardRef(function Accordion(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAccordion'
    });
    const { children: childrenProp, className: className, defaultExpanded: defaultExpanded = false, disabled: disabled = false, disableGutters: disableGutters = false, expanded: expandedProp, onChange: onChange, square: square = false, slots: slots = {}, slotProps: slotProps = {}, TransitionComponent: TransitionComponentProp, TransitionProps: TransitionPropsProp, ...other } = props;
    const [expanded, setExpandedState] = (0, $3c946fbcfb716a43$export$2e2bcd8739ae039)({
        controlled: expandedProp,
        default: defaultExpanded,
        name: 'Accordion',
        state: 'expanded'
    });
    const handleChange = $acw62.useCallback((event)=>{
        setExpandedState(!expanded);
        if (onChange) onChange(event, !expanded);
    }, [
        expanded,
        onChange,
        setExpandedState
    ]);
    const [summary, ...children] = $acw62.Children.toArray(childrenProp);
    const contextValue = $acw62.useMemo(()=>({
            expanded: expanded,
            disabled: disabled,
            disableGutters: disableGutters,
            toggle: handleChange
        }), [
        expanded,
        disabled,
        disableGutters,
        handleChange
    ]);
    const ownerState = {
        ...props,
        square: square,
        disabled: disabled,
        disableGutters: disableGutters,
        expanded: expanded
    };
    const classes = $8128d19b7581a50c$var$useUtilityClasses(ownerState);
    const backwardCompatibleSlots = {
        transition: TransitionComponentProp,
        ...slots
    };
    const backwardCompatibleSlotProps = {
        transition: TransitionPropsProp,
        ...slotProps
    };
    const externalForwardedProps = {
        slots: backwardCompatibleSlots,
        slotProps: backwardCompatibleSlotProps
    };
    const [RootSlot, rootProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        elementType: $8128d19b7581a50c$var$AccordionRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        ownerState: ownerState,
        ref: ref,
        additionalProps: {
            square: square
        }
    });
    const [AccordionHeadingSlot, accordionProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('heading', {
        elementType: $8128d19b7581a50c$var$AccordionHeading,
        externalForwardedProps: externalForwardedProps,
        className: classes.heading,
        ownerState: ownerState
    });
    const [TransitionSlot, transitionProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('transition', {
        elementType: (0, $691c7db844a32c8c$export$2e2bcd8739ae039),
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [AccordionRegionSlot, accordionRegionProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('region', {
        elementType: $8128d19b7581a50c$var$AccordionRegion,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState,
        className: classes.region,
        additionalProps: {
            'aria-labelledby': summary.props.id,
            id: summary.props['aria-controls'],
            role: 'region'
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(AccordionHeadingSlot, {
                ...accordionProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $105d163ff744545c$export$2e2bcd8739ae039).Provider, {
                    value: contextValue,
                    children: summary
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(TransitionSlot, {
                in: expanded,
                timeout: "auto",
                ...transitionProps,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(AccordionRegionSlot, {
                    ...accordionRegionProps,
                    children: children
                })
            })
        ]
    });
});
var $8128d19b7581a50c$export$2e2bcd8739ae039 = $8128d19b7581a50c$var$Accordion;


var $acw62 = parcelRequire("acw62");








function $d381e1f2d985a762$export$a6afb527becfac26(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiAccordionDetails', slot);
}
const $d381e1f2d985a762$var$accordionDetailsClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiAccordionDetails', [
    'root'
]);
var $d381e1f2d985a762$export$2e2bcd8739ae039 = $d381e1f2d985a762$var$accordionDetailsClasses;



'use client';
const $ede82a9c6dddd9d5$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $d381e1f2d985a762$export$a6afb527becfac26), classes);
};
const $ede82a9c6dddd9d5$var$AccordionDetailsRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('div', {
    name: 'MuiAccordionDetails',
    slot: 'Root'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        padding: theme.spacing(1, 2, 2)
    })));
const $ede82a9c6dddd9d5$var$AccordionDetails = /*#__PURE__*/ $acw62.forwardRef(function AccordionDetails(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAccordionDetails'
    });
    const { className: className, ...other } = props;
    const ownerState = props;
    const classes = $ede82a9c6dddd9d5$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ede82a9c6dddd9d5$var$AccordionDetailsRoot, {
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ref: ref,
        ownerState: ownerState,
        ...other
    });
});
var $ede82a9c6dddd9d5$export$2e2bcd8739ae039 = $ede82a9c6dddd9d5$var$AccordionDetails;



var $acw62 = parcelRequire("acw62");










function $96424997ad8822f7$export$282216ad123d6580(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiAccordionSummary', slot);
}
const $96424997ad8822f7$var$accordionSummaryClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiAccordionSummary', [
    'root',
    'expanded',
    'focusVisible',
    'disabled',
    'gutters',
    'contentGutters',
    'content',
    'expandIconWrapper'
]);
var $96424997ad8822f7$export$2e2bcd8739ae039 = $96424997ad8822f7$var$accordionSummaryClasses;




'use client';
const $29b6b3c2df561c19$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, expanded: expanded, disabled: disabled, disableGutters: disableGutters } = ownerState;
    const slots = {
        root: [
            'root',
            expanded && 'expanded',
            disabled && 'disabled',
            !disableGutters && 'gutters'
        ],
        focusVisible: [
            'focusVisible'
        ],
        content: [
            'content',
            expanded && 'expanded',
            !disableGutters && 'contentGutters'
        ],
        expandIconWrapper: [
            'expandIconWrapper',
            expanded && 'expanded'
        ]
    };
    return (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $96424997ad8822f7$export$282216ad123d6580), classes);
};
const $29b6b3c2df561c19$var$AccordionSummaryRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $21d0be68de155ec6$export$2e2bcd8739ae039), {
    name: 'MuiAccordionSummary',
    slot: 'Root'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>{
    const transition = {
        duration: theme.transitions.duration.shortest
    };
    return {
        display: 'flex',
        width: '100%',
        minHeight: 48,
        padding: theme.spacing(0, 2),
        transition: theme.transitions.create([
            'min-height',
            'background-color'
        ], transition),
        [`&.${(0, $96424997ad8822f7$export$2e2bcd8739ae039).focusVisible}`]: {
            backgroundColor: (theme.vars || theme).palette.action.focus
        },
        [`&.${(0, $96424997ad8822f7$export$2e2bcd8739ae039).disabled}`]: {
            opacity: (theme.vars || theme).palette.action.disabledOpacity
        },
        [`&:hover:not(.${(0, $96424997ad8822f7$export$2e2bcd8739ae039).disabled})`]: {
            cursor: 'pointer'
        },
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    [`&.${(0, $96424997ad8822f7$export$2e2bcd8739ae039).expanded}`]: {
                        minHeight: 64
                    }
                }
            }
        ]
    };
}));
const $29b6b3c2df561c19$var$AccordionSummaryContent = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiAccordionSummary',
    slot: 'Content'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        textAlign: 'start',
        flexGrow: 1,
        margin: '12px 0',
        variants: [
            {
                props: (props)=>!props.disableGutters,
                style: {
                    transition: theme.transitions.create([
                        'margin'
                    ], {
                        duration: theme.transitions.duration.shortest
                    }),
                    [`&.${(0, $96424997ad8822f7$export$2e2bcd8739ae039).expanded}`]: {
                        margin: '20px 0'
                    }
                }
            }
        ]
    })));
const $29b6b3c2df561c19$var$AccordionSummaryExpandIconWrapper = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiAccordionSummary',
    slot: 'ExpandIconWrapper'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        display: 'flex',
        color: (theme.vars || theme).palette.action.active,
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest
        }),
        [`&.${(0, $96424997ad8822f7$export$2e2bcd8739ae039).expanded}`]: {
            transform: 'rotate(180deg)'
        }
    })));
const $29b6b3c2df561c19$var$AccordionSummary = /*#__PURE__*/ $acw62.forwardRef(function AccordionSummary(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiAccordionSummary'
    });
    const { children: children, className: className, expandIcon: expandIcon, focusVisibleClassName: focusVisibleClassName, onClick: onClick, slots: slots, slotProps: slotProps, ...other } = props;
    const { disabled: disabled = false, disableGutters: disableGutters, expanded: expanded, toggle: toggle } = $acw62.useContext((0, $105d163ff744545c$export$2e2bcd8739ae039));
    const handleChange = (event)=>{
        if (toggle) toggle(event);
        if (onClick) onClick(event);
    };
    const ownerState = {
        ...props,
        expanded: expanded,
        disabled: disabled,
        disableGutters: disableGutters
    };
    const classes = $29b6b3c2df561c19$var$useUtilityClasses(ownerState);
    const externalForwardedProps = {
        slots: slots,
        slotProps: slotProps
    };
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        shouldForwardComponentProp: true,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        elementType: $29b6b3c2df561c19$var$AccordionSummaryRoot,
        externalForwardedProps: {
            ...externalForwardedProps,
            ...other
        },
        ownerState: ownerState,
        additionalProps: {
            focusRipple: false,
            disableRipple: true,
            disabled: disabled,
            'aria-expanded': expanded,
            focusVisibleClassName: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.focusVisible, focusVisibleClassName)
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onClick: (event)=>{
                    handlers.onClick?.(event);
                    handleChange(event);
                }
            })
    });
    const [ContentSlot, contentSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('content', {
        className: classes.content,
        elementType: $29b6b3c2df561c19$var$AccordionSummaryContent,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    const [ExpandIconWrapperSlot, expandIconWrapperSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('expandIconWrapper', {
        className: classes.expandIconWrapper,
        elementType: $29b6b3c2df561c19$var$AccordionSummaryExpandIconWrapper,
        externalForwardedProps: externalForwardedProps,
        ownerState: ownerState
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)(RootSlot, {
        ...rootSlotProps,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ContentSlot, {
                ...contentSlotProps,
                children: children
            }),
            expandIcon && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(ExpandIconWrapperSlot, {
                ...expandIconWrapperSlotProps,
                children: expandIcon
            })
        ]
    });
});
var $29b6b3c2df561c19$export$2e2bcd8739ae039 = $29b6b3c2df561c19$var$AccordionSummary;





const $251cae3df749d8b6$export$478a664dca8ee058 = ({ isLoading: isLoading, appointmentDay: appointmentDay, includeHeading: includeHeading })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $8128d19b7581a50c$export$2e2bcd8739ae039), {
            square: true,
            sx: {
                marginBottom: '30px'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $29b6b3c2df561c19$export$2e2bcd8739ae039), {
                    expandIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0953557707017bc5$export$2e2bcd8739ae039), {}),
                    "aria-controls": "panel1a-content",
                    id: "panel1a-header",
                    children: includeHeading && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h4",
                        children: (0, $90fb957545aae5a4$export$9677806c6bd86d45)(appointmentDay?.day) || 'N/A'
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ede82a9c6dddd9d5$export$2e2bcd8739ae039), {
                    className: "horizontal",
                    children: appointmentDay?.appointments?.sort((a, b)=>a.startTime - b.startTime).map((appointment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $eb6ac201fa409201$export$675aa2c02f1bc1a0), {
                            isLoading: isLoading,
                            appointment: appointment,
                            displayCustomerDetails: true
                        }, appointment?.id))
                })
            ]
        })
    });
};





parcelRequire("acw62");



"use client";
var $ed7b2b659b749647$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), 'Add');


const $f41a3593662d8a2c$export$87cbfb14b50d331c = ({ name: name, onClick: onClick })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
        variant: "outlined",
        className: "ctaBtn",
        onClick: onClick,
        children: [
            name,
            " ",
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {
                className: "ctaBtnIcon"
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");

parcelRequire("acw62");


'use client';
var $1cb10b5ba3096930$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');


parcelRequire("acw62");


'use client';
var $59248c5edcc630d3$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');






'use client';
const $30a65a873f527c35$var$RadioButtonIconRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span', {
    name: 'MuiRadioButtonIcon',
    shouldForwardProp: (0, $7f9f996b464e1691$export$2e2bcd8739ae039)
})({
    position: 'relative',
    display: 'flex'
});
const $30a65a873f527c35$var$RadioButtonIconBackground = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $1cb10b5ba3096930$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})({
    // Scale applied to prevent dot misalignment in Safari
    transform: 'scale(1)'
});
const $30a65a873f527c35$var$RadioButtonIconDot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $59248c5edcc630d3$export$2e2bcd8739ae039), {
    name: 'MuiRadioButtonIcon'
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        left: 0,
        position: 'absolute',
        transform: 'scale(0)',
        transition: theme.transitions.create('transform', {
            easing: theme.transitions.easing.easeIn,
            duration: theme.transitions.duration.shortest
        }),
        variants: [
            {
                props: {
                    checked: true
                },
                style: {
                    transform: 'scale(1)',
                    transition: theme.transitions.create('transform', {
                        easing: theme.transitions.easing.easeOut,
                        duration: theme.transitions.duration.shortest
                    })
                }
            }
        ]
    })));
/**
 * @ignore - internal component.
 */ function $30a65a873f527c35$var$RadioButtonIcon(props) {
    const { checked: checked = false, classes: classes = {}, fontSize: fontSize } = props;
    const ownerState = {
        ...props,
        checked: checked
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)($30a65a873f527c35$var$RadioButtonIconRoot, {
        className: classes.root,
        ownerState: ownerState,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($30a65a873f527c35$var$RadioButtonIconBackground, {
                fontSize: fontSize,
                className: classes.background,
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($30a65a873f527c35$var$RadioButtonIconDot, {
                fontSize: fontSize,
                className: classes.dot,
                ownerState: ownerState
            })
        ]
    });
}
var $30a65a873f527c35$export$2e2bcd8739ae039 = $30a65a873f527c35$var$RadioButtonIcon;




var $71dd6ce5929449ce$export$2e2bcd8739ae039 = (0, $cfb86ebe4ea00eb7$export$2e2bcd8739ae039);




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");
'use client';
/**
 * @ignore - internal component.
 */ const $3049db72b7690206$var$RadioGroupContext = /*#__PURE__*/ $acw62.createContext(undefined);
var $3049db72b7690206$export$2e2bcd8739ae039 = $3049db72b7690206$var$RadioGroupContext;


'use client';
function $ee6a752b51430a78$export$2e2bcd8739ae039() {
    return $acw62.useContext((0, $3049db72b7690206$export$2e2bcd8739ae039));
}




function $17730288e1c01674$export$192f7b2363c77155(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiRadio', slot);
}
const $17730288e1c01674$var$radioClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiRadio', [
    'root',
    'checked',
    'disabled',
    'colorPrimary',
    'colorSecondary',
    'sizeSmall'
]);
var $17730288e1c01674$export$2e2bcd8739ae039 = $17730288e1c01674$var$radioClasses;









'use client';
const $a588c4a0dc9c5bcb$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes, color: color, size: size } = ownerState;
    const slots = {
        root: [
            'root',
            `color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(color)}`,
            size !== 'medium' && `size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(size)}`
        ]
    };
    return {
        ...classes,
        ...(0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $17730288e1c01674$export$192f7b2363c77155), classes)
    };
};
const $a588c4a0dc9c5bcb$var$RadioRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $dadefa050dca578a$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiRadio',
    slot: 'Root',
    overridesResolver: (props, styles)=>{
        const { ownerState: ownerState } = props;
        return [
            styles.root,
            ownerState.size !== 'medium' && styles[`size${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.size)}`],
            styles[`color${(0, $29da0f32997f4b8c$export$2e2bcd8739ae039)(ownerState.color)}`]
        ];
    }
})((0, $fac58cb18f36893e$export$2e2bcd8739ae039)(({ theme: theme })=>({
        color: (theme.vars || theme).palette.text.secondary,
        [`&.${(0, $17730288e1c01674$export$2e2bcd8739ae039).disabled}`]: {
            color: (theme.vars || theme).palette.action.disabled
        },
        variants: [
            {
                props: {
                    color: 'default',
                    disabled: false,
                    disableRipple: false
                },
                style: {
                    '&:hover': {
                        backgroundColor: theme.alpha((theme.vars || theme).palette.action.active, (theme.vars || theme).palette.action.hoverOpacity)
                    }
                }
            },
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false,
                        disableRipple: false
                    },
                    style: {
                        '&:hover': {
                            backgroundColor: theme.alpha((theme.vars || theme).palette[color].main, (theme.vars || theme).palette.action.hoverOpacity)
                        }
                    }
                })),
            ...Object.entries(theme.palette).filter((0, $9bc172c5d9139290$export$2e2bcd8739ae039)()).map(([color])=>({
                    props: {
                        color: color,
                        disabled: false
                    },
                    style: {
                        [`&.${(0, $17730288e1c01674$export$2e2bcd8739ae039).checked}`]: {
                            color: (theme.vars || theme).palette[color].main
                        }
                    }
                })),
            {
                // Should be last to override other colors
                props: {
                    disableRipple: false
                },
                style: {
                    // Reset on touch devices, it doesn't add specificity
                    '&:hover': {
                        '@media (hover: none)': {
                            backgroundColor: 'transparent'
                        }
                    }
                }
            }
        ]
    })));
function $a588c4a0dc9c5bcb$var$areEqualValues(a, b) {
    if (typeof b === 'object' && b !== null) return a === b;
    // The value could be a number, the DOM will stringify it anyway.
    return String(a) === String(b);
}
const $a588c4a0dc9c5bcb$var$defaultCheckedIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30a65a873f527c35$export$2e2bcd8739ae039), {
    checked: true
});
const $a588c4a0dc9c5bcb$var$defaultIcon = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $30a65a873f527c35$export$2e2bcd8739ae039), {});
const $a588c4a0dc9c5bcb$var$Radio = /*#__PURE__*/ $acw62.forwardRef(function Radio(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiRadio'
    });
    const { checked: checkedProp, checkedIcon: checkedIcon = $a588c4a0dc9c5bcb$var$defaultCheckedIcon, color: color = 'primary', icon: icon = $a588c4a0dc9c5bcb$var$defaultIcon, name: nameProp, onChange: onChangeProp, size: size = 'medium', className: className, disabled: disabledProp, disableRipple: disableRipple = false, slots: slots = {}, slotProps: slotProps = {}, inputProps: inputProps, ...other } = props;
    const muiFormControl = (0, $343072e2ec7ced8d$export$2e2bcd8739ae039)();
    let disabled = disabledProp;
    if (muiFormControl) {
        if (typeof disabled === 'undefined') disabled = muiFormControl.disabled;
    }
    disabled ??= false;
    const ownerState = {
        ...props,
        disabled: disabled,
        disableRipple: disableRipple,
        color: color,
        size: size
    };
    const classes = $a588c4a0dc9c5bcb$var$useUtilityClasses(ownerState);
    const radioGroup = (0, $ee6a752b51430a78$export$2e2bcd8739ae039)();
    let checked = checkedProp;
    const onChange = (0, $71dd6ce5929449ce$export$2e2bcd8739ae039)(onChangeProp, radioGroup && radioGroup.onChange);
    let name = nameProp;
    if (radioGroup) {
        if (typeof checked === 'undefined') checked = $a588c4a0dc9c5bcb$var$areEqualValues(radioGroup.value, props.value);
        if (typeof name === 'undefined') name = radioGroup.name;
    }
    const externalInputProps = slotProps.input ?? inputProps;
    const [RootSlot, rootSlotProps] = (0, $25e19e282016bf82$export$2e2bcd8739ae039)('root', {
        ref: ref,
        elementType: $a588c4a0dc9c5bcb$var$RadioRoot,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        shouldForwardComponentProp: true,
        externalForwardedProps: {
            slots: slots,
            slotProps: slotProps,
            ...other
        },
        getSlotProps: (handlers)=>({
                ...handlers,
                onChange: (event, ...args)=>{
                    handlers.onChange?.(event, ...args);
                    onChange(event, ...args);
                }
            }),
        ownerState: ownerState,
        additionalProps: {
            type: 'radio',
            icon: /*#__PURE__*/ $acw62.cloneElement(icon, {
                fontSize: icon.props.fontSize ?? size
            }),
            checkedIcon: /*#__PURE__*/ $acw62.cloneElement(checkedIcon, {
                fontSize: checkedIcon.props.fontSize ?? size
            }),
            disabled: disabled,
            name: name,
            checked: checked,
            slots: slots,
            slotProps: {
                // Do not forward `slotProps.root` again because it's already handled by the `RootSlot` in this file.
                input: typeof externalInputProps === 'function' ? externalInputProps(ownerState) : externalInputProps
            }
        }
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)(RootSlot, {
        ...rootSlotProps,
        classes: classes
    });
});
var $a588c4a0dc9c5bcb$export$2e2bcd8739ae039 = $a588c4a0dc9c5bcb$var$Radio;



parcelRequire("acw62");

const $c48b5c4419b1e41f$export$4e3778eb35f54199 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
        fillRule: "evenodd",
        d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
        clipRule: "evenodd"
    })
}), 'ChevronDown');




const $2458841c407d1001$export$b6b4cb8dcfd6af64 = (props)=>{
    const { label: label, onChange: onChange, options: options, value: value = [], ...other } = props;
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const anchorRef = (0, $acw62.useRef)(null);
    const [openMenu, setOpenMenu] = (0, $acw62.useState)(false);
    const handleOpenMenu = ()=>{
        setOpenMenu(true);
    };
    const handleCloseMenu = ()=>{
        setOpenMenu(false);
    };
    const handleChange = (event)=>{
        console.log(event.target.value);
        onChange(event.target.value);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                color: "inherit",
                endIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c48b5c4419b1e41f$export$4e3778eb35f54199), {
                    fontSize: "small"
                }),
                onClick: handleOpenMenu,
                ref: anchorRef,
                ...other,
                sx: {
                    backgroundColor: themeColors.buttonColor,
                    color: 'white',
                    '&:hover': {
                        backgroundColor: themeColors.buttonHover
                    }
                },
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81db31f1007c14e1$export$2e2bcd8739ae039), {
                anchorEl: anchorRef.current,
                onClose: handleCloseMenu,
                open: openMenu,
                PaperProps: {
                    style: {
                        minWidth: 250
                    }
                },
                children: options.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e29860be68ec3320$export$2e2bcd8739ae039), {
                            disabled: option.disabled,
                            control: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a588c4a0dc9c5bcb$export$2e2bcd8739ae039), {
                                checked: value === option.value,
                                onChange: handleChange,
                                value: option.value,
                                sx: {
                                    color: 'white',
                                    '&.Mui-checked': {
                                        color: 'white'
                                    }
                                }
                            }),
                            label: option.label,
                            sx: {
                                flexGrow: 1,
                                mr: 0,
                                color: 'white',
                                fontSize: '16px'
                            }
                        })
                    }, `${option.label}-${option.value}`))
            })
        ]
    });
};


const $a12e81b08c6dd3b8$export$77bc526bfccc9372 = ({ isLoading: isLoading })=>{
    const { appointments: appointments, dealershipId: dealershipId, dealershipOptions: dealershipOptions, createAppointmentModalIsVisible: createAppointmentModalIsVisible, setCreateAppointmentModalIsVisible: setCreateAppointmentModalIsVisible, handleClose: handleClose, selectDealership: selectDealership } = (0, $717acf5975a336d7$export$ed5c3368304694)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginBottom: '30px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            gap: '20px'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "h1",
                            children: "Tasks"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            gap: '20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f41a3593662d8a2c$export$87cbfb14b50d331c), {
                                name: "New Appointment",
                                onClick: ()=>setCreateAppointmentModalIsVisible(true)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2458841c407d1001$export$b6b4cb8dcfd6af64), {
                                label: "Location",
                                value: dealershipId,
                                options: dealershipOptions,
                                onChange: selectDealership
                            })
                        ]
                    })
                ]
            }),
            appointments?.map((appointment)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $251cae3df749d8b6$export$478a664dca8ee058), {
                        isLoading: isLoading,
                        appointmentDay: appointment,
                        includeHeading: true
                    })
                }, appointment?.day)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ebc551e8e2aef5a1$export$7512f38e436d47e7), {
                modalIsOpen: createAppointmentModalIsVisible,
                handleClose: handleClose
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");

var $acw62 = parcelRequire("acw62");









function $ab9f026bf6924669$export$d9c6dc45f75b0e4f(slot) {
    return (0, $35cd7d64717698f7$export$2e2bcd8739ae039)('MuiDialogContentText', slot);
}
const $ab9f026bf6924669$var$dialogContentTextClasses = (0, $82df286c368a2a01$export$2e2bcd8739ae039)('MuiDialogContentText', [
    'root'
]);
var $ab9f026bf6924669$export$2e2bcd8739ae039 = $ab9f026bf6924669$var$dialogContentTextClasses;



'use client';
const $6b3200515d476ef1$var$useUtilityClasses = (ownerState)=>{
    const { classes: classes } = ownerState;
    const slots = {
        root: [
            'root'
        ]
    };
    const composedClasses = (0, $65847140631d74af$export$2e2bcd8739ae039)(slots, (0, $ab9f026bf6924669$export$d9c6dc45f75b0e4f), classes);
    return {
        ...classes,
        // forward classes to the Typography
        ...composedClasses
    };
};
const $6b3200515d476ef1$var$DialogContentTextRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
    shouldForwardProp: (prop)=>(0, $7f9f996b464e1691$export$2e2bcd8739ae039)(prop) || prop === 'classes',
    name: 'MuiDialogContentText',
    slot: 'Root'
})({});
const $6b3200515d476ef1$var$DialogContentText = /*#__PURE__*/ $acw62.forwardRef(function DialogContentText(inProps, ref) {
    const props = (0, $1bc4906ad0338fb8$export$2440da353cedad43)({
        props: inProps,
        name: 'MuiDialogContentText'
    });
    const { children: children, className: className, ...ownerState } = props;
    const classes = $6b3200515d476ef1$var$useUtilityClasses(ownerState);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6b3200515d476ef1$var$DialogContentTextRoot, {
        component: "p",
        variant: "body1",
        color: "textSecondary",
        ref: ref,
        ownerState: ownerState,
        className: (0, $f2ccb2ae3c8742b7$export$2e2bcd8739ae039)(classes.root, className),
        ...props,
        classes: classes
    });
});
var $6b3200515d476ef1$export$2e2bcd8739ae039 = $6b3200515d476ef1$var$DialogContentText;





"use client";
var $689927f0df05e8fa$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z"
}), 'Delete');





var $acw62 = parcelRequire("acw62");


var $3EyMN = parcelRequire("3EyMN");

const $b901e94c01d5794a$export$623922d2761a272a = (clientId)=>{
    // Filter states
    const [make, setMake] = (0, $acw62.useState)('');
    const [model, setModel] = (0, $acw62.useState)('');
    const [year, setYear] = (0, $acw62.useState)('');
    const [trim, setTrim] = (0, $acw62.useState)('');
    // Drawer states
    const [isAddDrawerOpen, setIsAddDrawerOpen] = (0, $acw62.useState)(false);
    const [isEditDrawerOpen, setIsEditDrawerOpen] = (0, $acw62.useState)(false);
    const [editingRecord, setEditingRecord] = (0, $acw62.useState)(null);
    // Delete modal states
    const [isDeleteDialogOpen, setIsDeleteDialogOpen] = (0, $acw62.useState)(false);
    const [deletingRecord, setDeletingRecord] = (0, $acw62.useState)(null);
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    // Query for vehicle media data
    const { data: vehicleMediaData, isLoading: isLoading, refetch: refetch } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'vehicleMedia',
            clientId,
            make,
            model,
            year,
            trim
        ],
        queryFn: async ()=>{
            if (!clientId) return {
                vehicleMediaList: []
            };
            try {
                const response = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getVehicleMedia(clientId, make, model, year, trim);
                // Ensure the response has the expected structure
                return {
                    vehicleMediaList: response?.mediaList || []
                };
            } catch (error) {
                console.error('Error fetching vehicle media:', error);
                return {
                    vehicleMediaList: []
                };
            }
        },
        enabled: !!clientId,
        staleTime: 30000 // 30 seconds
    });
    // Mutation for upserting vehicle media
    const upsertMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (data)=>{
            const request = new (0, $3EyMN.UpsertVehicleMediaRequest)();
            if (data.id) request.setId(data.id);
            request.setMake(data.make);
            request.setModel(data.model);
            request.setTrim(data.trim);
            request.setYear(data.year);
            request.setData(data.data);
            return await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).upsertVehicleMedia({
                clientId: clientId,
                upsertVehicleMediaRequest: request
            });
        },
        onSuccess: ()=>{
            // Refetch data after successful upsert
            queryClient.invalidateQueries({
                queryKey: [
                    'vehicleMedia'
                ]
            });
            setIsAddDrawerOpen(false);
            setIsEditDrawerOpen(false);
            setEditingRecord(null);
        },
        onError: (error)=>{
            console.error('Error upserting vehicle media:', error);
        }
    });
    // Mutation for deleting vehicle media
    const deleteMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (vehicleMediaId)=>{
            return await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).deleteVehicleMedia(vehicleMediaId);
        },
        onSuccess: ()=>{
            // Refetch data after successful delete
            queryClient.invalidateQueries({
                queryKey: [
                    'vehicleMedia'
                ]
            });
            setIsDeleteDialogOpen(false);
            setDeletingRecord(null);
        },
        onError: (error)=>{
            console.error('Error deleting vehicle media:', error);
        }
    });
    const handleSearch = ()=>{
        refetch();
    };
    const handleEdit = (record)=>{
        // Always set the editing record and open the drawer
        setEditingRecord(record);
        setIsEditDrawerOpen(true);
    };
    const handleDelete = (record)=>{
        setDeletingRecord(record);
        setIsDeleteDialogOpen(true);
    };
    const handleDeleteConfirm = ()=>{
        if (deletingRecord?.id) deleteMutation.mutate(deletingRecord.id);
    };
    const handleDeleteCancel = ()=>{
        setIsDeleteDialogOpen(false);
        setDeletingRecord(null);
    };
    return {
        // Data
        vehicleMediaList: vehicleMediaData?.vehicleMediaList || [],
        isLoading: isLoading,
        make: // Filter states
        make,
        setMake: setMake,
        model: model,
        setModel: setModel,
        year: year,
        setYear: setYear,
        trim: trim,
        setTrim: setTrim,
        isAddDrawerOpen: // Drawer states
        isAddDrawerOpen,
        setIsAddDrawerOpen: setIsAddDrawerOpen,
        isEditDrawerOpen: isEditDrawerOpen,
        setIsEditDrawerOpen: setIsEditDrawerOpen,
        editingRecord: editingRecord,
        setEditingRecord: setEditingRecord,
        isDeleteDialogOpen: // Delete modal states
        isDeleteDialogOpen,
        deletingRecord: deletingRecord,
        handleSearch: // Actions
        handleSearch,
        handleEdit: handleEdit,
        handleDelete: handleDelete,
        handleDeleteConfirm: handleDeleteConfirm,
        handleDeleteCancel: handleDeleteCancel,
        upsertMutation: upsertMutation,
        deleteMutation: deleteMutation
    };
};



parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");

var $6a0417a504da6745$export$915e9e7bd4f0f96d = function(s) {
    var t = s.as, a = s.errors, m = s.name, o = s.message, i = s.render, l = function(e, r) {
        if (null == e) return {};
        var n, s, t = {}, a = Object.keys(e);
        for(s = 0; s < a.length; s++)r.indexOf(n = a[s]) >= 0 || (t[n] = e[n]);
        return t;
    }(s, [
        "as",
        "errors",
        "name",
        "message",
        "render"
    ]), f = (0, $0d70f179cf56e662$export$4d957a5e1be13b03)(), c = (0, $0d70f179cf56e662$export$3988ae62b71be9a3)(a || f.formState.errors, m);
    if (!c) return null;
    var g = c.message, u = c.types, d = Object.assign({}, l, {
        children: g || o
    });
    return $acw62.isValidElement(t) ? $acw62.cloneElement(t, d) : i ? i({
        message: g || o,
        messages: u
    }) : $acw62.createElement(t || $acw62.Fragment, d);
};


const $a7f2a563d66a10b0$export$40e8430f3864eb9b = ({ errors: errors, control: control })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            mt: 3
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            container: true,
            spacing: 2,
            children: [
                typeof control?._formValues?.id !== 'undefined' && control._formValues.id !== null && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    style: {
                        display: 'none'
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        name: "id",
                        control: control,
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                ...field,
                                type: "hidden"
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12,
                        md: 6
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        name: "make",
                        control: control,
                        rules: {
                            required: 'Make is required'
                        },
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                ...field,
                                fullWidth: true,
                                label: "Make",
                                error: !!errors.make,
                                helperText: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a0417a504da6745$export$915e9e7bd4f0f96d), {
                                    errors: errors,
                                    name: "make"
                                })
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12,
                        md: 6
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        name: "model",
                        control: control,
                        rules: {
                            required: 'Model is required'
                        },
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                ...field,
                                fullWidth: true,
                                label: "Model",
                                error: !!errors.model,
                                helperText: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a0417a504da6745$export$915e9e7bd4f0f96d), {
                                    errors: errors,
                                    name: "model"
                                })
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12,
                        md: 6
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        name: "year",
                        control: control,
                        rules: {
                            required: 'Year is required',
                            min: {
                                value: 1900,
                                message: 'Year must be after 1900'
                            },
                            max: {
                                value: new Date().getFullYear() + 5,
                                message: 'Year cannot be too far in future'
                            }
                        },
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                ...field,
                                fullWidth: true,
                                label: "Year",
                                type: "number",
                                error: !!errors.year,
                                helperText: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a0417a504da6745$export$915e9e7bd4f0f96d), {
                                    errors: errors,
                                    name: "year"
                                })
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12,
                        md: 6
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        name: "trim",
                        control: control,
                        rules: {
                            required: 'Trim is required'
                        },
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                ...field,
                                fullWidth: true,
                                label: "Trim",
                                error: !!errors.trim,
                                helperText: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a0417a504da6745$export$915e9e7bd4f0f96d), {
                                    errors: errors,
                                    name: "trim"
                                })
                            })
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                        name: "data",
                        control: control,
                        rules: {
                            required: 'Data is required'
                        },
                        render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                ...field,
                                fullWidth: true,
                                label: "Data",
                                multiline: true,
                                rows: 4,
                                error: !!errors.data,
                                helperText: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6a0417a504da6745$export$915e9e7bd4f0f96d), {
                                    errors: errors,
                                    name: "data"
                                })
                            })
                    })
                })
            ]
        })
    });
};



const $9300ba81db24357b$export$e9224c7836f9484c = ()=>{
    const clientContext = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const clientId = clientContext?.clientId || '';
    const { vehicleMediaList: vehicleMediaList, isLoading: isLoading, make: // Filter states
    make, setMake: setMake, model: model, setModel: setModel, year: year, setYear: setYear, trim: trim, setTrim: setTrim, isAddDrawerOpen: // Drawer states
    isAddDrawerOpen, setIsAddDrawerOpen: setIsAddDrawerOpen, isEditDrawerOpen: isEditDrawerOpen, setIsEditDrawerOpen: setIsEditDrawerOpen, editingRecord: editingRecord, isDeleteDialogOpen: // Delete modal states
    isDeleteDialogOpen, deletingRecord: deletingRecord, handleSearch: // Actions
    handleSearch, handleEdit: handleEdit, handleDelete: handleDelete, handleDeleteConfirm: handleDeleteConfirm, handleDeleteCancel: handleDeleteCancel, upsertMutation: upsertMutation } = (0, $b901e94c01d5794a$export$623922d2761a272a)(clientId);
    const columns = [
        {
            field: 'make',
            headerName: 'Make',
            flex: 0.3
        },
        {
            field: 'model',
            headerName: 'Model',
            flex: 0.3
        },
        {
            field: 'trim',
            headerName: 'Trim',
            flex: 0.3
        },
        {
            field: 'year',
            headerName: 'Year',
            flex: 0.2
        },
        {
            field: 'data',
            headerName: 'Data',
            flex: 0.5
        },
        {
            field: 'created_at',
            headerName: 'Created At',
            flex: 0.3
        },
        {
            field: 'actions',
            headerName: 'Actions',
            flex: 0.2,
            sortable: false,
            renderCell: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        gap: 1
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                            size: "small",
                            onClick: ()=>handleEdit(params.row),
                            sx: {
                                color: 'primary.main'
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccd4473bf517ef36$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                            size: "small",
                            onClick: ()=>handleDelete(params.row),
                            sx: {
                                color: 'error.main'
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
        }
    ];
    const handleAddSave = (data)=>{
        upsertMutation.mutate(data);
    };
    const handleEditSave = (data)=>{
        if (editingRecord) upsertMutation.mutate({
            ...data
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $48a14f90dc08d980$export$89693000420c0acd), {
        heading: "Vehicle Media",
        headerHasBottomBorder: false,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                spacing: 3,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
                            sx: {
                                p: 3,
                                mb: 3
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                container: true,
                                spacing: 2,
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        size: {
                                            xs: 12,
                                            sm: 6,
                                            md: 3
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Make",
                                            value: make,
                                            onChange: (e)=>setMake(e.target.value),
                                            size: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        size: {
                                            xs: 12,
                                            sm: 6,
                                            md: 3
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Model",
                                            value: model,
                                            onChange: (e)=>setModel(e.target.value),
                                            size: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        size: {
                                            xs: 12,
                                            sm: 6,
                                            md: 2
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Year",
                                            type: "number",
                                            value: year,
                                            onChange: (e)=>setYear(e.target.value),
                                            size: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        size: {
                                            xs: 12,
                                            sm: 6,
                                            md: 2
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                            fullWidth: true,
                                            label: "Trim",
                                            value: trim,
                                            onChange: (e)=>setTrim(e.target.value),
                                            size: "small"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                        size: {
                                            xs: 12,
                                            sm: 6,
                                            md: 2
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                            variant: "contained",
                                            startIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $95f6704f80233608$export$2e2bcd8739ae039), {}),
                                            onClick: handleSearch,
                                            disabled: isLoading,
                                            fullWidth: true,
                                            children: isLoading ? 'Searching...' : 'Search'
                                        })
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    mb: 2
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "h6",
                                        children: "Vehicle Media Records"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                        variant: "contained",
                                        startIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed7b2b659b749647$export$2e2bcd8739ae039), {}),
                                        onClick: ()=>setIsAddDrawerOpen(true),
                                        children: "Add Vehicle Media"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                                    rows: vehicleMediaList || [],
                                    columns: columns,
                                    paginationModel: {
                                        page: 0,
                                        pageSize: 25
                                    },
                                    pageSizeOptions: [
                                        25,
                                        50,
                                        100
                                    ],
                                    loading: isLoading,
                                    autoHeight: true,
                                    getRowId: (row)=>row.id || `${row.make}-${row.model}-${row.trim}-${row.year}-${Date.now()}`
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                isDrawerOpen: isAddDrawerOpen,
                setIsDrawerOpen: setIsAddDrawerOpen,
                header: "Add Vehicle Media",
                handleSave: handleAddSave,
                form: (0, $a7f2a563d66a10b0$export$40e8430f3864eb9b),
                defaultValues: {
                    id: null,
                    make: '',
                    model: '',
                    trim: '',
                    year: new Date().getFullYear(),
                    data: ''
                }
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                isDrawerOpen: isEditDrawerOpen,
                setIsDrawerOpen: setIsEditDrawerOpen,
                header: "Edit Vehicle Media",
                handleSave: handleEditSave,
                form: (0, $a7f2a563d66a10b0$export$40e8430f3864eb9b),
                defaultValues: editingRecord
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
                open: isDeleteDialogOpen,
                onClose: handleDeleteCancel,
                "aria-labelledby": "delete-dialog-title",
                "aria-describedby": "delete-dialog-description",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                        id: "delete-dialog-title",
                        children: "Delete Vehicle Media"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b3200515d476ef1$export$2e2bcd8739ae039), {
                                id: "delete-dialog-description",
                                children: "Are you sure you would like to delete this record?"
                            }),
                            deletingRecord && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    mt: 2,
                                    p: 2,
                                    borderRadius: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Make:"
                                            }),
                                            " ",
                                            deletingRecord.make
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Model:"
                                            }),
                                            " ",
                                            deletingRecord.model
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Trim:"
                                            }),
                                            " ",
                                            deletingRecord.trim
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                children: "Year:"
                                            }),
                                            " ",
                                            deletingRecord.year
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                onClick: handleDeleteCancel,
                                variant: "outlined",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                onClick: handleDeleteConfirm,
                                autoFocus: true,
                                variant: "contained",
                                color: "secondary",
                                children: "Delete"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");




parcelRequire("acw62");


const $3d992edb82f5c3e3$var$ListVehicleCell = (props)=>{
    let { formattedValue: { vehicle: vehicle, isEligible: isEligible }, handler: handler } = props;
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    if (vehicle.vehicle) vehicle = vehicle.vehicle;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
        color: "secondary",
        onClick: ()=>{
            handler(vehicle);
        },
        variant: "contained",
        sx: {
            backgroundColor: themeColors.buttonColor,
            color: currentTheme === 'galpin' ? 'black' : 'white',
            '&:hover': {
                backgroundColor: themeColors.buttonHover
            }
        },
        children: isEligible ? 'Delist' : 'List'
    });
};
var $3d992edb82f5c3e3$export$2e2bcd8739ae039 = $3d992edb82f5c3e3$var$ListVehicleCell;



parcelRequire("acw62");






const $2992e39795c18a6c$export$9bdab767eeada07f = ({ open: open, onClose: onClose, listDelistMutation: listDelistMutation })=>{
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const onClickListDelist = async ()=>{
        try {
            await listDelistMutation.mutateAsync();
        } catch (error) {
            console.log('error', error);
        } finally{
            onClose();
            queryClient.invalidateQueries('getVehicles');
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
        open: open,
        onClose: onClose,
        TransitionComponent: (0, $64a991b625bf2127$export$2e2bcd8739ae039),
        sx: {
            minWidth: '20vw',
            padding: '15px 20px 20px 0'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                id: "dialog-title",
                children: "Would you like to list/delist this vehicle?"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        variant: "outlined",
                        onClick: onClose,
                        sx: {
                            borderColor: themeColors.buttonColor,
                            color: themeColors.buttonColor,
                            '&:hover': {
                                borderColor: themeColors.buttonHover,
                                color: themeColors.buttonHover
                            }
                        },
                        children: "Cancel"
                    }),
                    authState.isAuthenticated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        onClick: ()=>onClickListDelist(),
                        autoFocus: true,
                        variant: "contained",
                        color: "primary",
                        sx: {
                            backgroundColor: themeColors.buttonColor,
                            color: currentTheme === 'galpin' ? 'black' : 'white',
                            '&:hover': {
                                backgroundColor: themeColors.buttonHover
                            }
                        },
                        children: "yes"
                    })
                ]
            })
        ]
    });
};





parcelRequire("acw62");


$e5e982866f158f2e$export$2e2bcd8739ae039.propTypes = {
    isSelected: (0, (/*@__PURE__*/$parcel$interopDefault($8da5bfbbed271cd7$exports))).bool
};
$e5e982866f158f2e$export$2e2bcd8739ae039.defaultProps = {
    isSelected: false
};
function $e5e982866f158f2e$export$2e2bcd8739ae039({ isSelected: isSelected, ...otherProps }) {
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
        color: isSelected ? 'secondary' : 'primary',
        variant: isSelected ? 'contained' : 'outlined',
        size: "large",
        sx: {
            '&:not(:last-child)': {
                marginRight: '0.75rem'
            },
            ...isSelected && {
                backgroundColor: themeColors.buttonColor,
                color: currentTheme === 'galpin' ? 'black' : 'white',
                '&:hover': {
                    backgroundColor: themeColors.buttonHover
                }
            },
            ...!isSelected && {
                borderColor: themeColors.buttonColor,
                color: themeColors.buttonColor,
                '&:hover': {
                    borderColor: themeColors.buttonHover,
                    color: themeColors.buttonHover
                }
            }
        },
        ...otherProps
    });
}





parcelRequire("acw62");


const $84404855a4d2255b$var$VehicleDetailCell = (props)=>{
    const { id: id, from: from = 'listings' } = props;
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a), {
        to: `/view/${from}/${id}`,
        style: {
            textDecoration: 'none'
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
            color: "secondary",
            variant: "contained",
            sx: {
                backgroundColor: themeColors.buttonColor,
                color: currentTheme === 'galpin' ? 'black' : 'white',
                '&:hover': {
                    backgroundColor: themeColors.buttonHover
                }
            },
            children: "View"
        })
    });
};
var $84404855a4d2255b$export$2e2bcd8739ae039 = $84404855a4d2255b$var$VehicleDetailCell;




var $3EyMN = parcelRequire("3EyMN");

var $9YICB = parcelRequire("9YICB");

var $acw62 = parcelRequire("acw62");

var $f1q41 = parcelRequire("f1q41");



var $15d956139cf9d0d2$exports = {};
/* @preserve
 * The MIT License (MIT)
 * 
 * Copyright (c) 2013-2018 Petka Antonov
 * 
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.  IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 * 
 */ /**
 * bluebird build version 3.7.2
 * Features enabled: core, race, call_get, generators, map, nodeify, promisify, props, reduce, settle, some, using, timers, filter, any, each
*/ 
!function(e) {
    var f;
    $15d956139cf9d0d2$exports = e();
}(function() {
    var define, module1, exports;
    return (function e(t, n, r) {
        function s(o, u) {
            if (!n[o]) {
                if (!t[o]) {
                    var a = typeof _dereq_ == "function" && _dereq_;
                    if (!u && a) return a(o, !0);
                    if (i) return i(o, !0);
                    var f = new Error("Cannot find module '" + o + "'");
                    throw f.code = "MODULE_NOT_FOUND", f;
                }
                var l = n[o] = {
                    exports: {}
                };
                t[o][0].call(l.exports, function(e) {
                    var n = t[o][1][e];
                    return s(n ? n : e);
                }, l, l.exports, e, t, n, r);
            }
            return n[o].exports;
        }
        var i = typeof _dereq_ == "function" && _dereq_;
        for(var o = 0; o < r.length; o++)s(r[o]);
        return s;
    })({
        1: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var SomePromiseArray = Promise1._SomePromiseArray;
                    function any(promises) {
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(1);
                        ret.setUnwrap();
                        ret.init();
                        return promise;
                    }
                    Promise1.any = function(promises) {
                        return any(promises);
                    };
                    Promise1.prototype.any = function() {
                        return any(this);
                    };
                };
            },
            {}
        ],
        2: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var firstLineError;
                try {
                    throw new Error();
                } catch (e) {
                    firstLineError = e;
                }
                var schedule = _dereq_1("./schedule");
                var Queue = _dereq_1("./queue");
                function Async() {
                    this._customScheduler = false;
                    this._isTickUsed = false;
                    this._lateQueue = new Queue(16);
                    this._normalQueue = new Queue(16);
                    this._haveDrainedQueues = false;
                    var self1 = this;
                    this.drainQueues = function() {
                        self1._drainQueues();
                    };
                    this._schedule = schedule;
                }
                Async.prototype.setScheduler = function(fn) {
                    var prev = this._schedule;
                    this._schedule = fn;
                    this._customScheduler = true;
                    return prev;
                };
                Async.prototype.hasCustomScheduler = function() {
                    return this._customScheduler;
                };
                Async.prototype.haveItemsQueued = function() {
                    return this._isTickUsed || this._haveDrainedQueues;
                };
                Async.prototype.fatalError = function(e, isNode) {
                    if (isNode) {
                        $cfae44f0dfdf62c0$exports.stderr.write("Fatal " + (e instanceof Error ? e.stack : e) + "\n");
                        $cfae44f0dfdf62c0$exports.exit(2);
                    } else this.throwLater(e);
                };
                Async.prototype.throwLater = function(fn, arg) {
                    if (arguments.length === 1) {
                        arg = fn;
                        fn = function() {
                            throw arg;
                        };
                    }
                    if (typeof setTimeout !== "undefined") setTimeout(function() {
                        fn(arg);
                    }, 0);
                    else try {
                        this._schedule(function() {
                            fn(arg);
                        });
                    } catch (e) {
                        throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                    }
                };
                function AsyncInvokeLater(fn, receiver, arg) {
                    this._lateQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncInvoke(fn, receiver, arg) {
                    this._normalQueue.push(fn, receiver, arg);
                    this._queueTick();
                }
                function AsyncSettlePromises(promise) {
                    this._normalQueue._pushOne(promise);
                    this._queueTick();
                }
                Async.prototype.invokeLater = AsyncInvokeLater;
                Async.prototype.invoke = AsyncInvoke;
                Async.prototype.settlePromises = AsyncSettlePromises;
                function _drainQueue(queue) {
                    while(queue.length() > 0)_drainQueueStep(queue);
                }
                function _drainQueueStep(queue) {
                    var fn = queue.shift();
                    if (typeof fn !== "function") fn._settlePromises();
                    else {
                        var receiver = queue.shift();
                        var arg = queue.shift();
                        fn.call(receiver, arg);
                    }
                }
                Async.prototype._drainQueues = function() {
                    _drainQueue(this._normalQueue);
                    this._reset();
                    this._haveDrainedQueues = true;
                    _drainQueue(this._lateQueue);
                };
                Async.prototype._queueTick = function() {
                    if (!this._isTickUsed) {
                        this._isTickUsed = true;
                        this._schedule(this.drainQueues);
                    }
                };
                Async.prototype._reset = function() {
                    this._isTickUsed = false;
                };
                module1.exports = Async;
                module1.exports.firstLineError = firstLineError;
            },
            {
                "./queue": 26,
                "./schedule": 29
            }
        ],
        3: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, debug) {
                    var calledBind = false;
                    var rejectThis = function(_, e) {
                        this._reject(e);
                    };
                    var targetRejected = function(e, context) {
                        context.promiseRejectionQueued = true;
                        context.bindingPromise._then(rejectThis, rejectThis, null, this, e);
                    };
                    var bindingResolved = function(thisArg, context) {
                        if ((this._bitField & 50397184) === 0) this._resolveCallback(context.target);
                    };
                    var bindingRejected = function(e, context) {
                        if (!context.promiseRejectionQueued) this._reject(e);
                    };
                    Promise1.prototype.bind = function(thisArg) {
                        if (!calledBind) {
                            calledBind = true;
                            Promise1.prototype._propagateFrom = debug.propagateFromFunction();
                            Promise1.prototype._boundValue = debug.boundValueFunction();
                        }
                        var maybePromise = tryConvertToPromise(thisArg);
                        var ret = new Promise1(INTERNAL);
                        ret._propagateFrom(this, 1);
                        var target = this._target();
                        ret._setBoundTo(maybePromise);
                        if (maybePromise instanceof Promise1) {
                            var context = {
                                promiseRejectionQueued: false,
                                promise: ret,
                                target: target,
                                bindingPromise: maybePromise
                            };
                            target._then(INTERNAL, targetRejected, undefined, ret, context);
                            maybePromise._then(bindingResolved, bindingRejected, undefined, ret, context);
                            ret._setOnCancel(maybePromise);
                        } else ret._resolveCallback(target);
                        return ret;
                    };
                    Promise1.prototype._setBoundTo = function(obj) {
                        if (obj !== undefined) {
                            this._bitField = this._bitField | 2097152;
                            this._boundTo = obj;
                        } else this._bitField = this._bitField & -2097153;
                    };
                    Promise1.prototype._isBound = function() {
                        return (this._bitField & 2097152) === 2097152;
                    };
                    Promise1.bind = function(thisArg, value) {
                        return Promise1.resolve(value).bind(thisArg);
                    };
                };
            },
            {}
        ],
        4: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var old;
                if (typeof Promise !== "undefined") old = Promise;
                function noConflict() {
                    try {
                        if (Promise === bluebird) Promise = old;
                    } catch (e) {}
                    return bluebird;
                }
                var bluebird = _dereq_1("./promise")();
                bluebird.noConflict = noConflict;
                module1.exports = bluebird;
            },
            {
                "./promise": 22
            }
        ],
        5: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var cr = Object.create;
                if (cr) {
                    var callerCache = cr(null);
                    var getterCache = cr(null);
                    callerCache[" size"] = getterCache[" size"] = 0;
                }
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var isIdentifier = util.isIdentifier;
                    var getMethodCaller;
                    var getGetter;
                    var makeMethodCaller, makeGetter, getCompiled;
                    function ensureMethod(obj, methodName) {
                        var fn;
                        if (obj != null) fn = obj[methodName];
                        if (typeof fn !== "function") {
                            var message = "Object " + util.classString(obj) + " has no method '" + util.toString(methodName) + "'";
                            throw new Promise1.TypeError(message);
                        }
                        return fn;
                    }
                    function caller(obj) {
                        var methodName = this.pop();
                        var fn = ensureMethod(obj, methodName);
                        return fn.apply(obj, this);
                    }
                    Promise1.prototype.call = function(methodName) {
                        var args = [].slice.call(arguments, 1);
                        var maybeCaller;
                        args.push(methodName);
                        return this._then(caller, undefined, undefined, args, undefined);
                    };
                    function namedGetter(obj) {
                        return obj[this];
                    }
                    function indexedGetter(obj) {
                        var index = +this;
                        if (index < 0) index = Math.max(0, index + obj.length);
                        return obj[index];
                    }
                    Promise1.prototype.get = function(propertyName) {
                        var isIndex = typeof propertyName === "number";
                        var getter;
                        if (!isIndex) {
                            if (canEvaluate) {
                                var maybeGetter = getGetter(propertyName);
                                getter = maybeGetter !== null ? maybeGetter : namedGetter;
                            } else getter = namedGetter;
                        } else getter = indexedGetter;
                        return this._then(getter, undefined, undefined, propertyName, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        6: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    Promise1.prototype["break"] = Promise1.prototype.cancel = function() {
                        if (!debug.cancellation()) return this._warn("cancellation is disabled");
                        var promise = this;
                        var child = promise;
                        while(promise._isCancellable()){
                            if (!promise._cancelBy(child)) {
                                if (child._isFollowing()) child._followee().cancel();
                                else child._cancelBranched();
                                break;
                            }
                            var parent = promise._cancellationParent;
                            if (parent == null || !parent._isCancellable()) {
                                if (promise._isFollowing()) promise._followee().cancel();
                                else promise._cancelBranched();
                                break;
                            } else {
                                if (promise._isFollowing()) promise._followee().cancel();
                                promise._setWillBeCancelled();
                                child = promise;
                                promise = parent;
                            }
                        }
                    };
                    Promise1.prototype._branchHasCancelled = function() {
                        this._branchesRemainingToCancel--;
                    };
                    Promise1.prototype._enoughBranchesHaveCancelled = function() {
                        return this._branchesRemainingToCancel === undefined || this._branchesRemainingToCancel <= 0;
                    };
                    Promise1.prototype._cancelBy = function(canceller) {
                        if (canceller === this) {
                            this._branchesRemainingToCancel = 0;
                            this._invokeOnCancel();
                            return true;
                        } else {
                            this._branchHasCancelled();
                            if (this._enoughBranchesHaveCancelled()) {
                                this._invokeOnCancel();
                                return true;
                            }
                        }
                        return false;
                    };
                    Promise1.prototype._cancelBranched = function() {
                        if (this._enoughBranchesHaveCancelled()) this._cancel();
                    };
                    Promise1.prototype._cancel = function() {
                        if (!this._isCancellable()) return;
                        this._setCancelled();
                        async.invoke(this._cancelPromises, this, undefined);
                    };
                    Promise1.prototype._cancelPromises = function() {
                        if (this._length() > 0) this._settlePromises();
                    };
                    Promise1.prototype._unsetOnCancel = function() {
                        this._onCancelField = undefined;
                    };
                    Promise1.prototype._isCancellable = function() {
                        return this.isPending() && !this._isCancelled();
                    };
                    Promise1.prototype.isCancellable = function() {
                        return this.isPending() && !this.isCancelled();
                    };
                    Promise1.prototype._doInvokeOnCancel = function(onCancelCallback, internalOnly) {
                        if (util.isArray(onCancelCallback)) for(var i = 0; i < onCancelCallback.length; ++i)this._doInvokeOnCancel(onCancelCallback[i], internalOnly);
                        else if (onCancelCallback !== undefined) {
                            if (typeof onCancelCallback === "function") {
                                if (!internalOnly) {
                                    var e = tryCatch(onCancelCallback).call(this._boundValue());
                                    if (e === errorObj) {
                                        this._attachExtraTrace(e.e);
                                        async.throwLater(e.e);
                                    }
                                }
                            } else onCancelCallback._resultCancelled(this);
                        }
                    };
                    Promise1.prototype._invokeOnCancel = function() {
                        var onCancelCallback = this._onCancel();
                        this._unsetOnCancel();
                        async.invoke(this._doInvokeOnCancel, this, onCancelCallback);
                    };
                    Promise1.prototype._invokeInternalOnCancel = function() {
                        if (this._isCancellable()) {
                            this._doInvokeOnCancel(this._onCancel(), true);
                            this._unsetOnCancel();
                        }
                    };
                    Promise1.prototype._resultCancelled = function() {
                        this.cancel();
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        7: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var getKeys = _dereq_1("./es5").keys;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function catchFilter(instances, cb, promise) {
                        return function(e) {
                            var boundTo = promise._boundValue();
                            predicateLoop: for(var i = 0; i < instances.length; ++i){
                                var item = instances[i];
                                if (item === Error || item != null && item.prototype instanceof Error) {
                                    if (e instanceof item) return tryCatch(cb).call(boundTo, e);
                                } else if (typeof item === "function") {
                                    var matchesPredicate = tryCatch(item).call(boundTo, e);
                                    if (matchesPredicate === errorObj) return matchesPredicate;
                                    else if (matchesPredicate) return tryCatch(cb).call(boundTo, e);
                                } else if (util.isObject(e)) {
                                    var keys = getKeys(item);
                                    for(var j = 0; j < keys.length; ++j){
                                        var key = keys[j];
                                        if (item[key] != e[key]) continue predicateLoop;
                                    }
                                    return tryCatch(cb).call(boundTo, e);
                                }
                            }
                            return NEXT_FILTER;
                        };
                    }
                    return catchFilter;
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        8: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var longStackTraces = false;
                    var contextStack = [];
                    Promise1.prototype._promiseCreated = function() {};
                    Promise1.prototype._pushContext = function() {};
                    Promise1.prototype._popContext = function() {
                        return null;
                    };
                    Promise1._peekContext = Promise1.prototype._peekContext = function() {};
                    function Context() {
                        this._trace = new Context.CapturedTrace(peekContext());
                    }
                    Context.prototype._pushContext = function() {
                        if (this._trace !== undefined) {
                            this._trace._promiseCreated = null;
                            contextStack.push(this._trace);
                        }
                    };
                    Context.prototype._popContext = function() {
                        if (this._trace !== undefined) {
                            var trace = contextStack.pop();
                            var ret = trace._promiseCreated;
                            trace._promiseCreated = null;
                            return ret;
                        }
                        return null;
                    };
                    function createContext() {
                        if (longStackTraces) return new Context();
                    }
                    function peekContext() {
                        var lastIndex = contextStack.length - 1;
                        if (lastIndex >= 0) return contextStack[lastIndex];
                        return undefined;
                    }
                    Context.CapturedTrace = null;
                    Context.create = createContext;
                    Context.deactivateLongStackTraces = function() {};
                    Context.activateLongStackTraces = function() {
                        var Promise_pushContext = Promise1.prototype._pushContext;
                        var Promise_popContext = Promise1.prototype._popContext;
                        var Promise_PeekContext = Promise1._peekContext;
                        var Promise_peekContext = Promise1.prototype._peekContext;
                        var Promise_promiseCreated = Promise1.prototype._promiseCreated;
                        Context.deactivateLongStackTraces = function() {
                            Promise1.prototype._pushContext = Promise_pushContext;
                            Promise1.prototype._popContext = Promise_popContext;
                            Promise1._peekContext = Promise_PeekContext;
                            Promise1.prototype._peekContext = Promise_peekContext;
                            Promise1.prototype._promiseCreated = Promise_promiseCreated;
                            longStackTraces = false;
                        };
                        longStackTraces = true;
                        Promise1.prototype._pushContext = Context.prototype._pushContext;
                        Promise1.prototype._popContext = Context.prototype._popContext;
                        Promise1._peekContext = Promise1.prototype._peekContext = peekContext;
                        Promise1.prototype._promiseCreated = function() {
                            var ctx = this._peekContext();
                            if (ctx && ctx._promiseCreated == null) ctx._promiseCreated = this;
                        };
                    };
                    return Context;
                };
            },
            {}
        ],
        9: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, Context, enableAsyncHooks, disableAsyncHooks) {
                    var async = Promise1._async;
                    var Warning = _dereq_1("./errors").Warning;
                    var util = _dereq_1("./util");
                    var es5 = _dereq_1("./es5");
                    var canAttachTrace = util.canAttachTrace;
                    var unhandledRejectionHandled;
                    var possiblyUnhandledRejection;
                    var bluebirdFramePattern = /[\\\/]bluebird[\\\/]js[\\\/](release|debug|instrumented)/;
                    var nodeFramePattern = /\((?:timers\.js):\d+:\d+\)/;
                    var parseLinePattern = /[\/<\(](.+?):(\d+):(\d+)\)?\s*$/;
                    var stackFramePattern = null;
                    var formatStack = null;
                    var indentStackFrames = false;
                    var printWarning;
                    var debugging = !!(util.env("BLUEBIRD_DEBUG") != 0 && true);
                    var warnings = !!(util.env("BLUEBIRD_WARNINGS") != 0 && (debugging || util.env("BLUEBIRD_WARNINGS")));
                    var longStackTraces = !!(util.env("BLUEBIRD_LONG_STACK_TRACES") != 0 && (debugging || util.env("BLUEBIRD_LONG_STACK_TRACES")));
                    var wForgottenReturn = util.env("BLUEBIRD_W_FORGOTTEN_RETURN") != 0 && (warnings || !!util.env("BLUEBIRD_W_FORGOTTEN_RETURN"));
                    var deferUnhandledRejectionCheck;
                    (function() {
                        var promises = [];
                        function unhandledRejectionCheck() {
                            for(var i = 0; i < promises.length; ++i)promises[i]._notifyUnhandledRejection();
                            unhandledRejectionClear();
                        }
                        function unhandledRejectionClear() {
                            promises.length = 0;
                        }
                        deferUnhandledRejectionCheck = function(promise) {
                            promises.push(promise);
                            setTimeout(unhandledRejectionCheck, 1);
                        };
                        es5.defineProperty(Promise1, "_unhandledRejectionCheck", {
                            value: unhandledRejectionCheck
                        });
                        es5.defineProperty(Promise1, "_unhandledRejectionClear", {
                            value: unhandledRejectionClear
                        });
                    })();
                    Promise1.prototype.suppressUnhandledRejections = function() {
                        var target = this._target();
                        target._bitField = target._bitField & -1048577 | 524288;
                    };
                    Promise1.prototype._ensurePossibleRejectionHandled = function() {
                        if ((this._bitField & 524288) !== 0) return;
                        this._setRejectionIsUnhandled();
                        deferUnhandledRejectionCheck(this);
                    };
                    Promise1.prototype._notifyUnhandledRejectionIsHandled = function() {
                        fireRejectionEvent("rejectionHandled", unhandledRejectionHandled, undefined, this);
                    };
                    Promise1.prototype._setReturnedNonUndefined = function() {
                        this._bitField = this._bitField | 268435456;
                    };
                    Promise1.prototype._returnedNonUndefined = function() {
                        return (this._bitField & 268435456) !== 0;
                    };
                    Promise1.prototype._notifyUnhandledRejection = function() {
                        if (this._isRejectionUnhandled()) {
                            var reason = this._settledValue();
                            this._setUnhandledRejectionIsNotified();
                            fireRejectionEvent("unhandledRejection", possiblyUnhandledRejection, reason, this);
                        }
                    };
                    Promise1.prototype._setUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField | 262144;
                    };
                    Promise1.prototype._unsetUnhandledRejectionIsNotified = function() {
                        this._bitField = this._bitField & -262145;
                    };
                    Promise1.prototype._isUnhandledRejectionNotified = function() {
                        return (this._bitField & 262144) > 0;
                    };
                    Promise1.prototype._setRejectionIsUnhandled = function() {
                        this._bitField = this._bitField | 1048576;
                    };
                    Promise1.prototype._unsetRejectionIsUnhandled = function() {
                        this._bitField = this._bitField & -1048577;
                        if (this._isUnhandledRejectionNotified()) {
                            this._unsetUnhandledRejectionIsNotified();
                            this._notifyUnhandledRejectionIsHandled();
                        }
                    };
                    Promise1.prototype._isRejectionUnhandled = function() {
                        return (this._bitField & 1048576) > 0;
                    };
                    Promise1.prototype._warn = function(message, shouldUseOwnTrace, promise) {
                        return warn(message, shouldUseOwnTrace, promise || this);
                    };
                    Promise1.onPossiblyUnhandledRejection = function(fn) {
                        var context = Promise1._getContext();
                        possiblyUnhandledRejection = util.contextBind(context, fn);
                    };
                    Promise1.onUnhandledRejectionHandled = function(fn) {
                        var context = Promise1._getContext();
                        unhandledRejectionHandled = util.contextBind(context, fn);
                    };
                    var disableLongStackTraces = function() {};
                    Promise1.longStackTraces = function() {
                        if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        if (!config.longStackTraces && longStackTracesIsSupported()) {
                            var Promise_captureStackTrace = Promise1.prototype._captureStackTrace;
                            var Promise_attachExtraTrace = Promise1.prototype._attachExtraTrace;
                            var Promise_dereferenceTrace = Promise1.prototype._dereferenceTrace;
                            config.longStackTraces = true;
                            disableLongStackTraces = function() {
                                if (async.haveItemsQueued() && !config.longStackTraces) throw new Error("cannot enable long stack traces after promises have been created\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                                Promise1.prototype._captureStackTrace = Promise_captureStackTrace;
                                Promise1.prototype._attachExtraTrace = Promise_attachExtraTrace;
                                Promise1.prototype._dereferenceTrace = Promise_dereferenceTrace;
                                Context.deactivateLongStackTraces();
                                config.longStackTraces = false;
                            };
                            Promise1.prototype._captureStackTrace = longStackTracesCaptureStackTrace;
                            Promise1.prototype._attachExtraTrace = longStackTracesAttachExtraTrace;
                            Promise1.prototype._dereferenceTrace = longStackTracesDereferenceTrace;
                            Context.activateLongStackTraces();
                        }
                    };
                    Promise1.hasLongStackTraces = function() {
                        return config.longStackTraces && longStackTracesIsSupported();
                    };
                    var legacyHandlers = {
                        unhandledrejection: {
                            before: function() {
                                var ret = util.global.onunhandledrejection;
                                util.global.onunhandledrejection = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onunhandledrejection = fn;
                            }
                        },
                        rejectionhandled: {
                            before: function() {
                                var ret = util.global.onrejectionhandled;
                                util.global.onrejectionhandled = null;
                                return ret;
                            },
                            after: function(fn) {
                                util.global.onrejectionhandled = fn;
                            }
                        }
                    };
                    var fireDomEvent = function() {
                        var dispatch = function(legacy, e) {
                            if (legacy) {
                                var fn;
                                try {
                                    fn = legacy.before();
                                    return !util.global.dispatchEvent(e);
                                } finally{
                                    legacy.after(fn);
                                }
                            } else return !util.global.dispatchEvent(e);
                        };
                        try {
                            if (typeof CustomEvent === "function") {
                                var event = new CustomEvent("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var eventData = {
                                        detail: event,
                                        cancelable: true
                                    };
                                    var domEvent = new CustomEvent(name, eventData);
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else if (typeof Event === "function") {
                                var event = new Event("CustomEvent");
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = new Event(name, {
                                        cancelable: true
                                    });
                                    domEvent.detail = event;
                                    es5.defineProperty(domEvent, "promise", {
                                        value: event.promise
                                    });
                                    es5.defineProperty(domEvent, "reason", {
                                        value: event.reason
                                    });
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            } else {
                                var event = document.createEvent("CustomEvent");
                                event.initCustomEvent("testingtheevent", false, true, {});
                                util.global.dispatchEvent(event);
                                return function(name, event) {
                                    name = name.toLowerCase();
                                    var domEvent = document.createEvent("CustomEvent");
                                    domEvent.initCustomEvent(name, false, true, event);
                                    return dispatch(legacyHandlers[name], domEvent);
                                };
                            }
                        } catch (e) {}
                        return function() {
                            return false;
                        };
                    }();
                    var fireGlobalEvent = function() {
                        if (util.isNode) return function() {
                            return $cfae44f0dfdf62c0$exports.emit.apply($cfae44f0dfdf62c0$exports, arguments);
                        };
                        else {
                            if (!util.global) return function() {
                                return false;
                            };
                            return function(name) {
                                var methodName = "on" + name.toLowerCase();
                                var method = util.global[methodName];
                                if (!method) return false;
                                method.apply(util.global, [].slice.call(arguments, 1));
                                return true;
                            };
                        }
                    }();
                    function generatePromiseLifecycleEventObject(name, promise) {
                        return {
                            promise: promise
                        };
                    }
                    var eventToObjectGenerator = {
                        promiseCreated: generatePromiseLifecycleEventObject,
                        promiseFulfilled: generatePromiseLifecycleEventObject,
                        promiseRejected: generatePromiseLifecycleEventObject,
                        promiseResolved: generatePromiseLifecycleEventObject,
                        promiseCancelled: generatePromiseLifecycleEventObject,
                        promiseChained: function(name, promise, child) {
                            return {
                                promise: promise,
                                child: child
                            };
                        },
                        warning: function(name, warning) {
                            return {
                                warning: warning
                            };
                        },
                        unhandledRejection: function(name, reason, promise) {
                            return {
                                reason: reason,
                                promise: promise
                            };
                        },
                        rejectionHandled: generatePromiseLifecycleEventObject
                    };
                    var activeFireEvent = function(name) {
                        var globalEventFired = false;
                        try {
                            globalEventFired = fireGlobalEvent.apply(null, arguments);
                        } catch (e) {
                            async.throwLater(e);
                            globalEventFired = true;
                        }
                        var domEventFired = false;
                        try {
                            domEventFired = fireDomEvent(name, eventToObjectGenerator[name].apply(null, arguments));
                        } catch (e) {
                            async.throwLater(e);
                            domEventFired = true;
                        }
                        return domEventFired || globalEventFired;
                    };
                    Promise1.config = function(opts) {
                        opts = Object(opts);
                        if ("longStackTraces" in opts) {
                            if (opts.longStackTraces) Promise1.longStackTraces();
                            else if (!opts.longStackTraces && Promise1.hasLongStackTraces()) disableLongStackTraces();
                        }
                        if ("warnings" in opts) {
                            var warningsOption = opts.warnings;
                            config.warnings = !!warningsOption;
                            wForgottenReturn = config.warnings;
                            if (util.isObject(warningsOption)) {
                                if ("wForgottenReturn" in warningsOption) wForgottenReturn = !!warningsOption.wForgottenReturn;
                            }
                        }
                        if ("cancellation" in opts && opts.cancellation && !config.cancellation) {
                            if (async.haveItemsQueued()) throw new Error("cannot enable cancellation after promises are in use");
                            Promise1.prototype._clearCancellationData = cancellationClearCancellationData;
                            Promise1.prototype._propagateFrom = cancellationPropagateFrom;
                            Promise1.prototype._onCancel = cancellationOnCancel;
                            Promise1.prototype._setOnCancel = cancellationSetOnCancel;
                            Promise1.prototype._attachCancellationCallback = cancellationAttachCancellationCallback;
                            Promise1.prototype._execute = cancellationExecute;
                            propagateFromFunction = cancellationPropagateFrom;
                            config.cancellation = true;
                        }
                        if ("monitoring" in opts) {
                            if (opts.monitoring && !config.monitoring) {
                                config.monitoring = true;
                                Promise1.prototype._fireEvent = activeFireEvent;
                            } else if (!opts.monitoring && config.monitoring) {
                                config.monitoring = false;
                                Promise1.prototype._fireEvent = defaultFireEvent;
                            }
                        }
                        if ("asyncHooks" in opts && util.nodeSupportsAsyncResource) {
                            var prev = config.asyncHooks;
                            var cur = !!opts.asyncHooks;
                            if (prev !== cur) {
                                config.asyncHooks = cur;
                                if (cur) enableAsyncHooks();
                                else disableAsyncHooks();
                            }
                        }
                        return Promise1;
                    };
                    function defaultFireEvent() {
                        return false;
                    }
                    Promise1.prototype._fireEvent = defaultFireEvent;
                    Promise1.prototype._execute = function(executor, resolve, reject) {
                        try {
                            executor(resolve, reject);
                        } catch (e) {
                            return e;
                        }
                    };
                    Promise1.prototype._onCancel = function() {};
                    Promise1.prototype._setOnCancel = function(handler) {};
                    Promise1.prototype._attachCancellationCallback = function(onCancel) {};
                    Promise1.prototype._captureStackTrace = function() {};
                    Promise1.prototype._attachExtraTrace = function() {};
                    Promise1.prototype._dereferenceTrace = function() {};
                    Promise1.prototype._clearCancellationData = function() {};
                    Promise1.prototype._propagateFrom = function(parent, flags) {};
                    function cancellationExecute(executor, resolve, reject) {
                        var promise = this;
                        try {
                            executor(resolve, reject, function(onCancel) {
                                if (typeof onCancel !== "function") throw new TypeError("onCancel must be a function, got: " + util.toString(onCancel));
                                promise._attachCancellationCallback(onCancel);
                            });
                        } catch (e) {
                            return e;
                        }
                    }
                    function cancellationAttachCancellationCallback(onCancel) {
                        if (!this._isCancellable()) return this;
                        var previousOnCancel = this._onCancel();
                        if (previousOnCancel !== undefined) {
                            if (util.isArray(previousOnCancel)) previousOnCancel.push(onCancel);
                            else this._setOnCancel([
                                previousOnCancel,
                                onCancel
                            ]);
                        } else this._setOnCancel(onCancel);
                    }
                    function cancellationOnCancel() {
                        return this._onCancelField;
                    }
                    function cancellationSetOnCancel(onCancel) {
                        this._onCancelField = onCancel;
                    }
                    function cancellationClearCancellationData() {
                        this._cancellationParent = undefined;
                        this._onCancelField = undefined;
                    }
                    function cancellationPropagateFrom(parent, flags) {
                        if ((flags & 1) !== 0) {
                            this._cancellationParent = parent;
                            var branchesRemainingToCancel = parent._branchesRemainingToCancel;
                            if (branchesRemainingToCancel === undefined) branchesRemainingToCancel = 0;
                            parent._branchesRemainingToCancel = branchesRemainingToCancel + 1;
                        }
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    function bindingPropagateFrom(parent, flags) {
                        if ((flags & 2) !== 0 && parent._isBound()) this._setBoundTo(parent._boundTo);
                    }
                    var propagateFromFunction = bindingPropagateFrom;
                    function boundValueFunction() {
                        var ret = this._boundTo;
                        if (ret !== undefined) {
                            if (ret instanceof Promise1) {
                                if (ret.isFulfilled()) return ret.value();
                                else return undefined;
                            }
                        }
                        return ret;
                    }
                    function longStackTracesCaptureStackTrace() {
                        this._trace = new CapturedTrace(this._peekContext());
                    }
                    function longStackTracesAttachExtraTrace(error, ignoreSelf) {
                        if (canAttachTrace(error)) {
                            var trace = this._trace;
                            if (trace !== undefined) {
                                if (ignoreSelf) trace = trace._parent;
                            }
                            if (trace !== undefined) trace.attachExtraTrace(error);
                            else if (!error.__stackCleaned__) {
                                var parsed = parseStackAndMessage(error);
                                util.notEnumerableProp(error, "stack", parsed.message + "\n" + parsed.stack.join("\n"));
                                util.notEnumerableProp(error, "__stackCleaned__", true);
                            }
                        }
                    }
                    function longStackTracesDereferenceTrace() {
                        this._trace = undefined;
                    }
                    function checkForgottenReturns(returnValue, promiseCreated, name, promise, parent) {
                        if (returnValue === undefined && promiseCreated !== null && wForgottenReturn) {
                            if (parent !== undefined && parent._returnedNonUndefined()) return;
                            if ((promise._bitField & 65535) === 0) return;
                            if (name) name = name + " ";
                            var handlerLine = "";
                            var creatorLine = "";
                            if (promiseCreated._trace) {
                                var traceLines = promiseCreated._trace.stack.split("\n");
                                var stack = cleanStack(traceLines);
                                for(var i = stack.length - 1; i >= 0; --i){
                                    var line = stack[i];
                                    if (!nodeFramePattern.test(line)) {
                                        var lineMatches = line.match(parseLinePattern);
                                        if (lineMatches) handlerLine = "at " + lineMatches[1] + ":" + lineMatches[2] + ":" + lineMatches[3] + " ";
                                        break;
                                    }
                                }
                                if (stack.length > 0) {
                                    var firstUserLine = stack[0];
                                    for(var i = 0; i < traceLines.length; ++i)if (traceLines[i] === firstUserLine) {
                                        if (i > 0) creatorLine = "\n" + traceLines[i - 1];
                                        break;
                                    }
                                }
                            }
                            var msg = "a promise was created in a " + name + "handler " + handlerLine + "but was not returned from it, " + "see http://goo.gl/rRqMUw" + creatorLine;
                            promise._warn(msg, true, promiseCreated);
                        }
                    }
                    function deprecated(name, replacement) {
                        var message = name + " is deprecated and will be removed in a future version.";
                        if (replacement) message += " Use " + replacement + " instead.";
                        return warn(message);
                    }
                    function warn(message, shouldUseOwnTrace, promise) {
                        if (!config.warnings) return;
                        var warning = new Warning(message);
                        var ctx;
                        if (shouldUseOwnTrace) promise._attachExtraTrace(warning);
                        else if (config.longStackTraces && (ctx = Promise1._peekContext())) ctx.attachExtraTrace(warning);
                        else {
                            var parsed = parseStackAndMessage(warning);
                            warning.stack = parsed.message + "\n" + parsed.stack.join("\n");
                        }
                        if (!activeFireEvent("warning", warning)) formatAndLogError(warning, "", true);
                    }
                    function reconstructStack(message, stacks) {
                        for(var i = 0; i < stacks.length - 1; ++i){
                            stacks[i].push("From previous event:");
                            stacks[i] = stacks[i].join("\n");
                        }
                        if (i < stacks.length) stacks[i] = stacks[i].join("\n");
                        return message + "\n" + stacks.join("\n");
                    }
                    function removeDuplicateOrEmptyJumps(stacks) {
                        for(var i = 0; i < stacks.length; ++i)if (stacks[i].length === 0 || i + 1 < stacks.length && stacks[i][0] === stacks[i + 1][0]) {
                            stacks.splice(i, 1);
                            i--;
                        }
                    }
                    function removeCommonRoots(stacks) {
                        var current = stacks[0];
                        for(var i = 1; i < stacks.length; ++i){
                            var prev = stacks[i];
                            var currentLastIndex = current.length - 1;
                            var currentLastLine = current[currentLastIndex];
                            var commonRootMeetPoint = -1;
                            for(var j = prev.length - 1; j >= 0; --j)if (prev[j] === currentLastLine) {
                                commonRootMeetPoint = j;
                                break;
                            }
                            for(var j = commonRootMeetPoint; j >= 0; --j){
                                var line = prev[j];
                                if (current[currentLastIndex] === line) {
                                    current.pop();
                                    currentLastIndex--;
                                } else break;
                            }
                            current = prev;
                        }
                    }
                    function cleanStack(stack) {
                        var ret = [];
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            var isTraceLine = "    (No stack trace)" === line || stackFramePattern.test(line);
                            var isInternalFrame = isTraceLine && shouldIgnore(line);
                            if (isTraceLine && !isInternalFrame) {
                                if (indentStackFrames && line.charAt(0) !== " ") line = "    " + line;
                                ret.push(line);
                            }
                        }
                        return ret;
                    }
                    function stackFramesAsArray(error) {
                        var stack = error.stack.replace(/\s+$/g, "").split("\n");
                        for(var i = 0; i < stack.length; ++i){
                            var line = stack[i];
                            if ("    (No stack trace)" === line || stackFramePattern.test(line)) break;
                        }
                        if (i > 0 && error.name != "SyntaxError") stack = stack.slice(i);
                        return stack;
                    }
                    function parseStackAndMessage(error) {
                        var stack = error.stack;
                        var message = error.toString();
                        stack = typeof stack === "string" && stack.length > 0 ? stackFramesAsArray(error) : [
                            "    (No stack trace)"
                        ];
                        return {
                            message: message,
                            stack: error.name == "SyntaxError" ? stack : cleanStack(stack)
                        };
                    }
                    function formatAndLogError(error, title, isSoft) {
                        if (typeof console !== "undefined") {
                            var message;
                            if (util.isObject(error)) {
                                var stack = error.stack;
                                message = title + formatStack(stack, error);
                            } else message = title + String(error);
                            if (typeof printWarning === "function") printWarning(message, isSoft);
                            else if (typeof console.log === "function" || typeof console.log === "object") console.log(message);
                        }
                    }
                    function fireRejectionEvent(name, localHandler, reason, promise) {
                        var localEventFired = false;
                        try {
                            if (typeof localHandler === "function") {
                                localEventFired = true;
                                if (name === "rejectionHandled") localHandler(promise);
                                else localHandler(reason, promise);
                            }
                        } catch (e) {
                            async.throwLater(e);
                        }
                        if (name === "unhandledRejection") {
                            if (!activeFireEvent(name, reason, promise) && !localEventFired) formatAndLogError(reason, "Unhandled rejection ");
                        } else activeFireEvent(name, promise);
                    }
                    function formatNonError(obj) {
                        var str;
                        if (typeof obj === "function") str = "[function " + (obj.name || "anonymous") + "]";
                        else {
                            str = obj && typeof obj.toString === "function" ? obj.toString() : util.toString(obj);
                            var ruselessToString = /\[object [a-zA-Z0-9$_]+\]/;
                            if (ruselessToString.test(str)) try {
                                var newStr = JSON.stringify(obj);
                                str = newStr;
                            } catch (e) {}
                            if (str.length === 0) str = "(empty array)";
                        }
                        return "(<" + snip(str) + ">, no stack trace)";
                    }
                    function snip(str) {
                        var maxChars = 41;
                        if (str.length < maxChars) return str;
                        return str.substr(0, maxChars - 3) + "...";
                    }
                    function longStackTracesIsSupported() {
                        return typeof captureStackTrace === "function";
                    }
                    var shouldIgnore = function() {
                        return false;
                    };
                    var parseLineInfoRegex = /[\/<\(]([^:\/]+):(\d+):(?:\d+)\)?\s*$/;
                    function parseLineInfo(line) {
                        var matches = line.match(parseLineInfoRegex);
                        if (matches) return {
                            fileName: matches[1],
                            line: parseInt(matches[2], 10)
                        };
                    }
                    function setBounds(firstLineError, lastLineError) {
                        if (!longStackTracesIsSupported()) return;
                        var firstStackLines = (firstLineError.stack || "").split("\n");
                        var lastStackLines = (lastLineError.stack || "").split("\n");
                        var firstIndex = -1;
                        var lastIndex = -1;
                        var firstFileName;
                        var lastFileName;
                        for(var i = 0; i < firstStackLines.length; ++i){
                            var result = parseLineInfo(firstStackLines[i]);
                            if (result) {
                                firstFileName = result.fileName;
                                firstIndex = result.line;
                                break;
                            }
                        }
                        for(var i = 0; i < lastStackLines.length; ++i){
                            var result = parseLineInfo(lastStackLines[i]);
                            if (result) {
                                lastFileName = result.fileName;
                                lastIndex = result.line;
                                break;
                            }
                        }
                        if (firstIndex < 0 || lastIndex < 0 || !firstFileName || !lastFileName || firstFileName !== lastFileName || firstIndex >= lastIndex) return;
                        shouldIgnore = function(line) {
                            if (bluebirdFramePattern.test(line)) return true;
                            var info = parseLineInfo(line);
                            if (info) {
                                if (info.fileName === firstFileName && firstIndex <= info.line && info.line <= lastIndex) return true;
                            }
                            return false;
                        };
                    }
                    function CapturedTrace(parent) {
                        this._parent = parent;
                        this._promisesCreated = 0;
                        var length = this._length = 1 + (parent === undefined ? 0 : parent._length);
                        captureStackTrace(this, CapturedTrace);
                        if (length > 32) this.uncycle();
                    }
                    util.inherits(CapturedTrace, Error);
                    Context.CapturedTrace = CapturedTrace;
                    CapturedTrace.prototype.uncycle = function() {
                        var length = this._length;
                        if (length < 2) return;
                        var nodes = [];
                        var stackToIndex = {};
                        for(var i = 0, node = this; node !== undefined; ++i){
                            nodes.push(node);
                            node = node._parent;
                        }
                        length = this._length = i;
                        for(var i = length - 1; i >= 0; --i){
                            var stack = nodes[i].stack;
                            if (stackToIndex[stack] === undefined) stackToIndex[stack] = i;
                        }
                        for(var i = 0; i < length; ++i){
                            var currentStack = nodes[i].stack;
                            var index = stackToIndex[currentStack];
                            if (index !== undefined && index !== i) {
                                if (index > 0) {
                                    nodes[index - 1]._parent = undefined;
                                    nodes[index - 1]._length = 1;
                                }
                                nodes[i]._parent = undefined;
                                nodes[i]._length = 1;
                                var cycleEdgeNode = i > 0 ? nodes[i - 1] : this;
                                if (index < length - 1) {
                                    cycleEdgeNode._parent = nodes[index + 1];
                                    cycleEdgeNode._parent.uncycle();
                                    cycleEdgeNode._length = cycleEdgeNode._parent._length + 1;
                                } else {
                                    cycleEdgeNode._parent = undefined;
                                    cycleEdgeNode._length = 1;
                                }
                                var currentChildLength = cycleEdgeNode._length + 1;
                                for(var j = i - 2; j >= 0; --j){
                                    nodes[j]._length = currentChildLength;
                                    currentChildLength++;
                                }
                                return;
                            }
                        }
                    };
                    CapturedTrace.prototype.attachExtraTrace = function(error) {
                        if (error.__stackCleaned__) return;
                        this.uncycle();
                        var parsed = parseStackAndMessage(error);
                        var message = parsed.message;
                        var stacks = [
                            parsed.stack
                        ];
                        var trace = this;
                        while(trace !== undefined){
                            stacks.push(cleanStack(trace.stack.split("\n")));
                            trace = trace._parent;
                        }
                        removeCommonRoots(stacks);
                        removeDuplicateOrEmptyJumps(stacks);
                        util.notEnumerableProp(error, "stack", reconstructStack(message, stacks));
                        util.notEnumerableProp(error, "__stackCleaned__", true);
                    };
                    var captureStackTrace = function stackDetection() {
                        var v8stackFramePattern = /^\s*at\s*/;
                        var v8stackFormatter = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if (error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        if (typeof Error.stackTraceLimit === "number" && typeof Error.captureStackTrace === "function") {
                            Error.stackTraceLimit += 6;
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            var captureStackTrace = Error.captureStackTrace;
                            shouldIgnore = function(line) {
                                return bluebirdFramePattern.test(line);
                            };
                            return function(receiver, ignoreUntil) {
                                Error.stackTraceLimit += 6;
                                captureStackTrace(receiver, ignoreUntil);
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        var err = new Error();
                        if (typeof err.stack === "string" && err.stack.split("\n")[0].indexOf("stackDetection@") >= 0) {
                            stackFramePattern = /@/;
                            formatStack = v8stackFormatter;
                            indentStackFrames = true;
                            return function captureStackTrace(o) {
                                o.stack = new Error().stack;
                            };
                        }
                        var hasStackAfterThrow;
                        try {
                            throw new Error();
                        } catch (e) {
                            hasStackAfterThrow = "stack" in e;
                        }
                        if (!("stack" in err) && hasStackAfterThrow && typeof Error.stackTraceLimit === "number") {
                            stackFramePattern = v8stackFramePattern;
                            formatStack = v8stackFormatter;
                            return function captureStackTrace(o) {
                                Error.stackTraceLimit += 6;
                                try {
                                    throw new Error();
                                } catch (e) {
                                    o.stack = e.stack;
                                }
                                Error.stackTraceLimit -= 6;
                            };
                        }
                        formatStack = function(stack, error) {
                            if (typeof stack === "string") return stack;
                            if ((typeof error === "object" || typeof error === "function") && error.name !== undefined && error.message !== undefined) return error.toString();
                            return formatNonError(error);
                        };
                        return null;
                    }([]);
                    if (typeof console !== "undefined" && typeof console.warn !== "undefined") {
                        printWarning = function(message) {
                            console.warn(message);
                        };
                        if (util.isNode && $cfae44f0dfdf62c0$exports.stderr.isTTY) printWarning = function(message, isSoft) {
                            var color = isSoft ? "\u001b[33m" : "\u001b[31m";
                            console.warn(color + message + "\u001b[0m\n");
                        };
                        else if (!util.isNode && typeof new Error().stack === "string") printWarning = function(message, isSoft) {
                            console.warn("%c" + message, isSoft ? "color: darkorange" : "color: red");
                        };
                    }
                    var config = {
                        warnings: warnings,
                        longStackTraces: false,
                        cancellation: false,
                        monitoring: false,
                        asyncHooks: false
                    };
                    if (longStackTraces) Promise1.longStackTraces();
                    return {
                        asyncHooks: function() {
                            return config.asyncHooks;
                        },
                        longStackTraces: function() {
                            return config.longStackTraces;
                        },
                        warnings: function() {
                            return config.warnings;
                        },
                        cancellation: function() {
                            return config.cancellation;
                        },
                        monitoring: function() {
                            return config.monitoring;
                        },
                        propagateFromFunction: function() {
                            return propagateFromFunction;
                        },
                        boundValueFunction: function() {
                            return boundValueFunction;
                        },
                        checkForgottenReturns: checkForgottenReturns,
                        setBounds: setBounds,
                        warn: warn,
                        deprecated: deprecated,
                        CapturedTrace: CapturedTrace,
                        fireDomEvent: fireDomEvent,
                        fireGlobalEvent: fireGlobalEvent
                    };
                };
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        10: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function returner() {
                        return this.value;
                    }
                    function thrower() {
                        throw this.reason;
                    }
                    Promise1.prototype["return"] = Promise1.prototype.thenReturn = function(value) {
                        if (value instanceof Promise1) value.suppressUnhandledRejections();
                        return this._then(returner, undefined, undefined, {
                            value: value
                        }, undefined);
                    };
                    Promise1.prototype["throw"] = Promise1.prototype.thenThrow = function(reason) {
                        return this._then(thrower, undefined, undefined, {
                            reason: reason
                        }, undefined);
                    };
                    Promise1.prototype.catchThrow = function(reason) {
                        if (arguments.length <= 1) return this._then(undefined, thrower, undefined, {
                            reason: reason
                        }, undefined);
                        else {
                            var _reason = arguments[1];
                            var handler = function() {
                                throw _reason;
                            };
                            return this.caught(reason, handler);
                        }
                    };
                    Promise1.prototype.catchReturn = function(value) {
                        if (arguments.length <= 1) {
                            if (value instanceof Promise1) value.suppressUnhandledRejections();
                            return this._then(undefined, returner, undefined, {
                                value: value
                            }, undefined);
                        } else {
                            var _value = arguments[1];
                            if (_value instanceof Promise1) _value.suppressUnhandledRejections();
                            var handler = function() {
                                return _value;
                            };
                            return this.caught(value, handler);
                        }
                    };
                };
            },
            {}
        ],
        11: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseReduce = Promise1.reduce;
                    var PromiseAll = Promise1.all;
                    function promiseAllThis() {
                        return PromiseAll(this);
                    }
                    function PromiseMapSeries(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, INTERNAL);
                    }
                    Promise1.prototype.each = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, this, undefined);
                    };
                    Promise1.prototype.mapSeries = function(fn) {
                        return PromiseReduce(this, fn, INTERNAL, INTERNAL);
                    };
                    Promise1.each = function(promises, fn) {
                        return PromiseReduce(promises, fn, INTERNAL, 0)._then(promiseAllThis, undefined, undefined, promises, undefined);
                    };
                    Promise1.mapSeries = PromiseMapSeries;
                };
            },
            {}
        ],
        12: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var Objectfreeze = es5.freeze;
                var util = _dereq_1("./util");
                var inherits = util.inherits;
                var notEnumerableProp = util.notEnumerableProp;
                function subError(nameProperty, defaultMessage) {
                    function SubError(message) {
                        if (!(this instanceof SubError)) return new SubError(message);
                        notEnumerableProp(this, "message", typeof message === "string" ? message : defaultMessage);
                        notEnumerableProp(this, "name", nameProperty);
                        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                        else Error.call(this);
                    }
                    inherits(SubError, Error);
                    return SubError;
                }
                var _TypeError, _RangeError;
                var Warning = subError("Warning", "warning");
                var CancellationError = subError("CancellationError", "cancellation error");
                var TimeoutError = subError("TimeoutError", "timeout error");
                var AggregateError = subError("AggregateError", "aggregate error");
                try {
                    _TypeError = TypeError;
                    _RangeError = RangeError;
                } catch (e) {
                    _TypeError = subError("TypeError", "type error");
                    _RangeError = subError("RangeError", "range error");
                }
                var methods = "join pop push shift unshift slice filter forEach some every map indexOf lastIndexOf reduce reduceRight sort reverse".split(" ");
                for(var i = 0; i < methods.length; ++i)if (typeof Array.prototype[methods[i]] === "function") AggregateError.prototype[methods[i]] = Array.prototype[methods[i]];
                es5.defineProperty(AggregateError.prototype, "length", {
                    value: 0,
                    configurable: false,
                    writable: true,
                    enumerable: true
                });
                AggregateError.prototype["isOperational"] = true;
                var level = 0;
                AggregateError.prototype.toString = function() {
                    var indent = Array(level * 4 + 1).join(" ");
                    var ret = "\n" + indent + "AggregateError of:" + "\n";
                    level++;
                    indent = Array(level * 4 + 1).join(" ");
                    for(var i = 0; i < this.length; ++i){
                        var str = this[i] === this ? "[Circular AggregateError]" : this[i] + "";
                        var lines = str.split("\n");
                        for(var j = 0; j < lines.length; ++j)lines[j] = indent + lines[j];
                        str = lines.join("\n");
                        ret += str + "\n";
                    }
                    level--;
                    return ret;
                };
                function OperationalError(message) {
                    if (!(this instanceof OperationalError)) return new OperationalError(message);
                    notEnumerableProp(this, "name", "OperationalError");
                    notEnumerableProp(this, "message", message);
                    this.cause = message;
                    this["isOperational"] = true;
                    if (message instanceof Error) {
                        notEnumerableProp(this, "message", message.message);
                        notEnumerableProp(this, "stack", message.stack);
                    } else if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
                }
                inherits(OperationalError, Error);
                var errorTypes = Error["__BluebirdErrorTypes__"];
                if (!errorTypes) {
                    errorTypes = Objectfreeze({
                        CancellationError: CancellationError,
                        TimeoutError: TimeoutError,
                        OperationalError: OperationalError,
                        RejectionError: OperationalError,
                        AggregateError: AggregateError
                    });
                    es5.defineProperty(Error, "__BluebirdErrorTypes__", {
                        value: errorTypes,
                        writable: false,
                        enumerable: false,
                        configurable: false
                    });
                }
                module1.exports = {
                    Error: Error,
                    TypeError: _TypeError,
                    RangeError: _RangeError,
                    CancellationError: errorTypes.CancellationError,
                    OperationalError: errorTypes.OperationalError,
                    TimeoutError: errorTypes.TimeoutError,
                    AggregateError: errorTypes.AggregateError,
                    Warning: Warning
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        13: [
            function(_dereq_1, module1, exports) {
                var isES5 = function() {
                    "use strict";
                    return this === undefined;
                }();
                if (isES5) module1.exports = {
                    freeze: Object.freeze,
                    defineProperty: Object.defineProperty,
                    getDescriptor: Object.getOwnPropertyDescriptor,
                    keys: Object.keys,
                    names: Object.getOwnPropertyNames,
                    getPrototypeOf: Object.getPrototypeOf,
                    isArray: Array.isArray,
                    isES5: isES5,
                    propertyIsWritable: function(obj, prop) {
                        var descriptor = Object.getOwnPropertyDescriptor(obj, prop);
                        return !!(!descriptor || descriptor.writable || descriptor.set);
                    }
                };
                else {
                    var has = {}.hasOwnProperty;
                    var str = {}.toString;
                    var proto = {}.constructor.prototype;
                    var ObjectKeys = function(o) {
                        var ret = [];
                        for(var key in o)if (has.call(o, key)) ret.push(key);
                        return ret;
                    };
                    var ObjectGetDescriptor = function(o, key) {
                        return {
                            value: o[key]
                        };
                    };
                    var ObjectDefineProperty = function(o, key, desc) {
                        o[key] = desc.value;
                        return o;
                    };
                    var ObjectFreeze = function(obj) {
                        return obj;
                    };
                    var ObjectGetPrototypeOf = function(obj) {
                        try {
                            return Object(obj).constructor.prototype;
                        } catch (e) {
                            return proto;
                        }
                    };
                    var ArrayIsArray = function(obj) {
                        try {
                            return str.call(obj) === "[object Array]";
                        } catch (e) {
                            return false;
                        }
                    };
                    module1.exports = {
                        isArray: ArrayIsArray,
                        keys: ObjectKeys,
                        names: ObjectKeys,
                        defineProperty: ObjectDefineProperty,
                        getDescriptor: ObjectGetDescriptor,
                        freeze: ObjectFreeze,
                        getPrototypeOf: ObjectGetPrototypeOf,
                        isES5: isES5,
                        propertyIsWritable: function() {
                            return true;
                        }
                    };
                }
            },
            {}
        ],
        14: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var PromiseMap = Promise1.map;
                    Promise1.prototype.filter = function(fn, options) {
                        return PromiseMap(this, fn, options, INTERNAL);
                    };
                    Promise1.filter = function(promises, fn, options) {
                        return PromiseMap(promises, fn, options, INTERNAL);
                    };
                };
            },
            {}
        ],
        15: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, tryConvertToPromise, NEXT_FILTER) {
                    var util = _dereq_1("./util");
                    var CancellationError = Promise1.CancellationError;
                    var errorObj = util.errorObj;
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    function PassThroughHandlerContext(promise, type, handler) {
                        this.promise = promise;
                        this.type = type;
                        this.handler = handler;
                        this.called = false;
                        this.cancelPromise = null;
                    }
                    PassThroughHandlerContext.prototype.isFinallyHandler = function() {
                        return this.type === 0;
                    };
                    function FinallyHandlerCancelReaction(finallyHandler) {
                        this.finallyHandler = finallyHandler;
                    }
                    FinallyHandlerCancelReaction.prototype._resultCancelled = function() {
                        checkCancel(this.finallyHandler);
                    };
                    function checkCancel(ctx, reason) {
                        if (ctx.cancelPromise != null) {
                            if (arguments.length > 1) ctx.cancelPromise._reject(reason);
                            else ctx.cancelPromise._cancel();
                            ctx.cancelPromise = null;
                            return true;
                        }
                        return false;
                    }
                    function succeed() {
                        return finallyHandler.call(this, this.promise._target()._settledValue());
                    }
                    function fail(reason) {
                        if (checkCancel(this, reason)) return;
                        errorObj.e = reason;
                        return errorObj;
                    }
                    function finallyHandler(reasonOrValue) {
                        var promise = this.promise;
                        var handler = this.handler;
                        if (!this.called) {
                            this.called = true;
                            var ret = this.isFinallyHandler() ? handler.call(promise._boundValue()) : handler.call(promise._boundValue(), reasonOrValue);
                            if (ret === NEXT_FILTER) return ret;
                            else if (ret !== undefined) {
                                promise._setReturnedNonUndefined();
                                var maybePromise = tryConvertToPromise(ret, promise);
                                if (maybePromise instanceof Promise1) {
                                    if (this.cancelPromise != null) {
                                        if (maybePromise._isCancelled()) {
                                            var reason = new CancellationError("late cancellation observer");
                                            promise._attachExtraTrace(reason);
                                            errorObj.e = reason;
                                            return errorObj;
                                        } else if (maybePromise.isPending()) maybePromise._attachCancellationCallback(new FinallyHandlerCancelReaction(this));
                                    }
                                    return maybePromise._then(succeed, fail, undefined, this, undefined);
                                }
                            }
                        }
                        if (promise.isRejected()) {
                            checkCancel(this);
                            errorObj.e = reasonOrValue;
                            return errorObj;
                        } else {
                            checkCancel(this);
                            return reasonOrValue;
                        }
                    }
                    Promise1.prototype._passThrough = function(handler, type, success, fail) {
                        if (typeof handler !== "function") return this.then();
                        return this._then(success, fail, undefined, new PassThroughHandlerContext(this, type, handler), undefined);
                    };
                    Promise1.prototype.lastly = Promise1.prototype["finally"] = function(handler) {
                        return this._passThrough(handler, 0, finallyHandler, finallyHandler);
                    };
                    Promise1.prototype.tap = function(handler) {
                        return this._passThrough(handler, 1, finallyHandler);
                    };
                    Promise1.prototype.tapCatch = function(handlerOrPredicate) {
                        var len = arguments.length;
                        if (len === 1) return this._passThrough(handlerOrPredicate, 1, undefined, finallyHandler);
                        else {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return Promise1.reject(new TypeError("tapCatch statement predicate: expecting an object but got " + util.classString(item)));
                            }
                            catchInstances.length = j;
                            var handler = arguments[i];
                            return this._passThrough(catchFilter(catchInstances, handler, this), 1, undefined, finallyHandler);
                        }
                    };
                    return PassThroughHandlerContext;
                };
            },
            {
                "./catch_filter": 7,
                "./util": 36
            }
        ],
        16: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug) {
                    var errors = _dereq_1("./errors");
                    var TypeError1 = errors.TypeError;
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var yieldHandlers = [];
                    function promiseFromYieldHandler(value, yieldHandlers, traceParent) {
                        for(var i = 0; i < yieldHandlers.length; ++i){
                            traceParent._pushContext();
                            var result = tryCatch(yieldHandlers[i])(value);
                            traceParent._popContext();
                            if (result === errorObj) {
                                traceParent._pushContext();
                                var ret = Promise1.reject(errorObj.e);
                                traceParent._popContext();
                                return ret;
                            }
                            var maybePromise = tryConvertToPromise(result, traceParent);
                            if (maybePromise instanceof Promise1) return maybePromise;
                        }
                        return null;
                    }
                    function PromiseSpawn(generatorFunction, receiver, yieldHandler, stack) {
                        if (debug.cancellation()) {
                            var internal = new Promise1(INTERNAL);
                            var _finallyPromise = this._finallyPromise = new Promise1(INTERNAL);
                            this._promise = internal.lastly(function() {
                                return _finallyPromise;
                            });
                            internal._captureStackTrace();
                            internal._setOnCancel(this);
                        } else {
                            var promise = this._promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                        }
                        this._stack = stack;
                        this._generatorFunction = generatorFunction;
                        this._receiver = receiver;
                        this._generator = undefined;
                        this._yieldHandlers = typeof yieldHandler === "function" ? [
                            yieldHandler
                        ].concat(yieldHandlers) : yieldHandlers;
                        this._yieldedPromise = null;
                        this._cancellationPhase = false;
                    }
                    util.inherits(PromiseSpawn, Proxyable);
                    PromiseSpawn.prototype._isResolved = function() {
                        return this._promise === null;
                    };
                    PromiseSpawn.prototype._cleanup = function() {
                        this._promise = this._generator = null;
                        if (debug.cancellation() && this._finallyPromise !== null) {
                            this._finallyPromise._fulfill();
                            this._finallyPromise = null;
                        }
                    };
                    PromiseSpawn.prototype._promiseCancelled = function() {
                        if (this._isResolved()) return;
                        var implementsReturn = typeof this._generator["return"] !== "undefined";
                        var result;
                        if (!implementsReturn) {
                            var reason = new Promise1.CancellationError("generator .return() sentinel");
                            Promise1.coroutine.returnSentinel = reason;
                            this._promise._attachExtraTrace(reason);
                            this._promise._pushContext();
                            result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                            this._promise._popContext();
                        } else {
                            this._promise._pushContext();
                            result = tryCatch(this._generator["return"]).call(this._generator, undefined);
                            this._promise._popContext();
                        }
                        this._cancellationPhase = true;
                        this._yieldedPromise = null;
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseFulfilled = function(value) {
                        this._yieldedPromise = null;
                        this._promise._pushContext();
                        var result = tryCatch(this._generator.next).call(this._generator, value);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._promiseRejected = function(reason) {
                        this._yieldedPromise = null;
                        this._promise._attachExtraTrace(reason);
                        this._promise._pushContext();
                        var result = tryCatch(this._generator["throw"]).call(this._generator, reason);
                        this._promise._popContext();
                        this._continue(result);
                    };
                    PromiseSpawn.prototype._resultCancelled = function() {
                        if (this._yieldedPromise instanceof Promise1) {
                            var promise = this._yieldedPromise;
                            this._yieldedPromise = null;
                            promise.cancel();
                        }
                    };
                    PromiseSpawn.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseSpawn.prototype._run = function() {
                        this._generator = this._generatorFunction.call(this._receiver);
                        this._receiver = this._generatorFunction = undefined;
                        this._promiseFulfilled(undefined);
                    };
                    PromiseSpawn.prototype._continue = function(result) {
                        var promise = this._promise;
                        if (result === errorObj) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._rejectCallback(result.e, false);
                        }
                        var value = result.value;
                        if (result.done === true) {
                            this._cleanup();
                            if (this._cancellationPhase) return promise.cancel();
                            else return promise._resolveCallback(value);
                        } else {
                            var maybePromise = tryConvertToPromise(value, this._promise);
                            if (!(maybePromise instanceof Promise1)) {
                                maybePromise = promiseFromYieldHandler(maybePromise, this._yieldHandlers, this._promise);
                                if (maybePromise === null) {
                                    this._promiseRejected(new TypeError1("A value %s was yielded that could not be treated as a promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a\u000a".replace("%s", String(value)) + "From coroutine:\u000a" + this._stack.split("\n").slice(1, -7).join("\n")));
                                    return;
                                }
                            }
                            maybePromise = maybePromise._target();
                            var bitField = maybePromise._bitField;
                            if ((bitField & 50397184) === 0) {
                                this._yieldedPromise = maybePromise;
                                maybePromise._proxy(this, null);
                            } else if ((bitField & 33554432) !== 0) Promise1._async.invoke(this._promiseFulfilled, this, maybePromise._value());
                            else if ((bitField & 16777216) !== 0) Promise1._async.invoke(this._promiseRejected, this, maybePromise._reason());
                            else this._promiseCancelled();
                        }
                    };
                    Promise1.coroutine = function(generatorFunction, options) {
                        if (typeof generatorFunction !== "function") throw new TypeError1("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var yieldHandler = Object(options).yieldHandler;
                        var PromiseSpawn$ = PromiseSpawn;
                        var stack = new Error().stack;
                        return function() {
                            var generator = generatorFunction.apply(this, arguments);
                            var spawn = new PromiseSpawn$(undefined, undefined, yieldHandler, stack);
                            var ret = spawn.promise();
                            spawn._generator = generator;
                            spawn._promiseFulfilled(undefined);
                            return ret;
                        };
                    };
                    Promise1.coroutine.addYieldHandler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        yieldHandlers.push(fn);
                    };
                    Promise1.spawn = function(generatorFunction) {
                        debug.deprecated("Promise.spawn()", "Promise.coroutine()");
                        if (typeof generatorFunction !== "function") return apiRejection("generatorFunction must be a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var spawn = new PromiseSpawn(generatorFunction, this);
                        var ret = spawn.promise();
                        spawn._run(Promise1.spawn);
                        return ret;
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        17: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async) {
                    var util = _dereq_1("./util");
                    var canEvaluate = util.canEvaluate;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var reject;
                    var thenCallback, promiseSetter, generateHolderClass, holderClasses, thenCallbacks, promiseSetters, i;
                    Promise1.join = function() {
                        var last = arguments.length - 1;
                        var fn;
                        if (last > 0 && typeof arguments[last] === "function") {
                            fn = arguments[last];
                            var ret, HolderClass, holder, callbacks, i, maybePromise, bitField, context;
                        }
                        var args = [].slice.call(arguments);
                        if (fn) args.pop();
                        var ret = new PromiseArray(args).promise();
                        return fn !== undefined ? ret.spread(fn) : ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        18: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    var async = Promise1._async;
                    function MappingPromiseArray(promises, fn, limit, _filter) {
                        this.constructor$(promises);
                        this._promise._captureStackTrace();
                        var context = Promise1._getContext();
                        this._callback = util.contextBind(context, fn);
                        this._preservedValues = _filter === INTERNAL ? new Array(this.length()) : null;
                        this._limit = limit;
                        this._inFlight = 0;
                        this._queue = [];
                        async.invoke(this._asyncInit, this, undefined);
                        if (util.isArray(promises)) for(var i = 0; i < promises.length; ++i){
                            var maybePromise = promises[i];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                    }
                    util.inherits(MappingPromiseArray, PromiseArray);
                    MappingPromiseArray.prototype._asyncInit = function() {
                        this._init$(undefined, -2);
                    };
                    MappingPromiseArray.prototype._init = function() {};
                    MappingPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var values = this._values;
                        var length = this.length();
                        var preservedValues = this._preservedValues;
                        var limit = this._limit;
                        if (index < 0) {
                            index = index * -1 - 1;
                            values[index] = value;
                            if (limit >= 1) {
                                this._inFlight--;
                                this._drainQueue();
                                if (this._isResolved()) return true;
                            }
                        } else {
                            if (limit >= 1 && this._inFlight >= limit) {
                                values[index] = value;
                                this._queue.push(index);
                                return false;
                            }
                            if (preservedValues !== null) preservedValues[index] = value;
                            var promise = this._promise;
                            var callback = this._callback;
                            var receiver = promise._boundValue();
                            promise._pushContext();
                            var ret = tryCatch(callback).call(receiver, value, index, length);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, preservedValues !== null ? "Promise.filter" : "Promise.map", promise);
                            if (ret === errorObj) {
                                this._reject(ret.e);
                                return true;
                            }
                            var maybePromise = tryConvertToPromise(ret, this._promise);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                var bitField = maybePromise._bitField;
                                if ((bitField & 50397184) === 0) {
                                    if (limit >= 1) this._inFlight++;
                                    values[index] = maybePromise;
                                    maybePromise._proxy(this, (index + 1) * -1);
                                    return false;
                                } else if ((bitField & 33554432) !== 0) ret = maybePromise._value();
                                else if ((bitField & 16777216) !== 0) {
                                    this._reject(maybePromise._reason());
                                    return true;
                                } else {
                                    this._cancel();
                                    return true;
                                }
                            }
                            values[index] = ret;
                        }
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= length) {
                            if (preservedValues !== null) this._filter(values, preservedValues);
                            else this._resolve(values);
                            return true;
                        }
                        return false;
                    };
                    MappingPromiseArray.prototype._drainQueue = function() {
                        var queue = this._queue;
                        var limit = this._limit;
                        var values = this._values;
                        while(queue.length > 0 && this._inFlight < limit){
                            if (this._isResolved()) return;
                            var index = queue.pop();
                            this._promiseFulfilled(values[index], index);
                        }
                    };
                    MappingPromiseArray.prototype._filter = function(booleans, values) {
                        var len = values.length;
                        var ret = new Array(len);
                        var j = 0;
                        for(var i = 0; i < len; ++i)if (booleans[i]) ret[j++] = values[i];
                        ret.length = j;
                        this._resolve(ret);
                    };
                    MappingPromiseArray.prototype.preservedValues = function() {
                        return this._preservedValues;
                    };
                    function map(promises, fn, options, _filter) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var limit = 0;
                        if (options !== undefined) {
                            if (typeof options === "object" && options !== null) {
                                if (typeof options.concurrency !== "number") return Promise1.reject(new TypeError("'concurrency' must be a number but it is " + util.classString(options.concurrency)));
                                limit = options.concurrency;
                            } else return Promise1.reject(new TypeError("options argument must be an object but it is " + util.classString(options)));
                        }
                        limit = typeof limit === "number" && isFinite(limit) && limit >= 1 ? limit : 0;
                        return new MappingPromiseArray(promises, fn, limit, _filter).promise();
                    }
                    Promise1.prototype.map = function(fn, options) {
                        return map(this, fn, options, null);
                    };
                    Promise1.map = function(promises, fn, options, _filter) {
                        return map(promises, fn, options, _filter);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        19: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    Promise1.method = function(fn) {
                        if (typeof fn !== "function") throw new Promise1.TypeError("expecting a function but got " + util.classString(fn));
                        return function() {
                            var ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._pushContext();
                            var value = tryCatch(fn).apply(this, arguments);
                            var promiseCreated = ret._popContext();
                            debug.checkForgottenReturns(value, promiseCreated, "Promise.method", ret);
                            ret._resolveFromSyncValue(value);
                            return ret;
                        };
                    };
                    Promise1.attempt = Promise1["try"] = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._pushContext();
                        var value;
                        if (arguments.length > 1) {
                            debug.deprecated("calling Promise.try with more than 1 argument");
                            var arg = arguments[1];
                            var ctx = arguments[2];
                            value = util.isArray(arg) ? tryCatch(fn).apply(ctx, arg) : tryCatch(fn).call(ctx, arg);
                        } else value = tryCatch(fn)();
                        var promiseCreated = ret._popContext();
                        debug.checkForgottenReturns(value, promiseCreated, "Promise.try", ret);
                        ret._resolveFromSyncValue(value);
                        return ret;
                    };
                    Promise1.prototype._resolveFromSyncValue = function(value) {
                        if (value === util.errorObj) this._rejectCallback(value.e, false);
                        else this._resolveCallback(value, true);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        20: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var maybeWrapAsError = util.maybeWrapAsError;
                var errors = _dereq_1("./errors");
                var OperationalError = errors.OperationalError;
                var es5 = _dereq_1("./es5");
                function isUntypedError(obj) {
                    return obj instanceof Error && es5.getPrototypeOf(obj) === Error.prototype;
                }
                var rErrorKey = /^(?:name|message|stack|cause)$/;
                function wrapAsOperationalError(obj) {
                    var ret;
                    if (isUntypedError(obj)) {
                        ret = new OperationalError(obj);
                        ret.name = obj.name;
                        ret.message = obj.message;
                        ret.stack = obj.stack;
                        var keys = es5.keys(obj);
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            if (!rErrorKey.test(key)) ret[key] = obj[key];
                        }
                        return ret;
                    }
                    util.markAsOriginatingFromRejection(obj);
                    return obj;
                }
                function nodebackForPromise(promise, multiArgs) {
                    return function(err, value) {
                        if (promise === null) return;
                        if (err) {
                            var wrapped = wrapAsOperationalError(maybeWrapAsError(err));
                            promise._attachExtraTrace(wrapped);
                            promise._reject(wrapped);
                        } else if (!multiArgs) promise._fulfill(value);
                        else {
                            var args = [].slice.call(arguments, 1);
                            promise._fulfill(args);
                        }
                        promise = null;
                    };
                }
                module1.exports = nodebackForPromise;
            },
            {
                "./errors": 12,
                "./es5": 13,
                "./util": 36
            }
        ],
        21: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    var util = _dereq_1("./util");
                    var async = Promise1._async;
                    var tryCatch = util.tryCatch;
                    var errorObj = util.errorObj;
                    function spreadAdapter(val, nodeback) {
                        var promise = this;
                        if (!util.isArray(val)) return successAdapter.call(promise, val, nodeback);
                        var ret = tryCatch(nodeback).apply(promise._boundValue(), [
                            null
                        ].concat(val));
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function successAdapter(val, nodeback) {
                        var promise = this;
                        var receiver = promise._boundValue();
                        var ret = val === undefined ? tryCatch(nodeback).call(receiver, null) : tryCatch(nodeback).call(receiver, null, val);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    function errorAdapter(reason, nodeback) {
                        var promise = this;
                        if (!reason) {
                            var newReason = new Error(reason + "");
                            newReason.cause = reason;
                            reason = newReason;
                        }
                        var ret = tryCatch(nodeback).call(promise._boundValue(), reason);
                        if (ret === errorObj) async.throwLater(ret.e);
                    }
                    Promise1.prototype.asCallback = Promise1.prototype.nodeify = function(nodeback, options) {
                        if (typeof nodeback == "function") {
                            var adapter = successAdapter;
                            if (options !== undefined && Object(options).spread) adapter = spreadAdapter;
                            this._then(adapter, errorAdapter, undefined, this, nodeback);
                        }
                        return this;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        22: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function() {
                    var makeSelfResolutionError = function() {
                        return new TypeError1("circular promise resolution chain\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                    };
                    var reflectHandler = function() {
                        return new Promise1.PromiseInspection(this._target());
                    };
                    var apiRejection = function(msg) {
                        return Promise1.reject(new TypeError1(msg));
                    };
                    function Proxyable() {}
                    var UNDEFINED_BINDING = {};
                    var util = _dereq_1("./util");
                    util.setReflectHandler(reflectHandler);
                    var getDomain = function() {
                        var domain = $cfae44f0dfdf62c0$exports.domain;
                        if (domain === undefined) return null;
                        return domain;
                    };
                    var getContextDefault = function() {
                        return null;
                    };
                    var getContextDomain = function() {
                        return {
                            domain: getDomain(),
                            async: null
                        };
                    };
                    var AsyncResource = util.isNode && util.nodeSupportsAsyncResource ? _dereq_1("async_hooks").AsyncResource : null;
                    var getContextAsyncHooks = function() {
                        return {
                            domain: getDomain(),
                            async: new AsyncResource("Bluebird::Promise")
                        };
                    };
                    var getContext = util.isNode ? getContextDomain : getContextDefault;
                    util.notEnumerableProp(Promise1, "_getContext", getContext);
                    var enableAsyncHooks = function() {
                        getContext = getContextAsyncHooks;
                        util.notEnumerableProp(Promise1, "_getContext", getContextAsyncHooks);
                    };
                    var disableAsyncHooks = function() {
                        getContext = getContextDomain;
                        util.notEnumerableProp(Promise1, "_getContext", getContextDomain);
                    };
                    var es5 = _dereq_1("./es5");
                    var Async = _dereq_1("./async");
                    var async = new Async();
                    es5.defineProperty(Promise1, "_async", {
                        value: async
                    });
                    var errors = _dereq_1("./errors");
                    var TypeError1 = Promise1.TypeError = errors.TypeError;
                    Promise1.RangeError = errors.RangeError;
                    var CancellationError = Promise1.CancellationError = errors.CancellationError;
                    Promise1.TimeoutError = errors.TimeoutError;
                    Promise1.OperationalError = errors.OperationalError;
                    Promise1.RejectionError = errors.OperationalError;
                    Promise1.AggregateError = errors.AggregateError;
                    var INTERNAL = function() {};
                    var APPLY = {};
                    var NEXT_FILTER = {};
                    var tryConvertToPromise = _dereq_1("./thenables")(Promise1, INTERNAL);
                    var PromiseArray = _dereq_1("./promise_array")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable);
                    var Context = _dereq_1("./context")(Promise1);
                    /*jshint unused:false*/ var createContext = Context.create;
                    var debug = _dereq_1("./debuggability")(Promise1, Context, enableAsyncHooks, disableAsyncHooks);
                    var CapturedTrace = debug.CapturedTrace;
                    var PassThroughHandlerContext = _dereq_1("./finally")(Promise1, tryConvertToPromise, NEXT_FILTER);
                    var catchFilter = _dereq_1("./catch_filter")(NEXT_FILTER);
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    function check(self1, executor) {
                        if (self1 == null || self1.constructor !== Promise1) throw new TypeError1("the promise constructor cannot be invoked directly\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        if (typeof executor !== "function") throw new TypeError1("expecting a function but got " + util.classString(executor));
                    }
                    function Promise1(executor) {
                        if (executor !== INTERNAL) check(this, executor);
                        this._bitField = 0;
                        this._fulfillmentHandler0 = undefined;
                        this._rejectionHandler0 = undefined;
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._resolveFromExecutor(executor);
                        this._promiseCreated();
                        this._fireEvent("promiseCreated", this);
                    }
                    Promise1.prototype.toString = function() {
                        return "[object Promise]";
                    };
                    Promise1.prototype.caught = Promise1.prototype["catch"] = function(fn) {
                        var len = arguments.length;
                        if (len > 1) {
                            var catchInstances = new Array(len - 1), j = 0, i;
                            for(i = 0; i < len - 1; ++i){
                                var item = arguments[i];
                                if (util.isObject(item)) catchInstances[j++] = item;
                                else return apiRejection("Catch statement predicate: expecting an object but got " + util.classString(item));
                            }
                            catchInstances.length = j;
                            fn = arguments[i];
                            if (typeof fn !== "function") throw new TypeError1("The last argument to .catch() must be a function, got " + util.toString(fn));
                            return this.then(undefined, catchFilter(catchInstances, fn, this));
                        }
                        return this.then(undefined, fn);
                    };
                    Promise1.prototype.reflect = function() {
                        return this._then(reflectHandler, reflectHandler, undefined, this, undefined);
                    };
                    Promise1.prototype.then = function(didFulfill, didReject) {
                        if (debug.warnings() && arguments.length > 0 && typeof didFulfill !== "function" && typeof didReject !== "function") {
                            var msg = ".then() only accepts functions but was passed: " + util.classString(didFulfill);
                            if (arguments.length > 1) msg += ", " + util.classString(didReject);
                            this._warn(msg);
                        }
                        return this._then(didFulfill, didReject, undefined, undefined, undefined);
                    };
                    Promise1.prototype.done = function(didFulfill, didReject) {
                        var promise = this._then(didFulfill, didReject, undefined, undefined, undefined);
                        promise._setIsFinal();
                    };
                    Promise1.prototype.spread = function(fn) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        return this.all()._then(fn, undefined, undefined, APPLY, undefined);
                    };
                    Promise1.prototype.toJSON = function() {
                        var ret = {
                            isFulfilled: false,
                            isRejected: false,
                            fulfillmentValue: undefined,
                            rejectionReason: undefined
                        };
                        if (this.isFulfilled()) {
                            ret.fulfillmentValue = this.value();
                            ret.isFulfilled = true;
                        } else if (this.isRejected()) {
                            ret.rejectionReason = this.reason();
                            ret.isRejected = true;
                        }
                        return ret;
                    };
                    Promise1.prototype.all = function() {
                        if (arguments.length > 0) this._warn(".all() was passed arguments but it does not take any");
                        return new PromiseArray(this).promise();
                    };
                    Promise1.prototype.error = function(fn) {
                        return this.caught(util.originatesFromRejection, fn);
                    };
                    Promise1.getNewLibraryCopy = module1.exports;
                    Promise1.is = function(val) {
                        return val instanceof Promise1;
                    };
                    Promise1.fromNode = Promise1.fromCallback = function(fn) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        var multiArgs = arguments.length > 1 ? !!Object(arguments[1]).multiArgs : false;
                        var result = tryCatch(fn)(nodebackForPromise(ret, multiArgs));
                        if (result === errorObj) ret._rejectCallback(result.e, true);
                        if (!ret._isFateSealed()) ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.all = function(promises) {
                        return new PromiseArray(promises).promise();
                    };
                    Promise1.cast = function(obj) {
                        var ret = tryConvertToPromise(obj);
                        if (!(ret instanceof Promise1)) {
                            ret = new Promise1(INTERNAL);
                            ret._captureStackTrace();
                            ret._setFulfilled();
                            ret._rejectionHandler0 = obj;
                        }
                        return ret;
                    };
                    Promise1.resolve = Promise1.fulfilled = Promise1.cast;
                    Promise1.reject = Promise1.rejected = function(reason) {
                        var ret = new Promise1(INTERNAL);
                        ret._captureStackTrace();
                        ret._rejectCallback(reason, true);
                        return ret;
                    };
                    Promise1.setScheduler = function(fn) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        return async.setScheduler(fn);
                    };
                    Promise1.prototype._then = function(didFulfill, didReject, _, receiver, internalData) {
                        var haveInternalData = internalData !== undefined;
                        var promise = haveInternalData ? internalData : new Promise1(INTERNAL);
                        var target = this._target();
                        var bitField = target._bitField;
                        if (!haveInternalData) {
                            promise._propagateFrom(this, 3);
                            promise._captureStackTrace();
                            if (receiver === undefined && (this._bitField & 2097152) !== 0) {
                                if (!((bitField & 50397184) === 0)) receiver = this._boundValue();
                                else receiver = target === this ? undefined : this._boundTo;
                            }
                            this._fireEvent("promiseChained", this, promise);
                        }
                        var context = getContext();
                        if (!((bitField & 50397184) === 0)) {
                            var handler, value, settler = target._settlePromiseCtx;
                            if ((bitField & 33554432) !== 0) {
                                value = target._rejectionHandler0;
                                handler = didFulfill;
                            } else if ((bitField & 16777216) !== 0) {
                                value = target._fulfillmentHandler0;
                                handler = didReject;
                                target._unsetRejectionIsUnhandled();
                            } else {
                                settler = target._settlePromiseLateCancellationObserver;
                                value = new CancellationError("late cancellation observer");
                                target._attachExtraTrace(value);
                                handler = didReject;
                            }
                            async.invoke(settler, target, {
                                handler: util.contextBind(context, handler),
                                promise: promise,
                                receiver: receiver,
                                value: value
                            });
                        } else target._addCallbacks(didFulfill, didReject, promise, receiver, context);
                        return promise;
                    };
                    Promise1.prototype._length = function() {
                        return this._bitField & 65535;
                    };
                    Promise1.prototype._isFateSealed = function() {
                        return (this._bitField & 117506048) !== 0;
                    };
                    Promise1.prototype._isFollowing = function() {
                        return (this._bitField & 67108864) === 67108864;
                    };
                    Promise1.prototype._setLength = function(len) {
                        this._bitField = this._bitField & -65536 | len & 65535;
                    };
                    Promise1.prototype._setFulfilled = function() {
                        this._bitField = this._bitField | 33554432;
                        this._fireEvent("promiseFulfilled", this);
                    };
                    Promise1.prototype._setRejected = function() {
                        this._bitField = this._bitField | 16777216;
                        this._fireEvent("promiseRejected", this);
                    };
                    Promise1.prototype._setFollowing = function() {
                        this._bitField = this._bitField | 67108864;
                        this._fireEvent("promiseResolved", this);
                    };
                    Promise1.prototype._setIsFinal = function() {
                        this._bitField = this._bitField | 4194304;
                    };
                    Promise1.prototype._isFinal = function() {
                        return (this._bitField & 4194304) > 0;
                    };
                    Promise1.prototype._unsetCancelled = function() {
                        this._bitField = this._bitField & -65537;
                    };
                    Promise1.prototype._setCancelled = function() {
                        this._bitField = this._bitField | 65536;
                        this._fireEvent("promiseCancelled", this);
                    };
                    Promise1.prototype._setWillBeCancelled = function() {
                        this._bitField = this._bitField | 8388608;
                    };
                    Promise1.prototype._setAsyncGuaranteed = function() {
                        if (async.hasCustomScheduler()) return;
                        var bitField = this._bitField;
                        this._bitField = bitField | (bitField & 536870912) >> 2 ^ 134217728;
                    };
                    Promise1.prototype._setNoAsyncGuarantee = function() {
                        this._bitField = (this._bitField | 536870912) & -134217729;
                    };
                    Promise1.prototype._receiverAt = function(index) {
                        var ret = index === 0 ? this._receiver0 : this[index * 4 - 4 + 3];
                        if (ret === UNDEFINED_BINDING) return undefined;
                        else if (ret === undefined && this._isBound()) return this._boundValue();
                        return ret;
                    };
                    Promise1.prototype._promiseAt = function(index) {
                        return this[index * 4 - 4 + 2];
                    };
                    Promise1.prototype._fulfillmentHandlerAt = function(index) {
                        return this[index * 4 - 4 + 0];
                    };
                    Promise1.prototype._rejectionHandlerAt = function(index) {
                        return this[index * 4 - 4 + 1];
                    };
                    Promise1.prototype._boundValue = function() {};
                    Promise1.prototype._migrateCallback0 = function(follower) {
                        var bitField = follower._bitField;
                        var fulfill = follower._fulfillmentHandler0;
                        var reject = follower._rejectionHandler0;
                        var promise = follower._promise0;
                        var receiver = follower._receiverAt(0);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._migrateCallbackAt = function(follower, index) {
                        var fulfill = follower._fulfillmentHandlerAt(index);
                        var reject = follower._rejectionHandlerAt(index);
                        var promise = follower._promiseAt(index);
                        var receiver = follower._receiverAt(index);
                        if (receiver === undefined) receiver = UNDEFINED_BINDING;
                        this._addCallbacks(fulfill, reject, promise, receiver, null);
                    };
                    Promise1.prototype._addCallbacks = function(fulfill, reject, promise, receiver, context) {
                        var index = this._length();
                        if (index >= 65531) {
                            index = 0;
                            this._setLength(0);
                        }
                        if (index === 0) {
                            this._promise0 = promise;
                            this._receiver0 = receiver;
                            if (typeof fulfill === "function") this._fulfillmentHandler0 = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this._rejectionHandler0 = util.contextBind(context, reject);
                        } else {
                            var base = index * 4 - 4;
                            this[base + 2] = promise;
                            this[base + 3] = receiver;
                            if (typeof fulfill === "function") this[base + 0] = util.contextBind(context, fulfill);
                            if (typeof reject === "function") this[base + 1] = util.contextBind(context, reject);
                        }
                        this._setLength(index + 1);
                        return index;
                    };
                    Promise1.prototype._proxy = function(proxyable, arg) {
                        this._addCallbacks(undefined, undefined, arg, proxyable, null);
                    };
                    Promise1.prototype._resolveCallback = function(value, shouldBind) {
                        if ((this._bitField & 117506048) !== 0) return;
                        if (value === this) return this._rejectCallback(makeSelfResolutionError(), false);
                        var maybePromise = tryConvertToPromise(value, this);
                        if (!(maybePromise instanceof Promise1)) return this._fulfill(value);
                        if (shouldBind) this._propagateFrom(maybePromise, 2);
                        var promise = maybePromise._target();
                        if (promise === this) {
                            this._reject(makeSelfResolutionError());
                            return;
                        }
                        var bitField = promise._bitField;
                        if ((bitField & 50397184) === 0) {
                            var len = this._length();
                            if (len > 0) promise._migrateCallback0(this);
                            for(var i = 1; i < len; ++i)promise._migrateCallbackAt(this, i);
                            this._setFollowing();
                            this._setLength(0);
                            this._setFollowee(maybePromise);
                        } else if ((bitField & 33554432) !== 0) this._fulfill(promise._value());
                        else if ((bitField & 16777216) !== 0) this._reject(promise._reason());
                        else {
                            var reason = new CancellationError("late cancellation observer");
                            promise._attachExtraTrace(reason);
                            this._reject(reason);
                        }
                    };
                    Promise1.prototype._rejectCallback = function(reason, synchronous, ignoreNonErrorWarnings) {
                        var trace = util.ensureErrorObject(reason);
                        var hasStack = trace === reason;
                        if (!hasStack && !ignoreNonErrorWarnings && debug.warnings()) {
                            var message = "a promise was rejected with a non-error: " + util.classString(reason);
                            this._warn(message, true);
                        }
                        this._attachExtraTrace(trace, synchronous ? hasStack : false);
                        this._reject(reason);
                    };
                    Promise1.prototype._resolveFromExecutor = function(executor) {
                        if (executor === INTERNAL) return;
                        var promise = this;
                        this._captureStackTrace();
                        this._pushContext();
                        var synchronous = true;
                        var r = this._execute(executor, function(value) {
                            promise._resolveCallback(value);
                        }, function(reason) {
                            promise._rejectCallback(reason, synchronous);
                        });
                        synchronous = false;
                        this._popContext();
                        if (r !== undefined) promise._rejectCallback(r, true);
                    };
                    Promise1.prototype._settlePromiseFromHandler = function(handler, receiver, value, promise) {
                        var bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        promise._pushContext();
                        var x;
                        if (receiver === APPLY) {
                            if (!value || typeof value.length !== "number") {
                                x = errorObj;
                                x.e = new TypeError1("cannot .spread() a non-array: " + util.classString(value));
                            } else x = tryCatch(handler).apply(this._boundValue(), value);
                        } else x = tryCatch(handler).call(receiver, value);
                        var promiseCreated = promise._popContext();
                        bitField = promise._bitField;
                        if ((bitField & 65536) !== 0) return;
                        if (x === NEXT_FILTER) promise._reject(value);
                        else if (x === errorObj) promise._rejectCallback(x.e, false);
                        else {
                            debug.checkForgottenReturns(x, promiseCreated, "", promise, this);
                            promise._resolveCallback(x);
                        }
                    };
                    Promise1.prototype._target = function() {
                        var ret = this;
                        while(ret._isFollowing())ret = ret._followee();
                        return ret;
                    };
                    Promise1.prototype._followee = function() {
                        return this._rejectionHandler0;
                    };
                    Promise1.prototype._setFollowee = function(promise) {
                        this._rejectionHandler0 = promise;
                    };
                    Promise1.prototype._settlePromise = function(promise, handler, receiver, value) {
                        var isPromise = promise instanceof Promise1;
                        var bitField = this._bitField;
                        var asyncGuaranteed = (bitField & 134217728) !== 0;
                        if ((bitField & 65536) !== 0) {
                            if (isPromise) promise._invokeInternalOnCancel();
                            if (receiver instanceof PassThroughHandlerContext && receiver.isFinallyHandler()) {
                                receiver.cancelPromise = promise;
                                if (tryCatch(handler).call(receiver, value) === errorObj) promise._reject(errorObj.e);
                            } else if (handler === reflectHandler) promise._fulfill(reflectHandler.call(receiver));
                            else if (receiver instanceof Proxyable) receiver._promiseCancelled(promise);
                            else if (isPromise || promise instanceof PromiseArray) promise._cancel();
                            else receiver.cancel();
                        } else if (typeof handler === "function") {
                            if (!isPromise) handler.call(receiver, value, promise);
                            else {
                                if (asyncGuaranteed) promise._setAsyncGuaranteed();
                                this._settlePromiseFromHandler(handler, receiver, value, promise);
                            }
                        } else if (receiver instanceof Proxyable) {
                            if (!receiver._isResolved()) {
                                if ((bitField & 33554432) !== 0) receiver._promiseFulfilled(value, promise);
                                else receiver._promiseRejected(value, promise);
                            }
                        } else if (isPromise) {
                            if (asyncGuaranteed) promise._setAsyncGuaranteed();
                            if ((bitField & 33554432) !== 0) promise._fulfill(value);
                            else promise._reject(value);
                        }
                    };
                    Promise1.prototype._settlePromiseLateCancellationObserver = function(ctx) {
                        var handler = ctx.handler;
                        var promise = ctx.promise;
                        var receiver = ctx.receiver;
                        var value = ctx.value;
                        if (typeof handler === "function") {
                            if (!(promise instanceof Promise1)) handler.call(receiver, value, promise);
                            else this._settlePromiseFromHandler(handler, receiver, value, promise);
                        } else if (promise instanceof Promise1) promise._reject(value);
                    };
                    Promise1.prototype._settlePromiseCtx = function(ctx) {
                        this._settlePromise(ctx.promise, ctx.handler, ctx.receiver, ctx.value);
                    };
                    Promise1.prototype._settlePromise0 = function(handler, value, bitField) {
                        var promise = this._promise0;
                        var receiver = this._receiverAt(0);
                        this._promise0 = undefined;
                        this._receiver0 = undefined;
                        this._settlePromise(promise, handler, receiver, value);
                    };
                    Promise1.prototype._clearCallbackDataAtIndex = function(index) {
                        var base = index * 4 - 4;
                        this[base + 2] = this[base + 3] = this[base + 0] = this[base + 1] = undefined;
                    };
                    Promise1.prototype._fulfill = function(value) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        if (value === this) {
                            var err = makeSelfResolutionError();
                            this._attachExtraTrace(err);
                            return this._reject(err);
                        }
                        this._setFulfilled();
                        this._rejectionHandler0 = value;
                        if ((bitField & 65535) > 0) {
                            if ((bitField & 134217728) !== 0) this._settlePromises();
                            else async.settlePromises(this);
                            this._dereferenceTrace();
                        }
                    };
                    Promise1.prototype._reject = function(reason) {
                        var bitField = this._bitField;
                        if ((bitField & 117506048) >>> 16) return;
                        this._setRejected();
                        this._fulfillmentHandler0 = reason;
                        if (this._isFinal()) return async.fatalError(reason, util.isNode);
                        if ((bitField & 65535) > 0) async.settlePromises(this);
                        else this._ensurePossibleRejectionHandled();
                    };
                    Promise1.prototype._fulfillPromises = function(len, value) {
                        for(var i = 1; i < len; i++){
                            var handler = this._fulfillmentHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, value);
                        }
                    };
                    Promise1.prototype._rejectPromises = function(len, reason) {
                        for(var i = 1; i < len; i++){
                            var handler = this._rejectionHandlerAt(i);
                            var promise = this._promiseAt(i);
                            var receiver = this._receiverAt(i);
                            this._clearCallbackDataAtIndex(i);
                            this._settlePromise(promise, handler, receiver, reason);
                        }
                    };
                    Promise1.prototype._settlePromises = function() {
                        var bitField = this._bitField;
                        var len = bitField & 65535;
                        if (len > 0) {
                            if ((bitField & 16842752) !== 0) {
                                var reason = this._fulfillmentHandler0;
                                this._settlePromise0(this._rejectionHandler0, reason, bitField);
                                this._rejectPromises(len, reason);
                            } else {
                                var value = this._rejectionHandler0;
                                this._settlePromise0(this._fulfillmentHandler0, value, bitField);
                                this._fulfillPromises(len, value);
                            }
                            this._setLength(0);
                        }
                        this._clearCancellationData();
                    };
                    Promise1.prototype._settledValue = function() {
                        var bitField = this._bitField;
                        if ((bitField & 33554432) !== 0) return this._rejectionHandler0;
                        else if ((bitField & 16777216) !== 0) return this._fulfillmentHandler0;
                    };
                    if (typeof Symbol !== "undefined" && Symbol.toStringTag) es5.defineProperty(Promise1.prototype, Symbol.toStringTag, {
                        get: function() {
                            return "Object";
                        }
                    });
                    function deferResolve(v) {
                        this.promise._resolveCallback(v);
                    }
                    function deferReject(v) {
                        this.promise._rejectCallback(v, false);
                    }
                    Promise1.defer = Promise1.pending = function() {
                        debug.deprecated("Promise.defer", "new Promise");
                        var promise = new Promise1(INTERNAL);
                        return {
                            promise: promise,
                            resolve: deferResolve,
                            reject: deferReject
                        };
                    };
                    util.notEnumerableProp(Promise1, "_makeSelfResolutionError", makeSelfResolutionError);
                    _dereq_1("./method")(Promise1, INTERNAL, tryConvertToPromise, apiRejection, debug);
                    _dereq_1("./bind")(Promise1, INTERNAL, tryConvertToPromise, debug);
                    _dereq_1("./cancel")(Promise1, PromiseArray, apiRejection, debug);
                    _dereq_1("./direct_resolve")(Promise1);
                    _dereq_1("./synchronous_inspection")(Promise1);
                    _dereq_1("./join")(Promise1, PromiseArray, tryConvertToPromise, INTERNAL, async);
                    Promise1.Promise = Promise1;
                    Promise1.version = "3.7.2";
                    _dereq_1('./call_get.js')(Promise1);
                    _dereq_1('./generators.js')(Promise1, apiRejection, INTERNAL, tryConvertToPromise, Proxyable, debug);
                    _dereq_1('./map.js')(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1('./nodeify.js')(Promise1);
                    _dereq_1('./promisify.js')(Promise1, INTERNAL);
                    _dereq_1('./props.js')(Promise1, PromiseArray, tryConvertToPromise, apiRejection);
                    _dereq_1('./race.js')(Promise1, INTERNAL, tryConvertToPromise, apiRejection);
                    _dereq_1('./reduce.js')(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug);
                    _dereq_1('./settle.js')(Promise1, PromiseArray, debug);
                    _dereq_1('./some.js')(Promise1, PromiseArray, apiRejection);
                    _dereq_1('./timers.js')(Promise1, INTERNAL, debug);
                    _dereq_1('./using.js')(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug);
                    _dereq_1('./any.js')(Promise1);
                    _dereq_1('./each.js')(Promise1, INTERNAL);
                    _dereq_1('./filter.js')(Promise1, INTERNAL);
                    util.toFastProperties(Promise1);
                    util.toFastProperties(Promise1.prototype);
                    function fillTypes(value) {
                        var p = new Promise1(INTERNAL);
                        p._fulfillmentHandler0 = value;
                        p._rejectionHandler0 = value;
                        p._promise0 = value;
                        p._receiver0 = value;
                    }
                    // Complete slack tracking, opt out of field-type tracking and           
                    // stabilize map                                                         
                    fillTypes({
                        a: 1
                    });
                    fillTypes({
                        b: 2
                    });
                    fillTypes({
                        c: 3
                    });
                    fillTypes(1);
                    fillTypes(function() {});
                    fillTypes(undefined);
                    fillTypes(false);
                    fillTypes(new Promise1(INTERNAL));
                    debug.setBounds(Async.firstLineError, util.lastLineError);
                    return Promise1;
                };
            },
            {
                "./any.js": 1,
                "./async": 2,
                "./bind": 3,
                "./call_get.js": 5,
                "./cancel": 6,
                "./catch_filter": 7,
                "./context": 8,
                "./debuggability": 9,
                "./direct_resolve": 10,
                "./each.js": 11,
                "./errors": 12,
                "./es5": 13,
                "./filter.js": 14,
                "./finally": 15,
                "./generators.js": 16,
                "./join": 17,
                "./map.js": 18,
                "./method": 19,
                "./nodeback": 20,
                "./nodeify.js": 21,
                "./promise_array": 23,
                "./promisify.js": 24,
                "./props.js": 25,
                "./race.js": 27,
                "./reduce.js": 28,
                "./settle.js": 30,
                "./some.js": 31,
                "./synchronous_inspection": 32,
                "./thenables": 33,
                "./timers.js": 34,
                "./using.js": 35,
                "./util": 36,
                "async_hooks": undefined
            }
        ],
        23: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection, Proxyable) {
                    var util = _dereq_1("./util");
                    var isArray = util.isArray;
                    function toResolutionValue(val) {
                        switch(val){
                            case -2:
                                return [];
                            case -3:
                                return {};
                            case -6:
                                return new Map();
                        }
                    }
                    function PromiseArray(values) {
                        var promise = this._promise = new Promise1(INTERNAL);
                        if (values instanceof Promise1) {
                            promise._propagateFrom(values, 3);
                            values.suppressUnhandledRejections();
                        }
                        promise._setOnCancel(this);
                        this._values = values;
                        this._length = 0;
                        this._totalResolved = 0;
                        this._init(undefined, -2);
                    }
                    util.inherits(PromiseArray, Proxyable);
                    PromiseArray.prototype.length = function() {
                        return this._length;
                    };
                    PromiseArray.prototype.promise = function() {
                        return this._promise;
                    };
                    PromiseArray.prototype._init = function init(_, resolveValueIfEmpty) {
                        var values = tryConvertToPromise(this._values, this._promise);
                        if (values instanceof Promise1) {
                            values = values._target();
                            var bitField = values._bitField;
                            this._values = values;
                            if ((bitField & 50397184) === 0) {
                                this._promise._setAsyncGuaranteed();
                                return values._then(init, this._reject, undefined, this, resolveValueIfEmpty);
                            } else if ((bitField & 33554432) !== 0) values = values._value();
                            else if ((bitField & 16777216) !== 0) return this._reject(values._reason());
                            else return this._cancel();
                        }
                        values = util.asArray(values);
                        if (values === null) {
                            var err = apiRejection("expecting an array or an iterable object but got " + util.classString(values)).reason();
                            this._promise._rejectCallback(err, false);
                            return;
                        }
                        if (values.length === 0) {
                            if (resolveValueIfEmpty === -5) this._resolveEmptyArray();
                            else this._resolve(toResolutionValue(resolveValueIfEmpty));
                            return;
                        }
                        this._iterate(values);
                    };
                    PromiseArray.prototype._iterate = function(values) {
                        var len = this.getActualLength(values.length);
                        this._length = len;
                        this._values = this.shouldCopyValues() ? new Array(len) : this._values;
                        var result = this._promise;
                        var isResolved = false;
                        var bitField = null;
                        for(var i = 0; i < len; ++i){
                            var maybePromise = tryConvertToPromise(values[i], result);
                            if (maybePromise instanceof Promise1) {
                                maybePromise = maybePromise._target();
                                bitField = maybePromise._bitField;
                            } else bitField = null;
                            if (isResolved) {
                                if (bitField !== null) maybePromise.suppressUnhandledRejections();
                            } else if (bitField !== null) {
                                if ((bitField & 50397184) === 0) {
                                    maybePromise._proxy(this, i);
                                    this._values[i] = maybePromise;
                                } else if ((bitField & 33554432) !== 0) isResolved = this._promiseFulfilled(maybePromise._value(), i);
                                else if ((bitField & 16777216) !== 0) isResolved = this._promiseRejected(maybePromise._reason(), i);
                                else isResolved = this._promiseCancelled(i);
                            } else isResolved = this._promiseFulfilled(maybePromise, i);
                        }
                        if (!isResolved) result._setAsyncGuaranteed();
                    };
                    PromiseArray.prototype._isResolved = function() {
                        return this._values === null;
                    };
                    PromiseArray.prototype._resolve = function(value) {
                        this._values = null;
                        this._promise._fulfill(value);
                    };
                    PromiseArray.prototype._cancel = function() {
                        if (this._isResolved() || !this._promise._isCancellable()) return;
                        this._values = null;
                        this._promise._cancel();
                    };
                    PromiseArray.prototype._reject = function(reason) {
                        this._values = null;
                        this._promise._rejectCallback(reason, false);
                    };
                    PromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    PromiseArray.prototype._promiseCancelled = function() {
                        this._cancel();
                        return true;
                    };
                    PromiseArray.prototype._promiseRejected = function(reason) {
                        this._totalResolved++;
                        this._reject(reason);
                        return true;
                    };
                    PromiseArray.prototype._resultCancelled = function() {
                        if (this._isResolved()) return;
                        var values = this._values;
                        this._cancel();
                        if (values instanceof Promise1) values.cancel();
                        else {
                            for(var i = 0; i < values.length; ++i)if (values[i] instanceof Promise1) values[i].cancel();
                        }
                    };
                    PromiseArray.prototype.shouldCopyValues = function() {
                        return true;
                    };
                    PromiseArray.prototype.getActualLength = function(len) {
                        return len;
                    };
                    return PromiseArray;
                };
            },
            {
                "./util": 36
            }
        ],
        24: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var THIS = {};
                    var util = _dereq_1("./util");
                    var nodebackForPromise = _dereq_1("./nodeback");
                    var withAppended = util.withAppended;
                    var maybeWrapAsError = util.maybeWrapAsError;
                    var canEvaluate = util.canEvaluate;
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var defaultSuffix = "Async";
                    var defaultPromisified = {
                        __isPromisified__: true
                    };
                    var noCopyProps = [
                        "arity",
                        "length",
                        "name",
                        "arguments",
                        "caller",
                        "callee",
                        "prototype",
                        "__isPromisified__"
                    ];
                    var noCopyPropsPattern = new RegExp("^(?:" + noCopyProps.join("|") + ")$");
                    var defaultFilter = function(name) {
                        return util.isIdentifier(name) && name.charAt(0) !== "_" && name !== "constructor";
                    };
                    function propsFilter(key) {
                        return !noCopyPropsPattern.test(key);
                    }
                    function isPromisified(fn) {
                        try {
                            return fn.__isPromisified__ === true;
                        } catch (e) {
                            return false;
                        }
                    }
                    function hasPromisified(obj, key, suffix) {
                        var val = util.getDataPropertyOrDefault(obj, key + suffix, defaultPromisified);
                        return val ? isPromisified(val) : false;
                    }
                    function checkValid(ret, suffix, suffixRegexp) {
                        for(var i = 0; i < ret.length; i += 2){
                            var key = ret[i];
                            if (suffixRegexp.test(key)) {
                                var keyWithoutAsyncSuffix = key.replace(suffixRegexp, "");
                                for(var j = 0; j < ret.length; j += 2){
                                    if (ret[j] === keyWithoutAsyncSuffix) throw new TypeError1("Cannot promisify an API that has normal methods with '%s'-suffix\u000a\u000a    See http://goo.gl/MqrFmX\u000a".replace("%s", suffix));
                                }
                            }
                        }
                    }
                    function promisifiableMethods(obj, suffix, suffixRegexp, filter) {
                        var keys = util.inheritedDataKeys(obj);
                        var ret = [];
                        for(var i = 0; i < keys.length; ++i){
                            var key = keys[i];
                            var value = obj[key];
                            var passesDefaultFilter = filter === defaultFilter ? true : defaultFilter(key, value, obj);
                            if (typeof value === "function" && !isPromisified(value) && !hasPromisified(obj, key, suffix) && filter(key, value, obj, passesDefaultFilter)) ret.push(key, value);
                        }
                        checkValid(ret, suffix, suffixRegexp);
                        return ret;
                    }
                    var escapeIdentRegex = function(str) {
                        return str.replace(/([$])/, "\\$");
                    };
                    var makeNodePromisifiedEval;
                    var switchCaseArgumentOrder, argumentSequence, parameterDeclaration, parameterCount;
                    function makeNodePromisifiedClosure(callback, receiver, _, fn, __, multiArgs) {
                        var defaultThis = function() {
                            return this;
                        }();
                        var method = callback;
                        if (typeof method === "string") callback = fn;
                        function promisified() {
                            var _receiver = receiver;
                            if (receiver === THIS) _receiver = this;
                            var promise = new Promise1(INTERNAL);
                            promise._captureStackTrace();
                            var cb = typeof method === "string" && this !== defaultThis ? this[method] : callback;
                            var fn = nodebackForPromise(promise, multiArgs);
                            try {
                                cb.apply(_receiver, withAppended(arguments, fn));
                            } catch (e) {
                                promise._rejectCallback(maybeWrapAsError(e), true, true);
                            }
                            if (!promise._isFateSealed()) promise._setAsyncGuaranteed();
                            return promise;
                        }
                        util.notEnumerableProp(promisified, "__isPromisified__", true);
                        return promisified;
                    }
                    var makeNodePromisified = canEvaluate ? makeNodePromisifiedEval : makeNodePromisifiedClosure;
                    function promisifyAll(obj, suffix, filter, promisifier, multiArgs) {
                        var suffixRegexp = new RegExp(escapeIdentRegex(suffix) + "$");
                        var methods = promisifiableMethods(obj, suffix, suffixRegexp, filter);
                        for(var i = 0, len = methods.length; i < len; i += 2){
                            var key = methods[i];
                            var fn = methods[i + 1];
                            var promisifiedKey = key + suffix;
                            if (promisifier === makeNodePromisified) obj[promisifiedKey] = makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                            else {
                                var promisified = promisifier(fn, function() {
                                    return makeNodePromisified(key, THIS, key, fn, suffix, multiArgs);
                                });
                                util.notEnumerableProp(promisified, "__isPromisified__", true);
                                obj[promisifiedKey] = promisified;
                            }
                        }
                        util.toFastProperties(obj);
                        return obj;
                    }
                    function promisify(callback, receiver, multiArgs) {
                        return makeNodePromisified(callback, receiver, undefined, callback, null, multiArgs);
                    }
                    Promise1.promisify = function(fn, options) {
                        if (typeof fn !== "function") throw new TypeError1("expecting a function but got " + util.classString(fn));
                        if (isPromisified(fn)) return fn;
                        options = Object(options);
                        var receiver = options.context === undefined ? THIS : options.context;
                        var multiArgs = !!options.multiArgs;
                        var ret = promisify(fn, receiver, multiArgs);
                        util.copyDescriptors(fn, ret, propsFilter);
                        return ret;
                    };
                    Promise1.promisifyAll = function(target, options) {
                        if (typeof target !== "function" && typeof target !== "object") throw new TypeError1("the target of promisifyAll must be an object or a function\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        options = Object(options);
                        var multiArgs = !!options.multiArgs;
                        var suffix = options.suffix;
                        if (typeof suffix !== "string") suffix = defaultSuffix;
                        var filter = options.filter;
                        if (typeof filter !== "function") filter = defaultFilter;
                        var promisifier = options.promisifier;
                        if (typeof promisifier !== "function") promisifier = makeNodePromisified;
                        if (!util.isIdentifier(suffix)) throw new RangeError("suffix must be a valid identifier\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var keys = util.inheritedDataKeys(target);
                        for(var i = 0; i < keys.length; ++i){
                            var value = target[keys[i]];
                            if (keys[i] !== "constructor" && util.isClass(value)) {
                                promisifyAll(value.prototype, suffix, filter, promisifier, multiArgs);
                                promisifyAll(value, suffix, filter, promisifier, multiArgs);
                            }
                        }
                        return promisifyAll(target, suffix, filter, promisifier, multiArgs);
                    };
                };
            },
            {
                "./errors": 12,
                "./nodeback": 20,
                "./util": 36
            }
        ],
        25: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var isObject = util.isObject;
                    var es5 = _dereq_1("./es5");
                    var Es6Map;
                    if (typeof Map === "function") Es6Map = Map;
                    var mapToEntries = function() {
                        var index = 0;
                        var size = 0;
                        function extractEntry(value, key) {
                            this[index] = value;
                            this[index + size] = key;
                            index++;
                        }
                        return function mapToEntries(map) {
                            size = map.size;
                            index = 0;
                            var ret = new Array(map.size * 2);
                            map.forEach(extractEntry, ret);
                            return ret;
                        };
                    }();
                    var entriesToMap = function(entries) {
                        var ret = new Es6Map();
                        var length = entries.length / 2 | 0;
                        for(var i = 0; i < length; ++i){
                            var key = entries[length + i];
                            var value = entries[i];
                            ret.set(key, value);
                        }
                        return ret;
                    };
                    function PropertiesPromiseArray(obj) {
                        var isMap = false;
                        var entries;
                        if (Es6Map !== undefined && obj instanceof Es6Map) {
                            entries = mapToEntries(obj);
                            isMap = true;
                        } else {
                            var keys = es5.keys(obj);
                            var len = keys.length;
                            entries = new Array(len * 2);
                            for(var i = 0; i < len; ++i){
                                var key = keys[i];
                                entries[i] = obj[key];
                                entries[i + len] = key;
                            }
                        }
                        this.constructor$(entries);
                        this._isMap = isMap;
                        this._init$(undefined, isMap ? -6 : -3);
                    }
                    util.inherits(PropertiesPromiseArray, PromiseArray);
                    PropertiesPromiseArray.prototype._init = function() {};
                    PropertiesPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        this._values[index] = value;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            var val;
                            if (this._isMap) val = entriesToMap(this._values);
                            else {
                                val = {};
                                var keyOffset = this.length();
                                for(var i = 0, len = this.length(); i < len; ++i)val[this._values[i + keyOffset]] = this._values[i];
                            }
                            this._resolve(val);
                            return true;
                        }
                        return false;
                    };
                    PropertiesPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    PropertiesPromiseArray.prototype.getActualLength = function(len) {
                        return len >> 1;
                    };
                    function props(promises) {
                        var ret;
                        var castValue = tryConvertToPromise(promises);
                        if (!isObject(castValue)) return apiRejection("cannot await properties of a non-object\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        else if (castValue instanceof Promise1) ret = castValue._then(Promise1.props, undefined, undefined, undefined, undefined);
                        else ret = new PropertiesPromiseArray(castValue).promise();
                        if (castValue instanceof Promise1) ret._propagateFrom(castValue, 2);
                        return ret;
                    }
                    Promise1.prototype.props = function() {
                        return props(this);
                    };
                    Promise1.props = function(promises) {
                        return props(promises);
                    };
                };
            },
            {
                "./es5": 13,
                "./util": 36
            }
        ],
        26: [
            function(_dereq_1, module1, exports) {
                "use strict";
                function arrayMove(src, srcIndex, dst, dstIndex, len) {
                    for(var j = 0; j < len; ++j){
                        dst[j + dstIndex] = src[j + srcIndex];
                        src[j + srcIndex] = void 0;
                    }
                }
                function Queue(capacity) {
                    this._capacity = capacity;
                    this._length = 0;
                    this._front = 0;
                }
                Queue.prototype._willBeOverCapacity = function(size) {
                    return this._capacity < size;
                };
                Queue.prototype._pushOne = function(arg) {
                    var length = this.length();
                    this._checkCapacity(length + 1);
                    var i = this._front + length & this._capacity - 1;
                    this[i] = arg;
                    this._length = length + 1;
                };
                Queue.prototype.push = function(fn, receiver, arg) {
                    var length = this.length() + 3;
                    if (this._willBeOverCapacity(length)) {
                        this._pushOne(fn);
                        this._pushOne(receiver);
                        this._pushOne(arg);
                        return;
                    }
                    var j = this._front + length - 3;
                    this._checkCapacity(length);
                    var wrapMask = this._capacity - 1;
                    this[j + 0 & wrapMask] = fn;
                    this[j + 1 & wrapMask] = receiver;
                    this[j + 2 & wrapMask] = arg;
                    this._length = length;
                };
                Queue.prototype.shift = function() {
                    var front = this._front, ret = this[front];
                    this[front] = undefined;
                    this._front = front + 1 & this._capacity - 1;
                    this._length--;
                    return ret;
                };
                Queue.prototype.length = function() {
                    return this._length;
                };
                Queue.prototype._checkCapacity = function(size) {
                    if (this._capacity < size) this._resizeTo(this._capacity << 1);
                };
                Queue.prototype._resizeTo = function(capacity) {
                    var oldCapacity = this._capacity;
                    this._capacity = capacity;
                    var front = this._front;
                    var length = this._length;
                    var moveItemsCount = front + length & oldCapacity - 1;
                    arrayMove(this, 0, this, oldCapacity, moveItemsCount);
                };
                module1.exports = Queue;
            },
            {}
        ],
        27: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, tryConvertToPromise, apiRejection) {
                    var util = _dereq_1("./util");
                    var raceLater = function(promise) {
                        return promise.then(function(array) {
                            return race(array, promise);
                        });
                    };
                    function race(promises, parent) {
                        var maybePromise = tryConvertToPromise(promises);
                        if (maybePromise instanceof Promise1) return raceLater(maybePromise);
                        else {
                            promises = util.asArray(promises);
                            if (promises === null) return apiRejection("expecting an array or an iterable object but got " + util.classString(promises));
                        }
                        var ret = new Promise1(INTERNAL);
                        if (parent !== undefined) ret._propagateFrom(parent, 3);
                        var fulfill = ret._fulfill;
                        var reject = ret._reject;
                        for(var i = 0, len = promises.length; i < len; ++i){
                            var val = promises[i];
                            if (val === undefined && !(i in promises)) continue;
                            Promise1.cast(val)._then(fulfill, reject, undefined, ret, null);
                        }
                        return ret;
                    }
                    Promise1.race = function(promises) {
                        return race(promises, undefined);
                    };
                    Promise1.prototype.race = function() {
                        return race(this, undefined);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        28: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection, tryConvertToPromise, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var tryCatch = util.tryCatch;
                    function ReductionPromiseArray(promises, fn, initialValue, _each) {
                        this.constructor$(promises);
                        var context = Promise1._getContext();
                        this._fn = util.contextBind(context, fn);
                        if (initialValue !== undefined) {
                            initialValue = Promise1.resolve(initialValue);
                            initialValue._attachCancellationCallback(this);
                        }
                        this._initialValue = initialValue;
                        this._currentCancellable = null;
                        if (_each === INTERNAL) this._eachValues = Array(this._length);
                        else if (_each === 0) this._eachValues = null;
                        else this._eachValues = undefined;
                        this._promise._captureStackTrace();
                        this._init$(undefined, -5);
                    }
                    util.inherits(ReductionPromiseArray, PromiseArray);
                    ReductionPromiseArray.prototype._gotAccum = function(accum) {
                        if (this._eachValues !== undefined && this._eachValues !== null && accum !== INTERNAL) this._eachValues.push(accum);
                    };
                    ReductionPromiseArray.prototype._eachComplete = function(value) {
                        if (this._eachValues !== null) this._eachValues.push(value);
                        return this._eachValues;
                    };
                    ReductionPromiseArray.prototype._init = function() {};
                    ReductionPromiseArray.prototype._resolveEmptyArray = function() {
                        this._resolve(this._eachValues !== undefined ? this._eachValues : this._initialValue);
                    };
                    ReductionPromiseArray.prototype.shouldCopyValues = function() {
                        return false;
                    };
                    ReductionPromiseArray.prototype._resolve = function(value) {
                        this._promise._resolveCallback(value);
                        this._values = null;
                    };
                    ReductionPromiseArray.prototype._resultCancelled = function(sender) {
                        if (sender === this._initialValue) return this._cancel();
                        if (this._isResolved()) return;
                        this._resultCancelled$();
                        if (this._currentCancellable instanceof Promise1) this._currentCancellable.cancel();
                        if (this._initialValue instanceof Promise1) this._initialValue.cancel();
                    };
                    ReductionPromiseArray.prototype._iterate = function(values) {
                        this._values = values;
                        var value;
                        var i;
                        var length = values.length;
                        if (this._initialValue !== undefined) {
                            value = this._initialValue;
                            i = 0;
                        } else {
                            value = Promise1.resolve(values[0]);
                            i = 1;
                        }
                        this._currentCancellable = value;
                        for(var j = i; j < length; ++j){
                            var maybePromise = values[j];
                            if (maybePromise instanceof Promise1) maybePromise.suppressUnhandledRejections();
                        }
                        if (!value.isRejected()) for(; i < length; ++i){
                            var ctx = {
                                accum: null,
                                value: values[i],
                                index: i,
                                length: length,
                                array: this
                            };
                            value = value._then(gotAccum, undefined, undefined, ctx, undefined);
                            if ((i & 127) === 0) value._setNoAsyncGuarantee();
                        }
                        if (this._eachValues !== undefined) value = value._then(this._eachComplete, undefined, undefined, this, undefined);
                        value._then(completed, completed, undefined, value, this);
                    };
                    Promise1.prototype.reduce = function(fn, initialValue) {
                        return reduce(this, fn, initialValue, null);
                    };
                    Promise1.reduce = function(promises, fn, initialValue, _each) {
                        return reduce(promises, fn, initialValue, _each);
                    };
                    function completed(valueOrReason, array) {
                        if (this.isFulfilled()) array._resolve(valueOrReason);
                        else array._reject(valueOrReason);
                    }
                    function reduce(promises, fn, initialValue, _each) {
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var array = new ReductionPromiseArray(promises, fn, initialValue, _each);
                        return array.promise();
                    }
                    function gotAccum(accum) {
                        this.accum = accum;
                        this.array._gotAccum(accum);
                        var value = tryConvertToPromise(this.value, this.array._promise);
                        if (value instanceof Promise1) {
                            this.array._currentCancellable = value;
                            return value._then(gotValue, undefined, undefined, this, undefined);
                        } else return gotValue.call(this, value);
                    }
                    function gotValue(value) {
                        var array = this.array;
                        var promise = array._promise;
                        var fn = tryCatch(array._fn);
                        promise._pushContext();
                        var ret;
                        if (array._eachValues !== undefined) ret = fn.call(promise._boundValue(), value, this.index, this.length);
                        else ret = fn.call(promise._boundValue(), this.accum, value, this.index, this.length);
                        if (ret instanceof Promise1) array._currentCancellable = ret;
                        var promiseCreated = promise._popContext();
                        debug.checkForgottenReturns(ret, promiseCreated, array._eachValues !== undefined ? "Promise.each" : "Promise.reduce", promise);
                        return ret;
                    }
                };
            },
            {
                "./util": 36
            }
        ],
        29: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var util = _dereq_1("./util");
                var schedule;
                var noAsyncScheduler = function() {
                    throw new Error("No async scheduler available\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                };
                var NativePromise = util.getNativePromise();
                if (util.isNode && typeof MutationObserver === "undefined") {
                    var GlobalSetImmediate = $parcel$global.setImmediate;
                    var ProcessNextTick = $cfae44f0dfdf62c0$exports.nextTick;
                    schedule = util.isRecentNode ? function(fn) {
                        GlobalSetImmediate.call($parcel$global, fn);
                    } : function(fn) {
                        ProcessNextTick.call($cfae44f0dfdf62c0$exports, fn);
                    };
                } else if (typeof NativePromise === "function" && typeof NativePromise.resolve === "function") {
                    var nativePromise = NativePromise.resolve();
                    schedule = function(fn) {
                        nativePromise.then(fn);
                    };
                } else if (typeof MutationObserver !== "undefined" && !(typeof window !== "undefined" && window.navigator && (window.navigator.standalone || window.cordova)) && "classList" in document.documentElement) schedule = function() {
                    var div = document.createElement("div");
                    var opts = {
                        attributes: true
                    };
                    var toggleScheduled = false;
                    var div2 = document.createElement("div");
                    var o2 = new MutationObserver(function() {
                        div.classList.toggle("foo");
                        toggleScheduled = false;
                    });
                    o2.observe(div2, opts);
                    var scheduleToggle = function() {
                        if (toggleScheduled) return;
                        toggleScheduled = true;
                        div2.classList.toggle("foo");
                    };
                    return function schedule(fn) {
                        var o = new MutationObserver(function() {
                            o.disconnect();
                            fn();
                        });
                        o.observe(div, opts);
                        scheduleToggle();
                    };
                }();
                else if (typeof setImmediate !== "undefined") schedule = function(fn) {
                    setImmediate(fn);
                };
                else if (typeof setTimeout !== "undefined") schedule = function(fn) {
                    setTimeout(fn, 0);
                };
                else schedule = noAsyncScheduler;
                module1.exports = schedule;
            },
            {
                "./util": 36
            }
        ],
        30: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, debug) {
                    var PromiseInspection = Promise1.PromiseInspection;
                    var util = _dereq_1("./util");
                    function SettledPromiseArray(values) {
                        this.constructor$(values);
                    }
                    util.inherits(SettledPromiseArray, PromiseArray);
                    SettledPromiseArray.prototype._promiseResolved = function(index, inspection) {
                        this._values[index] = inspection;
                        var totalResolved = ++this._totalResolved;
                        if (totalResolved >= this._length) {
                            this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SettledPromiseArray.prototype._promiseFulfilled = function(value, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 33554432;
                        ret._settledValueField = value;
                        return this._promiseResolved(index, ret);
                    };
                    SettledPromiseArray.prototype._promiseRejected = function(reason, index) {
                        var ret = new PromiseInspection();
                        ret._bitField = 16777216;
                        ret._settledValueField = reason;
                        return this._promiseResolved(index, ret);
                    };
                    Promise1.settle = function(promises) {
                        debug.deprecated(".settle()", ".reflect()");
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.allSettled = function(promises) {
                        return new SettledPromiseArray(promises).promise();
                    };
                    Promise1.prototype.settle = function() {
                        return Promise1.settle(this);
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        31: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, PromiseArray, apiRejection) {
                    var util = _dereq_1("./util");
                    var RangeError1 = _dereq_1("./errors").RangeError;
                    var AggregateError = _dereq_1("./errors").AggregateError;
                    var isArray = util.isArray;
                    var CANCELLATION = {};
                    function SomePromiseArray(values) {
                        this.constructor$(values);
                        this._howMany = 0;
                        this._unwrap = false;
                        this._initialized = false;
                    }
                    util.inherits(SomePromiseArray, PromiseArray);
                    SomePromiseArray.prototype._init = function() {
                        if (!this._initialized) return;
                        if (this._howMany === 0) {
                            this._resolve([]);
                            return;
                        }
                        this._init$(undefined, -5);
                        var isArrayResolved = isArray(this._values);
                        if (!this._isResolved() && isArrayResolved && this._howMany > this._canPossiblyFulfill()) this._reject(this._getRangeError(this.length()));
                    };
                    SomePromiseArray.prototype.init = function() {
                        this._initialized = true;
                        this._init();
                    };
                    SomePromiseArray.prototype.setUnwrap = function() {
                        this._unwrap = true;
                    };
                    SomePromiseArray.prototype.howMany = function() {
                        return this._howMany;
                    };
                    SomePromiseArray.prototype.setHowMany = function(count) {
                        this._howMany = count;
                    };
                    SomePromiseArray.prototype._promiseFulfilled = function(value) {
                        this._addFulfilled(value);
                        if (this._fulfilled() === this.howMany()) {
                            this._values.length = this.howMany();
                            if (this.howMany() === 1 && this._unwrap) this._resolve(this._values[0]);
                            else this._resolve(this._values);
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._promiseRejected = function(reason) {
                        this._addRejected(reason);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._promiseCancelled = function() {
                        if (this._values instanceof Promise1 || this._values == null) return this._cancel();
                        this._addRejected(CANCELLATION);
                        return this._checkOutcome();
                    };
                    SomePromiseArray.prototype._checkOutcome = function() {
                        if (this.howMany() > this._canPossiblyFulfill()) {
                            var e = new AggregateError();
                            for(var i = this.length(); i < this._values.length; ++i)if (this._values[i] !== CANCELLATION) e.push(this._values[i]);
                            if (e.length > 0) this._reject(e);
                            else this._cancel();
                            return true;
                        }
                        return false;
                    };
                    SomePromiseArray.prototype._fulfilled = function() {
                        return this._totalResolved;
                    };
                    SomePromiseArray.prototype._rejected = function() {
                        return this._values.length - this.length();
                    };
                    SomePromiseArray.prototype._addRejected = function(reason) {
                        this._values.push(reason);
                    };
                    SomePromiseArray.prototype._addFulfilled = function(value) {
                        this._values[this._totalResolved++] = value;
                    };
                    SomePromiseArray.prototype._canPossiblyFulfill = function() {
                        return this.length() - this._rejected();
                    };
                    SomePromiseArray.prototype._getRangeError = function(count) {
                        var message = "Input array must contain at least " + this._howMany + " items but contains only " + count + " items";
                        return new RangeError1(message);
                    };
                    SomePromiseArray.prototype._resolveEmptyArray = function() {
                        this._reject(this._getRangeError(0));
                    };
                    function some(promises, howMany) {
                        if ((howMany | 0) !== howMany || howMany < 0) return apiRejection("expecting a positive integer\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        var ret = new SomePromiseArray(promises);
                        var promise = ret.promise();
                        ret.setHowMany(howMany);
                        ret.init();
                        return promise;
                    }
                    Promise1.some = function(promises, howMany) {
                        return some(promises, howMany);
                    };
                    Promise1.prototype.some = function(howMany) {
                        return some(this, howMany);
                    };
                    Promise1._SomePromiseArray = SomePromiseArray;
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        32: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1) {
                    function PromiseInspection(promise) {
                        if (promise !== undefined) {
                            promise = promise._target();
                            this._bitField = promise._bitField;
                            this._settledValueField = promise._isFateSealed() ? promise._settledValue() : undefined;
                        } else {
                            this._bitField = 0;
                            this._settledValueField = undefined;
                        }
                    }
                    PromiseInspection.prototype._settledValue = function() {
                        return this._settledValueField;
                    };
                    var value = PromiseInspection.prototype.value = function() {
                        if (!this.isFulfilled()) throw new TypeError("cannot get fulfillment value of a non-fulfilled promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        return this._settledValue();
                    };
                    var reason = PromiseInspection.prototype.error = PromiseInspection.prototype.reason = function() {
                        if (!this.isRejected()) throw new TypeError("cannot get rejection reason of a non-rejected promise\u000a\u000a    See http://goo.gl/MqrFmX\u000a");
                        return this._settledValue();
                    };
                    var isFulfilled = PromiseInspection.prototype.isFulfilled = function() {
                        return (this._bitField & 33554432) !== 0;
                    };
                    var isRejected = PromiseInspection.prototype.isRejected = function() {
                        return (this._bitField & 16777216) !== 0;
                    };
                    var isPending = PromiseInspection.prototype.isPending = function() {
                        return (this._bitField & 50397184) === 0;
                    };
                    var isResolved = PromiseInspection.prototype.isResolved = function() {
                        return (this._bitField & 50331648) !== 0;
                    };
                    PromiseInspection.prototype.isCancelled = function() {
                        return (this._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.__isCancelled = function() {
                        return (this._bitField & 65536) === 65536;
                    };
                    Promise1.prototype._isCancelled = function() {
                        return this._target().__isCancelled();
                    };
                    Promise1.prototype.isCancelled = function() {
                        return (this._target()._bitField & 8454144) !== 0;
                    };
                    Promise1.prototype.isPending = function() {
                        return isPending.call(this._target());
                    };
                    Promise1.prototype.isRejected = function() {
                        return isRejected.call(this._target());
                    };
                    Promise1.prototype.isFulfilled = function() {
                        return isFulfilled.call(this._target());
                    };
                    Promise1.prototype.isResolved = function() {
                        return isResolved.call(this._target());
                    };
                    Promise1.prototype.value = function() {
                        return value.call(this._target());
                    };
                    Promise1.prototype.reason = function() {
                        var target = this._target();
                        target._unsetRejectionIsUnhandled();
                        return reason.call(target);
                    };
                    Promise1.prototype._value = function() {
                        return this._settledValue();
                    };
                    Promise1.prototype._reason = function() {
                        this._unsetRejectionIsUnhandled();
                        return this._settledValue();
                    };
                    Promise1.PromiseInspection = PromiseInspection;
                };
            },
            {}
        ],
        33: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL) {
                    var util = _dereq_1("./util");
                    var errorObj = util.errorObj;
                    var isObject = util.isObject;
                    function tryConvertToPromise(obj, context) {
                        if (isObject(obj)) {
                            if (obj instanceof Promise1) return obj;
                            var then = getThen(obj);
                            if (then === errorObj) {
                                if (context) context._pushContext();
                                var ret = Promise1.reject(then.e);
                                if (context) context._popContext();
                                return ret;
                            } else if (typeof then === "function") {
                                if (isAnyBluebirdPromise(obj)) {
                                    var ret = new Promise1(INTERNAL);
                                    obj._then(ret._fulfill, ret._reject, undefined, ret, null);
                                    return ret;
                                }
                                return doThenable(obj, then, context);
                            }
                        }
                        return obj;
                    }
                    function doGetThen(obj) {
                        return obj.then;
                    }
                    function getThen(obj) {
                        try {
                            return doGetThen(obj);
                        } catch (e) {
                            errorObj.e = e;
                            return errorObj;
                        }
                    }
                    var hasProp = {}.hasOwnProperty;
                    function isAnyBluebirdPromise(obj) {
                        try {
                            return hasProp.call(obj, "_promise0");
                        } catch (e) {
                            return false;
                        }
                    }
                    function doThenable(x, then, context) {
                        var promise = new Promise1(INTERNAL);
                        var ret = promise;
                        if (context) context._pushContext();
                        promise._captureStackTrace();
                        if (context) context._popContext();
                        var synchronous = true;
                        var result = util.tryCatch(then).call(x, resolve, reject);
                        synchronous = false;
                        if (promise && result === errorObj) {
                            promise._rejectCallback(result.e, true, true);
                            promise = null;
                        }
                        function resolve(value) {
                            if (!promise) return;
                            promise._resolveCallback(value);
                            promise = null;
                        }
                        function reject(reason) {
                            if (!promise) return;
                            promise._rejectCallback(reason, synchronous, true);
                            promise = null;
                        }
                        return ret;
                    }
                    return tryConvertToPromise;
                };
            },
            {
                "./util": 36
            }
        ],
        34: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TimeoutError = Promise1.TimeoutError;
                    function HandleWrapper(handle) {
                        this.handle = handle;
                    }
                    HandleWrapper.prototype._resultCancelled = function() {
                        clearTimeout(this.handle);
                    };
                    var afterValue = function(value) {
                        return delay(+this).thenReturn(value);
                    };
                    var delay = Promise1.delay = function(ms, value) {
                        var ret;
                        var handle;
                        if (value !== undefined) {
                            ret = Promise1.resolve(value)._then(afterValue, null, null, ms, undefined);
                            if (debug.cancellation() && value instanceof Promise1) ret._setOnCancel(value);
                        } else {
                            ret = new Promise1(INTERNAL);
                            handle = setTimeout(function() {
                                ret._fulfill();
                            }, +ms);
                            if (debug.cancellation()) ret._setOnCancel(new HandleWrapper(handle));
                            ret._captureStackTrace();
                        }
                        ret._setAsyncGuaranteed();
                        return ret;
                    };
                    Promise1.prototype.delay = function(ms) {
                        return delay(ms, this);
                    };
                    var afterTimeout = function(promise, message, parent) {
                        var err;
                        if (typeof message !== "string") {
                            if (message instanceof Error) err = message;
                            else err = new TimeoutError("operation timed out");
                        } else err = new TimeoutError(message);
                        util.markAsOriginatingFromRejection(err);
                        promise._attachExtraTrace(err);
                        promise._reject(err);
                        if (parent != null) parent.cancel();
                    };
                    function successClear(value) {
                        clearTimeout(this.handle);
                        return value;
                    }
                    function failureClear(reason) {
                        clearTimeout(this.handle);
                        throw reason;
                    }
                    Promise1.prototype.timeout = function(ms, message) {
                        ms = +ms;
                        var ret, parent;
                        var handleWrapper = new HandleWrapper(setTimeout(function timeoutTimeout() {
                            if (ret.isPending()) afterTimeout(ret, message, parent);
                        }, ms));
                        if (debug.cancellation()) {
                            parent = this.then();
                            ret = parent._then(successClear, failureClear, undefined, handleWrapper, undefined);
                            ret._setOnCancel(handleWrapper);
                        } else ret = this._then(successClear, failureClear, undefined, handleWrapper, undefined);
                        return ret;
                    };
                };
            },
            {
                "./util": 36
            }
        ],
        35: [
            function(_dereq_1, module1, exports) {
                "use strict";
                module1.exports = function(Promise1, apiRejection, tryConvertToPromise, createContext, INTERNAL, debug) {
                    var util = _dereq_1("./util");
                    var TypeError1 = _dereq_1("./errors").TypeError;
                    var inherits = _dereq_1("./util").inherits;
                    var errorObj = util.errorObj;
                    var tryCatch = util.tryCatch;
                    var NULL = {};
                    function thrower(e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                    function castPreservingDisposable(thenable) {
                        var maybePromise = tryConvertToPromise(thenable);
                        if (maybePromise !== thenable && typeof thenable._isDisposable === "function" && typeof thenable._getDisposer === "function" && thenable._isDisposable()) maybePromise._setDisposable(thenable._getDisposer());
                        return maybePromise;
                    }
                    function dispose(resources, inspection) {
                        var i = 0;
                        var len = resources.length;
                        var ret = new Promise1(INTERNAL);
                        function iterator() {
                            if (i >= len) return ret._fulfill();
                            var maybePromise = castPreservingDisposable(resources[i++]);
                            if (maybePromise instanceof Promise1 && maybePromise._isDisposable()) {
                                try {
                                    maybePromise = tryConvertToPromise(maybePromise._getDisposer().tryDispose(inspection), resources.promise);
                                } catch (e) {
                                    return thrower(e);
                                }
                                if (maybePromise instanceof Promise1) return maybePromise._then(iterator, thrower, null, null, null);
                            }
                            iterator();
                        }
                        iterator();
                        return ret;
                    }
                    function Disposer(data, promise, context) {
                        this._data = data;
                        this._promise = promise;
                        this._context = context;
                    }
                    Disposer.prototype.data = function() {
                        return this._data;
                    };
                    Disposer.prototype.promise = function() {
                        return this._promise;
                    };
                    Disposer.prototype.resource = function() {
                        if (this.promise().isFulfilled()) return this.promise().value();
                        return NULL;
                    };
                    Disposer.prototype.tryDispose = function(inspection) {
                        var resource = this.resource();
                        var context = this._context;
                        if (context !== undefined) context._pushContext();
                        var ret = resource !== NULL ? this.doDispose(resource, inspection) : null;
                        if (context !== undefined) context._popContext();
                        this._promise._unsetDisposable();
                        this._data = null;
                        return ret;
                    };
                    Disposer.isDisposer = function(d) {
                        return d != null && typeof d.resource === "function" && typeof d.tryDispose === "function";
                    };
                    function FunctionDisposer(fn, promise, context) {
                        this.constructor$(fn, promise, context);
                    }
                    inherits(FunctionDisposer, Disposer);
                    FunctionDisposer.prototype.doDispose = function(resource, inspection) {
                        var fn = this.data();
                        return fn.call(resource, resource, inspection);
                    };
                    function maybeUnwrapDisposer(value) {
                        if (Disposer.isDisposer(value)) {
                            this.resources[this.index]._setDisposable(value);
                            return value.promise();
                        }
                        return value;
                    }
                    function ResourceList(length) {
                        this.length = length;
                        this.promise = null;
                        this[length - 1] = null;
                    }
                    ResourceList.prototype._resultCancelled = function() {
                        var len = this.length;
                        for(var i = 0; i < len; ++i){
                            var item = this[i];
                            if (item instanceof Promise1) item.cancel();
                        }
                    };
                    Promise1.using = function() {
                        var len = arguments.length;
                        if (len < 2) return apiRejection("you must pass at least 2 arguments to Promise.using");
                        var fn = arguments[len - 1];
                        if (typeof fn !== "function") return apiRejection("expecting a function but got " + util.classString(fn));
                        var input;
                        var spreadArgs = true;
                        if (len === 2 && Array.isArray(arguments[0])) {
                            input = arguments[0];
                            len = input.length;
                            spreadArgs = false;
                        } else {
                            input = arguments;
                            len--;
                        }
                        var resources = new ResourceList(len);
                        for(var i = 0; i < len; ++i){
                            var resource = input[i];
                            if (Disposer.isDisposer(resource)) {
                                var disposer = resource;
                                resource = resource.promise();
                                resource._setDisposable(disposer);
                            } else {
                                var maybePromise = tryConvertToPromise(resource);
                                if (maybePromise instanceof Promise1) resource = maybePromise._then(maybeUnwrapDisposer, null, null, {
                                    resources: resources,
                                    index: i
                                }, undefined);
                            }
                            resources[i] = resource;
                        }
                        var reflectedResources = new Array(resources.length);
                        for(var i = 0; i < reflectedResources.length; ++i)reflectedResources[i] = Promise1.resolve(resources[i]).reflect();
                        var resultPromise = Promise1.all(reflectedResources).then(function(inspections) {
                            for(var i = 0; i < inspections.length; ++i){
                                var inspection = inspections[i];
                                if (inspection.isRejected()) {
                                    errorObj.e = inspection.error();
                                    return errorObj;
                                } else if (!inspection.isFulfilled()) {
                                    resultPromise.cancel();
                                    return;
                                }
                                inspections[i] = inspection.value();
                            }
                            promise._pushContext();
                            fn = tryCatch(fn);
                            var ret = spreadArgs ? fn.apply(undefined, inspections) : fn(inspections);
                            var promiseCreated = promise._popContext();
                            debug.checkForgottenReturns(ret, promiseCreated, "Promise.using", promise);
                            return ret;
                        });
                        var promise = resultPromise.lastly(function() {
                            var inspection = new Promise1.PromiseInspection(resultPromise);
                            return dispose(resources, inspection);
                        });
                        resources.promise = promise;
                        promise._setOnCancel(resources);
                        return promise;
                    };
                    Promise1.prototype._setDisposable = function(disposer) {
                        this._bitField = this._bitField | 131072;
                        this._disposer = disposer;
                    };
                    Promise1.prototype._isDisposable = function() {
                        return (this._bitField & 131072) > 0;
                    };
                    Promise1.prototype._getDisposer = function() {
                        return this._disposer;
                    };
                    Promise1.prototype._unsetDisposable = function() {
                        this._bitField = this._bitField & -131073;
                        this._disposer = undefined;
                    };
                    Promise1.prototype.disposer = function(fn) {
                        if (typeof fn === "function") return new FunctionDisposer(fn, this, createContext());
                        throw new TypeError1();
                    };
                };
            },
            {
                "./errors": 12,
                "./util": 36
            }
        ],
        36: [
            function(_dereq_1, module1, exports) {
                "use strict";
                var es5 = _dereq_1("./es5");
                var canEvaluate = typeof navigator == "undefined";
                var errorObj = {
                    e: {}
                };
                var tryCatchTarget;
                var globalObject = typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : this !== undefined ? this : null;
                function tryCatcher() {
                    try {
                        var target = tryCatchTarget;
                        tryCatchTarget = null;
                        return target.apply(this, arguments);
                    } catch (e) {
                        errorObj.e = e;
                        return errorObj;
                    }
                }
                function tryCatch(fn) {
                    tryCatchTarget = fn;
                    return tryCatcher;
                }
                var inherits = function(Child, Parent) {
                    var hasProp = {}.hasOwnProperty;
                    function T() {
                        this.constructor = Child;
                        this.constructor$ = Parent;
                        for(var propertyName in Parent.prototype)if (hasProp.call(Parent.prototype, propertyName) && propertyName.charAt(propertyName.length - 1) !== "$") this[propertyName + "$"] = Parent.prototype[propertyName];
                    }
                    T.prototype = Parent.prototype;
                    Child.prototype = new T();
                    return Child.prototype;
                };
                function isPrimitive(val) {
                    return val == null || val === true || val === false || typeof val === "string" || typeof val === "number";
                }
                function isObject(value) {
                    return typeof value === "function" || typeof value === "object" && value !== null;
                }
                function maybeWrapAsError(maybeError) {
                    if (!isPrimitive(maybeError)) return maybeError;
                    return new Error(safeToString(maybeError));
                }
                function withAppended(target, appendee) {
                    var len = target.length;
                    var ret = new Array(len + 1);
                    var i;
                    for(i = 0; i < len; ++i)ret[i] = target[i];
                    ret[i] = appendee;
                    return ret;
                }
                function getDataPropertyOrDefault(obj, key, defaultValue) {
                    if (es5.isES5) {
                        var desc = Object.getOwnPropertyDescriptor(obj, key);
                        if (desc != null) return desc.get == null && desc.set == null ? desc.value : defaultValue;
                    } else return ({}).hasOwnProperty.call(obj, key) ? obj[key] : undefined;
                }
                function notEnumerableProp(obj, name, value) {
                    if (isPrimitive(obj)) return obj;
                    var descriptor = {
                        value: value,
                        configurable: true,
                        enumerable: false,
                        writable: true
                    };
                    es5.defineProperty(obj, name, descriptor);
                    return obj;
                }
                function thrower(r) {
                    throw r;
                }
                var inheritedDataKeys = function() {
                    var excludedPrototypes = [
                        Array.prototype,
                        Object.prototype,
                        Function.prototype
                    ];
                    var isExcludedProto = function(val) {
                        for(var i = 0; i < excludedPrototypes.length; ++i){
                            if (excludedPrototypes[i] === val) return true;
                        }
                        return false;
                    };
                    if (es5.isES5) {
                        var getKeys = Object.getOwnPropertyNames;
                        return function(obj) {
                            var ret = [];
                            var visitedKeys = Object.create(null);
                            while(obj != null && !isExcludedProto(obj)){
                                var keys;
                                try {
                                    keys = getKeys(obj);
                                } catch (e) {
                                    return ret;
                                }
                                for(var i = 0; i < keys.length; ++i){
                                    var key = keys[i];
                                    if (visitedKeys[key]) continue;
                                    visitedKeys[key] = true;
                                    var desc = Object.getOwnPropertyDescriptor(obj, key);
                                    if (desc != null && desc.get == null && desc.set == null) ret.push(key);
                                }
                                obj = es5.getPrototypeOf(obj);
                            }
                            return ret;
                        };
                    } else {
                        var hasProp = {}.hasOwnProperty;
                        return function(obj) {
                            if (isExcludedProto(obj)) return [];
                            var ret = [];
                            /*jshint forin:false */ enumeration: for(var key in obj)if (hasProp.call(obj, key)) ret.push(key);
                            else {
                                for(var i = 0; i < excludedPrototypes.length; ++i){
                                    if (hasProp.call(excludedPrototypes[i], key)) continue enumeration;
                                }
                                ret.push(key);
                            }
                            return ret;
                        };
                    }
                }();
                var thisAssignmentPattern = /this\s*\.\s*\S+\s*=/;
                function isClass(fn) {
                    try {
                        if (typeof fn === "function") {
                            var keys = es5.names(fn.prototype);
                            var hasMethods = es5.isES5 && keys.length > 1;
                            var hasMethodsOtherThanConstructor = keys.length > 0 && !(keys.length === 1 && keys[0] === "constructor");
                            var hasThisAssignmentAndStaticMethods = thisAssignmentPattern.test(fn + "") && es5.names(fn).length > 0;
                            if (hasMethods || hasMethodsOtherThanConstructor || hasThisAssignmentAndStaticMethods) return true;
                        }
                        return false;
                    } catch (e) {
                        return false;
                    }
                }
                function toFastProperties(obj) {
                    /*jshint -W027,-W055,-W031*/ function FakeConstructor() {}
                    FakeConstructor.prototype = obj;
                    var receiver = new FakeConstructor();
                    function ic() {
                        return typeof receiver.foo;
                    }
                    ic();
                    ic();
                    return obj;
                }
                var rident = /^[a-z$_][a-z$_0-9]*$/i;
                function isIdentifier(str) {
                    return rident.test(str);
                }
                function filledRange(count, prefix, suffix) {
                    var ret = new Array(count);
                    for(var i = 0; i < count; ++i)ret[i] = prefix + i + suffix;
                    return ret;
                }
                function safeToString(obj) {
                    try {
                        return obj + "";
                    } catch (e) {
                        return "[no string representation]";
                    }
                }
                function isError(obj) {
                    return obj instanceof Error || obj !== null && typeof obj === "object" && typeof obj.message === "string" && typeof obj.name === "string";
                }
                function markAsOriginatingFromRejection(e) {
                    try {
                        notEnumerableProp(e, "isOperational", true);
                    } catch (ignore) {}
                }
                function originatesFromRejection(e) {
                    if (e == null) return false;
                    return e instanceof Error["__BluebirdErrorTypes__"].OperationalError || e["isOperational"] === true;
                }
                function canAttachTrace(obj) {
                    return isError(obj) && es5.propertyIsWritable(obj, "stack");
                }
                var ensureErrorObject = function() {
                    if (!("stack" in new Error())) return function(value) {
                        if (canAttachTrace(value)) return value;
                        try {
                            throw new Error(safeToString(value));
                        } catch (err) {
                            return err;
                        }
                    };
                    else return function(value) {
                        if (canAttachTrace(value)) return value;
                        return new Error(safeToString(value));
                    };
                }();
                function classString(obj) {
                    return ({}).toString.call(obj);
                }
                function copyDescriptors(from, to, filter) {
                    var keys = es5.names(from);
                    for(var i = 0; i < keys.length; ++i){
                        var key = keys[i];
                        if (filter(key)) try {
                            es5.defineProperty(to, key, es5.getDescriptor(from, key));
                        } catch (ignore) {}
                    }
                }
                var asArray = function(v) {
                    if (es5.isArray(v)) return v;
                    return null;
                };
                if (typeof Symbol !== "undefined" && Symbol.iterator) {
                    var ArrayFrom = typeof Array.from === "function" ? function(v) {
                        return Array.from(v);
                    } : function(v) {
                        var ret = [];
                        var it = v[Symbol.iterator]();
                        var itResult;
                        while(!(itResult = it.next()).done)ret.push(itResult.value);
                        return ret;
                    };
                    asArray = function(v) {
                        if (es5.isArray(v)) return v;
                        else if (v != null && typeof v[Symbol.iterator] === "function") return ArrayFrom(v);
                        return null;
                    };
                }
                var isNode = false;
                var hasEnvVariables = false;
                function env(key) {
                    return hasEnvVariables ? $cfae44f0dfdf62c0$exports.env[key] : undefined;
                }
                function getNativePromise() {
                    if (typeof Promise === "function") try {
                        var promise = new Promise(function() {});
                        if (classString(promise) === "[object Promise]") return Promise;
                    } catch (e) {}
                }
                var reflectHandler;
                function contextBind(ctx, cb) {
                    if (ctx === null || typeof cb !== "function" || cb === reflectHandler) return cb;
                    if (ctx.domain !== null) cb = ctx.domain.bind(cb);
                    var async = ctx.async;
                    if (async !== null) {
                        var old = cb;
                        cb = function() {
                            var args = new Array(2).concat([].slice.call(arguments));
                            args[0] = old;
                            args[1] = this;
                            return async.runInAsyncScope.apply(async, args);
                        };
                    }
                    return cb;
                }
                var ret = {
                    setReflectHandler: function(fn) {
                        reflectHandler = fn;
                    },
                    isClass: isClass,
                    isIdentifier: isIdentifier,
                    inheritedDataKeys: inheritedDataKeys,
                    getDataPropertyOrDefault: getDataPropertyOrDefault,
                    thrower: thrower,
                    isArray: es5.isArray,
                    asArray: asArray,
                    notEnumerableProp: notEnumerableProp,
                    isPrimitive: isPrimitive,
                    isObject: isObject,
                    isError: isError,
                    canEvaluate: canEvaluate,
                    errorObj: errorObj,
                    tryCatch: tryCatch,
                    inherits: inherits,
                    withAppended: withAppended,
                    maybeWrapAsError: maybeWrapAsError,
                    toFastProperties: toFastProperties,
                    filledRange: filledRange,
                    toString: safeToString,
                    canAttachTrace: canAttachTrace,
                    ensureErrorObject: ensureErrorObject,
                    originatesFromRejection: originatesFromRejection,
                    markAsOriginatingFromRejection: markAsOriginatingFromRejection,
                    classString: classString,
                    copyDescriptors: copyDescriptors,
                    isNode: isNode,
                    hasEnvVariables: hasEnvVariables,
                    env: env,
                    global: globalObject,
                    getNativePromise: getNativePromise,
                    contextBind: contextBind
                };
                ret.isRecentNode = ret.isNode && function() {
                    var version;
                    if ($cfae44f0dfdf62c0$exports.versions && $cfae44f0dfdf62c0$exports.versions.node) version = $cfae44f0dfdf62c0$exports.versions.node.split(".").map(Number);
                    else if ($cfae44f0dfdf62c0$exports.version) version = $cfae44f0dfdf62c0$exports.version.split(".").map(Number);
                    return version[0] === 0 && version[1] > 10 || version[0] > 0;
                }();
                ret.nodeSupportsAsyncResource = ret.isNode && function() {
                    var supportsAsync = false;
                    try {
                        var res = _dereq_1("async_hooks").AsyncResource;
                        supportsAsync = typeof res.prototype.runInAsyncScope === "function";
                    } catch (e) {
                        supportsAsync = false;
                    }
                    return supportsAsync;
                }();
                if (ret.isNode) ret.toFastProperties($cfae44f0dfdf62c0$exports);
                try {
                    throw new Error();
                } catch (e) {
                    ret.lastLineError = e;
                }
                module1.exports = ret;
            },
            {
                "./es5": 13,
                "async_hooks": undefined
            }
        ]
    }, {}, [
        4
    ])(4);
});
if (typeof window !== 'undefined' && window !== null) window.P = window.Promise;
else if (typeof self !== 'undefined' && self !== null) self.P = self.Promise;



function $b798d7f31fd19976$export$b538a262033cdf07(address) {
    return [
        address?.street,
        address?.street2,
        address?.city,
        address?.state,
        address?.postal
    ].filter((n)=>!!n).join(', ');
}



function $3418b2fb7eede6e9$export$28dbab4a97a2e05f() {
    const { data: availableMakes } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'available-makes'
        ],
        queryFn: (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listVehicleMakes,
        placeholderData: [
            'Tesla',
            'Polestar'
        ] // fallback to original values
    });
    return availableMakes || [
        'Tesla',
        'Polestar'
    ];
}
function $3418b2fb7eede6e9$export$f7094f21fb3a6e5f() {
    const availableMakes = $3418b2fb7eede6e9$export$28dbab4a97a2e05f();
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { clientId: clientId, clients: clients } = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const getDefaultMake = ()=>{
        if (!clientId) return 'Tesla';
        const client = clients?.find((c)=>c.id === clientId);
        if (!client) return 'Tesla';
        if (client.name?.toLowerCase().includes('galpin')) return 'Polestar';
        return 'Tesla';
    };
    const [query, setQuery] = (0, $9963aa6f9102c92d$export$b37ee0d76c6d2fbc)({
        make: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$cc4e5467ec2866fa), getDefaultMake()),
        status: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$54e6d6dcaa879431)((0, $f1q41.map)((0, $f1q41.keys)((0, $3EyMN.NexusVehicle).Status), (0, $f1q41.toLower))), 'eligible'),
        page: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 0),
        rowsPerPage: (0, $87c38218c747143a$export$36faa878fcded3d7)((0, $edbc22aa0be45f44$export$618b01d7ec7ac09d), 100)
    });
    const [vehicleToList, setVehicleToList] = (0, $acw62.useState)({});
    const [fetchListVehiclesError, setFetchListVehiclesError] = (0, $acw62.useState)(false);
    const [isAddVehicleDrawerOpen, setIsAddVehicleDrawerOpen] = (0, $acw62.useState)(false);
    const [isUploadMultipleDrawerOpen, setIsUploadMultipleDrawerOpen] = (0, $acw62.useState)(false);
    const addVehicleMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (data)=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).addVehicle({
                programId: data.programId,
                financier: data.financier,
                vehicleJson: {
                    vin: data.vin,
                    make: data.make,
                    model: data.model,
                    trim: data.trim,
                    year: data.year,
                    exteriorColor: data.exteriorColor,
                    interiorColor: data.interiorColor,
                    startingOdometerMiles: data.startingOdometerMiles,
                    additionalDetails: data.additionalDetails
                }
            });
        },
        onSuccess: ()=>{
            setIsAddVehicleDrawerOpen(false);
            // Invalidate and refetch the vehicles query to show the new vehicle
            queryClient.invalidateQueries({
                queryKey: [
                    'getVehicles'
                ]
            });
        }
    });
    const addMultipleVehiclesMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (data)=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).addVehicles({
                programId: data.programId,
                financier: data.financier,
                vehicleJsons: data.vehicles.map((vehicle)=>({
                        vin: vehicle.vin,
                        make: vehicle.make,
                        model: vehicle.model,
                        trim: vehicle.trim,
                        year: vehicle.year,
                        exteriorColor: vehicle.exteriorColor,
                        interiorColor: vehicle.interiorColor,
                        startingOdometerMiles: vehicle.startingOdometerMiles,
                        additionalDetails: vehicle.additionalDetails
                    }))
            });
        },
        onSuccess: ()=>{
            setIsUploadMultipleDrawerOpen(false);
            // Invalidate and refetch the vehicles query to show the new vehicles
            queryClient.invalidateQueries({
                queryKey: [
                    'getVehicles'
                ]
            });
        }
    });
    const handleAddVehicle = async (data)=>{
        addVehicleMutation.mutate(data);
    };
    const handleUploadMultipleVehicles = async (data)=>{
        addMultipleVehiclesMutation.mutate(data);
    };
    const selectTab = (selectedTab)=>{
        setQuery({
            status: selectedTab.toLowerCase()
        });
    };
    /**
   * Toggles a vehicle between IN_LISTING and IN_PROCESS states.
   * Throws an error when the vehicle is not in one of these states.
   *
   * @returns {Promise} - A promise that resolves to the updated vehicle
   */ const listDelistMutation = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            // Toggle between IN_LISTING and IN_PROCESS states
            if (vehicleToList.state === (0, $9YICB.State).IN_LISTING) return (0, $930f18d689e94983$export$7b639b94d0b7f4c4).updateStateToInProcess(vehicleToList.id);
            if (vehicleToList.state === (0, $9YICB.State).IN_PROCESS) return (0, $930f18d689e94983$export$7b639b94d0b7f4c4).updateStateToInListing(vehicleToList.id);
            throw new Error('Invalid state');
        }
    });
    const listVehicle = (vehicle)=>{
        setVehicleToList(vehicle);
    };
    const onListVehicleClose = ()=>{
        setVehicleToList({});
    };
    const setPaginationModel = (paginationModel)=>{
        setQuery({
            page: paginationModel.page,
            rowsPerPage: paginationModel.pageSize
        });
    };
    const vehicleQuery = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'getVehicles',
            query
        ],
        queryFn: async ()=>{
            try {
                const res = await (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getVehicles({
                    criteriaList: [
                        {
                            property: 'status',
                            query: query.status
                        },
                        {
                            property: 'make',
                            query: query.make
                        }
                    ],
                    listByStatus: false,
                    trimPropertiesList: [],
                    page: query.page,
                    resultsPerPage: query.rowsPerPage,
                    customerId: ''
                }, null);
                return {
                    total: res.total,
                    vehiclesList: await $3418b2fb7eede6e9$export$c91095fdeeedb7af(res.vehiclesList)
                };
            } catch (error) {
                setFetchListVehiclesError(true);
                console.log('error', error);
                return {
                    total: 0,
                    vehiclesList: []
                };
            }
        },
        placeholderData: (previousData)=>previousData
    });
    return {
        total: vehicleQuery?.data?.total,
        vehicles: vehicleQuery?.data?.vehiclesList,
        vehicleQuery: vehicleQuery,
        activeTab: query.status,
        selectTab: selectTab,
        listVehicle: listVehicle,
        vehicleToList: vehicleToList,
        onListVehicleClose: onListVehicleClose,
        tabs: (0, $33cc3a71f154a56f$export$36c5d24873fc96ec),
        query: query,
        setQuery: setQuery,
        fetchListVehiclesError: fetchListVehiclesError,
        listDelistMutation: listDelistMutation,
        availableMakes: availableMakes,
        addVehicleMutation: addVehicleMutation,
        handleAddVehicle: handleAddVehicle,
        isAddVehicleDrawerOpen: isAddVehicleDrawerOpen,
        setIsAddVehicleDrawerOpen: setIsAddVehicleDrawerOpen,
        addMultipleVehiclesMutation: addMultipleVehiclesMutation,
        handleUploadMultipleVehicles: handleUploadMultipleVehicles,
        isUploadMultipleDrawerOpen: isUploadMultipleDrawerOpen,
        setIsUploadMultipleDrawerOpen: setIsUploadMultipleDrawerOpen,
        setPaginationModel: setPaginationModel
    };
}
async function $3418b2fb7eede6e9$export$c91095fdeeedb7af(vehicles) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($15d956139cf9d0d2$exports))).map(vehicles, async ({ vehicle: vehicle, status: status })=>{
        const latestCustody = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getLatestCustody({
            vehicleId: vehicle.id
        });
        const telematics = await (0, $930f18d689e94983$export$7b639b94d0b7f4c4).getTelematics(vehicle.id);
        const isEligible = vehicle.state === (0, $9YICB.State).IN_LISTING;
        return {
            isEligible: isEligible,
            id: vehicle.id,
            make: vehicle.make,
            model: vehicle.model,
            trim: vehicle.trim,
            vin: vehicle.vin,
            color: vehicle?.exteriorColorsList[0]?.title || 'N/A',
            miles: telematics?.telematicsList?.[0]?.odometer?.reading?.toString() || 'N/A',
            status: $3418b2fb7eede6e9$export$8d757bfda342fb53(status),
            dealerAddress: (0, $b798d7f31fd19976$export$b538a262033cdf07)(latestCustody?.dealership?.address),
            dealerName: latestCustody?.dealership?.name,
            bodyType: vehicle.profilesList?.[0]?.mediaListList?.[1]?.data,
            dateUpdated: latestCustody?.dealership?.updatedTime && new Date(latestCustody?.dealership?.updatedTime).toLocaleDateString(),
            list: {
                vehicle: vehicle,
                isEligible: isEligible
            }
        };
    });
}
function $3418b2fb7eede6e9$export$8d757bfda342fb53(status) {
    const state = (0, $f1q41.find)((0, $33cc3a71f154a56f$export$36c5d24873fc96ec), (s)=>{
        return s.value === status;
    });
    if (!state) return 'Unknown Status';
    return state.label;
}



parcelRequire("acw62");



var $f1q41 = parcelRequire("f1q41");
function $ba58719aa6308dbc$export$2e2bcd8739ae039({ onChange: onChange, value: value }) {
    const availableMakes = (0, $3418b2fb7eede6e9$export$28dbab4a97a2e05f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $88a0f3656f701f08$export$2e2bcd8739ae039), {
        sx: {
            marginLeft: '16px'
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $499ac2a9f7a67cb8$export$2e2bcd8739ae039), {
                htmlFor: "make-select",
                children: "Make"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                id: "make-select",
                label: "Make",
                onChange: (ev)=>onChange(ev.target.value),
                value: value,
                children: availableMakes.map((make)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                        value: make,
                        children: (0, $f1q41.upperFirst)(make)
                    }, make))
            })
        ]
    });
}





var $acw62 = parcelRequire("acw62");



"use client";
var $ab3704a7494e24f3$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M3 21h18v-2H3zM3 8v8l4-4zm8 9h10v-2H11zM3 3v2h18V3zm8 6h10V7H11zm0 4h10v-2H11z"
}), 'FormatIndentIncrease');



"use client";
var $6170a7275bffce61$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3"
}), 'Visibility');



"use client";
var $2fbf86b231223ed0$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z"
}), 'VisibilityOff');



/**
 * Validates if a string is valid JSON
 * @param jsonString - The string to validate
 * @returns Object with isValid boolean and error message if invalid
 */ function $7e27ae12ebf17737$export$c26cb9bb68f74f76(jsonString) {
    if (!jsonString || jsonString.trim() === '') return {
        isValid: true
    }; // Empty is valid
    try {
        JSON.parse(jsonString);
        return {
            isValid: true
        };
    } catch (error) {
        return {
            isValid: false,
            error: error instanceof Error ? error.message : 'Invalid JSON format'
        };
    }
}
function $7e27ae12ebf17737$export$6137f325a331a4c3(jsonString) {
    if (!jsonString || jsonString.trim() === '') return jsonString;
    try {
        const parsed = JSON.parse(jsonString);
        return JSON.stringify(parsed, null, 2);
    } catch (error) {
        console.log(error);
        return jsonString;
    }
}






const $9801e4aa11baca7a$export$d3a02d4587c189a = ({ errors: errors, control: control })=>{
    const [showJsonPreview, setShowJsonPreview] = (0, $acw62.useState)(false);
    const [jsonPreviewData, setJsonPreviewData] = (0, $acw62.useState)(null);
    const clientContext = (0, $acw62.useContext)((0, $1ed44f525ea4bba9$export$56e68f8f57ecfde4));
    const clientId = clientContext?.clientId || '';
    const selectedProgramId = (0, $0d70f179cf56e662$export$3c773aa2b84f29e0)({
        control: control,
        name: 'programId'
    });
    const { field: makeField } = (0, $0d70f179cf56e662$export$e8c786024a2b0a79)({
        name: 'make',
        control: control,
        rules: {
            required: 'Make is required'
        }
    });
    const { field: modelField } = (0, $0d70f179cf56e662$export$e8c786024a2b0a79)({
        name: 'model',
        control: control,
        rules: {
            required: 'Model is required'
        }
    });
    const { data: programsData } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/listPrograms',
            clientId
        ],
        queryFn: ()=>(0, $f647fd23fa4d1073$export$16d7a02b7436f06e).listPrograms(clientId),
        initialData: {
            programsList: []
        },
        enabled: !!clientId,
        staleTime: 0,
        refetchOnMount: 'always'
    });
    const programs = Array.isArray(programsData?.programsList) ? programsData.programsList : [];
    const selectedProgram = programs.find((program)=>program.id === selectedProgramId);
    (0, $acw62.useEffect)(()=>{
        makeField.onChange(selectedProgram?.make || '');
        modelField.onChange(selectedProgram?.model || '');
    }, [
        makeField,
        modelField,
        selectedProgram
    ]);
    const handleJsonPreview = (jsonString)=>{
        if (!jsonString || jsonString.trim() === '') {
            setJsonPreviewData(null);
            setShowJsonPreview(!showJsonPreview);
            return;
        }
        try {
            const parsed = JSON.parse(jsonString);
            setJsonPreviewData(parsed);
        } catch (e) {
            setJsonPreviewData(null);
            console.log(e);
        }
        setShowJsonPreview(!showJsonPreview);
    };
    const handleFormatJson = (field)=>{
        const formatted = (0, $7e27ae12ebf17737$export$6137f325a331a4c3)(field.value);
        field.onChange(formatted);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            mt: 2
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "h6",
                gutterBottom: true,
                children: "Vehicle Information"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "programId",
                            control: control,
                            rules: {
                                required: 'Program ID is required'
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    select: true,
                                    label: "Program",
                                    onChange: (event)=>{
                                        field.onChange(event);
                                    },
                                    error: !!errors.programId,
                                    helperText: errors.programId?.message,
                                    children: programs.map((program)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                            value: program.id,
                                            children: program.description
                                        }, program.id))
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "financier",
                            control: control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "Financier",
                                    disabled: true,
                                    error: !!errors.financier,
                                    helperText: errors.financier?.message
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "vin",
                            control: control,
                            rules: {
                                required: 'VIN is required'
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "VIN",
                                    error: !!errors.vin,
                                    helperText: errors.vin?.message
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            ...makeField,
                            fullWidth: true,
                            label: "Make",
                            disabled: true,
                            error: !!errors.make,
                            helperText: errors.make?.message
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                            ...modelField,
                            fullWidth: true,
                            label: "Model",
                            disabled: true,
                            error: !!errors.model,
                            helperText: errors.model?.message
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "trim",
                            control: control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "Trim",
                                    error: !!errors.trim,
                                    helperText: errors.trim?.message
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "year",
                            control: control,
                            rules: {
                                required: 'Year is required',
                                min: {
                                    value: 1900,
                                    message: 'Year must be after 1900'
                                },
                                max: {
                                    value: new Date().getFullYear() + 1,
                                    message: 'Year cannot be in the future'
                                }
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "Year",
                                    type: "number",
                                    error: !!errors.year,
                                    helperText: errors.year?.message,
                                    onChange: (e)=>field.onChange(parseInt(e.target.value) || '')
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "exteriorColor",
                            control: control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "Exterior Color",
                                    error: !!errors.exteriorColor,
                                    helperText: errors.exteriorColor?.message
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "interiorColor",
                            control: control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "Interior Color",
                                    error: !!errors.interiorColor,
                                    helperText: errors.interiorColor?.message
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "startingOdometerMiles",
                            control: control,
                            rules: {
                                required: 'Starting odometer miles is required',
                                min: {
                                    value: 0,
                                    message: 'Miles cannot be negative'
                                }
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "Starting Odometer Miles",
                                    type: "number",
                                    error: !!errors.startingOdometerMiles,
                                    helperText: errors.startingOdometerMiles?.message,
                                    onChange: (e)=>field.onChange(parseInt(e.target.value) || '')
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "additionalDetails",
                            control: control,
                            rules: {
                                validate: (value)=>{
                                    if (!value || value.trim() === '') return true;
                                    const validation = (0, $7e27ae12ebf17737$export$c26cb9bb68f74f76)(value);
                                    return validation.isValid || validation.error;
                                }
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 1,
                                                mb: 1
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "subtitle2",
                                                    children: "Additional Details (JSON)"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                                    title: "Format JSON",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                        size: "small",
                                                        onClick: ()=>handleFormatJson(field),
                                                        disabled: !field.value,
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ab3704a7494e24f3$export$2e2bcd8739ae039), {
                                                            fontSize: "small"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                                    title: showJsonPreview ? 'Hide preview' : 'Show preview',
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                        size: "small",
                                                        onClick: ()=>handleJsonPreview(field.value),
                                                        disabled: !field.value,
                                                        children: showJsonPreview ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2fbf86b231223ed0$export$2e2bcd8739ae039), {
                                                            fontSize: "small"
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6170a7275bffce61$export$2e2bcd8739ae039), {
                                                            fontSize: "small"
                                                        })
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                            ...field,
                                            fullWidth: true,
                                            multiline: true,
                                            rows: 4,
                                            placeholder: '{"key": "value"}',
                                            error: !!errors.additionalDetails,
                                            helperText: errors.additionalDetails?.message || 'Enter valid JSON format'
                                        }),
                                        showJsonPreview && jsonPreviewData && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                mt: 2,
                                                maxHeight: 300,
                                                overflow: 'auto'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                    variant: "caption",
                                                    sx: {
                                                        mb: 1,
                                                        display: 'block'
                                                    },
                                                    children: "JSON Preview:"
                                                }),
                                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f6f8982f63abb9b$export$2e2bcd8739ae039), {
                                                    displayDataTypes: false,
                                                    value: jsonPreviewData,
                                                    collapsed: 1,
                                                    style: {
                                                        width: '100%',
                                                        overflowX: 'auto'
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                })
                        })
                    })
                ]
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



"use client";
var $af7008da7e6d6ab9$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96M14 13v4h-4v-4H7l5-5 5 5z"
}), 'CloudUpload');



"use client";
var $efe2bdf7177eb81c$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.89-2-2-2m0 16H5V7h14zm-5.5-6c0 .83-.67 1.5-1.5 1.5s-1.5-.67-1.5-1.5.67-1.5 1.5-1.5 1.5.67 1.5 1.5M12 9c-2.73 0-5.06 1.66-6 4 .94 2.34 3.27 4 6 4s5.06-1.66 6-4c-.94-2.34-3.27-4-6-4m0 6.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5"
}), 'Preview');



function $25aa4bbf42dc9c6b$export$42ff9ca196b7255f(csvContent) {
    try {
        const lines = csvContent.trim().split('\n');
        if (lines.length < 2) return {
            success: false,
            vehicles: [],
            count: 0,
            error: 'CSV must have at least a header row and one data row'
        };
        const headers = lines[0].split(',').map((h)=>h.trim().toLowerCase());
        const vehicles = [];
        // Required headers mapping
        const headerMap = {
            vin: [
                'vin',
                'vehicle_identification_number'
            ],
            make: [
                'make',
                'manufacturer'
            ],
            model: [
                'model'
            ],
            trim: [
                'trim',
                'variant'
            ],
            year: [
                'year',
                'model_year'
            ],
            exteriorColor: [
                'exterior_color',
                'exteriorcolor',
                'color',
                'paint_color'
            ],
            interiorColor: [
                'interior_color',
                'interiorcolor',
                'interior'
            ],
            startingOdometerMiles: [
                'starting_odometer_miles',
                'odometer',
                'miles',
                'mileage'
            ],
            additionalDetails: [
                'additional_details',
                'details',
                'notes'
            ]
        };
        // Find column indices for each field
        const columnIndices = {};
        for (const [field, possibleHeaders] of Object.entries(headerMap)){
            const index = headers.findIndex((h)=>possibleHeaders.includes(h));
            if (index !== -1) columnIndices[field] = index;
        }
        // Validate required fields
        const requiredFields = [
            'vin',
            'make',
            'model',
            'year'
        ];
        const missingFields = requiredFields.filter((field)=>columnIndices[field] === undefined);
        if (missingFields.length > 0) return {
            success: false,
            vehicles: [],
            count: 0,
            error: `Missing required columns: ${missingFields.join(', ')}`
        };
        // Parse data rows
        for(let i = 1; i < lines.length; i++){
            const values = lines[i].split(',').map((v)=>v.trim());
            try {
                const vehicle = {
                    vin: values[columnIndices.vin] || '',
                    make: values[columnIndices.make] || '',
                    model: values[columnIndices.model] || '',
                    trim: values[columnIndices.trim] || '',
                    year: parseInt(values[columnIndices.year]) || new Date().getFullYear(),
                    exteriorColor: values[columnIndices.exteriorColor] || '',
                    interiorColor: values[columnIndices.interiorColor] || '',
                    startingOdometerMiles: parseInt(values[columnIndices.startingOdometerMiles]) || 0,
                    additionalDetails: values[columnIndices.additionalDetails] || ''
                };
                // Basic validation
                if (!vehicle.vin || !vehicle.make || !vehicle.model) continue; // Skip invalid rows
                vehicles.push(vehicle);
            } catch (error) {
                console.warn(`Skipping invalid row ${i + 1}:`, error);
            }
        }
        return {
            success: true,
            vehicles: vehicles,
            count: vehicles.length,
            error: vehicles.length === 0 ? 'No valid vehicle data found' : undefined
        };
    } catch (error) {
        return {
            success: false,
            vehicles: [],
            count: 0,
            error: `CSV parsing error: ${error instanceof Error ? error.message : 'Unknown error'}`
        };
    }
}
function $25aa4bbf42dc9c6b$export$27924e57e9afff7f(jsonContent) {
    try {
        const data = JSON.parse(jsonContent);
        let vehicles = [];
        // Handle both array of vehicles and single vehicle
        if (Array.isArray(data)) vehicles = data;
        else if (typeof data === 'object' && data !== null) vehicles = [
            data
        ];
        else return {
            success: false,
            vehicles: [],
            count: 0,
            error: 'JSON must be an object or array of objects'
        };
        // Validate and normalize each vehicle
        const validVehicles = [];
        for (const vehicle of vehicles)try {
            const normalizedVehicle = {
                vin: vehicle.vin || '',
                make: vehicle.make || '',
                model: vehicle.model || '',
                trim: vehicle.trim || '',
                year: typeof vehicle.year === 'number' ? vehicle.year : parseInt(vehicle.year) || new Date().getFullYear(),
                exteriorColor: vehicle.exteriorColor || '',
                interiorColor: vehicle.interiorColor || '',
                startingOdometerMiles: typeof vehicle.startingOdometerMiles === 'number' ? vehicle.startingOdometerMiles : parseInt(vehicle.startingOdometerMiles) || 0,
                additionalDetails: vehicle.additionalDetails || ''
            };
            // Basic validation
            if (!normalizedVehicle.vin || !normalizedVehicle.make || !normalizedVehicle.model) continue; // Skip invalid vehicles
            validVehicles.push(normalizedVehicle);
        } catch (error) {
            console.warn('Skipping invalid vehicle:', error);
        }
        return {
            success: true,
            vehicles: validVehicles,
            count: validVehicles.length,
            error: validVehicles.length === 0 ? 'No valid vehicle data found' : undefined
        };
    } catch (error) {
        return {
            success: false,
            vehicles: [],
            count: 0,
            error: `JSON parsing error: ${error instanceof Error ? error.message : 'Invalid JSON format'}`
        };
    }
}
function $25aa4bbf42dc9c6b$export$f1c553d4f1a2351(file) {
    return new Promise((resolve)=>{
        const reader = new FileReader();
        reader.onload = (e)=>{
            const content = e.target?.result;
            if (!content) {
                resolve({
                    success: false,
                    vehicles: [],
                    count: 0,
                    error: 'Failed to read file content'
                });
                return;
            }
            const fileExtension = file.name.toLowerCase().split('.').pop();
            if (fileExtension === 'csv') resolve($25aa4bbf42dc9c6b$export$42ff9ca196b7255f(content));
            else if (fileExtension === 'json') resolve($25aa4bbf42dc9c6b$export$27924e57e9afff7f(content));
            else resolve({
                success: false,
                vehicles: [],
                count: 0,
                error: 'Unsupported file format. Please use CSV or JSON files.'
            });
        };
        reader.onerror = ()=>{
            resolve({
                success: false,
                vehicles: [],
                count: 0,
                error: 'Failed to read file'
            });
        };
        reader.readAsText(file);
    });
}


const $552a5a04aa1d9d27$export$25c9459780049bdf = ({ errors: errors, control: control })=>{
    const [uploadedFile, setUploadedFile] = (0, $acw62.useState)(null);
    const [parseResult, setParseResult] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [showPreview, setShowPreview] = (0, $acw62.useState)(false);
    const handleFileUpload = async (event, onChange)=>{
        const file = event.target.files?.[0];
        if (!file) return;
        setIsLoading(true);
        setUploadedFile(file);
        try {
            const result = await (0, $25aa4bbf42dc9c6b$export$f1c553d4f1a2351)(file);
            setParseResult(result);
            // Update the form control with the parsed vehicles
            if (result.success) onChange(result.vehicles);
            else onChange([]);
        } catch (error) {
            setParseResult({
                success: false,
                vehicles: [],
                count: 0,
                error: 'Failed to parse file'
            });
            console.log(error);
            onChange([]);
        } finally{
            setIsLoading(false);
        }
    };
    const handleRemoveFile = (onChange)=>{
        setUploadedFile(null);
        setParseResult(null);
        setShowPreview(false);
        onChange([]);
        // Reset file input
        const fileInput = document.getElementById('vehicle-file-upload');
        if (fileInput) fileInput.value = '';
    };
    const renderFileStatus = (onChange)=>{
        if (!uploadedFile) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
            sx: {
                p: 2,
                mt: 2,
                backgroundColor: '#f5f5f5'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between'
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "subtitle2",
                                    sx: {
                                        fontWeight: 'bold'
                                    },
                                    children: uploadedFile.name
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "caption",
                                    color: "textSecondary",
                                    children: [
                                        (uploadedFile.size / 1024).toFixed(1),
                                        " KB"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            },
                            children: [
                                parseResult && parseResult.success && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $08a2e84130921e51$export$2e2bcd8739ae039), {
                                            label: `${parseResult.count} vehicles`,
                                            color: "success",
                                            size: "small"
                                        }),
                                        parseResult.count > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                            title: "Preview vehicles",
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                size: "small",
                                                onClick: ()=>setShowPreview(!showPreview),
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $efe2bdf7177eb81c$export$2e2bcd8739ae039), {
                                                    fontSize: "small"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                    title: "Remove file",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                        size: "small",
                                        onClick: ()=>handleRemoveFile(onChange),
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {
                                            fontSize: "small"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                parseResult && !parseResult.success && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                    severity: "error",
                    sx: {
                        mt: 1
                    },
                    children: parseResult.error
                }),
                parseResult && parseResult.success && parseResult.count === 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                    severity: "warning",
                    sx: {
                        mt: 1
                    },
                    children: "No valid vehicle data found in the file"
                })
            ]
        });
    };
    const renderVehiclePreview = ()=>{
        if (!showPreview || !parseResult || !parseResult.success || parseResult.vehicles.length === 0) return null;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
            sx: {
                p: 2,
                mt: 2,
                maxHeight: 300,
                overflow: 'auto'
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "subtitle2",
                    sx: {
                        mb: 1,
                        fontWeight: 'bold'
                    },
                    children: [
                        "Vehicle Preview (",
                        parseResult.count,
                        " vehicles)"
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
                    dense: true,
                    children: [
                        parseResult.vehicles.slice(0, 10).map((vehicle, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                                sx: {
                                    py: 0.5
                                },
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7cd8ac1360c47a2$export$2e2bcd8739ae039), {
                                    primary: `${vehicle.year} ${vehicle.make} ${vehicle.model} ${vehicle.trim}`,
                                    secondary: `VIN: ${vehicle.vin} | Color: ${vehicle.exteriorColor} | Miles: ${vehicle.startingOdometerMiles}`,
                                    primaryTypographyProps: {
                                        variant: 'body2',
                                        fontWeight: 'medium'
                                    },
                                    secondaryTypographyProps: {
                                        variant: 'caption'
                                    }
                                })
                            }, index)),
                        parseResult.vehicles.length > 10 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a7cd8ac1360c47a2$export$2e2bcd8739ae039), {
                                primary: `... and ${parseResult.vehicles.length - 10} more vehicles`,
                                primaryTypographyProps: {
                                    variant: 'caption',
                                    fontStyle: 'italic'
                                }
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            mt: 2
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "h6",
                gutterBottom: true,
                children: "Upload Multiple Vehicles"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "programId",
                            control: control,
                            rules: {
                                required: 'Program ID is required'
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "Program ID",
                                    error: !!errors.programId,
                                    helperText: errors.programId?.message
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            sm: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "financier",
                            control: control,
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    ...field,
                                    fullWidth: true,
                                    label: "Financier",
                                    error: !!errors.financier,
                                    helperText: errors.financier?.message
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "subtitle1",
                                gutterBottom: true,
                                children: "Vehicle Data File"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                variant: "body2",
                                color: "textSecondary",
                                sx: {
                                    mb: 2
                                },
                                children: "Upload a CSV or JSON file containing vehicle information. The file should include columns for VIN, make, model, year, and other vehicle details."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: "vehicles",
                                control: control,
                                rules: {
                                    validate: (value)=>{
                                        if (!value || value.length === 0) return 'Please upload a valid vehicle file';
                                        return true;
                                    }
                                },
                                render: ({ field: { onChange: onChange } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                                accept: ".csv,.json",
                                                style: {
                                                    display: 'none'
                                                },
                                                id: "vehicle-file-upload",
                                                type: "file",
                                                onChange: (e)=>handleFileUpload(e, onChange),
                                                disabled: isLoading
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                                htmlFor: "vehicle-file-upload",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                                    variant: "outlined",
                                                    component: "span",
                                                    startIcon: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $af7008da7e6d6ab9$export$2e2bcd8739ae039), {}),
                                                    disabled: isLoading,
                                                    fullWidth: !uploadedFile,
                                                    children: isLoading ? 'Processing...' : uploadedFile ? 'Change File' : 'Upload Vehicle File'
                                                })
                                            }),
                                            renderFileStatus(onChange),
                                            renderVehiclePreview()
                                        ]
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                            severity: "info",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                        children: "File Format Requirements:"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    component: "div",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "CSV:"
                                        }),
                                        " Must include headers: vin, make, model, year (required). Optional: trim, exterior_color, interior_color, starting_odometer_miles, additional_details"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    component: "div",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                            children: "JSON:"
                                        }),
                                        " Array of vehicle objects or single vehicle object with the same properties"
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};


const $dbfd352e59003ee7$export$b4cf1bc71356e54c = ()=>{
    const { tabs: tabs, vehicles: vehicles, selectTab: selectTab, activeTab: activeTab, vehicleToList: vehicleToList, onListVehicleClose: onListVehicleClose, vehicleQuery: vehicleQuery, fetchListVehiclesError: fetchListVehiclesError, listVehicle: listVehicle, listDelistMutation: listDelistMutation, total: total, setPaginationModel: setPaginationModel, query: query, setQuery: setQuery, addVehicleMutation: addVehicleMutation, handleAddVehicle: handleAddVehicle, isAddVehicleDrawerOpen: isAddVehicleDrawerOpen, setIsAddVehicleDrawerOpen: setIsAddVehicleDrawerOpen, addMultipleVehiclesMutation: addMultipleVehiclesMutation, handleUploadMultipleVehicles: handleUploadMultipleVehicles, isUploadMultipleDrawerOpen: isUploadMultipleDrawerOpen, setIsUploadMultipleDrawerOpen: setIsUploadMultipleDrawerOpen } = (0, $3418b2fb7eede6e9$export$f7094f21fb3a6e5f)();
    const isHidden = ()=>{
        return tabs.ASSIGNED.label.toLowerCase() === activeTab || tabs.SUBSCRIBED.label.toLowerCase() === activeTab;
    };
    const columns = [
        // {
        //   field: 'bodyType',
        //   headerName: ' ',
        //   flex: 0.5,
        //   renderCell: BodyStyleCell,
        // },
        {
            field: 'make',
            headerName: 'Make',
            flex: 0.5
        },
        {
            field: 'model',
            headerName: 'Model',
            flex: 0.5
        },
        {
            field: 'trim',
            headerName: 'Trim',
            flex: 1
        },
        {
            field: 'miles',
            headerName: 'Miles',
            flex: 0.5
        },
        {
            field: 'color',
            headerName: 'Color',
            flex: 0.5
        },
        {
            field: 'vin',
            headerName: 'Vin',
            flex: 1
        },
        {
            field: 'dealer',
            headerName: 'Dealership',
            flex: 1.2,
            renderCell (props) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                    title: props.row.dealerAddress,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: props.row.dealerName
                    })
                });
            }
        },
        {
            field: 'dealerAddress',
            headerName: 'Dealer Address',
            flex: 1.5,
            renderCell (props) {
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                    title: props.row.dealerAddress,
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: props.row.dealerAddress
                    })
                });
            }
        },
        {
            field: 'list',
            headerName: 'List/Delist',
            flex: 1,
            renderCell: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3d992edb82f5c3e3$export$2e2bcd8739ae039), {
                    ...props,
                    handler: listVehicle
                })
        },
        {
            field: 'vehicleDetail',
            headerName: 'View Vehicle',
            flex: 1,
            renderCell: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84404855a4d2255b$export$2e2bcd8739ae039), {
                    ...props,
                    from: "listings"
                })
        }
    ];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                sx: {
                    marginLeft: '5px'
                },
                variant: "h1",
                children: "Listings"
            }),
            addVehicleMutation.isSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                    onClose: ()=>addVehicleMutation.reset(),
                    children: "Vehicle added successfully."
                })
            }),
            addMultipleVehiclesMutation.isSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                    onClose: ()=>addMultipleVehiclesMutation.reset(),
                    children: "Multiple vehicles added successfully."
                })
            }),
            addMultipleVehiclesMutation.isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                    severity: "error",
                    onClose: ()=>addMultipleVehiclesMutation.reset(),
                    children: addMultipleVehiclesMutation.error instanceof Error ? addMultipleVehiclesMutation.error.message : 'Failed to add multiple vehicles'
                })
            }),
            listDelistMutation.isSuccess && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                    onClose: ()=>listDelistMutation.reset(),
                    children: "Update Successful."
                })
            }),
            listDelistMutation.isError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $11072e450c597f96$export$2e2bcd8739ae039), {
                    severity: "error",
                    onClose: ()=>listDelistMutation.reset(),
                    children: listDelistMutation.error?.message
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            margin: '20px 10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5e982866f158f2e$export$2e2bcd8739ae039), {
                                isSelected: tabs.ELIGIBLE.label.toLowerCase() === activeTab,
                                onClick: ()=>selectTab(tabs.ELIGIBLE.label),
                                children: tabs.ELIGIBLE.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5e982866f158f2e$export$2e2bcd8739ae039), {
                                isSelected: tabs.INELIGIBLE.label.toLowerCase() === activeTab,
                                onClick: ()=>selectTab(tabs.INELIGIBLE.label),
                                children: tabs.INELIGIBLE.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5e982866f158f2e$export$2e2bcd8739ae039), {
                                isSelected: tabs.ASSIGNED.label.toLowerCase() === activeTab,
                                onClick: ()=>selectTab(tabs.ASSIGNED.label),
                                children: tabs.ASSIGNED.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5e982866f158f2e$export$2e2bcd8739ae039), {
                                isSelected: tabs.SUBSCRIBED.label.toLowerCase() === activeTab,
                                onClick: ()=>selectTab(tabs.SUBSCRIBED.label),
                                children: tabs.SUBSCRIBED.label
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ba58719aa6308dbc$export$2e2bcd8739ae039), {
                                onChange: (selectedMake)=>setQuery({
                                        make: selectedMake
                                    }),
                                value: query.make
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    marginLeft: 'auto',
                                    paddingRight: '16px',
                                    display: 'flex',
                                    gap: 1
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                        variant: "outlined",
                                        onClick: ()=>setIsUploadMultipleDrawerOpen(true),
                                        children: "Upload Multiple"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                        variant: "contained",
                                        onClick: ()=>setIsAddVehicleDrawerOpen(true),
                                        children: "Add Vehicle"
                                    })
                                ]
                            })
                        ]
                    }),
                    !fetchListVehiclesError && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                        rows: vehicles,
                        rowCount: total,
                        columns: columns,
                        loading: vehicleQuery.isLoading || vehicleQuery.isFetching,
                        columnVisibilityModel: {
                            list: !isHidden()
                        },
                        disableColumnFilter: true,
                        paginationMode: "server",
                        pageSizeOptions: [
                            25,
                            50,
                            100
                        ],
                        paginationModel: {
                            page: query.page,
                            pageSize: query.rowsPerPage
                        },
                        onPaginationModelChange: (newPaginationModel)=>setPaginationModel(newPaginationModel)
                    }),
                    !!vehicleToList.id && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2992e39795c18a6c$export$9bdab767eeada07f), {
                        open: !!vehicleToList.id,
                        onClose: onListVehicleClose,
                        listDelistMutation: listDelistMutation
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                        isDrawerOpen: isAddVehicleDrawerOpen,
                        setIsDrawerOpen: setIsAddVehicleDrawerOpen,
                        header: "Add Vehicle",
                        handleSave: handleAddVehicle,
                        form: (0, $9801e4aa11baca7a$export$d3a02d4587c189a),
                        defaultValues: {
                            programId: '',
                            financier: 'Spouting Rock',
                            vin: '',
                            make: '',
                            model: '',
                            trim: '',
                            year: new Date().getFullYear(),
                            exteriorColor: '',
                            interiorColor: '',
                            startingOdometerMiles: 0,
                            additionalDetails: ''
                        }
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                        isDrawerOpen: isUploadMultipleDrawerOpen,
                        setIsDrawerOpen: setIsUploadMultipleDrawerOpen,
                        header: "Upload Multiple Vehicles",
                        handleSave: handleUploadMultipleVehicles,
                        form: (0, $552a5a04aa1d9d27$export$25c9459780049bdf),
                        defaultValues: {
                            programId: '',
                            financier: '',
                            vehicles: []
                        }
                    })
                ]
            })
        ]
    });
};



var $acw62 = parcelRequire("acw62");
'use client';
const $38e2e4dba3e7e5d8$export$b16d9fb1a22de840 = (0, $acw62.createContext)(null);
const $38e2e4dba3e7e5d8$var$initialState = {
    didCatch: false,
    error: null
};
class $38e2e4dba3e7e5d8$export$e926676385687eaf extends (0, $acw62.Component) {
    constructor(props){
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = $38e2e4dba3e7e5d8$var$initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error: error
        };
    }
    resetErrorBoundary() {
        const { error: error } = this.state;
        if (error !== null) {
            var _this$props$onReset, _this$props;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            (_this$props$onReset = (_this$props = this.props).onReset) === null || _this$props$onReset === void 0 || _this$props$onReset.call(_this$props, {
                args: args,
                reason: "imperative-api"
            });
            this.setState($38e2e4dba3e7e5d8$var$initialState);
        }
    }
    componentDidCatch(error, info) {
        var _this$props$onError, _this$props2;
        (_this$props$onError = (_this$props2 = this.props).onError) === null || _this$props$onError === void 0 || _this$props$onError.call(_this$props2, error, info);
    }
    componentDidUpdate(prevProps, prevState) {
        const { didCatch: didCatch } = this.state;
        const { resetKeys: resetKeys } = this.props;
        // There's an edge case where if the thing that triggered the error happens to *also* be in the resetKeys array,
        // we'd end up resetting the error boundary immediately.
        // This would likely trigger a second error to be thrown.
        // So we make sure that we don't check the resetKeys on the first call of cDU after the error is set.
        if (didCatch && prevState.error !== null && $38e2e4dba3e7e5d8$var$hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            var _this$props$onReset2, _this$props3;
            (_this$props$onReset2 = (_this$props3 = this.props).onReset) === null || _this$props$onReset2 === void 0 || _this$props$onReset2.call(_this$props3, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys"
            });
            this.setState($38e2e4dba3e7e5d8$var$initialState);
        }
    }
    render() {
        const { children: children, fallbackRender: fallbackRender, FallbackComponent: FallbackComponent, fallback: fallback } = this.props;
        const { didCatch: didCatch, error: error } = this.state;
        let childToRender = children;
        if (didCatch) {
            const props = {
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            };
            if (typeof fallbackRender === "function") childToRender = fallbackRender(props);
            else if (FallbackComponent) childToRender = (0, $acw62.createElement)(FallbackComponent, props);
            else if (fallback !== undefined) childToRender = fallback;
            else throw error;
        }
        return (0, $acw62.createElement)($38e2e4dba3e7e5d8$export$b16d9fb1a22de840.Provider, {
            value: {
                didCatch: didCatch,
                error: error,
                resetErrorBoundary: this.resetErrorBoundary
            }
        }, childToRender);
    }
}
function $38e2e4dba3e7e5d8$var$hasArrayChanged() {
    let a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return a.length !== b.length || a.some((item, index)=>!Object.is(item, b[index]));
}
function $38e2e4dba3e7e5d8$var$assertErrorBoundaryContext(value) {
    if (value == null || typeof value.didCatch !== "boolean" || typeof value.resetErrorBoundary !== "function") throw new Error("ErrorBoundaryContext not found");
}
function $38e2e4dba3e7e5d8$export$c052f6604b7d51fe() {
    const context = (0, $acw62.useContext)($38e2e4dba3e7e5d8$export$b16d9fb1a22de840);
    $38e2e4dba3e7e5d8$var$assertErrorBoundaryContext(context);
    const [state, setState] = (0, $acw62.useState)({
        error: null,
        hasError: false
    });
    const memoized = (0, $acw62.useMemo)(()=>({
            resetBoundary: ()=>{
                context.resetErrorBoundary();
                setState({
                    error: null,
                    hasError: false
                });
            },
            showBoundary: (error)=>setState({
                    error: error,
                    hasError: true
                })
        }), [
        context.resetErrorBoundary
    ]);
    if (state.hasError) throw state.error;
    return memoized;
}
function $38e2e4dba3e7e5d8$export$f0c7a449e0cfaec7(component, errorBoundaryProps) {
    const Wrapped = (0, $acw62.forwardRef)((props, ref)=>(0, $acw62.createElement)($38e2e4dba3e7e5d8$export$e926676385687eaf, errorBoundaryProps, (0, $acw62.createElement)(component, {
            ...props,
            ref: ref
        })));
    // Format for display in DevTools
    const name = component.displayName || component.name || "Unknown";
    Wrapped.displayName = "withErrorBoundary(".concat(name, ")");
    return Wrapped;
}




var $acw62 = parcelRequire("acw62");

const $e5ccd45368c6fef8$export$360df563ae2167f5 = ({ children: children })=>{
    var _a;
    const { navigator: navigator } = (0, $acw62.useContext)((0, $84c11e79798ea0cb$export$3044ab7fdabeaee6));
    const navigate = (0, $84c11e79798ea0cb$export$9770f232ac06a008)();
    const router = (_a = (0, $acw62.useContext)((0, $84c11e79798ea0cb$export$2eeee58951ff3c1c))) == null ? void 0 : _a.router;
    const location = (0, $84c11e79798ea0cb$export$45d76561a5302f2b)();
    const adapter = {
        replace (location2) {
            navigate(location2.search || "?", {
                replace: true,
                state: location2.state
            });
        },
        push (location2) {
            navigate(location2.search || "?", {
                replace: false,
                state: location2.state
            });
        },
        get location () {
            var _a2, _b, _c;
            return (_c = (_b = (_a2 = router == null ? void 0 : router.state) == null ? void 0 : _a2.location) != null ? _b : navigator == null ? void 0 : navigator.location) != null ? _c : location;
        }
    };
    return children(adapter);
};



parcelRequire("acw62");





parcelRequire("acw62");

const $3ca6931de5665f23$var$DeleteDialog = ({ open: open, handleClose: handleClose, title: title, description: description, onConfirm: onConfirm })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
        open: open,
        onClose: handleClose,
        "aria-labelledby": "alert-dialog-title",
        "aria-describedby": "alert-dialog-description",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                id: "alert-dialog-title",
                children: title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6b3200515d476ef1$export$2e2bcd8739ae039), {
                    id: "alert-dialog-description",
                    children: description
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        onClick: handleClose,
                        variant: "outlined",
                        children: "Cancel"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                        onClick: onConfirm,
                        autoFocus: true,
                        variant: "contained",
                        color: "secondary",
                        children: "Confirm"
                    })
                ]
            })
        ]
    });
};
var $3ca6931de5665f23$export$2e2bcd8739ae039 = $3ca6931de5665f23$var$DeleteDialog;





"use client";
var $f824a64da9568017$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M22 24H2v-4h20zM13.06 5.19l3.75 3.75L7.75 18H4v-3.75zm4.82 2.68-3.75-3.75 1.83-1.83c.39-.39 1.02-.39 1.41 0l2.34 2.34c.39.39.39 1.02 0 1.41z"
}), 'BorderColor');





var $acw62 = parcelRequire("acw62");




var $3QqPt = parcelRequire("3QqPt");

function $428c249bf76ac4db$var$useCustomerInfo() {
    const [phoneNumber, setPhoneNumber] = (0, $acw62.useState)(null);
    const [isUpdateAddOpen, setIsUpdateAddOpen] = (0, $acw62.useState)(false);
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const handleCloseFakePhone = (val)=>setPhoneNumber(val);
    const { customerId: customerId, updateCustomerWithFakePhone: updateCustomerWithFakePhone, customerInfo: customerInfo } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const onUpdateFakePhone = async ()=>{
        try {
            const result = await updateCustomerWithFakePhone(customerId);
            if (result) setPhoneNumber(null);
        } catch (error) {
            console.error('Error updating: ', error);
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('An error occurred while updating the record.');
        }
    };
    const onToggleUpdateAddress = (val)=>{
        setIsUpdateAddOpen(val);
    };
    const onHandleUpdateAddress = async (data)=>{
        try {
            const result = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).editCustomerAddresses(customerId, data);
            if (result) {
                queryClient.invalidateQueries({
                    queryKey: [
                        '/customers'
                    ]
                });
                (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success(`${isUpdateAddOpen} has been updated successfully.`);
                setIsUpdateAddOpen(false);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const getAddress = (address, id, addressType)=>{
        const breakAdd = address.split(',');
        return {
            street: breakAdd[0]?.trim() || '',
            street2: breakAdd[1]?.trim() || '',
            city: breakAdd[2]?.trim() || '',
            state: breakAdd[3]?.trim() || '',
            postal: breakAdd[4]?.trim() || '',
            id: id,
            addressType: addressType
        };
    };
    const getDefaultValues = ()=>{
        if (isUpdateAddOpen === 'Parking Address') return getAddress(customerInfo?.parkingAddress, customerInfo.parkingAddressId, (0, $3QqPt.Address).AddressType.PARKING);
        if (isUpdateAddOpen === 'License Address') return getAddress(customerInfo?.licenseAddress, customerInfo.licenseAddressId, (0, $3QqPt.Address).AddressType.LICENSE);
        if (isUpdateAddOpen === 'Contact Address') return getAddress(customerInfo?.contactAddress, customerInfo.contactAddressId, (0, $3QqPt.Address).AddressType.CONTACT);
        return {};
    };
    return {
        onUpdateFakePhone: onUpdateFakePhone,
        handleCloseFakePhone: handleCloseFakePhone,
        phoneNumber: phoneNumber,
        onToggleUpdateAddress: onToggleUpdateAddress,
        isUpdateAddOpen: isUpdateAddOpen,
        onHandleUpdateAddress: onHandleUpdateAddress,
        getDefaultValues: getDefaultValues
    };
}
var $428c249bf76ac4db$export$2e2bcd8739ae039 = $428c249bf76ac4db$var$useCustomerInfo;



parcelRequire("acw62");



const $c841c7ad5a543a1b$export$a3259b0ba23461a8 = ({ errors: errors, control: control })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "street",
                control: control,
                rules: {
                    required: 'This field is required',
                    maxLength: {
                        value: 150,
                        message: 'Maximum of 150 characters allowed.'
                    }
                },
                render: ({ field: { onChange: onChange, ...rest } })=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "Street Address",
                        margin: "normal",
                        onChange: onChange,
                        ...rest
                    });
                }
            }),
            errors?.street && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.street.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "street2",
                control: control,
                rules: {
                    maxLength: {
                        value: 150,
                        message: 'Maximum of 150 characters allowed.'
                    }
                },
                render: ({ field: { onChange: onChange, ...rest } })=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "Street Address 2",
                        margin: "normal",
                        onChange: onChange,
                        ...rest
                    });
                }
            }),
            errors?.street2 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.street2.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "city",
                control: control,
                rules: {
                    required: 'This field is required',
                    maxLength: {
                        value: 70,
                        message: 'Maximum of 70 characters allowed.'
                    }
                },
                render: ({ field: { onChange: onChange, ...rest } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "City",
                        margin: "normal",
                        onChange: onChange,
                        ...rest
                    })
            }),
            errors?.city && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.city.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "state",
                control: control,
                rules: {
                    required: 'This field is required.',
                    minLength: {
                        value: 2,
                        message: 'Minimum 2 characters required.'
                    },
                    maxLength: {
                        value: 2,
                        message: 'Maximum 2 characters allowed.'
                    }
                },
                render: ({ field: { onChange: onChange, ...rest } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "State",
                        margin: "normal",
                        onChange: onChange,
                        ...rest
                    })
            }),
            errors?.state && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.state.message
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "postal",
                control: control,
                rules: {
                    required: 'This field is required'
                },
                render: ({ field: { onChange: onChange, ...rest } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        fullWidth: true,
                        label: "Postal",
                        margin: "normal",
                        onChange: onChange,
                        ...rest
                    })
            }),
            errors?.postal && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                text: errors.postal.message
            })
        ]
    });
};





parcelRequire("acw62");







const $25db46a9dece052d$export$3722f4e6102a7b0a = ()=>{
    const { customerId: customerId, customerInfo: customerInfo } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    // Fetch list of clients to map client IDs to names
    const { data: clients } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'clients'
        ],
        queryFn: (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getListClients,
        placeholderData: []
    });
    // Create a mapping function from client ID to client name
    const getClientName = (clientId)=>{
        const client = clients?.find((client)=>client.id === clientId);
        return client?.name || clientId || 'Unknown';
    };
    // Fetch connected accounts based on phone number
    const { data: relatedAccounts, isLoading: isLoading, error: error } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'connected-accounts',
            customerInfo?.phone
        ],
        queryFn: async ()=>{
            if (!customerInfo?.phone) return [];
            try {
                const response = await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getAllCustomersByPhone(customerInfo.phone);
                return response.customersList?.filter((customer)=>customer.customerId !== customerId) // Exclude current customer
                ?.map((customer)=>({
                        customerId: customer.customerId,
                        clientId: customer.clientId || 'Unknown',
                        accountNumber: customer.accountNumber || 'N/A'
                    })) || [];
            } catch (error) {
                console.error('Error fetching connected accounts:', error);
                return [];
            }
        },
        enabled: !!customerInfo?.phone,
        staleTime: 300000,
        // 5 minutes
        retry: 1
    });
    // Don't render anything if loading, no phone number, or error occurred
    if (isLoading || !customerInfo?.phone || error) {
        if (error) console.error('Connected accounts error:', error);
        return null;
    }
    // Don't render if no connected customers
    if (!relatedAccounts?.length) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
        sx: {
            mb: 3,
            p: 2
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                variant: "h6",
                component: "h2",
                sx: {
                    mb: 2
                },
                children: "Related Accounts"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d8d66642fc2c080$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Client Name"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Account Number"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                            children: relatedAccounts.map((customer)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: getClientName(customer.clientId)
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a), {
                                                to: `/customers/${customer.customerId}`,
                                                style: {
                                                    color: themeColors.buttonColor,
                                                    textDecoration: 'none'
                                                },
                                                children: customer.accountNumber
                                            })
                                        })
                                    ]
                                }, customer.customerId))
                        })
                    ]
                })
            })
        ]
    });
};





var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");


const $1c24fbfca5f6bebb$export$d9f71e53150438bd = ({ errors: errors, control: control })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            mt: 2
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    mb: 2
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "body2",
                    color: "text.secondary",
                    sx: {
                        mb: 1
                    },
                    children: "Required fields are marked with *"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "vehicleId",
                control: control,
                rules: {
                    required: 'Vehicle ID is required'
                },
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "Vehicle ID *",
                        margin: "normal",
                        disabled: true,
                        error: !!errors?.vehicleId,
                        helperText: errors?.vehicleId?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "customerId",
                control: control,
                rules: {
                    required: 'Customer ID is required'
                },
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "Customer ID *",
                        margin: "normal",
                        disabled: true,
                        error: !!errors?.customerId,
                        helperText: errors?.customerId?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "subscriptionId",
                control: control,
                rules: {
                    required: 'Subscription ID is required'
                },
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "Subscription ID *",
                        margin: "normal",
                        disabled: true,
                        error: !!errors?.subscriptionId,
                        helperText: errors?.subscriptionId?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "vin",
                control: control,
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "VIN",
                        margin: "normal",
                        error: !!errors?.vin,
                        helperText: errors?.vin?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "odometerReading",
                control: control,
                rules: {
                    required: 'Odometer reading is required',
                    min: {
                        value: 0,
                        message: 'Odometer reading must be positive'
                    }
                },
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "Odometer Reading (miles) *",
                        margin: "normal",
                        type: "number",
                        error: !!errors?.odometerReading,
                        helperText: errors?.odometerReading?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "returnTime",
                control: control,
                rules: {
                    required: 'Return time is required'
                },
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "Return Time *",
                        margin: "normal",
                        type: "datetime-local",
                        error: !!errors?.returnTime,
                        helperText: errors?.returnTime?.message,
                        InputLabelProps: {
                            shrink: true
                        }
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "missingAssetsAmount",
                control: control,
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "Missing Assets Amount (cents)",
                        margin: "normal",
                        type: "number",
                        error: !!errors?.missingAssetsAmount,
                        helperText: errors?.missingAssetsAmount?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "initialDamagesAmount",
                control: control,
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "Initial Damages Amount (cents)",
                        margin: "normal",
                        type: "number",
                        error: !!errors?.initialDamagesAmount,
                        helperText: errors?.initialDamagesAmount?.message
                    })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                name: "miscellaneous",
                control: control,
                render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                        ...field,
                        fullWidth: true,
                        label: "Miscellaneous Notes",
                        margin: "normal",
                        multiline: true,
                        rows: 3,
                        error: !!errors?.miscellaneous,
                        helperText: errors?.miscellaneous?.message
                    })
            })
        ]
    });
};





function $f77beddb09464998$export$fa5840148ad8ddc7() {
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    return (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async (data)=>{
            // Convert form data to API request format
            const requestParams = {
                vehicleId: data.vehicleId,
                customerId: data.customerId,
                subscriptionId: data.subscriptionId,
                vin: data.vin || '',
                odometer: {
                    units: 0,
                    // MILES
                    reading: data.odometerReading,
                    readingType: 2,
                    // DROPOFF
                    date: new Date(data.returnTime).getUTCDate()
                },
                returnTime: new Date(data.returnTime).toISOString(),
                imagesList: [],
                lineItemsList: [],
                miscellaneousMap: data.miscellaneous ? [
                    [
                        'notes',
                        data.miscellaneous
                    ]
                ] : [],
                missingAssetsAmount: data.missingAssetsAmount || 0,
                initialDamagesAmount: data.initialDamagesAmount || 0
            };
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).initiateVehicleReturn(requestParams);
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    '/customers'
                ]
            });
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Vehicle return initiated successfully');
        },
        onError: (error)=>{
            console.error('Error initiating vehicle return:', error);
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Failed to initiate vehicle return. Please try again.');
        }
    });
}


function $e2cc60c346b977ea$export$390aac1620b744f8() {
    const { subscriptionId: subscriptionId, vehicleId: vehicleId, customerId: customerId } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const [isDrawerOpen, setIsDrawerOpen] = (0, $acw62.useState)(false);
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const mutation = (0, $f77beddb09464998$export$fa5840148ad8ddc7)();
    const handleSave = async (data)=>{
        await mutation.mutateAsync(data);
        setIsDrawerOpen(false);
    };
    const getDefaultValues = ()=>{
        // Get current datetime in local timezone formatted for datetime-local input
        const now = new Date();
        const year = now.getFullYear();
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const day = String(now.getDate()).padStart(2, '0');
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const localDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;
        return {
            vehicleId: vehicleId || '',
            customerId: customerId || '',
            subscriptionId: subscriptionId || '',
            vin: '',
            odometerReading: 0,
            returnTime: localDateTime,
            locationAddress: '',
            missingAssetsAmount: 0,
            initialDamagesAmount: 0,
            miscellaneous: ''
        };
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                color: "error",
                onClick: ()=>setIsDrawerOpen(true),
                type: "button",
                variant: "contained",
                sx: {
                    backgroundColor: themeColors.buttonColor,
                    color: 'black',
                    '&:hover': {
                        backgroundColor: themeColors.buttonHover
                    }
                },
                children: "Return Vehicle"
            }),
            isDrawerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                isDrawerOpen: isDrawerOpen,
                setIsDrawerOpen: setIsDrawerOpen,
                header: "Initiate Vehicle Return",
                handleSave: handleSave,
                defaultValues: getDefaultValues(),
                submitButtonLabel: "Complete Return",
                form: ({ errors: errors, control: control })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c24fbfca5f6bebb$export$d9f71e53150438bd), {
                        errors: errors,
                        control: control
                    })
            })
        ]
    });
}


const $54a953d3f16bc354$export$a392ed80e0c48a7d = ()=>{
    const { customerInfo: customerInfo, subscriptionStatus: subscriptionStatus, vehicleId: vehicleId } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const { handleCloseFakePhone: handleCloseFakePhone, onUpdateFakePhone: onUpdateFakePhone, isUpdateAddOpen: isUpdateAddOpen, onToggleUpdateAddress: onToggleUpdateAddress, onHandleUpdateAddress: onHandleUpdateAddress, getDefaultValues: getDefaultValues, phoneNumber: phoneNumber } = (0, $428c249bf76ac4db$export$2e2bcd8739ae039)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                size: 'small',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                        sx: {
                                            alignItems: 'center',
                                            display: 'flex'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                ml: 1
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                color: themeColors.buttonColor,
                                                variant: "subtitle2",
                                                sx: {
                                                    '&:hover': {
                                                        color: themeColors.buttonHover
                                                    }
                                                },
                                                children: "Basic Details"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                        sx: {
                                            alignItems: 'center',
                                            display: 'flex'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                ml: 1
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                color: "inherit",
                                                variant: "subtitle2"
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "Email"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: customerInfo?.email
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "Phone"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: [
                                            customerInfo?.phone ? (0, $f2f778d43eec38b2$export$a7b62c66cbe5cfdc)(customerInfo?.phone) : null,
                                            customerInfo?.phone ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                                    title: "Replace with fake phone number",
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                        className: "xsIcon",
                                                        onClick: ()=>{
                                                            handleCloseFakePhone(customerInfo?.phone);
                                                        },
                                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {})
                                                    })
                                                })
                                            }) : null
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "Parking Address"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: [
                                            customerInfo?.parkingAddress,
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                                title: "Edit Parking Address",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                    className: "xsIcon",
                                                    onClick: ()=>onToggleUpdateAddress('Parking Address'),
                                                    disabled: !customerInfo?.parkingAddress,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f824a64da9568017$export$2e2bcd8739ae039), {})
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "License Address"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: [
                                            customerInfo?.licenseAddress,
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                                title: "Edit License Address",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                    className: "xsIcon",
                                                    onClick: ()=>onToggleUpdateAddress('License Address'),
                                                    disabled: !customerInfo?.licenseAddress,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f824a64da9568017$export$2e2bcd8739ae039), {})
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "Contact Address"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: [
                                            customerInfo?.contactAddress,
                                            ' ',
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                                title: "Edit Contact Address",
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                                    className: "xsIcon",
                                                    onClick: ()=>onToggleUpdateAddress('Contact Address'),
                                                    disabled: !customerInfo?.licenseAddress,
                                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f824a64da9568017$export$2e2bcd8739ae039), {})
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "Subscription status"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: subscriptionStatus
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "Account Number"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: customerInfo?.accountNumber
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "Driver's License Exp. Date"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: customerInfo?.licenseExpirationDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                hover: true,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                alignItems: 'center',
                                                display: 'flex'
                                            },
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                                sx: {
                                                    ml: 1
                                                },
                                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                    variant: "subtitle2",
                                                    sx: {
                                                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: "Vehicle ID"
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        sx: {
                                            fontWeight: 'bold'
                                        },
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 2
                                            },
                                            children: [
                                                vehicleId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b7fbb59cc24be7e9$export$2e2bcd8739ae039), {
                                                    component: (0, $84c11e79798ea0cb$export$a6c7ac8248d6e38a),
                                                    to: `/view/listings/${vehicleId}`,
                                                    color: themeColors.buttonColor,
                                                    sx: {
                                                        '&:hover': {
                                                            color: themeColors.buttonHover
                                                        }
                                                    },
                                                    children: vehicleId
                                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                    children: "-"
                                                }),
                                                subscriptionStatus === 'ACTIVE' && vehicleId && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e2cc60c346b977ea$export$390aac1620b744f8), {})
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25db46a9dece052d$export$3722f4e6102a7b0a), {})
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ca6931de5665f23$export$2e2bcd8739ae039), {
                open: Boolean(phoneNumber),
                handleClose: ()=>handleCloseFakePhone(null),
                title: "Update customer with fake phone number",
                description: `You are about to change the phone number ${customerInfo?.phone} to a fake number would you like to proceed?`,
                onConfirm: onUpdateFakePhone
            }),
            isUpdateAddOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                isDrawerOpen: typeof isUpdateAddOpen === 'string' ? true : isUpdateAddOpen,
                setIsDrawerOpen: onToggleUpdateAddress,
                header: `Edit ${isUpdateAddOpen}`,
                handleSave: onHandleUpdateAddress,
                defaultValues: getDefaultValues(),
                form: ({ errors: errors, control: control })=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c841c7ad5a543a1b$export$a3259b0ba23461a8), {
                        errors: errors,
                        control: control
                    });
                }
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");





parcelRequire("acw62");


const $d4bc3a6f74bb6591$export$1ed32bb4777eea61 = ({ isDrawerOpen: isDrawerOpen, setIsDrawerOpen: setIsDrawerOpen, header: header, childComponent: childComponent })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3c5e6c7e7e283ee4$export$2e2bcd8739ae039), {
        anchor: "right",
        open: isDrawerOpen,
        onClose: ()=>setIsDrawerOpen(false),
        ModalProps: {
            keepMounted: true // Better open performance on mobile.
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
            sx: {
                padding: 0
            },
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
                sx: {
                    marginTop: '50px',
                    width: '600px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $e721a73094186d5d$export$2e2bcd8739ae039), {
                    sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 400,
                        p: 4
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'flex',
                                justifyContent: 'space-between'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "h5",
                                        children: header
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                    sx: {
                                        alignItems: 'center',
                                        display: 'flex'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                            sx: {
                                                flexGrow: 1
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                            onClick: ()=>setIsDrawerOpen(false),
                                            children: "Close"
                                        })
                                    ]
                                })
                            ]
                        }),
                        childComponent()
                    ]
                })
            })
        })
    });
};




parcelRequire("acw62");






const $babbf348553d0b37$export$7310d75e6ca83531 = ({ errors: errors, control: control })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
        sx: {
            mt: 2
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            container: true,
            spacing: 3,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "policyNumber",
                            control: control,
                            rules: {
                                required: 'Policy number is required'
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: "Policy Number",
                                    margin: "normal",
                                    ...field
                                })
                        }),
                        errors?.policyNumber && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                            text: errors.policyNumber.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                            name: "providerName",
                            control: control,
                            rules: {
                                required: 'Provider name is required'
                            },
                            render: ({ field: field })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                    fullWidth: true,
                                    label: "Provider Name",
                                    margin: "normal",
                                    ...field
                                })
                        }),
                        errors?.providerName && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                            text: errors.providerName.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 6
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                            dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: "effectiveDate",
                                control: control,
                                rules: {
                                    required: 'Effective date is required',
                                    validate: (value)=>value && (0, $f2a682b251363bc2$export$1ea939691cdc45b8)(value) ? true : 'Invalid date'
                                },
                                defaultValue: null,
                                render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                                        label: "Effective Date",
                                        value: value,
                                        onChange: onChange
                                    })
                            })
                        }),
                        errors?.effectiveDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                            text: errors.effectiveDate.message
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 6
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                            dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: "expirationDate",
                                control: control,
                                rules: {
                                    required: 'Expiration date is required',
                                    validate: (value)=>value && (0, $f2a682b251363bc2$export$1ea939691cdc45b8)(value) ? true : 'Invalid date'
                                },
                                defaultValue: null,
                                render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                                        label: "Expiration Date",
                                        value: value,
                                        onChange: onChange
                                    })
                            })
                        }),
                        errors?.expirationDate && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                            text: errors.expirationDate.message
                        })
                    ]
                })
            ]
        })
    });
};




var $acw62 = parcelRequire("acw62");




function $8f710ac90aa8ed76$export$aa59679c6bb6112() {
    const [{ invoiceId: invoiceId }, setQueryParams] = (0, $9963aa6f9102c92d$export$b37ee0d76c6d2fbc)({
        invoiceId: (0, $edbc22aa0be45f44$export$cc4e5467ec2866fa)
    });
    const setInvoiceId = (invoiceId)=>{
        setQueryParams({
            invoiceId: invoiceId
        });
    };
    const isInvoiceDetailsDrawerOpen = !!invoiceId;
    function payInvoiceByInvoiceId(documentNumber, subscriptionId, paymentAmount) {
        console.log('payInvoiceByInvoiceId: ', documentNumber, subscriptionId, paymentAmount);
        const { data: success, refetch: refetch } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/payInvoice'
            ],
            queryFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).payInvoice(documentNumber, subscriptionId, paymentAmount).then((res)=>{
                    return res;
                }),
            refetchOnWindowFocus: false,
            enabled: false
        });
        return {
            success: success,
            doPayInvoiceById: refetch
        };
    }
    return {
        invoiceId: invoiceId,
        setInvoiceId: setInvoiceId,
        isInvoiceDetailsDrawerOpen: isInvoiceDetailsDrawerOpen,
        payInvoiceByInvoiceId: payInvoiceByInvoiceId
    };
}



parcelRequire("acw62");


const $c84050f7797119db$var$StatusPillRoot = (0, $13f99d5fb06222df$export$2e2bcd8739ae039)('span')(({ theme: theme })=>{
    // TODO: remove hardcoded color
    const backgroundColor = (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).infoPillYellow;
    const color = (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).black;
    return {
        alignItems: 'center',
        backgroundColor: backgroundColor,
        borderRadius: 12,
        color: color,
        cursor: 'default',
        display: 'inline-flex',
        flexGrow: 0,
        flexShrink: 0,
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.pxToRem(10),
        justifyContent: 'center',
        minWidth: 20,
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
        textTransform: 'uppercase',
        whiteSpace: 'nowrap'
    };
});
const $c84050f7797119db$export$44918318b8113b6b = (props)=>{
    const { color: color = 'issued', children: children, ...other } = props;
    const statusState = {
        color: color
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($c84050f7797119db$var$StatusPillRoot, {
        statusState: statusState,
        ...other,
        children: children
    });
};







const $a39982ccf215849e$export$8b5246dbd6c8a7e8 = ({ invoices: invoices, refetchInvoices: refetchInvoices, subscriptionId: subscriptionId })=>{
    const { invoiceId: invoiceId, payInvoiceByInvoiceId: payInvoiceByInvoiceId } = (0, $8f710ac90aa8ed76$export$aa59679c6bb6112)();
    const invoiceDetails = invoices.find((invoice)=>invoice.id === invoiceId);
    const { doPayInvoiceById: doPayInvoiceById } = payInvoiceByInvoiceId(invoiceDetails?.documentNumber, subscriptionId, Number(invoiceDetails?.balance.replace(/\D/g, '')));
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [hidePayInvoiceButton, setHidePayInvoiceButton] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleClickOpen = ()=>{
        setOpen(true);
    };
    const handleClose = ()=>{
        setOpen(false);
    };
    function onClickPayInvoice() {
        doPayInvoiceById().then(()=>setHidePayInvoiceButton(true)).then(()=>refetchInvoices());
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            sx: {
                my: 4
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    container: true,
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "subtitle1",
                                    children: "Invoice Status"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c84050f7797119db$export$44918318b8113b6b), {
                                    color: 'issued',
                                    children: invoiceDetails?.status
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            sx: {
                                width: 150
                            },
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    sx: {
                                        textAlign: 'left'
                                    },
                                    variant: "subtitle1",
                                    children: "Invoice ID"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: invoiceDetails?.id
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    sx: {
                                        textAlign: 'left'
                                    },
                                    variant: "subtitle1",
                                    children: "Amount"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                    variant: "body2",
                                    children: invoiceDetails?.amount
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        my: 4
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        container: true,
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        gutterBottom: true,
                                        variant: "subtitle2",
                                        children: "Date of issue"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        children: invoiceDetails?.date
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        gutterBottom: true,
                                        variant: "subtitle2",
                                        children: "Due date"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        children: invoiceDetails?.dueDate
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        gutterBottom: true,
                                        variant: "subtitle2",
                                        children: "Document Number"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "body2",
                                        children: invoiceDetails?.documentNumber
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $f087e22488590525$export$2e2bcd8739ae039), {
                    className: 'invoice-details',
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9fd7c480e10ebc69$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                        align: "right",
                                        children: "Unit Price"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $791aa0d72f2174bf$export$2e2bcd8739ae039), {
                            children: [
                                (invoiceDetails?.lineItems || []).map((lineItem)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                children: lineItem.description
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {}),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                                align: "right",
                                                children: lineItem.amount
                                            })
                                        ]
                                    }, lineItem.id)),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data',
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                gutterBottom: true,
                                                variant: "subtitle2",
                                                children: "Subtotal"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data',
                                            align: "right",
                                            children: invoiceDetails?.subtotalAmount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data',
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                gutterBottom: true,
                                                variant: "subtitle2",
                                                children: "Taxes"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data',
                                            align: "right",
                                            children: invoiceDetails?.taxAmount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data',
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                gutterBottom: true,
                                                variant: "subtitle2",
                                                children: "Total"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data',
                                            align: "right",
                                            children: invoiceDetails?.amount
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7e1593b31b92bf3c$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data'
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data',
                                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                className: 'invoice-details-footer-data',
                                                gutterBottom: true,
                                                variant: "subtitle2",
                                                children: "Balance"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c63602040c542751$export$2e2bcd8739ae039), {
                                            className: 'invoice-details-footer-data',
                                            align: "right",
                                            children: invoiceDetails?.balance
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        mt: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            gutterBottom: true,
                            variant: "h6",
                            children: "Notes"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            color: "textSecondary",
                            variant: "body2",
                            children: "Notes section"
                        })
                    ]
                }),
                !hidePayInvoiceButton && invoiceDetails?.status && invoiceDetails?.status != 'Paid In Full' && invoiceDetails?.status != 'Voided' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                    sx: {
                        mt: 2
                    },
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                            variant: "contained",
                            onClick: ()=>handleClickOpen(),
                            children: "Pay Invoice"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
                            open: open,
                            onClose: handleClose,
                            "aria-labelledby": "alert-dialog-title",
                            "aria-describedby": "alert-dialog-description",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                                    id: "alert-dialog-title",
                                    children: 'Pay Invoice'
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $6b3200515d476ef1$export$2e2bcd8739ae039), {
                                        id: "alert-dialog-description",
                                        children: [
                                            "This will pay the following invoice and charge the customer the amount of ",
                                            invoiceDetails?.balance,
                                            ", are you sure you want to continue?"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                            onClick: handleClose,
                                            children: "Stop"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                            onClick: onClickPayInvoice,
                                            autoFocus: true,
                                            children: "Continue"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};





var $26u10 = parcelRequire("26u10");



function $abfbfac54d707e27$export$cca531d67fb03da1(customerId) {
    const { data: customerInvoices, refetch: refetch } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            '/customerinvoices'
        ],
        queryFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).getCustomerInvoices(customerId).then((res)=>$abfbfac54d707e27$export$54efd3a158b6e13e(res.invoicesList)),
        placeholderData: []
    });
    return {
        formattedInvoices: customerInvoices || [],
        refetchInvoices: refetch
    };
}
function $abfbfac54d707e27$export$54efd3a158b6e13e(invoices) {
    return invoices.map((invoice)=>{
        return {
            id: invoice.id,
            // type: getInvoiceTypeFromEnum(invoice.type),
            documentNumber: invoice.documentNumber,
            date: (0, $8f939e503a4cc6d3$export$3ae94a2503e890a1)(invoice.date),
            dueDate: (0, $8f939e503a4cc6d3$export$3ae94a2503e890a1)(invoice.dueDate),
            amount: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(invoice.amount),
            taxAmount: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(invoice.taxAmount),
            subtotalAmount: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(invoice.amount - invoice.taxAmount),
            balance: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(invoice.balance),
            status: $abfbfac54d707e27$export$4afd6ecc33fe9610(invoice.status),
            lineItems: $abfbfac54d707e27$export$fb467e1b1c2e8c0d(invoice.lineItemsList)
        };
    });
}
function $abfbfac54d707e27$export$8c84d5f51213d5c2(num) {
    return (0, $2fe0bab7a0e34f9c$export$5b979a6faa693550)((0, $26u10.InvoiceType), num);
}
function $abfbfac54d707e27$export$4afd6ecc33fe9610(num) {
    return (0, $2fe0bab7a0e34f9c$export$5b979a6faa693550)((0, $26u10.InvoiceStatus), num);
}
function $abfbfac54d707e27$export$fb467e1b1c2e8c0d(lineItems) {
    return lineItems.map((lineItem)=>{
        return {
            id: lineItem.id,
            amount: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(lineItem.amount),
            balance: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(lineItem.balance),
            description: lineItem.description
        };
    });
}




function $764306bf5a621bcf$export$b871dff2aa55db26(index) {
    return index % 2 === 0 ? 'evenRow' : 'oddRow';
}





"use client";
var $bd0577c36cb1af47$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2m-9 14-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), 'CheckBox');





var $26u10 = parcelRequire("26u10");

var $acw62 = parcelRequire("acw62");
function $25a403a64e2593fa$export$4d7b599f6c1a310d(customerId, subscriptionId) {
    const [isEditingSubscription, setIsEditingSubscription] = (0, $acw62.useState)(false);
    const [subscriptionAmount, setSubscriptionAmount] = (0, $acw62.useState)(0);
    function useRecurringBillableItems() {
        const { data: recurringBillableItems, refetch: refetch } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/recurringBillableItems'
            ],
            queryFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).listRecurringBillableItems(customerId, subscriptionId).then((res)=>{
                    setSubscriptionAmount(res.recurringBillableItemsList.find((rbi)=>rbi.productType === 1).amount);
                    return res;
                }),
            placeholderData: {},
            enabled: !!subscriptionId
        });
        return {
            recurringBillableItems: recurringBillableItems?.recurringBillableItemsList,
            refetchBillableItems: refetch
        };
    }
    function updateSubscriptionAmount(recurringBillableItems) {
        const { data: updateRecurringBillableItems, refetch: refetch } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/updateRecurringBillableItems'
            ],
            queryFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).updateRecurringBillableItems(customerId, subscriptionId, buildRecurringBillableItems(recurringBillableItems)).then((res)=>{
                    return res;
                }),
            placeholderData: {},
            refetchOnWindowFocus: false,
            enabled: !!subscriptionId
        });
        function buildRecurringBillableItems(recurringBillableItems) {
            const subscriptionRecurringBillableItems = recurringBillableItems.find((rbi)=>rbi.productType === 1);
            const newRecurringBillableItem = new (0, $26u10.RecurringBillableItem)();
            newRecurringBillableItem.setAmount(subscriptionAmount);
            newRecurringBillableItem.setId(subscriptionRecurringBillableItems.id);
            newRecurringBillableItem.setProductType(subscriptionRecurringBillableItems.productType);
            return [
                newRecurringBillableItem
            ];
        }
        return {
            updatedRecurringBillableItems: updateRecurringBillableItems?.recurringBillableItemsList,
            doUpdateSubscriptionAmount: refetch
        };
    }
    function deleteMileagePackage(recurringBillableItems) {
        const { data: success, refetch: refetch } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/deleteMileagePackage'
            ],
            queryFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).removeMileageRecurringBillableItem(customerId, subscriptionId, getMileagePackageId(recurringBillableItems)).then((res)=>{
                    return res;
                }),
            refetchOnWindowFocus: false,
            enabled: false
        });
        function getMileagePackageId(recurringBillableItems) {
            const mileageRecurringBillableItems = recurringBillableItems.find((rbi)=>rbi.productType === 23);
            return mileageRecurringBillableItems.id;
        }
        return {
            success: success,
            doDeleteMileagePackage: refetch
        };
    }
    return {
        useRecurringBillableItems: useRecurringBillableItems,
        updateSubscriptionAmount: updateSubscriptionAmount,
        isEditingSubscription: isEditingSubscription,
        setIsEditingSubscription: setIsEditingSubscription,
        subscriptionAmount: subscriptionAmount,
        setSubscriptionAmount: setSubscriptionAmount,
        deleteMileagePackage: deleteMileagePackage
    };
}







function $61b4b433b12fcfdb$export$34f2cea7b27d37bc(customerId, subscriptionId) {
    function cancelInsurance() {
        const { data: success, refetch: refetch } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/cancelInsurance'
            ],
            queryFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).cancelInsurancePolicy(subscriptionId).then((res)=>{
                    return res;
                }),
            refetchOnWindowFocus: false,
            enabled: false
        });
        return {
            success: success,
            doCancelInsurance: refetch
        };
    }
    function upsertInsurancePolicies(policyNumber, providerName, effectiveDate, expirationDate) {
        const { data: success, refetch: refetch } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/upsertInsurancePolicies'
            ],
            queryFn: ()=>(0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).upsertInsurancePolicies(policyNumber, providerName, effectiveDate, expirationDate, customerId, subscriptionId).then((res)=>{
                    return res;
                }),
            refetchOnWindowFocus: false,
            enabled: false
        });
        return {
            success: success,
            doUpsertInsurancePolicies: refetch
        };
    }
    return {
        cancelInsurance: cancelInsurance,
        upsertInsurancePolicies: upsertInsurancePolicies
    };
}



const $1ce6203d6a25c65b$export$9c8e5b2f269b05ca = ()=>{
    const { customerId: customerId, subscriptionId: subscriptionId } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($1ce6203d6a25c65b$var$Payments2Invoices, {
        subscriptionId: subscriptionId,
        customerId: customerId
    });
};
const $1ce6203d6a25c65b$var$Payments2Invoices = ({ customerId: customerId, subscriptionId: subscriptionId })=>{
    const { formattedInvoices: formattedInvoices, refetchInvoices: refetchInvoices } = (0, $abfbfac54d707e27$export$cca531d67fb03da1)(customerId);
    const { setInvoiceId: setInvoiceId, isInvoiceDetailsDrawerOpen: isInvoiceDetailsDrawerOpen } = (0, $8f710ac90aa8ed76$export$aa59679c6bb6112)();
    const { useRecurringBillableItems: useRecurringBillableItems, updateSubscriptionAmount: updateSubscriptionAmount, isEditingSubscription: isEditingSubscription, setIsEditingSubscription: setIsEditingSubscription, setSubscriptionAmount: setSubscriptionAmount, deleteMileagePackage: deleteMileagePackage } = (0, $25a403a64e2593fa$export$4d7b599f6c1a310d)(customerId, subscriptionId);
    const { cancelInsurance: cancelInsurance, upsertInsurancePolicies: upsertInsurancePolicies } = (0, $61b4b433b12fcfdb$export$34f2cea7b27d37bc)(customerId, subscriptionId);
    const { recurringBillableItems: recurringBillableItems, refetchBillableItems: refetchBillableItems } = useRecurringBillableItems();
    const { doUpdateSubscriptionAmount: doUpdateSubscriptionAmount } = updateSubscriptionAmount(recurringBillableItems);
    const { doCancelInsurance: doCancelInsurance } = cancelInsurance();
    const [policyNumber, setPolicyNumber] = (0, $acw62.useState)();
    const [providerName, setProviderName] = (0, $acw62.useState)();
    const [effectiveDate, setEffectiveDate] = (0, $acw62.useState)(0);
    const [expirationDate, setExpirationDate] = (0, $acw62.useState)(0);
    const { doUpsertInsurancePolicies: doUpsertInsurancePolicies } = upsertInsurancePolicies(policyNumber, providerName, effectiveDate, expirationDate);
    const { doDeleteMileagePackage: doDeleteMileagePackage } = deleteMileagePackage(recurringBillableItems);
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const style = {
        display: 'flex',
        alignItems: 'center',
        padding: '1rem'
    };
    const [isInsuranceDrawerOpen, setIsInsuranceDrawerOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [hideCancelInsuranceButton, setHideCancelInsuranceButton] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [hideDeleteMileageButton, setHideDeleteMileageButton] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const handleInsuranceCancelClick = ()=>{
        setIsInsuranceDrawerOpen(true);
    };
    const handleInsuranceFormSubmit = async (data)=>{
        try {
            setPolicyNumber(data.policyNumber);
            setProviderName(data.providerName);
            setEffectiveDate(data.effectiveDate);
            setExpirationDate(data.expirationDate);
            await (0, $ee0ab4f78b3163c4$export$e772c8ff12451969)(1000);
            doUpsertInsurancePolicies().then(()=>doCancelInsurance().then(()=>setHideCancelInsuranceButton(true)).then(()=>refetchBillableItems()).then(()=>setIsInsuranceDrawerOpen(false)));
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Insurance policy cancelled successfully');
        } catch (error) {
            console.error('Error cancelling insurance:', error);
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Error cancelling insurance policy');
        }
    };
    function onClickSaveAmount(recurringBillableItems) {
        doUpdateSubscriptionAmount(recurringBillableItems).then(()=>refetchBillableItems()).then(()=>setIsEditingSubscription(false));
    }
    function onClickDeleteMileage(recurringBillableItems) {
        doDeleteMileagePackage(recurringBillableItems).then(()=>setHideDeleteMileageButton(true)).then(()=>refetchBillableItems());
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $99712a90aa90aa89$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    ml: 1,
                    margin: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        color: "inherit",
                        variant: "subtitle2",
                        children: [
                            "Subscription ID:",
                            ' '
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        sx: {
                            fontWeight: 'bold'
                        },
                        color: (0, $487c79b981d09aa9$export$6e58fb8e4a4eb1b2).white,
                        variant: "subtitle2",
                        children: subscriptionId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2e2000df495a70f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    ml: 1,
                    margin: '20px'
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        color: "inherit",
                        variant: "h5",
                        children: "Recurring Costs"
                    }),
                    !recurringBillableItems && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        style: style,
                        color: "inherit",
                        variant: "subtitle2",
                        children: "Loading..."
                    }),
                    recurringBillableItems && recurringBillableItems.find((rbi)=>rbi.productType === 1) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
                        component: "form",
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                id: 'subscriptionAmount',
                                label: 'Subscription:',
                                color: isEditingSubscription ? 'error' : 'primary',
                                autoFocus: isEditingSubscription,
                                variant: isEditingSubscription ? 'outlined' : 'standard',
                                defaultValue: isEditingSubscription ? recurringBillableItems.find((rbi)=>rbi.productType === 1).amount : (0, $c21ede28b8496a52$export$a17b3c2052469c69)(recurringBillableItems.find((rbi)=>rbi.productType === 1).amount),
                                onChange: (e)=>setSubscriptionAmount(parseInt(e.target.value)),
                                disabled: !isEditingSubscription
                            }),
                            !isEditingSubscription && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                title: 'Edit Subscription',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    sx: {
                                        p: '10px',
                                        color: themeColors.buttonColor,
                                        '&:hover': {
                                            color: themeColors.buttonHover
                                        }
                                    },
                                    "aria-label": "edit subscription",
                                    onClick: ()=>setIsEditingSubscription(true),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ccd4473bf517ef36$export$2e2bcd8739ae039), {})
                                })
                            }),
                            isEditingSubscription && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                title: 'Save Subscription Changes',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    sx: {
                                        p: '10px',
                                        color: themeColors.buttonColor,
                                        '&:hover': {
                                            color: themeColors.buttonHover
                                        }
                                    },
                                    "aria-label": "save subscription changes",
                                    onClick: ()=>onClickSaveAmount(recurringBillableItems),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bd0577c36cb1af47$export$2e2bcd8739ae039), {})
                                })
                            })
                        ]
                    }),
                    recurringBillableItems && recurringBillableItems.find((rbi)=>rbi.productType === 4) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
                        component: "form",
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                label: 'Insurance:',
                                variant: 'standard',
                                defaultValue: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(recurringBillableItems.find((rbi)=>rbi.productType === 4).amount),
                                disabled: true
                            }),
                            !hideCancelInsuranceButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                title: 'Cancel Insurance',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    sx: {
                                        p: '10px',
                                        color: themeColors.buttonColor,
                                        '&:hover': {
                                            color: themeColors.buttonHover
                                        }
                                    },
                                    "aria-label": "cancel insurance",
                                    onClick: handleInsuranceCancelClick,
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {})
                                })
                            })
                        ]
                    }),
                    recurringBillableItems && recurringBillableItems.find((rbi)=>rbi.productType === 23) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $bca3355350079f94$export$2e2bcd8739ae039), {
                        component: "form",
                        sx: {
                            display: 'flex',
                            alignItems: 'center',
                            padding: '1rem'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                label: 'Mileage Package:',
                                variant: 'standard',
                                defaultValue: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(recurringBillableItems.find((rbi)=>rbi.productType === 23).amount),
                                disabled: true
                            }),
                            !hideDeleteMileageButton && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
                                title: 'Delete Mileage Package',
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                                    color: "primary",
                                    sx: {
                                        p: '10px',
                                        color: themeColors.buttonColor,
                                        '&:hover': {
                                            color: themeColors.buttonHover
                                        }
                                    },
                                    "aria-label": "delete mileage package",
                                    onClick: ()=>onClickDeleteMileage(recurringBillableItems),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {})
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2e2000df495a70f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                autoHeight: true,
                rowHeight: 35,
                isRowSelectable: ()=>true,
                getRowClassName: (params)=>(0, $764306bf5a621bcf$export$b871dff2aa55db26)(params.indexRelativeToCurrentPage),
                columns: $1ce6203d6a25c65b$var$invoiceColumns,
                rows: formattedInvoices,
                onRowClick: (params)=>{
                    setInvoiceId(params.row.id);
                },
                getRowId: (row)=>row.documentNumber,
                paginationModel: {
                    page: 0,
                    pageSize: 20
                },
                pagination: true,
                pageSizeOptions: [
                    10
                ]
            }),
            isInvoiceDetailsDrawerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d4bc3a6f74bb6591$export$1ed32bb4777eea61), {
                isDrawerOpen: true,
                setIsDrawerOpen: ()=>{
                    setInvoiceId();
                },
                header: 'Invoice Details',
                childComponent: ()=>{
                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a39982ccf215849e$export$8b5246dbd6c8a7e8), {
                        invoices: formattedInvoices,
                        refetchInvoices: refetchInvoices,
                        subscriptionId: subscriptionId
                    });
                }
            }),
            isInsuranceDrawerOpen && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $755dbc5e78f72812$export$1fc34e4d2dc67769), {
                isDrawerOpen: isInsuranceDrawerOpen,
                setIsDrawerOpen: setIsInsuranceDrawerOpen,
                header: "Cancel Insurance Policy",
                handleSave: handleInsuranceFormSubmit,
                form: (0, $babbf348553d0b37$export$7310d75e6ca83531),
                defaultValues: {
                    policyNumber: '',
                    providerName: '',
                    effectiveDate: null,
                    expirationDate: null
                }
            })
        ]
    });
};
const $1ce6203d6a25c65b$var$invoiceColumns = [
    // {
    //   field: 'type',
    //   headerName: 'Invoice Type',
    //   width: 150,
    // },
    {
        field: 'date',
        headerName: 'Date',
        width: 150
    },
    {
        field: 'dueDate',
        headerName: 'Due Date',
        width: 150
    },
    {
        field: 'status',
        headerName: 'Status',
        width: 150,
        renderCell: (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c84050f7797119db$export$44918318b8113b6b), {
                color: 'issued',
                children: props.row.status
            })
    },
    {
        field: 'amount',
        headerName: 'Amount',
        width: 100,
        cellClassName: 'rtl'
    },
    {
        field: 'balance',
        headerName: 'Balance',
        width: 100,
        cellClassName: 'rtl'
    },
    {
        field: 'documentNumber',
        headerName: 'Document Number',
        width: 150
    },
    {
        field: 'id',
        headerName: 'Invoice ID',
        width: 350
    }
];





var $f1q41 = parcelRequire("f1q41");
parcelRequire("acw62");



var $acw62 = parcelRequire("acw62");






function $9321583c1ce97211$export$9556dae7e7b32494() {
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { authState: authState } = (0, $54656f276146068e$export$2ae4a19e09ca9a00)();
    const [currentNote, setCurrentNote] = (0, $acw62.useState)('');
    const [decision, setDecision] = (0, $acw62.useState)();
    const [overrideDisqualificationVendor, setOverrideDisqualificationVendor] = (0, $acw62.useState)();
    const [feedbackMessage, setFeedbackMessage] = (0, $acw62.useState)();
    const userGroups = authState?.idToken?.claims?.groups;
    const isAdmin = (0, $bd0736fcf235ae86$export$7d046765d192af80)(userGroups);
    const showOverrideRejectionDropdown = decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected;
    const { customerId: customerId } = (0, $84c11e79798ea0cb$export$99eaa27ddbbb95ef)();
    const { data: cqeScores } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'scores',
            customerId
        ],
        queryFn: async ()=>{
            try {
                const scores = await (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).getCustomerCQEScores({
                    customerId: customerId
                });
                return {
                    ...scores,
                    disqualificationVendor: (0, $ba66fc54ecff33a1$export$b439d6f66e91ea32)(scores?.scoresList)
                };
            } catch  {
                return {
                    scoresList: [],
                    disqualificationVendor: undefined
                };
            }
        },
        placeholderData: {
            scoresList: [],
            disqualificationVendor: undefined
        },
        enabled: !!customerId
    });
    const { data: mostRecentNote } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'notes',
            customerId
        ],
        queryFn: ()=>{
            return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).getCustomerNotes({
                customerId: customerId
            }).catch((err)=>{
                console.error('CQE error', err);
                return {
                    notesList: [
                        {
                            noteText: 'CQE SERVICE ERROR ON NOTE FETCH'
                        }
                    ]
                };
            }).then((notesResponse)=>{
                const { notesList: notesList } = notesResponse;
                const lastestNote = notesList[0]?.noteText || '';
                setCurrentNote(lastestNote);
                return lastestNote;
            });
        },
        enabled: !!customerId
    });
    const { mutateAsync: overrideQualification, isSuccess: overrideQualificationSuccess } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (result)=>{
            if (result.decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).approved) return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).overrideCustomerQualification({
                customerId: customerId,
                tier: result.decision,
                disqualifiedScoreId: ''
            });
            if (!overrideDisqualificationVendor) throw new Error('No score set for disqualification');
            return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).overrideCustomerQualification({
                customerId: customerId,
                tier: result.decision,
                // @ts-ignore
                disqualifiedScoreId: overrideDisqualificationVendor.id
            });
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    'scores',
                    customerId
                ]
            });
        }
    });
    const { mutate: addNote } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            const data = {
                customerId: customerId,
                noteText: currentNote
            };
            return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).addCustomerNote(data);
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    'notes',
                    customerId
                ]
            });
        }
    });
    const { mutate: recalculateCustomerScores, error: cqeError, isSuccess: recalculateCustomerScoresSuccess } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: ()=>{
            return (0, $4bdfc929de3d2884$export$37ec5a33dd45773b).recalculateCustomerQualification({
                customerId: customerId,
                scoreNamesList: [
                    0,
                    1,
                    2,
                    3
                ],
                skipQualification: false
            });
        },
        onSuccess () {
            queryClient.invalidateQueries({
                queryKey: [
                    'scores',
                    customerId
                ]
            });
        }
    });
    return {
        cqeScores: cqeScores,
        customerId: customerId,
        overrideQualification: overrideQualification,
        overrideQualificationSuccess: overrideQualificationSuccess,
        currentNote: currentNote,
        setCurrentNote: setCurrentNote,
        isAdmin: isAdmin,
        addNote: addNote,
        recalculateCustomerScores: recalculateCustomerScores,
        cqeError: cqeError,
        recalculateCustomerScoresSuccess: recalculateCustomerScoresSuccess,
        decision: decision,
        setDecision: setDecision,
        overrideDisqualificationVendor: overrideDisqualificationVendor,
        setOverrideDisqualificationVendor: setOverrideDisqualificationVendor,
        showOverrideRejectionDropdown: showOverrideRejectionDropdown,
        feedbackMessage: feedbackMessage,
        setFeedbackMessage: setFeedbackMessage,
        mostRecentNote: mostRecentNote
    };
}





const $74cab93e35ab4829$var$getFeedbackMessage = (decision)=>{
    if (decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).approved) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.success,
        children: `Qualification Result Updated Successfully: Approved ${new Date()}`
    });
    if (decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
        color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.info,
        children: `Qualification Result Updated Successfully: Rejected ${new Date()}`
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {});
};
const $74cab93e35ab4829$export$d2b00b551618c20c = ()=>{
    const cqe = (0, $9321583c1ce97211$export$9556dae7e7b32494)();
    const scores = (0, $ba66fc54ecff33a1$export$2dccbe657ab23dc)(cqe.cqeScores?.scoresList);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        direction: "column",
        spacing: 6,
        style: {
            padding: 20
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                direction: "column",
                spacing: 6,
                children: [
                    !scores.length && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            children: "No qualification scores available"
                        })
                    }),
                    (0, $f1q41.map)(scores, (score, index)=>{
                        const sourceData = (0, $f1q41.find)(score.sourceData, {
                            vendorName: score.vendor
                        });
                        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                            container: true,
                            spacing: 2,
                            direction: "column",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            flexWrap: 'wrap',
                                            columnGap: '3rem',
                                            rowGap: '1.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        variant: "caption",
                                                        children: "Vendor"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: score.vendor || 'N/A'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        variant: "caption",
                                                        children: "Date"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: score.qualificationDate
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        variant: "caption",
                                                        children: "Time"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: score.qualificationTime
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        variant: "caption",
                                                        children: "Result"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: score.result === 'Accepted' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                            color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.success,
                                                            children: score.result
                                                        }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                            color: (0, $a72062603a8a430a$export$eaad8caa32d2521d).text.warning,
                                                            children: score.result
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        variant: "caption",
                                                        children: "Reason"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: score.reason || 'N/A'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        variant: "caption",
                                                        children: "Score"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: score.score || 'N/A'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                        variant: "caption",
                                                        children: "Tier"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                                        children: score.tier || 'N/A'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                                    style: {
                                        maxWidth: '100%'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                            variant: "caption",
                                            children: "Full Qualification Response"
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9f6f8982f63abb9b$export$2e2bcd8739ae039), {
                                            displayDataTypes: false,
                                            value: sourceData || score.sourceData,
                                            collapsed: 1,
                                            style: (0, $98d505a00bc654a2$export$3e936a8db52a10a0)
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                spacing: 2,
                direction: "column",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            flexDirection: 'row',
                            marginTop: '10px'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                sx: {
                                    display: 'inline-flex',
                                    columnGap: 4,
                                    rowGap: 2,
                                    flexWrap: 'wrap',
                                    paddingLeft: '10px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'inline-flex',
                                            flexDirection: 'column'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                children: "Qualification Result"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                                value: cqe.decision,
                                                onChange: (evt)=>{
                                                    cqe.setFeedbackMessage(null);
                                                    // @ts-ignore
                                                    cqe.setDecision(evt.target.value);
                                                    if (cqe.cqeScores?.disqualificationVendor) cqe.setOverrideDisqualificationVendor(cqe.cqeScores?.disqualificationVendor);
                                                },
                                                IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                        disabled: true,
                                                        value: (0, $ba66fc54ecff33a1$export$62bab6355639dfe).unchanged,
                                                        children: "Select a Qualification Result"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                        value: (0, $ba66fc54ecff33a1$export$62bab6355639dfe).approved,
                                                        children: "Approve"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                        value: (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected,
                                                        children: "Reject"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                        value: (0, $ba66fc54ecff33a1$export$62bab6355639dfe).recalculate,
                                                        children: "Repeat CQE"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    cqe.showOverrideRejectionDropdown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'inline-flex',
                                            flexDirection: 'column'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                children: "Rejection Used"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $13a94221f14f71e8$export$2e2bcd8739ae039), {
                                                defaultValue: cqe.cqeScores?.disqualificationVendor?.id,
                                                //@ts-ignore
                                                value: cqe?.overrideDisqualificationVendor?.id,
                                                onChange: (evt)=>cqe.setOverrideDisqualificationVendor(cqe.cqeScores?.scoresList.find((score)=>score.id === evt.target.value)),
                                                IconComponent: (0, $0953557707017bc5$export$2e2bcd8739ae039),
                                                children: cqe.cqeScores?.scoresList?.map((score)=>{
                                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45389177b9c2b08c$export$2e2bcd8739ae039), {
                                                        value: score.id,
                                                        children: score.vendorName
                                                    }, score.id);
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                        sx: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            width: '100%'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                                variant: "caption",
                                                children: "Notes"
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                                value: cqe.currentNote,
                                                onChange: (evt)=>cqe.setCurrentNote(evt.target.value),
                                                fullWidth: true,
                                                placeholder: "Add notes about this update",
                                                variant: "outlined"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            cqe.showOverrideRejectionDropdown && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                                        variant: "caption",
                                        children: "Reason Codes"
                                    }),
                                    cqe.cqeScores?.disqualificationVendor && !cqe.overrideDisqualificationVendor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
                                        sx: {
                                            listStyleType: 'disc',
                                            pl: 2,
                                            '& .MuiListItem-root': {
                                                display: 'list-item'
                                            }
                                        },
                                        children: cqe.cqeScores?.disqualificationVendor.disqualifiedReasonsList.map((reason, index)=>{
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                                                children: reason
                                            }, index);
                                        })
                                    }),
                                    cqe.overrideDisqualificationVendor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d987fddc25cef197$export$2e2bcd8739ae039), {
                                        sx: {
                                            listStyleType: 'disc',
                                            pl: 2,
                                            '& .MuiListItem-root': {
                                                display: 'list-item'
                                            }
                                        },
                                        children: // @ts-ignore
                                        cqe.overrideDisqualificationVendor?.disqualifiedReasonsList.map((reason, index)=>{
                                            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c1d275280a204574$export$2e2bcd8739ae039), {
                                                children: reason
                                            }, index);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        children: cqe.overrideQualificationSuccess && $74cab93e35ab4829$var$getFeedbackMessage(cqe.decision)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        sx: {
                            display: 'flex',
                            justifyContent: 'center'
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                            sx: {
                                display: 'inline-flex',
                                flexDirection: 'column'
                            },
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                disabled: !cqe.isAdmin || !cqe.decision && cqe.currentNote === cqe.mostRecentNote,
                                onClick: ()=>{
                                    if (cqe.decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).approved || cqe.decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).rejected) cqe.overrideQualification({
                                        note: cqe.currentNote,
                                        decision: cqe.decision
                                    }).then(()=>{
                                        // @ts-ignore
                                        cqe.setDecision((0, $ba66fc54ecff33a1$export$62bab6355639dfe).unchanged);
                                    });
                                    else if (cqe.decision === (0, $ba66fc54ecff33a1$export$62bab6355639dfe).recalculate) cqe.recalculateCustomerScores();
                                    if (cqe.currentNote) cqe.addNote();
                                },
                                variant: "contained",
                                color: "primary",
                                children: "Update"
                            })
                        })
                    })
                ]
            })
        ]
    });
};







var $acw62 = parcelRequire("acw62");








function $a92bacc669eda25d$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $abb9adbdb26342b3$export$ead8a1812b171991)(options?.in, NaN);
    const additionalDigits = options?.additionalDigits ?? 2;
    const dateStrings = $a92bacc669eda25d$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $a92bacc669eda25d$var$parseYear(dateStrings.date, additionalDigits);
        date = $a92bacc669eda25d$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $a92bacc669eda25d$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $a92bacc669eda25d$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $231bfb8d72679740$export$e67a095c620b86fe)(0, options?.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $231bfb8d72679740$export$e67a095c620b86fe)(timestamp + time + offset, options?.in);
}
const $a92bacc669eda25d$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $a92bacc669eda25d$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $a92bacc669eda25d$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $a92bacc669eda25d$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $a92bacc669eda25d$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($a92bacc669eda25d$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($a92bacc669eda25d$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($a92bacc669eda25d$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $a92bacc669eda25d$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $a92bacc669eda25d$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $a92bacc669eda25d$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($a92bacc669eda25d$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $a92bacc669eda25d$var$parseDateUnit(captures[1]);
    const month = $a92bacc669eda25d$var$parseDateUnit(captures[2]) - 1;
    const day = $a92bacc669eda25d$var$parseDateUnit(captures[3]);
    const week = $a92bacc669eda25d$var$parseDateUnit(captures[4]);
    const dayOfWeek = $a92bacc669eda25d$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$a92bacc669eda25d$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $a92bacc669eda25d$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$a92bacc669eda25d$var$validateDate(year, month, day) || !$a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $a92bacc669eda25d$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $a92bacc669eda25d$var$parseTime(timeString) {
    const captures = timeString.match($a92bacc669eda25d$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $a92bacc669eda25d$var$parseTimeUnit(captures[1]);
    const minutes = $a92bacc669eda25d$var$parseTimeUnit(captures[2]);
    const seconds = $a92bacc669eda25d$var$parseTimeUnit(captures[3]);
    if (!$a92bacc669eda25d$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff) + seconds * 1000;
}
function $a92bacc669eda25d$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $a92bacc669eda25d$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($a92bacc669eda25d$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$a92bacc669eda25d$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $8540a44f59a4af84$export$7f72910d6dfd237a) + minutes * (0, $8540a44f59a4af84$export$91246f0b9bd9beff));
}
function $a92bacc669eda25d$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $a92bacc669eda25d$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $a92bacc669eda25d$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $a92bacc669eda25d$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($a92bacc669eda25d$var$daysInMonths[month] || ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 29 : 28));
}
function $a92bacc669eda25d$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($a92bacc669eda25d$var$isLeapYearIndex(year) ? 366 : 365);
}
function $a92bacc669eda25d$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $a92bacc669eda25d$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $a92bacc669eda25d$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$a92bacc669eda25d$export$2e2bcd8739ae039 = $a92bacc669eda25d$export$4393d2ccbbedb219;










const $22195747a0923209$export$4f004fd4ddb2626 = (subscriptionId)=>{
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { mutateAsync: createPunitiveMiles, error: createPromoError } = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: async ({ vehicleId: vehicleId, subscriptionId: subscriptionId, amount: amount, price: price, time: time, referenceId: referenceId })=>{
            try {
                return await (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).LogMilesPurchased({
                    vehicleId: vehicleId,
                    subscriptionId: subscriptionId,
                    amount: amount,
                    price: price,
                    time: time,
                    referenceId: referenceId
                });
            } catch (err) {
                console.error({
                    message: 'Error',
                    err: err,
                    params: {
                        vehicleId: vehicleId,
                        subscriptionId: subscriptionId,
                        amount: amount,
                        price: price,
                        time: time,
                        referenceId: referenceId
                    }
                });
                // ! Allow UI to handle but log error so that datadog picks up additional data
                throw err;
            }
        },
        onSuccess () {
            invalidate();
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Punitive miles added.');
        },
        onError () {
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Something went wrong or there is an error adding pumitive miles.');
            console.log('Error: ', createPromoError);
        }
    });
    const mutationDeleteMilesPurchased = (0, $6a05afbd57376433$export$609860bf8b0084c)({
        mutationFn: (id)=>{
            return (0, $c01abb109ee4ca80$export$c540cfc05e7c00b1).deleteMilesPurchasedLog(id);
        },
        onSuccess () {
            invalidate();
        },
        // when a double booking response comes back, an error is thrown
        // but the appointment is still created. We must invalidate the queries
        // here as well to have proper refreshed data
        onError (e) {
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Something went wrong or there is an error adding pumitive miles.');
            console.log('Error: ', e);
        }
    });
    const invalidate = ()=>{
        queryClient.invalidateQueries({
            queryKey: [
                'subscriptionMileagePurchases',
                subscriptionId
            ]
        });
        queryClient.invalidateQueries({
            queryKey: [
                'subscriptionMileage',
                subscriptionId
            ]
        });
    };
    const deleteMilesPurchasedById = (id)=>{
        return mutationDeleteMilesPurchased.mutateAsync(id);
    };
    function addPunitiveMiles(formData) {
        return createPunitiveMiles(formData);
    }
    return {
        addPunitiveMiles: addPunitiveMiles,
        deleteMilesPurchasedById: deleteMilesPurchasedById
    };
};




parcelRequire("acw62");









function $c2770cefb072376e$export$1b7031a80bd92a6e(options) {
    return (0, $b6a2419fd0059687$export$eb9a03f0e9aa6cea)(Date.now(), options);
}
var // Fallback for modularized imports:
$c2770cefb072376e$export$2e2bcd8739ae039 = $c2770cefb072376e$export$1b7031a80bd92a6e;






const $04bfa982603183db$export$31014519c48f64c9 = ({ open: open, onClose: onClose, subscriptionId: subscriptionId })=>{
    const { control: control, handleSubmit: handleSubmit, formState: { errors: errors }, reset: reset } = (0, $0d70f179cf56e662$export$87c0cf8eb5a167e0)({
        defaultValues: {
            amount: '',
            price: '',
            time: ''
        }
    });
    const queryClient = (0, $c780594f51309d36$export$22e77b9572c4fded)();
    const { customerInfo: customerInfo } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const { addPunitiveMiles: addPunitiveMiles } = (0, $22195747a0923209$export$4f004fd4ddb2626)(subscriptionId);
    const onSubmit = async (data)=>{
        try {
            if (!subscriptionId) throw new Error('SubscriptionId not provided');
            const subscription = await (0, $756e67a155228bc1$export$16fd171b2bdd7a79)(subscriptionId);
            if (!subscription) throw new Error('Subscription not found');
            if (!data.amount || !data.price || !data.time) throw new Error('Please provide all required fields');
            // Get the current date and time
            const unixTimestampSeconds = (0, $8f939e503a4cc6d3$export$69ac1778977ccd3b)('seconds');
            const selectedDateinUnix = (0, $8f939e503a4cc6d3$export$6f32b2293d1d7b88)(data.time, 'seconds');
            const payload = {
                amount: parseInt(data.amount, 10),
                price: data.price,
                time: selectedDateinUnix,
                subscriptionId: subscriptionId,
                vehicleId: subscription.vehicleId,
                referenceId: `manual-ops-${customerInfo.accountNumber}-${unixTimestampSeconds}`
            };
            const response = await addPunitiveMiles(payload);
            if (response.success) {
                queryClient.invalidateQueries({
                    queryKey: [
                        'subscriptionMileagePurchases',
                        subscriptionId
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        'subscriptionMileage',
                        subscriptionId
                    ]
                });
            }
            resetForm();
        } catch (error) {
            console.error('Error: ', error);
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Error adding punitive miles');
        } finally{
            onClose();
            queryClient.invalidateQueries({
                queryKey: [
                    'subscriptionMileagePurchases',
                    subscriptionId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'subscriptionMileage',
                    subscriptionId
                ]
            });
        }
    };
    const resetForm = ()=>{
        reset({
            amount: '',
            price: '',
            time: ''
        });
    };
    const handleClose = ()=>{
        resetForm();
        onClose();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37762b86c13fe370$export$2e2bcd8739ae039), {
        maxWidth: "md",
        open: open,
        onClose: handleClose,
        TransitionComponent: (0, $64a991b625bf2127$export$2e2bcd8739ae039),
        sx: {
            minWidth: 800
        },
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                onSubmit: handleSubmit(onSubmit),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $493ef287866e3611$export$2e2bcd8739ae039), {
                        id: "dialog-title",
                        children: "Add Punitive Miles"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $17fd443c9302d537$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: "amount",
                                control: control,
                                rules: {
                                    required: 'This field is required',
                                    pattern: {
                                        value: /^[1-9]\d*(\.\d+)?$/,
                                        message: 'This input is number only'
                                    }
                                },
                                render: ({ field: field })=>{
                                    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        label: "Miles",
                                        margin: "normal",
                                        ...field
                                    });
                                }
                            }),
                            errors?.amount && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                                text: errors.amount.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                name: "price",
                                control: control,
                                rules: {
                                    required: 'This field is required',
                                    pattern: {
                                        value: /^[1-9]\d*(\.\d+)?$/,
                                        message: 'This input is number only'
                                    }
                                },
                                render: ({ field: { onChange: onChange } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $f480fb6201951027$export$2e2bcd8739ae039), {
                                        fullWidth: true,
                                        label: "Price",
                                        margin: "normal",
                                        onChange: onChange
                                    })
                            }),
                            errors?.price && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                                text: errors.price.message
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $b713746033a911a9$export$dc45bdc734ce6f1e), {
                                dateAdapter: (0, $cf2ede53d164004b$export$81f56c0329a1921d),
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0d70f179cf56e662$export$bd0bf19f25da8474), {
                                    name: "time",
                                    control: control,
                                    rules: {
                                        required: 'This field is Required',
                                        validate: (value)=>value && (0, $f2a682b251363bc2$export$1ea939691cdc45b8)(value) ? true : 'Invalid date'
                                    },
                                    defaultValue: null,
                                    render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $41015e883ddba84d$export$5109c6dd95d8fb00), {
                                            label: "Date Purchased",
                                            sx: {
                                                width: '100%'
                                            },
                                            slotProps: {
                                                textField: {
                                                    error: !!error,
                                                    helperText: error?.message
                                                }
                                            },
                                            onChange: (date)=>{
                                                onChange(date);
                                            },
                                            value: new Date(value),
                                            maxDate: (0, $c2770cefb072376e$export$1b7031a80bd92a6e)()
                                        })
                                })
                            }),
                            errors?.time && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1c636adc2e18838b$export$942b2219c902021e), {
                                text: errors.time.message
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $ce32ef3e14a19991$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                variant: "outlined",
                                onClick: handleClose,
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                                type: "submit",
                                autoFocus: true,
                                variant: "contained",
                                color: "secondary",
                                children: "Yes"
                            })
                        ]
                    })
                ]
            })
        })
    });
};


function $ec96edba72c52e05$var$SubscriptionMileage() {
    const { subscriptionId: subscriptionId } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const [open, setOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(false);
    const [milePurchaseRow, setMilePurchaseRow] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState(null);
    const { deleteMilesPurchasedById: deleteMilesPurchasedById } = (0, $22195747a0923209$export$4f004fd4ddb2626)(subscriptionId);
    const handleOpen = ()=>setOpen(true);
    const handleClose = ()=>setOpen(false);
    const { customerName: customerName, customerInfo: customerInfo } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    const { currentTheme: currentTheme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    const themeColors = (0, $8570a4c7e09f797a$export$db29694ebcfc583a)(currentTheme);
    const purchaseColumns = [
        {
            field: 'id',
            headerName: 'ID',
            flex: 1
        },
        {
            field: 'amount',
            headerName: 'Miles',
            flex: 1
        },
        {
            field: 'price',
            headerName: 'Paid',
            flex: 1
        },
        {
            field: 'time',
            headerName: 'Purchase Date',
            flex: 1
        },
        {
            field: 'referenceId',
            headerName: 'Reference ID',
            flex: 3
        },
        {
            field: 'delete',
            headerName: 'Action',
            width: 150,
            renderCell: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
                    className: "xsIcon",
                    onClick: ()=>{
                        handleOpenDeleteMiles(params?.row);
                    },
                    sx: {
                        color: themeColors.buttonColor,
                        '&:hover': {
                            color: themeColors.buttonHover
                        }
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $689927f0df05e8fa$export$2e2bcd8739ae039), {})
                })
        }
    ];
    const handleOpenDeleteMiles = (row)=>{
        setMilePurchaseRow(row);
    };
    const onDeleteMilesConfirm = async ()=>{
        if (!milePurchaseRow || !milePurchaseRow.id) {
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Please select a record to delete.');
            return;
        }
        try {
            const result = await deleteMilesPurchasedById(milePurchaseRow.id);
            if (result.success) {
                setMilePurchaseRow(null);
                (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).success('Record deleted.');
            }
        } catch (error) {
            console.error('Error deleting mileage: ', error);
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('An error occurred while deleting the record.');
        }
    };
    const handleCloseDeleteMiles = ()=>setMilePurchaseRow(null);
    const { data: data, error: error, isLoading: isLoading } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'subscriptionMileage',
            subscriptionId
        ],
        queryFn: ()=>(0, $1f7bb63928e45f23$export$c7b7bad5a1248c3e)(subscriptionId),
        placeholderData: {}
    });
    const purchasesQuery = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'subscriptionMileagePurchases',
            subscriptionId
        ],
        queryFn: ()=>(0, $1f7bb63928e45f23$export$6131c0e0b3329316)(subscriptionId),
        placeholderData: {}
    });
    if (!subscriptionId) return null;
    if (isLoading || purchasesQuery.isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        children: "Loading..."
    });
    function isMileageError(error) {
        return error && typeof error === 'object' && 'code' in error && 'message' in error;
    }
    if (isMileageError(error)) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            "Error: ",
            error?.message
        ]
    });
    else if (purchasesQuery.error) {
        let message = 'Unknown Error';
        if (purchasesQuery.error instanceof Error) message = purchasesQuery.error.message;
        return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            children: [
                "Error getting mileage purchases: ",
                message
            ]
        });
    }
    const allottedMinusDriven = data.totalAllotted - data.totalDriven;
    const overAllottedMiles = allottedMinusDriven < 0;
    const milesDrivenSummary = overAllottedMiles ? 'Over Allottment' : 'Within Allottment';
    let prepaidExtraSection;
    if (data.prepaidExtra) prepaidExtraSection = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                size: {
                    xs: 12
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "h4",
                    children: "Mileage Purchases"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                label: "Total Miles",
                value: (0, $4255990f5fa14d45$export$bd36a39497534430)(data.prepaidExtra.totalAmount)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                label: "Total Paid (including tax)",
                value: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(data.prepaidExtra.totalPrice)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                size: {
                    xs: 12,
                    md: 12
                },
                justifyContent: "flex-end",
                display: "flex",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $00a06c270f3ebd57$export$2e2bcd8739ae039), {
                    onClick: handleOpen,
                    variant: "contained",
                    sx: {
                        backgroundColor: themeColors.buttonColor,
                        color: currentTheme === 'galpin' ? 'black' : 'white',
                        '&:hover': {
                            backgroundColor: themeColors.buttonHover
                        }
                    },
                    children: "Add Punitive Miles"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                autoHeight: true,
                rowHeight: 35,
                sx: {
                    pt: 2
                },
                isRowSelectable: ()=>true,
                getRowClassName: (params)=>(0, $764306bf5a621bcf$export$b871dff2aa55db26)(params.indexRelativeToCurrentPage),
                columns: purchaseColumns,
                rows: purchasesQuery?.data?.purchasesList?.map((purchase)=>({
                        id: purchase.id,
                        amount: purchase.amount,
                        price: (0, $c21ede28b8496a52$export$a17b3c2052469c69)(purchase.price),
                        time: (0, $8f939e503a4cc6d3$export$3ae94a2503e890a1)(purchase.time),
                        referenceId: purchase.referenceId
                    }))
            })
        ]
    });
    let drivenByMonthListSection;
    if (data.drivenByMonthList) drivenByMonthListSection = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                size: {
                    xs: 12
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "h4",
                    children: "Last 6 Months of Miles Driven"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                autoHeight: true,
                rowHeight: 35,
                columns: $ec96edba72c52e05$var$drivenHistoryColumns,
                rows: data.drivenByMonthList.map((month)=>({
                        date: (0, $303ba10db2c74ab4$export$d9468344d3651243)((0, $a92bacc669eda25d$export$4393d2ccbbedb219)(month.date), 'MMM y'),
                        amount: month.amount
                    })),
                getRowId: (row)=>row.date,
                paginationModel: {
                    pageSize: 10,
                    page: 0
                },
                pageSizeOptions: [
                    10
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            milePurchaseRow ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3ca6931de5665f23$export$2e2bcd8739ae039), {
                open: Boolean(milePurchaseRow?.id),
                handleClose: handleCloseDeleteMiles,
                title: "Delete",
                description: `Are you sure you would like to delete the purchase of ${milePurchaseRow.amount} miles on ${milePurchaseRow.time} for customer ${customerName} ${customerInfo.accountNumber}?`,
                onConfirm: onDeleteMilesConfirm
            }) : null,
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $04bfa982603183db$export$31014519c48f64c9), {
                open: open,
                onClose: handleClose,
                subscriptionId: subscriptionId
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                container: true,
                spacing: 2,
                p: 3,
                direction: "row",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12,
                            md: 6
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            children: [
                                "Mileage for subscription id: ",
                                subscriptionId || 'N/A'
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "h4",
                            children: "Summary"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Miles Driven Summary",
                        value: milesDrivenSummary
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Number of Miles Over",
                        value: overAllottedMiles ? (0, $4255990f5fa14d45$export$bd36a39497534430)(Math.abs(allottedMinusDriven)) : 'N/A'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Recurring Plan",
                        value: 'Unknown - see Invoices tab'
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "h4",
                            children: "Odometer"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Starting Odometer",
                        value: (0, $4255990f5fa14d45$export$bd36a39497534430)(data.startingOdometer)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Last Odometer",
                        value: (0, $4255990f5fa14d45$export$bd36a39497534430)(data.lastOdometer)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                        size: {
                            xs: 12
                        },
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                            variant: "h4",
                            children: "Overall Stats"
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Total Allotted",
                        value: (0, $4255990f5fa14d45$export$bd36a39497534430)(data.totalAllotted)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Total Driven",
                        value: (0, $4255990f5fa14d45$export$bd36a39497534430)(data.totalDriven)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Allotted Per Month",
                        value: (0, $4255990f5fa14d45$export$bd36a39497534430)(data.allottedPerMonth)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($ec96edba72c52e05$var$MileageGridItem, {
                        label: "Driven Per Month",
                        value: (0, $4255990f5fa14d45$export$bd36a39497534430)(data.drivenPerMonth)
                    }),
                    prepaidExtraSection,
                    drivenByMonthListSection
                ]
            })
        ]
    });
}
function $ec96edba72c52e05$var$MileageGridItem({ label: label, value: value }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        size: {
            xs: 12,
            sm: 6
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                children: label
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: value || 'N/A'
            })
        ]
    });
}
var $ec96edba72c52e05$export$2e2bcd8739ae039 = $ec96edba72c52e05$var$SubscriptionMileage;
const $ec96edba72c52e05$var$drivenHistoryColumns = [
    {
        field: 'date',
        headerName: 'Month',
        flex: 1
    },
    {
        field: 'amount',
        headerName: 'Miles Driven',
        flex: 1
    }
];




var $acw62 = parcelRequire("acw62");





var $cyjZp = parcelRequire("cyjZp");



function $964affba476e6565$var$getDocumentService() {
    const idToken = (0, $e3ab3b3b306c7d16$export$219078e38253958).getIdToken();
    const target = (0, $4b3a74d272f69cbe$export$6c0517834721cef7).endpoints.fleet;
    return new (0, $df70feab7068291e$exports.DocumentServicePromiseClient)(target, null, {
        unaryInterceptors: [
            new (0, $e3ab3b3b306c7d16$export$ce6d32fcd969c986)(idToken)
        ],
        'grpc-node.max_session_memory': 1000,
        'grpc-node.max_send_message_length': 104857600,
        'grpc-node.max_receive_message_length': 104857600
    });
}
async function $964affba476e6565$export$f0b6627756c40ab6(customerId) {
    const client = $964affba476e6565$var$getDocumentService();
    const request = new (0, $cyjZp.GetCustomerDocumentsRequest)();
    request.setCustomerid(customerId);
    return client.getCustomerDocuments(request).then((res)=>{
        return res.toObject();
    });
}
async function $964affba476e6565$export$1c33fd997649bbb2(customerId, documentId) {
    const client = $964affba476e6565$var$getDocumentService();
    const request = new (0, $cyjZp.GetCustomerDocumentRequest)();
    request.setCustomerid(customerId);
    request.setDocumentId(documentId);
    return client.getCustomerDocument(request).then((res)=>{
        return res.toObject();
    });
}




const $316880e8df8b2f99$var$useDocuments = ()=>{
    const { customerId: customerId } = (0, $84c11e79798ea0cb$export$99eaa27ddbbb95ef)();
    const { data: data, error: error, isLoading: isLoading } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'customerDocuments',
            customerId
        ],
        queryFn: ()=>(0, $964affba476e6565$export$f0b6627756c40ab6)(customerId)
    });
    const { data: imagesData, error: imagesError } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
        queryKey: [
            'customerImages',
            customerId
        ],
        queryFn: ()=>(0, $a8158ebe03199986$export$bb306fc1d45c1bdf)(customerId)
    });
    const useDocumentUri = (documentId, customerId)=>{
        return (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                'downloadDocument',
                documentId
            ],
            queryFn: ()=>(0, $964affba476e6565$export$1c33fd997649bbb2)(customerId, documentId),
            enabled: false
        });
    };
    const contracts = $316880e8df8b2f99$var$filterAndAddFileName(data?.contractsMap?.[0] || []);
    const pickupReceipts = $316880e8df8b2f99$var$filterAndAddFileName(data?.pickupReceiptMap?.[0] || []);
    const insuranceCards = $316880e8df8b2f99$var$filterAndAddFileName(data?.insuranceCardsMap?.[0] || []);
    const autoPayAuthorizations = $316880e8df8b2f99$var$filterAndAddFileName(data?.autoPayAuthorizationsMap?.[0] || []);
    const images = imagesData?.imagesList?.length ? imagesData.imagesList.filter((image)=>image && typeof image === 'object').map((image, index)=>({
            id: image.id || '',
            imageType: image.imageType || 99,
            data: image.data || '',
            uri: image.uri || '',
            presignedUri: image.presignedUri || '',
            fileName: image.uri ? $316880e8df8b2f99$var$extractFileNameFromUri(image.uri) : `Image ${index + 1}`
        })) : [];
    return {
        contracts: contracts,
        pickupReceipts: pickupReceipts,
        insuranceCards: insuranceCards,
        autoPayAuthorizations: autoPayAuthorizations,
        images: images,
        error: error || imagesError,
        isLoading: isLoading,
        useDocumentUri: useDocumentUri
    };
};
var $316880e8df8b2f99$export$2e2bcd8739ae039 = $316880e8df8b2f99$var$useDocuments;
function $316880e8df8b2f99$var$extractFileNameFromUri(uri) {
    return uri.split('/').pop();
}
function $316880e8df8b2f99$var$filterAndAddFileName(inputArray) {
    const filteredObjects = inputArray?.filter((item)=>typeof item === 'object' && item !== null);
    return filteredObjects?.filter((obj)=>{
        if (typeof obj === 'object' && obj.documentUri) return {
            ...obj,
            fileName: $316880e8df8b2f99$var$extractFileNameFromUri(obj.documentUri)
        };
    });
}








"use client";
var $bae8d0b4be16a32a$export$2e2bcd8739ae039 = (0, $2f130330883526cb$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
    d: "M5 20h14v-2H5zM19 9h-4V3H9v6H5l7 7z"
}), 'Download');


const $571a51610528d330$var$CustomerDocuments = ()=>{
    const { contracts: contracts, pickupReceipts: pickupReceipts, insuranceCards: insuranceCards, autoPayAuthorizations: autoPayAuthorizations, images: images, error: error, isLoading: isLoading } = (0, $316880e8df8b2f99$export$2e2bcd8739ae039)();
    if (isLoading) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0891c3550aaff5f4$export$2e2bcd8739ae039), {});
    if (error) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            "Error on page: ",
            error?.message || error
        ]
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        p: 3,
        direction: "row",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            size: {
                xs: 12
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($571a51610528d330$var$DGrid, {
                    columns: $571a51610528d330$var$imageColumns,
                    title: 'Images',
                    data: images,
                    loading: isLoading
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($571a51610528d330$var$DGrid, {
                    columns: $571a51610528d330$var$contractColumns,
                    title: 'Contracts',
                    data: contracts,
                    loading: isLoading
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($571a51610528d330$var$DGrid, {
                    columns: $571a51610528d330$var$contractColumns,
                    title: 'Pickup Receipts',
                    data: pickupReceipts,
                    loading: isLoading
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($571a51610528d330$var$DGrid, {
                    columns: $571a51610528d330$var$contractColumns,
                    title: 'Insurance Cards',
                    data: insuranceCards,
                    loading: isLoading
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($571a51610528d330$var$DGrid, {
                    columns: $571a51610528d330$var$contractColumns,
                    title: 'AutoPay Authorizations',
                    data: autoPayAuthorizations,
                    loading: isLoading
                })
            ]
        })
    });
};
var $571a51610528d330$export$2e2bcd8739ae039 = $571a51610528d330$var$CustomerDocuments;
const $571a51610528d330$var$contractColumns = [
    {
        field: 'fileName',
        headerName: 'Name',
        width: 300
    },
    {
        field: 'creationDate',
        headerName: 'Creation Date',
        width: 150,
        renderCell: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: (0, $8f939e503a4cc6d3$export$3ae94a2503e890a1)(params.row.creationDate)
            })
    },
    {
        field: 'subscriptionId',
        headerName: 'Subscription ID',
        width: 300
    },
    {
        field: 'documentUri',
        headerName: 'Action',
        width: 150,
        renderCell: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($571a51610528d330$var$DownloadDocumentsButton, {
                documentId: params.row.id
            })
    }
];
const $571a51610528d330$var$getImageTypeLabel = (imageType)=>{
    switch(imageType){
        case 0:
            return 'License Front';
        case 1:
            return 'License Back';
        case 2:
            return 'Selfie';
        case 99:
        default:
            return 'Unknown';
    }
};
const $571a51610528d330$var$imageColumns = [
    {
        field: 'fileName',
        headerName: 'File Name',
        width: 300
    },
    {
        field: 'imageType',
        headerName: 'Image Type',
        width: 200,
        renderCell: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
                children: $571a51610528d330$var$getImageTypeLabel(params.value)
            })
    },
    {
        field: 'id',
        headerName: 'ID',
        width: 150
    },
    {
        field: 'uri',
        headerName: 'URI',
        width: 200
    },
    {
        field: 'presignedUri',
        headerName: 'Action',
        width: 150,
        renderCell: (params)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($571a51610528d330$var$DownloadImageButton, {
                presignedUri: params.row.presignedUri
            })
    },
    {
        field: 'data',
        headerName: 'Data',
        width: 150,
        renderCell: (params)=>params.row.data ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($571a51610528d330$var$DownloadImageDataButton, {
                imageData: params.row.data,
                fileName: params.row.fileName
            }) : null
    }
];
const $571a51610528d330$var$DGrid = ({ title: title, columns: columns, data: data, ...rest })=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                size: {
                    xs: 12
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    variant: "h4",
                    children: title
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                autoHeight: true,
                rowHeight: 35,
                sx: {
                    pt: 2
                },
                columns: columns,
                getRowClassName: (params)=>(0, $764306bf5a621bcf$export$b871dff2aa55db26)(params.indexRelativeToCurrentPage),
                rows: data,
                ...rest
            })
        ]
    });
};
const $571a51610528d330$var$DownloadDocumentsButton = ({ documentId: documentId })=>{
    const { useDocumentUri: useDocumentUri } = (0, $316880e8df8b2f99$export$2e2bcd8739ae039)();
    const { customerId: customerId } = (0, $84c11e79798ea0cb$export$99eaa27ddbbb95ef)();
    const { refetch: refetch } = useDocumentUri(documentId, customerId);
    const onClick = async ()=>{
        const { data: data } = await refetch();
        if (data) $571a51610528d330$var$handleDownload(data);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
        title: "Download",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
            className: "xsIcon",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bae8d0b4be16a32a$export$2e2bcd8739ae039), {})
        })
    });
};
const $571a51610528d330$var$DownloadImageButton = ({ presignedUri: presignedUri })=>{
    const onClick = ()=>{
        if (presignedUri) $571a51610528d330$var$handleDownload({
            documentUri: presignedUri
        });
    };
    // Only render the button if presignedUri is not empty
    if (!presignedUri) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
        title: "Download",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
            className: "xsIcon",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bae8d0b4be16a32a$export$2e2bcd8739ae039), {})
        })
    });
};
const $571a51610528d330$var$handleDownload = ({ documentUri: documentUri })=>{
    if (documentUri) {
        const link = document.createElement('a');
        link.href = documentUri;
        link.download = documentUri.split('/').pop();
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    } else {
        console.error('Document URI not found');
        (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Document not found.');
    }
};
const $571a51610528d330$var$DownloadImageDataButton = ({ imageData: imageData, fileName: fileName })=>{
    const onClick = ()=>{
        if (imageData) {
            const link = document.createElement('a');
            link.href = `data:image/jpeg;base64,${imageData}`;
            link.download = `${fileName || 'image'}.jpeg`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.error('Image data not found');
            (0, $7d5e77dbd040e613$export$2e2bcd8739ae039).error('Image data not found.');
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0c12c30993373593$export$2e2bcd8739ae039), {
        title: "Download",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $05a469b554e6dcda$export$2e2bcd8739ae039), {
            className: "xsIcon",
            onClick: onClick,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bae8d0b4be16a32a$export$2e2bcd8739ae039), {})
        })
    });
};




parcelRequire("acw62");

parcelRequire("acw62");






const $b01811b63b8a2061$var$useInsurance = ()=>{
    const { customerId: customerId } = (0, $84c11e79798ea0cb$export$99eaa27ddbbb95ef)();
    function useInsuredDrivers(subscriptionId) {
        const { data: insuredDrivers } = (0, $4cdfd80436a5bb32$export$dd0a697e1782aedd)({
            queryKey: [
                '/insuredDrivers'
            ],
            queryFn: ()=>(0, $dbaa63f10354f5f5$export$6754c540bf6e6bf1)(customerId, subscriptionId).then((res)=>res.driversList),
            placeholderData: []
        });
        return {
            insuredDrivers: insuredDrivers
        };
    }
    return {
        useInsuredDrivers: useInsuredDrivers
    };
};
var $b01811b63b8a2061$export$2e2bcd8739ae039 = $b01811b63b8a2061$var$useInsurance;


const $5ad6a3769e8efabe$var$InsuredDrivers = ({ subscriptionId: subscriptionId })=>{
    const { useInsuredDrivers: useInsuredDrivers } = (0, $b01811b63b8a2061$export$2e2bcd8739ae039)();
    const { insuredDrivers: insuredDrivers } = useInsuredDrivers(subscriptionId);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        container: true,
        spacing: 2,
        p: 3,
        direction: "row",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
            size: {
                xs: 12
            },
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
                    size: {
                        xs: 12
                    },
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                        variant: "h6",
                        children: "Insured Drivers"
                    })
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $91898409b7dc5553$export$c8dd51eb24f71762), {
                    autoHeight: true,
                    rowHeight: 35,
                    sx: {
                        pt: 2
                    },
                    columns: $5ad6a3769e8efabe$var$contractColumns,
                    getRowClassName: (params)=>(0, $764306bf5a621bcf$export$b871dff2aa55db26)(params.indexRelativeToCurrentPage),
                    rows: insuredDrivers || []
                })
            ]
        })
    });
};
var $5ad6a3769e8efabe$export$2e2bcd8739ae039 = $5ad6a3769e8efabe$var$InsuredDrivers;
const $5ad6a3769e8efabe$var$contractColumns = [
    {
        field: 'firstName',
        headerName: 'First Name',
        width: 300
    },
    {
        field: 'lastName',
        headerName: 'Last Name',
        width: 300
    },
    {
        field: 'dateOfBirth',
        headerName: 'Date of birth',
        width: 150
    },
    {
        field: 'isprimary',
        headerName: 'Primary',
        width: 150,
        renderCell: (props)=>props.row.isprimary ? 'Yes' : 'No'
    }
];





const $fe3bba5067149aa7$var$Insurance = ()=>{
    const { customerId: customerId, subscriptionId: subscriptionId } = (0, $669372cabeb8bdf2$export$3f89740658197ba2)();
    if (!subscriptionId) return null;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $a2c903eb2263b589$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    ml: 1,
                    margin: '20px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ca16cb6e72a53f1$export$2e2bcd8739ae039), {
                    color: "inherit",
                    variant: "h4",
                    children: "Insurance"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c2e2000df495a70f$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ed0dc78f73685bb9$export$2e2bcd8739ae039), {
                sx: {
                    ml: 1,
                    margin: '20px'
                },
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2061fcabe0ae87b$export$6e2c8f0811a474ce), {
                    heading: "",
                    children: subscriptionId ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ce3a959b6628486$export$cfb655cde9661b99), {
                        subscriptionId: subscriptionId,
                        customerId: customerId
                    }) : null
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5ad6a3769e8efabe$export$2e2bcd8739ae039), {
                subscriptionId: subscriptionId
            })
        ]
    });
};
var $fe3bba5067149aa7$export$2e2bcd8739ae039 = $fe3bba5067149aa7$var$Insurance;


const $8b488dbcce1c14ef$var$Routes = ()=>{
    const navigate = (0, $84c11e79798ea0cb$export$9770f232ac06a008)();
    const restoreOriginalUri = async (_oktaAuth, originalUri)=>{
        navigate((0, $83e7c3a0ba92185e$export$4ebdca5513a016fe)(originalUri || '/', window.location.origin), {
            replace: true
        });
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54656f276146068e$export$9fb697de7778c436), {
        oktaAuth: (0, $e3ab3b3b306c7d16$export$219078e38253958),
        restoreOriginalUri: restoreOriginalUri,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25251e27701bd9d9$export$64222bfa440b0c2), {
            adapter: (0, $e5ccd45368c6fef8$export$360df563ae2167f5),
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $84c11e79798ea0cb$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/login/callback",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54656f276146068e$export$8f938467209eea73), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$444b3ab0cb9aec40), {
                            to: "/fleet",
                            replace: true
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/fleet",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        exact: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Vehicles",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $dbfd352e59003ee7$export$b4cf1bc71356e54c), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/fleet/tasks",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Appointments",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a12e81b08c6dd3b8$export$77bc526bfccc9372), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/fleet/teamsettings",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Team Settings",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5dbc5936ee69e9e3$export$c72f6eaae7b9adff), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/fleet/vehiclemedia",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Vehicle Media",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9300ba81db24357b$export$e9224c7836f9484c), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/view/:from/:id",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Vehicle Details",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7260db35854db5df$export$14e1a0793cbc3278), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/fleet/reservations",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        exact: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Reservations",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fd6332adf46d8500$export$565ca80fd56969d7), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/reservations/:reservationId",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        exact: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Reservation",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $435a806a26a7beb9$export$2e2bcd8739ae039), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/customers",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        exact: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Customers",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a1f62b3b3c756a85$export$56e258bc8091b7e5), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/customers/:customerId",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        exact: true,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Customer Details",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf12675b18a38fc7$export$7adf003668c36e7b), {})
                                })
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54a953d3f16bc354$export$a392ed80e0c48a7d), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/customers/:customerId/invoices",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Customer Invoices",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf12675b18a38fc7$export$7adf003668c36e7b), {})
                                })
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ce6203d6a25c65b$export$9c8e5b2f269b05ca), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/customers/:customerId/cqe",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Customer Qualification",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf12675b18a38fc7$export$7adf003668c36e7b), {})
                                })
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $74cab93e35ab4829$export$d2b00b551618c20c), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/customers/:customerId/mileage",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Subscription Mileage",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf12675b18a38fc7$export$7adf003668c36e7b), {})
                                })
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec96edba72c52e05$export$2e2bcd8739ae039), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/customers/:customerId/documents",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Customer Documents",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf12675b18a38fc7$export$7adf003668c36e7b), {})
                                })
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $571a51610528d330$export$2e2bcd8739ae039), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/customers/:customerId/insurance",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Customer Insurance",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $bf12675b18a38fc7$export$7adf003668c36e7b), {})
                                })
                            }),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                                path: "",
                                element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $fe3bba5067149aa7$export$2e2bcd8739ae039), {})
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/promotions",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Promotions",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4b760d6aa7d016e3$export$6ba7dff125b299e8), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/assets/inventory",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Map",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ffa7abbb5f0060a7$export$23f3dfd47374502b), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "/vestaboard",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a3e5af206e1ac05b$export$2885ecfb6342598b), {}),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                            path: "",
                            element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $78d6ed22988c03d1$export$c84671f46d6a1ca), {
                                title: "Vestaboard",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38e2e4dba3e7e5d8$export$e926676385687eaf), {
                                    fallback: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                        children: "Something went wrong"
                                    }),
                                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2ec6c8a31991a5b$export$94d79dfc96f95537), {})
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3e0d78e1eee9f656$export$2e2bcd8739ae039), {})
                    })
                ]
            })
        })
    });
};
var $8b488dbcce1c14ef$export$2e2bcd8739ae039 = $8b488dbcce1c14ef$var$Routes;





const $35da740d59af89ba$var$muiCache = (0, $fc182b1f84212d3f$export$2e2bcd8739ae039)({
    key: 'mui',
    prepend: true
});
const $35da740d59af89ba$var$queryClient = new (0, $83ccb5f70678ce73$export$405d0624ed55a03f)({
    defaultOptions: {
        queries: {
            retry: false,
            staleTime: 10000 // Time in milliseconds
        }
    }
});
const $35da740d59af89ba$var$queryStringifyOptions = {
    transformSearchString: (0, $c1c13b455d7842dc$export$62f639b96e7f6421)
};
const $35da740d59af89ba$var$ThemedApp = ()=>{
    const { theme: theme } = (0, $2c5be066ce1eeb09$export$93d4e7f90805808f)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $cc8cea264685552f$export$2e2bcd8739ae039), {
        theme: theme,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $888b8a9d3c5d3650$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7d5e77dbd040e613$export$fb98e3a2a4cd92d7), {
                position: "top-center"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8b488dbcce1c14ef$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $797b6392ad7a8820$export$fd1469cb3147d866), {})
        ]
    });
};
const $35da740d59af89ba$var$App = ()=>{
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c780594f51309d36$export$45604f0cc8ae667b), {
        client: $35da740d59af89ba$var$queryClient,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25251e27701bd9d9$export$64222bfa440b0c2), {
            ReactRouterRoute: (0, $84c11e79798ea0cb$export$e7b0ac011bb776c6),
            stringifyOptions: $35da740d59af89ba$var$queryStringifyOptions,
            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4eee05ec22b53782$export$e7094788287c5e9b), {
                value: $35da740d59af89ba$var$muiCache,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1ed44f525ea4bba9$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2c5be066ce1eeb09$export$d8964aec282183a3), {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35da740d59af89ba$var$ThemedApp, {})
                    })
                })
            })
        })
    });
};
const $35da740d59af89ba$var$LDApp = (0, $47ddd57e03687cb6$export$39143e8ef25ed6fd)({
    clientSideID: "62670154c64e1f14d4574cce",
    deferInitialization: false
})($35da740d59af89ba$var$App);
const $35da740d59af89ba$var$rootElement = document.getElementById('root');
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$exports.createRoot)($35da740d59af89ba$var$rootElement);
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $84c11e79798ea0cb$export$9ba4e89fdfa1fc54), {
    children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($35da740d59af89ba$var$LDApp, {})
}));


//# sourceMappingURL=app.cfe0ed53.js.map
